
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc28"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc28"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jQYQa", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $e6d63797d689782f$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $e6d63797d689782f$export$d8f52e8f804021e8);
$parcel$export(module.exports, "segmentUnmountCache", () => $e6d63797d689782f$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $e6d63797d689782f$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $e6d63797d689782f$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $e6d63797d689782f$export$e4380431c2bdabee);
$parcel$export(module.exports, "addExcluded3pSegment", () => $e6d63797d689782f$export$9bfdf89f35702b2e);
$parcel$export(module.exports, "addSegmentExtraData", () => $e6d63797d689782f$export$35723c3772fda7dd);
$parcel$export(module.exports, "addIframeSegmentData", () => $e6d63797d689782f$export$c227d812a1e08d80);
$parcel$export(module.exports, "addCustomTiming", () => $e6d63797d689782f$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $e6d63797d689782f$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $e6d63797d689782f$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $e6d63797d689782f$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $e6d63797d689782f$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $e6d63797d689782f$export$10582acd678c213);
$parcel$export(module.exports, "addCompletedHold", () => $e6d63797d689782f$export$d6cf9650acfb0dab);
$parcel$export(module.exports, "removeHoldByID", () => $e6d63797d689782f$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "addError", () => $e6d63797d689782f$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $e6d63797d689782f$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $e6d63797d689782f$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $e6d63797d689782f$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $e6d63797d689782f$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $e6d63797d689782f$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $e6d63797d689782f$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $e6d63797d689782f$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $e6d63797d689782f$export$614a7af2affc5dff);
$parcel$export(module.exports, "addNewInteraction", () => $e6d63797d689782f$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $e6d63797d689782f$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $e6d63797d689782f$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $e6d63797d689782f$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $e6d63797d689782f$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $e6d63797d689782f$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $e6d63797d689782f$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $e6d63797d689782f$export$5342dcad19138a1c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $eUgRu = parcelRequire("eUgRu");

var $dRkX9 = parcelRequire("dRkX9");

var $jR7cM = parcelRequire("jR7cM");

var $8nAtj = parcelRequire("8nAtj");

var $5hPkM = parcelRequire("5hPkM");

var $joIQT = parcelRequire("joIQT");

var $jKRI6 = parcelRequire("jKRI6");

var $iU9Tu = parcelRequire("iU9Tu");

var $aQ7I7 = parcelRequire("aQ7I7");

var $2Eign = parcelRequire("2Eign");

var $ifobP = parcelRequire("ifobP");

var $7wGpR = parcelRequire("7wGpR");

var $0kO5U = parcelRequire("0kO5U");

var $7RDnQ = parcelRequire("7RDnQ");

var $2N1Hu = parcelRequire("2N1Hu");

var $33Vnw = parcelRequire("33Vnw");
const $e6d63797d689782f$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $e6d63797d689782f$export$d8f52e8f804021e8 = new (0, $33Vnw.default)();
const $e6d63797d689782f$var$interactionQueue = [];
const $e6d63797d689782f$var$segmentCache = new Map();
const $e6d63797d689782f$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $e6d63797d689782f$var$segmentObservers = [];
function $e6d63797d689782f$export$2b3954d2e8509985() {
    const interactionId = (0, $ifobP.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $2N1Hu.interactions).get(interactionId.current);
}
function $e6d63797d689782f$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $5hPkM.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $e6d63797d689782f$var$performanceEventObserver;
const $e6d63797d689782f$export$17afbba0f16b4b19 = ()=>{
    $e6d63797d689782f$var$performanceEventObserver = $e6d63797d689782f$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $e6d63797d689782f$export$e6be05b411ce21a6(entry);
    });
    return $e6d63797d689782f$var$performanceEventObserver;
};
const $e6d63797d689782f$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $e6d63797d689782f$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $e6d63797d689782f$var$labelStackToString(labelStack, name) {
    var _stack$map;
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map((l)=>l.name)) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $e6d63797d689782f$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $e6d63797d689782f$var$addSegmentObserver(observer) {
    $e6d63797d689782f$var$segmentObservers.push(observer);
    for (const segmentInfo of $e6d63797d689782f$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $e6d63797d689782f$var$removeSegmentObserver(observer) {
    const index = $e6d63797d689782f$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $e6d63797d689782f$var$segmentObservers.splice(index, 1);
}
function $e6d63797d689782f$export$cd7f480d6b8286c3(interactionId) {
    (0, $2N1Hu.interactions).delete(interactionId);
}
function $e6d63797d689782f$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $e6d63797d689782f$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $e6d63797d689782f$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $e6d63797d689782f$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $e6d63797d689782f$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    var _interaction;
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) ((_interaction = interaction).excluded3pSegmentData ?? (_interaction.excluded3pSegmentData = {}))[segmentId] = {
        segmentId: segmentId,
        ...interaction.excluded3pSegmentData[segmentId],
        ...data
    };
}
function $e6d63797d689782f$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $e6d63797d689782f$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $7wGpR.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $e6d63797d689782f$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $e6d63797d689782f$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $e6d63797d689782f$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $e6d63797d689782f$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $8nAtj.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $e6d63797d689782f$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $e6d63797d689782f$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $e6d63797d689782f$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $2N1Hu.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $e6d63797d689782f$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $e6d63797d689782f$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $2N1Hu.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $e6d63797d689782f$export$9e04fe1a58571ec(moduleId, timestamp) {
    $e6d63797d689782f$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $e6d63797d689782f$export$6f228d1fdc911d7(identifier, start, end) {
    $e6d63797d689782f$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $e6d63797d689782f$var$moduleLoadingRequests = {};
function $e6d63797d689782f$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $e6d63797d689782f$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $e6d63797d689782f$var$labelStackToString(labelStack), name, startTime);
}
function $e6d63797d689782f$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $e6d63797d689782f$export$7606887303596f82(interactionId, labelStack, name, _experimental, holdStartedAt) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $eUgRu.default)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $e6d63797d689782f$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, holdStartedAt ?? performance.now());
    if (interaction != null) {
        const start = holdStartedAt ?? performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($e6d63797d689782f$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $e6d63797d689782f$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $e6d63797d689782f$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $e6d63797d689782f$var$removeHoldCriterion(id);
            const currentInteraction = (0, $2N1Hu.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $e6d63797d689782f$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $e6d63797d689782f$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($e6d63797d689782f$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $e6d63797d689782f$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $e6d63797d689782f$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $e6d63797d689782f$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $e6d63797d689782f$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $e6d63797d689782f$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $e6d63797d689782f$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $2N1Hu.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($e6d63797d689782f$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $e6d63797d689782f$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $e6d63797d689782f$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $e6d63797d689782f$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $e6d63797d689782f$export$2df109852219d16e(interactionId) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
function $e6d63797d689782f$export$b1ce94abc72c69d7(interactionId, info) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction == null) return ()=>{};
    const preloadRow = {
        source: info.source,
        preloadStartedAt: info.preloadStartedAt,
        adoptedAt: info.adoptedAt
    };
    interaction.preloadInfo.push(preloadRow);
    const releaseHold = $e6d63797d689782f$export$7606887303596f82(interactionId, [], `preload:${info.source}`, false, interaction.start);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        preloadRow.settledAt = performance.now();
        releaseHold();
    };
}
function $e6d63797d689782f$export$43f87b52eb8fc449(args) {
    const interaction = $e6d63797d689782f$export$2b3954d2e8509985();
    if (interaction == null || interaction.ufoName !== args.experienceKey || args.preloadKey !== undefined && interaction.preloadKey !== undefined && interaction.preloadKey !== args.preloadKey) return null;
    return $e6d63797d689782f$export$b1ce94abc72c69d7(interaction.id, {
        source: args.source,
        preloadStartedAt: args.preloadStartedAt,
        adoptedAt: args.adoptedAt
    });
}
let $e6d63797d689782f$var$onInteractionStartForPreloadHolds = null;
function $e6d63797d689782f$export$e96f751b1e82abda(hook) {
    $e6d63797d689782f$var$onInteractionStartForPreloadHolds = hook;
}
const $e6d63797d689782f$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $e6d63797d689782f$export$9e04fe1a58571ec($e6d63797d689782f$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $e6d63797d689782f$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $e6d63797d689782f$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $e6d63797d689782f$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $e6d63797d689782f$var$moduleLoadingRequests[info.identifier];
            $e6d63797d689782f$export$6f228d1fdc911d7($e6d63797d689782f$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $ifobP.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $e6d63797d689782f$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $ifobP.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $e6d63797d689782f$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $e6d63797d689782f$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $e6d63797d689782f$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $2N1Hu.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $e6d63797d689782f$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $5hPkM.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $e6d63797d689782f$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $e6d63797d689782f$var$pushToQueue(id, data) {
    $e6d63797d689782f$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $e6d63797d689782f$var$handleInteraction = $e6d63797d689782f$var$pushToQueue;
const $e6d63797d689782f$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $e6d63797d689782f$var$hasMetricVariantCategory = (labelStack, category)=>(labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && label.type === category)) ?? false;
const $e6d63797d689782f$var$hasAnyMetricVariantCategory = (labelStack)=>(labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && $e6d63797d689782f$var$isKnownMetricVariantCategory(label.type))) ?? false;
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ const $e6d63797d689782f$var$isExcludedThirdPartyHold = (labelStack)=>(labelStack === null || labelStack === void 0 ? void 0 : labelStack.some((label)=>'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true)) ?? false;
const $e6d63797d689782f$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack === null || labelStack === void 0 || labelStack.forEach((label)=>{
        if ('type' in label && $e6d63797d689782f$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $e6d63797d689782f$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>{
    var _interaction$hold3pAc;
    return interaction.holdInfo.some((hold)=>$e6d63797d689782f$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$e6d63797d689782f$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$e6d63797d689782f$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.values()) ?? []
    ].some((hold)=>$e6d63797d689782f$var$hasMetricVariantCategory(hold.labelStack, category));
};
const $e6d63797d689782f$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($e6d63797d689782f$var$isExcludedThirdPartyHold(labelStack)) return;
    const categories = $e6d63797d689782f$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $e6d63797d689782f$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    var _interaction$hold3pAc2;
    (_interaction$hold3pAc2 = interaction.hold3pActive) === null || _interaction$hold3pAc2 === void 0 || _interaction$hold3pAc2.forEach((hold)=>{
        $e6d63797d689782f$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $e6d63797d689782f$var$hasActiveMetricVariantCategory = (interaction, category)=>{
    var _interaction$hold3pAc3;
    return [
        ...((_interaction$hold3pAc3 = interaction.hold3pActive) === null || _interaction$hold3pAc3 === void 0 ? void 0 : _interaction$hold3pAc3.values()) ?? []
    ].some((hold)=>$e6d63797d689782f$var$hasMetricVariantCategory(hold.labelStack, category));
};
function $e6d63797d689782f$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $e6d63797d689782f$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ const $e6d63797d689782f$var$getNonExcludedThirdPartyEnd = (interaction, currentTime, interactionEnd)=>{
    var _interaction$hold3pAc4;
    const activeHolds = [
        ...((_interaction$hold3pAc4 = interaction.hold3pActive) === null || _interaction$hold3pAc4 === void 0 ? void 0 : _interaction$hold3pAc4.values()) ?? []
    ];
    const releasedHolds = interaction.hold3pInfo ?? [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    const hasAnyExcludedThirdParty = activeHolds.some((hold)=>$e6d63797d689782f$var$isExcludedThirdPartyHold(hold.labelStack)) || releasedHolds.some((hold)=>$e6d63797d689782f$var$isExcludedThirdPartyHold(hold.labelStack));
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    const hasActiveNonExcludedThirdParty = activeHolds.some((hold)=>!$e6d63797d689782f$var$isExcludedThirdPartyHold(hold.labelStack));
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max(interactionEnd, ...releasedHolds.filter((hold)=>!$e6d63797d689782f$var$isExcludedThirdPartyHold(hold.labelStack)).map((hold)=>hold.end));
};
function $e6d63797d689782f$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $e6d63797d689782f$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $e6d63797d689782f$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$e6d63797d689782f$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $e6d63797d689782f$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $e6d63797d689782f$var$ensureMetricWindows(interaction) {
    var _interaction$metricCa, _interaction$metricCa2;
    if (interaction.end === 0) return;
    const hasGenAI = $e6d63797d689782f$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $e6d63797d689782f$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = ((_interaction$metricCa = interaction.metricCategoryEnds) === null || _interaction$metricCa === void 0 ? void 0 : _interaction$metricCa['third-party']) !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = ((_interaction$metricCa2 = interaction.metricCategoryEnds) === null || _interaction$metricCa2 === void 0 ? void 0 : _interaction$metricCa2['gen-ai']) !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $e6d63797d689782f$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $e6d63797d689782f$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $e6d63797d689782f$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $e6d63797d689782f$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $2Eign.currentFeatureFlagsAccessed));
    (0, $aQ7I7.clearActiveTrace)();
    $e6d63797d689782f$var$callCleanUpCallbacks(data);
    (0, $0kO5U.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $5hPkM.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $jR7cM.default)((0, $5hPkM.getPostInteractionRate)((0, $jKRI6.sanitizeUfoName)(data.ufoName), data.type))) $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
    $e6d63797d689782f$export$cd7f480d6b8286c3(id);
    $e6d63797d689782f$export$dbba6cdedab4e68b.id = data.id;
    $e6d63797d689782f$export$dbba6cdedab4e68b.type = data.type;
    $e6d63797d689782f$export$dbba6cdedab4e68b.timestamp = data.end;
    $e6d63797d689782f$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $e6d63797d689782f$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $e6d63797d689782f$var$handleInteraction(id, data);
    if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $e6d63797d689782f$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$e6d63797d689782f$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $e6d63797d689782f$export$9e614a29a1ac213e(sinkFn) {
    if ($e6d63797d689782f$var$handleInteraction === $e6d63797d689782f$var$pushToQueue) {
        $e6d63797d689782f$var$handleInteraction = sinkFn;
        $e6d63797d689782f$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $e6d63797d689782f$var$interactionQueue.length = 0;
    }
}
function $e6d63797d689782f$export$8a1ba7bef607358a(sinkFn) {
    $e6d63797d689782f$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $e6d63797d689782f$var$activeSubmitted = false;
function $e6d63797d689782f$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc5;
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $5hPkM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            var _getConfig3;
            if ((_getConfig3 = (0, $5hPkM.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $e6d63797d689782f$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $e6d63797d689782f$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = ((_interaction$hold3pAc5 = interaction.hold3pActive) === null || _interaction$hold3pAc5 === void 0 ? void 0 : _interaction$hold3pAc5.size) === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $e6d63797d689782f$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $e6d63797d689782f$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $e6d63797d689782f$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$e6d63797d689782f$var$activeSubmitted) {
                    var _getConfig4, _getConfig5;
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = $e6d63797d689782f$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $e6d63797d689782f$var$ensureMetricWindows(interaction);
                    $e6d63797d689782f$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig4 = (0, $5hPkM.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.extraSearchPageInteraction) !== null && _getConfig4 !== void 0 && _getConfig4.enabled && interaction.ufoName === ((_getConfig5 = (0, $5hPkM.getConfig)()) === null || _getConfig5 === void 0 || (_getConfig5 = _getConfig5.extraSearchPageInteraction) === null || _getConfig5 === void 0 ? void 0 : _getConfig5.searchPageMetricName)) (0, $joIQT.onSearchPageInteractionComplete)(interactionId, interaction);
                    $e6d63797d689782f$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$e6d63797d689782f$var$activeSubmitted) {
                var _getConfig6, _getConfig7;
                $e6d63797d689782f$var$finishInteraction(interactionId, interaction, endTime);
                if ((_getConfig6 = (0, $5hPkM.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.extraSearchPageInteraction) !== null && _getConfig6 !== void 0 && _getConfig6.enabled && interaction.ufoName === ((_getConfig7 = (0, $5hPkM.getConfig)()) === null || _getConfig7 === void 0 || (_getConfig7 = _getConfig7.extraSearchPageInteraction) === null || _getConfig7 === void 0 ? void 0 : _getConfig7.searchPageMetricName)) (0, $joIQT.onSearchPageInteractionComplete)(interactionId, interaction);
                $e6d63797d689782f$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $e6d63797d689782f$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $e6d63797d689782f$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc7;
        const shouldUseRawDataThirdParty = (0, $5hPkM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $e6d63797d689782f$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction$hold3pAc6;
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $e6d63797d689782f$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $e6d63797d689782f$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $e6d63797d689782f$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: ((_interaction$hold3pAc6 = interaction.hold3pActive) === null || _interaction$hold3pAc6 === void 0 ? void 0 : _interaction$hold3pAc6.size) ?? 0
            });
            $e6d63797d689782f$var$ensureMetricWindows(interaction);
            $e6d63797d689782f$var$finishInteraction(interactionId, interaction, endTime);
            $e6d63797d689782f$export$d8f52e8f804021e8.reset();
            $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $e6d63797d689782f$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $e6d63797d689782f$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (((_interaction$hold3pAc7 = interaction.hold3pActive) === null || _interaction$hold3pAc7 === void 0 ? void 0 : _interaction$hold3pAc7.size) ?? 0)
        });
        $e6d63797d689782f$var$finishInteraction(interactionId, interaction);
        $e6d63797d689782f$export$d8f52e8f804021e8.reset();
        $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $e6d63797d689782f$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $5hPkM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $e6d63797d689782f$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $e6d63797d689782f$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $e6d63797d689782f$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $e6d63797d689782f$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $e6d63797d689782f$var$ensureMetricWindows(interaction);
            $e6d63797d689782f$var$finishInteraction(interactionId, interaction, endTime);
            $e6d63797d689782f$export$d8f52e8f804021e8.reset();
            $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $e6d63797d689782f$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $e6d63797d689782f$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $e6d63797d689782f$var$finishInteraction(interactionId, interaction);
        $e6d63797d689782f$export$d8f52e8f804021e8.reset();
        $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $e6d63797d689782f$export$d8f52e8f804021e8.reset();
        $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $e6d63797d689782f$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $e6d63797d689782f$export$2b3954d2e8509985();
    const finishInteractions = (0, $5hPkM.getFinishInteractionOnTransition)();
    (0, $2N1Hu.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $5hPkM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $e6d63797d689782f$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $e6d63797d689782f$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $e6d63797d689782f$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $e6d63797d689782f$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $e6d63797d689782f$var$ensureMetricWindows(interaction);
            $e6d63797d689782f$var$finishInteraction(interactionId, interaction, endTime);
            $e6d63797d689782f$export$d8f52e8f804021e8.reset();
            $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $e6d63797d689782f$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $e6d63797d689782f$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $e6d63797d689782f$var$finishInteraction(interactionId, interaction);
        $e6d63797d689782f$export$d8f52e8f804021e8.reset();
        $e6d63797d689782f$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $e6d63797d689782f$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $2N1Hu.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $e6d63797d689782f$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null, preloadKey) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    $e6d63797d689782f$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $5hPkM.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $e6d63797d689782f$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $e6d63797d689782f$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $jR7cM.default)((0, $5hPkM.getCapabilityRate)('feature_flag_access'));
    const config = (0, $5hPkM.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $5hPkM.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $7RDnQ.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $2Eign.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        preloadKey: preloadKey,
        type: type,
        previousInteractionName: $e6d63797d689782f$export$dbba6cdedab4e68b.name,
        ...(0, $dRkX9.fg)('platform_ufo_emit_previous_interaction_id') ? {
            previousInteractionId: $e6d63797d689782f$export$dbba6cdedab4e68b.id
        } : {},
        isPreviousInteractionAborted: $e6d63797d689782f$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        preloadInfo: [],
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $2Eign.currentFeatureFlagsAccessed).clear();
    (0, $2N1Hu.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $e6d63797d689782f$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $e6d63797d689782f$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $5hPkM.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $e6d63797d689782f$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig8;
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig8 = (0, $5hPkM.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.postInteractionLog) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $e6d63797d689782f$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
    if ($e6d63797d689782f$var$onInteractionStartForPreloadHolds) try {
        $e6d63797d689782f$var$onInteractionStartForPreloadHolds(interactionId, ufoName, preloadKey);
    } catch  {
    // Preload instrumentation must not break interaction creation.
    }
}
function $e6d63797d689782f$export$4a759336b50e86e3(event) {
    const interaction = $e6d63797d689782f$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $e6d63797d689782f$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $e6d63797d689782f$export$ad216cc25852d44b(apdex) {
    (0, $2N1Hu.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $e6d63797d689782f$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $e6d63797d689782f$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $e6d63797d689782f$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $e6d63797d689782f$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $e6d63797d689782f$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $e6d63797d689782f$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($e6d63797d689782f$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $e6d63797d689782f$export$1c43f9ac826b6462(labelStack) {
    const key = $e6d63797d689782f$var$getSegmentCacheKey(labelStack);
    const existingSegment = $e6d63797d689782f$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $e6d63797d689782f$var$segmentCache.set(key, segmentInfo);
        $e6d63797d689782f$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $e6d63797d689782f$export$d0365e48b58231c3(labelStack) {
    const key = $e6d63797d689782f$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $e6d63797d689782f$var$segmentCache.get(key);
    if (segmentInfo) {
        $e6d63797d689782f$var$segmentCache.delete(key);
        const cacheKey = (0, $iU9Tu.stringifyLabelStackFully)(labelStack);
        $e6d63797d689782f$export$a2b14406ded37d60.set(cacheKey, ($e6d63797d689782f$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $e6d63797d689782f$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $e6d63797d689782f$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $2N1Hu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($e6d63797d689782f$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: (prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $e6d63797d689782f$export$6ce04c7ca6810a7e = [];
const $e6d63797d689782f$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $e6d63797d689782f$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $e6d63797d689782f$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $e6d63797d689782f$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("eUgRu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ada36004193781c6$export$2e2bcd8739ae039);

var $3mwvM = parcelRequire("3mwvM");

var $90Gdy = parcelRequire("90Gdy");

var $1jQTN = parcelRequire("1jQTN");
function $ada36004193781c6$var$v4(options, buf, offset) {
    if ((0, $3mwvM.default).randomUUID && !buf && !options) return (0, $3mwvM.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $90Gdy.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1jQTN.unsafeStringify)(rnds);
}
var $ada36004193781c6$export$2e2bcd8739ae039 = $ada36004193781c6$var$v4;

});
parcelRegister("3mwvM", function(module, exports) {
$parcel$export(module.exports, "default", () => $272ca5510cb70757$export$2e2bcd8739ae039);
const $272ca5510cb70757$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $272ca5510cb70757$export$2e2bcd8739ae039 = {
    randomUUID: $272ca5510cb70757$var$randomUUID
};

});

parcelRegister("90Gdy", function(module, exports) {
$parcel$export(module.exports, "default", () => $68f4dca94f8d215c$export$2e2bcd8739ae039);
let $68f4dca94f8d215c$var$getRandomValues;
const $68f4dca94f8d215c$var$rnds8 = new Uint8Array(16);
function $68f4dca94f8d215c$export$2e2bcd8739ae039() {
    if (!$68f4dca94f8d215c$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $68f4dca94f8d215c$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $68f4dca94f8d215c$var$getRandomValues($68f4dca94f8d215c$var$rnds8);
}

});

parcelRegister("1jQTN", function(module, exports) {
$parcel$export(module.exports, "unsafeStringify", () => $0f6099713f5a10f5$export$8fb373d660548968);

var $bGOs3 = parcelRequire("bGOs3");
const $0f6099713f5a10f5$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$0f6099713f5a10f5$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $0f6099713f5a10f5$export$8fb373d660548968(arr, offset = 0) {
    return ($0f6099713f5a10f5$var$byteToHex[arr[offset + 0]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 1]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 2]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 3]] + '-' + $0f6099713f5a10f5$var$byteToHex[arr[offset + 4]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 5]] + '-' + $0f6099713f5a10f5$var$byteToHex[arr[offset + 6]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 7]] + '-' + $0f6099713f5a10f5$var$byteToHex[arr[offset + 8]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 9]] + '-' + $0f6099713f5a10f5$var$byteToHex[arr[offset + 10]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 11]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 12]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 13]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 14]] + $0f6099713f5a10f5$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $0f6099713f5a10f5$var$stringify(arr, offset = 0) {
    const uuid = $0f6099713f5a10f5$export$8fb373d660548968(arr, offset);
    if (!(0, $bGOs3.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $0f6099713f5a10f5$export$2e2bcd8739ae039 = $0f6099713f5a10f5$var$stringify;

});
parcelRegister("bGOs3", function(module, exports) {
$parcel$export(module.exports, "default", () => $882ac09276952693$export$2e2bcd8739ae039);

var $1MKM1 = parcelRequire("1MKM1");
function $882ac09276952693$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $1MKM1.default).test(uuid);
}
var $882ac09276952693$export$2e2bcd8739ae039 = $882ac09276952693$var$validate;

});
parcelRegister("1MKM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ce8e6608ac8c81$export$2e2bcd8739ae039);
var $14ce8e6608ac8c81$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("dRkX9", function(module, exports) {
$parcel$export(module.exports, "fg", () => $33f4a9ef6385df00$export$b40ec24ac8275656);

var $1Bh5L = parcelRequire("1Bh5L");
function $33f4a9ef6385df00$export$b40ec24ac8275656(name) {
    return (0, $1Bh5L.resolveBooleanFlag)(name);
}

});
parcelRegister("1Bh5L", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $26e7a9800016d7ce$export$6333b6aff9fc6275);

var $k2M4v = parcelRequire("k2M4v");

var $1LxCZ = parcelRequire("1LxCZ");

var $ipEkV = parcelRequire("ipEkV");

var $3rmt1 = parcelRequire("3rmt1");

var $75Krz = parcelRequire("75Krz");

var $4utUE = parcelRequire("4utUE");
const $26e7a9800016d7ce$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $ipEkV.ENV_ENABLE_PLATFORM_FF) || (0, $3rmt1.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $26e7a9800016d7ce$export$6333b6aff9fc6275(flagKey) {
    if ($26e7a9800016d7ce$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1LxCZ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $4utUE.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $75Krz.globalVar)[0, $4utUE.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $75Krz.globalVar)[0, $4utUE.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $k2M4v.default).checkGate(flagKey);
        const result = (_globalVar$PFF_GLOBAL3 = (0, $75Krz.globalVar)[0, $4utUE.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("k2M4v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d45b8828c94f82e6$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lITKq = parcelRequire("lITKq");

var $2YDEV = parcelRequire("2YDEV");

var $1us34 = parcelRequire("1us34");

var $3ZUoj = parcelRequire("3ZUoj");

var $27NB5 = parcelRequire("27NB5");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $d45b8828c94f82e6$var$FeatureGates {
    static #_ = this.client = new (0, $lITKq.Client)();
    static #_2 = this.hasCheckGateErrorOccurred = false;
    static #_3 = this.hasGetExperimentValueErrorOccurred = false;
    static #_4 = this.checkGate = (gateName, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                // Attempt to retrieve an override value for the feature gate
                const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                // If an override value is found, return it immediately
                if (overrideValue !== undefined) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$d45b8828c94f82e6$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $d45b8828c94f82e6$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
        }
        // Proceed with the main logic if no override is found
        return this.client.checkGate(gateName, options);
    };
    /**
   * Returns whether the given feature gate exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use
   * {@link FeatureGates.ffpClient} for those. Use this method for Statsig flags, including flags
   * being migrated from Statsig to FFP.
   */ static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    /**
   * Returns whether the given experiment exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use
   * {@link FeatureGates.ffpClient} for those. Use this method for Statsig flags, including flags
   * being migrated from Statsig to FFP.
   */ static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static #_5 = this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$d45b8828c94f82e6$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
        // Proceed with the main logic if no override is found
        return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
    };
    static #_6 = this.initializeCalled = this.client.initializeCalled.bind(this.client);
    static #_7 = this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    static #_8 = this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    static #_9 = this.initialize = this.client.initialize.bind(this.client);
    static #_10 = this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    static #_11 = this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    static #_12 = this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    static #_13 = this.getExperiment = this.client.getExperiment.bind(this.client);
    static #_14 = this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    static #_15 = this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    static #_16 = this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    static #_17 = this.overrideGate = this.client.overrideGate.bind(this.client);
    static #_18 = this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    static #_19 = this.overrideConfig = this.client.overrideConfig.bind(this.client);
    static #_20 = this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    static #_21 = this.setOverrides = this.client.setOverrides.bind(this.client);
    static #_22 = this.getOverrides = this.client.getOverrides.bind(this.client);
    static #_23 = this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    static #_24 = this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    static #_25 = this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    static #_26 = this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    static #_27 = this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    static #_28 = this.updateUser = this.client.updateUser.bind(this.client);
    static #_29 = this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    static #_30 = this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    /**
   * The Feature Flag Platform (FFP) client, for reading flags that only exist in FFP. See
   * {@link Client.ffpClient}.
   *
   * It is `undefined` until an initialize method is called, and also when an older version of this
   * package that predates it is the one bound to the page.
   *
   * @example
   * ```ts
   * const enabled = FeatureGates.ffpClient?.getBooleanValue('my-new-flag', false) ?? false;
   * ```
   */ static get ffpClient() {
        return this.client.ffpClient;
    }
    static #_31 = this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    static #_32 = this.getTargetApp = this.client.getTargetApp.bind(this.client);
    static #_33 = this.getLayer = this.client.getLayer.bind(this.client);
    static #_34 = this.getLayerValue = this.client.getLayerValue.bind(this.client);
}
let $d45b8828c94f82e6$var$boundFGJS = $d45b8828c94f82e6$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $d45b8828c94f82e6$var$FeatureGates;
    else {
        var $d45b8828c94f82e6$var$_boundFGJS, $d45b8828c94f82e6$var$_boundFGJS$getPackage;
        $d45b8828c94f82e6$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (($d45b8828c94f82e6$var$_boundFGJS = $d45b8828c94f82e6$var$boundFGJS) === null || $d45b8828c94f82e6$var$_boundFGJS === void 0 || ($d45b8828c94f82e6$var$_boundFGJS$getPackage = $d45b8828c94f82e6$var$_boundFGJS.getPackageVersion) === null || $d45b8828c94f82e6$var$_boundFGJS$getPackage === void 0 ? void 0 : $d45b8828c94f82e6$var$_boundFGJS$getPackage.call($d45b8828c94f82e6$var$_boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, $2YDEV.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $2YDEV.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $d45b8828c94f82e6$export$2e2bcd8739ae039 = $d45b8828c94f82e6$var$boundFGJS;

});
parcelRegister("lITKq", function(module, exports) {
$parcel$export(module.exports, "Client", () => $993a2ed94c1e096e$export$1f2bb630327ac4b6);

var $drdCV = parcelRequire("drdCV");

var $gfBt2 = parcelRequire("gfBt2");

var $3ZUoj = parcelRequire("3ZUoj");

var $h14QI = parcelRequire("h14QI");

var $1us34 = parcelRequire("1us34");

var $5zsJk = parcelRequire("5zsJk");

var $fXaVY = parcelRequire("fXaVY");

var $5ZzJh = parcelRequire("5ZzJh");

var $4QrHS = parcelRequire("4QrHS");

var $hjviN = parcelRequire("hjviN");

var $5sBSy = parcelRequire("5sBSy");

var $dLxWR = parcelRequire("dLxWR");

var $fCJGM = parcelRequire("fCJGM");

var $8YzCX = parcelRequire("8YzCX");

var $chwyC = parcelRequire("chwyC");

var $csevr = parcelRequire("csevr");

var $27NB5 = parcelRequire("27NB5");

var $2YDEV = parcelRequire("2YDEV");
const $993a2ed94c1e096e$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $993a2ed94c1e096e$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
function $993a2ed94c1e096e$var$logFetchError(error) {
    if (error instanceof Error) // eslint-disable-next-line no-console
    console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error.message}`);
    // eslint-disable-next-line no-console
    console.warn(`Initialising Statsig client without values`);
}
class $993a2ed94c1e096e$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $8YzCX.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $gfBt2.default)();
        this.dataAdapter = new (0, $fCJGM.NoFetchDataAdapter)();
        /** Serves the flags the Feature Flag Service assigns to FFP; all other keys use Statsig. */ this.ffp = new (0, $hjviN.FfpClientAdapter)();
        /** True once an initialize method has applied values, even if Statsig is not running. */ this.valuesApplied = false;
        /** Incremented when Statsig stops, so a start that it overtook does nothing. */ this.statsigGeneration = 0;
        /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ this.statsigValuesUpdated = ()=>{
            if (this.user) {
                var _this$statsigClient4;
                // Trigger a reset of the memoize cache
                (_this$statsigClient4 = this.statsigClient) === null || _this$statsigClient4 === void 0 || _this$statsigClient4.updateUserSync(this.user, {
                    disableBackgroundCacheRefresh: true
                });
            }
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $8YzCX.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $5sBSy.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $chwyC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $5sBSy.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $chwyC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $2YDEV.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if ((this.initCompleted || this.initWithDefaults) && this.currentIdentifiers) {
                this.assertReady();
                const identifiers = this.currentIdentifiers;
                const customAttributes = experimentsResult.customAttributesFromFetch ?? this.currentAttributes;
                const disabled = experimentsResult.disabledProviders ?? [];
                this.ffp.apply(this.initOptions, disabled.includes('ffp') ? undefined : experimentsResult.ffp, identifiers, customAttributes);
                if (disabled.includes('statsig')) this.stopStatsig();
                else if (this.statsigClient) {
                    this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                    this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                } else if (!this.statsigStart) // Statsig is enabled again after being disabled. A start already in progress is left to
                // finish; the next update brings it up to date.
                this.restartStatsig(experimentsResult, identifiers, customAttributes).then(()=>this.subscriptions.anyUpdated()).catch((error)=>{
                    // eslint-disable-next-line no-console
                    console.warn('Failed to start the Statsig client', error);
                });
                this.statsigValuesUpdated();
                this.reportEvalFlagsStatus('providerUpdate', experimentsResult.status);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _this$sendOperational;
        (_this$sendOperational = this.sendOperationalEvent(action, 'featureGatesClient', {
            success: success,
            startTime: startTime,
            totalTime: totalTime,
            ...apiKey && {
                apiKey: apiKey
            }
        })) === null || _this$sendOperational === void 0 || _this$sendOperational.catch((err)=>{
            if (this.initOptions.environment !== (0, $27NB5.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    /** Sends an operational event about this client, once the analytics client is available. */ sendOperationalEvent(action, actionSubject, attributes) {
        var _initOptions$analytic;
        const initOptions = this.initOptions;
        return (_initOptions$analytic = initOptions.analyticsWebClient) === null || _initOptions$analytic === void 0 ? void 0 : _initOptions$analytic.then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: actionSubject,
                attributes: {
                    targetApp: initOptions.targetApp,
                    clientVersion: (0, $2YDEV.CLIENT_VERSION),
                    ...attributes
                },
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        });
    }
    /**
   * Reports values that are worse than the Feature Flag Service intends because a provider is
   * unavailable. The client still resolves with what it received; affected flags return the
   * code default (or, with the polling provider, the last values the provider served).
   */ reportEvalFlagsStatus(trigger, status) {
        var _this$sendOperational2;
        if (!status || !(0, $fXaVY.isEvalFlagsDegraded)(status) || !this.initOptions) return;
        const initOptions = this.initOptions;
        if (initOptions.environment !== (0, $27NB5.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
        console.warn(`Feature flag values are degraded (Statsig: ${status.statsig}, FFP: ${status.ffp}). Affected flags will return their default values.`);
        (_this$sendOperational2 = this.sendOperationalEvent('degraded', 'featureGatesClientValues', {
            trigger: trigger,
            statsigStatus: status.statsig,
            ffpStatus: status.ffp
        })) === null || _this$sendOperational2 === void 0 || _this$sendOperational2.catch(()=>{
        // The initialization event already reports a missing analytics client.
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}, ffpValues) {
        const clientOptionsWithDefaults = (0, $5sBSy.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $chwyC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues, ffpValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    /**
   * Throws if the Statsig client does not exist. The client's own methods use
   * {@link assertReady} instead, because Statsig is absent while the Feature Flag Service
   * disables it.
   */ assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertReady();
        const fetchOptionsWithDefaults = (0, $5sBSy.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $4QrHS.default).fetchFlagValues(fetchOptionsWithDefaults, identifiers, customAttributes).then((response)=>(0, $5ZzJh.toInitializeValues)(response, customAttributes));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertReady();
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}, ffpValues) {
        this.assertReady();
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes,
                ffp: ffpValues
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * The Feature Flag Platform (FFP) client, for reading flags that only exist in FFP. New flags are
   * created only in FFP, so read them here.
   *
   * @example
   * ```ts
   * const enabled = client.ffpClient?.getBooleanValue('my-new-flag', false) ?? false;
   * ```
   *
   * - It is `undefined` until an initialize method is called, then it is the same instance for the
   *   lifetime of this client, including across user updates.
   * - Until FFP values arrive, and when the Feature Flag Service does not use FFP for the user, its
   *   reads return the default they are given.
   * - Local overrides (see {@link Client.overrideGate}) do not apply to it.
   * - It serves only FFP values, so a flag being migrated from Statsig to FFP gets the default
   *   whenever Statsig serves it. Read migrating flags with {@link Client.checkGate},
   *   {@link Client.getExperimentValue} and the other methods of this client, which serve each flag
   *   from whichever of FFP or Statsig the service assigns it to.
   *
   * Its methods match those of `FlagClient` from `@atlaskit/flag-client`, so code that reads it
   * keeps working once it uses a `FlagClient` directly.
   */ get ffpClient() {
        return this.initOptions ? this.ffp.getClient(this.initOptions) : undefined;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertReady();
            const { fireGateExposure: fireGateExposure = true } = options;
            const route = this.route(gateName, 'gates');
            switch(route.source){
                case 'statsig':
                    return route.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                case 'ffp':
                    return this.ffp.checkGate(gateName, fireGateExposure);
                case 'override':
                    return route.value;
                default:
                    return false;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    /**
   * Returns whether the given feature gate exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   */ isGateExist(gateName) {
        try {
            this.assertReady();
            const route = this.route(gateName, 'gates');
            if (route.source !== 'statsig') return route.source !== 'default';
            const gate = route.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Returns whether the given experiment exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   */ isExperimentExist(experimentName) {
        try {
            this.assertReady();
            const route = this.route(experimentName, 'configs');
            if (route.source !== 'statsig') return route.source !== 'default';
            const config = route.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertReady();
        const route = this.route(gateName, 'gates');
        if (route.source === 'ffp') this.ffp.logGateExposure(gateName);
        else if (route.source === 'statsig') // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        route.statsigClient.checkGate(gateName);
    // An overridden or default value has no exposure.
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertReady();
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            const route = this.route(experimentName, 'configs');
            switch(route.source){
                case 'statsig':
                    return (0, $3ZUoj.DynamicConfig).fromExperiment(route.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                case 'ffp':
                    {
                        const ffpConfig = this.ffp.getConfig(experimentName, fireExperimentExposure);
                        return new (0, $3ZUoj.DynamicConfig)(experimentName, ffpConfig.value, ffpConfig.ruleId, {
                            time: Date.now(),
                            reason: (0, $1us34.EvaluationReason).Bootstrap
                        });
                    }
                case 'override':
                    return new (0, $3ZUoj.DynamicConfig)(experimentName, route.value, '', {
                        time: Date.now(),
                        reason: (0, $1us34.EvaluationReason).LocalOverride
                    });
                default:
                    return new (0, $3ZUoj.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $1us34.EvaluationReason).Unrecognized
                    });
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $3ZUoj.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $1us34.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertReady();
        const route = this.route(experimentName, 'configs');
        if (route.source === 'ffp') this.ffp.logConfigExposure(experimentName);
        else if (route.source === 'statsig') // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        route.statsigClient.getExperiment(experimentName);
    // An overridden or default value has no exposure.
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   *
   * Layers exist only in Statsig. Flags that only exist in the Feature Flag Platform (FFP) are read
   * with {@link Client.ffpClient}.
   *
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        var _this$statsigClient;
        this.assertReady();
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || (_this$statsigClient = _this$statsigClient.getLayer(layerName)) === null || _this$statsigClient === void 0 || _this$statsigClient.get(parameterName);
    }
    shutdownStatsig() {
        var _this$statsigClient2;
        this.assertReady();
        (_this$statsigClient2 = this.statsigClient) === null || _this$statsigClient2 === void 0 || _this$statsigClient2.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) {
            var _this$statsigClient3;
            (_this$statsigClient3 = this.statsigClient) === null || _this$statsigClient3 === void 0 || _this$statsigClient3.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
        }
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $chwyC.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $chwyC.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        await this.initFromFetchedValues(fromValuesClientOptions, identifiers, customAttributes, (0, $4QrHS.default).fetchClientSdk(clientOptions).then((value)=>value.clientSdkKey), (0, $4QrHS.default).fetchFlagValues(clientOptions, identifiers, customAttributes).then((response)=>(0, $5ZzJh.toInitializeValues)(response, customAttributes)), 'initialize');
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        // A failure to set the profile, even a synchronous one, fails both fetches.
        const profilePromise = Promise.resolve().then(()=>provider.setProfile(baseClientOptions, identifiers, customAttributes));
        await this.initFromFetchedValues(fromValuesClientOptions, identifiers, customAttributes, profilePromise.then(()=>provider.getClientSdkKey()), profilePromise.then(()=>provider.getExperimentValues()), 'initializeWithProvider');
    }
    /**
   * Initializes from values that are still being fetched, alongside Statsig's SDK key.
   *
   * Only Statsig needs the key, so a failed key fetch leaves FFP initialized with its values and
   * Statsig without values, and the key is not waited for at all when the Feature Flag Service
   * disables Statsig. A failed values fetch initializes Statsig without values (but with the key,
   * if it arrives) and FFP not at all. Either failure rejects after initializing.
   */ async initFromFetchedValues(fromValuesClientOptions, identifiers, customAttributes, clientSdkKeyPromise, valuesPromise, trigger) {
        // Record the key on the options whenever it arrives, so Statsig can still use it if it is
        // enabled after being disabled. Never leave a failure unhandled, as it may never be awaited.
        const clientSdkKeyResult = clientSdkKeyPromise.then((sdkKey)=>{
            fromValuesClientOptions.sdkKey = sdkKey;
            return {};
        }, (error)=>({
                error: error
            }));
        let values;
        try {
            values = await valuesPromise;
        } catch (error) {
            $993a2ed94c1e096e$var$logFetchError(error);
            // Statsig starts without values, but still with its SDK key if that arrives.
            await clientSdkKeyResult;
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        const disabledProviders = values.disabledProviders ?? [];
        const keyFailure = disabledProviders.includes('statsig') ? {} : await clientSdkKeyResult;
        if ('error' in keyFailure) {
            $993a2ed94c1e096e$var$logFetchError(keyFailure.error);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes, undefined, values.ffp, disabledProviders);
            throw keyFailure.error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, values.customAttributesFromFetch, values.experimentValues, values.ffp, disabledProviders);
        this.reportEvalFlagsStatus(trigger, values.status);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * Each provider is initialized independently, and a provider in `disabledProviders` is not
   * initialized at all.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}, ffpValues, disabledProviders = []) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        this.statsigInitOptions = clientOptions;
        // FFP is independent of Statsig, so apply it before the Statsig client can fail.
        this.ffp.apply(clientOptions, disabledProviders.includes('ffp') ? undefined : ffpValues, identifiers, customAttributes);
        this.valuesApplied = true;
        if (!disabledProviders.includes('statsig')) await this.startStatsig(clientOptions, identifiers, customAttributes, initializeValues);
    }
    /**
   * Creates and initializes the Statsig client. If that fails, Statsig is initialized with the
   * default SDK key and without values, and the error is rethrown.
   */ async startStatsig(clientOptions, identifiers, customAttributes, initializeValues) {
        var _newClientOptions$net;
        const newClientOptions = (0, $dLxWR.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $993a2ed94c1e096e$var$DEFAULT_CLIENT_KEY;
        if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $993a2ed94c1e096e$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $27NB5.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $csevr.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $5zsJk.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $drdCV.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $drdCV.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        const generation = this.statsigGeneration;
        try {
            this.statsigClient = new (0, $drdCV.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (generation !== this.statsigGeneration) // Statsig was stopped while starting, so it must not be started again with defaults.
            throw error;
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $drdCV.StatsigClient)($993a2ed94c1e096e$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * Starts Statsig after initialization, when the Feature Flag Service enables it again after
   * disabling it. Concurrent calls share one start, and a start overtaken by {@link stopStatsig}
   * does nothing.
   */ restartStatsig(values, identifiers, customAttributes) {
        if (!this.statsigStart) {
            const generation = this.statsigGeneration;
            this.statsigStart = this.getStatsigRestartOptions(values).then((options)=>{
                if (generation !== this.statsigGeneration) return;
                this.statsigInitOptions = options;
                return this.startStatsig(options, identifiers, customAttributes, values.experimentValues);
            }).finally(()=>{
                this.statsigStart = undefined;
            });
        }
        return this.statsigStart;
    }
    /**
   * The options to start Statsig with after initialization. Statsig's SDK key is normally already
   * known from initialization; otherwise it comes from the values or is fetched again.
   */ async getStatsigRestartOptions(values) {
        const options = {
            ...this.statsigInitOptions ?? this.initOptions
        };
        if (!options.sdkKey) options.sdkKey = values.clientSdkKey ?? await this.fetchStatsigSdkKey();
        return options;
    }
    async fetchStatsigSdkKey() {
        if (this.provider) return this.provider.getClientSdkKey();
        const initOptions = this.initOptions;
        if (initOptions && 'apiKey' in initOptions) return (await (0, $4QrHS.default).fetchClientSdk(initOptions)).clientSdkKey;
        // Initialized from values: the caller supplied the key, if any.
        return undefined;
    }
    /**
   * Stops Statsig while the Feature Flag Service disables it: the client is shut down and no longer
   * called, so its keys get the wrapper's defaults. It is started again when re-enabled.
   */ stopStatsig() {
        this.statsigGeneration += 1;
        const statsigClient = this.statsigClient;
        this.statsigClient = undefined;
        this.user = undefined;
        if (statsigClient) Promise.resolve(statsigClient.shutdown()).catch((error)=>{
            // eslint-disable-next-line no-console
            console.warn('Failed to shut down the Statsig client', error);
        });
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertReady();
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateClientsUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // A failed update leaves the initialization result as it was.
            this.initPromise = originalInitPromise;
            // Once the values arrive the client switches to the new user, even if Statsig then fails to
            // update, so the provider keeps the new profile. Only a failed fetch reverts it.
            if (this.isCurrentUser(identifiers, customAttributes)) return;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on each provider's client, independently: FFP serves the new
   * user's values even if Statsig fails to update, and a provider disabled by the Feature Flag
   * Service is stopped (or, if it is enabled again, started).
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateClientsUser(initializeValuesPromise, identifiers, customAttributes) {
        var _this$initOptions, _this$initOptions$upd;
        let initializeValues;
        try {
            initializeValues = await initializeValuesPromise;
        } catch (err) {
            var _updateUserCompletion, _ref;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_updateUserCompletion = (_ref = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref, false, errMsg);
            throw err;
        }
        const disabledProviders = initializeValues.disabledProviders ?? [];
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        this.ffp.apply(this.initOptions, disabledProviders.includes('ffp') ? undefined : initializeValues.ffp, identifiers, initializeValues.customAttributesFromFetch);
        let success = true;
        let errorMessage = null;
        try {
            await this.updateStatsigUser(initializeValues, identifiers, disabledProviders.includes('statsig'));
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
        this.subscriptions.anyUpdated();
        this.reportEvalFlagsStatus('updateUser', initializeValues.status);
        if (!success) throw new Error('Failed to update user. An unexpected error occured.');
    }
    /** Updates, starts or stops Statsig for a new user, as the Feature Flag Service directs. */ async updateStatsigUser(initializeValues, identifiers, disabled) {
        var _this$statsigStart;
        if (disabled) {
            this.stopStatsig();
            return;
        }
        // Let a start that is already in progress finish, then update the client it created.
        await ((_this$statsigStart = this.statsigStart) === null || _this$statsigStart === void 0 ? void 0 : _this$statsigStart.catch(()=>undefined));
        if (!this.statsigClient) {
            await this.restartStatsig(initializeValues, identifiers, initializeValues.customAttributesFromFetch);
            return;
        }
        const frontendUser = (0, $csevr.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
        this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
        this.user = (0, $5zsJk.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        await this.statsigClient.updateUserAsync(this.user);
    }
    /**
   * Picks the one source that answers for a gate or config, so a key never reaches a client that
   * does not own it:
   * - FFP, for a key in its latest payload. A local override for such a key is applied here
   *   instead, because Statsig must not be called for it.
   * - Statsig, for every other key while it is enabled. It applies local overrides itself.
   * - Otherwise a local override, or the wrapper's default.
   */ route(name, kind) {
        const servedByFfp = this.ffp.has(name);
        if (!servedByFfp && this.statsigClient) return {
            source: 'statsig',
            statsigClient: this.statsigClient
        };
        const override = this.overrideAdapter.getOverride(kind, name);
        if (override !== undefined) return {
            source: 'override',
            value: override
        };
        return {
            source: servedByFfp ? 'ffp' : 'default'
        };
    }
    /**
   * Throws until values have been applied by an initialize method. Statsig may legitimately be
   * absent afterwards, when the Feature Flag Service disables it.
   */ assertReady() {
        if (!this.valuesApplied) throw new Error('Client must be initialized before using this method');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $2YDEV.CLIENT_VERSION;
    }
    /**
   * Returns the `targetApp` value that was provided during client initialization.
   * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
   *
   * Returns `undefined` if `initialize` has never been called.
   *
   * @returns The targetApp string, or undefined if initialize has never been called.
   */ getTargetApp() {
        var _this$initOptions2;
        return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * Layers exist only in Statsig. Flags that only exist in the Feature Flag Platform (FFP) are read
   * with {@link Client.ffpClient}.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertReady();
            const { fireLayerExposure: fireLayerExposure = true } = options;
            if (!this.statsigClient) {
                // Layers are Statsig-only, so without Statsig only an override can serve one.
                const layer = (0, $drdCV._makeLayer)(layerName, {
                    reason: 'Unrecognized'
                }, null);
                return (0, $h14QI.Layer).fromLayer(this.overrideAdapter.getLayerOverride(layer, {}) ?? layer);
            }
            return (0, $h14QI.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $h14QI.Layer).fromLayer((0, $drdCV._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * Layers exist only in Statsig. Flags that only exist in the Feature Flag Platform (FFP) are read
   * with {@link Client.ffpClient}.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("drdCV", function(module, exports) {
"use strict";
var $9c885df8ded971a4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9c885df8ded971a4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9c885df8ded971a4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $2eC4V = parcelRequire("2eC4V");
module.exports.StatsigClient = $2eC4V.default;

$9c885df8ded971a4$var$__exportStar((parcelRequire("43xZh")), module.exports);
const $9c885df8ded971a4$var$__STATSIG__ = Object.assign((0, (parcelRequire("43xZh"))._getStatsigGlobal)(), {
    StatsigClient: $2eC4V.default
});
module.exports.default = $9c885df8ded971a4$var$__STATSIG__;

});
parcelRegister("43xZh", function(module, exports) {
"use strict";
var $2f41ce70c2207bee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2f41ce70c2207bee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2f41ce70c2207bee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("98VJX")).Diagnostics;
    }
});

var $iedfP = parcelRequire("iedfP");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $iedfP.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hwHco")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("50D8F")).Storage;
    }
});

$2f41ce70c2207bee$var$__exportStar((parcelRequire("57lb0")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("5gRYU")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("fQsmb")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("77zcO")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("98VJX")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("3U1ZO")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("lkSm2")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("csxYP")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("2kv9U")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("979Pl")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("6wiBW")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("hwHco")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("cL7Xw")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("5hL9X")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("2J7NS")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("bbtKw")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("30hqY")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("dKJwM")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("hiX04")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("k5ZRD")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("1AwjI")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("ji7JN")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("8Q8J8")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("3N6bL")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("iqfyz")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("kK0t3")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("ddH1s")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("kUuS0")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("jEzEK")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("bUTrg")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("30aRN")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("cG8S9")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("50D8F")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("5V1Jd")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("P1rWH")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("5AByv")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("lUjOe")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("i6B4H")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("iKPia")), module.exports);

$2f41ce70c2207bee$var$__exportStar((parcelRequire("jTF3q")), module.exports);
Object.assign((0, (parcelRequire("57lb0"))._getStatsigGlobal)(), {
    Log: (parcelRequire("hwHco")).Log,
    SDK_VERSION: (parcelRequire("ddH1s")).SDK_VERSION
});

});
parcelRegister("57lb0", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $3b9e086fec6b1ea1$var$_a, $3b9e086fec6b1ea1$var$_b, $3b9e086fec6b1ea1$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $hwHco = parcelRequire("hwHco");
const $3b9e086fec6b1ea1$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $3b9e086fec6b1ea1$var$statsigGlobal;
    } catch (e) {
        return $3b9e086fec6b1ea1$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $3b9e086fec6b1ea1$var$_getStatsigGlobal;
const $3b9e086fec6b1ea1$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $3b9e086fec6b1ea1$var$_getStatsigGlobalFlag;
const $3b9e086fec6b1ea1$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $hwHco.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $3b9e086fec6b1ea1$var$_getInstance;
const $3b9e086fec6b1ea1$var$GLOBAL_KEY = '__STATSIG__';
const $3b9e086fec6b1ea1$var$_window = typeof window !== 'undefined' ? window : {};
const $3b9e086fec6b1ea1$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $3b9e086fec6b1ea1$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $3b9e086fec6b1ea1$var$statsigGlobal = ($3b9e086fec6b1ea1$var$_c = ($3b9e086fec6b1ea1$var$_b = ($3b9e086fec6b1ea1$var$_a = $3b9e086fec6b1ea1$var$_window[$3b9e086fec6b1ea1$var$GLOBAL_KEY]) !== null && $3b9e086fec6b1ea1$var$_a !== void 0 ? $3b9e086fec6b1ea1$var$_a : $3b9e086fec6b1ea1$var$_global[$3b9e086fec6b1ea1$var$GLOBAL_KEY]) !== null && $3b9e086fec6b1ea1$var$_b !== void 0 ? $3b9e086fec6b1ea1$var$_b : $3b9e086fec6b1ea1$var$_globalThis[$3b9e086fec6b1ea1$var$GLOBAL_KEY]) !== null && $3b9e086fec6b1ea1$var$_c !== void 0 ? $3b9e086fec6b1ea1$var$_c : {
    instance: module.exports._getInstance
};
$3b9e086fec6b1ea1$var$_window[$3b9e086fec6b1ea1$var$GLOBAL_KEY] = $3b9e086fec6b1ea1$var$statsigGlobal;
$3b9e086fec6b1ea1$var$_global[$3b9e086fec6b1ea1$var$GLOBAL_KEY] = $3b9e086fec6b1ea1$var$statsigGlobal;
$3b9e086fec6b1ea1$var$_globalThis[$3b9e086fec6b1ea1$var$GLOBAL_KEY] = $3b9e086fec6b1ea1$var$statsigGlobal;

});
parcelRegister("hwHco", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $cc26ef3fd1aafbc9$var$DEBUG = ' DEBUG ';
const $cc26ef3fd1aafbc9$var$_INFO = '  INFO ';
const $cc26ef3fd1aafbc9$var$_WARN = '  WARN ';
const $cc26ef3fd1aafbc9$var$ERROR = ' ERROR ';
function $cc26ef3fd1aafbc9$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $cc26ef3fd1aafbc9$var$Log {
    static info(...args) {
        if ($cc26ef3fd1aafbc9$var$Log.level >= module.exports.LogLevel.Info) console.info($cc26ef3fd1aafbc9$var$_INFO, ...$cc26ef3fd1aafbc9$var$addTag(args));
    }
    static debug(...args) {
        if ($cc26ef3fd1aafbc9$var$Log.level >= module.exports.LogLevel.Debug) console.debug($cc26ef3fd1aafbc9$var$DEBUG, ...$cc26ef3fd1aafbc9$var$addTag(args));
    }
    static warn(...args) {
        if ($cc26ef3fd1aafbc9$var$Log.level >= module.exports.LogLevel.Warn) console.warn($cc26ef3fd1aafbc9$var$_WARN, ...$cc26ef3fd1aafbc9$var$addTag(args));
    }
    static error(...args) {
        if ($cc26ef3fd1aafbc9$var$Log.level >= module.exports.LogLevel.Error) console.error($cc26ef3fd1aafbc9$var$ERROR, ...$cc26ef3fd1aafbc9$var$addTag(args));
    }
}
module.exports.Log = $cc26ef3fd1aafbc9$var$Log;
$cc26ef3fd1aafbc9$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("98VJX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $6a81a66cd1b23665$var$MARKER_MAP = new Map();
const $6a81a66cd1b23665$var$ACT_START = 'start';
const $6a81a66cd1b23665$var$ACT_END = 'end';
const $6a81a66cd1b23665$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $6a81a66cd1b23665$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $6a81a66cd1b23665$var$_addMarker(sdkKey, $6a81a66cd1b23665$var$_createMarker({}, $6a81a66cd1b23665$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $6a81a66cd1b23665$var$_addMarker(sdkKey, $6a81a66cd1b23665$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $6a81a66cd1b23665$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $6a81a66cd1b23665$var$_addMarker(sdkKey, $6a81a66cd1b23665$var$_createMarker(data, $6a81a66cd1b23665$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $6a81a66cd1b23665$var$_addMarker(sdkKey, $6a81a66cd1b23665$var$_createMarker(data, $6a81a66cd1b23665$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $6a81a66cd1b23665$var$_addMarker(sdkKey, $6a81a66cd1b23665$var$_createMarker({}, $6a81a66cd1b23665$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $6a81a66cd1b23665$var$_addMarker(sdkKey, $6a81a66cd1b23665$var$_createMarker(data, $6a81a66cd1b23665$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $6a81a66cd1b23665$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $6a81a66cd1b23665$var$_safeGetField(e, 'code'),
            name: $6a81a66cd1b23665$var$_safeGetField(e, 'name'),
            message: $6a81a66cd1b23665$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $6a81a66cd1b23665$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $6a81a66cd1b23665$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $6a81a66cd1b23665$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $6a81a66cd1b23665$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $6a81a66cd1b23665$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $6a81a66cd1b23665$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $6a81a66cd1b23665$var$MARKER_MAP.set(sdkKey, markers);
}
function $6a81a66cd1b23665$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("iedfP", function(module, exports) {
"use strict";
var $d453d0d84ca681d5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $5gRYU = parcelRequire("5gRYU");

var $979Pl = parcelRequire("979Pl");

var $hwHco = parcelRequire("hwHco");

var $5hL9X = parcelRequire("5hL9X");

var $dKJwM = parcelRequire("dKJwM");

var $kK0t3 = parcelRequire("kK0t3");

var $kUuS0 = parcelRequire("kUuS0");

var $50D8F = parcelRequire("50D8F");

var $5AByv = parcelRequire("5AByv");

var $i6B4H = parcelRequire("i6B4H");
const $d453d0d84ca681d5$var$DEFAULT_QUEUE_SIZE = 100;
const $d453d0d84ca681d5$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $d453d0d84ca681d5$var$MAX_DEDUPER_KEYS = 1000;
const $d453d0d84ca681d5$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $d453d0d84ca681d5$var$MAX_FAILED_LOGS = 500;
const $d453d0d84ca681d5$var$QUICK_FLUSH_WINDOW_MS = 200;
const $d453d0d84ca681d5$var$EVENT_LOGGER_MAP = {};
class $d453d0d84ca681d5$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $d453d0d84ca681d5$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $d453d0d84ca681d5$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $kUuS0.LoggingEnabledOption.disabled : $kUuS0.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $hwHco.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $d453d0d84ca681d5$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $5AByv.UrlConfiguration($5hL9X.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $50D8F._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $50D8F.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $d453d0d84ca681d5$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $dKJwM._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $d453d0d84ca681d5$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $i6B4H._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $d453d0d84ca681d5$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $d453d0d84ca681d5$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $d453d0d84ca681d5$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $d453d0d84ca681d5$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $d453d0d84ca681d5$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $d453d0d84ca681d5$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$d453d0d84ca681d5$var$EventLogger._safeFlushAndForget(this._sdkKey), $d453d0d84ca681d5$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $dKJwM._isServerEnv)()) return false;
        if (!(0, $kK0t3._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $5gRYU._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $d453d0d84ca681d5$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $d453d0d84ca681d5$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $d453d0d84ca681d5$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $i6B4H._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $hwHco.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $hwHco.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $d453d0d84ca681d5$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$5hL9X.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        // Products opt into this patch through their own rollout controls.
        const boundFailedLogs = typeof window !== 'undefined' && window.__USE_STATSIG_PATCH__ === true;
        if (!boundFailedLogs) while(events.length > $d453d0d84ca681d5$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            // Bound the total retry queue only when the product opts in.
            // https://github.com/statsig-io/js-client-monorepo/issues/39
            const combined = [
                ...savedEvents,
                ...events
            ];
            if (boundFailedLogs && combined.length > 100) combined.splice(0, combined.length - 100);
            (0, $50D8F._setObjectInStorage)(storageKey, combined);
        } catch (_a) {
            $hwHco.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $50D8F._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$d453d0d84ca681d5$var$__awaiter(this, void 0, void 0, function*() {
                if (!$50D8F.Storage.isReady()) yield $50D8F.Storage.isReadyResolver();
                const events = (0, $50D8F._getObjectFromStorage)(storageKey);
                if (!events) return;
                $50D8F.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $hwHco.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $979Pl._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $hwHco.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $dKJwM._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $d453d0d84ca681d5$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $d453d0d84ca681d5$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $d453d0d84ca681d5$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $d453d0d84ca681d5$var$EventLogger;

});
parcelRegister("5gRYU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $979Pl = parcelRequire("979Pl");
function $3d6851f82a8b024b$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $979Pl._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $3d6851f82a8b024b$var$_getUserStorageKey;
function $3d6851f82a8b024b$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $3d6851f82a8b024b$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $979Pl._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $3d6851f82a8b024b$var$_getStorageKey;

});
parcelRegister("979Pl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $P1rWH = parcelRequire("P1rWH");
const $6a2c63f14c12b291$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $6a2c63f14c12b291$var$_DJB2;
const $6a2c63f14c12b291$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $6a2c63f14c12b291$var$_DJB2Object;
const $6a2c63f14c12b291$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $P1rWH._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $6a2c63f14c12b291$var$_getSortedObject;

});
parcelRegister("P1rWH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $0995e36c2104a2d5$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $0995e36c2104a2d5$var$_typeOf;
function $0995e36c2104a2d5$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $0995e36c2104a2d5$var$_isTypeMatch;

});



parcelRegister("5hL9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("dKJwM", function(module, exports) {

var $3jCFs = parcelRequire("3jCFs");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $a032e3171e96bb2b$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $a032e3171e96bb2b$var$_getWindowSafe;
const $a032e3171e96bb2b$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $a032e3171e96bb2b$var$_getDocumentSafe;
const $a032e3171e96bb2b$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3jCFs !== 'undefined' && $3jCFs.versions != null && $3jCFs.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $a032e3171e96bb2b$var$_isServerEnv;
const $a032e3171e96bb2b$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $a032e3171e96bb2b$var$_addWindowEventListenerSafe;
const $a032e3171e96bb2b$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $a032e3171e96bb2b$var$_addDocumentEventListenerSafe;
const $a032e3171e96bb2b$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $a032e3171e96bb2b$var$_getCurrentPageUrlSafe;
const $a032e3171e96bb2b$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $a032e3171e96bb2b$var$_getUnloadEvent;

});
parcelRegister("3jCFs", function(module, exports) {
// shim for using process in browser
var $26a1240c3192739a$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $26a1240c3192739a$var$cachedSetTimeout;
var $26a1240c3192739a$var$cachedClearTimeout;
function $26a1240c3192739a$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $26a1240c3192739a$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $26a1240c3192739a$var$cachedSetTimeout = setTimeout;
        else $26a1240c3192739a$var$cachedSetTimeout = $26a1240c3192739a$var$defaultSetTimout;
    } catch (e) {
        $26a1240c3192739a$var$cachedSetTimeout = $26a1240c3192739a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $26a1240c3192739a$var$cachedClearTimeout = clearTimeout;
        else $26a1240c3192739a$var$cachedClearTimeout = $26a1240c3192739a$var$defaultClearTimeout;
    } catch (e) {
        $26a1240c3192739a$var$cachedClearTimeout = $26a1240c3192739a$var$defaultClearTimeout;
    }
})();
function $26a1240c3192739a$var$runTimeout(fun) {
    if ($26a1240c3192739a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($26a1240c3192739a$var$cachedSetTimeout === $26a1240c3192739a$var$defaultSetTimout || !$26a1240c3192739a$var$cachedSetTimeout) && setTimeout) {
        $26a1240c3192739a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $26a1240c3192739a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $26a1240c3192739a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $26a1240c3192739a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $26a1240c3192739a$var$runClearTimeout(marker) {
    if ($26a1240c3192739a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($26a1240c3192739a$var$cachedClearTimeout === $26a1240c3192739a$var$defaultClearTimeout || !$26a1240c3192739a$var$cachedClearTimeout) && clearTimeout) {
        $26a1240c3192739a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $26a1240c3192739a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $26a1240c3192739a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $26a1240c3192739a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $26a1240c3192739a$var$queue = [];
var $26a1240c3192739a$var$draining = false;
var $26a1240c3192739a$var$currentQueue;
var $26a1240c3192739a$var$queueIndex = -1;
function $26a1240c3192739a$var$cleanUpNextTick() {
    if (!$26a1240c3192739a$var$draining || !$26a1240c3192739a$var$currentQueue) return;
    $26a1240c3192739a$var$draining = false;
    if ($26a1240c3192739a$var$currentQueue.length) $26a1240c3192739a$var$queue = $26a1240c3192739a$var$currentQueue.concat($26a1240c3192739a$var$queue);
    else $26a1240c3192739a$var$queueIndex = -1;
    if ($26a1240c3192739a$var$queue.length) $26a1240c3192739a$var$drainQueue();
}
function $26a1240c3192739a$var$drainQueue() {
    if ($26a1240c3192739a$var$draining) return;
    var timeout = $26a1240c3192739a$var$runTimeout($26a1240c3192739a$var$cleanUpNextTick);
    $26a1240c3192739a$var$draining = true;
    var len = $26a1240c3192739a$var$queue.length;
    while(len){
        $26a1240c3192739a$var$currentQueue = $26a1240c3192739a$var$queue;
        $26a1240c3192739a$var$queue = [];
        while(++$26a1240c3192739a$var$queueIndex < len)if ($26a1240c3192739a$var$currentQueue) $26a1240c3192739a$var$currentQueue[$26a1240c3192739a$var$queueIndex].run();
        $26a1240c3192739a$var$queueIndex = -1;
        len = $26a1240c3192739a$var$queue.length;
    }
    $26a1240c3192739a$var$currentQueue = null;
    $26a1240c3192739a$var$draining = false;
    $26a1240c3192739a$var$runClearTimeout(timeout);
}
$26a1240c3192739a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $26a1240c3192739a$var$queue.push(new $26a1240c3192739a$var$Item(fun, args));
    if ($26a1240c3192739a$var$queue.length === 1 && !$26a1240c3192739a$var$draining) $26a1240c3192739a$var$runTimeout($26a1240c3192739a$var$drainQueue);
};
// v8 likes predictible objects
function $26a1240c3192739a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$26a1240c3192739a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$26a1240c3192739a$var$process.title = 'browser';
$26a1240c3192739a$var$process.browser = true;
$26a1240c3192739a$var$process.env = {};
$26a1240c3192739a$var$process.argv = [];
$26a1240c3192739a$var$process.version = ''; // empty string to avoid regexp issues
$26a1240c3192739a$var$process.versions = {};
function $26a1240c3192739a$var$noop() {}
$26a1240c3192739a$var$process.on = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.addListener = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.once = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.off = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.removeListener = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.removeAllListeners = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.emit = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.prependListener = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.prependOnceListener = $26a1240c3192739a$var$noop;
$26a1240c3192739a$var$process.listeners = function(name) {
    return [];
};
$26a1240c3192739a$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$26a1240c3192739a$var$process.cwd = function() {
    return '/';
};
$26a1240c3192739a$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$26a1240c3192739a$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kK0t3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $f19877687ad13084$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $f19877687ad13084$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $f19877687ad13084$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $f19877687ad13084$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $f19877687ad13084$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $f19877687ad13084$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $f19877687ad13084$var$GATE_EXPOSURE_NAME || eventName === $f19877687ad13084$var$CONFIG_EXPOSURE_NAME || eventName === $f19877687ad13084$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $f19877687ad13084$var$_isExposureEvent;
const $f19877687ad13084$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $f19877687ad13084$var$_createExposure($f19877687ad13084$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $f19877687ad13084$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $f19877687ad13084$var$_createGateExposure;
function $f19877687ad13084$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $f19877687ad13084$var$_mapExposures;
const $f19877687ad13084$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $f19877687ad13084$var$_createExposure($f19877687ad13084$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $f19877687ad13084$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $f19877687ad13084$var$_createConfigExposure;
const $f19877687ad13084$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $f19877687ad13084$var$_createExposure($f19877687ad13084$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $f19877687ad13084$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $f19877687ad13084$var$_createLayerParameterExposure;
const $f19877687ad13084$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("kUuS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("50D8F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $hwHco = parcelRequire("hwHco");

var $dKJwM = parcelRequire("dKJwM");
const $3a5b4ffef109b8c9$var$inMemoryStore = {};
const $3a5b4ffef109b8c9$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$3a5b4ffef109b8c9$var$inMemoryStore[key] ? $3a5b4ffef109b8c9$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $3a5b4ffef109b8c9$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $3a5b4ffef109b8c9$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($3a5b4ffef109b8c9$var$inMemoryStore)
};
let $3a5b4ffef109b8c9$var$_localStorageProvider = null;
try {
    const win = (0, $dKJwM._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $3a5b4ffef109b8c9$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $hwHco.Log.warn('Failed to setup localStorageProvider.');
}
let $3a5b4ffef109b8c9$var$_main = $3a5b4ffef109b8c9$var$_localStorageProvider !== null && $3a5b4ffef109b8c9$var$_localStorageProvider !== void 0 ? $3a5b4ffef109b8c9$var$_localStorageProvider : $3a5b4ffef109b8c9$var$_inMemoryProvider;
let $3a5b4ffef109b8c9$var$_current = $3a5b4ffef109b8c9$var$_main;
function $3a5b4ffef109b8c9$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($3a5b4ffef109b8c9$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$3a5b4ffef109b8c9$var$_current.isReady(),
    isReadyResolver: ()=>$3a5b4ffef109b8c9$var$_current.isReadyResolver(),
    getProviderName: ()=>$3a5b4ffef109b8c9$var$_current.getProviderName(),
    getItem: (key)=>$3a5b4ffef109b8c9$var$_inMemoryBreaker(()=>$3a5b4ffef109b8c9$var$_current.getItem(key)),
    setItem: (key, value)=>$3a5b4ffef109b8c9$var$_inMemoryBreaker(()=>$3a5b4ffef109b8c9$var$_current.setItem(key, value)),
    removeItem: (key)=>$3a5b4ffef109b8c9$var$_current.removeItem(key),
    getAllKeys: ()=>$3a5b4ffef109b8c9$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $3a5b4ffef109b8c9$var$_main = newProvider;
        $3a5b4ffef109b8c9$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $3a5b4ffef109b8c9$var$_current = $3a5b4ffef109b8c9$var$_inMemoryProvider;
        else $3a5b4ffef109b8c9$var$_current = $3a5b4ffef109b8c9$var$_main;
    }
};
function $3a5b4ffef109b8c9$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $hwHco.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $3a5b4ffef109b8c9$var$_getObjectFromStorage;
function $3a5b4ffef109b8c9$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $3a5b4ffef109b8c9$var$_setObjectInStorage;

});

parcelRegister("5AByv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $979Pl = parcelRequire("979Pl");

var $5hL9X = parcelRequire("5hL9X");
const $411d72458b724d6f$var$ENDPOINT_DNS_KEY_MAP = {
    [$5hL9X.Endpoint._initialize]: 'i',
    [$5hL9X.Endpoint._rgstr]: 'e',
    [$5hL9X.Endpoint._download_config_specs]: 'd'
};
class $411d72458b724d6f$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $411d72458b724d6f$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $5hL9X.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $979Pl._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $411d72458b724d6f$var$UrlConfiguration;

});

parcelRegister("i6B4H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $dKJwM = parcelRequire("dKJwM");
const $d2e58bce57d3a23f$var$FOREGROUND = 'foreground';
const $d2e58bce57d3a23f$var$BACKGROUND = 'background';
const $d2e58bce57d3a23f$var$LISTENERS = [];
let $d2e58bce57d3a23f$var$current = $d2e58bce57d3a23f$var$FOREGROUND;
let $d2e58bce57d3a23f$var$isUnloading = false;
const $d2e58bce57d3a23f$var$_isCurrentlyVisible = ()=>{
    return $d2e58bce57d3a23f$var$current === $d2e58bce57d3a23f$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $d2e58bce57d3a23f$var$_isCurrentlyVisible;
const $d2e58bce57d3a23f$var$_isUnloading = ()=>$d2e58bce57d3a23f$var$isUnloading;
module.exports._isUnloading = $d2e58bce57d3a23f$var$_isUnloading;
const $d2e58bce57d3a23f$var$_subscribeToVisiblityChanged = (listener)=>{
    $d2e58bce57d3a23f$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $d2e58bce57d3a23f$var$_subscribeToVisiblityChanged;
const $d2e58bce57d3a23f$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $d2e58bce57d3a23f$var$current) return;
    $d2e58bce57d3a23f$var$current = visibility;
    $d2e58bce57d3a23f$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $d2e58bce57d3a23f$var$_notifyVisibilityChanged;
(0, $dKJwM._addWindowEventListenerSafe)('focus', ()=>{
    $d2e58bce57d3a23f$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($d2e58bce57d3a23f$var$FOREGROUND);
});
(0, $dKJwM._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($d2e58bce57d3a23f$var$BACKGROUND));
(0, $dKJwM._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $d2e58bce57d3a23f$var$FOREGROUND : $d2e58bce57d3a23f$var$BACKGROUND);
});
(0, $dKJwM._addWindowEventListenerSafe)((0, $dKJwM._getUnloadEvent)(), ()=>{
    $d2e58bce57d3a23f$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($d2e58bce57d3a23f$var$BACKGROUND);
});

});


parcelRegister("ddH1s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $99fddca3700f4ec5$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$99fddca3700f4ec5$var$metadata,
    add: (additions)=>{
        $99fddca3700f4ec5$var$metadata = Object.assign(Object.assign({}, $99fddca3700f4ec5$var$metadata), additions);
    }
};

});

parcelRegister("fQsmb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("77zcO", function(module, exports) {
"use strict";
var $52f47ef99a813a7e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $hwHco = parcelRequire("hwHco");

var $ji7JN = parcelRequire("ji7JN");

var $cG8S9 = parcelRequire("cG8S9");

var $50D8F = parcelRequire("50D8F");

var $5V1Jd = parcelRequire("5V1Jd");
const $52f47ef99a813a7e$var$CACHE_LIMIT = 10;
const $52f47ef99a813a7e$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $52f47ef99a813a7e$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $52f47ef99a813a7e$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $52f47ef99a813a7e$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $cG8S9._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $cG8S9._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $52f47ef99a813a7e$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $ji7JN.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $52f47ef99a813a7e$var$__awaiter(this, void 0, void 0, function*() {
            if (!$50D8F.Storage.isReady()) yield $50D8F.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $hwHco.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $52f47ef99a813a7e$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $cG8S9._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $52f47ef99a813a7e$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $hwHco.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $5V1Jd._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $ji7JN.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $52f47ef99a813a7e$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $52f47ef99a813a7e$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $hwHco.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $50D8F.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($50D8F.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $5V1Jd._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $52f47ef99a813a7e$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $50D8F.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $50D8F._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $52f47ef99a813a7e$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $50D8F.Storage.removeItem(evictable);
        }
        (0, $50D8F._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $52f47ef99a813a7e$var$DataAdapterCore;
function $52f47ef99a813a7e$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $cG8S9._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $52f47ef99a813a7e$var$_makeDataAdapterResult;
class $52f47ef99a813a7e$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $hwHco.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $52f47ef99a813a7e$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $52f47ef99a813a7e$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("ji7JN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $5gRYU = parcelRequire("5gRYU");

var $hwHco = parcelRequire("hwHco");

var $dKJwM = parcelRequire("dKJwM");

var $50D8F = parcelRequire("50D8F");

var $lUjOe = parcelRequire("lUjOe");
const $e0b5b34e88cf4f12$var$PROMISE_MAP = {};
const $e0b5b34e88cf4f12$var$COOKIE_ENABLED_MAP = {};
const $e0b5b34e88cf4f12$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($e0b5b34e88cf4f12$var$DISABLED_MAP[sdkKey]) return null;
        if ($e0b5b34e88cf4f12$var$PROMISE_MAP[sdkKey] != null) return $e0b5b34e88cf4f12$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $e0b5b34e88cf4f12$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $e0b5b34e88cf4f12$var$PROMISE_MAP[sdkKey] = stableID;
            $e0b5b34e88cf4f12$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $e0b5b34e88cf4f12$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $lUjOe.getUUID)();
        $e0b5b34e88cf4f12$var$_persistToStorage(stableID, sdkKey);
        $e0b5b34e88cf4f12$var$_persistToCookie(stableID, sdkKey);
        $e0b5b34e88cf4f12$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $e0b5b34e88cf4f12$var$PROMISE_MAP[sdkKey] = override;
        $e0b5b34e88cf4f12$var$_persistToStorage(override, sdkKey);
        $e0b5b34e88cf4f12$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $e0b5b34e88cf4f12$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $e0b5b34e88cf4f12$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $e0b5b34e88cf4f12$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $5gRYU._getStorageKey)(sdkKey)}`;
}
function $e0b5b34e88cf4f12$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $e0b5b34e88cf4f12$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $50D8F._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $hwHco.Log.warn('Failed to save StableID to storage');
    }
}
function $e0b5b34e88cf4f12$var$_loadFromStorage(sdkKey) {
    const storageKey = $e0b5b34e88cf4f12$var$_getStableIDStorageKey(sdkKey);
    return (0, $50D8F._getObjectFromStorage)(storageKey);
}
function $e0b5b34e88cf4f12$var$_loadFromCookie(sdkKey) {
    if (!$e0b5b34e88cf4f12$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $dKJwM._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $e0b5b34e88cf4f12$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $e0b5b34e88cf4f12$var$_persistToCookie(stableID, sdkKey) {
    if (!$e0b5b34e88cf4f12$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $dKJwM._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$e0b5b34e88cf4f12$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $e0b5b34e88cf4f12$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $5gRYU._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $e0b5b34e88cf4f12$var$getCookieName;

});
parcelRegister("lUjOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $ff2e31a0e5d307bd$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $ff2e31a0e5d307bd$var$getUUID;

});


parcelRegister("cG8S9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $979Pl = parcelRequire("979Pl");

var $hwHco = parcelRequire("hwHco");
function $93b04a2b58716663$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $hwHco.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $93b04a2b58716663$var$_normalizeUser;
function $93b04a2b58716663$var$_getFullUserHash(user) {
    return user ? (0, $979Pl._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $93b04a2b58716663$var$_getFullUserHash;

});

parcelRegister("5V1Jd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $hwHco = parcelRequire("hwHco");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $44f39dce1b48b147$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $hwHco.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $44f39dce1b48b147$var$_typedJsonParse;

});


parcelRegister("3U1ZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lkSm2", function(module, exports) {
"use strict";
var $f885a0df9b4fcf66$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $hwHco = parcelRequire("hwHco");

var $hiX04 = parcelRequire("hiX04");

var $ddH1s = parcelRequire("ddH1s");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $f885a0df9b4fcf66$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $f885a0df9b4fcf66$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $f885a0df9b4fcf66$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $f885a0df9b4fcf66$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $hwHco.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$f885a0df9b4fcf66$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($f885a0df9b4fcf66$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $f885a0df9b4fcf66$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $hiX04.SDKType._get(this._sdkKey);
                    const statsigMetadata = $ddH1s.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $f885a0df9b4fcf66$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $f885a0df9b4fcf66$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $f885a0df9b4fcf66$var$ErrorBoundary;
function $f885a0df9b4fcf66$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $f885a0df9b4fcf66$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $f885a0df9b4fcf66$var$UNKNOWN_ERROR;
    }
}
function $f885a0df9b4fcf66$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $f885a0df9b4fcf66$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("hiX04", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $c991e248c5586c5e$var$SDK_CLIENT = {};
let $c991e248c5586c5e$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $c991e248c5586c5e$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($c991e248c5586c5e$var$suffix !== null && $c991e248c5586c5e$var$suffix !== void 0 ? $c991e248c5586c5e$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $c991e248c5586c5e$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$c991e248c5586c5e$var$suffix || $c991e248c5586c5e$var$suffix === '-react') $c991e248c5586c5e$var$suffix = '-' + binding;
    }
};

});


parcelRegister("csxYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2kv9U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6wiBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cL7Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $94a00c57b8e0f735$var$EXIST_KEYS = new Set([]);
const $94a00c57b8e0f735$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $94a00c57b8e0f735$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($94a00c57b8e0f735$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($94a00c57b8e0f735$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $94a00c57b8e0f735$var$createMemoKey;

});

parcelRegister("2J7NS", function(module, exports) {
"use strict";
var $1fc5d65c90d07eac$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $57lb0 = parcelRequire("57lb0");

var $57lb0 = parcelRequire("57lb0");

var $98VJX = parcelRequire("98VJX");

var $hwHco = parcelRequire("hwHco");

var $5hL9X = parcelRequire("5hL9X");

var $1rk4w = parcelRequire("1rk4w");

var $jTF3q = parcelRequire("jTF3q");

var $hiX04 = parcelRequire("hiX04");

var $dKJwM = parcelRequire("dKJwM");

var $k5ZRD = parcelRequire("k5ZRD");

var $ji7JN = parcelRequire("ji7JN");

var $3N6bL = parcelRequire("3N6bL");

var $ddH1s = parcelRequire("ddH1s");

var $kUuS0 = parcelRequire("kUuS0");

var $i6B4H = parcelRequire("i6B4H");
const $1fc5d65c90d07eac$var$DEFAULT_TIMEOUT_MS = 10000;
const $1fc5d65c90d07eac$var$BACKOFF_BASE_MS = 500;
const $1fc5d65c90d07eac$var$BACKOFF_MAX_MS = 30000;
const $1fc5d65c90d07eac$var$RATE_LIMIT_WINDOW_MS = 1000;
const $1fc5d65c90d07eac$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $1fc5d65c90d07eac$var$LEAK_RATE = $1fc5d65c90d07eac$var$RATE_LIMIT_MAX_REQ_COUNT / $1fc5d65c90d07eac$var$RATE_LIMIT_WINDOW_MS;
const $1fc5d65c90d07eac$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $1fc5d65c90d07eac$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $1fc5d65c90d07eac$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $1rk4w.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$1fc5d65c90d07eac$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $1fc5d65c90d07eac$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $1fc5d65c90d07eac$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$1fc5d65c90d07eac$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $hwHco.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $i6B4H._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $1fc5d65c90d07eac$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $1fc5d65c90d07eac$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $1fc5d65c90d07eac$var$_getErrorMessage(error);
                const timedOut = $1fc5d65c90d07eac$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $1fc5d65c90d07eac$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$1fc5d65c90d07eac$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $3N6bL.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $hwHco.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $1fc5d65c90d07eac$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $kUuS0.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $kUuS0.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $1fc5d65c90d07eac$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $1fc5d65c90d07eac$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $5hL9X.Endpoint._initialize || args.urlConfig.endpoint === $5hL9X.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$5hL9X.NetworkParam.SdkKey]: args.sdkKey,
            [$5hL9X.NetworkParam.SdkType]: $hiX04.SDKType._get(args.sdkKey),
            [$5hL9X.NetworkParam.SdkVersion]: $ddH1s.SDK_VERSION,
            [$5hL9X.NetworkParam.Time]: String(Date.now()),
            [$5hL9X.NetworkParam.SessionID]: $k5ZRD.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $dKJwM._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $57lb0._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$5hL9X.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $hwHco.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $1fc5d65c90d07eac$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$1fc5d65c90d07eac$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($hwHco.Log.error);
                writer.close().catch($hwHco.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$5hL9X.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $hwHco.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $1fc5d65c90d07eac$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $1fc5d65c90d07eac$var$NetworkCore;
const $1fc5d65c90d07eac$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $hwHco.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $1fc5d65c90d07eac$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $ji7JN.StableID.get(sdkKey);
    const sessionID = $k5ZRD.SessionID.get(sdkKey);
    const sdkType = $hiX04.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $ddH1s.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $1fc5d65c90d07eac$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $57lb0._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $jTF3q.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $kUuS0.LogEventCompressionMode.Disabled:
            return false;
        case $kUuS0.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $kUuS0.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $1fc5d65c90d07eac$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $1fc5d65c90d07eac$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $1fc5d65c90d07eac$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $5hL9X.Endpoint._initialize) return;
    $98VJX.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $1fc5d65c90d07eac$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $5hL9X.Endpoint._initialize) return;
    $98VJX.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $98VJX.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $1fc5d65c90d07eac$var$_exponentialBackoff(attempt) {
    return $1fc5d65c90d07eac$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($1fc5d65c90d07eac$var$BACKOFF_BASE_MS * (attempt * attempt), $1fc5d65c90d07eac$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("1rk4w", function(module, exports) {
"use strict";
var $10c7e1f1dac89b58$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $gCdcC = parcelRequire("gCdcC");

var $979Pl = parcelRequire("979Pl");

var $hwHco = parcelRequire("hwHco");

var $50D8F = parcelRequire("50D8F");
const $10c7e1f1dac89b58$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $10c7e1f1dac89b58$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $10c7e1f1dac89b58$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $10c7e1f1dac89b58$var$DEFAULT_TTL_MS;
        $10c7e1f1dac89b58$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $10c7e1f1dac89b58$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $10c7e1f1dac89b58$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $10c7e1f1dac89b58$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$10c7e1f1dac89b58$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $10c7e1f1dac89b58$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $10c7e1f1dac89b58$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $10c7e1f1dac89b58$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $10c7e1f1dac89b58$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $gCdcC._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $10c7e1f1dac89b58$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $10c7e1f1dac89b58$var$NetworkFallbackResolver;
function $10c7e1f1dac89b58$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $10c7e1f1dac89b58$var$_isDomainFailure;
function $10c7e1f1dac89b58$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $979Pl._DJB2)(sdkKey)}`;
}
function $10c7e1f1dac89b58$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $10c7e1f1dac89b58$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $50D8F.Storage.removeItem(hashKey);
        return;
    }
    $50D8F.Storage.setItem(hashKey, JSON.stringify(info));
}
function $10c7e1f1dac89b58$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $10c7e1f1dac89b58$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $50D8F.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $hwHco.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $10c7e1f1dac89b58$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("gCdcC", function(module, exports) {
"use strict";
var $c18a6faf0a233eeb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $c18a6faf0a233eeb$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $c18a6faf0a233eeb$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $c18a6faf0a233eeb$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $c18a6faf0a233eeb$var$MAX_START_LOOKUP = 200;
function $c18a6faf0a233eeb$var$_fetchTxtRecords(networkFunc) {
    return $c18a6faf0a233eeb$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($c18a6faf0a233eeb$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $c18a6faf0a233eeb$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $c18a6faf0a233eeb$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $c18a6faf0a233eeb$var$_fetchTxtRecords;
function $c18a6faf0a233eeb$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $c18a6faf0a233eeb$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $c18a6faf0a233eeb$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("jTF3q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $e7c2ffea90055803$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $e7c2ffea90055803$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $e7c2ffea90055803$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("k5ZRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $57lb0 = parcelRequire("57lb0");

var $5gRYU = parcelRequire("5gRYU");

var $hwHco = parcelRequire("hwHco");

var $50D8F = parcelRequire("50D8F");

var $lUjOe = parcelRequire("lUjOe");
const $ea144335462ff14a$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $ea144335462ff14a$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $ea144335462ff14a$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($ea144335462ff14a$var$PROMISE_MAP[sdkKey] == null) $ea144335462ff14a$var$PROMISE_MAP[sdkKey] = $ea144335462ff14a$var$_loadSession(sdkKey);
        const session = $ea144335462ff14a$var$PROMISE_MAP[sdkKey];
        return $ea144335462ff14a$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $ea144335462ff14a$var$PROMISE_MAP[sdkKey] = $ea144335462ff14a$var$_overrideSessionId(override, sdkKey);
    }
};
function $ea144335462ff14a$var$_loadSession(sdkKey) {
    let data = $ea144335462ff14a$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $lUjOe.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $ea144335462ff14a$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $ea144335462ff14a$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($ea144335462ff14a$var$_isIdle(data) || $ea144335462ff14a$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $lUjOe.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $ea144335462ff14a$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $ea144335462ff14a$var$_createSessionTimeout(sdkKey, $ea144335462ff14a$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $ea144335462ff14a$var$_createSessionTimeout(sdkKey, $ea144335462ff14a$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $ea144335462ff14a$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $57lb0._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $ea144335462ff14a$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $ea144335462ff14a$var$MAX_SESSION_IDLE_TIME;
}
function $ea144335462ff14a$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $ea144335462ff14a$var$MAX_SESSION_AGE;
}
function $ea144335462ff14a$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $5gRYU._getStorageKey)(sdkKey)}`;
}
function $ea144335462ff14a$var$_persistToStorage(session, sdkKey) {
    const storageKey = $ea144335462ff14a$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $50D8F._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $hwHco.Log.warn('Failed to save SessionID');
    }
}
function $ea144335462ff14a$var$_loadFromStorage(sdkKey) {
    const storageKey = $ea144335462ff14a$var$_getSessionIDStorageKey(sdkKey);
    return (0, $50D8F._getObjectFromStorage)(storageKey);
}

});

parcelRegister("3N6bL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("bbtKw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("30hqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1AwjI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $128238b571f4a1b9$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $128238b571f4a1b9$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $128238b571f4a1b9$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $128238b571f4a1b9$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $128238b571f4a1b9$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $128238b571f4a1b9$var$_fastApproxSizeOf;

});

parcelRegister("8Q8J8", function(module, exports) {
"use strict";
var $66f9f30b4eee0bca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $57lb0 = parcelRequire("57lb0");

var $57lb0 = parcelRequire("57lb0");

var $lkSm2 = parcelRequire("lkSm2");

var $iedfP = parcelRequire("iedfP");

var $hwHco = parcelRequire("hwHco");

var $cL7Xw = parcelRequire("cL7Xw");

var $dKJwM = parcelRequire("dKJwM");

var $k5ZRD = parcelRequire("k5ZRD");

var $ji7JN = parcelRequire("ji7JN");

var $kUuS0 = parcelRequire("kUuS0");

var $50D8F = parcelRequire("50D8F");
const $66f9f30b4eee0bca$var$MAX_MEMO_CACHE_SIZE = 3000;
class $66f9f30b4eee0bca$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($hwHco.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $50D8F.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $k5ZRD.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $50D8F.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $ji7JN.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $ji7JN.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $iedfP.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $lkSm2.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $50D8F.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $66f9f30b4eee0bca$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $50D8F.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $ji7JN.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($kUuS0.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $66f9f30b4eee0bca$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $hwHco.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $cL7Xw.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $66f9f30b4eee0bca$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $66f9f30b4eee0bca$var$StatsigClientBase;
function $66f9f30b4eee0bca$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $dKJwM._isServerEnv)()) return;
    const statsigGlobal = (0, $57lb0._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $hwHco.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("iqfyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("jEzEK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bUTrg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $hwHco = parcelRequire("hwHco");

var $P1rWH = parcelRequire("P1rWH");
function $8acfeda7f21beb51$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $8acfeda7f21beb51$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $8acfeda7f21beb51$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $8acfeda7f21beb51$var$_makeFeatureGate;
function $8acfeda7f21beb51$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $8acfeda7f21beb51$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $8acfeda7f21beb51$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $8acfeda7f21beb51$var$_makeDynamicConfig;
function $8acfeda7f21beb51$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $8acfeda7f21beb51$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $8acfeda7f21beb51$var$_makeExperiment;
function $8acfeda7f21beb51$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $8acfeda7f21beb51$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $8acfeda7f21beb51$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $8acfeda7f21beb51$var$_makeLayer;
function $8acfeda7f21beb51$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $8acfeda7f21beb51$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $8acfeda7f21beb51$var$_mergeOverride;
function $8acfeda7f21beb51$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $P1rWH._isTypeMatch)(found, fallback)) {
            $hwHco.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $8acfeda7f21beb51$var$_makeTypedGet;

});

parcelRegister("30aRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iKPia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $da744f64ae857ffc$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $da744f64ae857ffc$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("2eC4V", function(module, exports) {
"use strict";
var $1a0a6d2943c949c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $43xZh = parcelRequire("43xZh");

var $bm87r = parcelRequire("bm87r");

var $fpCML = parcelRequire("fpCML");

var $iItVv = parcelRequire("iItVv");

var $9tCwk = parcelRequire("9tCwk");
class $1a0a6d2943c949c2$var$StatsigClient extends $43xZh.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $43xZh._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $1a0a6d2943c949c2$var$StatsigClient) return instance;
        $43xZh.Log.warn((0, $43xZh._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $1a0a6d2943c949c2$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $43xZh.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $fpCML.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $9tCwk.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($43xZh.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($43xZh.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($43xZh.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($43xZh.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($43xZh.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($43xZh.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $bm87r.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $43xZh.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $43xZh.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $1a0a6d2943c949c2$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $43xZh.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $43xZh.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $1a0a6d2943c949c2$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $1a0a6d2943c949c2$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $43xZh.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $43xZh.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $43xZh.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $43xZh.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($43xZh.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $43xZh.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $43xZh.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $43xZh.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $43xZh.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $43xZh.StatsigSession.get(this._sdkKey),
            stableID: $43xZh.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $1a0a6d2943c949c2$var$__awaiter(this, void 0, void 0, function*() {
            if (!$43xZh.Storage.isReady()) yield $43xZh.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $43xZh.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $43xZh.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $43xZh._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$43xZh.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$43xZh.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $43xZh.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $43xZh._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $43xZh._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $43xZh._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $43xZh._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $43xZh._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $43xZh._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $43xZh._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $43xZh._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $43xZh._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $43xZh._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $iItVv._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $iItVv._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $1a0a6d2943c949c2$var$StatsigClient;

});
parcelRegister("bm87r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $43xZh = parcelRequire("43xZh");

var $cEVXx = parcelRequire("cEVXx");

var $8OIks = parcelRequire("8OIks");
class $84480c0a968e0ade$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $43xZh._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $43xZh._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $8OIks.V2InitializeContainer(values);
        else this._values = new $cEVXx.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $43xZh.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $43xZh.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $43xZh._getFullUserHash)(userForComparison) !== (0, $43xZh._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $84480c0a968e0ade$var$EvaluationStore;

});
parcelRegister("cEVXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $43xZh = parcelRequire("43xZh");
class $93762dfae09e1519$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $43xZh._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $93762dfae09e1519$var$V1InitializeContainer;

});

parcelRegister("8OIks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $43xZh = parcelRequire("43xZh");
class $66b5610a6a215791$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $43xZh._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $66b5610a6a215791$var$V2InitializeContainer;

});


parcelRegister("fpCML", function(module, exports) {
"use strict";
var $b38746d380dd2baf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $43xZh = parcelRequire("43xZh");

var $arq4S = parcelRequire("arq4S");
class $b38746d380dd2baf$var$StatsigNetwork extends $43xZh.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $43xZh.UrlConfiguration($43xZh.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $b38746d380dd2baf$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $43xZh._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $b38746d380dd2baf$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $arq4S._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $b38746d380dd2baf$var$StatsigNetwork;

});
parcelRegister("arq4S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $43xZh = parcelRequire("43xZh");
const $79a0a77ec3eeb53c$var$MAX_DELTAS_SORT_DEPTH = 2;
function $79a0a77ec3eeb53c$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $43xZh._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $79a0a77ec3eeb53c$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $79a0a77ec3eeb53c$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $43xZh._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $79a0a77ec3eeb53c$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $79a0a77ec3eeb53c$var$_resolveDeltasResponse;
function $79a0a77ec3eeb53c$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $79a0a77ec3eeb53c$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $79a0a77ec3eeb53c$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $79a0a77ec3eeb53c$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $79a0a77ec3eeb53c$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $79a0a77ec3eeb53c$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("iItVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $43xZh = parcelRequire("43xZh");
const $da038cdb65dad68b$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $da038cdb65dad68b$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $da038cdb65dad68b$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $43xZh._isTypeMatch)(value, fallback);
}
function $da038cdb65dad68b$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $da038cdb65dad68b$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $da038cdb65dad68b$var$_shouldLogExposure(options) ? undefined : $da038cdb65dad68b$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $da038cdb65dad68b$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $da038cdb65dad68b$var$_shouldLogExposure(options) ? undefined : $da038cdb65dad68b$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($da038cdb65dad68b$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $da038cdb65dad68b$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $da038cdb65dad68b$var$_shouldLogExposure(options) ? undefined : $da038cdb65dad68b$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($da038cdb65dad68b$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $da038cdb65dad68b$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $da038cdb65dad68b$var$_shouldLogExposure(options) ? undefined : $da038cdb65dad68b$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($da038cdb65dad68b$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $da038cdb65dad68b$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $43xZh._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $da038cdb65dad68b$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $da038cdb65dad68b$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $da038cdb65dad68b$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $da038cdb65dad68b$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $da038cdb65dad68b$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $da038cdb65dad68b$var$_makeParamStoreGetter;

});

parcelRegister("9tCwk", function(module, exports) {
"use strict";
var $6e64b3d8f6450793$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $43xZh = parcelRequire("43xZh");

var $fpCML = parcelRequire("fpCML");
class $6e64b3d8f6450793$var$StatsigEvaluationsDataAdapter extends $43xZh.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $fpCML.default) this._network = network;
        else this._network = new $fpCML.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $43xZh._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $43xZh._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $43xZh.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $6e64b3d8f6450793$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $43xZh._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$43xZh.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $43xZh._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $6e64b3d8f6450793$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("gfBt2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec8bb033e38f9c4f$export$2e2bcd8739ae039);

var $kmfeD = parcelRequire("kmfeD");
const $ec8bb033e38f9c4f$export$a66cbd9b2289cd78 = '@all-features';
class $ec8bb033e38f9c4f$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($kmfeD)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($ec8bb033e38f9c4f$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($ec8bb033e38f9c4f$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($ec8bb033e38f9c4f$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $ec8bb033e38f9c4f$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});
parcelRegister("kmfeD", function(module, exports) {
'use strict';
var $ed21ae0fe61ebe5f$var$has = Object.prototype.hasOwnProperty, $ed21ae0fe61ebe5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $ed21ae0fe61ebe5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $ed21ae0fe61ebe5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $ed21ae0fe61ebe5f$var$Events().__proto__) $ed21ae0fe61ebe5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $ed21ae0fe61ebe5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $ed21ae0fe61ebe5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $ed21ae0fe61ebe5f$var$EE(fn, context || emitter, once), evt = $ed21ae0fe61ebe5f$var$prefix ? $ed21ae0fe61ebe5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $ed21ae0fe61ebe5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $ed21ae0fe61ebe5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $ed21ae0fe61ebe5f$var$EventEmitter() {
    this._events = new $ed21ae0fe61ebe5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($ed21ae0fe61ebe5f$var$has.call(events, name)) names.push($ed21ae0fe61ebe5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $ed21ae0fe61ebe5f$var$prefix ? $ed21ae0fe61ebe5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $ed21ae0fe61ebe5f$var$prefix ? $ed21ae0fe61ebe5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $ed21ae0fe61ebe5f$var$prefix ? $ed21ae0fe61ebe5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $ed21ae0fe61ebe5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $ed21ae0fe61ebe5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $ed21ae0fe61ebe5f$var$prefix ? $ed21ae0fe61ebe5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $ed21ae0fe61ebe5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $ed21ae0fe61ebe5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $ed21ae0fe61ebe5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $ed21ae0fe61ebe5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $ed21ae0fe61ebe5f$var$prefix ? $ed21ae0fe61ebe5f$var$prefix + event : event;
        if (this._events[evt]) $ed21ae0fe61ebe5f$var$clearEvent(this, evt);
    } else {
        this._events = new $ed21ae0fe61ebe5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$ed21ae0fe61ebe5f$var$EventEmitter.prototype.off = $ed21ae0fe61ebe5f$var$EventEmitter.prototype.removeListener;
$ed21ae0fe61ebe5f$var$EventEmitter.prototype.addListener = $ed21ae0fe61ebe5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$ed21ae0fe61ebe5f$var$EventEmitter.prefixed = $ed21ae0fe61ebe5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$ed21ae0fe61ebe5f$var$EventEmitter.EventEmitter = $ed21ae0fe61ebe5f$var$EventEmitter;
module.exports = $ed21ae0fe61ebe5f$var$EventEmitter;

});


parcelRegister("3ZUoj", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $25cda670854d4494$export$6dc24881a3d96325);

var $5rIRZ = parcelRequire("5rIRZ");

var $amxO3 = parcelRequire("amxO3");
class $25cda670854d4494$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        var _experiment$__evaluat;
        const config = new $25cda670854d4494$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $5rIRZ.migrateEvaluationDetails)(experiment.details), (0, $amxO3.migrateSecondaryExposures)(((_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures) ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        var _this$_onDefaultValue2;
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            var _this$_onDefaultValue;
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("5rIRZ", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $c7b864b87bd838a4$export$18ad168d3dbac899);

var $1us34 = parcelRequire("1us34");
const $c7b864b87bd838a4$var$evaluationReasonMappings = Object.entries((0, $1us34.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $c7b864b87bd838a4$export$18ad168d3dbac899 = (details)=>{
    var _evaluationReasonMapp;
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: ((_evaluationReasonMapp = $c7b864b87bd838a4$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))) === null || _evaluationReasonMapp === void 0 ? void 0 : _evaluationReasonMapp[1]) ?? (0, $1us34.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("1us34", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $a3d87ee7934f77f9$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $a3d87ee7934f77f9$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});


parcelRegister("amxO3", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $3e92b9a179e445e1$export$55fd683752d01e67);
const $3e92b9a179e445e1$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("h14QI", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $981b646bccfff268$export$936d0764594b6eb3);

var $5rIRZ = parcelRequire("5rIRZ");

var $amxO3 = parcelRequire("amxO3");
class $981b646bccfff268$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
        const value = new $981b646bccfff268$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $5rIRZ.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $amxO3.migrateSecondaryExposures)(((_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) ?? []), (0, $amxO3.migrateSecondaryExposures)(((_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) ?? []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        var _this$_logParameterFu;
        (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
    }
}

});

parcelRegister("5zsJk", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $ad4e9ebc4ee4a51a$export$1148cb79ceecd5fa);
/**
 * Deeply merges source objects into the target object.
 * Handles nested objects, but arrays are not handled (replaced).
 */ function $ad4e9ebc4ee4a51a$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $ad4e9ebc4ee4a51a$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $ad4e9ebc4ee4a51a$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $ad4e9ebc4ee4a51a$export$1148cb79ceecd5fa(target, ...sources);
}

});

parcelRegister("fXaVY", function(module, exports) {
$parcel$export(module.exports, "isEvalFlagsDegraded", () => $457863d6c0d65c4e$export$426949866882809c);
const $457863d6c0d65c4e$export$426949866882809c = (status)=>status.statsig === 'UNAVAILABLE' || status.ffp === 'UNAVAILABLE' || status.statsig === 'DISABLED' && status.ffp === 'DISABLED';

});

parcelRegister("5ZzJh", function(module, exports) {
$parcel$export(module.exports, "toInitializeValues", () => $28284fe0d173a9a8$export$8a9596f588a26431);

var $2pZxH = parcelRequire("2pZxH");
const $28284fe0d173a9a8$export$8a9596f588a26431 = (response, requestCustomAttributes)=>{
    const { status: status, statsig: statsig, ffp: ffp } = (0, $2pZxH.decodeEvalFlagsResponse)(response);
    const disabledProviders = [
        'statsig',
        'ffp'
    ].filter((provider)=>status[provider] === 'DISABLED');
    return {
        clientSdkKey: statsig === null || statsig === void 0 ? void 0 : statsig.clientSdkKey,
        experimentValues: (statsig === null || statsig === void 0 ? void 0 : statsig.experimentValues) ?? {},
        customAttributesFromFetch: (statsig === null || statsig === void 0 ? void 0 : statsig.customAttributes) ?? requestCustomAttributes,
        ffp: ffp,
        status: status,
        ...disabledProviders.length > 0 && {
            disabledProviders: disabledProviders
        }
    };
};

});
parcelRegister("2pZxH", function(module, exports) {
$parcel$export(module.exports, "decodeEvalFlagsResponse", () => $c7cdec57095eaea9$export$b697cf918684dbf0);
// @atlaskit/feature-gate-fetcher imports the helpers in this directory through the `./eval-flags/*`
// entry points, so the client and the providers share one implementation.
const $c7cdec57095eaea9$var$PROVIDER_STATUSES = [
    'OK',
    'DISABLED',
    'UNAVAILABLE'
];
const $c7cdec57095eaea9$var$isRecord = (value)=>typeof value === 'object' && value !== null;
/** The status the service reported, or `undefined` when it is absent or unknown to this client. */ const $c7cdec57095eaea9$var$decodeReportedStatus = (reported)=>$c7cdec57095eaea9$var$PROVIDER_STATUSES.find((status)=>status === reported);
/**
 * A provider's status when the service reported none this client knows. The body is not validated,
 * so this falls back to the sections, which the service omits for a provider it did not use.
 */ const $c7cdec57095eaea9$var$statusFromSection = (section)=>section === undefined ? 'DISABLED' : 'OK';
/** A section normalised to `undefined` unless it carries values. */ const $c7cdec57095eaea9$var$sectionWithValues = (section, hasValues)=>hasValues ? section ?? undefined : undefined;
/** The Statsig section when it carries values; `undefined` when omitted, `null` or empty. */ const $c7cdec57095eaea9$var$decodeStatsigSection = (response)=>{
    var _response$statsig;
    return $c7cdec57095eaea9$var$sectionWithValues(response.statsig, $c7cdec57095eaea9$var$isRecord((_response$statsig = response.statsig) === null || _response$statsig === void 0 ? void 0 : _response$statsig.experimentValues));
};
/** The FFP section when it carries flags; `undefined` when omitted, `null` or empty. */ const $c7cdec57095eaea9$var$decodeFfpSection = (response)=>{
    var _response$ffp;
    return $c7cdec57095eaea9$var$sectionWithValues(response.ffp, $c7cdec57095eaea9$var$isRecord((_response$ffp = response.ffp) === null || _response$ffp === void 0 ? void 0 : _response$ffp.flags));
};
/** A section a caller may use, which is one whose provider is `OK`. */ const $c7cdec57095eaea9$var$whenOk = (section, status)=>status === 'OK' ? section : undefined;
const $c7cdec57095eaea9$export$b697cf918684dbf0 = (response)=>{
    var _response$status, _response$status2;
    const statsig = $c7cdec57095eaea9$var$decodeStatsigSection(response);
    const ffp = $c7cdec57095eaea9$var$decodeFfpSection(response);
    const status = {
        statsig: $c7cdec57095eaea9$var$decodeReportedStatus((_response$status = response.status) === null || _response$status === void 0 ? void 0 : _response$status.statsig) ?? $c7cdec57095eaea9$var$statusFromSection(statsig),
        ffp: $c7cdec57095eaea9$var$decodeReportedStatus((_response$status2 = response.status) === null || _response$status2 === void 0 ? void 0 : _response$status2.ffp) ?? $c7cdec57095eaea9$var$statusFromSection(ffp)
    };
    return {
        status: status,
        statsig: $c7cdec57095eaea9$var$whenOk(statsig, status.statsig),
        ffp: $c7cdec57095eaea9$var$whenOk(ffp, status.ffp)
    };
};

});


parcelRegister("4QrHS", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc2e67596aced1be$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $27NB5 = parcelRequire("27NB5");

var $2YDEV = parcelRequire("2YDEV");

var $gtuxY = parcelRequire("gtuxY");

var $lbcbB = parcelRequire("lbcbB");

var $kFxFJ = parcelRequire("kFxFJ");

var $cuXm7 = parcelRequire("cuXm7");

var $asVR1 = parcelRequire("asVR1");
const $dc2e67596aced1be$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $dc2e67596aced1be$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $dc2e67596aced1be$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $dc2e67596aced1be$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $dc2e67596aced1be$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $dc2e67596aced1be$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $dc2e67596aced1be$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $dc2e67596aced1be$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $dc2e67596aced1be$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $dc2e67596aced1be$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $dc2e67596aced1be$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    /**
   * Fetches the Statsig values for a user from `/api/v2/frontend/experimentValues`. Use
   * {@link Fetcher.fetchFlagValues}, which calls this only without `includeFfpFlags`.
   */ static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    /**
   * Fetches the combined Statsig and Feature Flag Platform bootstrap values for a user.
   *
   * Rejects with {@link EvalFlagsUnavailableError} when no provider is `OK` and one is `UNAVAILABLE`,
   * so that a response with no values fails like any other failed fetch.
   */ static async fetchEvalFlags(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        let response;
        try {
            response = await this.fetchRequest('/api/v1/evalFlags', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve flag values');
        }
        const status = (0, $kFxFJ.getEvalFlagsStatus)(response);
        if ((0, $cuXm7.hasNoUsableProvider)(status)) throw new (0, $asVR1.EvalFlagsUnavailableError)(status);
        return response;
    }
    /**
   * Fetches the bootstrap values for a user. With `includeFfpFlags`, they come from
   * {@link Fetcher.fetchEvalFlags}; otherwise only Statsig values are fetched, with
   * {@link Fetcher.fetchExperimentValues}, and are returned as a response in which FFP is `DISABLED`.
   */ static async fetchFlagValues(fetcherOptions, identifiers, customAttributes) {
        if (fetcherOptions.includeFfpFlags) return this.fetchEvalFlags(fetcherOptions, identifiers, customAttributes);
        return this.fetchExperimentValues(fetcherOptions, identifiers, customAttributes).then((0, $lbcbB.fromExperimentValuesResponse));
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $gtuxY.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $gtuxY.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $dc2e67596aced1be$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $27NB5.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $27NB5.FeatureGateEnvironment).Production:
                return $dc2e67596aced1be$export$18c93900db9358a4;
            case (0, $27NB5.FeatureGateEnvironment).Staging:
                return $dc2e67596aced1be$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $27NB5.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $27NB5.FeatureGateEnvironment).Development:
                return $dc2e67596aced1be$export$f058dbf75c3bc647;
            case (0, $27NB5.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $dc2e67596aced1be$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $dc2e67596aced1be$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $dc2e67596aced1be$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $dc2e67596aced1be$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $2YDEV.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $dc2e67596aced1be$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$dc2e67596aced1be$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$dc2e67596aced1be$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("27NB5", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $da0d375d8e3f9d16$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $da0d375d8e3f9d16$export$c42b7bbc5e7ba555);
const $da0d375d8e3f9d16$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $da0d375d8e3f9d16$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $da0d375d8e3f9d16$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("2YDEV", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $875e6544ca667707$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $875e6544ca667707$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("gtuxY", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $8495082b91d68f7d$export$286baf652d0b1206);
class $8495082b91d68f7d$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("lbcbB", function(module, exports) {
$parcel$export(module.exports, "fromExperimentValuesResponse", () => $2ed6d35bb498de69$export$69f3c94f0aa979d5);
const $2ed6d35bb498de69$export$69f3c94f0aa979d5 = (response)=>({
        statsig: response,
        status: {
            statsig: 'OK',
            ffp: 'DISABLED'
        }
    });

});

parcelRegister("kFxFJ", function(module, exports) {
$parcel$export(module.exports, "getEvalFlagsStatus", () => $b973a1fe93a40af1$export$874ce68018557ae1);

var $2pZxH = parcelRequire("2pZxH");
const $b973a1fe93a40af1$export$874ce68018557ae1 = (response)=>(0, $2pZxH.decodeEvalFlagsResponse)(response).status;

});

parcelRegister("cuXm7", function(module, exports) {
$parcel$export(module.exports, "hasNoUsableProvider", () => $e4cae04dbd3ff211$export$1a81cdd8dc55ce47);
const $e4cae04dbd3ff211$export$1a81cdd8dc55ce47 = (status)=>status.statsig !== 'OK' && status.ffp !== 'OK' && (status.statsig === 'UNAVAILABLE' || status.ffp === 'UNAVAILABLE');

});

parcelRegister("asVR1", function(module, exports) {
$parcel$export(module.exports, "EvalFlagsUnavailableError", () => $e8dd8fe493ed5fb8$export$49ae4f7192ab8153);
class $e8dd8fe493ed5fb8$export$49ae4f7192ab8153 extends Error {
    constructor(status){
        super(`Feature flag values are unavailable (Statsig: ${status.statsig}, FFP: ${status.ffp})`);
        this.status = status;
    }
}

});


parcelRegister("hjviN", function(module, exports) {
$parcel$export(module.exports, "FfpClientAdapter", () => $4d80d991565e9ddf$export$d0440eddc68143b1);

var $hCcXA = parcelRequire("hCcXA");

var $9wvvs = parcelRequire("9wvvs");

var $27NB5 = parcelRequire("27NB5");
/**
 * Returned by a typed read only when the Feature Flag Platform client falls back to the safe
 * default (flag absent, type mismatch, unusable value, or `useCodeDefault`). Identity comparison
 * against it lets the wrapper apply the caller's own default instead.
 */ const $4d80d991565e9ddf$var$NOT_SERVED = Symbol('ffp-not-served');
const $4d80d991565e9ddf$var$toEnvironmentType = (environment)=>{
    switch(environment){
        case (0, $27NB5.FeatureGateEnvironment).Development:
            return 'dev';
        case (0, $27NB5.FeatureGateEnvironment).Staging:
            return 'staging';
        default:
            return 'prod';
    }
};
const $4d80d991565e9ddf$var$isPlainObject = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
/**
 * What the client serves for a user FFP serves nothing to: every read returns its default. The
 * payload's request context is the user, so exposures are attributed to them.
 */ const $4d80d991565e9ddf$var$emptyPayload = (user)=>()=>({
            flags: {},
            requestContext: user
        });
/** Only forward the members the FFP client consumes; the service payload carries extra metadata. */ const $4d80d991565e9ddf$var$toBulkEvaluationPayload = (values)=>({
        // Forward the schema version so the FFP client rejects a wire format it does not support.
        ...values.vs !== undefined && {
            vs: values.vs
        },
        flags: values.flags,
        requestContext: values.requestContext,
        ...values.clientVersion !== undefined && {
            clientVersion: values.clientVersion
        }
    });
const $4d80d991565e9ddf$var$toFlagClientOptions = (options)=>{
    // Match the Statsig client: no telemetry egress in FedRAMP or when logging is disabled.
    const loggingDisabled = options.perimeter === (0, $27NB5.PerimeterType).FEDRAMP_MODERATE || options.disableAllLogging === true;
    return {
        targetApp: options.targetApp,
        environmentType: $4d80d991565e9ddf$var$toEnvironmentType(options.environment),
        ...loggingDisabled && {
            exposureLogging: {
                enabled: false
            }
        }
    };
};
const $4d80d991565e9ddf$var$EMPTY_CONFIG = {
    value: {},
    ruleId: ''
};
class $4d80d991565e9ddf$export$d0440eddc68143b1 {
    /**
   * Applies the FFP values for a user. Absent values mean FFP serves nothing for this user (for
   * example the provider is disabled or unavailable), so no key is routed here until the next values
   * arrive. The client is not created until the first values arrive.
   */ apply(options, values, identifiers, customAttributes) {
        // Never keep serving the previous user's values, whatever happens below.
        this.flags = undefined;
        const user = (0, $9wvvs.toFlagUser)(identifiers, customAttributes);
        try {
            if (values && this.applyPayload(options, ()=>$4d80d991565e9ddf$var$toBulkEvaluationPayload(values), user)) {
                this.flags = values.flags;
                return;
            }
            // Callers may read the client directly (see `getClient`), and a failed or skipped replacement
            // would leave it serving the previous user's payload, so give it an empty one for this user.
            if (this.initialized) {
                var _this$client;
                (_this$client = this.client) === null || _this$client === void 0 || _this$client.replace($4d80d991565e9ddf$var$emptyPayload(user), user);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Failed to apply Feature Flag Platform values', error);
        }
    }
    /** Gives the client a payload and user, returning whether it accepted them. */ applyPayload(options, provider, user) {
        const client = this.getClient(options);
        // `initialize` can be retried after a failure; once it succeeds, later users use `replace`.
        if (this.initialized) return client.replace(provider, user).replaced;
        this.initialized = client.initialize(provider, user).initialized;
        return this.initialized;
    }
    /**
   * The FFP client, created on first use with the given options and the same instance afterwards.
   * Until values are applied (and while FFP serves nothing for the user), its reads return the safe
   * default they are given.
   */ getClient(options) {
        this.client ?? (this.client = new (0, $hCcXA.FlagClient)($4d80d991565e9ddf$var$toFlagClientOptions(options)));
        return this.client;
    }
    /** Whether the latest FFP payload contains the given flag key, so FFP answers for it. */ has(flagKey) {
        return this.getFlag(flagKey) !== undefined;
    }
    /**
   * Gate read. FFP's default is `false`, which covers a key it does not serve and a flag that is not
   * a boolean (FFP falls back to the default for a type mismatch).
   */ checkGate(gateName, fireExposure) {
        if (!this.client || !this.has(gateName)) return false;
        return this.client.getBooleanValue(gateName, false, $4d80d991565e9ddf$var$toEvaluationOptions(fireExposure));
    }
    /**
   * Config (experiment or dynamic config) read.
   *
   * JSON object flags are Statsig experiments and are returned as their parameters. Every other
   * value is a flattened Statsig dynamic config, so it is returned as `{ value }`. When FFP does not
   * serve the key or falls back to a code default, the config is empty so the caller's default
   * applies.
   */ getConfig(configName, fireExposure) {
        const flag = this.getFlag(configName);
        if (!this.client || !flag) return $4d80d991565e9ddf$var$EMPTY_CONFIG;
        const { value: value, metadata: metadata } = this.readDetails(this.client, configName, flag, $4d80d991565e9ddf$var$toEvaluationOptions(fireExposure));
        const ruleId = metadata.ruleId ?? '';
        if (value === $4d80d991565e9ddf$var$NOT_SERVED) return {
            value: {},
            ruleId: ruleId
        };
        return {
            value: $4d80d991565e9ddf$var$isPlainObject(value) ? value : {
                value: value
            },
            ruleId: ruleId
        };
    }
    /** Logs an exposure for a gate served by FFP. */ logGateExposure(gateName) {
        this.checkGate(gateName, true);
    }
    /** Logs an exposure for a config served by FFP. */ logConfigExposure(configName) {
        this.getConfig(configName, true);
    }
    getFlag(flagKey) {
        if (!this.flags || !Object.prototype.hasOwnProperty.call(this.flags, flagKey)) return undefined;
        return this.flags[flagKey];
    }
    readDetails(client, flagKey, flag, options) {
        // The sentinel is returned by identity on every fallback; the casts only satisfy the typed
        // read signatures.
        switch(flag.returnType){
            case 'BOOLEAN':
                return client.getBooleanDetails(flagKey, $4d80d991565e9ddf$var$NOT_SERVED, options);
            case 'STRING':
                return client.getStringDetails(flagKey, $4d80d991565e9ddf$var$NOT_SERVED, options);
            case 'NUMBER':
                return client.getNumberDetails(flagKey, $4d80d991565e9ddf$var$NOT_SERVED, options);
            default:
                return client.getObjectDetails(flagKey, $4d80d991565e9ddf$var$NOT_SERVED, options);
        }
    }
    constructor(){
        this.initialized = false;
    }
}
const $4d80d991565e9ddf$var$toEvaluationOptions = (fireExposure)=>({
        disableExposureLogging: !fireExposure
    });

});
parcelRegister("hCcXA", function(module, exports) {
$parcel$export(module.exports, "FlagClient", () => $4bb959b41fedeea0$export$603f1f22d15d0fb5);

var $bFPpQ = parcelRequire("bFPpQ");

var $3Ex9y = parcelRequire("3Ex9y");

var $9vNFv = parcelRequire("9vNFv");

var $2SNfs = parcelRequire("2SNfs");

var $eBXa8 = parcelRequire("eBXa8");

var $kRIfR = parcelRequire("kRIfR");

var $8k6Fj = parcelRequire("8k6Fj");

var $k2ZL5 = parcelRequire("k2ZL5");

var $48Cjc = parcelRequire("48Cjc");

var $6PlIB = parcelRequire("6PlIB");

var $dltAh = parcelRequire("dltAh");

var $aQhe8 = parcelRequire("aQhe8");
const $4bb959b41fedeea0$var$ACQUISITION_FAILURE_TIPS = {
    provider_threw: 'Check the payload provider for thrown errors and confirm it synchronously returns a BulkEvaluationPayload.',
    provider_returned_no_payload: 'Confirm the payload provider returns a BulkEvaluationPayload value instead of null or undefined.',
    invalid_schema_version: 'Supply a payload whose vs schema version is "1", or omit vs.',
    invalid_payload_shape: 'Validate the provider result against the BulkEvaluationPayload shape before passing the provider to the client.',
    payload_capture_failed: 'Ensure the payload only contains cloneable data so the SDK can capture an immutable snapshot.'
};
const $4bb959b41fedeea0$var$INITIALIZATION_FAILURE_TIPS = {
    ...$4bb959b41fedeea0$var$ACQUISITION_FAILURE_TIPS,
    already_initialized: 'Call replace() to serve a different payload or user from an initialized FlagClient.'
};
const $4bb959b41fedeea0$var$REPLACEMENT_FAILURE_TIPS = {
    ...$4bb959b41fedeea0$var$ACQUISITION_FAILURE_TIPS,
    not_initialized: 'Call initialize() successfully before calling replace().'
};
const $4bb959b41fedeea0$var$EXPOSURE_OPTION_TIP = 'See ExposureLoggingOptions: enabled is a boolean, endpoint an absolute HTTP(S) URL, batchSize a positive integer, and flushIntervalMs a positive finite number.';
const $4bb959b41fedeea0$var$USER_NORMALIZATION_TIP = 'Pass identifier values as strings and attribute values as strings, booleans, or finite numbers.';
class $4bb959b41fedeea0$export$603f1f22d15d0fb5 {
    /**
   * Create an uninitialized client for one target app and environment.
   *
   * Copies the option values without validating them and never throws. Unsupported exposure
   * logging options are ignored with one warning each, naming the option but never its value.
   */ constructor(options){
        this.initialized = null;
        /**
   * The normalized user from the most recent initialization attempt that did not fail with
   * `already_initialized`, or from the most recent successful replacement after it. Set even when
   * that initialization attempt fails, so exposure telemetry can attribute uninitialized reads.
   * `EMPTY_USER` before any such attempt, so reads need only check `initialized`.
   */ this.currentUser = (0, $aQhe8.EMPTY_USER);
        /**
   * Each details read's exposure inputs, keyed by the returned metadata object, so a manual exposure
   * reproduces its read's attribution. Shallow copies of details share the metadata object.
   */ this.exposureContexts = new WeakMap();
        /**
   * The identifier part of the last deduplication identity and the request context or user it was
   * built from. Both are replaced, never mutated, on `initialize` and `replace`.
   */ this.cachedIdentifiersKey = null;
        const captured = $4bb959b41fedeea0$var$captureOptions(options);
        this.retained = {
            options: captured,
            lastInitializeFailure: null,
            rejectedSchemaVersion: null
        };
        this.exposureIdentity = (0, $3Ex9y.resolveExposureIdentity)(captured);
        const exposureLogging = (0, $8k6Fj.resolveExposureLogging)(captured.exposureLogging, {
            hasWindow: typeof window !== 'undefined',
            origin: $4bb959b41fedeea0$var$windowOrigin()
        });
        for (const option of exposureLogging.unsupported)// eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client ignored an unsupported exposure logging option', {
            option: option,
            tip: $4bb959b41fedeea0$var$EXPOSURE_OPTION_TIP
        });
        let clock = null;
        let sink = (0, $k2ZL5.NOOP_EXPOSURE_SINK);
        if (exposureLogging.enabled) try {
            clock = (0, $9vNFv.createExposureClock)();
            sink = this.openSink(exposureLogging.delivery);
        } catch  {
            // Construction never throws, so a host that cannot run exposure delivery logs nothing.
            clock = null;
            sink = (0, $k2ZL5.NOOP_EXPOSURE_SINK);
        }
        this.exposureClock = clock;
        this.exposureSink = sink;
    }
    /**
   * The sink for an enabled client.
   *
   * The delivery subsystem is loaded on demand, so it is normally still arriving while the first
   * flags are read. Until it arrives those exposures are buffered and then replayed into it, so a
   * read on the critical path logs the same exposure an eagerly loaded subsystem would have logged.
   * A subsystem that fails to load leaves the client logging nothing, as a host that cannot run
   * delivery does.
   */ openSink(options) {
        const delivery = (0, $eBXa8.loadExposureDelivery)();
        if (!$4bb959b41fedeea0$var$isPending(delivery)) return (0, $k2ZL5.deliveringSink)(delivery.createExposureLogger(options, delivery.createExposureEnvironment()), delivery);
        const buffer = new (0, $k2ZL5.BufferingExposureSink)();
        // These callbacks run in a later microtask than the constructor, so the assignment below never
        // races the one the constructor makes from this method's return value.
        delivery.then((loaded)=>{
            let sink;
            try {
                sink = (0, $k2ZL5.deliveringSink)(loaded.createExposureLogger(options, loaded.createExposureEnvironment()), loaded);
            } catch  {
                this.exposureSink = (0, $k2ZL5.NOOP_EXPOSURE_SINK);
                return;
            }
            buffer.replayInto(sink);
            this.exposureSink = sink;
        }, ()=>{
            this.exposureSink = (0, $k2ZL5.NOOP_EXPOSURE_SINK);
        });
        return buffer;
    }
    /**
   * Initialize the client once from a synchronous payload provider.
   *
   * Checks run in order: `already_initialized`, user normalization, then payload acquisition. Never
   * throws.
   */ initialize(provider, user) {
        if (this.initialized !== null) return this.warnInitializationFailure({
            initialized: false,
            reason: 'already_initialized'
        });
        this.currentUser = this.normalizeAndWarn(user, 'initialize');
        const acquisition = $4bb959b41fedeea0$var$acquirePayload(provider);
        if (!acquisition.acquired) {
            this.retained.lastInitializeFailure = acquisition.reason;
            this.retained.rejectedSchemaVersion = acquisition.rejectedSchemaVersion ?? null;
            return this.warnInitializationFailure({
                initialized: false,
                reason: acquisition.reason,
                ...acquisition.error !== undefined ? {
                    error: acquisition.error
                } : {}
            });
        }
        this.initialized = {
            payload: acquisition.payload
        };
        this.retained.lastInitializeFailure = null;
        this.retained.rejectedSchemaVersion = null;
        return {
            initialized: true
        };
    }
    /**
   * Replace the payload and user of an initialized client together.
   *
   * Fails with `not_initialized`, without invoking the provider or normalizing the user, before a
   * successful initialization. Any other failure keeps the previous payload and user. Never throws.
   */ replace(provider, user) {
        if (this.initialized === null) return this.warnReplacementFailure({
            replaced: false,
            reason: 'not_initialized'
        });
        const replacementUser = this.normalizeAndWarn(user, 'replace');
        const acquisition = $4bb959b41fedeea0$var$acquirePayload(provider);
        if (!acquisition.acquired) return this.warnReplacementFailure({
            replaced: false,
            reason: acquisition.reason,
            ...acquisition.error !== undefined ? {
                error: acquisition.error
            } : {}
        });
        this.initialized = {
            payload: acquisition.payload
        };
        this.currentUser = replacementUser;
        this.exposureSink.endDeduplicationWindows();
        return {
            replaced: true
        };
    }
    getBooleanValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateBooleanFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getStringValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateStringFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getNumberValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateNumberFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getObjectValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateObjectFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getBooleanDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateBooleanFlag), flagKey, safeDefaultValue, options, true);
    }
    getStringDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateStringFlag), flagKey, safeDefaultValue, options, true);
    }
    getNumberDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateNumberFlag), flagKey, safeDefaultValue, options, true);
    }
    getObjectDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $bFPpQ.evaluateObjectFlag), flagKey, safeDefaultValue, options, true);
    }
    /**
   * Log one manual exposure for details obtained from this client, typically after a read with
   * `disableExposureLogging`. Details this client returned reproduce the exposure their read would
   * have produced; for any other details, attribution comes from the client's current state. Does
   * nothing when exposure logging is disabled and never throws.
   */ logExposure(details) {
        if (this.exposureClock === null) return;
        try {
            const metadata = details === null || details === void 0 ? void 0 : details.metadata;
            // Caller-built metadata without these would queue a record with no flag key or reason.
            if (typeof metadata !== 'object' || metadata === null) return;
            const { flagKey: flagKey, matchReason: matchReason } = metadata;
            if (!(0, $dltAh.isString)(flagKey) || !(0, $dltAh.isString)(matchReason)) return;
            const context = this.exposureContexts.get(metadata) ?? this.exposureContext(this.initialized === null ? null : (0, $bFPpQ.ownFlagResult)(this.initialized.payload.flags, flagKey) ?? null);
            this.recordExposure(details, context, true);
        } catch  {
        // Exposure telemetry must never affect the caller.
        }
    }
    /** The one read path: evaluate, record at most one automatic exposure, return the details. */ read(evaluate, flagKey, safeDefaultValue, options, // Only returned details can reach `logExposure`, so value reads keep no context.
    retainContext) {
        const outcome = evaluate(this.evaluationState(), flagKey, safeDefaultValue);
        if (this.exposureClock !== null) try {
            const record = (options === null || options === void 0 ? void 0 : options.disableExposureLogging) !== true;
            // A suppressed value read neither records nor retains, so it builds no context.
            if (record || retainContext) {
                const context = this.exposureContext(outcome.flagResult);
                if (retainContext) this.exposureContexts.set(outcome.details.metadata, context);
                if (record) this.recordExposure(outcome.details, context, false);
            }
        } catch  {
        // Exposure telemetry must never change or fail a read.
        }
        return outcome.details;
    }
    /** Queue one exposure unless deduplicated. The record is built only when it is queued. */ recordExposure(details, context, manual) {
        const clock = this.exposureClock;
        if (clock === null) return;
        const { flagKey: flagKey, variationId: variationId, ruleId: ruleId, matchReason: matchReason } = details.metadata;
        const identityKey = (0, $2SNfs.exposureIdentityKey)({
            flagKey: flagKey,
            variationId: variationId,
            ruleId: ruleId,
            matchReason: matchReason,
            identifiersKey: this.identifiersKey(context)
        });
        this.exposureSink.log(identityKey, {
            ...context,
            details: details,
            identity: this.exposureIdentity,
            manual: manual,
            epochMillis: clock.now()
        });
    }
    /** The identifier part of the deduplication identity, recomputed only when its source changes. */ identifiersKey(context) {
        var _cached;
        const source = context.requestContext ?? context.user;
        let cached = this.cachedIdentifiersKey;
        if (((_cached = cached) === null || _cached === void 0 ? void 0 : _cached.source) !== source) {
            cached = {
                source: source,
                key: (0, $2SNfs.exposureIdentifiersKey)((0, $kRIfR.attributionIdentifiers)(context))
            };
            this.cachedIdentifiersKey = cached;
        }
        return cached.key;
    }
    /** The exposure inputs current state supplies for a read of a flag with this payload result. */ exposureContext(flagResult) {
        var _this$initialized;
        const payload = (_this$initialized = this.initialized) === null || _this$initialized === void 0 ? void 0 : _this$initialized.payload;
        return {
            flagResult: flagResult,
            user: this.currentUser,
            initialization: this.initializationStatus(),
            ...payload !== undefined ? {
                requestContext: payload.requestContext
            } : {},
            ...(payload === null || payload === void 0 ? void 0 : payload.clientVersion) !== undefined ? {
                clientVersion: payload.clientVersion
            } : {}
        };
    }
    /**
   * Initialization as exposures see it, from FFP-141's retained most recent failure reason and
   * rejected schema version.
   */ initializationStatus() {
        if (this.initialized !== null) return 0, $3Ex9y.INITIALIZED;
        const { lastInitializeFailure: lastInitializeFailure, rejectedSchemaVersion: rejectedSchemaVersion } = this.retained;
        return {
            state: 'uninitialized',
            lastFailureReason: lastInitializeFailure,
            ...rejectedSchemaVersion === null ? {} : {
                rejectedSchemaVersion: rejectedSchemaVersion
            }
        };
    }
    /** Read state, or `null` while uninitialized. */ evaluationState() {
        if (this.initialized === null) return null;
        return {
            payload: this.initialized.payload,
            user: this.currentUser
        };
    }
    /** Normalize a user and emit at most one warning naming discarded keys, never values. */ normalizeAndWarn(user, operation) {
        const normalization = (0, $aQhe8.normalizeUser)(user);
        if ((0, $aQhe8.hasNormalizationFindings)(normalization)) // eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client user normalization dropped invalid entries', {
            operation: operation,
            droppedEntries: normalization.droppedEntries,
            emptyMembers: normalization.emptyMembers,
            tip: $4bb959b41fedeea0$var$USER_NORMALIZATION_TIP
        });
        return normalization.user;
    }
    warnInitializationFailure(result) {
        // eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client initialization failed', {
            reason: result.reason,
            tip: $4bb959b41fedeea0$var$INITIALIZATION_FAILURE_TIPS[result.reason],
            ...result.error !== undefined ? {
                error: result.error
            } : {}
        });
        return result;
    }
    warnReplacementFailure(result) {
        // eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client replacement failed', {
            reason: result.reason,
            tip: $4bb959b41fedeea0$var$REPLACEMENT_FAILURE_TIPS[result.reason],
            ...result.error !== undefined ? {
                error: result.error
            } : {}
        });
        return result;
    }
}
/**
 * Invoke, check, validate, and capture a provider payload. Shared by initialize and replace.
 *
 * The schema version is resolved before the rest of the shape, so a payload of another schema
 * version is reported as `invalid_schema_version` rather than `invalid_payload_shape`. Each version
 * is then validated against its own wire format.
 */ function $4bb959b41fedeea0$var$acquirePayload(provider) {
    let candidate;
    try {
        candidate = provider();
    } catch (error) {
        return {
            acquired: false,
            reason: 'provider_threw',
            error: error
        };
    }
    if (candidate == null) return {
        acquired: false,
        reason: 'provider_returned_no_payload'
    };
    try {
        return $4bb959b41fedeea0$var$inspectPayload(candidate);
    } catch (error) {
        // A payload that throws while it is read, such as a revoked proxy or a throwing getter, cannot
        // be validated; reporting it keeps initialize and replace from throwing.
        return {
            acquired: false,
            reason: 'invalid_payload_shape',
            error: error
        };
    }
}
/** Resolve the schema version, then validate and capture the payload against that version. */ function $4bb959b41fedeea0$var$inspectPayload(candidate) {
    if (!(0, $6PlIB.isRecord)(candidate)) return {
        acquired: false,
        reason: 'invalid_payload_shape'
    };
    const schemaVersion = (0, $6PlIB.payloadSchemaVersion)(candidate);
    if (schemaVersion === null) return {
        acquired: false,
        reason: 'invalid_schema_version',
        ...(0, $dltAh.isString)(candidate.vs) ? {
            rejectedSchemaVersion: candidate.vs
        } : {}
    };
    // A later schema version adds a case that validates its wire format and converts it into the
    // internal model that reads and exposure telemetry use; version 1 is currently that model.
    switch(schemaVersion){
        case '1':
            return $4bb959b41fedeea0$var$acquireVersion1Payload(candidate);
    }
}
function $4bb959b41fedeea0$var$acquireVersion1Payload(candidate) {
    if (!(0, $6PlIB.isValidBulkEvaluationPayloadV1)(candidate)) return {
        acquired: false,
        reason: 'invalid_payload_shape'
    };
    const payload = (0, $48Cjc.capturePayload)(candidate, $4bb959b41fedeea0$var$withRequestContextAttributes);
    if (payload === null) return {
        acquired: false,
        reason: 'payload_capture_failed'
    };
    // Capture reads the provider's object again, so a getter or proxy can yield a different value than
    // the one validated above. Validate the frozen snapshot that reads will use as well. The empty
    // `attributes` is supplied on the private copy before this check, so a valid snapshot always
    // carries both request context maps. The original is still validated first because the JSON
    // capture fallback drops members such as functions, and the failure reasons must reflect what the
    // provider returned.
    if (!(0, $6PlIB.isValidBulkEvaluationPayloadV1)(payload)) return {
        acquired: false,
        reason: 'invalid_payload_shape'
    };
    return {
        acquired: true,
        payload: payload
    };
}
/**
 * Supply an empty `attributes` to a `requestContext` that omits it, so the captured payload always
 * retains both maps.
 *
 * This runs on the private copy made during capture, which has not been validated yet; a copy that no
 * longer has an object `requestContext` is returned unchanged and fails the snapshot validation.
 */ function $4bb959b41fedeea0$var$withRequestContextAttributes(copy) {
    const requestContext = copy.requestContext;
    if (!(0, $6PlIB.isRecord)(requestContext) || requestContext.attributes !== undefined) // TypeScript does not narrow the nested optional member; the snapshot validation establishes it.
    return copy;
    return {
        ...copy,
        requestContext: {
            ...requestContext,
            attributes: {}
        }
    };
}
/**
 * Copy the construction option values so later mutation of the caller's object has no effect.
 *
 * The values are deliberately not validated at runtime. Reads go through optional chaining, so an
 * untyped caller that omits the options does not throw.
 */ function $4bb959b41fedeea0$var$captureOptions(options) {
    const source = options;
    const serviceVersion = source === null || source === void 0 ? void 0 : source.serviceVersion;
    const exposureLogging = source === null || source === void 0 ? void 0 : source.exposureLogging;
    return Object.freeze({
        targetApp: source === null || source === void 0 ? void 0 : source.targetApp,
        environmentType: source === null || source === void 0 ? void 0 : source.environmentType,
        ...serviceVersion !== undefined ? {
            serviceVersion: serviceVersion
        } : {},
        ...exposureLogging !== undefined ? {
            exposureLogging: $4bb959b41fedeea0$var$copyExposureLogging(exposureLogging)
        } : {}
    });
}
/** Shallow-copy exposure logging options when they are an object; other values are kept for warnings. */ function $4bb959b41fedeea0$var$copyExposureLogging(value) {
    try {
        return typeof value === 'object' && value !== null && !Array.isArray(value) ? Object.freeze({
            ...value
        }) : value;
    } catch  {
        // A throwing getter or a revoked proxy is reported as an unsupported `exposureLogging`.
        return null;
    }
}
/** Whether the exposure delivery subsystem is still loading. */ function $4bb959b41fedeea0$var$isPending(delivery) {
    return typeof delivery.then === 'function';
}
/** The global `window` location origin, or `null` when it is absent, unreadable, or opaque. */ function $4bb959b41fedeea0$var$windowOrigin() {
    if (typeof window === 'undefined') return null;
    try {
        var _location;
        const origin = (_location = window.location) === null || _location === void 0 ? void 0 : _location.origin;
        return typeof origin === 'string' && origin !== 'null' ? origin : null;
    } catch  {
        return null;
    }
}

});
parcelRegister("bFPpQ", function(module, exports) {
$parcel$export(module.exports, "CLIENT_FALLBACK_REASONS", () => $dad0bdb6a4451eac$export$3fdc239d777dd274);
$parcel$export(module.exports, "evaluateBooleanFlag", () => $dad0bdb6a4451eac$export$7f8a3203042948c);
$parcel$export(module.exports, "evaluateStringFlag", () => $dad0bdb6a4451eac$export$9884a797df8b2531);
$parcel$export(module.exports, "evaluateNumberFlag", () => $dad0bdb6a4451eac$export$c410031c8f6bac62);
$parcel$export(module.exports, "evaluateObjectFlag", () => $dad0bdb6a4451eac$export$13075d8205b2cfdb);
$parcel$export(module.exports, "ownFlagResult", () => $dad0bdb6a4451eac$export$5ad4da1a5d98a00d);

var $dltAh = parcelRequire("dltAh");
const $dad0bdb6a4451eac$export$3fdc239d777dd274 = [
    'not_initialized',
    'flag_not_found',
    'type_mismatch'
];
const $dad0bdb6a4451eac$var$NO_SEGMENTS = Object.freeze([]);
function $dad0bdb6a4451eac$export$7f8a3203042948c(state, flagKey, safeDefaultValue) {
    return $dad0bdb6a4451eac$var$evaluateFlag(state, flagKey, 'BOOLEAN', safeDefaultValue, $dad0bdb6a4451eac$var$isBoolean);
}
function $dad0bdb6a4451eac$export$9884a797df8b2531(state, flagKey, safeDefaultValue) {
    return $dad0bdb6a4451eac$var$evaluateFlag(state, flagKey, 'STRING', safeDefaultValue, (0, $dltAh.isString));
}
function $dad0bdb6a4451eac$export$c410031c8f6bac62(state, flagKey, safeDefaultValue) {
    return $dad0bdb6a4451eac$var$evaluateFlag(state, flagKey, 'NUMBER', safeDefaultValue, $dad0bdb6a4451eac$var$isNumber);
}
function $dad0bdb6a4451eac$export$13075d8205b2cfdb(state, flagKey, safeDefaultValue) {
    return $dad0bdb6a4451eac$var$evaluateFlag(state, flagKey, 'JSON', safeDefaultValue, (value)=>$dad0bdb6a4451eac$var$isJsonContainer(value));
}
function $dad0bdb6a4451eac$export$5ad4da1a5d98a00d(flags, flagKey) {
    return (0, $dltAh.hasOwn)(flags, flagKey) ? flags[flagKey] : undefined;
}
function $dad0bdb6a4451eac$var$evaluateFlag(state, flagKey, expectedReturnType, safeDefaultValue, isExpectedValue) {
    if (state === null) return $dad0bdb6a4451eac$var$fallbackDetails(flagKey, safeDefaultValue, 'not_initialized');
    const flagResult = $dad0bdb6a4451eac$export$5ad4da1a5d98a00d(state.payload.flags, flagKey);
    if (flagResult === undefined) return $dad0bdb6a4451eac$var$fallbackDetails(flagKey, safeDefaultValue, 'flag_not_found');
    if (flagResult.returnType !== expectedReturnType) return $dad0bdb6a4451eac$var$fallbackDetails(flagKey, safeDefaultValue, 'type_mismatch', flagResult);
    if (flagResult.useCodeDefault) return {
        details: {
            value: safeDefaultValue,
            metadata: $dad0bdb6a4451eac$var$metadataFromResult(flagKey, state.user, flagResult)
        },
        flagResult: flagResult
    };
    if (!isExpectedValue(flagResult.value)) return $dad0bdb6a4451eac$var$fallbackDetails(flagKey, safeDefaultValue, 'type_mismatch', flagResult);
    return {
        details: {
            value: flagResult.value,
            metadata: $dad0bdb6a4451eac$var$metadataFromResult(flagKey, state.user, flagResult)
        },
        flagResult: flagResult
    };
}
function $dad0bdb6a4451eac$var$fallbackDetails(flagKey, value, matchReason, flagResult = null) {
    const metadata = {
        flagKey: flagKey,
        identifierType: null,
        identifierValue: null,
        matchReason: matchReason,
        variationId: null,
        ruleId: null,
        holdoutAllocation: null,
        segments: $dad0bdb6a4451eac$var$NO_SEGMENTS
    };
    return {
        details: {
            value: value,
            metadata: metadata
        },
        flagResult: flagResult
    };
}
/**
 * Build details metadata for a payload-backed result.
 *
 * `identifierValue` comes from the current user, never from the payload request context. The holdout
 * allocation and segment list are the captured, already-frozen values, so no per-read copy is
 * needed.
 */ function $dad0bdb6a4451eac$var$metadataFromResult(flagKey, user, result) {
    const identifierType = result.metadata.identifierType ?? null;
    return {
        flagKey: flagKey,
        identifierType: identifierType,
        identifierValue: identifierType === null ? null : user.identifiers[identifierType] ?? null,
        matchReason: result.metadata.matchReason,
        variationId: result.metadata.variationId ?? null,
        ruleId: result.metadata.ruleId ?? null,
        holdoutAllocation: result.metadata.holdoutAllocation ?? null,
        segments: result.metadata.segments ?? $dad0bdb6a4451eac$var$NO_SEGMENTS
    };
}
function $dad0bdb6a4451eac$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $dad0bdb6a4451eac$var$isNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
function $dad0bdb6a4451eac$var$isJsonContainer(value) {
    return typeof value === 'object' && value !== null;
}

});
parcelRegister("dltAh", function(module, exports) {
$parcel$export(module.exports, "isString", () => $e59e2f74f968de65$export$844ec244b1367d54);
$parcel$export(module.exports, "hasOwn", () => $e59e2f74f968de65$export$b5a638e9b3fff9f3);
/** Shared internal type guards. Not part of the public API. */ /** Whether a value is a string primitive. */ function $e59e2f74f968de65$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $e59e2f74f968de65$export$b5a638e9b3fff9f3(value, property) {
    return Object.prototype.hasOwnProperty.call(value, property);
}

});


parcelRegister("3Ex9y", function(module, exports) {
$parcel$export(module.exports, "resolveExposureIdentity", () => $12988ccca3c0df6f$export$489c90dada9f64a4);
$parcel$export(module.exports, "isNonBlankString", () => $12988ccca3c0df6f$export$eba10bf061757d82);
$parcel$export(module.exports, "isEnvironmentType", () => $12988ccca3c0df6f$export$ba2ce149416198d2);
$parcel$export(module.exports, "INITIALIZED", () => $12988ccca3c0df6f$export$1ed1792d90fa81b2);
$parcel$export(module.exports, "notInitializedMessage", () => $12988ccca3c0df6f$export$392eab774f060ef0);
/** Resource identity and not-initialized messages for exposures. Not part of the public API. */ 
var $bfdUu = parcelRequire("bfdUu");
/** The `deployment.environment_type` values exposures may report. */ const $12988ccca3c0df6f$var$ENVIRONMENT_TYPES = new Set(Object.keys({
    dev: true,
    local: true,
    staging: true,
    prod: true
}));
function $12988ccca3c0df6f$export$489c90dada9f64a4(options) {
    const targetApp = $12988ccca3c0df6f$export$eba10bf061757d82(options.targetApp) ? options.targetApp : null;
    const environmentType = $12988ccca3c0df6f$export$ba2ce149416198d2(options.environmentType) ? options.environmentType : undefined;
    const serviceVersion = $12988ccca3c0df6f$export$eba10bf061757d82(options.serviceVersion) ? options.serviceVersion : undefined;
    return Object.freeze({
        resource: Object.freeze({
            serviceName: targetApp ?? (0, $bfdUu.PACKAGE_NAME),
            ...environmentType === undefined ? {} : {
                environmentType: environmentType
            },
            ...serviceVersion === undefined ? {} : {
                serviceVersion: serviceVersion
            }
        }),
        flagSetId: targetApp
    });
}
const $12988ccca3c0df6f$export$1ed1792d90fa81b2 = Object.freeze({
    state: 'initialized'
});
const $12988ccca3c0df6f$export$5f2944b911ea68d7 = Object.freeze({
    state: 'uninitialized',
    lastFailureReason: null
});
/** Characters of a rejected schema version kept in a message before it is cut short with `...`. */ const $12988ccca3c0df6f$var$MESSAGE_SCHEMA_VERSION_LENGTH = 16;
function $12988ccca3c0df6f$export$392eab774f060ef0(status) {
    if (status.state === 'initialized') return undefined;
    const reason = status.lastFailureReason;
    const cause = reason === null ? 'no initialize attempt completed' : reason === 'invalid_schema_version' && status.rejectedSchemaVersion !== undefined ? `${reason} ${$12988ccca3c0df6f$var$quoteForMessage(status.rejectedSchemaVersion)}` : reason;
    return `FFP evaluation failed: not_initialized (${cause})`;
}
/**
 * The value as a JSON string, cut to the message length on a code point boundary and followed by
 * `...` outside the quotes when cut, so a cut value cannot be mistaken for one ending in `...`.
 */ function $12988ccca3c0df6f$var$quoteForMessage(value) {
    const codePoints = Array.from(value);
    return codePoints.length <= $12988ccca3c0df6f$var$MESSAGE_SCHEMA_VERSION_LENGTH ? JSON.stringify(value) : `${JSON.stringify(codePoints.slice(0, $12988ccca3c0df6f$var$MESSAGE_SCHEMA_VERSION_LENGTH).join(''))}...`;
}
function $12988ccca3c0df6f$export$eba10bf061757d82(value) {
    return typeof value === 'string' && value.trim() !== '';
}
function $12988ccca3c0df6f$export$ba2ce149416198d2(value) {
    return typeof value === 'string' && $12988ccca3c0df6f$var$ENVIRONMENT_TYPES.has(value);
}

});
parcelRegister("bfdUu", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $8a704efafdabb616$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_VERSION", () => $8a704efafdabb616$export$4a03ffab3315ee34);
/** Package identity used for telemetry. Not part of the public API. */ /**
 * The npm package name, injected at build time from `package.json`; also the exposure
 * Instrumentation Scope name.
 */ const $8a704efafdabb616$export$b8b9d90f9e5bd72b = undefined;
const $8a704efafdabb616$export$4a03ffab3315ee34 = undefined;

});


parcelRegister("9vNFv", function(module, exports) {
$parcel$export(module.exports, "createExposureClock", () => $deab1d4efc8529ef$export$d9328b5eabf56099);
/**
 * The clock a read stamps its exposure with. Not part of the public API.
 *
 * This is the one host capability the client needs before the delivery subsystem has loaded, so it
 * is deliberately separate from {@link ExposureEnvironment}: an exposure buffered on the critical
 * path must carry the time its read observed, while everything else the subsystem touches — storage,
 * `fetch`, timers, page lifecycle — is constructed with the subsystem itself.
 */ function $deab1d4efc8529ef$export$2e1d42eb26789c5() {
    return {
        now: ()=>Date.now()
    };
}
let $deab1d4efc8529ef$var$clockFactory = $deab1d4efc8529ef$export$2e1d42eb26789c5;
function $deab1d4efc8529ef$export$d9328b5eabf56099() {
    return $deab1d4efc8529ef$var$clockFactory();
}
function $deab1d4efc8529ef$export$3d826b815b6de58a(factory) {
    $deab1d4efc8529ef$var$clockFactory = factory ?? $deab1d4efc8529ef$export$2e1d42eb26789c5;
}

});

parcelRegister("2SNfs", function(module, exports) {
$parcel$export(module.exports, "exposureIdentifiersKey", () => $fe001cbba4e0f61b$export$f26b09663eabb5d3);
$parcel$export(module.exports, "exposureIdentityKey", () => $fe001cbba4e0f61b$export$ca3dbc1b93284651);
$parcel$export(module.exports, "ExposureDeduplicator", () => $fe001cbba4e0f61b$export$c54265a17eb3acde);
/** Exposure deduplication windows. Not part of the public API. */ /** How long an identity's queued exposure suppresses later ones with the same identity. */ const $fe001cbba4e0f61b$export$4f403c2a3da953f4 = 600000;
function $fe001cbba4e0f61b$export$f26b09663eabb5d3(identifiers) {
    return JSON.stringify([
        ...identifiers
    ].sort(([a], [b])=>a < b ? -1 : a > b ? 1 : 0));
}
function $fe001cbba4e0f61b$export$ca3dbc1b93284651(parts) {
    return JSON.stringify([
        parts.flagKey,
        parts.variationId,
        parts.ruleId,
        parts.matchReason,
        parts.identifiersKey
    ]);
}
class $fe001cbba4e0f61b$export$c54265a17eb3acde {
    /**
   * Whether an exposure produced at `nowMs` should be queued. Admitting it starts a new window, so
   * later exposures with the same identity are discarded until the window has passed. A clock that
   * moves back before the window's start also ends it, so suppression never outlasts the window.
   */ admit(identityKey, nowMs) {
        const start = this.windowStarts.get(identityKey);
        if (start !== undefined && nowMs >= start && nowMs - start <= $fe001cbba4e0f61b$export$4f403c2a3da953f4) return false;
        this.windowStarts.set(identityKey, nowMs);
        return true;
    }
    /** End the window `admit` just started, for an exposure that was not queued after all. */ forget(identityKey) {
        this.windowStarts.delete(identityKey);
    }
    /** End every window, as a successful replacement requires. */ clear() {
        this.windowStarts.clear();
    }
    constructor(){
        this.windowStarts = new Map();
    }
}

});

parcelRegister("eBXa8", function(module, exports) {
$parcel$export(module.exports, "loadExposureDelivery", () => $941e1f0f44850a7b$export$79a84ccee9aa0b0);
/**
 * How the client obtains the exposure delivery subsystem. Not part of the public API.
 *
 * Loading is on demand, so a client that logs nothing never downloads it and a client that does
 * keeps it off the critical path. The result is deliberately a value or a promise: tests, and any
 * host that has already supplied the subsystem, construct their logger synchronously.
 */ let $941e1f0f44850a7b$var$supplied;

function $941e1f0f44850a7b$export$79a84ccee9aa0b0() {
    // @ts-ignore TS2835: a relative import() must name its file under `nodenext`, which only the prebuilt tools' declaration build uses
    return $941e1f0f44850a7b$var$supplied ?? (parcelRequire("hQY1k"));
}
function $941e1f0f44850a7b$export$14fb2985a3fdae6f(delivery) {
    $941e1f0f44850a7b$var$supplied = delivery;
}

});
parcelRegister("hQY1k", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1LXHf").then(()=>parcelRequire('8k0rN'));

});
parcelRegister("9dnsd", function(module, exports) {
"use strict";

function $6b57856c7829fee2$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5WWY2")).resolve(id));
}
module.exports = $6b57856c7829fee2$var$load;

});
parcelRegister("5WWY2", function(module, exports) {
$parcel$export(module.exports, "register", () => $45501c3954b19655$export$6503ec6e8aabbaf, (v) => $45501c3954b19655$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $45501c3954b19655$export$f7ad0328861e2f03, (v) => $45501c3954b19655$export$f7ad0328861e2f03 = v);
var $45501c3954b19655$export$6503ec6e8aabbaf;
var $45501c3954b19655$export$f7ad0328861e2f03;
"use strict";
var $45501c3954b19655$var$mapping = new Map();
function $45501c3954b19655$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$45501c3954b19655$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $45501c3954b19655$var$resolve(id) {
    var resolved = $45501c3954b19655$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$45501c3954b19655$export$6503ec6e8aabbaf = $45501c3954b19655$var$register;
$45501c3954b19655$export$f7ad0328861e2f03 = $45501c3954b19655$var$resolve;

});




parcelRegister("kRIfR", function(module, exports) {
$parcel$export(module.exports, "attributionIdentifiers", () => $9fe4fd33e3b82b39$export$2e8d7a22d44742f1);
$parcel$export(module.exports, "isNonEmptyString", () => $9fe4fd33e3b82b39$export$e1fe2eb830813601);
/**
 * The attribution identifiers of an exposure, and the string check exposure mapping shares with
 * them. Separate from the mapper so a read can build its deduplication identity without loading the
 * delivery subsystem. Not part of the public API.
 */ function $9fe4fd33e3b82b39$export$2e8d7a22d44742f1(input) {
    return Object.entries((input.requestContext ?? input.user).identifiers).filter((entry)=>entry[0] !== '' && $9fe4fd33e3b82b39$export$e1fe2eb830813601(entry[1]));
}
function $9fe4fd33e3b82b39$export$e1fe2eb830813601(value) {
    return typeof value === 'string' && value !== '';
}

});

parcelRegister("8k6Fj", function(module, exports) {
$parcel$export(module.exports, "resolveExposureLogging", () => $5b429e1aabdfc4d1$export$294a4baefb36c792);
/** Exposure logging option resolution. Not part of the public API. */ const $5b429e1aabdfc4d1$export$a658c6a2a046acde = 'https://xp.atlassian.com/ft/v1/logs';
const $5b429e1aabdfc4d1$export$45b7810513497e4d = 100;
const $5b429e1aabdfc4d1$export$5f8135784e47aa61 = 10000;
function $5b429e1aabdfc4d1$export$294a4baefb36c792(raw, host) {
    const unsupported = [];
    let source = {};
    if (raw !== undefined) {
        if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) source = raw;
        else unsupported.push('exposureLogging');
    }
    const pick = (name, resolve, fallback)=>{
        const value = source[name];
        if (value === undefined) return fallback;
        const resolved = resolve(value);
        if (resolved !== undefined) return resolved;
        unsupported.push(name);
        return fallback;
    };
    const enabled = pick('enabled', $5b429e1aabdfc4d1$var$asBoolean, host.hasWindow);
    const delivery = enabled ? {
        endpoint: pick('endpoint', (value)=>$5b429e1aabdfc4d1$var$asEndpoint(value, host.origin), $5b429e1aabdfc4d1$export$a658c6a2a046acde),
        batchSize: pick('batchSize', $5b429e1aabdfc4d1$var$asPositiveInteger, $5b429e1aabdfc4d1$export$45b7810513497e4d),
        flushIntervalMs: pick('flushIntervalMs', $5b429e1aabdfc4d1$var$asPositiveFiniteNumber, $5b429e1aabdfc4d1$export$5f8135784e47aa61)
    } : {
        endpoint: $5b429e1aabdfc4d1$export$a658c6a2a046acde,
        batchSize: $5b429e1aabdfc4d1$export$45b7810513497e4d,
        flushIntervalMs: $5b429e1aabdfc4d1$export$5f8135784e47aa61
    };
    return {
        enabled: enabled,
        delivery: delivery,
        unsupported: unsupported
    };
}
function $5b429e1aabdfc4d1$var$asBoolean(value) {
    return typeof value === 'boolean' ? value : undefined;
}
function $5b429e1aabdfc4d1$var$asPositiveInteger(value) {
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
}
function $5b429e1aabdfc4d1$var$asPositiveFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : undefined;
}
/**
 * An absolute `http:` or `https:` URL, normalized by the URL parser, or a single-slash path resolved
 * against `origin`.
 *
 * Parsing without a base rejects relative references. A second `/` or `\` would make the path
 * protocol-relative and leave the page origin, so such paths are rejected. The parser also drops
 * tab and newline characters, so a path is rejected whenever it resolves to another origin.
 */ function $5b429e1aabdfc4d1$var$asEndpoint(value, origin) {
    if (typeof value !== 'string') return undefined;
    if (value.startsWith('/')) {
        if (origin === null || value.startsWith('//') || value.startsWith('/\\')) return undefined;
        const url = $5b429e1aabdfc4d1$var$asHttpUrl(value, origin);
        return url !== undefined && new URL(url).origin === origin ? url : undefined;
    }
    return $5b429e1aabdfc4d1$var$asHttpUrl(value);
}
function $5b429e1aabdfc4d1$var$asHttpUrl(value, base) {
    try {
        const url = base === undefined ? new URL(value) : new URL(value, base);
        // Browsers reject a request to a URL with credentials, so such an endpoint could never deliver.
        const supported = (url.protocol === 'http:' || url.protocol === 'https:') && url.username === '' && url.password === '';
        return supported ? url.href : undefined;
    } catch  {
        return undefined;
    }
}

});

parcelRegister("k2ZL5", function(module, exports) {
$parcel$export(module.exports, "NOOP_EXPOSURE_SINK", () => $d0b5e8c75431f863$export$7f6c0ea3aef07d74);
$parcel$export(module.exports, "deliveringSink", () => $d0b5e8c75431f863$export$a72499ffc9e61d61);
$parcel$export(module.exports, "BufferingExposureSink", () => $d0b5e8c75431f863$export$bb3771f2a716fdec);
/**
 * Where a read sends its exposure: straight into the delivery subsystem, or into a buffer until that
 * subsystem has loaded. Not part of the public API.
 *
 * A sink takes the mapping input rather than a finished record, because the code that maps a record
 * is part of the subsystem being loaded.
 */ const $d0b5e8c75431f863$export$390c0a0afaa9f5ae = 1000;
const $d0b5e8c75431f863$export$7f6c0ea3aef07d74 = Object.freeze({
    log: ()=>undefined,
    endDeduplicationWindows: ()=>undefined
});
function $d0b5e8c75431f863$export$a72499ffc9e61d61(logger, delivery) {
    return {
        log: (identityKey, input)=>{
            logger.log(identityKey, ()=>delivery.mapExposureRecord(input));
        },
        endDeduplicationWindows: ()=>{
            logger.endDeduplicationWindows();
        }
    };
}
class $d0b5e8c75431f863$export$bb3771f2a716fdec {
    log(identityKey, input) {
        this.operations.push({
            kind: 'log',
            identityKey: identityKey,
            input: input
        });
        this.held += 1;
        if (this.held > $d0b5e8c75431f863$export$390c0a0afaa9f5ae) {
            // The push above guarantees there is one to drop.
            this.operations.splice(this.operations.findIndex((operation)=>operation.kind === 'log'), 1);
            this.held -= 1;
        }
    }
    endDeduplicationWindows() {
        this.operations.push({
            kind: 'endDeduplicationWindows'
        });
    }
    /** Replay every held operation into `sink`, in the order the client performed them. */ replayInto(sink) {
        const operations = this.operations.splice(0, this.operations.length);
        this.held = 0;
        for (const operation of operations)if (operation.kind === 'log') sink.log(operation.identityKey, operation.input);
        else sink.endDeduplicationWindows();
    }
    constructor(){
        this.operations = [];
        this.held = 0;
    }
}

});

parcelRegister("48Cjc", function(module, exports) {
$parcel$export(module.exports, "capturePayload", () => $3cfba6ad8c661b30$export$37593618646e1eae);
/**
 * Capture a deeply frozen copy of a validated payload, or `null` when it cannot be copied.
 *
 * `prepare` receives the private copy before it is frozen, so derived members are computed from the
 * copy rather than from another read of the caller's object.
 */ function $3cfba6ad8c661b30$export$37593618646e1eae(payload, prepare) {
    const clonedPayload = $3cfba6ad8c661b30$var$clonePayload(payload);
    if (clonedPayload === null) return null;
    const prepared = prepare === undefined ? clonedPayload : prepare(clonedPayload);
    return $3cfba6ad8c661b30$var$deepFreeze(prepared);
}
function $3cfba6ad8c661b30$var$clonePayload(payload) {
    try {
        return structuredClone(payload);
    } catch  {
        try {
            return JSON.parse(JSON.stringify(payload));
        } catch  {
            return null;
        }
    }
}
function $3cfba6ad8c661b30$var$deepFreeze(value, seen = new WeakSet()) {
    if (!$3cfba6ad8c661b30$var$isObjectLike(value) || seen.has(value)) return value;
    seen.add(value);
    for (const propertyValue of Object.values(value))$3cfba6ad8c661b30$var$deepFreeze(propertyValue, seen);
    return Object.freeze(value);
}
function $3cfba6ad8c661b30$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}

});

parcelRegister("6PlIB", function(module, exports) {
$parcel$export(module.exports, "payloadSchemaVersion", () => $21db6d51eabfa889$export$240351e8c44bdbd4);
$parcel$export(module.exports, "isValidBulkEvaluationPayloadV1", () => $21db6d51eabfa889$export$4a1f079b0fbec351);
$parcel$export(module.exports, "isRecord", () => $21db6d51eabfa889$export$6ba840931da50680);

var $dltAh = parcelRequire("dltAh");
const $21db6d51eabfa889$var$FLAG_RETURN_TYPES = new Set([
    'BOOLEAN',
    'STRING',
    'NUMBER',
    'JSON'
]);
const $21db6d51eabfa889$var$SUPPORTED_SCHEMA_VERSIONS = new Set([
    '1'
]);
function $21db6d51eabfa889$export$240351e8c44bdbd4(payload) {
    if (payload.vs === undefined) return '1';
    return $21db6d51eabfa889$var$SUPPORTED_SCHEMA_VERSIONS.has(payload.vs) ? payload.vs : null;
}
function $21db6d51eabfa889$export$4a1f079b0fbec351(value) {
    if (!$21db6d51eabfa889$export$6ba840931da50680(value) || value.vs !== undefined && value.vs !== '1' || !$21db6d51eabfa889$export$6ba840931da50680(value.flags)) return false;
    if (!$21db6d51eabfa889$var$isValidRequestContext(value.requestContext)) return false;
    if (value.clientVersion !== undefined && !$21db6d51eabfa889$var$isValidClientVersion(value.clientVersion)) return false;
    return Object.values(value.flags).every($21db6d51eabfa889$var$isValidFlagResult);
}
/**
 * Validate a client version: a non-empty string `token` and an optional string `updatedAt`, which is
 * not parsed as a timestamp. Other members are tolerated.
 */ function $21db6d51eabfa889$var$isValidClientVersion(value) {
    return $21db6d51eabfa889$export$6ba840931da50680(value) && typeof value.token === 'string' && value.token.length > 0 && $21db6d51eabfa889$var$isOptionalString(value.updatedAt);
}
/**
 * Validate request-context identifiers and, when present, attributes without enforcing higher-level
 * semantics. An absent `attributes` is valid; an explicit `null` is not.
 */ function $21db6d51eabfa889$var$isValidRequestContext(value) {
    if (!$21db6d51eabfa889$export$6ba840931da50680(value) || !$21db6d51eabfa889$var$isStringRecord(value.identifiers)) return false;
    return value.attributes === undefined || $21db6d51eabfa889$var$isFlagContextValueRecord(value.attributes);
}
/** Validate one per-flag result, including value presence rules for useCodeDefault. */ function $21db6d51eabfa889$var$isValidFlagResult(value) {
    if (!$21db6d51eabfa889$export$6ba840931da50680(value)) return false;
    if (!$21db6d51eabfa889$var$isFlagReturnType(value.returnType)) return false;
    if (typeof value.useCodeDefault !== 'boolean') return false;
    if (!$21db6d51eabfa889$var$isValidBulkEvaluationMetadata(value.metadata)) return false;
    return value.useCodeDefault || (0, $dltAh.hasOwn)(value, 'value') && $21db6d51eabfa889$var$isTransportFlagValue(value.value);
}
function $21db6d51eabfa889$var$isValidBulkEvaluationMetadata(value) {
    if (!$21db6d51eabfa889$export$6ba840931da50680(value) || typeof value.matchReason !== 'string') return false;
    return $21db6d51eabfa889$var$isOptionalStringOrNull(value.identifierType) && $21db6d51eabfa889$var$isOptionalStringOrNull(value.variationId) && $21db6d51eabfa889$var$isOptionalStringOrNull(value.ruleId) && $21db6d51eabfa889$var$isOptionalRecordOrNull(value.holdoutAllocation) && $21db6d51eabfa889$var$isOptionalArrayOf(value.segments, $21db6d51eabfa889$export$6ba840931da50680) && $21db6d51eabfa889$var$isOptionalArrayOf(value.targetApps, (0, $dltAh.isString)) && $21db6d51eabfa889$var$isOptionalString(value.flagVersion) && $21db6d51eabfa889$var$isOptionalString(value.errorMessage);
}
/**
 * Accept an omitted, `null`, or object member.
 *
 * A holdout allocation is checked only for being an object; its members pass through.
 */ function $21db6d51eabfa889$var$isOptionalRecordOrNull(value) {
    return value === undefined || value === null || $21db6d51eabfa889$export$6ba840931da50680(value);
}
/**
 * Accept an omitted member or an array whose every entry satisfies `isEntry`.
 *
 * Segment entries are checked only for being objects; their members pass through.
 */ function $21db6d51eabfa889$var$isOptionalArrayOf(value, isEntry) {
    return value === undefined || Array.isArray(value) && value.every(isEntry);
}
function $21db6d51eabfa889$var$isOptionalString(value) {
    return value === undefined || (0, $dltAh.isString)(value);
}
function $21db6d51eabfa889$var$isFlagReturnType(value) {
    return typeof value === 'string' && $21db6d51eabfa889$var$FLAG_RETURN_TYPES.has(value);
}
function $21db6d51eabfa889$var$isFlagContextValueRecord(value) {
    return $21db6d51eabfa889$export$6ba840931da50680(value) && Object.values(value).every((entry)=>typeof entry === 'string' || typeof entry === 'number' || typeof entry === 'boolean');
}
function $21db6d51eabfa889$var$isStringRecord(value) {
    return $21db6d51eabfa889$export$6ba840931da50680(value) && Object.values(value).every((entry)=>typeof entry === 'string');
}
function $21db6d51eabfa889$var$isOptionalStringOrNull(value) {
    return value === undefined || value === null || typeof value === 'string';
}
/** Accept transport-safe primitive values plus JSON composite values for JSON flags. */ function $21db6d51eabfa889$var$isTransportFlagValue(value) {
    if (typeof value === 'string' || typeof value === 'boolean') return true;
    if (typeof value === 'number') return Number.isFinite(value);
    return $21db6d51eabfa889$var$isJsonContainer(value);
}
/** Accept JSON object or array containers when all nested entries are JSON-compatible. */ function $21db6d51eabfa889$var$isJsonContainer(value) {
    if (!$21db6d51eabfa889$var$isObjectLike(value)) return false;
    return Object.values(value).every($21db6d51eabfa889$var$isJsonCompatibleValue);
}
/** Recursively validate JSON-compatible nested values used inside transport JSON containers. */ function $21db6d51eabfa889$var$isJsonCompatibleValue(value) {
    if (value === null || typeof value === 'string' || typeof value === 'boolean') return true;
    if (typeof value === 'number') return Number.isFinite(value);
    return $21db6d51eabfa889$var$isObjectLike(value) && Object.values(value).every($21db6d51eabfa889$var$isJsonCompatibleValue);
}
function $21db6d51eabfa889$export$6ba840931da50680(value) {
    return $21db6d51eabfa889$var$isObjectLike(value) && !Array.isArray(value);
}
function $21db6d51eabfa889$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}

});

parcelRegister("aQhe8", function(module, exports) {
$parcel$export(module.exports, "normalizeUser", () => $09ddf2ff24bb7850$export$86dc25049b50352f);
$parcel$export(module.exports, "EMPTY_USER", () => $09ddf2ff24bb7850$export$f19e2c3a37ff07b4);
$parcel$export(module.exports, "hasNormalizationFindings", () => $09ddf2ff24bb7850$export$c11d127f76cdede2);

var $dltAh = parcelRequire("dltAh");
function $09ddf2ff24bb7850$export$86dc25049b50352f(user) {
    const droppedEntries = [];
    const emptyMembers = [];
    if (!$09ddf2ff24bb7850$var$isRecord(user)) {
        emptyMembers.push('user');
        return {
            user: $09ddf2ff24bb7850$var$freezeUser($09ddf2ff24bb7850$var$createMap(), $09ddf2ff24bb7850$var$createMap()),
            droppedEntries: droppedEntries,
            emptyMembers: emptyMembers
        };
    }
    const identifiers = $09ddf2ff24bb7850$var$copyValidEntries(user, 'identifiers', (0, $dltAh.isString), droppedEntries, emptyMembers, false);
    const attributes = $09ddf2ff24bb7850$var$copyValidEntries(user, 'attributes', $09ddf2ff24bb7850$var$isFlagContextValue, droppedEntries, emptyMembers, true);
    return {
        user: $09ddf2ff24bb7850$var$freezeUser(identifiers, attributes),
        droppedEntries: droppedEntries,
        emptyMembers: emptyMembers
    };
}
const $09ddf2ff24bb7850$export$f19e2c3a37ff07b4 = $09ddf2ff24bb7850$var$freezeUser($09ddf2ff24bb7850$var$createMap(), $09ddf2ff24bb7850$var$createMap());
function $09ddf2ff24bb7850$export$c11d127f76cdede2(normalization) {
    return normalization.droppedEntries.length > 0 || normalization.emptyMembers.length > 0;
}
function $09ddf2ff24bb7850$var$copyValidEntries(user, member, isValid, droppedEntries, emptyMembers, absentIsEmpty) {
    const copy = $09ddf2ff24bb7850$var$createMap();
    let entries;
    try {
        const value = user[member];
        if (value === undefined && absentIsEmpty) return copy;
        if (!$09ddf2ff24bb7850$var$isRecord(value)) {
            emptyMembers.push(member);
            return copy;
        }
        entries = Object.entries(value);
    } catch  {
        emptyMembers.push(member);
        return copy;
    }
    for (const [key, value] of entries)if (isValid(value)) copy[key] = value;
    else droppedEntries.push(`${member}.${key}`);
    return copy;
}
function $09ddf2ff24bb7850$var$freezeUser(identifiers, attributes) {
    return Object.freeze({
        identifiers: Object.freeze(identifiers),
        attributes: Object.freeze(attributes)
    });
}
/** Null-prototype map, so keys such as `__proto__` are stored as ordinary entries. */ function $09ddf2ff24bb7850$var$createMap() {
    return Object.create(null);
}
function $09ddf2ff24bb7850$var$isFlagContextValue(value) {
    return typeof value === 'string' || typeof value === 'boolean' || typeof value === 'number' && Number.isFinite(value);
}
/** Object check that never throws, including for revoked proxies. */ function $09ddf2ff24bb7850$var$isRecord(value) {
    try {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    } catch  {
        return false;
    }
}

});


parcelRegister("9wvvs", function(module, exports) {
$parcel$export(module.exports, "toFlagUser", () => $b24ee4cb9ab12330$export$2e7de09bcd2b7caf);

var $csevr = parcelRequire("csevr");
const $b24ee4cb9ab12330$var$isFlagContextValue = (value)=>typeof value === 'string' || typeof value === 'boolean' || typeof value === 'number' && Number.isFinite(value);
const $b24ee4cb9ab12330$export$2e7de09bcd2b7caf = (identifiers, customAttributes)=>{
    const flagIdentifiers = {};
    Object.entries((0, $csevr.toStatsigUser)(identifiers).customIDs ?? {}).forEach(([key, value])=>{
        if (typeof value === 'string') flagIdentifiers[key] = value;
    });
    const attributes = {};
    Object.entries(customAttributes ?? {}).forEach(([key, value])=>{
        if ($b24ee4cb9ab12330$var$isFlagContextValue(value)) attributes[key] = value;
    });
    return {
        identifiers: flagIdentifiers,
        attributes: attributes
    };
};

});
parcelRegister("csevr", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $ac390d96c35e5cde$export$3dad1db244472f32);
const $ac390d96c35e5cde$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("5sBSy", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $867f603feef30266$export$d119b37e5f788b43);

var $7rEw1 = parcelRequire("7rEw1");

var $27NB5 = parcelRequire("27NB5");
const $867f603feef30266$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $7rEw1.isFedRamp)() ? (0, $27NB5.PerimeterType).FEDRAMP_MODERATE : (0, $27NB5.PerimeterType).COMMERCIAL,
        ...options
    });

});
parcelRegister("7rEw1", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $354a05325557fdfa$export$64d6499adf9b2e51);

var $8pF96 = parcelRequire("8pF96");
function $354a05325557fdfa$export$64d6499adf9b2e51() {
    var _global$location;
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $8pF96.FEDRAMP_MODERATE);
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("8pF96", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $74e31bfa898de51b$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $74e31bfa898de51b$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $74e31bfa898de51b$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $74e31bfa898de51b$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $74e31bfa898de51b$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $74e31bfa898de51b$export$404582bc18fe4d9e);
const $74e31bfa898de51b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $74e31bfa898de51b$export$f005e2e9f707cb5f = 'commercial';
const $74e31bfa898de51b$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $74e31bfa898de51b$export$a739cd5aac835909 = 'stg';
const $74e31bfa898de51b$export$42dd0cdd351a4a9 = 'prod';
const $74e31bfa898de51b$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("dLxWR", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $f3bd7c57db0c550f$export$202946b690d26d22);
const $f3bd7c57db0c550f$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};

});

parcelRegister("fCJGM", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $f8e67f8dbaa99f24$export$55fffef3474104af);

var $drdCV = parcelRequire("drdCV");
class $f8e67f8dbaa99f24$export$55fffef3474104af extends (0, $drdCV.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $drdCV.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $drdCV._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $drdCV._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $drdCV._getStorageKey)(this._getSdkKey(), user);
        return `${0, $drdCV.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("8YzCX", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5fb2ed5abdcee0fd$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5fb2ed5abdcee0fd$export$bcb28fbac1def494);

var $43xZh = parcelRequire("43xZh");
const $5fb2ed5abdcee0fd$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $5fb2ed5abdcee0fd$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $5fb2ed5abdcee0fd$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $5fb2ed5abdcee0fd$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $5fb2ed5abdcee0fd$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $5fb2ed5abdcee0fd$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $5fb2ed5abdcee0fd$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $5fb2ed5abdcee0fd$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $5fb2ed5abdcee0fd$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $5fb2ed5abdcee0fd$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5fb2ed5abdcee0fd$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem($5fb2ed5abdcee0fd$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $43xZh._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$5fb2ed5abdcee0fd$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($5fb2ed5abdcee0fd$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $5fb2ed5abdcee0fd$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($5fb2ed5abdcee0fd$var$djb2MapKey((0, $43xZh._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $5fb2ed5abdcee0fd$var$makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($5fb2ed5abdcee0fd$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $43xZh._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5fb2ed5abdcee0fd$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    /**
   * The override for a gate, config or layer, looked up the same way as the Statsig override
   * methods above. `undefined` when there is none. Used for keys the wrapper answers without the
   * Statsig client.
   */ getOverride(kind, name) {
        return this._overrides[kind][name] ?? this._djb2Map.get($5fb2ed5abdcee0fd$var$djb2MapKey(name, kind));
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($5fb2ed5abdcee0fd$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $43xZh._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5fb2ed5abdcee0fd$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});

parcelRegister("chwyC", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $d2f92b39ad392e19$export$fa1c2bbf4100b8bc);
const $d2f92b39ad392e19$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};

});



parcelRegister("1LxCZ", function(module, exports) {
$parcel$export(module.exports, "debug", () => $12db9fa13c35eeab$export$1c9f709888824e05);
var $12db9fa13c35eeab$var$_process, $12db9fa13c35eeab$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $12db9fa13c35eeab$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($12db9fa13c35eeab$var$_process = globalThis.process) === null || $12db9fa13c35eeab$var$_process === void 0 || ($12db9fa13c35eeab$var$_process = $12db9fa13c35eeab$var$_process.env) === null || $12db9fa13c35eeab$var$_process === void 0 ? void 0 : $12db9fa13c35eeab$var$_process.JEST_WORKER_ID) !== undefined;
const $12db9fa13c35eeab$var$DEBUG_MODE = !$12db9fa13c35eeab$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($12db9fa13c35eeab$var$_process2 = globalThis.process) === null || $12db9fa13c35eeab$var$_process2 === void 0 || ($12db9fa13c35eeab$var$_process2 = $12db9fa13c35eeab$var$_process2.env) === null || $12db9fa13c35eeab$var$_process2 === void 0 ? void 0 : $12db9fa13c35eeab$var$_process2.NODE_ENV) !== 'production';
const $12db9fa13c35eeab$export$1c9f709888824e05 = (...args)=>{
    if (!$12db9fa13c35eeab$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("ipEkV", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $73b60d31ffa33f42$export$b574c24e1e6490f5);

var $4utUE = parcelRequire("4utUE");
const $73b60d31ffa33f42$export$b574c24e1e6490f5 = (0, $4utUE.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("4utUE", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $3f85bc9c1819d5bf$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $3f85bc9c1819d5bf$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $3f85bc9c1819d5bf$export$75f4a1454eff2805);

var $3jCFs = parcelRequire("3jCFs");
const $3f85bc9c1819d5bf$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $3f85bc9c1819d5bf$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $3f85bc9c1819d5bf$export$75f4a1454eff2805 = typeof $3jCFs !== 'undefined' && typeof $3jCFs.env !== 'undefined';

});


parcelRegister("3rmt1", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $62e1de777e9316ad$export$92f8b531feaeb23d);

var $4utUE = parcelRequire("4utUE");
const $62e1de777e9316ad$export$92f8b531feaeb23d = (0, $4utUE.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("75Krz", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $b299e59f9a6483a8$export$54ea85357b4e0159);

var $4utUE = parcelRequire("4utUE");
const $b299e59f9a6483a8$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $b299e59f9a6483a8$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$b299e59f9a6483a8$export$54ea85357b4e0159[0, $4utUE.PFF_GLOBAL_KEY] = $b299e59f9a6483a8$export$54ea85357b4e0159[0, $4utUE.PFF_GLOBAL_KEY] || $b299e59f9a6483a8$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("jR7cM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2a83cc171622980$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $f2a83cc171622980$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $f2a83cc171622980$export$2e2bcd8739ae039 = $f2a83cc171622980$var$coinflip;

});

parcelRegister("8nAtj", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $c3981031d0907713$export$23e69abaca7d0236);
const $c3981031d0907713$export$4c07c8a3507ce307 = 255;
const $c3981031d0907713$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $c3981031d0907713$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $c3981031d0907713$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(param)));
    } catch  {
        return false;
    }
}
function $c3981031d0907713$export$23e69abaca7d0236(name) {
    if (name.length <= $c3981031d0907713$export$4c07c8a3507ce307) return name;
    if ($c3981031d0907713$var$isGqlUrl(name)) return name;
    return name.slice(0, $c3981031d0907713$export$4c07c8a3507ce307);
}

});

parcelRegister("5hPkM", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $8f766a086df359ad$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $8f766a086df359ad$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $8f766a086df359ad$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $8f766a086df359ad$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $8f766a086df359ad$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $8f766a086df359ad$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $8f766a086df359ad$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $8f766a086df359ad$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $8f766a086df359ad$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $8f766a086df359ad$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $8f766a086df359ad$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $8f766a086df359ad$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $8f766a086df359ad$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $8f766a086df359ad$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $8f766a086df359ad$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $8f766a086df359ad$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $8f766a086df359ad$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $8f766a086df359ad$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $8f766a086df359ad$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $8f766a086df359ad$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $41a4X = parcelRequire("41a4X");

var $dRkX9 = parcelRequire("dRkX9");
let $8f766a086df359ad$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $8f766a086df359ad$var$cachedIsFedrampModerate;
function $8f766a086df359ad$var$detectIsFedrampModerate() {
    if ($8f766a086df359ad$var$cachedIsFedrampModerate !== undefined) return $8f766a086df359ad$var$cachedIsFedrampModerate;
    try {
        $8f766a086df359ad$var$cachedIsFedrampModerate = (0, $41a4X.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $8f766a086df359ad$var$cachedIsFedrampModerate = false;
    }
    return $8f766a086df359ad$var$cachedIsFedrampModerate;
}
function $8f766a086df359ad$export$89dc2b6be8cc261() {
    $8f766a086df359ad$var$cachedIsFedrampModerate = undefined;
}
function $8f766a086df359ad$export$1133b5e2873baa7a() {
    try {
        return $8f766a086df359ad$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $8f766a086df359ad$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $8f766a086df359ad$export$f9bb3bb330fb9609 = 'fy26.04';
function $8f766a086df359ad$export$2182e73d31080cbc() {
    return $8f766a086df359ad$export$f9bb3bb330fb9609;
}
const $8f766a086df359ad$export$d50dacda7fe6392b = 1000;
function $8f766a086df359ad$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = (newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof (enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) ?? [],
            ...Object.values(byExperience).flat()
        ];
        $8f766a086df359ad$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $8f766a086df359ad$var$config = newConfig;
}
function $8f766a086df359ad$export$44487a86467333c3() {
    return $8f766a086df359ad$var$config;
}
function $8f766a086df359ad$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    var _config;
    // 1. FedRAMP override always wins.
    if ($8f766a086df359ad$var$detectIsFedrampModerate()) return $8f766a086df359ad$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? ((_config = $8f766a086df359ad$var$config) === null || _config === void 0 || (_config = _config.vc) === null || _config === void 0 ? void 0 : _config.selectorConfig) ?? defaultConfig;
}
function $8f766a086df359ad$export$74bdb753f1cf4860() {
    var _config2;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config2 = $8f766a086df359ad$var$config) === null || _config2 === void 0 ? void 0 : _config2.enabled) !== false;
}
const $8f766a086df359ad$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $8f766a086df359ad$export$87fbc8e01b137811(experienceKey = '') {
    try {
        var _config$vc;
        if (!$8f766a086df359ad$var$config) return [];
        if ((_config$vc = $8f766a086df359ad$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _enabledVCRevisions$b;
            const { enabledVCRevisions: enabledVCRevisions } = $8f766a086df359ad$var$config.vc ?? {};
            if ($8f766a086df359ad$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $dRkX9.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($8f766a086df359ad$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $8f766a086df359ad$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $8f766a086df359ad$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $8f766a086df359ad$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $8f766a086df359ad$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $8f766a086df359ad$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $8f766a086df359ad$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $8f766a086df359ad$export$2d8f8d64dc343d7b() {
    if (!$8f766a086df359ad$var$config) return undefined;
    try {
        var _config3, _config3$getReactHydr;
        const stats = (_config3 = $8f766a086df359ad$var$config) === null || _config3 === void 0 || (_config3$getReactHydr = _config3.getReactHydrationStats) === null || _config3$getReactHydr === void 0 ? void 0 : _config3$getReactHydr.call(_config3);
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $8f766a086df359ad$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$8f766a086df359ad$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $8f766a086df359ad$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $8f766a086df359ad$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $8f766a086df359ad$export$48f4e0d964030a96(name, interactionType) {
    return $8f766a086df359ad$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $8f766a086df359ad$export$9c69f5a724f05f38(name, interactionType) {
    return $8f766a086df359ad$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $8f766a086df359ad$export$1d459f020c06ae34(name, interactionType) {
    return $8f766a086df359ad$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $8f766a086df359ad$export$29b9ffb14861a1d(capability) {
    if ((0, $dRkX9.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$8f766a086df359ad$var$config) return 0;
        const { capability: capabilityRate } = $8f766a086df359ad$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $8f766a086df359ad$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$8f766a086df359ad$var$config) return 0;
        const gotConfig = $8f766a086df359ad$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $8f766a086df359ad$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $8f766a086df359ad$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$8f766a086df359ad$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $8f766a086df359ad$var$config;
        if (typingMethod != null && $8f766a086df359ad$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $8f766a086df359ad$export$2d311b3fd18dcab1() {
    try {
        if (!$8f766a086df359ad$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $8f766a086df359ad$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $8f766a086df359ad$export$4f4649ef27b6f5d6() {
    try {
        if (!$8f766a086df359ad$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $8f766a086df359ad$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $8f766a086df359ad$export$b150ddad71c80d77() {
    try {
        if (!$8f766a086df359ad$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $8f766a086df359ad$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $8f766a086df359ad$export$3c170167645a0eff() {
    try {
        if (!$8f766a086df359ad$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $8f766a086df359ad$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $8f766a086df359ad$export$d6dc9444bd15f70f() {
    try {
        if (!$8f766a086df359ad$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $8f766a086df359ad$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $8f766a086df359ad$export$20e8108b8ccdd0bd() {
    try {
        if (!$8f766a086df359ad$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $8f766a086df359ad$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $8f766a086df359ad$export$2a8604960d7d23d9 = 60000;
function $8f766a086df359ad$export$c681731847989445(ufoName) {
    try {
        if (!$8f766a086df359ad$var$config) return $8f766a086df359ad$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $8f766a086df359ad$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $8f766a086df359ad$export$2a8604960d7d23d9;
    } catch  {
        return $8f766a086df359ad$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("41a4X", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $2ee099b2261456cf$export$104cb891a6e90b3a);

var $5nZb1 = parcelRequire("5nZb1");

var $iPUNO = parcelRequire("iPUNO");
function $2ee099b2261456cf$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInFedramp) ?? false;
    }
    const atlCtxCookieValues = (0, $iPUNO.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $5nZb1.FEDRAMP_MODERATE);
}

});
parcelRegister("5nZb1", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $9a64cef6cb53f44f$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $9a64cef6cb53f44f$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $9a64cef6cb53f44f$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $9a64cef6cb53f44f$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $9a64cef6cb53f44f$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $9a64cef6cb53f44f$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $9a64cef6cb53f44f$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $9a64cef6cb53f44f$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $9a64cef6cb53f44f$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $9a64cef6cb53f44f$export$b61e047ddcc35726);
const $9a64cef6cb53f44f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9a64cef6cb53f44f$export$f005e2e9f707cb5f = 'commercial';
const $9a64cef6cb53f44f$export$17b81a3d6c98013c = 'isolated-cloud';
const $9a64cef6cb53f44f$export$a739cd5aac835909 = 'staging';
const $9a64cef6cb53f44f$export$42dd0cdd351a4a9 = 'prod';
const $9a64cef6cb53f44f$export$404582bc18fe4d9e = 'dev';
const $9a64cef6cb53f44f$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9a64cef6cb53f44f$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9a64cef6cb53f44f$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9a64cef6cb53f44f$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9a64cef6cb53f44f$export$b61e047ddcc35726 = 'GCP';
const $9a64cef6cb53f44f$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("iPUNO", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $e7b91a7dff5e05ea$export$3fa7b7af96286cc9);

var $5nZb1 = parcelRequire("5nZb1");

var $5TH1y = parcelRequire("5TH1y");
function $e7b91a7dff5e05ea$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $5TH1y.getRawCookieValue)((0, $5nZb1.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $5TH1y.getRawCookieValue)((0, $5nZb1.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $5TH1y.getRawCookieValue)((0, $5nZb1.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("5TH1y", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $a350bb4180c00a8f$export$aa09aab30a92256c);
function $a350bb4180c00a8f$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});




parcelRegister("joIQT", function(module, exports) {
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $9e1101cfa66632ec$export$74b9ce7e9d206a8);

var $9To4z = parcelRequire("9To4z");
function $9e1101cfa66632ec$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        (0, $9To4z.interactionBufferState).bufferInteractionData(interactionId, data);
        (0, $9To4z.interactionBufferState).interactionBuffer.length = 0;
    }
}

});
parcelRegister("9To4z", function(module, exports) {
$parcel$export(module.exports, "interactionBufferState", () => $e133d9c0c35534c2$export$af15cc1c63c2807a);
const $e133d9c0c35534c2$var$interactionBuffer = [];
const $e133d9c0c35534c2$export$af15cc1c63c2807a = {
    interactionBuffer: $e133d9c0c35534c2$var$interactionBuffer,
    bufferInteractionData: (interactionId, data)=>{
        $e133d9c0c35534c2$var$interactionBuffer.push({
            interactionId: interactionId,
            data: data
        });
    }
};

});


parcelRegister("jKRI6", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $dee31394dd40e6f7$export$e08487ea3ae92adb);
function $dee31394dd40e6f7$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}

});

parcelRegister("iU9Tu", function(module, exports) {
$parcel$export(module.exports, "stringifyLabelStackFully", () => $d296f4f21f45f731$export$caeee352b541de1f);

var $67wJP = parcelRequire("67wJP");

var $9JxdC = parcelRequire("9JxdC");
function $d296f4f21f45f731$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = (0, $9JxdC.sanitizeLabelStackName)(l.name);
        if ((0, $67wJP.isSegmentLabel)(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}

});
parcelRegister("67wJP", function(module, exports) {
$parcel$export(module.exports, "isSegmentLabel", () => $8204a2753df0cdee$export$1adbaf5c2363e4ae);
function $8204a2753df0cdee$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

});

parcelRegister("9JxdC", function(module, exports) {
$parcel$export(module.exports, "sanitizeLabelStackName", () => $136b0f94767cdd05$export$3535cd9da4961282);
function $136b0f94767cdd05$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}

});


parcelRegister("aQ7I7", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $cfff808111a779c1$export$17ab21d7be720b);

var $fgh8a = parcelRequire("fgh8a");

var $dRkX9 = parcelRequire("dRkX9");

var $LzvBG = parcelRequire("LzvBG");

var $fagaO = parcelRequire("fagaO");
function $cfff808111a779c1$export$17ab21d7be720b() {
    if ((0, $dRkX9.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $LzvBG.getContextManager)() instanceof (0, $LzvBG.UFOContextManager)) {
            let contextManager = (0, $LzvBG.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $fgh8a.ROOT_CONTEXT));
        }
    } else (0, $fagaO.state).context = null;
}

});
parcelRegister("fgh8a", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $b1c5a37544585f68$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $b1c5a37544585f68$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Get a key to uniquely identify a context value
 *
 * @since 1.0.0
 */ function $b1c5a37544585f68$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
class $b1c5a37544585f68$var$BaseContext {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ constructor(parentContext){
        // for minification
        const self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = (key)=>self._currentContext.get(key);
        self.setValue = (key, value)=>{
            const context = new $b1c5a37544585f68$var$BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = (key)=>{
            const context = new $b1c5a37544585f68$var$BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
}
const $b1c5a37544585f68$export$78df28f9b2f9a7dc = new $b1c5a37544585f68$var$BaseContext();

});

parcelRegister("LzvBG", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $2a08b55ce9fb0dda$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $2a08b55ce9fb0dda$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $2a08b55ce9fb0dda$export$dd301b96c16f583d);

var $fgh8a = parcelRequire("fgh8a");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $2a08b55ce9fb0dda$var$contextManager;
function $2a08b55ce9fb0dda$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $2a08b55ce9fb0dda$var$contextManager = ctxMgr;
}
function $2a08b55ce9fb0dda$export$831109c9f7727010() {
    return $2a08b55ce9fb0dda$var$contextManager;
}
class $2a08b55ce9fb0dda$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $fgh8a.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $fgh8a.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $fgh8a.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $fgh8a.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
   * whether the context manager is enabled or not
   */ this._enabled = false;
        /**
   * Keeps the reference to current context
   */ this._currentContext = (0, $fgh8a.ROOT_CONTEXT);
    }
}

});

parcelRegister("fagaO", function(module, exports) {
$parcel$export(module.exports, "state", () => $e83fcaea1a825e32$export$ca000e230c0caa3e);
const $e83fcaea1a825e32$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("2Eign", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $8766b6024c7c0990$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $8766b6024c7c0990$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $8766b6024c7c0990$export$47fade9662f71000);

var $ioeYy = parcelRequire("ioeYy");
const $8766b6024c7c0990$export$5b78c989c8db2561 = new Map();
const $8766b6024c7c0990$export$2a5c8df26bb89760 = new Map();
function $8766b6024c7c0990$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $ioeYy.redactValue)(featureFlagValue);
    $8766b6024c7c0990$export$5b78c989c8db2561.set(featureFlagName, value);
    $8766b6024c7c0990$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("ioeYy", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $74683cf99e2d238e$export$fcc03ee4c944962f);

var $99uSr = parcelRequire("99uSr");

var $6k7zB = parcelRequire("6k7zB");
function $74683cf99e2d238e$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $6k7zB.shouldRedactValue)(featureFlagValue) ? (0, $99uSr.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("99uSr", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $716a977975394a1b$export$42f4885608027d0c);
const $716a977975394a1b$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("6k7zB", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $b6cf886c96d09c38$export$7b4abba432e57989);
function $b6cf886c96d09c38$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $b6cf886c96d09c38$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $b6cf886c96d09c38$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $b6cf886c96d09c38$export$7b4abba432e57989(value) {
    return $b6cf886c96d09c38$var$isString(value) && $b6cf886c96d09c38$var$startsAsObject(value) || $b6cf886c96d09c38$var$isObject(value);
}

});



parcelRegister("ifobP", function(module, exports) {
$parcel$export(module.exports, "getInteractionId", () => $d861a4fcfc3f4da8$export$37bca3107733ac1e);

var $7bB5V = parcelRequire("7bB5V");
const $d861a4fcfc3f4da8$export$37bca3107733ac1e = ()=>(0, $7bB5V.default);

});
parcelRegister("7bB5V", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca5509da647db73$export$2e2bcd8739ae039);

var $clVtP = parcelRequire("clVtP");
class $bca5509da647db73$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        if (oldId !== newId) (0, $clVtP.listeners).forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
const $bca5509da647db73$var$initializeGlobalDefaultInteractionID = ()=>{
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    const instance = new $bca5509da647db73$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $bca5509da647db73$var$DefaultInteractionID = $bca5509da647db73$var$initializeGlobalDefaultInteractionID();
var $bca5509da647db73$export$2e2bcd8739ae039 = $bca5509da647db73$var$DefaultInteractionID;

});
parcelRegister("clVtP", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $6cfaa3179183d774$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $6cfaa3179183d774$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
const $6cfaa3179183d774$export$58bed631278dbc67 = new Set();
const $6cfaa3179183d774$export$3e0c3023952f6774 = (listener)=>{
    $6cfaa3179183d774$export$58bed631278dbc67.add(listener);
    return ()=>{
        $6cfaa3179183d774$export$58bed631278dbc67.delete(listener);
    };
};

});



parcelRegister("7wGpR", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $3d5734eef2bb6adf$export$c3b002e13fbb9ef2);
const $3d5734eef2bb6adf$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("0kO5U", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $b2e3e62c42c95c1c$export$c8760e11c713fafc);

var $koZIF = parcelRequire("koZIF");
const $b2e3e62c42c95c1c$export$c8760e11c713fafc = ()=>{
    (0, $koZIF.default).spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    (0, $koZIF.default).spanStates.clear();
};

});
parcelRegister("koZIF", function(module, exports) {
$parcel$export(module.exports, "default", () => $89a44a4e5fe3561f$export$2e2bcd8739ae039);
// Shared across profiler renders and the public reset/flush entry points. Keep this
// outside React context so Suspense restarts cannot discard the initial render.
const $89a44a4e5fe3561f$var$state = {
    startTimes: new Map(),
    spanStates: new Map(),
    lastActiveInteraction: undefined
};
var $89a44a4e5fe3561f$export$2e2bcd8739ae039 = $89a44a4e5fe3561f$var$state;

});


parcelRegister("7RDnQ", function(module, exports) {
$parcel$export(module.exports, "newVCObserver", () => $8737ebe3f8839390$export$c69731bddfc24d85);

var $vycX1 = parcelRequire("vycX1");

var $krazZ = parcelRequire("krazZ");

var $2gz56 = parcelRequire("2gz56");
function $8737ebe3f8839390$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !(0, $vycX1.isEnvironmentSupported)();
    const observer = shouldMockVCObserver ? new (0, $krazZ.VCObserverNOOP)() : new (0, $2gz56.VCObserverWrapper)(opts);
    return observer;
}

});
parcelRegister("vycX1", function(module, exports) {
$parcel$export(module.exports, "isEnvironmentSupported", () => $11d4d69522f8ea26$export$68d57b133e88584d);

var $3jCFs = parcelRequire("3jCFs");
var $11d4d69522f8ea26$var$_process;
// Some products set this variable to indicate it is running in SSR
let $11d4d69522f8ea26$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $11d4d69522f8ea26$var$isReactSSR = typeof $3jCFs !== 'undefined' && Boolean((($11d4d69522f8ea26$var$_process = $3jCFs) === null || $11d4d69522f8ea26$var$_process === void 0 || ($11d4d69522f8ea26$var$_process = $11d4d69522f8ea26$var$_process.env) === null || $11d4d69522f8ea26$var$_process === void 0 ? void 0 : $11d4d69522f8ea26$var$_process.REACT_SSR) || false);
function $11d4d69522f8ea26$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($11d4d69522f8ea26$var$isReactSSR || $11d4d69522f8ea26$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}

});

parcelRegister("krazZ", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $618b05aad5fc844b$export$24d07287b49da906);
class $618b05aad5fc844b$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("2gz56", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $c58d0d5577be0ccd$export$4a1fe1ab3c13bbf5);

var $5hPkM = parcelRequire("5hPkM");

var $4mqWP = parcelRequire("4mqWP");

var $kuRpz = parcelRequire("kuRpz");

var $fZmuU = parcelRequire("fZmuU");

var $YC9EF = parcelRequire("YC9EF");
class $c58d0d5577be0ccd$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $YC9EF.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $kuRpz.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $5hPkM.isVCRevisionEnabled)('fy25.01') || (0, $5hPkM.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $4mqWP.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        var _window;
        // Process any SSR abort listeners that remain
        if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        var _this$newVCObserver;
        if ((0, $5hPkM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5hPkM.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver;
            (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                startTime: startTime
            });
        }
        (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        var _this$newVCObserver2;
        if ((0, $5hPkM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5hPkM.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver2;
            (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
        }
        (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
        (0, $fZmuU.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        var _this$oldVCObserver3;
        return ((_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) ?? null;
    }
    async getVCResult(param) {
        var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$;
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $5hPkM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5hPkM.isVCRevisionEnabled)('fy25.02', experienceKey) ? await ((_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param)) : {};
        const v3v4Result = await ((_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        }));
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...(v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        var _this$oldVCObserver5, _this$newVCObserver4;
        (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
        (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        var _this$oldVCObserver6, _this$newVCObserver5;
        (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
        (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        var _this$oldVCObserver7, _this$newVCObserver6;
        (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
        (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}

});
parcelRegister("4mqWP", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $26572173b46a886f$export$1f70d263701b1d01);

var $dRkX9 = parcelRequire("dRkX9");

var $5hPkM = parcelRequire("5hPkM");

var $jQYQa = parcelRequire("jQYQa");

var $4pces = parcelRequire("4pces");

var $5h4hy = parcelRequire("5h4hy");

var $aPZ8g = parcelRequire("aPZ8g");

var $3e7hH = parcelRequire("3e7hH");

var $a20Ix = parcelRequire("a20Ix");

var $5h5r2 = parcelRequire("5h5r2");
const $26572173b46a886f$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $26572173b46a886f$var$UNUSED_SECTOR = 0;
function $26572173b46a886f$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $26572173b46a886f$export$1f70d263701b1d01 {
    static #_ = /** config * */ this.VCParts = [
        '25',
        '50',
        '75',
        '80',
        '85',
        '90',
        '95',
        '98',
        '99'
    ];
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $5hPkM.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $26572173b46a886f$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $26572173b46a886f$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $26572173b46a886f$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $5h4hy.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $5h4hy.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            var _window$__ufo_devtool2, _window2;
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) {
                                var _window$__ufo_devtool, _window;
                                (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                            }
                            // Handle v2
                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            var _window$__on_ufo_vc_d2, _window4;
                            if (!isTTVCv1Disabled) {
                                var _window$__on_ufo_vc_d, _window3;
                                (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                            }
                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $aPZ8g.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $26572173b46a886f$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $26572173b46a886f$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $5hPkM.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $jQYQa.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $5hPkM.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($26572173b46a886f$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $dRkX9.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $jQYQa.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    this.setAbortReason($26572173b46a886f$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($26572173b46a886f$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            var _window5;
            this.detachAbortListeners();
            let unbinds = (0, $4pces.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $5h5r2.Observers)({
            selectorConfig: (0, $5hPkM.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $5hPkM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $26572173b46a886f$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $26572173b46a886f$var$UNUSED_SECTOR) {
            var _window$document;
            const element = {
                __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $26572173b46a886f$var$UNUSED_SECTOR && ssrTime !== $26572173b46a886f$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $26572173b46a886f$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $26572173b46a886f$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $26572173b46a886f$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $26572173b46a886f$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $26572173b46a886f$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    var _componentsLog$time;
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            var _acc$abs, _componentsLog$timest, _acc$rel;
            const currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (((_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $26572173b46a886f$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $5hPkM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($26572173b46a886f$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $a20Ix.getViewportWidth)();
        this.viewport.h = (0, $3e7hH.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($26572173b46a886f$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($26572173b46a886f$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $26572173b46a886f$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("4pces", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $08327422f743ede2$export$9010aa71841a6887);

var $6Zi52 = parcelRequire("6Zi52");

var $2W84F = parcelRequire("2W84F");

var $3e7hH = parcelRequire("3e7hH");

var $a20Ix = parcelRequire("a20Ix");
function $08327422f743ede2$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $6Zi52.bind)(window, {
        type: (0, $2W84F.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $2W84F.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $6Zi52.bind)(window, {
        type: (0, $2W84F.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $2W84F.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $6Zi52.bind)(window, {
        type: (0, $2W84F.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $a20Ix.getViewportWidth)() !== initialViewPort.w || (0, $3e7hH.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $2W84F.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("6Zi52", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $lnWv7 = parcelRequire("lnWv7");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $lnWv7.bind;
    }
});

var $kEF3R = parcelRequire("kEF3R");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $kEF3R.bindAll;
    }
});

});
parcelRegister("lnWv7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $f9191fff68a99f26$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $f9191fff68a99f26$var$bind;

});

parcelRegister("kEF3R", function(module, exports) {
"use strict";
var $f09764ff2b298e68$var$__assign = module.exports && module.exports.__assign || function() {
    $f09764ff2b298e68$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f09764ff2b298e68$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $lnWv7 = parcelRequire("lnWv7");
function $f09764ff2b298e68$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f09764ff2b298e68$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f09764ff2b298e68$var$__assign($f09764ff2b298e68$var$__assign({}, original), {
        options: $f09764ff2b298e68$var$__assign($f09764ff2b298e68$var$__assign({}, $f09764ff2b298e68$var$toOptions(sharedOptions)), $f09764ff2b298e68$var$toOptions(original.options))
    });
    return binding;
}
function $f09764ff2b298e68$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f09764ff2b298e68$var$getBinding(original, sharedOptions);
        return (0, $lnWv7.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $f09764ff2b298e68$var$bindAll;

});


parcelRegister("2W84F", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $1a5a77770e750085$export$199edc0307b5587f);
const $1a5a77770e750085$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("3e7hH", function(module, exports) {
$parcel$export(module.exports, "getViewportHeight", () => $6026a45885f38494$export$4f01c15d21ef9cc6);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $6026a45885f38494$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("a20Ix", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $9fe05a02fd0bd5f7$export$a497a1dcb4408212);
function $9fe05a02fd0bd5f7$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});


parcelRegister("5h4hy", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $9ff1e670fc40267a$export$72e6dda9d5859230);
function $9ff1e670fc40267a$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                    rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                    visible: true,
                    attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                    oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                    newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                    ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("aPZ8g", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $baa19fe6e7baf184$export$5c86a34c9becd6d0);

var $5hPkM = parcelRequire("5hPkM");

var $1N51K = parcelRequire("1N51K");
const $baa19fe6e7baf184$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $baa19fe6e7baf184$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $baa19fe6e7baf184$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $baa19fe6e7baf184$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $baa19fe6e7baf184$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $baa19fe6e7baf184$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $1N51K.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $5hPkM.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $baa19fe6e7baf184$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $5hPkM.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $baa19fe6e7baf184$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});
parcelRegister("1N51K", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $c8be0f737e36deaa$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $c8be0f737e36deaa$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $c8be0f737e36deaa$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $c8be0f737e36deaa$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $c8be0f737e36deaa$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $c8be0f737e36deaa$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $c8be0f737e36deaa$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $c8be0f737e36deaa$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6Zi52 = parcelRequire("6Zi52");

var $dRkX9 = parcelRequire("dRkX9");
const $c8be0f737e36deaa$var$timings = [];
let $c8be0f737e36deaa$var$wasHiddenFlag;
let $c8be0f737e36deaa$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $c8be0f737e36deaa$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $c8be0f737e36deaa$var$openedInBackground = null;
function $c8be0f737e36deaa$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $c8be0f737e36deaa$var$SIZE = 50;
let $c8be0f737e36deaa$var$insertIndex = 0;
function $c8be0f737e36deaa$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    const earliestHiddenTiming = (_timings$find = $c8be0f737e36deaa$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $c8be0f737e36deaa$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $c8be0f737e36deaa$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $c8be0f737e36deaa$var$openedInBackground === true;
}
function $c8be0f737e36deaa$var$pushHidden(isPageHiddenFlag, time) {
    $c8be0f737e36deaa$var$timings[$c8be0f737e36deaa$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $c8be0f737e36deaa$var$insertIndex = ($c8be0f737e36deaa$var$insertIndex + 1) % $c8be0f737e36deaa$var$SIZE;
    $c8be0f737e36deaa$var$wasHiddenFlag = isPageHiddenFlag;
}
function $c8be0f737e36deaa$var$handleChange() {
    const isPageHiddenFlag = $c8be0f737e36deaa$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$c8be0f737e36deaa$var$wasHiddenFlag) $c8be0f737e36deaa$var$pushHidden(isPageHiddenFlag);
        $c8be0f737e36deaa$var$wasHiddenFlag = true;
    } else {
        if ($c8be0f737e36deaa$var$wasHiddenFlag) $c8be0f737e36deaa$var$pushHidden(isPageHiddenFlag);
        $c8be0f737e36deaa$var$wasHiddenFlag = false;
    }
}
let $c8be0f737e36deaa$var$hasHiddenTimingBeforeSetup = false;
function $c8be0f737e36deaa$export$95f048bd8bcdda23() {
    return $c8be0f737e36deaa$var$hasHiddenTimingBeforeSetup;
}
function $c8be0f737e36deaa$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach((result)=>{
            if ((0, $dRkX9.fg)('platform_ufo_use_native_page_visibility_api')) $c8be0f737e36deaa$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $c8be0f737e36deaa$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $6Zi52.bind)(window, {
        type: 'pageshow',
        listener: $c8be0f737e36deaa$var$handleChange
    });
    (0, $6Zi52.bind)(window, {
        type: 'pagehide',
        listener: $c8be0f737e36deaa$var$handleChange
    });
    (0, $6Zi52.bind)(document, {
        type: 'visibilitychange',
        listener: $c8be0f737e36deaa$var$handleChange
    });
}
function $c8be0f737e36deaa$export$554cefe0f0373da4() {
    if (!$c8be0f737e36deaa$var$setupFlag) {
        const isPageHiddenFlag = $c8be0f737e36deaa$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($c8be0f737e36deaa$var$openedInBackground === null) $c8be0f737e36deaa$var$openedInBackground = isPageHiddenFlag && setupTime < $c8be0f737e36deaa$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $c8be0f737e36deaa$var$pushHidden(isPageHiddenFlag, 0);
        $c8be0f737e36deaa$var$setup();
        $c8be0f737e36deaa$var$setupFlag = true;
    }
}
function $c8be0f737e36deaa$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($c8be0f737e36deaa$var$timings.length === 0) return 'visible';
    const currentSize = $c8be0f737e36deaa$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $c8be0f737e36deaa$var$insertIndex;
    let endIdx = $c8be0f737e36deaa$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($c8be0f737e36deaa$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($c8be0f737e36deaa$var$timings[tmpIdx] && $c8be0f737e36deaa$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($c8be0f737e36deaa$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $c8be0f737e36deaa$var$timings[startIdx]) hiddenState = $c8be0f737e36deaa$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $c8be0f737e36deaa$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $c8be0f737e36deaa$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $c8be0f737e36deaa$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $c8be0f737e36deaa$var$throttleMeasurements = [];
let $c8be0f737e36deaa$var$throttleInsertIndex = 0;
let $c8be0f737e36deaa$var$throttleIntervalId = null;
let $c8be0f737e36deaa$var$lastThrottleCheckTime = null;
let $c8be0f737e36deaa$var$throttleSetupDone = false;
function $c8be0f737e36deaa$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $c8be0f737e36deaa$var$THROTTLE_DRIFT_THRESHOLD;
    $c8be0f737e36deaa$var$throttleMeasurements[$c8be0f737e36deaa$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $c8be0f737e36deaa$var$throttleInsertIndex = ($c8be0f737e36deaa$var$throttleInsertIndex + 1) % $c8be0f737e36deaa$var$THROTTLE_BUFFER_SIZE;
}
function $c8be0f737e36deaa$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($c8be0f737e36deaa$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $c8be0f737e36deaa$var$lastThrottleCheckTime;
        $c8be0f737e36deaa$var$recordThrottleMeasurement($c8be0f737e36deaa$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $c8be0f737e36deaa$var$lastThrottleCheckTime = currentTime;
}
function $c8be0f737e36deaa$export$fa0d29a9c87052da() {
    if ($c8be0f737e36deaa$var$throttleSetupDone) return;
    $c8be0f737e36deaa$var$throttleSetupDone = true;
    // Record the initial timestamp
    $c8be0f737e36deaa$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $c8be0f737e36deaa$var$throttleIntervalId = setInterval($c8be0f737e36deaa$var$throttleCheckCallback, $c8be0f737e36deaa$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $c8be0f737e36deaa$export$3279694d66e4a1() {
    if ($c8be0f737e36deaa$var$throttleIntervalId !== null) {
        clearInterval($c8be0f737e36deaa$var$throttleIntervalId);
        $c8be0f737e36deaa$var$throttleIntervalId = null;
    }
    $c8be0f737e36deaa$var$lastThrottleCheckTime = null;
    $c8be0f737e36deaa$var$throttleSetupDone = false;
    $c8be0f737e36deaa$var$throttleMeasurements.length = 0;
    $c8be0f737e36deaa$var$throttleInsertIndex = 0;
}
function $c8be0f737e36deaa$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($c8be0f737e36deaa$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $c8be0f737e36deaa$var$throttleMeasurements.length; i++){
        const measurement = $c8be0f737e36deaa$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $c8be0f737e36deaa$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $c8be0f737e36deaa$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $c8be0f737e36deaa$export$9332de935653b687(measurement) {
    $c8be0f737e36deaa$var$throttleMeasurements[$c8be0f737e36deaa$var$throttleInsertIndex] = measurement;
    $c8be0f737e36deaa$var$throttleInsertIndex = ($c8be0f737e36deaa$var$throttleInsertIndex + 1) % $c8be0f737e36deaa$var$THROTTLE_BUFFER_SIZE;
}
function $c8be0f737e36deaa$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($c8be0f737e36deaa$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $c8be0f737e36deaa$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($c8be0f737e36deaa$var$insertIndex + i) % currentSize;
        const entry = $c8be0f737e36deaa$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($c8be0f737e36deaa$var$insertIndex + i) % currentSize;
        const entry = $c8be0f737e36deaa$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $c8be0f737e36deaa$export$9332de935653b687
};

});


parcelRegister("5h5r2", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $3df1ca55fff412f6$export$b65d046240060e78);

var $5hPkM = parcelRequire("5hPkM");

var $02Al1 = parcelRequire("02Al1");

var $kpvjH = parcelRequire("kpvjH");

var $fZmuU = parcelRequire("fZmuU");

var $YC9EF = parcelRequire("YC9EF");
const $3df1ca55fff412f6$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $3df1ca55fff412f6$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $3df1ca55fff412f6$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $3df1ca55fff412f6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $5hPkM.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $YC9EF.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        var _this$mutationObserve;
        this.totalTime = 0;
        this.ssr = {
            state: $3df1ca55fff412f6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        var _this$mutationObserve2, _this$intersectionObs;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $3df1ca55fff412f6$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $3df1ca55fff412f6$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $3df1ca55fff412f6$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $3df1ca55fff412f6$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $3df1ca55fff412f6$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $02Al1.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            var _this$intersectionObs3;
                            this.elementsInView.delete(node);
                            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $kpvjH.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $02Al1.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                    return;
                    if (!$3df1ca55fff412f6$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $fZmuU.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("02Al1", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $9c9952a6629d24c0$export$f61fbc3b9c4a9019);

var $lPAO5 = parcelRequire("lPAO5");
function $9c9952a6629d24c0$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $lPAO5.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("lPAO5", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $33cb6a1b89331035$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $33cb6a1b89331035$export$7028e9efe569888c);

var $fc4bM = parcelRequire("fc4bM");
const $33cb6a1b89331035$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $33cb6a1b89331035$export$7028e9efe569888c = {
    [$33cb6a1b89331035$export$7674290405cc25b0]: true
};
function $33cb6a1b89331035$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", $33cb6a1b89331035$export$7028e9efe569888c, children);
}

});
parcelRegister("fc4bM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jXfZ7"));

});
parcelRegister("jXfZ7", function(module, exports) {
$parcel$export(module.exports, "Children", () => $e86fed3c43f4fd72$export$dca3b0875bd9a954, (v) => $e86fed3c43f4fd72$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e86fed3c43f4fd72$export$16fa2f45be04daa8, (v) => $e86fed3c43f4fd72$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e86fed3c43f4fd72$export$ffb0004e005737fa, (v) => $e86fed3c43f4fd72$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e86fed3c43f4fd72$export$e2c29f18771995cb, (v) => $e86fed3c43f4fd72$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e86fed3c43f4fd72$export$221d75b3f55bb0bd, (v) => $e86fed3c43f4fd72$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e86fed3c43f4fd72$export$5f8d39834fd61797, (v) => $e86fed3c43f4fd72$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e86fed3c43f4fd72$export$74bf444e3cd11ea5, (v) => $e86fed3c43f4fd72$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e86fed3c43f4fd72$export$ae55be85d98224ed, (v) => $e86fed3c43f4fd72$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $e86fed3c43f4fd72$export$3ba232387fd5d6dd, (v) => $e86fed3c43f4fd72$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $e86fed3c43f4fd72$export$e530037191fcd5d7, (v) => $e86fed3c43f4fd72$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e86fed3c43f4fd72$export$fd42f52fd3ae1109, (v) => $e86fed3c43f4fd72$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e86fed3c43f4fd72$export$c8a8987d4410bf2d, (v) => $e86fed3c43f4fd72$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $e86fed3c43f4fd72$export$d38cd72104c1f0e9, (v) => $e86fed3c43f4fd72$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $e86fed3c43f4fd72$export$7d1e3a5e95ceca43, (v) => $e86fed3c43f4fd72$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e86fed3c43f4fd72$export$257a8862b851cb5b, (v) => $e86fed3c43f4fd72$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e86fed3c43f4fd72$export$a8257692ac88316c, (v) => $e86fed3c43f4fd72$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e86fed3c43f4fd72$export$488013bae63b21da, (v) => $e86fed3c43f4fd72$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e86fed3c43f4fd72$export$7c73462e0d25e514, (v) => $e86fed3c43f4fd72$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e86fed3c43f4fd72$export$7568632d0d33d16d, (v) => $e86fed3c43f4fd72$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $e86fed3c43f4fd72$export$88948ce120ea2619, (v) => $e86fed3c43f4fd72$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $e86fed3c43f4fd72$export$35808ee640e87ca7, (v) => $e86fed3c43f4fd72$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e86fed3c43f4fd72$export$fae74005e78b1a27, (v) => $e86fed3c43f4fd72$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e86fed3c43f4fd72$export$dc8fbce3eb94dc1e, (v) => $e86fed3c43f4fd72$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e86fed3c43f4fd72$export$6a7bc4e911dc01cf, (v) => $e86fed3c43f4fd72$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e86fed3c43f4fd72$export$6d9c69b0de29b591, (v) => $e86fed3c43f4fd72$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $e86fed3c43f4fd72$export$f680877a34711e37, (v) => $e86fed3c43f4fd72$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e86fed3c43f4fd72$export$d5a552a76deda3c2, (v) => $e86fed3c43f4fd72$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e86fed3c43f4fd72$export$aaabe4eda9ed9969, (v) => $e86fed3c43f4fd72$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e86fed3c43f4fd72$export$e5c5a5f917a5871c, (v) => $e86fed3c43f4fd72$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e86fed3c43f4fd72$export$1538c33de8887b59, (v) => $e86fed3c43f4fd72$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $e86fed3c43f4fd72$export$13e3392192263954, (v) => $e86fed3c43f4fd72$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e86fed3c43f4fd72$export$b8f5890fc79d6aca, (v) => $e86fed3c43f4fd72$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e86fed3c43f4fd72$export$60241385465d0a34, (v) => $e86fed3c43f4fd72$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e86fed3c43f4fd72$export$306c0aa65ff9ec16, (v) => $e86fed3c43f4fd72$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e86fed3c43f4fd72$export$7b286972b8d8ccbf, (v) => $e86fed3c43f4fd72$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e86fed3c43f4fd72$export$83d89fbfd8236492, (v) => $e86fed3c43f4fd72$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e86fed3c43f4fd72$export$dca3b0875bd9a954;
var $e86fed3c43f4fd72$export$16fa2f45be04daa8;
var $e86fed3c43f4fd72$export$ffb0004e005737fa;
var $e86fed3c43f4fd72$export$e2c29f18771995cb;
var $e86fed3c43f4fd72$export$221d75b3f55bb0bd;
var $e86fed3c43f4fd72$export$5f8d39834fd61797;
var $e86fed3c43f4fd72$export$74bf444e3cd11ea5;
var $e86fed3c43f4fd72$export$ae55be85d98224ed;
var $e86fed3c43f4fd72$export$3ba232387fd5d6dd;
var $e86fed3c43f4fd72$export$e530037191fcd5d7;
var $e86fed3c43f4fd72$export$fd42f52fd3ae1109;
var $e86fed3c43f4fd72$export$c8a8987d4410bf2d;
var $e86fed3c43f4fd72$export$d38cd72104c1f0e9;
var $e86fed3c43f4fd72$export$7d1e3a5e95ceca43;
var $e86fed3c43f4fd72$export$257a8862b851cb5b;
var $e86fed3c43f4fd72$export$a8257692ac88316c;
var $e86fed3c43f4fd72$export$488013bae63b21da;
var $e86fed3c43f4fd72$export$7c73462e0d25e514;
var $e86fed3c43f4fd72$export$7568632d0d33d16d;
var $e86fed3c43f4fd72$export$88948ce120ea2619;
var $e86fed3c43f4fd72$export$35808ee640e87ca7;
var $e86fed3c43f4fd72$export$fae74005e78b1a27;
var $e86fed3c43f4fd72$export$dc8fbce3eb94dc1e;
var $e86fed3c43f4fd72$export$6a7bc4e911dc01cf;
var $e86fed3c43f4fd72$export$6d9c69b0de29b591;
var $e86fed3c43f4fd72$export$f680877a34711e37;
var $e86fed3c43f4fd72$export$d5a552a76deda3c2;
var $e86fed3c43f4fd72$export$aaabe4eda9ed9969;
var $e86fed3c43f4fd72$export$e5c5a5f917a5871c;
var $e86fed3c43f4fd72$export$1538c33de8887b59;
var $e86fed3c43f4fd72$export$13e3392192263954;
var $e86fed3c43f4fd72$export$b8f5890fc79d6aca;
var $e86fed3c43f4fd72$export$60241385465d0a34;
var $e86fed3c43f4fd72$export$306c0aa65ff9ec16;
var $e86fed3c43f4fd72$export$7b286972b8d8ccbf;
var $e86fed3c43f4fd72$export$83d89fbfd8236492;
'use strict';
var $e86fed3c43f4fd72$var$l = Symbol.for("react.element"), $e86fed3c43f4fd72$var$n = Symbol.for("react.portal"), $e86fed3c43f4fd72$var$p = Symbol.for("react.fragment"), $e86fed3c43f4fd72$var$q = Symbol.for("react.strict_mode"), $e86fed3c43f4fd72$var$r = Symbol.for("react.profiler"), $e86fed3c43f4fd72$var$t = Symbol.for("react.provider"), $e86fed3c43f4fd72$var$u = Symbol.for("react.context"), $e86fed3c43f4fd72$var$v = Symbol.for("react.forward_ref"), $e86fed3c43f4fd72$var$w = Symbol.for("react.suspense"), $e86fed3c43f4fd72$var$x = Symbol.for("react.memo"), $e86fed3c43f4fd72$var$y = Symbol.for("react.lazy"), $e86fed3c43f4fd72$var$z = Symbol.iterator;
function $e86fed3c43f4fd72$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e86fed3c43f4fd72$var$z && a[$e86fed3c43f4fd72$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e86fed3c43f4fd72$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e86fed3c43f4fd72$var$C = Object.assign, $e86fed3c43f4fd72$var$D = {};
function $e86fed3c43f4fd72$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e86fed3c43f4fd72$var$D;
    this.updater = e || $e86fed3c43f4fd72$var$B;
}
$e86fed3c43f4fd72$var$E.prototype.isReactComponent = {};
$e86fed3c43f4fd72$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e86fed3c43f4fd72$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e86fed3c43f4fd72$var$F() {}
$e86fed3c43f4fd72$var$F.prototype = $e86fed3c43f4fd72$var$E.prototype;
function $e86fed3c43f4fd72$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e86fed3c43f4fd72$var$D;
    this.updater = e || $e86fed3c43f4fd72$var$B;
}
var $e86fed3c43f4fd72$var$H = $e86fed3c43f4fd72$var$G.prototype = new $e86fed3c43f4fd72$var$F;
$e86fed3c43f4fd72$var$H.constructor = $e86fed3c43f4fd72$var$G;
$e86fed3c43f4fd72$var$C($e86fed3c43f4fd72$var$H, $e86fed3c43f4fd72$var$E.prototype);
$e86fed3c43f4fd72$var$H.isPureReactComponent = !0;
var $e86fed3c43f4fd72$var$I = Array.isArray, $e86fed3c43f4fd72$var$J = Object.prototype.hasOwnProperty, $e86fed3c43f4fd72$var$K = {
    current: null
}, $e86fed3c43f4fd72$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e86fed3c43f4fd72$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e86fed3c43f4fd72$var$J.call(b, d) && !$e86fed3c43f4fd72$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e86fed3c43f4fd72$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e86fed3c43f4fd72$var$K.current
    };
}
function $e86fed3c43f4fd72$var$N(a, b) {
    return {
        $$typeof: $e86fed3c43f4fd72$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e86fed3c43f4fd72$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e86fed3c43f4fd72$var$l;
}
function $e86fed3c43f4fd72$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e86fed3c43f4fd72$var$P = /\/+/g;
function $e86fed3c43f4fd72$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e86fed3c43f4fd72$var$escape("" + a.key) : b.toString(36);
}
function $e86fed3c43f4fd72$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e86fed3c43f4fd72$var$l:
                case $e86fed3c43f4fd72$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e86fed3c43f4fd72$var$Q(h, 0) : d, $e86fed3c43f4fd72$var$I(c) ? (e = "", null != a && (e = a.replace($e86fed3c43f4fd72$var$P, "$&/") + "/"), $e86fed3c43f4fd72$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e86fed3c43f4fd72$var$O(c) && (c = $e86fed3c43f4fd72$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e86fed3c43f4fd72$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e86fed3c43f4fd72$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e86fed3c43f4fd72$var$Q(k, g);
        h += $e86fed3c43f4fd72$var$R(k, b, e, f, c);
    }
    else if (f = $e86fed3c43f4fd72$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e86fed3c43f4fd72$var$Q(k, g++), h += $e86fed3c43f4fd72$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e86fed3c43f4fd72$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e86fed3c43f4fd72$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e86fed3c43f4fd72$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e86fed3c43f4fd72$var$U = {
    current: null
}, $e86fed3c43f4fd72$var$V = {
    transition: null
}, $e86fed3c43f4fd72$var$W = {
    ReactCurrentDispatcher: $e86fed3c43f4fd72$var$U,
    ReactCurrentBatchConfig: $e86fed3c43f4fd72$var$V,
    ReactCurrentOwner: $e86fed3c43f4fd72$var$K
};
function $e86fed3c43f4fd72$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e86fed3c43f4fd72$export$dca3b0875bd9a954 = {
    map: $e86fed3c43f4fd72$var$S,
    forEach: function(a, b, e) {
        $e86fed3c43f4fd72$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e86fed3c43f4fd72$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e86fed3c43f4fd72$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e86fed3c43f4fd72$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e86fed3c43f4fd72$export$16fa2f45be04daa8 = $e86fed3c43f4fd72$var$E;
$e86fed3c43f4fd72$export$ffb0004e005737fa = $e86fed3c43f4fd72$var$p;
$e86fed3c43f4fd72$export$e2c29f18771995cb = $e86fed3c43f4fd72$var$r;
$e86fed3c43f4fd72$export$221d75b3f55bb0bd = $e86fed3c43f4fd72$var$G;
$e86fed3c43f4fd72$export$5f8d39834fd61797 = $e86fed3c43f4fd72$var$q;
$e86fed3c43f4fd72$export$74bf444e3cd11ea5 = $e86fed3c43f4fd72$var$w;
$e86fed3c43f4fd72$export$ae55be85d98224ed = $e86fed3c43f4fd72$var$W;
$e86fed3c43f4fd72$export$3ba232387fd5d6dd = $e86fed3c43f4fd72$var$X;
$e86fed3c43f4fd72$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e86fed3c43f4fd72$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e86fed3c43f4fd72$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e86fed3c43f4fd72$var$J.call(b, f) && !$e86fed3c43f4fd72$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e86fed3c43f4fd72$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e86fed3c43f4fd72$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e86fed3c43f4fd72$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e86fed3c43f4fd72$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e86fed3c43f4fd72$export$c8a8987d4410bf2d = $e86fed3c43f4fd72$var$M;
$e86fed3c43f4fd72$export$d38cd72104c1f0e9 = function(a) {
    var b = $e86fed3c43f4fd72$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e86fed3c43f4fd72$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e86fed3c43f4fd72$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e86fed3c43f4fd72$var$v,
        render: a
    };
};
$e86fed3c43f4fd72$export$a8257692ac88316c = $e86fed3c43f4fd72$var$O;
$e86fed3c43f4fd72$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e86fed3c43f4fd72$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e86fed3c43f4fd72$var$T
    };
};
$e86fed3c43f4fd72$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e86fed3c43f4fd72$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e86fed3c43f4fd72$export$7568632d0d33d16d = function(a) {
    var b = $e86fed3c43f4fd72$var$V.transition;
    $e86fed3c43f4fd72$var$V.transition = {};
    try {
        a();
    } finally{
        $e86fed3c43f4fd72$var$V.transition = b;
    }
};
$e86fed3c43f4fd72$export$88948ce120ea2619 = $e86fed3c43f4fd72$var$X;
$e86fed3c43f4fd72$export$35808ee640e87ca7 = function(a, b) {
    return $e86fed3c43f4fd72$var$U.current.useCallback(a, b);
};
$e86fed3c43f4fd72$export$fae74005e78b1a27 = function(a) {
    return $e86fed3c43f4fd72$var$U.current.useContext(a);
};
$e86fed3c43f4fd72$export$dc8fbce3eb94dc1e = function() {};
$e86fed3c43f4fd72$export$6a7bc4e911dc01cf = function(a) {
    return $e86fed3c43f4fd72$var$U.current.useDeferredValue(a);
};
$e86fed3c43f4fd72$export$6d9c69b0de29b591 = function(a, b) {
    return $e86fed3c43f4fd72$var$U.current.useEffect(a, b);
};
$e86fed3c43f4fd72$export$f680877a34711e37 = function() {
    return $e86fed3c43f4fd72$var$U.current.useId();
};
$e86fed3c43f4fd72$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e86fed3c43f4fd72$var$U.current.useImperativeHandle(a, b, e);
};
$e86fed3c43f4fd72$export$aaabe4eda9ed9969 = function(a, b) {
    return $e86fed3c43f4fd72$var$U.current.useInsertionEffect(a, b);
};
$e86fed3c43f4fd72$export$e5c5a5f917a5871c = function(a, b) {
    return $e86fed3c43f4fd72$var$U.current.useLayoutEffect(a, b);
};
$e86fed3c43f4fd72$export$1538c33de8887b59 = function(a, b) {
    return $e86fed3c43f4fd72$var$U.current.useMemo(a, b);
};
$e86fed3c43f4fd72$export$13e3392192263954 = function(a, b, e) {
    return $e86fed3c43f4fd72$var$U.current.useReducer(a, b, e);
};
$e86fed3c43f4fd72$export$b8f5890fc79d6aca = function(a) {
    return $e86fed3c43f4fd72$var$U.current.useRef(a);
};
$e86fed3c43f4fd72$export$60241385465d0a34 = function(a) {
    return $e86fed3c43f4fd72$var$U.current.useState(a);
};
$e86fed3c43f4fd72$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e86fed3c43f4fd72$var$U.current.useSyncExternalStore(a, b, e);
};
$e86fed3c43f4fd72$export$7b286972b8d8ccbf = function() {
    return $e86fed3c43f4fd72$var$U.current.useTransition();
};
$e86fed3c43f4fd72$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("kpvjH", function(module, exports) {
$parcel$export(module.exports, "default", () => $65ad9c78f098186c$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $65ad9c78f098186c$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $65ad9c78f098186c$export$2e2bcd8739ae039 = $65ad9c78f098186c$var$isNonVisualStyleMutation;

});

parcelRegister("fZmuU", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $32a33c4390f72722$export$166779fc0f49d4df);
const $32a33c4390f72722$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $32a33c4390f72722$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$32a33c4390f72722$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$32a33c4390f72722$var$GLOBAL_RLL_HANDLERS_KEY] = new $32a33c4390f72722$export$166779fc0f49d4df();
            return globalThis[$32a33c4390f72722$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $32a33c4390f72722$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            var _el$dataset;
            if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("YC9EF", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $a26ee532d51dc75a$export$c0102f1a1198d10f);
const $a26ee532d51dc75a$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $a26ee532d51dc75a$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $a26ee532d51dc75a$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            var _el$dataset;
            const ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $a26ee532d51dc75a$var$PAGE_LAYOUT_ID) return $a26ee532d51dc75a$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            var _el$dataset2;
            const ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $a26ee532d51dc75a$var$PAGE_LAYOUT_ID) return $a26ee532d51dc75a$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            var _this$intersectionObs5;
            (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch  {}
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                var _window$__SSR_PLACEHO, _this$intersectionObs;
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $a26ee532d51dc75a$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $a26ee532d51dc75a$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $a26ee532d51dc75a$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $a26ee532d51dc75a$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs2;
                this.callbacks.set(id, resolve);
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            var _this$intersectionObs3;
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs4;
                this.reactValidateCallbacks.set(id, resolve);
                (_this$intersectionObs4 = this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});



parcelRegister("kuRpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b716cf0420102bf$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $5hPkM = parcelRequire("5hPkM");

var $9JxdC = parcelRequire("9JxdC");

var $jQYQa = parcelRequire("jQYQa");

var $YC9EF = parcelRequire("YC9EF");

var $86mbW = parcelRequire("86mbW");

var $lSCkw = parcelRequire("lSCkw");

var $72oWn = parcelRequire("72oWn");

var $2Gwlo = parcelRequire("2Gwlo");

var $2fgGw = parcelRequire("2fgGw");

var $c5ERi = parcelRequire("c5ERi");

var $avGTO = parcelRequire("avGTO");

var $di51S = parcelRequire("di51S");

var $fFngC = parcelRequire("fFngC");

var $97Z07 = parcelRequire("97Z07");
const $2b716cf0420102bf$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $2b716cf0420102bf$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $2b716cf0420102bf$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $2b716cf0420102bf$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $86mbW.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $5hPkM.getSelectorConfig)(config.selectorConfig, $2b716cf0420102bf$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $2b716cf0420102bf$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $YC9EF.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: ((_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) ?? false
            });
        }
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $fFngC.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    const labelStacks = $2b716cf0420102bf$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $97Z07.default)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $dRkX9.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $jQYQa.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                const abortEventTargetElement = $2b716cf0420102bf$var$isAbortEventTargetSupported(type) && event ? $2b716cf0420102bf$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
    start(_) {
        var _this$viewportObserve, _window, _this$windowEventObse;
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $2b716cf0420102bf$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
        this.entriesTimeline.clear();
        if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
    }
    stop() {
        var _this$viewportObserve2, _this$windowEventObse2;
        (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
        (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $2b716cf0420102bf$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $2fgGw.default)(),
                    width: (0, $c5ERi.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $2fgGw.default)(),
                    right: (0, $c5ERi.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $72oWn.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $5hPkM.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $2Gwlo.default)();
        const calculator_next = new (0, $avGTO.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $5hPkM.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $5hPkM.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $di51S.default)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $lSCkw.default)(this.selectorConfig, element);
    }
}
function $2b716cf0420102bf$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    const value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $2b716cf0420102bf$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $9JxdC.sanitizeLabelStackName)(label.name)).join('/');
}
function $2b716cf0420102bf$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $9JxdC.sanitizeLabelStackName)(label.name)).join('/');
}
function $2b716cf0420102bf$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $2b716cf0420102bf$var$labelStackFromFiber(currentFiber);
                labelStackString = $2b716cf0420102bf$var$labelStackToString(labelStack) || 'unknown';
                segment = $2b716cf0420102bf$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $2b716cf0420102bf$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $2b716cf0420102bf$var$traverseFiber(fiber) : null;
}
const $2b716cf0420102bf$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $2b716cf0420102bf$var$isAbortEventTargetSupported(type) {
    return $2b716cf0420102bf$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $2b716cf0420102bf$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("86mbW", function(module, exports) {
$parcel$export(module.exports, "default", () => $32c57a073431cc34$export$2e2bcd8739ae039);
class $32c57a073431cc34$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        var _this$sortedEntriesCa;
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("lSCkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $79a5039bb257dc1f$export$2e2bcd8739ae039);
const $79a5039bb257dc1f$var$nameCache = new WeakMap();
function $79a5039bb257dc1f$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $79a5039bb257dc1f$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $79a5039bb257dc1f$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $79a5039bb257dc1f$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $79a5039bb257dc1f$var$nameCache.set(element, name);
    return name;
}
var $79a5039bb257dc1f$export$2e2bcd8739ae039 = $79a5039bb257dc1f$var$getElementName;

});

parcelRegister("72oWn", function(module, exports) {
$parcel$export(module.exports, "default", () => $d78c62af2c108245$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $d2l22 = parcelRequire("d2l22");

var $caZx8 = parcelRequire("caZx8");

var $i9zB5 = parcelRequire("i9zB5");

var $fo65T = parcelRequire("fo65T");

var $bp1fT = parcelRequire("bp1fT");
const $d78c62af2c108245$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $d78c62af2c108245$var$REVISION_NO = 'fy25.03';
const $d78c62af2c108245$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $d78c62af2c108245$export$2e2bcd8739ae039 extends (0, $i9zB5.default) {
    constructor(revisionNo){
        super(revisionNo ?? $d78c62af2c108245$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$d78c62af2c108245$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $dRkX9.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $d2l22.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $d2l22.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $caZx8.containsAnchorNameMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $fo65T.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $fo65T.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $fo65T.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) || (0, $fo65T.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName)) return false;
            return true;
        }
        if ((0, $bp1fT.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($d78c62af2c108245$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("d2l22", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $0a1db31c5c90ca72$export$9db1624a8af791a4);

var $k2M4v = parcelRequire("k2M4v");

var $2Eign = parcelRequire("2Eign");
const $0a1db31c5c90ca72$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $k2M4v.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $k2M4v.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $2Eign.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("caZx8", function(module, exports) {
$parcel$export(module.exports, "containsAnchorNameMutationInStyle", () => $c7667441d25caa77$export$f83f33200c1a234e);
$parcel$export(module.exports, "default", () => $c7667441d25caa77$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");
/**
 * Matches only the editor drag and drop anchors. This is the pre-gate behaviour.
 */ const $c7667441d25caa77$var$isDnDAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name: --node-anchor');
};
/**
 * Matches any `anchor-name` declaration.
 *
 * `anchor-name` (CSS Anchor Positioning) only names an element so that _other_
 * elements can position themselves against it. It never changes how the named
 * element itself renders, so adding or removing it is never a visual change.
 *
 * `@atlaskit/top-layer` writes `anchor-name` onto a popover's trigger as soon as
 * the popover host element exists, which for `Popover`-based consumers is first
 * open (for example, hovering an `@atlaskit/tooltip` trigger). Without this
 * exclusion that write is recorded as a repaint of the trigger at hover time,
 * which shifts TTVC in sessions where a user hovers a trigger before the page
 * has settled. See COPPER-1736.
 */ const $c7667441d25caa77$var$isAnyAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name:');
};
const $c7667441d25caa77$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a `style` change that consists only
 * of `anchor-name` declarations being added or removed.
 *
 * Without `platform_ufo_exclude_anchor_name_from_ttvc` this is limited to the
 * editor's drag and drop anchors (`--node-anchor…`), which is where the check
 * originated. With the gate on, every `anchor-name` is treated as non-visual,
 * because the property never affects the rendering of the element it is set on.
 *
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is an anchor-name-only style mutation
 */ function $c7667441d25caa77$export$7a0b59cebcbf44ec({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $c7667441d25caa77$export$f83f33200c1a234e({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $c7667441d25caa77$export$f83f33200c1a234e({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    // Resolved once per mutation rather than once per declaration: this runs
    // inside the MutationObserver callback.
    const isIgnoredDeclaration = (0, $dRkX9.fg)('platform_ufo_exclude_anchor_name_from_ttvc') ? $c7667441d25caa77$var$isAnyAnchorNameDeclaration : $c7667441d25caa77$var$isDnDAnchorNameDeclaration;
    const oldStyles = $c7667441d25caa77$var$parseStyleSet(oldValue);
    const newStyles = $c7667441d25caa77$var$parseStyleSet(newValue);
    let isAnchorNameMutation = false;
    for (const s of oldStyles ?? [])if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    for (const s of newStyles ?? [])if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(s))) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    return isAnchorNameMutation;
}
var $c7667441d25caa77$export$2e2bcd8739ae039 = $c7667441d25caa77$export$7a0b59cebcbf44ec;

});

parcelRegister("i9zB5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e8a3b2ab1080213$export$2e2bcd8739ae039);

var $aBKNQ = parcelRequire("aBKNQ");

var $4vp5a = parcelRequire("4vp5a");

var $2fgGw = parcelRequire("2fgGw");

var $c5ERi = parcelRequire("c5ERi");

var $bp1fT = parcelRequire("bp1fT");
// Helper function for reporting ratios
function $1e8a3b2ab1080213$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $1e8a3b2ab1080213$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $c5ERi.default)();
        const viewportHeight = (0, $2fgGw.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $1e8a3b2ab1080213$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $bp1fT.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        var _window, _window2, _window3, _window4, _window6;
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $aBKNQ.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $c5ERi.default)(),
                height: (0, $2fgGw.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $4vp5a.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>{
                    var _entry$rect, _entry$previousRect;
                    return {
                        ...entry,
                        rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                        previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                    };
                }),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                var _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou;
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push({
                    ...viewportData,
                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
            var _window5, _window5$__ufo_devtoo;
            (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
            var _window7, _window7$__on_ufo_vc_;
            (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        var _vcDetails$;
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) ?? false,
                    dist: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) ?? false
                },
                total_mut: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) ?? 0,
                mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': (vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("aBKNQ", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $830d9c5779e124e6$export$96ea73435089b05a);

var $dRkX9 = parcelRequire("dRkX9");

var $2XkLa = parcelRequire("2XkLa");

var $1NKOo = parcelRequire("1NKOo");

var $4boWq = parcelRequire("4boWq");
async function $830d9c5779e124e6$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $4boWq.ViewportCanvas)(viewport, (0, $dRkX9.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return (0, $2XkLa.calculatePercentiles)(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $830d9c5779e124e6$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $4boWq.ViewportCanvas)(viewport, (0, $dRkX9.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return (0, $1NKOo.calculatePercentilesWithDebugInfo)(timePixelCounts, elementMap, totalPixels, startTime);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$830d9c5779e124e6$export$2e2bcd8739ae039 = $830d9c5779e124e6$var$calculateTTVCPercentiles;

});
parcelRegister("2XkLa", function(module, exports) {
$parcel$export(module.exports, "calculatePercentiles", () => $511dc5c25b3a4a44$export$89c8da9b65eff678);
function $511dc5c25b3a4a44$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}

});

parcelRegister("1NKOo", function(module, exports) {
$parcel$export(module.exports, "calculatePercentilesWithDebugInfo", () => $4158e846df1139f4$export$a532ce01ea38d882);
function $4158e846df1139f4$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});

parcelRegister("4boWq", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $dc7f3cac4b293b50$export$3e59ac9de7402fb1);

var $jWGjM = parcelRequire("jWGjM");

var $2VS45 = parcelRequire("2VS45");
class $dc7f3cac4b293b50$export$3e59ac9de7402fb1 {
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return (0, $2VS45.getRGBComponents)(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await (0, $jWGjM.calculateDrawnPixelsRaw)(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = (0, $2VS45.getRGBComponents)(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}

});
parcelRegister("jWGjM", function(module, exports) {
$parcel$export(module.exports, "calculateDrawnPixelsRaw", () => $be8c32253a8a3f67$export$fafc9be44839f9c8);

var $g10B2 = parcelRequire("g10B2");
async function $be8c32253a8a3f67$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $g10B2.default)();
    }
    return arr;
}

});
parcelRegister("g10B2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6d227b250865f7a$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $b6d227b250865f7a$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $b6d227b250865f7a$export$2e2bcd8739ae039 = $b6d227b250865f7a$var$taskYield;

});


parcelRegister("2VS45", function(module, exports) {
$parcel$export(module.exports, "getRGBComponents", () => $cde5ea2292d4d602$export$54591583ed0b20ce);
function $cde5ea2292d4d602$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}

});



parcelRegister("4vp5a", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $130537cbaed1ec47$export$93ce39b765ea2cd3);
const $130537cbaed1ec47$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $130537cbaed1ec47$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $130537cbaed1ec47$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $130537cbaed1ec47$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $130537cbaed1ec47$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $130537cbaed1ec47$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $130537cbaed1ec47$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $130537cbaed1ec47$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $130537cbaed1ec47$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("2fgGw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e315e5aec7a0d475$export$2e2bcd8739ae039);
function $e315e5aec7a0d475$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $e315e5aec7a0d475$export$2e2bcd8739ae039 = $e315e5aec7a0d475$var$getViewportHeight;

});

parcelRegister("c5ERi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b86fac7958bc4f12$export$2e2bcd8739ae039);
function $b86fac7958bc4f12$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $b86fac7958bc4f12$export$2e2bcd8739ae039 = $b86fac7958bc4f12$var$getViewportWidth;

});

parcelRegister("bp1fT", function(module, exports) {
$parcel$export(module.exports, "default", () => $65d6b416b2c1b87e$export$2e2bcd8739ae039);
function $65d6b416b2c1b87e$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $65d6b416b2c1b87e$export$2e2bcd8739ae039 = $65d6b416b2c1b87e$var$isViewportEntryData;

});


parcelRegister("fo65T", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $9ef31861f4ca3a0b$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $9ef31861f4ca3a0b$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $9ef31861f4ca3a0b$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $9ef31861f4ca3a0b$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $9ef31861f4ca3a0b$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $9ef31861f4ca3a0b$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $9ef31861f4ca3a0b$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $9ef31861f4ca3a0b$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $9ef31861f4ca3a0b$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $9ef31861f4ca3a0b$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("2Gwlo", function(module, exports) {
$parcel$export(module.exports, "default", () => $21d25ab13c2d10fe$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $72oWn = parcelRequire("72oWn");

var $fo65T = parcelRequire("fo65T");
const $21d25ab13c2d10fe$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $21d25ab13c2d10fe$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $21d25ab13c2d10fe$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $21d25ab13c2d10fe$export$2e2bcd8739ae039 extends (0, $72oWn.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$21d25ab13c2d10fe$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $21d25ab13c2d10fe$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $dRkX9.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $fo65T.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $fo65T.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $fo65T.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES)
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $fo65T.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $fo65T.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $21d25ab13c2d10fe$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("avGTO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4e746e243f5524d$export$2e2bcd8739ae039);

var $2Gwlo = parcelRequire("2Gwlo");
const $f4e746e243f5524d$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $f4e746e243f5524d$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $f4e746e243f5524d$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $f4e746e243f5524d$export$2e2bcd8739ae039 extends (0, $2Gwlo.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$f4e746e243f5524d$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $f4e746e243f5524d$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($f4e746e243f5524d$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("di51S", function(module, exports) {
$parcel$export(module.exports, "default", () => $64bf1564678a030d$export$2e2bcd8739ae039);

var $5hPkM = parcelRequire("5hPkM");

var $1N51K = parcelRequire("1N51K");

var $2fgGw = parcelRequire("2fgGw");

var $c5ERi = parcelRequire("c5ERi");
const $64bf1564678a030d$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $64bf1564678a030d$var$MAX_OBSERVATIONS = 200;
const $64bf1564678a030d$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $64bf1564678a030d$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $64bf1564678a030d$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $64bf1564678a030d$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($64bf1564678a030d$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $1N51K.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $c5ERi.default)(),
                h: (0, $2fgGw.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $64bf1564678a030d$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $64bf1564678a030d$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $64bf1564678a030d$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$64bf1564678a030d$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $64bf1564678a030d$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $64bf1564678a030d$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$64bf1564678a030d$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$64bf1564678a030d$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $5hPkM.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $c5ERi.default)(),
                h: (0, $2fgGw.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("fFngC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea600f2c536bcdb4$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $02Al1 = parcelRequire("02Al1");

var $caZx8 = parcelRequire("caZx8");

var $kpvjH = parcelRequire("kpvjH");

var $bbodb = parcelRequire("bbodb");

var $fZmuU = parcelRequire("fZmuU");

var $4Ru9v = parcelRequire("4Ru9v");

var $9XeIP = parcelRequire("9XeIP");

var $4xseh = parcelRequire("4xseh");

var $bOpzE = parcelRequire("bOpzE");

var $83Hlv = parcelRequire("83Hlv");

var $1N45R = parcelRequire("1N45R");

var $laXuG = parcelRequire("laXuG");

var $kqZD2 = parcelRequire("kqZD2");

var $56JSJ = parcelRequire("56JSJ");

var $eSNhp = parcelRequire("eSNhp");

var $3mcED = parcelRequire("3mcED");
const $ea600f2c536bcdb4$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $kqZD2.default)(target)) return 'mutation:remount';
        if ((0, $02Al1.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $kqZD2.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $fZmuU.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $eSNhp.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $ea600f2c536bcdb4$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $kqZD2.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $02Al1.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $kqZD2.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $fZmuU.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $eSNhp.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $ea600f2c536bcdb4$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $laXuG.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                var _this$getSSRState, _this$intersectionObs;
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $bOpzE.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $bOpzE.default)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $1N45R.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === ((_this$getSSRState = this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $ea600f2c536bcdb4$var$createElementMutationsWatcherNew : $ea600f2c536bcdb4$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $02Al1.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $bOpzE.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $bOpzE.default)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $1N45R.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $caZx8.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $kpvjH.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $bbodb.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $dRkX9.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $56JSJ.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $fZmuU.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $3mcED.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $eSNhp.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $4Ru9v.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $9XeIP.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $4xseh.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        var _this$mutationObserve, _this$performanceObse;
        if (this.isStarted) return;
        this.initializeObservers();
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
        if (!this.isStarted) return;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
        (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $83Hlv.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("bbodb", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eef53f62190455b$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $5eef53f62190455b$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $5eef53f62190455b$export$846396c2d8be3710 = 'data-drop-target-for-';
function $5eef53f62190455b$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($5eef53f62190455b$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($5eef53f62190455b$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("4Ru9v", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $9831127f01f5477e$export$c3799d33e0ae80a5);

var $jiwGq = parcelRequire("jiwGq");
function $9831127f01f5477e$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $9831127f01f5477e$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $jiwGq.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$9831127f01f5477e$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("jiwGq", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $3c4b5f76f363f2e8$export$80d6b07c2266a1c6);
function $3c4b5f76f363f2e8$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("9XeIP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6055b0ef3b5ec140$export$2e2bcd8739ae039);

var $d2l22 = parcelRequire("d2l22");
/**
 * Whether the node is a top-layer element (`[popover]` or `<dialog>`) that
 * contains `data-vc-oob` content. A top-layer flag group mounts its layer only
 * while a flag shows, so the layer is added and removed with its out-of-band
 * content. Only top-layer elements are searched, so ordinary nodes stay cheap
 * and are still counted.
 */ function $6055b0ef3b5ec140$var$isLayerContainingOutOfBandContent(node) {
    const isLayer = node.hasAttribute('popover') || node.localName === 'dialog';
    return isLayer && node.querySelector('[data-vc-oob]') !== null;
}
function $6055b0ef3b5ec140$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            const shouldExcludeOutOfBand = (0, $d2l22.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false);
            if (shouldExcludeOutOfBand) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes. With the experiment on, skip a top-layer element
                // that contains out-of-band content, such as a flag layer.
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement && !(shouldExcludeOutOfBand && $6055b0ef3b5ec140$var$isLayerContainingOutOfBandContent(node))) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement && !(shouldExcludeOutOfBand && $6055b0ef3b5ec140$var$isLayerContainingOutOfBandContent(node))) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $6055b0ef3b5ec140$export$2e2bcd8739ae039 = $6055b0ef3b5ec140$var$createMutationObserver;

});

parcelRegister("4xseh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6c68cdb75960c2$export$2e2bcd8739ae039);

var $dApgq = parcelRequire("dApgq");
function $1b6c68cdb75960c2$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: (0, $dApgq.convertPhysicalToLogicalResolution)(attr.currentRect),
                    previousRect: (0, $dApgq.convertPhysicalToLogicalResolution)(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1b6c68cdb75960c2$export$2e2bcd8739ae039 = $1b6c68cdb75960c2$var$createPerformanceObserver;

});
parcelRegister("dApgq", function(module, exports) {
$parcel$export(module.exports, "convertPhysicalToLogicalResolution", () => $636e8c04eef88981$export$5e3f54cad8cb65e2);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $636e8c04eef88981$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}

});


parcelRegister("bOpzE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f79b743c648cca2c$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $jR7cM = parcelRequire("jR7cM");

var $bCjGT = parcelRequire("bCjGT");

var $hVq7V = parcelRequire("hVq7V");

var $83Hlv = parcelRequire("83Hlv");

var $4HTR6 = parcelRequire("4HTR6");
const $f79b743c648cca2c$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $f79b743c648cca2c$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $f79b743c648cca2c$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $f79b743c648cca2c$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
const $f79b743c648cca2c$var$CLEANUP_THRESHOLD = 50;
function $f79b743c648cca2c$var$maybeCleanup(resultCache) {
    (0, $bCjGT.cacheCleanupState).callCount++;
    if ((0, $bCjGT.cacheCleanupState).callCount >= $f79b743c648cca2c$var$CLEANUP_THRESHOLD && (0, $jR7cM.default)(0.3)) (0, $83Hlv.cleanupCaches)(resultCache);
}
function $f79b743c648cca2c$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $f79b743c648cca2c$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $dRkX9.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $f79b743c648cca2c$var$NEW_DOM_WALK_MAX_LEVEL : $f79b743c648cca2c$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $f79b743c648cca2c$var$NEW_FIBER_WALK_MAX_LEVEL : $f79b743c648cca2c$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $4HTR6.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $hVq7V.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("bCjGT", function(module, exports) {
$parcel$export(module.exports, "cacheCleanupState", () => $2b609eb19941739c$export$2d67c094e7802413);
const $2b609eb19941739c$export$2d67c094e7802413 = {
    callCount: 0
};

});

parcelRegister("hVq7V", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d8b7e399f2c677$export$2e2bcd8739ae039);

var $jeUDF = parcelRequire("jeUDF");
function $b1d8b7e399f2c677$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $jeUDF.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $b1d8b7e399f2c677$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("jeUDF", function(module, exports) {
$parcel$export(module.exports, "default", () => $001856394437a22b$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $001856394437a22b$export$2e2bcd8739ae039(fiber) {
    const type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("83Hlv", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $4faaac17467ba3c1$export$6a35c3789c327630);

var $bCjGT = parcelRequire("bCjGT");
function $4faaac17467ba3c1$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    (0, $bCjGT.cacheCleanupState).callCount = 0;
    return resultCache;
}

});

parcelRegister("4HTR6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3293576512bc1e42$export$2e2bcd8739ae039);

var $j7zBK = parcelRequire("j7zBK");
function $3293576512bc1e42$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $j7zBK.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("j7zBK", function(module, exports) {
$parcel$export(module.exports, "default", () => $9697e855626206f9$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $9697e855626206f9$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("1N45R", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $1f552b8f492b8da3$export$16c2770458939f21);

var $j5N6B = parcelRequire("j5N6B");
function $1f552b8f492b8da3$export$16c2770458939f21(node) {
    const doc = (0, $j5N6B.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("j5N6B", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $5e8879e612af5795$export$f65ca476c09acec0);
const $5e8879e612af5795$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("laXuG", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $e66764340702c91c$export$e989c0fffaa6b27a);
function $e66764340702c91c$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("kqZD2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2cd8b8087783ac4$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $f2cd8b8087783ac4$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $f2cd8b8087783ac4$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("56JSJ", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $02b1d33236dcc896$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $02b1d33236dcc896$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("eSNhp", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $fb12dbedd29ddca0$export$fde63bc968551821);
const $fb12dbedd29ddca0$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $fb12dbedd29ddca0$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $fb12dbedd29ddca0$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $fb12dbedd29ddca0$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $fb12dbedd29ddca0$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $fb12dbedd29ddca0$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("3mcED", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $1e045a0c9169062d$export$597b41700f7dcd36);
const $1e045a0c9169062d$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $1e045a0c9169062d$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $1e045a0c9169062d$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $1e045a0c9169062d$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("97Z07", function(module, exports) {
$parcel$export(module.exports, "default", () => $553f14bc15ae4247$export$2e2bcd8739ae039);

var $6Zi52 = parcelRequire("6Zi52");
class $553f14bc15ae4247$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $6Zi52.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $6Zi52.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});




parcelRegister("2N1Hu", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $8f1c8452653340fc$export$cc97b17ef9aeb088);
const $8f1c8452653340fc$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("33Vnw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed6b20d54c59dd04$export$2e2bcd8739ae039);

var $5hPkM = parcelRequire("5hPkM");

var $1N51K = parcelRequire("1N51K");

var $2gz56 = parcelRequire("2gz56");
const $ed6b20d54c59dd04$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $ed6b20d54c59dd04$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $2gz56.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        var _this$vcObserver;
        (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        var _this$vcObserver2;
        (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        var _this$reactProfilerTi;
        return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            var _this$vcObserver3;
            this.reset();
            (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
            return;
        }
        const pageVisibilityState = (0, $1N51K.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $5hPkM.getConfig)();
        const postInteractionFinishVCResult = await ((_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
            includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        }));
        (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        var _getConfig;
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = ((_getConfig = (0, $5hPkM.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $ed6b20d54c59dd04$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
   * Basic info about interaction that has just finished
   */ this.lastInteractionFinish = null;
        /**
   * Array of observed react render timings
   */ this.reactProfilerTimings = [];
        /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
   * Handler function to process / send the observation data
   */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("6LH8a", function(module, exports) {
$parcel$export(module.exports, "getMetaData", () => $49fbcb3409a807b8$export$929b5cc2a4ac0922);
$parcel$export(module.exports, "getMeta", () => $49fbcb3409a807b8$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getMetaFromHTML", () => $49fbcb3409a807b8$export$5a64793485e318f6);
$parcel$export(module.exports, "setHTMLMeta", () => $49fbcb3409a807b8$export$11f8d00783d7fcf3);
$parcel$export(module.exports, "getCloudId", () => $49fbcb3409a807b8$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getActivationId", () => $49fbcb3409a807b8$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getHelpCenterAri", () => $49fbcb3409a807b8$export$5b6c1ffe6316b179);
$parcel$export(module.exports, "getWorkspaceAri", () => $49fbcb3409a807b8$export$8e2de40963827c80);
$parcel$export(module.exports, "getLayoutAri", () => $49fbcb3409a807b8$export$b6b5277467022679);
$parcel$export(module.exports, "isValidLayoutAriPresent", () => $49fbcb3409a807b8$export$7a9c037572667aa1);
$parcel$export(module.exports, "addMetaToHead", () => $49fbcb3409a807b8$export$9e7e16a3dbced495);

var $him7m = parcelRequire("him7m");
var $49fbcb3409a807b8$var$EnvType = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}($49fbcb3409a807b8$var$EnvType || {});
const $49fbcb3409a807b8$var$requiredMetaTags = {
    'account-id': 'accountId',
    'ajs-user-locale': 'userLocale',
    'ajs-account-type': 'accountType',
    'ajs-sdPluginVersion': 'sdPluginVersion',
    'ajs-context-path': 'contextPath',
    environment: 'environment',
    'tenant-id': 'tenantId',
    'activation-id': 'activationId',
    'help-center-ari': 'helpCenterARI',
    'home-page-layout-ari': 'homePageLayoutARI'
};
const $49fbcb3409a807b8$export$929b5cc2a4ac0922 = ()=>{
    const metaData = {};
    Object.entries($49fbcb3409a807b8$var$requiredMetaTags).forEach(([key, name])=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        metaData[name] = $49fbcb3409a807b8$export$c47913ca32a5c6f7(key);
    });
    return Object.freeze(metaData);
};
function $49fbcb3409a807b8$export$5a64793485e318f6(name) {
    const metaElement = (0, $him7m.default).querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}
function $49fbcb3409a807b8$export$c47913ca32a5c6f7(name) {
    return $49fbcb3409a807b8$export$5a64793485e318f6(name);
}
const $49fbcb3409a807b8$export$11f8d00783d7fcf3 = (name, value)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let node = document.querySelector(`meta[name="${name}"]`);
    if (!node) {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        node = document.createElement('meta');
        node.setAttribute('name', name);
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.head.appendChild(node);
    }
    node.setAttribute('content', value);
};
const $49fbcb3409a807b8$export$fdd2c0ba94025c3c = ()=>{
    return $49fbcb3409a807b8$export$c47913ca32a5c6f7('tenant-id') || '';
};
const $49fbcb3409a807b8$export$3ad4bb31a1816ff6 = ()=>$49fbcb3409a807b8$export$c47913ca32a5c6f7('activation-id') ?? '';
const $49fbcb3409a807b8$export$5b6c1ffe6316b179 = ()=>{
    return $49fbcb3409a807b8$export$c47913ca32a5c6f7('help-center-ari') || '';
};
const $49fbcb3409a807b8$export$8e2de40963827c80 = ()=>{
    return $49fbcb3409a807b8$export$c47913ca32a5c6f7('jira-workspace-ari') || '';
};
const $49fbcb3409a807b8$export$b6b5277467022679 = ()=>{
    return $49fbcb3409a807b8$export$c47913ca32a5c6f7('home-page-layout-ari') || '';
};
const $49fbcb3409a807b8$export$7a9c037572667aa1 = ()=>{
    const layoutAri = $49fbcb3409a807b8$export$b6b5277467022679();
    return layoutAri !== '' && layoutAri !== 'null';
};
const $49fbcb3409a807b8$export$9e7e16a3dbced495 = (name, value)=>{
    var _document$head;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const existingMetaTag = document.querySelector(`meta[name="${name}"]`);
    if ((existingMetaTag === null || existingMetaTag === void 0 ? void 0 : existingMetaTag.getAttribute('content')) === value) return;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const metaTag = existingMetaTag || document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', value);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (_document$head = document.head) === null || _document$head === void 0 || _document$head.insertBefore(metaTag, document.head.childNodes[0]);
};

});
parcelRegister("him7m", function(module, exports) {
$parcel$export(module.exports, "default", () => $2761bcfd7745443f$export$2e2bcd8739ae039);
class $2761bcfd7745443f$export$6e283cdda5461374 {
    constructor(){
        this.store = {
            elements: {}
        };
        this.parsedHTML = null;
    }
    startup(parsedHTML) {
        this.parsedHTML = parsedHTML;
    }
    isRunningInSnapvmRuntime() {
        return typeof window === 'undefined';
    }
    getDataRef() {
        if (this.isRunningInSnapvmRuntime()) return this.parsedHTML;
        // Set to document when not in SnapVM runtime (Classic and Client side render cases)
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        return document;
    }
    getElementById(elementId) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementById(elementId);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementById');
        return null;
    }
    querySelector(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelector(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelector');
        return null;
    }
    querySelectorAll(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelectorAll(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelectorAll');
        return [];
    }
    getElementsByTagName(tagName) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementsByTagName(tagName);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementsByTagName');
        return [];
    }
    addClassName(elementName, className) {
        if (this.isRunningInSnapvmRuntime()) {
            if (!this.store.elements[elementName]) this.store.elements[elementName] = {
                classList: []
            };
            this.store.elements[elementName].classList.push(className);
            return;
        }
        if (elementName === 'body') {
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.body.classList.add(className);
            return;
        }
        // oxlint-disable-next-line no-console
        console.warn('invalid elementName sent to addClassName. elementName: ', elementName);
    }
    getStore() {
        return this.store;
    }
}
const $2761bcfd7745443f$var$clientServerBridge = new $2761bcfd7745443f$export$6e283cdda5461374();
var $2761bcfd7745443f$export$2e2bcd8739ae039 = $2761bcfd7745443f$var$clientServerBridge;

});


parcelRegister("66jVy", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $9b99d925968f7b3c$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $9b99d925968f7b3c$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $9b99d925968f7b3c$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $9b99d925968f7b3c$export$a3271f53e91faab7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $9b99d925968f7b3c$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $9b99d925968f7b3c$var$pressureRecordBuffer = [];
let $9b99d925968f7b3c$var$pressureObserver = null;
let $9b99d925968f7b3c$var$memoryRecordBuffer = [];
let $9b99d925968f7b3c$var$memoryInterval;
function $9b99d925968f7b3c$export$6c1060bed5fea050() {
    $9b99d925968f7b3c$var$pressureRecordBuffer.length = 0;
}
function $9b99d925968f7b3c$export$aa672c7221b183b0() {
    $9b99d925968f7b3c$var$memoryRecordBuffer.length = 0;
}
function $9b99d925968f7b3c$export$ec86686c1d2e65bc(filter) {
    $9b99d925968f7b3c$var$pressureRecordBuffer = $9b99d925968f7b3c$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $9b99d925968f7b3c$export$c0142ac82f5d0c28(filter) {
    $9b99d925968f7b3c$var$memoryRecordBuffer = $9b99d925968f7b3c$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $9b99d925968f7b3c$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $9b99d925968f7b3c$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $9b99d925968f7b3c$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $9b99d925968f7b3c$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $9b99d925968f7b3c$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $9b99d925968f7b3c$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $9b99d925968f7b3c$var$convertBytesToMegabytes($9b99d925968f7b3c$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $9b99d925968f7b3c$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $9b99d925968f7b3c$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $9b99d925968f7b3c$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $9b99d925968f7b3c$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $9b99d925968f7b3c$var$pressureObserver = new PressureObserver((records)=>{
                if ($9b99d925968f7b3c$var$pressureRecordBuffer.length + records.length <= $9b99d925968f7b3c$var$BUFFER_MAX_LENGTH) $9b99d925968f7b3c$var$pressureRecordBuffer.push(...records);
            });
            $9b99d925968f7b3c$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $9b99d925968f7b3c$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $9b99d925968f7b3c$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($9b99d925968f7b3c$var$memoryRecordBuffer.length <= $9b99d925968f7b3c$var$BUFFER_MAX_LENGTH) $9b99d925968f7b3c$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $9b99d925968f7b3c$export$10899ada382f2ae3() {
    clearInterval($9b99d925968f7b3c$var$memoryInterval);
}
function $9b99d925968f7b3c$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $9b99d925968f7b3c$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("f4Vz4", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $61f69d0895d54eca$export$b6ac780db3a3cc77);
parcelRequire("6BNHY");
var $hMg06 = parcelRequire("hMg06");

var $dRkX9 = parcelRequire("dRkX9");

var $gX41G = parcelRequire("gX41G");

var $cagIi = parcelRequire("cagIi");

var $fagaO = parcelRequire("fagaO");

var $4rFZM = parcelRequire("4rFZM");
function $61f69d0895d54eca$export$b6ac780db3a3cc77() {
    if ((0, $dRkX9.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $hMg06.context).active().getValue((0, $4rFZM.traceIdKey))),
            spanId: String((0, $hMg06.context).active().getValue((0, $cagIi.spanIdKey))),
            type: String((0, $hMg06.context).active().getValue((0, $gX41G.experienceTypeKey)))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return (0, $fagaO.state).context || undefined;
}

});
parcelRegister("6BNHY", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("hMg06")).context);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $fgh8a = parcelRequire("fgh8a");















var $hMg06 = parcelRequire("hMg06");

var $efBs7 = parcelRequire("efBs7");

var $aokQp = parcelRequire("aokQp");

var $cIbPg = parcelRequire("cIbPg");

var $bkzBY = parcelRequire("bkzBY");
var // Default export.
$4cfcc1c9ce9d30ef$export$2e2bcd8739ae039 = {
    context: $hMg06.context,
    diag: $efBs7.diag,
    metrics: $aokQp.metrics,
    propagation: $cIbPg.propagation,
    trace: $bkzBY.trace
};

});
parcelRegister("hMg06", function(module, exports) {
$parcel$export(module.exports, "context", () => $cf1354c826bbf70f$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $eIvfu = parcelRequire("eIvfu");
const $cf1354c826bbf70f$export$a078c61943f9dbbe = (0, $eIvfu.ContextAPI).getInstance();

});
parcelRegister("eIvfu", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $ab6d6a243264fdd8$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $6spcb = parcelRequire("6spcb");

var $9cIHP = parcelRequire("9cIHP");

var $dxZVW = parcelRequire("dxZVW");
const $ab6d6a243264fdd8$var$API_NAME = 'context';
const $ab6d6a243264fdd8$var$NOOP_CONTEXT_MANAGER = new (0, $6spcb.NoopContextManager)();
class $ab6d6a243264fdd8$export$4148866f0a453927 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Context API */ static getInstance() {
        if (!this._instance) this._instance = new $ab6d6a243264fdd8$export$4148866f0a453927();
        return this._instance;
    }
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ setGlobalContextManager(contextManager) {
        return (0, $9cIHP.registerGlobal)($ab6d6a243264fdd8$var$API_NAME, contextManager, (0, $dxZVW.DiagAPI).instance());
    }
    /**
     * Get the currently active context
     */ active() {
        return this._getContextManager().active();
    }
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        return this._getContextManager().with(context, fn, thisArg, ...args);
    }
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ bind(context, target) {
        return this._getContextManager().bind(context, target);
    }
    _getContextManager() {
        return (0, $9cIHP.getGlobal)($ab6d6a243264fdd8$var$API_NAME) || $ab6d6a243264fdd8$var$NOOP_CONTEXT_MANAGER;
    }
    /** Disable and remove the global context manager */ disable() {
        this._getContextManager().disable();
        (0, $9cIHP.unregisterGlobal)($ab6d6a243264fdd8$var$API_NAME, (0, $dxZVW.DiagAPI).instance());
    }
}

});
parcelRegister("6spcb", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $4b38e6e88fb55005$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $fgh8a = parcelRequire("fgh8a");
class $4b38e6e88fb55005$export$a27e5df35d1539a6 {
    active() {
        return 0, $fgh8a.ROOT_CONTEXT;
    }
    with(_context, fn, thisArg, ...args) {
        return fn.call(thisArg, ...args);
    }
    bind(_context, target) {
        return target;
    }
    enable() {
        return this;
    }
    disable() {
        return this;
    }
}

});

parcelRegister("9cIHP", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $6b37e9b60e36ef88$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $6b37e9b60e36ef88$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $6b37e9b60e36ef88$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $ipr6i = parcelRequire("ipr6i");

var $7Uitr = parcelRequire("7Uitr");
const $6b37e9b60e36ef88$var$major = (0, $ipr6i.VERSION).split('.')[0];
const $6b37e9b60e36ef88$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for(`opentelemetry.js.api.${$6b37e9b60e36ef88$var$major}`);
const $6b37e9b60e36ef88$var$_global = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};
function $6b37e9b60e36ef88$export$d586ae880b433238(type, instance, diag, allowOverride = false) {
    var _a;
    const api = $6b37e9b60e36ef88$var$_global[$6b37e9b60e36ef88$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $6b37e9b60e36ef88$var$_global[$6b37e9b60e36ef88$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $ipr6i.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        const err = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $ipr6i.VERSION)) {
        // All registered APIs must be of the same version exactly
        const err = new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${(0, $ipr6i.VERSION)}`);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug(`@opentelemetry/api: Registered a global for ${type} v${(0, $ipr6i.VERSION)}.`);
    return true;
}
function $6b37e9b60e36ef88$export$a4e55266d2135a7f(type) {
    var _a, _b;
    const globalVersion = (_a = $6b37e9b60e36ef88$var$_global[$6b37e9b60e36ef88$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $7Uitr.isCompatible)(globalVersion)) return;
    return (_b = $6b37e9b60e36ef88$var$_global[$6b37e9b60e36ef88$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $6b37e9b60e36ef88$export$d42ac835f38d1fb2(type, diag) {
    diag.debug(`@opentelemetry/api: Unregistering a global for ${type} v${(0, $ipr6i.VERSION)}.`);
    const api = $6b37e9b60e36ef88$var$_global[$6b37e9b60e36ef88$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("ipr6i", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $d66f956a9ccedcc8$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $d66f956a9ccedcc8$export$a4ad2735b021c132 = '1.9.1';

});

parcelRegister("7Uitr", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $5c1c17e74ad0437d$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $ipr6i = parcelRequire("ipr6i");
const $5c1c17e74ad0437d$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $5c1c17e74ad0437d$export$a5733a4d26a1ec61(ownVersion) {
    const acceptedVersions = new Set([
        ownVersion
    ]);
    const rejectedVersions = new Set();
    const myVersionMatch = ownVersion.match($5c1c17e74ad0437d$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return ()=>false;
    const ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        const globalVersionMatch = globalVersion.match($5c1c17e74ad0437d$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        const globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
const $5c1c17e74ad0437d$export$7fc0d8c3ab188c4c = $5c1c17e74ad0437d$export$a5733a4d26a1ec61((0, $ipr6i.VERSION));

});


parcelRegister("dxZVW", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $9dce66221a6e9fbf$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $38IvZ = parcelRequire("38IvZ");

var $jUmSl = parcelRequire("jUmSl");

var $MaYhf = parcelRequire("MaYhf");

var $9cIHP = parcelRequire("9cIHP");
const $9dce66221a6e9fbf$var$API_NAME = 'diag';
class $9dce66221a6e9fbf$export$5c8937ffc688cfd3 {
    /** Get the singleton instance of the DiagAPI API */ static instance() {
        if (!this._instance) this._instance = new $9dce66221a6e9fbf$export$5c8937ffc688cfd3();
        return this._instance;
    }
    /**
     * Private internal constructor
     * @private
     */ constructor(){
        function _logProxy(funcName) {
            return function(...args) {
                const logger = (0, $9cIHP.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName](...args);
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        const self = this;
        // DiagAPI specific functions
        const setLogger = (logger, optionsOrLogLevel = {
            logLevel: (0, $MaYhf.DiagLogLevel).INFO
        })=>{
            var _a, _b, _c;
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                const err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            const oldLogger = (0, $9cIHP.getGlobal)('diag');
            const newLogger = (0, $jUmSl.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $MaYhf.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                const stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn(`Current logger will be overwritten from ${stack}`);
                newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
            }
            return (0, $9cIHP.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = ()=>{
            (0, $9cIHP.unregisterGlobal)($9dce66221a6e9fbf$var$API_NAME, self);
        };
        self.createComponentLogger = (options)=>{
            return new (0, $38IvZ.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
}

});
parcelRegister("38IvZ", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $2494a632955c31b2$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9cIHP = parcelRequire("9cIHP");
class $2494a632955c31b2$export$b4bccc12f5b13129 {
    constructor(props){
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    debug(...args) {
        return $2494a632955c31b2$var$logProxy('debug', this._namespace, args);
    }
    error(...args) {
        return $2494a632955c31b2$var$logProxy('error', this._namespace, args);
    }
    info(...args) {
        return $2494a632955c31b2$var$logProxy('info', this._namespace, args);
    }
    warn(...args) {
        return $2494a632955c31b2$var$logProxy('warn', this._namespace, args);
    }
    verbose(...args) {
        return $2494a632955c31b2$var$logProxy('verbose', this._namespace, args);
    }
}
function $2494a632955c31b2$var$logProxy(funcName, namespace, args) {
    const logger = (0, $9cIHP.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    return logger[funcName](namespace, ...args);
}

});

parcelRegister("jUmSl", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $e7e4fde41e46946f$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $MaYhf = parcelRequire("MaYhf");
function $e7e4fde41e46946f$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $MaYhf.DiagLogLevel).NONE) maxLevel = (0, $MaYhf.DiagLogLevel).NONE;
    else if (maxLevel > (0, $MaYhf.DiagLogLevel).ALL) maxLevel = (0, $MaYhf.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        const theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $MaYhf.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $MaYhf.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $MaYhf.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $MaYhf.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $MaYhf.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("MaYhf", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $090cfe76bd1fac8b$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $090cfe76bd1fac8b$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($090cfe76bd1fac8b$export$b7d7b4c0f3c95263 || ($090cfe76bd1fac8b$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("efBs7", function(module, exports) {
$parcel$export(module.exports, "diag", () => $a5ff84b406699234$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $dxZVW = parcelRequire("dxZVW");
const $a5ff84b406699234$export$c042e7c2f59bc046 = (0, $dxZVW.DiagAPI).instance();

});

parcelRegister("aokQp", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $790c5083df4cb650$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $iIhwD = parcelRequire("iIhwD");
const $790c5083df4cb650$export$b0c5c2fac8144e54 = (0, $iIhwD.MetricsAPI).getInstance();

});
parcelRegister("iIhwD", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $d9f9ee357318c8bf$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $dVQFH = parcelRequire("dVQFH");

var $9cIHP = parcelRequire("9cIHP");

var $dxZVW = parcelRequire("dxZVW");
const $d9f9ee357318c8bf$var$API_NAME = 'metrics';
class $d9f9ee357318c8bf$export$1339f6eb6111c638 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Metrics API */ static getInstance() {
        if (!this._instance) this._instance = new $d9f9ee357318c8bf$export$1339f6eb6111c638();
        return this._instance;
    }
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ setGlobalMeterProvider(provider) {
        return (0, $9cIHP.registerGlobal)($d9f9ee357318c8bf$var$API_NAME, provider, (0, $dxZVW.DiagAPI).instance());
    }
    /**
     * Returns the global meter provider.
     */ getMeterProvider() {
        return (0, $9cIHP.getGlobal)($d9f9ee357318c8bf$var$API_NAME) || (0, $dVQFH.NOOP_METER_PROVIDER);
    }
    /**
     * Returns a meter from the global meter provider.
     */ getMeter(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    }
    /** Remove the global meter provider */ disable() {
        (0, $9cIHP.unregisterGlobal)($d9f9ee357318c8bf$var$API_NAME, (0, $dxZVW.DiagAPI).instance());
    }
}

});
parcelRegister("dVQFH", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $a24974b1e3b30248$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $1N8yR = parcelRequire("1N8yR");
class $a24974b1e3b30248$export$51c513ea08316108 {
    getMeter(_name, _version, _options) {
        return 0, $1N8yR.NOOP_METER;
    }
}
const $a24974b1e3b30248$export$d21fe83355c56e18 = new $a24974b1e3b30248$export$51c513ea08316108();

});
parcelRegister("1N8yR", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $14e10225a216b125$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ class $14e10225a216b125$export$c23c6f85dd4fc1e9 {
    constructor(){}
    /**
     * @see {@link Meter.createGauge}
     */ createGauge(_name, _options) {
        return $14e10225a216b125$export$dd01300aacbcec1c;
    }
    /**
     * @see {@link Meter.createHistogram}
     */ createHistogram(_name, _options) {
        return $14e10225a216b125$export$689c32a6a552e1a6;
    }
    /**
     * @see {@link Meter.createCounter}
     */ createCounter(_name, _options) {
        return $14e10225a216b125$export$e6d19fe5233efc54;
    }
    /**
     * @see {@link Meter.createUpDownCounter}
     */ createUpDownCounter(_name, _options) {
        return $14e10225a216b125$export$2f189cd99d2b7429;
    }
    /**
     * @see {@link Meter.createObservableGauge}
     */ createObservableGauge(_name, _options) {
        return $14e10225a216b125$export$ea67e3c6ff624776;
    }
    /**
     * @see {@link Meter.createObservableCounter}
     */ createObservableCounter(_name, _options) {
        return $14e10225a216b125$export$163422b94c3edbcb;
    }
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ createObservableUpDownCounter(_name, _options) {
        return $14e10225a216b125$export$5b8be9ab17b673b3;
    }
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ addBatchObservableCallback(_callback, _observables) {}
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ removeBatchObservableCallback(_callback) {}
}
class $14e10225a216b125$export$834a616d1cf278b {
}
class $14e10225a216b125$export$b556ba0f560c45b extends $14e10225a216b125$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $14e10225a216b125$export$df09a35db160df98 extends $14e10225a216b125$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $14e10225a216b125$export$b7f4a3c7ea16c24 extends $14e10225a216b125$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $14e10225a216b125$export$ef064c3e0426c607 extends $14e10225a216b125$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $14e10225a216b125$export$a5a3e7829c289482 {
    addCallback(_callback) {}
    removeCallback(_callback) {}
}
class $14e10225a216b125$export$7a7e4b169d5c93a8 extends $14e10225a216b125$export$a5a3e7829c289482 {
}
class $14e10225a216b125$export$6990a2f90809ffc1 extends $14e10225a216b125$export$a5a3e7829c289482 {
}
class $14e10225a216b125$export$3ec3555bc6f693a4 extends $14e10225a216b125$export$a5a3e7829c289482 {
}
const $14e10225a216b125$export$65e277d35235a01f = new $14e10225a216b125$export$c23c6f85dd4fc1e9();
const $14e10225a216b125$export$e6d19fe5233efc54 = new $14e10225a216b125$export$b556ba0f560c45b();
const $14e10225a216b125$export$dd01300aacbcec1c = new $14e10225a216b125$export$b7f4a3c7ea16c24();
const $14e10225a216b125$export$689c32a6a552e1a6 = new $14e10225a216b125$export$ef064c3e0426c607();
const $14e10225a216b125$export$2f189cd99d2b7429 = new $14e10225a216b125$export$df09a35db160df98();
const $14e10225a216b125$export$163422b94c3edbcb = new $14e10225a216b125$export$7a7e4b169d5c93a8();
const $14e10225a216b125$export$ea67e3c6ff624776 = new $14e10225a216b125$export$6990a2f90809ffc1();
const $14e10225a216b125$export$5b8be9ab17b673b3 = new $14e10225a216b125$export$3ec3555bc6f693a4();
function $14e10225a216b125$export$bc3a498ccbb5c2b5() {
    return $14e10225a216b125$export$65e277d35235a01f;
}

});




parcelRegister("cIbPg", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $9412c4724bd8b69d$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $3JGnW = parcelRequire("3JGnW");
const $9412c4724bd8b69d$export$3e49040daa9dba20 = (0, $3JGnW.PropagationAPI).getInstance();

});
parcelRegister("3JGnW", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $2b8673dcd3b6c34f$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9cIHP = parcelRequire("9cIHP");

var $15Wno = parcelRequire("15Wno");

var $iTBI6 = parcelRequire("iTBI6");

var $6wbMD = parcelRequire("6wbMD");

var $106wL = parcelRequire("106wL");

var $dxZVW = parcelRequire("dxZVW");
const $2b8673dcd3b6c34f$var$API_NAME = 'propagation';
const $2b8673dcd3b6c34f$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $15Wno.NoopTextMapPropagator)();
class $2b8673dcd3b6c34f$export$471eda0a6213cac9 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this.createBaggage = (0, $106wL.createBaggage);
        this.getBaggage = (0, $6wbMD.getBaggage);
        this.getActiveBaggage = (0, $6wbMD.getActiveBaggage);
        this.setBaggage = (0, $6wbMD.setBaggage);
        this.deleteBaggage = (0, $6wbMD.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ static getInstance() {
        if (!this._instance) this._instance = new $2b8673dcd3b6c34f$export$471eda0a6213cac9();
        return this._instance;
    }
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ setGlobalPropagator(propagator) {
        return (0, $9cIHP.registerGlobal)($2b8673dcd3b6c34f$var$API_NAME, propagator, (0, $dxZVW.DiagAPI).instance());
    }
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ inject(context, carrier, setter = (0, $iTBI6.defaultTextMapSetter)) {
        return this._getGlobalPropagator().inject(context, carrier, setter);
    }
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ extract(context, carrier, getter = (0, $iTBI6.defaultTextMapGetter)) {
        return this._getGlobalPropagator().extract(context, carrier, getter);
    }
    /**
     * Return a list of all fields which may be used by the propagator.
     */ fields() {
        return this._getGlobalPropagator().fields();
    }
    /** Remove the global propagator */ disable() {
        (0, $9cIHP.unregisterGlobal)($2b8673dcd3b6c34f$var$API_NAME, (0, $dxZVW.DiagAPI).instance());
    }
    _getGlobalPropagator() {
        return (0, $9cIHP.getGlobal)($2b8673dcd3b6c34f$var$API_NAME) || $2b8673dcd3b6c34f$var$NOOP_TEXT_MAP_PROPAGATOR;
    }
}

});
parcelRegister("15Wno", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $0cc38a606e93e0f1$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ class $0cc38a606e93e0f1$export$8356c7eb3af7963b {
    /** Noop inject function does nothing */ inject(_context, _carrier) {}
    /** Noop extract function does nothing and returns the input context */ extract(context, _carrier) {
        return context;
    }
    fields() {
        return [];
    }
}

});

parcelRegister("iTBI6", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $dc1a9d86c9f95764$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $dc1a9d86c9f95764$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ const $dc1a9d86c9f95764$export$a0f575f55f38720a = {
    get (carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys (carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
const $dc1a9d86c9f95764$export$f70f1d111fccf1c1 = {
    set (carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("6wbMD", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $4beedf33e339cff1$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $4beedf33e339cff1$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $4beedf33e339cff1$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $4beedf33e339cff1$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $eIvfu = parcelRequire("eIvfu");

var $fgh8a = parcelRequire("fgh8a");
/**
 * Baggage key
 */ const $4beedf33e339cff1$var$BAGGAGE_KEY = (0, $fgh8a.createContextKey)('OpenTelemetry Baggage Key');
function $4beedf33e339cff1$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($4beedf33e339cff1$var$BAGGAGE_KEY) || undefined;
}
function $4beedf33e339cff1$export$120a1756099436ee() {
    return $4beedf33e339cff1$export$f3bffa0b5dd10d1e((0, $eIvfu.ContextAPI).getInstance().active());
}
function $4beedf33e339cff1$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($4beedf33e339cff1$var$BAGGAGE_KEY, baggage);
}
function $4beedf33e339cff1$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($4beedf33e339cff1$var$BAGGAGE_KEY);
}

});

parcelRegister("106wL", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $0baadac03c61d1e0$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $dxZVW = parcelRequire("dxZVW");

var $kvV8f = parcelRequire("kvV8f");

var $cMeoe = parcelRequire("cMeoe");
const $0baadac03c61d1e0$var$diag = (0, $dxZVW.DiagAPI).instance();
function $0baadac03c61d1e0$export$1034a425c7384452(entries = {}) {
    return new (0, $kvV8f.BaggageImpl)(new Map(Object.entries(entries)));
}
function $0baadac03c61d1e0$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $0baadac03c61d1e0$var$diag.error(`Cannot create baggage metadata from unknown type: ${typeof str}`);
        str = '';
    }
    return {
        __TYPE__: (0, $cMeoe.baggageEntryMetadataSymbol),
        toString () {
            return str;
        }
    };
}

});
parcelRegister("kvV8f", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $eef3052754619aa7$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ class $eef3052754619aa7$export$b8c511fa1a5f4987 {
    constructor(entries){
        this._entries = entries ? new Map(entries) : new Map();
    }
    getEntry(key) {
        const entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    }
    getAllEntries() {
        return Array.from(this._entries.entries());
    }
    setEntry(key, entry) {
        const newBaggage = new $eef3052754619aa7$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    }
    removeEntry(key) {
        const newBaggage = new $eef3052754619aa7$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    }
    removeEntries(...keys) {
        const newBaggage = new $eef3052754619aa7$export$b8c511fa1a5f4987(this._entries);
        for (const key of keys)newBaggage._entries.delete(key);
        return newBaggage;
    }
    clear() {
        return new $eef3052754619aa7$export$b8c511fa1a5f4987();
    }
}

});

parcelRegister("cMeoe", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $94d5213b4f27a972$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ const $94d5213b4f27a972$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("bkzBY", function(module, exports) {
$parcel$export(module.exports, "trace", () => $83fd2fad849fb309$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $7cGfQ = parcelRequire("7cGfQ");
const $83fd2fad849fb309$export$357889f174732d38 = (0, $7cGfQ.TraceAPI).getInstance();

});
parcelRegister("7cGfQ", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $53ea6e49620fa12e$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9cIHP = parcelRequire("9cIHP");

var $jzopj = parcelRequire("jzopj");

var $9SUDK = parcelRequire("9SUDK");

var $keXr0 = parcelRequire("keXr0");

var $dxZVW = parcelRequire("dxZVW");
const $53ea6e49620fa12e$var$API_NAME = 'trace';
class $53ea6e49620fa12e$export$2cccde6fcc7b568a {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this._proxyTracerProvider = new (0, $jzopj.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $9SUDK.wrapSpanContext);
        this.isSpanContextValid = (0, $9SUDK.isSpanContextValid);
        this.deleteSpan = (0, $keXr0.deleteSpan);
        this.getSpan = (0, $keXr0.getSpan);
        this.getActiveSpan = (0, $keXr0.getActiveSpan);
        this.getSpanContext = (0, $keXr0.getSpanContext);
        this.setSpan = (0, $keXr0.setSpan);
        this.setSpanContext = (0, $keXr0.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ static getInstance() {
        if (!this._instance) this._instance = new $53ea6e49620fa12e$export$2cccde6fcc7b568a();
        return this._instance;
    }
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ setGlobalTracerProvider(provider) {
        const success = (0, $9cIHP.registerGlobal)($53ea6e49620fa12e$var$API_NAME, this._proxyTracerProvider, (0, $dxZVW.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    }
    /**
     * Returns the global tracer provider.
     */ getTracerProvider() {
        return (0, $9cIHP.getGlobal)($53ea6e49620fa12e$var$API_NAME) || this._proxyTracerProvider;
    }
    /**
     * Returns a tracer from the global tracer provider.
     */ getTracer(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    }
    /** Remove the global tracer provider */ disable() {
        (0, $9cIHP.unregisterGlobal)($53ea6e49620fa12e$var$API_NAME, (0, $dxZVW.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $jzopj.ProxyTracerProvider)();
    }
}

});
parcelRegister("jzopj", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $e3f437f7cb0ef25d$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $7bVAS = parcelRequire("7bVAS");

var $kmAkn = parcelRequire("kmAkn");
const $e3f437f7cb0ef25d$var$NOOP_TRACER_PROVIDER = new (0, $kmAkn.NoopTracerProvider)();
class $e3f437f7cb0ef25d$export$4137aabcb4254962 {
    /**
     * Get a {@link ProxyTracer}
     */ getTracer(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $7bVAS.ProxyTracer)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $e3f437f7cb0ef25d$var$NOOP_TRACER_PROVIDER;
    }
    /**
     * Set the delegate tracer provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateTracer(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    }
}

});
parcelRegister("7bVAS", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $53c63c6b4f36cc8b$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $ioIfO = parcelRequire("ioIfO");
const $53c63c6b4f36cc8b$var$NOOP_TRACER = new (0, $ioIfO.NoopTracer)();
class $53c63c6b4f36cc8b$export$df2c38268c6bb6b3 {
    constructor(provider, name, version, options){
        this._provider = provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    startSpan(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    }
    startActiveSpan(_name, _options, _context, _fn) {
        const tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    }
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ _getTracer() {
        if (this._delegate) return this._delegate;
        const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $53c63c6b4f36cc8b$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    }
}

});
parcelRegister("ioIfO", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $d64ccbd57bfc9513$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $eIvfu = parcelRequire("eIvfu");

var $keXr0 = parcelRequire("keXr0");

var $ll9Vq = parcelRequire("ll9Vq");

var $9SUDK = parcelRequire("9SUDK");
const $d64ccbd57bfc9513$var$contextApi = (0, $eIvfu.ContextAPI).getInstance();
class $d64ccbd57bfc9513$export$714c1036cabcd223 {
    // startSpan starts a noop span.
    startSpan(name, options, context = $d64ccbd57bfc9513$var$contextApi.active()) {
        const root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $ll9Vq.NonRecordingSpan)();
        const parentFromContext = context && (0, $keXr0.getSpanContext)(context);
        if ($d64ccbd57bfc9513$var$isSpanContext(parentFromContext) && (0, $9SUDK.isSpanContextValid)(parentFromContext)) return new (0, $ll9Vq.NonRecordingSpan)(parentFromContext);
        else return new (0, $ll9Vq.NonRecordingSpan)();
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx !== null && ctx !== void 0 ? ctx : $d64ccbd57bfc9513$var$contextApi.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = (0, $keXr0.setSpan)(parentContext, span);
        return $d64ccbd57bfc9513$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    }
}
function $d64ccbd57bfc9513$var$isSpanContext(spanContext) {
    return spanContext !== null && typeof spanContext === 'object' && 'spanId' in spanContext && typeof spanContext['spanId'] === 'string' && 'traceId' in spanContext && typeof spanContext['traceId'] === 'string' && 'traceFlags' in spanContext && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("keXr0", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $ebc337f2077a7639$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $ebc337f2077a7639$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $ebc337f2077a7639$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $ebc337f2077a7639$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $ebc337f2077a7639$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $ebc337f2077a7639$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $fgh8a = parcelRequire("fgh8a");

var $ll9Vq = parcelRequire("ll9Vq");

var $eIvfu = parcelRequire("eIvfu");
/**
 * span key
 */ const $ebc337f2077a7639$var$SPAN_KEY = (0, $fgh8a.createContextKey)('OpenTelemetry Context Key SPAN');
function $ebc337f2077a7639$export$246e04ba06066af1(context) {
    return context.getValue($ebc337f2077a7639$var$SPAN_KEY) || undefined;
}
function $ebc337f2077a7639$export$1be426a8e585c83e() {
    return $ebc337f2077a7639$export$246e04ba06066af1((0, $eIvfu.ContextAPI).getInstance().active());
}
function $ebc337f2077a7639$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($ebc337f2077a7639$var$SPAN_KEY, span);
}
function $ebc337f2077a7639$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($ebc337f2077a7639$var$SPAN_KEY);
}
function $ebc337f2077a7639$export$c90bf5428c14cdb1(context, spanContext) {
    return $ebc337f2077a7639$export$8ab2f2e6ee8ed0a8(context, new (0, $ll9Vq.NonRecordingSpan)(spanContext));
}
function $ebc337f2077a7639$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $ebc337f2077a7639$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("ll9Vq", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $f893421a11605ae9$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $5s6YE = parcelRequire("5s6YE");
class $f893421a11605ae9$export$972d28f7c6a8c6c7 {
    constructor(spanContext = (0, $5s6YE.INVALID_SPAN_CONTEXT)){
        this._spanContext = spanContext;
    }
    // Returns a SpanContext.
    spanContext() {
        return this._spanContext;
    }
    // By default does nothing
    setAttribute(_key, _value) {
        return this;
    }
    // By default does nothing
    setAttributes(_attributes) {
        return this;
    }
    // By default does nothing
    addEvent(_name, _attributes) {
        return this;
    }
    addLink(_link) {
        return this;
    }
    addLinks(_links) {
        return this;
    }
    // By default does nothing
    setStatus(_status) {
        return this;
    }
    // By default does nothing
    updateName(_name) {
        return this;
    }
    // By default does nothing
    end(_endTime) {}
    // isRecording always returns false for NonRecordingSpan.
    isRecording() {
        return false;
    }
    // By default does nothing
    recordException(_exception, _time) {}
}

});
parcelRegister("5s6YE", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $3f84fad2b8b11a54$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $3f84fad2b8b11a54$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $3f84fad2b8b11a54$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $djKeM = parcelRequire("djKeM");
const $3f84fad2b8b11a54$export$55cc39fb0d4bb4c0 = '0000000000000000';
const $3f84fad2b8b11a54$export$22be96e88d95e128 = '00000000000000000000000000000000';
const $3f84fad2b8b11a54$export$8591e4c852b66703 = {
    traceId: $3f84fad2b8b11a54$export$22be96e88d95e128,
    spanId: $3f84fad2b8b11a54$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $djKeM.TraceFlags).NONE
};

});
parcelRegister("djKeM", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $9b20ea8121162b49$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ var $9b20ea8121162b49$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($9b20ea8121162b49$export$bf9049ad2b0883ff || ($9b20ea8121162b49$export$bf9049ad2b0883ff = {}));

});




parcelRegister("9SUDK", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $732517beb3abb456$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $732517beb3abb456$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $5s6YE = parcelRequire("5s6YE");

var $ll9Vq = parcelRequire("ll9Vq");
// Valid characters (0-9, a-f, A-F) are marked as 1.
const $732517beb3abb456$var$isHex = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1
]);
function $732517beb3abb456$var$isValidHex(id, length) {
    // As of 1.9.0 the id was allowed to be a non-string value,
    // even though it was not possible in the types.
    if (typeof id !== 'string' || id.length !== length) return false;
    let r = 0;
    for(let i = 0; i < id.length; i += 4)r += ($732517beb3abb456$var$isHex[id.charCodeAt(i)] | 0) + ($732517beb3abb456$var$isHex[id.charCodeAt(i + 1)] | 0) + ($732517beb3abb456$var$isHex[id.charCodeAt(i + 2)] | 0) + ($732517beb3abb456$var$isHex[id.charCodeAt(i + 3)] | 0);
    return r === length;
}
function $732517beb3abb456$export$29dd34cf1269f6da(traceId) {
    return $732517beb3abb456$var$isValidHex(traceId, 32) && traceId !== (0, $5s6YE.INVALID_TRACEID);
}
function $732517beb3abb456$export$8e51c6d8f0586aff(spanId) {
    return $732517beb3abb456$var$isValidHex(spanId, 16) && spanId !== (0, $5s6YE.INVALID_SPANID);
}
function $732517beb3abb456$export$e4373b9a2c09216c(spanContext) {
    return $732517beb3abb456$export$29dd34cf1269f6da(spanContext.traceId) && $732517beb3abb456$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $732517beb3abb456$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $ll9Vq.NonRecordingSpan)(spanContext);
}

});



parcelRegister("kmAkn", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $ed320aa3bfc7f164$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $ioIfO = parcelRequire("ioIfO");
class $ed320aa3bfc7f164$export$87d8e93756f9e86e {
    getTracer(_name, _version, _options) {
        return new (0, $ioIfO.NoopTracer)();
    }
}

});





parcelRegister("gX41G", function(module, exports) {
$parcel$export(module.exports, "experienceTypeKey", () => $a9a312e554d9859f$export$1069c2293742749e);

var $fgh8a = parcelRequire("fgh8a");
const $a9a312e554d9859f$export$1069c2293742749e = (0, $fgh8a.createContextKey)('type');

});

parcelRegister("cagIi", function(module, exports) {
$parcel$export(module.exports, "spanIdKey", () => $9025356fc2db6ffc$export$ccdc89d1d45284c2);

var $fgh8a = parcelRequire("fgh8a");
const $9025356fc2db6ffc$export$ccdc89d1d45284c2 = (0, $fgh8a.createContextKey)('spanId');

});

parcelRegister("4rFZM", function(module, exports) {
$parcel$export(module.exports, "traceIdKey", () => $cebf267a4c1636ae$export$65f3d43d675bb81b);

var $fgh8a = parcelRequire("fgh8a");
const $cebf267a4c1636ae$export$65f3d43d675bb81b = (0, $fgh8a.createContextKey)('traceId');

});


parcelRegister("51dxT", function(module, exports) {
$parcel$export(module.exports, "useInteractionContext", () => $f50e0047b25de7b9$export$11bcb6e9af2aca35);

var $fc4bM = parcelRequire("fc4bM");

var $fVzQQ = parcelRequire("fVzQQ");
function $f50e0047b25de7b9$export$11bcb6e9af2aca35() {
    return (0, $fc4bM.useContext)((0, $fVzQQ.default));
}

});
parcelRegister("fVzQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c21f039d868b546a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $c21f039d868b546a$var$interactionContext = (0, $fc4bM.createContext)(null);
var $c21f039d868b546a$export$2e2bcd8739ae039 = $c21f039d868b546a$var$interactionContext;

});


parcelRegister("7jb5s", function(module, exports) {
$parcel$export(module.exports, "default", () => $4655aa7264d7ece6$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $4655aa7264d7ece6$var$UFORouteName = {
    current: null
};
var $4655aa7264d7ece6$export$2e2bcd8739ae039 = $4655aa7264d7ece6$var$UFORouteName;

});

parcelRegister("giVVN", function(module, exports) {
$parcel$export(module.exports, "ensureSoftNavigationObserved", () => $cd73b508d51eb686$export$e064a2fa755ff6f2);
$parcel$export(module.exports, "getSoftNavigationPaintMetrics", () => $cd73b508d51eb686$export$e0d5520cde609f66);

var $cUiDw = parcelRequire("cUiDw");
const $cd73b508d51eb686$var$MAX_TRACKED_SOFT_NAVIGATIONS = 20;
// A soft navigation's startTime is the interaction that triggered it, so it comes slightly before
// the UFO transition starts. Ignore soft navigations that started too long before the transition,
// as they most likely belong to an earlier navigation.
const $cd73b508d51eb686$var$MAX_SOFT_NAVIGATION_LEAD_TIME = 1000;
// Only plain timestamps are kept, so long-lived sessions don't retain the painted DOM elements.
const $cd73b508d51eb686$var$softNavigations = new (0, $cUiDw.BufferWithMaxLength)($cd73b508d51eb686$var$MAX_TRACKED_SOFT_NAVIGATIONS);
let $cd73b508d51eb686$var$observer = null;
// Same check as web-vitals' checkSoftNavsEnabled (src/lib/softNavs.ts).
function $cd73b508d51eb686$var$isSoftNavigationSupported() {
    var _globalThis$Performan, _PerformanceSoftNavig;
    return (((_globalThis$Performan = globalThis.PerformanceObserver) === null || _globalThis$Performan === void 0 || (_globalThis$Performan = _globalThis$Performan.supportedEntryTypes) === null || _globalThis$Performan === void 0 ? void 0 : _globalThis$Performan.includes('soft-navigation')) ?? false) && // Older implementations expose the value as an attribute rather than the method. Only the
    // method shipped to stable.
    typeof ((_PerformanceSoftNavig = globalThis.PerformanceSoftNavigation) === null || _PerformanceSoftNavig === void 0 || (_PerformanceSoftNavig = _PerformanceSoftNavig.prototype) === null || _PerformanceSoftNavig === void 0 ? void 0 : _PerformanceSoftNavig.getLargestInteractionContentfulPaint) === 'function';
}
// Each contentful paint is larger than the one before, so the latest one is the LCP.
function $cd73b508d51eb686$var$setLargestContentfulPaint(softNavigation, entry) {
    const paint = entry === null || entry === void 0 ? void 0 : entry.largestContentfulPaint;
    // `||` rather than `??` on purpose: renderTime is 0 when the browser withholds it (e.g. cross-origin
    // images without Timing-Allow-Origin), and no real paint here can happen at time 0.
    const paintTime = (paint === null || paint === void 0 ? void 0 : paint.renderTime) || (paint === null || paint === void 0 ? void 0 : paint.loadTime);
    if (softNavigation !== undefined && paintTime) softNavigation.largestContentfulPaint = paintTime;
}
function $cd73b508d51eb686$var$handleEntries(entries) {
    entries.forEach((entry)=>{
        if (entry.entryType === 'soft-navigation') {
            var _softNavigationEntry$;
            const softNavigationEntry = entry;
            const softNavigation = {
                interactionId: softNavigationEntry.interactionId,
                startTime: softNavigationEntry.startTime,
                // presentationTime is null where unsupported, and a paint after an interaction can't be at 0.
                firstContentfulPaint: softNavigationEntry.presentationTime || softNavigationEntry.paintTime || undefined
            };
            $cd73b508d51eb686$var$softNavigations.push(softNavigation);
            // Paints for this interaction that happened before the soft navigation was detected.
            $cd73b508d51eb686$var$setLargestContentfulPaint(softNavigation, (_softNavigationEntry$ = softNavigationEntry.getLargestInteractionContentfulPaint) === null || _softNavigationEntry$ === void 0 ? void 0 : _softNavigationEntry$.call(softNavigationEntry));
        } else if (entry.entryType === 'interaction-contentful-paint') {
            // These are emitted for any interaction that paints, not only soft navigations, so only keep
            // the ones for a tracked soft navigation.
            const contentfulPaint = entry;
            $cd73b508d51eb686$var$setLargestContentfulPaint($cd73b508d51eb686$var$softNavigations.getAll().find((softNavigation)=>softNavigation.interactionId === contentfulPaint.interactionId), contentfulPaint);
        }
    });
}
function $cd73b508d51eb686$var$findSoftNavigation(start) {
    return $cd73b508d51eb686$var$softNavigations.getAll().reduce((match, softNavigation)=>{
        if (softNavigation.startTime <= start && softNavigation.startTime >= start - $cd73b508d51eb686$var$MAX_SOFT_NAVIGATION_LEAD_TIME && (match === undefined || match.startTime < softNavigation.startTime)) return softNavigation;
        return match;
    }, undefined);
}
function $cd73b508d51eb686$export$e064a2fa755ff6f2() {
    if ($cd73b508d51eb686$var$observer !== null || !$cd73b508d51eb686$var$isSoftNavigationSupported()) return;
    try {
        $cd73b508d51eb686$var$observer = new PerformanceObserver((list)=>$cd73b508d51eb686$var$handleEntries(list.getEntries()));
        $cd73b508d51eb686$var$observer.observe({
            type: 'soft-navigation',
            buffered: true
        });
        if (PerformanceObserver.supportedEntryTypes.includes('interaction-contentful-paint')) $cd73b508d51eb686$var$observer.observe({
            type: 'interaction-contentful-paint',
            buffered: true
        });
    } catch  {
        var _observer;
        // A later observe() can throw after an earlier one succeeded, so stop the half-started observer
        // rather than leaving it filling the buffers while the next call starts another one.
        (_observer = $cd73b508d51eb686$var$observer) === null || _observer === void 0 || _observer.disconnect();
        $cd73b508d51eb686$var$observer = null;
    }
}
function $cd73b508d51eb686$export$e0d5520cde609f66(start) {
    // UFO init runs before jira-spa installs its platform flag resolver, so fg() there skips Jira's
    // overrides (e.g. ?fg=) and can read the un-overridden value. Soft navigations only happen once
    // the page has loaded, and buffered entries replay the ones from before the observer started.
    $cd73b508d51eb686$export$e064a2fa755ff6f2();
    if ($cd73b508d51eb686$var$observer === null) return {};
    $cd73b508d51eb686$var$handleEntries($cd73b508d51eb686$var$observer.takeRecords());
    const softNavigation = $cd73b508d51eb686$var$findSoftNavigation(start);
    if (softNavigation === undefined) return {};
    const metrics = {};
    if (softNavigation.firstContentfulPaint) metrics.fcp = Math.round(Math.max(softNavigation.firstContentfulPaint - start, 0));
    if (softNavigation.largestContentfulPaint) metrics.lcp = Math.round(Math.max(softNavigation.largestContentfulPaint - start, 0));
    return metrics;
}

});
parcelRegister("cUiDw", function(module, exports) {
$parcel$export(module.exports, "BufferWithMaxLength", () => $d0197cd0108e5378$export$2c6e86519c9e8188);
$parcel$export(module.exports, "EntriesBuffer", () => $d0197cd0108e5378$export$f7dc16cbd16f7bbe);

var $fkCWE = parcelRequire("fkCWE");
class $d0197cd0108e5378$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $d0197cd0108e5378$export$f7dc16cbd16f7bbe = {
    [(0, $fkCWE.PerformanceObserverEntryTypes).LongTask]: new $d0197cd0108e5378$export$2c6e86519c9e8188(),
    [(0, $fkCWE.PerformanceObserverEntryTypes).LayoutShift]: new $d0197cd0108e5378$export$2c6e86519c9e8188()
};

});
parcelRegister("fkCWE", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $b972b6eb67b0f8b8$export$a4def92db6fc8e17);
// oxlint-disable-next-line eslint/no-redeclare
const $b972b6eb67b0f8b8$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});



parcelRegister("c0rG1", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $8bdaf4262bf742e3$export$c4744153514ff05d, (v) => $8bdaf4262bf742e3$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $8bdaf4262bf742e3$export$3e506c1ccc9cc1a7, (v) => $8bdaf4262bf742e3$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $8bdaf4262bf742e3$export$e26fe2ed2fa76875, (v) => $8bdaf4262bf742e3$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $8bdaf4262bf742e3$export$502329bbf4b505b1, (v) => $8bdaf4262bf742e3$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $8bdaf4262bf742e3$export$6e3807111c4874c4, (v) => $8bdaf4262bf742e3$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $8bdaf4262bf742e3$export$c27134553091fb3a, (v) => $8bdaf4262bf742e3$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $8bdaf4262bf742e3$export$33ee1acdc04fd2a2, (v) => $8bdaf4262bf742e3$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $8bdaf4262bf742e3$export$b00a404bbd5edef2, (v) => $8bdaf4262bf742e3$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $8bdaf4262bf742e3$export$8352ce38b91d0c62, (v) => $8bdaf4262bf742e3$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $8bdaf4262bf742e3$export$d66a1c1c77bd778b, (v) => $8bdaf4262bf742e3$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $8bdaf4262bf742e3$export$d3dfb8e4810cb555, (v) => $8bdaf4262bf742e3$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $8bdaf4262bf742e3$export$839f9183b0465a69, (v) => $8bdaf4262bf742e3$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $8bdaf4262bf742e3$export$72fdf0e06517287b, (v) => $8bdaf4262bf742e3$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $8bdaf4262bf742e3$export$4b844e58a3e414b4, (v) => $8bdaf4262bf742e3$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $8bdaf4262bf742e3$export$816d2913ae6b83b1, (v) => $8bdaf4262bf742e3$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $8bdaf4262bf742e3$export$61bcfe829111a1d0, (v) => $8bdaf4262bf742e3$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $8bdaf4262bf742e3$export$7ee8c9beb337bc3f, (v) => $8bdaf4262bf742e3$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $8bdaf4262bf742e3$export$b5836b71941fa3ed, (v) => $8bdaf4262bf742e3$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $8bdaf4262bf742e3$export$cf845f2c119da08a, (v) => $8bdaf4262bf742e3$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bdaf4262bf742e3$export$c4744153514ff05d;
var $8bdaf4262bf742e3$export$3e506c1ccc9cc1a7;
var $8bdaf4262bf742e3$export$e26fe2ed2fa76875;
var $8bdaf4262bf742e3$export$502329bbf4b505b1;
var $8bdaf4262bf742e3$export$6e3807111c4874c4;
var $8bdaf4262bf742e3$export$c27134553091fb3a;
var $8bdaf4262bf742e3$export$33ee1acdc04fd2a2;
var $8bdaf4262bf742e3$export$b00a404bbd5edef2;
var $8bdaf4262bf742e3$export$8352ce38b91d0c62;
var $8bdaf4262bf742e3$export$d66a1c1c77bd778b;
var $8bdaf4262bf742e3$export$d3dfb8e4810cb555;
var $8bdaf4262bf742e3$export$839f9183b0465a69;
var $8bdaf4262bf742e3$export$72fdf0e06517287b;
var $8bdaf4262bf742e3$export$4b844e58a3e414b4;
var $8bdaf4262bf742e3$export$816d2913ae6b83b1;
var $8bdaf4262bf742e3$export$61bcfe829111a1d0;
var $8bdaf4262bf742e3$export$7ee8c9beb337bc3f;
var $8bdaf4262bf742e3$export$b5836b71941fa3ed;
var $8bdaf4262bf742e3$export$cf845f2c119da08a;
'use strict';
function $8bdaf4262bf742e3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $8bdaf4262bf742e3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $8bdaf4262bf742e3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $8bdaf4262bf742e3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $8bdaf4262bf742e3$var$g(C, c)) n < e && 0 > $8bdaf4262bf742e3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $8bdaf4262bf742e3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $8bdaf4262bf742e3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $8bdaf4262bf742e3$var$l = performance;
    $8bdaf4262bf742e3$export$c4744153514ff05d = function() {
        return $8bdaf4262bf742e3$var$l.now();
    };
} else {
    var $8bdaf4262bf742e3$var$p = Date, $8bdaf4262bf742e3$var$q = $8bdaf4262bf742e3$var$p.now();
    $8bdaf4262bf742e3$export$c4744153514ff05d = function() {
        return $8bdaf4262bf742e3$var$p.now() - $8bdaf4262bf742e3$var$q;
    };
}
var $8bdaf4262bf742e3$var$r = [], $8bdaf4262bf742e3$var$t = [], $8bdaf4262bf742e3$var$u = 1, $8bdaf4262bf742e3$var$v = null, $8bdaf4262bf742e3$var$y = 3, $8bdaf4262bf742e3$var$z = !1, $8bdaf4262bf742e3$var$A = !1, $8bdaf4262bf742e3$var$B = !1, $8bdaf4262bf742e3$var$D = "function" === typeof setTimeout ? setTimeout : null, $8bdaf4262bf742e3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $8bdaf4262bf742e3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $8bdaf4262bf742e3$var$G(a) {
    for(var b = $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$t); null !== b;){
        if (null === b.callback) $8bdaf4262bf742e3$var$k($8bdaf4262bf742e3$var$t);
        else if (b.startTime <= a) $8bdaf4262bf742e3$var$k($8bdaf4262bf742e3$var$t), b.sortIndex = b.expirationTime, $8bdaf4262bf742e3$var$f($8bdaf4262bf742e3$var$r, b);
        else break;
        b = $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$t);
    }
}
function $8bdaf4262bf742e3$var$H(a) {
    $8bdaf4262bf742e3$var$B = !1;
    $8bdaf4262bf742e3$var$G(a);
    if (!$8bdaf4262bf742e3$var$A) {
        if (null !== $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$r)) $8bdaf4262bf742e3$var$A = !0, $8bdaf4262bf742e3$var$I($8bdaf4262bf742e3$var$J);
        else {
            var b = $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$t);
            null !== b && $8bdaf4262bf742e3$var$K($8bdaf4262bf742e3$var$H, b.startTime - a);
        }
    }
}
function $8bdaf4262bf742e3$var$J(a, b) {
    $8bdaf4262bf742e3$var$A = !1;
    $8bdaf4262bf742e3$var$B && ($8bdaf4262bf742e3$var$B = !1, $8bdaf4262bf742e3$var$E($8bdaf4262bf742e3$var$L), $8bdaf4262bf742e3$var$L = -1);
    $8bdaf4262bf742e3$var$z = !0;
    var c = $8bdaf4262bf742e3$var$y;
    try {
        $8bdaf4262bf742e3$var$G(b);
        for($8bdaf4262bf742e3$var$v = $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$r); null !== $8bdaf4262bf742e3$var$v && (!($8bdaf4262bf742e3$var$v.expirationTime > b) || a && !$8bdaf4262bf742e3$var$M());){
            var d = $8bdaf4262bf742e3$var$v.callback;
            if ("function" === typeof d) {
                $8bdaf4262bf742e3$var$v.callback = null;
                $8bdaf4262bf742e3$var$y = $8bdaf4262bf742e3$var$v.priorityLevel;
                var e = d($8bdaf4262bf742e3$var$v.expirationTime <= b);
                b = $8bdaf4262bf742e3$export$c4744153514ff05d();
                "function" === typeof e ? $8bdaf4262bf742e3$var$v.callback = e : $8bdaf4262bf742e3$var$v === $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$r) && $8bdaf4262bf742e3$var$k($8bdaf4262bf742e3$var$r);
                $8bdaf4262bf742e3$var$G(b);
            } else $8bdaf4262bf742e3$var$k($8bdaf4262bf742e3$var$r);
            $8bdaf4262bf742e3$var$v = $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$r);
        }
        if (null !== $8bdaf4262bf742e3$var$v) var w = !0;
        else {
            var m = $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$t);
            null !== m && $8bdaf4262bf742e3$var$K($8bdaf4262bf742e3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $8bdaf4262bf742e3$var$v = null, $8bdaf4262bf742e3$var$y = c, $8bdaf4262bf742e3$var$z = !1;
    }
}
var $8bdaf4262bf742e3$var$N = !1, $8bdaf4262bf742e3$var$O = null, $8bdaf4262bf742e3$var$L = -1, $8bdaf4262bf742e3$var$P = 5, $8bdaf4262bf742e3$var$Q = -1;
function $8bdaf4262bf742e3$var$M() {
    return $8bdaf4262bf742e3$export$c4744153514ff05d() - $8bdaf4262bf742e3$var$Q < $8bdaf4262bf742e3$var$P ? !1 : !0;
}
function $8bdaf4262bf742e3$var$R() {
    if (null !== $8bdaf4262bf742e3$var$O) {
        var a = $8bdaf4262bf742e3$export$c4744153514ff05d();
        $8bdaf4262bf742e3$var$Q = a;
        var b = !0;
        try {
            b = $8bdaf4262bf742e3$var$O(!0, a);
        } finally{
            b ? $8bdaf4262bf742e3$var$S() : ($8bdaf4262bf742e3$var$N = !1, $8bdaf4262bf742e3$var$O = null);
        }
    } else $8bdaf4262bf742e3$var$N = !1;
}
var $8bdaf4262bf742e3$var$S;
if ("function" === typeof $8bdaf4262bf742e3$var$F) $8bdaf4262bf742e3$var$S = function() {
    $8bdaf4262bf742e3$var$F($8bdaf4262bf742e3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $8bdaf4262bf742e3$var$T = new MessageChannel, $8bdaf4262bf742e3$var$U = $8bdaf4262bf742e3$var$T.port2;
    $8bdaf4262bf742e3$var$T.port1.onmessage = $8bdaf4262bf742e3$var$R;
    $8bdaf4262bf742e3$var$S = function() {
        $8bdaf4262bf742e3$var$U.postMessage(null);
    };
} else $8bdaf4262bf742e3$var$S = function() {
    $8bdaf4262bf742e3$var$D($8bdaf4262bf742e3$var$R, 0);
};
function $8bdaf4262bf742e3$var$I(a) {
    $8bdaf4262bf742e3$var$O = a;
    $8bdaf4262bf742e3$var$N || ($8bdaf4262bf742e3$var$N = !0, $8bdaf4262bf742e3$var$S());
}
function $8bdaf4262bf742e3$var$K(a, b) {
    $8bdaf4262bf742e3$var$L = $8bdaf4262bf742e3$var$D(function() {
        a($8bdaf4262bf742e3$export$c4744153514ff05d());
    }, b);
}
$8bdaf4262bf742e3$export$3e506c1ccc9cc1a7 = 5;
$8bdaf4262bf742e3$export$e26fe2ed2fa76875 = 1;
$8bdaf4262bf742e3$export$502329bbf4b505b1 = 4;
$8bdaf4262bf742e3$export$6e3807111c4874c4 = 3;
$8bdaf4262bf742e3$export$c27134553091fb3a = null;
$8bdaf4262bf742e3$export$33ee1acdc04fd2a2 = 2;
$8bdaf4262bf742e3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$8bdaf4262bf742e3$export$8352ce38b91d0c62 = function() {
    $8bdaf4262bf742e3$var$A || $8bdaf4262bf742e3$var$z || ($8bdaf4262bf742e3$var$A = !0, $8bdaf4262bf742e3$var$I($8bdaf4262bf742e3$var$J));
};
$8bdaf4262bf742e3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $8bdaf4262bf742e3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$8bdaf4262bf742e3$export$d3dfb8e4810cb555 = function() {
    return $8bdaf4262bf742e3$var$y;
};
$8bdaf4262bf742e3$export$839f9183b0465a69 = function() {
    return $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$r);
};
$8bdaf4262bf742e3$export$72fdf0e06517287b = function(a) {
    switch($8bdaf4262bf742e3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $8bdaf4262bf742e3$var$y;
    }
    var c = $8bdaf4262bf742e3$var$y;
    $8bdaf4262bf742e3$var$y = b;
    try {
        return a();
    } finally{
        $8bdaf4262bf742e3$var$y = c;
    }
};
$8bdaf4262bf742e3$export$4b844e58a3e414b4 = function() {};
$8bdaf4262bf742e3$export$816d2913ae6b83b1 = function() {};
$8bdaf4262bf742e3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $8bdaf4262bf742e3$var$y;
    $8bdaf4262bf742e3$var$y = a;
    try {
        return b();
    } finally{
        $8bdaf4262bf742e3$var$y = c;
    }
};
$8bdaf4262bf742e3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $8bdaf4262bf742e3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $8bdaf4262bf742e3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $8bdaf4262bf742e3$var$f($8bdaf4262bf742e3$var$t, a), null === $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$r) && a === $8bdaf4262bf742e3$var$h($8bdaf4262bf742e3$var$t) && ($8bdaf4262bf742e3$var$B ? ($8bdaf4262bf742e3$var$E($8bdaf4262bf742e3$var$L), $8bdaf4262bf742e3$var$L = -1) : $8bdaf4262bf742e3$var$B = !0, $8bdaf4262bf742e3$var$K($8bdaf4262bf742e3$var$H, c - d))) : (a.sortIndex = e, $8bdaf4262bf742e3$var$f($8bdaf4262bf742e3$var$r, a), $8bdaf4262bf742e3$var$A || $8bdaf4262bf742e3$var$z || ($8bdaf4262bf742e3$var$A = !0, $8bdaf4262bf742e3$var$I($8bdaf4262bf742e3$var$J)));
    return a;
};
$8bdaf4262bf742e3$export$b5836b71941fa3ed = $8bdaf4262bf742e3$var$M;
$8bdaf4262bf742e3$export$cf845f2c119da08a = function(a) {
    var b = $8bdaf4262bf742e3$var$y;
    return function() {
        var c = $8bdaf4262bf742e3$var$y;
        $8bdaf4262bf742e3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $8bdaf4262bf742e3$var$y = c;
        }
    };
};

});

parcelRegister("9WfyI", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1dKyZ"),
    $9dnsd("kAmZh")
]).then(()=>parcelRequire('3GRQS'));

});

parcelRegister("7JN5Q", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1dKyZ"),
    $9dnsd("bBrKG")
]).then(()=>parcelRequire('5KG1d'));

});

parcelRegister("ezdA4", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("i8Kqo").then(()=>parcelRequire('hZLF2'));

});

parcelRegister("d8Y4I", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cVmG5").then(()=>parcelRequire('3cMtN'));

});

parcelRegister("7eeIG", function(module, exports) {
$parcel$export(module.exports, "configure", () => $5559177096acdf2e$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $5559177096acdf2e$export$44487a86467333c3);

var $5hPkM = parcelRequire("5hPkM");
const $5559177096acdf2e$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $5559177096acdf2e$var$getAllowedParams() {
    const config = (0, $5hPkM.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $5559177096acdf2e$var$defaultAllowedParams;
}
function $5559177096acdf2e$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $5559177096acdf2e$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $5559177096acdf2e$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $5559177096acdf2e$var$handleQueryParams(url);
    }
};
function $5559177096acdf2e$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $5559177096acdf2e$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $5559177096acdf2e$var$config = newConfig;
}
function $5559177096acdf2e$export$44487a86467333c3() {
    return $5559177096acdf2e$var$config;
}

});

parcelRegister("6B6vE", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $006f0a5841eef90a$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $006f0a5841eef90a$export$4138a729ef1db028);

var $11cxn = parcelRequire("11cxn");
const $006f0a5841eef90a$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $006f0a5841eef90a$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $006f0a5841eef90a$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        const duration = (0, $11cxn.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find((timing)=>timing.name === 'atl-edge')) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi'));
        const serverTime = totalBackendTimeEntry ? (0, $11cxn.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $11cxn.roundEpsilon)(entry.startTime),
            duration: (0, $11cxn.roundEpsilon)(entry.duration),
            fetchStart: (0, $11cxn.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $11cxn.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $11cxn.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $11cxn.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $11cxn.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $11cxn.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        var _performance$getEntri;
        const performance = $006f0a5841eef90a$var$getPerformanceObject();
        const PerformanceObserver = $006f0a5841eef90a$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($006f0a5841eef90a$export$bea963256235a63e.observer) return;
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $006f0a5841eef90a$export$bea963256235a63e.timings = resources.map((resource)=>$006f0a5841eef90a$export$bea963256235a63e.transformResource(resource));
        $006f0a5841eef90a$export$bea963256235a63e.observer = new PerformanceObserver($006f0a5841eef90a$export$bea963256235a63e.addTimings);
        $006f0a5841eef90a$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($006f0a5841eef90a$export$bea963256235a63e.observer) {
            $006f0a5841eef90a$export$bea963256235a63e.observer.disconnect();
            $006f0a5841eef90a$export$bea963256235a63e.observer = null;
        }
        $006f0a5841eef90a$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$006f0a5841eef90a$export$bea963256235a63e.transformResource(entry));
        const overflow = $006f0a5841eef90a$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $006f0a5841eef90a$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $006f0a5841eef90a$export$bea963256235a63e.maxSize;
            $006f0a5841eef90a$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $006f0a5841eef90a$export$bea963256235a63e.timings.push(...entries);
    }
};
function $006f0a5841eef90a$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $006f0a5841eef90a$export$4138a729ef1db028(startTime, endTime) {
    const performance = $006f0a5841eef90a$var$getPerformanceObject();
    const PerformanceObserver = $006f0a5841eef90a$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$006f0a5841eef90a$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$006f0a5841eef90a$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $006f0a5841eef90a$export$bea963256235a63e.timings.filter((timing)=>$006f0a5841eef90a$var$isValidTiming(timing, startTime, endTime));
}

});
parcelRegister("11cxn", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", () => $603d4b2eaaac515e$export$56014375de40214b);
function $603d4b2eaaac515e$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("iRdXI", function(module, exports) {
$parcel$export(module.exports, "configure", () => $ae424afe6ce01ae5$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $ae424afe6ce01ae5$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $ae424afe6ce01ae5$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $ae424afe6ce01ae5$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $ae424afe6ce01ae5$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $ae424afe6ce01ae5$export$1c4a9b5e6e22393d);
$parcel$export(module.exports, "getSSRSuccessBreakdown", () => $ae424afe6ce01ae5$export$eb7c400973493903);
const $ae424afe6ce01ae5$var$NESTED_METRIC_SEPARATOR = '/';
function $ae424afe6ce01ae5$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $ae424afe6ce01ae5$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $ae424afe6ce01ae5$var$SSR_PREFIX = 'ssr';
function $ae424afe6ce01ae5$var$mapKey(key) {
    if (key === 'total') return $ae424afe6ce01ae5$var$SSR_PREFIX;
    return `${$ae424afe6ce01ae5$var$SSR_PREFIX}${$ae424afe6ce01ae5$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $ae424afe6ce01ae5$var$config;
function $ae424afe6ce01ae5$export$8d21e34596265fa2(ssrConfig) {
    $ae424afe6ce01ae5$var$config = ssrConfig;
}
function $ae424afe6ce01ae5$var$getPerformanceNavigationTiming() {
    var _performance$getEntri;
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (_performance$getEntri = performance.getEntriesByType('navigation')) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri[0];
}
function $ae424afe6ce01ae5$var$getServerTimingsByName() {
    var _getPerformanceNaviga;
    const serverTimingsByName = Object.fromEntries(((_getPerformanceNaviga = $ae424afe6ce01ae5$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga === void 0 || (_getPerformanceNaviga = _getPerformanceNaviga.serverTiming) === null || _getPerformanceNaviga === void 0 ? void 0 : _getPerformanceNaviga.map((timing)=>[
            timing.name,
            timing
        ])) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $ae424afe6ce01ae5$var$getEdgeOffset(edgeTtfb) {
    var _getPerformanceNaviga2;
    const clientTtfb = (_getPerformanceNaviga2 = $ae424afe6ce01ae5$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga2 === void 0 ? void 0 : _getPerformanceNaviga2.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $ae424afe6ce01ae5$export$5300d1b82e594615() {
    var _serverTimingsByName$, _serverTimingsByName$2, _serverTimingsByName$3, _serverTimingsByName$4, _serverTimingsByName$5, _serverTimingsByName$6, _serverTimingsByName$7, _serverTimingsByName$8;
    const serverTimingsByName = $ae424afe6ce01ae5$var$getServerTimingsByName();
    const edgeTotalDuration = ((_serverTimingsByName$ = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$ === void 0 ? void 0 : _serverTimingsByName$.duration) ?? ((_serverTimingsByName$2 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$2 === void 0 ? void 0 : _serverTimingsByName$2.duration);
    if (!edgeTotalDuration) return null;
    const edgeOffset = $ae424afe6ce01ae5$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (((_serverTimingsByName$3 = serverTimingsByName['cdn-upstream-dns']) === null || _serverTimingsByName$3 === void 0 ? void 0 : _serverTimingsByName$3.duration) || 0) + (((_serverTimingsByName$4 = serverTimingsByName['cdn-upstream-connect']) === null || _serverTimingsByName$4 === void 0 ? void 0 : _serverTimingsByName$4.duration) || 0);
    const cfUpstreamDuration = (((_serverTimingsByName$5 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$5 === void 0 ? void 0 : _serverTimingsByName$5.duration) || 0) - cfInternalDuration;
    const cfDownstreamDuration = (((_serverTimingsByName$6 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$6 === void 0 ? void 0 : _serverTimingsByName$6.duration) || 0) - (((_serverTimingsByName$7 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$7 === void 0 ? void 0 : _serverTimingsByName$7.duration) || 0);
    const atlEdgeDuration = (_serverTimingsByName$8 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$8 === void 0 ? void 0 : _serverTimingsByName$8.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        var _serverTimingsByName$9;
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: (_serverTimingsByName$9 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$9 === void 0 ? void 0 : _serverTimingsByName$9.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        var _serverTimingsByName$0;
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: (_serverTimingsByName$0 = serverTimingsByName['atl-edge-internal']) === null || _serverTimingsByName$0 === void 0 ? void 0 : _serverTimingsByName$0.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    (edgeTimings === null || edgeTimings === void 0 ? void 0 : edgeTimings.edge) && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $ae424afe6ce01ae5$export$bf7408e83532dcd0() {
    var _config;
    const defaultSSRTimings = $ae424afe6ce01ae5$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof ((_config = $ae424afe6ce01ae5$var$config) === null || _config === void 0 ? void 0 : _config.getTimings) === 'function') configTimings = $ae424afe6ce01ae5$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($ae424afe6ce01ae5$var$filterEntry(entry[1])) acc[$ae424afe6ce01ae5$var$mapKey(entry[0])] = $ae424afe6ce01ae5$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $ae424afe6ce01ae5$export$c7ad864055e75537() {
    var _config2;
    return !!((_config2 = $ae424afe6ce01ae5$var$config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
function $ae424afe6ce01ae5$export$5eade9354185583d() {
    var _config3, _config3$getSsrPhaseS;
    return (_config3 = $ae424afe6ce01ae5$var$config) === null || _config3 === void 0 || (_config3$getSsrPhaseS = _config3.getSsrPhaseSuccess) === null || _config3$getSsrPhaseS === void 0 ? void 0 : _config3$getSsrPhaseS.call(_config3);
}
function $ae424afe6ce01ae5$export$3def7672244bab0c() {
    var _config4;
    return ((_config4 = $ae424afe6ce01ae5$var$config) === null || _config4 === void 0 ? void 0 : _config4.getDoneMark()) ?? undefined;
}
function $ae424afe6ce01ae5$export$1c4a9b5e6e22393d() {
    var _config5;
    if (!((_config5 = $ae424afe6ce01ae5$var$config) !== null && _config5 !== void 0 && _config5.getFeatureFlags)) return undefined;
    try {
        return $ae424afe6ce01ae5$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
function $ae424afe6ce01ae5$export$eb7c400973493903() {
    var _config6;
    if (!((_config6 = $ae424afe6ce01ae5$var$config) !== null && _config6 !== void 0 && _config6.getSsrSuccessBreakdown)) return undefined;
    try {
        return $ae424afe6ce01ae5$var$config.getSsrSuccessBreakdown() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}

});

parcelRegister("7lN8e", function(module, exports) {
$parcel$export(module.exports, "EnvType", () => $8c45a76c9b5159e6$export$76f4b1ef26f59baf);
$parcel$export(module.exports, "getEnv", () => $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e);
$parcel$export(module.exports, "getIsPageServerSideRendered", () => $8c45a76c9b5159e6$export$11bdeb36ea0511ca);
$parcel$export(module.exports, "getIsMultiHCEnabled", () => $8c45a76c9b5159e6$export$ae0e930c2df55631);
$parcel$export(module.exports, "getIsHCCustomizationEnabled", () => $8c45a76c9b5159e6$export$efe1682951193de4);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $8c45a76c9b5159e6$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $8c45a76c9b5159e6$export$9679fa5312e1354b);
$parcel$export(module.exports, "getHoistedProjectKey", () => $8c45a76c9b5159e6$export$3b0fd0e16a94f75);

var $him7m = parcelRequire("him7m");

var $6LH8a = parcelRequire("6LH8a");
var $8c45a76c9b5159e6$export$76f4b1ef26f59baf = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}({});
function $8c45a76c9b5159e6$var$parseEnvironment() {
    const env = (0, $6LH8a.getMeta)('environment');
    if (env === 'prod') return "prod";
    if (env === 'staging') return "staging";
    return "dev";
}
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const $8c45a76c9b5159e6$var$parseJson = (content)=>content ? JSON.parse(content) : {};
const $8c45a76c9b5159e6$var$envElement = (0, $him7m.default).getElementById('envJson');
let $8c45a76c9b5159e6$var$envData;
const $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e = ()=>{
    if ($8c45a76c9b5159e6$var$envData) return $8c45a76c9b5159e6$var$envData;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $8c45a76c9b5159e6$var$envData = Object.freeze({
        ...$8c45a76c9b5159e6$var$parseJson($8c45a76c9b5159e6$var$envElement && $8c45a76c9b5159e6$var$envElement.textContent),
        environment: $8c45a76c9b5159e6$var$parseEnvironment()
    });
    return $8c45a76c9b5159e6$var$envData;
};
const $8c45a76c9b5159e6$export$11bdeb36ea0511ca = ()=>{
    // @ts-ignore - TS2339: Property '__IS_PAGE_SERVER_SIDE_RENDERED__' does not exist on type 'Window & typeof globalThis'.
    // This was added when adding project references to help center.
    return window.__IS_PAGE_SERVER_SIDE_RENDERED__;
};
const $8c45a76c9b5159e6$export$ae0e930c2df55631 = ()=>{
    var _getEnv$featuredValue;
    return (_getEnv$featuredValue = $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue === void 0 ? void 0 : _getEnv$featuredValue.multiHelpCenterEnabled;
};
const $8c45a76c9b5159e6$export$efe1682951193de4 = ()=>{
    var _getEnv$featuredValue2;
    return (_getEnv$featuredValue2 = $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue2 === void 0 ? void 0 : _getEnv$featuredValue2.helpCenterCustomizationEnabled;
};
const $8c45a76c9b5159e6$export$a90992f5204fc247 = ()=>{
    var _getEnv$featuredValue3;
    return ((_getEnv$featuredValue3 = $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue3 === void 0 ? void 0 : _getEnv$featuredValue3.jsmAiConfigEnabled) ?? false;
};
const $8c45a76c9b5159e6$export$9679fa5312e1354b = ()=>{
    return $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e().jiraDisplayUrl;
};
const $8c45a76c9b5159e6$export$3b0fd0e16a94f75 = ()=>{
    return $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e().hoistedProjectKey;
};
const $8c45a76c9b5159e6$export$e567920edc63a849 = ()=>{
    return $8c45a76c9b5159e6$export$4bd44a2aa29d3d6e().relativeBaseUrl;
};

});

parcelRegister("53Jed", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $996fc86a2d1e8291$export$b46cecdf698e4bb5);

var $jTM1t = parcelRequire("jTM1t");

var $fkCWE = parcelRequire("fkCWE");

var $kBbsL = parcelRequire("kBbsL");

var $cUiDw = parcelRequire("cUiDw");
function $996fc86a2d1e8291$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $kBbsL.getTBT)(start, stop, (0, $cUiDw.EntriesBuffer)[(0, $fkCWE.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $jTM1t.getCLS)(start, stop, (0, $cUiDw.EntriesBuffer)[(0, $fkCWE.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("jTM1t", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $4dac8545226b1486$export$fc6227831ee7c7);
function $4dac8545226b1486$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $4dac8545226b1486$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        var _entry$sources;
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(({ previousRect: previousRect, currentRect: currentRect })=>$4dac8545226b1486$var$isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("kBbsL", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $59a2c2ed56726f51$export$2d6e933b35bd3407);
const $59a2c2ed56726f51$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $59a2c2ed56726f51$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $59a2c2ed56726f51$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $59a2c2ed56726f51$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $59a2c2ed56726f51$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});


parcelRegister("6lbrU", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $a0037d1baf4a24bd$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "updateUserInfo", () => $a0037d1baf4a24bd$export$c305be0ec5c00f16);
$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $a0037d1baf4a24bd$export$799525ac94ca811d);

var $8BjzM = parcelRequire("8BjzM");

var $2mgM4 = parcelRequire("2mgM4");

var $6LH8a = parcelRequire("6LH8a");

var $aYMdQ = parcelRequire("aYMdQ");

var $aVQWM = parcelRequire("aVQWM");

var $j5wIQ = parcelRequire("j5wIQ");

var $eENmG = parcelRequire("eENmG");

var $j4SCE = parcelRequire("j4SCE");
var $9mhZO = parcelRequire("9mhZO");

var $cf3fd = parcelRequire("cf3fd");

var $jgb8T = parcelRequire("jgb8T");

var $7lN8e = parcelRequire("7lN8e");

var $8Ogqb = parcelRequire("8Ogqb");

var $1cNOK = parcelRequire("1cNOK");

const $a0037d1baf4a24bd$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
class $a0037d1baf4a24bd$export$208d0eb1d9fc833e {
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, product: product, environment: environment, locale: locale, callback: callback, version: version, shouldTriggerUIViewed: shouldTriggerUIViewed = true }) {
        this.analyticsClient = new (0, $8BjzM.default)({
            product: product,
            locale: locale,
            env: environment,
            version: version || '1.0.0',
            origin: (0, $2mgM4.originType).WEB,
            ...(0, $j4SCE.isIsolatedCloud)() ? {
                ic: (0, $9mhZO.isolationContextId)()
            } : undefined
        }, {
            disableCookiePersistence: true,
            isSynthetic: (0, $6LH8a.getMeta)('ajs-is-synthetic') === 'true',
            ...(0, $j4SCE.isIsolatedCloud)() ? {
                apiHost: `${window.location.hostname}/${$a0037d1baf4a24bd$var$GAS_V3_ROUTE}`
            } : undefined
        });
        this.bootstrapEventPayloadOverride();
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $2mgM4.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $2mgM4.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, $aYMdQ.noop);
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        return true;
    }
    addCommonHelpCenterData(event) {
        if (typeof event === 'object') event.attributes = {
            ...event.attributes,
            ...(0, $1cNOK.getHelpCenterAnalyticsData)(),
            ...(0, $8Ogqb.getApplicationType)()
        };
        return event;
    }
    bootstrapEventPayloadOverride() {
        const sendUIEvent = this.analyticsClient.sendUIEvent;
        const sendTrackEvent = this.analyticsClient.sendTrackEvent;
        const sendOperationalEvent = this.analyticsClient.sendOperationalEvent;
        const sendScreenEvent = this.analyticsClient.sendScreenEvent;
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendUIEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendUIEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendTrackEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendTrackEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendOperationalEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendOperationalEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendScreenEvent = (event, callback, attributes)=>{
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const existingAttrs = typeof attributes === 'object' ? attributes : {
                //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value: attributes // non object vales are directly assigned as attributes accept `any`
            };
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const updatedAttrs = {
                ...existingAttrs,
                ...(0, $1cNOK.getHelpCenterAnalyticsData)(),
                ...(0, $8Ogqb.getApplicationType)()
            };
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendScreenEvent.call(this.analyticsClient, event, callback, updatedAttrs);
        };
    }
    getDataFromEvent(event, channel) {
        if (channel === (0, $aVQWM.ANALYTICS_BRIDGE_CHANNEL)) return (0, $j5wIQ.extractAWCDataFromEvent)(event);
        return (0, $eENmG.getEvent)(event);
    }
    sendEvent(event, channel) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { type: type, payload: payload } = this.getDataFromEvent(event, channel);
        try {
            switch(type){
                case 0, $eENmG.UI_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $eENmG.TRACK_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $eENmG.OPERATIONAL_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $eENmG.SCREEN_EVENT_TYPE:
                    // Disabling existing violations, should be fixed when revisited.
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                    break;
                default:
                    (0, $jgb8T.devLog)(`An event was blackholed because it was of an invalid analyticsType: ${// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    event.payload.analyticsType}.\nMake sure analyticsType is specified in the event's payload and is one of ${[
                        (0, $eENmG.UI_EVENT_TYPE),
                        (0, $eENmG.TRACK_EVENT_TYPE),
                        (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                        (0, $eENmG.SCREEN_EVENT_TYPE)
                    ].join(', ')}.`);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('Failed to send analytic data. It may be malformed, or sessionStorage may be disabled.', err);
        }
    }
    getInstance() {
        return this.analyticsClient;
    }
    updateUserInfo(accountId) {
        this.analyticsClient.setUserInfo((0, $2mgM4.userType).ATLASSIAN_ACCOUNT, accountId);
    }
}
let $a0037d1baf4a24bd$var$analyticsWebClient;
const $a0037d1baf4a24bd$export$e9ba7ef9458d1a4a = ()=>{
    if ($a0037d1baf4a24bd$var$analyticsWebClient) return $a0037d1baf4a24bd$var$analyticsWebClient;
    const locale = (0, $6LH8a.getMeta)('ajs-user-locale') || (0, $6LH8a.getMeta)('user-locale') || '';
    const tenantId = (0, $6LH8a.getMeta)('tenant-id') || '';
    const accountId = (0, $6LH8a.getMeta)('account-id') || '';
    const version = window.BUILD_KEY;
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const environment = (0, $7lN8e.getEnv)().environment;
    $a0037d1baf4a24bd$var$analyticsWebClient = new $a0037d1baf4a24bd$export$208d0eb1d9fc833e();
    $a0037d1baf4a24bd$var$analyticsWebClient.init({
        tenantId: tenantId,
        environment: environment,
        locale: locale,
        version: version,
        subProduct: isCSM ? 'customer-service' : 'serviceDesk',
        userId: accountId,
        product: 'jira',
        shouldTriggerUIViewed: false
    });
    return $a0037d1baf4a24bd$var$analyticsWebClient;
};
const $a0037d1baf4a24bd$export$c305be0ec5c00f16 = (accountId)=>{
    $a0037d1baf4a24bd$var$analyticsWebClient.updateUserInfo(accountId);
};
const $a0037d1baf4a24bd$export$799525ac94ca811d = ()=>Promise.resolve($a0037d1baf4a24bd$export$e9ba7ef9458d1a4a());
const $a0037d1baf4a24bd$export$474e180ec53844ef = ()=>{
    $a0037d1baf4a24bd$var$analyticsWebClient = undefined;
};

});
parcelRegister("8BjzM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ea6e6e541a36147$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $41a4X = parcelRequire("41a4X");

var $9mhZO = parcelRequire("9mhZO");

var $2mgM4 = parcelRequire("2mgM4");

var $l3mz8 = parcelRequire("l3mz8");

var $4g9KI = parcelRequire("4g9KI");

var $665ng = parcelRequire("665ng");

var $bUHQb = parcelRequire("bUHQb");

var $bLquF = parcelRequire("bLquF");

var $amegk = parcelRequire("amegk");

var $j5egH = parcelRequire("j5egH");

var $5mvra = parcelRequire("5mvra");

var $c6ki9 = parcelRequire("c6ki9");

var $aVVpm = parcelRequire("aVVpm");

var $i6mDL = parcelRequire("i6mDL");

var $IACFR = parcelRequire("IACFR");

var $6allD = parcelRequire("6allD");

var $94FNv = parcelRequire("94FNv");

var $2Lib9 = parcelRequire("2Lib9");

var $kfJIp = parcelRequire("kfJIp");

var $cRtxi = parcelRequire("cRtxi");

var $7shyU = parcelRequire("7shyU");

var $bXCOi = parcelRequire("bXCOi");

var $gYCEb = parcelRequire("gYCEb");

var $a40Zg = parcelRequire("a40Zg");

var $dO86J = parcelRequire("dO86J");

var $cRoJC = parcelRequire("cRoJC");

var $72Hes = parcelRequire("72Hes");

var $I5wOY = parcelRequire("I5wOY");

var $aUf9S = parcelRequire("aUf9S");

var $kTpbz = parcelRequire("kTpbz");

var $bsjOM = parcelRequire("bsjOM");

var $cKB5a = parcelRequire("cKB5a");

var $88PeU = parcelRequire("88PeU");

var $9Cv3R = parcelRequire("9Cv3R");

var $9I4pj = parcelRequire("9I4pj");

var $9FVmq = parcelRequire("9FVmq");

var $lM0b2 = parcelRequire("lM0b2");

var $bmI56 = parcelRequire("bmI56");

var $bfgv3 = parcelRequire("bfgv3");
const $8ea6e6e541a36147$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $8ea6e6e541a36147$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $amegk.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $amegk.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($8ea6e6e541a36147$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($8ea6e6e541a36147$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($8ea6e6e541a36147$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $2mgM4.eventType).UI:
                case (0, $2mgM4.eventType).OPERATIONAL:
                case (0, $2mgM4.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $2mgM4.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $2mgM4.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $2mgM4.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $94FNv.isType)((0, $2mgM4.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $kfJIp.objectValues)((0, $2mgM4.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $cKB5a.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $94FNv.isType)((0, $2mgM4.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $kfJIp.objectValues)((0, $2mgM4.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $94FNv.isType)((0, $2mgM4.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $kfJIp.objectValues)((0, $2mgM4.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $2mgM4.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $9I4pj.validateScreenEvent)(screenName);
            (0, $bsjOM.validateContainers)(screenContainers);
            const builtEvent = (0, $bLquF.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $bmI56.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $9FVmq.validateTrackEvent)(event);
            const builtEvent = (0, $4g9KI.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $2mgM4.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $665ng.buildActionName)(event), builtEvent, this._context, (0, $bmI56.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $lM0b2.validateUIEvent)(event);
            const builtEvent = (0, $4g9KI.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $2mgM4.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $665ng.buildActionName)(event), builtEvent, this._context, (0, $bmI56.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $88PeU.validateOperationalEvent)(event);
            const builtEvent = (0, $4g9KI.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $2mgM4.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $665ng.buildActionName)(event), builtEvent, this._context, (0, $bmI56.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $I5wOY.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $2mgM4.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $2mgM4.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $2mgM4.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $2mgM4.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $2mgM4.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $kfJIp.objectValues)((0, $2mgM4.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $94FNv.isType)((0, $2mgM4.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $kfJIp.objectValues)((0, $2mgM4.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $2mgM4.originType).WEB;
        else if (!(0, $94FNv.isType)((0, $2mgM4.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $kfJIp.objectValues)((0, $2mgM4.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $2mgM4.originType).WEB ? (0, $2mgM4.platformType).WEB : (0, $2mgM4.platformType).DESKTOP;
        else (0, $9Cv3R.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $41a4X.isFedrampModerate)()) productInfo.perimeter = (0, $2mgM4.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $2mgM4.perimeterType).COMMERCIAL;
        if (!(0, $94FNv.isType)((0, $2mgM4.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $kfJIp.objectValues)((0, $2mgM4.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $9mhZO.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $IACFR.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $6allD.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $bUHQb.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $a40Zg.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $bXCOi.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $bfgv3.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $i6mDL.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $aVVpm.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $2Lib9.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $7shyU.default)();
        this._tabTracking = new (0, $dO86J.default)();
        this._sessionTracking = new (0, $gYCEb.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $cRoJC.default)();
        this._originTracing = new (0, $cRtxi.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $l3mz8.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $5mvra.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $c6ki9.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $72Hes.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $kTpbz.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $j5egH.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $aUf9S.TestSupport).isGeminiVREnvironment() && !(0, $aUf9S.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $aUf9S.TestSupport).isGeminiVREnvironment() && !(0, $aUf9S.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("9mhZO", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $f2e44ad62b339920$export$839b022803d38d4d);

var $iPUNO = parcelRequire("iPUNO");

var $j4SCE = parcelRequire("j4SCE");
function $f2e44ad62b339920$export$839b022803d38d4d() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return (0, $j4SCE.isIsolatedCloud)() ? (_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.icName : undefined;
    }
    const atlCtxCookieValues = (0, $iPUNO.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("j4SCE", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $c0ac9e4d30fe4dcc$export$9186ccba8effc5de);

var $cq0dB = parcelRequire("cq0dB");

var $iPUNO = parcelRequire("iPUNO");
function $c0ac9e4d30fe4dcc$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInIC) ?? false;
    }
    const atlCtxCookieValues = (0, $iPUNO.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $cq0dB.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("cq0dB", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $04d003a8c27238b2$export$d8347b4aae768c2d);

var $5nZb1 = parcelRequire("5nZb1");
const $04d003a8c27238b2$export$d8347b4aae768c2d = [
    (0, $5nZb1.COMMERCIAL)
];

});



parcelRegister("2mgM4", function(module, exports) {
$parcel$export(module.exports, "envType", () => $db31f648fe16725c$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $db31f648fe16725c$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $db31f648fe16725c$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $db31f648fe16725c$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $db31f648fe16725c$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $db31f648fe16725c$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $db31f648fe16725c$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $db31f648fe16725c$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $db31f648fe16725c$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $db31f648fe16725c$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $db31f648fe16725c$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $db31f648fe16725c$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $db31f648fe16725c$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $db31f648fe16725c$export$e73680b18d9b7c6e);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $db31f648fe16725c$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $db31f648fe16725c$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $db31f648fe16725c$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $db31f648fe16725c$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $db31f648fe16725c$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $db31f648fe16725c$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $db31f648fe16725c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $db31f648fe16725c$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $db31f648fe16725c$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $db31f648fe16725c$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $db31f648fe16725c$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $db31f648fe16725c$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $db31f648fe16725c$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $db31f648fe16725c$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $db31f648fe16725c$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("l3mz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $504698b4d2e1dd4c$export$2e2bcd8739ae039);

var $2mgM4 = parcelRequire("2mgM4");

var $94FNv = parcelRequire("94FNv");

var $7shyU = parcelRequire("7shyU");

var $iRBGm = parcelRequire("iRBGm");
class $504698b4d2e1dd4c$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $2mgM4.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $2mgM4.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $2mgM4.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $94FNv.isType)((0, $2mgM4.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $2mgM4.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $7shyU.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $iRBGm.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("94FNv", function(module, exports) {
$parcel$export(module.exports, "isType", () => $eb6782d00db087ff$export$26b9f946b448f23e);
function $eb6782d00db087ff$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("7shyU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8f55163402c2d29$export$2e2bcd8739ae039);
class $b8f55163402c2d29$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("iRBGm", function(module, exports) {
$parcel$export(module.exports, "default", () => $75e6e2e498cec816$export$2e2bcd8739ae039);
class $75e6e2e498cec816$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("4g9KI", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $b50d8da411aab8e2$export$7bf451af4a8e3dd9);

var $bAwc3 = parcelRequire("bAwc3");

var $fTHM6 = parcelRequire("fTHM6");

var $bqGM8 = parcelRequire("bqGM8");

var $1bwob = parcelRequire("1bwob");

var $jHKaP = parcelRequire("jHKaP");

var $1Whyw = parcelRequire("1Whyw");

var $6MYqZ = parcelRequire("6MYqZ");

var $7vQgP = parcelRequire("7vQgP");

var $eu4NM = parcelRequire("eu4NM");

var $9nMbT = parcelRequire("9nMbT");

var $iA7Pq = parcelRequire("iA7Pq");
function $b50d8da411aab8e2$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $6MYqZ.buildProductFields)(productInfo, (0, $iA7Pq.extractProductOverrides)(event));
    const tenantFields = (0, $7vQgP.buildTenantFields)(tenantInfo);
    const orgFields = (0, $1Whyw.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $9nMbT.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $bqGM8.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $eu4NM.buildUserFields)(userInfo);
    const actionFields = (0, $bAwc3.buildActionFields)(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...(0, $1bwob.buildEventOverrides)(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $fTHM6.buildAliases)(aliases),
        ...(0, $jHKaP.buildGroups)(groups)
    };
}

});
parcelRegister("bAwc3", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $c7ead0762fffa5db$export$655ecf7241feac42);

var $1VTQm = parcelRequire("1VTQm");
function $c7ead0762fffa5db$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...(0, $1VTQm.buildContainersWithName)(event.containers)
    };
}

});
parcelRegister("1VTQm", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $96bac26f177c4bfd$export$f045f238d77c002a);

var $iL1aK = parcelRequire("iL1aK");

var $lxGUi = parcelRequire("lxGUi");

var $iJmFG = parcelRequire("iJmFG");
function $96bac26f177c4bfd$export$f045f238d77c002a(containers) {
    if ((0, $iJmFG.isNotEmptyObject)(containers)) {
        const validContainers = (0, $lxGUi.filterAndBuildContainers)(containers);
        return (0, $iL1aK.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("iL1aK", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $da57b2d4bfc52721$export$55b70947967d0b50);

var $iJmFG = parcelRequire("iJmFG");
function $da57b2d4bfc52721$export$55b70947967d0b50(name, attrObject) {
    return (0, $iJmFG.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("iJmFG", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $122a23a033520bb0$export$e0287cc73292b477);

var $86fUc = parcelRequire("86fUc");
function $122a23a033520bb0$export$e0287cc73292b477(obj) {
    return (0, $86fUc.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("86fUc", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $ae7ab38e041f54db$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $ae7ab38e041f54db$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $ae7ab38e041f54db$var$isObjectObject(o) {
    return $ae7ab38e041f54db$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $ae7ab38e041f54db$export$53b83ca8eaab0383(o) {
    if ($ae7ab38e041f54db$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($ae7ab38e041f54db$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("lxGUi", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $22c542df02b67ce6$export$3f5115a568819c1a);
function $22c542df02b67ce6$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("fTHM6", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $c4d114bbd9f19db0$export$2c4ef8ee173bbcaa);

var $iJmFG = parcelRequire("iJmFG");
function $c4d114bbd9f19db0$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $iJmFG.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("bqGM8", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $9807c3f9ad33e005$export$d138783ff9effae1);
function $9807c3f9ad33e005$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("1bwob", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $e6b2d0ddabe70932$export$469803cc371327c2);
function $e6b2d0ddabe70932$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("jHKaP", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $1ab443ccd2ed986b$export$680f59e10d3eb269);

var $iJmFG = parcelRequire("iJmFG");
function $1ab443ccd2ed986b$export$680f59e10d3eb269(groups) {
    if ((0, $iJmFG.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("1Whyw", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $56a3fc31b94054e3$export$19ccbe55c9aa75d5);
function $56a3fc31b94054e3$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("6MYqZ", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $e7952e67e2566550$export$bd1896e45d2ef8e8);

var $5gCYo = parcelRequire("5gCYo");
function $e7952e67e2566550$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $5gCYo.getProductField)(productInfo.env, overrides.env);
    const product = (0, $5gCYo.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $5gCYo.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $5gCYo.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $5gCYo.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $5gCYo.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("5gCYo", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $f305c0987872c48e$export$690c718dc8037b2e);
function $f305c0987872c48e$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("7vQgP", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $7b8a53959910f6a5$export$ab02ab56ae59d840);
function $7b8a53959910f6a5$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("eu4NM", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $b53da91d81679f60$export$4557a3fdd8921d68);
function $b53da91d81679f60$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("9nMbT", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $5a25bde1ce30e577$export$73c41604cd4b31da);
function $5a25bde1ce30e577$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("iA7Pq", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $06f7f7cc6e3becd2$export$e3d99b4bfec06f6e);
function $06f7f7cc6e3becd2$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("665ng", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $edcc53b7ef46541e$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $edcc53b7ef46541e$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("bUHQb", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $d92b681d136e553e$export$3a7fe28f9bf4f3d9);

var $hUxuu = parcelRequire("hUxuu");
const $d92b681d136e553e$var$libraryVersion = undefined;
function $d92b681d136e553e$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $hUxuu.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $hUxuu.validationMode).QUIET;
    return (0, $hUxuu.validationMode).COMPLETE;
}
function $d92b681d136e553e$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $d92b681d136e553e$var$libraryVersion
            },
            validationMode: $d92b681d136e553e$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("hUxuu", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $cca603e8a517cb61$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $cca603e8a517cb61$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("bLquF", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $43c8f8577928ebbb$export$c7d9a5f56acc4b19);

var $2mgM4 = parcelRequire("2mgM4");

var $fTHM6 = parcelRequire("fTHM6");

var $iL1aK = parcelRequire("iL1aK");

var $bqGM8 = parcelRequire("bqGM8");

var $1VTQm = parcelRequire("1VTQm");

var $1bwob = parcelRequire("1bwob");

var $jHKaP = parcelRequire("jHKaP");

var $lB7xm = parcelRequire("lB7xm");

var $1Whyw = parcelRequire("1Whyw");

var $6MYqZ = parcelRequire("6MYqZ");

var $7vQgP = parcelRequire("7vQgP");

var $eu4NM = parcelRequire("eu4NM");

var $9nMbT = parcelRequire("9nMbT");
function $43c8f8577928ebbb$var$buildAttributes(attributes) {
    return (0, $iL1aK.buildAttributesWithName)('attributes', attributes);
}
function $43c8f8577928ebbb$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $iL1aK.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $43c8f8577928ebbb$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $6MYqZ.buildProductFields)(productInfo);
    const tenantFields = (0, $7vQgP.buildTenantFields)(tenantInfo);
    const userFields = (0, $eu4NM.buildUserFields)(userInfo);
    const orgFields = (0, $1Whyw.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $9nMbT.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $bqGM8.buildCollaborationContextFields)(collaborationContextInfo);
    return {
        eventType: (0, $2mgM4.eventType).SCREEN,
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...(0, $lB7xm.buildLocationFields)(event),
        ...$43c8f8577928ebbb$var$buildAttributes(attributes),
        ...$43c8f8577928ebbb$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...(0, $1VTQm.buildContainersWithName)(containers),
        ...(0, $1bwob.buildEventOverrides)(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $fTHM6.buildAliases)(aliases),
        ...(0, $jHKaP.buildGroups)(groups)
    };
}

});
parcelRegister("lB7xm", function(module, exports) {
$parcel$export(module.exports, "buildLocationFields", () => $5666395bef7ebaf4$export$6dfd201add24e54d);
function $5666395bef7ebaf4$export$6dfd201add24e54d(event) {
    const payload = typeof event === 'object' ? event : undefined;
    return {
        title: '',
        path: typeof (payload === null || payload === void 0 ? void 0 : payload.path) === 'string' ? payload.path : '',
        url: typeof (payload === null || payload === void 0 ? void 0 : payload.url) === 'string' ? payload.url : '',
        referrer: '',
        search: ''
    };
}

});


parcelRegister("amegk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7732d48854f1d585$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $7732d48854f1d585$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $7732d48854f1d585$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($7732d48854f1d585$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("j5egH", function(module, exports) {
$parcel$export(module.exports, "default", () => $45fb013a5029d918$export$2e2bcd8739ae039);

var $3SMkF = parcelRequire("3SMkF");

var $1oIBu = parcelRequire("1oIBu");

var $hpxdz = parcelRequire("hpxdz");

var $2mgM4 = parcelRequire("2mgM4");

var $6BZEC = parcelRequire("6BZEC");
const $45fb013a5029d918$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $1oIBu.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $45fb013a5029d918$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $2mgM4.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $hpxdz.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $6BZEC.default)($45fb013a5029d918$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $1oIBu.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $1oIBu.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $3SMkF.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("3SMkF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6c698667b985548$export$2e2bcd8739ae039);

var $7VVXk = parcelRequire("7VVXk");

var $41a4X = parcelRequire("41a4X");

var $dRkX9 = parcelRequire("dRkX9");

var $jyVtM = parcelRequire("jyVtM");

var $1rk8W = parcelRequire("1rk8W");
const $f6c698667b985548$export$b9dd752fb13352ce = 'interactionSession.source';
const $f6c698667b985548$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $f6c698667b985548$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($f6c698667b985548$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($f6c698667b985548$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $dRkX9.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $7VVXk.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $41a4X.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $jyVtM.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $1rk8W.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($f6c698667b985548$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($f6c698667b985548$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("7VVXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $3W6Ty = parcelRequire("3W6Ty");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $3W6Ty.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $3W6Ty.isFeatureEnabled;
    }
});

});
parcelRegister("3W6Ty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $41a4X = parcelRequire("41a4X");
var $j4SCE = parcelRequire("j4SCE");
var $9mhZO = parcelRequire("9mhZO");

var $eIE36 = parcelRequire("eIE36");

var $7tbhC = parcelRequire("7tbhC");

var $4DKbK = parcelRequire("4DKbK");

var $30jAN = parcelRequire("30jAN");
const $2ddc2311d98967a6$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $2ddc2311d98967a6$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $2ddc2311d98967a6$var$getBoundaryKey();
    return (0, $7tbhC.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $2ddc2311d98967a6$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $2ddc2311d98967a6$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $4DKbK.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $2ddc2311d98967a6$var$getBoundaryKey();
    const aemResult = (0, $7tbhC.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $7tbhC.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($2ddc2311d98967a6$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $30jAN.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $2ddc2311d98967a6$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $2ddc2311d98967a6$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $2ddc2311d98967a6$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $7tbhC.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $9mhZO.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $2ddc2311d98967a6$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $30jAN.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $7tbhC.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $30jAN.isSSR)() && localStorage.getItem(`${$2ddc2311d98967a6$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $2ddc2311d98967a6$var$shouldEnableForAudit;
function $2ddc2311d98967a6$var$getBoundaryKey() {
    if ((0, $41a4X.isFedrampModerate)()) return $7tbhC.FED_MOD_KEY;
    if ((0, $j4SCE.isIsolatedCloud)()) return $7tbhC.ISOLATED_CLOUD_COMMERCIAL_KEY;
    if ((0, $eIE36.isGoogleCloudPlatform)()) return $7tbhC.GOOGLE_CLOUD_PLATFORM_KEY;
    return $7tbhC.COMMERCIAL_KEY;
}
function $2ddc2311d98967a6$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$2ddc2311d98967a6$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $2ddc2311d98967a6$var$configureAuditState;
function $2ddc2311d98967a6$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$2ddc2311d98967a6$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $2ddc2311d98967a6$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $2ddc2311d98967a6$var$isFeatureEnabled,
    overrideFeature: $4DKbK.overrideFeature,
    clearFeatureOverride: $4DKbK.clearFeatureOverride,
    clearAllOverrides: $4DKbK.clearAllOverrides,
    configureAuditState: $2ddc2311d98967a6$var$configureAuditState,
    clearAuditState: $2ddc2311d98967a6$var$clearAuditState
};

});
parcelRegister("eIE36", function(module, exports) {
$parcel$export(module.exports, "isGoogleCloudPlatform", () => $646a7495374629cc$export$d62bd105df52518a);

var $5nZb1 = parcelRequire("5nZb1");

var $5TH1y = parcelRequire("5TH1y");
function $646a7495374629cc$export$d62bd105df52518a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInGCP) ?? false;
    }
    try {
        const cookies = globalThis.document.cookie;
        const cloudServiceProvider = (0, $5TH1y.getRawCookieValue)((0, $5nZb1.BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER), cookies);
        return cloudServiceProvider === (0, $5nZb1.CLOUD_SERVICE_PROVIDER_GCP);
    } catch (e) {
        return false;
    }
}

});

parcelRegister("7tbhC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $d3Tcr = parcelRequire("d3Tcr");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $d3Tcr.isEnvironmentBlockEnabledForBoundary;
    }
});

var $d3Tcr = parcelRequire("d3Tcr");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $d3Tcr.isFeatureEnabledForBoundary;
    }
});

var $d3Tcr = parcelRequire("d3Tcr");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $d3Tcr.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $lJCrm = parcelRequire("lJCrm");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $lJCrm.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $lJCrm.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $lJCrm.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $lJCrm.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $lJCrm.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "GOOGLE_CLOUD_PLATFORM_KEY", {
    enumerable: true,
    get: function() {
        return $lJCrm.GOOGLE_CLOUD_PLATFORM_KEY;
    }
});

});
parcelRegister("d3Tcr", function(module, exports) {
"use strict";
var $98265fb30b829386$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $98265fb30b829386$var$sdk_data_json_1 = $98265fb30b829386$var$__importDefault((parcelRequire("6a6tT")));
const $98265fb30b829386$var$aemEnvironmentBlockData = $98265fb30b829386$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $98265fb30b829386$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($98265fb30b829386$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $98265fb30b829386$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $98265fb30b829386$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $98265fb30b829386$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $98265fb30b829386$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $98265fb30b829386$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $98265fb30b829386$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($98265fb30b829386$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $98265fb30b829386$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$98265fb30b829386$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $98265fb30b829386$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $98265fb30b829386$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $98265fb30b829386$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$98265fb30b829386$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $98265fb30b829386$var$getFeatureAvailabilityMetadataForBoundary;
function $98265fb30b829386$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $98265fb30b829386$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$98265fb30b829386$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("6a6tT", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"gcp\":\"google-cloud-platform\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-findings\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-local-transcript-upload\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sdp-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-service-registry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"assets-software-catalog\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards-browser-network-compatibility-check\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"home\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-lead-time-for-changes-dxe\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-space-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"iris\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-deprecated-incident-timeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-sign-up\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-live-chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-notification-logs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-project-creation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-request-type-template\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sidebar-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-solution-composer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-agent-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-browser-extension-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-chat-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-safety\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"file-scanner-content-moderation-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"dxe-metrics-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve-cross-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"agent-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-send-message\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"org-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"ui-extensibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"export-control-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"guard-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cross-domain-attribute-service\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"c2c-middleware-assistant\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"external-data-sync\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"file-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"xpsearch-memory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"xpsearch-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-cloud-offering-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"smartlinks-datasource-ari-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"smartlinks-support-portal-fedramp\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"mcp-collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"eureka-cdp\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"streamhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-controlplane\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"cryptor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"em-l3-astra-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"customer-data-plane-pc-archetypes\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"k8s-ref-service\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"kitt-fleet-platform-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"test-product\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cell-routing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-governance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"telemetry-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"alkemia-engine\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("lJCrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = "google-cloud-platform";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY,
    module.exports.GOOGLE_CLOUD_PLATFORM_KEY
];
var $fd2b9e5dd0298ceb$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($fd2b9e5dd0298ceb$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $fd2b9e5dd0298ceb$var$UnderAuditPhase = {}));

});


parcelRegister("4DKbK", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $360ea206ffbf6a0a$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $360ea206ffbf6a0a$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $360ea206ffbf6a0a$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $360ea206ffbf6a0a$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $360ea206ffbf6a0a$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$360ea206ffbf6a0a$var$isBrowserEnvironment()) return null;
    const map = $360ea206ffbf6a0a$var$getOverridesMap();
    const key = $360ea206ffbf6a0a$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $360ea206ffbf6a0a$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $360ea206ffbf6a0a$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$360ea206ffbf6a0a$var$isBrowserEnvironment()) return;
    const map = $360ea206ffbf6a0a$var$getOverridesMap();
    map[$360ea206ffbf6a0a$var$buildKey(environmentBlockName, featureName)] = value;
    $360ea206ffbf6a0a$var$setOverridesMap(map);
}
module.exports.overrideFeature = $360ea206ffbf6a0a$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $360ea206ffbf6a0a$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$360ea206ffbf6a0a$var$isBrowserEnvironment()) return;
    const map = $360ea206ffbf6a0a$var$getOverridesMap();
    delete map[$360ea206ffbf6a0a$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $360ea206ffbf6a0a$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $360ea206ffbf6a0a$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $360ea206ffbf6a0a$var$clearAllOverrides() {
    if (!$360ea206ffbf6a0a$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $360ea206ffbf6a0a$var$clearAllOverrides;

});

parcelRegister("30jAN", function(module, exports) {

var $3jCFs = parcelRequire("3jCFs");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $230091da61f33bda$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $3jCFs !== "undefined" && $3jCFs && $3jCFs.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $230091da61f33bda$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $230091da61f33bda$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $230091da61f33bda$var$getEnvironmentType;

});



parcelRegister("jyVtM", function(module, exports) {
$parcel$export(module.exports, "default", () => $232ce4873ced0a72$export$2e2bcd8739ae039);

var $3pO6U = parcelRequire("3pO6U");
const $232ce4873ced0a72$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $232ce4873ced0a72$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($232ce4873ced0a72$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$232ce4873ced0a72$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$232ce4873ced0a72$export$7bc189309d2ad463] = new (0, $3pO6U.default)();
                interactionSessionTracking = window[$232ce4873ced0a72$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("3pO6U", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $613d57bd63faec36$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $613d57bd63faec36$export$2e2bcd8739ae039);

var $1rk8W = parcelRequire("1rk8W");
const $613d57bd63faec36$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $613d57bd63faec36$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $613d57bd63faec36$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $613d57bd63faec36$export$285f6bddd927a06d = 1800000; // 30 minutes
const $613d57bd63faec36$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $613d57bd63faec36$export$a92e915d70316eb2 = 5000; // 5 seconds
const $613d57bd63faec36$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $613d57bd63faec36$var$INTEGER_REGEX = /^\d+$/;
const $613d57bd63faec36$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $613d57bd63faec36$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($613d57bd63faec36$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($613d57bd63faec36$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $613d57bd63faec36$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $613d57bd63faec36$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $613d57bd63faec36$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $1rk8W.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($613d57bd63faec36$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $613d57bd63faec36$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $613d57bd63faec36$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($613d57bd63faec36$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($613d57bd63faec36$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("1rk8W", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7cd990c6ffa688f$export$2e2bcd8739ae039);

var $9Ze7M = parcelRequire("9Ze7M");

var $8QIiu = parcelRequire("8QIiu");
class $a7cd990c6ffa688f$export$2e2bcd8739ae039 extends (0, $8QIiu.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $9Ze7M.default);
        } catch (err) {
            storageToUse = (0, $9Ze7M.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("9Ze7M", function(module, exports) {
$parcel$export(module.exports, "default", () => $639a2c3b3b20b3ef$export$2e2bcd8739ae039);

var $ewk4M = parcelRequire("ewk4M");
// eslint-disable-next-line import/no-anonymous-default-export
const $639a2c3b3b20b3ef$var$inmemorystorage = new (0, $ewk4M.InMemoryStore)();
var $639a2c3b3b20b3ef$export$2e2bcd8739ae039 = $639a2c3b3b20b3ef$var$inmemorystorage;

});
parcelRegister("ewk4M", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $b8c7c630cbe4cf75$export$90e3e001bcac59c7);
class $b8c7c630cbe4cf75$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}

});


parcelRegister("8QIiu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e65b89942afe5b9e$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $XLmju = parcelRequire("XLmju");

var $9Ze7M = parcelRequire("9Ze7M");

var $bfwYd = parcelRequire("bfwYd");
const $e65b89942afe5b9e$export$41c06fdd37b7e9a5 = 'awc';
const $e65b89942afe5b9e$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $e65b89942afe5b9e$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $9Ze7M.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ((0, $bfwYd.isSupported)(window[$e65b89942afe5b9e$export$770aa8bc07b3de03])) inMemoryStorage = window[$e65b89942afe5b9e$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $9Ze7M.default);
                if (!window[$e65b89942afe5b9e$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$e65b89942afe5b9e$export$770aa8bc07b3de03] = (0, $9Ze7M.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($e65b89942afe5b9e$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $XLmju.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, $bfwYd.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("XLmju", function(module, exports) {
$parcel$export(module.exports, "envType", () => $51414fdfc1e4d47e$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $51414fdfc1e4d47e$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("bfwYd", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $b8558320ffb66957$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $b8558320ffb66957$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("1oIBu", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $4c8721183748fc0d$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $4c8721183748fc0d$export$2e3999ec51334ffe);
const $4c8721183748fc0d$export$81d16f1428ce0486 = 'xpis';
const $4c8721183748fc0d$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($4c8721183748fc0d$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("hpxdz", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $2a92188618962af2$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $2a92188618962af2$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'talent',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("6BZEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $704cfe3f5559ba31$export$2e2bcd8739ae039);

var $5AM1g = parcelRequire("5AM1g");

var $5mvra = parcelRequire("5mvra");

var $2QTxW = parcelRequire("2QTxW");
const $704cfe3f5559ba31$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $5mvra.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $5AM1g.parseUrl)(removedFragmentURL);
    const captureParams = (0, $2QTxW.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $2QTxW.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $5AM1g.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$704cfe3f5559ba31$export$2e2bcd8739ae039 = $704cfe3f5559ba31$var$urlParamExtractor;

});
parcelRegister("5AM1g", function(module, exports) {
$parcel$export(module.exports, "extract", () => $4125903651c0c27d$export$f9380c9a627682d3, (v) => $4125903651c0c27d$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $4125903651c0c27d$export$98e6a39c04603d36, (v) => $4125903651c0c27d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $4125903651c0c27d$export$fac44ee5b035f737, (v) => $4125903651c0c27d$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $4125903651c0c27d$export$7a5253c0f62e0150, (v) => $4125903651c0c27d$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $4125903651c0c27d$export$a8c1621ea79325d3, (v) => $4125903651c0c27d$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $4125903651c0c27d$export$357523c63a2253b9, (v) => $4125903651c0c27d$export$357523c63a2253b9 = v);
var $4125903651c0c27d$export$f9380c9a627682d3;
var $4125903651c0c27d$export$98e6a39c04603d36;
var $4125903651c0c27d$export$fac44ee5b035f737;
var $4125903651c0c27d$export$7a5253c0f62e0150;
var $4125903651c0c27d$export$a8c1621ea79325d3;
var $4125903651c0c27d$export$357523c63a2253b9;
var $4125903651c0c27d$export$44c361b8ec72ef7f;
'use strict';

var $aIK1L = parcelRequire("aIK1L");

var $8DUYv = parcelRequire("8DUYv");

var $2mt75 = parcelRequire("2mt75");

var $diEVb = parcelRequire("diEVb");
const $4125903651c0c27d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $4125903651c0c27d$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $4125903651c0c27d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            '[',
                            $4125903651c0c27d$var$encode(index, options),
                            ']=',
                            $4125903651c0c27d$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            '[]=',
                            $4125903651c0c27d$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            ':list=',
                            $4125903651c0c27d$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $4125903651c0c27d$var$encode(key, options),
                                keyValueSep,
                                $4125903651c0c27d$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $4125903651c0c27d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $4125903651c0c27d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $4125903651c0c27d$var$encode(key, options),
                            '=',
                            $4125903651c0c27d$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $4125903651c0c27d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $4125903651c0c27d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $4125903651c0c27d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$4125903651c0c27d$var$decode(item, options)) : value === null ? value : $4125903651c0c27d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $4125903651c0c27d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$4125903651c0c27d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $4125903651c0c27d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $4125903651c0c27d$var$encode(value, options) {
    if (options.encode) return options.strict ? $aIK1L(value) : encodeURIComponent(value);
    return value;
}
function $4125903651c0c27d$var$decode(value, options) {
    if (options.decode) return $8DUYv(value);
    return value;
}
function $4125903651c0c27d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $4125903651c0c27d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $4125903651c0c27d$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $4125903651c0c27d$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $4125903651c0c27d$var$extract(input) {
    input = $4125903651c0c27d$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $4125903651c0c27d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $4125903651c0c27d$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $4125903651c0c27d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $4125903651c0c27d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $2mt75(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $4125903651c0c27d$var$decode(value, options);
        formatter($4125903651c0c27d$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $4125903651c0c27d$var$parseValue(value[k], options);
        else ret[key] = $4125903651c0c27d$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $4125903651c0c27d$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$4125903651c0c27d$export$f9380c9a627682d3 = $4125903651c0c27d$var$extract;
$4125903651c0c27d$export$98e6a39c04603d36 = $4125903651c0c27d$var$parse;
$4125903651c0c27d$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $4125903651c0c27d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $4125903651c0c27d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $4125903651c0c27d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $4125903651c0c27d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $4125903651c0c27d$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $4125903651c0c27d$var$encode(key, options) + '=' + $4125903651c0c27d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$4125903651c0c27d$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $2mt75(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $4125903651c0c27d$var$parse($4125903651c0c27d$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $4125903651c0c27d$var$decode(hash, options)
    } : {});
};
$4125903651c0c27d$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$4125903651c0c27d$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $4125903651c0c27d$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $4125903651c0c27d$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $4125903651c0c27d$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $4125903651c0c27d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $4125903651c0c27d$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$4125903651c0c27d$var$encodeFragmentIdentifier] ? $4125903651c0c27d$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$4125903651c0c27d$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$4125903651c0c27d$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $4125903651c0c27d$export$7a5253c0f62e0150(input, options);
    return $4125903651c0c27d$export$a8c1621ea79325d3({
        url: url,
        query: $diEVb(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$4125903651c0c27d$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $4125903651c0c27d$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("aIK1L", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("8DUYv", function(module, exports) {
'use strict';
var $64ae294947ee27d8$var$token = '%[a-f0-9]{2}';
var $64ae294947ee27d8$var$singleMatcher = new RegExp('(' + $64ae294947ee27d8$var$token + ')|([^%]+?)', 'gi');
var $64ae294947ee27d8$var$multiMatcher = new RegExp('(' + $64ae294947ee27d8$var$token + ')+', 'gi');
function $64ae294947ee27d8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $64ae294947ee27d8$var$decodeComponents(left), $64ae294947ee27d8$var$decodeComponents(right));
}
function $64ae294947ee27d8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($64ae294947ee27d8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $64ae294947ee27d8$var$decodeComponents(tokens, i).join('');
            tokens = input.match($64ae294947ee27d8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $64ae294947ee27d8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $64ae294947ee27d8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $64ae294947ee27d8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $64ae294947ee27d8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $64ae294947ee27d8$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("2mt75", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("diEVb", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("5mvra", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $14a3a8065e4df201$export$600dd5bf1b049f11);
const $14a3a8065e4df201$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("2QTxW", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $3a8fb8fb0c72a224$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $3a8fb8fb0c72a224$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $3a8fb8fb0c72a224$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $3a8fb8fb0c72a224$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $3a8fb8fb0c72a224$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $3a8fb8fb0c72a224$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $3a8fb8fb0c72a224$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $3a8fb8fb0c72a224$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $3a8fb8fb0c72a224$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $3a8fb8fb0c72a224$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $3a8fb8fb0c72a224$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $3a8fb8fb0c72a224$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $3a8fb8fb0c72a224$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$3a8fb8fb0c72a224$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $3a8fb8fb0c72a224$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("c6ki9", function(module, exports) {
$parcel$export(module.exports, "default", () => $72154d902983f1a1$export$2e2bcd8739ae039);

var $b6IUy = parcelRequire("b6IUy");

var $9VBBr = parcelRequire("9VBBr");

var $7Xtdx = parcelRequire("7Xtdx");
class $72154d902983f1a1$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $b6IUy.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $b6IUy.MAX_DELAY_TIMEOUT)) : (0, $b6IUy.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $7Xtdx.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $7Xtdx.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $9VBBr.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("b6IUy", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $0cf24b0175a9ef88$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $0cf24b0175a9ef88$export$8575e30be0feb909);
const $0cf24b0175a9ef88$export$cf090d5281b5ae06 = 10000;
const $0cf24b0175a9ef88$export$8575e30be0feb909 = 30000;

});

parcelRegister("9VBBr", function(module, exports) {
$parcel$export(module.exports, "default", () => $533c782871511602$export$2e2bcd8739ae039);

var $665ng = parcelRequire("665ng");

var $2QTxW = parcelRequire("2QTxW");

var $8lNQj = parcelRequire("8lNQj");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $533c782871511602$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $533c782871511602$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $533c782871511602$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $533c782871511602$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $533c782871511602$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $2QTxW.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $2QTxW.equals)(group.userInfo, args.userInfo) && (0, $2QTxW.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $665ng.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $8lNQj.default)(compressionRules);
    }
}

});
parcelRegister("8lNQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $888fdda03fd0cff6$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $bAwc3 = parcelRequire("bAwc3");

var $2QTxW = parcelRequire("2QTxW");

var $tiA5M = parcelRequire("tiA5M");
class $888fdda03fd0cff6$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $bAwc3.buildActionFields)(event, event.eventType);
                    contextFields = (0, $2QTxW.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $2QTxW.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $tiA5M.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("tiA5M", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $557ccb6761c84e53$export$89b3253ddfd2e6e8);

var $a1PTH = parcelRequire("a1PTH");

var $2QTxW = parcelRequire("2QTxW");

var $m66xS = parcelRequire("m66xS");

var $lhPxB = parcelRequire("lhPxB");
class $557ccb6761c84e53$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ this.canCompress = (event)=>{
            try {
                return event && (0, $a1PTH.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $2QTxW.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $lhPxB.validateActionEventType)(event.eventType);
                (0, $m66xS.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("a1PTH", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $24805bcd2b5cd08d$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2mgM4 = parcelRequire("2mgM4");
function $24805bcd2b5cd08d$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $2mgM4.eventType).OPERATIONAL:
        case (0, $2mgM4.eventType).TRACK:
        case (0, $2mgM4.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("m66xS", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $46c1849b0632ae65$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $bsjOM = parcelRequire("bsjOM");
function $46c1849b0632ae65$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $bsjOM.validateContainers)(event.containers);
}

});
parcelRegister("bsjOM", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $85d60501ccb11333$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $f1Gnb = parcelRequire("f1Gnb");
function $85d60501ccb11333$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $f1Gnb.validateContainersObject)(container));
}

});
parcelRegister("f1Gnb", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $f65fee5feb0f063a$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $86fUc = parcelRequire("86fUc");
function $f65fee5feb0f063a$export$df8ff30e3c960006(container) {
    if (!(0, $86fUc.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("lhPxB", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $df40bcd01f478748$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2mgM4 = parcelRequire("2mgM4");

var $a1PTH = parcelRequire("a1PTH");
const $df40bcd01f478748$var$actionEventTypes = Object.freeze([
    (0, $2mgM4.eventType).OPERATIONAL,
    (0, $2mgM4.eventType).TRACK,
    (0, $2mgM4.eventType).UI
]);
function $df40bcd01f478748$export$4a8d7476662aebcc(type) {
    if (!(0, $a1PTH.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$df40bcd01f478748$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("7Xtdx", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $3f2f6f57958a1b30$export$fa6e3729c21cb8f);
var $3f2f6f57958a1b30$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("aVVpm", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf9df1a2d8e2538e$export$2e2bcd8739ae039);

var $au7Tf = parcelRequire("au7Tf");

var $9hWrn = parcelRequire("9hWrn");

var $kTpbz = parcelRequire("kTpbz");

var $hCM8Y = parcelRequire("hCM8Y");

var $iNY2O = parcelRequire("iNY2O");

var $ikfoV = parcelRequire("ikfoV");

var $6n7YX = parcelRequire("6n7YX");

var $fBylk = parcelRequire("fBylk");

var $9kddK = parcelRequire("9kddK");

var $sQHH5 = parcelRequire("sQHH5");

var $1yKez = parcelRequire("1yKez");

var $eSoBx = parcelRequire("eSoBx");

var $hScKv = parcelRequire("hScKv");

var $4dh7b = parcelRequire("4dh7b");

var $iMpvQ = parcelRequire("iMpvQ");

var $d1m5C = parcelRequire("d1m5C");
class $cf9df1a2d8e2538e$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $cf9df1a2d8e2538e$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $cf9df1a2d8e2538e$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $cf9df1a2d8e2538e$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                var _this$originTracingCl;
                const response = await (0, $4dh7b.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this$originTracingCl = this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $9kddK.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $1yKez.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $iMpvQ.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $1yKez.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        var _this$options;
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $6n7YX.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $d1m5C.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $9hWrn.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $au7Tf.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $iMpvQ.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $iMpvQ.SegmentEventTypes).TRACK,
            properties: (0, $hScKv.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $iMpvQ.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $iMpvQ.SegmentEventTypes).PAGE,
            properties: (0, $hScKv.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $iMpvQ.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $iMpvQ.SegmentEventTypes).IDENTIFY,
            traits: (0, $hScKv.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $eSoBx.prepareEventContext)(context);
        const segmentContext = (0, $ikfoV.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $kTpbz.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $cf9df1a2d8e2538e$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $cf9df1a2d8e2538e$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $cf9df1a2d8e2538e$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $hCM8Y.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $cf9df1a2d8e2538e$var$BatchInterceptor {
    static #_ = this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $fBylk.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $iNY2O.AnalyticsResponse)(success, statusCode, (0, $sQHH5.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $sQHH5.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $sQHH5.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $sQHH5.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $fBylk.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $iNY2O.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($cf9df1a2d8e2538e$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $fBylk.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $iNY2O.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $fBylk.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $iNY2O.AnalyticsResponse)(false, -1, (0, $sQHH5.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("au7Tf", function(module, exports) {
$parcel$export(module.exports, "default", () => $659fefb8ad9069cf$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lJnIv = parcelRequire("lJnIv");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$659fefb8ad9069cf$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $lJnIv.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("lJnIv", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $4f3c705fc619295b$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $4f3c705fc619295b$export$2e2bcd8739ae039);

var $9RJSQ = parcelRequire("9RJSQ");

var $gVYzm = parcelRequire("gVYzm");

var $ibP7c = parcelRequire("ibP7c");

var $fTZRL = parcelRequire("fTZRL");

var $jY4Sp = parcelRequire("jY4Sp");

var $9hWrn = parcelRequire("9hWrn");

var $47EPR = parcelRequire("47EPR");

var $2VlDS = parcelRequire("2VlDS");

var $jCcAI = parcelRequire("jCcAI");

var $hmONp = parcelRequire("hmONp");
const $4f3c705fc619295b$var$ONE_MINUTE = 60000;
const $4f3c705fc619295b$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $4f3c705fc619295b$var$ONE_MINUTE,
    minRetryDelay: $4f3c705fc619295b$var$ONE_MINUTE,
    maxRetryDelay: $4f3c705fc619295b$var$ONE_MINUTE
};
const $4f3c705fc619295b$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $4f3c705fc619295b$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $ibP7c.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $4f3c705fc619295b$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $2VlDS.default)({
            ...this.options,
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $2VlDS.default)({
            ...$4f3c705fc619295b$var$LONG_POLLING_OPTIONS,
            waitInterval: $4f3c705fc619295b$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $9hWrn.default)();
        this.networkStatus = new (0, $47EPR.default)((status)=>{
            if (status === (0, $hmONp.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $fTZRL.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $hmONp.NetworkStatusEnum).OFFLINE) {
            done((0, $jCcAI.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $jY4Sp.CallbackProcessingErrorName)) {
                done((0, $jCcAI.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $9RJSQ.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $gVYzm.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $fTZRL.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $jCcAI.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $jCcAI.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $jCcAI.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $4f3c705fc619295b$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $4f3c705fc619295b$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $4f3c705fc619295b$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $4f3c705fc619295b$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $4f3c705fc619295b$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $4f3c705fc619295b$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $4f3c705fc619295b$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $4f3c705fc619295b$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $4f3c705fc619295b$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("9RJSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d58a1f6562fbbc9$export$2e2bcd8739ae039);

var $3BvKu = parcelRequire("3BvKu");

var $k0XCG = parcelRequire("k0XCG");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $6d58a1f6562fbbc9$var$validSuffixs = Object.values((0, $3BvKu.LocalStorageKeySuffix));
var $6d58a1f6562fbbc9$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $6d58a1f6562fbbc9$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $3BvKu.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $k0XCG.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("3BvKu", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $26a74b51fa09ade9$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $26a74b51fa09ade9$export$8bb2c1fb2b1765a9);
var $26a74b51fa09ade9$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $26a74b51fa09ade9$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("k0XCG", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $61c4bee38fc6361c$export$8433d54f767cbec5);

var $3BvKu = parcelRequire("3BvKu");
const $61c4bee38fc6361c$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $3BvKu.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $3BvKu.LocalStorageKeySuffix).ACK}`,
        [(0, $3BvKu.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $3BvKu.LocalStorageKeySuffix).QUEUE}`,
        [(0, $3BvKu.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $3BvKu.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $3BvKu.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $3BvKu.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $3BvKu.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $3BvKu.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("gVYzm", function(module, exports) {
$parcel$export(module.exports, "default", () => $134b5dbc03b47315$export$2e2bcd8739ae039);

var $kTpbz = parcelRequire("kTpbz");

var $3BvKu = parcelRequire("3BvKu");

var $k0XCG = parcelRequire("k0XCG");
const $134b5dbc03b47315$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $134b5dbc03b47315$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $3BvKu.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $3BvKu.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $134b5dbc03b47315$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $134b5dbc03b47315$var$promisedSetTimeout((0, $3BvKu.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $3BvKu.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $134b5dbc03b47315$var$promisedSetTimeout((0, $3BvKu.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $3BvKu.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $134b5dbc03b47315$var$reclaim(options, callback);
};
const $134b5dbc03b47315$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $134b5dbc03b47315$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $134b5dbc03b47315$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $134b5dbc03b47315$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $134b5dbc03b47315$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $kTpbz.default)();
    const queuesToReclaim = $134b5dbc03b47315$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$134b5dbc03b47315$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $k0XCG.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("kTpbz", function(module, exports) {
$parcel$export(module.exports, "default", () => $82ac23d68a7b2ed5$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $82ac23d68a7b2ed5$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("ibP7c", function(module, exports) {
$parcel$export(module.exports, "default", () => $793914d945827ee8$export$2e2bcd8739ae039);

var $iHpcP = parcelRequire("iHpcP");
var $793914d945827ee8$export$2e2bcd8739ae039 = (0, $iHpcP.default);

});
parcelRegister("iHpcP", function(module, exports) {
$parcel$export(module.exports, "default", () => $986d11191b297908$export$2e2bcd8739ae039);

var $fTZRL = parcelRequire("fTZRL");

var $EKePI = parcelRequire("EKePI");

var $3T0yM = parcelRequire("3T0yM");

var $aDU2R = parcelRequire("aDU2R");

var $lrA0C = parcelRequire("lrA0C");

var $gDkUw = parcelRequire("gDkUw");
class $986d11191b297908$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $EKePI.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $lrA0C.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $3T0yM.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $gDkUw.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $fTZRL.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $fTZRL.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $aDU2R.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $fTZRL.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $gDkUw.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $fTZRL.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("fTZRL", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $32b410109873a565$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $32b410109873a565$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $32b410109873a565$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $32b410109873a565$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $32b410109873a565$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $32b410109873a565$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $32b410109873a565$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $32b410109873a565$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $32b410109873a565$export$7710d69e6f450f20);
const $32b410109873a565$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $32b410109873a565$export$8cad224051643259 = 'analytics-web-client';
const $32b410109873a565$export$3d8420be07b276ab = 'analytics-resilience';
const $32b410109873a565$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $32b410109873a565$export$89d9c1ff8ac91862 = 'timeAdded';
const $32b410109873a565$export$a37d385bcd713809 = 'retryAttempts';
const $32b410109873a565$export$6d8635fed0e4b14d = 15000;
var $32b410109873a565$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $32b410109873a565$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("EKePI", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $ff384eca05aa20f8$export$ddc6718318090f71);

var $eeTZ3 = parcelRequire("eeTZ3");
const $ff384eca05aa20f8$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $eeTZ3.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $eeTZ3.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("eeTZ3", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $031bb5dc3024289d$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $031bb5dc3024289d$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $031bb5dc3024289d$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $031bb5dc3024289d$export$1188664dfff364c8);
const $031bb5dc3024289d$export$b6df3d334cec060f = 7;
const $031bb5dc3024289d$export$14ef152a03a4b6ee = 60000;
const $031bb5dc3024289d$export$da9ab7b2fd5998e8 = 10;
const $031bb5dc3024289d$export$1188664dfff364c8 = 8000;

});


parcelRegister("3T0yM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fc9b617d946a344$export$2e2bcd8739ae039);
const $4fc9b617d946a344$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $4fc9b617d946a344$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4fc9b617d946a344$export$2e2bcd8739ae039.prototype);
        this.name = $4fc9b617d946a344$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("aDU2R", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $0204274c9f745147$export$74101021e0969375);

var $glMaf = parcelRequire("glMaf");

var $jY4Sp = parcelRequire("jY4Sp");

var $enkCp = parcelRequire("enkCp");
const $0204274c9f745147$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $glMaf.AbandonWriteErrorName) || errorWithName.name === (0, $jY4Sp.CallbackProcessingErrorName) || errorWithName.name === (0, $enkCp.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("glMaf", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $b06d0242e3c34c21$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $b06d0242e3c34c21$export$2e2bcd8739ae039);
const $b06d0242e3c34c21$export$ba95206613c96b28 = 'AbandonWriteError';
class $b06d0242e3c34c21$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b06d0242e3c34c21$export$2e2bcd8739ae039.prototype);
        this.name = $b06d0242e3c34c21$export$ba95206613c96b28;
    }
}

});

parcelRegister("jY4Sp", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $c4a5ee7a49a7287b$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $c4a5ee7a49a7287b$export$2e2bcd8739ae039);
const $c4a5ee7a49a7287b$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $c4a5ee7a49a7287b$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c4a5ee7a49a7287b$export$2e2bcd8739ae039.prototype);
        this.name = $c4a5ee7a49a7287b$export$a409c8de90e11e14;
    }
}

});

parcelRegister("enkCp", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $db0f75207e99ea5a$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $db0f75207e99ea5a$export$2e2bcd8739ae039);
const $db0f75207e99ea5a$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $db0f75207e99ea5a$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $db0f75207e99ea5a$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("lrA0C", function(module, exports) {
$parcel$export(module.exports, "default", () => $f084b3f3415c67df$export$2e2bcd8739ae039);

var $5hNhv = parcelRequire("5hNhv");

var $fTZRL = parcelRequire("fTZRL");

var $e5731 = parcelRequire("e5731");

var $EKePI = parcelRequire("EKePI");

var $eeTZ3 = parcelRequire("eeTZ3");

var $jY4Sp = parcelRequire("jY4Sp");

var $enkCp = parcelRequire("enkCp");

var $3T0yM = parcelRequire("3T0yM");

var $aDU2R = parcelRequire("aDU2R");

var $6EWWa = parcelRequire("6EWWa");

var $7oRKi = parcelRequire("7oRKi");

var $4pRiH = parcelRequire("4pRiH");
class $f084b3f3415c67df$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $3T0yM.default)());
                    }, (0, $fTZRL.INDEXEDDB_TIMEOUT));
                    /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $fTZRL.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $fTZRL.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $fTZRL.TIME_TO_PROCESS_AFTER_INDEX), (0, $fTZRL.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $fTZRL.RETRY_INDEX), (0, $fTZRL.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $fTZRL.TIME_ADDED_INDEX), (0, $fTZRL.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $fTZRL.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $3T0yM.default)());
                    };
                    try {
                        await (0, $4pRiH.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $3T0yM.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $3T0yM.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $fTZRL.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $e5731.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $fTZRL.GuardPolicy).IGNORE) throw new (0, $enkCp.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $aDU2R.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $fTZRL.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $e5731.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $aDU2R.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $eeTZ3.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $eeTZ3.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $fTZRL.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $eeTZ3.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $7oRKi.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $7oRKi.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $5hNhv.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $5hNhv.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $fTZRL.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $4pRiH.requestToPromise)(request);
            await (0, $5hNhv.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $eeTZ3.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $jY4Sp.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $4pRiH.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $fTZRL.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $fTZRL.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $EKePI.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $3T0yM.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $6EWWa.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $fTZRL.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("5hNhv", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $77af1612745b757e$export$feab8418f018df89);

var $3Rs2y = parcelRequire("3Rs2y");
const $77af1612745b757e$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $3Rs2y.transactionToPromise)(transaction);
};

});
parcelRegister("3Rs2y", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $63c568b2ace408b8$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $63c568b2ace408b8$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("e5731", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $5cbaf0ade95a362c$export$aec476f33d77be11);

var $kTpbz = parcelRequire("kTpbz");
const $5cbaf0ade95a362c$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $kTpbz.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("6EWWa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3bad8a9fcb3dbb7$export$2e2bcd8739ae039);

var $5hNhv = parcelRequire("5hNhv");

var $fTZRL = parcelRequire("fTZRL");

var $glMaf = parcelRequire("glMaf");

var $4pRiH = parcelRequire("4pRiH");
class $d3bad8a9fcb3dbb7$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ this.deleteOldestNEvents = async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $fTZRL.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $4pRiH.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $fTZRL.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $fTZRL.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $fTZRL.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $fTZRL.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $4pRiH.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $5hNhv.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $glMaf.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $fTZRL.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $4pRiH.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("4pRiH", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $1b47aa0b40b94cc6$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $1b47aa0b40b94cc6$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("7oRKi", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $ba08431e4f25444a$export$342d941b6f724995);
const $ba08431e4f25444a$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("gDkUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f673ea8119db99b$export$2e2bcd8739ae039);

var $fTZRL = parcelRequire("fTZRL");

var $e5731 = parcelRequire("e5731");

var $EKePI = parcelRequire("EKePI");

var $eeTZ3 = parcelRequire("eeTZ3");

var $jY4Sp = parcelRequire("jY4Sp");

var $enkCp = parcelRequire("enkCp");

var $iyLma = parcelRequire("iyLma");
class $2f673ea8119db99b$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $EKePI.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $iyLma.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $fTZRL.GuardPolicy).ABANDON) {
        if (policy === (0, $fTZRL.GuardPolicy).IGNORE) throw new (0, $enkCp.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $e5731.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $fTZRL.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $e5731.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $fTZRL.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $eeTZ3.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $eeTZ3.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $eeTZ3.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $eeTZ3.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $jY4Sp.default)(error);
        }
    }
    storeType() {
        return (0, $fTZRL.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("iyLma", function(module, exports) {
$parcel$export(module.exports, "default", () => $43d5a19ebe6f766f$export$2e2bcd8739ae039);

var $fTZRL = parcelRequire("fTZRL");

var $glMaf = parcelRequire("glMaf");
class $43d5a19ebe6f766f$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $fTZRL.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $fTZRL.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $fTZRL.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $glMaf.default)((0, $fTZRL.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("9hWrn", function(module, exports) {
$parcel$export(module.exports, "default", () => $86832940d0117601$export$2e2bcd8739ae039);

var $bHJni = parcelRequire("bHJni");
let $86832940d0117601$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$86832940d0117601$export$2e2bcd8739ae039 = ()=>{
    if (!$86832940d0117601$var$cachedMetricsClient) $86832940d0117601$var$cachedMetricsClient = new (0, $bHJni.MetricsCollector)();
    return $86832940d0117601$var$cachedMetricsClient;
};

});
parcelRegister("bHJni", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $04f79b8a033cc158$export$4b62ee5120ab50a8);

var $hmONp = parcelRequire("hmONp");
class $04f79b8a033cc158$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $hmONp.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}

});
parcelRegister("hmONp", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $e9a31db0e9377996$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $e9a31db0e9377996$export$ee138fa712d11b84);
var $e9a31db0e9377996$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $e9a31db0e9377996$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("47EPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $84be10e991a12098$export$2e2bcd8739ae039);

var $hmONp = parcelRequire("hmONp");
class $84be10e991a12098$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $hmONp.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $hmONp.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $hmONp.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $hmONp.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $hmONp.NetworkStatusEnum).ONLINE;
        return (0, $hmONp.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("2VlDS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6db69f610f995d0$export$2e2bcd8739ae039);

var $3lyis = parcelRequire("3lyis");

var $jCcAI = parcelRequire("jCcAI");
const $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $e6db69f610f995d0$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $e6db69f610f995d0$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $jCcAI.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $jCcAI.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $3lyis.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $jCcAI.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $e6db69f610f995d0$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $3lyis.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("3lyis", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $7a33042207075afd$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $7a33042207075afd$export$590a718599f8f8b3);
var $7a33042207075afd$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $7a33042207075afd$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $7a33042207075afd$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("jCcAI", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $3fab2b1a64553d89$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $3fab2b1a64553d89$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("hCM8Y", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $6e9edafafdd6f9ee$export$c21270cab66ab290);

var $6Lgfl = parcelRequire("6Lgfl");
async function $6e9edafafdd6f9ee$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $6Lgfl.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("6Lgfl", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $af1bd22ce2c9ecb4$export$c9c3aaf655d6f275);

var $iMpvQ = parcelRequire("iMpvQ");
function $af1bd22ce2c9ecb4$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $iMpvQ.SegmentEventTypes).PAGE || item.msg.type === (0, $iMpvQ.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $iMpvQ.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}

});
parcelRegister("iMpvQ", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $4af099c1c3ed9885$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $4af099c1c3ed9885$export$96f086dcf574a9e2);
var $4af099c1c3ed9885$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $4af099c1c3ed9885$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $4af099c1c3ed9885$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $4af099c1c3ed9885$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("iNY2O", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $f89eaa60f9a49ae3$export$133650fcdde1b226);
class $f89eaa60f9a49ae3$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("ikfoV", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $867bca200db50d63$export$3a7fe28f9bf4f3d9);

var $557Iy = parcelRequire("557Iy");
// Shallow removal of all falsey properties from an object, returning a new object.
const $867bca200db50d63$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $867bca200db50d63$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...(0, $557Iy.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = {
        ...result.userConsents,
        ...(0, $557Iy.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $867bca200db50d63$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("557Iy", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $ed745e411693f1e4$export$2250ccecd1e040fd);
// This function will essentially deepClone as well
const $ed745e411693f1e4$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("6n7YX", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $91c40009a8062442$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $91c40009a8062442$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $91c40009a8062442$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $91c40009a8062442$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $91c40009a8062442$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $91c40009a8062442$export$6f1c008dd0c3b67e);
const $91c40009a8062442$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $91c40009a8062442$export$8fddcd1eff390364 = 60000; // 60 seconds
const $91c40009a8062442$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $91c40009a8062442$export$6649d5c857717efe = 5000; // 5 seconds
const $91c40009a8062442$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $91c40009a8062442$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("fBylk", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $d23da3b106943263$export$51e0b986fdbf3840);
class $d23da3b106943263$export$51e0b986fdbf3840 {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("9kddK", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $0b99d2d3bde2751b$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $0b99d2d3bde2751b$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("sQHH5", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $a25bc9743846a7e9$export$ba118f9de1e5ac63);
const $a25bc9743846a7e9$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("1yKez", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $763ab1dac871b250$export$a63e16b3351b8c36);

var $9kddK = parcelRequire("9kddK");
class $763ab1dac871b250$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $9kddK.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("eSoBx", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $32388081cdeb8c65$export$6b26e26d40264200);
// @ts-ignore

var $lT6zO = parcelRequire("lT6zO");

var $557Iy = parcelRequire("557Iy");
const $32388081cdeb8c65$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $557Iy.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT6zO)))(propertiesWithoutUndefined);
};

});
parcelRegister("lT6zO", function(module, exports) {
'use strict';

var $lLwbl = parcelRequire("lLwbl");
/**
 * Expose `traverse`.
 */ module.exports = $fef3d60886bbe6e5$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $fef3d60886bbe6e5$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $fef3d60886bbe6e5$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $fef3d60886bbe6e5$var$traverseArray(input, strict);
    else if ($lLwbl.is(input, strict)) return $lLwbl.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $fef3d60886bbe6e5$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $fef3d60886bbe6e5$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $fef3d60886bbe6e5$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $fef3d60886bbe6e5$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("lLwbl", function(module, exports) {
$parcel$export(module.exports, "parse", () => $fd86f370cacf98f1$export$98e6a39c04603d36, (v) => $fd86f370cacf98f1$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $fd86f370cacf98f1$export$226b3eccf92c9ed9, (v) => $fd86f370cacf98f1$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $fd86f370cacf98f1$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $fd86f370cacf98f1$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $fd86f370cacf98f1$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$fd86f370cacf98f1$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $fd86f370cacf98f1$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$fd86f370cacf98f1$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $fd86f370cacf98f1$var$matcher.test(string);
};

});



parcelRegister("hScKv", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $5a924e0a739a55d7$export$44d22e5fb02cc68e);
// @ts-ignore

var $lT6zO = parcelRequire("lT6zO");

var $557Iy = parcelRequire("557Iy");
const $5a924e0a739a55d7$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $557Iy.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT6zO)))(propertiesWithoutUndefined);
};

});

parcelRegister("4dh7b", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $e6984e2cc4576355$export$8e8f0180c1b41fad);

var $jiju3 = parcelRequire("jiju3");

var $cHdIu = parcelRequire("cHdIu");

var $9kddK = parcelRequire("9kddK");
const $e6984e2cc4576355$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $e6984e2cc4576355$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $e6984e2cc4576355$var$getCorsForUrl(options.url);
    const payload = await (0, $cHdIu.createRequestPayload)(options.batch);
    const response = await fetch(options.url, {
        method: 'POST',
        ...payload,
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $9kddK.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $9kddK.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $e6984e2cc4576355$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $e6984e2cc4576355$var$getCorsForUrl = (0, $jiju3.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("jiju3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0becfd8b66f43ef$export$2e2bcd8739ae039);
var $e0becfd8b66f43ef$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e0becfd8b66f43ef$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e0becfd8b66f43ef$var$safeIsNaN(first) && $e0becfd8b66f43ef$var$safeIsNaN(second)) return true;
    return false;
}
function $e0becfd8b66f43ef$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e0becfd8b66f43ef$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e0becfd8b66f43ef$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e0becfd8b66f43ef$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("cHdIu", function(module, exports) {
$parcel$export(module.exports, "createRequestPayload", () => $e6faae816efcda92$export$714cf425c39c51a5);

var $dRkX9 = parcelRequire("dRkX9");
const $e6faae816efcda92$var$REQUEST_COMPRESSION_GATE = 'analytics-web-client-request-compression';
const $e6faae816efcda92$var$gzip = async (body)=>{
    try {
        // Feature-detected below; the compat data lags browsers that support CompressionStream.
        // eslint-disable-next-line compat/compat
        const reader = new Blob([
            body
        ]).stream().pipeThrough(new CompressionStream('gzip')).getReader();
        const chunks = [];
        for(let next = await reader.read(); !next.done; next = await reader.read())chunks.push(next.value);
        return new Blob(chunks);
    } catch  {
        return undefined;
    }
};
const $e6faae816efcda92$export$714cf425c39c51a5 = async (batch)=>{
    const body = JSON.stringify(batch);
    const compressedBody = (0, $dRkX9.fg)($e6faae816efcda92$var$REQUEST_COMPRESSION_GATE) && typeof CompressionStream !== 'undefined' ? await $e6faae816efcda92$var$gzip(body) : undefined;
    return {
        // Plain requests avoid preflights. Compressed requests also require CORS to allow Content-Encoding.
        headers: {
            'Content-Type': 'text/plain',
            ...compressedBody ? {
                'Content-Encoding': 'gzip'
            } : {}
        },
        body: compressedBody ?? body
    };
};

});


parcelRegister("d1m5C", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2b0745f3dc80b24$export$2e2bcd8739ae039);

var $2sHEZ = parcelRequire("2sHEZ");

var $9jfzy = parcelRequire("9jfzy");

var $9MNxF = parcelRequire("9MNxF");

var $2vVsi = parcelRequire("2vVsi");

var $kTpbz = parcelRequire("kTpbz");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $c2b0745f3dc80b24$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $c2b0745f3dc80b24$var$SAFE = 'SAFE';
const $c2b0745f3dc80b24$var$UNSAFE = 'UNSAFE';
const $c2b0745f3dc80b24$var$NOT_FOUND = 'NOT_FOUND';
const $c2b0745f3dc80b24$var$COOKIE = 'COOKIE';
const $c2b0745f3dc80b24$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $c2b0745f3dc80b24$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $2vVsi.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $9MNxF.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $9jfzy.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $9jfzy.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $c2b0745f3dc80b24$var$LOCAL_STORAGE ? this.store.getItem((0, $9jfzy.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $9jfzy.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $c2b0745f3dc80b24$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $c2b0745f3dc80b24$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $c2b0745f3dc80b24$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($c2b0745f3dc80b24$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $2sHEZ.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $c2b0745f3dc80b24$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $c2b0745f3dc80b24$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $c2b0745f3dc80b24$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $c2b0745f3dc80b24$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($c2b0745f3dc80b24$var$COOKIE);
        switch(cookieValue.type){
            case $c2b0745f3dc80b24$var$SAFE:
            case $c2b0745f3dc80b24$var$UNSAFE:
                this.store.setItem((0, $9jfzy.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $c2b0745f3dc80b24$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $kTpbz.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("2sHEZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cb0104830dcb83c$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $cZp3K = parcelRequire("cZp3K");

var $3mokv = parcelRequire("3mokv");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $1cb0104830dcb83c$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $1cb0104830dcb83c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3mokv.default)(2, arguments);
    var dateLeft = (0, $a3cTc.default)(dirtyDateLeft);
    var dateRight = (0, $a3cTc.default)(dirtyDateRight);
    var sign = $1cb0104830dcb83c$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $cZp3K.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($1cb0104830dcb83c$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("a3cTc", function(module, exports) {
$parcel$export(module.exports, "default", () => $75142ebb6317070f$export$2e2bcd8739ae039);

var $6XyXV = parcelRequire("6XyXV");

var $3mokv = parcelRequire("3mokv");
function $75142ebb6317070f$export$2e2bcd8739ae039(argument) {
    (0, $3mokv.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $6XyXV.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("6XyXV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5113602e6b25c7fd$export$2e2bcd8739ae039);
function $5113602e6b25c7fd$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5113602e6b25c7fd$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5113602e6b25c7fd$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3mokv", function(module, exports) {
$parcel$export(module.exports, "default", () => $27264c8a1f9d6d6f$export$2e2bcd8739ae039);
function $27264c8a1f9d6d6f$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("cZp3K", function(module, exports) {
$parcel$export(module.exports, "default", () => $974e9ed1c005baa8$export$2e2bcd8739ae039);

var $hHLVj = parcelRequire("hHLVj");

var $lQxpB = parcelRequire("lQxpB");

var $3mokv = parcelRequire("3mokv");
var $974e9ed1c005baa8$var$MILLISECONDS_IN_DAY = 86400000;
function $974e9ed1c005baa8$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3mokv.default)(2, arguments);
    var startOfDayLeft = (0, $lQxpB.default)(dirtyDateLeft);
    var startOfDayRight = (0, $lQxpB.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $hHLVj.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $hHLVj.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $974e9ed1c005baa8$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("hHLVj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce3ba066181b0e08$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $ce3ba066181b0e08$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("lQxpB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe785f39143579e4$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $fe785f39143579e4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("9jfzy", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $519ab9855611b0c3$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $519ab9855611b0c3$export$d4cb17942ea57c95);
var $519ab9855611b0c3$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $519ab9855611b0c3$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $519ab9855611b0c3$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $519ab9855611b0c3$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $519ab9855611b0c3$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $519ab9855611b0c3$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $519ab9855611b0c3$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $519ab9855611b0c3$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $519ab9855611b0c3$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $519ab9855611b0c3$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("9MNxF", function(module, exports) {
$parcel$export(module.exports, "default", () => $472f726b8ccac0dc$export$2e2bcd8739ae039);

var $aEAmK = parcelRequire("aEAmK");

var $9jfzy = parcelRequire("9jfzy");

var $gd9MW = parcelRequire("gd9MW");

var $f0z7B = parcelRequire("f0z7B");
class $472f726b8ccac0dc$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $f0z7B.canUseCookie)(disableCookiePersistence) ? (0, $aEAmK.default) : new (0, $gd9MW.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $9jfzy.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $9jfzy.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $9jfzy.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $f0z7B.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $9jfzy.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $9jfzy.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $9jfzy.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $9jfzy.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("aEAmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c19d953aa799ecf$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $7c19d953aa799ecf$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $7c19d953aa799ecf$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $7c19d953aa799ecf$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $7c19d953aa799ecf$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $7c19d953aa799ecf$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $7c19d953aa799ecf$var$init(this.converter, $7c19d953aa799ecf$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $7c19d953aa799ecf$var$init($7c19d953aa799ecf$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $7c19d953aa799ecf$export$2e2bcd8739ae039 = $7c19d953aa799ecf$var$init($7c19d953aa799ecf$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("gd9MW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e7f909290d2de9e$export$2e2bcd8739ae039);

var $2vVsi = parcelRequire("2vVsi");
class $3e7f909290d2de9e$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $2vVsi.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("2vVsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d47c2498611e87ad$export$2e2bcd8739ae039);

var $7EIMl = parcelRequire("7EIMl");

var $7jwbl = parcelRequire("7jwbl");
class $d47c2498611e87ad$export$2e2bcd8739ae039 extends (0, $7jwbl.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $7EIMl.default);
        } catch (err) {
            storageToUse = (0, $7EIMl.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("7EIMl", function(module, exports) {
$parcel$export(module.exports, "default", () => $52c0d89416a06d89$export$2e2bcd8739ae039);

var $c6Nf9 = parcelRequire("c6Nf9");
// eslint-disable-next-line import/no-anonymous-default-export
const $52c0d89416a06d89$var$inmemorystorage = new (0, $c6Nf9.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$52c0d89416a06d89$export$2e2bcd8739ae039 = $52c0d89416a06d89$var$inmemorystorage;

});
parcelRegister("c6Nf9", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $ae1f8fc0af0f63e8$export$90e3e001bcac59c7);
class $ae1f8fc0af0f63e8$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}

});


parcelRegister("7jwbl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5b0c84005d27bc6$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $2mgM4 = parcelRequire("2mgM4");

var $7EIMl = parcelRequire("7EIMl");

var $d1NAr = parcelRequire("d1NAr");
const $e5b0c84005d27bc6$export$41c06fdd37b7e9a5 = 'awc';
const $e5b0c84005d27bc6$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $e5b0c84005d27bc6$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $7EIMl.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $d1NAr.isSupported)(globalThis[$e5b0c84005d27bc6$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$e5b0c84005d27bc6$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $7EIMl.default);
                if (!globalThis[$e5b0c84005d27bc6$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$e5b0c84005d27bc6$export$770aa8bc07b3de03] = (0, $7EIMl.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($e5b0c84005d27bc6$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $2mgM4.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $d1NAr.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("d1NAr", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $4cf0b77799d658c7$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $4cf0b77799d658c7$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("f0z7B", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $79b2942e8571461c$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $79b2942e8571461c$export$de6821eed3d5f32d);

var $aEAmK = parcelRequire("aEAmK");

var $jiju3 = parcelRequire("jiju3");

var $9jfzy = parcelRequire("9jfzy");
const $79b2942e8571461c$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $79b2942e8571461c$export$eb80e1beaa8dacf8 = (0, $9jfzy.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $79b2942e8571461c$export$19164982d36535d8 = 'tld_test';
const $79b2942e8571461c$export$de6821eed3d5f32d = (0, $jiju3.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $aEAmK.default).set($79b2942e8571461c$export$eb80e1beaa8dacf8, $79b2942e8571461c$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $aEAmK.default).get($79b2942e8571461c$export$eb80e1beaa8dacf8) === $79b2942e8571461c$export$19164982d36535d8) {
            (0, $aEAmK.default).remove($79b2942e8571461c$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("i6mDL", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $c24ebe28de86669f$export$1ac223ae496131c9);

var $hEFJC = parcelRequire("hEFJC");

var $47EPR = parcelRequire("47EPR");

var $lJnIv = parcelRequire("lJnIv");

var $2VlDS = parcelRequire("2VlDS");

var $jCcAI = parcelRequire("jCcAI");

var $hmONp = parcelRequire("hmONp");

var $aUf9S = parcelRequire("aUf9S");

var $6n7YX = parcelRequire("6n7YX");

var $9kddK = parcelRequire("9kddK");

var $lAzv6 = parcelRequire("lAzv6");

var $h6FeU = parcelRequire("h6FeU");

var $iMpvQ = parcelRequire("iMpvQ");
class $c24ebe28de86669f$export$1ac223ae496131c9 {
    static #_ = this.INITIAL_REFRESH_DELAY = 1;
    static #_2 = this.Factory = (apiHostProtocol, apiHost, product)=>{
        return new $c24ebe28de86669f$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
    };
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $hEFJC.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $6n7YX.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $6n7YX.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $2VlDS.default)({
            ...this._options,
            waitInterval: (0, $6n7YX.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $c24ebe28de86669f$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $47EPR.default)((status)=>{
            if (status === (0, $hmONp.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $aUf9S.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $lAzv6.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $6n7YX.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $h6FeU.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $9kddK.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $iMpvQ.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $hmONp.NetworkStatusEnum).OFFLINE) {
            done((0, $jCcAI.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $jCcAI.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $jCcAI.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $6n7YX.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $lJnIv.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $lJnIv.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $lJnIv.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $lJnIv.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("hEFJC", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $790e51c232bc3fc1$export$83a9dd8d74be72c);

var $bXCOi = parcelRequire("bXCOi");
function $790e51c232bc3fc1$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $bXCOi.stargateProxyUrl)();
}

});
parcelRegister("bXCOi", function(module, exports) {
$parcel$export(module.exports, "stargateProxyUrl", () => $68dde98a0ebff03f$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $68dde98a0ebff03f$export$18c0b81944902eae);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $2mgM4 = parcelRequire("2mgM4");

const $68dde98a0ebff03f$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $68dde98a0ebff03f$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $68dde98a0ebff03f$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $68dde98a0ebff03f$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $68dde98a0ebff03f$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $68dde98a0ebff03f$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $68dde98a0ebff03f$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $68dde98a0ebff03f$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $68dde98a0ebff03f$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $68dde98a0ebff03f$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $68dde98a0ebff03f$export$5df9262e102d0c32;
}
const $68dde98a0ebff03f$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $2mgM4.envType).LOCAL || env === (0, $2mgM4.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $2mgM4.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $2mgM4.envType).PROD ? $68dde98a0ebff03f$var$FEDRAMP_PROD_HOST : $68dde98a0ebff03f$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $2mgM4.envType).PROD ? $68dde98a0ebff03f$var$STARGATE_FEDRAMP_PROD_HOST : $68dde98a0ebff03f$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $68dde98a0ebff03f$export$78e02cfb66671ad0();
};
const $68dde98a0ebff03f$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $2mgM4.envType).PROD ? $68dde98a0ebff03f$var$PROD_HOST : $68dde98a0ebff03f$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $2mgM4.envType).PROD ? $68dde98a0ebff03f$var$STARGATE_PROD_HOST : $68dde98a0ebff03f$var$STARGATE_STAGING_HOST;
    return $68dde98a0ebff03f$export$78e02cfb66671ad0();
};
function $68dde98a0ebff03f$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $68dde98a0ebff03f$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $2mgM4.perimeterType).FEDRAMP_MODERATE) return $68dde98a0ebff03f$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $68dde98a0ebff03f$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("aUf9S", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $6cfee54284bd1362$export$44b578549c42d779);
class $6cfee54284bd1362$export$44b578549c42d779 {
    static #_ = this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    static #_2 = this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    static #_3 = this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    static #_4 = this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($6cfee54284bd1362$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($6cfee54284bd1362$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($6cfee54284bd1362$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($6cfee54284bd1362$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("lAzv6", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $9bfe5b1eb8bc1526$export$55b0d0261469055);

var $jiju3 = parcelRequire("jiju3");

var $9kddK = parcelRequire("9kddK");
const $9bfe5b1eb8bc1526$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $9bfe5b1eb8bc1526$var$createRequestAbortController(timeout, signal);
    const corsOptions = $9bfe5b1eb8bc1526$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $9kddK.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $9bfe5b1eb8bc1526$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $9bfe5b1eb8bc1526$var$getCorsForUrl = (0, $jiju3.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("h6FeU", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $3b268d110c01e189$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $3b268d110c01e189$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $3b268d110c01e189$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}

});


parcelRegister("IACFR", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $8f6e0e5abecebb36$export$f56713ced121eb91);

var $2mgM4 = parcelRequire("2mgM4");
const $8f6e0e5abecebb36$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $2mgM4.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("6allD", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $c612fb5a9f0299c9$export$ab34f90cc32c8960);

var $2mgM4 = parcelRequire("2mgM4");
const $c612fb5a9f0299c9$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $2mgM4.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("2Lib9", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $1a1b1083aa12cd65$export$48361b6ed38f1b0);
class $1a1b1083aa12cd65$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $1a1b1083aa12cd65$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("kfJIp", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $752b8f9a0456e1d9$export$ad1854f4a08c15f8);
function $752b8f9a0456e1d9$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("cRtxi", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbc9410a842fb379$export$2e2bcd8739ae039);

var $2mgM4 = parcelRequire("2mgM4");

var $6BZEC = parcelRequire("6BZEC");
class $cbc9410a842fb379$export$2e2bcd8739ae039 {
    static #_ = this.messageEvent = 'origin landed';
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $2mgM4.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $6BZEC.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $6BZEC.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $cbc9410a842fb379$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("gYCEb", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe1667e32723976$export$2e2bcd8739ae039);

var $lDWcQ = parcelRequire("lDWcQ");

var $2vVsi = parcelRequire("2vVsi");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $6fe1667e32723976$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $6fe1667e32723976$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $6fe1667e32723976$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $6fe1667e32723976$export$285f6bddd927a06d = 1800000;
const $6fe1667e32723976$export$a92e915d70316eb2 = 5000;
const $6fe1667e32723976$export$de43760b2dc10c19 = 0.9;
class $6fe1667e32723976$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($6fe1667e32723976$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // If session is not valid at this point, something has gone wrong with Local Storage access
            // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
            // gating roll-out of this early exit condition
            const { isValidSession: isValidSession } = this._getCurrentSessionParams();
            if (!isValidSession) return '';
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($6fe1667e32723976$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $6fe1667e32723976$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $6fe1667e32723976$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $6fe1667e32723976$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $lDWcQ.NOOP);
        this._safeLocalStorage = new (0, $2vVsi.default)();
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($6fe1667e32723976$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($6fe1667e32723976$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $6fe1667e32723976$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
   * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
   * read a null value from storage, in which case we will return empty String
   */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
}

});
parcelRegister("lDWcQ", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $28d11d48a856559a$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $28d11d48a856559a$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("a40Zg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0e790ea064184f$export$2e2bcd8739ae039);

var $7EIMl = parcelRequire("7EIMl");

var $7jwbl = parcelRequire("7jwbl");
class $5a0e790ea064184f$export$2e2bcd8739ae039 extends (0, $7jwbl.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $7EIMl.default);
        } catch (err) {
            storageToUse = (0, $7EIMl.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("dO86J", function(module, exports) {
$parcel$export(module.exports, "default", () => $35c7b94683b05d63$export$2e2bcd8739ae039);

var $a40Zg = parcelRequire("a40Zg");

var $kTpbz = parcelRequire("kTpbz");
const $35c7b94683b05d63$var$STORAGE_KEY = 'tab.id';
class $35c7b94683b05d63$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $kTpbz.default)();
            this._safeSessionStorage.setItem($35c7b94683b05d63$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $a40Zg.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($35c7b94683b05d63$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("cRoJC", function(module, exports) {
$parcel$export(module.exports, "default", () => $46fac9b847a89b0e$export$2e2bcd8739ae039);

var $5AM1g = parcelRequire("5AM1g");

var $2mgM4 = parcelRequire("2mgM4");

var $2QTxW = parcelRequire("2QTxW");

var $a40Zg = parcelRequire("a40Zg");

var $6BZEC = parcelRequire("6BZEC");

var $kTpbz = parcelRequire("kTpbz");
const $46fac9b847a89b0e$var$STORAGE_KEY = 'taskSessions';
const $46fac9b847a89b0e$var$INIT_KEY = 'taskSessionsInit';
const $46fac9b847a89b0e$var$AWC_PARAM_PREFIX = 'awc.';
const $46fac9b847a89b0e$var$TASK_SESSION_RELOAD_TIME = 3000;
class $46fac9b847a89b0e$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($46fac9b847a89b0e$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($46fac9b847a89b0e$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($46fac9b847a89b0e$var$INIT_KEY) || '0', 10) < currentTimestamp - $46fac9b847a89b0e$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($46fac9b847a89b0e$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($46fac9b847a89b0e$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($46fac9b847a89b0e$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($46fac9b847a89b0e$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $kTpbz.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $5AM1g.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $2QTxW.pick)(currentState, includedTaskSessions) : (0, $2QTxW.omit)(currentState, Object.values((0, $2mgM4.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $2QTxW.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$46fac9b847a89b0e$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $5AM1g.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $2QTxW.mapKeys)((0, $6BZEC.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $a40Zg.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($46fac9b847a89b0e$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("72Hes", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd6bf11224c8ace$export$2e2bcd8739ae039);

var $aEAmK = parcelRequire("aEAmK");

var $9jfzy = parcelRequire("9jfzy");

var $aUf9S = parcelRequire("aUf9S");
const $4fd6bf11224c8ace$var$MAX_CACHE_SIZE = 100;
const $4fd6bf11224c8ace$var$COOKIE_NAME = (0, $9jfzy.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $4fd6bf11224c8ace$var$DEBUG_TAG = 'synthetic';
class $4fd6bf11224c8ace$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $4fd6bf11224c8ace$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $4fd6bf11224c8ace$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($4fd6bf11224c8ace$var$DEBUG_TAG)) event.tags.push($4fd6bf11224c8ace$var$DEBUG_TAG);
        } else event.tags = [
            $4fd6bf11224c8ace$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $aUf9S.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $aEAmK.default).get($4fd6bf11224c8ace$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, $aEAmK.default).remove($4fd6bf11224c8ace$var$COOKIE_NAME);
        }
        return false;
    }
}
var $4fd6bf11224c8ace$export$2e2bcd8739ae039 = $4fd6bf11224c8ace$var$TestingCache;

});

parcelRegister("I5wOY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a304020d5f648432$export$2e2bcd8739ae039);

var $2mgM4 = parcelRequire("2mgM4");

var $6xLyi = parcelRequire("6xLyi");

var $2vVsi = parcelRequire("2vVsi");
const $a304020d5f648432$var$DEFAULT_DELAY = 2000; // 2 seconds
const $a304020d5f648432$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $a304020d5f648432$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $a304020d5f648432$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $a304020d5f648432$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($a304020d5f648432$var$SendEventDecision || {});
class $a304020d5f648432$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $6xLyi.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $2mgM4.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $a304020d5f648432$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $a304020d5f648432$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $a304020d5f648432$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $a304020d5f648432$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $2vVsi.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("6xLyi", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $845e93453430e483$export$f65ca476c09acec0);
const $845e93453430e483$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("cKB5a", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $f4d94eda4003cc97$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2mgM4 = parcelRequire("2mgM4");

var $94FNv = parcelRequire("94FNv");

var $kfJIp = parcelRequire("kfJIp");
function $f4d94eda4003cc97$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $94FNv.isType)((0, $2mgM4.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $kfJIp.objectValues)((0, $2mgM4.userType))}]`);
}

});

parcelRegister("88PeU", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $a44ebc80b8666de0$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $m66xS = parcelRequire("m66xS");
function $a44ebc80b8666de0$export$1e561554275607ef(event) {
    (0, $m66xS.validateActionEvent)(event);
}

});

parcelRegister("9Cv3R", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $b9cb1842e2f98b41$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2mgM4 = parcelRequire("2mgM4");

var $94FNv = parcelRequire("94FNv");

var $kfJIp = parcelRequire("kfJIp");
function $b9cb1842e2f98b41$export$801b46c35394d316(productInfo) {
    if (!(0, $94FNv.isType)((0, $2mgM4.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $kfJIp.objectValues)((0, $2mgM4.platformType))}]`);
    if (productInfo.origin === (0, $2mgM4.originType).DESKTOP && !(0, $94FNv.isType)((0, $2mgM4.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $2mgM4.originType).WEB && !(0, $94FNv.isType)((0, $2mgM4.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("9I4pj", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $17a6c95d0ae361dc$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $17a6c95d0ae361dc$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("9FVmq", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $1bc7d454a2157d7b$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $m66xS = parcelRequire("m66xS");
function $1bc7d454a2157d7b$export$8c014fd74b0c8b99(event) {
    (0, $m66xS.validateActionEvent)(event);
}

});

parcelRegister("lM0b2", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $91a253afd361bd18$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $m66xS = parcelRequire("m66xS");
function $91a253afd361bd18$export$e5bac0930c812e90(event) {
    (0, $m66xS.validateActionEvent)(event);
}

});

parcelRegister("bmI56", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ec8cb5ea18255b$export$2e2bcd8739ae039);
function $c4ec8cb5ea18255b$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("bfgv3", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $a98c3289ccc5d5c1$export$fbe53bbbe682bcdd);

var $gcdeS = parcelRequire("gcdeS");
const $a98c3289ccc5d5c1$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $gcdeS.createTimeoutXid)()), (0, $gcdeS.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $gcdeS.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("gcdeS", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $f0cbab5d0c7f1564$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $f0cbab5d0c7f1564$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $f0cbab5d0c7f1564$export$fa341d0c750d705b);

var $6vcqs = parcelRequire("6vcqs");
const $f0cbab5d0c7f1564$export$545bcbd53afabfa3 = 5000;
const $f0cbab5d0c7f1564$export$af4087e36d63846 = ()=>[
        {
            type: (0, $6vcqs.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $6vcqs.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $f0cbab5d0c7f1564$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $6vcqs.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $6vcqs.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("6vcqs", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $e0ec4653d999acaa$export$92ca0438bcb0d396);
var $e0ec4653d999acaa$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $e0ec4653d999acaa$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("aYMdQ", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("aVQWM", function(module, exports) {
$parcel$export(module.exports, "SCREEN", () => $12150cf0f0e6a760$export$f636b5b56f1d624a);
$parcel$export(module.exports, "MODAL", () => $12150cf0f0e6a760$export$1171103ea9083ffa);
$parcel$export(module.exports, "INLINE_DIALOG", () => $12150cf0f0e6a760$export$cae2783c9279926);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $12150cf0f0e6a760$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $12150cf0f0e6a760$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $12150cf0f0e6a760$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $12150cf0f0e6a760$export$12346a674644c156);
$parcel$export(module.exports, "ANALYTICS_BRIDGE_CHANNEL", () => $12150cf0f0e6a760$export$2ceccf177fae277c);
const $12150cf0f0e6a760$export$f636b5b56f1d624a = 'Screen';
const $12150cf0f0e6a760$export$9d2de6eebf7462b5 = 'Drawer';
const $12150cf0f0e6a760$export$1171103ea9083ffa = 'Modal';
const $12150cf0f0e6a760$export$cae2783c9279926 = 'InlineDialog';
const $12150cf0f0e6a760$export$d1123261ca8831d2 = 'Dropdown';
const $12150cf0f0e6a760$export$a1562d08625f5d7e = 'UI';
const $12150cf0f0e6a760$export$947dac6c72b26f81 = 'TRACK';
const $12150cf0f0e6a760$export$f1d537d508d2945a = 'SCREEN';
const $12150cf0f0e6a760$export$12346a674644c156 = 'OPERATIONAL';
const $12150cf0f0e6a760$export$2ceccf177fae277c = 'analyticsBridge';

});

parcelRegister("j5wIQ", function(module, exports) {
$parcel$export(module.exports, "extractAWCDataFromEvent", () => $1d4d002b812b842c$export$1c850cf68c053906);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $bomqv = parcelRequire("bomqv");

var $gK90j = parcelRequire("gK90j");

var $aVQWM = parcelRequire("aVQWM");

var $4GKjL = parcelRequire("4GKjL");
const $1d4d002b812b842c$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $4GKjL.getAnalyticsType)(castedEvent);
    const attributes = (0, $4GKjL.getAttributes)(castedEvent);
    const source = (0, $4GKjL.getSource)(castedEvent);
    const actionSubject = (0, $4GKjL.getActionSubject)(castedEvent);
    if (analyticsType === (0, $aVQWM.SCREEN_EVENT_TYPE)) return {
        type: (0, $aVQWM.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $aVQWM.UI_EVENT_TYPE:
        case 0, $aVQWM.TRACK_EVENT_TYPE:
        case 0, $aVQWM.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $4GKjL.getAction)(castedEvent);
                const actionSubjectId = (0, $4GKjL.getActionSubjectId)(castedEvent);
                const containerId = (0, $4GKjL.getContainerId)(castedEvent);
                const containerType = (0, $4GKjL.getContainerType)(castedEvent);
                const objectId = (0, $4GKjL.getObjectId)(castedEvent);
                const objectType = (0, $4GKjL.getObjectType)(castedEvent);
                const tags = (0, $4GKjL.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($gK90j)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($bomqv))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("bomqv", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $84b3550516dd9793$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $84b3550516dd9793$var$isUndefined;

});

parcelRegister("gK90j", function(module, exports) {

var $lNhdb = parcelRequire("lNhdb");

var $bweqi = parcelRequire("bweqi");

var $akVVk = parcelRequire("akVVk");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $c307ed3b7fe06b89$var$omitBy(object, predicate) {
    return $akVVk(object, $bweqi($lNhdb(predicate)));
}
module.exports = $c307ed3b7fe06b89$var$omitBy;

});
parcelRegister("lNhdb", function(module, exports) {

var $b4dXl = parcelRequire("b4dXl");

var $82m5X = parcelRequire("82m5X");

var $8wPDv = parcelRequire("8wPDv");

var $hl35j = parcelRequire("hl35j");

var $bkGBa = parcelRequire("bkGBa");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $fddb8673ef355def$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $8wPDv;
    if (typeof value == 'object') return $hl35j(value) ? $82m5X(value[0], value[1]) : $b4dXl(value);
    return $bkGBa(value);
}
module.exports = $fddb8673ef355def$var$baseIteratee;

});
parcelRegister("b4dXl", function(module, exports) {

var $7pq2K = parcelRequire("7pq2K");

var $ctnb9 = parcelRequire("ctnb9");

var $5hir1 = parcelRequire("5hir1");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $80eae4db57bf3c8f$var$baseMatches(source) {
    var matchData = $ctnb9(source);
    if (matchData.length == 1 && matchData[0][2]) return $5hir1(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $7pq2K(object, source, matchData);
    };
}
module.exports = $80eae4db57bf3c8f$var$baseMatches;

});
parcelRegister("7pq2K", function(module, exports) {

var $h9qpk = parcelRequire("h9qpk");

var $6iJje = parcelRequire("6iJje");
/** Used to compose bitmasks for value comparisons. */ var $564f11e159eff2dc$var$COMPARE_PARTIAL_FLAG = 1, $564f11e159eff2dc$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $564f11e159eff2dc$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $h9qpk;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $6iJje(srcValue, objValue, $564f11e159eff2dc$var$COMPARE_PARTIAL_FLAG | $564f11e159eff2dc$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $564f11e159eff2dc$var$baseIsMatch;

});
parcelRegister("h9qpk", function(module, exports) {

var $8p6FE = parcelRequire("8p6FE");

var $3ZHIT = parcelRequire("3ZHIT");

var $8Vgfo = parcelRequire("8Vgfo");

var $dJGlt = parcelRequire("dJGlt");

var $4W9iR = parcelRequire("4W9iR");

var $6V6q6 = parcelRequire("6V6q6");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c7c7c2ea8707ff2d$var$Stack(entries) {
    var data = this.__data__ = new $8p6FE(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$c7c7c2ea8707ff2d$var$Stack.prototype.clear = $3ZHIT;
$c7c7c2ea8707ff2d$var$Stack.prototype['delete'] = $8Vgfo;
$c7c7c2ea8707ff2d$var$Stack.prototype.get = $dJGlt;
$c7c7c2ea8707ff2d$var$Stack.prototype.has = $4W9iR;
$c7c7c2ea8707ff2d$var$Stack.prototype.set = $6V6q6;
module.exports = $c7c7c2ea8707ff2d$var$Stack;

});
parcelRegister("8p6FE", function(module, exports) {

var $4VFeW = parcelRequire("4VFeW");

var $aIUzy = parcelRequire("aIUzy");

var $14OpG = parcelRequire("14OpG");

var $6WR0I = parcelRequire("6WR0I");

var $fbzuW = parcelRequire("fbzuW");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $61e5d53adf788167$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$61e5d53adf788167$var$ListCache.prototype.clear = $4VFeW;
$61e5d53adf788167$var$ListCache.prototype['delete'] = $aIUzy;
$61e5d53adf788167$var$ListCache.prototype.get = $14OpG;
$61e5d53adf788167$var$ListCache.prototype.has = $6WR0I;
$61e5d53adf788167$var$ListCache.prototype.set = $fbzuW;
module.exports = $61e5d53adf788167$var$ListCache;

});
parcelRegister("4VFeW", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $396c79b8aab1a76d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $396c79b8aab1a76d$var$listCacheClear;

});

parcelRegister("aIUzy", function(module, exports) {

var $kCDAC = parcelRequire("kCDAC");
/** Used for built-in method references. */ var $7ce9e5933e254aa0$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7ce9e5933e254aa0$var$splice = $7ce9e5933e254aa0$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7ce9e5933e254aa0$var$listCacheDelete(key) {
    var data = this.__data__, index = $kCDAC(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7ce9e5933e254aa0$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $7ce9e5933e254aa0$var$listCacheDelete;

});
parcelRegister("kCDAC", function(module, exports) {

var $1ZVB0 = parcelRequire("1ZVB0");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f03610ec87b8fe61$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($1ZVB0(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $f03610ec87b8fe61$var$assocIndexOf;

});
parcelRegister("1ZVB0", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $17482a495e800a1a$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $17482a495e800a1a$var$eq;

});



parcelRegister("14OpG", function(module, exports) {

var $kCDAC = parcelRequire("kCDAC");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0c8d4535a1e9e6a4$var$listCacheGet(key) {
    var data = this.__data__, index = $kCDAC(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $0c8d4535a1e9e6a4$var$listCacheGet;

});

parcelRegister("6WR0I", function(module, exports) {

var $kCDAC = parcelRequire("kCDAC");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $50f147a86f169e03$var$listCacheHas(key) {
    return $kCDAC(this.__data__, key) > -1;
}
module.exports = $50f147a86f169e03$var$listCacheHas;

});

parcelRegister("fbzuW", function(module, exports) {

var $kCDAC = parcelRequire("kCDAC");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b0e36b47702ad78b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $kCDAC(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $b0e36b47702ad78b$var$listCacheSet;

});


parcelRegister("3ZHIT", function(module, exports) {

var $8p6FE = parcelRequire("8p6FE");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $2e88fc137162774d$var$stackClear() {
    this.__data__ = new $8p6FE;
    this.size = 0;
}
module.exports = $2e88fc137162774d$var$stackClear;

});

parcelRegister("8Vgfo", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $67f03ff394c64b23$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $67f03ff394c64b23$var$stackDelete;

});

parcelRegister("dJGlt", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a000534037ff68e4$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $a000534037ff68e4$var$stackGet;

});

parcelRegister("4W9iR", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3983cba44f4b2fdf$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $3983cba44f4b2fdf$var$stackHas;

});

parcelRegister("6V6q6", function(module, exports) {

var $8p6FE = parcelRequire("8p6FE");

var $kSIXZ = parcelRequire("kSIXZ");

var $77NjN = parcelRequire("77NjN");
/** Used as the size to enable large array optimizations. */ var $509d0bd79be432c6$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $509d0bd79be432c6$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $8p6FE) {
        var pairs = data.__data__;
        if (!$kSIXZ || pairs.length < $509d0bd79be432c6$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $77NjN(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $509d0bd79be432c6$var$stackSet;

});
parcelRegister("kSIXZ", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");

var $4XvF4 = parcelRequire("4XvF4");
/* Built-in method references that are verified to be native. */ var $f33bbb38a84cbbfd$var$Map = $kHI38($4XvF4, 'Map');
module.exports = $f33bbb38a84cbbfd$var$Map;

});
parcelRegister("kHI38", function(module, exports) {

var $jzksQ = parcelRequire("jzksQ");

var $47ee6 = parcelRequire("47ee6");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f129fe214dd40659$var$getNative(object, key) {
    var value = $47ee6(object, key);
    return $jzksQ(value) ? value : undefined;
}
module.exports = $f129fe214dd40659$var$getNative;

});
parcelRegister("jzksQ", function(module, exports) {

var $g2c8e = parcelRequire("g2c8e");

var $l5FGI = parcelRequire("l5FGI");

var $e3M82 = parcelRequire("e3M82");

var $5MmRP = parcelRequire("5MmRP");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e3f128f8ac53af4e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e3f128f8ac53af4e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $e3f128f8ac53af4e$var$funcProto = Function.prototype, $e3f128f8ac53af4e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e3f128f8ac53af4e$var$funcToString = $e3f128f8ac53af4e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e3f128f8ac53af4e$var$hasOwnProperty = $e3f128f8ac53af4e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $e3f128f8ac53af4e$var$reIsNative = RegExp('^' + $e3f128f8ac53af4e$var$funcToString.call($e3f128f8ac53af4e$var$hasOwnProperty).replace($e3f128f8ac53af4e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e3f128f8ac53af4e$var$baseIsNative(value) {
    if (!$e3M82(value) || $l5FGI(value)) return false;
    var pattern = $g2c8e(value) ? $e3f128f8ac53af4e$var$reIsNative : $e3f128f8ac53af4e$var$reIsHostCtor;
    return pattern.test($5MmRP(value));
}
module.exports = $e3f128f8ac53af4e$var$baseIsNative;

});
parcelRegister("g2c8e", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $e3M82 = parcelRequire("e3M82");
/** `Object#toString` result references. */ var $bac63e5b75876b21$var$asyncTag = '[object AsyncFunction]', $bac63e5b75876b21$var$funcTag = '[object Function]', $bac63e5b75876b21$var$genTag = '[object GeneratorFunction]', $bac63e5b75876b21$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $bac63e5b75876b21$var$isFunction(value) {
    if (!$e3M82(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $daBML(value);
    return tag == $bac63e5b75876b21$var$funcTag || tag == $bac63e5b75876b21$var$genTag || tag == $bac63e5b75876b21$var$asyncTag || tag == $bac63e5b75876b21$var$proxyTag;
}
module.exports = $bac63e5b75876b21$var$isFunction;

});
parcelRegister("daBML", function(module, exports) {

var $etweZ = parcelRequire("etweZ");

var $41Rqj = parcelRequire("41Rqj");

var $bPFEW = parcelRequire("bPFEW");
/** `Object#toString` result references. */ var $996984efcec93f0b$var$nullTag = '[object Null]', $996984efcec93f0b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $996984efcec93f0b$var$symToStringTag = $etweZ ? $etweZ.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $996984efcec93f0b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $996984efcec93f0b$var$undefinedTag : $996984efcec93f0b$var$nullTag;
    return $996984efcec93f0b$var$symToStringTag && $996984efcec93f0b$var$symToStringTag in Object(value) ? $41Rqj(value) : $bPFEW(value);
}
module.exports = $996984efcec93f0b$var$baseGetTag;

});
parcelRegister("etweZ", function(module, exports) {

var $4XvF4 = parcelRequire("4XvF4");
/** Built-in value references. */ var $a89cc87de7a7a8b2$var$Symbol = $4XvF4.Symbol;
module.exports = $a89cc87de7a7a8b2$var$Symbol;

});
parcelRegister("4XvF4", function(module, exports) {

var $3wVoD = parcelRequire("3wVoD");
/** Detect free variable `self`. */ var $39c53b6cf6771425$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $39c53b6cf6771425$var$root = $3wVoD || $39c53b6cf6771425$var$freeSelf || Function('return this')();
module.exports = $39c53b6cf6771425$var$root;

});
parcelRegister("3wVoD", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $2920e1f90f27e85f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $2920e1f90f27e85f$var$freeGlobal;

});



parcelRegister("41Rqj", function(module, exports) {

var $etweZ = parcelRequire("etweZ");
/** Used for built-in method references. */ var $2ef0b235d2f4b28b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2ef0b235d2f4b28b$var$hasOwnProperty = $2ef0b235d2f4b28b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2ef0b235d2f4b28b$var$nativeObjectToString = $2ef0b235d2f4b28b$var$objectProto.toString;
/** Built-in value references. */ var $2ef0b235d2f4b28b$var$symToStringTag = $etweZ ? $etweZ.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $2ef0b235d2f4b28b$var$getRawTag(value) {
    var isOwn = $2ef0b235d2f4b28b$var$hasOwnProperty.call(value, $2ef0b235d2f4b28b$var$symToStringTag), tag = value[$2ef0b235d2f4b28b$var$symToStringTag];
    try {
        value[$2ef0b235d2f4b28b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $2ef0b235d2f4b28b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$2ef0b235d2f4b28b$var$symToStringTag] = tag;
        else delete value[$2ef0b235d2f4b28b$var$symToStringTag];
    }
    return result;
}
module.exports = $2ef0b235d2f4b28b$var$getRawTag;

});

parcelRegister("bPFEW", function(module, exports) {
/** Used for built-in method references. */ var $89d4c5cdd133e99c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $89d4c5cdd133e99c$var$nativeObjectToString = $89d4c5cdd133e99c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $89d4c5cdd133e99c$var$objectToString(value) {
    return $89d4c5cdd133e99c$var$nativeObjectToString.call(value);
}
module.exports = $89d4c5cdd133e99c$var$objectToString;

});


parcelRegister("e3M82", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a3c6add83541e430$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $a3c6add83541e430$var$isObject;

});


parcelRegister("l5FGI", function(module, exports) {

var $3mJqO = parcelRequire("3mJqO");
/** Used to detect methods masquerading as native. */ var $f5aa66f0e03c663d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($3mJqO && $3mJqO.keys && $3mJqO.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f5aa66f0e03c663d$var$isMasked(func) {
    return !!$f5aa66f0e03c663d$var$maskSrcKey && $f5aa66f0e03c663d$var$maskSrcKey in func;
}
module.exports = $f5aa66f0e03c663d$var$isMasked;

});
parcelRegister("3mJqO", function(module, exports) {

var $4XvF4 = parcelRequire("4XvF4");
/** Used to detect overreaching core-js shims. */ var $2736aaef0634c069$var$coreJsData = $4XvF4["__core-js_shared__"];
module.exports = $2736aaef0634c069$var$coreJsData;

});


parcelRegister("5MmRP", function(module, exports) {
/** Used for built-in method references. */ var $43532c608c2f66aa$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $43532c608c2f66aa$var$funcToString = $43532c608c2f66aa$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $43532c608c2f66aa$var$toSource(func) {
    if (func != null) {
        try {
            return $43532c608c2f66aa$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $43532c608c2f66aa$var$toSource;

});


parcelRegister("47ee6", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $2ff2d9f85264f371$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $2ff2d9f85264f371$var$getValue;

});



parcelRegister("77NjN", function(module, exports) {

var $jZuUD = parcelRequire("jZuUD");

var $7AlKS = parcelRequire("7AlKS");

var $lHclx = parcelRequire("lHclx");

var $lBF24 = parcelRequire("lBF24");

var $faPZO = parcelRequire("faPZO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $52ff71752ac697f6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$52ff71752ac697f6$var$MapCache.prototype.clear = $jZuUD;
$52ff71752ac697f6$var$MapCache.prototype['delete'] = $7AlKS;
$52ff71752ac697f6$var$MapCache.prototype.get = $lHclx;
$52ff71752ac697f6$var$MapCache.prototype.has = $lBF24;
$52ff71752ac697f6$var$MapCache.prototype.set = $faPZO;
module.exports = $52ff71752ac697f6$var$MapCache;

});
parcelRegister("jZuUD", function(module, exports) {

var $ghAGV = parcelRequire("ghAGV");

var $8p6FE = parcelRequire("8p6FE");

var $kSIXZ = parcelRequire("kSIXZ");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e8dbb16a226afef9$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $ghAGV,
        'map': new ($kSIXZ || $8p6FE),
        'string': new $ghAGV
    };
}
module.exports = $e8dbb16a226afef9$var$mapCacheClear;

});
parcelRegister("ghAGV", function(module, exports) {

var $ecVtl = parcelRequire("ecVtl");

var $7CQzT = parcelRequire("7CQzT");

var $119x8 = parcelRequire("119x8");

var $ifUDJ = parcelRequire("ifUDJ");

var $6KnPg = parcelRequire("6KnPg");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bdaab1fc5c0c2b9b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bdaab1fc5c0c2b9b$var$Hash.prototype.clear = $ecVtl;
$bdaab1fc5c0c2b9b$var$Hash.prototype['delete'] = $7CQzT;
$bdaab1fc5c0c2b9b$var$Hash.prototype.get = $119x8;
$bdaab1fc5c0c2b9b$var$Hash.prototype.has = $ifUDJ;
$bdaab1fc5c0c2b9b$var$Hash.prototype.set = $6KnPg;
module.exports = $bdaab1fc5c0c2b9b$var$Hash;

});
parcelRegister("ecVtl", function(module, exports) {

var $9RfS2 = parcelRequire("9RfS2");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a57ec47dfeafe4f7$var$hashClear() {
    this.__data__ = $9RfS2 ? $9RfS2(null) : {};
    this.size = 0;
}
module.exports = $a57ec47dfeafe4f7$var$hashClear;

});
parcelRegister("9RfS2", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");
/* Built-in method references that are verified to be native. */ var $72d55fd8f98f8090$var$nativeCreate = $kHI38(Object, 'create');
module.exports = $72d55fd8f98f8090$var$nativeCreate;

});


parcelRegister("7CQzT", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $58d4dde72ef0858c$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $58d4dde72ef0858c$var$hashDelete;

});

parcelRegister("119x8", function(module, exports) {

var $9RfS2 = parcelRequire("9RfS2");
/** Used to stand-in for `undefined` hash values. */ var $0bdd47964f13fb38$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0bdd47964f13fb38$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0bdd47964f13fb38$var$hasOwnProperty = $0bdd47964f13fb38$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0bdd47964f13fb38$var$hashGet(key) {
    var data = this.__data__;
    if ($9RfS2) {
        var result = data[key];
        return result === $0bdd47964f13fb38$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0bdd47964f13fb38$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0bdd47964f13fb38$var$hashGet;

});

parcelRegister("ifUDJ", function(module, exports) {

var $9RfS2 = parcelRequire("9RfS2");
/** Used for built-in method references. */ var $d4a590359b439c32$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4a590359b439c32$var$hasOwnProperty = $d4a590359b439c32$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d4a590359b439c32$var$hashHas(key) {
    var data = this.__data__;
    return $9RfS2 ? data[key] !== undefined : $d4a590359b439c32$var$hasOwnProperty.call(data, key);
}
module.exports = $d4a590359b439c32$var$hashHas;

});

parcelRegister("6KnPg", function(module, exports) {

var $9RfS2 = parcelRequire("9RfS2");
/** Used to stand-in for `undefined` hash values. */ var $4e99854b48d22367$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4e99854b48d22367$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $9RfS2 && value === undefined ? $4e99854b48d22367$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $4e99854b48d22367$var$hashSet;

});



parcelRegister("7AlKS", function(module, exports) {

var $fyzkJ = parcelRequire("fyzkJ");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $585cc54e063cf830$var$mapCacheDelete(key) {
    var result = $fyzkJ(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $585cc54e063cf830$var$mapCacheDelete;

});
parcelRegister("fyzkJ", function(module, exports) {

var $9rXM1 = parcelRequire("9rXM1");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b535707874df54c2$var$getMapData(map, key) {
    var data = map.__data__;
    return $9rXM1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $b535707874df54c2$var$getMapData;

});
parcelRegister("9rXM1", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $6e150079586742a2$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $6e150079586742a2$var$isKeyable;

});



parcelRegister("lHclx", function(module, exports) {

var $fyzkJ = parcelRequire("fyzkJ");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fcb730e31d6443d4$var$mapCacheGet(key) {
    return $fyzkJ(this, key).get(key);
}
module.exports = $fcb730e31d6443d4$var$mapCacheGet;

});

parcelRegister("lBF24", function(module, exports) {

var $fyzkJ = parcelRequire("fyzkJ");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fbace1d85718cec2$var$mapCacheHas(key) {
    return $fyzkJ(this, key).has(key);
}
module.exports = $fbace1d85718cec2$var$mapCacheHas;

});

parcelRegister("faPZO", function(module, exports) {

var $fyzkJ = parcelRequire("fyzkJ");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b0c01f8056b6556c$var$mapCacheSet(key, value) {
    var data = $fyzkJ(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $b0c01f8056b6556c$var$mapCacheSet;

});




parcelRegister("6iJje", function(module, exports) {

var $48nIL = parcelRequire("48nIL");

var $8GSh0 = parcelRequire("8GSh0");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $496791f73c0c0a34$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8GSh0(value) && !$8GSh0(other)) return value !== value && other !== other;
    return $48nIL(value, other, bitmask, customizer, $496791f73c0c0a34$var$baseIsEqual, stack);
}
module.exports = $496791f73c0c0a34$var$baseIsEqual;

});
parcelRegister("48nIL", function(module, exports) {

var $h9qpk = parcelRequire("h9qpk");

var $bFBdA = parcelRequire("bFBdA");

var $gmMux = parcelRequire("gmMux");

var $e7uQf = parcelRequire("e7uQf");

var $eZ3ti = parcelRequire("eZ3ti");

var $hl35j = parcelRequire("hl35j");

var $kA7Y3 = parcelRequire("kA7Y3");

var $9l2OA = parcelRequire("9l2OA");
/** Used to compose bitmasks for value comparisons. */ var $302a4f4af33aa94c$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $302a4f4af33aa94c$var$argsTag = '[object Arguments]', $302a4f4af33aa94c$var$arrayTag = '[object Array]', $302a4f4af33aa94c$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $302a4f4af33aa94c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $302a4f4af33aa94c$var$hasOwnProperty = $302a4f4af33aa94c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $302a4f4af33aa94c$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $hl35j(object), othIsArr = $hl35j(other), objTag = objIsArr ? $302a4f4af33aa94c$var$arrayTag : $eZ3ti(object), othTag = othIsArr ? $302a4f4af33aa94c$var$arrayTag : $eZ3ti(other);
    objTag = objTag == $302a4f4af33aa94c$var$argsTag ? $302a4f4af33aa94c$var$objectTag : objTag;
    othTag = othTag == $302a4f4af33aa94c$var$argsTag ? $302a4f4af33aa94c$var$objectTag : othTag;
    var objIsObj = objTag == $302a4f4af33aa94c$var$objectTag, othIsObj = othTag == $302a4f4af33aa94c$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $kA7Y3(object)) {
        if (!$kA7Y3(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $h9qpk);
        return objIsArr || $9l2OA(object) ? $bFBdA(object, other, bitmask, customizer, equalFunc, stack) : $gmMux(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $302a4f4af33aa94c$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $302a4f4af33aa94c$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $302a4f4af33aa94c$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $h9qpk);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $h9qpk);
    return $e7uQf(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $302a4f4af33aa94c$var$baseIsEqualDeep;

});
parcelRegister("bFBdA", function(module, exports) {

var $7SHMG = parcelRequire("7SHMG");

var $bjIZD = parcelRequire("bjIZD");

var $2QtyU = parcelRequire("2QtyU");
/** Used to compose bitmasks for value comparisons. */ var $87f064cae0ec8a5f$var$COMPARE_PARTIAL_FLAG = 1, $87f064cae0ec8a5f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $87f064cae0ec8a5f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $87f064cae0ec8a5f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $87f064cae0ec8a5f$var$COMPARE_UNORDERED_FLAG ? new $7SHMG : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$bjIZD(other, function(othValue, othIndex) {
                if (!$2QtyU(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $87f064cae0ec8a5f$var$equalArrays;

});
parcelRegister("7SHMG", function(module, exports) {

var $77NjN = parcelRequire("77NjN");

var $5IZzN = parcelRequire("5IZzN");

var $fHn1V = parcelRequire("fHn1V");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $5bcf8a3304fcab31$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $77NjN;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$5bcf8a3304fcab31$var$SetCache.prototype.add = $5bcf8a3304fcab31$var$SetCache.prototype.push = $5IZzN;
$5bcf8a3304fcab31$var$SetCache.prototype.has = $fHn1V;
module.exports = $5bcf8a3304fcab31$var$SetCache;

});
parcelRegister("5IZzN", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $42b0d399e04d3198$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $42b0d399e04d3198$var$setCacheAdd(value) {
    this.__data__.set(value, $42b0d399e04d3198$var$HASH_UNDEFINED);
    return this;
}
module.exports = $42b0d399e04d3198$var$setCacheAdd;

});

parcelRegister("fHn1V", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $b6dcbc727b16406c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $b6dcbc727b16406c$var$setCacheHas;

});


parcelRegister("bjIZD", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $83d45ec3dab76e17$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $83d45ec3dab76e17$var$arraySome;

});

parcelRegister("2QtyU", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $21275e822bdc9909$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $21275e822bdc9909$var$cacheHas;

});


parcelRegister("gmMux", function(module, exports) {

var $etweZ = parcelRequire("etweZ");

var $1f96o = parcelRequire("1f96o");

var $1ZVB0 = parcelRequire("1ZVB0");

var $bFBdA = parcelRequire("bFBdA");

var $hlUxe = parcelRequire("hlUxe");

var $1HNT9 = parcelRequire("1HNT9");
/** Used to compose bitmasks for value comparisons. */ var $bea450d56f28c679$var$COMPARE_PARTIAL_FLAG = 1, $bea450d56f28c679$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $bea450d56f28c679$var$boolTag = '[object Boolean]', $bea450d56f28c679$var$dateTag = '[object Date]', $bea450d56f28c679$var$errorTag = '[object Error]', $bea450d56f28c679$var$mapTag = '[object Map]', $bea450d56f28c679$var$numberTag = '[object Number]', $bea450d56f28c679$var$regexpTag = '[object RegExp]', $bea450d56f28c679$var$setTag = '[object Set]', $bea450d56f28c679$var$stringTag = '[object String]', $bea450d56f28c679$var$symbolTag = '[object Symbol]';
var $bea450d56f28c679$var$arrayBufferTag = '[object ArrayBuffer]', $bea450d56f28c679$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $bea450d56f28c679$var$symbolProto = $etweZ ? $etweZ.prototype : undefined, $bea450d56f28c679$var$symbolValueOf = $bea450d56f28c679$var$symbolProto ? $bea450d56f28c679$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bea450d56f28c679$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $bea450d56f28c679$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $bea450d56f28c679$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $1f96o(object), new $1f96o(other))) return false;
            return true;
        case $bea450d56f28c679$var$boolTag:
        case $bea450d56f28c679$var$dateTag:
        case $bea450d56f28c679$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $1ZVB0(+object, +other);
        case $bea450d56f28c679$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $bea450d56f28c679$var$regexpTag:
        case $bea450d56f28c679$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $bea450d56f28c679$var$mapTag:
            var convert = $hlUxe;
        case $bea450d56f28c679$var$setTag:
            var isPartial = bitmask & $bea450d56f28c679$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1HNT9);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $bea450d56f28c679$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $bFBdA(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $bea450d56f28c679$var$symbolTag:
            if ($bea450d56f28c679$var$symbolValueOf) return $bea450d56f28c679$var$symbolValueOf.call(object) == $bea450d56f28c679$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $bea450d56f28c679$var$equalByTag;

});
parcelRegister("1f96o", function(module, exports) {

var $4XvF4 = parcelRequire("4XvF4");
/** Built-in value references. */ var $0e7e40a823d9dbf9$var$Uint8Array = $4XvF4.Uint8Array;
module.exports = $0e7e40a823d9dbf9$var$Uint8Array;

});

parcelRegister("hlUxe", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $ca20407cb4066c46$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $ca20407cb4066c46$var$mapToArray;

});

parcelRegister("1HNT9", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $13e08169badc6b76$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $13e08169badc6b76$var$setToArray;

});


parcelRegister("e7uQf", function(module, exports) {

var $256zW = parcelRequire("256zW");
/** Used to compose bitmasks for value comparisons. */ var $a479a4a53942136b$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a479a4a53942136b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a479a4a53942136b$var$hasOwnProperty = $a479a4a53942136b$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a479a4a53942136b$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a479a4a53942136b$var$COMPARE_PARTIAL_FLAG, objProps = $256zW(object), objLength = objProps.length, othProps = $256zW(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a479a4a53942136b$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $a479a4a53942136b$var$equalObjects;

});
parcelRegister("256zW", function(module, exports) {

var $ly4kF = parcelRequire("ly4kF");

var $adEWj = parcelRequire("adEWj");

var $auIsz = parcelRequire("auIsz");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $184126cf319723df$var$getAllKeys(object) {
    return $ly4kF(object, $auIsz, $adEWj);
}
module.exports = $184126cf319723df$var$getAllKeys;

});
parcelRegister("ly4kF", function(module, exports) {

var $eJSVT = parcelRequire("eJSVT");

var $hl35j = parcelRequire("hl35j");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fb002240e7f7a977$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $hl35j(object) ? result : $eJSVT(result, symbolsFunc(object));
}
module.exports = $fb002240e7f7a977$var$baseGetAllKeys;

});
parcelRegister("eJSVT", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $abafe122bec25a05$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $abafe122bec25a05$var$arrayPush;

});

parcelRegister("hl35j", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c9f6ca69b445b42b$var$isArray = Array.isArray;
module.exports = $c9f6ca69b445b42b$var$isArray;

});


parcelRegister("adEWj", function(module, exports) {

var $jllUj = parcelRequire("jllUj");

var $c1fuz = parcelRequire("c1fuz");
/** Used for built-in method references. */ var $770ae0032adc1a59$var$objectProto = Object.prototype;
/** Built-in value references. */ var $770ae0032adc1a59$var$propertyIsEnumerable = $770ae0032adc1a59$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $770ae0032adc1a59$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $770ae0032adc1a59$var$getSymbols = !$770ae0032adc1a59$var$nativeGetSymbols ? $c1fuz : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $jllUj($770ae0032adc1a59$var$nativeGetSymbols(object), function(symbol) {
        return $770ae0032adc1a59$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $770ae0032adc1a59$var$getSymbols;

});
parcelRegister("jllUj", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e150f8ca74b150a6$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $e150f8ca74b150a6$var$arrayFilter;

});

parcelRegister("c1fuz", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8c01987124242b6b$var$stubArray() {
    return [];
}
module.exports = $8c01987124242b6b$var$stubArray;

});


parcelRegister("auIsz", function(module, exports) {

var $a3Put = parcelRequire("a3Put");

var $eiAbe = parcelRequire("eiAbe");

var $4kWWy = parcelRequire("4kWWy");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $7a3f3183cacb1555$var$keys(object) {
    return $4kWWy(object) ? $a3Put(object) : $eiAbe(object);
}
module.exports = $7a3f3183cacb1555$var$keys;

});
parcelRegister("a3Put", function(module, exports) {

var $cfQta = parcelRequire("cfQta");

var $93JwG = parcelRequire("93JwG");

var $hl35j = parcelRequire("hl35j");

var $kA7Y3 = parcelRequire("kA7Y3");

var $igDEU = parcelRequire("igDEU");

var $9l2OA = parcelRequire("9l2OA");
/** Used for built-in method references. */ var $75322023ccc728b9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75322023ccc728b9$var$hasOwnProperty = $75322023ccc728b9$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $75322023ccc728b9$var$arrayLikeKeys(value, inherited) {
    var isArr = $hl35j(value), isArg = !isArr && $93JwG(value), isBuff = !isArr && !isArg && $kA7Y3(value), isType = !isArr && !isArg && !isBuff && $9l2OA(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $cfQta(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $75322023ccc728b9$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $igDEU(key, length)))) result.push(key);
    return result;
}
module.exports = $75322023ccc728b9$var$arrayLikeKeys;

});
parcelRegister("cfQta", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $8ebf96163791c5d9$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $8ebf96163791c5d9$var$baseTimes;

});

parcelRegister("93JwG", function(module, exports) {

var $4M7K1 = parcelRequire("4M7K1");

var $8GSh0 = parcelRequire("8GSh0");
/** Used for built-in method references. */ var $6987b56df8447abc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6987b56df8447abc$var$hasOwnProperty = $6987b56df8447abc$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $6987b56df8447abc$var$propertyIsEnumerable = $6987b56df8447abc$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $6987b56df8447abc$var$isArguments = $4M7K1(function() {
    return arguments;
}()) ? $4M7K1 : function(value) {
    return $8GSh0(value) && $6987b56df8447abc$var$hasOwnProperty.call(value, 'callee') && !$6987b56df8447abc$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $6987b56df8447abc$var$isArguments;

});
parcelRegister("4M7K1", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $37a1a65d3f31d54a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $37a1a65d3f31d54a$var$baseIsArguments(value) {
    return $8GSh0(value) && $daBML(value) == $37a1a65d3f31d54a$var$argsTag;
}
module.exports = $37a1a65d3f31d54a$var$baseIsArguments;

});
parcelRegister("8GSh0", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $653c587ffb710892$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $653c587ffb710892$var$isObjectLike;

});



parcelRegister("kA7Y3", function(module, exports) {

var $4XvF4 = parcelRequire("4XvF4");

var $aw7Y8 = parcelRequire("aw7Y8");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $4XvF4.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $aw7Y8;
module.exports = isBuffer;

});
parcelRegister("aw7Y8", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $7a8313010a7113a5$var$stubFalse() {
    return false;
}
module.exports = $7a8313010a7113a5$var$stubFalse;

});


parcelRegister("igDEU", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d4c87c0cea7813fc$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d4c87c0cea7813fc$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d4c87c0cea7813fc$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d4c87c0cea7813fc$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d4c87c0cea7813fc$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d4c87c0cea7813fc$var$isIndex;

});

parcelRegister("9l2OA", function(module, exports) {

var $liW7J = parcelRequire("liW7J");

var $eKaiJ = parcelRequire("eKaiJ");

var $affWm = parcelRequire("affWm");
/* Node.js helper references. */ var $6cc8422df7ed43b4$var$nodeIsTypedArray = $affWm && $affWm.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $6cc8422df7ed43b4$var$isTypedArray = $6cc8422df7ed43b4$var$nodeIsTypedArray ? $eKaiJ($6cc8422df7ed43b4$var$nodeIsTypedArray) : $liW7J;
module.exports = $6cc8422df7ed43b4$var$isTypedArray;

});
parcelRegister("liW7J", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $9i5Na = parcelRequire("9i5Na");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $f8285d94e61dd1c2$var$argsTag = '[object Arguments]', $f8285d94e61dd1c2$var$arrayTag = '[object Array]', $f8285d94e61dd1c2$var$boolTag = '[object Boolean]', $f8285d94e61dd1c2$var$dateTag = '[object Date]', $f8285d94e61dd1c2$var$errorTag = '[object Error]', $f8285d94e61dd1c2$var$funcTag = '[object Function]', $f8285d94e61dd1c2$var$mapTag = '[object Map]', $f8285d94e61dd1c2$var$numberTag = '[object Number]', $f8285d94e61dd1c2$var$objectTag = '[object Object]', $f8285d94e61dd1c2$var$regexpTag = '[object RegExp]', $f8285d94e61dd1c2$var$setTag = '[object Set]', $f8285d94e61dd1c2$var$stringTag = '[object String]', $f8285d94e61dd1c2$var$weakMapTag = '[object WeakMap]';
var $f8285d94e61dd1c2$var$arrayBufferTag = '[object ArrayBuffer]', $f8285d94e61dd1c2$var$dataViewTag = '[object DataView]', $f8285d94e61dd1c2$var$float32Tag = '[object Float32Array]', $f8285d94e61dd1c2$var$float64Tag = '[object Float64Array]', $f8285d94e61dd1c2$var$int8Tag = '[object Int8Array]', $f8285d94e61dd1c2$var$int16Tag = '[object Int16Array]', $f8285d94e61dd1c2$var$int32Tag = '[object Int32Array]', $f8285d94e61dd1c2$var$uint8Tag = '[object Uint8Array]', $f8285d94e61dd1c2$var$uint8ClampedTag = '[object Uint8ClampedArray]', $f8285d94e61dd1c2$var$uint16Tag = '[object Uint16Array]', $f8285d94e61dd1c2$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $f8285d94e61dd1c2$var$typedArrayTags = {};
$f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$float32Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$float64Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$int8Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$int16Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$int32Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$uint8Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$uint8ClampedTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$uint16Tag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$uint32Tag] = true;
$f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$argsTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$arrayTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$arrayBufferTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$boolTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$dataViewTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$dateTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$errorTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$funcTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$mapTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$numberTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$objectTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$regexpTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$setTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$stringTag] = $f8285d94e61dd1c2$var$typedArrayTags[$f8285d94e61dd1c2$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f8285d94e61dd1c2$var$baseIsTypedArray(value) {
    return $8GSh0(value) && $9i5Na(value.length) && !!$f8285d94e61dd1c2$var$typedArrayTags[$daBML(value)];
}
module.exports = $f8285d94e61dd1c2$var$baseIsTypedArray;

});
parcelRegister("9i5Na", function(module, exports) {
/** Used as references for various `Number` constants. */ var $6c3a49ad6a2aa967$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6c3a49ad6a2aa967$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $6c3a49ad6a2aa967$var$MAX_SAFE_INTEGER;
}
module.exports = $6c3a49ad6a2aa967$var$isLength;

});


parcelRegister("eKaiJ", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $abbd5a26dc321271$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $abbd5a26dc321271$var$baseUnary;

});

parcelRegister("affWm", function(module, exports) {

var $3wVoD = parcelRequire("3wVoD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $3wVoD.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("eiAbe", function(module, exports) {

var $f3JeU = parcelRequire("f3JeU");

var $9er3t = parcelRequire("9er3t");
/** Used for built-in method references. */ var $a68ecfbeafbc3e30$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a68ecfbeafbc3e30$var$hasOwnProperty = $a68ecfbeafbc3e30$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $a68ecfbeafbc3e30$var$baseKeys(object) {
    if (!$f3JeU(object)) return $9er3t(object);
    var result = [];
    for(var key in Object(object))if ($a68ecfbeafbc3e30$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $a68ecfbeafbc3e30$var$baseKeys;

});
parcelRegister("f3JeU", function(module, exports) {
/** Used for built-in method references. */ var $af6a3a73757afe81$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $af6a3a73757afe81$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $af6a3a73757afe81$var$objectProto;
    return value === proto;
}
module.exports = $af6a3a73757afe81$var$isPrototype;

});

parcelRegister("9er3t", function(module, exports) {

var $8fRbj = parcelRequire("8fRbj");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b8a686b77dcf169$var$nativeKeys = $8fRbj(Object.keys, Object);
module.exports = $6b8a686b77dcf169$var$nativeKeys;

});
parcelRegister("8fRbj", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $6028fa2ddb8ca1e4$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $6028fa2ddb8ca1e4$var$overArg;

});



parcelRegister("4kWWy", function(module, exports) {

var $g2c8e = parcelRequire("g2c8e");

var $9i5Na = parcelRequire("9i5Na");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $3286c09933b4bd62$var$isArrayLike(value) {
    return value != null && $9i5Na(value.length) && !$g2c8e(value);
}
module.exports = $3286c09933b4bd62$var$isArrayLike;

});




parcelRegister("eZ3ti", function(module, exports) {

var $ehiAN = parcelRequire("ehiAN");

var $kSIXZ = parcelRequire("kSIXZ");

var $8WMrg = parcelRequire("8WMrg");

var $dYwMD = parcelRequire("dYwMD");

var $buQo3 = parcelRequire("buQo3");

var $daBML = parcelRequire("daBML");

var $5MmRP = parcelRequire("5MmRP");
/** `Object#toString` result references. */ var $ae89748edcee63ca$var$mapTag = '[object Map]', $ae89748edcee63ca$var$objectTag = '[object Object]', $ae89748edcee63ca$var$promiseTag = '[object Promise]', $ae89748edcee63ca$var$setTag = '[object Set]', $ae89748edcee63ca$var$weakMapTag = '[object WeakMap]';
var $ae89748edcee63ca$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $ae89748edcee63ca$var$dataViewCtorString = $5MmRP($ehiAN), $ae89748edcee63ca$var$mapCtorString = $5MmRP($kSIXZ), $ae89748edcee63ca$var$promiseCtorString = $5MmRP($8WMrg), $ae89748edcee63ca$var$setCtorString = $5MmRP($dYwMD), $ae89748edcee63ca$var$weakMapCtorString = $5MmRP($buQo3);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $ae89748edcee63ca$var$getTag = $daBML;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($ehiAN && $ae89748edcee63ca$var$getTag(new $ehiAN(new ArrayBuffer(1))) != $ae89748edcee63ca$var$dataViewTag || $kSIXZ && $ae89748edcee63ca$var$getTag(new $kSIXZ) != $ae89748edcee63ca$var$mapTag || $8WMrg && $ae89748edcee63ca$var$getTag($8WMrg.resolve()) != $ae89748edcee63ca$var$promiseTag || $dYwMD && $ae89748edcee63ca$var$getTag(new $dYwMD) != $ae89748edcee63ca$var$setTag || $buQo3 && $ae89748edcee63ca$var$getTag(new $buQo3) != $ae89748edcee63ca$var$weakMapTag) $ae89748edcee63ca$var$getTag = function(value) {
    var result = $daBML(value), Ctor = result == $ae89748edcee63ca$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5MmRP(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $ae89748edcee63ca$var$dataViewCtorString:
            return $ae89748edcee63ca$var$dataViewTag;
        case $ae89748edcee63ca$var$mapCtorString:
            return $ae89748edcee63ca$var$mapTag;
        case $ae89748edcee63ca$var$promiseCtorString:
            return $ae89748edcee63ca$var$promiseTag;
        case $ae89748edcee63ca$var$setCtorString:
            return $ae89748edcee63ca$var$setTag;
        case $ae89748edcee63ca$var$weakMapCtorString:
            return $ae89748edcee63ca$var$weakMapTag;
    }
    return result;
};
module.exports = $ae89748edcee63ca$var$getTag;

});
parcelRegister("ehiAN", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");

var $4XvF4 = parcelRequire("4XvF4");
/* Built-in method references that are verified to be native. */ var $a651135248d2fe17$var$DataView = $kHI38($4XvF4, 'DataView');
module.exports = $a651135248d2fe17$var$DataView;

});

parcelRegister("8WMrg", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");

var $4XvF4 = parcelRequire("4XvF4");
/* Built-in method references that are verified to be native. */ var $6839506f83ac5a93$var$Promise = $kHI38($4XvF4, 'Promise');
module.exports = $6839506f83ac5a93$var$Promise;

});

parcelRegister("dYwMD", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");

var $4XvF4 = parcelRequire("4XvF4");
/* Built-in method references that are verified to be native. */ var $a2ca4f0c284a7f2f$var$Set = $kHI38($4XvF4, 'Set');
module.exports = $a2ca4f0c284a7f2f$var$Set;

});

parcelRegister("buQo3", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");

var $4XvF4 = parcelRequire("4XvF4");
/* Built-in method references that are verified to be native. */ var $85eb22081f2cc5fa$var$WeakMap = $kHI38($4XvF4, 'WeakMap');
module.exports = $85eb22081f2cc5fa$var$WeakMap;

});





parcelRegister("ctnb9", function(module, exports) {

var $ig3KZ = parcelRequire("ig3KZ");

var $auIsz = parcelRequire("auIsz");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $914a2c4a374a4290$var$getMatchData(object) {
    var result = $auIsz(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $ig3KZ(value)
        ];
    }
    return result;
}
module.exports = $914a2c4a374a4290$var$getMatchData;

});
parcelRegister("ig3KZ", function(module, exports) {

var $e3M82 = parcelRequire("e3M82");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $d4aca2a6ea76fe57$var$isStrictComparable(value) {
    return value === value && !$e3M82(value);
}
module.exports = $d4aca2a6ea76fe57$var$isStrictComparable;

});


parcelRegister("5hir1", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $3d7cd711f122fc0d$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $3d7cd711f122fc0d$var$matchesStrictComparable;

});


parcelRegister("82m5X", function(module, exports) {

var $6iJje = parcelRequire("6iJje");

var $97kDt = parcelRequire("97kDt");

var $8IpM7 = parcelRequire("8IpM7");

var $4StiK = parcelRequire("4StiK");

var $ig3KZ = parcelRequire("ig3KZ");

var $5hir1 = parcelRequire("5hir1");

var $bLWBt = parcelRequire("bLWBt");
/** Used to compose bitmasks for value comparisons. */ var $018293329a10cd1d$var$COMPARE_PARTIAL_FLAG = 1, $018293329a10cd1d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $018293329a10cd1d$var$baseMatchesProperty(path, srcValue) {
    if ($4StiK(path) && $ig3KZ(srcValue)) return $5hir1($bLWBt(path), srcValue);
    return function(object) {
        var objValue = $97kDt(object, path);
        return objValue === undefined && objValue === srcValue ? $8IpM7(object, path) : $6iJje(srcValue, objValue, $018293329a10cd1d$var$COMPARE_PARTIAL_FLAG | $018293329a10cd1d$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $018293329a10cd1d$var$baseMatchesProperty;

});
parcelRegister("97kDt", function(module, exports) {

var $9Mhzz = parcelRequire("9Mhzz");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $6a34c656a0603ff4$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $9Mhzz(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $6a34c656a0603ff4$var$get;

});
parcelRegister("9Mhzz", function(module, exports) {

var $6oSaQ = parcelRequire("6oSaQ");

var $bLWBt = parcelRequire("bLWBt");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $71e63a55b03c821c$var$baseGet(object, path) {
    path = $6oSaQ(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$bLWBt(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $71e63a55b03c821c$var$baseGet;

});
parcelRegister("6oSaQ", function(module, exports) {

var $hl35j = parcelRequire("hl35j");

var $4StiK = parcelRequire("4StiK");

var $50vyF = parcelRequire("50vyF");

var $2YOY3 = parcelRequire("2YOY3");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4a8f01cae61d29ac$var$castPath(value, object) {
    if ($hl35j(value)) return value;
    return $4StiK(value, object) ? [
        value
    ] : $50vyF($2YOY3(value));
}
module.exports = $4a8f01cae61d29ac$var$castPath;

});
parcelRegister("4StiK", function(module, exports) {

var $hl35j = parcelRequire("hl35j");

var $4NuiV = parcelRequire("4NuiV");
/** Used to match property names within property paths. */ var $38d2ef360b9eee4e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $38d2ef360b9eee4e$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $38d2ef360b9eee4e$var$isKey(value, object) {
    if ($hl35j(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $4NuiV(value)) return true;
    return $38d2ef360b9eee4e$var$reIsPlainProp.test(value) || !$38d2ef360b9eee4e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $38d2ef360b9eee4e$var$isKey;

});
parcelRegister("4NuiV", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $37e33ed409d24b04$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $37e33ed409d24b04$var$isSymbol(value) {
    return typeof value == 'symbol' || $8GSh0(value) && $daBML(value) == $37e33ed409d24b04$var$symbolTag;
}
module.exports = $37e33ed409d24b04$var$isSymbol;

});


parcelRegister("50vyF", function(module, exports) {

var $dG9lt = parcelRequire("dG9lt");
/** Used to match property names within property paths. */ var $3a556ea15db16978$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $3a556ea15db16978$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $3a556ea15db16978$var$stringToPath = $dG9lt(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($3a556ea15db16978$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($3a556ea15db16978$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $3a556ea15db16978$var$stringToPath;

});
parcelRegister("dG9lt", function(module, exports) {

var $jPgDQ = parcelRequire("jPgDQ");
/** Used as the maximum memoize cache size. */ var $9f56726bdc3824ba$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $9f56726bdc3824ba$var$memoizeCapped(func) {
    var result = $jPgDQ(func, function(key) {
        if (cache.size === $9f56726bdc3824ba$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $9f56726bdc3824ba$var$memoizeCapped;

});
parcelRegister("jPgDQ", function(module, exports) {

var $77NjN = parcelRequire("77NjN");
/** Error message constants. */ var $e6efb06b546916db$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $e6efb06b546916db$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($e6efb06b546916db$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($e6efb06b546916db$var$memoize.Cache || $77NjN);
    return memoized;
}
// Expose `MapCache`.
$e6efb06b546916db$var$memoize.Cache = $77NjN;
module.exports = $e6efb06b546916db$var$memoize;

});



parcelRegister("2YOY3", function(module, exports) {

var $l1SOi = parcelRequire("l1SOi");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $22b8b87d78316428$var$toString(value) {
    return value == null ? '' : $l1SOi(value);
}
module.exports = $22b8b87d78316428$var$toString;

});
parcelRegister("l1SOi", function(module, exports) {

var $etweZ = parcelRequire("etweZ");

var $40ghw = parcelRequire("40ghw");

var $hl35j = parcelRequire("hl35j");

var $4NuiV = parcelRequire("4NuiV");
/** Used as references for various `Number` constants. */ var $f4f43523a66af7b6$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f4f43523a66af7b6$var$symbolProto = $etweZ ? $etweZ.prototype : undefined, $f4f43523a66af7b6$var$symbolToString = $f4f43523a66af7b6$var$symbolProto ? $f4f43523a66af7b6$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f4f43523a66af7b6$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($hl35j(value)) // Recursively convert values (susceptible to call stack limits).
    return $40ghw(value, $f4f43523a66af7b6$var$baseToString) + '';
    if ($4NuiV(value)) return $f4f43523a66af7b6$var$symbolToString ? $f4f43523a66af7b6$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f4f43523a66af7b6$var$INFINITY ? '-0' : result;
}
module.exports = $f4f43523a66af7b6$var$baseToString;

});
parcelRegister("40ghw", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2ea3caae20b2e9f6$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $2ea3caae20b2e9f6$var$arrayMap;

});




parcelRegister("bLWBt", function(module, exports) {

var $4NuiV = parcelRequire("4NuiV");
/** Used as references for various `Number` constants. */ var $89218aecd0db46e7$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $89218aecd0db46e7$var$toKey(value) {
    if (typeof value == 'string' || $4NuiV(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$89218aecd0db46e7$var$INFINITY ? '-0' : result;
}
module.exports = $89218aecd0db46e7$var$toKey;

});



parcelRegister("8IpM7", function(module, exports) {

var $2kPeT = parcelRequire("2kPeT");

var $a98KV = parcelRequire("a98KV");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $65866d2b735908bd$var$hasIn(object, path) {
    return object != null && $a98KV(object, path, $2kPeT);
}
module.exports = $65866d2b735908bd$var$hasIn;

});
parcelRegister("2kPeT", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1b35320f01718c03$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $1b35320f01718c03$var$baseHasIn;

});

parcelRegister("a98KV", function(module, exports) {

var $6oSaQ = parcelRequire("6oSaQ");

var $93JwG = parcelRequire("93JwG");

var $hl35j = parcelRequire("hl35j");

var $igDEU = parcelRequire("igDEU");

var $9i5Na = parcelRequire("9i5Na");

var $bLWBt = parcelRequire("bLWBt");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $7631895d79a83907$var$hasPath(object, path, hasFunc) {
    path = $6oSaQ(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $bLWBt(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $9i5Na(length) && $igDEU(key, length) && ($hl35j(object) || $93JwG(object));
}
module.exports = $7631895d79a83907$var$hasPath;

});



parcelRegister("8wPDv", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $63595dc2c9e940b0$var$identity(value) {
    return value;
}
module.exports = $63595dc2c9e940b0$var$identity;

});

parcelRegister("bkGBa", function(module, exports) {

var $4zJyz = parcelRequire("4zJyz");

var $ak7Es = parcelRequire("ak7Es");

var $4StiK = parcelRequire("4StiK");

var $bLWBt = parcelRequire("bLWBt");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $84029b269dfc3dd4$var$property(path) {
    return $4StiK(path) ? $4zJyz($bLWBt(path)) : $ak7Es(path);
}
module.exports = $84029b269dfc3dd4$var$property;

});
parcelRegister("4zJyz", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $354dc4e181676f17$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $354dc4e181676f17$var$baseProperty;

});

parcelRegister("ak7Es", function(module, exports) {

var $9Mhzz = parcelRequire("9Mhzz");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7841b50e23308dd2$var$basePropertyDeep(path) {
    return function(object) {
        return $9Mhzz(object, path);
    };
}
module.exports = $7841b50e23308dd2$var$basePropertyDeep;

});



parcelRegister("bweqi", function(module, exports) {
/** Error message constants. */ var $862ddefe49c0725c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $862ddefe49c0725c$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($862ddefe49c0725c$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $862ddefe49c0725c$var$negate;

});

parcelRegister("akVVk", function(module, exports) {

var $40ghw = parcelRequire("40ghw");

var $lNhdb = parcelRequire("lNhdb");

var $91WE8 = parcelRequire("91WE8");

var $dGq8D = parcelRequire("dGq8D");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $01f12c31bfd34e5c$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $40ghw($dGq8D(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $lNhdb(predicate);
    return $91WE8(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $01f12c31bfd34e5c$var$pickBy;

});
parcelRegister("91WE8", function(module, exports) {

var $9Mhzz = parcelRequire("9Mhzz");

var $kedrj = parcelRequire("kedrj");

var $6oSaQ = parcelRequire("6oSaQ");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $6931b2fb65a1ab9c$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $9Mhzz(object, path);
        if (predicate(value, path)) $kedrj(result, $6oSaQ(path, object), value);
    }
    return result;
}
module.exports = $6931b2fb65a1ab9c$var$basePickBy;

});
parcelRegister("kedrj", function(module, exports) {

var $54JYx = parcelRequire("54JYx");

var $6oSaQ = parcelRequire("6oSaQ");

var $igDEU = parcelRequire("igDEU");

var $e3M82 = parcelRequire("e3M82");

var $bLWBt = parcelRequire("bLWBt");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $eb9f8a41711ebbe5$var$baseSet(object, path, value, customizer) {
    if (!$e3M82(object)) return object;
    path = $6oSaQ(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $bLWBt(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $e3M82(objValue) ? objValue : $igDEU(path[index + 1]) ? [] : {};
        }
        $54JYx(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $eb9f8a41711ebbe5$var$baseSet;

});
parcelRegister("54JYx", function(module, exports) {

var $7dsOk = parcelRequire("7dsOk");

var $1ZVB0 = parcelRequire("1ZVB0");
/** Used for built-in method references. */ var $3b20fd36d1a21caa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3b20fd36d1a21caa$var$hasOwnProperty = $3b20fd36d1a21caa$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3b20fd36d1a21caa$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3b20fd36d1a21caa$var$hasOwnProperty.call(object, key) && $1ZVB0(objValue, value)) || value === undefined && !(key in object)) $7dsOk(object, key, value);
}
module.exports = $3b20fd36d1a21caa$var$assignValue;

});
parcelRegister("7dsOk", function(module, exports) {

var $9kdlF = parcelRequire("9kdlF");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $54101880f48bc850$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $9kdlF) $9kdlF(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $54101880f48bc850$var$baseAssignValue;

});
parcelRegister("9kdlF", function(module, exports) {

var $kHI38 = parcelRequire("kHI38");
var $6ca0560dc34ff5bf$var$defineProperty = function() {
    try {
        var func = $kHI38(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $6ca0560dc34ff5bf$var$defineProperty;

});





parcelRegister("dGq8D", function(module, exports) {

var $ly4kF = parcelRequire("ly4kF");

var $k2Qdc = parcelRequire("k2Qdc");

var $gyE4m = parcelRequire("gyE4m");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9f63791aa73541df$var$getAllKeysIn(object) {
    return $ly4kF(object, $gyE4m, $k2Qdc);
}
module.exports = $9f63791aa73541df$var$getAllKeysIn;

});
parcelRegister("k2Qdc", function(module, exports) {

var $eJSVT = parcelRequire("eJSVT");

var $8KFdO = parcelRequire("8KFdO");

var $adEWj = parcelRequire("adEWj");

var $c1fuz = parcelRequire("c1fuz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e97c7ec0cbc450d9$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e97c7ec0cbc450d9$var$getSymbolsIn = !$e97c7ec0cbc450d9$var$nativeGetSymbols ? $c1fuz : function(object) {
    var result = [];
    while(object){
        $eJSVT(result, $adEWj(object));
        object = $8KFdO(object);
    }
    return result;
};
module.exports = $e97c7ec0cbc450d9$var$getSymbolsIn;

});
parcelRegister("8KFdO", function(module, exports) {

var $8fRbj = parcelRequire("8fRbj");
/** Built-in value references. */ var $65f29869162a3acf$var$getPrototype = $8fRbj(Object.getPrototypeOf, Object);
module.exports = $65f29869162a3acf$var$getPrototype;

});


parcelRegister("gyE4m", function(module, exports) {

var $a3Put = parcelRequire("a3Put");

var $chqVd = parcelRequire("chqVd");

var $4kWWy = parcelRequire("4kWWy");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $c0dee745481a087c$var$keysIn(object) {
    return $4kWWy(object) ? $a3Put(object, true) : $chqVd(object);
}
module.exports = $c0dee745481a087c$var$keysIn;

});
parcelRegister("chqVd", function(module, exports) {

var $e3M82 = parcelRequire("e3M82");

var $f3JeU = parcelRequire("f3JeU");

var $hYYkY = parcelRequire("hYYkY");
/** Used for built-in method references. */ var $8f0bf4af1c69b18f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8f0bf4af1c69b18f$var$hasOwnProperty = $8f0bf4af1c69b18f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8f0bf4af1c69b18f$var$baseKeysIn(object) {
    if (!$e3M82(object)) return $hYYkY(object);
    var isProto = $f3JeU(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8f0bf4af1c69b18f$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $8f0bf4af1c69b18f$var$baseKeysIn;

});
parcelRegister("hYYkY", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d176d8046bf7f4da$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $d176d8046bf7f4da$var$nativeKeysIn;

});






parcelRegister("4GKjL", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsType", () => $87d3248101f669c7$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $87d3248101f669c7$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $87d3248101f669c7$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $87d3248101f669c7$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $87d3248101f669c7$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $87d3248101f669c7$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $87d3248101f669c7$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $87d3248101f669c7$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $87d3248101f669c7$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $87d3248101f669c7$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $87d3248101f669c7$export$af63d7414243dad3);

var $dRaYf = parcelRequire("dRaYf");

var $bomqv = parcelRequire("bomqv");

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $gK90j = parcelRequire("gK90j");

var $l8G72 = parcelRequire("l8G72");
const $87d3248101f669c7$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $87d3248101f669c7$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $87d3248101f669c7$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $87d3248101f669c7$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $87d3248101f669c7$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($gK90j)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bomqv))));
};
const $87d3248101f669c7$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'source').filter(Boolean));
const $87d3248101f669c7$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $87d3248101f669c7$export$6ca3170acb89054 = (event)=>event.payload.action;
const $87d3248101f669c7$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $87d3248101f669c7$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'containerId').filter(Boolean));
const $87d3248101f669c7$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'containerType').filter(Boolean));
const $87d3248101f669c7$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'objectId').filter(Boolean));
const $87d3248101f669c7$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))($87d3248101f669c7$var$extractFromContext(event, 'objectType').filter(Boolean));
const $87d3248101f669c7$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))((0, (/*@__PURE__*/$parcel$interopDefault($dRaYf)))($87d3248101f669c7$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});
parcelRegister("dRaYf", function(module, exports) {

var $8kW7W = parcelRequire("8kW7W");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $a168bc2d21618b77$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8kW7W(array, 1) : [];
}
module.exports = $a168bc2d21618b77$var$flatten;

});
parcelRegister("8kW7W", function(module, exports) {

var $eJSVT = parcelRequire("eJSVT");

var $b7ZmK = parcelRequire("b7ZmK");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $611d47d6c7620e81$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $b7ZmK);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $611d47d6c7620e81$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $eJSVT(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $611d47d6c7620e81$var$baseFlatten;

});
parcelRegister("b7ZmK", function(module, exports) {

var $etweZ = parcelRequire("etweZ");

var $93JwG = parcelRequire("93JwG");

var $hl35j = parcelRequire("hl35j");
/** Built-in value references. */ var $819ff32184dad567$var$spreadableSymbol = $etweZ ? $etweZ.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $819ff32184dad567$var$isFlattenable(value) {
    return $hl35j(value) || $93JwG(value) || !!($819ff32184dad567$var$spreadableSymbol && value && value[$819ff32184dad567$var$spreadableSymbol]);
}
module.exports = $819ff32184dad567$var$isFlattenable;

});



parcelRegister("1VqtZ", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $166fa83b12786e93$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $166fa83b12786e93$var$last;

});

parcelRegister("eVfhL", function(module, exports) {

var $ir2Uq = parcelRequire("ir2Uq");

var $3yCii = parcelRequire("3yCii");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $add23ef32b49358d$var$merge = $3yCii(function(object, source, srcIndex) {
    $ir2Uq(object, source, srcIndex);
});
module.exports = $add23ef32b49358d$var$merge;

});
parcelRegister("ir2Uq", function(module, exports) {

var $h9qpk = parcelRequire("h9qpk");

var $bNyIE = parcelRequire("bNyIE");

var $dbMLx = parcelRequire("dbMLx");

var $ceUJG = parcelRequire("ceUJG");

var $e3M82 = parcelRequire("e3M82");

var $gyE4m = parcelRequire("gyE4m");

var $2CXrw = parcelRequire("2CXrw");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $d6bd0148cbb21243$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dbMLx(source, function(srcValue, key) {
        stack || (stack = new $h9qpk);
        if ($e3M82(srcValue)) $ceUJG(object, source, key, srcIndex, $d6bd0148cbb21243$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($2CXrw(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $bNyIE(object, key, newValue);
        }
    }, $gyE4m);
}
module.exports = $d6bd0148cbb21243$var$baseMerge;

});
parcelRegister("bNyIE", function(module, exports) {

var $7dsOk = parcelRequire("7dsOk");

var $1ZVB0 = parcelRequire("1ZVB0");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $896f33cd3a5a5e63$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$1ZVB0(object[key], value) || value === undefined && !(key in object)) $7dsOk(object, key, value);
}
module.exports = $896f33cd3a5a5e63$var$assignMergeValue;

});

parcelRegister("dbMLx", function(module, exports) {

var $bbqtF = parcelRequire("bbqtF");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $99a22147b15d1e2d$var$baseFor = $bbqtF();
module.exports = $99a22147b15d1e2d$var$baseFor;

});
parcelRegister("bbqtF", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $824542a78f22583d$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $824542a78f22583d$var$createBaseFor;

});


parcelRegister("ceUJG", function(module, exports) {

var $bNyIE = parcelRequire("bNyIE");

var $8mc0c = parcelRequire("8mc0c");

var $7Ogd2 = parcelRequire("7Ogd2");

var $7v5LO = parcelRequire("7v5LO");

var $2BLEs = parcelRequire("2BLEs");

var $93JwG = parcelRequire("93JwG");

var $hl35j = parcelRequire("hl35j");

var $66gHu = parcelRequire("66gHu");

var $kA7Y3 = parcelRequire("kA7Y3");

var $g2c8e = parcelRequire("g2c8e");

var $e3M82 = parcelRequire("e3M82");

var $kESXO = parcelRequire("kESXO");

var $9l2OA = parcelRequire("9l2OA");

var $2CXrw = parcelRequire("2CXrw");

var $lxQqC = parcelRequire("lxQqC");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $8e92cd6ba280c0d0$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $2CXrw(object, key), srcValue = $2CXrw(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $bNyIE(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $hl35j(srcValue), isBuff = !isArr && $kA7Y3(srcValue), isTyped = !isArr && !isBuff && $9l2OA(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($hl35j(objValue)) newValue = objValue;
            else if ($66gHu(objValue)) newValue = $7v5LO(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $8mc0c(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $7Ogd2(srcValue, true);
            } else newValue = [];
        } else if ($kESXO(srcValue) || $93JwG(srcValue)) {
            newValue = objValue;
            if ($93JwG(objValue)) newValue = $lxQqC(objValue);
            else if (!$e3M82(objValue) || $g2c8e(objValue)) newValue = $2BLEs(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $bNyIE(object, key, newValue);
}
module.exports = $8e92cd6ba280c0d0$var$baseMergeDeep;

});
parcelRegister("8mc0c", function(module, exports) {

var $4XvF4 = parcelRequire("4XvF4");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $4XvF4.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("7Ogd2", function(module, exports) {

var $339Qm = parcelRequire("339Qm");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $5af9c6c4d977b54f$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $339Qm(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $5af9c6c4d977b54f$var$cloneTypedArray;

});
parcelRegister("339Qm", function(module, exports) {

var $1f96o = parcelRequire("1f96o");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $2389499bac7ca5b4$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $1f96o(result).set(new $1f96o(arrayBuffer));
    return result;
}
module.exports = $2389499bac7ca5b4$var$cloneArrayBuffer;

});


parcelRegister("7v5LO", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $575fe77c7c084bf8$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $575fe77c7c084bf8$var$copyArray;

});

parcelRegister("2BLEs", function(module, exports) {

var $cisV2 = parcelRequire("cisV2");

var $8KFdO = parcelRequire("8KFdO");

var $f3JeU = parcelRequire("f3JeU");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $1e64001572537237$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$f3JeU(object) ? $cisV2($8KFdO(object)) : {};
}
module.exports = $1e64001572537237$var$initCloneObject;

});
parcelRegister("cisV2", function(module, exports) {

var $e3M82 = parcelRequire("e3M82");
/** Built-in value references. */ var $8f3d993048eee23b$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $8f3d993048eee23b$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$e3M82(proto)) return {};
        if ($8f3d993048eee23b$var$objectCreate) return $8f3d993048eee23b$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $8f3d993048eee23b$var$baseCreate;

});


parcelRegister("66gHu", function(module, exports) {

var $4kWWy = parcelRequire("4kWWy");

var $8GSh0 = parcelRequire("8GSh0");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $471041fa0221ab69$var$isArrayLikeObject(value) {
    return $8GSh0(value) && $4kWWy(value);
}
module.exports = $471041fa0221ab69$var$isArrayLikeObject;

});

parcelRegister("kESXO", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $8KFdO = parcelRequire("8KFdO");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $f0a22db5b5f9508e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $f0a22db5b5f9508e$var$funcProto = Function.prototype, $f0a22db5b5f9508e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f0a22db5b5f9508e$var$funcToString = $f0a22db5b5f9508e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f0a22db5b5f9508e$var$hasOwnProperty = $f0a22db5b5f9508e$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f0a22db5b5f9508e$var$objectCtorString = $f0a22db5b5f9508e$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f0a22db5b5f9508e$var$isPlainObject(value) {
    if (!$8GSh0(value) || $daBML(value) != $f0a22db5b5f9508e$var$objectTag) return false;
    var proto = $8KFdO(value);
    if (proto === null) return true;
    var Ctor = $f0a22db5b5f9508e$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $f0a22db5b5f9508e$var$funcToString.call(Ctor) == $f0a22db5b5f9508e$var$objectCtorString;
}
module.exports = $f0a22db5b5f9508e$var$isPlainObject;

});

parcelRegister("2CXrw", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1e9d3d83e25b7914$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $1e9d3d83e25b7914$var$safeGet;

});

parcelRegister("lxQqC", function(module, exports) {

var $aTpkk = parcelRequire("aTpkk");

var $gyE4m = parcelRequire("gyE4m");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $faf559344e344ed7$var$toPlainObject(value) {
    return $aTpkk(value, $gyE4m(value));
}
module.exports = $faf559344e344ed7$var$toPlainObject;

});
parcelRegister("aTpkk", function(module, exports) {

var $54JYx = parcelRequire("54JYx");

var $7dsOk = parcelRequire("7dsOk");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $7ee2afd1395166e8$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $7dsOk(object, key, newValue);
        else $54JYx(object, key, newValue);
    }
    return object;
}
module.exports = $7ee2afd1395166e8$var$copyObject;

});




parcelRegister("3yCii", function(module, exports) {

var $5bKlg = parcelRequire("5bKlg");

var $jaJ5V = parcelRequire("jaJ5V");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $2972407b53fcbcbc$var$createAssigner(assigner) {
    return $5bKlg(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $jaJ5V(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $2972407b53fcbcbc$var$createAssigner;

});
parcelRegister("5bKlg", function(module, exports) {

var $8wPDv = parcelRequire("8wPDv");

var $l3XAa = parcelRequire("l3XAa");

var $4vNCV = parcelRequire("4vNCV");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3c71ed5dedbc6445$var$baseRest(func, start) {
    return $4vNCV($l3XAa(func, start, $8wPDv), func + '');
}
module.exports = $3c71ed5dedbc6445$var$baseRest;

});
parcelRegister("l3XAa", function(module, exports) {

var $ipgnV = parcelRequire("ipgnV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f5581898886c3259$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $f5581898886c3259$var$overRest(func, start, transform) {
    start = $f5581898886c3259$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $f5581898886c3259$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $ipgnV(func, this, otherArgs);
    };
}
module.exports = $f5581898886c3259$var$overRest;

});
parcelRegister("ipgnV", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $d66745777052b87c$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $d66745777052b87c$var$apply;

});


parcelRegister("4vNCV", function(module, exports) {

var $7burg = parcelRequire("7burg");

var $7azDt = parcelRequire("7azDt");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $34908d865cfe61e9$var$setToString = $7azDt($7burg);
module.exports = $34908d865cfe61e9$var$setToString;

});
parcelRegister("7burg", function(module, exports) {

var $jbwB3 = parcelRequire("jbwB3");

var $9kdlF = parcelRequire("9kdlF");

var $8wPDv = parcelRequire("8wPDv");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $53b12bf9ce92e380$var$baseSetToString = !$9kdlF ? $8wPDv : function(func, string) {
    return $9kdlF(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $jbwB3(string),
        'writable': true
    });
};
module.exports = $53b12bf9ce92e380$var$baseSetToString;

});
parcelRegister("jbwB3", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $df78546d4cc0a87b$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $df78546d4cc0a87b$var$constant;

});


parcelRegister("7azDt", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $53851c0efeb80445$var$HOT_COUNT = 800, $53851c0efeb80445$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $53851c0efeb80445$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $53851c0efeb80445$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $53851c0efeb80445$var$nativeNow(), remaining = $53851c0efeb80445$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $53851c0efeb80445$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $53851c0efeb80445$var$shortOut;

});



parcelRegister("jaJ5V", function(module, exports) {

var $1ZVB0 = parcelRequire("1ZVB0");

var $4kWWy = parcelRequire("4kWWy");

var $igDEU = parcelRequire("igDEU");

var $e3M82 = parcelRequire("e3M82");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $df51ee597342ff47$var$isIterateeCall(value, index, object) {
    if (!$e3M82(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $4kWWy(object) && $igDEU(index, object.length) : type == 'string' && index in object) return $1ZVB0(object[index], value);
    return false;
}
module.exports = $df51ee597342ff47$var$isIterateeCall;

});



parcelRegister("l8G72", function(module, exports) {

var $jqxdR = parcelRequire("jqxdR");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $f63b02fba3c7f038$var$uniq(array) {
    return array && array.length ? $jqxdR(array) : [];
}
module.exports = $f63b02fba3c7f038$var$uniq;

});
parcelRegister("jqxdR", function(module, exports) {

var $7SHMG = parcelRequire("7SHMG");

var $cm9vO = parcelRequire("cm9vO");

var $89kNo = parcelRequire("89kNo");

var $2QtyU = parcelRequire("2QtyU");

var $3mhhl = parcelRequire("3mhhl");

var $1HNT9 = parcelRequire("1HNT9");
/** Used as the size to enable large array optimizations. */ var $e24a375641f06a7b$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $e24a375641f06a7b$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $cm9vO, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $89kNo;
    } else if (length >= $e24a375641f06a7b$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3mhhl(array);
        if (set) return $1HNT9(set);
        isCommon = false;
        includes = $2QtyU;
        seen = new $7SHMG;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $e24a375641f06a7b$var$baseUniq;

});
parcelRegister("cm9vO", function(module, exports) {

var $gFmf1 = parcelRequire("gFmf1");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $8feeeafe5ea49e10$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gFmf1(array, value, 0) > -1;
}
module.exports = $8feeeafe5ea49e10$var$arrayIncludes;

});
parcelRegister("gFmf1", function(module, exports) {

var $daajz = parcelRequire("daajz");

var $kC1N1 = parcelRequire("kC1N1");

var $35nhp = parcelRequire("35nhp");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c221ba53be301779$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $35nhp(array, value, fromIndex) : $daajz(array, $kC1N1, fromIndex);
}
module.exports = $c221ba53be301779$var$baseIndexOf;

});
parcelRegister("daajz", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $995435d4d46b3ba5$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $995435d4d46b3ba5$var$baseFindIndex;

});

parcelRegister("kC1N1", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $f018bea718bd73b3$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $f018bea718bd73b3$var$baseIsNaN;

});

parcelRegister("35nhp", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $23f3e59f5c64b53b$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $23f3e59f5c64b53b$var$strictIndexOf;

});



parcelRegister("89kNo", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5eef4b98b06e3ebd$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $5eef4b98b06e3ebd$var$arrayIncludesWith;

});

parcelRegister("3mhhl", function(module, exports) {

var $dYwMD = parcelRequire("dYwMD");

var $aUAhb = parcelRequire("aUAhb");

var $1HNT9 = parcelRequire("1HNT9");
/** Used as references for various `Number` constants. */ var $2720d45aa28dfe31$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $2720d45aa28dfe31$var$createSet = !($dYwMD && 1 / $1HNT9(new $dYwMD([
    ,
    -0
]))[1] == $2720d45aa28dfe31$var$INFINITY) ? $aUAhb : function(values) {
    return new $dYwMD(values);
};
module.exports = $2720d45aa28dfe31$var$createSet;

});
parcelRegister("aUAhb", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $7f1b4607c48775cd$var$noop() {
// No operation performed.
}
module.exports = $7f1b4607c48775cd$var$noop;

});






parcelRegister("eENmG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = module.exports.OPERATIONAL_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = module.exports.UI_EVENT_TYPE = module.exports.getEvent = module.exports.MountEvent = module.exports.fireAnalyticsEvent = module.exports.withAnalyticsContext = module.exports.AnalyticsContext = module.exports.EventTypes = module.exports.ScreenTypes = undefined;

var $cQsBQ = parcelRequire("cQsBQ");
Object.defineProperty(module.exports, 'ScreenTypes', {
    enumerable: true,
    get: function get() {
        return $cQsBQ.ScreenTypes;
    }
});
Object.defineProperty(module.exports, 'EventTypes', {
    enumerable: true,
    get: function get() {
        return $cQsBQ.EventTypes;
    }
});
Object.defineProperty(module.exports, 'UI_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $cQsBQ.UI_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'TRACK_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $cQsBQ.TRACK_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'SCREEN_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $cQsBQ.SCREEN_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'OPERATIONAL_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $cQsBQ.OPERATIONAL_EVENT_TYPE;
    }
});

var $k3nQm = parcelRequire("k3nQm");
Object.defineProperty(module.exports, 'createTestEvent', {
    enumerable: true,
    get: function get() {
        return $k3nQm.createTestEvent;
    }
});

var $a65oG = parcelRequire("a65oG");
var $aabb17f6270177b0$var$_analyticsContext2 = $aabb17f6270177b0$var$_interopRequireDefault($a65oG);

var $47KZT = parcelRequire("47KZT");
var $aabb17f6270177b0$var$_mountEvent2 = $aabb17f6270177b0$var$_interopRequireDefault($47KZT);

var $7ZMzf = parcelRequire("7ZMzf");
var $aabb17f6270177b0$var$_withAnalyticsContext2 = $aabb17f6270177b0$var$_interopRequireDefault($7ZMzf);

var $8Yslx = parcelRequire("8Yslx");
var $aabb17f6270177b0$var$_fireAnalyticsEvent2 = $aabb17f6270177b0$var$_interopRequireDefault($8Yslx);

var $cB1Tq = parcelRequire("cB1Tq");
var $aabb17f6270177b0$var$_getEventForWebClient2 = $aabb17f6270177b0$var$_interopRequireDefault($cB1Tq);
function $aabb17f6270177b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.AnalyticsContext = $aabb17f6270177b0$var$_analyticsContext2.default;
module.exports.withAnalyticsContext = $aabb17f6270177b0$var$_withAnalyticsContext2.default;
module.exports.fireAnalyticsEvent = $aabb17f6270177b0$var$_fireAnalyticsEvent2.default;
module.exports.MountEvent = $aabb17f6270177b0$var$_mountEvent2.default;
module.exports.getEvent = $aabb17f6270177b0$var$_getEventForWebClient2.default;

});
parcelRegister("cQsBQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ var $95a0889e402c7ef5$var$UI_EVENT_TYPE = module.exports.UI_EVENT_TYPE = 'UI';
var $95a0889e402c7ef5$var$TRACK_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = 'TRACK';
var $95a0889e402c7ef5$var$SCREEN_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = 'SCREEN';
var $95a0889e402c7ef5$var$OPERATIONAL_EVENT_TYPE = module.exports.OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';
/**
 * END ANALYTICS WEB CLIENT EVENTS
 */ var $95a0889e402c7ef5$var$PAGE_EVENT_ACTION = module.exports.PAGE_EVENT_ACTION = 'page-view';
var $95a0889e402c7ef5$var$SCREEN = module.exports.SCREEN = 'Screen';
var $95a0889e402c7ef5$var$DRAWER = module.exports.DRAWER = 'Drawer';
var $95a0889e402c7ef5$var$MODAL = module.exports.MODAL = 'Modal';
var $95a0889e402c7ef5$var$INLINE_DIALOG = module.exports.INLINE_DIALOG = 'InlineDialog';
var $95a0889e402c7ef5$var$DROPDOWN = module.exports.DROPDOWN = 'Dropdown';
var $95a0889e402c7ef5$var$ScreenTypes = module.exports.ScreenTypes = {
    SCREEN: $95a0889e402c7ef5$var$SCREEN,
    MODAL: $95a0889e402c7ef5$var$MODAL,
    DRAWER: $95a0889e402c7ef5$var$DRAWER,
    INLINE_DIALOG: $95a0889e402c7ef5$var$INLINE_DIALOG,
    DROPDOWN: $95a0889e402c7ef5$var$DROPDOWN
};
var $95a0889e402c7ef5$var$EventTypes = module.exports.EventTypes = {
    UI: $95a0889e402c7ef5$var$UI_EVENT_TYPE,
    TRACK: $95a0889e402c7ef5$var$TRACK_EVENT_TYPE,
    SCREEN: $95a0889e402c7ef5$var$SCREEN_EVENT_TYPE,
    OPERATIONAL: $95a0889e402c7ef5$var$OPERATIONAL_EVENT_TYPE
};

});

parcelRegister("k3nQm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = undefined;

var $ZyrkS = parcelRequire("ZyrkS");
var $e996954cbaa07c99$var$createTestEvent = module.exports.createTestEvent = function createTestEvent() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        payload: {
            action: 'thisIsADumyAction'
        }
    };
    return new $ZyrkS.default(payload);
};

});
parcelRegister("ZyrkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0a94571981e9199$export$2e2bcd8739ae039);
/// <reference types="node" />

var $bcAyF = parcelRequire("bcAyF");
class $f0a94571981e9199$export$2e2bcd8739ae039 extends (0, $bcAyF.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $f0a94571981e9199$var$clonePayload(this.payload);
            return new $f0a94571981e9199$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $f0a94571981e9199$var$clonePayload = (payload)=>{
    try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
};

});
parcelRegister("bcAyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $bba96f6a177e5d49$export$2e2bcd8739ae039);
class $bba96f6a177e5d49$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $bba96f6a177e5d49$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});



parcelRegister("a65oG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $akW80 = parcelRequire("akW80");
var $759ea6a96b980368$var$_getPrototypeOf2 = $759ea6a96b980368$var$_interopRequireDefault($akW80);

var $e1MRE = parcelRequire("e1MRE");
var $759ea6a96b980368$var$_classCallCheck3 = $759ea6a96b980368$var$_interopRequireDefault($e1MRE);

var $27SSl = parcelRequire("27SSl");
var $759ea6a96b980368$var$_createClass3 = $759ea6a96b980368$var$_interopRequireDefault($27SSl);

var $iMuMW = parcelRequire("iMuMW");
var $759ea6a96b980368$var$_possibleConstructorReturn3 = $759ea6a96b980368$var$_interopRequireDefault($iMuMW);

var $7glmA = parcelRequire("7glmA");
var $759ea6a96b980368$var$_inherits3 = $759ea6a96b980368$var$_interopRequireDefault($7glmA);

var $fc4bM = parcelRequire("fc4bM");
var $759ea6a96b980368$var$_react2 = $759ea6a96b980368$var$_interopRequireDefault($fc4bM);

var $3TJLC = parcelRequire("3TJLC");

var $5YuxV = parcelRequire("5YuxV");
var $759ea6a96b980368$var$_createContextData2 = $759ea6a96b980368$var$_interopRequireDefault($5YuxV);
function $759ea6a96b980368$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $759ea6a96b980368$var$AnalyticsContextWrapper = function(_Component) {
    (0, $759ea6a96b980368$var$_inherits3.default)(AnalyticsContextWrapper, _Component);
    function AnalyticsContextWrapper() {
        (0, $759ea6a96b980368$var$_classCallCheck3.default)(this, AnalyticsContextWrapper);
        return (0, $759ea6a96b980368$var$_possibleConstructorReturn3.default)(this, (AnalyticsContextWrapper.__proto__ || (0, $759ea6a96b980368$var$_getPrototypeOf2.default)(AnalyticsContextWrapper)).apply(this, arguments));
    }
    (0, $759ea6a96b980368$var$_createClass3.default)(AnalyticsContextWrapper, [
        {
            key: 'render',
            value: function render() {
                var data = (0, $759ea6a96b980368$var$_createContextData2.default)(this.props);
                return $759ea6a96b980368$var$_react2.default.createElement($3TJLC.default, {
                    data: data
                }, this.props.children);
            }
        }
    ]);
    return AnalyticsContextWrapper;
}($fc4bM.Component);
module.exports.default = $759ea6a96b980368$var$AnalyticsContextWrapper;

});
parcelRegister("akW80", function(module, exports) {

module.exports = {
    "default": (parcelRequire("e0fx5")),
    __esModule: true
};

});
parcelRegister("e0fx5", function(module, exports) {
parcelRequire("hvU7y");

module.exports = (parcelRequire("jPAur")).Object.getPrototypeOf;

});
parcelRegister("hvU7y", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $Bejaj = parcelRequire("Bejaj");

var $c9Oq1 = parcelRequire("c9Oq1");

(parcelRequire("2LJoY"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $c9Oq1($Bejaj(it));
    };
});

});
parcelRegister("Bejaj", function(module, exports) {
// 7.1.13 ToObject(argument)

var $i7SgQ = parcelRequire("i7SgQ");
module.exports = function(it) {
    return Object($i7SgQ(it));
};

});
parcelRegister("i7SgQ", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("c9Oq1", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $4Gvaf = parcelRequire("4Gvaf");

var $Bejaj = parcelRequire("Bejaj");

var $8d9d6f645fe84218$var$IE_PROTO = (parcelRequire("lIXTj"))('IE_PROTO');
var $8d9d6f645fe84218$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $Bejaj(O);
    if ($4Gvaf(O, $8d9d6f645fe84218$var$IE_PROTO)) return O[$8d9d6f645fe84218$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $8d9d6f645fe84218$var$ObjectProto : null;
};

});
parcelRegister("4Gvaf", function(module, exports) {
var $3693423987f2a835$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $3693423987f2a835$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("lIXTj", function(module, exports) {

var $fd0c2a2f792ce6be$var$shared = (parcelRequire("cvzC6"))('keys');

var $7W2v1 = parcelRequire("7W2v1");
module.exports = function(key) {
    return $fd0c2a2f792ce6be$var$shared[key] || ($fd0c2a2f792ce6be$var$shared[key] = $7W2v1(key));
};

});
parcelRegister("cvzC6", function(module, exports) {

var $jPAur = parcelRequire("jPAur");

var $gPLBa = parcelRequire("gPLBa");
var $91b401601dca9b04$var$SHARED = '__core-js_shared__';
var $91b401601dca9b04$var$store = $gPLBa[$91b401601dca9b04$var$SHARED] || ($gPLBa[$91b401601dca9b04$var$SHARED] = {});

(module.exports = function(key, value) {
    return $91b401601dca9b04$var$store[key] || ($91b401601dca9b04$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $jPAur.version,
    mode: (parcelRequire("7XG4C")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("jPAur", function(module, exports) {
var $e6ff15e7cb898cde$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $e6ff15e7cb898cde$var$core; // eslint-disable-line no-undef

});

parcelRegister("gPLBa", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $c41654d9bc656fbd$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $c41654d9bc656fbd$var$global; // eslint-disable-line no-undef

});

parcelRegister("7XG4C", function(module, exports) {
module.exports = true;

});


parcelRegister("7W2v1", function(module, exports) {
var $5c6fe37f8dbe3d4f$var$id = 0;
var $5c6fe37f8dbe3d4f$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$5c6fe37f8dbe3d4f$var$id + $5c6fe37f8dbe3d4f$var$px).toString(36));
};

});



parcelRegister("2LJoY", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $aYB6i = parcelRequire("aYB6i");

var $jPAur = parcelRequire("jPAur");

var $danph = parcelRequire("danph");
module.exports = function(KEY, exec) {
    var fn = ($jPAur.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $aYB6i($aYB6i.S + $aYB6i.F * $danph(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("aYB6i", function(module, exports) {

var $gPLBa = parcelRequire("gPLBa");

var $jPAur = parcelRequire("jPAur");

var $hda8t = parcelRequire("hda8t");

var $9MeJw = parcelRequire("9MeJw");

var $4Gvaf = parcelRequire("4Gvaf");
var $020ff0aadb5ebd84$var$PROTOTYPE = 'prototype';
var $020ff0aadb5ebd84$var$$export = function(type, name, source) {
    var IS_FORCED = type & $020ff0aadb5ebd84$var$$export.F;
    var IS_GLOBAL = type & $020ff0aadb5ebd84$var$$export.G;
    var IS_STATIC = type & $020ff0aadb5ebd84$var$$export.S;
    var IS_PROTO = type & $020ff0aadb5ebd84$var$$export.P;
    var IS_BIND = type & $020ff0aadb5ebd84$var$$export.B;
    var IS_WRAP = type & $020ff0aadb5ebd84$var$$export.W;
    var exports = IS_GLOBAL ? $jPAur : $jPAur[name] || ($jPAur[name] = {});
    var expProto = exports[$020ff0aadb5ebd84$var$PROTOTYPE];
    var target = IS_GLOBAL ? $gPLBa : IS_STATIC ? $gPLBa[name] : ($gPLBa[name] || {})[$020ff0aadb5ebd84$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $4Gvaf(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $hda8t(out, $gPLBa) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$020ff0aadb5ebd84$var$PROTOTYPE] = C[$020ff0aadb5ebd84$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $hda8t(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $020ff0aadb5ebd84$var$$export.R && expProto && !expProto[key]) $9MeJw(expProto, key, out);
        }
    }
};
// type bitmap
$020ff0aadb5ebd84$var$$export.F = 1; // forced
$020ff0aadb5ebd84$var$$export.G = 2; // global
$020ff0aadb5ebd84$var$$export.S = 4; // static
$020ff0aadb5ebd84$var$$export.P = 8; // proto
$020ff0aadb5ebd84$var$$export.B = 16; // bind
$020ff0aadb5ebd84$var$$export.W = 32; // wrap
$020ff0aadb5ebd84$var$$export.U = 64; // safe
$020ff0aadb5ebd84$var$$export.R = 128; // real proto method for `library`
module.exports = $020ff0aadb5ebd84$var$$export;

});
parcelRegister("hda8t", function(module, exports) {
// optional / simple context binding

var $bKpfO = parcelRequire("bKpfO");
module.exports = function(fn, that, length) {
    $bKpfO(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("bKpfO", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9MeJw", function(module, exports) {

var $3v06f = parcelRequire("3v06f");

var $krzP8 = parcelRequire("krzP8");

module.exports = (parcelRequire("dar3x")) ? function(object, key, value) {
    return $3v06f.f(object, key, $krzP8(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("3v06f", function(module, exports) {
$parcel$export(module.exports, "f", () => $28c458257bac4b51$export$2d1720544b23b823, (v) => $28c458257bac4b51$export$2d1720544b23b823 = v);
var $28c458257bac4b51$export$2d1720544b23b823;

var $7bOu1 = parcelRequire("7bOu1");

var $eI2mU = parcelRequire("eI2mU");

var $hlEid = parcelRequire("hlEid");
var $28c458257bac4b51$var$dP = Object.defineProperty;

$28c458257bac4b51$export$2d1720544b23b823 = (parcelRequire("dar3x")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $7bOu1(O);
    P = $hlEid(P, true);
    $7bOu1(Attributes);
    if ($eI2mU) try {
        return $28c458257bac4b51$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("7bOu1", function(module, exports) {

var $dYIGx = parcelRequire("dYIGx");
module.exports = function(it) {
    if (!$dYIGx(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("dYIGx", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("eI2mU", function(module, exports) {



module.exports = !(parcelRequire("dar3x")) && !(parcelRequire("danph"))(function() {
    return Object.defineProperty((parcelRequire("6k4nX"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("dar3x", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("danph"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("danph", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("6k4nX", function(module, exports) {

var $dYIGx = parcelRequire("dYIGx");

var $gPLBa = parcelRequire("gPLBa");
var $49a803360260fa30$require$document = $gPLBa.document;
// typeof document.createElement is 'object' in old IE
var $49a803360260fa30$var$is = $dYIGx($49a803360260fa30$require$document) && $dYIGx($49a803360260fa30$require$document.createElement);
module.exports = function(it) {
    return $49a803360260fa30$var$is ? $49a803360260fa30$require$document.createElement(it) : {};
};

});


parcelRegister("hlEid", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $dYIGx = parcelRequire("dYIGx");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$dYIGx(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$dYIGx(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$dYIGx(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$dYIGx(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("krzP8", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("e1MRE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $a367101ce8dc992e$export$1e511d4a378977f5, (v) => $a367101ce8dc992e$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $a367101ce8dc992e$export$2e2bcd8739ae039, (v) => $a367101ce8dc992e$export$2e2bcd8739ae039 = v);
var $a367101ce8dc992e$export$1e511d4a378977f5;
var $a367101ce8dc992e$export$2e2bcd8739ae039;
"use strict";
$a367101ce8dc992e$export$1e511d4a378977f5 = true;
$a367101ce8dc992e$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("27SSl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $18c6cd56d9b2cbaf$export$1e511d4a378977f5, (v) => $18c6cd56d9b2cbaf$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $18c6cd56d9b2cbaf$export$2e2bcd8739ae039, (v) => $18c6cd56d9b2cbaf$export$2e2bcd8739ae039 = v);
var $18c6cd56d9b2cbaf$export$1e511d4a378977f5;
var $18c6cd56d9b2cbaf$export$2e2bcd8739ae039;
"use strict";
$18c6cd56d9b2cbaf$export$1e511d4a378977f5 = true;

var $7OaWH = parcelRequire("7OaWH");
var $18c6cd56d9b2cbaf$var$_defineProperty2 = $18c6cd56d9b2cbaf$var$_interopRequireDefault($7OaWH);
function $18c6cd56d9b2cbaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$18c6cd56d9b2cbaf$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $18c6cd56d9b2cbaf$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("7OaWH", function(module, exports) {

module.exports = {
    "default": (parcelRequire("lglAq")),
    __esModule: true
};

});
parcelRegister("lglAq", function(module, exports) {
parcelRequire("cVb8U");

var $jPAur = parcelRequire("jPAur");
var $f7abd63ab7fffcb0$require$$Object = $jPAur.Object;
module.exports = function defineProperty(it, key, desc) {
    return $f7abd63ab7fffcb0$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("cVb8U", function(module, exports) {

var $aYB6i = parcelRequire("aYB6i");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$aYB6i($aYB6i.S + $aYB6i.F * !(parcelRequire("dar3x")), 'Object', {
    defineProperty: (parcelRequire("3v06f")).f
});

});




parcelRegister("iMuMW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $dac4979f11718f8a$export$1e511d4a378977f5, (v) => $dac4979f11718f8a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $dac4979f11718f8a$export$2e2bcd8739ae039, (v) => $dac4979f11718f8a$export$2e2bcd8739ae039 = v);
var $dac4979f11718f8a$export$1e511d4a378977f5;
var $dac4979f11718f8a$export$2e2bcd8739ae039;
"use strict";
$dac4979f11718f8a$export$1e511d4a378977f5 = true;

var $5dvzs = parcelRequire("5dvzs");
var $dac4979f11718f8a$var$_typeof3 = $dac4979f11718f8a$var$_interopRequireDefault($5dvzs);
function $dac4979f11718f8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$dac4979f11718f8a$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $dac4979f11718f8a$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("5dvzs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $3cc6a7fa19d13ecf$export$1e511d4a378977f5, (v) => $3cc6a7fa19d13ecf$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3cc6a7fa19d13ecf$export$2e2bcd8739ae039, (v) => $3cc6a7fa19d13ecf$export$2e2bcd8739ae039 = v);
var $3cc6a7fa19d13ecf$export$1e511d4a378977f5;
var $3cc6a7fa19d13ecf$export$2e2bcd8739ae039;
"use strict";
$3cc6a7fa19d13ecf$export$1e511d4a378977f5 = true;

var $l1NvO = parcelRequire("l1NvO");
var $3cc6a7fa19d13ecf$var$_iterator2 = $3cc6a7fa19d13ecf$var$_interopRequireDefault($l1NvO);

var $8HFNs = parcelRequire("8HFNs");
var $3cc6a7fa19d13ecf$var$_symbol2 = $3cc6a7fa19d13ecf$var$_interopRequireDefault($8HFNs);
var $3cc6a7fa19d13ecf$var$_typeof = typeof $3cc6a7fa19d13ecf$var$_symbol2.default === "function" && typeof $3cc6a7fa19d13ecf$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $3cc6a7fa19d13ecf$var$_symbol2.default === "function" && obj.constructor === $3cc6a7fa19d13ecf$var$_symbol2.default && obj !== $3cc6a7fa19d13ecf$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $3cc6a7fa19d13ecf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3cc6a7fa19d13ecf$export$2e2bcd8739ae039 = typeof $3cc6a7fa19d13ecf$var$_symbol2.default === "function" && $3cc6a7fa19d13ecf$var$_typeof($3cc6a7fa19d13ecf$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $3cc6a7fa19d13ecf$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $3cc6a7fa19d13ecf$var$_symbol2.default === "function" && obj.constructor === $3cc6a7fa19d13ecf$var$_symbol2.default && obj !== $3cc6a7fa19d13ecf$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $3cc6a7fa19d13ecf$var$_typeof(obj);
};

});
parcelRegister("l1NvO", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gY34O")),
    __esModule: true
};

});
parcelRegister("gY34O", function(module, exports) {
parcelRequire("1Lr00");
parcelRequire("641It");

module.exports = (parcelRequire("3uKO9")).f('iterator');

});
parcelRegister("1Lr00", function(module, exports) {
'use strict';

var $148f1fb42fd34d24$var$$at = (parcelRequire("7lETB"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("4Lfk6"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $148f1fb42fd34d24$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("7lETB", function(module, exports) {

var $3Pmrb = parcelRequire("3Pmrb");

var $i7SgQ = parcelRequire("i7SgQ");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($i7SgQ(that));
        var i = $3Pmrb(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("3Pmrb", function(module, exports) {
// 7.1.4 ToInteger
var $2c978a1a5b2d36a1$var$ceil = Math.ceil;
var $2c978a1a5b2d36a1$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $2c978a1a5b2d36a1$var$floor : $2c978a1a5b2d36a1$var$ceil)(it);
};

});


parcelRegister("4Lfk6", function(module, exports) {
'use strict';

var $7XG4C = parcelRequire("7XG4C");

var $aYB6i = parcelRequire("aYB6i");

var $6sIZs = parcelRequire("6sIZs");

var $9MeJw = parcelRequire("9MeJw");

var $aBxsx = parcelRequire("aBxsx");

var $kv2WT = parcelRequire("kv2WT");

var $8D74x = parcelRequire("8D74x");

var $c9Oq1 = parcelRequire("c9Oq1");

var $37777010f2841a26$var$ITERATOR = (parcelRequire("8PUov"))('iterator');
var $37777010f2841a26$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $37777010f2841a26$var$FF_ITERATOR = '@@iterator';
var $37777010f2841a26$var$KEYS = 'keys';
var $37777010f2841a26$var$VALUES = 'values';
var $37777010f2841a26$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $kv2WT(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$37777010f2841a26$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $37777010f2841a26$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $37777010f2841a26$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $37777010f2841a26$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$37777010f2841a26$var$ITERATOR] || proto[$37777010f2841a26$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $c9Oq1($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $8D74x(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$7XG4C && typeof IteratorPrototype[$37777010f2841a26$var$ITERATOR] != 'function') $9MeJw(IteratorPrototype, $37777010f2841a26$var$ITERATOR, $37777010f2841a26$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $37777010f2841a26$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$7XG4C || FORCED) && ($37777010f2841a26$var$BUGGY || VALUES_BUG || !proto[$37777010f2841a26$var$ITERATOR])) $9MeJw(proto, $37777010f2841a26$var$ITERATOR, $default);
    // Plug for library
    $aBxsx[NAME] = $default;
    $aBxsx[TAG] = $37777010f2841a26$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($37777010f2841a26$var$VALUES),
            keys: IS_SET ? $default : getMethod($37777010f2841a26$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $6sIZs(proto, key, methods[key]);
        } else $aYB6i($aYB6i.P + $aYB6i.F * ($37777010f2841a26$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("6sIZs", function(module, exports) {

module.exports = (parcelRequire("9MeJw"));

});

parcelRegister("aBxsx", function(module, exports) {
module.exports = {};

});

parcelRegister("kv2WT", function(module, exports) {
'use strict';

var $3ulAQ = parcelRequire("3ulAQ");

var $krzP8 = parcelRequire("krzP8");

var $8D74x = parcelRequire("8D74x");
var $eec8fd80eacf450c$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9MeJw"))($eec8fd80eacf450c$var$IteratorPrototype, (parcelRequire("8PUov"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $3ulAQ($eec8fd80eacf450c$var$IteratorPrototype, {
        next: $krzP8(1, next)
    });
    $8D74x(Constructor, NAME + ' Iterator');
};

});
parcelRegister("3ulAQ", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $7bOu1 = parcelRequire("7bOu1");

var $lwYZK = parcelRequire("lwYZK");

var $gKgGP = parcelRequire("gKgGP");

var $28a4ec6f19d0e45c$var$IE_PROTO = (parcelRequire("lIXTj"))('IE_PROTO');
var $28a4ec6f19d0e45c$var$Empty = function() {};
var $28a4ec6f19d0e45c$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $28a4ec6f19d0e45c$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("6k4nX"))('iframe');
    var i = $gKgGP.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("9TuhG")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $28a4ec6f19d0e45c$var$createDict = iframeDocument.F;
    while(i--)delete $28a4ec6f19d0e45c$var$createDict[$28a4ec6f19d0e45c$var$PROTOTYPE][$gKgGP[i]];
    return $28a4ec6f19d0e45c$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $28a4ec6f19d0e45c$var$Empty[$28a4ec6f19d0e45c$var$PROTOTYPE] = $7bOu1(O);
        result = new $28a4ec6f19d0e45c$var$Empty();
        $28a4ec6f19d0e45c$var$Empty[$28a4ec6f19d0e45c$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$28a4ec6f19d0e45c$var$IE_PROTO] = O;
    } else result = $28a4ec6f19d0e45c$var$createDict();
    return Properties === undefined ? result : $lwYZK(result, Properties);
};

});
parcelRegister("lwYZK", function(module, exports) {

var $3v06f = parcelRequire("3v06f");

var $7bOu1 = parcelRequire("7bOu1");

var $aH1Ij = parcelRequire("aH1Ij");

module.exports = (parcelRequire("dar3x")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $7bOu1(O);
    var keys = $aH1Ij(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$3v06f.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("aH1Ij", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $MqyLd = parcelRequire("MqyLd");

var $gKgGP = parcelRequire("gKgGP");
module.exports = Object.keys || function keys(O) {
    return $MqyLd(O, $gKgGP);
};

});
parcelRegister("MqyLd", function(module, exports) {

var $4Gvaf = parcelRequire("4Gvaf");

var $8uJlv = parcelRequire("8uJlv");

var $09191600ce78cf24$var$arrayIndexOf = (parcelRequire("2dzJX"))(false);

var $09191600ce78cf24$var$IE_PROTO = (parcelRequire("lIXTj"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $8uJlv(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $09191600ce78cf24$var$IE_PROTO) $4Gvaf(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($4Gvaf(O, key = names[i++])) ~$09191600ce78cf24$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("8uJlv", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $WEjGg = parcelRequire("WEjGg");

var $i7SgQ = parcelRequire("i7SgQ");
module.exports = function(it) {
    return $WEjGg($i7SgQ(it));
};

});
parcelRegister("WEjGg", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $jVgQR = parcelRequire("jVgQR");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $jVgQR(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("jVgQR", function(module, exports) {
var $e8106997042e64f2$var$toString = {}.toString;
module.exports = function(it) {
    return $e8106997042e64f2$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("2dzJX", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $8uJlv = parcelRequire("8uJlv");

var $e8byJ = parcelRequire("e8byJ");

var $1yCQF = parcelRequire("1yCQF");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $8uJlv($this);
        var length = $e8byJ(O.length);
        var index = $1yCQF(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("e8byJ", function(module, exports) {
// 7.1.15 ToLength

var $3Pmrb = parcelRequire("3Pmrb");
var $a49ac778d457db1d$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $a49ac778d457db1d$var$min($3Pmrb(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("1yCQF", function(module, exports) {

var $3Pmrb = parcelRequire("3Pmrb");
var $122719ecd8362f24$var$max = Math.max;
var $122719ecd8362f24$var$min = Math.min;
module.exports = function(index, length) {
    index = $3Pmrb(index);
    return index < 0 ? $122719ecd8362f24$var$max(index + length, 0) : $122719ecd8362f24$var$min(index, length);
};

});



parcelRegister("gKgGP", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("9TuhG", function(module, exports) {

var $gPLBa = parcelRequire("gPLBa");
var $7340bded8a60c484$require$document = $gPLBa.document;
module.exports = $7340bded8a60c484$require$document && $7340bded8a60c484$require$document.documentElement;

});


parcelRegister("8D74x", function(module, exports) {

var $3v06f = parcelRequire("3v06f");
var $648773a6de507037$require$def = $3v06f.f;

var $4Gvaf = parcelRequire("4Gvaf");

var $648773a6de507037$var$TAG = (parcelRequire("8PUov"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$4Gvaf(it = stat ? it : it.prototype, $648773a6de507037$var$TAG)) $648773a6de507037$require$def(it, $648773a6de507037$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("8PUov", function(module, exports) {

var $66eed4e5a56c7765$var$store = (parcelRequire("cvzC6"))('wks');

var $7W2v1 = parcelRequire("7W2v1");

var $gPLBa = parcelRequire("gPLBa");
var $66eed4e5a56c7765$require$Symbol = $gPLBa.Symbol;
var $66eed4e5a56c7765$var$USE_SYMBOL = typeof $66eed4e5a56c7765$require$Symbol == 'function';
var $66eed4e5a56c7765$var$$exports = module.exports = function(name) {
    return $66eed4e5a56c7765$var$store[name] || ($66eed4e5a56c7765$var$store[name] = $66eed4e5a56c7765$var$USE_SYMBOL && $66eed4e5a56c7765$require$Symbol[name] || ($66eed4e5a56c7765$var$USE_SYMBOL ? $66eed4e5a56c7765$require$Symbol : $7W2v1)('Symbol.' + name));
};
$66eed4e5a56c7765$var$$exports.store = $66eed4e5a56c7765$var$store;

});





parcelRegister("641It", function(module, exports) {
parcelRequire("jKu6F");

var $gPLBa = parcelRequire("gPLBa");

var $9MeJw = parcelRequire("9MeJw");

var $aBxsx = parcelRequire("aBxsx");

var $0123af44b18868aa$var$TO_STRING_TAG = (parcelRequire("8PUov"))('toStringTag');
var $0123af44b18868aa$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $0123af44b18868aa$var$i = 0; $0123af44b18868aa$var$i < $0123af44b18868aa$var$DOMIterables.length; $0123af44b18868aa$var$i++){
    var $0123af44b18868aa$var$NAME = $0123af44b18868aa$var$DOMIterables[$0123af44b18868aa$var$i];
    var $0123af44b18868aa$var$Collection = $gPLBa[$0123af44b18868aa$var$NAME];
    var $0123af44b18868aa$var$proto = $0123af44b18868aa$var$Collection && $0123af44b18868aa$var$Collection.prototype;
    if ($0123af44b18868aa$var$proto && !$0123af44b18868aa$var$proto[$0123af44b18868aa$var$TO_STRING_TAG]) $9MeJw($0123af44b18868aa$var$proto, $0123af44b18868aa$var$TO_STRING_TAG, $0123af44b18868aa$var$NAME);
    $aBxsx[$0123af44b18868aa$var$NAME] = $aBxsx.Array;
}

});
parcelRegister("jKu6F", function(module, exports) {
'use strict';

var $iu1Dt = parcelRequire("iu1Dt");

var $8as3A = parcelRequire("8as3A");

var $aBxsx = parcelRequire("aBxsx");

var $8uJlv = parcelRequire("8uJlv");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("4Lfk6"))(Array, 'Array', function(iterated, kind) {
    this._t = $8uJlv(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $8as3A(1);
    }
    if (kind == 'keys') return $8as3A(0, index);
    if (kind == 'values') return $8as3A(0, O[index]);
    return $8as3A(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$aBxsx.Arguments = $aBxsx.Array;
$iu1Dt('keys');
$iu1Dt('values');
$iu1Dt('entries');

});
parcelRegister("iu1Dt", function(module, exports) {
module.exports = function() {};

});

parcelRegister("8as3A", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("3uKO9", function(module, exports) {
$parcel$export(module.exports, "f", () => $28b87b832c9f8a93$export$2d1720544b23b823, (v) => $28b87b832c9f8a93$export$2d1720544b23b823 = v);
var $28b87b832c9f8a93$export$2d1720544b23b823;

$28b87b832c9f8a93$export$2d1720544b23b823 = (parcelRequire("8PUov"));

});



parcelRegister("8HFNs", function(module, exports) {

module.exports = {
    "default": (parcelRequire("7BZmr")),
    __esModule: true
};

});
parcelRegister("7BZmr", function(module, exports) {
parcelRequire("gwoFO");
parcelRequire("1OZyJ");
parcelRequire("7HDK1");
parcelRequire("egYGG");

module.exports = (parcelRequire("jPAur")).Symbol;

});
parcelRegister("gwoFO", function(module, exports) {
'use strict';

var $gPLBa = parcelRequire("gPLBa");

var $4Gvaf = parcelRequire("4Gvaf");

var $dar3x = parcelRequire("dar3x");

var $aYB6i = parcelRequire("aYB6i");

var $6sIZs = parcelRequire("6sIZs");

var $giItu = parcelRequire("giItu");
var $c072c6204b87bce1$require$META = $giItu.KEY;

var $danph = parcelRequire("danph");

var $cvzC6 = parcelRequire("cvzC6");

var $8D74x = parcelRequire("8D74x");

var $7W2v1 = parcelRequire("7W2v1");

var $8PUov = parcelRequire("8PUov");

var $3uKO9 = parcelRequire("3uKO9");

var $c7Nsa = parcelRequire("c7Nsa");

var $idBr3 = parcelRequire("idBr3");

var $7eAAc = parcelRequire("7eAAc");

var $7bOu1 = parcelRequire("7bOu1");

var $dYIGx = parcelRequire("dYIGx");

var $Bejaj = parcelRequire("Bejaj");

var $8uJlv = parcelRequire("8uJlv");

var $hlEid = parcelRequire("hlEid");

var $krzP8 = parcelRequire("krzP8");

var $3ulAQ = parcelRequire("3ulAQ");

var $9inKd = parcelRequire("9inKd");

var $N9PbJ = parcelRequire("N9PbJ");

var $8FaN5 = parcelRequire("8FaN5");

var $3v06f = parcelRequire("3v06f");

var $aH1Ij = parcelRequire("aH1Ij");
var $c072c6204b87bce1$var$gOPD = $N9PbJ.f;
var $c072c6204b87bce1$var$dP = $3v06f.f;
var $c072c6204b87bce1$var$gOPN = $9inKd.f;
var $c072c6204b87bce1$var$$Symbol = $gPLBa.Symbol;
var $c072c6204b87bce1$var$$JSON = $gPLBa.JSON;
var $c072c6204b87bce1$var$_stringify = $c072c6204b87bce1$var$$JSON && $c072c6204b87bce1$var$$JSON.stringify;
var $c072c6204b87bce1$var$PROTOTYPE = 'prototype';
var $c072c6204b87bce1$var$HIDDEN = $8PUov('_hidden');
var $c072c6204b87bce1$var$TO_PRIMITIVE = $8PUov('toPrimitive');
var $c072c6204b87bce1$var$isEnum = {}.propertyIsEnumerable;
var $c072c6204b87bce1$var$SymbolRegistry = $cvzC6('symbol-registry');
var $c072c6204b87bce1$var$AllSymbols = $cvzC6('symbols');
var $c072c6204b87bce1$var$OPSymbols = $cvzC6('op-symbols');
var $c072c6204b87bce1$var$ObjectProto = Object[$c072c6204b87bce1$var$PROTOTYPE];
var $c072c6204b87bce1$var$USE_NATIVE = typeof $c072c6204b87bce1$var$$Symbol == 'function' && !!$8FaN5.f;
var $c072c6204b87bce1$var$QObject = $gPLBa.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $c072c6204b87bce1$var$setter = !$c072c6204b87bce1$var$QObject || !$c072c6204b87bce1$var$QObject[$c072c6204b87bce1$var$PROTOTYPE] || !$c072c6204b87bce1$var$QObject[$c072c6204b87bce1$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $c072c6204b87bce1$var$setSymbolDesc = $dar3x && $danph(function() {
    return $3ulAQ($c072c6204b87bce1$var$dP({}, 'a', {
        get: function() {
            return $c072c6204b87bce1$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $c072c6204b87bce1$var$gOPD($c072c6204b87bce1$var$ObjectProto, key);
    if (protoDesc) delete $c072c6204b87bce1$var$ObjectProto[key];
    $c072c6204b87bce1$var$dP(it, key, D);
    if (protoDesc && it !== $c072c6204b87bce1$var$ObjectProto) $c072c6204b87bce1$var$dP($c072c6204b87bce1$var$ObjectProto, key, protoDesc);
} : $c072c6204b87bce1$var$dP;
var $c072c6204b87bce1$var$wrap = function(tag) {
    var sym = $c072c6204b87bce1$var$AllSymbols[tag] = $3ulAQ($c072c6204b87bce1$var$$Symbol[$c072c6204b87bce1$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $c072c6204b87bce1$var$isSymbol = $c072c6204b87bce1$var$USE_NATIVE && typeof $c072c6204b87bce1$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $c072c6204b87bce1$var$$Symbol;
};
var $c072c6204b87bce1$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $c072c6204b87bce1$var$ObjectProto) $c072c6204b87bce1$var$$defineProperty($c072c6204b87bce1$var$OPSymbols, key, D);
    $7bOu1(it);
    key = $hlEid(key, true);
    $7bOu1(D);
    if ($4Gvaf($c072c6204b87bce1$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$4Gvaf(it, $c072c6204b87bce1$var$HIDDEN)) $c072c6204b87bce1$var$dP(it, $c072c6204b87bce1$var$HIDDEN, $krzP8(1, {}));
            it[$c072c6204b87bce1$var$HIDDEN][key] = true;
        } else {
            if ($4Gvaf(it, $c072c6204b87bce1$var$HIDDEN) && it[$c072c6204b87bce1$var$HIDDEN][key]) it[$c072c6204b87bce1$var$HIDDEN][key] = false;
            D = $3ulAQ(D, {
                enumerable: $krzP8(0, false)
            });
        }
        return $c072c6204b87bce1$var$setSymbolDesc(it, key, D);
    }
    return $c072c6204b87bce1$var$dP(it, key, D);
};
var $c072c6204b87bce1$var$$defineProperties = function defineProperties(it, P) {
    $7bOu1(it);
    var keys = $idBr3(P = $8uJlv(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$c072c6204b87bce1$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $c072c6204b87bce1$var$$create = function create(it, P) {
    return P === undefined ? $3ulAQ(it) : $c072c6204b87bce1$var$$defineProperties($3ulAQ(it), P);
};
var $c072c6204b87bce1$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $c072c6204b87bce1$var$isEnum.call(this, key = $hlEid(key, true));
    if (this === $c072c6204b87bce1$var$ObjectProto && $4Gvaf($c072c6204b87bce1$var$AllSymbols, key) && !$4Gvaf($c072c6204b87bce1$var$OPSymbols, key)) return false;
    return E || !$4Gvaf(this, key) || !$4Gvaf($c072c6204b87bce1$var$AllSymbols, key) || $4Gvaf(this, $c072c6204b87bce1$var$HIDDEN) && this[$c072c6204b87bce1$var$HIDDEN][key] ? E : true;
};
var $c072c6204b87bce1$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $8uJlv(it);
    key = $hlEid(key, true);
    if (it === $c072c6204b87bce1$var$ObjectProto && $4Gvaf($c072c6204b87bce1$var$AllSymbols, key) && !$4Gvaf($c072c6204b87bce1$var$OPSymbols, key)) return;
    var D = $c072c6204b87bce1$var$gOPD(it, key);
    if (D && $4Gvaf($c072c6204b87bce1$var$AllSymbols, key) && !($4Gvaf(it, $c072c6204b87bce1$var$HIDDEN) && it[$c072c6204b87bce1$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $c072c6204b87bce1$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $c072c6204b87bce1$var$gOPN($8uJlv(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$4Gvaf($c072c6204b87bce1$var$AllSymbols, key = names[i++]) && key != $c072c6204b87bce1$var$HIDDEN && key != $c072c6204b87bce1$require$META) result.push(key);
    return result;
};
var $c072c6204b87bce1$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $c072c6204b87bce1$var$ObjectProto;
    var names = $c072c6204b87bce1$var$gOPN(IS_OP ? $c072c6204b87bce1$var$OPSymbols : $8uJlv(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($4Gvaf($c072c6204b87bce1$var$AllSymbols, key = names[i++]) && (IS_OP ? $4Gvaf($c072c6204b87bce1$var$ObjectProto, key) : true)) result.push($c072c6204b87bce1$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$c072c6204b87bce1$var$USE_NATIVE) {
    $c072c6204b87bce1$var$$Symbol = function Symbol() {
        if (this instanceof $c072c6204b87bce1$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $7W2v1(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $c072c6204b87bce1$var$ObjectProto) $set.call($c072c6204b87bce1$var$OPSymbols, value);
            if ($4Gvaf(this, $c072c6204b87bce1$var$HIDDEN) && $4Gvaf(this[$c072c6204b87bce1$var$HIDDEN], tag)) this[$c072c6204b87bce1$var$HIDDEN][tag] = false;
            $c072c6204b87bce1$var$setSymbolDesc(this, tag, $krzP8(1, value));
        };
        if ($dar3x && $c072c6204b87bce1$var$setter) $c072c6204b87bce1$var$setSymbolDesc($c072c6204b87bce1$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $c072c6204b87bce1$var$wrap(tag);
    };
    $6sIZs($c072c6204b87bce1$var$$Symbol[$c072c6204b87bce1$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $N9PbJ.f = $c072c6204b87bce1$var$$getOwnPropertyDescriptor;
    $3v06f.f = $c072c6204b87bce1$var$$defineProperty;
    (parcelRequire("c5wou")).f = $9inKd.f = $c072c6204b87bce1$var$$getOwnPropertyNames;
    (parcelRequire("5DZkg")).f = $c072c6204b87bce1$var$$propertyIsEnumerable;
    $8FaN5.f = $c072c6204b87bce1$var$$getOwnPropertySymbols;
    if ($dar3x && !(parcelRequire("7XG4C"))) $6sIZs($c072c6204b87bce1$var$ObjectProto, 'propertyIsEnumerable', $c072c6204b87bce1$var$$propertyIsEnumerable, true);
    $3uKO9.f = function(name) {
        return $c072c6204b87bce1$var$wrap($8PUov(name));
    };
}
$aYB6i($aYB6i.G + $aYB6i.W + $aYB6i.F * !$c072c6204b87bce1$var$USE_NATIVE, {
    Symbol: $c072c6204b87bce1$var$$Symbol
});
for(var $c072c6204b87bce1$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $c072c6204b87bce1$var$j = 0; $c072c6204b87bce1$var$es6Symbols.length > $c072c6204b87bce1$var$j;)$8PUov($c072c6204b87bce1$var$es6Symbols[$c072c6204b87bce1$var$j++]);
for(var $c072c6204b87bce1$var$wellKnownSymbols = $aH1Ij($8PUov.store), $c072c6204b87bce1$var$k = 0; $c072c6204b87bce1$var$wellKnownSymbols.length > $c072c6204b87bce1$var$k;)$c7Nsa($c072c6204b87bce1$var$wellKnownSymbols[$c072c6204b87bce1$var$k++]);
$aYB6i($aYB6i.S + $aYB6i.F * !$c072c6204b87bce1$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $4Gvaf($c072c6204b87bce1$var$SymbolRegistry, key += '') ? $c072c6204b87bce1$var$SymbolRegistry[key] : $c072c6204b87bce1$var$SymbolRegistry[key] = $c072c6204b87bce1$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$c072c6204b87bce1$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $c072c6204b87bce1$var$SymbolRegistry)if ($c072c6204b87bce1$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $c072c6204b87bce1$var$setter = true;
    },
    useSimple: function() {
        $c072c6204b87bce1$var$setter = false;
    }
});
$aYB6i($aYB6i.S + $aYB6i.F * !$c072c6204b87bce1$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $c072c6204b87bce1$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $c072c6204b87bce1$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $c072c6204b87bce1$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $c072c6204b87bce1$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $c072c6204b87bce1$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $c072c6204b87bce1$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $c072c6204b87bce1$var$FAILS_ON_PRIMITIVES = $danph(function() {
    $8FaN5.f(1);
});
$aYB6i($aYB6i.S + $aYB6i.F * $c072c6204b87bce1$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $8FaN5.f($Bejaj(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$c072c6204b87bce1$var$$JSON && $aYB6i($aYB6i.S + $aYB6i.F * (!$c072c6204b87bce1$var$USE_NATIVE || $danph(function() {
    var S = $c072c6204b87bce1$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $c072c6204b87bce1$var$_stringify([
        S
    ]) != '[null]' || $c072c6204b87bce1$var$_stringify({
        a: S
    }) != '{}' || $c072c6204b87bce1$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$dYIGx(replacer) && it === undefined || $c072c6204b87bce1$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$7eAAc(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$c072c6204b87bce1$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $c072c6204b87bce1$var$_stringify.apply($c072c6204b87bce1$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$c072c6204b87bce1$var$$Symbol[$c072c6204b87bce1$var$PROTOTYPE][$c072c6204b87bce1$var$TO_PRIMITIVE] || (parcelRequire("9MeJw"))($c072c6204b87bce1$var$$Symbol[$c072c6204b87bce1$var$PROTOTYPE], $c072c6204b87bce1$var$TO_PRIMITIVE, $c072c6204b87bce1$var$$Symbol[$c072c6204b87bce1$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$8D74x($c072c6204b87bce1$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$8D74x(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$8D74x($gPLBa.JSON, 'JSON', true);

});
parcelRegister("giItu", function(module, exports) {

var $bde0d38b0936a4cf$var$META = (parcelRequire("7W2v1"))('meta');

var $dYIGx = parcelRequire("dYIGx");

var $4Gvaf = parcelRequire("4Gvaf");

var $3v06f = parcelRequire("3v06f");
var $bde0d38b0936a4cf$require$setDesc = $3v06f.f;
var $bde0d38b0936a4cf$var$id = 0;
var $bde0d38b0936a4cf$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $bde0d38b0936a4cf$var$FREEZE = !(parcelRequire("danph"))(function() {
    return $bde0d38b0936a4cf$var$isExtensible(Object.preventExtensions({}));
});
var $bde0d38b0936a4cf$var$setMeta = function(it) {
    $bde0d38b0936a4cf$require$setDesc(it, $bde0d38b0936a4cf$var$META, {
        value: {
            i: 'O' + ++$bde0d38b0936a4cf$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $bde0d38b0936a4cf$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$dYIGx(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$4Gvaf(it, $bde0d38b0936a4cf$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$bde0d38b0936a4cf$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $bde0d38b0936a4cf$var$setMeta(it);
    // return object ID
    }
    return it[$bde0d38b0936a4cf$var$META].i;
};
var $bde0d38b0936a4cf$var$getWeak = function(it, create) {
    if (!$4Gvaf(it, $bde0d38b0936a4cf$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$bde0d38b0936a4cf$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $bde0d38b0936a4cf$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$bde0d38b0936a4cf$var$META].w;
};
// add metadata on freeze-family methods calling
var $bde0d38b0936a4cf$var$onFreeze = function(it) {
    if ($bde0d38b0936a4cf$var$FREEZE && $bde0d38b0936a4cf$var$meta.NEED && $bde0d38b0936a4cf$var$isExtensible(it) && !$4Gvaf(it, $bde0d38b0936a4cf$var$META)) $bde0d38b0936a4cf$var$setMeta(it);
    return it;
};
var $bde0d38b0936a4cf$var$meta = module.exports = {
    KEY: $bde0d38b0936a4cf$var$META,
    NEED: false,
    fastKey: $bde0d38b0936a4cf$var$fastKey,
    getWeak: $bde0d38b0936a4cf$var$getWeak,
    onFreeze: $bde0d38b0936a4cf$var$onFreeze
};

});

parcelRegister("c7Nsa", function(module, exports) {

var $gPLBa = parcelRequire("gPLBa");

var $jPAur = parcelRequire("jPAur");

var $7XG4C = parcelRequire("7XG4C");

var $3uKO9 = parcelRequire("3uKO9");

var $3v06f = parcelRequire("3v06f");
var $8d3c7fdf0d41f8f3$require$defineProperty = $3v06f.f;
module.exports = function(name) {
    var $Symbol = $jPAur.Symbol || ($jPAur.Symbol = $7XG4C ? {} : $gPLBa.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $8d3c7fdf0d41f8f3$require$defineProperty($Symbol, name, {
        value: $3uKO9.f(name)
    });
};

});

parcelRegister("idBr3", function(module, exports) {
// all enumerable object keys, includes symbols

var $aH1Ij = parcelRequire("aH1Ij");

var $8FaN5 = parcelRequire("8FaN5");

var $5DZkg = parcelRequire("5DZkg");
module.exports = function(it) {
    var result = $aH1Ij(it);
    var getSymbols = $8FaN5.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $5DZkg.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("8FaN5", function(module, exports) {
$parcel$export(module.exports, "f", () => $64ea85debefde674$export$2d1720544b23b823, (v) => $64ea85debefde674$export$2d1720544b23b823 = v);
var $64ea85debefde674$export$2d1720544b23b823;
$64ea85debefde674$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("5DZkg", function(module, exports) {
$parcel$export(module.exports, "f", () => $41c02a52989e087b$export$2d1720544b23b823, (v) => $41c02a52989e087b$export$2d1720544b23b823 = v);
var $41c02a52989e087b$export$2d1720544b23b823;
$41c02a52989e087b$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("7eAAc", function(module, exports) {
// 7.2.2 IsArray(argument)

var $jVgQR = parcelRequire("jVgQR");
module.exports = Array.isArray || function isArray(arg) {
    return $jVgQR(arg) == 'Array';
};

});

parcelRegister("9inKd", function(module, exports) {
$parcel$export(module.exports, "f", () => $6c4836a7db6b5f94$export$2d1720544b23b823, (v) => $6c4836a7db6b5f94$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $6c4836a7db6b5f94$export$2d1720544b23b823;

var $8uJlv = parcelRequire("8uJlv");

var $c5wou = parcelRequire("c5wou");
var $6c4836a7db6b5f94$require$gOPN = $c5wou.f;
var $6c4836a7db6b5f94$var$toString = {}.toString;
var $6c4836a7db6b5f94$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $6c4836a7db6b5f94$var$getWindowNames = function(it) {
    try {
        return $6c4836a7db6b5f94$require$gOPN(it);
    } catch (e) {
        return $6c4836a7db6b5f94$var$windowNames.slice();
    }
};
$6c4836a7db6b5f94$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $6c4836a7db6b5f94$var$windowNames && $6c4836a7db6b5f94$var$toString.call(it) == '[object Window]' ? $6c4836a7db6b5f94$var$getWindowNames(it) : $6c4836a7db6b5f94$require$gOPN($8uJlv(it));
};

});
parcelRegister("c5wou", function(module, exports) {
$parcel$export(module.exports, "f", () => $8ccf1474e7a25d74$export$2d1720544b23b823, (v) => $8ccf1474e7a25d74$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $8ccf1474e7a25d74$export$2d1720544b23b823;

var $MqyLd = parcelRequire("MqyLd");

var $8ccf1474e7a25d74$var$hiddenKeys = (parcelRequire("gKgGP")).concat('length', 'prototype');
$8ccf1474e7a25d74$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $MqyLd(O, $8ccf1474e7a25d74$var$hiddenKeys);
};

});


parcelRegister("N9PbJ", function(module, exports) {
$parcel$export(module.exports, "f", () => $093c32aeb80767e4$export$2d1720544b23b823, (v) => $093c32aeb80767e4$export$2d1720544b23b823 = v);
var $093c32aeb80767e4$export$2d1720544b23b823;

var $5DZkg = parcelRequire("5DZkg");

var $krzP8 = parcelRequire("krzP8");

var $8uJlv = parcelRequire("8uJlv");

var $hlEid = parcelRequire("hlEid");

var $4Gvaf = parcelRequire("4Gvaf");

var $eI2mU = parcelRequire("eI2mU");
var $093c32aeb80767e4$var$gOPD = Object.getOwnPropertyDescriptor;

$093c32aeb80767e4$export$2d1720544b23b823 = (parcelRequire("dar3x")) ? $093c32aeb80767e4$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $8uJlv(O);
    P = $hlEid(P, true);
    if ($eI2mU) try {
        return $093c32aeb80767e4$var$gOPD(O, P);
    } catch (e) {}
    if ($4Gvaf(O, P)) return $krzP8(!$5DZkg.f.call(O, P), O[P]);
};

});


parcelRegister("1OZyJ", function(module, exports) {

});

parcelRegister("7HDK1", function(module, exports) {

(parcelRequire("c7Nsa"))('asyncIterator');

});

parcelRegister("egYGG", function(module, exports) {

(parcelRequire("c7Nsa"))('observable');

});





parcelRegister("7glmA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $549a995489796d7d$export$1e511d4a378977f5, (v) => $549a995489796d7d$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $549a995489796d7d$export$2e2bcd8739ae039, (v) => $549a995489796d7d$export$2e2bcd8739ae039 = v);
var $549a995489796d7d$export$1e511d4a378977f5;
var $549a995489796d7d$export$2e2bcd8739ae039;
"use strict";
$549a995489796d7d$export$1e511d4a378977f5 = true;

var $aNoj4 = parcelRequire("aNoj4");
var $549a995489796d7d$var$_setPrototypeOf2 = $549a995489796d7d$var$_interopRequireDefault($aNoj4);

var $1fEjo = parcelRequire("1fEjo");
var $549a995489796d7d$var$_create2 = $549a995489796d7d$var$_interopRequireDefault($1fEjo);

var $5dvzs = parcelRequire("5dvzs");
var $549a995489796d7d$var$_typeof3 = $549a995489796d7d$var$_interopRequireDefault($5dvzs);
function $549a995489796d7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$549a995489796d7d$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $549a995489796d7d$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $549a995489796d7d$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $549a995489796d7d$var$_setPrototypeOf2.default ? (0, $549a995489796d7d$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("aNoj4", function(module, exports) {

module.exports = {
    "default": (parcelRequire("lGORh")),
    __esModule: true
};

});
parcelRegister("lGORh", function(module, exports) {
parcelRequire("kfC1f");

module.exports = (parcelRequire("jPAur")).Object.setPrototypeOf;

});
parcelRegister("kfC1f", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $aYB6i = parcelRequire("aYB6i");

$aYB6i($aYB6i.S, 'Object', {
    setPrototypeOf: (parcelRequire("4Wh2t")).set
});

});
parcelRegister("4Wh2t", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $dYIGx = parcelRequire("dYIGx");

var $7bOu1 = parcelRequire("7bOu1");
var $3989cbcb7baebaac$var$check = function(O, proto) {
    $7bOu1(O);
    if (!$dYIGx(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("hda8t"))(Function.call, (parcelRequire("N9PbJ")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $3989cbcb7baebaac$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $3989cbcb7baebaac$var$check
};

});




parcelRegister("1fEjo", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gFWyB")),
    __esModule: true
};

});
parcelRegister("gFWyB", function(module, exports) {
parcelRequire("9gT9A");

var $jPAur = parcelRequire("jPAur");
var $c23de5e16f3efe62$require$$Object = $jPAur.Object;
module.exports = function create(P, D) {
    return $c23de5e16f3efe62$require$$Object.create(P, D);
};

});
parcelRegister("9gT9A", function(module, exports) {

var $aYB6i = parcelRequire("aYB6i");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$aYB6i($aYB6i.S, 'Object', {
    create: (parcelRequire("3ulAQ"))
});

});




parcelRegister("3TJLC", function(module, exports) {
$parcel$export(module.exports, "default", () => $985415257094a936$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $fTyy7 = parcelRequire("fTyy7");

var $fU3Er = parcelRequire("fU3Er");

var $al52R = parcelRequire("al52R");
const $985415257094a936$var$AnalyticsContext = (props)=>{
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this provider.
    const [isModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(()=>(0, $fTyy7.default) || (0, $dRkX9.fg)('analytics-next-use-legacy-context') === false || (0, $dRkX9.fg)('adminhub-analytics-next-use-modern-context') || (0, $dRkX9.fg)('bitbucket-analytics-next-use-modern-context'));
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $al52R.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fU3Er.default), props);
};
var $985415257094a936$export$2e2bcd8739ae039 = $985415257094a936$var$AnalyticsContext;

});
parcelRegister("fTyy7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0633ef8f7c8498a1$export$2e2bcd8739ae039);

var $3jCFs = parcelRequire("3jCFs");
var $0633ef8f7c8498a1$var$_process$env;
/// <reference types="node" />
const $0633ef8f7c8498a1$var$_default_1 = typeof $3jCFs !== 'undefined' && $3jCFs !== null && (($0633ef8f7c8498a1$var$_process$env = {}, $0633ef8f7c8498a1$var$_process$env === void 0) ? void 0 : $0633ef8f7c8498a1$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $0633ef8f7c8498a1$export$2e2bcd8739ae039 = $0633ef8f7c8498a1$var$_default_1;

});

parcelRegister("fU3Er", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d92bba6c8cc4a46$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $liKxv = parcelRequire("liKxv");
const $4d92bba6c8cc4a46$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
};
const $4d92bba6c8cc4a46$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $4d92bba6c8cc4a46$var$AnalyticsContext extends (0, $fc4bM.Component) {
    static #_ = this.contextTypes = $4d92bba6c8cc4a46$var$ContextTypes;
    static #_2 = this.childContextTypes = $4d92bba6c8cc4a46$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $4d92bba6c8cc4a46$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $4d92bba6c8cc4a46$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $liKxv.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $4d92bba6c8cc4a46$export$2e2bcd8739ae039 = $4d92bba6c8cc4a46$var$AnalyticsContext;

});
parcelRegister("dso8W", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9cc09e3a8bdcf5c9$var$ReactIs, $9cc09e3a8bdcf5c9$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dTvPz"))();

});
parcelRegister("dTvPz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8pXFM = parcelRequire("8pXFM");
function $a1d91a529c8b2010$var$emptyFunction() {}
function $a1d91a529c8b2010$var$emptyFunctionWithReset() {}
$a1d91a529c8b2010$var$emptyFunctionWithReset.resetWarningCache = $a1d91a529c8b2010$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8pXFM) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a1d91a529c8b2010$var$emptyFunctionWithReset,
        resetWarningCache: $a1d91a529c8b2010$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8pXFM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $620ef24caa9b55a3$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $620ef24caa9b55a3$var$ReactPropTypesSecret;

});



parcelRegister("liKxv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f81f613136571048$export$2e2bcd8739ae039);

var $5yGXk = parcelRequire("5yGXk");
var $f81f613136571048$export$2e2bcd8739ae039 = (0, $5yGXk.default);

});
parcelRegister("5yGXk", function(module, exports) {
$parcel$export(module.exports, "default", () => $40c172e46705e627$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
var $40c172e46705e627$var$AnalyticsNextContext = (0, $fc4bM.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $40c172e46705e627$export$2e2bcd8739ae039 = $40c172e46705e627$var$AnalyticsNextContext;

});



parcelRegister("al52R", function(module, exports) {
$parcel$export(module.exports, "default", () => $baecd46b7911d453$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $liKxv = parcelRequire("liKxv");

var $cpVgk = parcelRequire("cpVgk");

var $7nxW1 = parcelRequire("7nxW1");
const $baecd46b7911d453$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $7nxW1.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $cpVgk.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $fc4bM.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $fc4bM.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $liKxv.default).Provider, {
        value: value
    }, children);
};
var $baecd46b7911d453$export$2e2bcd8739ae039 = $baecd46b7911d453$var$AnalyticsContext;

});
parcelRegister("cpVgk", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $5aa398cc7244a950$export$d1f587f82ad51c4);

var $fc4bM = parcelRequire("fc4bM");

var $liKxv = parcelRequire("liKxv");
const $5aa398cc7244a950$export$d1f587f82ad51c4 = ()=>{
    return (0, $fc4bM.useContext)((0, $liKxv.default));
};

});

parcelRegister("7nxW1", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $1dfdba4e23fba06f$export$1d27a74659855e44);

var $fc4bM = parcelRequire("fc4bM");
const $1dfdba4e23fba06f$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $fc4bM.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("5YuxV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i01hk = parcelRequire("i01hk");
var $459a403404c40fc1$var$_extends3 = $459a403404c40fc1$var$_interopRequireDefault($i01hk);

var $2M9gc = parcelRequire("2M9gc");
var $459a403404c40fc1$var$_objectWithoutProperties3 = $459a403404c40fc1$var$_interopRequireDefault($2M9gc);

var $bomqv = parcelRequire("bomqv");
var $459a403404c40fc1$var$_isUndefined2 = $459a403404c40fc1$var$_interopRequireDefault($bomqv);

var $gK90j = parcelRequire("gK90j");
var $459a403404c40fc1$var$_omitBy2 = $459a403404c40fc1$var$_interopRequireDefault($gK90j);

var $41s5B = parcelRequire("41s5B");
var $459a403404c40fc1$var$_mapDataPayloadToContextPayload2 = $459a403404c40fc1$var$_interopRequireDefault($41s5B);
function $459a403404c40fc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(props) {
    var sourceName = props.sourceName, sourceType = props.sourceType, componentName = props.componentName, other = (0, $459a403404c40fc1$var$_objectWithoutProperties3.default)(props, [
        'sourceName',
        'sourceType',
        'componentName'
    ]);
    var validProps = (0, $459a403404c40fc1$var$_mapDataPayloadToContextPayload2.default)(other);
    var source = sourceName && sourceType ? '' + sourceName + sourceType : undefined;
    return (0, $459a403404c40fc1$var$_omitBy2.default)((0, $459a403404c40fc1$var$_extends3.default)({
        componentName: componentName,
        source: source
    }, validProps), $459a403404c40fc1$var$_isUndefined2.default);
};

});
parcelRegister("i01hk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $d1a937f0db51e0e1$export$1e511d4a378977f5, (v) => $d1a937f0db51e0e1$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d1a937f0db51e0e1$export$2e2bcd8739ae039, (v) => $d1a937f0db51e0e1$export$2e2bcd8739ae039 = v);
var $d1a937f0db51e0e1$export$1e511d4a378977f5;
var $d1a937f0db51e0e1$export$2e2bcd8739ae039;
"use strict";
$d1a937f0db51e0e1$export$1e511d4a378977f5 = true;

var $lQatL = parcelRequire("lQatL");
var $d1a937f0db51e0e1$var$_assign2 = $d1a937f0db51e0e1$var$_interopRequireDefault($lQatL);
function $d1a937f0db51e0e1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d1a937f0db51e0e1$export$2e2bcd8739ae039 = $d1a937f0db51e0e1$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("lQatL", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2dEeO")),
    __esModule: true
};

});
parcelRegister("2dEeO", function(module, exports) {
parcelRequire("cAXet");

module.exports = (parcelRequire("jPAur")).Object.assign;

});
parcelRegister("cAXet", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $aYB6i = parcelRequire("aYB6i");

$aYB6i($aYB6i.S + $aYB6i.F, 'Object', {
    assign: (parcelRequire("dHQjT"))
});

});
parcelRegister("dHQjT", function(module, exports) {
'use strict';

var $dar3x = parcelRequire("dar3x");

var $aH1Ij = parcelRequire("aH1Ij");

var $8FaN5 = parcelRequire("8FaN5");

var $5DZkg = parcelRequire("5DZkg");

var $Bejaj = parcelRequire("Bejaj");

var $WEjGg = parcelRequire("WEjGg");
var $9fa7e02b08da2c97$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$9fa7e02b08da2c97$var$$assign || (parcelRequire("danph"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $9fa7e02b08da2c97$var$$assign({}, A)[S] != 7 || Object.keys($9fa7e02b08da2c97$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $Bejaj(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $8FaN5.f;
    var isEnum = $5DZkg.f;
    while(aLen > index){
        var S = $WEjGg(arguments[index++]);
        var keys = getSymbols ? $aH1Ij(S).concat(getSymbols(S)) : $aH1Ij(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$dar3x || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $9fa7e02b08da2c97$var$$assign;

});





parcelRegister("2M9gc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $20573f5ec0092e7c$export$1e511d4a378977f5, (v) => $20573f5ec0092e7c$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $20573f5ec0092e7c$export$2e2bcd8739ae039, (v) => $20573f5ec0092e7c$export$2e2bcd8739ae039 = v);
var $20573f5ec0092e7c$export$1e511d4a378977f5;
var $20573f5ec0092e7c$export$2e2bcd8739ae039;
"use strict";
$20573f5ec0092e7c$export$1e511d4a378977f5 = true;
$20573f5ec0092e7c$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("41s5B", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(payload) {
    var tags = payload.tags, containerId = payload.containerId, containerType = payload.containerType, objectId = payload.objectId, objectType = payload.objectType, attributes = payload.attributes;
    return {
        tags: tags,
        containerId: containerId,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    };
};

});



parcelRegister("47KZT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $akW80 = parcelRequire("akW80");
var $300c458e6ccd39f5$var$_getPrototypeOf2 = $300c458e6ccd39f5$var$_interopRequireDefault($akW80);

var $e1MRE = parcelRequire("e1MRE");
var $300c458e6ccd39f5$var$_classCallCheck3 = $300c458e6ccd39f5$var$_interopRequireDefault($e1MRE);

var $27SSl = parcelRequire("27SSl");
var $300c458e6ccd39f5$var$_createClass3 = $300c458e6ccd39f5$var$_interopRequireDefault($27SSl);

var $iMuMW = parcelRequire("iMuMW");
var $300c458e6ccd39f5$var$_possibleConstructorReturn3 = $300c458e6ccd39f5$var$_interopRequireDefault($iMuMW);

var $7glmA = parcelRequire("7glmA");
var $300c458e6ccd39f5$var$_inherits3 = $300c458e6ccd39f5$var$_interopRequireDefault($7glmA);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");
function $300c458e6ccd39f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $300c458e6ccd39f5$var$MountTracker = function(_Component) {
    (0, $300c458e6ccd39f5$var$_inherits3.default)(MountTracker, _Component);
    function MountTracker() {
        (0, $300c458e6ccd39f5$var$_classCallCheck3.default)(this, MountTracker);
        return (0, $300c458e6ccd39f5$var$_possibleConstructorReturn3.default)(this, (MountTracker.__proto__ || (0, $300c458e6ccd39f5$var$_getPrototypeOf2.default)(MountTracker)).apply(this, arguments));
    }
    (0, $300c458e6ccd39f5$var$_createClass3.default)(MountTracker, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                // $FlowFixMe
                this.props.onMount();
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return MountTracker;
}($fc4bM.Component);
module.exports.default = (0, $azARG.default)({
    onMount: {
        action: 'viewed'
    }
})($300c458e6ccd39f5$var$MountTracker);

});
parcelRegister("azARG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec7061f183e1fdd1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $awiS3 = parcelRequire("awiS3");
const $ec7061f183e1fdd1$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $awiS3.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $ec7061f183e1fdd1$export$2e2bcd8739ae039 = $ec7061f183e1fdd1$var$withAnalyticsEvents;

});
parcelRegister("jEubQ", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $dee8373fe2cf371e$export$5bf35293e545f20c);

var $81AKN = parcelRequire("81AKN");

var $ZyrkS = parcelRequire("ZyrkS");

var $cpVgk = parcelRequire("cpVgk");
function $dee8373fe2cf371e$export$5bf35293e545f20c() {
    const analyticsContext = (0, $cpVgk.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $81AKN.useCallbackOne)((payload)=>{
        return new (0, $ZyrkS.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("81AKN", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $5d7aed3ca40df405$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $5d7aed3ca40df405$export$33752cf3ee811995);

var $fc4bM = parcelRequire("fc4bM");
function $5d7aed3ca40df405$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $5d7aed3ca40df405$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $fc4bM.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $fc4bM.useRef)(true);
    var committed = (0, $fc4bM.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $5d7aed3ca40df405$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $fc4bM.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $5d7aed3ca40df405$export$33752cf3ee811995(callback, inputs) {
    return $5d7aed3ca40df405$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $5d7aed3ca40df405$export$1538c33de8887b59 = $5d7aed3ca40df405$export$b6feb8998cd9b342;
var $5d7aed3ca40df405$export$35808ee640e87ca7 = $5d7aed3ca40df405$export$33752cf3ee811995;

});


parcelRegister("awiS3", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $eb81205707e5c21f$export$9ebb5a84d17e5d18);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");
function $eb81205707e5c21f$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const handlerCache = (0, $fc4bM.useRef)({});
    const patchedProps = (0, $fc4bM.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("7ZMzf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $akW80 = parcelRequire("akW80");
var $5d23e7685bf99746$var$_getPrototypeOf2 = $5d23e7685bf99746$var$_interopRequireDefault($akW80);

var $e1MRE = parcelRequire("e1MRE");
var $5d23e7685bf99746$var$_classCallCheck3 = $5d23e7685bf99746$var$_interopRequireDefault($e1MRE);

var $27SSl = parcelRequire("27SSl");
var $5d23e7685bf99746$var$_createClass3 = $5d23e7685bf99746$var$_interopRequireDefault($27SSl);

var $iMuMW = parcelRequire("iMuMW");
var $5d23e7685bf99746$var$_possibleConstructorReturn3 = $5d23e7685bf99746$var$_interopRequireDefault($iMuMW);

var $7glmA = parcelRequire("7glmA");
var $5d23e7685bf99746$var$_inherits3 = $5d23e7685bf99746$var$_interopRequireDefault($7glmA);

var $fc4bM = parcelRequire("fc4bM");
var $5d23e7685bf99746$var$_react2 = $5d23e7685bf99746$var$_interopRequireDefault($fc4bM);

var $a65oG = parcelRequire("a65oG");
var $5d23e7685bf99746$var$_analyticsContext2 = $5d23e7685bf99746$var$_interopRequireDefault($a65oG);
function $5d23e7685bf99746$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Props) {
    return function(WrappedComponent) {
        return function(_Component) {
            (0, $5d23e7685bf99746$var$_inherits3.default)(WithAnalyticsContext, _Component);
            function WithAnalyticsContext() {
                (0, $5d23e7685bf99746$var$_classCallCheck3.default)(this, WithAnalyticsContext);
                return (0, $5d23e7685bf99746$var$_possibleConstructorReturn3.default)(this, (WithAnalyticsContext.__proto__ || (0, $5d23e7685bf99746$var$_getPrototypeOf2.default)(WithAnalyticsContext)).apply(this, arguments));
            }
            (0, $5d23e7685bf99746$var$_createClass3.default)(WithAnalyticsContext, [
                {
                    key: 'render',
                    value: function render() {
                        return $5d23e7685bf99746$var$_react2.default.createElement($5d23e7685bf99746$var$_analyticsContext2.default, Props, $5d23e7685bf99746$var$_react2.default.createElement(WrappedComponent, this.props));
                    }
                }
            ]);
            return WithAnalyticsContext;
        }($fc4bM.Component);
    };
};

});

parcelRegister("8Yslx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cQsBQ = parcelRequire("cQsBQ");

var $lCjtH = parcelRequire("lCjtH");

var $gZ6il = parcelRequire("gZ6il");

var $hLYKi = parcelRequire("hLYKi");

var $k4QE4 = parcelRequire("k4QE4");
// data.type necessary cause of flow
module.exports.default = function(data) {
    if (!data) throw new Error('No event data passed in');
    if (data.client && data.type !== $cQsBQ.OPERATIONAL_EVENT_TYPE) throw new Error('Sending events via client is not supported in non Operational events');
    if (data.type === $cQsBQ.UI_EVENT_TYPE) (0, $k4QE4.fireAnalyticsUiEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $cQsBQ.TRACK_EVENT_TYPE) (0, $hLYKi.fireAnalyticsTrackEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $cQsBQ.OPERATIONAL_EVENT_TYPE) (0, $lCjtH.fireAnalyticsOperationalEvent)(data);
    else if (data.type === $cQsBQ.SCREEN_EVENT_TYPE) (0, $gZ6il.fireAnalyticsScreenEvent)(data.analyticsEvent, data.payload);
    else throw new Error('Event type not supported: ' + data.type);
};

});
parcelRegister("lCjtH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationEventWithEvent = undefined;

var $i01hk = parcelRequire("i01hk");
var $fbcc4183726ff09e$var$_extends3 = $fbcc4183726ff09e$var$_interopRequireDefault($i01hk);

var $bomqv = parcelRequire("bomqv");
var $fbcc4183726ff09e$var$_isUndefined2 = $fbcc4183726ff09e$var$_interopRequireDefault($bomqv);

var $akVVk = parcelRequire("akVVk");
var $fbcc4183726ff09e$var$_pickBy2 = $fbcc4183726ff09e$var$_interopRequireDefault($akVVk);

var $cQsBQ = parcelRequire("cQsBQ");

var $41s5B = parcelRequire("41s5B");
var $fbcc4183726ff09e$var$_mapDataPayloadToContextPayload2 = $fbcc4183726ff09e$var$_interopRequireDefault($41s5B);
function $fbcc4183726ff09e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fbcc4183726ff09e$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $fbcc4183726ff09e$var$_isUndefined2.default)(a);
};
var $fbcc4183726ff09e$var$mapOperationalPayload = function mapOperationalPayload(payload) {
    var context = (0, $fbcc4183726ff09e$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $fbcc4183726ff09e$var$_pickBy2.default)((0, $fbcc4183726ff09e$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $fbcc4183726ff09e$var$isNotUndefined);
};
var $fbcc4183726ff09e$var$mapOperationalPayloadToClient = function mapOperationalPayloadToClient(payload) {
    var context = (0, $fbcc4183726ff09e$var$_mapDataPayloadToContextPayload2.default)(payload);
    var sourceName = payload.sourceName, sourceType = payload.sourceType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    if (!action || !actionSubject || !sourceName || !sourceType) return false;
    var source = sourceName + sourceType;
    return (0, $fbcc4183726ff09e$var$_pickBy2.default)((0, $fbcc4183726ff09e$var$_extends3.default)({}, context, {
        source: source,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $fbcc4183726ff09e$var$isNotUndefined);
};
var $fbcc4183726ff09e$var$fireAnalyticsOperationEventWithEvent = module.exports.fireAnalyticsOperationEventWithEvent = function fireAnalyticsOperationEventWithEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $fbcc4183726ff09e$var$_extends3.default)({}, $fbcc4183726ff09e$var$mapOperationalPayload(payload), {
        analyticsType: $cQsBQ.OPERATIONAL_EVENT_TYPE
    })).fire();
};
var $fbcc4183726ff09e$var$fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationalEventWithClient = function fireAnalyticsOperationalEventWithClient(client, payload) {
    if (!client.sendOperationalEvent) throw new Error('No Operational event fired, sendOperationEvent doesnt exist');
    if (!(typeof client.sendOperationalEvent === 'function')) throw new Error('No Operational event fired, sendOperationEvent is not a function');
    var mappedPayload = $fbcc4183726ff09e$var$mapOperationalPayloadToClient(payload);
    if (!mappedPayload) throw new Error('No Operational event fired, missing payload attributes. Operational events require an action, actionSubject, sourceName and sourceType');
    return client.sendOperationalEvent(mappedPayload);
};
var $fbcc4183726ff09e$var$fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEvent = function fireAnalyticsOperationalEvent(data) {
    if (data.client) return $fbcc4183726ff09e$var$fireAnalyticsOperationalEventWithClient(data.client, data.payload);
    return $fbcc4183726ff09e$var$fireAnalyticsOperationEventWithEvent(data.analyticsEvent, data.payload);
};

});

parcelRegister("gZ6il", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsScreenEvent = undefined;

var $i01hk = parcelRequire("i01hk");
var $c5d739db08f28543$var$_extends3 = $c5d739db08f28543$var$_interopRequireDefault($i01hk);

var $bomqv = parcelRequire("bomqv");
var $c5d739db08f28543$var$_isUndefined2 = $c5d739db08f28543$var$_interopRequireDefault($bomqv);

var $akVVk = parcelRequire("akVVk");
var $c5d739db08f28543$var$_pickBy2 = $c5d739db08f28543$var$_interopRequireDefault($akVVk);

var $cQsBQ = parcelRequire("cQsBQ");
function $c5d739db08f28543$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c5d739db08f28543$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $c5d739db08f28543$var$_isUndefined2.default)(a);
};
var $c5d739db08f28543$var$mapPayload = function mapPayload(payload) {
    return (0, $c5d739db08f28543$var$_pickBy2.default)((0, $c5d739db08f28543$var$_extends3.default)({}, payload, payload.attributes, {
        attributes: undefined
    }), $c5d739db08f28543$var$isNotUndefined);
};
var $c5d739db08f28543$var$fireAnalyticsScreenEvent = module.exports.fireAnalyticsScreenEvent = function fireAnalyticsScreenEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $c5d739db08f28543$var$_extends3.default)({}, $c5d739db08f28543$var$mapPayload(payload || {}), {
        analyticsType: $cQsBQ.SCREEN_EVENT_TYPE
    })).fire();
};

});

parcelRegister("hLYKi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsTrackEvent = undefined;

var $i01hk = parcelRequire("i01hk");
var $cf05f24f1d55dade$var$_extends3 = $cf05f24f1d55dade$var$_interopRequireDefault($i01hk);

var $bomqv = parcelRequire("bomqv");
var $cf05f24f1d55dade$var$_isUndefined2 = $cf05f24f1d55dade$var$_interopRequireDefault($bomqv);

var $akVVk = parcelRequire("akVVk");
var $cf05f24f1d55dade$var$_pickBy2 = $cf05f24f1d55dade$var$_interopRequireDefault($akVVk);

var $cQsBQ = parcelRequire("cQsBQ");

var $41s5B = parcelRequire("41s5B");
var $cf05f24f1d55dade$var$_mapDataPayloadToContextPayload2 = $cf05f24f1d55dade$var$_interopRequireDefault($41s5B);
function $cf05f24f1d55dade$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cf05f24f1d55dade$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $cf05f24f1d55dade$var$_isUndefined2.default)(a);
};
var $cf05f24f1d55dade$var$mapPayload = function mapPayload(payload) {
    var context = (0, $cf05f24f1d55dade$var$_mapDataPayloadToContextPayload2.default)(payload);
    var action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    return (0, $cf05f24f1d55dade$var$_pickBy2.default)((0, $cf05f24f1d55dade$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $cf05f24f1d55dade$var$isNotUndefined);
};
var $cf05f24f1d55dade$var$fireAnalyticsTrackEvent = module.exports.fireAnalyticsTrackEvent = function fireAnalyticsTrackEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $cf05f24f1d55dade$var$_extends3.default)({}, $cf05f24f1d55dade$var$mapPayload(payload), {
        analyticsType: $cQsBQ.TRACK_EVENT_TYPE
    })).fire();
};

});

parcelRegister("k4QE4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsUiEvent = undefined;

var $i01hk = parcelRequire("i01hk");
var $e9dd049c3f57a602$var$_extends3 = $e9dd049c3f57a602$var$_interopRequireDefault($i01hk);

var $bomqv = parcelRequire("bomqv");
var $e9dd049c3f57a602$var$_isUndefined2 = $e9dd049c3f57a602$var$_interopRequireDefault($bomqv);

var $akVVk = parcelRequire("akVVk");
var $e9dd049c3f57a602$var$_pickBy2 = $e9dd049c3f57a602$var$_interopRequireDefault($akVVk);

var $cQsBQ = parcelRequire("cQsBQ");

var $41s5B = parcelRequire("41s5B");
var $e9dd049c3f57a602$var$_mapDataPayloadToContextPayload2 = $e9dd049c3f57a602$var$_interopRequireDefault($41s5B);
function $e9dd049c3f57a602$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e9dd049c3f57a602$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $e9dd049c3f57a602$var$_isUndefined2.default)(a);
};
/**
 * Analytics web react 2.0
 */ var $e9dd049c3f57a602$var$mapUiPayload = function mapUiPayload(payload) {
    var context = (0, $e9dd049c3f57a602$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $e9dd049c3f57a602$var$_pickBy2.default)((0, $e9dd049c3f57a602$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $e9dd049c3f57a602$var$isNotUndefined);
};
var $e9dd049c3f57a602$var$fireAnalyticsUiEvent = module.exports.fireAnalyticsUiEvent = function fireAnalyticsUiEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $e9dd049c3f57a602$var$_extends3.default)({}, $e9dd049c3f57a602$var$mapUiPayload(payload), {
        analyticsType: $cQsBQ.UI_EVENT_TYPE
    })).fire();
};

});


parcelRegister("cB1Tq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i01hk = parcelRequire("i01hk");
var $92ba68a0a746a67d$var$_extends3 = $92ba68a0a746a67d$var$_interopRequireDefault($i01hk);

var $bomqv = parcelRequire("bomqv");
var $92ba68a0a746a67d$var$_isUndefined2 = $92ba68a0a746a67d$var$_interopRequireDefault($bomqv);

var $1VqtZ = parcelRequire("1VqtZ");
var $92ba68a0a746a67d$var$_last2 = $92ba68a0a746a67d$var$_interopRequireDefault($1VqtZ);

var $gK90j = parcelRequire("gK90j");
var $92ba68a0a746a67d$var$_omitBy2 = $92ba68a0a746a67d$var$_interopRequireDefault($gK90j);

var $cQsBQ = parcelRequire("cQsBQ");

var $l3JJZ = parcelRequire("l3JJZ");
function $92ba68a0a746a67d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $92ba68a0a746a67d$var$getActionSubjectForEventType = function getActionSubjectForEventType(event, analyticsType) {
    if (analyticsType === $cQsBQ.TRACK_EVENT_TYPE) return (0, $l3JJZ.getActionSubject)(event);
    return (0, $92ba68a0a746a67d$var$_last2.default)((0, $l3JJZ.getComponents)(event));
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * AtlasKit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ module.exports.default = function(event) {
    var sources = (0, $l3JJZ.getSources)(event);
    var analyticsType = (0, $l3JJZ.getAnalyticsType)(event);
    var actionSubject = $92ba68a0a746a67d$var$getActionSubjectForEventType(event, analyticsType);
    var source = (0, $92ba68a0a746a67d$var$_last2.default)(sources);
    var action = (0, $l3JJZ.getAction)(event);
    var attributes = (0, $92ba68a0a746a67d$var$_extends3.default)({}, (0, $l3JJZ.getAttributes)(event), {
        namespaces: sources.join('.')
    });
    if (action === $cQsBQ.PAGE_EVENT_ACTION || analyticsType === $cQsBQ.SCREEN_EVENT_TYPE) return {
        type: $cQsBQ.SCREEN_EVENT_TYPE,
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case $cQsBQ.UI_EVENT_TYPE:
        case $cQsBQ.TRACK_EVENT_TYPE:
        case $cQsBQ.OPERATIONAL_EVENT_TYPE:
            var actionSubjectId = (0, $l3JJZ.getActionSubjectId)(event);
            var containerId = (0, $92ba68a0a746a67d$var$_last2.default)((0, $l3JJZ.getContainerIds)(event));
            var containerType = (0, $92ba68a0a746a67d$var$_last2.default)((0, $l3JJZ.getContainerTypes)(event));
            var objectId = (0, $92ba68a0a746a67d$var$_last2.default)((0, $l3JJZ.getObjectIds)(event));
            var objectType = (0, $92ba68a0a746a67d$var$_last2.default)((0, $l3JJZ.getObjectTypes)(event));
            var tags = (0, $l3JJZ.getTags)(event);
            return {
                type: analyticsType,
                payload: (0, $92ba68a0a746a67d$var$_omitBy2.default)({
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: source,
                    tags: tags,
                    containerType: containerType,
                    containerId: containerId,
                    objectType: objectType,
                    objectId: objectId,
                    attributes: attributes
                }, $92ba68a0a746a67d$var$_isUndefined2.default)
            };
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("l3JJZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAction = module.exports.getAnalyticsType = module.exports.getActionSubjectId = module.exports.getObjectIds = module.exports.getObjectTypes = module.exports.getContainerIds = module.exports.getContainerTypes = module.exports.getTags = module.exports.getAttributes = module.exports.getSources = module.exports.getActionSubject = module.exports.getComponents = undefined;

var $2M9gc = parcelRequire("2M9gc");
var $f54d5befa077a2a4$var$_objectWithoutProperties3 = $f54d5befa077a2a4$var$_interopRequireDefault($2M9gc);

var $eVfhL = parcelRequire("eVfhL");
var $f54d5befa077a2a4$var$_merge2 = $f54d5befa077a2a4$var$_interopRequireDefault($eVfhL);

var $l8G72 = parcelRequire("l8G72");
var $f54d5befa077a2a4$var$_uniq2 = $f54d5befa077a2a4$var$_interopRequireDefault($l8G72);
function $f54d5befa077a2a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f54d5befa077a2a4$var$extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $f54d5befa077a2a4$var$extractFromEventPayload = function extractFromEventPayload(propertyName, event) {
    return event.payload[propertyName];
};
var $f54d5befa077a2a4$var$extractFromPayloadOrContext = function extractFromPayloadOrContext(propertyName, event) {
    var payloadProp = $f54d5befa077a2a4$var$extractFromEventPayload(propertyName, event);
    var contextProps = $f54d5befa077a2a4$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
var $f54d5befa077a2a4$var$extractPayloadAttributes = function extractPayloadAttributes(event) {
    var _event$payload = event.payload, tags = _event$payload.tags, actionSubjectId = _event$payload.actionSubjectId, containerType = _event$payload.containerType, containerId = _event$payload.containerId, objectType = _event$payload.objectType, objectId = _event$payload.objectId, analyticsType = _event$payload.analyticsType, name = _event$payload.name, action = _event$payload.action, actionSubject = _event$payload.actionSubject, attributes = (0, $f54d5befa077a2a4$var$_objectWithoutProperties3.default)(_event$payload, [
        'tags',
        'actionSubjectId',
        'containerType',
        'containerId',
        'objectType',
        'objectId',
        'analyticsType',
        'name',
        'action',
        'actionSubject'
    ]);
    return attributes;
};
var $f54d5befa077a2a4$var$getComponents = module.exports.getComponents = function getComponents(event) {
    return $f54d5befa077a2a4$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
};
var $f54d5befa077a2a4$var$getActionSubject = module.exports.getActionSubject = function getActionSubject(event) {
    return $f54d5befa077a2a4$var$extractFromEventPayload('actionSubject', event);
};
var $f54d5befa077a2a4$var$getSources = module.exports.getSources = function getSources(event) {
    return $f54d5befa077a2a4$var$extractFromEventContext([
        'source'
    ], event);
};
var $f54d5befa077a2a4$var$getAttributes = module.exports.getAttributes = function getAttributes(event) {
    return (0, $f54d5befa077a2a4$var$_merge2.default)($f54d5befa077a2a4$var$extractFromEventContext([
        'attributes'
    ], event).reduce(function(result, extraAttributes) {
        return (0, $f54d5befa077a2a4$var$_merge2.default)(result, extraAttributes);
    }, {}), $f54d5befa077a2a4$var$extractPayloadAttributes(event));
};
var $f54d5befa077a2a4$var$getTags = module.exports.getTags = function getTags(event) {
    var tags = (0, $f54d5befa077a2a4$var$_uniq2.default)($f54d5befa077a2a4$var$extractFromEventContext([
        'tags'
    ], event).reduce(function(result, extraTags) {
        return result.concat(extraTags);
    }, []).concat($f54d5befa077a2a4$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
var $f54d5befa077a2a4$var$getContainerTypes = module.exports.getContainerTypes = function getContainerTypes(event) {
    return $f54d5befa077a2a4$var$extractFromPayloadOrContext('containerType', event);
};
var $f54d5befa077a2a4$var$getContainerIds = module.exports.getContainerIds = function getContainerIds(event) {
    return $f54d5befa077a2a4$var$extractFromPayloadOrContext('containerId', event);
};
var $f54d5befa077a2a4$var$getObjectTypes = module.exports.getObjectTypes = function getObjectTypes(event) {
    return $f54d5befa077a2a4$var$extractFromPayloadOrContext('objectType', event);
};
var $f54d5befa077a2a4$var$getObjectIds = module.exports.getObjectIds = function getObjectIds(event) {
    return $f54d5befa077a2a4$var$extractFromPayloadOrContext('objectId', event);
};
// singluar extractors
var $f54d5befa077a2a4$var$getActionSubjectId = module.exports.getActionSubjectId = function getActionSubjectId(event) {
    return $f54d5befa077a2a4$var$extractFromEventPayload('actionSubjectId', event);
};
var $f54d5befa077a2a4$var$getAnalyticsType = module.exports.getAnalyticsType = function getAnalyticsType(event) {
    return $f54d5befa077a2a4$var$extractFromEventPayload('analyticsType', event);
};
var $f54d5befa077a2a4$var$getAction = module.exports.getAction = function getAction(event) {
    return $f54d5befa077a2a4$var$extractFromEventPayload('action', event);
};

});



parcelRegister("cf3fd", function(module, exports) {
$parcel$export(module.exports, "isAdvancedHelpCenter", () => $1583353523e4399f$export$a8032b4abe96a350);
$parcel$export(module.exports, "isUnifiedHelpHelpCenter", () => $1583353523e4399f$export$35fba107189c9761);
$parcel$export(module.exports, "isFlexiHCEnabledInDefaultHC", () => $1583353523e4399f$export$64db2d25a762d602);
$parcel$export(module.exports, "isDefaultHelpCenter", () => $1583353523e4399f$export$6770869865ec8ff4);
$parcel$export(module.exports, "isKoshEnabledForDefaultHelpCenter", () => $1583353523e4399f$export$f8bf208a2ec06357);
$parcel$export(module.exports, "isHelpCentersManagement", () => $1583353523e4399f$export$f20af57447c92bed);
$parcel$export(module.exports, "isCSMHelpCenter", () => $1583353523e4399f$export$3eacdddcf63bcdf9);
$parcel$export(module.exports, "getIsHelpHub", () => $1583353523e4399f$export$b4319ea987d17576);
$parcel$export(module.exports, "isJcsOnlyRestrictedRoute", () => $1583353523e4399f$export$ab40e3484f545b4f);
$parcel$export(module.exports, "getSlugForAdvancedHCFromArticleView", () => $1583353523e4399f$export$6287fcdbdaf12366);
$parcel$export(module.exports, "getSlugForHelpCenter", () => $1583353523e4399f$export$1487e10d6956fe03);

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");

var $diqlM = parcelRequire("diqlM");

var $7lN8e = parcelRequire("7lN8e");
const $1583353523e4399f$export$a8032b4abe96a350 = ()=>{
    return (0, $diqlM.getRelativeBasePath)().startsWith('/helpcenter') && !$1583353523e4399f$export$35fba107189c9761();
};
const $1583353523e4399f$export$64db2d25a762d602 = ()=>{
    return $1583353523e4399f$export$6770869865ec8ff4();
};
const $1583353523e4399f$export$6770869865ec8ff4 = ()=>{
    return (0, $diqlM.getRelativeBasePath)().startsWith('/servicedesk/customer');
};
const $1583353523e4399f$export$f8bf208a2ec06357 = ()=>{
    return !$1583353523e4399f$export$6770869865ec8ff4();
};
const $1583353523e4399f$export$35fba107189c9761 = ()=>{
    return (0, $diqlM.getRelativeBasePath)() === (0, $9mazR.UNIFIED_HELP_CENTER_BASE_PATH);
};
const $1583353523e4399f$export$f20af57447c92bed = ()=>{
    return (0, $diqlM.getRelativeBasePath)() === (0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH);
};
const $1583353523e4399f$export$3eacdddcf63bcdf9 = (helpCenterType)=>{
    return helpCenterType === 'CUSTOMER_SERVICE';
};
const $1583353523e4399f$export$b4319ea987d17576 = ()=>{
    return (0, $7lN8e.getEnv)().helpCenterType === 'HELP_HUB';
};
const $1583353523e4399f$export$ab40e3484f545b4f = (customerAccountAvailability)=>{
    return $1583353523e4399f$export$6770869865ec8ff4() && customerAccountAvailability === 'JCS_ONLY' && (0, $hN5YJ.isCsmAccessControlSplitEnabled)();
};
const $1583353523e4399f$export$6287fcdbdaf12366 = (url)=>{
    const pattern = $1583353523e4399f$export$3eacdddcf63bcdf9((0, $7lN8e.getEnv)().helpCenterType) ? /https:\/\/.*?\/helpcenter\/([^/]+)\// : /https:\/\/.*?\/helpcenter\/([^/]+)\/portal\//;
    const match = url.match(pattern);
    return match && match[1] ? match[1] : undefined;
};
const $1583353523e4399f$export$1487e10d6956fe03 = ()=>{
    const pattern = /\/helpcenter\/([^/?]*)/;
    const match = (0, $diqlM.getRelativeBasePath)().match(pattern);
    return match && match[1] ? match[1] : undefined;
};

});
parcelRegister("9mazR", function(module, exports) {
$parcel$export(module.exports, "USER_TYPING_DEBOUNCE_TIME", () => $a8ec4cd2f2713b84$export$c5b77883736a2a29);
$parcel$export(module.exports, "SELECTED_SECTION_BORDER_WIDTH", () => $a8ec4cd2f2713b84$export$57e6e5c7bcaced24);
$parcel$export(module.exports, "HTTP", () => $a8ec4cd2f2713b84$export$ee9d07cf1658f1a7);
$parcel$export(module.exports, "SPINNER_DELAY", () => $a8ec4cd2f2713b84$export$fb1d6648e4d00b79);
$parcel$export(module.exports, "ScreenName", () => $a8ec4cd2f2713b84$export$acfa120f168ab3f8);
$parcel$export(module.exports, "RouteName", () => $a8ec4cd2f2713b84$export$bfbea4d618559e4a);
$parcel$export(module.exports, "RoutePath", () => $a8ec4cd2f2713b84$export$1b64c75ea7ed0865);
$parcel$export(module.exports, "ExperienceName", () => $a8ec4cd2f2713b84$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "BrowserMetricViewName", () => $a8ec4cd2f2713b84$export$d28ca3cbca982562);
$parcel$export(module.exports, "EngagementMessages", () => $a8ec4cd2f2713b84$export$a0841dbe900de5cb);
$parcel$export(module.exports, "EngagementMessagesTarget", () => $a8ec4cd2f2713b84$export$e396ee6d05cbdca4);
$parcel$export(module.exports, "PORTAL_PARENT_PRODUCT", () => $a8ec4cd2f2713b84$export$218d9cffbbd32919);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SHIM_URL", () => $a8ec4cd2f2713b84$export$4ef7b134a809306c);
$parcel$export(module.exports, "UNIFIED_HELP_CENTER_BASE_PATH", () => $a8ec4cd2f2713b84$export$edfbc36787ce1acb);
$parcel$export(module.exports, "HELP_CENTERS_MANAGEMENT_BASE_PATH", () => $a8ec4cd2f2713b84$export$f9a9f80d0023ea53);
$parcel$export(module.exports, "VA_ON_HC_CONVERSATION_PATH", () => $a8ec4cd2f2713b84$export$640d6db9adfb1ee9);
$parcel$export(module.exports, "VA_ON_PORTAL_CONVERSATION_PATH", () => $a8ec4cd2f2713b84$export$ea450ea04b439b84);
$parcel$export(module.exports, "DEFAULT_HELP_CENTER_TYPE", () => $a8ec4cd2f2713b84$export$e2ce1da1cf52c1f4);
$parcel$export(module.exports, "DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY", () => $a8ec4cd2f2713b84$export$c7ac69203430ee56);
// This file contains re-used UI view related constants
/* The amount of time to wait before doing some work that is triggered by user typing */ const $a8ec4cd2f2713b84$export$c5b77883736a2a29 = 500;
const $a8ec4cd2f2713b84$export$57e6e5c7bcaced24 = 1.5;
const $a8ec4cd2f2713b84$export$ee9d07cf1658f1a7 = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    OFFLINE: 0,
    SERVER: 500,
    UNAUTHORIZED: 401
};
const $a8ec4cd2f2713b84$export$fb1d6648e4d00b79 = 300;
var $a8ec4cd2f2713b84$export$acfa120f168ab3f8 = /*#__PURE__*/ function(ScreenName) {
    ScreenName["HELP_CENTER"] = "portalHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_SIDEBAR"] = "portalCustomizeHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeHelpCenterAnnouncement";
    ScreenName["HELP_CENTER_VSA_CHAT_SIDEBAR"] = "portalCustomizeHelpCenterVsaChatSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOOK_AND_FEEL_SIDEBAR"] = "portalCustomizeLookAndFeelSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOGIN_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeLoginAnnouncementSidebar";
    ScreenName["HELP_CENTERS_MANAGEMENT"] = "helpCentersManagement";
    ScreenName["HELP_HUBS_MANAGEMENT"] = "helpHubsManagement";
    ScreenName["HELP_CENTER_MIGRATION_WIZARD_SELECT"] = "helpCenterMigrationWizardSelect";
    ScreenName["HELP_CENTER_MIGRATION_WIZARD_REVIEW"] = "helpCenterMigrationWizardReview";
    ScreenName["HELP_CENTER_MIGRATION_WIZARD_UPDATE"] = "helpCenterMigrationWizardUpdate";
    ScreenName["EDIT_HELP_CENTER"] = "helpCenterEditDetails";
    ScreenName["MANAGE_PROJECTS"] = "helpCenterManageProjects";
    ScreenName["MANAGE_PAGES"] = "helpCenterManagePages";
    ScreenName["FEEDBACK"] = "portalRequestFeedback";
    ScreenName["FEEDBACK_SUBMITTED"] = "portalRequestFeedbackCommentSubmitted";
    ScreenName["LOGIN"] = "portalLogin";
    ScreenName["LOGIN_PASSWORD"] = "portalLoginPassword";
    ScreenName["LOGIN_FORGOT_PASSWORD_CONFIRMATION"] = "portalLoginForgotPasswordConfirmation";
    ScreenName["LOGIN_SINGLE_SIGN_ON"] = "portalLoginSingleSignOn";
    ScreenName["LOGIN_SINGLE_SIGN_ON_CUSTOMER"] = "portalLoginSingleSignOnCustomer";
    ScreenName["LOGIN_ACTION"] = "portalLoginAction";
    ScreenName["LOGIN_ANNOUNCEMENT_CARD"] = "portalLoginAnnouncementCard";
    ScreenName["LOGIN_SSO_TEST_MODE_ERROR"] = "portalLoginSsoTestModeError";
    ScreenName["RESET_PASSWORD"] = "portalResetPassword";
    ScreenName["UNSUBSCRIBE"] = "portalUnsubscribeConfirmation";
    ScreenName["REQUEST_CREATE"] = "portalRequestCreate";
    ScreenName["REQUEST_DETAILS"] = "portalRequestDetails";
    ScreenName["REQUEST_LIST"] = "portalRequests";
    ScreenName["APPROVAL_LIST"] = "portalApprovals";
    ScreenName["KNOWLEDGE_CATEGORY"] = "categoryPage";
    ScreenName["REQUEST_CREATE_ANONYMOUS_SUCCESS"] = "requestCreateAnonymousSuccess";
    ScreenName["PORTAL_HOME"] = "singlePortal";
    ScreenName["REQUEST_GROUP_LIST"] = "requestGroupList";
    ScreenName["REQUEST_GROUP"] = "requestGroup";
    ScreenName["SIGNUP"] = "portalSignup";
    ScreenName["INVITED_SIGNUP"] = "portalAcceptInvite";
    ScreenName["COMPLETE_SIGNUP"] = "portalCompleteSignup";
    ScreenName["VERIFY_EMAIL"] = "portalVerifyEmail";
    ScreenName["COMPLETE_SIGNUP_TOKEN_EXPIRED"] = "portalCompleteSignupTokenExpired";
    ScreenName["COMPLETE_SIGNUP_TOKEN_INVALID"] = "portalCompleteSignupTokenInvalid";
    ScreenName["CHECK_EMAIL"] = "portalValidateEmail";
    ScreenName["KNOWLEDGE_ARTICLE"] = "knowledgeArticle";
    ScreenName["KNOWLEDGE_ALL_SEARCH_RESULTS"] = "knowledgeAllSearchResults";
    ScreenName["USER_PROFILE"] = "portalProfile";
    ScreenName["ADD_ANNOUNCEMENT_SIDEBAR"] = "addAnnouncementSidebar";
    ScreenName["REQUEST_LIST_CUSTOMIZE_SIDEBAR"] = "requestListCustomizeSidebar";
    ScreenName["REQUEST_APPROVAL"] = "requestApproval";
    ScreenName["PORTAL_REORDER_SETTINGS"] = "portalReorderSettings";
    ScreenName["ERROR_NOT_FOUND"] = "errorNotFound";
    ScreenName["PORTAL_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeAnnouncementSidebar";
    ScreenName["VIEW_TOPIC"] = "viewTopic";
    ScreenName["VIEW_CUSTOM_PAGE"] = "viewCustomPage";
    ScreenName["EDIT_CUSTOM_PAGE"] = "editCustomPage";
    ScreenName["EDIT_TOPICS_LAYOUT"] = "editTopicsLayout";
    ScreenName["EDIT_TOPIC"] = "editTopic";
    ScreenName["PORTAL_ACCESS_FORBIDDEN"] = "PortalAccessForbidden";
    ScreenName["EMBED_REQUEST_CREATE"] = "embedRequestCreate";
    ScreenName["EMBED_LOGIN_SUCCESS"] = "embedLoginSuccess";
    ScreenName["EMBED_SINGLE_PORTAL"] = "embedSinglePortal";
    ScreenName["EMBED_KB_ARTICLE"] = "embedKBArticle";
    ScreenName["VIEW_HOMEPAGE"] = "portalHelpCenter";
    ScreenName["EDIT_HOMEPAGE"] = "editHomepage";
    ScreenName["EDIT_NEW_HELP_CENTER"] = "editNewHelpCenter";
    ScreenName["HELP_DESK_REPORTING"] = "helpDeskReporting";
    ScreenName["UNIFIED_HELP_HOME_PAGE"] = "unifiedHelpHomePage";
    ScreenName["UNIFIED_HELP_TEST_HARNESS"] = "unifiedHelpTestHarness";
    ScreenName["ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES"] = "addHelpContentKnowledgeResources";
    ScreenName["ADD_HELP_CONTENT_EXTERNAL_LINKS"] = "addHelpContentExternalLinks";
    ScreenName["HELP_CENTER_SEARCH"] = "PortalSearch";
    ScreenName["CONVERSATION_PAGE"] = "conversationPage";
    ScreenName["CONSENT_FORM_PAGE"] = "consentFormPage";
    ScreenName["AI_ANSWER"] = "aiAnswer";
    ScreenName["CSM_CONTACT_US"] = "csmContactUs";
    ScreenName["CSM_FOLDER"] = "csmFolder";
    ScreenName["CSM_REQUESTS_LIST"] = "csmRequestsList";
    ScreenName["CSM_REQUEST_DETAILS"] = "csmRequestDetails";
    ScreenName["CSM_VIEW_HOMEPAGE"] = "csmViewHomepage";
    ScreenName["EMBED_FEATURED_PORTALS"] = "embedFeaturedPortals";
    ScreenName["VIRTUAL_SERVICE_AGENT_HEADER"] = "virtualServiceAgentHeader";
    ScreenName["TOPIC_ITEM_HOMEPAGE"] = "topicItemHomepage";
    ScreenName["TOPIC_ITEM"] = "topicItem";
    ScreenName["OMNICHANNEL_CONVERSATION_SOURCES"] = "omnichannelConversationSources";
    ScreenName["SURVEY"] = "survey";
    return ScreenName;
}({});
var $a8ec4cd2f2713b84$export$bfbea4d618559e4a = /*#__PURE__*/ function(RouteName) {
    RouteName["VIEW_CUSTOM_PAGE"] = "view-custom-page";
    RouteName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    RouteName["CSM_CONTACT_US_PAGE"] = "contact-us";
    RouteName["CSM_FOLDER_PAGE"] = "csm-folder";
    RouteName["CSM_REQUESTS_LIST_PAGE"] = "csm-requests-list";
    RouteName["CSM_REQUEST_DETAILS_PAGE"] = "csm-request-details";
    return RouteName;
}({});
var $a8ec4cd2f2713b84$export$1b64c75ea7ed0865 = /*#__PURE__*/ function(RoutePath) {
    RoutePath["VIEW_CUSTOM_PAGE"] = "/page/:id/:title?";
    RoutePath["EDIT_CUSTOM_PAGE"] = "/page/edit/:id/:title?";
    RoutePath["CSM_CONTACT_US_PATH"] = "/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?";
    RoutePath["CSM_FOLDER_PATH"] = "/folder/:folderId";
    RoutePath["CSM_REQUESTS_LIST_PATH"] = "/user/requests";
    RoutePath["CSM_REQUEST_DETAILS_PATH"] = "/user/requests/:requestKey";
    return RoutePath;
}({});
var $a8ec4cd2f2713b84$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REQUEST_CREATE"] = "request-create";
    ExperienceName["HELP_CENTER"] = "view-help-center";
    ExperienceName["CUSTOM_PAGE"] = "view-custom-page";
    ExperienceName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    ExperienceName["FEATURED_AND_SORTED_PORTALS"] = "featured-and-sorted-portals";
    return ExperienceName;
}({});
var $a8ec4cd2f2713b84$export$d28ca3cbca982562 = /*#__PURE__*/ function(BrowserMetricViewName) {
    BrowserMetricViewName["REQUEST_DETAIL_VIEW"] = "request-detail";
    BrowserMetricViewName["COMMENT_EDITOR_VIEW"] = "comment-editor";
    return BrowserMetricViewName;
}({});
var $a8ec4cd2f2713b84$export$a0841dbe900de5cb = /*#__PURE__*/ function(EngagementMessages) {
    EngagementMessages["SIDEBAR_REFACTOR"] = "jsm-portal-sidebar-refactor";
    EngagementMessages["PORTAL_REORDER_EXPERIENCE"] = "jsm-portal-reordering-change-boarding";
    EngagementMessages["TOPICS"] = "jsm-customer-portal-topics";
    EngagementMessages["EXTERNAL_RESOURCES_IN_TOPICS"] = "external-resources-in-topics-pill";
    EngagementMessages["TOPICS_FOR_ALL"] = "topics-for-all-customisation";
    EngagementMessages["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "jsm_admins_help_center_settings_button";
    EngagementMessages["CHANGE_BOARD_ADMINS_FREE_AND_STANDARD_EDITION"] = "changeboarding_jsm_admins_home_free_std";
    EngagementMessages["CHANGE_BOARD_ADMINS_SINGLE_PORTAL_SCREEN"] = "changeboarding_jsm_admins_singleportal";
    EngagementMessages["CHANGE_BOARD_ADMINS_PREMIUM_ENTERPRISE"] = "changeboarding_jsm_admins_premium_entr";
    EngagementMessages["ONBOARD_VA_REPORTING"] = "va-reporting-changeboarding-message";
    EngagementMessages["ONBOARD_VA_ON_HC"] = "va-on-hc-onboarding-message";
    EngagementMessages["CHANGE_BOARD_VISUAL_REFRESH"] = "jsm-visual-refresh-changeboarding";
    EngagementMessages["INCREASED_FLEXIBILITY_CHANGEBOARDING"] = "jsm-increased-flexibility-changeboarding";
    return EngagementMessages;
}({});
var $a8ec4cd2f2713b84$export$e396ee6d05cbdca4 = /*#__PURE__*/ function(EngagementMessagesTarget) {
    EngagementMessagesTarget["CHANGE_BOARDING_SPOTLIGHT"] = "changeBoardingSpotLight";
    EngagementMessagesTarget["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "changeBoardHelpCenterSettingsButton";
    EngagementMessagesTarget["MUTLI_HC_CHANGE_BOARDING_SPOTLIGHT"] = "multihcDropdownChangeBoardingSpotlight";
    EngagementMessagesTarget["REPORTING_ONBOARDING_SPOTLIGHT"] = "reportingOnboardingSpotlight";
    EngagementMessagesTarget["VISUAL_REFRESH_CHANGEBOARDING_SPOTLIGHT"] = "visualRefreshChangeboardingSpotlight";
    return EngagementMessagesTarget;
}({});
const $a8ec4cd2f2713b84$export$218d9cffbbd32919 = 'JSM-Portal';
const $a8ec4cd2f2713b84$export$4ef7b134a809306c = '/plugins/servlet/servicedesk/customer/confluence/shim/';
const $a8ec4cd2f2713b84$export$edfbc36787ce1acb = '/helpcenter/unified';
const $a8ec4cd2f2713b84$export$f9a9f80d0023ea53 = '/helpcenter-management';
const $a8ec4cd2f2713b84$export$640d6db9adfb1ee9 = '/conversation';
const $a8ec4cd2f2713b84$export$ea450ea04b439b84 = '/portal/:portalId/conversation';
const $a8ec4cd2f2713b84$export$e2ce1da1cf52c1f4 = 'BASIC';
const $a8ec4cd2f2713b84$export$c7ac69203430ee56 = 'JSM_AND_JCS';

});

parcelRegister("hN5YJ", function(module, exports) {
$parcel$export(module.exports, "RICH_TEXT_AREA_FIELD", () => $8f93d0824c768330$export$706f525b497c4077);
$parcel$export(module.exports, "UNIFIED_HELP_ADD_FILTER_FOR_CUSTOMER_ACCOUNTS", () => $8f93d0824c768330$export$a1c6198e9bfea49a);
$parcel$export(module.exports, "JSM_VIRTUAL_AGENT_ANONYMOUS_ACCESS", () => $8f93d0824c768330$export$56132373c73141db);
$parcel$export(module.exports, "JSM_SCALE_60K_AGG_BRANCH_OVERRIDE_IN_HELP_CENTER", () => $8f93d0824c768330$export$5681240cc1c04856);
$parcel$export(module.exports, "HELP_CENTER_REFRESH_FLAG", () => $8f93d0824c768330$export$cb73a351cc03929f);
$parcel$export(module.exports, "EMAIL_VERIFIED_SIGNAL_ON_CUSTOMERS_PAGE", () => $8f93d0824c768330$export$660d24662c32371a);
$parcel$export(module.exports, "ENABLE_INCREASED_FLEXIBILITY", () => $8f93d0824c768330$export$13d57865c16811e5);
$parcel$export(module.exports, "ENABLE_FOLLOWUP_QUESTIONS_ON_PORTAL", () => $8f93d0824c768330$export$40e944519b773806);
$parcel$export(module.exports, "isEmailVerifiedSignalEnabled", () => $8f93d0824c768330$export$d418c5a93f5a612e);
$parcel$export(module.exports, "isWrmOptimizationsEnabled", () => $8f93d0824c768330$export$9d40c615991b681d);
$parcel$export(module.exports, "isRichTextAreaEnabled", () => $8f93d0824c768330$export$ed104cfad45df81c);
$parcel$export(module.exports, "islooselyLazyJsErrorsToSentryEnabled", () => $8f93d0824c768330$export$bf2b9f47d2bc9d17);
$parcel$export(module.exports, "isCustomThemingEnabled", () => $8f93d0824c768330$export$dbb8ae3ec0512e12);
$parcel$export(module.exports, "isUnifiedHelpAddFilterForCustomerAccounts", () => $8f93d0824c768330$export$4fd1074ca1df827a);
$parcel$export(module.exports, "isFixRelayIdConflictInHelpCenter", () => $8f93d0824c768330$export$65c1b2a8a68046aa);
$parcel$export(module.exports, "isFixRelayIdConflictForHelpObjectStoreEnabled", () => $8f93d0824c768330$export$73a498f76aad8d2);
$parcel$export(module.exports, "isJsmScale60KAggBranchOverrideInHelpCenterEnabled", () => $8f93d0824c768330$export$56a24c7fc09b6e91);
$parcel$export(module.exports, "isSendRawHelpCenterTypeInAnalyticsEnabled", () => $8f93d0824c768330$export$5dccb020251579a1);
$parcel$export(module.exports, "isCsmAccessControlSplitEnabled", () => $8f93d0824c768330$export$27c460ed295f06bd);
$parcel$export(module.exports, "isAiWidgetTeam25Enabled", () => $8f93d0824c768330$export$4b18120aa62097f1);
$parcel$export(module.exports, "isUpdateArticlesLinkCsmEnabled", () => $8f93d0824c768330$export$19229ae1da4441b0);
$parcel$export(module.exports, "isCsmAppification", () => $8f93d0824c768330$export$24a6eb68da6f8093);
$parcel$export(module.exports, "isCsmForgeCustomFieldJsmContextTokenEnabled", () => $8f93d0824c768330$export$e14aa568fba1011a);
$parcel$export(module.exports, "isCrossSiteConnieConnectionEnabled", () => $8f93d0824c768330$export$8cfd0c7691c6e406);
$parcel$export(module.exports, "isKbArticlesSameTabRedirectionEnabled", () => $8f93d0824c768330$export$6bf26299f5ce3574);
$parcel$export(module.exports, "isRetryMechanismTuningEnabled", () => $8f93d0824c768330$export$484a220addce746c);
$parcel$export(module.exports, "isProformaTTVCUpdateMeasureEnabled", () => $8f93d0824c768330$export$f1047a0c2946b9);
$parcel$export(module.exports, "isDefaultHCUsingGqlBrandingCalls", () => $8f93d0824c768330$export$d10ba47ac271b5fb);
$parcel$export(module.exports, "isUseHelpCenterRefresh", () => $8f93d0824c768330$export$6c961d647d8a8d16);
$parcel$export(module.exports, "isDraftArticleSuggestionsEnabled", () => $8f93d0824c768330$export$edadb203ac2a6c5c);
$parcel$export(module.exports, "isForgeCustomFieldsOnPortalViewEnabled", () => $8f93d0824c768330$export$5998e12cd61e03e4);
$parcel$export(module.exports, "isUiModificationsSupportEnabled", () => $8f93d0824c768330$export$2b4c3a76f069fbf5);
$parcel$export(module.exports, "isTextFieldSupportEnabled", () => $8f93d0824c768330$export$97cf619b5c503901);
$parcel$export(module.exports, "isNumberFieldSupportEnabled", () => $8f93d0824c768330$export$5377338157c93a4a);
$parcel$export(module.exports, "isMultiCheckboxSupportEnabled", () => $8f93d0824c768330$export$d5cbe93dd4c558ea);
$parcel$export(module.exports, "isRadioButtonsSupportEnabled", () => $8f93d0824c768330$export$82589d303153590);
$parcel$export(module.exports, "isUserPickerEmailSupportEnabled", () => $8f93d0824c768330$export$2e53bb8a2a18dff0);
$parcel$export(module.exports, "isDateTimeSupportEnabled", () => $8f93d0824c768330$export$a3127feadc5f63ef);
$parcel$export(module.exports, "isDueDateSupportEnabled", () => $8f93d0824c768330$export$ca4e8050793caa6);
$parcel$export(module.exports, "isCascadingSelectSupportEnabled", () => $8f93d0824c768330$export$b738c6acf33d051a);
$parcel$export(module.exports, "isUserPickerSupportEnabled", () => $8f93d0824c768330$export$d16c700a701ab994);
$parcel$export(module.exports, "cascadingSelectDefaultValueSupportEnabled", () => $8f93d0824c768330$export$5621e5c6b3b162df);
$parcel$export(module.exports, "isFollowupEnabledForPortal", () => $8f93d0824c768330$export$cd1b5399e7ea70f2);
$parcel$export(module.exports, "isAiAnswer24HourTimeoutEnabled", () => $8f93d0824c768330$export$6d74bd5fbad4512e);
$parcel$export(module.exports, "isIncreasedFlexibilityEnabled", () => $8f93d0824c768330$export$81ac031d5c9eadb5);
$parcel$export(module.exports, "isElementRendererSplitEnabled", () => $8f93d0824c768330$export$6a665c3fef32cc75);
$parcel$export(module.exports, "isOmnichannelEnabledForHC", () => $8f93d0824c768330$export$c008df611f489124);
$parcel$export(module.exports, "isItsmIssueRenamingEnabled", () => $8f93d0824c768330$export$54d7baed1ffc6f83);
$parcel$export(module.exports, "isItsmProjectRenamingEnabled", () => $8f93d0824c768330$export$bd371ef032bb50b4);
$parcel$export(module.exports, "isOmnichannelGreetingAPIEnabled", () => $8f93d0824c768330$export$59c4c8d95bf1eefc);
$parcel$export(module.exports, "isOmnichannelSubscriptionErrorpageEnabled", () => $8f93d0824c768330$export$492c9921026864bb);
$parcel$export(module.exports, "isRequestCreateSkipDropdownInitialOptionsCallEnabled", () => $8f93d0824c768330$export$4c0bb2a2e82edb28);
$parcel$export(module.exports, "isHideKbColumnEnabled", () => $8f93d0824c768330$export$787e10895d9b5b56);
$parcel$export(module.exports, "isVsaSettingsPerformanceImprovementsEnabled", () => $8f93d0824c768330$export$2803857b1fa00ccb);
$parcel$export(module.exports, "isTotalArticleCountEnabled", () => $8f93d0824c768330$export$dbf6a8ec8de99792);
$parcel$export(module.exports, "isHideVsaEndpointsEnabled", () => $8f93d0824c768330$export$5ee14c6848af11b8);
$parcel$export(module.exports, "isHubsEnabledInHelpCenter", () => $8f93d0824c768330$export$b03e57f56b691f9d);
$parcel$export(module.exports, "isMultiSelectEnabled", () => $8f93d0824c768330$export$3d9060e51ab7079e);
$parcel$export(module.exports, "isJsmSurveysCoreFeatureEnabled", () => $8f93d0824c768330$export$a953b7b444ffe51e);
$parcel$export(module.exports, "isJsmSurveysValidationErrorPayloadEnabled", () => $8f93d0824c768330$export$329f9fca12e617c6);
$parcel$export(module.exports, "isJsmSurveysGraphqlApiEnabled", () => $8f93d0824c768330$export$eed81849decd0ba1);
$parcel$export(module.exports, "isSurveysWorkItemSupportEnabled", () => $8f93d0824c768330$export$e405833c44e0e395);
$parcel$export(module.exports, "isSendWorkItemIdInPortalSurveyEnabled", () => $8f93d0824c768330$export$4e0d6992fd0d9087);
$parcel$export(module.exports, "isSurveyLandingAnalyticsEnabled", () => $8f93d0824c768330$export$5bc9fb66c3587063);
$parcel$export(module.exports, "isJsmPortalRovoIntegrationEnabled", () => $8f93d0824c768330$export$c2b1b7c65c5a4a75);
$parcel$export(module.exports, "isDatePickerSupportEnabled", () => $8f93d0824c768330$export$1df7079ae40c80e4);
$parcel$export(module.exports, "isRovoAgentsToolsConfigM2Enabled", () => $8f93d0824c768330$export$ea979393725a029);
$parcel$export(module.exports, "isStudioGsnAndScenarioRefreshEnabled", () => $8f93d0824c768330$export$a111e2ff03776b7c);
$parcel$export(module.exports, "isSkipProjectSectionInInstructionsEnabled", () => $8f93d0824c768330$export$feff9c08935da719);
$parcel$export(module.exports, "isRequestListInfiniteScrollEnabled", () => $8f93d0824c768330$export$46753c7d3f251473);
$parcel$export(module.exports, "isApprovalListInfiniteScrollEnabled", () => $8f93d0824c768330$export$e86f67505602f2f);
$parcel$export(module.exports, "isDateSelectionFixForOmnichannelEnabled", () => $8f93d0824c768330$export$ece9dbae592cbfe0);
$parcel$export(module.exports, "JSM_PCI_CARD_NUMBER_FIELDS", () => $8f93d0824c768330$export$37ce31aec3224005);
$parcel$export(module.exports, "isJsmPciCardNumberFieldTypeEnabled", () => $8f93d0824c768330$export$e3376874eb99c8d3);
/**
 * Define feature flag here as constants.
 *
 * export const KB_ENHANCEMENTS = 'jsd.px.kb-enhancements';
 *
 * Use them in react components.
 * import { KB_ENHANCEMENTS } from '@helpcenter/feature-flags';
 * import { FeatureFlag } from 'view/common/feature-flag';
 *
 * <FeatureFlag name={KB_ENHANCEMENTS}>
 *  I will be shown in true :-)
 * </FeatureFlag>
 *
 * ========== NOTE ===================
 * BE CAREFUL ADDING FEATURE FLAGS, IF YOU RENAME THEM IT WILL CHANGE THE ANALYTIC CONTEXT
 * NAME AND NO LONGER SEND THE SAME CONTEXT ATTRIBUTE NAME.
 * ===================================
 */ 
var $k2M4v = parcelRequire("k2M4v");
const $8f93d0824c768330$export$706f525b497c4077 = 'jsd-use-adf-default-value-for-textarea';
const $8f93d0824c768330$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB = 'make-kb-articles-open-in-same-tab';
const $8f93d0824c768330$export$a1c6198e9bfea49a = 'unified-help-add-filter-for-customer-accounts';
const $8f93d0824c768330$var$CSM_ACCESS_CONTROL_SPLIT = 'csm_access_control_split_take2';
const $8f93d0824c768330$var$AI_WIDGET_TEAM25 = 'berry-5094-ai-widget-support-website-team25';
const $8f93d0824c768330$var$CSM_ENABLE_FORGE_CUSTOM_FIELD_JSM_CONTEXT_TOKEN = 'csm_enable_forge_custom_field_jsm_context_token';
const $8f93d0824c768330$var$SEND_RAW_HELP_CENTER_TYPE_IN_ANALYTICS = 'help-center-fix-type-in-analytics';
const $8f93d0824c768330$export$56132373c73141db = 'anonymous_virtual_agent_access';
const $8f93d0824c768330$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER = 'fix_relay_id_conflict_in_help_center';
const $8f93d0824c768330$var$FIX_RELAY_ID_CONFLICT_FOR_HELP_OBJECT_STORE = 'fix_relay_id_conflict_for_help_object_store';
const $8f93d0824c768330$export$5681240cc1c04856 = 'jsm_scale_60k_agg_branch_override_in_help_center';
const $8f93d0824c768330$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT = 'tuning_model_retries';
const $8f93d0824c768330$var$ENABLE_CROSS_SITE_CONFLUENCE = 'enable-cross-site-confluence';
const $8f93d0824c768330$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED = 'measure_proforma_ttvc_impact';
const $8f93d0824c768330$var$DEFAULT_HC_USING_GQL_BRANDING = 'default_hc_using_gql_branding';
const $8f93d0824c768330$export$cb73a351cc03929f = 'enable_increased_flexibility'; // TODO: using same key as increased flexibility for bundle release
const $8f93d0824c768330$export$660d24662c32371a = 'sptn-1697-email-verified-signal-on-customers-page';
const $8f93d0824c768330$export$13d57865c16811e5 = 'enable_increased_flexibility';
const $8f93d0824c768330$export$40e944519b773806 = 'enable_followup_questions_on_omni_channel_portal';
const $8f93d0824c768330$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL = 'request_create_dropdown_initial_options_call';
const $8f93d0824c768330$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN = 'hc_vsa_settings_hide_kb_article_column';
const $8f93d0824c768330$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS = 'hc_vsa_settings_performance_improvements';
const $8f93d0824c768330$var$TOTAL_ARTICLE_COUNT = 'hc_show_kb_total_article_count';
const $8f93d0824c768330$var$HIDE_VSA_ENDPOINTS = 'hide_vsa_endpoints';
const $8f93d0824c768330$var$ENABLE_HUBS_IN_HELP_CENTER = 'enable-hubs-in-help-center';
const $8f93d0824c768330$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT = 'ditto_uim_jsm_multi_select_support';
const $8f93d0824c768330$var$JSM_PORTAL_ROVO_INTEGRATION = 'jsm_portal_rovo_integration';
const $8f93d0824c768330$var$JSM_DATEPICKER_FIELD_SUPPORT = 'ditto_uim_jsm_datepicker_field_support';
const $8f93d0824c768330$var$JSM_SURVEYS_CORE_FEATURE = 'jsm_surveys_core_feature';
const $8f93d0824c768330$var$JSM_SURVEYS_GRAPHQL_API = 'jsm_surveys_graphql_api';
const $8f93d0824c768330$var$JSM_SURVEYS_VALIDATION_ERROR_PAYLOAD = 'jsm_surveys_validation_error_payload';
// Shared with the Jira side, which gates survey link enrichment on the same gate.
const $8f93d0824c768330$var$JSM_SURVEYS_WORK_ITEM_SUPPORT = 'enable-surveys-work-item-support';
// Portal-only (jsm-portal_web) counterpart of JSM_SURVEYS_WORK_ITEM_SUPPORT, which is not
// registered for the portal target app.
const $8f93d0824c768330$var$SEND_WORK_ITEM_ID_IN_PORTAL_SURVEY = 'send_workitem_id_in_portal_survey';
const $8f93d0824c768330$var$SURVEY_LANDING_ANALYTICS = 'add_analytics_for_survey_visited_with_work_item_';
const $8f93d0824c768330$var$ROVO_AGENTS_TOOLS_CONFIG_M2 = 'rovo_agents_tools_config_m2';
const $8f93d0824c768330$var$REQUEST_LIST_INFINITE_SCROLL = 'portal-6922-request-list-jsis-pagination';
const $8f93d0824c768330$var$APPROVAL_LIST_INFINITE_SCROLL = 'portal-approval-list-jsis-pagination';
const $8f93d0824c768330$export$d418c5a93f5a612e = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$export$660d24662c32371a);
};
const $8f93d0824c768330$export$9d40c615991b681d = ()=>true;
const $8f93d0824c768330$export$ed104cfad45df81c = ()=>(0, $k2M4v.default).checkGate($8f93d0824c768330$export$706f525b497c4077);
const $8f93d0824c768330$export$bf2b9f47d2bc9d17 = ()=>(0, $k2M4v.default).checkGate('throw_lazy_error_boundary_js_errors_to_sentry');
const $8f93d0824c768330$export$dbb8ae3ec0512e12 = ()=>false;
const $8f93d0824c768330$export$4fd1074ca1df827a = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$export$a1c6198e9bfea49a);
};
const $8f93d0824c768330$export$65c1b2a8a68046aa = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER);
};
const $8f93d0824c768330$export$73a498f76aad8d2 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$FIX_RELAY_ID_CONFLICT_FOR_HELP_OBJECT_STORE);
};
const $8f93d0824c768330$export$56a24c7fc09b6e91 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$export$5681240cc1c04856);
};
const $8f93d0824c768330$export$5dccb020251579a1 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$SEND_RAW_HELP_CENTER_TYPE_IN_ANALYTICS);
};
const $8f93d0824c768330$export$27c460ed295f06bd = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$CSM_ACCESS_CONTROL_SPLIT);
};
const $8f93d0824c768330$export$4b18120aa62097f1 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$AI_WIDGET_TEAM25);
};
const $8f93d0824c768330$export$19229ae1da4441b0 = ()=>{
    return (0, $k2M4v.default).checkGate('update_articles_links_csm');
};
const $8f93d0824c768330$export$24a6eb68da6f8093 = ()=>{
    return (0, $k2M4v.default).checkGate('csm_appification_standalone_navigation');
};
const $8f93d0824c768330$export$e14aa568fba1011a = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$CSM_ENABLE_FORGE_CUSTOM_FIELD_JSM_CONTEXT_TOKEN);
};
const $8f93d0824c768330$export$8cfd0c7691c6e406 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$ENABLE_CROSS_SITE_CONFLUENCE);
};
const $8f93d0824c768330$export$6bf26299f5ce3574 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB);
};
const $8f93d0824c768330$export$484a220addce746c = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT);
};
const $8f93d0824c768330$export$f1047a0c2946b9 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED);
};
const $8f93d0824c768330$export$d10ba47ac271b5fb = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$DEFAULT_HC_USING_GQL_BRANDING);
};
const $8f93d0824c768330$export$6c961d647d8a8d16 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$export$cb73a351cc03929f);
};
const $8f93d0824c768330$export$edadb203ac2a6c5c = ()=>{
    return (0, $k2M4v.default).checkGate('ai-answer-using-draft-article');
};
const $8f93d0824c768330$export$5998e12cd61e03e4 = ()=>(0, $k2M4v.default).checkGate('forge_custom_fields_on_jsm_portal_view');
const $8f93d0824c768330$export$2b4c3a76f069fbf5 = ()=>(0, $k2M4v.default).checkGate('ditto_uim_-_jsm_support_main');
const $8f93d0824c768330$export$97cf619b5c503901 = ()=>{
    return (0, $k2M4v.default).checkGate('uim_jsm_textfield_support');
};
const $8f93d0824c768330$export$5377338157c93a4a = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_number_field_support');
};
const $8f93d0824c768330$export$d5cbe93dd4c558ea = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_multi_checkbox_support');
};
const $8f93d0824c768330$export$82589d303153590 = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_radio_buttons_support');
};
const $8f93d0824c768330$export$2e53bb8a2a18dff0 = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_user_picker_email');
};
const $8f93d0824c768330$export$a3127feadc5f63ef = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_datetime_field_support');
};
const $8f93d0824c768330$export$ca4e8050793caa6 = ()=>{
    return (0, $k2M4v.default).checkGate('uim_jsm_duedate_support');
};
const $8f93d0824c768330$export$b738c6acf33d051a = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_cascading_select_support');
};
const $8f93d0824c768330$export$d16c700a701ab994 = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_user_picker_support');
};
const $8f93d0824c768330$export$5621e5c6b3b162df = ()=>{
    return (0, $k2M4v.default).checkGate('ditto_uim_jsm_cascading_default_value_support');
};
const $8f93d0824c768330$export$cd1b5399e7ea70f2 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$export$40e944519b773806);
};
const $8f93d0824c768330$export$6d74bd5fbad4512e = ()=>{
    return (0, $k2M4v.default).checkGate('ai_answer_default_timeout_to_24_hours');
};
const $8f93d0824c768330$export$81ac031d5c9eadb5 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$export$13d57865c16811e5);
};
const $8f93d0824c768330$export$6a665c3fef32cc75 = ()=>{
    return (0, $k2M4v.default).checkGate('enable_element_renderer_split');
};
const $8f93d0824c768330$export$c008df611f489124 = ()=>{
    return (0, $k2M4v.default).checkGate('enable_omni_channel_for_helpcenter');
};
const $8f93d0824c768330$export$54d7baed1ffc6f83 = ()=>{
    return (0, $k2M4v.default).checkGate('itsm-issue-renaming');
};
const $8f93d0824c768330$export$bd371ef032bb50b4 = ()=>{
    return (0, $k2M4v.default).checkGate('itsm-project-renaming');
};
const $8f93d0824c768330$export$59c4c8d95bf1eefc = ()=>{
    return (0, $k2M4v.default).checkGate('jsm_chat_orchestrator_greeting_api_enabled');
};
const $8f93d0824c768330$export$492c9921026864bb = ()=>{
    return (0, $k2M4v.default).checkGate('enable_omnichannel_subscription_error_page');
};
const $8f93d0824c768330$export$4c0bb2a2e82edb28 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL);
};
const $8f93d0824c768330$export$787e10895d9b5b56 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN);
};
const $8f93d0824c768330$export$2803857b1fa00ccb = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS);
};
const $8f93d0824c768330$export$dbf6a8ec8de99792 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$TOTAL_ARTICLE_COUNT);
};
const $8f93d0824c768330$export$5ee14c6848af11b8 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$HIDE_VSA_ENDPOINTS);
};
const $8f93d0824c768330$export$b03e57f56b691f9d = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$ENABLE_HUBS_IN_HELP_CENTER);
};
const $8f93d0824c768330$export$3d9060e51ab7079e = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT);
};
const $8f93d0824c768330$export$a953b7b444ffe51e = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$JSM_SURVEYS_CORE_FEATURE);
};
const $8f93d0824c768330$export$329f9fca12e617c6 = ()=>(0, $k2M4v.default).checkGate($8f93d0824c768330$var$JSM_SURVEYS_VALIDATION_ERROR_PAYLOAD);
const $8f93d0824c768330$export$eed81849decd0ba1 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$JSM_SURVEYS_GRAPHQL_API);
};
const $8f93d0824c768330$export$e405833c44e0e395 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$JSM_SURVEYS_WORK_ITEM_SUPPORT);
};
const $8f93d0824c768330$export$4e0d6992fd0d9087 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$SEND_WORK_ITEM_ID_IN_PORTAL_SURVEY);
};
const $8f93d0824c768330$export$5bc9fb66c3587063 = ()=>(0, $k2M4v.default).checkGate($8f93d0824c768330$var$SURVEY_LANDING_ANALYTICS);
const $8f93d0824c768330$export$c2b1b7c65c5a4a75 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$JSM_PORTAL_ROVO_INTEGRATION);
};
const $8f93d0824c768330$export$1df7079ae40c80e4 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$JSM_DATEPICKER_FIELD_SUPPORT);
};
const $8f93d0824c768330$export$ea979393725a029 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$ROVO_AGENTS_TOOLS_CONFIG_M2);
};
const $8f93d0824c768330$export$a111e2ff03776b7c = ()=>{
    return (0, $k2M4v.default).checkGate('studio-gsn-and-scenario-refresh');
};
const $8f93d0824c768330$export$feff9c08935da719 = ()=>{
    return (0, $k2M4v.default).checkGate('rsa-skip-project-section-in-instructions');
};
const $8f93d0824c768330$export$46753c7d3f251473 = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$REQUEST_LIST_INFINITE_SCROLL);
};
const $8f93d0824c768330$export$e86f67505602f2f = ()=>{
    return (0, $k2M4v.default).checkGate($8f93d0824c768330$var$APPROVAL_LIST_INFINITE_SCROLL);
};
const $8f93d0824c768330$export$ece9dbae592cbfe0 = ()=>(0, $k2M4v.default).checkGate('fix_date_selection_for_omnichannel');
const $8f93d0824c768330$export$37ce31aec3224005 = 'jsm-pci-card-number-fields-fe-flag';
const $8f93d0824c768330$export$e3376874eb99c8d3 = ()=>(0, $k2M4v.default).checkGate($8f93d0824c768330$export$37ce31aec3224005);

});

parcelRegister("diqlM", function(module, exports) {
$parcel$export(module.exports, "contextPath", () => $f21d588172b31521$export$bcb673b8a0b7ff6e);
$parcel$export(module.exports, "getRelativeBasePath", () => $f21d588172b31521$export$8bbd42317ee66540);
$parcel$export(module.exports, "getBasePath", () => $f21d588172b31521$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getBaseName", () => $f21d588172b31521$export$a8b0425edf52c70e);
$parcel$export(module.exports, "historyObservable", () => $f21d588172b31521$export$a43a1132874d88e3);
$parcel$export(module.exports, "default", () => $f21d588172b31521$export$2e2bcd8739ae039);

var $jFk35 = parcelRequire("jFk35");
parcelRequire("a3Wd7");
var $b2AyF = parcelRequire("b2AyF");

var $44fTH = parcelRequire("44fTH");

var $him7m = parcelRequire("him7m");

var $7lN8e = parcelRequire("7lN8e");
const $f21d588172b31521$export$bcb673b8a0b7ff6e = $44fTH.getMeta('context-path') || '';
const $f21d588172b31521$export$8bbd42317ee66540 = ()=>{
    if ((0, $7lN8e.getEnv)().hasOwnProperty('relativeBaseUrl')) return (0, $7lN8e.getEnv)().relativeBaseUrl;
    return '/servicedesk/customer';
};
const $f21d588172b31521$export$9099264ed9b1c55a = ()=>{
    if ((0, $7lN8e.getEnv)().hasOwnProperty('baseUrl')) return (0, $7lN8e.getEnv)().baseUrl;
    return `${$f21d588172b31521$export$bcb673b8a0b7ff6e}${$f21d588172b31521$export$8bbd42317ee66540()}`;
};
const $f21d588172b31521$export$e75259171a9ba0d5 = (url)=>{
    return url.replace('/servicedesk/customer', (0, $7lN8e.getEnv)().relativeBaseUrl);
};
const $f21d588172b31521$export$c4e6c35f2dffd087 = (url)=>{
    return url.replace((0, $7lN8e.getEnv)().relativeBaseUrl, '/servicedesk/customer');
};
const $f21d588172b31521$export$a8b0425edf52c70e = ()=>`${$f21d588172b31521$export$bcb673b8a0b7ff6e}${$f21d588172b31521$export$8bbd42317ee66540()}`;
const $f21d588172b31521$var$history = (0, $him7m.default).isRunningInSnapvmRuntime() ? (0, $b2AyF.createMemoryHistory)({
    initialEntries: [
        $f21d588172b31521$export$a8b0425edf52c70e()
    ]
}) : (0, $b2AyF.createBrowserHistory)({
    basename: $f21d588172b31521$export$a8b0425edf52c70e()
});
const $f21d588172b31521$export$a43a1132874d88e3 = (0, $jFk35.Observable).create((observer)=>{
    $f21d588172b31521$var$history.listen((location, action)=>observer.next({
            location: location,
            action: action
        }));
});
var $f21d588172b31521$export$2e2bcd8739ae039 = $f21d588172b31521$var$history;

});
parcelRegister("jFk35", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $e51165f1052d37de$export$77cea355fa80b5f4, (v) => $e51165f1052d37de$export$77cea355fa80b5f4 = v);
var $e51165f1052d37de$export$77cea355fa80b5f4;
"use strict";

var $4xUKK = parcelRequire("4xUKK");

var $721PO = parcelRequire("721PO");

var $kdmZ2 = parcelRequire("kdmZ2");

var $favZu = parcelRequire("favZu");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $e51165f1052d37de$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $721PO.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($4xUKK.root.Rx && $4xUKK.root.Rx.config && $4xUKK.root.Rx.config.Promise) PromiseCtor = $4xUKK.root.Rx.config.Promise;
            else if ($4xUKK.root.Promise) PromiseCtor = $4xUKK.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$kdmZ2.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $favZu.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($4xUKK.root.Rx && $4xUKK.root.Rx.config && $4xUKK.root.Rx.config.Promise) PromiseCtor = $4xUKK.root.Rx.config.Promise;
            else if ($4xUKK.root.Promise) PromiseCtor = $4xUKK.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$e51165f1052d37de$export$77cea355fa80b5f4 = $e51165f1052d37de$var$Observable;

});
parcelRegister("4xUKK", function(module, exports) {
$parcel$export(module.exports, "root", () => $34f6447acfb80d7a$export$e8e78c978b129247, (v) => $34f6447acfb80d7a$export$e8e78c978b129247 = v);
var $34f6447acfb80d7a$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $34f6447acfb80d7a$var$__window = typeof window !== 'undefined' && window;
var $34f6447acfb80d7a$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $34f6447acfb80d7a$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $34f6447acfb80d7a$var$_root = $34f6447acfb80d7a$var$__window || $34f6447acfb80d7a$var$__global || $34f6447acfb80d7a$var$__self;
$34f6447acfb80d7a$export$e8e78c978b129247 = $34f6447acfb80d7a$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$34f6447acfb80d7a$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});

parcelRegister("721PO", function(module, exports) {
$parcel$export(module.exports, "toSubscriber", () => $51ea24a8808acfba$export$2a12c2cebbfd1087, (v) => $51ea24a8808acfba$export$2a12c2cebbfd1087 = v);
var $51ea24a8808acfba$export$2a12c2cebbfd1087;
"use strict";

var $fwCeA = parcelRequire("fwCeA");

var $4THwh = parcelRequire("4THwh");

var $j4bjR = parcelRequire("j4bjR");
function $51ea24a8808acfba$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $fwCeA.Subscriber) return nextOrObserver;
        if (nextOrObserver[$4THwh.rxSubscriber]) return nextOrObserver[$4THwh.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $fwCeA.Subscriber($j4bjR.empty);
    return new $fwCeA.Subscriber(nextOrObserver, error, complete);
}
$51ea24a8808acfba$export$2a12c2cebbfd1087 = $51ea24a8808acfba$var$toSubscriber;

});
parcelRegister("fwCeA", function(module, exports) {
"use strict";
var $b4d780b9045f617e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6M1u7 = parcelRequire("6M1u7");

var $8IeZR = parcelRequire("8IeZR");

var $j4bjR = parcelRequire("j4bjR");

var $4THwh = parcelRequire("4THwh");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $b4d780b9045f617e$var$Subscriber = function(_super) {
    $b4d780b9045f617e$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $j4bjR.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $j4bjR.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($b4d780b9045f617e$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$4THwh.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $b4d780b9045f617e$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $b4d780b9045f617e$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$4THwh.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($8IeZR.Subscription);
module.exports.Subscriber = $b4d780b9045f617e$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b4d780b9045f617e$var$SafeSubscriber = function(_super) {
    $b4d780b9045f617e$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($6M1u7.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $j4bjR.empty) {
                context = Object.create(observerOrNext);
                if ($6M1u7.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($b4d780b9045f617e$var$Subscriber);
function $b4d780b9045f617e$var$isTrustedSubscriber(obj) {
    return obj instanceof $b4d780b9045f617e$var$Subscriber || 'syncErrorThrowable' in obj && obj[$4THwh.rxSubscriber];
}

});
parcelRegister("6M1u7", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $4ee8609f89737ea0$export$f6e2535fb5126e54, (v) => $4ee8609f89737ea0$export$f6e2535fb5126e54 = v);
var $4ee8609f89737ea0$export$f6e2535fb5126e54;
"use strict";
function $4ee8609f89737ea0$var$isFunction(x) {
    return typeof x === 'function';
}
$4ee8609f89737ea0$export$f6e2535fb5126e54 = $4ee8609f89737ea0$var$isFunction;

});

parcelRegister("8IeZR", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $657e10d474c0c7f7$export$f55210826850c514, (v) => $657e10d474c0c7f7$export$f55210826850c514 = v);
var $657e10d474c0c7f7$export$f55210826850c514;
"use strict";

var $bHRhK = parcelRequire("bHRhK");

var $6q2tC = parcelRequire("6q2tC");

var $6M1u7 = parcelRequire("6M1u7");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $ljiaq = parcelRequire("ljiaq");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $657e10d474c0c7f7$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($6M1u7.isFunction(_unsubscribe)) {
            var trial = $fgwEQ.tryCatch(_unsubscribe).call(this);
            if (trial === $5C5Tt.errorObject) {
                hasErrors = true;
                errors = errors || ($5C5Tt.errorObject.e instanceof $ljiaq.UnsubscriptionError ? $657e10d474c0c7f7$var$flattenUnsubscriptionErrors($5C5Tt.errorObject.e.errors) : [
                    $5C5Tt.errorObject.e
                ]);
            }
        }
        if ($bHRhK.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($6q2tC.isObject(sub)) {
                    var trial = $fgwEQ.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $5C5Tt.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $5C5Tt.errorObject.e;
                        if (err instanceof $ljiaq.UnsubscriptionError) errors = errors.concat($657e10d474c0c7f7$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $ljiaq.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$657e10d474c0c7f7$export$f55210826850c514 = $657e10d474c0c7f7$var$Subscription;
function $657e10d474c0c7f7$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $ljiaq.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("bHRhK", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $885d0b379e8f9539$export$43bee75e5e14138e, (v) => $885d0b379e8f9539$export$43bee75e5e14138e = v);
var $885d0b379e8f9539$export$43bee75e5e14138e;
"use strict";
$885d0b379e8f9539$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("6q2tC", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $4ac7179f4b231318$export$a6cdc56e425d0d0a, (v) => $4ac7179f4b231318$export$a6cdc56e425d0d0a = v);
var $4ac7179f4b231318$export$a6cdc56e425d0d0a;
"use strict";
function $4ac7179f4b231318$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$4ac7179f4b231318$export$a6cdc56e425d0d0a = $4ac7179f4b231318$var$isObject;

});

parcelRegister("fgwEQ", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $b1d1aecb6d7689b0$export$d234c058d1d4e435, (v) => $b1d1aecb6d7689b0$export$d234c058d1d4e435 = v);
var $b1d1aecb6d7689b0$export$d234c058d1d4e435;
"use strict";

var $5C5Tt = parcelRequire("5C5Tt");
var $b1d1aecb6d7689b0$var$tryCatchTarget;
function $b1d1aecb6d7689b0$var$tryCatcher() {
    try {
        return $b1d1aecb6d7689b0$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $5C5Tt.errorObject.e = e;
        return $5C5Tt.errorObject;
    }
}
function $b1d1aecb6d7689b0$var$tryCatch(fn) {
    $b1d1aecb6d7689b0$var$tryCatchTarget = fn;
    return $b1d1aecb6d7689b0$var$tryCatcher;
}
$b1d1aecb6d7689b0$export$d234c058d1d4e435 = $b1d1aecb6d7689b0$var$tryCatch;

});
parcelRegister("5C5Tt", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $416512bed89c0183$export$fc504b39d7c1176, (v) => $416512bed89c0183$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $416512bed89c0183$export$fc504b39d7c1176;
"use strict";
$416512bed89c0183$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("ljiaq", function(module, exports) {
"use strict";
var $f83976ea1e7a871f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $f83976ea1e7a871f$var$UnsubscriptionError = function(_super) {
    $f83976ea1e7a871f$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $f83976ea1e7a871f$var$UnsubscriptionError;

});


parcelRegister("j4bjR", function(module, exports) {
$parcel$export(module.exports, "empty", () => $de172bd3eddba47a$export$6e22c362a0406a2c, (v) => $de172bd3eddba47a$export$6e22c362a0406a2c = v);
var $de172bd3eddba47a$export$6e22c362a0406a2c;
"use strict";
$de172bd3eddba47a$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("4THwh", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $390e0e8eca50ca62$export$77f77496d7cade10, (v) => $390e0e8eca50ca62$export$77f77496d7cade10 = v);
var $390e0e8eca50ca62$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $390e0e8eca50ca62$export$4a2e07ff24d010f0;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
var $390e0e8eca50ca62$var$Symbol = $4xUKK.root.Symbol;
$390e0e8eca50ca62$export$77f77496d7cade10 = typeof $390e0e8eca50ca62$var$Symbol === 'function' && typeof $390e0e8eca50ca62$var$Symbol.for === 'function' ? $390e0e8eca50ca62$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$390e0e8eca50ca62$export$4a2e07ff24d010f0 = $390e0e8eca50ca62$export$77f77496d7cade10;

});



parcelRegister("kdmZ2", function(module, exports) {
$parcel$export(module.exports, "observable", () => $eb76d9954b2939f2$export$5ab46cbf6120b33a, (v) => $eb76d9954b2939f2$export$5ab46cbf6120b33a = v);
var $eb76d9954b2939f2$export$7e68bb2e8ecea8fe;
var $eb76d9954b2939f2$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $eb76d9954b2939f2$export$a7c40509ff863847;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
function $eb76d9954b2939f2$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$eb76d9954b2939f2$export$7e68bb2e8ecea8fe = $eb76d9954b2939f2$var$getSymbolObservable;
$eb76d9954b2939f2$export$5ab46cbf6120b33a = $eb76d9954b2939f2$var$getSymbolObservable($4xUKK.root);
$eb76d9954b2939f2$export$a7c40509ff863847 = $eb76d9954b2939f2$export$5ab46cbf6120b33a;

});

parcelRegister("favZu", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $b0b09ae52d59f8b8$export$a4627e546088548d, (v) => $b0b09ae52d59f8b8$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $b0b09ae52d59f8b8$export$71f88a61afaa14d7, (v) => $b0b09ae52d59f8b8$export$71f88a61afaa14d7 = v);
var $b0b09ae52d59f8b8$export$a4627e546088548d;
var $b0b09ae52d59f8b8$export$71f88a61afaa14d7;
"use strict";

var $6EUcf = parcelRequire("6EUcf");
/* tslint:enable:max-line-length */ function $b0b09ae52d59f8b8$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $b0b09ae52d59f8b8$var$pipeFromArray(fns);
}
$b0b09ae52d59f8b8$export$a4627e546088548d = $b0b09ae52d59f8b8$var$pipe;
/* @internal */ function $b0b09ae52d59f8b8$var$pipeFromArray(fns) {
    if (!fns) return $6EUcf.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$b0b09ae52d59f8b8$export$71f88a61afaa14d7 = $b0b09ae52d59f8b8$var$pipeFromArray;

});
parcelRegister("6EUcf", function(module, exports) {
$parcel$export(module.exports, "noop", () => $4d9211faf5e0b60b$export$8793edee2d425525, (v) => $4d9211faf5e0b60b$export$8793edee2d425525 = v);
var $4d9211faf5e0b60b$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $4d9211faf5e0b60b$var$noop() {}
$4d9211faf5e0b60b$export$8793edee2d425525 = $4d9211faf5e0b60b$var$noop;

});



parcelRegister("a3Wd7", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => (parcelRequire("b2AyF")).createBrowserHistory);
$parcel$export(module.exports, "createMemoryHistory", () => (parcelRequire("b2AyF")).createMemoryHistory);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("klylS")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("2drpp")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("dpoZ0")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("lJu6R")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("6FZlb")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("7lAXH")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("8whFx")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("7tc2B")).withRouter);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("3iZvk")).RouteComponent);
$parcel$export(module.exports, "Link", () => (parcelRequire("hi8gb")).default);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("fkBli")).generatePath);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("iKMBk")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("iKMBk")).useRouterStoreActions);
$parcel$export(module.exports, "createResource", () => (parcelRequire("fOvEc")).createResource);
$parcel$export(module.exports, "useResource", () => (parcelRequire("VTASg")).useResource);

var $b2AyF = parcelRequire("b2AyF");
parcelRequire("7FXXp");
var $klylS = parcelRequire("klylS");
var $2drpp = parcelRequire("2drpp");
var $dpoZ0 = parcelRequire("dpoZ0");
var $lJu6R = parcelRequire("lJu6R");
var $6FZlb = parcelRequire("6FZlb");
var $7lAXH = parcelRequire("7lAXH");
var $8whFx = parcelRequire("8whFx");
var $7tc2B = parcelRequire("7tc2B");
parcelRequire("j2ICI");
var $hi8gb = parcelRequire("hi8gb");
var $3iZvk = parcelRequire("3iZvk");
parcelRequire("b2RKK");
var $fkBli = parcelRequire("fkBli");

var $glIdA = parcelRequire("glIdA");

var $iKMBk = parcelRequire("iKMBk");

var $1YR7Y = parcelRequire("1YR7Y");
parcelRequire("lmYMP");
var $fOvEc = parcelRequire("fOvEc");
var $VTASg = parcelRequire("VTASg");

});
parcelRegister("b2AyF", function(module, exports) {
$parcel$export(module.exports, "parsePath", () => $809c3d4b13995ca3$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createPath", () => $809c3d4b13995ca3$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $809c3d4b13995ca3$export$90c043f1c57770b8);
$parcel$export(module.exports, "createBrowserHistory", () => $809c3d4b13995ca3$export$719fc203c4e16dee);
$parcel$export(module.exports, "createMemoryHistory", () => $809c3d4b13995ca3$export$2b76ad033c6e6d08);

var $hHCeM = parcelRequire("hHCeM");

var $aZfUL = parcelRequire("aZfUL");

var $bweo1 = parcelRequire("bweo1");


var $DNksS = parcelRequire("DNksS");
function $809c3d4b13995ca3$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $809c3d4b13995ca3$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $809c3d4b13995ca3$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $809c3d4b13995ca3$var$stripBasename(path, prefix) {
    return $809c3d4b13995ca3$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $809c3d4b13995ca3$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $809c3d4b13995ca3$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $809c3d4b13995ca3$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $809c3d4b13995ca3$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $809c3d4b13995ca3$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $hHCeM.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $aZfUL.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $809c3d4b13995ca3$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $bweo1.default)(a.state, b.state);
}
function $809c3d4b13995ca3$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $809c3d4b13995ca3$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $809c3d4b13995ca3$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $809c3d4b13995ca3$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $809c3d4b13995ca3$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $809c3d4b13995ca3$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $809c3d4b13995ca3$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $809c3d4b13995ca3$var$PopStateEvent = 'popstate';
var $809c3d4b13995ca3$var$HashChangeEvent = 'hashchange';
function $809c3d4b13995ca3$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $809c3d4b13995ca3$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$809c3d4b13995ca3$var$canUseDOM && (0, $DNksS.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $809c3d4b13995ca3$var$supportsHistory();
    var needsHashChangeListener = !$809c3d4b13995ca3$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $809c3d4b13995ca3$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $809c3d4b13995ca3$var$stripTrailingSlash($809c3d4b13995ca3$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $809c3d4b13995ca3$var$stripBasename(path, basename);
        return $809c3d4b13995ca3$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $809c3d4b13995ca3$var$createTransitionManager();
    function setState(nextState) {
        (0, $hHCeM.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($809c3d4b13995ca3$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($809c3d4b13995ca3$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($809c3d4b13995ca3$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $809c3d4b13995ca3$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $809c3d4b13995ca3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $809c3d4b13995ca3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($809c3d4b13995ca3$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($809c3d4b13995ca3$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($809c3d4b13995ca3$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($809c3d4b13995ca3$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $809c3d4b13995ca3$var$HashChangeEvent$1 = 'hashchange';
var $809c3d4b13995ca3$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $809c3d4b13995ca3$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $809c3d4b13995ca3$var$stripLeadingSlash,
        decodePath: $809c3d4b13995ca3$var$addLeadingSlash
    },
    slash: {
        encodePath: $809c3d4b13995ca3$var$addLeadingSlash,
        decodePath: $809c3d4b13995ca3$var$addLeadingSlash
    }
};
function $809c3d4b13995ca3$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $809c3d4b13995ca3$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $809c3d4b13995ca3$var$pushHashPath(path) {
    window.location.hash = path;
}
function $809c3d4b13995ca3$var$replaceHashPath(path) {
    window.location.replace($809c3d4b13995ca3$var$stripHash(window.location.href) + '#' + path);
}
function $809c3d4b13995ca3$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$809c3d4b13995ca3$var$canUseDOM && (0, $DNksS.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $809c3d4b13995ca3$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $809c3d4b13995ca3$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $809c3d4b13995ca3$var$stripTrailingSlash($809c3d4b13995ca3$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $809c3d4b13995ca3$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($809c3d4b13995ca3$var$getHashPath());
        if (basename) path = $809c3d4b13995ca3$var$stripBasename(path, basename);
        return $809c3d4b13995ca3$export$90c043f1c57770b8(path);
    }
    var transitionManager = $809c3d4b13995ca3$var$createTransitionManager();
    function setState(nextState) {
        (0, $hHCeM.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $809c3d4b13995ca3$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $809c3d4b13995ca3$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $809c3d4b13995ca3$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($809c3d4b13995ca3$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($809c3d4b13995ca3$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $809c3d4b13995ca3$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $809c3d4b13995ca3$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $809c3d4b13995ca3$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $809c3d4b13995ca3$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $809c3d4b13995ca3$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $809c3d4b13995ca3$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $809c3d4b13995ca3$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $809c3d4b13995ca3$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $809c3d4b13995ca3$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($809c3d4b13995ca3$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $809c3d4b13995ca3$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $809c3d4b13995ca3$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $809c3d4b13995ca3$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $809c3d4b13995ca3$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($809c3d4b13995ca3$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($809c3d4b13995ca3$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($809c3d4b13995ca3$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $809c3d4b13995ca3$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $809c3d4b13995ca3$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $809c3d4b13995ca3$var$createTransitionManager();
    function setState(nextState) {
        (0, $hHCeM.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $809c3d4b13995ca3$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $809c3d4b13995ca3$export$90c043f1c57770b8(entry, undefined, createKey()) : $809c3d4b13995ca3$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $809c3d4b13995ca3$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $809c3d4b13995ca3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $809c3d4b13995ca3$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $809c3d4b13995ca3$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("hHCeM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce341cfac90127fb$export$2e2bcd8739ae039);
function $ce341cfac90127fb$export$2e2bcd8739ae039() {
    return $ce341cfac90127fb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce341cfac90127fb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("aZfUL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ffbf2353b93e718$export$2e2bcd8739ae039);
function $7ffbf2353b93e718$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $7ffbf2353b93e718$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $7ffbf2353b93e718$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $7ffbf2353b93e718$var$isAbsolute(to);
    var isFromAbs = from && $7ffbf2353b93e718$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $7ffbf2353b93e718$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $7ffbf2353b93e718$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $7ffbf2353b93e718$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $7ffbf2353b93e718$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$7ffbf2353b93e718$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $7ffbf2353b93e718$export$2e2bcd8739ae039 = $7ffbf2353b93e718$var$resolvePathname;

});

parcelRegister("bweo1", function(module, exports) {
$parcel$export(module.exports, "default", () => $862dd7b43b5ee967$export$2e2bcd8739ae039);
function $862dd7b43b5ee967$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $862dd7b43b5ee967$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $862dd7b43b5ee967$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $862dd7b43b5ee967$var$valueOf(a);
        var bValue = $862dd7b43b5ee967$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $862dd7b43b5ee967$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $862dd7b43b5ee967$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $862dd7b43b5ee967$export$2e2bcd8739ae039 = $862dd7b43b5ee967$var$valueEqual;

});

parcelRegister("DNksS", function(module, exports) {
$parcel$export(module.exports, "default", () => $0779e85c22e63e9f$export$2e2bcd8739ae039);
var $0779e85c22e63e9f$var$isProduction = true;
var $0779e85c22e63e9f$var$prefix = 'Invariant failed';
function $0779e85c22e63e9f$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($0779e85c22e63e9f$var$isProduction) throw new Error($0779e85c22e63e9f$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($0779e85c22e63e9f$var$prefix, ": ").concat(provided) : $0779e85c22e63e9f$var$prefix;
    throw new Error(value);
}

});


parcelRegister("7FXXp", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => (parcelRequire("klylS")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("2drpp")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("dpoZ0")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("lJu6R")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("6FZlb")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("7lAXH")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("8whFx")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("7tc2B")).withRouter);

var $klylS = parcelRequire("klylS");

var $2drpp = parcelRequire("2drpp");

var $muw86 = parcelRequire("muw86");

var $dpoZ0 = parcelRequire("dpoZ0");

var $iKMBk = parcelRequire("iKMBk");

var $lJu6R = parcelRequire("lJu6R");

var $6FZlb = parcelRequire("6FZlb");

var $7lAXH = parcelRequire("7lAXH");

var $8whFx = parcelRequire("8whFx");

var $7tc2B = parcelRequire("7tc2B");

});
parcelRegister("klylS", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $ed006a62d2bfed5f$export$2d8d895a0a0f636e);

var $hHCeM = parcelRequire("hHCeM");

var $bD5s2 = parcelRequire("bD5s2");

var $b2AyF = parcelRequire("b2AyF");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("b2RKK");
var $li4LR = parcelRequire("li4LR");

var $7lAXH = parcelRequire("7lAXH");
class $ed006a62d2bfed5f$var$Redirector extends (0, $fc4bM.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $b2AyF.createPath)((0, $li4LR.generateLocationFromPath)(to.path, routeAttributes)) : (0, $b2AyF.createPath)(to) : to;
        const currentPath = (0, $b2AyF.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $bD5s2.default)($ed006a62d2bfed5f$var$Redirector, "defaultProps", {
    push: false
});
const $ed006a62d2bfed5f$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $7lAXH.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ed006a62d2bfed5f$var$Redirector, (0, $hHCeM.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("bD5s2", function(module, exports) {
$parcel$export(module.exports, "default", () => $877790ba5d7a9039$export$2e2bcd8739ae039);

var $85rQ1 = parcelRequire("85rQ1");
function $877790ba5d7a9039$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $85rQ1.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("85rQ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e34626583e478e6$export$2e2bcd8739ae039);

var $6XyXV = parcelRequire("6XyXV");

var $7dzzs = parcelRequire("7dzzs");
function $5e34626583e478e6$export$2e2bcd8739ae039(t) {
    var i = (0, $7dzzs.default)(t, "string");
    return "symbol" == (0, $6XyXV.default)(i) ? i : i + "";
}

});
parcelRegister("7dzzs", function(module, exports) {
$parcel$export(module.exports, "default", () => $015b2ed2535004f6$export$2e2bcd8739ae039);

var $6XyXV = parcelRequire("6XyXV");
function $015b2ed2535004f6$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6XyXV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6XyXV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("b2RKK", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("li4LR")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("fkBli")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("9Uvsu")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("jiIap")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("jAYcL")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("jAYcL")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("irKLf")).isSameRouteMatch);

var $l3Fyf = parcelRequire("l3Fyf");

var $li4LR = parcelRequire("li4LR");

var $fkBli = parcelRequire("fkBli");

var $9Uvsu = parcelRequire("9Uvsu");

var $jiIap = parcelRequire("jiIap");

var $jAYcL = parcelRequire("jAYcL");

var $irKLf = parcelRequire("irKLf");

});
parcelRegister("l3Fyf", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $f54a1c00a576e87b$export$883c3f3b6c000133);

var $hHCeM = parcelRequire("hHCeM");

var $b2AyF = parcelRequire("b2AyF");

var $pkMey = parcelRequire("pkMey");

var $ip10O = parcelRequire("ip10O");
const $f54a1c00a576e87b$var$hasWindow = ()=>typeof window !== 'undefined';
const $f54a1c00a576e87b$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ip10O)))
};
const $f54a1c00a576e87b$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $f54a1c00a576e87b$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $f54a1c00a576e87b$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($pkMey)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $f54a1c00a576e87b$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $f54a1c00a576e87b$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $f54a1c00a576e87b$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $hHCeM.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $f54a1c00a576e87b$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $f54a1c00a576e87b$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $b2AyF.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $b2AyF.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $f54a1c00a576e87b$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
        createHref: (location)=>(0, $b2AyF.createPath)(location)
    } : $f54a1c00a576e87b$var$methodsPlaceholders);
};

});
parcelRegister("pkMey", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $04c273c95452af12$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $04c273c95452af12$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $04c273c95452af12$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $04c273c95452af12$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $04c273c95452af12$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $04c273c95452af12$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $04c273c95452af12$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $04c273c95452af12$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $04c273c95452af12$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $04c273c95452af12$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $04c273c95452af12$var$root = $04c273c95452af12$var$freeGlobal || $04c273c95452af12$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $04c273c95452af12$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $04c273c95452af12$var$objectToString = $04c273c95452af12$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $04c273c95452af12$var$nativeMax = Math.max, $04c273c95452af12$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $04c273c95452af12$var$now = function() {
    return $04c273c95452af12$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $04c273c95452af12$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($04c273c95452af12$var$FUNC_ERROR_TEXT);
    wait = $04c273c95452af12$var$toNumber(wait) || 0;
    if ($04c273c95452af12$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $04c273c95452af12$var$nativeMax($04c273c95452af12$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $04c273c95452af12$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $04c273c95452af12$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($04c273c95452af12$var$now());
    }
    function debounced() {
        var time = $04c273c95452af12$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $04c273c95452af12$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $04c273c95452af12$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $04c273c95452af12$var$isSymbol(value) {
    return typeof value == 'symbol' || $04c273c95452af12$var$isObjectLike(value) && $04c273c95452af12$var$objectToString.call(value) == $04c273c95452af12$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $04c273c95452af12$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($04c273c95452af12$var$isSymbol(value)) return $04c273c95452af12$var$NAN;
    if ($04c273c95452af12$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $04c273c95452af12$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($04c273c95452af12$var$reTrim, '');
    var isBinary = $04c273c95452af12$var$reIsBinary.test(value);
    return isBinary || $04c273c95452af12$var$reIsOctal.test(value) ? $04c273c95452af12$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $04c273c95452af12$var$reIsBadHex.test(value) ? $04c273c95452af12$var$NAN : +value;
}
module.exports = $04c273c95452af12$var$debounce;

});

parcelRegister("ip10O", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $d65b58c588a79948$var$noop() {
// No operation performed.
}
module.exports = $d65b58c588a79948$var$noop;

});


parcelRegister("li4LR", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $f7fefacf6cb27003$export$37e0729cc751960b);

var $bWOto = parcelRequire("bWOto");

var $5AACw = parcelRequire("5AACw");
function $f7fefacf6cb27003$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5AACw.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $bWOto.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("bWOto", function(module, exports) {
$parcel$export(module.exports, "compile", () => $8b2c435f6df06f1c$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $8b2c435f6df06f1c$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $8b2c435f6df06f1c$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $8b2c435f6df06f1c$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $8b2c435f6df06f1c$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($8b2c435f6df06f1c$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($8b2c435f6df06f1c$var$escapeString(prevText), ")[^").concat($8b2c435f6df06f1c$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $8b2c435f6df06f1c$export$ef7acd7185315e22(str, options) {
    return $8b2c435f6df06f1c$export$5b9bad9e403cf3d9($8b2c435f6df06f1c$export$98e6a39c04603d36(str, options), options);
}
function $8b2c435f6df06f1c$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $8b2c435f6df06f1c$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $8b2c435f6df06f1c$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $8b2c435f6df06f1c$export$71304158c7e35877(str, keys, options);
    return $8b2c435f6df06f1c$export$968e97c88708237a(re, keys, options);
}
function $8b2c435f6df06f1c$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $8b2c435f6df06f1c$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $8b2c435f6df06f1c$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $8b2c435f6df06f1c$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $8b2c435f6df06f1c$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $8b2c435f6df06f1c$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $8b2c435f6df06f1c$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $8b2c435f6df06f1c$var$stringToRegexp(path, keys, options) {
    return $8b2c435f6df06f1c$export$9a9303716def6456($8b2c435f6df06f1c$export$98e6a39c04603d36(path, options), keys, options);
}
function $8b2c435f6df06f1c$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($8b2c435f6df06f1c$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($8b2c435f6df06f1c$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $8b2c435f6df06f1c$var$escapeString(encode(token));
        else {
            var prefix = $8b2c435f6df06f1c$var$escapeString(encode(token.prefix));
            var suffix = $8b2c435f6df06f1c$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $8b2c435f6df06f1c$var$flags(options));
}
function $8b2c435f6df06f1c$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $8b2c435f6df06f1c$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $8b2c435f6df06f1c$var$arrayToRegexp(path, keys, options);
    return $8b2c435f6df06f1c$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("5AACw", function(module, exports) {
'use strict';

var $hjM0R = parcelRequire("hjM0R");

var $3v9jh = parcelRequire("3v9jh");
var $411cb8968b9a784a$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $411cb8968b9a784a$var$CRHTLF = /[\n\r\t]/g, $411cb8968b9a784a$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $411cb8968b9a784a$var$port = /:\d+$/, $411cb8968b9a784a$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $411cb8968b9a784a$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $411cb8968b9a784a$var$trimLeft(str) {
    return (str ? str : '').toString().replace($411cb8968b9a784a$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $411cb8968b9a784a$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $411cb8968b9a784a$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $411cb8968b9a784a$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $411cb8968b9a784a$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $411cb8968b9a784a$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $411cb8968b9a784a$var$Url(loc, {});
        for(key in $411cb8968b9a784a$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $411cb8968b9a784a$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $411cb8968b9a784a$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $411cb8968b9a784a$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $411cb8968b9a784a$var$extractProtocol(address, location) {
    address = $411cb8968b9a784a$var$trimLeft(address);
    address = address.replace($411cb8968b9a784a$var$CRHTLF, '');
    location = location || {};
    var match = $411cb8968b9a784a$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($411cb8968b9a784a$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $411cb8968b9a784a$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $411cb8968b9a784a$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $411cb8968b9a784a$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $411cb8968b9a784a$var$Url(address, location, parser) {
    address = $411cb8968b9a784a$var$trimLeft(address);
    address = address.replace($411cb8968b9a784a$var$CRHTLF, '');
    if (!(this instanceof $411cb8968b9a784a$var$Url)) return new $411cb8968b9a784a$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $411cb8968b9a784a$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $3v9jh.parse;
    location = $411cb8968b9a784a$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $411cb8968b9a784a$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $411cb8968b9a784a$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$411cb8968b9a784a$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $411cb8968b9a784a$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $411cb8968b9a784a$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$hjM0R(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $411cb8968b9a784a$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $411cb8968b9a784a$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $3v9jh.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$hjM0R(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($411cb8968b9a784a$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $411cb8968b9a784a$var$rules.length; i++){
        var ins = $411cb8968b9a784a$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $411cb8968b9a784a$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $411cb8968b9a784a$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $3v9jh.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $411cb8968b9a784a$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $411cb8968b9a784a$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $411cb8968b9a784a$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$411cb8968b9a784a$var$Url.prototype = {
    set: $411cb8968b9a784a$var$set,
    toString: $411cb8968b9a784a$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$411cb8968b9a784a$var$Url.extractProtocol = $411cb8968b9a784a$var$extractProtocol;
$411cb8968b9a784a$var$Url.location = $411cb8968b9a784a$var$lolcation;
$411cb8968b9a784a$var$Url.trimLeft = $411cb8968b9a784a$var$trimLeft;
$411cb8968b9a784a$var$Url.qs = $3v9jh;
module.exports = $411cb8968b9a784a$var$Url;

});
parcelRegister("hjM0R", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("3v9jh", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $28cb7d1c2d936703$export$fac44ee5b035f737, (v) => $28cb7d1c2d936703$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $28cb7d1c2d936703$export$98e6a39c04603d36, (v) => $28cb7d1c2d936703$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $28cb7d1c2d936703$export$fac44ee5b035f737;
var $28cb7d1c2d936703$export$98e6a39c04603d36;
'use strict';
var $28cb7d1c2d936703$var$has = Object.prototype.hasOwnProperty, $28cb7d1c2d936703$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $28cb7d1c2d936703$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $28cb7d1c2d936703$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $28cb7d1c2d936703$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $28cb7d1c2d936703$var$decode(part[1]), value = $28cb7d1c2d936703$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $28cb7d1c2d936703$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($28cb7d1c2d936703$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $28cb7d1c2d936703$var$undef || isNaN(value))) value = '';
        key = $28cb7d1c2d936703$var$encode(key);
        value = $28cb7d1c2d936703$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$28cb7d1c2d936703$export$fac44ee5b035f737 = $28cb7d1c2d936703$var$querystringify;
$28cb7d1c2d936703$export$98e6a39c04603d36 = $28cb7d1c2d936703$var$querystring;

});



parcelRegister("fkBli", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $b295b0b9e71f9bc3$export$82476f982757e71e);

var $bWOto = parcelRequire("bWOto");
const $b295b0b9e71f9bc3$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $bWOto.compile)(pattern)(params);

});

parcelRegister("9Uvsu", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $7371bf0501a31321$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3jCFs = parcelRequire("3jCFs");
const $7371bf0501a31321$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $7371bf0501a31321$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3jCFs !== 'undefined' && $3jCFs.versions != null && $3jCFs.versions.node != null) return true;
    if ($7371bf0501a31321$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("jiIap", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $e0d1f562ad7fdd64$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $e0d1f562ad7fdd64$export$2e2bcd8739ae039);

var $5AACw = parcelRequire("5AACw");

var $2GVH7 = parcelRequire("2GVH7");

var $aueDd = parcelRequire("aueDd");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $e0d1f562ad7fdd64$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $5AACw.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $aueDd.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $2GVH7.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $aueDd.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $e0d1f562ad7fdd64$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$e0d1f562ad7fdd64$var$matchRoute(routes, pathname, queryParams, basePath);
const $e0d1f562ad7fdd64$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $e0d1f562ad7fdd64$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $e0d1f562ad7fdd64$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$e0d1f562ad7fdd64$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("2GVH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f5c41f57e549cd7$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");

var $gDF8j = parcelRequire("gDF8j");

var $cNdGP = parcelRequire("cNdGP");
/* This should match what react-router does to compute a root match. */ const $1f5c41f57e549cd7$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $1f5c41f57e549cd7$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $gDF8j.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $1f5c41f57e549cd7$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $cNdGP.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $hHCeM.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $1f5c41f57e549cd7$export$2e2bcd8739ae039 = $1f5c41f57e549cd7$var$execRouteMatching;

});
parcelRegister("gDF8j", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d03207f9b286a6$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $bWOto = parcelRequire("bWOto");
const $c1d03207f9b286a6$var$cache = {};
const $c1d03207f9b286a6$var$cacheLimit = 10000;
let $c1d03207f9b286a6$var$cacheCount = 0;
function $c1d03207f9b286a6$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $c1d03207f9b286a6$var$cache[cacheKey] || ($c1d03207f9b286a6$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $bWOto.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($c1d03207f9b286a6$var$cacheCount < $c1d03207f9b286a6$var$cacheLimit) {
        pathCache[path] = result;
        $c1d03207f9b286a6$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $c1d03207f9b286a6$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $c1d03207f9b286a6$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $c1d03207f9b286a6$export$2e2bcd8739ae039 = $c1d03207f9b286a6$var$matchPath;

});

parcelRegister("cNdGP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9504ae2153efd5bb$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $9504ae2153efd5bb$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $hHCeM.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $9504ae2153efd5bb$export$2e2bcd8739ae039 = $9504ae2153efd5bb$var$matchQuery;

});


parcelRegister("aueDd", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $7a280e3d9814b8d8$export$f594abf16a5ad948);
const $7a280e3d9814b8d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $7a280e3d9814b8d8$var$MAX_CACHE_SIZE = 1000;
function $7a280e3d9814b8d8$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$7a280e3d9814b8d8$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $7a280e3d9814b8d8$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($7a280e3d9814b8d8$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $7a280e3d9814b8d8$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $7a280e3d9814b8d8$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("jAYcL", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $e44014915997a8cd$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $e44014915997a8cd$export$a0bd0313cbeabd49);

var $5AACw = parcelRequire("5AACw");

var $1YR7Y = parcelRequire("1YR7Y");

var $fkBli = parcelRequire("fkBli");

var $jiIap = parcelRequire("jiIap");
const $e44014915997a8cd$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $fkBli.generatePath)(route.path, params);
    const matchedRoute = (0, $jiIap.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $1YR7Y.DEFAULT_MATCH),
        query: query
    };
};
const $e44014915997a8cd$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $5AACw.qs).parse(search);
    const matchedRoute = (0, $jiIap.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $1YR7Y.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $1YR7Y.DEFAULT_MATCH)
    };
};

});
parcelRegister("1YR7Y", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $17149b1471b92c2d$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $17149b1471b92c2d$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $17149b1471b92c2d$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $17149b1471b92c2d$export$fa440ddf675c8a93);

var $ip10O = parcelRequire("ip10O");

var $l3Fyf = parcelRequire("l3Fyf");
const $17149b1471b92c2d$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $17149b1471b92c2d$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $17149b1471b92c2d$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $17149b1471b92c2d$export$39607c9878cf5148 = (0, $l3Fyf.createLegacyHistory)();
const $17149b1471b92c2d$export$1515254c8c90bebb = {
    location: $17149b1471b92c2d$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O)))
};
const $17149b1471b92c2d$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("irKLf", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $d6df055c2d39a14c$export$5997e70fc4543270);
const $d6df055c2d39a14c$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $d6df055c2d39a14c$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $d6df055c2d39a14c$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $d6df055c2d39a14c$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("7lAXH", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $55972a6e40106ebb$export$9a302a45f65d0572);

var $iKMBk = parcelRequire("iKMBk");
const $55972a6e40106ebb$export$9a302a45f65d0572 = (0, $iKMBk.useRouterStore);

});
parcelRegister("iKMBk", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $da72390bf285860b$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $da72390bf285860b$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $da72390bf285860b$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $da72390bf285860b$export$ada49399abf7a3a1);

var $hHCeM = parcelRequire("hHCeM");

var $b2AyF = parcelRequire("b2AyF");

var $iOIqA = parcelRequire("iOIqA");
var $5nVr1 = parcelRequire("5nVr1");
var $ik3UL = parcelRequire("ik3UL");
var $ipn74 = parcelRequire("ipn74");
var $kMxBB = parcelRequire("kMxBB");

var $1YR7Y = parcelRequire("1YR7Y");
parcelRequire("b2RKK");
var $jAYcL = parcelRequire("jAYcL");
var $li4LR = parcelRequire("li4LR");
var $fkBli = parcelRequire("fkBli");
var $9Uvsu = parcelRequire("9Uvsu");
var $jiIap = parcelRequire("jiIap");

var $gV9Q4 = parcelRequire("gV9Q4");
const $da72390bf285860b$export$36d128238e6b60f5 = {
    action: (0, $1YR7Y.DEFAULT_ACTION),
    basePath: '',
    location: (0, $1YR7Y.DEFAULT_HISTORY).location,
    history: (0, $1YR7Y.DEFAULT_HISTORY),
    match: (0, $1YR7Y.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $1YR7Y.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $da72390bf285860b$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $jAYcL.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $hHCeM.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $9Uvsu.isServerEnvironment)()) dispatch($da72390bf285860b$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $jAYcL.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $gV9Q4.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iOIqA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $hHCeM.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $gV9Q4.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $gV9Q4.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $li4LR.generateLocationFromPath)(route.path, (0, $hHCeM.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $jiIap.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $gV9Q4.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $gV9Q4.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $li4LR.generateLocationFromPath)(route.path, (0, $hHCeM.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $jiIap.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $hHCeM.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $gV9Q4.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $gV9Q4.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $hHCeM.default)({}, existingPathParams, params);
            const updatedPath = (0, $fkBli.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $hHCeM.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $gV9Q4.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $gV9Q4.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $da72390bf285860b$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $gV9Q4.isExternalAbsolutePath)(path)) {
                const location = (0, $b2AyF.parsePath)((0, $gV9Q4.getRelativePath)(path, basePath));
                nextContext = (0, $jAYcL.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iOIqA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $da72390bf285860b$export$1cf0ecab63b1963c = (0, $ipn74.createStore)({
    initialState: $da72390bf285860b$export$36d128238e6b60f5,
    actions: $da72390bf285860b$var$actions,
    name: 'router'
});
const $da72390bf285860b$export$d6b817abe7a77ea5 = (0, $ik3UL.createContainer)($da72390bf285860b$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($da72390bf285860b$var$actions.bootstrapStore(props));
            !(0, $9Uvsu.isServerEnvironment)() && dispatch($da72390bf285860b$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $9Uvsu.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $da72390bf285860b$export$9569010eab09ae9e = (0, $5nVr1.createHook)($da72390bf285860b$export$1cf0ecab63b1963c);
const $da72390bf285860b$export$ada49399abf7a3a1 = (0, $5nVr1.createActionsHook)($da72390bf285860b$export$1cf0ecab63b1963c);
function $da72390bf285860b$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $5nVr1.createHook)($da72390bf285860b$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $da72390bf285860b$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $kMxBB.defaultRegistry).getStore($da72390bf285860b$export$1cf0ecab63b1963c);
const $da72390bf285860b$export$ebf37f7e180b13a9 = ()=>$da72390bf285860b$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("iOIqA", function(module, exports) {
$parcel$export(module.exports, "batch", () => $db2f5bf21243ff1b$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $bTkYf = parcelRequire("bTkYf");

var $h0ns1 = parcelRequire("h0ns1");

var $jlH1f = parcelRequire("jlH1f");

var $c8ckB = parcelRequire("c8ckB");
let $db2f5bf21243ff1b$var$isInsideBatchedSchedule = false;
function $db2f5bf21243ff1b$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $jlH1f.default).batchUpdates || !(0, $c8ckB.default).scheduling() || $db2f5bf21243ff1b$var$isInsideBatchedSchedule) return (0, $bTkYf.unstable_batchedUpdates)(fn);
    $db2f5bf21243ff1b$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $h0ns1.unstable_scheduleCallback)((0, $h0ns1.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $bTkYf.unstable_batchedUpdates)(fn);
        $db2f5bf21243ff1b$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("bTkYf", function(module, exports) {
'use strict';
function $8a85191b0793b675$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8a85191b0793b675$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8a85191b0793b675$var$checkDCE();

module.exports = (parcelRequire("kAtQE"));

});
parcelRegister("kAtQE", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $efce52b0925ca653$export$ae55be85d98224ed, (v) => $efce52b0925ca653$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $efce52b0925ca653$export$d39a5bbd09211389, (v) => $efce52b0925ca653$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $efce52b0925ca653$export$882461b6382ed46c, (v) => $efce52b0925ca653$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $efce52b0925ca653$export$466bfc07425424d5, (v) => $efce52b0925ca653$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $efce52b0925ca653$export$cd75ccfd720a3cd4, (v) => $efce52b0925ca653$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $efce52b0925ca653$export$fa8d919ba61d84db, (v) => $efce52b0925ca653$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $efce52b0925ca653$export$757ceba2d55c277e, (v) => $efce52b0925ca653$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $efce52b0925ca653$export$b3890eb0ae9dca99, (v) => $efce52b0925ca653$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $efce52b0925ca653$export$502457920280e6be, (v) => $efce52b0925ca653$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $efce52b0925ca653$export$c78a37762a8d58e1, (v) => $efce52b0925ca653$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $efce52b0925ca653$export$dc54d992c10e8a18, (v) => $efce52b0925ca653$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $efce52b0925ca653$export$83d89fbfd8236492, (v) => $efce52b0925ca653$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $efce52b0925ca653$export$ae55be85d98224ed;
var $efce52b0925ca653$export$d39a5bbd09211389;
var $efce52b0925ca653$export$882461b6382ed46c;
var $efce52b0925ca653$export$466bfc07425424d5;
var $efce52b0925ca653$export$cd75ccfd720a3cd4;
var $efce52b0925ca653$export$fa8d919ba61d84db;
var $efce52b0925ca653$export$757ceba2d55c277e;
var $efce52b0925ca653$export$b3890eb0ae9dca99;
var $efce52b0925ca653$export$502457920280e6be;
var $efce52b0925ca653$export$c78a37762a8d58e1;
var $efce52b0925ca653$export$dc54d992c10e8a18;
var $efce52b0925ca653$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $fc4bM = parcelRequire("fc4bM");

var $h0ns1 = parcelRequire("h0ns1");
function $efce52b0925ca653$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $efce52b0925ca653$var$da = new Set, $efce52b0925ca653$var$ea = {};
function $efce52b0925ca653$var$fa(a, b) {
    $efce52b0925ca653$var$ha(a, b);
    $efce52b0925ca653$var$ha(a + "Capture", b);
}
function $efce52b0925ca653$var$ha(a, b) {
    $efce52b0925ca653$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$efce52b0925ca653$var$da.add(b[a]);
}
var $efce52b0925ca653$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $efce52b0925ca653$var$ja = Object.prototype.hasOwnProperty, $efce52b0925ca653$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $efce52b0925ca653$var$la = {}, $efce52b0925ca653$var$ma = {};
function $efce52b0925ca653$var$na(a) {
    if ($efce52b0925ca653$var$ja.call($efce52b0925ca653$var$ma, a)) return !0;
    if ($efce52b0925ca653$var$ja.call($efce52b0925ca653$var$la, a)) return !1;
    if ($efce52b0925ca653$var$ka.test(a)) return $efce52b0925ca653$var$ma[a] = !0;
    $efce52b0925ca653$var$la[a] = !0;
    return !1;
}
function $efce52b0925ca653$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $efce52b0925ca653$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $efce52b0925ca653$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $efce52b0925ca653$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $efce52b0925ca653$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $efce52b0925ca653$var$t[b] = new $efce52b0925ca653$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $efce52b0925ca653$var$ra = /[\-:]([a-z])/g;
function $efce52b0925ca653$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($efce52b0925ca653$var$ra, $efce52b0925ca653$var$ta);
    $efce52b0925ca653$var$t[b] = new $efce52b0925ca653$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($efce52b0925ca653$var$ra, $efce52b0925ca653$var$ta);
    $efce52b0925ca653$var$t[b] = new $efce52b0925ca653$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($efce52b0925ca653$var$ra, $efce52b0925ca653$var$ta);
    $efce52b0925ca653$var$t[b] = new $efce52b0925ca653$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$efce52b0925ca653$var$t.xlinkHref = new $efce52b0925ca653$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $efce52b0925ca653$var$t[a] = new $efce52b0925ca653$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $efce52b0925ca653$var$ua(a, b, c, d) {
    var e = $efce52b0925ca653$var$t.hasOwnProperty(b) ? $efce52b0925ca653$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $efce52b0925ca653$var$pa(b, c, e, d) && (c = null), d || null === e ? $efce52b0925ca653$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $efce52b0925ca653$var$va = $fc4bM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $efce52b0925ca653$var$wa = Symbol.for("react.element"), $efce52b0925ca653$var$xa = Symbol.for("react.portal"), $efce52b0925ca653$var$ya = Symbol.for("react.fragment"), $efce52b0925ca653$var$za = Symbol.for("react.strict_mode"), $efce52b0925ca653$var$Aa = Symbol.for("react.profiler"), $efce52b0925ca653$var$Ba = Symbol.for("react.provider"), $efce52b0925ca653$var$Ca = Symbol.for("react.context"), $efce52b0925ca653$var$Da = Symbol.for("react.forward_ref"), $efce52b0925ca653$var$Ea = Symbol.for("react.suspense"), $efce52b0925ca653$var$Fa = Symbol.for("react.suspense_list"), $efce52b0925ca653$var$Ga = Symbol.for("react.memo"), $efce52b0925ca653$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $efce52b0925ca653$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $efce52b0925ca653$var$Ja = Symbol.iterator;
function $efce52b0925ca653$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $efce52b0925ca653$var$Ja && a[$efce52b0925ca653$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $efce52b0925ca653$var$u = Object.assign, $efce52b0925ca653$var$La;
function $efce52b0925ca653$var$Ma(a) {
    if (void 0 === $efce52b0925ca653$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $efce52b0925ca653$var$La = b && b[1] || "";
    }
    return "\n" + $efce52b0925ca653$var$La + a;
}
var $efce52b0925ca653$var$Na = !1;
function $efce52b0925ca653$var$Oa(a, b) {
    if (!a || $efce52b0925ca653$var$Na) return "";
    $efce52b0925ca653$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $efce52b0925ca653$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $efce52b0925ca653$var$Ma(a) : "";
}
function $efce52b0925ca653$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $efce52b0925ca653$var$Ma(a.type);
        case 16:
            return $efce52b0925ca653$var$Ma("Lazy");
        case 13:
            return $efce52b0925ca653$var$Ma("Suspense");
        case 19:
            return $efce52b0925ca653$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $efce52b0925ca653$var$Oa(a.type, !1), a;
        case 11:
            return a = $efce52b0925ca653$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $efce52b0925ca653$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $efce52b0925ca653$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $efce52b0925ca653$var$ya:
            return "Fragment";
        case $efce52b0925ca653$var$xa:
            return "Portal";
        case $efce52b0925ca653$var$Aa:
            return "Profiler";
        case $efce52b0925ca653$var$za:
            return "StrictMode";
        case $efce52b0925ca653$var$Ea:
            return "Suspense";
        case $efce52b0925ca653$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $efce52b0925ca653$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $efce52b0925ca653$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $efce52b0925ca653$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $efce52b0925ca653$var$Ga:
            return b = a.displayName || null, null !== b ? b : $efce52b0925ca653$var$Qa(a.type) || "Memo";
        case $efce52b0925ca653$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $efce52b0925ca653$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $efce52b0925ca653$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $efce52b0925ca653$var$Qa(b);
        case 8:
            return b === $efce52b0925ca653$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $efce52b0925ca653$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $efce52b0925ca653$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $efce52b0925ca653$var$Ua(a) {
    var b = $efce52b0925ca653$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $efce52b0925ca653$var$Va(a) {
    a._valueTracker || (a._valueTracker = $efce52b0925ca653$var$Ua(a));
}
function $efce52b0925ca653$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $efce52b0925ca653$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $efce52b0925ca653$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $efce52b0925ca653$var$Ya(a, b) {
    var c = b.checked;
    return $efce52b0925ca653$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $efce52b0925ca653$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $efce52b0925ca653$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $efce52b0925ca653$var$$a(a, b) {
    b = b.checked;
    null != b && $efce52b0925ca653$var$ua(a, "checked", b, !1);
}
function $efce52b0925ca653$var$ab(a, b) {
    $efce52b0925ca653$var$$a(a, b);
    var c = $efce52b0925ca653$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $efce52b0925ca653$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $efce52b0925ca653$var$bb(a, b.type, $efce52b0925ca653$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $efce52b0925ca653$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $efce52b0925ca653$var$bb(a, b, c) {
    if ("number" !== b || $efce52b0925ca653$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $efce52b0925ca653$var$db = Array.isArray;
function $efce52b0925ca653$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $efce52b0925ca653$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $efce52b0925ca653$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($efce52b0925ca653$var$p(91));
    return $efce52b0925ca653$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $efce52b0925ca653$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($efce52b0925ca653$var$p(92));
            if ($efce52b0925ca653$var$db(c)) {
                if (1 < c.length) throw Error($efce52b0925ca653$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $efce52b0925ca653$var$Sa(c)
    };
}
function $efce52b0925ca653$var$hb(a, b) {
    var c = $efce52b0925ca653$var$Sa(b.value), d = $efce52b0925ca653$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $efce52b0925ca653$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $efce52b0925ca653$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $efce52b0925ca653$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $efce52b0925ca653$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $efce52b0925ca653$var$mb, $efce52b0925ca653$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $efce52b0925ca653$var$mb = $efce52b0925ca653$var$mb || document.createElement("div");
        $efce52b0925ca653$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $efce52b0925ca653$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $efce52b0925ca653$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $efce52b0925ca653$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $efce52b0925ca653$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($efce52b0925ca653$var$pb).forEach(function(a) {
    $efce52b0925ca653$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $efce52b0925ca653$var$pb[b] = $efce52b0925ca653$var$pb[a];
    });
});
function $efce52b0925ca653$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $efce52b0925ca653$var$pb.hasOwnProperty(a) && $efce52b0925ca653$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $efce52b0925ca653$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $efce52b0925ca653$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $efce52b0925ca653$var$tb = $efce52b0925ca653$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $efce52b0925ca653$var$ub(a, b) {
    if (b) {
        if ($efce52b0925ca653$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($efce52b0925ca653$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($efce52b0925ca653$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($efce52b0925ca653$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($efce52b0925ca653$var$p(62));
    }
}
function $efce52b0925ca653$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $efce52b0925ca653$var$wb = null;
function $efce52b0925ca653$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $efce52b0925ca653$var$yb = null, $efce52b0925ca653$var$zb = null, $efce52b0925ca653$var$Ab = null;
function $efce52b0925ca653$var$Bb(a) {
    if (a = $efce52b0925ca653$var$Cb(a)) {
        if ("function" !== typeof $efce52b0925ca653$var$yb) throw Error($efce52b0925ca653$var$p(280));
        var b = a.stateNode;
        b && (b = $efce52b0925ca653$var$Db(b), $efce52b0925ca653$var$yb(a.stateNode, a.type, b));
    }
}
function $efce52b0925ca653$var$Eb(a) {
    $efce52b0925ca653$var$zb ? $efce52b0925ca653$var$Ab ? $efce52b0925ca653$var$Ab.push(a) : $efce52b0925ca653$var$Ab = [
        a
    ] : $efce52b0925ca653$var$zb = a;
}
function $efce52b0925ca653$var$Fb() {
    if ($efce52b0925ca653$var$zb) {
        var a = $efce52b0925ca653$var$zb, b = $efce52b0925ca653$var$Ab;
        $efce52b0925ca653$var$Ab = $efce52b0925ca653$var$zb = null;
        $efce52b0925ca653$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$efce52b0925ca653$var$Bb(b[a]);
    }
}
function $efce52b0925ca653$var$Gb(a, b) {
    return a(b);
}
function $efce52b0925ca653$var$Hb() {}
var $efce52b0925ca653$var$Ib = !1;
function $efce52b0925ca653$var$Jb(a, b, c) {
    if ($efce52b0925ca653$var$Ib) return a(b, c);
    $efce52b0925ca653$var$Ib = !0;
    try {
        return $efce52b0925ca653$var$Gb(a, b, c);
    } finally{
        if ($efce52b0925ca653$var$Ib = !1, null !== $efce52b0925ca653$var$zb || null !== $efce52b0925ca653$var$Ab) $efce52b0925ca653$var$Hb(), $efce52b0925ca653$var$Fb();
    }
}
function $efce52b0925ca653$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $efce52b0925ca653$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($efce52b0925ca653$var$p(231, b, typeof c));
    return c;
}
var $efce52b0925ca653$var$Lb = !1;
if ($efce52b0925ca653$var$ia) try {
    var $efce52b0925ca653$var$Mb = {};
    Object.defineProperty($efce52b0925ca653$var$Mb, "passive", {
        get: function() {
            $efce52b0925ca653$var$Lb = !0;
        }
    });
    window.addEventListener("test", $efce52b0925ca653$var$Mb, $efce52b0925ca653$var$Mb);
    window.removeEventListener("test", $efce52b0925ca653$var$Mb, $efce52b0925ca653$var$Mb);
} catch (a) {
    $efce52b0925ca653$var$Lb = !1;
}
function $efce52b0925ca653$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $efce52b0925ca653$var$Ob = !1, $efce52b0925ca653$var$Pb = null, $efce52b0925ca653$var$Qb = !1, $efce52b0925ca653$var$Rb = null, $efce52b0925ca653$var$Sb = {
    onError: function(a) {
        $efce52b0925ca653$var$Ob = !0;
        $efce52b0925ca653$var$Pb = a;
    }
};
function $efce52b0925ca653$var$Tb(a, b, c, d, e, f, g, h, k) {
    $efce52b0925ca653$var$Ob = !1;
    $efce52b0925ca653$var$Pb = null;
    $efce52b0925ca653$var$Nb.apply($efce52b0925ca653$var$Sb, arguments);
}
function $efce52b0925ca653$var$Ub(a, b, c, d, e, f, g, h, k) {
    $efce52b0925ca653$var$Tb.apply(this, arguments);
    if ($efce52b0925ca653$var$Ob) {
        if ($efce52b0925ca653$var$Ob) {
            var l = $efce52b0925ca653$var$Pb;
            $efce52b0925ca653$var$Ob = !1;
            $efce52b0925ca653$var$Pb = null;
        } else throw Error($efce52b0925ca653$var$p(198));
        $efce52b0925ca653$var$Qb || ($efce52b0925ca653$var$Qb = !0, $efce52b0925ca653$var$Rb = l);
    }
}
function $efce52b0925ca653$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $efce52b0925ca653$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $efce52b0925ca653$var$Xb(a) {
    if ($efce52b0925ca653$var$Vb(a) !== a) throw Error($efce52b0925ca653$var$p(188));
}
function $efce52b0925ca653$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $efce52b0925ca653$var$Vb(a);
        if (null === b) throw Error($efce52b0925ca653$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $efce52b0925ca653$var$Xb(e), a;
                if (f === d) return $efce52b0925ca653$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($efce52b0925ca653$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($efce52b0925ca653$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($efce52b0925ca653$var$p(190));
    }
    if (3 !== c.tag) throw Error($efce52b0925ca653$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $efce52b0925ca653$var$Zb(a) {
    a = $efce52b0925ca653$var$Yb(a);
    return null !== a ? $efce52b0925ca653$var$$b(a) : null;
}
function $efce52b0925ca653$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $efce52b0925ca653$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $efce52b0925ca653$var$ac = $h0ns1.unstable_scheduleCallback, $efce52b0925ca653$var$bc = $h0ns1.unstable_cancelCallback, $efce52b0925ca653$var$cc = $h0ns1.unstable_shouldYield, $efce52b0925ca653$var$dc = $h0ns1.unstable_requestPaint, $efce52b0925ca653$var$A = $h0ns1.unstable_now, $efce52b0925ca653$var$ec = $h0ns1.unstable_getCurrentPriorityLevel, $efce52b0925ca653$var$fc = $h0ns1.unstable_ImmediatePriority, $efce52b0925ca653$var$gc = $h0ns1.unstable_UserBlockingPriority, $efce52b0925ca653$var$hc = $h0ns1.unstable_NormalPriority, $efce52b0925ca653$var$ic = $h0ns1.unstable_LowPriority, $efce52b0925ca653$var$jc = $h0ns1.unstable_IdlePriority, $efce52b0925ca653$var$kc = null, $efce52b0925ca653$var$lc = null, $efce52b0925ca653$var$B = null, $efce52b0925ca653$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $efce52b0925ca653$var$nc(a, b) {
    if ($efce52b0925ca653$var$lc && "function" === typeof $efce52b0925ca653$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $efce52b0925ca653$var$fc;
                break;
            case 4:
                d = $efce52b0925ca653$var$gc;
                break;
            case 16:
                d = $efce52b0925ca653$var$hc;
                break;
            case 536870912:
                d = $efce52b0925ca653$var$jc;
                break;
            default:
                d = $efce52b0925ca653$var$hc;
        }
        $efce52b0925ca653$var$lc.onCommitFiberRoot($efce52b0925ca653$var$kc, a, d, c);
    } catch (e) {}
}
function $efce52b0925ca653$var$oc(a) {
    $efce52b0925ca653$var$B = a;
}
function $efce52b0925ca653$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $efce52b0925ca653$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $efce52b0925ca653$var$rc() {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markCommitStopped && $efce52b0925ca653$var$B.markCommitStopped();
}
function $efce52b0925ca653$var$sc(a) {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentRenderStarted && $efce52b0925ca653$var$B.markComponentRenderStarted(a);
}
function $efce52b0925ca653$var$tc() {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentRenderStopped && $efce52b0925ca653$var$B.markComponentRenderStopped();
}
function $efce52b0925ca653$var$uc(a) {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentLayoutEffectUnmountStarted && $efce52b0925ca653$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $efce52b0925ca653$var$vc() {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentLayoutEffectUnmountStopped && $efce52b0925ca653$var$B.markComponentLayoutEffectUnmountStopped();
}
function $efce52b0925ca653$var$wc(a) {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markRenderStarted && $efce52b0925ca653$var$B.markRenderStarted(a);
}
function $efce52b0925ca653$var$xc() {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markRenderStopped && $efce52b0925ca653$var$B.markRenderStopped();
}
function $efce52b0925ca653$var$yc(a, b) {
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markStateUpdateScheduled && $efce52b0925ca653$var$B.markStateUpdateScheduled(a, b);
}
var $efce52b0925ca653$var$Ac = Math.clz32 ? Math.clz32 : $efce52b0925ca653$var$zc, $efce52b0925ca653$var$Bc = Math.log, $efce52b0925ca653$var$Cc = Math.LN2;
function $efce52b0925ca653$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($efce52b0925ca653$var$Bc(a) / $efce52b0925ca653$var$Cc | 0) | 0;
}
function $efce52b0925ca653$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $efce52b0925ca653$var$Dc = 64, $efce52b0925ca653$var$Ec = 4194304;
function $efce52b0925ca653$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $efce52b0925ca653$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $efce52b0925ca653$var$Fc(h) : (f &= g, 0 !== f && (d = $efce52b0925ca653$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $efce52b0925ca653$var$Fc(g) : 0 !== f && (d = $efce52b0925ca653$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $efce52b0925ca653$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $efce52b0925ca653$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $efce52b0925ca653$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $efce52b0925ca653$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $efce52b0925ca653$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $efce52b0925ca653$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $efce52b0925ca653$var$Kc() {
    var a = $efce52b0925ca653$var$Dc;
    $efce52b0925ca653$var$Dc <<= 1;
    0 === ($efce52b0925ca653$var$Dc & 4194240) && ($efce52b0925ca653$var$Dc = 64);
    return a;
}
function $efce52b0925ca653$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $efce52b0925ca653$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $efce52b0925ca653$var$Ac(b);
    a[b] = c;
}
function $efce52b0925ca653$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $efce52b0925ca653$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $efce52b0925ca653$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $efce52b0925ca653$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $efce52b0925ca653$var$Pc(a, b, c) {
    if ($efce52b0925ca653$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $efce52b0925ca653$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $efce52b0925ca653$var$Qc(a, b) {
    if ($efce52b0925ca653$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $efce52b0925ca653$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $efce52b0925ca653$var$E = 0;
function $efce52b0925ca653$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $efce52b0925ca653$var$Sc, $efce52b0925ca653$var$Tc, $efce52b0925ca653$var$Uc, $efce52b0925ca653$var$Vc, $efce52b0925ca653$var$Wc, $efce52b0925ca653$var$Xc = !1, $efce52b0925ca653$var$Yc = [], $efce52b0925ca653$var$Zc = null, $efce52b0925ca653$var$$c = null, $efce52b0925ca653$var$ad = null, $efce52b0925ca653$var$bd = new Map, $efce52b0925ca653$var$cd = new Map, $efce52b0925ca653$var$dd = [], $efce52b0925ca653$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $efce52b0925ca653$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $efce52b0925ca653$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $efce52b0925ca653$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $efce52b0925ca653$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $efce52b0925ca653$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $efce52b0925ca653$var$cd.delete(b.pointerId);
    }
}
function $efce52b0925ca653$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $efce52b0925ca653$var$Cb(b), null !== b && $efce52b0925ca653$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $efce52b0925ca653$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $efce52b0925ca653$var$Zc = $efce52b0925ca653$var$gd($efce52b0925ca653$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $efce52b0925ca653$var$$c = $efce52b0925ca653$var$gd($efce52b0925ca653$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $efce52b0925ca653$var$ad = $efce52b0925ca653$var$gd($efce52b0925ca653$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $efce52b0925ca653$var$bd.set(f, $efce52b0925ca653$var$gd($efce52b0925ca653$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $efce52b0925ca653$var$cd.set(f, $efce52b0925ca653$var$gd($efce52b0925ca653$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $efce52b0925ca653$var$id(a) {
    var b = $efce52b0925ca653$var$jd(a.target);
    if (null !== b) {
        var c = $efce52b0925ca653$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $efce52b0925ca653$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $efce52b0925ca653$var$Wc(a.priority, function() {
                        $efce52b0925ca653$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $efce52b0925ca653$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $efce52b0925ca653$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $efce52b0925ca653$var$wb = d;
            c.target.dispatchEvent(d);
            $efce52b0925ca653$var$wb = null;
        } else return b = $efce52b0925ca653$var$Cb(c), null !== b && $efce52b0925ca653$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $efce52b0925ca653$var$md(a, b, c) {
    $efce52b0925ca653$var$kd(a) && c.delete(b);
}
function $efce52b0925ca653$var$nd() {
    $efce52b0925ca653$var$Xc = !1;
    null !== $efce52b0925ca653$var$Zc && $efce52b0925ca653$var$kd($efce52b0925ca653$var$Zc) && ($efce52b0925ca653$var$Zc = null);
    null !== $efce52b0925ca653$var$$c && $efce52b0925ca653$var$kd($efce52b0925ca653$var$$c) && ($efce52b0925ca653$var$$c = null);
    null !== $efce52b0925ca653$var$ad && $efce52b0925ca653$var$kd($efce52b0925ca653$var$ad) && ($efce52b0925ca653$var$ad = null);
    $efce52b0925ca653$var$bd.forEach($efce52b0925ca653$var$md);
    $efce52b0925ca653$var$cd.forEach($efce52b0925ca653$var$md);
}
function $efce52b0925ca653$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $efce52b0925ca653$var$Xc || ($efce52b0925ca653$var$Xc = !0, $h0ns1.unstable_scheduleCallback($h0ns1.unstable_NormalPriority, $efce52b0925ca653$var$nd)));
}
function $efce52b0925ca653$var$pd(a) {
    function b(b) {
        return $efce52b0925ca653$var$od(b, a);
    }
    if (0 < $efce52b0925ca653$var$Yc.length) {
        $efce52b0925ca653$var$od($efce52b0925ca653$var$Yc[0], a);
        for(var c = 1; c < $efce52b0925ca653$var$Yc.length; c++){
            var d = $efce52b0925ca653$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $efce52b0925ca653$var$Zc && $efce52b0925ca653$var$od($efce52b0925ca653$var$Zc, a);
    null !== $efce52b0925ca653$var$$c && $efce52b0925ca653$var$od($efce52b0925ca653$var$$c, a);
    null !== $efce52b0925ca653$var$ad && $efce52b0925ca653$var$od($efce52b0925ca653$var$ad, a);
    $efce52b0925ca653$var$bd.forEach(b);
    $efce52b0925ca653$var$cd.forEach(b);
    for(c = 0; c < $efce52b0925ca653$var$dd.length; c++)d = $efce52b0925ca653$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $efce52b0925ca653$var$dd.length && (c = $efce52b0925ca653$var$dd[0], null === c.blockedOn);)$efce52b0925ca653$var$id(c), null === c.blockedOn && $efce52b0925ca653$var$dd.shift();
}
var $efce52b0925ca653$var$qd = $efce52b0925ca653$var$va.ReactCurrentBatchConfig, $efce52b0925ca653$var$rd = !0;
function $efce52b0925ca653$var$sd(a, b, c, d) {
    var e = $efce52b0925ca653$var$E, f = $efce52b0925ca653$var$qd.transition;
    $efce52b0925ca653$var$qd.transition = null;
    try {
        $efce52b0925ca653$var$E = 1, $efce52b0925ca653$var$td(a, b, c, d);
    } finally{
        $efce52b0925ca653$var$E = e, $efce52b0925ca653$var$qd.transition = f;
    }
}
function $efce52b0925ca653$var$ud(a, b, c, d) {
    var e = $efce52b0925ca653$var$E, f = $efce52b0925ca653$var$qd.transition;
    $efce52b0925ca653$var$qd.transition = null;
    try {
        $efce52b0925ca653$var$E = 4, $efce52b0925ca653$var$td(a, b, c, d);
    } finally{
        $efce52b0925ca653$var$E = e, $efce52b0925ca653$var$qd.transition = f;
    }
}
function $efce52b0925ca653$var$td(a, b, c, d) {
    if ($efce52b0925ca653$var$rd) {
        var e = $efce52b0925ca653$var$ld(a, b, c, d);
        if (null === e) $efce52b0925ca653$var$vd(a, b, d, $efce52b0925ca653$var$wd, c), $efce52b0925ca653$var$fd(a, d);
        else if ($efce52b0925ca653$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($efce52b0925ca653$var$fd(a, d), b & 4 && -1 < $efce52b0925ca653$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $efce52b0925ca653$var$Cb(e);
                null !== f && $efce52b0925ca653$var$Sc(f);
                f = $efce52b0925ca653$var$ld(a, b, c, d);
                null === f && $efce52b0925ca653$var$vd(a, b, d, $efce52b0925ca653$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $efce52b0925ca653$var$vd(a, b, d, null, c);
    }
}
var $efce52b0925ca653$var$wd = null;
function $efce52b0925ca653$var$ld(a, b, c, d) {
    $efce52b0925ca653$var$wd = null;
    a = $efce52b0925ca653$var$xb(d);
    a = $efce52b0925ca653$var$jd(a);
    if (null !== a) {
        if (b = $efce52b0925ca653$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $efce52b0925ca653$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $efce52b0925ca653$var$wd = a;
    return null;
}
function $efce52b0925ca653$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($efce52b0925ca653$var$ec()){
                case $efce52b0925ca653$var$fc:
                    return 1;
                case $efce52b0925ca653$var$gc:
                    return 4;
                case $efce52b0925ca653$var$hc:
                case $efce52b0925ca653$var$ic:
                    return 16;
                case $efce52b0925ca653$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $efce52b0925ca653$var$yd = null, $efce52b0925ca653$var$zd = null, $efce52b0925ca653$var$Ad = null;
function $efce52b0925ca653$var$Bd() {
    if ($efce52b0925ca653$var$Ad) return $efce52b0925ca653$var$Ad;
    var a, b = $efce52b0925ca653$var$zd, c = b.length, d, e = "value" in $efce52b0925ca653$var$yd ? $efce52b0925ca653$var$yd.value : $efce52b0925ca653$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $efce52b0925ca653$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $efce52b0925ca653$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $efce52b0925ca653$var$Dd() {
    return !0;
}
function $efce52b0925ca653$var$Ed() {
    return !1;
}
function $efce52b0925ca653$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $efce52b0925ca653$var$Dd : $efce52b0925ca653$var$Ed;
        this.isPropagationStopped = $efce52b0925ca653$var$Ed;
        return this;
    }
    $efce52b0925ca653$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $efce52b0925ca653$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $efce52b0925ca653$var$Dd);
        },
        persist: function() {},
        isPersistent: $efce52b0925ca653$var$Dd
    });
    return b;
}
var $efce52b0925ca653$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $efce52b0925ca653$var$Hd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Gd), $efce52b0925ca653$var$Id = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Gd, {
    view: 0,
    detail: 0
}), $efce52b0925ca653$var$Jd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Id), $efce52b0925ca653$var$Kd, $efce52b0925ca653$var$Ld, $efce52b0925ca653$var$Md, $efce52b0925ca653$var$Od = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $efce52b0925ca653$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $efce52b0925ca653$var$Md && ($efce52b0925ca653$var$Md && "mousemove" === a.type ? ($efce52b0925ca653$var$Kd = a.screenX - $efce52b0925ca653$var$Md.screenX, $efce52b0925ca653$var$Ld = a.screenY - $efce52b0925ca653$var$Md.screenY) : $efce52b0925ca653$var$Ld = $efce52b0925ca653$var$Kd = 0, $efce52b0925ca653$var$Md = a);
        return $efce52b0925ca653$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $efce52b0925ca653$var$Ld;
    }
}), $efce52b0925ca653$var$Pd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Od), $efce52b0925ca653$var$Qd = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Od, {
    dataTransfer: 0
}), $efce52b0925ca653$var$Rd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Qd), $efce52b0925ca653$var$Sd = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Id, {
    relatedTarget: 0
}), $efce52b0925ca653$var$Td = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Sd), $efce52b0925ca653$var$Ud = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $efce52b0925ca653$var$Vd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Ud), $efce52b0925ca653$var$Wd = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $efce52b0925ca653$var$Xd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Wd), $efce52b0925ca653$var$Yd = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Gd, {
    data: 0
}), $efce52b0925ca653$var$Zd = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$Yd), $efce52b0925ca653$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $efce52b0925ca653$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $efce52b0925ca653$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $efce52b0925ca653$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $efce52b0925ca653$var$be[a]) ? !!b[a] : !1;
}
function $efce52b0925ca653$var$Nd() {
    return $efce52b0925ca653$var$ce;
}
var $efce52b0925ca653$var$de = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $efce52b0925ca653$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $efce52b0925ca653$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $efce52b0925ca653$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $efce52b0925ca653$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $efce52b0925ca653$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $efce52b0925ca653$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $efce52b0925ca653$var$ee = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$de), $efce52b0925ca653$var$fe = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $efce52b0925ca653$var$ge = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$fe), $efce52b0925ca653$var$he = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $efce52b0925ca653$var$Nd
}), $efce52b0925ca653$var$ie = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$he), $efce52b0925ca653$var$je = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $efce52b0925ca653$var$ke = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$je), $efce52b0925ca653$var$le = $efce52b0925ca653$var$u({}, $efce52b0925ca653$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $efce52b0925ca653$var$me = $efce52b0925ca653$var$Fd($efce52b0925ca653$var$le), $efce52b0925ca653$var$ne = [
    9,
    13,
    27,
    32
], $efce52b0925ca653$var$oe = $efce52b0925ca653$var$ia && "CompositionEvent" in window, $efce52b0925ca653$var$pe = null;
$efce52b0925ca653$var$ia && "documentMode" in document && ($efce52b0925ca653$var$pe = document.documentMode);
var $efce52b0925ca653$var$qe = $efce52b0925ca653$var$ia && "TextEvent" in window && !$efce52b0925ca653$var$pe, $efce52b0925ca653$var$re = $efce52b0925ca653$var$ia && (!$efce52b0925ca653$var$oe || $efce52b0925ca653$var$pe && 8 < $efce52b0925ca653$var$pe && 11 >= $efce52b0925ca653$var$pe), $efce52b0925ca653$var$se = String.fromCharCode(32), $efce52b0925ca653$var$te = !1;
function $efce52b0925ca653$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $efce52b0925ca653$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $efce52b0925ca653$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $efce52b0925ca653$var$we = !1;
function $efce52b0925ca653$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $efce52b0925ca653$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $efce52b0925ca653$var$te = !0;
            return $efce52b0925ca653$var$se;
        case "textInput":
            return a = b.data, a === $efce52b0925ca653$var$se && $efce52b0925ca653$var$te ? null : a;
        default:
            return null;
    }
}
function $efce52b0925ca653$var$ye(a, b) {
    if ($efce52b0925ca653$var$we) return "compositionend" === a || !$efce52b0925ca653$var$oe && $efce52b0925ca653$var$ue(a, b) ? (a = $efce52b0925ca653$var$Bd(), $efce52b0925ca653$var$Ad = $efce52b0925ca653$var$zd = $efce52b0925ca653$var$yd = null, $efce52b0925ca653$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $efce52b0925ca653$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $efce52b0925ca653$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $efce52b0925ca653$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$efce52b0925ca653$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $efce52b0925ca653$var$Be(a, b, c, d) {
    $efce52b0925ca653$var$Eb(d);
    b = $efce52b0925ca653$var$Ce(b, "onChange");
    0 < b.length && (c = new $efce52b0925ca653$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $efce52b0925ca653$var$De = null, $efce52b0925ca653$var$Ee = null;
function $efce52b0925ca653$var$Fe(a) {
    $efce52b0925ca653$var$Ge(a, 0);
}
function $efce52b0925ca653$var$He(a) {
    var b = $efce52b0925ca653$var$Ie(a);
    if ($efce52b0925ca653$var$Wa(b)) return a;
}
function $efce52b0925ca653$var$Je(a, b) {
    if ("change" === a) return b;
}
var $efce52b0925ca653$var$Ke = !1;
if ($efce52b0925ca653$var$ia) {
    var $efce52b0925ca653$var$Le;
    if ($efce52b0925ca653$var$ia) {
        var $efce52b0925ca653$var$Me = "oninput" in document;
        if (!$efce52b0925ca653$var$Me) {
            var $efce52b0925ca653$var$Ne = document.createElement("div");
            $efce52b0925ca653$var$Ne.setAttribute("oninput", "return;");
            $efce52b0925ca653$var$Me = "function" === typeof $efce52b0925ca653$var$Ne.oninput;
        }
        $efce52b0925ca653$var$Le = $efce52b0925ca653$var$Me;
    } else $efce52b0925ca653$var$Le = !1;
    $efce52b0925ca653$var$Ke = $efce52b0925ca653$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $efce52b0925ca653$var$Oe() {
    $efce52b0925ca653$var$De && ($efce52b0925ca653$var$De.detachEvent("onpropertychange", $efce52b0925ca653$var$Pe), $efce52b0925ca653$var$Ee = $efce52b0925ca653$var$De = null);
}
function $efce52b0925ca653$var$Pe(a) {
    if ("value" === a.propertyName && $efce52b0925ca653$var$He($efce52b0925ca653$var$Ee)) {
        var b = [];
        $efce52b0925ca653$var$Be(b, $efce52b0925ca653$var$Ee, a, $efce52b0925ca653$var$xb(a));
        $efce52b0925ca653$var$Jb($efce52b0925ca653$var$Fe, b);
    }
}
function $efce52b0925ca653$var$Qe(a, b, c) {
    "focusin" === a ? ($efce52b0925ca653$var$Oe(), $efce52b0925ca653$var$De = b, $efce52b0925ca653$var$Ee = c, $efce52b0925ca653$var$De.attachEvent("onpropertychange", $efce52b0925ca653$var$Pe)) : "focusout" === a && $efce52b0925ca653$var$Oe();
}
function $efce52b0925ca653$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $efce52b0925ca653$var$He($efce52b0925ca653$var$Ee);
}
function $efce52b0925ca653$var$Se(a, b) {
    if ("click" === a) return $efce52b0925ca653$var$He(b);
}
function $efce52b0925ca653$var$Te(a, b) {
    if ("input" === a || "change" === a) return $efce52b0925ca653$var$He(b);
}
function $efce52b0925ca653$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $efce52b0925ca653$var$Ve = "function" === typeof Object.is ? Object.is : $efce52b0925ca653$var$Ue;
function $efce52b0925ca653$var$We(a, b) {
    if ($efce52b0925ca653$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$efce52b0925ca653$var$ja.call(b, e) || !$efce52b0925ca653$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $efce52b0925ca653$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $efce52b0925ca653$var$Ye(a, b) {
    var c = $efce52b0925ca653$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $efce52b0925ca653$var$Xe(c);
    }
}
function $efce52b0925ca653$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $efce52b0925ca653$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $efce52b0925ca653$var$$e() {
    for(var a = window, b = $efce52b0925ca653$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $efce52b0925ca653$var$Xa(a.document);
    }
    return b;
}
function $efce52b0925ca653$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $efce52b0925ca653$var$bf(a) {
    var b = $efce52b0925ca653$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $efce52b0925ca653$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $efce52b0925ca653$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $efce52b0925ca653$var$Ye(c, f);
                var g = $efce52b0925ca653$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $efce52b0925ca653$var$cf = $efce52b0925ca653$var$ia && "documentMode" in document && 11 >= document.documentMode, $efce52b0925ca653$var$df = null, $efce52b0925ca653$var$ef = null, $efce52b0925ca653$var$ff = null, $efce52b0925ca653$var$gf = !1;
function $efce52b0925ca653$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $efce52b0925ca653$var$gf || null == $efce52b0925ca653$var$df || $efce52b0925ca653$var$df !== $efce52b0925ca653$var$Xa(d) || (d = $efce52b0925ca653$var$df, "selectionStart" in d && $efce52b0925ca653$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $efce52b0925ca653$var$ff && $efce52b0925ca653$var$We($efce52b0925ca653$var$ff, d) || ($efce52b0925ca653$var$ff = d, d = $efce52b0925ca653$var$Ce($efce52b0925ca653$var$ef, "onSelect"), 0 < d.length && (b = new $efce52b0925ca653$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $efce52b0925ca653$var$df)));
}
function $efce52b0925ca653$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $efce52b0925ca653$var$kf = {
    animationend: $efce52b0925ca653$var$jf("Animation", "AnimationEnd"),
    animationiteration: $efce52b0925ca653$var$jf("Animation", "AnimationIteration"),
    animationstart: $efce52b0925ca653$var$jf("Animation", "AnimationStart"),
    transitionend: $efce52b0925ca653$var$jf("Transition", "TransitionEnd")
}, $efce52b0925ca653$var$lf = {}, $efce52b0925ca653$var$mf = {};
$efce52b0925ca653$var$ia && ($efce52b0925ca653$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $efce52b0925ca653$var$kf.animationend.animation, delete $efce52b0925ca653$var$kf.animationiteration.animation, delete $efce52b0925ca653$var$kf.animationstart.animation), "TransitionEvent" in window || delete $efce52b0925ca653$var$kf.transitionend.transition);
function $efce52b0925ca653$var$nf(a) {
    if ($efce52b0925ca653$var$lf[a]) return $efce52b0925ca653$var$lf[a];
    if (!$efce52b0925ca653$var$kf[a]) return a;
    var b = $efce52b0925ca653$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $efce52b0925ca653$var$mf) return $efce52b0925ca653$var$lf[a] = b[c];
    return a;
}
var $efce52b0925ca653$var$of = $efce52b0925ca653$var$nf("animationend"), $efce52b0925ca653$var$pf = $efce52b0925ca653$var$nf("animationiteration"), $efce52b0925ca653$var$qf = $efce52b0925ca653$var$nf("animationstart"), $efce52b0925ca653$var$rf = $efce52b0925ca653$var$nf("transitionend"), $efce52b0925ca653$var$sf = new Map, $efce52b0925ca653$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $efce52b0925ca653$var$uf(a, b) {
    $efce52b0925ca653$var$sf.set(a, b);
    $efce52b0925ca653$var$fa(b, [
        a
    ]);
}
for(var $efce52b0925ca653$var$vf = 0; $efce52b0925ca653$var$vf < $efce52b0925ca653$var$tf.length; $efce52b0925ca653$var$vf++){
    var $efce52b0925ca653$var$wf = $efce52b0925ca653$var$tf[$efce52b0925ca653$var$vf], $efce52b0925ca653$var$xf = $efce52b0925ca653$var$wf.toLowerCase(), $efce52b0925ca653$var$yf = $efce52b0925ca653$var$wf[0].toUpperCase() + $efce52b0925ca653$var$wf.slice(1);
    $efce52b0925ca653$var$uf($efce52b0925ca653$var$xf, "on" + $efce52b0925ca653$var$yf);
}
$efce52b0925ca653$var$uf($efce52b0925ca653$var$of, "onAnimationEnd");
$efce52b0925ca653$var$uf($efce52b0925ca653$var$pf, "onAnimationIteration");
$efce52b0925ca653$var$uf($efce52b0925ca653$var$qf, "onAnimationStart");
$efce52b0925ca653$var$uf("dblclick", "onDoubleClick");
$efce52b0925ca653$var$uf("focusin", "onFocus");
$efce52b0925ca653$var$uf("focusout", "onBlur");
$efce52b0925ca653$var$uf($efce52b0925ca653$var$rf, "onTransitionEnd");
$efce52b0925ca653$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$efce52b0925ca653$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$efce52b0925ca653$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$efce52b0925ca653$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$efce52b0925ca653$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$efce52b0925ca653$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$efce52b0925ca653$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$efce52b0925ca653$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$efce52b0925ca653$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$efce52b0925ca653$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $efce52b0925ca653$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $efce52b0925ca653$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($efce52b0925ca653$var$zf));
function $efce52b0925ca653$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $efce52b0925ca653$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $efce52b0925ca653$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $efce52b0925ca653$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $efce52b0925ca653$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($efce52b0925ca653$var$Qb) throw a = $efce52b0925ca653$var$Rb, $efce52b0925ca653$var$Qb = !1, $efce52b0925ca653$var$Rb = null, a;
}
function $efce52b0925ca653$var$F(a, b) {
    var c = b[$efce52b0925ca653$var$Cf];
    void 0 === c && (c = b[$efce52b0925ca653$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($efce52b0925ca653$var$Df(b, a, 2, !1), c.add(d));
}
function $efce52b0925ca653$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $efce52b0925ca653$var$Df(c, a, d, b);
}
var $efce52b0925ca653$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $efce52b0925ca653$var$Gf(a) {
    if (!a[$efce52b0925ca653$var$Ff]) {
        a[$efce52b0925ca653$var$Ff] = !0;
        $efce52b0925ca653$var$da.forEach(function(b) {
            "selectionchange" !== b && ($efce52b0925ca653$var$Af.has(b) || $efce52b0925ca653$var$Ef(b, !1, a), $efce52b0925ca653$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$efce52b0925ca653$var$Ff] || (b[$efce52b0925ca653$var$Ff] = !0, $efce52b0925ca653$var$Ef("selectionchange", !1, b));
    }
}
function $efce52b0925ca653$var$Df(a, b, c, d) {
    switch($efce52b0925ca653$var$xd(b)){
        case 1:
            var e = $efce52b0925ca653$var$sd;
            break;
        case 4:
            e = $efce52b0925ca653$var$ud;
            break;
        default:
            e = $efce52b0925ca653$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$efce52b0925ca653$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $efce52b0925ca653$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $efce52b0925ca653$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $efce52b0925ca653$var$Jb(function() {
        var d = f, e = $efce52b0925ca653$var$xb(c), g = [];
        a: {
            var h = $efce52b0925ca653$var$sf.get(a);
            if (void 0 !== h) {
                var k = $efce52b0925ca653$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $efce52b0925ca653$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $efce52b0925ca653$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $efce52b0925ca653$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $efce52b0925ca653$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $efce52b0925ca653$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $efce52b0925ca653$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $efce52b0925ca653$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $efce52b0925ca653$var$ie;
                        break;
                    case $efce52b0925ca653$var$of:
                    case $efce52b0925ca653$var$pf:
                    case $efce52b0925ca653$var$qf:
                        k = $efce52b0925ca653$var$Vd;
                        break;
                    case $efce52b0925ca653$var$rf:
                        k = $efce52b0925ca653$var$ke;
                        break;
                    case "scroll":
                        k = $efce52b0925ca653$var$Jd;
                        break;
                    case "wheel":
                        k = $efce52b0925ca653$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $efce52b0925ca653$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $efce52b0925ca653$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $efce52b0925ca653$var$Kb(y, x), null != D && w.push($efce52b0925ca653$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $efce52b0925ca653$var$wb && (m = c.relatedTarget || c.fromElement) && ($efce52b0925ca653$var$jd(m) || m[$efce52b0925ca653$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $efce52b0925ca653$var$jd(m) : null, null !== m && (C = $efce52b0925ca653$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $efce52b0925ca653$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $efce52b0925ca653$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $efce52b0925ca653$var$Ie(k);
                        v = null == m ? h : $efce52b0925ca653$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $efce52b0925ca653$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $efce52b0925ca653$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $efce52b0925ca653$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $efce52b0925ca653$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $efce52b0925ca653$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $efce52b0925ca653$var$Jf(w);
                                x = $efce52b0925ca653$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $efce52b0925ca653$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $efce52b0925ca653$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $efce52b0925ca653$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $efce52b0925ca653$var$Je;
                else if ($efce52b0925ca653$var$Ae(h)) {
                    if ($efce52b0925ca653$var$Ke) ca = $efce52b0925ca653$var$Te;
                    else {
                        ca = $efce52b0925ca653$var$Re;
                        var R = $efce52b0925ca653$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $efce52b0925ca653$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $efce52b0925ca653$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $efce52b0925ca653$var$bb(h, "number", h.value);
            }
            R = d ? $efce52b0925ca653$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($efce52b0925ca653$var$Ae(R) || "true" === R.contentEditable) $efce52b0925ca653$var$df = R, $efce52b0925ca653$var$ef = d, $efce52b0925ca653$var$ff = null;
                    break;
                case "focusout":
                    $efce52b0925ca653$var$ff = $efce52b0925ca653$var$ef = $efce52b0925ca653$var$df = null;
                    break;
                case "mousedown":
                    $efce52b0925ca653$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $efce52b0925ca653$var$gf = !1;
                    $efce52b0925ca653$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($efce52b0925ca653$var$cf) break;
                case "keydown":
                case "keyup":
                    $efce52b0925ca653$var$hf(g, c, e);
            }
            var sa;
            if ($efce52b0925ca653$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $efce52b0925ca653$var$we ? $efce52b0925ca653$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($efce52b0925ca653$var$re && "ko" !== c.locale && ($efce52b0925ca653$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $efce52b0925ca653$var$we && (sa = $efce52b0925ca653$var$Bd()) : ($efce52b0925ca653$var$yd = e, $efce52b0925ca653$var$zd = "value" in $efce52b0925ca653$var$yd ? $efce52b0925ca653$var$yd.value : $efce52b0925ca653$var$yd.textContent, $efce52b0925ca653$var$we = !0)), R = $efce52b0925ca653$var$Ce(d, V), 0 < R.length && (V = new $efce52b0925ca653$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $efce52b0925ca653$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $efce52b0925ca653$var$qe ? $efce52b0925ca653$var$xe(a, c) : $efce52b0925ca653$var$ye(a, c)) d = $efce52b0925ca653$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $efce52b0925ca653$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $efce52b0925ca653$var$Ge(g, b);
    });
}
function $efce52b0925ca653$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $efce52b0925ca653$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $efce52b0925ca653$var$Kb(a, c), null != f && d.unshift($efce52b0925ca653$var$Hf(a, f, e)), f = $efce52b0925ca653$var$Kb(a, b), null != f && d.push($efce52b0925ca653$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $efce52b0925ca653$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $efce52b0925ca653$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $efce52b0925ca653$var$Kb(c, f), null != k && g.unshift($efce52b0925ca653$var$Hf(c, k, h))) : e || (k = $efce52b0925ca653$var$Kb(c, f), null != k && g.push($efce52b0925ca653$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $efce52b0925ca653$var$Lf = /\r\n?/g, $efce52b0925ca653$var$Mf = /\u0000|\uFFFD/g;
function $efce52b0925ca653$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($efce52b0925ca653$var$Lf, "\n").replace($efce52b0925ca653$var$Mf, "");
}
function $efce52b0925ca653$var$Of(a, b, c) {
    b = $efce52b0925ca653$var$Nf(b);
    if ($efce52b0925ca653$var$Nf(a) !== b && c) throw Error($efce52b0925ca653$var$p(425));
}
function $efce52b0925ca653$var$Pf() {}
var $efce52b0925ca653$var$Qf = null, $efce52b0925ca653$var$Rf = null;
function $efce52b0925ca653$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $efce52b0925ca653$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $efce52b0925ca653$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $efce52b0925ca653$var$Vf = "function" === typeof Promise ? Promise : void 0, $efce52b0925ca653$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $efce52b0925ca653$var$Vf ? function(a) {
    return $efce52b0925ca653$var$Vf.resolve(null).then(a).catch($efce52b0925ca653$var$Wf);
} : $efce52b0925ca653$var$Tf;
function $efce52b0925ca653$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $efce52b0925ca653$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $efce52b0925ca653$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $efce52b0925ca653$var$pd(b);
}
function $efce52b0925ca653$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $efce52b0925ca653$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $efce52b0925ca653$var$ag = Math.random().toString(36).slice(2), $efce52b0925ca653$var$bg = "__reactFiber$" + $efce52b0925ca653$var$ag, $efce52b0925ca653$var$cg = "__reactProps$" + $efce52b0925ca653$var$ag, $efce52b0925ca653$var$If = "__reactContainer$" + $efce52b0925ca653$var$ag, $efce52b0925ca653$var$Cf = "__reactEvents$" + $efce52b0925ca653$var$ag, $efce52b0925ca653$var$dg = "__reactListeners$" + $efce52b0925ca653$var$ag, $efce52b0925ca653$var$eg = "__reactHandles$" + $efce52b0925ca653$var$ag;
function $efce52b0925ca653$var$jd(a) {
    var b = a[$efce52b0925ca653$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$efce52b0925ca653$var$If] || c[$efce52b0925ca653$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $efce52b0925ca653$var$$f(a); null !== a;){
                if (c = a[$efce52b0925ca653$var$bg]) return c;
                a = $efce52b0925ca653$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $efce52b0925ca653$var$Cb(a) {
    a = a[$efce52b0925ca653$var$bg] || a[$efce52b0925ca653$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $efce52b0925ca653$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($efce52b0925ca653$var$p(33));
}
function $efce52b0925ca653$var$Db(a) {
    return a[$efce52b0925ca653$var$cg] || null;
}
var $efce52b0925ca653$var$fg = [], $efce52b0925ca653$var$gg = -1;
function $efce52b0925ca653$var$hg(a) {
    return {
        current: a
    };
}
function $efce52b0925ca653$var$G(a) {
    0 > $efce52b0925ca653$var$gg || (a.current = $efce52b0925ca653$var$fg[$efce52b0925ca653$var$gg], $efce52b0925ca653$var$fg[$efce52b0925ca653$var$gg] = null, $efce52b0925ca653$var$gg--);
}
function $efce52b0925ca653$var$H(a, b) {
    $efce52b0925ca653$var$gg++;
    $efce52b0925ca653$var$fg[$efce52b0925ca653$var$gg] = a.current;
    a.current = b;
}
var $efce52b0925ca653$var$ig = {}, $efce52b0925ca653$var$I = $efce52b0925ca653$var$hg($efce52b0925ca653$var$ig), $efce52b0925ca653$var$jg = $efce52b0925ca653$var$hg(!1), $efce52b0925ca653$var$kg = $efce52b0925ca653$var$ig;
function $efce52b0925ca653$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $efce52b0925ca653$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $efce52b0925ca653$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $efce52b0925ca653$var$ng() {
    $efce52b0925ca653$var$G($efce52b0925ca653$var$jg);
    $efce52b0925ca653$var$G($efce52b0925ca653$var$I);
}
function $efce52b0925ca653$var$og(a, b, c) {
    if ($efce52b0925ca653$var$I.current !== $efce52b0925ca653$var$ig) throw Error($efce52b0925ca653$var$p(168));
    $efce52b0925ca653$var$H($efce52b0925ca653$var$I, b);
    $efce52b0925ca653$var$H($efce52b0925ca653$var$jg, c);
}
function $efce52b0925ca653$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($efce52b0925ca653$var$p(108, $efce52b0925ca653$var$Ra(a) || "Unknown", e));
    return $efce52b0925ca653$var$u({}, c, d);
}
function $efce52b0925ca653$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $efce52b0925ca653$var$ig;
    $efce52b0925ca653$var$kg = $efce52b0925ca653$var$I.current;
    $efce52b0925ca653$var$H($efce52b0925ca653$var$I, a);
    $efce52b0925ca653$var$H($efce52b0925ca653$var$jg, $efce52b0925ca653$var$jg.current);
    return !0;
}
function $efce52b0925ca653$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($efce52b0925ca653$var$p(169));
    c ? (a = $efce52b0925ca653$var$pg(a, b, $efce52b0925ca653$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $efce52b0925ca653$var$G($efce52b0925ca653$var$jg), $efce52b0925ca653$var$G($efce52b0925ca653$var$I), $efce52b0925ca653$var$H($efce52b0925ca653$var$I, a)) : $efce52b0925ca653$var$G($efce52b0925ca653$var$jg);
    $efce52b0925ca653$var$H($efce52b0925ca653$var$jg, c);
}
var $efce52b0925ca653$var$sg = null, $efce52b0925ca653$var$tg = !1, $efce52b0925ca653$var$ug = !1;
function $efce52b0925ca653$var$vg(a) {
    null === $efce52b0925ca653$var$sg ? $efce52b0925ca653$var$sg = [
        a
    ] : $efce52b0925ca653$var$sg.push(a);
}
function $efce52b0925ca653$var$wg(a) {
    $efce52b0925ca653$var$tg = !0;
    $efce52b0925ca653$var$vg(a);
}
function $efce52b0925ca653$var$xg() {
    if (!$efce52b0925ca653$var$ug && null !== $efce52b0925ca653$var$sg) {
        $efce52b0925ca653$var$ug = !0;
        var a = 0, b = $efce52b0925ca653$var$E;
        try {
            var c = $efce52b0925ca653$var$sg;
            for($efce52b0925ca653$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $efce52b0925ca653$var$sg = null;
            $efce52b0925ca653$var$tg = !1;
        } catch (e) {
            throw null !== $efce52b0925ca653$var$sg && ($efce52b0925ca653$var$sg = $efce52b0925ca653$var$sg.slice(a + 1)), $efce52b0925ca653$var$ac($efce52b0925ca653$var$fc, $efce52b0925ca653$var$xg), e;
        } finally{
            $efce52b0925ca653$var$E = b, $efce52b0925ca653$var$ug = !1;
        }
    }
    return null;
}
var $efce52b0925ca653$var$yg = [], $efce52b0925ca653$var$zg = 0, $efce52b0925ca653$var$Ag = null, $efce52b0925ca653$var$Bg = 0, $efce52b0925ca653$var$Cg = [], $efce52b0925ca653$var$Dg = 0, $efce52b0925ca653$var$Eg = null, $efce52b0925ca653$var$Fg = 1, $efce52b0925ca653$var$Gg = "";
function $efce52b0925ca653$var$Hg(a, b) {
    $efce52b0925ca653$var$yg[$efce52b0925ca653$var$zg++] = $efce52b0925ca653$var$Bg;
    $efce52b0925ca653$var$yg[$efce52b0925ca653$var$zg++] = $efce52b0925ca653$var$Ag;
    $efce52b0925ca653$var$Ag = a;
    $efce52b0925ca653$var$Bg = b;
}
function $efce52b0925ca653$var$Ig(a, b, c) {
    $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg++] = $efce52b0925ca653$var$Fg;
    $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg++] = $efce52b0925ca653$var$Gg;
    $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg++] = $efce52b0925ca653$var$Eg;
    $efce52b0925ca653$var$Eg = a;
    var d = $efce52b0925ca653$var$Fg;
    a = $efce52b0925ca653$var$Gg;
    var e = 32 - $efce52b0925ca653$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $efce52b0925ca653$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $efce52b0925ca653$var$Fg = 1 << 32 - $efce52b0925ca653$var$Ac(b) + e | c << e | d;
        $efce52b0925ca653$var$Gg = f + a;
    } else $efce52b0925ca653$var$Fg = 1 << f | c << e | d, $efce52b0925ca653$var$Gg = a;
}
function $efce52b0925ca653$var$Jg(a) {
    null !== a.return && ($efce52b0925ca653$var$Hg(a, 1), $efce52b0925ca653$var$Ig(a, 1, 0));
}
function $efce52b0925ca653$var$Kg(a) {
    for(; a === $efce52b0925ca653$var$Ag;)$efce52b0925ca653$var$Ag = $efce52b0925ca653$var$yg[--$efce52b0925ca653$var$zg], $efce52b0925ca653$var$yg[$efce52b0925ca653$var$zg] = null, $efce52b0925ca653$var$Bg = $efce52b0925ca653$var$yg[--$efce52b0925ca653$var$zg], $efce52b0925ca653$var$yg[$efce52b0925ca653$var$zg] = null;
    for(; a === $efce52b0925ca653$var$Eg;)$efce52b0925ca653$var$Eg = $efce52b0925ca653$var$Cg[--$efce52b0925ca653$var$Dg], $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg] = null, $efce52b0925ca653$var$Gg = $efce52b0925ca653$var$Cg[--$efce52b0925ca653$var$Dg], $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg] = null, $efce52b0925ca653$var$Fg = $efce52b0925ca653$var$Cg[--$efce52b0925ca653$var$Dg], $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg] = null;
}
var $efce52b0925ca653$var$Lg = null, $efce52b0925ca653$var$Mg = null, $efce52b0925ca653$var$J = !1, $efce52b0925ca653$var$Ng = null;
function $efce52b0925ca653$var$Og(a, b) {
    var c = $efce52b0925ca653$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $efce52b0925ca653$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $efce52b0925ca653$var$Lg = a, $efce52b0925ca653$var$Mg = $efce52b0925ca653$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $efce52b0925ca653$var$Lg = a, $efce52b0925ca653$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $efce52b0925ca653$var$Eg ? {
                id: $efce52b0925ca653$var$Fg,
                overflow: $efce52b0925ca653$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $efce52b0925ca653$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $efce52b0925ca653$var$Lg = a, $efce52b0925ca653$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $efce52b0925ca653$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $efce52b0925ca653$var$Sg(a) {
    if ($efce52b0925ca653$var$J) {
        var b = $efce52b0925ca653$var$Mg;
        if (b) {
            var c = b;
            if (!$efce52b0925ca653$var$Qg(a, b)) {
                if ($efce52b0925ca653$var$Rg(a)) throw Error($efce52b0925ca653$var$p(418));
                b = $efce52b0925ca653$var$Zf(c.nextSibling);
                var d = $efce52b0925ca653$var$Lg;
                b && $efce52b0925ca653$var$Qg(a, b) ? $efce52b0925ca653$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $efce52b0925ca653$var$J = !1, $efce52b0925ca653$var$Lg = a);
            }
        } else {
            if ($efce52b0925ca653$var$Rg(a)) throw Error($efce52b0925ca653$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $efce52b0925ca653$var$J = !1;
            $efce52b0925ca653$var$Lg = a;
        }
    }
}
function $efce52b0925ca653$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $efce52b0925ca653$var$Lg = a;
}
function $efce52b0925ca653$var$Ug(a) {
    if (a !== $efce52b0925ca653$var$Lg) return !1;
    if (!$efce52b0925ca653$var$J) return $efce52b0925ca653$var$Tg(a), $efce52b0925ca653$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$efce52b0925ca653$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $efce52b0925ca653$var$Mg)) {
        if ($efce52b0925ca653$var$Rg(a)) throw $efce52b0925ca653$var$Vg(), Error($efce52b0925ca653$var$p(418));
        for(; b;)$efce52b0925ca653$var$Og(a, b), b = $efce52b0925ca653$var$Zf(b.nextSibling);
    }
    $efce52b0925ca653$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($efce52b0925ca653$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $efce52b0925ca653$var$Mg = $efce52b0925ca653$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $efce52b0925ca653$var$Mg = null;
        }
    } else $efce52b0925ca653$var$Mg = $efce52b0925ca653$var$Lg ? $efce52b0925ca653$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $efce52b0925ca653$var$Vg() {
    for(var a = $efce52b0925ca653$var$Mg; a;)a = $efce52b0925ca653$var$Zf(a.nextSibling);
}
function $efce52b0925ca653$var$Wg() {
    $efce52b0925ca653$var$Mg = $efce52b0925ca653$var$Lg = null;
    $efce52b0925ca653$var$J = !1;
}
function $efce52b0925ca653$var$Xg(a) {
    null === $efce52b0925ca653$var$Ng ? $efce52b0925ca653$var$Ng = [
        a
    ] : $efce52b0925ca653$var$Ng.push(a);
}
var $efce52b0925ca653$var$Yg = $efce52b0925ca653$var$va.ReactCurrentBatchConfig;
function $efce52b0925ca653$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($efce52b0925ca653$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($efce52b0925ca653$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($efce52b0925ca653$var$p(284));
        if (!c._owner) throw Error($efce52b0925ca653$var$p(290, a));
    }
    return a;
}
function $efce52b0925ca653$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($efce52b0925ca653$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $efce52b0925ca653$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $efce52b0925ca653$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $efce52b0925ca653$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $efce52b0925ca653$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $efce52b0925ca653$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $efce52b0925ca653$var$Ha && $efce52b0925ca653$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $efce52b0925ca653$var$Zg(a, b, c), d.return = a, d;
        d = $efce52b0925ca653$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $efce52b0925ca653$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $efce52b0925ca653$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $efce52b0925ca653$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $efce52b0925ca653$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $efce52b0925ca653$var$wa:
                    return c = $efce52b0925ca653$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $efce52b0925ca653$var$Zg(a, null, b), c.return = a, c;
                case $efce52b0925ca653$var$xa:
                    return b = $efce52b0925ca653$var$fh(b, a.mode, c), b.return = a, b;
                case $efce52b0925ca653$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($efce52b0925ca653$var$db(b) || $efce52b0925ca653$var$Ka(b)) return b = $efce52b0925ca653$var$gh(b, a.mode, c, null), b.return = a, b;
            $efce52b0925ca653$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $efce52b0925ca653$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $efce52b0925ca653$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $efce52b0925ca653$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($efce52b0925ca653$var$db(c) || $efce52b0925ca653$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $efce52b0925ca653$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $efce52b0925ca653$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $efce52b0925ca653$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $efce52b0925ca653$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($efce52b0925ca653$var$db(d) || $efce52b0925ca653$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $efce52b0925ca653$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $efce52b0925ca653$var$J && $efce52b0925ca653$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $efce52b0925ca653$var$J && $efce52b0925ca653$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $efce52b0925ca653$var$J && $efce52b0925ca653$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $efce52b0925ca653$var$Ka(h);
        if ("function" !== typeof l) throw Error($efce52b0925ca653$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($efce52b0925ca653$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $efce52b0925ca653$var$J && $efce52b0925ca653$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $efce52b0925ca653$var$J && $efce52b0925ca653$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $efce52b0925ca653$var$J && $efce52b0925ca653$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $efce52b0925ca653$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $efce52b0925ca653$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $efce52b0925ca653$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $efce52b0925ca653$var$Ha && $efce52b0925ca653$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $efce52b0925ca653$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $efce52b0925ca653$var$ya ? (d = $efce52b0925ca653$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $efce52b0925ca653$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $efce52b0925ca653$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $efce52b0925ca653$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $efce52b0925ca653$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $efce52b0925ca653$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($efce52b0925ca653$var$db(f)) return m(a, d, f, h);
            if ($efce52b0925ca653$var$Ka(f)) return w(a, d, f, h);
            $efce52b0925ca653$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $efce52b0925ca653$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $efce52b0925ca653$var$hh = $efce52b0925ca653$var$bh(!0), $efce52b0925ca653$var$ih = $efce52b0925ca653$var$bh(!1), $efce52b0925ca653$var$jh = $efce52b0925ca653$var$hg(null), $efce52b0925ca653$var$kh = null, $efce52b0925ca653$var$lh = null, $efce52b0925ca653$var$mh = null;
function $efce52b0925ca653$var$nh() {
    $efce52b0925ca653$var$mh = $efce52b0925ca653$var$lh = $efce52b0925ca653$var$kh = null;
}
function $efce52b0925ca653$var$oh(a) {
    var b = $efce52b0925ca653$var$jh.current;
    $efce52b0925ca653$var$G($efce52b0925ca653$var$jh);
    a._currentValue = b;
}
function $efce52b0925ca653$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $efce52b0925ca653$var$qh(a, b) {
    $efce52b0925ca653$var$kh = a;
    $efce52b0925ca653$var$mh = $efce52b0925ca653$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($efce52b0925ca653$var$rh = !0), a.firstContext = null);
}
function $efce52b0925ca653$var$sh(a) {
    var b = a._currentValue;
    if ($efce52b0925ca653$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $efce52b0925ca653$var$lh) {
            if (null === $efce52b0925ca653$var$kh) throw Error($efce52b0925ca653$var$p(308));
            $efce52b0925ca653$var$lh = a;
            $efce52b0925ca653$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $efce52b0925ca653$var$lh = $efce52b0925ca653$var$lh.next = a;
    }
    return b;
}
var $efce52b0925ca653$var$th = null;
function $efce52b0925ca653$var$uh(a) {
    null === $efce52b0925ca653$var$th ? $efce52b0925ca653$var$th = [
        a
    ] : $efce52b0925ca653$var$th.push(a);
}
function $efce52b0925ca653$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $efce52b0925ca653$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $efce52b0925ca653$var$wh(a, d);
}
function $efce52b0925ca653$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $efce52b0925ca653$var$xh = !1;
function $efce52b0925ca653$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $efce52b0925ca653$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $efce52b0925ca653$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $efce52b0925ca653$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($efce52b0925ca653$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $efce52b0925ca653$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $efce52b0925ca653$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $efce52b0925ca653$var$wh(a, c);
}
function $efce52b0925ca653$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $efce52b0925ca653$var$Oc(a, c);
    }
}
function $efce52b0925ca653$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $efce52b0925ca653$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $efce52b0925ca653$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $efce52b0925ca653$var$u({}, q, r);
                            break a;
                        case 2:
                            $efce52b0925ca653$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $efce52b0925ca653$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $efce52b0925ca653$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($efce52b0925ca653$var$p(191, e));
            e.call(d);
        }
    }
}
var $efce52b0925ca653$var$Hh = {}, $efce52b0925ca653$var$Ih = $efce52b0925ca653$var$hg($efce52b0925ca653$var$Hh), $efce52b0925ca653$var$Jh = $efce52b0925ca653$var$hg($efce52b0925ca653$var$Hh), $efce52b0925ca653$var$Kh = $efce52b0925ca653$var$hg($efce52b0925ca653$var$Hh);
function $efce52b0925ca653$var$Lh(a) {
    if (a === $efce52b0925ca653$var$Hh) throw Error($efce52b0925ca653$var$p(174));
    return a;
}
function $efce52b0925ca653$var$Mh(a, b) {
    $efce52b0925ca653$var$H($efce52b0925ca653$var$Kh, b);
    $efce52b0925ca653$var$H($efce52b0925ca653$var$Jh, a);
    $efce52b0925ca653$var$H($efce52b0925ca653$var$Ih, $efce52b0925ca653$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $efce52b0925ca653$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $efce52b0925ca653$var$kb(b, a);
    }
    $efce52b0925ca653$var$G($efce52b0925ca653$var$Ih);
    $efce52b0925ca653$var$H($efce52b0925ca653$var$Ih, b);
}
function $efce52b0925ca653$var$Nh() {
    $efce52b0925ca653$var$G($efce52b0925ca653$var$Ih);
    $efce52b0925ca653$var$G($efce52b0925ca653$var$Jh);
    $efce52b0925ca653$var$G($efce52b0925ca653$var$Kh);
}
function $efce52b0925ca653$var$Oh(a) {
    $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Kh.current);
    var b = $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Ih.current);
    var c = $efce52b0925ca653$var$kb(b, a.type);
    b !== c && ($efce52b0925ca653$var$H($efce52b0925ca653$var$Jh, a), $efce52b0925ca653$var$H($efce52b0925ca653$var$Ih, c));
}
function $efce52b0925ca653$var$Ph(a) {
    $efce52b0925ca653$var$Jh.current === a && ($efce52b0925ca653$var$G($efce52b0925ca653$var$Ih), $efce52b0925ca653$var$G($efce52b0925ca653$var$Jh));
}
var $efce52b0925ca653$var$L = $efce52b0925ca653$var$hg(0);
function $efce52b0925ca653$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $efce52b0925ca653$var$Rh = [];
function $efce52b0925ca653$var$Sh() {
    for(var a = 0; a < $efce52b0925ca653$var$Rh.length; a++)$efce52b0925ca653$var$Rh[a]._workInProgressVersionPrimary = null;
    $efce52b0925ca653$var$Rh.length = 0;
}
var $efce52b0925ca653$var$Th = $efce52b0925ca653$var$va.ReactCurrentDispatcher, $efce52b0925ca653$var$Uh = $efce52b0925ca653$var$va.ReactCurrentBatchConfig, $efce52b0925ca653$var$Vh = 0, $efce52b0925ca653$var$M = null, $efce52b0925ca653$var$N = null, $efce52b0925ca653$var$O = null, $efce52b0925ca653$var$Wh = !1, $efce52b0925ca653$var$Xh = !1, $efce52b0925ca653$var$Yh = 0, $efce52b0925ca653$var$Zh = 0;
function $efce52b0925ca653$var$P() {
    throw Error($efce52b0925ca653$var$p(321));
}
function $efce52b0925ca653$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$efce52b0925ca653$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $efce52b0925ca653$var$ai(a, b, c, d, e, f) {
    $efce52b0925ca653$var$Vh = f;
    $efce52b0925ca653$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $efce52b0925ca653$var$Th.current = null === a || null === a.memoizedState ? $efce52b0925ca653$var$bi : $efce52b0925ca653$var$ci;
    a = c(d, e);
    if ($efce52b0925ca653$var$Xh) {
        f = 0;
        do {
            $efce52b0925ca653$var$Xh = !1;
            $efce52b0925ca653$var$Yh = 0;
            if (25 <= f) throw Error($efce52b0925ca653$var$p(301));
            f += 1;
            $efce52b0925ca653$var$O = $efce52b0925ca653$var$N = null;
            b.updateQueue = null;
            $efce52b0925ca653$var$Th.current = $efce52b0925ca653$var$di;
            a = c(d, e);
        }while ($efce52b0925ca653$var$Xh);
    }
    $efce52b0925ca653$var$Th.current = $efce52b0925ca653$var$ei;
    b = null !== $efce52b0925ca653$var$N && null !== $efce52b0925ca653$var$N.next;
    $efce52b0925ca653$var$Vh = 0;
    $efce52b0925ca653$var$O = $efce52b0925ca653$var$N = $efce52b0925ca653$var$M = null;
    $efce52b0925ca653$var$Wh = !1;
    if (b) throw Error($efce52b0925ca653$var$p(300));
    return a;
}
function $efce52b0925ca653$var$fi() {
    var a = 0 !== $efce52b0925ca653$var$Yh;
    $efce52b0925ca653$var$Yh = 0;
    return a;
}
function $efce52b0925ca653$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $efce52b0925ca653$var$O ? $efce52b0925ca653$var$M.memoizedState = $efce52b0925ca653$var$O = a : $efce52b0925ca653$var$O = $efce52b0925ca653$var$O.next = a;
    return $efce52b0925ca653$var$O;
}
function $efce52b0925ca653$var$hi() {
    if (null === $efce52b0925ca653$var$N) {
        var a = $efce52b0925ca653$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $efce52b0925ca653$var$N.next;
    var b = null === $efce52b0925ca653$var$O ? $efce52b0925ca653$var$M.memoizedState : $efce52b0925ca653$var$O.next;
    if (null !== b) $efce52b0925ca653$var$O = b, $efce52b0925ca653$var$N = a;
    else {
        if (null === a) throw Error($efce52b0925ca653$var$p(310));
        $efce52b0925ca653$var$N = a;
        a = {
            memoizedState: $efce52b0925ca653$var$N.memoizedState,
            baseState: $efce52b0925ca653$var$N.baseState,
            baseQueue: $efce52b0925ca653$var$N.baseQueue,
            queue: $efce52b0925ca653$var$N.queue,
            next: null
        };
        null === $efce52b0925ca653$var$O ? $efce52b0925ca653$var$M.memoizedState = $efce52b0925ca653$var$O = a : $efce52b0925ca653$var$O = $efce52b0925ca653$var$O.next = a;
    }
    return $efce52b0925ca653$var$O;
}
function $efce52b0925ca653$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $efce52b0925ca653$var$ji(a) {
    var b = $efce52b0925ca653$var$hi(), c = b.queue;
    if (null === c) throw Error($efce52b0925ca653$var$p(311));
    c.lastRenderedReducer = a;
    var d = $efce52b0925ca653$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($efce52b0925ca653$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $efce52b0925ca653$var$M.lanes |= n;
                $efce52b0925ca653$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $efce52b0925ca653$var$Ve(d, b.memoizedState) || ($efce52b0925ca653$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $efce52b0925ca653$var$M.lanes |= f, $efce52b0925ca653$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $efce52b0925ca653$var$ki(a) {
    var b = $efce52b0925ca653$var$hi(), c = b.queue;
    if (null === c) throw Error($efce52b0925ca653$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $efce52b0925ca653$var$Ve(f, b.memoizedState) || ($efce52b0925ca653$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $efce52b0925ca653$var$li() {}
function $efce52b0925ca653$var$mi(a, b) {
    var c = $efce52b0925ca653$var$M, d = $efce52b0925ca653$var$hi(), e = b(), f = !$efce52b0925ca653$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $efce52b0925ca653$var$rh = !0);
    d = d.queue;
    $efce52b0925ca653$var$ni($efce52b0925ca653$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $efce52b0925ca653$var$O && $efce52b0925ca653$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $efce52b0925ca653$var$pi(9, $efce52b0925ca653$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $efce52b0925ca653$var$Q) throw Error($efce52b0925ca653$var$p(349));
        0 !== ($efce52b0925ca653$var$Vh & 30) || $efce52b0925ca653$var$ri(c, b, e);
    }
    return e;
}
function $efce52b0925ca653$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $efce52b0925ca653$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $efce52b0925ca653$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $efce52b0925ca653$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $efce52b0925ca653$var$si(b) && $efce52b0925ca653$var$ti(a);
}
function $efce52b0925ca653$var$oi(a, b, c) {
    return c(function() {
        $efce52b0925ca653$var$si(b) && $efce52b0925ca653$var$ti(a);
    });
}
function $efce52b0925ca653$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$efce52b0925ca653$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $efce52b0925ca653$var$ti(a) {
    var b = $efce52b0925ca653$var$wh(a, 1);
    null !== b && $efce52b0925ca653$var$ui(b, a, 1, -1);
}
function $efce52b0925ca653$var$vi(a) {
    var b = $efce52b0925ca653$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $efce52b0925ca653$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $efce52b0925ca653$var$wi.bind(null, $efce52b0925ca653$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $efce52b0925ca653$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $efce52b0925ca653$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $efce52b0925ca653$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $efce52b0925ca653$var$xi() {
    return $efce52b0925ca653$var$hi().memoizedState;
}
function $efce52b0925ca653$var$Ai(a, b, c, d) {
    var e = $efce52b0925ca653$var$gi();
    $efce52b0925ca653$var$M.flags |= a;
    e.memoizedState = $efce52b0925ca653$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $efce52b0925ca653$var$Bi(a, b, c, d) {
    var e = $efce52b0925ca653$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $efce52b0925ca653$var$N) {
        var g = $efce52b0925ca653$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $efce52b0925ca653$var$$h(d, g.deps)) {
            e.memoizedState = $efce52b0925ca653$var$pi(b, c, f, d);
            return;
        }
    }
    $efce52b0925ca653$var$M.flags |= a;
    e.memoizedState = $efce52b0925ca653$var$pi(1 | b, c, f, d);
}
function $efce52b0925ca653$var$Ci(a, b) {
    return $efce52b0925ca653$var$Ai(8390656, 8, a, b);
}
function $efce52b0925ca653$var$ni(a, b) {
    return $efce52b0925ca653$var$Bi(2048, 8, a, b);
}
function $efce52b0925ca653$var$Di(a, b) {
    return $efce52b0925ca653$var$Bi(4, 2, a, b);
}
function $efce52b0925ca653$var$Ei(a, b) {
    return $efce52b0925ca653$var$Bi(4, 4, a, b);
}
function $efce52b0925ca653$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $efce52b0925ca653$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $efce52b0925ca653$var$Bi(4, 4, $efce52b0925ca653$var$Fi.bind(null, b, a), c);
}
function $efce52b0925ca653$var$Hi() {}
function $efce52b0925ca653$var$Ii(a, b) {
    var c = $efce52b0925ca653$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $efce52b0925ca653$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $efce52b0925ca653$var$Ji(a, b) {
    var c = $efce52b0925ca653$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $efce52b0925ca653$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $efce52b0925ca653$var$Ki(a, b, c) {
    if (0 === ($efce52b0925ca653$var$Vh & 21)) return a.baseState && (a.baseState = !1, $efce52b0925ca653$var$rh = !0), a.memoizedState = c;
    $efce52b0925ca653$var$Ve(c, b) || (c = $efce52b0925ca653$var$Kc(), $efce52b0925ca653$var$M.lanes |= c, $efce52b0925ca653$var$Fh |= c, a.baseState = !0);
    return b;
}
function $efce52b0925ca653$var$Li(a, b) {
    var c = $efce52b0925ca653$var$E;
    $efce52b0925ca653$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $efce52b0925ca653$var$Uh.transition;
    $efce52b0925ca653$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $efce52b0925ca653$var$E = c, $efce52b0925ca653$var$Uh.transition = d;
    }
}
function $efce52b0925ca653$var$Mi() {
    return $efce52b0925ca653$var$hi().memoizedState;
}
function $efce52b0925ca653$var$Ni(a, b, c) {
    var d = $efce52b0925ca653$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($efce52b0925ca653$var$Pi(a)) $efce52b0925ca653$var$Qi(b, c);
    else if (c = $efce52b0925ca653$var$vh(a, b, c, d), null !== c) {
        var e = $efce52b0925ca653$var$Ri();
        $efce52b0925ca653$var$ui(c, a, d, e);
        $efce52b0925ca653$var$Si(c, b, d);
    }
    $efce52b0925ca653$var$yc(a, d);
}
function $efce52b0925ca653$var$wi(a, b, c) {
    var d = $efce52b0925ca653$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($efce52b0925ca653$var$Pi(a)) $efce52b0925ca653$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($efce52b0925ca653$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $efce52b0925ca653$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $efce52b0925ca653$var$vh(a, b, e, d);
        null !== c && (e = $efce52b0925ca653$var$Ri(), $efce52b0925ca653$var$ui(c, a, d, e), $efce52b0925ca653$var$Si(c, b, d));
    }
    $efce52b0925ca653$var$yc(a, d);
}
function $efce52b0925ca653$var$Pi(a) {
    var b = a.alternate;
    return a === $efce52b0925ca653$var$M || null !== b && b === $efce52b0925ca653$var$M;
}
function $efce52b0925ca653$var$Qi(a, b) {
    $efce52b0925ca653$var$Xh = $efce52b0925ca653$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $efce52b0925ca653$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $efce52b0925ca653$var$Oc(a, c);
    }
}
var $efce52b0925ca653$var$ei = {
    readContext: $efce52b0925ca653$var$sh,
    useCallback: $efce52b0925ca653$var$P,
    useContext: $efce52b0925ca653$var$P,
    useEffect: $efce52b0925ca653$var$P,
    useImperativeHandle: $efce52b0925ca653$var$P,
    useInsertionEffect: $efce52b0925ca653$var$P,
    useLayoutEffect: $efce52b0925ca653$var$P,
    useMemo: $efce52b0925ca653$var$P,
    useReducer: $efce52b0925ca653$var$P,
    useRef: $efce52b0925ca653$var$P,
    useState: $efce52b0925ca653$var$P,
    useDebugValue: $efce52b0925ca653$var$P,
    useDeferredValue: $efce52b0925ca653$var$P,
    useTransition: $efce52b0925ca653$var$P,
    useMutableSource: $efce52b0925ca653$var$P,
    useSyncExternalStore: $efce52b0925ca653$var$P,
    useId: $efce52b0925ca653$var$P,
    unstable_isNewReconciler: !1
}, $efce52b0925ca653$var$bi = {
    readContext: $efce52b0925ca653$var$sh,
    useCallback: function(a, b) {
        $efce52b0925ca653$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $efce52b0925ca653$var$sh,
    useEffect: $efce52b0925ca653$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $efce52b0925ca653$var$Ai(4194308, 4, $efce52b0925ca653$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $efce52b0925ca653$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $efce52b0925ca653$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $efce52b0925ca653$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $efce52b0925ca653$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $efce52b0925ca653$var$Ni.bind(null, $efce52b0925ca653$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $efce52b0925ca653$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $efce52b0925ca653$var$vi,
    useDebugValue: $efce52b0925ca653$var$Hi,
    useDeferredValue: function(a) {
        return $efce52b0925ca653$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $efce52b0925ca653$var$vi(!1), b = a[0];
        a = $efce52b0925ca653$var$Li.bind(null, a[1]);
        $efce52b0925ca653$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $efce52b0925ca653$var$M, e = $efce52b0925ca653$var$gi();
        if ($efce52b0925ca653$var$J) {
            if (void 0 === c) throw Error($efce52b0925ca653$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $efce52b0925ca653$var$Q) throw Error($efce52b0925ca653$var$p(349));
            0 !== ($efce52b0925ca653$var$Vh & 30) || $efce52b0925ca653$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $efce52b0925ca653$var$Ci($efce52b0925ca653$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $efce52b0925ca653$var$pi(9, $efce52b0925ca653$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $efce52b0925ca653$var$gi(), b = $efce52b0925ca653$var$Q.identifierPrefix;
        if ($efce52b0925ca653$var$J) {
            var c = $efce52b0925ca653$var$Gg;
            var d = $efce52b0925ca653$var$Fg;
            c = (d & ~(1 << 32 - $efce52b0925ca653$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $efce52b0925ca653$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $efce52b0925ca653$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $efce52b0925ca653$var$ci = {
    readContext: $efce52b0925ca653$var$sh,
    useCallback: $efce52b0925ca653$var$Ii,
    useContext: $efce52b0925ca653$var$sh,
    useEffect: $efce52b0925ca653$var$ni,
    useImperativeHandle: $efce52b0925ca653$var$Gi,
    useInsertionEffect: $efce52b0925ca653$var$Di,
    useLayoutEffect: $efce52b0925ca653$var$Ei,
    useMemo: $efce52b0925ca653$var$Ji,
    useReducer: $efce52b0925ca653$var$ji,
    useRef: $efce52b0925ca653$var$xi,
    useState: function() {
        return $efce52b0925ca653$var$ji($efce52b0925ca653$var$ii);
    },
    useDebugValue: $efce52b0925ca653$var$Hi,
    useDeferredValue: function(a) {
        var b = $efce52b0925ca653$var$hi();
        return $efce52b0925ca653$var$Ki(b, $efce52b0925ca653$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $efce52b0925ca653$var$ji($efce52b0925ca653$var$ii)[0], b = $efce52b0925ca653$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $efce52b0925ca653$var$li,
    useSyncExternalStore: $efce52b0925ca653$var$mi,
    useId: $efce52b0925ca653$var$Mi,
    unstable_isNewReconciler: !1
}, $efce52b0925ca653$var$di = {
    readContext: $efce52b0925ca653$var$sh,
    useCallback: $efce52b0925ca653$var$Ii,
    useContext: $efce52b0925ca653$var$sh,
    useEffect: $efce52b0925ca653$var$ni,
    useImperativeHandle: $efce52b0925ca653$var$Gi,
    useInsertionEffect: $efce52b0925ca653$var$Di,
    useLayoutEffect: $efce52b0925ca653$var$Ei,
    useMemo: $efce52b0925ca653$var$Ji,
    useReducer: $efce52b0925ca653$var$ki,
    useRef: $efce52b0925ca653$var$xi,
    useState: function() {
        return $efce52b0925ca653$var$ki($efce52b0925ca653$var$ii);
    },
    useDebugValue: $efce52b0925ca653$var$Hi,
    useDeferredValue: function(a) {
        var b = $efce52b0925ca653$var$hi();
        return null === $efce52b0925ca653$var$N ? b.memoizedState = a : $efce52b0925ca653$var$Ki(b, $efce52b0925ca653$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $efce52b0925ca653$var$ki($efce52b0925ca653$var$ii)[0], b = $efce52b0925ca653$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $efce52b0925ca653$var$li,
    useSyncExternalStore: $efce52b0925ca653$var$mi,
    useId: $efce52b0925ca653$var$Mi,
    unstable_isNewReconciler: !1
}, $efce52b0925ca653$var$Ti = $h0ns1.unstable_now, $efce52b0925ca653$var$Ui = 0, $efce52b0925ca653$var$Vi = -1, $efce52b0925ca653$var$Wi = -1, $efce52b0925ca653$var$Xi = -1, $efce52b0925ca653$var$Yi = !1, $efce52b0925ca653$var$Zi = !1;
function $efce52b0925ca653$var$$i(a, b) {
    if (0 <= $efce52b0925ca653$var$Wi) {
        var c = $efce52b0925ca653$var$Ti() - $efce52b0925ca653$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $efce52b0925ca653$var$Wi = -1;
    }
}
function $efce52b0925ca653$var$aj(a) {
    if (0 <= $efce52b0925ca653$var$Vi) {
        var b = $efce52b0925ca653$var$Ti() - $efce52b0925ca653$var$Vi;
        $efce52b0925ca653$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $efce52b0925ca653$var$bj(a) {
    if (0 <= $efce52b0925ca653$var$Xi) {
        var b = $efce52b0925ca653$var$Ti() - $efce52b0925ca653$var$Xi;
        $efce52b0925ca653$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $efce52b0925ca653$var$cj() {
    $efce52b0925ca653$var$Vi = $efce52b0925ca653$var$Ti();
}
function $efce52b0925ca653$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $efce52b0925ca653$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $efce52b0925ca653$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $efce52b0925ca653$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $efce52b0925ca653$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $efce52b0925ca653$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $efce52b0925ca653$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $efce52b0925ca653$var$Ri(), e = $efce52b0925ca653$var$Oi(a), f = $efce52b0925ca653$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $efce52b0925ca653$var$Bh(a, f, e);
        null !== b && ($efce52b0925ca653$var$ui(b, a, e, d), $efce52b0925ca653$var$Ch(b, a, e));
        $efce52b0925ca653$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $efce52b0925ca653$var$Ri(), e = $efce52b0925ca653$var$Oi(a), f = $efce52b0925ca653$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $efce52b0925ca653$var$Bh(a, f, e);
        null !== b && ($efce52b0925ca653$var$ui(b, a, e, d), $efce52b0925ca653$var$Ch(b, a, e));
        $efce52b0925ca653$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $efce52b0925ca653$var$Ri(), d = $efce52b0925ca653$var$Oi(a), e = $efce52b0925ca653$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $efce52b0925ca653$var$Bh(a, e, d);
        null !== b && ($efce52b0925ca653$var$ui(b, a, d, c), $efce52b0925ca653$var$Ch(b, a, d));
        null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markForceUpdateScheduled && $efce52b0925ca653$var$B.markForceUpdateScheduled(a, d);
    }
};
function $efce52b0925ca653$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$efce52b0925ca653$var$We(c, d) || !$efce52b0925ca653$var$We(e, f) : !0;
}
function $efce52b0925ca653$var$ij(a, b, c) {
    var d = !1, e = $efce52b0925ca653$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $efce52b0925ca653$var$sh(f) : (e = $efce52b0925ca653$var$mg(b) ? $efce52b0925ca653$var$kg : $efce52b0925ca653$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $efce52b0925ca653$var$lg(a, e) : $efce52b0925ca653$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $efce52b0925ca653$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $efce52b0925ca653$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $efce52b0925ca653$var$gj.enqueueReplaceState(b, b.state, null);
}
function $efce52b0925ca653$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $efce52b0925ca653$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $efce52b0925ca653$var$sh(f) : (f = $efce52b0925ca653$var$mg(b) ? $efce52b0925ca653$var$kg : $efce52b0925ca653$var$I.current, e.context = $efce52b0925ca653$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($efce52b0925ca653$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $efce52b0925ca653$var$gj.enqueueReplaceState(e, e.state, null), $efce52b0925ca653$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $efce52b0925ca653$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $efce52b0925ca653$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $efce52b0925ca653$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $efce52b0925ca653$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $efce52b0925ca653$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $efce52b0925ca653$var$pj(a, b, c) {
    c = $efce52b0925ca653$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $efce52b0925ca653$var$qj || ($efce52b0925ca653$var$qj = !0, $efce52b0925ca653$var$rj = d);
        $efce52b0925ca653$var$nj(a, b);
    };
    return c;
}
function $efce52b0925ca653$var$sj(a, b, c) {
    c = $efce52b0925ca653$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $efce52b0925ca653$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $efce52b0925ca653$var$nj(a, b);
        "function" !== typeof d && (null === $efce52b0925ca653$var$tj ? $efce52b0925ca653$var$tj = new Set([
            this
        ]) : $efce52b0925ca653$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $efce52b0925ca653$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $efce52b0925ca653$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $efce52b0925ca653$var$vj.bind(null, a, b, c), $efce52b0925ca653$var$mc && $efce52b0925ca653$var$wj(a, c), b.then(d, d));
}
function $efce52b0925ca653$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $efce52b0925ca653$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $efce52b0925ca653$var$Ah(-1, 1), b.tag = 2, $efce52b0925ca653$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $efce52b0925ca653$var$zj = $efce52b0925ca653$var$va.ReactCurrentOwner, $efce52b0925ca653$var$rh = !1;
function $efce52b0925ca653$var$Aj(a, b, c, d) {
    b.child = null === a ? $efce52b0925ca653$var$ih(b, null, c, d) : $efce52b0925ca653$var$hh(b, a.child, c, d);
}
function $efce52b0925ca653$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $efce52b0925ca653$var$qh(b, e);
    $efce52b0925ca653$var$sc(b);
    d = $efce52b0925ca653$var$ai(a, b, c, d, f, e);
    c = $efce52b0925ca653$var$fi();
    $efce52b0925ca653$var$tc();
    if (null !== a && !$efce52b0925ca653$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $efce52b0925ca653$var$Cj(a, b, e);
    $efce52b0925ca653$var$J && c && $efce52b0925ca653$var$Jg(b);
    b.flags |= 1;
    $efce52b0925ca653$var$Aj(a, b, d, e);
    return b.child;
}
function $efce52b0925ca653$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$efce52b0925ca653$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $efce52b0925ca653$var$Fj(a, b, f, d, e);
        a = $efce52b0925ca653$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $efce52b0925ca653$var$We;
        if (c(g, d) && a.ref === b.ref) return $efce52b0925ca653$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $efce52b0925ca653$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $efce52b0925ca653$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($efce52b0925ca653$var$We(f, d) && a.ref === b.ref) {
            if ($efce52b0925ca653$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($efce52b0925ca653$var$rh = !0);
            else return b.lanes = a.lanes, $efce52b0925ca653$var$Cj(a, b, e);
        }
    }
    return $efce52b0925ca653$var$Gj(a, b, c, d, e);
}
function $efce52b0925ca653$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $efce52b0925ca653$var$H($efce52b0925ca653$var$Ij, $efce52b0925ca653$var$Jj), $efce52b0925ca653$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $efce52b0925ca653$var$H($efce52b0925ca653$var$Ij, $efce52b0925ca653$var$Jj), $efce52b0925ca653$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $efce52b0925ca653$var$H($efce52b0925ca653$var$Ij, $efce52b0925ca653$var$Jj);
            $efce52b0925ca653$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $efce52b0925ca653$var$H($efce52b0925ca653$var$Ij, $efce52b0925ca653$var$Jj), $efce52b0925ca653$var$Jj |= d;
    $efce52b0925ca653$var$Aj(a, b, e, c);
    return b.child;
}
function $efce52b0925ca653$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $efce52b0925ca653$var$Gj(a, b, c, d, e) {
    var f = $efce52b0925ca653$var$mg(c) ? $efce52b0925ca653$var$kg : $efce52b0925ca653$var$I.current;
    f = $efce52b0925ca653$var$lg(b, f);
    $efce52b0925ca653$var$qh(b, e);
    $efce52b0925ca653$var$sc(b);
    c = $efce52b0925ca653$var$ai(a, b, c, d, f, e);
    d = $efce52b0925ca653$var$fi();
    $efce52b0925ca653$var$tc();
    if (null !== a && !$efce52b0925ca653$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $efce52b0925ca653$var$Cj(a, b, e);
    $efce52b0925ca653$var$J && d && $efce52b0925ca653$var$Jg(b);
    b.flags |= 1;
    $efce52b0925ca653$var$Aj(a, b, c, e);
    return b.child;
}
function $efce52b0925ca653$var$Lj(a, b, c, d, e) {
    if ($efce52b0925ca653$var$mg(c)) {
        var f = !0;
        $efce52b0925ca653$var$qg(b);
    } else f = !1;
    $efce52b0925ca653$var$qh(b, e);
    if (null === b.stateNode) $efce52b0925ca653$var$Mj(a, b), $efce52b0925ca653$var$ij(b, c, d), $efce52b0925ca653$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $efce52b0925ca653$var$sh(l) : (l = $efce52b0925ca653$var$mg(c) ? $efce52b0925ca653$var$kg : $efce52b0925ca653$var$I.current, l = $efce52b0925ca653$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $efce52b0925ca653$var$jj(b, g, d, l);
        $efce52b0925ca653$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $efce52b0925ca653$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $efce52b0925ca653$var$jg.current || $efce52b0925ca653$var$xh ? ("function" === typeof n && ($efce52b0925ca653$var$fj(b, c, n, d), k = b.memoizedState), (h = $efce52b0925ca653$var$xh || $efce52b0925ca653$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $efce52b0925ca653$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $efce52b0925ca653$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $efce52b0925ca653$var$sh(k) : (k = $efce52b0925ca653$var$mg(c) ? $efce52b0925ca653$var$kg : $efce52b0925ca653$var$I.current, k = $efce52b0925ca653$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $efce52b0925ca653$var$jj(b, g, d, k);
        $efce52b0925ca653$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $efce52b0925ca653$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $efce52b0925ca653$var$jg.current || $efce52b0925ca653$var$xh ? ("function" === typeof z && ($efce52b0925ca653$var$fj(b, c, z, d), m = b.memoizedState), (l = $efce52b0925ca653$var$xh || $efce52b0925ca653$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $efce52b0925ca653$var$Nj(a, b, c, d, f, e);
}
function $efce52b0925ca653$var$Nj(a, b, c, d, e, f) {
    $efce52b0925ca653$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $efce52b0925ca653$var$rg(b, c, !1), $efce52b0925ca653$var$Cj(a, b, f);
    d = b.stateNode;
    $efce52b0925ca653$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $efce52b0925ca653$var$Wi = -1;
    } else $efce52b0925ca653$var$sc(b), h = d.render(), $efce52b0925ca653$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $efce52b0925ca653$var$hh(b, a.child, null, f), b.child = $efce52b0925ca653$var$hh(b, null, g, f)) : $efce52b0925ca653$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $efce52b0925ca653$var$rg(b, c, !0);
    return b.child;
}
function $efce52b0925ca653$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $efce52b0925ca653$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $efce52b0925ca653$var$og(a, b.context, !1);
    $efce52b0925ca653$var$Mh(a, b.containerInfo);
}
function $efce52b0925ca653$var$Rj(a, b, c, d, e) {
    $efce52b0925ca653$var$Wg();
    $efce52b0925ca653$var$Xg(e);
    b.flags |= 256;
    $efce52b0925ca653$var$Aj(a, b, c, d);
    return b.child;
}
var $efce52b0925ca653$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $efce52b0925ca653$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $efce52b0925ca653$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $efce52b0925ca653$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $efce52b0925ca653$var$H($efce52b0925ca653$var$L, e & 1);
    if (null === a) {
        $efce52b0925ca653$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $efce52b0925ca653$var$Vj(g, d, 0, null), a = $efce52b0925ca653$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $efce52b0925ca653$var$Tj(c), b.memoizedState = $efce52b0925ca653$var$Sj, a) : $efce52b0925ca653$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $efce52b0925ca653$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $efce52b0925ca653$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $efce52b0925ca653$var$ch(h, f) : (f = $efce52b0925ca653$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $efce52b0925ca653$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $efce52b0925ca653$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $efce52b0925ca653$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $efce52b0925ca653$var$Wj(a, b) {
    b = $efce52b0925ca653$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $efce52b0925ca653$var$Yj(a, b, c, d) {
    null !== d && $efce52b0925ca653$var$Xg(d);
    $efce52b0925ca653$var$hh(b, a.child, null, c);
    a = $efce52b0925ca653$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $efce52b0925ca653$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $efce52b0925ca653$var$mj(Error($efce52b0925ca653$var$p(422))), $efce52b0925ca653$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $efce52b0925ca653$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $efce52b0925ca653$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $efce52b0925ca653$var$hh(b, a.child, null, g);
        b.child.memoizedState = $efce52b0925ca653$var$Tj(g);
        b.memoizedState = $efce52b0925ca653$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $efce52b0925ca653$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($efce52b0925ca653$var$p(419));
        d = $efce52b0925ca653$var$mj(f, d, void 0);
        return $efce52b0925ca653$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($efce52b0925ca653$var$rh || h) {
        d = $efce52b0925ca653$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $efce52b0925ca653$var$wh(a, e), $efce52b0925ca653$var$ui(d, a, e, -1));
        }
        $efce52b0925ca653$var$Zj();
        d = $efce52b0925ca653$var$mj(Error($efce52b0925ca653$var$p(421)));
        return $efce52b0925ca653$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $efce52b0925ca653$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $efce52b0925ca653$var$Mg = $efce52b0925ca653$var$Zf(e.nextSibling);
    $efce52b0925ca653$var$Lg = b;
    $efce52b0925ca653$var$J = !0;
    $efce52b0925ca653$var$Ng = null;
    null !== a && ($efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg++] = $efce52b0925ca653$var$Fg, $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg++] = $efce52b0925ca653$var$Gg, $efce52b0925ca653$var$Cg[$efce52b0925ca653$var$Dg++] = $efce52b0925ca653$var$Eg, $efce52b0925ca653$var$Fg = a.id, $efce52b0925ca653$var$Gg = a.overflow, $efce52b0925ca653$var$Eg = b);
    b = $efce52b0925ca653$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $efce52b0925ca653$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $efce52b0925ca653$var$ph(a.return, b, c);
}
function $efce52b0925ca653$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $efce52b0925ca653$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $efce52b0925ca653$var$Aj(a, b, d.children, c);
    d = $efce52b0925ca653$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $efce52b0925ca653$var$bk(a, c, b);
            else if (19 === a.tag) $efce52b0925ca653$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $efce52b0925ca653$var$H($efce52b0925ca653$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $efce52b0925ca653$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $efce52b0925ca653$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $efce52b0925ca653$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $efce52b0925ca653$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $efce52b0925ca653$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $efce52b0925ca653$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $efce52b0925ca653$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $efce52b0925ca653$var$Wi = -1;
    $efce52b0925ca653$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($efce52b0925ca653$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $efce52b0925ca653$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $efce52b0925ca653$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $efce52b0925ca653$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $efce52b0925ca653$var$Oj(b);
            $efce52b0925ca653$var$Wg();
            break;
        case 5:
            $efce52b0925ca653$var$Oh(b);
            break;
        case 1:
            $efce52b0925ca653$var$mg(b.type) && $efce52b0925ca653$var$qg(b);
            break;
        case 4:
            $efce52b0925ca653$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $efce52b0925ca653$var$H($efce52b0925ca653$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $efce52b0925ca653$var$H($efce52b0925ca653$var$L, $efce52b0925ca653$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $efce52b0925ca653$var$Uj(a, b, c);
                $efce52b0925ca653$var$H($efce52b0925ca653$var$L, $efce52b0925ca653$var$L.current & 1);
                a = $efce52b0925ca653$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $efce52b0925ca653$var$H($efce52b0925ca653$var$L, $efce52b0925ca653$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $efce52b0925ca653$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $efce52b0925ca653$var$H($efce52b0925ca653$var$L, $efce52b0925ca653$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $efce52b0925ca653$var$Hj(a, b, c);
    }
    return $efce52b0925ca653$var$Cj(a, b, c);
}
var $efce52b0925ca653$var$fk, $efce52b0925ca653$var$gk, $efce52b0925ca653$var$hk, $efce52b0925ca653$var$ik;
$efce52b0925ca653$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$efce52b0925ca653$var$gk = function() {};
$efce52b0925ca653$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $efce52b0925ca653$var$Ya(a, e);
                d = $efce52b0925ca653$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $efce52b0925ca653$var$u({}, e, {
                    value: void 0
                });
                d = $efce52b0925ca653$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $efce52b0925ca653$var$fb(a, e);
                d = $efce52b0925ca653$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $efce52b0925ca653$var$Pf);
        }
        $efce52b0925ca653$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($efce52b0925ca653$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($efce52b0925ca653$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $efce52b0925ca653$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$efce52b0925ca653$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $efce52b0925ca653$var$jk(a, b) {
    if (!$efce52b0925ca653$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $efce52b0925ca653$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $efce52b0925ca653$var$kk(a, b, c) {
    var d = b.pendingProps;
    $efce52b0925ca653$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $efce52b0925ca653$var$S(b), null;
        case 1:
            return $efce52b0925ca653$var$mg(b.type) && $efce52b0925ca653$var$ng(), $efce52b0925ca653$var$S(b), null;
        case 3:
            d = b.stateNode;
            $efce52b0925ca653$var$Nh();
            $efce52b0925ca653$var$G($efce52b0925ca653$var$jg);
            $efce52b0925ca653$var$G($efce52b0925ca653$var$I);
            $efce52b0925ca653$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $efce52b0925ca653$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $efce52b0925ca653$var$Ng && ($efce52b0925ca653$var$lk($efce52b0925ca653$var$Ng), $efce52b0925ca653$var$Ng = null));
            $efce52b0925ca653$var$gk(a, b);
            $efce52b0925ca653$var$S(b);
            return null;
        case 5:
            $efce52b0925ca653$var$Ph(b);
            var e = $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $efce52b0925ca653$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($efce52b0925ca653$var$p(166));
                    $efce52b0925ca653$var$S(b);
                    return null;
                }
                a = $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Ih.current);
                if ($efce52b0925ca653$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$efce52b0925ca653$var$bg] = b;
                    d[$efce52b0925ca653$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $efce52b0925ca653$var$F("cancel", d);
                            $efce52b0925ca653$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $efce52b0925ca653$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $efce52b0925ca653$var$zf.length; e++)$efce52b0925ca653$var$F($efce52b0925ca653$var$zf[e], d);
                            break;
                        case "source":
                            $efce52b0925ca653$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $efce52b0925ca653$var$F("error", d);
                            $efce52b0925ca653$var$F("load", d);
                            break;
                        case "details":
                            $efce52b0925ca653$var$F("toggle", d);
                            break;
                        case "input":
                            $efce52b0925ca653$var$Za(d, c);
                            $efce52b0925ca653$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $efce52b0925ca653$var$F("invalid", d);
                            break;
                        case "textarea":
                            $efce52b0925ca653$var$gb(d, c), $efce52b0925ca653$var$F("invalid", d);
                    }
                    $efce52b0925ca653$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $efce52b0925ca653$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $efce52b0925ca653$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $efce52b0925ca653$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $efce52b0925ca653$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $efce52b0925ca653$var$Va(d);
                            $efce52b0925ca653$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $efce52b0925ca653$var$Va(d);
                            $efce52b0925ca653$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $efce52b0925ca653$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $efce52b0925ca653$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$efce52b0925ca653$var$bg] = b;
                    a[$efce52b0925ca653$var$cg] = d;
                    $efce52b0925ca653$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $efce52b0925ca653$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $efce52b0925ca653$var$F("cancel", a);
                                $efce52b0925ca653$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $efce52b0925ca653$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $efce52b0925ca653$var$zf.length; e++)$efce52b0925ca653$var$F($efce52b0925ca653$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $efce52b0925ca653$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $efce52b0925ca653$var$F("error", a);
                                $efce52b0925ca653$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $efce52b0925ca653$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $efce52b0925ca653$var$Za(a, d);
                                e = $efce52b0925ca653$var$Ya(a, d);
                                $efce52b0925ca653$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $efce52b0925ca653$var$u({}, d, {
                                    value: void 0
                                });
                                $efce52b0925ca653$var$F("invalid", a);
                                break;
                            case "textarea":
                                $efce52b0925ca653$var$gb(a, d);
                                e = $efce52b0925ca653$var$fb(a, d);
                                $efce52b0925ca653$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $efce52b0925ca653$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $efce52b0925ca653$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $efce52b0925ca653$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $efce52b0925ca653$var$ob(a, k) : "number" === typeof k && $efce52b0925ca653$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($efce52b0925ca653$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $efce52b0925ca653$var$F("scroll", a) : null != k && $efce52b0925ca653$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $efce52b0925ca653$var$Va(a);
                                $efce52b0925ca653$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $efce52b0925ca653$var$Va(a);
                                $efce52b0925ca653$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $efce52b0925ca653$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $efce52b0925ca653$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $efce52b0925ca653$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $efce52b0925ca653$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $efce52b0925ca653$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $efce52b0925ca653$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($efce52b0925ca653$var$p(166));
                a = $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Kh.current);
                $efce52b0925ca653$var$Lh($efce52b0925ca653$var$Ih.current);
                if ($efce52b0925ca653$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$efce52b0925ca653$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $efce52b0925ca653$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $efce52b0925ca653$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $efce52b0925ca653$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$efce52b0925ca653$var$bg] = b, b.stateNode = d;
            }
            $efce52b0925ca653$var$S(b);
            return null;
        case 13:
            $efce52b0925ca653$var$G($efce52b0925ca653$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($efce52b0925ca653$var$J && null !== $efce52b0925ca653$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $efce52b0925ca653$var$Vg(), $efce52b0925ca653$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $efce52b0925ca653$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($efce52b0925ca653$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($efce52b0925ca653$var$p(317));
                        f[$efce52b0925ca653$var$bg] = b;
                        $efce52b0925ca653$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $efce52b0925ca653$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $efce52b0925ca653$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $efce52b0925ca653$var$Ng && ($efce52b0925ca653$var$lk($efce52b0925ca653$var$Ng), $efce52b0925ca653$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $efce52b0925ca653$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($efce52b0925ca653$var$L.current & 1) ? 0 === $efce52b0925ca653$var$T && ($efce52b0925ca653$var$T = 3) : $efce52b0925ca653$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $efce52b0925ca653$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $efce52b0925ca653$var$Nh(), $efce52b0925ca653$var$gk(a, b), null === a && $efce52b0925ca653$var$Gf(b.stateNode.containerInfo), $efce52b0925ca653$var$S(b), null;
        case 10:
            return $efce52b0925ca653$var$oh(b.type._context), $efce52b0925ca653$var$S(b), null;
        case 17:
            return $efce52b0925ca653$var$mg(b.type) && $efce52b0925ca653$var$ng(), $efce52b0925ca653$var$S(b), null;
        case 19:
            $efce52b0925ca653$var$G($efce52b0925ca653$var$L);
            f = b.memoizedState;
            if (null === f) return $efce52b0925ca653$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $efce52b0925ca653$var$jk(f, !1);
                else {
                    if (0 !== $efce52b0925ca653$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $efce52b0925ca653$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $efce52b0925ca653$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $efce52b0925ca653$var$H($efce52b0925ca653$var$L, $efce52b0925ca653$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $efce52b0925ca653$var$A() > $efce52b0925ca653$var$mk && (b.flags |= 128, d = !0, $efce52b0925ca653$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $efce52b0925ca653$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $efce52b0925ca653$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$efce52b0925ca653$var$J) return $efce52b0925ca653$var$S(b), null;
                    } else 2 * $efce52b0925ca653$var$A() - f.renderingStartTime > $efce52b0925ca653$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $efce52b0925ca653$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $efce52b0925ca653$var$A(), b.sibling = null, a = $efce52b0925ca653$var$L.current, $efce52b0925ca653$var$H($efce52b0925ca653$var$L, d ? a & 1 | 2 : a & 1), b;
            $efce52b0925ca653$var$S(b);
            return null;
        case 22:
        case 23:
            return $efce52b0925ca653$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($efce52b0925ca653$var$Jj & 1073741824) && ($efce52b0925ca653$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $efce52b0925ca653$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($efce52b0925ca653$var$p(156, b.tag));
}
function $efce52b0925ca653$var$ok(a, b) {
    $efce52b0925ca653$var$Kg(b);
    switch(b.tag){
        case 1:
            return $efce52b0925ca653$var$mg(b.type) && $efce52b0925ca653$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $efce52b0925ca653$var$dj(b), b) : null;
        case 3:
            return $efce52b0925ca653$var$Nh(), $efce52b0925ca653$var$G($efce52b0925ca653$var$jg), $efce52b0925ca653$var$G($efce52b0925ca653$var$I), $efce52b0925ca653$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $efce52b0925ca653$var$Ph(b), null;
        case 13:
            $efce52b0925ca653$var$G($efce52b0925ca653$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($efce52b0925ca653$var$p(340));
                $efce52b0925ca653$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $efce52b0925ca653$var$dj(b), b) : null;
        case 19:
            return $efce52b0925ca653$var$G($efce52b0925ca653$var$L), null;
        case 4:
            return $efce52b0925ca653$var$Nh(), null;
        case 10:
            return $efce52b0925ca653$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $efce52b0925ca653$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $efce52b0925ca653$var$pk = !1, $efce52b0925ca653$var$qk = !1, $efce52b0925ca653$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $efce52b0925ca653$var$U = null, $efce52b0925ca653$var$sk = null, $efce52b0925ca653$var$tk = null;
function $efce52b0925ca653$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $efce52b0925ca653$var$cj(), b.componentWillUnmount();
    } finally{
        $efce52b0925ca653$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $efce52b0925ca653$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $efce52b0925ca653$var$cj(), c(null);
            } finally{
                $efce52b0925ca653$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $efce52b0925ca653$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $efce52b0925ca653$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $efce52b0925ca653$var$W(a, b, d);
    }
}
var $efce52b0925ca653$var$xk = !1;
function $efce52b0925ca653$var$yk(a, b) {
    $efce52b0925ca653$var$Qf = $efce52b0925ca653$var$rd;
    a = $efce52b0925ca653$var$$e();
    if ($efce52b0925ca653$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $efce52b0925ca653$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $efce52b0925ca653$var$rd = !1;
    for($efce52b0925ca653$var$U = b; null !== $efce52b0925ca653$var$U;)if (b = $efce52b0925ca653$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $efce52b0925ca653$var$U = a;
    else for(; null !== $efce52b0925ca653$var$U;){
        b = $efce52b0925ca653$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $efce52b0925ca653$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($efce52b0925ca653$var$p(163));
            }
        } catch (D) {
            $efce52b0925ca653$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $efce52b0925ca653$var$U = a;
            break;
        }
        $efce52b0925ca653$var$U = b.return;
    }
    m = $efce52b0925ca653$var$xk;
    $efce52b0925ca653$var$xk = !1;
    return m;
}
function $efce52b0925ca653$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentPassiveEffectUnmountStarted && $efce52b0925ca653$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $efce52b0925ca653$var$uc(b), $efce52b0925ca653$var$wk(b, c, f), 0 !== (a & 8) ? null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentPassiveEffectUnmountStopped && $efce52b0925ca653$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $efce52b0925ca653$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $efce52b0925ca653$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentPassiveEffectMountStarted && $efce52b0925ca653$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentLayoutEffectMountStarted && $efce52b0925ca653$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentPassiveEffectMountStopped && $efce52b0925ca653$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentLayoutEffectMountStopped && $efce52b0925ca653$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $efce52b0925ca653$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $efce52b0925ca653$var$cj(), b(c);
            } finally{
                $efce52b0925ca653$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $efce52b0925ca653$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $efce52b0925ca653$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$efce52b0925ca653$var$bg], delete b[$efce52b0925ca653$var$cg], delete b[$efce52b0925ca653$var$Cf], delete b[$efce52b0925ca653$var$dg], delete b[$efce52b0925ca653$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $efce52b0925ca653$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $efce52b0925ca653$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $efce52b0925ca653$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $efce52b0925ca653$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $efce52b0925ca653$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($efce52b0925ca653$var$Fk(a, b, c), a = a.sibling; null !== a;)$efce52b0925ca653$var$Fk(a, b, c), a = a.sibling;
}
function $efce52b0925ca653$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($efce52b0925ca653$var$Gk(a, b, c), a = a.sibling; null !== a;)$efce52b0925ca653$var$Gk(a, b, c), a = a.sibling;
}
var $efce52b0925ca653$var$X = null, $efce52b0925ca653$var$Hk = !1;
function $efce52b0925ca653$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$efce52b0925ca653$var$Jk(a, b, c), c = c.sibling;
}
function $efce52b0925ca653$var$Jk(a, b, c) {
    if ($efce52b0925ca653$var$lc && "function" === typeof $efce52b0925ca653$var$lc.onCommitFiberUnmount) try {
        $efce52b0925ca653$var$lc.onCommitFiberUnmount($efce52b0925ca653$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $efce52b0925ca653$var$qk || $efce52b0925ca653$var$vk(c, b);
        case 6:
            var d = $efce52b0925ca653$var$X, e = $efce52b0925ca653$var$Hk;
            $efce52b0925ca653$var$X = null;
            $efce52b0925ca653$var$Ik(a, b, c);
            $efce52b0925ca653$var$X = d;
            $efce52b0925ca653$var$Hk = e;
            null !== $efce52b0925ca653$var$X && ($efce52b0925ca653$var$Hk ? (a = $efce52b0925ca653$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $efce52b0925ca653$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $efce52b0925ca653$var$X && ($efce52b0925ca653$var$Hk ? (a = $efce52b0925ca653$var$X, c = c.stateNode, 8 === a.nodeType ? $efce52b0925ca653$var$Yf(a.parentNode, c) : 1 === a.nodeType && $efce52b0925ca653$var$Yf(a, c), $efce52b0925ca653$var$pd(a)) : $efce52b0925ca653$var$Yf($efce52b0925ca653$var$X, c.stateNode));
            break;
        case 4:
            d = $efce52b0925ca653$var$X;
            e = $efce52b0925ca653$var$Hk;
            $efce52b0925ca653$var$X = c.stateNode.containerInfo;
            $efce52b0925ca653$var$Hk = !0;
            $efce52b0925ca653$var$Ik(a, b, c);
            $efce52b0925ca653$var$X = d;
            $efce52b0925ca653$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$efce52b0925ca653$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $efce52b0925ca653$var$wk(c, b, g) : 0 !== (f & 4) && ($efce52b0925ca653$var$uc(c), c.mode & 2 ? ($efce52b0925ca653$var$cj(), $efce52b0925ca653$var$wk(c, b, g), $efce52b0925ca653$var$aj(c)) : $efce52b0925ca653$var$wk(c, b, g), $efce52b0925ca653$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $efce52b0925ca653$var$Ik(a, b, c);
            break;
        case 1:
            if (!$efce52b0925ca653$var$qk && ($efce52b0925ca653$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $efce52b0925ca653$var$uk(c, d);
            } catch (h) {
                $efce52b0925ca653$var$W(c, b, h);
            }
            $efce52b0925ca653$var$Ik(a, b, c);
            break;
        case 21:
            $efce52b0925ca653$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($efce52b0925ca653$var$qk = (d = $efce52b0925ca653$var$qk) || null !== c.memoizedState, $efce52b0925ca653$var$Ik(a, b, c), $efce52b0925ca653$var$qk = d) : $efce52b0925ca653$var$Ik(a, b, c);
            break;
        default:
            $efce52b0925ca653$var$Ik(a, b, c);
    }
}
function $efce52b0925ca653$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $efce52b0925ca653$var$rk);
        b.forEach(function(b) {
            var d = $efce52b0925ca653$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($efce52b0925ca653$var$mc) {
                    if (null !== $efce52b0925ca653$var$sk && null !== $efce52b0925ca653$var$tk) $efce52b0925ca653$var$wj($efce52b0925ca653$var$tk, $efce52b0925ca653$var$sk);
                    else throw Error($efce52b0925ca653$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $efce52b0925ca653$var$Mk(a, b, c) {
    $efce52b0925ca653$var$sk = c;
    $efce52b0925ca653$var$tk = a;
    $efce52b0925ca653$var$Nk(b, a);
    $efce52b0925ca653$var$tk = $efce52b0925ca653$var$sk = null;
}
function $efce52b0925ca653$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $efce52b0925ca653$var$X = h.stateNode;
                        $efce52b0925ca653$var$Hk = !1;
                        break a;
                    case 3:
                        $efce52b0925ca653$var$X = h.stateNode.containerInfo;
                        $efce52b0925ca653$var$Hk = !0;
                        break a;
                    case 4:
                        $efce52b0925ca653$var$X = h.stateNode.containerInfo;
                        $efce52b0925ca653$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $efce52b0925ca653$var$X) throw Error($efce52b0925ca653$var$p(160));
            $efce52b0925ca653$var$Jk(f, g, e);
            $efce52b0925ca653$var$X = null;
            $efce52b0925ca653$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $efce52b0925ca653$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$efce52b0925ca653$var$Nk(b, a), b = b.sibling;
}
function $efce52b0925ca653$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            if (d & 4) {
                try {
                    $efce52b0925ca653$var$zk(3, a, a.return), $efce52b0925ca653$var$Ak(3, a);
                } catch (m) {
                    $efce52b0925ca653$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $efce52b0925ca653$var$cj(), $efce52b0925ca653$var$zk(5, a, a.return);
                    } catch (m) {
                        $efce52b0925ca653$var$W(a, a.return, m);
                    }
                    $efce52b0925ca653$var$aj(a);
                } else try {
                    $efce52b0925ca653$var$zk(5, a, a.return);
                } catch (m) {
                    $efce52b0925ca653$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            d & 512 && null !== c && $efce52b0925ca653$var$vk(c, c.return);
            break;
        case 5:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            d & 512 && null !== c && $efce52b0925ca653$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $efce52b0925ca653$var$ob(e, "");
                } catch (m) {
                    $efce52b0925ca653$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $efce52b0925ca653$var$$a(e, f);
                    $efce52b0925ca653$var$vb(h, g);
                    var l = $efce52b0925ca653$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $efce52b0925ca653$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $efce52b0925ca653$var$nb(e, q) : "children" === n ? $efce52b0925ca653$var$ob(e, q) : $efce52b0925ca653$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $efce52b0925ca653$var$ab(e, f);
                            break;
                        case "textarea":
                            $efce52b0925ca653$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $efce52b0925ca653$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $efce52b0925ca653$var$eb(e, !!f.multiple, f.defaultValue, !0) : $efce52b0925ca653$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$efce52b0925ca653$var$cg] = f;
                } catch (m) {
                    $efce52b0925ca653$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($efce52b0925ca653$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $efce52b0925ca653$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $efce52b0925ca653$var$pd(b.containerInfo);
            } catch (m) {
                $efce52b0925ca653$var$W(a, a.return, m);
            }
            break;
        case 4:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            break;
        case 13:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($efce52b0925ca653$var$Qk = $efce52b0925ca653$var$A()));
            d & 4 && $efce52b0925ca653$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($efce52b0925ca653$var$qk = (l = $efce52b0925ca653$var$qk) || n, $efce52b0925ca653$var$Ok(b, a), $efce52b0925ca653$var$qk = l) : $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($efce52b0925ca653$var$U = a, n = a.child; null !== n;){
                    for(q = $efce52b0925ca653$var$U = n; null !== $efce52b0925ca653$var$U;){
                        r = $efce52b0925ca653$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $efce52b0925ca653$var$cj(), $efce52b0925ca653$var$zk(4, r, r.return);
                                } finally{
                                    $efce52b0925ca653$var$aj(r);
                                }
                                else $efce52b0925ca653$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $efce52b0925ca653$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $efce52b0925ca653$var$uk(c, d);
                                    } catch (m) {
                                        $efce52b0925ca653$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $efce52b0925ca653$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $efce52b0925ca653$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $efce52b0925ca653$var$U = z) : $efce52b0925ca653$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $efce52b0925ca653$var$rb("display", g));
                            } catch (m) {
                                $efce52b0925ca653$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $efce52b0925ca653$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $efce52b0925ca653$var$Ok(b, a);
            $efce52b0925ca653$var$Pk(a);
            d & 4 && $efce52b0925ca653$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $efce52b0925ca653$var$Ok(b, a), $efce52b0925ca653$var$Pk(a);
    }
}
function $efce52b0925ca653$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($efce52b0925ca653$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($efce52b0925ca653$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($efce52b0925ca653$var$ob(e, ""), d.flags &= -33);
                    var f = $efce52b0925ca653$var$Ek(a);
                    $efce52b0925ca653$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $efce52b0925ca653$var$Ek(a);
                    $efce52b0925ca653$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($efce52b0925ca653$var$p(161));
            }
        } catch (k) {
            $efce52b0925ca653$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $efce52b0925ca653$var$Sk(a, b, c) {
    $efce52b0925ca653$var$sk = c;
    $efce52b0925ca653$var$tk = b;
    $efce52b0925ca653$var$U = a;
    $efce52b0925ca653$var$Tk(a, b, c);
    $efce52b0925ca653$var$tk = $efce52b0925ca653$var$sk = null;
}
function $efce52b0925ca653$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $efce52b0925ca653$var$U;){
        var e = $efce52b0925ca653$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $efce52b0925ca653$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $efce52b0925ca653$var$qk;
                h = $efce52b0925ca653$var$pk;
                var l = $efce52b0925ca653$var$qk;
                $efce52b0925ca653$var$pk = g;
                if (($efce52b0925ca653$var$qk = k) && !l) for($efce52b0925ca653$var$U = e; null !== $efce52b0925ca653$var$U;)g = $efce52b0925ca653$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $efce52b0925ca653$var$Uk(e) : null !== k ? (k.return = g, $efce52b0925ca653$var$U = k) : $efce52b0925ca653$var$Uk(e);
                for(; null !== f;)$efce52b0925ca653$var$U = f, $efce52b0925ca653$var$Tk(f, b, c), f = f.sibling;
                $efce52b0925ca653$var$U = e;
                $efce52b0925ca653$var$pk = h;
                $efce52b0925ca653$var$qk = l;
            }
            $efce52b0925ca653$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $efce52b0925ca653$var$U = f) : $efce52b0925ca653$var$Vk(a, b, c);
    }
}
function $efce52b0925ca653$var$Vk(a) {
    for(; null !== $efce52b0925ca653$var$U;){
        var b = $efce52b0925ca653$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$efce52b0925ca653$var$qk) {
                            if (b.mode & 2) try {
                                $efce52b0925ca653$var$cj(), $efce52b0925ca653$var$Ak(5, b);
                            } finally{
                                $efce52b0925ca653$var$aj(b);
                            }
                            else $efce52b0925ca653$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$efce52b0925ca653$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $efce52b0925ca653$var$cj(), d.componentDidMount();
                                } finally{
                                    $efce52b0925ca653$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $efce52b0925ca653$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $efce52b0925ca653$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $efce52b0925ca653$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $efce52b0925ca653$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $efce52b0925ca653$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $efce52b0925ca653$var$Ui;
                        c = null === c ? "mount" : "update";
                        $efce52b0925ca653$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $efce52b0925ca653$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $efce52b0925ca653$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($efce52b0925ca653$var$p(163));
                }
                $efce52b0925ca653$var$qk || b.flags & 512 && $efce52b0925ca653$var$Bk(b);
            } catch (v) {
                $efce52b0925ca653$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $efce52b0925ca653$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $efce52b0925ca653$var$U = k;
            break;
        }
        $efce52b0925ca653$var$U = b.return;
    }
}
function $efce52b0925ca653$var$Rk(a) {
    for(; null !== $efce52b0925ca653$var$U;){
        var b = $efce52b0925ca653$var$U;
        if (b === a) {
            $efce52b0925ca653$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $efce52b0925ca653$var$U = c;
            break;
        }
        $efce52b0925ca653$var$U = b.return;
    }
}
function $efce52b0925ca653$var$Uk(a) {
    for(; null !== $efce52b0925ca653$var$U;){
        var b = $efce52b0925ca653$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $efce52b0925ca653$var$cj();
                        var c = b.return;
                        try {
                            $efce52b0925ca653$var$Ak(4, b);
                        } catch (l) {
                            $efce52b0925ca653$var$W(b, c, l);
                        }
                    } finally{
                        $efce52b0925ca653$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $efce52b0925ca653$var$Ak(4, b);
                        } catch (l) {
                            $efce52b0925ca653$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $efce52b0925ca653$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $efce52b0925ca653$var$Bk(b);
                    } catch (l) {
                        $efce52b0925ca653$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $efce52b0925ca653$var$Bk(b);
                    } catch (l) {
                        $efce52b0925ca653$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $efce52b0925ca653$var$W(b, b.return, l);
        }
        if (b === a) {
            $efce52b0925ca653$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $efce52b0925ca653$var$U = k;
            break;
        }
        $efce52b0925ca653$var$U = b.return;
    }
}
var $efce52b0925ca653$var$Xk = Math.ceil, $efce52b0925ca653$var$Yk = $efce52b0925ca653$var$va.ReactCurrentDispatcher, $efce52b0925ca653$var$Zk = $efce52b0925ca653$var$va.ReactCurrentOwner, $efce52b0925ca653$var$$k = $efce52b0925ca653$var$va.ReactCurrentBatchConfig, $efce52b0925ca653$var$K = 0, $efce52b0925ca653$var$Q = null, $efce52b0925ca653$var$Y = null, $efce52b0925ca653$var$Z = 0, $efce52b0925ca653$var$Jj = 0, $efce52b0925ca653$var$Ij = $efce52b0925ca653$var$hg(0), $efce52b0925ca653$var$T = 0, $efce52b0925ca653$var$al = null, $efce52b0925ca653$var$Fh = 0, $efce52b0925ca653$var$bl = 0, $efce52b0925ca653$var$cl = 0, $efce52b0925ca653$var$dl = null, $efce52b0925ca653$var$el = null, $efce52b0925ca653$var$Qk = 0, $efce52b0925ca653$var$mk = Infinity, $efce52b0925ca653$var$fl = null, $efce52b0925ca653$var$qj = !1, $efce52b0925ca653$var$rj = null, $efce52b0925ca653$var$tj = null, $efce52b0925ca653$var$gl = !1, $efce52b0925ca653$var$hl = null, $efce52b0925ca653$var$il = 0, $efce52b0925ca653$var$jl = [], $efce52b0925ca653$var$kl = 0, $efce52b0925ca653$var$ll = null, $efce52b0925ca653$var$ml = -1, $efce52b0925ca653$var$nl = 0;
function $efce52b0925ca653$var$Ri() {
    return 0 !== ($efce52b0925ca653$var$K & 6) ? $efce52b0925ca653$var$A() : -1 !== $efce52b0925ca653$var$ml ? $efce52b0925ca653$var$ml : $efce52b0925ca653$var$ml = $efce52b0925ca653$var$A();
}
function $efce52b0925ca653$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($efce52b0925ca653$var$K & 2) && 0 !== $efce52b0925ca653$var$Z) return $efce52b0925ca653$var$Z & -$efce52b0925ca653$var$Z;
    if (null !== $efce52b0925ca653$var$Yg.transition) return 0 === $efce52b0925ca653$var$nl && ($efce52b0925ca653$var$nl = $efce52b0925ca653$var$Kc()), $efce52b0925ca653$var$nl;
    a = $efce52b0925ca653$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $efce52b0925ca653$var$xd(a.type);
    return a;
}
function $efce52b0925ca653$var$ui(a, b, c, d) {
    if (50 < $efce52b0925ca653$var$kl) throw $efce52b0925ca653$var$kl = 0, $efce52b0925ca653$var$ll = null, Error($efce52b0925ca653$var$p(185));
    $efce52b0925ca653$var$Mc(a, c, d);
    if (0 === ($efce52b0925ca653$var$K & 2) || a !== $efce52b0925ca653$var$Q) $efce52b0925ca653$var$mc && $efce52b0925ca653$var$Pc(a, b, c), a === $efce52b0925ca653$var$Q && (0 === ($efce52b0925ca653$var$K & 2) && ($efce52b0925ca653$var$bl |= c), 4 === $efce52b0925ca653$var$T && $efce52b0925ca653$var$ol(a, $efce52b0925ca653$var$Z)), $efce52b0925ca653$var$pl(a, d), 1 === c && 0 === $efce52b0925ca653$var$K && 0 === (b.mode & 1) && ($efce52b0925ca653$var$mk = $efce52b0925ca653$var$A() + 500, $efce52b0925ca653$var$tg && $efce52b0925ca653$var$xg());
}
function $efce52b0925ca653$var$pl(a, b) {
    var c = a.callbackNode;
    $efce52b0925ca653$var$Ic(a, b);
    var d = $efce52b0925ca653$var$Gc(a, a === $efce52b0925ca653$var$Q ? $efce52b0925ca653$var$Z : 0);
    if (0 === d) null !== c && $efce52b0925ca653$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $efce52b0925ca653$var$bc(c);
        if (1 === b) 0 === a.tag ? $efce52b0925ca653$var$wg($efce52b0925ca653$var$ql.bind(null, a)) : $efce52b0925ca653$var$vg($efce52b0925ca653$var$ql.bind(null, a)), $efce52b0925ca653$var$Xf(function() {
            0 === ($efce52b0925ca653$var$K & 6) && $efce52b0925ca653$var$xg();
        }), c = null;
        else {
            switch($efce52b0925ca653$var$Rc(d)){
                case 1:
                    c = $efce52b0925ca653$var$fc;
                    break;
                case 4:
                    c = $efce52b0925ca653$var$gc;
                    break;
                case 16:
                    c = $efce52b0925ca653$var$hc;
                    break;
                case 536870912:
                    c = $efce52b0925ca653$var$jc;
                    break;
                default:
                    c = $efce52b0925ca653$var$hc;
            }
            c = $efce52b0925ca653$var$rl(c, $efce52b0925ca653$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $efce52b0925ca653$var$sl(a, b) {
    $efce52b0925ca653$var$Zi = $efce52b0925ca653$var$Yi = !1;
    $efce52b0925ca653$var$ml = -1;
    $efce52b0925ca653$var$nl = 0;
    if (0 !== ($efce52b0925ca653$var$K & 6)) throw Error($efce52b0925ca653$var$p(327));
    var c = a.callbackNode;
    if ($efce52b0925ca653$var$tl() && a.callbackNode !== c) return null;
    var d = $efce52b0925ca653$var$Gc(a, a === $efce52b0925ca653$var$Q ? $efce52b0925ca653$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $efce52b0925ca653$var$ul(a, d);
    else {
        b = d;
        var e = $efce52b0925ca653$var$K;
        $efce52b0925ca653$var$K |= 2;
        var f = $efce52b0925ca653$var$vl();
        if ($efce52b0925ca653$var$Q !== a || $efce52b0925ca653$var$Z !== b) {
            if ($efce52b0925ca653$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($efce52b0925ca653$var$wj(a, $efce52b0925ca653$var$Z), g.clear());
                $efce52b0925ca653$var$Qc(a, b);
            }
            $efce52b0925ca653$var$fl = null;
            $efce52b0925ca653$var$mk = $efce52b0925ca653$var$A() + 500;
            $efce52b0925ca653$var$wl(a, b);
        }
        $efce52b0925ca653$var$wc(b);
        for(;;)try {
            $efce52b0925ca653$var$xl();
            break;
        } catch (h) {
            $efce52b0925ca653$var$yl(a, h);
        }
        $efce52b0925ca653$var$nh();
        $efce52b0925ca653$var$Yk.current = f;
        $efce52b0925ca653$var$K = e;
        null !== $efce52b0925ca653$var$Y ? (null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markRenderYielded && $efce52b0925ca653$var$B.markRenderYielded(), b = 0) : ($efce52b0925ca653$var$xc(), $efce52b0925ca653$var$Q = null, $efce52b0925ca653$var$Z = 0, b = $efce52b0925ca653$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $efce52b0925ca653$var$Jc(a), 0 !== e && (d = e, b = $efce52b0925ca653$var$zl(a, e)));
        if (1 === b) throw c = $efce52b0925ca653$var$al, $efce52b0925ca653$var$wl(a, 0), $efce52b0925ca653$var$ol(a, d), $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A()), c;
        if (6 === b) $efce52b0925ca653$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$efce52b0925ca653$var$Al(e) && (b = $efce52b0925ca653$var$ul(a, d), 2 === b && (f = $efce52b0925ca653$var$Jc(a), 0 !== f && (d = f, b = $efce52b0925ca653$var$zl(a, f))), 1 === b)) throw c = $efce52b0925ca653$var$al, $efce52b0925ca653$var$wl(a, 0), $efce52b0925ca653$var$ol(a, d), $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($efce52b0925ca653$var$p(345));
                case 2:
                    $efce52b0925ca653$var$Cl(a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl);
                    break;
                case 3:
                    $efce52b0925ca653$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $efce52b0925ca653$var$Qk + 500 - $efce52b0925ca653$var$A(), 10 < b)) {
                        if (0 !== $efce52b0925ca653$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $efce52b0925ca653$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $efce52b0925ca653$var$Tf($efce52b0925ca653$var$Cl.bind(null, a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl), b);
                        break;
                    }
                    $efce52b0925ca653$var$Cl(a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl);
                    break;
                case 4:
                    $efce52b0925ca653$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $efce52b0925ca653$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $efce52b0925ca653$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $efce52b0925ca653$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $efce52b0925ca653$var$Tf($efce52b0925ca653$var$Cl.bind(null, a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl), d);
                        break;
                    }
                    $efce52b0925ca653$var$Cl(a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl);
                    break;
                case 5:
                    $efce52b0925ca653$var$Cl(a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl);
                    break;
                default:
                    throw Error($efce52b0925ca653$var$p(329));
            }
        }
    }
    $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A());
    return a.callbackNode === c ? $efce52b0925ca653$var$sl.bind(null, a) : null;
}
function $efce52b0925ca653$var$zl(a, b) {
    var c = $efce52b0925ca653$var$dl;
    a.current.memoizedState.isDehydrated && ($efce52b0925ca653$var$wl(a, b).flags |= 256);
    a = $efce52b0925ca653$var$ul(a, b);
    2 !== a && (b = $efce52b0925ca653$var$el, $efce52b0925ca653$var$el = c, null !== b && $efce52b0925ca653$var$lk(b));
    return a;
}
function $efce52b0925ca653$var$lk(a) {
    null === $efce52b0925ca653$var$el ? $efce52b0925ca653$var$el = a : $efce52b0925ca653$var$el.push.apply($efce52b0925ca653$var$el, a);
}
function $efce52b0925ca653$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$efce52b0925ca653$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $efce52b0925ca653$var$ol(a, b) {
    b &= ~$efce52b0925ca653$var$cl;
    b &= ~$efce52b0925ca653$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $efce52b0925ca653$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $efce52b0925ca653$var$ql(a) {
    $efce52b0925ca653$var$Yi = $efce52b0925ca653$var$Zi;
    $efce52b0925ca653$var$Zi = !1;
    if (0 !== ($efce52b0925ca653$var$K & 6)) throw Error($efce52b0925ca653$var$p(327));
    $efce52b0925ca653$var$tl();
    var b = $efce52b0925ca653$var$Gc(a, 0);
    if (0 === (b & 1)) return $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A()), null;
    var c = $efce52b0925ca653$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $efce52b0925ca653$var$Jc(a);
        0 !== d && (b = d, c = $efce52b0925ca653$var$zl(a, d));
    }
    if (1 === c) throw c = $efce52b0925ca653$var$al, $efce52b0925ca653$var$wl(a, 0), $efce52b0925ca653$var$ol(a, b), $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A()), c;
    if (6 === c) throw Error($efce52b0925ca653$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $efce52b0925ca653$var$Cl(a, $efce52b0925ca653$var$el, $efce52b0925ca653$var$fl);
    $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A());
    return null;
}
function $efce52b0925ca653$var$Dl(a, b) {
    var c = $efce52b0925ca653$var$K;
    $efce52b0925ca653$var$K |= 1;
    try {
        return a(b);
    } finally{
        $efce52b0925ca653$var$K = c, 0 === $efce52b0925ca653$var$K && ($efce52b0925ca653$var$mk = $efce52b0925ca653$var$A() + 500, $efce52b0925ca653$var$tg && $efce52b0925ca653$var$xg());
    }
}
function $efce52b0925ca653$var$El(a) {
    null !== $efce52b0925ca653$var$hl && 0 === $efce52b0925ca653$var$hl.tag && 0 === ($efce52b0925ca653$var$K & 6) && $efce52b0925ca653$var$tl();
    var b = $efce52b0925ca653$var$K;
    $efce52b0925ca653$var$K |= 1;
    var c = $efce52b0925ca653$var$$k.transition, d = $efce52b0925ca653$var$E;
    try {
        if ($efce52b0925ca653$var$$k.transition = null, $efce52b0925ca653$var$E = 1, a) return a();
    } finally{
        $efce52b0925ca653$var$E = d, $efce52b0925ca653$var$$k.transition = c, $efce52b0925ca653$var$K = b, 0 === ($efce52b0925ca653$var$K & 6) && $efce52b0925ca653$var$xg();
    }
}
function $efce52b0925ca653$var$nk() {
    $efce52b0925ca653$var$Jj = $efce52b0925ca653$var$Ij.current;
    $efce52b0925ca653$var$G($efce52b0925ca653$var$Ij);
}
function $efce52b0925ca653$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $efce52b0925ca653$var$Uf(c));
    if (null !== $efce52b0925ca653$var$Y) for(c = $efce52b0925ca653$var$Y.return; null !== c;){
        var d = c;
        $efce52b0925ca653$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $efce52b0925ca653$var$ng();
                break;
            case 3:
                $efce52b0925ca653$var$Nh();
                $efce52b0925ca653$var$G($efce52b0925ca653$var$jg);
                $efce52b0925ca653$var$G($efce52b0925ca653$var$I);
                $efce52b0925ca653$var$Sh();
                break;
            case 5:
                $efce52b0925ca653$var$Ph(d);
                break;
            case 4:
                $efce52b0925ca653$var$Nh();
                break;
            case 13:
                $efce52b0925ca653$var$G($efce52b0925ca653$var$L);
                break;
            case 19:
                $efce52b0925ca653$var$G($efce52b0925ca653$var$L);
                break;
            case 10:
                $efce52b0925ca653$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $efce52b0925ca653$var$nk();
        }
        c = c.return;
    }
    $efce52b0925ca653$var$Q = a;
    $efce52b0925ca653$var$Y = a = $efce52b0925ca653$var$ch(a.current, null);
    $efce52b0925ca653$var$Z = $efce52b0925ca653$var$Jj = b;
    $efce52b0925ca653$var$T = 0;
    $efce52b0925ca653$var$al = null;
    $efce52b0925ca653$var$cl = $efce52b0925ca653$var$bl = $efce52b0925ca653$var$Fh = 0;
    $efce52b0925ca653$var$el = $efce52b0925ca653$var$dl = null;
    if (null !== $efce52b0925ca653$var$th) {
        for(b = 0; b < $efce52b0925ca653$var$th.length; b++)if (c = $efce52b0925ca653$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $efce52b0925ca653$var$th = null;
    }
    return a;
}
function $efce52b0925ca653$var$yl(a, b) {
    do {
        var c = $efce52b0925ca653$var$Y;
        try {
            $efce52b0925ca653$var$nh();
            $efce52b0925ca653$var$Th.current = $efce52b0925ca653$var$ei;
            if ($efce52b0925ca653$var$Wh) {
                for(var d = $efce52b0925ca653$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $efce52b0925ca653$var$Wh = !1;
            }
            $efce52b0925ca653$var$Vh = 0;
            $efce52b0925ca653$var$O = $efce52b0925ca653$var$N = $efce52b0925ca653$var$M = null;
            $efce52b0925ca653$var$Xh = !1;
            $efce52b0925ca653$var$Yh = 0;
            $efce52b0925ca653$var$Zk.current = null;
            if (null === c || null === c.return) {
                $efce52b0925ca653$var$T = 1;
                $efce52b0925ca653$var$al = b;
                $efce52b0925ca653$var$Y = null;
                break;
            }
            c.mode & 2 && $efce52b0925ca653$var$$i(c, !0);
            $efce52b0925ca653$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentSuspended && $efce52b0925ca653$var$B.markComponentSuspended(c, f, $efce52b0925ca653$var$Z);
            } else null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markComponentErrored && $efce52b0925ca653$var$B.markComponentErrored(c, b, $efce52b0925ca653$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $efce52b0925ca653$var$Z;
                k.flags |= 32768;
                $efce52b0925ca653$var$mc && $efce52b0925ca653$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $efce52b0925ca653$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $efce52b0925ca653$var$yj(z, h, k, g, b);
                        z.mode & 1 && $efce52b0925ca653$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $efce52b0925ca653$var$uj(g, l, b);
                            $efce52b0925ca653$var$Zj();
                            break a;
                        }
                        f = Error($efce52b0925ca653$var$p(426));
                    }
                } else if ($efce52b0925ca653$var$J && k.mode & 1) {
                    var C = $efce52b0925ca653$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $efce52b0925ca653$var$yj(C, h, k, g, b);
                        $efce52b0925ca653$var$Xg($efce52b0925ca653$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $efce52b0925ca653$var$lj(f, k);
                4 !== $efce52b0925ca653$var$T && ($efce52b0925ca653$var$T = 2);
                null === $efce52b0925ca653$var$dl ? $efce52b0925ca653$var$dl = [
                    g
                ] : $efce52b0925ca653$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $efce52b0925ca653$var$pj(g, f, b);
                            $efce52b0925ca653$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $efce52b0925ca653$var$tj || !$efce52b0925ca653$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $efce52b0925ca653$var$sj(g, k, b);
                                $efce52b0925ca653$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $efce52b0925ca653$var$Fl(c);
        } catch (ca) {
            b = ca;
            $efce52b0925ca653$var$Y === c && null !== c && ($efce52b0925ca653$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $efce52b0925ca653$var$vl() {
    var a = $efce52b0925ca653$var$Yk.current;
    $efce52b0925ca653$var$Yk.current = $efce52b0925ca653$var$ei;
    return null === a ? $efce52b0925ca653$var$ei : a;
}
function $efce52b0925ca653$var$Zj() {
    if (0 === $efce52b0925ca653$var$T || 3 === $efce52b0925ca653$var$T || 2 === $efce52b0925ca653$var$T) $efce52b0925ca653$var$T = 4;
    null === $efce52b0925ca653$var$Q || 0 === ($efce52b0925ca653$var$Fh & 268435455) && 0 === ($efce52b0925ca653$var$bl & 268435455) || $efce52b0925ca653$var$ol($efce52b0925ca653$var$Q, $efce52b0925ca653$var$Z);
}
function $efce52b0925ca653$var$ul(a, b) {
    var c = $efce52b0925ca653$var$K;
    $efce52b0925ca653$var$K |= 2;
    var d = $efce52b0925ca653$var$vl();
    if ($efce52b0925ca653$var$Q !== a || $efce52b0925ca653$var$Z !== b) {
        if ($efce52b0925ca653$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($efce52b0925ca653$var$wj(a, $efce52b0925ca653$var$Z), e.clear());
            $efce52b0925ca653$var$Qc(a, b);
        }
        $efce52b0925ca653$var$fl = null;
        $efce52b0925ca653$var$wl(a, b);
    }
    $efce52b0925ca653$var$wc(b);
    for(;;)try {
        $efce52b0925ca653$var$Gl();
        break;
    } catch (f) {
        $efce52b0925ca653$var$yl(a, f);
    }
    $efce52b0925ca653$var$nh();
    $efce52b0925ca653$var$K = c;
    $efce52b0925ca653$var$Yk.current = d;
    if (null !== $efce52b0925ca653$var$Y) throw Error($efce52b0925ca653$var$p(261));
    $efce52b0925ca653$var$xc();
    $efce52b0925ca653$var$Q = null;
    $efce52b0925ca653$var$Z = 0;
    return $efce52b0925ca653$var$T;
}
function $efce52b0925ca653$var$Gl() {
    for(; null !== $efce52b0925ca653$var$Y;)$efce52b0925ca653$var$Hl($efce52b0925ca653$var$Y);
}
function $efce52b0925ca653$var$xl() {
    for(; null !== $efce52b0925ca653$var$Y && !$efce52b0925ca653$var$cc();)$efce52b0925ca653$var$Hl($efce52b0925ca653$var$Y);
}
function $efce52b0925ca653$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($efce52b0925ca653$var$Wi = $efce52b0925ca653$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $efce52b0925ca653$var$Ti()), b = $efce52b0925ca653$var$Il(b, a, $efce52b0925ca653$var$Jj), $efce52b0925ca653$var$$i(a, !0)) : b = $efce52b0925ca653$var$Il(b, a, $efce52b0925ca653$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $efce52b0925ca653$var$Fl(a) : $efce52b0925ca653$var$Y = b;
    $efce52b0925ca653$var$Zk.current = null;
}
function $efce52b0925ca653$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $efce52b0925ca653$var$kk(c, b, $efce52b0925ca653$var$Jj);
            else {
                var d = b;
                $efce52b0925ca653$var$Wi = $efce52b0925ca653$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $efce52b0925ca653$var$Ti());
                c = $efce52b0925ca653$var$kk(c, b, $efce52b0925ca653$var$Jj);
                $efce52b0925ca653$var$$i(b, !1);
            }
            if (null !== c) {
                $efce52b0925ca653$var$Y = c;
                return;
            }
        } else {
            c = $efce52b0925ca653$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $efce52b0925ca653$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $efce52b0925ca653$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $efce52b0925ca653$var$T = 6;
                $efce52b0925ca653$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $efce52b0925ca653$var$Y = b;
            return;
        }
        $efce52b0925ca653$var$Y = b = a;
    }while (null !== b);
    0 === $efce52b0925ca653$var$T && ($efce52b0925ca653$var$T = 5);
}
function $efce52b0925ca653$var$Cl(a, b, c) {
    var d = $efce52b0925ca653$var$E, e = $efce52b0925ca653$var$$k.transition;
    try {
        $efce52b0925ca653$var$$k.transition = null, $efce52b0925ca653$var$E = 1, $efce52b0925ca653$var$Jl(a, b, c, d);
    } finally{
        $efce52b0925ca653$var$$k.transition = e, $efce52b0925ca653$var$E = d;
    }
    return null;
}
function $efce52b0925ca653$var$Jl(a, b, c, d) {
    do $efce52b0925ca653$var$tl();
    while (null !== $efce52b0925ca653$var$hl);
    if (0 !== ($efce52b0925ca653$var$K & 6)) throw Error($efce52b0925ca653$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markCommitStarted && $efce52b0925ca653$var$B.markCommitStarted(e);
    if (null === c) return $efce52b0925ca653$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($efce52b0925ca653$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $efce52b0925ca653$var$Nc(a, f);
    a === $efce52b0925ca653$var$Q && ($efce52b0925ca653$var$Y = $efce52b0925ca653$var$Q = null, $efce52b0925ca653$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $efce52b0925ca653$var$gl || ($efce52b0925ca653$var$gl = !0, $efce52b0925ca653$var$rl($efce52b0925ca653$var$hc, function() {
        $efce52b0925ca653$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $efce52b0925ca653$var$$k.transition;
        $efce52b0925ca653$var$$k.transition = null;
        var g = $efce52b0925ca653$var$E;
        $efce52b0925ca653$var$E = 1;
        var h = $efce52b0925ca653$var$K;
        $efce52b0925ca653$var$K |= 4;
        $efce52b0925ca653$var$Zk.current = null;
        $efce52b0925ca653$var$yk(a, c);
        $efce52b0925ca653$var$Ui = $efce52b0925ca653$var$Ti();
        $efce52b0925ca653$var$Mk(a, c, e);
        $efce52b0925ca653$var$bf($efce52b0925ca653$var$Rf);
        $efce52b0925ca653$var$rd = !!$efce52b0925ca653$var$Qf;
        $efce52b0925ca653$var$Rf = $efce52b0925ca653$var$Qf = null;
        a.current = c;
        null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markLayoutEffectsStarted && $efce52b0925ca653$var$B.markLayoutEffectsStarted(e);
        $efce52b0925ca653$var$Sk(c, a, e);
        null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markLayoutEffectsStopped && $efce52b0925ca653$var$B.markLayoutEffectsStopped();
        $efce52b0925ca653$var$dc();
        $efce52b0925ca653$var$K = h;
        $efce52b0925ca653$var$E = g;
        $efce52b0925ca653$var$$k.transition = f;
    } else a.current = c, $efce52b0925ca653$var$Ui = $efce52b0925ca653$var$Ti();
    $efce52b0925ca653$var$gl && ($efce52b0925ca653$var$gl = !1, $efce52b0925ca653$var$hl = a, $efce52b0925ca653$var$il = e);
    f = a.pendingLanes;
    0 === f && ($efce52b0925ca653$var$tj = null);
    $efce52b0925ca653$var$nc(c.stateNode, d);
    $efce52b0925ca653$var$mc && a.memoizedUpdaters.clear();
    $efce52b0925ca653$var$pl(a, $efce52b0925ca653$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($efce52b0925ca653$var$qj) throw $efce52b0925ca653$var$qj = !1, a = $efce52b0925ca653$var$rj, $efce52b0925ca653$var$rj = null, a;
    0 !== ($efce52b0925ca653$var$il & 1) && 0 !== a.tag && $efce52b0925ca653$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($efce52b0925ca653$var$Zi = !0, a === $efce52b0925ca653$var$ll ? $efce52b0925ca653$var$kl++ : ($efce52b0925ca653$var$kl = 0, $efce52b0925ca653$var$ll = a)) : $efce52b0925ca653$var$kl = 0;
    $efce52b0925ca653$var$xg();
    $efce52b0925ca653$var$rc();
    return null;
}
function $efce52b0925ca653$var$tl() {
    if (null !== $efce52b0925ca653$var$hl) {
        var a = $efce52b0925ca653$var$Rc($efce52b0925ca653$var$il), b = $efce52b0925ca653$var$$k.transition, c = $efce52b0925ca653$var$E;
        try {
            $efce52b0925ca653$var$$k.transition = null;
            $efce52b0925ca653$var$E = 16 > a ? 16 : a;
            if (null === $efce52b0925ca653$var$hl) var d = !1;
            else {
                a = $efce52b0925ca653$var$hl;
                var e = $efce52b0925ca653$var$il;
                $efce52b0925ca653$var$hl = null;
                $efce52b0925ca653$var$il = 0;
                if (0 !== ($efce52b0925ca653$var$K & 6)) throw Error($efce52b0925ca653$var$p(331));
                null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markPassiveEffectsStarted && $efce52b0925ca653$var$B.markPassiveEffectsStarted(e);
                e = $efce52b0925ca653$var$K;
                $efce52b0925ca653$var$K |= 4;
                for($efce52b0925ca653$var$U = a.current; null !== $efce52b0925ca653$var$U;){
                    var f = $efce52b0925ca653$var$U, g = f.child;
                    if (0 !== ($efce52b0925ca653$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($efce52b0925ca653$var$U = l; null !== $efce52b0925ca653$var$U;){
                                    var n = $efce52b0925ca653$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($efce52b0925ca653$var$Xi = $efce52b0925ca653$var$Ti(), $efce52b0925ca653$var$zk(8, q, f), $efce52b0925ca653$var$bj(q)) : $efce52b0925ca653$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $efce52b0925ca653$var$U = r;
                                    else for(; null !== $efce52b0925ca653$var$U;){
                                        n = $efce52b0925ca653$var$U;
                                        var z = n.sibling, m = n.return;
                                        $efce52b0925ca653$var$Ck(n);
                                        if (n === l) {
                                            $efce52b0925ca653$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $efce52b0925ca653$var$U = z;
                                            break;
                                        }
                                        $efce52b0925ca653$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $efce52b0925ca653$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $efce52b0925ca653$var$U = g;
                    else b: for(; null !== $efce52b0925ca653$var$U;){
                        f = $efce52b0925ca653$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($efce52b0925ca653$var$Xi = $efce52b0925ca653$var$Ti(), $efce52b0925ca653$var$zk(9, k, k.return), $efce52b0925ca653$var$bj(k)) : $efce52b0925ca653$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $efce52b0925ca653$var$U = y;
                            break b;
                        }
                        $efce52b0925ca653$var$U = f.return;
                    }
                }
                var v = a.current;
                for($efce52b0925ca653$var$U = v; null !== $efce52b0925ca653$var$U;){
                    g = $efce52b0925ca653$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $efce52b0925ca653$var$U = D;
                    else b: for(g = v; null !== $efce52b0925ca653$var$U;){
                        h = $efce52b0925ca653$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $efce52b0925ca653$var$Xi = $efce52b0925ca653$var$Ti();
                                        try {
                                            $efce52b0925ca653$var$Ak(9, l);
                                        } finally{
                                            $efce52b0925ca653$var$bj(l);
                                        }
                                    } else $efce52b0925ca653$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $efce52b0925ca653$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $efce52b0925ca653$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $efce52b0925ca653$var$U = ca;
                            break b;
                        }
                        $efce52b0925ca653$var$U = h.return;
                    }
                }
                v = $efce52b0925ca653$var$jl;
                $efce52b0925ca653$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $efce52b0925ca653$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $efce52b0925ca653$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markPassiveEffectsStopped && $efce52b0925ca653$var$B.markPassiveEffectsStopped();
                $efce52b0925ca653$var$K = e;
                $efce52b0925ca653$var$xg();
                if ($efce52b0925ca653$var$lc && "function" === typeof $efce52b0925ca653$var$lc.onPostCommitFiberRoot) try {
                    $efce52b0925ca653$var$lc.onPostCommitFiberRoot($efce52b0925ca653$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $efce52b0925ca653$var$E = c, $efce52b0925ca653$var$$k.transition = b;
        }
    }
    return !1;
}
function $efce52b0925ca653$var$Wk(a) {
    $efce52b0925ca653$var$jl.push(a);
    $efce52b0925ca653$var$gl || ($efce52b0925ca653$var$gl = !0, $efce52b0925ca653$var$rl($efce52b0925ca653$var$hc, function() {
        $efce52b0925ca653$var$tl();
        return null;
    }));
}
function $efce52b0925ca653$var$Kl(a, b, c) {
    b = $efce52b0925ca653$var$lj(c, b);
    b = $efce52b0925ca653$var$pj(a, b, 1);
    a = $efce52b0925ca653$var$Bh(a, b, 1);
    b = $efce52b0925ca653$var$Ri();
    null !== a && ($efce52b0925ca653$var$Mc(a, 1, b), $efce52b0925ca653$var$pl(a, b));
}
function $efce52b0925ca653$var$W(a, b, c) {
    if (3 === a.tag) $efce52b0925ca653$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $efce52b0925ca653$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $efce52b0925ca653$var$tj || !$efce52b0925ca653$var$tj.has(d))) {
                a = $efce52b0925ca653$var$lj(c, a);
                a = $efce52b0925ca653$var$sj(b, a, 1);
                b = $efce52b0925ca653$var$Bh(b, a, 1);
                a = $efce52b0925ca653$var$Ri();
                null !== b && ($efce52b0925ca653$var$Mc(b, 1, a), $efce52b0925ca653$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $efce52b0925ca653$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $efce52b0925ca653$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $efce52b0925ca653$var$Q === a && ($efce52b0925ca653$var$Z & c) === c && (4 === $efce52b0925ca653$var$T || 3 === $efce52b0925ca653$var$T && ($efce52b0925ca653$var$Z & 130023424) === $efce52b0925ca653$var$Z && 500 > $efce52b0925ca653$var$A() - $efce52b0925ca653$var$Qk ? $efce52b0925ca653$var$wl(a, 0) : $efce52b0925ca653$var$cl |= c);
    $efce52b0925ca653$var$pl(a, b);
}
function $efce52b0925ca653$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $efce52b0925ca653$var$Ec, $efce52b0925ca653$var$Ec <<= 1, 0 === ($efce52b0925ca653$var$Ec & 130023424) && ($efce52b0925ca653$var$Ec = 4194304)));
    var c = $efce52b0925ca653$var$Ri();
    a = $efce52b0925ca653$var$wh(a, b);
    null !== a && ($efce52b0925ca653$var$Mc(a, b, c), $efce52b0925ca653$var$pl(a, c));
}
function $efce52b0925ca653$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $efce52b0925ca653$var$Ll(a, c);
}
function $efce52b0925ca653$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($efce52b0925ca653$var$p(314));
    }
    null !== d && d.delete(b);
    $efce52b0925ca653$var$Ll(a, c);
}
var $efce52b0925ca653$var$Il;
$efce52b0925ca653$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $efce52b0925ca653$var$jg.current) $efce52b0925ca653$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $efce52b0925ca653$var$rh = !1, $efce52b0925ca653$var$ek(a, b, c);
            $efce52b0925ca653$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $efce52b0925ca653$var$rh = !1, $efce52b0925ca653$var$J && 0 !== (b.flags & 1048576) && $efce52b0925ca653$var$Ig(b, $efce52b0925ca653$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $efce52b0925ca653$var$Mj(a, b);
            a = b.pendingProps;
            var e = $efce52b0925ca653$var$lg(b, $efce52b0925ca653$var$I.current);
            $efce52b0925ca653$var$qh(b, c);
            $efce52b0925ca653$var$sc(b);
            e = $efce52b0925ca653$var$ai(null, b, d, a, e, c);
            var f = $efce52b0925ca653$var$fi();
            $efce52b0925ca653$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $efce52b0925ca653$var$mg(d) ? (f = !0, $efce52b0925ca653$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $efce52b0925ca653$var$yh(b), e.updater = $efce52b0925ca653$var$gj, b.stateNode = e, e._reactInternals = b, $efce52b0925ca653$var$kj(b, d, a, c), b = $efce52b0925ca653$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $efce52b0925ca653$var$J && f && $efce52b0925ca653$var$Jg(b), $efce52b0925ca653$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $efce52b0925ca653$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $efce52b0925ca653$var$Ml(d);
                a = $efce52b0925ca653$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $efce52b0925ca653$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $efce52b0925ca653$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $efce52b0925ca653$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $efce52b0925ca653$var$Dj(null, b, d, $efce52b0925ca653$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($efce52b0925ca653$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $efce52b0925ca653$var$ej(d, e), $efce52b0925ca653$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $efce52b0925ca653$var$ej(d, e), $efce52b0925ca653$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $efce52b0925ca653$var$Oj(b);
                if (null === a) throw Error($efce52b0925ca653$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $efce52b0925ca653$var$zh(a, b);
                $efce52b0925ca653$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $efce52b0925ca653$var$lj(Error($efce52b0925ca653$var$p(423)), b);
                        b = $efce52b0925ca653$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $efce52b0925ca653$var$lj(Error($efce52b0925ca653$var$p(424)), b);
                        b = $efce52b0925ca653$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($efce52b0925ca653$var$Mg = $efce52b0925ca653$var$Zf(b.stateNode.containerInfo.firstChild), $efce52b0925ca653$var$Lg = b, $efce52b0925ca653$var$J = !0, $efce52b0925ca653$var$Ng = null, c = $efce52b0925ca653$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $efce52b0925ca653$var$Wg();
                    if (d === e) {
                        b = $efce52b0925ca653$var$Cj(a, b, c);
                        break a;
                    }
                    $efce52b0925ca653$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $efce52b0925ca653$var$Oh(b), null === a && $efce52b0925ca653$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $efce52b0925ca653$var$Sf(d, e) ? g = null : null !== f && $efce52b0925ca653$var$Sf(d, f) && (b.flags |= 32), $efce52b0925ca653$var$Kj(a, b), $efce52b0925ca653$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $efce52b0925ca653$var$Sg(b), null;
        case 13:
            return $efce52b0925ca653$var$Uj(a, b, c);
        case 4:
            return $efce52b0925ca653$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $efce52b0925ca653$var$hh(b, null, d, c) : $efce52b0925ca653$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $efce52b0925ca653$var$ej(d, e), $efce52b0925ca653$var$Bj(a, b, d, e, c);
        case 7:
            return $efce52b0925ca653$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $efce52b0925ca653$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $efce52b0925ca653$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $efce52b0925ca653$var$H($efce52b0925ca653$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($efce52b0925ca653$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$efce52b0925ca653$var$jg.current) {
                            b = $efce52b0925ca653$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $efce52b0925ca653$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $efce52b0925ca653$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($efce52b0925ca653$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $efce52b0925ca653$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $efce52b0925ca653$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $efce52b0925ca653$var$qh(b, c), e = $efce52b0925ca653$var$sh(e), $efce52b0925ca653$var$sc(b), d = d(e), $efce52b0925ca653$var$tc(), b.flags |= 1, $efce52b0925ca653$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $efce52b0925ca653$var$ej(d, b.pendingProps), e = $efce52b0925ca653$var$ej(d.type, e), $efce52b0925ca653$var$Dj(a, b, d, e, c);
        case 15:
            return $efce52b0925ca653$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $efce52b0925ca653$var$ej(d, e), $efce52b0925ca653$var$Mj(a, b), b.tag = 1, $efce52b0925ca653$var$mg(d) ? (a = !0, $efce52b0925ca653$var$qg(b)) : a = !1, $efce52b0925ca653$var$qh(b, c), $efce52b0925ca653$var$ij(b, d, e), $efce52b0925ca653$var$kj(b, d, e, c), $efce52b0925ca653$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $efce52b0925ca653$var$dk(a, b, c);
        case 22:
            return $efce52b0925ca653$var$Hj(a, b, c);
    }
    throw Error($efce52b0925ca653$var$p(156, b.tag));
};
function $efce52b0925ca653$var$wj(a, b) {
    $efce52b0925ca653$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $efce52b0925ca653$var$Pc(a, c, b);
    });
}
function $efce52b0925ca653$var$rl(a, b) {
    return $efce52b0925ca653$var$ac(a, b);
}
function $efce52b0925ca653$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $efce52b0925ca653$var$Pg(a, b, c, d) {
    return new $efce52b0925ca653$var$Nl(a, b, c, d);
}
function $efce52b0925ca653$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $efce52b0925ca653$var$Ml(a) {
    if ("function" === typeof a) return $efce52b0925ca653$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $efce52b0925ca653$var$Da) return 11;
        if (a === $efce52b0925ca653$var$Ga) return 14;
    }
    return 2;
}
function $efce52b0925ca653$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $efce52b0925ca653$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $efce52b0925ca653$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $efce52b0925ca653$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $efce52b0925ca653$var$ya:
            return $efce52b0925ca653$var$gh(c.children, e, f, b);
        case $efce52b0925ca653$var$za:
            g = 8;
            e |= 8;
            break;
        case $efce52b0925ca653$var$Aa:
            return a = $efce52b0925ca653$var$Pg(12, c, b, e | 2), a.elementType = $efce52b0925ca653$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $efce52b0925ca653$var$Ea:
            return a = $efce52b0925ca653$var$Pg(13, c, b, e), a.elementType = $efce52b0925ca653$var$Ea, a.lanes = f, a;
        case $efce52b0925ca653$var$Fa:
            return a = $efce52b0925ca653$var$Pg(19, c, b, e), a.elementType = $efce52b0925ca653$var$Fa, a.lanes = f, a;
        case $efce52b0925ca653$var$Ia:
            return $efce52b0925ca653$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $efce52b0925ca653$var$Ba:
                    g = 10;
                    break a;
                case $efce52b0925ca653$var$Ca:
                    g = 9;
                    break a;
                case $efce52b0925ca653$var$Da:
                    g = 11;
                    break a;
                case $efce52b0925ca653$var$Ga:
                    g = 14;
                    break a;
                case $efce52b0925ca653$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($efce52b0925ca653$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $efce52b0925ca653$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $efce52b0925ca653$var$gh(a, b, c, d) {
    a = $efce52b0925ca653$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $efce52b0925ca653$var$Vj(a, b, c, d) {
    a = $efce52b0925ca653$var$Pg(22, a, d, b);
    a.elementType = $efce52b0925ca653$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $efce52b0925ca653$var$dh(a, b, c) {
    a = $efce52b0925ca653$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $efce52b0925ca653$var$fh(a, b, c) {
    b = $efce52b0925ca653$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $efce52b0925ca653$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $efce52b0925ca653$var$Lc(0);
    this.expirationTimes = $efce52b0925ca653$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $efce52b0925ca653$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $efce52b0925ca653$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $efce52b0925ca653$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $efce52b0925ca653$var$mc && (b |= 2);
    f = $efce52b0925ca653$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $efce52b0925ca653$var$yh(f);
    return a;
}
function $efce52b0925ca653$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $efce52b0925ca653$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $efce52b0925ca653$var$Rl(a) {
    if (!a) return $efce52b0925ca653$var$ig;
    a = a._reactInternals;
    a: {
        if ($efce52b0925ca653$var$Vb(a) !== a || 1 !== a.tag) throw Error($efce52b0925ca653$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($efce52b0925ca653$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($efce52b0925ca653$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($efce52b0925ca653$var$mg(c)) return $efce52b0925ca653$var$pg(a, c, b);
    }
    return b;
}
function $efce52b0925ca653$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $efce52b0925ca653$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $efce52b0925ca653$var$Rl(null);
    c = a.current;
    d = $efce52b0925ca653$var$Ri();
    e = $efce52b0925ca653$var$Oi(c);
    f = $efce52b0925ca653$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $efce52b0925ca653$var$Bh(c, f, e);
    a.current.lanes = e;
    $efce52b0925ca653$var$Mc(a, e, d);
    $efce52b0925ca653$var$pl(a, d);
    return a;
}
function $efce52b0925ca653$var$Tl(a, b, c, d) {
    var e = b.current, f = $efce52b0925ca653$var$Ri(), g = $efce52b0925ca653$var$Oi(e);
    null !== $efce52b0925ca653$var$B && "function" === typeof $efce52b0925ca653$var$B.markRenderScheduled && $efce52b0925ca653$var$B.markRenderScheduled(g);
    c = $efce52b0925ca653$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $efce52b0925ca653$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $efce52b0925ca653$var$Bh(e, b, g);
    null !== a && ($efce52b0925ca653$var$ui(a, e, g, f), $efce52b0925ca653$var$Ch(a, e, g));
    return g;
}
function $efce52b0925ca653$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $efce52b0925ca653$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $efce52b0925ca653$var$Wl(a, b) {
    $efce52b0925ca653$var$Vl(a, b);
    (a = a.alternate) && $efce52b0925ca653$var$Vl(a, b);
}
function $efce52b0925ca653$var$Xl() {
    return null;
}
var $efce52b0925ca653$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $efce52b0925ca653$var$Zl(a) {
    this._internalRoot = a;
}
$efce52b0925ca653$var$$l.prototype.render = $efce52b0925ca653$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($efce52b0925ca653$var$p(409));
    $efce52b0925ca653$var$Tl(a, b, null, null);
};
$efce52b0925ca653$var$$l.prototype.unmount = $efce52b0925ca653$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $efce52b0925ca653$var$El(function() {
            $efce52b0925ca653$var$Tl(null, a, null, null);
        });
        b[$efce52b0925ca653$var$If] = null;
    }
};
function $efce52b0925ca653$var$$l(a) {
    this._internalRoot = a;
}
$efce52b0925ca653$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $efce52b0925ca653$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $efce52b0925ca653$var$dd.length && 0 !== b && b < $efce52b0925ca653$var$dd[c].priority; c++);
        $efce52b0925ca653$var$dd.splice(c, 0, a);
        0 === c && $efce52b0925ca653$var$id(a);
    }
};
function $efce52b0925ca653$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $efce52b0925ca653$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $efce52b0925ca653$var$cm() {}
function $efce52b0925ca653$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $efce52b0925ca653$var$Ul(g);
                f.call(a);
            };
        }
        var g = $efce52b0925ca653$var$Sl(b, d, a, 0, null, !1, !1, "", $efce52b0925ca653$var$cm);
        a._reactRootContainer = g;
        a[$efce52b0925ca653$var$If] = g.current;
        $efce52b0925ca653$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $efce52b0925ca653$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $efce52b0925ca653$var$Ul(k);
            h.call(a);
        };
    }
    var k = $efce52b0925ca653$var$Pl(a, 0, !1, null, null, !1, !1, "", $efce52b0925ca653$var$cm);
    a._reactRootContainer = k;
    a[$efce52b0925ca653$var$If] = k.current;
    $efce52b0925ca653$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $efce52b0925ca653$var$El(function() {
        $efce52b0925ca653$var$Tl(b, k, c, d);
    });
    return k;
}
function $efce52b0925ca653$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $efce52b0925ca653$var$Ul(g);
                h.call(a);
            };
        }
        $efce52b0925ca653$var$Tl(b, g, a, e);
    } else g = $efce52b0925ca653$var$dm(c, b, a, e, d);
    return $efce52b0925ca653$var$Ul(g);
}
$efce52b0925ca653$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $efce52b0925ca653$var$Fc(b.pendingLanes);
                0 !== c && ($efce52b0925ca653$var$Oc(b, c | 1), $efce52b0925ca653$var$pl(b, $efce52b0925ca653$var$A()), 0 === ($efce52b0925ca653$var$K & 6) && ($efce52b0925ca653$var$mk = $efce52b0925ca653$var$A() + 500, $efce52b0925ca653$var$xg()));
            }
            break;
        case 13:
            $efce52b0925ca653$var$El(function() {
                var b = $efce52b0925ca653$var$wh(a, 1);
                if (null !== b) {
                    var c = $efce52b0925ca653$var$Ri();
                    $efce52b0925ca653$var$ui(b, a, 1, c);
                }
            }), $efce52b0925ca653$var$Wl(a, 1);
    }
};
$efce52b0925ca653$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $efce52b0925ca653$var$wh(a, 134217728);
        if (null !== b) {
            var c = $efce52b0925ca653$var$Ri();
            $efce52b0925ca653$var$ui(b, a, 134217728, c);
        }
        $efce52b0925ca653$var$Wl(a, 134217728);
    }
};
$efce52b0925ca653$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $efce52b0925ca653$var$Oi(a), c = $efce52b0925ca653$var$wh(a, b);
        if (null !== c) {
            var d = $efce52b0925ca653$var$Ri();
            $efce52b0925ca653$var$ui(c, a, b, d);
        }
        $efce52b0925ca653$var$Wl(a, b);
    }
};
$efce52b0925ca653$var$Vc = function() {
    return $efce52b0925ca653$var$E;
};
$efce52b0925ca653$var$Wc = function(a, b) {
    var c = $efce52b0925ca653$var$E;
    try {
        return $efce52b0925ca653$var$E = a, b();
    } finally{
        $efce52b0925ca653$var$E = c;
    }
};
$efce52b0925ca653$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $efce52b0925ca653$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $efce52b0925ca653$var$Db(d);
                        if (!e) throw Error($efce52b0925ca653$var$p(90));
                        $efce52b0925ca653$var$Wa(d);
                        $efce52b0925ca653$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $efce52b0925ca653$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $efce52b0925ca653$var$eb(a, !!c.multiple, b, !1);
    }
};
$efce52b0925ca653$var$Gb = $efce52b0925ca653$var$Dl;
$efce52b0925ca653$var$Hb = $efce52b0925ca653$var$El;
var $efce52b0925ca653$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $efce52b0925ca653$var$Cb,
        $efce52b0925ca653$var$Ie,
        $efce52b0925ca653$var$Db,
        $efce52b0925ca653$var$Eb,
        $efce52b0925ca653$var$Fb,
        $efce52b0925ca653$var$Dl
    ]
}, $efce52b0925ca653$var$gm = {
    findFiberByHostInstance: $efce52b0925ca653$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $efce52b0925ca653$var$u({}, a, {
            getLaneLabelMap: $efce52b0925ca653$var$pc,
            injectProfilingHooks: $efce52b0925ca653$var$oc
        }), $efce52b0925ca653$var$kc = b.inject(a), $efce52b0925ca653$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $efce52b0925ca653$var$gm.bundleType,
    version: $efce52b0925ca653$var$gm.version,
    rendererPackageName: $efce52b0925ca653$var$gm.rendererPackageName,
    rendererConfig: $efce52b0925ca653$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $efce52b0925ca653$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $efce52b0925ca653$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $efce52b0925ca653$var$gm.findFiberByHostInstance || $efce52b0925ca653$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$efce52b0925ca653$export$ae55be85d98224ed = $efce52b0925ca653$var$fm;
$efce52b0925ca653$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$efce52b0925ca653$var$am(b)) throw Error($efce52b0925ca653$var$p(200));
    return $efce52b0925ca653$var$Ql(a, b, null, c);
};
$efce52b0925ca653$export$882461b6382ed46c = function(a, b) {
    if (!$efce52b0925ca653$var$am(a)) throw Error($efce52b0925ca653$var$p(299));
    var c = !1, d = "", e = $efce52b0925ca653$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $efce52b0925ca653$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$efce52b0925ca653$var$If] = b.current;
    $efce52b0925ca653$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $efce52b0925ca653$var$Zl(b);
};
$efce52b0925ca653$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($efce52b0925ca653$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($efce52b0925ca653$var$p(268, a));
    }
    a = $efce52b0925ca653$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$efce52b0925ca653$export$cd75ccfd720a3cd4 = function(a) {
    return $efce52b0925ca653$var$El(a);
};
$efce52b0925ca653$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$efce52b0925ca653$var$bm(b)) throw Error($efce52b0925ca653$var$p(200));
    return $efce52b0925ca653$var$em(null, a, b, !0, c);
};
$efce52b0925ca653$export$757ceba2d55c277e = function(a, b, c) {
    if (!$efce52b0925ca653$var$am(a)) throw Error($efce52b0925ca653$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $efce52b0925ca653$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $efce52b0925ca653$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$efce52b0925ca653$var$If] = b.current;
    $efce52b0925ca653$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $efce52b0925ca653$var$$l(b);
};
$efce52b0925ca653$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$efce52b0925ca653$var$bm(b)) throw Error($efce52b0925ca653$var$p(200));
    return $efce52b0925ca653$var$em(null, a, b, !1, c);
};
$efce52b0925ca653$export$502457920280e6be = function(a) {
    if (!$efce52b0925ca653$var$bm(a)) throw Error($efce52b0925ca653$var$p(40));
    return a._reactRootContainer ? ($efce52b0925ca653$var$El(function() {
        $efce52b0925ca653$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$efce52b0925ca653$var$If] = null;
        });
    }), !0) : !1;
};
$efce52b0925ca653$export$c78a37762a8d58e1 = $efce52b0925ca653$var$Dl;
$efce52b0925ca653$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$efce52b0925ca653$var$bm(c)) throw Error($efce52b0925ca653$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($efce52b0925ca653$var$p(38));
    return $efce52b0925ca653$var$em(a, b, c, !1, d);
};
$efce52b0925ca653$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("h0ns1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c0rG1"));

});



parcelRegister("jlH1f", function(module, exports) {
$parcel$export(module.exports, "default", () => $e161593219fc8b51$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $e161593219fc8b51$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $e161593219fc8b51$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))),
    devtools: false,
    middlewares: new Set(),
    mutator: $e161593219fc8b51$var$defaultMutator
};
var $e161593219fc8b51$export$2e2bcd8739ae039 = $e161593219fc8b51$var$defaults;

});

parcelRegister("c8ckB", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d4fcc21769cf4a4$export$2e2bcd8739ae039);
const $8d4fcc21769cf4a4$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $8d4fcc21769cf4a4$export$2e2bcd8739ae039 = $8d4fcc21769cf4a4$var$supports;

});


parcelRegister("5nVr1", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $3ebba71c7ccc32ec$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $3ebba71c7ccc32ec$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $3ebba71c7ccc32ec$export$6e4e5611de132e85);

var $fc4bM = parcelRequire("fc4bM");

var $6R5ln = parcelRequire("6R5ln");

var $8MDsR = parcelRequire("8MDsR");

var $g6dQg = parcelRequire("g6dQg");
const $3ebba71c7ccc32ec$var$EMPTY_SELECTOR = ()=>undefined;
const $3ebba71c7ccc32ec$var$DEFAULT_SELECTOR = (state)=>state;
function $3ebba71c7ccc32ec$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $fc4bM.useContext)((0, $8MDsR.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $fc4bM.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $fc4bM.useMemo)(()=>selector ? (0, $g6dQg.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $3ebba71c7ccc32ec$var$EMPTY_SELECTOR : $3ebba71c7ccc32ec$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $fc4bM.useState)({})[1];
        const getSnapshot = (0, $fc4bM.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $6R5ln.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $3ebba71c7ccc32ec$export$7c643e1d6648e418(Store) {
    const useHook = $3ebba71c7ccc32ec$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $3ebba71c7ccc32ec$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $3ebba71c7ccc32ec$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("6R5ln", function(module, exports) {
'use strict';

module.exports = (parcelRequire("esUej"));

});
parcelRegister("esUej", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $a87f4c4efb0442eb$export$306c0aa65ff9ec16, (v) => $a87f4c4efb0442eb$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a87f4c4efb0442eb$export$306c0aa65ff9ec16;
"use strict";

var $fc4bM = parcelRequire("fc4bM");
function $a87f4c4efb0442eb$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a87f4c4efb0442eb$var$objectIs = "function" === typeof Object.is ? Object.is : $a87f4c4efb0442eb$var$is, $a87f4c4efb0442eb$var$useState = $fc4bM.useState, $a87f4c4efb0442eb$var$useEffect = $fc4bM.useEffect, $a87f4c4efb0442eb$var$useLayoutEffect = $fc4bM.useLayoutEffect, $a87f4c4efb0442eb$var$useDebugValue = $fc4bM.useDebugValue;
function $a87f4c4efb0442eb$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $a87f4c4efb0442eb$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $a87f4c4efb0442eb$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $a87f4c4efb0442eb$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $a87f4c4efb0442eb$var$useEffect(function() {
        $a87f4c4efb0442eb$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $a87f4c4efb0442eb$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $a87f4c4efb0442eb$var$useDebugValue(value);
    return value;
}
function $a87f4c4efb0442eb$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$a87f4c4efb0442eb$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $a87f4c4efb0442eb$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $a87f4c4efb0442eb$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $a87f4c4efb0442eb$var$useSyncExternalStore$1 : $a87f4c4efb0442eb$var$useSyncExternalStore$2;
$a87f4c4efb0442eb$export$306c0aa65ff9ec16 = void 0 !== $fc4bM.useSyncExternalStore ? $fc4bM.useSyncExternalStore : $a87f4c4efb0442eb$var$shim;

});


parcelRegister("8MDsR", function(module, exports) {
$parcel$export(module.exports, "Context", () => $66516b39fbb7abff$export$841858b892ce1f4c);

var $fc4bM = parcelRequire("fc4bM");

var $kMxBB = parcelRequire("kMxBB");
const $66516b39fbb7abff$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext({
    globalRegistry: (0, $kMxBB.defaultRegistry),
    retrieveStore: (Store)=>(0, $kMxBB.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("kMxBB", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $f2125bb7e5b10d20$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $f2125bb7e5b10d20$export$9d726ae4880b1060);

var $c8ckB = parcelRequire("c8ckB");

var $h8RF7 = parcelRequire("h8RF7");

var $kZB80 = parcelRequire("kZB80");
const $f2125bb7e5b10d20$export$e4d628ba0054221b = '__global__';
class $f2125bb7e5b10d20$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $f2125bb7e5b10d20$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $c8ckB.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $kZB80.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $h8RF7.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $f2125bb7e5b10d20$export$9d726ae4880b1060 = new $f2125bb7e5b10d20$export$acb47f32da33501e();

});
parcelRegister("h8RF7", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $c7accf32bcfd2f76$export$5ee1d46cd0883a22);

var $jlH1f = parcelRequire("jlH1f");
const $c7accf32bcfd2f76$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $c7accf32bcfd2f76$var$warnings = new WeakMap();
const $c7accf32bcfd2f76$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $jlH1f.default).devtools ? $c7accf32bcfd2f76$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$c7accf32bcfd2f76$var$warnings.has(actionFn)) $c7accf32bcfd2f76$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $c7accf32bcfd2f76$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $c7accf32bcfd2f76$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});

parcelRegister("kZB80", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4864e012c896c7c$export$2e2bcd8739ae039);

var $4LHqy = parcelRequire("4LHqy");

var $e224M = parcelRequire("e224M");

var $jlH1f = parcelRequire("jlH1f");

var $aYjQs = parcelRequire("aYjQs");
function $f4864e012c896c7c$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $aYjQs.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $4LHqy.default)(storeState, (0, $jlH1f.default).middlewares);
    return storeState;
}
var $f4864e012c896c7c$export$2e2bcd8739ae039 = (0, $e224M.default)($f4864e012c896c7c$var$createStoreState);

});
parcelRegister("4LHqy", function(module, exports) {
$parcel$export(module.exports, "default", () => $378d3cf55e1bb357$export$2e2bcd8739ae039);

var $jlH1f = parcelRequire("jlH1f");

var $fhVqL = parcelRequire("fhVqL");
const $378d3cf55e1bb357$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $fhVqL.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $jlH1f.default).mutator);
var $378d3cf55e1bb357$export$2e2bcd8739ae039 = $378d3cf55e1bb357$var$applyMiddleware;

});
parcelRegister("fhVqL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b214fe17edd1ab28$export$2e2bcd8739ae039);

var $20o5O = parcelRequire("20o5O");
const $b214fe17edd1ab28$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $20o5O.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $b214fe17edd1ab28$export$2e2bcd8739ae039 = $b214fe17edd1ab28$var$updateMiddleware;

});
parcelRegister("20o5O", function(module, exports) {
$parcel$export(module.exports, "default", () => $175e452e267f7971$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $175e452e267f7971$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $175e452e267f7971$var$CACHE = new WeakMap();
function $175e452e267f7971$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($175e452e267f7971$var$CACHE.has(objA)) keysA = $175e452e267f7971$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $175e452e267f7971$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($175e452e267f7971$var$CACHE.has(objB)) keysB = $175e452e267f7971$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $175e452e267f7971$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$175e452e267f7971$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("e224M", function(module, exports) {
$parcel$export(module.exports, "default", () => $a372dcda187a58cf$export$2e2bcd8739ae039);

var $jlH1f = parcelRequire("jlH1f");
const $a372dcda187a58cf$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $a372dcda187a58cf$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $jlH1f.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $jlH1f.default).devtools === 'function' ? (0, $jlH1f.default).devtools(storeState) : {};
                        devTools = $a372dcda187a58cf$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $a372dcda187a58cf$export$2e2bcd8739ae039 = $a372dcda187a58cf$var$withDevtools;

});

parcelRegister("aYjQs", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fcee6c96ad15e78$export$2e2bcd8739ae039);

var $jlH1f = parcelRequire("jlH1f");

var $iOIqA = parcelRequire("iOIqA");

var $c8ckB = parcelRequire("c8ckB");
const $7fcee6c96ad15e78$var$QUEUE = [];
let $7fcee6c96ad15e78$var$scheduled;
function $7fcee6c96ad15e78$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $jlH1f.default).batchUpdates || !(0, $c8ckB.default).scheduling()) return (0, $iOIqA.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$7fcee6c96ad15e78$var$QUEUE.includes(fn)) $7fcee6c96ad15e78$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($7fcee6c96ad15e78$var$scheduled) return;
    $7fcee6c96ad15e78$var$scheduled = (0, $iOIqA.batch)(()=>{
        let queueFn;
        while(queueFn = $7fcee6c96ad15e78$var$QUEUE.shift())queueFn();
        $7fcee6c96ad15e78$var$scheduled = null;
    });
}

});




parcelRegister("g6dQg", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $bb87f19debd1f20c$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $bb87f19debd1f20c$export$38d24f3c60944dd5);

var $98gsW = parcelRequire("98gsW");
function $bb87f19debd1f20c$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $98gsW.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $98gsW.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $bb87f19debd1f20c$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $bb87f19debd1f20c$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $bb87f19debd1f20c$var$cache = new WeakMap();
function $bb87f19debd1f20c$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$bb87f19debd1f20c$var$cache.has(storeState)) $bb87f19debd1f20c$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $bb87f19debd1f20c$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $bb87f19debd1f20c$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $bb87f19debd1f20c$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("98gsW", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a61a228510df486$export$2e2bcd8739ae039);

var $20o5O = parcelRequire("20o5O");
function $6a61a228510df486$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $6a61a228510df486$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $20o5O.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$6a61a228510df486$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $6a61a228510df486$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $6a61a228510df486$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $20o5O.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("ik3UL", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $d56d21930d4a7a91$export$26ae5ca175b4ec5a);

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $8MDsR = parcelRequire("8MDsR");

var $h8RF7 = parcelRequire("h8RF7");
var $kMxBB = parcelRequire("kMxBB");

var $20o5O = parcelRequire("20o5O");
const $d56d21930d4a7a91$var$_excluded = [
    "children"
], $d56d21930d4a7a91$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $d56d21930d4a7a91$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d56d21930d4a7a91$var$noop = ()=>()=>{};
function $d56d21930d4a7a91$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $d56d21930d4a7a91$var$noop, onUpdate: onUpdate = $d56d21930d4a7a91$var$noop, onCleanup: onCleanup = $d56d21930d4a7a91$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $d56d21930d4a7a91$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $d56d21930d4a7a91$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $d56d21930d4a7a91$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $d56d21930d4a7a91$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $d56d21930d4a7a91$var$createFunctionContainer(StoreOrOptions);
}
function $d56d21930d4a7a91$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $fc4bM.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $kMxBB.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $d56d21930d4a7a91$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $fc4bM.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $fc4bM.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $h8RF7.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $h8RF7.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $d56d21930d4a7a91$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $fc4bM.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $fc4bM.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $d56d21930d4a7a91$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $d56d21930d4a7a91$var$_objectWithoutPropertiesLoose(props, $d56d21930d4a7a91$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $d56d21930d4a7a91$var$_objectWithoutPropertiesLoose(restProps, $d56d21930d4a7a91$var$_excluded2);
        const ctx = (0, $fc4bM.useContext)((0, $8MDsR.Context));
        const registry = $d56d21930d4a7a91$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $fc4bM.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $d56d21930d4a7a91$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $d56d21930d4a7a91$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $20o5O.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $fc4bM.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $fc4bM.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MDsR.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).bool
    };
    return FunctionContainer;
}

});

parcelRegister("ipn74", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $d66c7d8a0f82adba$export$f51a9068ac82ea43);

var $3zHkR = parcelRequire("3zHkR");
function $d66c7d8a0f82adba$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $3zHkR.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $d66c7d8a0f82adba$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $d66c7d8a0f82adba$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("3zHkR", function(module, exports) {
$parcel$export(module.exports, "default", () => $29a641833a96c43e$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $29a641833a96c43e$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("gV9Q4", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $c5199a0591945a86$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $c5199a0591945a86$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $c5199a0591945a86$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $c5199a0591945a86$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $c5199a0591945a86$export$c9237620ff7fdf7c);

var $5AACw = parcelRequire("5AACw");
parcelRequire("b2RKK");
var $irKLf = parcelRequire("irKLf");
const $c5199a0591945a86$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $c5199a0591945a86$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $c5199a0591945a86$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $c5199a0591945a86$var$stripTrailingSlash(prefix);
        prefix = $c5199a0591945a86$var$addLeadingSlash(prefix);
        path = $c5199a0591945a86$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $c5199a0591945a86$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $c5199a0591945a86$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$c5199a0591945a86$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5AACw)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5AACw)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $c5199a0591945a86$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$c5199a0591945a86$export$e83e3719fc818ee5(path)) {
        path = $c5199a0591945a86$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($5AACw)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $c5199a0591945a86$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5AACw.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $c5199a0591945a86$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $c5199a0591945a86$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $irKLf.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("2drpp", function(module, exports) {
$parcel$export(module.exports, "Router", () => $19d20e831c63f6d3$export$55185c17a0fcbe46);

var $hHCeM = parcelRequire("hHCeM");

var $b2AyF = parcelRequire("b2AyF");

var $fc4bM = parcelRequire("fc4bM");

var $iKMBk = parcelRequire("iKMBk");
const $19d20e831c63f6d3$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iKMBk.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $19d20e831c63f6d3$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $fc4bM.useMemo)(()=>(0, $b2AyF.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($19d20e831c63f6d3$export$55185c17a0fcbe46, (0, $hHCeM.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("muw86", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $8whFx = parcelRequire("8whFx");
const $0439ba45d133ab32$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $8whFx.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(actions));
};
$0439ba45d133ab32$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("8whFx", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $633f04939373c795$export$402e82ff1b20594b);

var $iKMBk = parcelRequire("iKMBk");
const $633f04939373c795$export$402e82ff1b20594b = (0, $iKMBk.useRouterStoreActions);

});


parcelRegister("dpoZ0", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => $9c30fd3e7c447f3b$export$672d721d310ff5f0);

var $1ZwRz = parcelRequire("1ZwRz");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("b2RKK");
var $9Uvsu = parcelRequire("9Uvsu");

var $iKMBk = parcelRequire("iKMBk");
const $9c30fd3e7c447f3b$var$_excluded = [
    "listen"
];
const $9c30fd3e7c447f3b$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $iKMBk.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1ZwRz.default)(_ref, $9c30fd3e7c447f3b$var$_excluded);
    if (!state.unlisten && !(0, $9Uvsu.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(state, actions));
};

});
parcelRegister("1ZwRz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1734fadbe8a9b961$export$2e2bcd8739ae039);
function $1734fadbe8a9b961$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lJu6R", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $fd2528153924d43b$export$8c8591dcd57728e6);

var $fc4bM = parcelRequire("fc4bM");

var $5nVr1 = parcelRequire("5nVr1");

var $iKMBk = parcelRequire("iKMBk");
const $fd2528153924d43b$var$createPathParamHook = (0, $5nVr1.createHook)((0, $iKMBk.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $fd2528153924d43b$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $fd2528153924d43b$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $fc4bM.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("6FZlb", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $4dc62760d759e9ed$export$ae316f0eeb712a36);

var $fc4bM = parcelRequire("fc4bM");

var $5nVr1 = parcelRequire("5nVr1");

var $iKMBk = parcelRequire("iKMBk");
const $4dc62760d759e9ed$var$createQueryParamHook = (0, $5nVr1.createHook)((0, $iKMBk.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $4dc62760d759e9ed$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $4dc62760d759e9ed$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $fc4bM.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("7tc2B", function(module, exports) {
$parcel$export(module.exports, "withRouter", () => $570494ed455e6cf9$export$369b6b2b30582e8e);

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");

var $iKMBk = parcelRequire("iKMBk");
const $570494ed455e6cf9$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $570494ed455e6cf9$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $570494ed455e6cf9$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $iKMBk.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, (0, $hHCeM.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("j2ICI", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("hi8gb")).default);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("3iZvk")).RouteComponent);

var $hi8gb = parcelRequire("hi8gb");

var $3iZvk = parcelRequire("3iZvk");

});
parcelRegister("hi8gb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c96a865fa31ae6b3$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");

var $b2AyF = parcelRequire("b2AyF");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("b2RKK");
var $jAYcL = parcelRequire("jAYcL");
var $li4LR = parcelRequire("li4LR");

var $iKMBk = parcelRequire("iKMBk");

var $cy5iJ = parcelRequire("cy5iJ");
parcelRequire("45cgi");
var $cdXfl = parcelRequire("cdXfl");
var $l0HGD = parcelRequire("l0HGD");
const $c96a865fa31ae6b3$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $c96a865fa31ae6b3$var$PREFETCH_DELAY = 225;
const $c96a865fa31ae6b3$var$Link = /*#__PURE__*/ (0, $fc4bM.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1ZwRz.default)(_ref, $c96a865fa31ae6b3$var$_excluded);
    const routerActions = (0, $iKMBk.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $cy5iJ.useTimeout)($c96a865fa31ae6b3$var$PREFETCH_DELAY);
    const validLinkType = (0, $cdXfl.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $fc4bM.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $b2AyF.createPath)((0, $li4LR.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $fc4bM.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $jAYcL.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $l0HGD.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $fc4bM.createElement)(validLinkType, (0, $hHCeM.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$c96a865fa31ae6b3$var$Link.displayName = 'Link';
var $c96a865fa31ae6b3$export$2e2bcd8739ae039 = $c96a865fa31ae6b3$var$Link;

});
parcelRegister("cy5iJ", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $922cc5b816a45b39$export$d8e6abf214c9ec0f);

var $fc4bM = parcelRequire("fc4bM");
const $922cc5b816a45b39$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $fc4bM.useRef)();
    const schedule = (0, $fc4bM.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $fc4bM.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("45cgi", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("cdXfl")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("l0HGD")).handleNavigation);

var $cdXfl = parcelRequire("cdXfl");

var $l0HGD = parcelRequire("l0HGD");

});
parcelRegister("cdXfl", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $8e64a810773bdb17$export$855ece989b15eb57);
const $8e64a810773bdb17$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $8e64a810773bdb17$export$855ece989b15eb57 = (type)=>$8e64a810773bdb17$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("l0HGD", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $f4bb7c4f36c62ceb$export$706ad1af8096e280);

var $7sS2E = parcelRequire("7sS2E");
const $f4bb7c4f36c62ceb$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $7sS2E.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $7sS2E.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $7sS2E.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("7sS2E", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $56f51178b8350f46$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $56f51178b8350f46$export$130b789831072f4c);
const $56f51178b8350f46$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $56f51178b8350f46$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("3iZvk", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $2682c2feb074121f$export$7903e4b73fc7d6c3);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("7FXXp");
var $7lAXH = parcelRequire("7lAXH");
const $2682c2feb074121f$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $7lAXH.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("glIdA", function(module, exports) {
parcelRequire("b2RKK");
var $jAYcL = parcelRequire("jAYcL");
const $be70e84c5bceb008$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $jAYcL.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("lmYMP", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => (parcelRequire("fVzH4")).createResourcesPlugin);
$parcel$export(module.exports, "useResource", () => (parcelRequire("VTASg")).useResource);
$parcel$export(module.exports, "createResource", () => (parcelRequire("fOvEc")).createResource);

var $fVzH4 = parcelRequire("fVzH4");

var $dZijv = parcelRequire("dZijv");

var $VTASg = parcelRequire("VTASg");

var $4Aq7d = parcelRequire("4Aq7d");
parcelRequire("jT5qD");
var $fOvEc = parcelRequire("fOvEc");

var $fVzH4 = parcelRequire("fVzH4");

var $cr66w = parcelRequire("cr66w");

});
parcelRegister("fVzH4", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $b987dde4bf4fe844$export$23ed892c481a96fe);

var $jT5qD = parcelRequire("jT5qD");
parcelRequire("lR7Xx");
var $1obUV = parcelRequire("1obUV");
const $b987dde4bf4fe844$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $b987dde4bf4fe844$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $jT5qD.getResourceStore)().actions;
    const nextResources = (0, $1obUV.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $b987dde4bf4fe844$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $jT5qD.getResourceStore)().actions;
    const nextResources = (0, $1obUV.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $b987dde4bf4fe844$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $jT5qD.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $b987dde4bf4fe844$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $b987dde4bf4fe844$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $b987dde4bf4fe844$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $jT5qD.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $jT5qD.getResourceStore)().actions;
            const nextResources = (0, $1obUV.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $jT5qD.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("jT5qD", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $e7a75d5c465a396d$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $e7a75d5c465a396d$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $e7a75d5c465a396d$export$98e41a62c9bef75e);
$parcel$export(module.exports, "createResource", () => (parcelRequire("fOvEc")).createResource);

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");

var $5nVr1 = parcelRequire("5nVr1");
var $ik3UL = parcelRequire("ik3UL");
var $ipn74 = parcelRequire("ipn74");
var $c7ORi = parcelRequire("c7ORi");
var $kMxBB = parcelRequire("kMxBB");
parcelRequire("b2RKK");
var $9Uvsu = parcelRequire("9Uvsu");

var $h7P8c = parcelRequire("h7P8c");
parcelRequire("lR7Xx");
var $ljF9j = parcelRequire("ljF9j");
var $5hXFA = parcelRequire("5hXFA");
var $fOvEc = parcelRequire("fOvEc");
var $6K8hX = parcelRequire("6K8hX");
var $ePjjg = parcelRequire("ePjjg");
var $bkFRL = parcelRequire("bkFRL");
var $7Oa6j = parcelRequire("7Oa6j");
var $iW8fN = parcelRequire("iW8fN");
var $klPaC = parcelRequire("klPaC");
var $1Y6WL = parcelRequire("1Y6WL");
var $6boUu = parcelRequire("6boUu");
var $3rWDW = parcelRequire("3rWDW");
var $a0mdX = parcelRequire("a0mdX");
const $e7a75d5c465a396d$var$_excluded = [
    "context"
], $e7a75d5c465a396d$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $e7a75d5c465a396d$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $6K8hX.deleteResourceState)(type, key));
                dispatch((0, $ljF9j.executeForDependents)(resource, (dependentResource)=>$e7a75d5c465a396d$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $6K8hX.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1ZwRz.default)(_getState, $e7a75d5c465a396d$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $h7P8c.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $hHCeM.default)({}, prevSlice, changes, {
                expiresAt: (0, $iW8fN.getExpiresAt)(maxAge),
                accessedAt: (0, $bkFRL.getAccessedAt)()
            });
            dispatch((0, $6K8hX.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $ljF9j.executeForDependents)(resource, (dependentResource)=>$e7a75d5c465a396d$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $6K8hX.getResourceState)(type, key));
            if (cached && (0, $klPaC.shouldUseCache)(cached)) {
                if ((0, $klPaC.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $1Y6WL.setSsrDataPromise)(cached);
                    cached = (0, $iW8fN.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $bkFRL.getAccessedAt)();
                dispatch((0, $6K8hX.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($e7a75d5c465a396d$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $6K8hX.getResourceState)(type, key)) || (0, $7Oa6j.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $a0mdX.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $6K8hX.getPrefetchSlice)(type, key)) || (0, $5hXFA.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $ljF9j.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $6K8hX.setResourceState)(type, key, (0, $hHCeM.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $bkFRL.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $ljF9j.executeForDependents)(resource, (dependentResource)=>$e7a75d5c465a396d$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $6boUu.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $6K8hX.getResourceState)(type, key));
            const finalSlice = (0, $hHCeM.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $bkFRL.getAccessedAt)(),
                expiresAt: (0, $iW8fN.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $6K8hX.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $6K8hX.getPrefetchSlice)(type, key)) || (0, $5hXFA.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $ljF9j.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $6K8hX.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $ljF9j.executeForDependents)(resource, (dependentResource)=>$e7a75d5c465a396d$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $e7a75d5c465a396d$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $ljF9j.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $e7a75d5c465a396d$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $ljF9j.actionWithDependencies)(routerStoreContext.route.resources, resource, $e7a75d5c465a396d$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $ljF9j.actionWithDependencies)(routerStoreContext.route.resources, resource, $e7a75d5c465a396d$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $ljF9j.actionWithDependencies)(routerStoreContext.route.resources, resource, $e7a75d5c465a396d$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($e7a75d5c465a396d$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $6K8hX.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $6K8hX.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $9Uvsu.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $ljF9j.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$e7a75d5c465a396d$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $ljF9j.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$e7a75d5c465a396d$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $hHCeM.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $3rWDW.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1ZwRz.default)(_ref, $e7a75d5c465a396d$var$_excluded2);
                const deserializedError = !error ? null : (0, $ePjjg.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $hHCeM.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $3rWDW.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $ePjjg.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $6boUu.TimeoutError) ? loading : false
                }))
};
const $e7a75d5c465a396d$export$94f50dade551bd01 = (0, $ipn74.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $e7a75d5c465a396d$export$e324594224ef24da,
    name: 'router-resources'
});
const $e7a75d5c465a396d$export$cc90fb9c37c5589d = (0, $ik3UL.createContainer)($e7a75d5c465a396d$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $e7a75d5c465a396d$export$fee1a6213543bd78 = (0, $c7ORi.createSubscriber)($e7a75d5c465a396d$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $h7P8c.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $e7a75d5c465a396d$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $kMxBB.defaultRegistry).getStore($e7a75d5c465a396d$export$94f50dade551bd01);
const $e7a75d5c465a396d$export$ac3608e0bb357c7 = (0, $5nVr1.createHook)($e7a75d5c465a396d$export$94f50dade551bd01, {
    selector: (0, $h7P8c.getSliceForResource)
});
const $e7a75d5c465a396d$export$98e41a62c9bef75e = (0, $5nVr1.createActionsHook)($e7a75d5c465a396d$export$94f50dade551bd01);
const $e7a75d5c465a396d$export$e59f52df235ac7b3 = (0, $5nVr1.createHook)($e7a75d5c465a396d$export$94f50dade551bd01, {
    selector: (0, $h7P8c.getResourceStoreContext)
});

});
parcelRegister("c7ORi", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $8d3d96f79f979548$export$48f338a7e080595c);

var $5nVr1 = parcelRequire("5nVr1");
const $8d3d96f79f979548$var$_excluded = [
    "children"
];
function $8d3d96f79f979548$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8d3d96f79f979548$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $8d3d96f79f979548$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $5nVr1.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $8d3d96f79f979548$var$_objectWithoutPropertiesLoose(_ref, $8d3d96f79f979548$var$_excluded);
        const api = useStore($8d3d96f79f979548$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("h7P8c", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $c77ac0b96657eafc$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $c77ac0b96657eafc$export$6a0b1779210de0ee);

var $hHCeM = parcelRequire("hHCeM");
parcelRequire("lR7Xx");
var $7Oa6j = parcelRequire("7Oa6j");
const $c77ac0b96657eafc$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $hHCeM.default)({}, slice) : (0, $7Oa6j.getDefaultStateSlice)();
};
const $c77ac0b96657eafc$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("lR7Xx", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("bkFRL")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("5hXFA")).createLoadingSlice);
$parcel$export(module.exports, "createResource", () => (parcelRequire("fOvEc")).createResource);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("ljF9j")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("ljF9j")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("ljF9j")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("ljF9j")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("iW8fN")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("iW8fN")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("7Oa6j")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("1obUV")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("a0mdX")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("6K8hX")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("6K8hX")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("6K8hX")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("6K8hX")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("6K8hX")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("ePjjg")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("ePjjg")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("klPaC")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("klPaC")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("1Y6WL")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("6boUu")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("3rWDW")).transformData);

var $bkFRL = parcelRequire("bkFRL");

var $5hXFA = parcelRequire("5hXFA");

var $fOvEc = parcelRequire("fOvEc");

var $ljF9j = parcelRequire("ljF9j");

var $iW8fN = parcelRequire("iW8fN");

var $9MU5B = parcelRequire("9MU5B");

var $7Oa6j = parcelRequire("7Oa6j");

var $hmTas = parcelRequire("hmTas");

var $1obUV = parcelRequire("1obUV");

var $a0mdX = parcelRequire("a0mdX");

var $6K8hX = parcelRequire("6K8hX");

var $62jb5 = parcelRequire("62jb5");

var $ePjjg = parcelRequire("ePjjg");

var $klPaC = parcelRequire("klPaC");

var $1Y6WL = parcelRequire("1Y6WL");

var $6boUu = parcelRequire("6boUu");

var $3rWDW = parcelRequire("3rWDW");

});
parcelRegister("bkFRL", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $840209b3493e6dd9$export$9ccb639b7a119f61);
const $840209b3493e6dd9$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("5hXFA", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $3d9cd37513cc5cf9$export$dc62515c8f0b52dd);

var $hHCeM = parcelRequire("hHCeM");

var $3hrUC = parcelRequire("3hrUC");

var $iW8fN = parcelRequire("iW8fN");

var $9MU5B = parcelRequire("9MU5B");

var $6boUu = parcelRequire("6boUu");

var $hgDRg = parcelRequire("hgDRg");
function $3d9cd37513cc5cf9$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $hHCeM.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $9MU5B.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $6boUu.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $iW8fN.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $3hrUC.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $iW8fN.getExpiresAt)((0, $hgDRg.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("3hrUC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $26389c6ef66c1528$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $26389c6ef66c1528$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $26389c6ef66c1528$export$12c1dc38ea1692da);
const $26389c6ef66c1528$export$881d135f98d8d7d0 = 100;
const $26389c6ef66c1528$export$9ab5bdcb8a1d6c34 = false;
const $26389c6ef66c1528$export$12c1dc38ea1692da = 0;

});

parcelRegister("iW8fN", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $dc940bcda89f1e59$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $dc940bcda89f1e59$export$18d1d420fd588368);

var $hHCeM = parcelRequire("hHCeM");
const $dc940bcda89f1e59$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $dc940bcda89f1e59$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $hHCeM.default)({}, slice, {
        expiresAt: $dc940bcda89f1e59$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("9MU5B", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $72041ae9bcf60f51$export$58634b3a58ae66b7);
const $72041ae9bcf60f51$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("6boUu", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $480717cca2a9c500$export$66d311bf29d5c89c);
class $480717cca2a9c500$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("hgDRg", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $033e7f601fae1248$export$37d3126be6549b13);
const $033e7f601fae1248$export$37d3126be6549b13 = 10000;

});


parcelRegister("fOvEc", function(module, exports) {
$parcel$export(module.exports, "createResource", () => $b834130d14f7412a$export$edd172c6c83c39cc);

var $3hrUC = parcelRequire("3hrUC");
/**
 * Utility method to created async versions of getData functions
 */ const $b834130d14f7412a$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $b834130d14f7412a$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $b834130d14f7412a$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $3hrUC.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $3hrUC.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $3hrUC.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("ljF9j", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $f84b4aaf664acca2$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $f84b4aaf664acca2$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $f84b4aaf664acca2$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $f84b4aaf664acca2$export$75915f81f2a6540a);

var $hHCeM = parcelRequire("hHCeM");

var $7Oa6j = parcelRequire("7Oa6j");

var $6K8hX = parcelRequire("6K8hX");
var $f84b4aaf664acca2$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $f84b4aaf664acca2$var$fromEntries = ($f84b4aaf664acca2$var$_Object$fromEntries = Object.fromEntries) != null ? $f84b4aaf664acca2$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $f84b4aaf664acca2$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $f84b4aaf664acca2$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $f84b4aaf664acca2$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($f84b4aaf664acca2$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($f84b4aaf664acca2$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($f84b4aaf664acca2$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $f84b4aaf664acca2$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($f84b4aaf664acca2$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $f84b4aaf664acca2$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$f84b4aaf664acca2$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $f84b4aaf664acca2$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($f84b4aaf664acca2$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $f84b4aaf664acca2$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($f84b4aaf664acca2$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $f84b4aaf664acca2$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($f84b4aaf664acca2$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $f84b4aaf664acca2$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $f84b4aaf664acca2$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $f84b4aaf664acca2$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $6K8hX.getResourceState)(dependencyType, key)) || (0, $7Oa6j.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $6K8hX.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $hHCeM.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("7Oa6j", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $5af509c0058cd210$export$fa8e33c3301e2e94);

var $hHCeM = parcelRequire("hHCeM");

var $bkFRL = parcelRequire("bkFRL");

var $3hrUC = parcelRequire("3hrUC");

var $iW8fN = parcelRequire("iW8fN");

var $bar8b = parcelRequire("bar8b");
const $5af509c0058cd210$export$fa8e33c3301e2e94 = ()=>(0, $hHCeM.default)({}, (0, $bar8b.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $iW8fN.getExpiresAt)((0, $3hrUC.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $bkFRL.getAccessedAt)()
    });

});
parcelRegister("bar8b", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $8215ac84537c3719$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $8215ac84537c3719$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("6K8hX", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $4e8d77e159b71460$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $4e8d77e159b71460$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $4e8d77e159b71460$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $4e8d77e159b71460$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $4e8d77e159b71460$export$d40f35dc5952864b);

var $1ZwRz = parcelRequire("1ZwRz");

var $hHCeM = parcelRequire("hHCeM");
function $4e8d77e159b71460$var$_toPropertyKey(t) {
    var i = $4e8d77e159b71460$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $4e8d77e159b71460$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4e8d77e159b71460$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $4e8d77e159b71460$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $hHCeM.default)({}, prefetching, {
                [type]: (0, $hHCeM.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $4e8d77e159b71460$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($4e8d77e159b71460$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $hHCeM.default)({}, data, {
                [type]: (0, $hHCeM.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $4e8d77e159b71460$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $4e8d77e159b71460$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1ZwRz.default)(data, [
            type
        ].map($4e8d77e159b71460$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1ZwRz.default)(resourceForType, [
                key
            ].map($4e8d77e159b71460$var$_toPropertyKey));
            setState({
                data: (0, $hHCeM.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("hmTas", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $ca4f48e8f73ebf0e$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $ca4f48e8f73ebf0e$export$cd7fbe7e979df558);
const $ca4f48e8f73ebf0e$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $ca4f48e8f73ebf0e$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$ca4f48e8f73ebf0e$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("1obUV", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $103146ced743ab66$export$7cbbc763e2f3d65d);

var $hmTas = parcelRequire("hmTas");

var $62jb5 = parcelRequire("62jb5");
const $103146ced743ab66$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $62jb5.routeHasResources)(nextRoute)) return [];
    if ((0, $62jb5.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $hmTas.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $hmTas.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("62jb5", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $4651ce4d47a55770$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $4651ce4d47a55770$export$221027ff1aa38f82);
const $4651ce4d47a55770$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $4651ce4d47a55770$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("a0mdX", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $748b24b919b3cdde$export$89440b7623c2c75c);

var $6K8hX = parcelRequire("6K8hX");
const $748b24b919b3cdde$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $748b24b919b3cdde$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $748b24b919b3cdde$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $748b24b919b3cdde$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $748b24b919b3cdde$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $6K8hX.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("ePjjg", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $acb4cea23cabf70a$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $acb4cea23cabf70a$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $acb4cea23cabf70a$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $acb4cea23cabf70a$var$NonError);
    }
}
const $acb4cea23cabf70a$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $acb4cea23cabf70a$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $acb4cea23cabf70a$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $acb4cea23cabf70a$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $acb4cea23cabf70a$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $acb4cea23cabf70a$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $acb4cea23cabf70a$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $acb4cea23cabf70a$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $acb4cea23cabf70a$var$NonError(value);
};

});

parcelRegister("klPaC", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $ed0d762a7b6b5bff$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $ed0d762a7b6b5bff$export$399de8c43d0ece3c);
const $ed0d762a7b6b5bff$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $ed0d762a7b6b5bff$var$isFresh = (resource)=>{
    if ($ed0d762a7b6b5bff$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $ed0d762a7b6b5bff$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($ed0d762a7b6b5bff$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("1Y6WL", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $16f0c88c381bdd1d$export$2e4da1b414980956);

var $hHCeM = parcelRequire("hHCeM");
const $16f0c88c381bdd1d$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $hHCeM.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("3rWDW", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $283162076b973529$export$3ceb62baab058c6b);
const $283162076b973529$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("dZijv", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $VTASg = parcelRequire("VTASg");
const $a2ef2d93be1fc2b8$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $VTASg.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(result));
};

});
parcelRegister("VTASg", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $0ae072beccfb37b1$export$9f6abfd74295843b);

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");

var $5nVr1 = parcelRequire("5nVr1");
parcelRequire("a3Wd7");
var $iKMBk = parcelRequire("iKMBk");

var $jT5qD = parcelRequire("jT5qD");
const $0ae072beccfb37b1$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $jT5qD.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $iKMBk.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $fc4bM.useMemo)(()=>(0, $5nVr1.createHook)((0, $iKMBk.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $jT5qD.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $fc4bM.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $fc4bM.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $fc4bM.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $fc4bM.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $fc4bM.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $hHCeM.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("4Aq7d", function(module, exports) {

var $jT5qD = parcelRequire("jT5qD");
const $356ec82ca1cad138$export$dee7bf9fc0ff48c3 = (fn)=>(0, $jT5qD.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("cr66w", function(module, exports) {
const $90dcbdd7027dcfa8$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("44fTH", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $41a1f85383ed1c0d$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getEventQueue", () => $41a1f85383ed1c0d$export$584d8b0a0989eefd);
/**
 * Wrapper around AJS
 */ 
var $aYMdQ = parcelRequire("aYMdQ");

var $6LH8a = parcelRequire("6LH8a");
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $41a1f85383ed1c0d$var$ajs = window.AJS;
const $41a1f85383ed1c0d$export$c47913ca32a5c6f7 = (key)=>{
    if ($41a1f85383ed1c0d$var$ajs && $41a1f85383ed1c0d$var$ajs.Meta) return $41a1f85383ed1c0d$var$ajs.Meta.get(key);
    /** When jsd-dw-portal-wrm-optimisations is on we fallback to a native version of getMeta that doesn't rely on AJS being loaded on the page via WRM */ const value = (0, $6LH8a.getMetaFromHTML)(key);
    return (0, $aYMdQ.isNil)(value) ? undefined : value;
};
const $41a1f85383ed1c0d$export$584d8b0a0989eefd = ()=>{
    return $41a1f85383ed1c0d$var$ajs === undefined ? undefined : $41a1f85383ed1c0d$var$ajs.EventQueue;
};

});



parcelRegister("jgb8T", function(module, exports) {
$parcel$export(module.exports, "devLog", () => $ddaebe330c95c182$export$c45ebb6cef9d5b7b);

var $7lN8e = parcelRequire("7lN8e");
function $ddaebe330c95c182$export$c45ebb6cef9d5b7b(message, ...optionalParams) {
    const env = (0, $7lN8e.getEnv)();
    // eslint-disable-next-line no-console
    env.environment !== (0, $7lN8e.EnvType).PROD && console.log(message, ...optionalParams);
}

});

parcelRegister("8Ogqb", function(module, exports) {
$parcel$export(module.exports, "getApplicationType", () => $d4dc90661ad6b325$export$4f7ec84576d049fa);

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
const $d4dc90661ad6b325$export$4f7ec84576d049fa = ()=>{
    return {
        applicationType: (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) ? 'jcs' : 'jsm'
    };
};

});

parcelRegister("1cNOK", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterAnalyticsData", () => $d12a165d5a07e28d$export$bd448d1bc798d83d);

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");
const $d12a165d5a07e28d$export$bd448d1bc798d83d = ()=>{
    if ((0, $cf3fd.isHelpCentersManagement)()) return undefined;
    const { edition: edition } = (0, $7lN8e.getEnv)();
    return {
        helpCenterType: (0, $cf3fd.isAdvancedHelpCenter)() ? 'custom' : 'default',
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        ...edition ? {
            edition: edition
        } : {},
        ...(0, $hN5YJ.isSendRawHelpCenterTypeInAnalyticsEnabled)() ? {
            helpCenterCategory: (0, $7lN8e.getEnv)().helpCenterType
        } : {}
    };
};

});


parcelRegister("4B1hn", function(module, exports) {
$parcel$export(module.exports, "sentryQueue", () => $85c0592d1ca51e56$export$4bff35a64b482759);

var $7wx9B = parcelRequire("7wx9B");
const $85c0592d1ca51e56$export$4bff35a64b482759 = {
    pushError (err) {
        if ((0, $7wx9B.isSentryEnabled)()) {
            if (!window.JSM_EXCEPTION_QUEUE) window.JSM_EXCEPTION_QUEUE = [
                err
            ];
            else window.JSM_EXCEPTION_QUEUE.push(err);
        }
    },
    flushErrors () {
        var _window$JSM_EXCEPTION;
        (_window$JSM_EXCEPTION = window.JSM_EXCEPTION_QUEUE) === null || _window$JSM_EXCEPTION === void 0 || _window$JSM_EXCEPTION.forEach((err)=>(0, $7wx9B.reportError)(err));
        delete window.JSM_EXCEPTION_QUEUE;
    }
};

});
parcelRegister("7wx9B", function(module, exports) {
$parcel$export(module.exports, "isSentryEnabled", () => $a33cbe15e7b97e41$export$ec3dcf0ab235344b);
$parcel$export(module.exports, "reportError", () => $a33cbe15e7b97e41$export$b33b857ad1d9900e);

var $2tNS7 = parcelRequire("2tNS7");

var $eigSc = parcelRequire("eigSc");

var $aYMdQ = parcelRequire("aYMdQ");

var $7lN8e = parcelRequire("7lN8e");
const $a33cbe15e7b97e41$export$ec3dcf0ab235344b = ()=>{
    const env = (0, $7lN8e.getEnv)();
    if (env.environment === (0, $7lN8e.EnvType).STAGING) return true;
    return env.environment === (0, $7lN8e.EnvType).PROD;
};
const $a33cbe15e7b97e41$export$b33b857ad1d9900e = (exception, additionalErrorData)=>{
    // eslint-disable-next-line no-console
    console.error('reportError', exception, additionalErrorData);
    if ($a33cbe15e7b97e41$export$ec3dcf0ab235344b()) {
        if (additionalErrorData && (0, $aYMdQ.isNil)(additionalErrorData.message) && exception instanceof Error) $2tNS7.withScope((scope)=>{
            const { teamName: teamName, errorBoundaryId: errorBoundaryId, errorBoundaryPackageName: packageName } = additionalErrorData;
            if (errorBoundaryId) scope.setTag('errorBoundaryId', errorBoundaryId);
            if (packageName) scope.setTag('packageName', packageName);
            if (teamName) scope.setTag('teamName', teamName);
            const event = (0, $eigSc.eventFromUnknownInput)(exception);
            $2tNS7.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        });
        else {
            const event = (0, $eigSc.eventFromUnknownInput)(exception);
            $2tNS7.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        }
    }
};

});
parcelRegister("2tNS7", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $1ce4f9b5f9048527$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $1ce4f9b5f9048527$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $1ce4f9b5f9048527$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $1ce4f9b5f9048527$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $1ce4f9b5f9048527$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $1ce4f9b5f9048527$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $1ce4f9b5f9048527$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $1ce4f9b5f9048527$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $1ce4f9b5f9048527$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $1ce4f9b5f9048527$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $1ce4f9b5f9048527$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $1ce4f9b5f9048527$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $1ce4f9b5f9048527$export$e262da7ae6480481);

var $5lpFe = parcelRequire("5lpFe");

var $REREP = parcelRequire("REREP");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1ce4f9b5f9048527$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $REREP.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $5lpFe.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $1ce4f9b5f9048527$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $1ce4f9b5f9048527$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $1ce4f9b5f9048527$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $1ce4f9b5f9048527$var$callOnHub('captureMessage', message, level, (0, $5lpFe.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $1ce4f9b5f9048527$export$1462b974fdcf6ba2(event) {
    return $1ce4f9b5f9048527$var$callOnHub('captureEvent', event);
}
function $1ce4f9b5f9048527$export$99d44f04437e9cb8(callback) {
    $1ce4f9b5f9048527$var$callOnHub('configureScope', callback);
}
function $1ce4f9b5f9048527$export$efda9a273d7a036d(breadcrumb) {
    $1ce4f9b5f9048527$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $1ce4f9b5f9048527$export$2f04de43fe27971a(name, context) {
    $1ce4f9b5f9048527$var$callOnHub('setContext', name, context);
}
function $1ce4f9b5f9048527$export$bb4922da0dd51b92(extras) {
    $1ce4f9b5f9048527$var$callOnHub('setExtras', extras);
}
function $1ce4f9b5f9048527$export$74a8fb34822092e6(tags) {
    $1ce4f9b5f9048527$var$callOnHub('setTags', tags);
}
function $1ce4f9b5f9048527$export$8e8e7789d42ed61d(key, extra) {
    $1ce4f9b5f9048527$var$callOnHub('setExtra', key, extra);
}
function $1ce4f9b5f9048527$export$a37d07ee78eb4569(key, value) {
    $1ce4f9b5f9048527$var$callOnHub('setTag', key, value);
}
function $1ce4f9b5f9048527$export$8b6bb3dd62a01be2(user) {
    $1ce4f9b5f9048527$var$callOnHub('setUser', user);
}
function $1ce4f9b5f9048527$export$ec58d9285c204497(callback) {
    $1ce4f9b5f9048527$var$callOnHub('withScope', callback);
}
function $1ce4f9b5f9048527$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $1ce4f9b5f9048527$var$callOnHub.apply(void 0, (0, $5lpFe.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $1ce4f9b5f9048527$export$e262da7ae6480481(context, customSamplingContext) {
    return $1ce4f9b5f9048527$var$callOnHub('startTransaction', (0, $5lpFe.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("5lpFe", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $3e42d24666ecb6eb$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $3e42d24666ecb6eb$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $3e42d24666ecb6eb$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $3e42d24666ecb6eb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $3e42d24666ecb6eb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $3e42d24666ecb6eb$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $3e42d24666ecb6eb$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $3e42d24666ecb6eb$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $3e42d24666ecb6eb$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $3e42d24666ecb6eb$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $3e42d24666ecb6eb$export$1216008129fb82ed);
$parcel$export(module.exports, "__importDefault", () => $3e42d24666ecb6eb$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $3e42d24666ecb6eb$var$extendStatics = function(d, b) {
    $3e42d24666ecb6eb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3e42d24666ecb6eb$var$extendStatics(d, b);
};
function $3e42d24666ecb6eb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3e42d24666ecb6eb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3e42d24666ecb6eb$export$18ce0697a983be9b = function() {
    $3e42d24666ecb6eb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3e42d24666ecb6eb$export$18ce0697a983be9b.apply(this, arguments);
};
function $3e42d24666ecb6eb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3e42d24666ecb6eb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3e42d24666ecb6eb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3e42d24666ecb6eb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3e42d24666ecb6eb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3e42d24666ecb6eb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3e42d24666ecb6eb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3e42d24666ecb6eb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3e42d24666ecb6eb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3e42d24666ecb6eb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3e42d24666ecb6eb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3e42d24666ecb6eb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3e42d24666ecb6eb$export$45d3717a4c69092e(o, m, p);
}
function $3e42d24666ecb6eb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3e42d24666ecb6eb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3e42d24666ecb6eb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3e42d24666ecb6eb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3e42d24666ecb6eb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3e42d24666ecb6eb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3e42d24666ecb6eb$export$10c90e4f7922046c(v) {
    return this instanceof $3e42d24666ecb6eb$export$10c90e4f7922046c ? (this.v = v, this) : new $3e42d24666ecb6eb$export$10c90e4f7922046c(v);
}
function $3e42d24666ecb6eb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3e42d24666ecb6eb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3e42d24666ecb6eb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3e42d24666ecb6eb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3e42d24666ecb6eb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3e42d24666ecb6eb$export$19a8beecd37a4c45 === "function" ? $3e42d24666ecb6eb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3e42d24666ecb6eb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3e42d24666ecb6eb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $3e42d24666ecb6eb$var$ownKeys = function(o) {
    $3e42d24666ecb6eb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $3e42d24666ecb6eb$var$ownKeys(o);
};
function $3e42d24666ecb6eb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $3e42d24666ecb6eb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $3e42d24666ecb6eb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $3e42d24666ecb6eb$var$__setModuleDefault(result, mod);
    return result;
}
function $3e42d24666ecb6eb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3e42d24666ecb6eb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3e42d24666ecb6eb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3e42d24666ecb6eb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3e42d24666ecb6eb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3e42d24666ecb6eb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3e42d24666ecb6eb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3e42d24666ecb6eb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $3e42d24666ecb6eb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $3e42d24666ecb6eb$export$2e2bcd8739ae039 = {
    __extends: $3e42d24666ecb6eb$export$a8ba968b8961cb8a,
    __assign: $3e42d24666ecb6eb$export$18ce0697a983be9b,
    __rest: $3e42d24666ecb6eb$export$3c9a16f847548506,
    __decorate: $3e42d24666ecb6eb$export$29e00dfd3077644b,
    __param: $3e42d24666ecb6eb$export$d5ad3fd78186038f,
    __esDecorate: $3e42d24666ecb6eb$export$3a84e1ae4e97e9b0,
    __runInitializers: $3e42d24666ecb6eb$export$d831c04e792af3d,
    __propKey: $3e42d24666ecb6eb$export$6a2a36740a146cb8,
    __setFunctionName: $3e42d24666ecb6eb$export$d1a06452d3489bc7,
    __metadata: $3e42d24666ecb6eb$export$f1db080c865becb9,
    __awaiter: $3e42d24666ecb6eb$export$1050f835b63b671e,
    __generator: $3e42d24666ecb6eb$export$67ebef60e6f28a6,
    __createBinding: $3e42d24666ecb6eb$export$45d3717a4c69092e,
    __exportStar: $3e42d24666ecb6eb$export$f33643c0debef087,
    __values: $3e42d24666ecb6eb$export$19a8beecd37a4c45,
    __read: $3e42d24666ecb6eb$export$8d051b38c9118094,
    __spread: $3e42d24666ecb6eb$export$afc72e2116322959,
    __spreadArrays: $3e42d24666ecb6eb$export$6388937ca91ccae8,
    __spreadArray: $3e42d24666ecb6eb$export$1216008129fb82ed,
    __await: $3e42d24666ecb6eb$export$10c90e4f7922046c,
    __asyncGenerator: $3e42d24666ecb6eb$export$e427f37a30a4de9b,
    __asyncDelegator: $3e42d24666ecb6eb$export$bbd80228419bb833,
    __asyncValues: $3e42d24666ecb6eb$export$e3b29a3d6162315f,
    __makeTemplateObject: $3e42d24666ecb6eb$export$4fb47efe1390b86f,
    __importStar: $3e42d24666ecb6eb$export$c21735bcef00d192,
    __importDefault: $3e42d24666ecb6eb$export$da59b14a69baef04,
    __classPrivateFieldGet: $3e42d24666ecb6eb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3e42d24666ecb6eb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3e42d24666ecb6eb$export$81fdc39f203e4e04,
    __addDisposableResource: $3e42d24666ecb6eb$export$88ac25d8e944e405,
    __disposeResources: $3e42d24666ecb6eb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $3e42d24666ecb6eb$export$889dfb5d17574b0b
};

});

parcelRegister("REREP", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $0a14a62dd10d3a08$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $0a14a62dd10d3a08$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $0a14a62dd10d3a08$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $0a14a62dd10d3a08$export$a07cdf6544bbd7c);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("9mEYb");
var $dFcfr = parcelRequire("dFcfr");
var $hfQtX = parcelRequire("hfQtX");
var $aK5EH = parcelRequire("aK5EH");
var $8lRV2 = parcelRequire("8lRV2");
var $5sztu = parcelRequire("5sztu");

var $e4o5C = parcelRequire("e4o5C");

var $freWv = parcelRequire("freWv");

var $6q5Ba = parcelRequire("6q5Ba");
var $0a14a62dd10d3a08$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $0a14a62dd10d3a08$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $0a14a62dd10d3a08$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $freWv.Scope)();
        if (_version === void 0) _version = $0a14a62dd10d3a08$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $freWv.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $5sztu.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $5sztu.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $5sztu.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $0a14a62dd10d3a08$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $hfQtX.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $5lpFe.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $dFcfr.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $0a14a62dd10d3a08$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $0a14a62dd10d3a08$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $e4o5C.IS_DEBUG_BUILD) && (0, $dFcfr.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $aK5EH.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $6q5Ba.Session)((0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $5lpFe.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $0a14a62dd10d3a08$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $e4o5C.IS_DEBUG_BUILD) && (0, $dFcfr.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $0a14a62dd10d3a08$export$19eade501500c6c1() {
    var carrier = (0, $aK5EH.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $0a14a62dd10d3a08$export$4188a14ad302d1bc(hub) {
    var registry = $0a14a62dd10d3a08$export$19eade501500c6c1();
    var oldHub = $0a14a62dd10d3a08$export$bfa8a924a84a76b7(registry);
    $0a14a62dd10d3a08$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $0a14a62dd10d3a08$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $0a14a62dd10d3a08$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$0a14a62dd10d3a08$var$hasHubOnCarrier(registry) || $0a14a62dd10d3a08$export$bfa8a924a84a76b7(registry).isOlderThan($0a14a62dd10d3a08$export$24a86ef7798177e4)) $0a14a62dd10d3a08$export$849f05434e95d2f2(registry, new $0a14a62dd10d3a08$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $8lRV2.isNodeEnv)()) return $0a14a62dd10d3a08$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $0a14a62dd10d3a08$export$bfa8a924a84a76b7(registry);
}
function $0a14a62dd10d3a08$export$1c4d656130202699() {
    (0, $e4o5C.IS_DEBUG_BUILD) && (0, $dFcfr.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $0a14a62dd10d3a08$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $0a14a62dd10d3a08$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $0a14a62dd10d3a08$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $0a14a62dd10d3a08$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$0a14a62dd10d3a08$var$hasHubOnCarrier(activeDomain) || $0a14a62dd10d3a08$export$bfa8a924a84a76b7(activeDomain).isOlderThan($0a14a62dd10d3a08$export$24a86ef7798177e4)) {
            var registryHubTopStack = $0a14a62dd10d3a08$export$bfa8a924a84a76b7(registry).getStackTop();
            $0a14a62dd10d3a08$export$849f05434e95d2f2(activeDomain, new $0a14a62dd10d3a08$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $freWv.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $0a14a62dd10d3a08$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $0a14a62dd10d3a08$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $0a14a62dd10d3a08$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $0a14a62dd10d3a08$export$bfa8a924a84a76b7(carrier) {
    return (0, $aK5EH.getGlobalSingleton)('hub', function() {
        return new $0a14a62dd10d3a08$export$8c41bb232f1008b1();
    }, carrier);
}
function $0a14a62dd10d3a08$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("9mEYb", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("aK5EH")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("aK5EH")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("lFZ3G")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("lFZ3G")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("dFcfr")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("dFcfr")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("5sztu")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("hc1nC")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("cUNox")).SyncPromise);





parcelRequire("aK5EH");

parcelRequire("lFZ3G");
parcelRequire("dFcfr");

parcelRequire("5sztu");

var $8lRV2 = parcelRequire("8lRV2");

parcelRequire("hc1nC");







parcelRequire("cUNox");

var $hfQtX = parcelRequire("hfQtX");





$parcel$exportWildcard(module.exports, $8lRV2);
$parcel$exportWildcard(module.exports, $hfQtX);

});
parcelRegister("aK5EH", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $7d22964be1f1c244$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $7d22964be1f1c244$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $8lRV2 = parcelRequire("8lRV2");
var $7d22964be1f1c244$var$fallbackGlobalObject = {};
function $7d22964be1f1c244$export$256479dc0cea61c4() {
    return (0, $8lRV2.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $7d22964be1f1c244$var$fallbackGlobalObject;
}
function $7d22964be1f1c244$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $7d22964be1f1c244$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("8lRV2", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $bvekZ = parcelRequire("bvekZ");

var $3jCFs = parcelRequire("3jCFs");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $bvekZ.isBrowserBundle)() && Object.prototype.toString.call(typeof $3jCFs !== 'undefined' ? $3jCFs : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("bvekZ", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $85fdb6182e396538$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $85fdb6182e396538$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("lFZ3G", function(module, exports) {
$parcel$export(module.exports, "isError", () => $fc7cca3917efcef3$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $fc7cca3917efcef3$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $fc7cca3917efcef3$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $fc7cca3917efcef3$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $fc7cca3917efcef3$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $fc7cca3917efcef3$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $fc7cca3917efcef3$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $fc7cca3917efcef3$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $fc7cca3917efcef3$export$f5b060c2914b97c8);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $fc7cca3917efcef3$var$objectToString = Object.prototype.toString;
function $fc7cca3917efcef3$export$e6127cc7fe7395c3(wat) {
    switch($fc7cca3917efcef3$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $fc7cca3917efcef3$export$49034edbe6b62415(wat, Error);
    }
}
function $fc7cca3917efcef3$var$isBuiltin(wat, ty) {
    return $fc7cca3917efcef3$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $fc7cca3917efcef3$export$9f9636d330b71954(wat) {
    return $fc7cca3917efcef3$var$isBuiltin(wat, 'ErrorEvent');
}
function $fc7cca3917efcef3$export$ef9e2056653f0c8e(wat) {
    return $fc7cca3917efcef3$var$isBuiltin(wat, 'DOMError');
}
function $fc7cca3917efcef3$export$12e869b2a583f783(wat) {
    return $fc7cca3917efcef3$var$isBuiltin(wat, 'DOMException');
}
function $fc7cca3917efcef3$export$844ec244b1367d54(wat) {
    return $fc7cca3917efcef3$var$isBuiltin(wat, 'String');
}
function $fc7cca3917efcef3$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $fc7cca3917efcef3$export$53b83ca8eaab0383(wat) {
    return $fc7cca3917efcef3$var$isBuiltin(wat, 'Object');
}
function $fc7cca3917efcef3$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $fc7cca3917efcef3$export$49034edbe6b62415(wat, Event);
}
function $fc7cca3917efcef3$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $fc7cca3917efcef3$export$49034edbe6b62415(wat, Element);
}
function $fc7cca3917efcef3$export$49841c62b9eff15(wat) {
    return $fc7cca3917efcef3$var$isBuiltin(wat, 'RegExp');
}
function $fc7cca3917efcef3$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $fc7cca3917efcef3$export$bc2894c7158efbac(wat) {
    return $fc7cca3917efcef3$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $fc7cca3917efcef3$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $fc7cca3917efcef3$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("dFcfr", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", () => $9f289aeb1e45b1fd$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $9f289aeb1e45b1fd$export$af88d00dbe7f521);

var $5lpFe = parcelRequire("5lpFe");

var $9jmj1 = parcelRequire("9jmj1");

var $aK5EH = parcelRequire("aK5EH");
// TODO: Implement different loggers for different environments
var $9f289aeb1e45b1fd$var$global = (0, $aK5EH.getGlobalObject)();
/** Prefix for logging strings */ var $9f289aeb1e45b1fd$var$PREFIX = 'Sentry Logger ';
var $9f289aeb1e45b1fd$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $9f289aeb1e45b1fd$export$cda52e2a8927a2ca(callback) {
    var global = (0, $aK5EH.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $9f289aeb1e45b1fd$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $9f289aeb1e45b1fd$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $9jmj1.IS_DEBUG_BUILD) $9f289aeb1e45b1fd$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $9f289aeb1e45b1fd$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $9f289aeb1e45b1fd$var$global.console)[name].apply(_a, (0, $5lpFe.__spread)([
                    $9f289aeb1e45b1fd$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $9f289aeb1e45b1fd$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $9f289aeb1e45b1fd$export$af88d00dbe7f521;
if (0, $9jmj1.IS_DEBUG_BUILD) $9f289aeb1e45b1fd$export$af88d00dbe7f521 = (0, $aK5EH.getGlobalSingleton)('logger', $9f289aeb1e45b1fd$var$makeLogger);
else $9f289aeb1e45b1fd$export$af88d00dbe7f521 = $9f289aeb1e45b1fd$var$makeLogger();

});
parcelRegister("9jmj1", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $6c7730e36568eb57$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $6c7730e36568eb57$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("5sztu", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $3f9b15cc8ec8ca76$export$19f53698e68b2496);

var $5lpFe = parcelRequire("5lpFe");

var $aK5EH = parcelRequire("aK5EH");

var $hc1nC = parcelRequire("hc1nC");

var $fFjxg = parcelRequire("fFjxg");
function $3f9b15cc8ec8ca76$export$19f53698e68b2496() {
    var global = (0, $aK5EH.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $3f9b15cc8ec8ca76$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $3f9b15cc8ec8ca76$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $3f9b15cc8ec8ca76$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $3f9b15cc8ec8ca76$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $3f9b15cc8ec8ca76$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $3f9b15cc8ec8ca76$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $3f9b15cc8ec8ca76$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $3f9b15cc8ec8ca76$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $3f9b15cc8ec8ca76$export$d364f2020ab30578(input) {
    var match = input.match($3f9b15cc8ec8ca76$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $3f9b15cc8ec8ca76$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $fFjxg.snipLine)(line, 0);
    });
    frame.context_line = (0, $fFjxg.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $fFjxg.snipLine)(line, 0);
    });
}
function $3f9b15cc8ec8ca76$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $3f9b15cc8ec8ca76$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $hc1nC.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("hc1nC", function(module, exports) {
$parcel$export(module.exports, "addNonEnumerableProperty", () => $c844a0b45a40c49e$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $c844a0b45a40c49e$export$d25f2688db1bb433);

var $5lpFe = parcelRequire("5lpFe");

var $dMYIv = parcelRequire("dMYIv");

var $lFZ3G = parcelRequire("lFZ3G");

var $fFjxg = parcelRequire("fFjxg");
function $c844a0b45a40c49e$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $c844a0b45a40c49e$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $c844a0b45a40c49e$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $c844a0b45a40c49e$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $c844a0b45a40c49e$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $c844a0b45a40c49e$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $c844a0b45a40c49e$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $c844a0b45a40c49e$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $lFZ3G.isError)(value)) newObj = (0, $5lpFe.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $c844a0b45a40c49e$var$getOwnProperties(value));
    else if ((0, $lFZ3G.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $5lpFe.__assign)({
            type: event_1.type,
            target: $c844a0b45a40c49e$var$serializeEventTarget(event_1.target),
            currentTarget: $c844a0b45a40c49e$var$serializeEventTarget(event_1.currentTarget)
        }, $c844a0b45a40c49e$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $lFZ3G.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $c844a0b45a40c49e$var$serializeEventTarget(target) {
    try {
        return (0, $lFZ3G.isElement)(target) ? (0, $dMYIv.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $c844a0b45a40c49e$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $c844a0b45a40c49e$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($c844a0b45a40c49e$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $fFjxg.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $fFjxg.truncate)(serialized, maxLength);
    }
    return '';
}
function $c844a0b45a40c49e$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $lFZ3G.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $5lpFe.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $c844a0b45a40c49e$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($c844a0b45a40c49e$export$d25f2688db1bb433);
    return val;
}
function $c844a0b45a40c49e$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $lFZ3G.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("dMYIv", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $a09edb2b3d188ec0$export$5647df6b7814ac86);

var $aK5EH = parcelRequire("aK5EH");

var $lFZ3G = parcelRequire("lFZ3G");
function $a09edb2b3d188ec0$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a09edb2b3d188ec0$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a09edb2b3d188ec0$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $lFZ3G.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $a09edb2b3d188ec0$export$1cfafeee2987818b() {
    var global = (0, $aK5EH.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("fFjxg", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $b679d6b4be1e50ec$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $b679d6b4be1e50ec$export$4215662d762d6f9d);

var $lFZ3G = parcelRequire("lFZ3G");
function $b679d6b4be1e50ec$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $b679d6b4be1e50ec$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $b679d6b4be1e50ec$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $b679d6b4be1e50ec$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $lFZ3G.isString)(value)) return false;
    if ((0, $lFZ3G.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $b679d6b4be1e50ec$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("cUNox", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $967107c3f5a4d5c1$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $lFZ3G = parcelRequire("lFZ3G");
function $967107c3f5a4d5c1$export$1fda8aa4d135f8aa(value) {
    return new $967107c3f5a4d5c1$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $967107c3f5a4d5c1$export$78e43115b553f358(reason) {
    return new $967107c3f5a4d5c1$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $967107c3f5a4d5c1$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $lFZ3G.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("hfQtX", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $aK5EH = parcelRequire("aK5EH");

var $8lRV2 = parcelRequire("8lRV2");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $aK5EH.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $8lRV2.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $8lRV2.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $aK5EH.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("e4o5C", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a3e420191ca9e743$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a3e420191ca9e743$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("freWv", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $b3d4f7f3380ae494$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $b3d4f7f3380ae494$export$8e4e25f54d456511);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("9mEYb");
var $hfQtX = parcelRequire("hfQtX");
var $aK5EH = parcelRequire("aK5EH");
var $lFZ3G = parcelRequire("lFZ3G");
var $cUNox = parcelRequire("cUNox");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $b3d4f7f3380ae494$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $b3d4f7f3380ae494$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $5lpFe.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $5lpFe.__assign)({}, scope._tags);
            newScope._extra = (0, $5lpFe.__assign)({}, scope._extra);
            newScope._contexts = (0, $5lpFe.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $5lpFe.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $lFZ3G.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $b3d4f7f3380ae494$var$MAX_BREADCRUMBS) : $b3d4f7f3380ae494$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $5lpFe.__assign)({
            timestamp: (0, $hfQtX.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $5lpFe.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $5lpFe.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $5lpFe.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $5lpFe.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $5lpFe.__spread)($b3d4f7f3380ae494$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $cUNox.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $5lpFe.__assign)({}, event), hint);
                if ((0, $lFZ3G.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $b3d4f7f3380ae494$var$getGlobalEventProcessors() {
    return (0, $aK5EH.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $b3d4f7f3380ae494$export$8e4e25f54d456511(callback) {
    $b3d4f7f3380ae494$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("6q5Ba", function(module, exports) {
$parcel$export(module.exports, "Session", () => $4ac983805ae5ff1c$export$1fb4852a55678982);
parcelRequire("9mEYb");
var $hc1nC = parcelRequire("hc1nC");
var $hfQtX = parcelRequire("hfQtX");
var $5sztu = parcelRequire("5sztu");
/**
 * @inheritdoc
 */ var $4ac983805ae5ff1c$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $5sztu.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $hfQtX.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $hfQtX.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $5sztu.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $hc1nC.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("eigSc", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5lpFe = parcelRequire("5lpFe");

var $8lCud = parcelRequire("8lCud");
parcelRequire("5Ve5I");
var $kcrfC = parcelRequire("kcrfC");
var $ja3HM = parcelRequire("ja3HM");
var $bZphu = parcelRequire("bZphu");
var $eA0Kr = parcelRequire("eA0Kr");
var $a5ROm = parcelRequire("a5ROm");
var $1GwN2 = parcelRequire("1GwN2");

var $8mZWO = parcelRequire("8mZWO");
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */ function $a67fd5cd801954ca$var$exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $a67fd5cd801954ca$var$parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: $a67fd5cd801954ca$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
module.exports.exceptionFromError = $a67fd5cd801954ca$var$exceptionFromError;
/**
 * @hidden
 */ function $a67fd5cd801954ca$var$eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: $eA0Kr.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + $bZphu.extractExceptionKeysForMessage(exception)
                }
            ]
        },
        extra: {
            __serialized__: $a5ROm.normalizeToSize(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $a67fd5cd801954ca$var$parseStackFrames(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
module.exports.eventFromPlainObject = $a67fd5cd801954ca$var$eventFromPlainObject;
/**
 * @hidden
 */ function $a67fd5cd801954ca$var$eventFromError(ex) {
    return {
        exception: {
            values: [
                $a67fd5cd801954ca$var$exceptionFromError(ex)
            ]
        }
    };
}
module.exports.eventFromError = $a67fd5cd801954ca$var$eventFromError;
/** Parses stack frames from an error */ function $a67fd5cd801954ca$var$parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $a67fd5cd801954ca$var$getPopSize(ex);
    try {
        return $ja3HM.createStackParser($8mZWO.opera10StackParser, $8mZWO.opera11StackParser, $8mZWO.chromeStackParser, $8mZWO.winjsStackParser, $8mZWO.geckoStackParser)(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
module.exports.parseStackFrames = $a67fd5cd801954ca$var$parseStackFrames;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $a67fd5cd801954ca$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a67fd5cd801954ca$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($a67fd5cd801954ca$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a67fd5cd801954ca$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a67fd5cd801954ca$var$eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $a67fd5cd801954ca$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    $kcrfC.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = $8lCud.Severity.Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $1GwN2.resolvedSyncPromise(event);
}
module.exports.eventFromException = $a67fd5cd801954ca$var$eventFromException;
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a67fd5cd801954ca$var$eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) level = $8lCud.Severity.Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $a67fd5cd801954ca$var$eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $1GwN2.resolvedSyncPromise(event);
}
module.exports.eventFromMessage = $a67fd5cd801954ca$var$eventFromMessage;
/**
 * @hidden
 */ function $a67fd5cd801954ca$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ($eA0Kr.isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $a67fd5cd801954ca$var$eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ($eA0Kr.isDOMError(exception) || $eA0Kr.isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $a67fd5cd801954ca$var$eventFromError(exception);
        else {
            var name_1 = domException.name || ($eA0Kr.isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $a67fd5cd801954ca$var$eventFromString(message, syntheticException, attachStacktrace);
            $kcrfC.addExceptionTypeValue(event, message);
        }
        if ('code' in domException) event.tags = $5lpFe.__assign($5lpFe.__assign({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ($eA0Kr.isError(exception)) // we have a real Error object, do nothing
    return $a67fd5cd801954ca$var$eventFromError(exception);
    if ($eA0Kr.isPlainObject(exception) || $eA0Kr.isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $a67fd5cd801954ca$var$eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        $kcrfC.addExceptionMechanism(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a67fd5cd801954ca$var$eventFromString(exception, syntheticException, attachStacktrace);
    $kcrfC.addExceptionTypeValue(event, "" + exception, undefined);
    $kcrfC.addExceptionMechanism(event, {
        synthetic: true
    });
    return event;
}
module.exports.eventFromUnknownInput = $a67fd5cd801954ca$var$eventFromUnknownInput;
/**
 * @hidden
 */ function $a67fd5cd801954ca$var$eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $a67fd5cd801954ca$var$parseStackFrames(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}
module.exports.eventFromString = $a67fd5cd801954ca$var$eventFromString;

});
parcelRegister("8lCud", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $613e23776a2a2b62$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $613e23776a2a2b62$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($613e23776a2a2b62$export$918a9776c0a3cf27 || ($613e23776a2a2b62$export$918a9776c0a3cf27 = {}));
var $613e23776a2a2b62$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("5Ve5I", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("aIZwz")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("3vwCT")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("3vwCT")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("9R2Wx")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("9R2Wx")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("iqzHc")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("2mAO5")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("4ppVB")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("eA0Kr")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("eA0Kr")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("eA0Kr")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("eA0Kr")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("eA0Kr")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("eA0Kr")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("eA0Kr")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("eA0Kr")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("eA0Kr")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("eA0Kr")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("6Xtyr")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("kcrfC")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("kcrfC")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("kcrfC")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("kcrfC")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("kcrfC")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("kcrfC")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("a5ROm")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("a5ROm")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("bZphu")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("bZphu")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("bZphu")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("bZphu")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("bZphu")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("bZphu")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("XMAWz")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("ccrXg")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("ja3HM")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("ja3HM")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("eqURj")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("bQUiH")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("bQUiH")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("bQUiH")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("iSeUT")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("iSeUT")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("iSeUT")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("1GwN2")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("1GwN2")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("1GwN2")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("39WwY")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("39WwY")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("39WwY")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("kZZlM")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("2z5O0")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("2z5O0")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("2z5O0")).updateRateLimits);
parcelRequire("aIZwz");
parcelRequire("3vwCT");
parcelRequire("9R2Wx");

parcelRequire("iqzHc");
parcelRequire("2mAO5");
parcelRequire("4ppVB");
parcelRequire("eA0Kr");
parcelRequire("6Xtyr");

parcelRequire("kcrfC");

var $fMw01 = parcelRequire("fMw01");
parcelRequire("a5ROm");
parcelRequire("bZphu");

parcelRequire("XMAWz");
parcelRequire("ccrXg");
parcelRequire("ja3HM");
parcelRequire("eqURj");
parcelRequire("bQUiH");
parcelRequire("iSeUT");
parcelRequire("1GwN2");

var $7X7rA = parcelRequire("7X7rA");


parcelRequire("39WwY");
parcelRequire("kZZlM");
parcelRequire("2z5O0");
$parcel$exportWildcard(module.exports, $fMw01);
$parcel$exportWildcard(module.exports, $7X7rA);

});
parcelRegister("aIZwz", function(module, exports) {
$parcel$export(module.exports, "forget", () => $7cedbce822d74b8c$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7cedbce822d74b8c$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("3vwCT", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $28dd934150c788d9$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $28dd934150c788d9$export$1cfafeee2987818b);

var $2mAO5 = parcelRequire("2mAO5");

var $eA0Kr = parcelRequire("eA0Kr");
function $28dd934150c788d9$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $28dd934150c788d9$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $28dd934150c788d9$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $eA0Kr.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $28dd934150c788d9$export$1cfafeee2987818b() {
    var global = (0, $2mAO5.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("2mAO5", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $1b8a2fea5caff3f3$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $1b8a2fea5caff3f3$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $fMw01 = parcelRequire("fMw01");
var $1b8a2fea5caff3f3$var$fallbackGlobalObject = {};
function $1b8a2fea5caff3f3$export$256479dc0cea61c4() {
    return (0, $fMw01.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $1b8a2fea5caff3f3$var$fallbackGlobalObject;
}
function $1b8a2fea5caff3f3$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $1b8a2fea5caff3f3$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("fMw01", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $hogtQ = parcelRequire("hogtQ");

var $3jCFs = parcelRequire("3jCFs");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $hogtQ.isBrowserBundle)() && Object.prototype.toString.call(typeof $3jCFs !== 'undefined' ? $3jCFs : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("hogtQ", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $ca91763cdb06b796$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $ca91763cdb06b796$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("eA0Kr", function(module, exports) {
$parcel$export(module.exports, "isError", () => $a9d50203a6315a00$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $a9d50203a6315a00$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $a9d50203a6315a00$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $a9d50203a6315a00$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $a9d50203a6315a00$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $a9d50203a6315a00$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $a9d50203a6315a00$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $a9d50203a6315a00$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $a9d50203a6315a00$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $a9d50203a6315a00$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $a9d50203a6315a00$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $a9d50203a6315a00$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $a9d50203a6315a00$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $a9d50203a6315a00$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $a9d50203a6315a00$var$objectToString = Object.prototype.toString;
function $a9d50203a6315a00$export$e6127cc7fe7395c3(wat) {
    switch($a9d50203a6315a00$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $a9d50203a6315a00$export$49034edbe6b62415(wat, Error);
    }
}
function $a9d50203a6315a00$var$isBuiltin(wat, ty) {
    return $a9d50203a6315a00$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $a9d50203a6315a00$export$9f9636d330b71954(wat) {
    return $a9d50203a6315a00$var$isBuiltin(wat, 'ErrorEvent');
}
function $a9d50203a6315a00$export$ef9e2056653f0c8e(wat) {
    return $a9d50203a6315a00$var$isBuiltin(wat, 'DOMError');
}
function $a9d50203a6315a00$export$12e869b2a583f783(wat) {
    return $a9d50203a6315a00$var$isBuiltin(wat, 'DOMException');
}
function $a9d50203a6315a00$export$844ec244b1367d54(wat) {
    return $a9d50203a6315a00$var$isBuiltin(wat, 'String');
}
function $a9d50203a6315a00$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $a9d50203a6315a00$export$53b83ca8eaab0383(wat) {
    return $a9d50203a6315a00$var$isBuiltin(wat, 'Object');
}
function $a9d50203a6315a00$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $a9d50203a6315a00$export$49034edbe6b62415(wat, Event);
}
function $a9d50203a6315a00$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $a9d50203a6315a00$export$49034edbe6b62415(wat, Element);
}
function $a9d50203a6315a00$export$49841c62b9eff15(wat) {
    return $a9d50203a6315a00$var$isBuiltin(wat, 'RegExp');
}
function $a9d50203a6315a00$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $a9d50203a6315a00$export$bc2894c7158efbac(wat) {
    return $a9d50203a6315a00$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $a9d50203a6315a00$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $a9d50203a6315a00$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("9R2Wx", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $72cb58ba7056241a$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $72cb58ba7056241a$export$128827c3562ec0cb);

var $5lpFe = parcelRequire("5lpFe");

var $iqzHc = parcelRequire("iqzHc");

var $8tFEr = parcelRequire("8tFEr");
/** Regular expression used to parse a Dsn. */ var $72cb58ba7056241a$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $72cb58ba7056241a$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $72cb58ba7056241a$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $72cb58ba7056241a$var$dsnFromString(str) {
    var match = $72cb58ba7056241a$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $iqzHc.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $5lpFe.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $72cb58ba7056241a$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $72cb58ba7056241a$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $72cb58ba7056241a$var$validateDsn(dsn) {
    if (!(0, $8tFEr.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $iqzHc.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $iqzHc.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$72cb58ba7056241a$var$isValidProtocol(protocol)) throw new (0, $iqzHc.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $iqzHc.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $72cb58ba7056241a$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $72cb58ba7056241a$var$dsnFromString(from) : $72cb58ba7056241a$var$dsnFromComponents(from);
    $72cb58ba7056241a$var$validateDsn(components);
    return components;
}

});
parcelRegister("iqzHc", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $d6a65827e99e4e8b$export$5949942ba2a7c0e2);

var $5lpFe = parcelRequire("5lpFe");

var $3Sajg = parcelRequire("3Sajg");
/** An error emitted by Sentry SDKs and related utilities. */ var $d6a65827e99e4e8b$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $3Sajg.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("3Sajg", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $2d1e698cbcd0b86c$export$1cb0d91350beb6cc);
var $2d1e698cbcd0b86c$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $2d1e698cbcd0b86c$var$setProtoOf : $2d1e698cbcd0b86c$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $2d1e698cbcd0b86c$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $2d1e698cbcd0b86c$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("8tFEr", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $62c1573b70cdbff0$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $62c1573b70cdbff0$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("4ppVB", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $335d9c059902f9de$export$285b9172a3741fb7);

var $5lpFe = parcelRequire("5lpFe");

var $8tFEr = parcelRequire("8tFEr");

var $2mAO5 = parcelRequire("2mAO5");

var $eA0Kr = parcelRequire("eA0Kr");

var $6Xtyr = parcelRequire("6Xtyr");

var $bZphu = parcelRequire("bZphu");

var $ja3HM = parcelRequire("ja3HM");

var $iSeUT = parcelRequire("iSeUT");
var $335d9c059902f9de$var$global = (0, $2mAO5.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $335d9c059902f9de$var$handlers = {};
var $335d9c059902f9de$var$instrumented = {};
/** Instruments given API */ function $335d9c059902f9de$var$instrument(type) {
    if ($335d9c059902f9de$var$instrumented[type]) return;
    $335d9c059902f9de$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $335d9c059902f9de$var$instrumentConsole();
            break;
        case 'dom':
            $335d9c059902f9de$var$instrumentDOM();
            break;
        case 'xhr':
            $335d9c059902f9de$var$instrumentXHR();
            break;
        case 'fetch':
            $335d9c059902f9de$var$instrumentFetch();
            break;
        case 'history':
            $335d9c059902f9de$var$instrumentHistory();
            break;
        case 'error':
            $335d9c059902f9de$var$instrumentError();
            break;
        case 'unhandledrejection':
            $335d9c059902f9de$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $8tFEr.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $335d9c059902f9de$export$285b9172a3741fb7(type, callback) {
    $335d9c059902f9de$var$handlers[type] = $335d9c059902f9de$var$handlers[type] || [];
    $335d9c059902f9de$var$handlers[type].push(callback);
    $335d9c059902f9de$var$instrument(type);
}
/** JSDoc */ function $335d9c059902f9de$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$335d9c059902f9de$var$handlers[type]) return;
    try {
        for(var _b = (0, $5lpFe.__values)($335d9c059902f9de$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $8tFEr.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $ja3HM.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $335d9c059902f9de$var$instrumentConsole() {
    if (!('console' in $335d9c059902f9de$var$global)) return;
    (0, $6Xtyr.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $335d9c059902f9de$var$global.console)) return;
        (0, $bZphu.fill)($335d9c059902f9de$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $335d9c059902f9de$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($335d9c059902f9de$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $335d9c059902f9de$var$instrumentFetch() {
    if (!(0, $iSeUT.supportsNativeFetch)()) return;
    (0, $bZphu.fill)($335d9c059902f9de$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $335d9c059902f9de$var$getFetchMethod(args),
                    url: $335d9c059902f9de$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $335d9c059902f9de$var$triggerHandlers('fetch', (0, $5lpFe.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($335d9c059902f9de$var$global, args).then(function(response) {
                $335d9c059902f9de$var$triggerHandlers('fetch', (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $335d9c059902f9de$var$triggerHandlers('fetch', (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $335d9c059902f9de$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $335d9c059902f9de$var$global && (0, $eA0Kr.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $335d9c059902f9de$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $335d9c059902f9de$var$global && (0, $eA0Kr.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $335d9c059902f9de$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $335d9c059902f9de$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $bZphu.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $eA0Kr.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $eA0Kr.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $335d9c059902f9de$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $bZphu.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $bZphu.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $335d9c059902f9de$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $335d9c059902f9de$var$lastHref;
/** JSDoc */ function $335d9c059902f9de$var$instrumentHistory() {
    if (!(0, $iSeUT.supportsHistory)()) return;
    var oldOnPopState = $335d9c059902f9de$var$global.onpopstate;
    $335d9c059902f9de$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $335d9c059902f9de$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $335d9c059902f9de$var$lastHref;
        $335d9c059902f9de$var$lastHref = to;
        $335d9c059902f9de$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $335d9c059902f9de$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $335d9c059902f9de$var$lastHref = to;
                $335d9c059902f9de$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $bZphu.fill)($335d9c059902f9de$var$global.history, 'pushState', historyReplacementFunction);
    (0, $bZphu.fill)($335d9c059902f9de$var$global.history, 'replaceState', historyReplacementFunction);
}
var $335d9c059902f9de$var$debounceDuration = 1000;
var $335d9c059902f9de$var$debounceTimerID;
var $335d9c059902f9de$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $335d9c059902f9de$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $335d9c059902f9de$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $335d9c059902f9de$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $335d9c059902f9de$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($335d9c059902f9de$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($335d9c059902f9de$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $335d9c059902f9de$var$lastCapturedEvent = event;
        } else if ($335d9c059902f9de$var$shouldShortcircuitPreviousDebounce($335d9c059902f9de$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $335d9c059902f9de$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($335d9c059902f9de$var$debounceTimerID);
        $335d9c059902f9de$var$debounceTimerID = $335d9c059902f9de$var$global.setTimeout(function() {
            $335d9c059902f9de$var$debounceTimerID = undefined;
        }, $335d9c059902f9de$var$debounceDuration);
    };
}
/** JSDoc */ function $335d9c059902f9de$var$instrumentDOM() {
    if (!('document' in $335d9c059902f9de$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $335d9c059902f9de$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $335d9c059902f9de$var$makeDOMEventHandler(triggerDOMHandler, true);
    $335d9c059902f9de$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $335d9c059902f9de$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $335d9c059902f9de$var$global[target] && $335d9c059902f9de$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $bZphu.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $335d9c059902f9de$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $bZphu.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $335d9c059902f9de$var$_oldOnErrorHandler = null;
/** JSDoc */ function $335d9c059902f9de$var$instrumentError() {
    $335d9c059902f9de$var$_oldOnErrorHandler = $335d9c059902f9de$var$global.onerror;
    $335d9c059902f9de$var$global.onerror = function(msg, url, line, column, error) {
        $335d9c059902f9de$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($335d9c059902f9de$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $335d9c059902f9de$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $335d9c059902f9de$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $335d9c059902f9de$var$instrumentUnhandledRejection() {
    $335d9c059902f9de$var$_oldOnUnhandledRejectionHandler = $335d9c059902f9de$var$global.onunhandledrejection;
    $335d9c059902f9de$var$global.onunhandledrejection = function(e) {
        $335d9c059902f9de$var$triggerHandlers('unhandledrejection', e);
        if ($335d9c059902f9de$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $335d9c059902f9de$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("6Xtyr", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $510f2dae62c16073$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $510f2dae62c16073$export$af88d00dbe7f521);

var $5lpFe = parcelRequire("5lpFe");

var $8tFEr = parcelRequire("8tFEr");

var $2mAO5 = parcelRequire("2mAO5");
// TODO: Implement different loggers for different environments
var $510f2dae62c16073$var$global = (0, $2mAO5.getGlobalObject)();
/** Prefix for logging strings */ var $510f2dae62c16073$var$PREFIX = 'Sentry Logger ';
var $510f2dae62c16073$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $510f2dae62c16073$export$cda52e2a8927a2ca(callback) {
    var global = (0, $2mAO5.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $510f2dae62c16073$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $510f2dae62c16073$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $8tFEr.IS_DEBUG_BUILD) $510f2dae62c16073$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $510f2dae62c16073$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $510f2dae62c16073$var$global.console)[name].apply(_a, (0, $5lpFe.__spread)([
                    $510f2dae62c16073$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $510f2dae62c16073$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $510f2dae62c16073$export$af88d00dbe7f521;
if (0, $8tFEr.IS_DEBUG_BUILD) $510f2dae62c16073$export$af88d00dbe7f521 = (0, $2mAO5.getGlobalSingleton)('logger', $510f2dae62c16073$var$makeLogger);
else $510f2dae62c16073$export$af88d00dbe7f521 = $510f2dae62c16073$var$makeLogger();

});

parcelRegister("bZphu", function(module, exports) {
$parcel$export(module.exports, "fill", () => $8ba90087f8cf44a9$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $8ba90087f8cf44a9$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $8ba90087f8cf44a9$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $8ba90087f8cf44a9$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $8ba90087f8cf44a9$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $8ba90087f8cf44a9$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $8ba90087f8cf44a9$export$b0244d5063c0b61b);

var $5lpFe = parcelRequire("5lpFe");

var $3vwCT = parcelRequire("3vwCT");

var $eA0Kr = parcelRequire("eA0Kr");

var $bQUiH = parcelRequire("bQUiH");
function $8ba90087f8cf44a9$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $8ba90087f8cf44a9$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $8ba90087f8cf44a9$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $8ba90087f8cf44a9$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $8ba90087f8cf44a9$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $8ba90087f8cf44a9$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $8ba90087f8cf44a9$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $8ba90087f8cf44a9$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $eA0Kr.isError)(value)) newObj = (0, $5lpFe.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $8ba90087f8cf44a9$var$getOwnProperties(value));
    else if ((0, $eA0Kr.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $5lpFe.__assign)({
            type: event_1.type,
            target: $8ba90087f8cf44a9$var$serializeEventTarget(event_1.target),
            currentTarget: $8ba90087f8cf44a9$var$serializeEventTarget(event_1.currentTarget)
        }, $8ba90087f8cf44a9$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $eA0Kr.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $8ba90087f8cf44a9$var$serializeEventTarget(target) {
    try {
        return (0, $eA0Kr.isElement)(target) ? (0, $3vwCT.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $8ba90087f8cf44a9$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $8ba90087f8cf44a9$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($8ba90087f8cf44a9$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $bQUiH.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $bQUiH.truncate)(serialized, maxLength);
    }
    return '';
}
function $8ba90087f8cf44a9$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $eA0Kr.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $5lpFe.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $8ba90087f8cf44a9$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($8ba90087f8cf44a9$export$d25f2688db1bb433);
    return val;
}
function $8ba90087f8cf44a9$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $eA0Kr.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("bQUiH", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $8a103930af21b108$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $8a103930af21b108$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $8a103930af21b108$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $8a103930af21b108$export$cdded5b28a5f8c6d);

var $eA0Kr = parcelRequire("eA0Kr");
function $8a103930af21b108$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $8a103930af21b108$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $8a103930af21b108$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $8a103930af21b108$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $eA0Kr.isString)(value)) return false;
    if ((0, $eA0Kr.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $8a103930af21b108$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("ja3HM", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $df31d33f60baed34$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $df31d33f60baed34$export$aad197c7121a6651);

var $5lpFe = parcelRequire("5lpFe");
var $df31d33f60baed34$var$STACKTRACE_LIMIT = 50;
function $df31d33f60baed34$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $5lpFe.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $5lpFe.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $df31d33f60baed34$export$c55c24c0eeba0205(frames);
    };
}
function $df31d33f60baed34$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $df31d33f60baed34$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $df31d33f60baed34$var$defaultFunctionName = '<anonymous>';
function $df31d33f60baed34$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $df31d33f60baed34$var$defaultFunctionName;
        return fn.name || $df31d33f60baed34$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $df31d33f60baed34$var$defaultFunctionName;
    }
}

});

parcelRegister("iSeUT", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $dbd8d742a7f3f975$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $dbd8d742a7f3f975$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $dbd8d742a7f3f975$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $dbd8d742a7f3f975$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $dbd8d742a7f3f975$export$67fc34576016d6ec);

var $8tFEr = parcelRequire("8tFEr");

var $2mAO5 = parcelRequire("2mAO5");

var $6Xtyr = parcelRequire("6Xtyr");
function $dbd8d742a7f3f975$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $dbd8d742a7f3f975$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $dbd8d742a7f3f975$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $dbd8d742a7f3f975$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $2mAO5.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $dbd8d742a7f3f975$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $dbd8d742a7f3f975$export$c82d238e23c40b21() {
    if (!$dbd8d742a7f3f975$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $2mAO5.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($dbd8d742a7f3f975$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $dbd8d742a7f3f975$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $8tFEr.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $dbd8d742a7f3f975$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $2mAO5.getGlobalObject)();
}
function $dbd8d742a7f3f975$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$dbd8d742a7f3f975$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $dbd8d742a7f3f975$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $2mAO5.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("kcrfC", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $eb4a111af472a3cb$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $eb4a111af472a3cb$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $eb4a111af472a3cb$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $eb4a111af472a3cb$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $eb4a111af472a3cb$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $eb4a111af472a3cb$export$6de4ffac6a2f1098);

var $5lpFe = parcelRequire("5lpFe");

var $2mAO5 = parcelRequire("2mAO5");

var $bZphu = parcelRequire("bZphu");

var $bQUiH = parcelRequire("bQUiH");
function $eb4a111af472a3cb$export$19f53698e68b2496() {
    var global = (0, $2mAO5.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $eb4a111af472a3cb$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $eb4a111af472a3cb$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $eb4a111af472a3cb$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $eb4a111af472a3cb$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $eb4a111af472a3cb$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $eb4a111af472a3cb$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $eb4a111af472a3cb$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $eb4a111af472a3cb$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $eb4a111af472a3cb$export$d364f2020ab30578(input) {
    var match = input.match($eb4a111af472a3cb$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $eb4a111af472a3cb$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $bQUiH.snipLine)(line, 0);
    });
    frame.context_line = (0, $bQUiH.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $bQUiH.snipLine)(line, 0);
    });
}
function $eb4a111af472a3cb$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $eb4a111af472a3cb$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $bZphu.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("a5ROm", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $75941cccc2c2125e$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $75941cccc2c2125e$export$23fbbb20bed71033);

var $5lpFe = parcelRequire("5lpFe");

var $eA0Kr = parcelRequire("eA0Kr");

var $2FTG1 = parcelRequire("2FTG1");

var $bZphu = parcelRequire("bZphu");

var $ja3HM = parcelRequire("ja3HM");
function $75941cccc2c2125e$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $75941cccc2c2125e$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $75941cccc2c2125e$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $75941cccc2c2125e$export$a3295358bff77e(object, depth);
    if ($75941cccc2c2125e$var$jsonSize(normalized) > maxSize) return $75941cccc2c2125e$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $75941cccc2c2125e$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $2FTG1.memoBuilder)();
    var _a = (0, $5lpFe.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $eA0Kr.isNaN)(value)) return value;
    var stringified = $75941cccc2c2125e$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $eA0Kr.isError)(value) || (0, $eA0Kr.isEvent)(value) ? (0, $bZphu.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $75941cccc2c2125e$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $75941cccc2c2125e$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $eA0Kr.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $ja3HM.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $75941cccc2c2125e$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $75941cccc2c2125e$var$jsonSize(value) {
    return $75941cccc2c2125e$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("2FTG1", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $1f2a995ee2ebfc19$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $1f2a995ee2ebfc19$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("XMAWz", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $0b3b34bb1ec96fb7$export$85a4f67f852183e6);

var $iqzHc = parcelRequire("iqzHc");

var $1GwN2 = parcelRequire("1GwN2");
function $0b3b34bb1ec96fb7$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $1GwN2.rejectedSyncPromise)(new (0, $iqzHc.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $1GwN2.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $1GwN2.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("1GwN2", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $13a3261b0c87d769$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $13a3261b0c87d769$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $13a3261b0c87d769$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eA0Kr = parcelRequire("eA0Kr");
function $13a3261b0c87d769$export$1fda8aa4d135f8aa(value) {
    return new $13a3261b0c87d769$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $13a3261b0c87d769$export$78e43115b553f358(reason) {
    return new $13a3261b0c87d769$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $13a3261b0c87d769$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $eA0Kr.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("ccrXg", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $8e1c4a41cee4d8ce$export$e01cef29b4327697);

var $8lCud = parcelRequire("8lCud");

var $6r0cU = parcelRequire("6r0cU");
function $8e1c4a41cee4d8ce$var$isSupportedSeverity(level) {
    return (0, $6r0cU.SeverityLevels).indexOf(level) !== -1;
}
function $8e1c4a41cee4d8ce$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $8lCud.Severity).Warning;
    if ($8e1c4a41cee4d8ce$var$isSupportedSeverity(level)) return level;
    return (0, $8lCud.Severity).Log;
}

});
parcelRegister("6r0cU", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $4af56cdb757dbd95$export$484b1ea9aec914c);
var $4af56cdb757dbd95$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("eqURj", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $a81f995de77d1e8c$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $a81f995de77d1e8c$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("7X7rA", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $2mAO5 = parcelRequire("2mAO5");

var $fMw01 = parcelRequire("fMw01");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $2mAO5.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $fMw01.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $fMw01.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $2mAO5.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("39WwY", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $24cf9d5d49a9f94b$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $24cf9d5d49a9f94b$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $24cf9d5d49a9f94b$export$32f9b428425aac85);

var $5lpFe = parcelRequire("5lpFe");

var $eA0Kr = parcelRequire("eA0Kr");
function $24cf9d5d49a9f94b$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $24cf9d5d49a9f94b$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $5lpFe.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $5lpFe.__spread)(items, [
            newItem
        ])
    ];
}
function $24cf9d5d49a9f94b$export$d84939284bbafcd4(envelope) {
    var _a = (0, $5lpFe.__read)(envelope, 2), _b = (0, $5lpFe.__read)(_a[1], 1), _c = (0, $5lpFe.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $24cf9d5d49a9f94b$export$32f9b428425aac85(envelope) {
    var _a = (0, $5lpFe.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $5lpFe.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $eA0Kr.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("kZZlM", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $f4991808c18309b9$export$f3b9ed77c03eeb00);

var $39WwY = parcelRequire("39WwY");

var $7X7rA = parcelRequire("7X7rA");
function $f4991808c18309b9$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $7X7rA.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $39WwY.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("2z5O0", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $1de35a7da5758d08$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $1de35a7da5758d08$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $1de35a7da5758d08$export$699aff705e0d49d4);

var $5lpFe = parcelRequire("5lpFe");
var $1de35a7da5758d08$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $1de35a7da5758d08$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $1de35a7da5758d08$export$b09ce39faaeb1e7c;
}
function $1de35a7da5758d08$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $1de35a7da5758d08$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $1de35a7da5758d08$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $1de35a7da5758d08$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $5lpFe.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $5lpFe.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $5lpFe.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $1de35a7da5758d08$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("8mZWO", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5lpFe = parcelRequire("5lpFe");
// global reference to slice
var $61806e48a27f84dd$var$UNKNOWN_FUNCTION = '?';
var $61806e48a27f84dd$var$OPERA10_PRIORITY = 10;
var $61806e48a27f84dd$var$OPERA11_PRIORITY = 20;
var $61806e48a27f84dd$var$CHROME_PRIORITY = 30;
var $61806e48a27f84dd$var$WINJS_PRIORITY = 40;
var $61806e48a27f84dd$var$GECKO_PRIORITY = 50;
function $61806e48a27f84dd$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $61806e48a27f84dd$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $61806e48a27f84dd$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $61806e48a27f84dd$var$chrome = function(line) {
    var parts = $61806e48a27f84dd$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $61806e48a27f84dd$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = $5lpFe.__read($61806e48a27f84dd$var$extractSafariExtensionDetails(parts[1] || $61806e48a27f84dd$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $61806e48a27f84dd$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
module.exports.chromeStackParser = [
    $61806e48a27f84dd$var$CHROME_PRIORITY,
    $61806e48a27f84dd$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $61806e48a27f84dd$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $61806e48a27f84dd$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $61806e48a27f84dd$var$gecko = function(line) {
    var _a;
    var parts = $61806e48a27f84dd$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $61806e48a27f84dd$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $61806e48a27f84dd$var$UNKNOWN_FUNCTION;
        _a = $5lpFe.__read($61806e48a27f84dd$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $61806e48a27f84dd$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
module.exports.geckoStackParser = [
    $61806e48a27f84dd$var$GECKO_PRIORITY,
    $61806e48a27f84dd$var$gecko
];
var $61806e48a27f84dd$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $61806e48a27f84dd$var$winjs = function(line) {
    var parts = $61806e48a27f84dd$var$winjsRegex.exec(line);
    return parts ? $61806e48a27f84dd$var$createFrame(parts[2], parts[1] || $61806e48a27f84dd$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
module.exports.winjsStackParser = [
    $61806e48a27f84dd$var$WINJS_PRIORITY,
    $61806e48a27f84dd$var$winjs
];
var $61806e48a27f84dd$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $61806e48a27f84dd$var$opera10 = function(line) {
    var parts = $61806e48a27f84dd$var$opera10Regex.exec(line);
    return parts ? $61806e48a27f84dd$var$createFrame(parts[2], parts[3] || $61806e48a27f84dd$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
module.exports.opera10StackParser = [
    $61806e48a27f84dd$var$OPERA10_PRIORITY,
    $61806e48a27f84dd$var$opera10
];
var $61806e48a27f84dd$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $61806e48a27f84dd$var$opera11 = function(line) {
    var parts = $61806e48a27f84dd$var$opera11Regex.exec(line);
    return parts ? $61806e48a27f84dd$var$createFrame(parts[5], parts[3] || parts[4] || $61806e48a27f84dd$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
module.exports.opera11StackParser = [
    $61806e48a27f84dd$var$OPERA11_PRIORITY,
    $61806e48a27f84dd$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $61806e48a27f84dd$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $61806e48a27f84dd$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});




parcelRegister("ggpx4", function(module, exports) {
$parcel$export(module.exports, "getApplication", () => $0eac58a824e4e2e6$export$205bc258834dc08);
$parcel$export(module.exports, "bootstrap", () => $0eac58a824e4e2e6$export$36aff1fbb4f5dfc6);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $6LH8a = parcelRequire("6LH8a");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("ieUrC");
var $bAGzC = parcelRequire("bAGzC");

var $gszEw = parcelRequire("gszEw");

var $gq5Zl = parcelRequire("gq5Zl");

var $4gQCF = parcelRequire("4gQCF");

var $aZfc9 = parcelRequire("aZfc9");

var $8zZLS = parcelRequire("8zZLS");

var $7lN8e = parcelRequire("7lN8e");

var $7cVI2 = parcelRequire("7cVI2");

var $iuWTe = parcelRequire("iuWTe");

var $1InLN = parcelRequire("1InLN");
const $0eac58a824e4e2e6$var$initialiseAppUtilities = (0, $aYMdQ.once)(()=>{
    (0, $7cVI2.initialisePlatformFeatureFlags)();
    (0, $8zZLS.initialiseConnectAndSentryAndCleanUrl)();
    (0, $4gQCF.install)();
    (0, $aZfc9.initBrowserMetricsV3)();
});
const $0eac58a824e4e2e6$export$205bc258834dc08 = ()=>{
    const atlassianHelpConfig = {
        ...(0, $7lN8e.getEnv)(),
        ...(0, $6LH8a.getMetaData)()
    };
    (0, $gszEw.ModelsCache).getInstance().initFromInitialJsonPayload();
    $0eac58a824e4e2e6$var$initialiseAppUtilities();
    return /*#__PURE__*/ $fc4bM.createElement((0, $gq5Zl.default), {
        name: "help-center-root"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1InLN.AtlassianHelp), {
        config: atlassianHelpConfig
    }));
};
const $0eac58a824e4e2e6$export$36aff1fbb4f5dfc6 = ()=>{
    (0, $bAGzC.LooselyLazy).init({
        retry: 3
    });
    const rootId = 'root';
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let container = document.getElementById(rootId);
    if (!container) {
        // If there is no root element available yet, add one.
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        container = document.createElement('span');
        container.id = rootId;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.body.appendChild(container);
    }
    // Invalid report.
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const isPageServerSideRendered = (0, $7lN8e.getIsPageServerSideRendered)();
    // Workaround for this google translate problem https://github.com/facebook/react/issues/11538#issuecomment-417504600
    // which is causing this issue https://hello.jira.atlassian.cloud/browse/PORTAL-5241, affecting view page reliability
    (0, $iuWTe.handleDOMGoogleTranslateIssues)();
    if (isPageServerSideRendered) (0, $bTkYf.hydrate)($0eac58a824e4e2e6$export$205bc258834dc08(), container);
    else (0, $bTkYf.render)($0eac58a824e4e2e6$export$205bc258834dc08(), container);
};

});
parcelRegister("ieUrC", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("bAGzC")).LooselyLazy);
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("dohmo")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("dohmo")).lazy);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("fMoeW")).LazyWait);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("euVUr")).LazySuspense);
parcelRequire("bw4It");
var $eiZZF = parcelRequire("eiZZF");

var $bAGzC = parcelRequire("bAGzC");

var $dohmo = parcelRequire("dohmo");
parcelRequire("9B7Ng");
var $fMoeW = parcelRequire("fMoeW");
parcelRequire("RVZjr");
var $euVUr = parcelRequire("euVUr");

var $gQHdx = parcelRequire("gQHdx");

var $cZjZm = parcelRequire("cZjZm");

});
parcelRegister("bw4It", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $8626576ca63cd4d8$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $8626576ca63cd4d8$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("eiZZF")).MODE);

var $eiZZF = parcelRequire("eiZZF");
const $8626576ca63cd4d8$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8626576ca63cd4d8$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8626576ca63cd4d8$var$DEFAULT_MODE = (0, $eiZZF.MODE).HYDRATE;
const $8626576ca63cd4d8$var$DEFAULT_RETRY = 2;
const $8626576ca63cd4d8$var$config = {
    crossOrigin: $8626576ca63cd4d8$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8626576ca63cd4d8$var$DEFAULT_MANIFEST,
    mode: $8626576ca63cd4d8$var$DEFAULT_MODE,
    retry: $8626576ca63cd4d8$var$DEFAULT_RETRY
};
const $8626576ca63cd4d8$export$44487a86467333c3 = ()=>$8626576ca63cd4d8$var$config;
const $8626576ca63cd4d8$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $8626576ca63cd4d8$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $8626576ca63cd4d8$var$DEFAULT_CROSS_ORIGIN;
    $8626576ca63cd4d8$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $8626576ca63cd4d8$var$DEFAULT_MANIFEST;
    $8626576ca63cd4d8$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $8626576ca63cd4d8$var$DEFAULT_MODE;
    $8626576ca63cd4d8$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $8626576ca63cd4d8$var$DEFAULT_RETRY;
};

});
parcelRegister("eiZZF", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $a6a2d5c36a0ea8d9$export$e48589d9e4824227);
const $a6a2d5c36a0ea8d9$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("bAGzC", function(module, exports) {
$parcel$export(module.exports, "LooselyLazy", () => $870414b9a9a67f47$export$33c5f161e1d4706);

var $hX3pI = parcelRequire("hX3pI");

var $bw4It = parcelRequire("bw4It");
parcelRequire("gQHdx");
var $kpqUu = parcelRequire("kpqUu");
var $56eBg = parcelRequire("56eBg");

var $kDTOu = parcelRequire("kDTOu");
const $870414b9a9a67f47$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $bw4It.setConfig)(config);
        (0, $kpqUu.LISTENERS).length = 0;
        (0, $56eBg.setCurrent)(0);
        if (!(0, $kDTOu.isNodeEnvironment)()) (0, $hX3pI.collect)();
    }
};

});
parcelRegister("hX3pI", function(module, exports) {
$parcel$export(module.exports, "collect", () => $d11a98450690a8bb$export$bb44f104e3c54dae);

var $bw4It = parcelRequire("bw4It");
var $eiZZF = parcelRequire("eiZZF");

var $l3Tw1 = parcelRequire("l3Tw1");

var $f8mBP = parcelRequire("f8mBP");

var $6xwT0 = parcelRequire("6xwT0");
const $d11a98450690a8bb$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $bw4It.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $eiZZF.MODE).RENDER ? (0, $f8mBP.cloneElements)(markers[i], lazyBegin) : (0, $6xwT0.refElements)(markers[i], lazyBegin);
        if ((0, $l3Tw1.COLLECTED).has(lazyBegin)) (0, $l3Tw1.COLLECTED).get(lazyBegin).push(value);
        else (0, $l3Tw1.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("l3Tw1", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $f554f0ff3fe97d5b$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $f554f0ff3fe97d5b$export$4831ef3968ea94ef);
const $f554f0ff3fe97d5b$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $f554f0ff3fe97d5b$export$4831ef3968ea94ef = new Map();

});

parcelRegister("f8mBP", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $b0492410bc59214b$export$c42217d53a7ebafb);
const $b0492410bc59214b$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("6xwT0", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $4c2f55a4919f3182$export$c69443129766a7fc);
const $4c2f55a4919f3182$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("gQHdx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("56eBg")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("56eBg")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("kpqUu")).LISTENERS);

var $56eBg = parcelRequire("56eBg");

var $kpqUu = parcelRequire("kpqUu");

var $9BK3J = parcelRequire("9BK3J");

});
parcelRegister("56eBg", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $3b68d687030f6d4a$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $3b68d687030f6d4a$export$5a25eca35e5debcb);

var $fc4bM = parcelRequire("fc4bM");

var $l3Tw1 = parcelRequire("l3Tw1");

var $kpqUu = parcelRequire("kpqUu");

var $9BK3J = parcelRequire("9BK3J");
let $3b68d687030f6d4a$var$CURRENT_PHASE = (0, $l3Tw1.PHASE).PAINT;
const $3b68d687030f6d4a$export$5f80f094fd31fffd = (phase)=>{
    $3b68d687030f6d4a$var$CURRENT_PHASE = phase;
    (0, $kpqUu.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $3b68d687030f6d4a$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $fc4bM.createContext)({
    subscribe: (0, $9BK3J.createSubscribe)((0, $kpqUu.LISTENERS)),
    currentValue: ()=>$3b68d687030f6d4a$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $3b68d687030f6d4a$export$5f80f094fd31fffd((0, $l3Tw1.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$3b68d687030f6d4a$export$5f80f094fd31fffd((0, $l3Tw1.PHASE).PAINT)
    }
});
const $3b68d687030f6d4a$export$1dc361b277327f88 = ()=>{
    const v = (0, $fc4bM.useContext)($3b68d687030f6d4a$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("kpqUu", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $edbb04372ac06358$export$81b9c458a026d68f);
const $edbb04372ac06358$export$81b9c458a026d68f = [];

});

parcelRegister("9BK3J", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $6feb4c28b2bdcffb$export$364097d812234b3f);
const $6feb4c28b2bdcffb$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("kDTOu", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $f072be8650303b87$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $f072be8650303b87$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $f072be8650303b87$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $f072be8650303b87$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("jF8VL")).default);

var $jF8VL = parcelRequire("jF8VL");
const $f072be8650303b87$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $f072be8650303b87$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $f072be8650303b87$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $f072be8650303b87$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("jF8VL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e508c616e00ecd04$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $e508c616e00ecd04$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("dohmo", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $9bfafba3c6375c5a$export$c952e5f94576010e);
$parcel$export(module.exports, "lazy", () => $9bfafba3c6375c5a$export$488013bae63b21da);

var $gA1YI = parcelRequire("gA1YI");

var $bw4It = parcelRequire("bw4It");

var $l3Tw1 = parcelRequire("l3Tw1");

var $kDTOu = parcelRequire("kDTOu");
var $jF8VL = parcelRequire("jF8VL");

var $5uakL = parcelRequire("5uakL");

var $5Fy9c = parcelRequire("5Fy9c");

var $i0tVt = parcelRequire("i0tVt");

var $7AgAm = parcelRequire("7AgAm");

var $2rG8V = parcelRequire("2rG8V");

var $12sYd = parcelRequire("12sYd");

var $3gHxJ = parcelRequire("3gHxJ");
function $9bfafba3c6375c5a$var$_extends() {
    $9bfafba3c6375c5a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9bfafba3c6375c5a$var$_extends.apply(this, arguments);
}
function $9bfafba3c6375c5a$var$lazyProxy(_loader, { defer: defer = (0, $l3Tw1.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $kDTOu.isNodeEnvironment)();
    const dataLazyId = (0, $jF8VL.default)(moduleId);
    const LazyInternal = isServer ? (0, $i0tVt.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $5Fy9c.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $7AgAm.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $bw4It.getConfig)();
                return (0, $12sYd.retry)(_loader, {
                    delay: (0, $5uakL.RETRY_DELAY),
                    factor: (0, $5uakL.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $kDTOu.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $bw4It.getConfig)();
        return (0, $gA1YI.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $l3Tw1.PHASE).PAINT ? (0, $5uakL.PRIORITY).HIGH : (0, $5uakL.PRIORITY).LOW;
        return (0, $2rG8V.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $9bfafba3c6375c5a$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $l3Tw1.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $l3Tw1.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $l3Tw1.PHASE).LAZY
    }
};
function $9bfafba3c6375c5a$export$c952e5f94576010e(loader, opts) {
    return $9bfafba3c6375c5a$var$lazyProxy(loader, $9bfafba3c6375c5a$var$_extends({}, $9bfafba3c6375c5a$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $9bfafba3c6375c5a$export$291dd592399bdafa(loader, opts) {
    return $9bfafba3c6375c5a$var$lazyProxy(loader, $9bfafba3c6375c5a$var$_extends({}, $9bfafba3c6375c5a$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $9bfafba3c6375c5a$export$488013bae63b21da(loader, opts) {
    return $9bfafba3c6375c5a$var$lazyProxy(loader, $9bfafba3c6375c5a$var$_extends({}, $9bfafba3c6375c5a$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("gA1YI", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $c1218afd3e8080f5$export$303f43e55cf1ef2f);
const $c1218afd3e8080f5$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("5uakL", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $3fe7c52c2f7cf2b0$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $3fe7c52c2f7cf2b0$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $3fe7c52c2f7cf2b0$export$ba64c908e55507fe);
const $3fe7c52c2f7cf2b0$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $3fe7c52c2f7cf2b0$export$a339266ad71b2447 = 300;
const $3fe7c52c2f7cf2b0$export$ba64c908e55507fe = 1;

});

parcelRegister("5Fy9c", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $420b450854666672$export$6898b5504b58699a);

var $fc4bM = parcelRequire("fc4bM");

var $bw4It = parcelRequire("bw4It");
var $eiZZF = parcelRequire("eiZZF");

var $l3Tw1 = parcelRequire("l3Tw1");
parcelRequire("9B7Ng");
var $2xjc5 = parcelRequire("2xjc5");
parcelRequire("gQHdx");
var $56eBg = parcelRequire("56eBg");
parcelRequire("RVZjr");
var $kaSk5 = parcelRequire("kaSk5");

var $5uakL = parcelRequire("5uakL");

var $3gHxJ = parcelRequire("3gHxJ");

var $gneWk = parcelRequire("gneWk");

var $9WtFD = parcelRequire("9WtFD");

var $2rG8V = parcelRequire("2rG8V");

var $cZjZm = parcelRequire("cZjZm");

var $cSOHm = parcelRequire("cSOHm");
function $420b450854666672$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $fc4bM.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $l3Tw1.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $l3Tw1.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $fc4bM.useContext)((0, $cZjZm.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $3gHxJ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $cSOHm.useSubscription)({
            context: (0, $2xjc5.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $l3Tw1.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $cSOHm.useSubscription)({
                context: (0, $56eBg.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $fc4bM.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $2rG8V.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $5uakL.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $fc4bM.useContext)((0, $kaSk5.LazySuspenseContext));
        (0, $fc4bM.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $l3Tw1.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $bw4It.getConfig)().mode === (0, $eiZZF.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gneWk.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9WtFD.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("9B7Ng", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("2xjc5")).WaitContext);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("fMoeW")).LazyWait);

var $2xjc5 = parcelRequire("2xjc5");

var $fMoeW = parcelRequire("fMoeW");

});
parcelRegister("2xjc5", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $1d8d8d54f20955b4$export$9ba3fe09d15de47b);

var $fc4bM = parcelRequire("fc4bM");

var $ckmmC = parcelRequire("ckmmC");
const $1d8d8d54f20955b4$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $fc4bM.createContext)({
    subscribe: ()=>(0, $ckmmC.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ckmmC", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $8f98b346e6fa37a2$export$276c7dbda7675aec);
const $8f98b346e6fa37a2$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("fMoeW", function(module, exports) {
$parcel$export(module.exports, "LazyWait", () => $b7ce2442cd6afb45$export$7bf6cf03fd32cddb);

var $fc4bM = parcelRequire("fc4bM");

var $2xjc5 = parcelRequire("2xjc5");
const $b7ce2442cd6afb45$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $fc4bM.useContext)((0, $2xjc5.WaitContext));
    const value = (0, $fc4bM.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $fc4bM.useRef)(new Set());
    const api = (0, $fc4bM.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $fc4bM.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2xjc5.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("RVZjr", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("euVUr")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("kaSk5")).LazySuspenseContext);

var $euVUr = parcelRequire("euVUr");

var $kaSk5 = parcelRequire("kaSk5");

});
parcelRegister("euVUr", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $a8e0c9a103331fca$export$256c542058532d6f);

var $fc4bM = parcelRequire("fc4bM");

var $kDTOu = parcelRequire("kDTOu");

var $kaSk5 = parcelRequire("kaSk5");
class $a8e0c9a103331fca$export$256c542058532d6f extends (0, $fc4bM.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $fc4bM.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kaSk5.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kaSk5.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $kDTOu.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("kaSk5", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $eafee13b776a5a37$export$c33990e84065970c);

var $fc4bM = parcelRequire("fc4bM");
const $eafee13b776a5a37$export$c33990e84065970c = /*#__PURE__*/ (0, $fc4bM.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("3gHxJ", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $2614a47cbcc3cf31$export$c73a6a6f0bf7d425);
const $2614a47cbcc3cf31$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $2614a47cbcc3cf31$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$2614a47cbcc3cf31$export$6aa69c1258005366]: true
    });
    return error;
};
const $2614a47cbcc3cf31$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($2614a47cbcc3cf31$export$6aa69c1258005366);

});

parcelRegister("gneWk", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $beba62079eb26059$export$d55db778a3e1446b);

var $fc4bM = parcelRequire("fc4bM");
function $beba62079eb26059$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $beba62079eb26059$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $fc4bM.useRef)(null);
    const { current: ssrDomNodes } = (0, $fc4bM.useRef)(content || []);
    (0, $fc4bM.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($beba62079eb26059$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $beba62079eb26059$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $beba62079eb26059$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("9WtFD", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $73d08bc4b8b3550d$export$ca5b8fbc835d95e4);

var $fc4bM = parcelRequire("fc4bM");

var $kDTOu = parcelRequire("kDTOu");
function $73d08bc4b8b3550d$var$_extends() {
    $73d08bc4b8b3550d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $73d08bc4b8b3550d$var$_extends.apply(this, arguments);
}
const $73d08bc4b8b3550d$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $kDTOu.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $fc4bM.createElement)((0, $fc4bM.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $fc4bM.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $fc4bM.createElement)(tagName.toLowerCase(), $73d08bc4b8b3550d$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("2rG8V", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $1c7ecb13f6aab137$export$25bad4aa00c45355);

var $gA1YI = parcelRequire("gA1YI");

var $ckmmC = parcelRequire("ckmmC");

var $bw4It = parcelRequire("bw4It");

var $kDTOu = parcelRequire("kDTOu");

var $5uakL = parcelRequire("5uakL");

var $csqVj = parcelRequire("csqVj");

var $cZjZm = parcelRequire("cZjZm");
function $1c7ecb13f6aab137$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $bw4It.getConfig)();
    const assets = (0, $gA1YI.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $csqVj.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $1c7ecb13f6aab137$var$fakePromise = {
    then: ()=>$1c7ecb13f6aab137$var$fakePromise,
    catch: ()=>$1c7ecb13f6aab137$var$fakePromise,
    finally: ()=>$1c7ecb13f6aab137$var$fakePromise
};
function $1c7ecb13f6aab137$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $csqVj.insertLinkTag)(href, rel));
        return $1c7ecb13f6aab137$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $1c7ecb13f6aab137$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ckmmC.noopCleanup;
}
function $1c7ecb13f6aab137$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $kDTOu.isNodeEnvironment)()) return 0, $ckmmC.noopCleanup;
    (_GlobalReactLooselyLa = (0, $cZjZm.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $5uakL.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $1c7ecb13f6aab137$export$3af04dbcb01bad4d,
        $1c7ecb13f6aab137$export$1046fd6a49d5e7a,
        $1c7ecb13f6aab137$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $ckmmC.noopCleanup;
}

});
parcelRegister("csqVj", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $911cfbf9753f073e$export$6610512821c8a4ce);

var $cZjZm = parcelRequire("cZjZm");

var $ckmmC = parcelRequire("ckmmC");

var $bw4It = parcelRequire("bw4It");
function $911cfbf9753f073e$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ckmmC.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $bw4It.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $cZjZm.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});
parcelRegister("cZjZm", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $974aafe15983e17c$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $974aafe15983e17c$export$8146ab57a3f7a7cb);

var $fc4bM = parcelRequire("fc4bM");
const $974aafe15983e17c$export$e2d53c0cbedd2710 = {
    current: null
};
const $974aafe15983e17c$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $fc4bM.createContext)($974aafe15983e17c$export$e2d53c0cbedd2710);

});



parcelRegister("cSOHm", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $9611dacf7325a970$export$368b4214baeb914c);

var $fc4bM = parcelRequire("fc4bM");
function $9611dacf7325a970$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $fc4bM.useContext)(context);
    (0, $fc4bM.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("i0tVt", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $d1bf70c12ef40c45$export$eb2e4b04351cdd9e);

var $gA1YI = parcelRequire("gA1YI");

var $fc4bM = parcelRequire("fc4bM");

var $bw4It = parcelRequire("bw4It");

var $l3Tw1 = parcelRequire("l3Tw1");
parcelRequire("RVZjr");
var $kaSk5 = parcelRequire("kaSk5");

var $kDTOu = parcelRequire("kDTOu");

var $3gHxJ = parcelRequire("3gHxJ");
function $d1bf70c12ef40c45$var$load(moduleId, loader) {
    try {
        return (0, $kDTOu.getExport)(loader());
    } catch (err) {
        throw (0, $3gHxJ.createLoaderError)(err);
    }
}
function $d1bf70c12ef40c45$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $d1bf70c12ef40c45$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $fc4bM.useContext)((0, $kaSk5.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $bw4It.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $l3Tw1.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $gA1YI.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("link", {
                key: url,
                rel: defer === (0, $l3Tw1.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("7AgAm", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $5858c2b8f8ebec89$export$e673efccd97e4223);
const $5858c2b8f8ebec89$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("12sYd", function(module, exports) {
$parcel$export(module.exports, "retry", () => $0c1c733665aff0f5$export$9369b12211e1fce4);
const $0c1c733665aff0f5$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $0c1c733665aff0f5$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $0c1c733665aff0f5$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $0c1c733665aff0f5$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $0c1c733665aff0f5$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $0c1c733665aff0f5$var$calculateDelay(context, policy);
        if (delay) await $0c1c733665aff0f5$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("gszEw", function(module, exports) {
$parcel$export(module.exports, "ModelsCache", () => $c22d7d7fea39abd1$export$6525a85e50433f6b);

var $aYMdQ = parcelRequire("aYMdQ");

var $hqTXx = parcelRequire("hqTXx");

var $4MjGQ = parcelRequire("4MjGQ");

var $bKaMP = parcelRequire("bKaMP");
const $c22d7d7fea39abd1$var$TEN_MINUTE_TIMEOUT = 600;
const $c22d7d7fea39abd1$var$createCacheOperationalPayload = (modelType, cacheEventType)=>{
    return {
        action: cacheEventType,
        actionSubject: 'model-caches',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $c22d7d7fea39abd1$var$fireCacheMissOperationalEvent = (modelType)=>{
    (0, $4MjGQ.operationalEvent)($c22d7d7fea39abd1$var$createCacheOperationalPayload(modelType, 'cache-missed'));
};
const $c22d7d7fea39abd1$var$fireCacheHitOperationalEvent = (modelType)=>{
    (0, $4MjGQ.operationalEvent)($c22d7d7fea39abd1$var$createCacheOperationalPayload(modelType, 'cache-hit'));
};
class $c22d7d7fea39abd1$export$6525a85e50433f6b {
    constructor(){
        /**
   * We will cache the user model later after splitting it into two; a static component and one for dynamic data such
   * as counts.
   */ this.toCacheModels = [
            'helpCenterBranding',
            'suggestedRequestTypes',
            'organisations',
            'portalsAndRequestTypes',
            ...this.addNewModelsToCache()
        ];
        const cacheTTL = $c22d7d7fea39abd1$var$TEN_MINUTE_TIMEOUT;
        this.cache = new (0, (/*@__PURE__*/$parcel$interopDefault($hqTXx)))({
            stdTTL: cacheTTL,
            checkperiod: cacheTTL * 0.5,
            useClones: false
        });
    }
    static getInstance() {
        if (!$c22d7d7fea39abd1$export$6525a85e50433f6b.instance) $c22d7d7fea39abd1$export$6525a85e50433f6b.instance = new $c22d7d7fea39abd1$export$6525a85e50433f6b();
        return $c22d7d7fea39abd1$export$6525a85e50433f6b.instance;
    }
    shouldCache(modelType) {
        return this.toCacheModels.includes(modelType);
    }
    getFromCache(request) {
        const cachedResult = this.getFromCacheInternal(request);
        if (cachedResult !== undefined) $c22d7d7fea39abd1$var$fireCacheHitOperationalEvent(request.type);
        else $c22d7d7fea39abd1$var$fireCacheMissOperationalEvent(request.type);
        return cachedResult;
    }
    getFromCacheInternal(request) {
        const requestCacheEntries = this.cache.get(request.type) || [];
        return requestCacheEntries.find((cacheEntry)=>(0, $aYMdQ.isEqual)(cacheEntry.request, request));
    }
    putToCache(request, modelsResponse) {
        const fromCache = this.getFromCacheInternal(request);
        if (fromCache === undefined) {
            const requests = this.cache.get(request.type) || [];
            requests.push({
                request: request,
                response: modelsResponse
            });
            this.cache.set(request.type, requests);
        }
    }
    del(modelType) {
        this.cache.del(modelType);
    }
    /**
   * Initialise model cache with models contained in jsonPayload div.
   * This avoids loading them again during app init.
   *
   * Note that this implementation assumes model requests during initial page loads don't contain any parameters
   * other than the modelType.
   */ initFromInitialJsonPayload() {
        const initialModelState = (0, $bKaMP.default)();
        for (const modelTypeStr of Object.keys(initialModelState)){
            const modelType = modelTypeStr;
            if ($c22d7d7fea39abd1$export$6525a85e50433f6b.getInstance().shouldCache(modelType)) $c22d7d7fea39abd1$export$6525a85e50433f6b.getInstance().putToCache({
                type: modelType,
                params: {}
            }, // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            {
                [modelType]: initialModelState[modelType]
            });
        }
    }
    addNewModelsToCache() {
        return [
            'portal',
            'branding',
            'portalWebFragments',
            'user'
        ];
    }
}

});
parcelRegister("hqTXx", function(module, exports) {

/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var exports;
    exports = module.exports = (parcelRequire("9afX5"));
    exports.version = '5.1.2';
}).call(module.exports);

});
parcelRegister("9afX5", function(module, exports) {

var $kPPno = parcelRequire("kPPno");
var $6ac16bf9b3aabf58$require$Buffer = $kPPno.Buffer;


/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var EventEmitter, NodeCache, clone, splice = [].splice, boundMethodCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new Error('Bound instance method accessed before binding');
    }, indexOf = [].indexOf;
    clone = (parcelRequire("6nn7o"));
    EventEmitter = (parcelRequire("hylEy")).EventEmitter;
    // generate superclass
    module.exports = NodeCache = (function() {
        class NodeCache extends EventEmitter {
            constructor(options = {}){
                super();
                // ## get
                // get a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.get "myKey", ( err, val )
                this.get = this.get.bind(this);
                // ## mget
                // get multiple cached keys at once and change the stats
                // **Parameters:**
                // * `keys` ( String|Number[] ): an array of keys
                // **Example:**
                //	myCache.mget [ "foo", "bar" ]
                this.mget = this.mget.bind(this);
                // ## set
                // set a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // * `value` ( Any ): A element to cache. If the option `option.forceString` is `true` the module trys to translate it to a serialized JSON
                // * `[ ttl ]` ( Number | String ): ( optional ) The time to live in seconds.
                // **Example:**
                //	myCache.set "myKey", "my_String Value"
                //	myCache.set "myKey", "my_String Value", 10
                this.set = this.set.bind(this);
                // ## mset
                // set multiple keys at once
                // **Parameters:**
                // * `keyValueSet` ( Object[] ): an array of object which includes key,value and ttl
                // **Example:**
                //	myCache.mset(
                //		[
                //			{
                //				key: "myKey",
                //				val: "myValue",
                //				ttl: [ttl in seconds]
                //			}
                //		])
                this.mset = this.mset.bind(this);
                // ## del
                // remove keys
                // **Parameters:**
                // * `keys` ( String | Number | String|Number[] ): cache key to delete or a array of cache keys
                // **Return**
                // ( Number ): Number of deleted keys
                // **Example:**
                //	myCache.del( "myKey" )
                this.del = this.del.bind(this);
                // ## take
                // get the cached value and remove the key from the cache.
                // Equivalent to calling `get(key)` + `del(key)`.
                // Useful for implementing `single use` mechanism such as OTP, where once a value is read it will become obsolete.
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.take "myKey", ( err, val )
                this.take = this.take.bind(this);
                // ## ttl
                // reset or redefine the ttl of a key. `ttl` = 0 means infinite lifetime.
                // If `ttl` is not passed the default ttl is used.
                // If `ttl` < 0 the key will be deleted.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to reset the ttl value
                // * `ttl` ( Number ): ( optional -> options.stdTTL || 0 ) The time to live in seconds
                // **Return**
                // ( Boolen ): key found and ttl set
                // **Example:**
                //	myCache.ttl( "myKey" ) // will set ttl to default ttl
                //	myCache.ttl( "myKey", 1000 )
                this.ttl = this.ttl.bind(this);
                // ## getTtl
                // receive the ttl of a key.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Number|undefined ): The timestamp in ms when the key will expire, 0 if it will never expire or undefined if it not exists
                // **Example:**
                //	myCache.getTtl( "myKey" )
                this.getTtl = this.getTtl.bind(this);
                // ## keys
                // list all keys within this cache
                // **Return**
                // ( Array ): An array of all keys
                // **Example:**
                //     _keys = myCache.keys()
                //     # [ "foo", "bar", "fizz", "buzz", "anotherKeys" ]
                this.keys = this.keys.bind(this);
                // ## has
                // Check if a key is cached
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Boolean ): A boolean that indicates if the key is cached
                // **Example:**
                //     _exists = myCache.has('myKey')
                //     # true
                this.has = this.has.bind(this);
                // ## getStats
                // get the stats
                // **Parameters:**
                // -
                // **Return**
                // ( Object ): Stats data
                // **Example:**
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.getStats = this.getStats.bind(this);
                // ## flushAll
                // flush the whole data and reset the stats
                // **Example:**
                //     myCache.flushAll()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushAll = this.flushAll.bind(this);
                // ## flushStats
                // flush the stats and reset all counters to 0
                // **Example:**
                //     myCache.flushStats()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushStats = this.flushStats.bind(this);
                // ## close
                // This will clear the interval timeout which is set on checkperiod option.
                // **Example:**
                //     myCache.close()
                this.close = this.close.bind(this);
                // ## _checkData
                // internal housekeeping method.
                // Check all the cached data and delete the invalid values
                this._checkData = this._checkData.bind(this);
                // ## _check
                // internal method the check the value. If it's not valid any more delete it
                this._check = this._check.bind(this);
                // ## _isInvalidKey
                // internal method to check if the type of a key is either `number` or `string`
                this._isInvalidKey = this._isInvalidKey.bind(this);
                // ## _wrap
                // internal method to wrap a value in an object with some metadata
                this._wrap = this._wrap.bind(this);
                // ## _getValLength
                // internal method to calculate the value length
                this._getValLength = this._getValLength.bind(this);
                // ## _error
                // internal method to handle an error message
                this._error = this._error.bind(this);
                // ## _initErrors
                // internal method to generate error message templates
                this._initErrors = this._initErrors.bind(this);
                this.options = options;
                this._initErrors();
                // container for cached data
                this.data = {};
                // module options
                this.options = Object.assign({
                    // convert all elements to string
                    forceString: false,
                    // used standard size for calculating value size
                    objectValueSize: 80,
                    promiseValueSize: 80,
                    arrayValueSize: 40,
                    // standard time to live in seconds. 0 = infinity;
                    stdTTL: 0,
                    // time in seconds to check all data and delete expired keys
                    checkperiod: 600,
                    // en/disable cloning of variables. If `true` you'll get a copy of the cached variable. If `false` you'll save and get just the reference
                    useClones: true,
                    // whether values should be deleted automatically at expiration
                    deleteOnExpire: true,
                    // enable legacy callbacks
                    enableLegacyCallbacks: false,
                    // max amount of keys that are being stored
                    maxKeys: -1
                }, this.options);
                // generate functions with callbacks (legacy)
                if (this.options.enableLegacyCallbacks) {
                    console.warn("WARNING! node-cache legacy callback support will drop in v6.x");
                    [
                        "get",
                        "mget",
                        "set",
                        "del",
                        "ttl",
                        "getTtl",
                        "keys",
                        "has"
                    ].forEach((methodKey)=>{
                        var oldMethod;
                        // reference real function
                        oldMethod = this[methodKey];
                        this[methodKey] = function(...args) {
                            var cb, err, ref, res;
                            ref = args, [...args] = ref, [cb] = splice.call(args, -1);
                            // return a callback if cb is defined and a function
                            if (typeof cb === "function") try {
                                res = oldMethod(...args);
                                cb(null, res);
                            } catch (error1) {
                                err = error1;
                                cb(err);
                            }
                            else return oldMethod(...args, cb);
                        };
                    });
                }
                // statistics container
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // pre allocate valid keytypes array
                this.validKeyTypes = [
                    "string",
                    "number"
                ];
                // initalize checking period
                this._checkData();
                return;
            }
            get(key) {
                var _ret, err;
                boundMethodCheck(this, NodeCache);
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // get data and incremet stats
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    this.stats.hits++;
                    _ret = this._unwrap(this.data[key]);
                    // return data
                    return _ret;
                } else {
                    // if not found return undefined
                    this.stats.misses++;
                    return void 0;
                }
            }
            mget(keys) {
                var _err, err, i, key, len, oRet;
                boundMethodCheck(this, NodeCache);
                // convert a string to an array of one key
                if (!Array.isArray(keys)) {
                    _err = this._error("EKEYSTYPE");
                    throw _err;
                }
                // define return
                oRet = {};
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // get data and increment stats
                    if (this.data[key] != null && this._check(key, this.data[key])) {
                        this.stats.hits++;
                        oRet[key] = this._unwrap(this.data[key]);
                    } else // if not found return a error
                    this.stats.misses++;
                }
                // return all found keys
                return oRet;
            }
            set(key, value, ttl) {
                var _err, err, existent;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // force the data to string
                this.options.forceString;
                // set default ttl if not passed
                if (ttl == null) ttl = this.options.stdTTL;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // internal helper variables
                existent = false;
                // remove existing data from stats
                if (this.data[key]) {
                    existent = true;
                    this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                }
                // set the value
                this.data[key] = this._wrap(value, ttl);
                this.stats.vsize += this._getValLength(value);
                // only add the keys and key-size if the key is new
                if (!existent) {
                    this.stats.ksize += this._getKeyLength(key);
                    this.stats.keys++;
                }
                this.emit("set", key, value);
                // return true
                return true;
            }
            mset(keyValueSet) {
                var _err, err, i, j, key, keyValuePair, len, len1, ttl, val;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys + keyValueSet.length >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // loop over keyValueSet to validate key and ttl
                for(i = 0, len = keyValueSet.length; i < len; i++){
                    keyValuePair = keyValueSet[i];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    // check if there is ttl and it's a number
                    if (ttl && typeof ttl !== "number") {
                        _err = this._error("ETTLTYPE");
                        throw _err;
                    }
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                }
                for(j = 0, len1 = keyValueSet.length; j < len1; j++){
                    keyValuePair = keyValueSet[j];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    this.set(key, val, ttl);
                }
                return true;
            }
            del(keys) {
                var delCount, err, i, key, len, oldVal;
                boundMethodCheck(this, NodeCache);
                // convert keys to an array of itself
                if (!Array.isArray(keys)) keys = [
                    keys
                ];
                delCount = 0;
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // only delete if existent
                    if (this.data[key] != null) {
                        // calc the stats
                        this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                        this.stats.ksize -= this._getKeyLength(key);
                        this.stats.keys--;
                        delCount++;
                        // delete the value
                        oldVal = this.data[key];
                        delete this.data[key];
                        // return true
                        this.emit("del", key, oldVal.v);
                    }
                }
                return delCount;
            }
            take(key) {
                var _ret;
                boundMethodCheck(this, NodeCache);
                _ret = this.get(key);
                if (_ret != null) this.del(key);
                return _ret;
            }
            ttl(key, ttl) {
                var err;
                boundMethodCheck(this, NodeCache);
                ttl || (ttl = this.options.stdTTL);
                if (!key) return false;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existent data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    // if ttl < 0 delete the key. otherwise reset the value
                    if (ttl >= 0) this.data[key] = this._wrap(this.data[key].v, ttl, false);
                    else this.del(key);
                    return true;
                } else // return false if key has not been found
                return false;
            }
            getTtl(key) {
                var _ttl, err;
                boundMethodCheck(this, NodeCache);
                if (!key) return void 0;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existant data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    _ttl = this.data[key].t;
                    return _ttl;
                } else // return undefined if key has not been found
                return void 0;
            }
            keys() {
                var _keys;
                boundMethodCheck(this, NodeCache);
                _keys = Object.keys(this.data);
                return _keys;
            }
            has(key) {
                var _exists;
                boundMethodCheck(this, NodeCache);
                _exists = this.data[key] != null && this._check(key, this.data[key]);
                return _exists;
            }
            getStats() {
                boundMethodCheck(this, NodeCache);
                return this.stats;
            }
            flushAll(_startPeriod = true) {
                boundMethodCheck(this, NodeCache);
                // parameter just for testing
                // set data empty
                this.data = {};
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // reset check period
                this._killCheckPeriod();
                this._checkData(_startPeriod);
                this.emit("flush");
            }
            flushStats() {
                boundMethodCheck(this, NodeCache);
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                this.emit("flush_stats");
            }
            close() {
                boundMethodCheck(this, NodeCache);
                this._killCheckPeriod();
            }
            _checkData(startPeriod = true) {
                var key, ref, value;
                boundMethodCheck(this, NodeCache);
                ref = this.data;
                // run the housekeeping method
                for(key in ref){
                    value = ref[key];
                    this._check(key, value);
                }
                if (startPeriod && this.options.checkperiod > 0) {
                    this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1000, startPeriod);
                    if (this.checkTimeout != null && this.checkTimeout.unref != null) this.checkTimeout.unref();
                }
            }
            // ## _killCheckPeriod
            // stop the checkdata period. Only needed to abort the script in testing mode.
            _killCheckPeriod() {
                if (this.checkTimeout != null) return clearTimeout(this.checkTimeout);
            }
            _check(key, data) {
                var _retval;
                boundMethodCheck(this, NodeCache);
                _retval = true;
                // data is invalid if the ttl is too old and is not 0
                // console.log data.t < Date.now(), data.t, Date.now()
                if (data.t !== 0 && data.t < Date.now()) {
                    if (this.options.deleteOnExpire) {
                        _retval = false;
                        this.del(key);
                    }
                    this.emit("expired", key, this._unwrap(data));
                }
                return _retval;
            }
            _isInvalidKey(key) {
                var ref;
                boundMethodCheck(this, NodeCache);
                if (ref = typeof key, indexOf.call(this.validKeyTypes, ref) < 0) return this._error("EKEYTYPE", {
                    type: typeof key
                });
            }
            _wrap(value, ttl, asClone = true) {
                var livetime, now, oReturn, ttlMultiplicator;
                boundMethodCheck(this, NodeCache);
                if (!this.options.useClones) asClone = false;
                // define the time to live
                now = Date.now();
                livetime = 0;
                ttlMultiplicator = 1000;
                // use given ttl
                if (ttl === 0) livetime = 0;
                else if (ttl) livetime = now + ttl * ttlMultiplicator;
                else // use standard ttl
                if (this.options.stdTTL === 0) livetime = this.options.stdTTL;
                else livetime = now + this.options.stdTTL * ttlMultiplicator;
                // return the wrapped value
                return oReturn = {
                    t: livetime,
                    v: asClone ? clone(value) : value
                };
            }
            // ## _unwrap
            // internal method to extract get the value out of the wrapped value
            _unwrap(value, asClone = true) {
                if (!this.options.useClones) asClone = false;
                if (value.v != null) {
                    if (asClone) return clone(value.v);
                    else return value.v;
                }
                return null;
            }
            // ## _getKeyLength
            // internal method the calculate the key length
            _getKeyLength(key) {
                return key.toString().length;
            }
            _getValLength(value) {
                boundMethodCheck(this, NodeCache);
                if (typeof value === "string") // if the value is a String get the real length
                return value.length;
                else if (this.options.forceString) // force string if it's defined and not passed
                return JSON.stringify(value).length;
                else if (Array.isArray(value)) // if the data is an Array multiply each element with a defined default length
                return this.options.arrayValueSize * value.length;
                else if (typeof value === "number") return 8;
                else if (typeof (value != null ? value.then : void 0) === "function") // if the data is a Promise, use defined default
                // (can't calculate actual/resolved value size synchronously)
                return this.options.promiseValueSize;
                else if (typeof $6ac16bf9b3aabf58$require$Buffer !== "undefined" && $6ac16bf9b3aabf58$require$Buffer !== null ? $6ac16bf9b3aabf58$require$Buffer.isBuffer(value) : void 0) return value.length;
                else if (value != null && typeof value === "object") // if the data is an Object multiply each element with a defined default length
                return this.options.objectValueSize * Object.keys(value).length;
                else if (typeof value === "boolean") return 8;
                else // default fallback
                return 0;
            }
            _error(type, data = {}) {
                var error;
                boundMethodCheck(this, NodeCache);
                // generate the error object
                error = new Error();
                error.name = type;
                error.errorcode = type;
                error.message = this.ERRORS[type] != null ? this.ERRORS[type](data) : "-";
                error.data = data;
                // return the error object
                return error;
            }
            _initErrors() {
                var _errMsg, _errT, ref;
                boundMethodCheck(this, NodeCache);
                this.ERRORS = {};
                ref = this._ERRORS;
                for(_errT in ref){
                    _errMsg = ref[_errT];
                    this.ERRORS[_errT] = this.createErrorMessage(_errMsg);
                }
            }
            createErrorMessage(errMsg) {
                return function(args) {
                    return errMsg.replace("__key", args.type);
                };
            }
        }
        NodeCache.prototype._ERRORS = {
            "ENOTFOUND": "Key `__key` not found",
            "ECACHEFULL": "Cache max keys amount exceeded",
            "EKEYTYPE": "The key argument has to be of type `string` or `number`. Found: `__key`",
            "EKEYSTYPE": "The keys argument has to be an array.",
            "ETTLTYPE": "The ttl argument has to be a number."
        };
        return NodeCache;
    }).call(this);
}).call(module.exports);

});
parcelRegister("kPPno", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $f2b06c58c4dfc0fa$export$a143d493d941bafc, (v) => $f2b06c58c4dfc0fa$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $f2b06c58c4dfc0fa$export$e4cf37d7f6fb9e0a, (v) => $f2b06c58c4dfc0fa$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $f2b06c58c4dfc0fa$export$f99ded8fe4b79145, (v) => $f2b06c58c4dfc0fa$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $f2b06c58c4dfc0fa$export$599f31c3813fae4d, (v) => $f2b06c58c4dfc0fa$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f2b06c58c4dfc0fa$export$a143d493d941bafc;
var $f2b06c58c4dfc0fa$export$e4cf37d7f6fb9e0a;
var $f2b06c58c4dfc0fa$export$f99ded8fe4b79145;
var $f2b06c58c4dfc0fa$export$599f31c3813fae4d;
'use strict';

var $5tNIJ = parcelRequire("5tNIJ");

var $O2uLV = parcelRequire("O2uLV");
var $f2b06c58c4dfc0fa$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f2b06c58c4dfc0fa$export$a143d493d941bafc = $f2b06c58c4dfc0fa$var$Buffer;
$f2b06c58c4dfc0fa$export$e4cf37d7f6fb9e0a = $f2b06c58c4dfc0fa$var$SlowBuffer;
$f2b06c58c4dfc0fa$export$f99ded8fe4b79145 = 50;
var $f2b06c58c4dfc0fa$var$K_MAX_LENGTH = 0x7fffffff;
$f2b06c58c4dfc0fa$export$599f31c3813fae4d = $f2b06c58c4dfc0fa$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f2b06c58c4dfc0fa$var$Buffer.TYPED_ARRAY_SUPPORT = $f2b06c58c4dfc0fa$var$typedArraySupport();
if (!$f2b06c58c4dfc0fa$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f2b06c58c4dfc0fa$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f2b06c58c4dfc0fa$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f2b06c58c4dfc0fa$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f2b06c58c4dfc0fa$var$createBuffer(length) {
    if (length > $f2b06c58c4dfc0fa$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f2b06c58c4dfc0fa$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f2b06c58c4dfc0fa$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f2b06c58c4dfc0fa$var$allocUnsafe(arg);
    }
    return $f2b06c58c4dfc0fa$var$from(arg, encodingOrOffset, length);
}
$f2b06c58c4dfc0fa$var$Buffer.poolSize = 8192; // not used by this implementation
function $f2b06c58c4dfc0fa$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f2b06c58c4dfc0fa$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f2b06c58c4dfc0fa$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f2b06c58c4dfc0fa$var$isInstance(value, ArrayBuffer) || value && $f2b06c58c4dfc0fa$var$isInstance(value.buffer, ArrayBuffer)) return $f2b06c58c4dfc0fa$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f2b06c58c4dfc0fa$var$isInstance(value, SharedArrayBuffer) || value && $f2b06c58c4dfc0fa$var$isInstance(value.buffer, SharedArrayBuffer))) return $f2b06c58c4dfc0fa$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f2b06c58c4dfc0fa$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f2b06c58c4dfc0fa$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f2b06c58c4dfc0fa$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f2b06c58c4dfc0fa$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f2b06c58c4dfc0fa$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f2b06c58c4dfc0fa$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f2b06c58c4dfc0fa$var$Buffer, Uint8Array);
function $f2b06c58c4dfc0fa$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f2b06c58c4dfc0fa$var$alloc(size, fill, encoding) {
    $f2b06c58c4dfc0fa$var$assertSize(size);
    if (size <= 0) return $f2b06c58c4dfc0fa$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f2b06c58c4dfc0fa$var$createBuffer(size).fill(fill, encoding) : $f2b06c58c4dfc0fa$var$createBuffer(size).fill(fill);
    return $f2b06c58c4dfc0fa$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f2b06c58c4dfc0fa$var$Buffer.alloc = function(size, fill, encoding) {
    return $f2b06c58c4dfc0fa$var$alloc(size, fill, encoding);
};
function $f2b06c58c4dfc0fa$var$allocUnsafe(size) {
    $f2b06c58c4dfc0fa$var$assertSize(size);
    return $f2b06c58c4dfc0fa$var$createBuffer(size < 0 ? 0 : $f2b06c58c4dfc0fa$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f2b06c58c4dfc0fa$var$Buffer.allocUnsafe = function(size) {
    return $f2b06c58c4dfc0fa$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f2b06c58c4dfc0fa$var$Buffer.allocUnsafeSlow = function(size) {
    return $f2b06c58c4dfc0fa$var$allocUnsafe(size);
};
function $f2b06c58c4dfc0fa$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f2b06c58c4dfc0fa$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $f2b06c58c4dfc0fa$var$byteLength(string, encoding) | 0;
    var buf = $f2b06c58c4dfc0fa$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f2b06c58c4dfc0fa$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f2b06c58c4dfc0fa$var$checked(array.length) | 0;
    var buf = $f2b06c58c4dfc0fa$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f2b06c58c4dfc0fa$var$fromArrayView(arrayView) {
    if ($f2b06c58c4dfc0fa$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f2b06c58c4dfc0fa$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f2b06c58c4dfc0fa$var$fromArrayLike(arrayView);
}
function $f2b06c58c4dfc0fa$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f2b06c58c4dfc0fa$var$Buffer.prototype);
    return buf;
}
function $f2b06c58c4dfc0fa$var$fromObject(obj) {
    if ($f2b06c58c4dfc0fa$var$Buffer.isBuffer(obj)) {
        var len = $f2b06c58c4dfc0fa$var$checked(obj.length) | 0;
        var buf = $f2b06c58c4dfc0fa$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f2b06c58c4dfc0fa$var$numberIsNaN(obj.length)) return $f2b06c58c4dfc0fa$var$createBuffer(0);
        return $f2b06c58c4dfc0fa$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f2b06c58c4dfc0fa$var$fromArrayLike(obj.data);
}
function $f2b06c58c4dfc0fa$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f2b06c58c4dfc0fa$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f2b06c58c4dfc0fa$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f2b06c58c4dfc0fa$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f2b06c58c4dfc0fa$var$Buffer.alloc(+length);
}
$f2b06c58c4dfc0fa$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f2b06c58c4dfc0fa$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f2b06c58c4dfc0fa$var$Buffer.compare = function compare(a, b) {
    if ($f2b06c58c4dfc0fa$var$isInstance(a, Uint8Array)) a = $f2b06c58c4dfc0fa$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f2b06c58c4dfc0fa$var$isInstance(b, Uint8Array)) b = $f2b06c58c4dfc0fa$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(a) || !$f2b06c58c4dfc0fa$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f2b06c58c4dfc0fa$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f2b06c58c4dfc0fa$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f2b06c58c4dfc0fa$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f2b06c58c4dfc0fa$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f2b06c58c4dfc0fa$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $f2b06c58c4dfc0fa$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f2b06c58c4dfc0fa$var$byteLength(string, encoding) {
    if ($f2b06c58c4dfc0fa$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f2b06c58c4dfc0fa$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f2b06c58c4dfc0fa$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f2b06c58c4dfc0fa$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f2b06c58c4dfc0fa$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f2b06c58c4dfc0fa$var$Buffer.byteLength = $f2b06c58c4dfc0fa$var$byteLength;
function $f2b06c58c4dfc0fa$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f2b06c58c4dfc0fa$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f2b06c58c4dfc0fa$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f2b06c58c4dfc0fa$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f2b06c58c4dfc0fa$var$latin1Slice(this, start, end);
        case 'base64':
            return $f2b06c58c4dfc0fa$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f2b06c58c4dfc0fa$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f2b06c58c4dfc0fa$var$Buffer.prototype._isBuffer = true;
function $f2b06c58c4dfc0fa$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$f2b06c58c4dfc0fa$var$swap(this, i, i + 1);
    return this;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $f2b06c58c4dfc0fa$var$swap(this, i, i + 3);
        $f2b06c58c4dfc0fa$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $f2b06c58c4dfc0fa$var$swap(this, i, i + 7);
        $f2b06c58c4dfc0fa$var$swap(this, i + 1, i + 6);
        $f2b06c58c4dfc0fa$var$swap(this, i + 2, i + 5);
        $f2b06c58c4dfc0fa$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f2b06c58c4dfc0fa$var$utf8Slice(this, 0, length);
    return $f2b06c58c4dfc0fa$var$slowToString.apply(this, arguments);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.toLocaleString = $f2b06c58c4dfc0fa$var$Buffer.prototype.toString;
$f2b06c58c4dfc0fa$var$Buffer.prototype.equals = function equals(b) {
    if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f2b06c58c4dfc0fa$var$Buffer.compare(this, b) === 0;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $f2b06c58c4dfc0fa$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f2b06c58c4dfc0fa$var$customInspectSymbol) $f2b06c58c4dfc0fa$var$Buffer.prototype[$f2b06c58c4dfc0fa$var$customInspectSymbol] = $f2b06c58c4dfc0fa$var$Buffer.prototype.inspect;
$f2b06c58c4dfc0fa$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f2b06c58c4dfc0fa$var$isInstance(target, Uint8Array)) target = $f2b06c58c4dfc0fa$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f2b06c58c4dfc0fa$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($f2b06c58c4dfc0fa$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f2b06c58c4dfc0fa$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f2b06c58c4dfc0fa$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f2b06c58c4dfc0fa$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f2b06c58c4dfc0fa$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f2b06c58c4dfc0fa$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f2b06c58c4dfc0fa$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f2b06c58c4dfc0fa$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f2b06c58c4dfc0fa$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f2b06c58c4dfc0fa$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f2b06c58c4dfc0fa$var$utf8Write(buf, string, offset, length) {
    return $f2b06c58c4dfc0fa$var$blitBuffer($f2b06c58c4dfc0fa$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f2b06c58c4dfc0fa$var$asciiWrite(buf, string, offset, length) {
    return $f2b06c58c4dfc0fa$var$blitBuffer($f2b06c58c4dfc0fa$var$asciiToBytes(string), buf, offset, length);
}
function $f2b06c58c4dfc0fa$var$base64Write(buf, string, offset, length) {
    return $f2b06c58c4dfc0fa$var$blitBuffer($f2b06c58c4dfc0fa$var$base64ToBytes(string), buf, offset, length);
}
function $f2b06c58c4dfc0fa$var$ucs2Write(buf, string, offset, length) {
    return $f2b06c58c4dfc0fa$var$blitBuffer($f2b06c58c4dfc0fa$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f2b06c58c4dfc0fa$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f2b06c58c4dfc0fa$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f2b06c58c4dfc0fa$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f2b06c58c4dfc0fa$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f2b06c58c4dfc0fa$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f2b06c58c4dfc0fa$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5tNIJ.fromByteArray(buf);
    else return $5tNIJ.fromByteArray(buf.slice(start, end));
}
function $f2b06c58c4dfc0fa$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f2b06c58c4dfc0fa$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f2b06c58c4dfc0fa$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f2b06c58c4dfc0fa$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f2b06c58c4dfc0fa$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f2b06c58c4dfc0fa$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f2b06c58c4dfc0fa$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f2b06c58c4dfc0fa$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f2b06c58c4dfc0fa$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $f2b06c58c4dfc0fa$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f2b06c58c4dfc0fa$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f2b06c58c4dfc0fa$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f2b06c58c4dfc0fa$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUintLE = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUintBE = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUint8 = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUint16LE = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUint16BE = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUint32LE = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readUint32BE = $f2b06c58c4dfc0fa$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 4, this.length);
    return $O2uLV.read(this, offset, true, 23, 4);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 4, this.length);
    return $O2uLV.read(this, offset, false, 23, 4);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 8, this.length);
    return $O2uLV.read(this, offset, true, 52, 8);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkOffset(offset, 8, this.length);
    return $O2uLV.read(this, offset, false, 52, 8);
};
function $f2b06c58c4dfc0fa$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUintLE = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUintBE = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUint8 = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUint16LE = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUint16BE = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUint32LE = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeUint32BE = $f2b06c58c4dfc0fa$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f2b06c58c4dfc0fa$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f2b06c58c4dfc0fa$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $O2uLV.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f2b06c58c4dfc0fa$var$writeFloat(this, value, offset, true, noAssert);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f2b06c58c4dfc0fa$var$writeFloat(this, value, offset, false, noAssert);
};
function $f2b06c58c4dfc0fa$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2b06c58c4dfc0fa$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $O2uLV.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f2b06c58c4dfc0fa$var$writeDouble(this, value, offset, true, noAssert);
};
$f2b06c58c4dfc0fa$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f2b06c58c4dfc0fa$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f2b06c58c4dfc0fa$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f2b06c58c4dfc0fa$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f2b06c58c4dfc0fa$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f2b06c58c4dfc0fa$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f2b06c58c4dfc0fa$var$Buffer.isBuffer(val) ? val : $f2b06c58c4dfc0fa$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $f2b06c58c4dfc0fa$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f2b06c58c4dfc0fa$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f2b06c58c4dfc0fa$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f2b06c58c4dfc0fa$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f2b06c58c4dfc0fa$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f2b06c58c4dfc0fa$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f2b06c58c4dfc0fa$var$base64ToBytes(str) {
    return $5tNIJ.toByteArray($f2b06c58c4dfc0fa$var$base64clean(str));
}
function $f2b06c58c4dfc0fa$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f2b06c58c4dfc0fa$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f2b06c58c4dfc0fa$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f2b06c58c4dfc0fa$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("5tNIJ", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $3fd63aa5cccb6865$export$d622b2ad8d90c771, (v) => $3fd63aa5cccb6865$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $3fd63aa5cccb6865$export$6100ba28696e12de, (v) => $3fd63aa5cccb6865$export$6100ba28696e12de = v);
var $3fd63aa5cccb6865$export$a48f0734ac7c2329;
var $3fd63aa5cccb6865$export$d622b2ad8d90c771;
var $3fd63aa5cccb6865$export$6100ba28696e12de;
'use strict';
$3fd63aa5cccb6865$export$a48f0734ac7c2329 = $3fd63aa5cccb6865$var$byteLength;
$3fd63aa5cccb6865$export$d622b2ad8d90c771 = $3fd63aa5cccb6865$var$toByteArray;
$3fd63aa5cccb6865$export$6100ba28696e12de = $3fd63aa5cccb6865$var$fromByteArray;
var $3fd63aa5cccb6865$var$lookup = [];
var $3fd63aa5cccb6865$var$revLookup = [];
var $3fd63aa5cccb6865$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3fd63aa5cccb6865$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3fd63aa5cccb6865$var$i = 0, $3fd63aa5cccb6865$var$len = $3fd63aa5cccb6865$var$code.length; $3fd63aa5cccb6865$var$i < $3fd63aa5cccb6865$var$len; ++$3fd63aa5cccb6865$var$i){
    $3fd63aa5cccb6865$var$lookup[$3fd63aa5cccb6865$var$i] = $3fd63aa5cccb6865$var$code[$3fd63aa5cccb6865$var$i];
    $3fd63aa5cccb6865$var$revLookup[$3fd63aa5cccb6865$var$code.charCodeAt($3fd63aa5cccb6865$var$i)] = $3fd63aa5cccb6865$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3fd63aa5cccb6865$var$revLookup['-'.charCodeAt(0)] = 62;
$3fd63aa5cccb6865$var$revLookup['_'.charCodeAt(0)] = 63;
function $3fd63aa5cccb6865$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3fd63aa5cccb6865$var$byteLength(b64) {
    var lens = $3fd63aa5cccb6865$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3fd63aa5cccb6865$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3fd63aa5cccb6865$var$toByteArray(b64) {
    var tmp;
    var lens = $3fd63aa5cccb6865$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3fd63aa5cccb6865$var$Arr($3fd63aa5cccb6865$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i)] << 18 | $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i)] << 2 | $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i)] << 10 | $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3fd63aa5cccb6865$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3fd63aa5cccb6865$var$tripletToBase64(num) {
    return $3fd63aa5cccb6865$var$lookup[num >> 18 & 0x3F] + $3fd63aa5cccb6865$var$lookup[num >> 12 & 0x3F] + $3fd63aa5cccb6865$var$lookup[num >> 6 & 0x3F] + $3fd63aa5cccb6865$var$lookup[num & 0x3F];
}
function $3fd63aa5cccb6865$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3fd63aa5cccb6865$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3fd63aa5cccb6865$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3fd63aa5cccb6865$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3fd63aa5cccb6865$var$lookup[tmp >> 2] + $3fd63aa5cccb6865$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3fd63aa5cccb6865$var$lookup[tmp >> 10] + $3fd63aa5cccb6865$var$lookup[tmp >> 4 & 0x3F] + $3fd63aa5cccb6865$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("O2uLV", function(module, exports) {
$parcel$export(module.exports, "read", () => $09669b25415ca9bd$export$aafa59e2e03f2942, (v) => $09669b25415ca9bd$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $09669b25415ca9bd$export$68d8715fc104d294, (v) => $09669b25415ca9bd$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $09669b25415ca9bd$export$aafa59e2e03f2942;
var $09669b25415ca9bd$export$68d8715fc104d294;
$09669b25415ca9bd$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$09669b25415ca9bd$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6nn7o", function(module, exports) {

var $kPPno = parcelRequire("kPPno");
var $4a46d2d99bb0752a$require$Buffer = $kPPno.Buffer;
var $4a46d2d99bb0752a$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $4a46d2d99bb0752a$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $4a46d2d99bb0752a$require$Buffer.isBuffer(parent)) {
                if ($4a46d2d99bb0752a$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $4a46d2d99bb0752a$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $4a46d2d99bb0752a$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (module.exports) module.exports = $4a46d2d99bb0752a$var$clone;

});

parcelRegister("hylEy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $cc766883b33c63f6$var$R = typeof Reflect === 'object' ? Reflect : null;
var $cc766883b33c63f6$var$ReflectApply = $cc766883b33c63f6$var$R && typeof $cc766883b33c63f6$var$R.apply === 'function' ? $cc766883b33c63f6$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $cc766883b33c63f6$var$ReflectOwnKeys;
if ($cc766883b33c63f6$var$R && typeof $cc766883b33c63f6$var$R.ownKeys === 'function') $cc766883b33c63f6$var$ReflectOwnKeys = $cc766883b33c63f6$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $cc766883b33c63f6$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $cc766883b33c63f6$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $cc766883b33c63f6$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $cc766883b33c63f6$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $cc766883b33c63f6$var$EventEmitter() {
    $cc766883b33c63f6$var$EventEmitter.init.call(this);
}
module.exports = $cc766883b33c63f6$var$EventEmitter;
module.exports.once = $cc766883b33c63f6$var$once;
// Backwards-compat with node 0.10.x
$cc766883b33c63f6$var$EventEmitter.EventEmitter = $cc766883b33c63f6$var$EventEmitter;
$cc766883b33c63f6$var$EventEmitter.prototype._events = undefined;
$cc766883b33c63f6$var$EventEmitter.prototype._eventsCount = 0;
$cc766883b33c63f6$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $cc766883b33c63f6$var$defaultMaxListeners = 10;
function $cc766883b33c63f6$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($cc766883b33c63f6$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $cc766883b33c63f6$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $cc766883b33c63f6$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $cc766883b33c63f6$var$defaultMaxListeners = arg;
    }
});
$cc766883b33c63f6$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$cc766883b33c63f6$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $cc766883b33c63f6$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $cc766883b33c63f6$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $cc766883b33c63f6$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$cc766883b33c63f6$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $cc766883b33c63f6$var$_getMaxListeners(this);
};
$cc766883b33c63f6$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $cc766883b33c63f6$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $cc766883b33c63f6$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$cc766883b33c63f6$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $cc766883b33c63f6$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $cc766883b33c63f6$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $cc766883b33c63f6$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $cc766883b33c63f6$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$cc766883b33c63f6$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $cc766883b33c63f6$var$_addListener(this, type, listener, false);
};
$cc766883b33c63f6$var$EventEmitter.prototype.on = $cc766883b33c63f6$var$EventEmitter.prototype.addListener;
$cc766883b33c63f6$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $cc766883b33c63f6$var$_addListener(this, type, listener, true);
};
function $cc766883b33c63f6$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $cc766883b33c63f6$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $cc766883b33c63f6$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$cc766883b33c63f6$var$EventEmitter.prototype.once = function once(type, listener) {
    $cc766883b33c63f6$var$checkListener(listener);
    this.on(type, $cc766883b33c63f6$var$_onceWrap(this, type, listener));
    return this;
};
$cc766883b33c63f6$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $cc766883b33c63f6$var$checkListener(listener);
    this.prependListener(type, $cc766883b33c63f6$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$cc766883b33c63f6$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $cc766883b33c63f6$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $cc766883b33c63f6$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$cc766883b33c63f6$var$EventEmitter.prototype.off = $cc766883b33c63f6$var$EventEmitter.prototype.removeListener;
$cc766883b33c63f6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $cc766883b33c63f6$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $cc766883b33c63f6$var$unwrapListeners(evlistener) : $cc766883b33c63f6$var$arrayClone(evlistener, evlistener.length);
}
$cc766883b33c63f6$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $cc766883b33c63f6$var$_listeners(this, type, true);
};
$cc766883b33c63f6$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $cc766883b33c63f6$var$_listeners(this, type, false);
};
$cc766883b33c63f6$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $cc766883b33c63f6$var$listenerCount.call(emitter, type);
};
$cc766883b33c63f6$var$EventEmitter.prototype.listenerCount = $cc766883b33c63f6$var$listenerCount;
function $cc766883b33c63f6$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$cc766883b33c63f6$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $cc766883b33c63f6$var$ReflectOwnKeys(this._events) : [];
};
function $cc766883b33c63f6$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $cc766883b33c63f6$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $cc766883b33c63f6$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $cc766883b33c63f6$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $cc766883b33c63f6$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $cc766883b33c63f6$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $cc766883b33c63f6$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $cc766883b33c63f6$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $cc766883b33c63f6$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("4MjGQ", function(module, exports) {
$parcel$export(module.exports, "AnalyticsActionSubjects", () => $377661ab67d6f1ac$export$5378e27bf4bd9964);
$parcel$export(module.exports, "AnalyticsTrackActions", () => $377661ab67d6f1ac$export$66cb7b42e8abaf2a);
$parcel$export(module.exports, "trackIssueEvent", () => $377661ab67d6f1ac$export$a5fa4cf2c5c28270);
$parcel$export(module.exports, "trackIssueEventNext", () => $377661ab67d6f1ac$export$3967c914d9a6a7eb);
$parcel$export(module.exports, "trackRequestCreateNonGenericErrors", () => $377661ab67d6f1ac$export$6d75dc6487ba0729);
$parcel$export(module.exports, "firstInteraction", () => $377661ab67d6f1ac$export$f90e311dc845e78d);
$parcel$export(module.exports, "uiEvent", () => $377661ab67d6f1ac$export$62d6d0288077e3fc);
$parcel$export(module.exports, "operationalEvent", () => $377661ab67d6f1ac$export$396108a0e963cc78);
$parcel$export(module.exports, "ConnectRequestCreateEventType", () => $377661ab67d6f1ac$export$814045484cc5c60c);
$parcel$export(module.exports, "sendConnectTimeoutEventForRequestCreation", () => $377661ab67d6f1ac$export$bd82f0e8f384bdee);
$parcel$export(module.exports, "composeAnalyticsEvent", () => $377661ab67d6f1ac$export$812115af7f978952);

var $aYMdQ = parcelRequire("aYMdQ");

var $eENmG = parcelRequire("eENmG");

var $9mazR = parcelRequire("9mazR");

var $7wx9B = parcelRequire("7wx9B");

var $6lbrU = parcelRequire("6lbrU");
var $377661ab67d6f1ac$export$5378e27bf4bd9964 = /*#__PURE__*/ function(AnalyticsActionSubjects) {
    AnalyticsActionSubjects["ISSUE"] = "issue";
    AnalyticsActionSubjects["FORM"] = "form";
    AnalyticsActionSubjects["COMMENT"] = "comment";
    AnalyticsActionSubjects["REQUEST_TYPE"] = "issueType";
    AnalyticsActionSubjects["REQUEST_TYPE_GROUP"] = "requestTypeGroup";
    return AnalyticsActionSubjects;
}({});
var $377661ab67d6f1ac$export$66cb7b42e8abaf2a = /*#__PURE__*/ function(AnalyticsTrackActions) {
    AnalyticsTrackActions["CREATED"] = "created";
    AnalyticsTrackActions["DELETED"] = "deleted";
    AnalyticsTrackActions["UPDATED"] = "updated";
    AnalyticsTrackActions["VIEWED"] = "viewed";
    AnalyticsTrackActions["FETCHED"] = "fetched";
    AnalyticsTrackActions["CREATED_FAILURE"] = "created_failure";
    AnalyticsTrackActions["DELETED_FAILURE"] = "deleted_failure";
    AnalyticsTrackActions["UPDATED_FAILURE"] = "updated_failure";
    AnalyticsTrackActions["FETCHED_FAILURE"] = "fetched_failure";
    return AnalyticsTrackActions;
}({});
var $377661ab67d6f1ac$export$3b99c8679ca910fe = /*#__PURE__*/ function(AnalyticsUIActions) {
    AnalyticsUIActions["CLICKED"] = "clicked";
    return AnalyticsUIActions;
}({});
const $377661ab67d6f1ac$var$defaultTrackData = {
    source: 'portalScreen'
};
const $377661ab67d6f1ac$var$issueTrackData = {
    ...$377661ab67d6f1ac$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "issue"
};
function $377661ab67d6f1ac$var$getUserRole(user, portal) {
    if (user.getAccountId()) {
        if (portal && portal.getPortalAnnouncement().getCanAdministerProject()) return 'agent-project-admin';
        if (user.getAgentForPortal()) return 'agent';
        return 'customer';
    }
    return 'anonymous';
}
const $377661ab67d6f1ac$var$getDefaultAttributes = (user, portal)=>({
        attributes: {
            jsdRole: $377661ab67d6f1ac$var$getUserRole(user, portal),
            projectType: 'serviceDesk'
        }
    });
function $377661ab67d6f1ac$export$a5fa4cf2c5c28270(data, user, portal) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $aYMdQ.defaultsDeep)($377661ab67d6f1ac$var$getDefaultAttributes(user, portal), $377661ab67d6f1ac$var$issueTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackIssueEvent: failed to send analytics data', err);
        }
    }
}
function $377661ab67d6f1ac$export$3967c914d9a6a7eb(data, user, createAnalyticsEvent, portal) {
    try {
        const trackData = {
            analyticsType: 'TRACK',
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            ...$377661ab67d6f1ac$var$issueTrackData,
            ...$377661ab67d6f1ac$var$getDefaultAttributes(user, portal).attributes,
            ...data.attributes
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.fire();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('trackIssueEventNext: failed to send analytics data', err);
    }
}
function $377661ab67d6f1ac$export$6d75dc6487ba0729(errors, createAnalyticsEvent) {
    if (!createAnalyticsEvent) return;
    try {
        // Refrain from passing error messages from fieldError and submissionError to avoid PII logging
        const { errorReasonKey: errorReasonKey, traceId: traceId, fieldErrors: fieldErrors = {}, submissionError: submissionError = {} } = errors;
        const trackData = {
            errorReasonKey: errorReasonKey,
            traceId: traceId,
            hasSubmissionErrors: Object.keys(submissionError).length > 0,
            hasFieldErrors: Object.keys(fieldErrors).length > 0,
            analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
            action: 'failed',
            actionSubject: 'requestCreateNonGenericError'
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.context.push({
            componentName: 'requestCreateNonGenericError'
        });
        analyticsEvent.fire();
    } catch (err) {
        (0, $7wx9B.reportError)(err, {
            message: 'trackRequestCreateNonGenericErrors: failed to send analytics data'
        });
    }
}
let $377661ab67d6f1ac$var$firstInteractionTracked = false;
function $377661ab67d6f1ac$export$f90e311dc845e78d(data) {
    // In the interest of not spamming the analytics server, we try to limit this request to one per tab.
    // This does not guarantee that there is only 1 event fired per interaction as the user can start interaction on a separate tab
    if (!$377661ab67d6f1ac$var$firstInteractionTracked) {
        $377661ab67d6f1ac$var$firstInteractionTracked = true;
        const combinedData = {
            action: 'firstPortalMeaningfulInteraction',
            actionSubject: data.actionSubject,
            source: data.source,
            attributes: {
                isNewPortal: String(!!data.isNewPortal)
            }
        };
        $377661ab67d6f1ac$export$62d6d0288077e3fc(combinedData);
    }
}
function $377661ab67d6f1ac$export$62d6d0288077e3fc(data) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $aYMdQ.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendUIEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('uiEvent: failed to send analytics data', err);
        }
    }
}
function $377661ab67d6f1ac$export$396108a0e963cc78(data) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $aYMdQ.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendOperationalEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('operationalEvent: failed to send analytics data', err);
        }
    }
}
const $377661ab67d6f1ac$var$commentTrackData = {
    ...$377661ab67d6f1ac$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "comment"
};
function $377661ab67d6f1ac$export$ef4b02ed2d124f10(data, user, portal) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $aYMdQ.defaultsDeep)($377661ab67d6f1ac$var$getDefaultAttributes(user, portal), $377661ab67d6f1ac$var$commentTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            actionSubjectId: data.commentId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackCommentEvent: failed to send analytics data', err);
        }
    }
}
var $377661ab67d6f1ac$export$814045484cc5c60c = /*#__PURE__*/ function(ConnectRequestCreateEventType) {
    ConnectRequestCreateEventType["VALIDATE"] = "connectValidationTimedOut";
    ConnectRequestCreateEventType["SERIALIZE"] = "connectSerializationTimedOut";
    ConnectRequestCreateEventType["LEGACY"] = "connectValidationOrSerializationTimedOut";
    return ConnectRequestCreateEventType;
}({});
function $377661ab67d6f1ac$export$bd82f0e8f384bdee(eventType, connectKey, requestTypeId) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) try {
        const event = {
            actionSubject: 'connectKey.requestType',
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            actionSubjectId: `${connectKey}.${requestTypeId}`
        };
        if (eventType === "connectValidationOrSerializationTimedOut") {
            event.actionSubject = 'requestType';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            event.actionSubjectId = `${requestTypeId}`;
        }
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsWebClient.getInstance().sendOperationalEvent({
            action: eventType,
            actionSubject: event.actionSubject,
            actionSubjectId: event.actionSubjectId,
            source: (0, $9mazR.ScreenName).REQUEST_CREATE
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('sendConnectTimeoutEventForRequestCreation: failed to send analytics data', err);
    }
}
const $377661ab67d6f1ac$export$812115af7f978952 = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent) return createAnalyticsEvent({
            analyticsType: payload.analyticsType,
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: payload.actionSubjectId,
            ...payload.attributes
        });
        return undefined;
    };

});

parcelRegister("bKaMP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1545f4fa3ca6583$export$2e2bcd8739ae039);
/**
 * Util to help pre-fetching of initial model data
 */ 
var $him7m = parcelRequire("him7m");

var $cf3fd = parcelRequire("cf3fd");
let $a1545f4fa3ca6583$var$cachedObject;
var $a1545f4fa3ca6583$export$2e2bcd8739ae039 = ()=>{
    const jsonPayload = (0, $him7m.default).getElementById('jsonPayload');
    if (!$a1545f4fa3ca6583$var$cachedObject) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $a1545f4fa3ca6583$var$cachedObject = jsonPayload && jsonPayload.textContent && JSON.parse(jsonPayload.textContent) || {};
    if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)()) {
        delete $a1545f4fa3ca6583$var$cachedObject.helpCenterBranding;
        delete $a1545f4fa3ca6583$var$cachedObject.featuredAndSortedPortals;
        delete $a1545f4fa3ca6583$var$cachedObject.loginAnnouncements;
    }
    return $a1545f4fa3ca6583$var$cachedObject;
};
const $a1545f4fa3ca6583$export$246d7bb795c4c0e = ()=>{
    $a1545f4fa3ca6583$var$cachedObject = undefined;
};

});


parcelRegister("gq5Zl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc33ee9e6c14e774$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $pMGlN = parcelRequire("pMGlN");


var $bc33ee9e6c14e774$export$2e2bcd8739ae039 = (0, $pMGlN.default);

});
parcelRegister("pMGlN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec621f0d1ab1a226$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $h0ns1 = parcelRequire("h0ns1");

var $eUgRu = parcelRequire("eUgRu");

var $dRkX9 = parcelRequire("dRkX9");

var $jR7cM = parcelRequire("jR7cM");

var $5hPkM = parcelRequire("5hPkM");

var $9JxdC = parcelRequire("9JxdC");

var $f4Vz4 = parcelRequire("f4Vz4");

var $3qhoF = parcelRequire("3qhoF");

var $9UyEJ = parcelRequire("9UyEJ");

var $8o5rd = parcelRequire("8o5rd");

var $jQYQa = parcelRequire("jQYQa");

var $7jb5s = parcelRequire("7jb5s");

var $hl3ar = parcelRequire("hl3ar");

var $2JgUl = parcelRequire("2JgUl");

var $7M4Z9 = parcelRequire("7M4Z9");

var $7RnBA = parcelRequire("7RnBA");
let $ec621f0d1ab1a226$var$tryCompleteHandle;
/** A portion of the page we apply measurement to */ const $ec621f0d1ab1a226$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party', excludeFromMetrics: excludeFromMetrics = false })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $5hPkM.isUFOEnabled)();
    const parentContext = (0, $fc4bM.useContext)((0, $9UyEJ.default));
    const segmentIdMap = (0, $fc4bM.useMemo)(()=>{
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $fc4bM.useMemo)(()=>{
        if (mode === 'single') return (0, $hl3ar.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $hl3ar.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $fc4bM.useMemo)(()=>{
        // Only stamp `excludeFromMetrics` alongside a third-party type.
        // So it can never remove first-party work from metrics.
        const label = {
            name: segmentName,
            segmentId: segmentId,
            ...type !== 'first-party' ? {
                type: type
            } : {},
            // Only pass non-default types (not 'first-party') in payload to reduce size
            ...excludeFromMetrics && type === 'third-party' ? {
                excludeFromMetrics: true
            } : {}
        };
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [
            ...parentContext.labelStack,
            label
        ] : [
            label
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type,
        excludeFromMetrics
    ]);
    const interactionId = (0, $fc4bM.useContext)((0, $8o5rd.default));
    const interactionContext = (0, $fc4bM.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($ec621f0d1ab1a226$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($ec621f0d1ab1a226$var$tryCompleteHandle);
                    }
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            const isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $ec621f0d1ab1a226$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $ec621f0d1ab1a226$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $jQYQa.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $jQYQa.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    if ((0, $dRkX9.fg)('platform_ufo_native_task_scheduling')) (0, $2JgUl.default)(onComplete);
                    else (0, $h0ns1.unstable_scheduleCallback)((0, $h0ns1.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $jQYQa.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $jQYQa.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $jQYQa.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $5hPkM.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $5hPkM.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    const activeInteraction = (0, $jQYQa.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $jQYQa.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $5hPkM.getInteractionRate)(name, 'press');
                if ((0, $jR7cM.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $eUgRu.default)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $3qhoF.setInteractionActiveTrace)(newId, 'press');
                    (0, $jQYQa.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $7jb5s.default).current, (0, $f4Vz4.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $jQYQa.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $jQYQa.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $jQYQa.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $jQYQa.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $jQYQa.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $jQYQa.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $jQYQa.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $jQYQa.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $7M4Z9.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $fc4bM.useRef)(false);
    const onRender = (0, $fc4bM.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $5hPkM.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $fc4bM.useEffect)(()=>{
        (0, $jQYQa.addSegment)(labelStack);
        return ()=>{
            (0, $jQYQa.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $fc4bM.useMemo)(()=>labelStack.map((l)=>(0, $9JxdC.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9UyEJ.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7RnBA.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
$ec621f0d1ab1a226$var$UFOSegment.displayName = 'UFOSegment';
var $ec621f0d1ab1a226$export$2e2bcd8739ae039 = $ec621f0d1ab1a226$var$UFOSegment;

});
parcelRegister("3qhoF", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $d8caf297839f9a68$export$f2e521e495a88544);

var $19od8 = parcelRequire("19od8");

var $62qKR = parcelRequire("62qKR");
function $d8caf297839f9a68$export$f2e521e495a88544(interactionId, experienceType) {
    (0, $62qKR.setActiveTrace)(interactionId.replace(/-/g, ''), (0, $19od8.generateSpanId)(), experienceType);
}

});
parcelRegister("19od8", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $ea58a15c835aef0c$export$295213bc4d0c54ad);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
function $ea58a15c835aef0c$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("62qKR", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $800902634b02a519$export$a1002be327997103);

var $fgh8a = parcelRequire("fgh8a");

var $dRkX9 = parcelRequire("dRkX9");

var $LzvBG = parcelRequire("LzvBG");

var $gX41G = parcelRequire("gX41G");

var $cagIi = parcelRequire("cagIi");

var $fagaO = parcelRequire("fagaO");

var $4rFZM = parcelRequire("4rFZM");
function $800902634b02a519$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $dRkX9.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $fgh8a.ROOT_CONTEXT).setValue((0, $4rFZM.traceIdKey), traceId).setValue((0, $cagIi.spanIdKey), spanId).setValue((0, $gX41G.experienceTypeKey), type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $LzvBG.getContextManager)() instanceof (0, $LzvBG.UFOContextManager)) {
            let contextManager = (0, $LzvBG.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else (0, $fagaO.state).context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}

});


parcelRegister("9UyEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a372bc0f31db89$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fVzQQ = parcelRequire("fVzQQ");

var $02a372bc0f31db89$export$2e2bcd8739ae039 = (0, $fVzQQ.default);

});

parcelRegister("8o5rd", function(module, exports) {
$parcel$export(module.exports, "default", () => $68294c4141dde679$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fc4bM = parcelRequire("fc4bM");

var $7bB5V = parcelRequire("7bB5V");



// We use a context to allow modals to have their own lifecycle
const $68294c4141dde679$var$interactionContext = (0, $fc4bM.createContext)((0, $7bB5V.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$68294c4141dde679$export$2e2bcd8739ae039 = $68294c4141dde679$var$interactionContext;

});

parcelRegister("hl3ar", function(module, exports) {
$parcel$export(module.exports, "default", () => $0619033f038446b3$export$2e2bcd8739ae039);
function $0619033f038446b3$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $0619033f038446b3$export$2e2bcd8739ae039 = $0619033f038446b3$var$generateId;

});

parcelRegister("2JgUl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bd5d3fe4e44dbb3$export$2e2bcd8739ae039);
const $0bd5d3fe4e44dbb3$var$getNativeScheduler = ()=>{
    const nativeScheduler = globalThis.scheduler;
    return typeof (nativeScheduler === null || nativeScheduler === void 0 ? void 0 : nativeScheduler.postTask) === 'function' ? nativeScheduler : undefined;
};
/**
 * Schedules `callback` as a normal-priority macrotask using native browser APIs.
 *
 * Native replacement for `unstable_scheduleCallback(unstable_NormalPriority, callback)` from the
 * `scheduler` npm package, which is being removed for React 19 compatibility.
 *
 * - Prefers the Prioritized Task Scheduling API (`scheduler.postTask`) with `user-visible`
 *   priority, the native equivalent of React's `NormalPriority`.
 *   https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
 * - Falls back to `setTimeout(callback, 0)` where `postTask` is unavailable (e.g. Safari, SSR).
 *
 * Note: unlike the `scheduler` package, this does not share React's internal task queue, so the
 * callback is not guaranteed to run after already-queued React work of the same priority.
 */ function $0bd5d3fe4e44dbb3$var$scheduleNormalPriorityTask(callback) {
    const nativeScheduler = $0bd5d3fe4e44dbb3$var$getNativeScheduler();
    if (nativeScheduler) {
        nativeScheduler.postTask(callback, {
            priority: 'user-visible'
        });
        return;
    }
    setTimeout(callback, 0);
}
var $0bd5d3fe4e44dbb3$export$2e2bcd8739ae039 = $0bd5d3fe4e44dbb3$var$scheduleNormalPriorityTask;

});

parcelRegister("7M4Z9", function(module, exports) {
$parcel$export(module.exports, "default", () => $768c84b969bafc54$export$2e2bcd8739ae039);

var $3jCFs = parcelRequire("3jCFs");
function $768c84b969bafc54$var$scheduleOnPaint(callback) {
    var _process, _globalThis$document;
    const isSSR = typeof window === 'undefined' || Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $3jCFs !== 'undefined' && Boolean((_process = $3jCFs) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $768c84b969bafc54$export$2e2bcd8739ae039 = $768c84b969bafc54$var$scheduleOnPaint;

});

parcelRegister("7RnBA", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e5e56923dd441f2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bIcU7 = parcelRequire("bIcU7");

var $cXnTD = parcelRequire("cXnTD");

var $3jCFs = parcelRequire("3jCFs");
var $2e5e56923dd441f2$var$_process;
const $2e5e56923dd441f2$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $3jCFs !== 'undefined' && Boolean((($2e5e56923dd441f2$var$_process = $3jCFs) === null || $2e5e56923dd441f2$var$_process === void 0 || ($2e5e56923dd441f2$var$_process = $2e5e56923dd441f2$var$_process.env) === null || $2e5e56923dd441f2$var$_process === void 0 ? void 0 : $2e5e56923dd441f2$var$_process.REACT_SSR) || false);
const $2e5e56923dd441f2$var$SsrRenderProfiler = (props)=>{
    if ($2e5e56923dd441f2$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cXnTD.SsrRenderProfilerInner), props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bIcU7.ProfilerMarker), null), props.children);
};
var $2e5e56923dd441f2$export$2e2bcd8739ae039 = $2e5e56923dd441f2$var$SsrRenderProfiler;

});
parcelRegister("bIcU7", function(module, exports) {
$parcel$export(module.exports, "ProfilerMarker", () => $113201a6e133cb44$export$18d523e2a9aac2d9);
const $113201a6e133cb44$export$18d523e2a9aac2d9 = ({ onRender: onRender })=>{
    onRender === null || onRender === void 0 || onRender();
    return null;
};

});

parcelRegister("cXnTD", function(module, exports) {
$parcel$export(module.exports, "SsrRenderProfilerInner", () => $38fbdea5321741f4$export$b8bd105b650b1c1e);

var $fc4bM = parcelRequire("fc4bM");

var $5hPkM = parcelRequire("5hPkM");

var $9JxdC = parcelRequire("9JxdC");

var $jQYQa = parcelRequire("jQYQa");

var $8NwjI = parcelRequire("8NwjI");

var $bIcU7 = parcelRequire("bIcU7");

var $koZIF = parcelRequire("koZIF");
function $38fbdea5321741f4$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    const activeInteractionId = (_getActiveInteraction = (0, $jQYQa.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!(0, $koZIF.default).lastActiveInteraction && (0, $koZIF.default).lastActiveInteraction !== activeInteractionId) (0, $8NwjI.clearState)();
    (0, $koZIF.default).lastActiveInteraction = activeInteractionId;
}
const $38fbdea5321741f4$var$getIsNativeTracingEnabled = ()=>{
    var _getConfig;
    return ((_getConfig = (0, $5hPkM.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) ?? false;
};
const $38fbdea5321741f4$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    var _state$startTimes$get, _vm_internals__;
    if (!(0, $koZIF.default).startTimes.has(id)) (0, $koZIF.default).startTimes.set(id, []);
    (_state$startTimes$get = (0, $koZIF.default).startTimes.get(id)) === null || _state$startTimes$get === void 0 || _state$startTimes$get.push(performance.now());
    if (!$38fbdea5321741f4$var$getIsNativeTracingEnabled()) return null;
    const startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    let spanState = (0, $koZIF.default).spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        (0, $koZIF.default).spanStates.set(id, spanState);
    }
    return spanState;
};
const $38fbdea5321741f4$var$ParentSpanContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $38fbdea5321741f4$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $fc4bM.useMemo)(()=>labelStack.map((l)=>(0, $9JxdC.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $38fbdea5321741f4$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $fc4bM.useContext)($38fbdea5321741f4$var$ParentSpanContext);
    const currentSpanState = $38fbdea5321741f4$var$onStartRender(reactProfilerId, (0, $9JxdC.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($38fbdea5321741f4$var$ParentSpanContext.Provider, {
        value: (currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bIcU7.ProfilerMarker), {
        onRender: ()=>{
            const startTimesForId = (0, $koZIF.default).startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = (0, $koZIF.default).spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};

});
parcelRegister("8NwjI", function(module, exports) {
$parcel$export(module.exports, "clearState", () => $656b2e229ad035d0$export$cf4e4023c0a34c8d);

var $koZIF = parcelRequire("koZIF");
const $656b2e229ad035d0$export$cf4e4023c0a34c8d = ()=>{
    (0, $koZIF.default).startTimes.clear();
    (0, $koZIF.default).spanStates.clear();
};

});





parcelRegister("4gQCF", function(module, exports) {
$parcel$export(module.exports, "install", () => $0f85ce60877db0b9$export$4b3e715f166fdd78);

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("ilg7W");
var $gSo0Q = parcelRequire("gSo0Q");
parcelRequire("6WJ9J");
var $cPKAb = parcelRequire("cPKAb");
const $0f85ce60877db0b9$export$4b3e715f166fdd78 = (0, $aYMdQ.once)(()=>{
    // asset-field-value is rendered on Request Details; it displays the names of assets linked to the request
    if (typeof window !== 'undefined' && window.customElements) {
        customElements.define('asset-field-value', (0, $gSo0Q.getAssetFieldValueElementClass)());
        customElements.define('cmdb-field-value', (0, $cPKAb.getCmdbFieldValueElement)());
    }
});

});
parcelRegister("ilg7W", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => (parcelRequire("gSo0Q")).getAssetFieldValueElementClass);

var $gSo0Q = parcelRequire("gSo0Q");

});
parcelRegister("gSo0Q", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => $e0f9d3fa0ace81f9$export$586e8886906ef36f);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $6LH8a = parcelRequire("6LH8a");

var $8MaoS = parcelRequire("8MaoS");

var $9Ii6A = parcelRequire("9Ii6A");

var $7ZNRj = parcelRequire("7ZNRj");

var $7wx9B = parcelRequire("7wx9B");

var $iVKiT = parcelRequire("iVKiT");
const $e0f9d3fa0ace81f9$var$onIntlError = (intlError)=>{
    try {
        $7wx9B.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $e0f9d3fa0ace81f9$export$3bcefabe8b04378c = (intlError)=>{
    $e0f9d3fa0ace81f9$var$onIntlError(intlError.message);
};
const $e0f9d3fa0ace81f9$export$586e8886906ef36f = ()=>{
    class AssetFieldValueElement extends HTMLElement {
        connectedCallback() {
            // create a Shadow DOM (i.e. the contents of this web component)
            const shadow = this.attachShadow({
                mode: 'open'
            });
            // Jira passes the asset's origin as a data-origin attribute
            const origin = this.getAttribute('data-origin');
            // render the component with its props, and add to the Shadow DOM
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const root = document.createElement('span');
            // eslint-disable-next-line react/no-deprecated
            $bTkYf.render(/*#__PURE__*/ $fc4bM.createElement((0, $8MaoS.default), {
                messages: (0, $9Ii6A.default)(),
                locale: (0, $7ZNRj.getLanguageFromLocale)((0, $6LH8a.getMetaData)().userLocale),
                onError: $e0f9d3fa0ace81f9$export$3bcefabe8b04378c
            }, /*#__PURE__*/ $fc4bM.createElement((0, $iVKiT.default), {
                origin: origin
            })), root);
            shadow.appendChild(root);
        }
    }
    return AssetFieldValueElement;
};

});
parcelRegister("8MaoS", function(module, exports) {
$parcel$export(module.exports, "default", () => $663adfae56d6889f$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $5lpFe = parcelRequire("5lpFe");

var $kezTY = parcelRequire("kezTY");

var $fc4bM = parcelRequire("fc4bM");

var $9cljr = parcelRequire("9cljr");

var $hzT1C = parcelRequire("hzT1C");

var $fcCIH = parcelRequire("fcCIH");
function $663adfae56d6889f$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $663adfae56d6889f$var$IntlProvider = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $kezTY.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $hzT1C.createIntl)($663adfae56d6889f$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $663adfae56d6889f$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $663adfae56d6889f$var$processIntlConfig(props);
        if (!(0, $9cljr.shallowEqual)(prevConfig, config)) return {
            intl: (0, $hzT1C.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $9cljr.invariantIntlContext)(this.state.intl);
        return $fc4bM.createElement((0, $fcCIH.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $9cljr.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($fc4bM.PureComponent);
var $663adfae56d6889f$export$2e2bcd8739ae039 = $663adfae56d6889f$var$IntlProvider;

});
parcelRegister("kezTY", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $ebb0f6d107e1774a$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $ebb0f6d107e1774a$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $ebb0f6d107e1774a$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $ebb0f6d107e1774a$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $ebb0f6d107e1774a$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $ebb0f6d107e1774a$export$4ee1db8ce44a209b);

var $5lpFe = parcelRequire("5lpFe");

var $5gMvs = parcelRequire("5gMvs");
parcelRequire("3uLCW");
var $d0alL = parcelRequire("d0alL");

var $f50lf = parcelRequire("f50lf");
function $ebb0f6d107e1774a$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $ebb0f6d107e1774a$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $ebb0f6d107e1774a$var$defaultErrorHandler = function(error) {};
var $ebb0f6d107e1774a$var$defaultWarnHandler = function(warning) {};
var $ebb0f6d107e1774a$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $ebb0f6d107e1774a$var$defaultErrorHandler,
    onWarn: $ebb0f6d107e1774a$var$defaultWarnHandler
};
function $ebb0f6d107e1774a$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $ebb0f6d107e1774a$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $ebb0f6d107e1774a$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $ebb0f6d107e1774a$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $5gMvs.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $5lpFe.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $5gMvs.strategies).variadic
    });
    var getNumberFormat = (0, $5gMvs.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $5lpFe.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.number),
        strategy: (0, $5gMvs.strategies).variadic
    });
    var getPluralRules = (0, $5gMvs.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $5lpFe.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $5gMvs.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $5gMvs.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $d0alL.IntlMessageFormat)(message, locales, overrideFormats, (0, $5lpFe.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.message),
            strategy: (0, $5gMvs.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $5gMvs.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $5lpFe.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $5gMvs.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $5gMvs.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $5lpFe.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.list),
            strategy: (0, $5gMvs.strategies).variadic
        }),
        getDisplayNames: (0, $5gMvs.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $5lpFe.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $ebb0f6d107e1774a$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $5gMvs.strategies).variadic
        })
    };
}
function $ebb0f6d107e1774a$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $f50lf.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("5gMvs", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $3d6412b6705ed6a5$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $3d6412b6705ed6a5$export$c5491a8691a23b9e);
//
// Main
//
function $3d6412b6705ed6a5$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $3d6412b6705ed6a5$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $3d6412b6705ed6a5$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $3d6412b6705ed6a5$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $3d6412b6705ed6a5$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $3d6412b6705ed6a5$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $3d6412b6705ed6a5$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $3d6412b6705ed6a5$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $3d6412b6705ed6a5$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $3d6412b6705ed6a5$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $3d6412b6705ed6a5$var$monadic : $3d6412b6705ed6a5$var$variadic;
    return $3d6412b6705ed6a5$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $3d6412b6705ed6a5$var$strategyVariadic(fn, options) {
    return $3d6412b6705ed6a5$var$assemble(fn, this, $3d6412b6705ed6a5$var$variadic, options.cache.create(), options.serializer);
}
function $3d6412b6705ed6a5$var$strategyMonadic(fn, options) {
    return $3d6412b6705ed6a5$var$assemble(fn, this, $3d6412b6705ed6a5$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $3d6412b6705ed6a5$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $3d6412b6705ed6a5$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $3d6412b6705ed6a5$var$cacheDefault = {
    create: function create() {
        return new $3d6412b6705ed6a5$var$ObjectWithoutPrototypeCache();
    }
};
var $3d6412b6705ed6a5$export$c5491a8691a23b9e = {
    variadic: $3d6412b6705ed6a5$var$strategyVariadic,
    monadic: $3d6412b6705ed6a5$var$strategyMonadic
};

});

parcelRegister("3uLCW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("fqVr0")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("fqVr0")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("lVRIQ")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("d0alL")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $d0alL = parcelRequire("d0alL");
parcelRequire("fqVr0");
parcelRequire("lVRIQ");
var $28b91e3594a0352f$export$2e2bcd8739ae039 = (0, $d0alL.IntlMessageFormat);

});
parcelRegister("d0alL", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $97734dc6615b9764$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $5lpFe = parcelRequire("5lpFe");

var $5gMvs = parcelRequire("5gMvs");

var $lVpQT = parcelRequire("lVpQT");

var $lVRIQ = parcelRequire("lVRIQ");
// -- MessageFormat --------------------------------------------------------
function $97734dc6615b9764$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $97734dc6615b9764$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $97734dc6615b9764$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $5lpFe.__assign)({}, defaultConfig));
}
function $97734dc6615b9764$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $97734dc6615b9764$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $5gMvs.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $5lpFe.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $97734dc6615b9764$var$createFastMemoizeCache(cache.number),
            strategy: (0, $5gMvs.strategies).variadic
        }),
        getDateTimeFormat: (0, $5gMvs.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $5lpFe.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $97734dc6615b9764$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $5gMvs.strategies).variadic
        }),
        getPluralRules: (0, $5gMvs.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $5lpFe.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $97734dc6615b9764$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $5gMvs.strategies).variadic
        })
    };
}
var $97734dc6615b9764$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $lVRIQ.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $lVRIQ.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $5lpFe.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $97734dc6615b9764$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $97734dc6615b9764$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $lVpQT.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("lVpQT", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("7cB0d")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("7cB0d")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("7cB0d")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("7cB0d")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("7cB0d")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("7cB0d")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("7cB0d")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("7cB0d")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("7cB0d")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("7cB0d")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("7cB0d")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("7cB0d")).TYPE);
$parcel$export(module.exports, "parse", () => $ff62f98a3741f109$export$98e6a39c04603d36);

var $5lpFe = parcelRequire("5lpFe");

var $gv3W0 = parcelRequire("gv3W0");

var $bGZ53 = parcelRequire("bGZ53");

var $7cB0d = parcelRequire("7cB0d");

var $2KxtE = parcelRequire("2KxtE");
function $ff62f98a3741f109$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $7cB0d.isSelectElement)(el) || (0, $7cB0d.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $ff62f98a3741f109$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $7cB0d.isNumberElement)(el) && (0, $7cB0d.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $7cB0d.isDateElement)(el) || (0, $7cB0d.isTimeElement)(el)) && (0, $7cB0d.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $7cB0d.isTagElement)(el)) $ff62f98a3741f109$var$pruneLocation(el.children);
    });
}
function $ff62f98a3741f109$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $5lpFe.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $bGZ53.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $gv3W0.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $ff62f98a3741f109$var$pruneLocation(result.val);
    return result.val;
}
var $ff62f98a3741f109$export$d3c1bfa0f7d806e9 = (0, $bGZ53.Parser);

});
parcelRegister("gv3W0", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $c03297e9a3bd3ed3$export$896afd8541959ee5);
var $c03297e9a3bd3ed3$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($c03297e9a3bd3ed3$export$896afd8541959ee5 || ($c03297e9a3bd3ed3$export$896afd8541959ee5 = {}));

});

parcelRegister("bGZ53", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $8832ff4b98607ac4$export$7acfa6ed01010e37);

var $5lpFe = parcelRequire("5lpFe");

var $gv3W0 = parcelRequire("gv3W0");

var $7cB0d = parcelRequire("7cB0d");

var $7fpZN = parcelRequire("7fpZN");
parcelRequire("4YiR1");
var $78Gc9 = parcelRequire("78Gc9");
var $jdzdS = parcelRequire("jdzdS");

var $7s7Oh = parcelRequire("7s7Oh");
var $8832ff4b98607ac4$var$_a;
var $8832ff4b98607ac4$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $7fpZN.SPACE_SEPARATOR_REGEX).source, "*"));
var $8832ff4b98607ac4$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $7fpZN.SPACE_SEPARATOR_REGEX).source, "*$"));
function $8832ff4b98607ac4$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $8832ff4b98607ac4$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $8832ff4b98607ac4$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $8832ff4b98607ac4$var$hasNativeFromEntries = !!Object.fromEntries;
var $8832ff4b98607ac4$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $8832ff4b98607ac4$var$hasTrimStart = !!String.prototype.trimStart;
var $8832ff4b98607ac4$var$hasTrimEnd = !!String.prototype.trimEnd;
var $8832ff4b98607ac4$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $8832ff4b98607ac4$var$isSafeInteger = $8832ff4b98607ac4$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $8832ff4b98607ac4$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $8832ff4b98607ac4$var$re = $8832ff4b98607ac4$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $8832ff4b98607ac4$var$REGEX_SUPPORTS_U_AND_Y = (($8832ff4b98607ac4$var$_a = $8832ff4b98607ac4$var$re.exec('a')) === null || $8832ff4b98607ac4$var$_a === void 0 ? void 0 : $8832ff4b98607ac4$var$_a[0]) === 'a';
} catch (_) {
    $8832ff4b98607ac4$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $8832ff4b98607ac4$var$startsWith = $8832ff4b98607ac4$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $8832ff4b98607ac4$var$fromCodePoint = $8832ff4b98607ac4$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $8832ff4b98607ac4$var$fromEntries = // native
$8832ff4b98607ac4$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $8832ff4b98607ac4$var$codePointAt = $8832ff4b98607ac4$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $8832ff4b98607ac4$var$trimStart = $8832ff4b98607ac4$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($8832ff4b98607ac4$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $8832ff4b98607ac4$var$trimEnd = $8832ff4b98607ac4$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($8832ff4b98607ac4$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $8832ff4b98607ac4$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $8832ff4b98607ac4$var$matchIdentifierAtIndex;
if ($8832ff4b98607ac4$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $8832ff4b98607ac4$var$IDENTIFIER_PREFIX_RE_1 = $8832ff4b98607ac4$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $8832ff4b98607ac4$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $8832ff4b98607ac4$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $8832ff4b98607ac4$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$8832ff4b98607ac4$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $8832ff4b98607ac4$var$codePointAt(s, index);
        if (c === undefined || $8832ff4b98607ac4$var$_isWhiteSpace(c) || $8832ff4b98607ac4$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $8832ff4b98607ac4$var$fromCodePoint.apply(void 0, match);
};
var $8832ff4b98607ac4$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $7cB0d.TYPE).pound,
                    location: $8832ff4b98607ac4$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $gv3W0.ErrorKind).UNMATCHED_CLOSING_TAG, $8832ff4b98607ac4$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $8832ff4b98607ac4$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $7cB0d.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $8832ff4b98607ac4$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$8832ff4b98607ac4$var$_isAlpha(this.char())) return this.error((0, $gv3W0.ErrorKind).INVALID_TAG, $8832ff4b98607ac4$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $gv3W0.ErrorKind).UNMATCHED_CLOSING_TAG, $8832ff4b98607ac4$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $gv3W0.ErrorKind).INVALID_TAG, $8832ff4b98607ac4$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $7cB0d.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $8832ff4b98607ac4$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $gv3W0.ErrorKind).UNCLOSED_TAG, $8832ff4b98607ac4$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $gv3W0.ErrorKind).INVALID_TAG, $8832ff4b98607ac4$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $8832ff4b98607ac4$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $8832ff4b98607ac4$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $7cB0d.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$8832ff4b98607ac4$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $8832ff4b98607ac4$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $8832ff4b98607ac4$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $gv3W0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $gv3W0.ErrorKind).EMPTY_ARGUMENT, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $gv3W0.ErrorKind).MALFORMED_ARGUMENT, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $gv3W0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $7cB0d.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $gv3W0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $gv3W0.ErrorKind).MALFORMED_ARGUMENT, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $8832ff4b98607ac4$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $8832ff4b98607ac4$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $gv3W0.ErrorKind).EXPECT_ARGUMENT_TYPE, $8832ff4b98607ac4$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $8832ff4b98607ac4$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $gv3W0.ErrorKind).EXPECT_ARGUMENT_STYLE, $8832ff4b98607ac4$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $8832ff4b98607ac4$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $8832ff4b98607ac4$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $8832ff4b98607ac4$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $7cB0d.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $gv3W0.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $7s7Oh.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $7cB0d.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $78Gc9.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $7cB0d.TYPE).date : (0, $7cB0d.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $7cB0d.TYPE).number : argType === 'date' ? (0, $7cB0d.TYPE).date : (0, $7cB0d.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $gv3W0.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $8832ff4b98607ac4$var$createLocation(typeEndPosition_1, (0, $5lpFe.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $gv3W0.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $8832ff4b98607ac4$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $gv3W0.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $gv3W0.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $7cB0d.TYPE).select,
                        value: value,
                        options: $8832ff4b98607ac4$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $7cB0d.TYPE).plural,
                        value: value,
                        options: $8832ff4b98607ac4$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $gv3W0.ErrorKind).INVALID_ARGUMENT_TYPE, $8832ff4b98607ac4$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $gv3W0.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $gv3W0.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $8832ff4b98607ac4$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $jdzdS.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $gv3W0.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $7cB0d.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $jdzdS.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $gv3W0.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $gv3W0.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $8832ff4b98607ac4$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $gv3W0.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $gv3W0.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $gv3W0.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $gv3W0.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $8832ff4b98607ac4$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $8832ff4b98607ac4$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $gv3W0.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $gv3W0.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $8832ff4b98607ac4$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $gv3W0.ErrorKind).MISSING_OTHER_CLAUSE, $8832ff4b98607ac4$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $8832ff4b98607ac4$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$8832ff4b98607ac4$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $8832ff4b98607ac4$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($8832ff4b98607ac4$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $8832ff4b98607ac4$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $8832ff4b98607ac4$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $8832ff4b98607ac4$var$_isAlphaOrSlash(codepoint) {
    return $8832ff4b98607ac4$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $8832ff4b98607ac4$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $8832ff4b98607ac4$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $8832ff4b98607ac4$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("7cB0d", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $53e65b4bf6daaa44$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $53e65b4bf6daaa44$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $53e65b4bf6daaa44$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $53e65b4bf6daaa44$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $53e65b4bf6daaa44$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $53e65b4bf6daaa44$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $53e65b4bf6daaa44$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $53e65b4bf6daaa44$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $53e65b4bf6daaa44$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $53e65b4bf6daaa44$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $53e65b4bf6daaa44$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $53e65b4bf6daaa44$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $53e65b4bf6daaa44$export$7680c41f1a55f4cf);
var $53e65b4bf6daaa44$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($53e65b4bf6daaa44$export$b87f371cbc396fcf || ($53e65b4bf6daaa44$export$b87f371cbc396fcf = {}));
var $53e65b4bf6daaa44$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($53e65b4bf6daaa44$export$906452485466fa53 || ($53e65b4bf6daaa44$export$906452485466fa53 = {}));
function $53e65b4bf6daaa44$export$cfa10c5697238752(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.literal;
}
function $53e65b4bf6daaa44$export$4f55724281bdfaf9(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.argument;
}
function $53e65b4bf6daaa44$export$e11187b219e191e1(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.number;
}
function $53e65b4bf6daaa44$export$32d811605da75f40(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.date;
}
function $53e65b4bf6daaa44$export$34ec46f596b1702f(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.time;
}
function $53e65b4bf6daaa44$export$dcfe1c11d168b5a1(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.select;
}
function $53e65b4bf6daaa44$export$6c796d116f0a4fbc(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.plural;
}
function $53e65b4bf6daaa44$export$c0ece297bdd0c082(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.pound;
}
function $53e65b4bf6daaa44$export$5c83de34745812b(el) {
    return el.type === $53e65b4bf6daaa44$export$b87f371cbc396fcf.tag;
}
function $53e65b4bf6daaa44$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $53e65b4bf6daaa44$export$906452485466fa53.number);
}
function $53e65b4bf6daaa44$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $53e65b4bf6daaa44$export$906452485466fa53.dateTime);
}
function $53e65b4bf6daaa44$export$f0ac572c1121c662(value) {
    return {
        type: $53e65b4bf6daaa44$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $53e65b4bf6daaa44$export$425e864b0ba114f1(value, style) {
    return {
        type: $53e65b4bf6daaa44$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("7fpZN", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $546e194ec910103b$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $546e194ec910103b$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $546e194ec910103b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("4YiR1", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("78Gc9")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("jdzdS")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("jdzdS")).parseNumberSkeletonFromString);
parcelRequire("78Gc9");
parcelRequire("jdzdS");

});
parcelRegister("78Gc9", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $532a02cca4a02225$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $532a02cca4a02225$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $532a02cca4a02225$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($532a02cca4a02225$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("jdzdS", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $dfda8dc1a43c1b11$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $dfda8dc1a43c1b11$export$47c6f8480bda3e11);

var $5lpFe = parcelRequire("5lpFe");

var $f2VLQ = parcelRequire("f2VLQ");
function $dfda8dc1a43c1b11$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $f2VLQ.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $dfda8dc1a43c1b11$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $dfda8dc1a43c1b11$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $dfda8dc1a43c1b11$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $dfda8dc1a43c1b11$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $dfda8dc1a43c1b11$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $dfda8dc1a43c1b11$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($dfda8dc1a43c1b11$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $dfda8dc1a43c1b11$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $dfda8dc1a43c1b11$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$dfda8dc1a43c1b11$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $dfda8dc1a43c1b11$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $dfda8dc1a43c1b11$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $dfda8dc1a43c1b11$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $dfda8dc1a43c1b11$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, all), $dfda8dc1a43c1b11$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, all), $dfda8dc1a43c1b11$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($dfda8dc1a43c1b11$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($dfda8dc1a43c1b11$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($dfda8dc1a43c1b11$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($dfda8dc1a43c1b11$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), $dfda8dc1a43c1b11$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($dfda8dc1a43c1b11$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), $dfda8dc1a43c1b11$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $dfda8dc1a43c1b11$var$parseSign(token.stem);
        if (signOpts) result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $dfda8dc1a43c1b11$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("f2VLQ", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $02d3acd28ae7d9b3$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $02d3acd28ae7d9b3$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("7s7Oh", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $56d134d76d825495$export$29c5368be8904d27);

var $b00Mt = parcelRequire("b00Mt");
function $56d134d76d825495$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $56d134d76d825495$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $56d134d76d825495$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $b00Mt.timeData)[regionTag || ''] || (0, $b00Mt.timeData)[languageTag || ''] || (0, $b00Mt.timeData)["".concat(languageTag, "-001")] || (0, $b00Mt.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("b00Mt", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $80204cdfacc4f327$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $80204cdfacc4f327$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("2KxtE", function(module, exports) {

var $5lpFe = parcelRequire("5lpFe");

var $7cB0d = parcelRequire("7cB0d");
function $2009d889710cd223$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $5lpFe.__spreadArray)([], obj.map($2009d889710cd223$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $2009d889710cd223$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $2009d889710cd223$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $2009d889710cd223$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $2009d889710cd223$export$be5687ba8bbdf416((0, $5lpFe.__spreadArray)((0, $5lpFe.__spreadArray)((0, $5lpFe.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $2009d889710cd223$var$isPluralOrSelectElement(el) {
    return (0, $7cB0d.isPluralElement)(el) || (0, $7cB0d.isSelectElement)(el);
}
function $2009d889710cd223$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($2009d889710cd223$var$isPluralOrSelectElement(el)) return true;
        if ((0, $7cB0d.isTagElement)(el)) return $2009d889710cd223$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $2009d889710cd223$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($2009d889710cd223$var$isPluralOrSelectElement(el)) return [
            $2009d889710cd223$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $7cB0d.isTagElement)(el) && $2009d889710cd223$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $2009d889710cd223$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $7cB0d.isArgumentElement)(el) || (0, $7cB0d.isDateElement)(el) || (0, $7cB0d.isTimeElement)(el) || (0, $7cB0d.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $7cB0d.isPluralElement)(el) || (0, $7cB0d.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $2009d889710cd223$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $7cB0d.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $2009d889710cd223$var$collectVariables(el.children, vars);
        }
    });
}
function $2009d889710cd223$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $2009d889710cd223$var$collectVariables(a, aVars);
    $2009d889710cd223$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $7cB0d.TYPE)[type], " vs ").concat((0, $7cB0d.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("lVRIQ", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $ff7897f84f0dc3ee$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $ff7897f84f0dc3ee$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $ff7897f84f0dc3ee$export$275d4a3bb5f66fda);
parcelRequire("lVpQT");
var $7cB0d = parcelRequire("7cB0d");

var $fqVr0 = parcelRequire("fqVr0");
var $ff7897f84f0dc3ee$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ff7897f84f0dc3ee$export$49694c2877b44c57 || ($ff7897f84f0dc3ee$export$49694c2877b44c57 = {}));
function $ff7897f84f0dc3ee$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ff7897f84f0dc3ee$export$49694c2877b44c57.literal || part.type !== $ff7897f84f0dc3ee$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ff7897f84f0dc3ee$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $ff7897f84f0dc3ee$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $7cB0d.isLiteralElement)(els[0])) return [
        {
            type: $ff7897f84f0dc3ee$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $7cB0d.isLiteralElement)(el)) {
            result.push({
                type: $ff7897f84f0dc3ee$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $7cB0d.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $ff7897f84f0dc3ee$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $fqVr0.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $7cB0d.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $ff7897f84f0dc3ee$export$49694c2877b44c57.literal : $ff7897f84f0dc3ee$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $7cB0d.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $7cB0d.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ff7897f84f0dc3ee$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7cB0d.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $7cB0d.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ff7897f84f0dc3ee$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7cB0d.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $7cB0d.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ff7897f84f0dc3ee$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7cB0d.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ff7897f84f0dc3ee$export$df0c12a2d414a163(formatFn)) throw new (0, $fqVr0.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $ff7897f84f0dc3ee$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $ff7897f84f0dc3ee$export$49694c2877b44c57.literal : $ff7897f84f0dc3ee$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $7cB0d.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $fqVr0.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ff7897f84f0dc3ee$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $7cB0d.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $fqVr0.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $fqVr0.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $fqVr0.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ff7897f84f0dc3ee$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ff7897f84f0dc3ee$var$mergeLiteral(result);
}

});
parcelRegister("fqVr0", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $b3c5d60f57999b62$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $b3c5d60f57999b62$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $b3c5d60f57999b62$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $b3c5d60f57999b62$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $b3c5d60f57999b62$export$8bfc137e4d23fdf0);

var $5lpFe = parcelRequire("5lpFe");
var $b3c5d60f57999b62$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b3c5d60f57999b62$export$d4e71bc0b80dc0fb || ($b3c5d60f57999b62$export$d4e71bc0b80dc0fb = {}));
var $b3c5d60f57999b62$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b3c5d60f57999b62$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $b3c5d60f57999b62$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b3c5d60f57999b62$export$7369836851cc1329);
var $b3c5d60f57999b62$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $b3c5d60f57999b62$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b3c5d60f57999b62$export$7369836851cc1329);
var $b3c5d60f57999b62$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $b3c5d60f57999b62$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b3c5d60f57999b62$export$7369836851cc1329);

});




parcelRegister("f50lf", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $afa7967e6a7fccbd$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $afa7967e6a7fccbd$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $afa7967e6a7fccbd$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $afa7967e6a7fccbd$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $afa7967e6a7fccbd$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $afa7967e6a7fccbd$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $afa7967e6a7fccbd$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $afa7967e6a7fccbd$export$2ddcb436d0aa3688);

var $5lpFe = parcelRequire("5lpFe");
var $afa7967e6a7fccbd$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($afa7967e6a7fccbd$export$557d6acb76e8a244 || ($afa7967e6a7fccbd$export$557d6acb76e8a244 = {}));
var $afa7967e6a7fccbd$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $afa7967e6a7fccbd$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $afa7967e6a7fccbd$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($afa7967e6a7fccbd$export$c016d36112f6ddf8);
var $afa7967e6a7fccbd$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $afa7967e6a7fccbd$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($afa7967e6a7fccbd$export$c016d36112f6ddf8);
var $afa7967e6a7fccbd$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $afa7967e6a7fccbd$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($afa7967e6a7fccbd$export$c016d36112f6ddf8);
var $afa7967e6a7fccbd$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $afa7967e6a7fccbd$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($afa7967e6a7fccbd$export$c016d36112f6ddf8);
var $afa7967e6a7fccbd$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($afa7967e6a7fccbd$export$e3b7eee1dbc44895);
var $afa7967e6a7fccbd$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $afa7967e6a7fccbd$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($afa7967e6a7fccbd$export$c016d36112f6ddf8);

});


parcelRegister("9cljr", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $6b25c44782ae13f3$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $6b25c44782ae13f3$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $6b25c44782ae13f3$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $6b25c44782ae13f3$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $6b25c44782ae13f3$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $6b25c44782ae13f3$export$d36bdfa510afb180);

var $5lpFe = parcelRequire("5lpFe");

var $fc4bM = parcelRequire("fc4bM");

var $kezTY = parcelRequire("kezTY");
function $6b25c44782ae13f3$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $6b25c44782ae13f3$export$45c4bbf6e55bba1f(intl) {
    $6b25c44782ae13f3$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $6b25c44782ae13f3$export$b52f8d6fc0d47415 = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, (0, $kezTY.DEFAULT_INTL_CONFIG)), {
    textComponent: $fc4bM.Fragment
});
var $6b25c44782ae13f3$var$toKeyedReactNode = function(reactNode, key) {
    return $fc4bM.isValidElement(reactNode) ? $fc4bM.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $6b25c44782ae13f3$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $fc4bM.Children.map(children, $6b25c44782ae13f3$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $6b25c44782ae13f3$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($6b25c44782ae13f3$export$d2fd241e0b53c057(parts));
    };
}
function $6b25c44782ae13f3$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});

parcelRegister("hzT1C", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $ccc063696ba60819$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $5lpFe = parcelRequire("5lpFe");

var $kc34h = parcelRequire("kc34h");
var $33Lts = parcelRequire("33Lts");

var $lVRIQ = parcelRequire("lVRIQ");

var $9cljr = parcelRequire("9cljr");
function $ccc063696ba60819$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $lVRIQ.isFormatXMLElementFn)(v) ? (0, $9cljr.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $ccc063696ba60819$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $ccc063696ba60819$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $33Lts.formatMessage).apply(void 0, (0, $5lpFe.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $9cljr.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $ccc063696ba60819$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $5lpFe.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $ccc063696ba60819$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $kc34h.createIntl)((0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, (0, $9cljr.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, coreIntl), {
        formatMessage: $ccc063696ba60819$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $ccc063696ba60819$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("kc34h", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $eb374ee5c8191a13$export$7e4cbedfdd7b4c0d);

var $5lpFe = parcelRequire("5lpFe");

var $jeM3k = parcelRequire("jeM3k");

var $9iwxS = parcelRequire("9iwxS");

var $f50lf = parcelRequire("f50lf");

var $dHVAj = parcelRequire("dHVAj");

var $33Lts = parcelRequire("33Lts");

var $cZ8g1 = parcelRequire("cZ8g1");

var $4XBvE = parcelRequire("4XBvE");

var $5kIRL = parcelRequire("5kIRL");

var $kezTY = parcelRequire("kezTY");
function $eb374ee5c8191a13$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $eb374ee5c8191a13$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $eb374ee5c8191a13$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $eb374ee5c8191a13$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $kezTY.createFormatters)(cache);
    var resolvedConfig = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, (0, $kezTY.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $f50lf.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $f50lf.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $f50lf.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $eb374ee5c8191a13$var$verifyConfigMessages(resolvedConfig);
    return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $cZ8g1.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $cZ8g1.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $5kIRL.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $jeM3k.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $jeM3k.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $jeM3k.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $jeM3k.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $jeM3k.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $4XBvE.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $33Lts.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $33Lts.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $dHVAj.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $dHVAj.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $9iwxS.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("jeM3k", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $e014996755b3f1d8$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $e014996755b3f1d8$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $e014996755b3f1d8$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $e014996755b3f1d8$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $e014996755b3f1d8$export$af6e5d7a5c73edeb);

var $5lpFe = parcelRequire("5lpFe");

var $f50lf = parcelRequire("f50lf");

var $kezTY = parcelRequire("kezTY");
var $e014996755b3f1d8$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $e014996755b3f1d8$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $kezTY.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $kezTY.filterProps)(options, $e014996755b3f1d8$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $e014996755b3f1d8$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e014996755b3f1d8$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $e014996755b3f1d8$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e014996755b3f1d8$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $e014996755b3f1d8$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $e014996755b3f1d8$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $e014996755b3f1d8$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e014996755b3f1d8$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $e014996755b3f1d8$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e014996755b3f1d8$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("9iwxS", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $01bf35d8207f0863$export$62fe1a4d9e891fa2);

var $kezTY = parcelRequire("kezTY");

var $fqVr0 = parcelRequire("fqVr0");

var $f50lf = parcelRequire("f50lf");
var $01bf35d8207f0863$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $01bf35d8207f0863$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $fqVr0.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $fqVr0.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $kezTY.filterProps)(options, $01bf35d8207f0863$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $f50lf.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("dHVAj", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $9fabf5a212b3ddb5$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $9fabf5a212b3ddb5$export$6f284aad1934db69);

var $5lpFe = parcelRequire("5lpFe");

var $fqVr0 = parcelRequire("fqVr0");

var $f50lf = parcelRequire("f50lf");

var $kezTY = parcelRequire("kezTY");
var $9fabf5a212b3ddb5$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $9fabf5a212b3ddb5$var$now = Date.now();
function $9fabf5a212b3ddb5$var$generateToken(i) {
    return "".concat($9fabf5a212b3ddb5$var$now, "_").concat(i, "_").concat($9fabf5a212b3ddb5$var$now);
}
function $9fabf5a212b3ddb5$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $9fabf5a212b3ddb5$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $9fabf5a212b3ddb5$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $fqVr0.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $fqVr0.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $kezTY.filterProps)(options, $9fabf5a212b3ddb5$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $9fabf5a212b3ddb5$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $f50lf.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("33Lts", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $23a67a4d67298187$export$25868d1e8e76735f);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("lVpQT");
var $7cB0d = parcelRequire("7cB0d");
parcelRequire("3uLCW");
var $d0alL = parcelRequire("d0alL");

var $f50lf = parcelRequire("f50lf");

var $kezTY = parcelRequire("kezTY");
function $23a67a4d67298187$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $5lpFe.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $23a67a4d67298187$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $23a67a4d67298187$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $d0alL.IntlMessageFormat).formats;
    return (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, mfFormats), f1), {
        date: $23a67a4d67298187$var$deepMergeOptions($23a67a4d67298187$var$setTimeZoneInOptions(mfFormats.date, timeZone), $23a67a4d67298187$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $23a67a4d67298187$var$deepMergeOptions($23a67a4d67298187$var$setTimeZoneInOptions(mfFormats.time, timeZone), $23a67a4d67298187$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $23a67a4d67298187$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $kezTY.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $7cB0d.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, defaultRichTextElements), values || {});
    formats = $23a67a4d67298187$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $23a67a4d67298187$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $f50lf.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $f50lf.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $5lpFe.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $f50lf.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $f50lf.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("cZ8g1", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $97419646c5ae212a$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $97419646c5ae212a$export$6871080848f10b2f);

var $f50lf = parcelRequire("f50lf");

var $kezTY = parcelRequire("kezTY");
var $97419646c5ae212a$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $97419646c5ae212a$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $kezTY.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $kezTY.filterProps)(options, $97419646c5ae212a$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $97419646c5ae212a$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $97419646c5ae212a$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $97419646c5ae212a$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $97419646c5ae212a$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("4XBvE", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $39c9c4b1fa327c30$export$bbbd05c900f3568d);

var $fqVr0 = parcelRequire("fqVr0");

var $f50lf = parcelRequire("f50lf");

var $kezTY = parcelRequire("kezTY");
var $39c9c4b1fa327c30$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $39c9c4b1fa327c30$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $fqVr0.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $fqVr0.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $kezTY.filterProps)(options, $39c9c4b1fa327c30$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $f50lf.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("5kIRL", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $3e219f7c8f48a03d$export$b4ea3b48dcf921f6);

var $kezTY = parcelRequire("kezTY");

var $fqVr0 = parcelRequire("fqVr0");

var $f50lf = parcelRequire("f50lf");
var $3e219f7c8f48a03d$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $3e219f7c8f48a03d$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $kezTY.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $kezTY.filterProps)(options, $3e219f7c8f48a03d$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $3e219f7c8f48a03d$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $fqVr0.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $fqVr0.ErrorCode).MISSING_INTL_API));
    try {
        return $3e219f7c8f48a03d$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $f50lf.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("fcCIH", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $b11602f72ce12cf8$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $b11602f72ce12cf8$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $b11602f72ce12cf8$export$2e2bcd8739ae039);

var $5lpFe = parcelRequire("5lpFe");

var $hFHD3 = parcelRequire("hFHD3");

var $fc4bM = parcelRequire("fc4bM");

var $9cljr = parcelRequire("9cljr");
function $b11602f72ce12cf8$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $b11602f72ce12cf8$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $fc4bM.createContext(null)) : $fc4bM.createContext(null);
var $b11602f72ce12cf8$var$IntlConsumer = $b11602f72ce12cf8$var$IntlContext.Consumer, $b11602f72ce12cf8$var$IntlProvider = $b11602f72ce12cf8$var$IntlContext.Provider;
var $b11602f72ce12cf8$export$2881499e37b75b9a = $b11602f72ce12cf8$var$IntlProvider;
var $b11602f72ce12cf8$export$841858b892ce1f4c = $b11602f72ce12cf8$var$IntlContext;
function $b11602f72ce12cf8$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $fc4bM.createElement($b11602f72ce12cf8$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $9cljr.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $fc4bM.createElement(WrappedComponent, (0, $5lpFe.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($b11602f72ce12cf8$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($hFHD3)))(// @ts-expect-error
    $fc4bM.forwardRef(function(props, ref) {
        return $fc4bM.createElement(WithIntl, (0, $5lpFe.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hFHD3)))(WithIntl, WrappedComponent);
}

});
parcelRegister("hFHD3", function(module, exports) {
'use strict';

var $6y7BY = parcelRequire("6y7BY");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $cdd81bcb7bc2096b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $cdd81bcb7bc2096b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $cdd81bcb7bc2096b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $cdd81bcb7bc2096b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $cdd81bcb7bc2096b$var$TYPE_STATICS = {};
$cdd81bcb7bc2096b$var$TYPE_STATICS[$6y7BY.ForwardRef] = $cdd81bcb7bc2096b$var$FORWARD_REF_STATICS;
$cdd81bcb7bc2096b$var$TYPE_STATICS[$6y7BY.Memo] = $cdd81bcb7bc2096b$var$MEMO_STATICS;
function $cdd81bcb7bc2096b$var$getStatics(component) {
    // React v16.11 and below
    if ($6y7BY.isMemo(component)) return $cdd81bcb7bc2096b$var$MEMO_STATICS;
     // React v16.12 and above
    return $cdd81bcb7bc2096b$var$TYPE_STATICS[component['$$typeof']] || $cdd81bcb7bc2096b$var$REACT_STATICS;
}
var $cdd81bcb7bc2096b$var$defineProperty = Object.defineProperty;
var $cdd81bcb7bc2096b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $cdd81bcb7bc2096b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $cdd81bcb7bc2096b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $cdd81bcb7bc2096b$var$getPrototypeOf = Object.getPrototypeOf;
var $cdd81bcb7bc2096b$var$objectPrototype = Object.prototype;
function $cdd81bcb7bc2096b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($cdd81bcb7bc2096b$var$objectPrototype) {
            var inheritedComponent = $cdd81bcb7bc2096b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $cdd81bcb7bc2096b$var$objectPrototype) $cdd81bcb7bc2096b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $cdd81bcb7bc2096b$var$getOwnPropertyNames(sourceComponent);
        if ($cdd81bcb7bc2096b$var$getOwnPropertySymbols) keys = keys.concat($cdd81bcb7bc2096b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $cdd81bcb7bc2096b$var$getStatics(targetComponent);
        var sourceStatics = $cdd81bcb7bc2096b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$cdd81bcb7bc2096b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $cdd81bcb7bc2096b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $cdd81bcb7bc2096b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $cdd81bcb7bc2096b$var$hoistNonReactStatics;

});
parcelRegister("6y7BY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kmMVH"));

});
parcelRegister("kmMVH", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $ed3bd124f030ef5a$export$2b8d127b894957b9, (v) => $ed3bd124f030ef5a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $ed3bd124f030ef5a$export$cea3a54a6425200c, (v) => $ed3bd124f030ef5a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $ed3bd124f030ef5a$export$a7c73072b1a182ae, (v) => $ed3bd124f030ef5a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ed3bd124f030ef5a$export$9f27bc3417b4524d, (v) => $ed3bd124f030ef5a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ed3bd124f030ef5a$export$db77ccec0bb4ccac, (v) => $ed3bd124f030ef5a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ed3bd124f030ef5a$export$8392c0c9d3dcbd35, (v) => $ed3bd124f030ef5a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ed3bd124f030ef5a$export$ffb0004e005737fa, (v) => $ed3bd124f030ef5a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ed3bd124f030ef5a$export$b624eff549462981, (v) => $ed3bd124f030ef5a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ed3bd124f030ef5a$export$7897aa7841a5380c, (v) => $ed3bd124f030ef5a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ed3bd124f030ef5a$export$602eac185826482c, (v) => $ed3bd124f030ef5a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ed3bd124f030ef5a$export$e2c29f18771995cb, (v) => $ed3bd124f030ef5a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ed3bd124f030ef5a$export$5f8d39834fd61797, (v) => $ed3bd124f030ef5a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ed3bd124f030ef5a$export$74bf444e3cd11ea5, (v) => $ed3bd124f030ef5a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ed3bd124f030ef5a$export$92387174baf9b227, (v) => $ed3bd124f030ef5a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ed3bd124f030ef5a$export$ec112efeb987d9c6, (v) => $ed3bd124f030ef5a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ed3bd124f030ef5a$export$b706b080d889d2c9, (v) => $ed3bd124f030ef5a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ed3bd124f030ef5a$export$5be5a87408f70ddc, (v) => $ed3bd124f030ef5a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ed3bd124f030ef5a$export$45a5e7f76e0caa8d, (v) => $ed3bd124f030ef5a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ed3bd124f030ef5a$export$455c2e768291efa6, (v) => $ed3bd124f030ef5a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ed3bd124f030ef5a$export$9522e17588c12572, (v) => $ed3bd124f030ef5a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ed3bd124f030ef5a$export$2110ac352bb060b9, (v) => $ed3bd124f030ef5a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ed3bd124f030ef5a$export$56885ab8b9c456ab, (v) => $ed3bd124f030ef5a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ed3bd124f030ef5a$export$d927fcb6adf8f9de, (v) => $ed3bd124f030ef5a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ed3bd124f030ef5a$export$b82d16f27459e05a, (v) => $ed3bd124f030ef5a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ed3bd124f030ef5a$export$522c17b4f5e123e8, (v) => $ed3bd124f030ef5a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ed3bd124f030ef5a$export$1aabd8a0274ecfd6, (v) => $ed3bd124f030ef5a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ed3bd124f030ef5a$export$9b621391a187a31a, (v) => $ed3bd124f030ef5a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ed3bd124f030ef5a$export$f5bbd400c2f4426f, (v) => $ed3bd124f030ef5a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed3bd124f030ef5a$export$2b8d127b894957b9;
var $ed3bd124f030ef5a$export$cea3a54a6425200c;
var $ed3bd124f030ef5a$export$a7c73072b1a182ae;
var $ed3bd124f030ef5a$export$9f27bc3417b4524d;
var $ed3bd124f030ef5a$export$db77ccec0bb4ccac;
var $ed3bd124f030ef5a$export$8392c0c9d3dcbd35;
var $ed3bd124f030ef5a$export$ffb0004e005737fa;
var $ed3bd124f030ef5a$export$b624eff549462981;
var $ed3bd124f030ef5a$export$7897aa7841a5380c;
var $ed3bd124f030ef5a$export$602eac185826482c;
var $ed3bd124f030ef5a$export$e2c29f18771995cb;
var $ed3bd124f030ef5a$export$5f8d39834fd61797;
var $ed3bd124f030ef5a$export$74bf444e3cd11ea5;
var $ed3bd124f030ef5a$export$92387174baf9b227;
var $ed3bd124f030ef5a$export$ec112efeb987d9c6;
var $ed3bd124f030ef5a$export$b706b080d889d2c9;
var $ed3bd124f030ef5a$export$5be5a87408f70ddc;
var $ed3bd124f030ef5a$export$45a5e7f76e0caa8d;
var $ed3bd124f030ef5a$export$455c2e768291efa6;
var $ed3bd124f030ef5a$export$9522e17588c12572;
var $ed3bd124f030ef5a$export$2110ac352bb060b9;
var $ed3bd124f030ef5a$export$56885ab8b9c456ab;
var $ed3bd124f030ef5a$export$d927fcb6adf8f9de;
var $ed3bd124f030ef5a$export$b82d16f27459e05a;
var $ed3bd124f030ef5a$export$522c17b4f5e123e8;
var $ed3bd124f030ef5a$export$1aabd8a0274ecfd6;
var $ed3bd124f030ef5a$export$9b621391a187a31a;
var $ed3bd124f030ef5a$export$f5bbd400c2f4426f;
'use strict';
var $ed3bd124f030ef5a$var$b = "function" === typeof Symbol && Symbol.for, $ed3bd124f030ef5a$var$c = $ed3bd124f030ef5a$var$b ? Symbol.for("react.element") : 60103, $ed3bd124f030ef5a$var$d = $ed3bd124f030ef5a$var$b ? Symbol.for("react.portal") : 60106, $ed3bd124f030ef5a$var$e = $ed3bd124f030ef5a$var$b ? Symbol.for("react.fragment") : 60107, $ed3bd124f030ef5a$var$f = $ed3bd124f030ef5a$var$b ? Symbol.for("react.strict_mode") : 60108, $ed3bd124f030ef5a$var$g = $ed3bd124f030ef5a$var$b ? Symbol.for("react.profiler") : 60114, $ed3bd124f030ef5a$var$h = $ed3bd124f030ef5a$var$b ? Symbol.for("react.provider") : 60109, $ed3bd124f030ef5a$var$k = $ed3bd124f030ef5a$var$b ? Symbol.for("react.context") : 60110, $ed3bd124f030ef5a$var$l = $ed3bd124f030ef5a$var$b ? Symbol.for("react.async_mode") : 60111, $ed3bd124f030ef5a$var$m = $ed3bd124f030ef5a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ed3bd124f030ef5a$var$n = $ed3bd124f030ef5a$var$b ? Symbol.for("react.forward_ref") : 60112, $ed3bd124f030ef5a$var$p = $ed3bd124f030ef5a$var$b ? Symbol.for("react.suspense") : 60113, $ed3bd124f030ef5a$var$q = $ed3bd124f030ef5a$var$b ? Symbol.for("react.suspense_list") : 60120, $ed3bd124f030ef5a$var$r = $ed3bd124f030ef5a$var$b ? Symbol.for("react.memo") : 60115, $ed3bd124f030ef5a$var$t = $ed3bd124f030ef5a$var$b ? Symbol.for("react.lazy") : 60116, $ed3bd124f030ef5a$var$v = $ed3bd124f030ef5a$var$b ? Symbol.for("react.block") : 60121, $ed3bd124f030ef5a$var$w = $ed3bd124f030ef5a$var$b ? Symbol.for("react.fundamental") : 60117, $ed3bd124f030ef5a$var$x = $ed3bd124f030ef5a$var$b ? Symbol.for("react.responder") : 60118, $ed3bd124f030ef5a$var$y = $ed3bd124f030ef5a$var$b ? Symbol.for("react.scope") : 60119;
function $ed3bd124f030ef5a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ed3bd124f030ef5a$var$c:
                switch(a = a.type, a){
                    case $ed3bd124f030ef5a$var$l:
                    case $ed3bd124f030ef5a$var$m:
                    case $ed3bd124f030ef5a$var$e:
                    case $ed3bd124f030ef5a$var$g:
                    case $ed3bd124f030ef5a$var$f:
                    case $ed3bd124f030ef5a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ed3bd124f030ef5a$var$k:
                            case $ed3bd124f030ef5a$var$n:
                            case $ed3bd124f030ef5a$var$t:
                            case $ed3bd124f030ef5a$var$r:
                            case $ed3bd124f030ef5a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ed3bd124f030ef5a$var$d:
                return u;
        }
    }
}
function $ed3bd124f030ef5a$var$A(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$m;
}
$ed3bd124f030ef5a$export$2b8d127b894957b9 = $ed3bd124f030ef5a$var$l;
$ed3bd124f030ef5a$export$cea3a54a6425200c = $ed3bd124f030ef5a$var$m;
$ed3bd124f030ef5a$export$a7c73072b1a182ae = $ed3bd124f030ef5a$var$k;
$ed3bd124f030ef5a$export$9f27bc3417b4524d = $ed3bd124f030ef5a$var$h;
$ed3bd124f030ef5a$export$db77ccec0bb4ccac = $ed3bd124f030ef5a$var$c;
$ed3bd124f030ef5a$export$8392c0c9d3dcbd35 = $ed3bd124f030ef5a$var$n;
$ed3bd124f030ef5a$export$ffb0004e005737fa = $ed3bd124f030ef5a$var$e;
$ed3bd124f030ef5a$export$b624eff549462981 = $ed3bd124f030ef5a$var$t;
$ed3bd124f030ef5a$export$7897aa7841a5380c = $ed3bd124f030ef5a$var$r;
$ed3bd124f030ef5a$export$602eac185826482c = $ed3bd124f030ef5a$var$d;
$ed3bd124f030ef5a$export$e2c29f18771995cb = $ed3bd124f030ef5a$var$g;
$ed3bd124f030ef5a$export$5f8d39834fd61797 = $ed3bd124f030ef5a$var$f;
$ed3bd124f030ef5a$export$74bf444e3cd11ea5 = $ed3bd124f030ef5a$var$p;
$ed3bd124f030ef5a$export$92387174baf9b227 = function(a) {
    return $ed3bd124f030ef5a$var$A(a) || $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$l;
};
$ed3bd124f030ef5a$export$ec112efeb987d9c6 = $ed3bd124f030ef5a$var$A;
$ed3bd124f030ef5a$export$b706b080d889d2c9 = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$k;
};
$ed3bd124f030ef5a$export$5be5a87408f70ddc = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$h;
};
$ed3bd124f030ef5a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ed3bd124f030ef5a$var$c;
};
$ed3bd124f030ef5a$export$455c2e768291efa6 = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$n;
};
$ed3bd124f030ef5a$export$9522e17588c12572 = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$e;
};
$ed3bd124f030ef5a$export$2110ac352bb060b9 = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$t;
};
$ed3bd124f030ef5a$export$56885ab8b9c456ab = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$r;
};
$ed3bd124f030ef5a$export$d927fcb6adf8f9de = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$d;
};
$ed3bd124f030ef5a$export$b82d16f27459e05a = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$g;
};
$ed3bd124f030ef5a$export$522c17b4f5e123e8 = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$f;
};
$ed3bd124f030ef5a$export$1aabd8a0274ecfd6 = function(a) {
    return $ed3bd124f030ef5a$var$z(a) === $ed3bd124f030ef5a$var$p;
};
$ed3bd124f030ef5a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ed3bd124f030ef5a$var$e || a === $ed3bd124f030ef5a$var$m || a === $ed3bd124f030ef5a$var$g || a === $ed3bd124f030ef5a$var$f || a === $ed3bd124f030ef5a$var$p || a === $ed3bd124f030ef5a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ed3bd124f030ef5a$var$t || a.$$typeof === $ed3bd124f030ef5a$var$r || a.$$typeof === $ed3bd124f030ef5a$var$h || a.$$typeof === $ed3bd124f030ef5a$var$k || a.$$typeof === $ed3bd124f030ef5a$var$n || a.$$typeof === $ed3bd124f030ef5a$var$w || a.$$typeof === $ed3bd124f030ef5a$var$x || a.$$typeof === $ed3bd124f030ef5a$var$y || a.$$typeof === $ed3bd124f030ef5a$var$v);
};
$ed3bd124f030ef5a$export$f5bbd400c2f4426f = $ed3bd124f030ef5a$var$z;

});





parcelRegister("9Ii6A", function(module, exports) {
$parcel$export(module.exports, "default", () => $e86ba0e85b241e37$export$2e2bcd8739ae039);
$parcel$export(module.exports, "onIntlError", () => $e86ba0e85b241e37$export$ec3f29afcf92cc87);
$parcel$export(module.exports, "onIntlNextError", () => $e86ba0e85b241e37$export$3bcefabe8b04378c);

var $4MjGQ = parcelRequire("4MjGQ");

var $lvGv2 = parcelRequire("lvGv2");
function $e86ba0e85b241e37$export$2e2bcd8739ae039() {
    window.__JSD_I18N_MESSAGES = window.__JSD_I18N_MESSAGES || {};
    return window.__JSD_I18N_MESSAGES;
}
const $e86ba0e85b241e37$export$ec3f29afcf92cc87 = (intlError)=>{
    try {
        if (!intlError) return;
        const isExternalTranslation = intlError.match(/Missing message: "fabric\.(editor|media|theme|emoji)\..*/);
        const { errorKey: errorKey, errorLocale: errorLocale, isNonFinal: isNonFinal } = (0, $lvGv2.intlErrorMatch)(intlError);
        // According to https://hello.atlassian.net/wiki/spaces/i18n/pages/647802766/
        // Localized+Language+Support+Coverage+and+Strategy the following locales were
        // discontinued in 2018.
        const isUnSupportedLocale = !!intlError.match(/.*Missing message.*for locale "(ro|pt|no|sk|et|is)".*/);
        if (isExternalTranslation || isUnSupportedLocale) return;
        (0, $4MjGQ.operationalEvent)({
            attributes: {
                isNonFinal: isNonFinal,
                key: errorKey,
                locale: errorLocale
            },
            actionSubject: 'intl_translation',
            action: 'missing',
            source: 'unknownSource'
        });
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $e86ba0e85b241e37$export$3bcefabe8b04378c = (intlError)=>{
    $e86ba0e85b241e37$export$ec3f29afcf92cc87(`IntlV5: ${intlError.message}`);
};

});
parcelRegister("lvGv2", function(module, exports) {
$parcel$export(module.exports, "intlErrorMatch", () => $532eb7df3b0aa996$export$c8d26e19aa1787d3);
const $532eb7df3b0aa996$export$c8d26e19aa1787d3 = (intlError)=>{
    const match = intlError.match(/Missing message: "(.*)" for locale "(.*)", using default message as fallback./);
    let isNonFinal = false;
    const errorKey = match ? match[1] : null;
    if (errorKey) isNonFinal = [
        '.non-final',
        'nonFinal'
    ].some((checkString)=>errorKey.includes(checkString));
    return {
        errorKey: errorKey,
        isNonFinal: isNonFinal,
        errorLocale: match ? match[2] : null
    };
};

});


parcelRegister("7ZNRj", function(module, exports) {
$parcel$export(module.exports, "getLanguageFromLocale", () => $0dade5c5314ef92c$export$e085862dfb8d71);
// get language from locale for usage with react-intl. For eg: en_US => en
const $0dade5c5314ef92c$export$e085862dfb8d71 = (locale)=>{
    if (locale && locale.trim()) {
        if (locale === 'pt_BR' || locale === 'pt-BR') return 'pt-BR';
        return locale.split('_')[0].split('-')[0].trim();
    }
    // default to 'en'
    return 'en';
};

});

parcelRegister("iVKiT", function(module, exports) {
$parcel$export(module.exports, "default", () => $eda00c1b6893eaff$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bTjsX = parcelRequire("bTjsX");

var $fcCIH = parcelRequire("fcCIH");

var $diqlM = parcelRequire("diqlM");

var $jkDoy = parcelRequire("jkDoy");
class $eda00c1b6893eaff$export$1e0c5ecf7bd99e3 extends $fc4bM.Component {
    componentDidMount() {
        const { origin: origin } = this.props;
        if (origin === null) return;
        (0, $bTjsX.get)(`${(0, $diqlM.contextPath)}/rest/assetapi/asset/${origin}`)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        .map((asset)=>this.setState({
                value: asset.label.value
            })).subscribe({
            error: ()=>this.setState({
                    isErrored: true
                })
        });
    }
    render() {
        const { intl: intl, origin: origin } = this.props;
        const { value: value, isErrored: isErrored } = this.state;
        if (isErrored || origin === null) return intl.formatMessage((0, $jkDoy.default).unknown);
        if (value === undefined) return intl.formatMessage((0, $jkDoy.default).loading);
        return value;
    }
    constructor(...args){
        super(...args), this.state = {};
    }
}
var $eda00c1b6893eaff$export$2e2bcd8739ae039 = (0, $fcCIH.default)($eda00c1b6893eaff$export$1e0c5ecf7bd99e3);

});
parcelRegister("bTjsX", function(module, exports) {
$parcel$export(module.exports, "get", () => $fb5251bfe3e8099e$export$3988ae62b71be9a3);
$parcel$export(module.exports, "post", () => $fb5251bfe3e8099e$export$299ba2dee77727e9);
$parcel$export(module.exports, "put", () => $fb5251bfe3e8099e$export$327f7b26ebf455db);
$parcel$export(module.exports, "doDelete", () => $fb5251bfe3e8099e$export$3450a603e4796ceb);

var $jFk35 = parcelRequire("jFk35");

var $4qqyC = parcelRequire("4qqyC");
const $fb5251bfe3e8099e$export$e68fce4c5f453854 = (0, $jFk35.Observable).ajax;
const $fb5251bfe3e8099e$export$3988ae62b71be9a3 = (0, $4qqyC.traceableAjaxGet);
const $fb5251bfe3e8099e$export$299ba2dee77727e9 = (0, $4qqyC.traceableAjaxPost);
const $fb5251bfe3e8099e$export$327f7b26ebf455db = (0, $4qqyC.traceableAjaxPut);
const $fb5251bfe3e8099e$export$3450a603e4796ceb = (0, $4qqyC.traceableAjaxDelete);

});
parcelRegister("4qqyC", function(module, exports) {
$parcel$export(module.exports, "traceableAjaxGet", () => $8405e6cac17987da$export$9b2538eb22ed41e3);
$parcel$export(module.exports, "traceableAjaxPost", () => $8405e6cac17987da$export$9f4e186c104ab31a);
$parcel$export(module.exports, "traceableAjaxPut", () => $8405e6cac17987da$export$54de09e82d9434c3);
$parcel$export(module.exports, "traceableAjaxDelete", () => $8405e6cac17987da$export$d507aea434380fd4);

var $jFk35 = parcelRequire("jFk35");

var $akU0n = parcelRequire("akU0n");
const $8405e6cac17987da$var$extendHeadersWithTracing = (url, originalHeaders = {})=>({
        ...originalHeaders,
        ...(0, $akU0n.getActiveTraceHttpRequestHeaders)(url)
    });
const $8405e6cac17987da$export$9b2538eb22ed41e3 = (url, headers)=>{
    return (0, $jFk35.Observable).ajax.get(url, $8405e6cac17987da$var$extendHeadersWithTracing(url, headers));
};
const $8405e6cac17987da$export$9f4e186c104ab31a = (url, body, headers)=>{
    return (0, $jFk35.Observable).ajax.post(url, body, $8405e6cac17987da$var$extendHeadersWithTracing(url, headers));
};
const $8405e6cac17987da$export$54de09e82d9434c3 = (url, body, headers)=>{
    return (0, $jFk35.Observable).ajax.put(url, body, $8405e6cac17987da$var$extendHeadersWithTracing(url, headers));
};
const $8405e6cac17987da$export$d507aea434380fd4 = (url, headers)=>{
    return (0, $jFk35.Observable).ajax.delete(url, $8405e6cac17987da$var$extendHeadersWithTracing(url, headers));
};

});
parcelRegister("akU0n", function(module, exports) {
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $a10ad0508f4eb918$export$6e17cce6446848f9);

var $f4Vz4 = parcelRequire("f4Vz4");

var $2ooME = parcelRequire("2ooME");
function $a10ad0508f4eb918$export$6e17cce6446848f9(_url) {
    if ((0, $f4Vz4.getActiveTrace)() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = (0, $f4Vz4.getActiveTrace)();
    return (0, $2ooME.makeTraceHttpRequestHeaders)(traceId, spanId);
}

});
parcelRegister("2ooME", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $efd4b0aa21681d64$export$1115c5277eb10d5e);
function $efd4b0aa21681d64$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});




parcelRegister("jkDoy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8233443ef0517f77$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $8233443ef0517f77$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    loading: {
        id: 'asset.tracking.field.loading.asset',
        defaultMessage: 'Loading asset...',
        description: 'Displayed when asset label is being loaded from saffron (asset microservice)'
    },
    unknown: {
        id: 'asset.tracking.field.unknown.asset',
        defaultMessage: 'Unknown asset',
        description: 'Displayed when a value for an asset field is not known (eg: it has been deleted)'
    }
});

});
parcelRegister("8p5Cv", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $61e5049073b8107a$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $61e5049073b8107a$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $61e5049073b8107a$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $61e5049073b8107a$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $61e5049073b8107a$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $61e5049073b8107a$export$f52b44e459e6e71d);

var $ch4yH = parcelRequire("ch4yH");

var $hzT1C = parcelRequire("hzT1C");

var $bvUXY = parcelRequire("bvUXY");

var $fcCIH = parcelRequire("fcCIH");

var $fd880 = parcelRequire("fd880");

var $3Yl4y = parcelRequire("3Yl4y");

var $8MaoS = parcelRequire("8MaoS");

var $95h7S = parcelRequire("95h7S");

var $gpjDl = parcelRequire("gpjDl");

var $kezTY = parcelRequire("kezTY");
var $f50lf = parcelRequire("f50lf");
function $61e5049073b8107a$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $61e5049073b8107a$export$747d244ee58120dd(msg) {
    return msg;
}
var $61e5049073b8107a$export$40ae3194919d16b = (0, $ch4yH.createFormattedComponent)('formatDate');
var $61e5049073b8107a$export$5b390a54f8a846f7 = (0, $ch4yH.createFormattedComponent)('formatTime');
var $61e5049073b8107a$export$db80edc1e6b2f63d = (0, $ch4yH.createFormattedComponent)('formatNumber');
var $61e5049073b8107a$export$f52b44e459e6e71d = (0, $ch4yH.createFormattedComponent)('formatList');
var $61e5049073b8107a$export$c2336ea5aaab92fa = (0, $ch4yH.createFormattedComponent)('formatDisplayName');
var $61e5049073b8107a$export$7fdc7d2c91ce149b = (0, $ch4yH.createFormattedDateTimePartsComponent)('formatDate');
var $61e5049073b8107a$export$ec35873761676c2a = (0, $ch4yH.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("ch4yH", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $8efa9bd2dd622568$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $8efa9bd2dd622568$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $8efa9bd2dd622568$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $8efa9bd2dd622568$export$b37e14176d001dec);

var $5lpFe = parcelRequire("5lpFe");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
var $8efa9bd2dd622568$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($8efa9bd2dd622568$var$DisplayName || ($8efa9bd2dd622568$var$DisplayName = {}));
var $8efa9bd2dd622568$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($8efa9bd2dd622568$var$DisplayNameParts || ($8efa9bd2dd622568$var$DisplayNameParts = {}));
var $8efa9bd2dd622568$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $gpjDl.default)();
    var value = props.value, children = props.children, formatProps = (0, $5lpFe.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$8efa9bd2dd622568$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $8efa9bd2dd622568$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $gpjDl.default)();
    var value = props.value, children = props.children, formatProps = (0, $5lpFe.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$8efa9bd2dd622568$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $8efa9bd2dd622568$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $gpjDl.default)();
        var value = props.value, children = props.children, formatProps = (0, $5lpFe.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $8efa9bd2dd622568$var$DisplayNameParts[name];
    return ComponentParts;
}
function $8efa9bd2dd622568$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $gpjDl.default)();
        var value = props.value, children = props.children, formatProps = (0, $5lpFe.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $fc4bM.Fragment;
        return $fc4bM.createElement(Text, null, formattedValue);
    };
    Component.displayName = $8efa9bd2dd622568$var$DisplayName[name];
    return Component;
}

});
parcelRegister("gpjDl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf1e35f37ad45b6a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9cljr = parcelRequire("9cljr");

var $fcCIH = parcelRequire("fcCIH");
function $bf1e35f37ad45b6a$export$2e2bcd8739ae039() {
    var intl = $fc4bM.useContext((0, $fcCIH.Context));
    (0, $9cljr.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("bvUXY", function(module, exports) {
$parcel$export(module.exports, "default", () => $861ec74373dbe541$export$2e2bcd8739ae039);

var $5lpFe = parcelRequire("5lpFe");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
var $861ec74373dbe541$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $gpjDl.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $5lpFe.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $fc4bM.Fragment;
    return $fc4bM.createElement(Text, null, formattedValue);
};
$861ec74373dbe541$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $861ec74373dbe541$export$2e2bcd8739ae039 = $861ec74373dbe541$var$FormattedDateTimeRange;

});

parcelRegister("fd880", function(module, exports) {
$parcel$export(module.exports, "default", () => $b12e5ff858177bf9$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $5lpFe = parcelRequire("5lpFe");

var $fc4bM = parcelRequire("fc4bM");

var $9cljr = parcelRequire("9cljr");

var $gpjDl = parcelRequire("gpjDl");
function $b12e5ff858177bf9$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $5lpFe.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $5lpFe.__rest)(nextProps, [
        "values"
    ]);
    return (0, $9cljr.shallowEqual)(nextValues, values) && (0, $9cljr.shallowEqual)(otherProps, nextOtherProps);
}
function $b12e5ff858177bf9$var$FormattedMessage(props) {
    var intl = (0, $gpjDl.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $fc4bM.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $fc4bM.createElement(Component, null, nodes);
    return $fc4bM.createElement($fc4bM.Fragment, null, nodes);
}
$b12e5ff858177bf9$var$FormattedMessage.displayName = 'FormattedMessage';
var $b12e5ff858177bf9$var$MemoizedFormattedMessage = $fc4bM.memo($b12e5ff858177bf9$var$FormattedMessage, $b12e5ff858177bf9$var$areEqual);
$b12e5ff858177bf9$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $b12e5ff858177bf9$export$2e2bcd8739ae039 = $b12e5ff858177bf9$var$MemoizedFormattedMessage;

});

parcelRegister("3Yl4y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e47523d9f7189a4$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
var $2e47523d9f7189a4$var$FormattedPlural = function(props) {
    var _a = (0, $gpjDl.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $fc4bM.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$2e47523d9f7189a4$var$FormattedPlural.displayName = 'FormattedPlural';
var $2e47523d9f7189a4$export$2e2bcd8739ae039 = $2e47523d9f7189a4$var$FormattedPlural;

});

parcelRegister("95h7S", function(module, exports) {
$parcel$export(module.exports, "default", () => $69d1dd91b6a15e81$export$2e2bcd8739ae039);

var $5lpFe = parcelRequire("5lpFe");

var $fc4bM = parcelRequire("fc4bM");

var $9cljr = parcelRequire("9cljr");

var $gpjDl = parcelRequire("gpjDl");
var $69d1dd91b6a15e81$var$MINUTE = 60;
var $69d1dd91b6a15e81$var$HOUR = 3600;
var $69d1dd91b6a15e81$var$DAY = 86400;
function $69d1dd91b6a15e81$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $69d1dd91b6a15e81$var$MINUTE) return 'second';
    if (absValue < $69d1dd91b6a15e81$var$HOUR) return 'minute';
    if (absValue < $69d1dd91b6a15e81$var$DAY) return 'hour';
    return 'day';
}
function $69d1dd91b6a15e81$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $69d1dd91b6a15e81$var$MINUTE;
        case 'hour':
            return $69d1dd91b6a15e81$var$HOUR;
        default:
            return $69d1dd91b6a15e81$var$DAY;
    }
}
function $69d1dd91b6a15e81$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $69d1dd91b6a15e81$var$MINUTE;
        default:
            return value * $69d1dd91b6a15e81$var$HOUR;
    }
}
var $69d1dd91b6a15e81$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $69d1dd91b6a15e81$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $69d1dd91b6a15e81$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $69d1dd91b6a15e81$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $gpjDl.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $5lpFe.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $fc4bM.createElement(Text, null, formattedRelativeTime);
    return $fc4bM.createElement($fc4bM.Fragment, null, formattedRelativeTime);
};
var $69d1dd91b6a15e81$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $5lpFe.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $9cljr.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $69d1dd91b6a15e81$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $fc4bM.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $fc4bM.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $fc4bM.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($69d1dd91b6a15e81$var$canIncrement(unit) ? $69d1dd91b6a15e81$var$valueToSeconds(value, unit) : 0);
    }
    $fc4bM.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$69d1dd91b6a15e81$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $69d1dd91b6a15e81$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $69d1dd91b6a15e81$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($69d1dd91b6a15e81$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $69d1dd91b6a15e81$var$selectUnit(currentValueInSeconds);
        var unitDuration = $69d1dd91b6a15e81$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $fc4bM.createElement($69d1dd91b6a15e81$var$SimpleFormattedRelativeTime, (0, $5lpFe.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$69d1dd91b6a15e81$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $69d1dd91b6a15e81$export$2e2bcd8739ae039 = $69d1dd91b6a15e81$var$FormattedRelativeTime;

});






parcelRegister("6WJ9J", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => (parcelRequire("cPKAb")).getCmdbFieldValueElement);

var $cPKAb = parcelRequire("cPKAb");

});
parcelRegister("cPKAb", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => $42565e765eb452d7$export$ce19e854d193d5b3);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $iya1I = parcelRequire("iya1I");

var $6LH8a = parcelRequire("6LH8a");

var $8MaoS = parcelRequire("8MaoS");

var $hH2zO = parcelRequire("hH2zO");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $9Ii6A = parcelRequire("9Ii6A");

var $7ZNRj = parcelRequire("7ZNRj");

var $7wx9B = parcelRequire("7wx9B");
parcelRequire("jfcYL");
var $eRuSQ = parcelRequire("eRuSQ");
const $42565e765eb452d7$var$onIntlError = (intlError)=>{
    try {
        $7wx9B.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $42565e765eb452d7$export$3bcefabe8b04378c = (intlError)=>{
    $42565e765eb452d7$var$onIntlError(intlError.message);
};
const $42565e765eb452d7$export$3c09dff16567da2f = (base64String)=>{
    try {
        // Decode base64 string while preserving Unicode characters
        const binaryString = atob(base64String || '');
        const bytes = new Uint8Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
        const decoder = new TextDecoder('utf-8');
        const decodedString = decoder.decode(bytes);
        return JSON.parse(decodedString);
    } catch (e) {
        return null;
    }
};
const $42565e765eb452d7$export$ce19e854d193d5b3 = ()=>{
    class CmdbFieldValueElement extends HTMLElement {
        connectedCallback() {
            // Jira passes the cmdb object data as a data-object-details-base64 attribute
            const objectDetailsBase64 = this.getAttribute('data-object-details-base64');
            const parsedObjectDetails = $42565e765eb452d7$export$3c09dff16567da2f(objectDetailsBase64);
            if (!parsedObjectDetails) return;
            // render the component with its props, and add to the Shadow DOM
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const root = document.createElement('span');
            // eslint-disable-next-line react/no-deprecated
            $bTkYf.render(/*#__PURE__*/ $fc4bM.createElement((0, $8MaoS.default), {
                messages: (0, $9Ii6A.default)(),
                locale: (0, $7ZNRj.getLanguageFromLocale)((0, $6LH8a.getMetaData)().userLocale),
                onError: $42565e765eb452d7$export$3bcefabe8b04378c
            }, /*#__PURE__*/ $fc4bM.createElement((0, $hH2zO.default), {
                onEvent: (0, $aIVqJ.legacySendEvent)
            }, /*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
                sourceName: "portalUnknown",
                sourceType: (0, $eENmG.ScreenTypes).SCREEN,
                attributes: {
                    context: 'Portal'
                }
            }, /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
                packageName: "cmdbFieldValueWebComponent",
                id: "cmdb-object-card",
                renderError: ()=>null
            }, /*#__PURE__*/ $fc4bM.createElement((0, $eRuSQ.default), {
                cmdbObject: parsedObjectDetails
            }))))), root);
            this.appendChild(root);
        }
    }
    return CmdbFieldValueElement;
};

});
parcelRegister("iya1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $364b768c28ede08f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $aIVqJ = parcelRequire("aIVqJ");
const $364b768c28ede08f$var$SENTRY_EXCLUDED_STATUS_CODES = [
    429
];
class $364b768c28ede08f$export$e926676385687eaf extends $fc4bM.Component {
    componentDidCatch(error) {
        const { id: id, createAnalyticsEvent: createAnalyticsEvent, analyticsAttributes: analyticsAttributes, packageName: packageName, onError: onError } = this.props;
        this.setState({
            error: error
        });
        const data = {};
        if (id) data.errorBoundaryId = id;
        if (packageName) data.errorBoundaryPackageName = packageName;
        const shouldExclude = error && error.hasOwnProperty('status') && $364b768c28ede08f$var$SENTRY_EXCLUDED_STATUS_CODES.includes(error.status);
        if (!shouldExclude) (0, $aIVqJ.trackError)('app.boundary.uncaught.error', data, error);
        if (createAnalyticsEvent !== undefined) {
            const analyticsEvent = createAnalyticsEvent({
                ...analyticsAttributes,
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                errorMessage: (0, $aIVqJ.getErrorData)(error)
            });
            // TODO: FSD-4121 switch to using '@atlassian/error-handling'
            // Note that `componentName` is used as `actionSubject` in gasV3 operational events, and takes this form as described at
            // https://hello.atlassian.net/wiki/spaces/ALBS/pages/589347147/Jira+monitoring+frontend+errors#Step-2%3A-register-events
            const finalId = id || 'unknownErrorBoundary';
            const finalPackage = packageName || 'unknownPackage';
            const actionSubject = `${finalPackage}.${finalId}`;
            analyticsEvent.context.push({
                componentName: actionSubject
            });
            analyticsEvent.fire();
        }
        if (onError) onError(error);
    }
    render() {
        const { children: children, renderError: renderError } = this.props;
        const { error: error } = this.state;
        if (error) return renderError ? renderError(error) : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
var $364b768c28ede08f$export$2e2bcd8739ae039 = (0, $613oU.default)()((0, $azARG.default)()($364b768c28ede08f$export$e926676385687eaf));

});
parcelRegister("613oU", function(module, exports) {
$parcel$export(module.exports, "default", () => $91617c42866eb824$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");
const $91617c42866eb824$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $fc4bM.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $91617c42866eb824$export$2e2bcd8739ae039 = $91617c42866eb824$var$withAnalyticsContext;

});

parcelRegister("aIVqJ", function(module, exports) {
$parcel$export(module.exports, "legacySendEvent", () => $d934da38cd6b364c$export$31613c62bfdc6a53);
$parcel$export(module.exports, "sendEventFromAnalyticsBridge", () => $d934da38cd6b364c$export$80c476f25a50624a);
$parcel$export(module.exports, "sendAtlaskitUIEvent", () => $d934da38cd6b364c$export$8c604b65319094be);
$parcel$export(module.exports, "legacyTrackEvent", () => $d934da38cd6b364c$export$d34aefccac2c4e2b);
$parcel$export(module.exports, "getErrorData", () => $d934da38cd6b364c$export$6fd42d413c537998);
$parcel$export(module.exports, "trackError", () => $d934da38cd6b364c$export$5a6ec5e5079bbe35);

var $hN5YJ = parcelRequire("hN5YJ");

var $aVQWM = parcelRequire("aVQWM");

var $eENmG = parcelRequire("eENmG");

var $4MjGQ = parcelRequire("4MjGQ");

var $3l5RH = parcelRequire("3l5RH");

var $7wx9B = parcelRequire("7wx9B");

var $2f8GC = parcelRequire("2f8GC");

var $6lbrU = parcelRequire("6lbrU");

var $3OBUL = parcelRequire("3OBUL");
const $d934da38cd6b364c$var$getMeta = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,  @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    const buildVersion = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION;
    return {
        sessionId: $3OBUL.sessionId,
        context: window.location.pathname,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        version: buildVersion ? buildVersion.buildKey : 'JPF-STORYBOOK-000'
    };
};
function $d934da38cd6b364c$export$31613c62bfdc6a53(event) {
    $d934da38cd6b364c$var$sendEvent(event);
}
function $d934da38cd6b364c$export$80c476f25a50624a(event) {
    $d934da38cd6b364c$var$sendEvent(event, (0, $aVQWM.ANALYTICS_BRIDGE_CHANNEL));
}
function $d934da38cd6b364c$var$sendEvent(event, channel) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) analyticsWebClient.sendEvent(event, channel);
    (0, $2f8GC.reportAnalyticsEvent)(event);
}
const $d934da38cd6b364c$var$extractFromEventContext = (propertyNames, event)=>// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    event.context// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    .reduceRight((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
function $d934da38cd6b364c$export$8c604b65319094be(event) {
    const analyticsWebClient = (0, $6lbrU.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        event.update({
            // Don't override analyticsType if it already exists.
            // Else set it to UI_EVENT_TYPE.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            analyticsType: event.payload.analyticsType || (0, $eENmG.UI_EVENT_TYPE),
            // Extract actionSubjectId from context.
            // Analytics web react enforces it must be defined here - else it won't pick it up.
            // See: https://bitbucket.org/atlassian/analytics-web-react/src/master/src/utils/extract-data-from-event.js?at=master#lines-89
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            actionSubjectId: $d934da38cd6b364c$var$extractFromEventContext([
                'actionSubjectId'
            ], event)[0]
        });
        analyticsWebClient.sendEvent(event);
    }
}
function $d934da38cd6b364c$export$d34aefccac2c4e2b(eventName, data) {
    const mergedData = {
        ...data,
        ...$d934da38cd6b364c$var$getMeta()
    };
    (0, $3l5RH.trackLegacyEvent)(eventName, mergedData);
}
function $d934da38cd6b364c$var$truncateMessage(message, length = 25) {
    if (message === null || message === undefined) return 'null';
    return message.slice(0, length);
}
function $d934da38cd6b364c$var$sendErrorToSentry(error, additionalErrorData) {
    try {
        // log to sentry
        (0, $7wx9B.reportError)(error, additionalErrorData);
    } catch (ex) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access ,@typescript-eslint/no-unsafe-assignment
        const errorMessage = JSON.stringify({
            name: ex.name,
            msg: ex.message
        });
        $d934da38cd6b364c$export$d34aefccac2c4e2b('sentry.error.tracking.failed', {
            error: errorMessage
        });
        (0, $4MjGQ.operationalEvent)({
            action: 'failed',
            actionSubjectId: 'SentryErrorTracking',
            attributes: {
                error: errorMessage,
                ...additionalErrorData
            },
            source: 'unknownSource'
        });
    }
}
/**
 * this error tracking event is to send the caught sentry error to the newer GASv3 analytics as an
 * operational event
 */ function $d934da38cd6b364c$var$sendOperationalErrorEvent(eventName, error, additionalAttribute) {
    (0, $4MjGQ.operationalEvent)({
        action: 'failed',
        actionSubjectId: 'SentryErrorTracking',
        actionSubject: 'sentryError',
        source: 'unknownSource',
        attributes: {
            ...additionalAttribute,
            error: error,
            eventName: eventName
        }
    });
}
function $d934da38cd6b364c$export$6fd42d413c537998(error) {
    let errorData = '';
    if (!error) // undefined error
    errorData = JSON.stringify({
        msg: 'null'
    });
    else if (!!error.xhr) {
        // ajax error
        const ajaxError = error;
        const xhr = ajaxError.xhr;
        errorData = JSON.stringify({
            name: 'AjaxError',
            // we can hard code this here because we know it's an ajax error
            stat: xhr.status,
            msg: $d934da38cd6b364c$var$truncateMessage(ajaxError.message)
        });
    } else if (typeof error === 'string') // error as string
    errorData = JSON.stringify({
        msg: error
    });
    else {
        // generic js error
        const jsError = error;
        errorData = JSON.stringify({
            name: $d934da38cd6b364c$var$truncateMessage(jsError.name),
            msg: $d934da38cd6b364c$var$truncateMessage(jsError.message, 100)
        });
    }
    return errorData;
}
function $d934da38cd6b364c$export$5a6ec5e5079bbe35(eventName, data, error) {
    const errorData = $d934da38cd6b364c$export$6fd42d413c537998(error);
    // Skip sending to Sentry if it's an AjaxError or if filterFromSentry is true
    if (error && !error.xhr && !error.filterFromSentry) {
        if (typeof error === 'string') $d934da38cd6b364c$var$sendErrorToSentry(new Error(error), data);
        else {
            // generic js error
            const jsError = error;
            $d934da38cd6b364c$var$sendErrorToSentry(jsError, data);
        }
    }
    /**  behind the WRM optimisation feature flag and do not fire
   *  operational event for errors caught by error boundary
   */ if ((0, $hN5YJ.isWrmOptimizationsEnabled)() && !(data && data.errorBoundaryId)) $d934da38cd6b364c$var$sendOperationalErrorEvent(eventName, errorData, data);
    const eventData = {
        ...data,
        error: errorData
    };
    return $d934da38cd6b364c$export$d34aefccac2c4e2b(eventName, eventData);
}

});
parcelRegister("3l5RH", function(module, exports) {
$parcel$export(module.exports, "trackLegacyEvent", () => $747266114bca3648$export$655ee831d8b45890);

var $hN5YJ = parcelRequire("hN5YJ");

var $44fTH = parcelRequire("44fTH");

var $3OBUL = parcelRequire("3OBUL");

var $apklp = parcelRequire("apklp");

var $iw2B3 = parcelRequire("iw2B3");

var $2Aj86 = parcelRequire("2Aj86");
const $747266114bca3648$var$sanitizeAnalyticEvent = (eventName, eventProperties)=>{
    // for any new events which have been added to portal frontend whitelist
    // we will add a prefix to the eventname and sanitize its properties
    if ((0, $apklp.isWhiteListEvent)(eventName)) return {
        name: `jsd.portal.frontend.${eventName}`,
        properties: (0, $apklp.sanitizeEventProperties)(eventName, eventProperties)
    };
    // if events not in whitelist, we will let cloud analytic plugin handle it instead
    return {
        name: eventName,
        properties: eventProperties
    };
};
const $747266114bca3648$export$655ee831d8b45890 = (name, data)=>{
    const props = {
        ...data,
        sessionId: $3OBUL.sessionId
    };
    props.sdVersion = (0, $iw2B3.getPluginVersion)() || props.sdVersion || 'unknown';
    props.portalFrontendBuildKey = (0, $iw2B3.getCustomerPortalFrontendBuildKey)() || props.portalFrontendBuildKey || 'unknown';
    const safeEventObject = $747266114bca3648$var$sanitizeAnalyticEvent(name, props);
    // TODO: replace with fireLegacyEvent(safeEventObject) from src/rest/legacy-event
    // the reason now here is to cater for the https://jdog.jira-dev.com/browse/JSDKB-1468 task which
    // still consumes the GASv2 events, this following code should be removed once the above task is fixed
    if ((0, $hN5YJ.isWrmOptimizationsEnabled)()) {
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $2Aj86.fireLegacyEvent)(safeEventObject);
        return;
    }
    const eventQueue = (0, $44fTH.getEventQueue)();
    eventQueue && eventQueue.push(safeEventObject);
};

});
parcelRegister("3OBUL", function(module, exports) {
$parcel$export(module.exports, "sessionId", () => $7acc75a059c42d19$export$f1faf18bafef2950);

var $98yQX = parcelRequire("98yQX");
const $7acc75a059c42d19$export$f1faf18bafef2950 = (0, $98yQX.default)();

});
parcelRegister("98yQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e71588b62a64483a$export$2e2bcd8739ae039);

var $3m6I3 = parcelRequire("3m6I3");
const $e71588b62a64483a$var$s4 = ()=>(0, $3m6I3.default).floor((1 + (0, $3m6I3.default).random()) * 0x10000).toString(16).substring(1);
function $e71588b62a64483a$export$2e2bcd8739ae039() {
    return `${$e71588b62a64483a$var$s4()}${$e71588b62a64483a$var$s4()}-${$e71588b62a64483a$var$s4()}-${$e71588b62a64483a$var$s4()}-${$e71588b62a64483a$var$s4()}-${$e71588b62a64483a$var$s4()}${$e71588b62a64483a$var$s4()}${$e71588b62a64483a$var$s4()}`;
}

});
parcelRegister("3m6I3", function(module, exports) {
$parcel$export(module.exports, "default", () => $43c39ace1e60b19b$export$2e2bcd8739ae039);
// This exists so we can have an easier time stubbing it out in tests.
var $43c39ace1e60b19b$export$2e2bcd8739ae039 = Math;

});



parcelRegister("apklp", function(module, exports) {
$parcel$export(module.exports, "isWhiteListEvent", () => $70ba83ea8b179571$export$364166d55b6d152b);
$parcel$export(module.exports, "sanitizeEventProperties", () => $70ba83ea8b179571$export$fc45a7cd0562e9ff);

var $aYMdQ = parcelRequire("aYMdQ");

var $jios7 = parcelRequire("jios7");
const $70ba83ea8b179571$var$WHITELIST_KEYS = Object.keys($jios7);
const $70ba83ea8b179571$export$364166d55b6d152b = (eventName)=>(0, $aYMdQ.includes)($70ba83ea8b179571$var$WHITELIST_KEYS, eventName);
const $70ba83ea8b179571$export$fc45a7cd0562e9ff = (eventName, eventProperties)=>{
    return (0, $aYMdQ.pick)(eventProperties, $jios7[eventName]);
};

});
parcelRegister("jios7", function(module, exports) {
module.exports = JSON.parse("{\"footer.waclink.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"search.overlay.button.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"session.logout.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"header.avatar.menu.opened\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.profile.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.logout.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.all.requests.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.pending.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.organisation.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.spotlight.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.not.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"request.change.spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"search.result.kb.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.portal.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"sentry.error.tracking.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"helpcenter.search.textbox.focused\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"helpcenter.search.textbox.submit\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.dismiss.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.target.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"spotlightKey\",\"error\"],\"servicedesk.customerview.smartportal.browse.popular.portals.portal.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"portalFrontendBuildKey\"],\"servicedesk.customerview.smartportal.browse.popular.portals.browse.all.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"organisation.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"kbsuggestions.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"findlabel.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"finduser.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"servicedesk.customerview.smartportal.browse.recent.requesttypes.requesttype.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.save.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.cancel.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"async.loader.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"portal.home.announcement.banner.collapse.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"portal.home.announcement.banner.expand.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"categories.fetch.all.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"category.articles.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"raise.request.cta.button\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"]}");

});


parcelRegister("iw2B3", function(module, exports) {
$parcel$export(module.exports, "getPluginVersion", () => $7c44d057dd6db92e$export$face9f52d66c8c0f);
$parcel$export(module.exports, "getCustomerPortalFrontendBuildKey", () => $7c44d057dd6db92e$export$d9a9dd9e37b497b6);

var $44fTH = parcelRequire("44fTH");
const $7c44d057dd6db92e$export$face9f52d66c8c0f = ()=>{
    return (0, $44fTH.getMeta) && (0, $44fTH.getMeta)('sdPluginVersion');
};
const $7c44d057dd6db92e$export$d9a9dd9e37b497b6 = ()=>{
    if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    return undefined;
};

});

parcelRegister("2Aj86", function(module, exports) {
$parcel$export(module.exports, "fireLegacyEvent", () => $6664f4f1c7f45dd1$export$88121588a617f5f9);

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $6664f4f1c7f45dd1$export$88121588a617f5f9 = (event, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/analytics/1.0/publish/bulk`;
    const body = [
        event
    ];
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise();
};

});


parcelRegister("2f8GC", function(module, exports) {
$parcel$export(module.exports, "reportAnalyticsEvent", () => $570ae5344e858383$export$4d9f272573494add);

var $2tNS7 = parcelRequire("2tNS7");
var $8lCud = parcelRequire("8lCud");

var $eENmG = parcelRequire("eENmG");

var $jgb8T = parcelRequire("jgb8T");
const $570ae5344e858383$export$4d9f272573494add = (event)=>{
    try {
        const { analyticsType: analyticsType, action: action, componentName: componentName, actionSubjectId: actionSubjectId, source: source } = [
            ...event.context || [],
            event.payload
        ].reduce((acc, curr)=>({
                ...acc,
                ...curr
            }), {
            eventType: undefined,
            action: undefined,
            componentName: undefined,
            actionSubjectId: undefined,
            source: undefined
        });
        // for screen events, source has the name of the screen
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
        const actionSubject = analyticsType === (0, $eENmG.SCREEN_EVENT_TYPE) ? `screen<${source}>` : componentName;
        if (analyticsType && action && actionSubject) {
            if (analyticsType !== (0, $eENmG.UI_EVENT_TYPE) && analyticsType !== (0, $eENmG.TRACK_EVENT_TYPE) && analyticsType !== (0, $eENmG.OPERATIONAL_EVENT_TYPE) && analyticsType !== (0, $eENmG.SCREEN_EVENT_TYPE)) {
                (0, $jgb8T.devLog)(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `An event was left out of Sentry breadcrumbs because it had an invalid analyticsType: ${analyticsType}.\nAllowed types: ${[
                    (0, $eENmG.UI_EVENT_TYPE),
                    (0, $eENmG.TRACK_EVENT_TYPE),
                    (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                    (0, $eENmG.SCREEN_EVENT_TYPE)
                ].join(', ')}`);
                return;
            }
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const eventDescription = `${analyticsType} ${action} ${actionSubject}`;
            const eventDescriptionWithId = actionSubjectId ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescription}<${actionSubjectId}>` : eventDescription;
            // omit source for screen events because it's already about them!
            const eventMessage = source && analyticsType !== (0, $eENmG.SCREEN_EVENT_TYPE) ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescriptionWithId} from source<${source}>` : eventDescriptionWithId;
            // Scenario: a user clicks on a button with ID myButton on a screen with ID myScreen
            // Here's what's sent as a breadcrumb: ui clicked button<myButton> from source<myScreen>
            // When some data is missing, it's omitted, so we still get a good idea of what was going on.
            $2tNS7.addBreadcrumb({
                category: 'analytics',
                message: eventMessage,
                level: $8lCud.Severity.Info
            });
        }
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.error('Error capturing analytics event as Sentry breadcrumb', exception);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        $2tNS7.captureEvent({
            exception: exception,
            message: 'Error capturing analytics event as Sentry breadcrumb'
        });
    }
};

});



parcelRegister("hH2zO", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c30bbe05d3a2c1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $fTyy7 = parcelRequire("fTyy7");

var $lQOhY = parcelRequire("lQOhY");

var $lQSq2 = parcelRequire("lQSq2");
const $53c30bbe05d3a2c1$var$AnalyticsListener = (props)=>{
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this listener.
    const [isModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(()=>(0, $fTyy7.default) || (0, $dRkX9.fg)('analytics-next-use-legacy-context') === false || (0, $dRkX9.fg)('adminhub-analytics-next-use-modern-context') || (0, $dRkX9.fg)('bitbucket-analytics-next-use-modern-context'));
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lQSq2.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lQOhY.default), props);
};
var $53c30bbe05d3a2c1$export$2e2bcd8739ae039 = $53c30bbe05d3a2c1$var$AnalyticsListener;

});
parcelRegister("lQOhY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b4fb8e9cd0b21e9$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $liKxv = parcelRequire("liKxv");
const $6b4fb8e9cd0b21e9$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
};
const $6b4fb8e9cd0b21e9$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $6b4fb8e9cd0b21e9$var$AnalyticsListener extends (0, $fc4bM.Component) {
    static #_ = this.contextTypes = $6b4fb8e9cd0b21e9$var$ContextTypes;
    static #_2 = this.childContextTypes = $6b4fb8e9cd0b21e9$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $6b4fb8e9cd0b21e9$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $6b4fb8e9cd0b21e9$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $liKxv.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $6b4fb8e9cd0b21e9$export$2e2bcd8739ae039 = $6b4fb8e9cd0b21e9$var$AnalyticsListener;

});

parcelRegister("lQSq2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f32e2458a3f7a32$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $liKxv = parcelRequire("liKxv");

var $cpVgk = parcelRequire("cpVgk");

var $7nxW1 = parcelRequire("7nxW1");
const $9f32e2458a3f7a32$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $cpVgk.useAnalyticsContext)();
    const onEventRef = (0, $7nxW1.useTrackedRef)(onEvent);
    const channelRef = (0, $7nxW1.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $fc4bM.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $fc4bM.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $liKxv.default).Provider, {
        value: value
    }, children);
};
var $9f32e2458a3f7a32$export$2e2bcd8739ae039 = $9f32e2458a3f7a32$var$AnalyticsListener;

});


parcelRegister("jfcYL", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectCard", () => (parcelRequire("eRuSQ")).default);

var $eRuSQ = parcelRequire("eRuSQ");

});
parcelRegister("eRuSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $01041a9cdd8a5bf6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $him7m = parcelRequire("him7m");

var $fcCIH = parcelRequire("fcCIH");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");

var $hculA = parcelRequire("hculA");

var $k2M4v = parcelRequire("k2M4v");

var $4MjGQ = parcelRequire("4MjGQ");
parcelRequire("eJ8cW");
var $7Kp1k = parcelRequire("7Kp1k");
parcelRequire("7XxaT");
var $impvR = parcelRequire("impvR");
parcelRequire("jMtJe");
var $f98TQ = parcelRequire("f98TQ");

var $8qVo1 = parcelRequire("8qVo1");
const $01041a9cdd8a5bf6$var$CmdbObjectCard = ({ cmdbObject: cmdbObject, onExpand: onExpand, intl: intl, hideExpand: hideExpand = false, alwaysShowExpand: alwaysShowExpand = false, isLoadingAttributes: isLoadingAttributes = false })=>{
    var _clientServerBridge$q;
    const [expanded, setExpanded] = (0, $fc4bM.useState)(false);
    const [hasRequestedAttributes, setHasRequestedAttributes] = (0, $fc4bM.useState)(false);
    const handleToggleExpand = ()=>{
        const next = !expanded;
        setExpanded(next);
        // Expand/collapse analytics are only for the new (GA-gated) experience — the old picker
        // must not emit this event.
        if ((0, $k2M4v.default).checkGate('assets_custom_fields_limit_increase_ga')) (0, $4MjGQ.uiEvent)({
            action: next ? 'expanded' : 'collapsed',
            actionSubject: 'cmdbObjectCard',
            source: 'cmdbObjectCard'
        });
        if (next && !hasRequestedAttributes && onExpand && cmdbObject) {
            setHasRequestedAttributes(true);
            onExpand(cmdbObject.id);
        }
    };
    const timezoneId = // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    typeof document !== 'undefined' ? (_clientServerBridge$q = (0, $him7m.default).querySelector('meta[name="user-timezone"]')) === null || _clientServerBridge$q === void 0 ? void 0 : _clientServerBridge$q.getAttribute('content') : undefined;
    if (cmdbObject === null) return intl.formatMessage((0, $8qVo1.default).error);
    const renderChevronButton = ()=>{
        if (hideExpand || cmdbObject.attributes.length === 0 && !alwaysShowExpand) return null;
        const buttonLabel = intl.formatMessage(expanded ? (0, $8qVo1.default).collapseLabel : (0, $8qVo1.default).expandLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $f98TQ.ExpandCollapseToggle), {
            isExpanded: expanded,
            label: buttonLabel,
            onClick: handleToggleExpand,
            testId: "cmdb-object-card-expand-collapse-toggle"
        });
    };
    const containerVariantStyles = [
        $01041a9cdd8a5bf6$var$containerStyles,
        ...hideExpand || alwaysShowExpand ? [
            $01041a9cdd8a5bf6$var$newExperienceCardStyles
        ] : [],
        ...hideExpand ? [
            $01041a9cdd8a5bf6$var$reserveRemoveSpaceStyles
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: containerVariantStyles,
        testId: "cmdb-object-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7Kp1k.MemoizedInsightIcon), {
        ...cmdbObject.avatar.mediaClientConfig,
        iconUrl: cmdbObject.avatar.url48
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $01041a9cdd8a5bf6$var$labelStyles
    }, cmdbObject.label), renderChevronButton()), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $01041a9cdd8a5bf6$var$attributesListContainerStyles
    }, (0, $k2M4v.default).checkGate('assets_custom_fields_limit_increase_ga') && isLoadingAttributes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $01041a9cdd8a5bf6$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
        size: "small",
        label: intl.formatMessage((0, $8qVo1.default).loadingAttributes)
    })), (!(0, $k2M4v.default).checkGate('assets_custom_fields_limit_increase_ga') || !isLoadingAttributes) && cmdbObject.attributes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $impvR.AttributeList), {
        attributes: cmdbObject.attributes,
        timezoneId: timezoneId
    }), (0, $k2M4v.default).checkGate('assets_custom_fields_limit_increase_ga') && !isLoadingAttributes && cmdbObject.attributes.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $01041a9cdd8a5bf6$var$noAttributesStyles,
        role: "status",
        "aria-live": "polite"
    }, intl.formatMessage((0, $8qVo1.default).noAttributes))));
};
var $01041a9cdd8a5bf6$export$2e2bcd8739ae039 = (0, $fcCIH.default)($01041a9cdd8a5bf6$var$CmdbObjectCard);
const $01041a9cdd8a5bf6$var$containerStyles = (0, $kig2V.xcss)({
    position: 'relative',
    width: '100%',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    marginBottom: 'space.100',
    padding: 'space.100',
    boxSizing: 'border-box'
});
const $01041a9cdd8a5bf6$var$newExperienceCardStyles = (0, $kig2V.xcss)({
    marginBottom: 'space.025',
    borderRadius: 'radius.medium'
});
const $01041a9cdd8a5bf6$var$reserveRemoveSpaceStyles = (0, $kig2V.xcss)({
    maxWidth: '100%',
    paddingRight: 'space.400'
});
const $01041a9cdd8a5bf6$var$labelStyles = (0, $kig2V.xcss)({
    font: 'font.body',
    color: 'color.text.subtle',
    margin: 'space.0',
    paddingLeft: 'space.100',
    flexGrow: 1,
    minWidth: 'space.0',
    overflowWrap: 'break-word'
});
const $01041a9cdd8a5bf6$var$attributesListContainerStyles = (0, $kig2V.xcss)({
    marginTop: 'space.200'
});
const $01041a9cdd8a5bf6$var$noAttributesStyles = (0, $kig2V.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtlest'
});
const $01041a9cdd8a5bf6$var$loadingStyles = (0, $kig2V.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingBlock: 'space.100'
});

});
parcelRegister("5a4EU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Box", () => $968613f334143a82$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $968613f334143a82$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $2C58c = parcelRequire("2C58c");

var $6sDmn = parcelRequire("6sDmn");

var $g3724 = parcelRequire("g3724");

var $aVlMc = parcelRequire("aVlMc");

var $hg0W2 = parcelRequire("hg0W2");

var $h8qFH = parcelRequire("h8qFH");
function $968613f334143a82$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $968613f334143a82$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $hg0W2.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $jctmk.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $968613f334143a82$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $6sDmn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $g3724.isSurfaceColorToken)(backgroundColor) && (0, $h8qFH.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $aVlMc.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $aVlMc.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $aVlMc.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $aVlMc.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $aVlMc.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $aVlMc.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $aVlMc.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $2C58c.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$968613f334143a82$export$2e2bcd8739ae039 = $968613f334143a82$export$e71c4d32a2263218;
const $968613f334143a82$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("jctmk", function(module, exports) {
$parcel$export(module.exports, "Global", () => $dfa5e96a7057fe16$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $dfa5e96a7057fe16$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $dfa5e96a7057fe16$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $dfa5e96a7057fe16$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $dfa5e96a7057fe16$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("g7pKS")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("g7pKS")).w);

var $g7pKS = parcelRequire("g7pKS");

var $fc4bM = parcelRequire("fc4bM");

var $cW82w = parcelRequire("cW82w");

var $dUbjW = parcelRequire("dUbjW");

var $dWJZQ = parcelRequire("dWJZQ");
parcelRequire("jpkqT");
parcelRequire("hHCeM");
parcelRequire("a1evj");

parcelRequire("hFHD3");
var $dfa5e96a7057fe16$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $g7pKS.h).call(props, 'css')) return $fc4bM.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $g7pKS.E);
    createElementArgArray[1] = (0, $g7pKS.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $fc4bM.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($dfa5e96a7057fe16$export$c8a8987d4410bf2d || ($dfa5e96a7057fe16$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $dfa5e96a7057fe16$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $g7pKS.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $dWJZQ.serializeStyles)([
        styles
    ], undefined, $fc4bM.useContext((0, $g7pKS.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $fc4bM.useRef();
    (0, $dUbjW.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $dUbjW.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $cW82w.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $dfa5e96a7057fe16$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $dWJZQ.serializeStyles)(args);
}
function $dfa5e96a7057fe16$export$d25ddfdf17c3ad3e() {
    var insertable = $dfa5e96a7057fe16$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $dfa5e96a7057fe16$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $dfa5e96a7057fe16$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $cW82w.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $dfa5e96a7057fe16$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $dUbjW.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $cW82w.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $dfa5e96a7057fe16$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $g7pKS.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $g7pKS.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $dWJZQ.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $cW82w.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $g7pKS.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $dfa5e96a7057fe16$var$merge(cache.registered, css, $dfa5e96a7057fe16$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $fc4bM.useContext((0, $g7pKS.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($dfa5e96a7057fe16$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("g7pKS", function(module, exports) {
$parcel$export(module.exports, "i", () => $bbc1473adeac9643$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $bbc1473adeac9643$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $bbc1473adeac9643$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $bbc1473adeac9643$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $bbc1473adeac9643$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $bbc1473adeac9643$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $bbc1473adeac9643$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $bbc1473adeac9643$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $bbc1473adeac9643$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $bbc1473adeac9643$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $bbc1473adeac9643$export$a9c23c6ac3fc3eca);

var $fc4bM = parcelRequire("fc4bM");

var $jpkqT = parcelRequire("jpkqT");

var $hHCeM = parcelRequire("hHCeM");

var $a1evj = parcelRequire("a1evj");

var $ltzWz = parcelRequire("ltzWz");

var $cW82w = parcelRequire("cW82w");

var $dWJZQ = parcelRequire("dWJZQ");

var $dUbjW = parcelRequire("dUbjW");
var $bbc1473adeac9643$export$23f2a1d2818174ef = false;
var $bbc1473adeac9643$var$EmotionCacheContext = /* #__PURE__ */ $fc4bM.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $jpkqT.default)({
    key: 'css'
}) : null);
var $bbc1473adeac9643$export$e7094788287c5e9b = $bbc1473adeac9643$var$EmotionCacheContext.Provider;
var $bbc1473adeac9643$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $fc4bM.useContext)($bbc1473adeac9643$var$EmotionCacheContext);
};
var $bbc1473adeac9643$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $fc4bM.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $fc4bM.useContext)($bbc1473adeac9643$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $bbc1473adeac9643$export$971d5caa766a69d7 = /* #__PURE__ */ $fc4bM.createContext({});
var $bbc1473adeac9643$export$3b14a55fb2447963 = function useTheme() {
    return $fc4bM.useContext($bbc1473adeac9643$export$971d5caa766a69d7);
};
var $bbc1473adeac9643$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $hHCeM.default)({}, outerTheme, theme);
};
var $bbc1473adeac9643$var$createCacheWithTheme = /* #__PURE__ */ (0, $a1evj.default)(function(outerTheme) {
    return (0, $a1evj.default)(function(theme) {
        return $bbc1473adeac9643$var$getTheme(outerTheme, theme);
    });
});
var $bbc1473adeac9643$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $fc4bM.useContext($bbc1473adeac9643$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $bbc1473adeac9643$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $fc4bM.createElement($bbc1473adeac9643$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $bbc1473adeac9643$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $fc4bM.forwardRef(function render(props, ref) {
        var theme = $fc4bM.useContext($bbc1473adeac9643$export$971d5caa766a69d7);
        return /*#__PURE__*/ $fc4bM.createElement(Component, (0, $hHCeM.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $ltzWz.default)(WithTheme, Component);
}
var $bbc1473adeac9643$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $bbc1473adeac9643$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $bbc1473adeac9643$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($bbc1473adeac9643$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$bbc1473adeac9643$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $bbc1473adeac9643$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cW82w.registerStyles)(cache, serialized, isStringTag);
    (0, $dUbjW.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cW82w.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $bbc1473adeac9643$var$Emotion = /* #__PURE__ */ $bbc1473adeac9643$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$bbc1473adeac9643$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $cW82w.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $dWJZQ.serializeStyles)(registeredStyles, undefined, $fc4bM.useContext($bbc1473adeac9643$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($bbc1473adeac9643$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $bbc1473adeac9643$var$typePropName && !$bbc1473adeac9643$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($bbc1473adeac9643$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, newProps));
});
var $bbc1473adeac9643$export$a9c23c6ac3fc3eca = $bbc1473adeac9643$var$Emotion;

});
parcelRegister("jpkqT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e21033a9dda21e70$export$2e2bcd8739ae039);

var $erT7b = parcelRequire("erT7b");

var $emrom = parcelRequire("emrom");
var $98H6d = parcelRequire("98H6d");
var $l3LCf = parcelRequire("l3LCf");
var $cGbeo = parcelRequire("cGbeo");
var $4sQSk = parcelRequire("4sQSk");
var $ayRND = parcelRequire("ayRND");
parcelRequire("a1evj");
parcelRequire("kMbkQ");
var $e21033a9dda21e70$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $emrom.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $emrom.token)(character)) break;
        (0, $emrom.next)();
    }
    return (0, $emrom.slice)(begin, (0, $emrom.position));
};
var $e21033a9dda21e70$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $emrom.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $emrom.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $e21033a9dda21e70$var$identifierWithPointTracking((0, $emrom.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $emrom.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $emrom.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $98H6d.from)(character);
    }
    while (character = (0, $emrom.next)());
    return parsed;
};
var $e21033a9dda21e70$var$getRules = function getRules(value, points) {
    return (0, $emrom.dealloc)($e21033a9dda21e70$var$toRules((0, $emrom.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $e21033a9dda21e70$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $e21033a9dda21e70$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$e21033a9dda21e70$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $e21033a9dda21e70$var$fixedElements.set(element, true);
    var points = [];
    var rules = $e21033a9dda21e70$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $e21033a9dda21e70$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $e21033a9dda21e70$var$prefix(value, length) {
    switch((0, $98H6d.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cGbeo.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cGbeo.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MOZ) + value + (0, $cGbeo.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + value + value;
        // order
        case 6165:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cGbeo.WEBKIT) + value + (0, $98H6d.replace)(value, /(\w+).+(:[^]+)/, (0, $cGbeo.WEBKIT) + 'box-$1$2' + (0, $cGbeo.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + 'flex-item-' + (0, $98H6d.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + 'flex-line-pack' + (0, $98H6d.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cGbeo.WEBKIT) + 'box-' + (0, $98H6d.replace)(value, '-grow', '') + (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cGbeo.WEBKIT) + (0, $98H6d.replace)(value, /([^-])(transform)/g, '$1' + (0, $cGbeo.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $98H6d.replace)((0, $98H6d.replace)((0, $98H6d.replace)(value, /(zoom-|grab)/, (0, $cGbeo.WEBKIT) + '$1'), /(image-set)/, (0, $cGbeo.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $98H6d.replace)(value, /(image-set\([^]*)/, (0, $cGbeo.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $98H6d.replace)((0, $98H6d.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cGbeo.WEBKIT) + 'box-pack:$3' + (0, $cGbeo.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cGbeo.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $98H6d.replace)(value, /(.+)-inline(.+)/, (0, $cGbeo.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $98H6d.strlen)(value) - 1 - length > 6) switch((0, $98H6d.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $98H6d.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $98H6d.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cGbeo.WEBKIT) + '$2-$3' + '$1' + (0, $cGbeo.MOZ) + ((0, $98H6d.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $98H6d.indexof)(value, 'stretch') ? $e21033a9dda21e70$var$prefix((0, $98H6d.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $98H6d.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $98H6d.charat)(value, (0, $98H6d.strlen)(value) - 3 - (~(0, $98H6d.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $98H6d.replace)(value, ':', ':' + (0, $cGbeo.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $98H6d.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cGbeo.WEBKIT) + ((0, $98H6d.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cGbeo.WEBKIT) + '$2$3' + '$1' + (0, $cGbeo.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $98H6d.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + value + value;
    }
    return value;
}
var $e21033a9dda21e70$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cGbeo.DECLARATION:
                element["return"] = $e21033a9dda21e70$var$prefix(element.value, element.length);
                break;
            case 0, $cGbeo.KEYFRAMES:
                return (0, $ayRND.serialize)([
                    (0, $emrom.copy)(element, {
                        value: (0, $98H6d.replace)(element.value, '@', '@' + (0, $cGbeo.WEBKIT))
                    })
                ], callback);
            case 0, $cGbeo.RULESET:
                if (element.length) return (0, $98H6d.combine)(element.props, function(value) {
                    switch((0, $98H6d.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $ayRND.serialize)([
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(read-\w+)/, ':' + (0, $cGbeo.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $ayRND.serialize)([
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(plac\w+)/, ':' + (0, $cGbeo.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(plac\w+)/, ':' + (0, $cGbeo.MOZ) + '$1')
                                    ]
                                }),
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(plac\w+)/, (0, $cGbeo.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $e21033a9dda21e70$var$defaultStylisPlugins = [
    $e21033a9dda21e70$var$prefixer
];
var $e21033a9dda21e70$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $e21033a9dda21e70$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $e21033a9dda21e70$var$compat,
        $e21033a9dda21e70$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $ayRND.stringify),
        (0, $4sQSk.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $4sQSk.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $ayRND.serialize)((0, $l3LCf.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $erT7b.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("erT7b", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $a84e56fcd86d4898$export$9d753cd7ae895cce);
var $a84e56fcd86d4898$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $a84e56fcd86d4898$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $a84e56fcd86d4898$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $a84e56fcd86d4898$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$a84e56fcd86d4898$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($a84e56fcd86d4898$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $a84e56fcd86d4898$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("emrom", function(module, exports) {
$parcel$export(module.exports, "position", () => $a7485e354d3fa9d7$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $a7485e354d3fa9d7$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $a7485e354d3fa9d7$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $a7485e354d3fa9d7$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $a7485e354d3fa9d7$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $a7485e354d3fa9d7$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $a7485e354d3fa9d7$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $a7485e354d3fa9d7$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $a7485e354d3fa9d7$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $a7485e354d3fa9d7$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $a7485e354d3fa9d7$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $a7485e354d3fa9d7$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $a7485e354d3fa9d7$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $a7485e354d3fa9d7$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $a7485e354d3fa9d7$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $a7485e354d3fa9d7$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $a7485e354d3fa9d7$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $a7485e354d3fa9d7$export$4254d4e2b3745c4c);

var $98H6d = parcelRequire("98H6d");
var $a7485e354d3fa9d7$export$53f1d5ea8de3d7c = 1;
var $a7485e354d3fa9d7$export$4e0c71f277ca26b3 = 1;
var $a7485e354d3fa9d7$export$f24224f1c91d8156 = 0;
var $a7485e354d3fa9d7$export$5880b8b5730aff45 = 0;
var $a7485e354d3fa9d7$export$c0306caf338ac095 = 0;
var $a7485e354d3fa9d7$export$30a86d91af8ff6e6 = '';
function $a7485e354d3fa9d7$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $a7485e354d3fa9d7$export$53f1d5ea8de3d7c,
        column: $a7485e354d3fa9d7$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $a7485e354d3fa9d7$export$784d13d8ee351f07(root, props) {
    return (0, $98H6d.assign)($a7485e354d3fa9d7$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $a7485e354d3fa9d7$export$eba6f6f03b0a92e7() {
    return $a7485e354d3fa9d7$export$c0306caf338ac095;
}
function $a7485e354d3fa9d7$export$232faf9add678146() {
    $a7485e354d3fa9d7$export$c0306caf338ac095 = $a7485e354d3fa9d7$export$5880b8b5730aff45 > 0 ? (0, $98H6d.charat)($a7485e354d3fa9d7$export$30a86d91af8ff6e6, --$a7485e354d3fa9d7$export$5880b8b5730aff45) : 0;
    if ($a7485e354d3fa9d7$export$4e0c71f277ca26b3--, $a7485e354d3fa9d7$export$c0306caf338ac095 === 10) $a7485e354d3fa9d7$export$4e0c71f277ca26b3 = 1, $a7485e354d3fa9d7$export$53f1d5ea8de3d7c--;
    return $a7485e354d3fa9d7$export$c0306caf338ac095;
}
function $a7485e354d3fa9d7$export$48cfd1e771a65c4f() {
    $a7485e354d3fa9d7$export$c0306caf338ac095 = $a7485e354d3fa9d7$export$5880b8b5730aff45 < $a7485e354d3fa9d7$export$f24224f1c91d8156 ? (0, $98H6d.charat)($a7485e354d3fa9d7$export$30a86d91af8ff6e6, $a7485e354d3fa9d7$export$5880b8b5730aff45++) : 0;
    if ($a7485e354d3fa9d7$export$4e0c71f277ca26b3++, $a7485e354d3fa9d7$export$c0306caf338ac095 === 10) $a7485e354d3fa9d7$export$4e0c71f277ca26b3 = 1, $a7485e354d3fa9d7$export$53f1d5ea8de3d7c++;
    return $a7485e354d3fa9d7$export$c0306caf338ac095;
}
function $a7485e354d3fa9d7$export$4d3fb11e950abb9e() {
    return (0, $98H6d.charat)($a7485e354d3fa9d7$export$30a86d91af8ff6e6, $a7485e354d3fa9d7$export$5880b8b5730aff45);
}
function $a7485e354d3fa9d7$export$e88cb2efb12ae807() {
    return $a7485e354d3fa9d7$export$5880b8b5730aff45;
}
function $a7485e354d3fa9d7$export$58adb3bec8346d0f(begin, end) {
    return (0, $98H6d.substr)($a7485e354d3fa9d7$export$30a86d91af8ff6e6, begin, end);
}
function $a7485e354d3fa9d7$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $a7485e354d3fa9d7$export$2de70f21292aac9e(value) {
    return $a7485e354d3fa9d7$export$53f1d5ea8de3d7c = $a7485e354d3fa9d7$export$4e0c71f277ca26b3 = 1, $a7485e354d3fa9d7$export$f24224f1c91d8156 = (0, $98H6d.strlen)($a7485e354d3fa9d7$export$30a86d91af8ff6e6 = value), $a7485e354d3fa9d7$export$5880b8b5730aff45 = 0, [];
}
function $a7485e354d3fa9d7$export$45918ac1574455b1(value) {
    return $a7485e354d3fa9d7$export$30a86d91af8ff6e6 = '', value;
}
function $a7485e354d3fa9d7$export$410ac95b9ec204b8(type) {
    return (0, $98H6d.trim)($a7485e354d3fa9d7$export$58adb3bec8346d0f($a7485e354d3fa9d7$export$5880b8b5730aff45 - 1, $a7485e354d3fa9d7$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $a7485e354d3fa9d7$export$660b2ee2d4fb4eff(value) {
    return $a7485e354d3fa9d7$export$45918ac1574455b1($a7485e354d3fa9d7$export$5f8c09e3ae6f64e1($a7485e354d3fa9d7$export$2de70f21292aac9e(value)));
}
function $a7485e354d3fa9d7$export$7af1228ff777d175(type) {
    while($a7485e354d3fa9d7$export$c0306caf338ac095 = $a7485e354d3fa9d7$export$4d3fb11e950abb9e())if ($a7485e354d3fa9d7$export$c0306caf338ac095 < 33) $a7485e354d3fa9d7$export$48cfd1e771a65c4f();
    else break;
    return $a7485e354d3fa9d7$export$9e1725a4cfeada27(type) > 2 || $a7485e354d3fa9d7$export$9e1725a4cfeada27($a7485e354d3fa9d7$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $a7485e354d3fa9d7$export$5f8c09e3ae6f64e1(children) {
    while($a7485e354d3fa9d7$export$48cfd1e771a65c4f())switch($a7485e354d3fa9d7$export$9e1725a4cfeada27($a7485e354d3fa9d7$export$c0306caf338ac095)){
        case 0:
            (0, $98H6d.append)($a7485e354d3fa9d7$export$c2ab62c7bf24634($a7485e354d3fa9d7$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $98H6d.append)($a7485e354d3fa9d7$export$410ac95b9ec204b8($a7485e354d3fa9d7$export$c0306caf338ac095), children);
            break;
        default:
            (0, $98H6d.append)((0, $98H6d.from)($a7485e354d3fa9d7$export$c0306caf338ac095), children);
    }
    return children;
}
function $a7485e354d3fa9d7$export$955ba06d119e085e(index, count) {
    while(--count && $a7485e354d3fa9d7$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($a7485e354d3fa9d7$export$c0306caf338ac095 < 48 || $a7485e354d3fa9d7$export$c0306caf338ac095 > 102 || $a7485e354d3fa9d7$export$c0306caf338ac095 > 57 && $a7485e354d3fa9d7$export$c0306caf338ac095 < 65 || $a7485e354d3fa9d7$export$c0306caf338ac095 > 70 && $a7485e354d3fa9d7$export$c0306caf338ac095 < 97) break;
    return $a7485e354d3fa9d7$export$58adb3bec8346d0f(index, $a7485e354d3fa9d7$export$e88cb2efb12ae807() + (count < 6 && $a7485e354d3fa9d7$export$4d3fb11e950abb9e() == 32 && $a7485e354d3fa9d7$export$48cfd1e771a65c4f() == 32));
}
function $a7485e354d3fa9d7$export$c889f2fcc19dbf12(type) {
    while($a7485e354d3fa9d7$export$48cfd1e771a65c4f())switch($a7485e354d3fa9d7$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $a7485e354d3fa9d7$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $a7485e354d3fa9d7$export$c889f2fcc19dbf12($a7485e354d3fa9d7$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $a7485e354d3fa9d7$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $a7485e354d3fa9d7$export$48cfd1e771a65c4f();
            break;
    }
    return $a7485e354d3fa9d7$export$5880b8b5730aff45;
}
function $a7485e354d3fa9d7$export$4254d4e2b3745c4c(type, index) {
    while($a7485e354d3fa9d7$export$48cfd1e771a65c4f())// //
    if (type + $a7485e354d3fa9d7$export$c0306caf338ac095 === 57) break;
    else if (type + $a7485e354d3fa9d7$export$c0306caf338ac095 === 84 && $a7485e354d3fa9d7$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $a7485e354d3fa9d7$export$58adb3bec8346d0f(index, $a7485e354d3fa9d7$export$5880b8b5730aff45 - 1) + '*' + (0, $98H6d.from)(type === 47 ? type : $a7485e354d3fa9d7$export$48cfd1e771a65c4f());
}
function $a7485e354d3fa9d7$export$c2ab62c7bf24634(index) {
    while(!$a7485e354d3fa9d7$export$9e1725a4cfeada27($a7485e354d3fa9d7$export$4d3fb11e950abb9e()))$a7485e354d3fa9d7$export$48cfd1e771a65c4f();
    return $a7485e354d3fa9d7$export$58adb3bec8346d0f(index, $a7485e354d3fa9d7$export$5880b8b5730aff45);
}

});
parcelRegister("98H6d", function(module, exports) {
$parcel$export(module.exports, "abs", () => $6a764b09b3cf037a$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $6a764b09b3cf037a$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $6a764b09b3cf037a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $6a764b09b3cf037a$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $6a764b09b3cf037a$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $6a764b09b3cf037a$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $6a764b09b3cf037a$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $6a764b09b3cf037a$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $6a764b09b3cf037a$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $6a764b09b3cf037a$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $6a764b09b3cf037a$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $6a764b09b3cf037a$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $6a764b09b3cf037a$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $6a764b09b3cf037a$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $6a764b09b3cf037a$export$2335f513bbd82c6d = Math.abs;
var $6a764b09b3cf037a$export$6788812c4e6611e6 = String.fromCharCode;
var $6a764b09b3cf037a$export$e6e34fd1f2686227 = Object.assign;
function $6a764b09b3cf037a$export$d6af199866bfb566(value, length) {
    return $6a764b09b3cf037a$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $6a764b09b3cf037a$export$a9db5e087081082d(value, 0)) << 2 ^ $6a764b09b3cf037a$export$a9db5e087081082d(value, 1)) << 2 ^ $6a764b09b3cf037a$export$a9db5e087081082d(value, 2)) << 2 ^ $6a764b09b3cf037a$export$a9db5e087081082d(value, 3) : 0;
}
function $6a764b09b3cf037a$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $6a764b09b3cf037a$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $6a764b09b3cf037a$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $6a764b09b3cf037a$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $6a764b09b3cf037a$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $6a764b09b3cf037a$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $6a764b09b3cf037a$export$36776f635604f274(value) {
    return value.length;
}
function $6a764b09b3cf037a$export$f9084667e487ed46(value) {
    return value.length;
}
function $6a764b09b3cf037a$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $6a764b09b3cf037a$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("l3LCf", function(module, exports) {
$parcel$export(module.exports, "compile", () => $f54ed052fa1e651b$export$ef7acd7185315e22);

var $cGbeo = parcelRequire("cGbeo");

var $98H6d = parcelRequire("98H6d");

var $emrom = parcelRequire("emrom");
function $f54ed052fa1e651b$export$ef7acd7185315e22(value) {
    return (0, $emrom.dealloc)($f54ed052fa1e651b$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $emrom.alloc)(value), 0, [
        0
    ], value));
}
function $f54ed052fa1e651b$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $emrom.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $98H6d.charat)(characters, length - 1) == 58) {
                if ((0, $98H6d.indexof)(characters += (0, $98H6d.replace)((0, $emrom.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $emrom.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $emrom.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $emrom.escaping)((0, $emrom.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $emrom.peek)()){
                case 42:
                case 47:
                    (0, $98H6d.append)($f54ed052fa1e651b$export$4a34f930e789283c((0, $emrom.commenter)((0, $emrom.next)(), (0, $emrom.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $98H6d.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $98H6d.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $98H6d.strlen)(characters) - length) (0, $98H6d.append)(property > 32 ? $f54ed052fa1e651b$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $f54ed052fa1e651b$export$f8483753829ec8f3((0, $98H6d.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $98H6d.append)(reference = $f54ed052fa1e651b$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $f54ed052fa1e651b$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $98H6d.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f54ed052fa1e651b$export$98e6a39c04603d36(value, reference, reference, rule && (0, $98H6d.append)($f54ed052fa1e651b$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $f54ed052fa1e651b$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $98H6d.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $emrom.prev)() == 125) continue;
            }
            switch(characters += (0, $98H6d.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $98H6d.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $emrom.peek)() === 45) characters += (0, $emrom.delimit)((0, $emrom.next)());
                    atrule = (0, $emrom.peek)(), offset = length = (0, $98H6d.strlen)(type = characters += (0, $emrom.identifier)((0, $emrom.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $98H6d.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $f54ed052fa1e651b$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $98H6d.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $98H6d.substr)(value, post + 1, post = (0, $98H6d.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $98H6d.trim)(j > 0 ? rule[x] + ' ' + y : (0, $98H6d.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $emrom.node)(value, root, parent, offset === 0 ? (0, $cGbeo.RULESET) : type, props, children, length);
}
function $f54ed052fa1e651b$export$4a34f930e789283c(value, root, parent) {
    return (0, $emrom.node)(value, root, parent, (0, $cGbeo.COMMENT), (0, $98H6d.from)((0, $emrom.char)()), (0, $98H6d.substr)(value, 2, -2), 0);
}
function $f54ed052fa1e651b$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $emrom.node)(value, root, parent, (0, $cGbeo.DECLARATION), (0, $98H6d.substr)(value, 0, length), (0, $98H6d.substr)(value, length + 1, -1), length);
}

});
parcelRegister("cGbeo", function(module, exports) {
$parcel$export(module.exports, "MS", () => $93b21e8ca92e8c5a$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $93b21e8ca92e8c5a$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $93b21e8ca92e8c5a$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $93b21e8ca92e8c5a$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $93b21e8ca92e8c5a$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $93b21e8ca92e8c5a$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $93b21e8ca92e8c5a$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $93b21e8ca92e8c5a$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $93b21e8ca92e8c5a$export$d773506282b3cfe6);
var $93b21e8ca92e8c5a$export$71ad59f2e432cfe8 = '-ms-';
var $93b21e8ca92e8c5a$export$2c0f367103c8d01c = '-moz-';
var $93b21e8ca92e8c5a$export$39dfd62a25e0fe93 = '-webkit-';
var $93b21e8ca92e8c5a$export$a29989082612d0d9 = 'comm';
var $93b21e8ca92e8c5a$export$aa3a2e812ca8570d = 'rule';
var $93b21e8ca92e8c5a$export$527d108ccf083c2b = 'decl';
var $93b21e8ca92e8c5a$export$d3d35020fa5b54f0 = '@page';
var $93b21e8ca92e8c5a$export$500415a86c544f73 = '@media';
var $93b21e8ca92e8c5a$export$a763edbf796b780a = '@import';
var $93b21e8ca92e8c5a$export$2790aeb8b4e5c826 = '@charset';
var $93b21e8ca92e8c5a$export$1cc683e23b84b133 = '@viewport';
var $93b21e8ca92e8c5a$export$9447a5efea57e862 = '@supports';
var $93b21e8ca92e8c5a$export$ef011b4e114b1fba = '@document';
var $93b21e8ca92e8c5a$export$6aad947bda0f3f46 = '@namespace';
var $93b21e8ca92e8c5a$export$b44a8529a35fcb60 = '@keyframes';
var $93b21e8ca92e8c5a$export$2c16de31893252e6 = '@font-face';
var $93b21e8ca92e8c5a$export$3d846dd52e150c6f = '@counter-style';
var $93b21e8ca92e8c5a$export$22314bfbb57653fe = '@font-feature-values';
var $93b21e8ca92e8c5a$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("4sQSk", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $3402cada8fdb9a0f$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $3402cada8fdb9a0f$export$38bcb760f1d4871c);

var $cGbeo = parcelRequire("cGbeo");

var $98H6d = parcelRequire("98H6d");

var $emrom = parcelRequire("emrom");

var $ayRND = parcelRequire("ayRND");

var $4hI3i = parcelRequire("4hI3i");
function $3402cada8fdb9a0f$export$5a7767152ae0305f(collection) {
    var length = (0, $98H6d.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $3402cada8fdb9a0f$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $3402cada8fdb9a0f$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $cGbeo.DECLARATION:
                element.return = (0, $4hI3i.prefix)(element.value, element.length, children);
                return;
            case 0, $cGbeo.KEYFRAMES:
                return (0, $ayRND.serialize)([
                    (0, $emrom.copy)(element, {
                        value: (0, $98H6d.replace)(element.value, '@', '@' + (0, $cGbeo.WEBKIT))
                    })
                ], callback);
            case 0, $cGbeo.RULESET:
                if (element.length) return (0, $98H6d.combine)(element.props, function(value) {
                    switch((0, $98H6d.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $ayRND.serialize)([
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(read-\w+)/, ':' + (0, $cGbeo.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $ayRND.serialize)([
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(plac\w+)/, ':' + (0, $cGbeo.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(plac\w+)/, ':' + (0, $cGbeo.MOZ) + '$1')
                                    ]
                                }),
                                (0, $emrom.copy)(element, {
                                    props: [
                                        (0, $98H6d.replace)(value, /:(plac\w+)/, (0, $cGbeo.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $3402cada8fdb9a0f$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $cGbeo.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $98H6d.combine)((0, $emrom.tokenize)(value), function(value, index, children) {
                    switch((0, $98H6d.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $98H6d.substr)(value, 1, (0, $98H6d.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $98H6d.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $98H6d.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $98H6d.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("ayRND", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $7b06cfd0d1afee0f$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $7b06cfd0d1afee0f$export$fac44ee5b035f737);

var $cGbeo = parcelRequire("cGbeo");

var $98H6d = parcelRequire("98H6d");
function $7b06cfd0d1afee0f$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $98H6d.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $7b06cfd0d1afee0f$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $cGbeo.LAYER:
            if (element.children.length) break;
        case 0, $cGbeo.IMPORT:
        case 0, $cGbeo.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $cGbeo.COMMENT:
            return '';
        case 0, $cGbeo.KEYFRAMES:
            return element.return = element.value + '{' + $7b06cfd0d1afee0f$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $cGbeo.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $98H6d.strlen)(children = $7b06cfd0d1afee0f$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("4hI3i", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $31eaebcdc6aef615$export$82e9f45cca5ba907);

var $cGbeo = parcelRequire("cGbeo");

var $98H6d = parcelRequire("98H6d");
function $31eaebcdc6aef615$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $98H6d.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cGbeo.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cGbeo.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $cGbeo.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MOZ) + value + (0, $cGbeo.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $98H6d.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + value + value;
        // order
        case 6165:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cGbeo.WEBKIT) + value + (0, $98H6d.replace)(value, /(\w+).+(:[^]+)/, (0, $cGbeo.WEBKIT) + 'box-$1$2' + (0, $cGbeo.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + 'flex-item-' + (0, $98H6d.replace)(value, /flex-|-self/g, '') + (!(0, $98H6d.match)(value, /flex-|baseline/) ? (0, $cGbeo.MS) + 'grid-row-' + (0, $98H6d.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + 'flex-line-pack' + (0, $98H6d.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cGbeo.WEBKIT) + 'box-' + (0, $98H6d.replace)(value, '-grow', '') + (0, $cGbeo.WEBKIT) + value + (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cGbeo.WEBKIT) + (0, $98H6d.replace)(value, /([^-])(transform)/g, '$1' + (0, $cGbeo.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $98H6d.replace)((0, $98H6d.replace)((0, $98H6d.replace)(value, /(zoom-|grab)/, (0, $cGbeo.WEBKIT) + '$1'), /(image-set)/, (0, $cGbeo.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $98H6d.replace)(value, /(image-set\([^]*)/, (0, $cGbeo.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $98H6d.replace)((0, $98H6d.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cGbeo.WEBKIT) + 'box-pack:$3' + (0, $cGbeo.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cGbeo.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $98H6d.match)(value, /flex-|baseline/)) return (0, $cGbeo.MS) + 'grid-column-align' + (0, $98H6d.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $cGbeo.MS) + (0, $98H6d.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $98H6d.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $98H6d.indexof)(value + (children = children[length].value), 'span') ? value : (0, $cGbeo.MS) + (0, $98H6d.replace)(value, '-start', '') + value + (0, $cGbeo.MS) + 'grid-row-span:' + (~(0, $98H6d.indexof)(children, 'span') ? (0, $98H6d.match)(children, /\d+/) : +(0, $98H6d.match)(children, /\d+/) - +(0, $98H6d.match)(value, /\d+/)) + ';';
            return (0, $cGbeo.MS) + (0, $98H6d.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $98H6d.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $cGbeo.MS) + (0, $98H6d.replace)((0, $98H6d.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $98H6d.replace)(value, /(.+)-inline(.+)/, (0, $cGbeo.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $98H6d.strlen)(value) - 1 - length > 6) switch((0, $98H6d.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $98H6d.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $98H6d.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cGbeo.WEBKIT) + '$2-$3' + '$1' + (0, $cGbeo.MOZ) + ((0, $98H6d.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $98H6d.indexof)(value, 'stretch') ? $31eaebcdc6aef615$export$82e9f45cca5ba907((0, $98H6d.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $98H6d.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $cGbeo.MS) + a + ':' + b + f + (c ? (0, $cGbeo.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $98H6d.charat)(value, length + 6) === 121) return (0, $98H6d.replace)(value, ':', ':' + (0, $cGbeo.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $98H6d.charat)(value, (0, $98H6d.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $98H6d.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $cGbeo.WEBKIT) + ((0, $98H6d.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cGbeo.WEBKIT) + '$2$3' + '$1' + (0, $cGbeo.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $98H6d.replace)(value, ':', ':' + (0, $cGbeo.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $98H6d.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("a1evj", function(module, exports) {
$parcel$export(module.exports, "default", () => $74b53f93dc56e509$export$2e2bcd8739ae039);
var $74b53f93dc56e509$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("kMbkQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $03e73e474ddda2f7$export$2e2bcd8739ae039);
function $03e73e474ddda2f7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("ltzWz", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2830153bd4c1c0$export$2e2bcd8739ae039);

var $hFHD3 = parcelRequire("hFHD3");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $fa2830153bd4c1c0$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hFHD3)))(targetComponent, sourceComponent);
};

});

parcelRegister("cW82w", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $96b1235217f5db68$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $96b1235217f5db68$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $96b1235217f5db68$export$6f077d94b33a01aa);
var $96b1235217f5db68$var$isBrowser = true;
function $96b1235217f5db68$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $96b1235217f5db68$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $96b1235217f5db68$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $96b1235217f5db68$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $96b1235217f5db68$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("dWJZQ", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $a2745f1c6ab3d7fe$export$6321afa313b251b5);

var $lVpAE = parcelRequire("lVpAE");

var $7311G = parcelRequire("7311G");

var $kMbkQ = parcelRequire("kMbkQ");
var $a2745f1c6ab3d7fe$var$isDevelopment = false;
var $a2745f1c6ab3d7fe$var$hyphenateRegex = /[A-Z]|^ms/g;
var $a2745f1c6ab3d7fe$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $a2745f1c6ab3d7fe$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $a2745f1c6ab3d7fe$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $a2745f1c6ab3d7fe$var$processStyleName = /* #__PURE__ */ (0, $kMbkQ.default)(function(styleName) {
    return $a2745f1c6ab3d7fe$var$isCustomProperty(styleName) ? styleName : styleName.replace($a2745f1c6ab3d7fe$var$hyphenateRegex, '-$&').toLowerCase();
});
var $a2745f1c6ab3d7fe$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($a2745f1c6ab3d7fe$var$animationRegex, function(match, p1, p2) {
                $a2745f1c6ab3d7fe$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $a2745f1c6ab3d7fe$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7311G.default)[key] !== 1 && !$a2745f1c6ab3d7fe$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $a2745f1c6ab3d7fe$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $a2745f1c6ab3d7fe$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $a2745f1c6ab3d7fe$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $a2745f1c6ab3d7fe$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $a2745f1c6ab3d7fe$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $a2745f1c6ab3d7fe$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $a2745f1c6ab3d7fe$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $a2745f1c6ab3d7fe$var$cursor;
                var result = interpolation(mergedProps);
                $a2745f1c6ab3d7fe$var$cursor = previousCursor;
                return $a2745f1c6ab3d7fe$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $a2745f1c6ab3d7fe$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $a2745f1c6ab3d7fe$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($a2745f1c6ab3d7fe$var$isProcessableValue(asString)) string += $a2745f1c6ab3d7fe$var$processStyleName(key) + ":" + $a2745f1c6ab3d7fe$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $a2745f1c6ab3d7fe$var$isDevelopment) throw new Error($a2745f1c6ab3d7fe$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($a2745f1c6ab3d7fe$var$isProcessableValue(value[_i])) string += $a2745f1c6ab3d7fe$var$processStyleName(key) + ":" + $a2745f1c6ab3d7fe$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $a2745f1c6ab3d7fe$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $a2745f1c6ab3d7fe$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $a2745f1c6ab3d7fe$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $a2745f1c6ab3d7fe$var$cursor;
function $a2745f1c6ab3d7fe$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $a2745f1c6ab3d7fe$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $a2745f1c6ab3d7fe$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $a2745f1c6ab3d7fe$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $a2745f1c6ab3d7fe$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $a2745f1c6ab3d7fe$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $lVpAE.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $a2745f1c6ab3d7fe$var$cursor
    };
}

});
parcelRegister("lVpAE", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff62c584030ad339$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $ff62c584030ad339$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("7311G", function(module, exports) {
$parcel$export(module.exports, "default", () => $52199bfeaf302f17$export$2e2bcd8739ae039);
var $52199bfeaf302f17$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("dUbjW", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $a1f9496479d51a76$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $a1f9496479d51a76$export$811a713a7276cb9d);

var $fc4bM = parcelRequire("fc4bM");
var $a1f9496479d51a76$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1f9496479d51a76$var$useInsertionEffect = false;
var $a1f9496479d51a76$export$db21c7ffa21794e7 = $a1f9496479d51a76$var$useInsertionEffect || $a1f9496479d51a76$var$syncFallback;
var $a1f9496479d51a76$export$811a713a7276cb9d = $a1f9496479d51a76$var$useInsertionEffect || $fc4bM.useLayoutEffect;

});



parcelRegister("2C58c", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $48997634f6297551$export$1ca2a26fecb070ae);

var $fc4bM = parcelRequire("fc4bM");
const $48997634f6297551$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $fc4bM.createContext)('elevation.surface');

});

parcelRegister("6sDmn", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $0df6f4f100ba8e57$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aCIQh = parcelRequire("aCIQh");

var $hDCFn = parcelRequire("hDCFn");
const $0df6f4f100ba8e57$export$e7af83bafe7f9e63 = (0, $hDCFn.getSerializedStylesMap)('backgroundColor', (0, $aCIQh.backgroundColorMap));

});
parcelRegister("aCIQh", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $f57d74d1e4d520e5$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b9ffd6dcccead720baadbffd4a1648a>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $f57d74d1e4d520e5$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("hDCFn", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $8df049c647ee9611$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
const $8df049c647ee9611$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = /*#__PURE__*/ (0, $jctmk.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("g3724", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $7d5ad47fa496033d$export$5e65a44e5b6ecadb);

var $62UX5 = parcelRequire("62UX5");
const $7d5ad47fa496033d$export$5e65a44e5b6ecadb = (color)=>(0, $62UX5.surfaceColorMap)[color] !== undefined;

});
parcelRegister("62UX5", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $275071c5ffcc42ec$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c124f7044e82421c90bec6e00efe281>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $275071c5ffcc42ec$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("aVlMc", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $d61bd3384e4936f9$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hlKtg = parcelRequire("hlKtg");

var $gkD7x = parcelRequire("gkD7x");
const $d61bd3384e4936f9$export$e615f061ca585a6c = (0, $hlKtg.createSpacingStylesMap)((0, $gkD7x.positiveSpaceMap), [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd'
]);

});
parcelRegister("hlKtg", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $bde9f1b64927fced$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hDCFn = parcelRequire("hDCFn");
const $bde9f1b64927fced$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $bde9f1b64927fced$export$f2bee1f59203ac70 = (tokenMap, properties)=>{
    return properties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $hDCFn.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("gkD7x", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $646792f029ab82d4$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd46ff4a983762dcab797228d1ab2ee6>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $646792f029ab82d4$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("hg0W2", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $79e148fa1aef795c$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ /* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("fc4bM");

var $5PYMS = parcelRequire("5PYMS");
const $79e148fa1aef795c$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $79e148fa1aef795c$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $5PYMS.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("5PYMS", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $511065d9f5635abb$export$43e479c916cb4ada);
const $511065d9f5635abb$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("h8qFH", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $8e8a2bf243ba503b$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $h6oew = parcelRequire("h6oew");

var $hDCFn = parcelRequire("hDCFn");

var $62UX5 = parcelRequire("62UX5");
const $8e8a2bf243ba503b$export$ff257d957d48c421 = (0, $hDCFn.getSerializedStylesMap)((0, $h6oew.CURRENT_SURFACE_CSS_VAR), (0, $62UX5.surfaceColorMap));

});
parcelRegister("h6oew", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $071b00ecda3bb374$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $071b00ecda3bb374$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $071b00ecda3bb374$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $071b00ecda3bb374$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $071b00ecda3bb374$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $071b00ecda3bb374$export$9d7b58831ae93caa);
const $071b00ecda3bb374$export$4ef52930e33717cd = 'data-theme';
const $071b00ecda3bb374$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $071b00ecda3bb374$export$a00eac3f8684bcd0 = 'data-color-mode';
const $071b00ecda3bb374$export$2112803007239c61 = 'data-contrast-mode';
const $071b00ecda3bb374$export$352e418ed5b6193a = 'data-custom-theme';
const $071b00ecda3bb374$export$6f0c6fb8c80fcc92 = 'ds';
const $071b00ecda3bb374$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $071b00ecda3bb374$export$dddac1532e822863 = `--${$071b00ecda3bb374$export$6f0c6fb8c80fcc92}-token-not-found`;
const $071b00ecda3bb374$export$9d7b58831ae93caa = `--${$071b00ecda3bb374$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});



parcelRegister("lgMZ2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Inline", () => $f92a888c03d50d9f$export$fbae5b5ffd8af05e);
$parcel$export(module.exports, "default", () => $f92a888c03d50d9f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $kig2V = parcelRequire("kig2V");

var $1JdzP = parcelRequire("1JdzP");
const $f92a888c03d50d9f$var$flexGrowMap = {
    hug: (0, $kig2V.xcss)({
        flexGrow: 0
    }),
    fill: (0, $kig2V.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $f92a888c03d50d9f$var$separatorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $f92a888c03d50d9f$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: $f92a888c03d50d9f$var$separatorStyles
    }, children);
const $f92a888c03d50d9f$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $jctmk.jsx)($f92a888c03d50d9f$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $fc4bM.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $f92a888c03d50d9f$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $1JdzP.Flex), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f92a888c03d50d9f$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f92a888c03d50d9f$export$2e2bcd8739ae039 = $f92a888c03d50d9f$export$fbae5b5ffd8af05e;

});
parcelRegister("kig2V", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $ca69919a3a7934e0$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $eHD4S = parcelRequire("eHD4S");

var $5PYMS = parcelRequire("5PYMS");

var $3jCFs = parcelRequire("3jCFs");
const $ca69919a3a7934e0$var$isSafeEnvToThrow = ()=>typeof $3jCFs === 'object' && typeof $3jCFs.env === 'object' && false;
const $ca69919a3a7934e0$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $ca69919a3a7934e0$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $ca69919a3a7934e0$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($ca69919a3a7934e0$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $ca69919a3a7934e0$var$safeSelectors.test(key)) {
            styleObj[key] = $ca69919a3a7934e0$var$transformStyles(value);
            return;
        }
        if ($ca69919a3a7934e0$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($ca69919a3a7934e0$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $eHD4S.tokensMap))) return;
        const tokenValue = (0, $eHD4S.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $ca69919a3a7934e0$var$baseXcss = (style)=>{
    const transformedStyles = $ca69919a3a7934e0$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $5PYMS.uniqueSymbol)]: /*#__PURE__*/ (0, $jctmk.css)(transformedStyles)
    };
};
function $ca69919a3a7934e0$export$f6c783d06584602c(style) {
    return $ca69919a3a7934e0$var$baseXcss(style);
}

});
parcelRegister("eHD4S", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $dcb3cfe35347a556$export$9a199fbafee0014e);

var $64r8F = parcelRequire("64r8F");

var $aCIQh = parcelRequire("aCIQh");

var $d8xIF = parcelRequire("d8xIF");

var $hZqiq = parcelRequire("hZqiq");

var $8nNtm = parcelRequire("8nNtm");

var $jqMUP = parcelRequire("jqMUP");

var $cFlSN = parcelRequire("cFlSN");

var $1HrWA = parcelRequire("1HrWA");

var $2MF4J = parcelRequire("2MF4J");

var $5hXax = parcelRequire("5hXax");

var $dr8IU = parcelRequire("dr8IU");

var $jsyAC = parcelRequire("jsyAC");

var $gkD7x = parcelRequire("gkD7x");

var $dNUST = parcelRequire("dNUST");

var $1tNk5 = parcelRequire("1tNk5");
const $dcb3cfe35347a556$export$9a199fbafee0014e = {
    backgroundColor: (0, $aCIQh.backgroundColorMap),
    blockSize: (0, $jqMUP.dimensionMap),
    borderBlockColor: (0, $d8xIF.borderColorMap),
    borderBlockEndColor: (0, $d8xIF.borderColorMap),
    borderBlockEndWidth: (0, $8nNtm.borderWidthMap),
    borderBlockStartColor: (0, $d8xIF.borderColorMap),
    borderBlockStartWidth: (0, $8nNtm.borderWidthMap),
    borderBlockWidth: (0, $8nNtm.borderWidthMap),
    borderBottomColor: (0, $d8xIF.borderColorMap),
    borderBottomLeftRadius: (0, $hZqiq.borderRadiusMap),
    borderBottomRightRadius: (0, $hZqiq.borderRadiusMap),
    borderBottomWidth: (0, $8nNtm.borderWidthMap),
    borderColor: (0, $d8xIF.borderColorMap),
    borderEndEndRadius: (0, $hZqiq.borderRadiusMap),
    borderEndStartRadius: (0, $hZqiq.borderRadiusMap),
    borderInlineColor: (0, $d8xIF.borderColorMap),
    borderInlineEndColor: (0, $d8xIF.borderColorMap),
    borderInlineEndWidth: (0, $8nNtm.borderWidthMap),
    borderInlineStartColor: (0, $d8xIF.borderColorMap),
    borderInlineStartWidth: (0, $8nNtm.borderWidthMap),
    borderInlineWidth: (0, $8nNtm.borderWidthMap),
    borderLeftColor: (0, $d8xIF.borderColorMap),
    borderLeftWidth: (0, $8nNtm.borderWidthMap),
    borderRadius: (0, $hZqiq.borderRadiusMap),
    borderRightColor: (0, $d8xIF.borderColorMap),
    borderRightWidth: (0, $8nNtm.borderWidthMap),
    borderStartEndRadius: (0, $hZqiq.borderRadiusMap),
    borderStartStartRadius: (0, $hZqiq.borderRadiusMap),
    borderTopColor: (0, $d8xIF.borderColorMap),
    borderTopLeftRadius: (0, $hZqiq.borderRadiusMap),
    borderTopRightRadius: (0, $hZqiq.borderRadiusMap),
    borderTopWidth: (0, $8nNtm.borderWidthMap),
    borderWidth: (0, $8nNtm.borderWidthMap),
    bottom: (0, $64r8F.allSpaceMap),
    boxShadow: (0, $dNUST.shadowMap),
    color: (0, $1tNk5.textColorMap),
    columnGap: (0, $5hXax.gapSpaceMap),
    font: (0, $cFlSN.fontMap),
    fontFamily: (0, $1HrWA.fontFamilyMap),
    fontWeight: (0, $2MF4J.fontWeightMap),
    gap: (0, $5hXax.gapSpaceMap),
    height: (0, $jqMUP.dimensionMap),
    inlineSize: (0, $jqMUP.dimensionMap),
    inset: (0, $64r8F.allSpaceMap),
    insetBlock: (0, $64r8F.allSpaceMap),
    insetBlockEnd: (0, $64r8F.allSpaceMap),
    insetBlockStart: (0, $64r8F.allSpaceMap),
    insetInline: (0, $64r8F.allSpaceMap),
    insetInlineEnd: (0, $64r8F.allSpaceMap),
    insetInlineStart: (0, $64r8F.allSpaceMap),
    left: (0, $64r8F.allSpaceMap),
    margin: (0, $64r8F.allSpaceMap),
    marginBlock: (0, $64r8F.allSpaceMap),
    marginBlockEnd: (0, $64r8F.allSpaceMap),
    marginBlockStart: (0, $64r8F.allSpaceMap),
    marginBottom: (0, $64r8F.allSpaceMap),
    marginInline: (0, $64r8F.allSpaceMap),
    marginInlineEnd: (0, $64r8F.allSpaceMap),
    marginInlineStart: (0, $64r8F.allSpaceMap),
    marginLeft: (0, $64r8F.allSpaceMap),
    marginRight: (0, $64r8F.allSpaceMap),
    marginTop: (0, $64r8F.allSpaceMap),
    maxBlockSize: (0, $jqMUP.dimensionMap),
    maxHeight: (0, $jqMUP.dimensionMap),
    maxInlineSize: (0, $jqMUP.dimensionMap),
    maxWidth: (0, $jqMUP.dimensionMap),
    minBlockSize: (0, $jqMUP.dimensionMap),
    minHeight: (0, $jqMUP.dimensionMap),
    minInlineSize: (0, $jqMUP.dimensionMap),
    minWidth: (0, $jqMUP.dimensionMap),
    opacity: (0, $jsyAC.opacityMap),
    outlineColor: (0, $d8xIF.borderColorMap),
    outlineOffset: (0, $64r8F.allSpaceMap),
    outlineWidth: (0, $8nNtm.borderWidthMap),
    padding: (0, $gkD7x.positiveSpaceMap),
    paddingBlock: (0, $gkD7x.positiveSpaceMap),
    paddingBlockEnd: (0, $gkD7x.positiveSpaceMap),
    paddingBlockStart: (0, $gkD7x.positiveSpaceMap),
    paddingBottom: (0, $gkD7x.positiveSpaceMap),
    paddingInline: (0, $gkD7x.positiveSpaceMap),
    paddingInlineEnd: (0, $gkD7x.positiveSpaceMap),
    paddingInlineStart: (0, $gkD7x.positiveSpaceMap),
    paddingLeft: (0, $gkD7x.positiveSpaceMap),
    paddingRight: (0, $gkD7x.positiveSpaceMap),
    paddingTop: (0, $gkD7x.positiveSpaceMap),
    right: (0, $64r8F.allSpaceMap),
    rowGap: (0, $5hXax.gapSpaceMap),
    top: (0, $64r8F.allSpaceMap),
    width: (0, $jqMUP.dimensionMap),
    zIndex: (0, $dr8IU.layerMap)
};

});
parcelRegister("64r8F", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $ca7fba2d38e84331$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cc1af374b7280144c0465457ed9f756>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $ca7fba2d38e84331$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("d8xIF", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $c496c527c56ed269$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2852cd6e8656adbef1c6b8cb926235c9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $c496c527c56ed269$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("hZqiq", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $aeae4c41f8b94b11$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac51b10fd4c84e2b653aff461a93b73>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $aeae4c41f8b94b11$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("8nNtm", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $3e67721a8bf0a896$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cdb9fba904c3ac54bf1c429a821ffc2>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $3e67721a8bf0a896$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("jqMUP", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $29191b172cb54507$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $29191b172cb54507$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("cFlSN", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $4064d179314f4770$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $4064d179314f4770$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("1HrWA", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $b98ca31aa27f9dd2$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $b98ca31aa27f9dd2$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("2MF4J", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $bec876ac9384eec9$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $bec876ac9384eec9$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("5hXax", function(module, exports) {
$parcel$export(module.exports, "gapSpaceMap", () => $0a8d1a3a79fb284c$export$ae2d66f16ab57ecd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71d191c679a99ef0b72b3412372b1db9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $0a8d1a3a79fb284c$export$ae2d66f16ab57ecd = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.gap.large': "var(--ds-space-gap-large, 12px)",
    'space.gap.medium': "var(--ds-space-gap-medium, 8px)",
    'space.gap.small': "var(--ds-space-gap-small, 6px)",
    'space.gap.xlarge': "var(--ds-space-gap-xlarge, 16px)",
    'space.gap.xsmall': "var(--ds-space-gap-xsmall, 4px)",
    'space.gap.xxlarge': "var(--ds-space-gap-xxlarge, 24px)",
    'space.gap.xxsmall': "var(--ds-space-gap-xxsmall, 2px)"
};

});

parcelRegister("dr8IU", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $956952bc4f584222$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $956952bc4f584222$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("jsyAC", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $d0b167e72af4e1d1$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f768e44d85ca8256730a17510c4d3901>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $d0b167e72af4e1d1$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("dNUST", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $4e82c19d67c5f400$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31f7af0716c25896201100f27266bca7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $4e82c19d67c5f400$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("1tNk5", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $f5825485043b5288$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $f5825485043b5288$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("1JdzP", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $41ae3d9863a2163f$export$f51f4c4ede09e011);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $hg0W2 = parcelRequire("hg0W2");

var $2FCAn = parcelRequire("2FCAn");
function $41ae3d9863a2163f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $41ae3d9863a2163f$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $41ae3d9863a2163f$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $41ae3d9863a2163f$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $41ae3d9863a2163f$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $41ae3d9863a2163f$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
const $41ae3d9863a2163f$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $hg0W2.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $jctmk.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $41ae3d9863a2163f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $2FCAn.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $2FCAn.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $2FCAn.spaceStylesMap).rowGap[rowGap],
            alignItems && $41ae3d9863a2163f$var$alignItemsMap[alignItems],
            direction && $41ae3d9863a2163f$var$flexDirectionMap[direction],
            justifyContent && $41ae3d9863a2163f$var$justifyContentMap[justifyContent],
            wrap && $41ae3d9863a2163f$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$41ae3d9863a2163f$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$41ae3d9863a2163f$export$2e2bcd8739ae039 = $41ae3d9863a2163f$export$f51f4c4ede09e011;

});
parcelRegister("2FCAn", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $2186406e9d8bc111$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hlKtg = parcelRequire("hlKtg");

var $5hXax = parcelRequire("5hXax");
const $2186406e9d8bc111$export$bf46c3f9eeafc71f = (0, $hlKtg.createSpacingStylesMap)((0, $5hXax.gapSpaceMap), [
    'gap',
    'rowGap',
    'columnGap'
]);

});



parcelRegister("hculA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7662ceef8bc5d963$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $fVzQQ = parcelRequire("fVzQQ");

var $9182V = parcelRequire("9182V");
/**
 * Returns the appropriate circle stroke color.
 */ function $7662ceef8bc5d963$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $7662ceef8bc5d963$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $7662ceef8bc5d963$var$loadIn = null;
const $7662ceef8bc5d963$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $7662ceef8bc5d963$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $7662ceef8bc5d963$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $9182V.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $7662ceef8bc5d963$var$getStrokeColor(appearance);
    const context = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    $7662ceef8bc5d963$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2R2iS.default)([
            $7662ceef8bc5d963$var$styles.wrapperStyles,
            $7662ceef8bc5d963$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $2R2iS.default)([
                $7662ceef8bc5d963$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $2R2iS.default)([
                    $7662ceef8bc5d963$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $7662ceef8bc5d963$export$2e2bcd8739ae039 = $7662ceef8bc5d963$var$Spinner;

});
parcelRegister("3LM7S", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2sjMp"));

});
parcelRegister("2sjMp", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $1c9d8a27767dda65$export$ffb0004e005737fa, (v) => $1c9d8a27767dda65$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1c9d8a27767dda65$export$34b9dba7ce09269b, (v) => $1c9d8a27767dda65$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1c9d8a27767dda65$export$25062201e9e25d76, (v) => $1c9d8a27767dda65$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c9d8a27767dda65$export$ffb0004e005737fa;
var $1c9d8a27767dda65$export$34b9dba7ce09269b;
var $1c9d8a27767dda65$export$25062201e9e25d76;
'use strict';

var $fc4bM = parcelRequire("fc4bM");
var $1c9d8a27767dda65$var$k = Symbol.for("react.element"), $1c9d8a27767dda65$var$l = Symbol.for("react.fragment"), $1c9d8a27767dda65$var$m = Object.prototype.hasOwnProperty, $1c9d8a27767dda65$var$n = $fc4bM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1c9d8a27767dda65$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c9d8a27767dda65$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1c9d8a27767dda65$var$m.call(a, b) && !$1c9d8a27767dda65$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1c9d8a27767dda65$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1c9d8a27767dda65$var$n.current
    };
}
$1c9d8a27767dda65$export$ffb0004e005737fa = $1c9d8a27767dda65$var$l;
$1c9d8a27767dda65$export$34b9dba7ce09269b = $1c9d8a27767dda65$var$q;
$1c9d8a27767dda65$export$25062201e9e25d76 = $1c9d8a27767dda65$var$q;

});


parcelRegister("2R2iS", function(module, exports) {
$parcel$export(module.exports, "default", () => $214251707e72b823$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $214251707e72b823$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $214251707e72b823$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $214251707e72b823$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("9182V", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $191643dab06d7cd0$export$4e9f1640bbe7a1a8);
const $191643dab06d7cd0$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("eJ8cW", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => (parcelRequire("7Kp1k")).MemoizedInsightIcon);

var $7Kp1k = parcelRequire("7Kp1k");

});
parcelRegister("7Kp1k", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => $3172230077032455$export$55641517b59933d7);

var $fc4bM = parcelRequire("fc4bM");

var $cWkQ8 = parcelRequire("cWkQ8");

var $lfFx3 = parcelRequire("lfFx3");

var $epNlJ = parcelRequire("epNlJ");

var $imTNy = parcelRequire("imTNy");
const $3172230077032455$var$ICON_SIZE = 'small';
const $3172230077032455$var$sizeInPx = (0, $epNlJ.AVATAR_SIZES)[$3172230077032455$var$ICON_SIZE];
// We want to reuse mediaClientConfigs across all InsightIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $3172230077032455$var$mediaClientConfigs = new Map();
const $3172230077032455$var$getMediaClientConfig = ({ mediaJwtToken: mediaJwtToken, clientId: clientId, mediaBaseUrl: mediaBaseUrl })=>{
    const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
    if ($3172230077032455$var$mediaClientConfigs.has(key)) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return $3172230077032455$var$mediaClientConfigs.get(key);
    const mediaClientConfig = {
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: mediaJwtToken,
                baseUrl: mediaBaseUrl
            }),
        useSha256ForUploads: true
    };
    $3172230077032455$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $3172230077032455$var$hasAuth = ({ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, clientId: clientId })=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const $3172230077032455$var$DefaultIcon = ()=>/*#__PURE__*/ $fc4bM.createElement((0, $cWkQ8.default), {
        appearance: "square",
        size: "small"
    });
// Mimics logic from jira/src/packages/servicedesk/insight-common/insight-icon/src/ui/index.tsx
const $3172230077032455$var$renderAvatar = (src)=>/*#__PURE__*/ $fc4bM.createElement("img", {
        loading: "lazy",
        src: src,
        width: $3172230077032455$var$sizeInPx,
        height: $3172230077032455$var$sizeInPx,
        alt: ""
    });
const $3172230077032455$export$4f72cced31fa9b94 = (props)=>{
    const { fileId: fileId, iconUrl: iconUrl, MediaImage: MediaImage = (0, $imTNy.MediaImageWithErrorBoundary) } = props;
    if (!$3172230077032455$var$hasAuth({
        ...props
    }) || !MediaImage) {
        if (iconUrl) return $3172230077032455$var$renderAvatar(iconUrl);
        return /*#__PURE__*/ $fc4bM.createElement($3172230077032455$var$DefaultIcon, null);
    }
    const fileIdentifier = {
        id: fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: 24,
        height: 24
    };
    return /*#__PURE__*/ $fc4bM.createElement("div", null, /*#__PURE__*/ $fc4bM.createElement(MediaImage, {
        identifier: fileIdentifier,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        mediaClientConfig: $3172230077032455$var$getMediaClientConfig(props),
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $fc4bM.createElement((0, $lfFx3.default), {
            appearance: "square",
            size: "small"
        });
        if (error) return /*#__PURE__*/ $fc4bM.createElement($3172230077032455$var$DefaultIcon, null);
        if (!data) return /*#__PURE__*/ $fc4bM.createElement($3172230077032455$var$DefaultIcon, null);
        return /*#__PURE__*/ $fc4bM.createElement((0, $cWkQ8.default), {
            src: data.src,
            appearance: "square",
            size: "small"
        });
    }));
};
const $3172230077032455$export$55641517b59933d7 = /*#__PURE__*/ $fc4bM.memo($3172230077032455$export$4f72cced31fa9b94);

});
parcelRegister("cWkQ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd519d9279f43e28$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jEubQ = parcelRequire("jEubQ");

var $3zBNx = parcelRequire("3zBNx");

var $dRkX9 = parcelRequire("dRkX9");

var $hYnqX = parcelRequire("hYnqX");

var $7B5lM = parcelRequire("7B5lM");

var $8iAxT = parcelRequire("8iAxT");

var $dlnc2 = parcelRequire("dlnc2");

var $7OjkQ = parcelRequire("7OjkQ");

var $b6jHF = parcelRequire("b6jHF");

var $dEndX = parcelRequire("dEndX");

var $8dUjK = parcelRequire("8dUjK");
const $fd519d9279f43e28$var$packageName = undefined;
const $fd519d9279f43e28$var$packageVersion = undefined;
const $fd519d9279f43e28$var$containerStyles = null;
const $fd519d9279f43e28$var$updatedHexagonNegativeMarginMap = {
    xxsmall: "_6rth1b3j _1pfh1b3j",
    small: "_6rth1tv6 _1pfh1tv6",
    medium: "_6rth1lmm _1pfh1lmm",
    large: "_6rth1wmd _1pfh1wmd",
    xlarge: "_6rth130q _1pfh130q",
    xxlarge: "_6rthyzhl _1pfhyzhl"
};
const $fd519d9279f43e28$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $dRkX9.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
const $fd519d9279f43e28$var$Avatar = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const context = (0, $8dUjK.useAvatarContext)();
    const size = $fd519d9279f43e28$var$normalizeAvatarSize(sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium');
    const isUpdatedHexagonGeometry = appearance === 'hexagon' && Boolean(UNSAFE_isUpdatedGeometry) && size !== 'UNSAFE_xsmall';
    const customPresenceNode = /*#__PURE__*/ (0, $fc4bM.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $fc4bM.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $fc4bM.useRef)(analyticsContext);
    const labelId = (0, $3zBNx.useId)();
    (0, $fc4bM.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $fc4bM.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $fd519d9279f43e28$var$packageName,
                packageVersion: $fd519d9279f43e28$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $fd519d9279f43e28$var$packageName,
            packageVersion: $fd519d9279f43e28$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dlnc2.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $2R2iS.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm",
                isUpdatedHexagonGeometry && $fd519d9279f43e28$var$updatedHexagonNegativeMarginMap[size]
            ]),
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8iAxT.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $7OjkQ.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7B5lM.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hYnqX.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b6jHF.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dEndX.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$fd519d9279f43e28$var$Avatar.displayName = 'Avatar';
var $fd519d9279f43e28$export$2e2bcd8739ae039 = $fd519d9279f43e28$var$Avatar;

});
parcelRegister("3zBNx", function(module, exports) {
$parcel$export(module.exports, "useId", () => $7a33403dedb92f0d$export$f680877a34711e37);

var $fc4bM = parcelRequire("fc4bM");
function $7a33403dedb92f0d$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("hYnqX", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $04bd9f19a37c320f$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $8iAxT = parcelRequire("8iAxT");

var $dw0nz = parcelRequire("dw0nz");
const $04bd9f19a37c320f$var$boxShadowCssVar = '--avatar-box-shadow';
const $04bd9f19a37c320f$var$bgColorCssVar = '--avatar-bg-color';
const $04bd9f19a37c320f$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    isolation: "_kqswh2mm _19121cl4",
    legacyLayerPromotion: "_v564ieh6 _t9ec1aqe",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $04bd9f19a37c320f$var$unboundStyles = {
    root: "_11q7cxp3 _vchh1ntv _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    updatedHexagonClipPath: "_mkrz1ezo",
    hexagonBorderContainer: "_11q7cxp3 _1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _m6k41e03 _1llweo6y"
};
const $04bd9f19a37c320f$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const $04bd9f19a37c320f$var$updatedHexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5di1a _1q51di1a _y4tiidpf _bozgidpf _6rthwit5 _1pfhwit5 _12l2idpf _ahbqidpf",
    hexagonFocusContainer: "_85i51hhc _1q511hhc _y4ti1dm9 _bozg1dm9 _6rthypyw _1pfhypyw _12l21ksc _ahbq1ksc"
};
const $04bd9f19a37c320f$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
// The sole source of truth for the updated hexagon width/height geometry (per size).
const $04bd9f19a37c320f$var$updatedHexagonDimensionMap = {
    xxsmall: "_1bsbgaek _4t3ikzaa",
    small: "_1bsb1ftb _4t3i1pm0",
    medium: "_1bsb1cun _4t3i3vj5",
    large: "_1bsbctg4 _4t3i15zd",
    xlarge: "_1bsbovoe _4t3i1sfy",
    xxlarge: "_1bsbhec5 _4t3i1ejz"
};
const $04bd9f19a37c320f$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children }, ref)=>{
    (0, $dw0nz.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $fc4bM.useContext)((0, $8iAxT.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $3LM7S.jsx)(Container, {
        style: {
            [$04bd9f19a37c320f$var$bgColorCssVar]: borderColor,
            [$04bd9f19a37c320f$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $2R2iS.default)([
            $04bd9f19a37c320f$var$unboundStyles.root,
            $04bd9f19a37c320f$var$styles.root,
            (0, $dRkX9.fg)('platform_avatar_disable_layer_promotion') ? $04bd9f19a37c320f$var$styles.isolation : $04bd9f19a37c320f$var$styles.legacyLayerPromotion,
            appearance === 'square' && $04bd9f19a37c320f$var$styles.square,
            appearance === 'circle' && $04bd9f19a37c320f$var$styles.circle,
            appearance === 'hexagon' && $04bd9f19a37c320f$var$unboundStyles.hexagon,
            $04bd9f19a37c320f$var$widthHeightMap[size],
            UNSAFE_isUpdatedGeometry && $04bd9f19a37c320f$var$updatedHexagonDimensionMap[size],
            stackIndex !== undefined && $04bd9f19a37c320f$var$styles.positionRelative,
            isInteractive && !isDisabled && $04bd9f19a37c320f$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $dRkX9.fg)('platform-dst-motion-uplift') && $04bd9f19a37c320f$var$unboundStyles.interactiveMotion,
            isDisabled && $04bd9f19a37c320f$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            [$04bd9f19a37c320f$var$bgColorCssVar]: borderColor,
            [$04bd9f19a37c320f$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $2R2iS.default)([
            $04bd9f19a37c320f$var$unboundStyles.hexagonFocusContainer,
            UNSAFE_isUpdatedGeometry && $04bd9f19a37c320f$var$unboundStyles.updatedHexagonClipPath,
            isInteractive && !isDisabled && (0, $dRkX9.fg)('platform-dst-motion-uplift') && $04bd9f19a37c320f$var$unboundStyles.interactiveMotion,
            UNSAFE_isUpdatedGeometry && $04bd9f19a37c320f$var$updatedHexagonBorderFixStyles.hexagonFocusContainer,
            (0, $dRkX9.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $04bd9f19a37c320f$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $2R2iS.default)([
                $04bd9f19a37c320f$var$unboundStyles.hexagonBorderContainer,
                UNSAFE_isUpdatedGeometry && $04bd9f19a37c320f$var$updatedHexagonBorderFixStyles.hexagonBorderContainer,
                (0, $dRkX9.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $04bd9f19a37c320f$var$hexagonBorderFixStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("8iAxT", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $5abf8d2ee56fbc7e$export$b983474ddd0b6d28);

var $fc4bM = parcelRequire("fc4bM");
const $5abf8d2ee56fbc7e$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $5abf8d2ee56fbc7e$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $fc4bM.createContext)($5abf8d2ee56fbc7e$var$defaultAvatarContentProps);

});

parcelRegister("dw0nz", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $b4834bf5fad9dc19$export$7db5c57474082dd9);

var $fc4bM = parcelRequire("fc4bM");

var $dlnc2 = parcelRequire("dlnc2");
const $b4834bf5fad9dc19$export$7db5c57474082dd9 = ()=>{
    const context = (0, $fc4bM.useContext)((0, $dlnc2.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("dlnc2", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $a09f106ad3a2c40f$export$6b4cbd90d24955ad);

var $fc4bM = parcelRequire("fc4bM");
const $a09f106ad3a2c40f$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $fc4bM.createContext)(false);

});



parcelRegister("7B5lM", function(module, exports) {
$parcel$export(module.exports, "default", () => $324f18ac868de90c$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $lB4EN = parcelRequire("lB4EN");

var $gW5Bf = parcelRequire("gW5Bf");

var $ctR60 = parcelRequire("ctR60");
const $324f18ac868de90c$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g",
    updatedHexagonIcon: "_4cvr1h6o _1bah1h6o",
    updatedHexagonImage: "_mkrz1kw7 _5ral1dfr _1kem1wug"
};
const $324f18ac868de90c$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $324f18ac868de90c$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const $324f18ac868de90c$var$updatedHexagonNestedSvgStylesMap = {
    xxsmall: "_w8l5gaek _1752kzaa",
    small: "_w8l51ftb _17521pm0",
    medium: "_w8l51cun _17523vj5",
    large: "_w8l5ctg4 _175215zd",
    xlarge: "_w8l5ovoe _17521sfy",
    xxlarge: "_w8l5hec5 _17521ejz"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $324f18ac868de90c$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fc4bM.useState)(false);
    // If src changes, reset state
    (0, $fc4bM.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gW5Bf))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lB4EN))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctR60))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            className: (0, $2R2iS.default)([
                $324f18ac868de90c$var$styles.icon,
                UNSAFE_isUpdatedGeometry ? $324f18ac868de90c$var$updatedHexagonNestedSvgStylesMap[size] : $324f18ac868de90c$var$nestedSvgStylesMap[size],
                UNSAFE_isUpdatedGeometry && $324f18ac868de90c$var$styles.updatedHexagonIcon
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $3LM7S.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $2R2iS.default)([
            $324f18ac868de90c$var$styles.image,
            $324f18ac868de90c$var$borderRadiusMap[size],
            appearance === 'circle' && $324f18ac868de90c$var$styles.circle,
            appearance === 'hexagon' && $324f18ac868de90c$var$styles.hexagon,
            UNSAFE_isUpdatedGeometry && $324f18ac868de90c$var$styles.updatedHexagonImage
        ])
    });
};
var $324f18ac868de90c$export$2e2bcd8739ae039 = $324f18ac868de90c$var$AvatarImage;

});
parcelRegister("lB4EN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb90aa706ac77c29$var$_react = $fb90aa706ac77c29$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $fb90aa706ac77c29$var$_iconNew = $fb90aa706ac77c29$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $fb90aa706ac77c29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb90aa706ac77c29$var$AiAgentIcon = (props)=>/*#__PURE__*/ $fb90aa706ac77c29$var$_react.default.createElement($fb90aa706ac77c29$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$fb90aa706ac77c29$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $fb90aa706ac77c29$var$_default = module.exports.default = $fb90aa706ac77c29$var$AiAgentIcon;

});
parcelRegister("7ypK2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $d6e2f6f68aae9011$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $d6e2f6f68aae9011$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $d6e2f6f68aae9011$var$svgStyles = null;
const $d6e2f6f68aae9011$var$iconStyles = null;
const $d6e2f6f68aae9011$var$smallIconStyles = null;
const $d6e2f6f68aae9011$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $d6e2f6f68aae9011$var$baseHcmStyles = null;
const $d6e2f6f68aae9011$var$scaleSize = null;
const $d6e2f6f68aae9011$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $d6e2f6f68aae9011$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $d6e2f6f68aae9011$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $d6e2f6f68aae9011$export$f04a61298a47a40f = /*#__PURE__*/ (0, $fc4bM.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $d6e2f6f68aae9011$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $2R2iS.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $d6e2f6f68aae9011$var$coreSizeSmall[spacing] : $d6e2f6f68aae9011$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d6e2f6f68aae9011$export$2e2bcd8739ae039 = $d6e2f6f68aae9011$export$f04a61298a47a40f;

});


parcelRegister("gW5Bf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c546681fe5b5bc29$var$_react = $c546681fe5b5bc29$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $c546681fe5b5bc29$var$_iconNew = $c546681fe5b5bc29$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $c546681fe5b5bc29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c546681fe5b5bc29$var$PersonIcon = (props)=>/*#__PURE__*/ $c546681fe5b5bc29$var$_react.default.createElement($c546681fe5b5bc29$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$c546681fe5b5bc29$var$PersonIcon.displayName = 'PersonIcon';
var $c546681fe5b5bc29$var$_default = module.exports.default = $c546681fe5b5bc29$var$PersonIcon;

});

parcelRegister("ctR60", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91616137a606ae18$var$_react = $91616137a606ae18$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $91616137a606ae18$var$_iconNew = $91616137a606ae18$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $91616137a606ae18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $91616137a606ae18$var$ReleaseIcon = (props)=>/*#__PURE__*/ $91616137a606ae18$var$_react.default.createElement($91616137a606ae18$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$91616137a606ae18$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $91616137a606ae18$var$_default = module.exports.default = $91616137a606ae18$var$ReleaseIcon;

});


parcelRegister("7OjkQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f187d4c43fa7015c$export$2e2bcd8739ae039);
const $f187d4c43fa7015c$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $f187d4c43fa7015c$export$2e2bcd8739ae039 = $f187d4c43fa7015c$var$getCustomElement;

});

parcelRegister("b6jHF", function(module, exports) {
$parcel$export(module.exports, "default", () => $20fbe32883d8c8b5$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $6BfJ7 = parcelRequire("6BfJ7");
const $20fbe32883d8c8b5$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $20fbe32883d8c8b5$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $20fbe32883d8c8b5$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $20fbe32883d8c8b5$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $20fbe32883d8c8b5$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $20fbe32883d8c8b5$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $2R2iS.default)([
            $20fbe32883d8c8b5$var$styles.root,
            $20fbe32883d8c8b5$var$iconSizeMap[size],
            $20fbe32883d8c8b5$var$circleIconOffsetMap[size],
            appearance === 'square' && $20fbe32883d8c8b5$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $20fbe32883d8c8b5$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6BfJ7.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
var $20fbe32883d8c8b5$export$2e2bcd8739ae039 = $20fbe32883d8c8b5$var$PresenceWrapper;

});
parcelRegister("6BfJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $398f73e19ffbf80c$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fWvQI = parcelRequire("fWvQI");
const $398f73e19ffbf80c$var$BusyIndicator = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $398f73e19ffbf80c$var$FocusIndicator = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
    children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $398f73e19ffbf80c$var$OfflineIndicator = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $398f73e19ffbf80c$var$OnlineIndicator = /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $398f73e19ffbf80c$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $398f73e19ffbf80c$var$BusyIndicator;
        case 'focus':
            return $398f73e19ffbf80c$var$FocusIndicator;
        case 'offline':
            return $398f73e19ffbf80c$var$OfflineIndicator;
        case 'online':
            return $398f73e19ffbf80c$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $398f73e19ffbf80c$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fWvQI.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $398f73e19ffbf80c$var$getPresence(presence)
        }) : children
    });
var $398f73e19ffbf80c$export$2e2bcd8739ae039 = $398f73e19ffbf80c$var$AvatarPresence;

});
parcelRegister("fWvQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $41545b84c50c0d28$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $41545b84c50c0d28$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $41545b84c50c0d28$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $41545b84c50c0d28$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $2R2iS.default)([
            $41545b84c50c0d28$var$styles.root,
            $41545b84c50c0d28$var$unboundStyles.root
        ]),
        children: children
    });
var $41545b84c50c0d28$export$2e2bcd8739ae039 = $41545b84c50c0d28$var$IconWrapper;

});



parcelRegister("dEndX", function(module, exports) {
$parcel$export(module.exports, "default", () => $28fdf7f063163b1b$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $1LdTi = parcelRequire("1LdTi");
const $28fdf7f063163b1b$var$styles = {
    root: "_kqswstnw"
};
const $28fdf7f063163b1b$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $28fdf7f063163b1b$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $28fdf7f063163b1b$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $28fdf7f063163b1b$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $28fdf7f063163b1b$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $2R2iS.default)([
            $28fdf7f063163b1b$var$styles.root,
            $28fdf7f063163b1b$var$iconSizeMap[size],
            $28fdf7f063163b1b$var$circleIconOffsetMap[size],
            appearance === 'square' && $28fdf7f063163b1b$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $28fdf7f063163b1b$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1LdTi.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
var $28fdf7f063163b1b$export$2e2bcd8739ae039 = $28fdf7f063163b1b$var$StatusWrapper;

});
parcelRegister("1LdTi", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a7c35a93f8c82ab$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fWvQI = parcelRequire("fWvQI");
const $1a7c35a93f8c82ab$var$ApprovedIndicator = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $1a7c35a93f8c82ab$var$DeclinedIndicator = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $1a7c35a93f8c82ab$var$LockedIndicator = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
const $1a7c35a93f8c82ab$var$WarningIndicator = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
            fill: "var(--ds-icon-warning, #E06C00)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
        })
    ]
});
function $1a7c35a93f8c82ab$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $1a7c35a93f8c82ab$var$ApprovedIndicator;
        case 'declined':
            return $1a7c35a93f8c82ab$var$DeclinedIndicator;
        case 'locked':
            return $1a7c35a93f8c82ab$var$LockedIndicator;
        case 'warning':
            return $1a7c35a93f8c82ab$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $1a7c35a93f8c82ab$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fWvQI.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $1a7c35a93f8c82ab$var$getStatus(status)
        }) : children
    });
var $1a7c35a93f8c82ab$export$2e2bcd8739ae039 = $1a7c35a93f8c82ab$var$AvatarStatus;

});


parcelRegister("8dUjK", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $e73644115be1ebfd$export$b50b87a1c4086b23);

var $fc4bM = parcelRequire("fc4bM");

var $lFL2m = parcelRequire("lFL2m");
const $e73644115be1ebfd$export$b50b87a1c4086b23 = ()=>(0, $fc4bM.useContext)((0, $lFL2m.AvatarContext));

});
parcelRegister("lFL2m", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $48e70ce136b13bcc$export$a20dad690e1279e2);

var $fc4bM = parcelRequire("fc4bM");
const $48e70ce136b13bcc$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});



parcelRegister("lfFx3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ee9890534b702dc$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $3ee9890534b702dc$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $3ee9890534b702dc$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d1j28 _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $3ee9890534b702dc$var$sizeStyles = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $3ee9890534b702dc$var$Skeleton = ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            [$3ee9890534b702dc$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $2R2iS.default)([
            $3ee9890534b702dc$var$styles.root,
            $3ee9890534b702dc$var$sizeStyles[avatarSize],
            appearance === 'square' && $3ee9890534b702dc$var$styles.square,
            appearance === 'hexagon' && $3ee9890534b702dc$var$styles.hexagon,
            weight === 'strong' && $3ee9890534b702dc$var$styles.strongOpacity
        ])
    });
};
var $3ee9890534b702dc$export$2e2bcd8739ae039 = $3ee9890534b702dc$var$Skeleton;

});

parcelRegister("epNlJ", function(module, exports) {
$parcel$export(module.exports, "AVATAR_SIZES", () => $f048e48a81550242$export$9a270941bcff7e77);
const $f048e48a81550242$export$9a270941bcff7e77 = {
    xxsmall: 16,
    xsmall: 16,
    UNSAFE_xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};

});

parcelRegister("imTNy", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $8208a02245a8c9a1$export$758a2fef95a29ad0);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $kypbC = parcelRequire("kypbC");
const $8208a02245a8c9a1$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kypbC.MediaImageWithMediaClient), props));

});
parcelRegister("1VpRA", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $166f2d3ddfccfd7f$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $166f2d3ddfccfd7f$export$f0c7a449e0cfaec7);

var $fc4bM = parcelRequire("fc4bM");
'use client';
const $166f2d3ddfccfd7f$export$b16d9fb1a22de840 = (0, $fc4bM.createContext)(null);
const $166f2d3ddfccfd7f$var$initialState = {
    didCatch: false,
    error: null
};
class $166f2d3ddfccfd7f$export$e926676385687eaf extends (0, $fc4bM.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $166f2d3ddfccfd7f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($166f2d3ddfccfd7f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $166f2d3ddfccfd7f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($166f2d3ddfccfd7f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $fc4bM.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $fc4bM.createElement)($166f2d3ddfccfd7f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $166f2d3ddfccfd7f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $166f2d3ddfccfd7f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $166f2d3ddfccfd7f$export$c052f6604b7d51fe() {
    const context = (0, $fc4bM.useContext)($166f2d3ddfccfd7f$export$b16d9fb1a22de840);
    $166f2d3ddfccfd7f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $fc4bM.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $fc4bM.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $166f2d3ddfccfd7f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $fc4bM.forwardRef)((props, ref)=>(0, $fc4bM.createElement)($166f2d3ddfccfd7f$export$e926676385687eaf, errorBoundaryProps, (0, $fc4bM.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("kypbC", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithMediaClient", () => $9a3ba2ba8399a9e8$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $22fJ4 = parcelRequire("22fJ4");

var $ied3Y = parcelRequire("ied3Y");

var $dRkX9 = parcelRequire("dRkX9");
const $9a3ba2ba8399a9e8$var$copyDivStyles = null;
const $9a3ba2ba8399a9e8$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $ied3Y.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview !== null && preview !== void 0 && preview.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview === null || preview === void 0 ? void 0 : preview.dataURI
        } : undefined
    }), (0, $dRkX9.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $fc4bM.createElement("div", {
        ref: copyNodeRef,
        className: (0, $2R2iS.default)([
            "_1e0cglyw"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $fc4bM.createElement("script", getSsrScriptProps()));
};
const $9a3ba2ba8399a9e8$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $fc4bM.useMemo)(()=>(0, $22fJ4.withMediaClient)($9a3ba2ba8399a9e8$var$MediaImageBase), []);
    return /*#__PURE__*/ $fc4bM.createElement(MediaImageComponent, props);
};

});
parcelRegister("22fJ4", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $c3bbdd3579478889$export$9f7977d4a2561bee);

var $fc4bM = parcelRequire("fc4bM");

var $fzRvL = parcelRequire("fzRvL");

var $dRkX9 = parcelRequire("dRkX9");

var $bLScU = parcelRequire("bLScU");

var $4cz1R = parcelRequire("4cz1R");
const $c3bbdd3579478889$export$9f7977d4a2561bee = (Component)=>(0, $fzRvL.componentWithCondition)(()=>(0, $dRkX9.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $fc4bM.useContext)((0, $4cz1R.MediaClientContext));
        const mediaClient = (0, $fc4bM.useMemo)(()=>existingMediaClient ?? (0, $bLScU.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4cz1R.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4cz1R.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4cz1R.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4cz1R.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));

});
parcelRegister("fzRvL", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $3bb38fa51448683d$export$6e8ea24b15199873);

var $fc4bM = parcelRequire("fc4bM");
function $3bb38fa51448683d$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("bLScU", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $ce7bbbfdd383713f$export$c9ecbc1b719fd417);

var $2rfCb = parcelRequire("2rfCb");
const $ce7bbbfdd383713f$export$f92e83e86b03c398 = new Map();
const $ce7bbbfdd383713f$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $2rfCb.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $ce7bbbfdd383713f$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $2rfCb.MediaClient)(mediaClientConfig);
        $ce7bbbfdd383713f$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("2rfCb", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $0f5418810fb5a35b$export$fba8b4ca6d386aec);

var $JlnMl = parcelRequire("JlnMl");

var $lh6Yd = parcelRequire("lh6Yd");

var $88fAz = parcelRequire("88fAz");

var $ezIR3 = parcelRequire("ezIR3");

var $fRnN7 = parcelRequire("fRnN7");

var $b9LoH = parcelRequire("b9LoH");

class $0f5418810fb5a35b$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $88fAz.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $fRnN7.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $lh6Yd.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $ezIR3.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $JlnMl.EventEmitter2)();
        this.stargate = new (0, $b9LoH.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext, clientOptions) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext, clientOptions);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params, seededCdnUrl) {
        return this.mediaStore.getFileImageURLSync(id, params, seededCdnUrl);
    }
    async getClientId(collectionName) {
        return this.mediaStore.getClientId(collectionName);
    }
    getClientIdSync() {
        return this.mediaStore.getClientIdSync();
    }
    async getImageWatermarkVersion(collectionName) {
        return this.mediaStore.getImageWatermarkVersion(collectionName);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("bObIr"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("JlnMl", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $3jCFs = parcelRequire("3jCFs");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $3jCFs !== 'undefined' && $3jCFs.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $3jCFs.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("lh6Yd", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $1b0cdbc38280eabd$export$d3e73a50cc549c2e);
var $1b0cdbc38280eabd$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});

parcelRegister("88fAz", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $1155ff09e9f582b8$export$5785580dea19518d);

var $azY32 = parcelRequire("azY32");

var $hFBAU = parcelRequire("hFBAU");

var $dc0mX = parcelRequire("dc0mX");
const $1155ff09e9f582b8$var$mediaStoreWithoutDevtools = (0, $dc0mX.createStore)()((0, $azY32.subscribeWithSelector)((0, $hFBAU.immer)(()=>({
        files: {}
    }))));
const $1155ff09e9f582b8$var$mediaStoreWithDevtools = (0, $dc0mX.createStore)()((0, $azY32.devtools)((0, $azY32.subscribeWithSelector)((0, $hFBAU.immer)(()=>({
        files: {}
    })))));
const $1155ff09e9f582b8$export$5785580dea19518d = $1155ff09e9f582b8$var$mediaStoreWithoutDevtools;

});
parcelRegister("azY32", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $7b3bc091bc84325f$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $7b3bc091bc84325f$export$5c593627aef9f076);
var $7b3bc091bc84325f$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/middleware.mjs"
});
const $7b3bc091bc84325f$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $7b3bc091bc84325f$export$4feba8a1bc8e9afd = $7b3bc091bc84325f$var$reduxImpl;
const $7b3bc091bc84325f$var$trackedConnections = /* @__PURE__ */ new Map();
const $7b3bc091bc84325f$var$getTrackedConnectionState = (name)=>{
    const api = $7b3bc091bc84325f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $7b3bc091bc84325f$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $7b3bc091bc84325f$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $7b3bc091bc84325f$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $7b3bc091bc84325f$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($7b3bc091bc84325f$import_meta.env ? $7b3bc091bc84325f$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($7b3bc091bc84325f$import_meta.env ? $7b3bc091bc84325f$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $7b3bc091bc84325f$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$7b3bc091bc84325f$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($7b3bc091bc84325f$import_meta.env ? $7b3bc091bc84325f$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $7b3bc091bc84325f$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($7b3bc091bc84325f$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($7b3bc091bc84325f$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $7b3bc091bc84325f$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($7b3bc091bc84325f$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $7b3bc091bc84325f$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $7b3bc091bc84325f$export$6922d3b3a607469e = $7b3bc091bc84325f$var$devtoolsImpl;
const $7b3bc091bc84325f$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $7b3bc091bc84325f$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $7b3bc091bc84325f$export$5c593627aef9f076 = $7b3bc091bc84325f$var$subscribeWithSelectorImpl;
const $7b3bc091bc84325f$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $7b3bc091bc84325f$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $7b3bc091bc84325f$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $7b3bc091bc84325f$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $7b3bc091bc84325f$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $7b3bc091bc84325f$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $7b3bc091bc84325f$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $7b3bc091bc84325f$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $7b3bc091bc84325f$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $7b3bc091bc84325f$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $7b3bc091bc84325f$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $7b3bc091bc84325f$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($7b3bc091bc84325f$import_meta.env ? $7b3bc091bc84325f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $7b3bc091bc84325f$var$oldImpl(config, baseOptions);
    }
    return $7b3bc091bc84325f$var$newImpl(config, baseOptions);
};
const $7b3bc091bc84325f$export$9a6132153fba2e0 = $7b3bc091bc84325f$var$persistImpl;

});

parcelRegister("hFBAU", function(module, exports) {
$parcel$export(module.exports, "immer", () => $cdd36d6fbccab7db$export$428de7ec69ac95c);

var $3L01G = parcelRequire("3L01G");
const $cdd36d6fbccab7db$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $3L01G.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $cdd36d6fbccab7db$export$428de7ec69ac95c = $cdd36d6fbccab7db$var$immerImpl;

});
parcelRegister("3L01G", function(module, exports) {
$parcel$export(module.exports, "produce", () => $2bc5c818c7e9b08c$export$b46cabe22e78bc00);
// src/utils/env.ts
var $2bc5c818c7e9b08c$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $2bc5c818c7e9b08c$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $2bc5c818c7e9b08c$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $2bc5c818c7e9b08c$var$errors = [];
function $2bc5c818c7e9b08c$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $2bc5c818c7e9b08c$var$O = Object;
var $2bc5c818c7e9b08c$var$getPrototypeOf = $2bc5c818c7e9b08c$var$O.getPrototypeOf;
var $2bc5c818c7e9b08c$var$CONSTRUCTOR = "constructor";
var $2bc5c818c7e9b08c$var$PROTOTYPE = "prototype";
var $2bc5c818c7e9b08c$var$CONFIGURABLE = "configurable";
var $2bc5c818c7e9b08c$var$ENUMERABLE = "enumerable";
var $2bc5c818c7e9b08c$var$WRITABLE = "writable";
var $2bc5c818c7e9b08c$var$VALUE = "value";
var $2bc5c818c7e9b08c$export$541ac630993a4c84 = (value)=>!!value && !!value[$2bc5c818c7e9b08c$var$DRAFT_STATE];
function $2bc5c818c7e9b08c$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $2bc5c818c7e9b08c$var$isPlainObject(value) || $2bc5c818c7e9b08c$var$isArray(value) || !!value[$2bc5c818c7e9b08c$export$6ee2082928bcb0ee] || !!value[$2bc5c818c7e9b08c$var$CONSTRUCTOR]?.[$2bc5c818c7e9b08c$export$6ee2082928bcb0ee] || $2bc5c818c7e9b08c$var$isMap(value) || $2bc5c818c7e9b08c$var$isSet(value);
}
var $2bc5c818c7e9b08c$var$objectCtorString = $2bc5c818c7e9b08c$var$O[$2bc5c818c7e9b08c$var$PROTOTYPE][$2bc5c818c7e9b08c$var$CONSTRUCTOR].toString();
var $2bc5c818c7e9b08c$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $2bc5c818c7e9b08c$var$isPlainObject(value) {
    if (!value || !$2bc5c818c7e9b08c$var$isObjectish(value)) return false;
    const proto = $2bc5c818c7e9b08c$var$getPrototypeOf(value);
    if (proto === null || proto === $2bc5c818c7e9b08c$var$O[$2bc5c818c7e9b08c$var$PROTOTYPE]) return true;
    const Ctor = $2bc5c818c7e9b08c$var$O.hasOwnProperty.call(proto, $2bc5c818c7e9b08c$var$CONSTRUCTOR) && proto[$2bc5c818c7e9b08c$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$2bc5c818c7e9b08c$var$isFunction(Ctor)) return false;
    let ctorString = $2bc5c818c7e9b08c$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $2bc5c818c7e9b08c$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $2bc5c818c7e9b08c$var$objectCtorString;
}
function $2bc5c818c7e9b08c$export$22e8af3f75a010e3(value) {
    if (!$2bc5c818c7e9b08c$export$541ac630993a4c84(value)) $2bc5c818c7e9b08c$var$die(15, value);
    return value[$2bc5c818c7e9b08c$var$DRAFT_STATE].base_;
}
function $2bc5c818c7e9b08c$var$each(obj, iter, strict = true) {
    if ($2bc5c818c7e9b08c$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $2bc5c818c7e9b08c$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $2bc5c818c7e9b08c$var$getArchtype(thing) {
    const state = thing[$2bc5c818c7e9b08c$var$DRAFT_STATE];
    return state ? state.type_ : $2bc5c818c7e9b08c$var$isArray(thing) ? 1 /* Array */  : $2bc5c818c7e9b08c$var$isMap(thing) ? 2 /* Map */  : $2bc5c818c7e9b08c$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $2bc5c818c7e9b08c$var$has = (thing, prop, type = $2bc5c818c7e9b08c$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $2bc5c818c7e9b08c$var$O[$2bc5c818c7e9b08c$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $2bc5c818c7e9b08c$var$get = (thing, prop, type = $2bc5c818c7e9b08c$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $2bc5c818c7e9b08c$var$set = (thing, propOrOldValue, value, type = $2bc5c818c7e9b08c$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $2bc5c818c7e9b08c$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $2bc5c818c7e9b08c$var$isArray = Array.isArray;
var $2bc5c818c7e9b08c$var$isMap = (target)=>target instanceof Map;
var $2bc5c818c7e9b08c$var$isSet = (target)=>target instanceof Set;
var $2bc5c818c7e9b08c$var$isObjectish = (target)=>typeof target === "object";
var $2bc5c818c7e9b08c$var$isFunction = (target)=>typeof target === "function";
var $2bc5c818c7e9b08c$var$isBoolean = (target)=>typeof target === "boolean";
function $2bc5c818c7e9b08c$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $2bc5c818c7e9b08c$var$getProxyDraft = (value)=>{
    if (!$2bc5c818c7e9b08c$var$isObjectish(value)) return null;
    return value?.[$2bc5c818c7e9b08c$var$DRAFT_STATE];
};
var $2bc5c818c7e9b08c$var$latest = (state)=>state.copy_ || state.base_;
var $2bc5c818c7e9b08c$var$getValue = (value)=>{
    const proxyDraft = $2bc5c818c7e9b08c$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $2bc5c818c7e9b08c$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $2bc5c818c7e9b08c$var$shallowCopy(base, strict) {
    if ($2bc5c818c7e9b08c$var$isMap(base)) return new Map(base);
    if ($2bc5c818c7e9b08c$var$isSet(base)) return new Set(base);
    if ($2bc5c818c7e9b08c$var$isArray(base)) return Array[$2bc5c818c7e9b08c$var$PROTOTYPE].slice.call(base);
    const isPlain = $2bc5c818c7e9b08c$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $2bc5c818c7e9b08c$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$2bc5c818c7e9b08c$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$2bc5c818c7e9b08c$var$WRITABLE] === false) {
                desc[$2bc5c818c7e9b08c$var$WRITABLE] = true;
                desc[$2bc5c818c7e9b08c$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$2bc5c818c7e9b08c$var$CONFIGURABLE]: true,
                [$2bc5c818c7e9b08c$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$2bc5c818c7e9b08c$var$ENUMERABLE]: desc[$2bc5c818c7e9b08c$var$ENUMERABLE],
                [$2bc5c818c7e9b08c$var$VALUE]: base[key]
            };
        }
        return $2bc5c818c7e9b08c$var$O.create($2bc5c818c7e9b08c$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $2bc5c818c7e9b08c$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $2bc5c818c7e9b08c$var$O.create(proto);
        return $2bc5c818c7e9b08c$var$O.assign(obj, base);
    }
}
function $2bc5c818c7e9b08c$export$792f3d81ea979f55(obj, deep = false) {
    if ($2bc5c818c7e9b08c$var$isFrozen(obj) || $2bc5c818c7e9b08c$export$541ac630993a4c84(obj) || !$2bc5c818c7e9b08c$export$16e3aed3edb85946(obj)) return obj;
    if ($2bc5c818c7e9b08c$var$getArchtype(obj) > 1) $2bc5c818c7e9b08c$var$O.defineProperties(obj, {
        set: $2bc5c818c7e9b08c$var$dontMutateMethodOverride,
        add: $2bc5c818c7e9b08c$var$dontMutateMethodOverride,
        clear: $2bc5c818c7e9b08c$var$dontMutateMethodOverride,
        delete: $2bc5c818c7e9b08c$var$dontMutateMethodOverride
    });
    $2bc5c818c7e9b08c$var$O.freeze(obj);
    if (deep) $2bc5c818c7e9b08c$var$each(obj, (_key, value)=>{
        $2bc5c818c7e9b08c$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $2bc5c818c7e9b08c$var$dontMutateFrozenCollections() {
    $2bc5c818c7e9b08c$var$die(2);
}
var $2bc5c818c7e9b08c$var$dontMutateMethodOverride = {
    [$2bc5c818c7e9b08c$var$VALUE]: $2bc5c818c7e9b08c$var$dontMutateFrozenCollections
};
function $2bc5c818c7e9b08c$var$isFrozen(obj) {
    if (obj === null || !$2bc5c818c7e9b08c$var$isObjectish(obj)) return true;
    return $2bc5c818c7e9b08c$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $2bc5c818c7e9b08c$var$PluginMapSet = "MapSet";
var $2bc5c818c7e9b08c$var$PluginPatches = "Patches";
var $2bc5c818c7e9b08c$var$PluginArrayMethods = "ArrayMethods";
var $2bc5c818c7e9b08c$var$plugins = {};
function $2bc5c818c7e9b08c$var$getPlugin(pluginKey) {
    const plugin = $2bc5c818c7e9b08c$var$plugins[pluginKey];
    if (!plugin) $2bc5c818c7e9b08c$var$die(0, pluginKey);
    return plugin;
}
var $2bc5c818c7e9b08c$var$isPluginLoaded = (pluginKey)=>!!$2bc5c818c7e9b08c$var$plugins[pluginKey];
function $2bc5c818c7e9b08c$var$loadPlugin(pluginKey, implementation) {
    if (!$2bc5c818c7e9b08c$var$plugins[pluginKey]) $2bc5c818c7e9b08c$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $2bc5c818c7e9b08c$var$currentScope;
var $2bc5c818c7e9b08c$var$getCurrentScope = ()=>$2bc5c818c7e9b08c$var$currentScope;
var $2bc5c818c7e9b08c$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $2bc5c818c7e9b08c$var$isPluginLoaded($2bc5c818c7e9b08c$var$PluginMapSet) ? $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $2bc5c818c7e9b08c$var$isPluginLoaded($2bc5c818c7e9b08c$var$PluginArrayMethods) ? $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginArrayMethods) : void 0
    });
function $2bc5c818c7e9b08c$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $2bc5c818c7e9b08c$var$revokeScope(scope) {
    $2bc5c818c7e9b08c$var$leaveScope(scope);
    scope.drafts_.forEach($2bc5c818c7e9b08c$var$revokeDraft);
    scope.drafts_ = null;
}
function $2bc5c818c7e9b08c$var$leaveScope(scope) {
    if (scope === $2bc5c818c7e9b08c$var$currentScope) $2bc5c818c7e9b08c$var$currentScope = scope.parent_;
}
var $2bc5c818c7e9b08c$var$enterScope = (immer2)=>$2bc5c818c7e9b08c$var$currentScope = $2bc5c818c7e9b08c$var$createScope($2bc5c818c7e9b08c$var$currentScope, immer2);
function $2bc5c818c7e9b08c$var$revokeDraft(draft) {
    const state = draft[$2bc5c818c7e9b08c$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $2bc5c818c7e9b08c$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$2bc5c818c7e9b08c$var$DRAFT_STATE].modified_) {
            $2bc5c818c7e9b08c$var$revokeScope(scope);
            $2bc5c818c7e9b08c$var$die(4);
        }
        if ($2bc5c818c7e9b08c$export$16e3aed3edb85946(result)) result = $2bc5c818c7e9b08c$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$2bc5c818c7e9b08c$var$DRAFT_STATE].base_, result, scope);
    } else result = $2bc5c818c7e9b08c$var$finalize(scope, baseDraft);
    $2bc5c818c7e9b08c$var$maybeFreeze(scope, result, true);
    $2bc5c818c7e9b08c$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $2bc5c818c7e9b08c$export$45b790e32b2810ee ? result : void 0;
}
function $2bc5c818c7e9b08c$var$finalize(rootScope, value) {
    if ($2bc5c818c7e9b08c$var$isFrozen(value)) return value;
    const state = value[$2bc5c818c7e9b08c$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $2bc5c818c7e9b08c$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$2bc5c818c7e9b08c$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $2bc5c818c7e9b08c$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $2bc5c818c7e9b08c$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $2bc5c818c7e9b08c$export$792f3d81ea979f55(value, deep);
}
function $2bc5c818c7e9b08c$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $2bc5c818c7e9b08c$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $2bc5c818c7e9b08c$var$EMPTY_LOCATIONS_RESULT = [];
function $2bc5c818c7e9b08c$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $2bc5c818c7e9b08c$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $2bc5c818c7e9b08c$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $2bc5c818c7e9b08c$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $2bc5c818c7e9b08c$var$each(parentCopy, (key, value)=>{
            if ($2bc5c818c7e9b08c$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $2bc5c818c7e9b08c$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$2bc5c818c7e9b08c$var$set(parentCopy, location, finalizedValue, parentType);
}
function $2bc5c818c7e9b08c$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$2bc5c818c7e9b08c$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $2bc5c818c7e9b08c$var$getFinalValue(state);
        $2bc5c818c7e9b08c$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $2bc5c818c7e9b08c$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $2bc5c818c7e9b08c$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $2bc5c818c7e9b08c$var$markStateFinalized(state);
    }
}
function $2bc5c818c7e9b08c$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($2bc5c818c7e9b08c$export$541ac630993a4c84(value)) {
        const state = value[$2bc5c818c7e9b08c$var$DRAFT_STATE];
        if ($2bc5c818c7e9b08c$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $2bc5c818c7e9b08c$var$prepareCopy(target);
            const finalizedValue = $2bc5c818c7e9b08c$var$getFinalValue(state);
            $2bc5c818c7e9b08c$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($2bc5c818c7e9b08c$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $2bc5c818c7e9b08c$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $2bc5c818c7e9b08c$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($2bc5c818c7e9b08c$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $2bc5c818c7e9b08c$var$handleValue($2bc5c818c7e9b08c$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $2bc5c818c7e9b08c$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($2bc5c818c7e9b08c$export$541ac630993a4c84(target) || handledSet.has(target) || !$2bc5c818c7e9b08c$export$16e3aed3edb85946(target) || $2bc5c818c7e9b08c$var$isFrozen(target)) return target;
    handledSet.add(target);
    $2bc5c818c7e9b08c$var$each(target, (key, value)=>{
        if ($2bc5c818c7e9b08c$export$541ac630993a4c84(value)) {
            const state = value[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            if ($2bc5c818c7e9b08c$var$isSameScope(state, rootScope)) {
                const updatedValue = $2bc5c818c7e9b08c$var$getFinalValue(state);
                $2bc5c818c7e9b08c$var$set(target, key, updatedValue, target.type_);
                $2bc5c818c7e9b08c$var$markStateFinalized(state);
            }
        } else if ($2bc5c818c7e9b08c$export$16e3aed3edb85946(value)) $2bc5c818c7e9b08c$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $2bc5c818c7e9b08c$var$createProxyProxy(base, parent) {
    const baseIsArray = $2bc5c818c7e9b08c$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $2bc5c818c7e9b08c$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $2bc5c818c7e9b08c$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $2bc5c818c7e9b08c$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $2bc5c818c7e9b08c$var$objectTraps = {
    get (state, prop) {
        if (prop === $2bc5c818c7e9b08c$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $2bc5c818c7e9b08c$var$latest(state);
        if (!$2bc5c818c7e9b08c$var$has(source, prop, state.type_)) return $2bc5c818c7e9b08c$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$2bc5c818c7e9b08c$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $2bc5c818c7e9b08c$var$isArrayIndex(prop)) return value;
        if (value === $2bc5c818c7e9b08c$var$peek(state.base_, prop)) {
            $2bc5c818c7e9b08c$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $2bc5c818c7e9b08c$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $2bc5c818c7e9b08c$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($2bc5c818c7e9b08c$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $2bc5c818c7e9b08c$var$getDescriptorFromProto($2bc5c818c7e9b08c$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $2bc5c818c7e9b08c$var$peek($2bc5c818c7e9b08c$var$latest(state), prop);
            const currentState = current2?.[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($2bc5c818c7e9b08c$var$is(value, current2) && (value !== void 0 || $2bc5c818c7e9b08c$var$has(state.base_, prop, state.type_))) return true;
            $2bc5c818c7e9b08c$var$prepareCopy(state);
            $2bc5c818c7e9b08c$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $2bc5c818c7e9b08c$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $2bc5c818c7e9b08c$var$prepareCopy(state);
        if ($2bc5c818c7e9b08c$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $2bc5c818c7e9b08c$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $2bc5c818c7e9b08c$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$2bc5c818c7e9b08c$var$WRITABLE]: true,
            [$2bc5c818c7e9b08c$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$2bc5c818c7e9b08c$var$ENUMERABLE]: desc[$2bc5c818c7e9b08c$var$ENUMERABLE],
            [$2bc5c818c7e9b08c$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $2bc5c818c7e9b08c$var$die(11);
    },
    getPrototypeOf (state) {
        return $2bc5c818c7e9b08c$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $2bc5c818c7e9b08c$var$die(12);
    }
};
var $2bc5c818c7e9b08c$var$arrayTraps = {};
for(let key in $2bc5c818c7e9b08c$var$objectTraps){
    let fn = $2bc5c818c7e9b08c$var$objectTraps[key];
    $2bc5c818c7e9b08c$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$2bc5c818c7e9b08c$var$arrayTraps.deleteProperty = function(state, prop) {
    return $2bc5c818c7e9b08c$var$arrayTraps.set.call(this, state, prop, void 0);
};
$2bc5c818c7e9b08c$var$arrayTraps.set = function(state, prop, value) {
    return $2bc5c818c7e9b08c$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $2bc5c818c7e9b08c$var$peek(draft, prop) {
    const state = draft[$2bc5c818c7e9b08c$var$DRAFT_STATE];
    const source = state ? $2bc5c818c7e9b08c$var$latest(state) : draft;
    return source[prop];
}
function $2bc5c818c7e9b08c$var$readPropFromProto(state, source, prop) {
    const desc = $2bc5c818c7e9b08c$var$getDescriptorFromProto(source, prop);
    return desc ? $2bc5c818c7e9b08c$var$VALUE in desc ? desc[$2bc5c818c7e9b08c$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $2bc5c818c7e9b08c$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $2bc5c818c7e9b08c$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $2bc5c818c7e9b08c$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $2bc5c818c7e9b08c$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $2bc5c818c7e9b08c$var$markChanged(state.parent_);
    }
}
function $2bc5c818c7e9b08c$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $2bc5c818c7e9b08c$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $2bc5c818c7e9b08c$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($2bc5c818c7e9b08c$var$isFunction(base) && !$2bc5c818c7e9b08c$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$2bc5c818c7e9b08c$var$isFunction(recipe)) $2bc5c818c7e9b08c$var$die(6);
            if (patchListener !== void 0 && !$2bc5c818c7e9b08c$var$isFunction(patchListener)) $2bc5c818c7e9b08c$var$die(7);
            let result;
            if ($2bc5c818c7e9b08c$export$16e3aed3edb85946(base)) {
                const scope = $2bc5c818c7e9b08c$var$enterScope(this);
                const proxy = $2bc5c818c7e9b08c$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $2bc5c818c7e9b08c$var$revokeScope(scope);
                    else $2bc5c818c7e9b08c$var$leaveScope(scope);
                }
                $2bc5c818c7e9b08c$var$usePatchesInScope(scope, patchListener);
                return $2bc5c818c7e9b08c$var$processResult(result, scope);
            } else if (!base || !$2bc5c818c7e9b08c$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $2bc5c818c7e9b08c$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $2bc5c818c7e9b08c$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $2bc5c818c7e9b08c$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($2bc5c818c7e9b08c$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($2bc5c818c7e9b08c$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($2bc5c818c7e9b08c$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($2bc5c818c7e9b08c$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$2bc5c818c7e9b08c$export$16e3aed3edb85946(base)) $2bc5c818c7e9b08c$var$die(8);
        if ($2bc5c818c7e9b08c$export$541ac630993a4c84(base)) base = $2bc5c818c7e9b08c$export$97aac956da55dae9(base);
        const scope = $2bc5c818c7e9b08c$var$enterScope(this);
        const proxy = $2bc5c818c7e9b08c$var$createProxy(scope, base, void 0);
        proxy[$2bc5c818c7e9b08c$var$DRAFT_STATE].isManual_ = true;
        $2bc5c818c7e9b08c$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$2bc5c818c7e9b08c$var$DRAFT_STATE];
        if (!state || !state.isManual_) $2bc5c818c7e9b08c$var$die(9);
        const { scope_: scope } = state;
        $2bc5c818c7e9b08c$var$usePatchesInScope(scope, patchListener);
        return $2bc5c818c7e9b08c$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginPatches).applyPatches_;
        if ($2bc5c818c7e9b08c$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $2bc5c818c7e9b08c$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $2bc5c818c7e9b08c$var$isMap(value) ? $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginMapSet).proxyMap_(value, parent) : $2bc5c818c7e9b08c$var$isSet(value) ? $2bc5c818c7e9b08c$var$getPlugin($2bc5c818c7e9b08c$var$PluginMapSet).proxySet_(value, parent) : $2bc5c818c7e9b08c$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $2bc5c818c7e9b08c$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $2bc5c818c7e9b08c$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $2bc5c818c7e9b08c$export$97aac956da55dae9(value) {
    if (!$2bc5c818c7e9b08c$export$541ac630993a4c84(value)) $2bc5c818c7e9b08c$var$die(10, value);
    return $2bc5c818c7e9b08c$var$currentImpl(value);
}
function $2bc5c818c7e9b08c$var$currentImpl(value) {
    if (!$2bc5c818c7e9b08c$export$16e3aed3edb85946(value) || $2bc5c818c7e9b08c$var$isFrozen(value)) return value;
    const state = value[$2bc5c818c7e9b08c$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $2bc5c818c7e9b08c$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $2bc5c818c7e9b08c$var$shallowCopy(value, true);
    $2bc5c818c7e9b08c$var$each(copy, (key, childValue)=>{
        $2bc5c818c7e9b08c$var$set(copy, key, $2bc5c818c7e9b08c$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $2bc5c818c7e9b08c$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $2bc5c818c7e9b08c$var$getProxyDraft($2bc5c818c7e9b08c$var$get(parentCopy, state.key_));
            const valueAtKey = $2bc5c818c7e9b08c$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $2bc5c818c7e9b08c$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $2bc5c818c7e9b08c$var$get(current2, key);
            if (!$2bc5c818c7e9b08c$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$2bc5c818c7e9b08c$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $2bc5c818c7e9b08c$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $2bc5c818c7e9b08c$var$get(base_, key, type_);
            const value = $2bc5c818c7e9b08c$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $2bc5c818c7e9b08c$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $2bc5c818c7e9b08c$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $2bc5c818c7e9b08c$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $2bc5c818c7e9b08c$var$CONSTRUCTOR)) $2bc5c818c7e9b08c$var$die(errorOffset + 3);
                if ($2bc5c818c7e9b08c$var$isFunction(base) && p === $2bc5c818c7e9b08c$var$PROTOTYPE) $2bc5c818c7e9b08c$var$die(errorOffset + 3);
                base = $2bc5c818c7e9b08c$var$get(base, p);
                if (!$2bc5c818c7e9b08c$var$isObjectish(base)) $2bc5c818c7e9b08c$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $2bc5c818c7e9b08c$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $2bc5c818c7e9b08c$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $2bc5c818c7e9b08c$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$2bc5c818c7e9b08c$export$16e3aed3edb85946(obj)) return obj;
        if ($2bc5c818c7e9b08c$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($2bc5c818c7e9b08c$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($2bc5c818c7e9b08c$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($2bc5c818c7e9b08c$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($2bc5c818c7e9b08c$var$has(obj, $2bc5c818c7e9b08c$export$6ee2082928bcb0ee)) cloned[$2bc5c818c7e9b08c$export$6ee2082928bcb0ee] = obj[$2bc5c818c7e9b08c$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($2bc5c818c7e9b08c$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $2bc5c818c7e9b08c$var$loadPlugin($2bc5c818c7e9b08c$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $2bc5c818c7e9b08c$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$2bc5c818c7e9b08c$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $2bc5c818c7e9b08c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $2bc5c818c7e9b08c$var$latest(this[$2bc5c818c7e9b08c$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $2bc5c818c7e9b08c$var$latest(this[$2bc5c818c7e9b08c$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$2bc5c818c7e9b08c$var$latest(state).has(key) || $2bc5c818c7e9b08c$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $2bc5c818c7e9b08c$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $2bc5c818c7e9b08c$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $2bc5c818c7e9b08c$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($2bc5c818c7e9b08c$var$latest(state).size) {
                prepareMapCopy(state);
                $2bc5c818c7e9b08c$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $2bc5c818c7e9b08c$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            $2bc5c818c7e9b08c$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $2bc5c818c7e9b08c$var$latest(state).get(key);
            if (state.finalized_ || !$2bc5c818c7e9b08c$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $2bc5c818c7e9b08c$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $2bc5c818c7e9b08c$var$latest(this[$2bc5c818c7e9b08c$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($2bc5c818c7e9b08c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$2bc5c818c7e9b08c$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$2bc5c818c7e9b08c$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $2bc5c818c7e9b08c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $2bc5c818c7e9b08c$var$latest(this[$2bc5c818c7e9b08c$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $2bc5c818c7e9b08c$var$markChanged(state);
                state.copy_.add(value);
                $2bc5c818c7e9b08c$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $2bc5c818c7e9b08c$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($2bc5c818c7e9b08c$var$latest(state).size) {
                prepareSetCopy(state);
                $2bc5c818c7e9b08c$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$2bc5c818c7e9b08c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($2bc5c818c7e9b08c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$2bc5c818c7e9b08c$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($2bc5c818c7e9b08c$export$16e3aed3edb85946(value)) {
                    const draft = $2bc5c818c7e9b08c$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $2bc5c818c7e9b08c$var$die(3, JSON.stringify($2bc5c818c7e9b08c$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($2bc5c818c7e9b08c$var$getValue(value));
            });
        }
    }
    $2bc5c818c7e9b08c$var$loadPlugin($2bc5c818c7e9b08c$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $2bc5c818c7e9b08c$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $2bc5c818c7e9b08c$var$prepareCopy(state);
        const result = operation();
        $2bc5c818c7e9b08c$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $2bc5c818c7e9b08c$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $2bc5c818c7e9b08c$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $2bc5c818c7e9b08c$var$loadPlugin($2bc5c818c7e9b08c$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $2bc5c818c7e9b08c$var$immer = new $2bc5c818c7e9b08c$export$aaadc6ff0f822719();
var $2bc5c818c7e9b08c$export$b46cabe22e78bc00 = $2bc5c818c7e9b08c$var$immer.produce;
var $2bc5c818c7e9b08c$export$4da66d41c9492c78 = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.produceWithPatches.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$573f26f60825c493 = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.setAutoFreeze.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$333ce65961cbe047 = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.setUseStrictShallowCopy.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$1045b3be3904c489 = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.setUseStrictIteration.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.applyPatches.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$3c3214997190395f = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.createDraft.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$c60f5e69c521b528 = /* @__PURE__ */ $2bc5c818c7e9b08c$var$immer.finishDraft.bind($2bc5c818c7e9b08c$var$immer);
var $2bc5c818c7e9b08c$export$c05b21e3257751e5 = (value)=>value;
var $2bc5c818c7e9b08c$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("dc0mX", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $99acaeb183ded470$export$f51a9068ac82ea43);
var $99acaeb183ded470$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/vanilla.mjs"
});
const $99acaeb183ded470$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($99acaeb183ded470$import_meta.env ? $99acaeb183ded470$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $99acaeb183ded470$export$f51a9068ac82ea43 = (createState)=>createState ? $99acaeb183ded470$var$createStoreImpl(createState) : $99acaeb183ded470$var$createStoreImpl;
var $99acaeb183ded470$export$2e2bcd8739ae039 = (createState)=>{
    if (($99acaeb183ded470$import_meta.env ? $99acaeb183ded470$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $99acaeb183ded470$export$f51a9068ac82ea43(createState);
};

});


parcelRegister("ezIR3", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $a22c20fb5a8c81a3$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("8EYCQ")).FileFetcherError);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $a62B7 = parcelRequire("a62B7");

var $4KOmc = parcelRequire("4KOmc");

var $8IeZR = parcelRequire("8IeZR");

var $eUgRu = parcelRequire("eUgRu");

var $QXD38 = parcelRequire("QXD38");

var $7GxXx = parcelRequire("7GxXx");

var $heTdg = parcelRequire("heTdg");

var $4Kwvh = parcelRequire("4Kwvh");

var $88fAz = parcelRequire("88fAz");

var $dRkX9 = parcelRequire("dRkX9");

var $eNvXo = parcelRequire("eNvXo");

var $7LXyu = parcelRequire("7LXyu");

var $k0t1W = parcelRequire("k0t1W");

var $96uki = parcelRequire("96uki");

var $amPHK = parcelRequire("amPHK");

var $kNFIw = parcelRequire("kNFIw");

var $4vCw2 = parcelRequire("4vCw2");

var $7NMrd = parcelRequire("7NMrd");

var $4q78e = parcelRequire("4q78e");

var $il9on = parcelRequire("il9on");

var $hho5j = parcelRequire("hho5j");

var $251ox = parcelRequire("251ox");

var $izsnd = parcelRequire("izsnd");

var $PyuEE = parcelRequire("PyuEE");

var $azoTB = parcelRequire("azoTB");

var $cnpKk = parcelRequire("cnpKk");

var $95FIF = parcelRequire("95FIF");

var $hJfx9 = parcelRequire("hJfx9");

var $asz90 = parcelRequire("asz90");

var $iLLjQ = parcelRequire("iLLjQ");

var $fb1Ys = parcelRequire("fb1Ys");

var $7lxp5 = parcelRequire("7lxp5");

var $hsOpp = parcelRequire("hsOpp");

var $7JZuO = parcelRequire("7JZuO");

var $8bOBg = parcelRequire("8bOBg");

var $68VzF = parcelRequire("68VzF");

var $fRnN7 = parcelRequire("fRnN7");

var $8EYCQ = parcelRequire("8EYCQ");

const $a22c20fb5a8c81a3$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $a22c20fb5a8c81a3$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
const $a22c20fb5a8c81a3$var$EXTERNAL_UPLOAD_FALLBACK_STEM = 'image';
// Only used to resolve relative urls so their path can be read; never requested.
const $a22c20fb5a8c81a3$var$EXTERNAL_UPLOAD_URL_BASE = 'https://media.invalid';
// A leading dot names a file rather than an extension, so `.gitignore` splits to a stem.
const $a22c20fb5a8c81a3$var$splitExtension = (name)=>{
    const index = name.lastIndexOf('.');
    return index > 0 ? [
        name.slice(0, index),
        name.slice(index)
    ] : [
        name,
        ''
    ];
};
// Publishing copies media into page attachments keyed by filename, and same-named files collapse
// into versions of a single attachment. External URLs are frequently endpoint-style (for example
// `/binary`), so the stem is made unique before the upload reaches Media Services.
const $a22c20fb5a8c81a3$var$buildExternalUploadName = (url, anonymizeFilename)=>{
    if (anonymizeFilename) return crypto.randomUUID();
    if (!(0, $dRkX9.fg)('platform_media_unique_external_upload_name')) return url.split('/').pop() || '';
    // Reading the path drops any query string, which would otherwise be captured as part of the
    // extension and suppress the MIME-derived fallback.
    const urlName = new URL(url, $a22c20fb5a8c81a3$var$EXTERNAL_UPLOAD_URL_BASE).pathname.split('/').pop() || '';
    const [stem, extension] = $a22c20fb5a8c81a3$var$splitExtension(urlName);
    return `${stem || $a22c20fb5a8c81a3$var$EXTERNAL_UPLOAD_FALLBACK_STEM}-${crypto.randomUUID()}${extension}`;
};
class $a22c20fb5a8c81a3$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $88fAz.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $kNFIw.isCommonMediaClientError)(error)) return (0, $amPHK.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $96uki.CommonMediaClientError)(error);
                return (0, $amPHK.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $96uki.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
                return (0, $amPHK.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh, initialFileState)=>{
            const subject = (0, $95FIF.createMediaSubject)(initialFileState);
            const poll = new (0, $7JZuO.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (!forceRefresh && (initialFileState === null || initialFileState === void 0 ? void 0 : initialFileState.status) === 'processed') {
                    subject.complete();
                    return;
                }
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $4q78e.isNotFoundMediaItemDetails)(response)) throw new (0, $8EYCQ.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $hJfx9.isEmptyFile)(response)) throw new (0, $8EYCQ.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $251ox.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $PyuEE.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' // name property is not available in base64 image
             } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $iLLjQ.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $251ox.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            var _fileState$mediaMetad;
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if ('mediaMetadata' in fileState && (_fileState$mediaMetad = fileState.mediaMetadata) !== null && _fileState$mediaMetad !== void 0 && _fileState$mediaMetad.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch  {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $cnpKk.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $azoTB.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh, initialFileState: initialFileState } = options;
        if (!(0, $7GxXx.isValidUuid)(id)) {
            // Do NOT pass initialFileState here — for an invalid UUID the SSR seed
            // is meaningless and would cause subscribers to briefly see a
            // valid-looking file state before the error is emitted.
            const subject = (0, $95FIF.createMediaSubject)();
            const err = new (0, $8EYCQ.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $fb1Ys.fromObservable)(subject);
        }
        if (forceRefresh) (0, $7LXyu.getFileStreamsCache)().remove(id);
        return (0, $fb1Ys.fromObservable)((0, $7LXyu.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh, initialFileState);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $7lxp5.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge, name) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge, name);
    }
    touchFiles(descriptors, collection, traceContext, expectedFileSize) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext, {
            expectedFileSize: expectedFileSize
        }).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext, expectedFileSize) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $eUgRu.default)();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const occurrenceKey = (0, $eUgRu.default)();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext, expectedFileSize).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext, anonymizeFilename) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $95FIF.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const initialName = $a22c20fb5a8c81a3$var$buildExternalUploadName(url, anonymizeFilename);
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: initialName,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $7LXyu.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const extensionAllowed = anonymizeFilename || (0, $dRkX9.fg)('platform_media_unique_external_upload_name');
            const [, existingExtension] = $a22c20fb5a8c81a3$var$splitExtension(initialName);
            const extension = extensionAllowed && !existingExtension ? (0, $a62B7.getExtension)(type) : undefined;
            const name = extension ? `${initialName}.${extension}` : initialName;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $heTdg.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $asz90.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext, file.size);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $95FIF.createMediaSubject)();
        (0, $7LXyu.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $8IeZR.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $4KOmc.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $hsOpp.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $izsnd.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller === null || controller === void 0 || controller.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $fb1Ys.fromObservable)(subject);
    }
    async downloadBinary(id, name, collectionName, traceContext) {
        const downloadName = name ?? 'download';
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName, undefined, name);
        (0, $QXD38.downloadUrl)(url, {
            name: downloadName
        });
        (0, $k0t1W.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $eNvXo.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $8bOBg.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $fRnN7.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $4Kwvh.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext, source.clientId);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $7LXyu.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($a22c20fb5a8c81a3$var$isCopySourceFileWithToken(source) && $a22c20fb5a8c81a3$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $heTdg.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $hho5j.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $95FIF.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $4vCw2.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $7NMrd.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $68VzF.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $hsOpp.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $hsOpp.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $4vCw2.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $il9on.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $4vCw2.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $7LXyu.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $95FIF.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("a62B7", function(module, exports) {
'use strict';

var $2cLgk = parcelRequire("2cLgk");


module.exports = new $2cLgk((parcelRequire("CNC5X")), (parcelRequire("iDfIt")));

});
parcelRegister("2cLgk", function(module, exports) {
'use strict';
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function $19b15d101e112021$var$Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ $19b15d101e112021$var$Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === '*') continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== '*' ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ $19b15d101e112021$var$Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, '').toLowerCase();
    let ext = last.replace(/^.*\./, '').toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ $19b15d101e112021$var$Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
module.exports = $19b15d101e112021$var$Mime;

});

parcelRegister("CNC5X", function(module, exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

});

parcelRegister("iDfIt", function(module, exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

});


parcelRegister("4KOmc", function(module, exports) {
"use strict";
var $3762852408b19ea3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $3762852408b19ea3$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $3762852408b19ea3$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $3762852408b19ea3$var$map;
var $3762852408b19ea3$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3762852408b19ea3$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $3762852408b19ea3$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3762852408b19ea3$var$MapSubscriber = function(_super) {
    $3762852408b19ea3$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($fwCeA.Subscriber);

});

parcelRegister("QXD38", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $5ccaefebc4df722e$export$8a96edb1c96563f4);
const $5ccaefebc4df722e$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("7GxXx", function(module, exports) {
$parcel$export(module.exports, "isValidUuid", () => $50dc17451a56cb51$export$6ad459db9a6bcc76);
const $50dc17451a56cb51$var$BASIC_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $50dc17451a56cb51$export$6ad459db9a6bcc76 = (value)=>{
    if (typeof value !== 'string') return false;
    const normalizedValue = value.toLowerCase();
    if (!$50dc17451a56cb51$var$BASIC_UUID_REGEX.test(normalizedValue)) return false;
    const version = normalizedValue[14];
    if (version === '1' || version === '2') return true;
    if (version === '3' || version === '4' || version === '5') {
        const variant = normalizedValue[19];
        return variant === '8' || variant === '9' || variant === 'a' || variant === 'b';
    }
    return false;
};

});

parcelRegister("heTdg", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $75781bb0e6f6f392$export$79e1dc0d1801e8ef);

var $kSHWh = parcelRequire("kSHWh");

var $d3B1s = parcelRequire("d3B1s");

var $hcvNb = parcelRequire("hcvNb");

const $75781bb0e6f6f392$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $kSHWh.isArchive)(mimeType)) return 'archive';
    if ((0, $d3B1s.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $hcvNb.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $d3B1s.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $hcvNb.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $d3B1s.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $hcvNb.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $d3B1s.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $hcvNb.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("kSHWh", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $ec2f0dfd01fdf163$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $ec2f0dfd01fdf163$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("d3B1s", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $f80d85f4703aaf54$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $f80d85f4703aaf54$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $f80d85f4703aaf54$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $f80d85f4703aaf54$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $f80d85f4703aaf54$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $f80d85f4703aaf54$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $f80d85f4703aaf54$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $f80d85f4703aaf54$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $f80d85f4703aaf54$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $f80d85f4703aaf54$export$55ca6cdaf6093034 = (mimeType)=>$f80d85f4703aaf54$export$74325e3c843a9555(mimeType) || $f80d85f4703aaf54$export$c021f2623a75015f(mimeType) || $f80d85f4703aaf54$export$ff36075ea755a717(mimeType) || $f80d85f4703aaf54$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("hcvNb", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $e057c26963a5d5c4$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $e057c26963a5d5c4$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $e057c26963a5d5c4$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $e057c26963a5d5c4$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $e057c26963a5d5c4$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $e057c26963a5d5c4$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $e057c26963a5d5c4$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $e057c26963a5d5c4$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $e057c26963a5d5c4$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $e057c26963a5d5c4$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $e057c26963a5d5c4$export$548d9148a80556a3 = (mimeType)=>$e057c26963a5d5c4$export$e9a065a80f76311e(mimeType) || $e057c26963a5d5c4$export$86baad7a89d908e9(mimeType) || $e057c26963a5d5c4$export$8cba23825d020bbb(mimeType) || $e057c26963a5d5c4$export$9c2b4de5fdca2ce3(mimeType) || $e057c26963a5d5c4$export$94e1479e01d2af53(mimeType);

});


parcelRegister("4Kwvh", function(module, exports) {
$parcel$export(module.exports, "authToOwner", () => $3c971afdff9e1a4b$export$17f6055767a8d96a);

var $lXw42 = parcelRequire("lXw42");
const $3c971afdff9e1a4b$export$17f6055767a8d96a = (auth)=>{
    if ((0, $lXw42.isAsapBasedAuth)(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});
parcelRegister("lXw42", function(module, exports) {
$parcel$export(module.exports, "isAsapBasedAuth", () => $775c3e142e2f16fb$export$af1ab14f2246ef72);
function $775c3e142e2f16fb$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}

});


parcelRegister("eNvXo", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $2f423b64bbc2a8a9$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $2f423b64bbc2a8a9$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $2f423b64bbc2a8a9$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $2f423b64bbc2a8a9$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $2f423b64bbc2a8a9$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $2f423b64bbc2a8a9$export$f14f521f3d306044);
$parcel$export(module.exports, "FILE_READER_FALLBACK_ERROR_NAME", () => $2f423b64bbc2a8a9$export$b3e78a9a23c941e9);

var $6EvJE = parcelRequire("6EvJE");
const $2f423b64bbc2a8a9$export$860a16125e30000b = 'recents';
const $2f423b64bbc2a8a9$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $2f423b64bbc2a8a9$export$6e70f30e392bc53f = 4096;
const $2f423b64bbc2a8a9$export$c1abb8bab1e615cd = 5 * (0, $6EvJE.DATA_UNIT).MB;
const $2f423b64bbc2a8a9$export$3d5157f0def70e54 = 1000;
const $2f423b64bbc2a8a9$export$f14f521f3d306044 = 2 * (0, $6EvJE.DATA_UNIT).TB;
const $2f423b64bbc2a8a9$export$b3e78a9a23c941e9 = 'FileReaderError';

});
parcelRegister("6EvJE", function(module, exports) {
$parcel$export(module.exports, "DATA_UNIT", () => $c7bca06ae88bd0d1$export$76cfea4c354af843);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

var $c7bca06ae88bd0d1$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("7LXyu", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $d4fe5b13f7306cc8$export$f2f061938c1e6810);

var $8N5vw = parcelRequire("8N5vw");
let $d4fe5b13f7306cc8$var$streamCache;

const $d4fe5b13f7306cc8$export$f2f061938c1e6810 = ()=>{
    if (!$d4fe5b13f7306cc8$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("kOQzt")).mediaState;
        $d4fe5b13f7306cc8$var$streamCache = new (0, $8N5vw.StreamsCache)(mediaState.streams);
    }
    return $d4fe5b13f7306cc8$var$streamCache;
};

});
parcelRegister("8N5vw", function(module, exports) {
$parcel$export(module.exports, "StreamsCache", () => $63aee4b3d9dbc06f$export$4293896e79732236);
class $63aee4b3d9dbc06f$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}

});

parcelRegister("kOQzt", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $d0474f1c92ce0522$export$8cef61637918b288);

var $JlnMl = parcelRequire("JlnMl");

var $11Qwb = parcelRequire("11Qwb");
const $d0474f1c92ce0522$export$8cef61637918b288 = {
    streams: new (0, $11Qwb.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $JlnMl.EventEmitter2)()
};

});
parcelRegister("11Qwb", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("k0t1W", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $f8029cba667a0940$export$68d003d3105952ad);

var $kOQzt = parcelRequire("kOQzt");
const $f8029cba667a0940$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $kOQzt.mediaState).eventEmitter) (0, $kOQzt.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $kOQzt.mediaState).eventEmitter) (0, $kOQzt.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $kOQzt.mediaState).eventEmitter) return (0, $kOQzt.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("96uki", function(module, exports) {
$parcel$export(module.exports, "CommonMediaClientError", () => $87ccef564d40b024$export$e574d1724215079f);

var $yw0N8 = parcelRequire("yw0N8");
class $87ccef564d40b024$export$e574d1724215079f extends (0, $yw0N8.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}

});
parcelRegister("yw0N8", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $5e5e9ed9ab5a8485$export$2b0aca14d61c3190);
class $5e5e9ed9ab5a8485$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});


parcelRegister("amPHK", function(module, exports) {
$parcel$export(module.exports, "fromCommonMediaClientError", () => $a578a8830561fab1$export$c2b89b9a32286816);
const $a578a8830561fab1$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error === null || error === void 0 ? void 0 : error.reason,
                metadata: error === null || error === void 0 ? void 0 : error.metadata,
                innerError: error === null || error === void 0 ? void 0 : error.innerError
            },
            // Legacy details
            ...error === null || error === void 0 ? void 0 : error.attributes
        },
        message: error === null || error === void 0 ? void 0 : error.message
    };
};

});

parcelRegister("kNFIw", function(module, exports) {
$parcel$export(module.exports, "isCommonMediaClientError", () => $7b78e70322ea7f9a$export$881f0f9bc813e1f3);

var $96uki = parcelRequire("96uki");
function $7b78e70322ea7f9a$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof (0, $96uki.CommonMediaClientError)) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}

});

parcelRegister("4vCw2", function(module, exports) {
$parcel$export(module.exports, "isErrorFileState", () => $89d21c84fa86b8a4$export$f863e1e09c8a926);
const $89d21c84fa86b8a4$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';

});

parcelRegister("7NMrd", function(module, exports) {
$parcel$export(module.exports, "isFinalFileState", () => $978008e70cd88592$export$270b3fc27120edd0);
const $978008e70cd88592$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);

});

parcelRegister("4q78e", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $3d1826aa73a1ffa5$export$fd27d7abbc4a746d);
const $3d1826aa73a1ffa5$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};

});

parcelRegister("il9on", function(module, exports) {
$parcel$export(module.exports, "isProcessingFileState", () => $ae002855d8becc9d$export$5c30e6dd75278e66);
const $ae002855d8becc9d$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';

});

parcelRegister("hho5j", function(module, exports) {
$parcel$export(module.exports, "mapMediaFileToFileState", () => $6e3d5c24f0cdffbe$export$ddfd67d20657322f);
const $6e3d5c24f0cdffbe$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata, failReason: failReason, previewCdnUrl: previewCdnUrl } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata,
        previewCdnUrl: previewCdnUrl
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing',
                failReason: failReason
            };
    }
};

});

parcelRegister("251ox", function(module, exports) {
$parcel$export(module.exports, "mapMediaItemToFileState", () => $44dc789a03f09a90$export$ea3730792e8bebfb);

var $hho5j = parcelRequire("hho5j");
const $44dc789a03f09a90$export$ea3730792e8bebfb = (id, item)=>{
    return (0, $hho5j.mapMediaFileToFileState)({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("izsnd", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $cf20aaf7cb69b737$export$a5575dbeeffdad98);

var $kQy2N = parcelRequire("kQy2N");

var $c4lxx = parcelRequire("c4lxx");

var $bxzWV = parcelRequire("bxzWV");

var $eNvXo = parcelRequire("eNvXo");

var $2Vz82 = parcelRequire("2Vz82");

var $cn9xm = parcelRequire("cn9xm");

var $175O4 = parcelRequire("175O4");
const $cf20aaf7cb69b737$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $2Vz82.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $cf20aaf7cb69b737$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $cf20aaf7cb69b737$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext, size)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $cf20aaf7cb69b737$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext, {
            expectedFileSize: size
        });
        offset += chunks.length;
    };
};
const $cf20aaf7cb69b737$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType, content: content } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    // If the file is a Blob and the size is not passed from consumer, set the file size from file content
    if (content instanceof Blob && !file.size) file.size = content.size;
    return store.createFileFromUpload({
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    }, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext, {
        expectedFileSize: file.size
    });
};
const $cf20aaf7cb69b737$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $eNvXo.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $cn9xm.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $cn9xm.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $175O4.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $bxzWV.chunkinator)(content, {
        hashingFunction: (blob)=>$cf20aaf7cb69b737$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $cf20aaf7cb69b737$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $eNvXo.PROCESSING_BATCH_SIZE),
        processingFunction: $cf20aaf7cb69b737$var$createProcessingFunction(store, deferredUploadId, collection, traceContext, file.size)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $kQy2N.from)(deferredUploadId).pipe((0, $c4lxx.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $c4lxx.concatMap)(()=>(0, $kQy2N.from)($cf20aaf7cb69b737$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $cf20aaf7cb69b737$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("kQy2N", function(module, exports) {
$parcel$export(module.exports, "from", () => $f2d312676f755fd8$export$6788812c4e6611e6, (v) => $f2d312676f755fd8$export$6788812c4e6611e6 = v);
var $f2d312676f755fd8$export$6788812c4e6611e6;
"use strict";

var $eRGDk = parcelRequire("eRGDk");
$f2d312676f755fd8$export$6788812c4e6611e6 = $eRGDk.FromObservable.create;

});
parcelRegister("eRGDk", function(module, exports) {
"use strict";
var $ad27160582b3d6e3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bHRhK = parcelRequire("bHRhK");

var $3ZjfH = parcelRequire("3ZjfH");

var $jIEIv = parcelRequire("jIEIv");

var $lkbJX = parcelRequire("lkbJX");

var $9zu9E = parcelRequire("9zu9E");

var $eogqV = parcelRequire("eogqV");

var $goUjH = parcelRequire("goUjH");

var $lTj45 = parcelRequire("lTj45");

var $jFk35 = parcelRequire("jFk35");

var $aLrOR = parcelRequire("aLrOR");

var $kdmZ2 = parcelRequire("kdmZ2");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ad27160582b3d6e3$var$FromObservable = function(_super) {
    $ad27160582b3d6e3$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$kdmZ2.observable] === 'function') {
                if (ish instanceof $jFk35.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($bHRhK.isArray(ish)) return new $eogqV.ArrayObservable(ish, scheduler);
            else if ($jIEIv.isPromise(ish)) return new $lkbJX.PromiseObservable(ish, scheduler);
            else if (typeof ish[$lTj45.iterator] === 'function' || typeof ish === 'string') return new $9zu9E.IteratorObservable(ish, scheduler);
            else if ($3ZjfH.isArrayLike(ish)) return new $goUjH.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$kdmZ2.observable]().subscribe(subscriber);
        else return ish[$kdmZ2.observable]().subscribe(new $aLrOR.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($jFk35.Observable);
module.exports.FromObservable = $ad27160582b3d6e3$var$FromObservable;

});
parcelRegister("3ZjfH", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $2e7600ac497554be$export$1e2f57719e155213, (v) => $2e7600ac497554be$export$1e2f57719e155213 = v);
var $2e7600ac497554be$export$1e2f57719e155213;
"use strict";
$2e7600ac497554be$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("jIEIv", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $e5b1b5e5e5223f8e$export$4369c812aac99591, (v) => $e5b1b5e5e5223f8e$export$4369c812aac99591 = v);
var $e5b1b5e5e5223f8e$export$4369c812aac99591;
"use strict";
function $e5b1b5e5e5223f8e$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$e5b1b5e5e5223f8e$export$4369c812aac99591 = $e5b1b5e5e5223f8e$var$isPromise;

});

parcelRegister("lkbJX", function(module, exports) {
"use strict";
var $f864929e21585cf4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4xUKK = parcelRequire("4xUKK");

var $jFk35 = parcelRequire("jFk35");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f864929e21585cf4$var$PromiseObservable = function(_super) {
    $f864929e21585cf4$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $4xUKK.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($f864929e21585cf4$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($f864929e21585cf4$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($f864929e21585cf4$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $4xUKK.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($jFk35.Observable);
module.exports.PromiseObservable = $f864929e21585cf4$var$PromiseObservable;
function $f864929e21585cf4$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $f864929e21585cf4$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});

parcelRegister("9zu9E", function(module, exports) {
"use strict";
var $6f7ec6042b01e3e8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4xUKK = parcelRequire("4xUKK");

var $jFk35 = parcelRequire("jFk35");

var $lTj45 = parcelRequire("lTj45");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $6f7ec6042b01e3e8$var$IteratorObservable = function(_super) {
    $6f7ec6042b01e3e8$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $6f7ec6042b01e3e8$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($jFk35.Observable);
module.exports.IteratorObservable = $6f7ec6042b01e3e8$var$IteratorObservable;
var $6f7ec6042b01e3e8$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$lTj45.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $6f7ec6042b01e3e8$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $6f7ec6042b01e3e8$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$lTj45.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $6f7ec6042b01e3e8$var$getIterator(obj) {
    var i = obj[$lTj45.iterator];
    if (!i && typeof obj === 'string') return new $6f7ec6042b01e3e8$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $6f7ec6042b01e3e8$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$lTj45.iterator]();
}
var $6f7ec6042b01e3e8$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $6f7ec6042b01e3e8$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$6f7ec6042b01e3e8$var$numberIsFinite(len)) return len;
    len = $6f7ec6042b01e3e8$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $6f7ec6042b01e3e8$var$maxSafeInteger) return $6f7ec6042b01e3e8$var$maxSafeInteger;
    return len;
}
function $6f7ec6042b01e3e8$var$numberIsFinite(value) {
    return typeof value === 'number' && $4xUKK.root.isFinite(value);
}
function $6f7ec6042b01e3e8$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});
parcelRegister("lTj45", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $fefd85e94baa414b$export$6f58e2338da23f4d, (v) => $fefd85e94baa414b$export$6f58e2338da23f4d = v);
var $fefd85e94baa414b$export$77b88d321d1c84c6;
var $fefd85e94baa414b$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $fefd85e94baa414b$export$9785f547d3164dac;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
function $fefd85e94baa414b$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$fefd85e94baa414b$export$77b88d321d1c84c6 = $fefd85e94baa414b$var$symbolIteratorPonyfill;
$fefd85e94baa414b$export$6f58e2338da23f4d = $fefd85e94baa414b$var$symbolIteratorPonyfill($4xUKK.root);
$fefd85e94baa414b$export$9785f547d3164dac = $fefd85e94baa414b$export$6f58e2338da23f4d;

});


parcelRegister("eogqV", function(module, exports) {
"use strict";
var $a7a00de61642c109$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $3DDoV = parcelRequire("3DDoV");

var $b9w09 = parcelRequire("b9w09");

var $2gCz7 = parcelRequire("2gCz7");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a7a00de61642c109$var$ArrayObservable = function(_super) {
    $a7a00de61642c109$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($2gCz7.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $3DDoV.ScalarObservable(array[0], scheduler);
        else return new $b9w09.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($jFk35.Observable);
module.exports.ArrayObservable = $a7a00de61642c109$var$ArrayObservable;

});
parcelRegister("3DDoV", function(module, exports) {
"use strict";
var $2a6393d95b74c6ed$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2a6393d95b74c6ed$var$ScalarObservable = function(_super) {
    $2a6393d95b74c6ed$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($jFk35.Observable);
module.exports.ScalarObservable = $2a6393d95b74c6ed$var$ScalarObservable;

});

parcelRegister("b9w09", function(module, exports) {
"use strict";
var $81e95bc63ea16ede$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $81e95bc63ea16ede$var$EmptyObservable = function(_super) {
    $81e95bc63ea16ede$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($jFk35.Observable);
module.exports.EmptyObservable = $81e95bc63ea16ede$var$EmptyObservable;

});

parcelRegister("2gCz7", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $1a6afdb58ecf07a2$export$187e35932e88c15c, (v) => $1a6afdb58ecf07a2$export$187e35932e88c15c = v);
var $1a6afdb58ecf07a2$export$187e35932e88c15c;
"use strict";
function $1a6afdb58ecf07a2$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$1a6afdb58ecf07a2$export$187e35932e88c15c = $1a6afdb58ecf07a2$var$isScheduler;

});


parcelRegister("goUjH", function(module, exports) {
"use strict";
var $bf0a928e25d2a0a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $3DDoV = parcelRequire("3DDoV");

var $b9w09 = parcelRequire("b9w09");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $bf0a928e25d2a0a1$var$ArrayLikeObservable = function(_super) {
    $bf0a928e25d2a0a1$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $b9w09.EmptyObservable();
        else if (length === 1) return new $3DDoV.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($jFk35.Observable);
module.exports.ArrayLikeObservable = $bf0a928e25d2a0a1$var$ArrayLikeObservable;

});

parcelRegister("aLrOR", function(module, exports) {
"use strict";
var $7d63df7c014701db$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $jWUHN = parcelRequire("jWUHN");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $7d63df7c014701db$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $7d63df7c014701db$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $7d63df7c014701db$var$observeOn;
var $7d63df7c014701db$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7d63df7c014701db$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $7d63df7c014701db$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7d63df7c014701db$var$ObserveOnSubscriber = function(_super) {
    $7d63df7c014701db$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $7d63df7c014701db$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($jWUHN.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($jWUHN.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($jWUHN.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($fwCeA.Subscriber);
module.exports.ObserveOnSubscriber = $7d63df7c014701db$var$ObserveOnSubscriber;
var $7d63df7c014701db$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $7d63df7c014701db$var$ObserveOnMessage;

});
parcelRegister("jWUHN", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $e85f6b98a966faad$export$14834abbfce3b8cd, (v) => $e85f6b98a966faad$export$14834abbfce3b8cd = v);
var $e85f6b98a966faad$export$14834abbfce3b8cd;
"use strict";

var $jFk35 = parcelRequire("jFk35");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $e85f6b98a966faad$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $jFk35.Observable.of(this.value);
            case 'E':
                return $jFk35.Observable.throw(this.error);
            case 'C':
                return $jFk35.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$e85f6b98a966faad$export$14834abbfce3b8cd = $e85f6b98a966faad$var$Notification;

});




parcelRegister("c4lxx", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $8c96911fbd1f20b6$export$c28c8388be0ab31a, (v) => $8c96911fbd1f20b6$export$c28c8388be0ab31a = v);
var $8c96911fbd1f20b6$export$c28c8388be0ab31a;
"use strict";

var $3kOhX = parcelRequire("3kOhX");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $8c96911fbd1f20b6$var$concatMap(project, resultSelector) {
    return $3kOhX.mergeMap(project, resultSelector, 1);
}
$8c96911fbd1f20b6$export$c28c8388be0ab31a = $8c96911fbd1f20b6$var$concatMap;

});
parcelRegister("3kOhX", function(module, exports) {
"use strict";
var $26da3fa0cd6ea725$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $26da3fa0cd6ea725$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $26da3fa0cd6ea725$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $26da3fa0cd6ea725$var$mergeMap;
var $26da3fa0cd6ea725$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $26da3fa0cd6ea725$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $26da3fa0cd6ea725$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $26da3fa0cd6ea725$var$MergeMapSubscriber = function(_super) {
    $26da3fa0cd6ea725$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($8JM6B.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.MergeMapSubscriber = $26da3fa0cd6ea725$var$MergeMapSubscriber;

});
parcelRegister("8JM6B", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $65c7d7725472550d$export$d0604af3321cfb1b, (v) => $65c7d7725472550d$export$d0604af3321cfb1b = v);
var $65c7d7725472550d$export$d0604af3321cfb1b;
"use strict";

var $4xUKK = parcelRequire("4xUKK");

var $3ZjfH = parcelRequire("3ZjfH");

var $jIEIv = parcelRequire("jIEIv");

var $6q2tC = parcelRequire("6q2tC");

var $jFk35 = parcelRequire("jFk35");

var $lTj45 = parcelRequire("lTj45");

var $8BlEi = parcelRequire("8BlEi");

var $kdmZ2 = parcelRequire("kdmZ2");
function $65c7d7725472550d$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $8BlEi.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $jFk35.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($3ZjfH.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($jIEIv.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $4xUKK.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$lTj45.iterator] === 'function') {
        var iterator = result[$lTj45.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$kdmZ2.observable] === 'function') {
        var obs = result[$kdmZ2.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $8BlEi.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $6q2tC.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$65c7d7725472550d$export$d0604af3321cfb1b = $65c7d7725472550d$var$subscribeToResult;

});
parcelRegister("8BlEi", function(module, exports) {
"use strict";
var $6432927b14079589$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6432927b14079589$var$InnerSubscriber = function(_super) {
    $6432927b14079589$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($fwCeA.Subscriber);
module.exports.InnerSubscriber = $6432927b14079589$var$InnerSubscriber;

});


parcelRegister("cSU8n", function(module, exports) {
"use strict";
var $9616123e3c711de0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9616123e3c711de0$var$OuterSubscriber = function(_super) {
    $9616123e3c711de0$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($fwCeA.Subscriber);
module.exports.OuterSubscriber = $9616123e3c711de0$var$OuterSubscriber;

});



parcelRegister("bxzWV", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $8f9836dc9d830029$export$9ab6bef3838698f8);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $j9itN = parcelRequire("j9itN");
const $8f9836dc9d830029$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return (0, $j9itN.getObservableFromFile)(file, options, callbacks);
};

});
parcelRegister("j9itN", function(module, exports) {
$parcel$export(module.exports, "getObservableFromFile", () => $39ac6f5ecd45b0bb$export$88e80b3a0bb31f63);

var $kQy2N = parcelRequire("kQy2N");

var $9UmnK = parcelRequire("9UmnK");

var $btX5F = parcelRequire("btX5F");

var $c4lxx = parcelRequire("c4lxx");

var $Ap2W5 = parcelRequire("Ap2W5");

var $7NnQ3 = parcelRequire("7NnQ3");

var $l41YP = parcelRequire("l41YP");

var $z8viq = parcelRequire("z8viq");

var $4PMc6 = parcelRequire("4PMc6");

var $iJELW = parcelRequire("iJELW");
const $39ac6f5ecd45b0bb$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $9UmnK.fromPromise)((0, $7NnQ3.fetchBlob)(file)).pipe((0, $c4lxx.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $4PMc6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $l41YP.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $iJELW.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $Ap2W5.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $z8viq.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $c4lxx.concatMap)((batchedChunks)=>{
            return (0, $kQy2N.from)(batchedChunks);
        }), (0, $btX5F.bufferCount)(totalChunks));
    }));

});
parcelRegister("9UmnK", function(module, exports) {
$parcel$export(module.exports, "fromPromise", () => $736ab4a3e6f0d424$export$60f45028237c39d1, (v) => $736ab4a3e6f0d424$export$60f45028237c39d1 = v);
var $736ab4a3e6f0d424$export$60f45028237c39d1;
"use strict";

var $lkbJX = parcelRequire("lkbJX");
$736ab4a3e6f0d424$export$60f45028237c39d1 = $lkbJX.PromiseObservable.create;

});

parcelRegister("btX5F", function(module, exports) {
"use strict";
var $85c03d40559f5c4b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $85c03d40559f5c4b$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $85c03d40559f5c4b$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $85c03d40559f5c4b$var$bufferCount;
var $85c03d40559f5c4b$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $85c03d40559f5c4b$var$BufferCountSubscriber;
        else this.subscriberClass = $85c03d40559f5c4b$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $85c03d40559f5c4b$var$BufferCountSubscriber = function(_super) {
    $85c03d40559f5c4b$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($fwCeA.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $85c03d40559f5c4b$var$BufferSkipCountSubscriber = function(_super) {
    $85c03d40559f5c4b$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($fwCeA.Subscriber);

});

parcelRegister("Ap2W5", function(module, exports) {
"use strict";
var $06d6ca975f891769$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $06d6ca975f891769$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $06d6ca975f891769$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $06d6ca975f891769$var$tap;
var $06d6ca975f891769$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $06d6ca975f891769$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $06d6ca975f891769$var$DoSubscriber = function(_super) {
    $06d6ca975f891769$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $fwCeA.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($fwCeA.Subscriber);

});

parcelRegister("7NnQ3", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $5ac6a532b250090d$export$14e9cfd4a872cc1e);
async function $5ac6a532b250090d$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}

});

parcelRegister("l41YP", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $d46dd630e4ff84be$export$d5f5a550a38ec367);

var $jpbhF = parcelRequire("jpbhF");

var $6EFHZ = parcelRequire("6EFHZ");
const $d46dd630e4ff84be$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $jpbhF.asyncMap)((0, $6EFHZ.blobToHashedBlob)(hasher), concurrency)(blobs$);

});
parcelRegister("jpbhF", function(module, exports) {
$parcel$export(module.exports, "asyncMap", () => $f7e59221a0b14c2b$export$707ee4c4c95d39e3);

var $jFk35 = parcelRequire("jFk35");

var $3kOhX = parcelRequire("3kOhX");
const $f7e59221a0b14c2b$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $f7e59221a0b14c2b$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $jFk35.Observable)((sub)=>{
            notifiers.push($f7e59221a0b14c2b$var$notify(project(value), sub, onReady));
        });
};
const $f7e59221a0b14c2b$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $3kOhX.mergeMap)($f7e59221a0b14c2b$var$mapper(project), concurrent);

});

parcelRegister("6EFHZ", function(module, exports) {
$parcel$export(module.exports, "blobToHashedBlob", () => $31984ef1414de097$export$28a452a485721473);
const $31984ef1414de097$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));

});


parcelRegister("z8viq", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $9fe1f8875043e9f9$export$2f21790600302ed);

var $btX5F = parcelRequire("btX5F");

var $c4lxx = parcelRequire("c4lxx");
const $9fe1f8875043e9f9$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $btX5F.bufferCount)(options.batchSize)).pipe((0, $c4lxx.concatMap)(process));
};

});

parcelRegister("4PMc6", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $c88594c60d0fd163$export$5b92d769f2f57509);

var $lV2sg = parcelRequire("lV2sg");

var $4KOmc = parcelRequire("4KOmc");
const $c88594c60d0fd163$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $lV2sg.range)(0, totalChunks).pipe((0, $4KOmc.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});
parcelRegister("lV2sg", function(module, exports) {
$parcel$export(module.exports, "range", () => $ff50d357b29533a7$export$d02631cccf789723, (v) => $ff50d357b29533a7$export$d02631cccf789723 = v);
var $ff50d357b29533a7$export$d02631cccf789723;
"use strict";

var $34vP6 = parcelRequire("34vP6");
$ff50d357b29533a7$export$d02631cccf789723 = $34vP6.RangeObservable.create;

});
parcelRegister("34vP6", function(module, exports) {
"use strict";
var $23ca6e39e7673c73$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $23ca6e39e7673c73$var$RangeObservable = function(_super) {
    $23ca6e39e7673c73$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($jFk35.Observable);
module.exports.RangeObservable = $23ca6e39e7673c73$var$RangeObservable;

});



parcelRegister("iJELW", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $651dc75dba8f0327$export$94ce0f3fcf999415);

var $jpbhF = parcelRequire("jpbhF");
const $651dc75dba8f0327$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $jpbhF.asyncMap)(upload, options.concurrency));
};

});



parcelRegister("2Vz82", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $f8b1d83e4ee9b519$export$14b114effbc08b6b);

var $lh6Yd = parcelRequire("lh6Yd");
let $f8b1d83e4ee9b519$var$hasher = null;
let $f8b1d83e4ee9b519$var$sha256Hasher = null;
const $f8b1d83e4ee9b519$export$d9c9d11cd648a505 = ()=>{
    $f8b1d83e4ee9b519$var$hasher = null;
    $f8b1d83e4ee9b519$var$sha256Hasher = null;
};


const $f8b1d83e4ee9b519$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $lh6Yd.ChunkHashAlgorithm).Sha256) {
            if (!$f8b1d83e4ee9b519$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("jGMMS"));
                $f8b1d83e4ee9b519$var$sha256Hasher = new SimpleHasher();
            }
            return $f8b1d83e4ee9b519$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("362sF"));
    $f8b1d83e4ee9b519$var$hasher = new SimpleHasher();
    return $f8b1d83e4ee9b519$var$hasher;
};

});
parcelRegister("jGMMS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jUXSj").then(()=>parcelRequire('bugJ1'));

});

parcelRegister("362sF", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5TqqM"),
    $9dnsd("boCnB")
]).then(()=>parcelRequire('6Ub7e'));

});


parcelRegister("cn9xm", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $74365e9e0db460f4$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $74365e9e0db460f4$export$71f452e02035c1e2);

var $eNvXo = parcelRequire("eNvXo");

var $6EvJE = parcelRequire("6EvJE");
const $74365e9e0db460f4$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $74365e9e0db460f4$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $eNvXo.MAX_UPLOAD_FILE_SIZE)) throw new Error($74365e9e0db460f4$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $6EvJE.DATA_UNIT).GB) return 5 * (0, $6EvJE.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $6EvJE.DATA_UNIT).GB && fileSize <= 50 * (0, $6EvJE.DATA_UNIT).GB) return 50 * (0, $6EvJE.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $6EvJE.DATA_UNIT).GB && fileSize <= 0.95 * (0, $6EvJE.DATA_UNIT).TB) return 100 * (0, $6EvJE.DATA_UNIT).MB;
    return 210 * (0, $6EvJE.DATA_UNIT).MB;
};

});

parcelRegister("175O4", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $9e46d8995448df12$export$515240c3f059c807);

var $yw0N8 = parcelRequire("yw0N8");
class $9e46d8995448df12$export$515240c3f059c807 extends (0, $yw0N8.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}

});


parcelRegister("PyuEE", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $af659b1511b10d7a$export$ed17558b11b88056);
const $af659b1511b10d7a$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("azoTB", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $444e53c3011f487a$export$57945b6819e39246);

var $6kMSc = parcelRequire("6kMSc");

var $1uElz = parcelRequire("1uElz");
const $444e53c3011f487a$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $444e53c3011f487a$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $1uElz.getRandomTelemetryId)(),
                spanId: (0, $1uElz.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            var _items$find;
            return (_items$find = items.find((item)=>item.id === id && item.collection === collectionName)) === null || _items$find === void 0 ? void 0 : _items$find.error;
        });
    };
}
function $444e53c3011f487a$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($6kMSc)))($444e53c3011f487a$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $444e53c3011f487a$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});
parcelRegister("6kMSc", function(module, exports) {

var $3jCFs = parcelRequire("3jCFs");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $49ca858b6b727b4c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $49ca858b6b727b4c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $49ca858b6b727b4c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $49ca858b6b727b4c$var$getValidCacheKeyFn(options);
        this._cacheMap = $49ca858b6b727b4c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $49ca858b6b727b4c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $49ca858b6b727b4c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$49ca858b6b727b4c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $49ca858b6b727b4c$var$enqueuePostPromiseJob = typeof $3jCFs === 'object' && typeof $3jCFs.nextTick === 'function' ? function(fn) {
    if (!$49ca858b6b727b4c$var$resolvedPromise) $49ca858b6b727b4c$var$resolvedPromise = Promise.resolve();
    $49ca858b6b727b4c$var$resolvedPromise.then(function() {
        $3jCFs.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $49ca858b6b727b4c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $49ca858b6b727b4c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $49ca858b6b727b4c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $49ca858b6b727b4c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $49ca858b6b727b4c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $49ca858b6b727b4c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $49ca858b6b727b4c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$49ca858b6b727b4c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $49ca858b6b727b4c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $49ca858b6b727b4c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $49ca858b6b727b4c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $49ca858b6b727b4c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $49ca858b6b727b4c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $49ca858b6b727b4c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $49ca858b6b727b4c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $49ca858b6b727b4c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $49ca858b6b727b4c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $49ca858b6b727b4c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $49ca858b6b727b4c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $49ca858b6b727b4c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $49ca858b6b727b4c$var$DataLoader;

});

parcelRegister("1uElz", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $69857d936747a190$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $69857d936747a190$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $69857d936747a190$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $69857d936747a190$export$2e36de8639bad0ad);
const $69857d936747a190$export$fce6876652108ab = (value)=>value === undefined;
const $69857d936747a190$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $69857d936747a190$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $69857d936747a190$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $69857d936747a190$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $69857d936747a190$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $69857d936747a190$export$456b25e3a9b4a843(byte) {
    var _window;
    let randomHex;
    if ((_window = window) !== null && _window !== void 0 && _window.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $69857d936747a190$var$getRandomHexValues(byte);
    }
    else randomHex = $69857d936747a190$var$getRandomHexValues(byte);
    return randomHex;
}
function $69857d936747a190$export$2e36de8639bad0ad() {
    return $69857d936747a190$export$456b25e3a9b4a843(8);
}

});


parcelRegister("cnpKk", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $38d77bd14d5c76d3$export$ae188fee39529b82);

var $6kMSc = parcelRequire("6kMSc");

var $kzLNg = parcelRequire("kzLNg");

var $hANe2 = parcelRequire("hANe2");
function $38d77bd14d5c76d3$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($6kMSc)))((0, $kzLNg.createBatchLoadingFunc)(mediaStore), {
        maxBatchSize: (0, $hANe2.MAX_BATCH_SIZE)
    });
}

});
parcelRegister("kzLNg", function(module, exports) {
$parcel$export(module.exports, "createBatchLoadingFunc", () => $a8ec084e55dfcaa5$export$4a53beb129e8c49a);

var $1uElz = parcelRequire("1uElz");

var $jQXgm = parcelRequire("jQXgm");
function $a8ec084e55dfcaa5$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $1uElz.getRandomTelemetryId)(),
                spanId: (0, $1uElz.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return (0, $jQXgm.getItemsFromKeys)(keys, items);
    };
}

});
parcelRegister("jQXgm", function(module, exports) {
$parcel$export(module.exports, "getItemsFromKeys", () => $f85051c481fb53f7$export$71cd2e8f8162d47b);
const $f85051c481fb53f7$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $f85051c481fb53f7$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $f85051c481fb53f7$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $f85051c481fb53f7$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $f85051c481fb53f7$var$makeCacheKey(id, collection);
        if ($f85051c481fb53f7$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($f85051c481fb53f7$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $f85051c481fb53f7$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};

});


parcelRegister("hANe2", function(module, exports) {
$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $85828d328a177de0$export$b79d95ee17a87a);
const $85828d328a177de0$export$b79d95ee17a87a = 100;

});


parcelRegister("95FIF", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $13f84cfa4840bee5$export$bc76d51553fa5e35);

var $dktU4 = parcelRequire("dktU4");
function $13f84cfa4840bee5$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $dktU4.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});
parcelRegister("dktU4", function(module, exports) {
"use strict";
var $9b4456c85010cbbf$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $fh4Yk = parcelRequire("fh4Yk");

var $8IeZR = parcelRequire("8IeZR");

var $aLrOR = parcelRequire("aLrOR");

var $imzSm = parcelRequire("imzSm");

var $bVy6d = parcelRequire("bVy6d");
/**
 * @class ReplaySubject<T>
 */ var $9b4456c85010cbbf$var$ReplaySubject = function(_super) {
    $9b4456c85010cbbf$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $9b4456c85010cbbf$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $8IeZR.Subscription.EMPTY;
        else if (this.isStopped) subscription = $8IeZR.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $bVy6d.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $aLrOR.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $fh4Yk.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($aSveF.Subject);
module.exports.ReplaySubject = $9b4456c85010cbbf$var$ReplaySubject;
var $9b4456c85010cbbf$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRegister("aSveF", function(module, exports) {
"use strict";
var $7eb72d3cb8bb1662$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $fwCeA = parcelRequire("fwCeA");

var $8IeZR = parcelRequire("8IeZR");

var $imzSm = parcelRequire("imzSm");

var $bVy6d = parcelRequire("bVy6d");

var $4THwh = parcelRequire("4THwh");
/**
 * @class SubjectSubscriber<T>
 */ var $7eb72d3cb8bb1662$var$SubjectSubscriber = function(_super) {
    $7eb72d3cb8bb1662$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($fwCeA.Subscriber);
module.exports.SubjectSubscriber = $7eb72d3cb8bb1662$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $7eb72d3cb8bb1662$var$Subject = function(_super) {
    $7eb72d3cb8bb1662$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$4THwh.rxSubscriber] = function() {
        return new $7eb72d3cb8bb1662$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $7eb72d3cb8bb1662$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $8IeZR.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $8IeZR.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $bVy6d.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $jFk35.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $7eb72d3cb8bb1662$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($jFk35.Observable);
module.exports.Subject = $7eb72d3cb8bb1662$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $7eb72d3cb8bb1662$var$AnonymousSubject = function(_super) {
    $7eb72d3cb8bb1662$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $8IeZR.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($7eb72d3cb8bb1662$var$Subject);
module.exports.AnonymousSubject = $7eb72d3cb8bb1662$var$AnonymousSubject;

});
parcelRegister("imzSm", function(module, exports) {
"use strict";
var $d5e61c3d296d1391$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $d5e61c3d296d1391$var$ObjectUnsubscribedError = function(_super) {
    $d5e61c3d296d1391$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $d5e61c3d296d1391$var$ObjectUnsubscribedError;

});

parcelRegister("bVy6d", function(module, exports) {
"use strict";
var $8aef77f7ead3931b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8IeZR = parcelRequire("8IeZR");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8aef77f7ead3931b$var$SubjectSubscription = function(_super) {
    $8aef77f7ead3931b$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($8IeZR.Subscription);
module.exports.SubjectSubscription = $8aef77f7ead3931b$var$SubjectSubscription;

});


parcelRegister("fh4Yk", function(module, exports) {
$parcel$export(module.exports, "queue", () => $b1ec4ce727fa7c3e$export$4f7fa46ff53e516f, (v) => $b1ec4ce727fa7c3e$export$4f7fa46ff53e516f = v);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $b1ec4ce727fa7c3e$export$4f7fa46ff53e516f;
"use strict";

var $9hgY9 = parcelRequire("9hgY9");

var $HyoDO = parcelRequire("HyoDO");
$b1ec4ce727fa7c3e$export$4f7fa46ff53e516f = new $HyoDO.QueueScheduler($9hgY9.QueueAction);

});
parcelRegister("9hgY9", function(module, exports) {
"use strict";
var $6c12dd4d59fa07f2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kpCGY = parcelRequire("kpCGY");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6c12dd4d59fa07f2$var$QueueAction = function(_super) {
    $6c12dd4d59fa07f2$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($kpCGY.AsyncAction);
module.exports.QueueAction = $6c12dd4d59fa07f2$var$QueueAction;

});
parcelRegister("kpCGY", function(module, exports) {
"use strict";
var $edc427ea8e1fb33a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4xUKK = parcelRequire("4xUKK");

var $hAp7r = parcelRequire("hAp7r");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $edc427ea8e1fb33a$var$AsyncAction = function(_super) {
    $edc427ea8e1fb33a$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $4xUKK.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $4xUKK.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($hAp7r.Action);
module.exports.AsyncAction = $edc427ea8e1fb33a$var$AsyncAction;

});
parcelRegister("hAp7r", function(module, exports) {
"use strict";
var $ccd94892a2020f89$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8IeZR = parcelRequire("8IeZR");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $ccd94892a2020f89$var$Action = function(_super) {
    $ccd94892a2020f89$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($8IeZR.Subscription);
module.exports.Action = $ccd94892a2020f89$var$Action;

});



parcelRegister("HyoDO", function(module, exports) {
"use strict";
var $082eb2aeed48a190$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5wLDa = parcelRequire("5wLDa");
var $082eb2aeed48a190$var$QueueScheduler = function(_super) {
    $082eb2aeed48a190$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($5wLDa.AsyncScheduler);
module.exports.QueueScheduler = $082eb2aeed48a190$var$QueueScheduler;

});
parcelRegister("5wLDa", function(module, exports) {
"use strict";
var $4064e35c9f4b943b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ipnNp = parcelRequire("ipnNp");
var $4064e35c9f4b943b$var$AsyncScheduler = function(_super) {
    $4064e35c9f4b943b$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($ipnNp.Scheduler);
module.exports.AsyncScheduler = $4064e35c9f4b943b$var$AsyncScheduler;

});
parcelRegister("ipnNp", function(module, exports) {
$parcel$export(module.exports, "Scheduler", () => $d66d0528da1b7555$export$d3e54bb8584cda7c, (v) => $d66d0528da1b7555$export$d3e54bb8584cda7c = v);
var $d66d0528da1b7555$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $d66d0528da1b7555$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$d66d0528da1b7555$export$d3e54bb8584cda7c = $d66d0528da1b7555$var$Scheduler;

});






parcelRegister("hJfx9", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $0ce733be91daa81d$export$728192ce8dd94659);
const $0ce733be91daa81d$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $0ce733be91daa81d$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $0ce733be91daa81d$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("asz90", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $d709c0372523b39a$export$71797c284d89a3e1);

var $bSdo9 = parcelRequire("bSdo9");

var $bf2Vh = parcelRequire("bf2Vh");
const $d709c0372523b39a$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $bSdo9.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $bf2Vh.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("bSdo9", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $38827b36404cf0e5$export$a1c3205f28a20414);
const $38827b36404cf0e5$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("bf2Vh", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $e0578cafa3bab95d$export$62aabd5ff85d0451);
const $e0578cafa3bab95d$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("iLLjQ", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $2156fed993b39ca5$export$ac3214931ffd82af);

var $heTdg = parcelRequire("heTdg");
const $2156fed993b39ca5$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $heTdg.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});

parcelRegister("fb1Ys", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $617fd5bc6e751e12$export$4b2432e2d8723823);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
function $617fd5bc6e751e12$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}

});

parcelRegister("7lxp5", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $36f56ee3799424c2$export$4dbaaf6c79705e6c);

var $8IeZR = parcelRequire("8IeZR");
const $36f56ee3799424c2$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $8IeZR.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("hsOpp", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $4a92a95ae4a66c70$export$89097c0ec1e0dee1);

var $4vCw2 = parcelRequire("4vCw2");
const $4a92a95ae4a66c70$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $4vCw2.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("7JZuO", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $5b94e629afbfbdd4$export$4c54d536f8e37dc2);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $iJYLx = parcelRequire("iJYLx");

const $5b94e629afbfbdd4$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $5b94e629afbfbdd4$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$5b94e629afbfbdd4$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $iJYLx.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $iJYLx.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("iJYLx", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $d68f34656f62d2a3$export$c3748c310e92340a);

var $yw0N8 = parcelRequire("yw0N8");
class $d68f34656f62d2a3$export$c3748c310e92340a extends (0, $yw0N8.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}

});


parcelRegister("8bOBg", function(module, exports) {
$parcel$export(module.exports, "defaultShouldRetryError", () => $92b3b5f255eee333$export$fee2242cbb339663);

var $dW6eo = parcelRequire("dW6eo");

var $aRuop = parcelRequire("aRuop");
const $92b3b5f255eee333$export$fee2242cbb339663 = (err)=>{
    const statusCode = (0, $dW6eo.getStatusCode)(err);
    return (0, $aRuop.isFetchNetworkError)(err) || (statusCode ? statusCode >= 500 : false);
};

});
parcelRegister("dW6eo", function(module, exports) {
$parcel$export(module.exports, "getStatusCode", () => $99169dd4c551e0d4$export$68868794c9b58e55);

var $bPjfs = parcelRequire("bPjfs");
const $99169dd4c551e0d4$export$68868794c9b58e55 = (error)=>{
    var _error$metadata;
    return (0, $bPjfs.isRequestError)(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.statusCode) && error.metadata.statusCode;
};

});
parcelRegister("bPjfs", function(module, exports) {
$parcel$export(module.exports, "isRequestError", () => $d97bef005a413ec0$export$3717b1ffef4428ea);

var $95p9z = parcelRequire("95p9z");
function $d97bef005a413ec0$export$3717b1ffef4428ea(err) {
    return err instanceof (0, $95p9z.RequestError);
}

});
parcelRegister("95p9z", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $be5db7e92762c6be$export$43ee7d0e4f429743);

var $yw0N8 = parcelRequire("yw0N8");
class $be5db7e92762c6be$export$43ee7d0e4f429743 extends (0, $yw0N8.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}

});



parcelRegister("aRuop", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $fdce1c93dfa2f453$export$ad8c5cf7dd4c3caf);
// fetch throws TypeError for network errors
function $fdce1c93dfa2f453$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}

});


parcelRegister("68VzF", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $532609c39ea49bb2$export$2ccdd6f9a9eba6a);

var $d3B1s = parcelRequire("d3B1s");

var $hcvNb = parcelRequire("hcvNb");

var $bf2Vh = parcelRequire("bf2Vh");
async function $532609c39ea49bb2$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $d3B1s.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $hcvNb.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $bf2Vh.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("fRnN7", function(module, exports) {
$parcel$export(module.exports, "MEDIA_API_REGION", () => $6a8b50b04f4e0dd9$export$ae7fb0ee64408016);
$parcel$export(module.exports, "MEDIA_API_ENVIRONMENT", () => $6a8b50b04f4e0dd9$export$2e3b0a8a2a2bf81c);
$parcel$export(module.exports, "MediaStore", () => $6a8b50b04f4e0dd9$export$572b8a2a9fd7cbba);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lh6Yd = parcelRequire("lh6Yd");

var $iw7Zd = parcelRequire("iw7Zd");

var $dRkX9 = parcelRequire("dRkX9");

var $eNvXo = parcelRequire("eNvXo");

var $638DX = parcelRequire("638DX");

var $2hBiT = parcelRequire("2hBiT");

var $6vzn1 = parcelRequire("6vzn1");

var $88Gik = parcelRequire("88Gik");

var $22wIf = parcelRequire("22wIf");

var $fBjGN = parcelRequire("fBjGN");

var $bPjfs = parcelRequire("bPjfs");
var $6w2IC = parcelRequire("6w2IC");

var $b9zjd = parcelRequire("b9zjd");

var $evKh4 = parcelRequire("evKh4");

var $1WV7X = parcelRequire("1WV7X");

var $8bOBg = parcelRequire("8bOBg");

var $aOmId = parcelRequire("aOmId");

var $lIeYq = parcelRequire("lIeYq");

var $dAVkr = parcelRequire("dAVkr");

var $8ZVdW = parcelRequire("8ZVdW");

var $51yHl = parcelRequire("51yHl");

var $3IFup = parcelRequire("3IFup");

var $53V7C = parcelRequire("53V7C");

var $hWXUp = parcelRequire("hWXUp");

var $aAKVm = parcelRequire("aAKVm");



const $6a8b50b04f4e0dd9$export$ae7fb0ee64408016 = 'media-api-region';
const $6a8b50b04f4e0dd9$export$2e3b0a8a2a2bf81c = 'media-api-environment';
class $6a8b50b04f4e0dd9$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $eNvXo.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $aOmId.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $6w2IC.request)(artifactUrl, options, abortController).then((0, $b9zjd.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $evKh4.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $53V7C.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hWXUp.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $lh6Yd.ChunkHashAlgorithm).Sha256;
    }
    async getClientId(collectionName) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return $6a8b50b04f4e0dd9$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
    }
    getClientIdSync() {
        try {
            const auth = this.resolveInitialAuth();
            return $6a8b50b04f4e0dd9$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
        } catch  {
            // initialAuth may not be available, return undefined
            return undefined;
        }
    }
    static extractClientIdFromAuth(auth) {
        if ((0, $iw7Zd.isClientBasedAuth)(auth)) return auth.clientId;
        // decode JWT token and get clientId (or iss) from payload
        try {
            const jwtPayload = (0, $8ZVdW.decodeJwtToken)(auth.token);
            return jwtPayload.clientId;
        } catch  {
        // leave clientId as undefined
        }
        return undefined;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const headers = {
            ...(0, $3IFup.jsonHeaders)
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $dRkX9.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', requestOptions).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const headers = {
            ...(0, $3IFup.jsonHeaders)
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $dRkX9.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', requestOptions).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params, seededCdnUrl) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params, seededCdnUrl);
    }
    createFileImageURL(id, auth, params, seededCdnUrl) {
        const wmv = (0, $dRkX9.fg)('confluence_watermark_admin_ui') ? (0, $lIeYq.getWatermarkVersionFromToken)(auth.token) : undefined;
        const options = {
            params: {
                ...(0, $51yHl.extendImageParams)(params),
                ...wmv ? {
                    wmv: wmv
                } : {}
            },
            auth: auth
        };
        const imageEndpoint = (0, $dAVkr.cdnFeatureFlag)('image');
        if (seededCdnUrl && (0, $2hBiT.isCDNEnabled)()) return (0, $fBjGN.mapToSeedBasedCdnUrl)(seededCdnUrl, options.params);
        if ((0, $6vzn1.isPathBasedEnabled)()) return (0, $22wIf.mapToPathBasedUrl)((0, $1WV7X.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $88Gik.mapToMediaCdnUrl)((0, $1WV7X.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $eNvXo.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = (0, $dAVkr.cdnFeatureFlag)('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $b9zjd.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $eNvXo.FILE_CACHE_MAX_AGE), name) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge,
                ...name ? {
                    name: name
                } : {}
            },
            auth: auth
        };
        const binaryEndpoint = (0, $dAVkr.cdnFeatureFlag)('binary');
        if ((0, $6vzn1.isPathBasedEnabled)()) return (0, $22wIf.mapToPathBasedUrl)((0, $1WV7X.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $88Gik.mapToMediaCdnUrl)((0, $1WV7X.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $eNvXo.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
    	const cdnUrl = artifacts[artifactName]?.cdnUrl;
    	if (cdnUrl) {
    		return cdnUrl;
    	}
    } */ const artifactUrl = (0, $638DX.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $88Gik.mapToMediaCdnUrl)((0, $1WV7X.createUrl)(`${auth.baseUrl}${artifactUrl}`, options), auth.token);
        if ((0, $6vzn1.isPathBasedEnabled)()) return (0, $22wIf.mapToPathBasedUrl)(url);
        return url;
    }
    /**
   * The watermark version `getImage` sends as `wmv` for `collectionName`, or
   * `undefined` when it sends none. A caller that reuses an image fetched earlier can
   * compare it to tell whether the watermark config has changed since.
   */ async getImageWatermarkVersion(collectionName) {
        if (!(0, $dRkX9.fg)('confluence_watermark_admin_ui')) return undefined;
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return (0, $lIeYq.getWatermarkVersionFromToken)(auth.token);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext, clientOptions) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = (0, $dAVkr.cdnFeatureFlag)('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        let wmvParams = {};
        let authOptions = {
            authContext: {
                collectionName: params && params.collection
            }
        };
        if ((0, $dRkX9.fg)('confluence_watermark_admin_ui')) {
            const auth = await this.resolveAuth(authOptions.authContext);
            const wmv = (0, $lIeYq.getWatermarkVersionFromToken)(auth.token);
            if (wmv) wmvParams = {
                wmv: wmv
            };
            authOptions = {
                resolvedAuth: auth
            };
        }
        const options = {
            ...metadata,
            ...authOptions,
            params: {
                ...(0, $51yHl.extendImageParams)(params, fetchMaxRes),
                ...wmvParams
            },
            headers: headers,
            traceContext: traceContext,
            clientOptions: clientOptions,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $b9zjd.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: (0, $3IFup.jsonHeaders),
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? (0, $dAVkr.cdnFeatureFlag)('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $eNvXo.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? (0, $dAVkr.cdnFeatureFlag)('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $eNvXo.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $b9zjd.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext, options) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const headers = {
            ...(0, $3IFup.jsonHeaders)
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $dRkX9.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, requestOptions);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: // Contains collection name to write to
            params,
            // Contains collection name to write to
            headers: (0, $3IFup.jsonHeaders),
            body: JSON.stringify(body),
            traceContext: // Contains collection name to read from
            traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext, clientId) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: (0, $3IFup.jsonHeaders),
            body: JSON.stringify({
                id: id,
                clientId: clientId
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>{
                        var _err$metadata;
                        return (0, $8bOBg.defaultShouldRetryError)(err) || (0, $bPjfs.isRequestError)(err) && (err === null || err === void 0 || (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode) === 401;
                    }
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $evKh4.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: (0, $3IFup.jsonHeaders),
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $iw7Zd.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $aOmId.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $88Gik.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $6vzn1.isPathBasedEnabled)()) url = (0, $22wIf.mapToPathBasedUrl)(url);
        const response = await (0, $6w2IC.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        (0, $aAKVm.setKeyValueInSessionStorage)($6a8b50b04f4e0dd9$export$ae7fb0ee64408016, response.headers.get('x-media-region'));
        (0, $aAKVm.setKeyValueInSessionStorage)($6a8b50b04f4e0dd9$export$2e3b0a8a2a2bf81c, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $6w2IC.request)(url, {
            method: 'HEAD',
            traceContext: (0, $aOmId.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}

});
parcelRegister("iw7Zd", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $db383de04868c3d5$export$6ba49fcac9c46e54);
function $db383de04868c3d5$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}

});

parcelRegister("638DX", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $4a248293b46cd11d$export$1cc24defa44e7f84);

var $2hBiT = parcelRequire("2hBiT");
const $4a248293b46cd11d$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    var _artifacts$prop, _artifacts$prop3;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $2hBiT.isCDNEnabled)() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
        var _artifacts$prop2;
        return `${(_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url}/cdn`;
    }
    return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};

});
parcelRegister("2hBiT", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $0672aaaa5bd99d99$export$3e47d0e609e44278);

var $eIE36 = parcelRequire("eIE36");

var $j4SCE = parcelRequire("j4SCE");

var $6hpxM = parcelRequire("6hpxM");

var $dRkX9 = parcelRequire("dRkX9");

var $aChzC = parcelRequire("aChzC");

var $6vzn1 = parcelRequire("6vzn1");
function $0672aaaa5bd99d99$export$3e47d0e609e44278() {
    return (0, $aChzC.isCommercial)() && !(0, $j4SCE.isIsolatedCloud)() && !((0, $eIE36.isGoogleCloudPlatform)() || (0, $6hpxM.isGCPtenant)()) && (0, $dRkX9.fg)('platform_media_cdn_delivery') && !(0, $6vzn1.isPathBasedEnabled)();
}

});
parcelRegister("6hpxM", function(module, exports) {
$parcel$export(module.exports, "isGCPtenant", () => $a867c327320503b2$export$1e98abd71682b665);
/**
 * Returns true if the current hostname matches the GCP tenant pattern.
 * GCP tenants follow the pattern: <name>-cdp-<cdp-id>.jira-dev.com
 *
 * CDN (CloudFront) is an AWS service and is not available on GCP tenants.
 * This function is used to gate CDN delivery, mirroring the isIsolatedCloud() pattern.
 *
 * @deprecated This is a staging-only hostname heuristic and should not be used for
 * new code. Prefer `isGoogleCloudPlatform()` from `@atlaskit/atlassian-context/cloud-provider`
 * (cookie/SSR-based) to detect GCP tenants. This helper is retained only as a fallback for
 * staging tenants, which do not reliably have a proper value for the
 * `Bifrost-Atl-Ctx-Cloud-Service-Provider` cookie.
 *
 * @param hostname - Optional hostname override (defaults to globalThis.location?.hostname). Used for testing.
 */ function $a867c327320503b2$export$1e98abd71682b665(hostname) {
    var _location;
    const host = hostname ?? (typeof globalThis !== 'undefined' ? (_location = globalThis.location) === null || _location === void 0 ? void 0 : _location.hostname : undefined);
    if (!host) return false;
    const gcpTenantPattern = /^.*-cdp-\w+\.jira-dev\.com$/;
    return gcpTenantPattern.test(host);
}

});

parcelRegister("aChzC", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $2ab6181a3c834ca7$export$df69ff6733e73e50);
function $2ab6181a3c834ca7$export$df69ff6733e73e50() {
    var _global$location;
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !((_global$location = global.location) !== null && _global$location !== void 0 && (_global$location = _global$location.hostname) !== null && _global$location !== void 0 && _global$location.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/));
}

});

parcelRegister("6vzn1", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $bb95a3ba2ee1cfc7$export$6de3392754e98e65);

var $dRkX9 = parcelRequire("dRkX9");

var $bGFYS = parcelRequire("bGFYS");
function $bb95a3ba2ee1cfc7$export$6de3392754e98e65() {
    var _getDocument;
    const isLocalhost = ((_getDocument = (0, $bGFYS.default)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
    return (0, $dRkX9.fg)('platform_media_path_based_route') && !isLocalhost;
}

});
parcelRegister("bGFYS", function(module, exports) {
$parcel$export(module.exports, "default", () => $41cceab64c2147b4$export$2e2bcd8739ae039);
var $41cceab64c2147b4$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("88Gik", function(module, exports) {
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $de3df541a2297611$export$fb88a576cf28364d);

var $eIE36 = parcelRequire("eIE36");

var $6hpxM = parcelRequire("6hpxM");

var $dRkX9 = parcelRequire("dRkX9");

var $2hBiT = parcelRequire("2hBiT");

var $4gQkS = parcelRequire("4gQkS");
function $de3df541a2297611$export$fb88a576cf28364d(url, token) {
    const tokenLength = (token === null || token === void 0 ? void 0 : token.length) ?? 0;
    if (!(0, $2hBiT.isCDNEnabled)() || tokenLength > (0, $4gQkS.MEDIA_TOKEN_LENGTH_LIMIT)) return url;
    const isGcpTenant = (0, $eIE36.isGoogleCloudPlatform)() || (0, $6hpxM.isGCPtenant)();
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!isGcpTenant && (0, $dRkX9.fg)('platform_media_cdn_delivery') && (0, $dRkX9.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = (0, $4gQkS.MEDIA_CDN_MAP)[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("4gQkS", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CDN_MAP", () => $1090b62613794a16$export$8a9b6ab3569a543a);
$parcel$export(module.exports, "MEDIA_TOKEN_LENGTH_LIMIT", () => $1090b62613794a16$export$9c6324050210f959);

var $2hBiT = parcelRequire("2hBiT");
const $1090b62613794a16$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
const $1090b62613794a16$export$9c6324050210f959 = 7000;

});


parcelRegister("22wIf", function(module, exports) {
$parcel$export(module.exports, "mapToPathBasedUrl", () => $f102ff3d7c522764$export$774e2add1fbe26aa);

var $bGFYS = parcelRequire("bGFYS");

var $6vzn1 = parcelRequire("6vzn1");

var $dN3Mk = parcelRequire("dN3Mk");
function $f102ff3d7c522764$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $f102ff3d7c522764$export$774e2add1fbe26aa(url) {
    if ((0, $6vzn1.isPathBasedEnabled)()) {
        var _getDocument;
        const parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith((0, $dN3Mk.mediaApiPathPrefix))) parsedUrl.pathname = `${0, $dN3Mk.mediaApiPathPrefix}${parsedUrl.pathname}`;
        const location = (_getDocument = (0, $bGFYS.default)()) === null || _getDocument === void 0 ? void 0 : _getDocument.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $f102ff3d7c522764$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}

});
parcelRegister("dN3Mk", function(module, exports) {
$parcel$export(module.exports, "mediaApiPathPrefix", () => $369b9607855ea88d$export$401b0a9ee44eb977);
const $369b9607855ea88d$export$401b0a9ee44eb977 = '/media-api';

});


parcelRegister("fBjGN", function(module, exports) {
$parcel$export(module.exports, "mapToSeedBasedCdnUrl", () => $6c19f4309612bd4f$export$6a61eda13a74de3b);
const $6c19f4309612bd4f$var$IMAGE_PARAM_KEYS = new Set([
    'width',
    'height',
    'mode',
    'allowAnimated',
    'upscale',
    'version',
    'max-age'
]);
const $6c19f4309612bd4f$export$6a61eda13a74de3b = (seededCdnUrl, params)=>{
    const insert = Object.entries(params ?? {}).filter(([key, value])=>value != null && $6c19f4309612bd4f$var$IMAGE_PARAM_KEYS.has(key)).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`).join('&');
    if (!insert) return seededCdnUrl;
    const wm = seededCdnUrl.search(/[?&]wm-ari=/);
    if (wm !== -1) {
        const separator = seededCdnUrl[wm];
        return `${seededCdnUrl.slice(0, wm)}${separator}${insert}&${seededCdnUrl.slice(wm + 1)}`;
    }
    return `${seededCdnUrl}${seededCdnUrl.includes('?') ? '&' : '?'}${insert}`;
};

});

parcelRegister("6w2IC", function(module, exports) {
$parcel$export(module.exports, "request", () => $f3b7e31d65c861df$export$b5fe3f66a567bec0);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $95p9z = parcelRequire("95p9z");

var $bPjfs = parcelRequire("bPjfs");



var $dRkX9 = parcelRequire("dRkX9");

var $3EF8v = parcelRequire("3EF8v");

var $3SzGz = parcelRequire("3SzGz");

var $bXy4s = parcelRequire("bXy4s");

var $1WV7X = parcelRequire("1WV7X");

var $8bOBg = parcelRequire("8bOBg");

var $27K5E = parcelRequire("27K5E");

var $cLj0V = parcelRequire("cLj0V");

var $aRuop = parcelRequire("aRuop");
async function $f3b7e31d65c861df$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $1WV7X.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $27K5E.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $bXy4s.createProcessFetchResponse)(metadata));
    if ((0, $dRkX9.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            var _getNavigator;
            if ((0, $aRuop.isFetchNetworkError)(err) && (_getNavigator = (0, $3EF8v.default)()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) return false;
            return (0, $8bOBg.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $cLj0V.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            var _getNavigator2;
            if ((0, $aRuop.isFetchNetworkError)(error) && (_getNavigator2 = (0, $3EF8v.default)()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $1WV7X.createUrl)((0, $3SzGz.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $27K5E.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $bXy4s.createProcessFetchResponse)(metadata));
                return (0, $cLj0V.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $cLj0V.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("3EF8v", function(module, exports) {
$parcel$export(module.exports, "default", () => $719d841c2f951ee7$export$2e2bcd8739ae039);
var $719d841c2f951ee7$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});

parcelRegister("3SzGz", function(module, exports) {
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $79226154a15a4eee$export$e71b0af0000b3cfa);

var $bGFYS = parcelRequire("bGFYS");

var $dN3Mk = parcelRequire("dN3Mk");
function $79226154a15a4eee$export$e71b0af0000b3cfa(url) {
    var _getDocument;
    const parsedUrl = new URL(url);
    parsedUrl.host = ((_getDocument = (0, $bGFYS.default)()) === null || _getDocument === void 0 ? void 0 : _getDocument.location.host) ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith((0, $dN3Mk.mediaApiPathPrefix))) parsedUrl.pathname = `${0, $dN3Mk.mediaApiPathPrefix}${parsedUrl.pathname}`;
    return parsedUrl;
}

});

parcelRegister("bXy4s", function(module, exports) {
$parcel$export(module.exports, "createProcessFetchResponse", () => $7c64f01b6c2eef53$export$6e2e477edb7d6032);

var $jPI9L = parcelRequire("jPI9L");
function $7c64f01b6c2eef53$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = (0, $jPI9L.createRequestErrorFromResponse)(metadata, response);
        throw requestError;
    };
}

});
parcelRegister("jPI9L", function(module, exports) {
$parcel$export(module.exports, "createRequestErrorFromResponse", () => $4ae38cd17d939c77$export$d171f49f6b4ddc33);

var $2HyKO = parcelRequire("2HyKO");

var $lC9Tq = parcelRequire("lC9Tq");

var $95p9z = parcelRequire("95p9z");
function $4ae38cd17d939c77$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = (0, $2HyKO.createRequestErrorReason)(statusCode);
    return new (0, $95p9z.RequestError)(reason, {
        ...metadata,
        ...(0, $lC9Tq.extractMediaHeaders)(response),
        statusCode: statusCode
    });
}

});
parcelRegister("2HyKO", function(module, exports) {
$parcel$export(module.exports, "createRequestErrorReason", () => $5defe51f0fe46eab$export$6397609af718d008);
function $5defe51f0fe46eab$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}

});

parcelRegister("lC9Tq", function(module, exports) {
$parcel$export(module.exports, "extractMediaHeaders", () => $039a378a36b8449a$export$ea175c0c5497224);
function $039a378a36b8449a$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});



parcelRegister("1WV7X", function(module, exports) {
$parcel$export(module.exports, "createUrl", () => $7fb82451e7710040$export$7138c24907de3954);

var $2RHnv = parcelRequire("2RHnv");
function $7fb82451e7710040$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth === null || auth === void 0 ? void 0 : auth.baseUrl);
    const authParams = auth && (0, $2RHnv.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}

});
parcelRegister("2RHnv", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $d7bbf68f41db4634$export$6833b130611df767);

var $iw7Zd = parcelRequire("iw7Zd");
function $d7bbf68f41db4634$export$6833b130611df767(auth) {
    if ((0, $iw7Zd.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("27K5E", function(module, exports) {
$parcel$export(module.exports, "extendHeaders", () => $68f5250396a21478$export$18cfbabc415d771c);

var $gfPM4 = parcelRequire("gfPM4");

var $l1yj7 = parcelRequire("l1yj7");
const $68f5250396a21478$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [(0, $gfPM4.ZipkinHeaderKeys).traceId]: traceContext.traceId,
        [(0, $gfPM4.ZipkinHeaderKeys).spanId]: traceContext.spanId
    } : {};
};
function $68f5250396a21478$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...(0, $l1yj7.mapAuthToRequestHeaders)(auth),
        ...$68f5250396a21478$var$mapTraceIdToRequestHeaders(traceContext)
    };
}

});
parcelRegister("gfPM4", function(module, exports) {
$parcel$export(module.exports, "ZipkinHeaderKeys", () => $3ad7534f1e2c2054$export$922566b90d0535ce);
$parcel$export(module.exports, "DEFAULT_RETRY_OPTIONS", () => $3ad7534f1e2c2054$export$c65cfa70960d8fe5);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

















const $3ad7534f1e2c2054$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $3ad7534f1e2c2054$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};

});

parcelRegister("l1yj7", function(module, exports) {
$parcel$export(module.exports, "mapAuthToRequestHeaders", () => $1c0f54deef0a1d0e$export$eaf4479116d2f925);

var $iw7Zd = parcelRequire("iw7Zd");
function $1c0f54deef0a1d0e$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $iw7Zd.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}

});


parcelRegister("cLj0V", function(module, exports) {
$parcel$export(module.exports, "fetchRetry", () => $4d526dedc9138b37$export$782df2acbe10b22c);

var $dC5NA = parcelRequire("dC5NA");

var $8bOBg = parcelRequire("8bOBg");

var $gfPM4 = parcelRequire("gfPM4");

var $e7CBe = parcelRequire("e7CBe");

var $bPjfs = parcelRequire("bPjfs");

var $95p9z = parcelRequire("95p9z");

var $9AqsT = parcelRequire("9AqsT");
async function $4d526dedc9138b37$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...(0, $gfPM4.DEFAULT_RETRY_OPTIONS),
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = (0, $8bOBg.defaultShouldRetryError) } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await (0, $9AqsT.waitPromise)(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ((0, $e7CBe.isAbortedRequestError)(err)) throw new (0, $95p9z.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $bPjfs.isRequestError)(lastError)) throw (0, $dC5NA.cloneRequestError)(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $95p9z.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}

});
parcelRegister("dC5NA", function(module, exports) {
$parcel$export(module.exports, "cloneRequestError", () => $effb916ab8889165$export$359f19ca51f9eba1);

var $95p9z = parcelRequire("95p9z");
function $effb916ab8889165$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $95p9z.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}

});

parcelRegister("e7CBe", function(module, exports) {
$parcel$export(module.exports, "isAbortedRequestError", () => $fdfbb5e5aecb5b5a$export$de0b576cf7ce4a53);
function $fdfbb5e5aecb5b5a$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}

});

parcelRegister("9AqsT", function(module, exports) {
$parcel$export(module.exports, "waitPromise", () => $04ce1d2ddeab9501$export$80c51ea1e89203dd);
function $04ce1d2ddeab9501$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}

});



parcelRegister("b9zjd", function(module, exports) {
$parcel$export(module.exports, "createMapResponseToBlob", () => $5013a15fd097b9cc$export$5cc7b0795397da86);

var $lC9Tq = parcelRequire("lC9Tq");

var $95p9z = parcelRequire("95p9z");
function $5013a15fd097b9cc$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $95p9z.RequestError)('serverInvalidBody', {
                ...metadata,
                ...(0, $lC9Tq.extractMediaHeaders)(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}

});

parcelRegister("evKh4", function(module, exports) {
$parcel$export(module.exports, "createMapResponseToJson", () => $fe1880b7c8369a1b$export$e0519b126b73efa6);

var $lC9Tq = parcelRequire("lC9Tq");

var $95p9z = parcelRequire("95p9z");
function $fe1880b7c8369a1b$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $95p9z.RequestError)('serverInvalidBody', {
                ...metadata,
                ...(0, $lC9Tq.extractMediaHeaders)(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}

});

parcelRegister("aOmId", function(module, exports) {
$parcel$export(module.exports, "extendTraceContext", () => $9a5396cf541971e9$export$ee24a95986dfd173);

var $1uElz = parcelRequire("1uElz");
const $9a5396cf541971e9$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $1uElz.getRandomTelemetryId)()
    } : undefined;

});

parcelRegister("lIeYq", function(module, exports) {
$parcel$export(module.exports, "getWatermarkVersionFromToken", () => $0d4f213690733582$export$5296269cf74e58e);
function $0d4f213690733582$export$5296269cf74e58e(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return undefined;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        const watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch  {
        return undefined;
    }
}

});

parcelRegister("dAVkr", function(module, exports) {
$parcel$export(module.exports, "cdnFeatureFlag", () => $dd04a2f5414b4fa8$export$fca9c48f5ff2eb1a);

var $2hBiT = parcelRequire("2hBiT");
const $dd04a2f5414b4fa8$export$fca9c48f5ff2eb1a = (endpoint)=>{
    let result = endpoint;
    if ((0, $2hBiT.isCDNEnabled)()) result += '/cdn';
    return result;
};

});

parcelRegister("8ZVdW", function(module, exports) {
$parcel$export(module.exports, "decodeJwtToken", () => $290ee7f583f2c426$export$a8b71bcb3b2f6325);
const $290ee7f583f2c426$export$a8b71bcb3b2f6325 = (token)=>{
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};

});

parcelRegister("51yHl", function(module, exports) {
$parcel$export(module.exports, "extendImageParams", () => $0928b02de59e6632$export$1f6f5681971a5e73);

var $eNvXo = parcelRequire("eNvXo");
const $0928b02de59e6632$export$1f6f5681971a5e73 = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': (params === null || params === void 0 ? void 0 : params['max-age']) ?? (0, $eNvXo.FILE_CACHE_MAX_AGE),
        allowAnimated: (params === null || params === void 0 ? void 0 : params.allowAnimated) ?? true,
        mode: (params === null || params === void 0 ? void 0 : params.mode) ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $eNvXo.MAX_RESOLUTION),
            height: (0, $eNvXo.MAX_RESOLUTION)
        } : {}
    };
};

});

parcelRegister("3IFup", function(module, exports) {
$parcel$export(module.exports, "jsonHeaders", () => $da4c96b692080115$export$dd23d116120d45cc);
const $da4c96b692080115$export$dd23d116120d45cc = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};

});

parcelRegister("53V7C", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $ad820811344f880c$export$4b4cec3dcdfce972);

var $dRkX9 = parcelRequire("dRkX9");

var $k0t1W = parcelRequire("k0t1W");

var $5I7JW = parcelRequire("5I7JW");

var $fK2pR = parcelRequire("fK2pR");
const $ad820811344f880c$export$560085fe411c0660 = 10000;
const $ad820811344f880c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $ad820811344f880c$export$560085fe411c0660)=>{
    const startTime = performance.now();
    let eventEmitted = false;
    // Feature flag: wrap authProvider with analytics event emission
    const authProviderPromise = (0, $dRkX9.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then((result)=>{
        const durationMs = performance.now() - startTime;
        if (!eventEmitted) {
            eventEmitted = true;
            (0, $k0t1W.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext
            });
        } else {
            // Timeout already fired - auth arrived too late
            const timeoutError = new (0, $fK2pR.MediaStoreError)('authProviderTimedOut');
            (0, $k0t1W.globalMediaEventEmitter).emit('auth-provider-failed', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext,
                error: timeoutError
            });
        }
        return result;
    }).catch((error)=>{
        const durationMs = performance.now() - startTime;
        eventEmitted = true;
        (0, $k0t1W.globalMediaEventEmitter).emit('auth-provider-failed', {
            durationMs: durationMs,
            timeoutMs: authProviderTimeout,
            authContext: authContext,
            error: error
        });
        throw error;
    }) : authProvider(authContext); // Original behavior when FG off
    let auth;
    try {
        auth = await Promise.race([
            authProviderPromise,
            (0, $5I7JW.rejectTimeout)(authProviderTimeout, new (0, $fK2pR.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
        if (!eventEmitted && (0, $dRkX9.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
        // PRESERVE ORIGINAL ERROR HANDLING
        if (err instanceof (0, $fK2pR.MediaStoreError)) throw err;
        throw new (0, $fK2pR.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $fK2pR.MediaStoreError)('emptyAuth');
    /*
  Only client-based auth carries a clientId. Fail fast when it is present but empty, instead of
  letting the request reach dt-auth and get rejected with `Client id "" is invalid`.
   */ if ('clientId' in auth && !auth.clientId && (0, $dRkX9.fg)('platform_media_validate_client_id')) throw new (0, $fK2pR.MediaStoreError)('emptyClientId');
    /*
     We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
     Token expiration check in the frontend is a bad idea. Don't do it!
     More info:
     https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
     https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
   */ return auth;
};

});
parcelRegister("5I7JW", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $54fc6c6837243032$export$cf2d2a1124beacb2);
const $54fc6c6837243032$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});

parcelRegister("fK2pR", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $cff6b4fb63479b04$export$b78480bd311630bc);

var $yw0N8 = parcelRequire("yw0N8");
class $cff6b4fb63479b04$export$b78480bd311630bc extends (0, $yw0N8.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}

});


parcelRegister("hWXUp", function(module, exports) {
$parcel$export(module.exports, "resolveInitialAuth", () => $339c6e204d7ff4af$export$5211e1371264aec3);

var $fK2pR = parcelRequire("fK2pR");
const $339c6e204d7ff4af$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $fK2pR.MediaStoreError)('missingInitialAuth');
    return auth;
};

});

parcelRegister("aAKVm", function(module, exports) {
$parcel$export(module.exports, "setKeyValueInSessionStorage", () => $3dca90b79c3d327c$export$be4c63de2c8c945);
const $3dca90b79c3d327c$export$be4c63de2c8c945 = (key, value)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (!value || !(window && window.sessionStorage)) return;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.sessionStorage.setItem(key, value);
};

});


parcelRegister("8EYCQ", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $7ac8440fbfed5645$export$e3e60f0dab8641de);

var $yw0N8 = parcelRequire("yw0N8");
class $7ac8440fbfed5645$export$e3e60f0dab8641de extends (0, $yw0N8.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}

});


parcelRegister("b9LoH", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $273cacdaa58438ba$export$c66ca190f89caaac);
class $273cacdaa58438ba$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("bObIr", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4RPYE").then(()=>parcelRequire('TaEeF'));

});



parcelRegister("4cz1R", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $4f7caaeea7ec00e6$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $4f7caaeea7ec00e6$export$5bff351c86f56d97);

var $fc4bM = parcelRequire("fc4bM");

var $bLScU = parcelRequire("bLScU");
const $4f7caaeea7ec00e6$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(undefined);
const $4f7caaeea7ec00e6$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $fc4bM.useMemo)(()=>(0, $bLScU.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($4f7caaeea7ec00e6$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};

});


parcelRegister("ied3Y", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $467b3c631ed17f0b$export$4eaebdef02112fe4);

var $fc4bM = parcelRequire("fc4bM");

var $ayBkd = parcelRequire("ayBkd");
var $1N5XT = parcelRequire("1N5XT");

var $kMOab = parcelRequire("kMOab");

var $j5sQP = parcelRequire("j5sQP");

var $eenXr = parcelRequire("eenXr");

var $2hBiT = parcelRequire("2hBiT");

var $d3B1s = parcelRequire("d3B1s");

var $dRkX9 = parcelRequire("dRkX9");

var $51dxT = parcelRequire("51dxT");

var $9hMYe = parcelRequire("9hMYe");

var $htN43 = parcelRequire("htN43");

var $qLp6O = parcelRequire("qLp6O");

var $jWTuE = parcelRequire("jWTuE");

var $cFaxz = parcelRequire("cFaxz");

var $e50HS = parcelRequire("e50HS");

var $4PKLB = parcelRequire("4PKLB");

var $g1VIA = parcelRequire("g1VIA");

var $f4ixZ = parcelRequire("f4ixZ");

var $j810B = parcelRequire("j810B");

var $9oo67 = parcelRequire("9oo67");

var $rQ9A8 = parcelRequire("rQ9A8");

var $jk4Pk = parcelRequire("jk4Pk");

var $dnaS8 = parcelRequire("dnaS8");

var $e91H1 = parcelRequire("e91H1");

var $bDruT = parcelRequire("bDruT");

var $9biMU = parcelRequire("9biMU");

var $dma3p = parcelRequire("dma3p");

var $ikeKC = parcelRequire("ikeKC");

var $SP6cY = parcelRequire("SP6cY");

var $kETOS = parcelRequire("kETOS");
// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $467b3c631ed17f0b$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $467b3c631ed17f0b$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source, initialFileState: initialFileState })=>{
    const mediaClient = (0, $eenXr.useMediaClient)();
    const [status, setStatus] = (0, $fc4bM.useState)('loading');
    const [error, setError] = (0, $fc4bM.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $fc4bM.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $fc4bM.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $fc4bM.useState)('not-resolved');
    const ssrReliabilityRef = (0, $fc4bM.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $51dxT.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(false);
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (isLoading) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $fc4bM.useMemo)(()=>dimensions ? (0, $htN43.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $kETOS.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $cFaxz.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $bDruT.getSSRData)(identifier, resizeMode);
            if (ssrData !== null && ssrData !== void 0 && ssrData.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!(ssrData !== null && ssrData !== void 0 && ssrData.dataURI)) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    // When the relay/SSR-seed path provided a full pre-signed CDN asset
                    // URL, pass it through to getImageUrlSync as the base. That inserts
                    // the client's image-transform params before &wm-ari and preserves
                    // the backend's v2 CDN path, CloudFront signature and watermark
                    // anchors that a rebuilt /file/{id}/image/cdn URL cannot reproduce.
                    const seededCdnUrl = initialFileState && initialFileState.status !== 'error' ? initialFileState.previewCdnUrl : undefined;
                    // Only use the seeded CDN URL when CDN delivery is actually in use.
                    // isCDNEnabled() is false for path-based routing (and for isolated
                    // cloud / GCP), where the signed media-cdn URL is not served — there
                    // getImageUrlSync must build the URL on the product's own /media-api
                    // host instead.
                    const ssrSeededCdnUrl = seededCdnUrl && (0, $2hBiT.isCDNEnabled)() && (0, $dRkX9.fg)('platform_media_ssr_data_seed') ? seededCdnUrl : undefined;
                    return (0, $g1VIA.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs, ssrSeededCdnUrl);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $jWTuE.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $fc4bM.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $j5sQP.useFileState)(identifier.id, {
        initialFileState: initialFileState,
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $ayBkd.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && (fileState === null || fileState === void 0 ? void 0 : fileState.status) !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $fc4bM.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $SP6cY.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $SP6cY.MediaFilePreviewError)('metadata-fetch', (0, $1N5XT.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $fc4bM.useEffect)(()=>{
        var _getSSRData;
        if (!(0, $dRkX9.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (_getSSRData = (0, $bDruT.getSSRData)(identifier, resizeMode)) === null || _getSSRData === void 0 ? void 0 : _getSSRData.loadPromise;
        if (preview && (0, $rQ9A8.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $kETOS.useCurrentValueRef)(()=>{
        return (0, $4PKLB.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $fc4bM.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $dma3p.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $kETOS.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $fc4bM.useEffect)(()=>{
        const cachedPreview = (0, $cFaxz.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $dma3p.isBigger)(cachedPreview === null || cachedPreview === void 0 ? void 0 : cachedPreview.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $dnaS8.isSupportedLocalPreview)(mediaType) && (0, $d3B1s.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $e50HS.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $dma3p.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $jk4Pk.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview && (0, $jk4Pk.isSSRPreview)(preview) && !(0, $ikeKC.isWider)(preview.dimensions, dimensions) && (0, $dRkX9.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $qLp6O.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $fc4bM.useEffect)(()=>{
        (0, $cFaxz.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $cFaxz.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $fc4bM.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $9oo67.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $9hMYe.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $rQ9A8.isSSRDataPreview)(failedPreview) || (0, $9oo67.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $9hMYe.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $9hMYe.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
        const isLocal = (0, $f4ixZ.isLocalPreview)(failedPreview);
        const isRemote = (0, $j810B.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $9biMU.ImageLoadError)(failedPreview === null || failedPreview === void 0 ? void 0 : failedPreview.source);
            (0, $cFaxz.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview === null || preview === void 0 ? void 0 : preview.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $fc4bM.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $9oo67.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $rQ9A8.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if ((newPreview === null || newPreview === void 0 ? void 0 : newPreview.dataURI) !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
    }, [
        preview === null || preview === void 0 ? void 0 : preview.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>{
        var _ssrReliabilityRef$cu;
        return (0, $e91H1.generateScriptProps)(identifier, preview === null || preview === void 0 ? void 0 : preview.dataURI, resizeMode, preview === null || preview === void 0 ? void 0 : preview.srcSet, requestDimensions, ((_ssrReliabilityRef$cu = ssrReliabilityRef.current.server) === null || _ssrReliabilityRef$cu === void 0 ? void 0 : _ssrReliabilityRef$cu.status) === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $dRkX9.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $dRkX9.fg)('media-perf-lazy-loading-optimisation')
        });
    } : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kMOab.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $dRkX9.fg)('media-perf-uplift-mutation-fix') ? $467b3c631ed17f0b$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("ayBkd", function(module, exports) {
$parcel$export(module.exports, "isImageRepresentationReady", () => $d835f4176edea769$export$4e33ccde53b4f0bf);
const $d835f4176edea769$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};

});

parcelRegister("1N5XT", function(module, exports) {
$parcel$export(module.exports, "toCommonMediaClientError", () => $b0bc2cf8cdd8d6d0$export$a5db89cfc88eff9);

var $96uki = parcelRequire("96uki");
const $b0bc2cf8cdd8d6d0$export$a5db89cfc88eff9 = (errorFileState)=>{
    var _errorFileState$detai;
    const error = (_errorFileState$detai = errorFileState.details) === null || _errorFileState$detai === void 0 ? void 0 : _errorFileState$detai.error;
    return new (0, $96uki.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown-reason', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
};

});

parcelRegister("kMOab", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $f312ec26224b2eac$export$46fd859414de9d62);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $dRkX9 = parcelRequire("dRkX9");

var $eenXr = parcelRequire("eenXr");

var $1BkOH = parcelRequire("1BkOH");

var $XDzZS = parcelRequire("XDzZS");

var $9W7M9 = parcelRequire("9W7M9");
function $f312ec26224b2eac$var$useCurrentValueRef(value) {
    const ref = (0, $fc4bM.useRef)(value);
    ref.current = value;
    return ref;
}
const $f312ec26224b2eac$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $eenXr.useMediaClient)();
    const innerRef = (0, $fc4bM.useRef)(null);
    const clientIdRef = (0, $fc4bM.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $dRkX9.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $f312ec26224b2eac$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $XDzZS.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $1BkOH.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $fc4bM.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $dRkX9.fg)('platform_media_cross_client_copy')) elem === null || elem === void 0 || elem.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $fc4bM.useCallback)((event)=>{
        var _getSelection;
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && ((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.containsNode(currentCopyTarget, true));
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $dRkX9.fg)('platform_media_cross_client_copy_with_auth')) {
                var _event$clipboardData;
                const clientId = clientIdRef.current;
                const html = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId) {
                    var _event$clipboardData2;
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId}"$2`);
                    (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 || _event$clipboardData2.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $dRkX9.fg)('platform_media_cross_client_copy')) {
            var _getDocument;
            (_getDocument = (0, $9W7M9.getDocument)()) === null || _getDocument === void 0 || _getDocument.addEventListener('copy', onGlobalCopy);
        }
        return ()=>{
            var _getDocument2;
            return (_getDocument2 = (0, $9W7M9.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.removeEventListener('copy', onGlobalCopy);
        };
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("eenXr", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $10325d8c804088e9$export$8b3e87ea56c3a345);

var $fc4bM = parcelRequire("fc4bM");

var $4cz1R = parcelRequire("4cz1R");

var $6D0PJ = parcelRequire("6D0PJ");
const $10325d8c804088e9$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $4cz1R.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $6D0PJ.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("6D0PJ", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $1f381cf28a83ea3d$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $1f381cf28a83ea3d$export$57164260bc1f1218);

var $fc4bM = parcelRequire("fc4bM");

var $bLScU = parcelRequire("bLScU");

var $5pZyX = parcelRequire("5pZyX");
const $1f381cf28a83ea3d$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(undefined);
const $1f381cf28a83ea3d$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $fc4bM.useMemo)(()=>(0, $bLScU.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $5pZyX.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1f381cf28a83ea3d$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};

});
parcelRegister("5pZyX", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $5f9a3d79b1e8924d$export$d54af28440a5efc0);

var $fc4bM = parcelRequire("fc4bM");

var $3q0OP = parcelRequire("3q0OP");
const $5f9a3d79b1e8924d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $fc4bM.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $3q0OP.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("3q0OP", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $600d092f3a037ed8$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $600d092f3a037ed8$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $600d092f3a037ed8$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($600d092f3a037ed8$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $600d092f3a037ed8$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $600d092f3a037ed8$export$2d23ed2854ac1650 = $600d092f3a037ed8$export$7e209e67b965bc63($600d092f3a037ed8$var$defaultUserPreferences);

});




parcelRegister("1BkOH", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $0004f2369c5be948$export$3ab52330b662b987);

var $bPjfs = parcelRequire("bPjfs");
const $0004f2369c5be948$var$getRequestErrorDetails = (err)=>{
    if ((0, $bPjfs.isRequestError)(err)) {
        var _err$metadata, _err$metadata2, _err$metadata3, _err$metadata4;
        return {
            request: {
                statusCode: (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode,
                traceContext: (_err$metadata2 = err.metadata) === null || _err$metadata2 === void 0 ? void 0 : _err$metadata2.traceContext,
                mediaEnv: (_err$metadata3 = err.metadata) === null || _err$metadata3 === void 0 ? void 0 : _err$metadata3.mediaEnv,
                mediaRegion: (_err$metadata4 = err.metadata) === null || _err$metadata4 === void 0 ? void 0 : _err$metadata4.mediaRegion
            }
        };
    }
    return undefined;
};
const $0004f2369c5be948$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $bPjfs.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$0004f2369c5be948$var$getRequestErrorDetails(error)
        }
    };
};

});

parcelRegister("XDzZS", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $a1d77f7148abd6a3$export$aacb463551da2e8f);
const $a1d77f7148abd6a3$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("9W7M9", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $fcb29c20c504f0f2$export$f65ca476c09acec0);
const $fcb29c20c504f0f2$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("j5sQP", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $577bf92794e0d969$export$90ff537b0999afb);

var $fc4bM = parcelRequire("fc4bM");

var $eenXr = parcelRequire("eenXr");

var $ffKdj = parcelRequire("ffKdj");
function $577bf92794e0d969$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const mediaClient = (0, $eenXr.useMediaClient)();
    const fileState = (0, $ffKdj.useMediaStore)((state)=>state.files[id]);
    // Capture initialFileState as a ref so it's a stable one-time SSR seed that
    // doesn't affect the useEffect dependency array. Including it directly would
    // cause repeated unsubscribe/resubscribe cycles whenever the caller passes a
    // new (unstabilized) object reference — each cycle fires getFileState before
    // the store is populated.
    const initialFileStateRef = (0, $fc4bM.useRef)(initialFileState);
    (0, $fc4bM.useEffect)(()=>{
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            initialFileState: initialFileStateRef.current,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState ?? initialFileState
    };
}

});
parcelRegister("ffKdj", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $b5e827131a841807$export$8a9cc8c330400af8);

var $cWuPv = parcelRequire("cWuPv");

var $eenXr = parcelRequire("eenXr");
const $b5e827131a841807$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $cWuPv.useStore)(store, selector, equals);
function $b5e827131a841807$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $eenXr.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $b5e827131a841807$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("cWuPv", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $96c2d0f6df9bdb0d$export$6ccbb43953eebf8);

var $dc0mX = parcelRequire("dc0mX");

var $fc4bM = parcelRequire("fc4bM");

var $iXlbb = parcelRequire("iXlbb");
var $96c2d0f6df9bdb0d$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $96c2d0f6df9bdb0d$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM)));
const { useSyncExternalStoreWithSelector: $96c2d0f6df9bdb0d$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iXlbb)));
let $96c2d0f6df9bdb0d$var$didWarnAboutEqualityFn = false;
const $96c2d0f6df9bdb0d$var$identity = (arg)=>arg;
function $96c2d0f6df9bdb0d$export$6ccbb43953eebf8(api, selector = $96c2d0f6df9bdb0d$var$identity, equalityFn) {
    if (($96c2d0f6df9bdb0d$import_meta.env ? $96c2d0f6df9bdb0d$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$96c2d0f6df9bdb0d$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $96c2d0f6df9bdb0d$var$didWarnAboutEqualityFn = true;
    }
    const slice = $96c2d0f6df9bdb0d$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $96c2d0f6df9bdb0d$var$useDebugValue(slice);
    return slice;
}
const $96c2d0f6df9bdb0d$var$createImpl = (createState)=>{
    if (($96c2d0f6df9bdb0d$import_meta.env ? $96c2d0f6df9bdb0d$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $dc0mX.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$96c2d0f6df9bdb0d$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $96c2d0f6df9bdb0d$export$185802fd694ee1f5 = (createState)=>createState ? $96c2d0f6df9bdb0d$var$createImpl(createState) : $96c2d0f6df9bdb0d$var$createImpl;
var $96c2d0f6df9bdb0d$export$2e2bcd8739ae039 = (createState)=>{
    if (($96c2d0f6df9bdb0d$import_meta.env ? $96c2d0f6df9bdb0d$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $96c2d0f6df9bdb0d$export$185802fd694ee1f5(createState);
};

});
parcelRegister("iXlbb", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hPbz6"));

});
parcelRegister("hPbz6", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $cfa02badef5ba3d0$export$bf730a2d8bf68b42, (v) => $cfa02badef5ba3d0$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cfa02badef5ba3d0$export$bf730a2d8bf68b42;
"use strict";

var $fc4bM = parcelRequire("fc4bM");

var $6R5ln = parcelRequire("6R5ln");
function $cfa02badef5ba3d0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $cfa02badef5ba3d0$var$objectIs = "function" === typeof Object.is ? Object.is : $cfa02badef5ba3d0$var$is, $cfa02badef5ba3d0$var$useSyncExternalStore = $6R5ln.useSyncExternalStore, $cfa02badef5ba3d0$var$useRef = $fc4bM.useRef, $cfa02badef5ba3d0$var$useEffect = $fc4bM.useEffect, $cfa02badef5ba3d0$var$useMemo = $fc4bM.useMemo, $cfa02badef5ba3d0$var$useDebugValue = $fc4bM.useDebugValue;
$cfa02badef5ba3d0$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $cfa02badef5ba3d0$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $cfa02badef5ba3d0$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($cfa02badef5ba3d0$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $cfa02badef5ba3d0$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $cfa02badef5ba3d0$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $cfa02badef5ba3d0$var$useDebugValue(value);
    return value;
};

});





parcelRegister("9hMYe", function(module, exports) {
$parcel$export(module.exports, "createFailedSSRObject", () => $effbdb3932cc74cc$export$768c370ed0dbaeb3);

var $jWTuE = parcelRequire("jWTuE");

var $9biMU = parcelRequire("9biMU");
const $effbdb3932cc74cc$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...(0, $jWTuE.extractErrorInfo)(new (0, $9biMU.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("jWTuE", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $1ab05177ba6fe037$export$74aaf4784c2edb2c);

var $lI99k = parcelRequire("lI99k");

var $3lRt6 = parcelRequire("3lRt6");

var $lFYj8 = parcelRequire("lFYj8");

var $enmew = parcelRequire("enmew");
const $1ab05177ba6fe037$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: (0, $enmew.getRenderErrorFailReason)(error),
        error: (0, $lFYj8.getRenderErrorErrorReason)(error),
        errorDetail: (0, $3lRt6.getRenderErrorErrorDetail)(error),
        metadataTraceContext: metadataTraceContext ?? (0, $lI99k.getErrorTraceContext)(error)
    };
};

});
parcelRegister("lI99k", function(module, exports) {
$parcel$export(module.exports, "getErrorTraceContext", () => $ac56c7dca8820acb$export$29aa614726672b2e);

var $kNFIw = parcelRequire("kNFIw");
const $ac56c7dca8820acb$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $kNFIw.isCommonMediaClientError)(secondaryError)) {
        var _secondaryError$metad;
        return (_secondaryError$metad = secondaryError.metadata) === null || _secondaryError$metad === void 0 ? void 0 : _secondaryError$metad.traceContext;
    }
};

});

parcelRegister("3lRt6", function(module, exports) {
$parcel$export(module.exports, "getRenderErrorErrorDetail", () => $572dac96b4a495c4$export$9ccc5365d056da4b);

var $kNFIw = parcelRequire("kNFIw");
const $572dac96b4a495c4$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $kNFIw.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};

});

parcelRegister("lFYj8", function(module, exports) {
$parcel$export(module.exports, "getRenderErrorErrorReason", () => $a6b89b23ed43b947$export$88c61dcad53762da);

var $kNFIw = parcelRequire("kNFIw");
const $a6b89b23ed43b947$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $kNFIw.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};

});

parcelRegister("enmew", function(module, exports) {
$parcel$export(module.exports, "getRenderErrorFailReason", () => $2ad4348805188193$export$4af9d71992e89714);
const $2ad4348805188193$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};

});


parcelRegister("9biMU", function(module, exports) {
$parcel$export(module.exports, "ImageLoadError", () => $a8bbed1cacb58816$export$d0a45ab59b4606b);

var $SP6cY = parcelRequire("SP6cY");
const $a8bbed1cacb58816$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $a8bbed1cacb58816$export$d0a45ab59b4606b extends (0, $SP6cY.MediaFilePreviewError) {
    constructor(source){
        super($a8bbed1cacb58816$var$getImageLoadPrimaryReason(source));
    }
}

});
parcelRegister("SP6cY", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $b6af9d2d3cf1f4ce$export$96e559194c287cf4);
class $b6af9d2d3cf1f4ce$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});



parcelRegister("htN43", function(module, exports) {
$parcel$export(module.exports, "createRequestDimensions", () => $b3d9039d6559b7e3$export$3063221e86a58f9);
/** Verifies if the current screen is retina display */ function $b3d9039d6559b7e3$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $b3d9039d6559b7e3$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $b3d9039d6559b7e3$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};

});

parcelRegister("qLp6O", function(module, exports) {
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ac7178c045249c96$export$7156ce7b78b49bd7);

var $eaIy1 = parcelRequire("eaIy1");

var $SP6cY = parcelRequire("SP6cY");
const $ac7178c045249c96$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ((0, $eaIy1.isMediaFilePreviewError)(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new (0, $SP6cY.MediaFilePreviewError)(primaryReason, error.secondaryError);
        return error;
    }
    return new (0, $SP6cY.MediaFilePreviewError)(primaryReason, error);
};

});
parcelRegister("eaIy1", function(module, exports) {
$parcel$export(module.exports, "isMediaFilePreviewError", () => $df5d97d89cda1d0f$export$553696a6e769784c);

var $SP6cY = parcelRequire("SP6cY");
function $df5d97d89cda1d0f$export$553696a6e769784c(err) {
    return err instanceof (0, $SP6cY.MediaFilePreviewError);
}

});


parcelRegister("cFaxz", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $adfb28cd5835b89f$export$b7e8ee3f7a41459);

var $3opYE = parcelRequire("3opYE");

var $diZss = parcelRequire("diZss");
const $adfb28cd5835b89f$export$b7e8ee3f7a41459 = new (0, $3opYE.CardPreviewCacheImpl)((0, $diZss.createObjectURLCache)());

});
parcelRegister("3opYE", function(module, exports) {
$parcel$export(module.exports, "CardPreviewCacheImpl", () => $93dc8a88da864e9b$export$7b50526c091bb915);

var $3rv2v = parcelRequire("3rv2v");
class $93dc8a88da864e9b$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = (0, $3rv2v.getCacheKey)(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = (0, $3rv2v.getCacheKey)(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = (0, $3rv2v.getCacheKey)(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = (0, $3rv2v.getCacheKey)(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = (0, $3rv2v.getCacheKey)(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}

});
parcelRegister("3rv2v", function(module, exports) {
$parcel$export(module.exports, "getCacheKey", () => $72e3f978cff7495e$export$611736262b635f8d);
const $72e3f978cff7495e$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};

});


parcelRegister("diZss", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $1c6b1d7ff618e6e8$export$ba71be67d5c32535);

var $epWBv = parcelRequire("epWBv");

var $gytFo = parcelRequire("gytFo");
const $1c6b1d7ff618e6e8$export$ba71be67d5c32535 = ()=>new (0, $gytFo.ObjectURLCache)((0, $epWBv.PREVIEW_CACHE_LRU_SIZE));

});
parcelRegister("epWBv", function(module, exports) {
$parcel$export(module.exports, "PREVIEW_CACHE_LRU_SIZE", () => $30c977f971fe44fd$export$36d0f9859761643d);
const $30c977f971fe44fd$export$36d0f9859761643d = 50;

});

parcelRegister("gytFo", function(module, exports) {
$parcel$export(module.exports, "ObjectURLCache", () => $3e052d490abe36b1$export$75d1c8c9ba1d0773);

var $11Qwb = parcelRequire("11Qwb");
/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * The oldest entry is kept if `shouldEvict` returns false.
 */ class $3e052d490abe36b1$var$EvictionLRUCache extends (0, $11Qwb.LRUMap) {
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = options === null || options === void 0 ? void 0 : options.shouldEvict;
        this.onEvict = options === null || options === void 0 ? void 0 : options.onEvict;
    }
    shift() {
        const oldest = this.oldest;
        if (oldest && this.shouldEvict && !this.shouldEvict([
            oldest.key,
            oldest.value
        ])) return undefined;
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
}
class $3e052d490abe36b1$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.activeRefs = new Map();
        this.cache = new $3e052d490abe36b1$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = entry[1].dataURI.split('#')[0];
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = removed === null || removed === void 0 ? void 0 : removed.dataURI.split('#')[0];
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
}

});



parcelRegister("e50HS", function(module, exports) {
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $af09f0a6fd17f8e0$export$98e935d981c884d);

var $9Ml7i = parcelRequire("9Ml7i");

var $5S5cH = parcelRequire("5S5cH");

var $30GPA = parcelRequire("30GPA");
const $af09f0a6fd17f8e0$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $30GPA.getLocalPreview)(filePreview),
        (0, $9Ml7i.enrichAttrsWithClientId)(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return (0, $5S5cH.extendAndCachePreview)(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};

});
parcelRegister("9Ml7i", function(module, exports) {
$parcel$export(module.exports, "enrichAttrsWithClientId", () => $724233857da46661$export$9c3033a429726afd);

var $dRkX9 = parcelRequire("dRkX9");

var $e13nl = parcelRequire("e13nl");
const $724233857da46661$export$9c3033a429726afd = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $dRkX9.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return (0, $e13nl.mergeClientIdIntoAttrs)(clientId, id, mediaBlobUrlAttrs, collectionName);
};

});
parcelRegister("e13nl", function(module, exports) {
$parcel$export(module.exports, "mergeClientIdIntoAttrs", () => $0d481926a49e6d96$export$95365db502f725a1);
const $0d481926a49e6d96$export$95365db502f725a1 = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};

});


parcelRegister("5S5cH", function(module, exports) {
$parcel$export(module.exports, "extendAndCachePreview", () => $8dec097bd5a6e501$export$f47ee10612bdcb19);

var $4mnXP = parcelRequire("4mnXP");

var $cFaxz = parcelRequire("cFaxz");
const $8dec097bd5a6e501$export$f47ee10612bdcb19 = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $4mnXP.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $cFaxz.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};

});
parcelRegister("4mnXP", function(module, exports) {
$parcel$export(module.exports, "addFileAttrsToUrl", () => $f0b7e40bad288d7e$export$e51a8146182600b8);

var $4xQj9 = parcelRequire("4xQj9");

var $fVvXj = parcelRequire("fVvXj");
const $f0b7e40bad288d7e$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [(0, $fVvXj.mediaBlobUrlIdentifier)]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = (0, $4xQj9.objectToQueryString)(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});
parcelRegister("4xQj9", function(module, exports) {
$parcel$export(module.exports, "objectToQueryString", () => $c7049daa7a2886c9$export$89a7e74069fbb7af);
const $c7049daa7a2886c9$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};

});

parcelRegister("fVvXj", function(module, exports) {
$parcel$export(module.exports, "mediaBlobUrlIdentifier", () => $1e720c9821fb69c9$export$dbe437e0902936cc);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 



const $1e720c9821fb69c9$export$dbe437e0902936cc = 'media-blob-url';

});



parcelRegister("30GPA", function(module, exports) {
$parcel$export(module.exports, "getLocalPreview", () => $a157853ce850e424$export$3d6ed68e437b8c99);

var $heTdg = parcelRequire("heTdg");

var $kf8Yw = parcelRequire("kf8Yw");

var $k6hzv = parcelRequire("k6hzv");

var $34IXc = parcelRequire("34IXc");
const $a157853ce850e424$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $kf8Yw.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $k6hzv.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $a157853ce850e424$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $34IXc.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $k6hzv.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $a157853ce850e424$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $k6hzv.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $heTdg.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $a157853ce850e424$var$getImageLocalPreview(value);
            case 'video':
                return $a157853ce850e424$var$getVideoLocalPreview(value);
            default:
                throw new (0, $k6hzv.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $k6hzv.LocalPreviewError)('local-preview-unsupported');
};

});
parcelRegister("kf8Yw", function(module, exports) {
$parcel$export(module.exports, "getOrientation", () => $fc2ca5623349ab96$export$67689507e8404821);

var $9x0IK = parcelRequire("9x0IK");

var $8Vlvw = parcelRequire("8Vlvw");
const $fc2ca5623349ab96$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[(0, $8Vlvw.SupportedImageMetaTag).Orientation]) {
        const tagValue = tags[(0, $8Vlvw.SupportedImageMetaTag).Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $8Vlvw.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $fc2ca5623349ab96$export$67689507e8404821(file) {
    const tags = await (0, $9x0IK.readImageMetaTags)(file);
    return $fc2ca5623349ab96$var$getOrientationFromTags(tags);
}

});
parcelRegister("9x0IK", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $258230d7ea82d288$export$41982b5c7acb23c4);

var $3pem5 = parcelRequire("3pem5");

var $4iCeU = parcelRequire("4iCeU");

var $4GsHZ = parcelRequire("4GsHZ");

var $8Vlvw = parcelRequire("8Vlvw");
async function $258230d7ea82d288$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $8Vlvw.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $4iCeU.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $4GsHZ.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $8Vlvw.ImageType).JPEG) return await (0, $3pem5.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("3pem5", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $9b3ad6612edc44a1$export$556b2ccec62d7f2a);

var $8Vlvw = parcelRequire("8Vlvw");
const { XResolution: $9b3ad6612edc44a1$var$XResolution, YResolution: $9b3ad6612edc44a1$var$YResolution } = (0, $8Vlvw.SupportedImageMetaTag);
let $9b3ad6612edc44a1$var$loadImage;

function $9b3ad6612edc44a1$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$9b3ad6612edc44a1$var$loadImage) {
            const module = await (parcelRequire("1N2WW"));
            $9b3ad6612edc44a1$var$loadImage = module.default || module;
        }
        $9b3ad6612edc44a1$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $9b3ad6612edc44a1$var$XResolution || key === $9b3ad6612edc44a1$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8Vlvw", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $1a84ecc15edcb44b$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $1a84ecc15edcb44b$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $1a84ecc15edcb44b$export$f6ea0c89fd7d156);
var $1a84ecc15edcb44b$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $1a84ecc15edcb44b$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $1a84ecc15edcb44b$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    // none
    'top-right': 2,
    // flip horizontal
    'bottom-right': 3,
    // rotate 180
    'bottom-left': 4,
    // flip vertical
    'left-top': 5,
    // transpose
    'right-top': 6,
    // rotate 90
    'right-bottom': 7,
    // transverse
    'left-bottom': 8 // rotate 270
};

});

parcelRegister("1N2WW", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4fVGv").then(()=>parcelRequire('cCgAc'));

});


parcelRegister("4iCeU", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $7a6fc9e1e679e4ff$export$5fb37736440fca6f);

var $55bW6 = parcelRequire("55bW6");

var $7EQJi = parcelRequire("7EQJi");
let $7a6fc9e1e679e4ff$var$pngChunksExtract;

async function $7a6fc9e1e679e4ff$export$5fb37736440fca6f(file) {
    if (!$7a6fc9e1e679e4ff$var$pngChunksExtract) {
        const module = await (parcelRequire("9WvvN"));
        $7a6fc9e1e679e4ff$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $55bW6.fileToArrayBuffer)(file);
    const chunks = $7a6fc9e1e679e4ff$var$pngChunksExtract(buffer);
    return await (0, $7EQJi.parsePNGChunks)(chunks);
}

});
parcelRegister("55bW6", function(module, exports) {
$parcel$export(module.exports, "fileToArrayBuffer", () => $b3b084639bf27ae4$export$956310555b96755a);
function $b3b084639bf27ae4$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}

});

parcelRegister("7EQJi", function(module, exports) {
$parcel$export(module.exports, "parsePNGChunks", () => $667b15b08f1c93ef$export$9185743fdd58ce45);
async function $667b15b08f1c93ef$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
   * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
   * Order of every chunk is not guaranteed.
   * And both iTXt and pHYs are Ancillary chunks.
   */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
     * iTXt contains the useful XMP/XML string data of meta tags
     */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
     * Pixels per unit, X axis: 4 bytes (unsigned integer)
     * Pixels per unit, Y axis: 4 bytes (unsigned integer)
     * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
     */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});

parcelRegister("9WvvN", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4h81S").then(()=>parcelRequire('f1bVD'));

});


parcelRegister("4GsHZ", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $b7b961ff5e9a7df9$export$55c3bc9841b19de2);
function $b7b961ff5e9a7df9$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});



parcelRegister("k6hzv", function(module, exports) {
$parcel$export(module.exports, "LocalPreviewError", () => $95576ec4eb7f3d2a$export$2c035820a31723e);

var $SP6cY = parcelRequire("SP6cY");
class $95576ec4eb7f3d2a$export$2c035820a31723e extends (0, $SP6cY.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}

});

parcelRegister("34IXc", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $9fcafc031d3981eb$export$4269d30173168e5c);
const $9fcafc031d3981eb$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("4PKLB", function(module, exports) {
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $bbe1822fb6db8a4d$export$49721bcc26fb9388);

var $9Ml7i = parcelRequire("9Ml7i");

var $5S5cH = parcelRequire("5S5cH");

var $kCc5B = parcelRequire("kCc5B");
const $bbe1822fb6db8a4d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $kCc5B.getRemotePreview)(mediaClient, id, params, traceContext),
        (0, $9Ml7i.enrichAttrsWithClientId)(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return (0, $5S5cH.extendAndCachePreview)(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};

});
parcelRegister("kCc5B", function(module, exports) {
$parcel$export(module.exports, "getRemotePreview", () => $41bd4748ef9fa6d9$export$bfe20bd01db02b3);

var $aSGyM = parcelRequire("aSGyM");
const $41bd4748ef9fa6d9$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $aSGyM.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("aSGyM", function(module, exports) {
$parcel$export(module.exports, "RemotePreviewError", () => $e7a2badcf33e7aaa$export$10ab445310d30114);

var $SP6cY = parcelRequire("SP6cY");
class $e7a2badcf33e7aaa$export$10ab445310d30114 extends (0, $SP6cY.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}

});



parcelRegister("g1VIA", function(module, exports) {
$parcel$export(module.exports, "getSSRPreview", () => $fe3a9d6f4e794963$export$faf1c301c59a1bdc);

var $4mnXP = parcelRequire("4mnXP");

var $dRkX9 = parcelRequire("dRkX9");

var $c6BgG = parcelRequire("c6BgG");

var $e13nl = parcelRequire("e13nl");
const $fe3a9d6f4e794963$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs, seededCdnUrl)=>{
    const signedDataURI = mediaClient.getImageUrlSync(id, params, seededCdnUrl);
    return mediaBlobUrlAttrs ? (0, $4mnXP.addFileAttrsToUrl)(signedDataURI, mediaBlobUrlAttrs) : signedDataURI;
};
const $fe3a9d6f4e794963$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs, seededCdnUrl)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $dRkX9.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = (0, $e13nl.mergeClientIdIntoAttrs)(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $fe3a9d6f4e794963$var$getDataUri(mediaClient, id, params, attrsWithClientId, seededCdnUrl);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $fe3a9d6f4e794963$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId, seededCdnUrl);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $c6BgG.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("c6BgG", function(module, exports) {
$parcel$export(module.exports, "SsrPreviewError", () => $8264039a9f66cbfe$export$18e89b7e50818288);

var $SP6cY = parcelRequire("SP6cY");
class $8264039a9f66cbfe$export$18e89b7e50818288 extends (0, $SP6cY.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}

});


parcelRegister("f4ixZ", function(module, exports) {
$parcel$export(module.exports, "isLocalPreview", () => $9521b51fbe171cca$export$78ad02c5efc361c9);
const $9521b51fbe171cca$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};

});

parcelRegister("j810B", function(module, exports) {
$parcel$export(module.exports, "isRemotePreview", () => $c25726f55a42e203$export$87442a14a8a19e0);
const $c25726f55a42e203$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};

});

parcelRegister("9oo67", function(module, exports) {
$parcel$export(module.exports, "isSSRClientPreview", () => $08637b543a6445c5$export$36aae1afbc0a9661);
const $08637b543a6445c5$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';

});

parcelRegister("rQ9A8", function(module, exports) {
$parcel$export(module.exports, "isSSRDataPreview", () => $d349c63fdccdea88$export$f366c2c8a792cce6);
const $d349c63fdccdea88$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';

});

parcelRegister("jk4Pk", function(module, exports) {
$parcel$export(module.exports, "isSSRPreview", () => $291b0be99779df9d$export$dea79d05143ccf4);
const $291b0be99779df9d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};

});

parcelRegister("dnaS8", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $269a2ab53344b563$export$1fa85b75e8662d54);
const $269a2ab53344b563$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';

});

parcelRegister("e91H1", function(module, exports) {
$parcel$export(module.exports, "generateScriptProps", () => $df0fa43b721a37f9$export$de7c49925e44d75d);

var $go06O = parcelRequire("go06O");

var $ar7HU = parcelRequire("ar7HU");
const $df0fa43b721a37f9$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = (0, $go06O.getKey)(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: (0, $ar7HU.MAX_EAGER_LOAD_COUNT)
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $df0fa43b721a37f9$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $df0fa43b721a37f9$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });

});
parcelRegister("go06O", function(module, exports) {
$parcel$export(module.exports, "getKey", () => $1b9417489b5f79a1$export$a47fb462a08de82f);
const $1b9417489b5f79a1$var$dashed = (param)=>param ? `-${param}` : '';
const $1b9417489b5f79a1$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$1b9417489b5f79a1$var$dashed(collectionName)}${$1b9417489b5f79a1$var$dashed(occurrenceKey)}${$1b9417489b5f79a1$var$dashed(resizeMode)}`;

});

parcelRegister("ar7HU", function(module, exports) {
$parcel$export(module.exports, "MAX_EAGER_LOAD_COUNT", () => $7e5627971710daad$export$4ced612cd8b14538);
const $7e5627971710daad$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $7e5627971710daad$export$d26005e8749921c9 = 'mediaCountSsr';
const $7e5627971710daad$export$7aeb4eab53a57df7 = 'performanceEntries';
const $7e5627971710daad$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $7e5627971710daad$export$4ced612cd8b14538 = 6;

});


parcelRegister("bDruT", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $cb79b818265660e2$export$d3a890b0f7844b6f);

var $go06O = parcelRequire("go06O");

var $glUMR = parcelRequire("glUMR");
const $cb79b818265660e2$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $glUMR.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $go06O.getKey)(identifier, resizeMode)];
};

});
parcelRegister("glUMR", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $43e2c0a4bc5ccab1$export$ede93d4564eaa8da);

var $2xFOP = parcelRequire("2xFOP");
function $43e2c0a4bc5ccab1$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = (0, $2xFOP.getMediaGlobalScope)(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}

});
parcelRegister("2xFOP", function(module, exports) {
$parcel$export(module.exports, "getMediaGlobalScope", () => $054647ebc5f6cd21$export$96a3cfb3a41e9bb2);
function $054647ebc5f6cd21$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}

});



parcelRegister("dma3p", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $e02357e6ed2ade54$export$912a00e9a5470d9a);
const $e02357e6ed2ade54$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};

});

parcelRegister("ikeKC", function(module, exports) {
$parcel$export(module.exports, "isWider", () => $519adb5004c3badf$export$ae6224430098bc5f);
const $519adb5004c3badf$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = (current === null || current === void 0 ? void 0 : current.width) || 0;
    const nextWidth = (next === null || next === void 0 ? void 0 : next.width) || 0;
    return currentWidth < nextWidth;
};

});

parcelRegister("kETOS", function(module, exports) {
$parcel$export(module.exports, "useCurrentValueRef", () => $65f41faf13238ba0$export$b3e10e1f0fbb71db);

var $fc4bM = parcelRequire("fc4bM");
function $65f41faf13238ba0$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $fc4bM.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("7XxaT", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => (parcelRequire("impvR")).AttributeList);

var $impvR = parcelRequire("impvR");

});
parcelRegister("impvR", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => $041482f55d354c15$export$f632a70b7942a9ca);

var $fc4bM = parcelRequire("fc4bM");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $73xOu = parcelRequire("73xOu");
const $041482f55d354c15$export$f632a70b7942a9ca = ({ attributes: attributes, timezoneId: timezoneId })=>{
    const objectAttributeValuesAreNotEmpty = (values)=>{
        return values.every((value)=>Object.keys(value).length > 0);
    };
    const renderAttribute = (attribute)=>{
        var _attribute$objectType;
        if (((_attribute$objectType = attribute.objectTypeAttribute.defaultType) === null || _attribute$objectType === void 0 ? void 0 : _attribute$objectType.name) === 'DateTime' && timezoneId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            const displayValue = value.value ? (0, $73xOu.convertToTimezone)(value.value, timezoneId) : value.displayValue;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
                key: index
            }, displayValue);
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
                key: index
            }, value.displayValue);
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $041482f55d354c15$var$ListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "dl",
        xcss: $041482f55d354c15$var$ListStyles
    }, attributes.map((attribute)=>objectAttributeValuesAreNotEmpty(attribute.objectAttributeValues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            key: attribute.id ?? attribute.objectTypeAttribute.name,
            xcss: $041482f55d354c15$var$AttributeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "dt",
            xcss: $041482f55d354c15$var$AttributeLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
            size: "xsmall",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "span",
            xcss: $041482f55d354c15$var$attributeLabelStyles
        }, attribute.objectTypeAttribute.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "dd",
            xcss: $041482f55d354c15$var$AttributeValueStyles
        }, renderAttribute(attribute))))));
};
const $041482f55d354c15$var$ListStyles = (0, $kig2V.xcss)({
    paddingLeft: 'space.0'
});
const $041482f55d354c15$var$ListWrapperStyles = (0, $kig2V.xcss)({
    /* Offset the outside padding from children */ // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.negative.050',
    marginRight: 'space.negative.150',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.150'
});
const $041482f55d354c15$var$attributeLabelStyles = (0, $kig2V.xcss)({
    color: 'color.text.subtle'
});
const $041482f55d354c15$var$AttributeLabelWrapperStyles = (0, $kig2V.xcss)({
    marginBlock: 'space.050',
    marginInline: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '112px',
    flexGrow: 1
});
const $041482f55d354c15$var$AttributeValueStyles = (0, $kig2V.xcss)({
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    color: 'color.text',
    // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.050',
    marginRight: 'space.150',
    marginBottom: 'space.050',
    marginLeft: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '224px',
    flexGrow: 1
});
const $041482f55d354c15$var$AttributeWrapperStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
});

});
parcelRegister("1hJdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $eff3b08dc5b630ad$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gPFyv = parcelRequire("gPFyv");

var $3tX4e = parcelRequire("3tX4e");

var $hDMvW = parcelRequire("hDMvW");

var $3jCFs = parcelRequire("3jCFs");
const $eff3b08dc5b630ad$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $eff3b08dc5b630ad$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $eff3b08dc5b630ad$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $eff3b08dc5b630ad$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $eff3b08dc5b630ad$var$useColor = (colorProp)=>{
    const surface = (0, $gPFyv.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $3tX4e.inverseColorMap).hasOwnProperty(surface)) return (0, $3tX4e.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $eff3b08dc5b630ad$var$Heading = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $3jCFs;
    const [hLevel, inferredElement] = (0, $hDMvW.useHeading)($eff3b08dc5b630ad$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $eff3b08dc5b630ad$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $2R2iS.default)([
            $eff3b08dc5b630ad$var$styles.reset,
            $eff3b08dc5b630ad$var$headingSizeStyles[size],
            $eff3b08dc5b630ad$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $eff3b08dc5b630ad$export$2e2bcd8739ae039 = $eff3b08dc5b630ad$var$Heading;

});
parcelRegister("gPFyv", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $c36ee448ab0d6c61$export$1aeb4f6b93c4540d);

var $fc4bM = parcelRequire("fc4bM");

var $2C58c = parcelRequire("2C58c");
const $c36ee448ab0d6c61$export$1aeb4f6b93c4540d = ()=>{
    return (0, $fc4bM.useContext)((0, $2C58c.SurfaceContext));
};
(0, $2C58c.SurfaceContext).displayName = 'SurfaceProvider';

});

parcelRegister("3tX4e", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $bd3a41bd1f6db8d0$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f941eca1bf309f7088207fc024b707>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $bd3a41bd1f6db8d0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("hDMvW", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $78e8c9be34928431$export$97a37b1befbbf9b1);

var $ergv9 = parcelRequire("ergv9");
const $78e8c9be34928431$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $ergv9.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("ergv9", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $eaa18a4234ae5175$export$6a64a1e2d0bbbf75);

var $fc4bM = parcelRequire("fc4bM");

var $c06WK = parcelRequire("c06WK");
const $eaa18a4234ae5175$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $fc4bM.useContext)((0, $c06WK.HeadingLevelContext));
};

});
parcelRegister("c06WK", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $adeae3514fa3d7db$export$d1fa8a19e192bc63);

var $fc4bM = parcelRequire("fc4bM");
const $adeae3514fa3d7db$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $fc4bM.createContext)(0);

});




parcelRegister("73xOu", function(module, exports) {
$parcel$export(module.exports, "convertToTimezone", () => $8b729af9300eb8e0$export$4d189baac548427);
const $8b729af9300eb8e0$export$4d189baac548427 = (dateString, timezoneId)=>{
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timezoneId
    }).format(date);
};

});



parcelRegister("jMtJe", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => (parcelRequire("f98TQ")).ExpandCollapseToggle);

var $f98TQ = parcelRequire("f98TQ");

});
parcelRegister("f98TQ", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => $fcc3d9538734db99$export$170fda29b81e014c);

var $fc4bM = parcelRequire("fc4bM");

var $kTVlm = parcelRequire("kTVlm");

var $13zmE = parcelRequire("13zmE");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $bcTS3 = parcelRequire("bcTS3");
const $fcc3d9538734db99$export$170fda29b81e014c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: props.label,
        hasNewContentOnTriggerClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        appearance: "subtle",
        onClick: props.onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: [
                $fcc3d9538734db99$var$animatedRotationStyles,
                props.isExpanded && $fcc3d9538734db99$var$animatedRotationStylesInverted
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            spacing: "spacious",
            label: props.label,
            size: "small"
        })),
        testId: props.testId
    }));
};
const $fcc3d9538734db99$var$animatedRotationStyles = (0, $kig2V.xcss)({
    transition: '200ms ease all',
    transform: 'rotate(0deg)'
});
const $fcc3d9538734db99$var$animatedRotationStylesInverted = (0, $kig2V.xcss)({
    transform: 'rotate(180deg)'
});

});
parcelRegister("kTVlm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a5b6183964d85c18$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $2mc3E = parcelRequire("2mc3E");

var $lNvWx = parcelRequire("lNvWx");

var $9KPkf = parcelRequire("9KPkf");
const $a5b6183964d85c18$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $a5b6183964d85c18$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $9JZL9.default), onMouseUp: providedOnMouseUp = (0, $9JZL9.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $9KPkf.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $fc4bM.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $fc4bM.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($a5b6183964d85c18$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $fc4bM.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($a5b6183964d85c18$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $fc4bM.useMemo)(()=>(0, $lNvWx.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2mc3E.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$a5b6183964d85c18$var$Button.displayName = 'Button';
var $a5b6183964d85c18$export$2e2bcd8739ae039 = $a5b6183964d85c18$var$Button;

});
parcelRegister("9JZL9", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5e7dd3986843846$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $f5e7dd3986843846$export$2e2bcd8739ae039() {}

});

parcelRegister("2mc3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $e358ba0901674901$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $8PakO = parcelRequire("8PakO");

var $aTvf2 = parcelRequire("aTvf2");

var $fVzQQ = parcelRequire("fVzQQ");

var $77VlM = parcelRequire("77VlM");

var $8f2YX = parcelRequire("8f2YX");

var $k5UwX = parcelRequire("k5UwX");

var $gyJCU = parcelRequire("gyJCU");

var $a74m4 = parcelRequire("a74m4");

var $cMojb = parcelRequire("cMojb");
function $e358ba0901674901$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $e358ba0901674901$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $e358ba0901674901$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $e358ba0901674901$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $e358ba0901674901$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $a74m4.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $e358ba0901674901$var$getChildren = (children, childrenStyles)=>{
    if ((0, $a74m4.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $e358ba0901674901$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $9JZL9.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $9JZL9.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $fc4bM.useRef)();
    const setRef = (0, $fc4bM.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $8PakO.default)(ourRef, autoFocus);
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $fc4bM.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $fc4bM.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $jctmk.css)((0, $k5UwX.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $aTvf2.default), null, /*#__PURE__*/ (0, $jctmk.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $e358ba0901674901$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $77VlM.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gyJCU.getIconStyle)({
                spacing: spacing
            }),
            $e358ba0901674901$var$getSpacingFix(children, $e358ba0901674901$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $e358ba0901674901$var$getChildren(children, [
        fadeStyles,
        (0, $8f2YX.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gyJCU.getIconStyle)({
                spacing: spacing
            }),
            $e358ba0901674901$var$getSpacingFix(children, $e358ba0901674901$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: [
            (0, $cMojb.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e358ba0901674901$export$2e2bcd8739ae039 = $e358ba0901674901$var$ButtonBase;

});
parcelRegister("7iKPB", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $31ba067e484e49f0$export$a4687b0234b40e28);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $7nxW1 = parcelRequire("7nxW1");
function $31ba067e484e49f0$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $7nxW1.useTrackedRef)(analyticsData);
    const fnRef = (0, $7nxW1.useTrackedRef)(fn);
    const handler = (0, $fc4bM.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("8PakO", function(module, exports) {
$parcel$export(module.exports, "default", () => $28bfc9bb9fe69494$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $28bfc9bb9fe69494$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $fc4bM.useRef)(true);
    (0, $fc4bM.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("aTvf2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ed2a0f473b087a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");
const $2ed2a0f473b087a3$var$BORDER_WIDTH = 2;
const $2ed2a0f473b087a3$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $jctmk.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $2ed2a0f473b087a3$var$BORDER_WIDTH
});
const $2ed2a0f473b087a3$var$baseInsetStyles = /*#__PURE__*/ (0, $jctmk.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$2ed2a0f473b087a3$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $2ed2a0f473b087a3$var$focusRingStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $2ed2a0f473b087a3$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $2ed2a0f473b087a3$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $2ed2a0f473b087a3$var$insetFocusRingStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $2ed2a0f473b087a3$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $2ed2a0f473b087a3$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $2ed2a0f473b087a3$var$FocusRing = /*#__PURE__*/ (0, $fc4bM.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $2ed2a0f473b087a3$var$baseInsetStyles : $2ed2a0f473b087a3$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $2ed2a0f473b087a3$var$insetFocusRingStyles : $2ed2a0f473b087a3$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $jctmk.ClassNames), null, ({ css: css, cx: cx })=>(0, $fc4bM.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $fc4bM.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$2ed2a0f473b087a3$var$FocusRing.displayName = 'FocusRing';
var $2ed2a0f473b087a3$export$2e2bcd8739ae039 = $2ed2a0f473b087a3$var$FocusRing;

});

parcelRegister("77VlM", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0c14282d81a8244$export$2e2bcd8739ae039);
function $d0c14282d81a8244$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $d0c14282d81a8244$var$tabKeyCode = 9;
function $d0c14282d81a8244$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d0c14282d81a8244$var$tabKeyCode) return;
    $d0c14282d81a8244$var$abort(event);
}
const $d0c14282d81a8244$var$block = {
    onMouseDownCapture: $d0c14282d81a8244$var$abort,
    onMouseUpCapture: $d0c14282d81a8244$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $d0c14282d81a8244$var$onKey,
    onKeyUpCapture: $d0c14282d81a8244$var$onKey,
    onTouchStartCapture: $d0c14282d81a8244$var$abort,
    onTouchEndCapture: $d0c14282d81a8244$var$abort,
    onPointerDownCapture: $d0c14282d81a8244$var$abort,
    onPointerUpCapture: $d0c14282d81a8244$var$abort,
    onClickCapture: $d0c14282d81a8244$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $d0c14282d81a8244$var$abort
};
const $d0c14282d81a8244$var$doNotBlock = {};
function $d0c14282d81a8244$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $d0c14282d81a8244$var$doNotBlock : $d0c14282d81a8244$var$block;
}

});

parcelRegister("8f2YX", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $51eab45715b8ac48$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
function $51eab45715b8ac48$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("k5UwX", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $e33ee95a868102de$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
function $e33ee95a868102de$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("gyJCU", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $37c8d6617e071fee$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
function $37c8d6617e071fee$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $jctmk.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("a74m4", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $e531e6ee7ba90a57$export$20bbd2efb0d734c4);

var $fc4bM = parcelRequire("fc4bM");

var $dVxDa = parcelRequire("dVxDa");
const $e531e6ee7ba90a57$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $fc4bM.isValidElement)(children) && children.type === (0, $dVxDa.default);
};

});
parcelRegister("dVxDa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ac0e84c0b8daf4d$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $2ac0e84c0b8daf4d$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $2ac0e84c0b8daf4d$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$2ac0e84c0b8daf4d$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $2ac0e84c0b8daf4d$export$2e2bcd8739ae039 = $2ac0e84c0b8daf4d$var$VisuallyHidden;

});


parcelRegister("cMojb", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $e0be5175c523f50d$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $e0be5175c523f50d$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("lNvWx", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $809f8c99982c0cb1$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dRkX9 = parcelRequire("dRkX9");
const $809f8c99982c0cb1$var$gridSize = 8;
const $809f8c99982c0cb1$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $809f8c99982c0cb1$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $809f8c99982c0cb1$var$lineHeights = {
    default: $809f8c99982c0cb1$var$heights.default,
    compact: $809f8c99982c0cb1$var$heights.compact,
    none: 'inherit'
};
const $809f8c99982c0cb1$var$padding = {
    // 10px gutter
    default: `0 ${$809f8c99982c0cb1$var$gridSize + $809f8c99982c0cb1$var$gridSize / 4}px`,
    compact: `0 ${$809f8c99982c0cb1$var$gridSize + $809f8c99982c0cb1$var$gridSize / 4}px`,
    none: '0'
};
const $809f8c99982c0cb1$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$809f8c99982c0cb1$var$gridSize / 4}px`,
    default: `0 ${$809f8c99982c0cb1$var$gridSize / 4}px`,
    none: '0'
};
const $809f8c99982c0cb1$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $809f8c99982c0cb1$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $809f8c99982c0cb1$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$809f8c99982c0cb1$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    },
    textDecoration: 'none'
};
const $809f8c99982c0cb1$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$809f8c99982c0cb1$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $809f8c99982c0cb1$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $809f8c99982c0cb1$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseAppearanceStyles = {
        ...appearance === 'default' && $809f8c99982c0cb1$var$defaultStyles,
        ...appearance === 'primary' && $809f8c99982c0cb1$var$primaryStyles,
        ...appearance === 'link' && $809f8c99982c0cb1$var$linkStyles,
        ...appearance === 'subtle' && $809f8c99982c0cb1$var$subtleStyles,
        ...appearance === 'subtle-link' && $809f8c99982c0cb1$var$subtleLinkStyles,
        ...appearance === 'warning' && $809f8c99982c0cb1$var$warningStyles,
        ...appearance === 'danger' && $809f8c99982c0cb1$var$dangerStyles
    };
    const appearanceStyles = appearance === 'default' && (0, $dRkX9.fg)('platform-dst-tokens-finesse') ? {
        ...baseAppearanceStyles,
        '&:hover': {
            ...baseAppearanceStyles['&:hover'],
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        '&:active': {
            ...baseAppearanceStyles['&:active'],
            background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        }
    } : baseAppearanceStyles;
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-medium, 6px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)`,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $809f8c99982c0cb1$var$heights[spacing],
        lineHeight: $809f8c99982c0cb1$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $809f8c99982c0cb1$var$singleIconPadding[spacing] : $809f8c99982c0cb1$var$padding[spacing],
        verticalAlign: $809f8c99982c0cb1$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $809f8c99982c0cb1$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $809f8c99982c0cb1$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $809f8c99982c0cb1$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $809f8c99982c0cb1$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$809f8c99982c0cb1$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("9KPkf", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ab7881d0d81f817$export$2e2bcd8739ae039);

var $a74m4 = parcelRequire("a74m4");
function $6ab7881d0d81f817$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $a74m4.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("13zmE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c5180dcbdb85b9a$var$_react = $0c5180dcbdb85b9a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $0c5180dcbdb85b9a$var$_iconNew = $0c5180dcbdb85b9a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $0c5180dcbdb85b9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c5180dcbdb85b9a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $0c5180dcbdb85b9a$var$_react.default.createElement($0c5180dcbdb85b9a$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$0c5180dcbdb85b9a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $0c5180dcbdb85b9a$var$_default = module.exports.default = $0c5180dcbdb85b9a$var$ChevronDownIcon;

});

parcelRegister("bcTS3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b7180e6fe31028f$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $e6tCE = parcelRequire("e6tCE");

var $4dCfH = parcelRequire("4dCfH");

var $9JZL9 = parcelRequire("9JZL9");

var $j0DAO = parcelRequire("j0DAO");

var $bYhJa = parcelRequire("bYhJa");

var $jlwk8 = parcelRequire("jlwk8");

var $iXBtU = parcelRequire("iXBtU");

var $4CgiI = parcelRequire("4CgiI");

var $dRkX9 = parcelRequire("dRkX9");

var $dgKcj = parcelRequire("dgKcj");

var $cufVT = parcelRequire("cufVT");

var $2SWSA = parcelRequire("2SWSA");

var $j5ggC = parcelRequire("j5ggC");

var $GyLDf = parcelRequire("GyLDf");

var $lz1tR = parcelRequire("lz1tR");

var $51q3I = parcelRequire("51q3I");

var $bwRpG = parcelRequire("bwRpG");

var $kZDsQ = parcelRequire("kZDsQ");

var $6Aut2 = parcelRequire("6Aut2");

var $2J80J = parcelRequire("2J80J");

var $4Ug84 = parcelRequire("4Ug84");

var $9prlt = parcelRequire("9prlt");

var $aShMO = parcelRequire("aShMO");
const $9b7180e6fe31028f$var$tooltipZIndex = (0, $2SWSA.layers).tooltip();
const $9b7180e6fe31028f$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $9b7180e6fe31028f$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $9b7180e6fe31028f$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry (or, for `mouseout`, a real exit) from one of those.
 */ function $9b7180e6fe31028f$var$isTopLayerPointerReEntry({ trigger: trigger, relatedTarget: relatedTarget }) {
    if (!(0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $9b7180e6fe31028f$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $aShMO.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $9JZL9.default), onHide: onHide = (0, $9JZL9.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    // The deprecated hide props win over `hasNewContentOnTriggerClick`, as the prop
    // docs say. Setting both is a mistake, so keep the older behaviour. Read only
    // together with `platform-dst-top-layer-tooltip`; without the gate a press
    // never closes.
    const isStayOpenOnTriggerClick = hasNewContentOnTriggerClick && !hideTooltipOnClick && !hideTooltipOnMouseDown;
    const onShowHandler = (0, $e6tCE.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$9b7180e6fe31028f$var$analyticsAttributes
    });
    const onHideHandler = (0, $e6tCE.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$9b7180e6fe31028f$var$analyticsAttributes
    });
    const apiRef = (0, $fc4bM.useRef)(null);
    const [state, setState] = (0, $fc4bM.useState)('hide');
    const targetRef = (0, $fc4bM.useRef)(null);
    const containerRef = (0, $fc4bM.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $fc4bM.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $bYhJa.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $bYhJa.default)(onShowHandler);
    const onHideHandlerStable = (0, $bYhJa.default)(onHideHandler);
    const delayStable = (0, $bYhJa.default)(delay);
    const canAppearStable = (0, $bYhJa.default)(canAppear);
    const hasCalledShowHandler = (0, $fc4bM.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $bYhJa.default)(shouldAlwaysFadeIn);
    const start = (0, $fc4bM.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $fc4bM.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $fc4bM.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $fc4bM.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        return (0, $kZDsQ.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set by Escape, light dismiss or a press on the trigger. Every read and write is
    // behind `platform-dst-top-layer-tooltip`.
    const isDismissedUntilTriggerLeaveRef = (0, $fc4bM.useRef)(false);
    const tryShowTooltip = (0, $fc4bM.useCallback)((source)=>{
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        // After the "already active" check, so a held press stays visible.
        if (isDismissedUntilTriggerLeaveRef.current && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $4Ug84.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $fc4bM.useCallback)(()=>{
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="hint" handles Escape natively
    (0, $j0DAO.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $fc4bM.useCallback)(()=>{
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss: Escape, or light dismiss on pointerup.
    const handlePopoverClose = (0, $fc4bM.useCallback)(()=>{
        var _apiRef$current4;
        if ((0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        if (state === 'hide') return 0, $9JZL9.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $6Zi52.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $fc4bM.useCallback)(()=>{
        // `hasNewContentOnTriggerClick`: `TopLayerTooltipPopup` re-shows the popover
        // after the light dismiss, so there is nothing to record, and a pending
        // show goes ahead with the new content, as it does without the gate.
        if (isStayOpenOnTriggerClick && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) return;
        // Set now: light dismiss only hides on pointerup.
        if ((0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        const shouldCancelPendingShow = stableState.current === 'hide' && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        isStayOpenOnTriggerClick,
        stableState
    ]);
    const onClick = (0, $fc4bM.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $fc4bM.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Not on a boundary crossing inside the trigger.
        if ($9b7180e6fe31028f$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = false;
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $fc4bM.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Not on a boundary crossing inside the trigger.
        if ($9b7180e6fe31028f$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $fc4bM.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $fc4bM.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $fc4bM.useCallback)(()=>{
        if ((0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $fc4bM.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $fc4bM.useCallback)(()=>{
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Called unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path a tooltip is not a layer (open layer
    // checks skip tooltips), so it does not register with the observer.
    (0, $jlwk8.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        isEnabled: !(0, $dRkX9.fg)('platform-dst-top-layer-tooltip'),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $2J80J.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $9prlt.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $fc4bM.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $fc4bM.Fragment) : $9b7180e6fe31028f$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : /*#__PURE__*/ (0, $3LM7S.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        /**
   * TODO: Why is role="presentation" added?
   * - Is it only to "remove" the `Container` from screen readers?
   * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
   * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
   */ role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current8;
        return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
            children: [
                trigger,
                shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $3LM7S.jsx)($9b7180e6fe31028f$var$TopLayerTooltipPopup, {
                    targetRef: targetRef,
                    tooltipPosition: tooltipPosition,
                    mousePos: ((_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) ?? undefined,
                    position: position,
                    onMouseOut: onMouseOut,
                    onMouseOverTooltip: onMouseOverTooltip,
                    ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                    truncate: truncate,
                    testId: testId,
                    shortcut: shortcut,
                    content: content,
                    Container: Container,
                    onClose: handlePopoverClose,
                    shouldStayOpenOnTriggerClick: isStayOpenOnTriggerClick,
                    onExitFinish: handleExitFinish,
                    isOpen: state !== 'hide' && state !== 'top-layer-exit'
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $3LM7S.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dgKcj.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $9b7180e6fe31028f$var$invertedDirection[$9b7180e6fe31028f$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4CgiI.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $3LM7S.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $9b7180e6fe31028f$export$2e2bcd8739ae039 = $9b7180e6fe31028f$var$Tooltip;
const $9b7180e6fe31028f$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cufVT.default), {
        zIndex: $9b7180e6fe31028f$var$tooltipZIndex,
        children: children
    });
};
const $9b7180e6fe31028f$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with two positioning
 * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
 * fight for ownership, so `isEnabled` is derived from one boolean and negated:
 *
 *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
 *     `mouse-x`, `mouse-y`) activated by a pointer.
 *   - `useAnchoredPopover` for everything else, including a cursor position
 *     activated via keyboard focus, where there is no cursor to track and
 *     anchoring to the trigger is what keeps the tooltip beside the target.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $9b7180e6fe31028f$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen, shouldStayOpenOnTriggerClick: shouldStayOpenOnTriggerClick }) {
    const popoverRef = (0, $fc4bM.useRef)(null);
    // Never read. Some custom `component` wrappers render nothing without a ref.
    const containerRef = (0, $fc4bM.useRef)(null);
    // The host unmounts on close and remounts on open, so set `data-placement`
    // whenever a node attaches, as well as when the placement changes.
    const setPopoverNode = (0, $fc4bM.useCallback)((node)=>{
        node === null || node === void 0 || node.setAttribute('data-placement', tooltipPosition);
    }, [
        tooltipPosition
    ]);
    const hostRef = (0, $4dCfH.default)([
        popoverRef,
        setPopoverNode
    ]);
    // `shouldStayOpenOnTriggerClick`: a press on the trigger light-dismisses the hint
    // popover, and the browser gives no way to cancel that. The dismiss runs
    // before the `pointerup` is dispatched, so show the popover again from the
    // trigger's `pointerup`. It is the same task, so no closed frame is painted,
    // the entry transition does not restart, and the `toggle` events coalesce
    // to open -> open, so `onClose` is not called. `mouseup` covers
    // environments that dismiss on `mouseup` too, such as the test polyfill.
    // `showPopover()` does nothing when the popover is already open. A layout
    // effect, so the listener is gone in the same commit that closes the
    // popover: a passive cleanup runs later, and a `pointerup` in that gap would
    // re-open a closing tooltip.
    (0, $fc4bM.useLayoutEffect)(()=>{
        const trigger = targetRef.current;
        if (!shouldStayOpenOnTriggerClick || !isOpen || !trigger) return;
        const reshow = ()=>{
            try {
                var _popoverRef$current;
                (_popoverRef$current = popoverRef.current) === null || _popoverRef$current === void 0 || _popoverRef$current.showPopover();
            } catch  {}
        };
        return (0, $6Zi52.bindAll)(trigger, [
            {
                type: 'pointerup',
                listener: reshow
            },
            {
                type: 'mouseup',
                listener: reshow
            }
        ]);
    }, [
        shouldStayOpenOnTriggerClick,
        isOpen,
        targetRef
    ]);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    const placement = (0, $j5ggC.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // One object so the two calls cannot drift on `placement` or `isOpen`.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $lz1tR.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    });
    // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $51q3I.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isMouseStrategyActive,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $6Aut2.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
        ref: hostRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $9b7180e6fe31028f$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $9b7180e6fe31028f$var$tooltipMouseAnimationStyles.exit,
        placement: placement,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bwRpG.DefaultRoleContext).Provider, {
            value: "presentation",
            children: /*#__PURE__*/ (0, $3LM7S.jsx)(Container, {
                ref: containerRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
                className: "Tooltip",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- top-layer spike
                style: ignoreTooltipPointerEvents ? {
                    pointerEvents: 'none'
                } : undefined,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut,
                children: typeof content === 'function' ? content({
                    update: (0, $9JZL9.default)
                }) : content
            })
        })
    });
}

});
parcelRegister("e6tCE", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $473d27b76c71c0aa$export$1a04351537078b55);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $7nxW1 = parcelRequire("7nxW1");
function $473d27b76c71c0aa$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $7nxW1.useTrackedRef)(analyticsData);
    const fnRef = (0, $7nxW1.useTrackedRef)(fn);
    const handler = (0, $fc4bM.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("4dCfH", function(module, exports) {
$parcel$export(module.exports, "default", () => $00fd524f1d67771b$export$2e2bcd8739ae039);
function $00fd524f1d67771b$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("j0DAO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4c737f3498c2e98$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $d5gKU = parcelRequire("d5gKU");
function $e4c737f3498c2e98$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $fc4bM.useRef)(false);
    const onKeyDown = (0, $fc4bM.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $d5gKU.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $fc4bM.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $6Zi52.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("d5gKU", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $a5dd9e076e4b2b7d$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $a5dd9e076e4b2b7d$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $a5dd9e076e4b2b7d$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $a5dd9e076e4b2b7d$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $a5dd9e076e4b2b7d$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $a5dd9e076e4b2b7d$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $a5dd9e076e4b2b7d$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $a5dd9e076e4b2b7d$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $a5dd9e076e4b2b7d$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $a5dd9e076e4b2b7d$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $a5dd9e076e4b2b7d$export$390330c10ff2b9a1 = 'ArrowUp';
const $a5dd9e076e4b2b7d$export$a80636c6f41931fe = 'ArrowDown';
const $a5dd9e076e4b2b7d$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $a5dd9e076e4b2b7d$export$c40f9845adc73fb5 = 'ArrowRight';
const $a5dd9e076e4b2b7d$export$4af703091671bc = 'Home';
const $a5dd9e076e4b2b7d$export$e2bc30913faa5db7 = 'End';
const $a5dd9e076e4b2b7d$export$10f6869ed0a7d75b = 'Tab';
const $a5dd9e076e4b2b7d$export$8152f929a25a0ff4 = 'Enter';
const $a5dd9e076e4b2b7d$export$e51a3576c045c8d5 = 'Space';
const $a5dd9e076e4b2b7d$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("bYhJa", function(module, exports) {
$parcel$export(module.exports, "default", () => $311c498aa6e512a7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $311c498aa6e512a7$export$2e2bcd8739ae039(value) {
    const ref = (0, $fc4bM.useRef)(value);
    (0, $fc4bM.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("jlwk8", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $24bb640efb8c1687$export$469bb693f11edc7f);

var $fc4bM = parcelRequire("fc4bM");

var $bEzr3 = parcelRequire("bEzr3");

var $w0DQI = parcelRequire("w0DQI");
function $24bb640efb8c1687$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose, isEnabled: isEnabled = true }) {
    const context = (0, $fc4bM.useContext)((0, $bEzr3.OpenLayerObserverContext));
    const namespace = (0, $w0DQI.useOpenLayerObserverNamespace)();
    (0, $fc4bM.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null || !isEnabled) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isEnabled,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("bEzr3", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $a781ff4fcb9496ac$export$5fbf4d7fae6cdc00);

var $fc4bM = parcelRequire("fc4bM");
const $a781ff4fcb9496ac$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);

});

parcelRegister("w0DQI", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $487bfe389367fc1c$export$1d57e79091cc3046);

var $fc4bM = parcelRequire("fc4bM");

var $jp81U = parcelRequire("jp81U");
function $487bfe389367fc1c$export$1d57e79091cc3046() {
    const namespace = (0, $fc4bM.useContext)((0, $jp81U.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("jp81U", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $eb69a3686c61bc8e$export$644a49f3b8c50fcd);

var $fc4bM = parcelRequire("fc4bM");
const $eb69a3686c61bc8e$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $fc4bM.createContext)(null);

});



parcelRegister("iXBtU", function(module, exports) {
$parcel$export(module.exports, "defaultExitingContext", () => $b7ebfc8dbc4daeb2$export$52502485782d6180);
$parcel$export(module.exports, "ExitingContext", () => $b7ebfc8dbc4daeb2$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $b7ebfc8dbc4daeb2$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
const $b7ebfc8dbc4daeb2$export$52502485782d6180 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
const $b7ebfc8dbc4daeb2$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $fc4bM.createContext)($b7ebfc8dbc4daeb2$export$52502485782d6180);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $b7ebfc8dbc4daeb2$var$wrapChildWithContextProvider = (child, value = $b7ebfc8dbc4daeb2$export$52502485782d6180)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)($b7ebfc8dbc4daeb2$export$b9c4904d7a6929e6.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $b7ebfc8dbc4daeb2$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $fc4bM.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $b7ebfc8dbc4daeb2$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $b7ebfc8dbc4daeb2$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $b7ebfc8dbc4daeb2$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $b7ebfc8dbc4daeb2$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $b7ebfc8dbc4daeb2$var$ExitingPersistence = /*#__PURE__*/ (0, $fc4bM.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $fc4bM.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $fc4bM.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $fc4bM.useState)(()=>({
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        }));
    (0, $fc4bM.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $b7ebfc8dbc4daeb2$var$childrenToArray(previousChildren);
    const current = $b7ebfc8dbc4daeb2$var$childrenToArray(currentChildren);
    if (currentChildren !== children) {
        // Parent updates can rerender this boundary before its children finish exiting. Keep
        // the previous children until their onFinish callbacks release them.
        const hasPendingExit = ((0, $dRkX9.fg)('platform-dst-motion-uplift-labels') || (0, $dRkX9.fg)('platform-dst-motion-uplift-input')) && $b7ebfc8dbc4daeb2$var$getMissingKeys(current, previous).size > 0;
        setChildren([
            hasPendingExit ? previousChildren : currentChildren,
            children
        ]);
    }
    const nextChildren = currentChildren !== children ? $b7ebfc8dbc4daeb2$var$childrenToArray(children) : current;
    const missingKeys = $b7ebfc8dbc4daeb2$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $b7ebfc8dbc4daeb2$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $dRkX9.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        // Retained exits can span several parent renders. Unchanged siblings should
        // keep their context identity instead of receiving redundant updates.
        if (((0, $dRkX9.fg)('platform-dst-motion-uplift-labels') || (0, $dRkX9.fg)('platform-dst-motion-uplift-input')) && !isExiting) return $b7ebfc8dbc4daeb2$var$wrapChildWithContextProvider(child, defaultContext);
        return $b7ebfc8dbc4daeb2$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$b7ebfc8dbc4daeb2$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b7ebfc8dbc4daeb2$export$2e2bcd8739ae039 = $b7ebfc8dbc4daeb2$var$ExitingPersistence;
$b7ebfc8dbc4daeb2$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("4CgiI", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f577e7b9b2bac97$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gh5HC = parcelRequire("gh5HC");
const $6f577e7b9b2bac97$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $6f577e7b9b2bac97$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $6f577e7b9b2bac97$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gh5HC.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $6f577e7b9b2bac97$export$2e2bcd8739ae039 = $6f577e7b9b2bac97$var$FadeIn;

});
parcelRegister("gh5HC", function(module, exports) {
$parcel$export(module.exports, "default", () => $27b6e768e5c8dd9d$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $9dmSL = parcelRequire("9dmSL");

var $bKFmB = parcelRequire("bKFmB");

var $kUMs0 = parcelRequire("kUMs0");

var $8Xjx2 = parcelRequire("8Xjx2");

var $8vg2n = parcelRequire("8vg2n");

var $9dMLa = parcelRequire("9dMLa");
const $27b6e768e5c8dd9d$var$zoomIn = null;
const $27b6e768e5c8dd9d$var$zoomOut = null;
const $27b6e768e5c8dd9d$var$fadeIn = null;
const $27b6e768e5c8dd9d$var$fadeOut = null;
const $27b6e768e5c8dd9d$var$fadeInFromTop = null;
const $27b6e768e5c8dd9d$var$fadeOutFromTop = null;
const $27b6e768e5c8dd9d$var$fadeInFromLeft = null;
const $27b6e768e5c8dd9d$var$fadeOutFromLeft = null;
const $27b6e768e5c8dd9d$var$fadeInFromBottom = null;
const $27b6e768e5c8dd9d$var$fadeOutFromBottom = null;
const $27b6e768e5c8dd9d$var$fadeInFromRight = null;
const $27b6e768e5c8dd9d$var$fadeOutFromRight = null;
const $27b6e768e5c8dd9d$var$fadeInFromTopConstant = null;
const $27b6e768e5c8dd9d$var$fadeOutFromTopConstant = null;
const $27b6e768e5c8dd9d$var$fadeInFromLeftConstant = null;
const $27b6e768e5c8dd9d$var$fadeOutFromLeftConstant = null;
const $27b6e768e5c8dd9d$var$fadeInFromBottomConstant = null;
const $27b6e768e5c8dd9d$var$fadeOutFromBottomConstant = null;
const $27b6e768e5c8dd9d$var$fadeInFromRightConstant = null;
const $27b6e768e5c8dd9d$var$fadeOutFromRightConstant = null;
const $27b6e768e5c8dd9d$var$slideInFromTop = null;
const $27b6e768e5c8dd9d$var$slideOutFromTop = null;
const $27b6e768e5c8dd9d$var$slideInFromRight = null;
const $27b6e768e5c8dd9d$var$slideOutFromRight = null;
const $27b6e768e5c8dd9d$var$slideInFromBottom = null;
const $27b6e768e5c8dd9d$var$slideOutFromBottom = null;
const $27b6e768e5c8dd9d$var$slideInFromLeft = null;
const $27b6e768e5c8dd9d$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $27b6e768e5c8dd9d$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $9dMLa.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8vg2n.useExitingPersistence)();
    const setTimeout = (0, $8Xjx2.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $fc4bM.useState)(appear);
    (0, $fc4bM.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $kUMs0.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $bKFmB.exitingDurations)[duration] : (0, $9dmSL.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $2R2iS.default)([
            (0, $2R2iS.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $2R2iS.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $2R2iS.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $2R2iS.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $2R2iS.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $2R2iS.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $2R2iS.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $2R2iS.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $2R2iS.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $2R2iS.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $2R2iS.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $2R2iS.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $2R2iS.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $2R2iS.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $2R2iS.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $2R2iS.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $2R2iS.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $2R2iS.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $2R2iS.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $2R2iS.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $2R2iS.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $2R2iS.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $2R2iS.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $2R2iS.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $2R2iS.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $2R2iS.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $2R2iS.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $2R2iS.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $2R2iS.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $2R2iS.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $2R2iS.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $2R2iS.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $2R2iS.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $2R2iS.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $2R2iS.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $2R2iS.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $2R2iS.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $2R2iS.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $2R2iS.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $2R2iS.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $2R2iS.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $2R2iS.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $2R2iS.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $2R2iS.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $2R2iS.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $2R2iS.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $2R2iS.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $2R2iS.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $2R2iS.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $2R2iS.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $2R2iS.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $27b6e768e5c8dd9d$export$2e2bcd8739ae039 = $27b6e768e5c8dd9d$var$EnteringMotion;

});
parcelRegister("9dmSL", function(module, exports) {
$parcel$export(module.exports, "durations", () => $6a3fb56afa5a0148$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $6a3fb56afa5a0148$export$368bacef0dacbe05 = 25;
const $6a3fb56afa5a0148$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("bKFmB", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $8fa03cbc1ea00697$export$30fa1a2e62ae150c);

var $9dmSL = parcelRequire("9dmSL");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $8fa03cbc1ea00697$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $8fa03cbc1ea00697$export$30fa1a2e62ae150c = {
    none: (0, $9dmSL.durations).none,
    small: (0, $9dmSL.durations).small * $8fa03cbc1ea00697$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $9dmSL.durations).medium * $8fa03cbc1ea00697$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $9dmSL.durations).large * $8fa03cbc1ea00697$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("kUMs0", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $5d4a8200ef0be1c9$export$b7baf7667a68d87c);

var $1EkOZ = parcelRequire("1EkOZ");
const $5d4a8200ef0be1c9$export$b7baf7667a68d87c = ()=>{
    if (!(0, $1EkOZ.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("1EkOZ", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $f54db4d146fab73c$export$c5406bd59b374abd);
const $f54db4d146fab73c$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("8Xjx2", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $b8dd1fce24a2abe5$export$4f34107a2b00f39c);

var $fc4bM = parcelRequire("fc4bM");
const $b8dd1fce24a2abe5$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $b8dd1fce24a2abe5$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $fc4bM.useRef)([]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b8dd1fce24a2abe5$var$getHookDeps(opts));
    return (0, $fc4bM.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("8vg2n", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $11563508de187e66$export$3b6f38abbdcbd000);

var $fc4bM = parcelRequire("fc4bM");

var $iXBtU = parcelRequire("iXBtU");
const $11563508de187e66$export$3b6f38abbdcbd000 = ()=>{
    return (0, $fc4bM.useContext)((0, $iXBtU.ExitingContext));
};

});

parcelRegister("9dMLa", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $5969b81a526b7bc0$export$25c7213fc07ec080);

var $fc4bM = parcelRequire("fc4bM");

var $bCftt = parcelRequire("bCftt");

var $fvyyl = parcelRequire("fvyyl");
const $5969b81a526b7bc0$export$25c7213fc07ec080 = ()=>{
    const identifier = (0, $bCftt.useUniqueId)();
    const context = (0, $fc4bM.useContext)((0, $fvyyl.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("bCftt", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $1996a803394f3334$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $fc4bM = parcelRequire("fc4bM");
function $1996a803394f3334$export$c485849f2e393253() {
    const identifier = (0, $fc4bM.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("fvyyl", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $da164139fb59c899$export$5e65d7d58ae96ad8);
$parcel$export(module.exports, "default", () => $da164139fb59c899$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $1JUTA = parcelRequire("1JUTA");
const $da164139fb59c899$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $fc4bM.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $9JZL9.default)
    }));
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $da164139fb59c899$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $fc4bM.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $fc4bM.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $1JUTA.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($da164139fb59c899$export$5e65d7d58ae96ad8.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$da164139fb59c899$export$2e2bcd8739ae039 = $da164139fb59c899$var$StaggeredEntrance;

});
parcelRegister("1JUTA", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $5156197cc9161e1d$export$e5c5a5f917a5871c);

var $fc4bM = parcelRequire("fc4bM");
const $5156197cc9161e1d$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);

});





parcelRegister("dgKcj", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $c6de4e57b37d686c$export$badac9ada3a0bdf9);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5mSwt = parcelRequire("5mSwt");

var $dRkX9 = parcelRequire("dRkX9");

var $lkQdL = parcelRequire("lkQdL");

var $8xENs = parcelRequire("8xENs");

const $c6de4e57b37d686c$var$viewportPadding = 5;
const $c6de4e57b37d686c$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $c6de4e57b37d686c$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $c6de4e57b37d686c$var$defaultChildrenFn() {
    return null;
}
const $c6de4e57b37d686c$var$defaultOffset = [
    0,
    8
];
function $c6de4e57b37d686c$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $dRkX9.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8xENs.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($c6de4e57b37d686c$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $c6de4e57b37d686c$var$LegacyPopper({ children: children = $c6de4e57b37d686c$var$defaultChildrenFn, offset: offset = $c6de4e57b37d686c$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $fc4bM.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $c6de4e57b37d686c$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $lkQdL.getMaxSizeModifiers)({
            viewportPadding: $c6de4e57b37d686c$var$viewportPadding
        }) : [];
        return [
            ...$c6de4e57b37d686c$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $fc4bM.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5mSwt.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("5mSwt", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $3e894cee18786dfa$export$badac9ada3a0bdf9);

var $fc4bM = parcelRequire("fc4bM");

var $ikgDL = parcelRequire("ikgDL");

var $58q6a = parcelRequire("58q6a");

var $55JI2 = parcelRequire("55JI2");
var $3e894cee18786dfa$var$NOOP = function NOOP() {
    return void 0;
};
var $3e894cee18786dfa$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $3e894cee18786dfa$var$EMPTY_MODIFIERS = [];
function $3e894cee18786dfa$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $3e894cee18786dfa$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $fc4bM.useContext((0, $ikgDL.ManagerReferenceNodeContext));
    var _React$useState = $fc4bM.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $fc4bM.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $fc4bM.useEffect(function() {
        (0, $58q6a.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $fc4bM.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $55JI2.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $fc4bM.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $3e894cee18786dfa$var$NOOP,
            update: update || $3e894cee18786dfa$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $58q6a.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("ikgDL", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $d57700aa4aaa76d9$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $d57700aa4aaa76d9$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $d57700aa4aaa76d9$export$d0d38e7dec7a1a61);

var $fc4bM = parcelRequire("fc4bM");
var $d57700aa4aaa76d9$export$3dbd3405086fec7b = $fc4bM.createContext();
var $d57700aa4aaa76d9$export$cbabb21c2529b130 = $fc4bM.createContext();
function $d57700aa4aaa76d9$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $fc4bM.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $fc4bM.useRef(false);
    $fc4bM.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $fc4bM.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $fc4bM.createElement($d57700aa4aaa76d9$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $fc4bM.createElement($d57700aa4aaa76d9$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("58q6a", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $3bd1f1bcf5492cdf$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3bd1f1bcf5492cdf$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3bd1f1bcf5492cdf$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3bd1f1bcf5492cdf$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3bd1f1bcf5492cdf$export$700979bc83e7db82);

var $fc4bM = parcelRequire("fc4bM");
var $3bd1f1bcf5492cdf$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3bd1f1bcf5492cdf$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3bd1f1bcf5492cdf$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3bd1f1bcf5492cdf$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3bd1f1bcf5492cdf$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3bd1f1bcf5492cdf$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $fc4bM.useLayoutEffect : $fc4bM.useEffect;

});

parcelRegister("55JI2", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $3b50e04db76b24ea$export$f4d5bf230a36dd6e);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $9yeiV = parcelRequire("9yeiV");

var $l6n8m = parcelRequire("l6n8m");

var $58q6a = parcelRequire("58q6a");
var $3b50e04db76b24ea$var$EMPTY_MODIFIERS = [];
var $3b50e04db76b24ea$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $fc4bM.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $3b50e04db76b24ea$var$EMPTY_MODIFIERS
    };
    var _React$useState = $fc4bM.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $fc4bM.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $bTkYf.flushSync(function() {
                    setState({
                        styles: (0, $58q6a.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $58q6a.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $fc4bM.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($l6n8m)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $fc4bM.useRef();
    (0, $58q6a.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $58q6a.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $9yeiV.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("9yeiV", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $6f42628a21f5941e$export$8f7491d57c8f97a9);

var $aFJJ2 = parcelRequire("aFJJ2");

var $hMTfL = parcelRequire("hMTfL");

var $j0jLb = parcelRequire("j0jLb");

var $c7Kwy = parcelRequire("c7Kwy");

var $cCxE5 = parcelRequire("cCxE5");

var $l9wwk = parcelRequire("l9wwk");

var $aZ5dm = parcelRequire("aZ5dm");

var $fj0qN = parcelRequire("fj0qN");

var $e0eer = parcelRequire("e0eer");

var $7DjFi = parcelRequire("7DjFi");


var $6f42628a21f5941e$export$d34966752335dd47 = [
    (0, $hMTfL.default),
    (0, $j0jLb.default),
    (0, $c7Kwy.default),
    (0, $cCxE5.default),
    (0, $l9wwk.default),
    (0, $aZ5dm.default),
    (0, $fj0qN.default),
    (0, $e0eer.default),
    (0, $7DjFi.default)
];
var $6f42628a21f5941e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $aFJJ2.popperGenerator)({
    defaultModifiers: $6f42628a21f5941e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("aFJJ2", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $7c5133d784bbce79$export$ed5e13716264f202);

var $ltbae = parcelRequire("ltbae");

var $aLg0M = parcelRequire("aLg0M");

var $4lgVg = parcelRequire("4lgVg");

var $3Og5Y = parcelRequire("3Og5Y");

var $eV0J8 = parcelRequire("eV0J8");

var $2LDWQ = parcelRequire("2LDWQ");

var $91ySw = parcelRequire("91ySw");


var $lep1e = parcelRequire("lep1e");
var $7c5133d784bbce79$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $7c5133d784bbce79$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $7c5133d784bbce79$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $7c5133d784bbce79$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $7c5133d784bbce79$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $lep1e.isElement)(reference) ? (0, $4lgVg.default)(reference) : reference.contextElement ? (0, $4lgVg.default)(reference.contextElement) : [],
                    popper: (0, $4lgVg.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $eV0J8.default)((0, $91ySw.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$7c5133d784bbce79$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ltbae.default)(reference, (0, $3Og5Y.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $aLg0M.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $2LDWQ.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$7c5133d784bbce79$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $7c5133d784bbce79$export$8f7491d57c8f97a9 = /*#__PURE__*/ $7c5133d784bbce79$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ltbae", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa14f75953366626$export$2e2bcd8739ae039);

var $cgk7E = parcelRequire("cgk7E");

var $aax9d = parcelRequire("aax9d");

var $2iDvz = parcelRequire("2iDvz");

var $lep1e = parcelRequire("lep1e");

var $jHjey = parcelRequire("jHjey");

var $arACa = parcelRequire("arACa");

var $1BxYS = parcelRequire("1BxYS");

var $eZzhS = parcelRequire("eZzhS");
function $fa14f75953366626$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $eZzhS.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $eZzhS.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $fa14f75953366626$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $lep1e.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $lep1e.isHTMLElement)(offsetParent) && $fa14f75953366626$var$isElementScaled(offsetParent);
    var documentElement = (0, $arACa.default)(offsetParent);
    var rect = (0, $cgk7E.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $2iDvz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1BxYS.default)(documentElement)) scroll = (0, $aax9d.default)(offsetParent);
        if ((0, $lep1e.isHTMLElement)(offsetParent)) {
            offsets = (0, $cgk7E.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $jHjey.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("cgk7E", function(module, exports) {
$parcel$export(module.exports, "default", () => $024dc89f26ea10ce$export$2e2bcd8739ae039);

var $lep1e = parcelRequire("lep1e");

var $eZzhS = parcelRequire("eZzhS");

var $az4qA = parcelRequire("az4qA");

var $2Plfy = parcelRequire("2Plfy");
function $024dc89f26ea10ce$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $lep1e.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $eZzhS.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $eZzhS.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $lep1e.isElement)(element) ? (0, $az4qA.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2Plfy.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("lep1e", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $f74e500380efc344$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $f74e500380efc344$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $f74e500380efc344$export$af51f0f06c0f328a);

var $az4qA = parcelRequire("az4qA");
function $f74e500380efc344$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $az4qA.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f74e500380efc344$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $az4qA.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f74e500380efc344$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $az4qA.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("az4qA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b109b8a8f0b55b6$export$2e2bcd8739ae039);
function $7b109b8a8f0b55b6$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("eZzhS", function(module, exports) {
$parcel$export(module.exports, "max", () => $aea2228636ea78e0$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $aea2228636ea78e0$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $aea2228636ea78e0$export$2077e0241d6afd3c);
var $aea2228636ea78e0$export$8960430cfd85939f = Math.max;
var $aea2228636ea78e0$export$96ec731ed4dcb222 = Math.min;
var $aea2228636ea78e0$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2Plfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $20f0d3fa41255f61$export$2e2bcd8739ae039);

var $knjI5 = parcelRequire("knjI5");
function $20f0d3fa41255f61$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $knjI5.default)());
}

});
parcelRegister("knjI5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed553ea3232ba868$export$2e2bcd8739ae039);
function $ed553ea3232ba868$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("aax9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $76748d0109bc0808$export$2e2bcd8739ae039);

var $87Ks4 = parcelRequire("87Ks4");

var $az4qA = parcelRequire("az4qA");

var $lep1e = parcelRequire("lep1e");

var $hGI5V = parcelRequire("hGI5V");
function $76748d0109bc0808$export$2e2bcd8739ae039(node) {
    if (node === (0, $az4qA.default)(node) || !(0, $lep1e.isHTMLElement)(node)) return (0, $87Ks4.default)(node);
    else return (0, $hGI5V.default)(node);
}

});
parcelRegister("87Ks4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ea302815bc17ea0$export$2e2bcd8739ae039);

var $az4qA = parcelRequire("az4qA");
function $5ea302815bc17ea0$export$2e2bcd8739ae039(node) {
    var win = (0, $az4qA.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("hGI5V", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce08902deca3f5ea$export$2e2bcd8739ae039);
function $ce08902deca3f5ea$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("2iDvz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1acbe8b9c6958b5e$export$2e2bcd8739ae039);
function $1acbe8b9c6958b5e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("jHjey", function(module, exports) {
$parcel$export(module.exports, "default", () => $e570f3e26b413dc1$export$2e2bcd8739ae039);

var $cgk7E = parcelRequire("cgk7E");

var $arACa = parcelRequire("arACa");

var $87Ks4 = parcelRequire("87Ks4");
function $e570f3e26b413dc1$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $cgk7E.default)((0, $arACa.default)(element)).left + (0, $87Ks4.default)(element).scrollLeft;
}

});
parcelRegister("arACa", function(module, exports) {
$parcel$export(module.exports, "default", () => $79a8d3e0a5419665$export$2e2bcd8739ae039);

var $lep1e = parcelRequire("lep1e");
function $79a8d3e0a5419665$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $lep1e.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1BxYS", function(module, exports) {
$parcel$export(module.exports, "default", () => $12b39b0c4b281289$export$2e2bcd8739ae039);

var $dH6Cg = parcelRequire("dH6Cg");
function $12b39b0c4b281289$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $dH6Cg.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("dH6Cg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f846c5320a3f3cc$export$2e2bcd8739ae039);

var $az4qA = parcelRequire("az4qA");
function $9f846c5320a3f3cc$export$2e2bcd8739ae039(element) {
    return (0, $az4qA.default)(element).getComputedStyle(element);
}

});



parcelRegister("aLg0M", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d5ab6b846810c9a$export$2e2bcd8739ae039);

var $cgk7E = parcelRequire("cgk7E");
function $7d5ab6b846810c9a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $cgk7E.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("4lgVg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3296401053f7bdaa$export$2e2bcd8739ae039);

var $4ANZ7 = parcelRequire("4ANZ7");

var $gOu1x = parcelRequire("gOu1x");

var $az4qA = parcelRequire("az4qA");

var $1BxYS = parcelRequire("1BxYS");
function $3296401053f7bdaa$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4ANZ7.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $az4qA.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1BxYS.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3296401053f7bdaa$export$2e2bcd8739ae039((0, $gOu1x.default)(target)));
}

});
parcelRegister("4ANZ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $35814c2db0846d2d$export$2e2bcd8739ae039);

var $gOu1x = parcelRequire("gOu1x");

var $1BxYS = parcelRequire("1BxYS");

var $2iDvz = parcelRequire("2iDvz");

var $lep1e = parcelRequire("lep1e");
function $35814c2db0846d2d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $2iDvz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $lep1e.isHTMLElement)(node) && (0, $1BxYS.default)(node)) return node;
    return $35814c2db0846d2d$export$2e2bcd8739ae039((0, $gOu1x.default)(node));
}

});
parcelRegister("gOu1x", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3d89af911d8eec3$export$2e2bcd8739ae039);

var $2iDvz = parcelRequire("2iDvz");

var $arACa = parcelRequire("arACa");

var $lep1e = parcelRequire("lep1e");
function $c3d89af911d8eec3$export$2e2bcd8739ae039(element) {
    if ((0, $2iDvz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $lep1e.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $arACa.default)(element) // fallback
    );
}

});



parcelRegister("3Og5Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c6286ce384a3050$export$2e2bcd8739ae039);

var $az4qA = parcelRequire("az4qA");

var $2iDvz = parcelRequire("2iDvz");

var $dH6Cg = parcelRequire("dH6Cg");

var $lep1e = parcelRequire("lep1e");

var $kxnnP = parcelRequire("kxnnP");

var $gOu1x = parcelRequire("gOu1x");

var $knjI5 = parcelRequire("knjI5");
function $2c6286ce384a3050$var$getTrueOffsetParent(element) {
    if (!(0, $lep1e.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $dH6Cg.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $2c6286ce384a3050$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $knjI5.default)());
    var isIE = /Trident/i.test((0, $knjI5.default)());
    if (isIE && (0, $lep1e.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $dH6Cg.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $gOu1x.default)(element);
    if ((0, $lep1e.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $lep1e.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $2iDvz.default)(currentNode)) < 0){
        var css = (0, $dH6Cg.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $2c6286ce384a3050$export$2e2bcd8739ae039(element) {
    var window = (0, $az4qA.default)(element);
    var offsetParent = $2c6286ce384a3050$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $kxnnP.default)(offsetParent) && (0, $dH6Cg.default)(offsetParent).position === 'static')offsetParent = $2c6286ce384a3050$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $2iDvz.default)(offsetParent) === 'html' || (0, $2iDvz.default)(offsetParent) === 'body' && (0, $dH6Cg.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $2c6286ce384a3050$var$getContainingBlock(element) || window;
}

});
parcelRegister("kxnnP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef39072a86c22d15$export$2e2bcd8739ae039);

var $2iDvz = parcelRequire("2iDvz");
function $ef39072a86c22d15$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $2iDvz.default)(element)) >= 0;
}

});


parcelRegister("eV0J8", function(module, exports) {
$parcel$export(module.exports, "default", () => $adc6f3eb29131bb4$export$2e2bcd8739ae039);

var $gmzJC = parcelRequire("gmzJC");
function $adc6f3eb29131bb4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $adc6f3eb29131bb4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $adc6f3eb29131bb4$var$order(modifiers); // order based on phase
    return (0, $gmzJC.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("gmzJC", function(module, exports) {
$parcel$export(module.exports, "top", () => $be9a6b978290ec7b$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $be9a6b978290ec7b$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $be9a6b978290ec7b$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $be9a6b978290ec7b$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $be9a6b978290ec7b$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $be9a6b978290ec7b$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $be9a6b978290ec7b$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $be9a6b978290ec7b$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $be9a6b978290ec7b$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $be9a6b978290ec7b$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $be9a6b978290ec7b$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $be9a6b978290ec7b$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $be9a6b978290ec7b$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $be9a6b978290ec7b$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $be9a6b978290ec7b$export$d087d3878fdf71d5);
var $be9a6b978290ec7b$export$1e95b668f3b82d = 'top';
var $be9a6b978290ec7b$export$40e543e69a8b3fbb = 'bottom';
var $be9a6b978290ec7b$export$79ffe56a765070d2 = 'right';
var $be9a6b978290ec7b$export$eabcd2c8791e7bf4 = 'left';
var $be9a6b978290ec7b$export$dfb5619354ba860 = 'auto';
var $be9a6b978290ec7b$export$aec2ce47c367b8c3 = [
    $be9a6b978290ec7b$export$1e95b668f3b82d,
    $be9a6b978290ec7b$export$40e543e69a8b3fbb,
    $be9a6b978290ec7b$export$79ffe56a765070d2,
    $be9a6b978290ec7b$export$eabcd2c8791e7bf4
];
var $be9a6b978290ec7b$export$b3571188c770cc5a = 'start';
var $be9a6b978290ec7b$export$bd5df0f255a350f8 = 'end';
var $be9a6b978290ec7b$export$390fd549c5303b4d = 'clippingParents';
var $be9a6b978290ec7b$export$d7b7311ec04a3e8f = 'viewport';
var $be9a6b978290ec7b$export$ae5ab1c730825774 = 'popper';
var $be9a6b978290ec7b$export$ca50aac9f3ba507f = 'reference';
var $be9a6b978290ec7b$export$368f9a87e87fa4e1 = /*#__PURE__*/ $be9a6b978290ec7b$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $be9a6b978290ec7b$export$b3571188c770cc5a,
        placement + "-" + $be9a6b978290ec7b$export$bd5df0f255a350f8
    ]);
}, []);
var $be9a6b978290ec7b$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($be9a6b978290ec7b$export$aec2ce47c367b8c3, [
    $be9a6b978290ec7b$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $be9a6b978290ec7b$export$b3571188c770cc5a,
        placement + "-" + $be9a6b978290ec7b$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $be9a6b978290ec7b$export$421679a7c3d56e = 'beforeRead';
var $be9a6b978290ec7b$export$aafa59e2e03f2942 = 'read';
var $be9a6b978290ec7b$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $be9a6b978290ec7b$export$c65e99957a05207c = 'beforeMain';
var $be9a6b978290ec7b$export$f22da7240b7add18 = 'main';
var $be9a6b978290ec7b$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $be9a6b978290ec7b$export$8d4d2d70e7d46032 = 'beforeWrite';
var $be9a6b978290ec7b$export$68d8715fc104d294 = 'write';
var $be9a6b978290ec7b$export$70a6e5159acce2e6 = 'afterWrite';
var $be9a6b978290ec7b$export$d087d3878fdf71d5 = [
    $be9a6b978290ec7b$export$421679a7c3d56e,
    $be9a6b978290ec7b$export$aafa59e2e03f2942,
    $be9a6b978290ec7b$export$6964f6c886723980,
    $be9a6b978290ec7b$export$c65e99957a05207c,
    $be9a6b978290ec7b$export$f22da7240b7add18,
    $be9a6b978290ec7b$export$bab79516f2d662fe,
    $be9a6b978290ec7b$export$8d4d2d70e7d46032,
    $be9a6b978290ec7b$export$68d8715fc104d294,
    $be9a6b978290ec7b$export$70a6e5159acce2e6
];

});


parcelRegister("2LDWQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $203ef569371cc223$export$2e2bcd8739ae039);
function $203ef569371cc223$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("91ySw", function(module, exports) {
$parcel$export(module.exports, "default", () => $01b20d7876549198$export$2e2bcd8739ae039);
function $01b20d7876549198$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hMTfL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf31c780b1cc21c0$export$2e2bcd8739ae039);

var $az4qA = parcelRequire("az4qA");
var $cf31c780b1cc21c0$var$passive = {
    passive: true
};
function $cf31c780b1cc21c0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $az4qA.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cf31c780b1cc21c0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cf31c780b1cc21c0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cf31c780b1cc21c0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cf31c780b1cc21c0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cf31c780b1cc21c0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cf31c780b1cc21c0$var$effect,
    data: {}
};

});

parcelRegister("j0jLb", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd5d585111b2f900$export$2e2bcd8739ae039);

var $5K0wj = parcelRequire("5K0wj");
function $dd5d585111b2f900$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5K0wj.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dd5d585111b2f900$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dd5d585111b2f900$var$popperOffsets,
    data: {}
};

});
parcelRegister("5K0wj", function(module, exports) {
$parcel$export(module.exports, "default", () => $42e1a6eeaf3cccd1$export$2e2bcd8739ae039);

var $cD9Qn = parcelRequire("cD9Qn");

var $7DXzr = parcelRequire("7DXzr");

var $70qAV = parcelRequire("70qAV");

var $gmzJC = parcelRequire("gmzJC");
function $42e1a6eeaf3cccd1$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $cD9Qn.default)(placement) : null;
    var variation = placement ? (0, $7DXzr.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $gmzJC.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $gmzJC.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $gmzJC.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $gmzJC.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $70qAV.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $gmzJC.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $gmzJC.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("cD9Qn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9320c34da3ee134c$export$2e2bcd8739ae039);

function $9320c34da3ee134c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7DXzr", function(module, exports) {
$parcel$export(module.exports, "default", () => $590a626cccd91bf1$export$2e2bcd8739ae039);
function $590a626cccd91bf1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("70qAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $519d29a0a03584f0$export$2e2bcd8739ae039);
function $519d29a0a03584f0$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("c7Kwy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d3a3a2c708924e0$export$2e2bcd8739ae039);

var $gmzJC = parcelRequire("gmzJC");

var $3Og5Y = parcelRequire("3Og5Y");

var $az4qA = parcelRequire("az4qA");

var $arACa = parcelRequire("arACa");

var $dH6Cg = parcelRequire("dH6Cg");

var $cD9Qn = parcelRequire("cD9Qn");

var $7DXzr = parcelRequire("7DXzr");

var $eZzhS = parcelRequire("eZzhS");
var $8d3a3a2c708924e0$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8d3a3a2c708924e0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $eZzhS.round)(x * dpr) / dpr || 0,
        y: (0, $eZzhS.round)(y * dpr) / dpr || 0
    };
}
function $8d3a3a2c708924e0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $gmzJC.left);
    var sideY = (0, $gmzJC.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3Og5Y.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $az4qA.default)(popper)) {
            offsetParent = (0, $arACa.default)(popper);
            if ((0, $dH6Cg.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $gmzJC.top) || (placement === (0, $gmzJC.left) || placement === (0, $gmzJC.right)) && variation === (0, $gmzJC.end)) {
            sideY = (0, $gmzJC.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $gmzJC.left) || (placement === (0, $gmzJC.top) || placement === (0, $gmzJC.bottom)) && variation === (0, $gmzJC.end)) {
            sideX = (0, $gmzJC.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8d3a3a2c708924e0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8d3a3a2c708924e0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $az4qA.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8d3a3a2c708924e0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $cD9Qn.default)(state.placement),
        variation: (0, $7DXzr.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8d3a3a2c708924e0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8d3a3a2c708924e0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8d3a3a2c708924e0$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8d3a3a2c708924e0$var$computeStyles,
    data: {}
};

});

parcelRegister("cCxE5", function(module, exports) {
$parcel$export(module.exports, "default", () => $930321ee5fb547b4$export$2e2bcd8739ae039);

var $2iDvz = parcelRequire("2iDvz");

var $lep1e = parcelRequire("lep1e");
// and applies them to the HTMLElements such as popper and arrow
function $930321ee5fb547b4$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $lep1e.isHTMLElement)(element) || !(0, $2iDvz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $930321ee5fb547b4$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $lep1e.isHTMLElement)(element) || !(0, $2iDvz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $930321ee5fb547b4$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $930321ee5fb547b4$var$applyStyles,
    effect: $930321ee5fb547b4$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("l9wwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f663aa18b63a5e61$export$2e2bcd8739ae039);

var $cD9Qn = parcelRequire("cD9Qn");

var $gmzJC = parcelRequire("gmzJC");
function $f663aa18b63a5e61$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $cD9Qn.default)(placement);
    var invertDistance = [
        (0, $gmzJC.left),
        (0, $gmzJC.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $gmzJC.left),
        (0, $gmzJC.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f663aa18b63a5e61$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $gmzJC.placements).reduce(function(acc, placement) {
        acc[placement] = $f663aa18b63a5e61$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f663aa18b63a5e61$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f663aa18b63a5e61$var$offset
};

});

parcelRegister("aZ5dm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ff3a560eaebe0ab$export$2e2bcd8739ae039);

var $dFyKe = parcelRequire("dFyKe");

var $cD9Qn = parcelRequire("cD9Qn");

var $fgbdT = parcelRequire("fgbdT");

var $7zecR = parcelRequire("7zecR");

var $2zbdh = parcelRequire("2zbdh");

var $gmzJC = parcelRequire("gmzJC");

var $7DXzr = parcelRequire("7DXzr");
function $7ff3a560eaebe0ab$var$getExpandedFallbackPlacements(placement) {
    if ((0, $cD9Qn.default)(placement) === (0, $gmzJC.auto)) return [];
    var oppositePlacement = (0, $dFyKe.default)(placement);
    return [
        (0, $fgbdT.default)(placement),
        oppositePlacement,
        (0, $fgbdT.default)(oppositePlacement)
    ];
}
function $7ff3a560eaebe0ab$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $cD9Qn.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $dFyKe.default)(preferredPlacement)
    ] : $7ff3a560eaebe0ab$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $cD9Qn.default)(placement) === (0, $gmzJC.auto) ? (0, $2zbdh.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $cD9Qn.default)(placement);
        var isStartVariation = (0, $7DXzr.default)(placement) === (0, $gmzJC.start);
        var isVertical = [
            (0, $gmzJC.top),
            (0, $gmzJC.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $7zecR.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $gmzJC.right) : (0, $gmzJC.left) : isStartVariation ? (0, $gmzJC.bottom) : (0, $gmzJC.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $dFyKe.default)(mainVariationSide);
        var altVariationSide = (0, $dFyKe.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7ff3a560eaebe0ab$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7ff3a560eaebe0ab$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("dFyKe", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f3a0e480a7d0300$export$2e2bcd8739ae039);
var $9f3a0e480a7d0300$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $9f3a0e480a7d0300$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $9f3a0e480a7d0300$var$hash[matched];
    });
}

});

parcelRegister("fgbdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c10e5203dc5609$export$2e2bcd8739ae039);
var $b1c10e5203dc5609$var$hash = {
    start: 'end',
    end: 'start'
};
function $b1c10e5203dc5609$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b1c10e5203dc5609$var$hash[matched];
    });
}

});

parcelRegister("7zecR", function(module, exports) {
$parcel$export(module.exports, "default", () => $5826d267cd2a6085$export$2e2bcd8739ae039);

var $7YgMj = parcelRequire("7YgMj");

var $arACa = parcelRequire("arACa");

var $cgk7E = parcelRequire("cgk7E");

var $5K0wj = parcelRequire("5K0wj");

var $2oKUn = parcelRequire("2oKUn");

var $gmzJC = parcelRequire("gmzJC");

var $lep1e = parcelRequire("lep1e");

var $1wqhl = parcelRequire("1wqhl");

var $8aifQ = parcelRequire("8aifQ");
function $5826d267cd2a6085$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $gmzJC.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $gmzJC.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $gmzJC.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $1wqhl.default)(typeof padding !== 'number' ? padding : (0, $8aifQ.default)(padding, (0, $gmzJC.basePlacements)));
    var altContext = elementContext === (0, $gmzJC.popper) ? (0, $gmzJC.reference) : (0, $gmzJC.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7YgMj.default)((0, $lep1e.isElement)(element) ? element : element.contextElement || (0, $arACa.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $cgk7E.default)(state.elements.reference);
    var popperOffsets = (0, $5K0wj.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2oKUn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $gmzJC.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $gmzJC.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $gmzJC.right),
                (0, $gmzJC.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $gmzJC.top),
                (0, $gmzJC.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("7YgMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cdb26ca80890f76$export$2e2bcd8739ae039);

var $gmzJC = parcelRequire("gmzJC");

var $5Qcg0 = parcelRequire("5Qcg0");

var $bj39P = parcelRequire("bj39P");

var $4lgVg = parcelRequire("4lgVg");

var $3Og5Y = parcelRequire("3Og5Y");

var $arACa = parcelRequire("arACa");

var $dH6Cg = parcelRequire("dH6Cg");

var $lep1e = parcelRequire("lep1e");

var $cgk7E = parcelRequire("cgk7E");

var $gOu1x = parcelRequire("gOu1x");

var $aj94W = parcelRequire("aj94W");

var $2iDvz = parcelRequire("2iDvz");

var $2oKUn = parcelRequire("2oKUn");

var $eZzhS = parcelRequire("eZzhS");
function $5cdb26ca80890f76$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $cgk7E.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5cdb26ca80890f76$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $gmzJC.viewport) ? (0, $2oKUn.default)((0, $5Qcg0.default)(element, strategy)) : (0, $lep1e.isElement)(clippingParent) ? $5cdb26ca80890f76$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2oKUn.default)((0, $bj39P.default)((0, $arACa.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5cdb26ca80890f76$var$getClippingParents(element) {
    var clippingParents = (0, $4lgVg.default)((0, $gOu1x.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $dH6Cg.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $lep1e.isHTMLElement)(element) ? (0, $3Og5Y.default)(element) : element;
    if (!(0, $lep1e.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $lep1e.isElement)(clippingParent) && (0, $aj94W.default)(clippingParent, clipperElement) && (0, $2iDvz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5cdb26ca80890f76$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $5cdb26ca80890f76$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5cdb26ca80890f76$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $eZzhS.max)(rect.top, accRect.top);
        accRect.right = (0, $eZzhS.min)(rect.right, accRect.right);
        accRect.bottom = (0, $eZzhS.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $eZzhS.max)(rect.left, accRect.left);
        return accRect;
    }, $5cdb26ca80890f76$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("5Qcg0", function(module, exports) {
$parcel$export(module.exports, "default", () => $440b511c065aa566$export$2e2bcd8739ae039);

var $az4qA = parcelRequire("az4qA");

var $arACa = parcelRequire("arACa");

var $jHjey = parcelRequire("jHjey");

var $2Plfy = parcelRequire("2Plfy");
function $440b511c065aa566$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $az4qA.default)(element);
    var html = (0, $arACa.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2Plfy.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $jHjey.default)(element),
        y: y
    };
}

});

parcelRegister("bj39P", function(module, exports) {
$parcel$export(module.exports, "default", () => $83b3eb12e4db16e1$export$2e2bcd8739ae039);

var $arACa = parcelRequire("arACa");

var $dH6Cg = parcelRequire("dH6Cg");

var $jHjey = parcelRequire("jHjey");

var $87Ks4 = parcelRequire("87Ks4");

var $eZzhS = parcelRequire("eZzhS");
function $83b3eb12e4db16e1$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $arACa.default)(element);
    var winScroll = (0, $87Ks4.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $eZzhS.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $eZzhS.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $jHjey.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $dH6Cg.default)(body || html).direction === 'rtl') x += (0, $eZzhS.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("aj94W", function(module, exports) {
$parcel$export(module.exports, "default", () => $7812b88c1b2641c7$export$2e2bcd8739ae039);

var $lep1e = parcelRequire("lep1e");
function $7812b88c1b2641c7$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $lep1e.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("2oKUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bf235ad7597e92a$export$2e2bcd8739ae039);
function $1bf235ad7597e92a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("1wqhl", function(module, exports) {
$parcel$export(module.exports, "default", () => $11bd2a064c5f37ff$export$2e2bcd8739ae039);

var $4NrMi = parcelRequire("4NrMi");
function $11bd2a064c5f37ff$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4NrMi.default)(), paddingObject);
}

});
parcelRegister("4NrMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $37e149231d6c4c66$export$2e2bcd8739ae039);
function $37e149231d6c4c66$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("8aifQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f1d6adebb61d64b$export$2e2bcd8739ae039);
function $5f1d6adebb61d64b$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("2zbdh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1de78c5c4b57914a$export$2e2bcd8739ae039);

var $7DXzr = parcelRequire("7DXzr");

var $gmzJC = parcelRequire("gmzJC");

var $7zecR = parcelRequire("7zecR");

var $cD9Qn = parcelRequire("cD9Qn");
function $1de78c5c4b57914a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $gmzJC.placements) : _options$allowedAutoP;
    var variation = (0, $7DXzr.default)(placement);
    var placements = variation ? flipVariations ? (0, $gmzJC.variationPlacements) : (0, $gmzJC.variationPlacements).filter(function(placement) {
        return (0, $7DXzr.default)(placement) === variation;
    }) : (0, $gmzJC.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $7zecR.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $cD9Qn.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fj0qN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b248f702ada0d63a$export$2e2bcd8739ae039);

var $gmzJC = parcelRequire("gmzJC");

var $cD9Qn = parcelRequire("cD9Qn");

var $70qAV = parcelRequire("70qAV");

var $ce8KU = parcelRequire("ce8KU");

var $e45ME = parcelRequire("e45ME");

var $aLg0M = parcelRequire("aLg0M");

var $3Og5Y = parcelRequire("3Og5Y");

var $7zecR = parcelRequire("7zecR");

var $7DXzr = parcelRequire("7DXzr");

var $4NrMi = parcelRequire("4NrMi");

var $eZzhS = parcelRequire("eZzhS");
function $b248f702ada0d63a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $7zecR.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $cD9Qn.default)(state.placement);
    var variation = (0, $7DXzr.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $70qAV.default)(basePlacement);
    var altAxis = (0, $ce8KU.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $gmzJC.top) : (0, $gmzJC.left);
        var altSide = mainAxis === 'y' ? (0, $gmzJC.bottom) : (0, $gmzJC.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $gmzJC.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $gmzJC.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $aLg0M.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $4NrMi.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $e45ME.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3Og5Y.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $e45ME.within)(tether ? (0, $eZzhS.min)(min, tetherMin) : min, offset, tether ? (0, $eZzhS.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $gmzJC.top) : (0, $gmzJC.left);
        var _altSide = mainAxis === 'x' ? (0, $gmzJC.bottom) : (0, $gmzJC.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $gmzJC.top),
            (0, $gmzJC.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $e45ME.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $e45ME.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b248f702ada0d63a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $b248f702ada0d63a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("ce8KU", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e6d958028d4e412$export$2e2bcd8739ae039);
function $8e6d958028d4e412$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("e45ME", function(module, exports) {
$parcel$export(module.exports, "within", () => $a3d5ecea19044840$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $a3d5ecea19044840$export$86c8af6d3ef0b4a);

var $eZzhS = parcelRequire("eZzhS");
function $a3d5ecea19044840$export$f28d906d67a997f3(min, value, max) {
    return (0, $eZzhS.max)(min, (0, $eZzhS.min)(value, max));
}
function $a3d5ecea19044840$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $a3d5ecea19044840$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("e0eer", function(module, exports) {
$parcel$export(module.exports, "default", () => $a31c1aea711776ee$export$2e2bcd8739ae039);

var $cD9Qn = parcelRequire("cD9Qn");

var $aLg0M = parcelRequire("aLg0M");

var $aj94W = parcelRequire("aj94W");

var $3Og5Y = parcelRequire("3Og5Y");

var $70qAV = parcelRequire("70qAV");

var $e45ME = parcelRequire("e45ME");

var $1wqhl = parcelRequire("1wqhl");

var $8aifQ = parcelRequire("8aifQ");

var $gmzJC = parcelRequire("gmzJC");
var $a31c1aea711776ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $1wqhl.default)(typeof padding !== 'number' ? padding : (0, $8aifQ.default)(padding, (0, $gmzJC.basePlacements)));
};
function $a31c1aea711776ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $cD9Qn.default)(state.placement);
    var axis = (0, $70qAV.default)(basePlacement);
    var isVertical = [
        (0, $gmzJC.left),
        (0, $gmzJC.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $a31c1aea711776ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $aLg0M.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $gmzJC.top) : (0, $gmzJC.left);
    var maxProp = axis === 'y' ? (0, $gmzJC.bottom) : (0, $gmzJC.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3Og5Y.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $e45ME.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $a31c1aea711776ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $aj94W.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $a31c1aea711776ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $a31c1aea711776ee$var$arrow,
    effect: $a31c1aea711776ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("7DjFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $58eb6dfd9292ef0a$export$2e2bcd8739ae039);

var $gmzJC = parcelRequire("gmzJC");

var $7zecR = parcelRequire("7zecR");
function $58eb6dfd9292ef0a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $58eb6dfd9292ef0a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $gmzJC.top),
        (0, $gmzJC.right),
        (0, $gmzJC.bottom),
        (0, $gmzJC.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $58eb6dfd9292ef0a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $7zecR.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $7zecR.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $58eb6dfd9292ef0a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $58eb6dfd9292ef0a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $58eb6dfd9292ef0a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $58eb6dfd9292ef0a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $58eb6dfd9292ef0a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $58eb6dfd9292ef0a$var$hide
};

});


parcelRegister("l6n8m", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $f5cc1a6bbd03fe52$var$hasElementType = typeof Element !== 'undefined';
var $f5cc1a6bbd03fe52$var$hasMap = typeof Map === 'function';
var $f5cc1a6bbd03fe52$var$hasSet = typeof Set === 'function';
var $f5cc1a6bbd03fe52$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $f5cc1a6bbd03fe52$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$f5cc1a6bbd03fe52$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($f5cc1a6bbd03fe52$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$f5cc1a6bbd03fe52$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($f5cc1a6bbd03fe52$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($f5cc1a6bbd03fe52$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($f5cc1a6bbd03fe52$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$f5cc1a6bbd03fe52$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $f5cc1a6bbd03fe52$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("lkQdL", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $2c95f07af806e11e$export$6d8c2b45c99d6e3f);
function $2c95f07af806e11e$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                var _data$viewport, _data$viewport2, _state$modifiersData;
                const data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = ((_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("8xENs", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $ded92e72353fcd31$export$9802f50720ab826e);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $j5ggC = parcelRequire("j5ggC");

var $GyLDf = parcelRequire("GyLDf");

var $lz1tR = parcelRequire("lz1tR");

var $51q3I = parcelRequire("51q3I");

var $i3E5d = parcelRequire("i3E5d");

var $jPxIN = parcelRequire("jPxIN");

var $32M6G = parcelRequire("32M6G");

var $bpfBi = parcelRequire("bpfBi");

var $8L1DO = parcelRequire("8L1DO");

var $7cM3U = parcelRequire("7cM3U");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $ded92e72353fcd31$var$noopStyle = {};
const $ded92e72353fcd31$var$noopSetRef = (0, $9JZL9.default);
const $ded92e72353fcd31$var$noopUpdate = ()=>Promise.resolve(null);
const $ded92e72353fcd31$var$noopForceUpdate = ()=>({});
const $ded92e72353fcd31$var$noopArrowProps = {
    ref: $ded92e72353fcd31$var$noopSetRef,
    style: $ded92e72353fcd31$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $ded92e72353fcd31$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * SSR-safe `instanceof HTMLElement`. This runs during render, and the server
 * has no `HTMLElement` global. No hydration mismatch: refs are unset on the
 * server and on the first client render, so both sides get the same result.
 */ function $ded92e72353fcd31$var$isHTMLElement(value) {
    return typeof HTMLElement !== 'undefined' && value instanceof HTMLElement;
}
function $ded92e72353fcd31$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $8L1DO.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes are anchored by `useAnchoredPopover`; popper
    // `VirtualElement`s go to `useAnchoredPopoverAtPoint`, which owns a synthetic
    // anchor element in `document.body`.
    const htmlAnchor = $ded92e72353fcd31$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !$ded92e72353fcd31$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const htmlAnchorRef = (0, $fc4bM.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $fc4bM.useRef)(null);
    const popoverId = (0, $i3E5d.usePopoverId)();
    // Track the resolved DOM anchor in state so the visibility hook re-runs when
    // its identity changes. Virtual anchors do not feed that hook, because their
    // probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $fc4bM.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $fc4bM.useMemo)(()=>{
        return (0, $j5ggC.fromLegacyPlacement)({
            legacy: (0, $bpfBi.toLegacyPlacement)(placement),
            offset: $ded92e72353fcd31$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // Refs, because `getPoint` is LATCHED: called once per activation, so a
    // closed-over value would go stale if either prop changed while it stayed open.
    const virtualReferenceRef = (0, $fc4bM.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $fc4bM.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    // Two positioning hooks, at most one enabled: `htmlAnchor` and
    // `virtualReference` both derive from `effectiveReference`, so they are never
    // both set, and when neither is the popover is closed.
    const isElementAnchored = htmlAnchor !== null;
    const isPointAnchored = virtualReference !== null;
    // Passed as one object so the element and point calls cannot drift.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        inlineSize: shouldFitViewport ? 'max-available' : 'content',
        blockSize: shouldFitViewport ? 'max-available' : 'content'
    };
    (0, $lz1tR.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: htmlAnchorRef,
        isEnabled: isElementAnchored
    });
    (0, $51q3I.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isPointAnchored,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $32M6G.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $jPxIN.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $7cM3U.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $ded92e72353fcd31$var$noopSetRef,
        style: $ded92e72353fcd31$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $ded92e72353fcd31$var$noopUpdate,
        forceUpdate: $ded92e72353fcd31$var$noopForceUpdate,
        arrowProps: $ded92e72353fcd31$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // Rendered directly into the `<Popover>` host, which supplies the flex
    // formatting context the size caps need — so the render prop must return ONE
    // element. See `children` in `@atlaskit/top-layer`'s `popover/types.tsx`.
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}

});
parcelRegister("j5ggC", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $cd25e20d5b394904$export$69e99ed50b2534c9);

var $aYXOe = parcelRequire("aYXOe");
function $cd25e20d5b394904$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $aYXOe.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // `direction` holds the sign and `value` holds the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("aYXOe", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $a145e9033e32d661$export$27df359c528b7120);
const $a145e9033e32d661$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("GyLDf", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $dd44d72f5bc981d9$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ /* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $jdt4T = parcelRequire("jdt4T");

var $6Zi52 = parcelRequire("6Zi52");

var $4dCfH = parcelRequire("4dCfH");

var $g68k0 = parcelRequire("g68k0");

var $9kfe7 = parcelRequire("9kfe7");

var $kRn6p = parcelRequire("kRn6p");

var $5rfGa = parcelRequire("5rfGa");

var $XXDGK = parcelRequire("XXDGK");

var $izfOd = parcelRequire("izfOd");

var $TvYCN = parcelRequire("TvYCN");

var $8txjc = parcelRequire("8txjc");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $dd44d72f5bc981d9$var$restoreFocus({ popover: popover, focusRestorationTarget: focusRestorationTarget }) {
    if (!focusRestorationTarget) return;
    const { ownerDocument: ownerDocument } = popover;
    // Native restoration has finished. Preserve focus moved outside the popover.
    const activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $dd44d72f5bc981d9$var$supportsPopoverHint = (0, $g68k0.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
/**
 * **Surface reset**
 *
 * The host is still a DOM child of its trigger for inheritance, so it inherits
 * values like `pointer-events: none` or `white-space: nowrap`. Resets them to
 * what `<body>` gave the portal path. `font` and direction still inherit.
 * Not `all: initial`: that would also override the UA `[popover]` rules.
 *
 * `color` is a reset too: the UA `[popover]` rule sets `color: CanvasText`, so
 * the host never inherits a colour. `color.text` is what `<body>` gave the portal
 * path. Not `inherit`, which would take the trigger's colour (for example a link).
 * See `notes/decisions/surface-reset-color.md`.
 *
 * KEEP IN SYNC with `dialog/dialog-content.tsx` (ADS forbids shared styles).
 * The `satisfies` check below catches drift.
 */ const $dd44d72f5bc981d9$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $dd44d72f5bc981d9$var$styles = {
    root: "_lzhqglyw _az2pidpf _13shidpf _1mjeidpf _byz4idpf _b2a9idpf _z3e7idpf _1aqridpf _1ap0idpf _1vdi1wug _wmifewfl _1blzewfl _1rec1j28 _kqwmvrvc _1maw1q9c _17ke4jg8 _1ogd4jg8 _1dqv1n9t _qctn1ns9 _1rmr1wug _1yd01wug _li0iglyw _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1p7w1txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $dd44d72f5bc981d9$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
const $dd44d72f5bc981d9$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, initialFocusRef: initialFocusRef, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $fc4bM.useId)();
    const ownRef = (0, $fc4bM.useRef)(null);
    const combinedRef = (0, $4dCfH.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    const onCloseRef = (0, $fc4bM.useRef)(onClose);
    (0, $9kfe7.useLayoutEffect)(()=>{
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // A popover with `onClose` is closable (see `closable-popover-contract`).
    // `requestClosePopovers()` asks it to close; the consumer decides.
    const isClosable = Boolean(onClose);
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$dd44d72f5bc981d9$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $fc4bM.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $XXDGK.resolvePlacement)({
            placement: placement
        });
        return $dd44d72f5bc981d9$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    const closeReasonRef = (0, $fc4bM.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    const focusRestorationTargetRef = (0, $fc4bM.useRef)(null);
    const handleBeforeToggle = (0, $fc4bM.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const { ownerDocument: ownerDocument } = popover;
        const { activeElement: activeElement } = ownerDocument;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    const handleToggleClosed = (0, $fc4bM.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        const reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $dd44d72f5bc981d9$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current;
            (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $izfOd.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Focus management: Tab cycling for dialog roles. Initial focus is below
    // the show/hide layout effect. Restoration is native for outermost
    // popovers; nested popovers are handled above via the `beforetoggle`
    // snapshot. Passing `phase` keeps `useFocusWrap` attached through the
    // animated-exit window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $TvYCN.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $9kfe7.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $6Zi52.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $5rfGa.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $6Zi52.bind)(element, {
            type: 'toggle',
            listener: (event)=>{
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        const unbindBeforeToggle = (0, $6Zi52.bind)(element, {
            type: 'beforetoggle',
            listener: (event)=>{
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        // `requestClosePopovers()` asks the consumer to close. Nothing is
        // hidden here, so a consumer that keeps `isOpen` stays in sync.
        const unbindRequestClose = (0, $6Zi52.bind)(element, {
            type: (0, $kRn6p.requestCloseEventName),
            listener: ()=>{
                var _onCloseRef$current2;
                (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                    reason: 'programmatic'
                });
            }
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
            unbindRequestClose();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $9kfe7.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Initial focus (role-dependent) is a layout effect, so it must come AFTER
    // the show/hide layout effect above: React runs layout effects in source
    // order, and focus only works once `showPopover()` has run. Focus then
    // lands in the same task as the open, before the browser paints.
    (0, $8txjc.useInitialFocus)({
        elementRef: ownRef,
        isEnabled: !UNSAFE__disableInitialAutoFocus,
        initialFocusRef: initialFocusRef,
        phase: phase,
        role: role
    });
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        // Keep in sync with `closablePopoverAttribute` (internal/closable-popover-contract).
        "data-top-layer-closable": isClosable ? '' : undefined,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $dd44d72f5bc981d9$var$styles.root,
            $dd44d72f5bc981d9$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $dd44d72f5bc981d9$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $dd44d72f5bc981d9$var$styles.exit,
            shouldAnimate && $dd44d72f5bc981d9$var$styles.motion,
            (0, $jdt4T.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("jdt4T", function(module, exports) {
$parcel$export(module.exports, "cx", () => $dfd5c97790b4fd9b$export$a274e22fb40f762e);

var $2R2iS = parcelRequire("2R2iS");
const $dfd5c97790b4fd9b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $2R2iS.default)(actualStyles);
};

});

parcelRegister("g68k0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6386720c615520b8$export$2e2bcd8739ae039);
function $6386720c615520b8$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("9kfe7", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $faf847a3ebb8cf31$export$e5c5a5f917a5871c);

var $fc4bM = parcelRequire("fc4bM");
const $faf847a3ebb8cf31$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);

});

parcelRegister("kRn6p", function(module, exports) {
$parcel$export(module.exports, "closablePopoverAttribute", () => $9de14a23d6f3ade1$export$c6890d80f1a52941);
$parcel$export(module.exports, "requestCloseEventName", () => $9de14a23d6f3ade1$export$17ed9502ee8e92da);
/**
 * `Popover` sets this attribute on its host element when it has an `onClose`. Only those popovers
 * can be asked to close, so `hasOpenDialogOrPopover` counts only those and `requestClosePopovers`
 * asks only those. Outside code cannot dismiss a popover without `onClose` (for example the flag
 * group or a spotlight), so both skip it.
 *
 * `Popover` writes the attribute name as a literal JSX prop. Keep the two in sync.
 */ const $9de14a23d6f3ade1$export$c6890d80f1a52941 = 'data-top-layer-closable';
const $9de14a23d6f3ade1$export$17ed9502ee8e92da = 'top-layer-request-close';

});

parcelRegister("5rfGa", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $71e7a6e4a84334e7$export$89b923e18c14644d);
/**
 * `true` when `element` is open in the DOM: an open `<dialog>`, or a popover that matches
 * `:popover-open`. This is the browser state, not the `isOpen` prop.
 */ function $71e7a6e4a84334e7$export$89b923e18c14644d({ element: element }) {
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw on `:popover-open`.
    try {
        return element.matches(':popover-open');
    } catch  {
        return false;
    }
}

});

parcelRegister("XXDGK", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $3ce814677e9fe06e$export$63044d21bc3d3fa2);

var $i7MKf = parcelRequire("i7MKf");
/**
 * The gap between the anchor and the popover when `placement.offset.gap` is not
 * set. A design token (`space.100`), so it follows the spacing scale.
 */ const $3ce814677e9fe06e$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $3ce814677e9fe06e$export$63044d21bc3d3fa2({ placement: placement }) {
    var _placement$offset, _placement$offset2, _placement$offset3;
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        // No `??` default: `undefined` must survive, so "not set" stays different
        // from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $i7MKf.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $i7MKf.toCssLengthString)({
                value: ((_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) ?? $3ce814677e9fe06e$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $i7MKf.toCssLengthString)({
                    value: ((_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) ?? 0
                }),
                direction: ((_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("i7MKf", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $da32391e550fddf9$export$63b6b0ff65d84d47);
/**
 * Converts a length to a CSS length string. A number becomes `${value}px`, and a
 * string passes through unchanged. Apply at the API boundary, so internal code
 * only deals with strings.
 */ function $da32391e550fddf9$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("izfOd", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $44b264d7cbbe8d49$export$1bccb45daf07907f);

var $fc4bM = parcelRequire("fc4bM");

var $9kfe7 = parcelRequire("9kfe7");

var $5rfGa = parcelRequire("5rfGa");

var $gDajN = parcelRequire("gDajN");
/**
 * Calls `schedule` with a `settle` callback, and `settle` calls `onSettled`.
 * The returned cleanup makes `settle` do nothing, so an interrupted or
 * unmounted lifecycle cannot call a stale `onSettled`.
 */ function $44b264d7cbbe8d49$var$runCancellableSettlement({ schedule: schedule, onSettled: onSettled }) {
    let isCancelled = false;
    schedule(()=>{
        if (isCancelled) return;
        onSettled();
    });
    return ()=>{
        isCancelled = true;
    };
}
/**
 * Calls `onSettled` when all animations on `element` at the time of the call
 * finish or are cancelled. With no animations, it settles in a promise
 * microtask. Returns a cleanup that stops a stale `onSettled` call.
 */ function $44b264d7cbbe8d49$var$runOnAnimationsSettled({ element: element, onSettled: onSettled }) {
    return $44b264d7cbbe8d49$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: (settle)=>{
            var _element$getAnimation;
            // Some environments, such as jsdom, do not implement `getAnimations`.
            const animations = ((_element$getAnimation = element.getAnimations) === null || _element$getAnimation === void 0 ? void 0 : _element$getAnimation.call(element)) ?? [];
            Promise.allSettled(animations.map((animation)=>animation.finished)).then(settle);
        }
    });
}
function $44b264d7cbbe8d49$var$getInitialVisibilityState({ isOpen: isOpen, willAnimate: willAnimate }) {
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility state.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $44b264d7cbbe8d49$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        const shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return {
            ...state,
            controlledIntent: 'open'
        };
    }
    if (action.type === 'close-requested') return {
        ...state,
        controlledIntent: 'closed'
    };
    if (action.type === 'native-close-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'exiting'
        };
    }
    // A browser dismiss started the exit while controlled intent stayed open, and
    // the element was shown natively again before the exit settled. For example,
    // `@atlaskit/tooltip` calls `showPopover()` on `pointerup`, in the same task as
    // the light dismiss of a press. The element never painted closed, so go back
    // to `open`. See `notes/decisions/tooltip-stay-open-on-trigger-click.md`.
    if (action.type === 'native-open-started') {
        if (state.phase !== 'exiting' || state.controlledIntent !== 'open') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return {
            ...state,
            phase: 'closed'
        };
    }
    return state;
}
function $44b264d7cbbe8d49$export$1bccb45daf07907f({ isOpen: isOpen, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $gDajN.prefersReducedMotion)();
    const [visibilityState, dispatch] = (0, $fc4bM.useReducer)($44b264d7cbbe8d49$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $44b264d7cbbe8d49$var$getInitialVisibilityState);
    const { phase: phase, controlledIntent: controlledIntent } = visibilityState;
    // Refs hold the latest callbacks and `willAnimate`, so the stable callbacks, effects
    // and settlement closures read current values without them in dependency arrays.
    const onEnterFinishRef = (0, $fc4bM.useRef)(onEnterFinish);
    const onExitFinishRef = (0, $fc4bM.useRef)(onExitFinish);
    const willAnimateRef = (0, $fc4bM.useRef)(willAnimate);
    (0, $9kfe7.useLayoutEffect)(()=>{
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Call `onEnterFinish` after the `open` commit, so consumers observe the
    // settled host and not its entering styles. Entry can wait for the commit
    // because the host stays mounted. The previous phase starts as `closed`, so
    // a host that is open on mount also calls `onEnterFinish`.
    const previousPhaseRef = (0, $fc4bM.useRef)('closed');
    (0, $fc4bM.useEffect)(()=>{
        const previousPhase = previousPhaseRef.current;
        previousPhaseRef.current = phase;
        if (previousPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    const isMounted = phase !== 'closed';
    const cancelExitSettlementRef = (0, $fc4bM.useRef)(()=>{});
    // Exit must notify consumers before `closed` unmounts the host.
    const settleExit = (0, $fc4bM.useCallback)(()=>{
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    const onBeforeToggle = (0, $fc4bM.useCallback)((event)=>{
        // Any native toggle cancels a pending exit settlement, so a stale
        // settlement cannot close a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot `currentTarget`, because the DOM clears it after event dispatch.
        const element = event.currentTarget;
        if (event.newState === 'open') {
            // Undo the `inert` and `aria-hidden` that a previous close added.
            if (element instanceof HTMLElement) {
                element.removeAttribute('inert');
                element.removeAttribute('aria-hidden');
            }
            // Dispatched on every native open. The reducer only acts when a browser
            // dismiss left the host `exiting` while `isOpen` stayed `true`.
            dispatch({
                type: 'native-open-started'
            });
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // Wait a microtask so native focus restoration runs before the host
            // becomes inert. The browser restores focus after `beforetoggle`
            // returns, during its close steps.
            queueMicrotask(()=>{
                // A controlled close can be interrupted by `isOpen` changing back to
                // `true`, which reopens the element before this microtask runs.
                if ((0, $5rfGa.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep the closed host rendered, so make it
                // non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even
                // though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'native-close-started'
            });
        }
    }, []);
    const onToggle = (0, $fc4bM.useCallback)((event)=>{
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $44b264d7cbbe8d49$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after the synchronous `beforetoggle`.
        // By now the `exiting` styles have committed, so the snapshot holds the
        // animations that decide when the exit settles.
        cancelExitSettlementRef.current = $44b264d7cbbe8d49$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $9kfe7.useLayoutEffect)(()=>()=>{
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        }, []);
    // Entry settlement moves the phase to `open`, which removes the entering
    // styles. The effect above then calls `onEnterFinish`.
    (0, $fc4bM.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        // Animation was disabled during entry, so settle now.
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        return $44b264d7cbbe8d49$var$runOnAnimationsSettled({
            element: element,
            onSettled () {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("gDajN", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $3cbb8329f99f9369$export$ff7706047246b98b);

var $g68k0 = parcelRequire("g68k0");
const $3cbb8329f99f9369$export$ff7706047246b98b = (0, $g68k0.default)(function getPrefersReducedMotion() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("TvYCN", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $66f4343d577a404e$export$4f6462e86a70abe5);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $1jBJ5 = parcelRequire("1jBJ5");

var $6nKyR = parcelRequire("6nKyR");

var $ac55F = parcelRequire("ac55F");

var $ZFkkZ = parcelRequire("ZFkkZ");
/**
 * Returns `true` for the roles that wrap Tab focus, per the WAI-ARIA APG:
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as `dialog`
 *
 * `menu` is not included. A menu is a composite widget
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within):
 * arrow keys move focus inside it, and Tab moves focus out of it.
 *
 * Menu keyboard behavior (arrow keys, Home and End, type-ahead, Enter and
 * Space) changes with orientation, nesting, item type and control pattern
 * (menu button or menubar), so this hook cannot do it for all menus. The
 * consumer (for example `dropdown-menu`) owns it.
 *
 * See `notes/decisions/menu-keyboard.md`.
 */ function $66f4343d577a404e$var$roleRequiresFocusWrap({ role: role }) {
    return role === 'dialog' || role === 'alertdialog';
}
function $66f4343d577a404e$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $fc4bM.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$66f4343d577a404e$var$roleRequiresFocusWrap({
            role: role
        }) || !isVisible) return;
        const unbind = (0, $6Zi52.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // While focus is in a nested layer, that layer handles Tab.
                if ((0, $ZFkkZ.isNestedLayerFocused)({
                    container: element
                })) return;
                // Stop the browser focus move. This hook moves focus itself.
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                const nextFocusable = (0, $ac55F.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (nextFocusable) {
                    nextFocusable.focus();
                    return;
                }
                // Focus is not inside the element, or the element has no focusable
                // elements. Move focus to the first or last focusable element, based
                // on the direction.
                const fallback = direction === 'forwards' ? (0, $1jBJ5.getFirstFocusable)({
                    container: element
                }) : (0, $6nKyR.getLastFocusable)({
                    container: element
                });
                fallback === null || fallback === void 0 || fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("1jBJ5", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $ec8d9e3a9d42d5ab$export$748138f04a69bf21);

var $1Lo1K = parcelRequire("1Lo1K");
function $ec8d9e3a9d42d5ab$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $1Lo1K.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("1Lo1K", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $441a89e148dbd09a$export$f6768025e418420e);

var $axgQR = parcelRequire("axgQR");
const $441a89e148dbd09a$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
const $441a89e148dbd09a$var$exclusionSelector = $441a89e148dbd09a$var$focusableExclusions.map((selector)=>`:not(${selector})`).join('');
const $441a89e148dbd09a$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map((selector)=>`${selector}${$441a89e148dbd09a$var$exclusionSelector}`).join(',');
function $441a89e148dbd09a$var$isVisible({ element: element }) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch  {
        return true;
    }
}
function $441a89e148dbd09a$export$f6768025e418420e({ container: container, filter: filter }) {
    const containerLayer = (0, $axgQR.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($441a89e148dbd09a$var$focusableSelector)).filter((element)=>{
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $axgQR.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$441a89e148dbd09a$var$isVisible({
            element: element
        })) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("axgQR", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $0544f5dd32d22f05$export$3c9385904be131db);
/**
 * Returns the closest `[popover]` or `<dialog>` element, starting at `element`
 * itself. Returns `null` when the element is not in a layer.
 */ function $0544f5dd32d22f05$export$3c9385904be131db({ element: element }) {
    return element.closest('[popover], dialog');
}

});



parcelRegister("6nKyR", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $22005cfff7616df9$export$73e81fa65335a75b);

var $1Lo1K = parcelRequire("1Lo1K");
function $22005cfff7616df9$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $1Lo1K.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("ac55F", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $8aea70b5e3197f4d$export$a7db88e6d491b450);

var $1Lo1K = parcelRequire("1Lo1K");
function $8aea70b5e3197f4d$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const focusables = (0, $1Lo1K.getFocusables)({
        container: container,
        filter: filter
    });
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    // `container` has no focusable elements.
    if (!first || !last) return null;
    const focusedElement = container.ownerDocument.activeElement;
    if (!(focusedElement instanceof HTMLElement) || !container.contains(focusedElement)) return null;
    const focusedIndex = focusables.indexOf(focusedElement);
    // The focused element is not in `focusables` when it is not tabbable, or
    // when `filter` excludes it. Find the first focusable element after it in
    // the DOM. That element, and the one before it in `focusables`, are the
    // closest focusable elements in each direction.
    if (focusedIndex === -1) {
        const followingIndex = focusables.findIndex((element)=>Boolean(focusedElement.compareDocumentPosition(element) & focusedElement.DOCUMENT_POSITION_FOLLOWING));
        if (direction === 'forwards') // If nothing follows the focused element, wrap to the start.
        return focusables[followingIndex] ?? first;
        // Use `last` when there is no entry before the following element. Either
        // nothing precedes the focused element (wrap to the end), or nothing
        // follows it (`last` is the closest preceding element).
        return focusables[followingIndex - 1] ?? last;
    }
    // The focused element is in `focusables`, so use the adjacent entry. Wrap
    // when the focused element is at either end.
    if (direction === 'forwards') return focusables[focusedIndex + 1] ?? first;
    return focusables[focusedIndex - 1] ?? last;
}

});

parcelRegister("ZFkkZ", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $e178d10251eb3fbd$export$b9590fdfeb5f722f);

var $axgQR = parcelRequire("axgQR");
function $e178d10251eb3fbd$export$b9590fdfeb5f722f({ container: container }) {
    const focusedElement = container.ownerDocument.activeElement;
    if (!(focusedElement instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focusedElement)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $axgQR.getClosestLayer)({
        element: focusedElement
    }) !== (0, $axgQR.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("8txjc", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $0d4137518bae92a6$export$e992c40175757a22);

var $fc4bM = parcelRequire("fc4bM");

var $9kfe7 = parcelRequire("9kfe7");

var $hjfZU = parcelRequire("hjfZU");
function $0d4137518bae92a6$export$e992c40175757a22({ elementRef: elementRef, isEnabled: isEnabled, initialFocusRef: initialFocusRef, phase: phase, role: role }) {
    const prevPhaseRef = (0, $fc4bM.useRef)('closed');
    (0, $9kfe7.useLayoutEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (!isEnabled || phase === 'closed' || prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (element) (0, $hjfZU.applyInitialFocus)({
            container: element,
            initialFocusRef: initialFocusRef,
            role: role
        });
    }, [
        elementRef,
        initialFocusRef,
        isEnabled,
        phase,
        role
    ]);
}

});
parcelRegister("hjfZU", function(module, exports) {
$parcel$export(module.exports, "applyInitialFocus", () => $c0e58fe5aa80878d$export$d1972957354b5ad6);

var $i1mZJ = parcelRequire("i1mZJ");
function $c0e58fe5aa80878d$export$d1972957354b5ad6({ container: container, initialFocusRef: initialFocusRef, role: role }) {
    const target = (0, $i1mZJ.getInitialFocusTarget)({
        container: container,
        initialFocusRef: initialFocusRef,
        role: role
    });
    if (!target) return {
        applied: false,
        target: null
    };
    target.focus();
    return {
        applied: true,
        target: target
    };
}

});
parcelRegister("i1mZJ", function(module, exports) {
$parcel$export(module.exports, "getInitialFocusTarget", () => $b44f14c2d9234afd$export$2e85eb60457252d6);

var $1jBJ5 = parcelRequire("1jBJ5");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox. This applies to `menu`, `listbox`, and to
 * `dialog` / `alertdialog` when the combobox is outside the dialog. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, menu, or dialog), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $b44f14c2d9234afd$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $b44f14c2d9234afd$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $b44f14c2d9234afd$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $b44f14c2d9234afd$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$b44f14c2d9234afd$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
/**
 * The `initialFocusRef` override target, when it is inside the popover. A
 * target outside the popover (or not in the DOM) is ignored, so the role
 * default applies.
 */ function $b44f14c2d9234afd$var$getOverrideTarget({ container: container, initialFocusRef: initialFocusRef }) {
    const target = initialFocusRef === null || initialFocusRef === void 0 ? void 0 : initialFocusRef.current;
    if (target && container.contains(target)) return target;
    return null;
}
function $b44f14c2d9234afd$export$2e85eb60457252d6({ container: container, initialFocusRef: initialFocusRef, role: role }) {
    // In each role branch, the combobox carve-out decides whether focus moves.
    // The override target, then the role default, decides where.
    if (role === 'dialog' || role === 'alertdialog') {
        // APG allows a combobox to control a dialog popup. Focus stays on the
        // combobox only when it is OUTSIDE the dialog. A dialog that contains
        // its own combobox still takes focus (see the comment below on why the
        // carve-out is per-role).
        if (!container.contains(container.ownerDocument.activeElement) && $b44f14c2d9234afd$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $b44f14c2d9234afd$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $1jBJ5.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific rather than hoisted.
    // Hoisting it over-matched on dialog popups that contain a nested
    // combobox (e.g. datetime-picker's dialog hosts a react-select), where
    // the active combobox's `aria-controls` falsely matched the container
    // and suppressed the dialog's own focus contract. The dialog branch
    // above therefore skips only for a combobox outside the dialog.
    if (role === 'menu') {
        if ($b44f14c2d9234afd$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $b44f14c2d9234afd$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/decisions/menu-keyboard.md
        return (0, $1jBJ5.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($b44f14c2d9234afd$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $b44f14c2d9234afd$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $1jBJ5.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
} /**
 * Moves focus into a popover element when it opens, based on its ARIA role.
 *
 * Follows the WAI-ARIA APG initial-focus patterns for each role. For the
 * roles that move focus, an `initialFocusRef` target inside the popover
 * comes first:
 * - `dialog` / `alertdialog` → focus first focusable (or `[autofocus]`)
 * - `menu` → focus first menu item
 * - `listbox` → focus selected or first option
 * - `tooltip` / no role → no focus movement (focus must remain on trigger;
 *   moving focus into the tooltip would dismiss it)
 *
 * Role is taken from the typed `role` prop - this is the consumer's contract
 * and is not subject to drift from a directly-mutated DOM attribute.
 *
 * Always call this hook unconditionally. Focus is moved on each transition
 * into a visible phase, the moment the host element first becomes visible
 * for that open intent:
 *
 * - Animated path: on `closed → entering`. The host has just been mounted
 *   and the layout effect that calls `showPopover()` / `showModal()` has
 *   already run, so the element is in the top layer. We focus before the
 *   entry transition settles to match the WAI-ARIA APG expectation that
 *   focus lands on the new menu / dialog the instant it opens, not after
 *   the CSS finishes animating.
 * - Non-animated path: on `closed → open` (the entering phase is skipped).
 * - Reopen mid-exit: on `exiting → entering`. When a user dismisses the
 *   popup (Escape, close button, light dismiss) the browser natively
 *   restores focus to the trigger as part of `hidePopover()` /
 *   `<dialog>.close()`. If the consumer reopens before the exit transition
 *   has settled, the phase machine jumps `exiting → entering` without
 *   passing through `closed`, so without this branch the popup would be
 *   visible again with focus stranded on the trigger - a keyboard usability
 *   gap for menu/dialog/listbox roles.
 *
 * Note: there is a rare programmatic path where a consumer flips `isOpen`
 * false → true without any user-initiated close gesture and had moved focus
 * to a non-default target inside the popup. In that scenario this hook
 * re-focuses the role-appropriate default (e.g. first menu item) rather
 * than preserving the consumer-chosen target. This matches the documented
 * `closed → entering` behavior and is considered acceptable given how
 * abstract the scenario is. See `notes/architecture/focus.md`.
 *
 * Pure `entering → exiting → entering` stutters where the popup never
 * reaches `closed` and the consumer toggles in the same frame are still
 * collapsed: the `prevPhase` ref guard rejects any transition whose
 * previous phase was not `closed` or `exiting`.
 *
 * Runs in a layout effect, so focus lands in the same task as the open,
 * before the browser paints. Call it AFTER the layout effect that calls
 * `showPopover()`: React runs a component's layout effects in source order,
 * and a hidden popover cannot take focus.
 *
 * An `initialFocusRef` target must be set by then: in a ref callback, a
 * child's layout effect, or during render. A child's `useEffect` runs later
 * and its target is missed.
 *
 * If a regression appears that needs a paint before focusing (e.g. browsers
 * that require a layout pass before `focus()` works on a freshly promoted
 * top-layer element), wrap the `focus()` call in a single
 * `requestAnimationFrame` here and re-add a same-element ref check inside
 * the RAF callback.
 */ 

});




parcelRegister("lz1tR", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $f6e4750cca7f92bf$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate, use `useAnchoredPopoverAtPoint`.
 *
 * There are two runtime paths. Each is a function that applies its styles and
 * returns the cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the
 * JavaScript fallback in `./javascript-fallback`. The hook picks the path ONCE,
 * at the top of the effect, and passes it to positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $3zBNx = parcelRequire("3zBNx");

var $9kfe7 = parcelRequire("9kfe7");

var $dr3Yd = parcelRequire("dr3Yd");

var $j20PE = parcelRequire("j20PE");

var $3AhxT = parcelRequire("3AhxT");

var $XXDGK = parcelRequire("XXDGK");

var $kf8kL = parcelRequire("kf8kL");

var $ebSkB = parcelRequire("ebSkB");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to do for every
 * popover.
 */ function $f6e4750cca7f92bf$var$getPopoverWritingMode({ popover: popover }) {
    // `String()` because not every test environment implements `writing-mode`.
    const writingMode = String(getComputedStyle(popover).writingMode);
    const isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $f6e4750cca7f92bf$var$measureAnchorSize({ anchor: anchor, writingMode: writingMode }) {
    if (writingMode === 'vertical') return {
        inline: `${anchor.offsetHeight}px`,
        block: `${anchor.offsetWidth}px`
    };
    return {
        inline: `${anchor.offsetWidth}px`,
        block: `${anchor.offsetHeight}px`
    };
}
const $f6e4750cca7f92bf$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
const $f6e4750cca7f92bf$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
/**
 * The anchor size that the size declarations use:
 *
 * - `NO_ANCHOR_SIZE` when no size rule reads the anchor size.
 * - `CSS_ANCHOR_SIZE` (`anchor-size()` references) when the browser supports them.
 * - Otherwise, the anchor size measured in pixels.
 */ function $f6e4750cca7f92bf$var$getAnchorSize({ anchor: anchor, writingMode: writingMode, needsAnchorSize: needsAnchorSize, canUseAnchorSize: canUseAnchorSize }) {
    if (!needsAnchorSize) return $f6e4750cca7f92bf$var$NO_ANCHOR_SIZE;
    if (canUseAnchorSize) return $f6e4750cca7f92bf$var$CSS_ANCHOR_SIZE;
    return $f6e4750cca7f92bf$var$measureAnchorSize({
        anchor: anchor,
        writingMode: writingMode
    });
}
function $f6e4750cca7f92bf$var$isAnchorRelative({ size: size }) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a
 * CSS `<dashed-ident>`. `useId()` is the same source as every other id in the
 * design system, including the popover's own `id` that `aria-controls` and
 * `popovertarget` point at. So it is unique exactly where those are, and collides
 * exactly where they do. See `useAnchoredPopover` for the one case that needs the
 * host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $f6e4750cca7f92bf$var$useNewAnchorName() {
    const id = (0, $3zBNx.useId)();
    return (0, $fc4bM.useMemo)(()=>`--anchor-${id.replace(/[^A-Za-z0-9_-]/g, '_')}`, [
        id
    ]);
}
/**
 * A referentially stable, fully resolved `TPlacement`, so a new inline
 * `placement` object on each render does not re-run the effect.
 */ function $f6e4750cca7f92bf$var$useStablePlacement({ placement: placement }) {
    const resolved = (0, $XXDGK.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const minSize = resolved.minSize;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $fc4bM.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $f6e4750cca7f92bf$export$147d8888d96bf7a3({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement, isOpen: isOpen, isEnabled: isEnabled = true, inlineSize: inlineSize = 'content', blockSize: blockSize = 'content', shouldPreserveInlineSize: shouldPreserveInlineSize = false, forceFallbackPositioning: forceFallbackPositioning = false }) {
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    const fallbackAnchorName = $f6e4750cca7f92bf$var$useNewAnchorName();
    const stablePlacement = $f6e4750cca7f92bf$var$useStablePlacement({
        placement: placement
    });
    (0, $9kfe7.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        const isUsingCssAnchorPositioning = (0, $kf8kL.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        const canUseAnchorSize = isUsingCssAnchorPositioning && (0, $ebSkB.supportsAnchorSize)();
        const anchor = anchorRef.current;
        const popover = popoverRef.current;
        if (!anchor || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        const writingMode = $f6e4750cca7f92bf$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        const needsAnchorSize = $f6e4750cca7f92bf$var$isAnchorRelative({
            size: inlineSize
        }) || $f6e4750cca7f92bf$var$isAnchorRelative({
            size: blockSize
        }) || isFitting && isUsingCssAnchorPositioning;
        const anchorSize = $f6e4750cca7f92bf$var$getAnchorSize({
            anchor: anchor,
            writingMode: writingMode,
            needsAnchorSize: needsAnchorSize,
            canUseAnchorSize: canUseAnchorSize
        });
        const sizeStyles = (0, $j20PE.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $dr3Yd.applyAnchorPositioning)({
            anchor: anchor,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $3AhxT.applyJavaScriptFallbackPositioning)({
            anchor: anchor,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("dr3Yd", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $b34fa7590bd14a0a$export$50da8074e1408934);
/**
 * The CSS Anchor Positioning path: `position-anchor`, `position-area`,
 * `position-try-fallbacks` and the gap and shift margins, all declared on the
 * popover so the browser owns placement and flipping. The twin of
 * `../javascript-fallback/apply-javascript-fallback-positioning`.
 */ 
var $1qHoh = parcelRequire("1qHoh");

var $hs0cW = parcelRequire("hs0cW");

var $1mUq6 = parcelRequire("1mUq6");

var $bclZv = parcelRequire("bclZv");

var $dA9DU = parcelRequire("dA9DU");

var $5OFUZ = parcelRequire("5OFUZ");

var $kpopp = parcelRequire("kpopp");
function $b34fa7590bd14a0a$export$50da8074e1408934({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles, isFitting: isFitting, fallbackAnchorName: fallbackAnchorName }) {
    // Reuse the existing name rather than write a new one: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    const existingAnchorName = (0, $dA9DU.getExistingAnchorName)({
        element: anchor
    });
    const anchorName = existingAnchorName ?? fallbackAnchorName;
    const gapMargin = (0, $1mUq6.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    const shiftMargins = (0, $hs0cW.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    const popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $5OFUZ.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $kpopp.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * The initial value, `anchors-visible`, lets the browser hide the popover
   * when its anchor is fully clipped by an ancestor (for example a scroll
   * container) or is `visibility: hidden`. This hiding does not close the
   * popover: `:popover-open` still matches, but the popover is not painted and
   * gets no pointer input. Chrome also keeps it focusable and in the
   * accessibility tree, so keyboard and screen reader users can land inside a
   * surface they cannot see.
   *
   * The default is usually fine. It fails when:
   *  - The anchor is hidden on purpose (for example `position: absolute` moves
   *    it outside its parent's clip, or it is `visibility: hidden`).
   *  - The anchor scrolls out of its scroll container while the popover is
   *    open.
   *
   * `always` turns the automatic hiding off. There is no strong reason to keep
   * the default. If one comes up, this could become configurable. Per-engine
   * behaviour: `notes/decisions/position-visibility-always.md`.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset the UA popover styles (`inset: 0; margin: auto`), which conflict
        // with anchor positioning.
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gapMargin,
        // When fitting, the shift margins come back COMPOSED with the reserved
        // viewport padding, rather than being written twice.
        ...isFitting ? (0, $bclZv.getFitMarginDeclarations)({
            placement: placement,
            crossAxisShiftMargins: shiftMargins
        }) : shiftMargins,
        ...sizeStyles
    ];
    // Anchor names are never removed: several popovers can share an anchor, and
    // even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only a new name is written: a
    // name from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $1qHoh.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("1qHoh", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $547623e2babbe7ef$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ function $547623e2babbe7ef$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior INLINE value, not the computed style: cleanup restores
    // only what the consumer or an earlier run wrote inline. An empty string means
    // there was no inline value, so cleanup removes the property.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("hs0cW", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $553174c2a88de556$export$f7505ccec0897ae3);
function $553174c2a88de556$export$f7505ccec0897ae3({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    const negatedValue = `calc(-1 * ${crossAxisShiftCssValue})`;
    const isForwards = direction === 'forwards';
    return [
        {
            property: `margin-${crossAxis}-start`,
            value: isForwards ? crossAxisShiftCssValue : negatedValue
        },
        {
            property: `margin-${crossAxis}-end`,
            value: isForwards ? negatedValue : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("1mUq6", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $07e13b267dcb8503$export$b94d052c6b40496);
function $07e13b267dcb8503$export$b94d052c6b40496({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    // The side FACING the anchor is always opposite the placement edge.
    const anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: `margin-${axis}-${anchorFacingEdge}`,
        value: offset
    };
}

});

parcelRegister("bclZv", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $20808fca7dbac8e1$export$a7ffde4a856e8d8e);

var $j20PE = parcelRequire("j20PE");
/**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $20808fca7dbac8e1$var$viewportFacingCrossAxisSides({ align: align }) {
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $20808fca7dbac8e1$export$a7ffde4a856e8d8e({ placement: placement, crossAxisShiftMargins: crossAxisShiftMargins }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    const paddedProperties = new Set($20808fca7dbac8e1$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map((side)=>`margin-${crossAxis}-${side}`));
    return [
        {
            property: `margin-${placement.axis}-${placement.edge}`,
            value: (0, $j20PE.VIEWPORT_PADDING)
        },
        ...crossAxisShiftMargins.map(({ property: property, value: value })=>paddedProperties.has(property) ? {
                property: property,
                value: `calc(${value} + ${0, $j20PE.VIEWPORT_PADDING})`
            } : {
                property: property,
                value: value
            })
    ];
}

});
parcelRegister("j20PE", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $880c8beb5d897218$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $880c8beb5d897218$export$860b30329fa0b990);
const $880c8beb5d897218$export$9f2fdbacbc62226e = '5px';
const $880c8beb5d897218$export$32ab78b2bb853a01 = '150px';
/**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $880c8beb5d897218$var$viewportUnit({ axis: axis, writingMode: writingMode }) {
    // The inline axis is horizontal in a horizontal writing mode. The block axis is
    // horizontal in a vertical one.
    const isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
function $880c8beb5d897218$var$getCrossAxis({ axis: axis }) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $880c8beb5d897218$var$viewportCap({ axis: axis, writingMode: writingMode }) {
    return `calc(100${$880c8beb5d897218$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    })} - 2 * ${$880c8beb5d897218$export$9f2fdbacbc62226e})`;
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $880c8beb5d897218$var$cellCap({ gap: gap }) {
    return `calc(100% - ${$880c8beb5d897218$export$9f2fdbacbc62226e} - ${gap})`;
}
/**
 * The anchor term of the placement-axis floor, or `null` for none. It is the only
 * part of the floor that is ever clamped to a cap.
 *
 * `'min-anchor'` always gets an anchor floor. `'match-anchor'` gets one only where
 * it can flip: its definite size alone gives way to the cap, so the popover would
 * shrink below the anchor instead of flipping.
 *
 * It is clamped only where it cannot flip, on purpose:
 *
 * - With no flip, an unclamped floor beats `max-{axis}-size` (CSS applies the
 *   `min` last), so the viewport backstop would do nothing.
 * - With a flip, a clamp would stop the floor exceeding the cell cap, and that
 *   overflow is what drives the flip.
 */ function $880c8beb5d897218$var$getPlacementAxisAnchorFloor({ placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, canFlip: canFlip, writingMode: writingMode }) {
    const hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return null;
    if (canFlip) return anchorValue;
    return `min(${anchorValue}, ${$880c8beb5d897218$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    })})`;
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells on either side of the anchor add up to the viewport less the
 * anchor, so the roomier one is at least half of that. A floor whose margin box
 * fits inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` stops
 * the floor going negative, for example for an anchor larger than the viewport.
 */ function $880c8beb5d897218$var$getDefaultPlacementAxisFloor({ placementAxis: placementAxis, anchorValue: anchorValue, gap: gap, writingMode: writingMode }) {
    if (anchorValue === null) return $880c8beb5d897218$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    const viewport = `100${$880c8beb5d897218$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    })}`;
    const halfOfRemainingViewport = `calc((${viewport} - ${anchorValue}) / 2 - ${gap} - ${$880c8beb5d897218$export$9f2fdbacbc62226e})`;
    return `min(${$880c8beb5d897218$export$32ab78b2bb853a01}, max(0px, ${halfOfRemainingViewport}))`;
}
/**
 * The placement-axis floor, or `null` for none. Explicit minimums COMPOSE, the
 * default does not:
 *
 * - `placement.minSize` and the anchor term are both explicit requests, so they
 *   compose as `max()`. As intended, `minSize: 0` does not remove an anchor
 *   floor, because `max(0px, anchor)` IS the anchor.
 * - The default floor applies only when neither is set and the popover can flip.
 *   It never composes: in a `max()` it would only win by overriding a size the
 *   consumer asked for, and the anchor term drives the flip on its own.
 */ function $880c8beb5d897218$var$getPlacementAxisFloor({ minSize: minSize, placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, gap: gap, canFlip: canFlip, writingMode: writingMode }) {
    const anchorFloor = $880c8beb5d897218$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === null ? minSize : `max(${minSize}, ${anchorFloor})`;
    if (anchorFloor !== null) return anchorFloor;
    if (!canFlip) return null;
    return $880c8beb5d897218$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $880c8beb5d897218$export$860b30329fa0b990({ placement: placement, inlineSize: inlineSize, blockSize: blockSize, isUsingCssAnchorPositioning: isUsingCssAnchorPositioning, anchorSize: anchorSize, writingMode: writingMode, shouldPreserveInlineSize: shouldPreserveInlineSize = false }) {
    const placementAxis = placement.axis;
    const crossAxis = $880c8beb5d897218$var$getCrossAxis({
        axis: placementAxis
    });
    // Rule 1. In effect this feeds only the placement-axis cap: every other check
    // below treats `'content'` and `'max-available'` the same.
    const size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values, not `size`: flipping is a whole-popover
    // outcome, so a fit request on either axis turns the floor on.
    const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // The floor drives the flip only on the CSS path. On the JavaScript fallback a
    // floor only inflates the measured size that the side is picked from, so it
    // would flip a popover that fits.
    const canFlip = isFitting && isUsingCssAnchorPositioning;
    const declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: `max-${placementAxis}-size`,
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $880c8beb5d897218$var$cellCap({
                gap: placement.offset.gap
            }) : $880c8beb5d897218$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: `max-${crossAxis}-size`,
            value: $880c8beb5d897218$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // `'match-anchor'` is a definite size. A max beats a definite size, so the caps
    // above still win.
    [
        placementAxis,
        crossAxis
    ].forEach((axis)=>{
        const anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: `${axis}-size`,
            value: anchorValue
        });
    });
    const placementAxisFloor = $880c8beb5d897218$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== null) declarations.push({
        property: `min-${placementAxis}-size`,
        value: placementAxisFloor
    });
    // `'min-anchor'` on the cross axis is a size contract, not a flip driver, so it
    // is clamped to the viewport cap.
    const crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: `min-${crossAxis}-size`,
        value: `min(${crossAxisAnchorValue}, ${$880c8beb5d897218$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        })})`
    });
    return declarations;
}

});


parcelRegister("dA9DU", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $9df1573dde911a8a$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Reads the computed
 * value as well as the inline one, so a name set from a STYLESHEET is found: a
 * new inline name would otherwise override it for every other rule anchored
 * to that element. `anchor-name` is a list and `position-anchor` takes one ident,
 * so the first name is the one to anchor to.
 */ function $9df1573dde911a8a$export$948d15b01d509455({ element: element }) {
    const anchorNames = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    const firstAnchorName = anchorNames.split(',')[0].trim();
    return firstAnchorName !== '' && firstAnchorName !== 'none' ? firstAnchorName : null;
}

});

parcelRegister("5OFUZ", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $781ed0ccadfcc551$export$de49b61f233ddeb9);
function $781ed0ccadfcc551$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const edgeArea = `${axis}-${edge}`;
    if (align === 'center') return edgeArea;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDirection = align === 'start' ? 'end' : 'start';
    return `${edgeArea} span-${crossAxis}-${spanDirection}`;
}

});

parcelRegister("kpopp", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $26d3a2808ed87084$export$c4e16947a95d61f1);
/**
 * The try options that slide the popover along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not. Two options over the SAME cell have the same margin box and the
 * same fit result. That rules out three cells for an aligned placement: the near
 * span on the requested edge IS the base `position-area`, and on the opposite
 * edge the near and far spans are where the placement-axis flip and the diagonal
 * flip land.
 *
 * A centred placement has no near or far span, so it slides to both spans on
 * both edges.
 */ function $26d3a2808ed87084$var$getSlideTryOptions({ align: align, edgeArea: edgeArea, crossAxis: crossAxis, isOppositeEdge: isOppositeEdge }) {
    if (align === 'center') return [
        `${edgeArea} span-${crossAxis}-end`,
        `${edgeArea} span-${crossAxis}-start`
    ];
    if (isOppositeEdge) return [
        edgeArea
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`. `align: 'end'` is the mirror image.
    const farSpanSide = align === 'start' ? 'start' : 'end';
    return [
        edgeArea,
        `${edgeArea} span-${crossAxis}-${farSpanSide}`
    ];
}
/**
 * The try option that flips on both axes, into the opposite corner.
 */ function $26d3a2808ed87084$var$getDiagonalFlipTryOption({ axis: axis }) {
    const placementAxisFlip = axis === 'block' ? 'flip-block' : 'flip-inline';
    const crossAxisFlip = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${placementAxisFlip} ${crossAxisFlip}`;
}
function $26d3a2808ed87084$export$c4e16947a95d61f1({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const oppositeEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${oppositeEdge}`;
    const placementAxisFlip = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $26d3a2808ed87084$var$getSlideTryOptions({
            align: align,
            edgeArea: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        placementAxisFlip,
        align !== 'center' ? $26d3a2808ed87084$var$getDiagonalFlipTryOption({
            axis: axis
        }) : null,
        $26d3a2808ed87084$var$getSlideTryOptions({
            align: align,
            edgeArea: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("3AhxT", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $0c60f102c44d9d69$export$89babc4c2047d2ba);
/**
 * **JavaScript positioning fallback**
 *
 * Writes measured `position: fixed` coordinates for browsers without CSS Anchor
 * Positioning.
 *
 * Best effort. The popover is always visible, and the position degrades in this
 * order:
 *
 * 1. Anchored, at the measured position.
 * 2. Anchored, with unresolvable offsets treated as `0`.
 * 3. Centred in the viewport.
 *
 * The two hazards differ in kind:
 *
 * - `new ResizeObserver` runs synchronously in the layout effect, where a throw
 *   unmounts the React tree.
 * - `updatePosition` runs asynchronously, where the danger is an `opacity: 0`
 *   that is never cleared.
 */ 
var $6Zi52 = parcelRequire("6Zi52");

var $PIUl3 = parcelRequire("PIUl3");

var $bhmax = parcelRequire("bhmax");

var $1qHoh = parcelRequire("1qHoh");

var $9j9w9 = parcelRequire("9j9w9");

var $k988v = parcelRequire("k988v");

var $gKbac = parcelRequire("gKbac");
// Wrapped because jsdom throws on the unknown `:popover-open` selector.
function $0c60f102c44d9d69$var$isPopoverOpen({ popover: popover }) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Creates an observer that calls `onFirstLayout` at the first non-zero layout
 * of the popover, then disconnects. The scroll and resize listeners handle
 * movement after that. The popover is `display: none` until `showPopover()`,
 * and some browsers fire `toggle` before layout, so a RAF after `toggle` is
 * unreliable.
 *
 * Returns `null` when `ResizeObserver` is missing (non-DOM jest environments)
 * or its constructor throws. There is then no measurement to wait for, so the
 * caller positions immediately and must not hide the popover, because no
 * reveal would follow.
 */ function $0c60f102c44d9d69$var$createFirstLayoutObserver({ popover: popover, onFirstLayout: onFirstLayout }) {
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        const observer = new ResizeObserver(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $gKbac.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $0c60f102c44d9d69$export$89babc4c2047d2ba({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles }) {
    // The `popover` attribute already puts the popover in the top layer. Reset the
    // UA `margin` and `inset` so that the measured `top` / `left` apply, and write
    // the size styles.
    const cleanupBaseStyles = (0, $1qHoh.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            },
            ...sizeStyles
        ]
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    let cleanupPositionStyles;
    let cleanupHideStyles;
    // Resolved once per open and per resize, and reused across scrolls. Resolving
    // is a full style and layout flush, and a scroll cannot change what a CSS
    // length resolves to. A resize can (viewport units), and so can a re-open (a
    // token retargeted while closed).
    let resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probe INSIDE the popover, so a length resolves against the popover's font
        // size and custom-property scope, not the anchor's.
        resolvedOffsets = {
            gap: (0, $k988v.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $k988v.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _cleanupHideStyles;
        (_cleanupHideStyles = cleanupHideStyles) === null || _cleanupHideStyles === void 0 || _cleanupHideStyles();
        cleanupHideStyles = undefined;
    }
    function restorePosition() {
        var _cleanupPositionStyle;
        (_cleanupPositionStyle = cleanupPositionStyles) === null || _cleanupPositionStyle === void 0 || _cleanupPositionStyle();
        cleanupPositionStyles = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (cleanupHideStyles) return;
        cleanupHideStyles = (0, $1qHoh.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        cleanupPositionStyles = (0, $1qHoh.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function updatePosition() {
        try {
            const anchorRect = anchor.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            const { gap: gap, crossAxisShift: crossAxisShift } = getResolvedOffsets();
            const { top: top, left: left } = (0, $9j9w9.computeFallbackPosition)({
                anchorRect: anchorRect,
                popover: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            });
            // A non-finite coordinate serialises to a declaration the browser drops.
            // That leaves the popover in the corner, as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            cleanupPositionStyles = (0, $1qHoh.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: `${top}px`
                    },
                    {
                        property: 'left',
                        value: `${left}px`
                    }
                ]
            });
        } catch (error) {
            (0, $gKbac.warnFallbackFailure)({
                error: error
            });
            // Anchored positioning failed, so the centred position is the only one left
            // to degrade to.
            try {
                centerInViewport();
            } catch  {}
        } finally{
            // Always reveal. A popover in the wrong place recovers on the next scroll or
            // resize. A popover left at `opacity: 0` stays invisible.
            reveal();
        }
    }
    function invalidateOffsetsAndUpdatePosition() {
        invalidateResolvedOffsets();
        updatePosition();
    }
    // One update per animation frame. Scroll reuses the resolved offsets. Resize
    // resolves them again.
    const scheduledScrollUpdate = (0, $PIUl3.default)(updatePosition);
    const scheduledResizeUpdate = (0, $PIUl3.default)(invalidateOffsetsAndUpdatePosition);
    const firstLayoutObserver = $0c60f102c44d9d69$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: updatePosition
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open resolves the offsets again.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            updatePosition();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs. Then the initial `toggle`
    // has fired, and the listener below would miss it.
    if ($0c60f102c44d9d69$var$isPopoverOpen({
        popover: popover
    })) positionOnNextLayout();
    return (0, $bhmax.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and observe again.
    (0, $6Zi52.bind)(popover, {
        type: 'toggle',
        listener: (event)=>{
            const toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), ()=>firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect(), (0, $6Zi52.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $6Zi52.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), ()=>{
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("PIUl3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09b799440db230ba$export$2e2bcd8739ae039);
var $09b799440db230ba$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $09b799440db230ba$export$2e2bcd8739ae039 = $09b799440db230ba$var$rafSchd;

});

parcelRegister("bhmax", function(module, exports) {
$parcel$export(module.exports, "combine", () => $2dadbaf421eda5a0$export$1be1fc439b849fdf);
/**
 * Combines cleanup functions into one cleanup function. It calls them in order and skips
 * `undefined` entries.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $2dadbaf421eda5a0$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((cleanupFn)=>cleanupFn === null || cleanupFn === void 0 ? void 0 : cleanupFn());
    };
}

});

parcelRegister("9j9w9", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $15add975db2cefbf$export$d5ef1dac02135664);
/**
 * Returns the position on the placement `edge`, centred on the cross axis.
 *
 * Flips to the opposite edge when the popover does not fit and the opposite
 * edge has more space. `gap` separates the anchor and the popover along the
 * placement axis.
 */ function $15add975db2cefbf$var$computeEdgePosition({ axis: axis, edge: edge, anchorRect: anchorRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below the anchor
        const spaceBelow = viewport.height - anchorRect.bottom;
        const spaceAbove = anchorRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const shouldPlaceBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: shouldPlaceBelow ? anchorRect.bottom + gap : anchorRect.top - popoverHeight - gap,
            left: anchorRect.left + anchorRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above the anchor
        const spaceAbove = anchorRect.top;
        const spaceBelow = viewport.height - anchorRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const shouldPlaceAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: shouldPlaceAbove ? anchorRect.top - popoverHeight - gap : anchorRect.bottom + gap,
            left: anchorRect.left + anchorRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of the anchor
        const spaceRight = viewport.width - anchorRect.right;
        const spaceLeft = anchorRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const shouldPlaceRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: anchorRect.top + anchorRect.height / 2 - popoverHeight / 2,
            left: shouldPlaceRight ? anchorRect.right + gap : anchorRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of the anchor
        const spaceLeft = anchorRect.left;
        const spaceRight = viewport.width - anchorRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const shouldPlaceLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: anchorRect.top + anchorRect.height / 2 - popoverHeight / 2,
            left: shouldPlaceLeft ? anchorRect.left - popoverWidth - gap : anchorRect.right + gap
        };
    }
    // Unreachable for a valid placement. Defaults to below the anchor.
    return {
        top: anchorRect.bottom + gap,
        left: anchorRect.left + anchorRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Moves the centred position from `computeEdgePosition` along the cross axis
 * for a non-centre `align`:
 *
 * - `'start'`: the popover start edge lines up with the anchor start edge.
 * - `'end'`: the popover end edge lines up with the anchor end edge.
 */ function $15add975db2cefbf$var$applyAlignment({ position: position, axis: axis, align: align, anchorRect: anchorRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    // A block-axis placement has an inline (left and right) cross axis.
    if (axis === 'block') {
        if (align === 'start') return {
            ...position,
            left: anchorRect.left
        };
        return {
            ...position,
            left: anchorRect.right - popoverWidth
        };
    }
    // An inline-axis placement has a block (top and bottom) cross axis.
    if (align === 'start') return {
        ...position,
        top: anchorRect.top
    };
    return {
        ...position,
        top: anchorRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $15add975db2cefbf$var$applyCrossAxisShift({ position: position, axis: axis, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const delta = crossAxisShift.value * directionSign;
    // The cross axis is perpendicular to the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $15add975db2cefbf$export$d5ef1dac02135664({ anchorRect: anchorRect, popover: popover, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // The popover must have layout here (not `display: none`), or both sizes are `0`.
    const popoverWidth = popover.offsetWidth;
    const popoverHeight = popover.offsetHeight;
    const edgePosition = $15add975db2cefbf$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        anchorRect: anchorRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $15add975db2cefbf$var$applyAlignment({
        position: edgePosition,
        axis: axis,
        align: align,
        anchorRect: anchorRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $15add975db2cefbf$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to the viewport. A popover larger than the viewport keeps its top-left
    // corner on screen.
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("k988v", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $5bd269c03dc6c167$export$98721546d2816d9e);

var $gKbac = parcelRequire("gKbac");
/**
 * Measures `value` as the computed `margin-left` of a hidden probe inside
 * `container`. Returns `null` when the environment cannot measure, and `0` when
 * the computed value is not a number.
 */ function $5bd269c03dc6c167$var$measureWithProbe({ value: value, container: container }) {
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    const view = container.ownerDocument.defaultView;
    if (!view) return null;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `margin-left`, not `width`, because `width` clamps a negative value to `0`.
    // `getComputedStyle` returns the resolved pixel value of a margin, even when
    // the source is a token, `calc()` or `var()`.
    probe.style.marginLeft = value;
    // Hidden from assistive technology and from events. This also protects
    // consumer code that walks the DOM (for example `getElementsByTagName('div')`).
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        const pixels = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(pixels) ? pixels : 0;
    } catch (error) {
        (0, $gKbac.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $5bd269c03dc6c167$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    const pixelMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pixelMatch) return Number(pixelMatch[1]);
    return $5bd269c03dc6c167$var$measureWithProbe({
        value: value,
        container: container
    }) ?? 0;
}

});
parcelRegister("gKbac", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $067a401a15e0abe0$export$e142245b95267f17);

function $067a401a15e0abe0$export$e142245b95267f17({ error: error }) {
    return;
}

});



parcelRegister("kf8kL", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $b56fb6a8a4a81248$export$7192e63dfa9e8124);

var $hk01v = parcelRequire("hk01v");
const $b56fb6a8a4a81248$export$7192e63dfa9e8124 = (0, $hk01v.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("hk01v", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $f0cdd679469d8b18$export$69de71b4b7c76bad);

var $g68k0 = parcelRequire("g68k0");
function $f0cdd679469d8b18$export$69de71b4b7c76bad({ property: property, value: value }) {
    return (0, $g68k0.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("ebSkB", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $ff9e74e3348ad30d$export$1c8dd0d1c9df9c6e);

var $hk01v = parcelRequire("hk01v");
const $ff9e74e3348ad30d$export$1c8dd0d1c9df9c6e = (0, $hk01v.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("51q3I", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopoverAtPoint", () => $595ee815df44425d$export$3c5c8baff3ccd957);
/**
 * Positioning and sizing for a popover anchored to a viewport COORDINATE. No
 * positioning logic here: CSS Anchor Positioning needs a real element to carry
 * `anchor-name`, so this hook creates a hidden, zero-size one at the requested
 * point and delegates everything else to `useAnchoredPopover`.
 *
 * See `notes/decisions/anchored-popover-at-point.md` for why this is a sibling
 * hook instead of an anchor union inside `useAnchoredPopover`.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $9kfe7 = parcelRequire("9kfe7");

var $lz1tR = parcelRequire("lz1tR");
/**
 * Creates a hidden, zero-size anchor element at `point`. It is appended to
 * `document.body` to escape any transformed ancestor, which would stop
 * `position: fixed` from resolving against the viewport. `Object.assign` rather
 * than `setStyle`: we own the element, so there is nothing to restore.
 */ function $595ee815df44425d$var$mountAnchorElementAtPoint({ point: point }) {
    const element = document.createElement('div');
    element.setAttribute('aria-hidden', 'true');
    Object.assign(element.style, {
        position: 'fixed',
        // Physical insets: `inset-inline-start` would need `viewportWidth - point.x`
        // in RTL.
        top: `${point.y}px`,
        left: `${point.x}px`,
        // Zero size, so placement alone decides which side the popover sits on.
        width: '0',
        height: '0',
        pointerEvents: 'none'
    });
    document.body.appendChild(element);
    return {
        element: element,
        cleanup: function cleanup() {
            element.remove();
        }
    };
}
function $595ee815df44425d$export$3c5c8baff3ccd957({ getPoint: getPoint, isEnabled: isEnabled = true, ...anchoredPopoverOptions }) {
    const anchorRef = (0, $fc4bM.useRef)(null);
    // Latched, keyed on `isEnabled`: consumers read mutable refs inside `getPoint`,
    // so re-reading it would move an already-open popover, and keying on
    // `getPoint`'s identity would re-latch on every parent render.
    const getPointRef = (0, $fc4bM.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Declared BEFORE `useAnchoredPopover` below, so the element exists when that
    // hook's effect reads the ref (React runs layout effects in source order). This
    // effect must not depend on anything the delegated effect does not: a dependency
    // here alone re-creates the element without that hook writing an `anchor-name`
    // onto it, and positioning silently dies.
    (0, $9kfe7.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const { element: element, cleanup: unmountAnchorElement } = $595ee815df44425d$var$mountAnchorElementAtPoint({
            point: point
        });
        anchorRef.current = element;
        return function cleanup() {
            unmountAnchorElement();
            anchorRef.current = null;
        };
    // The latch. See `getPointRef` above: `getPoint` is deliberately absent.
    }, [
        isEnabled
    ]);
    (0, $lz1tR.useAnchoredPopover)({
        ...anchoredPopoverOptions,
        anchorRef: anchorRef,
        isEnabled: isEnabled
    });
}

});

parcelRegister("i3E5d", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $a7111c7a079043e5$export$9198c6c168be2eeb);

var $3zBNx = parcelRequire("3zBNx");
function $a7111c7a079043e5$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output can contain `:`, `«` and `»`,
    // which break CSS selectors such as `document.querySelector('#id')`.
    return `popover-${(0, $3zBNx.useId)()}`;
}

});

parcelRegister("jPxIN", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $95c47c3cbf2d19cc$export$175375e9a2b5515d);

var $j5N6B = parcelRequire("j5N6B");
function $95c47c3cbf2d19cc$export$175375e9a2b5515d() {
    const document = (0, $j5N6B.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("32M6G", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $fdca108f10b20a35$export$b065aeb850c3e87f);
function $fdca108f10b20a35$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $fdca108f10b20a35$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $fdca108f10b20a35$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $fdca108f10b20a35$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $fdca108f10b20a35$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $fdca108f10b20a35$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $fdca108f10b20a35$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("bpfBi", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $61abd0e33d80b018$export$e9a6fdb80170ffd);
function $61abd0e33d80b018$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("8L1DO", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $3996383b1fa49cfe$export$941a7e8bf0b9eafd);

var $fc4bM = parcelRequire("fc4bM");

var $kwZKX = parcelRequire("kwZKX");
function $3996383b1fa49cfe$export$941a7e8bf0b9eafd() {
    return (0, $fc4bM.useContext)((0, $kwZKX.AnchorContext));
}

});
parcelRegister("kwZKX", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $604176569f982ffe$export$8f73317645bb7b8e);

var $fc4bM = parcelRequire("fc4bM");
const $604176569f982ffe$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $fc4bM.createContext)(null);

});


parcelRegister("7cM3U", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $99d346b461657e86$export$61d36e2b682e92f7);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $9kfe7 = parcelRequire("9kfe7");

var $loYPt = parcelRequire("loYPt");
const $99d346b461657e86$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $99d346b461657e86$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $99d346b461657e86$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $99d346b461657e86$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $99d346b461657e86$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $99d346b461657e86$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $99d346b461657e86$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $fc4bM.useState)($99d346b461657e86$var$INITIAL);
    const measure = (0, $fc4bM.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $99d346b461657e86$var$INITIAL);
            return;
        }
        const viewport = (0, $loYPt.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $99d346b461657e86$var$isFullyOutsideViewport(anchorRect, viewport) || $99d346b461657e86$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $99d346b461657e86$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $9kfe7.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $6Zi52.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $6Zi52.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("loYPt", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $9b7cc52242fea605$export$64beed533e21f72d);
function $9b7cc52242fea605$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("cufVT", function(module, exports) {
$parcel$export(module.exports, "default", () => $11417edc4237c8fe$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $8jyMF = parcelRequire("8jyMF");

var $02FhI = parcelRequire("02FhI");

var $h41S1 = parcelRequire("h41S1");

var $9fHXX = parcelRequire("9fHXX");
function $11417edc4237c8fe$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $h41S1.default)(mountStrategy);
    (0, $9fHXX.default)(zIndex);
    return !(0, $dRkX9.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8jyMF.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $02FhI.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("8jyMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2c08912af3ba060$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $gvJqv = parcelRequire("gvJqv");

var $h5e7t = parcelRequire("h5e7t");

var $6DuHi = parcelRequire("6DuHi");

var $dTBq5 = parcelRequire("dTBq5");

var $5EIOe = parcelRequire("5EIOe");

var $1xSck = parcelRequire("1xSck");
function $f2c08912af3ba060$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $fc4bM.useMemo)(()=>(0, $5EIOe.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $h5e7t.useColorMode)();
    const isInsideThemeProvider = (0, $6DuHi.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $dTBq5.appendPortalContainerIfNotAppended)(container);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            (0, $1xSck.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $bTkYf.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gvJqv.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("gvJqv", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $e36ab5256f8b37ae$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $dRkX9 = parcelRequire("dRkX9");

var $h6oew = parcelRequire("h6oew");

var $cBDbV = parcelRequire("cBDbV");

var $1nilL = parcelRequire("1nilL");

var $1DvZb = parcelRequire("1DvZb");

var $dmQVf = parcelRequire("dmQVf");

var $l6UsL = parcelRequire("l6UsL");

var $9ulCF = parcelRequire("9ulCF");

var $54Vfc = parcelRequire("54Vfc");

var $9n2Vu = parcelRequire("9n2Vu");

var $42TF6 = parcelRequire("42TF6");

var $6DuHi = parcelRequire("6DuHi");

var $3VreF = parcelRequire("3VreF");

var $9PeGV = parcelRequire("9PeGV");
const $e36ab5256f8b37ae$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
const $e36ab5256f8b37ae$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $e36ab5256f8b37ae$var$prefersDarkModeMql = $e36ab5256f8b37ae$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $e36ab5256f8b37ae$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $e36ab5256f8b37ae$var$prefersDarkModeMql !== null && $e36ab5256f8b37ae$var$prefersDarkModeMql !== void 0 && $e36ab5256f8b37ae$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
const $e36ab5256f8b37ae$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $e36ab5256f8b37ae$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $fc4bM.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $fc4bM.useState)($e36ab5256f8b37ae$var$getReconciledColorMode(defaultColorMode));
    const isInsideAppProvider = (0, $l6UsL.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $dmQVf.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $6DuHi.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    /**
   * Each provider owns its own override stylesheet, so nested providers don't overwrite or remove
   * each other's overrides. `useId` is stable between the server render and hydration.
   *
   * Subtree providers also scope their override selector to their own element. Otherwise every
   * subtree using the same custom theme would match every provider's overrides, and the last
   * stylesheet in the document would win. The root provider targets `html`, which subtrees
   * inherit from.
   */ const customThemeOverridesStyleId = (0, $fc4bM.useId)();
    const { theme: normalizedDefaultTheme, inlineStyles: inlineStyles } = (0, $cBDbV.getThemeAndOverrides)(defaultTheme, isRootThemeProvider ? undefined : customThemeOverridesStyleId);
    const [theme, setTheme] = (0, $fc4bM.useState)(()=>({
            ...$e36ab5256f8b37ae$var$defaultThemeSettings,
            ...normalizedDefaultTheme
        }));
    const [hasHoistedInlineThemeStyles, setHasHoistedInlineThemeStyles] = (0, $fc4bM.useState)(false);
    const setColorMode = (0, $fc4bM.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($e36ab5256f8b37ae$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $fc4bM.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $fc4bM.useRef)(null);
    /**
   * Custom theme overrides apply regardless of `platform-static-theme-loading`: that gate only
   * controls how the theme stylesheets themselves are loaded.
   */ const inlineThemeStylesOverrides = inlineStyles;
    (0, $fc4bM.useLayoutEffect)(()=>{
        return ()=>{
            var _document$head$queryS;
            (_document$head$queryS = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`)) === null || _document$head$queryS === void 0 || _document$head$queryS.remove();
        };
    }, [
        customThemeOverridesStyleId
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        const isStaticThemeLoadingEnabled = (0, $dRkX9.fg)('platform-static-theme-loading');
        if (isStaticThemeLoadingEnabled && !hasHoistedInlineThemeStyles) (0, $3VreF.getInlineThemeStyles)(theme, chosenColorMode).forEach(({ id: id, css: css })=>{
            if (document.head.querySelector(`style[data-theme="${id}"]`)) return;
            const style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        const existingOverrideStyle = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`);
        if (inlineThemeStylesOverrides) {
            if (existingOverrideStyle) existingOverrideStyle.textContent = inlineThemeStylesOverrides;
            else {
                const style = document.createElement('style');
                style.dataset.themeOverrides = customThemeOverridesStyleId;
                style.textContent = inlineThemeStylesOverrides;
                document.head.appendChild(style);
            }
        } else existingOverrideStyle === null || existingOverrideStyle === void 0 || existingOverrideStyle.remove();
        // Only re-render to drop the inline styles when there are any to drop.
        if (!hasHoistedInlineThemeStyles && (isStaticThemeLoadingEnabled || inlineThemeStylesOverrides)) setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        customThemeOverridesStyleId,
        hasHoistedInlineThemeStyles,
        inlineThemeStylesOverrides,
        theme
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $1DvZb.setGlobalTheme)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        }
        // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $9PeGV.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!$e36ab5256f8b37ae$var$prefersDarkModeMql) return;
        const unbindListener = (0, $6Zi52.bind)($e36ab5256f8b37ae$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $1nilL.getThemeHtmlAttrs)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $h6oew.SUBTREE_THEME_ATTRIBUTE)]: true,
        // Matches this provider's scoped override selector. Only set when there are overrides.
        ...inlineThemeStylesOverrides ? {
            [(0, $cBDbV.CUSTOM_THEME_SCOPE_ATTRIBUTE)]: customThemeOverridesStyleId
        } : {}
    };
    const inlineThemeStyles = (0, $dRkX9.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $3VreF.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $54Vfc.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9ulCF.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9n2Vu.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $42TF6.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $42TF6.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                            ...attrs,
                            className: (0, $2R2iS.default)([
                                $e36ab5256f8b37ae$var$contentStyles.body
                            ]),
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $3LM7S.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $3LM7S.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        }) : /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $3LM7S.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $3LM7S.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("cBDbV", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_THEME_SCOPE_ATTRIBUTE", () => $efc0195d8c62bed3$export$e5f6e0f338f81b9a);
$parcel$export(module.exports, "getThemeAndOverrides", () => $efc0195d8c62bed3$export$12087c26a9b2e83e);
function $efc0195d8c62bed3$var$isThemeWithOverrides(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'overrides' in value && typeof value.id === 'string' && typeof value.overrides === 'object' && value.overrides !== null;
}
const $efc0195d8c62bed3$export$e5f6e0f338f81b9a = 'data-theme-overrides-scope';
function $efc0195d8c62bed3$export$12087c26a9b2e83e(themeWithOverrides, scope) {
    const theme = {};
    const overrides = {};
    for (const [themeKind, value] of Object.entries(themeWithOverrides || {})){
        if ($efc0195d8c62bed3$var$isThemeWithOverrides(value)) {
            theme[themeKind] = value.id;
            overrides[themeKind] = {
                [value.id]: value.overrides
            };
            continue;
        }
        theme[themeKind] = value;
    }
    return {
        theme: theme,
        inlineStyles: $efc0195d8c62bed3$var$getCustomThemeOverrideStyles(overrides, scope)
    };
}
/**
 * Escapes a value for use inside a double-quoted CSS attribute selector.
 */ function $efc0195d8c62bed3$var$escapeAttributeValue(value) {
    return value.replace(/["\\]/g, '\\$&');
}
function $efc0195d8c62bed3$var$getThemeOverrideSelector(themeKind, themeName, scope) {
    // Colour themes only apply in their own colour mode.
    const colorMode = themeKind === 'light' || themeKind === 'dark' ? `[data-color-mode="${themeKind}"]` : '';
    const theme = `${colorMode}[data-theme~="${themeKind}:${themeName}"]`;
    if (scope) return `[data-subtree-theme][${$efc0195d8c62bed3$export$e5f6e0f338f81b9a}="${$efc0195d8c62bed3$var$escapeAttributeValue(scope)}"]${theme}`;
    return `html${theme}, [data-subtree-theme]${theme}`;
}
function $efc0195d8c62bed3$var$getCssVariableName(propertyName) {
    return `--ds-${propertyName.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
}
/**
 * Generates CSS for custom theme overrides.
 *
 * Override property names are converted from camel case to `--ds-` CSS custom properties.
 */ function $efc0195d8c62bed3$var$getCustomThemeOverrideStyles(overrides, scope) {
    if (!overrides) return '';
    return Object.entries(overrides).flatMap(([themeKind, themes])=>Object.entries(themes || {}).flatMap(([themeName, values])=>{
            const styles = Object.entries(values || {})// Unset optional inputs are skipped so the theme's `var()` fallback applies. Writing
            // `undefined` would be a valid custom property value that breaks the formula.
            .filter(([, value])=>value !== undefined && value !== null).map(([propertyName, value])=>`${$efc0195d8c62bed3$var$getCssVariableName(propertyName)}: ${typeof value === 'boolean' ? Number(value) : value};`).join('');
            return styles ? `
		${$efc0195d8c62bed3$var$getThemeOverrideSelector(themeKind, themeName, scope)} {
			${styles}
		}
	` : [];
        })).join('');
}

});

parcelRegister("1nilL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getThemeHtmlAttrs", () => $b37b121c9e8e776e$export$e1f80cb7a749802f);
$parcel$export(module.exports, "default", () => $b37b121c9e8e776e$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $h6oew = parcelRequire("h6oew");

var $aHwAH = parcelRequire("aHwAH");

var $2Thdv = parcelRequire("2Thdv");

var $fi6ke = parcelRequire("fi6ke");

var $dLoRK = parcelRequire("dLoRK");
const $b37b121c9e8e776e$var$defaultColorMode = 'light';
const $b37b121c9e8e776e$var$defaultContrastMode = 'no-preference';
const $b37b121c9e8e776e$export$e1f80cb7a749802f = ({ colorMode: colorMode = (0, $2Thdv.themeStateDefaults)['colorMode'], dark: dark = (0, $2Thdv.themeStateDefaults)['dark'], light: light = (0, $2Thdv.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $2Thdv.themeStateDefaults)['contrastMode'], motion: motion = (0, $2Thdv.themeStateDefaults)['motion'](), shape: shape = (0, $2Thdv.themeStateDefaults)['shape'], spacing: spacing = (0, $2Thdv.themeStateDefaults)['spacing'], typography: typography = (0, $2Thdv.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $2Thdv.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $aHwAH.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $h6oew.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $h6oew.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $b37b121c9e8e776e$var$defaultColorMode : colorMode
    };
    if ((0, $dRkX9.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $h6oew.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $b37b121c9e8e776e$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $dLoRK.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $fi6ke.hash)(optionString);
        result[0, $h6oew.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $b37b121c9e8e776e$export$2e2bcd8739ae039 = $b37b121c9e8e776e$export$e1f80cb7a749802f;

});
parcelRegister("aHwAH", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $6a57af5ed92b4b73$export$62c37ab81302621a);

var $1q7j6 = parcelRequire("1q7j6");

var $5g0c0 = parcelRequire("5g0c0");

var $eaaKH = parcelRequire("eaaKH");
const $6a57af5ed92b4b73$var$customThemeOptions = 'UNSAFE_themeOptions';
const $6a57af5ed92b4b73$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $1q7j6.isColorMode)(id) || // custom theme state
        kind === $6a57af5ed92b4b73$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $eaaKH.isThemeKind)(kind) && typeof id === 'string' && (0, $5g0c0.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});
parcelRegister("1q7j6", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $20877d0a70cdfd67$export$4a14e169b1de4ee7);
const $20877d0a70cdfd67$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("5g0c0", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $3ce6837819ad06f4$export$ea35b8958c39dd07);

var $8y8q9 = parcelRequire("8y8q9");
const $3ce6837819ad06f4$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $8y8q9.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("8y8q9", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $52dae356ec8b7806$export$7d43e72a58e3283f);
const $52dae356ec8b7806$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-dynamic',
    'UNSAFE-dynamic-dark',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'UNSAFE-spacing',
    'shape',
    'typography',
    'UNSAFE-typography',
    'motion'
];

});


parcelRegister("eaaKH", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $9724775d6368fd02$export$958fa026be3a263e);
const $9724775d6368fd02$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $9724775d6368fd02$export$958fa026be3a263e = (themeKind)=>{
    return $9724775d6368fd02$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});


parcelRegister("2Thdv", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $7e2d2bebc92ad786$export$9aedcfa7336a207);
function $7e2d2bebc92ad786$var$getMotionDefault() {
    return 'motion';
}
const $7e2d2bebc92ad786$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $7e2d2bebc92ad786$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("fi6ke", function(module, exports) {
$parcel$export(module.exports, "hash", () => $a7597b1f28a869c3$export$d6af199866bfb566);
const $a7597b1f28a869c3$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("dLoRK", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $744e574e80371ec6$export$53031ac1ecb71f44);
const $744e574e80371ec6$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("1DvZb", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", () => $5f1697bd3bc35d82$export$fd7e0dd2b74807f7);

var $dRkX9 = parcelRequire("dRkX9");

var $hvzwL = parcelRequire("hvzwL");

var $2Thdv = parcelRequire("2Thdv");

var $jX9H9 = parcelRequire("jX9H9");

var $4geqn = parcelRequire("4geqn");

var $eSTRI = parcelRequire("eSTRI");

var $lHDyu = parcelRequire("lHDyu");

var $dLoRK = parcelRequire("dLoRK");

var $hcaq9 = parcelRequire("hcaq9");

var $jEJHq = parcelRequire("jEJHq");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $5f1697bd3bc35d82$export$fd7e0dd2b74807f7 = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $2Thdv.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $2Thdv.themeStateDefaults)['contrastMode'], dark: dark = (0, $2Thdv.themeStateDefaults)['dark'], light: light = (0, $2Thdv.themeStateDefaults)['light'], shape: shape = (0, $2Thdv.themeStateDefaults)['shape'], spacing: spacing = (0, $2Thdv.themeStateDefaults)['spacing'], typography: typography = (0, $2Thdv.themeStateDefaults)['typography'], motion: motion = (0, $2Thdv.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $2Thdv.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $2Thdv.themeStateDefaults),
        typography: (0, $2Thdv.themeStateDefaults)['typography'],
        shape: (0, $2Thdv.themeStateDefaults)['shape'],
        motion: (0, $2Thdv.themeStateDefaults)['motion'](),
        ...(0, $hvzwL.getGlobalTheme)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $dRkX9.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    const themePreferences = (0, $lHDyu.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $jEJHq.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    const themeOverridePreferences = (0, $eSTRI.getThemeOverridePreferences)(themeState);
    // Start loading override CSS before the first await. It is appended only after the standard
    // themes have loaded so that the override cascade order remains deterministic.
    const overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map((themeId)=>(0, $hcaq9.loadThemeCss)(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $dLoRK.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
        const mode = colorMode || (0, $2Thdv.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $4geqn.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("3gqeY"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    if (themeLoader) for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    else {
        const overrideThemeCss = await Promise.all(overrideThemeCssLoadingTasks);
        await Promise.all(themeOverridePreferences.map((themeId, index)=>(0, $jEJHq.loadAndAppendThemeCss)(themeId, overrideThemeCss[index])));
    }
    const autoUnbind = (0, $jX9H9.default)(themeState);
    return autoUnbind;
};

});
parcelRegister("hvzwL", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $700f22998d987aac$export$813ecdf77207a053);

var $h6oew = parcelRequire("h6oew");

var $hzj7Z = parcelRequire("hzj7Z");

var $lup9w = parcelRequire("lup9w");
const $700f22998d987aac$export$813ecdf77207a053 = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $h6oew.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $h6oew.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $lup9w.themeStringToObject)(theme),
        ...(0, $hzj7Z.isThemeColorMode)(colorMode) && {
            colorMode: colorMode
        }
    };
};

});
parcelRegister("hzj7Z", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $d03079ebe1df4911$export$fcfb1976c88f9f75);

var $fJBNt = parcelRequire("fJBNt");
const $d03079ebe1df4911$export$fcfb1976c88f9f75 = (colorMode)=>{
    return (0, $fJBNt.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};

});
parcelRegister("fJBNt", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $02d46308128d2c7b$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $02d46308128d2c7b$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("lup9w", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $22544527fccabbb9$export$f19b488f7c0547ee);

var $1q7j6 = parcelRequire("1q7j6");

var $5g0c0 = parcelRequire("5g0c0");

var $eaaKH = parcelRequire("eaaKH");
const $22544527fccabbb9$var$customThemeOptions = 'UNSAFE_themeOptions';
const $22544527fccabbb9$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $1q7j6.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $eaaKH.isThemeKind)(kind) && (0, $5g0c0.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $22544527fccabbb9$var$customThemeOptions) try {
            themeObject[$22544527fccabbb9$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("jX9H9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c906ccfd63c5d1c$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $1nilL = parcelRequire("1nilL");

var $jBGt0 = parcelRequire("jBGt0");

var $5mXCg = parcelRequire("5mXCg");
function $2c906ccfd63c5d1c$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $jBGt0.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $jBGt0.default).bind();
    } else (0, $jBGt0.default).unbind();
    if ((0, $dRkX9.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $5mXCg.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $5mXCg.default).bind();
        } else (0, $5mXCg.default).unbind();
    }
    const themeAttributes = (0, $1nilL.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $jBGt0.default).unbind();
        if ((0, $dRkX9.fg)('platform_increased-contrast-themes')) (0, $5mXCg.default).unbind();
    };
}

});
parcelRegister("jBGt0", function(module, exports) {
$parcel$export(module.exports, "default", () => $db6d376ecb651d23$export$2e2bcd8739ae039);

var $6Zi52 = parcelRequire("6Zi52");

var $h6oew = parcelRequire("h6oew");

var $jEJHq = parcelRequire("jEJHq");
const $db6d376ecb651d23$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $db6d376ecb651d23$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $h6oew.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $db6d376ecb651d23$var$darkModeMql = $db6d376ecb651d23$var$isMatchMediaAvailable && window.matchMedia((0, $jEJHq.darkModeMediaQuery));
class $db6d376ecb651d23$var$ColorModeObserver {
    getColorMode() {
        if (!$db6d376ecb651d23$var$darkModeMql) return 'light';
        return $db6d376ecb651d23$var$darkModeMql !== null && $db6d376ecb651d23$var$darkModeMql !== void 0 && $db6d376ecb651d23$var$darkModeMql.matches ? 'dark' : 'light';
    }
    bind() {
        if ($db6d376ecb651d23$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $6Zi52.bind)($db6d376ecb651d23$var$darkModeMql, {
            type: 'change',
            listener: $db6d376ecb651d23$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $db6d376ecb651d23$var$SingletonColorModeObserver = new $db6d376ecb651d23$var$ColorModeObserver();
var $db6d376ecb651d23$export$2e2bcd8739ae039 = $db6d376ecb651d23$var$SingletonColorModeObserver;

});
parcelRegister("jEJHq", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $667a88ad7ba358f8$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $667a88ad7ba358f8$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $667a88ad7ba358f8$export$8662df6937d86fcb);

var $h6oew = parcelRequire("h6oew");

var $hcaq9 = parcelRequire("hcaq9");
const $667a88ad7ba358f8$export$26cd7ae85c7144e5 = async (themeId, preloadedThemeCss)=>{
    if (document.head.querySelector(`style[${(0, $h6oew.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $h6oew.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = preloadedThemeCss ?? await (0, $hcaq9.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $667a88ad7ba358f8$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $667a88ad7ba358f8$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("hcaq9", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $0d035ea14ef1db1a$export$8a48286ed7df6720);

var $dF8nZ = parcelRequire("dF8nZ");
const $0d035ea14ef1db1a$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $dF8nZ.default)[themeId]();
    return themeCss;
};

});
parcelRegister("dF8nZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "themeImportMap", () => $a3915556c9b941e7$export$3a171c49f8c16356);
$parcel$export(module.exports, "default", () => $a3915556c9b941e7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::53ff14285f7c9bd19729a6820212b645>>
 * @codegenCommand yarn build tokens
 */ 




















const $a3915556c9b941e7$export$3a171c49f8c16356 = {
    'light': ()=>(parcelRequire("4Le8Q")),
    'light-future': ()=>(parcelRequire("ne7Sb")),
    'light-finesse': ()=>(parcelRequire("9FQkq")),
    'light-increased-contrast-finesse': ()=>(parcelRequire("lQER1")),
    'light-increased-contrast': ()=>(parcelRequire("bUumT")),
    'UNSAFE-dynamic': ()=>(parcelRequire("KQ2YI")),
    'UNSAFE-dynamic-dark': ()=>(parcelRequire("5leEK")),
    'UNSAFE-test-light': ()=>(parcelRequire("blavs")),
    'UNSAFE-test-dark': ()=>(parcelRequire("2ECcG")),
    'dark': ()=>(parcelRequire("gZL9c")),
    'dark-future': ()=>(parcelRequire("gJC7A")),
    'dark-finesse': ()=>(parcelRequire("cYUXu")),
    'dark-increased-contrast-finesse': ()=>(parcelRequire("8PRQn")),
    'dark-increased-contrast': ()=>(parcelRequire("ikybC")),
    'spacing': ()=>(parcelRequire("jaRTu")),
    'UNSAFE-spacing': ()=>(parcelRequire("dcInn")),
    'typography': ()=>(parcelRequire("4BM2U")),
    'UNSAFE-typography': ()=>(parcelRequire("g3rIV")),
    'typography-finesse': ()=>(parcelRequire("185hb")),
    'shape': ()=>(parcelRequire("18gUd")),
    'motion': ()=>(parcelRequire("c3TpQ"))
};
var $a3915556c9b941e7$export$2e2bcd8739ae039 = $a3915556c9b941e7$export$3a171c49f8c16356;

});
parcelRegister("4Le8Q", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("eRkqo").then(()=>parcelRequire('c0T0f'));

});

parcelRegister("ne7Sb", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("38pa9").then(()=>parcelRequire('1kwIr'));

});

parcelRegister("9FQkq", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5lBHi").then(()=>parcelRequire('3dMoM'));

});

parcelRegister("lQER1", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hQQKA").then(()=>parcelRequire('dHwQv'));

});

parcelRegister("bUumT", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hbA6g").then(()=>parcelRequire('f6i9M'));

});

parcelRegister("KQ2YI", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bV45P").then(()=>parcelRequire('dhiUZ'));

});

parcelRegister("5leEK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("wrbKQ").then(()=>parcelRequire('5H2QX'));

});

parcelRegister("blavs", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("iglxw").then(()=>parcelRequire('88tyO'));

});

parcelRegister("2ECcG", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cc1fK").then(()=>parcelRequire('esMFq'));

});

parcelRegister("gZL9c", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("98vUs").then(()=>parcelRequire('ksVrL'));

});

parcelRegister("gJC7A", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5e5H4").then(()=>parcelRequire('6ArMx'));

});

parcelRegister("cYUXu", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gfz6I").then(()=>parcelRequire('9Yyqx'));

});

parcelRegister("8PRQn", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6dL8A").then(()=>parcelRequire('9X5dS'));

});

parcelRegister("ikybC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gu05g").then(()=>parcelRequire('fIy1J'));

});

parcelRegister("jaRTu", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6mfZY").then(()=>parcelRequire('jJQYq'));

});

parcelRegister("dcInn", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("9Qrqv").then(()=>parcelRequire('dulNl'));

});

parcelRegister("4BM2U", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("lYySd").then(()=>parcelRequire('eoTaM'));

});

parcelRegister("g3rIV", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("baclC").then(()=>parcelRequire('ibOCp'));

});

parcelRegister("185hb", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jBeve").then(()=>parcelRequire('fg1Jk'));

});

parcelRegister("18gUd", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jHw5e").then(()=>parcelRequire('d593m'));

});

parcelRegister("c3TpQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("f4hrE").then(()=>parcelRequire('2lni3'));

});





parcelRegister("5mXCg", function(module, exports) {
$parcel$export(module.exports, "default", () => $315126131d7a1964$export$2e2bcd8739ae039);

var $6Zi52 = parcelRequire("6Zi52");

var $h6oew = parcelRequire("h6oew");

var $jEJHq = parcelRequire("jEJHq");
const $315126131d7a1964$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $315126131d7a1964$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $h6oew.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $315126131d7a1964$var$contrastModeMql = $315126131d7a1964$var$isMatchMediaAvailable && window.matchMedia((0, $jEJHq.moreContrastMediaQuery));
class $315126131d7a1964$var$ContrastModeObserver {
    getContrastMode() {
        if (!$315126131d7a1964$var$contrastModeMql) return 'no-preference';
        return $315126131d7a1964$var$contrastModeMql !== null && $315126131d7a1964$var$contrastModeMql !== void 0 && $315126131d7a1964$var$contrastModeMql.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($315126131d7a1964$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $6Zi52.bind)($315126131d7a1964$var$contrastModeMql, {
            type: 'change',
            listener: $315126131d7a1964$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $315126131d7a1964$var$SingletonContrastModeObserver = new $315126131d7a1964$var$ContrastModeObserver();
var $315126131d7a1964$export$2e2bcd8739ae039 = $315126131d7a1964$var$SingletonContrastModeObserver;

});


parcelRegister("4geqn", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $342355792a623093$export$bd1ac9300b0e885a);

var $h6oew = parcelRequire("h6oew");

var $fi6ke = parcelRequire("fi6ke");
function $342355792a623093$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $fi6ke.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $h6oew.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $h6oew.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("eSTRI", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $85c525505b0908fa$export$5d76d7014f4a5d08);

var $dRkX9 = parcelRequire("dRkX9");

var $2KlHP = parcelRequire("2KlHP");
const $85c525505b0908fa$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
const $85c525505b0908fa$export$5d76d7014f4a5d08 = (themeState)=>{
    if (!(0, $dRkX9.fg)('platform-dst-tokens-finesse')) return [];
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, typography: typography } = themeState;
    const selectedThemes = [
        ...colorMode === 'auto' ? [
            light,
            dark
        ] : [
            themeState[colorMode]
        ],
        typography
    ];
    if (contrastMode !== 'no-preference' && (0, $dRkX9.fg)('platform_increased-contrast-themes')) selectedThemes.forEach((themeId)=>{
        const increasedContrastTheme = (0, $2KlHP.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    const themeOverridePreferences = selectedThemes.map((themeId)=>$85c525505b0908fa$var$finesseOverrides[themeId]).filter((themeId)=>themeId !== undefined);
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("2KlHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $fad2eb5173423a37$export$2e2bcd8739ae039);

var $5tRJN = parcelRequire("5tRJN");
function $fad2eb5173423a37$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $5tRJN.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("5tRJN", function(module, exports) {
$parcel$export(module.exports, "themeOverrideIds", () => $501864357031735d$export$ba8a43b83ecc69f8);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $501864357031735d$export$92ba366331403db2);
$parcel$export(module.exports, "default", () => $501864357031735d$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $8y8q9 = parcelRequire("8y8q9");


/**
 * Contrast preferences: The system contrast preference
 */ const $501864357031735d$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $501864357031735d$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
const $501864357031735d$export$92ba366331403db2 = [
    ...(0, $8y8q9.themeIds),
    ...$501864357031735d$export$ba8a43b83ecc69f8
];
const $501864357031735d$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-dynamic': {
        id: 'UNSAFE-dynamic',
        displayName: 'UNSAFE Dynamic Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-dynamic-dark': {
        id: 'UNSAFE-dynamic-dark',
        displayName: 'UNSAFE Dynamic Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'UNSAFE-spacing': {
        id: 'UNSAFE-spacing',
        displayName: 'UNSAFE Dynamic Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        },
        extends: 'spacing'
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'UNSAFE-typography': {
        id: 'UNSAFE-typography',
        displayName: 'UNSAFE Dynamic Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        extends: 'typography'
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$501864357031735d$export$2e2bcd8739ae039 = $501864357031735d$export$9d64ff89b6869900;

});



parcelRegister("lHDyu", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $69dab8af37a70b0b$export$dd6aeb7c823fc03d);

var $dRkX9 = parcelRequire("dRkX9");

var $2KlHP = parcelRequire("2KlHP");
const $69dab8af37a70b0b$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $dRkX9.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $2KlHP.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $dRkX9.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $2KlHP.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});

parcelRegister("3gqeY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("4oE74"),
    $9dnsd("h5tpZ")
]).then(()=>parcelRequire('36bp9'));

});


parcelRegister("dmQVf", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $295f24ffadd27e08$export$a782702263f77544);

var $fc4bM = parcelRequire("fc4bM");

var $aehaU = parcelRequire("aehaU");
const $295f24ffadd27e08$export$a782702263f77544 = ()=>{
    return (0, $fc4bM.useContext)((0, $aehaU.AppProviderThemingEnabledContext));
};

});
parcelRegister("aehaU", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $8ef139bb41985cb0$export$d2def9838ca456c0);

var $fc4bM = parcelRequire("fc4bM");
const $8ef139bb41985cb0$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $fc4bM.createContext)(false);

});


parcelRegister("l6UsL", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $07bc52afe8d6ac6f$export$26aa23367bfbab0e);

var $fc4bM = parcelRequire("fc4bM");

var $77pV6 = parcelRequire("77pV6");
const $07bc52afe8d6ac6f$export$26aa23367bfbab0e = ()=>{
    return (0, $fc4bM.useContext)((0, $77pV6.InsideAppProviderContext));
};

});
parcelRegister("77pV6", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $f7d93cecb5e8facc$export$7981b2444296e410);

var $fc4bM = parcelRequire("fc4bM");
const $f7d93cecb5e8facc$export$7981b2444296e410 = /*#__PURE__*/ (0, $fc4bM.createContext)(false);

});


parcelRegister("9ulCF", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $0241cd327a6a4e6f$export$49ddd74a6729fdb0);

var $fc4bM = parcelRequire("fc4bM");
const $0241cd327a6a4e6f$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});

parcelRegister("54Vfc", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $f8368f7f4951c0ff$export$332347eeb335453c);

var $fc4bM = parcelRequire("fc4bM");
const $f8368f7f4951c0ff$export$332347eeb335453c = /*#__PURE__*/ (0, $fc4bM.createContext)(false);

});

parcelRegister("9n2Vu", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $7f0ead0b6af3c2ae$export$b06130bad0bbc70f);

var $fc4bM = parcelRequire("fc4bM");
const $7f0ead0b6af3c2ae$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});

parcelRegister("42TF6", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $65f5591e660a484f$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $65f5591e660a484f$export$f7a97b47760e2a13);

var $fc4bM = parcelRequire("fc4bM");
const $65f5591e660a484f$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $65f5591e660a484f$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});

parcelRegister("6DuHi", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $232014d7c40d61a6$export$7ca11437599d653d);

var $fc4bM = parcelRequire("fc4bM");

var $54Vfc = parcelRequire("54Vfc");
const $232014d7c40d61a6$export$7ca11437599d653d = ()=>{
    return (0, $fc4bM.useContext)((0, $54Vfc.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("3VreF", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", () => $33487a2cf7d6a13c$export$ae40e6ba718781b9);

var $fc4bM = parcelRequire("fc4bM");

var $dF8nZ = parcelRequire("dF8nZ");

var $eSTRI = parcelRequire("eSTRI");

var $lHDyu = parcelRequire("lHDyu");
const $33487a2cf7d6a13c$var$themeCssPromises = new Map();
function $33487a2cf7d6a13c$var$getThemeCssPromise(themeId) {
    let themeCssPromise = $33487a2cf7d6a13c$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $dF8nZ.themeImportMap)[themeId]().then(({ default: css })=>css);
        $33487a2cf7d6a13c$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $33487a2cf7d6a13c$var$getInlineThemeCss(themeId) {
    var _document$body$queryS;
    const reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).use;
    const isServer = globalThis.__SERVER__ === true || typeof document === 'undefined';
    if (isServer) return reactUse === null || reactUse === void 0 ? void 0 : reactUse($33487a2cf7d6a13c$var$getThemeCssPromise(themeId));
    return ((_document$body$queryS = document.body.querySelector(`style[data-theme="${themeId}"]`)) === null || _document$body$queryS === void 0 ? void 0 : _document$body$queryS.textContent) ?? undefined;
}
function $33487a2cf7d6a13c$export$ae40e6ba718781b9(theme, colorMode) {
    const themeState = {
        ...theme,
        colorMode: colorMode,
        contrastMode: 'no-preference'
    };
    const themeIds = [
        ...(0, $lHDyu.getThemePreferences)(themeState),
        ...(0, $eSTRI.getThemeOverridePreferences)(themeState)
    ];
    return [
        ...new Set(themeIds)
    ].map((themeId)=>{
        const css = $33487a2cf7d6a13c$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter((style)=>style !== undefined);
}

});

parcelRegister("9PeGV", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $adb5cbf06d0d9f47$export$7d4a7e812d176b24);

var $j5N6B = parcelRequire("j5N6B");

var $dF8nZ = parcelRequire("dF8nZ");

var $9oi4Y = parcelRequire("9oi4Y");
const $adb5cbf06d0d9f47$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $9oi4Y.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $dF8nZ.themeImportMap)[themeId]();
    return themeCss;
};
const $adb5cbf06d0d9f47$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $j5N6B.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $9oi4Y.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $adb5cbf06d0d9f47$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $adb5cbf06d0d9f47$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $adb5cbf06d0d9f47$var$mountThemeCss(themeCss, themeId);
};
const $adb5cbf06d0d9f47$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($adb5cbf06d0d9f47$var$loadAndMountThemeCss);
};

});
parcelRegister("9oi4Y", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $b9c30537f8fe238c$export$835a0dc855d02822);

var $j5N6B = parcelRequire("j5N6B");

var $h6oew = parcelRequire("h6oew");
function $b9c30537f8fe238c$export$835a0dc855d02822(themeId) {
    const doc = (0, $j5N6B.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $h6oew.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("h5e7t", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $f0013f91c1edf6f2$export$20f3076712c8dfa);

var $fc4bM = parcelRequire("fc4bM");

var $hvzwL = parcelRequire("hvzwL");

var $2cpQq = parcelRequire("2cpQq");

var $9ulCF = parcelRequire("9ulCF");
function $f0013f91c1edf6f2$export$20f3076712c8dfa() {
    const value = (0, $fc4bM.useContext)((0, $9ulCF.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $hvzwL.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $fc4bM.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
    (0, $fc4bM.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $2cpQq.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("2cpQq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ThemeMutationObserver", () => $368f1b3bef33e8ad$export$b741a7c3bcb1c635);
$parcel$export(module.exports, "default", () => $368f1b3bef33e8ad$export$2e2bcd8739ae039);

var $h6oew = parcelRequire("h6oew");

var $hvzwL = parcelRequire("hvzwL");
class $368f1b3bef33e8ad$export$b741a7c3bcb1c635 {
    static #_ = this.observer = null;
    static #_2 = this.callbacks = new Set();
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $368f1b3bef33e8ad$export$b741a7c3bcb1c635.callbacks.add(callback);
    }
    observe() {
        if (!$368f1b3bef33e8ad$export$b741a7c3bcb1c635.observer) {
            $368f1b3bef33e8ad$export$b741a7c3bcb1c635.observer = new MutationObserver(()=>{
                const theme = (0, $hvzwL.getGlobalTheme)();
                $368f1b3bef33e8ad$export$b741a7c3bcb1c635.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $368f1b3bef33e8ad$export$b741a7c3bcb1c635.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $h6oew.THEME_DATA_ATTRIBUTE),
                    (0, $h6oew.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $368f1b3bef33e8ad$export$b741a7c3bcb1c635.callbacks.delete(this.callback);
        if ($368f1b3bef33e8ad$export$b741a7c3bcb1c635.callbacks.size === 0 && $368f1b3bef33e8ad$export$b741a7c3bcb1c635.observer) {
            $368f1b3bef33e8ad$export$b741a7c3bcb1c635.observer.disconnect();
            $368f1b3bef33e8ad$export$b741a7c3bcb1c635.observer = null;
        }
    }
}
var $368f1b3bef33e8ad$export$2e2bcd8739ae039 = $368f1b3bef33e8ad$export$b741a7c3bcb1c635;

});


parcelRegister("dTBq5", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $494afd3bbe34e28c$export$c582005add11e141);

var $foC0e = parcelRequire("foC0e");

var $fNCI9 = parcelRequire("fNCI9");
const $494afd3bbe34e28c$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $foC0e.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $foC0e.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $fNCI9.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $494afd3bbe34e28c$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $494afd3bbe34e28c$var$getPortalParent().appendChild(container);
};

});
parcelRegister("foC0e", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $c5b4aed2e3444b39$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $c5b4aed2e3444b39$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $c5b4aed2e3444b39$export$13f57c02915787b3);
const $c5b4aed2e3444b39$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $c5b4aed2e3444b39$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $c5b4aed2e3444b39$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("fNCI9", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $d646d855db20b55e$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $d646d855db20b55e$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("5EIOe", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $0c6b0576ae8d92be$export$26ae5ca175b4ec5a);

var $foC0e = parcelRequire("foC0e");
const $0c6b0576ae8d92be$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $foC0e.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("1xSck", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $e47d7ce4b370ecb1$export$da99f98bf3fe55b3);

var $foC0e = parcelRequire("foC0e");

var $fNCI9 = parcelRequire("fNCI9");
const $e47d7ce4b370ecb1$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $foC0e.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $foC0e.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $fNCI9.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $e47d7ce4b370ecb1$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $e47d7ce4b370ecb1$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("02FhI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c4d48d2e8fe51d4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $gvJqv = parcelRequire("gvJqv");

var $h5e7t = parcelRequire("h5e7t");

var $6DuHi = parcelRequire("6DuHi");

var $l0hBX = parcelRequire("l0hBX");

var $li5rG = parcelRequire("li5rG");

var $2a1oW = parcelRequire("2a1oW");
function $4c4d48d2e8fe51d4$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $fc4bM.useState)(null);
    const colorMode = (0, $h5e7t.useColorMode)();
    const isInsideThemeProvider = (0, $6DuHi.useIsInsideThemeProvider)();
    (0, $l0hBX.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $li5rG.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $2a1oW.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gvJqv.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $bTkYf.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("l0hBX", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $0b13476ef397b2f0$export$700979bc83e7db82);

var $fc4bM = parcelRequire("fc4bM");
const $0b13476ef397b2f0$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $fc4bM.useLayoutEffect) : (0, $fc4bM.useEffect);

});

parcelRegister("li5rG", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $eaf1ede13e1de4cf$export$fef014d7cef9e543);

var $foC0e = parcelRequire("foC0e");
const $eaf1ede13e1de4cf$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $eaf1ede13e1de4cf$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($eaf1ede13e1de4cf$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $foC0e.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("2a1oW", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $6790881f47aa4f92$export$95029ca7aca2989e);

var $foC0e = parcelRequire("foC0e");

var $fNCI9 = parcelRequire("fNCI9");
const $6790881f47aa4f92$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $6790881f47aa4f92$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($6790881f47aa4f92$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $foC0e.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            const parent = document.createElement('div');
            parent.className = (0, $foC0e.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $fNCI9.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("h41S1", function(module, exports) {
$parcel$export(module.exports, "default", () => $626ffa99c5f82643$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $l0hBX = parcelRequire("l0hBX");
const $626ffa99c5f82643$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $fc4bM.useState)(false);
    const [useMountEffect] = (0, $fc4bM.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $l0hBX.useIsomorphicLayoutEffect) : (0, $fc4bM.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $626ffa99c5f82643$export$2e2bcd8739ae039 = $626ffa99c5f82643$var$useIsSubsequentRender;

});

parcelRegister("9fHXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $645b2055bce68d1e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7DEbz = parcelRequire("7DEbz");

var $RQcIR = parcelRequire("RQcIR");
const $645b2055bce68d1e$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $fc4bM.useEffect)(()=>{
        (0, $RQcIR.default)((0, $7DEbz.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $RQcIR.default)((0, $7DEbz.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $645b2055bce68d1e$export$2e2bcd8739ae039 = $645b2055bce68d1e$var$useFirePortalEvent;

});
parcelRegister("7DEbz", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $dbe19f98637e4bcf$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $dbe19f98637e4bcf$export$80816bd900e5bd00);
/**
 * @deprecated Top-layer surfaces do not fire portal events. To know when a top-layer surface opens
 * or closes, listen for the native `toggle` and `close` events.
 */ const $dbe19f98637e4bcf$export$ed5835cc67e87f72 = 'akPortalMount';
const $dbe19f98637e4bcf$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("RQcIR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc319d0a502c506$export$2e2bcd8739ae039);
const $7bc319d0a502c506$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $7bc319d0a502c506$var$getLayerName = (zIndex)=>{
    return $7bc319d0a502c506$var$zIndexToName.hasOwnProperty(zIndex) ? $7bc319d0a502c506$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $7bc319d0a502c506$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $7bc319d0a502c506$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $7bc319d0a502c506$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $7bc319d0a502c506$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("2SWSA", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $2VCDt = parcelRequire("2VCDt");
module.exports = Object.assign({}, $2VCDt, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($2VCDt.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("2VCDt", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $b94ee4d4a1824de2$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $b94ee4d4a1824de2$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $b94ee4d4a1824de2$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $b94ee4d4a1824de2$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $b94ee4d4a1824de2$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $b94ee4d4a1824de2$export$c93026a968943f95 = 'light';
const $b94ee4d4a1824de2$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $b94ee4d4a1824de2$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});


parcelRegister("bwRpG", function(module, exports) {
$parcel$export(module.exports, "DefaultRoleContext", () => $d76dd3bb610f5b55$export$acf85578b9060d4d);
$parcel$export(module.exports, "useDefaultRole", () => $d76dd3bb610f5b55$export$940503e6d676c973);

var $fc4bM = parcelRequire("fc4bM");
const $d76dd3bb610f5b55$export$acf85578b9060d4d = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
function $d76dd3bb610f5b55$export$940503e6d676c973() {
    return (0, $fc4bM.useContext)($d76dd3bb610f5b55$export$acf85578b9060d4d);
}

});

parcelRegister("kZDsQ", function(module, exports) {
$parcel$export(module.exports, "register", () => $31b638ca8b5d92de$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $6Zi52 = parcelRequire("6Zi52");
const $31b638ca8b5d92de$var$registrations = new Set();
let $31b638ca8b5d92de$var$cleanupEndEventListeners = null;
function $31b638ca8b5d92de$var$onDragStart() {
    if ($31b638ca8b5d92de$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $31b638ca8b5d92de$var$cleanupEndEventListeners = (0, $6Zi52.bindAll)(window, [
        {
            type: 'dragend',
            listener: $31b638ca8b5d92de$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $31b638ca8b5d92de$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $31b638ca8b5d92de$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($31b638ca8b5d92de$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $31b638ca8b5d92de$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $31b638ca8b5d92de$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $31b638ca8b5d92de$var$cleanupEndEventListeners = null;
    const clone = Array.from($31b638ca8b5d92de$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $31b638ca8b5d92de$var$bindStartEvents() {
    return (0, $6Zi52.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $31b638ca8b5d92de$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $31b638ca8b5d92de$var$onDragStart
        }
    ]);
}
let $31b638ca8b5d92de$var$cleanupStartEventListeners = null;
function $31b638ca8b5d92de$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$31b638ca8b5d92de$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $31b638ca8b5d92de$var$cleanupStartEventListeners = $31b638ca8b5d92de$var$bindStartEvents();
    $31b638ca8b5d92de$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $31b638ca8b5d92de$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $31b638ca8b5d92de$var$registrations.delete(registration);
        if ($31b638ca8b5d92de$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $31b638ca8b5d92de$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $31b638ca8b5d92de$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("6Aut2", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $f1d0b776e89257f9$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $f1d0b776e89257f9$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $f1d0b776e89257f9$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $f1d0b776e89257f9$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $f1d0b776e89257f9$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $f1d0b776e89257f9$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("2J80J", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $a290b59c089b1d8f$export$2e68479e0a5d8746);
function $a290b59c089b1d8f$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("4Ug84", function(module, exports) {
$parcel$export(module.exports, "show", () => $1f3bdd453f2410fc$export$57bf213be019eeb0);

var $dRkX9 = parcelRequire("dRkX9");
let $1f3bdd453f2410fc$var$delayId = null;
function $1f3bdd453f2410fc$var$clearScheduled() {
    if ($1f3bdd453f2410fc$var$delayId != null) {
        window.clearTimeout($1f3bdd453f2410fc$var$delayId);
        $1f3bdd453f2410fc$var$delayId = null;
    }
}
function $1f3bdd453f2410fc$var$scheduleTimeout(fn, delay) {
    $1f3bdd453f2410fc$var$clearScheduled();
    $1f3bdd453f2410fc$var$delayId = window.setTimeout(()=>{
        $1f3bdd453f2410fc$var$delayId = null;
        fn();
    }, delay);
}
let $1f3bdd453f2410fc$var$active = null;
function $1f3bdd453f2410fc$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($1f3bdd453f2410fc$var$active && $1f3bdd453f2410fc$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $1f3bdd453f2410fc$var$clearScheduled();
            $1f3bdd453f2410fc$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $1f3bdd453f2410fc$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $1f3bdd453f2410fc$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $1f3bdd453f2410fc$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($1f3bdd453f2410fc$var$active && $1f3bdd453f2410fc$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($1f3bdd453f2410fc$var$active) {
            $1f3bdd453f2410fc$var$clearScheduled();
            $1f3bdd453f2410fc$var$active.entry.hide({
                isImmediate: true
            });
            $1f3bdd453f2410fc$var$active.entry.done();
            $1f3bdd453f2410fc$var$active = null;
        }
        // this tooltip is now the active tooltip
        $1f3bdd453f2410fc$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $1f3bdd453f2410fc$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("9prlt", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c8bcc61a38a313$export$2e2bcd8739ae039);

var $doZJb = parcelRequire("doZJb");
function $86c8bcc61a38a313$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $doZJb.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("doZJb", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $682c682801a7215d$export$6ee17796e3d70de2);

var $3zBNx = parcelRequire("3zBNx");
function $682c682801a7215d$export$6ee17796e3d70de2() {
    const uid = (0, $3zBNx.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("aShMO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d9418bd276cec6$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $9Jrka = parcelRequire("9Jrka");
const $f7d9418bd276cec6$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $f7d9418bd276cec6$var$TooltipContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9Jrka.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            $f7d9418bd276cec6$var$styles.base,
            truncate && $f7d9418bd276cec6$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});
$f7d9418bd276cec6$var$TooltipContainer.displayName = 'TooltipContainer';
var $f7d9418bd276cec6$export$2e2bcd8739ae039 = $f7d9418bd276cec6$var$TooltipContainer;

});
parcelRegister("9Jrka", function(module, exports) {
$parcel$export(module.exports, "default", () => $ada259ea20e951c8$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bwRpG = parcelRequire("bwRpG");

var $3fpGr = parcelRequire("3fpGr");
const $ada259ea20e951c8$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $ada259ea20e951c8$var$TooltipPrimitive = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const defaultRole = (0, $bwRpG.useDefaultRole)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
            role: role ?? defaultRole ?? 'tooltip',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $2R2iS.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bwRpG.DefaultRoleContext).Provider, {
                    value: undefined,
                    children: children
                }),
                shortcut && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3fpGr.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$ada259ea20e951c8$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $ada259ea20e951c8$export$2e2bcd8739ae039 = $ada259ea20e951c8$var$TooltipPrimitive;

});
parcelRegister("3fpGr", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $a7788374b9783c13$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $a7788374b9783c13$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $a7788374b9783c13$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            $a7788374b9783c13$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $3LM7S.jsx)("kbd", {
                className: (0, $2R2iS.default)([
                    $a7788374b9783c13$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});






parcelRegister("8qVo1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab13f98c2ff7f0a6$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ab13f98c2ff7f0a6$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    error: {
        id: 'cmdb.object.card.error.loading.object',
        defaultMessage: 'Error occured loading object',
        description: 'Displayed when a value for a CMDB Assets field does not load'
    },
    expandLabel: {
        id: 'cmdb.object.card.expand.label',
        defaultMessage: 'Expand object details',
        description: 'Label for the expand button on the CMDB object field'
    },
    collapseLabel: {
        id: 'cmdb.object.card.collapse.label',
        defaultMessage: 'Collapse object details',
        description: 'Label for the collapse button on the CMDB object field'
    },
    noAttributes: {
        id: 'cmdb.object.card.no.attributes',
        defaultMessage: 'No attributes to display',
        description: 'Shown when an expanded CMDB object card has no attribute details available'
    },
    loadingAttributes: {
        id: 'cmdb.object.card.loading.attributes',
        defaultMessage: 'Loading object details',
        description: 'Accessible label for the spinner shown while a CMDB object card lazily loads its attributes on expand'
    }
});

});






parcelRegister("aZfc9", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetricsV3", () => $199a751a87c78c2f$export$229e3124c8dc9ca9);
$parcel$export(module.exports, "startPageLoad", () => $199a751a87c78c2f$export$5244fe38dccf2e1d);
$parcel$export(module.exports, "perfMark", () => $199a751a87c78c2f$export$61a691dabeb80f51);

var $fc4bM = parcelRequire("fc4bM");

var $27NB5 = parcelRequire("27NB5");

var $7rEw1 = parcelRequire("7rEw1");

var $2gs1B = parcelRequire("2gs1B");

var $5QekB = parcelRequire("5QekB");

var $6lbrU = parcelRequire("6lbrU");

var $1NC3I = parcelRequire("1NC3I");

var $jgb8T = parcelRequire("jgb8T");

var $6LH8a = parcelRequire("6LH8a");

var $55vtE = parcelRequire("55vtE");

var $5OiZV = parcelRequire("5OiZV");

var $a3HS6 = parcelRequire("a3HS6");
const $199a751a87c78c2f$var$PERFORMANCE_MARK_PREFIX = 'jsd.performance.profile.customer.portal';
/**
 * List of feature flags whose value has to be sent along with Browser metrics.
 */ const $199a751a87c78c2f$var$FEATURE_FLAGS_TO_REPORT = [];
const $199a751a87c78c2f$export$229e3124c8dc9ca9 = ()=>{
    var _window$JSD_CUSTOMER_;
    if (typeof window === 'undefined') return;
    /**
   * tenant and region information for UFO
   */ const region = (0, $6LH8a.getMeta)('ajs-region');
    const tenantType = (0, $6LH8a.getMeta)('ajs-is-synthetic') === 'true' ? (0, $a3HS6.TenantType).Synthetic : (0, $a3HS6.TenantType).RealUser;
    /**
   * Framework and Product Info
   */ const perimeter = (0, $7rEw1.isFedRamp)() ? (0, $27NB5.PerimeterType).FEDRAMP_MODERATE : (0, $27NB5.PerimeterType).COMMERCIAL;
    const info = {
        perimeter: perimeter,
        product: 'jira',
        app: {
            version: {
                web: ((_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || _window$JSD_CUSTOMER_ === void 0 ? void 0 : _window$JSD_CUSTOMER_.buildKey) || 'local'
            },
            framework: {
                version: $fc4bM.version,
                name: 'react'
            }
        },
        region: region !== null ? region : 'none'
    };
    /**
   * eventPipelineClient expects pre configured `analytics-web-client` promise.
   */ const endpoints = {
        eventPipelineClient: (0, $6lbrU.getAnalyticsWebClientPromise)().then((client)=>{
            return client.getInstance();
        })
    };
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (0, $6lbrU.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $5OiZV.payloadPublisher).setup({
            product: info.product,
            app: info.app,
            region: region || info.region,
            gasv3: client.getInstance(),
            resourceTimings: (0, $5QekB.resourceTimingsPlugin),
            featureFlags: $199a751a87c78c2f$var$FEATURE_FLAGS_TO_REPORT,
            ...tenantType && {
                tenantType: tenantType
            }
        });
    });
    (0, $2gs1B.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: {
            featureFlags: (0, $5QekB.featureFlagsPlugin),
            resourceTimings: (0, $5QekB.resourceTimingsPlugin)
        },
        events: {
            all: {
                featureFlags: $199a751a87c78c2f$var$FEATURE_FLAGS_TO_REPORT,
                plugins: [
                    (0, $5QekB.customPerfMarks)
                ]
            }
        },
        ssr: {
            getDoneMark: ()=>{
                var _getMark;
                return ((_getMark = (0, $55vtE.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) || null;
            }
        }
    });
};
let $199a751a87c78c2f$var$isInitialPageLoadTracked = false;
const $199a751a87c78c2f$export$5244fe38dccf2e1d = (screenName)=>{
    if (typeof window === 'undefined') return;
    if ((0, $1NC3I.isPageLoadInstrumented)(screenName)) {
        (0, $jgb8T.devLog)('Browser metrics v3: startPageLoad() fired');
        (0, $2gs1B.browserMetrics).startPageLoad({
            isInitial: !$199a751a87c78c2f$var$isInitialPageLoadTracked
        });
    }
    if (!$199a751a87c78c2f$var$isInitialPageLoadTracked) $199a751a87c78c2f$var$isInitialPageLoadTracked = true;
};
function $199a751a87c78c2f$export$61a691dabeb80f51(shortKey) {
    let key = shortKey.trim();
    if (!key.startsWith($199a751a87c78c2f$var$PERFORMANCE_MARK_PREFIX)) key = `${$199a751a87c78c2f$var$PERFORMANCE_MARK_PREFIX}.${shortKey}`;
    window.performance && window.performance.mark && window.performance.mark(key);
}

});
parcelRegister("2gs1B", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $3a7d4271c0af433c$export$c08e7affcf78b064);

var $imfsZ = parcelRequire("imfsZ");

var $jMy1f = parcelRequire("jMy1f");

var $5z5pU = parcelRequire("5z5pU");

var $7XXq3 = parcelRequire("7XXq3");

var $gcqGF = parcelRequire("gcqGF");

var $dMXrj = parcelRequire("dMXrj");

var $ihXkA = parcelRequire("ihXkA");

var $9YX3G = parcelRequire("9YX3G");
const $3a7d4271c0af433c$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            var _config$events$BMEven, _config$ssr;
            (0, $7XXq3.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $9YX3G.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $gcqGF.webVitalsObserver).start();
            if (config.debug) {
                (0, $jMy1f.logger).enable();
                (0, $ihXkA.submitter).setDebug(true);
                (0, $5z5pU.pageLoadMetaMetric).setDebug(true);
            }
            (0, $ihXkA.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $imfsZ.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $dMXrj.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $5z5pU.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $5z5pU.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $5z5pU.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $5z5pU.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $5z5pU.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $5z5pU.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $3a7d4271c0af433c$export$c08e7affcf78b064 = $3a7d4271c0af433c$var$makeBrowserMetrics();

});
parcelRegister("imfsZ", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $df71c61dc16aaf92$export$9e87a201397ac0a9);
const $df71c61dc16aaf92$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $df71c61dc16aaf92$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("jMy1f", function(module, exports) {
$parcel$export(module.exports, "logger", () => $db22b4bb54e90807$export$af88d00dbe7f521);
const $db22b4bb54e90807$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("5z5pU", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $9fc6918de4018564$export$24b7a1a311eb05dc);

var $9YX3G = parcelRequire("9YX3G");

var $hc42S = parcelRequire("hc42S");

var $1L3j0 = parcelRequire("1L3j0");
class $9fc6918de4018564$export$9609608c00ea5077 extends (0, $1L3j0.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $hc42S.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $9fc6918de4018564$export$24b7a1a311eb05dc = new $9fc6918de4018564$export$9609608c00ea5077({
    type: (0, $9YX3G.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("9YX3G", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $458e3ab79930def7$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $458e3ab79930def7$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $458e3ab79930def7$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $458e3ab79930def7$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $458e3ab79930def7$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $458e3ab79930def7$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $458e3ab79930def7$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $458e3ab79930def7$export$983b017156c2aee2);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $458e3ab79930def7$export$60c0193054fc3040);
var $458e3ab79930def7$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $458e3ab79930def7$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $458e3ab79930def7$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $458e3ab79930def7$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $458e3ab79930def7$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $458e3ab79930def7$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $458e3ab79930def7$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $458e3ab79930def7$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $458e3ab79930def7$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});

parcelRegister("hc42S", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $4edd194d85174f3b$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $4edd194d85174f3b$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $4edd194d85174f3b$export$2bce4ffdd840e878);

var $dRkX9 = parcelRequire("dRkX9");

var $9c6HD = parcelRequire("9c6HD");

var $3oxNO = parcelRequire("3oxNO");

var $cIxIF = parcelRequire("cIxIF");

var $7jpon = parcelRequire("7jpon");

var $bkEmU = parcelRequire("bkEmU");

var $14oNX = parcelRequire("14oNX");

var $jMy1f = parcelRequire("jMy1f");

var $7XXq3 = parcelRequire("7XXq3");

var $eA6ck = parcelRequire("eA6ck");
var $4edd194d85174f3b$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $4edd194d85174f3b$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $4edd194d85174f3b$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $4edd194d85174f3b$export$2bce4ffdd840e878 {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $4edd194d85174f3b$var$getPageVisibleState();
        this.traceContext = null;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        var _this$config$timings;
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach((entry)=>{
            if ((0, $14oNX.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $jMy1f.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $4edd194d85174f3b$var$getPageVisibleState();
        (0, $7XXq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
        this.startTrace(this.key);
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $jMy1f.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $jMy1f.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $7XXq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        this.stopTrace();
        return true;
    }
    startTrace(metricKey) {
        if ((0, $dRkX9.fg)('uip_bm3_tracing')) {
            let traceContext = (0, $7jpon.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $cIxIF.generateTraceId)(),
                    spanId: (0, $3oxNO.generateSpanId)()
                };
                (0, $bkEmU.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'bm3.' + metricKey);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $dRkX9.fg)('uip_bm3_tracing')) (0, $9c6HD.clearActiveTrace)();
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $jMy1f.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $7XXq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type,
            ...(0, $dRkX9.fg)('uip_bm3_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
   *
   * @param metric
   * The array of Until metrics can be of two types
   * This function returns an UntilExperience
   */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $4edd194d85174f3b$export$2bce4ffdd840e878 ? (0, $eA6ck.UntilExperience).fromMetric(metricOrConfig) : (0, $eA6ck.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = (currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $4edd194d85174f3b$var$getPageVisibleState();
        this.traceContext = null;
    }
}

});
parcelRegister("9c6HD", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $e7d6d0e6d49f53d7$export$17ab21d7be720b);

var $4mJ7d = parcelRequire("4mJ7d");
function $e7d6d0e6d49f53d7$export$17ab21d7be720b() {
    (0, $4mJ7d.state).context = null;
}

});
parcelRegister("4mJ7d", function(module, exports) {
$parcel$export(module.exports, "state", () => $6e5f7b67763101ea$export$ca000e230c0caa3e);
const $6e5f7b67763101ea$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("3oxNO", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $67a58d637c003507$export$295213bc4d0c54ad);
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $67a58d637c003507$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("cIxIF", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $123b21c01e7add8b$export$dc6d7ea554bcce10);
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $123b21c01e7add8b$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("7jpon", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $2db88be983a67e6e$export$b6ac780db3a3cc77);

var $4mJ7d = parcelRequire("4mJ7d");
function $2db88be983a67e6e$export$b6ac780db3a3cc77() {
    return (0, $4mJ7d.state).context;
}

});

parcelRegister("bkEmU", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $5ecec6389474f8c5$export$a1002be327997103);

var $8BjzM = parcelRequire("8BjzM");

var $4GHX1 = parcelRequire("4GHX1");

var $4mJ7d = parcelRequire("4mJ7d");
const $5ecec6389474f8c5$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $4GHX1.getEnvironment)();
            instance = new (0, $8BjzM.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $5ecec6389474f8c5$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $4mJ7d.state).context !== null) $5ecec6389474f8c5$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $4mJ7d.state).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $4mJ7d.state).context = {
        traceId: traceId,
        spanId: spanId
    };
}

});
parcelRegister("4GHX1", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $a25d1c75e716da79$export$57570b1603cf6adb);

var $2mgM4 = parcelRequire("2mgM4");
function $a25d1c75e716da79$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $2mgM4.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $2mgM4.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $2mgM4.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $2mgM4.envType).STAGING;
    return (0, $2mgM4.envType).PROD;
}

});


parcelRegister("14oNX", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $609bd91fd613fb04$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $609bd91fd613fb04$export$df21d285cfcda81e);
const $609bd91fd613fb04$export$1d17377365286b00 = [
    'ssr'
];
const $609bd91fd613fb04$export$df21d285cfcda81e = 7500;

});

parcelRegister("7XXq3", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d6233e7a7bb2a1b9$export$13e680397ec8f3eb);
class $d6233e7a7bb2a1b9$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d6233e7a7bb2a1b9$export$13e680397ec8f3eb = new $d6233e7a7bb2a1b9$var$VisibilityChangeObserver();

});

parcelRegister("eA6ck", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $748498803049552e$export$3fcc0936ee2cc852);
class $748498803049552e$export$3fcc0936ee2cc852 {
    static #_ = this.FMP = 'fmp';
    static fromConfig(config) {
        return new $748498803049552e$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $748498803049552e$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$748498803049552e$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
   * Get the time it takes for a segment to become fully interactable,
   * regardless of whether it uses the FMP as the stop time. (Eventual load)
   */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$748498803049552e$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});


parcelRegister("1L3j0", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $1912150b7e4119d1$export$fd1447b187f590fe);

var $jMy1f = parcelRequire("jMy1f");

var $hc42S = parcelRequire("hc42S");
class $1912150b7e4119d1$export$fd1447b187f590fe extends (0, $hc42S.BaseMetric) {
    static #_ = this.FMP = 'fmp';
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $jMy1f.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $hc42S.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $jMy1f.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $jMy1f.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $hc42S.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $1912150b7e4119d1$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $1912150b7e4119d1$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($1912150b7e4119d1$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("gcqGF", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $14a5b9fd7881774f$export$253d38dccbb37615);


class $14a5b9fd7881774f$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("fOj0G"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("b24qM"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $14a5b9fd7881774f$export$253d38dccbb37615 = new $14a5b9fd7881774f$var$WebVitalsObserver();

});
parcelRegister("fOj0G", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8xLlu").then(()=>parcelRequire('3h1uS'));

});

parcelRegister("b24qM", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("993oY").then(()=>parcelRequire('jSpMH'));

});


parcelRegister("dMXrj", function(module, exports) {
$parcel$export(module.exports, "Route", () => $adfb9f1b518aaef7$export$e7b0ac011bb776c6);
const $adfb9f1b518aaef7$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("ihXkA", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $7cc6cfd828032f9c$export$c21a25872e3f5a2b);

var $jQYQa = parcelRequire("jQYQa");

var $9YX3G = parcelRequire("9YX3G");

var $1h51p = parcelRequire("1h51p");

var $jyqii = parcelRequire("jyqii");
const $7cc6cfd828032f9c$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $jyqii.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $9YX3G.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $jQYQa.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $1h51p.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("1h51p", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $38f5f021cbb643f1$export$896b6e121bbaec25);

var $14oNX = parcelRequire("14oNX");

var $jMy1f = parcelRequire("jMy1f");

var $kZvJv = parcelRequire("kZvJv");

var $9NR8E = parcelRequire("9NR8E");

var $8MsoE = parcelRequire("8MsoE");

var $3fsa1 = parcelRequire("3fsa1");

var $270bb = parcelRequire("270bb");

var $hwlua = parcelRequire("hwlua");

var $ktqnO = parcelRequire("ktqnO");

var $6Bbe4 = parcelRequire("6Bbe4");

var $1Olvs = parcelRequire("1Olvs");

var $byCAe = parcelRequire("byCAe");

var $bjKFs = parcelRequire("bjKFs");

var $9VLG4 = parcelRequire("9VLG4");

var $jGXmq = parcelRequire("jGXmq");

var $d2eUb = parcelRequire("d2eUb");

var $7I9h3 = parcelRequire("7I9h3");

var $2TzbF = parcelRequire("2TzbF");

var $WaYkc = parcelRequire("WaYkc");

var $l7Fc9 = parcelRequire("l7Fc9");

var $HoJQQ = parcelRequire("HoJQQ");

var $wGtif = parcelRequire("wGtif");

var $2tB7C = parcelRequire("2tB7C");

var $8tjb6 = parcelRequire("8tjb6");

var $fIUhW = parcelRequire("fIUhW");

var $60TJQ = parcelRequire("60TJQ");

var $bUkFp = parcelRequire("bUkFp");

var $bAfWs = parcelRequire("bAfWs");

var $939f0 = parcelRequire("939f0");

var $f2WSf = parcelRequire("f2WSf");

var $jkcas = parcelRequire("jkcas");

var $lVcRp = parcelRequire("lVcRp");

var $dLy1o = parcelRequire("dLy1o");

var $cJtx5 = parcelRequire("cJtx5");

var $9X7dp = parcelRequire("9X7dp");

var $5afzH = parcelRequire("5afzH");

var $kMQSn = parcelRequire("kMQSn");

var $eWzUq = parcelRequire("eWzUq");

var $5N1Uy = parcelRequire("5N1Uy");

var $9YX3G = parcelRequire("9YX3G");
const $38f5f021cbb643f1$var$defaultSet = [
    (0, $1Olvs.eventKey),
    (0, $7I9h3.eventType),
    (0, $9VLG4.eventProduct),
    (0, $bjKFs.eventPopulation),
    (0, $d2eUb.eventRoute),
    (0, $ktqnO.eventId),
    (0, $byCAe.eventLocalTime),
    (0, $jGXmq.eventRegion),
    (0, $8MsoE.appFramework),
    (0, $3fsa1.appVersion),
    (0, $270bb.bmVersion),
    (0, $lVcRp.telemetryBrowser),
    (0, $dLy1o.telemetryCpu),
    (0, $cJtx5.telemetryMemory),
    (0, $9X7dp.telemetryNetwork),
    (0, $hwlua.customData),
    (0, $2TzbF.featureFlags),
    (0, $WaYkc.hostname),
    (0, $939f0.productCustomData),
    (0, $5afzH.appTimings),
    (0, $eWzUq.resourceTimings),
    (0, $5N1Uy.traceContext)
];
const $38f5f021cbb643f1$var$pageLoadCommon = [
    ...$38f5f021cbb643f1$var$defaultSet,
    (0, $bUkFp.pageVisibleState),
    (0, $bAfWs.pageVisibleValue),
    (0, $6Bbe4.eventInitial),
    (0, $8tjb6.pageLoadMetrics),
    (0, $kMQSn.bundleEvalTimings)
];
const $38f5f021cbb643f1$var$initialPageLoadSet = [
    ...$38f5f021cbb643f1$var$pageLoadCommon,
    (0, $HoJQQ.initialPageLoadMetrics),
    (0, $2tB7C.navigationMetrics),
    (0, $jkcas.ssrSuccess),
    (0, $f2WSf.ssrFeatureFlags)
];
const $38f5f021cbb643f1$var$spaTransitionSet = [
    ...$38f5f021cbb643f1$var$pageLoadCommon
];
const $38f5f021cbb643f1$var$pageSegmentLoadSet = [
    ...$38f5f021cbb643f1$var$defaultSet,
    (0, $fIUhW.pageSegmentLoadMetrics),
    (0, $bUkFp.pageVisibleState),
    (0, $bAfWs.pageVisibleValue),
    (0, $6Bbe4.eventInitial),
    (0, $kMQSn.bundleEvalTimings)
];
const $38f5f021cbb643f1$var$interactionSet = [
    ...$38f5f021cbb643f1$var$defaultSet,
    (0, $bUkFp.pageVisibleState),
    (0, $bAfWs.pageVisibleValue),
    (0, $wGtif.interactionMetrics)
];
const $38f5f021cbb643f1$var$customMetricSet = [
    ...$38f5f021cbb643f1$var$defaultSet,
    (0, $bUkFp.pageVisibleState),
    (0, $bAfWs.pageVisibleValue),
    (0, $l7Fc9.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $38f5f021cbb643f1$var$webVitalsMetricSet = [
    ...$38f5f021cbb643f1$var$defaultSet,
    (0, $60TJQ.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $38f5f021cbb643f1$var$waitForCLS = (delay = (0, $14oNX.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $38f5f021cbb643f1$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $jMy1f.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $9YX3G.BMEventsType).PAGE_LOAD && (0, $kZvJv.isPageLoadMetricData)(data) && data.isInitial) set = $38f5f021cbb643f1$var$initialPageLoadSet;
    if (data.config.type === (0, $9YX3G.BMEventsType).PAGE_LOAD && (0, $kZvJv.isPageLoadMetricData)(data) && !data.isInitial) set = $38f5f021cbb643f1$var$spaTransitionSet;
    if (data.config.type === (0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD && (0, $9NR8E.isPageSegmentLoadMetricData)(data)) set = $38f5f021cbb643f1$var$pageSegmentLoadSet;
    if (data.config.type === (0, $9YX3G.BMEventsType).INLINE_RESULT) set = $38f5f021cbb643f1$var$interactionSet;
    if (data.config.type === (0, $9YX3G.BMEventsType).CUSTOM) set = $38f5f021cbb643f1$var$customMetricSet;
    if (data.config.type === (0, $9YX3G.BMEventsType).WEB_VITALS) {
        set = $38f5f021cbb643f1$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $38f5f021cbb643f1$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, // some plugins support page load specific data with special check
        globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("kZvJv", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $68479fe187bc9e44$export$b0e12e7abb0bff11);

var $9YX3G = parcelRequire("9YX3G");
const $68479fe187bc9e44$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $9YX3G.BMEventsType).PAGE_LOAD;
};

});

parcelRegister("9NR8E", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $75b49cd8ecf8439a$export$83d0099ee6dbb5b0);

var $9YX3G = parcelRequire("9YX3G");
const $75b49cd8ecf8439a$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD;
};

});

parcelRegister("8MsoE", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $1599238d92e377ce$export$e34e4529b979f74c);
const $1599238d92e377ce$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("3fsa1", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $ddec7f70bdef6682$export$82ae485178b37419);
const $ddec7f70bdef6682$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("270bb", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $f21010bf72bbb836$export$5cafa465fc876895);
const $f21010bf72bbb836$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("hwlua", function(module, exports) {
$parcel$export(module.exports, "customData", () => $c361b3d0847f90bb$export$f7e743c7db162193);
const $c361b3d0847f90bb$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("ktqnO", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $6d657233cd854679$export$aed28df7ac07d79a);
const $6d657233cd854679$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("6Bbe4", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $e7156593076f61e2$export$fa8e91d436b3ef8b);

var $kZvJv = parcelRequire("kZvJv");

var $9NR8E = parcelRequire("9NR8E");
const $e7156593076f61e2$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $kZvJv.isPageLoadMetricData)(data) && !(0, $9NR8E.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("1Olvs", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $baa4ebeefd099bd8$export$10be2d3a558d3f88);

var $1nkIg = parcelRequire("1nkIg");
const $baa4ebeefd099bd8$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $1nkIg.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("1nkIg", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $828ab5df1fd7c248$export$b334d07f11140768);

var $9YX3G = parcelRequire("9YX3G");
const $828ab5df1fd7c248$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $9YX3G.BMEventsType).CUSTOM:
            return (0, $9YX3G.StorableBMEventsType).CUSTOM;
        case (0, $9YX3G.BMEventsType).INLINE_RESULT:
            return (0, $9YX3G.StorableBMEventsType).INLINE_RESULT;
        case (0, $9YX3G.BMEventsType).PAGE_LOAD:
            return (0, $9YX3G.StorableBMEventsType).PAGE_LOAD;
        case (0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $9YX3G.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $9YX3G.BMEventsType).WEB_VITALS:
            return (0, $9YX3G.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("byCAe", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $3527dc09e3343e99$export$5219854ae7ec45da);

var $iY5sc = parcelRequire("iY5sc");
const $3527dc09e3343e99$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $iY5sc.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $iY5sc.default)(new Date(), 'i'), 10)
    });

});
parcelRegister("iY5sc", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcf20f9a445c703e$export$2e2bcd8739ae039);

var $abJ7q = parcelRequire("abJ7q");

var $4xhXe = parcelRequire("4xhXe");

var $a3cTc = parcelRequire("a3cTc");

var $419Ty = parcelRequire("419Ty");

var $jRPwQ = parcelRequire("jRPwQ");

var $hHLVj = parcelRequire("hHLVj");

var $eTCip = parcelRequire("eTCip");

var $1Cu8A = parcelRequire("1Cu8A");

var $3mokv = parcelRequire("3mokv");

var $4WP6t = parcelRequire("4WP6t");

var $HzLXG = parcelRequire("HzLXG");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $dcf20f9a445c703e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $dcf20f9a445c703e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $dcf20f9a445c703e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $dcf20f9a445c703e$var$doubleQuoteRegExp = /''/g;
var $dcf20f9a445c703e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $dcf20f9a445c703e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $3mokv.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $4WP6t.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $HzLXG.default);
    var firstWeekContainsDate = (0, $1Cu8A.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $1Cu8A.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $a3cTc.default)(dirtyDate);
    if (!(0, $abJ7q.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $hHLVj.default)(originalDate);
    var utcDate = (0, $4xhXe.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($dcf20f9a445c703e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $jRPwQ.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($dcf20f9a445c703e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $dcf20f9a445c703e$var$cleanEscapedString(substring);
        var formatter = (0, $419Ty.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $eTCip.isProtectedWeekYearToken)(substring)) (0, $eTCip.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $eTCip.isProtectedDayOfYearToken)(substring)) (0, $eTCip.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($dcf20f9a445c703e$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $dcf20f9a445c703e$var$cleanEscapedString(input) {
    var matched = input.match($dcf20f9a445c703e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($dcf20f9a445c703e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("abJ7q", function(module, exports) {
$parcel$export(module.exports, "default", () => $76adee17bf739388$export$2e2bcd8739ae039);

var $fPEGj = parcelRequire("fPEGj");

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $76adee17bf739388$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    if (!(0, $fPEGj.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $a3cTc.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("fPEGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b86b2cf091f446de$export$2e2bcd8739ae039);

var $6XyXV = parcelRequire("6XyXV");

var $3mokv = parcelRequire("3mokv");
function $b86b2cf091f446de$export$2e2bcd8739ae039(value) {
    (0, $3mokv.default)(1, arguments);
    return value instanceof Date || (0, $6XyXV.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("4xhXe", function(module, exports) {
$parcel$export(module.exports, "default", () => $34d82bd689c497c2$export$2e2bcd8739ae039);

var $4Biaw = parcelRequire("4Biaw");

var $3mokv = parcelRequire("3mokv");

var $1Cu8A = parcelRequire("1Cu8A");
function $34d82bd689c497c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3mokv.default)(2, arguments);
    var amount = (0, $1Cu8A.default)(dirtyAmount);
    return (0, $4Biaw.default)(dirtyDate, -amount);
}

});
parcelRegister("4Biaw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3598b613896b13fa$export$2e2bcd8739ae039);

var $1Cu8A = parcelRequire("1Cu8A");

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $3598b613896b13fa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3mokv.default)(2, arguments);
    var timestamp = (0, $a3cTc.default)(dirtyDate).getTime();
    var amount = (0, $1Cu8A.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("1Cu8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $12e0b7b9336a985c$export$2e2bcd8739ae039);
function $12e0b7b9336a985c$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("419Ty", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eceee5f3259e66d$export$2e2bcd8739ae039);

var $daSMK = parcelRequire("daSMK");

var $6x2h9 = parcelRequire("6x2h9");

var $lxx3N = parcelRequire("lxx3N");

var $8cu26 = parcelRequire("8cu26");

var $16hSb = parcelRequire("16hSb");

var $8MI6h = parcelRequire("8MI6h");

var $hnAl6 = parcelRequire("hnAl6");
var $2eceee5f3259e66d$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2eceee5f3259e66d$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $hnAl6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $16hSb.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $8MI6h.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $8MI6h.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $lxx3N.default)(date);
        // Padding
        return (0, $8MI6h.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $8MI6h.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $8MI6h.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $8MI6h.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $hnAl6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $8MI6h.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $8cu26.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $8MI6h.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $6x2h9.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $8MI6h.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $hnAl6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $daSMK.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $8MI6h.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $8MI6h.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $8MI6h.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $8MI6h.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2eceee5f3259e66d$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2eceee5f3259e66d$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2eceee5f3259e66d$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2eceee5f3259e66d$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2eceee5f3259e66d$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2eceee5f3259e66d$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $hnAl6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $hnAl6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $8MI6h.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $8MI6h.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $hnAl6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $hnAl6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $hnAl6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2eceee5f3259e66d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $2eceee5f3259e66d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2eceee5f3259e66d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2eceee5f3259e66d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $2eceee5f3259e66d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2eceee5f3259e66d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2eceee5f3259e66d$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2eceee5f3259e66d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $2eceee5f3259e66d$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $2eceee5f3259e66d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $8MI6h.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $8MI6h.default)(timestamp, token.length);
    }
};
function $2eceee5f3259e66d$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $8MI6h.default)(minutes, 2);
}
function $2eceee5f3259e66d$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $8MI6h.default)(Math.abs(offset) / 60, 2);
    }
    return $2eceee5f3259e66d$var$formatTimezone(offset, dirtyDelimiter);
}
function $2eceee5f3259e66d$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $8MI6h.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $8MI6h.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2eceee5f3259e66d$export$2e2bcd8739ae039 = $2eceee5f3259e66d$var$formatters;

});
parcelRegister("daSMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $9976b4c1bb0ab948$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
var $9976b4c1bb0ab948$var$MILLISECONDS_IN_DAY = 86400000;
function $9976b4c1bb0ab948$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $9976b4c1bb0ab948$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("6x2h9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c17970b03811b53$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $gNdRc = parcelRequire("gNdRc");

var $lcmqX = parcelRequire("lcmqX");

var $3mokv = parcelRequire("3mokv");
var $4c17970b03811b53$var$MILLISECONDS_IN_WEEK = 604800000;
function $4c17970b03811b53$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var diff = (0, $gNdRc.default)(date).getTime() - (0, $lcmqX.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4c17970b03811b53$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("gNdRc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c39bf8a75ac49c4e$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $c39bf8a75ac49c4e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("lcmqX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6ec1edb2d1880aa$export$2e2bcd8739ae039);

var $lxx3N = parcelRequire("lxx3N");

var $gNdRc = parcelRequire("gNdRc");

var $3mokv = parcelRequire("3mokv");
function $f6ec1edb2d1880aa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var year = (0, $lxx3N.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $gNdRc.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("lxx3N", function(module, exports) {
$parcel$export(module.exports, "default", () => $fae6531ffcfaf4ca$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");

var $gNdRc = parcelRequire("gNdRc");
function $fae6531ffcfaf4ca$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $gNdRc.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $gNdRc.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("8cu26", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f86bda457212fb5$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $l7lcF = parcelRequire("l7lcF");

var $5vHq6 = parcelRequire("5vHq6");

var $3mokv = parcelRequire("3mokv");
var $5f86bda457212fb5$var$MILLISECONDS_IN_WEEK = 604800000;
function $5f86bda457212fb5$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var diff = (0, $l7lcF.default)(date, options).getTime() - (0, $5vHq6.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $5f86bda457212fb5$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("l7lcF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5fab2f59361ca9a$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");

var $1Cu8A = parcelRequire("1Cu8A");

var $4WP6t = parcelRequire("4WP6t");
function $f5fab2f59361ca9a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3mokv.default)(1, arguments);
    var defaultOptions = (0, $4WP6t.getDefaultOptions)();
    var weekStartsOn = (0, $1Cu8A.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("4WP6t", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $39a43848da82413d$export$430a3269e24b912e);
var $39a43848da82413d$var$defaultOptions = {};
function $39a43848da82413d$export$430a3269e24b912e() {
    return $39a43848da82413d$var$defaultOptions;
}
function $39a43848da82413d$export$95365be1b0704abc(newOptions) {
    $39a43848da82413d$var$defaultOptions = newOptions;
}

});


parcelRegister("5vHq6", function(module, exports) {
$parcel$export(module.exports, "default", () => $40318754988936b4$export$2e2bcd8739ae039);

var $16hSb = parcelRequire("16hSb");

var $3mokv = parcelRequire("3mokv");

var $l7lcF = parcelRequire("l7lcF");

var $1Cu8A = parcelRequire("1Cu8A");

var $4WP6t = parcelRequire("4WP6t");
function $40318754988936b4$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3mokv.default)(1, arguments);
    var defaultOptions = (0, $4WP6t.getDefaultOptions)();
    var firstWeekContainsDate = (0, $1Cu8A.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $16hSb.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $l7lcF.default)(firstWeek, options);
    return date;
}

});
parcelRegister("16hSb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cd437314665ce2a$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");

var $l7lcF = parcelRequire("l7lcF");

var $1Cu8A = parcelRequire("1Cu8A");

var $4WP6t = parcelRequire("4WP6t");
function $0cd437314665ce2a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $4WP6t.getDefaultOptions)();
    var firstWeekContainsDate = (0, $1Cu8A.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $l7lcF.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $l7lcF.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("8MI6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $665503d53d2829c0$export$2e2bcd8739ae039);
function $665503d53d2829c0$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("hnAl6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca70c5e1c01636a5$export$2e2bcd8739ae039);

var $8MI6h = parcelRequire("8MI6h");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $ca70c5e1c01636a5$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $8MI6h.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $8MI6h.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $8MI6h.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $8MI6h.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $8MI6h.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $8MI6h.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $8MI6h.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $8MI6h.default)(fractionalSeconds, token.length);
    }
};
var $ca70c5e1c01636a5$export$2e2bcd8739ae039 = $ca70c5e1c01636a5$var$formatters;

});


parcelRegister("jRPwQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e76af014b7727917$export$2e2bcd8739ae039);
var $e76af014b7727917$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $e76af014b7727917$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $e76af014b7727917$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $e76af014b7727917$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $e76af014b7727917$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $e76af014b7727917$var$timeLongFormatter(timePattern, formatLong));
};
var $e76af014b7727917$var$longFormatters = {
    p: $e76af014b7727917$var$timeLongFormatter,
    P: $e76af014b7727917$var$dateTimeLongFormatter
};
var $e76af014b7727917$export$2e2bcd8739ae039 = $e76af014b7727917$var$longFormatters;

});

parcelRegister("eTCip", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $ad83e8815e14e91b$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $ad83e8815e14e91b$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $ad83e8815e14e91b$export$8073c1ae88f0e727);
var $ad83e8815e14e91b$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $ad83e8815e14e91b$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $ad83e8815e14e91b$export$c6cc36aa33304772(token) {
    return $ad83e8815e14e91b$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $ad83e8815e14e91b$export$c6b49d6dceb604a1(token) {
    return $ad83e8815e14e91b$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $ad83e8815e14e91b$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("HzLXG", function(module, exports) {
$parcel$export(module.exports, "default", () => $082fc3f48ca9f676$export$2e2bcd8739ae039);

var $1I9Ga = parcelRequire("1I9Ga");
var $082fc3f48ca9f676$export$2e2bcd8739ae039 = (0, $1I9Ga.default);

});
parcelRegister("1I9Ga", function(module, exports) {
$parcel$export(module.exports, "default", () => $13f16894390e0fb6$export$2e2bcd8739ae039);

var $95tmY = parcelRequire("95tmY");

var $asBuo = parcelRequire("asBuo");

var $g3RCZ = parcelRequire("g3RCZ");

var $hvmYR = parcelRequire("hvmYR");

var $aMpgq = parcelRequire("aMpgq");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $13f16894390e0fb6$var$locale = {
    code: 'en-US',
    formatDistance: (0, $95tmY.default),
    formatLong: (0, $asBuo.default),
    formatRelative: (0, $g3RCZ.default),
    localize: (0, $hvmYR.default),
    match: (0, $aMpgq.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $13f16894390e0fb6$export$2e2bcd8739ae039 = $13f16894390e0fb6$var$locale;

});
parcelRegister("95tmY", function(module, exports) {
$parcel$export(module.exports, "default", () => $69db5ce076fce278$export$2e2bcd8739ae039);
var $69db5ce076fce278$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $69db5ce076fce278$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $69db5ce076fce278$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $69db5ce076fce278$export$2e2bcd8739ae039 = $69db5ce076fce278$var$formatDistance;

});

parcelRegister("asBuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $79d9997cab3f1b05$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $79d9997cab3f1b05$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $79d9997cab3f1b05$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $79d9997cab3f1b05$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $79d9997cab3f1b05$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $79d9997cab3f1b05$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $79d9997cab3f1b05$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $79d9997cab3f1b05$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $79d9997cab3f1b05$export$2e2bcd8739ae039 = $79d9997cab3f1b05$var$formatLong;

});
parcelRegister("hqkXT", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf5209bd95ed355$export$2e2bcd8739ae039);
function $caf5209bd95ed355$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("g3RCZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb16868a8ce70d89$export$2e2bcd8739ae039);
var $bb16868a8ce70d89$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $bb16868a8ce70d89$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bb16868a8ce70d89$var$formatRelativeLocale[token];
};
var $bb16868a8ce70d89$export$2e2bcd8739ae039 = $bb16868a8ce70d89$var$formatRelative;

});

parcelRegister("hvmYR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbe728680de709e6$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $cbe728680de709e6$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $cbe728680de709e6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $cbe728680de709e6$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $cbe728680de709e6$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $cbe728680de709e6$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $cbe728680de709e6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $cbe728680de709e6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $cbe728680de709e6$var$localize = {
    ordinalNumber: $cbe728680de709e6$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $cbe728680de709e6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $cbe728680de709e6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $cbe728680de709e6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $cbe728680de709e6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $cbe728680de709e6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cbe728680de709e6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cbe728680de709e6$export$2e2bcd8739ae039 = $cbe728680de709e6$var$localize;

});
parcelRegister("afp2T", function(module, exports) {
$parcel$export(module.exports, "default", () => $775ebb9fa4f7d91c$export$2e2bcd8739ae039);
function $775ebb9fa4f7d91c$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("aMpgq", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d91fbfd44f3d057$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $7d91fbfd44f3d057$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7d91fbfd44f3d057$var$parseOrdinalNumberPattern = /\d+/i;
var $7d91fbfd44f3d057$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7d91fbfd44f3d057$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7d91fbfd44f3d057$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7d91fbfd44f3d057$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7d91fbfd44f3d057$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7d91fbfd44f3d057$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7d91fbfd44f3d057$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7d91fbfd44f3d057$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7d91fbfd44f3d057$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7d91fbfd44f3d057$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7d91fbfd44f3d057$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $7d91fbfd44f3d057$var$matchOrdinalNumberPattern,
        parsePattern: $7d91fbfd44f3d057$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $7d91fbfd44f3d057$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d91fbfd44f3d057$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $7d91fbfd44f3d057$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d91fbfd44f3d057$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $7d91fbfd44f3d057$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d91fbfd44f3d057$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $7d91fbfd44f3d057$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d91fbfd44f3d057$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $7d91fbfd44f3d057$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7d91fbfd44f3d057$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7d91fbfd44f3d057$export$2e2bcd8739ae039 = $7d91fbfd44f3d057$var$match;

});
parcelRegister("ckS9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fb15ac8ae0bb9c2$export$2e2bcd8739ae039);
function $8fb15ac8ae0bb9c2$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $8fb15ac8ae0bb9c2$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $8fb15ac8ae0bb9c2$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $8fb15ac8ae0bb9c2$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $8fb15ac8ae0bb9c2$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("59jA4", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bfcfb5ea4acfac0$export$2e2bcd8739ae039);
function $3bfcfb5ea4acfac0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("bjKFs", function(module, exports) {
$parcel$export(module.exports, "eventPopulation", () => $9a2024cacd8015ee$export$9086dbeda9b1d633);
const $9a2024cacd8015ee$export$9086dbeda9b1d633 = (_config, _data, globalConfig)=>{
    if (!globalConfig.population) return {};
    return {
        'event:population': `${globalConfig.population}`
    };
};

});

parcelRegister("9VLG4", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $27770076bf2f6947$export$a7df4e8088db8843);
const $27770076bf2f6947$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("jGXmq", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $8ab30d6e153166c2$export$d0117b71adcdebc0);
const $8ab30d6e153166c2$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("d2eUb", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $e942482ce4501f1c$export$44d3627af289ca16);
const $e942482ce4501f1c$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("7I9h3", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $3ddf4ff0d87aa66c$export$4c045e605d532c98);

var $1nkIg = parcelRequire("1nkIg");
const $3ddf4ff0d87aa66c$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $1nkIg.mapEventType)(config.type)
    };
};

});

parcelRegister("2TzbF", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $c0826119edca3f48$export$e62953d023125748);
const $c0826119edca3f48$export$e62953d023125748 = (config, _data, globalConfig)=>{
    var _config$featureFlags;
    const localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("WaYkc", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $e7b78211425902c2$export$640106f6dc7d2706);
const $e7b78211425902c2$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("l7Fc9", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $3898933051eb36fd$export$cab039265c52a2e9);

var $eNmol = parcelRequire("eNmol");
const $3898933051eb36fd$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    var _config$slo, _config$histogram;
    if (!(0, $eNmol.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});
parcelRegister("eNmol", function(module, exports) {
$parcel$export(module.exports, "isCustomConfig", () => $53667ff0c6331618$export$b493eb8b2ba87421);

var $9YX3G = parcelRequire("9YX3G");
const $53667ff0c6331618$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $9YX3G.BMEventsType).CUSTOM;
};

});


parcelRegister("HoJQQ", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $b6b32338e0d8427a$export$cc95aa3f6ea8e5cb);
const $b6b32338e0d8427a$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("wGtif", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $9f272397be11de88$export$86db56030b57ba34);

var $dAuum = parcelRequire("dAuum");

var $2TVSD = parcelRequire("2TVSD");

var $9YX3G = parcelRequire("9YX3G");
const $9f272397be11de88$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    var _config$histogram;
    if (!(0, $2TVSD.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $9YX3G.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $dAuum.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $9YX3G.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $9YX3G.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $dAuum.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});
parcelRegister("dAuum", function(module, exports) {
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $40f16457e874c6c4$export$b10c1d9a7db7765b);
const $40f16457e874c6c4$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};

});

parcelRegister("2TVSD", function(module, exports) {
$parcel$export(module.exports, "isInteractionConfig", () => $d64dc8447cc1cc69$export$ae68674b6a9353be);

var $9YX3G = parcelRequire("9YX3G");
const $d64dc8447cc1cc69$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $9YX3G.BMEventsType).INLINE_RESULT;
};

});


parcelRegister("2tB7C", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $902fdc401d236c30$export$b88d990436be0f8a);
const $902fdc401d236c30$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("8tjb6", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $600c7508bebf4606$export$2878bf482e539059);

var $hKL3E = parcelRequire("hKL3E");

var $8jSbY = parcelRequire("8jSbY");

var $9YX3G = parcelRequire("9YX3G");
const $600c7508bebf4606$var$getThreshold = (isInitial, metric)=>{
    return (0, $hKL3E.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $600c7508bebf4606$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $600c7508bebf4606$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $8jSbY.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $9YX3G.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $600c7508bebf4606$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $600c7508bebf4606$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $600c7508bebf4606$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $600c7508bebf4606$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $600c7508bebf4606$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $600c7508bebf4606$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});
parcelRegister("hKL3E", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $99e17146b28adf12$export$5866f95702a15142);
const $99e17146b28adf12$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("8jSbY", function(module, exports) {
$parcel$export(module.exports, "isPageLoadConfig", () => $0bdbff8e13f4ea43$export$8672fa27ba8bba88);

var $9YX3G = parcelRequire("9YX3G");
const $0bdbff8e13f4ea43$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $9YX3G.BMEventsType).PAGE_LOAD;
};

});


parcelRegister("fIUhW", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $67e7f7cc8e9dbba6$export$ba86cb47f2f22db5);

var $fzRkJ = parcelRequire("fzRkJ");

var $8mcjq = parcelRequire("8mcjq");

var $5z5pU = parcelRequire("5z5pU");

var $9YX3G = parcelRequire("9YX3G");
const $67e7f7cc8e9dbba6$var$getThreshold = (isInitial, metric)=>{
    return (0, $fzRkJ.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $67e7f7cc8e9dbba6$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $67e7f7cc8e9dbba6$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    var _config$slo, _config$slo2;
    if (!(0, $8mcjq.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $9YX3G.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $67e7f7cc8e9dbba6$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $67e7f7cc8e9dbba6$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $67e7f7cc8e9dbba6$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $67e7f7cc8e9dbba6$var$getHistogram(data.isInitial, (0, $9YX3G.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        const threshold = $67e7f7cc8e9dbba6$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        const threshold = $67e7f7cc8e9dbba6$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $9YX3G.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $9YX3G.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $5z5pU.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $9YX3G.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});
parcelRegister("fzRkJ", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $03c009d63ef8e671$export$f087a59bd717e49d);
const $03c009d63ef8e671$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("8mcjq", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $2d730036620892bd$export$abe063537ef4987b);

var $9YX3G = parcelRequire("9YX3G");
const $2d730036620892bd$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD;
};

});


parcelRegister("60TJQ", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $1ab140ef1c000f82$export$3731db279f590f30);

var $hc42S = parcelRequire("hc42S");

var $7XXq3 = parcelRequire("7XXq3");

var $bAfWs = parcelRequire("bAfWs");

var $6ryw1 = parcelRequire("6ryw1");
const $1ab140ef1c000f82$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $hc42S.PageVisibleState).MIXED;
    };
    (0, $7XXq3.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
    const webVitalMetrics = await (0, $6ryw1.webVitalsMetricCustomTimeout)(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
    (0, $7XXq3.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $bAfWs.pageVisibleValue)(config, data, globalConfig)
    };
};

});
parcelRegister("bAfWs", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $923169fa71de9922$export$177b923114656380);

var $hc42S = parcelRequire("hc42S");

var $9YX3G = parcelRequire("9YX3G");
const $923169fa71de9922$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $9YX3G.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $hc42S.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});

parcelRegister("6ryw1", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetricCustomTimeout", () => $d954f94f9e49bd95$export$193ae490b52081dd);

var $gcqGF = parcelRequire("gcqGF");
const $d954f94f9e49bd95$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $gcqGF.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $gcqGF.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $gcqGF.webVitalsObserver).data;
};

});


parcelRegister("bUkFp", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $ccc676b19a037d53$export$723b4c298aca63af);
const $ccc676b19a037d53$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("939f0", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $47fd2b218df32baa$export$fa2af6e412815a74);
const $47fd2b218df32baa$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("f2WSf", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $10101e667eaea886$export$fdbea518c19dfa8);

var $9YX3G = parcelRequire("9YX3G");
const $10101e667eaea886$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $10101e667eaea886$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
    // no config or missing
    if (!((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags)) return null;
    const includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $9YX3G.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $9YX3G.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $9YX3G.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $10101e667eaea886$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("jkcas", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $85ecb4aade8dd7ee$export$a3dc8251cf55b2e0);
const $85ecb4aade8dd7ee$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("lVcRp", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $fa45eb7a96f4abb3$export$386b10ac64a50b1);

var $kgstt = parcelRequire("kgstt");
const $fa45eb7a96f4abb3$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($kgstt))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($kgstt))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("kgstt", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("dLy1o", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $a209466092d51de5$export$9f84cb359ed29139);
const $a209466092d51de5$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("cJtx5", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $9e29abb7118b878e$export$496c14d72b257e07);
const $9e29abb7118b878e$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("9X7dp", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $d91441ab65053946$export$88bf7b55f7fc4e8e);
const $d91441ab65053946$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("5afzH", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $b31839469f104e6f$export$e952f50a4f2d02da);

var $9YX3G = parcelRequire("9YX3G");

var $2Rf3j = parcelRequire("2Rf3j");

var $aYUkO = parcelRequire("aYUkO");
const $b31839469f104e6f$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $9YX3G.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $2Rf3j.customTimings)(config, data);
    const ssr = config.type === (0, $9YX3G.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $aYUkO.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("2Rf3j", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $03b2c90587256071$export$6126f85083a72c6e);

var $acjS8 = parcelRequire("acjS8");
const $03b2c90587256071$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $03b2c90587256071$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $03b2c90587256071$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $03b2c90587256071$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $acjS8.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("acjS8", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $22965fcc8cc3072c$export$b98e411ae80c806f);
const $22965fcc8cc3072c$export$b98e411ae80c806f = '/';

});


parcelRegister("aYUkO", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $92717bd0a8330a5d$export$130f411261a599c5);

var $acjS8 = parcelRequire("acjS8");
const $92717bd0a8330a5d$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $92717bd0a8330a5d$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $92717bd0a8330a5d$var$SSR_PREFIX = 'ssr';
const $92717bd0a8330a5d$var$mapKey = (key)=>{
    if (key === 'total') return $92717bd0a8330a5d$var$SSR_PREFIX;
    return `${$92717bd0a8330a5d$var$SSR_PREFIX}${0, $acjS8.NESTED_METRIC_SEPARATOR}${key}`;
};
const $92717bd0a8330a5d$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($92717bd0a8330a5d$var$filterEntry(entry[1])) acc[$92717bd0a8330a5d$var$mapKey(entry[0])] = $92717bd0a8330a5d$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("kMQSn", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $53f96bcf27f41013$export$1a2bb347935fc536);
const $53f96bcf27f41013$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $53f96bcf27f41013$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($53f96bcf27f41013$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("eWzUq", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $6cef5d5a4e433a9c$export$81a7d52441a06b50);
const $6cef5d5a4e433a9c$var$cacheableTypes = [
    'script',
    'link'
];
const $6cef5d5a4e433a9c$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $6cef5d5a4e433a9c$var$CACHE_NETWORK = 'network';
const $6cef5d5a4e433a9c$var$CACHE_MEMORY = 'memory';
const $6cef5d5a4e433a9c$var$CACHE_DISK = 'disk';
const $6cef5d5a4e433a9c$var$calculateTransferType = (type, duration, size)=>{
    if (!$6cef5d5a4e433a9c$var$cacheableTypes.includes(type)) return $6cef5d5a4e433a9c$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $6cef5d5a4e433a9c$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $6cef5d5a4e433a9c$var$CACHE_DISK;
    if (size === undefined) return null;
    return $6cef5d5a4e433a9c$var$CACHE_NETWORK;
};
const $6cef5d5a4e433a9c$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$6cef5d5a4e433a9c$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $6cef5d5a4e433a9c$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $6cef5d5a4e433a9c$var$withoutHeaders = ()=>false;
const $6cef5d5a4e433a9c$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $6cef5d5a4e433a9c$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $6cef5d5a4e433a9c$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $6cef5d5a4e433a9c$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $6cef5d5a4e433a9c$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $6cef5d5a4e433a9c$var$getNetworkData = (item, eventStart, hasTimingHeaders = $6cef5d5a4e433a9c$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$6cef5d5a4e433a9c$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($6cef5d5a4e433a9c$var$cacheableTypes.includes(type)) {
        const transferType = $6cef5d5a4e433a9c$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$6cef5d5a4e433a9c$var$getSizeObject(size)
        };
        if (transferType !== $6cef5d5a4e433a9c$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$6cef5d5a4e433a9c$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$6cef5d5a4e433a9c$var$getSizeObject(size)
    };
};
const $6cef5d5a4e433a9c$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $6cef5d5a4e433a9c$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $6cef5d5a4e433a9c$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$6cef5d5a4e433a9c$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$6cef5d5a4e433a9c$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});

parcelRegister("5N1Uy", function(module, exports) {
$parcel$export(module.exports, "traceContext", () => $237bd307268c5cfb$export$90f20fc1d8cfb95b);
const $237bd307268c5cfb$export$90f20fc1d8cfb95b = (_config, data, _globalConfig)=>{
    if (!data.traceContext) return null;
    return {
        tracingContext: {
            'X-B3-TraceId': data.traceContext.traceId,
            'X-B3-SpanId': data.traceContext.spanId
        }
    };
};

});


parcelRegister("jyqii", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $0612bc8bfd61c00a$export$5b4fb14409a2a825);

var $9YX3G = parcelRequire("9YX3G");
const $0612bc8bfd61c00a$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $0612bc8bfd61c00a$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) ?? (allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) ?? (0, $9YX3G.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($0612bc8bfd61c00a$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    });
};
const $0612bc8bfd61c00a$export$5b4fb14409a2a825 = async (globalConfig)=>{
    var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: (_globalConfig$events$ = globalConfig.events[(0, $9YX3G.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $9YX3G.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $9YX3G.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
        }
    };
    return {
        [(0, $9YX3G.BMEventsType).PAGE_LOAD]: $0612bc8bfd61c00a$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $9YX3G.BMEventsType).PAGE_LOAD]),
        [(0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD]: $0612bc8bfd61c00a$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $9YX3G.BMEventsType).INLINE_RESULT]: $0612bc8bfd61c00a$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $9YX3G.BMEventsType).INLINE_RESULT]),
        [(0, $9YX3G.BMEventsType).CUSTOM]: $0612bc8bfd61c00a$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $9YX3G.BMEventsType).CUSTOM]),
        [(0, $9YX3G.BMEventsType).WEB_VITALS]: $0612bc8bfd61c00a$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $9YX3G.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("5QekB", function(module, exports) {
$parcel$export(module.exports, "featureFlagsPlugin", () => $7b6d442ff19d9c4b$export$79626a094e303f80);
$parcel$export(module.exports, "resourceTimingsPlugin", () => $7b6d442ff19d9c4b$export$8c43ac1c32352978);
$parcel$export(module.exports, "customPerfMarks", () => $7b6d442ff19d9c4b$export$960f38db9936e6ea);

var $k2M4v = parcelRequire("k2M4v");

var $jgb8T = parcelRequire("jgb8T");

var $cvI7Q = parcelRequire("cvI7Q");

var $gAmX3 = parcelRequire("gAmX3");
const $7b6d442ff19d9c4b$export$e5bb225813e92c1f = (url)=>url.includes('jsm-portal-frontend');
const $7b6d442ff19d9c4b$export$79626a094e303f80 = {
    client: Promise.resolve({
        getValue: (featureFlagName)=>{
            return (0, $k2M4v.default).checkGate(featureFlagName);
        }
    })
};
const $7b6d442ff19d9c4b$export$6dfc8bfc2349f367 = (url)=>{
    const { isProcessed: isProcessed, url: processedUrl } = (0, $gAmX3.processUrl)(url, []);
    if (!isProcessed) {
        (0, $jgb8T.devLog)(`Unsanitised URL: ${processedUrl}`);
        return 'unknown';
    }
    return processedUrl;
};
const $7b6d442ff19d9c4b$export$8c43ac1c32352978 = {
    hasTimingHeaders: $7b6d442ff19d9c4b$export$e5bb225813e92c1f,
    sanitiseEndpoints: $7b6d442ff19d9c4b$export$6dfc8bfc2349f367,
    mapResources: (0, $cvI7Q.sanitizeAssetName)(false)
};
function $7b6d442ff19d9c4b$export$960f38db9936e6ea() {
    var _window$performance, _window$performance$g;
    const marks = {};
    const entries = (_window$performance = window.performance) === null || _window$performance === void 0 || (_window$performance$g = _window$performance.getEntriesByType) === null || _window$performance$g === void 0 ? void 0 : _window$performance$g.call(_window$performance, 'mark');
    if (entries && entries.length > 0) entries.forEach((entry)=>{
        const key = `mark__${entry.name}`;
        const value = Math.floor(entry.startTime);
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        marks[key] = value;
    });
    return marks;
}

});
parcelRegister("cvI7Q", function(module, exports) {
$parcel$export(module.exports, "sanitizeAssetName", () => $0f3888143a685b67$export$715967a06dea6152);
/**
 * Webpack dev assets without hashes
 */ const $0f3888143a685b67$var$webpackDevAssetsRegexp = /(.*)\.(?:chunk|bundle)(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * Webpack prod assets with hashes
 */ const $0f3888143a685b67$var$webpackProdAssetsRegexp = /(.*)\.(?:chunk|bundle)\..*(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * jira.webresources:calendar.js asset with localization string
 */ const $0f3888143a685b67$var$calendarWRMRegexp = /(jira.webresources:calendar)(-[a-z]+).js$/;
/**
 * This returns the base name of the asset/url that is getting loaded.
 * eg: for: https://<your-domain>/assets/servicedesk-vendor.chunk.js
 * return servicedesk-vendor.chunk.js
 * @param assetPathOrURL all the external asset/path urls,  eg: anything refereced using <link>, <script> etc tag
 */ const $0f3888143a685b67$var$getBaseName = (assetPathOrURL)=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop() || '';
const $0f3888143a685b67$export$715967a06dea6152 = (isDevelopment)=>(assetPathOrURL)=>{
        const assetBaseName = $0f3888143a685b67$var$getBaseName(assetPathOrURL);
        const webpackAssetsMatch = assetBaseName.match(isDevelopment ? $0f3888143a685b67$var$webpackDevAssetsRegexp : $0f3888143a685b67$var$webpackProdAssetsRegexp);
        if (webpackAssetsMatch) return `${webpackAssetsMatch[1]}.js`;
        const calendarWRMMatch = assetBaseName.match($0f3888143a685b67$var$calendarWRMRegexp);
        if (calendarWRMMatch) return `${calendarWRMMatch[1]}.js`;
        return assetBaseName;
    };

});

parcelRegister("gAmX3", function(module, exports) {
$parcel$export(module.exports, "processUrl", () => $d77eef1128587600$export$8378cb52a6ed7e05);
class $d77eef1128587600$export$b323b8cc3ace981b {
    /**
   * Processes URLs that match a given pattern.
   *
   * @param pattern The pattern to match the URL against
   * @param onMatch The action to perform on the URL
   */ constructor(options){
        this.hasMatched = false;
        this.name = options.name;
        this.onMatch = options.onMatch;
        this.pattern = options.pattern;
    }
    /**
   * True if the last URL processed matched the processor's pattern.
   */ getHasMatched() {
        return this.hasMatched;
    }
    /**
   * The name of the processor.
   */ getName() {
        return this.name;
    }
    /**
   * Attempt to process the URL.
   *
   * If the URL matches the processor's pattern, then the URL is processed
   * and `hasMatched` is set to true. Otherwise, return the URL as is, and
   * set `hasMatched` to false.
   *
   * @param url The URL to process
   * @returns The URL (processed if the pattern matched, otherwise as-is)
   */ process(url) {
        const match = url.match(this.pattern);
        if (match) {
            this.hasMatched = true;
            const processedUrl = this.onMatch(url, match);
            return processedUrl;
        }
        this.hasMatched = false;
        return url;
    }
}
const $d77eef1128587600$export$8378cb52a6ed7e05 = (url, processors)=>{
    for (const processor of processors){
        const processedUrl = processor.process(url);
        if (processor.getHasMatched()) return {
            url: processedUrl,
            isProcessed: true
        };
    }
    return {
        url: url,
        isProcessed: false
    };
};

});


parcelRegister("1NC3I", function(module, exports) {
$parcel$export(module.exports, "isPageLoadInstrumented", () => $c2633c41ac039ca4$export$f571430402d3e925);
$parcel$export(module.exports, "default", () => $c2633c41ac039ca4$export$2e2bcd8739ae039);

var $yIOXv = parcelRequire("yIOXv");

var $9mazR = parcelRequire("9mazR");
const $c2633c41ac039ca4$export$8d6ac02b84099d24 = ()=>{
    if (window.__IS_PAGE_SERVER_SIDE_RENDERED__) return {
        ssr: {
            doneAsFmp: true
        }
    };
    return {};
};
/**
 * Object containing page load metric for all instrumented screens,
 * as we instrument BM3 for more screens we update values here
 * all new keys will follow the `service-management.help-center.[screenName]` schema
 * and can be accessed using `jira.fe.page-load.service-management.help-center.[screenName]`
 */ const $c2633c41ac039ca4$var$perfConfig = {
    [(0, $9mazR.ScreenName).HELP_CENTER]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-help-center',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).PORTAL_REORDER_SETTINGS]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-reorder-settings',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).VIEW_TOPIC]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.view-topic',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).EDIT_TOPIC]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.edit-topic',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).EDIT_HOMEPAGE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.edit-homepage',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-knowledge-resources',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).ADD_HELP_CONTENT_EXTERNAL_LINKS]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-external-links',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).UNIFIED_HELP_HOME_PAGE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.unified-help-center.home-page',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).HELP_CENTERS_MANAGEMENT]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.help-centers-management',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).HELP_HUBS_MANAGEMENT]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.help-hubs-management',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    })
};
const $c2633c41ac039ca4$var$bm3BatchOneMetrics = {
    [(0, $9mazR.ScreenName).REQUEST_LIST]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-requests',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).LOGIN]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-login',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.knowledge-article',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).LOGIN_SINGLE_SIGN_ON]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-single-sign-on',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).SIGNUP]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-signup',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).APPROVAL_LIST]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-approvals',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).KNOWLEDGE_CATEGORY]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.category-page',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).USER_PROFILE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-profile',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).CHECK_EMAIL]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-validate-email',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).COMPLETE_SIGNUP]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).RESET_PASSWORD]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-reset-password',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).INVITED_SIGNUP]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-accept-invite',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).COMPLETE_SIGNUP_TOKEN_INVALID]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-invalid',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).COMPLETE_SIGNUP_TOKEN_EXPIRED]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-expired',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-forgot-password-confirmation',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).CONSENT_FORM_PAGE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.user-consent',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    })
};
const $c2633c41ac039ca4$var$bm3BatchTwoMetrics = {
    [(0, $9mazR.ScreenName).REQUEST_DETAILS]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-details',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).REQUEST_CREATE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-create',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).PORTAL_HOME]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.single-portal',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).REQUEST_GROUP]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.request-group',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).REQUEST_GROUP_LIST]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.request-group-list',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).FEEDBACK]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.request-create-anonymous-success',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).UNSUBSCRIBE]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-unsubscribe-confirmation',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    }),
    [(0, $9mazR.ScreenName).FEEDBACK_SUBMITTED]: (0, $yIOXv.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback-comment-submitted',
        ...$c2633c41ac039ca4$export$8d6ac02b84099d24()
    })
};
Object.assign($c2633c41ac039ca4$var$perfConfig, $c2633c41ac039ca4$var$bm3BatchOneMetrics, $c2633c41ac039ca4$var$bm3BatchTwoMetrics);
const $c2633c41ac039ca4$export$f571430402d3e925 = (screenName)=>{
    if (!screenName) return false;
    return $c2633c41ac039ca4$var$perfConfig.hasOwnProperty(screenName);
};
var $c2633c41ac039ca4$export$2e2bcd8739ae039 = $c2633c41ac039ca4$var$perfConfig;

});
parcelRegister("yIOXv", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $98087ecafaf2fde5$export$b0c5c2fac8144e54);

var $l2hcp = parcelRequire("l2hcp");

var $dzcgp = parcelRequire("dzcgp");

var $kjilv = parcelRequire("kjilv");

var $3noGJ = parcelRequire("3noGJ");

var $4RgDj = parcelRequire("4RgDj");
const $98087ecafaf2fde5$export$b0c5c2fac8144e54 = {
    pageLoad: $3noGJ.pageLoad,
    pageSegmentLoad: $4RgDj.pageSegmentLoad,
    interaction: $kjilv.interaction,
    custom: $dzcgp.custom,
    concurrent: $l2hcp.concurrent
};

});
parcelRegister("l2hcp", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $b4098816ee9410bd$export$370df09ecc3de059);

var $9YX3G = parcelRequire("9YX3G");

var $dzcgp = parcelRequire("dzcgp");

var $kjilv = parcelRequire("kjilv");
const $b4098816ee9410bd$var$concurrentMetrics = {};
const $b4098816ee9410bd$var$getKey = (config, type)=>`${type}--${config.key}`;
const $b4098816ee9410bd$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $b4098816ee9410bd$var$ensurePath = (config, type)=>{
    const key = $b4098816ee9410bd$var$getKey(config, type);
    if (!(key in $b4098816ee9410bd$var$concurrentMetrics)) $b4098816ee9410bd$var$concurrentMetrics[key] = {};
};
const $b4098816ee9410bd$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $b4098816ee9410bd$var$getKey(config, type);
    if (concurrentKey in $b4098816ee9410bd$var$concurrentMetrics && $b4098816ee9410bd$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $b4098816ee9410bd$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $b4098816ee9410bd$var$concurrentMetrics)) $b4098816ee9410bd$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $b4098816ee9410bd$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $b4098816ee9410bd$var$validateConfig(config);
    $b4098816ee9410bd$var$ensurePath(config, type);
    const metricFromCache = $b4098816ee9410bd$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $9YX3G.BMEventsType).INLINE_RESULT ? (0, $kjilv.interaction) : (0, $dzcgp.custom);
    const metric = metricFactory(config);
    $b4098816ee9410bd$var$concurrentMetrics[$b4098816ee9410bd$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $b4098816ee9410bd$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$b4098816ee9410bd$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$b4098816ee9410bd$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $9YX3G.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$b4098816ee9410bd$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $9YX3G.BMEventsType).CUSTOM)
};

});
parcelRegister("dzcgp", function(module, exports) {
$parcel$export(module.exports, "custom", () => $8332df0941afa1ad$export$4c00f665f0d4b443);

var $jeEHs = parcelRequire("jeEHs");

var $9YX3G = parcelRequire("9YX3G");
const $8332df0941afa1ad$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $jeEHs.Metric)({
        ...config,
        type: (0, $9YX3G.BMEventsType).CUSTOM
    });
};

});
parcelRegister("jeEHs", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $9494a901026918fd$export$efdd3e096bc27746);

var $dMXrj = parcelRequire("dMXrj");

var $ihXkA = parcelRequire("ihXkA");

var $hc42S = parcelRequire("hc42S");
class $9494a901026918fd$export$efdd3e096bc27746 extends (0, $hc42S.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $dMXrj.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $ihXkA.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});


parcelRegister("kjilv", function(module, exports) {
$parcel$export(module.exports, "interaction", () => $2d57f46b33c885e8$export$92473e6020ad89b4);

var $jeEHs = parcelRequire("jeEHs");

var $9YX3G = parcelRequire("9YX3G");
const $2d57f46b33c885e8$export$92473e6020ad89b4 = (config)=>{
    return new (0, $jeEHs.Metric)({
        ...config,
        type: (0, $9YX3G.BMEventsType).INLINE_RESULT
    });
};

});


parcelRegister("3noGJ", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $be685fc593695a57$export$791d520f7e8058a5);

var $cn4Rq = parcelRequire("cn4Rq");

var $9YX3G = parcelRequire("9YX3G");
const $be685fc593695a57$export$791d520f7e8058a5 = (config)=>{
    return new (0, $cn4Rq.PageLoadMetric)({
        ...config,
        type: (0, $9YX3G.BMEventsType).PAGE_LOAD
    });
};

});
parcelRegister("cn4Rq", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $a5e04b3681b03476$export$3c51073271a9eac3);

var $imfsZ = parcelRequire("imfsZ");

var $jMy1f = parcelRequire("jMy1f");

var $dMXrj = parcelRequire("dMXrj");

var $ihXkA = parcelRequire("ihXkA");

var $9YX3G = parcelRequire("9YX3G");

var $1L3j0 = parcelRequire("1L3j0");

var $5z5pU = parcelRequire("5z5pU");

var $23kZ1 = parcelRequire("23kZ1");
class $a5e04b3681b03476$export$3c51073271a9eac3 extends (0, $1L3j0.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $5z5pU.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        var _this$config$ssr;
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $5z5pU.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $5z5pU.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[(0, $1L3j0.BasePageLoadMetric).FMP]) {
                const mark = (0, $imfsZ.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $5z5pU.pageLoadMetaMetric).markFMP(mark);
            } else (0, $5z5pU.pageLoadMetaMetric).markFMP(this.marks[(0, $1L3j0.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $dMXrj.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $ihXkA.submitter).queue(data);
        (0, $jMy1f.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $5z5pU.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $5z5pU.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $5z5pU.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        var _configChunk$BMEvents;
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $ihXkA.submitter).config.configChunk;
        if (!(configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $9YX3G.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled)) return false;
        const webVitalMetric = new (0, $23kZ1.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $ihXkA.submitter).queue(webVitalMetric.getData());
        (0, $jMy1f.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("23kZ1", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $805b9199de49e038$export$dc0d85d4d6503cd7);

var $9YX3G = parcelRequire("9YX3G");

var $hc42S = parcelRequire("hc42S");
class $805b9199de49e038$export$dc0d85d4d6503cd7 extends (0, $hc42S.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $9YX3G.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $hc42S.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});



parcelRegister("4RgDj", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $a4a9b73be23f6187$export$94114666844d5f66);

var $bQIE7 = parcelRequire("bQIE7");

var $9YX3G = parcelRequire("9YX3G");
const $a4a9b73be23f6187$export$94114666844d5f66 = (config)=>{
    return new (0, $bQIE7.PageSegmentLoadMetric)({
        ...config,
        type: (0, $9YX3G.BMEventsType).PAGE_SEGMENT_LOAD
    });
};

});
parcelRegister("bQIE7", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $fc1190d11299efa3$export$24c8bfcd77494cc1);

var $imfsZ = parcelRequire("imfsZ");

var $9YX3G = parcelRequire("9YX3G");

var $hc42S = parcelRequire("hc42S");

var $jeEHs = parcelRequire("jeEHs");

var $5z5pU = parcelRequire("5z5pU");
class $fc1190d11299efa3$export$24c8bfcd77494cc1 extends (0, $jeEHs.Metric) {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $5z5pU.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $fc1190d11299efa3$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($fc1190d11299efa3$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        var _this$config$ssr;
        const pageLoadData = (0, $5z5pU.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[$fc1190d11299efa3$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $imfsZ.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $9YX3G.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $hc42S.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $hc42S.MetricState).STARTED) (0, $5z5pU.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("55vtE", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $36ffd28323eece13$export$f45af69d005a6ed);
const $36ffd28323eece13$export$f45af69d005a6ed = (markName)=>{
    if (!performance.getEntriesByName) return null;
    const marks = performance.getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};

});

parcelRegister("5OiZV", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $9119d493b21c4169$export$edb879ae55bb9be3);

var $dRkX9 = parcelRequire("dRkX9");

var $atXmE = parcelRequire("atXmE");

var $6ijIC = parcelRequire("6ijIC");

var $bEEgW = parcelRequire("bEEgW");

var $fLDvZ = parcelRequire("fLDvZ");

var $7MJfF = parcelRequire("7MJfF");

var $127T9 = parcelRequire("127T9");

var $h26xP = parcelRequire("h26xP");

var $g8gWL = parcelRequire("g8gWL");

var $a3HS6 = parcelRequire("a3HS6");

var $htcL7 = parcelRequire("htcL7");

var $5xAcw = parcelRequire("5xAcw");

var $iEVDb = parcelRequire("iEVDb");

var $jwrMl = parcelRequire("jwrMl");

var $38QJf = parcelRequire("38QJf");

var $2BxHX = parcelRequire("2BxHX");

var $3DAGl = parcelRequire("3DAGl");

var $C7lsR = parcelRequire("C7lsR");

var $ksyoN = parcelRequire("ksyoN");

var $2eWE4 = parcelRequire("2eWE4");

var $h4tlu = parcelRequire("h4tlu");

var $913ya = parcelRequire("913ya");

var $fHR1z = parcelRequire("fHR1z");

var $dqgRx = parcelRequire("dqgRx");

var $bQQUF = parcelRequire("bQQUF");

var $fYc8n = parcelRequire("fYc8n");

var $dXSsW = parcelRequire("dXSsW");
var $9119d493b21c4169$var$_getWindowObject;
const $9119d493b21c4169$var$UNKNOWN_VALUE = 'unknown';
const $9119d493b21c4169$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $9119d493b21c4169$var$UNKNOWN_VALUE,
    id: $9119d493b21c4169$var$UNKNOWN_VALUE,
    uuid: $9119d493b21c4169$var$UNKNOWN_VALUE,
    state: {
        id: $9119d493b21c4169$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $atXmE.ExperienceTypes).Experience,
    category: $9119d493b21c4169$var$UNKNOWN_VALUE,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $127T9.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $9119d493b21c4169$var$Publisher {
    publish(data) {
        var _getPerformanceObject, _getPerformanceObject2, _getPerformanceObject3;
        const payloadStart = ((_getPerformanceObject = (0, $bQQUF.getPerformanceObject)()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $7MJfF.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$9119d493b21c4169$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $g8gWL.UFO_BUILD_VERSION) || $9119d493b21c4169$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    ...(0, $dRkX9.fg)('ufo_cdp_attribute') ? {
                        'event:cdp': this.cdp
                    } : null,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $3DAGl.eventBrowserPlugin)(),
                    ...(0, $C7lsR.eventCpusPlugin)(),
                    ...(0, $2eWE4.eventMemoryPlugin)(),
                    ...(0, $h4tlu.eventNetworkPlugin)(),
                    ...(0, $38QJf.appFramework)(this.app),
                    ...(0, $2BxHX.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $a3HS6.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $iEVDb.pageVisibleState)(supportedData),
                    ...(0, $dXSsW.isInitialPageLoad)(supportedData) && (0, $fHR1z.ssrSuccess)(this.ssr),
                    ...(0, $dXSsW.isInitialPageLoad)(supportedData) && (0, $913ya.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $ksyoN.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: ((_getPerformanceObject2 = (0, $bQQUF.getPerformanceObject)()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.timeOrigin) ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = ((_getPerformanceObject3 = (0, $bQQUF.getPerformanceObject)()) === null || _getPerformanceObject3 === void 0 ? void 0 : _getPerformanceObject3.now()) || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $fLDvZ.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $6ijIC.getGlobalEventStream)() instanceof (0, $htcL7.UFOGlobalEventStream))) {
            const eventStream = new (0, $htcL7.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $127T9.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $bEEgW.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $h26xP.visibilityChangeObserver).start();
        (0, $jwrMl.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.cdp) this.cdp = config.cdp;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $5xAcw.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $9119d493b21c4169$var$UNKNOWN_VALUE;
        this.cdp = $9119d493b21c4169$var$UNKNOWN_VALUE;
        this.hostname = (($9119d493b21c4169$var$_getWindowObject = (0, $fYc8n.getWindowObject)()) === null || $9119d493b21c4169$var$_getWindowObject === void 0 || ($9119d493b21c4169$var$_getWindowObject = $9119d493b21c4169$var$_getWindowObject.location) === null || $9119d493b21c4169$var$_getWindowObject === void 0 ? void 0 : $9119d493b21c4169$var$_getWindowObject.hostname) || '';
        this.tenantType = (0, $a3HS6.TenantType).RealUser;
        this.app = {
            version: {
                web: $9119d493b21c4169$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $dqgRx.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $9119d493b21c4169$export$edb879ae55bb9be3 = new $9119d493b21c4169$var$Publisher();

});
parcelRegister("atXmE", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $98d49e62388b6e35$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $98d49e62388b6e35$export$cc26007c03242fff);
var $98d49e62388b6e35$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $98d49e62388b6e35$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("6ijIC", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $e042bd81d54f558f$export$6123a44dc2384540);

var $eE8Dt = parcelRequire("eE8Dt");
const $e042bd81d54f558f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $eE8Dt.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("eE8Dt", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $113f1dc87535a40a$export$d8b468db8a225bc9);
const $113f1dc87535a40a$export$d8b468db8a225bc9 = 250;

});


parcelRegister("bEEgW", function(module, exports) {
$parcel$export(module.exports, "setGlobalEventStream", () => $28258b1dd8513629$export$c1522520b417b066);

var $7MJfF = parcelRequire("7MJfF");
const $28258b1dd8513629$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $7MJfF.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};

});
parcelRegister("7MJfF", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $23e4f257598ebb46$export$d53d07b6034c4560);

var $47W3d = parcelRequire("47W3d");
const $23e4f257598ebb46$export$d53d07b6034c4560 = (...args)=>{
    (0, $47W3d.ufologger).warn(...args);
};

});
parcelRegister("47W3d", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $b967f5b3b562b03c$export$4ab84f6f04f6566d);
class $b967f5b3b562b03c$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($b967f5b3b562b03c$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($b967f5b3b562b03c$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $b967f5b3b562b03c$export$4ab84f6f04f6566d = new $b967f5b3b562b03c$var$UFOLogger();

});



parcelRegister("fLDvZ", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $84dc8b5a0dcaad61$export$b4958caff08a0960);

var $47W3d = parcelRequire("47W3d");
const $84dc8b5a0dcaad61$export$b4958caff08a0960 = (...args)=>{
    (0, $47W3d.ufologger).log(...args);
};

});

parcelRegister("127T9", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $b17188f676b62e8d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $b17188f676b62e8d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $b17188f676b62e8d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $b17188f676b62e8d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $b17188f676b62e8d$export$837e0f79a8056912);
var $b17188f676b62e8d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $b17188f676b62e8d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $b17188f676b62e8d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $b17188f676b62e8d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $b17188f676b62e8d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $b17188f676b62e8d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $b17188f676b62e8d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $b17188f676b62e8d$export$9f2bf58999404c75 = 'fmp';
const $b17188f676b62e8d$export$837e0f79a8056912 = 'inline-response';

});

parcelRegister("h26xP", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $74da4e813ef1ac83$export$13e680397ec8f3eb);

var $2VesA = parcelRequire("2VesA");
class $74da4e813ef1ac83$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $2VesA.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $74da4e813ef1ac83$export$13e680397ec8f3eb = new $74da4e813ef1ac83$var$VisibilityChangeObserver();

});
parcelRegister("2VesA", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $8aef1711db17332d$export$15e172712955e18f);
const $8aef1711db17332d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("g8gWL", function(module, exports) {
$parcel$export(module.exports, "UFO_BUILD_VERSION", () => $26cde144bfea89f0$export$93809551debf385f);
// temp solution until a proper versioning
const $26cde144bfea89f0$export$93809551debf385f = '0.1.7';

});

parcelRegister("a3HS6", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $4b9f3a044ab5cc59$export$92a757ac1398962f);
var $4b9f3a044ab5cc59$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("htcL7", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $1772f00f565b4001$export$faf4c91b80fc830e);

var $fLDvZ = parcelRequire("fLDvZ");

var $127T9 = parcelRequire("127T9");
class $1772f00f565b4001$export$faf4c91b80fc830e {
    push(event) {
        (0, $fLDvZ.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $127T9.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $127T9.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $127T9.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        var _this$subscribers$eve;
        if (this.subscribers[0, $127T9.SUBSCRIBE_ALL]) this.subscribers[0, $127T9.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $fLDvZ.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("5xAcw", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $355c58b91969f7c9$export$738d24377baf6a5e);

var $atXmE = parcelRequire("atXmE");

var $dXSsW = parcelRequire("dXSsW");

var $bHg3w = parcelRequire("bHg3w");

var $hBdBz = parcelRequire("hBdBz");

var $7dhQB = parcelRequire("7dhQB");

var $giYzc = parcelRequire("giYzc");

var $dKH2W = parcelRequire("dKH2W");

var $lGKsG = parcelRequire("lGKsG");

var $2XCEW = parcelRequire("2XCEW");
const $355c58b91969f7c9$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $atXmE.ExperiencePerformanceTypes).PageLoad:
        case (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad:
            return (0, $7dhQB.getLoadMetrics)(data, ssr, performanceConfig);
        case (0, $atXmE.ExperiencePerformanceTypes).InlineResult:
            return (0, $hBdBz.getInlineResultMetrics)(data, performanceConfig);
        case (0, $atXmE.ExperiencePerformanceTypes).Custom:
            return (0, $bHg3w.getCustomMetrics)(data, performanceConfig);
    }
};
const $355c58b91969f7c9$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$355c58b91969f7c9$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $2XCEW.resourceTimings)(data, resourceConfig),
        ...(0, $lGKsG.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $dKH2W.appTimings)(data, ssr),
        ...(0, $dXSsW.isInitialPageLoad)(data) ? (0, $giYzc.navigationMetrics)() : null
    };
};

});
parcelRegister("dXSsW", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $dcda9dd893010eeb$export$7167d96e9881d500);

var $atXmE = parcelRequire("atXmE");
const $dcda9dd893010eeb$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $atXmE.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("bHg3w", function(module, exports) {
$parcel$export(module.exports, "getCustomMetrics", () => $cf938d4303519f41$export$c25c1b3ff2ce92cf);

var $h2Mz3 = parcelRequire("h2Mz3");

var $cn8xD = parcelRequire("cn8xD");
const $cf938d4303519f41$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [(0, $h2Mz3.CustomMetricKeys).duration]: Math.round(duration),
        ...(0, $cn8xD.getHistogram)(data, performanceConfig)
    };
};

});
parcelRegister("h2Mz3", function(module, exports) {
$parcel$export(module.exports, "CustomMetricKeys", () => $45dde503f177cdc5$export$8b4d49d876b19889);
const $45dde503f177cdc5$export$8b4d49d876b19889 = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};

});

parcelRegister("cn8xD", function(module, exports) {
$parcel$export(module.exports, "getHistogram", () => $867b8051f4ad9569$export$908946735178c541);

var $atXmE = parcelRequire("atXmE");

var $h2Mz3 = parcelRequire("h2Mz3");

var $8YLVV = parcelRequire("8YLVV");

var $9kh5F = parcelRequire("9kh5F");
const $867b8051f4ad9569$export$908946735178c541 = (data, performanceConfig, isInitial)=>{
    var _data$performanceConf;
    let histogram = {};
    if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $atXmE.ExperiencePerformanceTypes).PageLoad:
            case (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [(0, $9kh5F.LoadMetricKeys).ttiHistograms]: histograms[histogramType].tti,
                    [(0, $9kh5F.LoadMetricKeys).fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $atXmE.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [(0, $8YLVV.InlineResultMetricKeys).resultHistograms]: histograms.result,
                    [(0, $8YLVV.InlineResultMetricKeys).responseHistograms]: histograms.response
                } : {};
            case (0, $atXmE.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [(0, $h2Mz3.CustomMetricKeys).durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};

});
parcelRegister("8YLVV", function(module, exports) {
$parcel$export(module.exports, "InlineResultMetricKeys", () => $797d67dd0261c94c$export$1bc754b4266cc540);
const $797d67dd0261c94c$export$1bc754b4266cc540 = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};

});

parcelRegister("9kh5F", function(module, exports) {
$parcel$export(module.exports, "LoadMetricKeys", () => $eddc026d4561509e$export$6869ee9ee4309612);
const $eddc026d4561509e$export$6869ee9ee4309612 = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};

});



parcelRegister("hBdBz", function(module, exports) {
$parcel$export(module.exports, "getInlineResultMetrics", () => $2031be8faf7aee58$export$47f0208fd62dffce);

var $127T9 = parcelRequire("127T9");

var $cn8xD = parcelRequire("cn8xD");

var $8YLVV = parcelRequire("8YLVV");
const $2031be8faf7aee58$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $127T9.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [(0, $8YLVV.InlineResultMetricKeys).result]: Math.round(result),
        [(0, $8YLVV.InlineResultMetricKeys).response]: Math.round(response),
        ...(0, $cn8xD.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("7dhQB", function(module, exports) {
$parcel$export(module.exports, "getLoadMetrics", () => $387a32432eb5dd21$export$bd4e6d81a822ece6);

var $127T9 = parcelRequire("127T9");

var $dXSsW = parcelRequire("dXSsW");

var $cn8xD = parcelRequire("cn8xD");

var $9kh5F = parcelRequire("9kh5F");
const $387a32432eb5dd21$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    var _data$metrics$marks$f;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find((mark)=>mark.name === (0, $127T9.FMP_MARK))) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || (0, $dXSsW.isInitialPageLoad)(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [(0, $9kh5F.LoadMetricKeys).tti]: Math.round(tti),
        [(0, $9kh5F.LoadMetricKeys).fmp]: Math.round(fmp),
        ...(0, $cn8xD.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("giYzc", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $5e84afbfbb0c2bc4$export$b88d990436be0f8a);
const $5e84afbfbb0c2bc4$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("dKH2W", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $fe83df4fbdd131da$export$e952f50a4f2d02da);

var $atXmE = parcelRequire("atXmE");

var $dXSsW = parcelRequire("dXSsW");

var $4by0Q = parcelRequire("4by0Q");

var $10gbN = parcelRequire("10gbN");
const $fe83df4fbdd131da$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $atXmE.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $4by0Q.customTimings)(data);
    const ssr = (0, $dXSsW.isInitialPageLoad)(data) ? (0, $10gbN.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("4by0Q", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $97a5ee62ec0bacf6$export$6126f85083a72c6e);
const $97a5ee62ec0bacf6$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $97a5ee62ec0bacf6$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $97a5ee62ec0bacf6$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("10gbN", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $483c81961c492999$export$130f411261a599c5);

var $blP7p = parcelRequire("blP7p");
const $483c81961c492999$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $483c81961c492999$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $483c81961c492999$var$SSR_PREFIX = 'ssr';
const $483c81961c492999$var$mapKey = (key)=>{
    if (key === 'total') return $483c81961c492999$var$SSR_PREFIX;
    return `${$483c81961c492999$var$SSR_PREFIX}${0, $blP7p.NESTED_METRIC_SEPARATOR}${key}`;
};
const $483c81961c492999$export$130f411261a599c5 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getTimings)) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($483c81961c492999$var$filterEntry(entry[1])) acc[$483c81961c492999$var$mapKey(entry[0])] = $483c81961c492999$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("blP7p", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $c25470a3528c7334$export$b98e411ae80c806f);
const $c25470a3528c7334$export$b98e411ae80c806f = '/';

});



parcelRegister("lGKsG", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $4ea4f0871f1b496a$export$1a2bb347935fc536);

var $bQQUF = parcelRequire("bQQUF");
const $4ea4f0871f1b496a$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $bQQUF.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings !== null && bundleEvalTimings !== void 0 && bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("bQQUF", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObject", () => $60e51dadffe3f06f$export$8cd0c777b0eb66a0);

var $fYc8n = parcelRequire("fYc8n");
const $60e51dadffe3f06f$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = (0, $fYc8n.getWindowObject)() || {};
    return performance;
};

});
parcelRegister("fYc8n", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $cd1714eaa4102f75$export$9aa44f85591248d9);
const $cd1714eaa4102f75$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};

});



parcelRegister("2XCEW", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $8a045be6d9e97219$export$81a7d52441a06b50);

var $bQQUF = parcelRequire("bQQUF");

var $fYc8n = parcelRequire("fYc8n");

var $jwrMl = parcelRequire("jwrMl");
const $8a045be6d9e97219$var$cacheableTypes = [
    'script',
    'link'
];
const $8a045be6d9e97219$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $8a045be6d9e97219$var$CACHE_NETWORK = 'network';
const $8a045be6d9e97219$var$CACHE_MEMORY = 'memory';
const $8a045be6d9e97219$var$CACHE_DISK = 'disk';
const $8a045be6d9e97219$var$calculateTransferType = (type, duration, size)=>{
    if (!$8a045be6d9e97219$var$cacheableTypes.includes(type)) return $8a045be6d9e97219$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $8a045be6d9e97219$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $8a045be6d9e97219$var$CACHE_DISK;
    if (size === undefined) return null;
    return $8a045be6d9e97219$var$CACHE_NETWORK;
};
const $8a045be6d9e97219$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$8a045be6d9e97219$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $fYc8n.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $8a045be6d9e97219$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $8a045be6d9e97219$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $8a045be6d9e97219$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $8a045be6d9e97219$var$getNetworkData = (item, eventStart, hasTimingHeaders = $8a045be6d9e97219$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$8a045be6d9e97219$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($8a045be6d9e97219$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $8a045be6d9e97219$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$8a045be6d9e97219$var$getSizeObject(transferSize)
        };
        if (transferType !== $8a045be6d9e97219$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$8a045be6d9e97219$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$8a045be6d9e97219$var$getSizeObject(transferSize)
    };
};
const $8a045be6d9e97219$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $bQQUF.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !(resourceTimings !== null && resourceTimings !== void 0 && resourceTimings.sanitiseEndpoints)) return null;
    const resources = (0, $jwrMl.getResourceTimings)(data.result.startTime, performance);
    if (!(resources !== null && resources !== void 0 && resources.length)) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $8a045be6d9e97219$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $8a045be6d9e97219$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$8a045be6d9e97219$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("jwrMl", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $fe6d51e4c5078bdc$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $fe6d51e4c5078bdc$export$9eebb59359c2e9e5);
// @flow strict-local

var $47W3d = parcelRequire("47W3d");

var $bQQUF = parcelRequire("bQQUF");

var $8rwXn = parcelRequire("8rwXn");
const $fe6d51e4c5078bdc$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $bQQUF.getPerformanceObject)(), PerformanceObserver1 = (0, $8rwXn.getPerformanceObserverObject)())=>{
        var _performance$getEntri;
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($fe6d51e4c5078bdc$export$bea963256235a63e.observer) {
            (0, $47W3d.ufologger).warn('Observer is already running');
            return;
        }
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $fe6d51e4c5078bdc$export$bea963256235a63e.timings = resources.map((resource)=>$fe6d51e4c5078bdc$export$bea963256235a63e.transformResource(resource));
        $fe6d51e4c5078bdc$export$bea963256235a63e.observer = new PerformanceObserver1($fe6d51e4c5078bdc$export$bea963256235a63e.addTimings);
        $fe6d51e4c5078bdc$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($fe6d51e4c5078bdc$export$bea963256235a63e.observer) {
            $fe6d51e4c5078bdc$export$bea963256235a63e.observer.disconnect();
            $fe6d51e4c5078bdc$export$bea963256235a63e.observer = null;
        }
        $fe6d51e4c5078bdc$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$fe6d51e4c5078bdc$export$bea963256235a63e.transformResource(entry));
        const overflow = $fe6d51e4c5078bdc$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $fe6d51e4c5078bdc$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $fe6d51e4c5078bdc$export$bea963256235a63e.maxSize;
            $fe6d51e4c5078bdc$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $fe6d51e4c5078bdc$export$bea963256235a63e.timings.push(...entries);
    }
};
const $fe6d51e4c5078bdc$export$9eebb59359c2e9e5 = (startTime, performance = (0, $bQQUF.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$fe6d51e4c5078bdc$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $fe6d51e4c5078bdc$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});
parcelRegister("8rwXn", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserverObject", () => $6e79e3680a785684$export$74560fd4e61fd440);

var $fYc8n = parcelRequire("fYc8n");
const $6e79e3680a785684$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = (0, $fYc8n.getWindowObject)() || {};
    return PerformanceObserver;
};

});




parcelRegister("iEVDb", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $71d6e59662940ed3$export$723b4c298aca63af);

var $127T9 = parcelRequire("127T9");
const $71d6e59662940ed3$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $127T9.PageVisibleState).HIDDEN : (0, $127T9.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("38QJf", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $eb2bf5044deb9953$export$e34e4529b979f74c);
const $eb2bf5044deb9953$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("2BxHX", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $ba67ce55eef4a49c$export$82ae485178b37419);
const $ba67ce55eef4a49c$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("3DAGl", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $4f11f8f2b1caeb64$export$f435c2789ca334a7);

var $kgstt = parcelRequire("kgstt");

var $jiju3 = parcelRequire("jiju3");

var $fYc8n = parcelRequire("fYc8n");
const $4f11f8f2b1caeb64$export$f435c2789ca334a7 = (0, $jiju3.default)(()=>{
    var _getWindowObject;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($kgstt))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($kgstt))).getParser(((_getWindowObject = (0, $fYc8n.getWindowObject)()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.navigator) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("C7lsR", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $0f6eb8674101d10d$export$db7649b8854107ad);

var $jiju3 = parcelRequire("jiju3");
const $0f6eb8674101d10d$export$db7649b8854107ad = (0, $jiju3.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("ksyoN", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $1a4daa3416ca244f$export$e62953d023125748);
const $1a4daa3416ca244f$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("2eWE4", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $4eb42f7f5a31226c$export$81efaf8414879a1a);

var $jiju3 = parcelRequire("jiju3");
const $4eb42f7f5a31226c$export$81efaf8414879a1a = (0, $jiju3.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("h4tlu", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $72a6bf4fa0d57850$export$ce1cf816dce1da56);
const $72a6bf4fa0d57850$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("913ya", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $3d8591668113e171$export$fdbea518c19dfa8);
const $3d8591668113e171$export$fdbea518c19dfa8 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("fHR1z", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $b06509239fb4d60f$export$a3dc8251cf55b2e0);
const $b06509239fb4d60f$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("dqgRx", function(module, exports) {
$parcel$export(module.exports, "Route", () => $b7c70fde121c8351$export$e7b0ac011bb776c6);
const $b7c70fde121c8351$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});



parcelRegister("8zZLS", function(module, exports) {
$parcel$export(module.exports, "initialiseConnectAndSentryAndCleanUrl", () => $4bbc8252d0217884$export$d937591d0adcb4ed);

var $hN5YJ = parcelRequire("hN5YJ");

var $cfAtN = parcelRequire("cfAtN");

var $aeJDa = parcelRequire("aeJDa");

var $6rayQ = parcelRequire("6rayQ");

var $esgVk = parcelRequire("esgVk");

var $7wx9B = parcelRequire("7wx9B");

var $5Vxee = parcelRequire("5Vxee");

var $4B1hn = parcelRequire("4B1hn");
const $4bbc8252d0217884$export$d937591d0adcb4ed = ()=>{
    if (!(0, $hN5YJ.isWrmOptimizationsEnabled)()) (0, $cfAtN.awaitGlobal)('connectHost', (0, $aeJDa.default));
    if ((0, $7wx9B.isSentryEnabled)()) {
        (0, $5Vxee.install)();
        (0, $4B1hn.sentryQueue).flushErrors();
    }
    const url = (0, $esgVk.href)();
    const modifiedUrl = (0, $6rayQ.removeParamsFromUrl)(url, [
        'sda_source'
    ]);
    if (url !== modifiedUrl) (0, $6rayQ.set)({
        sda_source: undefined
    });
};

});
parcelRegister("cfAtN", function(module, exports) {
$parcel$export(module.exports, "awaitGlobal", () => $1b50544fe0b1ead6$export$653e97524db056d2);
const $1b50544fe0b1ead6$var$isGlobalDefined = (objName)=>{
    // @ts-ignore TS(7015) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    return window[objName] !== undefined;
};
const $1b50544fe0b1ead6$export$653e97524db056d2 = (objectName, cb)=>{
    if ($1b50544fe0b1ead6$var$isGlobalDefined(objectName)) cb();
    else {
        const intervalTime = 100;
        let loopCounter = 0;
        const awaitInterval = setInterval(()=>{
            if ($1b50544fe0b1ead6$var$isGlobalDefined(objectName)) {
                clearInterval(awaitInterval);
                cb();
            }
            loopCounter += 1;
            // Loop will run for maximum of 10 seconds
            if (loopCounter > 100) clearInterval(awaitInterval);
        }, intervalTime);
    }
};

});

parcelRegister("aeJDa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b315ece8dcb76159$export$2e2bcd8739ae039);

var $eFuYD = parcelRequire("eFuYD");
function $b315ece8dcb76159$var$init() {
    const { connectHost: connectHost } = window;
    const api = (0, $eFuYD.connectApi)(connectHost);
    function createRequestPropertiesModule() {
        class RequestProperties {
            validate(isValid, context) {
                api.validate(isValid, context._context);
            }
            serialize(data, context) {
                api.serialize(data, context._context);
            }
        }
        return {
            constructor: RequestProperties,
            validate: RequestProperties.prototype.validate,
            serialize: RequestProperties.prototype.serialize
        };
    }
    const jiraServiceDesk = {
        RequestProperties: createRequestPropertiesModule()
    };
    connectHost.defineModule('jiraServiceDesk', jiraServiceDesk);
}
var $b315ece8dcb76159$export$2e2bcd8739ae039 = $b315ece8dcb76159$var$init;

});
parcelRegister("eFuYD", function(module, exports) {
$parcel$export(module.exports, "getAppKeyFromFullKey", () => $8ca3706dc2e88941$export$30f3f10c136c0ee6);
$parcel$export(module.exports, "getUniqueAppKeysFromConnectFragments", () => $8ca3706dc2e88941$export$bc66b351c49d3b94);
$parcel$export(module.exports, "connectApi", () => $8ca3706dc2e88941$export$b0d55f75723432a0);
$parcel$export(module.exports, "validate", () => $8ca3706dc2e88941$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "serialize", () => $8ca3706dc2e88941$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "register", () => $8ca3706dc2e88941$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $8ca3706dc2e88941$export$d07f55d4c15c0440);
// Events that the connect field add-on will need to listen to, These are API.
// We don't need to worry about these as it's handled by us but they shouldn't be changed.

var $aYMdQ = parcelRequire("aYMdQ");
const $8ca3706dc2e88941$var$EVENTS = {
    VALIDATE: 'jira-servicedesk-request-properties-validate',
    SERIALIZE: 'jira-servicedesk-request-properties-serialize'
};
const $8ca3706dc2e88941$var$connectPluginKey = 'com.atlassian.plugins.atlassian-connect-plugin';
const $8ca3706dc2e88941$var$internalListOfAddons = {};
function $8ca3706dc2e88941$var$getFullkey(context) {
    const addonKey = context.extension.addon_key;
    const panelKey = context.extension.key;
    return `${$8ca3706dc2e88941$var$connectPluginKey}:${addonKey}__${panelKey}`;
}
const $8ca3706dc2e88941$export$30f3f10c136c0ee6 = (fullKey = '')=>{
    const strippedOfModuleKey = fullKey.substring(0, fullKey.lastIndexOf('__'));
    return strippedOfModuleKey.substring(strippedOfModuleKey.lastIndexOf(':') + 1);
};
const $8ca3706dc2e88941$export$bc66b351c49d3b94 = (connectFragments)=>{
    return (0, $aYMdQ.uniq)(connectFragments.map((fragment)=>$8ca3706dc2e88941$export$30f3f10c136c0ee6(fragment.key)));
};
let $8ca3706dc2e88941$var$connectHost;
const $8ca3706dc2e88941$export$b0d55f75723432a0 = (host)=>{
    $8ca3706dc2e88941$var$connectHost = host;
    $8ca3706dc2e88941$var$connectHost.onIframeEstablished((context)=>{
        const fullKey = $8ca3706dc2e88941$var$getFullkey(context);
        const addonRef = $8ca3706dc2e88941$var$internalListOfAddons[fullKey];
        if (!!addonRef) $8ca3706dc2e88941$var$internalListOfAddons[fullKey] = {
            ...$8ca3706dc2e88941$var$internalListOfAddons[fullKey],
            contextExtension: context.extension
        };
    });
    return {
        // add-ons will call this on the request create page with the result of the validation after they receive the EVENTS.VALIDATE event
        validate (isValid, context) {
            const fullKey = $8ca3706dc2e88941$var$getFullkey(context);
            const addonRef = $8ca3706dc2e88941$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onValidated(isValid);
        },
        // add-ons will call this on the request create page with the serialized data after they receive the EVENTS.SERIALIZE event
        serialize (data, context) {
            const fullKey = $8ca3706dc2e88941$var$getFullkey(context);
            const addonRef = $8ca3706dc2e88941$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onSerialized(data);
        }
    };
};
const $8ca3706dc2e88941$export$a22775fa5e2eebd9 = (key)=>{
    const addonRef = $8ca3706dc2e88941$var$internalListOfAddons[key];
    $8ca3706dc2e88941$var$connectHost && addonRef && addonRef.contextExtension && $8ca3706dc2e88941$var$connectHost.broadcastEvent($8ca3706dc2e88941$var$EVENTS.VALIDATE, addonRef.contextExtension);
};
const $8ca3706dc2e88941$export$dfdc1655ccc5b9cb = (key)=>{
    const addonRef = $8ca3706dc2e88941$var$internalListOfAddons[key];
    $8ca3706dc2e88941$var$connectHost && addonRef && addonRef.contextExtension && $8ca3706dc2e88941$var$connectHost.broadcastEvent($8ca3706dc2e88941$var$EVENTS.SERIALIZE, addonRef.contextExtension);
};
const $8ca3706dc2e88941$export$6503ec6e8aabbaf = (key, onSerialized, onValidated)=>{
    $8ca3706dc2e88941$var$internalListOfAddons[key] = {
        onSerialized: onSerialized,
        onValidated: onValidated
    };
};
const $8ca3706dc2e88941$export$d07f55d4c15c0440 = (key)=>{
    delete $8ca3706dc2e88941$var$internalListOfAddons[key];
};

});


parcelRegister("6rayQ", function(module, exports) {
$parcel$export(module.exports, "getAll", () => $2b8772e63ea0ed44$export$2774c37398bee8b2);
$parcel$export(module.exports, "get", () => $2b8772e63ea0ed44$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $2b8772e63ea0ed44$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "addParamsToUrl", () => $2b8772e63ea0ed44$export$e1e3ddd390fd26f2);
$parcel$export(module.exports, "removeParamsFromUrl", () => $2b8772e63ea0ed44$export$9d6317f3c41bff91);

var $aYMdQ = parcelRequire("aYMdQ");

var $6dipk = parcelRequire("6dipk");

var $diqlM = parcelRequire("diqlM");
function $2b8772e63ea0ed44$export$2774c37398bee8b2() {
    if (!(0, $diqlM.default).location.search) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...$6dipk.parse((0, $diqlM.default).location.search)
    };
}
function $2b8772e63ea0ed44$export$3988ae62b71be9a3(key) {
    const values = $2b8772e63ea0ed44$export$2774c37398bee8b2();
    return values && values[key];
}
const $2b8772e63ea0ed44$export$fac44ee5b035f737 = (queryParams)=>$6dipk.stringify(queryParams).replace(/%20/g, '+');
function $2b8772e63ea0ed44$export$adaa4cf7ef1b65be(newValues, replace = true) {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values = $6dipk.parse((0, $diqlM.default).location.search);
    const search = $2b8772e63ea0ed44$export$fac44ee5b035f737({
        ...values,
        ...newValues
    });
    const newLocation = {
        ...(0, $diqlM.default).location,
        search: search
    };
    if (replace) (0, $diqlM.default).replace(newLocation);
    else (0, $diqlM.default).push(newLocation);
}
const $2b8772e63ea0ed44$export$e1e3ddd390fd26f2 = (url, addParams)=>{
    const qs = $6dipk.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = {
        ...$6dipk.parse(qs),
        ...addParams
    };
    const newQueryString = $2b8772e63ea0ed44$export$fac44ee5b035f737(params);
    if (newQueryString) return `${url.split('?')[0]}?${newQueryString}`;
    return url;
};
const $2b8772e63ea0ed44$export$9d6317f3c41bff91 = (url, paramsToRemove)=>{
    const qs = $6dipk.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = $6dipk.parse(qs);
    let isParamsRemoved = false;
    paramsToRemove.forEach((paramToRemove)=>{
        if ((0, $aYMdQ.has)(params, paramToRemove)) {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            delete params[paramToRemove];
            isParamsRemoved = true;
        }
    });
    // don't modify url if there is nothing to remove
    if (!isParamsRemoved) return url;
    const newQueryString = $2b8772e63ea0ed44$export$fac44ee5b035f737(params);
    const urlWithoutQuery = url.split('?')[0];
    if (newQueryString) return `${urlWithoutQuery}?${newQueryString}`;
    return urlWithoutQuery;
};

});
parcelRegister("6dipk", function(module, exports) {
$parcel$export(module.exports, "extract", () => $48623c5892d3ece7$export$f9380c9a627682d3, (v) => $48623c5892d3ece7$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $48623c5892d3ece7$export$98e6a39c04603d36, (v) => $48623c5892d3ece7$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $48623c5892d3ece7$export$fac44ee5b035f737, (v) => $48623c5892d3ece7$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $48623c5892d3ece7$export$7a5253c0f62e0150, (v) => $48623c5892d3ece7$export$7a5253c0f62e0150 = v);
var $48623c5892d3ece7$export$f9380c9a627682d3;
var $48623c5892d3ece7$export$98e6a39c04603d36;
var $48623c5892d3ece7$export$fac44ee5b035f737;
var $48623c5892d3ece7$export$7a5253c0f62e0150;
'use strict';

var $dp4Ym = parcelRequire("dp4Ym");

var $9Z27o = parcelRequire("9Z27o");

var $8DUYv = parcelRequire("8DUYv");
function $48623c5892d3ece7$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $48623c5892d3ece7$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $48623c5892d3ece7$var$encode(key, opts),
                    '[',
                    $48623c5892d3ece7$var$encode(index, opts),
                    ']=',
                    $48623c5892d3ece7$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $48623c5892d3ece7$var$encode(key, opts) : [
                    $48623c5892d3ece7$var$encode(key, opts),
                    '[]=',
                    $48623c5892d3ece7$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $48623c5892d3ece7$var$encode(key, opts) : [
                    $48623c5892d3ece7$var$encode(key, opts),
                    '=',
                    $48623c5892d3ece7$var$encode(value, opts)
                ].join('');
            };
    }
}
function $48623c5892d3ece7$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $48623c5892d3ece7$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $dp4Ym(value) : encodeURIComponent(value);
    return value;
}
function $48623c5892d3ece7$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $48623c5892d3ece7$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $48623c5892d3ece7$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $48623c5892d3ece7$var$parse(str, opts) {
    opts = $9Z27o({
        arrayFormat: 'none'
    }, opts);
    var formatter = $48623c5892d3ece7$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $8DUYv(val);
        formatter($8DUYv(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $48623c5892d3ece7$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$48623c5892d3ece7$export$f9380c9a627682d3 = $48623c5892d3ece7$var$extract;
$48623c5892d3ece7$export$98e6a39c04603d36 = $48623c5892d3ece7$var$parse;
$48623c5892d3ece7$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $9Z27o(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $48623c5892d3ece7$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $48623c5892d3ece7$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $48623c5892d3ece7$var$encode(key, opts) + '=' + $48623c5892d3ece7$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$48623c5892d3ece7$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $48623c5892d3ece7$var$parse($48623c5892d3ece7$var$extract(str), opts)
    };
};

});
parcelRegister("dp4Ym", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("9Z27o", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $744b7436b9ad1b4c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $744b7436b9ad1b4c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $744b7436b9ad1b4c$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $744b7436b9ad1b4c$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $744b7436b9ad1b4c$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $744b7436b9ad1b4c$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $744b7436b9ad1b4c$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($744b7436b9ad1b4c$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($744b7436b9ad1b4c$var$getOwnPropertySymbols) {
            symbols = $744b7436b9ad1b4c$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($744b7436b9ad1b4c$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("esgVk", function(module, exports) {
$parcel$export(module.exports, "reload", () => $644c2b12a92c4b49$export$32da5b5043dcd88c);
$parcel$export(module.exports, "replace", () => $644c2b12a92c4b49$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "pathname", () => $644c2b12a92c4b49$export$7333db99aa99d383);
$parcel$export(module.exports, "location", () => $644c2b12a92c4b49$export$17b07c660794dc13);
$parcel$export(module.exports, "href", () => $644c2b12a92c4b49$export$8f51af5840e0602a);
$parcel$export(module.exports, "hash", () => $644c2b12a92c4b49$export$d6af199866bfb566);
$parcel$export(module.exports, "origin", () => $644c2b12a92c4b49$export$f710a83a91838a36);
$parcel$export(module.exports, "search", () => $644c2b12a92c4b49$export$d76128d007d19019);
$parcel$export(module.exports, "open", () => $644c2b12a92c4b49$export$3ce6949f20cea765);
$parcel$export(module.exports, "assign", () => $644c2b12a92c4b49$export$e6e34fd1f2686227);
$parcel$export(module.exports, "isValidLocation", () => $644c2b12a92c4b49$export$f15ea956d38b6f8a);

var $aYMdQ = parcelRequire("aYMdQ");
const $644c2b12a92c4b49$export$32da5b5043dcd88c = ()=>window.location.reload();
const $644c2b12a92c4b49$export$77ad94ebf1c2b9ed = (path)=>window.location.replace(path);
const $644c2b12a92c4b49$export$7333db99aa99d383 = ()=>window.location.pathname;
const $644c2b12a92c4b49$export$17b07c660794dc13 = ()=>window.location;
const $644c2b12a92c4b49$export$8f51af5840e0602a = ()=>window.location.href;
const $644c2b12a92c4b49$export$d6af199866bfb566 = ()=>window.location.hash;
const $644c2b12a92c4b49$export$f710a83a91838a36 = ()=>window.location.origin;
const $644c2b12a92c4b49$export$d76128d007d19019 = ()=>window.location.search;
const $644c2b12a92c4b49$export$3ce6949f20cea765 = (url, target)=>window.open(url, target);
const $644c2b12a92c4b49$export$e6e34fd1f2686227 = (url)=>window.location.assign(url);
const $644c2b12a92c4b49$export$f15ea956d38b6f8a = (maybeUrl)=>{
    if (decodeURIComponent(maybeUrl).startsWith('//')) return false;
    return (0, $aYMdQ.startsWith)(maybeUrl, 'http') || (0, $aYMdQ.startsWith)(maybeUrl, '/') || (0, $aYMdQ.startsWith)(maybeUrl, '%2F') || (0, $aYMdQ.startsWith)(maybeUrl, '%2f');
};

});

parcelRegister("5Vxee", function(module, exports) {
$parcel$export(module.exports, "install", () => $634ea3d357a18364$export$4b3e715f166fdd78);

var $2tNS7 = parcelRequire("2tNS7");
var $REREP = parcelRequire("REREP");
var $6SODg = parcelRequire("6SODg");

var $clhwU = parcelRequire("clhwU");

var $7rEw1 = parcelRequire("7rEw1");

var $6LH8a = parcelRequire("6LH8a");

var $7lN8e = parcelRequire("7lN8e");
function $634ea3d357a18364$export$94684a7ef5037b24(event) {
    try {
        var _event$exception;
        const rewriteStacktrace = (value)=>{
            var _value$stacktrace, _value$stacktrace2;
            if (!Array.isArray(value === null || value === void 0 || (_value$stacktrace = value.stacktrace) === null || _value$stacktrace === void 0 ? void 0 : _value$stacktrace.frames)) return;
            value === null || value === void 0 || (_value$stacktrace2 = value.stacktrace) === null || _value$stacktrace2 === void 0 || _value$stacktrace2.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `event.stacktrace`
        rewriteStacktrace(event);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (Array.isArray(event === null || event === void 0 || (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values)) {
            var _event$exception2;
            event === null || event === void 0 || (_event$exception2 = event.exception) === null || _event$exception2 === void 0 || _event$exception2.values.forEach(rewriteStacktrace);
        }
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return event;
}
function $634ea3d357a18364$var$getSentryEnv(env) {
    switch(env){
        case (0, $7lN8e.EnvType).PROD:
            return 'production';
        case (0, $7lN8e.EnvType).STAGING:
            return 'staging';
        default:
            return 'development';
    }
}
class $634ea3d357a18364$var$SentryInstaller {
    static install() {
        // Check if we have already initialised Sentry to be defensive in case two fragments are loaded in the same page, we don't want duplicated error reports.
        const client = $REREP.getCurrentHub().getClient();
        if (client && client.getOptions().enabled) return;
        $6SODg.init({
            dsn: $634ea3d357a18364$var$SentryInstaller.JS_ERROR_TRACKING_SENTRY_URL,
            release: $634ea3d357a18364$var$SentryInstaller.getRelease(),
            environment: $634ea3d357a18364$var$getSentryEnv((0, $7lN8e.getEnv)().environment),
            // This is evaluated against the *first* frame of the stack trace. If it doesn't match, the error is not sent.
            whitelistUrls: $634ea3d357a18364$var$SentryInstaller.FRONTEND_RESOURCES,
            beforeSend: (event)=>{
                return $634ea3d357a18364$export$94684a7ef5037b24(event);
            },
            maxBreadcrumbs: 100,
            integrations: (integrations)=>{
                integrations.push(// This is used to mark which frames of the stacktrace are part of our app. They will be displayed in a different UI in Sentry.
                new $clhwU.RewriteFrames({
                    iteratee: (frame)=>{
                        if (frame.filename) frame.in_app = $634ea3d357a18364$var$SentryInstaller.FRONTEND_RESOURCES.some((path)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            path.test(frame.filename));
                        return frame;
                    }
                }));
                return integrations;
            }
        });
        // This is for OpsGenie, so that alerts are tagged correctly.
        $2tNS7.configureScope((scope)=>{
            scope.setTag('environment_type', (0, $7lN8e.getEnv)().environment);
            scope.setTag('service_id', 'jsm-portal-frontend');
            const commit = $634ea3d357a18364$var$SentryInstaller.getCommit();
            if (commit) scope.setTag('commit', commit);
            const cloudId = $634ea3d357a18364$var$SentryInstaller.getCloudId();
            if (cloudId) scope.setTag('cloud_id', cloudId);
        });
    // TODO: add Aa ID + feature flags state tracking  - FSD-2309
    }
    static #_ = // TODO: extract this URL in a env variable - FSD-2309
    this.JS_ERROR_TRACKING_SENTRY_URL = (0, $7rEw1.isFedRamp)() ? 'https://9f5728b18f4afcbbd6127c57b615afa3@sentry.prod.services.kitt-inf-us-gov-mod.net/15' : 'https://dc9ea62591514adf8234e2c995959d5c@o55978.ingest.sentry.io/5988807';
    static #_2 = this.FRONTEND_RESOURCES = [
        // Our DEV and PROD environments in Micros Static.
        /https:\/\/jsm-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsd-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atlassian-us-gov-mod\.com\//,
        // For devs using `yarn dev`.
        /localhost/
    ];
    static getCommit() {
        if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit;
        return undefined;
    }
    static getRelease() {
        return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    }
    static getCloudId() {
        return (0, $6LH8a.getMeta)('tenant-id');
    }
}
const $634ea3d357a18364$export$4b3e715f166fdd78 = $634ea3d357a18364$var$SentryInstaller.install;

});
parcelRegister("6SODg", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $502f0fbcc9a884ad$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $502f0fbcc9a884ad$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $502f0fbcc9a884ad$export$3a8fd680da42627b);
$parcel$export(module.exports, "lastEventId", () => $502f0fbcc9a884ad$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "forceLoad", () => $502f0fbcc9a884ad$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $502f0fbcc9a884ad$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "flush", () => $502f0fbcc9a884ad$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $502f0fbcc9a884ad$export$8360e631d277ea4d);
$parcel$export(module.exports, "wrap", () => $502f0fbcc9a884ad$export$4997ffc0176396a6);

var $5lpFe = parcelRequire("5lpFe");

var $REREP = parcelRequire("REREP");
var $7NGQC = parcelRequire("7NGQC");
var $2aLTg = parcelRequire("2aLTg");
parcelRequire("5Ve5I");
var $4ppVB = parcelRequire("4ppVB");
var $2mAO5 = parcelRequire("2mAO5");
var $6Xtyr = parcelRequire("6Xtyr");
var $1GwN2 = parcelRequire("1GwN2");

var $keI9Q = parcelRequire("keI9Q");

var $7ZUKl = parcelRequire("7ZUKl");

var $1xbOS = parcelRequire("1xbOS");

var $jEFf2 = parcelRequire("jEFf2");
var $flU3k = parcelRequire("flU3k");
var $7ATFd = parcelRequire("7ATFd");
var $inxLT = parcelRequire("inxLT");
var $5FM25 = parcelRequire("5FM25");
var $2yS8d = parcelRequire("2yS8d");
var $502f0fbcc9a884ad$export$5ef831fccfce35e5 = [
    new (0, $2aLTg).InboundFilters(),
    new (0, $2aLTg).FunctionToString(),
    new (0, $5FM25.TryCatch)(),
    new (0, $jEFf2.Breadcrumbs)(),
    new (0, $7ATFd.GlobalHandlers)(),
    new (0, $inxLT.LinkedErrors)(),
    new (0, $flU3k.Dedupe)(),
    new (0, $2yS8d.UserAgent)()
];
function $502f0fbcc9a884ad$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $502f0fbcc9a884ad$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $2mAO5.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $7NGQC.initAndBind)((0, $keI9Q.BrowserClient), options);
    if (options.autoSessionTracking) $502f0fbcc9a884ad$var$startSessionTracking();
}
function $502f0fbcc9a884ad$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $REREP.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $502f0fbcc9a884ad$export$5d4e9fd7fac8e617() {
    return (0, $REREP.getCurrentHub)().lastEventId();
}
function $502f0fbcc9a884ad$export$a3f323d81eede727() {
// Noop
}
function $502f0fbcc9a884ad$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $502f0fbcc9a884ad$export$4909b86c8034bf73(timeout) {
    var client = (0, $REREP.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Cannot flush events. No client defined.');
    return (0, $1GwN2.resolvedSyncPromise)(false);
}
function $502f0fbcc9a884ad$export$8360e631d277ea4d(timeout) {
    var client = (0, $REREP.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $1GwN2.resolvedSyncPromise)(false);
}
function $502f0fbcc9a884ad$export$4997ffc0176396a6(fn) {
    return (0, $1xbOS.wrap)(fn)();
}
function $502f0fbcc9a884ad$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $502f0fbcc9a884ad$var$startSessionTracking() {
    var window = (0, $2mAO5.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $REREP.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $502f0fbcc9a884ad$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $4ppVB.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $502f0fbcc9a884ad$var$startSessionOnHub((0, $REREP.getCurrentHub)());
    });
}

});
parcelRegister("7NGQC", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $5ade58aad9011d9b$export$5333c3f1c58d9bc1);

var $REREP = parcelRequire("REREP");
parcelRequire("5Ve5I");
var $6Xtyr = parcelRequire("6Xtyr");

var $awYVl = parcelRequire("awYVl");
function $5ade58aad9011d9b$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $awYVl.IS_DEBUG_BUILD) (0, $6Xtyr.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $REREP.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("awYVl", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $7aac26bda689830a$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $7aac26bda689830a$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("2aLTg", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("5fVq3")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("b5JcU")).InboundFilters);

var $5fVq3 = parcelRequire("5fVq3");

var $b5JcU = parcelRequire("b5JcU");

});
parcelRegister("5fVq3", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $3d3ae4bef1ca9019$export$da4704525c20ae79);
parcelRequire("5Ve5I");
var $bZphu = parcelRequire("bZphu");
var $3d3ae4bef1ca9019$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $3d3ae4bef1ca9019$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $3d3ae4bef1ca9019$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $bZphu.getOriginalFunction)(this) || this;
            return $3d3ae4bef1ca9019$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("b5JcU", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $81333a8d0f7ed2b7$export$2ffbb5359dcc6be4);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("5Ve5I");
var $kcrfC = parcelRequire("kcrfC");
var $bQUiH = parcelRequire("bQUiH");
var $6Xtyr = parcelRequire("6Xtyr");

var $awYVl = parcelRequire("awYVl");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $81333a8d0f7ed2b7$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $81333a8d0f7ed2b7$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $81333a8d0f7ed2b7$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $81333a8d0f7ed2b7$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $81333a8d0f7ed2b7$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $5lpFe.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $5lpFe.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $5lpFe.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $81333a8d0f7ed2b7$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $81333a8d0f7ed2b7$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $81333a8d0f7ed2b7$var$_isSentryError(event)) {
        (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $kcrfC.getEventDescription)(event));
        return true;
    }
    if ($81333a8d0f7ed2b7$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $kcrfC.getEventDescription)(event));
        return true;
    }
    if ($81333a8d0f7ed2b7$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $kcrfC.getEventDescription)(event) + ".\nUrl: " + $81333a8d0f7ed2b7$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$81333a8d0f7ed2b7$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $kcrfC.getEventDescription)(event) + ".\nUrl: " + $81333a8d0f7ed2b7$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $81333a8d0f7ed2b7$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $81333a8d0f7ed2b7$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $bQUiH.isMatchingPattern)(message, pattern);
        });
    });
}
function $81333a8d0f7ed2b7$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $81333a8d0f7ed2b7$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $bQUiH.isMatchingPattern)(url, pattern);
    });
}
function $81333a8d0f7ed2b7$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $81333a8d0f7ed2b7$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $bQUiH.isMatchingPattern)(url, pattern);
    });
}
function $81333a8d0f7ed2b7$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error("Cannot extract message for event " + (0, $kcrfC.getEventDescription)(event));
        return [];
    }
    return [];
}
function $81333a8d0f7ed2b7$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $81333a8d0f7ed2b7$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $81333a8d0f7ed2b7$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $81333a8d0f7ed2b7$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $81333a8d0f7ed2b7$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error("Cannot extract url for event " + (0, $kcrfC.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("keI9Q", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $ebb75e452fe2d8bc$export$1df9218a526d318d);

var $5lpFe = parcelRequire("5lpFe");

var $ain4T = parcelRequire("ain4T");
var $8ntGr = parcelRequire("8ntGr");
parcelRequire("5Ve5I");
var $2mAO5 = parcelRequire("2mAO5");
var $6Xtyr = parcelRequire("6Xtyr");

var $kQFyR = parcelRequire("kQFyR");

var $7ZUKl = parcelRequire("7ZUKl");

var $1xbOS = parcelRequire("1xbOS");

var $jEFf2 = parcelRequire("jEFf2");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $ebb75e452fe2d8bc$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $8ntGr.SDK_VERSION)
                }
            ],
            version: (0, $8ntGr.SDK_VERSION)
        };
        _this = _super.call(this, (0, $kQFyR.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $2mAO5.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $1xbOS.injectReportDialog)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $jEFf2.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $ain4T.BaseClient));

});
parcelRegister("ain4T", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $77ed7ca35065cc40$export$4f22f74eddb7716a);

var $5lpFe = parcelRequire("5lpFe");

var $freWv = parcelRequire("freWv");
parcelRequire("5Ve5I");
var $kcrfC = parcelRequire("kcrfC");
var $7X7rA = parcelRequire("7X7rA");
var $eA0Kr = parcelRequire("eA0Kr");
var $6Xtyr = parcelRequire("6Xtyr");
var $9R2Wx = parcelRequire("9R2Wx");
var $a5ROm = parcelRequire("a5ROm");
var $1GwN2 = parcelRequire("1GwN2");
var $iqzHc = parcelRequire("iqzHc");
var $bQUiH = parcelRequire("bQUiH");

var $awYVl = parcelRequire("awYVl");

var $iurus = parcelRequire("iurus");
var $77ed7ca35065cc40$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $77ed7ca35065cc40$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $9R2Wx.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $kcrfC.checkOrSetAlreadyCaught)(exception)) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log($77ed7ca35065cc40$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $eA0Kr.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $kcrfC.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log($77ed7ca35065cc40$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $iurus.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $5lpFe.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $1GwN2.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $kcrfC.uuid4)()),
            timestamp: event.timestamp || (0, $7X7rA.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $freWv.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $1GwN2.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $a5ROm.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, b), b.data && {
                    data: (0, $a5ROm.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $a5ROm.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $a5ROm.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $a5ROm.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $bQUiH.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $bQUiH.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $bQUiH.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $5lpFe.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $1GwN2.rejectedSyncPromise)(new (0, $iqzHc.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $1GwN2.rejectedSyncPromise)(new (0, $iqzHc.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $iqzHc.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $77ed7ca35065cc40$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $iqzHc.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $iqzHc.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $iqzHc.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $77ed7ca35065cc40$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $eA0Kr.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $eA0Kr.isPlainObject)(event) || event === null)) throw new (0, $iqzHc.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $iqzHc.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $eA0Kr.isPlainObject)(rv) || rv === null)) throw new (0, $iqzHc.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("iurus", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $d7605a4eb80971b9$export$51abed9797baa598);

var $5lpFe = parcelRequire("5lpFe");

var $freWv = parcelRequire("freWv");
var $REREP = parcelRequire("REREP");
parcelRequire("5Ve5I");
var $bZphu = parcelRequire("bZphu");
var $6Xtyr = parcelRequire("6Xtyr");

var $awYVl = parcelRequire("awYVl");
var $d7605a4eb80971b9$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $d7605a4eb80971b9$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $d7605a4eb80971b9$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $5lpFe.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $5lpFe.__spread)($d7605a4eb80971b9$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $5lpFe.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $d7605a4eb80971b9$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $5lpFe.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $d7605a4eb80971b9$export$e7390a03b70a6f2f(integration) {
    if ($d7605a4eb80971b9$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $freWv.addGlobalEventProcessor), (0, $REREP.getCurrentHub));
    $d7605a4eb80971b9$export$b14a8888f80a0b3e.push(integration.name);
    (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log("Integration installed: " + integration.name);
}
function $d7605a4eb80971b9$export$51abed9797baa598(options) {
    var integrations = {};
    $d7605a4eb80971b9$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $d7605a4eb80971b9$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $bZphu.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("8ntGr", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $61977f38c717670f$export$31499a9cd224b78c);
var $61977f38c717670f$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("kQFyR", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $f2d8e728b0b4e6f6$export$2526e21aec9d0ce7);

var $5lpFe = parcelRequire("5lpFe");

var $3Y11X = parcelRequire("3Y11X");
var $3kzox = parcelRequire("3kzox");

var $8lCud = parcelRequire("8lCud");
parcelRequire("5Ve5I");
var $iSeUT = parcelRequire("iSeUT");

var $fcznZ = parcelRequire("fcznZ");

var $GRO5X = parcelRequire("GRO5X");
var $8Qb7E = parcelRequire("8Qb7E");
var $k2phX = parcelRequire("k2phX");
var $b1vKk = parcelRequire("b1vKk");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $f2d8e728b0b4e6f6$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $fcznZ.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $8lCud.Severity).Info;
        return (0, $fcznZ.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $3kzox.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $3kzox.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $iSeUT.supportsFetch)()) {
            var requestOptions = (0, $5lpFe.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $8Qb7E.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $GRO5X.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $k2phX.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $b1vKk.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $3Y11X.BaseBackend));

});
parcelRegister("3Y11X", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $2e37c657ede0aa83$export$8f43a53a38d7e95f);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("5Ve5I");
var $6Xtyr = parcelRequire("6Xtyr");
var $iqzHc = parcelRequire("iqzHc");

var $3kzox = parcelRequire("3kzox");

var $awYVl = parcelRequire("awYVl");

var $doD91 = parcelRequire("doD91");

var $lKSgZ = parcelRequire("lKSgZ");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $2e37c657ede0aa83$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $iqzHc.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $iqzHc.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $3kzox.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $doD91.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $3kzox.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $5lpFe.__read)((0, $doD91.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $awYVl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $lKSgZ.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("3kzox", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $26ceb20ad15fb436$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $26ceb20ad15fb436$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $26ceb20ad15fb436$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $26ceb20ad15fb436$export$671c7ed8e40a7a57);
parcelRequire("5Ve5I");
var $9R2Wx = parcelRequire("9R2Wx");
var $bZphu = parcelRequire("bZphu");
var $26ceb20ad15fb436$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $26ceb20ad15fb436$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $9R2Wx.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $26ceb20ad15fb436$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $26ceb20ad15fb436$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $26ceb20ad15fb436$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $26ceb20ad15fb436$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $26ceb20ad15fb436$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $9R2Wx.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $26ceb20ad15fb436$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $26ceb20ad15fb436$var$_getIngestEndpoint(dsn, target) {
    return "" + $26ceb20ad15fb436$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $26ceb20ad15fb436$var$_encodedAuth(dsn) {
    return (0, $bZphu.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $26ceb20ad15fb436$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $26ceb20ad15fb436$var$getStoreEndpoint(dsn) {
    return $26ceb20ad15fb436$var$_getIngestEndpoint(dsn, 'store');
}
function $26ceb20ad15fb436$export$c1677e22ac2217a5(dsn) {
    return $26ceb20ad15fb436$var$getStoreEndpoint(dsn) + "?" + $26ceb20ad15fb436$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $26ceb20ad15fb436$var$_getEnvelopeEndpoint(dsn) {
    return $26ceb20ad15fb436$var$_getIngestEndpoint(dsn, 'envelope');
}
function $26ceb20ad15fb436$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $26ceb20ad15fb436$var$_getEnvelopeEndpoint(dsn) + "?" + $26ceb20ad15fb436$var$_encodedAuth(dsn);
}
function $26ceb20ad15fb436$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $26ceb20ad15fb436$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $26ceb20ad15fb436$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $9R2Wx.makeDsn)(dsnLike);
    var endpoint = $26ceb20ad15fb436$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $9R2Wx.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("doD91", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $9c0be1836082a8d7$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $9c0be1836082a8d7$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $9c0be1836082a8d7$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $9c0be1836082a8d7$export$2006389de558b996);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("5Ve5I");
var $39WwY = parcelRequire("39WwY");
var $9R2Wx = parcelRequire("9R2Wx");
var $a5ROm = parcelRequire("a5ROm");

var $3kzox = parcelRequire("3kzox");
/** Extract sdk info from from the API metadata */ function $9c0be1836082a8d7$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9c0be1836082a8d7$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $5lpFe.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $5lpFe.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $9c0be1836082a8d7$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $9c0be1836082a8d7$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $9R2Wx.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $39WwY.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $9c0be1836082a8d7$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $5lpFe.__read)($9c0be1836082a8d7$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $39WwY.serializeEnvelope)(envelope),
        type: type,
        url: (0, $3kzox.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $9c0be1836082a8d7$export$c31057337a18010f(event, api) {
    var sdkInfo = $9c0be1836082a8d7$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9c0be1836082a8d7$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $9R2Wx.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $39WwY.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $9c0be1836082a8d7$export$2006389de558b996(event, api) {
    var sdkInfo = $9c0be1836082a8d7$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9c0be1836082a8d7$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $a5ROm.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $3kzox.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $3kzox.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $9R2Wx.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $39WwY.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $39WwY.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("lKSgZ", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $fd67fe58af7e0e0b$export$6f2767450ea1346c);
parcelRequire("5Ve5I");
var $1GwN2 = parcelRequire("1GwN2");
/** Noop transport */ var $fd67fe58af7e0e0b$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $1GwN2.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $1GwN2.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("fcznZ", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $b1136ceee26449f9$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $b1136ceee26449f9$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $b1136ceee26449f9$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $b1136ceee26449f9$export$5425b53185d13d6c);

var $5lpFe = parcelRequire("5lpFe");

var $8lCud = parcelRequire("8lCud");
parcelRequire("5Ve5I");
var $kcrfC = parcelRequire("kcrfC");
var $ja3HM = parcelRequire("ja3HM");
var $bZphu = parcelRequire("bZphu");
var $eA0Kr = parcelRequire("eA0Kr");
var $a5ROm = parcelRequire("a5ROm");
var $1GwN2 = parcelRequire("1GwN2");

var $be0RE = parcelRequire("be0RE");
function $b1136ceee26449f9$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $b1136ceee26449f9$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $b1136ceee26449f9$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $b1136ceee26449f9$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $eA0Kr.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $bZphu.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $a5ROm.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $b1136ceee26449f9$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $b1136ceee26449f9$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $b1136ceee26449f9$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $b1136ceee26449f9$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $b1136ceee26449f9$var$getPopSize(ex);
    try {
        return (0, $ja3HM.createStackParser)((0, $be0RE.opera10StackParser), (0, $be0RE.opera11StackParser), (0, $be0RE.chromeStackParser), (0, $be0RE.winjsStackParser), (0, $be0RE.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $b1136ceee26449f9$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $b1136ceee26449f9$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($b1136ceee26449f9$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $b1136ceee26449f9$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $b1136ceee26449f9$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $b1136ceee26449f9$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $kcrfC.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $8lCud.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $1GwN2.resolvedSyncPromise)(event);
}
function $b1136ceee26449f9$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $8lCud.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $b1136ceee26449f9$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $1GwN2.resolvedSyncPromise)(event);
}
function $b1136ceee26449f9$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $eA0Kr.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $b1136ceee26449f9$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $eA0Kr.isDOMError)(exception) || (0, $eA0Kr.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $b1136ceee26449f9$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $eA0Kr.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $b1136ceee26449f9$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $kcrfC.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $eA0Kr.isError)(exception)) // we have a real Error object, do nothing
    return $b1136ceee26449f9$export$73fbea5a0a5234af(exception);
    if ((0, $eA0Kr.isPlainObject)(exception) || (0, $eA0Kr.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $b1136ceee26449f9$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $kcrfC.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $b1136ceee26449f9$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $kcrfC.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $kcrfC.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $b1136ceee26449f9$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $b1136ceee26449f9$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("be0RE", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $82c1ac2922b5e43d$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $82c1ac2922b5e43d$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $82c1ac2922b5e43d$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $82c1ac2922b5e43d$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $82c1ac2922b5e43d$export$989a1824b4734ce6);

var $5lpFe = parcelRequire("5lpFe");
// global reference to slice
var $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION = '?';
var $82c1ac2922b5e43d$var$OPERA10_PRIORITY = 10;
var $82c1ac2922b5e43d$var$OPERA11_PRIORITY = 20;
var $82c1ac2922b5e43d$var$CHROME_PRIORITY = 30;
var $82c1ac2922b5e43d$var$WINJS_PRIORITY = 40;
var $82c1ac2922b5e43d$var$GECKO_PRIORITY = 50;
function $82c1ac2922b5e43d$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $82c1ac2922b5e43d$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $82c1ac2922b5e43d$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $82c1ac2922b5e43d$var$chrome = function(line) {
    var parts = $82c1ac2922b5e43d$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $82c1ac2922b5e43d$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $5lpFe.__read)($82c1ac2922b5e43d$var$extractSafariExtensionDetails(parts[1] || $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $82c1ac2922b5e43d$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $82c1ac2922b5e43d$export$c693d9295441d8f9 = [
    $82c1ac2922b5e43d$var$CHROME_PRIORITY,
    $82c1ac2922b5e43d$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $82c1ac2922b5e43d$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $82c1ac2922b5e43d$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $82c1ac2922b5e43d$var$gecko = function(line) {
    var _a;
    var parts = $82c1ac2922b5e43d$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $82c1ac2922b5e43d$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION;
        _a = (0, $5lpFe.__read)($82c1ac2922b5e43d$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $82c1ac2922b5e43d$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $82c1ac2922b5e43d$export$c9ddf1e2b5d48bff = [
    $82c1ac2922b5e43d$var$GECKO_PRIORITY,
    $82c1ac2922b5e43d$var$gecko
];
var $82c1ac2922b5e43d$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $82c1ac2922b5e43d$var$winjs = function(line) {
    var parts = $82c1ac2922b5e43d$var$winjsRegex.exec(line);
    return parts ? $82c1ac2922b5e43d$var$createFrame(parts[2], parts[1] || $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $82c1ac2922b5e43d$export$b6d155d85c1dcba5 = [
    $82c1ac2922b5e43d$var$WINJS_PRIORITY,
    $82c1ac2922b5e43d$var$winjs
];
var $82c1ac2922b5e43d$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $82c1ac2922b5e43d$var$opera10 = function(line) {
    var parts = $82c1ac2922b5e43d$var$opera10Regex.exec(line);
    return parts ? $82c1ac2922b5e43d$var$createFrame(parts[2], parts[3] || $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $82c1ac2922b5e43d$export$966ec832d9699d6 = [
    $82c1ac2922b5e43d$var$OPERA10_PRIORITY,
    $82c1ac2922b5e43d$var$opera10
];
var $82c1ac2922b5e43d$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $82c1ac2922b5e43d$var$opera11 = function(line) {
    var parts = $82c1ac2922b5e43d$var$opera11Regex.exec(line);
    return parts ? $82c1ac2922b5e43d$var$createFrame(parts[5], parts[3] || parts[4] || $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $82c1ac2922b5e43d$export$989a1824b4734ce6 = [
    $82c1ac2922b5e43d$var$OPERA11_PRIORITY,
    $82c1ac2922b5e43d$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $82c1ac2922b5e43d$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $82c1ac2922b5e43d$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("GRO5X", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $080da94e071190e2$export$2bdee3f9b92f4e82);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("5Ve5I");
var $iqzHc = parcelRequire("iqzHc");
var $iSeUT = parcelRequire("iSeUT");
var $1GwN2 = parcelRequire("1GwN2");

var $31QKS = parcelRequire("31QKS");

var $AMyWe = parcelRequire("AMyWe");
/** `fetch` based transport */ var $080da94e071190e2$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $AMyWe.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $iSeUT.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $1GwN2.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $iqzHc.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $31QKS.BaseTransport));

});
parcelRegister("31QKS", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $234a6321dae50d4f$export$74b99d619e90f481);

var $5lpFe = parcelRequire("5lpFe");

var $doD91 = parcelRequire("doD91");
var $3kzox = parcelRequire("3kzox");
parcelRequire("5Ve5I");
var $kZZlM = parcelRequire("kZZlM");
var $2z5O0 = parcelRequire("2z5O0");
var $9R2Wx = parcelRequire("9R2Wx");
var $eqURj = parcelRequire("eqURj");
var $2mAO5 = parcelRequire("2mAO5");
var $6Xtyr = parcelRequire("6Xtyr");
var $XMAWz = parcelRequire("XMAWz");
var $39WwY = parcelRequire("39WwY");

var $7ZUKl = parcelRequire("7ZUKl");

var $AMyWe = parcelRequire("AMyWe");
function $234a6321dae50d4f$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $234a6321dae50d4f$var$global = (0, $2mAO5.getGlobalObject)();
/** Base Transport class implementation */ var $234a6321dae50d4f$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $XMAWz.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $3kzox.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $3kzox.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $234a6321dae50d4f$var$global.document) $234a6321dae50d4f$var$global.document.addEventListener('visibilitychange', function() {
            if ($234a6321dae50d4f$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $doD91.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $doD91.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $234a6321dae50d4f$var$requestTypeToCategory(category) + ":" + reason;
        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log('No outcomes to flush');
            return;
        }
        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $3kzox.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $5lpFe.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $kZZlM.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $9R2Wx.dsnToString)(this._api.dsn));
        try {
            (0, $AMyWe.sendReport)(url, (0, $39WwY.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $eqURj.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $2z5O0.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $7ZUKl.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $6Xtyr.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $234a6321dae50d4f$var$requestTypeToCategory(requestType);
        return new Date((0, $2z5O0.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $234a6321dae50d4f$var$requestTypeToCategory(requestType);
        return (0, $2z5O0.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("7ZUKl", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $5d2a3f95c296bca2$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $5d2a3f95c296bca2$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("AMyWe", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $06e90869a79b6abe$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $06e90869a79b6abe$export$84bb63b2c17ec44d);
parcelRequire("5Ve5I");
var $aIZwz = parcelRequire("aIZwz");
var $2mAO5 = parcelRequire("2mAO5");
var $iSeUT = parcelRequire("iSeUT");
var $6Xtyr = parcelRequire("6Xtyr");

var $7ZUKl = parcelRequire("7ZUKl");
var $06e90869a79b6abe$var$global = (0, $2mAO5.getGlobalObject)();
var $06e90869a79b6abe$var$cachedFetchImpl;
function $06e90869a79b6abe$export$8be2119ce08e3379() {
    if ($06e90869a79b6abe$var$cachedFetchImpl) return $06e90869a79b6abe$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $iSeUT.isNativeFetch)($06e90869a79b6abe$var$global.fetch)) return $06e90869a79b6abe$var$cachedFetchImpl = $06e90869a79b6abe$var$global.fetch.bind($06e90869a79b6abe$var$global);
    var document = $06e90869a79b6abe$var$global.document;
    var fetchImpl = $06e90869a79b6abe$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $06e90869a79b6abe$var$cachedFetchImpl = fetchImpl.bind($06e90869a79b6abe$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $06e90869a79b6abe$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($06e90869a79b6abe$var$global && $06e90869a79b6abe$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $06e90869a79b6abe$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $06e90869a79b6abe$var$global.navigator.sendBeacon.bind($06e90869a79b6abe$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $iSeUT.supportsFetch)()) {
        var fetch_1 = $06e90869a79b6abe$export$8be2119ce08e3379();
        return (0, $aIZwz.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("8Qb7E", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $66fbceba6c809b4e$export$1c57e6bfd09bad13);

var $5lpFe = parcelRequire("5lpFe");

var $cvbmT = parcelRequire("cvbmT");

var $AMyWe = parcelRequire("AMyWe");
function $66fbceba6c809b4e$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $AMyWe.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $5lpFe.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $cvbmT.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("cvbmT", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $91a132ca7cc1d150$export$d09f50d9ab7f7b69);
parcelRequire("5Ve5I");
var $2z5O0 = parcelRequire("2z5O0");
var $eqURj = parcelRequire("eqURj");
var $39WwY = parcelRequire("39WwY");
var $XMAWz = parcelRequire("XMAWz");
var $1GwN2 = parcelRequire("1GwN2");
var $91a132ca7cc1d150$export$d8a725a7dce95622 = 'error';
var $91a132ca7cc1d150$export$99adc6fe67a3c63e = 'transaction';
var $91a132ca7cc1d150$export$9d7ad34f132fe68f = 'attachment';
var $91a132ca7cc1d150$export$42d9e7b5fc564c45 = 'session';
var $91a132ca7cc1d150$export$e515cf6dfd2f98b8 = 30;
function $91a132ca7cc1d150$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $XMAWz.makePromiseBuffer)(options.bufferSize || $91a132ca7cc1d150$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $39WwY.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $39WwY.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $2z5O0.isRateLimited)(rateLimits, category)) return (0, $1GwN2.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $91a132ca7cc1d150$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $eqURj.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $2z5O0.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $1GwN2.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $1GwN2.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $91a132ca7cc1d150$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $91a132ca7cc1d150$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $2z5O0.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("k2phX", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $e9679c5890406494$export$4c0ac1dd4bbf4921);

var $cvbmT = parcelRequire("cvbmT");
parcelRequire("5Ve5I");
var $1GwN2 = parcelRequire("1GwN2");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $e9679c5890406494$var$XHR_READYSTATE_DONE = 4;
function $e9679c5890406494$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $1GwN2.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $e9679c5890406494$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $cvbmT.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("b1vKk", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $806869d2facb4912$export$874a283af77e8e62);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("5Ve5I");
var $iqzHc = parcelRequire("iqzHc");
var $1GwN2 = parcelRequire("1GwN2");

var $31QKS = parcelRequire("31QKS");
/** `XHR` based transport */ var $806869d2facb4912$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $5lpFe.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $1GwN2.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $iqzHc.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $31QKS.BaseTransport));

});


parcelRegister("1xbOS", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $11e20aa3500cc69c$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $11e20aa3500cc69c$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $11e20aa3500cc69c$export$deb9aac8ea0b576c);

var $5lpFe = parcelRequire("5lpFe");

var $2tNS7 = parcelRequire("2tNS7");
var $3kzox = parcelRequire("3kzox");
parcelRequire("5Ve5I");
var $kcrfC = parcelRequire("kcrfC");
var $bZphu = parcelRequire("bZphu");
var $2mAO5 = parcelRequire("2mAO5");
var $6Xtyr = parcelRequire("6Xtyr");

var $7ZUKl = parcelRequire("7ZUKl");
var $11e20aa3500cc69c$var$global = (0, $2mAO5.getGlobalObject)();
var $11e20aa3500cc69c$var$ignoreOnError = 0;
function $11e20aa3500cc69c$export$b79738ab10c590b2() {
    return $11e20aa3500cc69c$var$ignoreOnError > 0;
}
function $11e20aa3500cc69c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $11e20aa3500cc69c$var$ignoreOnError += 1;
    setTimeout(function() {
        $11e20aa3500cc69c$var$ignoreOnError -= 1;
    });
}
function $11e20aa3500cc69c$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $bZphu.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $11e20aa3500cc69c$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $11e20aa3500cc69c$export$1265a142ff5ba165();
            (0, $2tNS7.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $kcrfC.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $kcrfC.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $2tNS7.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $bZphu.markFunctionWrapped)(sentryWrapped, fn);
    (0, $bZphu.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $11e20aa3500cc69c$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$11e20aa3500cc69c$var$global.document) return;
    if (!options.eventId) {
        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $11e20aa3500cc69c$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $3kzox.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $11e20aa3500cc69c$var$global.document.head || $11e20aa3500cc69c$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("jEFf2", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $e4f1be71e83b5045$export$2dc68d50d56fbbd);

var $5lpFe = parcelRequire("5lpFe");

var $REREP = parcelRequire("REREP");

var $8lCud = parcelRequire("8lCud");
parcelRequire("5Ve5I");
var $4ppVB = parcelRequire("4ppVB");
var $kcrfC = parcelRequire("kcrfC");
var $2mAO5 = parcelRequire("2mAO5");
var $3vwCT = parcelRequire("3vwCT");
var $bQUiH = parcelRequire("bQUiH");
var $ccrXg = parcelRequire("ccrXg");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $e4f1be71e83b5045$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $5lpFe.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $REREP.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $kcrfC.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $4ppVB.addInstrumentationHandler)('console', $e4f1be71e83b5045$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $4ppVB.addInstrumentationHandler)('dom', $e4f1be71e83b5045$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $4ppVB.addInstrumentationHandler)('xhr', $e4f1be71e83b5045$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $4ppVB.addInstrumentationHandler)('fetch', $e4f1be71e83b5045$var$_fetchBreadcrumb);
        if (this._options.history) (0, $4ppVB.addInstrumentationHandler)('history', $e4f1be71e83b5045$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e4f1be71e83b5045$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $3vwCT.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $3vwCT.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $REREP.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e4f1be71e83b5045$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $ccrXg.severityFromString)(handlerData.level),
        message: (0, $bQUiH.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $bQUiH.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $REREP.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e4f1be71e83b5045$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $REREP.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e4f1be71e83b5045$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $REREP.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $8lCud.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $REREP.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e4f1be71e83b5045$var$_historyBreadcrumb(handlerData) {
    var global = (0, $2mAO5.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $kcrfC.parseUrl)(global.location.href);
    var parsedFrom = (0, $kcrfC.parseUrl)(from);
    var parsedTo = (0, $kcrfC.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $REREP.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("flU3k", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $b2d44c10f86af45e$export$688d98c249d31ad3);
parcelRequire("5Ve5I");
var $6Xtyr = parcelRequire("6Xtyr");

var $7ZUKl = parcelRequire("7ZUKl");
/** Deduplication filter */ var $b2d44c10f86af45e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($b2d44c10f86af45e$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $b2d44c10f86af45e$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b2d44c10f86af45e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b2d44c10f86af45e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $b2d44c10f86af45e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b2d44c10f86af45e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b2d44c10f86af45e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $b2d44c10f86af45e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $b2d44c10f86af45e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $b2d44c10f86af45e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b2d44c10f86af45e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b2d44c10f86af45e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $b2d44c10f86af45e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $b2d44c10f86af45e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $b2d44c10f86af45e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $b2d44c10f86af45e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $b2d44c10f86af45e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $b2d44c10f86af45e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("7ATFd", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $587712e30a52679d$export$204155decbc90e5a);

var $5lpFe = parcelRequire("5lpFe");

var $REREP = parcelRequire("REREP");

var $8lCud = parcelRequire("8lCud");
parcelRequire("5Ve5I");
var $kcrfC = parcelRequire("kcrfC");
var $4ppVB = parcelRequire("4ppVB");
var $3vwCT = parcelRequire("3vwCT");
var $eA0Kr = parcelRequire("eA0Kr");
var $6Xtyr = parcelRequire("6Xtyr");

var $fcznZ = parcelRequire("fcznZ");

var $7ZUKl = parcelRequire("7ZUKl");

var $1xbOS = parcelRequire("1xbOS");
/** Global handlers */ var $587712e30a52679d$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $587712e30a52679d$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $587712e30a52679d$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $5lpFe.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $587712e30a52679d$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $587712e30a52679d$var$_installGlobalOnErrorHandler() {
    (0, $4ppVB.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $5lpFe.__read)($587712e30a52679d$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($587712e30a52679d$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $1xbOS.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $eA0Kr.isString)(msg) ? $587712e30a52679d$var$_eventFromIncompleteOnError(msg, url, line, column) : $587712e30a52679d$var$_enhanceEventWithInitialFrame((0, $fcznZ.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $8lCud.Severity).Error;
        $587712e30a52679d$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $587712e30a52679d$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $4ppVB.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $5lpFe.__read)($587712e30a52679d$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($587712e30a52679d$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $1xbOS.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $eA0Kr.isPrimitive)(error) ? $587712e30a52679d$var$_eventFromRejectionWithPrimitive(error) : (0, $fcznZ.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $8lCud.Severity).Error;
        $587712e30a52679d$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $587712e30a52679d$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $587712e30a52679d$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $eA0Kr.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $587712e30a52679d$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $587712e30a52679d$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $eA0Kr.isString)(url) && url.length > 0 ? url : (0, $3vwCT.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $587712e30a52679d$var$globalHandlerLog(type) {
    (0, $7ZUKl.IS_DEBUG_BUILD) && (0, $6Xtyr.logger).log("Global Handler attached: " + type);
}
function $587712e30a52679d$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $kcrfC.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $587712e30a52679d$var$getHubAndAttachStacktrace() {
    var hub = (0, $REREP.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("inxLT", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $0373f1d7dd01f120$export$8d1e60aaf616fb4f);

var $5lpFe = parcelRequire("5lpFe");

var $freWv = parcelRequire("freWv");
var $REREP = parcelRequire("REREP");
parcelRequire("5Ve5I");
var $eA0Kr = parcelRequire("eA0Kr");

var $fcznZ = parcelRequire("fcznZ");
var $0373f1d7dd01f120$var$DEFAULT_KEY = 'cause';
var $0373f1d7dd01f120$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $0373f1d7dd01f120$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $0373f1d7dd01f120$var$DEFAULT_KEY;
        this._limit = options.limit || $0373f1d7dd01f120$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $freWv.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $REREP.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $0373f1d7dd01f120$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $0373f1d7dd01f120$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $eA0Kr.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $0373f1d7dd01f120$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $5lpFe.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $0373f1d7dd01f120$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $eA0Kr.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $fcznZ.exceptionFromError)(error[key]);
    return $0373f1d7dd01f120$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $5lpFe.__spread)([
        exception
    ], stack));
}

});

parcelRegister("5FM25", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $42160a5b7ab75f43$export$f1a018517668e6d3);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("5Ve5I");
var $bZphu = parcelRequire("bZphu");
var $ja3HM = parcelRequire("ja3HM");
var $2mAO5 = parcelRequire("2mAO5");

var $1xbOS = parcelRequire("1xbOS");
var $42160a5b7ab75f43$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $42160a5b7ab75f43$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $5lpFe.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $2mAO5.getGlobalObject)();
        if (this._options.setTimeout) (0, $bZphu.fill)(global, 'setTimeout', $42160a5b7ab75f43$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $bZphu.fill)(global, 'setInterval', $42160a5b7ab75f43$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $bZphu.fill)(global, 'requestAnimationFrame', $42160a5b7ab75f43$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $bZphu.fill)(XMLHttpRequest.prototype, 'send', $42160a5b7ab75f43$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $42160a5b7ab75f43$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($42160a5b7ab75f43$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $42160a5b7ab75f43$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $1xbOS.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $ja3HM.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $42160a5b7ab75f43$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $1xbOS.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $ja3HM.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $42160a5b7ab75f43$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $bZphu.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $ja3HM.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $bZphu.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $ja3HM.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $1xbOS.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $42160a5b7ab75f43$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $2mAO5.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $bZphu.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $1xbOS.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $ja3HM.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $1xbOS.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $ja3HM.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $bZphu.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("2yS8d", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $1dd8bf23a158ecd1$export$5fba5e10934a4faf);

var $5lpFe = parcelRequire("5lpFe");

var $freWv = parcelRequire("freWv");
var $REREP = parcelRequire("REREP");
parcelRequire("5Ve5I");
var $2mAO5 = parcelRequire("2mAO5");
var $1dd8bf23a158ecd1$var$global = (0, $2mAO5.getGlobalObject)();
/** UserAgent */ var $1dd8bf23a158ecd1$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $freWv.addGlobalEventProcessor)(function(event) {
            if ((0, $REREP.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$1dd8bf23a158ecd1$var$global.navigator && !$1dd8bf23a158ecd1$var$global.location && !$1dd8bf23a158ecd1$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $1dd8bf23a158ecd1$var$global.location && $1dd8bf23a158ecd1$var$global.location.href;
                var referrer = ($1dd8bf23a158ecd1$var$global.document || {}).referrer;
                var userAgent = ($1dd8bf23a158ecd1$var$global.navigator || {}).userAgent;
                var headers = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("clhwU", function(module, exports) {
$parcel$export(module.exports, "RewriteFrames", () => $8fc50b452e97506f$export$af39fa91d1acf248);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("dMeSH");
var $2Ss9P = parcelRequire("2Ss9P");
/** Rewrite event frames paths */ var $8fc50b452e97506f$export$af39fa91d1acf248 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */ this._prefix = 'app:///';
        /**
         * @inheritDoc
         */ this._iteratee = function(frame) {
            if (!frame.filename) return frame;
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame ? frame.filename.replace(/^[A-Z]:/, '') // remove Windows-style prefix
                .replace(/\\/g, '/') // replace all `\\` instances with `/`
                 : frame.filename;
                var base = _this._root ? (0, $2Ss9P.relative)(_this._root, filename) : (0, $2Ss9P.basename)(filename);
                frame.filename = "" + _this._prefix + base;
            }
            return frame;
        };
        if (options.root) this._root = options.root;
        if (options.prefix) this._prefix = options.prefix;
        if (options.iteratee) this._iteratee = options.iteratee;
    }
    /**
     * @inheritDoc
     */ RewriteFrames.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) return self.process(event);
            return event;
        });
    };
    /** JSDoc */ RewriteFrames.prototype.process = function(originalEvent) {
        var processedEvent = originalEvent;
        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = this._processExceptionsEvent(processedEvent);
        if (originalEvent.stacktrace) processedEvent = this._processStacktraceEvent(processedEvent);
        return processedEvent;
    };
    /** JSDoc */ RewriteFrames.prototype._processExceptionsEvent = function(event) {
        var _this = this;
        try {
            return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event), {
                exception: (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, value), {
                            stacktrace: _this._processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktraceEvent = function(event) {
        try {
            return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event), {
                stacktrace: this._processStacktrace(event.stacktrace)
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktrace = function(stacktrace) {
        var _this = this;
        return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return _this._iteratee(f);
            })
        });
    };
    /**
     * @inheritDoc
     */ RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}();

});
parcelRegister("dMeSH", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("j0N8V")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("fZ517")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("fZ517")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("KqrRx")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("KqrRx")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("3NuAA")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("fKSzi")).fill);
$parcel$export(module.exports, "basename", () => (parcelRequire("2Ss9P")).basename);
$parcel$export(module.exports, "relative", () => (parcelRequire("2Ss9P")).relative);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("QUwn3")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("1tu1w")).safeJoin);





parcelRequire("j0N8V");

parcelRequire("fZ517");
parcelRequire("KqrRx");



var $j53Fa = parcelRequire("j53Fa");
parcelRequire("3NuAA");
parcelRequire("fKSzi");
parcelRequire("2Ss9P");

parcelRequire("QUwn3");


parcelRequire("1tu1w");



var $5KddG = parcelRequire("5KddG");





$parcel$exportWildcard(module.exports, $j53Fa);
$parcel$exportWildcard(module.exports, $5KddG);

});
parcelRegister("j0N8V", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $dd7423292f8aae55$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $dd7423292f8aae55$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $j53Fa = parcelRequire("j53Fa");
var $dd7423292f8aae55$var$fallbackGlobalObject = {};
function $dd7423292f8aae55$export$256479dc0cea61c4() {
    return (0, $j53Fa.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $dd7423292f8aae55$var$fallbackGlobalObject;
}
function $dd7423292f8aae55$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $dd7423292f8aae55$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("j53Fa", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $14XOu = parcelRequire("14XOu");

var $3jCFs = parcelRequire("3jCFs");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $14XOu.isBrowserBundle)() && Object.prototype.toString.call(typeof $3jCFs !== 'undefined' ? $3jCFs : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("14XOu", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $0c948fd71ad9a0d7$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0c948fd71ad9a0d7$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("fZ517", function(module, exports) {
$parcel$export(module.exports, "isError", () => $ba3071cc36b8b5e2$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $ba3071cc36b8b5e2$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $ba3071cc36b8b5e2$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $ba3071cc36b8b5e2$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $ba3071cc36b8b5e2$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $ba3071cc36b8b5e2$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $ba3071cc36b8b5e2$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $ba3071cc36b8b5e2$export$49841c62b9eff15);
$parcel$export(module.exports, "isSyntheticEvent", () => $ba3071cc36b8b5e2$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $ba3071cc36b8b5e2$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $ba3071cc36b8b5e2$var$objectToString = Object.prototype.toString;
function $ba3071cc36b8b5e2$export$e6127cc7fe7395c3(wat) {
    switch($ba3071cc36b8b5e2$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $ba3071cc36b8b5e2$export$49034edbe6b62415(wat, Error);
    }
}
function $ba3071cc36b8b5e2$var$isBuiltin(wat, ty) {
    return $ba3071cc36b8b5e2$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $ba3071cc36b8b5e2$export$9f9636d330b71954(wat) {
    return $ba3071cc36b8b5e2$var$isBuiltin(wat, 'ErrorEvent');
}
function $ba3071cc36b8b5e2$export$ef9e2056653f0c8e(wat) {
    return $ba3071cc36b8b5e2$var$isBuiltin(wat, 'DOMError');
}
function $ba3071cc36b8b5e2$export$12e869b2a583f783(wat) {
    return $ba3071cc36b8b5e2$var$isBuiltin(wat, 'DOMException');
}
function $ba3071cc36b8b5e2$export$844ec244b1367d54(wat) {
    return $ba3071cc36b8b5e2$var$isBuiltin(wat, 'String');
}
function $ba3071cc36b8b5e2$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $ba3071cc36b8b5e2$export$53b83ca8eaab0383(wat) {
    return $ba3071cc36b8b5e2$var$isBuiltin(wat, 'Object');
}
function $ba3071cc36b8b5e2$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $ba3071cc36b8b5e2$export$49034edbe6b62415(wat, Event);
}
function $ba3071cc36b8b5e2$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $ba3071cc36b8b5e2$export$49034edbe6b62415(wat, Element);
}
function $ba3071cc36b8b5e2$export$49841c62b9eff15(wat) {
    return $ba3071cc36b8b5e2$var$isBuiltin(wat, 'RegExp');
}
function $ba3071cc36b8b5e2$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $ba3071cc36b8b5e2$export$bc2894c7158efbac(wat) {
    return $ba3071cc36b8b5e2$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $ba3071cc36b8b5e2$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $ba3071cc36b8b5e2$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("KqrRx", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $08b8d017dae76434$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $08b8d017dae76434$export$af88d00dbe7f521);

var $5lpFe = parcelRequire("5lpFe");

var $jCThO = parcelRequire("jCThO");

var $j0N8V = parcelRequire("j0N8V");
// TODO: Implement different loggers for different environments
var $08b8d017dae76434$var$global = (0, $j0N8V.getGlobalObject)();
/** Prefix for logging strings */ var $08b8d017dae76434$var$PREFIX = 'Sentry Logger ';
var $08b8d017dae76434$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $08b8d017dae76434$export$cda52e2a8927a2ca(callback) {
    var global = (0, $j0N8V.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $08b8d017dae76434$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $08b8d017dae76434$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $jCThO.IS_DEBUG_BUILD) $08b8d017dae76434$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $08b8d017dae76434$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $08b8d017dae76434$var$global.console)[name].apply(_a, (0, $5lpFe.__spread)([
                    $08b8d017dae76434$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $08b8d017dae76434$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $08b8d017dae76434$export$af88d00dbe7f521;
if (0, $jCThO.IS_DEBUG_BUILD) $08b8d017dae76434$export$af88d00dbe7f521 = (0, $j0N8V.getGlobalSingleton)('logger', $08b8d017dae76434$var$makeLogger);
else $08b8d017dae76434$export$af88d00dbe7f521 = $08b8d017dae76434$var$makeLogger();

});
parcelRegister("jCThO", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $e49c73a52c0796d7$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $e49c73a52c0796d7$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("3NuAA", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $2c3dad157f63cbe3$export$a3295358bff77e);

var $5lpFe = parcelRequire("5lpFe");

var $fZ517 = parcelRequire("fZ517");

var $6VGkH = parcelRequire("6VGkH");

var $fKSzi = parcelRequire("fKSzi");

var $lKEkE = parcelRequire("lKEkE");
function $2c3dad157f63cbe3$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $2c3dad157f63cbe3$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $2c3dad157f63cbe3$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $2c3dad157f63cbe3$export$a3295358bff77e(object, depth);
    if ($2c3dad157f63cbe3$var$jsonSize(normalized) > maxSize) return $2c3dad157f63cbe3$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $2c3dad157f63cbe3$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $6VGkH.memoBuilder)();
    var _a = (0, $5lpFe.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $fZ517.isNaN)(value)) return value;
    var stringified = $2c3dad157f63cbe3$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $fZ517.isError)(value) || (0, $fZ517.isEvent)(value) ? (0, $fKSzi.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $2c3dad157f63cbe3$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $2c3dad157f63cbe3$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $fZ517.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $lKEkE.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $2c3dad157f63cbe3$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $2c3dad157f63cbe3$var$jsonSize(value) {
    return $2c3dad157f63cbe3$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("6VGkH", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $50b8e76174067f5d$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $50b8e76174067f5d$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("fKSzi", function(module, exports) {
$parcel$export(module.exports, "fill", () => $b7857b04479a8394$export$9563e054e6f787fb);
$parcel$export(module.exports, "convertToPlainObject", () => $b7857b04479a8394$export$62ff257738bf57f5);

var $5lpFe = parcelRequire("5lpFe");

var $hEXjC = parcelRequire("hEXjC");

var $fZ517 = parcelRequire("fZ517");

var $1tu1w = parcelRequire("1tu1w");
function $b7857b04479a8394$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $b7857b04479a8394$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $b7857b04479a8394$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $b7857b04479a8394$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $b7857b04479a8394$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $b7857b04479a8394$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $b7857b04479a8394$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $b7857b04479a8394$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $fZ517.isError)(value)) newObj = (0, $5lpFe.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $b7857b04479a8394$var$getOwnProperties(value));
    else if ((0, $fZ517.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $5lpFe.__assign)({
            type: event_1.type,
            target: $b7857b04479a8394$var$serializeEventTarget(event_1.target),
            currentTarget: $b7857b04479a8394$var$serializeEventTarget(event_1.currentTarget)
        }, $b7857b04479a8394$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $fZ517.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $b7857b04479a8394$var$serializeEventTarget(target) {
    try {
        return (0, $fZ517.isElement)(target) ? (0, $hEXjC.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $b7857b04479a8394$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $b7857b04479a8394$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($b7857b04479a8394$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $1tu1w.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $1tu1w.truncate)(serialized, maxLength);
    }
    return '';
}
function $b7857b04479a8394$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $fZ517.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $5lpFe.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $b7857b04479a8394$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($b7857b04479a8394$export$d25f2688db1bb433);
    return val;
}
function $b7857b04479a8394$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $fZ517.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("hEXjC", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $cdb42ee295ad4ed3$export$5647df6b7814ac86);

var $j0N8V = parcelRequire("j0N8V");

var $fZ517 = parcelRequire("fZ517");
function $cdb42ee295ad4ed3$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cdb42ee295ad4ed3$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cdb42ee295ad4ed3$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $fZ517.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $cdb42ee295ad4ed3$export$1cfafeee2987818b() {
    var global = (0, $j0N8V.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("1tu1w", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $112fc9eb3d1c3dae$export$6a506b36fdea397d);
$parcel$export(module.exports, "safeJoin", () => $112fc9eb3d1c3dae$export$465e9d514283d4fd);

var $fZ517 = parcelRequire("fZ517");
function $112fc9eb3d1c3dae$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $112fc9eb3d1c3dae$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $112fc9eb3d1c3dae$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $112fc9eb3d1c3dae$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $fZ517.isString)(value)) return false;
    if ((0, $fZ517.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $112fc9eb3d1c3dae$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("lKEkE", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $fd5d2df6dd85df50$export$aad197c7121a6651);

var $5lpFe = parcelRequire("5lpFe");
var $fd5d2df6dd85df50$var$STACKTRACE_LIMIT = 50;
function $fd5d2df6dd85df50$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $5lpFe.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $5lpFe.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $fd5d2df6dd85df50$export$c55c24c0eeba0205(frames);
    };
}
function $fd5d2df6dd85df50$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $fd5d2df6dd85df50$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $fd5d2df6dd85df50$var$defaultFunctionName = '<anonymous>';
function $fd5d2df6dd85df50$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $fd5d2df6dd85df50$var$defaultFunctionName;
        return fn.name || $fd5d2df6dd85df50$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $fd5d2df6dd85df50$var$defaultFunctionName;
    }
}

});


parcelRegister("2Ss9P", function(module, exports) {
$parcel$export(module.exports, "relative", () => $218677674c9c8f8f$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $218677674c9c8f8f$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $218677674c9c8f8f$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $218677674c9c8f8f$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $218677674c9c8f8f$var$splitPath(filename) {
    var parts = $218677674c9c8f8f$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $218677674c9c8f8f$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $218677674c9c8f8f$var$normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $218677674c9c8f8f$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $218677674c9c8f8f$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $218677674c9c8f8f$export$f7ad0328861e2f03(from).substr(1);
    to = $218677674c9c8f8f$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $218677674c9c8f8f$var$trim(from.split('/'));
    var toParts = $218677674c9c8f8f$var$trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function $218677674c9c8f8f$export$6af368f973c74c5(path) {
    var isPathAbsolute = $218677674c9c8f8f$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = $218677674c9c8f8f$var$normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function $218677674c9c8f8f$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
function $218677674c9c8f8f$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $218677674c9c8f8f$export$6af368f973c74c5(args.join('/'));
}
function $218677674c9c8f8f$export$7f7b8152cc673abe(path) {
    var result = $218677674c9c8f8f$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $218677674c9c8f8f$export$9bf319d8f74f51d1(path, ext) {
    var f = $218677674c9c8f8f$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("QUwn3", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $09f0b35bd3c1ef5b$export$e01cef29b4327697);

var $8lCud = parcelRequire("8lCud");

var $5c7g9 = parcelRequire("5c7g9");
function $09f0b35bd3c1ef5b$var$isSupportedSeverity(level) {
    return (0, $5c7g9.SeverityLevels).indexOf(level) !== -1;
}
function $09f0b35bd3c1ef5b$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $8lCud.Severity).Warning;
    if ($09f0b35bd3c1ef5b$var$isSupportedSeverity(level)) return level;
    return (0, $8lCud.Severity).Log;
}

});
parcelRegister("5c7g9", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $3c83b458b19fb8c8$export$484b1ea9aec914c);
var $3c83b458b19fb8c8$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("5KddG", function(module, exports) {

var $j0N8V = parcelRequire("j0N8V");

var $j53Fa = parcelRequire("j53Fa");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $j0N8V.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $j53Fa.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $j53Fa.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $j0N8V.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});





parcelRegister("7cVI2", function(module, exports) {
$parcel$export(module.exports, "initialisePlatformFeatureFlags", () => $9537af258b0087a6$export$bcd24dd77ba35b8a);
/**
 *  Adapted from JFE:
 *  https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/common-legacy-do-not-add-anything-new/src/util/get-feature-flag-value.js
 *
 */ 
var $k2M4v = parcelRequire("k2M4v");

var $dV4G1 = parcelRequire("dV4G1");
const $9537af258b0087a6$export$bcd24dd77ba35b8a = ()=>{
    (0, $dV4G1.setBooleanFeatureFlagResolver)((flagKey)=>(0, $k2M4v.default).checkGate(flagKey));
};

});
parcelRegister("dV4G1", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $192d20bc751e5dff$export$ba05d765b8392e5e);

var $h2sDR = parcelRequire("h2sDR");
function $192d20bc751e5dff$export$ba05d765b8392e5e(flagResolver) {
    (0, $h2sDR.setBooleanResolver)(flagResolver);
}

});
parcelRegister("h2sDR", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $95730978d49a42c1$export$f2b591175b3e424c);

var $75Krz = parcelRequire("75Krz");

var $4utUE = parcelRequire("4utUE");
function $95730978d49a42c1$export$f2b591175b3e424c(resolver) {
    (0, $75Krz.globalVar)[0, $4utUE.PFF_GLOBAL_KEY].booleanResolver = resolver;
}

});



parcelRegister("iuWTe", function(module, exports) {
$parcel$export(module.exports, "handleDOMGoogleTranslateIssues", () => $c4fcb3cbac02bfe9$export$d1215808cd22e615);
// #reference /confluence/packages/confluence-frontend-server/src/google-translate-issue-workaround.js

var $aIVqJ = parcelRequire("aIVqJ");
const $c4fcb3cbac02bfe9$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $c4fcb3cbac02bfe9$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot remove a child from a different parent', child, this);
                    $c4fcb3cbac02bfe9$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $c4fcb3cbac02bfe9$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $c4fcb3cbac02bfe9$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $c4fcb3cbac02bfe9$var$extractNodeData(childNode)
    };
    $c4fcb3cbac02bfe9$var$sendAnalyticsEvent($c4fcb3cbac02bfe9$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $c4fcb3cbac02bfe9$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $c4fcb3cbac02bfe9$var$extractNodeData(newNode),
        referenceNode: $c4fcb3cbac02bfe9$var$extractNodeData(referenceNode)
    };
    $c4fcb3cbac02bfe9$var$sendAnalyticsEvent($c4fcb3cbac02bfe9$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $c4fcb3cbac02bfe9$var$sendAnalyticsEvent(action, nodeData) {
    (0, $aIVqJ.trackError)('google.translate.issue.error', {
        ...nodeData,
        errorBoundaryId: 'root',
        suppressedError: action,
        errorBoundaryPackageName: 'unknown'
    }, new Error(action));
}
function $c4fcb3cbac02bfe9$var$extractNodeData(node) {
    var _node$parentElement;
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.nodeName,
        isConnected: node.isConnected
    };
}

});

parcelRegister("1InLN", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelp", () => $ebab958ce2e2cfba$export$1d3b4fb23d556424);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $4OMBM = parcelRequire("4OMBM");
parcelRequire("9KCPm");
var $43htV = parcelRequire("43htV");
parcelRequire("esMAf");
var $2607U = parcelRequire("2607U");
parcelRequire("gEtje");
var $cIcbU = parcelRequire("cIcbU");
const $ebab958ce2e2cfba$var$renderError = ()=>/*#__PURE__*/ $fc4bM.createElement((0, $43htV.default), null);
const $ebab958ce2e2cfba$export$1d3b4fb23d556424 = ({ config: config })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $4OMBM.AppProviders), {
        config: config
    }, /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
        renderError: $ebab958ce2e2cfba$var$renderError
    }, /*#__PURE__*/ $fc4bM.createElement((0, $cIcbU.ThemingContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $2607U.default), null))));
};

});
parcelRegister("4OMBM", function(module, exports) {
$parcel$export(module.exports, "store", () => $4152f7bf3e46dcb0$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "injectReducer", () => $4152f7bf3e46dcb0$export$8d491a82891620e4);
$parcel$export(module.exports, "onIntlNextError", () => $4152f7bf3e46dcb0$export$3bcefabe8b04378c);
$parcel$export(module.exports, "AppProviders", () => $4152f7bf3e46dcb0$export$6c4743022ef2c318);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $csQ5w = parcelRequire("csQ5w");

var $hN5YJ = parcelRequire("hN5YJ");

var $aYMdQ = parcelRequire("aYMdQ");

var $8MaoS = parcelRequire("8MaoS");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");

var $7zWyU = parcelRequire("7zWyU");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $cYiNs = parcelRequire("cYiNs");
parcelRequire("bqVIG");
var $9uFN1 = parcelRequire("9uFN1");
parcelRequire("l6Vqg");
var $j8HEB = parcelRequire("j8HEB");
parcelRequire("i9uyX");
var $qzyFS = parcelRequire("qzyFS");
parcelRequire("kOWPe");
var $bwpot = parcelRequire("bwpot");

var $llvqx = parcelRequire("llvqx");

var $38vAg = parcelRequire("38vAg");

var $hH2zO = parcelRequire("hH2zO");

var $k2M4v = parcelRequire("k2M4v");

var $aVQWM = parcelRequire("aVQWM");

var $2czqN = parcelRequire("2czqN");

var $aIVqJ = parcelRequire("aIVqJ");

var $6lbrU = parcelRequire("6lbrU");

var $hN8HB = parcelRequire("hN8HB");

var $6ilSv = parcelRequire("6ilSv");

var $aIVqJ = parcelRequire("aIVqJ");

var $6wrSQ = parcelRequire("6wrSQ");

var $caiWY = parcelRequire("caiWY");

var $9Ii6A = parcelRequire("9Ii6A");

var $7ZNRj = parcelRequire("7ZNRj");

var $1xOZp = parcelRequire("1xOZp");

var $cs1mQ = parcelRequire("cs1mQ");
parcelRequire("54cCj");
var $br4PW = parcelRequire("br4PW");
parcelRequire("9KawQ");
var $lenHW = parcelRequire("lenHW");
const $4152f7bf3e46dcb0$var$initialState = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4152f7bf3e46dcb0$var$accountTypeMetaTagMiddleware = ()=>(next)=>(action)=>{
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (action.type === (0, $7m3Xa.UPDATE_USER_MODEL)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $2czqN.setAccountMetaTag)(action.payload.atlassianAccountManaged, action.payload.accountId);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return next(action);
        };
const { store: $4152f7bf3e46dcb0$export$6f57813fe9f31bf9, injectReducer: $4152f7bf3e46dcb0$export$8d491a82891620e4 } = (0, $7zWyU.default)({
    initialState: $4152f7bf3e46dcb0$var$initialState,
    middleware: [
        $4152f7bf3e46dcb0$var$accountTypeMetaTagMiddleware
    ]
});
const $4152f7bf3e46dcb0$export$ec3f29afcf92cc87 = (0, $9Ii6A.onIntlError);
const $4152f7bf3e46dcb0$export$3bcefabe8b04378c = (0, $9Ii6A.onIntlNextError);
const $4152f7bf3e46dcb0$var$onAnalyticsEvent = (event)=>{
    if ((0, $k2M4v.default).checkGate('enable_help_center_analytics_bridge')) (0, $aIVqJ.sendEventFromAnalyticsBridge)(event);
    else (0, $aIVqJ.legacySendEvent)(event);
};
class $4152f7bf3e46dcb0$export$6c4743022ef2c318 extends $fc4bM.Component {
    render() {
        const { config: config } = this.props;
        const { analyticsClient: analyticsClient, xpcAnalyticsClient: xpcAnalyticsClient } = this;
        const envFeatureFlags = $4152f7bf3e46dcb0$export$6f57813fe9f31bf9.getState().persisted.env.featureFlags;
        const configFeatureFlags = config === null || config === void 0 ? void 0 : config.featureFlags;
        const memoizedFeatureFlags = (0, $aYMdQ.memoize)(// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (envFFs, configFFs)=>({
                ...envFFs,
                ...configFFs
            }), (...args)=>(0, $aYMdQ.keys)({
                ...args[0],
                ...args[1]
            }));
        const WrmResourceProvider = (0, $hN5YJ.isWrmOptimizationsEnabled)() ? (0, $cs1mQ.default) : $fc4bM.Fragment;
        return /*#__PURE__*/ $fc4bM.createElement((0, $3BZyK.RelayEnvironmentProvider), {
            environment: (0, $1xOZp.getRelayEnvironment)()
        }, /*#__PURE__*/ $fc4bM.createElement((0, $hN8HB.CustomDomainsAnalyticsProvider), {
            baseUrl: config.baseUrl
        }, /*#__PURE__*/ $fc4bM.createElement((0, $llvqx.default), {
            client: analyticsClient,
            excludedChannels: [
                (0, $38vAg.FabricChannel).atlaskit
            ]
        }, /*#__PURE__*/ $fc4bM.createElement((0, $9uFN1.EngagementProviderWrapper), {
            config: config,
            analyticsClientInstance: analyticsClient
        }, /*#__PURE__*/ $fc4bM.createElement((0, $hH2zO.default), {
            onEvent: (0, $aIVqJ.sendAtlaskitUIEvent),
            channel: "atlaskit"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $hH2zO.default), {
            onEvent: (0, $aIVqJ.sendEventFromAnalyticsBridge),
            channel: (0, $aVQWM.ANALYTICS_BRIDGE_CHANNEL)
        }, /*#__PURE__*/ $fc4bM.createElement((0, $hH2zO.default), {
            onEvent: $4152f7bf3e46dcb0$var$onAnalyticsEvent
        }, /*#__PURE__*/ $fc4bM.createElement((0, $8MaoS.default), {
            messages: (0, $9Ii6A.default)(),
            locale: (0, $7ZNRj.getLanguageFromLocale)((0, $7RWiC.getLocale)($4152f7bf3e46dcb0$export$6f57813fe9f31bf9.getState())),
            onError: $4152f7bf3e46dcb0$export$3bcefabe8b04378c
        }, /*#__PURE__*/ $fc4bM.createElement((0, $csQ5w.default), {
            store: $4152f7bf3e46dcb0$export$6f57813fe9f31bf9
        }, /*#__PURE__*/ $fc4bM.createElement((0, $lenHW.default), {
            config: this.props.config
        }, /*#__PURE__*/ $fc4bM.createElement(WrmResourceProvider, null, /*#__PURE__*/ $fc4bM.createElement((0, $6wrSQ.PortalAnalyticsContext), null, /*#__PURE__*/ $fc4bM.createElement((0, $cYiNs.HelpSeekerTypeProvider), null, /*#__PURE__*/ $fc4bM.createElement((0, $j8HEB.default), {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            featureFlags: memoizedFeatureFlags(envFeatureFlags, configFeatureFlags)
        }, /*#__PURE__*/ $fc4bM.createElement((0, $6ilSv.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $caiWY.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $qzyFS.TFECacheProvider), null, /*#__PURE__*/ $fc4bM.createElement((0, $bwpot.CustomiseSidebarTriggerProvider), null, /*#__PURE__*/ $fc4bM.createElement((0, $br4PW.HelpCenterXpcNavigationObserver), {
            analyticsClient: xpcAnalyticsClient
        }, this.props.children)))))))))))))))))));
    }
    constructor(...args){
        super(...args), this.analyticsClient = (0, $6lbrU.getAnalyticsWebClient)().getInstance(), this.xpcAnalyticsClient = (0, $br4PW.adaptAnalyticsWebClientForXpc)(this.analyticsClient);
    }
}

});
parcelRegister("9XZeF", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("csQ5w")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("6umft")).default);

var $csQ5w = parcelRequire("csQ5w");

var $2EX7y = parcelRequire("2EX7y");

var $a8nBC = parcelRequire("a8nBC");

var $6umft = parcelRequire("6umft");

});
parcelRegister("csQ5w", function(module, exports) {
$parcel$export(module.exports, "default", () => $9130812f5bf3a81b$export$2e2bcd8739ae039);

var $i1Sqh = parcelRequire("i1Sqh");

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $a8nBC = parcelRequire("a8nBC");
var $9130812f5bf3a81b$var$Provider = /*#__PURE__*/ function(_Component) {
    (0, $i1Sqh.default)(Provider, _Component);
    function Provider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        var store = props.store;
        _this.state = {
            storeState: store.getState(),
            store: store
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.subscribe();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this._isMounted = false;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.store !== prevProps.store) {
            if (this.unsubscribe) this.unsubscribe();
            this.subscribe();
        }
    };
    _proto.subscribe = function subscribe() {
        var _this2 = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function() {
            var newStoreState = store.getState();
            if (!_this2._isMounted) return;
            _this2.setState(function(providerState) {
                // If the value is the same, skip the unnecessary state update.
                if (providerState.storeState === newStoreState) return null;
                return {
                    storeState: newStoreState
                };
            });
        }); // Actions might have been dispatched between render and mount - handle those
        var postMountStoreState = store.getState();
        if (postMountStoreState !== this.state.storeState) this.setState({
            storeState: postMountStoreState
        });
    };
    _proto.render = function render() {
        var Context = this.props.context || (0, $a8nBC.ReactReduxContext);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Context.Provider, {
            value: this.state
        }, this.props.children);
    };
    return Provider;
}((0, $fc4bM.Component));
$9130812f5bf3a81b$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).any
};
var $9130812f5bf3a81b$export$2e2bcd8739ae039 = $9130812f5bf3a81b$var$Provider;

});
parcelRegister("i1Sqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d202893c41eb285b$export$2e2bcd8739ae039);

var $iPop6 = parcelRequire("iPop6");
function $d202893c41eb285b$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $iPop6.default)(t, o);
}

});
parcelRegister("iPop6", function(module, exports) {
$parcel$export(module.exports, "default", () => $db4feb80cba19270$export$2e2bcd8739ae039);
function $db4feb80cba19270$export$2e2bcd8739ae039(t, e) {
    return $db4feb80cba19270$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $db4feb80cba19270$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("a8nBC", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $760cf653e958449c$export$cc80c08dc91f1c00);

var $fc4bM = parcelRequire("fc4bM");
var $760cf653e958449c$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(null);
var $760cf653e958449c$export$2e2bcd8739ae039 = $760cf653e958449c$export$cc80c08dc91f1c00;

});


parcelRegister("2EX7y", function(module, exports) {
$parcel$export(module.exports, "default", () => $1efd2d596157ebdf$export$2e2bcd8739ae039);

var $ac5sj = parcelRequire("ac5sj");

var $i1Sqh = parcelRequire("i1Sqh");

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");

var $hFHD3 = parcelRequire("hFHD3");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");

var $6y7BY = parcelRequire("6y7BY");

var $a8nBC = parcelRequire("a8nBC");
var $1efd2d596157ebdf$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1efd2d596157ebdf$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $a8nBC.ReactReduxContext) : _ref2$context, connectOptions = (0, $1ZwRz.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bCunb)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($bCunb)))(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
    var customStoreWarningMessage = "To use a custom Redux store for specific components,  create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($bCunb)))(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $hHCeM.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        var OuterBaseComponent = (0, $fc4bM.Component);
        if (pure) OuterBaseComponent = (0, $fc4bM.PureComponent);
        function makeDerivedPropsSelector() {
            var lastProps;
            var lastState;
            var lastDerivedProps;
            var lastStore;
            var lastSelectorFactoryOptions;
            var sourceSelector;
            return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
                if (pure && lastProps === props && lastState === state) return lastDerivedProps;
                if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
                    lastStore = store;
                    lastSelectorFactoryOptions = selectorFactoryOptions;
                    sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
                }
                lastProps = props;
                lastState = state;
                var nextProps = sourceSelector(state, props);
                lastDerivedProps = nextProps;
                return lastDerivedProps;
            };
        }
        function makeChildElementSelector() {
            var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
            return function selectChildElement(WrappedComponent, childProps, forwardRef) {
                if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
                    lastChildProps = childProps;
                    lastForwardRef = forwardRef;
                    lastComponent = WrappedComponent;
                    lastChildElement = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, (0, $hHCeM.default)({}, childProps, {
                        ref: forwardRef
                    }));
                }
                return lastChildElement;
            };
        }
        var Connect = /*#__PURE__*/ function(_OuterBaseComponent) {
            (0, $i1Sqh.default)(Connect, _OuterBaseComponent);
            function Connect(props) {
                var _this;
                _this = _OuterBaseComponent.call(this, props) || this;
                (0, (/*@__PURE__*/$parcel$interopDefault($bCunb)))(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
                _this.selectDerivedProps = makeDerivedPropsSelector();
                _this.selectChildElement = makeChildElementSelector();
                _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, $ac5sj.default)(_this));
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
                // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
                return this.renderWrappedComponent(value);
            };
            _proto.renderWrappedComponent = function renderWrappedComponent(value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($bCunb)))(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
                var storeState = value.storeState, store = value.store;
                var wrapperProps = this.props;
                var forwardedRef;
                if (forwardRef) {
                    wrapperProps = this.props.wrapperProps;
                    forwardedRef = this.props.forwardedRef;
                }
                var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
                return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
            };
            _proto.render = function render() {
                var ContextToUse = this.props.context && this.props.context.Consumer && (0, $6y7BY.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
            };
            return Connect;
        }(OuterBaseComponent);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Connect, {
                    wrapperProps: props,
                    forwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($hFHD3)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($hFHD3)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("ac5sj", function(module, exports) {
$parcel$export(module.exports, "default", () => $76bf41c23524272b$export$2e2bcd8739ae039);
function $76bf41c23524272b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("bCunb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $875acdbe5752b034$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $875acdbe5752b034$var$invariant;

});


parcelRegister("6umft", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b96cd88e007bd79$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");

var $2EX7y = parcelRequire("2EX7y");

var $239VW = parcelRequire("239VW");

var $hZpfL = parcelRequire("hZpfL");

var $lamtf = parcelRequire("lamtf");

var $6kfu5 = parcelRequire("6kfu5");

var $3oDEf = parcelRequire("3oDEf");
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $4b96cd88e007bd79$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $4b96cd88e007bd79$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $4b96cd88e007bd79$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $2EX7y.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $lamtf.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $hZpfL.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $6kfu5.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $3oDEf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $4b96cd88e007bd79$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $239VW.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $239VW.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $239VW.default) : _ref3$areMergedPropsE, extraOptions = (0, $1ZwRz.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $4b96cd88e007bd79$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $4b96cd88e007bd79$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $4b96cd88e007bd79$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $hHCeM.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $4b96cd88e007bd79$export$2e2bcd8739ae039 = $4b96cd88e007bd79$export$9f9feb656dec1fc4();

});
parcelRegister("239VW", function(module, exports) {
$parcel$export(module.exports, "default", () => $17e39131b5622580$export$2e2bcd8739ae039);
var $17e39131b5622580$var$hasOwn = Object.prototype.hasOwnProperty;
function $17e39131b5622580$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $17e39131b5622580$export$2e2bcd8739ae039(objA, objB) {
    if ($17e39131b5622580$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$17e39131b5622580$var$hasOwn.call(objB, keysA[i]) || !$17e39131b5622580$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("hZpfL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d18bb8f5aeccbdfd$export$2e2bcd8739ae039);
parcelRequire("UZaDE");
var $c5EDQ = parcelRequire("c5EDQ");

var $cMSwg = parcelRequire("cMSwg");
function $d18bb8f5aeccbdfd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $cMSwg.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $d18bb8f5aeccbdfd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $cMSwg.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d18bb8f5aeccbdfd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $cMSwg.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $c5EDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d18bb8f5aeccbdfd$export$2e2bcd8739ae039 = [
    $d18bb8f5aeccbdfd$export$a9f27b4b187c1166,
    $d18bb8f5aeccbdfd$export$ba20d1a7aa0c4a90,
    $d18bb8f5aeccbdfd$export$94a6e55709d4d961
];

});
parcelRegister("UZaDE", function(module, exports) {
$parcel$export(module.exports, "createStore", () => (parcelRequire("6tkGS")).default);
$parcel$export(module.exports, "combineReducers", () => (parcelRequire("bLO8A")).default);
$parcel$export(module.exports, "bindActionCreators", () => (parcelRequire("c5EDQ")).default);
$parcel$export(module.exports, "applyMiddleware", () => (parcelRequire("kbJSm")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("9DdYZ")).default);

var $6tkGS = parcelRequire("6tkGS");

var $bLO8A = parcelRequire("bLO8A");

var $c5EDQ = parcelRequire("c5EDQ");

var $kbJSm = parcelRequire("kbJSm");

var $9DdYZ = parcelRequire("9DdYZ");
parcelRequire("1x2aO");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $0ab4ae484c4573f9$var$isCrushed() {}

});
parcelRegister("6tkGS", function(module, exports) {
$parcel$export(module.exports, "ActionTypes", () => $4b65803afdd0b126$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "default", () => $4b65803afdd0b126$export$2e2bcd8739ae039);

var $k34Jw = parcelRequire("k34Jw");

var $9uJm9 = parcelRequire("9uJm9");
var $4b65803afdd0b126$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $4b65803afdd0b126$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($4b65803afdd0b126$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $k34Jw.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $4b65803afdd0b126$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $9uJm9.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $4b65803afdd0b126$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $9uJm9.default] = observable, _ref2;
}

});
parcelRegister("k34Jw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e987c25acfb0b8bf$export$2e2bcd8739ae039);

var $e6qFc = parcelRequire("e6qFc");

var $3FtKM = parcelRequire("3FtKM");

var $2M5Hg = parcelRequire("2M5Hg");
/** `Object#toString` result references. */ var $e987c25acfb0b8bf$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e987c25acfb0b8bf$var$funcProto = Function.prototype, $e987c25acfb0b8bf$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e987c25acfb0b8bf$var$funcToString = $e987c25acfb0b8bf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e987c25acfb0b8bf$var$hasOwnProperty = $e987c25acfb0b8bf$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $e987c25acfb0b8bf$var$objectCtorString = $e987c25acfb0b8bf$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $e987c25acfb0b8bf$var$isPlainObject(value) {
    if (!(0, $2M5Hg.default)(value) || (0, $e6qFc.default)(value) != $e987c25acfb0b8bf$var$objectTag) return false;
    var proto = (0, $3FtKM.default)(value);
    if (proto === null) return true;
    var Ctor = $e987c25acfb0b8bf$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $e987c25acfb0b8bf$var$funcToString.call(Ctor) == $e987c25acfb0b8bf$var$objectCtorString;
}
var $e987c25acfb0b8bf$export$2e2bcd8739ae039 = $e987c25acfb0b8bf$var$isPlainObject;

});
parcelRegister("e6qFc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4464f11647b044e$export$2e2bcd8739ae039);

var $bZ3WS = parcelRequire("bZ3WS");

var $6AxZJ = parcelRequire("6AxZJ");

var $krlao = parcelRequire("krlao");
/** `Object#toString` result references. */ var $a4464f11647b044e$var$nullTag = '[object Null]', $a4464f11647b044e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a4464f11647b044e$var$symToStringTag = (0, $bZ3WS.default) ? (0, $bZ3WS.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a4464f11647b044e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a4464f11647b044e$var$undefinedTag : $a4464f11647b044e$var$nullTag;
    return $a4464f11647b044e$var$symToStringTag && $a4464f11647b044e$var$symToStringTag in Object(value) ? (0, $6AxZJ.default)(value) : (0, $krlao.default)(value);
}
var $a4464f11647b044e$export$2e2bcd8739ae039 = $a4464f11647b044e$var$baseGetTag;

});
parcelRegister("bZ3WS", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b987453dd14a047$export$2e2bcd8739ae039);

var $eBmfT = parcelRequire("eBmfT");
/** Built-in value references. */ var $8b987453dd14a047$var$Symbol = (0, $eBmfT.default).Symbol;
var $8b987453dd14a047$export$2e2bcd8739ae039 = $8b987453dd14a047$var$Symbol;

});
parcelRegister("eBmfT", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa15c8d260e2e933$export$2e2bcd8739ae039);

var $bji80 = parcelRequire("bji80");
/** Detect free variable `self`. */ var $aa15c8d260e2e933$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $aa15c8d260e2e933$var$root = (0, $bji80.default) || $aa15c8d260e2e933$var$freeSelf || Function('return this')();
var $aa15c8d260e2e933$export$2e2bcd8739ae039 = $aa15c8d260e2e933$var$root;

});
parcelRegister("bji80", function(module, exports) {
$parcel$export(module.exports, "default", () => $83bf87ed805e1b50$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $83bf87ed805e1b50$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $83bf87ed805e1b50$export$2e2bcd8739ae039 = $83bf87ed805e1b50$var$freeGlobal;

});



parcelRegister("6AxZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cc079836935d828$export$2e2bcd8739ae039);

var $bZ3WS = parcelRequire("bZ3WS");
/** Used for built-in method references. */ var $4cc079836935d828$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4cc079836935d828$var$hasOwnProperty = $4cc079836935d828$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4cc079836935d828$var$nativeObjectToString = $4cc079836935d828$var$objectProto.toString;
/** Built-in value references. */ var $4cc079836935d828$var$symToStringTag = (0, $bZ3WS.default) ? (0, $bZ3WS.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4cc079836935d828$var$getRawTag(value) {
    var isOwn = $4cc079836935d828$var$hasOwnProperty.call(value, $4cc079836935d828$var$symToStringTag), tag = value[$4cc079836935d828$var$symToStringTag];
    try {
        value[$4cc079836935d828$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4cc079836935d828$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4cc079836935d828$var$symToStringTag] = tag;
        else delete value[$4cc079836935d828$var$symToStringTag];
    }
    return result;
}
var $4cc079836935d828$export$2e2bcd8739ae039 = $4cc079836935d828$var$getRawTag;

});

parcelRegister("krlao", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee16bf81aea7bef6$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $ee16bf81aea7bef6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ee16bf81aea7bef6$var$nativeObjectToString = $ee16bf81aea7bef6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ee16bf81aea7bef6$var$objectToString(value) {
    return $ee16bf81aea7bef6$var$nativeObjectToString.call(value);
}
var $ee16bf81aea7bef6$export$2e2bcd8739ae039 = $ee16bf81aea7bef6$var$objectToString;

});


parcelRegister("3FtKM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2abc47ddb5d3f0a6$export$2e2bcd8739ae039);

var $fcgtT = parcelRequire("fcgtT");
/** Built-in value references. */ var $2abc47ddb5d3f0a6$var$getPrototype = (0, $fcgtT.default)(Object.getPrototypeOf, Object);
var $2abc47ddb5d3f0a6$export$2e2bcd8739ae039 = $2abc47ddb5d3f0a6$var$getPrototype;

});
parcelRegister("fcgtT", function(module, exports) {
$parcel$export(module.exports, "default", () => $02daea5e1a9621ed$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $02daea5e1a9621ed$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $02daea5e1a9621ed$export$2e2bcd8739ae039 = $02daea5e1a9621ed$var$overArg;

});


parcelRegister("2M5Hg", function(module, exports) {
$parcel$export(module.exports, "default", () => $20547bba84ad4599$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $20547bba84ad4599$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $20547bba84ad4599$export$2e2bcd8739ae039 = $20547bba84ad4599$var$isObjectLike;

});


parcelRegister("9uJm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e9a192fbcb2d40c$export$2e2bcd8739ae039);
/* global window */ 
var $jpPnc = parcelRequire("jpPnc");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $jpPnc.default)(root);
var $6e9a192fbcb2d40c$export$2e2bcd8739ae039 = result;

});
parcelRegister("jpPnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e22833c382f131b7$export$2e2bcd8739ae039);
function $e22833c382f131b7$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("bLO8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $891af9c1c6c9a756$export$2e2bcd8739ae039);

var $6tkGS = parcelRequire("6tkGS");

var $k34Jw = parcelRequire("k34Jw");
parcelRequire("1x2aO");
function $891af9c1c6c9a756$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $891af9c1c6c9a756$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $6tkGS.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $k34Jw.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $891af9c1c6c9a756$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $6tkGS.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $6tkGS.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $891af9c1c6c9a756$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $891af9c1c6c9a756$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $891af9c1c6c9a756$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("1x2aO", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $11da8f1cea70becb$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("c5EDQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cd57a4680d7894f$export$2e2bcd8739ae039);
function $8cd57a4680d7894f$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $8cd57a4680d7894f$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $8cd57a4680d7894f$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $8cd57a4680d7894f$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("kbJSm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb286bb605b21873$export$2e2bcd8739ae039);

var $9DdYZ = parcelRequire("9DdYZ");
var $eb286bb605b21873$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $eb286bb605b21873$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $9DdYZ.default).apply(undefined, chain)(store.dispatch);
            return $eb286bb605b21873$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("9DdYZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $01cf448d832d5a28$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $01cf448d832d5a28$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("cMSwg", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $94f4422ae4fa399d$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $94f4422ae4fa399d$export$8d46c7f53c8c602f);
parcelRequire("9IbZm");
function $94f4422ae4fa399d$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $94f4422ae4fa399d$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $94f4422ae4fa399d$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $94f4422ae4fa399d$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $94f4422ae4fa399d$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("9IbZm", function(module, exports) {

var $fpJdl = parcelRequire("fpJdl");

var $3wdKH = parcelRequire("3wdKH");
function $712185ce993f006c$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $fpJdl.default)(value)) (0, $3wdKH.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("fpJdl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c436a5e92d99e$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b38c436a5e92d99e$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("3wdKH", function(module, exports) {
$parcel$export(module.exports, "default", () => $28ff072af8c80abb$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $28ff072af8c80abb$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("lamtf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f68bf6610c6e715d$export$2e2bcd8739ae039);

var $cMSwg = parcelRequire("cMSwg");
function $f68bf6610c6e715d$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $cMSwg.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $f68bf6610c6e715d$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $cMSwg.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f68bf6610c6e715d$export$2e2bcd8739ae039 = [
    $f68bf6610c6e715d$export$23fc470827b14aa,
    $f68bf6610c6e715d$export$514bc8c1a53c1d66
];

});

parcelRegister("6kfu5", function(module, exports) {
$parcel$export(module.exports, "default", () => $49b09f3446205bdf$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");
parcelRequire("9IbZm");
function $49b09f3446205bdf$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $hHCeM.default)({}, ownProps, stateProps, dispatchProps);
}
function $49b09f3446205bdf$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $49b09f3446205bdf$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $49b09f3446205bdf$export$5b105939c84b5234(mergeProps) : undefined;
}
function $49b09f3446205bdf$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $49b09f3446205bdf$export$691c327fc30bc857;
    } : undefined;
}
var $49b09f3446205bdf$export$2e2bcd8739ae039 = [
    $49b09f3446205bdf$export$d61b680184bc3f00,
    $49b09f3446205bdf$export$a13ba70ef50dda6d
];

});

parcelRegister("3oDEf", function(module, exports) {
$parcel$export(module.exports, "default", () => $27925e445e37f297$export$2e2bcd8739ae039);

var $1ZwRz = parcelRequire("1ZwRz");
parcelRequire("34DbB");
function $27925e445e37f297$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $27925e445e37f297$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $27925e445e37f297$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $1ZwRz.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $27925e445e37f297$export$d20c0c2ca6eb2b6f : $27925e445e37f297$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("34DbB", function(module, exports) {

var $3wdKH = parcelRequire("3wdKH");
function $23d0245d26d38513$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!selector.hasOwnProperty('dependsOnOwnProps')) (0, $3wdKH.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $23d0245d26d38513$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $23d0245d26d38513$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $23d0245d26d38513$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $23d0245d26d38513$var$verify(mergeProps, 'mergeProps', displayName);
}

});




parcelRegister("3BZyK", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("2kf2w"));

});
parcelRegister("2kf2w", function(module, exports) {
'use strict';

var $152Cr = parcelRequire("152Cr");

var $48Zfe = parcelRequire("48Zfe");

var $kAG1C = parcelRequire("kAG1C");

var $4zRbM = parcelRequire("4zRbM");

var $g16EC = parcelRequire("g16EC");

var $5Diux = parcelRequire("5Diux");

var $3aGSj = parcelRequire("3aGSj");

var $aTLj4 = parcelRequire("aTLj4");

var $l0KzO = parcelRequire("l0KzO");
var $1b191d9265c8947d$var$loadQuery = $l0KzO.loadQuery;

var $v2hvX = parcelRequire("v2hvX");

var $9NVV1 = parcelRequire("9NVV1");

var $4vlU3 = parcelRequire("4vlU3");

var $6XY4W = parcelRequire("6XY4W");

var $ghHiT = parcelRequire("ghHiT");

var $3QDJV = parcelRequire("3QDJV");

var $9V8gE = parcelRequire("9V8gE");

var $7iuie = parcelRequire("7iuie");

var $eW9Rn = parcelRequire("eW9Rn");

var $dvC0l = parcelRequire("dvC0l");

var $i4SF2 = parcelRequire("i4SF2");

var $86KBN = parcelRequire("86KBN");

var $jIrdm = parcelRequire("jIrdm");

var $3hsec = parcelRequire("3hsec");

var $9FKKq = parcelRequire("9FKKq");

var $5KQKg = parcelRequire("5KQKg");
module.exports = {
    ConnectionHandler: $5KQKg.ConnectionHandler,
    QueryRenderer: $g16EC,
    LocalQueryRenderer: $kAG1C,
    MutationTypes: $5KQKg.MutationTypes,
    RangeOperations: $5KQKg.RangeOperations,
    ReactRelayContext: $152Cr,
    applyOptimisticMutation: $5KQKg.applyOptimisticMutation,
    commitLocalUpdate: $5KQKg.commitLocalUpdate,
    commitMutation: $5KQKg.commitMutation,
    createFragmentContainer: $48Zfe.createContainer,
    createPaginationContainer: $4zRbM.createContainer,
    createRefetchContainer: $5Diux.createContainer,
    fetchQuery_DEPRECATED: $5KQKg.fetchQuery_DEPRECATED,
    graphql: $5KQKg.graphql,
    readInlineData: $5KQKg.readInlineData,
    requestSubscription: $5KQKg.requestSubscription,
    EntryPointContainer: $3aGSj,
    RelayEnvironmentProvider: $9NVV1,
    ProfilerContext: $v2hvX,
    fetchQuery: $5KQKg.fetchQuery,
    loadQuery: $1b191d9265c8947d$var$loadQuery,
    loadEntryPoint: $aTLj4,
    useClientQuery: $4vlU3,
    useFragment: $ghHiT,
    useLazyLoadQuery: $3QDJV,
    useEntryPointLoader: $6XY4W,
    useQueryLoader: $i4SF2,
    useMutation: $9V8gE,
    usePaginationFragment: $7iuie,
    usePreloadedQuery: $dvC0l,
    useRefetchableFragment: $86KBN,
    usePrefetchableForwardPaginationFragment: $eW9Rn,
    useRelayEnvironment: $jIrdm,
    useSubscribeToInvalidationState: $3hsec,
    useSubscription: $9FKKq
};

});
parcelRegister("152Cr", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $0c984a27f39d94b7$var$createRelayContext = $5KQKg.__internal.createRelayContext;
module.exports = $0c984a27f39d94b7$var$createRelayContext($fc4bM);

});
parcelRegister("5KQKg", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("2hr5C"));

});
parcelRegister("2hr5C", function(module, exports) {
'use strict';

var $dbu1d = parcelRequire("dbu1d");
var $1a922ec0eb270777$var$isErrorResult = $dbu1d.isErrorResult, $1a922ec0eb270777$var$isValueResult = $dbu1d.isValueResult;

var $5h5mW = parcelRequire("5h5mW");

var $dhkCT = parcelRequire("dhkCT");

var $9QN3y = parcelRequire("9QN3y");

var $8S8Xr = parcelRequire("8S8Xr");

var $7EuYb = parcelRequire("7EuYb");

var $jSv2R = parcelRequire("jSv2R");

var $ih8Ks = parcelRequire("ih8Ks");

var $3tVxJ = parcelRequire("3tVxJ");

var $aNn02 = parcelRequire("aNn02");

var $8oIvB = parcelRequire("8oIvB");

var $8DZga = parcelRequire("8DZga");

var $7Invo = parcelRequire("7Invo");

var $4Qc5e = parcelRequire("4Qc5e");

var $dFQpN = parcelRequire("dFQpN");

var $ixIqX = parcelRequire("ixIqX");

var $e5Z6E = parcelRequire("e5Z6E");

var $cvbom = parcelRequire("cvbom");
var $1a922ec0eb270777$var$generateClientID = $cvbom.generateClientID, $1a922ec0eb270777$var$generateUniqueClientID = $cvbom.generateUniqueClientID, $1a922ec0eb270777$var$isClientID = $cvbom.isClientID;

var $7d53m = parcelRequire("7d53m");

var $bKCQT = parcelRequire("bKCQT");

var $29A6b = parcelRequire("29A6b");

var $2XJ33 = parcelRequire("2XJ33");

var $8rY4t = parcelRequire("8rY4t");
var $1a922ec0eb270777$var$isSuspenseSentinel = $8rY4t.isSuspenseSentinel, $1a922ec0eb270777$var$suspenseSentinel = $8rY4t.suspenseSentinel;

var $cojLE = parcelRequire("cojLE");

var $1klMT = parcelRequire("1klMT");

var $1S69g = parcelRequire("1S69g");

var $jfikN = parcelRequire("jfikN");

var $gGDWH = parcelRequire("gGDWH");

var $drWdC = parcelRequire("drWdC");

var $kPRSQ = parcelRequire("kPRSQ");

var $6h5qO = parcelRequire("6h5qO");

var $5ppYm = parcelRequire("5ppYm");

var $4OW3Y = parcelRequire("4OW3Y");

var $3GmWb = parcelRequire("3GmWb");

var $iVkak = parcelRequire("iVkak");

var $eRuLr = parcelRequire("eRuLr");

var $aIFxI = parcelRequire("aIFxI");

var $1vPAk = parcelRequire("1vPAk");

var $6hMsx = parcelRequire("6hMsx");

var $xeWcm = parcelRequire("xeWcm");

var $1Wogz = parcelRequire("1Wogz");

var $dxG36 = parcelRequire("dxG36");

var $6TOAe = parcelRequire("6TOAe");

var $4WacY = parcelRequire("4WacY");

var $57W7s = parcelRequire("57W7s");

var $dW07R = parcelRequire("dW07R");

var $alT9O = parcelRequire("alT9O");

var $lz2bc = parcelRequire("lz2bc");
var $1a922ec0eb270777$var$handlePotentialSnapshotErrors = $lz2bc.handlePotentialSnapshotErrors;

var $in4l7 = parcelRequire("in4l7");

var $lJXBf = parcelRequire("lJXBf");

var $lln7q = parcelRequire("lln7q");

var $f5GV4 = parcelRequire("f5GV4");

var $fVkDC = parcelRequire("fVkDC");

var $cYOet = parcelRequire("cYOet");

var $dRMp3 = parcelRequire("dRMp3");

var $34pGi = parcelRequire("34pGi");

var $hiJsq = parcelRequire("hiJsq");

var $4gj9D = parcelRequire("4gj9D");
var $1a922ec0eb270777$var$hasCycle = $4gj9D.hasCycle, $1a922ec0eb270777$var$stableCopy = $4gj9D.stableCopy;

var $7HWZR = parcelRequire("7HWZR");
var $1a922ec0eb270777$var$mapStr, $1a922ec0eb270777$var$setStr, $1a922ec0eb270777$var$promiseStr, $1a922ec0eb270777$var$objStr;
module.exports = {
    Environment: $jfikN,
    Network: $aNn02,
    Observable: $8oIvB,
    QueryResponseCache: $8DZga,
    RecordSource: $4OW3Y,
    Record: $drWdC,
    ReplaySubject: $hiJsq,
    Store: $6h5qO,
    areEqualSelectors: $kPRSQ.areEqualSelectors,
    createFragmentSpecResolver: $7d53m,
    createNormalizationSelector: $kPRSQ.createNormalizationSelector,
    createOperationDescriptor: $gGDWH.createOperationDescriptor,
    createReaderSelector: $kPRSQ.createReaderSelector,
    createRequestDescriptor: $gGDWH.createRequestDescriptor,
    getArgumentValues: $3GmWb.getArgumentValues,
    getDataIDsFromFragment: $kPRSQ.getDataIDsFromFragment,
    getDataIDsFromObject: $kPRSQ.getDataIDsFromObject,
    getNode: $ixIqX.getNode,
    getFragment: $ixIqX.getFragment,
    getInlineDataFragment: $ixIqX.getInlineDataFragment,
    getModuleComponentKey: $3GmWb.getModuleComponentKey,
    getModuleOperationKey: $3GmWb.getModuleOperationKey,
    getPaginationFragment: $ixIqX.getPaginationFragment,
    getPluralSelector: $kPRSQ.getPluralSelector,
    getRefetchableFragment: $ixIqX.getRefetchableFragment,
    getRequest: $ixIqX.getRequest,
    getRequestIdentifier: $dW07R,
    getSelector: $kPRSQ.getSelector,
    getSelectorsFromObject: $kPRSQ.getSelectorsFromObject,
    getSingularSelector: $kPRSQ.getSingularSelector,
    getStorageKey: $3GmWb.getStorageKey,
    getVariablesFromFragment: $kPRSQ.getVariablesFromFragment,
    getVariablesFromObject: $kPRSQ.getVariablesFromObject,
    getVariablesFromPluralFragment: $kPRSQ.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $kPRSQ.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $1a922ec0eb270777$var$handlePotentialSnapshotErrors,
    graphql: $ixIqX.graphql,
    isErrorResult: $1a922ec0eb270777$var$isErrorResult,
    isValueResult: $1a922ec0eb270777$var$isValueResult,
    isFragment: $ixIqX.isFragment,
    isInlineDataFragment: $ixIqX.isInlineDataFragment,
    isSuspenseSentinel: $1a922ec0eb270777$var$isSuspenseSentinel,
    suspenseSentinel: $1a922ec0eb270777$var$suspenseSentinel,
    isRequest: $ixIqX.isRequest,
    readInlineData: $1klMT,
    readFragment: $iVkak.readFragment,
    MutationTypes: $3tVxJ.MutationTypes,
    RangeOperations: $3tVxJ.RangeOperations,
    DefaultHandlerProvider: $8S8Xr,
    ConnectionHandler: $5h5mW,
    MutationHandlers: $9QN3y,
    VIEWER_ID: $eRuLr.VIEWER_ID,
    VIEWER_TYPE: $eRuLr.VIEWER_TYPE,
    applyOptimisticMutation: $7EuYb,
    commitLocalUpdate: $jSv2R,
    commitMutation: $ih8Ks,
    fetchQuery: $7Invo,
    fetchQuery_DEPRECATED: $4Qc5e,
    isRelayModernEnvironment: $2XJ33,
    requestSubscription: $aIFxI,
    ConnectionInterface: $dhkCT,
    PreloadableQueryRegistry: $e5Z6E,
    RelayProfiler: $34pGi,
    createPayloadFor3DField: $1vPAk,
    RelayConcreteNode: $f5GV4,
    RelayError: $cYOet,
    RelayFeatureFlags: $dRMp3,
    DEFAULT_HANDLE_KEY: $fVkDC.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $3GmWb.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $3GmWb.FRAGMENT_OWNER_KEY,
    ID_KEY: $3GmWb.ID_KEY,
    REF_KEY: $3GmWb.REF_KEY,
    REFS_KEY: $3GmWb.REFS_KEY,
    ROOT_ID: $3GmWb.ROOT_ID,
    ROOT_TYPE: $3GmWb.ROOT_TYPE,
    TYPENAME_KEY: $3GmWb.TYPENAME_KEY,
    deepFreeze: $6hMsx,
    generateClientID: $1a922ec0eb270777$var$generateClientID,
    generateUniqueClientID: $1a922ec0eb270777$var$generateUniqueClientID,
    getRelayHandleKey: $57W7s,
    isClientID: $1a922ec0eb270777$var$isClientID,
    isPromise: $in4l7,
    isScalarAndEqual: $lJXBf,
    recycleNodesInto: $lln7q,
    stableCopy: $1a922ec0eb270777$var$stableCopy,
    hasCycle: $1a922ec0eb270777$var$hasCycle,
    getFragmentIdentifier: $xeWcm,
    getRefetchMetadata: $4WacY,
    getPaginationMetadata: $1Wogz,
    getPaginationVariables: $dxG36,
    getPendingOperationsForFragment: $6TOAe,
    getValueAtPath: $alT9O,
    __internal: {
        ResolverFragments: $iVkak,
        OperationTracker: $5ppYm,
        createRelayContext: $bKCQT,
        createRelayLoggingContext: $29A6b,
        getOperationVariables: $1S69g.getOperationVariables,
        getLocalVariables: $1S69g.getLocalVariables,
        fetchQuery: $dFQpN.fetchQuery,
        fetchQueryDeduped: $dFQpN.fetchQueryDeduped,
        getPromiseForActiveRequest: $dFQpN.getPromiseForActiveRequest,
        getObservableForActiveRequest: $dFQpN.getObservableForActiveRequest,
        normalizeResponse: $cojLE,
        withProvidedVariables: $7HWZR
    }
};

});
parcelRegister("dbu1d", function(module, exports) {
'use strict';

var $eWImj = parcelRequire("eWImj");

var $9AKzb = parcelRequire("9AKzb");
var $999396826dc20925$var$observeFragment = $9AKzb.observeFragment;

var $46O5u = parcelRequire("46O5u");
var $999396826dc20925$var$observeQuery = $46O5u.observeQuery;

var $k4SaM = parcelRequire("k4SaM");
var $999396826dc20925$var$waitForFragmentData = $k4SaM.waitForFragmentData;
function $999396826dc20925$var$isValueResult(input) {
    return input.ok === true;
}
function $999396826dc20925$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $eWImj,
    isValueResult: $999396826dc20925$var$isValueResult,
    isErrorResult: $999396826dc20925$var$isErrorResult,
    observeQuery: $999396826dc20925$var$observeQuery,
    observeFragment: $999396826dc20925$var$observeFragment,
    waitForFragmentData: $999396826dc20925$var$waitForFragmentData
};

});
parcelRegister("eWImj", function(module, exports) {
'use strict';

var $iVkak = parcelRequire("iVkak");
var $ae18e4360daf60a7$var$readFragment = $iVkak.readFragment;

var $bCunb = parcelRequire("bCunb");
function $ae18e4360daf60a7$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $ae18e4360daf60a7$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $bCunb(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $bCunb(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $bCunb(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $ae18e4360daf60a7$var$resolverDataInjector;

});
parcelRegister("iVkak", function(module, exports) {
'use strict';

var $ixIqX = parcelRequire("ixIqX");
var $dc6d31585ffc727d$var$getFragment = $ixIqX.getFragment;

var $lz2bc = parcelRequire("lz2bc");
var $dc6d31585ffc727d$var$eventShouldThrow = $lz2bc.eventShouldThrow;

var $kPRSQ = parcelRequire("kPRSQ");
var $dc6d31585ffc727d$var$getSelector = $kPRSQ.getSelector;

var $bCunb = parcelRequire("bCunb");
var $dc6d31585ffc727d$var$contextStack = [];
function $dc6d31585ffc727d$var$withResolverContext(context, cb) {
    $dc6d31585ffc727d$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $dc6d31585ffc727d$var$contextStack.pop();
    }
}
function $dc6d31585ffc727d$var$readFragment(fragmentInput, fragmentKey) {
    if (!$dc6d31585ffc727d$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $dc6d31585ffc727d$var$contextStack[$dc6d31585ffc727d$var$contextStack.length - 1];
    var fragmentNode = $dc6d31585ffc727d$var$getFragment(fragmentInput);
    var fragmentSelector = $dc6d31585ffc727d$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $bCunb(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $bCunb(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($dc6d31585ffc727d$var$eventShouldThrow)) throw $dc6d31585ffc727d$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $dc6d31585ffc727d$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $dc6d31585ffc727d$var$readFragment,
    withResolverContext: $dc6d31585ffc727d$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $dc6d31585ffc727d$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("ixIqX", function(module, exports) {
'use strict';

var $f5GV4 = parcelRequire("f5GV4");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $d7fdc6aa0f338b7a$var$graphql(strings) {
    $bCunb(false);
}
function $d7fdc6aa0f338b7a$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $d7fdc6aa0f338b7a$var$isFragment(node) {
    var fragment = $d7fdc6aa0f338b7a$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $f5GV4.FRAGMENT;
}
function $d7fdc6aa0f338b7a$var$isRequest(node) {
    var request = $d7fdc6aa0f338b7a$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $f5GV4.REQUEST;
}
function $d7fdc6aa0f338b7a$var$isUpdatableQuery(node) {
    var updatableQuery = $d7fdc6aa0f338b7a$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $f5GV4.UPDATABLE_QUERY;
}
function $d7fdc6aa0f338b7a$var$isInlineDataFragment(node) {
    var fragment = $d7fdc6aa0f338b7a$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $f5GV4.INLINE_DATA_FRAGMENT;
}
function $d7fdc6aa0f338b7a$var$getFragment(taggedNode) {
    var fragment = $d7fdc6aa0f338b7a$var$getNode(taggedNode);
    !$d7fdc6aa0f338b7a$var$isFragment(fragment) && $bCunb(false);
    return fragment;
}
function $d7fdc6aa0f338b7a$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $d7fdc6aa0f338b7a$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $d7fdc6aa0f338b7a$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $d7fdc6aa0f338b7a$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $d7fdc6aa0f338b7a$var$getRequest(taggedNode) {
    var request = $d7fdc6aa0f338b7a$var$getNode(taggedNode);
    !$d7fdc6aa0f338b7a$var$isRequest(request) && $bCunb(false);
    return request;
}
function $d7fdc6aa0f338b7a$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $d7fdc6aa0f338b7a$var$getNode(taggedNode);
    !$d7fdc6aa0f338b7a$var$isUpdatableQuery(updatableQuery) && $bCunb(false);
    return updatableQuery;
}
function $d7fdc6aa0f338b7a$var$getInlineDataFragment(taggedNode) {
    var fragment = $d7fdc6aa0f338b7a$var$getNode(taggedNode);
    !$d7fdc6aa0f338b7a$var$isInlineDataFragment(fragment) && $bCunb(false);
    return fragment;
}
module.exports = {
    getFragment: $d7fdc6aa0f338b7a$var$getFragment,
    getNode: $d7fdc6aa0f338b7a$var$getNode,
    getPaginationFragment: $d7fdc6aa0f338b7a$var$getPaginationFragment,
    getRefetchableFragment: $d7fdc6aa0f338b7a$var$getRefetchableFragment,
    getRequest: $d7fdc6aa0f338b7a$var$getRequest,
    getUpdatableQuery: $d7fdc6aa0f338b7a$var$getUpdatableQuery,
    getInlineDataFragment: $d7fdc6aa0f338b7a$var$getInlineDataFragment,
    graphql: $d7fdc6aa0f338b7a$var$graphql,
    isFragment: $d7fdc6aa0f338b7a$var$isFragment,
    isRequest: $d7fdc6aa0f338b7a$var$isRequest,
    isUpdatableQuery: $d7fdc6aa0f338b7a$var$isUpdatableQuery,
    isInlineDataFragment: $d7fdc6aa0f338b7a$var$isInlineDataFragment
};

});
parcelRegister("f5GV4", function(module, exports) {
'use strict';
var $afc89d8b1988df42$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $afc89d8b1988df42$var$RelayConcreteNode;

});

parcelRegister("fLDY5", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $gjaAA = parcelRequire("gjaAA");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $b7aa3fa10dae61bd$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $b7aa3fa10dae61bd$var$warning = $gjaAA;
module.exports = $b7aa3fa10dae61bd$var$warning;

});
parcelRegister("gjaAA", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $bdf6a27dd976b14f$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $bdf6a27dd976b14f$var$emptyFunction = function emptyFunction() {};
$bdf6a27dd976b14f$var$emptyFunction.thatReturns = $bdf6a27dd976b14f$var$makeEmptyFunction;
$bdf6a27dd976b14f$var$emptyFunction.thatReturnsFalse = $bdf6a27dd976b14f$var$makeEmptyFunction(false);
$bdf6a27dd976b14f$var$emptyFunction.thatReturnsTrue = $bdf6a27dd976b14f$var$makeEmptyFunction(true);
$bdf6a27dd976b14f$var$emptyFunction.thatReturnsNull = $bdf6a27dd976b14f$var$makeEmptyFunction(null);
$bdf6a27dd976b14f$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$bdf6a27dd976b14f$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $bdf6a27dd976b14f$var$emptyFunction;

});



parcelRegister("lz2bc", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $fb2e8eaf3ec77b86$var$_interopRequireDefault = $j3tQw.default;

var $fb2e8eaf3ec77b86$var$_objectSpread2 = $fb2e8eaf3ec77b86$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $fb2e8eaf3ec77b86$var$_createForOfIteratorHelper2 = $fb2e8eaf3ec77b86$var$_interopRequireDefault((parcelRequire("cJrco")));

var $bCunb = parcelRequire("bCunb");
function $fb2e8eaf3ec77b86$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $fb2e8eaf3ec77b86$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $fb2e8eaf3ec77b86$var$_objectSpread2["default"])((0, $fb2e8eaf3ec77b86$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $fb2e8eaf3ec77b86$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($fb2e8eaf3ec77b86$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $bCunb(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $fb2e8eaf3ec77b86$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $fb2e8eaf3ec77b86$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $fb2e8eaf3ec77b86$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: $fb2e8eaf3ec77b86$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $fb2e8eaf3ec77b86$var$eventShouldThrow
};

});
parcelRegister("j3tQw", function(module, exports) {
function $ddf572f66eaf8526$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $ddf572f66eaf8526$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("MwqMq", function(module, exports) {

var $geBXM = parcelRequire("geBXM");
function $091da3eb09835abc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $091da3eb09835abc$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $091da3eb09835abc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $geBXM(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $091da3eb09835abc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $091da3eb09835abc$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("geBXM", function(module, exports) {

var $gvBRV = parcelRequire("gvBRV");
function $bd1b66dbff8e531d$var$_defineProperty(e, r, t) {
    return (r = $gvBRV(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bd1b66dbff8e531d$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gvBRV", function(module, exports) {

var $9fQWM = parcelRequire("9fQWM");
var $c04cea90126fb927$var$_typeof = $9fQWM.default;

var $c84Ni = parcelRequire("c84Ni");
function $c04cea90126fb927$var$toPropertyKey(t) {
    var i = $c84Ni(t, "string");
    return "symbol" == $c04cea90126fb927$var$_typeof(i) ? i : i + "";
}
module.exports = $c04cea90126fb927$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9fQWM", function(module, exports) {
function $6bce95f7127d8f33$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $6bce95f7127d8f33$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6bce95f7127d8f33$var$_typeof(o);
}
module.exports = $6bce95f7127d8f33$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("c84Ni", function(module, exports) {

var $9fQWM = parcelRequire("9fQWM");
var $8d49f36061dbb4a2$var$_typeof = $9fQWM.default;
function $8d49f36061dbb4a2$var$toPrimitive(t, r) {
    if ("object" != $8d49f36061dbb4a2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8d49f36061dbb4a2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $8d49f36061dbb4a2$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cJrco", function(module, exports) {

var $dTqio = parcelRequire("dTqio");
function $944ec92824ce2b99$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dTqio(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $944ec92824ce2b99$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dTqio", function(module, exports) {

var $ajm0H = parcelRequire("ajm0H");
function $a1d4cf29c3a8ae43$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ajm0H(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ajm0H(r, a) : void 0;
    }
}
module.exports = $a1d4cf29c3a8ae43$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ajm0H", function(module, exports) {
function $781cc08641b9f6cf$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $781cc08641b9f6cf$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("kPRSQ", function(module, exports) {
'use strict';

var $1S69g = parcelRequire("1S69g");
var $f2b25e385be2c60c$var$getFragmentVariables = $1S69g.getFragmentVariables;

var $3GmWb = parcelRequire("3GmWb");
var $f2b25e385be2c60c$var$CLIENT_EDGE_TRAVERSAL_PATH = $3GmWb.CLIENT_EDGE_TRAVERSAL_PATH, $f2b25e385be2c60c$var$FRAGMENT_OWNER_KEY = $3GmWb.FRAGMENT_OWNER_KEY, $f2b25e385be2c60c$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $3GmWb.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $f2b25e385be2c60c$var$FRAGMENTS_KEY = $3GmWb.FRAGMENTS_KEY, $f2b25e385be2c60c$var$ID_KEY = $3GmWb.ID_KEY;

var $lPzB2 = parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $f2b25e385be2c60c$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $bCunb(false);
    var dataID = item[$f2b25e385be2c60c$var$ID_KEY];
    var fragments = item[$f2b25e385be2c60c$var$FRAGMENTS_KEY];
    var mixedOwner = item[$f2b25e385be2c60c$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$f2b25e385be2c60c$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $f2b25e385be2c60c$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$f2b25e385be2c60c$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $f2b25e385be2c60c$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $f2b25e385be2c60c$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $f2b25e385be2c60c$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $f2b25e385be2c60c$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $bCunb(false);
        return $f2b25e385be2c60c$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $bCunb(false);
        return $f2b25e385be2c60c$var$getSingularSelector(fragment, item);
    }
}
function $f2b25e385be2c60c$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $f2b25e385be2c60c$var$getSelector(fragment, item);
    }
    return selectors;
}
function $f2b25e385be2c60c$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $f2b25e385be2c60c$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $f2b25e385be2c60c$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $bCunb(false);
        return $f2b25e385be2c60c$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $bCunb(false);
        return $f2b25e385be2c60c$var$getDataID(fragment, item);
    }
}
function $f2b25e385be2c60c$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $f2b25e385be2c60c$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $f2b25e385be2c60c$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $bCunb(false);
    var dataID = item[$f2b25e385be2c60c$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $f2b25e385be2c60c$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $f2b25e385be2c60c$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $f2b25e385be2c60c$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $bCunb(false);
        return $f2b25e385be2c60c$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $bCunb(false);
        return $f2b25e385be2c60c$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $f2b25e385be2c60c$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $f2b25e385be2c60c$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $f2b25e385be2c60c$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $f2b25e385be2c60c$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $f2b25e385be2c60c$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $lPzB2(thisSelector.variables, thatSelector.variables) && $f2b25e385be2c60c$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $f2b25e385be2c60c$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $f2b25e385be2c60c$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $lPzB2(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $f2b25e385be2c60c$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $f2b25e385be2c60c$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $f2b25e385be2c60c$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $f2b25e385be2c60c$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $f2b25e385be2c60c$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $f2b25e385be2c60c$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $f2b25e385be2c60c$var$areEqualSelectors,
    createReaderSelector: $f2b25e385be2c60c$var$createReaderSelector,
    createNormalizationSelector: $f2b25e385be2c60c$var$createNormalizationSelector,
    getDataIDsFromFragment: $f2b25e385be2c60c$var$getDataIDsFromFragment,
    getDataIDsFromObject: $f2b25e385be2c60c$var$getDataIDsFromObject,
    getSingularSelector: $f2b25e385be2c60c$var$getSingularSelector,
    getPluralSelector: $f2b25e385be2c60c$var$getPluralSelector,
    getSelector: $f2b25e385be2c60c$var$getSelector,
    getSelectorsFromObject: $f2b25e385be2c60c$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $f2b25e385be2c60c$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $f2b25e385be2c60c$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $f2b25e385be2c60c$var$getVariablesFromFragment,
    getVariablesFromObject: $f2b25e385be2c60c$var$getVariablesFromObject
};

});
parcelRegister("1S69g", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $15cf9a8a3d688273$var$_interopRequireDefault = $j3tQw.default;

var $15cf9a8a3d688273$var$_objectSpread2 = $15cf9a8a3d688273$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $3GmWb = parcelRequire("3GmWb");
var $15cf9a8a3d688273$var$getArgumentValues = $3GmWb.getArgumentValues;

var $bCunb = parcelRequire("bCunb");
function $15cf9a8a3d688273$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $15cf9a8a3d688273$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $bCunb(false);
        }
    });
    return variables || argumentVariables;
}
function $15cf9a8a3d688273$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $15cf9a8a3d688273$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $15cf9a8a3d688273$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $15cf9a8a3d688273$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $15cf9a8a3d688273$var$getLocalVariables,
    getFragmentVariables: $15cf9a8a3d688273$var$getFragmentVariables,
    getOperationVariables: $15cf9a8a3d688273$var$getOperationVariables
};

});
parcelRegister("3GmWb", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $2ae716413697f61d$var$_interopRequireDefault = $j3tQw.default;

var $2ae716413697f61d$var$_toConsumableArray2 = $2ae716413697f61d$var$_interopRequireDefault((parcelRequire("6jwD6")));

var $57W7s = parcelRequire("57W7s");

var $f5GV4 = parcelRequire("f5GV4");

var $dRMp3 = parcelRequire("dRMp3");

var $4gj9D = parcelRequire("4gj9D");
var $2ae716413697f61d$var$stableCopy = $4gj9D.stableCopy;

var $bCunb = parcelRequire("bCunb");
var $2ae716413697f61d$var$VARIABLE = $f5GV4.VARIABLE, $2ae716413697f61d$var$LITERAL = $f5GV4.LITERAL, $2ae716413697f61d$var$OBJECT_VALUE = $f5GV4.OBJECT_VALUE, $2ae716413697f61d$var$LIST_VALUE = $f5GV4.LIST_VALUE;
var $2ae716413697f61d$var$ERRORS_KEY = '__errors';
var $2ae716413697f61d$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $2ae716413697f61d$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $2ae716413697f61d$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $2ae716413697f61d$var$getArgumentValue(arg, variables) {
    if (arg.kind === $2ae716413697f61d$var$VARIABLE) return $2ae716413697f61d$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $2ae716413697f61d$var$LITERAL) return arg.value;
    else if (arg.kind === $2ae716413697f61d$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $2ae716413697f61d$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $2ae716413697f61d$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($2ae716413697f61d$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $2ae716413697f61d$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$2ae716413697f61d$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $2ae716413697f61d$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $2ae716413697f61d$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $57W7s(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $2ae716413697f61d$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $2ae716413697f61d$var$formatStorageKey(handleName, $2ae716413697f61d$var$getArgumentValues(filterArgs, variables));
}
function $2ae716413697f61d$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $2ae716413697f61d$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $2ae716413697f61d$var$formatStorageKey(name, $2ae716413697f61d$var$getArgumentValues(args, variables)) : name;
}
function $2ae716413697f61d$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $2ae716413697f61d$var$getStorageKey(field, variables);
    return $dRMp3.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $2ae716413697f61d$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $2ae716413697f61d$var$getStableStorageKey(name, args) {
    return $2ae716413697f61d$var$formatStorageKey(name, $2ae716413697f61d$var$stableCopy(args));
}
function $2ae716413697f61d$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $2ae716413697f61d$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $bCunb(false);
    return $2ae716413697f61d$var$stableCopy(variables[name]);
}
function $2ae716413697f61d$var$getModuleComponentKey(documentName) {
    return "".concat($2ae716413697f61d$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $2ae716413697f61d$var$getModuleOperationKey(documentName) {
    return "".concat($2ae716413697f61d$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $2ae716413697f61d$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $2ae716413697f61d$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $2ae716413697f61d$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $2ae716413697f61d$var$formatStorageKey,
    getArgumentValue: $2ae716413697f61d$var$getArgumentValue,
    getArgumentValues: $2ae716413697f61d$var$getArgumentValues,
    getHandleStorageKey: $2ae716413697f61d$var$getHandleStorageKey,
    getStorageKey: $2ae716413697f61d$var$getStorageKey,
    getReadTimeResolverStorageKey: $2ae716413697f61d$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $2ae716413697f61d$var$getStableStorageKey,
    getModuleComponentKey: $2ae716413697f61d$var$getModuleComponentKey,
    getModuleOperationKey: $2ae716413697f61d$var$getModuleOperationKey
};
module.exports = $2ae716413697f61d$var$RelayStoreUtils;

});
parcelRegister("6jwD6", function(module, exports) {

var $3nenZ = parcelRequire("3nenZ");

var $inCZK = parcelRequire("inCZK");

var $dTqio = parcelRequire("dTqio");

var $8wTBH = parcelRequire("8wTBH");
function $498dd3ff735e8fbc$var$_toConsumableArray(r) {
    return $3nenZ(r) || $inCZK(r) || $dTqio(r) || $8wTBH();
}
module.exports = $498dd3ff735e8fbc$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3nenZ", function(module, exports) {

var $ajm0H = parcelRequire("ajm0H");
function $274eadd48d233fb5$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ajm0H(r);
}
module.exports = $274eadd48d233fb5$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("inCZK", function(module, exports) {
function $d6189f934795a939$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $d6189f934795a939$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8wTBH", function(module, exports) {
function $635c724cb53bd977$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $635c724cb53bd977$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("57W7s", function(module, exports) {
'use strict';

var $fVkDC = parcelRequire("fVkDC");
var $3bbab0765eed56b7$var$DEFAULT_HANDLE_KEY = $fVkDC.DEFAULT_HANDLE_KEY;

var $bCunb = parcelRequire("bCunb");
function $3bbab0765eed56b7$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $3bbab0765eed56b7$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $bCunb(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $3bbab0765eed56b7$var$getRelayHandleKey;

});
parcelRegister("fVkDC", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("dRMp3", function(module, exports) {
'use strict';
var $a185c575423a9573$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = $a185c575423a9573$var$RelayFeatureFlags;

});

parcelRegister("4gj9D", function(module, exports) {
'use strict';
function $31a783b9a52beefd$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($31a783b9a52beefd$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $31a783b9a52beefd$var$stableCopy(value[keys[i]]);
    return stable;
}
function $31a783b9a52beefd$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $31a783b9a52beefd$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $31a783b9a52beefd$var$stableCopy,
    hasCycle: $31a783b9a52beefd$var$hasCycle
};

});



parcelRegister("lPzB2", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $fe49f913d99a62d7$var$aStackPool = [];
var $fe49f913d99a62d7$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $fe49f913d99a62d7$var$areEqual(a, b) {
    var aStack = $fe49f913d99a62d7$var$aStackPool.length ? $fe49f913d99a62d7$var$aStackPool.pop() : [];
    var bStack = $fe49f913d99a62d7$var$bStackPool.length ? $fe49f913d99a62d7$var$bStackPool.pop() : [];
    var result = $fe49f913d99a62d7$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $fe49f913d99a62d7$var$aStackPool.push(aStack);
    $fe49f913d99a62d7$var$bStackPool.push(bStack);
    return result;
}
function $fe49f913d99a62d7$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$fe49f913d99a62d7$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$fe49f913d99a62d7$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $fe49f913d99a62d7$var$areEqual;

});




parcelRegister("9AKzb", function(module, exports) {
"use strict";

var $j3tQw = parcelRequire("j3tQw");
var $6fbb98fe0c0480a1$var$_interopRequireDefault = $j3tQw.default;

var $DzIbC = parcelRequire("DzIbC");
var $6fbb98fe0c0480a1$require$_asyncToGenerator = $DzIbC.default;

var $6fbb98fe0c0480a1$var$_createForOfIteratorHelper2 = $6fbb98fe0c0480a1$var$_interopRequireDefault((parcelRequire("cJrco")));

var $8oIvB = parcelRequire("8oIvB");

var $dFQpN = parcelRequire("dFQpN");
var $6fbb98fe0c0480a1$var$getObservableForActiveRequest = $dFQpN.getObservableForActiveRequest;

var $ixIqX = parcelRequire("ixIqX");
var $6fbb98fe0c0480a1$var$getFragment = $ixIqX.getFragment;

var $lz2bc = parcelRequire("lz2bc");
var $6fbb98fe0c0480a1$var$handlePotentialSnapshotErrors = $lz2bc.handlePotentialSnapshotErrors;

var $kPRSQ = parcelRequire("kPRSQ");
var $6fbb98fe0c0480a1$var$getSelector = $kPRSQ.getSelector;

var $bCunb = parcelRequire("bCunb");
function $6fbb98fe0c0480a1$var$waitForFragmentData(_x, _x2, _x3) {
    return $6fbb98fe0c0480a1$var$_waitForFragmentData.apply(this, arguments);
}
function $6fbb98fe0c0480a1$var$_waitForFragmentData() {
    $6fbb98fe0c0480a1$var$_waitForFragmentData = $6fbb98fe0c0480a1$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $6fbb98fe0c0480a1$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $6fbb98fe0c0480a1$var$_waitForFragmentData.apply(this, arguments);
}
function $6fbb98fe0c0480a1$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $6fbb98fe0c0480a1$var$getFragment(fragment);
    var fragmentSelector = $6fbb98fe0c0480a1$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $bCunb(false);
    !(fragmentSelector != null) && $bCunb(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $6fbb98fe0c0480a1$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $6fbb98fe0c0480a1$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $bCunb(false);
}
function $6fbb98fe0c0480a1$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $8oIvB.create(function(sink) {
        sink.next($6fbb98fe0c0480a1$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($6fbb98fe0c0480a1$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $6fbb98fe0c0480a1$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $8oIvB.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $6fbb98fe0c0480a1$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($6fbb98fe0c0480a1$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $6fbb98fe0c0480a1$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($6fbb98fe0c0480a1$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $6fbb98fe0c0480a1$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($6fbb98fe0c0480a1$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $6fbb98fe0c0480a1$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $bCunb(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $6fbb98fe0c0480a1$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $6fbb98fe0c0480a1$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $6fbb98fe0c0480a1$var$observeFragment,
    waitForFragmentData: $6fbb98fe0c0480a1$var$waitForFragmentData
};

});
parcelRegister("DzIbC", function(module, exports) {
function $076f583ab6495327$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $076f583ab6495327$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $076f583ab6495327$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $076f583ab6495327$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $076f583ab6495327$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8oIvB", function(module, exports) {
'use strict';

var $in4l7 = parcelRequire("in4l7");
var $61d317241a87d660$var$hostReportError = $61d317241a87d660$var$swallowError;
var $61d317241a87d660$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $61d317241a87d660$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $61d317241a87d660$var$isObservable(obj) ? $61d317241a87d660$var$fromObservable(obj) : $in4l7(obj) ? $61d317241a87d660$var$fromPromise(obj) : $61d317241a87d660$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $61d317241a87d660$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $61d317241a87d660$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $61d317241a87d660$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $61d317241a87d660$var$fromObservable(obj) {
    return obj instanceof $61d317241a87d660$var$RelayObservable ? obj : $61d317241a87d660$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $61d317241a87d660$var$fromPromise(promise) {
    return $61d317241a87d660$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $61d317241a87d660$var$fromValue(value) {
    return $61d317241a87d660$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $61d317241a87d660$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $61d317241a87d660$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $61d317241a87d660$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $61d317241a87d660$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $61d317241a87d660$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $61d317241a87d660$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $61d317241a87d660$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $61d317241a87d660$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $61d317241a87d660$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $61d317241a87d660$var$RelayObservable;

});
parcelRegister("in4l7", function(module, exports) {
'use strict';
function $d5fdbdbc6cb7ca54$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $d5fdbdbc6cb7ca54$var$isPromise;

});


parcelRegister("dFQpN", function(module, exports) {
'use strict';

var $8oIvB = parcelRequire("8oIvB");

var $hiJsq = parcelRequire("hiJsq");

var $bCunb = parcelRequire("bCunb");
var $9f47c341c1d8c3ab$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $9f47c341c1d8c3ab$var$requestCachesByEnvironment = $9f47c341c1d8c3ab$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $9f47c341c1d8c3ab$var$fetchQuery(environment, operation) {
    return $9f47c341c1d8c3ab$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $9f47c341c1d8c3ab$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $8oIvB.create(function(sink) {
        var requestCache = $9f47c341c1d8c3ab$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $hiJsq(),
                    subjectForInFlightStatus: new $hiJsq(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $9f47c341c1d8c3ab$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $9f47c341c1d8c3ab$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $9f47c341c1d8c3ab$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $9f47c341c1d8c3ab$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $bCunb(false);
        return $9f47c341c1d8c3ab$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $9f47c341c1d8c3ab$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $8oIvB.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $9f47c341c1d8c3ab$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $8oIvB.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $9f47c341c1d8c3ab$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $9f47c341c1d8c3ab$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $9f47c341c1d8c3ab$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $9f47c341c1d8c3ab$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $9f47c341c1d8c3ab$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $9f47c341c1d8c3ab$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $9f47c341c1d8c3ab$var$getRequestCache(environment) {
    var cached = $9f47c341c1d8c3ab$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $9f47c341c1d8c3ab$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $9f47c341c1d8c3ab$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $bCunb(false);
    return cached;
}
module.exports = {
    fetchQuery: $9f47c341c1d8c3ab$var$fetchQuery,
    fetchQueryDeduped: $9f47c341c1d8c3ab$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $9f47c341c1d8c3ab$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $9f47c341c1d8c3ab$var$getObservableForActiveRequest
};

});
parcelRegister("hiJsq", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $c9876101580798ca$var$_interopRequireDefault = $j3tQw.default;

var $c9876101580798ca$var$_createForOfIteratorHelper2 = $c9876101580798ca$var$_interopRequireDefault((parcelRequire("cJrco")));

var $c9876101580798ca$var$_defineProperty2 = $c9876101580798ca$var$_interopRequireDefault((parcelRequire("geBXM")));

var $8oIvB = parcelRequire("8oIvB");

var $bCunb = parcelRequire("bCunb");
var $c9876101580798ca$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $c9876101580798ca$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $c9876101580798ca$var$_defineProperty2["default"])(this, "_events", []);
        (0, $c9876101580798ca$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $c9876101580798ca$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $8oIvB.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $bCunb(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $c9876101580798ca$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $c9876101580798ca$var$RelayReplaySubject;

});



parcelRegister("46O5u", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $2fde93488206b39b$var$_interopRequireDefault = $j3tQw.default;

var $2fde93488206b39b$var$_defineProperty2 = $2fde93488206b39b$var$_interopRequireDefault((parcelRequire("geBXM")));

var $9AKzb = parcelRequire("9AKzb");
var $2fde93488206b39b$var$observeFragment = $9AKzb.observeFragment;

var $gGDWH = parcelRequire("gGDWH");
var $2fde93488206b39b$var$createOperationDescriptor = $gGDWH.createOperationDescriptor;
function $2fde93488206b39b$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $2fde93488206b39b$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $2fde93488206b39b$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return $2fde93488206b39b$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $2fde93488206b39b$var$observeQuery
};

});
parcelRegister("gGDWH", function(module, exports) {
'use strict';
parcelRequire("6hMsx");

var $dW07R = parcelRequire("dW07R");

var $dRMp3 = parcelRequire("dRMp3");

var $4gj9D = parcelRequire("4gj9D");
var $c25f8dfad294842f$var$hasCycle = $4gj9D.hasCycle;

var $1S69g = parcelRequire("1S69g");
var $c25f8dfad294842f$var$getOperationVariables = $1S69g.getOperationVariables;

var $kPRSQ = parcelRequire("kPRSQ");
var $c25f8dfad294842f$var$createNormalizationSelector = $kPRSQ.createNormalizationSelector, $c25f8dfad294842f$var$createReaderSelector = $kPRSQ.createReaderSelector;

var $3GmWb = parcelRequire("3GmWb");
var $c25f8dfad294842f$var$ROOT_ID = $3GmWb.ROOT_ID;

var $bCunb = parcelRequire("bCunb");
function $c25f8dfad294842f$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c25f8dfad294842f$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $c25f8dfad294842f$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($dRMp3.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$c25f8dfad294842f$var$hasCycle(operationVariables) && $bCunb(false);
    var requestDescriptor = $c25f8dfad294842f$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $c25f8dfad294842f$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $c25f8dfad294842f$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $c25f8dfad294842f$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $dW07R(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $c25f8dfad294842f$var$createOperationDescriptor,
    createRequestDescriptor: $c25f8dfad294842f$var$createRequestDescriptor
};

});
parcelRegister("6hMsx", function(module, exports) {
'use strict';
function $4939eba11b38a7b6$var$deepFreeze(object) {
    if (!$4939eba11b38a7b6$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $4939eba11b38a7b6$var$deepFreeze(property);
    });
    return object;
}
function $4939eba11b38a7b6$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $4939eba11b38a7b6$var$deepFreeze;

});

parcelRegister("dW07R", function(module, exports) {
'use strict';

var $4gj9D = parcelRequire("4gj9D");
var $a250ca22be036fee$var$stableCopy = $4gj9D.stableCopy;

var $bCunb = parcelRequire("bCunb");
function $a250ca22be036fee$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $bCunb(false);
    return requestID + JSON.stringify($a250ca22be036fee$var$stableCopy(variables));
}
module.exports = $a250ca22be036fee$var$getRequestIdentifier;

});



parcelRegister("k4SaM", function(module, exports) {
"use strict";

var $DzIbC = parcelRequire("DzIbC");
var $e9de33fe39146e51$require$_asyncToGenerator = $DzIbC.default;

var $9AKzb = parcelRequire("9AKzb");
var $e9de33fe39146e51$var$observeFragment = $9AKzb.observeFragment;
function $e9de33fe39146e51$var$waitForFragmentData(_x, _x2, _x3) {
    return $e9de33fe39146e51$var$_waitForFragmentData.apply(this, arguments);
}
function $e9de33fe39146e51$var$_waitForFragmentData() {
    $e9de33fe39146e51$var$_waitForFragmentData = $e9de33fe39146e51$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $e9de33fe39146e51$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $e9de33fe39146e51$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $e9de33fe39146e51$var$waitForFragmentData
};

});


parcelRegister("5h5mW", function(module, exports) {
'use strict';

var $cvbom = parcelRequire("cvbom");
var $3d72b472ef2178ff$var$generateClientID = $cvbom.generateClientID;

var $3GmWb = parcelRequire("3GmWb");
var $3d72b472ef2178ff$var$getStableStorageKey = $3GmWb.getStableStorageKey;

var $57W7s = parcelRequire("57W7s");

var $dhkCT = parcelRequire("dhkCT");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
var $3d72b472ef2178ff$var$CONNECTION = 'connection';
var $3d72b472ef2178ff$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $3d72b472ef2178ff$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $dhkCT.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $3d72b472ef2178ff$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $3d72b472ef2178ff$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $3d72b472ef2178ff$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($3d72b472ef2178ff$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $3d72b472ef2178ff$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $3d72b472ef2178ff$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $3d72b472ef2178ff$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $3d72b472ef2178ff$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $3d72b472ef2178ff$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $3d72b472ef2178ff$var$getConnection(record, key, filters) {
    var handleKey = $57W7s($3d72b472ef2178ff$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $3d72b472ef2178ff$var$getConnectionID(recordID, key, filters) {
    var handleKey = $57W7s($3d72b472ef2178ff$var$CONNECTION, key, null);
    var storageKey = $3d72b472ef2178ff$var$getStableStorageKey(handleKey, filters);
    return $3d72b472ef2178ff$var$generateClientID(recordID, storageKey);
}
function $3d72b472ef2178ff$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $dhkCT.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $3d72b472ef2178ff$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $dhkCT.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $3d72b472ef2178ff$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $3d72b472ef2178ff$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $dhkCT.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $3d72b472ef2178ff$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $dhkCT.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $3d72b472ef2178ff$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $dhkCT.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($3d72b472ef2178ff$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $bCunb(false);
    var edgeID = $3d72b472ef2178ff$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $3d72b472ef2178ff$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $3d72b472ef2178ff$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $dhkCT.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $3d72b472ef2178ff$var$buildConnectionEdge,
    createEdge: $3d72b472ef2178ff$var$createEdge,
    deleteNode: $3d72b472ef2178ff$var$deleteNode,
    getConnection: $3d72b472ef2178ff$var$getConnection,
    getConnectionID: $3d72b472ef2178ff$var$getConnectionID,
    insertEdgeAfter: $3d72b472ef2178ff$var$insertEdgeAfter,
    insertEdgeBefore: $3d72b472ef2178ff$var$insertEdgeBefore,
    update: $3d72b472ef2178ff$var$update
};

});
parcelRegister("cvbom", function(module, exports) {
'use strict';

var $dRMp3 = parcelRequire("dRMp3");

var $9Dq7V = parcelRequire("9Dq7V");
var $91a13777089fa1a7$var$intern = $9Dq7V.intern;
var $91a13777089fa1a7$var$PREFIX = 'client:';
function $91a13777089fa1a7$var$generateClientID(id, storageKey, index) {
    var internedId = $dRMp3.STRING_INTERN_LEVEL <= 0 ? id : $91a13777089fa1a7$var$intern(id, $dRMp3.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($91a13777089fa1a7$var$PREFIX) !== 0) key = $91a13777089fa1a7$var$PREFIX + key;
    return key;
}
function $91a13777089fa1a7$var$isClientID(id) {
    return id.indexOf($91a13777089fa1a7$var$PREFIX) === 0;
}
var $91a13777089fa1a7$var$localID = 0;
function $91a13777089fa1a7$var$generateUniqueClientID() {
    return "".concat($91a13777089fa1a7$var$PREFIX, "local:").concat($91a13777089fa1a7$var$localID++);
}
function $91a13777089fa1a7$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($91a13777089fa1a7$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $91a13777089fa1a7$var$generateClientID,
    generateClientObjectClientID: $91a13777089fa1a7$var$generateClientObjectClientID,
    generateUniqueClientID: $91a13777089fa1a7$var$generateUniqueClientID,
    isClientID: $91a13777089fa1a7$var$isClientID
};

});
parcelRegister("9Dq7V", function(module, exports) {
'use strict';
var $703c05cbb2cf7f2e$var$internTable = new Map();
var $703c05cbb2cf7f2e$var$nextIndex = 1;
var $703c05cbb2cf7f2e$var$digits = $703c05cbb2cf7f2e$var$initDigitTable();
var $703c05cbb2cf7f2e$var$INTERN_PREFIX = '\t';
var $703c05cbb2cf7f2e$var$ESCAPE_PREFIX = '\v';
function $703c05cbb2cf7f2e$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $703c05cbb2cf7f2e$var$escape(str) {
    if (str[0] === $703c05cbb2cf7f2e$var$INTERN_PREFIX && $703c05cbb2cf7f2e$var$digits.has(str[1]) || str[0] === $703c05cbb2cf7f2e$var$ESCAPE_PREFIX) return $703c05cbb2cf7f2e$var$ESCAPE_PREFIX + str;
    return str;
}
function $703c05cbb2cf7f2e$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $703c05cbb2cf7f2e$var$escape(str);
    var internedString = $703c05cbb2cf7f2e$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $703c05cbb2cf7f2e$var$INTERN_PREFIX + $703c05cbb2cf7f2e$var$nextIndex++;
    $703c05cbb2cf7f2e$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $703c05cbb2cf7f2e$var$intern
};

});


parcelRegister("dhkCT", function(module, exports) {
'use strict';
var $9aacdcddcbacd1a9$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $9aacdcddcbacd1a9$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $9aacdcddcbacd1a9$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $9aacdcddcbacd1a9$var$config = newConfig;
    },
    get: function get() {
        return $9aacdcddcbacd1a9$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $9aacdcddcbacd1a9$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $9aacdcddcbacd1a9$var$ConnectionInterface;

});


parcelRegister("9QN3y", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $72bf05f64644f200$var$_interopRequireDefault = $j3tQw.default;

var $72bf05f64644f200$var$_createForOfIteratorHelper2 = $72bf05f64644f200$var$_interopRequireDefault((parcelRequire("cJrco")));

var $5h5mW = parcelRequire("5h5mW");

var $dhkCT = parcelRequire("dhkCT");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
var $72bf05f64644f200$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $72bf05f64644f200$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $bCunb(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $72bf05f64644f200$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $5h5mW.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $72bf05f64644f200$var$AppendEdgeHandler = {
    update: $72bf05f64644f200$var$edgeUpdater($5h5mW.insertEdgeAfter)
};
var $72bf05f64644f200$var$PrependEdgeHandler = {
    update: $72bf05f64644f200$var$edgeUpdater($5h5mW.insertEdgeBefore)
};
var $72bf05f64644f200$var$AppendNodeHandler = {
    update: $72bf05f64644f200$var$nodeUpdater($5h5mW.insertEdgeAfter)
};
var $72bf05f64644f200$var$PrependNodeHandler = {
    update: $72bf05f64644f200$var$nodeUpdater($5h5mW.insertEdgeBefore)
};
function $72bf05f64644f200$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $bCunb(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $dhkCT.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $72bf05f64644f200$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $72bf05f64644f200$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $5h5mW.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $bCunb(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $72bf05f64644f200$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $bCunb(false);
        !(edgeTypeName != null) && $bCunb(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $dhkCT.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $72bf05f64644f200$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $72bf05f64644f200$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $5h5mW.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $bCunb(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $72bf05f64644f200$var$AppendEdgeHandler,
    DeleteRecordHandler: $72bf05f64644f200$var$DeleteRecordHandler,
    PrependEdgeHandler: $72bf05f64644f200$var$PrependEdgeHandler,
    AppendNodeHandler: $72bf05f64644f200$var$AppendNodeHandler,
    PrependNodeHandler: $72bf05f64644f200$var$PrependNodeHandler,
    DeleteEdgeHandler: $72bf05f64644f200$var$DeleteEdgeHandler
};

});

parcelRegister("8S8Xr", function(module, exports) {
'use strict';

var $5h5mW = parcelRequire("5h5mW");

var $9QN3y = parcelRequire("9QN3y");

var $bCunb = parcelRequire("bCunb");
function $675a50ac65689106$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $5h5mW;
        case 'deleteRecord':
            return $9QN3y.DeleteRecordHandler;
        case 'deleteEdge':
            return $9QN3y.DeleteEdgeHandler;
        case 'appendEdge':
            return $9QN3y.AppendEdgeHandler;
        case 'prependEdge':
            return $9QN3y.PrependEdgeHandler;
        case 'appendNode':
            return $9QN3y.AppendNodeHandler;
        case 'prependNode':
            return $9QN3y.PrependNodeHandler;
    }
    $bCunb(false);
}
module.exports = $675a50ac65689106$var$RelayDefaultHandlerProvider;

});

parcelRegister("7EuYb", function(module, exports) {
'use strict';

var $ixIqX = parcelRequire("ixIqX");
var $59244ac81cbfcdd7$var$getRequest = $ixIqX.getRequest;

var $2XJ33 = parcelRequire("2XJ33");

var $gGDWH = parcelRequire("gGDWH");
var $59244ac81cbfcdd7$var$createOperationDescriptor = $gGDWH.createOperationDescriptor;

var $3tVxJ = parcelRequire("3tVxJ");

var $bCunb = parcelRequire("bCunb");
function $59244ac81cbfcdd7$var$applyOptimisticMutation(environment, config) {
    !$2XJ33(environment) && $bCunb(false);
    var mutation = $59244ac81cbfcdd7$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $59244ac81cbfcdd7$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $3tVxJ.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $59244ac81cbfcdd7$var$applyOptimisticMutation;

});
parcelRegister("2XJ33", function(module, exports) {
'use strict';
function $2284091715c4c380$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $2284091715c4c380$var$isRelayModernEnvironment;

});

parcelRegister("3tVxJ", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $2890b767885f35e4$var$_interopRequireDefault = $j3tQw.default;

var $2890b767885f35e4$var$_createForOfIteratorHelper2 = $2890b767885f35e4$var$_interopRequireDefault((parcelRequire("cJrco")));

var $5h5mW = parcelRequire("5h5mW");
parcelRequire("fLDY5");
var $2890b767885f35e4$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $2890b767885f35e4$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $2890b767885f35e4$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $2890b767885f35e4$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $2890b767885f35e4$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $2890b767885f35e4$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $2890b767885f35e4$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $2890b767885f35e4$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $2890b767885f35e4$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $2890b767885f35e4$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $2890b767885f35e4$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $5h5mW.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $5h5mW.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $5h5mW.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $5h5mW.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $2890b767885f35e4$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $2890b767885f35e4$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $2890b767885f35e4$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $2890b767885f35e4$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $2890b767885f35e4$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $2890b767885f35e4$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $5h5mW.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $5h5mW.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $2890b767885f35e4$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $2890b767885f35e4$var$MutationTypes,
    RangeOperations: $2890b767885f35e4$var$RangeOperations,
    convert: $2890b767885f35e4$var$convert
};

});


parcelRegister("jSv2R", function(module, exports) {
'use strict';
function $e78b24625311bdad$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $e78b24625311bdad$var$commitLocalUpdate;

});

parcelRegister("ih8Ks", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $d4e099c1346287b8$var$_interopRequireDefault = $j3tQw.default;

var $d4e099c1346287b8$var$_toConsumableArray2 = $d4e099c1346287b8$var$_interopRequireDefault((parcelRequire("6jwD6")));

var $ixIqX = parcelRequire("ixIqX");
var $d4e099c1346287b8$var$getRequest = $ixIqX.getRequest;

var $cvbom = parcelRequire("cvbom");
var $d4e099c1346287b8$var$generateUniqueClientID = $cvbom.generateUniqueClientID;

var $2XJ33 = parcelRequire("2XJ33");

var $gGDWH = parcelRequire("gGDWH");
var $d4e099c1346287b8$var$createOperationDescriptor = $gGDWH.createOperationDescriptor;

var $3tVxJ = parcelRequire("3tVxJ");
parcelRequire("clZ82");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $d4e099c1346287b8$var$commitMutation(environment, config) {
    !$2XJ33(environment) && $bCunb(false);
    var mutation = $d4e099c1346287b8$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $d4e099c1346287b8$var$createOperationDescriptor(mutation, variables, cacheConfig, $d4e099c1346287b8$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $3tVxJ.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $d4e099c1346287b8$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $d4e099c1346287b8$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $d4e099c1346287b8$var$commitMutation;

});
parcelRegister("clZ82", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $8fe6dd0f1cca3467$var$_interopRequireDefault = $j3tQw.default;

var $8fe6dd0f1cca3467$var$_objectSpread2 = $8fe6dd0f1cca3467$var$_interopRequireDefault((parcelRequire("MwqMq")));
parcelRequire("fLDY5");
var $8fe6dd0f1cca3467$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8fe6dd0f1cca3467$var$validateMutation = function validateMutation() {};
var $8fe6dd0f1cca3467$var$addFieldToDiff, $8fe6dd0f1cca3467$var$validateSelections, $8fe6dd0f1cca3467$var$validateSelection, $8fe6dd0f1cca3467$var$validateModuleImport, $8fe6dd0f1cca3467$var$validateAbstractKey, $8fe6dd0f1cca3467$var$validateField, $8fe6dd0f1cca3467$var$validateOptimisticResponse;
module.exports = $8fe6dd0f1cca3467$var$validateMutation;

});


parcelRegister("aNn02", function(module, exports) {
'use strict';

var $7HWZR = parcelRequire("7HWZR");

var $6No8G = parcelRequire("6No8G");
var $7dc0523960186870$var$convertFetch = $6No8G.convertFetch;

var $bCunb = parcelRequire("bCunb");
function $7dc0523960186870$var$create(fetchFn, subscribe) {
    var observeFetch = $7dc0523960186870$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $7HWZR(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $bCunb(false);
            !!uploadables && $bCunb(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $bCunb(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $7dc0523960186870$var$create
};

});
parcelRegister("7HWZR", function(module, exports) {
'use strict';
parcelRequire("lPzB2");
parcelRequire("fLDY5");
var $59ca501b8ed7b327$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $59ca501b8ed7b327$var$debugCache = $59ca501b8ed7b327$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $59ca501b8ed7b327$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$59ca501b8ed7b327$var$debugCache.has(providerFunction)) {
                $59ca501b8ed7b327$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $59ca501b8ed7b327$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$59ca501b8ed7b327$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $59ca501b8ed7b327$var$withProvidedVariables;

});

parcelRegister("6No8G", function(module, exports) {
'use strict';

var $8oIvB = parcelRequire("8oIvB");
function $4f2a0b309c77d531$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $8oIvB.create(function(sink) {
            return sink.error(result);
        });
        return $8oIvB.from(result);
    };
}
module.exports = {
    convertFetch: $4f2a0b309c77d531$var$convertFetch
};

});


parcelRegister("8DZga", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $64b17c2e531baf4e$var$_interopRequireDefault = $j3tQw.default;

var $64b17c2e531baf4e$var$_objectSpread2 = $64b17c2e531baf4e$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $4gj9D = parcelRequire("4gj9D");
var $64b17c2e531baf4e$var$stableCopy = $4gj9D.stableCopy;

var $bCunb = parcelRequire("bCunb");
var $64b17c2e531baf4e$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $bCunb(false);
        !(ttl > 0) && $bCunb(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $64b17c2e531baf4e$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$64b17c2e531baf4e$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $64b17c2e531baf4e$var$_objectSpread2["default"])((0, $64b17c2e531baf4e$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $64b17c2e531baf4e$var$_objectSpread2["default"])((0, $64b17c2e531baf4e$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $64b17c2e531baf4e$var$_objectSpread2["default"])((0, $64b17c2e531baf4e$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $64b17c2e531baf4e$var$_objectSpread2["default"])((0, $64b17c2e531baf4e$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $64b17c2e531baf4e$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $64b17c2e531baf4e$var$getCacheKey(queryID, variables) {
    return JSON.stringify($64b17c2e531baf4e$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $64b17c2e531baf4e$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $64b17c2e531baf4e$var$RelayQueryResponseCache;

});

parcelRegister("7Invo", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $59dee01dcda2c103$var$_interopRequireDefault = $j3tQw.default;

var $59dee01dcda2c103$var$_objectSpread2 = $59dee01dcda2c103$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $8oIvB = parcelRequire("8oIvB");

var $gGDWH = parcelRequire("gGDWH");
var $59dee01dcda2c103$var$createOperationDescriptor = $gGDWH.createOperationDescriptor;

var $lz2bc = parcelRequire("lz2bc");
var $59dee01dcda2c103$var$handlePotentialSnapshotErrors = $lz2bc.handlePotentialSnapshotErrors;

var $dFQpN = parcelRequire("dFQpN");

var $ixIqX = parcelRequire("ixIqX");
var $59dee01dcda2c103$var$getRequest = $ixIqX.getRequest;

var $bCunb = parcelRequire("bCunb");
function $59dee01dcda2c103$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $59dee01dcda2c103$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $bCunb(false);
    var networkCacheConfig = (0, $59dee01dcda2c103$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $59dee01dcda2c103$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $59dee01dcda2c103$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $59dee01dcda2c103$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $8oIvB.from(environment.lookup(operation.fragment)).map(readData);
            return $59dee01dcda2c103$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $59dee01dcda2c103$var$getNetworkObservable(environment, operation) {
    return $dFQpN.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $59dee01dcda2c103$var$fetchQuery;

});

parcelRegister("4Qc5e", function(module, exports) {
'use strict';

var $gGDWH = parcelRequire("gGDWH");
var $386564451008ec7c$var$createOperationDescriptor = $gGDWH.createOperationDescriptor;

var $ixIqX = parcelRequire("ixIqX");
var $386564451008ec7c$var$getRequest = $ixIqX.getRequest;
function $386564451008ec7c$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $386564451008ec7c$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $386564451008ec7c$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $386564451008ec7c$var$fetchQuery_DEPRECATED;

});

parcelRegister("e5Z6E", function(module, exports) {
'use strict';
var $a430eec469e6bd9c$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $a430eec469e6bd9c$var$preloadableQueryRegistry = new $a430eec469e6bd9c$var$PreloadableQueryRegistry();
module.exports = $a430eec469e6bd9c$var$preloadableQueryRegistry;

});

parcelRegister("7d53m", function(module, exports) {
'use strict';

var $2KJnK = parcelRequire("2KJnK");
parcelRequire("fLDY5");
function $53fdaac815013c3f$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $2KJnK(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $53fdaac815013c3f$var$createFragmentSpecResolver;

});
parcelRegister("2KJnK", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $20131494588977dc$var$_interopRequireDefault = $j3tQw.default;

var $20131494588977dc$var$_objectSpread2 = $20131494588977dc$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $20131494588977dc$var$_defineProperty2 = $20131494588977dc$var$_interopRequireDefault((parcelRequire("geBXM")));

var $6TOAe = parcelRequire("6TOAe");

var $lz2bc = parcelRequire("lz2bc");
var $20131494588977dc$var$handlePotentialSnapshotErrors = $lz2bc.handlePotentialSnapshotErrors;

var $lJXBf = parcelRequire("lJXBf");

var $lln7q = parcelRequire("lln7q");

var $dRMp3 = parcelRequire("dRMp3");

var $gGDWH = parcelRequire("gGDWH");
var $20131494588977dc$var$createRequestDescriptor = $gGDWH.createRequestDescriptor;

var $kPRSQ = parcelRequire("kPRSQ");
var $20131494588977dc$var$areEqualSelectors = $kPRSQ.areEqualSelectors, $20131494588977dc$var$createReaderSelector = $kPRSQ.createReaderSelector, $20131494588977dc$var$getSelectorsFromObject = $kPRSQ.getSelectorsFromObject;

var $lPzB2 = parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
var $20131494588977dc$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $20131494588977dc$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $20131494588977dc$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $20131494588977dc$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$lJXBf(_nextItem, prevItem)) {
                        nextData = nextData || (0, $20131494588977dc$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($dRMp3.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $20131494588977dc$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $20131494588977dc$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $20131494588977dc$var$SelectorListResolver) && $bCunb(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $20131494588977dc$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $20131494588977dc$var$SelectorResolver) && $bCunb(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $20131494588977dc$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $20131494588977dc$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($dRMp3.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $6TOAe(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $20131494588977dc$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $20131494588977dc$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $lln7q(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($lPzB2(variables, this._selector.variables)) return;
        var requestDescriptor = $20131494588977dc$var$createRequestDescriptor(request, variables);
        var selector = $20131494588977dc$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $20131494588977dc$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $20131494588977dc$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($20131494588977dc$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $20131494588977dc$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $20131494588977dc$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $20131494588977dc$var$RelayModernFragmentSpecResolver;

});
parcelRegister("6TOAe", function(module, exports) {
'use strict';

var $dFQpN = parcelRequire("dFQpN");
var $505f1df1e7c93428$var$getPromiseForActiveRequest = $dFQpN.getPromiseForActiveRequest;
function $505f1df1e7c93428$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $505f1df1e7c93428$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $505f1df1e7c93428$var$getPendingOperationsForFragment;

});

parcelRegister("lJXBf", function(module, exports) {
'use strict';
function $fd3c0833fd604a80$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $fd3c0833fd604a80$var$isScalarAndEqual;

});

parcelRegister("lln7q", function(module, exports) {
'use strict';
function $f89d7e0b024393eb$var$recycleNodesInto(prevData, nextData) {
    return $f89d7e0b024393eb$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $f89d7e0b024393eb$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $f89d7e0b024393eb$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $f89d7e0b024393eb$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $f89d7e0b024393eb$var$recycleNodesInto;

});



parcelRegister("bKCQT", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");
var $88e220c8da501308$var$relayContext;
var $88e220c8da501308$var$firstReact;
function $88e220c8da501308$var$createRelayContext(react) {
    if (!$88e220c8da501308$var$relayContext) {
        $88e220c8da501308$var$relayContext = react.createContext(null);
        $88e220c8da501308$var$firstReact = react;
    }
    !(react === $88e220c8da501308$var$firstReact) && $bCunb(false);
    return $88e220c8da501308$var$relayContext;
}
module.exports = $88e220c8da501308$var$createRelayContext;

});

parcelRegister("29A6b", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");
var $19186c7bcb381a02$var$relayLoggingContext;
var $19186c7bcb381a02$var$firstReact;
function $19186c7bcb381a02$var$createRelayLoggingContext(react) {
    if (!$19186c7bcb381a02$var$relayLoggingContext) {
        $19186c7bcb381a02$var$relayLoggingContext = react.createContext(null);
        $19186c7bcb381a02$var$firstReact = react;
    }
    !(react === $19186c7bcb381a02$var$firstReact) && $bCunb(false);
    return $19186c7bcb381a02$var$relayLoggingContext;
}
module.exports = $19186c7bcb381a02$var$createRelayLoggingContext;

});

parcelRegister("8rY4t", function(module, exports) {
'use strict';
var $626f713f7bf3a651$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $626f713f7bf3a651$var$suspenseSentinel() {
    return $626f713f7bf3a651$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $626f713f7bf3a651$var$isSuspenseSentinel(value) {
    return value === $626f713f7bf3a651$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $626f713f7bf3a651$var$isSuspenseSentinel,
    suspenseSentinel: $626f713f7bf3a651$var$suspenseSentinel
};

});

parcelRegister("cojLE", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $90570f5be3639ddb$var$_interopRequireDefault = $j3tQw.default;

var $90570f5be3639ddb$var$_objectSpread2 = $90570f5be3639ddb$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $90570f5be3639ddb$var$_RelayModernRecord = $90570f5be3639ddb$var$_interopRequireDefault((parcelRequire("drWdC")));

var $90570f5be3639ddb$var$_RelayRecordSource = $90570f5be3639ddb$var$_interopRequireDefault((parcelRequire("4OW3Y")));

var $90570f5be3639ddb$var$_RelayResponseNormalizer = $90570f5be3639ddb$var$_interopRequireDefault((parcelRequire("aPj4D")));
function $90570f5be3639ddb$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $90570f5be3639ddb$var$_RelayRecordSource["default"].create();
    var record = $90570f5be3639ddb$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $90570f5be3639ddb$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $90570f5be3639ddb$var$_objectSpread2["default"])((0, $90570f5be3639ddb$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $90570f5be3639ddb$var$normalizeResponse;

});
parcelRegister("drWdC", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $9caaf502b4fdb0f4$var$_interopRequireDefault = $j3tQw.default;

var $9caaf502b4fdb0f4$var$_defineProperty2 = $9caaf502b4fdb0f4$var$_interopRequireDefault((parcelRequire("geBXM")));

var $9caaf502b4fdb0f4$var$_objectWithoutPropertiesLoose2 = $9caaf502b4fdb0f4$var$_interopRequireDefault((parcelRequire("6Mx0E")));

var $9caaf502b4fdb0f4$var$_toPropertyKey2 = $9caaf502b4fdb0f4$var$_interopRequireDefault((parcelRequire("gvBRV")));

var $9caaf502b4fdb0f4$var$_objectSpread2 = $9caaf502b4fdb0f4$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $6hMsx = parcelRequire("6hMsx");

var $cvbom = parcelRequire("cvbom");
var $9caaf502b4fdb0f4$var$generateClientObjectClientID = $cvbom.generateClientObjectClientID, $9caaf502b4fdb0f4$var$isClientID = $cvbom.isClientID;

var $8rY4t = parcelRequire("8rY4t");
var $9caaf502b4fdb0f4$var$isSuspenseSentinel = $8rY4t.isSuspenseSentinel;

var $3GmWb = parcelRequire("3GmWb");
var $9caaf502b4fdb0f4$var$ACTOR_IDENTIFIER_KEY = $3GmWb.ACTOR_IDENTIFIER_KEY, $9caaf502b4fdb0f4$var$ERRORS_KEY = $3GmWb.ERRORS_KEY, $9caaf502b4fdb0f4$var$ID_KEY = $3GmWb.ID_KEY, $9caaf502b4fdb0f4$var$INVALIDATED_AT_KEY = $3GmWb.INVALIDATED_AT_KEY, $9caaf502b4fdb0f4$var$REF_KEY = $3GmWb.REF_KEY, $9caaf502b4fdb0f4$var$REFS_KEY = $3GmWb.REFS_KEY, $9caaf502b4fdb0f4$var$RELAY_RESOLVER_VALUE_KEY = $3GmWb.RELAY_RESOLVER_VALUE_KEY, $9caaf502b4fdb0f4$var$ROOT_ID = $3GmWb.ROOT_ID, $9caaf502b4fdb0f4$var$TYPENAME_KEY = $3GmWb.TYPENAME_KEY;

var $lPzB2 = parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $9caaf502b4fdb0f4$var$clone(record) {
    return (0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])({}, record);
}
function $9caaf502b4fdb0f4$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $9caaf502b4fdb0f4$var$ID_KEY && key !== $9caaf502b4fdb0f4$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $9caaf502b4fdb0f4$var$create(dataID, typeName) {
    var record = {};
    record[$9caaf502b4fdb0f4$var$ID_KEY] = dataID;
    record[$9caaf502b4fdb0f4$var$TYPENAME_KEY] = typeName;
    return record;
}
function $9caaf502b4fdb0f4$var$fromObject(json) {
    return json;
}
function $9caaf502b4fdb0f4$var$getDataID(record) {
    return record[$9caaf502b4fdb0f4$var$ID_KEY];
}
function $9caaf502b4fdb0f4$var$getFields(record) {
    if ($9caaf502b4fdb0f4$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $9caaf502b4fdb0f4$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $9caaf502b4fdb0f4$var$getType(record) {
    return record[$9caaf502b4fdb0f4$var$TYPENAME_KEY];
}
function $9caaf502b4fdb0f4$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$9caaf502b4fdb0f4$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $9caaf502b4fdb0f4$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($9caaf502b4fdb0f4$var$REF_KEY) && !value.hasOwnProperty($9caaf502b4fdb0f4$var$REFS_KEY)) && $bCunb(false);
    return value;
}
function $9caaf502b4fdb0f4$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $9caaf502b4fdb0f4$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$9caaf502b4fdb0f4$var$REF_KEY] === 'string') && $bCunb(false);
    return link[$9caaf502b4fdb0f4$var$REF_KEY];
}
function $9caaf502b4fdb0f4$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$9caaf502b4fdb0f4$var$REF_KEY] === 'string';
}
function $9caaf502b4fdb0f4$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$9caaf502b4fdb0f4$var$REFS_KEY])) && $bCunb(false);
    return links[$9caaf502b4fdb0f4$var$REFS_KEY];
}
function $9caaf502b4fdb0f4$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$9caaf502b4fdb0f4$var$REFS_KEY]) && links[$9caaf502b4fdb0f4$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $9caaf502b4fdb0f4$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$9caaf502b4fdb0f4$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $9caaf502b4fdb0f4$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$9caaf502b4fdb0f4$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$9caaf502b4fdb0f4$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$lPzB2(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $9caaf502b4fdb0f4$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($lPzB2(prevValue, nextValue) && $lPzB2(prevErrors, nextErrors)) continue;
            updated = (0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$9caaf502b4fdb0f4$var$ERRORS_KEY] = (0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $9caaf502b4fdb0f4$var$setValue(updated, _storageKey2, nextValue);
        $9caaf502b4fdb0f4$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $9caaf502b4fdb0f4$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($9caaf502b4fdb0f4$var$ERRORS_KEY in record1 || $9caaf502b4fdb0f4$var$ERRORS_KEY in record2) {
        var errors1 = record1[$9caaf502b4fdb0f4$var$ERRORS_KEY], fields1 = (0, $9caaf502b4fdb0f4$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $9caaf502b4fdb0f4$var$ERRORS_KEY
        ].map($9caaf502b4fdb0f4$var$_toPropertyKey2["default"]));
        var errors2 = record2[$9caaf502b4fdb0f4$var$ERRORS_KEY], fields2 = (0, $9caaf502b4fdb0f4$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $9caaf502b4fdb0f4$var$ERRORS_KEY
        ].map($9caaf502b4fdb0f4$var$_toPropertyKey2["default"]));
        var updated = (0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])((0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$9caaf502b4fdb0f4$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])((0, $9caaf502b4fdb0f4$var$_objectSpread2["default"])({}, record1), record2);
}
function $9caaf502b4fdb0f4$var$freeze(record) {
    $6hMsx(record);
}
function $9caaf502b4fdb0f4$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$9caaf502b4fdb0f4$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$9caaf502b4fdb0f4$var$ERRORS_KEY] = (0, $9caaf502b4fdb0f4$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$9caaf502b4fdb0f4$var$ERRORS_KEY];
        }
    }
}
function $9caaf502b4fdb0f4$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $9caaf502b4fdb0f4$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$9caaf502b4fdb0f4$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $9caaf502b4fdb0f4$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$9caaf502b4fdb0f4$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $9caaf502b4fdb0f4$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$9caaf502b4fdb0f4$var$REF_KEY] = linkedID;
    link[$9caaf502b4fdb0f4$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $9caaf502b4fdb0f4$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$9caaf502b4fdb0f4$var$REF_KEY] === 'string' && link[$9caaf502b4fdb0f4$var$ACTOR_IDENTIFIER_KEY] != null) && $bCunb(false);
    return [
        link[$9caaf502b4fdb0f4$var$ACTOR_IDENTIFIER_KEY],
        link[$9caaf502b4fdb0f4$var$REF_KEY]
    ];
}
function $9caaf502b4fdb0f4$var$getResolverLinkedRecordID(record, typeName) {
    var id = $9caaf502b4fdb0f4$var$getValue(record, $9caaf502b4fdb0f4$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $9caaf502b4fdb0f4$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $bCunb(false);
    return $9caaf502b4fdb0f4$var$generateClientObjectClientID(typeName, id);
}
function $9caaf502b4fdb0f4$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $9caaf502b4fdb0f4$var$getValue(record, $9caaf502b4fdb0f4$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $9caaf502b4fdb0f4$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $bCunb(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $bCunb(false);
        return $9caaf502b4fdb0f4$var$generateClientObjectClientID(typeName, id);
    });
}
function $9caaf502b4fdb0f4$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $9caaf502b4fdb0f4$var$clone,
    copyFields: $9caaf502b4fdb0f4$var$copyFields,
    create: $9caaf502b4fdb0f4$var$create,
    freeze: $9caaf502b4fdb0f4$var$freeze,
    fromObject: $9caaf502b4fdb0f4$var$fromObject,
    getDataID: $9caaf502b4fdb0f4$var$getDataID,
    getErrors: $9caaf502b4fdb0f4$var$getErrors,
    getFields: $9caaf502b4fdb0f4$var$getFields,
    getInvalidationEpoch: $9caaf502b4fdb0f4$var$getInvalidationEpoch,
    getLinkedRecordID: $9caaf502b4fdb0f4$var$getLinkedRecordID,
    getLinkedRecordIDs: $9caaf502b4fdb0f4$var$getLinkedRecordIDs,
    getType: $9caaf502b4fdb0f4$var$getType,
    getValue: $9caaf502b4fdb0f4$var$getValue,
    hasValue: $9caaf502b4fdb0f4$var$hasValue,
    hasLinkedRecordID: $9caaf502b4fdb0f4$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $9caaf502b4fdb0f4$var$hasLinkedRecordIDs,
    merge: $9caaf502b4fdb0f4$var$merge,
    setErrors: $9caaf502b4fdb0f4$var$setErrors,
    setValue: $9caaf502b4fdb0f4$var$setValue,
    setLinkedRecordID: $9caaf502b4fdb0f4$var$setLinkedRecordID,
    setLinkedRecordIDs: $9caaf502b4fdb0f4$var$setLinkedRecordIDs,
    update: $9caaf502b4fdb0f4$var$update,
    getActorLinkedRecordID: $9caaf502b4fdb0f4$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $9caaf502b4fdb0f4$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $9caaf502b4fdb0f4$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $9caaf502b4fdb0f4$var$getResolverLinkedRecordIDs,
    toJSON: $9caaf502b4fdb0f4$var$toJSON
};

});
parcelRegister("6Mx0E", function(module, exports) {
function $4f00d4c25cc97d4e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $4f00d4c25cc97d4e$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4OW3Y", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $3828df0a2ad6854a$var$_interopRequireDefault = $j3tQw.default;

var $3828df0a2ad6854a$var$_createForOfIteratorHelper2 = $3828df0a2ad6854a$var$_interopRequireDefault((parcelRequire("cJrco")));

var $drWdC = parcelRequire("drWdC");

var $jvs2t = parcelRequire("jvs2t");
var $3828df0a2ad6854a$var$EXISTENT = $jvs2t.EXISTENT, $3828df0a2ad6854a$var$NONEXISTENT = $jvs2t.NONEXISTENT, $3828df0a2ad6854a$var$UNKNOWN = $jvs2t.UNKNOWN;
var $3828df0a2ad6854a$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $drWdC.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $3828df0a2ad6854a$var$UNKNOWN;
        return this._records.get(dataID) == null ? $3828df0a2ad6854a$var$NONEXISTENT : $3828df0a2ad6854a$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $3828df0a2ad6854a$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $drWdC.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $3828df0a2ad6854a$var$RelayRecordSource;

});
parcelRegister("jvs2t", function(module, exports) {
'use strict';
var $e336a9892a940aed$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $e336a9892a940aed$var$RelayRecordState;

});


parcelRegister("aPj4D", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $7e1d766ebf1381a0$var$_interopRequireDefault = $j3tQw.default;

var $7e1d766ebf1381a0$var$_createForOfIteratorHelper2 = $7e1d766ebf1381a0$var$_interopRequireDefault((parcelRequire("cJrco")));

var $7e1d766ebf1381a0$var$_toConsumableArray2 = $7e1d766ebf1381a0$var$_interopRequireDefault((parcelRequire("6jwD6")));

var $h04uD = parcelRequire("h04uD");
var $7e1d766ebf1381a0$var$ACTOR_IDENTIFIER_FIELD_NAME = $h04uD.ACTOR_IDENTIFIER_FIELD_NAME, $7e1d766ebf1381a0$var$getActorIdentifierFromPayload = $h04uD.getActorIdentifierFromPayload;

var $dRMp3 = parcelRequire("dRMp3");

var $cvbom = parcelRequire("cvbom");
var $7e1d766ebf1381a0$var$generateClientID = $cvbom.generateClientID, $7e1d766ebf1381a0$var$isClientID = $cvbom.isClientID;

var $1S69g = parcelRequire("1S69g");
var $7e1d766ebf1381a0$var$getLocalVariables = $1S69g.getLocalVariables;

var $9KRTy = parcelRequire("9KRTy");
var $7e1d766ebf1381a0$var$buildErrorTrie = $9KRTy.buildErrorTrie, $7e1d766ebf1381a0$var$getErrorsByKey = $9KRTy.getErrorsByKey, $7e1d766ebf1381a0$var$getNestedErrorTrieByKey = $9KRTy.getNestedErrorTrieByKey;

var $drWdC = parcelRequire("drWdC");

var $kPRSQ = parcelRequire("kPRSQ");
var $7e1d766ebf1381a0$var$createNormalizationSelector = $kPRSQ.createNormalizationSelector;

var $3GmWb = parcelRequire("3GmWb");
var $7e1d766ebf1381a0$var$ROOT_ID = $3GmWb.ROOT_ID, $7e1d766ebf1381a0$var$TYPENAME_KEY = $3GmWb.TYPENAME_KEY, $7e1d766ebf1381a0$var$getArgumentValues = $3GmWb.getArgumentValues, $7e1d766ebf1381a0$var$getHandleStorageKey = $3GmWb.getHandleStorageKey, $7e1d766ebf1381a0$var$getModuleComponentKey = $3GmWb.getModuleComponentKey, $7e1d766ebf1381a0$var$getModuleOperationKey = $3GmWb.getModuleOperationKey, $7e1d766ebf1381a0$var$getStorageKey = $3GmWb.getStorageKey;

var $aojLn = parcelRequire("aojLn");
var $7e1d766ebf1381a0$var$TYPE_SCHEMA_TYPE = $aojLn.TYPE_SCHEMA_TYPE, $7e1d766ebf1381a0$var$generateTypeID = $aojLn.generateTypeID;
parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $7e1d766ebf1381a0$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $7e1d766ebf1381a0$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $7e1d766ebf1381a0$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $7e1d766ebf1381a0$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $bCunb(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $7e1d766ebf1381a0$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $7e1d766ebf1381a0$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $7e1d766ebf1381a0$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $drWdC.create(typeID, $7e1d766ebf1381a0$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $drWdC.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bCunb(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$7e1d766ebf1381a0$var$TYPENAME_KEY];
        !(typeName != null) && $bCunb(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $7e1d766ebf1381a0$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $drWdC.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = $drWdC.getType(record);
                        var typeID = $7e1d766ebf1381a0$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $drWdC.create(typeID, $7e1d766ebf1381a0$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $drWdC.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = $drWdC.getType(record);
                    var _typeID = $7e1d766ebf1381a0$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $drWdC.create(_typeID, $7e1d766ebf1381a0$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $drWdC.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $7e1d766ebf1381a0$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $7e1d766ebf1381a0$var$getStorageKey(selection, this._variables);
                    var handleKey = $7e1d766ebf1381a0$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $drWdC.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $7e1d766ebf1381a0$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $bCunb(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $7e1d766ebf1381a0$var$_toConsumableArray2["default"])(this._path),
            selector: $7e1d766ebf1381a0$var$createNormalizationSelector(defer, $drWdC.getDataID(record), this._variables),
            typeName: $drWdC.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $7e1d766ebf1381a0$var$_toConsumableArray2["default"])(this._path),
            parentID: $drWdC.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $bCunb(false);
        var typeName = $drWdC.getType(record);
        var componentKey = $7e1d766ebf1381a0$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $drWdC.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $7e1d766ebf1381a0$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $drWdC.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $drWdC.getDataID(record),
            operationReference: operationReference,
            path: (0, $7e1d766ebf1381a0$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $bCunb(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $7e1d766ebf1381a0$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $dRMp3.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $drWdC.setLinkedRecordIDs(record, storageKey, []);
                else $drWdC.setValue(record, storageKey, []);
            } else $drWdC.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $7e1d766ebf1381a0$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $drWdC.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $drWdC.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $7e1d766ebf1381a0$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $bCunb(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $bCunb(false);
        var responseKey = field.alias || field.name;
        var storageKey = $7e1d766ebf1381a0$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $drWdC.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $7e1d766ebf1381a0$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $drWdC.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $drWdC.getLinkedRecordID(record, storageKey) || $7e1d766ebf1381a0$var$generateClientID($drWdC.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $bCunb(false);
        $drWdC.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $7e1d766ebf1381a0$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $bCunb(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $drWdC.getLinkedRecordID(record, storageKey) || $7e1d766ebf1381a0$var$generateClientID($drWdC.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $bCunb(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($drWdC.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $drWdC.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $drWdC.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $bCunb(false);
        var prevIDs = $drWdC.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $7e1d766ebf1381a0$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $bCunb(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $7e1d766ebf1381a0$var$generateClientID($drWdC.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $bCunb(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $drWdC.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $drWdC.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($dRMp3.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $drWdC.getDataID(record);
            var expected = $7e1d766ebf1381a0$var$isClientID(dataID) && dataID !== $7e1d766ebf1381a0$var$ROOT_ID || $drWdC.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: $drWdC.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $7e1d766ebf1381a0$var$normalize
};

});
parcelRegister("h04uD", function(module, exports) {
'use strict';
var $c605ebff7e0a67f4$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $4YW2I = parcelRequire("4YW2I");
var $c605ebff7e0a67f4$var$getActorIdentifier = $4YW2I.getActorIdentifier;
function $c605ebff7e0a67f4$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$c605ebff7e0a67f4$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $c605ebff7e0a67f4$var$getActorIdentifier(payload[$c605ebff7e0a67f4$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $c605ebff7e0a67f4$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $c605ebff7e0a67f4$var$getActorIdentifierFromPayload
};

});
parcelRegister("4YW2I", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");
var $3a09ca1e71d65665$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $3a09ca1e71d65665$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $3a09ca1e71d65665$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $bCunb(false);
}
module.exports = {
    assertInternalActorIdentifier: $3a09ca1e71d65665$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $3a09ca1e71d65665$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("9KRTy", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $71a2375fd8cb3a57$var$_interopRequireDefault = $j3tQw.default;

var $71a2375fd8cb3a57$var$_objectSpread2 = $71a2375fd8cb3a57$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $71a2375fd8cb3a57$var$_objectWithoutPropertiesLoose2 = $71a2375fd8cb3a57$var$_interopRequireDefault((parcelRequire("6Mx0E")));

var $71a2375fd8cb3a57$var$_createForOfIteratorHelper2 = $71a2375fd8cb3a57$var$_interopRequireDefault((parcelRequire("cJrco")));

var $71a2375fd8cb3a57$var$_toConsumableArray2 = $71a2375fd8cb3a57$var$_interopRequireDefault((parcelRequire("6jwD6")));
var $71a2375fd8cb3a57$var$_excluded = [
    "path",
    "locations"
];
var $71a2375fd8cb3a57$var$SELF = Symbol('$SELF');
function $71a2375fd8cb3a57$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $71a2375fd8cb3a57$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $71a2375fd8cb3a57$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $71a2375fd8cb3a57$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($71a2375fd8cb3a57$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $71a2375fd8cb3a57$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $71a2375fd8cb3a57$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $71a2375fd8cb3a57$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $71a2375fd8cb3a57$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $71a2375fd8cb3a57$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $71a2375fd8cb3a57$var$_toConsumableArray2["default"])(value));
            else $71a2375fd8cb3a57$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $71a2375fd8cb3a57$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $71a2375fd8cb3a57$var$_objectSpread2["default"])((0, $71a2375fd8cb3a57$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $71a2375fd8cb3a57$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $71a2375fd8cb3a57$var$SELF,
    buildErrorTrie: $71a2375fd8cb3a57$var$buildErrorTrie,
    getNestedErrorTrieByKey: $71a2375fd8cb3a57$var$getNestedErrorTrieByKey,
    getErrorsByKey: $71a2375fd8cb3a57$var$getErrorsByKey
};

});

parcelRegister("aojLn", function(module, exports) {
'use strict';
var $790b79d464eacc75$var$PREFIX = 'client:__type:';
var $790b79d464eacc75$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $790b79d464eacc75$var$generateTypeID(typeName) {
    return $790b79d464eacc75$var$PREFIX + typeName;
}
function $790b79d464eacc75$var$isTypeID(id) {
    return id.indexOf($790b79d464eacc75$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $790b79d464eacc75$var$generateTypeID,
    isTypeID: $790b79d464eacc75$var$isTypeID,
    TYPE_SCHEMA_TYPE: $790b79d464eacc75$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("1klMT", function(module, exports) {
'use strict';

var $ixIqX = parcelRequire("ixIqX");
var $0f788f4456a6b0c2$var$getInlineDataFragment = $ixIqX.getInlineDataFragment;

var $3GmWb = parcelRequire("3GmWb");
var $0f788f4456a6b0c2$var$FRAGMENTS_KEY = $3GmWb.FRAGMENTS_KEY;

var $bCunb = parcelRequire("bCunb");
function $0f788f4456a6b0c2$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $0f788f4456a6b0c2$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $bCunb(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$0f788f4456a6b0c2$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $bCunb(false);
    return inlineData;
}
module.exports = $0f788f4456a6b0c2$var$readInlineData;

});

parcelRegister("jfikN", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $e02da3da5eee201f$var$_interopRequireDefault = $j3tQw.default;

var $e02da3da5eee201f$var$_objectSpread2 = $e02da3da5eee201f$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $8S8Xr = parcelRequire("8S8Xr");

var $4YW2I = parcelRequire("4YW2I");
var $e02da3da5eee201f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $4YW2I.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $e02da3da5eee201f$var$assertInternalActorIdentifier = $4YW2I.assertInternalActorIdentifier;

var $8oIvB = parcelRequire("8oIvB");

var $fMLhA = parcelRequire("fMLhA");

var $5ppYm = parcelRequire("5ppYm");

var $kEOyy = parcelRequire("kEOyy");

var $19y06 = parcelRequire("19y06");

var $c3FWH = parcelRequire("c3FWH");

var $cojLE = parcelRequire("cojLE");

var $hmLk8 = parcelRequire("hmLk8");

var $6h5qO = parcelRequire("6h5qO");

var $2ofgG = parcelRequire("2ofgG");

var $4OW3Y = parcelRequire("4OW3Y");
parcelRequire("bCunb");
var $e02da3da5eee201f$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $6h5qO(new $4OW3Y(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $e02da3da5eee201f$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $c3FWH;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $fMLhA(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $19y06;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $2ofgG(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $8S8Xr, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $cojLE;
        this.__setNet = function(newNet) {
            return _this._network = $fMLhA(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $5ppYm();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $kEOyy(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $8oIvB.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$e02da3da5eee201f$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $8oIvB.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $4OW3Y.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $e02da3da5eee201f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $e02da3da5eee201f$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $e02da3da5eee201f$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $e02da3da5eee201f$var$_objectSpread2["default"])((0, $e02da3da5eee201f$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $8oIvB.create(function(sink) {
            var executor = $hmLk8.execute({
                actorIdentifier: $e02da3da5eee201f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $e02da3da5eee201f$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $e02da3da5eee201f$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $e02da3da5eee201f$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$e02da3da5eee201f$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $e02da3da5eee201f$var$emptyFunction() {}
module.exports = $e02da3da5eee201f$var$RelayModernEnvironment;

});
parcelRegister("fMLhA", function(module, exports) {
'use strict';

var $g443D = parcelRequire("g443D");
function $b7e004136d8a6193$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $g443D();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $b7e004136d8a6193$var$wrapNetworkWithLogObserver;

});
parcelRegister("g443D", function(module, exports) {
'use strict';
var $bb202ad8aedb1483$var$id = 100000;
function $bb202ad8aedb1483$var$generateID() {
    return $bb202ad8aedb1483$var$id++;
}
module.exports = $bb202ad8aedb1483$var$generateID;

});


parcelRegister("5ppYm", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $3f036f2273bd6909$var$_interopRequireDefault = $j3tQw.default;

var $3f036f2273bd6909$var$_createForOfIteratorHelper2 = $3f036f2273bd6909$var$_interopRequireDefault((parcelRequire("cJrco")));

var $bCunb = parcelRequire("bCunb");
var $3f036f2273bd6909$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $3f036f2273bd6909$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $3f036f2273bd6909$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $3f036f2273bd6909$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $3f036f2273bd6909$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $3f036f2273bd6909$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $bCunb(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $3f036f2273bd6909$var$RelayOperationTracker;

});

parcelRegister("kEOyy", function(module, exports) {
'use strict';
function $f09ec27f28aa8a27$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $f09ec27f28aa8a27$var$registerEnvironmentWithDevTools;

});

parcelRegister("19y06", function(module, exports) {
'use strict';

var $eRuLr = parcelRequire("eRuLr");
var $0d710189ab5022be$var$VIEWER_ID = $eRuLr.VIEWER_ID, $0d710189ab5022be$var$VIEWER_TYPE = $eRuLr.VIEWER_TYPE;
function $0d710189ab5022be$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $0d710189ab5022be$var$VIEWER_TYPE) return fieldValue.id == null ? $0d710189ab5022be$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $0d710189ab5022be$var$defaultGetDataID;

});
parcelRegister("eRuLr", function(module, exports) {
'use strict';

var $cvbom = parcelRequire("cvbom");
var $ad1de1076c732d4b$var$generateClientID = $cvbom.generateClientID;

var $3GmWb = parcelRequire("3GmWb");
var $ad1de1076c732d4b$var$ROOT_ID = $3GmWb.ROOT_ID;
var $ad1de1076c732d4b$var$VIEWER_ID = $ad1de1076c732d4b$var$generateClientID($ad1de1076c732d4b$var$ROOT_ID, 'viewer');
var $ad1de1076c732d4b$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $ad1de1076c732d4b$var$VIEWER_ID,
    VIEWER_TYPE: $ad1de1076c732d4b$var$VIEWER_TYPE
};

});


parcelRegister("c3FWH", function(module, exports) {
'use strict';
var $8c764d6a8b837d01$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $8c764d6a8b837d01$var$defaultRelayFieldLogger;

});

parcelRegister("hmLk8", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $ca4933415055fcac$var$_interopRequireDefault = $j3tQw.default;

var $ca4933415055fcac$var$_createForOfIteratorHelper2 = $ca4933415055fcac$var$_interopRequireDefault((parcelRequire("cJrco")));

var $ca4933415055fcac$var$_toConsumableArray2 = $ca4933415055fcac$var$_interopRequireDefault((parcelRequire("6jwD6")));

var $8oIvB = parcelRequire("8oIvB");

var $g443D = parcelRequire("g443D");

var $f9gZR = parcelRequire("f9gZR");

var $cYOet = parcelRequire("cYOet");

var $dRMp3 = parcelRequire("dRMp3");

var $4gj9D = parcelRequire("4gj9D");
var $ca4933415055fcac$var$stableCopy = $4gj9D.stableCopy;

var $V0SBD = parcelRequire("V0SBD");

var $cvbom = parcelRequire("cvbom");
var $ca4933415055fcac$var$generateClientID = $cvbom.generateClientID, $ca4933415055fcac$var$generateUniqueClientID = $cvbom.generateUniqueClientID;

var $1S69g = parcelRequire("1S69g");
var $ca4933415055fcac$var$getLocalVariables = $1S69g.getLocalVariables;

var $drWdC = parcelRequire("drWdC");

var $kPRSQ = parcelRequire("kPRSQ");
var $ca4933415055fcac$var$createNormalizationSelector = $kPRSQ.createNormalizationSelector, $ca4933415055fcac$var$createReaderSelector = $kPRSQ.createReaderSelector;

var $4OW3Y = parcelRequire("4OW3Y");

var $3GmWb = parcelRequire("3GmWb");
var $ca4933415055fcac$var$ROOT_TYPE = $3GmWb.ROOT_TYPE, $ca4933415055fcac$var$TYPENAME_KEY = $3GmWb.TYPENAME_KEY, $ca4933415055fcac$var$getStorageKey = $3GmWb.getStorageKey;

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $ca4933415055fcac$var$execute(config) {
    return new $ca4933415055fcac$var$Executor(config);
}
var $ca4933415055fcac$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $g443D();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($dRMp3.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!$dRMp3.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $bCunb(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $8oIvB.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $cYOet.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $bCunb(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $bCunb(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $ca4933415055fcac$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $ca4933415055fcac$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $ca4933415055fcac$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $ca4933415055fcac$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new $4OW3Y(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $bCunb(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $ca4933415055fcac$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $ca4933415055fcac$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $4OW3Y.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($dRMp3.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $ca4933415055fcac$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $ca4933415055fcac$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $bCunb(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $ca4933415055fcac$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $ca4933415055fcac$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $f9gZR(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $ca4933415055fcac$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $ca4933415055fcac$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $ca4933415055fcac$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $f9gZR(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $8oIvB.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $8oIvB.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $f9gZR(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $dRMp3.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $V0SBD(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $bCunb(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $bCunb(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $ca4933415055fcac$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $bCunb(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $drWdC.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $ca4933415055fcac$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $bCunb(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $bCunb(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $bCunb(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $4OW3Y.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $bCunb(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $ca4933415055fcac$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $4OW3Y.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $bCunb(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $ca4933415055fcac$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $bCunb(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $drWdC.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $bCunb(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $bCunb(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$ca4933415055fcac$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $bCunb(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $ca4933415055fcac$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $bCunb(false);
        var selector = $ca4933415055fcac$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $drWdC.clone(parentRecord);
        var nextIDs = (0, $ca4933415055fcac$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $drWdC.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $ca4933415055fcac$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $ca4933415055fcac$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $ca4933415055fcac$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $ca4933415055fcac$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $ca4933415055fcac$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $bCunb(false);
        return operationLoader;
    };
    return Executor;
}();
function $ca4933415055fcac$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $bCunb(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $ca4933415055fcac$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($ca4933415055fcac$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $ca4933415055fcac$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $bCunb(false);
}
module.exports = {
    execute: $ca4933415055fcac$var$execute
};

});
parcelRegister("f9gZR", function(module, exports) {
'use strict';

var $f5GV4 = parcelRequire("f5GV4");
var $b074e18136ffc31e$var$REQUEST = $f5GV4.REQUEST, $b074e18136ffc31e$var$SPLIT_OPERATION = $f5GV4.SPLIT_OPERATION;
function $b074e18136ffc31e$var$getOperation(node) {
    switch(node.kind){
        case $b074e18136ffc31e$var$REQUEST:
            return node.operation;
        case $b074e18136ffc31e$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $b074e18136ffc31e$var$getOperation;

});

parcelRegister("cYOet", function(module, exports) {
'use strict';
function $97320dc0efdde9ee$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $97320dc0efdde9ee$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $97320dc0efdde9ee$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("V0SBD", function(module, exports) {
'use strict';
var $0ab601af45a8b29a$var$_window, $0ab601af45a8b29a$var$_window$performance;
var $0ab601af45a8b29a$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($0ab601af45a8b29a$var$_window = window) === null || $0ab601af45a8b29a$var$_window === void 0 ? void 0 : ($0ab601af45a8b29a$var$_window$performance = $0ab601af45a8b29a$var$_window.performance) === null || $0ab601af45a8b29a$var$_window$performance === void 0 ? void 0 : $0ab601af45a8b29a$var$_window$performance.now) === 'function';
function $0ab601af45a8b29a$var$currentTimestamp() {
    if ($0ab601af45a8b29a$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $0ab601af45a8b29a$var$withStartAndDuration(cb) {
    var startTime = $0ab601af45a8b29a$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $0ab601af45a8b29a$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $0ab601af45a8b29a$var$withStartAndDuration;

});


parcelRegister("6h5qO", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $49188b2f8e0a4917$var$_interopRequireDefault = $j3tQw.default;

var $49188b2f8e0a4917$var$_createForOfIteratorHelper2 = $49188b2f8e0a4917$var$_interopRequireDefault((parcelRequire("cJrco")));

var $49188b2f8e0a4917$var$_defineProperty2 = $49188b2f8e0a4917$var$_interopRequireDefault((parcelRequire("geBXM")));

var $4YW2I = parcelRequire("4YW2I");
var $49188b2f8e0a4917$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $4YW2I.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $49188b2f8e0a4917$var$assertInternalActorIdentifier = $4YW2I.assertInternalActorIdentifier;
parcelRequire("6hMsx");

var $gqqtY = parcelRequire("gqqtY");

var $egxPf = parcelRequire("egxPf");

var $19y06 = parcelRequire("19y06");

var $a6OeT = parcelRequire("a6OeT");
var $49188b2f8e0a4917$var$LiveResolverCache = $a6OeT.LiveResolverCache, $49188b2f8e0a4917$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $a6OeT.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $49188b2f8e0a4917$var$getUpdatedDataIDs = $a6OeT.getUpdatedDataIDs;

var $drWdC = parcelRequire("drWdC");

var $2fIUM = parcelRequire("2fIUM");

var $aBfZH = parcelRequire("aBfZH");

var $kclMZ = parcelRequire("kclMZ");

var $jqYVg = parcelRequire("jqYVg");

var $3GmWb = parcelRequire("3GmWb");

var $3GmWb = parcelRequire("3GmWb");
var $49188b2f8e0a4917$var$ROOT_ID = $3GmWb.ROOT_ID, $49188b2f8e0a4917$var$ROOT_TYPE = $3GmWb.ROOT_TYPE;

var $bCunb = parcelRequire("bCunb");
var $49188b2f8e0a4917$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $49188b2f8e0a4917$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $49188b2f8e0a4917$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $49188b2f8e0a4917$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $gqqtY;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $19y06;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $49188b2f8e0a4917$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $jqYVg(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $49188b2f8e0a4917$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $49188b2f8e0a4917$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $49188b2f8e0a4917$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $egxPf.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $49188b2f8e0a4917$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $49188b2f8e0a4917$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $aBfZH.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $49188b2f8e0a4917$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $drWdC.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $49188b2f8e0a4917$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $bCunb(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $2fIUM.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $bCunb(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $2fIUM.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $49188b2f8e0a4917$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $bCunb(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $kclMZ.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $drWdC.getValue(record, $49188b2f8e0a4917$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $49188b2f8e0a4917$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $49188b2f8e0a4917$var$initializeRecordSource(target) {
    if (!target.has($49188b2f8e0a4917$var$ROOT_ID)) {
        var rootRecord = $drWdC.create($49188b2f8e0a4917$var$ROOT_ID, $49188b2f8e0a4917$var$ROOT_TYPE);
        target.set($49188b2f8e0a4917$var$ROOT_ID, rootRecord);
    }
}
function $49188b2f8e0a4917$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $drWdC.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $drWdC.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $drWdC.setValue(nextRecord, $3GmWb.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $drWdC.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $49188b2f8e0a4917$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $49188b2f8e0a4917$var$RelayModernStore;

});
parcelRegister("gqqtY", function(module, exports) {
'use strict';
var $bf539de533475b86$var$resolvedPromise = Promise.resolve();
function $bf539de533475b86$var$resolveImmediate(callback) {
    $bf539de533475b86$var$resolvedPromise.then(callback)["catch"]($bf539de533475b86$var$throwNext);
}
function $bf539de533475b86$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $bf539de533475b86$var$resolveImmediate;

});

parcelRegister("egxPf", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $a62ccc5d4711953c$var$_interopRequireDefault = $j3tQw.default;

var $a62ccc5d4711953c$var$_createForOfIteratorHelper2 = $a62ccc5d4711953c$var$_interopRequireDefault((parcelRequire("cJrco")));

var $3XH5F = parcelRequire("3XH5F");

var $cazAm = parcelRequire("cazAm");

var $f9gZR = parcelRequire("f9gZR");

var $cvbom = parcelRequire("cvbom");
var $a62ccc5d4711953c$var$isClientID = $cvbom.isClientID;

var $f9ftm = parcelRequire("f9ftm");

var $aC1wx = parcelRequire("aC1wx");

var $1S69g = parcelRequire("1S69g");
var $a62ccc5d4711953c$var$getLocalVariables = $1S69g.getLocalVariables;

var $drWdC = parcelRequire("drWdC");

var $jvs2t = parcelRequire("jvs2t");
var $a62ccc5d4711953c$var$EXISTENT = $jvs2t.EXISTENT, $a62ccc5d4711953c$var$UNKNOWN = $jvs2t.UNKNOWN;

var $3GmWb = parcelRequire("3GmWb");

var $aojLn = parcelRequire("aojLn");
var $a62ccc5d4711953c$var$TYPE_SCHEMA_TYPE = $aojLn.TYPE_SCHEMA_TYPE, $a62ccc5d4711953c$var$generateTypeID = $aojLn.generateTypeID;

var $bCunb = parcelRequire("bCunb");
var $a62ccc5d4711953c$var$getModuleOperationKey = $3GmWb.getModuleOperationKey, $a62ccc5d4711953c$var$getStorageKey = $3GmWb.getStorageKey, $a62ccc5d4711953c$var$getArgumentValues = $3GmWb.getArgumentValues;
function $a62ccc5d4711953c$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $a62ccc5d4711953c$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $a62ccc5d4711953c$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $3XH5F(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $cazAm(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bCunb(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $a62ccc5d4711953c$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $a62ccc5d4711953c$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $a62ccc5d4711953c$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $a62ccc5d4711953c$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $a62ccc5d4711953c$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $a62ccc5d4711953c$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $a62ccc5d4711953c$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $a62ccc5d4711953c$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $a62ccc5d4711953c$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $a62ccc5d4711953c$var$UNKNOWN) this._handleMissing();
        if (status === $a62ccc5d4711953c$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $drWdC.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $bCunb(false);
                        var _typeID = $a62ccc5d4711953c$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $f9ftm(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $aC1wx(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $a62ccc5d4711953c$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $bCunb(false);
                    var typeID = $a62ccc5d4711953c$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $bCunb(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $bCunb(false);
        var operationKey = $a62ccc5d4711953c$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $f9gZR(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $a62ccc5d4711953c$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $a62ccc5d4711953c$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $a62ccc5d4711953c$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $a62ccc5d4711953c$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $a62ccc5d4711953c$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $drWdC.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $a62ccc5d4711953c$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $a62ccc5d4711953c$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $a62ccc5d4711953c$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $a62ccc5d4711953c$var$check
};

});
parcelRegister("3XH5F", function(module, exports) {
'use strict';

var $drWdC = parcelRequire("drWdC");

var $jvs2t = parcelRequire("jvs2t");
var $2e284ea05e5ab28a$var$EXISTENT = $jvs2t.EXISTENT;

var $bCunb = parcelRequire("bCunb");
var $2e284ea05e5ab28a$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $drWdC.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $drWdC.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $drWdC.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $bCunb(false);
            sinkRecord = $drWdC.create(dataID, $drWdC.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $bCunb(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $drWdC.copyFields(baseSource, sink);
        if (sinkSource) $drWdC.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $drWdC.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $2e284ea05e5ab28a$var$EXISTENT && this._sink.getStatus(dataID) !== $2e284ea05e5ab28a$var$EXISTENT) && $bCunb(false);
        var record = $drWdC.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $drWdC.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $drWdC.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $drWdC.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $drWdC.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $drWdC.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $drWdC.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $drWdC.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $drWdC.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $drWdC.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $2e284ea05e5ab28a$var$RelayRecordSourceMutator;

});

parcelRegister("cazAm", function(module, exports) {
'use strict';

var $drWdC = parcelRequire("drWdC");

var $jvs2t = parcelRequire("jvs2t");
var $8dc205be9157ca7b$var$EXISTENT = $jvs2t.EXISTENT, $8dc205be9157ca7b$var$NONEXISTENT = $jvs2t.NONEXISTENT;

var $3GmWb = parcelRequire("3GmWb");
var $8dc205be9157ca7b$var$ROOT_ID = $3GmWb.ROOT_ID, $8dc205be9157ca7b$var$ROOT_TYPE = $3GmWb.ROOT_TYPE;

var $c2T9m = parcelRequire("c2T9m");
var $8dc205be9157ca7b$var$_readUpdatableFragment = $c2T9m.readUpdatableFragment;

var $lEfoM = parcelRequire("lEfoM");
var $8dc205be9157ca7b$var$_readUpdatableQuery = $lEfoM.readUpdatableQuery;

var $2Wiht = parcelRequire("2Wiht");

var $bCunb = parcelRequire("bCunb");
var $8dc205be9157ca7b$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $8dc205be9157ca7b$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $8dc205be9157ca7b$var$EXISTENT) _this.create(dataID, $drWdC.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $8dc205be9157ca7b$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $bCunb(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $bCunb(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $8dc205be9157ca7b$var$ROOT_ID) && $bCunb(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $8dc205be9157ca7b$var$EXISTENT) this._proxies[dataID] = new $2Wiht(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $8dc205be9157ca7b$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($8dc205be9157ca7b$var$ROOT_ID);
        if (!root) root = this.create($8dc205be9157ca7b$var$ROOT_ID, $8dc205be9157ca7b$var$ROOT_TYPE);
        !(root && root.getType() === $8dc205be9157ca7b$var$ROOT_TYPE) && $bCunb(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $8dc205be9157ca7b$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $8dc205be9157ca7b$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $8dc205be9157ca7b$var$RelayRecordSourceProxy;

});
parcelRegister("c2T9m", function(module, exports) {
'use strict';

var $ixIqX = parcelRequire("ixIqX");
var $8c5073978d2ef7c5$var$getFragment = $ixIqX.getFragment;

var $kPRSQ = parcelRequire("kPRSQ");
var $8c5073978d2ef7c5$var$getVariablesFromFragment = $kPRSQ.getVariablesFromFragment;

var $3GmWb = parcelRequire("3GmWb");
var $8c5073978d2ef7c5$var$ID_KEY = $3GmWb.ID_KEY;

var $4uHZi = parcelRequire("4uHZi");
var $8c5073978d2ef7c5$var$createUpdatableProxy = $4uHZi.createUpdatableProxy;

var $bCunb = parcelRequire("bCunb");
function $8c5073978d2ef7c5$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $8c5073978d2ef7c5$var$getFragment(fragment);
    var fragmentVariables = $8c5073978d2ef7c5$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$8c5073978d2ef7c5$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $bCunb(false);
    return {
        updatableData: $8c5073978d2ef7c5$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $8c5073978d2ef7c5$var$readUpdatableFragment
};

});
parcelRegister("4uHZi", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $345c15c94343203b$var$_interopRequireDefault = $j3tQw.default;

var $345c15c94343203b$var$_createForOfIteratorHelper2 = $345c15c94343203b$var$_interopRequireDefault((parcelRequire("cJrco")));

var $3GmWb = parcelRequire("3GmWb");
var $345c15c94343203b$var$getArgumentValues = $3GmWb.getArgumentValues;
var $345c15c94343203b$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $345c15c94343203b$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $345c15c94343203b$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $345c15c94343203b$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $345c15c94343203b$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $345c15c94343203b$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $345c15c94343203b$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $345c15c94343203b$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $345c15c94343203b$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $345c15c94343203b$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $345c15c94343203b$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $345c15c94343203b$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $345c15c94343203b$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $345c15c94343203b$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $345c15c94343203b$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $345c15c94343203b$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $345c15c94343203b$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $345c15c94343203b$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $345c15c94343203b$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $345c15c94343203b$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $345c15c94343203b$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $345c15c94343203b$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $345c15c94343203b$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $345c15c94343203b$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $345c15c94343203b$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $345c15c94343203b$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $345c15c94343203b$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $345c15c94343203b$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $345c15c94343203b$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $345c15c94343203b$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $345c15c94343203b$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $345c15c94343203b$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $345c15c94343203b$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $345c15c94343203b$var$createUpdatableProxy
};

});


parcelRegister("lEfoM", function(module, exports) {
'use strict';

var $ixIqX = parcelRequire("ixIqX");
var $fc2947404047858c$var$getUpdatableQuery = $ixIqX.getUpdatableQuery;

var $4uHZi = parcelRequire("4uHZi");
var $fc2947404047858c$var$createUpdatableProxy = $4uHZi.createUpdatableProxy;
function $fc2947404047858c$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $fc2947404047858c$var$getUpdatableQuery(query);
    return {
        updatableData: $fc2947404047858c$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $fc2947404047858c$var$readUpdatableQuery
};

});

parcelRegister("2Wiht", function(module, exports) {
'use strict';

var $cvbom = parcelRequire("cvbom");
var $223f2dc42c2a265f$var$generateClientID = $cvbom.generateClientID;

var $3GmWb = parcelRequire("3GmWb");
var $223f2dc42c2a265f$var$getStableStorageKey = $3GmWb.getStableStorageKey;

var $bCunb = parcelRequire("bCunb");
var $223f2dc42c2a265f$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $bCunb(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$223f2dc42c2a265f$var$isValidLeafValue(value) && $bCunb(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $bCunb(false);
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
            var clientID = $223f2dc42c2a265f$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $bCunb(false);
        var storageKey = $223f2dc42c2a265f$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $223f2dc42c2a265f$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($223f2dc42c2a265f$var$isValidLeafValue);
}
module.exports = $223f2dc42c2a265f$var$RelayRecordProxy;

});


parcelRegister("f9ftm", function(module, exports) {
'use strict';

var $f5GV4 = parcelRequire("f5GV4");
var $b073b2cfcd1b2d9d$var$LINKED_FIELD = $f5GV4.LINKED_FIELD;

var $3GmWb = parcelRequire("3GmWb");
var $b073b2cfcd1b2d9d$var$getHandleStorageKey = $3GmWb.getHandleStorageKey;

var $lPzB2 = parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");
function $b073b2cfcd1b2d9d$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $b073b2cfcd1b2d9d$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $lPzB2(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $b073b2cfcd1b2d9d$var$LINKED_FIELD) && $bCunb(false);
    var handleKey = $b073b2cfcd1b2d9d$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $b073b2cfcd1b2d9d$var$cloneRelayHandleSourceField;

});

parcelRegister("aC1wx", function(module, exports) {
'use strict';

var $f5GV4 = parcelRequire("f5GV4");
var $7b9ea29c39b71389$var$SCALAR_FIELD = $f5GV4.SCALAR_FIELD;

var $3GmWb = parcelRequire("3GmWb");
var $7b9ea29c39b71389$var$getHandleStorageKey = $3GmWb.getHandleStorageKey;

var $lPzB2 = parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");
function $7b9ea29c39b71389$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $7b9ea29c39b71389$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $lPzB2(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $7b9ea29c39b71389$var$SCALAR_FIELD) && $bCunb(false);
    var handleKey = $7b9ea29c39b71389$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $7b9ea29c39b71389$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("a6OeT", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $75c16f5b285257a2$var$_interopRequireDefault = $j3tQw.default;

var $75c16f5b285257a2$var$_createForOfIteratorHelper2 = $75c16f5b285257a2$var$_interopRequireDefault((parcelRequire("cJrco")));

var $lln7q = parcelRequire("lln7q");

var $f5GV4 = parcelRequire("f5GV4");
var $75c16f5b285257a2$var$RELAY_LIVE_RESOLVER = $f5GV4.RELAY_LIVE_RESOLVER;

var $dRMp3 = parcelRequire("dRMp3");

var $bf1Oi = parcelRequire("bf1Oi");

var $cvbom = parcelRequire("cvbom");
var $75c16f5b285257a2$var$generateClientID = $cvbom.generateClientID, $75c16f5b285257a2$var$generateClientObjectClientID = $cvbom.generateClientObjectClientID;

var $drWdC = parcelRequire("drWdC");

var $kPRSQ = parcelRequire("kPRSQ");
var $75c16f5b285257a2$var$createNormalizationSelector = $kPRSQ.createNormalizationSelector;

var $4OW3Y = parcelRequire("4OW3Y");

var $aPj4D = parcelRequire("aPj4D");
var $75c16f5b285257a2$var$normalize = $aPj4D.normalize;

var $3GmWb = parcelRequire("3GmWb");
var $75c16f5b285257a2$var$RELAY_RESOLVER_ERROR_KEY = $3GmWb.RELAY_RESOLVER_ERROR_KEY, $75c16f5b285257a2$var$RELAY_RESOLVER_INVALIDATION_KEY = $3GmWb.RELAY_RESOLVER_INVALIDATION_KEY, $75c16f5b285257a2$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $3GmWb.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $75c16f5b285257a2$var$RELAY_RESOLVER_SNAPSHOT_KEY = $3GmWb.RELAY_RESOLVER_SNAPSHOT_KEY, $75c16f5b285257a2$var$RELAY_RESOLVER_VALUE_KEY = $3GmWb.RELAY_RESOLVER_VALUE_KEY, $75c16f5b285257a2$var$getReadTimeResolverStorageKey = $3GmWb.getReadTimeResolverStorageKey, $75c16f5b285257a2$var$getStorageKey = $3GmWb.getStorageKey;

var $5Vx5t = parcelRequire("5Vx5t");

var $7rCAc = parcelRequire("7rCAc");

var $8rY4t = parcelRequire("8rY4t");
var $75c16f5b285257a2$var$isSuspenseSentinel = $8rY4t.isSuspenseSentinel;

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
var $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $75c16f5b285257a2$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $75c16f5b285257a2$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $75c16f5b285257a2$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $75c16f5b285257a2$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $75c16f5b285257a2$var$expectRecord(recordSource, recordID);
        var storageKey = $75c16f5b285257a2$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $drWdC.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $75c16f5b285257a2$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $75c16f5b285257a2$var$generateClientID(recordID, storageKey);
            linkedRecord = $drWdC.create(linkedID, $75c16f5b285257a2$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $drWdC.setValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $drWdC.setValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $75c16f5b285257a2$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $bCunb(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $75c16f5b285257a2$var$expectRecord(recordSource, recordID);
            var nextRecord = $drWdC.clone(currentRecord);
            $drWdC.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $75c16f5b285257a2$var$getStorageKey(field.fragment, variables);
                var resolverID = $75c16f5b285257a2$var$generateClientID(recordID, fragmentStorageKey);
                $75c16f5b285257a2$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $75c16f5b285257a2$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $75c16f5b285257a2$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $75c16f5b285257a2$var$RELAY_LIVE_RESOLVER && $drWdC.getValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $75c16f5b285257a2$var$generateClientID(recordID, storageKey);
            linkedRecord = $drWdC.clone(linkedRecord);
            var _liveState = $drWdC.getValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$7rCAc(_liveState)) $bCunb(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $drWdC.setValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $drWdC.getValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $drWdC.getValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($75c16f5b285257a2$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $75c16f5b285257a2$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $bCunb(false);
        var liveState = $drWdC.getValue(liveStateRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $drWdC.setValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $drWdC.setValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $drWdC.setValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$drWdC.hasValue(currentRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $drWdC.clone(currentRecord);
            $drWdC.setValue(nextRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $4OW3Y.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $4OW3Y.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $bCunb(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $drWdC.setValue(resolverRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$75c16f5b285257a2$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $5Vx5t(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $bCunb(false);
                resolverValue = [];
                var nextSource = $4OW3Y.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $bCunb(false);
                    var typename = $75c16f5b285257a2$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $75c16f5b285257a2$var$generateClientObjectClientID(typename, $drWdC.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $75c16f5b285257a2$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $75c16f5b285257a2$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $bCunb(false);
                var _typename = $75c16f5b285257a2$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $75c16f5b285257a2$var$generateClientObjectClientID(_typename, $drWdC.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $75c16f5b285257a2$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $drWdC.setValue(resolverRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $bf1Oi(resolverValue);
            $drWdC.setValue(resolverRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $bf1Oi(value);
            $drWdC.setValue(resolverRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $drWdC.getValue(resolverRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $75c16f5b285257a2$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$drWdC.getValue(record, $75c16f5b285257a2$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $drWdC.getValue(record, $75c16f5b285257a2$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $lln7q(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($dRMp3.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $drWdC.clone(record);
            $drWdC.setValue(nextRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($drWdC.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $4OW3Y.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $drWdC.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $75c16f5b285257a2$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $75c16f5b285257a2$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $drWdC.create(outputTypeDataID, typename);
                $drWdC.setValue(_record, $75c16f5b285257a2$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $bCunb(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $75c16f5b285257a2$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $drWdC.create(key, typeName);
            $drWdC.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $75c16f5b285257a2$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $75c16f5b285257a2$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $75c16f5b285257a2$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $75c16f5b285257a2$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $75c16f5b285257a2$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $drWdC.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $75c16f5b285257a2$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $75c16f5b285257a2$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $drWdC.getFields(record).forEach(function(field) {
        if ($drWdC.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $drWdC.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($drWdC.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $drWdC.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $75c16f5b285257a2$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $drWdC.clone(record);
    $drWdC.setValue(nextRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $75c16f5b285257a2$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $75c16f5b285257a2$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $75c16f5b285257a2$var$isResolverRecord(_record2)) $75c16f5b285257a2$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $75c16f5b285257a2$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $75c16f5b285257a2$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $75c16f5b285257a2$var$isResolverRecord(record)) $75c16f5b285257a2$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $75c16f5b285257a2$var$isResolverRecord(record) {
    return $drWdC.getType(record) === $75c16f5b285257a2$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $75c16f5b285257a2$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $drWdC.getValue(linkedRecord, $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $75c16f5b285257a2$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $bCunb(false);
    return record;
}
function $75c16f5b285257a2$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $75c16f5b285257a2$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $bCunb(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $75c16f5b285257a2$var$LiveResolverCache,
    getUpdatedDataIDs: $75c16f5b285257a2$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $75c16f5b285257a2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("bf1Oi", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("5Vx5t", function(module, exports) {
'use strict';

var $drWdC = parcelRequire("drWdC");

var $3GmWb = parcelRequire("3GmWb");
var $450bf11459881b1e$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $3GmWb.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $bCunb = parcelRequire("bCunb");
function $450bf11459881b1e$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $drWdC.getValue(record, $450bf11459881b1e$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $bCunb(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $450bf11459881b1e$var$getOutputTypeRecordIDs;

});

parcelRegister("7rCAc", function(module, exports) {
'use strict';
function $56b8fbc785ae038f$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $56b8fbc785ae038f$var$isLiveStateValue;

});


parcelRegister("2fIUM", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $1a3fd29fd094b35e$var$_interopRequireDefault = $j3tQw.default;

var $1a3fd29fd094b35e$var$_objectSpread2 = $1a3fd29fd094b35e$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $drWdC = parcelRequire("drWdC");

var $4OW3Y = parcelRequire("4OW3Y");

var $bCunb = parcelRequire("bCunb");
var $1a3fd29fd094b35e$var$UNPUBLISH_RECORD_SENTINEL = $drWdC.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $1a3fd29fd094b35e$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $4OW3Y.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $1a3fd29fd094b35e$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $1a3fd29fd094b35e$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $4OW3Y.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $1a3fd29fd094b35e$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $1a3fd29fd094b35e$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $drWdC.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $1a3fd29fd094b35e$var$create(base) {
    return new $1a3fd29fd094b35e$var$RelayOptimisticRecordSource(base);
}
function $1a3fd29fd094b35e$var$getOptimisticRecordIDs(source) {
    !(source instanceof $1a3fd29fd094b35e$var$RelayOptimisticRecordSource) && $bCunb(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $1a3fd29fd094b35e$var$create,
    getOptimisticRecordIDs: $1a3fd29fd094b35e$var$getOptimisticRecordIDs
};

});

parcelRegister("aBfZH", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $7b79c432e0bcacc0$var$_interopRequireDefault = $j3tQw.default;

var $7b79c432e0bcacc0$var$_objectSpread2 = $7b79c432e0bcacc0$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $7b79c432e0bcacc0$var$_defineProperty2 = $7b79c432e0bcacc0$var$_interopRequireDefault((parcelRequire("geBXM")));

var $7b79c432e0bcacc0$var$_objectWithoutPropertiesLoose2 = $7b79c432e0bcacc0$var$_interopRequireDefault((parcelRequire("6Mx0E")));

var $7b79c432e0bcacc0$var$_toConsumableArray2 = $7b79c432e0bcacc0$var$_interopRequireDefault((parcelRequire("6jwD6")));
var $7b79c432e0bcacc0$var$_excluded = [
    "message"
];

var $dRMp3 = parcelRequire("dRMp3");

var $8rY4t = parcelRequire("8rY4t");
var $7b79c432e0bcacc0$var$isSuspenseSentinel = $8rY4t.isSuspenseSentinel;

var $1S69g = parcelRequire("1S69g");

var $drWdC = parcelRequire("drWdC");

var $3GmWb = parcelRequire("3GmWb");
var $7b79c432e0bcacc0$var$CLIENT_EDGE_TRAVERSAL_PATH = $3GmWb.CLIENT_EDGE_TRAVERSAL_PATH, $7b79c432e0bcacc0$var$FRAGMENT_OWNER_KEY = $3GmWb.FRAGMENT_OWNER_KEY, $7b79c432e0bcacc0$var$FRAGMENT_PROP_NAME_KEY = $3GmWb.FRAGMENT_PROP_NAME_KEY, $7b79c432e0bcacc0$var$FRAGMENTS_KEY = $3GmWb.FRAGMENTS_KEY, $7b79c432e0bcacc0$var$ID_KEY = $3GmWb.ID_KEY, $7b79c432e0bcacc0$var$MODULE_COMPONENT_KEY = $3GmWb.MODULE_COMPONENT_KEY, $7b79c432e0bcacc0$var$ROOT_ID = $3GmWb.ROOT_ID, $7b79c432e0bcacc0$var$getArgumentValues = $3GmWb.getArgumentValues, $7b79c432e0bcacc0$var$getModuleComponentKey = $3GmWb.getModuleComponentKey, $7b79c432e0bcacc0$var$getStorageKey = $3GmWb.getStorageKey;

var $9SgNN = parcelRequire("9SgNN");
var $7b79c432e0bcacc0$var$NoopResolverCache = $9SgNN.NoopResolverCache;

var $iVkak = parcelRequire("iVkak");
var $7b79c432e0bcacc0$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $iVkak.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $7b79c432e0bcacc0$var$withResolverContext = $iVkak.withResolverContext;

var $aojLn = parcelRequire("aojLn");
var $7b79c432e0bcacc0$var$generateTypeID = $aojLn.generateTypeID;

var $bCunb = parcelRequire("bCunb");
function $7b79c432e0bcacc0$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $7b79c432e0bcacc0$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $7b79c432e0bcacc0$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $7b79c432e0bcacc0$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $7b79c432e0bcacc0$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $drWdC.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bCunb(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($7b79c432e0bcacc0$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $7b79c432e0bcacc0$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $7b79c432e0bcacc0$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $bCunb(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $bCunb(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $bCunb(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $bCunb(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $drWdC.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = $7b79c432e0bcacc0$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $7b79c432e0bcacc0$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $7b79c432e0bcacc0$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$7b79c432e0bcacc0$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $7b79c432e0bcacc0$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $7b79c432e0bcacc0$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $7b79c432e0bcacc0$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $7b79c432e0bcacc0$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($7b79c432e0bcacc0$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $bCunb(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $7b79c432e0bcacc0$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $bCunb(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $bCunb(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $bCunb(false);
                var localId = $7b79c432e0bcacc0$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $bCunb(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $7b79c432e0bcacc0$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $7b79c432e0bcacc0$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $bCunb(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $bCunb(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $bCunb(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $bCunb(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $7b79c432e0bcacc0$var$getStorageKey(field, this._variables);
        var value = $drWdC.getValue(record, storageKey);
        if (value === null || $dRMp3.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $7b79c432e0bcacc0$var$getStorageKey(field, this._variables);
        var linkedID = $drWdC.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $bCunb(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $7b79c432e0bcacc0$var$getStorageKey(field, this._variables);
        var externalRef = $drWdC.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $drWdC.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $7b79c432e0bcacc0$var$getStorageKey(field, this._variables);
        var linkedIDs = $drWdC.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $dRMp3.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $bCunb(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $bCunb(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $7b79c432e0bcacc0$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $drWdC.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$7b79c432e0bcacc0$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$7b79c432e0bcacc0$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $drWdC.getType(record);
        return typeName != null && typeName === type || $drWdC.getDataID(record) === $7b79c432e0bcacc0$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$7b79c432e0bcacc0$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$7b79c432e0bcacc0$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $bCunb(false);
        if (data[$7b79c432e0bcacc0$var$ID_KEY] == null) data[$7b79c432e0bcacc0$var$ID_KEY] = $drWdC.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $7b79c432e0bcacc0$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$7b79c432e0bcacc0$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$7b79c432e0bcacc0$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $7b79c432e0bcacc0$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$7b79c432e0bcacc0$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$7b79c432e0bcacc0$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $bCunb(false);
        if (data[$7b79c432e0bcacc0$var$ID_KEY] == null) data[$7b79c432e0bcacc0$var$ID_KEY] = $drWdC.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $7b79c432e0bcacc0$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $1S69g.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $drWdC.getType(record);
        var typeRecord = this._recordSource.get($7b79c432e0bcacc0$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $drWdC.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $7b79c432e0bcacc0$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $7b79c432e0bcacc0$var$_objectSpread2["default"])((0, $7b79c432e0bcacc0$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $bCunb(false);
    }
}
function $7b79c432e0bcacc0$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $7b79c432e0bcacc0$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $7b79c432e0bcacc0$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $7b79c432e0bcacc0$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $bCunb(false);
}
module.exports = {
    read: $7b79c432e0bcacc0$var$read
};

});
parcelRegister("9SgNN", function(module, exports) {
'use strict';

var $f5GV4 = parcelRequire("f5GV4");
var $730630c907484192$var$RELAY_LIVE_RESOLVER = $f5GV4.RELAY_LIVE_RESOLVER;

var $bCunb = parcelRequire("bCunb");
var $730630c907484192$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $730630c907484192$var$RELAY_LIVE_RESOLVER) && $bCunb(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $bCunb(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $730630c907484192$var$NoopResolverCache
};

});


parcelRegister("kclMZ", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $eb45d481e6bb768e$var$_interopRequireDefault = $j3tQw.default;

var $eb45d481e6bb768e$var$_createForOfIteratorHelper2 = $eb45d481e6bb768e$var$_interopRequireDefault((parcelRequire("cJrco")));

var $f9gZR = parcelRequire("f9gZR");

var $f9ftm = parcelRequire("f9ftm");

var $5Vx5t = parcelRequire("5Vx5t");

var $1S69g = parcelRequire("1S69g");
var $eb45d481e6bb768e$var$getLocalVariables = $1S69g.getLocalVariables;

var $drWdC = parcelRequire("drWdC");

var $3GmWb = parcelRequire("3GmWb");

var $aojLn = parcelRequire("aojLn");
var $eb45d481e6bb768e$var$generateTypeID = $aojLn.generateTypeID;

var $bCunb = parcelRequire("bCunb");
var $eb45d481e6bb768e$var$getReadTimeResolverStorageKey = $3GmWb.getReadTimeResolverStorageKey, $eb45d481e6bb768e$var$getStorageKey = $3GmWb.getStorageKey, $eb45d481e6bb768e$var$getModuleOperationKey = $3GmWb.getModuleOperationKey;
function $eb45d481e6bb768e$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $eb45d481e6bb768e$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $eb45d481e6bb768e$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bCunb(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $drWdC.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $3GmWb.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $drWdC.getType(record);
                        var typeID = $eb45d481e6bb768e$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $eb45d481e6bb768e$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $f9ftm(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $drWdC.getType(record);
                    var _typeID = $eb45d481e6bb768e$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $bCunb(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $5Vx5t(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $eb45d481e6bb768e$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $drWdC.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $eb45d481e6bb768e$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $drWdC.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $eb45d481e6bb768e$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $drWdC.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $bCunb(false);
        var operationKey = $eb45d481e6bb768e$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $drWdC.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $f9gZR(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $eb45d481e6bb768e$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $eb45d481e6bb768e$var$getStorageKey(field, this._variables);
        var linkedID = $drWdC.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $eb45d481e6bb768e$var$getStorageKey(field, this._variables);
        var linkedIDs = $drWdC.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $eb45d481e6bb768e$var$mark
};

});

parcelRegister("jqYVg", function(module, exports) {
'use strict';
parcelRequire("6hMsx");

var $lln7q = parcelRequire("lln7q");

var $dRMp3 = parcelRequire("dRMp3");

var $hxYFB = parcelRequire("hxYFB");

var $91jsx = parcelRequire("91jsx");

var $aBfZH = parcelRequire("aBfZH");
var $e25fb40085584aa6$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $aBfZH.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $lln7q(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $hxYFB(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $aBfZH.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $lln7q(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $dRMp3.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($dRMp3.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $91jsx(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $e25fb40085584aa6$var$RelayStoreSubscriptions;

});
parcelRegister("hxYFB", function(module, exports) {
'use strict';
var $cc64948eb9192ccf$var$ITERATOR_KEY = Symbol.iterator;
function $cc64948eb9192ccf$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$cc64948eb9192ccf$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $cc64948eb9192ccf$var$hasOverlappingIDs;

});

parcelRegister("91jsx", function(module, exports) {
'use strict';

var $3GmWb = parcelRequire("3GmWb");
var $69134d42729d2d84$var$ROOT_ID = $3GmWb.ROOT_ID;

var $eRuLr = parcelRequire("eRuLr");
var $69134d42729d2d84$var$VIEWER_ID = $eRuLr.VIEWER_ID;
var $69134d42729d2d84$var$ITERATOR_KEY = Symbol.iterator;
function $69134d42729d2d84$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$69134d42729d2d84$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $69134d42729d2d84$var$ROOT_ID && key !== $69134d42729d2d84$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $69134d42729d2d84$var$hasSignificantOverlappingIDs;

});



parcelRegister("2ofgG", function(module, exports) {
'use strict';
var $1bd9aa916609ef31$var$_global$ErrorUtils$ap, $1bd9aa916609ef31$var$_global$ErrorUtils;

var $3XH5F = parcelRequire("3XH5F");

var $cazAm = parcelRequire("cazAm");

var $hSka0 = parcelRequire("hSka0");

var $dRMp3 = parcelRequire("dRMp3");

var $aBfZH = parcelRequire("aBfZH");

var $4OW3Y = parcelRequire("4OW3Y");

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
var $1bd9aa916609ef31$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $1bd9aa916609ef31$var$applyWithGuard = ($1bd9aa916609ef31$var$_global$ErrorUtils$ap = $1bd9aa916609ef31$var$_global === null || $1bd9aa916609ef31$var$_global === void 0 ? void 0 : ($1bd9aa916609ef31$var$_global$ErrorUtils = $1bd9aa916609ef31$var$_global.ErrorUtils) === null || $1bd9aa916609ef31$var$_global$ErrorUtils === void 0 ? void 0 : $1bd9aa916609ef31$var$_global$ErrorUtils.applyWithGuard) !== null && $1bd9aa916609ef31$var$_global$ErrorUtils$ap !== void 0 ? $1bd9aa916609ef31$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $1bd9aa916609ef31$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $bCunb(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $dRMp3.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $bCunb(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $3XH5F(this._store.getSource(), source);
        var recordSourceProxy = new $cazAm(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $bCunb(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $bCunb(false);
            var recordSourceSelectorProxy = new $hSka0(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $1bd9aa916609ef31$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $4OW3Y.create();
                var mutator = new $3XH5F(_this2._store.getSource(), sink);
                var recordSourceProxy = new $cazAm(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $1bd9aa916609ef31$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $4OW3Y.create();
        var mutator = new $3XH5F(this._store.getSource(), sink);
        var recordSourceProxy = new $cazAm(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $1bd9aa916609ef31$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $1bd9aa916609ef31$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $hSka0(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $1bd9aa916609ef31$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $1bd9aa916609ef31$var$lookupSelector(source, selector) {
    var selectorData = $aBfZH.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $1bd9aa916609ef31$var$RelayPublishQueue;

});
parcelRegister("hSka0", function(module, exports) {
'use strict';

var $3GmWb = parcelRequire("3GmWb");
var $d0371e403ebf089e$var$ROOT_TYPE = $3GmWb.ROOT_TYPE, $d0371e403ebf089e$var$getStorageKey = $3GmWb.getStorageKey;

var $c2T9m = parcelRequire("c2T9m");
var $d0371e403ebf089e$var$_readUpdatableFragment = $c2T9m.readUpdatableFragment;

var $lEfoM = parcelRequire("lEfoM");
var $d0371e403ebf089e$var$_readUpdatableQuery = $lEfoM.readUpdatableQuery;

var $bCunb = parcelRequire("bCunb");
var $d0371e403ebf089e$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $d0371e403ebf089e$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $bCunb(false);
        !(field.plural === plural) && $bCunb(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $d0371e403ebf089e$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $d0371e403ebf089e$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $d0371e403ebf089e$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $d0371e403ebf089e$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $d0371e403ebf089e$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("aIFxI", function(module, exports) {
'use strict';

var $3tVxJ = parcelRequire("3tVxJ");

var $ixIqX = parcelRequire("ixIqX");
var $7cde3cfa7bfa61dd$var$getRequest = $ixIqX.getRequest;

var $gGDWH = parcelRequire("gGDWH");
var $7cde3cfa7bfa61dd$var$createOperationDescriptor = $gGDWH.createOperationDescriptor;

var $kPRSQ = parcelRequire("kPRSQ");
var $7cde3cfa7bfa61dd$var$createReaderSelector = $kPRSQ.createReaderSelector;
parcelRequire("fLDY5");
function $7cde3cfa7bfa61dd$var$requestSubscription(environment, config) {
    var subscription = $7cde3cfa7bfa61dd$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $7cde3cfa7bfa61dd$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $3tVxJ.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $7cde3cfa7bfa61dd$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $7cde3cfa7bfa61dd$var$requestSubscription;

});

parcelRegister("1vPAk", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $11a0b3669f590a1d$var$_interopRequireDefault = $j3tQw.default;

var $11a0b3669f590a1d$var$_objectSpread2 = $11a0b3669f590a1d$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $3GmWb = parcelRequire("3GmWb");
var $11a0b3669f590a1d$var$getModuleComponentKey = $3GmWb.getModuleComponentKey, $11a0b3669f590a1d$var$getModuleOperationKey = $3GmWb.getModuleOperationKey;
function $11a0b3669f590a1d$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $11a0b3669f590a1d$var$_objectSpread2["default"])({}, response);
    data[$11a0b3669f590a1d$var$getModuleComponentKey(name)] = component;
    data[$11a0b3669f590a1d$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $11a0b3669f590a1d$var$createPayloadFor3DField;

});

parcelRegister("xeWcm", function(module, exports) {
'use strict';

var $kPRSQ = parcelRequire("kPRSQ");
var $063eab7eb9dd568a$var$getDataIDsFromFragment = $kPRSQ.getDataIDsFromFragment, $063eab7eb9dd568a$var$getSelector = $kPRSQ.getSelector, $063eab7eb9dd568a$var$getVariablesFromFragment = $kPRSQ.getVariablesFromFragment;

var $eEKg8 = parcelRequire("eEKg8");

var $dRMp3 = parcelRequire("dRMp3");

var $4gj9D = parcelRequire("4gj9D");
var $063eab7eb9dd568a$var$stableCopy = $4gj9D.stableCopy;

var $9Dq7V = parcelRequire("9Dq7V");
var $063eab7eb9dd568a$var$intern = $9Dq7V.intern;
function $063eab7eb9dd568a$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $063eab7eb9dd568a$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $063eab7eb9dd568a$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $063eab7eb9dd568a$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($dRMp3.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $dRMp3.STRING_INTERN_LEVEL <= 1 ? ids : $063eab7eb9dd568a$var$intern(ids, $dRMp3.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $eEKg8(fragmentVariables) ? '{}' : JSON.stringify($063eab7eb9dd568a$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $dRMp3.STRING_INTERN_LEVEL <= 1 ? _ids : $063eab7eb9dd568a$var$intern(_ids, $dRMp3.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($063eab7eb9dd568a$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $063eab7eb9dd568a$var$getFragmentIdentifier;

});
parcelRegister("eEKg8", function(module, exports) {
'use strict';
var $aab8af39efbd0583$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $aab8af39efbd0583$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($aab8af39efbd0583$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $aab8af39efbd0583$var$isEmptyObject;

});


parcelRegister("1Wogz", function(module, exports) {
'use strict';

var $4WacY = parcelRequire("4WacY");

var $bCunb = parcelRequire("bCunb");
function $169e0803108ba63b$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $4WacY(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $bCunb(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $bCunb(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $bCunb(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $169e0803108ba63b$var$getPaginationMetadata;

});
parcelRegister("4WacY", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");
function $39847f57aec0b8be$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $bCunb(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $bCunb(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $bCunb(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $bCunb(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $bCunb(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $39847f57aec0b8be$var$getRefetchMetadata;

});


parcelRegister("dxG36", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $9dbef98272fd635d$var$_interopRequireDefault = $j3tQw.default;

var $9dbef98272fd635d$var$_defineProperty2 = $9dbef98272fd635d$var$_interopRequireDefault((parcelRequire("geBXM")));

var $9dbef98272fd635d$var$_objectSpread4 = $9dbef98272fd635d$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $bCunb = parcelRequire("bCunb");
parcelRequire("fLDY5");
function $9dbef98272fd635d$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $bCunb(false);
        var _paginationVariables = (0, $9dbef98272fd635d$var$_objectSpread4["default"])((0, $9dbef98272fd635d$var$_objectSpread4["default"])((0, $9dbef98272fd635d$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $9dbef98272fd635d$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $9dbef98272fd635d$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $bCunb(false);
    var paginationVariables = (0, $9dbef98272fd635d$var$_objectSpread4["default"])((0, $9dbef98272fd635d$var$_objectSpread4["default"])((0, $9dbef98272fd635d$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $9dbef98272fd635d$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $9dbef98272fd635d$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $9dbef98272fd635d$var$getPaginationVariables;

});

parcelRegister("alT9O", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $7896a6a60bd430b3$var$_interopRequireDefault = $j3tQw.default;

var $7896a6a60bd430b3$var$_createForOfIteratorHelper2 = $7896a6a60bd430b3$var$_interopRequireDefault((parcelRequire("cJrco")));

var $bCunb = parcelRequire("bCunb");
function $7896a6a60bd430b3$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $7896a6a60bd430b3$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $bCunb(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $bCunb(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $7896a6a60bd430b3$var$getValueAtPath;

});

parcelRegister("34pGi", function(module, exports) {
'use strict';
var $23c5aa93f729a4bd$var$profileHandlersByName = {};
var $23c5aa93f729a4bd$var$defaultProfiler = {
    stop: function stop() {}
};
var $23c5aa93f729a4bd$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $23c5aa93f729a4bd$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $23c5aa93f729a4bd$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$23c5aa93f729a4bd$var$profileHandlersByName.hasOwnProperty(name)) $23c5aa93f729a4bd$var$profileHandlersByName[name] = [];
        $23c5aa93f729a4bd$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($23c5aa93f729a4bd$var$profileHandlersByName.hasOwnProperty(name)) $23c5aa93f729a4bd$var$removeFromArray($23c5aa93f729a4bd$var$profileHandlersByName[name], handler);
    }
};
function $23c5aa93f729a4bd$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $23c5aa93f729a4bd$var$RelayProfiler;

});




parcelRegister("48Zfe", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $30476ab0196eca3b$var$_interopRequireDefault = $j3tQw.default;

var $30476ab0196eca3b$var$_extends2 = $30476ab0196eca3b$var$_interopRequireDefault((parcelRequire("lfcx2")));

var $30476ab0196eca3b$var$_objectWithoutPropertiesLoose2 = $30476ab0196eca3b$var$_interopRequireDefault((parcelRequire("6Mx0E")));

var $30476ab0196eca3b$var$_assertThisInitialized2 = $30476ab0196eca3b$var$_interopRequireDefault((parcelRequire("fGR3n")));

var $30476ab0196eca3b$var$_inheritsLoose2 = $30476ab0196eca3b$var$_interopRequireDefault((parcelRequire("cmfeQ")));

var $30476ab0196eca3b$var$_defineProperty2 = $30476ab0196eca3b$var$_interopRequireDefault((parcelRequire("geBXM")));
var $30476ab0196eca3b$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $2Fuaz = parcelRequire("2Fuaz");

var $lHmKR = parcelRequire("lHmKR");
var $30476ab0196eca3b$var$getContainerName = $lHmKR.getContainerName;

var $97sFF = parcelRequire("97sFF");
var $30476ab0196eca3b$var$assertRelayContext = $97sFF.assertRelayContext;

var $lPzB2 = parcelRequire("lPzB2");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $30476ab0196eca3b$var$createFragmentSpecResolver = $5KQKg.createFragmentSpecResolver, $30476ab0196eca3b$var$getDataIDsFromObject = $5KQKg.getDataIDsFromObject, $30476ab0196eca3b$var$isScalarAndEqual = $5KQKg.isScalarAndEqual;
function $30476ab0196eca3b$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $30476ab0196eca3b$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $30476ab0196eca3b$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $30476ab0196eca3b$var$_defineProperty2["default"])((0, $30476ab0196eca3b$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $30476ab0196eca3b$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $30476ab0196eca3b$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $30476ab0196eca3b$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $30476ab0196eca3b$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $30476ab0196eca3b$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $30476ab0196eca3b$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $30476ab0196eca3b$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$lPzB2(prevIDs, nextIDs)) {
                resolver = $30476ab0196eca3b$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $30476ab0196eca3b$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $30476ab0196eca3b$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$30476ab0196eca3b$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $30476ab0196eca3b$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $30476ab0196eca3b$var$_excluded);
            return /*#__PURE__*/ $fc4bM.createElement(Component, (0, $30476ab0196eca3b$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($fc4bM.Component), (0, $30476ab0196eca3b$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $30476ab0196eca3b$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $30476ab0196eca3b$var$createContainer(Component, fragmentSpec) {
    return $2Fuaz(Component, fragmentSpec, $30476ab0196eca3b$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $30476ab0196eca3b$var$createContainer
};

});
parcelRegister("lfcx2", function(module, exports) {
function $03fdc0e84d590607$var$_extends() {
    return module.exports = $03fdc0e84d590607$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $03fdc0e84d590607$var$_extends.apply(null, arguments);
}
module.exports = $03fdc0e84d590607$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fGR3n", function(module, exports) {
function $b6c3ee954c6a92ff$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $b6c3ee954c6a92ff$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cmfeQ", function(module, exports) {

var $8pyts = parcelRequire("8pyts");
function $8ff35c25e3acf957$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $8pyts(t, o);
}
module.exports = $8ff35c25e3acf957$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8pyts", function(module, exports) {
function $61fb6660cf272997$var$_setPrototypeOf(t, e) {
    return module.exports = $61fb6660cf272997$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $61fb6660cf272997$var$_setPrototypeOf(t, e);
}
module.exports = $61fb6660cf272997$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2Fuaz", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $1f16d01d5985a1f5$var$_interopRequireDefault = $j3tQw.default;

var $1f16d01d5985a1f5$var$_extends2 = $1f16d01d5985a1f5$var$_interopRequireDefault((parcelRequire("lfcx2")));

var $eEduP = parcelRequire("eEduP");

var $lHmKR = parcelRequire("lHmKR");
var $1f16d01d5985a1f5$var$getComponentName = $lHmKR.getComponentName, $1f16d01d5985a1f5$var$getContainerName = $lHmKR.getContainerName;

var $152Cr = parcelRequire("152Cr");

var $fqWYE = parcelRequire("fqWYE");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $1f16d01d5985a1f5$var$getFragment = $5KQKg.getFragment;
var $1f16d01d5985a1f5$var$useContext = $fc4bM.useContext;
function $1f16d01d5985a1f5$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $1f16d01d5985a1f5$var$getContainerName(ComponentClass);
    $eEduP($1f16d01d5985a1f5$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $1f16d01d5985a1f5$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $1f16d01d5985a1f5$var$useContext($152Cr);
        !(context != null) && $bCunb(false);
        var queryRendererContext = $1f16d01d5985a1f5$var$useContext($fqWYE);
        return /*#__PURE__*/ $fc4bM.createElement(Container, (0, $1f16d01d5985a1f5$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $fc4bM.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $1f16d01d5985a1f5$var$buildReactRelayContainer;

});
parcelRegister("eEduP", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");
function $aa9f45301f0ff563$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $bCunb(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $bCunb(false);
    }
}
module.exports = $aa9f45301f0ff563$var$assertFragmentMap;

});

parcelRegister("lHmKR", function(module, exports) {
'use strict';
function $fcbf43c38ce23f39$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $fcbf43c38ce23f39$var$getContainerName(Component) {
    return 'Relay(' + $fcbf43c38ce23f39$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $fcbf43c38ce23f39$var$getComponentName,
    getContainerName: $fcbf43c38ce23f39$var$getContainerName
};

});

parcelRegister("fqWYE", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");
module.exports = $fc4bM.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("97sFF", function(module, exports) {
'use strict';

var $4jD5t = parcelRequire("4jD5t");

var $bCunb = parcelRequire("bCunb");
function $6a3b01fd74491f1d$var$assertRelayContext(relay) {
    !$6a3b01fd74491f1d$var$isRelayContext(relay) && $bCunb(false);
    return relay;
}
function $6a3b01fd74491f1d$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $4jD5t(context.environment);
}
module.exports = {
    assertRelayContext: $6a3b01fd74491f1d$var$assertRelayContext,
    isRelayContext: $6a3b01fd74491f1d$var$isRelayContext
};

});
parcelRegister("4jD5t", function(module, exports) {
'use strict';
function $324741b4d8297444$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $324741b4d8297444$var$isRelayEnvironment;

});



parcelRegister("kAG1C", function(module, exports) {
'use strict';

var $152Cr = parcelRequire("152Cr");

var $fqWYE = parcelRequire("fqWYE");

var $lPzB2 = parcelRequire("lPzB2");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $efd7c4beb306a4e1$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $efd7c4beb306a4e1$var$deepFreeze = $5KQKg.deepFreeze, $efd7c4beb306a4e1$var$getRequest = $5KQKg.getRequest;
var $efd7c4beb306a4e1$var$useLayoutEffect = $fc4bM.useLayoutEffect, $efd7c4beb306a4e1$var$useState = $fc4bM.useState, $efd7c4beb306a4e1$var$useRef = $fc4bM.useRef, $efd7c4beb306a4e1$var$useMemo = $fc4bM.useMemo;
var $efd7c4beb306a4e1$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $efd7c4beb306a4e1$var$useDeepCompare(value) {
    var latestValue = $fc4bM.useRef(value);
    if (!$lPzB2(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $efd7c4beb306a4e1$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $efd7c4beb306a4e1$var$useDeepCompare(variables);
    var operation = $efd7c4beb306a4e1$var$useMemo(function() {
        var request = $efd7c4beb306a4e1$var$getRequest(query);
        return $efd7c4beb306a4e1$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $efd7c4beb306a4e1$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $efd7c4beb306a4e1$var$useRef(null);
    var _useState = $efd7c4beb306a4e1$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $efd7c4beb306a4e1$var$useRef(null);
    var snapshot = $efd7c4beb306a4e1$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $efd7c4beb306a4e1$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($152Cr.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $fc4bM.createElement($fqWYE.Provider, {
        value: $efd7c4beb306a4e1$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $efd7c4beb306a4e1$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("4zRbM", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $3553b08d84920ef2$var$_interopRequireDefault = $j3tQw.default;

var $3553b08d84920ef2$var$_extends2 = $3553b08d84920ef2$var$_interopRequireDefault((parcelRequire("lfcx2")));

var $3553b08d84920ef2$var$_objectWithoutPropertiesLoose2 = $3553b08d84920ef2$var$_interopRequireDefault((parcelRequire("6Mx0E")));

var $3553b08d84920ef2$var$_assertThisInitialized2 = $3553b08d84920ef2$var$_interopRequireDefault((parcelRequire("fGR3n")));

var $3553b08d84920ef2$var$_inheritsLoose2 = $3553b08d84920ef2$var$_interopRequireDefault((parcelRequire("cmfeQ")));

var $3553b08d84920ef2$var$_defineProperty2 = $3553b08d84920ef2$var$_interopRequireDefault((parcelRequire("geBXM")));

var $3553b08d84920ef2$var$_objectSpread3 = $3553b08d84920ef2$var$_interopRequireDefault((parcelRequire("MwqMq")));
var $3553b08d84920ef2$var$_excluded = [
    "componentRef"
], $3553b08d84920ef2$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $3553b08d84920ef2$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $2Fuaz = parcelRequire("2Fuaz");

var $gfrUG = parcelRequire("gfrUG");

var $lHmKR = parcelRequire("lHmKR");
var $3553b08d84920ef2$var$getComponentName = $lHmKR.getComponentName, $3553b08d84920ef2$var$getContainerName = $lHmKR.getContainerName;

var $152Cr = parcelRequire("152Cr");

var $hTu18 = parcelRequire("hTu18");

var $97sFF = parcelRequire("97sFF");
var $3553b08d84920ef2$var$assertRelayContext = $97sFF.assertRelayContext;

var $lPzB2 = parcelRequire("lPzB2");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $3553b08d84920ef2$var$ConnectionInterface = $5KQKg.ConnectionInterface, $3553b08d84920ef2$var$Observable = $5KQKg.Observable, $3553b08d84920ef2$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $3553b08d84920ef2$var$createFragmentSpecResolver = $5KQKg.createFragmentSpecResolver, $3553b08d84920ef2$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $3553b08d84920ef2$var$getDataIDsFromObject = $5KQKg.getDataIDsFromObject, $3553b08d84920ef2$var$getRequest = $5KQKg.getRequest, $3553b08d84920ef2$var$getVariablesFromObject = $5KQKg.getVariablesFromObject, $3553b08d84920ef2$var$isScalarAndEqual = $5KQKg.isScalarAndEqual;
parcelRequire("fLDY5");
var $3553b08d84920ef2$var$FORWARD = 'forward';
function $3553b08d84920ef2$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $bCunb(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $3553b08d84920ef2$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $bCunb(false);
    return function(prevVars, totalCount) {
        return (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, prevVars), {}, (0, $3553b08d84920ef2$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $3553b08d84920ef2$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $bCunb(false);
            !!foundConnectionMetadata && $bCunb(false);
            foundConnectionMetadata = (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $bCunb(false);
    return foundConnectionMetadata || {};
}
function $3553b08d84920ef2$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $3553b08d84920ef2$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $3553b08d84920ef2$var$getComponentName(Component);
    var containerName = $3553b08d84920ef2$var$getContainerName(Component);
    var metadata = $3553b08d84920ef2$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $3553b08d84920ef2$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $bCunb(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $3553b08d84920ef2$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $3553b08d84920ef2$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $3553b08d84920ef2$var$_defineProperty2["default"])((0, $3553b08d84920ef2$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $3553b08d84920ef2$var$_defineProperty2["default"])((0, $3553b08d84920ef2$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $3553b08d84920ef2$var$_defineProperty2["default"])((0, $3553b08d84920ef2$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $3553b08d84920ef2$var$_defineProperty2["default"])((0, $3553b08d84920ef2$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $3553b08d84920ef2$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $3553b08d84920ef2$var$_defineProperty2["default"])((0, $3553b08d84920ef2$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $3553b08d84920ef2$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $3553b08d84920ef2$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $3553b08d84920ef2$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $3553b08d84920ef2$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($3553b08d84920ef2$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $3553b08d84920ef2$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $3553b08d84920ef2$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($3553b08d84920ef2$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($3553b08d84920ef2$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $3553b08d84920ef2$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $3553b08d84920ef2$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $3553b08d84920ef2$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $gfrUG(fragments, this.props);
            var nextRootVariables = $gfrUG(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$lPzB2(prevRootVariables, nextRootVariables) || !$lPzB2(prevIDs, nextIDs)) {
                this._cleanup();
                if ($3553b08d84920ef2$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $3553b08d84920ef2$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $3553b08d84920ef2$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$3553b08d84920ef2$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $3553b08d84920ef2$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $3553b08d84920ef2$var$_excluded);
            var props = (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $3553b08d84920ef2$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $bCunb(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $bCunb(false);
            !(typeof pageInfo === 'object') && $bCunb(false);
            var hasMore = direction === $3553b08d84920ef2$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $3553b08d84920ef2$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $hTu18();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $3553b08d84920ef2$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $3553b08d84920ef2$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $3553b08d84920ef2$var$_excluded2);
            var props = (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $gfrUG(fragments, restProps);
            fragmentVariables = $3553b08d84920ef2$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $bCunb(false);
            fetchVariables = (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $3553b08d84920ef2$var$_objectSpread3["default"])((0, $3553b08d84920ef2$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $3553b08d84920ef2$var$getRequest(connectionConfig.query);
            var operation = $3553b08d84920ef2$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$lPzB2(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $3553b08d84920ef2$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $3553b08d84920ef2$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $3553b08d84920ef2$var$_excluded3);
            return /*#__PURE__*/ $fc4bM.createElement($152Cr.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $fc4bM.createElement(Component, (0, $3553b08d84920ef2$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($fc4bM.Component), (0, $3553b08d84920ef2$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $3553b08d84920ef2$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $2Fuaz(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $3553b08d84920ef2$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $3553b08d84920ef2$var$createContainer
};

});
parcelRegister("gfrUG", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $bd43b30f1c70fbe0$var$_interopRequireDefault = $j3tQw.default;

var $bd43b30f1c70fbe0$var$_objectSpread2 = $bd43b30f1c70fbe0$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $5KQKg = parcelRequire("5KQKg");
var $bd43b30f1c70fbe0$var$getSelector = $5KQKg.getSelector;
function $bd43b30f1c70fbe0$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $bd43b30f1c70fbe0$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $bd43b30f1c70fbe0$var$_objectSpread2["default"])((0, $bd43b30f1c70fbe0$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $bd43b30f1c70fbe0$var$getRootVariablesForFragments;

});

parcelRegister("hTu18", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $d06edb8b6cca25c7$var$_interopRequireDefault = $j3tQw.default;

var $d06edb8b6cca25c7$var$_defineProperty2 = $d06edb8b6cca25c7$var$_interopRequireDefault((parcelRequire("geBXM")));

var $bCunb = parcelRequire("bCunb");

var $5KQKg = parcelRequire("5KQKg");
var $d06edb8b6cca25c7$var$fetchQuery = $5KQKg.__internal.fetchQuery, $d06edb8b6cca25c7$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $d06edb8b6cca25c7$var$isRelayModernEnvironment = $5KQKg.isRelayModernEnvironment;
var $d06edb8b6cca25c7$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $d06edb8b6cca25c7$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $d06edb8b6cca25c7$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$d06edb8b6cca25c7$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $d06edb8b6cca25c7$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $bCunb(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $d06edb8b6cca25c7$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $bCunb(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $bCunb(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $d06edb8b6cca25c7$var$ReactRelayQueryFetcher;

});


parcelRegister("g16EC", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $ba91e6afc5ef0114$var$_interopRequireDefault = $j3tQw.default;

var $ba91e6afc5ef0114$var$_objectSpread2 = $ba91e6afc5ef0114$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $ba91e6afc5ef0114$var$_assertThisInitialized2 = $ba91e6afc5ef0114$var$_interopRequireDefault((parcelRequire("fGR3n")));

var $ba91e6afc5ef0114$var$_inheritsLoose2 = $ba91e6afc5ef0114$var$_interopRequireDefault((parcelRequire("cmfeQ")));

var $ba91e6afc5ef0114$var$_defineProperty2 = $ba91e6afc5ef0114$var$_interopRequireDefault((parcelRequire("geBXM")));

var $152Cr = parcelRequire("152Cr");

var $hTu18 = parcelRequire("hTu18");

var $fqWYE = parcelRequire("fqWYE");

var $lPzB2 = parcelRequire("lPzB2");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $ba91e6afc5ef0114$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $ba91e6afc5ef0114$var$deepFreeze = $5KQKg.deepFreeze, $ba91e6afc5ef0114$var$getRequest = $5KQKg.getRequest;
var $ba91e6afc5ef0114$var$requestCache = {};
var $ba91e6afc5ef0114$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $ba91e6afc5ef0114$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $ba91e6afc5ef0114$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $ba91e6afc5ef0114$var$_defineProperty2["default"])((0, $ba91e6afc5ef0114$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $ba91e6afc5ef0114$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $ba91e6afc5ef0114$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $ba91e6afc5ef0114$var$getRequest(query);
            requestCacheKey = $ba91e6afc5ef0114$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $ba91e6afc5ef0114$var$requestCache[requestCacheKey] ? $ba91e6afc5ef0114$var$requestCache[requestCacheKey].queryFetcher : new $hTu18();
        } else queryFetcher = new $hTu18();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $ba91e6afc5ef0114$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $ba91e6afc5ef0114$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$lPzB2(prevState.prevPropsVariables, nextProps.variables)) return $ba91e6afc5ef0114$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $ba91e6afc5ef0114$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $ba91e6afc5ef0114$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $ba91e6afc5ef0114$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $ba91e6afc5ef0114$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $ba91e6afc5ef0114$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $ba91e6afc5ef0114$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $fc4bM.createElement($152Cr.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $fc4bM.createElement($fqWYE.Provider, {
            value: $ba91e6afc5ef0114$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($fc4bM.Component);
function $ba91e6afc5ef0114$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $ba91e6afc5ef0114$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $ba91e6afc5ef0114$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $ba91e6afc5ef0114$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $ba91e6afc5ef0114$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $ba91e6afc5ef0114$var$getRequest(query);
        var requestCacheKey = $ba91e6afc5ef0114$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $ba91e6afc5ef0114$var$requestCache[requestCacheKey] ? $ba91e6afc5ef0114$var$requestCache[requestCacheKey].queryFetcher : new $hTu18(prevSelectionReferences);
    } else queryFetcher = new $hTu18(prevSelectionReferences);
    return (0, $ba91e6afc5ef0114$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $ba91e6afc5ef0114$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $ba91e6afc5ef0114$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $ba91e6afc5ef0114$var$getRequest(query);
        var operation = $ba91e6afc5ef0114$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $ba91e6afc5ef0114$var$requestCache[requestCacheKey]) {
            var snapshot = $ba91e6afc5ef0114$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $ba91e6afc5ef0114$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $ba91e6afc5ef0114$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $ba91e6afc5ef0114$var$getRequestCacheKey(request.params, props.variables);
            $ba91e6afc5ef0114$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $ba91e6afc5ef0114$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $ba91e6afc5ef0114$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $ba91e6afc5ef0114$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $ba91e6afc5ef0114$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $ba91e6afc5ef0114$var$ReactRelayQueryRenderer;

});

parcelRegister("5Diux", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $419ef049119db55b$var$_interopRequireDefault = $j3tQw.default;

var $419ef049119db55b$var$_extends2 = $419ef049119db55b$var$_interopRequireDefault((parcelRequire("lfcx2")));

var $419ef049119db55b$var$_objectWithoutPropertiesLoose2 = $419ef049119db55b$var$_interopRequireDefault((parcelRequire("6Mx0E")));

var $419ef049119db55b$var$_objectSpread2 = $419ef049119db55b$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $419ef049119db55b$var$_assertThisInitialized2 = $419ef049119db55b$var$_interopRequireDefault((parcelRequire("fGR3n")));

var $419ef049119db55b$var$_inheritsLoose2 = $419ef049119db55b$var$_interopRequireDefault((parcelRequire("cmfeQ")));

var $419ef049119db55b$var$_defineProperty2 = $419ef049119db55b$var$_interopRequireDefault((parcelRequire("geBXM")));
var $419ef049119db55b$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $2Fuaz = parcelRequire("2Fuaz");

var $gfrUG = parcelRequire("gfrUG");

var $lHmKR = parcelRequire("lHmKR");
var $419ef049119db55b$var$getContainerName = $lHmKR.getContainerName;

var $152Cr = parcelRequire("152Cr");

var $hTu18 = parcelRequire("hTu18");

var $97sFF = parcelRequire("97sFF");
var $419ef049119db55b$var$assertRelayContext = $97sFF.assertRelayContext;

var $lPzB2 = parcelRequire("lPzB2");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $419ef049119db55b$var$Observable = $5KQKg.Observable, $419ef049119db55b$var$createFragmentSpecResolver = $5KQKg.createFragmentSpecResolver, $419ef049119db55b$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $419ef049119db55b$var$getDataIDsFromObject = $5KQKg.getDataIDsFromObject, $419ef049119db55b$var$getRequest = $5KQKg.getRequest, $419ef049119db55b$var$getVariablesFromObject = $5KQKg.getVariablesFromObject, $419ef049119db55b$var$isScalarAndEqual = $5KQKg.isScalarAndEqual;
parcelRequire("fLDY5");
function $419ef049119db55b$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $419ef049119db55b$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $419ef049119db55b$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $419ef049119db55b$var$_defineProperty2["default"])((0, $419ef049119db55b$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $419ef049119db55b$var$_defineProperty2["default"])((0, $419ef049119db55b$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $419ef049119db55b$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $gfrUG(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $419ef049119db55b$var$_objectSpread2["default"])((0, $419ef049119db55b$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $419ef049119db55b$var$_objectSpread2["default"])((0, $419ef049119db55b$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $419ef049119db55b$var$getRequest(taggedNode);
                var operation = $419ef049119db55b$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $419ef049119db55b$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $419ef049119db55b$var$_objectSpread2["default"])((0, $419ef049119db55b$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $419ef049119db55b$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $419ef049119db55b$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $419ef049119db55b$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $419ef049119db55b$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $419ef049119db55b$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $419ef049119db55b$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $gfrUG(fragments, prevProps);
            var nextRootVariables = $gfrUG(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$lPzB2(prevRootVariables, nextRootVariables) || !$lPzB2(prevIDs, nextIDs)) {
                resolver = $419ef049119db55b$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $419ef049119db55b$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$419ef049119db55b$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $419ef049119db55b$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $hTu18();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $419ef049119db55b$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $419ef049119db55b$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $fc4bM.createElement($152Cr.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $fc4bM.createElement(Component, (0, $419ef049119db55b$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($fc4bM.Component), (0, $419ef049119db55b$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $419ef049119db55b$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $419ef049119db55b$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $2Fuaz(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $419ef049119db55b$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $419ef049119db55b$var$createContainer
};

});

parcelRegister("3aGSj", function(module, exports) {
'use strict';

var $v2hvX = parcelRequire("v2hvX");

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");

var $fc4bM = parcelRequire("fc4bM");
var $24f39058cea7c4da$var$useContext = $fc4bM.useContext, $24f39058cea7c4da$var$useEffect = $fc4bM.useEffect;
parcelRequire("fLDY5");
function $24f39058cea7c4da$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $24f39058cea7c4da$var$useContext($v2hvX);
    var environment = $jIrdm();
    $24f39058cea7c4da$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $fc4bM.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $24f39058cea7c4da$var$EntryPointContainer;

});
parcelRegister("v2hvX", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");
var $05d4aa6c0ea811bb$var$ProfilerContext = $fc4bM.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $05d4aa6c0ea811bb$var$ProfilerContext;

});

parcelRegister("jIrdm", function(module, exports) {
'use strict';

var $152Cr = parcelRequire("152Cr");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $e5a73c99cdca42a8$var$useContext = $fc4bM.useContext;
function $e5a73c99cdca42a8$var$useRelayEnvironment() {
    var context = $e5a73c99cdca42a8$var$useContext($152Cr);
    !(context != null) && $bCunb(false);
    return context.environment;
}
module.exports = $e5a73c99cdca42a8$var$useRelayEnvironment;

});


parcelRegister("aTLj4", function(module, exports) {
'use strict';

var $l0KzO = parcelRequire("l0KzO");
var $7ef3bc8f92295db2$var$loadQuery = $l0KzO.loadQuery;
function $7ef3bc8f92295db2$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $7ef3bc8f92295db2$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $7ef3bc8f92295db2$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $7ef3bc8f92295db2$var$loadEntryPoint;

});
parcelRegister("l0KzO", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $f4bdba370eeb4e07$var$_interopRequireDefault = $j3tQw.default;

var $f4bdba370eeb4e07$var$_objectSpread2 = $f4bdba370eeb4e07$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $bCunb = parcelRequire("bCunb");

var $5KQKg = parcelRequire("5KQKg");
var $f4bdba370eeb4e07$var$fetchQueryDeduped = $5KQKg.__internal.fetchQueryDeduped, $f4bdba370eeb4e07$var$Observable = $5KQKg.Observable, $f4bdba370eeb4e07$var$PreloadableQueryRegistry = $5KQKg.PreloadableQueryRegistry, $f4bdba370eeb4e07$var$ReplaySubject = $5KQKg.ReplaySubject, $f4bdba370eeb4e07$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $f4bdba370eeb4e07$var$getRequest = $5KQKg.getRequest, $f4bdba370eeb4e07$var$getRequestIdentifier = $5KQKg.getRequestIdentifier;
var $f4bdba370eeb4e07$var$fetchKey = 100001;
function $f4bdba370eeb4e07$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $f4bdba370eeb4e07$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $f4bdba370eeb4e07$var$_objectSpread2["default"])((0, $f4bdba370eeb4e07$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $f4bdba370eeb4e07$var$ReplaySubject();
    var returnedObservable = $f4bdba370eeb4e07$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $f4bdba370eeb4e07$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $f4bdba370eeb4e07$var$getRequestIdentifier(params, variables);
        var observable = $f4bdba370eeb4e07$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $f4bdba370eeb4e07$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $f4bdba370eeb4e07$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $f4bdba370eeb4e07$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $bCunb(false);
        var _module = $f4bdba370eeb4e07$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $f4bdba370eeb4e07$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $f4bdba370eeb4e07$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $f4bdba370eeb4e07$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $f4bdba370eeb4e07$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $f4bdba370eeb4e07$var$loadQuery
};

});


parcelRegister("9NVV1", function(module, exports) {
'use strict';

var $152Cr = parcelRequire("152Cr");

var $fc4bM = parcelRequire("fc4bM");
var $72359e189c863a19$var$useMemo = $fc4bM.useMemo;
function $72359e189c863a19$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $72359e189c863a19$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($152Cr.Provider, {
        value: context
    }, children);
}
module.exports = $72359e189c863a19$var$RelayEnvironmentProvider;

});

parcelRegister("4vlU3", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $347b0c28be9227c2$var$_interopRequireDefault = $j3tQw.default;

var $347b0c28be9227c2$var$_objectSpread2 = $347b0c28be9227c2$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $3QDJV = parcelRequire("3QDJV");
function $347b0c28be9227c2$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $3QDJV(query, variables, (0, $347b0c28be9227c2$var$_objectSpread2["default"])((0, $347b0c28be9227c2$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $347b0c28be9227c2$var$useClientQuery;

});
parcelRegister("3QDJV", function(module, exports) {
'use strict';

var $8Ifj5 = parcelRequire("8Ifj5");

var $dpmsU = parcelRequire("dpmsU");

var $jIrdm = parcelRequire("jIrdm");

var $5KQKg = parcelRequire("5KQKg");
var $2cd50de64bde50ca$var$fetchQuery = $5KQKg.__internal.fetchQuery;
function $2cd50de64bde50ca$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $jIrdm();
    var query = $dpmsU(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $8Ifj5({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $2cd50de64bde50ca$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $2cd50de64bde50ca$var$useLazyLoadQuery;

});
parcelRegister("8Ifj5", function(module, exports) {
'use strict';

var $v2hvX = parcelRequire("v2hvX");

var $jLGBa = parcelRequire("jLGBa");
var $657e4e6342ac4eb5$var$getQueryCacheIdentifier = $jLGBa.getQueryCacheIdentifier, $657e4e6342ac4eb5$var$getQueryResourceForEnvironment = $jLGBa.getQueryResourceForEnvironment;

var $3tDtI = parcelRequire("3tDtI");

var $9PBYb = parcelRequire("9PBYb");

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");
var $657e4e6342ac4eb5$var$useContext = $fc4bM.useContext, $657e4e6342ac4eb5$var$useEffect = $fc4bM.useEffect, $657e4e6342ac4eb5$var$useState = $fc4bM.useState, $657e4e6342ac4eb5$var$useRef = $fc4bM.useRef;
function $657e4e6342ac4eb5$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $jIrdm();
    var profilerContext = $657e4e6342ac4eb5$var$useContext($v2hvX);
    var QueryResource = $657e4e6342ac4eb5$var$getQueryResourceForEnvironment(environment);
    var _useState = $657e4e6342ac4eb5$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $3tDtI(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $657e4e6342ac4eb5$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $657e4e6342ac4eb5$var$useRef(false);
    $657e4e6342ac4eb5$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $657e4e6342ac4eb5$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $657e4e6342ac4eb5$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $9PBYb(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $657e4e6342ac4eb5$var$useLazyLoadQueryNode;

});
parcelRegister("jLGBa", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $e6437346b5263ab4$var$_interopRequireDefault = $j3tQw.default;

var $e6437346b5263ab4$var$_objectSpread2 = $e6437346b5263ab4$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $e6437346b5263ab4$var$_defineProperty2 = $e6437346b5263ab4$var$_interopRequireDefault((parcelRequire("geBXM")));

var $c6QRH = parcelRequire("c6QRH");

var $kcUMS = parcelRequire("kcUMS");

var $bCunb = parcelRequire("bCunb");

var $5KQKg = parcelRequire("5KQKg");
var $e6437346b5263ab4$var$isPromise = $5KQKg.isPromise;
parcelRequire("fLDY5");
var $e6437346b5263ab4$var$CACHE_CAPACITY = 1000;
var $e6437346b5263ab4$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $e6437346b5263ab4$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $e6437346b5263ab4$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $e6437346b5263ab4$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $e6437346b5263ab4$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $e6437346b5263ab4$var$operationIsLiveQuery(operation) ? $e6437346b5263ab4$var$DEFAULT_LIVE_FETCH_POLICY : $e6437346b5263ab4$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $e6437346b5263ab4$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $e6437346b5263ab4$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $e6437346b5263ab4$var$nextID = 200000;
function $e6437346b5263ab4$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $e6437346b5263ab4$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $kcUMS(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $e6437346b5263ab4$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $e6437346b5263ab4$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $e6437346b5263ab4$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $c6QRH.create($e6437346b5263ab4$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $e6437346b5263ab4$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $e6437346b5263ab4$var$operationIsLiveQuery(operation) ? $e6437346b5263ab4$var$DEFAULT_LIVE_FETCH_POLICY : $e6437346b5263ab4$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $e6437346b5263ab4$var$_objectSpread2["default"])((0, $e6437346b5263ab4$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($e6437346b5263ab4$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $e6437346b5263ab4$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $e6437346b5263ab4$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $e6437346b5263ab4$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $e6437346b5263ab4$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $e6437346b5263ab4$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $e6437346b5263ab4$var$_objectSpread2["default"])((0, $e6437346b5263ab4$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($e6437346b5263ab4$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $e6437346b5263ab4$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $bCunb(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $e6437346b5263ab4$var$createQueryResource(environment) {
    return new $e6437346b5263ab4$var$QueryResourceImpl(environment);
}
var $e6437346b5263ab4$var$dataResources = $e6437346b5263ab4$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $e6437346b5263ab4$var$getQueryResourceForEnvironment(environment) {
    var cached = $e6437346b5263ab4$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $e6437346b5263ab4$var$createQueryResource(environment);
    $e6437346b5263ab4$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $e6437346b5263ab4$var$createQueryResource,
    getQueryResourceForEnvironment: $e6437346b5263ab4$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $e6437346b5263ab4$var$getQueryCacheIdentifier
};

});
parcelRegister("c6QRH", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");
var $8d0f0d79fe62acda$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $bCunb(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $8d0f0d79fe62acda$var$create(capacity) {
    return new $8d0f0d79fe62acda$var$LRUCache(capacity);
}
module.exports = {
    create: $8d0f0d79fe62acda$var$create
};

});

parcelRegister("kcUMS", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $eb60fa680e8d8023$var$_interopRequireDefault = $j3tQw.default;

var $eb60fa680e8d8023$var$_defineProperty2 = $eb60fa680e8d8023$var$_interopRequireDefault((parcelRequire("geBXM")));
parcelRequire("fLDY5");
var $eb60fa680e8d8023$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $eb60fa680e8d8023$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $eb60fa680e8d8023$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $eb60fa680e8d8023$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $eb60fa680e8d8023$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $eb60fa680e8d8023$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $eb60fa680e8d8023$var$SuspenseResource;

});


parcelRegister("3tDtI", function(module, exports) {
'use strict';

var $9y5Sm = parcelRequire("9y5Sm");

var $fc4bM = parcelRequire("fc4bM");
var $2882b41d5d430b39$var$useCallback = $fc4bM.useCallback, $2882b41d5d430b39$var$useEffect = $fc4bM.useEffect;
function $2882b41d5d430b39$var$useFetchTrackingRef() {
    var subscriptionRef = $9y5Sm(null);
    var isFetchingRef = $9y5Sm(false);
    var disposeFetch = $2882b41d5d430b39$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $2882b41d5d430b39$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $2882b41d5d430b39$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $2882b41d5d430b39$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $2882b41d5d430b39$var$useFetchTrackingRef;

});
parcelRegister("9y5Sm", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");
var $6f3bd8da47cb7c8f$var$useMemo = $fc4bM.useMemo;
function $6f3bd8da47cb7c8f$var$useUnsafeRef_DEPRECATED(init) {
    return $6f3bd8da47cb7c8f$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $6f3bd8da47cb7c8f$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("9PBYb", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $728654731ce858e8$var$_interopRequireDefault = $j3tQw.default;

var $728654731ce858e8$var$_useFragmentInternal_CURRENT = $728654731ce858e8$var$_interopRequireDefault((parcelRequire("4ILus")));

var $728654731ce858e8$var$_useFragmentInternal_EXPERIMENTAL = $728654731ce858e8$var$_interopRequireDefault((parcelRequire("6k1AT")));

var $5KQKg = parcelRequire("5KQKg");
function $728654731ce858e8$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($5KQKg.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $728654731ce858e8$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $728654731ce858e8$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $728654731ce858e8$var$useFragmentInternal;

});
parcelRegister("4ILus", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $37001c0d68d4eefb$var$_interopRequireDefault = $j3tQw.default;

var $37001c0d68d4eefb$var$_objectSpread2 = $37001c0d68d4eefb$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $37001c0d68d4eefb$var$_createForOfIteratorHelper2 = $37001c0d68d4eefb$var$_interopRequireDefault((parcelRequire("cJrco")));

var $37001c0d68d4eefb$var$_toConsumableArray2 = $37001c0d68d4eefb$var$_interopRequireDefault((parcelRequire("6jwD6")));

var $jLGBa = parcelRequire("jLGBa");
var $37001c0d68d4eefb$var$getQueryResourceForEnvironment = $jLGBa.getQueryResourceForEnvironment;

var $jIrdm = parcelRequire("jIrdm");

var $5WaLW = parcelRequire("5WaLW");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $37001c0d68d4eefb$var$useDebugValue = $fc4bM.useDebugValue, $37001c0d68d4eefb$var$useEffect = $fc4bM.useEffect, $37001c0d68d4eefb$var$useMemo = $fc4bM.useMemo, $37001c0d68d4eefb$var$useRef = $fc4bM.useRef, $37001c0d68d4eefb$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $37001c0d68d4eefb$var$_require3$__internal = $5KQKg.__internal, $37001c0d68d4eefb$var$fetchQueryInternal = $37001c0d68d4eefb$var$_require3$__internal.fetchQuery, $37001c0d68d4eefb$var$getPromiseForActiveRequest = $37001c0d68d4eefb$var$_require3$__internal.getPromiseForActiveRequest, $37001c0d68d4eefb$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $37001c0d68d4eefb$var$areEqualSelectors = $5KQKg.areEqualSelectors, $37001c0d68d4eefb$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $37001c0d68d4eefb$var$getPendingOperationsForFragment = $5KQKg.getPendingOperationsForFragment, $37001c0d68d4eefb$var$getSelector = $5KQKg.getSelector, $37001c0d68d4eefb$var$getVariablesFromFragment = $5KQKg.getVariablesFromFragment, $37001c0d68d4eefb$var$handlePotentialSnapshotErrors = $5KQKg.handlePotentialSnapshotErrors, $37001c0d68d4eefb$var$recycleNodesInto = $5KQKg.recycleNodesInto;
parcelRequire("fLDY5");
function $37001c0d68d4eefb$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $37001c0d68d4eefb$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $37001c0d68d4eefb$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $37001c0d68d4eefb$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $37001c0d68d4eefb$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $37001c0d68d4eefb$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $37001c0d68d4eefb$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $37001c0d68d4eefb$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $37001c0d68d4eefb$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $bCunb(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $37001c0d68d4eefb$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $37001c0d68d4eefb$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $37001c0d68d4eefb$var$_objectSpread2["default"])((0, $37001c0d68d4eefb$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $37001c0d68d4eefb$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $37001c0d68d4eefb$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $37001c0d68d4eefb$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $37001c0d68d4eefb$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $37001c0d68d4eefb$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $37001c0d68d4eefb$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $37001c0d68d4eefb$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $37001c0d68d4eefb$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $37001c0d68d4eefb$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $37001c0d68d4eefb$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $37001c0d68d4eefb$var$useMemo(function() {
        return $37001c0d68d4eefb$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bCunb(false);
    else !!Array.isArray(fragmentRef) && $bCunb(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bCunb(false);
    var environment = $jIrdm();
    var loggerContext;
    if ($37001c0d68d4eefb$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $5WaLW();
    var _useState = $37001c0d68d4eefb$var$useState(function() {
        return $37001c0d68d4eefb$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $37001c0d68d4eefb$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $37001c0d68d4eefb$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $37001c0d68d4eefb$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$37001c0d68d4eefb$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $37001c0d68d4eefb$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $37001c0d68d4eefb$var$useRef(false);
    $37001c0d68d4eefb$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $37001c0d68d4eefb$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $37001c0d68d4eefb$var$useMemo(function() {
            var missingClientEdges = $37001c0d68d4eefb$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $37001c0d68d4eefb$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $37001c0d68d4eefb$var$useEffect(function() {
            var QueryResource = $37001c0d68d4eefb$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $37001c0d68d4eefb$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($37001c0d68d4eefb$var$isMissingData(state)) {
        var suspendingLiveResolvers = $37001c0d68d4eefb$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($37001c0d68d4eefb$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$37001c0d68d4eefb$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $bCunb(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $37001c0d68d4eefb$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $37001c0d68d4eefb$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $37001c0d68d4eefb$var$useRef(false);
    $37001c0d68d4eefb$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $37001c0d68d4eefb$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $37001c0d68d4eefb$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $37001c0d68d4eefb$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $37001c0d68d4eefb$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $bCunb(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $bCunb(false);
        data = state.snapshot.data;
    }
    if ($37001c0d68d4eefb$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $37001c0d68d4eefb$var$useFragmentInternal;

});
parcelRegister("5WaLW", function(module, exports) {
'use strict';

var $eIHkd = parcelRequire("eIHkd");

var $fc4bM = parcelRequire("fc4bM");
var $452ab9b1be06e73d$var$useContext = $fc4bM.useContext;
function $452ab9b1be06e73d$var$useRelayLoggingContext() {
    return $452ab9b1be06e73d$var$useContext($eIHkd);
}
module.exports = $452ab9b1be06e73d$var$useRelayLoggingContext;

});
parcelRegister("eIHkd", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $ab76c832cbeb643f$var$createRelayLoggingContext = $5KQKg.__internal.createRelayLoggingContext;
module.exports = $ab76c832cbeb643f$var$createRelayLoggingContext($fc4bM);

});



parcelRegister("6k1AT", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $49a5d8e08d245011$var$_interopRequireDefault = $j3tQw.default;

var $49a5d8e08d245011$var$_objectSpread2 = $49a5d8e08d245011$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $49a5d8e08d245011$var$_createForOfIteratorHelper2 = $49a5d8e08d245011$var$_interopRequireDefault((parcelRequire("cJrco")));

var $49a5d8e08d245011$var$_toConsumableArray2 = $49a5d8e08d245011$var$_interopRequireDefault((parcelRequire("6jwD6")));

var $jLGBa = parcelRequire("jLGBa");
var $49a5d8e08d245011$var$getQueryResourceForEnvironment = $jLGBa.getQueryResourceForEnvironment;

var $jIrdm = parcelRequire("jIrdm");

var $5WaLW = parcelRequire("5WaLW");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $49a5d8e08d245011$var$useDebugValue = $fc4bM.useDebugValue, $49a5d8e08d245011$var$useEffect = $fc4bM.useEffect, $49a5d8e08d245011$var$useMemo = $fc4bM.useMemo, $49a5d8e08d245011$var$useRef = $fc4bM.useRef, $49a5d8e08d245011$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $49a5d8e08d245011$var$_require3$__internal = $5KQKg.__internal, $49a5d8e08d245011$var$fetchQueryInternal = $49a5d8e08d245011$var$_require3$__internal.fetchQuery, $49a5d8e08d245011$var$getPromiseForActiveRequest = $49a5d8e08d245011$var$_require3$__internal.getPromiseForActiveRequest, $49a5d8e08d245011$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $49a5d8e08d245011$var$areEqualSelectors = $5KQKg.areEqualSelectors, $49a5d8e08d245011$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $49a5d8e08d245011$var$getPendingOperationsForFragment = $5KQKg.getPendingOperationsForFragment, $49a5d8e08d245011$var$getSelector = $5KQKg.getSelector, $49a5d8e08d245011$var$getVariablesFromFragment = $5KQKg.getVariablesFromFragment, $49a5d8e08d245011$var$handlePotentialSnapshotErrors = $5KQKg.handlePotentialSnapshotErrors, $49a5d8e08d245011$var$recycleNodesInto = $5KQKg.recycleNodesInto;
parcelRequire("fLDY5");
function $49a5d8e08d245011$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $49a5d8e08d245011$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $49a5d8e08d245011$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $49a5d8e08d245011$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $49a5d8e08d245011$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $49a5d8e08d245011$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $49a5d8e08d245011$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $49a5d8e08d245011$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $49a5d8e08d245011$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $bCunb(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $49a5d8e08d245011$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $49a5d8e08d245011$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $49a5d8e08d245011$var$_objectSpread2["default"])((0, $49a5d8e08d245011$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $49a5d8e08d245011$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $49a5d8e08d245011$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $49a5d8e08d245011$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $49a5d8e08d245011$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $49a5d8e08d245011$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $49a5d8e08d245011$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $49a5d8e08d245011$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $49a5d8e08d245011$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $49a5d8e08d245011$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $49a5d8e08d245011$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $49a5d8e08d245011$var$useMemo(function() {
        return $49a5d8e08d245011$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bCunb(false);
    else !!Array.isArray(fragmentRef) && $bCunb(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bCunb(false);
    var environment = $jIrdm();
    var loggerContext;
    if ($49a5d8e08d245011$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $5WaLW();
    var _useState = $49a5d8e08d245011$var$useState(function() {
        return $49a5d8e08d245011$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$49a5d8e08d245011$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $49a5d8e08d245011$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $49a5d8e08d245011$var$useRef(false);
    $49a5d8e08d245011$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $49a5d8e08d245011$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $49a5d8e08d245011$var$useMemo(function() {
            var missingClientEdges = $49a5d8e08d245011$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $49a5d8e08d245011$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $49a5d8e08d245011$var$useEffect(function() {
            var QueryResource = $49a5d8e08d245011$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $49a5d8e08d245011$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($49a5d8e08d245011$var$isMissingData(state)) {
        var suspendingLiveResolvers = $49a5d8e08d245011$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($49a5d8e08d245011$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$49a5d8e08d245011$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $bCunb(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $49a5d8e08d245011$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $49a5d8e08d245011$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $49a5d8e08d245011$var$useRef(null);
    $49a5d8e08d245011$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $49a5d8e08d245011$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $49a5d8e08d245011$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $49a5d8e08d245011$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $49a5d8e08d245011$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $49a5d8e08d245011$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $bCunb(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $bCunb(false);
        data = state.snapshot.data;
    }
    if ($49a5d8e08d245011$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $49a5d8e08d245011$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("dpmsU", function(module, exports) {
'use strict';

var $dvWL5 = parcelRequire("dvWL5");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $9c2f094e6c572005$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $9c2f094e6c572005$var$getRequest = $5KQKg.getRequest;
var $9c2f094e6c572005$var$useMemo = $fc4bM.useMemo;
function $9c2f094e6c572005$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $dvWL5(variables);
    var memoCacheConfig = $dvWL5(cacheConfig || {});
    return $9c2f094e6c572005$var$useMemo(function() {
        return $9c2f094e6c572005$var$createOperationDescriptor($9c2f094e6c572005$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $9c2f094e6c572005$var$useMemoOperationDescriptor;

});
parcelRegister("dvWL5", function(module, exports) {
'use strict';

var $lPzB2 = parcelRequire("lPzB2");

var $fc4bM = parcelRequire("fc4bM");
var $9d6bbfd22e8e3e03$var$useState = $fc4bM.useState;
function $9d6bbfd22e8e3e03$var$useMemoVariables(variables) {
    var _useState = $9d6bbfd22e8e3e03$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($lPzB2(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $9d6bbfd22e8e3e03$var$useMemoVariables;

});




parcelRegister("6XY4W", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $5126db20b2ba08ec$var$_interopRequireDefault = $j3tQw.default;

var $5126db20b2ba08ec$var$_createForOfIteratorHelper2 = $5126db20b2ba08ec$var$_interopRequireDefault((parcelRequire("cJrco")));

var $aTLj4 = parcelRequire("aTLj4");

var $7cUyl = parcelRequire("7cUyl");

var $fc4bM = parcelRequire("fc4bM");
var $5126db20b2ba08ec$var$useCallback = $fc4bM.useCallback, $5126db20b2ba08ec$var$useEffect = $fc4bM.useEffect, $5126db20b2ba08ec$var$useRef = $fc4bM.useRef, $5126db20b2ba08ec$var$useState = $fc4bM.useState;
var $5126db20b2ba08ec$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $5126db20b2ba08ec$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $5126db20b2ba08ec$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $7cUyl();
    var undisposedEntryPointReferencesRef = $5126db20b2ba08ec$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $5126db20b2ba08ec$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $5126db20b2ba08ec$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $5126db20b2ba08ec$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $5126db20b2ba08ec$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $aTLj4(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $5126db20b2ba08ec$var$useRef(false);
    $5126db20b2ba08ec$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $5126db20b2ba08ec$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $5126db20b2ba08ec$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $5126db20b2ba08ec$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $5126db20b2ba08ec$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $5126db20b2ba08ec$var$useLoadEntryPoint;

});
parcelRegister("7cUyl", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");
var $53f585a4db6fb851$var$useEffect = $fc4bM.useEffect, $53f585a4db6fb851$var$useRef = $fc4bM.useRef;
function $53f585a4db6fb851$var$useIsMountedRef() {
    var isMountedRef = $53f585a4db6fb851$var$useRef(true);
    $53f585a4db6fb851$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $53f585a4db6fb851$var$useIsMountedRef;

});


parcelRegister("ghHiT", function(module, exports) {
'use strict';

var $9PBYb = parcelRequire("9PBYb");

var $juPyG = parcelRequire("juPyG");

var $fc4bM = parcelRequire("fc4bM");
var $bdafd31c727bfbfe$var$useDebugValue = $fc4bM.useDebugValue;

var $5KQKg = parcelRequire("5KQKg");
var $bdafd31c727bfbfe$var$getFragment = $5KQKg.getFragment;
function $bdafd31c727bfbfe$var$useFragment(fragment, key) {
    var fragmentNode = $bdafd31c727bfbfe$var$getFragment(fragment);
    $juPyG(fragmentNode, 'first argument of useFragment()');
    var data = $9PBYb(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $bdafd31c727bfbfe$var$useFragment;

});
parcelRegister("juPyG", function(module, exports) {
'use strict';
parcelRequire("9y5Sm");
parcelRequire("fLDY5");
function $e318d01bdf19b967$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $e318d01bdf19b967$var$useStaticFragmentNodeWarning;

});


parcelRegister("9V8gE", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $738fd9acf20037b7$var$_interopRequireDefault = $j3tQw.default;

var $738fd9acf20037b7$var$_objectSpread2 = $738fd9acf20037b7$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $7cUyl = parcelRequire("7cUyl");

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $738fd9acf20037b7$var$defaultCommitMutation = $5KQKg.commitMutation;
var $738fd9acf20037b7$var$useState = $fc4bM.useState, $738fd9acf20037b7$var$useEffect = $fc4bM.useEffect, $738fd9acf20037b7$var$useRef = $fc4bM.useRef, $738fd9acf20037b7$var$useCallback = $fc4bM.useCallback;
function $738fd9acf20037b7$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $738fd9acf20037b7$var$defaultCommitMutation;
    var environment = $jIrdm();
    var isMountedRef = $7cUyl();
    var environmentRef = $738fd9acf20037b7$var$useRef(environment);
    var mutationRef = $738fd9acf20037b7$var$useRef(mutation);
    var inFlightMutationsRef = $738fd9acf20037b7$var$useRef(new Set());
    var _useState = $738fd9acf20037b7$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $738fd9acf20037b7$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $738fd9acf20037b7$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $738fd9acf20037b7$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $738fd9acf20037b7$var$_objectSpread2["default"])((0, $738fd9acf20037b7$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $738fd9acf20037b7$var$useMutation;

});

parcelRegister("7iuie", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $5501b66785e1f86e$var$_interopRequireDefault = $j3tQw.default;

var $5501b66785e1f86e$var$_objectSpread2 = $5501b66785e1f86e$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $gLnjF = parcelRequire("gLnjF");

var $l1sJu = parcelRequire("l1sJu");

var $jIrdm = parcelRequire("jIrdm");

var $juPyG = parcelRequire("juPyG");

var $fc4bM = parcelRequire("fc4bM");
var $5501b66785e1f86e$var$useCallback = $fc4bM.useCallback, $5501b66785e1f86e$var$useDebugValue = $fc4bM.useDebugValue, $5501b66785e1f86e$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $5501b66785e1f86e$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $5501b66785e1f86e$var$getFragment = $5KQKg.getFragment, $5501b66785e1f86e$var$getFragmentIdentifier = $5KQKg.getFragmentIdentifier, $5501b66785e1f86e$var$getPaginationMetadata = $5KQKg.getPaginationMetadata;
function $5501b66785e1f86e$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $5501b66785e1f86e$var$getFragment(fragmentInput);
    $juPyG(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $5501b66785e1f86e$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $l1sJu(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $5501b66785e1f86e$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $5501b66785e1f86e$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $5501b66785e1f86e$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $5501b66785e1f86e$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $5501b66785e1f86e$var$_objectSpread2["default"])((0, $5501b66785e1f86e$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $5501b66785e1f86e$var$useLoadMore(args) {
    var environment = $jIrdm();
    var _useState = $5501b66785e1f86e$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $5501b66785e1f86e$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $gLnjF((0, $5501b66785e1f86e$var$_objectSpread2["default"])((0, $5501b66785e1f86e$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $5501b66785e1f86e$var$usePaginationFragment;

});
parcelRegister("gLnjF", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $c3431f3d5d8403d0$var$_interopRequireDefault = $j3tQw.default;

var $c3431f3d5d8403d0$var$_objectSpread2 = $c3431f3d5d8403d0$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $kw5D7 = parcelRequire("kw5D7");

var $3tDtI = parcelRequire("3tDtI");

var $7cUyl = parcelRequire("7cUyl");

var $eWdVb = parcelRequire("eWdVb");

var $7zwJq = parcelRequire("7zwJq");

var $jIrdm = parcelRequire("jIrdm");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $c3431f3d5d8403d0$var$useCallback = $fc4bM.useCallback, $c3431f3d5d8403d0$var$useEffect = $fc4bM.useEffect, $c3431f3d5d8403d0$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $c3431f3d5d8403d0$var$fetchQuery = $5KQKg.__internal.fetchQuery, $c3431f3d5d8403d0$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $c3431f3d5d8403d0$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $c3431f3d5d8403d0$var$getPaginationVariables = $5KQKg.getPaginationVariables, $c3431f3d5d8403d0$var$getRefetchMetadata = $5KQKg.getRefetchMetadata, $c3431f3d5d8403d0$var$getSelector = $5KQKg.getSelector;
parcelRequire("fLDY5");
function $c3431f3d5d8403d0$var$useLoadMoreFunction(args) {
    if ($c3431f3d5d8403d0$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $7zwJq(args);
    return $c3431f3d5d8403d0$var$useLoadMoreFunction_CURRENT(args);
}
function $c3431f3d5d8403d0$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $jIrdm();
    var _useFetchTrackingRef = $3tDtI(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $c3431f3d5d8403d0$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $7cUyl();
    var _useState = $c3431f3d5d8403d0$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $c3431f3d5d8403d0$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $eWdVb(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $kw5D7(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $c3431f3d5d8403d0$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $c3431f3d5d8403d0$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $c3431f3d5d8403d0$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $bCunb(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $c3431f3d5d8403d0$var$_objectSpread2["default"])((0, $c3431f3d5d8403d0$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $c3431f3d5d8403d0$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $c3431f3d5d8403d0$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $c3431f3d5d8403d0$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $c3431f3d5d8403d0$var$fetchQuery(environment, paginationQuery).subscribe((0, $c3431f3d5d8403d0$var$_objectSpread2["default"])((0, $c3431f3d5d8403d0$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $c3431f3d5d8403d0$var$useLoadMoreFunction;

});
parcelRegister("kw5D7", function(module, exports) {
'use strict';

var $bCunb = parcelRequire("bCunb");

var $5KQKg = parcelRequire("5KQKg");
var $eefb29caf8e355fa$var$ConnectionInterface = $5KQKg.ConnectionInterface, $eefb29caf8e355fa$var$getValueAtPath = $5KQKg.getValueAtPath;
function $eefb29caf8e355fa$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $eefb29caf8e355fa$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $eefb29caf8e355fa$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $bCunb(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $bCunb(false);
    !(typeof pageInfo === 'object') && $bCunb(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $bCunb(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $eefb29caf8e355fa$var$getConnectionState;

});

parcelRegister("eWdVb", function(module, exports) {
'use strict';

var $jIrdm = parcelRequire("jIrdm");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");

var $5KQKg = parcelRequire("5KQKg");
var $ae0147f2d6128f1a$var$getObservableForActiveRequest = $5KQKg.__internal.getObservableForActiveRequest, $ae0147f2d6128f1a$var$getSelector = $5KQKg.getSelector;
var $ae0147f2d6128f1a$var$useEffect = $fc4bM.useEffect, $ae0147f2d6128f1a$var$useState = $fc4bM.useState, $ae0147f2d6128f1a$var$useMemo = $fc4bM.useMemo;
function $ae0147f2d6128f1a$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $jIrdm();
    var observable = $ae0147f2d6128f1a$var$useMemo(function() {
        var selector = $ae0147f2d6128f1a$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $bCunb(false);
        return $ae0147f2d6128f1a$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $ae0147f2d6128f1a$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $ae0147f2d6128f1a$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $ae0147f2d6128f1a$var$useIsOperationNodeActive;

});

parcelRegister("7zwJq", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $5835311eadd5206f$var$_interopRequireDefault = $j3tQw.default;

var $5835311eadd5206f$var$_objectSpread2 = $5835311eadd5206f$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $kw5D7 = parcelRequire("kw5D7");

var $7cUyl = parcelRequire("7cUyl");

var $eWdVb = parcelRequire("eWdVb");

var $jIrdm = parcelRequire("jIrdm");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $5835311eadd5206f$var$useCallback = $fc4bM.useCallback, $5835311eadd5206f$var$useRef = $fc4bM.useRef, $5835311eadd5206f$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $5835311eadd5206f$var$fetchQuery = $5KQKg.__internal.fetchQuery, $5835311eadd5206f$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $5835311eadd5206f$var$getPaginationVariables = $5KQKg.getPaginationVariables, $5835311eadd5206f$var$getRefetchMetadata = $5KQKg.getRefetchMetadata, $5835311eadd5206f$var$getSelector = $5KQKg.getSelector;
parcelRequire("fLDY5");
function $5835311eadd5206f$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $jIrdm();
    var _getRefetchMetadata = $5835311eadd5206f$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $5835311eadd5206f$var$useRef({
        kind: 'none'
    });
    var _useState = $5835311eadd5206f$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $5835311eadd5206f$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $eWdVb(fragmentNode, fragmentRef);
    var forceDisposeFn = $5835311eadd5206f$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $kw5D7(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $7cUyl();
    var loadMore = $5835311eadd5206f$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $5835311eadd5206f$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $bCunb(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $5835311eadd5206f$var$_objectSpread2["default"])((0, $5835311eadd5206f$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $5835311eadd5206f$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $5835311eadd5206f$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $5835311eadd5206f$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $5835311eadd5206f$var$fetchQuery(environment, paginationQuery).subscribe((0, $5835311eadd5206f$var$_objectSpread2["default"])((0, $5835311eadd5206f$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $5835311eadd5206f$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("l1sJu", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $f4dffaaedc85c45d$var$_interopRequireDefault = $j3tQw.default;

var $f4dffaaedc85c45d$var$_objectSpread2 = $f4dffaaedc85c45d$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $v2hvX = parcelRequire("v2hvX");

var $jLGBa = parcelRequire("jLGBa");
var $f4dffaaedc85c45d$var$getQueryResourceForEnvironment = $jLGBa.getQueryResourceForEnvironment;

var $13nPA = parcelRequire("13nPA");

var $9PBYb = parcelRequire("9PBYb");

var $7cUyl = parcelRequire("7cUyl");

var $i4SF2 = parcelRequire("i4SF2");

var $jIrdm = parcelRequire("jIrdm");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $f4dffaaedc85c45d$var$useCallback = $fc4bM.useCallback, $f4dffaaedc85c45d$var$useContext = $fc4bM.useContext, $f4dffaaedc85c45d$var$useReducer = $fc4bM.useReducer;

var $5KQKg = parcelRequire("5KQKg");
var $f4dffaaedc85c45d$var$fetchQuery = $5KQKg.__internal.fetchQuery, $f4dffaaedc85c45d$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $f4dffaaedc85c45d$var$getFragmentIdentifier = $5KQKg.getFragmentIdentifier, $f4dffaaedc85c45d$var$getRefetchMetadata = $5KQKg.getRefetchMetadata, $f4dffaaedc85c45d$var$getSelector = $5KQKg.getSelector, $f4dffaaedc85c45d$var$getValueAtPath = $5KQKg.getValueAtPath;
parcelRequire("fLDY5");
function $f4dffaaedc85c45d$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $f4dffaaedc85c45d$var$_objectSpread2["default"])((0, $f4dffaaedc85c45d$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $f4dffaaedc85c45d$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $jIrdm();
    var _getRefetchMetadata = $f4dffaaedc85c45d$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $f4dffaaedc85c45d$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $f4dffaaedc85c45d$var$useReducer($f4dffaaedc85c45d$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $f4dffaaedc85c45d$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $f4dffaaedc85c45d$var$useContext($v2hvX);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $i4SF2(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $f4dffaaedc85c45d$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $13nPA(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $bCunb(false);
        var refetchedFragmentRef = $f4dffaaedc85c45d$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $9PBYb(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $f4dffaaedc85c45d$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $f4dffaaedc85c45d$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $7cUyl();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $f4dffaaedc85c45d$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $f4dffaaedc85c45d$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $f4dffaaedc85c45d$var$_objectSpread2["default"])((0, $f4dffaaedc85c45d$var$_objectSpread2["default"])((0, $f4dffaaedc85c45d$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $f4dffaaedc85c45d$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $f4dffaaedc85c45d$var$debugFunctions;
module.exports = $f4dffaaedc85c45d$var$useRefetchableFragmentInternal;

});
parcelRegister("13nPA", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $0c488e98184cb52b$var$_interopRequireDefault = $j3tQw.default;

var $0c488e98184cb52b$var$_objectSpread2 = $0c488e98184cb52b$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $0c488e98184cb52b$var$_createForOfIteratorHelper2 = $0c488e98184cb52b$var$_interopRequireDefault((parcelRequire("cJrco")));

var $jLGBa = parcelRequire("jLGBa");
var $0c488e98184cb52b$var$getQueryResourceForEnvironment = $jLGBa.getQueryResourceForEnvironment;

var $bCunb = parcelRequire("bCunb");

var $5KQKg = parcelRequire("5KQKg");
var $0c488e98184cb52b$var$fetchQueryInternal = $5KQKg.__internal.fetchQuery, $0c488e98184cb52b$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $0c488e98184cb52b$var$createOperationDescriptor = $5KQKg.createOperationDescriptor, $0c488e98184cb52b$var$getPendingOperationsForFragment = $5KQKg.getPendingOperationsForFragment, $0c488e98184cb52b$var$getSelector = $5KQKg.getSelector, $0c488e98184cb52b$var$getVariablesFromFragment = $5KQKg.getVariablesFromFragment, $0c488e98184cb52b$var$handlePotentialSnapshotErrors = $5KQKg.handlePotentialSnapshotErrors;
parcelRequire("fLDY5");
function $0c488e98184cb52b$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $0c488e98184cb52b$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $0c488e98184cb52b$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $0c488e98184cb52b$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $0c488e98184cb52b$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $0c488e98184cb52b$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $0c488e98184cb52b$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $0c488e98184cb52b$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $0c488e98184cb52b$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $0c488e98184cb52b$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $0c488e98184cb52b$var$_objectSpread2["default"])((0, $0c488e98184cb52b$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $0c488e98184cb52b$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $0c488e98184cb52b$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $0c488e98184cb52b$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $0c488e98184cb52b$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $0c488e98184cb52b$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $0c488e98184cb52b$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bCunb(false);
    else !!Array.isArray(fragmentRef) && $bCunb(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bCunb(false);
    var state = $0c488e98184cb52b$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $0c488e98184cb52b$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $0c488e98184cb52b$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $0c488e98184cb52b$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($0c488e98184cb52b$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($0c488e98184cb52b$var$isMissingData(state)) {
        !(fragmentSelector != null) && $bCunb(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $0c488e98184cb52b$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $0c488e98184cb52b$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($0c488e98184cb52b$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $0c488e98184cb52b$var$readFragmentInternal;

});

parcelRegister("i4SF2", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $d293003ca5d63ad1$var$_interopRequireDefault = $j3tQw.default;

var $d293003ca5d63ad1$var$_createForOfIteratorHelper2 = $d293003ca5d63ad1$var$_interopRequireDefault((parcelRequire("cJrco")));

var $l0KzO = parcelRequire("l0KzO");
var $d293003ca5d63ad1$var$loadQuery = $l0KzO.loadQuery;

var $7cUyl = parcelRequire("7cUyl");

var $35Ysl = parcelRequire("35Ysl");

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");
var $d293003ca5d63ad1$var$useCallback = $fc4bM.useCallback, $d293003ca5d63ad1$var$useEffect = $fc4bM.useEffect, $d293003ca5d63ad1$var$useRef = $fc4bM.useRef, $d293003ca5d63ad1$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $d293003ca5d63ad1$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $d293003ca5d63ad1$var$getRequest = $5KQKg.getRequest;
var $d293003ca5d63ad1$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $d293003ca5d63ad1$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $d293003ca5d63ad1$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $d293003ca5d63ad1$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($d293003ca5d63ad1$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $35Ysl(preloadableRequest, initialQueryReference);
    return $d293003ca5d63ad1$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $d293003ca5d63ad1$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $d293003ca5d63ad1$var$initialNullQueryReferenceState;
    var environment = $jIrdm();
    var isMountedRef = $7cUyl();
    var undisposedQueryReferencesRef = $d293003ca5d63ad1$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $d293003ca5d63ad1$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $d293003ca5d63ad1$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $d293003ca5d63ad1$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($d293003ca5d63ad1$var$initialNullQueryReferenceState);
            setQueryReference($d293003ca5d63ad1$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $d293003ca5d63ad1$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $d293003ca5d63ad1$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $d293003ca5d63ad1$var$useRef(false);
    $d293003ca5d63ad1$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $d293003ca5d63ad1$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $d293003ca5d63ad1$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($d293003ca5d63ad1$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $d293003ca5d63ad1$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $d293003ca5d63ad1$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($d293003ca5d63ad1$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $d293003ca5d63ad1$var$useQueryLoader;

});
parcelRegister("35Ysl", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $2410bc12d5d1ccf5$var$_interopRequireDefault = $j3tQw.default;

var $2410bc12d5d1ccf5$var$_createForOfIteratorHelper2 = $2410bc12d5d1ccf5$var$_interopRequireDefault((parcelRequire("cJrco")));

var $l0KzO = parcelRequire("l0KzO");
var $2410bc12d5d1ccf5$var$loadQuery = $l0KzO.loadQuery;

var $7cUyl = parcelRequire("7cUyl");

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");
var $2410bc12d5d1ccf5$var$useCallback = $fc4bM.useCallback, $2410bc12d5d1ccf5$var$useEffect = $fc4bM.useEffect, $2410bc12d5d1ccf5$var$useInsertionEffect = $fc4bM.useInsertionEffect, $2410bc12d5d1ccf5$var$useRef = $fc4bM.useRef, $2410bc12d5d1ccf5$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $2410bc12d5d1ccf5$var$getRequest = $5KQKg.getRequest;
var $2410bc12d5d1ccf5$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $2410bc12d5d1ccf5$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $2410bc12d5d1ccf5$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $2410bc12d5d1ccf5$var$CLEANUP_TIMEOUT = 300000;
function $2410bc12d5d1ccf5$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $2410bc12d5d1ccf5$var$initialNullQueryReferenceState;
    var environment = $jIrdm();
    var isMountedRef = $7cUyl();
    var undisposedQueryReferencesRef = $2410bc12d5d1ccf5$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $2410bc12d5d1ccf5$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $2410bc12d5d1ccf5$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $2410bc12d5d1ccf5$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($2410bc12d5d1ccf5$var$initialNullQueryReferenceState);
            setQueryReference($2410bc12d5d1ccf5$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $2410bc12d5d1ccf5$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $2410bc12d5d1ccf5$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $2410bc12d5d1ccf5$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $2410bc12d5d1ccf5$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($2410bc12d5d1ccf5$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $2410bc12d5d1ccf5$var$useRef(null);
    $2410bc12d5d1ccf5$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $2410bc12d5d1ccf5$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $2410bc12d5d1ccf5$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $2410bc12d5d1ccf5$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("eW9Rn", function(module, exports) {
'use strict';

var $j3tQw = parcelRequire("j3tQw");
var $adfe216b984aaa05$var$_interopRequireDefault = $j3tQw.default;

var $adfe216b984aaa05$var$_objectSpread2 = $adfe216b984aaa05$var$_interopRequireDefault((parcelRequire("MwqMq")));

var $ghHiT = parcelRequire("ghHiT");

var $gLnjF = parcelRequire("gLnjF");

var $l1sJu = parcelRequire("l1sJu");

var $jIrdm = parcelRequire("jIrdm");

var $juPyG = parcelRequire("juPyG");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $adfe216b984aaa05$var$useCallback = $fc4bM.useCallback, $adfe216b984aaa05$var$useDebugValue = $fc4bM.useDebugValue, $adfe216b984aaa05$var$useEffect = $fc4bM.useEffect, $adfe216b984aaa05$var$useLayoutEffect = $fc4bM.useLayoutEffect, $adfe216b984aaa05$var$useMemo = $fc4bM.useMemo, $adfe216b984aaa05$var$useRef = $fc4bM.useRef, $adfe216b984aaa05$var$useState = $fc4bM.useState;

var $5KQKg = parcelRequire("5KQKg");
var $adfe216b984aaa05$var$getFragment = $5KQKg.getFragment, $adfe216b984aaa05$var$getFragmentIdentifier = $5KQKg.getFragmentIdentifier, $adfe216b984aaa05$var$getPaginationMetadata = $5KQKg.getPaginationMetadata;

var $5KQKg = parcelRequire("5KQKg");
var $adfe216b984aaa05$var$ConnectionInterface = $5KQKg.ConnectionInterface, $adfe216b984aaa05$var$RelayFeatureFlags = $5KQKg.RelayFeatureFlags, $adfe216b984aaa05$var$getSelector = $5KQKg.getSelector, $adfe216b984aaa05$var$getValueAtPath = $5KQKg.getValueAtPath;
function $adfe216b984aaa05$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $adfe216b984aaa05$var$getFragment(fragmentInput);
    $juPyG(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $adfe216b984aaa05$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $l1sJu(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $adfe216b984aaa05$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $adfe216b984aaa05$var$useMemo(function() {
        var connection = $adfe216b984aaa05$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $adfe216b984aaa05$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $adfe216b984aaa05$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $jIrdm();
    var _useState2 = $adfe216b984aaa05$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $adfe216b984aaa05$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $adfe216b984aaa05$var$useRef(0);
    var setIsLoadingMore = $adfe216b984aaa05$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $adfe216b984aaa05$var$useRef(false);
    var observer = $adfe216b984aaa05$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $adfe216b984aaa05$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $adfe216b984aaa05$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $gLnjF({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $adfe216b984aaa05$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $adfe216b984aaa05$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $adfe216b984aaa05$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $bCunb(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $bCunb(false);
    $adfe216b984aaa05$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $adfe216b984aaa05$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $bCunb(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $adfe216b984aaa05$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $ghHiT(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $adfe216b984aaa05$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $adfe216b984aaa05$var$_objectSpread2["default"])((0, $adfe216b984aaa05$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $adfe216b984aaa05$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("dvC0l", function(module, exports) {
'use strict';

var $8Ifj5 = parcelRequire("8Ifj5");

var $dpmsU = parcelRequire("dpmsU");

var $jIrdm = parcelRequire("jIrdm");

var $bCunb = parcelRequire("bCunb");

var $fc4bM = parcelRequire("fc4bM");
var $9d5ba680b547854b$var$useDebugValue = $fc4bM.useDebugValue;

var $5KQKg = parcelRequire("5KQKg");
var $9d5ba680b547854b$var$_require2$__internal = $5KQKg.__internal, $9d5ba680b547854b$var$fetchQueryDeduped = $9d5ba680b547854b$var$_require2$__internal.fetchQueryDeduped, $9d5ba680b547854b$var$fetchQuery = $9d5ba680b547854b$var$_require2$__internal.fetchQuery;
parcelRequire("fLDY5");
function $9d5ba680b547854b$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $jIrdm();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $dpmsU(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $bCunb(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $9d5ba680b547854b$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $9d5ba680b547854b$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $8Ifj5(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $9d5ba680b547854b$var$usePreloadedQuery;

});

parcelRegister("86KBN", function(module, exports) {
'use strict';

var $l1sJu = parcelRequire("l1sJu");

var $juPyG = parcelRequire("juPyG");

var $fc4bM = parcelRequire("fc4bM");
var $5e7309bf38fda257$var$useDebugValue = $fc4bM.useDebugValue;

var $5KQKg = parcelRequire("5KQKg");
var $5e7309bf38fda257$var$getFragment = $5KQKg.getFragment;
function $5e7309bf38fda257$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $5e7309bf38fda257$var$getFragment(fragmentInput);
    $juPyG(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $l1sJu(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $5e7309bf38fda257$var$useRefetchableFragment;

});

parcelRegister("3hsec", function(module, exports) {
'use strict';

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");
var $2638db21bf62a32c$var$useEffect = $fc4bM.useEffect, $2638db21bf62a32c$var$useRef = $fc4bM.useRef;
function $2638db21bf62a32c$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $jIrdm();
    var disposableRef = $2638db21bf62a32c$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $2638db21bf62a32c$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $2638db21bf62a32c$var$useSubscribeToInvalidationState;

});

parcelRegister("9FKKq", function(module, exports) {
'use strict';

var $jIrdm = parcelRequire("jIrdm");

var $fc4bM = parcelRequire("fc4bM");
var $70ac3481f17c5be2$var$useEffect = $fc4bM.useEffect;

var $5KQKg = parcelRequire("5KQKg");
var $70ac3481f17c5be2$var$requestSubscription = $5KQKg.requestSubscription;
function $70ac3481f17c5be2$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $70ac3481f17c5be2$var$requestSubscription;
    var environment = $jIrdm();
    $70ac3481f17c5be2$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $70ac3481f17c5be2$var$useSubscription;

});



parcelRegister("d6hfC", function(module, exports) {
$parcel$export(module.exports, "updateUserModelAction", () => (parcelRequire("7m3Xa")).updateUserModelAction);
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => (parcelRequire("7m3Xa")).UPDATE_USER_MODEL);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => (parcelRequire("7m3Xa")).updateUserModelAnonymousAction);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => (parcelRequire("7m3Xa")).UPDATE_USER_TO_ANON);
$parcel$export(module.exports, "saveUserProfile", () => (parcelRequire("7m3Xa")).saveUserProfile);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => (parcelRequire("7m3Xa")).SAVE_USER_PROFILE);
$parcel$export(module.exports, "saveUserProfileFailure", () => (parcelRequire("7m3Xa")).saveUserProfileFailure);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => (parcelRequire("7m3Xa")).SAVE_USER_PROFILE_FAILURE);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => (parcelRequire("7m3Xa")).setUserProfileValidationErrors);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => (parcelRequire("7m3Xa")).SET_USER_PROFILE_VALIDATION_ERRORS);
$parcel$export(module.exports, "saveUserProfileSuccess", () => (parcelRequire("7m3Xa")).saveUserProfileSuccess);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => (parcelRequire("7m3Xa")).SAVE_USER_PROFILE_SUCCESS);
$parcel$export(module.exports, "showChangePasswordDialog", () => (parcelRequire("7m3Xa")).showChangePasswordDialog);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("7m3Xa")).SHOW_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "closeChangePasswordDialog", () => (parcelRequire("7m3Xa")).closeChangePasswordDialog);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("7m3Xa")).CLOSE_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => (parcelRequire("7m3Xa")).validateAndSavePasswordChange);
$parcel$export(module.exports, "validatePassword", () => (parcelRequire("7m3Xa")).validatePassword);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => (parcelRequire("7m3Xa")).VALIDATE_PASSWORD);
$parcel$export(module.exports, "validatePasswordSuccess", () => (parcelRequire("7m3Xa")).validatePasswordSuccess);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => (parcelRequire("7m3Xa")).VALIDATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => (parcelRequire("7m3Xa")).VALIDATE_AND_SAVE_PASSWORD_CHANGE);
$parcel$export(module.exports, "changePassword", () => (parcelRequire("7m3Xa")).changePassword);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => (parcelRequire("7m3Xa")).CHANGE_PASSWORD);
$parcel$export(module.exports, "changePasswordFailure", () => (parcelRequire("7m3Xa")).changePasswordFailure);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => (parcelRequire("7m3Xa")).CHANGE_PASSWORD_FAILURE);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => (parcelRequire("7m3Xa")).CHANGE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "successfullyLoggedIn", () => (parcelRequire("7m3Xa")).successfullyLoggedIn);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => (parcelRequire("7m3Xa")).SUCCESSFULLY_LOGGED_IN);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => (parcelRequire("7m3Xa")).UPDATE_USER_REQUESTS_COUNTS_MODEL);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("7m3Xa")).forgotPassword);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("7m3Xa")).forgotPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordFailure", () => (parcelRequire("7m3Xa")).forgotPasswordFailure);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => (parcelRequire("7m3Xa")).USER_PROFILE_FORGOT_PASSWORD);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("7m3Xa")).USER_PROFILE_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("7m3Xa")).USER_PROFILE_FORGOT_PASSWORD_FAILURE);

var $7m3Xa = parcelRequire("7m3Xa");

});
parcelRegister("7m3Xa", function(module, exports) {
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => $428d2bfe84170343$export$bb738d1d47f9c080);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => $428d2bfe84170343$export$e2e5f617828e4213);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => $428d2bfe84170343$export$b1b3790fd3dd41e);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => $428d2bfe84170343$export$ed8e9a22a73d5238);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => $428d2bfe84170343$export$c705a7e05c58a85d);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => $428d2bfe84170343$export$617cd283d6722784);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => $428d2bfe84170343$export$9e99a97090f99b20);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => $428d2bfe84170343$export$dbaf6c31aeaab4c0);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => $428d2bfe84170343$export$15f268d233a1a9e8);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => $428d2bfe84170343$export$5ea2388969a07735);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => $428d2bfe84170343$export$d4203d6239c0a45f);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => $428d2bfe84170343$export$2776cc46c0e74482);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => $428d2bfe84170343$export$87c02ba615b030f7);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => $428d2bfe84170343$export$67e8c4b0fd356271);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => $428d2bfe84170343$export$52dd5c72d66642a1);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => $428d2bfe84170343$export$8095eb34b5a9bf48);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => $428d2bfe84170343$export$b03aac23a3b960e0);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => $428d2bfe84170343$export$fd1274b492be3442);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => $428d2bfe84170343$export$228c8378e3cf38db);
$parcel$export(module.exports, "updateUserModelAction", () => $428d2bfe84170343$export$e64d70be6597f269);
$parcel$export(module.exports, "updateUserRequestsCountsAction", () => $428d2bfe84170343$export$8de1e14d714c3764);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => $428d2bfe84170343$export$c79034a87b96133d);
$parcel$export(module.exports, "saveUserProfile", () => $428d2bfe84170343$export$12b30392f405d671);
$parcel$export(module.exports, "saveUserProfileSuccess", () => $428d2bfe84170343$export$7ded1c1b185ee372);
$parcel$export(module.exports, "saveUserProfileFailure", () => $428d2bfe84170343$export$bb55fe7965c57a31);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => $428d2bfe84170343$export$f5417889851341ee);
$parcel$export(module.exports, "showChangePasswordDialog", () => $428d2bfe84170343$export$b473bd12e6a9a566);
$parcel$export(module.exports, "closeChangePasswordDialog", () => $428d2bfe84170343$export$1a2f283b7350e33f);
$parcel$export(module.exports, "validatePassword", () => $428d2bfe84170343$export$4d2a7159fda5dc93);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => $428d2bfe84170343$export$3d37c4744747732c);
$parcel$export(module.exports, "changePassword", () => $428d2bfe84170343$export$99d837dc30eb1ef7);
$parcel$export(module.exports, "validatePasswordSuccess", () => $428d2bfe84170343$export$6c2ac98735d96a42);
$parcel$export(module.exports, "changePasswordFailure", () => $428d2bfe84170343$export$a60289eb7ee45981);
$parcel$export(module.exports, "successfullyLoggedIn", () => $428d2bfe84170343$export$ffc865c9cfe87560);
$parcel$export(module.exports, "forgotPassword", () => $428d2bfe84170343$export$66791fb2cfeec3e);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $428d2bfe84170343$export$e65d2e9031cf7578);
$parcel$export(module.exports, "forgotPasswordFailure", () => $428d2bfe84170343$export$c82fc620622643dd);
const $428d2bfe84170343$export$bb738d1d47f9c080 = 'state.persisted.user.UPDATE_USER_MODEL';
const $428d2bfe84170343$export$e2e5f617828e4213 = 'state.persisted.user.UPDATE_USER_REQUESTS_COUNTS_MODEL';
const $428d2bfe84170343$export$b1b3790fd3dd41e = 'state.persisted.user.UPDATE_USER_TO_ANON';
const $428d2bfe84170343$export$ed8e9a22a73d5238 = 'state.persisted.user.SAVE_USER_PROFILE';
const $428d2bfe84170343$export$c705a7e05c58a85d = 'state.persisted.user.SAVE_USER_PROFILE_SUCCESS';
const $428d2bfe84170343$export$617cd283d6722784 = 'state.persisted.user.SAVE_USER_PROFILE_FAILURE';
const $428d2bfe84170343$export$9e99a97090f99b20 = 'state.persisted.user.SET_USER_PROFILE_VALIDATION_ERRORS';
const $428d2bfe84170343$export$dbaf6c31aeaab4c0 = 'state.persisted.user.SUCCESSFULLY_LOGGED_IN';
const $428d2bfe84170343$export$15f268d233a1a9e8 = 'state.ui.user.profile.SHOW_CHANGE_PASSWORD_DIALOG';
const $428d2bfe84170343$export$5ea2388969a07735 = 'state.ui.user.profile.CLOSE_CHANGE_PASSWORD_DIALOG';
const $428d2bfe84170343$export$d4203d6239c0a45f = 'state.persisted.user.VALIDATE_AND_SAVE_PASSWORD_CHANGE';
const $428d2bfe84170343$export$2776cc46c0e74482 = 'state.persisted.user.VALIDATE_PASSWORD';
const $428d2bfe84170343$export$87c02ba615b030f7 = 'state.persisted.user.VALIDATE_PASSWORD_SUCCESS';
const $428d2bfe84170343$export$67e8c4b0fd356271 = 'state.persisted.user.CHANGE_PASSWORD';
const $428d2bfe84170343$export$52dd5c72d66642a1 = 'state.persisted.user.CHANGE_PASSWORD_SUCCESS';
const $428d2bfe84170343$export$8095eb34b5a9bf48 = 'state.persisted.user.CHANGE_PASSWORD_FAILURE';
const $428d2bfe84170343$export$b03aac23a3b960e0 = 'state.ui.user.profile.FORGOT_PASSWORD';
const $428d2bfe84170343$export$fd1274b492be3442 = 'state.ui.user.profile.FORGOT_PASSWORD_SUCCESS';
const $428d2bfe84170343$export$228c8378e3cf38db = 'state.ui.user.profile.FORGOT_PASSWORD_FAILURE';
const $428d2bfe84170343$export$e64d70be6597f269 = (userResponse)=>({
        payload: userResponse,
        type: $428d2bfe84170343$export$bb738d1d47f9c080
    });
const $428d2bfe84170343$export$8de1e14d714c3764 = (userRequestsCountsResponse)=>({
        payload: userRequestsCountsResponse,
        type: $428d2bfe84170343$export$e2e5f617828e4213
    });
const $428d2bfe84170343$export$c79034a87b96133d = ()=>({
        type: $428d2bfe84170343$export$b1b3790fd3dd41e
    });
const $428d2bfe84170343$export$12b30392f405d671 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $428d2bfe84170343$export$ed8e9a22a73d5238
    });
const $428d2bfe84170343$export$7ded1c1b185ee372 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $428d2bfe84170343$export$c705a7e05c58a85d
    });
const $428d2bfe84170343$export$bb55fe7965c57a31 = ()=>({
        type: $428d2bfe84170343$export$617cd283d6722784
    });
const $428d2bfe84170343$export$f5417889851341ee = (nameError, timezoneError)=>({
        payload: {
            nameError: nameError,
            timezoneError: timezoneError
        },
        type: $428d2bfe84170343$export$9e99a97090f99b20
    });
const $428d2bfe84170343$export$b473bd12e6a9a566 = ()=>({
        type: $428d2bfe84170343$export$15f268d233a1a9e8
    });
const $428d2bfe84170343$export$1a2f283b7350e33f = ()=>({
        type: $428d2bfe84170343$export$5ea2388969a07735
    });
const $428d2bfe84170343$export$4d2a7159fda5dc93 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $428d2bfe84170343$export$2776cc46c0e74482
    });
const $428d2bfe84170343$export$3d37c4744747732c = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $428d2bfe84170343$export$d4203d6239c0a45f
    });
const $428d2bfe84170343$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $428d2bfe84170343$export$67e8c4b0fd356271
    });
const $428d2bfe84170343$export$6c2ac98735d96a42 = ()=>({
        type: $428d2bfe84170343$export$87c02ba615b030f7
    });
const $428d2bfe84170343$export$592a066e988f52df = ()=>({
        type: $428d2bfe84170343$export$52dd5c72d66642a1
    });
const $428d2bfe84170343$export$a60289eb7ee45981 = (currentPasswordError, newPasswordError, confirmPasswordError, generalError)=>({
        payload: {
            currentPasswordError: currentPasswordError,
            newPasswordError: newPasswordError,
            confirmPasswordError: confirmPasswordError,
            generalError: generalError
        },
        type: $428d2bfe84170343$export$8095eb34b5a9bf48
    });
const $428d2bfe84170343$export$ffc865c9cfe87560 = ()=>{
    return {
        type: $428d2bfe84170343$export$dbaf6c31aeaab4c0
    };
};
const $428d2bfe84170343$export$66791fb2cfeec3e = (resetUrl, email, createAnalyticsEvent)=>({
        type: $428d2bfe84170343$export$b03aac23a3b960e0,
        payload: {
            resetUrl: resetUrl,
            email: email,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $428d2bfe84170343$export$e65d2e9031cf7578 = ()=>({
        type: $428d2bfe84170343$export$fd1274b492be3442
    });
const $428d2bfe84170343$export$c82fc620622643dd = ()=>({
        type: $428d2bfe84170343$export$228c8378e3cf38db
    });

});


parcelRegister("7zWyU", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e10d4f4cb4e9905$export$2e2bcd8739ae039);
parcelRequire("UZaDE");
var $kbJSm = parcelRequire("kbJSm");
var $bLO8A = parcelRequire("bLO8A");
var $9DdYZ = parcelRequire("9DdYZ");
var $6tkGS = parcelRequire("6tkGS");
parcelRequire("e19ob");
var $eH2bk = parcelRequire("eH2bk");

var $lhUKW = parcelRequire("lhUKW");

var $ivlng = parcelRequire("ivlng");

var $d6WEC = parcelRequire("d6WEC");

var $j0mQl = parcelRequire("j0mQl");
const $7e10d4f4cb4e9905$var$createReducer = (asyncPersistedReducers, asyncUIReducers)=>{
    const persisted = (0, $ivlng.getCombinedPersistedReducer)(asyncPersistedReducers);
    const ui = (0, $j0mQl.getCombinedUIReducer)(asyncUIReducers);
    return (0, $bLO8A.default)({
        persisted: persisted,
        ui: ui
    });
};
/**
 * Sometimes we want to run storybooks as standalone apps so we can embed them. In that case they
 * behave a little differently to when they are embedded inside the Storybook application frame.
 * This checks a query parameter to make sure we don't run into CORS issues.
 *
 * @returns True if we're in a storybook and it's being embedded outside the usual storybook frame.
 */ const $7e10d4f4cb4e9905$var$isStandaloneStory = ()=>{
    const params = new URLSearchParams(window.location.search);
    return (params.get('singleStory') || params.get('singlestory')) === 'true';
};
function $7e10d4f4cb4e9905$export$2e2bcd8739ae039({ initialState: initialState, middleware: middleware = [], initializeEpics: initializeEpics = true } = {}) {
    // Enables redux for storybook
    // trueWindow will hold the value of the window in which portal is loaded
    let trueWindow;
    // if portal is loaded inside an iframe, window.self will not be equal to window.top
    if ($7e10d4f4cb4e9905$var$isStandaloneStory() || window.self !== window.top) trueWindow = window.self || window;
    else trueWindow = window.parent || window;
    const composeEnhancers = trueWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $9DdYZ.default);
    const epicMiddlewares = initializeEpics ? [
        (0, $eH2bk.createEpicMiddleware)((0, $lhUKW.default))
    ] : [];
    const store = (0, $6tkGS.default)((0, $d6WEC.default), initialState || {}, composeEnhancers((0, $kbJSm.default)(...epicMiddlewares, ...middleware)));
    let asyncPersistedReducers = {};
    let asyncUIReducers = {};
    const injectReducer = (storeType, key, asyncReducer)=>{
        if (storeType === 'ui') asyncUIReducers = {
            ...asyncUIReducers,
            [key]: asyncReducer
        };
        if (storeType === 'persisted') asyncPersistedReducers = {
            ...asyncPersistedReducers,
            [key]: asyncReducer
        };
        store.replaceReducer($7e10d4f4cb4e9905$var$createReducer(asyncPersistedReducers, asyncUIReducers));
    };
    return {
        store: store,
        injectReducer: injectReducer
    };
}

});
parcelRegister("e19ob", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => (parcelRequire("eH2bk")).createEpicMiddleware);
$parcel$export(module.exports, "combineEpics", () => (parcelRequire("eSm63")).combineEpics);

var $eH2bk = parcelRequire("eH2bk");

var $DiL3U = parcelRequire("DiL3U");

var $eSm63 = parcelRequire("eSm63");

var $PZ1Kh = parcelRequire("PZ1Kh");

var $fmN5F = parcelRequire("fmN5F");

});
parcelRegister("eH2bk", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => $ab26c6126b9362e2$export$147cf6f7ce5462cb);

var $aSveF = parcelRequire("aSveF");

var $2RyB9 = parcelRequire("2RyB9");

var $jXTSa = parcelRequire("jXTSa");

var $DiL3U = parcelRequire("DiL3U");

var $PZ1Kh = parcelRequire("PZ1Kh");
var $ab26c6126b9362e2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ab26c6126b9362e2$var$defaultAdapter = {
    input: function input(action$) {
        return action$;
    },
    output: function output(action$) {
        return action$;
    }
};
var $ab26c6126b9362e2$var$defaultOptions = {
    adapter: $ab26c6126b9362e2$var$defaultAdapter
};
function $ab26c6126b9362e2$export$147cf6f7ce5462cb(rootEpic) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ab26c6126b9362e2$var$defaultOptions;
    if (typeof rootEpic !== 'function') throw new TypeError('You must provide a root Epic to createEpicMiddleware');
    // even though we used default param, we need to merge the defaults
    // inside the options object as well in case they declare only some
    options = $ab26c6126b9362e2$var$_extends({}, $ab26c6126b9362e2$var$defaultOptions, options);
    var input$ = new (0, $aSveF.Subject)();
    var action$ = options.adapter.input(new (0, $DiL3U.ActionsObservable)(input$));
    var epic$ = new (0, $aSveF.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        return function(next) {
            var _context;
            (_context = (0, $2RyB9.map).call(epic$, function(epic) {
                var vault = store;
                var output$ = 'dependencies' in options ? epic(action$, vault, options.dependencies) : epic(action$, vault);
                if (!output$) throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
                return output$;
            }), $jXTSa.switchMap).call(_context, function(output$) {
                return options.adapter.output(output$);
            }).subscribe(store.dispatch);
            // Setup initial root epic
            epic$.next(rootEpic);
            return function(action) {
                var result = next(action);
                input$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.replaceEpic = function(rootEpic) {
        // gives the previous root Epic a last chance
        // to do some clean up
        store.dispatch({
            type: (0, $PZ1Kh.EPIC_END)
        });
        // switches to the new root Epic, synchronously terminating
        // the previous one
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

});
parcelRegister("2RyB9", function(module, exports) {
$parcel$export(module.exports, "map", () => $215b5e8240ebe356$export$871de8747c9eaa88, (v) => $215b5e8240ebe356$export$871de8747c9eaa88 = v);
var $215b5e8240ebe356$export$871de8747c9eaa88;
"use strict";

var $4KOmc = parcelRequire("4KOmc");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $215b5e8240ebe356$var$map(project, thisArg) {
    return $4KOmc.map(project, thisArg)(this);
}
$215b5e8240ebe356$export$871de8747c9eaa88 = $215b5e8240ebe356$var$map;

});

parcelRegister("jXTSa", function(module, exports) {
$parcel$export(module.exports, "switchMap", () => $e88ede24dcb33f63$export$9f6ea8e48bc26eab, (v) => $e88ede24dcb33f63$export$9f6ea8e48bc26eab = v);
var $e88ede24dcb33f63$export$9f6ea8e48bc26eab;
"use strict";

var $dJlfH = parcelRequire("dJlfH");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $e88ede24dcb33f63$var$switchMap(project, resultSelector) {
    return $dJlfH.switchMap(project, resultSelector)(this);
}
$e88ede24dcb33f63$export$9f6ea8e48bc26eab = $e88ede24dcb33f63$var$switchMap;

});
parcelRegister("dJlfH", function(module, exports) {
"use strict";
var $029462f1e5880d51$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $029462f1e5880d51$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $029462f1e5880d51$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $029462f1e5880d51$var$switchMap;
var $029462f1e5880d51$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $029462f1e5880d51$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $029462f1e5880d51$var$SwitchMapSubscriber = function(_super) {
    $029462f1e5880d51$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $8JM6B.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($cSU8n.OuterSubscriber);

});


parcelRegister("DiL3U", function(module, exports) {
$parcel$export(module.exports, "ActionsObservable", () => $07623197fba8eff8$export$fa75b7f5c32db4e9);

var $jFk35 = parcelRequire("jFk35");

var $kMocN = parcelRequire("kMocN");

var $kQy2N = parcelRequire("kQy2N");

var $fmN5F = parcelRequire("fmN5F");
var $07623197fba8eff8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $07623197fba8eff8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $07623197fba8eff8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $07623197fba8eff8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $07623197fba8eff8$export$fa75b7f5c32db4e9 = function(_Observable) {
    $07623197fba8eff8$var$_inherits(ActionsObservable, _Observable);
    $07623197fba8eff8$var$_createClass(ActionsObservable, null, [
        {
            key: 'of',
            value: function of() {
                return new this((0, $kMocN.of).apply(undefined, arguments));
            }
        },
        {
            key: 'from',
            value: function from(actions, scheduler) {
                return new this((0, $kQy2N.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        $07623197fba8eff8$var$_classCallCheck(this, ActionsObservable);
        var _this = $07623197fba8eff8$var$_possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    $07623197fba8eff8$var$_createClass(ActionsObservable, [
        {
            key: 'lift',
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: 'ofType',
            value: function ofType() {
                return (0, $fmN5F.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, $jFk35.Observable));

});
parcelRegister("kMocN", function(module, exports) {
$parcel$export(module.exports, "of", () => $f20b11021118eb52$export$ba255e9e49e00608, (v) => $f20b11021118eb52$export$ba255e9e49e00608 = v);
var $f20b11021118eb52$export$ba255e9e49e00608;
"use strict";

var $eogqV = parcelRequire("eogqV");
$f20b11021118eb52$export$ba255e9e49e00608 = $eogqV.ArrayObservable.of;

});

parcelRegister("fmN5F", function(module, exports) {
$parcel$export(module.exports, "ofType", () => $b2fefd72536bd03f$export$5db8774c0df95fce);

var $gTQyV = parcelRequire("gTQyV");
var $b2fefd72536bd03f$var$keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === 'function' && type === key.toString();
};
function $b2fefd72536bd03f$export$5db8774c0df95fce() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function ofTypeOperatorFunction(source) {
        return (0, $gTQyV.filter).call(source, function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return $b2fefd72536bd03f$var$keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if ($b2fefd72536bd03f$var$keyHasType(type, keys[i])) return true;
            }
            return false;
        });
    };
}

});
parcelRegister("gTQyV", function(module, exports) {
$parcel$export(module.exports, "filter", () => $c4da8e301e6325a8$export$3dea766d36a8935f, (v) => $c4da8e301e6325a8$export$3dea766d36a8935f = v);
var $c4da8e301e6325a8$export$3dea766d36a8935f;
"use strict";

var $2alSH = parcelRequire("2alSH");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $c4da8e301e6325a8$var$filter(predicate, thisArg) {
    return $2alSH.filter(predicate, thisArg)(this);
}
$c4da8e301e6325a8$export$3dea766d36a8935f = $c4da8e301e6325a8$var$filter;

});
parcelRegister("2alSH", function(module, exports) {
"use strict";
var $193d7d1f37bcef60$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $193d7d1f37bcef60$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $193d7d1f37bcef60$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $193d7d1f37bcef60$var$filter;
var $193d7d1f37bcef60$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $193d7d1f37bcef60$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $193d7d1f37bcef60$var$FilterSubscriber = function(_super) {
    $193d7d1f37bcef60$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($fwCeA.Subscriber);

});




parcelRegister("PZ1Kh", function(module, exports) {
$parcel$export(module.exports, "EPIC_END", () => $09c41a41a1d5bc50$export$b74d5afcca2d016c);
var $09c41a41a1d5bc50$export$b74d5afcca2d016c = '@@redux-observable/EPIC_END';

});


parcelRegister("eSm63", function(module, exports) {
$parcel$export(module.exports, "combineEpics", () => $ad473fc838171e70$export$6259fe981e4a41dc);

var $7HS6F = parcelRequire("7HS6F");
function $ad473fc838171e70$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $ad473fc838171e70$export$6259fe981e4a41dc = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, $7HS6F.merge).apply(undefined, $ad473fc838171e70$var$_toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
            return output$;
        })));
    };
};

});
parcelRegister("7HS6F", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59c684f8b8205485$export$4950aa0f605343fb, (v) => $59c684f8b8205485$export$4950aa0f605343fb = v);
var $59c684f8b8205485$export$4950aa0f605343fb;
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $eogqV = parcelRequire("eogqV");

var $2gCz7 = parcelRequire("2gCz7");

var $x9PRW = parcelRequire("x9PRW");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59c684f8b8205485$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($2gCz7.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $jFk35.Observable) return observables[0];
    return $x9PRW.mergeAll(concurrent)(new $eogqV.ArrayObservable(observables, scheduler));
}
$59c684f8b8205485$export$4950aa0f605343fb = $59c684f8b8205485$var$merge;

});
parcelRegister("x9PRW", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $063ab653af6ffe9e$export$18aef43295bbe906, (v) => $063ab653af6ffe9e$export$18aef43295bbe906 = v);
var $063ab653af6ffe9e$export$18aef43295bbe906;
"use strict";

var $3kOhX = parcelRequire("3kOhX");

var $itbNr = parcelRequire("itbNr");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $063ab653af6ffe9e$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $3kOhX.mergeMap($itbNr.identity, null, concurrent);
}
$063ab653af6ffe9e$export$18aef43295bbe906 = $063ab653af6ffe9e$var$mergeAll;

});
parcelRegister("itbNr", function(module, exports) {
$parcel$export(module.exports, "identity", () => $d72415f8643deccb$export$f0954fd7d5368655, (v) => $d72415f8643deccb$export$f0954fd7d5368655 = v);
var $d72415f8643deccb$export$f0954fd7d5368655;
"use strict";
function $d72415f8643deccb$var$identity(x) {
    return x;
}
$d72415f8643deccb$export$f0954fd7d5368655 = $d72415f8643deccb$var$identity;

});





parcelRegister("lhUKW", function(module, exports) {
$parcel$export(module.exports, "epic$", () => $6788ba5d51bbb9cb$export$5eda8fe942b06fa7);
$parcel$export(module.exports, "default", () => $6788ba5d51bbb9cb$export$2e2bcd8739ae039);
parcelRequire("e19ob");
var $eSm63 = parcelRequire("eSm63");

var $4Q7yw = parcelRequire("4Q7yw");

var $6J2dj = parcelRequire("6J2dj");

var $eJ2p7 = parcelRequire("eJ2p7");

var $dpJHP = parcelRequire("dpJHP");

var $ixZ2N = parcelRequire("ixZ2N");

var $ff9sd = parcelRequire("ff9sd");

var $OFS2L = parcelRequire("OFS2L");

var $jm44O = parcelRequire("jm44O");

var $csxvO = parcelRequire("csxvO");

var $1LBQA = parcelRequire("1LBQA");
var $5UCp6 = parcelRequire("5UCp6");
var $7M1Vy = parcelRequire("7M1Vy");
var $jCW5p = parcelRequire("jCW5p");
var $hJyBD = parcelRequire("hJyBD");

var $chS0d = parcelRequire("chS0d");

var $f8AuD = parcelRequire("f8AuD");

var $cJVfe = parcelRequire("cJVfe");

var $5j5Xz = parcelRequire("5j5Xz");

var $8PGmP = parcelRequire("8PGmP");

var $4wKih = parcelRequire("4wKih");
var $2awzr = parcelRequire("2awzr");
var $4Sh87 = parcelRequire("4Sh87");
var $1ExnT = parcelRequire("1ExnT");
var $batva = parcelRequire("batva");
var $2t7ls = parcelRequire("2t7ls");
var $E7hpf = parcelRequire("E7hpf");
var $9gzKO = parcelRequire("9gzKO");

var $cQWEe = parcelRequire("cQWEe");

var $kLsp0 = parcelRequire("kLsp0");
var $5pKkD = parcelRequire("5pKkD");
var $6nVoo = parcelRequire("6nVoo");
var $72u69 = parcelRequire("72u69");
var $c23cN = parcelRequire("c23cN");

var $70sQ9 = parcelRequire("70sQ9");

var $fRUO0 = parcelRequire("fRUO0");

var $7FKRy = parcelRequire("7FKRy");

var $d12gF = parcelRequire("d12gF");

var $lovgD = parcelRequire("lovgD");

var $cMUG2 = parcelRequire("cMUG2");
const $6788ba5d51bbb9cb$export$678ceb4a4ee87d76 = [
    (0, $5j5Xz.default),
    (0, $7FKRy.default),
    (0, $cJVfe.logOutEpic),
    (0, $ixZ2N.default),
    (0, $cQWEe.requestGroupsEpic),
    (0, $5pKkD.createGroupWithRequestTypeEpic),
    (0, $kLsp0.addRequestTypeToRequestGroupEpic),
    (0, $6nVoo.deleteRequestTypeFromGroupEpic),
    (0, $c23cN.setRequestTypeGroupsEpic),
    (0, $72u69.reorderRequestTypeEpic),
    (0, $4wKih.changeRequestSubscriptionEpic),
    (0, $2awzr.createCommentEpic),
    (0, $4Sh87.decideApprovalEpic),
    (0, $batva.removeOrganisationEpic),
    (0, $2t7ls.removeParticipantEpic),
    (0, $E7hpf.shareRequestEpic),
    (0, $9gzKO.transitionRequestEpic),
    (0, $1ExnT.getMediaReadCredentialsEpic),
    (0, $ff9sd.handleAjaxErrorEpic),
    (0, $d12gF.resendValidationEmailEpic),
    (0, $lovgD.validateAndSavePasswordChangeEpic),
    (0, $lovgD.validateEpic),
    (0, $lovgD.changePasswordEpic),
    (0, $lovgD.updateUserProfileEpic),
    (0, $1LBQA.checkLoginActionEpic),
    (0, $jCW5p.forgotPasswordEpic),
    (0, $5UCp6.createPasswordEpic),
    (0, $hJyBD.loginEpic),
    (0, $jm44O.invitedSignUpEpic),
    (0, $eJ2p7.completeSignupEpic),
    (0, $eJ2p7.sendNewSignupLinkEpic),
    (0, $OFS2L.updateHelpCenterBrandingEpic),
    (0, $OFS2L.updateHelpCenterBrandingEpicMutationSuccess),
    (0, $OFS2L.updateHelpCenterBrandingEpicMutationFailure),
    (0, $fRUO0.resetPasswordEpic),
    (0, $chS0d.updateLoginAnnouncementsEpic),
    (0, $8PGmP.updatePortalAnnouncementsEpic),
    (0, $cMUG2.forgotPasswordEpic),
    (0, $7M1Vy.exitTestModeEpic),
    (0, $70sQ9.resendVerifyEmailEpic),
    (0, $f8AuD.loginConsentEpic),
    (0, $dpJHP.fetchCrossSiteArticleEpic),
    (0, $csxvO.fetchLinkedSpacesEpic)
];
const $6788ba5d51bbb9cb$var$staticEpics = (0, $eSm63.combineEpics)(...$6788ba5d51bbb9cb$export$678ceb4a4ee87d76);
const $6788ba5d51bbb9cb$export$5eda8fe942b06fa7 = new (0, $4Q7yw.BehaviorSubject)($6788ba5d51bbb9cb$var$staticEpics);
const $6788ba5d51bbb9cb$var$combinedEpic = (action$, store$, deps)=>$6788ba5d51bbb9cb$export$5eda8fe942b06fa7.pipe((0, $6J2dj.mergeMap)((epic)=>epic(action$, store$, deps)));
var $6788ba5d51bbb9cb$export$2e2bcd8739ae039 = $6788ba5d51bbb9cb$var$combinedEpic;

});
parcelRegister("4Q7yw", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $3861e12b1cc15427$export$77cea355fa80b5f4, (v) => $3861e12b1cc15427$export$77cea355fa80b5f4 = v);
$parcel$export(module.exports, "BehaviorSubject", () => $3861e12b1cc15427$export$cc3d42e6b2b9cf8b, (v) => $3861e12b1cc15427$export$cc3d42e6b2b9cf8b = v);
$parcel$export(module.exports, "AjaxError", () => $3861e12b1cc15427$export$9b8f4d0b97ba3d22, (v) => $3861e12b1cc15427$export$9b8f4d0b97ba3d22 = v);
$parcel$export(module.exports, "Scheduler", () => $3861e12b1cc15427$export$d3e54bb8584cda7c, (v) => $3861e12b1cc15427$export$d3e54bb8584cda7c = v);
var $3861e12b1cc15427$export$b6bbab5a9b109038;
var $3861e12b1cc15427$export$155189cde295587d;
var $3861e12b1cc15427$export$77cea355fa80b5f4;
var $3861e12b1cc15427$export$f55210826850c514;
var $3861e12b1cc15427$export$60959659b2c22881;
var $3861e12b1cc15427$export$fe960da701faae26;
var $3861e12b1cc15427$export$915d2682b0aa0991;
var $3861e12b1cc15427$export$cc3d42e6b2b9cf8b;
var $3861e12b1cc15427$export$9038dea0172d3ba9;
var $3861e12b1cc15427$export$14834abbfce3b8cd;
var $3861e12b1cc15427$export$78f6d1b1dbcda304;
var $3861e12b1cc15427$export$630691c4a0cd4093;
var $3861e12b1cc15427$export$f708eee25634bc80;
var $3861e12b1cc15427$export$66d311bf29d5c89c;
var $3861e12b1cc15427$export$c9648b76fd580c34;
var $3861e12b1cc15427$export$8bb95198b45adaac;
var $3861e12b1cc15427$export$d9bcbd5e1ff81430;
var $3861e12b1cc15427$export$62927158df9c43dd;
var $3861e12b1cc15427$export$789cef2613b1402;
var $3861e12b1cc15427$export$ae07db09d6fbd01b;
var $3861e12b1cc15427$export$9b8f4d0b97ba3d22;
var $3861e12b1cc15427$export$fcf72a1ab36e1e65;
var $3861e12b1cc15427$export$a4627e546088548d;
var $3861e12b1cc15427$export$ccbce4efa7f8029b;
var $3861e12b1cc15427$export$d3e54bb8584cda7c;
var $3861e12b1cc15427$export$3e25e887b7a5b37b;
"use strict";

var $aSveF = parcelRequire("aSveF");
$3861e12b1cc15427$export$b6bbab5a9b109038 = $aSveF.Subject;
$3861e12b1cc15427$export$155189cde295587d = $aSveF.AnonymousSubject;

var $jFk35 = parcelRequire("jFk35");
$3861e12b1cc15427$export$77cea355fa80b5f4 = $jFk35.Observable;
parcelRequire("1KZNU");
parcelRequire("hCwQV");
parcelRequire("1qTs6");
parcelRequire("ejXlb");
parcelRequire("gjmaX");
parcelRequire("k5Hhk");
parcelRequire("6WMy8");
parcelRequire("h57Mc");
parcelRequire("kBusu");
parcelRequire("c2lUv");
parcelRequire("DIAIz");
parcelRequire("auHAG");
parcelRequire("f05Q8");
parcelRequire("ja58I");
parcelRequire("g5gU3");
parcelRequire("fOLxI");
parcelRequire("AA0eL");
parcelRequire("fVYvr");
parcelRequire("lHsaP");
parcelRequire("i4vns");
parcelRequire("5Lbfo");
parcelRequire("fCrzu");
parcelRequire("enPEE");
parcelRequire("290b3");
parcelRequire("8wqyB");
parcelRequire("bdQTz");
parcelRequire("j4ehL");
parcelRequire("9hypP");
parcelRequire("1ruYh");
parcelRequire("c4qMi");
parcelRequire("lV9cr");
parcelRequire("61coZ");
parcelRequire("1jLhC");
parcelRequire("1tMne");
parcelRequire("bYRq1");
parcelRequire("2nTYk");
parcelRequire("gAgiX");
parcelRequire("hFz6o");
parcelRequire("dXPid");
parcelRequire("5S6n4");
parcelRequire("6B5jK");
parcelRequire("9jgx3");
parcelRequire("6yL0d");
parcelRequire("hFoSs");
parcelRequire("ec160");
parcelRequire("lHshI");
parcelRequire("72MNT");
parcelRequire("d7Oyu");
parcelRequire("f5Ic9");
parcelRequire("5YmLX");
parcelRequire("9MBPF");
parcelRequire("3sKSK");
parcelRequire("lS0O8");
parcelRequire("3EBE1");
parcelRequire("3YqsY");
parcelRequire("ehCqI");
parcelRequire("hB7Zq");
parcelRequire("4jKjx");
parcelRequire("37JoW");
parcelRequire("d2bE9");
parcelRequire("f1yFl");
parcelRequire("c6ynT");
parcelRequire("fWP9V");
parcelRequire("jIjGL");
parcelRequire("lVObb");
parcelRequire("1Sbja");
parcelRequire("eXhTM");
parcelRequire("kePbj");
parcelRequire("ics23");
parcelRequire("bjOkS");
parcelRequire("TPqCa");
parcelRequire("j8OxM");
parcelRequire("c0NVC");
parcelRequire("jBFa6");
parcelRequire("9x6OC");
parcelRequire("fKRAL");
parcelRequire("2XWjp");
parcelRequire("e3q4o");
parcelRequire("7QAMm");
parcelRequire("gH503");
parcelRequire("6x9hZ");
parcelRequire("60Zwo");
parcelRequire("8jBPO");
parcelRequire("3XfDZ");
parcelRequire("hLgpe");
parcelRequire("3si8N");
parcelRequire("7DgsF");
parcelRequire("48FsU");
parcelRequire("3swvU");
parcelRequire("8UaTV");
parcelRequire("i3QyP");
parcelRequire("b3SaU");
parcelRequire("lhPdR");
parcelRequire("AVDGD");
parcelRequire("chRa5");
parcelRequire("hBiCY");
parcelRequire("i1x1P");
parcelRequire("d9EKX");
parcelRequire("8IpJ4");
parcelRequire("8pGZd");
parcelRequire("8aBES");
parcelRequire("9vVNA");
parcelRequire("6FRex");
parcelRequire("yM10v");
parcelRequire("eoKqt");
parcelRequire("bvlBJ");
parcelRequire("hBY7i");
parcelRequire("UJgRH");
parcelRequire("gdKsj");
parcelRequire("il1oD");
parcelRequire("nms5C");
parcelRequire("78DUe");
parcelRequire("iqtt4");
parcelRequire("dxKsL");
parcelRequire("iUCwE");
parcelRequire("f8zms");
parcelRequire("2dZzF");
parcelRequire("iZvMa");
parcelRequire("e5TXc");
parcelRequire("9idcC");
parcelRequire("kbDVp");
parcelRequire("2LBTj");
parcelRequire("gQTaE");
parcelRequire("7XaiY");
parcelRequire("gv9ex");
parcelRequire("3cDWp");
parcelRequire("l339T");
parcelRequire("krDMQ");
parcelRequire("7fAT1");

var $8IeZR = parcelRequire("8IeZR");
$3861e12b1cc15427$export$f55210826850c514 = $8IeZR.Subscription;

var $fwCeA = parcelRequire("fwCeA");
$3861e12b1cc15427$export$60959659b2c22881 = $fwCeA.Subscriber;

var $hGBKd = parcelRequire("hGBKd");
$3861e12b1cc15427$export$fe960da701faae26 = $hGBKd.AsyncSubject;

var $dktU4 = parcelRequire("dktU4");
$3861e12b1cc15427$export$915d2682b0aa0991 = $dktU4.ReplaySubject;

var $4laNn = parcelRequire("4laNn");
$3861e12b1cc15427$export$cc3d42e6b2b9cf8b = $4laNn.BehaviorSubject;

var $hZeRx = parcelRequire("hZeRx");
$3861e12b1cc15427$export$9038dea0172d3ba9 = $hZeRx.ConnectableObservable;

var $jWUHN = parcelRequire("jWUHN");
$3861e12b1cc15427$export$14834abbfce3b8cd = $jWUHN.Notification;

var $gJkED = parcelRequire("gJkED");
$3861e12b1cc15427$export$78f6d1b1dbcda304 = $gJkED.EmptyError;

var $cdlG8 = parcelRequire("cdlG8");
$3861e12b1cc15427$export$630691c4a0cd4093 = $cdlG8.ArgumentOutOfRangeError;

var $imzSm = parcelRequire("imzSm");
$3861e12b1cc15427$export$f708eee25634bc80 = $imzSm.ObjectUnsubscribedError;

var $6QnRJ = parcelRequire("6QnRJ");
$3861e12b1cc15427$export$66d311bf29d5c89c = $6QnRJ.TimeoutError;

var $ljiaq = parcelRequire("ljiaq");
$3861e12b1cc15427$export$c9648b76fd580c34 = $ljiaq.UnsubscriptionError;

var $4j2eI = parcelRequire("4j2eI");
$3861e12b1cc15427$export$8bb95198b45adaac = $4j2eI.TimeInterval;

var $9jiVH = parcelRequire("9jiVH");
$3861e12b1cc15427$export$d9bcbd5e1ff81430 = $9jiVH.Timestamp;

var $dIrp5 = parcelRequire("dIrp5");
$3861e12b1cc15427$export$62927158df9c43dd = $dIrp5.TestScheduler;

var $2Uttx = parcelRequire("2Uttx");
$3861e12b1cc15427$export$789cef2613b1402 = $2Uttx.VirtualTimeScheduler;

var $57NaT = parcelRequire("57NaT");
$3861e12b1cc15427$export$ae07db09d6fbd01b = $57NaT.AjaxResponse;
$3861e12b1cc15427$export$9b8f4d0b97ba3d22 = $57NaT.AjaxError;
$3861e12b1cc15427$export$fcf72a1ab36e1e65 = $57NaT.AjaxTimeoutError;

var $favZu = parcelRequire("favZu");
$3861e12b1cc15427$export$a4627e546088548d = $favZu.pipe;

var $iMh1Q = parcelRequire("iMh1Q");

var $1KBsc = parcelRequire("1KBsc");

var $fh4Yk = parcelRequire("fh4Yk");

var $jW3rE = parcelRequire("jW3rE");

var $4THwh = parcelRequire("4THwh");

var $lTj45 = parcelRequire("lTj45");

var $kdmZ2 = parcelRequire("kdmZ2");

var $6J2dj = parcelRequire("6J2dj");
$3861e12b1cc15427$export$ccbce4efa7f8029b = $6J2dj;
/* tslint:enable:no-unused-variable */ /**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */ var $3861e12b1cc15427$var$Scheduler = {
    asap: $iMh1Q.asap,
    queue: $fh4Yk.queue,
    animationFrame: $jW3rE.animationFrame,
    async: $1KBsc.async
};
$3861e12b1cc15427$export$d3e54bb8584cda7c = $3861e12b1cc15427$var$Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */ var $3861e12b1cc15427$var$Symbol = {
    rxSubscriber: $4THwh.rxSubscriber,
    observable: $kdmZ2.observable,
    iterator: $lTj45.iterator
};
$3861e12b1cc15427$export$3e25e887b7a5b37b = $3861e12b1cc15427$var$Symbol;

});
parcelRegister("1KZNU", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $kSmsF = parcelRequire("kSmsF");
$jFk35.Observable.bindCallback = $kSmsF.bindCallback;

});
parcelRegister("kSmsF", function(module, exports) {
$parcel$export(module.exports, "bindCallback", () => $f32a4624b07a539b$export$ba9059a8de3f18e, (v) => $f32a4624b07a539b$export$ba9059a8de3f18e = v);
var $f32a4624b07a539b$export$ba9059a8de3f18e;
"use strict";

var $eO4eC = parcelRequire("eO4eC");
$f32a4624b07a539b$export$ba9059a8de3f18e = $eO4eC.BoundCallbackObservable.create;

});
parcelRegister("eO4eC", function(module, exports) {
"use strict";
var $ac79052a0374bac5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $hGBKd = parcelRequire("hGBKd");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ac79052a0374bac5$var$BoundCallbackObservable = function(_super) {
    $ac79052a0374bac5$var$__extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments it will return an Observable. If function `func`
     * calls its callback with one argument the Observable will emit that value.
     * If on the other hand the callback is called with multiple values the resulting
     * Observable will emit an array with said values as arguments.
     *
     * It is very important to remember that input function `func` is not called
     * when the output function is, but rather when the Observable returned by the output
     * function is subscribed. This means if `func` makes an AJAX request, that request
     * will be made every time someone subscribes to the resulting Observable, but not before.
     *
     * Optionally, a selector function can be passed to `bindObservable`. The selector function
     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
     * Even though by default multiple arguments passed to callback appear in the stream as an array
     * the selector function will be called with arguments directly, just as the callback would.
     * This means you can imagine the default selector (when one is not provided explicitly)
     * as a function that aggregates all its arguments into an array, or simply returns first argument
     * if there is only one.
     *
     * The last optional parameter - {@link Scheduler} - can be used to control when the call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
     * and call `subscribe` on the output Observable all function calls that are currently executing
     * will end before `func` is invoked.
     *
     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
     * In particular, if the callback is called synchronously the subscription of the resulting Observable
     * will call the `next` function synchronously as well.  If you want to defer that call,
     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that the Observable created by the output function will always emit a single value
     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
     * calls will not appear in the stream. If you need to listen for multiple calls,
     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
     * will be the context that the output function has at call time. In particular, if `func`
     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
     * it is recommended that the context of the output function is set to that object as well.
     *
     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions the same as any other and error parameters
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive an array of arguments passed to a callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with a selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on an object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func A function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps them to a value that is emitted on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */ BoundCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $hGBKd.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = $fgwEQ.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $5C5Tt.errorObject) subject.error($5C5Tt.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $fgwEQ.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $5C5Tt.errorObject) subject.error($5C5Tt.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule(BoundCallbackObservable.dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    BoundCallbackObservable.dispatch = function(state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new $hGBKd.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = $fgwEQ.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === $5C5Tt.errorObject) self.add(scheduler.schedule($ac79052a0374bac5$var$dispatchError, 0, {
                        err: $5C5Tt.errorObject.e,
                        subject: subject
                    }));
                    else self.add(scheduler.schedule($ac79052a0374bac5$var$dispatchNext, 0, {
                        value: result_2,
                        subject: subject
                    }));
                } else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule($ac79052a0374bac5$var$dispatchNext, 0, {
                        value: value,
                        subject: subject
                    }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = $fgwEQ.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === $5C5Tt.errorObject) subject.error($5C5Tt.errorObject.e);
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}($jFk35.Observable);
module.exports.BoundCallbackObservable = $ac79052a0374bac5$var$BoundCallbackObservable;
function $ac79052a0374bac5$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $ac79052a0374bac5$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});
parcelRegister("hGBKd", function(module, exports) {
"use strict";
var $ce03a3289df116ba$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $8IeZR = parcelRequire("8IeZR");
/**
 * @class AsyncSubject<T>
 */ var $ce03a3289df116ba$var$AsyncSubject = function(_super) {
    $ce03a3289df116ba$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $8IeZR.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $8IeZR.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($aSveF.Subject);
module.exports.AsyncSubject = $ce03a3289df116ba$var$AsyncSubject;

});




parcelRegister("hCwQV", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ezxFi = parcelRequire("ezxFi");
$jFk35.Observable.bindNodeCallback = $ezxFi.bindNodeCallback;

});
parcelRegister("ezxFi", function(module, exports) {
$parcel$export(module.exports, "bindNodeCallback", () => $a9be72c71efacf93$export$4893451713772b1a, (v) => $a9be72c71efacf93$export$4893451713772b1a = v);
var $a9be72c71efacf93$export$4893451713772b1a;
"use strict";

var $faXmj = parcelRequire("faXmj");
$a9be72c71efacf93$export$4893451713772b1a = $faXmj.BoundNodeCallbackObservable.create;

});
parcelRegister("faXmj", function(module, exports) {
"use strict";
var $b0c5d59a7754cbd0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $hGBKd = parcelRequire("hGBKd");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $b0c5d59a7754cbd0$var$BoundNodeCallbackObservable = function(_super) {
    $b0c5d59a7754cbd0$var$__extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */ BoundNodeCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $hGBKd.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) subject.error(err);
                    else if (selector) {
                        var result_1 = $fgwEQ.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $5C5Tt.errorObject) subject.error($5C5Tt.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $fgwEQ.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $5C5Tt.errorObject) subject.error($5C5Tt.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule($b0c5d59a7754cbd0$var$dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    return BoundNodeCallbackObservable;
}($jFk35.Observable);
module.exports.BoundNodeCallbackObservable = $b0c5d59a7754cbd0$var$BoundNodeCallbackObservable;
function $b0c5d59a7754cbd0$var$dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new $hGBKd.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) self.add(scheduler.schedule($b0c5d59a7754cbd0$var$dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else if (selector) {
                var result_2 = $fgwEQ.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === $5C5Tt.errorObject) self.add(scheduler.schedule($b0c5d59a7754cbd0$var$dispatchError, 0, {
                    err: $5C5Tt.errorObject.e,
                    subject: subject
                }));
                else self.add(scheduler.schedule($b0c5d59a7754cbd0$var$dispatchNext, 0, {
                    value: result_2,
                    subject: subject
                }));
            } else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule($b0c5d59a7754cbd0$var$dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = $fgwEQ.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === $5C5Tt.errorObject) self.add(scheduler.schedule($b0c5d59a7754cbd0$var$dispatchError, 0, {
            err: $5C5Tt.errorObject.e,
            subject: subject
        }));
    }
    self.add(subject.subscribe(subscriber));
}
function $b0c5d59a7754cbd0$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $b0c5d59a7754cbd0$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});



parcelRegister("1qTs6", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dLWdj = parcelRequire("dLWdj");
$jFk35.Observable.combineLatest = $dLWdj.combineLatest;

});
parcelRegister("dLWdj", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $a06cd230c1332eca$export$77fa7d86f5204e8a, (v) => $a06cd230c1332eca$export$77fa7d86f5204e8a = v);
var $a06cd230c1332eca$export$77fa7d86f5204e8a;
"use strict";

var $2gCz7 = parcelRequire("2gCz7");

var $bHRhK = parcelRequire("bHRhK");

var $eogqV = parcelRequire("eogqV");

var $4SeQD = parcelRequire("4SeQD");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */ function $a06cd230c1332eca$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    var scheduler = null;
    if ($2gCz7.isScheduler(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $bHRhK.isArray(observables[0])) observables = observables[0];
    return new $eogqV.ArrayObservable(observables, scheduler).lift(new $4SeQD.CombineLatestOperator(project));
}
$a06cd230c1332eca$export$77fa7d86f5204e8a = $a06cd230c1332eca$var$combineLatest;

});
parcelRegister("4SeQD", function(module, exports) {
"use strict";
var $38c7b9146247d20b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $eogqV = parcelRequire("eogqV");

var $bHRhK = parcelRequire("bHRhK");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
var $38c7b9146247d20b$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $38c7b9146247d20b$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $bHRhK.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $eogqV.ArrayObservable([
            source
        ].concat(observables)), new $38c7b9146247d20b$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $38c7b9146247d20b$var$combineLatest;
var $38c7b9146247d20b$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $38c7b9146247d20b$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $38c7b9146247d20b$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $38c7b9146247d20b$var$CombineLatestSubscriber = function(_super) {
    $38c7b9146247d20b$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($38c7b9146247d20b$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($8JM6B.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $38c7b9146247d20b$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.CombineLatestSubscriber = $38c7b9146247d20b$var$CombineLatestSubscriber;

});



parcelRegister("ejXlb", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $9aoKF = parcelRequire("9aoKF");
$jFk35.Observable.concat = $9aoKF.concat;

});
parcelRegister("9aoKF", function(module, exports) {
$parcel$export(module.exports, "concat", () => $6ac83f67ed1f4790$export$ee1b3e54f0441b22, (v) => $6ac83f67ed1f4790$export$ee1b3e54f0441b22 = v);
var $6ac83f67ed1f4790$export$ee1b3e54f0441b22;
"use strict";

var $2gCz7 = parcelRequire("2gCz7");

var $kMocN = parcelRequire("kMocN");

var $kQy2N = parcelRequire("kQy2N");

var $jfCUi = parcelRequire("jfCUi");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */ function $6ac83f67ed1f4790$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    if (observables.length === 1 || observables.length === 2 && $2gCz7.isScheduler(observables[1])) return $kQy2N.from(observables[0]);
    return $jfCUi.concatAll()($kMocN.of.apply(void 0, observables));
}
$6ac83f67ed1f4790$export$ee1b3e54f0441b22 = $6ac83f67ed1f4790$var$concat;

});
parcelRegister("jfCUi", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $e03d992c4f400129$export$b314777ae20abca9, (v) => $e03d992c4f400129$export$b314777ae20abca9 = v);
var $e03d992c4f400129$export$b314777ae20abca9;
"use strict";

var $x9PRW = parcelRequire("x9PRW");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $e03d992c4f400129$var$concatAll() {
    return $x9PRW.mergeAll(1);
}
$e03d992c4f400129$export$b314777ae20abca9 = $e03d992c4f400129$var$concatAll;

});



parcelRegister("gjmaX", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2YEJc = parcelRequire("2YEJc");
$jFk35.Observable.defer = $2YEJc.defer;

});
parcelRegister("2YEJc", function(module, exports) {
$parcel$export(module.exports, "defer", () => $22b0c71f680bf487$export$260e5c0943f31606, (v) => $22b0c71f680bf487$export$260e5c0943f31606 = v);
var $22b0c71f680bf487$export$260e5c0943f31606;
"use strict";

var $4U6Xp = parcelRequire("4U6Xp");
$22b0c71f680bf487$export$260e5c0943f31606 = $4U6Xp.DeferObservable.create;

});
parcelRegister("4U6Xp", function(module, exports) {
"use strict";
var $3921c9ef62325515$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3921c9ef62325515$var$DeferObservable = function(_super) {
    $3921c9ef62325515$var$__extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */ DeferObservable.create = function(observableFactory) {
        return new DeferObservable(observableFactory);
    };
    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function(subscriber) {
        return new $3921c9ef62325515$var$DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}($jFk35.Observable);
module.exports.DeferObservable = $3921c9ef62325515$var$DeferObservable;
var $3921c9ef62325515$var$DeferSubscriber = function(_super) {
    $3921c9ef62325515$var$__extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function() {
        try {
            this._callFactory();
        } catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function() {
        var result = this.factory();
        if (result) this.add($8JM6B.subscribeToResult(this, result));
    };
    return DeferSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("k5Hhk", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $69Wah = parcelRequire("69Wah");
$jFk35.Observable.empty = $69Wah.empty;

});
parcelRegister("69Wah", function(module, exports) {
$parcel$export(module.exports, "empty", () => $47c0b3af6c7676b3$export$6e22c362a0406a2c, (v) => $47c0b3af6c7676b3$export$6e22c362a0406a2c = v);
var $47c0b3af6c7676b3$export$6e22c362a0406a2c;
"use strict";

var $b9w09 = parcelRequire("b9w09");
$47c0b3af6c7676b3$export$6e22c362a0406a2c = $b9w09.EmptyObservable.create;

});


parcelRegister("6WMy8", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $1cIiu = parcelRequire("1cIiu");
$jFk35.Observable.forkJoin = $1cIiu.forkJoin;

});
parcelRegister("1cIiu", function(module, exports) {
$parcel$export(module.exports, "forkJoin", () => $0e0945f0adac8c38$export$b5bbde3786dfbd68, (v) => $0e0945f0adac8c38$export$b5bbde3786dfbd68 = v);
var $0e0945f0adac8c38$export$b5bbde3786dfbd68;
"use strict";

var $cdgW3 = parcelRequire("cdgW3");
$0e0945f0adac8c38$export$b5bbde3786dfbd68 = $cdgW3.ForkJoinObservable.create;

});
parcelRegister("cdgW3", function(module, exports) {
"use strict";
var $8e43d5f604dc28d0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $b9w09 = parcelRequire("b9w09");

var $bHRhK = parcelRequire("bHRhK");

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $8e43d5f604dc28d0$var$ForkJoinObservable = function(_super) {
    $8e43d5f604dc28d0$var$__extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */ /**
     * Joins last values emitted by passed Observables.
     *
     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
     *
     * <img src="./img/forkJoin.png" width="100%">
     *
     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
     * or directly as arguments. If no input Observables are provided, resulting stream will complete
     * immediately.
     *
     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
     * array will have `n` values, where first value is the last thing emitted by the first Observable,
     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
     * not emit more than once and it will complete after that. If you need to emit combined values not only
     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
     * or {@link zip} instead.
     *
     * In order for resulting array to have the same length as the number of input Observables, whenever any of
     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
     * and it will not emit anything either, even if it already has some last values from other Observables.
     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
     * unless at any point some other Observable completes without emitting value, which brings us back to
     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
     * have to emit something at least once and complete.
     *
     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
     * will be immediately unsubscribed.
     *
     * Optionally `forkJoin` accepts project function, that will be called with values which normally
     * would land in emitted array. Whatever is returned by project function, will appear in output
     * Observable instead. This means that default project can be thought of as a function that takes
     * all its arguments and puts them into an array. Note that project function will be called only
     * when output Observable is supposed to emit a result.
     *
     * @example <caption>Use forkJoin with operator emitting immediately</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.of(1, 2, 3, 4),
     *   Rx.Observable.of(5, 6, 7, 8)
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [4, 8]
     * // "This is how it ends!"
     *
     *
     * @example <caption>Use forkJoin with operator emitting after some time</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [2, 3] after 3 seconds
     * // "This is how it ends!" immediately after
     *
     *
     * @example <caption>Use forkJoin with project function</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
     *   (n, m) => n + m
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // 5 after 3 seconds
     * // "This is how it ends!" immediately after
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     *
     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
     * passed directly to the operator.
     * @param {function} [project] Function that takes values emitted by input Observables and returns value
     * that will appear in resulting Observable instead of default array.
     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
     * or value from project function.
     * @static true
     * @name forkJoin
     * @owner Observable
     */ ForkJoinObservable.create = function() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i - 0] = arguments[_i];
        if (sources === null || arguments.length === 0) return new $b9w09.EmptyObservable();
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') resultSelector = sources.pop();
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && $bHRhK.isArray(sources[0])) sources = sources[0];
        if (sources.length === 0) return new $b9w09.EmptyObservable();
        return new ForkJoinObservable(sources, resultSelector);
    };
    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function(subscriber) {
        return new $8e43d5f604dc28d0$var$ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}($jFk35.Observable);
module.exports.ForkJoinObservable = $8e43d5f604dc28d0$var$ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8e43d5f604dc28d0$var$ForkJoinSubscriber = function(_super) {
    $8e43d5f604dc28d0$var$__extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for(var i = 0; i < len; i++){
            var source = sources[i];
            var innerSubscription = $8JM6B.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function(innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) return;
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("h57Mc", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $kQy2N = parcelRequire("kQy2N");
$jFk35.Observable.from = $kQy2N.from;

});

parcelRegister("kBusu", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $acmPy = parcelRequire("acmPy");
$jFk35.Observable.fromEvent = $acmPy.fromEvent;

});
parcelRegister("acmPy", function(module, exports) {
$parcel$export(module.exports, "fromEvent", () => $76ccbc0e127d28ae$export$a36e16046ae8f1bb, (v) => $76ccbc0e127d28ae$export$a36e16046ae8f1bb = v);
var $76ccbc0e127d28ae$export$a36e16046ae8f1bb;
"use strict";

var $6KPu4 = parcelRequire("6KPu4");
$76ccbc0e127d28ae$export$a36e16046ae8f1bb = $6KPu4.FromEventObservable.create;

});
parcelRegister("6KPu4", function(module, exports) {
"use strict";
var $4eaef99c42cf54c8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $fgwEQ = parcelRequire("fgwEQ");

var $6M1u7 = parcelRequire("6M1u7");

var $5C5Tt = parcelRequire("5C5Tt");

var $8IeZR = parcelRequire("8IeZR");
var $4eaef99c42cf54c8$var$toString = Object.prototype.toString;
function $4eaef99c42cf54c8$var$isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function $4eaef99c42cf54c8$var$isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function $4eaef99c42cf54c8$var$isNodeList(sourceObj) {
    return !!sourceObj && $4eaef99c42cf54c8$var$toString.call(sourceObj) === '[object NodeList]';
}
function $4eaef99c42cf54c8$var$isHTMLCollection(sourceObj) {
    return !!sourceObj && $4eaef99c42cf54c8$var$toString.call(sourceObj) === '[object HTMLCollection]';
}
function $4eaef99c42cf54c8$var$isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $4eaef99c42cf54c8$var$FromEventObservable = function(_super) {
    $4eaef99c42cf54c8$var$__extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */ /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node.js
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * `fromEvent` accepts as a first argument event target, which is an object with methods
     * for registering event handler functions. As a second argument it takes string that indicates
     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
     * which are described in detail below. If your event target does not match any of the ones listed,
     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
     * handler functions have different names, but they all accept a string describing event type
     * and function itself, which will be called whenever said event happens.
     *
     * Every time resulting Observable is subscribed, event handler function will be registered
     * to event target on given event type. When that event fires, value
     * passed as a first argument to registered function will be emitted by output Observable.
     * When Observable is unsubscribed, function will be unregistered from event target.
     *
     * Note that if event target calls registered function with more than one argument, second
     * and following arguments will not appear in resulting stream. In order to get access to them,
     * you can pass to `fromEvent` optional project function, which will be called with all arguments
     * passed to event handler. Output Observable will then emit value returned by project function,
     * instead of the usual value.
     *
     * Remember that event targets listed below are checked via duck typing. It means that
     * no matter what kind of object you have and no matter what environment you work in,
     * you can safely use `fromEvent` on that object if it exposes described methods (provided
     * of course they behave as was described above). So for example if Node.js library exposes
     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
     * a good choice.
     *
     * If the API you use is more callback then event handler oriented (subscribed
     * callback function fires only once and thus there is no need to manually
     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
     * instead.
     *
     * `fromEvent` supports following types of event targets:
     *
     * **DOM EventTarget**
     *
     * This is an object with `addEventListener` and `removeEventListener` methods.
     *
     * In the browser, `addEventListener` accepts - apart from event type string and event
     * handler function arguments - optional third parameter, which is either an object or boolean,
     * both used for additional configuration how and when passed function will be called. When
     * `fromEvent` is used with event target of that type, you can provide this values
     * as third parameter as well.
     *
     * **Node.js EventEmitter**
     *
     * An object with `addListener` and `removeListener` methods.
     *
     * **JQuery-style event target**
     *
     * An object with `on` and `off` methods
     *
     * **DOM NodeList**
     *
     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
     *
     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
     * it contains and install event handler function in every of them. When returned Observable
     * is unsubscribed, function will be removed from all Nodes.
     *
     * **DOM HtmlCollection**
     *
     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
     * installed and removed in each of elements.
     *
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console every time a click
     * // occurs on the document.
     *
     *
     * @example <caption>Use addEventListener with capture option</caption>
     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
     *                                                                          // which will be passed to addEventListener
     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
     *
     * clicksInDocument.subscribe(() => console.log('document'));
     * clicksInDiv.subscribe(() => console.log('div'));
     *
     * // By default events bubble UP in DOM tree, so normally
     * // when we would click on div in document
     * // "div" would be logged first and then "document".
     * // Since we specified optional `capture` option, document
     * // will catch event when it goes DOWN DOM tree, so console
     * // will log "document" and then "div".
     *
     * @see {@link bindCallback}
     * @see {@link bindNodeCallback}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOM EventTarget, Node.js
     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */ FromEventObservable.create = function(target, eventName, options, selector) {
        if ($6M1u7.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function(sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if ($4eaef99c42cf54c8$var$isNodeList(sourceObj) || $4eaef99c42cf54c8$var$isHTMLCollection(sourceObj)) for(var i = 0, len = sourceObj.length; i < len; i++)FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        else if ($4eaef99c42cf54c8$var$isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function() {
                return source_1.removeEventListener(eventName, handler, options);
            };
        } else if ($4eaef99c42cf54c8$var$isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function() {
                return source_2.off(eventName, handler);
            };
        } else if ($4eaef99c42cf54c8$var$isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function() {
                return source_3.removeListener(eventName, handler);
            };
        } else throw new TypeError('Invalid event target');
        subscriber.add(new $8IeZR.Subscription(unsubscribe));
    };
    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function(subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            var result = $fgwEQ.tryCatch(selector).apply(void 0, args);
            if (result === $5C5Tt.errorObject) subscriber.error($5C5Tt.errorObject.e);
            else subscriber.next(result);
        } : function(e) {
            return subscriber.next(e);
        };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}($jFk35.Observable);
module.exports.FromEventObservable = $4eaef99c42cf54c8$var$FromEventObservable;

});



parcelRegister("c2lUv", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $k7qnX = parcelRequire("k7qnX");
$jFk35.Observable.fromEventPattern = $k7qnX.fromEventPattern;

});
parcelRegister("k7qnX", function(module, exports) {
$parcel$export(module.exports, "fromEventPattern", () => $ea58edb03e2b164e$export$af596f9f0ff848f8, (v) => $ea58edb03e2b164e$export$af596f9f0ff848f8 = v);
var $ea58edb03e2b164e$export$af596f9f0ff848f8;
"use strict";

var $kQOfM = parcelRequire("kQOfM");
$ea58edb03e2b164e$export$af596f9f0ff848f8 = $kQOfM.FromEventPatternObservable.create;

});
parcelRegister("kQOfM", function(module, exports) {
"use strict";
var $f2dfa54a91d4d56f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6M1u7 = parcelRequire("6M1u7");

var $jFk35 = parcelRequire("jFk35");

var $8IeZR = parcelRequire("8IeZR");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f2dfa54a91d4d56f$var$FromEventPatternObservable = function(_super) {
    $f2dfa54a91d4d56f$var$__extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */ FromEventPatternObservable.create = function(addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            _this._callSelector(subscriber, args);
        } : function(e) {
            subscriber.next(e);
        };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!$6M1u7.isFunction(removeHandler)) return;
        subscriber.add(new $8IeZR.Subscription(function() {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function(subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        } catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function(handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        } catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}($jFk35.Observable);
module.exports.FromEventPatternObservable = $f2dfa54a91d4d56f$var$FromEventPatternObservable;

});



parcelRegister("DIAIz", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $9UmnK = parcelRequire("9UmnK");
$jFk35.Observable.fromPromise = $9UmnK.fromPromise;

});

parcelRegister("auHAG", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $8Sprk = parcelRequire("8Sprk");
$jFk35.Observable.generate = $8Sprk.generate;

});
parcelRegister("8Sprk", function(module, exports) {
$parcel$export(module.exports, "generate", () => $676719abadc851ff$export$80d376111cc09ad7, (v) => $676719abadc851ff$export$80d376111cc09ad7 = v);
var $676719abadc851ff$export$80d376111cc09ad7;
"use strict";

var $cPz0D = parcelRequire("cPz0D");
$676719abadc851ff$export$80d376111cc09ad7 = $cPz0D.GenerateObservable.create;

});
parcelRegister("cPz0D", function(module, exports) {
"use strict";
var $9575678a0c75c4cd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $2gCz7 = parcelRequire("2gCz7");
var $9575678a0c75c4cd$var$selfSelector = function(value) {
    return value;
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $9575678a0c75c4cd$var$GenerateObservable = function(_super) {
    $9575678a0c75c4cd$var$__extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || $9575678a0c75c4cd$var$selfSelector, initialStateOrOptions.scheduler);
        if (resultSelectorOrObservable === undefined || $2gCz7.isScheduler(resultSelectorOrObservable)) return new GenerateObservable(initialStateOrOptions, condition, iterate, $9575678a0c75c4cd$var$selfSelector, resultSelectorOrObservable);
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function(subscriber) {
        var state = this.initialState;
        if (this.scheduler) return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
            subscriber: subscriber,
            iterate: this.iterate,
            condition: this.condition,
            resultSelector: this.resultSelector,
            state: state
        });
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
        }while (true);
    };
    GenerateObservable.dispatch = function(state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) return;
        if (state.needIterate) try {
            state.state = state.iterate(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        else state.needIterate = true;
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) return;
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) return;
        subscriber.next(value);
        if (subscriber.closed) return;
        return this.schedule(state);
    };
    return GenerateObservable;
}($jFk35.Observable);
module.exports.GenerateObservable = $9575678a0c75c4cd$var$GenerateObservable;

});



parcelRegister("f05Q8", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $70IGd = parcelRequire("70IGd");
$jFk35.Observable.if = $70IGd._if;

});
parcelRegister("70IGd", function(module, exports) {
$parcel$export(module.exports, "_if", () => $51ab31000c1cf715$export$3d19121892ad9076, (v) => $51ab31000c1cf715$export$3d19121892ad9076 = v);
var $51ab31000c1cf715$export$3d19121892ad9076;
"use strict";

var $1uRe2 = parcelRequire("1uRe2");
$51ab31000c1cf715$export$3d19121892ad9076 = $1uRe2.IfObservable.create;

});
parcelRegister("1uRe2", function(module, exports) {
"use strict";
var $1171e143fde43df4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $1171e143fde43df4$var$IfObservable = function(_super) {
    $1171e143fde43df4$var$__extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function(condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function(subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new $1171e143fde43df4$var$IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}($jFk35.Observable);
module.exports.IfObservable = $1171e143fde43df4$var$IfObservable;
var $1171e143fde43df4$var$IfSubscriber = function(_super) {
    $1171e143fde43df4$var$__extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function() {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) this.add($8JM6B.subscribeToResult(this, source));
            else this._complete();
        } catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("ja58I", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $gnRsG = parcelRequire("gnRsG");
$jFk35.Observable.interval = $gnRsG.interval;

});
parcelRegister("gnRsG", function(module, exports) {
$parcel$export(module.exports, "interval", () => $bed843acbc9f6aaf$export$3174cdbf0a0cbc84, (v) => $bed843acbc9f6aaf$export$3174cdbf0a0cbc84 = v);
var $bed843acbc9f6aaf$export$3174cdbf0a0cbc84;
"use strict";

var $bo2jp = parcelRequire("bo2jp");
$bed843acbc9f6aaf$export$3174cdbf0a0cbc84 = $bo2jp.IntervalObservable.create;

});
parcelRegister("bo2jp", function(module, exports) {
"use strict";
var $84a3babaa272901a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8xi5Q = parcelRequire("8xi5Q");

var $jFk35 = parcelRequire("jFk35");

var $1KBsc = parcelRequire("1KBsc");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $84a3babaa272901a$var$IntervalObservable = function(_super) {
    $84a3babaa272901a$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $1KBsc.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$8xi5Q.isNumeric(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $1KBsc.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $1KBsc.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($jFk35.Observable);
module.exports.IntervalObservable = $84a3babaa272901a$var$IntervalObservable;

});
parcelRegister("8xi5Q", function(module, exports) {
$parcel$export(module.exports, "isNumeric", () => $636f70c2e685ff5f$export$e90fb89750dba83f, (v) => $636f70c2e685ff5f$export$e90fb89750dba83f = v);
var $636f70c2e685ff5f$export$e90fb89750dba83f;
"use strict";

var $bHRhK = parcelRequire("bHRhK");
function $636f70c2e685ff5f$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$bHRhK.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$636f70c2e685ff5f$export$e90fb89750dba83f = $636f70c2e685ff5f$var$isNumeric;

});

parcelRegister("1KBsc", function(module, exports) {
$parcel$export(module.exports, "async", () => $146723e10157dea8$export$12af436354f1a4f7, (v) => $146723e10157dea8$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $146723e10157dea8$export$12af436354f1a4f7;
"use strict";

var $kpCGY = parcelRequire("kpCGY");

var $5wLDa = parcelRequire("5wLDa");
$146723e10157dea8$export$12af436354f1a4f7 = new $5wLDa.AsyncScheduler($kpCGY.AsyncAction);

});




parcelRegister("g5gU3", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $7HS6F = parcelRequire("7HS6F");
$jFk35.Observable.merge = $7HS6F.merge;

});

parcelRegister("fOLxI", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $bzCla = parcelRequire("bzCla");
$jFk35.Observable.race = $bzCla.race;

});
parcelRegister("bzCla", function(module, exports) {
"use strict";
var $86d0b4339ea60ed2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bHRhK = parcelRequire("bHRhK");

var $eogqV = parcelRequire("eogqV");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
function $86d0b4339ea60ed2$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($bHRhK.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $eogqV.ArrayObservable(observables).lift(new $86d0b4339ea60ed2$var$RaceOperator());
}
module.exports.race = $86d0b4339ea60ed2$var$race;
var $86d0b4339ea60ed2$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $86d0b4339ea60ed2$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $86d0b4339ea60ed2$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $86d0b4339ea60ed2$var$RaceSubscriber = function(_super) {
    $86d0b4339ea60ed2$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $8JM6B.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.RaceSubscriber = $86d0b4339ea60ed2$var$RaceSubscriber;

});


parcelRegister("AA0eL", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $bkCIG = parcelRequire("bkCIG");
$jFk35.Observable.never = $bkCIG.never;

});
parcelRegister("bkCIG", function(module, exports) {
$parcel$export(module.exports, "never", () => $83ff98e9f945527d$export$b3e22bcfd64c1022, (v) => $83ff98e9f945527d$export$b3e22bcfd64c1022 = v);
var $83ff98e9f945527d$export$b3e22bcfd64c1022;
"use strict";

var $2Ood1 = parcelRequire("2Ood1");
$83ff98e9f945527d$export$b3e22bcfd64c1022 = $2Ood1.NeverObservable.create;

});
parcelRegister("2Ood1", function(module, exports) {
"use strict";
var $20c307ab7abb012d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $6EUcf = parcelRequire("6EUcf");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $20c307ab7abb012d$var$NeverObservable = function(_super) {
    $20c307ab7abb012d$var$__extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */ NeverObservable.create = function() {
        return new NeverObservable();
    };
    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function(subscriber) {
        $6EUcf.noop();
    };
    return NeverObservable;
}($jFk35.Observable);
module.exports.NeverObservable = $20c307ab7abb012d$var$NeverObservable;

});



parcelRegister("fVYvr", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $kMocN = parcelRequire("kMocN");
$jFk35.Observable.of = $kMocN.of;

});

parcelRegister("lHsaP", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $kz8yA = parcelRequire("kz8yA");
$jFk35.Observable.onErrorResumeNext = $kz8yA.onErrorResumeNext;

});
parcelRegister("kz8yA", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $ef8db6b83c2c9ead$export$5fba66d61591f42, (v) => $ef8db6b83c2c9ead$export$5fba66d61591f42 = v);
var $ef8db6b83c2c9ead$export$5fba66d61591f42;
"use strict";

var $cimxX = parcelRequire("cimxX");
$ef8db6b83c2c9ead$export$5fba66d61591f42 = $cimxX.onErrorResumeNextStatic;

});
parcelRegister("cimxX", function(module, exports) {
"use strict";
var $8f38a7c7acb4deab$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $eRGDk = parcelRequire("eRGDk");

var $bHRhK = parcelRequire("bHRhK");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $8f38a7c7acb4deab$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $bHRhK.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $8f38a7c7acb4deab$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $8f38a7c7acb4deab$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $8f38a7c7acb4deab$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $bHRhK.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $eRGDk.FromObservable(source, null).lift(new $8f38a7c7acb4deab$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $8f38a7c7acb4deab$var$onErrorResumeNextStatic;
var $8f38a7c7acb4deab$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8f38a7c7acb4deab$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $8f38a7c7acb4deab$var$OnErrorResumeNextSubscriber = function(_super) {
    $8f38a7c7acb4deab$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($8JM6B.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("i4vns", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $7HCY7 = parcelRequire("7HCY7");
$jFk35.Observable.pairs = $7HCY7.pairs;

});
parcelRegister("7HCY7", function(module, exports) {
$parcel$export(module.exports, "pairs", () => $59bac6ea905920a4$export$589748d90c221be3, (v) => $59bac6ea905920a4$export$589748d90c221be3 = v);
var $59bac6ea905920a4$export$589748d90c221be3;
"use strict";

var $304oI = parcelRequire("304oI");
$59bac6ea905920a4$export$589748d90c221be3 = $304oI.PairsObservable.create;

});
parcelRegister("304oI", function(module, exports) {
"use strict";
var $22f4c8728a728ef2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");
function $22f4c8728a728ef2$var$dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([
        key,
        obj[key]
    ]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $22f4c8728a728ef2$var$PairsObservable = function(_super) {
    $22f4c8728a728ef2$var$__extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */ PairsObservable.create = function(obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function(subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) return scheduler.schedule($22f4c8728a728ef2$var$dispatch, 0, {
            obj: this.obj,
            keys: keys,
            length: length,
            index: 0,
            subscriber: subscriber
        });
        else {
            for(var idx = 0; idx < length; idx++){
                var key = keys[idx];
                subscriber.next([
                    key,
                    this.obj[key]
                ]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}($jFk35.Observable);
module.exports.PairsObservable = $22f4c8728a728ef2$var$PairsObservable;

});



parcelRegister("5Lbfo", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $lV2sg = parcelRequire("lV2sg");
$jFk35.Observable.range = $lV2sg.range;

});

parcelRegister("fCrzu", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $9P7DC = parcelRequire("9P7DC");
$jFk35.Observable.using = $9P7DC.using;

});
parcelRegister("9P7DC", function(module, exports) {
$parcel$export(module.exports, "using", () => $726ecd3beac467f7$export$fb1889ddede82380, (v) => $726ecd3beac467f7$export$fb1889ddede82380 = v);
var $726ecd3beac467f7$export$fb1889ddede82380;
"use strict";

var $6tg5w = parcelRequire("6tg5w");
$726ecd3beac467f7$export$fb1889ddede82380 = $6tg5w.UsingObservable.create;

});
parcelRegister("6tg5w", function(module, exports) {
"use strict";
var $4b61ee40bdc82d50$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $4b61ee40bdc82d50$var$UsingObservable = function(_super) {
    $4b61ee40bdc82d50$var$__extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function(resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function(subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new $4b61ee40bdc82d50$var$UsingSubscriber(subscriber, resource, observableFactory);
        } catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}($jFk35.Observable);
module.exports.UsingObservable = $4b61ee40bdc82d50$var$UsingObservable;
var $4b61ee40bdc82d50$var$UsingSubscriber = function(_super) {
    $4b61ee40bdc82d50$var$__extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function() {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) this.add($8JM6B.subscribeToResult(this, source));
        } catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("enPEE", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $gjnqL = parcelRequire("gjnqL");
$jFk35.Observable.throw = $gjnqL._throw;

});
parcelRegister("gjnqL", function(module, exports) {
$parcel$export(module.exports, "_throw", () => $be00988974fa0a89$export$82a8af9b11518516, (v) => $be00988974fa0a89$export$82a8af9b11518516 = v);
var $be00988974fa0a89$export$82a8af9b11518516;
"use strict";

var $aYqG9 = parcelRequire("aYqG9");
$be00988974fa0a89$export$82a8af9b11518516 = $aYqG9.ErrorObservable.create;

});
parcelRegister("aYqG9", function(module, exports) {
"use strict";
var $7fd433d1d103721a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7fd433d1d103721a$var$ErrorObservable = function(_super) {
    $7fd433d1d103721a$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($jFk35.Observable);
module.exports.ErrorObservable = $7fd433d1d103721a$var$ErrorObservable;

});



parcelRegister("290b3", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $eSP70 = parcelRequire("eSP70");
$jFk35.Observable.timer = $eSP70.timer;

});
parcelRegister("eSP70", function(module, exports) {
$parcel$export(module.exports, "timer", () => $ad5dc1a127b10f0a$export$9dc4ecf953986f04, (v) => $ad5dc1a127b10f0a$export$9dc4ecf953986f04 = v);
var $ad5dc1a127b10f0a$export$9dc4ecf953986f04;
"use strict";

var $eSNEk = parcelRequire("eSNEk");
$ad5dc1a127b10f0a$export$9dc4ecf953986f04 = $eSNEk.TimerObservable.create;

});
parcelRegister("eSNEk", function(module, exports) {
"use strict";
var $ad5c9f2dc090349a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8xi5Q = parcelRequire("8xi5Q");

var $jFk35 = parcelRequire("jFk35");

var $1KBsc = parcelRequire("1KBsc");

var $2gCz7 = parcelRequire("2gCz7");

var $iUp3d = parcelRequire("iUp3d");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ad5c9f2dc090349a$var$TimerObservable = function(_super) {
    $ad5c9f2dc090349a$var$__extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) dueTime = 0;
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if ($8xi5Q.isNumeric(period)) this.period = Number(period) < 1 && 1 || Number(period);
        else if ($2gCz7.isScheduler(period)) scheduler = period;
        if (!$2gCz7.isScheduler(scheduler)) scheduler = $1KBsc.async;
        this.scheduler = scheduler;
        this.dueTime = $iUp3d.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */ TimerObservable.create = function(initialDelay, period, scheduler) {
        if (initialDelay === void 0) initialDelay = 0;
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function(state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) return;
        else if (period === -1) return subscriber.complete();
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index,
            period: period,
            subscriber: subscriber
        });
    };
    return TimerObservable;
}($jFk35.Observable);
module.exports.TimerObservable = $ad5c9f2dc090349a$var$TimerObservable;

});
parcelRegister("iUp3d", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $dc40e38ca48313c8$export$871608497c498473, (v) => $dc40e38ca48313c8$export$871608497c498473 = v);
var $dc40e38ca48313c8$export$871608497c498473;
"use strict";
function $dc40e38ca48313c8$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$dc40e38ca48313c8$export$871608497c498473 = $dc40e38ca48313c8$var$isDate;

});




parcelRegister("8wqyB", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $1rcNS = parcelRequire("1rcNS");
$jFk35.Observable.zip = $1rcNS.zip;

});
parcelRegister("1rcNS", function(module, exports) {
$parcel$export(module.exports, "zip", () => $10c23e9412f7f299$export$8901015135f2fb22, (v) => $10c23e9412f7f299$export$8901015135f2fb22 = v);
var $10c23e9412f7f299$export$8901015135f2fb22;
"use strict";

var $4mSt5 = parcelRequire("4mSt5");
$10c23e9412f7f299$export$8901015135f2fb22 = $4mSt5.zipStatic;

});
parcelRegister("4mSt5", function(module, exports) {
"use strict";
var $32e377bf25aae76e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $eogqV = parcelRequire("eogqV");

var $bHRhK = parcelRequire("bHRhK");

var $fwCeA = parcelRequire("fwCeA");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");

var $lTj45 = parcelRequire("lTj45");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $32e377bf25aae76e$var$zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call($32e377bf25aae76e$var$zipStatic.apply(void 0, [
            source
        ].concat(observables)));
    };
}
module.exports.zip = $32e377bf25aae76e$var$zip;
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */ function $32e377bf25aae76e$var$zipStatic() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = observables[observables.length - 1];
    if (typeof project === 'function') observables.pop();
    return new $eogqV.ArrayObservable(observables).lift(new $32e377bf25aae76e$var$ZipOperator(project));
}
module.exports.zipStatic = $32e377bf25aae76e$var$zipStatic;
var $32e377bf25aae76e$var$ZipOperator = function() {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $32e377bf25aae76e$var$ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}();
module.exports.ZipOperator = $32e377bf25aae76e$var$ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $32e377bf25aae76e$var$ZipSubscriber = function(_super) {
    $32e377bf25aae76e$var$__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) values = Object.create(null);
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = typeof project === 'function' ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ($bHRhK.isArray(value)) iterators.push(new $32e377bf25aae76e$var$StaticArrayIterator(value));
        else if (typeof value[$lTj45.iterator] === 'function') iterators.push(new $32e377bf25aae76e$var$StaticIterator(value[$lTj45.iterator]()));
        else iterators.push(new $32e377bf25aae76e$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) this.add(iterator.subscribe(iterator, i));
            else this.active--; // not an observable
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) this._tryProject(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}($fwCeA.Subscriber);
module.exports.ZipSubscriber = $32e377bf25aae76e$var$ZipSubscriber;
var $32e377bf25aae76e$var$StaticIterator = function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}();
var $32e377bf25aae76e$var$StaticArrayIterator = function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[$lTj45.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $32e377bf25aae76e$var$ZipBufferIterator = function(_super) {
    $32e377bf25aae76e$var$__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[$lTj45.iterator] = function() {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function(value, index) {
        return $8JM6B.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}($cSU8n.OuterSubscriber);

});



parcelRegister("bdQTz", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $fS03Q = parcelRequire("fS03Q");
$jFk35.Observable.ajax = $fS03Q.ajax;

});
parcelRegister("fS03Q", function(module, exports) {
$parcel$export(module.exports, "ajax", () => $b8dbf24cf2588c15$export$e68fce4c5f453854, (v) => $b8dbf24cf2588c15$export$e68fce4c5f453854 = v);
var $b8dbf24cf2588c15$export$e68fce4c5f453854;
"use strict";

var $57NaT = parcelRequire("57NaT");
$b8dbf24cf2588c15$export$e68fce4c5f453854 = $57NaT.AjaxObservable.create;

});
parcelRegister("57NaT", function(module, exports) {
"use strict";
var $3bb3c04aa77023f1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4xUKK = parcelRequire("4xUKK");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $jFk35 = parcelRequire("jFk35");

var $fwCeA = parcelRequire("fwCeA");

var $4KOmc = parcelRequire("4KOmc");
function $3bb3c04aa77023f1$var$getCORSRequest() {
    if ($4xUKK.root.XMLHttpRequest) return new $4xUKK.root.XMLHttpRequest();
    else if (!!$4xUKK.root.XDomainRequest) return new $4xUKK.root.XDomainRequest();
    else throw new Error('CORS is not supported by your browser');
}
function $3bb3c04aa77023f1$var$getXMLHttpRequest() {
    if ($4xUKK.root.XMLHttpRequest) return new $4xUKK.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                'Msxml2.XMLHTTP',
                'Microsoft.XMLHTTP',
                'Msxml2.XMLHTTP.4.0'
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $4xUKK.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $4xUKK.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function $3bb3c04aa77023f1$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $3bb3c04aa77023f1$var$AjaxObservable({
        method: 'GET',
        url: url,
        headers: headers
    });
}
module.exports.ajaxGet = $3bb3c04aa77023f1$var$ajaxGet;
function $3bb3c04aa77023f1$var$ajaxPost(url, body, headers) {
    return new $3bb3c04aa77023f1$var$AjaxObservable({
        method: 'POST',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPost = $3bb3c04aa77023f1$var$ajaxPost;
function $3bb3c04aa77023f1$var$ajaxDelete(url, headers) {
    return new $3bb3c04aa77023f1$var$AjaxObservable({
        method: 'DELETE',
        url: url,
        headers: headers
    });
}
module.exports.ajaxDelete = $3bb3c04aa77023f1$var$ajaxDelete;
function $3bb3c04aa77023f1$var$ajaxPut(url, body, headers) {
    return new $3bb3c04aa77023f1$var$AjaxObservable({
        method: 'PUT',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPut = $3bb3c04aa77023f1$var$ajaxPut;
function $3bb3c04aa77023f1$var$ajaxPatch(url, body, headers) {
    return new $3bb3c04aa77023f1$var$AjaxObservable({
        method: 'PATCH',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPatch = $3bb3c04aa77023f1$var$ajaxPatch;
var $3bb3c04aa77023f1$var$mapResponse = $4KOmc.map(function(x, index) {
    return x.response;
});
function $3bb3c04aa77023f1$var$ajaxGetJSON(url, headers) {
    return $3bb3c04aa77023f1$var$mapResponse(new $3bb3c04aa77023f1$var$AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
module.exports.ajaxGetJSON = $3bb3c04aa77023f1$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3bb3c04aa77023f1$var$AjaxObservable = function(_super) {
    $3bb3c04aa77023f1$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $3bb3c04aa77023f1$var$getCORSRequest.call(this) : $3bb3c04aa77023f1$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $3bb3c04aa77023f1$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $3bb3c04aa77023f1$var$ajaxGet;
        create.post = $3bb3c04aa77023f1$var$ajaxPost;
        create.delete = $3bb3c04aa77023f1$var$ajaxDelete;
        create.put = $3bb3c04aa77023f1$var$ajaxPut;
        create.patch = $3bb3c04aa77023f1$var$ajaxPatch;
        create.getJSON = $3bb3c04aa77023f1$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($jFk35.Observable);
module.exports.AjaxObservable = $3bb3c04aa77023f1$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3bb3c04aa77023f1$var$AjaxSubscriber = function(_super) {
    $3bb3c04aa77023f1$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) headers['X-Requested-With'] = 'XMLHttpRequest';
        // ensure content type is set
        if (!('Content-Type' in headers) && !($4xUKK.root.FormData && request.body instanceof $4xUKK.root.FormData) && typeof request.body !== 'undefined') headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $3bb3c04aa77023f1$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $fgwEQ.tryCatch(createXHR).call(request);
        if (xhr === $5C5Tt.errorObject) this.error($5C5Tt.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $fgwEQ.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $fgwEQ.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $5C5Tt.errorObject) {
                this.error($5C5Tt.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $fgwEQ.tryCatch(xhr.send).call(xhr, body) : $fgwEQ.tryCatch(xhr.send).call(xhr);
            if (result === $5C5Tt.errorObject) {
                this.error($5C5Tt.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === 'string') return body;
        else if ($4xUKK.root.FormData && body instanceof $4xUKK.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $3bb3c04aa77023f1$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($4xUKK.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $3bb3c04aa77023f1$var$AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === 'text' ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $3bb3c04aa77023f1$var$AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($fwCeA.Subscriber);
module.exports.AjaxSubscriber = $3bb3c04aa77023f1$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $3bb3c04aa77023f1$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $3bb3c04aa77023f1$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
module.exports.AjaxResponse = $3bb3c04aa77023f1$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $3bb3c04aa77023f1$var$AjaxError = function(_super) {
    $3bb3c04aa77023f1$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $3bb3c04aa77023f1$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
module.exports.AjaxError = $3bb3c04aa77023f1$var$AjaxError;
function $3bb3c04aa77023f1$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case 'json':
            if ('response' in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || 'null');
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return 'response' in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $3bb3c04aa77023f1$var$AjaxTimeoutError = function(_super) {
    $3bb3c04aa77023f1$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}($3bb3c04aa77023f1$var$AjaxError);
module.exports.AjaxTimeoutError = $3bb3c04aa77023f1$var$AjaxTimeoutError;

});



parcelRegister("j4ehL", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $juMVe = parcelRequire("juMVe");
$jFk35.Observable.webSocket = $juMVe.webSocket;

});
parcelRegister("juMVe", function(module, exports) {
$parcel$export(module.exports, "webSocket", () => $e316c491525adaaf$export$debf5095acd2163f, (v) => $e316c491525adaaf$export$debf5095acd2163f = v);
var $e316c491525adaaf$export$debf5095acd2163f;
"use strict";

var $b4aZB = parcelRequire("b4aZB");
$e316c491525adaaf$export$debf5095acd2163f = $b4aZB.WebSocketSubject.create;

});
parcelRegister("b4aZB", function(module, exports) {
"use strict";
var $80e8985490e119ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $fwCeA = parcelRequire("fwCeA");

var $jFk35 = parcelRequire("jFk35");

var $8IeZR = parcelRequire("8IeZR");

var $4xUKK = parcelRequire("4xUKK");

var $dktU4 = parcelRequire("dktU4");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $6AHA3 = parcelRequire("6AHA3");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $80e8985490e119ff$var$WebSocketSubject = function(_super) {
    $80e8985490e119ff$var$__extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof $jFk35.Observable) _super.call(this, destination, urlConfigOrSource);
        else {
            _super.call(this);
            this.WebSocketCtor = $4xUKK.root.WebSocket;
            this._output = new $aSveF.Subject();
            if (typeof urlConfigOrSource === 'string') this.url = urlConfigOrSource;
            else // WARNING: config object could override important members here.
            $6AHA3.assign(this, urlConfigOrSource);
            if (!this.WebSocketCtor) throw new Error('no WebSocket constructor can be found');
            this.destination = new $dktU4.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function(e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */ WebSocketSubject.create = function(urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function(operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function() {
        this.socket = null;
        if (!this.source) this.destination = new $dktU4.ReplaySubject();
        this._output = new $aSveF.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function(subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new $jFk35.Observable(function(observer) {
            var result = $fgwEQ.tryCatch(subMsg)();
            if (result === $5C5Tt.errorObject) observer.error($5C5Tt.errorObject.e);
            else self.next(result);
            var subscription = self.subscribe(function(x) {
                var result = $fgwEQ.tryCatch(messageFilter)(x);
                if (result === $5C5Tt.errorObject) observer.error($5C5Tt.errorObject.e);
                else if (result) observer.next(x);
            }, function(err) {
                return observer.error(err);
            }, function() {
                return observer.complete();
            });
            return function() {
                var result = $fgwEQ.tryCatch(unsubMsg)();
                if (result === $5C5Tt.errorObject) observer.error($5C5Tt.errorObject.e);
                else self.next(result);
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function() {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ? new WebSocketCtor(this.url, this.protocol) : new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) this.socket.binaryType = this.binaryType;
        } catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new $8IeZR.Subscription(function() {
            _this.socket = null;
            if (socket && socket.readyState === 1) socket.close();
        });
        socket.onopen = function(e) {
            var openObserver = _this.openObserver;
            if (openObserver) openObserver.next(e);
            var queue = _this.destination;
            _this.destination = $fwCeA.Subscriber.create(function(x) {
                return socket.readyState === 1 && socket.send(x);
            }, function(e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                if (e && e.code) socket.close(e.code, e.reason);
                else observer.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }"));
                _this._resetState();
            }, function() {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof $dktU4.ReplaySubject) subscription.add(queue.subscribe(_this.destination));
        };
        socket.onerror = function(e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function(e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) closeObserver.next(e);
            if (e.wasClean) observer.complete();
            else observer.error(e);
        };
        socket.onmessage = function(e) {
            var result = $fgwEQ.tryCatch(_this.resultSelector)(e);
            if (result === $5C5Tt.errorObject) observer.error($5C5Tt.errorObject.e);
            else observer.next(result);
        };
    };
    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function(subscriber) {
        var _this = this;
        var source = this.source;
        if (source) return source.subscribe(subscriber);
        if (!this.socket) this._connectSocket();
        var subscription = new $8IeZR.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function() {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) socket.close();
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function() {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) this.destination = new $dktU4.ReplaySubject();
    };
    return WebSocketSubject;
}($aSveF.AnonymousSubject);
module.exports.WebSocketSubject = $80e8985490e119ff$var$WebSocketSubject;

});
parcelRegister("6AHA3", function(module, exports) {
$parcel$export(module.exports, "assign", () => $4cc7e90e63897a9e$export$e6e34fd1f2686227, (v) => $4cc7e90e63897a9e$export$e6e34fd1f2686227 = v);
var $4cc7e90e63897a9e$export$b668effad3120ef4;
var $4cc7e90e63897a9e$export$e4f7f8fe212de33b;
var $4cc7e90e63897a9e$export$e6e34fd1f2686227;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
function $4cc7e90e63897a9e$var$assignImpl(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    var len = sources.length;
    for(var i = 0; i < len; i++){
        var source = sources[i];
        for(var k in source)if (source.hasOwnProperty(k)) target[k] = source[k];
    }
    return target;
}
$4cc7e90e63897a9e$export$b668effad3120ef4 = $4cc7e90e63897a9e$var$assignImpl;
function $4cc7e90e63897a9e$var$getAssign(root) {
    return root.Object.assign || $4cc7e90e63897a9e$var$assignImpl;
}
$4cc7e90e63897a9e$export$e4f7f8fe212de33b = $4cc7e90e63897a9e$var$getAssign;
$4cc7e90e63897a9e$export$e6e34fd1f2686227 = $4cc7e90e63897a9e$var$getAssign($4xUKK.root);

});




parcelRegister("9hypP", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2Z77S = parcelRequire("2Z77S");
$jFk35.Observable.prototype.buffer = $2Z77S.buffer;

});
parcelRegister("2Z77S", function(module, exports) {
$parcel$export(module.exports, "buffer", () => $22c6ce607d326c0b$export$ab1029bcae9ddb4a, (v) => $22c6ce607d326c0b$export$ab1029bcae9ddb4a = v);
var $22c6ce607d326c0b$export$ab1029bcae9ddb4a;
"use strict";

var $7Wi5u = parcelRequire("7Wi5u");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $22c6ce607d326c0b$var$buffer(closingNotifier) {
    return $7Wi5u.buffer(closingNotifier)(this);
}
$22c6ce607d326c0b$export$ab1029bcae9ddb4a = $22c6ce607d326c0b$var$buffer;

});
parcelRegister("7Wi5u", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var BufferSubscriber = function(_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add($8JM6B.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("1ruYh", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $lKp36 = parcelRequire("lKp36");
$jFk35.Observable.prototype.bufferCount = $lKp36.bufferCount;

});
parcelRegister("lKp36", function(module, exports) {
$parcel$export(module.exports, "bufferCount", () => $fd51530ba3aa0956$export$8916d2c8119541bb, (v) => $fd51530ba3aa0956$export$8916d2c8119541bb = v);
var $fd51530ba3aa0956$export$8916d2c8119541bb;
"use strict";

var $btX5F = parcelRequire("btX5F");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $fd51530ba3aa0956$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return $btX5F.bufferCount(bufferSize, startBufferEvery)(this);
}
$fd51530ba3aa0956$export$8916d2c8119541bb = $fd51530ba3aa0956$var$bufferCount;

});


parcelRegister("c4qMi", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dEIgX = parcelRequire("dEIgX");
$jFk35.Observable.prototype.bufferTime = $dEIgX.bufferTime;

});
parcelRegister("dEIgX", function(module, exports) {
$parcel$export(module.exports, "bufferTime", () => $9f115a5dfa0ea5b1$export$d6b40c95035461c7, (v) => $9f115a5dfa0ea5b1$export$d6b40c95035461c7 = v);
var $9f115a5dfa0ea5b1$export$d6b40c95035461c7;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $2gCz7 = parcelRequire("2gCz7");

var $donj9 = parcelRequire("donj9");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $9f115a5dfa0ea5b1$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $1KBsc.async;
    if ($2gCz7.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return $donj9.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
$9f115a5dfa0ea5b1$export$d6b40c95035461c7 = $9f115a5dfa0ea5b1$var$bufferTime;

});
parcelRegister("donj9", function(module, exports) {
"use strict";
var $9bff98bc88066b14$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1KBsc = parcelRequire("1KBsc");

var $fwCeA = parcelRequire("fwCeA");

var $2gCz7 = parcelRequire("2gCz7");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $9bff98bc88066b14$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $1KBsc.async;
    if ($2gCz7.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new $9bff98bc88066b14$var$BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
module.exports.bufferTime = $9bff98bc88066b14$var$bufferTime;
var $9bff98bc88066b14$var$BufferTimeOperator = function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9bff98bc88066b14$var$BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var $9bff98bc88066b14$var$Context = function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9bff98bc88066b14$var$BufferTimeSubscriber = function(_super) {
    $9bff98bc88066b14$var$__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = scheduler.schedule($9bff98bc88066b14$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(context.closeAction = scheduler.schedule($9bff98bc88066b14$var$dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule($9bff98bc88066b14$var$dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule($9bff98bc88066b14$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new $9bff98bc88066b14$var$Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}($fwCeA.Subscriber);
function $9bff98bc88066b14$var$dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function $9bff98bc88066b14$var$dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule($9bff98bc88066b14$var$dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function $9bff98bc88066b14$var$dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

});



parcelRegister("lV9cr", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $fHEx0 = parcelRequire("fHEx0");
$jFk35.Observable.prototype.bufferToggle = $fHEx0.bufferToggle;

});
parcelRegister("fHEx0", function(module, exports) {
$parcel$export(module.exports, "bufferToggle", () => $b6ea4fde381281ba$export$91115bdd8709945f, (v) => $b6ea4fde381281ba$export$91115bdd8709945f = v);
var $b6ea4fde381281ba$export$91115bdd8709945f;
"use strict";

var $flD5n = parcelRequire("flD5n");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $b6ea4fde381281ba$var$bufferToggle(openings, closingSelector) {
    return $flD5n.bufferToggle(openings, closingSelector)(this);
}
$b6ea4fde381281ba$export$91115bdd8709945f = $b6ea4fde381281ba$var$bufferToggle;

});
parcelRegister("flD5n", function(module, exports) {
"use strict";
var $b2c722cf8978d2cc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8IeZR = parcelRequire("8IeZR");

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $b2c722cf8978d2cc$var$bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new $b2c722cf8978d2cc$var$BufferToggleOperator(openings, closingSelector));
    };
}
module.exports.bufferToggle = $b2c722cf8978d2cc$var$bufferToggle;
var $b2c722cf8978d2cc$var$BufferToggleOperator = function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b2c722cf8978d2cc$var$BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b2c722cf8978d2cc$var$BufferToggleSubscriber = function(_super) {
    $b2c722cf8978d2cc$var$__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add($8JM6B.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new $8IeZR.Subscription();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = $8JM6B.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("61coZ", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2JyAm = parcelRequire("2JyAm");
$jFk35.Observable.prototype.bufferWhen = $2JyAm.bufferWhen;

});
parcelRegister("2JyAm", function(module, exports) {
$parcel$export(module.exports, "bufferWhen", () => $1fda9cb3cd927861$export$9e55760d3282e08c, (v) => $1fda9cb3cd927861$export$9e55760d3282e08c = v);
var $1fda9cb3cd927861$export$9e55760d3282e08c;
"use strict";

var $jnxYA = parcelRequire("jnxYA");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $1fda9cb3cd927861$var$bufferWhen(closingSelector) {
    return $jnxYA.bufferWhen(closingSelector)(this);
}
$1fda9cb3cd927861$export$9e55760d3282e08c = $1fda9cb3cd927861$var$bufferWhen;

});
parcelRegister("jnxYA", function(module, exports) {
"use strict";
var $e1ba85414a313ffb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8IeZR = parcelRequire("8IeZR");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $e1ba85414a313ffb$var$bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new $e1ba85414a313ffb$var$BufferWhenOperator(closingSelector));
    };
}
module.exports.bufferWhen = $e1ba85414a313ffb$var$bufferWhen;
var $e1ba85414a313ffb$var$BufferWhenOperator = function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e1ba85414a313ffb$var$BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e1ba85414a313ffb$var$BufferWhenSubscriber = function(_super) {
    $e1ba85414a313ffb$var$__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier = $fgwEQ.tryCatch(this.closingSelector)();
        if (closingNotifier === $5C5Tt.errorObject) this.error($5C5Tt.errorObject.e);
        else {
            closingSubscription = new $8IeZR.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add($8JM6B.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("1jLhC", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cyQMK = parcelRequire("cyQMK");
$jFk35.Observable.prototype.catch = $cyQMK._catch;
$jFk35.Observable.prototype._catch = $cyQMK._catch;

});
parcelRegister("cyQMK", function(module, exports) {
$parcel$export(module.exports, "_catch", () => $92519b0bb012d7d3$export$7f43fa37c3d8a0b3, (v) => $92519b0bb012d7d3$export$7f43fa37c3d8a0b3 = v);
var $92519b0bb012d7d3$export$7f43fa37c3d8a0b3;
"use strict";

var $lSkkn = parcelRequire("lSkkn");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $92519b0bb012d7d3$var$_catch(selector) {
    return $lSkkn.catchError(selector)(this);
}
$92519b0bb012d7d3$export$7f43fa37c3d8a0b3 = $92519b0bb012d7d3$var$_catch;

});
parcelRegister("lSkkn", function(module, exports) {
"use strict";
var $fece68be83a02762$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $fece68be83a02762$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $fece68be83a02762$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $fece68be83a02762$var$catchError;
var $fece68be83a02762$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fece68be83a02762$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fece68be83a02762$var$CatchSubscriber = function(_super) {
    $fece68be83a02762$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($8JM6B.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("1tMne", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $fmOPU = parcelRequire("fmOPU");
$jFk35.Observable.prototype.combineAll = $fmOPU.combineAll;

});
parcelRegister("fmOPU", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $b30058210be014ee$export$29ae691b7de52fe3, (v) => $b30058210be014ee$export$29ae691b7de52fe3 = v);
var $b30058210be014ee$export$29ae691b7de52fe3;
"use strict";

var $l6d2m = parcelRequire("l6d2m");
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */ function $b30058210be014ee$var$combineAll(project) {
    return $l6d2m.combineAll(project)(this);
}
$b30058210be014ee$export$29ae691b7de52fe3 = $b30058210be014ee$var$combineAll;

});
parcelRegister("l6d2m", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $f5c4456b2aeba767$export$29ae691b7de52fe3, (v) => $f5c4456b2aeba767$export$29ae691b7de52fe3 = v);
var $f5c4456b2aeba767$export$29ae691b7de52fe3;
"use strict";

var $4SeQD = parcelRequire("4SeQD");
function $f5c4456b2aeba767$var$combineAll(project) {
    return function(source) {
        return source.lift(new $4SeQD.CombineLatestOperator(project));
    };
}
$f5c4456b2aeba767$export$29ae691b7de52fe3 = $f5c4456b2aeba767$var$combineAll;

});



parcelRegister("bYRq1", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dJFgG = parcelRequire("dJFgG");
$jFk35.Observable.prototype.combineLatest = $dJFgG.combineLatest;

});
parcelRegister("dJFgG", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $9fff7d54662626a6$export$77fa7d86f5204e8a, (v) => $9fff7d54662626a6$export$77fa7d86f5204e8a = v);
var $9fff7d54662626a6$export$77fa7d86f5204e8a;
"use strict";

var $4SeQD = parcelRequire("4SeQD");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $9fff7d54662626a6$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $4SeQD.combineLatest.apply(void 0, observables)(this);
}
$9fff7d54662626a6$export$77fa7d86f5204e8a = $9fff7d54662626a6$var$combineLatest;

});


parcelRegister("2nTYk", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $j68BC = parcelRequire("j68BC");
$jFk35.Observable.prototype.concat = $j68BC.concat;

});
parcelRegister("j68BC", function(module, exports) {
$parcel$export(module.exports, "concat", () => $de7540cd359b33a1$export$ee1b3e54f0441b22, (v) => $de7540cd359b33a1$export$ee1b3e54f0441b22 = v);
var $de7540cd359b33a1$export$9343b684b018b33a;
var $de7540cd359b33a1$export$ee1b3e54f0441b22;
"use strict";

var $9U7Iv = parcelRequire("9U7Iv");

var $9aoKF = parcelRequire("9aoKF");
$de7540cd359b33a1$export$9343b684b018b33a = $9aoKF.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $de7540cd359b33a1$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $9U7Iv.concat.apply(void 0, observables)(this);
}
$de7540cd359b33a1$export$ee1b3e54f0441b22 = $de7540cd359b33a1$var$concat;

});
parcelRegister("9U7Iv", function(module, exports) {
$parcel$export(module.exports, "concat", () => $735f5468e2cbd2d7$export$ee1b3e54f0441b22, (v) => $735f5468e2cbd2d7$export$ee1b3e54f0441b22 = v);
var $735f5468e2cbd2d7$export$9343b684b018b33a;
var $735f5468e2cbd2d7$export$ee1b3e54f0441b22;
"use strict";

var $9aoKF = parcelRequire("9aoKF");

var $9aoKF = parcelRequire("9aoKF");
$735f5468e2cbd2d7$export$9343b684b018b33a = $9aoKF.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $735f5468e2cbd2d7$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($9aoKF.concat.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$735f5468e2cbd2d7$export$ee1b3e54f0441b22 = $735f5468e2cbd2d7$var$concat;

});



parcelRegister("gAgiX", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $84T97 = parcelRequire("84T97");
$jFk35.Observable.prototype.concatAll = $84T97.concatAll;

});
parcelRegister("84T97", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $5e1979513313c12a$export$b314777ae20abca9, (v) => $5e1979513313c12a$export$b314777ae20abca9 = v);
var $5e1979513313c12a$export$b314777ae20abca9;
"use strict";

var $jfCUi = parcelRequire("jfCUi");
/* tslint:enable:max-line-length */ /**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $5e1979513313c12a$var$concatAll() {
    return $jfCUi.concatAll()(this);
}
$5e1979513313c12a$export$b314777ae20abca9 = $5e1979513313c12a$var$concatAll;

});


parcelRegister("hFz6o", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $a4EnK = parcelRequire("a4EnK");
$jFk35.Observable.prototype.concatMap = $a4EnK.concatMap;

});
parcelRegister("a4EnK", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $75599a1dd70b1f7e$export$c28c8388be0ab31a, (v) => $75599a1dd70b1f7e$export$c28c8388be0ab31a = v);
var $75599a1dd70b1f7e$export$c28c8388be0ab31a;
"use strict";

var $c4lxx = parcelRequire("c4lxx");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $75599a1dd70b1f7e$var$concatMap(project, resultSelector) {
    return $c4lxx.concatMap(project, resultSelector)(this);
}
$75599a1dd70b1f7e$export$c28c8388be0ab31a = $75599a1dd70b1f7e$var$concatMap;

});


parcelRegister("dXPid", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $59QDJ = parcelRequire("59QDJ");
$jFk35.Observable.prototype.concatMapTo = $59QDJ.concatMapTo;

});
parcelRegister("59QDJ", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $3c16a0333a57aae8$export$82fbd7a2841d2484, (v) => $3c16a0333a57aae8$export$82fbd7a2841d2484 = v);
var $3c16a0333a57aae8$export$82fbd7a2841d2484;
"use strict";

var $6kB8h = parcelRequire("6kB8h");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $3c16a0333a57aae8$var$concatMapTo(innerObservable, resultSelector) {
    return $6kB8h.concatMapTo(innerObservable, resultSelector)(this);
}
$3c16a0333a57aae8$export$82fbd7a2841d2484 = $3c16a0333a57aae8$var$concatMapTo;

});
parcelRegister("6kB8h", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $49c16a0f6bc350d9$export$82fbd7a2841d2484, (v) => $49c16a0f6bc350d9$export$82fbd7a2841d2484 = v);
var $49c16a0f6bc350d9$export$82fbd7a2841d2484;
"use strict";

var $c4lxx = parcelRequire("c4lxx");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $49c16a0f6bc350d9$var$concatMapTo(innerObservable, resultSelector) {
    return $c4lxx.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$49c16a0f6bc350d9$export$82fbd7a2841d2484 = $49c16a0f6bc350d9$var$concatMapTo;

});



parcelRegister("5S6n4", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ecNMd = parcelRequire("ecNMd");
$jFk35.Observable.prototype.count = $ecNMd.count;

});
parcelRegister("ecNMd", function(module, exports) {
$parcel$export(module.exports, "count", () => $a578cc44152664b4$export$85b9a36db797e02b, (v) => $a578cc44152664b4$export$85b9a36db797e02b = v);
var $a578cc44152664b4$export$85b9a36db797e02b;
"use strict";

var $8ARP1 = parcelRequire("8ARP1");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $a578cc44152664b4$var$count(predicate) {
    return $8ARP1.count(predicate)(this);
}
$a578cc44152664b4$export$85b9a36db797e02b = $a578cc44152664b4$var$count;

});
parcelRegister("8ARP1", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("6B5jK", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $gOUil = parcelRequire("gOUil");
$jFk35.Observable.prototype.dematerialize = $gOUil.dematerialize;

});
parcelRegister("gOUil", function(module, exports) {
$parcel$export(module.exports, "dematerialize", () => $c3ecfbda90a0aace$export$ab9a5985b741fa7a, (v) => $c3ecfbda90a0aace$export$ab9a5985b741fa7a = v);
var $c3ecfbda90a0aace$export$ab9a5985b741fa7a;
"use strict";

var $eea4V = parcelRequire("eea4V");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $c3ecfbda90a0aace$var$dematerialize() {
    return $eea4V.dematerialize()(this);
}
$c3ecfbda90a0aace$export$ab9a5985b741fa7a = $c3ecfbda90a0aace$var$dematerialize;

});
parcelRegister("eea4V", function(module, exports) {
"use strict";
var $a5ba30df12f2cbde$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $a5ba30df12f2cbde$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $a5ba30df12f2cbde$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $a5ba30df12f2cbde$var$dematerialize;
var $a5ba30df12f2cbde$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5ba30df12f2cbde$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5ba30df12f2cbde$var$DeMaterializeSubscriber = function(_super) {
    $a5ba30df12f2cbde$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("9jgx3", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $77zX8 = parcelRequire("77zX8");
$jFk35.Observable.prototype.debounce = $77zX8.debounce;

});
parcelRegister("77zX8", function(module, exports) {
$parcel$export(module.exports, "debounce", () => $52f51351ce52b406$export$61fc7d43ac8f84b0, (v) => $52f51351ce52b406$export$61fc7d43ac8f84b0 = v);
var $52f51351ce52b406$export$61fc7d43ac8f84b0;
"use strict";

var $g6ErV = parcelRequire("g6ErV");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $52f51351ce52b406$var$debounce(durationSelector) {
    return $g6ErV.debounce(durationSelector)(this);
}
$52f51351ce52b406$export$61fc7d43ac8f84b0 = $52f51351ce52b406$var$debounce;

});
parcelRegister("g6ErV", function(module, exports) {
"use strict";
var $bb9c9546a100765d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $bb9c9546a100765d$var$debounce(durationSelector) {
    return function(source) {
        return source.lift(new $bb9c9546a100765d$var$DebounceOperator(durationSelector));
    };
}
module.exports.debounce = $bb9c9546a100765d$var$debounce;
var $bb9c9546a100765d$var$DebounceOperator = function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bb9c9546a100765d$var$DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bb9c9546a100765d$var$DebounceSubscriber = function(_super) {
    $bb9c9546a100765d$var$__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = $8JM6B.subscribeToResult(this, duration);
        if (!subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("6yL0d", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $eNxDG = parcelRequire("eNxDG");
$jFk35.Observable.prototype.debounceTime = $eNxDG.debounceTime;

});
parcelRegister("eNxDG", function(module, exports) {
$parcel$export(module.exports, "debounceTime", () => $ac5fbc4c40e622ac$export$7843a4469d64c07e, (v) => $ac5fbc4c40e622ac$export$7843a4469d64c07e = v);
var $ac5fbc4c40e622ac$export$7843a4469d64c07e;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $lmNHo = parcelRequire("lmNHo");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $ac5fbc4c40e622ac$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $lmNHo.debounceTime(dueTime, scheduler)(this);
}
$ac5fbc4c40e622ac$export$7843a4469d64c07e = $ac5fbc4c40e622ac$var$debounceTime;

});
parcelRegister("lmNHo", function(module, exports) {
"use strict";
var $f8e2343479f80b0f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $1KBsc = parcelRequire("1KBsc");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $f8e2343479f80b0f$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return function(source) {
        return source.lift(new $f8e2343479f80b0f$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $f8e2343479f80b0f$var$debounceTime;
var $f8e2343479f80b0f$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f8e2343479f80b0f$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f8e2343479f80b0f$var$DebounceTimeSubscriber = function(_super) {
    $f8e2343479f80b0f$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($f8e2343479f80b0f$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($fwCeA.Subscriber);
function $f8e2343479f80b0f$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});



parcelRegister("hFoSs", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ci7tq = parcelRequire("ci7tq");
$jFk35.Observable.prototype.defaultIfEmpty = $ci7tq.defaultIfEmpty;

});
parcelRegister("ci7tq", function(module, exports) {
$parcel$export(module.exports, "defaultIfEmpty", () => $8f2cf699bc1ccd70$export$e4ca6d7b7a6dcf9b, (v) => $8f2cf699bc1ccd70$export$e4ca6d7b7a6dcf9b = v);
var $8f2cf699bc1ccd70$export$e4ca6d7b7a6dcf9b;
"use strict";

var $k5Foi = parcelRequire("k5Foi");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $8f2cf699bc1ccd70$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $k5Foi.defaultIfEmpty(defaultValue)(this);
}
$8f2cf699bc1ccd70$export$e4ca6d7b7a6dcf9b = $8f2cf699bc1ccd70$var$defaultIfEmpty;

});
parcelRegister("k5Foi", function(module, exports) {
"use strict";
var $ea0461a06e91b9a2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $ea0461a06e91b9a2$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $ea0461a06e91b9a2$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $ea0461a06e91b9a2$var$defaultIfEmpty;
var $ea0461a06e91b9a2$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ea0461a06e91b9a2$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ea0461a06e91b9a2$var$DefaultIfEmptySubscriber = function(_super) {
    $ea0461a06e91b9a2$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("ec160", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $c8258 = parcelRequire("c8258");
$jFk35.Observable.prototype.delay = $c8258.delay;

});
parcelRegister("c8258", function(module, exports) {
$parcel$export(module.exports, "delay", () => $8d47d8cb59badc65$export$1391212d75b2ee65, (v) => $8d47d8cb59badc65$export$1391212d75b2ee65 = v);
var $8d47d8cb59badc65$export$1391212d75b2ee65;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $dgT9w = parcelRequire("dgT9w");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $8d47d8cb59badc65$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $dgT9w.delay(delay, scheduler)(this);
}
$8d47d8cb59badc65$export$1391212d75b2ee65 = $8d47d8cb59badc65$var$delay;

});
parcelRegister("dgT9w", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1KBsc = parcelRequire("1KBsc");

var $iUp3d = parcelRequire("iUp3d");

var $fwCeA = parcelRequire("fwCeA");

var $jWUHN = parcelRequire("jWUHN");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    var absoluteDelay = $iUp3d.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($jWUHN.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($jWUHN.Notification.createComplete());
    };
    return DelaySubscriber;
}($fwCeA.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});



parcelRegister("lHshI", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $7iipu = parcelRequire("7iipu");
$jFk35.Observable.prototype.delayWhen = $7iipu.delayWhen;

});
parcelRegister("7iipu", function(module, exports) {
$parcel$export(module.exports, "delayWhen", () => $015ed8c0ea58afdd$export$286ca829307725c9, (v) => $015ed8c0ea58afdd$export$286ca829307725c9 = v);
var $015ed8c0ea58afdd$export$286ca829307725c9;
"use strict";

var $50lVf = parcelRequire("50lVf");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $015ed8c0ea58afdd$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    return $50lVf.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
$015ed8c0ea58afdd$export$286ca829307725c9 = $015ed8c0ea58afdd$var$delayWhen;

});
parcelRegister("50lVf", function(module, exports) {
"use strict";
var $3a4df524417c05be$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $jFk35 = parcelRequire("jFk35");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $3a4df524417c05be$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $3a4df524417c05be$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $3a4df524417c05be$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $3a4df524417c05be$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $3a4df524417c05be$var$delayWhen;
var $3a4df524417c05be$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3a4df524417c05be$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3a4df524417c05be$var$DelayWhenSubscriber = function(_super) {
    $3a4df524417c05be$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $8JM6B.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($cSU8n.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3a4df524417c05be$var$SubscriptionDelayObservable = function(_super) {
    $3a4df524417c05be$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $3a4df524417c05be$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($jFk35.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3a4df524417c05be$var$SubscriptionDelaySubscriber = function(_super) {
    $3a4df524417c05be$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("72MNT", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $6vthK = parcelRequire("6vthK");
$jFk35.Observable.prototype.distinct = $6vthK.distinct;

});
parcelRegister("6vthK", function(module, exports) {
$parcel$export(module.exports, "distinct", () => $4bcc5ac9f7e6cee3$export$983a3b5fb2f7202e, (v) => $4bcc5ac9f7e6cee3$export$983a3b5fb2f7202e = v);
var $4bcc5ac9f7e6cee3$export$983a3b5fb2f7202e;
"use strict";

var $EoR3N = parcelRequire("EoR3N");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $4bcc5ac9f7e6cee3$var$distinct(keySelector, flushes) {
    return $EoR3N.distinct(keySelector, flushes)(this);
}
$4bcc5ac9f7e6cee3$export$983a3b5fb2f7202e = $4bcc5ac9f7e6cee3$var$distinct;

});
parcelRegister("EoR3N", function(module, exports) {
"use strict";
var $0797043051329c64$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");

var $ipSmK = parcelRequire("ipSmK");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $0797043051329c64$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $0797043051329c64$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $0797043051329c64$var$distinct;
var $0797043051329c64$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0797043051329c64$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0797043051329c64$var$DistinctSubscriber = function(_super) {
    $0797043051329c64$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $ipSmK.Set();
        if (flushes) this.add($8JM6B.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.DistinctSubscriber = $0797043051329c64$var$DistinctSubscriber;

});
parcelRegister("ipSmK", function(module, exports) {
$parcel$export(module.exports, "Set", () => $d684bbb7d569aedf$export$bdf4ff5a442cbbc5, (v) => $d684bbb7d569aedf$export$bdf4ff5a442cbbc5 = v);
var $d684bbb7d569aedf$export$ac57f2e66ff143c0;
var $d684bbb7d569aedf$export$bdf4ff5a442cbbc5;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
function $d684bbb7d569aedf$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$d684bbb7d569aedf$export$ac57f2e66ff143c0 = $d684bbb7d569aedf$var$minimalSetImpl;
$d684bbb7d569aedf$export$bdf4ff5a442cbbc5 = $4xUKK.root.Set || $d684bbb7d569aedf$var$minimalSetImpl();

});




parcelRegister("d7Oyu", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $e68sN = parcelRequire("e68sN");
$jFk35.Observable.prototype.distinctUntilChanged = $e68sN.distinctUntilChanged;

});
parcelRegister("e68sN", function(module, exports) {
$parcel$export(module.exports, "distinctUntilChanged", () => $a43830e56ea330c0$export$779c5fb865a0172e, (v) => $a43830e56ea330c0$export$779c5fb865a0172e = v);
var $a43830e56ea330c0$export$779c5fb865a0172e;
"use strict";

var $lPqv7 = parcelRequire("lPqv7");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $a43830e56ea330c0$var$distinctUntilChanged(compare, keySelector) {
    return $lPqv7.distinctUntilChanged(compare, keySelector)(this);
}
$a43830e56ea330c0$export$779c5fb865a0172e = $a43830e56ea330c0$var$distinctUntilChanged;

});
parcelRegister("lPqv7", function(module, exports) {
"use strict";
var $fe42eae9fbdc4e97$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $fe42eae9fbdc4e97$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $fe42eae9fbdc4e97$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $fe42eae9fbdc4e97$var$distinctUntilChanged;
var $fe42eae9fbdc4e97$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe42eae9fbdc4e97$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe42eae9fbdc4e97$var$DistinctUntilChangedSubscriber = function(_super) {
    $fe42eae9fbdc4e97$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $fgwEQ.tryCatch(this.keySelector)(value);
            if (key === $5C5Tt.errorObject) return this.destination.error($5C5Tt.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $fgwEQ.tryCatch(this.compare)(this.key, key);
            if (result === $5C5Tt.errorObject) return this.destination.error($5C5Tt.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("f5Ic9", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $4D7L8 = parcelRequire("4D7L8");
$jFk35.Observable.prototype.distinctUntilKeyChanged = $4D7L8.distinctUntilKeyChanged;

});
parcelRegister("4D7L8", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $35f0d2c755a6292d$export$571da16e28367bde, (v) => $35f0d2c755a6292d$export$571da16e28367bde = v);
var $35f0d2c755a6292d$export$571da16e28367bde;
"use strict";

var $ffjUk = parcelRequire("ffjUk");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $35f0d2c755a6292d$var$distinctUntilKeyChanged(key, compare) {
    return $ffjUk.distinctUntilKeyChanged(key, compare)(this);
}
$35f0d2c755a6292d$export$571da16e28367bde = $35f0d2c755a6292d$var$distinctUntilKeyChanged;

});
parcelRegister("ffjUk", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $b197b2f262b4236b$export$571da16e28367bde, (v) => $b197b2f262b4236b$export$571da16e28367bde = v);
var $b197b2f262b4236b$export$571da16e28367bde;
"use strict";

var $lPqv7 = parcelRequire("lPqv7");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $b197b2f262b4236b$var$distinctUntilKeyChanged(key, compare) {
    return $lPqv7.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$b197b2f262b4236b$export$571da16e28367bde = $b197b2f262b4236b$var$distinctUntilKeyChanged;

});



parcelRegister("5YmLX", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dzLwx = parcelRequire("dzLwx");
$jFk35.Observable.prototype.do = $dzLwx._do;
$jFk35.Observable.prototype._do = $dzLwx._do;

});
parcelRegister("dzLwx", function(module, exports) {
$parcel$export(module.exports, "_do", () => $9e2368809af2e65f$export$6e1c2ce23f3c9991, (v) => $9e2368809af2e65f$export$6e1c2ce23f3c9991 = v);
var $9e2368809af2e65f$export$6e1c2ce23f3c9991;
"use strict";

var $Ap2W5 = parcelRequire("Ap2W5");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $9e2368809af2e65f$var$_do(nextOrObserver, error, complete) {
    return $Ap2W5.tap(nextOrObserver, error, complete)(this);
}
$9e2368809af2e65f$export$6e1c2ce23f3c9991 = $9e2368809af2e65f$var$_do;

});


parcelRegister("9MBPF", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $bOZDi = parcelRequire("bOZDi");
$jFk35.Observable.prototype.exhaust = $bOZDi.exhaust;

});
parcelRegister("bOZDi", function(module, exports) {
$parcel$export(module.exports, "exhaust", () => $89b42c337cbd074d$export$31039f1fbd797b9c, (v) => $89b42c337cbd074d$export$31039f1fbd797b9c = v);
var $89b42c337cbd074d$export$31039f1fbd797b9c;
"use strict";

var $9WMCN = parcelRequire("9WMCN");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $89b42c337cbd074d$var$exhaust() {
    return $9WMCN.exhaust()(this);
}
$89b42c337cbd074d$export$31039f1fbd797b9c = $89b42c337cbd074d$var$exhaust;

});
parcelRegister("9WMCN", function(module, exports) {
"use strict";
var $73df3faff4f8f4b9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $73df3faff4f8f4b9$var$exhaust() {
    return function(source) {
        return source.lift(new $73df3faff4f8f4b9$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $73df3faff4f8f4b9$var$exhaust;
var $73df3faff4f8f4b9$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $73df3faff4f8f4b9$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $73df3faff4f8f4b9$var$SwitchFirstSubscriber = function(_super) {
    $73df3faff4f8f4b9$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($8JM6B.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("3sKSK", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $krxri = parcelRequire("krxri");
$jFk35.Observable.prototype.exhaustMap = $krxri.exhaustMap;

});
parcelRegister("krxri", function(module, exports) {
$parcel$export(module.exports, "exhaustMap", () => $ee20449693dca784$export$d70d492cd31004c0, (v) => $ee20449693dca784$export$d70d492cd31004c0 = v);
var $ee20449693dca784$export$d70d492cd31004c0;
"use strict";

var $cDQb0 = parcelRequire("cDQb0");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $ee20449693dca784$var$exhaustMap(project, resultSelector) {
    return $cDQb0.exhaustMap(project, resultSelector)(this);
}
$ee20449693dca784$export$d70d492cd31004c0 = $ee20449693dca784$var$exhaustMap;

});
parcelRegister("cDQb0", function(module, exports) {
"use strict";
var $934199b2fb805e1d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $934199b2fb805e1d$var$exhaustMap(project, resultSelector) {
    return function(source) {
        return source.lift(new $934199b2fb805e1d$var$SwitchFirstMapOperator(project, resultSelector));
    };
}
module.exports.exhaustMap = $934199b2fb805e1d$var$exhaustMap;
var $934199b2fb805e1d$var$SwitchFirstMapOperator = function() {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $934199b2fb805e1d$var$SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $934199b2fb805e1d$var$SwitchFirstMapSubscriber = function(_super) {
    $934199b2fb805e1d$var$__extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function(value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add($8JM6B.subscribeToResult(this, result, value, index));
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstMapSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("lS0O8", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $6QPB4 = parcelRequire("6QPB4");
$jFk35.Observable.prototype.expand = $6QPB4.expand;

});
parcelRegister("6QPB4", function(module, exports) {
$parcel$export(module.exports, "expand", () => $4fcf9f76236205ae$export$9f77e0932fb78f72, (v) => $4fcf9f76236205ae$export$9f77e0932fb78f72 = v);
var $4fcf9f76236205ae$export$9f77e0932fb78f72;
"use strict";

var $jr4BH = parcelRequire("jr4BH");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $4fcf9f76236205ae$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return $jr4BH.expand(project, concurrent, scheduler)(this);
}
$4fcf9f76236205ae$export$9f77e0932fb78f72 = $4fcf9f76236205ae$var$expand;

});
parcelRegister("jr4BH", function(module, exports) {
"use strict";
var $e2641cd0361b7536$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $e2641cd0361b7536$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $e2641cd0361b7536$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $e2641cd0361b7536$var$expand;
var $e2641cd0361b7536$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e2641cd0361b7536$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $e2641cd0361b7536$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e2641cd0361b7536$var$ExpandSubscriber = function(_super) {
    $e2641cd0361b7536$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $fgwEQ.tryCatch(this.project)(value, index);
            if (result === $5C5Tt.errorObject) destination.error($5C5Tt.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($8JM6B.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.ExpandSubscriber = $e2641cd0361b7536$var$ExpandSubscriber;

});



parcelRegister("3EBE1", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $36oMW = parcelRequire("36oMW");
$jFk35.Observable.prototype.elementAt = $36oMW.elementAt;

});
parcelRegister("36oMW", function(module, exports) {
$parcel$export(module.exports, "elementAt", () => $24252917573114bf$export$91d69c7761a17bbc, (v) => $24252917573114bf$export$91d69c7761a17bbc = v);
var $24252917573114bf$export$91d69c7761a17bbc;
"use strict";

var $giEnQ = parcelRequire("giEnQ");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $24252917573114bf$var$elementAt(index, defaultValue) {
    return $giEnQ.elementAt(index, defaultValue)(this);
}
$24252917573114bf$export$91d69c7761a17bbc = $24252917573114bf$var$elementAt;

});
parcelRegister("giEnQ", function(module, exports) {
"use strict";
var $bddda7206e244376$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $cdlG8 = parcelRequire("cdlG8");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $bddda7206e244376$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $bddda7206e244376$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $bddda7206e244376$var$elementAt;
var $bddda7206e244376$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $cdlG8.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bddda7206e244376$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bddda7206e244376$var$ElementAtSubscriber = function(_super) {
    $bddda7206e244376$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $cdlG8.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($fwCeA.Subscriber);

});
parcelRegister("cdlG8", function(module, exports) {
"use strict";
var $8e4783dc23932509$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $8e4783dc23932509$var$ArgumentOutOfRangeError = function(_super) {
    $8e4783dc23932509$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $8e4783dc23932509$var$ArgumentOutOfRangeError;

});




parcelRegister("3YqsY", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $gTQyV = parcelRequire("gTQyV");
$jFk35.Observable.prototype.filter = $gTQyV.filter;

});

parcelRegister("ehCqI", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $gGiUL = parcelRequire("gGiUL");
$jFk35.Observable.prototype.finally = $gGiUL._finally;
$jFk35.Observable.prototype._finally = $gGiUL._finally;

});
parcelRegister("gGiUL", function(module, exports) {
$parcel$export(module.exports, "_finally", () => $c24f3d9e833dd445$export$f6224470e4cea3fa, (v) => $c24f3d9e833dd445$export$f6224470e4cea3fa = v);
var $c24f3d9e833dd445$export$f6224470e4cea3fa;
"use strict";

var $i0OUJ = parcelRequire("i0OUJ");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $c24f3d9e833dd445$var$_finally(callback) {
    return $i0OUJ.finalize(callback)(this);
}
$c24f3d9e833dd445$export$f6224470e4cea3fa = $c24f3d9e833dd445$var$_finally;

});
parcelRegister("i0OUJ", function(module, exports) {
"use strict";
var $d1cfb88bc4206a68$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $8IeZR = parcelRequire("8IeZR");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $d1cfb88bc4206a68$var$finalize(callback) {
    return function(source) {
        return source.lift(new $d1cfb88bc4206a68$var$FinallyOperator(callback));
    };
}
module.exports.finalize = $d1cfb88bc4206a68$var$finalize;
var $d1cfb88bc4206a68$var$FinallyOperator = function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d1cfb88bc4206a68$var$FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d1cfb88bc4206a68$var$FinallySubscriber = function(_super) {
    $d1cfb88bc4206a68$var$__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new $8IeZR.Subscription(callback));
    }
    return FinallySubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("hB7Zq", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $7PV7o = parcelRequire("7PV7o");
$jFk35.Observable.prototype.find = $7PV7o.find;

});
parcelRegister("7PV7o", function(module, exports) {
$parcel$export(module.exports, "find", () => $5b499a4cc3bcc5b7$export$71aa6c912b956294, (v) => $5b499a4cc3bcc5b7$export$71aa6c912b956294 = v);
var $5b499a4cc3bcc5b7$export$71aa6c912b956294;
"use strict";

var $gka91 = parcelRequire("gka91");
/* tslint:enable:max-line-length */ /**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $5b499a4cc3bcc5b7$var$find(predicate, thisArg) {
    return $gka91.find(predicate, thisArg)(this);
}
$5b499a4cc3bcc5b7$export$71aa6c912b956294 = $5b499a4cc3bcc5b7$var$find;

});
parcelRegister("gka91", function(module, exports) {
"use strict";
var $be2662195c27946a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $be2662195c27946a$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $be2662195c27946a$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $be2662195c27946a$var$find;
var $be2662195c27946a$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $be2662195c27946a$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $be2662195c27946a$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $be2662195c27946a$var$FindValueSubscriber = function(_super) {
    $be2662195c27946a$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($fwCeA.Subscriber);
module.exports.FindValueSubscriber = $be2662195c27946a$var$FindValueSubscriber;

});



parcelRegister("4jKjx", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $k2gDL = parcelRequire("k2gDL");
$jFk35.Observable.prototype.findIndex = $k2gDL.findIndex;

});
parcelRegister("k2gDL", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $e960e7005f082385$export$de3a4d4a0d731119, (v) => $e960e7005f082385$export$de3a4d4a0d731119 = v);
var $e960e7005f082385$export$de3a4d4a0d731119;
"use strict";

var $dEmYk = parcelRequire("dEmYk");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $e960e7005f082385$var$findIndex(predicate, thisArg) {
    return $dEmYk.findIndex(predicate, thisArg)(this);
}
$e960e7005f082385$export$de3a4d4a0d731119 = $e960e7005f082385$var$findIndex;

});
parcelRegister("dEmYk", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $9f00d48936b9316a$export$de3a4d4a0d731119, (v) => $9f00d48936b9316a$export$de3a4d4a0d731119 = v);
var $9f00d48936b9316a$export$de3a4d4a0d731119;
"use strict";

var $gka91 = parcelRequire("gka91");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $9f00d48936b9316a$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $gka91.FindValueOperator(predicate, source, true, thisArg));
    };
}
$9f00d48936b9316a$export$de3a4d4a0d731119 = $9f00d48936b9316a$var$findIndex;

});



parcelRegister("37JoW", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dVyeY = parcelRequire("dVyeY");
$jFk35.Observable.prototype.first = $dVyeY.first;

});
parcelRegister("dVyeY", function(module, exports) {
$parcel$export(module.exports, "first", () => $a23b28ac7896d207$export$43128fadae87b74a, (v) => $a23b28ac7896d207$export$43128fadae87b74a = v);
var $a23b28ac7896d207$export$43128fadae87b74a;
"use strict";

var $eInEH = parcelRequire("eInEH");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $a23b28ac7896d207$var$first(predicate, resultSelector, defaultValue) {
    return $eInEH.first(predicate, resultSelector, defaultValue)(this);
}
$a23b28ac7896d207$export$43128fadae87b74a = $a23b28ac7896d207$var$first;

});
parcelRegister("eInEH", function(module, exports) {
"use strict";
var $ab67863f9f28a8e5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $gJkED = parcelRequire("gJkED");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $ab67863f9f28a8e5$var$first(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $ab67863f9f28a8e5$var$FirstOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.first = $ab67863f9f28a8e5$var$first;
var $ab67863f9f28a8e5$var$FirstOperator = function() {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ab67863f9f28a8e5$var$FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ab67863f9f28a8e5$var$FirstSubscriber = function(_super) {
    $ab67863f9f28a8e5$var$__extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else this._emit(value, index);
    };
    FirstSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this._emit(value, index);
    };
    FirstSubscriber.prototype._emit = function(value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function(value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        } else if (!this.hasCompleted) destination.error(new $gJkED.EmptyError);
    };
    return FirstSubscriber;
}($fwCeA.Subscriber);

});
parcelRegister("gJkED", function(module, exports) {
"use strict";
var $c2e0ded4dd50b897$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */ var $c2e0ded4dd50b897$var$EmptyError = function(_super) {
    $c2e0ded4dd50b897$var$__extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error);
module.exports.EmptyError = $c2e0ded4dd50b897$var$EmptyError;

});




parcelRegister("d2bE9", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $4yTCu = parcelRequire("4yTCu");
$jFk35.Observable.prototype.groupBy = $4yTCu.groupBy;

});
parcelRegister("4yTCu", function(module, exports) {
$parcel$export(module.exports, "groupBy", () => $35257b575691f5bf$export$3f063810d7bf01bd, (v) => $35257b575691f5bf$export$3f063810d7bf01bd = v);
var $35257b575691f5bf$export$ff26824b3dc37d8c;
var $35257b575691f5bf$export$3f063810d7bf01bd;
"use strict";

var $fmsS1 = parcelRequire("fmsS1");
$35257b575691f5bf$export$ff26824b3dc37d8c = $fmsS1.GroupedObservable;
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $35257b575691f5bf$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return $fmsS1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
$35257b575691f5bf$export$3f063810d7bf01bd = $35257b575691f5bf$var$groupBy;

});
parcelRegister("fmsS1", function(module, exports) {
"use strict";
var $b2ef4e20b29b872d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $8IeZR = parcelRequire("8IeZR");

var $jFk35 = parcelRequire("jFk35");

var $aSveF = parcelRequire("aSveF");

var $748NH = parcelRequire("748NH");

var $cGe7o = parcelRequire("cGe7o");
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $b2ef4e20b29b872d$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new $b2ef4e20b29b872d$var$GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
module.exports.groupBy = $b2ef4e20b29b872d$var$groupBy;
var $b2ef4e20b29b872d$var$GroupByOperator = function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b2ef4e20b29b872d$var$GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b2ef4e20b29b872d$var$GroupBySubscriber = function(_super) {
    $b2ef4e20b29b872d$var$__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = typeof key === 'string' ? new $cGe7o.FastMap() : new $748NH.Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new $aSveF.Subject();
            groups.set(key, group);
            var groupedObservable = new $b2ef4e20b29b872d$var$GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new $b2ef4e20b29b872d$var$GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new $b2ef4e20b29b872d$var$GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}($fwCeA.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b2ef4e20b29b872d$var$GroupDurationSubscriber = function(_super) {
    $b2ef4e20b29b872d$var$__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}($fwCeA.Subscriber);
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */ var $b2ef4e20b29b872d$var$GroupedObservable = function(_super) {
    $b2ef4e20b29b872d$var$__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new $8IeZR.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new $b2ef4e20b29b872d$var$InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}($jFk35.Observable);
module.exports.GroupedObservable = $b2ef4e20b29b872d$var$GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b2ef4e20b29b872d$var$InnerRefCountSubscription = function(_super) {
    $b2ef4e20b29b872d$var$__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}($8IeZR.Subscription);

});
parcelRegister("748NH", function(module, exports) {
$parcel$export(module.exports, "Map", () => $524fbbc37aa9b2c8$export$a5c7b93649eaf8f8, (v) => $524fbbc37aa9b2c8$export$a5c7b93649eaf8f8 = v);
var $524fbbc37aa9b2c8$export$a5c7b93649eaf8f8;
"use strict";

var $4xUKK = parcelRequire("4xUKK");

var $h3IDl = parcelRequire("h3IDl");
$524fbbc37aa9b2c8$export$a5c7b93649eaf8f8 = $4xUKK.root.Map || function() {
    return $h3IDl.MapPolyfill;
}();

});
parcelRegister("h3IDl", function(module, exports) {
$parcel$export(module.exports, "MapPolyfill", () => $c6b556c79d5e4e2a$export$dd450425f6b4a07, (v) => $c6b556c79d5e4e2a$export$dd450425f6b4a07 = v);
var $c6b556c79d5e4e2a$export$dd450425f6b4a07;
"use strict";
var $c6b556c79d5e4e2a$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function(key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function(key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        } else this._values[i] = value;
        return this;
    };
    MapPolyfill.prototype.delete = function(key) {
        var i = this._keys.indexOf(key);
        if (i === -1) return false;
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function() {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function(cb, thisArg) {
        for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
    };
    return MapPolyfill;
}();
$c6b556c79d5e4e2a$export$dd450425f6b4a07 = $c6b556c79d5e4e2a$var$MapPolyfill;

});


parcelRegister("cGe7o", function(module, exports) {
$parcel$export(module.exports, "FastMap", () => $0261e0732a955cf7$export$d3f0a24774bb4055, (v) => $0261e0732a955cf7$export$d3f0a24774bb4055 = v);
var $0261e0732a955cf7$export$d3f0a24774bb4055;
"use strict";
var $0261e0732a955cf7$var$FastMap = function() {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function(key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function(key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function(key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function(cb, thisArg) {
        var values = this.values;
        for(var key in values)if (values.hasOwnProperty(key) && values[key] !== null) cb.call(thisArg, values[key], key);
    };
    FastMap.prototype.clear = function() {
        this.values = {};
    };
    return FastMap;
}();
$0261e0732a955cf7$export$d3f0a24774bb4055 = $0261e0732a955cf7$var$FastMap;

});




parcelRegister("f1yFl", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cnAoR = parcelRequire("cnAoR");
$jFk35.Observable.prototype.ignoreElements = $cnAoR.ignoreElements;

});
parcelRegister("cnAoR", function(module, exports) {
$parcel$export(module.exports, "ignoreElements", () => $9033de4aed50d153$export$6953b97c7d866605, (v) => $9033de4aed50d153$export$6953b97c7d866605 = v);
var $9033de4aed50d153$export$6953b97c7d866605;
"use strict";

var $2J6Du = parcelRequire("2J6Du");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $9033de4aed50d153$var$ignoreElements() {
    return $2J6Du.ignoreElements()(this);
}
$9033de4aed50d153$export$6953b97c7d866605 = $9033de4aed50d153$var$ignoreElements;

});
parcelRegister("2J6Du", function(module, exports) {
"use strict";
var $1fc4ee83fba0bc46$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $6EUcf = parcelRequire("6EUcf");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $1fc4ee83fba0bc46$var$ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new $1fc4ee83fba0bc46$var$IgnoreElementsOperator());
    };
}
module.exports.ignoreElements = $1fc4ee83fba0bc46$var$ignoreElements;
var $1fc4ee83fba0bc46$var$IgnoreElementsOperator = function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1fc4ee83fba0bc46$var$IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1fc4ee83fba0bc46$var$IgnoreElementsSubscriber = function(_super) {
    $1fc4ee83fba0bc46$var$__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {
        $6EUcf.noop();
    };
    return IgnoreElementsSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("c6ynT", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $4ESEU = parcelRequire("4ESEU");
$jFk35.Observable.prototype.isEmpty = $4ESEU.isEmpty;

});
parcelRegister("4ESEU", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $36454bf72299c4ae$export$dd1bc94b04021eeb, (v) => $36454bf72299c4ae$export$dd1bc94b04021eeb = v);
var $36454bf72299c4ae$export$dd1bc94b04021eeb;
"use strict";

var $irbCR = parcelRequire("irbCR");
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */ function $36454bf72299c4ae$var$isEmpty() {
    return $irbCR.isEmpty()(this);
}
$36454bf72299c4ae$export$dd1bc94b04021eeb = $36454bf72299c4ae$var$isEmpty;

});
parcelRegister("irbCR", function(module, exports) {
"use strict";
var $d6c3c443e67b5e0e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
function $d6c3c443e67b5e0e$var$isEmpty() {
    return function(source) {
        return source.lift(new $d6c3c443e67b5e0e$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $d6c3c443e67b5e0e$var$isEmpty;
var $d6c3c443e67b5e0e$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d6c3c443e67b5e0e$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d6c3c443e67b5e0e$var$IsEmptySubscriber = function(_super) {
    $d6c3c443e67b5e0e$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("fWP9V", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cUorJ = parcelRequire("cUorJ");
$jFk35.Observable.prototype.audit = $cUorJ.audit;

});
parcelRegister("cUorJ", function(module, exports) {
$parcel$export(module.exports, "audit", () => $965dad8c0b45c8c6$export$d779b02e6b68c3e8, (v) => $965dad8c0b45c8c6$export$d779b02e6b68c3e8 = v);
var $965dad8c0b45c8c6$export$d779b02e6b68c3e8;
"use strict";

var $620jj = parcelRequire("620jj");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $965dad8c0b45c8c6$var$audit(durationSelector) {
    return $620jj.audit(durationSelector)(this);
}
$965dad8c0b45c8c6$export$d779b02e6b68c3e8 = $965dad8c0b45c8c6$var$audit;

});
parcelRegister("620jj", function(module, exports) {
"use strict";
var $46432ba6a88c7b32$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $46432ba6a88c7b32$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $46432ba6a88c7b32$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $46432ba6a88c7b32$var$audit;
var $46432ba6a88c7b32$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $46432ba6a88c7b32$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $46432ba6a88c7b32$var$AuditSubscriber = function(_super) {
    $46432ba6a88c7b32$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $fgwEQ.tryCatch(this.durationSelector)(value);
            if (duration === $5C5Tt.errorObject) this.destination.error($5C5Tt.errorObject.e);
            else {
                var innerSubscription = $8JM6B.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("jIjGL", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dsl6D = parcelRequire("dsl6D");
$jFk35.Observable.prototype.auditTime = $dsl6D.auditTime;

});
parcelRegister("dsl6D", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $9cbe4318f34f42fd$export$719c70722b10e5ff, (v) => $9cbe4318f34f42fd$export$719c70722b10e5ff = v);
var $9cbe4318f34f42fd$export$719c70722b10e5ff;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $kBaGQ = parcelRequire("kBaGQ");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $9cbe4318f34f42fd$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $kBaGQ.auditTime(duration, scheduler)(this);
}
$9cbe4318f34f42fd$export$719c70722b10e5ff = $9cbe4318f34f42fd$var$auditTime;

});
parcelRegister("kBaGQ", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $efef8e2dfa27e780$export$719c70722b10e5ff, (v) => $efef8e2dfa27e780$export$719c70722b10e5ff = v);
var $efef8e2dfa27e780$export$719c70722b10e5ff;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $620jj = parcelRequire("620jj");

var $eSP70 = parcelRequire("eSP70");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $efef8e2dfa27e780$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $620jj.audit(function() {
        return $eSP70.timer(duration, scheduler);
    });
}
$efef8e2dfa27e780$export$719c70722b10e5ff = $efef8e2dfa27e780$var$auditTime;

});



parcelRegister("lVObb", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $6SiRm = parcelRequire("6SiRm");
$jFk35.Observable.prototype.last = $6SiRm.last;

});
parcelRegister("6SiRm", function(module, exports) {
$parcel$export(module.exports, "last", () => $50166a62070887e3$export$4c7897fafd92b108, (v) => $50166a62070887e3$export$4c7897fafd92b108 = v);
var $50166a62070887e3$export$4c7897fafd92b108;
"use strict";

var $aJXfP = parcelRequire("aJXfP");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $50166a62070887e3$var$last(predicate, resultSelector, defaultValue) {
    return $aJXfP.last(predicate, resultSelector, defaultValue)(this);
}
$50166a62070887e3$export$4c7897fafd92b108 = $50166a62070887e3$var$last;

});
parcelRegister("aJXfP", function(module, exports) {
"use strict";
var $7d1c12039c4a97a8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $gJkED = parcelRequire("gJkED");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $7d1c12039c4a97a8$var$last(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $7d1c12039c4a97a8$var$LastOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.last = $7d1c12039c4a97a8$var$last;
var $7d1c12039c4a97a8$var$LastOperator = function() {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $7d1c12039c4a97a8$var$LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7d1c12039c4a97a8$var$LastSubscriber = function(_super) {
    $7d1c12039c4a97a8$var$__extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        } else destination.error(new $gJkED.EmptyError);
    };
    return LastSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("1Sbja", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $lThch = parcelRequire("lThch");
$jFk35.Observable.prototype.let = $lThch.letProto;
$jFk35.Observable.prototype.letBind = $lThch.letProto;

});
parcelRegister("lThch", function(module, exports) {
$parcel$export(module.exports, "letProto", () => $fefc13045eb4b437$export$50696b801ff96e66, (v) => $fefc13045eb4b437$export$50696b801ff96e66 = v);
var $fefc13045eb4b437$export$50696b801ff96e66;
"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */ function $fefc13045eb4b437$var$letProto(func) {
    return func(this);
}
$fefc13045eb4b437$export$50696b801ff96e66 = $fefc13045eb4b437$var$letProto;

});


parcelRegister("eXhTM", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $etGAV = parcelRequire("etGAV");
$jFk35.Observable.prototype.every = $etGAV.every;

});
parcelRegister("etGAV", function(module, exports) {
$parcel$export(module.exports, "every", () => $a8a4d084748976b9$export$7ecc1a3b11b57dab, (v) => $a8a4d084748976b9$export$7ecc1a3b11b57dab = v);
var $a8a4d084748976b9$export$7ecc1a3b11b57dab;
"use strict";

var $kSIv6 = parcelRequire("kSIv6");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $a8a4d084748976b9$var$every(predicate, thisArg) {
    return $kSIv6.every(predicate, thisArg)(this);
}
$a8a4d084748976b9$export$7ecc1a3b11b57dab = $a8a4d084748976b9$var$every;

});
parcelRegister("kSIv6", function(module, exports) {
"use strict";
var $f33b5eb79e3e0fff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $f33b5eb79e3e0fff$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $f33b5eb79e3e0fff$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $f33b5eb79e3e0fff$var$every;
var $f33b5eb79e3e0fff$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $f33b5eb79e3e0fff$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f33b5eb79e3e0fff$var$EverySubscriber = function(_super) {
    $f33b5eb79e3e0fff$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("kePbj", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2RyB9 = parcelRequire("2RyB9");
$jFk35.Observable.prototype.map = $2RyB9.map;

});

parcelRegister("ics23", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $52t6W = parcelRequire("52t6W");
$jFk35.Observable.prototype.mapTo = $52t6W.mapTo;

});
parcelRegister("52t6W", function(module, exports) {
$parcel$export(module.exports, "mapTo", () => $3ab3b8805c73415f$export$e0eaf3a86c03b2ad, (v) => $3ab3b8805c73415f$export$e0eaf3a86c03b2ad = v);
var $3ab3b8805c73415f$export$e0eaf3a86c03b2ad;
"use strict";

var $hqSe7 = parcelRequire("hqSe7");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $3ab3b8805c73415f$var$mapTo(value) {
    return $hqSe7.mapTo(value)(this);
}
$3ab3b8805c73415f$export$e0eaf3a86c03b2ad = $3ab3b8805c73415f$var$mapTo;

});
parcelRegister("hqSe7", function(module, exports) {
"use strict";
var $cb0eedb24cfdfdf4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $cb0eedb24cfdfdf4$var$mapTo(value) {
    return function(source) {
        return source.lift(new $cb0eedb24cfdfdf4$var$MapToOperator(value));
    };
}
module.exports.mapTo = $cb0eedb24cfdfdf4$var$mapTo;
var $cb0eedb24cfdfdf4$var$MapToOperator = function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cb0eedb24cfdfdf4$var$MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cb0eedb24cfdfdf4$var$MapToSubscriber = function(_super) {
    $cb0eedb24cfdfdf4$var$__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("bjOkS", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $f3SCJ = parcelRequire("f3SCJ");
$jFk35.Observable.prototype.materialize = $f3SCJ.materialize;

});
parcelRegister("f3SCJ", function(module, exports) {
$parcel$export(module.exports, "materialize", () => $af7181f15486b479$export$76dbd6ffd832405d, (v) => $af7181f15486b479$export$76dbd6ffd832405d = v);
var $af7181f15486b479$export$76dbd6ffd832405d;
"use strict";

var $ckxgf = parcelRequire("ckxgf");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $af7181f15486b479$var$materialize() {
    return $ckxgf.materialize()(this);
}
$af7181f15486b479$export$76dbd6ffd832405d = $af7181f15486b479$var$materialize;

});
parcelRegister("ckxgf", function(module, exports) {
"use strict";
var $8fa12739e672f5c8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $jWUHN = parcelRequire("jWUHN");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $8fa12739e672f5c8$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $8fa12739e672f5c8$var$MaterializeOperator());
    };
}
module.exports.materialize = $8fa12739e672f5c8$var$materialize;
var $8fa12739e672f5c8$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8fa12739e672f5c8$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8fa12739e672f5c8$var$MaterializeSubscriber = function(_super) {
    $8fa12739e672f5c8$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($jWUHN.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($jWUHN.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($jWUHN.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("TPqCa", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ga2GR = parcelRequire("ga2GR");
$jFk35.Observable.prototype.max = $ga2GR.max;

});
parcelRegister("ga2GR", function(module, exports) {
$parcel$export(module.exports, "max", () => $bc3faac630e6b1f5$export$8960430cfd85939f, (v) => $bc3faac630e6b1f5$export$8960430cfd85939f = v);
var $bc3faac630e6b1f5$export$8960430cfd85939f;
"use strict";

var $dfZRS = parcelRequire("dfZRS");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $bc3faac630e6b1f5$var$max(comparer) {
    return $dfZRS.max(comparer)(this);
}
$bc3faac630e6b1f5$export$8960430cfd85939f = $bc3faac630e6b1f5$var$max;

});
parcelRegister("dfZRS", function(module, exports) {
$parcel$export(module.exports, "max", () => $9a6caac23a03cadb$export$8960430cfd85939f, (v) => $9a6caac23a03cadb$export$8960430cfd85939f = v);
var $9a6caac23a03cadb$export$8960430cfd85939f;
"use strict";

var $bXSND = parcelRequire("bXSND");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $9a6caac23a03cadb$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $bXSND.reduce(max);
}
$9a6caac23a03cadb$export$8960430cfd85939f = $9a6caac23a03cadb$var$max;

});
parcelRegister("bXSND", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $8b5fb671e581808b$export$533b26079ad0b4b, (v) => $8b5fb671e581808b$export$533b26079ad0b4b = v);
var $8b5fb671e581808b$export$533b26079ad0b4b;
"use strict";

var $eAuN3 = parcelRequire("eAuN3");

var $kkovN = parcelRequire("kkovN");

var $k5Foi = parcelRequire("k5Foi");

var $favZu = parcelRequire("favZu");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $8b5fb671e581808b$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $favZu.pipe($eAuN3.scan(accumulator, seed), $kkovN.takeLast(1), $k5Foi.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $favZu.pipe($eAuN3.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $kkovN.takeLast(1))(source);
    };
}
$8b5fb671e581808b$export$533b26079ad0b4b = $8b5fb671e581808b$var$reduce;

});
parcelRegister("eAuN3", function(module, exports) {
"use strict";
var $a9ec4fc24eadfd8a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $a9ec4fc24eadfd8a$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $a9ec4fc24eadfd8a$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $a9ec4fc24eadfd8a$var$scan;
var $a9ec4fc24eadfd8a$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a9ec4fc24eadfd8a$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a9ec4fc24eadfd8a$var$ScanSubscriber = function(_super) {
    $a9ec4fc24eadfd8a$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($fwCeA.Subscriber);

});

parcelRegister("kkovN", function(module, exports) {
"use strict";
var $ecc8b075e97270e2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $cdlG8 = parcelRequire("cdlG8");

var $b9w09 = parcelRequire("b9w09");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $ecc8b075e97270e2$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b9w09.EmptyObservable();
        else return source.lift(new $ecc8b075e97270e2$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $ecc8b075e97270e2$var$takeLast;
var $ecc8b075e97270e2$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $cdlG8.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ecc8b075e97270e2$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ecc8b075e97270e2$var$TakeLastSubscriber = function(_super) {
    $ecc8b075e97270e2$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($fwCeA.Subscriber);

});





parcelRegister("j8OxM", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $eDMxD = parcelRequire("eDMxD");
$jFk35.Observable.prototype.merge = $eDMxD.merge;

});
parcelRegister("eDMxD", function(module, exports) {
$parcel$export(module.exports, "merge", () => $aa8a5c8751cbad6f$export$4950aa0f605343fb, (v) => $aa8a5c8751cbad6f$export$4950aa0f605343fb = v);
var $aa8a5c8751cbad6f$export$9f199afc30ae2269;
var $aa8a5c8751cbad6f$export$4950aa0f605343fb;
"use strict";

var $3TWuV = parcelRequire("3TWuV");

var $7HS6F = parcelRequire("7HS6F");
$aa8a5c8751cbad6f$export$9f199afc30ae2269 = $7HS6F.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $aa8a5c8751cbad6f$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $3TWuV.merge.apply(void 0, observables)(this);
}
$aa8a5c8751cbad6f$export$4950aa0f605343fb = $aa8a5c8751cbad6f$var$merge;

});
parcelRegister("3TWuV", function(module, exports) {
$parcel$export(module.exports, "merge", () => $2d73e29e91cb9733$export$4950aa0f605343fb, (v) => $2d73e29e91cb9733$export$4950aa0f605343fb = v);
var $2d73e29e91cb9733$export$9f199afc30ae2269;
var $2d73e29e91cb9733$export$4950aa0f605343fb;
"use strict";

var $7HS6F = parcelRequire("7HS6F");

var $7HS6F = parcelRequire("7HS6F");
$2d73e29e91cb9733$export$9f199afc30ae2269 = $7HS6F.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $2d73e29e91cb9733$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($7HS6F.merge.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$2d73e29e91cb9733$export$4950aa0f605343fb = $2d73e29e91cb9733$var$merge;

});



parcelRegister("c0NVC", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $kLki9 = parcelRequire("kLki9");
$jFk35.Observable.prototype.mergeAll = $kLki9.mergeAll;

});
parcelRegister("kLki9", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f1d7efee7ed93daa$export$18aef43295bbe906, (v) => $f1d7efee7ed93daa$export$18aef43295bbe906 = v);
var $f1d7efee7ed93daa$export$18aef43295bbe906;
"use strict";

var $x9PRW = parcelRequire("x9PRW");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f1d7efee7ed93daa$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $x9PRW.mergeAll(concurrent)(this);
}
$f1d7efee7ed93daa$export$18aef43295bbe906 = $f1d7efee7ed93daa$var$mergeAll;

});


parcelRegister("jBFa6", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $as2ti = parcelRequire("as2ti");
$jFk35.Observable.prototype.mergeMap = $as2ti.mergeMap;
$jFk35.Observable.prototype.flatMap = $as2ti.mergeMap;

});
parcelRegister("as2ti", function(module, exports) {
$parcel$export(module.exports, "mergeMap", () => $79be6fae59287cfa$export$6b9f6c0d32c093f9, (v) => $79be6fae59287cfa$export$6b9f6c0d32c093f9 = v);
var $79be6fae59287cfa$export$6b9f6c0d32c093f9;
"use strict";

var $3kOhX = parcelRequire("3kOhX");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $79be6fae59287cfa$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $3kOhX.mergeMap(project, resultSelector, concurrent)(this);
}
$79be6fae59287cfa$export$6b9f6c0d32c093f9 = $79be6fae59287cfa$var$mergeMap;

});


parcelRegister("9x6OC", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $1hRhE = parcelRequire("1hRhE");
$jFk35.Observable.prototype.flatMapTo = $1hRhE.mergeMapTo;
$jFk35.Observable.prototype.mergeMapTo = $1hRhE.mergeMapTo;

});
parcelRegister("1hRhE", function(module, exports) {
$parcel$export(module.exports, "mergeMapTo", () => $0f00b5fd38b34e8e$export$bd7cfc9a42b8a412, (v) => $0f00b5fd38b34e8e$export$bd7cfc9a42b8a412 = v);
var $0f00b5fd38b34e8e$export$bd7cfc9a42b8a412;
"use strict";

var $iVznV = parcelRequire("iVznV");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $0f00b5fd38b34e8e$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $iVznV.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
}
$0f00b5fd38b34e8e$export$bd7cfc9a42b8a412 = $0f00b5fd38b34e8e$var$mergeMapTo;

});
parcelRegister("iVznV", function(module, exports) {
"use strict";
var $dc78ff8d4209de3d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $dc78ff8d4209de3d$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $dc78ff8d4209de3d$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $dc78ff8d4209de3d$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $dc78ff8d4209de3d$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $dc78ff8d4209de3d$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $dc78ff8d4209de3d$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $dc78ff8d4209de3d$var$MergeMapToSubscriber = function(_super) {
    $dc78ff8d4209de3d$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($8JM6B.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.MergeMapToSubscriber = $dc78ff8d4209de3d$var$MergeMapToSubscriber;

});



parcelRegister("fKRAL", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $5DGQY = parcelRequire("5DGQY");
$jFk35.Observable.prototype.mergeScan = $5DGQY.mergeScan;

});
parcelRegister("5DGQY", function(module, exports) {
$parcel$export(module.exports, "mergeScan", () => $41b1d6106b42a4e9$export$c1fc905202bced53, (v) => $41b1d6106b42a4e9$export$c1fc905202bced53 = v);
var $41b1d6106b42a4e9$export$c1fc905202bced53;
"use strict";

var $88WL2 = parcelRequire("88WL2");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $41b1d6106b42a4e9$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $88WL2.mergeScan(accumulator, seed, concurrent)(this);
}
$41b1d6106b42a4e9$export$c1fc905202bced53 = $41b1d6106b42a4e9$var$mergeScan;

});
parcelRegister("88WL2", function(module, exports) {
"use strict";
var $5edca625d850514a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $8JM6B = parcelRequire("8JM6B");

var $cSU8n = parcelRequire("cSU8n");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $5edca625d850514a$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $5edca625d850514a$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $5edca625d850514a$var$mergeScan;
var $5edca625d850514a$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5edca625d850514a$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $5edca625d850514a$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5edca625d850514a$var$MergeScanSubscriber = function(_super) {
    $5edca625d850514a$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $fgwEQ.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $5C5Tt.errorObject) destination.error($5C5Tt.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($8JM6B.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($cSU8n.OuterSubscriber);
module.exports.MergeScanSubscriber = $5edca625d850514a$var$MergeScanSubscriber;

});



parcelRegister("2XWjp", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $6oXbV = parcelRequire("6oXbV");
$jFk35.Observable.prototype.min = $6oXbV.min;

});
parcelRegister("6oXbV", function(module, exports) {
$parcel$export(module.exports, "min", () => $4a92e61f573ce0e9$export$96ec731ed4dcb222, (v) => $4a92e61f573ce0e9$export$96ec731ed4dcb222 = v);
var $4a92e61f573ce0e9$export$96ec731ed4dcb222;
"use strict";

var $ccmvW = parcelRequire("ccmvW");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $4a92e61f573ce0e9$var$min(comparer) {
    return $ccmvW.min(comparer)(this);
}
$4a92e61f573ce0e9$export$96ec731ed4dcb222 = $4a92e61f573ce0e9$var$min;

});
parcelRegister("ccmvW", function(module, exports) {
$parcel$export(module.exports, "min", () => $8e1811db7acecb7a$export$96ec731ed4dcb222, (v) => $8e1811db7acecb7a$export$96ec731ed4dcb222 = v);
var $8e1811db7acecb7a$export$96ec731ed4dcb222;
"use strict";

var $bXSND = parcelRequire("bXSND");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $8e1811db7acecb7a$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $bXSND.reduce(min);
}
$8e1811db7acecb7a$export$96ec731ed4dcb222 = $8e1811db7acecb7a$var$min;

});



parcelRegister("e3q4o", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ljL3H = parcelRequire("ljL3H");
$jFk35.Observable.prototype.multicast = $ljL3H.multicast;

});
parcelRegister("ljL3H", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $f84fe02d37e51d2f$export$1364843af8d5a963, (v) => $f84fe02d37e51d2f$export$1364843af8d5a963 = v);
var $f84fe02d37e51d2f$export$1364843af8d5a963;
"use strict";

var $67LBu = parcelRequire("67LBu");
/* tslint:enable:max-line-length */ /**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */ function $f84fe02d37e51d2f$var$multicast(subjectOrSubjectFactory, selector) {
    return $67LBu.multicast(subjectOrSubjectFactory, selector)(this);
}
$f84fe02d37e51d2f$export$1364843af8d5a963 = $f84fe02d37e51d2f$var$multicast;

});
parcelRegister("67LBu", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $4758529cf8377063$export$1364843af8d5a963, (v) => $4758529cf8377063$export$1364843af8d5a963 = v);
var $4758529cf8377063$export$1364843af8d5a963;
var $4758529cf8377063$export$150d52413393bf2c;
"use strict";

var $hZeRx = parcelRequire("hZeRx");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $4758529cf8377063$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $4758529cf8377063$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $hZeRx.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$4758529cf8377063$export$1364843af8d5a963 = $4758529cf8377063$var$multicast;
var $4758529cf8377063$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$4758529cf8377063$export$150d52413393bf2c = $4758529cf8377063$var$MulticastOperator;

});
parcelRegister("hZeRx", function(module, exports) {
"use strict";
var $d183a99221f42e38$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $jFk35 = parcelRequire("jFk35");

var $fwCeA = parcelRequire("fwCeA");

var $8IeZR = parcelRequire("8IeZR");

var $65yBJ = parcelRequire("65yBJ");
/**
 * @class ConnectableObservable<T>
 */ var $d183a99221f42e38$var$ConnectableObservable = function(_super) {
    $d183a99221f42e38$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $8IeZR.Subscription();
            connection.add(this.source.subscribe(new $d183a99221f42e38$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $8IeZR.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $65yBJ.refCount()(this);
    };
    return ConnectableObservable;
}($jFk35.Observable);
module.exports.ConnectableObservable = $d183a99221f42e38$var$ConnectableObservable;
var $d183a99221f42e38$var$connectableProto = $d183a99221f42e38$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $d183a99221f42e38$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $d183a99221f42e38$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $d183a99221f42e38$var$connectableProto.getSubject
    },
    connect: {
        value: $d183a99221f42e38$var$connectableProto.connect
    },
    refCount: {
        value: $d183a99221f42e38$var$connectableProto.refCount
    }
};
var $d183a99221f42e38$var$ConnectableSubscriber = function(_super) {
    $d183a99221f42e38$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($aSveF.SubjectSubscriber);
var $d183a99221f42e38$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $d183a99221f42e38$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $d183a99221f42e38$var$RefCountSubscriber = function(_super) {
    $d183a99221f42e38$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($fwCeA.Subscriber);

});
parcelRegister("65yBJ", function(module, exports) {
"use strict";
var $46ee0e06d9453f06$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
function $46ee0e06d9453f06$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $46ee0e06d9453f06$var$RefCountOperator(source));
    };
}
module.exports.refCount = $46ee0e06d9453f06$var$refCount;
var $46ee0e06d9453f06$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $46ee0e06d9453f06$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $46ee0e06d9453f06$var$RefCountSubscriber = function(_super) {
    $46ee0e06d9453f06$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($fwCeA.Subscriber);

});





parcelRegister("7QAMm", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $6HHsZ = parcelRequire("6HHsZ");
$jFk35.Observable.prototype.observeOn = $6HHsZ.observeOn;

});
parcelRegister("6HHsZ", function(module, exports) {
$parcel$export(module.exports, "observeOn", () => $4e1879c69d66794d$export$9007f49c319d1ac7, (v) => $4e1879c69d66794d$export$9007f49c319d1ac7 = v);
var $4e1879c69d66794d$export$9007f49c319d1ac7;
"use strict";

var $aLrOR = parcelRequire("aLrOR");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $4e1879c69d66794d$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $aLrOR.observeOn(scheduler, delay)(this);
}
$4e1879c69d66794d$export$9007f49c319d1ac7 = $4e1879c69d66794d$var$observeOn;

});


parcelRegister("gH503", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $c3p2E = parcelRequire("c3p2E");
$jFk35.Observable.prototype.onErrorResumeNext = $c3p2E.onErrorResumeNext;

});
parcelRegister("c3p2E", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $8c693098fbe43ba4$export$5fba66d61591f42, (v) => $8c693098fbe43ba4$export$5fba66d61591f42 = v);
var $8c693098fbe43ba4$export$5fba66d61591f42;
"use strict";

var $cimxX = parcelRequire("cimxX");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $8c693098fbe43ba4$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    return $cimxX.onErrorResumeNext.apply(void 0, nextSources)(this);
}
$8c693098fbe43ba4$export$5fba66d61591f42 = $8c693098fbe43ba4$var$onErrorResumeNext;

});


parcelRegister("6x9hZ", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $5G68g = parcelRequire("5G68g");
$jFk35.Observable.prototype.pairwise = $5G68g.pairwise;

});
parcelRegister("5G68g", function(module, exports) {
$parcel$export(module.exports, "pairwise", () => $4225a1c0865c9a56$export$8f9d79d42bff1aac, (v) => $4225a1c0865c9a56$export$8f9d79d42bff1aac = v);
var $4225a1c0865c9a56$export$8f9d79d42bff1aac;
"use strict";

var $hTZ3K = parcelRequire("hTZ3K");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $4225a1c0865c9a56$var$pairwise() {
    return $hTZ3K.pairwise()(this);
}
$4225a1c0865c9a56$export$8f9d79d42bff1aac = $4225a1c0865c9a56$var$pairwise;

});
parcelRegister("hTZ3K", function(module, exports) {
"use strict";
var $d086efd7eaa108e2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $d086efd7eaa108e2$var$pairwise() {
    return function(source) {
        return source.lift(new $d086efd7eaa108e2$var$PairwiseOperator());
    };
}
module.exports.pairwise = $d086efd7eaa108e2$var$pairwise;
var $d086efd7eaa108e2$var$PairwiseOperator = function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d086efd7eaa108e2$var$PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d086efd7eaa108e2$var$PairwiseSubscriber = function(_super) {
    $d086efd7eaa108e2$var$__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        if (this.hasPrev) this.destination.next([
            this.prev,
            value
        ]);
        else this.hasPrev = true;
        this.prev = value;
    };
    return PairwiseSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("60Zwo", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cvSLD = parcelRequire("cvSLD");
$jFk35.Observable.prototype.partition = $cvSLD.partition;

});
parcelRegister("cvSLD", function(module, exports) {
$parcel$export(module.exports, "partition", () => $91c2dcf0fe2cd2f5$export$b29f828819edca8d, (v) => $91c2dcf0fe2cd2f5$export$b29f828819edca8d = v);
var $91c2dcf0fe2cd2f5$export$b29f828819edca8d;
"use strict";

var $3uzZC = parcelRequire("3uzZC");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $91c2dcf0fe2cd2f5$var$partition(predicate, thisArg) {
    return $3uzZC.partition(predicate, thisArg)(this);
}
$91c2dcf0fe2cd2f5$export$b29f828819edca8d = $91c2dcf0fe2cd2f5$var$partition;

});
parcelRegister("3uzZC", function(module, exports) {
$parcel$export(module.exports, "partition", () => $28b017e34b05cbe9$export$b29f828819edca8d, (v) => $28b017e34b05cbe9$export$b29f828819edca8d = v);
var $28b017e34b05cbe9$export$b29f828819edca8d;
"use strict";

var $ed3mb = parcelRequire("ed3mb");

var $2alSH = parcelRequire("2alSH");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $28b017e34b05cbe9$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $2alSH.filter(predicate, thisArg)(source),
            $2alSH.filter($ed3mb.not(predicate, thisArg))(source)
        ];
    };
}
$28b017e34b05cbe9$export$b29f828819edca8d = $28b017e34b05cbe9$var$partition;

});
parcelRegister("ed3mb", function(module, exports) {
$parcel$export(module.exports, "not", () => $a584e229da378c69$export$6003a5f097c73977, (v) => $a584e229da378c69$export$6003a5f097c73977 = v);
var $a584e229da378c69$export$6003a5f097c73977;
"use strict";
function $a584e229da378c69$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$a584e229da378c69$export$6003a5f097c73977 = $a584e229da378c69$var$not;

});




parcelRegister("8jBPO", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $aC6Mb = parcelRequire("aC6Mb");
$jFk35.Observable.prototype.pluck = $aC6Mb.pluck;

});
parcelRegister("aC6Mb", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $7ba2b59d89e88328$export$c44985b87d605eff, (v) => $7ba2b59d89e88328$export$c44985b87d605eff = v);
var $7ba2b59d89e88328$export$c44985b87d605eff;
"use strict";

var $5tLxm = parcelRequire("5tLxm");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $7ba2b59d89e88328$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    return $5tLxm.pluck.apply(void 0, properties)(this);
}
$7ba2b59d89e88328$export$c44985b87d605eff = $7ba2b59d89e88328$var$pluck;

});
parcelRegister("5tLxm", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $3fd4890cc3083c4e$export$c44985b87d605eff, (v) => $3fd4890cc3083c4e$export$c44985b87d605eff = v);
var $3fd4890cc3083c4e$export$c44985b87d605eff;
"use strict";

var $4KOmc = parcelRequire("4KOmc");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $3fd4890cc3083c4e$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return function(source) {
        return $4KOmc.map($3fd4890cc3083c4e$var$plucker(properties, length))(source);
    };
}
$3fd4890cc3083c4e$export$c44985b87d605eff = $3fd4890cc3083c4e$var$pluck;
function $3fd4890cc3083c4e$var$plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

});



parcelRegister("3XfDZ", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $fuwBQ = parcelRequire("fuwBQ");
$jFk35.Observable.prototype.publish = $fuwBQ.publish;

});
parcelRegister("fuwBQ", function(module, exports) {
$parcel$export(module.exports, "publish", () => $b472f3e17038fb1c$export$89b472e03be495df, (v) => $b472f3e17038fb1c$export$89b472e03be495df = v);
var $b472f3e17038fb1c$export$89b472e03be495df;
"use strict";

var $1Xyx2 = parcelRequire("1Xyx2");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $b472f3e17038fb1c$var$publish(selector) {
    return $1Xyx2.publish(selector)(this);
}
$b472f3e17038fb1c$export$89b472e03be495df = $b472f3e17038fb1c$var$publish;

});
parcelRegister("1Xyx2", function(module, exports) {
$parcel$export(module.exports, "publish", () => $16d6167414c983fc$export$89b472e03be495df, (v) => $16d6167414c983fc$export$89b472e03be495df = v);
var $16d6167414c983fc$export$89b472e03be495df;
"use strict";

var $aSveF = parcelRequire("aSveF");

var $67LBu = parcelRequire("67LBu");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $16d6167414c983fc$var$publish(selector) {
    return selector ? $67LBu.multicast(function() {
        return new $aSveF.Subject();
    }, selector) : $67LBu.multicast(new $aSveF.Subject());
}
$16d6167414c983fc$export$89b472e03be495df = $16d6167414c983fc$var$publish;

});



parcelRegister("hLgpe", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2F4Qr = parcelRequire("2F4Qr");
$jFk35.Observable.prototype.publishBehavior = $2F4Qr.publishBehavior;

});
parcelRegister("2F4Qr", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $1f032b2ba4c4e231$export$16ae46fda9567053, (v) => $1f032b2ba4c4e231$export$16ae46fda9567053 = v);
var $1f032b2ba4c4e231$export$16ae46fda9567053;
"use strict";

var $9svvu = parcelRequire("9svvu");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $1f032b2ba4c4e231$var$publishBehavior(value) {
    return $9svvu.publishBehavior(value)(this);
}
$1f032b2ba4c4e231$export$16ae46fda9567053 = $1f032b2ba4c4e231$var$publishBehavior;

});
parcelRegister("9svvu", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $6e2f2b359b0406b8$export$16ae46fda9567053, (v) => $6e2f2b359b0406b8$export$16ae46fda9567053 = v);
var $6e2f2b359b0406b8$export$16ae46fda9567053;
"use strict";

var $4laNn = parcelRequire("4laNn");

var $67LBu = parcelRequire("67LBu");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $6e2f2b359b0406b8$var$publishBehavior(value) {
    return function(source) {
        return $67LBu.multicast(new $4laNn.BehaviorSubject(value))(source);
    };
}
$6e2f2b359b0406b8$export$16ae46fda9567053 = $6e2f2b359b0406b8$var$publishBehavior;

});
parcelRegister("4laNn", function(module, exports) {
"use strict";
var $32917f5814cdee8b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $imzSm = parcelRequire("imzSm");
/**
 * @class BehaviorSubject<T>
 */ var $32917f5814cdee8b$var$BehaviorSubject = function(_super) {
    $32917f5814cdee8b$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $imzSm.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($aSveF.Subject);
module.exports.BehaviorSubject = $32917f5814cdee8b$var$BehaviorSubject;

});




parcelRegister("3si8N", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $k2TN3 = parcelRequire("k2TN3");
$jFk35.Observable.prototype.publishReplay = $k2TN3.publishReplay;

});
parcelRegister("k2TN3", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $e97f45551d79a145$export$1f3342bf81d92d52, (v) => $e97f45551d79a145$export$1f3342bf81d92d52 = v);
var $e97f45551d79a145$export$1f3342bf81d92d52;
"use strict";

var $3Y92z = parcelRequire("3Y92z");
/* tslint:enable:max-line-length */ /**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */ function $e97f45551d79a145$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return $3Y92z.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
$e97f45551d79a145$export$1f3342bf81d92d52 = $e97f45551d79a145$var$publishReplay;

});
parcelRegister("3Y92z", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $2e3dfcedb73dd8cb$export$1f3342bf81d92d52, (v) => $2e3dfcedb73dd8cb$export$1f3342bf81d92d52 = v);
var $2e3dfcedb73dd8cb$export$1f3342bf81d92d52;
"use strict";

var $dktU4 = parcelRequire("dktU4");

var $67LBu = parcelRequire("67LBu");
/* tslint:enable:max-line-length */ function $2e3dfcedb73dd8cb$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $dktU4.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $67LBu.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$2e3dfcedb73dd8cb$export$1f3342bf81d92d52 = $2e3dfcedb73dd8cb$var$publishReplay;

});



parcelRegister("7DgsF", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ecFA6 = parcelRequire("ecFA6");
$jFk35.Observable.prototype.publishLast = $ecFA6.publishLast;

});
parcelRegister("ecFA6", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $a57270dca9acf581$export$42d9b6b38c68d989, (v) => $a57270dca9acf581$export$42d9b6b38c68d989 = v);
var $a57270dca9acf581$export$42d9b6b38c68d989;
"use strict";

var $ko7NX = parcelRequire("ko7NX");
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */ function $a57270dca9acf581$var$publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return $ko7NX.publishLast()(this);
}
$a57270dca9acf581$export$42d9b6b38c68d989 = $a57270dca9acf581$var$publishLast;

});
parcelRegister("ko7NX", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $ed7c1a65048225c5$export$42d9b6b38c68d989, (v) => $ed7c1a65048225c5$export$42d9b6b38c68d989 = v);
var $ed7c1a65048225c5$export$42d9b6b38c68d989;
"use strict";

var $hGBKd = parcelRequire("hGBKd");

var $67LBu = parcelRequire("67LBu");
function $ed7c1a65048225c5$var$publishLast() {
    return function(source) {
        return $67LBu.multicast(new $hGBKd.AsyncSubject())(source);
    };
}
$ed7c1a65048225c5$export$42d9b6b38c68d989 = $ed7c1a65048225c5$var$publishLast;

});



parcelRegister("48FsU", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $frq7F = parcelRequire("frq7F");
$jFk35.Observable.prototype.race = $frq7F.race;

});
parcelRegister("frq7F", function(module, exports) {
$parcel$export(module.exports, "race", () => $b3dda40a4d015c8c$export$236c05de452bec2, (v) => $b3dda40a4d015c8c$export$236c05de452bec2 = v);
var $b3dda40a4d015c8c$export$dc3f181b77d95dcc;
var $b3dda40a4d015c8c$export$236c05de452bec2;
"use strict";

var $cvJcz = parcelRequire("cvJcz");

var $bzCla = parcelRequire("bzCla");
$b3dda40a4d015c8c$export$dc3f181b77d95dcc = $bzCla.race;
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $b3dda40a4d015c8c$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $cvJcz.race.apply(void 0, observables)(this);
}
$b3dda40a4d015c8c$export$236c05de452bec2 = $b3dda40a4d015c8c$var$race;

});
parcelRegister("cvJcz", function(module, exports) {
$parcel$export(module.exports, "race", () => $91bb7164a636ad8d$export$236c05de452bec2, (v) => $91bb7164a636ad8d$export$236c05de452bec2 = v);
var $91bb7164a636ad8d$export$236c05de452bec2;
"use strict";

var $bHRhK = parcelRequire("bHRhK");

var $bzCla = parcelRequire("bzCla");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $91bb7164a636ad8d$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $bHRhK.isArray(observables[0])) observables = observables[0];
        return source.lift.call($bzCla.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$91bb7164a636ad8d$export$236c05de452bec2 = $91bb7164a636ad8d$var$race;

});



parcelRegister("3swvU", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $hOfcd = parcelRequire("hOfcd");
$jFk35.Observable.prototype.reduce = $hOfcd.reduce;

});
parcelRegister("hOfcd", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $cf72e4cd6dc2736d$export$533b26079ad0b4b, (v) => $cf72e4cd6dc2736d$export$533b26079ad0b4b = v);
var $cf72e4cd6dc2736d$export$533b26079ad0b4b;
"use strict";

var $bXSND = parcelRequire("bXSND");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $cf72e4cd6dc2736d$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return $bXSND.reduce(accumulator, seed)(this);
    return $bXSND.reduce(accumulator)(this);
}
$cf72e4cd6dc2736d$export$533b26079ad0b4b = $cf72e4cd6dc2736d$var$reduce;

});


parcelRegister("8UaTV", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dfho1 = parcelRequire("dfho1");
$jFk35.Observable.prototype.repeat = $dfho1.repeat;

});
parcelRegister("dfho1", function(module, exports) {
$parcel$export(module.exports, "repeat", () => $9a4a29ae222872cb$export$76d90c956114f2c2, (v) => $9a4a29ae222872cb$export$76d90c956114f2c2 = v);
var $9a4a29ae222872cb$export$76d90c956114f2c2;
"use strict";

var $i7MDh = parcelRequire("i7MDh");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $9a4a29ae222872cb$var$repeat(count) {
    if (count === void 0) count = -1;
    return $i7MDh.repeat(count)(this);
}
$9a4a29ae222872cb$export$76d90c956114f2c2 = $9a4a29ae222872cb$var$repeat;

});
parcelRegister("i7MDh", function(module, exports) {
"use strict";
var $d31e9ad99613de0b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $b9w09 = parcelRequire("b9w09");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $d31e9ad99613de0b$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $b9w09.EmptyObservable();
        else if (count < 0) return source.lift(new $d31e9ad99613de0b$var$RepeatOperator(-1, source));
        else return source.lift(new $d31e9ad99613de0b$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $d31e9ad99613de0b$var$repeat;
var $d31e9ad99613de0b$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d31e9ad99613de0b$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d31e9ad99613de0b$var$RepeatSubscriber = function(_super) {
    $d31e9ad99613de0b$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("i3QyP", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2Lvsb = parcelRequire("2Lvsb");
$jFk35.Observable.prototype.repeatWhen = $2Lvsb.repeatWhen;

});
parcelRegister("2Lvsb", function(module, exports) {
$parcel$export(module.exports, "repeatWhen", () => $20385e9816ce4fd2$export$b39ac5b4ffd1415a, (v) => $20385e9816ce4fd2$export$b39ac5b4ffd1415a = v);
var $20385e9816ce4fd2$export$b39ac5b4ffd1415a;
"use strict";

var $fGAAo = parcelRequire("fGAAo");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $20385e9816ce4fd2$var$repeatWhen(notifier) {
    return $fGAAo.repeatWhen(notifier)(this);
}
$20385e9816ce4fd2$export$b39ac5b4ffd1415a = $20385e9816ce4fd2$var$repeatWhen;

});
parcelRegister("fGAAo", function(module, exports) {
"use strict";
var $b6b7287ad3409b9b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $b6b7287ad3409b9b$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $b6b7287ad3409b9b$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $b6b7287ad3409b9b$var$repeatWhen;
var $b6b7287ad3409b9b$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b6b7287ad3409b9b$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b6b7287ad3409b9b$var$RepeatWhenSubscriber = function(_super) {
    $b6b7287ad3409b9b$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $aSveF.Subject();
        var retries = $fgwEQ.tryCatch(this.notifier)(this.notifications);
        if (retries === $5C5Tt.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $8JM6B.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("b3SaU", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $h2kMc = parcelRequire("h2kMc");
$jFk35.Observable.prototype.retry = $h2kMc.retry;

});
parcelRegister("h2kMc", function(module, exports) {
$parcel$export(module.exports, "retry", () => $c672bd544fcaee4c$export$9369b12211e1fce4, (v) => $c672bd544fcaee4c$export$9369b12211e1fce4 = v);
var $c672bd544fcaee4c$export$9369b12211e1fce4;
"use strict";

var $6A4Er = parcelRequire("6A4Er");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $c672bd544fcaee4c$var$retry(count) {
    if (count === void 0) count = -1;
    return $6A4Er.retry(count)(this);
}
$c672bd544fcaee4c$export$9369b12211e1fce4 = $c672bd544fcaee4c$var$retry;

});
parcelRegister("6A4Er", function(module, exports) {
"use strict";
var $4ca9b683a117dec6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $4ca9b683a117dec6$var$retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $4ca9b683a117dec6$var$RetryOperator(count, source));
    };
}
module.exports.retry = $4ca9b683a117dec6$var$retry;
var $4ca9b683a117dec6$var$RetryOperator = function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4ca9b683a117dec6$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4ca9b683a117dec6$var$RetrySubscriber = function(_super) {
    $4ca9b683a117dec6$var$__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("lhPdR", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $iTumU = parcelRequire("iTumU");
$jFk35.Observable.prototype.retryWhen = $iTumU.retryWhen;

});
parcelRegister("iTumU", function(module, exports) {
$parcel$export(module.exports, "retryWhen", () => $dc14eb9b0a679cea$export$1281551253cfee02, (v) => $dc14eb9b0a679cea$export$1281551253cfee02 = v);
var $dc14eb9b0a679cea$export$1281551253cfee02;
"use strict";

var $cMKhe = parcelRequire("cMKhe");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $dc14eb9b0a679cea$var$retryWhen(notifier) {
    return $cMKhe.retryWhen(notifier)(this);
}
$dc14eb9b0a679cea$export$1281551253cfee02 = $dc14eb9b0a679cea$var$retryWhen;

});
parcelRegister("cMKhe", function(module, exports) {
"use strict";
var $94eddd58b1cc3937$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $94eddd58b1cc3937$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $94eddd58b1cc3937$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $94eddd58b1cc3937$var$retryWhen;
var $94eddd58b1cc3937$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $94eddd58b1cc3937$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $94eddd58b1cc3937$var$RetryWhenSubscriber = function(_super) {
    $94eddd58b1cc3937$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $aSveF.Subject();
                retries = $fgwEQ.tryCatch(this.notifier)(errors);
                if (retries === $5C5Tt.errorObject) return _super.prototype.error.call(this, $5C5Tt.errorObject.e);
                retriesSubscription = $8JM6B.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("AVDGD", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $03KuW = parcelRequire("03KuW");
$jFk35.Observable.prototype.sample = $03KuW.sample;

});
parcelRegister("03KuW", function(module, exports) {
$parcel$export(module.exports, "sample", () => $00b4597dbaa5c8a1$export$4812e460280c6ef2, (v) => $00b4597dbaa5c8a1$export$4812e460280c6ef2 = v);
var $00b4597dbaa5c8a1$export$4812e460280c6ef2;
"use strict";

var $lmAP3 = parcelRequire("lmAP3");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $00b4597dbaa5c8a1$var$sample(notifier) {
    return $lmAP3.sample(notifier)(this);
}
$00b4597dbaa5c8a1$export$4812e460280c6ef2 = $00b4597dbaa5c8a1$var$sample;

});
parcelRegister("lmAP3", function(module, exports) {
"use strict";
var $f8d83736291ebf15$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $f8d83736291ebf15$var$sample(notifier) {
    return function(source) {
        return source.lift(new $f8d83736291ebf15$var$SampleOperator(notifier));
    };
}
module.exports.sample = $f8d83736291ebf15$var$sample;
var $f8d83736291ebf15$var$SampleOperator = function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new $f8d83736291ebf15$var$SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add($8JM6B.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f8d83736291ebf15$var$SampleSubscriber = function(_super) {
    $f8d83736291ebf15$var$__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("chRa5", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cOd5X = parcelRequire("cOd5X");
$jFk35.Observable.prototype.sampleTime = $cOd5X.sampleTime;

});
parcelRegister("cOd5X", function(module, exports) {
$parcel$export(module.exports, "sampleTime", () => $95344ff7fb65c79c$export$fe33c7b2002d97b0, (v) => $95344ff7fb65c79c$export$fe33c7b2002d97b0 = v);
var $95344ff7fb65c79c$export$fe33c7b2002d97b0;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $frUcu = parcelRequire("frUcu");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $95344ff7fb65c79c$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $frUcu.sampleTime(period, scheduler)(this);
}
$95344ff7fb65c79c$export$fe33c7b2002d97b0 = $95344ff7fb65c79c$var$sampleTime;

});
parcelRegister("frUcu", function(module, exports) {
"use strict";
var $b3f4f8e322317738$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $1KBsc = parcelRequire("1KBsc");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $b3f4f8e322317738$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return function(source) {
        return source.lift(new $b3f4f8e322317738$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $b3f4f8e322317738$var$sampleTime;
var $b3f4f8e322317738$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b3f4f8e322317738$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b3f4f8e322317738$var$SampleTimeSubscriber = function(_super) {
    $b3f4f8e322317738$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($b3f4f8e322317738$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($fwCeA.Subscriber);
function $b3f4f8e322317738$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});



parcelRegister("hBiCY", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dXGzZ = parcelRequire("dXGzZ");
$jFk35.Observable.prototype.scan = $dXGzZ.scan;

});
parcelRegister("dXGzZ", function(module, exports) {
$parcel$export(module.exports, "scan", () => $a2a1d073d75c269a$export$c87d910e63d22ed6, (v) => $a2a1d073d75c269a$export$c87d910e63d22ed6 = v);
var $a2a1d073d75c269a$export$c87d910e63d22ed6;
"use strict";

var $eAuN3 = parcelRequire("eAuN3");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $a2a1d073d75c269a$var$scan(accumulator, seed) {
    if (arguments.length >= 2) return $eAuN3.scan(accumulator, seed)(this);
    return $eAuN3.scan(accumulator)(this);
}
$a2a1d073d75c269a$export$c87d910e63d22ed6 = $a2a1d073d75c269a$var$scan;

});


parcelRegister("i1x1P", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $ghDOi = parcelRequire("ghDOi");
$jFk35.Observable.prototype.sequenceEqual = $ghDOi.sequenceEqual;

});
parcelRegister("ghDOi", function(module, exports) {
$parcel$export(module.exports, "sequenceEqual", () => $bdad1d5e27a2721b$export$d0a07e60ae428313, (v) => $bdad1d5e27a2721b$export$d0a07e60ae428313 = v);
var $bdad1d5e27a2721b$export$d0a07e60ae428313;
"use strict";

var $3Qmjh = parcelRequire("3Qmjh");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $bdad1d5e27a2721b$var$sequenceEqual(compareTo, comparor) {
    return $3Qmjh.sequenceEqual(compareTo, comparor)(this);
}
$bdad1d5e27a2721b$export$d0a07e60ae428313 = $bdad1d5e27a2721b$var$sequenceEqual;

});
parcelRegister("3Qmjh", function(module, exports) {
"use strict";
var $2cc788b64036ea5f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $2cc788b64036ea5f$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $2cc788b64036ea5f$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $2cc788b64036ea5f$var$sequenceEqual;
var $2cc788b64036ea5f$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2cc788b64036ea5f$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $2cc788b64036ea5f$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2cc788b64036ea5f$var$SequenceEqualSubscriber = function(_super) {
    $2cc788b64036ea5f$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $2cc788b64036ea5f$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $fgwEQ.tryCatch(comparor)(a, b);
                if (areEqual === $5C5Tt.errorObject) this.destination.error($5C5Tt.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($fwCeA.Subscriber);
module.exports.SequenceEqualSubscriber = $2cc788b64036ea5f$var$SequenceEqualSubscriber;
var $2cc788b64036ea5f$var$SequenceEqualCompareToSubscriber = function(_super) {
    $2cc788b64036ea5f$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("d9EKX", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $jgiNg = parcelRequire("jgiNg");
$jFk35.Observable.prototype.share = $jgiNg.share;

});
parcelRegister("jgiNg", function(module, exports) {
$parcel$export(module.exports, "share", () => $e05e16f2d3c25a90$export$ed80d9de1d9df928, (v) => $e05e16f2d3c25a90$export$ed80d9de1d9df928 = v);
var $e05e16f2d3c25a90$export$ed80d9de1d9df928;
"use strict";

var $gwuHf = parcelRequire("gwuHf");
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $e05e16f2d3c25a90$var$share() {
    return $gwuHf.share()(this);
}
$e05e16f2d3c25a90$export$ed80d9de1d9df928 = $e05e16f2d3c25a90$var$share;

});
parcelRegister("gwuHf", function(module, exports) {
$parcel$export(module.exports, "share", () => $c07772313f9dc083$export$ed80d9de1d9df928, (v) => $c07772313f9dc083$export$ed80d9de1d9df928 = v);
var $c07772313f9dc083$export$ed80d9de1d9df928;
"use strict";

var $67LBu = parcelRequire("67LBu");

var $65yBJ = parcelRequire("65yBJ");

var $aSveF = parcelRequire("aSveF");
function $c07772313f9dc083$var$shareSubjectFactory() {
    return new $aSveF.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $c07772313f9dc083$var$share() {
    return function(source) {
        return $65yBJ.refCount()($67LBu.multicast($c07772313f9dc083$var$shareSubjectFactory)(source));
    };
}
$c07772313f9dc083$export$ed80d9de1d9df928 = $c07772313f9dc083$var$share;

});



parcelRegister("8IpJ4", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $lydsW = parcelRequire("lydsW");
$jFk35.Observable.prototype.shareReplay = $lydsW.shareReplay;

});
parcelRegister("lydsW", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $fb0737fd59f7f672$export$db61d692014e534e, (v) => $fb0737fd59f7f672$export$db61d692014e534e = v);
var $fb0737fd59f7f672$export$db61d692014e534e;
"use strict";

var $hoasZ = parcelRequire("hoasZ");
/**
 * @method shareReplay
 * @owner Observable
 */ function $fb0737fd59f7f672$var$shareReplay(bufferSize, windowTime, scheduler) {
    return $hoasZ.shareReplay(bufferSize, windowTime, scheduler)(this);
}
$fb0737fd59f7f672$export$db61d692014e534e = $fb0737fd59f7f672$var$shareReplay;

});
parcelRegister("hoasZ", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $ca8ccbfdf930324b$export$db61d692014e534e, (v) => $ca8ccbfdf930324b$export$db61d692014e534e = v);
var $ca8ccbfdf930324b$export$db61d692014e534e;
"use strict";

var $dktU4 = parcelRequire("dktU4");
/**
 * @method shareReplay
 * @owner Observable
 */ function $ca8ccbfdf930324b$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($ca8ccbfdf930324b$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$ca8ccbfdf930324b$export$db61d692014e534e = $ca8ccbfdf930324b$var$shareReplay;
function $ca8ccbfdf930324b$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $dktU4.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});



parcelRegister("8pGZd", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $kZkvx = parcelRequire("kZkvx");
$jFk35.Observable.prototype.single = $kZkvx.single;

});
parcelRegister("kZkvx", function(module, exports) {
$parcel$export(module.exports, "single", () => $f479698c086b78ee$export$863d7ca51b416cee, (v) => $f479698c086b78ee$export$863d7ca51b416cee = v);
var $f479698c086b78ee$export$863d7ca51b416cee;
"use strict";

var $3CO7U = parcelRequire("3CO7U");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $f479698c086b78ee$var$single(predicate) {
    return $3CO7U.single(predicate)(this);
}
$f479698c086b78ee$export$863d7ca51b416cee = $f479698c086b78ee$var$single;

});
parcelRegister("3CO7U", function(module, exports) {
"use strict";
var $2a3bcdd0a4a928ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $gJkED = parcelRequire("gJkED");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $2a3bcdd0a4a928ff$var$single(predicate) {
    return function(source) {
        return source.lift(new $2a3bcdd0a4a928ff$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $2a3bcdd0a4a928ff$var$single;
var $2a3bcdd0a4a928ff$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2a3bcdd0a4a928ff$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2a3bcdd0a4a928ff$var$SingleSubscriber = function(_super) {
    $2a3bcdd0a4a928ff$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $gJkED.EmptyError);
    };
    return SingleSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("8aBES", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $hzyrZ = parcelRequire("hzyrZ");
$jFk35.Observable.prototype.skip = $hzyrZ.skip;

});
parcelRegister("hzyrZ", function(module, exports) {
$parcel$export(module.exports, "skip", () => $ccb06db298aaece1$export$955fc4a6c4be454d, (v) => $ccb06db298aaece1$export$955fc4a6c4be454d = v);
var $ccb06db298aaece1$export$955fc4a6c4be454d;
"use strict";

var $4NY5O = parcelRequire("4NY5O");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $ccb06db298aaece1$var$skip(count) {
    return $4NY5O.skip(count)(this);
}
$ccb06db298aaece1$export$955fc4a6c4be454d = $ccb06db298aaece1$var$skip;

});
parcelRegister("4NY5O", function(module, exports) {
"use strict";
var $37fa5a2ebf0de1d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $37fa5a2ebf0de1d7$var$skip(count) {
    return function(source) {
        return source.lift(new $37fa5a2ebf0de1d7$var$SkipOperator(count));
    };
}
module.exports.skip = $37fa5a2ebf0de1d7$var$skip;
var $37fa5a2ebf0de1d7$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $37fa5a2ebf0de1d7$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $37fa5a2ebf0de1d7$var$SkipSubscriber = function(_super) {
    $37fa5a2ebf0de1d7$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("9vVNA", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $5d1Uy = parcelRequire("5d1Uy");
$jFk35.Observable.prototype.skipLast = $5d1Uy.skipLast;

});
parcelRegister("5d1Uy", function(module, exports) {
$parcel$export(module.exports, "skipLast", () => $3cafa6285eb6f0ff$export$635f6273df29ea1c, (v) => $3cafa6285eb6f0ff$export$635f6273df29ea1c = v);
var $3cafa6285eb6f0ff$export$635f6273df29ea1c;
"use strict";

var $eRCG8 = parcelRequire("eRCG8");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $3cafa6285eb6f0ff$var$skipLast(count) {
    return $eRCG8.skipLast(count)(this);
}
$3cafa6285eb6f0ff$export$635f6273df29ea1c = $3cafa6285eb6f0ff$var$skipLast;

});
parcelRegister("eRCG8", function(module, exports) {
"use strict";
var $ad2404ad2dfc06d1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $cdlG8 = parcelRequire("cdlG8");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $ad2404ad2dfc06d1$var$skipLast(count) {
    return function(source) {
        return source.lift(new $ad2404ad2dfc06d1$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $ad2404ad2dfc06d1$var$skipLast;
var $ad2404ad2dfc06d1$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $cdlG8.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $fwCeA.Subscriber(subscriber));
        else return source.subscribe(new $ad2404ad2dfc06d1$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ad2404ad2dfc06d1$var$SkipLastSubscriber = function(_super) {
    $ad2404ad2dfc06d1$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("6FRex", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $39fmr = parcelRequire("39fmr");
$jFk35.Observable.prototype.skipUntil = $39fmr.skipUntil;

});
parcelRegister("39fmr", function(module, exports) {
$parcel$export(module.exports, "skipUntil", () => $24ae20badb3c6cef$export$facc584867c26fde, (v) => $24ae20badb3c6cef$export$facc584867c26fde = v);
var $24ae20badb3c6cef$export$facc584867c26fde;
"use strict";

var $lOfMb = parcelRequire("lOfMb");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $24ae20badb3c6cef$var$skipUntil(notifier) {
    return $lOfMb.skipUntil(notifier)(this);
}
$24ae20badb3c6cef$export$facc584867c26fde = $24ae20badb3c6cef$var$skipUntil;

});
parcelRegister("lOfMb", function(module, exports) {
"use strict";
var $fe0a814dd09fc8ce$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $fe0a814dd09fc8ce$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $fe0a814dd09fc8ce$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $fe0a814dd09fc8ce$var$skipUntil;
var $fe0a814dd09fc8ce$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe0a814dd09fc8ce$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe0a814dd09fc8ce$var$SkipUntilSubscriber = function(_super) {
    $fe0a814dd09fc8ce$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($8JM6B.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("yM10v", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dsZHX = parcelRequire("dsZHX");
$jFk35.Observable.prototype.skipWhile = $dsZHX.skipWhile;

});
parcelRegister("dsZHX", function(module, exports) {
$parcel$export(module.exports, "skipWhile", () => $9cddc1c932d6c57d$export$175dedd748069215, (v) => $9cddc1c932d6c57d$export$175dedd748069215 = v);
var $9cddc1c932d6c57d$export$175dedd748069215;
"use strict";

var $9aVxy = parcelRequire("9aVxy");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $9cddc1c932d6c57d$var$skipWhile(predicate) {
    return $9aVxy.skipWhile(predicate)(this);
}
$9cddc1c932d6c57d$export$175dedd748069215 = $9cddc1c932d6c57d$var$skipWhile;

});
parcelRegister("9aVxy", function(module, exports) {
"use strict";
var $6ae1ae8348decd48$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $6ae1ae8348decd48$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $6ae1ae8348decd48$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $6ae1ae8348decd48$var$skipWhile;
var $6ae1ae8348decd48$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6ae1ae8348decd48$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6ae1ae8348decd48$var$SkipWhileSubscriber = function(_super) {
    $6ae1ae8348decd48$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("eoKqt", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $6PT4Q = parcelRequire("6PT4Q");
$jFk35.Observable.prototype.startWith = $6PT4Q.startWith;

});
parcelRegister("6PT4Q", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $4fa23aa847b405a3$export$a4fe86229b0e9bdd, (v) => $4fa23aa847b405a3$export$a4fe86229b0e9bdd = v);
var $4fa23aa847b405a3$export$a4fe86229b0e9bdd;
"use strict";

var $lhs6h = parcelRequire("lhs6h");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $4fa23aa847b405a3$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return $lhs6h.startWith.apply(void 0, array)(this);
}
$4fa23aa847b405a3$export$a4fe86229b0e9bdd = $4fa23aa847b405a3$var$startWith;

});
parcelRegister("lhs6h", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $f7e0fba41172e8f6$export$a4fe86229b0e9bdd, (v) => $f7e0fba41172e8f6$export$a4fe86229b0e9bdd = v);
var $f7e0fba41172e8f6$export$a4fe86229b0e9bdd;
"use strict";

var $eogqV = parcelRequire("eogqV");

var $3DDoV = parcelRequire("3DDoV");

var $b9w09 = parcelRequire("b9w09");

var $9aoKF = parcelRequire("9aoKF");

var $2gCz7 = parcelRequire("2gCz7");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $f7e0fba41172e8f6$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return function(source) {
        var scheduler = array[array.length - 1];
        if ($2gCz7.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len === 1) return $9aoKF.concat(new $3DDoV.ScalarObservable(array[0], scheduler), source);
        else if (len > 1) return $9aoKF.concat(new $eogqV.ArrayObservable(array, scheduler), source);
        else return $9aoKF.concat(new $b9w09.EmptyObservable(scheduler), source);
    };
}
$f7e0fba41172e8f6$export$a4fe86229b0e9bdd = $f7e0fba41172e8f6$var$startWith;

});



parcelRegister("bvlBJ", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $1JG7f = parcelRequire("1JG7f");
$jFk35.Observable.prototype.subscribeOn = $1JG7f.subscribeOn;

});
parcelRegister("1JG7f", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $143aa9c3f81f45b2$export$1eb44d8f5f64733b, (v) => $143aa9c3f81f45b2$export$1eb44d8f5f64733b = v);
var $143aa9c3f81f45b2$export$1eb44d8f5f64733b;
"use strict";

var $crEx8 = parcelRequire("crEx8");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $143aa9c3f81f45b2$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $crEx8.subscribeOn(scheduler, delay)(this);
}
$143aa9c3f81f45b2$export$1eb44d8f5f64733b = $143aa9c3f81f45b2$var$subscribeOn;

});
parcelRegister("crEx8", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $90f772c588067d18$export$1eb44d8f5f64733b, (v) => $90f772c588067d18$export$1eb44d8f5f64733b = v);
var $90f772c588067d18$export$1eb44d8f5f64733b;
"use strict";

var $id7nO = parcelRequire("id7nO");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $90f772c588067d18$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new $90f772c588067d18$var$SubscribeOnOperator(scheduler, delay));
    };
}
$90f772c588067d18$export$1eb44d8f5f64733b = $90f772c588067d18$var$subscribeOn;
var $90f772c588067d18$var$SubscribeOnOperator = function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new $id7nO.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

});
parcelRegister("id7nO", function(module, exports) {
"use strict";
var $d41f2b0534d93cce$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $iMh1Q = parcelRequire("iMh1Q");

var $8xi5Q = parcelRequire("8xi5Q");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $d41f2b0534d93cce$var$SubscribeOnObservable = function(_super) {
    $d41f2b0534d93cce$var$__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = $iMh1Q.asap;
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!$8xi5Q.isNumeric(delayTime) || delayTime < 0) this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $iMh1Q.asap;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = $iMh1Q.asap;
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}($jFk35.Observable);
module.exports.SubscribeOnObservable = $d41f2b0534d93cce$var$SubscribeOnObservable;

});
parcelRegister("iMh1Q", function(module, exports) {
$parcel$export(module.exports, "asap", () => $dab9eb3e9533da6f$export$dc4d482300a341e1, (v) => $dab9eb3e9533da6f$export$dc4d482300a341e1 = v);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */ var $dab9eb3e9533da6f$export$dc4d482300a341e1;
"use strict";

var $8AsRr = parcelRequire("8AsRr");

var $VLYF5 = parcelRequire("VLYF5");
$dab9eb3e9533da6f$export$dc4d482300a341e1 = new $VLYF5.AsapScheduler($8AsRr.AsapAction);

});
parcelRegister("8AsRr", function(module, exports) {
"use strict";
var $640812b207dce1e7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1PbEM = parcelRequire("1PbEM");

var $kpCGY = parcelRequire("kpCGY");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $640812b207dce1e7$var$AsapAction = function(_super) {
    $640812b207dce1e7$var$__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = $1PbEM.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            $1PbEM.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}($kpCGY.AsyncAction);
module.exports.AsapAction = $640812b207dce1e7$var$AsapAction;

});
parcelRegister("1PbEM", function(module, exports) {
$parcel$export(module.exports, "Immediate", () => $154398a96d6420a9$export$9bf7f22d83f7b5af, (v) => $154398a96d6420a9$export$9bf7f22d83f7b5af = v);
/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/ var $154398a96d6420a9$export$9dc12cb738f70fa0;
var $154398a96d6420a9$export$9bf7f22d83f7b5af;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
var $154398a96d6420a9$var$ImmediateDefinition = function() {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        } else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) // For Node.js before 0.9
            this.setImmediate = this.createProcessNextTickSetImmediate();
            else if (this.canUsePostMessage()) // For non-IE10 modern browsers
            this.setImmediate = this.createPostMessageSetImmediate();
            else if (this.canUseMessageChannel()) // For web workers, where supported
            this.setImmediate = this.createMessageChannelSetImmediate();
            else if (this.canUseReadyStateChange()) // For IE 6–8
            this.setImmediate = this.createReadyStateChangeSetImmediate();
            else // For older browsers
            this.setImmediate = this.createSetTimeoutSetImmediate();
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function(o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function() {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function() {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function() {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function() {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function() {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function(handler) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') handler.apply(undefined, args);
            else new Function('' + handler)();
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function(args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root && typeof event.data === 'string' && event.data.indexOf(messagePrefix) === 0) instance.runIfPresent(+event.data.slice(messagePrefix.length));
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function(handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // 'too much recursion' error.
        this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                } finally{
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function() {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function() {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}();
$154398a96d6420a9$export$9dc12cb738f70fa0 = $154398a96d6420a9$var$ImmediateDefinition;
$154398a96d6420a9$export$9bf7f22d83f7b5af = new $154398a96d6420a9$var$ImmediateDefinition($4xUKK.root);

});


parcelRegister("VLYF5", function(module, exports) {
"use strict";
var $0ada8a4d02cee8a0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5wLDa = parcelRequire("5wLDa");
var $0ada8a4d02cee8a0$var$AsapScheduler = function(_super) {
    $0ada8a4d02cee8a0$var$__extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}($5wLDa.AsyncScheduler);
module.exports.AsapScheduler = $0ada8a4d02cee8a0$var$AsapScheduler;

});






parcelRegister("hBY7i", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2V1DT = parcelRequire("2V1DT");
$jFk35.Observable.prototype.switch = $2V1DT._switch;
$jFk35.Observable.prototype._switch = $2V1DT._switch;

});
parcelRegister("2V1DT", function(module, exports) {
$parcel$export(module.exports, "_switch", () => $22022dcebabbc014$export$424b8b2ab9af2944, (v) => $22022dcebabbc014$export$424b8b2ab9af2944 = v);
var $22022dcebabbc014$export$424b8b2ab9af2944;
"use strict";

var $xN6ty = parcelRequire("xN6ty");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */ function $22022dcebabbc014$var$_switch() {
    return $xN6ty.switchAll()(this);
}
$22022dcebabbc014$export$424b8b2ab9af2944 = $22022dcebabbc014$var$_switch;

});
parcelRegister("xN6ty", function(module, exports) {
$parcel$export(module.exports, "switchAll", () => $06592c1a8501ec26$export$6a45284a4b0bf33a, (v) => $06592c1a8501ec26$export$6a45284a4b0bf33a = v);
var $06592c1a8501ec26$export$6a45284a4b0bf33a;
"use strict";

var $dJlfH = parcelRequire("dJlfH");

var $itbNr = parcelRequire("itbNr");
function $06592c1a8501ec26$var$switchAll() {
    return $dJlfH.switchMap($itbNr.identity);
}
$06592c1a8501ec26$export$6a45284a4b0bf33a = $06592c1a8501ec26$var$switchAll;

});



parcelRegister("UJgRH", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $jXTSa = parcelRequire("jXTSa");
$jFk35.Observable.prototype.switchMap = $jXTSa.switchMap;

});

parcelRegister("gdKsj", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2Fbs6 = parcelRequire("2Fbs6");
$jFk35.Observable.prototype.switchMapTo = $2Fbs6.switchMapTo;

});
parcelRegister("2Fbs6", function(module, exports) {
$parcel$export(module.exports, "switchMapTo", () => $1f084b4d705f8d81$export$a439dc30c845238, (v) => $1f084b4d705f8d81$export$a439dc30c845238 = v);
var $1f084b4d705f8d81$export$a439dc30c845238;
"use strict";

var $1MPmh = parcelRequire("1MPmh");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $1f084b4d705f8d81$var$switchMapTo(innerObservable, resultSelector) {
    return $1MPmh.switchMapTo(innerObservable, resultSelector)(this);
}
$1f084b4d705f8d81$export$a439dc30c845238 = $1f084b4d705f8d81$var$switchMapTo;

});
parcelRegister("1MPmh", function(module, exports) {
"use strict";
var $14d21cd45a779fda$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $14d21cd45a779fda$var$switchMapTo(innerObservable, resultSelector) {
    return function(source) {
        return source.lift(new $14d21cd45a779fda$var$SwitchMapToOperator(innerObservable, resultSelector));
    };
}
module.exports.switchMapTo = $14d21cd45a779fda$var$switchMapTo;
var $14d21cd45a779fda$var$SwitchMapToOperator = function() {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $14d21cd45a779fda$var$SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $14d21cd45a779fda$var$SwitchMapToSubscriber = function(_super) {
    $14d21cd45a779fda$var$__extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function(value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $8JM6B.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("il1oD", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $f2ULY = parcelRequire("f2ULY");
$jFk35.Observable.prototype.take = $f2ULY.take;

});
parcelRegister("f2ULY", function(module, exports) {
$parcel$export(module.exports, "take", () => $af4314cc3ab7ad53$export$b7df5d561049483a, (v) => $af4314cc3ab7ad53$export$b7df5d561049483a = v);
var $af4314cc3ab7ad53$export$b7df5d561049483a;
"use strict";

var $kwz1F = parcelRequire("kwz1F");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $af4314cc3ab7ad53$var$take(count) {
    return $kwz1F.take(count)(this);
}
$af4314cc3ab7ad53$export$b7df5d561049483a = $af4314cc3ab7ad53$var$take;

});
parcelRegister("kwz1F", function(module, exports) {
"use strict";
var $ef11f7396b65d089$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $cdlG8 = parcelRequire("cdlG8");

var $b9w09 = parcelRequire("b9w09");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $ef11f7396b65d089$var$take(count) {
    return function(source) {
        if (count === 0) return new $b9w09.EmptyObservable();
        else return source.lift(new $ef11f7396b65d089$var$TakeOperator(count));
    };
}
module.exports.take = $ef11f7396b65d089$var$take;
var $ef11f7396b65d089$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $cdlG8.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ef11f7396b65d089$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ef11f7396b65d089$var$TakeSubscriber = function(_super) {
    $ef11f7396b65d089$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("nms5C", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $4G7Nq = parcelRequire("4G7Nq");
$jFk35.Observable.prototype.takeLast = $4G7Nq.takeLast;

});
parcelRegister("4G7Nq", function(module, exports) {
$parcel$export(module.exports, "takeLast", () => $368121d98011c1cc$export$1b47ad771ce5af5e, (v) => $368121d98011c1cc$export$1b47ad771ce5af5e = v);
var $368121d98011c1cc$export$1b47ad771ce5af5e;
"use strict";

var $kkovN = parcelRequire("kkovN");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $368121d98011c1cc$var$takeLast(count) {
    return $kkovN.takeLast(count)(this);
}
$368121d98011c1cc$export$1b47ad771ce5af5e = $368121d98011c1cc$var$takeLast;

});


parcelRegister("78DUe", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cBJiV = parcelRequire("cBJiV");
$jFk35.Observable.prototype.takeUntil = $cBJiV.takeUntil;

});
parcelRegister("cBJiV", function(module, exports) {
$parcel$export(module.exports, "takeUntil", () => $92dc153773637243$export$ac8dfd3a7ad06e80, (v) => $92dc153773637243$export$ac8dfd3a7ad06e80 = v);
var $92dc153773637243$export$ac8dfd3a7ad06e80;
"use strict";

var $h1DVk = parcelRequire("h1DVk");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $92dc153773637243$var$takeUntil(notifier) {
    return $h1DVk.takeUntil(notifier)(this);
}
$92dc153773637243$export$ac8dfd3a7ad06e80 = $92dc153773637243$var$takeUntil;

});
parcelRegister("h1DVk", function(module, exports) {
"use strict";
var $c6517fa690c9266b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $c6517fa690c9266b$var$takeUntil(notifier) {
    return function(source) {
        return source.lift(new $c6517fa690c9266b$var$TakeUntilOperator(notifier));
    };
}
module.exports.takeUntil = $c6517fa690c9266b$var$takeUntil;
var $c6517fa690c9266b$var$TakeUntilOperator = function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c6517fa690c9266b$var$TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c6517fa690c9266b$var$TakeUntilSubscriber = function(_super) {
    $c6517fa690c9266b$var$__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add($8JM6B.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    return TakeUntilSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("iqtt4", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $8DAJ9 = parcelRequire("8DAJ9");
$jFk35.Observable.prototype.takeWhile = $8DAJ9.takeWhile;

});
parcelRegister("8DAJ9", function(module, exports) {
$parcel$export(module.exports, "takeWhile", () => $649e7482a908cd04$export$9384c7afe4015e42, (v) => $649e7482a908cd04$export$9384c7afe4015e42 = v);
var $649e7482a908cd04$export$9384c7afe4015e42;
"use strict";

var $5WpS6 = parcelRequire("5WpS6");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $649e7482a908cd04$var$takeWhile(predicate) {
    return $5WpS6.takeWhile(predicate)(this);
}
$649e7482a908cd04$export$9384c7afe4015e42 = $649e7482a908cd04$var$takeWhile;

});
parcelRegister("5WpS6", function(module, exports) {
"use strict";
var $4536701737652d2f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $4536701737652d2f$var$takeWhile(predicate) {
    return function(source) {
        return source.lift(new $4536701737652d2f$var$TakeWhileOperator(predicate));
    };
}
module.exports.takeWhile = $4536701737652d2f$var$takeWhile;
var $4536701737652d2f$var$TakeWhileOperator = function() {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4536701737652d2f$var$TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4536701737652d2f$var$TakeWhileSubscriber = function(_super) {
    $4536701737652d2f$var$__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else destination.complete();
    };
    return TakeWhileSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("dxKsL", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $jKR4P = parcelRequire("jKR4P");
$jFk35.Observable.prototype.throttle = $jKR4P.throttle;

});
parcelRegister("jKR4P", function(module, exports) {
$parcel$export(module.exports, "throttle", () => $e61b7c279d0c56c8$export$de363e709c412c8a, (v) => $e61b7c279d0c56c8$export$de363e709c412c8a = v);
var $e61b7c279d0c56c8$export$de363e709c412c8a;
"use strict";

var $gX0bT = parcelRequire("gX0bT");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $e61b7c279d0c56c8$var$throttle(durationSelector, config) {
    if (config === void 0) config = $gX0bT.defaultThrottleConfig;
    return $gX0bT.throttle(durationSelector, config)(this);
}
$e61b7c279d0c56c8$export$de363e709c412c8a = $e61b7c279d0c56c8$var$throttle;

});
parcelRegister("gX0bT", function(module, exports) {
"use strict";
var $c5724de7ecb08a40$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
module.exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $c5724de7ecb08a40$var$throttle(durationSelector, config) {
    if (config === void 0) config = module.exports.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $c5724de7ecb08a40$var$ThrottleOperator(durationSelector, config.leading, config.trailing));
    };
}
module.exports.throttle = $c5724de7ecb08a40$var$throttle;
var $c5724de7ecb08a40$var$ThrottleOperator = function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c5724de7ecb08a40$var$ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */ var $c5724de7ecb08a40$var$ThrottleSubscriber = function(_super) {
    $c5724de7ecb08a40$var$__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        } else {
            var duration = this.tryDurationSelector(value);
            if (duration) this.add(this.throttled = $8JM6B.subscribeToResult(this, duration));
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function() {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function() {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("iUCwE", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $4WRwn = parcelRequire("4WRwn");
$jFk35.Observable.prototype.throttleTime = $4WRwn.throttleTime;

});
parcelRegister("4WRwn", function(module, exports) {
$parcel$export(module.exports, "throttleTime", () => $39a61864b5ecbca1$export$4efe28f192921dd4, (v) => $39a61864b5ecbca1$export$4efe28f192921dd4 = v);
var $39a61864b5ecbca1$export$4efe28f192921dd4;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $gX0bT = parcelRequire("gX0bT");

var $fXHrt = parcelRequire("fXHrt");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $39a61864b5ecbca1$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    if (config === void 0) config = $gX0bT.defaultThrottleConfig;
    return $fXHrt.throttleTime(duration, scheduler, config)(this);
}
$39a61864b5ecbca1$export$4efe28f192921dd4 = $39a61864b5ecbca1$var$throttleTime;

});
parcelRegister("fXHrt", function(module, exports) {
"use strict";
var $b9ee106861582fe1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $1KBsc = parcelRequire("1KBsc");

var $gX0bT = parcelRequire("gX0bT");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $b9ee106861582fe1$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    if (config === void 0) config = $gX0bT.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $b9ee106861582fe1$var$ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
module.exports.throttleTime = $b9ee106861582fe1$var$throttleTime;
var $b9ee106861582fe1$var$ThrottleTimeOperator = function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b9ee106861582fe1$var$ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b9ee106861582fe1$var$ThrottleTimeSubscriber = function(_super) {
    $b9ee106861582fe1$var$__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule($b9ee106861582fe1$var$dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}($fwCeA.Subscriber);
function $b9ee106861582fe1$var$dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

});



parcelRegister("f8zms", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $4j2eI = parcelRequire("4j2eI");
$jFk35.Observable.prototype.timeInterval = $4j2eI.timeInterval;

});
parcelRegister("4j2eI", function(module, exports) {
$parcel$export(module.exports, "TimeInterval", () => $322aabda7ef9c783$export$8bb95198b45adaac, (v) => $322aabda7ef9c783$export$8bb95198b45adaac = v);
$parcel$export(module.exports, "timeInterval", () => $322aabda7ef9c783$export$1a539c8b2950ab40, (v) => $322aabda7ef9c783$export$1a539c8b2950ab40 = v);
var $322aabda7ef9c783$export$8bb95198b45adaac;
var $322aabda7ef9c783$export$1a539c8b2950ab40;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $9skuk = parcelRequire("9skuk");
$322aabda7ef9c783$export$8bb95198b45adaac = $9skuk.TimeInterval;
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */ function $322aabda7ef9c783$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $9skuk.timeInterval(scheduler)(this);
}
$322aabda7ef9c783$export$1a539c8b2950ab40 = $322aabda7ef9c783$var$timeInterval;

});
parcelRegister("9skuk", function(module, exports) {
"use strict";
var $6e269f1c74bd9868$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $1KBsc = parcelRequire("1KBsc");
function $6e269f1c74bd9868$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return function(source) {
        return source.lift(new $6e269f1c74bd9868$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $6e269f1c74bd9868$var$timeInterval;
var $6e269f1c74bd9868$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $6e269f1c74bd9868$var$TimeInterval;
var $6e269f1c74bd9868$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $6e269f1c74bd9868$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6e269f1c74bd9868$var$TimeIntervalSubscriber = function(_super) {
    $6e269f1c74bd9868$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $6e269f1c74bd9868$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("2dZzF", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $gcqUu = parcelRequire("gcqUu");
$jFk35.Observable.prototype.timeout = $gcqUu.timeout;

});
parcelRegister("gcqUu", function(module, exports) {
$parcel$export(module.exports, "timeout", () => $bcb2a41e25dbde26$export$83e74882c5df8fe1, (v) => $bcb2a41e25dbde26$export$83e74882c5df8fe1 = v);
var $bcb2a41e25dbde26$export$83e74882c5df8fe1;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $3PFfe = parcelRequire("3PFfe");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $bcb2a41e25dbde26$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $3PFfe.timeout(due, scheduler)(this);
}
$bcb2a41e25dbde26$export$83e74882c5df8fe1 = $bcb2a41e25dbde26$var$timeout;

});
parcelRegister("3PFfe", function(module, exports) {
"use strict";
var $2ca620d7aade45bb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1KBsc = parcelRequire("1KBsc");

var $iUp3d = parcelRequire("iUp3d");

var $fwCeA = parcelRequire("fwCeA");

var $6QnRJ = parcelRequire("6QnRJ");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $2ca620d7aade45bb$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    var absoluteTimeout = $iUp3d.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $2ca620d7aade45bb$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6QnRJ.TimeoutError()));
    };
}
module.exports.timeout = $2ca620d7aade45bb$var$timeout;
var $2ca620d7aade45bb$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2ca620d7aade45bb$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2ca620d7aade45bb$var$TimeoutSubscriber = function(_super) {
    $2ca620d7aade45bb$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($fwCeA.Subscriber);

});
parcelRegister("6QnRJ", function(module, exports) {
"use strict";
var $4fba1c9a45c46724$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4fba1c9a45c46724$var$TimeoutError = function(_super) {
    $4fba1c9a45c46724$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4fba1c9a45c46724$var$TimeoutError;

});




parcelRegister("iZvMa", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $cPFxd = parcelRequire("cPFxd");
$jFk35.Observable.prototype.timeoutWith = $cPFxd.timeoutWith;

});
parcelRegister("cPFxd", function(module, exports) {
$parcel$export(module.exports, "timeoutWith", () => $957a775f11de67b3$export$86fe999fba7953f2, (v) => $957a775f11de67b3$export$86fe999fba7953f2 = v);
var $957a775f11de67b3$export$86fe999fba7953f2;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $46MUI = parcelRequire("46MUI");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $957a775f11de67b3$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $46MUI.timeoutWith(due, withObservable, scheduler)(this);
}
$957a775f11de67b3$export$86fe999fba7953f2 = $957a775f11de67b3$var$timeoutWith;

});
parcelRegister("46MUI", function(module, exports) {
"use strict";
var $2fddaa32690fb8e9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1KBsc = parcelRequire("1KBsc");

var $iUp3d = parcelRequire("iUp3d");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $2fddaa32690fb8e9$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return function(source) {
        var absoluteTimeout = $iUp3d.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $2fddaa32690fb8e9$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $2fddaa32690fb8e9$var$timeoutWith;
var $2fddaa32690fb8e9$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2fddaa32690fb8e9$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2fddaa32690fb8e9$var$TimeoutWithSubscriber = function(_super) {
    $2fddaa32690fb8e9$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($8JM6B.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("e5TXc", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $lESbv = parcelRequire("lESbv");
$jFk35.Observable.prototype.timestamp = $lESbv.timestamp;

});
parcelRegister("lESbv", function(module, exports) {
$parcel$export(module.exports, "timestamp", () => $fc475d51a626394f$export$fc00ee57782020aa, (v) => $fc475d51a626394f$export$fc00ee57782020aa = v);
var $fc475d51a626394f$export$fc00ee57782020aa;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $9jiVH = parcelRequire("9jiVH");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function $fc475d51a626394f$var$timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $9jiVH.timestamp(scheduler)(this);
}
$fc475d51a626394f$export$fc00ee57782020aa = $fc475d51a626394f$var$timestamp;

});
parcelRegister("9jiVH", function(module, exports) {
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $4KOmc = parcelRequire("4KOmc");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $1KBsc.async;
    return $4KOmc.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});



parcelRegister("9idcC", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $jY2D5 = parcelRequire("jY2D5");
$jFk35.Observable.prototype.toArray = $jY2D5.toArray;

});
parcelRegister("jY2D5", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $e895a90ab29c7bb0$export$45b10814cc054894, (v) => $e895a90ab29c7bb0$export$45b10814cc054894 = v);
var $e895a90ab29c7bb0$export$45b10814cc054894;
"use strict";

var $30nnw = parcelRequire("30nnw");
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */ function $e895a90ab29c7bb0$var$toArray() {
    return $30nnw.toArray()(this);
}
$e895a90ab29c7bb0$export$45b10814cc054894 = $e895a90ab29c7bb0$var$toArray;

});
parcelRegister("30nnw", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $230381a923905696$export$45b10814cc054894, (v) => $230381a923905696$export$45b10814cc054894 = v);
var $230381a923905696$export$45b10814cc054894;
"use strict";

var $bXSND = parcelRequire("bXSND");
function $230381a923905696$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $230381a923905696$var$toArray() {
    return $bXSND.reduce($230381a923905696$var$toArrayReducer, []);
}
$230381a923905696$export$45b10814cc054894 = $230381a923905696$var$toArray;

});



parcelRegister("kbDVp", function(module, exports) {
// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.

});

parcelRegister("2LBTj", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $hYQYb = parcelRequire("hYQYb");
$jFk35.Observable.prototype.window = $hYQYb.window;

});
parcelRegister("hYQYb", function(module, exports) {
$parcel$export(module.exports, "window", () => $d17120ecccad5cfc$export$8291e5b88f90ce4, (v) => $d17120ecccad5cfc$export$8291e5b88f90ce4 = v);
var $d17120ecccad5cfc$export$8291e5b88f90ce4;
"use strict";

var $dgqxI = parcelRequire("dgqxI");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function $d17120ecccad5cfc$var$window(windowBoundaries) {
    return $dgqxI.window(windowBoundaries)(this);
}
$d17120ecccad5cfc$export$8291e5b88f90ce4 = $d17120ecccad5cfc$var$window;

});
parcelRegister("dgqxI", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add($8JM6B.subscribeToResult(windowSubscriber, this.windowBoundaries));
        return sourceSubscription;
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var WindowSubscriber = function(_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new $aSveF.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new $aSveF.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("gQTaE", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $CzcDr = parcelRequire("CzcDr");
$jFk35.Observable.prototype.windowCount = $CzcDr.windowCount;

});
parcelRegister("CzcDr", function(module, exports) {
$parcel$export(module.exports, "windowCount", () => $073edb441aa18fe4$export$f3a19e933f377396, (v) => $073edb441aa18fe4$export$f3a19e933f377396 = v);
var $073edb441aa18fe4$export$f3a19e933f377396;
"use strict";

var $dpbV4 = parcelRequire("dpbV4");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $073edb441aa18fe4$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return $dpbV4.windowCount(windowSize, startWindowEvery)(this);
}
$073edb441aa18fe4$export$f3a19e933f377396 = $073edb441aa18fe4$var$windowCount;

});
parcelRegister("dpbV4", function(module, exports) {
"use strict";
var $9c26db19ef061f4f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fwCeA = parcelRequire("fwCeA");

var $aSveF = parcelRequire("aSveF");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $9c26db19ef061f4f$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $9c26db19ef061f4f$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $9c26db19ef061f4f$var$windowCount;
var $9c26db19ef061f4f$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9c26db19ef061f4f$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9c26db19ef061f4f$var$WindowCountSubscriber = function(_super) {
    $9c26db19ef061f4f$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $aSveF.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $aSveF.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($fwCeA.Subscriber);

});



parcelRegister("7XaiY", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $2Zi9S = parcelRequire("2Zi9S");
$jFk35.Observable.prototype.windowTime = $2Zi9S.windowTime;

});
parcelRegister("2Zi9S", function(module, exports) {
$parcel$export(module.exports, "windowTime", () => $22cf5d23d8afcd92$export$1284415effa79ee0, (v) => $22cf5d23d8afcd92$export$1284415effa79ee0 = v);
var $22cf5d23d8afcd92$export$1284415effa79ee0;
"use strict";

var $1KBsc = parcelRequire("1KBsc");

var $8xi5Q = parcelRequire("8xi5Q");

var $2gCz7 = parcelRequire("2gCz7");

var $4uUSK = parcelRequire("4uUSK");
function $22cf5d23d8afcd92$var$windowTime(windowTimeSpan) {
    var scheduler = $1KBsc.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($2gCz7.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($2gCz7.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($8xi5Q.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($2gCz7.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($8xi5Q.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return $4uUSK.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
$22cf5d23d8afcd92$export$1284415effa79ee0 = $22cf5d23d8afcd92$var$windowTime;

});
parcelRegister("4uUSK", function(module, exports) {
"use strict";
var $3466165866aa965c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $1KBsc = parcelRequire("1KBsc");

var $fwCeA = parcelRequire("fwCeA");

var $8xi5Q = parcelRequire("8xi5Q");

var $2gCz7 = parcelRequire("2gCz7");
function $3466165866aa965c$var$windowTime(windowTimeSpan) {
    var scheduler = $1KBsc.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($2gCz7.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($2gCz7.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($8xi5Q.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($2gCz7.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($8xi5Q.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $3466165866aa965c$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $3466165866aa965c$var$windowTime;
var $3466165866aa965c$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3466165866aa965c$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $3466165866aa965c$var$CountedSubject = function(_super) {
    $3466165866aa965c$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($aSveF.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3466165866aa965c$var$WindowTimeSubscriber = function(_super) {
    $3466165866aa965c$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($3466165866aa965c$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($3466165866aa965c$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($3466165866aa965c$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $3466165866aa965c$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($fwCeA.Subscriber);
function $3466165866aa965c$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $3466165866aa965c$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($3466165866aa965c$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $3466165866aa965c$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});



parcelRegister("gv9ex", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $1xkSe = parcelRequire("1xkSe");
$jFk35.Observable.prototype.windowToggle = $1xkSe.windowToggle;

});
parcelRegister("1xkSe", function(module, exports) {
$parcel$export(module.exports, "windowToggle", () => $11e910961a0709c1$export$3182be990e0eeaad, (v) => $11e910961a0709c1$export$3182be990e0eeaad = v);
var $11e910961a0709c1$export$3182be990e0eeaad;
"use strict";

var $1mF7f = parcelRequire("1mF7f");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $11e910961a0709c1$var$windowToggle(openings, closingSelector) {
    return $1mF7f.windowToggle(openings, closingSelector)(this);
}
$11e910961a0709c1$export$3182be990e0eeaad = $11e910961a0709c1$var$windowToggle;

});
parcelRegister("1mF7f", function(module, exports) {
"use strict";
var $0fe7bd44c3e9cfeb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $8IeZR = parcelRequire("8IeZR");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $0fe7bd44c3e9cfeb$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $0fe7bd44c3e9cfeb$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $0fe7bd44c3e9cfeb$var$windowToggle;
var $0fe7bd44c3e9cfeb$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0fe7bd44c3e9cfeb$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fe7bd44c3e9cfeb$var$WindowToggleSubscriber = function(_super) {
    $0fe7bd44c3e9cfeb$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $8JM6B.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $fgwEQ.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $5C5Tt.errorObject) return this.error($5C5Tt.errorObject.e);
            else {
                var window_1 = new $aSveF.Subject();
                var subscription = new $8IeZR.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $8JM6B.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("3cDWp", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $jYbl0 = parcelRequire("jYbl0");
$jFk35.Observable.prototype.windowWhen = $jYbl0.windowWhen;

});
parcelRegister("jYbl0", function(module, exports) {
$parcel$export(module.exports, "windowWhen", () => $e89c6a64e4dca25c$export$6a5dea797879f644, (v) => $e89c6a64e4dca25c$export$6a5dea797879f644 = v);
var $e89c6a64e4dca25c$export$6a5dea797879f644;
"use strict";

var $5yvNS = parcelRequire("5yvNS");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $e89c6a64e4dca25c$var$windowWhen(closingSelector) {
    return $5yvNS.windowWhen(closingSelector)(this);
}
$e89c6a64e4dca25c$export$6a5dea797879f644 = $e89c6a64e4dca25c$var$windowWhen;

});
parcelRegister("5yvNS", function(module, exports) {
"use strict";
var $40b8cc418902950f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $fgwEQ = parcelRequire("fgwEQ");

var $5C5Tt = parcelRequire("5C5Tt");

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $40b8cc418902950f$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $40b8cc418902950f$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $40b8cc418902950f$var$windowWhen;
var $40b8cc418902950f$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $40b8cc418902950f$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $40b8cc418902950f$var$WindowSubscriber = function(_super) {
    $40b8cc418902950f$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $aSveF.Subject();
        this.destination.next(window);
        var closingNotifier = $fgwEQ.tryCatch(this.closingSelector)();
        if (closingNotifier === $5C5Tt.errorObject) {
            var err = $5C5Tt.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $8JM6B.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("l339T", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $hxKUJ = parcelRequire("hxKUJ");
$jFk35.Observable.prototype.withLatestFrom = $hxKUJ.withLatestFrom;

});
parcelRegister("hxKUJ", function(module, exports) {
$parcel$export(module.exports, "withLatestFrom", () => $cc59e8e0b695ef6a$export$d449030e5c10edf7, (v) => $cc59e8e0b695ef6a$export$d449030e5c10edf7 = v);
var $cc59e8e0b695ef6a$export$d449030e5c10edf7;
"use strict";

var $6aRJ7 = parcelRequire("6aRJ7");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $cc59e8e0b695ef6a$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return $6aRJ7.withLatestFrom.apply(void 0, args)(this);
}
$cc59e8e0b695ef6a$export$d449030e5c10edf7 = $cc59e8e0b695ef6a$var$withLatestFrom;

});
parcelRegister("6aRJ7", function(module, exports) {
"use strict";
var $0128fd53b472333b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cSU8n = parcelRequire("cSU8n");

var $8JM6B = parcelRequire("8JM6B");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $0128fd53b472333b$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === 'function') project = args.pop();
        var observables = args;
        return source.lift(new $0128fd53b472333b$var$WithLatestFromOperator(observables, project));
    };
}
module.exports.withLatestFrom = $0128fd53b472333b$var$withLatestFrom;
var $0128fd53b472333b$var$WithLatestFromOperator = function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0128fd53b472333b$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0128fd53b472333b$var$WithLatestFromSubscriber = function(_super) {
    $0128fd53b472333b$var$__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for(var i = 0; i < len; i++)this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            this.add($8JM6B.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}($cSU8n.OuterSubscriber);

});



parcelRegister("krDMQ", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $03ytN = parcelRequire("03ytN");
$jFk35.Observable.prototype.zip = $03ytN.zipProto;

});
parcelRegister("03ytN", function(module, exports) {
$parcel$export(module.exports, "zipProto", () => $00ab06d7d43847c4$export$ad1b5245dc53c655, (v) => $00ab06d7d43847c4$export$ad1b5245dc53c655 = v);
var $00ab06d7d43847c4$export$ad1b5245dc53c655;
"use strict";

var $4mSt5 = parcelRequire("4mSt5");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $00ab06d7d43847c4$var$zipProto() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $4mSt5.zip.apply(void 0, observables)(this);
}
$00ab06d7d43847c4$export$ad1b5245dc53c655 = $00ab06d7d43847c4$var$zipProto;

});


parcelRegister("7fAT1", function(module, exports) {
"use strict";

var $jFk35 = parcelRequire("jFk35");

var $dwvnN = parcelRequire("dwvnN");
$jFk35.Observable.prototype.zipAll = $dwvnN.zipAll;

});
parcelRegister("dwvnN", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $9d869b7cac2b6beb$export$adddb6a2fa3864e9, (v) => $9d869b7cac2b6beb$export$adddb6a2fa3864e9 = v);
var $9d869b7cac2b6beb$export$adddb6a2fa3864e9;
"use strict";

var $lPsda = parcelRequire("lPsda");
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */ function $9d869b7cac2b6beb$var$zipAll(project) {
    return $lPsda.zipAll(project)(this);
}
$9d869b7cac2b6beb$export$adddb6a2fa3864e9 = $9d869b7cac2b6beb$var$zipAll;

});
parcelRegister("lPsda", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $fe443e92bef5750b$export$adddb6a2fa3864e9, (v) => $fe443e92bef5750b$export$adddb6a2fa3864e9 = v);
var $fe443e92bef5750b$export$adddb6a2fa3864e9;
"use strict";

var $4mSt5 = parcelRequire("4mSt5");
function $fe443e92bef5750b$var$zipAll(project) {
    return function(source) {
        return source.lift(new $4mSt5.ZipOperator(project));
    };
}
$fe443e92bef5750b$export$adddb6a2fa3864e9 = $fe443e92bef5750b$var$zipAll;

});



parcelRegister("dIrp5", function(module, exports) {
"use strict";
var $9fc4a4389f6a338b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $jWUHN = parcelRequire("jWUHN");

var $41hrH = parcelRequire("41hrH");

var $2A8vG = parcelRequire("2A8vG");

var $h0XSc = parcelRequire("h0XSc");

var $2Uttx = parcelRequire("2Uttx");
var $9fc4a4389f6a338b$var$defaultMaxFrame = 750;
var $9fc4a4389f6a338b$var$TestScheduler = function(_super) {
    $9fc4a4389f6a338b$var$__extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, $2Uttx.VirtualAction, $9fc4a4389f6a338b$var$defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function(marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) throw new Error('marble diagram for time should have a completion marker "|"');
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function(marbles, values, error) {
        if (marbles.indexOf('^') !== -1) throw new Error('cold observable cannot have subscription offset "^"');
        if (marbles.indexOf('!') !== -1) throw new Error('cold observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new $41hrH.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function(marbles, values, error) {
        if (marbles.indexOf('!') !== -1) throw new Error('hot observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new $2A8vG.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function(observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function(value) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $jWUHN.Notification.createNext(value)
            });
        }, function(err) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $jWUHN.Notification.createError(err)
            });
        }, function() {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $jWUHN.Notification.createComplete()
            });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function(observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) unsubscriptionMarbles = null;
        var actual = [];
        var flushTest = {
            actual: actual,
            ready: false
        };
        var unsubscriptionFrame = TestScheduler.parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function() {
            subscription = observable.subscribe(function(x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof $jFk35.Observable) value = _this.materializeInnerObservable(value, _this.frame);
                actual.push({
                    frame: _this.frame,
                    notification: $jWUHN.Notification.createNext(value)
                });
            }, function(err) {
                actual.push({
                    frame: _this.frame,
                    notification: $jWUHN.Notification.createError(err)
                });
            }, function() {
                actual.push({
                    frame: _this.frame,
                    notification: $jWUHN.Notification.createComplete()
                });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) this.schedule(function() {
            return subscription.unsubscribe();
        }, unsubscriptionFrame);
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function(actualSubscriptionLogs) {
        var flushTest = {
            actual: actualSubscriptionLogs,
            ready: false
        };
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles) {
                var marblesArray = typeof marbles === 'string' ? [
                    marbles
                ] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function(marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function() {
        var hotObservables = this.hotObservables;
        while(hotObservables.length > 0)hotObservables.shift().setup();
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function(test) {
            return test.ready;
        });
        while(readyFlushTests.length > 0){
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function(marbles) {
        if (typeof marbles !== 'string') return new $h0XSc.SubscriptionLog(Number.POSITIVE_INFINITY);
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error("there can only be '^' and '!' markers in a subscription marble diagram. Found instead '" + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) return new $h0XSc.SubscriptionLog(subscriptionFrame);
        else return new $h0XSc.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
    };
    TestScheduler.parseMarbles = function(marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) materializeInnerObservables = false;
        if (marbles.indexOf('!') !== -1) throw new Error('conventional marble diagrams cannot have the unsubscription marker "!"');
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : subIndex * -this.frameTimeFactor;
        var getValue = typeof values !== 'object' ? function(x) {
            return x;
        } : function(x) {
            // Support Observable-of-Observables
            if (materializeInnerObservables && values[x] instanceof $41hrH.ColdObservable) return values[x].messages;
            return values[x];
        };
        var groupStart = -1;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = $jWUHN.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = $jWUHN.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = $jWUHN.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) testMessages.push({
                frame: groupStart > -1 ? groupStart : frame,
                notification: notification
            });
        }
        return testMessages;
    };
    return TestScheduler;
}($2Uttx.VirtualTimeScheduler);
module.exports.TestScheduler = $9fc4a4389f6a338b$var$TestScheduler;

});
parcelRegister("41hrH", function(module, exports) {
"use strict";
var $2ed4c9c3ab24ff74$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jFk35 = parcelRequire("jFk35");

var $8IeZR = parcelRequire("8IeZR");

var $iwGQw = parcelRequire("iwGQw");

var $655Kb = parcelRequire("655Kb");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2ed4c9c3ab24ff74$var$ColdObservable = function(_super) {
    $2ed4c9c3ab24ff74$var$__extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function(subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new $8IeZR.Subscription(function() {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function(subscriber) {
        var messagesLength = this.messages.length;
        for(var i = 0; i < messagesLength; i++){
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function(_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, {
                message: message,
                subscriber: subscriber
            }));
        }
    };
    return ColdObservable;
}($jFk35.Observable);
module.exports.ColdObservable = $2ed4c9c3ab24ff74$var$ColdObservable;
$655Kb.applyMixins($2ed4c9c3ab24ff74$var$ColdObservable, [
    $iwGQw.SubscriptionLoggable
]);

});
parcelRegister("iwGQw", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLoggable", () => $d7cc7386c25b094c$export$b07abd1cdf2201bb, (v) => $d7cc7386c25b094c$export$b07abd1cdf2201bb = v);
var $d7cc7386c25b094c$export$b07abd1cdf2201bb;
"use strict";

var $h0XSc = parcelRequire("h0XSc");
var $d7cc7386c25b094c$var$SubscriptionLoggable = function() {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function() {
        this.subscriptions.push(new $h0XSc.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function(index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new $h0XSc.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}();
$d7cc7386c25b094c$export$b07abd1cdf2201bb = $d7cc7386c25b094c$var$SubscriptionLoggable;

});
parcelRegister("h0XSc", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLog", () => $c630e15397b5d623$export$63bb55968f4c7c1e, (v) => $c630e15397b5d623$export$63bb55968f4c7c1e = v);
var $c630e15397b5d623$export$63bb55968f4c7c1e;
"use strict";
var $c630e15397b5d623$var$SubscriptionLog = function() {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) unsubscribedFrame = Number.POSITIVE_INFINITY;
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}();
$c630e15397b5d623$export$63bb55968f4c7c1e = $c630e15397b5d623$var$SubscriptionLog;

});


parcelRegister("655Kb", function(module, exports) {
$parcel$export(module.exports, "applyMixins", () => $46d7aa5755182f62$export$6ccb92ce135089b4, (v) => $46d7aa5755182f62$export$6ccb92ce135089b4 = v);
var $46d7aa5755182f62$export$6ccb92ce135089b4;
"use strict";
function $46d7aa5755182f62$var$applyMixins(derivedCtor, baseCtors) {
    for(var i = 0, len = baseCtors.length; i < len; i++){
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for(var j = 0, len2 = propertyKeys.length; j < len2; j++){
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
$46d7aa5755182f62$export$6ccb92ce135089b4 = $46d7aa5755182f62$var$applyMixins;

});


parcelRegister("2A8vG", function(module, exports) {
"use strict";
var $1e158b7cd7700198$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aSveF = parcelRequire("aSveF");

var $8IeZR = parcelRequire("8IeZR");

var $iwGQw = parcelRequire("iwGQw");

var $655Kb = parcelRequire("655Kb");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1e158b7cd7700198$var$HotObservable = function(_super) {
    $1e158b7cd7700198$var$__extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function(subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new $8IeZR.Subscription(function() {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function() {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */ for(var i = 0; i < messagesLength; i++)(function() {
            var message = subject.messages[i];
            /* tslint:enable */ subject.scheduler.schedule(function() {
                message.notification.observe(subject);
            }, message.frame);
        })();
    };
    return HotObservable;
}($aSveF.Subject);
module.exports.HotObservable = $1e158b7cd7700198$var$HotObservable;
$655Kb.applyMixins($1e158b7cd7700198$var$HotObservable, [
    $iwGQw.SubscriptionLoggable
]);

});

parcelRegister("2Uttx", function(module, exports) {
"use strict";
var $21e7acede79098d3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kpCGY = parcelRequire("kpCGY");

var $5wLDa = parcelRequire("5wLDa");
var $21e7acede79098d3$var$VirtualTimeScheduler = function(_super) {
    $21e7acede79098d3$var$__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) SchedulerAction = $21e7acede79098d3$var$VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        _super.call(this, SchedulerAction, function() {
            return _this.frame;
        });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */ VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions.shift()) && (this.frame = action.delay) <= maxFrames){
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}($5wLDa.AsyncScheduler);
module.exports.VirtualTimeScheduler = $21e7acede79098d3$var$VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $21e7acede79098d3$var$VirtualAction = function(_super) {
    $21e7acede79098d3$var$__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}($kpCGY.AsyncAction);
module.exports.VirtualAction = $21e7acede79098d3$var$VirtualAction;

});


parcelRegister("jW3rE", function(module, exports) {
$parcel$export(module.exports, "animationFrame", () => $e8361b335fdda2bc$export$1402cba6a733f33a, (v) => $e8361b335fdda2bc$export$1402cba6a733f33a = v);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */ var $e8361b335fdda2bc$export$1402cba6a733f33a;
"use strict";

var $12Jno = parcelRequire("12Jno");

var $8MfnC = parcelRequire("8MfnC");
$e8361b335fdda2bc$export$1402cba6a733f33a = new $8MfnC.AnimationFrameScheduler($12Jno.AnimationFrameAction);

});
parcelRegister("12Jno", function(module, exports) {
"use strict";
var $0c292d1cd5c2c15f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kpCGY = parcelRequire("kpCGY");

var $gKZTh = parcelRequire("gKZTh");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0c292d1cd5c2c15f$var$AnimationFrameAction = function(_super) {
    $0c292d1cd5c2c15f$var$__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = $gKZTh.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            $gKZTh.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}($kpCGY.AsyncAction);
module.exports.AnimationFrameAction = $0c292d1cd5c2c15f$var$AnimationFrameAction;

});
parcelRegister("gKZTh", function(module, exports) {
$parcel$export(module.exports, "AnimationFrame", () => $c330f364a98adeed$export$1f3d5b43727c648a, (v) => $c330f364a98adeed$export$1f3d5b43727c648a = v);
var $c330f364a98adeed$export$5e49294fc1f79cc3;
var $c330f364a98adeed$export$1f3d5b43727c648a;
"use strict";

var $4xUKK = parcelRequire("4xUKK");
var $c330f364a98adeed$var$RequestAnimationFrameDefinition = function() {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        } else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        } else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        } else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        } else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        } else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function(cb) {
                return root.setTimeout(cb, 1000 / 60);
            };
        }
    }
    return RequestAnimationFrameDefinition;
}();
$c330f364a98adeed$export$5e49294fc1f79cc3 = $c330f364a98adeed$var$RequestAnimationFrameDefinition;
$c330f364a98adeed$export$1f3d5b43727c648a = new $c330f364a98adeed$var$RequestAnimationFrameDefinition($4xUKK.root);

});


parcelRegister("8MfnC", function(module, exports) {
"use strict";
var $663ebc9487bb8e3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5wLDa = parcelRequire("5wLDa");
var $663ebc9487bb8e3c$var$AnimationFrameScheduler = function(_super) {
    $663ebc9487bb8e3c$var$__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}($5wLDa.AsyncScheduler);
module.exports.AnimationFrameScheduler = $663ebc9487bb8e3c$var$AnimationFrameScheduler;

});


parcelRegister("6J2dj", function(module, exports) {
$parcel$export(module.exports, "audit", () => $4e58a9a7bbaab9cb$export$d779b02e6b68c3e8, (v) => $4e58a9a7bbaab9cb$export$d779b02e6b68c3e8 = v);
$parcel$export(module.exports, "auditTime", () => $4e58a9a7bbaab9cb$export$719c70722b10e5ff, (v) => $4e58a9a7bbaab9cb$export$719c70722b10e5ff = v);
$parcel$export(module.exports, "buffer", () => $4e58a9a7bbaab9cb$export$ab1029bcae9ddb4a, (v) => $4e58a9a7bbaab9cb$export$ab1029bcae9ddb4a = v);
$parcel$export(module.exports, "bufferCount", () => $4e58a9a7bbaab9cb$export$8916d2c8119541bb, (v) => $4e58a9a7bbaab9cb$export$8916d2c8119541bb = v);
$parcel$export(module.exports, "bufferTime", () => $4e58a9a7bbaab9cb$export$d6b40c95035461c7, (v) => $4e58a9a7bbaab9cb$export$d6b40c95035461c7 = v);
$parcel$export(module.exports, "bufferToggle", () => $4e58a9a7bbaab9cb$export$91115bdd8709945f, (v) => $4e58a9a7bbaab9cb$export$91115bdd8709945f = v);
$parcel$export(module.exports, "bufferWhen", () => $4e58a9a7bbaab9cb$export$9e55760d3282e08c, (v) => $4e58a9a7bbaab9cb$export$9e55760d3282e08c = v);
$parcel$export(module.exports, "catchError", () => $4e58a9a7bbaab9cb$export$3dede90624df3ba9, (v) => $4e58a9a7bbaab9cb$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "combineAll", () => $4e58a9a7bbaab9cb$export$29ae691b7de52fe3, (v) => $4e58a9a7bbaab9cb$export$29ae691b7de52fe3 = v);
$parcel$export(module.exports, "combineLatest", () => $4e58a9a7bbaab9cb$export$77fa7d86f5204e8a, (v) => $4e58a9a7bbaab9cb$export$77fa7d86f5204e8a = v);
$parcel$export(module.exports, "concat", () => $4e58a9a7bbaab9cb$export$ee1b3e54f0441b22, (v) => $4e58a9a7bbaab9cb$export$ee1b3e54f0441b22 = v);
$parcel$export(module.exports, "concatAll", () => $4e58a9a7bbaab9cb$export$b314777ae20abca9, (v) => $4e58a9a7bbaab9cb$export$b314777ae20abca9 = v);
$parcel$export(module.exports, "concatMap", () => $4e58a9a7bbaab9cb$export$c28c8388be0ab31a, (v) => $4e58a9a7bbaab9cb$export$c28c8388be0ab31a = v);
$parcel$export(module.exports, "concatMapTo", () => $4e58a9a7bbaab9cb$export$82fbd7a2841d2484, (v) => $4e58a9a7bbaab9cb$export$82fbd7a2841d2484 = v);
$parcel$export(module.exports, "count", () => $4e58a9a7bbaab9cb$export$85b9a36db797e02b, (v) => $4e58a9a7bbaab9cb$export$85b9a36db797e02b = v);
$parcel$export(module.exports, "debounce", () => $4e58a9a7bbaab9cb$export$61fc7d43ac8f84b0, (v) => $4e58a9a7bbaab9cb$export$61fc7d43ac8f84b0 = v);
$parcel$export(module.exports, "debounceTime", () => $4e58a9a7bbaab9cb$export$7843a4469d64c07e, (v) => $4e58a9a7bbaab9cb$export$7843a4469d64c07e = v);
$parcel$export(module.exports, "defaultIfEmpty", () => $4e58a9a7bbaab9cb$export$e4ca6d7b7a6dcf9b, (v) => $4e58a9a7bbaab9cb$export$e4ca6d7b7a6dcf9b = v);
$parcel$export(module.exports, "delay", () => $4e58a9a7bbaab9cb$export$1391212d75b2ee65, (v) => $4e58a9a7bbaab9cb$export$1391212d75b2ee65 = v);
$parcel$export(module.exports, "delayWhen", () => $4e58a9a7bbaab9cb$export$286ca829307725c9, (v) => $4e58a9a7bbaab9cb$export$286ca829307725c9 = v);
$parcel$export(module.exports, "dematerialize", () => $4e58a9a7bbaab9cb$export$ab9a5985b741fa7a, (v) => $4e58a9a7bbaab9cb$export$ab9a5985b741fa7a = v);
$parcel$export(module.exports, "distinct", () => $4e58a9a7bbaab9cb$export$983a3b5fb2f7202e, (v) => $4e58a9a7bbaab9cb$export$983a3b5fb2f7202e = v);
$parcel$export(module.exports, "distinctUntilChanged", () => $4e58a9a7bbaab9cb$export$779c5fb865a0172e, (v) => $4e58a9a7bbaab9cb$export$779c5fb865a0172e = v);
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $4e58a9a7bbaab9cb$export$571da16e28367bde, (v) => $4e58a9a7bbaab9cb$export$571da16e28367bde = v);
$parcel$export(module.exports, "elementAt", () => $4e58a9a7bbaab9cb$export$91d69c7761a17bbc, (v) => $4e58a9a7bbaab9cb$export$91d69c7761a17bbc = v);
$parcel$export(module.exports, "every", () => $4e58a9a7bbaab9cb$export$7ecc1a3b11b57dab, (v) => $4e58a9a7bbaab9cb$export$7ecc1a3b11b57dab = v);
$parcel$export(module.exports, "exhaust", () => $4e58a9a7bbaab9cb$export$31039f1fbd797b9c, (v) => $4e58a9a7bbaab9cb$export$31039f1fbd797b9c = v);
$parcel$export(module.exports, "exhaustMap", () => $4e58a9a7bbaab9cb$export$d70d492cd31004c0, (v) => $4e58a9a7bbaab9cb$export$d70d492cd31004c0 = v);
$parcel$export(module.exports, "expand", () => $4e58a9a7bbaab9cb$export$9f77e0932fb78f72, (v) => $4e58a9a7bbaab9cb$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "filter", () => $4e58a9a7bbaab9cb$export$3dea766d36a8935f, (v) => $4e58a9a7bbaab9cb$export$3dea766d36a8935f = v);
$parcel$export(module.exports, "finalize", () => $4e58a9a7bbaab9cb$export$578723aef62d92f5, (v) => $4e58a9a7bbaab9cb$export$578723aef62d92f5 = v);
$parcel$export(module.exports, "find", () => $4e58a9a7bbaab9cb$export$71aa6c912b956294, (v) => $4e58a9a7bbaab9cb$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "findIndex", () => $4e58a9a7bbaab9cb$export$de3a4d4a0d731119, (v) => $4e58a9a7bbaab9cb$export$de3a4d4a0d731119 = v);
$parcel$export(module.exports, "first", () => $4e58a9a7bbaab9cb$export$43128fadae87b74a, (v) => $4e58a9a7bbaab9cb$export$43128fadae87b74a = v);
$parcel$export(module.exports, "groupBy", () => $4e58a9a7bbaab9cb$export$3f063810d7bf01bd, (v) => $4e58a9a7bbaab9cb$export$3f063810d7bf01bd = v);
$parcel$export(module.exports, "ignoreElements", () => $4e58a9a7bbaab9cb$export$6953b97c7d866605, (v) => $4e58a9a7bbaab9cb$export$6953b97c7d866605 = v);
$parcel$export(module.exports, "isEmpty", () => $4e58a9a7bbaab9cb$export$dd1bc94b04021eeb, (v) => $4e58a9a7bbaab9cb$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "last", () => $4e58a9a7bbaab9cb$export$4c7897fafd92b108, (v) => $4e58a9a7bbaab9cb$export$4c7897fafd92b108 = v);
$parcel$export(module.exports, "map", () => $4e58a9a7bbaab9cb$export$871de8747c9eaa88, (v) => $4e58a9a7bbaab9cb$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mapTo", () => $4e58a9a7bbaab9cb$export$e0eaf3a86c03b2ad, (v) => $4e58a9a7bbaab9cb$export$e0eaf3a86c03b2ad = v);
$parcel$export(module.exports, "materialize", () => $4e58a9a7bbaab9cb$export$76dbd6ffd832405d, (v) => $4e58a9a7bbaab9cb$export$76dbd6ffd832405d = v);
$parcel$export(module.exports, "max", () => $4e58a9a7bbaab9cb$export$8960430cfd85939f, (v) => $4e58a9a7bbaab9cb$export$8960430cfd85939f = v);
$parcel$export(module.exports, "merge", () => $4e58a9a7bbaab9cb$export$4950aa0f605343fb, (v) => $4e58a9a7bbaab9cb$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "mergeAll", () => $4e58a9a7bbaab9cb$export$18aef43295bbe906, (v) => $4e58a9a7bbaab9cb$export$18aef43295bbe906 = v);
$parcel$export(module.exports, "mergeMap", () => $4e58a9a7bbaab9cb$export$6b9f6c0d32c093f9, (v) => $4e58a9a7bbaab9cb$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "flatMap", () => $4e58a9a7bbaab9cb$export$5b8affa63fc6df16, (v) => $4e58a9a7bbaab9cb$export$5b8affa63fc6df16 = v);
$parcel$export(module.exports, "mergeMapTo", () => $4e58a9a7bbaab9cb$export$bd7cfc9a42b8a412, (v) => $4e58a9a7bbaab9cb$export$bd7cfc9a42b8a412 = v);
$parcel$export(module.exports, "mergeScan", () => $4e58a9a7bbaab9cb$export$c1fc905202bced53, (v) => $4e58a9a7bbaab9cb$export$c1fc905202bced53 = v);
$parcel$export(module.exports, "min", () => $4e58a9a7bbaab9cb$export$96ec731ed4dcb222, (v) => $4e58a9a7bbaab9cb$export$96ec731ed4dcb222 = v);
$parcel$export(module.exports, "multicast", () => $4e58a9a7bbaab9cb$export$1364843af8d5a963, (v) => $4e58a9a7bbaab9cb$export$1364843af8d5a963 = v);
$parcel$export(module.exports, "observeOn", () => $4e58a9a7bbaab9cb$export$9007f49c319d1ac7, (v) => $4e58a9a7bbaab9cb$export$9007f49c319d1ac7 = v);
$parcel$export(module.exports, "onErrorResumeNext", () => $4e58a9a7bbaab9cb$export$5fba66d61591f42, (v) => $4e58a9a7bbaab9cb$export$5fba66d61591f42 = v);
$parcel$export(module.exports, "pairwise", () => $4e58a9a7bbaab9cb$export$8f9d79d42bff1aac, (v) => $4e58a9a7bbaab9cb$export$8f9d79d42bff1aac = v);
$parcel$export(module.exports, "partition", () => $4e58a9a7bbaab9cb$export$b29f828819edca8d, (v) => $4e58a9a7bbaab9cb$export$b29f828819edca8d = v);
$parcel$export(module.exports, "pluck", () => $4e58a9a7bbaab9cb$export$c44985b87d605eff, (v) => $4e58a9a7bbaab9cb$export$c44985b87d605eff = v);
$parcel$export(module.exports, "publish", () => $4e58a9a7bbaab9cb$export$89b472e03be495df, (v) => $4e58a9a7bbaab9cb$export$89b472e03be495df = v);
$parcel$export(module.exports, "publishBehavior", () => $4e58a9a7bbaab9cb$export$16ae46fda9567053, (v) => $4e58a9a7bbaab9cb$export$16ae46fda9567053 = v);
$parcel$export(module.exports, "publishLast", () => $4e58a9a7bbaab9cb$export$42d9b6b38c68d989, (v) => $4e58a9a7bbaab9cb$export$42d9b6b38c68d989 = v);
$parcel$export(module.exports, "publishReplay", () => $4e58a9a7bbaab9cb$export$1f3342bf81d92d52, (v) => $4e58a9a7bbaab9cb$export$1f3342bf81d92d52 = v);
$parcel$export(module.exports, "race", () => $4e58a9a7bbaab9cb$export$236c05de452bec2, (v) => $4e58a9a7bbaab9cb$export$236c05de452bec2 = v);
$parcel$export(module.exports, "reduce", () => $4e58a9a7bbaab9cb$export$533b26079ad0b4b, (v) => $4e58a9a7bbaab9cb$export$533b26079ad0b4b = v);
$parcel$export(module.exports, "repeat", () => $4e58a9a7bbaab9cb$export$76d90c956114f2c2, (v) => $4e58a9a7bbaab9cb$export$76d90c956114f2c2 = v);
$parcel$export(module.exports, "repeatWhen", () => $4e58a9a7bbaab9cb$export$b39ac5b4ffd1415a, (v) => $4e58a9a7bbaab9cb$export$b39ac5b4ffd1415a = v);
$parcel$export(module.exports, "retry", () => $4e58a9a7bbaab9cb$export$9369b12211e1fce4, (v) => $4e58a9a7bbaab9cb$export$9369b12211e1fce4 = v);
$parcel$export(module.exports, "retryWhen", () => $4e58a9a7bbaab9cb$export$1281551253cfee02, (v) => $4e58a9a7bbaab9cb$export$1281551253cfee02 = v);
$parcel$export(module.exports, "refCount", () => $4e58a9a7bbaab9cb$export$18d0766d894cba0c, (v) => $4e58a9a7bbaab9cb$export$18d0766d894cba0c = v);
$parcel$export(module.exports, "sample", () => $4e58a9a7bbaab9cb$export$4812e460280c6ef2, (v) => $4e58a9a7bbaab9cb$export$4812e460280c6ef2 = v);
$parcel$export(module.exports, "sampleTime", () => $4e58a9a7bbaab9cb$export$fe33c7b2002d97b0, (v) => $4e58a9a7bbaab9cb$export$fe33c7b2002d97b0 = v);
$parcel$export(module.exports, "scan", () => $4e58a9a7bbaab9cb$export$c87d910e63d22ed6, (v) => $4e58a9a7bbaab9cb$export$c87d910e63d22ed6 = v);
$parcel$export(module.exports, "sequenceEqual", () => $4e58a9a7bbaab9cb$export$d0a07e60ae428313, (v) => $4e58a9a7bbaab9cb$export$d0a07e60ae428313 = v);
$parcel$export(module.exports, "share", () => $4e58a9a7bbaab9cb$export$ed80d9de1d9df928, (v) => $4e58a9a7bbaab9cb$export$ed80d9de1d9df928 = v);
$parcel$export(module.exports, "shareReplay", () => $4e58a9a7bbaab9cb$export$db61d692014e534e, (v) => $4e58a9a7bbaab9cb$export$db61d692014e534e = v);
$parcel$export(module.exports, "single", () => $4e58a9a7bbaab9cb$export$863d7ca51b416cee, (v) => $4e58a9a7bbaab9cb$export$863d7ca51b416cee = v);
$parcel$export(module.exports, "skip", () => $4e58a9a7bbaab9cb$export$955fc4a6c4be454d, (v) => $4e58a9a7bbaab9cb$export$955fc4a6c4be454d = v);
$parcel$export(module.exports, "skipLast", () => $4e58a9a7bbaab9cb$export$635f6273df29ea1c, (v) => $4e58a9a7bbaab9cb$export$635f6273df29ea1c = v);
$parcel$export(module.exports, "skipUntil", () => $4e58a9a7bbaab9cb$export$facc584867c26fde, (v) => $4e58a9a7bbaab9cb$export$facc584867c26fde = v);
$parcel$export(module.exports, "skipWhile", () => $4e58a9a7bbaab9cb$export$175dedd748069215, (v) => $4e58a9a7bbaab9cb$export$175dedd748069215 = v);
$parcel$export(module.exports, "startWith", () => $4e58a9a7bbaab9cb$export$a4fe86229b0e9bdd, (v) => $4e58a9a7bbaab9cb$export$a4fe86229b0e9bdd = v);
$parcel$export(module.exports, "switchAll", () => $4e58a9a7bbaab9cb$export$6a45284a4b0bf33a, (v) => $4e58a9a7bbaab9cb$export$6a45284a4b0bf33a = v);
$parcel$export(module.exports, "switchMap", () => $4e58a9a7bbaab9cb$export$9f6ea8e48bc26eab, (v) => $4e58a9a7bbaab9cb$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "switchMapTo", () => $4e58a9a7bbaab9cb$export$a439dc30c845238, (v) => $4e58a9a7bbaab9cb$export$a439dc30c845238 = v);
$parcel$export(module.exports, "take", () => $4e58a9a7bbaab9cb$export$b7df5d561049483a, (v) => $4e58a9a7bbaab9cb$export$b7df5d561049483a = v);
$parcel$export(module.exports, "takeLast", () => $4e58a9a7bbaab9cb$export$1b47ad771ce5af5e, (v) => $4e58a9a7bbaab9cb$export$1b47ad771ce5af5e = v);
$parcel$export(module.exports, "takeUntil", () => $4e58a9a7bbaab9cb$export$ac8dfd3a7ad06e80, (v) => $4e58a9a7bbaab9cb$export$ac8dfd3a7ad06e80 = v);
$parcel$export(module.exports, "takeWhile", () => $4e58a9a7bbaab9cb$export$9384c7afe4015e42, (v) => $4e58a9a7bbaab9cb$export$9384c7afe4015e42 = v);
$parcel$export(module.exports, "tap", () => $4e58a9a7bbaab9cb$export$3f23594af5f37336, (v) => $4e58a9a7bbaab9cb$export$3f23594af5f37336 = v);
$parcel$export(module.exports, "throttle", () => $4e58a9a7bbaab9cb$export$de363e709c412c8a, (v) => $4e58a9a7bbaab9cb$export$de363e709c412c8a = v);
$parcel$export(module.exports, "throttleTime", () => $4e58a9a7bbaab9cb$export$4efe28f192921dd4, (v) => $4e58a9a7bbaab9cb$export$4efe28f192921dd4 = v);
$parcel$export(module.exports, "timeInterval", () => $4e58a9a7bbaab9cb$export$1a539c8b2950ab40, (v) => $4e58a9a7bbaab9cb$export$1a539c8b2950ab40 = v);
$parcel$export(module.exports, "timeout", () => $4e58a9a7bbaab9cb$export$83e74882c5df8fe1, (v) => $4e58a9a7bbaab9cb$export$83e74882c5df8fe1 = v);
$parcel$export(module.exports, "timeoutWith", () => $4e58a9a7bbaab9cb$export$86fe999fba7953f2, (v) => $4e58a9a7bbaab9cb$export$86fe999fba7953f2 = v);
$parcel$export(module.exports, "timestamp", () => $4e58a9a7bbaab9cb$export$fc00ee57782020aa, (v) => $4e58a9a7bbaab9cb$export$fc00ee57782020aa = v);
$parcel$export(module.exports, "toArray", () => $4e58a9a7bbaab9cb$export$45b10814cc054894, (v) => $4e58a9a7bbaab9cb$export$45b10814cc054894 = v);
$parcel$export(module.exports, "window", () => $4e58a9a7bbaab9cb$export$8291e5b88f90ce4, (v) => $4e58a9a7bbaab9cb$export$8291e5b88f90ce4 = v);
$parcel$export(module.exports, "windowCount", () => $4e58a9a7bbaab9cb$export$f3a19e933f377396, (v) => $4e58a9a7bbaab9cb$export$f3a19e933f377396 = v);
$parcel$export(module.exports, "windowTime", () => $4e58a9a7bbaab9cb$export$1284415effa79ee0, (v) => $4e58a9a7bbaab9cb$export$1284415effa79ee0 = v);
$parcel$export(module.exports, "windowToggle", () => $4e58a9a7bbaab9cb$export$3182be990e0eeaad, (v) => $4e58a9a7bbaab9cb$export$3182be990e0eeaad = v);
$parcel$export(module.exports, "windowWhen", () => $4e58a9a7bbaab9cb$export$6a5dea797879f644, (v) => $4e58a9a7bbaab9cb$export$6a5dea797879f644 = v);
$parcel$export(module.exports, "withLatestFrom", () => $4e58a9a7bbaab9cb$export$d449030e5c10edf7, (v) => $4e58a9a7bbaab9cb$export$d449030e5c10edf7 = v);
$parcel$export(module.exports, "zip", () => $4e58a9a7bbaab9cb$export$8901015135f2fb22, (v) => $4e58a9a7bbaab9cb$export$8901015135f2fb22 = v);
$parcel$export(module.exports, "zipAll", () => $4e58a9a7bbaab9cb$export$adddb6a2fa3864e9, (v) => $4e58a9a7bbaab9cb$export$adddb6a2fa3864e9 = v);
var $4e58a9a7bbaab9cb$export$d779b02e6b68c3e8;
var $4e58a9a7bbaab9cb$export$719c70722b10e5ff;
var $4e58a9a7bbaab9cb$export$ab1029bcae9ddb4a;
var $4e58a9a7bbaab9cb$export$8916d2c8119541bb;
var $4e58a9a7bbaab9cb$export$d6b40c95035461c7;
var $4e58a9a7bbaab9cb$export$91115bdd8709945f;
var $4e58a9a7bbaab9cb$export$9e55760d3282e08c;
var $4e58a9a7bbaab9cb$export$3dede90624df3ba9;
var $4e58a9a7bbaab9cb$export$29ae691b7de52fe3;
var $4e58a9a7bbaab9cb$export$77fa7d86f5204e8a;
var $4e58a9a7bbaab9cb$export$ee1b3e54f0441b22;
var $4e58a9a7bbaab9cb$export$b314777ae20abca9;
var $4e58a9a7bbaab9cb$export$c28c8388be0ab31a;
var $4e58a9a7bbaab9cb$export$82fbd7a2841d2484;
var $4e58a9a7bbaab9cb$export$85b9a36db797e02b;
var $4e58a9a7bbaab9cb$export$61fc7d43ac8f84b0;
var $4e58a9a7bbaab9cb$export$7843a4469d64c07e;
var $4e58a9a7bbaab9cb$export$e4ca6d7b7a6dcf9b;
var $4e58a9a7bbaab9cb$export$1391212d75b2ee65;
var $4e58a9a7bbaab9cb$export$286ca829307725c9;
var $4e58a9a7bbaab9cb$export$ab9a5985b741fa7a;
var $4e58a9a7bbaab9cb$export$983a3b5fb2f7202e;
var $4e58a9a7bbaab9cb$export$779c5fb865a0172e;
var $4e58a9a7bbaab9cb$export$571da16e28367bde;
var $4e58a9a7bbaab9cb$export$91d69c7761a17bbc;
var $4e58a9a7bbaab9cb$export$7ecc1a3b11b57dab;
var $4e58a9a7bbaab9cb$export$31039f1fbd797b9c;
var $4e58a9a7bbaab9cb$export$d70d492cd31004c0;
var $4e58a9a7bbaab9cb$export$9f77e0932fb78f72;
var $4e58a9a7bbaab9cb$export$3dea766d36a8935f;
var $4e58a9a7bbaab9cb$export$578723aef62d92f5;
var $4e58a9a7bbaab9cb$export$71aa6c912b956294;
var $4e58a9a7bbaab9cb$export$de3a4d4a0d731119;
var $4e58a9a7bbaab9cb$export$43128fadae87b74a;
var $4e58a9a7bbaab9cb$export$3f063810d7bf01bd;
var $4e58a9a7bbaab9cb$export$6953b97c7d866605;
var $4e58a9a7bbaab9cb$export$dd1bc94b04021eeb;
var $4e58a9a7bbaab9cb$export$4c7897fafd92b108;
var $4e58a9a7bbaab9cb$export$871de8747c9eaa88;
var $4e58a9a7bbaab9cb$export$e0eaf3a86c03b2ad;
var $4e58a9a7bbaab9cb$export$76dbd6ffd832405d;
var $4e58a9a7bbaab9cb$export$8960430cfd85939f;
var $4e58a9a7bbaab9cb$export$4950aa0f605343fb;
var $4e58a9a7bbaab9cb$export$18aef43295bbe906;
var $4e58a9a7bbaab9cb$export$6b9f6c0d32c093f9;
var $4e58a9a7bbaab9cb$export$5b8affa63fc6df16;
var $4e58a9a7bbaab9cb$export$bd7cfc9a42b8a412;
var $4e58a9a7bbaab9cb$export$c1fc905202bced53;
var $4e58a9a7bbaab9cb$export$96ec731ed4dcb222;
var $4e58a9a7bbaab9cb$export$1364843af8d5a963;
var $4e58a9a7bbaab9cb$export$9007f49c319d1ac7;
var $4e58a9a7bbaab9cb$export$5fba66d61591f42;
var $4e58a9a7bbaab9cb$export$8f9d79d42bff1aac;
var $4e58a9a7bbaab9cb$export$b29f828819edca8d;
var $4e58a9a7bbaab9cb$export$c44985b87d605eff;
var $4e58a9a7bbaab9cb$export$89b472e03be495df;
var $4e58a9a7bbaab9cb$export$16ae46fda9567053;
var $4e58a9a7bbaab9cb$export$42d9b6b38c68d989;
var $4e58a9a7bbaab9cb$export$1f3342bf81d92d52;
var $4e58a9a7bbaab9cb$export$236c05de452bec2;
var $4e58a9a7bbaab9cb$export$533b26079ad0b4b;
var $4e58a9a7bbaab9cb$export$76d90c956114f2c2;
var $4e58a9a7bbaab9cb$export$b39ac5b4ffd1415a;
var $4e58a9a7bbaab9cb$export$9369b12211e1fce4;
var $4e58a9a7bbaab9cb$export$1281551253cfee02;
var $4e58a9a7bbaab9cb$export$18d0766d894cba0c;
var $4e58a9a7bbaab9cb$export$4812e460280c6ef2;
var $4e58a9a7bbaab9cb$export$fe33c7b2002d97b0;
var $4e58a9a7bbaab9cb$export$c87d910e63d22ed6;
var $4e58a9a7bbaab9cb$export$d0a07e60ae428313;
var $4e58a9a7bbaab9cb$export$ed80d9de1d9df928;
var $4e58a9a7bbaab9cb$export$db61d692014e534e;
var $4e58a9a7bbaab9cb$export$863d7ca51b416cee;
var $4e58a9a7bbaab9cb$export$955fc4a6c4be454d;
var $4e58a9a7bbaab9cb$export$635f6273df29ea1c;
var $4e58a9a7bbaab9cb$export$facc584867c26fde;
var $4e58a9a7bbaab9cb$export$175dedd748069215;
var $4e58a9a7bbaab9cb$export$a4fe86229b0e9bdd;
var $4e58a9a7bbaab9cb$export$6a45284a4b0bf33a;
var $4e58a9a7bbaab9cb$export$9f6ea8e48bc26eab;
var $4e58a9a7bbaab9cb$export$a439dc30c845238;
var $4e58a9a7bbaab9cb$export$b7df5d561049483a;
var $4e58a9a7bbaab9cb$export$1b47ad771ce5af5e;
var $4e58a9a7bbaab9cb$export$ac8dfd3a7ad06e80;
var $4e58a9a7bbaab9cb$export$9384c7afe4015e42;
var $4e58a9a7bbaab9cb$export$3f23594af5f37336;
var $4e58a9a7bbaab9cb$export$de363e709c412c8a;
var $4e58a9a7bbaab9cb$export$4efe28f192921dd4;
var $4e58a9a7bbaab9cb$export$1a539c8b2950ab40;
var $4e58a9a7bbaab9cb$export$83e74882c5df8fe1;
var $4e58a9a7bbaab9cb$export$86fe999fba7953f2;
var $4e58a9a7bbaab9cb$export$fc00ee57782020aa;
var $4e58a9a7bbaab9cb$export$45b10814cc054894;
var $4e58a9a7bbaab9cb$export$8291e5b88f90ce4;
var $4e58a9a7bbaab9cb$export$f3a19e933f377396;
var $4e58a9a7bbaab9cb$export$1284415effa79ee0;
var $4e58a9a7bbaab9cb$export$3182be990e0eeaad;
var $4e58a9a7bbaab9cb$export$6a5dea797879f644;
var $4e58a9a7bbaab9cb$export$d449030e5c10edf7;
var $4e58a9a7bbaab9cb$export$8901015135f2fb22;
var $4e58a9a7bbaab9cb$export$adddb6a2fa3864e9;
"use strict";

var $620jj = parcelRequire("620jj");
$4e58a9a7bbaab9cb$export$d779b02e6b68c3e8 = $620jj.audit;

var $kBaGQ = parcelRequire("kBaGQ");
$4e58a9a7bbaab9cb$export$719c70722b10e5ff = $kBaGQ.auditTime;

var $7Wi5u = parcelRequire("7Wi5u");
$4e58a9a7bbaab9cb$export$ab1029bcae9ddb4a = $7Wi5u.buffer;

var $btX5F = parcelRequire("btX5F");
$4e58a9a7bbaab9cb$export$8916d2c8119541bb = $btX5F.bufferCount;

var $donj9 = parcelRequire("donj9");
$4e58a9a7bbaab9cb$export$d6b40c95035461c7 = $donj9.bufferTime;

var $flD5n = parcelRequire("flD5n");
$4e58a9a7bbaab9cb$export$91115bdd8709945f = $flD5n.bufferToggle;

var $jnxYA = parcelRequire("jnxYA");
$4e58a9a7bbaab9cb$export$9e55760d3282e08c = $jnxYA.bufferWhen;

var $lSkkn = parcelRequire("lSkkn");
$4e58a9a7bbaab9cb$export$3dede90624df3ba9 = $lSkkn.catchError;

var $l6d2m = parcelRequire("l6d2m");
$4e58a9a7bbaab9cb$export$29ae691b7de52fe3 = $l6d2m.combineAll;

var $4SeQD = parcelRequire("4SeQD");
$4e58a9a7bbaab9cb$export$77fa7d86f5204e8a = $4SeQD.combineLatest;

var $9U7Iv = parcelRequire("9U7Iv");
$4e58a9a7bbaab9cb$export$ee1b3e54f0441b22 = $9U7Iv.concat;

var $jfCUi = parcelRequire("jfCUi");
$4e58a9a7bbaab9cb$export$b314777ae20abca9 = $jfCUi.concatAll;

var $c4lxx = parcelRequire("c4lxx");
$4e58a9a7bbaab9cb$export$c28c8388be0ab31a = $c4lxx.concatMap;

var $6kB8h = parcelRequire("6kB8h");
$4e58a9a7bbaab9cb$export$82fbd7a2841d2484 = $6kB8h.concatMapTo;

var $8ARP1 = parcelRequire("8ARP1");
$4e58a9a7bbaab9cb$export$85b9a36db797e02b = $8ARP1.count;

var $g6ErV = parcelRequire("g6ErV");
$4e58a9a7bbaab9cb$export$61fc7d43ac8f84b0 = $g6ErV.debounce;

var $lmNHo = parcelRequire("lmNHo");
$4e58a9a7bbaab9cb$export$7843a4469d64c07e = $lmNHo.debounceTime;

var $k5Foi = parcelRequire("k5Foi");
$4e58a9a7bbaab9cb$export$e4ca6d7b7a6dcf9b = $k5Foi.defaultIfEmpty;

var $dgT9w = parcelRequire("dgT9w");
$4e58a9a7bbaab9cb$export$1391212d75b2ee65 = $dgT9w.delay;

var $50lVf = parcelRequire("50lVf");
$4e58a9a7bbaab9cb$export$286ca829307725c9 = $50lVf.delayWhen;

var $eea4V = parcelRequire("eea4V");
$4e58a9a7bbaab9cb$export$ab9a5985b741fa7a = $eea4V.dematerialize;

var $EoR3N = parcelRequire("EoR3N");
$4e58a9a7bbaab9cb$export$983a3b5fb2f7202e = $EoR3N.distinct;

var $lPqv7 = parcelRequire("lPqv7");
$4e58a9a7bbaab9cb$export$779c5fb865a0172e = $lPqv7.distinctUntilChanged;

var $ffjUk = parcelRequire("ffjUk");
$4e58a9a7bbaab9cb$export$571da16e28367bde = $ffjUk.distinctUntilKeyChanged;

var $giEnQ = parcelRequire("giEnQ");
$4e58a9a7bbaab9cb$export$91d69c7761a17bbc = $giEnQ.elementAt;

var $kSIv6 = parcelRequire("kSIv6");
$4e58a9a7bbaab9cb$export$7ecc1a3b11b57dab = $kSIv6.every;

var $9WMCN = parcelRequire("9WMCN");
$4e58a9a7bbaab9cb$export$31039f1fbd797b9c = $9WMCN.exhaust;

var $cDQb0 = parcelRequire("cDQb0");
$4e58a9a7bbaab9cb$export$d70d492cd31004c0 = $cDQb0.exhaustMap;

var $jr4BH = parcelRequire("jr4BH");
$4e58a9a7bbaab9cb$export$9f77e0932fb78f72 = $jr4BH.expand;

var $2alSH = parcelRequire("2alSH");
$4e58a9a7bbaab9cb$export$3dea766d36a8935f = $2alSH.filter;

var $i0OUJ = parcelRequire("i0OUJ");
$4e58a9a7bbaab9cb$export$578723aef62d92f5 = $i0OUJ.finalize;

var $gka91 = parcelRequire("gka91");
$4e58a9a7bbaab9cb$export$71aa6c912b956294 = $gka91.find;

var $dEmYk = parcelRequire("dEmYk");
$4e58a9a7bbaab9cb$export$de3a4d4a0d731119 = $dEmYk.findIndex;

var $eInEH = parcelRequire("eInEH");
$4e58a9a7bbaab9cb$export$43128fadae87b74a = $eInEH.first;

var $fmsS1 = parcelRequire("fmsS1");
$4e58a9a7bbaab9cb$export$3f063810d7bf01bd = $fmsS1.groupBy;

var $2J6Du = parcelRequire("2J6Du");
$4e58a9a7bbaab9cb$export$6953b97c7d866605 = $2J6Du.ignoreElements;

var $irbCR = parcelRequire("irbCR");
$4e58a9a7bbaab9cb$export$dd1bc94b04021eeb = $irbCR.isEmpty;

var $aJXfP = parcelRequire("aJXfP");
$4e58a9a7bbaab9cb$export$4c7897fafd92b108 = $aJXfP.last;

var $4KOmc = parcelRequire("4KOmc");
$4e58a9a7bbaab9cb$export$871de8747c9eaa88 = $4KOmc.map;

var $hqSe7 = parcelRequire("hqSe7");
$4e58a9a7bbaab9cb$export$e0eaf3a86c03b2ad = $hqSe7.mapTo;

var $ckxgf = parcelRequire("ckxgf");
$4e58a9a7bbaab9cb$export$76dbd6ffd832405d = $ckxgf.materialize;

var $dfZRS = parcelRequire("dfZRS");
$4e58a9a7bbaab9cb$export$8960430cfd85939f = $dfZRS.max;

var $3TWuV = parcelRequire("3TWuV");
$4e58a9a7bbaab9cb$export$4950aa0f605343fb = $3TWuV.merge;

var $x9PRW = parcelRequire("x9PRW");
$4e58a9a7bbaab9cb$export$18aef43295bbe906 = $x9PRW.mergeAll;

var $3kOhX = parcelRequire("3kOhX");
$4e58a9a7bbaab9cb$export$6b9f6c0d32c093f9 = $3kOhX.mergeMap;

var $3kOhX = parcelRequire("3kOhX");
$4e58a9a7bbaab9cb$export$5b8affa63fc6df16 = $3kOhX.mergeMap;

var $iVznV = parcelRequire("iVznV");
$4e58a9a7bbaab9cb$export$bd7cfc9a42b8a412 = $iVznV.mergeMapTo;

var $88WL2 = parcelRequire("88WL2");
$4e58a9a7bbaab9cb$export$c1fc905202bced53 = $88WL2.mergeScan;

var $ccmvW = parcelRequire("ccmvW");
$4e58a9a7bbaab9cb$export$96ec731ed4dcb222 = $ccmvW.min;

var $67LBu = parcelRequire("67LBu");
$4e58a9a7bbaab9cb$export$1364843af8d5a963 = $67LBu.multicast;

var $aLrOR = parcelRequire("aLrOR");
$4e58a9a7bbaab9cb$export$9007f49c319d1ac7 = $aLrOR.observeOn;

var $cimxX = parcelRequire("cimxX");
$4e58a9a7bbaab9cb$export$5fba66d61591f42 = $cimxX.onErrorResumeNext;

var $hTZ3K = parcelRequire("hTZ3K");
$4e58a9a7bbaab9cb$export$8f9d79d42bff1aac = $hTZ3K.pairwise;

var $3uzZC = parcelRequire("3uzZC");
$4e58a9a7bbaab9cb$export$b29f828819edca8d = $3uzZC.partition;

var $5tLxm = parcelRequire("5tLxm");
$4e58a9a7bbaab9cb$export$c44985b87d605eff = $5tLxm.pluck;

var $1Xyx2 = parcelRequire("1Xyx2");
$4e58a9a7bbaab9cb$export$89b472e03be495df = $1Xyx2.publish;

var $9svvu = parcelRequire("9svvu");
$4e58a9a7bbaab9cb$export$16ae46fda9567053 = $9svvu.publishBehavior;

var $ko7NX = parcelRequire("ko7NX");
$4e58a9a7bbaab9cb$export$42d9b6b38c68d989 = $ko7NX.publishLast;

var $3Y92z = parcelRequire("3Y92z");
$4e58a9a7bbaab9cb$export$1f3342bf81d92d52 = $3Y92z.publishReplay;

var $cvJcz = parcelRequire("cvJcz");
$4e58a9a7bbaab9cb$export$236c05de452bec2 = $cvJcz.race;

var $bXSND = parcelRequire("bXSND");
$4e58a9a7bbaab9cb$export$533b26079ad0b4b = $bXSND.reduce;

var $i7MDh = parcelRequire("i7MDh");
$4e58a9a7bbaab9cb$export$76d90c956114f2c2 = $i7MDh.repeat;

var $fGAAo = parcelRequire("fGAAo");
$4e58a9a7bbaab9cb$export$b39ac5b4ffd1415a = $fGAAo.repeatWhen;

var $6A4Er = parcelRequire("6A4Er");
$4e58a9a7bbaab9cb$export$9369b12211e1fce4 = $6A4Er.retry;

var $cMKhe = parcelRequire("cMKhe");
$4e58a9a7bbaab9cb$export$1281551253cfee02 = $cMKhe.retryWhen;

var $65yBJ = parcelRequire("65yBJ");
$4e58a9a7bbaab9cb$export$18d0766d894cba0c = $65yBJ.refCount;

var $lmAP3 = parcelRequire("lmAP3");
$4e58a9a7bbaab9cb$export$4812e460280c6ef2 = $lmAP3.sample;

var $frUcu = parcelRequire("frUcu");
$4e58a9a7bbaab9cb$export$fe33c7b2002d97b0 = $frUcu.sampleTime;

var $eAuN3 = parcelRequire("eAuN3");
$4e58a9a7bbaab9cb$export$c87d910e63d22ed6 = $eAuN3.scan;

var $3Qmjh = parcelRequire("3Qmjh");
$4e58a9a7bbaab9cb$export$d0a07e60ae428313 = $3Qmjh.sequenceEqual;

var $gwuHf = parcelRequire("gwuHf");
$4e58a9a7bbaab9cb$export$ed80d9de1d9df928 = $gwuHf.share;

var $hoasZ = parcelRequire("hoasZ");
$4e58a9a7bbaab9cb$export$db61d692014e534e = $hoasZ.shareReplay;

var $3CO7U = parcelRequire("3CO7U");
$4e58a9a7bbaab9cb$export$863d7ca51b416cee = $3CO7U.single;

var $4NY5O = parcelRequire("4NY5O");
$4e58a9a7bbaab9cb$export$955fc4a6c4be454d = $4NY5O.skip;

var $eRCG8 = parcelRequire("eRCG8");
$4e58a9a7bbaab9cb$export$635f6273df29ea1c = $eRCG8.skipLast;

var $lOfMb = parcelRequire("lOfMb");
$4e58a9a7bbaab9cb$export$facc584867c26fde = $lOfMb.skipUntil;

var $9aVxy = parcelRequire("9aVxy");
$4e58a9a7bbaab9cb$export$175dedd748069215 = $9aVxy.skipWhile;

var $lhs6h = parcelRequire("lhs6h");
$4e58a9a7bbaab9cb$export$a4fe86229b0e9bdd = $lhs6h.startWith;

var $xN6ty = parcelRequire("xN6ty");
$4e58a9a7bbaab9cb$export$6a45284a4b0bf33a = $xN6ty.switchAll;

var $dJlfH = parcelRequire("dJlfH");
$4e58a9a7bbaab9cb$export$9f6ea8e48bc26eab = $dJlfH.switchMap;

var $1MPmh = parcelRequire("1MPmh");
$4e58a9a7bbaab9cb$export$a439dc30c845238 = $1MPmh.switchMapTo;

var $kwz1F = parcelRequire("kwz1F");
$4e58a9a7bbaab9cb$export$b7df5d561049483a = $kwz1F.take;

var $kkovN = parcelRequire("kkovN");
$4e58a9a7bbaab9cb$export$1b47ad771ce5af5e = $kkovN.takeLast;

var $h1DVk = parcelRequire("h1DVk");
$4e58a9a7bbaab9cb$export$ac8dfd3a7ad06e80 = $h1DVk.takeUntil;

var $5WpS6 = parcelRequire("5WpS6");
$4e58a9a7bbaab9cb$export$9384c7afe4015e42 = $5WpS6.takeWhile;

var $Ap2W5 = parcelRequire("Ap2W5");
$4e58a9a7bbaab9cb$export$3f23594af5f37336 = $Ap2W5.tap;

var $gX0bT = parcelRequire("gX0bT");
$4e58a9a7bbaab9cb$export$de363e709c412c8a = $gX0bT.throttle;

var $fXHrt = parcelRequire("fXHrt");
$4e58a9a7bbaab9cb$export$4efe28f192921dd4 = $fXHrt.throttleTime;

var $9skuk = parcelRequire("9skuk");
$4e58a9a7bbaab9cb$export$1a539c8b2950ab40 = $9skuk.timeInterval;

var $3PFfe = parcelRequire("3PFfe");
$4e58a9a7bbaab9cb$export$83e74882c5df8fe1 = $3PFfe.timeout;

var $46MUI = parcelRequire("46MUI");
$4e58a9a7bbaab9cb$export$86fe999fba7953f2 = $46MUI.timeoutWith;

var $9jiVH = parcelRequire("9jiVH");
$4e58a9a7bbaab9cb$export$fc00ee57782020aa = $9jiVH.timestamp;

var $30nnw = parcelRequire("30nnw");
$4e58a9a7bbaab9cb$export$45b10814cc054894 = $30nnw.toArray;

var $dgqxI = parcelRequire("dgqxI");
$4e58a9a7bbaab9cb$export$8291e5b88f90ce4 = $dgqxI.window;

var $dpbV4 = parcelRequire("dpbV4");
$4e58a9a7bbaab9cb$export$f3a19e933f377396 = $dpbV4.windowCount;

var $4uUSK = parcelRequire("4uUSK");
$4e58a9a7bbaab9cb$export$1284415effa79ee0 = $4uUSK.windowTime;

var $1mF7f = parcelRequire("1mF7f");
$4e58a9a7bbaab9cb$export$3182be990e0eeaad = $1mF7f.windowToggle;

var $5yvNS = parcelRequire("5yvNS");
$4e58a9a7bbaab9cb$export$6a5dea797879f644 = $5yvNS.windowWhen;

var $6aRJ7 = parcelRequire("6aRJ7");
$4e58a9a7bbaab9cb$export$d449030e5c10edf7 = $6aRJ7.withLatestFrom;

var $4mSt5 = parcelRequire("4mSt5");
$4e58a9a7bbaab9cb$export$8901015135f2fb22 = $4mSt5.zip;

var $lPsda = parcelRequire("lPsda");
$4e58a9a7bbaab9cb$export$adddb6a2fa3864e9 = $lPsda.zipAll;

});


parcelRegister("eJ2p7", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $25b0acb722c2e447$export$c3902030a5d4d47a);
$parcel$export(module.exports, "sendNewSignupLinkEpic", () => $25b0acb722c2e447$export$5566cb2a1dee7448);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $jbdta = parcelRequire("jbdta");

var $6tjxC = parcelRequire("6tjxC");
parcelRequire("23jTe");
var $bAYOu = parcelRequire("bAYOu");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");

var $fASm6 = parcelRequire("fASm6");
const $25b0acb722c2e447$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $bAYOu.COMPLETE_SIGNUP)).mergeMap((completeSignupAction)=>{
        const { jwtToken: jwtToken, fullName: fullName, password: password, email: email, contactAdminsFormEnabled: contactAdminsFormEnabled, continueParam: continueParam } = completeSignupAction.payload;
        return (0, $jbdta.completeSignup)(jwtToken, fullName, password).flatMap(()=>{
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $bAYOu.completeSignupSuccess)()), (0, $jFk35.Observable).of((0, $6oW6S.loginAttempt)({
                email: email,
                password: password,
                continueParam: continueParam ?? null
            })));
        }).catch((error)=>{
            const parsedError = (0, $fASm6.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $jFk35.Observable).of((0, $bAYOu.completeSignupFailure)(parsedError));
        });
    });
};
const $25b0acb722c2e447$export$5566cb2a1dee7448 = (action$)=>{
    return action$.ofType((0, $bAYOu.SEND_NEW_SIGNUP_LINK)).mergeMap((sendNewSignupLinkAction)=>{
        const { email: email, portalId: portalId } = sendNewSignupLinkAction.payload;
        return (0, $6tjxC.resendValidationEmail)(email, portalId, undefined).map(()=>{
            return (0, $bAYOu.sendNewSignupLinkSuccess)();
        }).catch((error)=>{
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $bAYOu.sendNewSignupLinkFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("5kfOu", function(module, exports) {
$parcel$export(module.exports, "HANDLE_AJAX_ERROR", () => $6a9cddb35daf6ecf$export$a7c57e52be964b91);
$parcel$export(module.exports, "SHOW_ERROR_FLAG", () => $6a9cddb35daf6ecf$export$2b6b999b3eafcf24);
$parcel$export(module.exports, "SHOW_WARNING_FLAG", () => $6a9cddb35daf6ecf$export$4f0f0fac05b2a93f);
$parcel$export(module.exports, "SHOW_SUCCESS_FLAG", () => $6a9cddb35daf6ecf$export$c911d7565dd7a733);
$parcel$export(module.exports, "SHOW_BOLD_APPEARANCE_FLAG", () => $6a9cddb35daf6ecf$export$8eec0f3e4bc42e5c);
$parcel$export(module.exports, "DISMISS_FLAG", () => $6a9cddb35daf6ecf$export$1eb56620df104bf);
$parcel$export(module.exports, "handleAjaxError", () => $6a9cddb35daf6ecf$export$1245fce1755f5ec2);
$parcel$export(module.exports, "showErrorFlag", () => $6a9cddb35daf6ecf$export$dfa2148cdb92917d);
$parcel$export(module.exports, "showWarningFlag", () => $6a9cddb35daf6ecf$export$9475ea83c9ea0d1c);
$parcel$export(module.exports, "showSuccessFlag", () => $6a9cddb35daf6ecf$export$fef8478a2c810f18);
$parcel$export(module.exports, "showBoldAppearanceFlag", () => $6a9cddb35daf6ecf$export$4231a8f3b05ab067);
$parcel$export(module.exports, "dismissFlag", () => $6a9cddb35daf6ecf$export$900a08a292ad23cd);
const $6a9cddb35daf6ecf$export$a7c57e52be964b91 = 'state.ui.flags.HANDLE_AJAX_ERROR';
const $6a9cddb35daf6ecf$export$2b6b999b3eafcf24 = 'state.ui.flags.SHOW_ERROR_FLAG';
const $6a9cddb35daf6ecf$export$4f0f0fac05b2a93f = 'state.ui.flags.SHOW_WARNING_FLAG';
const $6a9cddb35daf6ecf$export$c911d7565dd7a733 = 'state.ui.flags.SHOW_SUCCESS_FLAG';
const $6a9cddb35daf6ecf$export$8eec0f3e4bc42e5c = 'state.ui.flags.SHOW_BOLD_APPEARANCE_FLAG';
const $6a9cddb35daf6ecf$export$1eb56620df104bf = 'state.ui.flags.DISMISS_FLAG';
const $6a9cddb35daf6ecf$export$1245fce1755f5ec2 = (error)=>({
        type: $6a9cddb35daf6ecf$export$a7c57e52be964b91,
        payload: {
            error: error
        }
    });
const $6a9cddb35daf6ecf$export$dfa2148cdb92917d = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $6a9cddb35daf6ecf$export$2b6b999b3eafcf24,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $6a9cddb35daf6ecf$export$9475ea83c9ea0d1c = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $6a9cddb35daf6ecf$export$4f0f0fac05b2a93f,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $6a9cddb35daf6ecf$export$fef8478a2c810f18 = (titleMessage, titleMessageValues, descriptionMessage, actions, descriptionMessageValues)=>({
        type: $6a9cddb35daf6ecf$export$c911d7565dd7a733,
        payload: {
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            actions: actions
        }
    });
const $6a9cddb35daf6ecf$export$4231a8f3b05ab067 = (appearance, titleMessage, titleMessageValues, descriptionMessage, descriptionMessageValues, actions, dismissActionValue)=>({
        type: $6a9cddb35daf6ecf$export$8eec0f3e4bc42e5c,
        payload: {
            appearance: appearance,
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            dismissActionValue: dismissActionValue,
            actions: actions
        }
    });
const $6a9cddb35daf6ecf$export$900a08a292ad23cd = (flagId)=>({
        type: $6a9cddb35daf6ecf$export$1eb56620df104bf,
        payload: {
            flagId: flagId
        }
    });

});

parcelRegister("jbdta", function(module, exports) {
$parcel$export(module.exports, "completeSignup", () => $58421df02214f29b$export$96271c6a96268661);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $58421df02214f29b$export$96271c6a96268661 = (token, fullName, password, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/complete-signup?jwt=${token}`;
    const body = $58421df02214f29b$var$createBody(fullName, password);
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};
const $58421df02214f29b$var$createBody = (fullName, password)=>{
    return JSON.stringify({
        fullName: fullName,
        password: password
    });
};

});

parcelRegister("6tjxC", function(module, exports) {
$parcel$export(module.exports, "signUp", () => $978c26ba0d1169de$export$cf64224bcd829024);
$parcel$export(module.exports, "resendValidationEmail", () => $978c26ba0d1169de$export$b53bc6c531462e2c);

var $bTjsX = parcelRequire("bTjsX");

var $6LH8a = parcelRequire("6LH8a");

var $diqlM = parcelRequire("diqlM");
const $978c26ba0d1169de$var$baseSignupBody = (email, portalId, redirectUrl)=>({
        email: email,
        signUpContext: {
            portalId: portalId,
            redirectUrl: redirectUrl,
            helpCenterAri: (0, $6LH8a.getHelpCenterAri)()
        }
    });
const $978c26ba0d1169de$export$cf64224bcd829024 = async (email, secondaryEmail, portalId, redirectUrl, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/signup`;
    const body = {
        ...$978c26ba0d1169de$var$baseSignupBody(email, portalId, redirectUrl),
        secondaryEmail: secondaryEmail,
        usingNewUi: true
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise().catch((e)=>Promise.reject(e));
};
const $978c26ba0d1169de$export$b53bc6c531462e2c = (email, portalId, redirectUrl, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/send-validation-email`;
    const body = $978c26ba0d1169de$var$baseSignupBody(email, portalId, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("23jTe", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => (parcelRequire("bAYOu")).FETCH_COMPLETE_SIGNUP_MODEL);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => (parcelRequire("bAYOu")).FETCH_COMPLETE_SIGNUP_SUCCESS);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("bAYOu")).FETCH_COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => (parcelRequire("bAYOu")).COMPLETE_SIGNUP);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("bAYOu")).COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => (parcelRequire("bAYOu")).SEND_NEW_SIGNUP_LINK);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => (parcelRequire("bAYOu")).SEND_NEW_SIGNUP_LINK_SUCCESS);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => (parcelRequire("bAYOu")).SEND_NEW_SIGNUP_LINK_FAILURE);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => (parcelRequire("bAYOu")).fetchCompleteSignupModel);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => (parcelRequire("bAYOu")).fetchCompleteSignupSuccess);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => (parcelRequire("bAYOu")).fetchCompleteSignupFailure);
$parcel$export(module.exports, "completeSignup", () => (parcelRequire("bAYOu")).completeSignup);
$parcel$export(module.exports, "completeSignupSuccess", () => (parcelRequire("bAYOu")).completeSignupSuccess);
$parcel$export(module.exports, "completeSignupFailure", () => (parcelRequire("bAYOu")).completeSignupFailure);
$parcel$export(module.exports, "sendNewSignupLink", () => (parcelRequire("bAYOu")).sendNewSignupLink);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => (parcelRequire("bAYOu")).sendNewSignupLinkSuccess);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => (parcelRequire("bAYOu")).sendNewSignupLinkFailure);

var $bAYOu = parcelRequire("bAYOu");

});
parcelRegister("bAYOu", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => $b7fd953d98b06835$export$a57d1f559f8199cb);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => $b7fd953d98b06835$export$c991c467f18c47c4);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => $b7fd953d98b06835$export$af520912b7d6706d);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => $b7fd953d98b06835$export$53ff245dddbf796c);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => $b7fd953d98b06835$export$88f081a1fe475d4e);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => $b7fd953d98b06835$export$d76ccb8fbc57714);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => $b7fd953d98b06835$export$50cb33d74bd8c2e4);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => $b7fd953d98b06835$export$10f6ec3c86fb611d);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => $b7fd953d98b06835$export$22acc17286f74b59);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => $b7fd953d98b06835$export$93e33f94b1c7e30b);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => $b7fd953d98b06835$export$7559c63f3aa1d23b);
$parcel$export(module.exports, "completeSignup", () => $b7fd953d98b06835$export$96271c6a96268661);
$parcel$export(module.exports, "completeSignupSuccess", () => $b7fd953d98b06835$export$854f5c75b16a30e1);
$parcel$export(module.exports, "completeSignupFailure", () => $b7fd953d98b06835$export$76e49af38e42140f);
$parcel$export(module.exports, "sendNewSignupLink", () => $b7fd953d98b06835$export$bc99093a83dfa75);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => $b7fd953d98b06835$export$1277dcc40c57fab3);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => $b7fd953d98b06835$export$f5f09020b407e701);

var $dv0hN = parcelRequire("dv0hN");
const $b7fd953d98b06835$export$a57d1f559f8199cb = 'epic.model.FETCH_COMPLETE_SIGNUP_MODEL';
const $b7fd953d98b06835$export$c991c467f18c47c4 = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_SUCCESS';
const $b7fd953d98b06835$export$af520912b7d6706d = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_FAILURE';
const $b7fd953d98b06835$export$53ff245dddbf796c = 'state.ui.invited.sign.up.COMPLETE_SIGNUP';
const $b7fd953d98b06835$export$e7a1360e631dd35b = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_SUCCESS';
const $b7fd953d98b06835$export$88f081a1fe475d4e = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_FAILURE';
const $b7fd953d98b06835$export$d76ccb8fbc57714 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK';
const $b7fd953d98b06835$export$50cb33d74bd8c2e4 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_SUCCESS';
const $b7fd953d98b06835$export$10f6ec3c86fb611d = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_FAILURE';
const $b7fd953d98b06835$export$22acc17286f74b59 = (0, $dv0hN.buildModelsActionCreator)($b7fd953d98b06835$export$a57d1f559f8199cb, 'completeSignup');
const $b7fd953d98b06835$export$93e33f94b1c7e30b = (completeSignupResponse)=>({
        type: $b7fd953d98b06835$export$c991c467f18c47c4,
        payload: completeSignupResponse
    });
const $b7fd953d98b06835$export$7559c63f3aa1d23b = (error)=>({
        type: $b7fd953d98b06835$export$af520912b7d6706d,
        payload: {
            error: error
        }
    });
const $b7fd953d98b06835$export$96271c6a96268661 = (jwtToken, fullName, password, email, contactAdminsFormEnabled, continueParam)=>({
        type: $b7fd953d98b06835$export$53ff245dddbf796c,
        payload: {
            jwtToken: jwtToken,
            fullName: fullName,
            password: password,
            email: email,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            continueParam: continueParam
        }
    });
const $b7fd953d98b06835$export$854f5c75b16a30e1 = ()=>({
        type: $b7fd953d98b06835$export$e7a1360e631dd35b
    });
const $b7fd953d98b06835$export$76e49af38e42140f = (error)=>({
        type: $b7fd953d98b06835$export$88f081a1fe475d4e,
        payload: {
            error: error
        }
    });
const $b7fd953d98b06835$export$bc99093a83dfa75 = (email, portalId)=>({
        type: $b7fd953d98b06835$export$d76ccb8fbc57714,
        payload: {
            email: email,
            portalId: portalId
        }
    });
const $b7fd953d98b06835$export$1277dcc40c57fab3 = ()=>({
        type: $b7fd953d98b06835$export$50cb33d74bd8c2e4
    });
const $b7fd953d98b06835$export$f5f09020b407e701 = ()=>({
        type: $b7fd953d98b06835$export$10f6ec3c86fb611d
    });

});
parcelRegister("dv0hN", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $f66fa859c057781b$export$9f8a38b5e77ac29);
const $f66fa859c057781b$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});



parcelRegister("9ipL7", function(module, exports) {
$parcel$export(module.exports, "changeEmailInput", () => (parcelRequire("6oW6S")).changeEmailInput);
$parcel$export(module.exports, "checkLoginAction", () => (parcelRequire("6oW6S")).checkLoginAction);
$parcel$export(module.exports, "checkLoginActionSuccess", () => (parcelRequire("6oW6S")).checkLoginActionSuccess);
$parcel$export(module.exports, "checkLoginActionFailure", () => (parcelRequire("6oW6S")).checkLoginActionFailure);
$parcel$export(module.exports, "fetchLoginSuccess", () => (parcelRequire("6oW6S")).fetchLoginSuccess);
$parcel$export(module.exports, "fetchLoginFailure", () => (parcelRequire("6oW6S")).fetchLoginFailure);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("6oW6S")).forgotPassword);
$parcel$export(module.exports, "createPassword", () => (parcelRequire("6oW6S")).createPassword);
$parcel$export(module.exports, "createPasswordSuccess", () => (parcelRequire("6oW6S")).createPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("6oW6S")).forgotPasswordSuccess);
$parcel$export(module.exports, "loginAttempt", () => (parcelRequire("6oW6S")).loginAttempt);
$parcel$export(module.exports, "loginAttemptSuccess", () => (parcelRequire("6oW6S")).loginAttemptSuccess);
$parcel$export(module.exports, "loginAttemptFailure", () => (parcelRequire("6oW6S")).loginAttemptFailure);
$parcel$export(module.exports, "resetLogin", () => (parcelRequire("6oW6S")).resetLogin);
$parcel$export(module.exports, "exitTestModeAction", () => (parcelRequire("6oW6S")).exitTestModeAction);
$parcel$export(module.exports, "caSsoTestModeFailure", () => (parcelRequire("6oW6S")).caSsoTestModeFailure);
$parcel$export(module.exports, "loginConsentFailure", () => (parcelRequire("6oW6S")).loginConsentFailure);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => (parcelRequire("6oW6S")).CHANGE_EMAIL_INPUT);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => (parcelRequire("6oW6S")).CHECK_LOGIN_ACTION);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => (parcelRequire("6oW6S")).CHECK_LOGIN_ACTION_FAILURE);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => (parcelRequire("6oW6S")).CHECK_LOGIN_ACTION_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => (parcelRequire("6oW6S")).FETCH_LOGIN_FAILURE);
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => (parcelRequire("6oW6S")).FETCH_LOGIN_SUCCESS);
$parcel$export(module.exports, "CREATE_PASSWORD", () => (parcelRequire("6oW6S")).CREATE_PASSWORD);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => (parcelRequire("6oW6S")).CREATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => (parcelRequire("6oW6S")).FORGOT_PASSWORD);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("6oW6S")).FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => (parcelRequire("6oW6S")).FORGOT_PASSWORD_FAILURE);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => (parcelRequire("6oW6S")).LOGIN_ATTEMPT);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => (parcelRequire("6oW6S")).LOGIN_ATTEMPT_SUCCESS);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => (parcelRequire("6oW6S")).LOGIN_ATTEMPT_FAILURE);
$parcel$export(module.exports, "RESET_LOGIN", () => (parcelRequire("6oW6S")).RESET_LOGIN);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => (parcelRequire("6oW6S")).CA_SSO_TEST_MODE_FAILURE);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => (parcelRequire("6oW6S")).LOGIN_CONSENT_FAILURE);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => (parcelRequire("6oW6S")).EXIT_TEST_MODE_ACTION);

var $6oW6S = parcelRequire("6oW6S");

});
parcelRegister("6oW6S", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => $3ecb2dab6eef0e19$export$839deb1eefe4e515);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => $3ecb2dab6eef0e19$export$8cf8563c2d1c6683);
$parcel$export(module.exports, "CREATE_PASSWORD", () => $3ecb2dab6eef0e19$export$fe8137105dc1ed9);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => $3ecb2dab6eef0e19$export$66c73e13cf8b697a);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => $3ecb2dab6eef0e19$export$816b17d1322118b2);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => $3ecb2dab6eef0e19$export$f5cb563064a027ff);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => $3ecb2dab6eef0e19$export$150db551ad2bf414);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => $3ecb2dab6eef0e19$export$e479859894f5f058);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => $3ecb2dab6eef0e19$export$e70701c4dc1893e1);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => $3ecb2dab6eef0e19$export$7e8a762ed2d6f2d2);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => $3ecb2dab6eef0e19$export$f3ad885eaa1b5f72);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => $3ecb2dab6eef0e19$export$716c6a62442b28d7);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => $3ecb2dab6eef0e19$export$1c3cf2fdaea15601);
$parcel$export(module.exports, "RESET_LOGIN", () => $3ecb2dab6eef0e19$export$afec5a557a208da9);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => $3ecb2dab6eef0e19$export$98672ea6f23cc2ca);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => $3ecb2dab6eef0e19$export$cbb84f780c133cae);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => $3ecb2dab6eef0e19$export$82f99ffed31fea50);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => $3ecb2dab6eef0e19$export$daf9894dcc19911a);
$parcel$export(module.exports, "fetchLoginSuccess", () => $3ecb2dab6eef0e19$export$edced81742fba4bc);
$parcel$export(module.exports, "fetchLoginFailure", () => $3ecb2dab6eef0e19$export$d8cdd04268f89e8d);
$parcel$export(module.exports, "checkLoginAction", () => $3ecb2dab6eef0e19$export$a4840b835bebc845);
$parcel$export(module.exports, "checkLoginActionSuccess", () => $3ecb2dab6eef0e19$export$80f72fff3f8aebd3);
$parcel$export(module.exports, "checkLoginActionFailure", () => $3ecb2dab6eef0e19$export$ab186d6cbffedaab);
$parcel$export(module.exports, "loginAttempt", () => $3ecb2dab6eef0e19$export$bff2b4217ebde9c3);
$parcel$export(module.exports, "loginAttemptSuccess", () => $3ecb2dab6eef0e19$export$4b4199104faef544);
$parcel$export(module.exports, "loginAttemptFailure", () => $3ecb2dab6eef0e19$export$6df4ba6cdf3cad7f);
$parcel$export(module.exports, "forgotPassword", () => $3ecb2dab6eef0e19$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $3ecb2dab6eef0e19$export$2effc3102ad6a101);
$parcel$export(module.exports, "createPasswordSuccess", () => $3ecb2dab6eef0e19$export$dc17890d1692fbd);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $3ecb2dab6eef0e19$export$e65d2e9031cf7578);
$parcel$export(module.exports, "resetLogin", () => $3ecb2dab6eef0e19$export$9a31ad345a1aa336);
$parcel$export(module.exports, "exitTestModeAction", () => $3ecb2dab6eef0e19$export$ba564c8e35ce769d);
$parcel$export(module.exports, "changeEmailInput", () => $3ecb2dab6eef0e19$export$c55ade57a8bbcea5);
$parcel$export(module.exports, "caSsoTestModeFailure", () => $3ecb2dab6eef0e19$export$cf9ecdd9f9c734b3);
$parcel$export(module.exports, "loginConsentFailure", () => $3ecb2dab6eef0e19$export$22b3a2f6203607fa);
const $3ecb2dab6eef0e19$export$839deb1eefe4e515 = 'state.ui.login.FETCH_LOGIN_SUCCESS';
const $3ecb2dab6eef0e19$export$8cf8563c2d1c6683 = 'state.ui.login.FETCH_LOGIN_FAILURE';
const $3ecb2dab6eef0e19$export$fe8137105dc1ed9 = 'state.ui.login.CREATE_PASSWORD';
const $3ecb2dab6eef0e19$export$66c73e13cf8b697a = 'state.ui.login.CREATE_PASSWORD_SUCCESS';
const $3ecb2dab6eef0e19$export$816b17d1322118b2 = 'state.ui.login.CHECK_LOGIN_ACTION';
const $3ecb2dab6eef0e19$export$f5cb563064a027ff = 'state.ui.login.CHECK_LOGIN_ACTION_SUCCESS';
const $3ecb2dab6eef0e19$export$150db551ad2bf414 = 'state.ui.login.CHECK_LOGIN_ACTION_FAILURE';
const $3ecb2dab6eef0e19$export$e479859894f5f058 = 'state.ui.login.FORGOT_PASSWORD';
const $3ecb2dab6eef0e19$export$e70701c4dc1893e1 = 'state.ui.login.FORGOT_PASSWORD_SUCCESS';
const $3ecb2dab6eef0e19$export$7e8a762ed2d6f2d2 = 'state.ui.login.FORGOT_PASSWORD_FAILURE';
const $3ecb2dab6eef0e19$export$f3ad885eaa1b5f72 = 'state.ui.login.LOGIN_ATTEMPT';
const $3ecb2dab6eef0e19$export$716c6a62442b28d7 = 'state.ui.login.LOGIN_ATTEMPT_SUCCESS';
const $3ecb2dab6eef0e19$export$1c3cf2fdaea15601 = 'state.ui.login.LOGIN_ATTEMPT_FAILURE';
const $3ecb2dab6eef0e19$export$afec5a557a208da9 = 'state.ui.login.RESET_LOGIN';
const $3ecb2dab6eef0e19$export$98672ea6f23cc2ca = 'state.ui.login.EXIT_TEST_MODE_ACTION';
const $3ecb2dab6eef0e19$export$cbb84f780c133cae = 'state.ui.login.CHANGE_EMAIL_INPUT';
const $3ecb2dab6eef0e19$export$82f99ffed31fea50 = 'state.ui.login.CA_SSO_TEST_MODE_FAILURE';
const $3ecb2dab6eef0e19$export$daf9894dcc19911a = 'state.ui.login.LOGIN_CONSENT_FAILURE';
const $3ecb2dab6eef0e19$export$edced81742fba4bc = (loginModel)=>({
        payload: loginModel,
        type: $3ecb2dab6eef0e19$export$839deb1eefe4e515
    });
const $3ecb2dab6eef0e19$export$d8cdd04268f89e8d = (error)=>({
        type: $3ecb2dab6eef0e19$export$8cf8563c2d1c6683,
        payload: {
            error: error
        }
    });
const $3ecb2dab6eef0e19$export$a4840b835bebc845 = (email, portalId, authData, createAnalyticsEvent)=>({
        type: $3ecb2dab6eef0e19$export$816b17d1322118b2,
        payload: {
            email: email,
            portalId: portalId,
            authData: authData,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $3ecb2dab6eef0e19$export$80f72fff3f8aebd3 = (action, authInfo)=>({
        type: $3ecb2dab6eef0e19$export$f5cb563064a027ff,
        payload: {
            action: action,
            authInfo: authInfo
        }
    });
const $3ecb2dab6eef0e19$export$ab186d6cbffedaab = (error)=>({
        type: $3ecb2dab6eef0e19$export$150db551ad2bf414,
        payload: {
            error: error
        }
    });
const $3ecb2dab6eef0e19$export$bff2b4217ebde9c3 = (payload)=>({
        payload: payload,
        type: $3ecb2dab6eef0e19$export$f3ad885eaa1b5f72
    });
const $3ecb2dab6eef0e19$export$4b4199104faef544 = (loginAttemptResponse)=>({
        type: $3ecb2dab6eef0e19$export$716c6a62442b28d7,
        payload: {
            loginAttemptResponse: loginAttemptResponse
        }
    });
const $3ecb2dab6eef0e19$export$6df4ba6cdf3cad7f = (error)=>({
        type: $3ecb2dab6eef0e19$export$1c3cf2fdaea15601,
        payload: {
            error: error
        }
    });
const $3ecb2dab6eef0e19$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>({
        type: $3ecb2dab6eef0e19$export$e479859894f5f058,
        payload: {
            resetUrl: resetUrl,
            email: email,
            redirectUrl: redirectUrl
        }
    });
const $3ecb2dab6eef0e19$export$2effc3102ad6a101 = (resetUrl, email)=>({
        type: $3ecb2dab6eef0e19$export$fe8137105dc1ed9,
        payload: {
            resetUrl: resetUrl,
            email: email
        }
    });
const $3ecb2dab6eef0e19$export$dc17890d1692fbd = ()=>({
        type: $3ecb2dab6eef0e19$export$66c73e13cf8b697a
    });
const $3ecb2dab6eef0e19$export$e65d2e9031cf7578 = ()=>({
        type: $3ecb2dab6eef0e19$export$e70701c4dc1893e1
    });
const $3ecb2dab6eef0e19$export$c82fc620622643dd = (error)=>({
        type: $3ecb2dab6eef0e19$export$7e8a762ed2d6f2d2,
        payload: {
            error: error
        }
    });
const $3ecb2dab6eef0e19$export$9a31ad345a1aa336 = (email = '')=>({
        type: $3ecb2dab6eef0e19$export$afec5a557a208da9,
        payload: {
            email: email
        }
    });
const $3ecb2dab6eef0e19$export$ba564c8e35ce769d = (email = '')=>({
        type: $3ecb2dab6eef0e19$export$98672ea6f23cc2ca,
        payload: {
            email: email
        }
    });
const $3ecb2dab6eef0e19$export$c55ade57a8bbcea5 = (email)=>({
        type: $3ecb2dab6eef0e19$export$cbb84f780c133cae,
        payload: {
            email: email
        }
    });
const $3ecb2dab6eef0e19$export$cf9ecdd9f9c734b3 = ()=>({
        type: $3ecb2dab6eef0e19$export$82f99ffed31fea50
    });
const $3ecb2dab6eef0e19$export$22b3a2f6203607fa = ()=>({
        type: $3ecb2dab6eef0e19$export$daf9894dcc19911a
    });

});


parcelRegister("fASm6", function(module, exports) {
$parcel$export(module.exports, "getFirstMessageFromJiraError", () => $50a96ca849187e21$export$63b892f0c5ffc91e);
$parcel$export(module.exports, "getJiraErrorOrDefault", () => $50a96ca849187e21$export$c3183aaaea823e43);
$parcel$export(module.exports, "getDefaultError", () => $50a96ca849187e21$export$7419e04ae130d87b);
$parcel$export(module.exports, "getJiraErrorResponse", () => $50a96ca849187e21$export$93579a27d9d34c28);
$parcel$export(module.exports, "genericError", () => $50a96ca849187e21$export$28cd364e99d3d2cb);
$parcel$export(module.exports, "getDefaultSignUpError", () => $50a96ca849187e21$export$48e9b610f790f75b);
$parcel$export(module.exports, "getDefaultCheckLoginError", () => $50a96ca849187e21$export$e35369cd8bc15322);
$parcel$export(module.exports, "isSsoTestModeError", () => $50a96ca849187e21$export$ef531073403eb96);
$parcel$export(module.exports, "getUserProfileForgotPasswordFailedError", () => $50a96ca849187e21$export$8258d31b06384bf2);

var $6UkEX = parcelRequire("6UkEX");

var $esgVk = parcelRequire("esgVk");
const $50a96ca849187e21$export$ce1888b50106d3cd = (errorResponse)=>{
    const hasError = errorResponse && errorResponse.errors;
    return hasError ? errorResponse.errors.map((error)=>error && error.errorMessage) : [];
};
const $50a96ca849187e21$export$63b892f0c5ffc91e = (errorResponse)=>{
    const errorMessages = $50a96ca849187e21$export$ce1888b50106d3cd(errorResponse);
    return errorMessages.length > 0 ? errorMessages[0] : '';
};
const $50a96ca849187e21$export$c3183aaaea823e43 = (error)=>{
    const jiraErrorMessage = $50a96ca849187e21$export$63b892f0c5ffc91e(error.response);
    if (jiraErrorMessage.length > 0) return {
        errorMessage: jiraErrorMessage
    };
    return $50a96ca849187e21$export$7419e04ae130d87b(error);
};
const $50a96ca849187e21$export$93579a27d9d34c28 = (error)=>{
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (error.response && error.response.errors) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return error.response;
    return undefined;
};
const $50a96ca849187e21$export$7419e04ae130d87b = (error)=>{
    if ($50a96ca849187e21$var$isRateLimitedError(error)) return $50a96ca849187e21$export$91ba33ab5aae4f04;
    if ($50a96ca849187e21$var$isNetworkError(error)) return $50a96ca849187e21$export$2b69dc41a4a4ae83();
    return $50a96ca849187e21$export$28cd364e99d3d2cb;
};
const $50a96ca849187e21$export$48e9b610f790f75b = (error, contactAdminsFormEnabled)=>{
    if ($50a96ca849187e21$var$isNetworkError(error)) return $50a96ca849187e21$export$2b69dc41a4a4ae83();
    return $50a96ca849187e21$export$fb8509ea6df35a83(contactAdminsFormEnabled);
};
const $50a96ca849187e21$export$e35369cd8bc15322 = (error)=>{
    const jiraErrorResponse = $50a96ca849187e21$export$93579a27d9d34c28(error);
    if (jiraErrorResponse) {
        if ($50a96ca849187e21$var$isSignupDomainBlockedError(error)) return $50a96ca849187e21$export$7528741a99bb3a62;
        if ($50a96ca849187e21$var$isEmailInvalidError(error)) return $50a96ca849187e21$export$e97b837fddbca6b3;
    } else if ($50a96ca849187e21$var$isNetworkError(error)) return $50a96ca849187e21$export$2b69dc41a4a4ae83();
    return $50a96ca849187e21$export$28cd364e99d3d2cb;
};
const $50a96ca849187e21$export$ef531073403eb96 = (error)=>$50a96ca849187e21$export$93579a27d9d34c28(error) && $50a96ca849187e21$var$isSsoTestModeFailure(error);
const $50a96ca849187e21$export$fb8509ea6df35a83 = (contactAdminsFormEnabled)=>{
    const noContactDescription = (0, $6UkEX.GenericSignUpErrorNoContactLinkDescription);
    const description = contactAdminsFormEnabled ? (0, $6UkEX.GenericSignUpErrorDescriptionUnified) : noContactDescription;
    return {
        description: description,
        title: (0, $6UkEX.GenericErrorTitle),
        action: $50a96ca849187e21$var$getGenericErrorFlagActions()
    };
};
const $50a96ca849187e21$var$isNetworkError = (errorResponse)=>errorResponse.status === 0;
const $50a96ca849187e21$var$isSignupDomainBlockedError = (errorResponse)=>{
    var _errorResponse$respon, _errorResponse$respon2;
    return errorResponse.status === 403 && (((_errorResponse$respon = errorResponse.response) === null || _errorResponse$respon === void 0 ? void 0 : _errorResponse$respon.reasonKey) === 'sd.customer.management.rest.error.customer.account.signup.blocked' || ((_errorResponse$respon2 = errorResponse.response) === null || _errorResponse$respon2 === void 0 ? void 0 : _errorResponse$respon2.reasonKey) === 'customer-signup-domain-blocked');
};
const $50a96ca849187e21$var$isEmailInvalidError = (errorResponse)=>{
    var _errorResponse$respon3;
    return errorResponse.status === 400 && ((_errorResponse$respon3 = errorResponse.response) === null || _errorResponse$respon3 === void 0 ? void 0 : _errorResponse$respon3.reasonKey) === 'signup.error.email.valid';
};
const $50a96ca849187e21$var$isSsoTestModeFailure = (errorResponse)=>{
    var _errorResponse$respon4;
    return errorResponse.status === 400 && ((_errorResponse$respon4 = errorResponse.response) === null || _errorResponse$respon4 === void 0 ? void 0 : _errorResponse$respon4.reasonKey) === 'CA_SSO_TEST_MODE_NOT_ENABLED';
};
const $50a96ca849187e21$var$isRateLimited = (errorResponse)=>errorResponse.status === 429;
const $50a96ca849187e21$var$isRateLimitedError = (errorResponse)=>{
    var _errorResponse$respon5;
    return $50a96ca849187e21$var$isRateLimited(errorResponse) && ((_errorResponse$respon5 = errorResponse.response) === null || _errorResponse$respon5 === void 0 ? void 0 : _errorResponse$respon5.reasonKey) === 'sd.email.signup.email.rate.limited';
};
const $50a96ca849187e21$var$getGenericErrorFlagActions = ()=>({
        href: (0, $esgVk.location)().href,
        content: (0, $6UkEX.GenericErrorRefreshPageAction)
    });
const $50a96ca849187e21$export$2b69dc41a4a4ae83 = ()=>$50a96ca849187e21$export$5bd59b549d90b63;
const $50a96ca849187e21$export$5bd59b549d90b63 = {
    title: (0, $6UkEX.NoNetworkTitle),
    description: (0, $6UkEX.NoNetworkDescription)
};
const $50a96ca849187e21$export$91ba33ab5aae4f04 = {
    title: (0, $6UkEX.GenericErrorTitle),
    description: (0, $6UkEX.SignupEmailResendRateLimitedDescription)
};
const $50a96ca849187e21$export$7528741a99bb3a62 = {
    title: (0, $6UkEX.SignupDomainBlockedTitle),
    description: (0, $6UkEX.SignupDomainBlockedDescription)
};
const $50a96ca849187e21$export$e97b837fddbca6b3 = {
    title: (0, $6UkEX.InvalidEmailTitle),
    description: (0, $6UkEX.InvalidEmailDescription)
};
const $50a96ca849187e21$export$28cd364e99d3d2cb = {
    title: (0, $6UkEX.GenericErrorTitle),
    description: (0, $6UkEX.GenericErrorDescription),
    action: $50a96ca849187e21$var$getGenericErrorFlagActions()
};
const $50a96ca849187e21$var$genericUserProfileForgotPasswordFailedError = {
    title: (0, $6UkEX.UserProfileForgotPasswordFailedErrorTitle),
    description: (0, $6UkEX.UserProfileForgotPasswordFailedErrorDescription)
};
const $50a96ca849187e21$export$3cd8f5c164dad65c = {
    title: (0, $6UkEX.UserProfileForgotPasswordRateLimitedErrorTitle),
    description: (0, $6UkEX.UserProfileForgotPasswordRateLimitedErrorDescription)
};
const $50a96ca849187e21$export$8258d31b06384bf2 = (error)=>{
    if ($50a96ca849187e21$var$isNetworkError(error)) return $50a96ca849187e21$export$2b69dc41a4a4ae83();
    if ($50a96ca849187e21$var$isRateLimited(error)) return $50a96ca849187e21$export$3cd8f5c164dad65c;
    return $50a96ca849187e21$var$genericUserProfileForgotPasswordFailedError;
};

});
parcelRegister("6UkEX", function(module, exports) {
$parcel$export(module.exports, "GenericErrorTitle", () => $1bcbbcf0c5395a38$export$e882af1f191f98ed);
$parcel$export(module.exports, "GenericErrorDescription", () => $1bcbbcf0c5395a38$export$435282e749b7e900);
$parcel$export(module.exports, "GenericSignUpErrorDescriptionUnified", () => $1bcbbcf0c5395a38$export$814e1ad271462eee);
$parcel$export(module.exports, "GenericSignUpErrorNoContactLinkDescription", () => $1bcbbcf0c5395a38$export$53a250c0a0614ddf);
$parcel$export(module.exports, "RefreshPageLinkText", () => $1bcbbcf0c5395a38$export$2c865db45566f3fc);
$parcel$export(module.exports, "TellUsAboutIssueLinkText", () => $1bcbbcf0c5395a38$export$4cd0b637ea791e58);
$parcel$export(module.exports, "LetUsKnowLinkText", () => $1bcbbcf0c5395a38$export$91b106f2d7a60f86);
$parcel$export(module.exports, "GenericErrorRefreshPageAction", () => $1bcbbcf0c5395a38$export$20483281c243b1a0);
$parcel$export(module.exports, "NoNetworkTitle", () => $1bcbbcf0c5395a38$export$b0cc5cbdc11d8431);
$parcel$export(module.exports, "SignupEmailResendRateLimitedDescription", () => $1bcbbcf0c5395a38$export$fdbfe2d9101e694);
$parcel$export(module.exports, "NoNetworkDescription", () => $1bcbbcf0c5395a38$export$d349948b740c510b);
$parcel$export(module.exports, "SignupDomainBlockedDescription", () => $1bcbbcf0c5395a38$export$f1af5cb5b09d8e91);
$parcel$export(module.exports, "SignupDomainBlockedTitle", () => $1bcbbcf0c5395a38$export$23a02d68ec91feaf);
$parcel$export(module.exports, "InvalidEmailTitle", () => $1bcbbcf0c5395a38$export$593b1e00f52b5f5e);
$parcel$export(module.exports, "InvalidEmailDescription", () => $1bcbbcf0c5395a38$export$82cbc81342a448dd);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorTitle", () => $1bcbbcf0c5395a38$export$6e2b8a076a84e30b);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorDescription", () => $1bcbbcf0c5395a38$export$eb78dd4efec095b1);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorTitle", () => $1bcbbcf0c5395a38$export$17669172b666864);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorDescription", () => $1bcbbcf0c5395a38$export$6daa483c0f823589);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("ixYp4")).default);

var $ixYp4 = parcelRequire("ixYp4");

var $hG4G8 = parcelRequire("hG4G8");
const $1bcbbcf0c5395a38$export$e882af1f191f98ed = (0, $hG4G8.default).genericErrorTitle;
const $1bcbbcf0c5395a38$export$435282e749b7e900 = (0, $hG4G8.default).genericErrorDescription;
const $1bcbbcf0c5395a38$export$814e1ad271462eee = (0, $hG4G8.default).genericSignUpErrorDescriptionUnified;
const $1bcbbcf0c5395a38$export$53a250c0a0614ddf = (0, $hG4G8.default).genericSignUpErrorNoContactLinkDescription;
const $1bcbbcf0c5395a38$export$2c865db45566f3fc = (0, $hG4G8.default).refreshPageLinkText;
const $1bcbbcf0c5395a38$export$4cd0b637ea791e58 = (0, $hG4G8.default).tellUsAboutIssueLinkText;
const $1bcbbcf0c5395a38$export$91b106f2d7a60f86 = (0, $hG4G8.default).letUsKnowLinkText;
const $1bcbbcf0c5395a38$export$20483281c243b1a0 = (0, $hG4G8.default).genericErrorRefreshPageAction;
const $1bcbbcf0c5395a38$export$b0cc5cbdc11d8431 = (0, $hG4G8.default).noNetworkTitle;
const $1bcbbcf0c5395a38$export$fdbfe2d9101e694 = (0, $hG4G8.default).signupEmailResendRateLimitedDescription;
const $1bcbbcf0c5395a38$export$d349948b740c510b = (0, $hG4G8.default).noNetworkDescription;
const $1bcbbcf0c5395a38$export$f1af5cb5b09d8e91 = (0, $hG4G8.default).blockedDescription;
const $1bcbbcf0c5395a38$export$23a02d68ec91feaf = (0, $hG4G8.default).blockedTitle;
const $1bcbbcf0c5395a38$export$593b1e00f52b5f5e = (0, $hG4G8.default).invalidEmailTitle;
const $1bcbbcf0c5395a38$export$82cbc81342a448dd = (0, $hG4G8.default).invalidEmailDescription;
const $1bcbbcf0c5395a38$export$6e2b8a076a84e30b = (0, $hG4G8.default).userProfileForgotPasswordFailedFlagTitle;
const $1bcbbcf0c5395a38$export$eb78dd4efec095b1 = (0, $hG4G8.default).userProfileForgotPasswordFailedFlagDescription;
const $1bcbbcf0c5395a38$export$17669172b666864 = (0, $hG4G8.default).userProfileForgotPasswordRateLimitedFlagTitle;
const $1bcbbcf0c5395a38$export$6daa483c0f823589 = (0, $hG4G8.default).userProfileForgotPasswordRateLimitedFlagDescription;

});
parcelRegister("ixYp4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dac8e7d831ad7bd$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $5kfOu = parcelRequire("5kfOu");
parcelRequire("jBTVi");
var $4llD6 = parcelRequire("4llD6");

var $4VZp4 = parcelRequire("4VZp4");
const $9dac8e7d831ad7bd$var$selector = (0, $2n2bS.createSelector)((state)=>(0, $4llD6.getFlags)(state), (flags)=>({
        flags: flags
    }));
var $9dac8e7d831ad7bd$export$2e2bcd8739ae039 = (0, $6umft.default)($9dac8e7d831ad7bd$var$selector, {
    dismissFlagAction: (0, $5kfOu.dismissFlag)
})((0, $4VZp4.default));

});
parcelRegister("2n2bS", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $1b9f6dbfd0200f28$export$595d22ed68ca2841, (v) => $1b9f6dbfd0200f28$export$595d22ed68ca2841 = v);
var $1b9f6dbfd0200f28$export$1e511d4a378977f5;
var $1b9f6dbfd0200f28$export$281bff7f05488aa2;
var $1b9f6dbfd0200f28$export$5943f4447f6ef248;
var $1b9f6dbfd0200f28$export$75979cfcd91bf38f;
var $1b9f6dbfd0200f28$export$595d22ed68ca2841;
'use strict';
$1b9f6dbfd0200f28$export$1e511d4a378977f5 = true;
$1b9f6dbfd0200f28$export$281bff7f05488aa2 = $1b9f6dbfd0200f28$var$defaultMemoize;
$1b9f6dbfd0200f28$export$5943f4447f6ef248 = $1b9f6dbfd0200f28$var$createSelectorCreator;
$1b9f6dbfd0200f28$export$75979cfcd91bf38f = $1b9f6dbfd0200f28$var$createStructuredSelector;
function $1b9f6dbfd0200f28$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $1b9f6dbfd0200f28$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $1b9f6dbfd0200f28$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1b9f6dbfd0200f28$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$1b9f6dbfd0200f28$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $1b9f6dbfd0200f28$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $1b9f6dbfd0200f28$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $1b9f6dbfd0200f28$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $1b9f6dbfd0200f28$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $1b9f6dbfd0200f28$var$createSelector = $1b9f6dbfd0200f28$export$595d22ed68ca2841 = $1b9f6dbfd0200f28$var$createSelectorCreator($1b9f6dbfd0200f28$var$defaultMemoize);
function $1b9f6dbfd0200f28$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1b9f6dbfd0200f28$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("jBTVi", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => (parcelRequire("4llD6")).getFlags);

var $4llD6 = parcelRequire("4llD6");

});
parcelRegister("4llD6", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => $4a3dc6550e9f015e$export$d5815430bcc75df0);
const $4a3dc6550e9f015e$export$d5815430bcc75df0 = (state)=>{
    return state.ui.flags.flags;
};

});


parcelRegister("4VZp4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8003332ef9b3986$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("fRm8i");
var $3fqyr = parcelRequire("3fqyr");
class $d8003332ef9b3986$export$2e2bcd8739ae039 extends $fc4bM.Component {
    render() {
        const { flags: flags, dismissFlagAction: dismissFlagAction } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $3fqyr.default), {
            flags: flags,
            dismissFlagAction: dismissFlagAction
        });
    }
}

});
parcelRegister("fRm8i", function(module, exports) {
$parcel$export(module.exports, "FlagGroupStateless", () => (parcelRequire("3fqyr")).default);

var $3fqyr = parcelRequire("3fqyr");

});
parcelRegister("3fqyr", function(module, exports) {
$parcel$export(module.exports, "default", () => $776267c6f2619a08$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $bAQQ9 = parcelRequire("bAQQ9");

var $jS4uw = parcelRequire("jS4uw");

var $48hlF = parcelRequire("48hlF");

var $fKWgA = parcelRequire("fKWgA");

var $fBVBf = parcelRequire("fBVBf");

var $7ZdBj = parcelRequire("7ZdBj");
const $776267c6f2619a08$var$isSuccessFlagAction = (flagAction)=>{
    return 'contentNode' in flagAction && !!flagAction.contentNode;
};
class $776267c6f2619a08$export$bf63ac67069f812 extends $fc4bM.Component {
    render() {
        const { flags: flags } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $bAQQ9.default), {
            onDismissed: this.handleFlagDismissed
        }, flags.map((flag)=>this.renderFlag(flag)));
    }
    constructor(...args){
        super(...args), this.handleFlagDismissed = (flagId)=>{
            this.props.dismissFlagAction(flagId);
        }, this.i18nFlagActions = (actions)=>{
            const { intl: intl } = this.props;
            return actions.map((action)=>{
                return $776267c6f2619a08$var$isSuccessFlagAction(action) ? {
                    content: action.contentNode,
                    href: action === null || action === void 0 ? void 0 : action.href
                } : {
                    content: intl.formatMessage(action.content),
                    href: action.href
                };
            });
        }, this.getIcon = (flag)=>{
            switch(flag.type){
                case 'error':
                    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'warning':
                    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-warning, #FF8B00)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'success':
                    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #36B37E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'bold':
                    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-information, #42526E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                default:
                    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
            }
        }, this.renderFlag = (flag)=>{
            const { intl: intl } = this.props;
            if (flag.type === 'bold') {
                const dismissAction = [];
                if (flag.dismissActionValue) dismissAction.push({
                    content: intl.formatMessage(flag.dismissActionValue),
                    onClick: ()=>{
                        this.handleFlagDismissed(flag.id);
                    }
                });
                return /*#__PURE__*/ $fc4bM.createElement((0, $jS4uw.default), {
                    appearance: flag.appearance,
                    id: flag.id,
                    key: flag.id,
                    icon: this.getIcon(flag),
                    title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                    description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                    actions: [
                        ...flag.actions,
                        ...dismissAction
                    ]
                });
            }
            return /*#__PURE__*/ $fc4bM.createElement((0, $jS4uw.default), {
                id: flag.id,
                key: flag.id,
                icon: this.getIcon(flag),
                title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                actions: this.i18nFlagActions(flag.actions)
            });
        };
    }
}
var $776267c6f2619a08$export$2e2bcd8739ae039 = (0, $fcCIH.default)($776267c6f2619a08$export$bf63ac67069f812);

});
parcelRegister("bAQQ9", function(module, exports) {
$parcel$export(module.exports, "FlagGroup", () => $abfcac09a5803fa1$export$a2c3479950310d7d);
$parcel$export(module.exports, "default", () => $abfcac09a5803fa1$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $6Zi52 = parcelRequire("6Zi52");

var $jEubQ = parcelRequire("jEubQ");

var $j5N6B = parcelRequire("j5N6B");

var $4Cnkn = parcelRequire("4Cnkn");

var $9JZL9 = parcelRequire("9JZL9");

var $9kfe7 = parcelRequire("9kfe7");

var $dVK9d = parcelRequire("dVK9d");

var $iXBtU = parcelRequire("iXBtU");

var $jCsvE = parcelRequire("jCsvE");

var $dRkX9 = parcelRequire("dRkX9");

var $cufVT = parcelRequire("cufVT");

var $dBtOK = parcelRequire("dBtOK");

var $2SWSA = parcelRequire("2SWSA");

var $GyLDf = parcelRequire("GyLDf");

var $dVxDa = parcelRequire("dVxDa");

var $2RNme = parcelRequire("2RNme");

var $6hmrw = parcelRequire("6hmrw");
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $abfcac09a5803fa1$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $abfcac09a5803fa1$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $abfcac09a5803fa1$var$dismissAllowedStyles = null;
const $abfcac09a5803fa1$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $abfcac09a5803fa1$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $abfcac09a5803fa1$var$flagGroupContainerStylesSymmetric = null;
/**
 * Tells the flag group when a flag mounts and unmounts. A flag stays mounted
 * while its exit animation plays, so the count includes exiting flags.
 */ function $abfcac09a5803fa1$var$FlagPresence({ onChange: onChange }) {
    (0, $9kfe7.useLayoutEffect)(()=>{
        onChange(1);
        return ()=>onChange(-1);
    }, [
        onChange
    ]);
    return null;
}
const $abfcac09a5803fa1$export$a2c3479950310d7d = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $9JZL9.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const useTopLayer = (0, $dRkX9.fg)('platform-dst-top-layer');
    // Top layer only. The host renders in place, so an open host with no flags
    // adds an empty element to the consumer's DOM. Open the host only while a
    // flag is mounted, including a flag that plays its exit animation.
    const [mountedFlagCount, setMountedFlagCount] = (0, $fc4bM.useState)(0);
    const onFlagPresenceChange = (0, $fc4bM.useCallback)((delta)=>{
        setMountedFlagCount((count)=>count + delta);
    }, []);
    // `hasFlags` opens the host for the first flag: flags count themselves from
    // inside the host, so the count is 0 until the host renders. The count keeps
    // the host open after the last flag leaves `children` but is still exiting.
    const isHostOpen = hasFlags || mountedFlagCount > 0;
    // Top layer only. The host mounts with its first flag, so that flag must
    // animate in. Flags that are present when the group mounts do not animate,
    // as on the portal path.
    const hasMountedRef = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        hasMountedRef.current = true;
    }, []);
    const dismissFlagContext = (0, $fc4bM.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const latestRef = (0, $fc4bM.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $fc4bM.useEffect)(()=>{
        if (!(0, $dRkX9.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $j5N6B.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, $6Zi52.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                var _props;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = (_props = firstFlag.props) === null || _props === void 0 ? void 0 : _props.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    var _latestRef$current$on, _latestRef$current;
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    (_latestRef$current$on = (_latestRef$current = latestRef.current).onDismissed) === null || _latestRef$current$on === void 0 || _latestRef$current$on.call(_latestRef$current, id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $fc4bM.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $dRkX9.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                xcss: (0, $4Cnkn.cx)($abfcac09a5803fa1$var$groupStylesNew.root, index === 0 && $abfcac09a5803fa1$var$groupStylesNew.first, index === 1 && $abfcac09a5803fa1$var$groupStylesNew.second, index >= 2 && $abfcac09a5803fa1$var$groupStylesNew.nth, index >= 3 && $abfcac09a5803fa1$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVK9d.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6hmrw.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, $2RNme.defaultFlagGroupContext),
                        children: [
                            flag,
                            useTopLayer ? /*#__PURE__*/ (0, $3LM7S.jsx)($abfcac09a5803fa1$var$FlagPresence, {
                                onChange: onFlagPresenceChange
                            }) : null
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jCsvE.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $2R2iS.default)([
                            $abfcac09a5803fa1$var$groupStyles.root,
                            index === 0 && $abfcac09a5803fa1$var$groupStyles.first,
                            index === 1 && $abfcac09a5803fa1$var$groupStyles.second,
                            index >= 1 && $abfcac09a5803fa1$var$groupStyles.nth,
                            index >= 2 && $abfcac09a5803fa1$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6hmrw.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, $2RNme.defaultFlagGroupContext),
                            children: [
                                flag,
                                useTopLayer ? /*#__PURE__*/ (0, $3LM7S.jsx)($abfcac09a5803fa1$var$FlagPresence, {
                                    onChange: onFlagPresenceChange
                                }) : null
                            ]
                        })
                    })
            });
        }) : false;
    };
    const useSymmetricAnchor = (0, $dRkX9.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $dRkX9.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $2R2iS.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
                appear: useTopLayer && hasMountedRef.current,
                children: renderChildren()
            })
        ]
    });
    if (useTopLayer) // Render no host (and run no Popover hooks) until a flag mounts.
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
        children: isHostOpen ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
            mode: "manual",
            isOpen: true,
            children: flags
        }) : null
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cufVT.default), {
        zIndex: (0, $2SWSA.layers).flag(),
        children: flags
    });
};
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$abfcac09a5803fa1$export$2e2bcd8739ae039 = $abfcac09a5803fa1$export$a2c3479950310d7d;

});
parcelRegister("4Cnkn", function(module, exports) {
$parcel$export(module.exports, "cx", () => $edfe8f01b6d07d6a$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("fc4bM");

var $1t41N = parcelRequire("1t41N");
const $edfe8f01b6d07d6a$var$strictApi = (0, $1t41N.createStrictAPI)();
const $edfe8f01b6d07d6a$export$dbf350e5966cf602 = $edfe8f01b6d07d6a$var$strictApi.css;
const $edfe8f01b6d07d6a$export$eb1ecd84a24ee424 = $edfe8f01b6d07d6a$var$strictApi.cssMap;
$edfe8f01b6d07d6a$var$strictApi.cssMap;
const $edfe8f01b6d07d6a$export$a274e22fb40f762e = $edfe8f01b6d07d6a$var$strictApi.cx;
const $edfe8f01b6d07d6a$var$XCSSProp = $edfe8f01b6d07d6a$var$strictApi.XCSSProp;

});
parcelRegister("1t41N", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $111b9fc433473ac9$export$39716b4af53f4ad);

var $84Q0G = parcelRequire("84Q0G");

var $jdt4T = parcelRequire("jdt4T");
function $111b9fc433473ac9$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $84Q0G.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $84Q0G.createStrictSetupError)();
        },
        cx: $jdt4T.cx,
        XCSSProp () {
            throw (0, $84Q0G.createStrictSetupError)();
        }
    };
}

});
parcelRegister("84Q0G", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $5e170a92651b60d7$export$c4df1cb0c2b4d77c);
const $5e170a92651b60d7$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $5e170a92651b60d7$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("dVK9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $92d0fc860bf28f2b$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $dRkX9 = parcelRequire("dRkX9");

var $2ybbW = parcelRequire("2ybbW");

var $3ZBv6 = parcelRequire("3ZBv6");

var $kUMs0 = parcelRequire("kUMs0");

var $lVO5o = parcelRequire("lVO5o");

var $9AxjN = parcelRequire("9AxjN");

var $8vg2n = parcelRequire("8vg2n");

var $2ggqN = parcelRequire("2ggqN");

var $9dMLa = parcelRequire("9dMLa");
const $92d0fc860bf28f2b$var$initialStateByAction = {
    enter: 'visible',
    exit: 'hidden'
};
const $92d0fc860bf28f2b$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const $92d0fc860bf28f2b$var$MotionLegacy = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $9dMLa.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8vg2n.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $fc4bM.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $fc4bM.useRef)(null);
    const reanimateRef = (0, $fc4bM.useRef)();
    const animationRef = (0, $fc4bM.useRef)();
    const staggeredEntryRef = (0, $fc4bM.useRef)();
    (0, $fc4bM.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $fc4bM.useEffect)(()=>{
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $fc4bM.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $9AxjN.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $9AxjN.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $kUMs0.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $3ZBv6.getDurationMs)((0, $lVO5o.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $2ybbW.getComputedAnimationDurationMs)(styles.animationName, styles.animationDuration, styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $fc4bM.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $9AxjN.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $9AxjN.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            hasAnimationStyles && $92d0fc860bf28f2b$var$styles.base,
            state === 'init' && $92d0fc860bf28f2b$var$styles.hidden,
            (0, $4Cnkn.cx)(xcss, customAnimation)
        ]),
        ref: (0, $4dCfH.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? {
            ...styleProp,
            ...style
        } : undefined,
        "data-testid": testId,
        children: children
    });
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const $92d0fc860bf28f2b$var$MotionNext = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, action: action, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $2ggqN.useMotion)({
        onFinish: onFinishMotion,
        initialState: action ? $92d0fc860bf28f2b$var$initialStateByAction[action] : undefined
    });
    (0, $fc4bM.useImperativeHandle)(ref, ()=>({
            reanimate: reanimate
        }), [
        reanimate
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (action === 'exit' && state !== 'exiting' && state !== 'hidden') reanimate((0, $9AxjN.Reanimate).exit);
        else if (action === 'enter' && (state === 'exiting' || state === 'hidden')) reanimate((0, $9AxjN.Reanimate).enter);
    }, [
        action,
        reanimate,
        state
    ]);
    if (state === 'hidden') return null;
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            state === 'init' && $92d0fc860bf28f2b$var$styles.hidden,
            (0, $4Cnkn.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...styleProp,
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        },
        "data-testid": testId,
        children: children
    });
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ const $92d0fc860bf28f2b$var$Motion = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    if ((0, $dRkX9.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, $3LM7S.jsx)($92d0fc860bf28f2b$var$MotionNext, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($92d0fc860bf28f2b$var$MotionLegacy, {
        ...props,
        ref: ref
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$92d0fc860bf28f2b$export$2e2bcd8739ae039 = $92d0fc860bf28f2b$var$Motion;

});
parcelRegister("2ybbW", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $19f2efca63c7a5dc$export$dd9b73a7482d05b6);

var $6UcuK = parcelRequire("6UcuK");
const $19f2efca63c7a5dc$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
const $19f2efca63c7a5dc$var$toCssList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean);
const $19f2efca63c7a5dc$var$toTimeList = (value)=>$19f2efca63c7a5dc$var$toCssList(value).filter((time)=>$19f2efca63c7a5dc$var$cssTimePattern.test(time)).map((0, $6UcuK.convertToMs));
const $19f2efca63c7a5dc$export$dd9b73a7482d05b6 = (animationName, animationDuration, animationDelay)=>{
    const names = $19f2efca63c7a5dc$var$toCssList(animationName);
    const durations = $19f2efca63c7a5dc$var$toTimeList(animationDuration);
    const delays = $19f2efca63c7a5dc$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    let longestDuration = 0;
    for(let index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        const duration = durations[index % durations.length];
        const delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("6UcuK", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $77c9c70a2d4ed510$export$75eee42ff540d8ae);
const $77c9c70a2d4ed510$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("3ZBv6", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $2d4f66bb214d663d$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $2d4f66bb214d663d$export$d0038b6e47881463 = (animation)=>{
    const animations = animation.split(/,(?![^()]*\))/).map((value)=>[
            ...value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
        ]).filter((matches)=>matches.length > 0);
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce((longest, matches)=>{
        const toMilliseconds = (match)=>{
            const value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        const timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("lVO5o", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $422b7bea501b0817$export$82b92541889a035d);

var $j5N6B = parcelRequire("j5N6B");
const $422b7bea501b0817$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        const documentElement = (_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("9AxjN", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $e4137f47198993e4$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $e4137f47198993e4$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("2ggqN", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $d2519beab5af9909$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Exposes start and finish callbacks while useMotion coordinates the animation lifecycle.

var $fc4bM = parcelRequire("fc4bM");

var $4dCfH = parcelRequire("4dCfH");

var $2ybbW = parcelRequire("2ybbW");

var $3ZBv6 = parcelRequire("3ZBv6");

var $kUMs0 = parcelRequire("kUMs0");

var $lVO5o = parcelRequire("lVO5o");

var $1JUTA = parcelRequire("1JUTA");

var $9AxjN = parcelRequire("9AxjN");

var $8vg2n = parcelRequire("8vg2n");

var $9dMLa = parcelRequire("9dMLa");
function $d2519beab5af9909$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, onStart: onStartMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $kUMs0.isReducedMotion)();
    const staggered = (0, $9dMLa.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8vg2n.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $fc4bM.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'));
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    const motionState = isExiting ? 'exiting' : state;
    const elementRef = (0, $fc4bM.useRef)(null);
    const onFinishMotionRef = (0, $fc4bM.useRef)(onFinishMotion);
    onFinishMotionRef.current = onFinishMotion;
    const onStartMotionRef = (0, $fc4bM.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    const onExitFinishedRef = (0, $fc4bM.useRef)(onExitFinished);
    onExitFinishedRef.current = onExitFinished;
    const reanimateRef = (0, $fc4bM.useRef)();
    const animationRef = (0, $fc4bM.useRef)();
    const staggeredEntryRef = (0, $fc4bM.useRef)();
    (0, $1JUTA.useLayoutEffect)(()=>{
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $fc4bM.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            var _onFinishMotionRef$cu;
            if (!reanimateRef.current) {
                var _onExitFinishedRef$cu;
                // Updates the `ExitingPersistence` to remove this child
                (_onExitFinishedRef$cu = onExitFinishedRef.current) === null || _onExitFinishedRef$cu === void 0 || _onExitFinishedRef$cu.call(onExitFinishedRef);
            }
            (_onFinishMotionRef$cu = onFinishMotionRef.current) === null || _onFinishMotionRef$cu === void 0 || _onFinishMotionRef$cu.call(onFinishMotionRef, 'exiting');
        }
        if (currentState === 'entering') {
            var _onFinishMotionRef$cu2;
            (_onFinishMotionRef$cu2 = onFinishMotionRef.current) === null || _onFinishMotionRef$cu2 === void 0 || _onFinishMotionRef$cu2.call(onFinishMotionRef, 'entering');
        }
        if (reanimateRef.current === (0, $9AxjN.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $9AxjN.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $9AxjN.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $9AxjN.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Handles staggered entry
    (0, $fc4bM.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $3ZBv6.getDurationMs)((0, $lVO5o.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $2ybbW.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $fc4bM.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $9AxjN.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $9AxjN.Reanimate).enter) setState('entering');
        else if (value === (0, $9AxjN.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $fc4bM.useMemo)(()=>(0, $4dCfH.default)([
            staggered.ref,
            elementRef
        ]), [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});


parcelRegister("jCsvE", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1c752cc31f5a2d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gh5HC = parcelRequire("gh5HC");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $df1c752cc31f5a2d$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gh5HC.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $df1c752cc31f5a2d$export$2e2bcd8739ae039 = $df1c752cc31f5a2d$var$SlideIn;

});

parcelRegister("dBtOK", function(module, exports) {
$parcel$export(module.exports, "Box", () => $b9994aa11ec45775$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ /* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $2C58c = parcelRequire("2C58c");
const $b9994aa11ec45775$var$baseStyles = null;
const $b9994aa11ec45775$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $b9994aa11ec45775$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $b9994aa11ec45775$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $b9994aa11ec45775$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $b9994aa11ec45775$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $b9994aa11ec45775$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $b9994aa11ec45775$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
const $b9994aa11ec45775$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2R2iS.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $b9994aa11ec45775$var$backgroundColorMap[backgroundColor],
            backgroundColor && $b9994aa11ec45775$var$isSurfaceToken(backgroundColor) && $b9994aa11ec45775$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $b9994aa11ec45775$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $b9994aa11ec45775$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $b9994aa11ec45775$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $b9994aa11ec45775$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2C58c.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
function $b9994aa11ec45775$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $b9994aa11ec45775$var$setSurfaceTokenMap;
}

});

parcelRegister("2RNme", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $d0463ef3d9744919$export$643760c4938da30d);

var $9JZL9 = parcelRequire("9JZL9");
const $d0463ef3d9744919$export$643760c4938da30d = {
    onDismissed: (0, $9JZL9.default),
    isDismissAllowed: false
};

});

parcelRegister("6hmrw", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $2bc3d931c1185ab3$export$c57ba665aaa722be);

var $fc4bM = parcelRequire("fc4bM");

var $2RNme = parcelRequire("2RNme");
const $2bc3d931c1185ab3$export$c57ba665aaa722be = /*#__PURE__*/ (0, $fc4bM.createContext)((0, $2RNme.defaultFlagGroupContext));

});


parcelRegister("jS4uw", function(module, exports) {
$parcel$export(module.exports, "default", () => $430ee796225aeff4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $eBDNv = parcelRequire("eBDNv");

var $gtbOt = parcelRequire("gtbOt");
const $430ee796225aeff4$var$packageName = undefined;
const $430ee796225aeff4$var$packageVersion = undefined;
const $430ee796225aeff4$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $430ee796225aeff4$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $9JZL9.default), autoDismissSeconds: autoDismissSeconds = $430ee796225aeff4$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $fc4bM.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gtbOt.useFlagGroup)();
    const onDismissed = (0, $fc4bM.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $430ee796225aeff4$var$packageName,
        packageVersion: $430ee796225aeff4$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $fc4bM.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $fc4bM.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $fc4bM.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $fc4bM.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eBDNv.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $430ee796225aeff4$export$2e2bcd8739ae039 = $430ee796225aeff4$var$AutoDismissFlag;

});
parcelRegister("eBDNv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f94572beecc07446$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $1hJdJ = parcelRequire("1hJdJ");

var $khBwH = parcelRequire("khBwH");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $cJzRi = parcelRequire("cJzRi");

var $dVxDa = parcelRequire("dVxDa");

var $8Dg72 = parcelRequire("8Dg72");

var $9nLpi = parcelRequire("9nLpi");

var $fo5AA = parcelRequire("fo5AA");

var $jdPRc = parcelRequire("jdPRc");

var $yQ5Fu = parcelRequire("yQ5Fu");

var $1Y7qu = parcelRequire("1Y7qu");

var $1EXeQ = parcelRequire("1EXeQ");

var $ad55h = parcelRequire("ad55h");

var $9LyRN = parcelRequire("9LyRN");

var $gtbOt = parcelRequire("gtbOt");
const $f94572beecc07446$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rko1mok _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    contentStack: "_k8m01vax _1oec1mzy _156yru3m"
};
const $f94572beecc07446$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $f94572beecc07446$var$descriptionStyles = null;
const $f94572beecc07446$var$flagWrapperStyles = null;
const $f94572beecc07446$var$iconWrapperStyles = null;
const $f94572beecc07446$var$transitionStyles = null;
const $f94572beecc07446$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const $f94572beecc07446$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $8Dg72.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $9JZL9.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $9JZL9.default), onDismissed: onDismissedProp = (0, $9JZL9.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $fc4bM.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gtbOt.useFlagGroup)();
    const onDismissed = (0, $fc4bM.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $fc4bM.useState)(false);
    const onDismissedAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$f94572beecc07446$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $8Dg72.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $fc4bM.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $fc4bM.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$f94572beecc07446$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$f94572beecc07446$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $1Y7qu.flagTextColor)[appearance];
    const iconColor = (0, $jdPRc.flagIconColor)[appearance];
    const iconGlyph = (0, $yQ5Fu.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    const isCollapseAnimationEnabled = (0, $dRkX9.fg)('platform-dst-flag-collapse-animation-fix');
    // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $khBwH.default), {
            children: [
                title,
                description
            ]
        })
    }) : undefined;
    // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $2R2iS.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
            padding: "space.200",
            backgroundColor: (0, $fo5AA.flagBackgroundColor)[appearance],
            xcss: $f94572beecc07446$var$styles.flag,
            children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            [$f94572beecc07446$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $2R2iS.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                        className: (0, $2R2iS.default)([
                            "_v5641hdc _1ul9idpf _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            xcss: isCollapseAnimationEnabled ? $f94572beecc07446$var$styles.contentStack : undefined,
                            testId: testId && `${testId}-content-stack`,
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $f94572beecc07446$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                                                        children: title
                                                    })
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ad55h.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $9LyRN.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            style: {
                                                color: (0, $1EXeQ.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                            className: (0, $2R2iS.default)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9nLpi.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $f94572beecc07446$export$2e2bcd8739ae039 = $f94572beecc07446$var$Flag;

});
parcelRegister("khBwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9a339997b5ed38a$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $iXBtU = parcelRequire("iXBtU");
function $f9a339997b5ed38a$export$2e2bcd8739ae039({ children: children }) {
    return (0, $dRkX9.fg)('platform-dst-motion-isolate-presence') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.ExitingContext).Provider, {
        value: (0, $iXBtU.defaultExitingContext),
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: children
    });
}

});

parcelRegister("i3riz", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $3936a02ee074924b$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ /* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4Cnkn = parcelRequire("4Cnkn");

var $26fPW = parcelRequire("26fPW");
const $3936a02ee074924b$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $3936a02ee074924b$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            $3936a02ee074924b$var$styles.separator
        ]),
        children: children
    });
const $3936a02ee074924b$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $3LM7S.jsx)($3936a02ee074924b$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $fc4bM.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $4Cnkn.cx)(grow === 'hug' && $3936a02ee074924b$var$styles.hug, grow === 'fill' && $3936a02ee074924b$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$3936a02ee074924b$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("26fPW", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $982df78d24747ad9$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $982df78d24747ad9$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz",
    'space.gap.xxsmall': "_1p571j29",
    'space.gap.xsmall': "_1p57t24t",
    'space.gap.small': "_1p57e2kt",
    'space.gap.medium': "_1p57slki",
    'space.gap.large': "_1p571l0c",
    'space.gap.xlarge': "_1p571a4g",
    'space.gap.xxlarge': "_1p57rdp2"
};
const $982df78d24747ad9$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz",
    'space.gap.xxsmall': "_gy1p1j29",
    'space.gap.xsmall': "_gy1pt24t",
    'space.gap.small': "_gy1pe2kt",
    'space.gap.medium': "_gy1pslki",
    'space.gap.large': "_gy1p1l0c",
    'space.gap.xlarge': "_gy1p1a4g",
    'space.gap.xxlarge': "_gy1prdp2"
};
const $982df78d24747ad9$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $982df78d24747ad9$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $982df78d24747ad9$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $982df78d24747ad9$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $982df78d24747ad9$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
const $982df78d24747ad9$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $2R2iS.default)([
            $982df78d24747ad9$var$styles.root,
            gap && $982df78d24747ad9$var$columnGapMap[gap],
            columnGap && $982df78d24747ad9$var$columnGapMap[columnGap],
            gap && $982df78d24747ad9$var$rowGapMap[gap],
            rowGap && $982df78d24747ad9$var$rowGapMap[rowGap],
            alignItems && $982df78d24747ad9$var$alignItemsMap[alignItems],
            direction && $982df78d24747ad9$var$flexDirectionMap[direction],
            justifyContent && $982df78d24747ad9$var$justifyContentMap[justifyContent],
            wrap && $982df78d24747ad9$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$982df78d24747ad9$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("cJzRi", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $23ae9d7709975b6d$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ /* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $26fPW = parcelRequire("26fPW");
const $23ae9d7709975b6d$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $23ae9d7709975b6d$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $4Cnkn.cx)(grow === 'hug' && $23ae9d7709975b6d$var$styles.hug, grow === 'fill' && $23ae9d7709975b6d$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$23ae9d7709975b6d$export$694e0d28c7ffc90c.displayName = 'Stack';

});

parcelRegister("8Dg72", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $1850dcfab0f5f27a$export$d6830277b06edd6);
const $1850dcfab0f5f27a$export$d6830277b06edd6 = 'normal';
const $1850dcfab0f5f27a$export$1eee5ddc4f6d41c5 = 400;

});

parcelRegister("9nLpi", function(module, exports) {
$parcel$export(module.exports, "default", () => $18faa60ee2b9cd02$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $k7lry = parcelRequire("k7lry");

var $dRkX9 = parcelRequire("dRkX9");

var $i3riz = parcelRequire("i3riz");

var $18sne = parcelRequire("18sne");

var $8Dg72 = parcelRequire("8Dg72");

var $1U9CU = parcelRequire("1U9CU");
const $18faa60ee2b9cd02$var$buttonStylesOld = null;
const $18faa60ee2b9cd02$var$buttonStyles = null;
const $18faa60ee2b9cd02$var$fontStyles = null;
const $18faa60ee2b9cd02$var$appearanceNormalButtonStyles = null;
const $18faa60ee2b9cd02$var$appearanceBoldButtonStyles = null;
const $18faa60ee2b9cd02$var$appearanceNormalActionsContainerStyles = null;
const $18faa60ee2b9cd02$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $8Dg72.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $8Dg72.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>(0, $dRkX9.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k7lry.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $18sne.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $1U9CU.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $1U9CU.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $1U9CU.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $2R2iS.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k7lry.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $18sne.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $1U9CU.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $1U9CU.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $1U9CU.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $2R2iS.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18faa60ee2b9cd02$export$2e2bcd8739ae039 = $18faa60ee2b9cd02$var$FlagActions;

});
parcelRegister("k7lry", function(module, exports) {
$parcel$export(module.exports, "default", () => $54343b9f175736ca$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5FyJq = parcelRequire("5FyJq");

var $2mc3E = parcelRequire("2mc3E");

var $9KPkf = parcelRequire("9KPkf");

var $3wc6l = parcelRequire("3wc6l");

var $i58qg = parcelRequire("i58qg");

var $2TxPU = parcelRequire("2TxPU");

var $6zR5w = parcelRequire("6zR5w");
function $54343b9f175736ca$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $54343b9f175736ca$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $54343b9f175736ca$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $i58qg.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $fc4bM.useState)($54343b9f175736ca$var$initial);
    const onMouseEnter = (0, $fc4bM.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $fc4bM.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $fc4bM.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $fc4bM.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $fc4bM.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $fc4bM.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6zR5w.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5FyJq.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $6zR5w.default).Consumer, {
                    mode: mode,
                    state: $54343b9f175736ca$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $9KPkf.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $2mc3E.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3wc6l.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $2TxPU.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$54343b9f175736ca$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $54343b9f175736ca$export$2e2bcd8739ae039 = $54343b9f175736ca$var$CustomThemeButton;

});
parcelRegister("5FyJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cec5dc7516972d4$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8qR0o = parcelRequire("8qR0o");
// Create default global light theme
const $6cec5dc7516972d4$var$dest = (0, $8qR0o.createTheme)(()=>({
        mode: 'light'
    }));
const $6cec5dc7516972d4$var$Provider = $6cec5dc7516972d4$var$dest.Provider;
const $6cec5dc7516972d4$var$Consumer = $6cec5dc7516972d4$var$dest.Consumer;
const $6cec5dc7516972d4$export$7692396083754928 = $6cec5dc7516972d4$var$dest.useTheme;
const $6cec5dc7516972d4$var$Theme = {
    Provider: $6cec5dc7516972d4$var$Provider,
    Consumer: $6cec5dc7516972d4$var$Consumer
};
var /**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2652 Internal documentation for deprecation (no external access)}
 * Use design tokens and the supported customization APIs of Atlassian Design System components.
 */ $6cec5dc7516972d4$export$2e2bcd8739ae039 = $6cec5dc7516972d4$var$Theme;

});
parcelRegister("8qR0o", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $070aadb9c1ec0ac5$export$25d302a5b900a763);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
function $070aadb9c1ec0ac5$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $fc4bM.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $fc4bM.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
            children: children(tokens)
        });
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $fc4bM.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $fc4bM.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $3LM7S.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("3wc6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b411ab6c8fe3c5c4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $hculA = parcelRequire("hculA");
function $b411ab6c8fe3c5c4$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $b411ab6c8fe3c5c4$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
        size: size,
        label: ", Loading",
        appearance: $b411ab6c8fe3c5c4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("i58qg", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $cca507f29ec1a4ab$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $cca507f29ec1a4ab$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("2TxPU", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $fbc0f974c8691cad$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $fbc0f974c8691cad$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("6zR5w", function(module, exports) {
$parcel$export(module.exports, "default", () => $12f21337dd7e7b4f$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @atlaskit/ui-styling-standard/no-atlaskit-theme -- Ignored via go/DSP-18766

var $8qR0o = parcelRequire("8qR0o");

var $bbNQy = parcelRequire("bbNQy");
const $12f21337dd7e7b4f$var$Theme = (0, $8qR0o.createTheme)((themeProps)=>({
        buttonStyles: (0, $bbNQy.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$12f21337dd7e7b4f$export$2e2bcd8739ae039 = $12f21337dd7e7b4f$var$Theme;

});
parcelRegister("bbNQy", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $a11598e0dbe639f2$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lNvWx = parcelRequire("lNvWx");
const $a11598e0dbe639f2$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $a11598e0dbe639f2$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $lNvWx.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $a11598e0dbe639f2$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("18sne", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $668ce86d79d1bb8e$export$7bcfe3cca4dd78b6);
const $668ce86d79d1bb8e$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("1U9CU", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $195afca046eaff56$export$81ba6b63eedb299f);
const $195afca046eaff56$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("fo5AA", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $c74a9e9546d7d11e$export$59e42969c95d314);
const $c74a9e9546d7d11e$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("jdPRc", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $aff5e0c35822f804$export$7f70afe2167f8235);
const $aff5e0c35822f804$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("yQ5Fu", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $7ca52d5b1b1607bd$export$73f08aee70487cd4);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gDsF8 = parcelRequire("gDsF8");

var $fKWgA = parcelRequire("fKWgA");

var $fBVBf = parcelRequire("fBVBf");

var $7ZdBj = parcelRequire("7ZdBj");
const $7ca52d5b1b1607bd$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))), {
        label: ""
    })
};

});
parcelRegister("gDsF8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1c6859d7a7f4e28$var$_react = $c1c6859d7a7f4e28$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $c1c6859d7a7f4e28$var$_iconNew = $c1c6859d7a7f4e28$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $c1c6859d7a7f4e28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1c6859d7a7f4e28$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $c1c6859d7a7f4e28$var$_react.default.createElement($c1c6859d7a7f4e28$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$c1c6859d7a7f4e28$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $c1c6859d7a7f4e28$var$_default = module.exports.default = $c1c6859d7a7f4e28$var$StatusErrorIcon;

});

parcelRegister("fKWgA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b788596c6f38442a$var$_react = $b788596c6f38442a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b788596c6f38442a$var$_iconNew = $b788596c6f38442a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b788596c6f38442a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b788596c6f38442a$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $b788596c6f38442a$var$_react.default.createElement($b788596c6f38442a$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$b788596c6f38442a$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $b788596c6f38442a$var$_default = module.exports.default = $b788596c6f38442a$var$StatusInformationIcon;

});

parcelRegister("fBVBf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fec260a5beb0e93db2111df1ab9a2e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5d6fdda76820b80$var$_react = $b5d6fdda76820b80$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b5d6fdda76820b80$var$_iconNew = $b5d6fdda76820b80$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b5d6fdda76820b80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5d6fdda76820b80$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $b5d6fdda76820b80$var$_react.default.createElement($b5d6fdda76820b80$var$_iconNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$b5d6fdda76820b80$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $b5d6fdda76820b80$var$_default = module.exports.default = $b5d6fdda76820b80$var$StatusSuccessIcon;

});

parcelRegister("7ZdBj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d08c7bc09e9c48b$var$_react = $5d08c7bc09e9c48b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5d08c7bc09e9c48b$var$_iconNew = $5d08c7bc09e9c48b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5d08c7bc09e9c48b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d08c7bc09e9c48b$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $5d08c7bc09e9c48b$var$_react.default.createElement($5d08c7bc09e9c48b$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$5d08c7bc09e9c48b$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $5d08c7bc09e9c48b$var$_default = module.exports.default = $5d08c7bc09e9c48b$var$StatusWarningIcon;

});


parcelRegister("1Y7qu", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $f508ad0b8edcd2b7$export$f50075b2584087f);
const $f508ad0b8edcd2b7$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("1EXeQ", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $2c76e4d9b360a6af$export$13b42cd9d596bfe0);
const $2c76e4d9b360a6af$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("ad55h", function(module, exports) {
$parcel$export(module.exports, "default", () => $a799aa1aa7bb6a19$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fRCnG = parcelRequire("fRCnG");

var $13zmE = parcelRequire("13zmE");

var $f69ft = parcelRequire("f69ft");

var $gV8E5 = parcelRequire("gV8E5");

var $1EXeQ = parcelRequire("1EXeQ");
const $a799aa1aa7bb6a19$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($gV8E5)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($f69ft))) : (0, (/*@__PURE__*/$parcel$interopDefault($13zmE)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $1EXeQ.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $a799aa1aa7bb6a19$var$DismissButton = /*#__PURE__*/ (0, $fc4bM.memo)($a799aa1aa7bb6a19$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a799aa1aa7bb6a19$export$2e2bcd8739ae039 = $a799aa1aa7bb6a19$var$DismissButton;

});
parcelRegister("fRCnG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8d3faa439dbef2c2$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4dCfH = parcelRequire("4dCfH");

var $bcTS3 = parcelRequire("bcTS3");

var $dVxDa = parcelRequire("dVxDa");

var $7ncUj = parcelRequire("7ncUj");

var $6m8y3 = parcelRequire("6m8y3");

var $dw5IO = parcelRequire("dw5IO");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $8d3faa439dbef2c2$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7ncUj.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6m8y3.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                    icon: icon,
                    spacing: spacing
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7ncUj.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    var _triggerProps$onClick;
                    onClick === null || onClick === void 0 || onClick(e, analyticsEvent);
                    (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
                },
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                ref: (0, $4dCfH.default)([
                    ref,
                    triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6m8y3.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                            icon: icon,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$8d3faa439dbef2c2$var$IconButton.displayName = 'IconButton';
var $8d3faa439dbef2c2$export$2e2bcd8739ae039 = $8d3faa439dbef2c2$var$IconButton;

});
parcelRegister("7ncUj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed369714155b8cc4$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $8PakO = parcelRequire("8PakO");

var $3zBNx = parcelRequire("3zBNx");

var $dRkX9 = parcelRequire("dRkX9");

var $EawnW = parcelRequire("EawnW");

var $dVxDa = parcelRequire("dVxDa");

var $9P9F7 = parcelRequire("9P9F7");

var $cokUz = parcelRequire("cokUz");

var $2H7sr = parcelRequire("2H7sr");

var $lnPDH = parcelRequire("lnPDH");
const $ed369714155b8cc4$var$LOADING_LABEL = ', Loading';
const $ed369714155b8cc4$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_2rko12b0 _1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $ed369714155b8cc4$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $ed369714155b8cc4$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $ed369714155b8cc4$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $ed369714155b8cc4$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $ed369714155b8cc4$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $ed369714155b8cc4$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $ed369714155b8cc4$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $ed369714155b8cc4$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $ed369714155b8cc4$var$brandSelectedSplitButtonStyles = {
    root: "_bfhk1gmr _syaz1oa5 _8l3ma755 _aetrb3bt _10531oa5 _f8pj1oa5 _30l31oa5 _9h8h1oa5",
    interactive: "_irr33v15 _30l31oa5 _1di6u02c _9h8h1oa5"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $ed369714155b8cc4$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, rootXcss: rootXcss, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $fc4bM.useRef)(null);
    const splitButtonContext = (0, $cokUz.useSplitButtonContext)();
    const loadingLabelId = (0, $3zBNx.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    const isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    const spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    const isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    // The open dropdown is part of a primary action, not a standalone selection.
    const isBrandSelectedSplitButton = isSelected && appearance === 'primary' && (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'primary' && (0, $dRkX9.fg)('platform-dst-tokens-finesse');
    (0, $8PakO.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $4dCfH.default)([
            localRef,
            ref
        ]),
        xcss: (0, $4Cnkn.cx)($ed369714155b8cc4$var$styles.base, isInteractive && $ed369714155b8cc4$var$styles.interactiveMotion, appearance === 'default' && $ed369714155b8cc4$var$defaultStyles.root, appearance === 'default' && isInteractive && $ed369714155b8cc4$var$defaultStyles.interactive, appearance === 'primary' && $ed369714155b8cc4$var$primaryStyles.root, appearance === 'primary' && isInteractive && $ed369714155b8cc4$var$primaryStyles.interactive, appearance === 'rovo' && $ed369714155b8cc4$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $ed369714155b8cc4$var$rovoStyles.interactive, appearance === 'warning' && $ed369714155b8cc4$var$warningStyles.root, appearance === 'warning' && isInteractive && $ed369714155b8cc4$var$warningStyles.interactive, appearance === 'danger' && $ed369714155b8cc4$var$dangerStyles.root, appearance === 'danger' && isInteractive && $ed369714155b8cc4$var$dangerStyles.interactive, appearance === 'discovery' && $ed369714155b8cc4$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $ed369714155b8cc4$var$discoveryStyles.interactive, appearance === 'subtle' && $ed369714155b8cc4$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $ed369714155b8cc4$var$subtleStyles.interactive, $ed369714155b8cc4$var$styles.linkDecorationUnset, isSelected && $ed369714155b8cc4$var$selectedStyles.root, isSelected && isSplitButton && $ed369714155b8cc4$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $ed369714155b8cc4$var$selectedStyles.interactive, isBrandSelectedSplitButton && $ed369714155b8cc4$var$brandSelectedSplitButtonStyles.root, isBrandSelectedSplitButton && isInteractive && $ed369714155b8cc4$var$brandSelectedSplitButtonStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $ed369714155b8cc4$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $ed369714155b8cc4$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $ed369714155b8cc4$var$selectedStyles.discovery, isDisabled && $ed369714155b8cc4$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $ed369714155b8cc4$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $ed369714155b8cc4$var$defaultStyles.disabled, spacing === 'compact' && $ed369714155b8cc4$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $ed369714155b8cc4$var$styles.circle, shouldFitContainer && $ed369714155b8cc4$var$styles.fullWidth, hasIconBefore && $ed369714155b8cc4$var$styles.buttonIconBefore, hasIconAfter && $ed369714155b8cc4$var$styles.buttonIconAfter, isIconButton && $ed369714155b8cc4$var$styles.iconButton, isIconButton && spacing === 'compact' && $ed369714155b8cc4$var$styles.iconButtonCompact, isLoading && $ed369714155b8cc4$var$styles.loading, isSplitButton && $ed369714155b8cc4$var$styles.splitButton, isNavigationSplitButton && $ed369714155b8cc4$var$styles.navigationSplitButton, rootXcss),
        isDisabled: isDisabled,
        "aria-live": "polite",
        ...isLoading && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$ed369714155b8cc4$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $2H7sr.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $9P9F7.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    className: (0, $2R2iS.default)([
                        $ed369714155b8cc4$var$styles.loadingOverlay
                    ]),
                    children: (0, $lnPDH.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                    id: loadingLabelId,
                    children: $ed369714155b8cc4$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $ed369714155b8cc4$export$2e2bcd8739ae039 = $ed369714155b8cc4$var$ButtonBase;

});
parcelRegister("EawnW", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $59008ec41e9b29e7$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jdt4T = parcelRequire("jdt4T");

var $7iKPB = parcelRequire("7iKPB");

var $R8XYI = parcelRequire("R8XYI");

var $9JZL9 = parcelRequire("9JZL9");

var $fVzQQ = parcelRequire("fVzQQ");

var $ipCDL = parcelRequire("ipCDL");
const $59008ec41e9b29e7$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
const $59008ec41e9b29e7$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $9JZL9.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ipCDL.Focusable), {
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $R8XYI.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $jdt4T.cx)($59008ec41e9b29e7$var$styles.root, isDisabled && $59008ec41e9b29e7$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});

});
parcelRegister("R8XYI", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $c8c81986715398fa$export$95df08bae54cb4df);
function $c8c81986715398fa$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        const ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("ipCDL", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $14d1c43c86c908ce$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $14d1c43c86c908ce$var$focusRingStyles = null;
const $14d1c43c86c908ce$var$insetFocusRingStyles = null;
const $14d1c43c86c908ce$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2R2iS.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});

});


parcelRegister("9P9F7", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $7ea4313c67e972d9$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");
const $7ea4313c67e972d9$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});

parcelRegister("cokUz", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $e6e10d73ecf83cbd$export$47e2c6fdb142d947);

var $fc4bM = parcelRequire("fc4bM");

var $9P9F7 = parcelRequire("9P9F7");
const $e6e10d73ecf83cbd$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $fc4bM.useContext)((0, $9P9F7.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("2H7sr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d6c468278926f6f$export$2e2bcd8739ae039);
function $9d6c468278926f6f$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $9d6c468278926f6f$var$tabKeyCode = 9;
function $9d6c468278926f6f$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $9d6c468278926f6f$var$tabKeyCode) return;
    $9d6c468278926f6f$var$abort(event);
}
function $9d6c468278926f6f$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $9d6c468278926f6f$var$abort,
        onMouseUpCapture: $9d6c468278926f6f$var$abort,
        onKeyDownCapture: $9d6c468278926f6f$var$onKey,
        onKeyUpCapture: $9d6c468278926f6f$var$onKey,
        onTouchStartCapture: $9d6c468278926f6f$var$abort,
        onTouchEndCapture: $9d6c468278926f6f$var$abort,
        onPointerDownCapture: $9d6c468278926f6f$var$abort,
        onPointerUpCapture: $9d6c468278926f6f$var$abort,
        onClickCapture: $9d6c468278926f6f$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $9d6c468278926f6f$var$abort
    } : events;
}

});

parcelRegister("lnPDH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e20f3bde022bef0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $hculA = parcelRequire("hculA");
function $6e20f3bde022bef0$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $6e20f3bde022bef0$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $6e20f3bde022bef0$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
        size: $6e20f3bde022bef0$var$getIconSpacing(spacing),
        appearance: $6e20f3bde022bef0$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("6m8y3", function(module, exports) {
$parcel$export(module.exports, "default", () => $096a8fddcdbbafd5$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");
const $096a8fddcdbbafd5$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $096a8fddcdbbafd5$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            $096a8fddcdbbafd5$var$styles.common,
            type === 'text' && $096a8fddcdbbafd5$var$styles.text,
            type === 'icon' && $096a8fddcdbbafd5$var$styles.icon,
            isLoading && $096a8fddcdbbafd5$var$styles.fade
        ]),
        children: children
    });
};
var $096a8fddcdbbafd5$export$2e2bcd8739ae039 = $096a8fddcdbbafd5$var$Content;

});

parcelRegister("dw5IO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e616c9c1497db446$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
function $e616c9c1497db446$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * How far an icon can move past its box before it reaches the border of the button, which is the
 * space around the icon in the button minus the width of the border, so that the icon doesn't go
 * over the border. Passed to icon render props so that, for example, `IconMotion` can use it as its
 * `overshoot`. These are worked out once here, as every icon in every button goes through this file.
 */ const $e616c9c1497db446$var$OVERSHOOT_DEFAULT = `calc(${"var(--ds-space-100, 8px)"} - ${"var(--ds-border-width, 1px)"})`;
const $e616c9c1497db446$var$OVERSHOOT_COMPACT = `calc(${"var(--ds-space-050, 4px)"} - ${"var(--ds-border-width, 1px)"})`;
const $e616c9c1497db446$var$getOvershoot = (spacing)=>spacing === 'compact' ? $e616c9c1497db446$var$OVERSHOOT_COMPACT : $e616c9c1497db446$var$OVERSHOOT_DEFAULT;
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $e616c9c1497db446$var$IconRenderer = ({ icon: Icon, spacing: spacing })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $e616c9c1497db446$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dRkX9.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // Only a render prop can use `motionOvershoot`, so an icon component doesn't get it
    const icon = isRenderProp ? Icon({
        ...iconProps,
        motionOvershoot: $e616c9c1497db446$var$getOvershoot(spacing)
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
        ...iconProps
    });
    // @ts-expect-error -- The render-prop guard returns IconProp (a component type), which is not a ReactNode.
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: icon
    });
};
var $e616c9c1497db446$export$2e2bcd8739ae039 = $e616c9c1497db446$var$IconRenderer;

});


parcelRegister("f69ft", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd264112f4a6872d04b33e03dd95c892>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afde971f0dc5cf07$var$_react = $afde971f0dc5cf07$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $afde971f0dc5cf07$var$_iconNew = $afde971f0dc5cf07$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $afde971f0dc5cf07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afde971f0dc5cf07$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $afde971f0dc5cf07$var$_react.default.createElement($afde971f0dc5cf07$var$_iconNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$afde971f0dc5cf07$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $afde971f0dc5cf07$var$_default = module.exports.default = $afde971f0dc5cf07$var$ChevronUpIcon;

});

parcelRegister("gV8E5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c518ad0b7e6b6c01$var$_react = $c518ad0b7e6b6c01$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $c518ad0b7e6b6c01$var$_iconNew = $c518ad0b7e6b6c01$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $c518ad0b7e6b6c01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c518ad0b7e6b6c01$var$CrossIcon = (props)=>/*#__PURE__*/ $c518ad0b7e6b6c01$var$_react.default.createElement($c518ad0b7e6b6c01$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$c518ad0b7e6b6c01$var$CrossIcon.displayName = 'CrossIcon';
var $c518ad0b7e6b6c01$var$_default = module.exports.default = $c518ad0b7e6b6c01$var$CrossIcon;

});


parcelRegister("9LyRN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cf50bf9e421974c$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ /* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $iXBtU = parcelRequire("iXBtU");

var $4CgiI = parcelRequire("4CgiI");

var $khBwH = parcelRequire("khBwH");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $cJzRi = parcelRequire("cJzRi");
const $2cf50bf9e421974c$var$styles = {
    expander: "_1bsb1osq",
    expanderTransition: "_k8m0wor5 _1oec1mzy _156yru3m",
    expanderCollapsed: "_1reo15vq _18m915vq",
    container: "_v5641xzp"
};
const $2cf50bf9e421974c$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    const isCollapseAnimationEnabled = (0, $dRkX9.fg)('platform-dst-flag-collapse-animation-fix');
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: (0, $4Cnkn.cx)($2cf50bf9e421974c$var$styles.expander, isCollapseAnimationEnabled && $2cf50bf9e421974c$var$styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && $2cf50bf9e421974c$var$styles.expanderCollapsed),
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4CgiI.default), {
                children: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                        xcss: (0, $4Cnkn.cx)(!isCollapseAnimationEnabled && $2cf50bf9e421974c$var$styles.container),
                        ...props,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cJzRi.Stack), {
                            space: "space.100",
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                                children: children
                            })
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2cf50bf9e421974c$export$2e2bcd8739ae039 = $2cf50bf9e421974c$var$Expander;

});

parcelRegister("gtbOt", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $e9927ad179aea935$export$e91ea202abb66350);

var $fc4bM = parcelRequire("fc4bM");

var $6hmrw = parcelRequire("6hmrw");
function $e9927ad179aea935$export$e91ea202abb66350() {
    return (0, $fc4bM.useContext)((0, $6hmrw.FlagGroupContext));
}

});



parcelRegister("48hlF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30255dd73074645c$var$_react = $30255dd73074645c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $30255dd73074645c$var$_iconNew = $30255dd73074645c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $30255dd73074645c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30255dd73074645c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $30255dd73074645c$var$_react.default.createElement($30255dd73074645c$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$30255dd73074645c$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $30255dd73074645c$var$_default = module.exports.default = $30255dd73074645c$var$CrossCircleIcon;

});





parcelRegister("hG4G8", function(module, exports) {
$parcel$export(module.exports, "default", () => $7508a884956a3fa0$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7508a884956a3fa0$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    genericErrorTitle: {
        id: 'cv.generic.error.title',
        defaultMessage: 'Error',
        description: 'Title of the error panel shown when a generic error has occurred.'
    },
    genericErrorDescription: {
        id: 'cv.generic.error.description',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred.'
    },
    genericSignUpErrorDescriptionUnified: {
        id: 'cv.generic.sign.up.error.description.unified',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again. If you continue to experience issues, {contactAdminLinkUnified}.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    genericSignUpErrorNoContactLinkDescription: {
        id: 'cv.generic.sign.up.error.no.contact.link.description.unified',
        defaultMessage: "We couldn\u2019t submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    refreshPageLinkText: {
        id: 'cv.generic.refresh.page.link.text',
        defaultMessage: 'refresh',
        description: 'The text is shown as a hyperlink label that triggers a page refresh, displayed within an error flag or error panel when a generic error has occurred.'
    },
    tellUsAboutIssueLinkText: {
        id: 'cv.generic.tell.about.issue.link.text',
        defaultMessage: 'tell us about this issue',
        description: 'Text shown for the tell us about this issue link, used to report errors.'
    },
    letUsKnowLinkText: {
        id: 'cv.generic.let.us.know.link.text',
        defaultMessage: 'let us know',
        description: 'Text shown for the let us know link, used to report errors.'
    },
    genericErrorRefreshPageAction: {
        id: 'cv.generic.error.refresh.page.action',
        defaultMessage: 'Refresh page',
        description: 'Label of the refresh page button on the error panel shown when a generic error has occurred.'
    },
    noNetworkTitle: {
        id: 'cv.no.network.title',
        defaultMessage: 'Check your connection',
        description: 'Title of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    noNetworkDescription: {
        id: 'cv.no.network.description.unified',
        defaultMessage: "It looks like you've lost your internet connection. Check your network and try again later.",
        description: 'Message body of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    signupEmailResendRateLimitedDescription: {
        defaultMessage: "There\u2019s an issue with sending the email at the moment. Try again later in 10 minutes",
        description: 'Message to notify the user that the sign up email has been rate limited',
        id: 'cv.sign.up.email.resend.rate.limited.description'
    },
    blockedTitle: {
        id: 'cv.signup.blocked.title',
        defaultMessage: 'Access Blocked',
        description: 'Title of the error panel shown when a blocked action occurs.'
    },
    blockedDescription: {
        id: 'cv.signup.blocked.description',
        defaultMessage: "The email isn't approved for access. Use another email and try again.",
        description: 'Message body of the error panel  shown when a blocked action occurs.'
    },
    invalidEmailTitle: {
        id: 'cv.signup.email.invalid.title',
        defaultMessage: 'Invalid Email',
        description: 'Title of the error panel shown when a invalid email is entered.'
    },
    invalidEmailDescription: {
        id: 'cv.signup.email.invalid.description',
        defaultMessage: 'You must specify a valid email address.',
        description: 'Message body of the error panel shown when a invalid email is entered.'
    },
    userProfileForgotPasswordFailedFlagTitle: {
        id: 'cv.user.profile.forgot.password.failed.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordFailedFlagDescription: {
        id: 'cv.user.profile.forgot.password.failed.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagTitle: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagDescription: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again in a few minutes.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    }
});

});




parcelRegister("dpJHP", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticleEpic", () => $e9181a8dd9b2a771$export$d67800395c791e52);

var $jFk35 = parcelRequire("jFk35");

var $4wNEu = parcelRequire("4wNEu");
parcelRequire("1zrpx");
var $1EWnP = parcelRequire("1EWnP");

var $jJWhr = parcelRequire("jJWhr");

var $aIVqJ = parcelRequire("aIVqJ");

var $ja4bY = parcelRequire("ja4bY");
const $e9181a8dd9b2a771$export$3361e9be8093ddcc = (response, articleId)=>{
    const parseAri = (0, $jJWhr.ConfluenceSpaceAri).parse(response.space.id);
    return {
        id: parseInt(articleId, 10),
        title: response.title,
        url: '',
        projects: response.projects.map((project)=>({
                projectId: parseInt(project.projectId, 10),
                portalId: parseInt(project.portalId, 10),
                projectAri: project.projectAri
            })),
        space: {
            key: response.space.key,
            id: parseInt(parseAri.spaceId, 10)
        },
        idInString: articleId,
        hostname: response.hostname
    };
};
const $e9181a8dd9b2a771$export$d67800395c791e52 = (action$)=>action$.ofType((0, $1EWnP.FETCH_CROSS_SITE_ARTICLE)).mergeMap((action)=>{
        const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = action.payload;
        return (0, $4wNEu.fetchCrossSiteArticles)({
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId || ''
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
            const articleResponse = $e9181a8dd9b2a771$export$3361e9be8093ddcc(response, articleId);
            return (0, $1EWnP.fetchArticleSuccess)(articleResponse);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)((0, $ja4bY.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $jFk35.Observable).of((0, $1EWnP.fetchArticleFailure)(articleId, error));
        });
    });

});
parcelRegister("4wNEu", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticles", () => $51a409851316a7c6$export$5cbd1a869c9b635a);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6LH8a = parcelRequire("6LH8a");

var $6dipk = parcelRequire("6dipk");

var $fUaVT = parcelRequire("fUaVT");
var $5svsU = parcelRequire("5svsU");

var $k2M4v = parcelRequire("k2M4v");

var $aIVqJ = parcelRequire("aIVqJ");

var $f60co = parcelRequire("f60co");
/**
 * Feature flag: kb_article_metadata_help_center_project_resolution
 *
 * When enabled, article-metadata uses helpCenterAri to resolve the project for portal-less
 * article URLs when projectAri is omitted.
 */ const $51a409851316a7c6$var$KB_ARTICLE_METADATA_HELP_CENTER_PROJECT_RESOLUTION = 'kb_article_metadata_help_center_project_resolution';
const $51a409851316a7c6$export$5cbd1a869c9b635a = ({ articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId })=>{
    const cloudId = (0, $6LH8a.getMeta)('tenant-id') || '';
    const activationId = (0, $6LH8a.getMeta)('activation-id');
    const pageAri = (0, $fUaVT.ConfluencePageAri).create({
        siteId: crossSiteTenantId,
        pageId: articleId
    }).toString();
    const useHelpCenterProjectResolution = (0, $k2M4v.default).checkGate($51a409851316a7c6$var$KB_ARTICLE_METADATA_HELP_CENTER_PROJECT_RESOLUTION);
    const projectAri = projectId ? (0, $5svsU.JiraProjectAri).create({
        projectId: projectId.toString(),
        siteId: cloudId
    }).toString() : undefined;
    const queryStringV2 = $6dipk.stringify({
        projectAri: projectAri,
        articleAri: pageAri,
        ...useHelpCenterProjectResolution ? {
            helpCenterAri: (0, $6LH8a.getHelpCenterAri)()
        } : {}
    });
    const uri = `${(0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/article-metadata?${queryStringV2}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        (0, $aIVqJ.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $jFk35.Observable).throw(e);
    });
};

});
parcelRegister("fUaVT", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAri", () => $b94491049a21e739$export$3f931dd15d96caff);

var $8WJIR = parcelRequire("8WJIR");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/confluence/page/manifest.ts
var $b94491049a21e739$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $8WJIR.ConfluencePageAriResourceOwner),
    resourceType: (0, $8WJIR.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $b94491049a21e739$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b94491049a21e739$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $b94491049a21e739$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b94491049a21e739$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $b94491049a21e739$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $b94491049a21e739$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $b94491049a21e739$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("8WJIR", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $68373514061304e4$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $68373514061304e4$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $68373514061304e4$export$da53e4f7db4c6a71 = "confluence", $68373514061304e4$export$636fc622562a2c5b = "page";

});

parcelRegister("bDhZ4", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $878149790e2e77cb$export$579ee78b1dcf0a11);

var $gYy9q = parcelRequire("gYy9q");
// src/core/registered-ari.ts
var $878149790e2e77cb$export$579ee78b1dcf0a11 = class extends (0, $gYy9q.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $gYy9q.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("gYy9q", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $c5bcbda294889447$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $c5bcbda294889447$export$44a7af7122933d6b);

var $4UxLu = parcelRequire("4UxLu");
// src/core/ari.ts
var $c5bcbda294889447$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $4UxLu.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $c5bcbda294889447$export$44a7af7122933d6b = class _AnyAri extends $c5bcbda294889447$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $4UxLu.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $4UxLu.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("4UxLu", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $3936956b4f26ef3b$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $3936956b4f26ef3b$export$ab4b293d0121b8ee);

var $6teZI = parcelRequire("6teZI");

var $hxWAf = parcelRequire("hxWAf");
// src/core/rules/cloud-id.ts
function $3936956b4f26ef3b$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $hxWAf.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $3936956b4f26ef3b$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $hxWAf.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $3936956b4f26ef3b$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $3936956b4f26ef3b$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $3936956b4f26ef3b$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $hxWAf.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $3936956b4f26ef3b$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $hxWAf.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $3936956b4f26ef3b$var$NUMBER_OF_ARI_SEGMENTS = 5, $3936956b4f26ef3b$export$4c3a8cde7a55740b = class extends (0, $6teZI.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $3936956b4f26ef3b$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), ariProperties.resourceIdSegmentFormats) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $6teZI.validateAriQualifier)(qualifier), (0, $6teZI.validatePlatformQualifier)(platformQualifier), $3936956b4f26ef3b$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $3936956b4f26ef3b$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $3936956b4f26ef3b$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $3936956b4f26ef3b$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, segmentFormats) {
        var _a;
        let expectedKeys = Object.keys(segmentFormats), slugVariables = (_a = slug.match(/\{(.*?)\}/g)) != null ? _a : [], finalVariable = slugVariables[slugVariables.length - 1], finalVariableKey = finalVariable == null ? void 0 : finalVariable.slice(1, -1), slugWithFinalSegmentFormat = slug.replace(/\{(.*?)\}/g, (_placeholder, key)=>{
            var _a2;
            let finalSegmentFormat = key === finalVariableKey ? segmentFormats[key] : void 0;
            return `(?<${key}>${(_a2 = finalSegmentFormat == null ? void 0 : finalSegmentFormat.source) != null ? _a2 : ".*?"})`;
        }), regexpResult = new RegExp(`^${slugWithFinalSegmentFormat}$`).exec(incomingSegments);
        if (!regexpResult) throw new (0, $hxWAf.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a2;
            if (!((_a2 = regexpResult.groups) != null && _a2[expectedKey])) throw new (0, $hxWAf.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $3936956b4f26ef3b$var$NUMBER_OF_ATI_SEGMENTS = 4, $3936956b4f26ef3b$var$AtiParser = class extends (0, $6teZI.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $3936956b4f26ef3b$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $6teZI.validateAtiQualifier)(qualifier), (0, $6teZI.validatePlatformQualifier)(platformQualifier), $3936956b4f26ef3b$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $3936956b4f26ef3b$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $6teZI.validateAtiQualifier)(qualifier), (0, $6teZI.validatePlatformQualifier)(platformQualifier), $3936956b4f26ef3b$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $3936956b4f26ef3b$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $3936956b4f26ef3b$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $3936956b4f26ef3b$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("6teZI", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $4b61151a8bfc1e06$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $4b61151a8bfc1e06$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $4b61151a8bfc1e06$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $4b61151a8bfc1e06$export$3d09a5c28ff3e040);

var $hxWAf = parcelRequire("hxWAf");
// src/core/rules/platform-qualifier.ts
function $4b61151a8bfc1e06$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $hxWAf.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $4b61151a8bfc1e06$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $hxWAf.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $4b61151a8bfc1e06$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $hxWAf.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $4b61151a8bfc1e06$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $hxWAf.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $4b61151a8bfc1e06$var$NUMBER_OF_BASE_SEGMENTS = 5, $4b61151a8bfc1e06$var$SEGMENT_SEPARATOR = ":", $4b61151a8bfc1e06$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($4b61151a8bfc1e06$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $hxWAf.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $4b61151a8bfc1e06$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($4b61151a8bfc1e06$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($4b61151a8bfc1e06$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("hxWAf", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $cc62f63b3d9eff66$export$2191b9da168c6cf0);
// src/errors.ts
var $cc62f63b3d9eff66$export$2191b9da168c6cf0 = class extends Error {
};

});






parcelRegister("5svsU", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $3f97f9a1b966c014$export$75a0a0a7cb0a58ae);

var $g349L = parcelRequire("g349L");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/jira/project/manifest.ts
var $3f97f9a1b966c014$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $g349L.JiraProjectAriResourceOwner),
    resourceType: (0, $g349L.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $3f97f9a1b966c014$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $3f97f9a1b966c014$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $3f97f9a1b966c014$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $3f97f9a1b966c014$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $3f97f9a1b966c014$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $3f97f9a1b966c014$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $3f97f9a1b966c014$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("g349L", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $baf0268bfa9c04d2$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $baf0268bfa9c04d2$export$736763838d3aa22e);
// src/jira/project/types.ts
var $baf0268bfa9c04d2$export$99d538a3b04916b1 = "jira", $baf0268bfa9c04d2$export$736763838d3aa22e = "project";

});


parcelRegister("f60co", function(module, exports) {
$parcel$export(module.exports, "APOLLO_STARGATE_CONTEXT_ROOT", () => $df0be25a7f9a63b6$export$f224912d4ec4705e);
const $df0be25a7f9a63b6$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

});


parcelRegister("1zrpx", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => (parcelRequire("1EWnP")).FETCH_ARTICLE);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => (parcelRequire("1EWnP")).FETCH_ARTICLE_FAILURE);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => (parcelRequire("1EWnP")).FETCH_ARTICLE_SUCCESS);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => (parcelRequire("1EWnP")).FETCH_CROSS_SITE_ARTICLE);
$parcel$export(module.exports, "fetchArticle", () => (parcelRequire("1EWnP")).fetchArticle);
$parcel$export(module.exports, "fetchArticleFailure", () => (parcelRequire("1EWnP")).fetchArticleFailure);
$parcel$export(module.exports, "fetchArticleSuccess", () => (parcelRequire("1EWnP")).fetchArticleSuccess);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => (parcelRequire("1EWnP")).fetchCrossSiteArticle);
parcelRequire("1EWnP");

});
parcelRegister("1EWnP", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => $f7ffdefdedb1a543$export$a55f0530be417648);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => $f7ffdefdedb1a543$export$2d213dcac7fc3339);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => $f7ffdefdedb1a543$export$862d1fc538bf047c);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => $f7ffdefdedb1a543$export$ffd65713f8cf7ee0);
$parcel$export(module.exports, "fetchArticle", () => $f7ffdefdedb1a543$export$b455945318d7989e);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => $f7ffdefdedb1a543$export$9b8d6025673edc75);
$parcel$export(module.exports, "fetchArticleSuccess", () => $f7ffdefdedb1a543$export$6910c63a4b3017af);
$parcel$export(module.exports, "fetchArticleFailure", () => $f7ffdefdedb1a543$export$b135c19fc249d3ab);

var $dv0hN = parcelRequire("dv0hN");
const $f7ffdefdedb1a543$export$a55f0530be417648 = 'epic.model.FETCH_ARTICLE';
const $f7ffdefdedb1a543$export$2d213dcac7fc3339 = 'state.persisted.article.FETCH_ARTICLE_SUCCESS';
const $f7ffdefdedb1a543$export$862d1fc538bf047c = 'state.persisted.article.FETCH_ARTICLE_FAILURE';
const $f7ffdefdedb1a543$export$ffd65713f8cf7ee0 = 'epic.model.FETCH_CROSS_SITE_ARTICLE';
const $f7ffdefdedb1a543$export$b455945318d7989e = (payload, meta)=>({
        meta: meta,
        ...(0, $dv0hN.buildModelsActionCreator)($f7ffdefdedb1a543$export$a55f0530be417648, 'kbPage')(payload)
    });
const $f7ffdefdedb1a543$export$9b8d6025673edc75 = (params)=>{
    const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = params;
    return {
        type: $f7ffdefdedb1a543$export$ffd65713f8cf7ee0,
        payload: {
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId,
            meta: meta
        }
    };
};
const $f7ffdefdedb1a543$export$6910c63a4b3017af = (article)=>({
        type: $f7ffdefdedb1a543$export$2d213dcac7fc3339,
        payload: article
    });
const $f7ffdefdedb1a543$export$b135c19fc249d3ab = (id, error)=>({
        type: $f7ffdefdedb1a543$export$862d1fc538bf047c,
        payload: {
            id: id,
            error: error
        }
    });

});


parcelRegister("jJWhr", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAri", () => $e5ef6d91590dd645$export$4e1bd9257e1b7213);

var $bZMdL = parcelRequire("bZMdL");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/confluence/space/manifest.ts
var $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bZMdL.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $bZMdL.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $e5ef6d91590dd645$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $e5ef6d91590dd645$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("bZMdL", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $8bbacbeb38ecccf5$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $8bbacbeb38ecccf5$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $8bbacbeb38ecccf5$export$204c4c730af505ce = "confluence", $8bbacbeb38ecccf5$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("ja4bY", function(module, exports) {
$parcel$export(module.exports, "logErrorToFailureEvent", () => $25ead16e7d622777$export$7c2011d2dfcd2230);
const $25ead16e7d622777$var$getErrorMessage = (error)=>{
    var _errorMessages;
    const nestedResponse = error.response;
    return (nestedResponse === null || nestedResponse === void 0 ? void 0 : nestedResponse.errorMessage) || error.errorMessage || ((_errorMessages = error.errorMessages) === null || _errorMessages === void 0 ? void 0 : _errorMessages.join(',')) || error.message;
};
const $25ead16e7d622777$var$getErrorStatus = (error)=>{
    const nestedResponse = error.response;
    return error.status || (nestedResponse === null || nestedResponse === void 0 ? void 0 : nestedResponse.statusCode) || error.statusCode;
};
const $25ead16e7d622777$export$7c2011d2dfcd2230 = (analyticsFailureEvent, error)=>{
    analyticsFailureEvent.update((payload)=>({
            ...payload,
            errorMessage: $25ead16e7d622777$var$getErrorMessage(error),
            status: $25ead16e7d622777$var$getErrorStatus(error)
        }));
    return analyticsFailureEvent;
};

});


parcelRegister("ixZ2N", function(module, exports) {
$parcel$export(module.exports, "default", () => $45595163038c7885$export$2e2bcd8739ae039);
parcelRequire("e19ob");
var $eSm63 = parcelRequire("eSm63");

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("kzuYB");
var $5QO1D = parcelRequire("5QO1D");

var $eXcu8 = parcelRequire("eXcu8");
const $45595163038c7885$export$21d16fd7fed1f163 = (action$)=>{
    return action$.filter((action)=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        action.type.startsWith('epic.model') && action.type !== (0, $eXcu8.FETCH_HELP_CENTER_BRANDING_MODEL)).switchMap(()=>(0, $b4gcU.default)({
            type: 'xsrfToken',
            params: {}
        }))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    .filter(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    (response)=>!!response && (!!response.xsrfToken || !!response.env.xsrfToken))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    .map((response)=>(0, $5QO1D.updateXsrfAction)(response.xsrfToken || response.env.xsrfToken)).catch((_)=>(0, $jFk35.Observable).never());
};
var $45595163038c7885$export$2e2bcd8739ae039 = (0, $eSm63.combineEpics)($45595163038c7885$export$21d16fd7fed1f163);

});
parcelRegister("b4gcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0f136e1bcd80d5d$export$2e2bcd8739ae039);

var $cCRUL = parcelRequire("cCRUL");
function $b0f136e1bcd80d5d$export$2e2bcd8739ae039(request, options) {
    return (0, $cCRUL.fetchModel)(request, options);
}

});
parcelRegister("cCRUL", function(module, exports) {
$parcel$export(module.exports, "fetchModel", () => $44528e30c8d93009$export$6146dff2e008af3d);

var $jFk35 = parcelRequire("jFk35");

var $6LH8a = parcelRequire("6LH8a");

var $aYMdQ = parcelRequire("aYMdQ");

var $9OCxq = parcelRequire("9OCxq");

var $gszEw = parcelRequire("gszEw");

var $4MjGQ = parcelRequire("4MjGQ");

var $aeF17 = parcelRequire("aeF17");

var $diqlM = parcelRequire("diqlM");
const $44528e30c8d93009$var$createBatchOperationalPayload = (modelType, batchingType)=>{
    return {
        action: batchingType,
        actionSubject: 'model-batched',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $44528e30c8d93009$var$mergeOrReplaceOptions = (obj1, obj2, modelType)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    if (!obj1 || obj1.id !== obj2.id) {
        (0, $4MjGQ.operationalEvent)($44528e30c8d93009$var$createBatchOperationalPayload(modelType, 'model-replaced'));
        return obj2;
    }
    return (0, $aYMdQ.mergeWith)(obj1, obj2, (value, srcValue, key)=>{
        if (key === 'expand' && value) {
            (0, $4MjGQ.operationalEvent)($44528e30c8d93009$var$createBatchOperationalPayload(modelType, 'model-merged'));
            // We merge expand arrays if it is from the same type and they have the same id.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            return (0, $aYMdQ.uniq)(srcValue.concat(value));
        }
        return undefined;
    });
};
function $44528e30c8d93009$var$fetchModels(requests) {
    const requestTypes = (0, $aYMdQ.uniq)(requests.map((request)=>request.type));
    // This will build up the request params. If the request type is the same and the id is different it will
    // replace the type params, else it will merge them together.
    // If it finds two expand arrays to merge together it will concat them together and ensure only unique values.
    const requestOptions = requests.reduce((obj, request)=>Object.keys(request.params || {}).length ? {
            ...obj,
            [request.type]: $44528e30c8d93009$var$mergeOrReplaceOptions(obj[request.type], request.params, request.type)
        } : obj, {});
    const modelContext = {
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        clientBasePath: (0, $diqlM.getBasePath)()
    };
    return (0, $9OCxq.requestModels)(requestTypes, requestOptions, modelContext).toPromise();
}
/**
 * A TS limitation results in this losing its arg type.
 * See: https://github.com/Microsoft/TypeScript/issues/29638
 *
 * As a work around we create another wrapping function and re-type it.
 */ const $44528e30c8d93009$var$secondaryBatchedFetchModels = (0, $aeF17.default)($44528e30c8d93009$var$fetchModels, 0);
const $44528e30c8d93009$var$primaryBatchedFetchModels = (0, $aeF17.default)($44528e30c8d93009$var$fetchModels, 0);
function $44528e30c8d93009$export$6146dff2e008af3d(request, { type: type, disableBatching: disableBatching } = {
    type: 'primary',
    disableBatching: false
}) {
    const modelContext = {
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        clientBasePath: (0, $diqlM.getBasePath)()
    };
    if ((0, $gszEw.ModelsCache).getInstance().shouldCache(request.type)) {
        const cachedData = (0, $gszEw.ModelsCache).getInstance().getFromCache(request);
        if (cachedData !== undefined) return (0, $jFk35.Observable).from(Promise.resolve(cachedData.response));
    }
    if (disableBatching) {
        const options = {
            [request.type]: request.params
        };
        return (0, $9OCxq.requestModels)([
            request.type
        ], options, modelContext);
    }
    const promise = type === 'secondary' ? $44528e30c8d93009$var$secondaryBatchedFetchModels(request).then((successResult)=>$44528e30c8d93009$export$8d0b7c1ef062bcaa(request, successResult)) : $44528e30c8d93009$var$primaryBatchedFetchModels(request).then((successResult)=>$44528e30c8d93009$export$8d0b7c1ef062bcaa(request, successResult));
    return (0, $jFk35.Observable).from(promise);
}
function $44528e30c8d93009$export$8d0b7c1ef062bcaa(request, modelsResponse) {
    const requestType = request.type;
    if ((0, $gszEw.ModelsCache).getInstance().shouldCache(requestType)) (0, $gszEw.ModelsCache).getInstance().putToCache(request, modelsResponse);
    return modelsResponse;
}

});
parcelRegister("9OCxq", function(module, exports) {
$parcel$export(module.exports, "requestModels", () => $241fd787d23ebc35$export$be054e1f3ca89815);

var $bTjsX = parcelRequire("bTjsX");

var $him7m = parcelRequire("him7m");

var $04E2Q = parcelRequire("04E2Q");

var $jFk35 = parcelRequire("jFk35");

var $hN5YJ = parcelRequire("hN5YJ");

var $aYMdQ = parcelRequire("aYMdQ");

var $6J2dj = parcelRequire("6J2dj");

var $4MjGQ = parcelRequire("4MjGQ");

var $diqlM = parcelRequire("diqlM");
const $241fd787d23ebc35$var$retryableStatusCodes = [
    429,
    500,
    502,
    503
];
const $241fd787d23ebc35$var$isRetryableStatusCode = (status)=>$241fd787d23ebc35$var$retryableStatusCodes.includes(status);
const $241fd787d23ebc35$var$MAX_RETRY_DELAY_MS = 30000;
const $241fd787d23ebc35$var$BASE_DELAY_MS = 10000;
const $241fd787d23ebc35$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    return Math.min(exponential, maxDelay) + Math.floor(Math.random() * 1000);
};
const $241fd787d23ebc35$var$NUMBER_OF_RETRIES = 2;
const $241fd787d23ebc35$var$createOperationalEvent = (models, numberOfRetries, success, status)=>{
    return {
        action: 'fetch',
        actionSubject: 'models',
        source: 'unknownSource',
        attributes: {
            models: models,
            numberOfRetries: numberOfRetries,
            success: success,
            status: status
        }
    };
};
const $241fd787d23ebc35$var$optionsNotAvailableInRestEndpoint = [
    'availableLanguages',
    'forgotPassword',
    'organisations',
    'portalsAndRequestTypes',
    'profileWebFragments',
    'sharedPortal',
    'timezones',
    'timezoneRegions',
    'xsrfToken',
    'portalsAndStatuses'
];
const $241fd787d23ebc35$var$setTimezoneMetaTag = (timezone)=>{
    const windowDocument = (0, $him7m.default).getDataRef();
    if (!timezone || !windowDocument) return;
    let metaTimezone = (0, $him7m.default).querySelector('meta[name="user-timezone"]');
    if (metaTimezone) metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
    else {
        metaTimezone = windowDocument.createElement('meta');
        metaTimezone.setAttribute('name', 'user-timezone');
        metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
        windowDocument.head.appendChild(metaTimezone);
    }
};
const $241fd787d23ebc35$var$addExtraImplicitDataRequirements = (types, options)=>{
    var _requestOptions$porta;
    const requestTypes = types.concat([]);
    // We want to clone child objects as well so we don't accidentally mutate them.
    // Not having it previously caused downstream actions to no longer have params after we deleted some propeties.
    const requestOptions = (0, $aYMdQ.cloneDeep)(options);
    if (requestTypes.includes('portal') && !requestTypes.includes('branding') && requestOptions.portal) {
        requestTypes.push('branding');
        requestOptions.branding = {
            id: requestOptions.portal.id
        };
    }
    // Implicitly add 'kbs' in portals requestOptions if fetchPortal is requested. // ref src/view/help-center/help-center-content/single-portal/index.tsx:15, projectId & isKbEnabled is considered to be present together
    if (requestTypes.includes('portal') && !((_requestOptions$porta = requestOptions.portal) !== null && _requestOptions$porta !== void 0 && (_requestOptions$porta = _requestOptions$porta.expand) !== null && _requestOptions$porta !== void 0 && _requestOptions$porta.includes('kbs'))) {
        var _requestOptions$porta2;
        (_requestOptions$porta2 = requestOptions.portal) === null || _requestOptions$porta2 === void 0 || (_requestOptions$porta2 = _requestOptions$porta2.expand) === null || _requestOptions$porta2 === void 0 || _requestOptions$porta2.push('kbs');
    }
    // Implicitly fetch portal if portalWebFragments defined portalId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.portalId && !requestTypes.includes('portal')) {
        if (requestOptions.portalWebFragments.portalPage === (0, $04E2Q.REQUEST_CREATE)) requestOptions.portal = {
            id: requestOptions.portalWebFragments.portalId
        };
        else {
            requestTypes.push('portal');
            requestOptions.portal = {
                id: requestOptions.portalWebFragments.portalId
            };
        }
    }
    // Implicitly fetch request create if portalWebFragments defined portalId and requestTypeId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.requestTypeId && requestOptions.portalWebFragments.portalPage === (0, $04E2Q.REQUEST_CREATE) && !requestTypes.includes('reqCreate')) requestOptions.reqCreate = {
        portalId: requestOptions.portalWebFragments.portalId,
        id: requestOptions.portalWebFragments.requestTypeId
    };
    if (requestTypes.includes('portal') && requestOptions.portal) requestOptions.portalId = requestOptions.portal.id;
    return {
        requestTypes: requestTypes,
        requestOptions: requestOptions
    };
};
const $241fd787d23ebc35$var$adjustRequestOptions = (options)=>{
    const requestOptions = {
        ...options
    };
    for(const key in requestOptions){
        if (requestOptions.hasOwnProperty(key)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        {
            if (requestOptions[key].portalId) // The backend needs this as a blanket rule.
            // If we run into any we add it onto the request options object.
            // Last one wins.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            requestOptions.portalId = requestOptions[key].portalId;
        }
    }
    for(const key in requestOptions)if ($241fd787d23ebc35$var$optionsNotAvailableInRestEndpoint.includes(key)) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    delete requestOptions[key];
    return requestOptions;
};
const $241fd787d23ebc35$var$getTraceId = (err)=>{
    let traceId = '';
    try {
        const { xhr: xhr } = err;
        traceId = xhr.getResponseHeader('Atl-Traceid') || '';
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get traceId from error', e);
    }
    return traceId;
};
const $241fd787d23ebc35$var$getAllResponseHeaders = (err)=>{
    let headers = '';
    try {
        const { xhr: xhr } = err;
        headers = xhr.getAllResponseHeaders();
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get headers from error', e);
    }
    return headers;
};
const $241fd787d23ebc35$export$a06581639cf24e1e = (modelsDescriptor, options, modelContext, context = (0, $diqlM.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $241fd787d23ebc35$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $241fd787d23ebc35$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((response)=>response.response).catch((err)=>{
        const traceId = $241fd787d23ebc35$var$getTraceId(err);
        const responseHeaders = $241fd787d23ebc35$var$getAllResponseHeaders(err);
        return (0, $jFk35.Observable).throw(err.response ? {
            traceId: traceId,
            responseHeaders: responseHeaders,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            status: err.response.status,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorMessages: err.response.errorMessages,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionUrl: err.response.nextActionUrl,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionDisplayText: err.response.nextActionDisplayText
        } : {
            traceId: traceId,
            responseHeaders: responseHeaders,
            status: err.status,
            errorMessages: []
        });
    });
};
const $241fd787d23ebc35$var$requestModelsWithRetries = (modelsDescriptor, options, modelContext, context = (0, $diqlM.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $241fd787d23ebc35$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    let retries = 0;
    return (0, $bTjsX.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $241fd787d23ebc35$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    }).pipe((0, $6J2dj.retryWhen)((errors)=>errors.mergeMap((errorValue)=>{
            retries += 1;
            const status = errorValue.status;
            if (!$241fd787d23ebc35$var$isRetryableStatusCode(status) || retries > $241fd787d23ebc35$var$NUMBER_OF_RETRIES) return (0, $jFk35.Observable).throw(errorValue);
            return (0, $jFk35.Observable).of(errorValue).delay($241fd787d23ebc35$var$maxExpBackoffWithJitter(retries, $241fd787d23ebc35$var$BASE_DELAY_MS, $241fd787d23ebc35$var$MAX_RETRY_DELAY_MS));
        })), (0, $6J2dj.map)((response)=>{
        if (retries > 0) //only send event if there were retries to avoid sending too many events
        (0, $4MjGQ.operationalEvent)($241fd787d23ebc35$var$createOperationalEvent(requestTypes, retries, true, undefined));
        //Update timezone meta tag when model response has user properties
        if (response.response) {
            var _modelResponse$user;
            const modelResponse = response.response;
            if (modelResponse !== null && modelResponse !== void 0 && (_modelResponse$user = modelResponse.user) !== null && _modelResponse$user !== void 0 && _modelResponse$user.timezone) {
                var _modelResponse$user2;
                $241fd787d23ebc35$var$setTimezoneMetaTag(modelResponse === null || modelResponse === void 0 || (_modelResponse$user2 = modelResponse.user) === null || _modelResponse$user2 === void 0 ? void 0 : _modelResponse$user2.timezone);
            }
        }
        return response.response;
    }), (0, $6J2dj.catchError)((err)=>{
        (0, $4MjGQ.operationalEvent)($241fd787d23ebc35$var$createOperationalEvent(requestTypes, retries, false, err.status));
        const traceId = $241fd787d23ebc35$var$getTraceId(err);
        const responseHeaders = $241fd787d23ebc35$var$getAllResponseHeaders(err);
        return new (0, $jFk35.Observable)((observer)=>{
            observer.error(err.response ? {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.response.status,
                errorMessages: err.response.errorMessages,
                nextActionUrl: err.response.nextActionUrl,
                nextActionDisplayText: err.response.nextActionDisplayText
            } : {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.status,
                errorMessages: []
            });
        });
    }));
};
const $241fd787d23ebc35$export$be054e1f3ca89815 = (modelsDescriptor, options, modelContext, context = (0, $diqlM.contextPath))=>{
    if ((0, $hN5YJ.isRetryMechanismTuningEnabled)()) return $241fd787d23ebc35$var$requestModelsWithRetries(modelsDescriptor, options, modelContext, context);
    return $241fd787d23ebc35$export$a06581639cf24e1e(modelsDescriptor, options, modelContext, context);
};

});
parcelRegister("04E2Q", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER", () => $2c8ea0bd777ba9f7$export$8e46b442a40fd146);
$parcel$export(module.exports, "PORTAL_HOME", () => $2c8ea0bd777ba9f7$export$e7639abf9d430473);
$parcel$export(module.exports, "REQUEST_CREATE", () => $2c8ea0bd777ba9f7$export$722b80b55a1414f);
$parcel$export(module.exports, "REQUEST_DETAILS", () => $2c8ea0bd777ba9f7$export$9e5185d6a2a60dc);
$parcel$export(module.exports, "REQUEST_LIST", () => $2c8ea0bd777ba9f7$export$805e3047ef7cb33e);
$parcel$export(module.exports, "PROFILE", () => $2c8ea0bd777ba9f7$export$91c3232a793620f2);
$parcel$export(module.exports, "PROFILE_PANEL", () => $2c8ea0bd777ba9f7$export$b87ce3f352c7af33);
$parcel$export(module.exports, "REQUEST_CREATE_PANEL", () => $2c8ea0bd777ba9f7$export$fcdaac8f3aa2d02e);
$parcel$export(module.exports, "HEADER", () => $2c8ea0bd777ba9f7$export$526a1e214ba17198);
$parcel$export(module.exports, "SUB_HEADER", () => $2c8ea0bd777ba9f7$export$9e49b02bf8c4161f);
$parcel$export(module.exports, "FOOTER", () => $2c8ea0bd777ba9f7$export$d8d929c77d921e7d);
$parcel$export(module.exports, "DETAILS", () => $2c8ea0bd777ba9f7$export$e094c4db500be584);
$parcel$export(module.exports, "DETAILS_SIDE_SECTION", () => $2c8ea0bd777ba9f7$export$6c81f8b23c0dd1d2);
$parcel$export(module.exports, "ConnectFragment", () => $2c8ea0bd777ba9f7$export$aa8ab018415f92e4);

var $fc4bM = parcelRequire("fc4bM");

var $eENmG = parcelRequire("eENmG");

var $eFuYD = parcelRequire("eFuYD");

var $6PMii = parcelRequire("6PMii");

var $1yEgh = parcelRequire("1yEgh");
const $2c8ea0bd777ba9f7$export$8e46b442a40fd146 = 'HELP_CENTER';
const $2c8ea0bd777ba9f7$export$e7639abf9d430473 = 'PORTAL';
const $2c8ea0bd777ba9f7$export$722b80b55a1414f = 'CREATE_REQUEST';
const $2c8ea0bd777ba9f7$export$9e5185d6a2a60dc = 'VIEW_REQUEST';
const $2c8ea0bd777ba9f7$export$805e3047ef7cb33e = 'MY_REQUESTS';
const $2c8ea0bd777ba9f7$export$91c3232a793620f2 = 'PROFILE';
const $2c8ea0bd777ba9f7$export$b87ce3f352c7af33 = 'profilePagePanel';
const $2c8ea0bd777ba9f7$export$fcdaac8f3aa2d02e = 'requestCreatePanel';
const $2c8ea0bd777ba9f7$export$526a1e214ba17198 = 'headerPanels';
const $2c8ea0bd777ba9f7$export$9e49b02bf8c4161f = 'subheaderPanels';
const $2c8ea0bd777ba9f7$export$d8d929c77d921e7d = 'footerPanels';
const $2c8ea0bd777ba9f7$export$e094c4db500be584 = 'detailsPanels';
const $2c8ea0bd777ba9f7$export$6c81f8b23c0dd1d2 = 'optionPanels';
class $2c8ea0bd777ba9f7$export$aa8ab018415f92e4 extends $fc4bM.Component {
    componentDidMount() {
        const { fetchConnectFragments: fetchConnectFragments, page: page, connectFragments: connectFragments, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        if (!connectFragments) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        else this.fireConnectFragmentAnalytics();
        this.fireShowConnectBlockedAppsBanner();
    }
    componentDidUpdate(prevProps) {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId || prevProps.portalId !== portalId;
        if (requestTypeUpdated) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        if (!prevProps.connectFragments && connectFragments) this.fireConnectFragmentAnalytics();
        else if (prevProps.connectFragments && connectFragments) {
            const previouslyErrored = 'error' in prevProps.connectFragments;
            const currentlyErrored = 'error' in connectFragments;
            if (previouslyErrored !== currentlyErrored) this.fireConnectFragmentAnalytics();
        }
        if (prevProps.projectId !== this.props.projectId) this.fireShowConnectBlockedAppsBanner();
    }
    render() {
        const { connectFragments: connectFragments, className: className, location: location } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $1yEgh.default), {
            location: location,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            connectFragments: connectFragments
        });
    }
    constructor(...args){
        super(...args), this.fireShowConnectBlockedAppsBanner = ()=>{
            const { page: page, projectId: projectId } = this.props;
            if ((0, $6PMii.isConnectBlockedAppsRelevantPage)(page)) {
                this.props.resetBannerState(page);
                if (projectId) (0, $6PMii.fetchIsAnyConnectAppBlocked)({
                    projectId: projectId,
                    page: page
                }).then((isBlocked)=>{
                    if (isBlocked) this.props.showBanner(page);
                }).catch(()=>{
                // The error is already logged in the fetchIsAnyConnectAppBlocked function
                });
            }
        }, this.fireConnectFragmentAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, connectFragments: connectFragments, location: location, portalId: portalId, requestTypeId: requestTypeId } = this.props;
            if (!createAnalyticsEvent || !connectFragments) return;
            const isError = 'error' in connectFragments;
            if (!isError && connectFragments.length === 0) return;
            const uniqueAppKeys = !isError ? (0, $eFuYD.getUniqueAppKeysFromConnectFragments)(connectFragments) : [];
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                location: location,
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: isError ? 'failed' : 'loaded',
                appKeys: uniqueAppKeys
            });
            analyticsEvent.fire();
        };
    }
}

});
parcelRegister("6PMii", function(module, exports) {
$parcel$export(module.exports, "isConnectBlockedAppsRelevantPage", () => $5ba8d7ca6d40371d$export$aa2542e596000b48);
$parcel$export(module.exports, "fetchIsAnyConnectAppBlocked", () => $5ba8d7ca6d40371d$export$40f1d90131a12a2);

var $bTjsX = parcelRequire("bTjsX");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $5ba8d7ca6d40371d$var$perProjectRequestCache = new Map();
const $5ba8d7ca6d40371d$export$aa2542e596000b48 = (page)=>{
    const relevantConnectPages = [
        'PORTAL',
        'CREATE_REQUEST',
        'VIEW_REQUEST'
    ];
    return relevantConnectPages.includes(page);
};
const $5ba8d7ca6d40371d$export$40f1d90131a12a2 = (context)=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/atlassian-connect/latest/addon-access`;
    const body = {
        context: context
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const cacheKey = context.projectId.toString();
    let cachedRequest = $5ba8d7ca6d40371d$var$perProjectRequestCache.get(cacheKey);
    if (!cachedRequest) {
        cachedRequest = (0, $bTjsX.post)(uri, body, headers).map(({ response: response })=>response.isAnyAppBlocked).catch((e)=>{
            (0, $aIVqJ.trackError)('connect.blocked-apps.fetch.failed', {}, e);
            return Promise.reject(e);
        }).toPromise();
        $5ba8d7ca6d40371d$var$perProjectRequestCache.set(cacheKey, cachedRequest);
    }
    return cachedRequest;
};

});

parcelRegister("1yEgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e97a3c14046d2cae$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $9Bdk5 = parcelRequire("9Bdk5");
const $e97a3c14046d2cae$var$ConnectFragmentsDumb = ({ connectFragments: connectFragments, className: className, location: location })=>{
    if (!connectFragments || 'error' in connectFragments) return null;
    if (connectFragments.length) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ $fc4bM.createElement($e97a3c14046d2cae$var$Root, {
        className: className
    }, connectFragments.map((fragment)=>/*#__PURE__*/ $fc4bM.createElement((0, $9Bdk5.default), {
            key: fragment.key,
            fullKey: fragment.key,
            location: location,
            fragmentHtml: fragment.html
        }))));
    return null;
};
var $e97a3c14046d2cae$export$2e2bcd8739ae039 = $e97a3c14046d2cae$var$ConnectFragmentsDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e97a3c14046d2cae$var$Root = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-19x1uwk-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("luz1X", function(module, exports) {
$parcel$export(module.exports, "css", () => $a99c71ed134b41a3$export$dbf350e5966cf602);
$parcel$export(module.exports, "injectGlobal", () => $a99c71ed134b41a3$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "keyframes", () => $a99c71ed134b41a3$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeProvider", () => $a99c71ed134b41a3$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $a99c71ed134b41a3$export$e8748c6a27b910dc);
$parcel$export(module.exports, "default", () => $a99c71ed134b41a3$export$2e2bcd8739ae039);

var $hlToM = parcelRequire("hlToM");
const { css: $a99c71ed134b41a3$export$dbf350e5966cf602, injectGlobal: $a99c71ed134b41a3$export$efb9f5caaa2ca0c7, keyframes: $a99c71ed134b41a3$export$d25ddfdf17c3ad3e, ThemeProvider: $a99c71ed134b41a3$export$d8964aec282183a3, default: $a99c71ed134b41a3$var$styled } = $hlToM;
// Custom type definition for withTheme method for styled components so that
// we don't have to manually inject theme props in storybook
const $a99c71ed134b41a3$export$e8748c6a27b910dc = (component)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $hlToM.withTheme(component);
var $a99c71ed134b41a3$export$2e2bcd8739ae039 = $a99c71ed134b41a3$var$styled;

});
parcelRegister("hlToM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "isStyledComponent", () => $ca1f5ed637621ffa$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "consolidateStreamedStyles", () => $ca1f5ed637621ffa$export$953e7e0c06f2f28b);
$parcel$export(module.exports, "css", () => $ca1f5ed637621ffa$export$dbf350e5966cf602);
$parcel$export(module.exports, "StyleSheetManager", () => $ca1f5ed637621ffa$export$a473771da2f0ff7c);
$parcel$export(module.exports, "ServerStyleSheet", () => $ca1f5ed637621ffa$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "ThemeProvider", () => $ca1f5ed637621ffa$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $ca1f5ed637621ffa$export$e8748c6a27b910dc);
$parcel$export(module.exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", () => $ca1f5ed637621ffa$export$84079c323bb0915e);
$parcel$export(module.exports, "keyframes", () => $ca1f5ed637621ffa$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "injectGlobal", () => $ca1f5ed637621ffa$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "default", () => $ca1f5ed637621ffa$export$2e2bcd8739ae039);

var $hhyTi = parcelRequire("hhyTi");

var $fc4bM = parcelRequire("fc4bM");

var $8hZo6 = parcelRequire("8hZo6");

var $lupZ7 = parcelRequire("lupZ7");

var $dso8W = parcelRequire("dso8W");

var $40tzq = parcelRequire("40tzq");

var $6y7BY = parcelRequire("6y7BY");

var $3jCFs = parcelRequire("3jCFs");
var $ca1f5ed637621ffa$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $ca1f5ed637621ffa$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $ca1f5ed637621ffa$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $ca1f5ed637621ffa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ca1f5ed637621ffa$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $ca1f5ed637621ffa$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $ca1f5ed637621ffa$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $ca1f5ed637621ffa$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $ca1f5ed637621ffa$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $ca1f5ed637621ffa$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $ca1f5ed637621ffa$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $ca1f5ed637621ffa$var$StyledComponentsError = function(_Error) {
    $ca1f5ed637621ffa$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $ca1f5ed637621ffa$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $ca1f5ed637621ffa$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $ca1f5ed637621ffa$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $ca1f5ed637621ffa$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($ca1f5ed637621ffa$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hhyTi)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $ca1f5ed637621ffa$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $ca1f5ed637621ffa$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $ca1f5ed637621ffa$var$isPlainObject(chunk) ? $ca1f5ed637621ffa$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $ca1f5ed637621ffa$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $ca1f5ed637621ffa$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($8hZo6)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $ca1f5ed637621ffa$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($8hZo6)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $ca1f5ed637621ffa$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $ca1f5ed637621ffa$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $ca1f5ed637621ffa$var$parsingRules;
        $ca1f5ed637621ffa$var$parsingRules = [];
        return parsedRules;
    }
};
var $ca1f5ed637621ffa$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($lupZ7)))(function(rule) {
    $ca1f5ed637621ffa$var$parsingRules.push(rule);
});
$ca1f5ed637621ffa$var$stylis.use([
    $ca1f5ed637621ffa$var$parseRulesPlugin,
    $ca1f5ed637621ffa$var$returnRulesPlugin
]);
$ca1f5ed637621ffa$var$stylisSplitter.use([
    $ca1f5ed637621ffa$var$parseRulesPlugin,
    $ca1f5ed637621ffa$var$returnRulesPlugin
]);
var $ca1f5ed637621ffa$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($ca1f5ed637621ffa$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $ca1f5ed637621ffa$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $ca1f5ed637621ffa$var$splitByRules = function splitByRules(css) {
    return $ca1f5ed637621ffa$var$stylisSplitter('', css);
};
// 
function $ca1f5ed637621ffa$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $ca1f5ed637621ffa$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $ca1f5ed637621ffa$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $ca1f5ed637621ffa$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $ca1f5ed637621ffa$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $ca1f5ed637621ffa$var$charsLength; x = Math.floor(x / $ca1f5ed637621ffa$var$charsLength))name = $ca1f5ed637621ffa$var$getAlphabeticChar(x % $ca1f5ed637621ffa$var$charsLength) + name;
    return $ca1f5ed637621ffa$var$getAlphabeticChar(x % $ca1f5ed637621ffa$var$charsLength) + name;
};
// 
var $ca1f5ed637621ffa$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $ca1f5ed637621ffa$var$EMPTY_ARRAY = Object.freeze([]);
var $ca1f5ed637621ffa$var$EMPTY_OBJECT = Object.freeze({});
// 
var $ca1f5ed637621ffa$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $ca1f5ed637621ffa$var$isPlainObject(styles)) // $FlowFixMe
    return $ca1f5ed637621ffa$var$flatten($ca1f5ed637621ffa$var$interleave($ca1f5ed637621ffa$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $ca1f5ed637621ffa$var$flatten($ca1f5ed637621ffa$var$interleave(styles, interpolations));
};
// 
var $ca1f5ed637621ffa$var$SC_ATTR = (typeof $3jCFs !== 'undefined' && undefined, 'data-styled-components');
var $ca1f5ed637621ffa$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $ca1f5ed637621ffa$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $ca1f5ed637621ffa$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $ca1f5ed637621ffa$var$DISABLE_SPEEDY = false;
// 
var $ca1f5ed637621ffa$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $ca1f5ed637621ffa$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($ca1f5ed637621ffa$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $ca1f5ed637621ffa$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $ca1f5ed637621ffa$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $ca1f5ed637621ffa$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $ca1f5ed637621ffa$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $ca1f5ed637621ffa$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $ca1f5ed637621ffa$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $ca1f5ed637621ffa$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $ca1f5ed637621ffa$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $ca1f5ed637621ffa$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $ca1f5ed637621ffa$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $ca1f5ed637621ffa$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $ca1f5ed637621ffa$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $ca1f5ed637621ffa$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $ca1f5ed637621ffa$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $ca1f5ed637621ffa$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($ca1f5ed637621ffa$var$SC_ATTR, '');
    var nonce = $ca1f5ed637621ffa$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $ca1f5ed637621ffa$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $ca1f5ed637621ffa$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $ca1f5ed637621ffa$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $ca1f5ed637621ffa$var$SC_ATTR + '="' + $ca1f5ed637621ffa$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $ca1f5ed637621ffa$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$ca1f5ed637621ffa$var$SC_ATTR] = $ca1f5ed637621ffa$var$stringifyNames(names), _props);
        var nonce = $ca1f5ed637621ffa$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement('style', $ca1f5ed637621ffa$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $ca1f5ed637621ffa$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $ca1f5ed637621ffa$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $ca1f5ed637621ffa$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $ca1f5ed637621ffa$var$sheetForTag(el);
        var insertIndex = $ca1f5ed637621ffa$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($ca1f5ed637621ffa$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $ca1f5ed637621ffa$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $ca1f5ed637621ffa$var$sheetForTag(el);
        var removalIndex = $ca1f5ed637621ffa$var$addUpUntilIndex(sizes, marker);
        $ca1f5ed637621ffa$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $ca1f5ed637621ffa$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $ca1f5ed637621ffa$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $ca1f5ed637621ffa$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $ca1f5ed637621ffa$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $ca1f5ed637621ffa$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $ca1f5ed637621ffa$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $ca1f5ed637621ffa$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $ca1f5ed637621ffa$var$wrapAsElement(css, names),
        toHTML: $ca1f5ed637621ffa$var$wrapAsHtmlTag(css, names)
    };
};
var $ca1f5ed637621ffa$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($ca1f5ed637621ffa$var$makeTextMarker(id));
};
var $ca1f5ed637621ffa$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $ca1f5ed637621ffa$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $ca1f5ed637621ffa$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $ca1f5ed637621ffa$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $ca1f5ed637621ffa$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $ca1f5ed637621ffa$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $ca1f5ed637621ffa$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $ca1f5ed637621ffa$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $ca1f5ed637621ffa$var$wrapAsElement(css, names),
        toHTML: $ca1f5ed637621ffa$var$wrapAsHtmlTag(css, names)
    };
};
var $ca1f5ed637621ffa$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $ca1f5ed637621ffa$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $ca1f5ed637621ffa$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $ca1f5ed637621ffa$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $ca1f5ed637621ffa$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $ca1f5ed637621ffa$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $ca1f5ed637621ffa$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $ca1f5ed637621ffa$var$wrapAsElement(css, names),
        toHTML: $ca1f5ed637621ffa$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $ca1f5ed637621ffa$var$makeServerTag = function makeServerTag() {
    return $ca1f5ed637621ffa$var$makeServerTagInternal();
};
var $ca1f5ed637621ffa$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($ca1f5ed637621ffa$var$IS_BROWSER && !forceServer) {
        var el = $ca1f5ed637621ffa$var$makeStyleTag(target, tagEl, insertBefore);
        if ($ca1f5ed637621ffa$var$DISABLE_SPEEDY) return $ca1f5ed637621ffa$var$makeBrowserTag(el, getImportRuleTag);
        else return $ca1f5ed637621ffa$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $ca1f5ed637621ffa$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $ca1f5ed637621ffa$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $ca1f5ed637621ffa$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $ca1f5ed637621ffa$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $ca1f5ed637621ffa$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $ca1f5ed637621ffa$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $ca1f5ed637621ffa$var$MAX_SIZE = void 0;
if ($ca1f5ed637621ffa$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $ca1f5ed637621ffa$var$MAX_SIZE = $ca1f5ed637621ffa$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $ca1f5ed637621ffa$var$MAX_SIZE = -1;
var $ca1f5ed637621ffa$var$sheetRunningId = 0;
var $ca1f5ed637621ffa$var$master = void 0;
var $ca1f5ed637621ffa$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ca1f5ed637621ffa$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $ca1f5ed637621ffa$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $ca1f5ed637621ffa$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $ca1f5ed637621ffa$var$sheetRunningId += 1;
        this.id = $ca1f5ed637621ffa$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$ca1f5ed637621ffa$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $ca1f5ed637621ffa$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($ca1f5ed637621ffa$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($ca1f5ed637621ffa$var$SC_ATTR) || '').trim().split($ca1f5ed637621ffa$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $ca1f5ed637621ffa$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $ca1f5ed637621ffa$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $ca1f5ed637621ffa$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $ca1f5ed637621ffa$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $ca1f5ed637621ffa$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $ca1f5ed637621ffa$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $ca1f5ed637621ffa$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $ca1f5ed637621ffa$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $fc4bM.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $ca1f5ed637621ffa$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $ca1f5ed637621ffa$var$master || ($ca1f5ed637621ffa$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $ca1f5ed637621ffa$var$_StyleSheetManager$ch;
var $ca1f5ed637621ffa$export$a473771da2f0ff7c = function(_Component) {
    $ca1f5ed637621ffa$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $ca1f5ed637621ffa$var$classCallCheck(this, StyleSheetManager);
        return $ca1f5ed637621ffa$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$ca1f5ed637621ffa$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $ca1f5ed637621ffa$var$StyleSheet(this.props.target);
        else throw new $ca1f5ed637621ffa$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $fc4bM.Component));
$ca1f5ed637621ffa$export$a473771da2f0ff7c.childContextTypes = ($ca1f5ed637621ffa$var$_StyleSheetManager$ch = {}, $ca1f5ed637621ffa$var$_StyleSheetManager$ch[$ca1f5ed637621ffa$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).instanceOf($ca1f5ed637621ffa$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).instanceOf($ca1f5ed637621ffa$export$ae8c7d15c8b89a20)
]).isRequired, $ca1f5ed637621ffa$var$_StyleSheetManager$ch);
// 
var $ca1f5ed637621ffa$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $ca1f5ed637621ffa$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $ca1f5ed637621ffa$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $ca1f5ed637621ffa$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ca1f5ed637621ffa$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $ca1f5ed637621ffa$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $ca1f5ed637621ffa$var$LIMIT = 200;
var $ca1f5ed637621ffa$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $ca1f5ed637621ffa$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $ca1f5ed637621ffa$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $ca1f5ed637621ffa$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $ca1f5ed637621ffa$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $ca1f5ed637621ffa$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $ca1f5ed637621ffa$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($ca1f5ed637621ffa$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($ca1f5ed637621ffa$var$dashesAtEnds, '');
}
// 
function $ca1f5ed637621ffa$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $ca1f5ed637621ffa$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $ca1f5ed637621ffa$var$generateDisplayName(target) {
    return $ca1f5ed637621ffa$var$isTag(target) ? 'styled.' + target : 'Styled(' + $ca1f5ed637621ffa$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $ca1f5ed637621ffa$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $ca1f5ed637621ffa$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $ca1f5ed637621ffa$var$ATTRIBUTE_NAME_CHAR = $ca1f5ed637621ffa$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $ca1f5ed637621ffa$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $ca1f5ed637621ffa$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $ca1f5ed637621ffa$var$validAttr = function(name) {
    return $ca1f5ed637621ffa$var$ATTRIBUTE_REGEX.test(name) || $ca1f5ed637621ffa$var$isCustomAttribute(name.toLowerCase());
};
// 
function $ca1f5ed637621ffa$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $ca1f5ed637621ffa$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $ca1f5ed637621ffa$var$_contextShape, $ca1f5ed637621ffa$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $ca1f5ed637621ffa$var$CHANNEL = '__styled-components__';
var $ca1f5ed637621ffa$var$CHANNEL_NEXT = $ca1f5ed637621ffa$var$CHANNEL + 'next__';
var $ca1f5ed637621ffa$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
});
var $ca1f5ed637621ffa$var$contextShape = ($ca1f5ed637621ffa$var$_contextShape = {}, $ca1f5ed637621ffa$var$_contextShape[$ca1f5ed637621ffa$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func, $ca1f5ed637621ffa$var$_contextShape[$ca1f5ed637621ffa$var$CHANNEL_NEXT] = $ca1f5ed637621ffa$var$CONTEXT_CHANNEL_SHAPE, $ca1f5ed637621ffa$var$_contextShape);
var $ca1f5ed637621ffa$var$warnChannelDeprecated = void 0;
var $ca1f5ed637621ffa$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $ca1f5ed637621ffa$export$d8964aec282183a3 = function(_Component) {
    $ca1f5ed637621ffa$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $ca1f5ed637621ffa$var$classCallCheck(this, ThemeProvider);
        var _this = $ca1f5ed637621ffa$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$ca1f5ed637621ffa$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $ca1f5ed637621ffa$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $ca1f5ed637621ffa$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$ca1f5ed637621ffa$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$ca1f5ed637621ffa$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$ca1f5ed637621ffa$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($ca1f5ed637621ffa$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $ca1f5ed637621ffa$var$_typeof(theme)) !== 'object') throw new $ca1f5ed637621ffa$var$StyledComponentsError(8);
        return $ca1f5ed637621ffa$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $fc4bM.Component));
$ca1f5ed637621ffa$export$d8964aec282183a3.childContextTypes = $ca1f5ed637621ffa$var$contextShape;
$ca1f5ed637621ffa$export$d8964aec282183a3.contextTypes = ($ca1f5ed637621ffa$var$_ThemeProvider$contex = {}, $ca1f5ed637621ffa$var$_ThemeProvider$contex[$ca1f5ed637621ffa$var$CHANNEL_NEXT] = $ca1f5ed637621ffa$var$CONTEXT_CHANNEL_SHAPE, $ca1f5ed637621ffa$var$_ThemeProvider$contex);
var $ca1f5ed637621ffa$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $ca1f5ed637621ffa$var$STATIC_EXECUTION_CONTEXT = {};
var $ca1f5ed637621ffa$var$modifiedContextShape = $ca1f5ed637621ffa$var$_extends({}, $ca1f5ed637621ffa$var$contextShape, ($ca1f5ed637621ffa$var$_babelHelpers$extends = {}, $ca1f5ed637621ffa$var$_babelHelpers$extends[$ca1f5ed637621ffa$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).instanceOf($ca1f5ed637621ffa$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).instanceOf($ca1f5ed637621ffa$export$ae8c7d15c8b89a20)
]), $ca1f5ed637621ffa$var$_babelHelpers$extends));
var $ca1f5ed637621ffa$var$identifiers = {};
/* We depend on components having unique IDs */ var $ca1f5ed637621ffa$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $ca1f5ed637621ffa$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($ca1f5ed637621ffa$var$identifiers[displayName] || 0) + 1;
    $ca1f5ed637621ffa$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $ca1f5ed637621ffa$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $ca1f5ed637621ffa$var$BaseStyledComponent = function(_Component) {
    $ca1f5ed637621ffa$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $ca1f5ed637621ffa$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $ca1f5ed637621ffa$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $ca1f5ed637621ffa$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$ca1f5ed637621ffa$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $ca1f5ed637621ffa$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$ca1f5ed637621ffa$var$hasInInheritanceChain(attr, (0, $fc4bM.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $ca1f5ed637621ffa$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$ca1f5ed637621ffa$var$CONTEXT_KEY] || $ca1f5ed637621ffa$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($ca1f5ed637621ffa$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$ca1f5ed637621ffa$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($ca1f5ed637621ffa$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $ca1f5ed637621ffa$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $ca1f5ed637621ffa$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $ca1f5ed637621ffa$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $ca1f5ed637621ffa$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $ca1f5ed637621ffa$var$_extends({}, this.attrs, {
            className: className
        });
        if ($ca1f5ed637621ffa$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $ca1f5ed637621ffa$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $ca1f5ed637621ffa$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $fc4bM.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $fc4bM.Component));
var $ca1f5ed637621ffa$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$ca1f5ed637621ffa$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $ca1f5ed637621ffa$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $ca1f5ed637621ffa$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $ca1f5ed637621ffa$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $ca1f5ed637621ffa$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $ca1f5ed637621ffa$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $ca1f5ed637621ffa$var$classCallCheck(this, StyledComponent);
                return $ca1f5ed637621ffa$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $ca1f5ed637621ffa$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($ca1f5ed637621ffa$var$isTag(tag) ? tag : $ca1f5ed637621ffa$var$escape($ca1f5ed637621ffa$var$getComponentName(tag)));
                var newOptions = $ca1f5ed637621ffa$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $ca1f5ed637621ffa$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $ca1f5ed637621ffa$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $ca1f5ed637621ffa$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $ca1f5ed637621ffa$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $ca1f5ed637621ffa$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($40tzq)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $ca1f5ed637621ffa$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $ca1f5ed637621ffa$var$areStylesCacheable = $ca1f5ed637621ffa$var$IS_BROWSER;
var $ca1f5ed637621ffa$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$ca1f5ed637621ffa$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $ca1f5ed637621ffa$var$isHMREnabled = null && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $ca1f5ed637621ffa$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($ca1f5ed637621ffa$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $ca1f5ed637621ffa$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$ca1f5ed637621ffa$var$isHMREnabled && $ca1f5ed637621ffa$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$ca1f5ed637621ffa$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $ca1f5ed637621ffa$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($ca1f5ed637621ffa$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $ca1f5ed637621ffa$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $ca1f5ed637621ffa$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $ca1f5ed637621ffa$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $ca1f5ed637621ffa$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $ca1f5ed637621ffa$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $ca1f5ed637621ffa$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($ca1f5ed637621ffa$var$murmurhash($ca1f5ed637621ffa$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $ca1f5ed637621ffa$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $ca1f5ed637621ffa$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $ca1f5ed637621ffa$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $ca1f5ed637621ffa$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ca1f5ed637621ffa$var$EMPTY_OBJECT;
        if (!(0, $6y7BY.isValidElementType)(tag)) throw new $ca1f5ed637621ffa$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $ca1f5ed637621ffa$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $ca1f5ed637621ffa$var$_extends({}, options, {
                attrs: $ca1f5ed637621ffa$var$_extends({}, options.attrs || $ca1f5ed637621ffa$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $ca1f5ed637621ffa$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $ca1f5ed637621ffa$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $ca1f5ed637621ffa$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $ca1f5ed637621ffa$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $ca1f5ed637621ffa$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $ca1f5ed637621ffa$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $ca1f5ed637621ffa$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$ca1f5ed637621ffa$var$CHANNEL_NEXT];
            var themeProp = $ca1f5ed637621ffa$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $ca1f5ed637621ffa$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $ca1f5ed637621ffa$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$ca1f5ed637621ffa$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $ca1f5ed637621ffa$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component);
    WithTheme.contextTypes = $ca1f5ed637621ffa$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $ca1f5ed637621ffa$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($40tzq)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $ca1f5ed637621ffa$export$84079c323bb0915e = {
    StyleSheet: $ca1f5ed637621ffa$var$StyleSheet
};
/* Instantiate singletons */ var $ca1f5ed637621ffa$var$ComponentStyle = $ca1f5ed637621ffa$var$_ComponentStyle($ca1f5ed637621ffa$var$generateAlphabeticName, $ca1f5ed637621ffa$var$flatten, $ca1f5ed637621ffa$var$stringifyRules);
var $ca1f5ed637621ffa$var$constructWithOptions = $ca1f5ed637621ffa$var$_constructWithOptions($ca1f5ed637621ffa$export$dbf350e5966cf602);
var $ca1f5ed637621ffa$var$StyledComponent = $ca1f5ed637621ffa$var$_StyledComponent($ca1f5ed637621ffa$var$ComponentStyle, $ca1f5ed637621ffa$var$constructWithOptions);
/* Instantiate exported singletons */ var $ca1f5ed637621ffa$export$d25ddfdf17c3ad3e = $ca1f5ed637621ffa$var$_keyframes($ca1f5ed637621ffa$var$generateAlphabeticName, $ca1f5ed637621ffa$var$stringifyRules, $ca1f5ed637621ffa$export$dbf350e5966cf602);
var $ca1f5ed637621ffa$export$efb9f5caaa2ca0c7 = $ca1f5ed637621ffa$var$_injectGlobal($ca1f5ed637621ffa$var$stringifyRules, $ca1f5ed637621ffa$export$dbf350e5966cf602);
var $ca1f5ed637621ffa$var$styled = $ca1f5ed637621ffa$var$_styled($ca1f5ed637621ffa$var$StyledComponent, $ca1f5ed637621ffa$var$constructWithOptions);
var $ca1f5ed637621ffa$export$2e2bcd8739ae039 = $ca1f5ed637621ffa$var$styled;

});
parcelRegister("hhyTi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $jWcEH = parcelRequire("jWcEH");
var $c94f16cd0d645a8f$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $c94f16cd0d645a8f$var$hyphenateStyleName(string) {
    return $jWcEH(string).replace($c94f16cd0d645a8f$var$msPattern, '-ms-');
}
module.exports = $c94f16cd0d645a8f$var$hyphenateStyleName;

});
parcelRegister("jWcEH", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $e83d402f29c5792c$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $e83d402f29c5792c$var$hyphenate(string) {
    return string.replace($e83d402f29c5792c$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $e83d402f29c5792c$var$hyphenate;

});


parcelRegister("8hZo6", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("lupZ7", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("40tzq", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $2eae198bcdcbc7a7$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $2eae198bcdcbc7a7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $2eae198bcdcbc7a7$var$defineProperty = Object.defineProperty;
var $2eae198bcdcbc7a7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $2eae198bcdcbc7a7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2eae198bcdcbc7a7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2eae198bcdcbc7a7$var$getPrototypeOf = Object.getPrototypeOf;
var $2eae198bcdcbc7a7$var$objectPrototype = $2eae198bcdcbc7a7$var$getPrototypeOf && $2eae198bcdcbc7a7$var$getPrototypeOf(Object);
function $2eae198bcdcbc7a7$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($2eae198bcdcbc7a7$var$objectPrototype) {
            var inheritedComponent = $2eae198bcdcbc7a7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2eae198bcdcbc7a7$var$objectPrototype) $2eae198bcdcbc7a7$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $2eae198bcdcbc7a7$var$getOwnPropertyNames(sourceComponent);
        if ($2eae198bcdcbc7a7$var$getOwnPropertySymbols) keys = keys.concat($2eae198bcdcbc7a7$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$2eae198bcdcbc7a7$var$REACT_STATICS[key] && !$2eae198bcdcbc7a7$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $2eae198bcdcbc7a7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $2eae198bcdcbc7a7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $2eae198bcdcbc7a7$var$hoistNonReactStatics;

});



parcelRegister("9Bdk5", function(module, exports) {
$parcel$export(module.exports, "default", () => $a99e67a55c5cfcea$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $eENmG = parcelRequire("eENmG");

var $eFuYD = parcelRequire("eFuYD");
class $a99e67a55c5cfcea$var$ConnectFragmentDumb extends $fc4bM.Component {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement("div", {
            ref: this.onRef,
            dangerouslySetInnerHTML: {
                __html: this.props.fragmentHtml
            }
        });
    }
    constructor(...args){
        super(...args), this.componentDidMount = ()=>{
            const { onMount: onMount } = this.props;
            onMount && onMount();
        }, this.onRef = (element)=>{
            if (element) this.savedElement = element;
            this.executeConnectIFrameScripts();
        }, this.executeConnectIFrameScripts = ()=>{
            if (this.savedElement) {
                // We manually go through each script tag and then clone it so that it will execute
                const scriptTags = this.savedElement.querySelectorAll('script') || [];
                Array.prototype.forEach.call(scriptTags, (scriptTag)=>{
                    if (scriptTag.parentNode) {
                        // We create a new script tag and then append it to the parent node this way it will execute properly.
                        // Upgrading @atlaskit/platform; fix these violations.
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                        const newScript = document.createElement('script');
                        newScript.innerHTML = scriptTag.innerHTML;
                        scriptTag.parentNode.replaceChild(newScript, scriptTag);
                    }
                });
            }
        }, this.componentDidUpdate = ()=>{
            // If we don't call this, then Connect addon iframes are not rendered when a component is reloaded
            this.executeConnectIFrameScripts();
        };
    }
}
var $a99e67a55c5cfcea$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'ConnectFragment'
})((0, $azARG.default)({
    onMount: (create, props)=>create({
            action: 'mounted',
            analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
            location: props.location ?? 'LocationUnknown',
            appKeys: [
                (0, $eFuYD.getAppKeyFromFullKey)(props.fullKey)
            ]
        }).fire()
})($a99e67a55c5cfcea$var$ConnectFragmentDumb));

});




parcelRegister("aeF17", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a93338d0e1bb9fb$export$2e2bcd8739ae039);

var $aYMdQ = parcelRequire("aYMdQ");
const $3a93338d0e1bb9fb$var$defer = ()=>{
    let resolve;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reject;
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: // @ts-ignore
        resolve,
        reject: // @ts-ignore
        reject
    };
};
const $3a93338d0e1bb9fb$var$proxyFunction = (func, wait, options = {})=>{
    let arrArg = [];
    let deferred = $3a93338d0e1bb9fb$var$defer();
    const callThenResetArgs = (args)=>{
        try {
            const result = func(args);
            deferred.resolve(result);
        } catch (err) {
            deferred.reject(err);
        }
        arrArg = [];
        deferred = $3a93338d0e1bb9fb$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $aYMdQ.debounce)(callThenResetArgs, wait, options);
    return (arg)=>{
        if (arg) arrArg = arrArg.concat(arg);
        debouncedFunc(arrArg);
        return deferred.promise;
    };
};
var $3a93338d0e1bb9fb$export$2e2bcd8739ae039 = $3a93338d0e1bb9fb$var$proxyFunction;

});



parcelRegister("kzuYB", function(module, exports) {
$parcel$export(module.exports, "updateEnvAction", () => (parcelRequire("5QO1D")).updateEnvAction);
$parcel$export(module.exports, "UPDATE_ENV", () => (parcelRequire("5QO1D")).UPDATE_ENV);
$parcel$export(module.exports, "updateXsrfAction", () => (parcelRequire("5QO1D")).updateXsrfAction);
$parcel$export(module.exports, "UPDATE_XSRF", () => (parcelRequire("5QO1D")).UPDATE_XSRF);

var $5QO1D = parcelRequire("5QO1D");

});
parcelRegister("5QO1D", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ENV", () => $2d1031c3fe982e4c$export$54fc9c8b94b5595f);
$parcel$export(module.exports, "UPDATE_XSRF", () => $2d1031c3fe982e4c$export$b024063085428a5d);
$parcel$export(module.exports, "updateEnvAction", () => $2d1031c3fe982e4c$export$b66da392cb9395e8);
$parcel$export(module.exports, "updateXsrfAction", () => $2d1031c3fe982e4c$export$1293ace05a0f6e97);
const $2d1031c3fe982e4c$export$54fc9c8b94b5595f = 'state.persisted.env.UPDATE_ENV';
const $2d1031c3fe982e4c$export$b024063085428a5d = 'state.persisted.env.UPDATE_XSRF';
const $2d1031c3fe982e4c$export$b66da392cb9395e8 = (env)=>({
        payload: env,
        type: $2d1031c3fe982e4c$export$54fc9c8b94b5595f
    });
const $2d1031c3fe982e4c$export$1293ace05a0f6e97 = (xsrf)=>({
        payload: xsrf,
        type: $2d1031c3fe982e4c$export$b024063085428a5d
    });

});


parcelRegister("eXcu8", function(module, exports) {
$parcel$export(module.exports, "FETCH_HELP_CENTER_MODEL", () => $8ed96f2580ee6723$export$5586a78b777598b9);
$parcel$export(module.exports, "INVALIDATE_HELP_CENTER_RELAY_STORE", () => $8ed96f2580ee6723$export$e3632d3a6ee981be);
$parcel$export(module.exports, "fetchHelpCenterAction", () => $8ed96f2580ee6723$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "invalidateHelpCenterStoreAction", () => $8ed96f2580ee6723$export$d06ed959afe649d4);
$parcel$export(module.exports, "FETCH_HELP_CENTER_BRANDING_MODEL", () => $8ed96f2580ee6723$export$d8cc5374b8afc050);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $8ed96f2580ee6723$export$42cfcdfd4935cc23);

var $dv0hN = parcelRequire("dv0hN");
const $8ed96f2580ee6723$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $8ed96f2580ee6723$export$e3632d3a6ee981be = 'epic.model.INVALIDATE_HELP_CENTER_RELAY_STORE';
const $8ed96f2580ee6723$export$61e2f9e78cb604c7 = (0, $dv0hN.buildModelsActionCreator)($8ed96f2580ee6723$export$5586a78b777598b9, 'sharedPortal');
const $8ed96f2580ee6723$export$d06ed959afe649d4 = ()=>({
        type: $8ed96f2580ee6723$export$e3632d3a6ee981be
    });
const $8ed96f2580ee6723$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $8ed96f2580ee6723$export$42cfcdfd4935cc23 = (0, $dv0hN.buildModelsActionCreator)($8ed96f2580ee6723$export$d8cc5374b8afc050, 'helpCenterBranding');

});


parcelRegister("ff9sd", function(module, exports) {
$parcel$export(module.exports, "handleAjaxErrorEpic", () => $f8feabb0d644d06b$export$91f7ef464c43cc97);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $fASm6 = parcelRequire("fASm6");
const $f8feabb0d644d06b$export$91f7ef464c43cc97 = (action$)=>{
    return action$.ofType((0, $5kfOu.HANDLE_AJAX_ERROR)).mergeMap((handleAjaxErrorAction)=>{
        const { error: error } = handleAjaxErrorAction.payload;
        // TODO: Handle errors that come directly from the backend already translated (https://jdog.jira-dev.com/browse/JNW-236)
        const errorDescriptor = (0, $fASm6.getDefaultError)(error);
        const genericAction = errorDescriptor.action === undefined ? undefined : [
            errorDescriptor.action
        ];
        const errorFlagAction = (0, $5kfOu.showErrorFlag)(errorDescriptor.title, errorDescriptor.description, genericAction);
        return (0, $jFk35.Observable).of(errorFlagAction);
    });
};

});

parcelRegister("OFS2L", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterBrandingEpic", () => $81db2e52886771bf$export$dbe2bc3705ae4647);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationSuccess", () => $81db2e52886771bf$export$8d56a889e7db4abe);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationFailure", () => $81db2e52886771bf$export$f0ef15072aa7d01f);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $alVAg = parcelRequire("alVAg");

var $eXcu8 = parcelRequire("eXcu8");

var $b6ZT9 = parcelRequire("b6ZT9");
parcelRequire("jjuxZ");
var $gwluP = parcelRequire("gwluP");

var $4f9An = parcelRequire("4f9An");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");

var $ja4bY = parcelRequire("ja4bY");
const $81db2e52886771bf$var$getAnnouncementBodyFromHCBrandingBody = (body, siteDefaultLanguageTag)=>{
    return {
        header: body.translations[siteDefaultLanguageTag].announcementHeader,
        message: body.translations[siteDefaultLanguageTag].announcementMessage
    };
};
/*
    Different APIs for admins and agents. Admins have permissions to update help center branding along
    with announcements so help center branding api is used. For the agents on the other hand announcement API is used.
    TODO: Separate out announcements from help center branding.
*/ const $81db2e52886771bf$var$getUpdateBrandingPromise = (body, canAdministerJira, rawBrandingResponse)=>{
    return !canAdministerJira && rawBrandingResponse ? (0, $b6ZT9.updateAnnouncement)($81db2e52886771bf$var$getAnnouncementBodyFromHCBrandingBody(body, rawBrandingResponse.siteDefaultLanguageTag)) : (0, $b6ZT9.updateBranding)(body);
};
const $81db2e52886771bf$export$dbe2bc3705ae4647 = (action$, store)=>{
    return action$.ofType((0, $alVAg.UPDATE_HELP_CENTER_BRANDING)).mergeMap((updateBrandingAction)=>{
        const { payload: payload, meta: meta } = updateBrandingAction;
        const { body: body } = payload;
        const state = store.getState();
        const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return $81db2e52886771bf$var$getUpdateBrandingPromise(body, canAdministerJira, rawBrandingResponse).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
            const modifiedResponse = rawBrandingResponse ? {
                ...rawBrandingResponse,
                ...response
            } : response;
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingModelAction)(modifiedResponse)), (0, $jFk35.Observable).of((0, $alVAg.clearHCPreviewModelAction)()));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && error.status >= 500) (0, $aIVqJ.legacySendEvent)((0, $ja4bY.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $alVAg.updateBrandingFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
        });
    });
};
const $81db2e52886771bf$export$8d56a889e7db4abe = (action$, store)=>{
    return action$.ofType((0, $alVAg.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS)).mergeMap((updateBrandingMutationSuccessAction)=>{
        const { response: response, meta: meta } = updateBrandingMutationSuccessAction;
        const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4f9An.updateThemeSideBarExperience).success();
        const modifiedResponse = rawBrandingResponse ? {
            ...rawBrandingResponse,
            ...response
        } : response;
        return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingModelAction)(modifiedResponse)), (0, $jFk35.Observable).of((0, $alVAg.clearHCPreviewModelAction)()), (0, $jFk35.Observable).of((0, $eXcu8.invalidateHelpCenterStoreAction)()));
    });
};
const $81db2e52886771bf$export$f0ef15072aa7d01f = (action$)=>{
    return action$.ofType((0, $alVAg.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE)).mergeMap((updateBrandingMutationFailureAction)=>{
        const { error: error, meta: meta } = updateBrandingMutationFailureAction;
        //const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        // const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return (0, $jFk35.Observable).from(Promise.reject(error)).catch((err)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(err.status)) (0, $aIVqJ.legacySendEvent)((0, $ja4bY.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            if (!(0, $17nJI.isNetworkOrClientErrorCode)(err.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $4f9An.updateThemeSideBarExperience).failure({
                metadata: {
                    error: err.message
                }
            });
            else // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $4f9An.updateThemeSideBarExperience).success();
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $alVAg.updateBrandingFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(err)));
        });
    });
};

});
parcelRegister("alVAg", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_PREVIEW_MODEL", () => $5eddb6845d806e1b$export$f0cfe50b4b81e5e5);
$parcel$export(module.exports, "CLEAR_HELP_CENTER_PREVIEW_MODEL", () => $5eddb6845d806e1b$export$61f6f0f25aef37a);
$parcel$export(module.exports, "EDITING_HELP_CENTER", () => $5eddb6845d806e1b$export$429f706ec067751a);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING", () => $5eddb6845d806e1b$export$e49dc7a9374bb0ed);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS", () => $5eddb6845d806e1b$export$75be5b55c825c5f4);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE", () => $5eddb6845d806e1b$export$bb6272ebd92e455f);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_FAILURE", () => $5eddb6845d806e1b$export$d249354c8afb6e40);
$parcel$export(module.exports, "UPLOAD_START", () => $5eddb6845d806e1b$export$b03358de8b670bd6);
$parcel$export(module.exports, "UPLOAD_END", () => $5eddb6845d806e1b$export$56dfdb40a4995b23);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_SAVE_START", () => $5eddb6845d806e1b$export$d6b07b90ea00e758);
$parcel$export(module.exports, "editingHelpCenter", () => $5eddb6845d806e1b$export$8f5c235cd10e8248);
$parcel$export(module.exports, "updateHCPreviewModelAction", () => $5eddb6845d806e1b$export$52aab28d032a2b51);
$parcel$export(module.exports, "clearHCPreviewModelAction", () => $5eddb6845d806e1b$export$1044307c0b2e2fc4);
$parcel$export(module.exports, "updateBranding", () => $5eddb6845d806e1b$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateBrandingMutationSuccess", () => $5eddb6845d806e1b$export$e7ca67101719c569);
$parcel$export(module.exports, "updateBrandingMutationFailure", () => $5eddb6845d806e1b$export$4522a481460f5735);
$parcel$export(module.exports, "updateBrandingSaveStart", () => $5eddb6845d806e1b$export$676616ec28a47579);
$parcel$export(module.exports, "updateBrandingFailure", () => $5eddb6845d806e1b$export$be3ae179d979bebe);
$parcel$export(module.exports, "uploadStart", () => $5eddb6845d806e1b$export$34ff845ea9831833);
$parcel$export(module.exports, "uploadEnd", () => $5eddb6845d806e1b$export$f986c9a8af4f4565);
const $5eddb6845d806e1b$export$f0cfe50b4b81e5e5 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_PREVIEW_MODEL';
const $5eddb6845d806e1b$export$61f6f0f25aef37a = 'state.ui.help-center-preview.CLEAR_HELP_CENTER_PREVIEW_MODEL';
const $5eddb6845d806e1b$export$429f706ec067751a = 'state.ui.help-center-preview.EDITING_HELP_CENTER';
const $5eddb6845d806e1b$export$e49dc7a9374bb0ed = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING';
const $5eddb6845d806e1b$export$75be5b55c825c5f4 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS';
const $5eddb6845d806e1b$export$bb6272ebd92e455f = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE';
const $5eddb6845d806e1b$export$d249354c8afb6e40 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_FAILURE';
const $5eddb6845d806e1b$export$b03358de8b670bd6 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_START';
const $5eddb6845d806e1b$export$56dfdb40a4995b23 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_END';
const $5eddb6845d806e1b$export$d6b07b90ea00e758 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_SAVE_START';
const $5eddb6845d806e1b$export$8f5c235cd10e8248 = (isEditing)=>({
        type: $5eddb6845d806e1b$export$429f706ec067751a,
        payload: isEditing
    });
const $5eddb6845d806e1b$export$52aab28d032a2b51 = (previewPayload)=>({
        payload: previewPayload,
        type: $5eddb6845d806e1b$export$f0cfe50b4b81e5e5
    });
const $5eddb6845d806e1b$export$1044307c0b2e2fc4 = ()=>({
        type: $5eddb6845d806e1b$export$61f6f0f25aef37a
    });
const $5eddb6845d806e1b$export$eb176b496ba6ad25 = (body, meta = {})=>({
        meta: meta,
        type: $5eddb6845d806e1b$export$e49dc7a9374bb0ed,
        payload: {
            body: body
        }
    });
const $5eddb6845d806e1b$export$e7ca67101719c569 = (response, meta = {})=>({
        meta: meta,
        response: response,
        type: $5eddb6845d806e1b$export$75be5b55c825c5f4
    });
const $5eddb6845d806e1b$export$4522a481460f5735 = (error, meta = {})=>({
        meta: meta,
        error: error,
        type: $5eddb6845d806e1b$export$bb6272ebd92e455f
    });
const $5eddb6845d806e1b$export$676616ec28a47579 = ()=>({
        type: $5eddb6845d806e1b$export$d6b07b90ea00e758
    });
const $5eddb6845d806e1b$export$be3ae179d979bebe = ()=>({
        type: $5eddb6845d806e1b$export$d249354c8afb6e40
    });
const $5eddb6845d806e1b$export$34ff845ea9831833 = (fileCollection)=>({
        type: $5eddb6845d806e1b$export$b03358de8b670bd6,
        payload: {
            fileCollection: fileCollection
        }
    });
const $5eddb6845d806e1b$export$f986c9a8af4f4565 = (fileCollection)=>({
        type: $5eddb6845d806e1b$export$56dfdb40a4995b23,
        payload: {
            fileCollection: fileCollection
        }
    });

});

parcelRegister("b6ZT9", function(module, exports) {
$parcel$export(module.exports, "BrandingTargetCollections", () => $1a4f662391c33e6b$export$b5e98a61473b07ad);
$parcel$export(module.exports, "getUploadTokenWithClientInfo", () => $1a4f662391c33e6b$export$1c22c9bf986a3d58);
$parcel$export(module.exports, "updateBranding", () => $1a4f662391c33e6b$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateAnnouncement", () => $1a4f662391c33e6b$export$159f65cfbafa86b5);

var $bTjsX = parcelRequire("bTjsX");

var $aYMdQ = parcelRequire("aYMdQ");

var $gszEw = parcelRequire("gszEw");

var $diqlM = parcelRequire("diqlM");
var $1a4f662391c33e6b$export$b5e98a61473b07ad = /*#__PURE__*/ function(BrandingTargetCollections) {
    BrandingTargetCollections["banner"] = "sd-banner-upload";
    BrandingTargetCollections["logo"] = "sd-logo-upload";
    return BrandingTargetCollections;
}({});
const $1a4f662391c33e6b$export$de87322aceb1e609 = async (targetCollection, context = (0, $diqlM.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    .map((ajaxResponse)=>ajaxResponse.response.token).toPromise();
};
const $1a4f662391c33e6b$export$1c22c9bf986a3d58 = async (targetCollection, context = (0, $diqlM.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-media-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise();
};
const $1a4f662391c33e6b$export$eb176b496ba6ad25 = (body, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/with-translations`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $gszEw.ModelsCache).getInstance().del('helpCenterBranding');
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
/*
    Map announcement response to help center branding response. Since we are using same epic and reducer for
    announcement API and help center branding API. TODO: A new epic for help center announcements.
*/ const $1a4f662391c33e6b$var$mapAnnouncementResponseToHelpCenterBrandingResponse = (ajaxResponse)=>{
    let modifiedTranslations = {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = ajaxResponse.response;
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    modifiedTranslations = (0, $aYMdQ.mapValues)(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    response.translations, (translation)=>({
            announcementHeader: translation.header,
            announcementMessage: translation.message
        }));
    return {
        translations: modifiedTranslations,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementHeader: response.header,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementMessageWiki: response.messageWiki
    };
};
const $1a4f662391c33e6b$export$159f65cfbafa86b5 = (body, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/announcement/help-center`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $gszEw.ModelsCache).getInstance().del('helpCenterBranding');
    return (0, $bTjsX.post)(uri, body, headers).map($1a4f662391c33e6b$var$mapAnnouncementResponseToHelpCenterBrandingResponse);
};

});

parcelRegister("jjuxZ", function(module, exports) {
$parcel$export(module.exports, "updateHCBrandingModelAction", () => (parcelRequire("gwluP")).updateHCBrandingModelAction);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => (parcelRequire("gwluP")).updateHelpCenterModelAction);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => (parcelRequire("gwluP")).updateHCBrandingLoaderAction);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => (parcelRequire("gwluP")).UPDATE_HELP_CENTER_BRANDING_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => (parcelRequire("gwluP")).UPDATE_HELP_CENTER_BRANDING_LOADER);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => (parcelRequire("gwluP")).UPDATE_HELP_CENTER_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => (parcelRequire("gwluP")).UPDATE_HELP_CENTER_THEME_COLOR);

var $gwluP = parcelRequire("gwluP");

});
parcelRegister("gwluP", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => $01e2821e76b76107$export$791f10ed5ca1afbc);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => $01e2821e76b76107$export$72877be1acecfff2);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => $01e2821e76b76107$export$51eff4874ab833ce);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => $01e2821e76b76107$export$749d9a3565d43c74);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => $01e2821e76b76107$export$9c200ab172652613);
$parcel$export(module.exports, "updateHCBrandingModelAction", () => $01e2821e76b76107$export$765a61788077a43a);
$parcel$export(module.exports, "updateHCThemeColorAction", () => $01e2821e76b76107$export$8865f165e0e8e610);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => $01e2821e76b76107$export$b9ec760cc662cf16);
const $01e2821e76b76107$export$791f10ed5ca1afbc = 'state.persisted.help-center.UPDATE_HELP_CENTER_MODEL';
const $01e2821e76b76107$export$72877be1acecfff2 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_MODEL';
const $01e2821e76b76107$export$51eff4874ab833ce = 'state.persisted.help-center.UPDATE_HELP_CENTER_THEME_COLOR';
const $01e2821e76b76107$export$749d9a3565d43c74 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_LOADER';
const $01e2821e76b76107$export$9c200ab172652613 = (modelResponse)=>({
        payload: modelResponse,
        type: $01e2821e76b76107$export$791f10ed5ca1afbc
    });
const $01e2821e76b76107$export$765a61788077a43a = (brandingResponse)=>({
        payload: brandingResponse,
        type: $01e2821e76b76107$export$72877be1acecfff2
    });
const $01e2821e76b76107$export$8865f165e0e8e610 = (themeColorResponse)=>({
        payload: themeColorResponse,
        type: $01e2821e76b76107$export$51eff4874ab833ce
    });
const $01e2821e76b76107$export$b9ec760cc662cf16 = (loaded)=>({
        payload: {
            loaded: loaded
        },
        type: $01e2821e76b76107$export$749d9a3565d43c74
    });

});


parcelRegister("4f9An", function(module, exports) {
$parcel$export(module.exports, "updateAnnouncementSideBarExperience", () => $951a4cab412b84be$export$9202b582e9a7e7e5);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperience", () => $951a4cab412b84be$export$bbfbb2132f16ad3e);
$parcel$export(module.exports, "updateThemeSideBarExperience", () => $951a4cab412b84be$export$d4df676089e680c5);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $951a4cab412b84be$export$9202b582e9a7e7e5 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.updateAnnouncementSideBarExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $951a4cab412b84be$export$bbfbb2132f16ad3e = new (0, $9LFKj.UFOExperience)((0, $fCHdA.updateLoginAnnouncementSideBarExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $951a4cab412b84be$export$d4df676089e680c5 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.updateThemeSideBarExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});
parcelRegister("fCHdA", function(module, exports) {
$parcel$export(module.exports, "ProductExperienceStart", () => $b0abd724ea2390c8$export$8c235a9c4b486599);
$parcel$export(module.exports, "externalLinksProductExperienceId", () => $b0abd724ea2390c8$export$df6053b3f6f8746e);
$parcel$export(module.exports, "yourApprovalExperienceId", () => $b0abd724ea2390c8$export$2748904bbde569a6);
$parcel$export(module.exports, "approvalStatusSectionExperienceId", () => $b0abd724ea2390c8$export$53d4142e5691fc30);
$parcel$export(module.exports, "publishLayoutExperienceId", () => $b0abd724ea2390c8$export$7706cfa126a5e293);
$parcel$export(module.exports, "topicsReorderExperienceId", () => $b0abd724ea2390c8$export$45f14e05062fc2ca);
$parcel$export(module.exports, "helpCenterTopicsProductExperienceId", () => $b0abd724ea2390c8$export$3bdaba26dccf5ee6);
$parcel$export(module.exports, "helpCenterViewHomePageExperienceId", () => $b0abd724ea2390c8$export$d165863a94dcab28);
$parcel$export(module.exports, "helpCenterTopicEditExperienceId", () => $b0abd724ea2390c8$export$d58e75689d75e480);
$parcel$export(module.exports, "helpCenterTopicViewExperienceId", () => $b0abd724ea2390c8$export$f1ae827b1686e4b6);
$parcel$export(module.exports, "viewHomepageExperienceId", () => $b0abd724ea2390c8$export$42633b810d73bab2);
$parcel$export(module.exports, "viewCustomPageExperienceId", () => $b0abd724ea2390c8$export$c25f92d477e645db);
$parcel$export(module.exports, "profileExperienceId", () => $b0abd724ea2390c8$export$6b7cf274ce127c6c);
$parcel$export(module.exports, "updateManageColumnsSidebarExperienceId", () => $b0abd724ea2390c8$export$1d4505191d749c3);
$parcel$export(module.exports, "editHomepageExperienceId", () => $b0abd724ea2390c8$export$f5b418a8fb4c2e52);
$parcel$export(module.exports, "editCustomPageExperienceId", () => $b0abd724ea2390c8$export$1a5dc88687c6c743);
$parcel$export(module.exports, "searchExperienceId", () => $b0abd724ea2390c8$export$8e695cad45fa9462);
$parcel$export(module.exports, "inlineSearchExperienceId", () => $b0abd724ea2390c8$export$ef4e3240bcfb0749);
$parcel$export(module.exports, "helpCenterReportingExperienceId", () => $b0abd724ea2390c8$export$a31e9803c7cf4e9c);
$parcel$export(module.exports, "helpCenterReportingContentGapExperienceId", () => $b0abd724ea2390c8$export$a49db1fcfecaa197);
$parcel$export(module.exports, "helpCentersManagementExperienceId", () => $b0abd724ea2390c8$export$28b0efc551538ce4);
$parcel$export(module.exports, "manageProjectsExperienceId", () => $b0abd724ea2390c8$export$8125d660e6f5341);
$parcel$export(module.exports, "managePagesExperienceId", () => $b0abd724ea2390c8$export$b3c36987f8f3e130);
$parcel$export(module.exports, "editHelpCenterExperienceId", () => $b0abd724ea2390c8$export$9d36a9a1a5392695);
$parcel$export(module.exports, "avatarMenuExperienceId", () => $b0abd724ea2390c8$export$ccd2c0d87dacec5b);
$parcel$export(module.exports, "updateAnnouncementSideBarExperienceId", () => $b0abd724ea2390c8$export$afc2346bbf17f6dc);
$parcel$export(module.exports, "updateSinglePortalAnnouncementSideBarExperienceId", () => $b0abd724ea2390c8$export$ad5e73bffe8e8683);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperienceId", () => $b0abd724ea2390c8$export$7b03636a868ec87a);
$parcel$export(module.exports, "updateThemeSideBarExperienceId", () => $b0abd724ea2390c8$export$3a07bc7f4f48662a);
$parcel$export(module.exports, "requestCreateEntitlementPickerExperienceId", () => $b0abd724ea2390c8$export$950826a562410f6a);
$parcel$export(module.exports, "csmContactsUFormPickerExperienceId", () => $b0abd724ea2390c8$export$eb5378d79d45e2ce);
$parcel$export(module.exports, "csmViewHomepageExperienceId", () => $b0abd724ea2390c8$export$cb86036c3a8f0a3d);

var $6Nd92 = parcelRequire("6Nd92");
const $b0abd724ea2390c8$export$8c235a9c4b486599 = (props)=>{
    const { ufoExperience: ufoExperience } = props;
    (0, $6Nd92.useUFOComponentExperience)(ufoExperience);
    return null;
};
const $b0abd724ea2390c8$export$df6053b3f6f8746e = 'service-management.help-center.external-resources';
const $b0abd724ea2390c8$export$2748904bbde569a6 = 'service-management.help-center.your-approval';
const $b0abd724ea2390c8$export$53d4142e5691fc30 = 'service-management.help-center.approval-status-section';
const $b0abd724ea2390c8$export$7706cfa126a5e293 = 'service-management.help-center.publish.layout';
const $b0abd724ea2390c8$export$45f14e05062fc2ca = 'service-management.help-center.topics.reorder';
const $b0abd724ea2390c8$export$3bdaba26dccf5ee6 = 'service-management.help-center.topics';
const $b0abd724ea2390c8$export$d165863a94dcab28 = 'service-management.help-center.view.homepage';
const $b0abd724ea2390c8$export$d58e75689d75e480 = 'service-management.help-center.topic.edit';
const $b0abd724ea2390c8$export$f1ae827b1686e4b6 = 'service-management.help-center.topic.view';
const $b0abd724ea2390c8$export$42633b810d73bab2 = 'service-management.help-center.advanced.homepage.view';
const $b0abd724ea2390c8$export$c25f92d477e645db = 'service-management.help-center.custom.page.view';
const $b0abd724ea2390c8$export$6b7cf274ce127c6c = 'service-management.help-center.profile.view';
const $b0abd724ea2390c8$export$1d4505191d749c3 = 'service-management.help-center.update.manage-columns-sidebar-view';
const $b0abd724ea2390c8$export$f5b418a8fb4c2e52 = 'service-management.help-center.advanced.homepage.edit';
const $b0abd724ea2390c8$export$1a5dc88687c6c743 = 'service-management.help-center.custom.page.edit';
const $b0abd724ea2390c8$export$8e695cad45fa9462 = 'service-management.help-center.search';
const $b0abd724ea2390c8$export$ef4e3240bcfb0749 = 'service-management.help-center.inline-search';
const $b0abd724ea2390c8$export$a31e9803c7cf4e9c = 'service-management.help-center.help-center-reporting';
const $b0abd724ea2390c8$export$a49db1fcfecaa197 = 'service-management.help-center.help-center-reporting-content-gap';
const $b0abd724ea2390c8$export$28b0efc551538ce4 = 'service-management.help-center.help-centers-management';
const $b0abd724ea2390c8$export$8125d660e6f5341 = 'service-management.help-center.manage-projects';
const $b0abd724ea2390c8$export$b3c36987f8f3e130 = 'service-management.help-center.manage-pages';
const $b0abd724ea2390c8$export$9d36a9a1a5392695 = 'service-management.help-center.edit-details';
const $b0abd724ea2390c8$export$814916ea7ef3fe17 = 'service-management.help-center.multi-hc-dropdown';
const $b0abd724ea2390c8$export$ccd2c0d87dacec5b = 'service-management.help-center.avatar-menu';
const $b0abd724ea2390c8$export$afc2346bbf17f6dc = 'service-management.help-center.update.announcement-sidebar';
const $b0abd724ea2390c8$export$ad5e73bffe8e8683 = 'service-management.help-center.update.single-portal-announcement-sidebar';
const $b0abd724ea2390c8$export$7b03636a868ec87a = 'service-management.help-center.update.login-announcement-sidebar';
const $b0abd724ea2390c8$export$3a07bc7f4f48662a = 'service-management.help-center.update.theme-sidebar';
const $b0abd724ea2390c8$export$950826a562410f6a = 'service-management.help-center.request-create.jsm-cs-entitlement-custom-field-load';
const $b0abd724ea2390c8$export$a14ae97aa64fd38f = 'service-management.help-center.csm-help-center-form-picker';
const $b0abd724ea2390c8$export$eb5378d79d45e2ce = 'service-management.help-center.csm-contact-us-form-picker';
const $b0abd724ea2390c8$export$cb86036c3a8f0a3d = 'service-management.help-center.advanced.csm.homepage.view';

});
parcelRegister("6Nd92", function(module, exports) {
$parcel$export(module.exports, "useUFOComponentExperience", () => $bad5f770c77abe56$export$30ab340faaed55d4);

var $fc4bM = parcelRequire("fc4bM");
const $bad5f770c77abe56$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $fc4bM.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $bad5f770c77abe56$export$30ab340faaed55d4 = (experience)=>{
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $bad5f770c77abe56$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("9LFKj", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $11eff6c46a020c16$export$c00d22927c60484a);

var $8en26 = parcelRequire("8en26");
class $11eff6c46a020c16$export$c00d22927c60484a extends (0, $8en26.UFOAbstractExperience) {
}

});
parcelRegister("8en26", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $70d66e0bf1644ceb$export$d31c89db257648c);

var $eUgRu = parcelRequire("eUgRu");

var $dRkX9 = parcelRequire("dRkX9");

var $9c6HD = parcelRequire("9c6HD");

var $3oxNO = parcelRequire("3oxNO");

var $cIxIF = parcelRequire("cIxIF");

var $7jpon = parcelRequire("7jpon");

var $bkEmU = parcelRequire("bkEmU");

var $c0yNf = parcelRequire("c0yNf");

var $2VesA = parcelRequire("2VesA");

var $jQ6H9 = parcelRequire("jQ6H9");

var $6ijIC = parcelRequire("6ijIC");

var $eoQVp = parcelRequire("eoQVp");

var $6u6pi = parcelRequire("6u6pi");

var $fLDvZ = parcelRequire("fLDvZ");

var $7MJfF = parcelRequire("7MJfF");

var $h26xP = parcelRequire("h26xP");

var $127T9 = parcelRequire("127T9");

var $3zq6K = parcelRequire("3zq6K");

var $fDrrL = parcelRequire("fDrrL");

var $atXmE = parcelRequire("atXmE");

var $kWdDC = parcelRequire("kWdDC");
const $70d66e0bf1644ceb$var$getPageVisibleState = ()=>{
    return !(0, $2VesA.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $127T9.PageVisibleState).VISIBLE : (0, $127T9.PageVisibleState).HIDDEN;
};
class $70d66e0bf1644ceb$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $3zq6K.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $127T9.PageVisibleState).MIXED;
            (0, $h26xP.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $70d66e0bf1644ceb$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $atXmE.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $fLDvZ.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $fDrrL.canTransition)(this.state, newState)) {
            (0, $fLDvZ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $3zq6K.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $kWdDC.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $eUgRu.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $kWdDC.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $6ijIC.getGlobalEventStream)().push((0, $6u6pi.unsubscribeEvent)((0, $127T9.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $fLDvZ.ufolog)('this.parent', this.parent);
                (0, $6ijIC.getGlobalEventStream)().push((0, $jQ6H9.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $fLDvZ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $7MJfF.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $3zq6K.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $70d66e0bf1644ceb$var$getPageVisibleState();
            (0, $h26xP.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $fLDvZ.ufolog)('subscribed', this.id);
                (0, $6ijIC.getGlobalEventStream)().push((0, $eoQVp.subscribeEvent)((0, $127T9.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $127T9.FMP_MARK) && name !== (0, $127T9.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $7MJfF.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $kWdDC.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $3zq6K.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $127T9.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $127T9.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $dRkX9.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $7jpon.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $cIxIF.generateTraceId)(),
                    spanId: (0, $3oxNO.generateSpanId)()
                };
                (0, $bkEmU.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $dRkX9.fg)('ufo_v1_tracing')) (0, $9c6HD.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $7MJfF.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $h26xP.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $3zq6K.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $3zq6K.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $3zq6K.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $fLDvZ.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $c0yNf.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $dRkX9.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("c0yNf", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $770ed98d1a796578$export$2295b861f318254a);
// temp solution until we can get it automated
const $770ed98d1a796578$export$2295b861f318254a = '0.1.5';

});

parcelRegister("jQ6H9", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $45bf0740745f3c0c$export$7c957416596ca127);

var $127T9 = parcelRequire("127T9");
const $45bf0740745f3c0c$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $127T9.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});

parcelRegister("eoQVp", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $2bb0bb4b7f27b88f$export$37863216db4b714d);

var $127T9 = parcelRequire("127T9");
const $2bb0bb4b7f27b88f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $127T9.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("6u6pi", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $9932fc9c85f58018$export$ee1a7bd1fc9ea85e);

var $127T9 = parcelRequire("127T9");
const $9932fc9c85f58018$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $127T9.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("3zq6K", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $b488e2f2a190bede$export$81b70111112841a0);
const $b488e2f2a190bede$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("fDrrL", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $a0301919ba2f220c$export$178881f329fdb81f);

var $3zq6K = parcelRequire("3zq6K");
const $a0301919ba2f220c$var$UFOStateAvailableTransitions = {
    [(0, $3zq6K.UFOExperienceState).NOT_STARTED.id]: [
        (0, $3zq6K.UFOExperienceState).STARTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).STARTED.id]: [
        (0, $3zq6K.UFOExperienceState).IN_PROGRESS.id,
        (0, $3zq6K.UFOExperienceState).BLOCKED.id,
        (0, $3zq6K.UFOExperienceState).SUCCEEDED.id,
        (0, $3zq6K.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $3zq6K.UFOExperienceState).FAILED.id,
        (0, $3zq6K.UFOExperienceState).ABORTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $3zq6K.UFOExperienceState).BLOCKED.id,
        (0, $3zq6K.UFOExperienceState).SUCCEEDED.id,
        (0, $3zq6K.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $3zq6K.UFOExperienceState).FAILED.id,
        (0, $3zq6K.UFOExperienceState).ABORTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).BLOCKED.id]: [
        (0, $3zq6K.UFOExperienceState).RECOVERED.id,
        (0, $3zq6K.UFOExperienceState).ABORTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).RECOVERED.id]: [
        (0, $3zq6K.UFOExperienceState).STARTED.id,
        (0, $3zq6K.UFOExperienceState).SUCCEEDED.id,
        (0, $3zq6K.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $3zq6K.UFOExperienceState).FAILED.id,
        (0, $3zq6K.UFOExperienceState).ABORTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).SUCCEEDED.id]: [
        (0, $3zq6K.UFOExperienceState).STARTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $3zq6K.UFOExperienceState).SUCCEEDED.id,
        (0, $3zq6K.UFOExperienceState).FAILED.id,
        (0, $3zq6K.UFOExperienceState).ABORTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).FAILED.id]: [
        (0, $3zq6K.UFOExperienceState).STARTED.id
    ],
    [(0, $3zq6K.UFOExperienceState).ABORTED.id]: [
        (0, $3zq6K.UFOExperienceState).STARTED.id
    ]
};
const $a0301919ba2f220c$export$178881f329fdb81f = (state1, state2)=>{
    return $a0301919ba2f220c$var$UFOStateAvailableTransitions[state1.id] && $a0301919ba2f220c$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("kWdDC", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $718c0378b5dd8164$export$c753e8669d30c8ad);

var $lD7wJ = parcelRequire("lD7wJ");
const $718c0378b5dd8164$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $lD7wJ.roundPerfNow)();
};

});
parcelRegister("lD7wJ", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $d8fa48c54711b063$export$5f490af6b2b115cf);
const $d8fa48c54711b063$export$5f490af6b2b115cf = ()=>~~performance.now();

});





parcelRegister("17nJI", function(module, exports) {
$parcel$export(module.exports, "isNetworkErrorCode", () => $a0c50f3e4552b9da$export$1a5a4674dd906e7e);
$parcel$export(module.exports, "isClientErrorCode", () => $a0c50f3e4552b9da$export$d31fd506ce75fa65);
$parcel$export(module.exports, "isNetworkOrClientErrorCode", () => $a0c50f3e4552b9da$export$53ee51427129200c);
const $a0c50f3e4552b9da$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $a0c50f3e4552b9da$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $a0c50f3e4552b9da$export$53ee51427129200c = (statusCode)=>$a0c50f3e4552b9da$export$1a5a4674dd906e7e(statusCode) || $a0c50f3e4552b9da$export$d31fd506ce75fa65(statusCode);

});


parcelRegister("jm44O", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpEpic", () => $a1d7453db35b4916$export$ccd8cad10bc12583);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $Sgz8Z = parcelRequire("Sgz8Z");
parcelRequire("6ukid");
var $fdqjK = parcelRequire("fdqjK");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");

var $fASm6 = parcelRequire("fASm6");
const $a1d7453db35b4916$export$ccd8cad10bc12583 = (action$)=>{
    return action$.ofType((0, $fdqjK.INVITED_SIGN_UP)).mergeMap((invitedSignUpAction)=>{
        const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, contactAdminsFormEnabled: contactAdminsFormEnabled, setPasswordJwt: setPasswordJwt } = invitedSignUpAction.payload;
        return (0, $Sgz8Z.invitedSignUp)({
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            setPasswordJwt: setPasswordJwt
        }).flatMap(()=>{
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $fdqjK.invitedSignUpSuccess)()), (0, $jFk35.Observable).of((0, $6oW6S.loginAttempt)({
                email: email,
                password: password,
                continueParam: null
            })));
        }).catch((error)=>{
            const parsedError = (0, $fASm6.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $jFk35.Observable).of((0, $fdqjK.invitedSignUpFailure)(parsedError));
        });
    });
};

});
parcelRegister("Sgz8Z", function(module, exports) {
$parcel$export(module.exports, "invitedSignUp", () => $fd77dfff7dabda88$export$3693303625071052);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $fd77dfff7dabda88$export$3693303625071052 = (params)=>{
    const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, setPasswordJwt: setPasswordJwt, context: context = (0, $diqlM.contextPath) } = params;
    const uri = setPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword?jwt=${setPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword`;
    const body = {
        fullName: fullName,
        password: password,
        username: username,
        email: email,
        ...token ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};

});

parcelRegister("6ukid", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => (parcelRequire("fdqjK")).FETCH_VISIT_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => (parcelRequire("fdqjK")).FETCH_VISIT_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => (parcelRequire("fdqjK")).FETCH_VISIT_PORTAL_FAILURE);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => (parcelRequire("fdqjK")).INVITED_SIGN_UP);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => (parcelRequire("fdqjK")).INVITED_SIGN_UP_FAILURE);
$parcel$export(module.exports, "fetchVisitPortalModel", () => (parcelRequire("fdqjK")).fetchVisitPortalModel);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => (parcelRequire("fdqjK")).fetchVisitPortalSuccess);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => (parcelRequire("fdqjK")).fetchVisitPortalFailure);
$parcel$export(module.exports, "invitedSignUp", () => (parcelRequire("fdqjK")).invitedSignUp);
$parcel$export(module.exports, "invitedSignUpSuccess", () => (parcelRequire("fdqjK")).invitedSignUpSuccess);
$parcel$export(module.exports, "invitedSignUpFailure", () => (parcelRequire("fdqjK")).invitedSignUpFailure);

var $fdqjK = parcelRequire("fdqjK");

});
parcelRegister("fdqjK", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => $5be1882a37389f18$export$5aa92ec48cad67e1);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => $5be1882a37389f18$export$cd1a8438490d4c7e);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => $5be1882a37389f18$export$7d63bf92ff546bd4);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => $5be1882a37389f18$export$10a878c7005ffa23);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => $5be1882a37389f18$export$fc43f808dcbef187);
$parcel$export(module.exports, "fetchVisitPortalModel", () => $5be1882a37389f18$export$6513e51a3bb59ea8);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => $5be1882a37389f18$export$fd6356a11ec803b4);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => $5be1882a37389f18$export$4807fff848ef2c1a);
$parcel$export(module.exports, "invitedSignUp", () => $5be1882a37389f18$export$3693303625071052);
$parcel$export(module.exports, "invitedSignUpSuccess", () => $5be1882a37389f18$export$a2add4c6435cf561);
$parcel$export(module.exports, "invitedSignUpFailure", () => $5be1882a37389f18$export$7ae6305616bacef7);

var $dv0hN = parcelRequire("dv0hN");
const $5be1882a37389f18$export$5aa92ec48cad67e1 = 'epic.model.FETCH_VISIT_PORTAL_MODEL';
const $5be1882a37389f18$export$cd1a8438490d4c7e = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_SUCCESS';
const $5be1882a37389f18$export$7d63bf92ff546bd4 = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_FAILURE';
const $5be1882a37389f18$export$10a878c7005ffa23 = 'state.ui.invited.sign.up.INVITED_SIGN_UP';
const $5be1882a37389f18$export$6bf64c2d60f7e63d = 'state.ui.invited.sign.up.INVITED_SIGN_UP_SUCCESS';
const $5be1882a37389f18$export$fc43f808dcbef187 = 'state.ui.invited.sign.up.INVITED_SIGN_UP_FAILURE';
const $5be1882a37389f18$export$6513e51a3bb59ea8 = (0, $dv0hN.buildModelsActionCreator)($5be1882a37389f18$export$5aa92ec48cad67e1, 'visitPortal');
const $5be1882a37389f18$export$fd6356a11ec803b4 = (visitPortalResponse)=>({
        type: $5be1882a37389f18$export$cd1a8438490d4c7e,
        payload: visitPortalResponse
    });
const $5be1882a37389f18$export$4807fff848ef2c1a = (error)=>({
        type: $5be1882a37389f18$export$7d63bf92ff546bd4,
        payload: {
            error: error
        }
    });
const $5be1882a37389f18$export$3693303625071052 = (portalId, email, fullName, password, token, username, contactAdminsFormEnabled, setPasswordJwt)=>({
        type: $5be1882a37389f18$export$10a878c7005ffa23,
        payload: {
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            setPasswordJwt: setPasswordJwt
        }
    });
const $5be1882a37389f18$export$a2add4c6435cf561 = ()=>({
        type: $5be1882a37389f18$export$6bf64c2d60f7e63d
    });
const $5be1882a37389f18$export$7ae6305616bacef7 = (error)=>({
        type: $5be1882a37389f18$export$fc43f808dcbef187,
        payload: {
            error: error
        }
    });

});



parcelRegister("csxvO", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpacesEpic", () => $3bbbc7da51f1c268$export$fe4c3219e901f34f);

var $jFk35 = parcelRequire("jFk35");

var $jvy2f = parcelRequire("jvy2f");
parcelRequire("9a3MY");
var $8dMoV = parcelRequire("8dMoV");

var $aIVqJ = parcelRequire("aIVqJ");
const $3bbbc7da51f1c268$export$fe4c3219e901f34f = (action$)=>action$.ofType((0, $8dMoV.FETCH_LINKED_SPACES)).mergeMap((action)=>{
        const { meta: meta } = action.payload;
        return (0, $jvy2f.fetchLinkedSpaces)().map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $8dMoV.fetchLinkedSpacesSuccess)(response.linkedSpaces.map((space)=>space.spaceKey));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) {
                const failureEvent = meta.analyticsFailureEvent.update((payload)=>({
                        ...payload,
                        status: error.status
                    }));
                (0, $aIVqJ.legacySendEvent)(failureEvent);
            }
            return (0, $jFk35.Observable).of((0, $8dMoV.fetchLinkedSpacesFailure)(error));
        });
    });

});
parcelRegister("jvy2f", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpaces", () => $5b057f2f55598e34$export$1999596e4ea30c16);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6LH8a = parcelRequire("6LH8a");

var $f60co = parcelRequire("f60co");

var $aIVqJ = parcelRequire("aIVqJ");
const $5b057f2f55598e34$export$1999596e4ea30c16 = ()=>{
    const activationId = (0, $6LH8a.getMeta)('activation-id');
    const uri = `${(0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/linked-spaces`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        return response;
    }).catch((e)=>{
        (0, $aIVqJ.trackError)('linked-spaces.fetch.failed', {}, e);
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("9a3MY", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => (parcelRequire("8dMoV")).FETCH_LINKED_SPACES);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => (parcelRequire("8dMoV")).FETCH_LINKED_SPACES_SUCCESS);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => (parcelRequire("8dMoV")).FETCH_LINKED_SPACES_FAILURE);
$parcel$export(module.exports, "fetchLinkedSpaces", () => (parcelRequire("8dMoV")).fetchLinkedSpaces);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => (parcelRequire("8dMoV")).fetchLinkedSpacesSuccess);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => (parcelRequire("8dMoV")).fetchLinkedSpacesFailure);

var $8dMoV = parcelRequire("8dMoV");

});
parcelRegister("8dMoV", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => $7875ddaa30d37721$export$3d78263a729bb91);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => $7875ddaa30d37721$export$55cd199355628b5a);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => $7875ddaa30d37721$export$9c186423b974805a);
$parcel$export(module.exports, "fetchLinkedSpaces", () => $7875ddaa30d37721$export$1999596e4ea30c16);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => $7875ddaa30d37721$export$ad2cc5272eef487);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => $7875ddaa30d37721$export$e63a5f7249c4e5d6);
const $7875ddaa30d37721$export$3d78263a729bb91 = 'state.actions.linked-spaces.FETCH_LINKED_SPACES';
const $7875ddaa30d37721$export$55cd199355628b5a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_SUCCESS';
const $7875ddaa30d37721$export$9c186423b974805a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_FAILURE';
const $7875ddaa30d37721$export$1999596e4ea30c16 = (meta)=>({
        type: $7875ddaa30d37721$export$3d78263a729bb91,
        payload: {
            meta: meta
        }
    });
const $7875ddaa30d37721$export$ad2cc5272eef487 = (linkedSpaces)=>({
        type: $7875ddaa30d37721$export$55cd199355628b5a,
        payload: {
            linkedSpaces: linkedSpaces
        }
    });
const $7875ddaa30d37721$export$e63a5f7249c4e5d6 = (error)=>({
        type: $7875ddaa30d37721$export$9c186423b974805a,
        payload: {
            error: error
        }
    });

});



parcelRegister("1LBQA", function(module, exports) {
$parcel$export(module.exports, "checkLoginActionEpic", () => $f1edfe9ba308f4ab$export$f1b0b99279015d5e);

var $4Q7yw = parcelRequire("4Q7yw");

var $jFk35 = parcelRequire("jFk35");

var $epDUQ = parcelRequire("epDUQ");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("eDtG6");
var $5Eeij = parcelRequire("5Eeij");

var $fASm6 = parcelRequire("fASm6");

var $klK2e = parcelRequire("klK2e");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");

var $dbYz0 = parcelRequire("dbYz0");

var $gioQl = parcelRequire("gioQl");
const $f1edfe9ba308f4ab$export$f1b0b99279015d5e = (action$)=>{
    return action$.ofType((0, $6oW6S.CHECK_LOGIN_ACTION)).mergeMap((checkLoginActionAction)=>{
        const { email: email, portalId: portalId, authData: authData, createAnalyticsEvent: createAnalyticsEvent } = checkLoginActionAction.payload;
        return (0, $klK2e.fetchAwsWafToken)(createAnalyticsEvent).mergeMap((token)=>(0, $epDUQ.checkLoginAction)({
                email: email,
                authData: authData,
                awsWafToken: token
            })).flatMap((response)=>{
            const autoInfo = $f1edfe9ba308f4ab$var$extractAuthInfoFromResponse(response);
            const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'enteredEmailAndClickedNext',
                actionSubject: 'jsmPortalUnifiedLogin',
                attributes: {
                    accountStage: autoInfo.accountStage,
                    authMethodTypes: Array.from(autoInfo.authMethods.keys())
                }
            });
            trackEvent && (0, $aIVqJ.legacySendEvent)(trackEvent);
            if (response.action === (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_SIGNUP) return (0, $jFk35.Observable).of((0, $5Eeij.setSignupDataAction)(email, autoInfo)).do(()=>{
                // Make sure we set the signup state first before doing the transition
                (0, $4Q7yw.Scheduler).async.schedule(()=>{
                    (0, $diqlM.default).push((0, $gioQl.getSignupUrl)(portalId ? Number.parseInt(portalId, 10) : undefined));
                }, 0);
            });
            return (0, $jFk35.Observable).of((0, $6oW6S.checkLoginActionSuccess)(response.action, autoInfo));
        }).catch((error)=>{
            if ((0, $fASm6.isSsoTestModeError)(error)) return (0, $jFk35.Observable).of((0, $6oW6S.caSsoTestModeFailure)());
            const parsedError = (0, $fASm6.getDefaultCheckLoginError)(error);
            return (0, $jFk35.Observable).of((0, $6oW6S.checkLoginActionFailure)(parsedError));
        });
    });
};
const $f1edfe9ba308f4ab$var$getAccountStage = (action)=>{
    switch(action){
        case (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $dbYz0.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
            return (0, $dbYz0.AccountStageType).SIGNUP;
        case (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        case (0, $dbYz0.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
        default:
            return (0, $dbYz0.AccountStageType).LOGIN;
    }
};
const $f1edfe9ba308f4ab$var$extractAuthInfoFromResponse = (payload)=>{
    const { action: action, methods: methods } = payload;
    const stage = $f1edfe9ba308f4ab$var$getAccountStage(action);
    if (methods.length === 0) // add observable
    // cleanup entire part when FF is cleaned up - Jira ticket
    switch(action){
        case (0, $dbYz0.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $dbYz0.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $dbYz0.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {}
                    ]
                ])
            };
        case (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            };
    }
    switch(action){
        case (0, $dbYz0.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $dbYz0.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    return [
                        (0, $dbYz0.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                }))
            };
        case (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    if (method.authType === 'SSO') return [
                        (0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                    return [
                        (0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ];
                }))
            };
    }
};

});
parcelRegister("epDUQ", function(module, exports) {
$parcel$export(module.exports, "LoginAttemptErrorType", () => $9b43acf16a2d2766$export$d265801d14b9cbd6);
$parcel$export(module.exports, "checkLoginAction", () => $9b43acf16a2d2766$export$a4840b835bebc845);
$parcel$export(module.exports, "forgotPassword", () => $9b43acf16a2d2766$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $9b43acf16a2d2766$export$2effc3102ad6a101);
$parcel$export(module.exports, "loginV2", () => $9b43acf16a2d2766$export$c5789ac087856ec0);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $k2M4v = parcelRequire("k2M4v");

var $4MjGQ = parcelRequire("4MjGQ");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $7wx9B = parcelRequire("7wx9B");

var $gioQl = parcelRequire("gioQl");
const $9b43acf16a2d2766$var$IDENTITY_LOGIN_RETRY_DELAY_MS = 500;
const $9b43acf16a2d2766$var$IDENTITY_LOGIN_MAX_RETRIES = 2;
const $9b43acf16a2d2766$var$isRetryableError = (status)=>{
    // Retry on 5xx server errors or network errors (status 0)
    return status >= 500 || status === 0;
};
const $9b43acf16a2d2766$var$delay = (ms)=>{
    return new (0, $jFk35.Observable)((subscriber)=>{
        const timeoutId = setTimeout(()=>{
            subscriber.next();
            subscriber.complete();
        }, ms);
        return ()=>clearTimeout(timeoutId);
    });
};
var $9b43acf16a2d2766$export$d265801d14b9cbd6 = /*#__PURE__*/ function(LoginAttemptErrorType) {
    LoginAttemptErrorType[LoginAttemptErrorType["INVALID_CREDENTIALS"] = 0] = "INVALID_CREDENTIALS";
    LoginAttemptErrorType[LoginAttemptErrorType["ACCOUNT_LOCKED_ERROR"] = 1] = "ACCOUNT_LOCKED_ERROR";
    LoginAttemptErrorType[LoginAttemptErrorType["MISC_LOGIN_ERROR"] = 2] = "MISC_LOGIN_ERROR";
    return LoginAttemptErrorType;
}({});
const $9b43acf16a2d2766$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'login',
        source: 'unknownSource'
    };
};
const $9b43acf16a2d2766$export$a4840b835bebc845 = (params)=>{
    const { email: email, authData: authData, awsWafToken: awsWafToken, context: context = (0, $diqlM.contextPath) } = params;
    const uri = `${context}/rest/servicedesk/customer-management/1/twosteplogin/action`;
    const body = JSON.stringify({
        email: email,
        ...authData
    });
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...awsWafToken ? {
            'x-aws-waf-token': `${awsWafToken}`
        } : {},
        ...(0, $k2M4v.default).getExperiment('bypass_jsm_two_step_login_waf_challenge_js').value.value ? {
            'atl-jsm-login-challenge-bypass': true
        } : {}
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $9b43acf16a2d2766$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>{
    const uri = (0, $gioQl.prependWithSlashIfAbsent)(resetUrl);
    const body = $9b43acf16a2d2766$var$createBodyForForgotPassword(email, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers);
};
const $9b43acf16a2d2766$export$2effc3102ad6a101 = (resetUrl, email)=>{
    const uri = (0, $gioQl.prependWithSlashIfAbsent)(resetUrl);
    const body = $9b43acf16a2d2766$var$createBodyForForgotPassword(email);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers);
};
const $9b43acf16a2d2766$var$createBodyForForgotPassword = (usernameOrEmail, redirectUrl)=>{
    return JSON.stringify({
        usernameOrEmail: usernameOrEmail,
        redirectUrl: redirectUrl
    });
};
const $9b43acf16a2d2766$var$responseKeyToErrorType = (loginPayload)=>{
    if (loginPayload) switch(loginPayload.key){
        case 'invalid-user-credentials':
            return 0;
        case 'blocked-user-credentials':
            return 1;
        default:
    }
    return 2;
};
const $9b43acf16a2d2766$export$4030e1d1ae5ebd69 = (ajaxError)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ajaxResponse = ajaxError.response;
    if (ajaxError.status === 403) {
        const errorType = $9b43acf16a2d2766$var$responseKeyToErrorType(ajaxResponse);
        if (errorType === 2) (0, $7wx9B.reportError)(ajaxError, {
            message: JSON.stringify(ajaxResponse)
        });
        return {
            loginSucceeded: false,
            error: {
                errorType: errorType
            }
        };
    }
    (0, $7wx9B.reportError)(ajaxError, {
        message: JSON.stringify(ajaxResponse)
    });
    throw ajaxError;
};
const $9b43acf16a2d2766$export$abbe0c285917a9df = ()=>`${(0, $esgVk.origin)()}${(0, $diqlM.getBaseName)()}${(0, $gioQl.getHelpCenterUrl)()}`;
const $9b43acf16a2d2766$export$f7ebdb13a3e88fec = (params)=>{
    const { email: email, password: password, context: context = (0, $diqlM.contextPath) } = params;
    const continueParam = params.continueParam ? params.continueParam : $9b43acf16a2d2766$export$abbe0c285917a9df();
    const uri = `${context}/jsd-login-v2/v2/customer/login/authenticate?continue=${continueParam}`;
    const body = {
        email: email,
        password: password
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    const envWithEdition = (0, $7lN8e.getEnv)();
    const edition = envWithEdition.edition;
    const maxRetries = $9b43acf16a2d2766$var$IDENTITY_LOGIN_MAX_RETRIES;
    const fireSuccessEvent = (ajaxResponse, retryCount)=>{
        (0, $4MjGQ.operationalEvent)($9b43acf16a2d2766$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString(),
            traceId: ajaxResponse.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const fireErrorEvent = (ajaxError, retryCount)=>{
        const response = ajaxError.response;
        (0, $4MjGQ.operationalEvent)($9b43acf16a2d2766$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            errorKey: (response === null || response === void 0 ? void 0 : response.key) || 'unknown',
            errorMessage: typeof (response === null || response === void 0 ? void 0 : response.context) === 'object' && response.context ? response.context.errorDetail || 'unknown' : 'unknown',
            traceId: ajaxError.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const makeRequest = (retryCount)=>{
        return (0, $bTjsX.post)(uri, body, headers).do((ajaxResponse)=>fireSuccessEvent(ajaxResponse, retryCount), (ajaxError)=>{
            if (retryCount >= maxRetries || !$9b43acf16a2d2766$var$isRetryableError(ajaxError.status)) fireErrorEvent(ajaxError, retryCount);
        }).map(()=>({
                loginSucceeded: true,
                error: null
            })).catch((ajaxError)=>{
            if (retryCount < maxRetries && $9b43acf16a2d2766$var$isRetryableError(ajaxError.status)) return $9b43acf16a2d2766$var$delay($9b43acf16a2d2766$var$IDENTITY_LOGIN_RETRY_DELAY_MS).switchMap(()=>makeRequest(retryCount + 1));
            return (0, $jFk35.Observable).of($9b43acf16a2d2766$export$4030e1d1ae5ebd69(ajaxError));
        });
    };
    return makeRequest(0);
};
const $9b43acf16a2d2766$export$c5789ac087856ec0 = (email, password, continueParam)=>{
    return $9b43acf16a2d2766$export$f7ebdb13a3e88fec({
        email: email,
        password: password,
        continueParam: continueParam
    });
};

});
parcelRegister("gioQl", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER_URL", () => $d7215e394d7d3139$export$5b56ffbd3ae3f811);
$parcel$export(module.exports, "getLoginUrl", () => $d7215e394d7d3139$export$8abe2e83e8d74da2);
$parcel$export(module.exports, "getLoginUrlForPortalId", () => $d7215e394d7d3139$export$2c3bf2ac72f35daf);
$parcel$export(module.exports, "getLoginUrlForPortalIdAsString", () => $d7215e394d7d3139$export$cf0d2e77a068eb02);
$parcel$export(module.exports, "getSignupUrl", () => $d7215e394d7d3139$export$61811316248f3423);
$parcel$export(module.exports, "getRedirectUrlOrLoginUrlIfNotLoggedIn", () => $d7215e394d7d3139$export$e1ec45c36436315e);
$parcel$export(module.exports, "stripBasename", () => $d7215e394d7d3139$export$b69e3301ce081aa3);
$parcel$export(module.exports, "getLoginUrlForTestMode", () => $d7215e394d7d3139$export$538cfa4687a1dbf1);
$parcel$export(module.exports, "parseLoginSignupRedirectUrlParams", () => $d7215e394d7d3139$export$63db7ca0fb70fb36);
$parcel$export(module.exports, "getManageAtlassianAccountUrl", () => $d7215e394d7d3139$export$ad959f16b2c52bb0);
$parcel$export(module.exports, "getEditAccountPreferenceUrl", () => $d7215e394d7d3139$export$aa7a50c8d9783676);
$parcel$export(module.exports, "getHelpCenterUrl", () => $d7215e394d7d3139$export$bb97e50e9203cc1d);
$parcel$export(module.exports, "getLearnMoreUrl", () => $d7215e394d7d3139$export$54cf7883df84f437);
$parcel$export(module.exports, "getPortalUrl", () => $d7215e394d7d3139$export$8f6fdb27182bf17e);
$parcel$export(module.exports, "getPortalUrlWithPortalIdAsString", () => $d7215e394d7d3139$export$46b08aeb2d28084e);
$parcel$export(module.exports, "getRequestListUrl", () => $d7215e394d7d3139$export$1ca0042661bee534);
$parcel$export(module.exports, "prependWithSlashIfAbsent", () => $d7215e394d7d3139$export$1d7449e2f82591f7);
$parcel$export(module.exports, "parseIssueKeyFromUrl", () => $d7215e394d7d3139$export$286b4bf70293043b);
$parcel$export(module.exports, "getNextgenSettingsUrl", () => $d7215e394d7d3139$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsRequestTypesUrl", () => $d7215e394d7d3139$export$289b05216208b30f);
$parcel$export(module.exports, "getPortalGroupSettingsUrl", () => $d7215e394d7d3139$export$902d92fe4f764798);
$parcel$export(module.exports, "getTeamManagedPortalGroupSettingsUrl", () => $d7215e394d7d3139$export$668319f0cf7cb94b);
$parcel$export(module.exports, "getRequestTypeSettingsUrl", () => $d7215e394d7d3139$export$521ab03a93b5e8f0);
$parcel$export(module.exports, "getMyPendingApprovalsUrl", () => $d7215e394d7d3139$export$b7fb861bceb68e9e);
$parcel$export(module.exports, "isTestModeRequested", () => $d7215e394d7d3139$export$87980cf49820be56);
$parcel$export(module.exports, "getSsoTestModeParamFromUrl", () => $d7215e394d7d3139$export$a992d459a03ed45d);
$parcel$export(module.exports, "convertAbsoluteUrlToRelativeUrl", () => $d7215e394d7d3139$export$71e894c24943ddb2);
$parcel$export(module.exports, "getUpdatedDisplayLink", () => $d7215e394d7d3139$export$1f8744d5447339dc);
$parcel$export(module.exports, "getBillingUrl", () => $d7215e394d7d3139$export$776b50dd35ff8711);
$parcel$export(module.exports, "formatTitleForUrl", () => $d7215e394d7d3139$export$4ff2caca9bc551ab);
$parcel$export(module.exports, "getDefaultDestination", () => $d7215e394d7d3139$export$3621fe01f0e72eb7);
$parcel$export(module.exports, "getContinueParam", () => $d7215e394d7d3139$export$46b6a16917b33fad);
$parcel$export(module.exports, "getRedirectUrlForSignupAndResetPasswordRequestParam", () => $d7215e394d7d3139$export$c20e132b33b4b975);

var $6dipk = parcelRequire("6dipk");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $6rayQ = parcelRequire("6rayQ");

var $esgVk = parcelRequire("esgVk");

var $dbYz0 = parcelRequire("dbYz0");
const $d7215e394d7d3139$export$5b56ffbd3ae3f811 = (0, $cf3fd.isAdvancedHelpCenter)() || (0, $cf3fd.isUnifiedHelpHelpCenter)() || (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) ? '/' : '/portals';
const $d7215e394d7d3139$var$ATLASSIAN_ACCOUNT_URL = 'https://id.atlassian.com';
const $d7215e394d7d3139$var$ATLASSIAN_ACCOUNT_STG_URL = 'https://id.stg.internal.atlassian.com';
const $d7215e394d7d3139$var$envToAtlassianAccountUrlMap = new Map([
    [
        (0, $7lN8e.EnvType).LOCAL,
        $d7215e394d7d3139$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $7lN8e.EnvType).DEV,
        $d7215e394d7d3139$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $7lN8e.EnvType).STAGING,
        $d7215e394d7d3139$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $7lN8e.EnvType).PROD,
        $d7215e394d7d3139$var$ATLASSIAN_ACCOUNT_URL
    ]
]);
const $d7215e394d7d3139$export$8abe2e83e8d74da2 = (loginOptions)=>{
    return $d7215e394d7d3139$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl);
};
const $d7215e394d7d3139$export$2c3bf2ac72f35daf = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/login${(0, $esgVk.search)()}` : `/user/login${(0, $esgVk.search)()}`;
};
const $d7215e394d7d3139$export$cf0d2e77a068eb02 = (portalIdAsString)=>{
    return $d7215e394d7d3139$export$2c3bf2ac72f35daf($d7215e394d7d3139$var$stringToNumberOrUndefined(portalIdAsString));
};
const $d7215e394d7d3139$export$61811316248f3423 = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/signup${(0, $esgVk.search)()}` : `/user/signup${(0, $esgVk.search)()}`;
};
const $d7215e394d7d3139$export$e1ec45c36436315e = (redirectToLogin, url, portalId)=>{
    const strippedUrl = $d7215e394d7d3139$export$b69e3301ce081aa3(url);
    if (redirectToLogin) return $d7215e394d7d3139$var$internalGetLoginUrl(false, portalId, strippedUrl);
    return strippedUrl;
};
const $d7215e394d7d3139$var$internalGetLoginUrl = (isAbsolute, portalId, redirectUrl)=>{
    const pathUrl = portalId ? `portal/${portalId}/user/login` : 'user/login';
    const portalUrl = isAbsolute ? `${(0, $diqlM.getBaseName)()}/${pathUrl}` : `/${pathUrl}`;
    if (redirectUrl) {
        // trim leading slash if it is present
        const url = redirectUrl.replace(/^\/+/g, '');
        return (0, $6rayQ.addParamsToUrl)(portalUrl, {
            destination: url
        });
    }
    return portalUrl;
};
const $d7215e394d7d3139$export$538cfa4687a1dbf1 = (loginOptions)=>{
    return (0, $6rayQ.addParamsToUrl)($d7215e394d7d3139$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl), {
        [(0, $dbYz0.QUERY_PARAM_SSO_TEST)]: 'true'
    });
};
const $d7215e394d7d3139$export$63db7ca0fb70fb36 = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedSearchQuery = $6dipk.parse((0, $esgVk.search)());
    return {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        destination: parsedSearchQuery.destination,
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        isAbsolute: parsedSearchQuery.absolute === 'true'
    };
};
const $d7215e394d7d3139$export$ad959f16b2c52bb0 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $6rayQ.addParamsToUrl)(url, {
        target: 'profile-visibility'
    });
};
const $d7215e394d7d3139$export$aa7a50c8d9783676 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $6rayQ.addParamsToUrl)(url, {
        target: 'edit-preference'
    });
};
const $d7215e394d7d3139$export$bb97e50e9203cc1d = ()=>{
    return $d7215e394d7d3139$export$5b56ffbd3ae3f811;
};
const $d7215e394d7d3139$export$54cf7883df84f437 = ()=>{
    var _envToAtlassianAccoun;
    return (_envToAtlassianAccoun = $d7215e394d7d3139$var$envToAtlassianAccountUrlMap.get((0, $7lN8e.getEnv)().environment)) === null || _envToAtlassianAccoun === void 0 ? void 0 : _envToAtlassianAccoun.concat('/manage-profile/apps');
};
const $d7215e394d7d3139$export$8f6fdb27182bf17e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $d7215e394d7d3139$export$bb97e50e9203cc1d();
};
const $d7215e394d7d3139$export$46b08aeb2d28084e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $d7215e394d7d3139$export$bb97e50e9203cc1d();
};
const $d7215e394d7d3139$export$b69e3301ce081aa3 = (url)=>{
    if (url) {
        const pos = url.indexOf((0, $diqlM.getRelativeBasePath)());
        if (pos >= 0) return url.substring(pos + (0, $diqlM.getRelativeBasePath)().length);
    }
    return url;
};
const $d7215e394d7d3139$export$1ca0042661bee534 = (parameters)=>{
    const queryParameters = [
        `page=${parameters.page}`
    ];
    if (parameters.reporter) queryParameters.push(`reporter=${parameters.reporter}`);
    if (parameters.statuses) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    queryParameters.push(`statuses=${parameters.statuses}`);
    return `/user/requests?${queryParameters.join('&')}`;
};
const $d7215e394d7d3139$export$1d7449e2f82591f7 = (toPrepend)=>{
    if (toPrepend.startsWith('/')) return toPrepend;
    return `/${toPrepend}`;
};
const $d7215e394d7d3139$var$stringToNumberOrUndefined = (toConvert)=>toConvert === undefined ? undefined : Number(toConvert);
const $d7215e394d7d3139$export$286b4bf70293043b = (url)=>{
    const jiraUrlMatch = `${(0, $esgVk.origin)()}/browse/([A-Z][A-Z0-9_]+-\\d+)`;
    const portalUrlMatch = `${(0, $esgVk.origin)()}${(0, $diqlM.getRelativeBasePath)()}/portal/\\d+/([A-Z][A-Z0-9_]+-\\d+)`;
    const jiraMatch = url.match(jiraUrlMatch);
    if (jiraMatch) return jiraMatch[1];
    const portalMatch = url.match(portalUrlMatch);
    return portalMatch === null ? null : portalMatch[1];
};
const $d7215e394d7d3139$export$26432406821aa7bf = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/settings`;
const $d7215e394d7d3139$export$718bab188935b069 = (projectKey)=>`${$d7215e394d7d3139$export$26432406821aa7bf(projectKey)}/language`;
const $d7215e394d7d3139$export$289b05216208b30f = (projectKey)=>`${$d7215e394d7d3139$export$26432406821aa7bf(projectKey)}/issuetypes`;
const $d7215e394d7d3139$export$c38761508d5f074d = (projectKey, requestTypeId)=>`${$d7215e394d7d3139$export$289b05216208b30f(projectKey)}/${requestTypeId}`;
const $d7215e394d7d3139$export$902d92fe4f764798 = (projectKey)=>`${$d7215e394d7d3139$export$26432406821aa7bf(projectKey)}/portal-settings/portal-groups`;
const $d7215e394d7d3139$export$668319f0cf7cb94b = (projectKey)=>`${$d7215e394d7d3139$export$26432406821aa7bf(projectKey)}/channels/portal-settings/portal-groups`;
const $d7215e394d7d3139$export$521ab03a93b5e8f0 = (projectKey, requestTypeId)=>`${$d7215e394d7d3139$export$26432406821aa7bf(projectKey)}/request-types/category/service-requests/request-type/${requestTypeId}/request-form`;
const $d7215e394d7d3139$export$7517f177d0bcebc3 = (url, jiraBaseUrl)=>{
    return url.startsWith(jiraBaseUrl);
};
const $d7215e394d7d3139$export$b7fb861bceb68e9e = ()=>{
    return `/user/approvals?approvalQueryType=myPending&page=1`;
};
const $d7215e394d7d3139$export$87980cf49820be56 = (ssoTest)=>{
    return ssoTest === 'true';
};
const $d7215e394d7d3139$export$a992d459a03ed45d = (params)=>{
    return params.get((0, $dbYz0.QUERY_PARAM_SSO_TEST)) === 'true';
};
const $d7215e394d7d3139$export$a1cbf2de32a9fd1 = (url)=>{
    if (decodeURIComponent(url).startsWith('//')) return false;
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $d7215e394d7d3139$export$71e894c24943ddb2 = (url)=>{
    if ($d7215e394d7d3139$export$a1cbf2de32a9fd1(url)) return url.replace(`${new URL(url).origin}`, '') || '/';
    return url;
};
const $d7215e394d7d3139$export$1f8744d5447339dc = (displayLink)=>{
    const isBasicHCRegex = /\/servicedesk\/customer\/.+/;
    if ((0, $cf3fd.isAdvancedHelpCenter)() && isBasicHCRegex.test(displayLink) && !$d7215e394d7d3139$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace('/servicedesk/customer/', '/');
    return displayLink;
};
const $d7215e394d7d3139$export$6c23a56732080745 = (displayLink)=>{
    if ((0, $cf3fd.isAdvancedHelpCenter)() && displayLink.includes('/servicedesk/customer/') && $d7215e394d7d3139$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace(/.+\/servicedesk\/customer\//, `${(0, $diqlM.getRelativeBasePath)()}/`);
    return displayLink;
};
const $d7215e394d7d3139$var$ADMIN_STAGING_URL = 'http://admin.stg.atlassian.com';
const $d7215e394d7d3139$var$ADMIN_PROD_URL = 'https://admin.atlassian.com';
const $d7215e394d7d3139$export$1cfdf9a01e3f7773 = ()=>window.location.host.includes('-dev.com') ? false : true;
const $d7215e394d7d3139$export$995f5f30765d3edb = $d7215e394d7d3139$export$1cfdf9a01e3f7773() ? $d7215e394d7d3139$var$ADMIN_PROD_URL : $d7215e394d7d3139$var$ADMIN_STAGING_URL;
const $d7215e394d7d3139$export$776b50dd35ff8711 = (products, cloudId)=>{
    const baseUrl = `${$d7215e394d7d3139$export$995f5f30765d3edb}/s/${cloudId}`;
    return products.length === 1 ? `${baseUrl}/billing/applications/change-edition/${products[0]}.ondemand` : `${baseUrl}/billing-preview`;
};
const $d7215e394d7d3139$export$4ff2caca9bc551ab = (title)=>{
    return title.trim().replace(/[^a-zA-Z0-9]+/g, '+').replace(/^(?:\++)|(?:\++)$/g, '');
};
const $d7215e394d7d3139$export$3621fe01f0e72eb7 = (portalId)=>{
    if (portalId) return `portal/${portalId}`;
    return $d7215e394d7d3139$export$bb97e50e9203cc1d().replace(/\//g, '');
};
const $d7215e394d7d3139$export$46b6a16917b33fad = (portalId)=>{
    const { destination: destination, isAbsolute: isAbsolute } = $d7215e394d7d3139$export$63db7ca0fb70fb36();
    const prefix = destination && isAbsolute ? '' : `${(0, $esgVk.origin)()}${(0, $diqlM.getBaseName)()}/`;
    const continueParam = `${prefix}${destination || $d7215e394d7d3139$export$3621fe01f0e72eb7(portalId)}`;
    return `${continueParam}`;
};
const $d7215e394d7d3139$export$c20e132b33b4b975 = (baseUrl)=>{
    const { destination: destination } = $d7215e394d7d3139$export$63db7ca0fb70fb36();
    if (destination && ($d7215e394d7d3139$export$7517f177d0bcebc3(destination, baseUrl) || !$d7215e394d7d3139$export$a1cbf2de32a9fd1(destination))) return destination;
    return undefined;
};

});
parcelRegister("dbYz0", function(module, exports) {
$parcel$export(module.exports, "AccountStageType", () => $e8fc62be58aad5d4$export$fcf6b116730276db);
$parcel$export(module.exports, "AuthMethodType", () => $e8fc62be58aad5d4$export$ccd4174b7ee5aaf9);
$parcel$export(module.exports, "LoginType", () => $e8fc62be58aad5d4$export$7ecae1a0f094da22);
$parcel$export(module.exports, "QUERY_PARAM_SSO_TEST", () => $e8fc62be58aad5d4$export$491b9d320a651537);
// eslint-disable-next-line no-shadow
var $e8fc62be58aad5d4$export$fcf6b116730276db = /*#__PURE__*/ function(AccountStageType) {
    AccountStageType["LOGIN"] = "LOGIN";
    AccountStageType["SIGNUP"] = "SIGNUP";
    return AccountStageType;
}({});
var $e8fc62be58aad5d4$export$ccd4174b7ee5aaf9 = /*#__PURE__*/ function(AuthMethodType) {
    AuthMethodType["CUSTOMER_ACCOUNT_PASSWORD"] = "CUSTOMER_ACCOUNT_PASSWORD";
    AuthMethodType["CUSTOMER_ACCOUNT_SSO"] = "CUSTOMER_ACCOUNT_SSO";
    AuthMethodType["ATLASSIAN_ACCOUNT_SSO"] = "ATLASSIAN_ACCOUNT_SSO";
    return AuthMethodType;
}({});
var $e8fc62be58aad5d4$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["ATLASSIAN_ACCOUNT_LOGIN"] = "atlassian.account.login";
    LoginType["ATLASSIAN_ACCOUNT_SIGNUP"] = "atlassian.account.signup";
    LoginType["CUSTOMER_ACCOUNT_LOGIN"] = "customer.account.login";
    LoginType["CUSTOMER_ACCOUNT_SIGNUP"] = "customer.account.signup";
    return LoginType;
}({});
const $e8fc62be58aad5d4$export$491b9d320a651537 = 'sso_test';

});



parcelRegister("eDtG6", function(module, exports) {
$parcel$export(module.exports, "enableResendValidationEmailLink", () => (parcelRequire("5Eeij")).enableResendValidationEmailLink);
$parcel$export(module.exports, "resendValidationEmail", () => (parcelRequire("5Eeij")).resendValidationEmail);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => (parcelRequire("5Eeij")).resendValidationEmailSuccess);
$parcel$export(module.exports, "resendValidationEmailFailure", () => (parcelRequire("5Eeij")).resendValidationEmailFailure);
$parcel$export(module.exports, "setSignupDataAction", () => (parcelRequire("5Eeij")).setSignupDataAction);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => (parcelRequire("5Eeij")).ENABLE_RESEND_VALIDATION_EMAIL_LINK);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => (parcelRequire("5Eeij")).RESEND_VALIDATION_EMAIL);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => (parcelRequire("5Eeij")).RESEND_VALIDATION_EMAIL_SUCCESS);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => (parcelRequire("5Eeij")).RESEND_VALIDATION_EMAIL_FAILURE);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => (parcelRequire("5Eeij")).SET_SIGN_UP_DATA);

var $5Eeij = parcelRequire("5Eeij");

});
parcelRegister("5Eeij", function(module, exports) {
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => $79b75db3a7363b3b$export$9186eb7b1196909f);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => $79b75db3a7363b3b$export$54095a5808d614c5);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => $79b75db3a7363b3b$export$bb70263db5ecc48f);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => $79b75db3a7363b3b$export$1f3acfffff4b90ca);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => $79b75db3a7363b3b$export$b5da7c907fc7ff71);
$parcel$export(module.exports, "resendValidationEmail", () => $79b75db3a7363b3b$export$b53bc6c531462e2c);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => $79b75db3a7363b3b$export$5e093ceac56a577c);
$parcel$export(module.exports, "resendValidationEmailFailure", () => $79b75db3a7363b3b$export$49a7f6865c86a52a);
$parcel$export(module.exports, "enableResendValidationEmailLink", () => $79b75db3a7363b3b$export$bfd31929fb03dc3a);
$parcel$export(module.exports, "setSignupDataAction", () => $79b75db3a7363b3b$export$b9b1c14c91a0ee7a);
const $79b75db3a7363b3b$export$9186eb7b1196909f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL';
const $79b75db3a7363b3b$export$54095a5808d614c5 = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_SUCCESS';
const $79b75db3a7363b3b$export$bb70263db5ecc48f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_FAILURE';
const $79b75db3a7363b3b$export$1f3acfffff4b90ca = 'epic.persisted.signup.ENABLE_RESEND_VALIDATION_EMAIL_LINK';
const $79b75db3a7363b3b$export$b5da7c907fc7ff71 = 'epic.persisted.signup.SET_SIGN_UP_DATA';
const $79b75db3a7363b3b$export$b53bc6c531462e2c = (email, portalId, redirectUrl)=>({
        type: $79b75db3a7363b3b$export$9186eb7b1196909f,
        payload: {
            email: email,
            portalId: portalId,
            redirectUrl: redirectUrl
        }
    });
const $79b75db3a7363b3b$export$5e093ceac56a577c = ()=>({
        type: $79b75db3a7363b3b$export$54095a5808d614c5
    });
const $79b75db3a7363b3b$export$49a7f6865c86a52a = ()=>({
        type: $79b75db3a7363b3b$export$bb70263db5ecc48f
    });
const $79b75db3a7363b3b$export$bfd31929fb03dc3a = ()=>({
        type: $79b75db3a7363b3b$export$1f3acfffff4b90ca
    });
const $79b75db3a7363b3b$export$b9b1c14c91a0ee7a = (email, authInfo)=>({
        type: $79b75db3a7363b3b$export$b5da7c907fc7ff71,
        payload: {
            email: email,
            authInfo: authInfo
        }
    });

});


parcelRegister("klK2e", function(module, exports) {
$parcel$export(module.exports, "fetchAwsWafToken", () => $f0049a6bd060f92a$export$408b4a82d889c63b);

var $jFk35 = parcelRequire("jFk35");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");
const $f0049a6bd060f92a$export$408b4a82d889c63b = (createAnalyticsEvent)=>{
    try {
        if (typeof AwsWafIntegration !== 'undefined' && typeof AwsWafIntegration.getToken === 'function') return (0, $jFk35.Observable).from(AwsWafIntegration.getToken());
        $f0049a6bd060f92a$var$sendFailToFetchWafTokenEvent("js.not.load", createAnalyticsEvent);
        return (0, $jFk35.Observable).of(undefined);
    } catch (error) {
        $f0049a6bd060f92a$var$sendFailToFetchWafTokenEvent("unknown.error", createAnalyticsEvent);
        return (0, $jFk35.Observable).of(undefined);
    }
};
const $f0049a6bd060f92a$var$sendFailToFetchWafTokenEvent = (failureType, createAnalyticsEvent)=>{
    const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
        analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
        action: 'failed',
        actionSubject: 'fetchWafToken',
        attributes: {
            failureType: failureType
        }
    });
    trackEvent && (0, $aIVqJ.legacySendEvent)(trackEvent);
};

});


parcelRegister("5UCp6", function(module, exports) {
$parcel$export(module.exports, "createPasswordEpic", () => $f2deddfe42377e84$export$4f23d4ad55796890);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $epDUQ = parcelRequire("epDUQ");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
const $f2deddfe42377e84$export$4f23d4ad55796890 = (action$)=>{
    return action$.ofType((0, $6oW6S.CREATE_PASSWORD)).mergeMap((createPasswordAction)=>{
        const { resetUrl: resetUrl, email: email } = createPasswordAction.payload;
        return (0, $epDUQ.createPassword)(resetUrl, email).map(()=>{
            return (0, $6oW6S.createPasswordSuccess)();
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("7M1Vy", function(module, exports) {
$parcel$export(module.exports, "exitTestModeEpic", () => $8af0f183337fd76f$export$2da1b652de0f5c38);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");

var $diqlM = parcelRequire("diqlM");

var $gioQl = parcelRequire("gioQl");

var $cJeoZ = parcelRequire("cJeoZ");
const $8af0f183337fd76f$export$2da1b652de0f5c38 = (action$)=>{
    return action$.ofType((0, $6oW6S.EXIT_TEST_MODE_ACTION)).mergeMap((exitTestModeAction)=>{
        const { email: email } = exitTestModeAction.payload;
        return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $6oW6S.resetLogin)(email)), (0, $jFk35.Observable).of((0, $5kfOu.showSuccessFlag)((0, $cJeoZ.default).exitTestModeSuccessFlagTitle, undefined, (0, $cJeoZ.default).exitTestModeSuccessFlagDescription, undefined, {
            emailAddress: email
        }))).do(()=>{
            (0, $diqlM.default).push((0, $gioQl.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
        });
    });
};

});
parcelRegister("cJeoZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb7eb2086b458174$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $fb7eb2086b458174$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    exitTestModeSuccessFlagTitle: {
        defaultMessage: "You\u2019re out of single sign-on test mode",
        description: 'Message title for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.title'
    },
    exitTestModeSuccessFlagDescription: {
        defaultMessage: 'Go to the Authentication page in your Jira settings to enable single sign-on for customers.',
        description: 'Message description for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.description'
    }
});

});


parcelRegister("jCW5p", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $24920f6ed8dc5014$export$cb36b6e8b9a45314);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $epDUQ = parcelRequire("epDUQ");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
const $24920f6ed8dc5014$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $6oW6S.FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, redirectUrl: redirectUrl } = forgotPasswordAction.payload;
        return (0, $epDUQ.forgotPassword)(resetUrl, email, redirectUrl).map(()=>{
            return (0, $6oW6S.forgotPasswordSuccess)();
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("hJyBD", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $08fa9bd3d51a730f$export$da8045e9cad7ec9b);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $epDUQ = parcelRequire("epDUQ");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");

var $fASm6 = parcelRequire("fASm6");
const $08fa9bd3d51a730f$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $6oW6S.LOGIN_ATTEMPT)).mergeMap((loginAction)=>{
        const { email: email, password: password, continueParam: continueParam } = loginAction.payload;
        const loginResponse = (0, $epDUQ.loginV2)(email, password, continueParam);
        return loginResponse.flatMap((response)=>{
            if (response.loginSucceeded) return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $6oW6S.loginAttemptSuccess)(response)), (0, $jFk35.Observable).of((0, $7m3Xa.successfullyLoggedIn)()));
            return (0, $jFk35.Observable).of((0, $6oW6S.loginAttemptSuccess)(response));
        }).catch((error)=>{
            const parsedError = (0, $fASm6.getDefaultError)(error);
            return (0, $jFk35.Observable).of((0, $6oW6S.loginAttemptFailure)(parsedError));
        });
    });
};

});

parcelRegister("chS0d", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsEpic", () => $a54c15d91a6bc5b5$export$2bd3c7829bd01a9c);

var $9mazR = parcelRequire("9mazR");

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");
parcelRequire("700aU");
var $dxx1m = parcelRequire("dxx1m");

var $4f9An = parcelRequire("4f9An");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");

var $h0yAZ = parcelRequire("h0yAZ");

var $ja4bY = parcelRequire("ja4bY");
const $a54c15d91a6bc5b5$var$gqlMutationLoginAnnouncements = (action)=>{
    var _inputVariables$input, _inputVariables$input2;
    const { meta: meta, payload: payload } = action;
    const inputVariables = (0, $h0yAZ.mapLoginAnnouncementsPayloadToGqlInput)(payload);
    if (!((_inputVariables$input = inputVariables.input.nameTranslations) !== null && _inputVariables$input !== void 0 && _inputVariables$input.every((translation)=>translation.locale)) || !((_inputVariables$input2 = inputVariables.input.descriptionTranslations) !== null && _inputVariables$input2 !== void 0 && _inputVariables$input2.every((translation)=>translation.locale))) {
        // making sure that empty locale is not sent to the server
        const errorResponse = {
            status: (0, $9mazR.HTTP).BAD_REQUEST
        };
        return (0, $jFk35.Observable).from(Promise.reject(errorResponse)).catch((error)=>{
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $dxx1m.updateLoginAnnouncementsFailure)(errorResponse)), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
        });
    }
    return (0, $jFk35.Observable).from((0, $h0yAZ.updateLoginAnnouncementsData)(inputVariables).then((response)=>{
        var _response$helpCenter, _response$helpCenter2, _response$helpCenter3;
        if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateLoginAnnouncement) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) // incase of mutation success, we get success as true and no errors
        return true;
        // we get success as false and errors in case of mutation failure
        const errorResponse = {
            errorMessages: ((_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateLoginAnnouncement) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.errors) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.map((error)=>error.message ?? '')) ?? [],
            status: ((_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateLoginAnnouncement) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.errors) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3[0]) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.extensions) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.statusCode) ?? (0, $9mazR.HTTP).SERVER
        };
        return Promise.reject(errorResponse);
    })).flatMap(()=>{
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4f9An.updateLoginAnnouncementSideBarExperience).success();
        // unlink model mutation call, we do not get login announcements in response, hence using payload to call updateLoginAnnouncementsSuccess
        return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $dxx1m.updateLoginAnnouncementsSuccess)(payload)), (0, $jFk35.Observable).of((0, $dxx1m.resetLoginAnnouncements)()));
    }).catch((error)=>{
        if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(error.status)) (0, $aIVqJ.legacySendEvent)((0, $ja4bY.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
        if (!(0, $17nJI.isNetworkOrClientErrorCode)(error.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4f9An.updateLoginAnnouncementSideBarExperience).failure({
            metadata: {
                error: error.message
            }
        });
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4f9An.updateLoginAnnouncementSideBarExperience).success();
        // we are mapping the error, because mutation error in not always in form of AjaxError
        const errorResponse = {
            ...error,
            errorMessages: [
                error.message
            ],
            status: error.status ?? (0, $9mazR.HTTP).SERVER
        };
        return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $dxx1m.updateLoginAnnouncementsFailure)(errorResponse)), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(errorResponse)));
    });
};
const $a54c15d91a6bc5b5$export$2bd3c7829bd01a9c = (action$)=>{
    return action$.ofType((0, $dxx1m.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL)).mergeMap((action)=>{
        return $a54c15d91a6bc5b5$var$gqlMutationLoginAnnouncements(action);
    });
};

});
parcelRegister("700aU", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => (parcelRequire("dxx1m")).fetchLoginAnnouncementModel);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("dxx1m")).FETCH_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("dxx1m")).FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("dxx1m")).FETCH_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => (parcelRequire("dxx1m")).fetchLoginAnnouncementsSuccess);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => (parcelRequire("dxx1m")).fetchLoginAnnouncementsFailure);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => (parcelRequire("dxx1m")).UPDATE_LOGIN_ANNOUNCEMENTS_MODEL);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("dxx1m")).UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("dxx1m")).UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("dxx1m")).UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("dxx1m")).RESET_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => (parcelRequire("dxx1m")).updateLoginAnnouncementsModel);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => (parcelRequire("dxx1m")).updateLoginAnnouncementsSuccess);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => (parcelRequire("dxx1m")).updateLoginAnnouncementsFailure);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => (parcelRequire("dxx1m")).updateLoginAnnouncementsUIState);
$parcel$export(module.exports, "resetLoginAnnouncements", () => (parcelRequire("dxx1m")).resetLoginAnnouncements);

var $dxx1m = parcelRequire("dxx1m");

});
parcelRegister("dxx1m", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => $a7a534a1cbfcbd58$export$dc62bc08b47f80d);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $a7a534a1cbfcbd58$export$b975358f73425401);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => $a7a534a1cbfcbd58$export$182afe1fbca9c1ad);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => $a7a534a1cbfcbd58$export$ebcd8b9795616937);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => $a7a534a1cbfcbd58$export$85451866d84a5811);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $a7a534a1cbfcbd58$export$bca8bb13b9278354);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => $a7a534a1cbfcbd58$export$12b5ff9da9aaaa28);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => $a7a534a1cbfcbd58$export$2ef132370a38839c);
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => $a7a534a1cbfcbd58$export$2510bc335620bfa4);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => $a7a534a1cbfcbd58$export$66b083401f2dd420);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => $a7a534a1cbfcbd58$export$b7ec07a46de8ffd1);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => $a7a534a1cbfcbd58$export$c139274c332846b7);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => $a7a534a1cbfcbd58$export$1723ccec0130d524);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => $a7a534a1cbfcbd58$export$682d06bd9eef1572);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => $a7a534a1cbfcbd58$export$5b3b63a7f806c6d8);
$parcel$export(module.exports, "resetLoginAnnouncements", () => $a7a534a1cbfcbd58$export$c992a3f94eef7527);

var $dv0hN = parcelRequire("dv0hN");
const $a7a534a1cbfcbd58$export$dc62bc08b47f80d = 'epic.model.FETCH_LOGIN_ANNOUNCEMENTS';
const $a7a534a1cbfcbd58$export$b975358f73425401 = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $a7a534a1cbfcbd58$export$182afe1fbca9c1ad = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE';
const $a7a534a1cbfcbd58$export$ebcd8b9795616937 = 'epic.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL';
const $a7a534a1cbfcbd58$export$85451866d84a5811 = 'state.ui.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE';
const $a7a534a1cbfcbd58$export$bca8bb13b9278354 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $a7a534a1cbfcbd58$export$12b5ff9da9aaaa28 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE';
const $a7a534a1cbfcbd58$export$2ef132370a38839c = 'state.ui.loginAnnouncements.RESET_LOGIN_ANNOUNCEMENTS';
const $a7a534a1cbfcbd58$export$2510bc335620bfa4 = (0, $dv0hN.buildModelsActionCreator)($a7a534a1cbfcbd58$export$dc62bc08b47f80d, 'loginAnnouncements');
const $a7a534a1cbfcbd58$export$66b083401f2dd420 = (loginAnnouncementsModel)=>({
        type: $a7a534a1cbfcbd58$export$b975358f73425401,
        payload: loginAnnouncementsModel
    });
const $a7a534a1cbfcbd58$export$b7ec07a46de8ffd1 = (error)=>({
        type: $a7a534a1cbfcbd58$export$182afe1fbca9c1ad,
        payload: {
            error: error
        }
    });
const $a7a534a1cbfcbd58$export$c139274c332846b7 = (loginAnnouncementsModel, meta)=>({
        meta: meta,
        type: $a7a534a1cbfcbd58$export$ebcd8b9795616937,
        payload: loginAnnouncementsModel
    });
const $a7a534a1cbfcbd58$export$1723ccec0130d524 = (loginAnnouncementsModel)=>({
        type: $a7a534a1cbfcbd58$export$bca8bb13b9278354,
        payload: loginAnnouncementsModel
    });
const $a7a534a1cbfcbd58$export$682d06bd9eef1572 = (error)=>({
        type: $a7a534a1cbfcbd58$export$12b5ff9da9aaaa28,
        payload: {
            error: error
        }
    });
const $a7a534a1cbfcbd58$export$5b3b63a7f806c6d8 = (loginAnnouncementsModel)=>({
        type: $a7a534a1cbfcbd58$export$85451866d84a5811,
        payload: loginAnnouncementsModel
    });
const $a7a534a1cbfcbd58$export$c992a3f94eef7527 = ()=>({
        type: $a7a534a1cbfcbd58$export$2ef132370a38839c
    });

});


parcelRegister("h0yAZ", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsData", () => $f798e9562bde87a0$export$40a99b486fb0f5fd);
$parcel$export(module.exports, "mapLoginAnnouncementsPayloadToGqlInput", () => $f798e9562bde87a0$export$85e7a57e62ad0fbc);

var $6INqF = parcelRequire("6INqF");

var $5KQKg = parcelRequire("5KQKg");

var $6LH8a = parcelRequire("6LH8a");

var $1xOZp = parcelRequire("1xOZp");
const $f798e9562bde87a0$export$40a99b486fb0f5fd = (variables)=>{
    return new Promise((resolve, reject)=>{
        (0, $5KQKg.commitMutation)((0, $1xOZp.getRelayEnvironment)(), {
            variables: variables,
            mutation: (0, $6INqF.default),
            onCompleted: (response)=>{
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};
const $f798e9562bde87a0$export$85e7a57e62ad0fbc = (payload)=>{
    const nameTranslations = [];
    const descriptionTranslations = [];
    // map payload to gql input
    Object.keys(payload.translatedLogInAnnouncements).forEach((locale)=>{
        nameTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].header
        });
        descriptionTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].message
        });
    });
    return {
        cloudId: (0, $6LH8a.getCloudId)(),
        input: {
            nameTranslations: nameTranslations,
            descriptionTranslations: descriptionTranslations,
            helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
            descriptionType: 'WIKI_MARKUP'
        }
    };
};

});
parcelRegister("6INqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $21804aadcf64a602$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a43a0b0a9899057b05221c5b213a09fa>>
 * @relayHash d08d5aad8dde8629cc060f7256c65f6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c
const $21804aadcf64a602$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c",
            "metadata": {},
            "name": "loginAnnouncementsUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$21804aadcf64a602$var$node.hash = "a5dd7f4861ac93d9b41cc3104b2a0e6a";
var $21804aadcf64a602$export$2e2bcd8739ae039 = $21804aadcf64a602$var$node;

});

parcelRegister("1xOZp", function(module, exports) {
$parcel$export(module.exports, "getRelayEnvironment", () => $7efc9ac905497ec7$export$ffa93f1e5be01566);

var $hN5YJ = parcelRequire("hN5YJ");

var $dRkX9 = parcelRequire("dRkX9");

var $cUcXT = parcelRequire("cUcXT");

var $5WGzE = parcelRequire("5WGzE");

var $jWHK4 = parcelRequire("jWHK4");

var $cH4DC = parcelRequire("cH4DC");

var $9cYDP = parcelRequire("9cYDP");

var $2xOCW = parcelRequire("2xOCW");
const $7efc9ac905497ec7$var$resolveSharedRelayGetDataIDConfig = ()=>{
    if ((0, $hN5YJ.isFixRelayIdConflictForHelpObjectStoreEnabled)()) return {
        getDataID: (0, $5WGzE.resolveGetDataID)()
    };
    if (!(0, $hN5YJ.isFixRelayIdConflictInHelpCenter)()) return {
        getDataID: undefined
    };
    return {};
};
const $7efc9ac905497ec7$var$sharedRelayEnvironment = (0, $cUcXT.createRelayEnvironment)({
    ...$7efc9ac905497ec7$var$resolveSharedRelayGetDataIDConfig(),
    networkOptions: {
        setEndpoint: (0, $jWHK4.default).setEndpoint,
        getHeaders: (0, $jWHK4.default).getHeaders,
        isServer: false,
        subscribeExtensions: (0, $9cYDP.subscribeOptions).extensions,
        onSubscribeError: (0, $9cYDP.subscribeOptions).onError,
        onSubscribeTrigger: (0, $9cYDP.subscribeOptions).onTrigger,
        queryResponseCache: (0, $cH4DC.QueryResponseCache),
        validateResponse: (0, $jWHK4.default).validateResponse,
        onFetchError: (0, $jWHK4.default).onFetchError
    }
});
const $7efc9ac905497ec7$export$ffa93f1e5be01566 = ()=>{
    if ((0, $dRkX9.fg)('platform_relay_use_shared_relay_env_help_center')) return $7efc9ac905497ec7$var$sharedRelayEnvironment;
    return 0, $5WGzE.default;
};

});
parcelRegister("cUcXT", function(module, exports) {
$parcel$export(module.exports, "isAtlassianRelayEnvironment", () => $b156dbd350363998$export$56db1ec1ca8ef90c);
$parcel$export(module.exports, "createRelayEnvironment", () => $b156dbd350363998$export$7afaa9c867644497);

var $5KQKg = parcelRequire("5KQKg");

var $6h04l = parcelRequire("6h04l");

var $1i4zH = parcelRequire("1i4zH");

var $brUL9 = parcelRequire("brUL9");

var $ddWwf = parcelRequire("ddWwf");

var $1znWW = parcelRequire("1znWW");

var $1WbgB = parcelRequire("1WbgB");

var $6NkX9 = parcelRequire("6NkX9");

var $gJw8m = parcelRequire("gJw8m");

var $aEwT0 = parcelRequire("aEwT0");
// Enable Relay Resolvers globally for this module
(0, $5KQKg.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $b156dbd350363998$var$createNetwork(networkOptions, getEnableUfoHolds) {
    const fetchOperation = (request, variables, cacheConfig)=>(0, $ddWwf.fetch)(request, variables, cacheConfig, networkOptions);
    const fetchOperationWithMiddleware = (0, $aEwT0.ufoDataFetchHoldMiddleware)(fetchOperation, {
        getIsEnabled: getEnableUfoHolds
    });
    return (0, $5KQKg.Network).create(fetchOperationWithMiddleware, networkOptions.isServer === false ? (0, $6NkX9.createSubscribeFn)(networkOptions) : undefined);
}
/**
 * Brand attached to every environment produced by {@link createRelayEnvironment}.
 *
 * We use `Symbol.for` (the global symbol registry) rather than a module-local `Symbol()` so the
 * brand stays stable even if this module ends up duplicated across bundles/realms — the guard in a
 * consumer will still recognise an environment created by another copy of this package.
 */ const $b156dbd350363998$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND = Symbol.for('@atlassian/relay-environment.AtlassianRelayEnvironment');
function $b156dbd350363998$var$brandEnvironment(environment) {
    Object.defineProperty(environment, $b156dbd350363998$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND, {
        value: true,
        enumerable: false,
        configurable: false,
        writable: false
    });
    return environment;
}
function $b156dbd350363998$export$56db1ec1ca8ef90c(environment) {
    return environment != null && (typeof environment === 'object' || typeof environment === 'function') && environment[$b156dbd350363998$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND] === true;
}
/**
 * Relay calls `environment.UNSTABLE_getDefaultRenderPolicy()` on every `QueryResource.prepare`, so
 * this allows overriding it dynamically (and not during module scope evaluation).
 */ class $b156dbd350363998$var$DynamicRenderPolicyEnvironment extends (0, $5KQKg.Environment) {
    constructor(config, getRenderPolicy){
        super(config);
        this.getRenderPolicy = getRenderPolicy;
    }
    /**
   * Note: currently missing from @types/relay-runtime (version 20.1.1) but DOES exist at runtime.
   */ UNSTABLE_getDefaultRenderPolicy() {
        return this.getRenderPolicy();
    }
}
const $b156dbd350363998$var$createStore = (source, options)=>new (0, (/*@__PURE__*/$parcel$interopDefault($6h04l)))(source, options);
function $b156dbd350363998$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, getDefaultRenderPolicy: getDefaultRenderPolicy, getEnableUfoHolds: getEnableUfoHolds, wsClientOptions: wsClientOptions }) {
    if (wsClientOptions) (0, $1i4zH.configureWebSocketClient)(wsClientOptions);
    const source = new (0, $5KQKg.RecordSource)();
    const config = {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $b156dbd350363998$var$createNetwork(networkOptions || {
            isServer: false
        }, getEnableUfoHolds),
        store: $b156dbd350363998$var$createStore(source, {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $brUL9.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $brUL9.default),
        scheduler: (0, $1WbgB.default),
        missingFieldHandlers: (0, $1znWW.default),
        handlerProvider: (0, $gJw8m.createRelayHandlerProvider)(source)
    };
    const environment = getDefaultRenderPolicy ? new $b156dbd350363998$var$DynamicRenderPolicyEnvironment(config, getDefaultRenderPolicy) : new (0, $5KQKg.Environment)(config);
    return $b156dbd350363998$var$brandEnvironment(environment);
}

});
parcelRegister("6h04l", function(module, exports) {
'use strict';

var $6h5qO = parcelRequire("6h5qO");
module.exports = $6h5qO;

});

parcelRegister("1i4zH", function(module, exports) {
$parcel$export(module.exports, "configureWebSocketClient", () => $8d49c2a0588eddcf$export$155768b0e0a38663);
$parcel$export(module.exports, "getClient", () => $8d49c2a0588eddcf$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getSocketConnectionState", () => $8d49c2a0588eddcf$export$83dc7d6f7d0a4fad);
$parcel$export(module.exports, "acquireSubscriptionClient", () => $8d49c2a0588eddcf$export$2f4a9d3832f4a2d9);

var $fSTQn = parcelRequire("fSTQn");

var $dRkX9 = parcelRequire("dRkX9");

var $fOrLF = parcelRequire("fOrLF");

var $ey8US = parcelRequire("ey8US");

var $5AJaZ = parcelRequire("5AJaZ");

var $lnGCO = parcelRequire("lnGCO");

var $18WXM = parcelRequire("18WXM");

var $5shBR = parcelRequire("5shBR");
const $8d49c2a0588eddcf$var$defaultClientState = (0, $lnGCO.createClientState)();
let $8d49c2a0588eddcf$var$configuredOptions;
let $8d49c2a0588eddcf$var$recoveryCount = 0;
let $8d49c2a0588eddcf$var$detachRecovery;
const $8d49c2a0588eddcf$export$155768b0e0a38663 = (options)=>{
    if ($8d49c2a0588eddcf$var$defaultClientState.client) {
        // eslint-disable-next-line no-console
        console.warn('configureWebSocketClient was called after the subscription client was already created, so these options have been ignored. Configure it while creating the relay environment, before any subscription starts.');
        return;
    }
    $8d49c2a0588eddcf$var$configuredOptions = options;
};
const $8d49c2a0588eddcf$var$getClientForState = (state, url)=>{
    if ((0, $5AJaZ.isSSR)()) return null;
    if (!state.client) {
        var _configuredOptions, _configuredOptions$ge, _window, _window2;
        const onConnectionEvent = (_configuredOptions = $8d49c2a0588eddcf$var$configuredOptions) === null || _configuredOptions === void 0 || (_configuredOptions$ge = _configuredOptions.getConnectionEventReporter) === null || _configuredOptions$ge === void 0 ? void 0 : _configuredOptions$ge.call(_configuredOptions);
        const terminate = ()=>{
            var _state$client;
            return (_state$client = state.client) === null || _state$client === void 0 ? void 0 : _state$client.terminate();
        };
        const { listeners: listeners, isConnected: isConnected } = (0, $5shBR.createSocketListeners)({
            onConnectionEvent: onConnectionEvent,
            pongWaitTimeout: (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? (0, $ey8US.WS_CLIENT_PONG_WAIT) : 0,
            terminate: terminate
        });
        state.isSocketConnected = isConnected;
        const rateLimitedRetryWait = (0, $dRkX9.fg)('platform_relay_subscription_reliability') && (0, $dRkX9.fg)('platform_relay_subscription_rate_limit_backoff') ? (0, $18WXM.createRateLimitedRetryWait)((0, $ey8US.WS_CLIENT_MAX_RETRY_WAIT)) : undefined;
        const retryWait = (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? rateLimitedRetryWait ?? (0, $18WXM.createRetryWait)((0, $ey8US.WS_CLIENT_MAX_RETRY_WAIT)) : undefined;
        state.abortPendingRetryWait = (retryWait === null || retryWait === void 0 ? void 0 : retryWait.abort) ?? (()=>false);
        state.observesSocketState = (0, $dRkX9.fg)('platform_relay_subscription_reliability-additional') && Boolean(onConnectionEvent || (0, $dRkX9.fg)('platform_relay_subscription_reliability'));
        const options = {
            url: url ?? (0, $5AJaZ.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? (0, $ey8US.WS_CLIENT_LIVENESS_KEEP_ALIVE) : (0, $ey8US.WS_CLIENT_KEEP_ALIVE),
            retryAttempts: (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? (0, $ey8US.WS_CLIENT_CAPPED_RETRIES) : (0, $ey8US.WS_CLIENT_RETRIES),
            retryWait: retryWait === null || retryWait === void 0 ? void 0 : retryWait.wait,
            shouldRetry: (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? (0, $18WXM.shouldRetryTransportFailure) : undefined,
            // 0 = wait forever (graphql-ws default).
            connectionAckWaitTimeout: (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? (0, $ey8US.WS_CLIENT_CONNECTION_ACK_WAIT) : 0,
            lazyCloseTimeout: (0, $dRkX9.fg)('platform_relay_subscription_connection_reuse') ? (0, $ey8US.WS_CLIENT_LAZY_CLOSE) : 0,
            on: onConnectionEvent || (0, $dRkX9.fg)('platform_relay_subscription_reliability') ? listeners : undefined,
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${((_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) ?? ''}::${((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.SSR_BUILD_KEY) ?? ''}`,
                'X-ExperimentalApi': (0, $fOrLF.getRelayExperimentalApis)().join(',')
            }
        };
        state.client = (0, $fSTQn.createClient)(options);
        state.lazyCloseTimeout = options.lazyCloseTimeout;
        if (rateLimitedRetryWait) state.client.on('closed', rateLimitedRetryWait.recordClose);
    }
    return state.client;
};
const $8d49c2a0588eddcf$export$6bb76d6eba7e258c = ()=>$8d49c2a0588eddcf$var$getClientForState($8d49c2a0588eddcf$var$defaultClientState);
const $8d49c2a0588eddcf$export$b4412e664c6cc09b = ()=>{
    if (!(0, $dRkX9.fg)('platform_relay_subscription_reliability')) return ()=>{};
    $8d49c2a0588eddcf$var$recoveryCount += 1;
    if ($8d49c2a0588eddcf$var$recoveryCount === 1) (0, $lnGCO.setEndpointRecoveryEnabled)(true);
    $8d49c2a0588eddcf$var$detachRecovery ?? ($8d49c2a0588eddcf$var$detachRecovery = (0, $18WXM.addRecoveryListeners)({
        terminate: ()=>{
            var _defaultClientState$c;
            return (_defaultClientState$c = $8d49c2a0588eddcf$var$defaultClientState.client) === null || _defaultClientState$c === void 0 ? void 0 : _defaultClientState$c.terminate();
        },
        isConnected: ()=>$8d49c2a0588eddcf$var$defaultClientState.isSocketConnected(),
        abortRetryWait: ()=>$8d49c2a0588eddcf$var$defaultClientState.abortPendingRetryWait()
    }));
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        $8d49c2a0588eddcf$var$recoveryCount -= 1;
        if ($8d49c2a0588eddcf$var$recoveryCount === 0) {
            var _detachRecovery;
            (0, $lnGCO.setEndpointRecoveryEnabled)(false);
            (_detachRecovery = $8d49c2a0588eddcf$var$detachRecovery) === null || _detachRecovery === void 0 || _detachRecovery();
            $8d49c2a0588eddcf$var$detachRecovery = undefined;
        }
    };
};
const $8d49c2a0588eddcf$export$2f0afd443356d36f = ()=>{
    $8d49c2a0588eddcf$var$defaultClientState.client = null;
    $8d49c2a0588eddcf$var$configuredOptions = undefined;
    $8d49c2a0588eddcf$var$defaultClientState.isSocketConnected = ()=>false;
    $8d49c2a0588eddcf$var$defaultClientState.abortPendingRetryWait = ()=>false;
    $8d49c2a0588eddcf$var$defaultClientState.observesSocketState = false;
    $8d49c2a0588eddcf$var$defaultClientState.lazyCloseTimeout = 0;
};
/** Unknown when the product has not enabled socket lifecycle reporting or reliability. */ const $8d49c2a0588eddcf$var$getConnectionState = (state)=>(0, $dRkX9.fg)('platform_relay_subscription_reliability-additional') && state.observesSocketState ? state.isSocketConnected() ? 'connected' : 'disconnected' : 'unknown';
const $8d49c2a0588eddcf$export$83dc7d6f7d0a4fad = ()=>$8d49c2a0588eddcf$var$getConnectionState($8d49c2a0588eddcf$var$defaultClientState);
const $8d49c2a0588eddcf$export$2f4a9d3832f4a2d9 = (url)=>(0, $5AJaZ.isSSR)() ? null : (0, $lnGCO.acquireClient)(typeof url === 'function' ? url() : url, $8d49c2a0588eddcf$var$getClientForState, $8d49c2a0588eddcf$var$getConnectionState);

});
parcelRegister("fSTQn", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $02fbfcc455a4b833$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $7Qm8x = parcelRequire("7Qm8x");

var $ctcDy = parcelRequire("ctcDy");
var $02fbfcc455a4b833$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $02fbfcc455a4b833$var$__await ? (this.v = v, this) : new $02fbfcc455a4b833$var$__await(v);
};
var $02fbfcc455a4b833$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $02fbfcc455a4b833$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $02fbfcc455a4b833$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $02fbfcc455a4b833$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$02fbfcc455a4b833$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $7Qm8x.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $7Qm8x.stringifyMessage)({
                                    type: (0, $7Qm8x.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $02fbfcc455a4b833$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $7Qm8x.stringifyMessage)(payload ? {
                            type: (0, $7Qm8x.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $7Qm8x.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $7Qm8x.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $7Qm8x.CloseCode).InternalClientError, (0, $ctcDy.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $7Qm8x.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $7Qm8x.stringifyMessage)(message.payload ? {
                                    type: (0, $7Qm8x.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $7Qm8x.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $7Qm8x.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $7Qm8x.CloseCode).BadResponse, (0, $ctcDy.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($02fbfcc455a4b833$var$isLikeCloseEvent(errOrCloseEvent) && ($02fbfcc455a4b833$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $7Qm8x.CloseCode).InternalServerError,
            (0, $7Qm8x.CloseCode).InternalClientError,
            (0, $7Qm8x.CloseCode).BadRequest,
            (0, $7Qm8x.CloseCode).BadResponse,
            (0, $7Qm8x.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $7Qm8x.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $7Qm8x.CloseCode).SubscriberAlreadyExists,
            (0, $7Qm8x.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($02fbfcc455a4b833$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $7Qm8x.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $7Qm8x.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $7Qm8x.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $7Qm8x.stringifyMessage)({
                    id: id,
                    type: (0, $7Qm8x.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $7Qm8x.stringifyMessage)({
                        id: id,
                        type: (0, $7Qm8x.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $02fbfcc455a4b833$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $02fbfcc455a4b833$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $02fbfcc455a4b833$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $02fbfcc455a4b833$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $02fbfcc455a4b833$export$f5b1bfead8e118a7());
        }
    };
}
class $02fbfcc455a4b833$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $02fbfcc455a4b833$var$isLikeCloseEvent(val) {
    return (0, $ctcDy.isObject)(val) && 'code' in val && 'reason' in val;
}
function $02fbfcc455a4b833$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $02fbfcc455a4b833$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("7Qm8x", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $5b5e8fa05d486d25$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $5b5e8fa05d486d25$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $5b5e8fa05d486d25$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $5b5e8fa05d486d25$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $5b5e8fa05d486d25$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $ctcDy = parcelRequire("ctcDy");
const $5b5e8fa05d486d25$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $5b5e8fa05d486d25$export$ec743af8bb66f3be = 'graphql-ws';
var $5b5e8fa05d486d25$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($5b5e8fa05d486d25$export$777128f41f6616ec || ($5b5e8fa05d486d25$export$777128f41f6616ec = {}));
var $5b5e8fa05d486d25$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($5b5e8fa05d486d25$export$80edbf15fa61a4db || ($5b5e8fa05d486d25$export$80edbf15fa61a4db = {}));
function $5b5e8fa05d486d25$export$c17861b159b1b673(val) {
    if (!(0, $ctcDy.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $ctcDy.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $ctcDy.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.ConnectionInit:
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.ConnectionAck:
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.Ping:
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $ctcDy.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ctcDy.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ctcDy.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $ctcDy.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $ctcDy.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $ctcDy.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $ctcDy.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $ctcDy.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $ctcDy.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $ctcDy.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $ctcDy.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ctcDy.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ctcDy.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $ctcDy.extendedTypeof)(val.payload)}`);
            break;
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ctcDy.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ctcDy.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $5b5e8fa05d486d25$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ctcDy.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $5b5e8fa05d486d25$export$9e0e49e75fa7d548(val) {
    try {
        $5b5e8fa05d486d25$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $5b5e8fa05d486d25$export$f2f615077a189f21(data, reviver) {
    return $5b5e8fa05d486d25$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $5b5e8fa05d486d25$export$77896e5b47bfd50b(msg, replacer) {
    $5b5e8fa05d486d25$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("ctcDy", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $9141feecd7cb9d6c$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $9141feecd7cb9d6c$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $9141feecd7cb9d6c$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $9141feecd7cb9d6c$export$2937fa0c8dddae54);
/** @private */ function $9141feecd7cb9d6c$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $9141feecd7cb9d6c$export$a6cdc56e425d0d0a(val) {
    return $9141feecd7cb9d6c$export$573326049e1b1c6b(val) === 'object';
}
function $9141feecd7cb9d6c$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $9141feecd7cb9d6c$export$92bd080471bc30f1(val) {
    return $9141feecd7cb9d6c$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $9141feecd7cb9d6c$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $9141feecd7cb9d6c$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("fOrLF", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $7f3f58b8b0242139$export$2cb71284f72ca45b);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $7f3f58b8b0242139$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const $7f3f58b8b0242139$export$2cb71284f72ca45b = ()=>$7f3f58b8b0242139$export$ebe3a775ce3053a5;

});

parcelRegister("ey8US", function(module, exports) {
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $a85bc5c492d7e3ca$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_LIVENESS_KEEP_ALIVE", () => $a85bc5c492d7e3ca$export$68a6a6cccbaf5f06);
$parcel$export(module.exports, "WS_CLIENT_PONG_WAIT", () => $a85bc5c492d7e3ca$export$6fe3216720bb7a79);
$parcel$export(module.exports, "WS_CLIENT_CONNECTION_ACK_WAIT", () => $a85bc5c492d7e3ca$export$e5f3cb8ab5223cd4);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $a85bc5c492d7e3ca$export$bf6cd96e19b2987f);
$parcel$export(module.exports, "WS_CLIENT_MAX_RETRY_WAIT", () => $a85bc5c492d7e3ca$export$bcf3b302e1a0ba63);
$parcel$export(module.exports, "WS_CLOSE_RATE_LIMITED", () => $a85bc5c492d7e3ca$export$74f911c394187993);
$parcel$export(module.exports, "WS_CLIENT_MAX_RETRY_AFTER", () => $a85bc5c492d7e3ca$export$5d72de7e544ab20f);
$parcel$export(module.exports, "WS_CLIENT_RATE_LIMIT_SPREAD", () => $a85bc5c492d7e3ca$export$a5991d6597d2d0f8);
$parcel$export(module.exports, "WS_CLIENT_CAPPED_RETRIES", () => $a85bc5c492d7e3ca$export$6a0c27ebdbd1f0ed);
$parcel$export(module.exports, "WS_CLIENT_LAZY_CLOSE", () => $a85bc5c492d7e3ca$export$3f57674185473b5d);
// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $a85bc5c492d7e3ca$export$8b012b965402e06a = 580000;
const $a85bc5c492d7e3ca$export$68a6a6cccbaf5f06 = 30000;
const $a85bc5c492d7e3ca$export$6fe3216720bb7a79 = 15000;
const $a85bc5c492d7e3ca$export$e5f3cb8ab5223cd4 = 15000;
const $a85bc5c492d7e3ca$export$bf6cd96e19b2987f = 100;
const $a85bc5c492d7e3ca$export$bcf3b302e1a0ba63 = 30000;
const $a85bc5c492d7e3ca$export$74f911c394187993 = 4430;
const $a85bc5c492d7e3ca$export$5d72de7e544ab20f = 300000;
const $a85bc5c492d7e3ca$export$a5991d6597d2d0f8 = 15000;
const $a85bc5c492d7e3ca$export$6a0c27ebdbd1f0ed = 240;
const $a85bc5c492d7e3ca$export$3f57674185473b5d = 5000;
const $a85bc5c492d7e3ca$export$1ad8434180c5936c = 300000;

});

parcelRegister("5AJaZ", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $47286b15ae6fe12a$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $47286b15ae6fe12a$export$29a72e89601dfc59);
const $47286b15ae6fe12a$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $47286b15ae6fe12a$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});

parcelRegister("lnGCO", function(module, exports) {
$parcel$export(module.exports, "createClientState", () => $51b6528962dca3d5$export$cc843780465d747);
$parcel$export(module.exports, "setEndpointRecoveryEnabled", () => $51b6528962dca3d5$export$9a35d4fa6f37aac7);
$parcel$export(module.exports, "acquireClient", () => $51b6528962dca3d5$export$8ecce7f262269062);

var $18WXM = parcelRequire("18WXM");
const $51b6528962dca3d5$export$cc843780465d747 = ()=>({
        client: null,
        isSocketConnected: ()=>false,
        abortPendingRetryWait: ()=>false,
        observesSocketState: false,
        lazyCloseTimeout: 0
    });
const $51b6528962dca3d5$var$clients = new Map();
let $51b6528962dca3d5$var$recoveryEnabled = false;
function $51b6528962dca3d5$var$attachRecovery(entry) {
    if ($51b6528962dca3d5$var$recoveryEnabled && entry.references > 0 && !entry.detachRecovery) entry.detachRecovery = (0, $18WXM.addRecoveryListeners)({
        terminate: ()=>entry.client.terminate(),
        isConnected: entry.state.isSocketConnected,
        abortRetryWait: entry.state.abortPendingRetryWait
    });
}
function $51b6528962dca3d5$export$9a35d4fa6f37aac7(enabled) {
    $51b6528962dca3d5$var$recoveryEnabled = enabled;
    for (const entry of $51b6528962dca3d5$var$clients.values())if (enabled) $51b6528962dca3d5$var$attachRecovery(entry);
    else {
        var _entry$detachRecovery;
        (_entry$detachRecovery = entry.detachRecovery) === null || _entry$detachRecovery === void 0 || _entry$detachRecovery.call(entry);
        entry.detachRecovery = undefined;
    }
}
function $51b6528962dca3d5$export$8ecce7f262269062(url, initialize, getConnectionState) {
    let entry = $51b6528962dca3d5$var$clients.get(url);
    if (!entry) {
        const state = $51b6528962dca3d5$export$cc843780465d747();
        const client = initialize(state, url);
        if (!client) return null;
        entry = {
            state: state,
            client: client,
            references: 0
        };
        $51b6528962dca3d5$var$clients.set(url, entry);
    }
    const acquired = entry;
    clearTimeout(acquired.evictionTimer);
    acquired.evictionTimer = undefined;
    acquired.references += 1;
    $51b6528962dca3d5$var$attachRecovery(acquired);
    let released = false;
    return {
        client: acquired.client,
        getSocketConnectionState: ()=>getConnectionState(acquired.state),
        release: ()=>{
            var _acquired$detachRecov;
            if (released) return;
            released = true;
            if (--acquired.references !== 0) return;
            (_acquired$detachRecov = acquired.detachRecovery) === null || _acquired$detachRecov === void 0 || _acquired$detachRecov.call(acquired);
            acquired.detachRecovery = undefined;
            const evict = ()=>{
                // A rapid resubscription can retain the entry during the lazy-close window.
                if (acquired.references !== 0 || $51b6528962dca3d5$var$clients.get(url) !== acquired) return;
                $51b6528962dca3d5$var$clients.delete(url);
                try {
                    Promise.resolve(acquired.client.dispose()).catch(()=>{
                    /* disposal errors must not break observer teardown */ });
                } catch  {
                /* disposal errors must not break observer teardown */ }
            };
            if (acquired.state.lazyCloseTimeout > 0) acquired.evictionTimer = setTimeout(evict, acquired.state.lazyCloseTimeout);
            else evict();
        }
    };
}

});
parcelRegister("18WXM", function(module, exports) {
$parcel$export(module.exports, "createRetryWait", () => $141bb4764f7ec5ed$export$ea2f6b7dff89727b);
$parcel$export(module.exports, "shouldRetryTransportFailure", () => $141bb4764f7ec5ed$export$f7ed0a50263b7ba7);
$parcel$export(module.exports, "createRateLimitedRetryWait", () => $141bb4764f7ec5ed$export$7543ed35130ad0de);
$parcel$export(module.exports, "addRecoveryListeners", () => $141bb4764f7ec5ed$export$693cd641fa681cb1);

var $j5N6B = parcelRequire("j5N6B");

var $ey8US = parcelRequire("ey8US");
const $141bb4764f7ec5ed$export$ea2f6b7dff89727b = (maxRetryWait)=>{
    let abortCurrent;
    return {
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            abortCurrent = undefined;
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            const delay = Math.min(1000 * 2 ** retries + jitter, maxRetryWait);
            await new Promise((resolve)=>{
                const timer = setTimeout(()=>{
                    abortCurrent = undefined;
                    resolve();
                }, delay);
                abortCurrent = ()=>{
                    clearTimeout(timer);
                    resolve();
                };
            });
        }
    };
};
// The library's own default `shouldRetry`. From 5.16, `Client.terminate()` emits a close-like
// `Error`, so the close shape must be checked before the type.
const $141bb4764f7ec5ed$var$isLikeCloseEvent = (value)=>typeof value === 'object' && value !== null && 'code' in value && 'reason' in value;
const $141bb4764f7ec5ed$export$f7ed0a50263b7ba7 = (errOrCloseEvent)=>$141bb4764f7ec5ed$var$isLikeCloseEvent(errOrCloseEvent) || !(errOrCloseEvent instanceof Error);
/** Retry-after in ms of a rate-limit close, or undefined for any other close. */ const $141bb4764f7ec5ed$var$getRateLimitRetryAfter = (event)=>{
    if (!$141bb4764f7ec5ed$var$isLikeCloseEvent(event) || event.code !== (0, $ey8US.WS_CLOSE_RATE_LIMITED) || typeof event.reason !== 'string' || !/^\d+$/.test(event.reason)) return undefined;
    return Math.min(Math.max(Number(event.reason), 1) * 1000, (0, $ey8US.WS_CLIENT_MAX_RETRY_AFTER));
};
const $141bb4764f7ec5ed$export$7543ed35130ad0de = (maxRetryWait)=>{
    let notBefore = 0;
    let abortCurrent;
    return {
        recordClose: (event)=>{
            const retryAfter = $141bb4764f7ec5ed$var$getRateLimitRetryAfter(event);
            if (retryAfter !== undefined) notBefore = Date.now() + retryAfter + Math.floor(Math.random() * (0, $ey8US.WS_CLIENT_RATE_LIMIT_SPREAD));
        },
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            // Jitter after the cap, so clients that reached it do not retry in lockstep.
            const backoff = Math.min(1000 * 2 ** retries, maxRetryWait) + jitter;
            await new Promise((resolve)=>{
                let timer;
                const finish = ()=>{
                    clearTimeout(timer);
                    abortCurrent = undefined;
                    resolve();
                };
                const finishAfter = (delay)=>{
                    clearTimeout(timer);
                    timer = setTimeout(finish, delay);
                };
                finishAfter(Math.max(backoff, notBefore - Date.now()));
                abortCurrent = ()=>{
                    const untilDeadline = notBefore - Date.now();
                    if (untilDeadline > 0) finishAfter(untilDeadline);
                    else finish();
                };
            });
        }
    };
};
const $141bb4764f7ec5ed$export$693cd641fa681cb1 = ({ terminate: terminate, isConnected: isConnected, abortRetryWait: abortRetryWait })=>{
    const doc = (0, $j5N6B.getDocument)();
    const reconnect = ()=>{
        if (abortRetryWait()) return;
        terminate();
    };
    const wakeIfDisconnected = ()=>{
        if (!isConnected()) reconnect();
    };
    const onVisibilityChange = ()=>{
        if ((doc === null || doc === void 0 ? void 0 : doc.visibilityState) === 'visible') wakeIfDisconnected();
    };
    const onPageShow = (event)=>{
        // pageshow also fires on ordinary loads; only `persisted` is bfcache.
        if (event.persisted) reconnect();
    };
    const onResume = ()=>{
        reconnect();
    };
    window.addEventListener('online', wakeIfDisconnected);
    window.addEventListener('pageshow', onPageShow);
    doc === null || doc === void 0 || doc.addEventListener('visibilitychange', onVisibilityChange);
    // Chrome tab freeze; no pageshow.
    doc === null || doc === void 0 || doc.addEventListener('resume', onResume);
    return ()=>{
        window.removeEventListener('online', wakeIfDisconnected);
        window.removeEventListener('pageshow', onPageShow);
        doc === null || doc === void 0 || doc.removeEventListener('visibilitychange', onVisibilityChange);
        doc === null || doc === void 0 || doc.removeEventListener('resume', onResume);
    };
};

});


parcelRegister("5shBR", function(module, exports) {
$parcel$export(module.exports, "createSocketListeners", () => $eb8931d7d6c3b19e$export$e9b0d6f3238eb01d);

var $3prvb = parcelRequire("3prvb");
// Browser close is a CloseEvent; Client.terminate() emits a close-like object, which from
// graphql-ws 5.16 is an Error.
const $eb8931d7d6c3b19e$var$readCloseInfo = (event)=>{
    if (typeof event !== 'object' || event === null) return {
        closeCode: null,
        reason: null,
        wasClean: null
    };
    const code = 'code' in event ? event.code : undefined;
    const reason = 'reason' in event ? event.reason : undefined;
    const wasClean = 'wasClean' in event ? event.wasClean : undefined;
    return {
        closeCode: typeof code === 'number' ? code : null,
        reason: typeof reason === 'string' ? reason : null,
        wasClean: typeof wasClean === 'boolean' ? wasClean : null
    };
};
const $eb8931d7d6c3b19e$export$e9b0d6f3238eb01d = ({ onConnectionEvent: onConnectionEvent, pongWaitTimeout: pongWaitTimeout, terminate: terminate })=>{
    let attempt = 0;
    let connectionCount = 0;
    let connectedAt = null;
    let pongDeadline;
    const report = (event)=>{
        if (!onConnectionEvent) return;
        try {
            onConnectionEvent(event);
        } catch  {
        // Avoid breaking the transport if reporting throws.
        }
    };
    const clearPongDeadline = ()=>{
        clearTimeout(pongDeadline);
        pongDeadline = undefined;
    };
    return {
        isConnected: ()=>connectedAt !== null,
        listeners: {
            connecting: ()=>{
                attempt += 1;
                report({
                    type: 'connecting',
                    attempt: attempt
                });
            },
            opened: ()=>{
                report({
                    type: 'opened',
                    attempt: attempt
                });
            },
            connected: ()=>{
                connectionCount += 1;
                connectedAt = Date.now();
                report({
                    type: 'connected',
                    attempt: attempt,
                    connectionCount: connectionCount
                });
                attempt = 0;
            },
            closed: (event)=>{
                // Drop the deadline so it cannot kill a reconnecting socket.
                clearPongDeadline();
                report({
                    type: 'closed',
                    ...$eb8931d7d6c3b19e$var$readCloseInfo(event),
                    connectedForMs: connectedAt === null ? null : Date.now() - connectedAt
                });
                connectedAt = null;
            },
            // Only our outbound ping arms the deadline; only an inbound pong clears it.
            ping: (received)=>{
                if (received || pongWaitTimeout <= 0) return;
                clearPongDeadline();
                pongDeadline = setTimeout(terminate, pongWaitTimeout);
            },
            pong: (received)=>{
                if (received) clearPongDeadline();
            },
            error: (error)=>{
                report({
                    type: 'error',
                    message: error instanceof Error ? error.message : null,
                    kind: (0, $3prvb.getSinkError)(error).kind
                });
            }
        }
    };
};

});
parcelRegister("3prvb", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $e6f543f56b8b98a2$export$ece4736473c28965);

var $dRkX9 = parcelRequire("dRkX9");
/** `Array.isArray` alone narrows a `readonly` array to `any[]`, losing the element type. */ const $e6f543f56b8b98a2$var$isGraphQLErrorArray = (error)=>Array.isArray(error);
/**
 * Events are duck-typed rather than matched with `instanceof`: `Event`, `CloseEvent` and
 * `ErrorEvent` are not globals in every environment the client runs in, and `instanceof`
 * throws outright when its right-hand side is undefined.
 */ const $e6f543f56b8b98a2$var$isEventLike = (error)=>typeof error === 'object' && error !== null && 'type' in error && typeof error.type === 'string';
const $e6f543f56b8b98a2$var$isCloseEvent = (error)=>$e6f543f56b8b98a2$var$isEventLike(error) && error.type === 'close';
const $e6f543f56b8b98a2$var$isErrorEvent = (error)=>$e6f543f56b8b98a2$var$isEventLike(error) && error.type === 'error';
// The numeric `code` keeps out Node-style errors, whose `code` is a string such as `ECONNRESET`.
const $e6f543f56b8b98a2$var$isCloseLike = (error)=>typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'number' && 'reason' in error && typeof error.reason === 'string';
/** Non-enumerable details on a shared Error instance (same object goes to every sink). */ const $e6f543f56b8b98a2$var$withDetails = (error, details)=>{
    for (const [key, value] of Object.entries(details))Object.defineProperty(error, key, {
        value: value,
        enumerable: false,
        configurable: true,
        writable: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return error;
};
/** Pre-gate sink shaping. */ const $e6f543f56b8b98a2$var$getLegacySinkError = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const closeEvent = error;
        errorInfo = new Error(`CloseEvent: ${closeEvent.reason}`);
        errorInfo.closeCode = closeEvent.code;
        errorInfo.wasClean = closeEvent.wasClean;
    } else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
const $e6f543f56b8b98a2$var$getStructuredSinkError = (error)=>{
    if ($e6f543f56b8b98a2$var$isGraphQLErrorArray(error)) {
        const [firstError] = error;
        // A real Error, not the raw payload element typed as one, so it carries a stack. AGG
        // sends these as JSON, so the element is a plain object however it is typed.
        const errorInfo = Object.assign(new Error(firstError === null || firstError === void 0 ? void 0 : firstError.message), {
            kind: 'graphql-errors',
            graphQLErrors: error
        });
        if (firstError !== null && firstError !== void 0 && firstError.stack) errorInfo.stack = firstError.stack;
        return errorInfo;
    }
    if (error instanceof Error) // Its own `wasClean`, where it has one, is left as it is rather than redefined.
    return $e6f543f56b8b98a2$var$withDetails(error, $e6f543f56b8b98a2$var$isCloseLike(error) ? {
        kind: 'close-event',
        closeCode: error.code
    } : {
        kind: 'error'
    });
    if ($e6f543f56b8b98a2$var$isCloseEvent(error)) return Object.assign(new Error(`CloseEvent: ${error.reason}`), {
        kind: 'close-event',
        closeCode: error.code,
        wasClean: error.wasClean
    });
    if ($e6f543f56b8b98a2$var$isErrorEvent(error)) return Object.assign(new Error(`ErrorEvent: "${error.error}"`), {
        kind: 'error-event'
    });
    if ($e6f543f56b8b98a2$var$isEventLike(error)) return Object.assign(new Error(`Event: ${error.type}`), {
        kind: 'event'
    });
    // `String` rather than interpolation, which throws for a symbol.
    const message = `Unknown sink error: ${String(error)}`;
    // A close with no `type`, such as "All Subscriptions Gone". The message stays as it was,
    // because consumers match on it.
    if ($e6f543f56b8b98a2$var$isCloseLike(error)) return Object.assign(new Error(message), {
        kind: 'close-event',
        closeCode: error.code,
        ...'wasClean' in error && typeof error.wasClean === 'boolean' ? {
            wasClean: error.wasClean
        } : {}
    });
    return Object.assign(new Error(message), {
        kind: 'unknown'
    });
};
const $e6f543f56b8b98a2$export$ece4736473c28965 = (error)=>{
    if ((0, $dRkX9.fg)('platform_relay_subscription_sink_error')) return $e6f543f56b8b98a2$var$getStructuredSinkError(error);
    // Gate off: legacy shape (no `kind`).
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $e6f543f56b8b98a2$var$getLegacySinkError(error);
};

});



parcelRegister("brUL9", function(module, exports) {
$parcel$export(module.exports, "default", () => $df6531fe5bd89f17$export$2e2bcd8739ae039);
function $df6531fe5bd89f17$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("ddWwf", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $6d71969a549921d6$export$e7aa7bc5c1b3cfb3);

var $25okM = parcelRequire("25okM");

var $5KQKg = parcelRequire("5KQKg");

var $dRkX9 = parcelRequire("dRkX9");

var $8LEVO = parcelRequire("8LEVO");

var $ggYjM = parcelRequire("ggYjM");

var $hCTjc = parcelRequire("hCTjc");

var $8mmdq = parcelRequire("8mmdq");

var $hs92v = parcelRequire("hs92v");

var $2xrpV = parcelRequire("2xrpV");

var $hRu4I = parcelRequire("hRu4I");

var $el7Cq = parcelRequire("el7Cq");

var $joPsb = parcelRequire("joPsb");

var $gkhm7 = parcelRequire("gkhm7");

var $bePc1 = parcelRequire("bePc1");

var $7NlI6 = parcelRequire("7NlI6");

var $8ZUT6 = parcelRequire("8ZUT6");

var $kujxi = parcelRequire("kujxi");
const $6d71969a549921d6$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $6d71969a549921d6$var$moduleID = 'relay-fetch';
const $6d71969a549921d6$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    var _dependencies$didPref, _dependencies$getLogg, _cacheConfig$metadata;
    if ((dependencies === null || dependencies === void 0 || (_dependencies$didPref = dependencies.didPreflightAuthenticationCheckTriggerRedirect) === null || _dependencies$didPref === void 0 ? void 0 : _dependencies$didPref.call(dependencies, request, variables, cacheConfig)) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
    // while the redirect takes over instead of starting a fetch with a stale auth state.
    return (0, $5KQKg.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies === null || dependencies === void 0 || (_dependencies$getLogg = dependencies.getLoggingAndMetricsHelper) === null || _dependencies$getLogg === void 0 ? void 0 : _dependencies$getLogg.call(dependencies, loggingMetadata);
    // Per-query opt-in (cacheConfig.metadata.captureErrors) to forward this operation's response to
    // the product's capture callback, if one is provided. Whether to actually capture (feature gates,
    // etc.) is a product concern owned by the callback itself, not by this platform code.
    const shouldCaptureErrors = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.captureErrors) === true && !(dependencies !== null && dependencies !== void 0 && dependencies.isServer);
    let responseHeaders;
    // A payload already chose this operation's trace id. A later transport error must not append
    // the header id as well.
    let responseTraceIdCaptured = false;
    function responseHeaderTraceId() {
        var _responseHeaders;
        return ((_responseHeaders = responseHeaders) === null || _responseHeaders === void 0 ? void 0 : _responseHeaders.get('atl-traceid')) ?? undefined;
    }
    function augmentResponse(response) {
        const traceIdFromHeader = responseHeaderTraceId();
        (0, $8mmdq.addTraceId)(queryName, (0, $kujxi.getTraceIdFromExtensions)(response) ?? traceIdFromHeader, variables);
        (0, $8LEVO.putExtensions)(queryName, response.extensions);
        responseTraceIdCaptured = true;
    }
    function recordAvailableHeaderTraceId() {
        if (responseTraceIdCaptured) return;
        const traceId = responseHeaderTraceId();
        if (traceId === undefined) return;
        responseTraceIdCaptured = true;
        (0, $8mmdq.addTraceId)(queryName, traceId, variables);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $5KQKg.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$6d71969a549921d6$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                var _dependencies$earlySc;
                const endpoint = (0, $ggYjM.getAggEndpoint)(request, cacheConfig);
                const body = (0, $ggYjM.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies !== null && dependencies !== void 0 && dependencies.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies !== null && dependencies !== void 0 && dependencies.getAbortSignal) options.signal = dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal();
                const fetchOverNetwork = (0, $joPsb.buildGraphqlSmartFetch)({
                    url: dependencies !== null && dependencies !== void 0 && dependencies.setEndpoint ? dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies === null || dependencies === void 0 || (_dependencies$earlySc = dependencies.earlyScriptPromise) === null || _dependencies$earlySc === void 0 ? void 0 : _dependencies$earlySc.call(dependencies, request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies !== null && dependencies !== void 0 && dependencies.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                } else if ((0, $dRkX9.fg)('relay_environment_-_add_status-code_to_agg_errors')) {
                    // Preserve existing custom handlers and their retry semantics (e.g. Jira).
                    const checkResponse = (response)=>{
                        const details = (0, $hRu4I.getHttpErrorDetails)(response);
                        if (details) throw new (0, $el7Cq.RelayHttpError)(details);
                        return response;
                    };
                    fetchFn = ()=>fetchOverNetwork().then(checkResponse);
                    initialSource = ()=>!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && earlyScriptPromise ? earlyScriptPromise.then(checkResponse) : fetchFn();
                }
                const responses = (0, $gkhm7.processMultipartPromise)(()=>(0, $7NlI6.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $8ZUT6.shouldRetry),
                        retryAttempts: (0, $bePc1.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logErrorRetry
                    }), dependencies === null || dependencies === void 0 ? void 0 : dependencies.onFetchError, (headers)=>{
                    responseHeaders = headers;
                });
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $6d71969a549921d6$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $hCTjc.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $hCTjc.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $hCTjc.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $6d71969a549921d6$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $2xrpV.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (shouldCaptureErrors && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.captureResponseErrors) === 'function') dependencies.captureResponseErrors(request, singularResponse);
                            if (dependencies !== null && dependencies !== void 0 && dependencies.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                var _dependencies$onInval;
                                dependencies === null || dependencies === void 0 || (_dependencies$onInval = dependencies.onInvalidResponse) === null || _dependencies$onInval === void 0 || _dependencies$onInval.call(dependencies, request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && requestID != null && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.queryResponseCache) !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $6d71969a549921d6$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        recordAvailableHeaderTraceId();
                        loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && requestID != null) {
                var _dependencies$queryRe;
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies === null || dependencies === void 0 || (_dependencies$queryRe = dependencies.queryResponseCache) === null || _dependencies$queryRe === void 0 ? void 0 : _dependencies$queryRe.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($25okM)))(ssrCache)) {
                    var _dependencies$queryRe2;
                    // The cached payload is seeded into Relay below without passing through
                    // validateResponse, so capture its errors here instead.
                    if (shouldCaptureErrors && !Array.isArray(ssrCache) && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.captureResponseErrors) === 'function') dependencies.captureResponseErrors(request, ssrCache);
                    dependencies === null || dependencies === void 0 || (_dependencies$queryRe2 = dependencies.queryResponseCache) === null || _dependencies$queryRe2 === void 0 || _dependencies$queryRe2.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($6d71969a549921d6$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $hs92v.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $hs92v.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                var _dependencies$handleA;
                                dependencies === null || dependencies === void 0 || (_dependencies$handleA = dependencies.handleAbort) === null || _dependencies$handleA === void 0 || _dependencies$handleA.call(dependencies, request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            recordAvailableHeaderTraceId();
            loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("25okM", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $184eeca5a2b17dd7$var$isNil(value) {
    return value == null;
}
module.exports = $184eeca5a2b17dd7$var$isNil;

});

parcelRegister("8LEVO", function(module, exports) {
$parcel$export(module.exports, "putExtensions", () => $f8f139027649400d$export$17dc47fdf278de21);
const $f8f139027649400d$var$OperationExtensionsMap = {};
const $f8f139027649400d$export$8656ba3981c6f6c1 = (operationName)=>{
    $f8f139027649400d$var$OperationExtensionsMap[operationName] = $f8f139027649400d$var$OperationExtensionsMap[operationName] || [];
};
const $f8f139027649400d$export$f16fa6040161f056 = (operationName)=>{
    $f8f139027649400d$var$OperationExtensionsMap[operationName] = undefined;
};
const $f8f139027649400d$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $f8f139027649400d$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $f8f139027649400d$export$7c6ea4184129ef74 = (operationName)=>$f8f139027649400d$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("ggYjM", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $7f044a8615285583$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $7f044a8615285583$export$55bce18df99af758);

var $3jCFs = parcelRequire("3jCFs");
const $7f044a8615285583$var$branchSlug = typeof $3jCFs !== 'undefined' && $3jCFs.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $7f044a8615285583$var$serviceOverrides = typeof $3jCFs !== 'undefined' && $3jCFs.env ? undefined : undefined;
const $7f044a8615285583$export$8f8c52ac77845a86 = `/gateway/api/graphql${$7f044a8615285583$var$branchSlug ? `/${$7f044a8615285583$var$branchSlug}/graphql` : ''}`;
const $7f044a8615285583$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    var _cacheConfig$metadata;
    let endpoint = $7f044a8615285583$export$8f8c52ac77845a86;
    if ((_cacheConfig$metadata = cacheConfig.metadata) !== null && _cacheConfig$metadata !== void 0 && _cacheConfig$metadata.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($7f044a8615285583$var$serviceOverrides) url = `${url}&serviceOverride=${$7f044a8615285583$var$serviceOverrides}`;
    return url;
};
const $7f044a8615285583$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("hCTjc", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $f23cdae5e228e881$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $f23cdae5e228e881$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $f23cdae5e228e881$export$607b80f5bc6e396d = new Map();
const $f23cdae5e228e881$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("8mmdq", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIds", () => $06730f436fc1aa1a$export$a2bcb2fac360646c);
$parcel$export(module.exports, "addTraceId", () => $06730f436fc1aa1a$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $06730f436fc1aa1a$export$5113e470f5c95670);

var $dqdqr = parcelRequire("dqdqr");
const $06730f436fc1aa1a$export$a2bcb2fac360646c = (operationName)=>{
    (0, $dqdqr.startCapturingTraceIdsForOperation)(operationName);
};
const $06730f436fc1aa1a$export$559128bdc4352001 = (operationName)=>{
    (0, $dqdqr.stopCapturingTraceIdsForOperation)(operationName);
};
const $06730f436fc1aa1a$export$fcaa732775f12226 = (operationName, traceId, variables)=>{
    (0, $dqdqr.recordTraceId)(operationName, traceId, variables);
};
const $06730f436fc1aa1a$export$5113e470f5c95670 = (operationName)=>(0, $dqdqr.getCapturedTraceIds)(operationName);

});
parcelRegister("dqdqr", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIdsForOperation", () => $196b149b1a7c29fd$export$8b184389fd4ed20b);
$parcel$export(module.exports, "stopCapturingTraceIdsForOperation", () => $196b149b1a7c29fd$export$eb9d7fc8b95c0dfe);
$parcel$export(module.exports, "recordTraceId", () => $196b149b1a7c29fd$export$87165385048cf7ff);
$parcel$export(module.exports, "getCapturedTraceIds", () => $196b149b1a7c29fd$export$af2228e00c126daa);
// Internal trace-id capture state, shared by the public entry points of this package.
//
// This file intentionally is NOT named `index.ts` so that adding new exports here does not
// expand the package's public barrel file (see the "No expanding existing src/index barrel
// files" ratcheting rule). Public surface area is exposed explicitly via subpath exports in
// package.json (`.` and `./start-capturing-trace-ids-by-predicate`).
const $196b149b1a7c29fd$var$OperationTraceIdMap = {};
const $196b149b1a7c29fd$var$predicateCaptures = new Set();
const $196b149b1a7c29fd$export$8b184389fd4ed20b = (operationName)=>{
    $196b149b1a7c29fd$var$OperationTraceIdMap[operationName] = $196b149b1a7c29fd$var$OperationTraceIdMap[operationName] || [];
};
const $196b149b1a7c29fd$export$6ce1cd976801b213 = (predicate)=>{
    const capture = {
        predicate: predicate,
        traces: []
    };
    $196b149b1a7c29fd$var$predicateCaptures.add(capture);
    return {
        getTraces: ()=>capture.traces.slice(),
        dispose: ()=>{
            $196b149b1a7c29fd$var$predicateCaptures.delete(capture);
        }
    };
};
const $196b149b1a7c29fd$export$eb9d7fc8b95c0dfe = (operationName)=>{
    $196b149b1a7c29fd$var$OperationTraceIdMap[operationName] = undefined;
};
const $196b149b1a7c29fd$export$87165385048cf7ff = (operationName, traceId, variables)=>{
    var _OperationTraceIdMap$;
    if (traceId === undefined) return;
    (_OperationTraceIdMap$ = $196b149b1a7c29fd$var$OperationTraceIdMap[operationName]) === null || _OperationTraceIdMap$ === void 0 || _OperationTraceIdMap$.push(traceId);
    if ($196b149b1a7c29fd$var$predicateCaptures.size === 0) return;
    const context = {
        operationName: operationName,
        variables: variables ?? {}
    };
    for (const capture of [
        ...$196b149b1a7c29fd$var$predicateCaptures
    ])if (capture.predicate(context)) capture.traces.push(traceId);
};
const $196b149b1a7c29fd$export$af2228e00c126daa = (operationName)=>$196b149b1a7c29fd$var$OperationTraceIdMap[operationName] || [];

});


parcelRegister("hs92v", function(module, exports) {
$parcel$export(module.exports, "getClientDispatcher", () => $34f3b79145855099$export$5bb012cf9b3a5452);

var $lyGPk = parcelRequire("lyGPk");
const $34f3b79145855099$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $34f3b79145855099$var$dispatcher;
const $34f3b79145855099$export$5bb012cf9b3a5452 = ()=>{
    if (!$34f3b79145855099$var$dispatcher) {
        $34f3b79145855099$var$dispatcher = new (0, $lyGPk.ClientDispatcher)();
        // Handle the server hangup scenarios
        $34f3b79145855099$var$dispatcher.register($34f3b79145855099$export$eb5d9c90d65c7fea, $34f3b79145855099$var$dispatcher._abort.bind($34f3b79145855099$var$dispatcher));
    }
    return $34f3b79145855099$var$dispatcher;
};

});
parcelRegister("lyGPk", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $86869de8d346ebb9$export$3f5ba18eb97af725);
class $86869de8d346ebb9$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("2xrpV", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $9620af3c9bf8ab6c$export$bd50bc4cd3c601ee);
const $9620af3c9bf8ab6c$var$events = [];
const $9620af3c9bf8ab6c$export$bd50bc4cd3c601ee = (event)=>{
    $9620af3c9bf8ab6c$var$events.push(event);
};
const $9620af3c9bf8ab6c$export$3c7145db84d4587c = ()=>{
    return $9620af3c9bf8ab6c$var$events.splice(0, $9620af3c9bf8ab6c$var$events.length);
};

});

parcelRegister("hRu4I", function(module, exports) {
$parcel$export(module.exports, "getHttpErrorDetails", () => $f8ad8fb6ee164c6b$export$1862c452948bb411);
function $f8ad8fb6ee164c6b$export$1862c452948bb411(response) {
    if (response.ok) return undefined;
    // Match Jira's first-present-header precedence, including an empty atl-traceid.
    const header = [
        'atl-traceid',
        'x-trace-id'
    ].find((name)=>response.headers.has(name));
    return {
        statusCode: response.status,
        message: `Error server response: ${response.status}`,
        traceId: header === undefined ? undefined : response.headers.get(header) || undefined,
        originalResponse: response
    };
}

});

parcelRegister("el7Cq", function(module, exports) {
$parcel$export(module.exports, "RelayHttpError", () => $e628a462f8a58676$export$8489bdbad141de6d);
class $e628a462f8a58676$export$8489bdbad141de6d extends Error {
    constructor({ statusCode: statusCode, message: message, traceId: traceId, originalResponse: originalResponse }){
        super(message);
        this.name = 'RelayHttpError';
        this.statusCode = statusCode;
        this.traceId = traceId;
        this.originalResponse = originalResponse;
    }
}

});

parcelRegister("joPsb", function(module, exports) {
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $e68a7d12de1a115d$export$33c9c992c7855d86);

var $eVfhL = parcelRequire("eVfhL");

var $fOrLF = parcelRequire("fOrLF");

var $2xkDj = parcelRequire("2xkDj");

var $9eaSi = parcelRequire("9eaSi");
const $e68a7d12de1a115d$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $e68a7d12de1a115d$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    var _cacheConfig$metadata;
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $e68a7d12de1a115d$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $fOrLF.getRelayExperimentalApis)().join(','),
        ...(cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.headers) || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = (0, $9eaSi.shouldUseGetMethod)({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = (0, $2xkDj.buildGetUrl)(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("2xkDj", function(module, exports) {
$parcel$export(module.exports, "buildGetUrl", () => $1e87114815af6fec$export$28ae0033b80c6303);
function $1e87114815af6fec$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}

});

parcelRegister("9eaSi", function(module, exports) {
$parcel$export(module.exports, "shouldUseGetMethod", () => $ce29d667d8c4e68c$export$5ad31d96a9271d42);

var $9gj8n = parcelRequire("9gj8n");

var $2xkDj = parcelRequire("2xkDj");

var $3PDok = parcelRequire("3PDok");
const $ce29d667d8c4e68c$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $ce29d667d8c4e68c$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
function $ce29d667d8c4e68c$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $9gj8n.killswitch)('relay-get-queries')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = (0, $2xkDj.buildGetUrl)(baseUrl, variables).length;
    const headersSize = (0, $3PDok.calculateHeadersSize)(headers || {});
    return queryLength <= $ce29d667d8c4e68c$var$MAX_QUERY_LENGTH && headersSize <= $ce29d667d8c4e68c$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}

});
parcelRegister("9gj8n", function(module, exports) {
$parcel$export(module.exports, "killswitch", () => $eee3d75412649e0f$export$fcfcaa5d2f57d3a7);

var $k2M4v = parcelRequire("k2M4v");
let $eee3d75412649e0f$var$cachedNames;
const $eee3d75412649e0f$var$isStringArray = (value)=>Array.isArray(value) && value.every((name)=>typeof name === 'string');
function $eee3d75412649e0f$export$fcfcaa5d2f57d3a7(name) {
    if (!$eee3d75412649e0f$var$cachedNames) {
        // Do not permanently cache the default before the host initializes the SDK.
        if (!(0, $k2M4v.default).initializeCompleted()) return false;
        // Killswitches are operational controls and must not fire experiment exposures.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- shared dynamic config killswitch helper
        const config = (0, $k2M4v.default).getExperimentValue('killswitch', 'value', [], {
            fireExperimentExposure: false,
            typeGuard: $eee3d75412649e0f$var$isStringArray
        });
        // SDK mocks and config overrides can bypass the SDK's type guard.
        $eee3d75412649e0f$var$cachedNames = new Set($eee3d75412649e0f$var$isStringArray(config) ? config.map((entry)=>entry.toLowerCase()) : []);
    }
    return $eee3d75412649e0f$var$cachedNames.has(name.toLowerCase());
}

});

parcelRegister("3PDok", function(module, exports) {
$parcel$export(module.exports, "calculateHeadersSize", () => $11af6ba5a5d9de30$export$dd754c3ef60c6999);
// Calculate the size of the headers
function $11af6ba5a5d9de30$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}

});



parcelRegister("gkhm7", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $da0cbbf5f2c91078$export$f76505a7f2969e4e);

var $5KQKg = parcelRequire("5KQKg");

var $dRkX9 = parcelRequire("dRkX9");

var $8FRcm = parcelRequire("8FRcm");
const $da0cbbf5f2c91078$var$NO_CONTENT = 204;
function $da0cbbf5f2c91078$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $da0cbbf5f2c91078$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $da0cbbf5f2c91078$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $da0cbbf5f2c91078$var$getBoundary(contentType || '');
    if (!boundary) {
        $da0cbbf5f2c91078$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        (0, $8FRcm.processStream)(streamReader(), boundary, observer).catch((error)=>$da0cbbf5f2c91078$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $da0cbbf5f2c91078$var$emitError(observer, error, response, onFetchError);
    }
}
function $da0cbbf5f2c91078$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$da0cbbf5f2c91078$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $da0cbbf5f2c91078$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        var _response$headers;
        let traceId = '';
        if ((0, $dRkX9.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $da0cbbf5f2c91078$var$emitError(observer, error, response, onFetchError);
    });
}
function $da0cbbf5f2c91078$export$f76505a7f2969e4e(source, onFetchError, onResponseHeaders) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $5KQKg.Observable).create((observer)=>{
        result.then((response)=>{
            // Expose the response headers via a side-channel so the consumer can
            // read values such as `atl-traceid` without changing the payload emission shape.
            onResponseHeaders === null || onResponseHeaders === void 0 || onResponseHeaders(response.headers);
            if (response.status === $da0cbbf5f2c91078$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $da0cbbf5f2c91078$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $da0cbbf5f2c91078$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $da0cbbf5f2c91078$var$handleMultipartResponse(response, observer, onFetchError);
            else $da0cbbf5f2c91078$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$da0cbbf5f2c91078$var$emitError(observer, error, undefined, onFetchError));
    });
}

});
parcelRegister("8FRcm", function(module, exports) {
$parcel$export(module.exports, "processStream", () => $bf6b45cf48b03c38$export$efb69f1fe7577739);

var $hh0in = parcelRequire("hh0in");
async function $bf6b45cf48b03c38$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = (0, $hh0in.processChunk)(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) (0, $hh0in.processChunk)(incompleteChunk, boundaryString, observer);
    observer.complete();
}

});
parcelRegister("hh0in", function(module, exports) {
$parcel$export(module.exports, "processChunk", () => $906558c7fd22065c$export$701544522b0c6c99);

var $dRkX9 = parcelRequire("dRkX9");
function $906558c7fd22065c$var$escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
// The boundary is fixed for the lifetime of a response while processChunk runs once per network chunk,
// so the compiled delimiter pattern is kept for the last boundary seen instead of rebuilt per chunk.
let $906558c7fd22065c$var$cachedDelimiter;
function $906558c7fd22065c$var$getDelimiterPattern(boundaryString) {
    var _cachedDelimiter;
    if (((_cachedDelimiter = $906558c7fd22065c$var$cachedDelimiter) === null || _cachedDelimiter === void 0 ? void 0 : _cachedDelimiter.boundaryString) !== boundaryString) $906558c7fd22065c$var$cachedDelimiter = {
        boundaryString: boundaryString,
        pattern: new RegExp(`(?:^|\\r\\n)${$906558c7fd22065c$var$escapeRegExp(boundaryString)}`)
    };
    return $906558c7fd22065c$var$cachedDelimiter.pattern;
}
function $906558c7fd22065c$var$getBody(part) {
    // A part with a header block is "headers\r\n\r\nbody", so the split yields [headers, body] and the
    // payload is part2. A part without a header block yields a single element, part2 is undefined and
    // the whole part (part1) is the payload.
    const [part1, part2] = part.split(/\r?\n\r?\n/);
    return part2 ?? part1;
}
function $906558c7fd22065c$var$processChunkCrlfAnchored(chunk, boundaryString, observer) {
    // RFC 2046 5.1.1: a delimiter is CRLF followed by "--" and the boundary (the CRLF is optional only
    // for the first delimiter, at the very start of the body). Matching the bare "--boundary" would
    // also match the same characters inside a JSON payload (e.g. "---" in a document body), which
    // splits and corrupts the payload. JSON strings carry escaped newlines, so a CRLF-anchored
    // delimiter does not occur inside a payload.
    const parts = chunk.split($906558c7fd22065c$var$getDelimiterPattern(boundaryString));
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            const body = $906558c7fd22065c$var$getBody(part);
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    const lastPart = parts[parts.length - 1];
    // The trailing segment is only known to be complete once the next delimiter arrives, but a part
    // whose body already parses as JSON is complete: emit it now instead of holding it back until the
    // next part (or the end of the stream). Keep the trailing CRLF so the delimiter that follows is
    // still recognised.
    const trailingPart = lastPart.trim();
    if (trailingPart && !trailingPart.startsWith('--')) {
        const body = $906558c7fd22065c$var$getBody(trailingPart);
        if (body) try {
            var _lastPart$match;
            observer.next(JSON.parse(incompleteChunk + body));
            return ((_lastPart$match = lastPart.match(/\s*$/)) === null || _lastPart$match === void 0 ? void 0 : _lastPart$match[0]) ?? '';
        } catch  {
        // Body is still incomplete; keep it until more data arrives.
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + lastPart;
}
/**
 * The previous implementation, used while `ai_3p_defer_multipart_response_fix` is off.
 *
 * It splits on the bare boundary string, so a payload containing it is cut apart, and a part is only
 * emitted once the next delimiter has arrived.
 */ function $906558c7fd22065c$var$processChunkLegacy(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
function $906558c7fd22065c$export$701544522b0c6c99(chunk, boundaryString, observer) {
    if ((0, $dRkX9.fg)('ai_3p_defer_multipart_response_fix')) return $906558c7fd22065c$var$processChunkCrlfAnchored(chunk, boundaryString, observer);
    return $906558c7fd22065c$var$processChunkLegacy(chunk, boundaryString, observer);
}

});



parcelRegister("bePc1", function(module, exports) {
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $bff58c6c5090e340$export$9dec0f42cc67f6ab);

var $crD4o = parcelRequire("crD4o");
const $bff58c6c5090e340$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return 0, $crD4o.RETRY_ATTEMPTS_LIMIT;
    return 0;
};

});
parcelRegister("crD4o", function(module, exports) {
$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $9cbcaf98efdc06e0$export$81189edc9b923717);
const $9cbcaf98efdc06e0$export$81189edc9b923717 = 1;

});


parcelRegister("7NlI6", function(module, exports) {
$parcel$export(module.exports, "retryOnError", () => $71cab0886150e131$export$f859c88bfac2cf2c);

var $crD4o = parcelRequire("crD4o");
const $71cab0886150e131$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = (0, $crD4o.RETRY_ATTEMPTS_LIMIT), onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > (0, $crD4o.RETRY_ATTEMPTS_LIMIT) ? (0, $crD4o.RETRY_ATTEMPTS_LIMIT) : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("8ZUT6", function(module, exports) {
$parcel$export(module.exports, "shouldRetry", () => $93bf90608e29bbb4$export$7bfea3c3d460ecd8);

var $dRkX9 = parcelRequire("dRkX9");
const $93bf90608e29bbb4$export$7bfea3c3d460ecd8 = (error)=>{
    if ((0, $dRkX9.fg)('platform_relay_fetch_guard_non_object_retry_errors')) {
        if (typeof error !== 'object' || error === null) return false;
    }
    const fetchError = error;
    if ('statusCode' in fetchError && typeof fetchError.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(fetchError.statusCode);
    return false;
};

});

parcelRegister("kujxi", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $779a708341cf59cf$export$eefb7f54c3b07211);

var $dRkX9 = parcelRequire("dRkX9");
const $779a708341cf59cf$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions == null || extensions.gateway == null) return undefined;
    if ((0, $dRkX9.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

});


parcelRegister("1znWW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7599b745914a1914$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $jd1EL = parcelRequire("jd1EL");

var $1uX2A = parcelRequire("1uX2A");

var $brUL9 = parcelRequire("brUL9");
const $7599b745914a1914$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $7599b745914a1914$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $7599b745914a1914$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $jd1EL.JiraFilterAri).parse(id).filterId;
            if ($7599b745914a1914$var$isCustomFilter(filterId)) return (0, $brUL9.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($7599b745914a1914$var$isSystemFilter(filterId)) return (0, $brUL9.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $7599b745914a1914$var$JiraQueryIssueByIdMissingFieldHandler = {
    handle: (field, record, argValues)=>{
        if ((0, $dRkX9.fg)('platform_relay_issue_by_id_cache')) {
            if ((record === null || record === void 0 ? void 0 : record.getType()) === 'JiraQuery' && field.name === 'issueById' && argValues.id != null) return (0, $brUL9.default)({
                id: argValues.id
            }, 'JiraIssue');
        }
        return undefined;
    },
    kind: 'linked'
};
const $7599b745914a1914$var$JiraIssueNodeMissingFieldHandler = {
    handle: (field, record, argValues, store)=>{
        if ((0, $dRkX9.fg)('platform_relay_issue_by_id_cache')) {
            var _store$get;
            if ((record === null || record === void 0 ? void 0 : record.getDataID()) !== store.getRoot().getDataID() || field.name !== 'node' || typeof argValues.id !== 'string') return undefined;
            try {
                (0, $1uX2A.JiraIssueAri).parse(argValues.id);
            } catch  {
                return undefined;
            }
            const dataId = (0, $brUL9.default)({
                id: argValues.id
            }, 'JiraIssue');
            if (dataId !== undefined && ((_store$get = store.get(dataId)) === null || _store$get === void 0 ? void 0 : _store$get.getType()) === 'JiraIssue') return dataId;
        }
        return undefined;
    },
    kind: 'linked'
};
const $7599b745914a1914$var$MissingFieldHandlers = [
    $7599b745914a1914$export$77232ec02db7a24a,
    $7599b745914a1914$var$JiraQueryIssueByIdMissingFieldHandler,
    $7599b745914a1914$var$JiraIssueNodeMissingFieldHandler
];
var $7599b745914a1914$export$2e2bcd8739ae039 = $7599b745914a1914$var$MissingFieldHandlers;

});
parcelRegister("jd1EL", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $dfc084238e772f99$export$3cfb6cc809e835bd);

var $38je9 = parcelRequire("38je9");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/jira/filter/manifest.ts
var $dfc084238e772f99$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $38je9.JiraFilterAriResourceOwner),
    resourceType: (0, $38je9.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $dfc084238e772f99$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $dfc084238e772f99$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $dfc084238e772f99$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $dfc084238e772f99$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $dfc084238e772f99$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $dfc084238e772f99$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $dfc084238e772f99$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("38je9", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $2481089b84a12c9e$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $2481089b84a12c9e$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $2481089b84a12c9e$export$e6199848f52f1119 = "jira", $2481089b84a12c9e$export$3c64de4ae038e3ae = "filter";

});


parcelRegister("1uX2A", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAri", () => $1176640bd00483d6$export$1da6808e89ee03e);

var $ers5k = parcelRequire("ers5k");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/jira/issue/manifest.ts
var $1176640bd00483d6$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ers5k.JiraIssueAriResourceOwner),
    resourceType: (0, $ers5k.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $1176640bd00483d6$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1176640bd00483d6$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $1176640bd00483d6$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1176640bd00483d6$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $1176640bd00483d6$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $1176640bd00483d6$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $1176640bd00483d6$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("ers5k", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $a8395f5e15dc2211$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $a8395f5e15dc2211$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $a8395f5e15dc2211$export$665a39f1b4e29e0a = "jira", $a8395f5e15dc2211$export$76beb4d0da177ad4 = "issue";

});



parcelRegister("1WbgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fdb221f05340cb4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7fdb221f05340cb4$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($bTkYf))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $bTkYf.version) === 'undefined' || (0, $bTkYf.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($bTkYf))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).startTransition === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});

parcelRegister("6NkX9", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $033b1df16776ff4d$export$10f5a0700f263f11);

var $5KQKg = parcelRequire("5KQKg");

var $dRkX9 = parcelRequire("dRkX9");

var $3iyua = parcelRequire("3iyua");

var $1i4zH = parcelRequire("1i4zH");

var $3prvb = parcelRequire("3prvb");
const $033b1df16776ff4d$var$channels = new Map();
const $033b1df16776ff4d$var$channelsByClient = new WeakMap();
/** Select connection state; all observers then run the same subscription implementation. */ function $033b1df16776ff4d$var$createSubscriptionObservable(cacheConfig, subscribe) {
    return (0, $5KQKg.Observable).create((sink)=>{
        var _cacheConfig$metadata;
        const context = cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.subscriptionShardingContext;
        if (context === undefined) return subscribe(sink, (0, $1i4zH.getClient)(), $033b1df16776ff4d$var$channels, (0, $1i4zH.getSocketConnectionState));
        const lease = (0, $1i4zH.acquireSubscriptionClient)(()=>(0, $3iyua.getSubscriptionUrl)(context));
        if (!lease) return subscribe(sink, null, $033b1df16776ff4d$var$channels, (0, $1i4zH.getSocketConnectionState));
        try {
            let clientChannels = $033b1df16776ff4d$var$channelsByClient.get(lease.client);
            if (!clientChannels) {
                clientChannels = new Map();
                $033b1df16776ff4d$var$channelsByClient.set(lease.client, clientChannels);
            }
            const cleanup = subscribe(sink, lease.client, clientChannels, lease.getSocketConnectionState);
            return ()=>{
                try {
                    cleanup === null || cleanup === void 0 || cleanup();
                } finally{
                    lease.release();
                }
            };
        } catch (error) {
            lease.release();
            throw error;
        }
    });
}
function $033b1df16776ff4d$var$stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null';
    if (Array.isArray(value)) return `[${value.map($033b1df16776ff4d$var$stableStringify).join(',')}]`;
    const obj = value;
    const keys = Object.keys(obj).sort();
    return `{${keys.map((k)=>`${JSON.stringify(k)}:${$033b1df16776ff4d$var$stableStringify(obj[k])}`).join(',')}}`;
}
function $033b1df16776ff4d$var$channelKey(payload) {
    var _payload$extensions;
    return $033b1df16776ff4d$var$stableStringify({
        pq: ((_payload$extensions = payload.extensions) === null || _payload$extensions === void 0 ? void 0 : _payload$extensions.pq) ?? null,
        operationName: payload.operationName ?? null,
        variables: payload.variables ?? null,
        extensions: payload.extensions ?? null
    });
}
let $033b1df16776ff4d$var$cachedDefaultSubscribe;
function $033b1df16776ff4d$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $033b1df16776ff4d$var$cachedDefaultSubscribe !== 'undefined') return $033b1df16776ff4d$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>$033b1df16776ff4d$var$createSubscriptionObservable(cacheConfig, (sink, client, channels, getConnectionState)=>{
            var _cacheConfig$metadata2, _subscribeOptions$onS;
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata2 = cacheConfig.metadata) === null || _cacheConfig$metadata2 === void 0 ? void 0 : _cacheConfig$metadata2.replay) || undefined;
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...(subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {},
                    ...replayExtensions
                }
            };
            subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions$onS === void 0 || _subscribeOptions$onS.call(subscribeOptions, payload);
            const key = $033b1df16776ff4d$var$channelKey(payload);
            // Keep one cleanup policy for the entire observer lifetime.
            const guardChannelOwnership = !(0, $dRkX9.fg)('relay_subscription_cleanup_killswitch');
            const existingChannel = channels.get(key);
            let joinedChannel = existingChannel;
            // Capture before failure; the channel may reopen first.
            const isNewChannel = !existingChannel;
            const observerCount = ((existingChannel === null || existingChannel === void 0 ? void 0 : existingChannel.sinks.size) ?? 0) + 1;
            // Reuse the product-level subscription reporter instead of a per-call metadata callback.
            const diagnosticsEnabled = (0, $dRkX9.fg)('platform_relay_subscription_reliability-additional');
            const diagnostics = diagnosticsEnabled && typeof (subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.onSubscriptionDiagnostic) === 'function' ? subscribeOptions.onSubscriptionDiagnostic : undefined;
            const report = (event)=>{
                try {
                    diagnostics === null || diagnostics === void 0 || diagnostics({
                        operationName: payload.operationName,
                        variables: payload.variables,
                        ...event
                    });
                } catch  {
                // Diagnostics must not interrupt subscriptions.
                }
            };
            if (diagnostics) report({
                type: 'attached',
                isNewChannel: isNewChannel,
                observerCount: observerCount,
                channelHasReceivedResponse: (existingChannel === null || existingChannel === void 0 ? void 0 : existingChannel.hasReceivedResponse) ?? false,
                socketState: getConnectionState()
            });
            const removeConnected = diagnostics ? client.on('connected', ()=>report({
                    type: 'connected'
                })) : undefined;
            const removeClosed = diagnostics ? client.on('closed', ()=>report({
                    type: 'closed'
                })) : undefined;
            const detachDiagnostics = ()=>{
                removeConnected === null || removeConnected === void 0 || removeConnected();
                removeClosed === null || removeClosed === void 0 || removeClosed();
            };
            const localSink = {
                next: (value)=>{
                    if (diagnostics) {
                        var _extensions$gateway, _extensions$gateway2, _extensions$gateway3, _extensions$agg;
                        const extensions = value === null || value === void 0 ? void 0 : value.extensions;
                        const requestId = extensions === null || extensions === void 0 || (_extensions$gateway = extensions.gateway) === null || _extensions$gateway === void 0 ? void 0 : _extensions$gateway.request_id;
                        const traceId = (extensions === null || extensions === void 0 || (_extensions$gateway2 = extensions.gateway) === null || _extensions$gateway2 === void 0 ? void 0 : _extensions$gateway2.tId) ?? (extensions === null || extensions === void 0 || (_extensions$gateway3 = extensions.gateway) === null || _extensions$gateway3 === void 0 ? void 0 : _extensions$gateway3.trace_id);
                        const channel = extensions === null || extensions === void 0 || (_extensions$agg = extensions.agg) === null || _extensions$agg === void 0 ? void 0 : _extensions$agg.channel;
                        report({
                            type: 'response',
                            requestId: typeof requestId === 'string' ? requestId : null,
                            traceId: typeof traceId === 'string' ? traceId : null,
                            channel: typeof channel === 'string' ? channel : null
                        });
                    }
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (err, requestId)=>{
                    var _subscribeOptions$onS2;
                    report({
                        type: 'error',
                        requestId: requestId
                    });
                    detachDiagnostics();
                    sink.error(err);
                    subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS2 = subscribeOptions.onSubscribeError) === null || _subscribeOptions$onS2 === void 0 || _subscribeOptions$onS2.call(subscribeOptions, {
                        ...payload,
                        requestId: requestId,
                        isNewChannel: isNewChannel,
                        observerCount: observerCount
                    });
                },
                complete: ()=>{
                    var _sink$complete;
                    report({
                        type: 'completed'
                    });
                    detachDiagnostics();
                    (_sink$complete = sink.complete) === null || _sink$complete === void 0 || _sink$complete.call(sink);
                }
            };
            if (!existingChannel) {
                const newChannel = {
                    sinks: new Set([
                        localSink
                    ]),
                    dispose: ()=>{},
                    lastRequestId: null,
                    hasReceivedResponse: false
                };
                joinedChannel = newChannel;
                let terminated = false;
                newChannel.dispose = client.subscribe(payload, {
                    next: (value)=>{
                        var _value$extensions;
                        if (diagnosticsEnabled) newChannel.hasReceivedResponse = true;
                        // @ts-expect-error agg prop is missing on generic "extensions" type
                        const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                        if (aggRequestId) newChannel.lastRequestId = aggRequestId;
                        for (const s of Array.from(newChannel.sinks))try {
                            s.next(value);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    error: (sinkError)=>{
                        terminated = true;
                        const errorInfo = (0, $3prvb.getSinkError)(sinkError);
                        const sinks = Array.from(newChannel.sinks);
                        const { lastRequestId: lastRequestId } = newChannel;
                        if (!guardChannelOwnership || channels.get(key) === newChannel) channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.error(errorInfo, lastRequestId);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    complete: ()=>{
                        terminated = true;
                        const sinks = Array.from(newChannel.sinks);
                        if (!guardChannelOwnership || channels.get(key) === newChannel) channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            var _s$complete;
                            (_s$complete = s.complete) === null || _s$complete === void 0 || _s$complete.call(s);
                        } catch  {
                        /* isolate sinks */ }
                    }
                });
                // A synchronous terminal callback may already have opened a replacement.
                // Register only a live channel, once its real disposer is available.
                if (!guardChannelOwnership || !terminated) channels.set(key, newChannel);
            } else existingChannel.sinks.add(localSink);
            return ()=>{
                report({
                    type: 'disposed'
                });
                detachDiagnostics();
                const c = guardChannelOwnership ? joinedChannel : channels.get(key);
                if (!c) return;
                const removed = c.sinks.delete(localSink);
                if (guardChannelOwnership && !removed) return;
                if (c.sinks.size === 0) {
                    if (!guardChannelOwnership || channels.get(key) === c) channels.delete(key);
                    try {
                        c.dispose();
                    } catch  {
                    /* upstream dispose errors must not break Relay teardown */ }
                }
            };
        });
    if (typeof subscribeOptions === 'undefined') $033b1df16776ff4d$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $033b1df16776ff4d$export$ec068583843480e7 = $033b1df16776ff4d$export$10f5a0700f263f11();

});
parcelRegister("3iyua", function(module, exports) {
$parcel$export(module.exports, "getSubscriptionUrl", () => $79a2e72b880fd69a$export$192ea60656b1a47f);

var $5AJaZ = parcelRequire("5AJaZ");
function $79a2e72b880fd69a$export$192ea60656b1a47f(context) {
    if (typeof context !== 'object' || context === null || !('type' in context) || context.type !== 'workspace' || !('product' in context) || typeof context.product !== 'string' || !('workspaceId' in context) || typeof context.workspaceId !== 'string') throw new Error('Invalid subscription sharding context');
    return `${(0, $5AJaZ.getAggSubscriptionEndpoint)()}/${$79a2e72b880fd69a$var$encodeContextSegment(context.product)}/workspace/${$79a2e72b880fd69a$var$encodeContextSegment(context.workspaceId)}`;
}
function $79a2e72b880fd69a$var$encodeContextSegment(value) {
    if (!value || value === '.' || value === '..') throw new Error('Invalid subscription sharding context segment');
    return encodeURIComponent(value);
}

});


parcelRegister("gJw8m", function(module, exports) {
$parcel$export(module.exports, "createRelayHandlerProvider", () => $696ade14134de18c$export$a40b5c8b00dd9369);

var $5KQKg = parcelRequire("5KQKg");

var $bepBF = parcelRequire("bepBF");

var $ccueE = parcelRequire("ccueE");
function $696ade14134de18c$export$a40b5c8b00dd9369(source) {
    const DeleteRecordHandler = (0, $ccueE.createDeleteRecordHandler)(source);
    return (handle)=>{
        switch(handle){
            case 'deleteEdge':
                return 0, $bepBF.DeleteEdgeHandler;
            case 'deleteRecord':
                return DeleteRecordHandler;
            default:
                return (0, $5KQKg.DefaultHandlerProvider)(handle);
        }
    };
}

});
parcelRegister("bepBF", function(module, exports) {
$parcel$export(module.exports, "DeleteEdgeHandler", () => $ab48041a3e2bfbe1$export$a2264b8f69028704);

var $5KQKg = parcelRequire("5KQKg");

var $DNksS = parcelRequire("DNksS");

var $16OhS = parcelRequire("16OhS");
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $ab48041a3e2bfbe1$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $5KQKg.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
const $ab48041a3e2bfbe1$export$a2264b8f69028704 = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $DNksS.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $16OhS.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $ab48041a3e2bfbe1$var$deleteNode(connection, id);
            }
        });
    }
};

});
parcelRegister("16OhS", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ced5bfd5f2b9a35$export$2e2bcd8739ae039);
var $0ced5bfd5f2b9a35$var$isProduction = true;
function $0ced5bfd5f2b9a35$var$warning(condition, message) {
    if (!$0ced5bfd5f2b9a35$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $0ced5bfd5f2b9a35$export$2e2bcd8739ae039 = $0ced5bfd5f2b9a35$var$warning;

});


parcelRegister("ccueE", function(module, exports) {
$parcel$export(module.exports, "createDeleteRecordHandler", () => $863ccba9cde2e227$export$a61ecd985ed07422);
const $863ccba9cde2e227$var$RELAY_DATA_ID_SEPARATOR = ':::::';
const $863ccba9cde2e227$export$a61ecd985ed07422 = (source)=>({
        update: (store, payload)=>{
            const record = store.get(payload.dataID);
            if (record == null) return;
            const idOrIds = record.getValue(payload.fieldKey);
            const aris = Array.isArray(idOrIds) ? idOrIds : [
                idOrIds
            ];
            const idsInStore = source.getRecordIDs();
            const arisToDelete = aris.flatMap((id)=>{
                if (typeof id !== 'string') return [];
                const typeQualifiedPrefix = `${id}${$863ccba9cde2e227$var$RELAY_DATA_ID_SEPARATOR}`;
                const matchingStoreIDs = idsInStore.filter((dataID)=>dataID.startsWith(typeQualifiedPrefix));
                return matchingStoreIDs;
            });
            arisToDelete.forEach((dataID)=>store.delete(dataID));
        }
    });

});


parcelRegister("aEwT0", function(module, exports) {
$parcel$export(module.exports, "ufoDataFetchHoldMiddleware", () => $08d9236c92e219db$export$3e78a79ab7bcbcc3);

var $5KQKg = parcelRequire("5KQKg");

var $bYcKg = parcelRequire("bYcKg");
const $08d9236c92e219db$var$HELD_INTERACTION_TYPES = [
    'press',
    'typing'
];
const $08d9236c92e219db$export$3e78a79ab7bcbcc3 = (next, options)=>(request, variables, cacheConfig, uploadables)=>{
        var _options$getIsEnabled;
        if ((options === null || options === void 0 || (_options$getIsEnabled = options.getIsEnabled) === null || _options$getIsEnabled === void 0 ? void 0 : _options$getIsEnabled.call(options)) !== true) return next(request, variables, cacheConfig, uploadables);
        const source = next(request, variables, cacheConfig, uploadables);
        if ('subscribe' in source) return (0, $5KQKg.Observable).create((sink)=>{
            const releaseHold = (0, $bYcKg.startDataFetchHold)({
                label: `relay-${request.operationKind}`,
                // `as const` to ignore `no-literal-string-in-object`
                name: request.name,
                interactionTypes: $08d9236c92e219db$var$HELD_INTERACTION_TYPES
            });
            const subscription = source.subscribe(sink);
            return ()=>{
                try {
                    subscription.unsubscribe();
                } finally{
                    releaseHold === null || releaseHold === void 0 || releaseHold();
                }
            };
        });
        return source;
    };

});
parcelRegister("bYcKg", function(module, exports) {
$parcel$export(module.exports, "startDataFetchHold", () => $baaf0829e4e385d4$export$fbd04cc8165928ea);

var $jQYQa = parcelRequire("jQYQa");

var $7M4Z9 = parcelRequire("7M4Z9");
function $baaf0829e4e385d4$export$fbd04cc8165928ea({ label: label, name: name, interactionTypes: interactionTypes }) {
    const interaction = (0, $jQYQa.getActiveInteraction)();
    if (!interaction || interaction.end !== 0) return;
    if (interactionTypes && !interactionTypes.includes(interaction.type)) return;
    const releaseHold = (0, $jQYQa.addHold)(interaction.id, [
        {
            name: label
        }
    ], name, false);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        (0, $7M4Z9.default)(()=>{
            releaseHold();
            (0, $jQYQa.tryComplete)(interaction.id);
        });
    };
}

});



parcelRegister("5WGzE", function(module, exports) {
$parcel$export(module.exports, "resolveGetDataID", () => $5240241a52014af8$export$e6629d3c6f1259a8);
$parcel$export(module.exports, "default", () => $5240241a52014af8$export$2e2bcd8739ae039);

var $hN5YJ = parcelRequire("hN5YJ");

var $5KQKg = parcelRequire("5KQKg");

var $7lN8e = parcelRequire("7lN8e");

var $brUL9 = parcelRequire("brUL9");

var $59Bzz = parcelRequire("59Bzz");

var $16Sbm = parcelRequire("16Sbm");

var $9cYDP = parcelRequire("9cYDP");

var $6fWu5 = parcelRequire("6fWu5");
const $5240241a52014af8$var$fetchRelay = (params, variables, cacheConfig, uploadables)=>{
    const fetcher = (0, $7lN8e.getIsPageServerSideRendered)() ? (0, $16Sbm.default) : (0, $59Bzz.default);
    return fetcher(params, variables, cacheConfig, uploadables);
};
const $5240241a52014af8$var$getNetWork = ()=>{
    if ((0, $6fWu5.isSSR)()) return (0, $5KQKg.Network).create($5240241a52014af8$var$fetchRelay);
    return (0, $5KQKg.Network).create($5240241a52014af8$var$fetchRelay, (0, $9cYDP.subscribe));
};
const $5240241a52014af8$export$215146372577871a = new Set([
    'HelpObjectStoreEntityData',
    'JiraServiceManagementRequestType',
    'HelpObjectStorePortalGroup',
    'HelpObjectStoreKbCategories',
    'HelpObjectStoreRequestForm',
    'HelpObjectStoreHelpObject',
    'HelpObjectStorePortalGroupRequestForm',
    'HelpCenterPageParentReference'
]);
const $5240241a52014af8$var$getHelpObjectStoreDataID = (fieldValue, typeName)=>{
    if ($5240241a52014af8$export$215146372577871a.has(typeName)) return (0, $brUL9.default)(fieldValue, typeName);
    // Mirror Relay's default id derivation for all other types. Copied the implementation from RelayDataID.
    const { id: id } = fieldValue;
    return id == null ? undefined : String(id);
};
const $5240241a52014af8$export$e6629d3c6f1259a8 = ()=>{
    if ((0, $hN5YJ.isFixRelayIdConflictForHelpObjectStoreEnabled)()) return $5240241a52014af8$var$getHelpObjectStoreDataID;
    if ((0, $hN5YJ.isFixRelayIdConflictInHelpCenter)()) return 0, $brUL9.default;
    return undefined;
};
const $5240241a52014af8$var$getDataID = $5240241a52014af8$export$e6629d3c6f1259a8();
var // Export a singleton instance of Relay Environment configured with our network function:
$5240241a52014af8$export$2e2bcd8739ae039 = new (0, $5KQKg.Environment)({
    network: $5240241a52014af8$var$getNetWork(),
    store: new (0, $5KQKg.Store)(new (0, $5KQKg.RecordSource)()),
    ...$5240241a52014af8$var$getDataID ? {
        getDataID: $5240241a52014af8$var$getDataID
    } : {}
});

});
parcelRegister("59Bzz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0061d3b21710953$export$2e2bcd8739ae039);

var $c0Y6o = parcelRequire("c0Y6o");

var $jWHK4 = parcelRequire("jWHK4");
const $b0061d3b21710953$var$fetchQuery = ({ operationKind: operationKind, id: id, name: name }, variables)=>{
    const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
    const AGG_PATH = (0, $jWHK4.default).getJsmScaleTestAggPath(id) ?? AGG_BASE_PATH;
    const body = JSON.stringify({
        variables: variables,
        operationName: name
    });
    return (0, $c0Y6o.fetchJson)(AGG_PATH, {
        body: body,
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            ...operationKind === 'mutation' && {
                'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
            },
            ...(0, $jWHK4.default).getHeaders()
        }
    });
};
var $b0061d3b21710953$export$2e2bcd8739ae039 = $b0061d3b21710953$var$fetchQuery;

});
parcelRegister("c0Y6o", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $cadf86deee976628$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $cadf86deee976628$export$6d71b655afe1638d);
$parcel$export(module.exports, "handleGraphQlErrors", () => $cadf86deee976628$export$e7e6c134f67b83b7);
$parcel$export(module.exports, "isFetchNetworkOrClientError", () => $cadf86deee976628$export$68d314c2a361832e);

var $aYMdQ = parcelRequire("aYMdQ");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
const $cadf86deee976628$var$NO_CONTENT = 204;
const $cadf86deee976628$var$NETWORK_ERROR_MESSAGE = 'Failed to fetch';
const $cadf86deee976628$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $cadf86deee976628$var$NETWORK_ERROR_CODE = 0;
class $cadf86deee976628$export$26e841bcf1aeb894 extends Error {
    constructor(message, status, filterFromSentry){
        super(message);
        this.status = status;
        this.filterFromSentry = filterFromSentry;
    }
}
const $cadf86deee976628$export$6d71b655afe1638d = (url, params)=>{
    return fetch(url, params).then($cadf86deee976628$var$handleErrors).then($cadf86deee976628$var$processResponseFromServer).then($cadf86deee976628$export$e7e6c134f67b83b7).catch($cadf86deee976628$var$handleNetworkErrors);
};
const $cadf86deee976628$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new $cadf86deee976628$export$26e841bcf1aeb894($cadf86deee976628$var$NETWORK_ERROR_MESSAGE, $cadf86deee976628$var$NETWORK_ERROR_CODE);
    throw err;
};
const $cadf86deee976628$var$handleErrors = (response)=>{
    if (!response.ok) {
        const traceId = response.headers.get('atl-traceid');
        // If the traceId is null, it indicates that the request never reached the Atlassian network. In such cases, we should not throw an error. This situation may occur if the request has been intercepted by a firewall or another proxy server. For more details, refer to the discussion in the following Slack thread: https://atlassian.slack.com/archives/C06Q6AC22MV/p1711342785804189?thread_ts=1711335142.173669&cid=C06Q6AC22MV
        if (!traceId) // If the request does not have a traceId we treat it as a network error.
        throw new $cadf86deee976628$export$26e841bcf1aeb894($cadf86deee976628$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $cadf86deee976628$var$NETWORK_ERROR_CODE);
        if (traceId) // We filter out network errors with traceId from Sentry as they are not actionable and can be investigated from Splunk.
        throw new $cadf86deee976628$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: ${traceId}`, response.status, true);
        throw new $cadf86deee976628$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: null`, response.status);
    }
    return response;
};
const $cadf86deee976628$var$processResponseFromServer = (response)=>{
    if (response.status === $cadf86deee976628$var$NO_CONTENT) return Promise.resolve(null);
    return response.json();
};
const $cadf86deee976628$export$e7e6c134f67b83b7 = (response)=>{
    const dataEmptyCheck = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && response && typeof response === 'object' && 'data' in response ? (0, $aYMdQ.isEmpty)(response.data) : true;
    if (response && typeof response === 'object' && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('errors') && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('extensions') && dataEmptyCheck) {
        var _graphQlResponse$exte, _graphQlResponse$erro3, _graphQlResponse$erro4;
        // throw error from graphql API
        const graphQlResponse = response;
        const traceId = (_graphQlResponse$exte = graphQlResponse.extensions) === null || _graphQlResponse$exte === void 0 || (_graphQlResponse$exte = _graphQlResponse$exte.gateway) === null || _graphQlResponse$exte === void 0 ? void 0 : _graphQlResponse$exte.request_id;
        if (traceId) {
            var _graphQlResponse$erro, _graphQlResponse$erro2;
            throw new $cadf86deee976628$export$26e841bcf1aeb894(`ErrorCode: ${(_graphQlResponse$erro = graphQlResponse.errors) === null || _graphQlResponse$erro === void 0 || (_graphQlResponse$erro = _graphQlResponse$erro[0]) === null || _graphQlResponse$erro === void 0 ? void 0 : _graphQlResponse$erro.message}, traceId: ${traceId}`, Number((_graphQlResponse$erro2 = graphQlResponse.errors) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2[0]) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2.extensions) === null || _graphQlResponse$erro2 === void 0 ? void 0 : _graphQlResponse$erro2.statusCode) || 500, true);
        }
        throw new $cadf86deee976628$export$26e841bcf1aeb894(`Error: ${(_graphQlResponse$erro3 = graphQlResponse.errors) === null || _graphQlResponse$erro3 === void 0 || (_graphQlResponse$erro3 = _graphQlResponse$erro3[0]) === null || _graphQlResponse$erro3 === void 0 ? void 0 : _graphQlResponse$erro3.message}, traceId: null`, Number((_graphQlResponse$erro4 = graphQlResponse.errors) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4[0]) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4.extensions) === null || _graphQlResponse$erro4 === void 0 ? void 0 : _graphQlResponse$erro4.statusCode) || 500);
    }
    return response;
};
const $cadf86deee976628$export$ad8c5cf7dd4c3caf = (err)=>{
    return err.status === $cadf86deee976628$var$NETWORK_ERROR_CODE;
};
const $cadf86deee976628$export$fa5c2d120eda5e1c = (err)=>{
    return err.status < 500;
};
const $cadf86deee976628$export$68d314c2a361832e = (err)=>{
    return $cadf86deee976628$export$ad8c5cf7dd4c3caf(err) || $cadf86deee976628$export$fa5c2d120eda5e1c(err);
};

});

parcelRegister("jWHK4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f55e0a8463270882$export$2e2bcd8739ae039);

var $c0Y6o = parcelRequire("c0Y6o");

var $hN5YJ = parcelRequire("hN5YJ");

var $7lN8e = parcelRequire("7lN8e");
const $f55e0a8463270882$var$JSM_SCALE_TEST_AGG_BRANCH_SLUG = 'branch-issue-remove-rate-limit';
const $f55e0a8463270882$var$isJsmScaleTestAggOverrideEnabled = ()=>(0, $hN5YJ.isJsmScale60KAggBranchOverrideInHelpCenterEnabled)() && (0, $7lN8e.getEnv)().environment !== (0, $7lN8e.EnvType).PROD;
const $f55e0a8463270882$var$getJsmScaleTestAggPath = (id)=>{
    if (!$f55e0a8463270882$var$isJsmScaleTestAggOverrideEnabled()) return null;
    return id ? `/gateway/api/graphql/${$f55e0a8463270882$var$JSM_SCALE_TEST_AGG_BRANCH_SLUG}/graphql/pq/${id}` : `/gateway/api/graphql/${$f55e0a8463270882$var$JSM_SCALE_TEST_AGG_BRANCH_SLUG}/graphql`;
};
const $f55e0a8463270882$var$setEndpoint = (endpoint)=>{
    $f55e0a8463270882$var$isJsmScaleTestAggOverrideEnabled();
    return endpoint;
};
const $f55e0a8463270882$var$EDGE_FALLBACK_HEADER = {
    'X-Edge-Fallback-To-Unidentified': 'true'
};
const $f55e0a8463270882$var$getHeaders = ()=>({
        ...$f55e0a8463270882$var$EDGE_FALLBACK_HEADER
    });
// Refactored from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/92866a25d86943454624c5ac4fe38a59a17ed7d1/help-center/packages/util/fetch/fetch.tsx#fetch.tsx-51:66
const $f55e0a8463270882$var$NETWORK_ERROR_CODE = 0;
const $f55e0a8463270882$var$NETWORK_ERROR_MESSAGE = 'Failed to fetch';
const $f55e0a8463270882$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $f55e0a8463270882$var$validateResponse = (_request, gqlData)=>{
    if (typeof gqlData === 'object' && typeof gqlData.data === 'undefined') {
        var _gqlData$extensions;
        const traceId = (_gqlData$extensions = gqlData.extensions) === null || _gqlData$extensions === void 0 || (_gqlData$extensions = _gqlData$extensions.gateway) === null || _gqlData$extensions === void 0 ? void 0 : _gqlData$extensions.request_id;
        const statusCode = $f55e0a8463270882$var$getErrorStatusCode('errors' in gqlData && gqlData.errors || []);
        if (typeof traceId === 'undefined') throw new (0, $c0Y6o.FetchError)($f55e0a8463270882$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $f55e0a8463270882$var$NETWORK_ERROR_CODE);
        if (traceId) throw new (0, $c0Y6o.FetchError)(`ErrorCode: ${statusCode}, traceId: ${traceId}`, statusCode, true);
    }
    // This function returns the response but this unused.
    // All that we rely upon is thrown errors to ensure that there aren't any problems with the response.
    (0, $c0Y6o.handleGraphQlErrors)(gqlData);
    // This returns true as the response will be valid if an error is not thrown above.
    return true;
};
function $f55e0a8463270882$var$errorHasAggErrorExtension(err) {
    if (typeof err !== 'object' || err === null) return false;
    if ('extensions' in err === false || typeof err !== 'object' || err === null) return false;
    if (typeof err.extensions !== 'object' || err.extensions === null || 'statusCode' in err.extensions === false) return false;
    return typeof err.extensions.statusCode === 'number';
}
function $f55e0a8463270882$var$getErrorStatusCode(errors) {
    var _errorExtension$exten;
    if (Array.isArray(errors) === false) return 200;
    const errorExtension = errors.find($f55e0a8463270882$var$errorHasAggErrorExtension);
    if (typeof (errorExtension === null || errorExtension === void 0 || (_errorExtension$exten = errorExtension.extensions) === null || _errorExtension$exten === void 0 ? void 0 : _errorExtension$exten.statusCode) !== 'number') return 500;
    return errorExtension.extensions.statusCode;
}
/**
 * Product hook for `ExternalDependencies['onFetchError']` in `platform/packages/relay/relay-fetch/src/multi-fetch.ts`.
 * Called whenever the relay fetch pipeline is about to surface an error to Relay.
 *
 * Help-center's error filtering (see `help-center/packages/util/fetch/fetch.tsx`:
 * `isFetchClientError`/`isFetchNetworkOrClientError`) keys off `FetchError.status`. Errors emitted from the platform
 * `handleTextResponse` /`handleJsonResponse` catch blocks are plain `Error`s with no `status` attached, which means
 * downstream filtering treats them as unclassified server errors and incorrectly fails the view-help-center SLO for
 * upstream proxy/CDN responses (e.g. an HTML `405 Method Not Allowed` page).
 *
 * We wrap any non-`FetchError` error into a `FetchError` so the existing classification pipeline applies.
 *
 * Errors surfaced before an HTTP `Response` was received (e.g. network failure) have `response === undefined`. The
 * shared relay environment runs the platform `relay-fetch` pipeline, which does NOT route through help-center's
 * `fetchJson`/`handleNetworkErrors`, so we must replicate that conversion here: the browser surfaces network failures
 * as a raw `TypeError` ("Failed to fetch") with no `status`. Left unwrapped, it reaches `isFetchNetworkOrClientError`
 * with `status === undefined`, is misclassified as a server error, and incorrectly fails the view-help-center premium
 * SLO. We wrap it into a `FetchError(NETWORK_ERROR_MESSAGE, NETWORK_ERROR_CODE)` (status `0`) so it is classified as a
 * network error and filtered out — matching the legacy (non-shared) relay environment behaviour. Non-`TypeError`
 * pre-response errors are left unchanged, mirroring `handleNetworkErrors`.
 */ const $f55e0a8463270882$var$onFetchError = (error, response)=>{
    if (!response) {
        if (error instanceof TypeError) return new (0, $c0Y6o.FetchError)($f55e0a8463270882$var$NETWORK_ERROR_MESSAGE, $f55e0a8463270882$var$NETWORK_ERROR_CODE);
        return error;
    }
    if (error instanceof (0, $c0Y6o.FetchError)) return error;
    const message = error instanceof Error ? error.message : String(error);
    const filterFromSentry = Boolean(response.headers.get('atl-traceid'));
    return new (0, $c0Y6o.FetchError)(message, response.status, filterFromSentry);
};
var $f55e0a8463270882$export$2e2bcd8739ae039 = {
    setEndpoint: $f55e0a8463270882$var$setEndpoint,
    getJsmScaleTestAggPath: $f55e0a8463270882$var$getJsmScaleTestAggPath,
    getHeaders: $f55e0a8463270882$var$getHeaders,
    validateResponse: $f55e0a8463270882$var$validateResponse,
    onFetchError: $f55e0a8463270882$var$onFetchError,
    getErrorStatusCode: $f55e0a8463270882$var$getErrorStatusCode,
    errorHasAggErrorExtension: $f55e0a8463270882$var$errorHasAggErrorExtension
};

});


parcelRegister("16Sbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $44a0ceac7a937439$export$2e2bcd8739ae039);

var $aYMdQ = parcelRequire("aYMdQ");

var $5KQKg = parcelRequire("5KQKg");

var $c0Y6o = parcelRequire("c0Y6o");

var $jWHK4 = parcelRequire("jWHK4");

var $cH4DC = parcelRequire("cH4DC");
const $44a0ceac7a937439$export$aa8bf897e49821c3 = new Set();
const $44a0ceac7a937439$var$fetchQuery = (request, variables)=>{
    return (0, $5KQKg.Observable).create((sink)=>{
        const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
        const cachedResponse = requestID ? (0, $cH4DC.QueryResponseCache).get(requestID, variables) : undefined;
        /**
     * If we're on the client and we have a cached response, return it immediately.
     */ if (!(0, $aYMdQ.isNil)(cachedResponse)) {
            if (requestID != null) (0, $cH4DC.QueryResponseCache).delete(requestID, variables);
            sink.next(cachedResponse);
            sink.complete();
            return;
        }
        const { id: id, operationKind: operationKind, name: queryName } = request;
        const metaData = {
            queryName: queryName,
            operationKind: operationKind
        };
        const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
        const AGG_PATH = (0, $jWHK4.default).getJsmScaleTestAggPath(id) ?? AGG_BASE_PATH;
        const body = JSON.stringify({
            variables: variables
        });
        const promise = (0, $c0Y6o.fetchJson)(`${AGG_PATH}`, {
            body: body,
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                ...operationKind === 'mutation' && {
                    'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
                },
                ...(0, $jWHK4.default).getHeaders()
            }
        });
        promise.then((response)=>{
            sink.next(response);
            sink.complete();
            return response;
        }).catch((error)=>{
            sink.error(error);
        });
    });
};
var $44a0ceac7a937439$export$2e2bcd8739ae039 = $44a0ceac7a937439$var$fetchQuery;

});
parcelRegister("cH4DC", function(module, exports) {
$parcel$export(module.exports, "QueryResponseCache", () => $1282602b777fa5a5$export$688bd21be71b9e5d);
/**
 * This implementation is copied from Jira frontend.
 */ 
var $5KQKg = parcelRequire("5KQKg");

var $7wx9B = parcelRequire("7wx9B");
const $1282602b777fa5a5$var$CACHE_NAME = 'RELAY_SSR_CACHE';
const $1282602b777fa5a5$export$611736262b635f8d = (queryID, variables)=>JSON.stringify((0, $5KQKg.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
const $1282602b777fa5a5$export$1e65e863cf3a0f21 = (cacheKey)=>JSON.parse(cacheKey).queryID;
class $1282602b777fa5a5$export$be21c283b097d175 extends (0, $5KQKg.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        // Load cached data from the server, if available
        let spaState = {};
        {
            var _document$getElementB;
            const spaStateFromServer = (_document$getElementB = document.getElementById('spa-state')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.getAttribute('data-state');
            try {
                spaState = spaStateFromServer ? JSON.parse(decodeURIComponent(spaStateFromServer)) : {};
            } catch (err) {
                (0, $7wx9B.reportError)(err);
            }
        }
        const cachedData = spaState[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(undefined);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        setTimeout(()=>{
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $1282602b777fa5a5$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $1282602b777fa5a5$export$688bd21be71b9e5d = new $1282602b777fa5a5$export$be21c283b097d175({
    cacheName: $1282602b777fa5a5$var$CACHE_NAME,
    size: Infinity,
    ttl: Infinity
});
const $1282602b777fa5a5$export$de9cebd147177ad2 = ()=>$1282602b777fa5a5$export$688bd21be71b9e5d.serialize();

});


parcelRegister("9cYDP", function(module, exports) {
$parcel$export(module.exports, "subscribeOptions", () => $83afb7ccc941aaa5$export$9bdaf447ae2b3b45);
$parcel$export(module.exports, "subscribe", () => $83afb7ccc941aaa5$export$ec068583843480e7);

var $5KQKg = parcelRequire("5KQKg");

var $6lbrU = parcelRequire("6lbrU");

var $dXoLD = parcelRequire("dXoLD");
const $83afb7ccc941aaa5$export$9bdaf447ae2b3b45 = {
    extensions: {},
    onTrigger: (payload)=>(0, $6lbrU.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'triggered',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                ...payload
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        }),
    onError: (payload)=>(0, $6lbrU.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'failed',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                operationName: payload.operationName,
                requestId: payload.requestId
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        })
};
const $83afb7ccc941aaa5$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $5KQKg.Observable).create((sink)=>{
        const client = (0, $dXoLD.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            operationName: operationName,
            variables: variables,
            query: '',
            extensions: {
                pq: id,
                ...$83afb7ccc941aaa5$export$9bdaf447ae2b3b45.extensions
            }
        };
        let requestId;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $83afb7ccc941aaa5$export$9bdaf447ae2b3b45.onTrigger(payload);
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                var _value$extensions;
                const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                requestId = aggRequestId ?? requestId;
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = $83afb7ccc941aaa5$export$ece4736473c28965(sinkError);
                sink.error(errorInfo);
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                $83afb7ccc941aaa5$export$9bdaf447ae2b3b45.onError({
                    operationName: operationName,
                    requestId: requestId
                });
            }
        });
    });
const $83afb7ccc941aaa5$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
    else // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});
parcelRegister("dXoLD", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $7141947fe6865649$export$6bb76d6eba7e258c);

var $fSTQn = parcelRequire("fSTQn");

var $6fWu5 = parcelRequire("6fWu5");
let $7141947fe6865649$var$client = null;
const $7141947fe6865649$export$6bb76d6eba7e258c = ()=>{
    if ((0, $6fWu5.isSSR)()) return null;
    if ($7141947fe6865649$var$client == null) $7141947fe6865649$var$client = (0, $fSTQn.createClient)({
        url: (0, $6fWu5.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $6fWu5.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $6fWu5.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend'
        }
    });
    return $7141947fe6865649$var$client;
};
const $7141947fe6865649$export$2f0afd443356d36f = ()=>{
    $7141947fe6865649$var$client = null;
};

});
parcelRegister("6fWu5", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $90e8dc15691d29dc$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $90e8dc15691d29dc$export$29a72e89601dfc59);
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $90e8dc15691d29dc$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $90e8dc15691d29dc$export$bf6cd96e19b2987f);
const $90e8dc15691d29dc$export$48d7c418edadb60c = ()=>false ?? false;
const $90e8dc15691d29dc$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
const $90e8dc15691d29dc$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $90e8dc15691d29dc$export$bf6cd96e19b2987f = 100;

});




parcelRegister("2xOCW", function(module, exports) {
$parcel$export(module.exports, "getRelayDataId", () => $d53cf0c61e070755$export$944f9dc3d03637c3);

var $hN5YJ = parcelRequire("hN5YJ");

var $brUL9 = parcelRequire("brUL9");
const $d53cf0c61e070755$export$944f9dc3d03637c3 = (id, typeName)=>{
    if ((0, $hN5YJ.isFixRelayIdConflictInHelpCenter)()) return (0, $brUL9.default)({
        id: id
    }, typeName);
    return id;
};

});




parcelRegister("f8AuD", function(module, exports) {
$parcel$export(module.exports, "loginConsentEpic", () => $0cff74d37660e6c3$export$90c588d343cf5f98);

var $jFk35 = parcelRequire("jFk35");

var $k2N5X = parcelRequire("k2N5X");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("gQGD7");
var $cKoJT = parcelRequire("cKoJT");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $gioQl = parcelRequire("gioQl");
const $0cff74d37660e6c3$export$90c588d343cf5f98 = (action$)=>{
    return action$.ofType((0, $cKoJT.LOGIN_CONSENT)).mergeMap((action)=>{
        const { param: param } = action.payload;
        return (0, $k2N5X.loginConsent)(param).mergeMap(({ response: response })=>{
            (0, $esgVk.replace)(response.uri);
            return (0, $jFk35.Observable).empty();
        }).catch(()=>{
            (0, $diqlM.default).push((0, $gioQl.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
            return (0, $jFk35.Observable).of((0, $6oW6S.loginConsentFailure)());
        });
    });
};

});
parcelRegister("k2N5X", function(module, exports) {
$parcel$export(module.exports, "loginConsent", () => $1a4f486d09e0b1dc$export$fd88d7fe0deeba34);

var $bTjsX = parcelRequire("bTjsX");
const $1a4f486d09e0b1dc$export$fd88d7fe0deeba34 = (param)=>{
    const uri = `/jsd-login-v2/v2/customer/login/fedramp/consent${param}`;
    const body = {
        fedrampConsent: 'provided'
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers);
};

});

parcelRegister("gQGD7", function(module, exports) {
$parcel$export(module.exports, "loginConsentAction", () => (parcelRequire("cKoJT")).loginConsentAction);
$parcel$export(module.exports, "LOGIN_CONSENT", () => (parcelRequire("cKoJT")).LOGIN_CONSENT);

var $cKoJT = parcelRequire("cKoJT");

});
parcelRegister("cKoJT", function(module, exports) {
$parcel$export(module.exports, "LOGIN_CONSENT", () => $6b9038547bdc2e1c$export$12110c14f93a926f);
$parcel$export(module.exports, "loginConsentAction", () => $6b9038547bdc2e1c$export$684d17f74d8831a7);
const $6b9038547bdc2e1c$export$12110c14f93a926f = 'state.ui.LOGIN_CONSENT';
const $6b9038547bdc2e1c$export$684d17f74d8831a7 = (param)=>{
    return {
        payload: {
            param: param
        },
        type: $6b9038547bdc2e1c$export$12110c14f93a926f
    };
};

});



parcelRegister("cJVfe", function(module, exports) {
$parcel$export(module.exports, "logOutEpic", () => $1c9de72c6e59e076$export$c4456f69976aae9b);

var $jFk35 = parcelRequire("jFk35");

var $1BinA = parcelRequire("1BinA");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");

var $2AdoZ = parcelRequire("2AdoZ");

var $esgVk = parcelRequire("esgVk");

var $gioQl = parcelRequire("gioQl");

var $3C1PA = parcelRequire("3C1PA");
const $1c9de72c6e59e076$var$AA_LOGOUT_REDIRECT_URL = `/logout?dest-url=${encodeURIComponent(`${(0, $diqlM.getRelativeBasePath)()}${(0, $gioQl.getHelpCenterUrl)()}`)}`;
const $1c9de72c6e59e076$export$8931338e80b3349d = (state)=>{
    if ((0, $7RWiC.isAtlassianAccountManaged)(state)) // no need to call Jira to log out Atlassian accounts. Simply redirect to AA logout page
    return (0, $jFk35.Observable).of({
        logoutRedirectUrl: $1c9de72c6e59e076$var$AA_LOGOUT_REDIRECT_URL
    });
    return (0, $1BinA.logoutUsingIdentity)(`${(0, $fYLlE.getBaseUrl)(state)}${$1c9de72c6e59e076$var$getAfterLogoutUrl(state)}`);
};
const $1c9de72c6e59e076$export$c4456f69976aae9b = (action$, store)=>{
    return action$.ofType((0, $3C1PA.LOG_OUT)).mergeMap(()=>{
        const state = store.getState();
        // Removing cached response of help-seeker-type on logout
        (0, $2AdoZ.removeLocalStorageItem)('help-seeker-type');
        return $1c9de72c6e59e076$export$8931338e80b3349d(state).mergeMap((response)=>{
            // We do a full page load to the login or help center page to clear out the redux store and avoid
            // data for one user being seen by another if one logs out and another logs in in the same tab
            (0, $esgVk.assign)($1c9de72c6e59e076$var$getLogoutDestination(state, response));
            return (0, $jFk35.Observable).empty();
        }).catch((error)=>{
            return $1c9de72c6e59e076$var$handleLogoutError(error);
        });
    });
};
function $1c9de72c6e59e076$var$handleLogoutError(error) {
    (0, $aIVqJ.trackError)('session.logout.failed', {}, error);
    (0, $esgVk.reload)();
    return (0, $jFk35.Observable).empty();
}
function $1c9de72c6e59e076$var$getAfterLogoutUrl(state) {
    if ((0, $fYLlE.getIsAnonymousEnabled)(state)) return (0, $gioQl.getHelpCenterUrl)();
    return (0, $gioQl.getLoginUrlForPortalId)((0, $dFKzv.getPortalId)(state));
}
function $1c9de72c6e59e076$var$getLogoutDestination(state, logoutResponseBody) {
    if (logoutResponseBody && logoutResponseBody.logoutRedirectUrl) return logoutResponseBody.logoutRedirectUrl;
    return `${(0, $diqlM.getBaseName)()}${$1c9de72c6e59e076$var$getAfterLogoutUrl(state)}`;
}

});
parcelRegister("1BinA", function(module, exports) {
$parcel$export(module.exports, "logoutUsingIdentity", () => $7c56b7fcc045ad0c$export$7d7e0f6e9da553cb);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $aIVqJ = parcelRequire("aIVqJ");

var $4MjGQ = parcelRequire("4MjGQ");

var $diqlM = parcelRequire("diqlM");
const $7c56b7fcc045ad0c$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'logout',
        source: 'unknownSource'
    };
};
const $7c56b7fcc045ad0c$export$7d7e0f6e9da553cb = (redirectUrl, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/jsd-login-v2/v2/customer/logout?continue=${redirectUrl}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri).do((ajaxResponse)=>{
        (0, $4MjGQ.operationalEvent)($7c56b7fcc045ad0c$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString()
        }));
    }, (ajaxError)=>{
        var _ajaxError$response;
        (0, $4MjGQ.operationalEvent)($7c56b7fcc045ad0c$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorKey: (_ajaxError$response = ajaxError.response) === null || _ajaxError$response === void 0 ? void 0 : _ajaxError$response.key
        }));
        (0, $aIVqJ.trackError)('session.logout.failed', {}, ajaxError);
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};

});

parcelRegister("53Mcy", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => (parcelRequire("dFKzv")).getPathname);
$parcel$export(module.exports, "getPortalId", () => (parcelRequire("dFKzv")).getPortalId);

var $dFKzv = parcelRequire("dFKzv");

});
parcelRegister("dFKzv", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => $9584dd152d1de534$export$b829272b1dcc6798);
$parcel$export(module.exports, "getPortalId", () => $9584dd152d1de534$export$79c9b12a0a57147a);
const $9584dd152d1de534$export$f71e6ac2c1d88be0 = (state)=>state.ui.context.portalId !== undefined && state.ui.context.portalId !== null && !isNaN(state.ui.context.portalId);
const $9584dd152d1de534$export$b829272b1dcc6798 = (state)=>state.ui.context.pathname;
const $9584dd152d1de534$export$6c570a1091322ad4 = (state)=>state.ui.context.routeName;
const $9584dd152d1de534$export$79c9b12a0a57147a = (state)=>{
    if (!$9584dd152d1de534$export$f71e6ac2c1d88be0(state)) return undefined;
    return state.ui.context.portalId;
};

});


parcelRegister("68iI4", function(module, exports) {
$parcel$export(module.exports, "getWacLink", () => (parcelRequire("fYLlE")).getWacLink);
$parcel$export(module.exports, "getHeadless", () => (parcelRequire("fYLlE")).getHeadless);
$parcel$export(module.exports, "getServiceDeskVersion", () => (parcelRequire("fYLlE")).getServiceDeskVersion);
$parcel$export(module.exports, "getXsrfToken", () => (parcelRequire("fYLlE")).getXsrfToken);
$parcel$export(module.exports, "getBaseUrl", () => (parcelRequire("fYLlE")).getBaseUrl);
$parcel$export(module.exports, "getContactLink", () => (parcelRequire("fYLlE")).getContactLink);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => (parcelRequire("fYLlE")).getIsAnonymousEnabled);
$parcel$export(module.exports, "getFabricEmojiUrl", () => (parcelRequire("fYLlE")).getFabricEmojiUrl);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => (parcelRequire("fYLlE")).getJsmAIConfigEnabled);
$parcel$export(module.exports, "getJiraDisplayUrl", () => (parcelRequire("fYLlE")).getJiraDisplayUrl);

var $fYLlE = parcelRequire("fYLlE");

});
parcelRegister("fYLlE", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskVersion", () => $cae6b60eb4e8d436$export$cf63d87096689a17);
$parcel$export(module.exports, "getWacLink", () => $cae6b60eb4e8d436$export$94833c7df37d6b17);
$parcel$export(module.exports, "getHeadless", () => $cae6b60eb4e8d436$export$915f62c9c01bc3d6);
$parcel$export(module.exports, "getXsrfToken", () => $cae6b60eb4e8d436$export$14407a25c57e1f92);
$parcel$export(module.exports, "getContactLink", () => $cae6b60eb4e8d436$export$a204de3b9df9c687);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => $cae6b60eb4e8d436$export$10062cf4ec7decdd);
$parcel$export(module.exports, "getFabricEmojiUrl", () => $cae6b60eb4e8d436$export$81a8d16acc87f947);
$parcel$export(module.exports, "getBaseUrl", () => $cae6b60eb4e8d436$export$f654b28f82155665);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $cae6b60eb4e8d436$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $cae6b60eb4e8d436$export$9679fa5312e1354b);
const $cae6b60eb4e8d436$export$cf63d87096689a17 = (state)=>state.persisted.env.serviceDeskVersion;
const $cae6b60eb4e8d436$export$94833c7df37d6b17 = (state)=>state.persisted.env.wacLink;
const $cae6b60eb4e8d436$export$915f62c9c01bc3d6 = (state)=>state.persisted.env.headless;
const $cae6b60eb4e8d436$export$14407a25c57e1f92 = (state)=>state.persisted.env.xsrfToken;
const $cae6b60eb4e8d436$export$a204de3b9df9c687 = (state)=>state.persisted.env.contactLink;
const $cae6b60eb4e8d436$export$10062cf4ec7decdd = (state)=>state.persisted.env.anonymousEnabled;
const $cae6b60eb4e8d436$export$81a8d16acc87f947 = (state)=>state.persisted.env.fabricEmojiUrl;
const $cae6b60eb4e8d436$export$f654b28f82155665 = (state)=>state.persisted.env.baseUrl;
const $cae6b60eb4e8d436$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $cae6b60eb4e8d436$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $cae6b60eb4e8d436$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $cae6b60eb4e8d436$export$23a8be9c477ed0ba = (state)=>state.persisted.env.hoistedProjectId;
const $cae6b60eb4e8d436$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;
const $cae6b60eb4e8d436$export$16e2ca57934a087e = (state)=>state.persisted.env.customerAccountAvailabilty;

});


parcelRegister("b46ZL", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => (parcelRequire("7RWiC")).getLocale);
$parcel$export(module.exports, "getAvatar", () => (parcelRequire("7RWiC")).getAvatar);
$parcel$export(module.exports, "AvatarSizes", () => (parcelRequire("7RWiC")).AvatarSizes);
$parcel$export(module.exports, "isLoggedIn", () => (parcelRequire("7RWiC")).isLoggedIn);
$parcel$export(module.exports, "isUserLoaded", () => (parcelRequire("7RWiC")).isUserLoaded);
$parcel$export(module.exports, "getCanAdministerJIRA", () => (parcelRequire("7RWiC")).getCanAdministerJIRA);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => (parcelRequire("7RWiC")).getHasSiteAdministerAccess);
$parcel$export(module.exports, "getAgentForPortal", () => (parcelRequire("7RWiC")).getAgentForPortal);
$parcel$export(module.exports, "getAccountId", () => (parcelRequire("7RWiC")).getAccountId);
$parcel$export(module.exports, "getDisplayName", () => (parcelRequire("7RWiC")).getDisplayName);
$parcel$export(module.exports, "getAvatarSrc", () => (parcelRequire("7RWiC")).getAvatarSrc);
$parcel$export(module.exports, "getCustomMenuLinks", () => (parcelRequire("7RWiC")).getCustomMenuLinks);
$parcel$export(module.exports, "getUserState", () => (parcelRequire("7RWiC")).getUserState);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => (parcelRequire("7RWiC")).isAtlassianAccountManaged);

var $7RWiC = parcelRequire("7RWiC");

});
parcelRegister("7RWiC", function(module, exports) {
$parcel$export(module.exports, "AvatarSizes", () => $583e2646de42bdbc$export$a56a976854e036b3);
$parcel$export(module.exports, "isLoggedIn", () => $583e2646de42bdbc$export$256a5a3564694cfc);
$parcel$export(module.exports, "isUserLoaded", () => $583e2646de42bdbc$export$e184595b7ec7bf2a);
$parcel$export(module.exports, "getLocale", () => $583e2646de42bdbc$export$180605366c04f0cd);
$parcel$export(module.exports, "getAvatar", () => $583e2646de42bdbc$export$4832dff6e2fcc91f);
$parcel$export(module.exports, "getAvatarSrc", () => $583e2646de42bdbc$export$35125d98e6f1484);
$parcel$export(module.exports, "getCustomMenuLinks", () => $583e2646de42bdbc$export$bf9a934424e2dbf1);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $583e2646de42bdbc$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $583e2646de42bdbc$export$c5f994129d97ed23);
$parcel$export(module.exports, "getAgentForPortal", () => $583e2646de42bdbc$export$a163df73b48c15df);
$parcel$export(module.exports, "getAccountId", () => $583e2646de42bdbc$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getDisplayName", () => $583e2646de42bdbc$export$be63e0664592e141);
$parcel$export(module.exports, "getUserState", () => $583e2646de42bdbc$export$531a2013799771e3);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => $583e2646de42bdbc$export$9055c338585b9def);
var $583e2646de42bdbc$export$a56a976854e036b3 = /*#__PURE__*/ function(AvatarSizes) {
    AvatarSizes["XSMALL"] = "xsmall";
    AvatarSizes["SMALL"] = "small";
    AvatarSizes["MEDIUM"] = "medium";
    AvatarSizes["LARGE"] = "large";
    AvatarSizes["XLARGE"] = "xlarge";
    return AvatarSizes;
}({});
const $583e2646de42bdbc$export$256a5a3564694cfc = (state)=>state.persisted.user.isLoggedIn;
const $583e2646de42bdbc$export$e184595b7ec7bf2a = (state)=>state.persisted.user.isLoaded;
const $583e2646de42bdbc$export$180605366c04f0cd = (state)=>state.persisted.user.language.key;
const $583e2646de42bdbc$export$4832dff6e2fcc91f = (state, size)=>{
    if (state.persisted.user.avatars && size) return state.persisted.user.avatars[size];
    return undefined;
};
const $583e2646de42bdbc$export$35125d98e6f1484 = (state)=>$583e2646de42bdbc$export$4832dff6e2fcc91f(state, "xlarge");
const $583e2646de42bdbc$export$ee387765d0284f6c = (state)=>{
    return state.persisted.user.userRequests;
};
const $583e2646de42bdbc$export$aa593f8d08aea763 = (state)=>{
    return state.persisted.user.userRequests.myRequestCount;
};
const $583e2646de42bdbc$export$e088f15960c351f6 = (state)=>{
    return state.persisted.user.userRequests.pendingApprovalCount;
};
const $583e2646de42bdbc$export$c0edbdc6282ca463 = (state)=>{
    return state.persisted.user.userRequests.approvalCount;
};
const $583e2646de42bdbc$export$bf9a934424e2dbf1 = (state)=>state.persisted.user.customMenuLinks;
const $583e2646de42bdbc$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $583e2646de42bdbc$export$c5f994129d97ed23 = (state)=>{
    return state.persisted.user.hasSiteAdministerAccess;
};
const $583e2646de42bdbc$export$a163df73b48c15df = (state)=>{
    return state.persisted.user.agentForPortal;
};
const $583e2646de42bdbc$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $583e2646de42bdbc$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName;
};
const $583e2646de42bdbc$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $583e2646de42bdbc$export$531a2013799771e3 = (state)=>{
    return state.persisted.user;
};
const $583e2646de42bdbc$export$9055c338585b9def = (state)=>{
    return state.persisted.user.atlassianAccountManaged;
};

});


parcelRegister("2AdoZ", function(module, exports) {
$parcel$export(module.exports, "getLocalStorageItem", () => $d481f47a9a34102d$export$93d719890ad66653);
$parcel$export(module.exports, "setLocalStorageItem", () => $d481f47a9a34102d$export$5aa524d86254b4f);
$parcel$export(module.exports, "removeLocalStorageItem", () => $d481f47a9a34102d$export$baf306891f1b93bd);

var $hPIXE = parcelRequire("hPIXE");

var $7xlLS = parcelRequire("7xlLS");
const $d481f47a9a34102d$export$93d719890ad66653 = (key, errorHandler)=>{
    return (0, $7xlLS.safeAccessWithErrorHandler)(()=>(0, $hPIXE.AtlBrowserStorageLocal).getItem(key), errorHandler);
};
const $d481f47a9a34102d$export$5aa524d86254b4f = (key, value, errorHandler)=>{
    return (0, $7xlLS.safeAccessWithErrorHandler)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $hPIXE.AtlBrowserStorageLocal).setItem(key, value);
    }, errorHandler);
};
const $d481f47a9a34102d$export$baf306891f1b93bd = (key, errorHandler)=>{
    return (0, $7xlLS.safeAccessWithErrorHandler)(()=>(0, $hPIXE.AtlBrowserStorageLocal).removeItem(key), errorHandler);
};

});
parcelRegister("hPIXE", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $c84aefb28a8e5703$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $c84aefb28a8e5703$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $c84aefb28a8e5703$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("jvA59")).WebStorageType);

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");
var $iPmiQ = parcelRequire("iPmiQ");
var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");

var $cjHoj = parcelRequire("cjHoj");

var $jvA59 = parcelRequire("jvA59");

var $7hXtQ = parcelRequire("7hXtQ");
var $k3mGF = parcelRequire("k3mGF");
var $isStc = parcelRequire("isStc");
class $c84aefb28a8e5703$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $eqqb5.getBscGlobalState)().webStorageEnabled) return true;
        (0, $3k55j.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $3k55j.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $7hXtQ.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            // BSC controls are disabled (pre-init, caller opted out, or killswitch active).
            // Write proceeds unconditionally — emit analytics so we can quantify bypass volume
            // (gated by platform_bsc_consent_bypass_analytics for safe rollout).
            if ((0, $dRkX9.fg)('platform_bsc_consent_bypass_analytics')) {
                const globalState = (0, $eqqb5.getBscGlobalState)();
                (0, $g5Y6L.sendPackageOperationalEvent)({
                    action: 'usedAtlBrowserStorageSetItemBscDisabled',
                    attributes: {
                        storageType: this.storageType,
                        product: globalState.product,
                        hasInitialized: globalState.hasInitialized ?? false
                    }
                });
            }
            this.storage.setItem(key, value);
            return {
                status: (0, $cjHoj.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $3k55j.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $cjHoj.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $eqqb5.getBscGlobalState)().product;
        const wasInitialized = (0, $eqqb5.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $k3mGF.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized) (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, $cjHoj.Status).SUCCESS) (0, $3k55j.Logger).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, $cjHoj.Status).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, $3k55j.Logger).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, $3k55j.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, $3k55j.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $3k55j.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $isStc.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, $eqqb5.getBscGlobalState)().hasInitialized) (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $3k55j.Logger).debug(`${itemSetStatus === (0, $cjHoj.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $3k55j.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $iPmiQ.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $c84aefb28a8e5703$export$c8cc3ffd3f2c1d2f = new $c84aefb28a8e5703$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, $jvA59.WebStorageType).LocalStorage);
const $c84aefb28a8e5703$export$edbae459bdf957a5 = new $c84aefb28a8e5703$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, $jvA59.WebStorageType).SessionStorage);
const $c84aefb28a8e5703$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $jvA59.WebStorageType).LocalStorage]: $c84aefb28a8e5703$export$c8cc3ffd3f2c1d2f,
        [(0, $jvA59.WebStorageType).SessionStorage]: $c84aefb28a8e5703$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("eqqb5", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $89cf1ca948d1a9bb$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $89cf1ca948d1a9bb$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetPatternFormat", () => $89cf1ca948d1a9bb$export$f9550288b9b1f6e3);
$parcel$export(module.exports, "__internalSetPatternFormat", () => $89cf1ca948d1a9bb$export$f10a7691f1fb3cb);
$parcel$export(module.exports, "__internalGetResolvedFlatPatternFileFormat", () => $89cf1ca948d1a9bb$export$8bf1367cc4bb66da);
$parcel$export(module.exports, "__internalSetResolvedFlatPatternFileFormat", () => $89cf1ca948d1a9bb$export$2bd306fd2b97e710);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $89cf1ca948d1a9bb$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $89cf1ca948d1a9bb$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $89cf1ca948d1a9bb$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $89cf1ca948d1a9bb$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $89cf1ca948d1a9bb$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $89cf1ca948d1a9bb$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $89cf1ca948d1a9bb$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", () => $89cf1ca948d1a9bb$export$cff869f7e58c9036);
$parcel$export(module.exports, "__internalSetCacheLoadedDate", () => $89cf1ca948d1a9bb$export$491d0e6c401a0697);
$parcel$export(module.exports, "__internalSetCdnFileVersion", () => $89cf1ca948d1a9bb$export$4c4bd5703eacf293);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $89cf1ca948d1a9bb$export$ea32fe1e8610fd3b);

var $cjHoj = parcelRequire("cjHoj");

var $bqFvR = parcelRequire("bqFvR");
let $89cf1ca948d1a9bb$var$analyticsEnabledGlobalState;
let $89cf1ca948d1a9bb$var$productGlobalState;
let $89cf1ca948d1a9bb$var$perimeterGlobalState;
let $89cf1ca948d1a9bb$var$webStorageControlsEnabledGlobalState;
let $89cf1ca948d1a9bb$var$indexedDbControlsEnabledGlobalState;
let $89cf1ca948d1a9bb$var$disableWebStorageConsentChecksGlobalState;
let $89cf1ca948d1a9bb$var$localConsentModeGlobalState;
let $89cf1ca948d1a9bb$var$packageLogLevelGlobalState;
let $89cf1ca948d1a9bb$var$allowUncategorizedCookiesInOverridesGlobalState;
let $89cf1ca948d1a9bb$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $89cf1ca948d1a9bb$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $89cf1ca948d1a9bb$var$disableIndexedDbConsentChecksGlobalState;
let $89cf1ca948d1a9bb$var$userIdGlobalState;
let $89cf1ca948d1a9bb$var$cloudIdGlobalState;
let $89cf1ca948d1a9bb$var$hasInitialized = false;
let $89cf1ca948d1a9bb$var$cacheLoadedDateGlobalState;
let $89cf1ca948d1a9bb$var$cdnFileVersionGlobalState;
let $89cf1ca948d1a9bb$var$patternFormatGlobalState;
let $89cf1ca948d1a9bb$var$resolvedFlatPatternFileFormatGlobalState;
let $89cf1ca948d1a9bb$var$cookiesCacheLoader;
let $89cf1ca948d1a9bb$var$localStorageCacheLoader;
let $89cf1ca948d1a9bb$var$sessionStorageCacheLoader;
let $89cf1ca948d1a9bb$var$indexedDBCacheLoader;
let $89cf1ca948d1a9bb$var$loadCache = async (storageType)=>{
    var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL, _indexedDBCacheLoader;
    switch(storageType){
        case (0, $cjHoj.CategoryStorageType).Cookies:
            return await ((_cookiesCacheLoader = $89cf1ca948d1a9bb$var$cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData());
        case (0, $cjHoj.CategoryStorageType).LocalStorage:
            return await ((_localStorageCacheLoa = $89cf1ca948d1a9bb$var$localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData());
        case (0, $cjHoj.CategoryStorageType).SessionStorage:
            return await ((_sessionStorageCacheL = $89cf1ca948d1a9bb$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData());
        case (0, $cjHoj.CategoryStorageType).IndexedDB:
            return await ((_indexedDBCacheLoader = $89cf1ca948d1a9bb$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader === void 0 ? void 0 : _indexedDBCacheLoader.loadStorageControlsData());
        default:
            return undefined;
    }
};
let $89cf1ca948d1a9bb$var$loadCacheMaybeSync = (storageType)=>{
    var _cookiesCacheLoader2, _cookiesCacheLoader3, _localStorageCacheLoa2, _localStorageCacheLoa3, _sessionStorageCacheL2, _sessionStorageCacheL3, _indexedDBCacheLoader2, _indexedDBCacheLoader3;
    switch(storageType){
        case (0, $cjHoj.CategoryStorageType).Cookies:
            return ((_cookiesCacheLoader2 = $89cf1ca948d1a9bb$var$cookiesCacheLoader) === null || _cookiesCacheLoader2 === void 0 ? void 0 : _cookiesCacheLoader2.getStorageControlsDataFromCache()) ?? ((_cookiesCacheLoader3 = $89cf1ca948d1a9bb$var$cookiesCacheLoader) === null || _cookiesCacheLoader3 === void 0 ? void 0 : _cookiesCacheLoader3.loadStorageControlsData());
        case (0, $cjHoj.CategoryStorageType).LocalStorage:
            return ((_localStorageCacheLoa2 = $89cf1ca948d1a9bb$var$localStorageCacheLoader) === null || _localStorageCacheLoa2 === void 0 ? void 0 : _localStorageCacheLoa2.getStorageControlsDataFromCache()) ?? ((_localStorageCacheLoa3 = $89cf1ca948d1a9bb$var$localStorageCacheLoader) === null || _localStorageCacheLoa3 === void 0 ? void 0 : _localStorageCacheLoa3.loadStorageControlsData());
        case (0, $cjHoj.CategoryStorageType).SessionStorage:
            return ((_sessionStorageCacheL2 = $89cf1ca948d1a9bb$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL2 === void 0 ? void 0 : _sessionStorageCacheL2.getStorageControlsDataFromCache()) ?? ((_sessionStorageCacheL3 = $89cf1ca948d1a9bb$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL3 === void 0 ? void 0 : _sessionStorageCacheL3.loadStorageControlsData());
        case (0, $cjHoj.CategoryStorageType).IndexedDB:
            return ((_indexedDBCacheLoader2 = $89cf1ca948d1a9bb$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader2 === void 0 ? void 0 : _indexedDBCacheLoader2.getStorageControlsDataFromCache()) ?? ((_indexedDBCacheLoader3 = $89cf1ca948d1a9bb$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader3 === void 0 ? void 0 : _indexedDBCacheLoader3.loadStorageControlsData());
        default:
            return undefined;
    }
};
const $89cf1ca948d1a9bb$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $89cf1ca948d1a9bb$var$analyticsEnabledGlobalState ?? true,
        product: $89cf1ca948d1a9bb$var$productGlobalState,
        perimeter: $89cf1ca948d1a9bb$var$perimeterGlobalState,
        webStorageEnabled: $89cf1ca948d1a9bb$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $89cf1ca948d1a9bb$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $89cf1ca948d1a9bb$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $89cf1ca948d1a9bb$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $89cf1ca948d1a9bb$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $89cf1ca948d1a9bb$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $89cf1ca948d1a9bb$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $89cf1ca948d1a9bb$var$disableIndexedDbConsentChecksGlobalState ?? false,
        packageLogLevel: $89cf1ca948d1a9bb$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $89cf1ca948d1a9bb$var$cookiesCacheLoader,
        localStorageCacheLoader: $89cf1ca948d1a9bb$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $89cf1ca948d1a9bb$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $89cf1ca948d1a9bb$var$indexedDBCacheLoader,
        loadCache: $89cf1ca948d1a9bb$var$loadCache,
        loadCacheMaybeSync: $89cf1ca948d1a9bb$var$loadCacheMaybeSync,
        hasInitialized: $89cf1ca948d1a9bb$var$hasInitialized,
        userId: $89cf1ca948d1a9bb$var$userIdGlobalState,
        cloudId: $89cf1ca948d1a9bb$var$cloudIdGlobalState,
        cacheLoadedDate: $89cf1ca948d1a9bb$var$cacheLoadedDateGlobalState,
        cdnFileVersion: $89cf1ca948d1a9bb$var$cdnFileVersionGlobalState,
        patternFormat: $89cf1ca948d1a9bb$var$patternFormatGlobalState
    };
};
const $89cf1ca948d1a9bb$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $89cf1ca948d1a9bb$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $89cf1ca948d1a9bb$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $89cf1ca948d1a9bb$var$productGlobalState = overrideProduct;
};
const $89cf1ca948d1a9bb$export$ac7c2edd09656c05 = ()=>{
    $89cf1ca948d1a9bb$var$analyticsEnabledGlobalState = undefined;
    $89cf1ca948d1a9bb$var$productGlobalState = undefined;
    $89cf1ca948d1a9bb$var$webStorageControlsEnabledGlobalState = undefined;
    $89cf1ca948d1a9bb$var$indexedDbControlsEnabledGlobalState = undefined;
    $89cf1ca948d1a9bb$var$disableWebStorageConsentChecksGlobalState = undefined;
    $89cf1ca948d1a9bb$var$localConsentModeGlobalState = undefined;
    $89cf1ca948d1a9bb$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $89cf1ca948d1a9bb$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $89cf1ca948d1a9bb$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $89cf1ca948d1a9bb$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $89cf1ca948d1a9bb$var$userIdGlobalState = undefined;
    $89cf1ca948d1a9bb$var$cloudIdGlobalState = undefined;
    $89cf1ca948d1a9bb$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $bqFvR.resetLogLevelCache)();
    $89cf1ca948d1a9bb$var$cookiesCacheLoader = undefined;
    $89cf1ca948d1a9bb$var$localStorageCacheLoader = undefined;
    $89cf1ca948d1a9bb$var$sessionStorageCacheLoader = undefined;
    $89cf1ca948d1a9bb$var$indexedDBCacheLoader = undefined;
    $89cf1ca948d1a9bb$var$hasInitialized = false;
    $89cf1ca948d1a9bb$var$cacheLoadedDateGlobalState = undefined;
    $89cf1ca948d1a9bb$var$cdnFileVersionGlobalState = undefined;
    $89cf1ca948d1a9bb$var$patternFormatGlobalState = undefined;
    $89cf1ca948d1a9bb$var$resolvedFlatPatternFileFormatGlobalState = undefined;
};
function $89cf1ca948d1a9bb$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $89cf1ca948d1a9bb$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $89cf1ca948d1a9bb$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $89cf1ca948d1a9bb$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $89cf1ca948d1a9bb$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $89cf1ca948d1a9bb$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $89cf1ca948d1a9bb$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $89cf1ca948d1a9bb$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $89cf1ca948d1a9bb$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $89cf1ca948d1a9bb$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $89cf1ca948d1a9bb$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $89cf1ca948d1a9bb$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $89cf1ca948d1a9bb$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $89cf1ca948d1a9bb$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $89cf1ca948d1a9bb$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $89cf1ca948d1a9bb$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $89cf1ca948d1a9bb$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $89cf1ca948d1a9bb$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $89cf1ca948d1a9bb$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $89cf1ca948d1a9bb$var$userIdGlobalState = updates.userIdGlobalState;
    if (updates.cdnFileVersionGlobalState !== undefined) $89cf1ca948d1a9bb$var$cdnFileVersionGlobalState = updates.cdnFileVersionGlobalState;
}
function $89cf1ca948d1a9bb$export$f9550288b9b1f6e3() {
    return $89cf1ca948d1a9bb$var$patternFormatGlobalState;
}
function $89cf1ca948d1a9bb$export$f10a7691f1fb3cb(patternFormat) {
    if ($89cf1ca948d1a9bb$var$patternFormatGlobalState === undefined) $89cf1ca948d1a9bb$var$patternFormatGlobalState = patternFormat;
}
function $89cf1ca948d1a9bb$export$8bf1367cc4bb66da() {
    return $89cf1ca948d1a9bb$var$resolvedFlatPatternFileFormatGlobalState;
}
function $89cf1ca948d1a9bb$export$2bd306fd2b97e710(value) {
    if ($89cf1ca948d1a9bb$var$resolvedFlatPatternFileFormatGlobalState === undefined) $89cf1ca948d1a9bb$var$resolvedFlatPatternFileFormatGlobalState = value;
}
function $89cf1ca948d1a9bb$export$8835d45f445e6ba4() {
    return $89cf1ca948d1a9bb$var$hasInitialized;
}
function $89cf1ca948d1a9bb$export$9dfdd17bbd03b460() {
    return $89cf1ca948d1a9bb$var$productGlobalState;
}
function $89cf1ca948d1a9bb$export$d96c3b0fb6d35c5d() {
    return $89cf1ca948d1a9bb$var$webStorageControlsEnabledGlobalState;
}
function $89cf1ca948d1a9bb$export$c8554d68c78456d3() {
    return $89cf1ca948d1a9bb$var$indexedDbControlsEnabledGlobalState;
}
function $89cf1ca948d1a9bb$export$ea650e4f51ec84d8() {
    return $89cf1ca948d1a9bb$var$disableWebStorageConsentChecksGlobalState;
}
function $89cf1ca948d1a9bb$export$fa1f6ebb49ec4b30() {
    return $89cf1ca948d1a9bb$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $89cf1ca948d1a9bb$export$b60c6437117dfaf9() {
    return $89cf1ca948d1a9bb$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $89cf1ca948d1a9bb$export$cff869f7e58c9036() {
    return $89cf1ca948d1a9bb$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $89cf1ca948d1a9bb$export$491d0e6c401a0697(date) {
    if ($89cf1ca948d1a9bb$var$cacheLoadedDateGlobalState === undefined) $89cf1ca948d1a9bb$var$cacheLoadedDateGlobalState = date;
}
function $89cf1ca948d1a9bb$export$4c4bd5703eacf293(version) {
    if ($89cf1ca948d1a9bb$var$cdnFileVersionGlobalState === undefined) $89cf1ca948d1a9bb$var$cdnFileVersionGlobalState = version;
}
function $89cf1ca948d1a9bb$export$ea32fe1e8610fd3b() {
    return $89cf1ca948d1a9bb$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("cjHoj", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $b60d8c19f2023b70$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $b60d8c19f2023b70$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $b60d8c19f2023b70$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $b60d8c19f2023b70$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $b60d8c19f2023b70$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $b60d8c19f2023b70$export$96e9906d6d93a972);
var $b60d8c19f2023b70$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $b60d8c19f2023b70$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $b60d8c19f2023b70$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $b60d8c19f2023b70$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $b60d8c19f2023b70$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $b60d8c19f2023b70$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $b60d8c19f2023b70$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $b60d8c19f2023b70$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("bqFvR", function(module, exports) {
$parcel$export(module.exports, "determineLogLevel", () => $6531fd2a0f914863$export$5461380538f47d52);
$parcel$export(module.exports, "resetLogLevelCache", () => $6531fd2a0f914863$export$977223726df102da);

var $aEAmK = parcelRequire("aEAmK");

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");

var $lfM2z = parcelRequire("lfM2z");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $6531fd2a0f914863$var$cachedLogLevel;
const $6531fd2a0f914863$export$5461380538f47d52 = ()=>{
    if ($6531fd2a0f914863$var$cachedLogLevel !== undefined) return $6531fd2a0f914863$var$cachedLogLevel;
    $6531fd2a0f914863$var$cachedLogLevel = $6531fd2a0f914863$var$readDebugCookieOverride() ?? $6531fd2a0f914863$var$readInitParamLogLevel() ?? (0, $lfM2z.DEFAULT_LOG_LEVEL);
    return $6531fd2a0f914863$var$cachedLogLevel;
};
const $6531fd2a0f914863$export$977223726df102da = ()=>{
    $6531fd2a0f914863$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $6531fd2a0f914863$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $aEAmK.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $dRkX9.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $lfM2z.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $6531fd2a0f914863$var$readInitParamLogLevel = ()=>{
    return (0, $lfM2z.packageLogLevelStringToEnum)((0, $eqqb5.getBscGlobalState)().packageLogLevel);
};

});
parcelRegister("lfM2z", function(module, exports) {
$parcel$export(module.exports, "LogLevel", () => $0264e08f5d4811c0$export$243e62d78d3b544d);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $0264e08f5d4811c0$export$97d4c6871900dcac);
$parcel$export(module.exports, "packageLogLevelStringToEnum", () => $0264e08f5d4811c0$export$6b31b02af0747fdf);
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $0264e08f5d4811c0$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $0264e08f5d4811c0$export$97d4c6871900dcac = 1;
const $0264e08f5d4811c0$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $0264e08f5d4811c0$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $0264e08f5d4811c0$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};

});



parcelRegister("iPmiQ", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $0074509b00dcc889$export$48d7c418edadb60c);

var $8BjzM = parcelRequire("8BjzM");

var $dRkX9 = parcelRequire("dRkX9");
const $0074509b00dcc889$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $dRkX9.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $8BjzM.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("g5Y6L", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $06b5ea0f0e22793c$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $06b5ea0f0e22793c$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $06b5ea0f0e22793c$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $06b5ea0f0e22793c$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $06b5ea0f0e22793c$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $06b5ea0f0e22793c$export$1ba525b8a711eaac);

var $2mgM4 = parcelRequire("2mgM4");

var $8BjzM = parcelRequire("8BjzM");

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");

var $a7Nyb = parcelRequire("a7Nyb");

var $lvNOB = parcelRequire("lvNOB");

var $6X9WF = parcelRequire("6X9WF");

var $4lHDh = parcelRequire("4lHDh");
const $06b5ea0f0e22793c$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $2mgM4.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $2mgM4.envType).DEV;
    return (0, $2mgM4.envType).PROD;
};
const $06b5ea0f0e22793c$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $06b5ea0f0e22793c$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $06b5ea0f0e22793c$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $06b5ea0f0e22793c$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $06b5ea0f0e22793c$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $06b5ea0f0e22793c$var$decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState$pr;
    const { domain: domain, product: product } = $06b5ea0f0e22793c$export$fce3dd735e04d566();
    const cdnFileVersion = (0, $eqqb5.getBscGlobalState)().cdnFileVersion;
    return {
        packageName: (0, $dRkX9.fg)('platform_bsc_use_generated_package_info') ? (0, $6X9WF.packageName) : (0, $lvNOB.packageName),
        packageVersion: (0, $dRkX9.fg)('platform_bsc_use_generated_package_info') ? (0, $6X9WF.packageVersion) : (0, $lvNOB.packageVersion),
        domain: domain,
        product: ((_getBscGlobalState$pr = (0, $eqqb5.getBscGlobalState)().product) === null || _getBscGlobalState$pr === void 0 ? void 0 : _getBscGlobalState$pr.toLowerCase()) ?? product,
        ...(0, $dRkX9.fg)('platform_bsc_add_cdn_file_version_in_events') && cdnFileVersion && typeof cdnFileVersion === 'object' ? {
            cdnBuildNumber: cdnFileVersion.buildNumber,
            cdnBuildTimestamp: cdnFileVersion.fileCreationTimestamp
        } : {},
        ...attributes && attributes
    };
};
const $06b5ea0f0e22793c$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $eqqb5.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $8BjzM.default)({
                    env: $06b5ea0f0e22793c$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $eqqb5.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $2mgM4.tenantType).CLOUD_ID, (0, $eqqb5.getBscGlobalState)().cloudId);
                if ((0, $eqqb5.getBscGlobalState)().userId) instance.setUserInfo((0, $2mgM4.userType).ATLASSIAN_ACCOUNT, (0, $eqqb5.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $a7Nyb.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $eqqb5.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $06b5ea0f0e22793c$export$5bfe55348e7aebc1(properties) {
    (0, $4lHDh.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $06b5ea0f0e22793c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $06b5ea0f0e22793c$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $06b5ea0f0e22793c$export$c986f0e7f985d67f(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $06b5ea0f0e22793c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $06b5ea0f0e22793c$var$decorateEventAttributes(properties.attributes)
    });
}
function $06b5ea0f0e22793c$export$1aecf263098db667(properties) {
    (0, $4lHDh.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>{
        var _getAnalyticsClient3;
        return (_getAnalyticsClient3 = $06b5ea0f0e22793c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 ? void 0 : _getAnalyticsClient3.sendUIEvent({
            ...properties,
            attributes: $06b5ea0f0e22793c$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $06b5ea0f0e22793c$export$22a3b1671f38a193(properties) {
    (0, $4lHDh.withAnalyticsEventSampling)(properties.name, ()=>{
        var _getAnalyticsClient4;
        return (_getAnalyticsClient4 = $06b5ea0f0e22793c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 ? void 0 : _getAnalyticsClient4.sendScreenEvent({
            ...properties,
            attributes: $06b5ea0f0e22793c$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $06b5ea0f0e22793c$export$1ba525b8a711eaac(properties) {
    const { onSent: onSent, ...eventProperties } = properties;
    (0, $4lHDh.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        const client = $06b5ea0f0e22793c$export$fde53e78fd93a54d();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent({
            ...eventProperties,
            attributes: $06b5ea0f0e22793c$var$decorateEventAttributes(properties.attributes)
        });
        onSent === null || onSent === void 0 || onSent();
    });
}

});
parcelRegister("a7Nyb", function(module, exports) {
$parcel$export(module.exports, "LOG_PREFIX", () => $3a02961b73998416$export$5e28bf885ebebfa6);
$parcel$export(module.exports, "ERROR_EVENT_THROTTLE_INTERVAL_MS", () => $3a02961b73998416$export$aeb1f5aa1188ce28);
$parcel$export(module.exports, "ERROR_EVENT_MAX_PER_SESSION", () => $3a02961b73998416$export$ee3d07c2528881e2);
const $3a02961b73998416$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $3a02961b73998416$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $3a02961b73998416$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

});

parcelRegister("lvNOB", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $62df6cfce84b0b1e$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $62df6cfce84b0b1e$export$91546b032799aa40);
const $62df6cfce84b0b1e$export$9345d7360ffe0722 = undefined ?? '';
const $62df6cfce84b0b1e$export$91546b032799aa40 = undefined ?? '';

});

parcelRegister("6X9WF", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $73fe5eb47c4296f9$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $73fe5eb47c4296f9$export$91546b032799aa40);
// eslint-disable-next-line import/no-extraneous-dependencies

var $85vsp = parcelRequire("85vsp");
const $73fe5eb47c4296f9$export$9345d7360ffe0722 = (0, (/*@__PURE__*/$parcel$interopDefault($85vsp))).name;
const $73fe5eb47c4296f9$export$91546b032799aa40 = (0, (/*@__PURE__*/$parcel$interopDefault($85vsp))).version;

});
parcelRegister("85vsp", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@atlassian/browser-storage-controls\",\"version\":\"11.5.3\",\"description\":\"Package containing utilities and components for collecting and enforcing user preferences on atlassian browser storage (cookies,localstorage, indexedDB etc.)\",\"publishConfig\":{\"registry\":\"https://packages.atlassian.com/api/npm/npm-remote\"},\"repository\":\"https://bitbucket.org/atlassian/atlassian-frontend-monorepo\",\"author\":\"Atlassian Pty Ltd\",\"main\":\"dist/cjs/index.js\",\"module\":\"dist/esm/index.js\",\"module:es2019\":\"dist/es2019/index.js\",\"types\":\"dist/types/index.d.ts\",\"sideEffects\":[\"*.compiled.css\"],\"atlaskit:src\":\"src/index.ts\",\"atlassian\":{\"team\":\"trust-privacy-controls-eng-team\",\"i18n\":true},\"scripts\":{\"webpack-build\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js\",\"ak-postbuild\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js && cp package.json dist/package.json\",\"test\":\"node -r esbuild-register build/ci/test-pipeline/scripts/run-test.ts -c packages/policy-platform/browser-storage-controls/jest.config.js\"},\"dependencies\":{\"@atlaskit/atlassian-context\":\"workspace:^\",\"@atlaskit/button\":\"workspace:^\",\"@atlaskit/checkbox\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlaskit/flag\":\"workspace:^\",\"@atlaskit/form\":\"workspace:^\",\"@atlaskit/heading\":\"workspace:^\",\"@atlaskit/icon\":\"workspace:^\",\"@atlaskit/intl-messages-provider\":\"workspace:^\",\"@atlaskit/modal-dialog\":\"workspace:^\",\"@atlaskit/platform-feature-flags\":\"workspace:^\",\"@atlaskit/primitives\":\"workspace:^\",\"@atlaskit/react-ufo\":\"workspace:^\",\"@atlaskit/tokens\":\"workspace:^\",\"@atlaskit/tooltip\":\"workspace:^\",\"@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls\":\"root:*\",\"@atlassian/atl-context\":\"workspace:^\",\"@atlassian/ufo\":\"workspace:^\",\"@atlassian/ufo-experimental\":\"workspace:^\",\"@atlassiansox/analytics-web-client\":\"workspace:^\",\"@atlassiansox/frontend-feature-encoding\":\"root:*\",\"@babel/runtime\":\"root:*\",\"bind-event-listener\":\"root:*\",\"js-cookie\":\"root:*\",\"react-error-boundary\":\"root:*\",\"react-magnetic-di\":\"root:*\"},\"peerDependencies\":{\"react\":\"^18.2.0\",\"react-dom\":\"^18.2.0\",\"react-intl\":\"^5.25.1 || ^6.0.0 || ^7.0.0\"},\"devDependencies\":{\"@af/integration-testing\":\"workspace:^\",\"@af/visual-regression\":\"workspace:^\",\"@atlaskit/code\":\"workspace:^\",\"@atlaskit/css\":\"workspace:^\",\"@atlaskit/docs\":\"workspace:^\",\"@atlaskit/ssr\":\"workspace:^\",\"@atlaskit/toggle\":\"workspace:^\",\"@atlassian/feature-flags-storybook-utils\":\"workspace:^\",\"@atlassian/feature-flags-test-utils\":\"workspace:^\",\"@atlassian/multi-entry-tools\":\"workspace:^\",\"@atlassian/platform-storybook-helpers\":\"workspace:^\",\"@atlassian/testing-library\":\"workspace:^\",\"@babel/preset-typescript\":\"root:*\",\"@storybook/addon-actions\":\"root:*\",\"@storybook/test\":\"root:*\",\"@testing-library/react\":\"root:*\",\"@testing-library/user-event\":\"root:*\",\"@types/node\":\"root:*\",\"fake-indexeddb\":\"root:*\",\"fetch-mock\":\"root:*\",\"react\":\"root:*\",\"react-dom\":\"root:*\",\"react-intl\":\"root:*\",\"webpack-cli\":\"root:*\"},\"exports\":{\".\":\"./src/index.ts\",\"./banner-controls\":\"./src/controllers/banner-controls/index.ts\",\"./consent-banner\":\"./src/ui/consent-banner/index.tsx\",\"./consent-banner/preference-modal\":\"./src/ui/consent-banner/preference-modal/index.tsx\",\"./constants\":\"./src/constants.ts\",\"./controllers/banner-controls/get-banner-visibility\":\"./src/controllers/banner-controls/get-banner-visibility/index.ts\",\"./controllers/banner-controls/should-banner-render-prefetched\":\"./src/controllers/banner-controls/should-banner-render-prefetched/index.ts\",\"./controllers/banner-controls/should-banner-render\":\"./src/controllers/banner-controls/should-banner-render/index.ts\",\"./controllers/banner-controls/types\":\"./src/controllers/banner-controls/types.ts\",\"./controllers/cookie-controls/delete-cookie\":\"./src/controllers/cookie-controls/delete-cookie/index.ts\",\"./controllers/cookie-controls/get-cookie\":\"./src/controllers/cookie-controls/get-cookie/index.ts\",\"./controllers/cookie-controls/initialize-controls\":\"./src/controllers/cookie-controls/initialize-controls/index.ts\",\"./controllers/cookie-controls/set-cookie\":\"./src/controllers/cookie-controls/set-cookie/index.ts\",\"./controllers/cookie-controls/set-cookie/types\":\"./src/controllers/cookie-controls/set-cookie/types.ts\",\"./controllers/cookie-controls/set-strictly-necessary-cookie\":\"./src/controllers/cookie-controls/set-strictly-necessary-cookie/index.ts\",\"./controllers/cookie-controls/transformer\":\"./src/controllers/cookie-controls/transformer/index.ts\",\"./controllers/preferences-controls/get-preferences\":\"./src/controllers/preferences-controls/get-preferences/index.ts\",\"./controllers/third-party-controls/check-third-party\":\"./src/controllers/third-party-controls/check-third-party/index.ts\",\"./cookie-controls\":\"./src/controllers/cookie-controls/index.ts\",\"./core\":\"./src/common/utils/bsc-global-state/core.ts\",\"./consent-hub-service/types\":\"./src/services/consent-hub-service/types.ts\",\"./consent-hub-service/utils\":\"./src/services/consent-hub-service/utils.ts\",\"./i18n/*\":{\"publish\":null,\"default\":\"./src/i18n/*.ts\"},\"./indexed-db-wrapper-service\":\"./src/services/indexed-db-wrapper-service/index.ts\",\"./indexed-db-wrapper-service/types\":\"./src/services/indexed-db-wrapper-service/types.ts\",\"./types\":\"./src/types.ts\",\"./utils/item-processing\":\"./src/common/utils/item-processing/index.ts\",\"./utils/load-storage-controls-data/constants\":\"./src/common/utils/load-storage-controls-data/constants.ts\",\"./web-storage-service\":\"./src/services/web-storage-service/index.ts\",\"./web-storage-service/types\":\"./src/services/web-storage-service/types.ts\"},\"platform-feature-flags\":{\"platform_bsc_auto_detect_perimeter\":{\"type\":\"boolean\"},\"platform.moonjelly.block-unknown-cookies\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ssr_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ui_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_master_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_debug_mode\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_web_storage_killswitch\":{\"type\":\"boolean\"},\"product-terminology-refresh\":{\"type\":\"boolean\"},\"platform_remove_bsc_overrides\":{\"type\":\"boolean\"},\"platform_bsc_ssr_flat_pattern_file_format\":{\"type\":\"boolean\"},\"platform_bsc_longest_pattern_match_wins\":{\"type\":\"boolean\"},\"platform_bsc_flat_lookup_skip_merge\":{\"type\":\"boolean\"},\"platform_bsc_cleanup_revoked_storage_live_delete\":{\"type\":\"boolean\"},\"platform_bsc_consent_hub_x_origin_app_normalized\":{\"type\":\"boolean\"},\"platform_bsc_browser_extension_detection\":{\"type\":\"boolean\"},\"platform_bsc_consent_bypass_analytics\":{\"type\":\"boolean\"},\"platform_bsc_sync_initialize_controls\":{\"type\":\"boolean\"},\"platform_bsc_use_generated_package_info\":{\"type\":\"boolean\"},\"platform_bsc_add_cdn_file_version_in_events\":{\"type\":\"boolean\"}}}");

});


parcelRegister("4lHDh", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $d38d392f540c4d21$export$67b6e87f323cb6ad);

var $cjHoj = parcelRequire("cjHoj");

var $eqqb5 = parcelRequire("eqqb5");

var $lo8Ay = parcelRequire("lo8Ay");

var $iPmiQ = parcelRequire("iPmiQ");
const $d38d392f540c4d21$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 1000,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    browserExtensionKeysAllowed: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    detectPerimeterError: 1,
    usedAtlBrowserStorageSetItemBscDisabled: 100,
    usedSetCookieMasterKillswitch: 100,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $d38d392f540c4d21$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $d38d392f540c4d21$var$loadSamplingConfig() {
    if ((0, $lo8Ay.cache).cachedSamplingConfig) return (0, $lo8Ay.cache).cachedSamplingConfig;
    if ((0, $iPmiQ.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $eqqb5.getBscGlobalState)();
    const controlsData = await loadCache((0, $cjHoj.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, $lo8Ay.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $d38d392f540c4d21$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($d38d392f540c4d21$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $d38d392f540c4d21$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $d38d392f540c4d21$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $d38d392f540c4d21$export$1138592b3c099377;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $d38d392f540c4d21$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $d38d392f540c4d21$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $d38d392f540c4d21$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $d38d392f540c4d21$export$b286f5e8716d11ad(analyticsEventKey);
    $d38d392f540c4d21$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("lo8Ay", function(module, exports) {
$parcel$export(module.exports, "cache", () => $4935ac53a40a6db1$export$69a3209f1a06c04d);

var $l46Ap = parcelRequire("l46Ap");
const $4935ac53a40a6db1$export$69a3209f1a06c04d = new (0, $l46Ap.CachedSamplingConfig)();

});
parcelRegister("l46Ap", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $ee9bf738a870b880$export$b886edaf6623554a);
class $ee9bf738a870b880$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});




parcelRegister("3k55j", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $d3604c661ca7b613$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $g5Y6L = parcelRequire("g5Y6L");

var $a7Nyb = parcelRequire("a7Nyb");

var $bqFvR = parcelRequire("bqFvR");

var $ei5hA = parcelRequire("ei5hA");

var $lfM2z = parcelRequire("lfM2z");
const $d3604c661ca7b613$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $d3604c661ca7b613$export$efa9a398d6368992 {
    // Console output is controlled solely by the resolved log level. `DEFAULT_LOG_LEVEL` is ERROR,
    // so info/warn/debug stay silent unless a consumer raises `packageLogLevel` or a developer sets
    // the `atl-bsc-debug-mode` cookie. ERROR output is intentionally always on.
    //
    // Keep these guards free of `fg` calls: `Logger.*` runs at module-load time in some consumers
    // (e.g. the AtlIndexedDb singleton), and evaluating a feature gate during a plain import breaks
    // consumers whose tests mock `fg` with a not-yet-initialized factory variable. The one gate this
    // path can still reach is handled in determine-log-level.ts, which checks its cookie first.
    static info(message, metadata) {
        if ((0, $bqFvR.determineLogLevel)() >= (0, $lfM2z.LogLevel).INFO) console.info(`${(0, $a7Nyb.LOG_PREFIX)}: ${message}`, $d3604c661ca7b613$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $bqFvR.determineLogLevel)() >= (0, $lfM2z.LogLevel).WARN) console.warn(`${(0, $a7Nyb.LOG_PREFIX)}: ${message}`, $d3604c661ca7b613$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $bqFvR.determineLogLevel)() >= (0, $lfM2z.LogLevel).ERROR) console.error(`${(0, $a7Nyb.LOG_PREFIX)}: ${message}`, $d3604c661ca7b613$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $bqFvR.determineLogLevel)() >= (0, $lfM2z.LogLevel).DEBUG) console.debug(`${(0, $a7Nyb.LOG_PREFIX)}: DEBUG ${message}`, $d3604c661ca7b613$var$formatMetadata(metadata));
    }
    /**
   * Sends an unsampled operational event to backend telemetry and also emits the message via
   * `Logger.error`. The telemetry send is throttled per-action (see error-event-throttle). The
   * console output is always at ERROR level (subject to the resolved log level).
   */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // shouldSendErrorEvent records the send and limits per-action volume, so a repeatedly
            // failing call site cannot flood telemetry with duplicate events.
            if ((0, $ei5hA.shouldSendErrorEvent)(action)) (0, $g5Y6L.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

});
parcelRegister("ei5hA", function(module, exports) {
$parcel$export(module.exports, "shouldSendErrorEvent", () => $4c22daacbccb9ed7$export$e54335114720f029);

var $a7Nyb = parcelRequire("a7Nyb");
// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $4c22daacbccb9ed7$var$throttleState = new Map();
function $4c22daacbccb9ed7$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $4c22daacbccb9ed7$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $4c22daacbccb9ed7$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $a7Nyb.ERROR_EVENT_MAX_PER_SESSION)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $a7Nyb.ERROR_EVENT_THROTTLE_INTERVAL_MS)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $4c22daacbccb9ed7$export$a5ff37ede5ff9625() {
    $4c22daacbccb9ed7$var$throttleState.clear();
}

});


parcelRegister("jvA59", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $0a5b9eb113836db6$export$259e3a861f28589b);
var $0a5b9eb113836db6$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("7hXtQ", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $492f83ce20e9eea5$export$e612bb1301d659de);

var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");
const $492f83ce20e9eea5$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("k3mGF", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $e8c4bf26d4089154$export$5ee8760f703d9d62);

var $eqqb5 = parcelRequire("eqqb5");
var $g5Y6L = parcelRequire("g5Y6L");

var $ckf9y = parcelRequire("ckf9y");

var $cjHoj = parcelRequire("cjHoj");

var $dODCb = parcelRequire("dODCb");

var $jvA59 = parcelRequire("jvA59");

var $7QI3R = parcelRequire("7QI3R");
const $e8c4bf26d4089154$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $e8c4bf26d4089154$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $jvA59.WebStorageType).LocalStorage ? (0, $cjHoj.CategoryStorageType).LocalStorage : (0, $cjHoj.CategoryStorageType).SessionStorage;
    const disableWebStorageConsentChecks = (0, $eqqb5.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $dODCb.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, $7QI3R.reportSetItemError)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, $cjHoj.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, $ckf9y.isProcessingAllowedByPreferencesMaybeSync)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            if ($e8c4bf26d4089154$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, $g5Y6L.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $7QI3R.reportSetItemError)({
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, $cjHoj.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, $ckf9y.isProcessingAllowedByPreferencesMaybeSync)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    if ($e8c4bf26d4089154$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $dODCb.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $cjHoj.Status).SUCCESS
            };
        } else return {
            status: (0, $cjHoj.Status).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, $7QI3R.reportSetItemError)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, $cjHoj.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("ckf9y", function(module, exports) {
$parcel$export(module.exports, "getItemCategoryFromPassedCache", () => $549698dcaedbe79c$export$69d5b68d01f4a366);
$parcel$export(module.exports, "getItemCategory", () => $549698dcaedbe79c$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isPromise", () => $549698dcaedbe79c$export$4369c812aac99591);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesMaybeSync", () => $549698dcaedbe79c$export$ffbb879d3fefb45c);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $549698dcaedbe79c$export$e7a3dca206fec6e2);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesWithCategory", () => $549698dcaedbe79c$export$17e4a7e00d5b99d9);

var $dRkX9 = parcelRequire("dRkX9");

var $fWQ0G = parcelRequire("fWQ0G");

var $cjHoj = parcelRequire("cjHoj");

var $g5Y6L = parcelRequire("g5Y6L");

var $eqqb5 = parcelRequire("eqqb5");

var $2zjw9 = parcelRequire("2zjw9");

var $3k55j = parcelRequire("3k55j");
/**
 * Narrows a payload to the layout it declares, so the matchers below can be type-checked against a
 * concrete pattern shape rather than casting.
 *
 * An absent `patternFormat` means the legacy trie layout — the format the CDN serves while the
 * flat-format gate is off, and what a payload fetched by a consumer that predates COOK-632 will be.
 * TypeScript cannot infer that rule, so this is the one place it is asserted.
 */ const $549698dcaedbe79c$var$asConcreteCache = (storageControlsData)=>storageControlsData.patternFormat === 'flat' ? storageControlsData : storageControlsData;
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $549698dcaedbe79c$var$compiledRegExpCache = new WeakMap();
const $549698dcaedbe79c$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($549698dcaedbe79c$var$compiledRegExpCache.has(rawPatterns)) return $549698dcaedbe79c$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $3k55j.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $549698dcaedbe79c$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $549698dcaedbe79c$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $549698dcaedbe79c$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $549698dcaedbe79c$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $549698dcaedbe79c$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $549698dcaedbe79c$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $549698dcaedbe79c$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $549698dcaedbe79c$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $549698dcaedbe79c$var$hasOwn = (map, key)=>map !== undefined && Object.prototype.hasOwnProperty.call(map, key);
/**
 * Picks the longer of a product and an 'all' pattern match. A tie can only be the same pattern in
 * both maps (two distinct prefixes or suffixes of equal length cannot both match one key), and the
 * product entry wins it — the value a merge of the two maps would have produced.
 */ const $549698dcaedbe79c$var$pickLongerMatch = (productMatch, allMatch)=>{
    if (productMatch === null) return allMatch;
    if (allMatch === null || productMatch.length >= allMatch.length) return productMatch;
    return allMatch;
};
/**
 * Resolves an item key's category number from a flat payload without merging the 'all' and
 * product maps. Merging allocated four objects per lookup, and the merged regexp object was new
 * every call so `compiledRegExpCache` never hit. Each stage checks the product map before 'all',
 * matching the precedence of the legacy trie path.
 */ const $549698dcaedbe79c$var$findFlatItemCategoryNumber = (itemKey, cache, product)=>{
    var _patterns$regexp, _patterns$regexp2;
    const { keys: keys, patterns: patterns } = cache;
    const productKeys = product ? keys[product] : undefined;
    if ($549698dcaedbe79c$var$hasOwn(productKeys, itemKey)) return productKeys[itemKey];
    const allKeys = keys['all'];
    if ($549698dcaedbe79c$var$hasOwn(allKeys, itemKey)) return allKeys[itemKey];
    const productStartsWith = product ? patterns.startsWith[product] : undefined;
    const allStartsWith = patterns.startsWith['all'];
    const productEndsWith = product ? patterns.endsWith[product] : undefined;
    const allEndsWith = patterns.endsWith['all'];
    if ((0, $dRkX9.fg)('platform_bsc_longest_pattern_match_wins')) {
        const swMatch = $549698dcaedbe79c$var$pickLongerMatch(productStartsWith ? $549698dcaedbe79c$export$4381be1b9fd38456(itemKey, productStartsWith) : null, allStartsWith ? $549698dcaedbe79c$export$4381be1b9fd38456(itemKey, allStartsWith) : null);
        if (swMatch !== null) return swMatch.category;
        const ewMatch = $549698dcaedbe79c$var$pickLongerMatch(productEndsWith ? $549698dcaedbe79c$export$495f1917e0bfb98c(itemKey, productEndsWith) : null, allEndsWith ? $549698dcaedbe79c$export$495f1917e0bfb98c(itemKey, allEndsWith) : null);
        if (ewMatch !== null) return ewMatch.category;
    } else {
        // Compare against null, not truthiness: category 0 (strictly necessary) is a valid match.
        if (productStartsWith) {
            const match = $549698dcaedbe79c$export$915dea35caff63c(itemKey, productStartsWith);
            if (match !== null) return match;
        }
        if (allStartsWith) {
            const match = $549698dcaedbe79c$export$915dea35caff63c(itemKey, allStartsWith);
            if (match !== null) return match;
        }
        if (productEndsWith) {
            const match = $549698dcaedbe79c$export$f6f7882079c4a2cb(itemKey, productEndsWith);
            if (match !== null) return match;
        }
        if (allEndsWith) {
            const match = $549698dcaedbe79c$export$f6f7882079c4a2cb(itemKey, allEndsWith);
            if (match !== null) return match;
        }
    }
    // The payload's own regexp maps are stable objects, so the WeakMap compile cache hits.
    const productRegExp = product ? (_patterns$regexp = patterns.regexp) === null || _patterns$regexp === void 0 ? void 0 : _patterns$regexp[product] : undefined;
    if (productRegExp) {
        const match = $549698dcaedbe79c$export$81a82818a800a999(itemKey, $549698dcaedbe79c$var$compileRegExpPatterns(productRegExp));
        if (match !== null) return match;
    }
    const allRegExp = (_patterns$regexp2 = patterns.regexp) === null || _patterns$regexp2 === void 0 ? void 0 : _patterns$regexp2['all'];
    if (allRegExp) return $549698dcaedbe79c$export$81a82818a800a999(itemKey, $549698dcaedbe79c$var$compileRegExpPatterns(allRegExp));
    return null;
};
/**
 * A matcher can hand back a value that is not a category number when the payload's shape does
 * not match the matcher in use, so the lookup misses. Coalesce that miss to `null` to honour
 * the declared `PreferenceCategory | null` return type; callers treat `null` as uncategorized.
 */ const $549698dcaedbe79c$var$toPreferenceCategory = (itemCategoryNumber, categories)=>{
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $cjHoj.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $cjHoj.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $cjHoj.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $cjHoj.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $cjHoj.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] ?? null : null;
};
const $549698dcaedbe79c$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName === null || productName === void 0 ? void 0 : productName.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    // The payload states its own format, recorded when it was fetched. Re-evaluating the flat-format
    // rollout gate here could disagree with the gate value that chose the file we actually fetched — an
    // unresolved Statsig client, a stale cross-request SSR cache entry, or a gate flip mid-session — and
    // the losing matcher silently returns null for every pattern rather than erroring. The gate stays
    // the sole input to the *fetch* decision.
    const cache = $549698dcaedbe79c$var$asConcreteCache(storageControlsData);
    if (cache.patternFormat === 'flat' && (0, $dRkX9.fg)('platform_bsc_flat_lookup_skip_merge')) return $549698dcaedbe79c$var$toPreferenceCategory($549698dcaedbe79c$var$findFlatItemCategoryNumber(itemKey, cache, downcasedProduct), categories);
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if (cache.patternFormat === 'flat') {
        // Flat prefix/suffix maps merge cleanly, because each key is a whole pattern rather than one
        // character of one.
        const productStartsWithPatterns = {
            ...cache.patterns.startsWith['all'],
            ...downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : {}
        };
        const productEndsWithPatterns = {
            ...cache.patterns.endsWith['all'],
            ...downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : {}
        };
        if ((0, $dRkX9.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $549698dcaedbe79c$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $549698dcaedbe79c$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $549698dcaedbe79c$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $549698dcaedbe79c$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
    } else {
        // Legacy trie matching path. We search the product trie first and fall back
        // to the 'all' trie; a merged trie is unsafe because a shared first character
        // silently drops the entire 'all' subtree under it (HOT-303432).
        const productStartsWith = downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : undefined;
        const productEndsWith = downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : undefined;
        const allStartsWith = cache.patterns.startsWith['all'];
        const allEndsWith = cache.patterns.endsWith['all'];
        if (productStartsWith) itemCategoryNumber = $549698dcaedbe79c$export$2c141b1c00f3e482(itemKey, productStartsWith);
        if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $549698dcaedbe79c$export$2c141b1c00f3e482(itemKey, allStartsWith);
        if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $549698dcaedbe79c$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
        if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $549698dcaedbe79c$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
    }
    // RegExp fallback, applied to both the flat and legacy trie pattern paths
    if (itemCategoryNumber === null) {
        var _patterns$regexp3, _patterns$regexp4;
        const rawRegExpPatterns = {
            ...(_patterns$regexp3 = patterns.regexp) === null || _patterns$regexp3 === void 0 ? void 0 : _patterns$regexp3['all'],
            ...downcasedProduct ? (_patterns$regexp4 = patterns.regexp) === null || _patterns$regexp4 === void 0 ? void 0 : _patterns$regexp4[downcasedProduct] : {}
        };
        const compiledPatterns = $549698dcaedbe79c$var$compileRegExpPatterns(rawRegExpPatterns);
        itemCategoryNumber = $549698dcaedbe79c$export$81a82818a800a999(itemKey, compiledPatterns);
    }
    return $549698dcaedbe79c$var$toPreferenceCategory(itemCategoryNumber, categories);
};
const $549698dcaedbe79c$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $eqqb5.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $549698dcaedbe79c$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $549698dcaedbe79c$export$4369c812aac99591 = (value)=>value != null && typeof value.then === 'function';
const $549698dcaedbe79c$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $eqqb5.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if ($549698dcaedbe79c$export$4369c812aac99591(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $549698dcaedbe79c$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $549698dcaedbe79c$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $549698dcaedbe79c$var$getEffectiveCategory(category) {
    if (category === null) return (0, $cjHoj.PreferenceCategory).Marketing;
    return category;
}
function $549698dcaedbe79c$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    const effectiveCategory = $549698dcaedbe79c$var$getEffectiveCategory(category);
    if (!!preferences) {
        if (!!effectiveCategory) return preferences[effectiveCategory];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $549698dcaedbe79c$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $cjHoj.PreferenceCategory).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($549698dcaedbe79c$export$4369c812aac99591(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $549698dcaedbe79c$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $549698dcaedbe79c$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $549698dcaedbe79c$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $549698dcaedbe79c$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $fWQ0G.getPreferencesMaybeSync)();
    if ($549698dcaedbe79c$export$4369c812aac99591(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$549698dcaedbe79c$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $549698dcaedbe79c$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $549698dcaedbe79c$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $549698dcaedbe79c$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    const handleDecision = ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory }, wasAsync)=>{
        if (shouldProcessItem) {
            allowedCallback === null || allowedCallback === void 0 || allowedCallback({
                wasAsync: wasAsync
            });
            return shouldProcessItem;
        }
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $2zjw9.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $g5Y6L.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback === null || allowedCallback === void 0 || allowedCallback({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback === null || blockedCallback === void 0 || blockedCallback({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
        return shouldProcessItem;
    };
    if ($549698dcaedbe79c$export$4369c812aac99591(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then((categoryAndPreference)=>handleDecision(categoryAndPreference, true));
    else return handleDecision(categoryAndPreferenceOrPromise, false);
};
const $549698dcaedbe79c$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = $549698dcaedbe79c$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($549698dcaedbe79c$export$4369c812aac99591(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback === null || allowedCallback === void 0 || allowedCallback({
        wasAsync: wasAsync
    });
    else {
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $2zjw9.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $g5Y6L.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback === null || allowedCallback === void 0 || allowedCallback({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback === null || blockedCallback === void 0 || blockedCallback({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
    }
    return shouldProcessItem;
};
const $549698dcaedbe79c$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $549698dcaedbe79c$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($549698dcaedbe79c$export$4369c812aac99591(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    // Check if blocked item is from extension
    if (!shouldProcessItem) {
        const extensionCaller = itemCategory === null ? (0, $2zjw9.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $g5Y6L.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            return {
                isAllowed: true,
                itemCategory: itemCategory
            };
        }
    }
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};

});
parcelRegister("fWQ0G", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $a133dc521de91762$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $a133dc521de91762$export$39c2cb6e65c1c16b);

var $eqqb5 = parcelRequire("eqqb5");
var $iPmiQ = parcelRequire("iPmiQ");

var $2jQ6M = parcelRequire("2jQ6M");

var $kvl06 = parcelRequire("kvl06");

var $k8XFy = parcelRequire("k8XFy");

var $dzMIZ = parcelRequire("dzMIZ");
async function $a133dc521de91762$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $eqqb5.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $k8XFy.getCookie)((0, $2jQ6M.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $dzMIZ.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $kvl06.getConsentToken)();
            if ((0, $iPmiQ.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $dzMIZ.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $dzMIZ.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $a133dc521de91762$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $eqqb5.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $k8XFy.getCookie)((0, $2jQ6M.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $dzMIZ.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $kvl06.getConsentToken)().then((consentToken)=>{
            if ((0, $iPmiQ.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $dzMIZ.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $dzMIZ.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("2jQ6M", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $ed3a82a17564b45e$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $ed3a82a17564b45e$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $ed3a82a17564b45e$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $ed3a82a17564b45e$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $ed3a82a17564b45e$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $ed3a82a17564b45e$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $ed3a82a17564b45e$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $ed3a82a17564b45e$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $ed3a82a17564b45e$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $ed3a82a17564b45e$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $ed3a82a17564b45e$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $ed3a82a17564b45e$export$31deaeaebce525bb);

var $cjHoj = parcelRequire("cjHoj");
const $ed3a82a17564b45e$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $ed3a82a17564b45e$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $ed3a82a17564b45e$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $ed3a82a17564b45e$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $ed3a82a17564b45e$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $ed3a82a17564b45e$export$37073d560ecebada = 'atl-testing-consents';
const $ed3a82a17564b45e$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $ed3a82a17564b45e$export$b28b5d760fe14a21 = {
    [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $cjHoj.PreferenceCategory).Functional]: true,
    [(0, $cjHoj.PreferenceCategory).Marketing]: true,
    [(0, $cjHoj.PreferenceCategory).Analytics]: true,
    [(0, $cjHoj.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $ed3a82a17564b45e$export$4a12f9e99971760a = {
    [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $cjHoj.PreferenceCategory).Functional]: false,
    [(0, $cjHoj.PreferenceCategory).Marketing]: false,
    [(0, $cjHoj.PreferenceCategory).Analytics]: false,
    [(0, $cjHoj.PreferenceCategory).Unknown]: false
};
const $ed3a82a17564b45e$export$f0fd1d13ec1d48f2 = {
    ...$ed3a82a17564b45e$export$4a12f9e99971760a,
    [(0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $ed3a82a17564b45e$export$f95182b7aa141c57 = '001';
const $ed3a82a17564b45e$export$1f25427b34f9c405 = '002';
const $ed3a82a17564b45e$export$31deaeaebce525bb = '003';

});

parcelRegister("kvl06", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $c354490f801853ad$export$f1b8f2ca713fca08);

var $2jQ6M = parcelRequire("2jQ6M");

var $k8XFy = parcelRequire("k8XFy");

var $3RTmK = parcelRequire("3RTmK");

var $9W30i = parcelRequire("9W30i");

var $8dLIX = parcelRequire("8dLIX");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $c354490f801853ad$var$inFlightConsentToken = null;
const $c354490f801853ad$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $8dLIX.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $3RTmK.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $k8XFy.getCookie)((0, $2jQ6M.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $9W30i.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $9W30i.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $9W30i.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $c354490f801853ad$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($c354490f801853ad$var$inFlightConsentToken) return $c354490f801853ad$var$inFlightConsentToken;
    $c354490f801853ad$var$inFlightConsentToken = $c354490f801853ad$var$_getConsentToken().finally(()=>{
        $c354490f801853ad$var$inFlightConsentToken = null;
    });
    return $c354490f801853ad$var$inFlightConsentToken;
};

});
parcelRegister("k8XFy", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $7aab26349d37aab6$export$4be65e66cfa2648a);

var $aEAmK = parcelRequire("aEAmK");

var $dRkX9 = parcelRequire("dRkX9");

var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");
function $7aab26349d37aab6$export$4be65e66cfa2648a(key) {
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $aEAmK.default).get(key) : (0, $aEAmK.default).get();
    try {
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $aEAmK.default).get(key) : (0, $aEAmK.default).get();
    } catch (e) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("3RTmK", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $ebe399a05dbb8c1d$export$b5282052fc15e1ae);

var $2jQ6M = parcelRequire("2jQ6M");

var $k8XFy = parcelRequire("k8XFy");
const $ebe399a05dbb8c1d$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $k8XFy.getCookie)((0, $2jQ6M.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("9W30i", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $2185193525f4253b$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $2185193525f4253b$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $2185193525f4253b$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $2185193525f4253b$export$b3365240280cb3c3);

var $13hRO = parcelRequire("13hRO");
var $3k55j = parcelRequire("3k55j");

var $2jQ6M = parcelRequire("2jQ6M");

var $kcA52 = parcelRequire("kcA52");

var $fIv8k = parcelRequire("fIv8k");
const $2185193525f4253b$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $2185193525f4253b$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $2185193525f4253b$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($2185193525f4253b$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $2185193525f4253b$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $2185193525f4253b$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $2185193525f4253b$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $2185193525f4253b$export$6e0b780517c88191();
const $2185193525f4253b$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + $2185193525f4253b$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES * 60000);
    return expiryDate;
};
const $2185193525f4253b$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $fIv8k.setStrictlyNecessaryCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $2185193525f4253b$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $3k55j.Logger).debug(`Set Consent Token ${(0, $2jQ6M.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $2185193525f4253b$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $fIv8k.setStrictlyNecessaryCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $3k55j.Logger).debug(`set fallback consent token: ${(0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $2185193525f4253b$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $kcA52.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $13hRO.getBitValueFromBool)(!!bannerVisibility);
    (0, $fIv8k.setStrictlyNecessaryCookie)((0, $2jQ6M.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $2185193525f4253b$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $3k55j.Logger).debug(`set shouldShowBannerCookie: ${(0, $2jQ6M.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $2185193525f4253b$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $2185193525f4253b$export$8e560d0760f733a2(consentToken);
    $2185193525f4253b$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("13hRO", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $38ca144d5991b006$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $38ca144d5991b006$export$27647458f3cf29d2);
const $38ca144d5991b006$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $38ca144d5991b006$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("kcA52", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $ce9089f6acf11415$export$bfdb9f82a9194c1e);

var $aEAmK = parcelRequire("aEAmK");

var $iPmiQ = parcelRequire("iPmiQ");

var $13hRO = parcelRequire("13hRO");

var $2jQ6M = parcelRequire("2jQ6M");

var $lmMgc = parcelRequire("lmMgc");

var $k8XFy = parcelRequire("k8XFy");

var $dzMIZ = parcelRequire("dzMIZ");
const $ce9089f6acf11415$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $dzMIZ.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $ce9089f6acf11415$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $ce9089f6acf11415$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $13hRO.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $lmMgc.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $ce9089f6acf11415$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $lmMgc.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $ce9089f6acf11415$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $lmMgc.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $ce9089f6acf11415$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $ce9089f6acf11415$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $13hRO.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $lmMgc.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $ce9089f6acf11415$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $lmMgc.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $ce9089f6acf11415$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $lmMgc.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $ce9089f6acf11415$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $aEAmK.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $iPmiQ.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $ce9089f6acf11415$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $13hRO.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $ce9089f6acf11415$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $ce9089f6acf11415$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("lmMgc", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $98d1be5a814e1d82$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $98d1be5a814e1d82$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $98d1be5a814e1d82$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $98d1be5a814e1d82$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $98d1be5a814e1d82$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $98d1be5a814e1d82$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $98d1be5a814e1d82$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $98d1be5a814e1d82$export$a79c0ea3d7c2444a);

var $13hRO = parcelRequire("13hRO");

var $2jQ6M = parcelRequire("2jQ6M");

var $k8XFy = parcelRequire("k8XFy");

var $cjHoj = parcelRequire("cjHoj");

var $2Rc1Z = parcelRequire("2Rc1Z");
const $98d1be5a814e1d82$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $2jQ6M.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $98d1be5a814e1d82$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $2jQ6M.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $98d1be5a814e1d82$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($98d1be5a814e1d82$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $98d1be5a814e1d82$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $98d1be5a814e1d82$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $98d1be5a814e1d82$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $98d1be5a814e1d82$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $13hRO.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $98d1be5a814e1d82$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $2jQ6M.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $2jQ6M.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $cjHoj.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $13hRO.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $13hRO.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $13hRO.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $98d1be5a814e1d82$export$42a0b3fb1e53e7b9 = (consents)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $2jQ6M.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $13hRO.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $2Rc1Z.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $13hRO.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $2Rc1Z.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $13hRO.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $2Rc1Z.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $13hRO.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $2Rc1Z.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $98d1be5a814e1d82$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $98d1be5a814e1d82$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $98d1be5a814e1d82$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $98d1be5a814e1d82$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $98d1be5a814e1d82$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $cjHoj.PreferenceCategory).StrictlyNecessary,
        (0, $cjHoj.PreferenceCategory).Functional,
        (0, $cjHoj.PreferenceCategory).Analytics,
        (0, $cjHoj.PreferenceCategory).Marketing,
        (0, $cjHoj.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: (0, $2Rc1Z.ConsentHubKey).StrictlyNecessary,
        [(0, $cjHoj.PreferenceCategory).Functional]: (0, $2Rc1Z.ConsentHubKey).Functional,
        [(0, $cjHoj.PreferenceCategory).Analytics]: (0, $2Rc1Z.ConsentHubKey).Analytics,
        [(0, $cjHoj.PreferenceCategory).Marketing]: (0, $2Rc1Z.ConsentHubKey).Marketing,
        [(0, $cjHoj.PreferenceCategory).Unknown]: (0, $2Rc1Z.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $98d1be5a814e1d82$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $98d1be5a814e1d82$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $98d1be5a814e1d82$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $98d1be5a814e1d82$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $98d1be5a814e1d82$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $98d1be5a814e1d82$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $98d1be5a814e1d82$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("2Rc1Z", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $0a0915d575ffa0f6$export$31140359b1e505cf);
var $0a0915d575ffa0f6$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("dzMIZ", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $ff10e44cebf826fc$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $ff10e44cebf826fc$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $ff10e44cebf826fc$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initializePreferencesData", () => $ff10e44cebf826fc$export$7962405c3ca274b1);

var $eqqb5 = parcelRequire("eqqb5");

var $13hRO = parcelRequire("13hRO");

var $2jQ6M = parcelRequire("2jQ6M");

var $lmMgc = parcelRequire("lmMgc");

var $cjHoj = parcelRequire("cjHoj");
const $ff10e44cebf826fc$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $2jQ6M.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $2jQ6M.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $2jQ6M.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $2jQ6M.V001_SCHEMA_KEY),
        (0, $2jQ6M.V002_SCHEMA_KEY),
        (0, $2jQ6M.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $ff10e44cebf826fc$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $2jQ6M.V001_SCHEMA_KEY);
    return [
        version,
        (0, $13hRO.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $13hRO.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $13hRO.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $13hRO.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $ff10e44cebf826fc$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $cjHoj.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $cjHoj.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $cjHoj.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $cjHoj.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $ff10e44cebf826fc$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $2jQ6M.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $cjHoj.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $cjHoj.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $cjHoj.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $cjHoj.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Functional]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Analytics]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Marketing]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Unknown]),
        (0, $13hRO.getBitValueFromBool)(isDefaultConsentBit),
        (0, $13hRO.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $13hRO.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $ff10e44cebf826fc$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $lmMgc.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$ff10e44cebf826fc$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $ff10e44cebf826fc$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $2jQ6M.V003_SCHEMA_KEY);
    return [
        version,
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Functional]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Analytics]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Marketing]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.PreferenceCategory).Unknown]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $13hRO.getBitValueFromBool)(userPreferences[(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $ff10e44cebf826fc$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $cjHoj.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $cjHoj.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $cjHoj.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $cjHoj.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $ff10e44cebf826fc$var$V002SpecificBitKeys = [
    (0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $cjHoj.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $cjHoj.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $cjHoj.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $cjHoj.ConsentPreferenceV2).ConsentedUnderFADP
];
const $ff10e44cebf826fc$var$V003SpecificBitKeys = [
    (0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault,
    (0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated,
    (0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable
];
function $ff10e44cebf826fc$export$3199823fec979bd1(userPreferences) {
    if ((0, $eqqb5.getBscGlobalState)().localConsentMode) return $ff10e44cebf826fc$var$packPrefsVersion001(userPreferences);
    const isV002 = $ff10e44cebf826fc$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $ff10e44cebf826fc$var$packPrefsVersion002(userPreferences);
    const isV003 = $ff10e44cebf826fc$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $ff10e44cebf826fc$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $ff10e44cebf826fc$var$packPrefsVersion001(userPreferences);
}
function $ff10e44cebf826fc$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $eqqb5.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $2jQ6M.V001_SCHEMA_KEY)) return $ff10e44cebf826fc$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $ff10e44cebf826fc$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $ff10e44cebf826fc$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $ff10e44cebf826fc$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $ff10e44cebf826fc$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $ff10e44cebf826fc$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $ff10e44cebf826fc$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $cjHoj.PrefetchedPreferenceState).INTERNAL) {
        if ($ff10e44cebf826fc$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $ff10e44cebf826fc$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $lmMgc.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $ff10e44cebf826fc$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $cjHoj.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("fIv8k", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $5883453adaa6c0b9$export$93509ff9a62ee022);

var $aEAmK = parcelRequire("aEAmK");

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");
var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");
const $5883453adaa6c0b9$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $aEAmK.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $eqqb5.getBscGlobalState)().hasInitialized) (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $aEAmK.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});


parcelRegister("8dLIX", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $31001c7610ba2cef$export$c515de1cc9cebc71);

var $2jQ6M = parcelRequire("2jQ6M");

var $cXyAq = parcelRequire("cXyAq");

var $dzMIZ = parcelRequire("dzMIZ");
const $31001c7610ba2cef$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $cXyAq.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $dzMIZ.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $2jQ6M.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("cXyAq", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $78f4f33916a86f08$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $78f4f33916a86f08$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $78f4f33916a86f08$export$f8422650c3dec8b2);

var $dRkX9 = parcelRequire("dRkX9");

var $3k55j = parcelRequire("3k55j");

var $eqqb5 = parcelRequire("eqqb5");

var $lmMgc = parcelRequire("lmMgc");
const $78f4f33916a86f08$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $78f4f33916a86f08$var$POST_CONSENTS_URL = `${$78f4f33916a86f08$var$BASE_CONSENTS_URL}/user`;
const $78f4f33916a86f08$var$GET_CONSENTS_URL = `${$78f4f33916a86f08$var$POST_CONSENTS_URL}/consents/cookies`;
const $78f4f33916a86f08$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        'X-Request-Origin': 'bsc',
        'X-Request-Origin-App': $78f4f33916a86f08$var$getProductForConsentHubHeader()
    });
const $78f4f33916a86f08$var$getProductForConsentHubHeader = ()=>{
    const product = (0, $eqqb5.getBscGlobalState)().product;
    if (!product || product === 'all') return 'unknown';
    if ((0, $dRkX9.fg)('platform_bsc_consent_hub_x_origin_app_normalized')) // ConsentHub buckets anything that is not lowercase and hyphen-separated as `unknown`.
    return product.toLowerCase().replace(/\s+/g, '-');
    return product;
};
const $78f4f33916a86f08$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $lmMgc.serializeConsents)(consentData);
        const consentTimestamp = (0, $lmMgc.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $lmMgc.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $78f4f33916a86f08$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$78f4f33916a86f08$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $78f4f33916a86f08$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $78f4f33916a86f08$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $78f4f33916a86f08$export$bd9f5bcbf9cd947c();
    }
};
const $78f4f33916a86f08$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $lmMgc.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $78f4f33916a86f08$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$78f4f33916a86f08$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $78f4f33916a86f08$var$getConsentHubHeaders(),
            body: $78f4f33916a86f08$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $lmMgc.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});




parcelRegister("2zjw9", function(module, exports) {
$parcel$export(module.exports, "captureCallerSignals", () => $3bef16969a406d5e$export$9a9299a14dc0c1cb);
$parcel$export(module.exports, "attributeExtensionCaller", () => $3bef16969a406d5e$export$9674893ac982a3cc);
// Detects storage writes made by browser extensions so consent enforcement doesn't block them.
// Chromium family (Chrome, Chromium Edge, Brave, Opera) all use `chrome-extension://`.
// Firefox uses `moz-extension://`; Safari uses `safari-web-extension://`.
// `ms-browser-extension://` is the legacy EdgeHTML
const $3bef16969a406d5e$export$99d1f70e3d2681ed = /(chrome-extension|moz-extension|safari-web-extension|ms-browser-extension):\/\/([^/)\s]+)/;
// A frame's script location, minus the `:line:column`. Matches V8's `at fn (url:1:2)` and
// SpiderMonkey/JavaScriptCore's `fn@url:1:2`.
const $3bef16969a406d5e$var$FRAME_LOCATION = /([a-z][a-z0-9+.-]*:\/\/[^\s)]+?)(?::\d+){0,2}\)?$/i;
// A frame line, not the `Error: ` header V8 prefixes the trace with. V8 starts frames with `at `; the
// other engines use `name@url` and emit no header, so filtering keeps indices comparable.
const $3bef16969a406d5e$var$FRAME_LINE = /^at\s|@/;
// How many leading frames can hold the code that made the write. BSC sits 2 frames above the caller —
// `captureCallerSignals` and the override closure — and neither can be inlined away: the closure is the
// value installed on `setItem`/the cookie accessor, and a minifier won't inline a function containing
// try/catch. The capture is deliberately one function for that reason.
//
// Bounding the scan is the point of this module. Matching an extension URL anywhere in the stack also
// matches every write made by Atlassian code that an extension merely called into, which turns the
// extension allowance into a blanket consent bypass for our own writes.
const $3bef16969a406d5e$var$ORIGINATOR_FRAME_WINDOW = 3;
// Nothing past the window is read. V8 defaults to 10 and a product can lower it, so pin it.
const $3bef16969a406d5e$var$CAPTURED_FRAME_LIMIT = 6;
const $3bef16969a406d5e$var$parseFrames = (stack)=>stack.split('\n').map((line)=>line.trim()).filter((line)=>$3bef16969a406d5e$var$FRAME_LINE.test(line));
const $3bef16969a406d5e$var$asExtensionCaller = (frame)=>{
    var _frame$match;
    const extension = frame === null || frame === void 0 || (_frame$match = frame.match($3bef16969a406d5e$var$FRAME_LOCATION)) === null || _frame$match === void 0 || (_frame$match = _frame$match[1]) === null || _frame$match === void 0 ? void 0 : _frame$match.match($3bef16969a406d5e$export$99d1f70e3d2681ed);
    return extension ? {
        scheme: extension[1],
        id: extension[2]
    } : null;
};
const $3bef16969a406d5e$export$d5f56ab842d0792b = (captured)=>{
    const stack = captured === null || captured === void 0 ? void 0 : captured.stack;
    if (!stack) return null;
    for (const frame of $3bef16969a406d5e$var$parseFrames(stack).slice(0, $3bef16969a406d5e$var$ORIGINATOR_FRAME_WINDOW)){
        const caller = $3bef16969a406d5e$var$asExtensionCaller(frame);
        if (caller) return caller;
    }
    return null;
};
const $3bef16969a406d5e$export$9a9299a14dc0c1cb = ()=>{
    try {
        const previousLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = $3bef16969a406d5e$var$CAPTURED_FRAME_LIMIT;
        const stack = new Error();
        Error.stackTraceLimit = previousLimit;
        return {
            stack: stack
        };
    } catch  {
        return {
            stack: new Error()
        };
    }
};
const $3bef16969a406d5e$export$9674893ac982a3cc = (signals)=>signals ? $3bef16969a406d5e$export$d5f56ab842d0792b(signals.stack) : null;

});


parcelRegister("dODCb", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $e948d7ecff487258$export$ff3c91e80f54f26c);

var $cjHoj = parcelRequire("cjHoj");
class $e948d7ecff487258$var$ItemKeyCacheService {
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $cjHoj.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $e948d7ecff487258$export$ff3c91e80f54f26c = new $e948d7ecff487258$var$ItemKeyCacheService();

});

parcelRegister("7QI3R", function(module, exports) {
$parcel$export(module.exports, "reportSetItemError", () => $9807178bf5dd9525$export$ba6a684424c69e54);

var $3k55j = parcelRequire("3k55j");
/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const $9807178bf5dd9525$var$isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name: name, code: code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const $9807178bf5dd9525$export$ba6a684424c69e54 = ({ message: message, attributes: attributes, error: error })=>{
    if ($9807178bf5dd9525$var$isQuotaExceededError(error)) {
        (0, $3k55j.Logger).error(message);
        return;
    }
    (0, $3k55j.Logger).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message: message,
        attributes: attributes
    });
};

});


parcelRegister("isStc", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $ac1db49e7cf3e4af$export$f1b0c189562aa9fd);

var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");

var $cjHoj = parcelRequire("cjHoj");

var $dODCb = parcelRequire("dODCb");

var $jvA59 = parcelRequire("jvA59");
const $ac1db49e7cf3e4af$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, $dODCb.ItemKeyCache).markSetByPackage(storageType === (0, $jvA59.WebStorageType).LocalStorage ? (0, $cjHoj.CategoryStorageType).LocalStorage : (0, $cjHoj.CategoryStorageType).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, $cjHoj.Status).SUCCESS;
    } catch (e) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $cjHoj.Status).FAILED;
    }
};

});


parcelRegister("7xlLS", function(module, exports) {
$parcel$export(module.exports, "safeAccessWithErrorHandler", () => $87f9839e2f913c40$export$d1415594ea5ec958);
const $87f9839e2f913c40$export$d1415594ea5ec958 = (action, errorCase)=>{
    try {
        return action();
    } catch (err) {
        return errorCase && errorCase();
    }
};

});


parcelRegister("3C1PA", function(module, exports) {
$parcel$export(module.exports, "LOG_OUT", () => $04820d212a55237c$export$cb307dad255adf47);
$parcel$export(module.exports, "logOutAction", () => $04820d212a55237c$export$1a3865346be34527);
const $04820d212a55237c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $04820d212a55237c$export$1a3865346be34527 = ()=>{
    return {
        type: $04820d212a55237c$export$cb307dad255adf47
    };
};

});


parcelRegister("5j5Xz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0fc664469ac77ba$export$2e2bcd8739ae039);
parcelRequire("e19ob");
var $eSm63 = parcelRequire("eSm63");

var $2cjT0 = parcelRequire("2cjT0");

var $iG5NL = parcelRequire("iG5NL");

var $evXYl = parcelRequire("evXYl");

var $dYLB0 = parcelRequire("dYLB0");

var $4hXnv = parcelRequire("4hXnv");

var $gXv2g = parcelRequire("gXv2g");

var $51AoQ = parcelRequire("51AoQ");

var $fTN62 = parcelRequire("fTN62");

var $3TIdz = parcelRequire("3TIdz");

var $7Rjp7 = parcelRequire("7Rjp7");

var $GW3Bm = parcelRequire("GW3Bm");

var $3CpLJ = parcelRequire("3CpLJ");

var $jp9ha = parcelRequire("jp9ha");

var $d9wAa = parcelRequire("d9wAa");

var $5i23l = parcelRequire("5i23l");

var $lRMAu = parcelRequire("lRMAu");

var $ka5yY = parcelRequire("ka5yY");

var $5aitR = parcelRequire("5aitR");

var $4BzGi = parcelRequire("4BzGi");

var $4QT8R = parcelRequire("4QT8R");

var $k3HpB = parcelRequire("k3HpB");

var $bADwM = parcelRequire("bADwM");

var $iFYPT = parcelRequire("iFYPT");

var $cCChy = parcelRequire("cCChy");

var $faaon = parcelRequire("faaon");

var $btn7V = parcelRequire("btn7V");

var $52CG5 = parcelRequire("52CG5");
var // Need to force typescript to pick up the right combineEpics
$f0fc664469ac77ba$export$2e2bcd8739ae039 = (0, $eSm63.combineEpics)((0, $7Rjp7.helpCenterBrandingEpic), (0, $7Rjp7.helpCenterEpic), (0, $7Rjp7.invalidateHelpCenterBrandingEpic), (0, $ka5yY.portalEpic), (0, $ka5yY.portalUploadMediaTokenEpic), (0, $ka5yY.refreshPortalUploadMediaTokenBeforeExpiryEpic), (0, $2cjT0.default), (0, $lRMAu.organisationsEpic), (0, $5aitR.requestCreateEpic), (0, $bADwM.requestTypeSuggestionEpic), (0, $51AoQ.connectFragmentsEpic), (0, $3CpLJ.default), (0, $GW3Bm.default), (0, $btn7V.unsubscribedConfirmationEpic), (0, $d9wAa.loginEpic), (0, $5i23l.loginAnnouncementsEpic), (0, $3TIdz.forgotPasswordEpic), (0, $4hXnv.fetchArticleEpic), (0, $4BzGi.requestDetailsEpic), (0, $k3HpB.reqSlasEpic), (0, $4QT8R.requestListEpic), (0, $iFYPT.requestsColumnSettingsEpic), (0, $dYLB0.approvalListEpic), (0, $jp9ha.languagesEpic), (0, $cCChy.timezoneRegionsEpic), (0, $cCChy.timezonesEpic), (0, $51AoQ.profileConnectFragmentsEpic), (0, $52CG5.visitPortalEpic), (0, $gXv2g.completeSignupEpic), (0, $iG5NL.default), (0, $fTN62.featuredAndSortedPortalsEpic), (0, $evXYl.aiAnswerFeedbackPageEpic), (0, $faaon.uiModificationsEpic));

});
parcelRegister("2cjT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e66cfc8b0572730$export$2e2bcd8739ae039);

var $jFk35 = parcelRequire("jFk35");
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");

var $b4gcU = parcelRequire("b4gcU");

var $fecgs = parcelRequire("fecgs");
const $5e66cfc8b0572730$var$epic = (action$)=>{
    return action$.ofType((0, $fecgs.FETCH_USER_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).map((response)=>{
            // If we requested for a user model but never got one or got an empty user object we assume that the user is anonymous.
            if (!response.user || !response.user.accountId) return (0, $7m3Xa.updateUserModelAnonymousAction)();
            return (0, $7m3Xa.updateUserModelAction)(response.user);
        }).catch(()=>(0, $jFk35.Observable).never()));
};
var $5e66cfc8b0572730$export$2e2bcd8739ae039 = $5e66cfc8b0572730$var$epic;

});
parcelRegister("fecgs", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_MODEL", () => $bdb4ff8a7387a4f9$export$d79dd8ba2ab60f61);
$parcel$export(module.exports, "fetchUserModelAction", () => $bdb4ff8a7387a4f9$export$d4f34f8f1b2704a8);

var $dv0hN = parcelRequire("dv0hN");
const $bdb4ff8a7387a4f9$export$d79dd8ba2ab60f61 = 'epic.model.FETCH_USER_MODEL';
const $bdb4ff8a7387a4f9$export$d4f34f8f1b2704a8 = (params = {})=>{
    const excludeRequestCountsParam = {
        ...params,
        fetchRequestCounts: false
    };
    return (0, $dv0hN.buildModelsActionCreator)($bdb4ff8a7387a4f9$export$d79dd8ba2ab60f61, 'user')(excludeRequestCountsParam);
};

});


parcelRegister("iG5NL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5becda2cade3c34b$export$2e2bcd8739ae039);

var $jFk35 = parcelRequire("jFk35");

var $7m3Xa = parcelRequire("7m3Xa");

var $b4gcU = parcelRequire("b4gcU");

var $haEws = parcelRequire("haEws");
const $5becda2cade3c34b$var$fetchUserRequestsCountsEpic = (action$)=>{
    return action$.ofType((0, $haEws.FETCH_USER_REQUESTS_COUNTS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.userRequestsCounts).map((response)=>(0, $7m3Xa.updateUserRequestsCountsAction)(response.userRequestsCounts)).catch(()=>(0, $jFk35.Observable).never()));
};
var $5becda2cade3c34b$export$2e2bcd8739ae039 = $5becda2cade3c34b$var$fetchUserRequestsCountsEpic;

});
parcelRegister("haEws", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_REQUESTS_COUNTS_MODEL", () => $e82ddfe44bb3ceff$export$dfecf710cdf030b1);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $e82ddfe44bb3ceff$export$71172847a48a08a6);

var $dv0hN = parcelRequire("dv0hN");
const $e82ddfe44bb3ceff$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $e82ddfe44bb3ceff$export$71172847a48a08a6 = (0, $dv0hN.buildModelsActionCreator)($e82ddfe44bb3ceff$export$dfecf710cdf030b1, 'userRequestsCounts');

});


parcelRegister("evXYl", function(module, exports) {
$parcel$export(module.exports, "aiAnswerFeedbackPageEpic", () => $173273661adac212$export$ceff4b1bfa1bc6ba);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("h705Q");
var $bYbKZ = parcelRequire("bYbKZ");
const $173273661adac212$export$ceff4b1bfa1bc6ba = (action$)=>{
    return action$.ofType((0, $bYbKZ.FETCH_AI_ANSWER_FEEDBACK_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.aianswer).map((response)=>{
            return (0, $bYbKZ.fetchAiAnswerFeedbackSuccess)(response.aianswer);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $bYbKZ.fetchAiAnswerFeedbackFailure)(error));
        }));
};

});
parcelRegister("h705Q", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => (parcelRequire("bYbKZ")).FETCH_AI_ANSWER_FEEDBACK_MODEL);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => (parcelRequire("bYbKZ")).FETCH_AI_ANSWER_FEEDBACK_SUCCESS);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => (parcelRequire("bYbKZ")).FETCH_AI_ANSWER_FEEDBACK_FAILURE);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => (parcelRequire("bYbKZ")).fetchAiAnswerFeedbackModel);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => (parcelRequire("bYbKZ")).fetchAiAnswerFeedbackSuccess);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => (parcelRequire("bYbKZ")).fetchAiAnswerFeedbackFailure);

var $bYbKZ = parcelRequire("bYbKZ");

});
parcelRegister("bYbKZ", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => $08b72a8266df53c6$export$ae77fa01ad25f4c9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => $08b72a8266df53c6$export$6f922337a7af3b9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => $08b72a8266df53c6$export$4daab78c9d39cdb5);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => $08b72a8266df53c6$export$4514f111c053f647);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => $08b72a8266df53c6$export$4da568a91bd226dc);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => $08b72a8266df53c6$export$a1584ed81f70c36d);

var $dv0hN = parcelRequire("dv0hN");
const $08b72a8266df53c6$export$ae77fa01ad25f4c9 = 'epic.model.FETCH_AI_ANSWER_FEEDBACK_MODEL';
const $08b72a8266df53c6$export$6f922337a7af3b9 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_SUCCESS';
const $08b72a8266df53c6$export$4daab78c9d39cdb5 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_FAILURE';
const $08b72a8266df53c6$export$4514f111c053f647 = (0, $dv0hN.buildModelsActionCreator)($08b72a8266df53c6$export$ae77fa01ad25f4c9, 'aianswer');
const $08b72a8266df53c6$export$4da568a91bd226dc = (aiAnswerFeedbackResponse)=>({
        type: $08b72a8266df53c6$export$6f922337a7af3b9,
        payload: aiAnswerFeedbackResponse
    });
const $08b72a8266df53c6$export$a1584ed81f70c36d = (error)=>({
        type: $08b72a8266df53c6$export$4daab78c9d39cdb5,
        payload: {
            error: error
        }
    });

});



parcelRegister("dYLB0", function(module, exports) {
$parcel$export(module.exports, "approvalListEpic", () => $c561d549fc24b73e$export$77e5ddee619f2d69);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("8knRH");
var $kXd9e = parcelRequire("kXd9e");
const $c561d549fc24b73e$export$77e5ddee619f2d69 = (action$)=>{
    return action$.ofType((0, $kXd9e.FETCH_APPROVAL_LIST_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.approvalListFilter && !!response.approvalListFilter.requests).map((response)=>{
            return (0, $kXd9e.fetchApprovalListSuccess)(response.approvalListFilter);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $kXd9e.fetchApprovalListFailure)(error));
        }));
};

});
parcelRegister("8knRH", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => (parcelRequire("kXd9e")).FETCH_APPROVAL_LIST_MODEL);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => (parcelRequire("kXd9e")).FETCH_APPROVAL_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => (parcelRequire("kXd9e")).FETCH_APPROVAL_LIST_FAILURE);
$parcel$export(module.exports, "fetchApprovalListModel", () => (parcelRequire("kXd9e")).fetchApprovalListModel);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => (parcelRequire("kXd9e")).fetchApprovalListSuccess);
$parcel$export(module.exports, "fetchApprovalListFailure", () => (parcelRequire("kXd9e")).fetchApprovalListFailure);

var $kXd9e = parcelRequire("kXd9e");

});
parcelRegister("kXd9e", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => $80156ca9c4a58ac7$export$2e7343d23ce2e264);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => $80156ca9c4a58ac7$export$42d9c935d4bfef61);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => $80156ca9c4a58ac7$export$132a25b8ba1cc94);
$parcel$export(module.exports, "fetchApprovalListModel", () => $80156ca9c4a58ac7$export$c4decf32e9c96894);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => $80156ca9c4a58ac7$export$2ac6685d409334fa);
$parcel$export(module.exports, "fetchApprovalListFailure", () => $80156ca9c4a58ac7$export$9059cd838e20fcf6);

var $dv0hN = parcelRequire("dv0hN");
const $80156ca9c4a58ac7$export$2e7343d23ce2e264 = 'epic.model.FETCH_APPROVAL_LIST_MODEL';
const $80156ca9c4a58ac7$export$42d9c935d4bfef61 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_SUCCESS';
const $80156ca9c4a58ac7$export$132a25b8ba1cc94 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_FAILURE';
const $80156ca9c4a58ac7$export$c4decf32e9c96894 = (0, $dv0hN.buildModelsActionCreator)($80156ca9c4a58ac7$export$2e7343d23ce2e264, 'approvalListFilter');
const $80156ca9c4a58ac7$export$2ac6685d409334fa = (approvalListFilter)=>({
        type: $80156ca9c4a58ac7$export$42d9c935d4bfef61,
        payload: approvalListFilter
    });
const $80156ca9c4a58ac7$export$9059cd838e20fcf6 = (error)=>({
        type: $80156ca9c4a58ac7$export$132a25b8ba1cc94,
        payload: {
            error: error
        }
    });

});



parcelRegister("4hXnv", function(module, exports) {
$parcel$export(module.exports, "fetchArticleEpic", () => $8e806a1294cd9ace$export$3c4e80b80ffa2c37);

var $jFk35 = parcelRequire("jFk35");
parcelRequire("1zrpx");
var $1EWnP = parcelRequire("1EWnP");

var $aIVqJ = parcelRequire("aIVqJ");

var $ja4bY = parcelRequire("ja4bY");

var $b4gcU = parcelRequire("b4gcU");
const $8e806a1294cd9ace$export$3c4e80b80ffa2c37 = (action$)=>action$.ofType((0, $1EWnP.FETCH_ARTICLE)).mergeMap((action)=>{
        const { meta: meta } = action;
        return (0, $b4gcU.default)(action.payload).filter((response)=>!!response.kbPage).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $1EWnP.fetchArticleSuccess)(response.kbPage);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)((0, $ja4bY.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $jFk35.Observable).of((0, $1EWnP.fetchArticleFailure)(action.payload.params.id, error));
        });
    });

});

parcelRegister("gXv2g", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $f03aca17dff04abd$export$c3902030a5d4d47a);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("23jTe");
var $bAYOu = parcelRequire("bAYOu");
const $f03aca17dff04abd$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $bAYOu.FETCH_COMPLETE_SIGNUP_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.completeSignup && !!response.completeSignup.emailAddress).map((response)=>{
            return (0, $bAYOu.fetchCompleteSignupSuccess)(response.completeSignup);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $bAYOu.fetchCompleteSignupFailure)(error));
        }));
};

});

parcelRegister("51AoQ", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsEpic", () => $2b8843b75ebdda42$export$da9f118c732015e);
$parcel$export(module.exports, "profileConnectFragmentsEpic", () => $2b8843b75ebdda42$export$a3ede6811238e533);

var $jFk35 = parcelRequire("jFk35");
parcelRequire("lgOtA");
var $03HuP = parcelRequire("03HuP");

var $b4gcU = parcelRequire("b4gcU");
const $2b8843b75ebdda42$export$da9f118c732015e = (action$)=>action$.ofType((0, $03HuP.FETCH_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $b4gcU.default)(action.payload, {
            type: action.payload.params.portalPage === 'CREATE_REQUEST' ? 'secondary' : 'primary'
        }).filter((response)=>!!response.portalWebFragments).map((response)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $03HuP.fetchConnectFragmentsSuccess)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                requestKey: requestKey,
                portalPageName: portalPage,
                connectFragments: response.portalWebFragments
            });
        }).catch((error)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $jFk35.Observable).of((0, $03HuP.fetchConnectFragmentsFailure)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                error: error,
                requestKey: requestKey,
                portalPageName: portalPage
            }));
        }));
const $2b8843b75ebdda42$export$a3ede6811238e533 = (action$)=>action$.ofType((0, $03HuP.FETCH_PROFILE_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.profileWebFragments).map((response)=>{
            return (0, $03HuP.fetchProfileConnectFragmentsSuccess)(response.profileWebFragments);
        }).catch((error)=>(0, $jFk35.Observable).of((0, $03HuP.fetchProfileConnectFragmentsFailure)(error))));

});
parcelRegister("lgOtA", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => (parcelRequire("03HuP")).FETCH_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("03HuP")).FETCH_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("03HuP")).FETCH_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => (parcelRequire("03HuP")).FETCH_PROFILE_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("03HuP")).FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("03HuP")).FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => (parcelRequire("03HuP")).fetchConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => (parcelRequire("03HuP")).fetchConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => (parcelRequire("03HuP")).fetchProfileConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => (parcelRequire("03HuP")).fetchProfileConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => (parcelRequire("03HuP")).fetchConnectFragmentsAction);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => (parcelRequire("03HuP")).fetchProfileConnectFragmentsAction);

var $03HuP = parcelRequire("03HuP");

});
parcelRegister("03HuP", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => $9d21dd8cb5aa1ec4$export$be3b6b321a4b2e30);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => $9d21dd8cb5aa1ec4$export$8c14498d55ee35d5);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => $9d21dd8cb5aa1ec4$export$c4d0c4cc4d23ec29);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => $9d21dd8cb5aa1ec4$export$ac33d6e70ef6394b);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => $9d21dd8cb5aa1ec4$export$93b4a584ef971c3e);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => $9d21dd8cb5aa1ec4$export$bd274633ff57df1a);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => $9d21dd8cb5aa1ec4$export$acefa59403de59c3);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => $9d21dd8cb5aa1ec4$export$9b734d900be9577d);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => $9d21dd8cb5aa1ec4$export$2e62b6b504d95c08);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => $9d21dd8cb5aa1ec4$export$ea99ad4f53065bdf);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => $9d21dd8cb5aa1ec4$export$802082c6f9bfe7);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => $9d21dd8cb5aa1ec4$export$3b319d8313349388);

var $dv0hN = parcelRequire("dv0hN");
const $9d21dd8cb5aa1ec4$export$be3b6b321a4b2e30 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_SUCCESS';
const $9d21dd8cb5aa1ec4$export$8c14498d55ee35d5 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_FAILURE';
const $9d21dd8cb5aa1ec4$export$c4d0c4cc4d23ec29 = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS';
const $9d21dd8cb5aa1ec4$export$ac33d6e70ef6394b = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE';
const $9d21dd8cb5aa1ec4$export$93b4a584ef971c3e = 'epic.model.FETCH_CONNECT_FRAGMENTS';
const $9d21dd8cb5aa1ec4$export$bd274633ff57df1a = (0, $dv0hN.buildModelsActionCreator)($9d21dd8cb5aa1ec4$export$93b4a584ef971c3e, 'portalWebFragments');
const $9d21dd8cb5aa1ec4$export$acefa59403de59c3 = 'epic.model.FETCH_PROFILE_CONNECT_FRAGMENTS';
const $9d21dd8cb5aa1ec4$export$9b734d900be9577d = (0, $dv0hN.buildModelsActionCreator)($9d21dd8cb5aa1ec4$export$acefa59403de59c3, 'profileWebFragments');
const $9d21dd8cb5aa1ec4$export$2e62b6b504d95c08 = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey })=>({
        type: $9d21dd8cb5aa1ec4$export$be3b6b321a4b2e30,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            connectFragments: connectFragments,
            requestKey: requestKey
        }
    });
const $9d21dd8cb5aa1ec4$export$ea99ad4f53065bdf = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey })=>({
        type: $9d21dd8cb5aa1ec4$export$8c14498d55ee35d5,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error,
            requestKey: requestKey
        }
    });
const $9d21dd8cb5aa1ec4$export$802082c6f9bfe7 = (fragments)=>({
        type: $9d21dd8cb5aa1ec4$export$c4d0c4cc4d23ec29,
        payload: {
            fragments: fragments
        }
    });
const $9d21dd8cb5aa1ec4$export$3b319d8313349388 = (error)=>({
        type: $9d21dd8cb5aa1ec4$export$ac33d6e70ef6394b,
        payload: {
            error: error
        }
    });

});



parcelRegister("fTN62", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsEpic", () => $dee572311925d510$export$482dd9b2afe107b5);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("csZtW");
var $gD2hW = parcelRequire("gD2hW");

var $cf3fd = parcelRequire("cf3fd");

var $cVbKE = parcelRequire("cVbKE");
const $dee572311925d510$var$emptyFeaturedAndSortedPortalsResponse = {
    portals: [],
    total: 0
};
const $dee572311925d510$export$482dd9b2afe107b5 = (action$)=>{
    return action$.ofType((0, $gD2hW.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL)).mergeMap((action)=>{
        const { isPortalReorderingSelected: isPortalReorderingSelected, ...params } = action.payload.params;
        if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)()) return (0, $jFk35.Observable).from((0, $cVbKE.fetchFeaturedAndSortedPortalsData)(params).toPromise().then((response)=>(0, $cVbKE.convertToFeaturedAndSortedPortalsResponse)(response))).flatMap((data)=>{
            return (0, $jFk35.Observable).of((0, $gD2hW.fetchFeaturedAndSortedPortalsSuccess)(data || $dee572311925d510$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $gD2hW.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $jFk35.Observable).of((0, $gD2hW.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
        return (0, $b4gcU.default)({
            ...action.payload,
            params: params
        }).filter((response)=>!!response.featuredAndSortedPortals).flatMap((response)=>{
            return (0, $jFk35.Observable).of((0, $gD2hW.fetchFeaturedAndSortedPortalsSuccess)(response.featuredAndSortedPortals || $dee572311925d510$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $gD2hW.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $jFk35.Observable).of((0, $gD2hW.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
    });
};

});
parcelRegister("csZtW", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => (parcelRequire("gD2hW")).FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => (parcelRequire("gD2hW")).fetchFeaturedAndSortedPortalsSuccess);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => (parcelRequire("gD2hW")).FETCH_FEATURED_AND_SORTED_PORTALS_MODEL);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => (parcelRequire("gD2hW")).fetchFeaturedAndSortedPortalsModel);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => (parcelRequire("gD2hW")).FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => (parcelRequire("gD2hW")).fetchFeaturedAndSortedPortalsFailure);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => (parcelRequire("gD2hW")).REORDER_FEATURED_PORTAL);
$parcel$export(module.exports, "reorderFeaturedPortal", () => (parcelRequire("gD2hW")).reorderFeaturedPortal);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => (parcelRequire("gD2hW")).MARK_PORTAL_FEATURED);
$parcel$export(module.exports, "markPortalFeatured", () => (parcelRequire("gD2hW")).markPortalFeatured);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("gD2hW")).UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => (parcelRequire("gD2hW")).updatePortalReorderSettingsSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => (parcelRequire("gD2hW")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => (parcelRequire("gD2hW")).updatePortalReorderSettingsModel);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => (parcelRequire("gD2hW")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => (parcelRequire("gD2hW")).updatePortalReorderSettingsModelSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => (parcelRequire("gD2hW")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => (parcelRequire("gD2hW")).updatePortalReorderSettingsModelFailure);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => (parcelRequire("gD2hW")).UPDATE_PORTAL_REORDER_SETTINGS_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => (parcelRequire("gD2hW")).updatePortalReorderSettingsFailure);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => (parcelRequire("gD2hW")).RESET_PORTAL_REORDER_SETTINGS);
$parcel$export(module.exports, "resetPortalReorderSettings", () => (parcelRequire("gD2hW")).resetPortalReorderSettings);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("gD2hW")).RESET_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => (parcelRequire("gD2hW")).resetPortalReorderSettingsSuccess);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => (parcelRequire("gD2hW")).MARK_PORTAL_REORDER_SETTINGS_DIRTY);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => (parcelRequire("gD2hW")).markPortalReorderSettingsDirty);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => (parcelRequire("gD2hW")).TOGGLE_PORTAL_VISIBILITY);
$parcel$export(module.exports, "togglePortalVisibility", () => (parcelRequire("gD2hW")).togglePortalVisibility);

var $gD2hW = parcelRequire("gD2hW");

});
parcelRegister("gD2hW", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => $fa97cf950ef88726$export$8772f11deb28968a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => $fa97cf950ef88726$export$6ed163277f07d17a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => $fa97cf950ef88726$export$9198b985767ee6a9);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => $fa97cf950ef88726$export$c4ada71ac24d5427);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => $fa97cf950ef88726$export$e78177131adb1a7a);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => $fa97cf950ef88726$export$f04d3c0a6161427f);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => $fa97cf950ef88726$export$68f1a628095e7df5);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => $fa97cf950ef88726$export$aa2114acd4f820aa);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => $fa97cf950ef88726$export$2d425395f1203ae4);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => $fa97cf950ef88726$export$e6dde7e78d51edc9);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => $fa97cf950ef88726$export$d6299724cb4f13de);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => $fa97cf950ef88726$export$47862f368a701d13);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => $fa97cf950ef88726$export$bce4411b856ef9e5);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => $fa97cf950ef88726$export$a90731f74ba59c30);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => $fa97cf950ef88726$export$6ea18f901a4f825e);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => $fa97cf950ef88726$export$6d3c5bcff4d8dcfc);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => $fa97cf950ef88726$export$9d041bf07bd04f34);
$parcel$export(module.exports, "markPortalFeatured", () => $fa97cf950ef88726$export$3b1a77584c9a6b81);
$parcel$export(module.exports, "togglePortalVisibility", () => $fa97cf950ef88726$export$89b8e7ec4e1c2d07);
$parcel$export(module.exports, "reorderFeaturedPortal", () => $fa97cf950ef88726$export$62b3d711c52e9aa2);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => $fa97cf950ef88726$export$ff946f5ffd1293d7);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => $fa97cf950ef88726$export$eeed66775c51f217);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => $fa97cf950ef88726$export$eb2d78b304e5909c);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => $fa97cf950ef88726$export$8fabcd6d8271b790);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => $fa97cf950ef88726$export$4b50f99aebbcd6b7);
$parcel$export(module.exports, "resetPortalReorderSettings", () => $fa97cf950ef88726$export$4157bb81256cfd7f);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => $fa97cf950ef88726$export$d0f9348a57407b6c);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => $fa97cf950ef88726$export$5c52eef312473e8b);
const $fa97cf950ef88726$export$8772f11deb28968a = 'epic.model.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL';
const $fa97cf950ef88726$export$6ed163277f07d17a = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS';
const $fa97cf950ef88726$export$9198b985767ee6a9 = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE';
const $fa97cf950ef88726$export$c4ada71ac24d5427 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_FEATURED';
const $fa97cf950ef88726$export$e78177131adb1a7a = 'state.ui.featuredAndSortedPortals.REORDER_FEATURED_PORTAL';
const $fa97cf950ef88726$export$f04d3c0a6161427f = 'state.ui.featuredAndSortedPortals.TOGGLE_PORTAL_VISIBILITY';
const $fa97cf950ef88726$export$68f1a628095e7df5 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL';
const $fa97cf950ef88726$export$aa2114acd4f820aa = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS';
const $fa97cf950ef88726$export$2d425395f1203ae4 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE';
const $fa97cf950ef88726$export$e6dde7e78d51edc9 = 'state.persisted.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS';
const $fa97cf950ef88726$export$d6299724cb4f13de = 'state.ui.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE';
const $fa97cf950ef88726$export$47862f368a701d13 = 'epic.portal-reorder-settings.RESET_PORTAL_REORDER_SETTINGS';
const $fa97cf950ef88726$export$bce4411b856ef9e5 = 'state.ui.featuredAndSortedPortals.RESET_PORTAL_REORDER_SETTINGS_SUCCESS';
const $fa97cf950ef88726$export$a90731f74ba59c30 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_REORDER_SETTINGS_DIRTY';
/* isPortalReorderingSelected is used to distinguish between the calls made to featuredAndSortedPortals model in case of help-seeker view from that of portal reordering screen view, inside the state reducers */ const $fa97cf950ef88726$var$buildModelsActionCreatorForFeaturedAndSortedPortals = (actionType, type)=>(params = {}, isPortalReorderingSelected)=>({
            type: actionType,
            payload: {
                type: type,
                params: {
                    ...params,
                    isPortalReorderingSelected: isPortalReorderingSelected
                }
            }
        });
const $fa97cf950ef88726$export$6ea18f901a4f825e = $fa97cf950ef88726$var$buildModelsActionCreatorForFeaturedAndSortedPortals($fa97cf950ef88726$export$8772f11deb28968a, 'featuredAndSortedPortals');
const $fa97cf950ef88726$export$6d3c5bcff4d8dcfc = (featuredAndSortedPortalsModel, requestParams)=>({
        requestParams: requestParams,
        type: $fa97cf950ef88726$export$6ed163277f07d17a,
        payload: featuredAndSortedPortalsModel
    });
const $fa97cf950ef88726$export$9d041bf07bd04f34 = (error, requestParams)=>({
        requestParams: requestParams,
        type: $fa97cf950ef88726$export$9198b985767ee6a9,
        payload: {
            error: error
        }
    });
const $fa97cf950ef88726$export$3b1a77584c9a6b81 = (id, isFeatured)=>({
        type: $fa97cf950ef88726$export$c4ada71ac24d5427,
        payload: {
            isFeatured: isFeatured,
            id: id
        }
    });
const $fa97cf950ef88726$export$89b8e7ec4e1c2d07 = (id, hiddenFromHomeScreen)=>({
        type: $fa97cf950ef88726$export$f04d3c0a6161427f,
        payload: {
            id: id,
            hiddenFromHomeScreen: hiddenFromHomeScreen
        }
    });
const $fa97cf950ef88726$export$62b3d711c52e9aa2 = (oldIndex, newIndex)=>({
        type: $fa97cf950ef88726$export$e78177131adb1a7a,
        payload: {
            oldIndex: oldIndex,
            newIndex: newIndex
        }
    });
const $fa97cf950ef88726$export$ff946f5ffd1293d7 = (meta)=>({
        meta: meta,
        type: $fa97cf950ef88726$export$68f1a628095e7df5
    });
const $fa97cf950ef88726$export$eeed66775c51f217 = (meta)=>({
        meta: meta,
        type: $fa97cf950ef88726$export$aa2114acd4f820aa
    });
const $fa97cf950ef88726$export$eb2d78b304e5909c = (meta, error)=>({
        meta: meta,
        error: error,
        type: $fa97cf950ef88726$export$2d425395f1203ae4
    });
const $fa97cf950ef88726$export$8fabcd6d8271b790 = (featuredPortalIds, sortBy, orderedPortalIds, hiddenPortalIds)=>({
        type: $fa97cf950ef88726$export$e6dde7e78d51edc9,
        payload: {
            featuredPortalIds: featuredPortalIds,
            sortBy: sortBy,
            orderedPortalIds: orderedPortalIds,
            hiddenPortalIds: hiddenPortalIds
        }
    });
const $fa97cf950ef88726$export$4b50f99aebbcd6b7 = (error)=>({
        type: $fa97cf950ef88726$export$d6299724cb4f13de,
        payload: {
            error: error
        }
    });
const $fa97cf950ef88726$export$4157bb81256cfd7f = (shouldRedirect)=>({
        type: $fa97cf950ef88726$export$47862f368a701d13,
        payload: {
            shouldRedirect: shouldRedirect
        }
    });
const $fa97cf950ef88726$export$d0f9348a57407b6c = ()=>({
        type: $fa97cf950ef88726$export$a90731f74ba59c30
    });
const $fa97cf950ef88726$export$5c52eef312473e8b = (featuredPortalIds, orderedPortalIds, sortBy)=>({
        type: $fa97cf950ef88726$export$bce4411b856ef9e5,
        payload: {
            featuredPortalIds: featuredPortalIds,
            orderedPortalIds: orderedPortalIds,
            sortBy: sortBy
        }
    });

});


parcelRegister("cVbKE", function(module, exports) {
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsData", () => $9657a9da9bd026d2$export$1e547feda5a72cb5);
$parcel$export(module.exports, "convertToFeaturedAndSortedPortalsResponse", () => $9657a9da9bd026d2$export$af9ca8a283fc9983);

var $bJx48 = parcelRequire("bJx48");

var $4Q7yw = parcelRequire("4Q7yw");

var $5KQKg = parcelRequire("5KQKg");

var $6LH8a = parcelRequire("6LH8a");

var $1xOZp = parcelRequire("1xOZp");
const $9657a9da9bd026d2$export$1e547feda5a72cb5 = (params)=>{
    return (0, $5KQKg.fetchQuery)((0, $1xOZp.getRelayEnvironment)(), (0, $bJx48.default), {
        cloudId: (0, $6LH8a.getCloudId)(),
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        sortOrder: $9657a9da9bd026d2$var$getSortIngParams(params.sortBy),
        portalsFilter: $9657a9da9bd026d2$var$getFilterParams(params.exploreAll)
    });
};
const $9657a9da9bd026d2$var$getFilterParams = (exploreAll)=>{
    if (exploreAll) return undefined;
    return {
        typeFilter: [
            'VISIBLE'
        ]
    };
};
const $9657a9da9bd026d2$var$getSortIngParams = (sortBy)=>{
    if (sortBy === 'ALPHABETICALLY') return 'NAME_ASCENDING';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $9657a9da9bd026d2$var$getSortIngValues = (sortBy)=>{
    if (sortBy === 'NAME_ASCENDING') return 'ALPHABETICALLY';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $9657a9da9bd026d2$export$af9ca8a283fc9983 = (response)=>{
    var _response$helpCenter;
    if (response === undefined) return undefined;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') {
        const extensions = data.extensions;
        const message = data.message;
        if (extensions && Array.isArray(extensions) && extensions.length > 0 && message) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const { statusCode: statusCode } = extensions[0];
            const xhr = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                status: statusCode,
                responseType: 'json',
                response: data
            };
            throw new (0, $4Q7yw.AjaxError)(`${message} with status ${String(statusCode)}`, xhr, {});
        }
        throw new Error(message || '');
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        const portals = data.portals;
        const { portalsList: portalsList } = portals || {
            portalsList: []
        };
        return {
            sortBy: $9657a9da9bd026d2$var$getSortIngValues(portals === null || portals === void 0 ? void 0 : portals.sortOrder),
            // Backend will return all the portals there is no pagination
            total: portalsList === null || portalsList === void 0 ? void 0 : portalsList.length,
            // This FF has been rolled out so this is always true
            isPortalHidingEnabled: true,
            portals: (portalsList === null || portalsList === void 0 ? void 0 : portalsList.map((portal)=>({
                    // right now id is number will have to verify while backend integration
                    id: parseInt(portal.id, 10),
                    key: portal.key || '',
                    name: portal.name || '',
                    description: portal.description || '',
                    logoUrl: portal.logoUrl || undefined,
                    rank: portal.rank || -1,
                    portalBaseUrl: portal.portalBaseUrl,
                    isFeatured: !!portal.isFeatured,
                    hiddenFromHomeScreen: !!portal.isHidden,
                    isPortalNotVisibleOnHelpCentre: false
                }))) || []
        };
    }
    return undefined;
};

});
parcelRegister("bJx48", function(module, exports) {
$parcel$export(module.exports, "default", () => $388a11bb44200613$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d849493470a62f53c7a36f89d8810125>>
 * @relayHash 25e6269361cd6efc34c09587ad76c352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e
const $388a11bb44200613$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortOrder"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "portalsFilter",
                "variableName": "portalsFilter"
            },
            {
                "kind": "Variable",
                "name": "sortOrder",
                "variableName": "sortOrder"
            }
        ],
        "concreteType": "HelpCenterPortals",
        "kind": "LinkedField",
        "name": "portals",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sortOrder"
            },
            {
                "concreteType": "HelpCenterPortal",
                "kind": "LinkedField",
                "name": "portalsList",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "logoUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "portalBaseUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isFeatured"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isHidden"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rank"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e",
            "metadata": {},
            "name": "featuredAndSortedPortalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$388a11bb44200613$var$node.hash = "db239181519d00ccb6f4d7cba5dc3acd";
var $388a11bb44200613$export$2e2bcd8739ae039 = $388a11bb44200613$var$node;

});



parcelRegister("3TIdz", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $e3308ef976e23e7b$export$cb36b6e8b9a45314);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("aBure");
var $imKPc = parcelRequire("imKPc");

var $hO6iq = parcelRequire("hO6iq");
const $e3308ef976e23e7b$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $hO6iq.FETCH_FORGOT_PASSWORD_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.forgotPassword && !!response.forgotPassword.resetUrl).map((response)=>{
            return (0, $imKPc.fetchForgotPasswordModelSuccess)(response.forgotPassword);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $imKPc.fetchForgotPasswordModelFailure)(error));
        }));
};

});
parcelRegister("aBure", function(module, exports) {
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => (parcelRequire("imKPc")).fetchForgotPasswordModelSuccess);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => (parcelRequire("imKPc")).fetchForgotPasswordModelFailure);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("imKPc")).FETCH_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("imKPc")).FETCH_FORGOT_PASSWORD_FAILURE);

var $imKPc = parcelRequire("imKPc");

});
parcelRegister("imKPc", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => $04395b9a0a6865d9$export$78f743c8c0190142);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => $04395b9a0a6865d9$export$aeb2acd4962d8ce9);
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => $04395b9a0a6865d9$export$f5ac004adf4f85e3);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => $04395b9a0a6865d9$export$d6a87818b7101f95);
const $04395b9a0a6865d9$export$78f743c8c0190142 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_SUCCESS';
const $04395b9a0a6865d9$export$aeb2acd4962d8ce9 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_FAILURE';
const $04395b9a0a6865d9$export$f5ac004adf4f85e3 = (forgotPasswordModel)=>({
        payload: forgotPasswordModel,
        type: $04395b9a0a6865d9$export$78f743c8c0190142
    });
const $04395b9a0a6865d9$export$d6a87818b7101f95 = (error)=>({
        type: $04395b9a0a6865d9$export$aeb2acd4962d8ce9,
        payload: {
            error: error
        }
    });

});


parcelRegister("hO6iq", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_MODEL", () => $80f683e841bd630d$export$8908eff00e7804c6);
$parcel$export(module.exports, "fetchForgotPasswordModel", () => $80f683e841bd630d$export$41d4a614faed30ee);

var $dv0hN = parcelRequire("dv0hN");
const $80f683e841bd630d$export$8908eff00e7804c6 = 'epic.model.FETCH_FORGOT_PASSWORD_MODEL';
const $80f683e841bd630d$export$41d4a614faed30ee = (0, $dv0hN.buildModelsActionCreator)($80f683e841bd630d$export$8908eff00e7804c6, 'forgotPassword');

});


parcelRegister("7Rjp7", function(module, exports) {
$parcel$export(module.exports, "helpCenterEpic", () => $ef64770afe510581$export$5b8469c39769260e);
$parcel$export(module.exports, "invalidateHelpCenterBrandingEpic", () => $ef64770afe510581$export$dc52639d81083812);
$parcel$export(module.exports, "helpCenterBrandingEpic", () => $ef64770afe510581$export$10de7c69d36b21f6);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $5KQKg = parcelRequire("5KQKg");
parcelRequire("jjuxZ");
var $gwluP = parcelRequire("gwluP");

var $cf3fd = parcelRequire("cf3fd");

var $3O0Ex = parcelRequire("3O0Ex");

var $1xOZp = parcelRequire("1xOZp");

var $b4gcU = parcelRequire("b4gcU");

var $eXcu8 = parcelRequire("eXcu8");
const $ef64770afe510581$export$5b8469c39769260e = (action$)=>{
    return action$.ofType((0, $eXcu8.FETCH_HELP_CENTER_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.sharedPortal).map((response)=>{
            return (0, $gwluP.updateHelpCenterModelAction)(response.sharedPortal);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $jFk35.Observable).never()));
};
const $ef64770afe510581$export$dc52639d81083812 = (action$)=>{
    return action$.ofType((0, $eXcu8.INVALIDATE_HELP_CENTER_RELAY_STORE)).mergeMap(()=>{
        // invalidate local cache of relay store for help center branding
        (0, $5KQKg.commitLocalUpdate)((0, $1xOZp.getRelayEnvironment)(), (relayStore)=>{
            const root = relayStore.getRoot();
            const query = root.getLinkedRecord('helpCenter', {
                cloudId: (0, $6LH8a.getCloudId)()
            });
            const helpCenter = query === null || query === void 0 ? void 0 : query.getLinkedRecord('helpCenterById', {
                helpCenterAri: (0, $6LH8a.getHelpCenterAri)()
            });
            helpCenter === null || helpCenter === void 0 || helpCenter.invalidateRecord();
        });
        const noAction = (0, $jFk35.Observable).never();
        return noAction;
    });
};
const $ef64770afe510581$export$10de7c69d36b21f6 = (action$)=>{
    return action$.ofType((0, $eXcu8.FETCH_HELP_CENTER_BRANDING_MODEL)).mergeMap((action)=>{
        const noAction = (0, $jFk35.Observable).never();
        if ((0, $hN5YJ.isDefaultHCUsingGqlBrandingCalls)() || (0, $cf3fd.isKoshEnabledForDefaultHelpCenter)()) return (0, $jFk35.Observable).from((0, $3O0Ex.fetchBrandingData)().toPromise().then((response)=>(0, $3O0Ex.convertToHCBrandingResponse)(response))).filter((data)=>!!data).flatMap((data)=>{
            if (data) return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingModelAction)(data)), (0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingLoaderAction)(true)));
            throw new Error('No data');
        }).catch(()=>(0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingLoaderAction)(true)));
        return (0, $jFk35.Observable).from((0, $b4gcU.default)(action.payload).filter((response)=>!!response.helpCenterBranding).flatMap((response)=>{
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingModelAction)(response.helpCenterBranding)), (0, $jFk35.Observable).of((0, $gwluP.updateHCBrandingLoaderAction)(true)));
        }).catch((_)=>noAction));
    });
};

});
parcelRegister("3O0Ex", function(module, exports) {
$parcel$export(module.exports, "fetchBrandingData", () => $b8232dc62e5f5d18$export$7bfdb01d731b8001);
$parcel$export(module.exports, "convertToHCBrandingResponse", () => $b8232dc62e5f5d18$export$4560b37f8fc33ae3);

var $eKtVN = parcelRequire("eKtVN");

var $6LH8a = parcelRequire("6LH8a");

var $5KQKg = parcelRequire("5KQKg");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $1xOZp = parcelRequire("1xOZp");
const $b8232dc62e5f5d18$export$7bfdb01d731b8001 = ()=>{
    return (0, $5KQKg.fetchQuery)((0, $1xOZp.getRelayEnvironment)(), (0, $eKtVN.default), {
        cloudId: (0, $6LH8a.getCloudId)(),
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)()
    }, {
        fetchPolicy: 'store-or-network'
    });
};
const $b8232dc62e5f5d18$var$mapTranslations = (translations, fieldName, acc)=>{
    translations === null || translations === void 0 || translations.forEach((translation)=>{
        if (translation && acc[translation === null || translation === void 0 ? void 0 : translation.locale] !== undefined) acc[translation.locale][fieldName] = translation.value;
        else if (translation) acc[translation === null || translation === void 0 ? void 0 : translation.locale] = {
            [fieldName]: translation.value,
            localeDisplayName: translation.localeDisplayName
        };
    });
};
const $b8232dc62e5f5d18$export$4560b37f8fc33ae3 = (response)=>{
    var _response$helpCenter;
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        var _homePageAnnouncement, _homePageAnnouncement2;
        const branding = data.helpCenterBranding;
        const announcements = data.announcements;
        const sharedPortalName = data.name;
        const { homePageAnnouncements: homePageAnnouncements } = announcements || {};
        const { logo: logo, banner: banner, homePageTitle: homePageTitle, colors: colors, hasTopBarBeenSplit: hasTopBarBeenSplit } = branding;
        const initialTranslation = {};
        let translations = {};
        if (homePageAnnouncements) translations = homePageAnnouncements === null || homePageAnnouncements === void 0 ? void 0 : homePageAnnouncements.filter((announcement)=>!!announcement).reduce((acc, announcement)=>{
            const { nameTranslationsRaw: nameTranslationsRaw, descriptionTranslationsRaw: descriptionTranslationsRaw } = announcement;
            $b8232dc62e5f5d18$var$mapTranslations(nameTranslationsRaw, 'announcementHeader', acc);
            $b8232dc62e5f5d18$var$mapTranslations(descriptionTranslationsRaw, 'announcementMessage', acc);
            return acc;
        }, initialTranslation);
        $b8232dc62e5f5d18$var$mapTranslations(sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.translations, 'sharedPortalName', translations);
        $b8232dc62e5f5d18$var$mapTranslations(homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.translations, 'helpCenterTitle', translations);
        const getDefaultTitle = ()=>{
            if (isCSM) return 'How can we help?';
            return 'Welcome to the Help Center';
        };
        const portalThemeColor = (colors === null || colors === void 0 ? void 0 : colors.primary) || '#0074e0';
        const helpCenterTitleColor = (colors === null || colors === void 0 ? void 0 : colors.bannerTextColor) || '#ffffff';
        return {
            translations: translations,
            portalThemeColor: portalThemeColor,
            helpCenterTitleColor: helpCenterTitleColor,
            logoUrl: (logo === null || logo === void 0 ? void 0 : logo.url) || '',
            logoId: (logo === null || logo === void 0 ? void 0 : logo.fileId) || '',
            bannerMediaApiFileId: (banner === null || banner === void 0 ? void 0 : banner.fileId) || '',
            bannerMediaApiUrl: (banner === null || banner === void 0 ? void 0 : banner.url) || '',
            helpCenterTitle: (homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.default) || getDefaultTitle(),
            canEditAnnouncement: !!(announcements !== null && announcements !== void 0 && announcements.canEditHomePageAnnouncement),
            userInitialAnnouncementHeader: homePageAnnouncements && ((_homePageAnnouncement = homePageAnnouncements[0]) === null || _homePageAnnouncement === void 0 ? void 0 : _homePageAnnouncement.name) || '',
            userInitialAnnouncementMessageWiki: homePageAnnouncements && ((_homePageAnnouncement2 = homePageAnnouncements[0]) === null || _homePageAnnouncement2 === void 0 ? void 0 : _homePageAnnouncement2.description) || '',
            sharedPortalName: isCSM ? '' : (sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.default) || '',
            siteDefaultLanguageTag: data.siteDefaultLanguageTag || 'en-US',
            userLanguageTag: data.userLanguageTag || 'en-US',
            topBarColor: (colors === null || colors === void 0 ? void 0 : colors.topBarColor) || portalThemeColor,
            topBarTextColor: (colors === null || colors === void 0 ? void 0 : colors.topBarTextColor) || helpCenterTitleColor,
            hasTopBarBeenSplit: hasTopBarBeenSplit ?? false,
            isBannerAvailable: !!branding.isBannerAvailable,
            useDefaultBanner: !!branding.useDefaultBanner,
            isLogoAvailable: !!branding.isLogoAvailable
        };
    }
    return null;
};

});
parcelRegister("eKtVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aaedf09693b6452$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<762b42f3490374656d56e2bee709a301>>
 * @relayHash d9e8688fd258712e7252323bfaac25bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6
const $5aaedf09693b6452$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "default"
        },
        {
            "concreteType": "HelpCenterTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": true,
            "selections": v4 /*: any*/ 
        }
    ], v6 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "fileId"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v8 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterHomePageTitle",
                "kind": "LinkedField",
                "name": "homePageTitle",
                "plural": false,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bannerTextColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarTextColor"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "isBannerAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "isLogoAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            },
            {
                "kind": "ScalarField",
                "name": "hasTopBarBeenSplit"
            }
        ]
    }, v9 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canEditHomePageAnnouncement"
            },
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "homePageAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    }
                ]
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v11 = {
        "kind": "ScalarField",
        "name": "userLanguageTag"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "helpCenter.helpCenterById.helpCenterBranding"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6",
            "metadata": {},
            "name": "helpCenterBrandingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5aaedf09693b6452$var$node.hash = "4d4bfd3b05fd09feee5f588ec411df08";
var $5aaedf09693b6452$export$2e2bcd8739ae039 = $5aaedf09693b6452$var$node;

});



parcelRegister("GW3Bm", function(module, exports) {
$parcel$export(module.exports, "default", () => $39e8488908222707$export$2e2bcd8739ae039);

var $9aoKF = parcelRequire("9aoKF");
var $1cIiu = parcelRequire("1cIiu");
var $jFk35 = parcelRequire("jFk35");

var $4fLGk = parcelRequire("4fLGk");

var $ekYYx = parcelRequire("ekYYx");
parcelRequire("2t72L");
var $lmrcQ = parcelRequire("lmrcQ");
parcelRequire("2hp8E");
var $2hqAY = parcelRequire("2hqAY");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");

var $2EMow = parcelRequire("2EMow");
const $39e8488908222707$var$categoryArticlesEpic = (action$)=>{
    return action$.ofType((0, $2EMow.FETCH_ARTICLES)).mergeMap((action)=>{
        const { projectId: projectId, categoryId: categoryId, portalId: portalId, categoryDataRequired: categoryDataRequired, meta: meta } = action.payload;
        if (categoryDataRequired) // parallelize categories request with articles, used on initial category page load, ensures we always have the necessary category data
        return (0, $1cIiu.forkJoin)((0, $ekYYx.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((articlesResponse)=>(0, $lmrcQ.fetchArticlesSuccess)(articlesResponse, categoryId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(error.statusCode)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $lmrcQ.fetchArticlesFailure)(error, portalId, categoryId));
        }), (0, $4fLGk.fetchCategories)({
            projectId: projectId
        }).map((categoriesResponse)=>(0, $2hqAY.fetchCategoriesSuccess)(categoriesResponse, portalId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(error.statusCode)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $2hqAY.fetchCategoriesFailure)(error, portalId));
        })).mergeMap(([articlesSuccessOrFailure, categoriesSuccessOrFailure])=>(0, $9aoKF.concat)((0, $jFk35.Observable).of(articlesSuccessOrFailure), (0, $jFk35.Observable).of(categoriesSuccessOrFailure)));
        return (0, $ekYYx.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((response)=>{
            return (0, $lmrcQ.fetchArticlesSuccess)(response, categoryId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(error.statusCode)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $lmrcQ.fetchArticlesFailure)(error, portalId, categoryId));
        });
    });
};
var $39e8488908222707$export$2e2bcd8739ae039 = $39e8488908222707$var$categoryArticlesEpic;

});
parcelRegister("4fLGk", function(module, exports) {
$parcel$export(module.exports, "fetchCategories", () => $aede5261300fc778$export$416ec9f5729de215);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6LH8a = parcelRequire("6LH8a");

var $f60co = parcelRequire("f60co");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $aede5261300fc778$var$mapApolloErrorResponse = (error)=>{
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: error.message || ''
    };
};
const $aede5261300fc778$export$416ec9f5729de215 = ({ projectId: projectId, contextPath: contextPath = (0, $diqlM.contextPath) })=>{
    const activationId = (0, $6LH8a.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category`;
    return (0, $bTjsX.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $aIVqJ.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $jFk35.Observable).throw($aede5261300fc778$var$mapApolloErrorResponse(e));
    });
};

});

parcelRegister("ekYYx", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesForCategory", () => $dbf75457c89713f2$export$b51ae2f6685b749);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6LH8a = parcelRequire("6LH8a");

var $6dipk = parcelRequire("6dipk");

var $f60co = parcelRequire("f60co");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");

var $c7a4S = parcelRequire("c7a4S");
const $dbf75457c89713f2$var$errorKeyToMessage = {
    'jsd.apollo.error.category.not.found': (0, $c7a4S.default).categoryNotFound,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $c7a4S.default).noPermission,
    'jsd.apollo.error.article.not.found': (0, $c7a4S.default).articleNotFound
};
const $dbf75457c89713f2$var$mapApolloErrorResponse = (error)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = error.response;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (response && response.errorKey && $dbf75457c89713f2$var$errorKeyToMessage[response.errorKey]) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const translatedMessage = $dbf75457c89713f2$var$errorKeyToMessage[response.errorKey];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return {
            ...error.response,
            errorMessage: translatedMessage
        };
    }
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: ''
    };
};
const $dbf75457c89713f2$export$b51ae2f6685b749 = ({ projectId: projectId, categoryId: categoryId, contextPath: contextPath = (0, $diqlM.contextPath) })=>{
    const queryString = $6dipk.stringify({
        limit: 100,
        orderBy: '+featured',
        expand: 'category'
    });
    const activationId = (0, $6LH8a.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category/${categoryId}/article?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $aIVqJ.trackError)('category.article.fetch.failed', {}, e);
        return (0, $jFk35.Observable).throw($dbf75457c89713f2$var$mapApolloErrorResponse(e));
    });
};

});
parcelRegister("c7a4S", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6b37b754d42b615$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $d6b37b754d42b615$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    categoryNotFound: {
        id: 'cv.error.page.category.page.category.not.found',
        defaultMessage: "That category doesn't exist.",
        description: 'The error message shown when the category not found on the category page.'
    },
    articleNotFound: {
        id: 'cv.error.page.category.page.article.not.found',
        defaultMessage: "That article doesn't exist.",
        description: 'The error message shown when the requested article was not found on the category page.'
    },
    noPermission: {
        id: 'cv.error.page.category.page.no-permission',
        defaultMessage: 'You do not have permission to view this category. Ask an admin to check your permissions.',
        description: 'The error shown when the user does not have permission to add categories to the project.'
    },
    callToActionText: {
        id: 'cv.error.page.category.page.call.to.action',
        defaultMessage: 'Go back',
        description: 'Call to action message shown when an error occurs on the category page'
    }
});

});


parcelRegister("2t72L", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesSuccess", () => (parcelRequire("lmrcQ")).fetchArticlesSuccess);
$parcel$export(module.exports, "fetchArticlesFailure", () => (parcelRequire("lmrcQ")).fetchArticlesFailure);

var $lmrcQ = parcelRequire("lmrcQ");

});
parcelRegister("lmrcQ", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES_SUCCESS", () => $ef97447d0eef4360$export$76b83d637130c0fa);
$parcel$export(module.exports, "FETCH_ARTICLES_FAILURE", () => $ef97447d0eef4360$export$7c415676e9f98e60);
$parcel$export(module.exports, "fetchArticlesSuccess", () => $ef97447d0eef4360$export$5a1d149417c43ad9);
$parcel$export(module.exports, "fetchArticlesFailure", () => $ef97447d0eef4360$export$47896f258d652153);
const $ef97447d0eef4360$export$76b83d637130c0fa = 'state.persisted.kb.articles.FETCH_ARTICLES_SUCCESS';
const $ef97447d0eef4360$export$7c415676e9f98e60 = 'state.persisted.kb.articles.FETCH_ARTICLES_FAILURE';
const $ef97447d0eef4360$export$5a1d149417c43ad9 = (response, categoryId)=>({
        type: $ef97447d0eef4360$export$76b83d637130c0fa,
        payload: {
            response: response,
            categoryId: categoryId
        }
    });
const $ef97447d0eef4360$export$47896f258d652153 = (error, portalId, categoryId)=>({
        type: $ef97447d0eef4360$export$7c415676e9f98e60,
        payload: {
            error: error,
            portalId: portalId,
            categoryId: categoryId
        }
    });

});


parcelRegister("2hp8E", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => (parcelRequire("2hqAY")).FETCH_CATEGORIES_SUCCESS);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => (parcelRequire("2hqAY")).FETCH_CATEGORIES_FAILURE);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => (parcelRequire("2hqAY")).fetchCategoriesSuccess);
$parcel$export(module.exports, "fetchCategoriesFailure", () => (parcelRequire("2hqAY")).fetchCategoriesFailure);

var $2hqAY = parcelRequire("2hqAY");

});
parcelRegister("2hqAY", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => $3029dca50c555557$export$8fe15054f89178e3);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => $3029dca50c555557$export$4425a101b60fad1);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => $3029dca50c555557$export$1372a078b0bbb728);
$parcel$export(module.exports, "fetchCategoriesFailure", () => $3029dca50c555557$export$10b1ac5b71f5513e);
const $3029dca50c555557$export$8fe15054f89178e3 = 'state.persisted.kb.categories.FETCH_CATEGORIES_SUCCESS';
const $3029dca50c555557$export$4425a101b60fad1 = 'state.persisted.kb.categories.FETCH_CATEGORIES_FAILURE';
const $3029dca50c555557$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $3029dca50c555557$export$1372a078b0bbb728 = (response, portalId)=>{
    if (Array.isArray(response)) return {
        type: $3029dca50c555557$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: response
        }
    };
    const isCategoriesSupported = response.categoriesSupported;
    return {
        type: $3029dca50c555557$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: isCategoriesSupported ? response.categories : $3029dca50c555557$export$baa53a1870be4bc5
        }
    };
};
const $3029dca50c555557$export$10b1ac5b71f5513e = (error, portalId)=>({
        type: $3029dca50c555557$export$4425a101b60fad1,
        payload: {
            error: error,
            portalId: portalId
        }
    });

});


parcelRegister("2EMow", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES", () => $8fbe5c919227082d$export$d5cdb0266add81c8);
$parcel$export(module.exports, "fetchArticlesAction", () => $8fbe5c919227082d$export$43937e098a3fb347);
const $8fbe5c919227082d$export$d5cdb0266add81c8 = 'epic.model.FETCH_KB_ARTICLES';
const $8fbe5c919227082d$export$43937e098a3fb347 = (params)=>{
    const { projectId: projectId, portalId: portalId, categoryId: categoryId, categoryDataRequired: categoryDataRequired, meta: meta } = params;
    return {
        type: $8fbe5c919227082d$export$d5cdb0266add81c8,
        payload: {
            projectId: projectId,
            portalId: portalId,
            categoryId: categoryId,
            categoryDataRequired: categoryDataRequired,
            meta: meta
        }
    };
};

});


parcelRegister("3CpLJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe2cd499d24b3c1$export$2e2bcd8739ae039);

var $jFk35 = parcelRequire("jFk35");

var $4fLGk = parcelRequire("4fLGk");
parcelRequire("2hp8E");
var $2hqAY = parcelRequire("2hqAY");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");

var $eSLE4 = parcelRequire("eSLE4");
const $1fe2cd499d24b3c1$var$categoriesEpic = (action$)=>{
    return action$.ofType((0, $eSLE4.FETCH_CATEGORIES)).mergeMap((action)=>{
        const { portalId: portalId, projectId: projectId, meta: meta } = action.payload;
        return (0, $4fLGk.fetchCategories)({
            projectId: projectId
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $2hqAY.fetchCategoriesSuccess)(response, portalId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $17nJI.isNetworkOrClientErrorCode)(error.statusCode)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $2hqAY.fetchCategoriesFailure)(error, portalId));
        });
    });
};
var $1fe2cd499d24b3c1$export$2e2bcd8739ae039 = $1fe2cd499d24b3c1$var$categoriesEpic;

});
parcelRegister("eSLE4", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES", () => $56a4a28029092fef$export$cce9a7031b65f96c);
$parcel$export(module.exports, "fetchCategoriesAction", () => $56a4a28029092fef$export$10813fa84276d50);
const $56a4a28029092fef$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $56a4a28029092fef$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $56a4a28029092fef$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});


parcelRegister("jp9ha", function(module, exports) {
$parcel$export(module.exports, "languagesEpic", () => $da987210b2424afe$export$f18fac0a77b35e0d);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("9CX1u");
var $fYB4S = parcelRequire("fYB4S");

var $fASm6 = parcelRequire("fASm6");
const $da987210b2424afe$export$f18fac0a77b35e0d = (action$)=>{
    return action$.ofType((0, $fYB4S.FETCH_LANGUAGES_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.availableLanguages).map((response)=>{
            return (0, $fYB4S.fetchLanguagesSuccess)(response.availableLanguages || []);
        }).catch((_)=>{
            return (0, $jFk35.Observable).of((0, $5kfOu.showErrorFlag)((0, $fASm6.genericError).title, (0, $fASm6.genericError).description));
        }));
};

});
parcelRegister("9CX1u", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => (parcelRequire("fYB4S")).FETCH_LANGUAGES_SUCCESS);
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => (parcelRequire("fYB4S")).FETCH_LANGUAGES_MODEL);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => (parcelRequire("fYB4S")).fetchLanguagesSuccess);
$parcel$export(module.exports, "fetchLanguagesModel", () => (parcelRequire("fYB4S")).fetchLanguagesModel);

var $fYB4S = parcelRequire("fYB4S");

});
parcelRegister("fYB4S", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => $b46b33f9a2a2883e$export$50695c17a56afb1c);
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => $b46b33f9a2a2883e$export$e4a250eae790b1c0);
$parcel$export(module.exports, "fetchLanguagesModel", () => $b46b33f9a2a2883e$export$93153c0d57b5d23f);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => $b46b33f9a2a2883e$export$5ecfd42a9b3d2b31);

var $dv0hN = parcelRequire("dv0hN");
const $b46b33f9a2a2883e$export$50695c17a56afb1c = 'epic.model.FETCH_LANGUAGES_MODEL';
const $b46b33f9a2a2883e$export$e4a250eae790b1c0 = 'state.persisted.languages.FETCH_LANGUAGES_SUCCESS';
const $b46b33f9a2a2883e$export$93153c0d57b5d23f = (0, $dv0hN.buildModelsActionCreator)($b46b33f9a2a2883e$export$50695c17a56afb1c, 'availableLanguages');
const $b46b33f9a2a2883e$export$5ecfd42a9b3d2b31 = (languages)=>({
        type: $b46b33f9a2a2883e$export$e4a250eae790b1c0,
        payload: {
            languages: languages
        }
    });

});



parcelRegister("d9wAa", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $fb17fe8a0d8217ce$export$da8045e9cad7ec9b);

var $5W771 = parcelRequire("5W771");

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");

var $1wdH4 = parcelRequire("1wdH4");
const $fb17fe8a0d8217ce$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $1wdH4.FETCH_LOGIN_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.login && !(0, (/*@__PURE__*/$parcel$interopDefault($5W771)))(response.login)).map((response)=>{
            return (0, $6oW6S.fetchLoginSuccess)(response.login);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $6oW6S.fetchLoginFailure)(error));
        }));
};

});
parcelRegister("5W771", function(module, exports) {

var $eiAbe = parcelRequire("eiAbe");

var $eZ3ti = parcelRequire("eZ3ti");

var $93JwG = parcelRequire("93JwG");

var $hl35j = parcelRequire("hl35j");

var $4kWWy = parcelRequire("4kWWy");

var $kA7Y3 = parcelRequire("kA7Y3");

var $f3JeU = parcelRequire("f3JeU");

var $9l2OA = parcelRequire("9l2OA");
/** `Object#toString` result references. */ var $4527e2deb2309318$var$mapTag = '[object Map]', $4527e2deb2309318$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $4527e2deb2309318$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4527e2deb2309318$var$hasOwnProperty = $4527e2deb2309318$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $4527e2deb2309318$var$isEmpty(value) {
    if (value == null) return true;
    if ($4kWWy(value) && ($hl35j(value) || typeof value == 'string' || typeof value.splice == 'function' || $kA7Y3(value) || $9l2OA(value) || $93JwG(value))) return !value.length;
    var tag = $eZ3ti(value);
    if (tag == $4527e2deb2309318$var$mapTag || tag == $4527e2deb2309318$var$setTag) return !value.size;
    if ($f3JeU(value)) return !$eiAbe(value).length;
    for(var key in value){
        if ($4527e2deb2309318$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $4527e2deb2309318$var$isEmpty;

});

parcelRegister("1wdH4", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_MODEL", () => $3bbc17b0ddfedc88$export$c7e01c95750f0d63);
$parcel$export(module.exports, "fetchLoginModel", () => $3bbc17b0ddfedc88$export$6e443fe31e715257);

var $dv0hN = parcelRequire("dv0hN");
const $3bbc17b0ddfedc88$export$c7e01c95750f0d63 = 'epic.model.FETCH_LOGIN_MODEL';
const $3bbc17b0ddfedc88$export$6e443fe31e715257 = (0, $dv0hN.buildModelsActionCreator)($3bbc17b0ddfedc88$export$c7e01c95750f0d63, 'login');

});


parcelRegister("5i23l", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsEpic", () => $162ad53831b3e0c1$export$8abec8cdaadd5d28);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("700aU");
var $dxx1m = parcelRequire("dxx1m");

var $cf3fd = parcelRequire("cf3fd");

var $ctX1C = parcelRequire("ctX1C");
const $162ad53831b3e0c1$export$32d9db53927095d3 = {
    defaultLocale: '',
    translatedLoginAnnouncements: {}
};
const $162ad53831b3e0c1$export$8abec8cdaadd5d28 = (action$)=>{
    return action$.ofType((0, $dxx1m.FETCH_LOGIN_ANNOUNCEMENTS)).mergeMap((action)=>{
        if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)()) return (0, $jFk35.Observable).from((0, $ctX1C.fetchLoginAnnouncementsData)().toPromise().then((response)=>(0, $ctX1C.convertToLoginAnnouncementsResponse)(response))).filter((data)=>Boolean(data)).map((data)=>{
            if (data) return (0, $dxx1m.fetchLoginAnnouncementsSuccess)(data);
            return (0, $dxx1m.fetchLoginAnnouncementsSuccess)($162ad53831b3e0c1$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $dxx1m.fetchLoginAnnouncementsFailure)(error));
        });
        return (0, $b4gcU.default)(action.payload).filter((response)=>Boolean(response)).map((response)=>{
            if (response.loginAnnouncements) return (0, $dxx1m.fetchLoginAnnouncementsSuccess)(response.loginAnnouncements);
            return (0, $dxx1m.fetchLoginAnnouncementsSuccess)($162ad53831b3e0c1$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $dxx1m.fetchLoginAnnouncementsFailure)(error));
        });
    });
};

});
parcelRegister("ctX1C", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementsData", () => $33aab79880da7625$export$32c914da1ff32f72);
$parcel$export(module.exports, "convertToLoginAnnouncementsResponse", () => $33aab79880da7625$export$a8a0b51b62d54e0);

var $h8uqZ = parcelRequire("h8uqZ");

var $6LH8a = parcelRequire("6LH8a");

var $5KQKg = parcelRequire("5KQKg");

var $1xOZp = parcelRequire("1xOZp");
const $33aab79880da7625$export$32c914da1ff32f72 = ()=>{
    return (0, $5KQKg.fetchQuery)((0, $1xOZp.getRelayEnvironment)(), (0, $h8uqZ.default), {
        cloudId: (0, $6LH8a.getCloudId)(),
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)()
    });
};
const $33aab79880da7625$var$mergeNameAndDescriptionTranslations = (nameTranslationsRaw, descriptionTranslationsRaw)=>{
    const translatedLoginAnnouncements = {};
    nameTranslationsRaw === null || nameTranslationsRaw === void 0 || nameTranslationsRaw.forEach((translationName)=>{
        const locale = translationName.locale;
        const header = translationName.value;
        const targetDescriptionAnnouncement = descriptionTranslationsRaw === null || descriptionTranslationsRaw === void 0 ? void 0 : descriptionTranslationsRaw.find((translationDescription)=>translationDescription.locale === locale);
        translatedLoginAnnouncements[locale] = {
            header: header,
            message: (targetDescriptionAnnouncement === null || targetDescriptionAnnouncement === void 0 ? void 0 : targetDescriptionAnnouncement.value) || '',
            localeDisplayName: translationName.localeDisplayName
        };
    });
    return translatedLoginAnnouncements;
};
const $33aab79880da7625$export$a8a0b51b62d54e0 = (response)=>{
    var _response$helpCenter, _data$announcements;
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && (_data$announcements = data.announcements) !== null && _data$announcements !== void 0 && (_data$announcements = _data$announcements.loginAnnouncements) !== null && _data$announcements !== void 0 && _data$announcements.length) {
        // Currently we only support one login announcement
        const targetLoginAnnouncement = data.announcements.loginAnnouncements[0];
        return {
            translatedLoginAnnouncements: $33aab79880da7625$var$mergeNameAndDescriptionTranslations(targetLoginAnnouncement.nameTranslationsRaw || [], targetLoginAnnouncement.descriptionTranslationsRaw || []),
            defaultLocale: data.siteDefaultLanguageTag || ''
        };
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && data.siteDefaultLanguageTag) // case then loginAnnouncements array is empty but siteDefaultLanguageTag is present, we have to map default locale
    return {
        translatedLoginAnnouncements: {
            [data.siteDefaultLanguageTag]: {
                localeDisplayName: data.siteDefaultLanguageTag,
                header: '',
                message: ''
            }
        },
        defaultLocale: data.siteDefaultLanguageTag
    };
    return null;
};

});
parcelRegister("h8uqZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4ad44f33685cbd3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9a2845fdb0ebf85b6c1c8816fcdfced>>
 * @relayHash 71f2f66044bc8f8bd3ab026ad2505549
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b
const $e4ad44f33685cbd3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b",
            "metadata": {},
            "name": "loginAnnouncementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e4ad44f33685cbd3$var$node.hash = "76319886fc90231eee48f51d80798d47";
var $e4ad44f33685cbd3$export$2e2bcd8739ae039 = $e4ad44f33685cbd3$var$node;

});



parcelRegister("lRMAu", function(module, exports) {
$parcel$export(module.exports, "organisationsEpic", () => $4f98d4831d3b04ab$export$11ed7e95538202ff);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");

var $1eY13 = parcelRequire("1eY13");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("lQHAL");
var $lrRyo = parcelRequire("lrRyo");
const $4f98d4831d3b04ab$export$11ed7e95538202ff = (action$)=>{
    return action$.ofType((0, $1eY13.FETCH_ORGANISATIONS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.organisations && !(0, $aYMdQ.isEmpty)(response.organisations)).map((response)=>{
            return (0, $lrRyo.updateOrganisationsModelAction)(response.organisations);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $jFk35.Observable).never()));
};
var $4f98d4831d3b04ab$export$2e2bcd8739ae039 = $4f98d4831d3b04ab$export$11ed7e95538202ff;

});
parcelRegister("1eY13", function(module, exports) {
$parcel$export(module.exports, "FETCH_ORGANISATIONS_MODEL", () => $ff763df005b1c9f8$export$b60557155cf3c6c0);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $ff763df005b1c9f8$export$cbdd5d7a098d34a2);

var $dv0hN = parcelRequire("dv0hN");
const $ff763df005b1c9f8$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $ff763df005b1c9f8$export$cbdd5d7a098d34a2 = (0, $dv0hN.buildModelsActionCreator)($ff763df005b1c9f8$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("lQHAL", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => (parcelRequire("lrRyo")).UPDATE_ORGANISATIONS_MODEL);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => (parcelRequire("lrRyo")).updateOrganisationsModelAction);

var $lrRyo = parcelRequire("lrRyo");

});
parcelRegister("lrRyo", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => $830815247052264b$export$1fb754e532426cdc);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => $830815247052264b$export$72c2e60e3f358ed9);
const $830815247052264b$export$1fb754e532426cdc = 'state.persisted.organisations.UPDATE_ORGANISATIONS_MODEL';
const $830815247052264b$export$72c2e60e3f358ed9 = (organisations)=>({
        payload: organisations,
        type: $830815247052264b$export$1fb754e532426cdc
    });

});



parcelRegister("ka5yY", function(module, exports) {
$parcel$export(module.exports, "portalEpic", () => $22a0a41bba791cc0$export$a9922bad2863d6ee);
$parcel$export(module.exports, "portalUploadMediaTokenEpic", () => $22a0a41bba791cc0$export$a5051d4620a9cd24);
$parcel$export(module.exports, "refreshPortalUploadMediaTokenBeforeExpiryEpic", () => $22a0a41bba791cc0$export$9bf2e8f39289e99a);

var $jFk35 = parcelRequire("jFk35");

var $cD8ok = parcelRequire("cD8ok");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");

var $aIVqJ = parcelRequire("aIVqJ");

var $b4gcU = parcelRequire("b4gcU");
const $22a0a41bba791cc0$export$a9922bad2863d6ee = (action$)=>{
    return action$.ofType((0, $hijaX.FETCH_PORTAL_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.portal && !!response.branding).map((response)=>{
            var _action$meta;
            if ((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(action.meta.analyticsSuccessEvent);
            return (0, $hijaX.fetchPortalSuccess)(response.portal, response.branding);
        }).catch((error)=>{
            var _action$meta2;
            if ((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.analyticsFailureEvent && error.status !== 0) (0, $aIVqJ.legacySendEvent)(action.meta.analyticsFailureEvent);
            const params = action.payload.params;
            return (0, $jFk35.Observable).of((0, $hijaX.fetchPortalFailure)(params.id, error));
        }));
};
const $22a0a41bba791cc0$export$a5051d4620a9cd24 = (action$)=>{
    return action$.ofType((0, $hijaX.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION)).mergeMap((action)=>{
        const portalId = action.payload.portalId;
        return (0, $cD8ok.getUploadCredentialsObservable)(portalId).map((response)=>(0, $hijaX.fetchPortalUploadMediaTokenSuccess)({
                ...response,
                tokenDurationInMins: (response.expiryEpoch - Date.now()) / 60000
            }, portalId)).catch(()=>{
            return (0, $jFk35.Observable).of((0, $hijaX.fetchPortalUploadMediaTokenFailure)());
        });
    });
};
const $22a0a41bba791cc0$export$9bf2e8f39289e99a = (action$)=>{
    return action$.ofType((0, $hijaX.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS), (0, $hijaX.FETCH_PORTAL_SUCCESS)).switchMap((action)=>{
        const uploadContext = action.payload.mediaApiUploadInformation;
        if (uploadContext && 'token' in uploadContext) {
            const mediaApiUploadToken = uploadContext;
            // gets the token duration in milliseconds minus 5 minute buffer for network calls/inactive tab throttling
            const wantsRefreshAt = mediaApiUploadToken.tokenDurationInMins * 60000 - 300000;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt);
            const portalId = action.type === (0, $hijaX.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS) ? action.payload.portalId : action.payload.id;
            if (portalId) return (0, $jFk35.Observable).of((0, $hijaX.fetchPortalUploadMediaTokenAction)(Number(portalId))).delay(timeUntilRefresh);
        }
        return (0, $jFk35.Observable).empty();
    });
};

});
parcelRegister("cD8ok", function(module, exports) {
$parcel$export(module.exports, "getUploadCredentials", () => $a45dcee4aef5e29c$export$1d8e51ec2b973100);
$parcel$export(module.exports, "getUploadCredentialsObservable", () => $a45dcee4aef5e29c$export$42e3feb9754fda17);
$parcel$export(module.exports, "getCredentialsForMediaRequest", () => $a45dcee4aef5e29c$export$ec7ab5d74f1f3c37);
$parcel$export(module.exports, "getUploadCredentialsForRequest", () => $a45dcee4aef5e29c$export$766d1bd3b5e7fe1b);
$parcel$export(module.exports, "getReadCredentialsForRequest", () => $a45dcee4aef5e29c$export$9748c08f8d568d41);

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $a45dcee4aef5e29c$export$1d8e51ec2b973100 = (portalId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $a45dcee4aef5e29c$export$42e3feb9754fda17 = (portalId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $a45dcee4aef5e29c$export$ec7ab5d74f1f3c37 = (portalId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload/inline`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $a45dcee4aef5e29c$export$766d1bd3b5e7fe1b = (portalId, requestId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $a45dcee4aef5e29c$export$9748c08f8d568d41 = (portalId, requestId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/read`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers).map((response)=>response.response);
};

});

parcelRegister("cizQ1", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => (parcelRequire("hijaX")).FETCH_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => (parcelRequire("hijaX")).FETCH_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => (parcelRequire("hijaX")).FETCH_PORTAL_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => (parcelRequire("hijaX")).UPDATE_PORTAL_ANNOUNCEMENT_MODEL);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => (parcelRequire("hijaX")).UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => (parcelRequire("hijaX")).UPDATE_PORTAL_ANNOUNCEMENT_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("hijaX")).UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => (parcelRequire("hijaX")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => (parcelRequire("hijaX")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS);
$parcel$export(module.exports, "fetchPortalAction", () => (parcelRequire("hijaX")).fetchPortalAction);
$parcel$export(module.exports, "fetchPortalSuccess", () => (parcelRequire("hijaX")).fetchPortalSuccess);
$parcel$export(module.exports, "fetchPortalFailure", () => (parcelRequire("hijaX")).fetchPortalFailure);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => (parcelRequire("hijaX")).updatePortalAnnouncementModel);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => (parcelRequire("hijaX")).updatePortalAnnouncementSuccess);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => (parcelRequire("hijaX")).updatePortalAnnouncementFailure);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => (parcelRequire("hijaX")).updatePortalAnnouncementsUIState);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => (parcelRequire("hijaX")).fetchPortalUploadMediaTokenAction);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => (parcelRequire("hijaX")).fetchPortalUploadMediaTokenSuccess);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => (parcelRequire("hijaX")).fetchPortalUploadMediaTokenFailure);

var $hijaX = parcelRequire("hijaX");

});
parcelRegister("hijaX", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => $7467fb134d1fc94e$export$fca1c6628f14bdf2);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => $7467fb134d1fc94e$export$b929cb285face2c);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => $7467fb134d1fc94e$export$d0378806ff79f20f);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => $7467fb134d1fc94e$export$f1992600da6904c6);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => $7467fb134d1fc94e$export$9181049110925f2a);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => $7467fb134d1fc94e$export$d5fa92c7d79f8706);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => $7467fb134d1fc94e$export$6a473efc246ca86a);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => $7467fb134d1fc94e$export$eedf58a097d7a901);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => $7467fb134d1fc94e$export$c769ac1c1c5f67f5);
$parcel$export(module.exports, "fetchPortalAction", () => $7467fb134d1fc94e$export$8262b38db2952a96);
$parcel$export(module.exports, "fetchPortalSuccess", () => $7467fb134d1fc94e$export$c9cc1b81c69f8b54);
$parcel$export(module.exports, "fetchPortalFailure", () => $7467fb134d1fc94e$export$bc631fe34431953a);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => $7467fb134d1fc94e$export$a2c25b3a57d1e1e1);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => $7467fb134d1fc94e$export$1cb4859b979a107e);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => $7467fb134d1fc94e$export$a71bb12efca5ed02);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => $7467fb134d1fc94e$export$7f7bb35e246605cc);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => $7467fb134d1fc94e$export$82b91227c2617f7c);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => $7467fb134d1fc94e$export$977a37e5820c7d60);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => $7467fb134d1fc94e$export$5531ab3802c122e6);

var $dv0hN = parcelRequire("dv0hN");
const $7467fb134d1fc94e$export$fca1c6628f14bdf2 = 'epic.model.FETCH_PORTAL_MODEL';
const $7467fb134d1fc94e$export$b929cb285face2c = 'state.persisted.portals.FETCH_PORTAL_SUCCESS';
const $7467fb134d1fc94e$export$d0378806ff79f20f = 'state.persisted.portals.FETCH_PORTAL_FAILURE';
const $7467fb134d1fc94e$export$f1992600da6904c6 = 'epic.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENT_MODEL';
const $7467fb134d1fc94e$export$9181049110925f2a = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS';
const $7467fb134d1fc94e$export$d5fa92c7d79f8706 = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE';
const $7467fb134d1fc94e$export$6a473efc246ca86a = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION';
const $7467fb134d1fc94e$export$eedf58a097d7a901 = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $7467fb134d1fc94e$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE';
const $7467fb134d1fc94e$export$c769ac1c1c5f67f5 = 'state.ui.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE';
const $7467fb134d1fc94e$export$8262b38db2952a96 = (payload, meta)=>({
        meta: meta,
        ...(0, $dv0hN.buildModelsActionCreator)($7467fb134d1fc94e$export$fca1c6628f14bdf2, 'portal')(payload)
    });
const $7467fb134d1fc94e$export$c9cc1b81c69f8b54 = (portalModel, portalBrandingResponse)=>{
    return {
        payload: {
            ...portalBrandingResponse,
            ...portalModel
        },
        type: $7467fb134d1fc94e$export$b929cb285face2c
    };
};
const $7467fb134d1fc94e$export$bc631fe34431953a = (portalId, error)=>({
        type: $7467fb134d1fc94e$export$d0378806ff79f20f,
        payload: {
            portalId: portalId,
            error: error
        }
    });
const $7467fb134d1fc94e$export$a2c25b3a57d1e1e1 = (portalId, portalAnnouncementModel, meta)=>({
        portalId: portalId,
        meta: meta,
        type: $7467fb134d1fc94e$export$f1992600da6904c6,
        payload: portalAnnouncementModel
    });
const $7467fb134d1fc94e$export$1cb4859b979a107e = (portalAnnouncementModel)=>({
        type: $7467fb134d1fc94e$export$9181049110925f2a,
        payload: portalAnnouncementModel
    });
const $7467fb134d1fc94e$export$a71bb12efca5ed02 = (error)=>({
        type: $7467fb134d1fc94e$export$d5fa92c7d79f8706,
        payload: {
            error: error
        }
    });
const $7467fb134d1fc94e$export$7f7bb35e246605cc = (portalAnnouncementModel)=>({
        type: $7467fb134d1fc94e$export$c769ac1c1c5f67f5,
        payload: portalAnnouncementModel
    });
const $7467fb134d1fc94e$export$82b91227c2617f7c = (portalId)=>({
        type: $7467fb134d1fc94e$export$6a473efc246ca86a,
        payload: {
            portalId: portalId
        }
    });
const $7467fb134d1fc94e$export$977a37e5820c7d60 = (mediaUploadToken, portalId)=>{
    return {
        type: $7467fb134d1fc94e$export$eedf58a097d7a901,
        payload: {
            portalId: portalId,
            mediaApiUploadInformation: mediaUploadToken
        }
    };
};
const $7467fb134d1fc94e$export$5531ab3802c122e6 = ()=>{
    return {
        type: $7467fb134d1fc94e$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE
    };
};

});



parcelRegister("5aitR", function(module, exports) {
$parcel$export(module.exports, "requestCreateEpic", () => $9740ac46864f058e$export$a2b66173a86c1319);

var $jFk35 = parcelRequire("jFk35");

var $hN5YJ = parcelRequire("hN5YJ");

var $b4gcU = parcelRequire("b4gcU");

var $9JVIU = parcelRequire("9JVIU");

var $keYO2 = parcelRequire("keYO2");
parcelRequire("ljSph");
var $1mt5N = parcelRequire("1mt5N");

var $YWCnr = parcelRequire("YWCnr");

var $ay3bN = parcelRequire("ay3bN");
parcelRequire("ehZx5");
var $2ae6t = parcelRequire("2ae6t");
const $9740ac46864f058e$export$a2b66173a86c1319 = (action$)=>{
    return action$.ofType((0, $1mt5N.FETCH_REQUEST_CREATE_MODEL)).mergeMap((action)=>{
        const portalId = action.payload && action.payload.params && action.payload.params.portalId;
        const requestTypeId = action.payload && action.payload.params && action.payload.params.id;
        if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)()) return (0, $b4gcU.default)(action.payload).filter((response)=>!!response.reqCreate).mergeMap((response)=>{
            return $9740ac46864f058e$var$hydrateUrlParamOverrides(response.reqCreate, portalId, requestTypeId).then(({ requestCreateResponse: requestCreateResponse, hydratedUrlParamOverrides: hydratedUrlParamOverrides })=>(0, $1mt5N.fetchRequestCreateSuccess)({
                    ...requestCreateResponse,
                    hydratedUrlParamOverrides: hydratedUrlParamOverrides,
                    portalId: portalId
                }));
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $jFk35.Observable).of((0, $1mt5N.fetchRequestCreateFailure)(portalId, params.id, error));
        });
        return (0, $b4gcU.default)(action.payload).filter((response)=>!!response.reqCreate).map((response)=>{
            return (0, $1mt5N.fetchRequestCreateSuccess)({
                ...response.reqCreate,
                portalId: portalId,
                hydratedUrlParamOverrides: {}
            });
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $jFk35.Observable).of((0, $1mt5N.fetchRequestCreateFailure)(portalId, params.id, error));
        });
    });
};
/**
 * Builds a set of URL param overrides from the query parameters, and attempts to hydrate any overrides
 * for dynamic fields.
 *
 * This should never break the request create flow. If a dynamic field cannot be hydrated successfully (failed
 * API call), this function will proceed as though a URL override was not provided for that field.
 */ const $9740ac46864f058e$var$hydrateUrlParamOverrides = async (requestCreateResponse, portalId, requestTypeId)=>{
    const fieldStates = (0, $YWCnr.toFieldStates)(requestCreateResponse.fields);
    const fieldStatesMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    const fieldValueOverrides = (0, $ay3bN.parseFieldUrlParams)(fieldStates);
    const asyncFieldStatesWithDependencies = [];
    // This is a map used to store a representation of all current field values (including any hydrated ones)
    // so that it can be sent in the payload for CMDB queries. CMDB queries require this since AQL can filter
    // based on dependencies on other fields.
    const fieldValueMap = fieldStates.reduce((valueMap, field)=>{
        var _field$value;
        valueMap[field.id] = (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.toString();
        return valueMap;
    }, {});
    // Mapping all dynamic pre-fill fields to promises so they can be hydrated in parallel.
    // Fields with dependencies need to be mapped last so we can populate the fielValueMap
    // as much as possible. The only known field with dependencies at the moment are CMDB fields.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const asyncFieldValuePromises = fieldStates.map((fieldState)=>{
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                // We don't resolve CMDB fields immediately because they may have dependencies that need to be resolved first
                asyncFieldStatesWithDependencies.push(fieldState);
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'userpicker':
                return $9740ac46864f058e$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'reporter':
                return $9740ac46864f058e$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'multiuserpicker':
                return $9740ac46864f058e$var$getMultiUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'organisationpicker':
                return $9740ac46864f058e$var$getOrganisationPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, undefined, requestCreateResponse.userOrganisations);
            case 'entitlementpicker':
                // Entitlement picker value is just passed through as a string
                if (fieldValueOverrides[fieldState.id]) return Promise.resolve({
                    fieldId: fieldState.id,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    value: fieldValueOverrides[fieldState.id]
                });
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'multiservicepicker':
                return $9740ac46864f058e$var$getMultiServicePickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            // The following are static fields which have been converted into options. They need to be converted
            // to a different format for the fieldValueMap
            case 'labelpicker':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((defaultLabel)=>defaultLabel.value).toString();
                return undefined;
            case 'select':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].value;
                return undefined;
            case 'multiselect':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((multiSelectOverride)=>multiSelectOverride.value).toString();
                return undefined;
            // All other static field types don't need to be hydrated or transformed, so we can store them
            // directly on fieldValueMap
            default:
                // TODO: Work out the format for cascading select data. This is currently also broken in the existing
                // CMDB field implementation so we're only being consistent with how cascading fields work in
                // Portal view.
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].toString();
                return undefined;
        }
    }).filter((loader)=>loader !== undefined);
    // When storing the hydrated results of dynamic fields, we need to keep asyncFieldValueOverrides in sync with
    // fieldValueMap. They need to store the same results, but in a different representation.
    const asyncFieldValueOverrides = await Promise.all(asyncFieldValuePromises).then((results)=>results.reduce((accumulator, result)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            accumulator[result.fieldId] = result.value;
            if (result.value === undefined) return accumulator;
            const fieldType = fieldStatesMap[result.fieldId].type;
            switch(fieldType){
                case 'userpicker':
                case 'reporter':
                    {
                        const userValue = result.value;
                        fieldValueMap[result.fieldId] = userValue.accountId;
                        break;
                    }
                case 'multiuserpicker':
                    {
                        const userValues = result.value;
                        fieldValueMap[result.fieldId] = userValues.map((user)=>user.accountId).toString();
                        break;
                    }
                case 'organisationpicker':
                    {
                        const organisationValue = result.value;
                        fieldValueMap[result.fieldId] = organisationValue.id.toString();
                        break;
                    }
                case 'multiservicepicker':
                    {
                        const multiServiceValues = result.value;
                        if (multiServiceValues && multiServiceValues.length > 0) fieldValueMap[result.fieldId] = multiServiceValues.toString();
                        break;
                    }
                default:
                    break;
            }
            return accumulator;
        }, {}));
    // A for loop is needed because CMDB fields can depend on other CMDB fields. Hence we need to hydrate them one
    // at a time and make subsequent calls with an updated fieldValueMap.
    for (const fieldState of asyncFieldStatesWithDependencies){
        const fieldId = fieldState.id;
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                {
                    // oxlint-disable-next-line no-await-in-loop
                    const cmdbLoaderResult = await $9740ac46864f058e$var$getCmdbObjectLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap);
                    const cmdbPickerValue = cmdbLoaderResult.value;
                    asyncFieldValueOverrides[fieldId] = cmdbPickerValue;
                    if (cmdbPickerValue === undefined) break;
                    fieldValueMap[fieldId] = cmdbPickerValue.map((value)=>value.value).toString();
                    break;
                }
            default:
                break;
        }
    }
    const hydratedUrlParamOverrides = Object.fromEntries(Object.entries({
        ...fieldValueOverrides,
        ...asyncFieldValueOverrides
    }).filter(([, fieldValue])=>fieldValue !== undefined));
    return {
        requestCreateResponse: requestCreateResponse,
        hydratedUrlParamOverrides: hydratedUrlParamOverrides
    };
};
const $9740ac46864f058e$var$getMultiUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiUserPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof multiUserPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Split comma-separated user queries and search for each
    const userQueries = multiUserPickerQuery.split(',').map((query)=>query.trim()).filter((query)=>query.length > 0);
    if (userQueries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userSearchPromises = userQueries.map((query)=>(0, $keYO2.searchUser)({
            portalId: portalId,
            query: query,
            fieldName: fieldId,
            fieldConfigId: fieldState.fieldConfigId
        }).toPromise().then((userSearchResponse)=>{
            if (userSearchResponse.length === 0) return undefined;
            // Return the first matching user for this query
            const userResult = userSearchResponse[0];
            return {
                accountId: userResult.accountId,
                email: userResult.emailAddress,
                iconUrl: userResult.avatar,
                label: userResult.displayName,
                value: userResult.accountId
            };
        }).catch(()=>undefined));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Promise.all(userSearchPromises).then((results)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const users = results.filter((user)=>user !== undefined);
        return {
            fieldId: fieldState.id,
            value: users.length > 0 ? users : undefined
        };
    });
};
const $9740ac46864f058e$var$getUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const userPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof userPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return (0, $keYO2.searchUser)({
        portalId: portalId,
        query: userPickerQuery,
        fieldName: fieldId,
        fieldConfigId: fieldState.fieldConfigId
    }).toPromise().then((userSearchResponse)=>{
        if (userSearchResponse.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstUserResult = userSearchResponse[0];
        return {
            fieldId: fieldState.id,
            value: {
                accountId: firstUserResult.accountId,
                email: firstUserResult.emailAddress,
                iconUrl: firstUserResult.avatar,
                label: firstUserResult.displayName,
                value: firstUserResult.accountId
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};
const $9740ac46864f058e$var$getOrganisationPickerLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap, userOrganisations)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const organisationPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof organisationPickerQuery !== 'string' || !userOrganisations) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Try to match the URL parameter against user's organisations
    // First, try to match by ID (if the query is numeric)
    const queryAsId = parseInt(organisationPickerQuery, 10);
    if (!isNaN(queryAsId)) {
        const matchedOrgById = userOrganisations.find((org)=>org.id === queryAsId);
        if (matchedOrgById) return Promise.resolve({
            fieldId: fieldId,
            value: {
                id: matchedOrgById.id,
                name: matchedOrgById.name,
                domain: ''
            }
        });
    }
    // Try to match by name (case-insensitive)
    const matchedOrgByName = userOrganisations.find((org)=>org.name.toLowerCase() === organisationPickerQuery.toLowerCase());
    if (matchedOrgByName) return Promise.resolve({
        fieldId: fieldId,
        value: {
            id: matchedOrgByName.id,
            name: matchedOrgByName.name,
            domain: ''
        }
    });
    // No matching organisation found
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $9740ac46864f058e$var$getMultiServicePickerLoader = async (fieldState, fieldValueOverrides)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiServicePickerQuery = fieldValueOverrides[fieldState.id];
    if (!multiServicePickerQuery) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Handle both single value and array of values
    let queries = [];
    if (Array.isArray(multiServicePickerQuery)) queries = multiServicePickerQuery;
    else if (typeof multiServicePickerQuery === 'string') queries = [
        multiServicePickerQuery
    ];
    if (queries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    const matchedServiceIds = [];
    // For each query, try to find a matching service
    for (const query of queries)try {
        // Try to match by searching for the service name
        // oxlint-disable-next-line no-await-in-loop
        const result = await (0, $9JVIU.fetchServices)(query);
        // Find exact or partial match by name
        let matchedService = result.services.find((service)=>service.label.toLowerCase() === query.toLowerCase());
        // If no exact match, try to match by ID
        if (!matchedService) matchedService = result.services.find((service)=>service.value === query);
        if (matchedService) matchedServiceIds.push(matchedService.value);
    } catch (error) {
        // If fetch fails, continue to next query
        // oxlint-disable-next-line no-console
        console.warn(`Failed to fetch services for query: ${query}`, error);
    }
    if (matchedServiceIds.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return Promise.resolve({
        fieldId: fieldId,
        value: matchedServiceIds
    });
};
const $9740ac46864f058e$var$getCmdbObjectLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const cmdbPickerQuery = fieldValueOverrides[fieldState.id];
    const abortController = new AbortController();
    const { signal: signal } = abortController;
    if (typeof cmdbPickerQuery === 'string') return $9740ac46864f058e$var$getSingleCmdbObjectLoader(signal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId).then((cmdbResult)=>cmdbResult.value === undefined ? {
            fieldId: cmdbResult.fieldId,
            value: undefined
        } : {
            fieldId: cmdbResult.fieldId,
            value: [
                cmdbResult.value
            ]
        });
    if (Array.isArray(cmdbPickerQuery)) {
        const cmdbObjectPickerQueries = cmdbPickerQuery.filter((query)=>typeof query === 'string');
        const cmdbObjectPickerPromises = cmdbObjectPickerQueries.map((query)=>$9740ac46864f058e$var$getSingleCmdbObjectLoader(signal, query, fieldId, fieldValueMap, portalId, requestTypeId));
        return Promise.all(cmdbObjectPickerPromises).then((results)=>{
            const options = results.map((loaderResult)=>loaderResult.value).filter((option)=>option !== undefined);
            return {
                fieldId: fieldId,
                value: options.length === 0 ? undefined : options
            };
        });
    }
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $9740ac46864f058e$var$getSingleCmdbObjectLoader = (abortSignal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId)=>{
    return (0, $2ae6t.fetchCmdbObjectsWithSignal)(portalId, requestTypeId, fieldId, cmdbPickerQuery, Object.entries(fieldValueMap).filter(([_, fieldValue])=>!!fieldValue), abortSignal, 0).then((response)=>{
        const responseObjects = response.cmdbObjects;
        if (responseObjects.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstResult = responseObjects[0];
        return {
            fieldId: fieldId,
            value: {
                cmdbObject: firstResult,
                label: firstResult.label,
                value: firstResult.id
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};

});
parcelRegister("9JVIU", function(module, exports) {
$parcel$export(module.exports, "fetchServices", () => $d5bca597e983df14$export$aaba171dbee0d63b);

var $bTjsX = parcelRequire("bTjsX");

var $6LH8a = parcelRequire("6LH8a");

var $diqlM = parcelRequire("diqlM");
const $d5bca597e983df14$export$6ad2d0b3772389f4 = `
    query GetServices($cloudId: String!, $nameContains: String!, $first: Int!, $after: String) {
        devOpsServices(cloudId: $cloudId, filter: { nameContains: $nameContains }, first: $first, after: $after) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;
const $d5bca597e983df14$var$pageLimit = 20;
const $d5bca597e983df14$export$aaba171dbee0d63b = async (inputValue, after)=>(0, $bTjsX.post)(`${(0, $diqlM.contextPath)}/gateway/api/graphql`, JSON.stringify({
        query: $d5bca597e983df14$export$6ad2d0b3772389f4,
        variables: {
            after: after,
            cloudId: (0, $6LH8a.getMeta)('tenant-id'),
            nameContains: inputValue,
            first: $d5bca597e983df14$var$pageLimit
        }
    }), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const res = response;
        const { data: { devOpsServices: { nodes: nodes, pageInfo: { hasNextPage: hasNextPage, endCursor: endCursor } } } } = res;
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            services: nodes.map(({ id: id, name: name })=>({
                    label: name,
                    value: id
                }))
        };
    }).toPromise();

});

parcelRegister("keYO2", function(module, exports) {
$parcel$export(module.exports, "searchUser", () => $ab977354a1a930d4$export$c6a60b910185c7f2);
$parcel$export(module.exports, "updateUserProfile", () => $ab977354a1a930d4$export$c92c4ec7a2418617);
$parcel$export(module.exports, "changePassword", () => $ab977354a1a930d4$export$99d837dc30eb1ef7);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6dipk = parcelRequire("6dipk");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $ab977354a1a930d4$export$c6a60b910185c7f2 = (userQuery, context = (0, $diqlM.contextPath))=>{
    const query = {
        query: userQuery.query,
        fieldName: userQuery.fieldName,
        fieldConfigId: userQuery.fieldConfigId
    };
    const queryString = $6dipk.stringify(query);
    const uri = `${context}/rest/servicedesk/1/customer/portal/${userQuery.portalId}/user-search?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).catch((e)=>{
        (0, $aIVqJ.trackError)('finduser.fetch.failed', {}, e);
        return (0, $jFk35.Observable).throw(e);
    });
};
const $ab977354a1a930d4$export$c92c4ec7a2418617 = (displayName, languageKey, timezone, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user`;
    const body = {
        displayName: displayName,
        languageKey: languageKey,
        timezone: timezone
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $jFk35.Observable).throw(e);
    });
};
const $ab977354a1a930d4$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmNewPassword, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user/password`;
    const body = {
        current: currentPassword,
        password: newPassword,
        confirm: confirmNewPassword
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("ljSph", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => (parcelRequire("1mt5N")).FETCH_REQUEST_CREATE_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => (parcelRequire("1mt5N")).FETCH_REQUEST_CREATE_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => (parcelRequire("1mt5N")).FETCH_REQUEST_CREATE_FAILURE);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => (parcelRequire("1mt5N")).RESET_REQUEST_CREATE_STATE);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => (parcelRequire("1mt5N")).PROFORMA_FORM_DIRTY);
$parcel$export(module.exports, "fetchRequestCreateAction", () => (parcelRequire("1mt5N")).fetchRequestCreateAction);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => (parcelRequire("1mt5N")).fetchRequestCreateSuccess);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => (parcelRequire("1mt5N")).fetchRequestCreateFailure);
$parcel$export(module.exports, "proformaFormDirtyAction", () => (parcelRequire("1mt5N")).proformaFormDirtyAction);

var $1mt5N = parcelRequire("1mt5N");

});
parcelRegister("1mt5N", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => $6b1b366706cea671$export$d4d8c69b4715e057);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => $6b1b366706cea671$export$372a19d33177b0bf);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => $6b1b366706cea671$export$fee18c3aa48984ad);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => $6b1b366706cea671$export$8b4f4d20da5c4667);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => $6b1b366706cea671$export$b8bfd97914e38eff);
$parcel$export(module.exports, "fetchRequestCreateAction", () => $6b1b366706cea671$export$466553923c00f94b);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => $6b1b366706cea671$export$180824a15bbc742e);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => $6b1b366706cea671$export$fdc3fd637ad84f03);
$parcel$export(module.exports, "proformaFormDirtyAction", () => $6b1b366706cea671$export$b8e903edf5d19376);

var $dv0hN = parcelRequire("dv0hN");
const $6b1b366706cea671$export$d4d8c69b4715e057 = 'epic.model.FETCH_REQUEST_CREATE_MODEL';
const $6b1b366706cea671$export$372a19d33177b0bf = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_SUCCESS';
const $6b1b366706cea671$export$fee18c3aa48984ad = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_FAILURE';
const $6b1b366706cea671$export$8b4f4d20da5c4667 = 'state.persisted.reqCreate.RESET_REQUEST_CREATE_STATE';
const $6b1b366706cea671$export$67e1c6172c207525 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_ACTION';
const $6b1b366706cea671$export$9d7c65c6842f6093 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $6b1b366706cea671$export$751581aefd0ecd0 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_FAILURE';
const $6b1b366706cea671$export$b8bfd97914e38eff = 'state.persisted.reqCreate.PROFORMA_FORM_DIRTY';
const $6b1b366706cea671$export$466553923c00f94b = (0, $dv0hN.buildModelsActionCreator)($6b1b366706cea671$export$d4d8c69b4715e057, 'reqCreate');
const $6b1b366706cea671$export$180824a15bbc742e = (requestCreateResponse)=>({
        payload: requestCreateResponse,
        type: $6b1b366706cea671$export$372a19d33177b0bf
    });
const $6b1b366706cea671$export$fdc3fd637ad84f03 = (portalId, requestCreateId, error)=>({
        type: $6b1b366706cea671$export$fee18c3aa48984ad,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId,
            error: error
        }
    });
const $6b1b366706cea671$export$702e4cce91196841 = (portalId, requestCreateId)=>({
        type: $6b1b366706cea671$export$67e1c6172c207525,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    });
const $6b1b366706cea671$export$a6d0fa922519029e = (mediaApiUploadInformation, portalId, requestCreateId)=>{
    return {
        type: $6b1b366706cea671$export$9d7c65c6842f6093,
        payload: {
            mediaApiUploadInformation: mediaApiUploadInformation,
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    };
};
const $6b1b366706cea671$export$e9635fc96da2dc14 = ()=>{
    return {
        type: $6b1b366706cea671$export$751581aefd0ecd0
    };
};
const $6b1b366706cea671$export$4f2b3c2ed928ac62 = ()=>{
    return {
        type: $6b1b366706cea671$export$8b4f4d20da5c4667,
        payload: {}
    };
};
const $6b1b366706cea671$export$b8e903edf5d19376 = (payload)=>{
    return {
        payload: payload,
        type: $6b1b366706cea671$export$b8bfd97914e38eff
    };
};

});


parcelRegister("YWCnr", function(module, exports) {
$parcel$export(module.exports, "toFieldStates", () => $4611ca06523b3789$export$9144b5804cf423d6);

var $k2M4v = parcelRequire("k2M4v");

var $hN5YJ = parcelRequire("hN5YJ");

var $iY5sc = parcelRequire("iY5sc");
var $abJ7q = parcelRequire("abJ7q");

var $tHTQY = parcelRequire("tHTQY");
const $4611ca06523b3789$var$MAX_CMDB_OBJECTS_PER_FIELD = 20;
const $4611ca06523b3789$var$MAX_AFFECTED_SERVICES_PER_FIELD = 20;
const $4611ca06523b3789$export$9144b5804cf423d6 = (fields)=>{
    return fields.map((field)=>{
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'text':
                return $4611ca06523b3789$var$toTextFieldState(field);
            case 'textarea':
                return $4611ca06523b3789$var$toTextAreaState(field);
            case 'checkbox':
                return $4611ca06523b3789$var$toCheckboxGroupState(field);
            case 'radio':
                return $4611ca06523b3789$var$toRadioGroupState(field);
            case 'date':
            case 'duedate':
                return $4611ca06523b3789$var$toDateState(field, fieldType);
            case 'datetime':
                return $4611ca06523b3789$var$toDateTimeState(field);
            case 'attachment':
                return $4611ca06523b3789$var$toAttachmentState(field);
            case 'reporter':
                return $4611ca06523b3789$var$toReporterState(field);
            case 'userpicker':
                return $4611ca06523b3789$var$toUserPickerState(field);
            case 'multiuserpicker':
                return $4611ca06523b3789$var$toMultiUserPickerState(field);
            case 'organduserpicker':
                // When feature flag is off, treat as unknown (like before)
                return $4611ca06523b3789$var$toUnknownState(field);
            case 'labelpicker':
                return $4611ca06523b3789$var$toLabelPickerState(field);
            case 'select':
                return $4611ca06523b3789$var$toSelectState(field);
            case 'multiselect':
                return $4611ca06523b3789$var$toMultiSelectState(field);
            case 'organisationpicker':
                return $4611ca06523b3789$var$toOrganisationState(field);
            case 'assetspicker':
                return $4611ca06523b3789$var$toAssetsState(field);
            case 'multiservicepicker':
                return $4611ca06523b3789$var$toMultiServicePickerState(field);
            case 'cascadingselect':
                return $4611ca06523b3789$var$toCascadingSelect(field);
            case 'cmdbobjectpicker':
                return $4611ca06523b3789$var$toCmdbObjectPickerState(field);
            case 'entitlementpicker':
                return $4611ca06523b3789$var$toEntitlementPickerState(field);
            case 'cardnumber':
                // When the gate is off, keep the previous unknown-field behaviour.
                return (0, $hN5YJ.isJsmPciCardNumberFieldTypeEnabled)() ? $4611ca06523b3789$var$toSdCardNumberFieldState(field) : $4611ca06523b3789$var$toUnknownState(field);
            case 'forge':
                return $4611ca06523b3789$var$toForgeFieldState(field);
            default:
                return $4611ca06523b3789$var$toUnknownState(field);
        }
    });
};
/**
 * Parses defaultObjectAsJson and converts to an object if it can be parsed
 */ const $4611ca06523b3789$var$getDefaultObjectAsJsonFromField = (field)=>{
    const { defaultObjectAsJson: defaultObjectAsJson } = field;
    let defaultObj;
    try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultObj = defaultObjectAsJson && JSON.parse(defaultObjectAsJson);
    } catch (e) {
    // Swallow the error here
    }
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return defaultObj;
};
// This extracts all the common field properties, normally the only difference between fields are
// type and value
const $4611ca06523b3789$var$extractCommonFieldProperties = (field)=>({
        id: field.fieldId,
        displayed: field.displayed,
        label: field.label,
        required: field.required,
        description: field.descriptionHtml,
        ...(0, $hN5YJ.isUiModificationsSupportEnabled)() ? {
            jiraFieldType: field.jiraFieldType
        } : {}
    });
const $4611ca06523b3789$var$toSdCardNumberFieldState = (field)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        type: 'cardnumber',
        value: defaultObject ? defaultObject : ''
    };
};
const $4611ca06523b3789$var$toTextFieldState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'text',
        value: defaultObject ? defaultObject : ''
    };
};
const $4611ca06523b3789$var$toTextAreaState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, rendererType: rendererType, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    const emptyDefaultValue = (0, $hN5YJ.isRichTextAreaEnabled)() && rendererType === 'atlassian-wiki-renderer' ? undefined : '';
    return {
        ...baseFieldProperties,
        rendererType: rendererType,
        fieldConfigId: fieldConfigId,
        type: 'textarea',
        value: defaultObject ? defaultObject : emptyDefaultValue
    };
};
const $4611ca06523b3789$var$toCheckboxGroupState = (field)=>{
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const checkboxItems = fieldValues.map((fieldValue)=>({
            label: fieldValue.label,
            value: fieldValue.value,
            checked: fieldValue.selected
        }));
    const checkedItems = checkboxItems.filter((item)=>!!item.checked);
    const value = checkedItems.map((item)=>item.value);
    return {
        ...baseFieldProperties,
        value: value,
        type: 'checkbox',
        items: checkboxItems
    };
};
const $4611ca06523b3789$var$toRadioGroupState = (field)=>{
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const radioGroupItems = fieldValues.map((item)=>({
            name: field.fieldId,
            label: item.label,
            value: item.value,
            selected: item.selected
        }));
    const selectedItem = radioGroupItems.find((item)=>!!item.selected);
    const value = selectedItem ? selectedItem.value : '';
    return {
        ...baseFieldProperties,
        value: value,
        items: radioGroupItems,
        type: 'radio'
    };
};
const $4611ca06523b3789$var$IsoDateFormat = /^\d{4}-\d{2}-\d{2}$/;
const $4611ca06523b3789$var$normalizeDateTimeFromJson = (field, isoFormat)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    let defaultDate = $4611ca06523b3789$var$getDefaultObjectAsJsonFromField(field);
    if (!defaultDate || !(0, $abJ7q.default)(new Date(defaultDate))) // This needs fallback to undefined so the datetime picker sets todays date
    // as the initial screen correctly, else it's 1970.
    return undefined;
    // Fix for the one-day-off issue with new Date()
    // Link: [DateTime Picker One Day Off Issue](https://hello.atlassian.net/wiki/x/zwTjxw)
    if (defaultDate.match($4611ca06523b3789$var$IsoDateFormat)) defaultDate = defaultDate.replace(/-/g, '/');
    return (0, $iY5sc.default)(new Date(defaultDate), isoFormat);
};
const $4611ca06523b3789$var$toDateState = (field, fieldType)=>{
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $4611ca06523b3789$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd'),
        type: fieldType,
        value: $4611ca06523b3789$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd')
    };
};
const $4611ca06523b3789$var$toDateTimeState = (field)=>{
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $4611ca06523b3789$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm"),
        type: 'datetime',
        // We don't store timezone date, it's assumed the timezone will be the users timezone set in Jira.
        value: $4611ca06523b3789$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm")
    };
};
const $4611ca06523b3789$var$toReporterState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'reporter',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultReporter: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $4611ca06523b3789$var$toUserPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'userpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUser: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $4611ca06523b3789$var$toMultiUserPickerState = (field)=>{
    const defaultList = field.defaultList || [];
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'multiuserpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUsers: defaultList,
        fieldConfigId: field.fieldConfigId ? String(field.fieldConfigId) : '',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        value: defaultList.map((u)=>u.id).join(',')
    };
};
const $4611ca06523b3789$var$toSelectState = (field)=>{
    const selectedValue = field.values ? field.values.find((v)=>v.selected) : undefined;
    const value = selectedValue && selectedValue.value;
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        value: value,
        type: 'select',
        options: field.values || [],
        defaultValue: selectedValue
    };
};
const $4611ca06523b3789$var$toMultiSelectState = (field)=>{
    const selectedValues = field.values ? field.values.filter((v)=>v.selected) : [];
    const values = selectedValues.map((v)=>v.value);
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        type: 'multiselect',
        options: field.values || [],
        defaultValue: selectedValues,
        value: values
    };
};
const $4611ca06523b3789$var$toLabelPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const value = field.defaultList || [];
    /**
   * The field id takes the form of customfield_xxxx where xxxx is the custom field id.
   *
   * The field id can also be "label" if it is the system label field.
   * In the case where the field is the system field we will consider the custom field id to be undefiend
   */ const fieldIdTokens = (field.fieldId || '').toLowerCase().split('customfield_');
    const customFieldId = fieldIdTokens.length > 1 ? fieldIdTokens[1] : undefined;
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        value: value,
        customFieldId: customFieldId,
        type: 'labelpicker',
        defaultLabels: value.map((labelStr)=>({
                label: labelStr,
                value: labelStr
            }))
    };
};
const $4611ca06523b3789$var$toCascadingSelect = (field)=>{
    const selectedGroup = field.values && field.values.find((v)=>v.selected);
    const selectedValue = selectedGroup && selectedGroup.children.find((v)=>v.selected);
    const value = selectedGroup && {
        primaryValue: selectedGroup.value,
        children: selectedValue && selectedValue.value
    };
    /**
   * UI Modifications requires defaultValue because it includes both labels and values for parent and child options,
   * whereas the value field only contains the values. This enables the getValueTransformer to properly
   * reconstruct the complete option data structure with value and labels.
   */ const defaultValue = selectedGroup ? {
        primaryValue: {
            label: selectedGroup.label,
            value: selectedGroup.value
        },
        children: selectedValue ? {
            label: selectedValue.label,
            value: selectedValue.value
        } : undefined
    } : undefined;
    const options = field.values ? field.values.map((v)=>({
            label: v.label,
            value: v.value,
            children: v.children
        })) : [];
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        options: options,
        value: value,
        type: 'cascadingselect',
        ...(0, $hN5YJ.cascadingSelectDefaultValueSupportEnabled)() ? {
            defaultValue: defaultValue
        } : {}
    };
};
const $4611ca06523b3789$var$toOrganisationState = (field)=>{
    var _field$portalFieldCon;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { fieldConfigId: fieldConfigId, defaultObject: defaultObject } = field;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const shareWithOrgByDefault = ((_field$portalFieldCon = field.portalFieldConfiguration) === null || _field$portalFieldCon === void 0 ? void 0 : _field$portalFieldCon.shareWithOrgByDefault) ?? true;
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        fieldConfigId: fieldConfigId,
        shareWithOrgByDefault: // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        shareWithOrgByDefault,
        type: 'organisationpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
};
const $4611ca06523b3789$var$toAssetsState = (field)=>{
    const { fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        fieldConfigId: fieldConfigId,
        type: 'assetspicker'
    };
};
const $4611ca06523b3789$var$toMultiServicePickerState = (field)=>{
    var _field$portalFieldCon2;
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        type: 'multiservicepicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon2 = field.portalFieldConfiguration) === null || _field$portalFieldCon2 === void 0 ? void 0 : _field$portalFieldCon2.limit) ?? $4611ca06523b3789$var$MAX_AFFECTED_SERVICES_PER_FIELD
    };
};
const $4611ca06523b3789$var$toAttachmentState = (field)=>{
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        value: [],
        type: 'attachment'
    };
};
const $4611ca06523b3789$var$toCmdbObjectPickerState = (field)=>{
    var _field$portalFieldCon3, _field$portalFieldCon4, _field$portalFieldCon5;
    const assignScopeEnabled = (0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope');
    const config = field.portalFieldConfiguration;
    const autofill = assignScopeEnabled && config !== null && typeof config === 'object' && 'autofill' in config && config.autofill === true;
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        ...assignScopeEnabled ? {
            assignStrict: autofill && config !== null && typeof config === 'object' && 'assignStrict' in config && config.assignStrict === true
        } : {},
        hasValidConfig: Boolean(field.portalFieldConfiguration),
        type: 'cmdbobjectpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        isMulti: field.portalFieldConfiguration ? field.portalFieldConfiguration.isMulti : false,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        filterAttributes: field.portalFieldConfiguration ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        field.portalFieldConfiguration.filterAttributes : [],
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon3 = field.portalFieldConfiguration) === null || _field$portalFieldCon3 === void 0 ? void 0 : _field$portalFieldCon3.limit) ?? $4611ca06523b3789$var$MAX_CMDB_OBJECTS_PER_FIELD,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        placeholderKeys: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon4 = field.portalFieldConfiguration) === null || _field$portalFieldCon4 === void 0 ? void 0 : _field$portalFieldCon4.placeholderKeys) ?? undefined,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        populateDefaultValue: assignScopeEnabled ? autofill : // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon5 = field.portalFieldConfiguration) === null || _field$portalFieldCon5 === void 0 ? void 0 : _field$portalFieldCon5.populateDefaultValue) ?? false
    };
};
const $4611ca06523b3789$var$toEntitlementPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)()) return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
    return {
        ...$4611ca06523b3789$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker'
    };
};
const $4611ca06523b3789$var$toForgeFieldState = (field)=>{
    var _field$forge, _forgeExtension$prope, _forgeExtension$prope2;
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    const forgeExtension = (_field$forge = field.forge) === null || _field$forge === void 0 ? void 0 : _field$forge.extension;
    const fieldType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope = forgeExtension.properties) === null || _forgeExtension$prope === void 0 ? void 0 : _forgeExtension$prope.type;
    const collectionType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope2 = forgeExtension.properties) === null || _forgeExtension$prope2 === void 0 ? void 0 : _forgeExtension$prope2.collection;
    // defaultObject is typed as any in the Field type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const defaultObject = field.defaultObject;
    const defaultList = field.defaultList || [];
    const { value: value, additionalProps: additionalProps } = (0, $tHTQY.forgeFieldParamsParser)(fieldType, collectionType, defaultObject, defaultList);
    if ((0, $hN5YJ.isForgeCustomFieldsOnPortalViewEnabled)()) return {
        value: value,
        ...baseFieldProperties,
        ...additionalProps,
        type: 'forge',
        extension: forgeExtension
    };
    return {
        ...baseFieldProperties,
        type: 'forge',
        jiraFieldType: field.jiraFieldType // TODO: remove as with ditto_uim_-_jsm_support_main FF cleanup
    };
};
const $4611ca06523b3789$var$toUnknownState = (field)=>{
    const baseFieldProperties = $4611ca06523b3789$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'unknown'
    };
};

});
parcelRegister("tHTQY", function(module, exports) {
$parcel$export(module.exports, "forgeFieldParamsParser", () => $3f4d8f04fad5a971$export$ba975bd6e357689d);

var $iY5sc = parcelRequire("iY5sc");
const $3f4d8f04fad5a971$export$ba975bd6e357689d = (fieldType, collectionType, defaultObject, defaultList)=>{
    let value;
    let additionalProps = {};
    switch(fieldType){
        case 'string':
            if (collectionType === 'list') {
                value = defaultList;
                additionalProps = {
                    // String list is rendered as label picker
                    defaultLabels: value.map((labelStr)=>({
                            label: labelStr,
                            value: labelStr
                        }))
                };
            } else value = defaultObject;
            break;
        case 'number':
            value = defaultObject;
            break;
        case 'date':
            value = defaultObject ? (0, $iY5sc.default)(new Date(defaultObject), 'yyyy-MM-dd') : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'datetime':
            value = defaultObject ? (0, $iY5sc.default)(new Date(defaultObject), "yyyy-MM-dd'T'HH:mm") : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'user':
            if (collectionType === 'list') {
                value = defaultList.map((u)=>u.id).join(',');
                additionalProps = {
                    defaultUsers: defaultList
                };
            } else {
                value = defaultList && defaultList.length > 0 ? defaultList[0].id : undefined;
                additionalProps = {
                    defaultUser: defaultList[0]
                };
            }
            break;
        default:
            value = null;
            break;
    }
    return {
        value: value,
        additionalProps: additionalProps
    };
};

});


parcelRegister("ay3bN", function(module, exports) {
$parcel$export(module.exports, "parseFieldUrlParams", () => $cb35e69425553502$export$23f65b7a085343aa);

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");

var $6dipk = parcelRequire("6dipk");

var $2eOU2 = parcelRequire("2eOU2");

var $4MjGQ = parcelRequire("4MjGQ");

var $esgVk = parcelRequire("esgVk");
const $cb35e69425553502$var$CASCADE_SELECT_ID_SUFFIX = ':1';
function $cb35e69425553502$export$23f65b7a085343aa(fields) {
    if (!fields || fields.length === 0) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const urlParams = (0, $6dipk.parse)((0, $esgVk.search)());
    if (!urlParams) return {};
    return fields.reduce((values, field)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const urlParamValue = urlParams[field.id];
        if (urlParamValue !== undefined) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const cascadeNestedSelectUrlParamValue = urlParams[`${field.id}${$cb35e69425553502$var$CASCADE_SELECT_ID_SUFFIX}`];
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            values[field.id] = $cb35e69425553502$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue);
            if (cascadeNestedSelectUrlParamValue) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            values[`${field.id}${$cb35e69425553502$var$CASCADE_SELECT_ID_SUFFIX}`] = cascadeNestedSelectUrlParamValue;
        }
        return values;
    }, {});
}
function $cb35e69425553502$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue) {
    $cb35e69425553502$var$firePrePopAnalyticsEvent(field);
    switch(field.type){
        case 'labelpicker':
            return $cb35e69425553502$var$parseLabelsUrlParam(urlParamValue);
        case 'checkbox':
            {
                const checkboxGroup = field;
                return $cb35e69425553502$var$parseCheckboxUrlParam(urlParamValue, checkboxGroup.items);
            }
        case 'select':
            {
                const select = field;
                return $cb35e69425553502$var$parseSelectUrlParam(urlParamValue, select.options);
            }
        case 'multiselect':
            {
                const multiSelect = field;
                return $cb35e69425553502$var$parseMultiSelectUrlParam(urlParamValue, multiSelect.options);
            }
        case 'cascadingselect':
            {
                const cascadingSelectState = field;
                return $cb35e69425553502$var$parseCascadingSelectUrlParam(cascadingSelectState.options, urlParamValue, cascadeNestedSelectUrlParamValue);
            }
        case 'textarea':
            if ((0, $hN5YJ.isRichTextAreaEnabled)() && field.rendererType === 'atlassian-wiki-renderer') return $cb35e69425553502$var$parseRichTextAreaUrlParam(urlParamValue);
            return urlParamValue;
        case 'multiuserpicker':
            return urlParamValue;
        default:
            // Dynamic fields are handled directly in hydrateUrlParamOverrides() since async calls need to be made
            return urlParamValue;
    }
}
function $cb35e69425553502$var$firePrePopAnalyticsEvent(field) {
    const actionSubjectId = field.id.startsWith('customfield') ? 'customfield' : field.id;
    (0, $4MjGQ.operationalEvent)({
        actionSubjectId: actionSubjectId,
        action: 'prePopulated',
        actionSubject: 'field',
        source: (0, $9mazR.ScreenName).REQUEST_CREATE,
        attributes: {
            fieldType: field.type
        }
    });
}
function $cb35e69425553502$var$parseLabelsUrlParam(labels) {
    if ($cb35e69425553502$var$isEmptyStringOrArray(labels)) return [];
    if (typeof labels === 'string') {
        const singleLabel = labels;
        return [
            {
                label: singleLabel,
                value: singleLabel
            }
        ];
    }
    const multipleLabels = labels;
    return multipleLabels.map((toConvert)=>({
            label: toConvert,
            value: toConvert
        }));
}
const $cb35e69425553502$var$isEmptyStringOrArray = (value)=>value.length === 0;
const $cb35e69425553502$var$parseSelectUrlParam = (urlParam, options)=>options.find((option)=>option.value === urlParam);
function $cb35e69425553502$var$parseCheckboxUrlParam(checkedUrlParam, items) {
    if ($cb35e69425553502$var$isEmptyStringOrArray(checkedUrlParam)) return [];
    if (typeof checkedUrlParam === 'string') {
        const checkedBoxValue = checkedUrlParam;
        const checkedBox = items.find((item)=>item.value === checkedBoxValue);
        return checkedBox ? [
            checkedBox.value
        ] : [];
    }
    const checkedBoxValues = checkedUrlParam;
    return items.filter((item)=>checkedBoxValues.includes(item.value)).map((item)=>item.value);
}
function $cb35e69425553502$var$parseMultiSelectUrlParam(selected, options) {
    if ($cb35e69425553502$var$isEmptyStringOrArray(selected)) return [];
    if (typeof selected === 'string') {
        const selection = selected;
        return options.filter((option)=>option.value === selection);
    }
    const selections = selected;
    return options.filter((option)=>selections.includes(option.value));
}
function $cb35e69425553502$var$parseCascadingSelectUrlParam(options, parentUrlParam, childUrlParam) {
    const parentOption = options.find((option)=>option.value === parentUrlParam);
    if (!parentOption) return null;
    const childOption = parentOption.children.find((option)=>option.value === childUrlParam);
    return {
        primaryValue: parentOption.value,
        children: childOption && childOption.value
    };
}
const $cb35e69425553502$var$parseRichTextAreaUrlParam = (urlParam)=>JSON.stringify((0, $2eOU2.plainTextToAdfParagraph)(urlParam));

});
parcelRegister("2eOU2", function(module, exports) {
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $a423c348979346a6$export$cf4bde415465976c);
$parcel$export(module.exports, "parseAdf", () => $a423c348979346a6$export$5659c60045974de9);
$parcel$export(module.exports, "plainTextToAdfParagraph", () => $a423c348979346a6$export$a5c4f0d0658bc780);
$parcel$export(module.exports, "getAccountIdsFromComment", () => $a423c348979346a6$export$f9672ae84945eb8e);

var $9RIwK = parcelRequire("9RIwK");

var $3l5RH = parcelRequire("3l5RH");

var $gioQl = parcelRequire("gioQl");
const $a423c348979346a6$var$hardBreakNodeType = 'hardBreak';
const $a423c348979346a6$export$cf4bde415465976c = (adf)=>{
    if (adf && adf.content) return adf.content.every((content)=>{
        return $a423c348979346a6$var$isOnlyWhitespaceParagraphNode(content);
    });
    return false;
};
const $a423c348979346a6$var$isOnlyWhitespaceParagraphNode = (content)=>{
    if (content.type === 'paragraph') return content.content === undefined || content.content.length === 0 || content.content.every((innerContent)=>$a423c348979346a6$var$isOnlyWhitespaceTextNode(innerContent) || $a423c348979346a6$var$isHardBreakNode(innerContent));
    return false;
};
const $a423c348979346a6$var$isOnlyWhitespaceTextNode = (content)=>{
    if ((content === null || content === void 0 ? void 0 : content.type) === 'text') return content.text === undefined || content.text.match(/^\s*$/) !== null;
    return false;
};
const $a423c348979346a6$var$isHardBreakNode = (content)=>{
    return (content === null || content === void 0 ? void 0 : content.type) === $a423c348979346a6$var$hardBreakNodeType;
};
const $a423c348979346a6$export$5659c60045974de9 = (content)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const node = JSON.parse(content);
    /*
     With Editor and Media upgrade, we have a strongly typed renderer, which is causing some types
     to break. This (typecasting to DocNode['content']) should be fixed in a follow-up.
     */ node.content = $a423c348979346a6$var$removeSuffixFromNodes(node.content);
    return node;
};
const $a423c348979346a6$var$removeSuffixFromNodes = (nodes)=>{
    if (!nodes) return nodes;
    return nodes.map((node)=>{
        if (!node) return node;
        if (node.type === 'inlineCard' && node.attrs) node.attrs = $a423c348979346a6$var$updateInlineCardAttributes(node.attrs);
        if (node.content) node.content = $a423c348979346a6$var$removeSuffixFromNodes(node.content);
        return node;
    });
};
const $a423c348979346a6$export$a5c4f0d0658bc780 = (plainText)=>({
        version: 1,
        // Using static version number as this doesn't seem to change
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: plainText
                    }
                ]
            }
        ]
    });
const $a423c348979346a6$var$removedIcftFromUrlCache = {};
const $a423c348979346a6$var$updateInlineCardAttributes = (attributes)=>{
    if (attributes.url && (0, $gioQl.parseIssueKeyFromUrl)(attributes.url)) {
        if (!$a423c348979346a6$var$removedIcftFromUrlCache[attributes.url]) {
            (0, $3l5RH.trackLegacyEvent)('servicedesk.customerview.util.adf.remove.icft.suffix', {});
            $a423c348979346a6$var$removedIcftFromUrlCache[attributes.url] = true;
        }
        attributes.url = $a423c348979346a6$var$removeICFTURLSuffix(attributes.url);
    }
    return attributes;
};
const $a423c348979346a6$var$removeICFTURLSuffix = (content)=>{
    return content.replace(/#icft=[A-Z][A-Z0-9_]+-\d+/gi, '');
};
const $a423c348979346a6$export$f9672ae84945eb8e = (adfText)=>{
    const accountIds = new Map();
    (0, $9RIwK.traverse)(adfText, {
        mention: (node)=>{
            var _node$attrs, _node$attrs2;
            /* text can be of form @user_name or user_name */ // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            let displayName = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.text;
            if (displayName) displayName = displayName.charAt(0) === '@' ? displayName.substring(1) : displayName;
            accountIds.set((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.id, displayName);
        }
    });
    return accountIds;
};

});
parcelRegister("9RIwK", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $d73391819936b83d$export$df3f009e3d155b20);

var $46Se4 = parcelRequire("46Se4");
function $d73391819936b83d$export$df3f009e3d155b20(adf, visitors) {
    if (!(0, $46Se4.validateVisitors)(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $d73391819936b83d$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $d73391819936b83d$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $d73391819936b83d$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});
parcelRegister("46Se4", function(module, exports) {
$parcel$export(module.exports, "validateVisitors", () => $1a500347c1304b85$export$735cfea22ce30f58);
function $1a500347c1304b85$export$735cfea22ce30f58(_visitors) {
    return true;
}

});




parcelRegister("ehZx5", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => (parcelRequire("2ae6t")).fetchCmdbObjectsWithSignal);
$parcel$export(module.exports, "fetchCmdbObjectDetails", () => (parcelRequire("2ae6t")).fetchCmdbObjectDetails);

var $2ae6t = parcelRequire("2ae6t");

});
parcelRegister("2ae6t", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectDetails", () => $86e25dcb0fb2969e$export$8b96c3d6d1277eda);
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => $86e25dcb0fb2969e$export$d4d0e07838855f63);

var $k2M4v = parcelRequire("k2M4v");

var $c0Y6o = parcelRequire("c0Y6o");

var $diqlM = parcelRequire("diqlM");
const $86e25dcb0fb2969e$export$8b96c3d6d1277eda = (requestKey, fieldId, objectGlobalId, signal)=>(0, $c0Y6o.fetchJson)(`${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/request/${requestKey}/cmdb/field/${fieldId}/object/${objectGlobalId}`, {
        signal: signal,
        method: 'GET'
    }).then(({ attributes: attributes })=>attributes ?? []);
const $86e25dcb0fb2969e$export$d4d0e07838855f63 = (portalId, requestTypeId, fieldId, inputValue, fieldValueMap, signal, start, includeAssignScope = true)=>{
    const fieldValueMapObject = fieldValueMap.reduce((accumulator, field)=>{
        if (field[0] !== 'attachment') accumulator[field[0]] = field[1];
        return accumulator;
    }, {});
    const body = {
        query: inputValue,
        fieldValueMap: fieldValueMapObject
    };
    const assignScopeQuery = (0, $k2M4v.default).checkGate('assets_custom_field_ui_assign_strict_scope') ? `&includeAssignScope=${String(includeAssignScope)}` : '';
    return (0, $c0Y6o.fetchJson)(`${(0, $diqlM.contextPath)}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}${assignScopeQuery}`, {
        signal: signal,
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(({ results: results, total: total, hasNextPage: hasNextPage })=>({
            total: total,
            hasNextPage: hasNextPage,
            cmdbObjects: results
        }));
};

});



parcelRegister("4BzGi", function(module, exports) {
$parcel$export(module.exports, "requestDetailsEpic", () => $4bc6f60ffc15b068$export$211ba11a17095531);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");
const $4bc6f60ffc15b068$export$211ba11a17095531 = (action$)=>{
    return action$.ofType((0, $kV2FF.FETCH_REQUEST_DETAILS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload, {
            type: 'secondary',
            disableBatching: true
        }).filter((response)=>!!response.reqDetails && !!response.reqDetails.issue).map((response)=>{
            return (0, $kV2FF.fetchRequestDetailsSuccess)(response.reqDetails);
        }).catch((error)=>{
            const key = action.payload.params.key;
            return (0, $jFk35.Observable).of((0, $kV2FF.fetchRequestDetailsFailure)(key, error));
        }));
};

});
parcelRegister("kjNSL", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => (parcelRequire("kV2FF")).CHANGE_SUBSCRIPTION);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => (parcelRequire("kV2FF")).CHANGE_SUBSCRIPTION_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT", () => (parcelRequire("kV2FF")).CREATE_COMMENT);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => (parcelRequire("kV2FF")).CREATE_COMMENT_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => (parcelRequire("kV2FF")).CREATE_COMMENT_FAILURE);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => (parcelRequire("kV2FF")).GET_MEDIA_READ_CREDENTIALS);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => (parcelRequire("kV2FF")).GET_MEDIA_READ_CREDENTIALS_SUCCESS);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => (parcelRequire("kV2FF")).DECIDE_APPROVAL);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => (parcelRequire("kV2FF")).DECIDE_APPROVAL_FAILURE);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => (parcelRequire("kV2FF")).FETCH_REQUEST_DETAILS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => (parcelRequire("kV2FF")).FETCH_REQUEST_DETAILS_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => (parcelRequire("kV2FF")).FETCH_REQUEST_DETAILS_FAILURE);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => (parcelRequire("kV2FF")).REMOVE_ORGANISATION);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => (parcelRequire("kV2FF")).REMOVE_ORGANISATION_SUCCESS);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => (parcelRequire("kV2FF")).ADD_PARTICIPANTS_SUCCESS);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => (parcelRequire("kV2FF")).REMOVE_PARTICIPANT);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => (parcelRequire("kV2FF")).REMOVE_PARTICIPANT_SUCCESS);
$parcel$export(module.exports, "SHARE_REQUEST", () => (parcelRequire("kV2FF")).SHARE_REQUEST);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => (parcelRequire("kV2FF")).SHOW_TRANSITION_DIALOG);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => (parcelRequire("kV2FF")).HIDE_TRANSITION_DIALOG);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => (parcelRequire("kV2FF")).TRANSITION_REQUEST);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => (parcelRequire("kV2FF")).TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => (parcelRequire("kV2FF")).CLEAR_TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "changeSubscription", () => (parcelRequire("kV2FF")).changeSubscription);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => (parcelRequire("kV2FF")).changeSubscriptionSuccess);
$parcel$export(module.exports, "createCommentFailure", () => (parcelRequire("kV2FF")).createCommentFailure);
$parcel$export(module.exports, "createComment", () => (parcelRequire("kV2FF")).createComment);
$parcel$export(module.exports, "createCommentSuccess", () => (parcelRequire("kV2FF")).createCommentSuccess);
$parcel$export(module.exports, "getReadCredentials", () => (parcelRequire("kV2FF")).getReadCredentials);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => (parcelRequire("kV2FF")).getReadCredentialsSuccess);
$parcel$export(module.exports, "getReadCredentialsFailure", () => (parcelRequire("kV2FF")).getReadCredentialsFailure);
$parcel$export(module.exports, "decideApproval", () => (parcelRequire("kV2FF")).decideApproval);
$parcel$export(module.exports, "decideApprovalFailure", () => (parcelRequire("kV2FF")).decideApprovalFailure);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => (parcelRequire("kV2FF")).fetchRequestDetailsModel);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => (parcelRequire("kV2FF")).fetchRequestDetailsSuccess);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => (parcelRequire("kV2FF")).fetchRequestDetailsFailure);
$parcel$export(module.exports, "removeOrganisation", () => (parcelRequire("kV2FF")).removeOrganisation);
$parcel$export(module.exports, "removeOrganisationSuccess", () => (parcelRequire("kV2FF")).removeOrganisationSuccess);
$parcel$export(module.exports, "addParticipantsSuccess", () => (parcelRequire("kV2FF")).addParticipantsSuccess);
$parcel$export(module.exports, "removeParticipant", () => (parcelRequire("kV2FF")).removeParticipant);
$parcel$export(module.exports, "removeParticipantSuccess", () => (parcelRequire("kV2FF")).removeParticipantSuccess);
$parcel$export(module.exports, "shareRequest", () => (parcelRequire("kV2FF")).shareRequest);
$parcel$export(module.exports, "showTransitionDialog", () => (parcelRequire("kV2FF")).showTransitionDialog);
$parcel$export(module.exports, "hideTransitionDialog", () => (parcelRequire("kV2FF")).hideTransitionDialog);
$parcel$export(module.exports, "transitionRequest", () => (parcelRequire("kV2FF")).transitionRequest);
$parcel$export(module.exports, "transitionRequestFailure", () => (parcelRequire("kV2FF")).transitionRequestFailure);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => (parcelRequire("kV2FF")).clearTransitionRequestFailure);

var $kV2FF = parcelRequire("kV2FF");

});
parcelRegister("kV2FF", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => $0e53a6ce21977e80$export$c82a76c42259b55e);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => $0e53a6ce21977e80$export$aed2f68a180d5132);
$parcel$export(module.exports, "CREATE_COMMENT", () => $0e53a6ce21977e80$export$b2aae42fb0a19db3);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => $0e53a6ce21977e80$export$5e5d6c973a5c4e53);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => $0e53a6ce21977e80$export$423d075659092bbe);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => $0e53a6ce21977e80$export$6e57eb44a84791a7);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => $0e53a6ce21977e80$export$710f501aa8462ae0);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => $0e53a6ce21977e80$export$17b4c1a883566436);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => $0e53a6ce21977e80$export$32a89de369c73827);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => $0e53a6ce21977e80$export$c6977262f615318f);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => $0e53a6ce21977e80$export$16e2b1f014063eb8);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => $0e53a6ce21977e80$export$b793c4f327f63a76);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => $0e53a6ce21977e80$export$8fb5a515e01e48c5);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => $0e53a6ce21977e80$export$74436d62ceb0e590);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => $0e53a6ce21977e80$export$85378bb183dca844);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => $0e53a6ce21977e80$export$fbce83858fb867fb);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => $0e53a6ce21977e80$export$dfb1c2f386aee705);
$parcel$export(module.exports, "SHARE_REQUEST", () => $0e53a6ce21977e80$export$5cf2f51c187a7d5f);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => $0e53a6ce21977e80$export$7fb10a1857e0e02a);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => $0e53a6ce21977e80$export$3a407eae5b6f60b);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => $0e53a6ce21977e80$export$a966f1a0c1a920e7);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => $0e53a6ce21977e80$export$fd4af480b5082555);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => $0e53a6ce21977e80$export$9e405a82dd6dd4e1);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => $0e53a6ce21977e80$export$5d6a7943e794d360);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => $0e53a6ce21977e80$export$f9b1366a7a60a8a);
$parcel$export(module.exports, "addParticipantsSuccess", () => $0e53a6ce21977e80$export$524d371754c76f3c);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => $0e53a6ce21977e80$export$5ef0f7883c2144b6);
$parcel$export(module.exports, "changeSubscription", () => $0e53a6ce21977e80$export$99effa43b85cc1d1);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => $0e53a6ce21977e80$export$e91b59ae91b1c17d);
$parcel$export(module.exports, "decideApprovalFailure", () => $0e53a6ce21977e80$export$8ab1e7354f0ec72f);
$parcel$export(module.exports, "decideApproval", () => $0e53a6ce21977e80$export$5fffe31f8df4a90b);
$parcel$export(module.exports, "removeOrganisation", () => $0e53a6ce21977e80$export$66d4278db03b2954);
$parcel$export(module.exports, "removeOrganisationSuccess", () => $0e53a6ce21977e80$export$f8de82921adab699);
$parcel$export(module.exports, "removeParticipant", () => $0e53a6ce21977e80$export$971a7382b074b466);
$parcel$export(module.exports, "removeParticipantSuccess", () => $0e53a6ce21977e80$export$9be1ee8fbc799e1c);
$parcel$export(module.exports, "shareRequest", () => $0e53a6ce21977e80$export$904a7ffbfa202969);
$parcel$export(module.exports, "showTransitionDialog", () => $0e53a6ce21977e80$export$375ec276b5b0476c);
$parcel$export(module.exports, "hideTransitionDialog", () => $0e53a6ce21977e80$export$69175c2908a46e20);
$parcel$export(module.exports, "transitionRequest", () => $0e53a6ce21977e80$export$e72771314c1d54);
$parcel$export(module.exports, "transitionRequestFailure", () => $0e53a6ce21977e80$export$18f56c137e75378a);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => $0e53a6ce21977e80$export$20cf1fa346e88708);
$parcel$export(module.exports, "createComment", () => $0e53a6ce21977e80$export$2a15b079e3f46654);
$parcel$export(module.exports, "createCommentSuccess", () => $0e53a6ce21977e80$export$e993efecfd9a08b4);
$parcel$export(module.exports, "createCommentFailure", () => $0e53a6ce21977e80$export$5e212521c28e6663);
$parcel$export(module.exports, "getReadCredentials", () => $0e53a6ce21977e80$export$c62f8329852c0c3e);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => $0e53a6ce21977e80$export$1c3602ad787f66de);
$parcel$export(module.exports, "getReadCredentialsFailure", () => $0e53a6ce21977e80$export$c1fdee8bb31030c2);

var $dv0hN = parcelRequire("dv0hN");
const $0e53a6ce21977e80$export$c82a76c42259b55e = 'state.persisted.request.details.CHANGE_SUBSCRIPTION';
const $0e53a6ce21977e80$export$aed2f68a180d5132 = 'state.persisted.request.details.CHANGE_SUBSCRIPTION_SUCCESS';
const $0e53a6ce21977e80$export$b2aae42fb0a19db3 = 'state.persisted.request.details.CREATE_COMMENT';
const $0e53a6ce21977e80$export$5e5d6c973a5c4e53 = 'state.persisted.request.details.CREATE_COMMENT_SUCCESS';
const $0e53a6ce21977e80$export$423d075659092bbe = 'state.persisted.request.details.CREATE_COMMENT_FAILURE';
const $0e53a6ce21977e80$export$6e57eb44a84791a7 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS';
const $0e53a6ce21977e80$export$710f501aa8462ae0 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_SUCCESS';
const $0e53a6ce21977e80$export$73373e74567a5c83 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_FAILURE';
const $0e53a6ce21977e80$export$17b4c1a883566436 = 'state.persisted.request.details.DECIDE_APPROVAL';
const $0e53a6ce21977e80$export$32a89de369c73827 = 'state.persisted.request.details.DECIDE_APPROVAL_FAILURE';
const $0e53a6ce21977e80$export$c6977262f615318f = 'epic.model.FETCH_REQUEST_DETAILS_MODEL';
const $0e53a6ce21977e80$export$16e2b1f014063eb8 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_SUCCESS';
const $0e53a6ce21977e80$export$b793c4f327f63a76 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_FAILURE';
const $0e53a6ce21977e80$export$8fb5a515e01e48c5 = 'state.persisted.request.details.REMOVE_ORGANISATION';
const $0e53a6ce21977e80$export$74436d62ceb0e590 = 'state.persisted.request.details.REMOVE_ORGANISATION_SUCCESS';
const $0e53a6ce21977e80$export$85378bb183dca844 = 'state.persisted.request.details.ADD_PARTICIPANTS_SUCCESS';
const $0e53a6ce21977e80$export$fbce83858fb867fb = 'state.persisted.request.details.REMOVE_PARTICIPANT';
const $0e53a6ce21977e80$export$dfb1c2f386aee705 = 'state.persisted.request.details.REMOVE_PARTICIPANT_SUCCESS';
const $0e53a6ce21977e80$export$5cf2f51c187a7d5f = 'state.persisted.request.details.SHARE_REQUEST';
const $0e53a6ce21977e80$export$7fb10a1857e0e02a = 'state.ui.request.details.SHOW_TRANSITION_DIALOG';
const $0e53a6ce21977e80$export$3a407eae5b6f60b = 'state.ui.request.details.HIDE_TRANSITION_DIALOG';
const $0e53a6ce21977e80$export$a966f1a0c1a920e7 = 'state.persisted.request.details.TRANSITION_REQUEST';
const $0e53a6ce21977e80$export$fd4af480b5082555 = 'state.persisted.request.details.TRANSITION_REQUEST_FAILURE';
const $0e53a6ce21977e80$export$9e405a82dd6dd4e1 = 'state.persisted.request.details.CLEAR_TRANSITION_REQUEST';
const $0e53a6ce21977e80$export$5d6a7943e794d360 = (0, $dv0hN.buildModelsActionCreator)($0e53a6ce21977e80$export$c6977262f615318f, 'reqDetails');
const $0e53a6ce21977e80$export$f9b1366a7a60a8a = (requestDetailsModel)=>({
        type: $0e53a6ce21977e80$export$16e2b1f014063eb8,
        payload: requestDetailsModel
    });
const $0e53a6ce21977e80$export$524d371754c76f3c = (requestKey, addParticipantsSuccessResponse, userMentionedDuringRequestCreation = false)=>({
        type: $0e53a6ce21977e80$export$85378bb183dca844,
        payload: {
            requestKey: requestKey,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            addParticipantsSuccessResponse: addParticipantsSuccessResponse
        }
    });
const $0e53a6ce21977e80$export$5ef0f7883c2144b6 = (requestKey, error)=>({
        type: $0e53a6ce21977e80$export$b793c4f327f63a76,
        payload: {
            requestKey: requestKey,
            error: error
        }
    });
const $0e53a6ce21977e80$export$99effa43b85cc1d1 = (requestKey, requestId, shouldSubscribe)=>({
        type: $0e53a6ce21977e80$export$c82a76c42259b55e,
        payload: {
            requestKey: requestKey,
            requestId: requestId,
            shouldSubscribe: shouldSubscribe
        }
    });
const $0e53a6ce21977e80$export$e91b59ae91b1c17d = (requestKey, shouldSubscribe)=>({
        type: $0e53a6ce21977e80$export$aed2f68a180d5132,
        payload: {
            requestKey: requestKey,
            shouldSubscribe: shouldSubscribe
        }
    });
const $0e53a6ce21977e80$export$8ab1e7354f0ec72f = ()=>({
        type: $0e53a6ce21977e80$export$32a89de369c73827
    });
const $0e53a6ce21977e80$export$5fffe31f8df4a90b = (portalId, requestKey, approvalId, approve, createAnalyticsEvent)=>({
        type: $0e53a6ce21977e80$export$17b4c1a883566436,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            approvalId: approvalId,
            approve: approve,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $0e53a6ce21977e80$export$66d4278db03b2954 = (requestKey, organisationId)=>({
        type: $0e53a6ce21977e80$export$8fb5a515e01e48c5,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $0e53a6ce21977e80$export$f8de82921adab699 = (requestKey, organisationId)=>({
        type: $0e53a6ce21977e80$export$74436d62ceb0e590,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $0e53a6ce21977e80$export$971a7382b074b466 = (requestKey, accountId)=>({
        type: $0e53a6ce21977e80$export$fbce83858fb867fb,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $0e53a6ce21977e80$export$9be1ee8fbc799e1c = (requestKey, accountId)=>({
        type: $0e53a6ce21977e80$export$dfb1c2f386aee705,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $0e53a6ce21977e80$export$904a7ffbfa202969 = (requestKey, organizations, emailAddresses, accountIds, isUserMentioned, mentionedUserName, userMentionedDuringRequestCreation)=>({
        type: $0e53a6ce21977e80$export$5cf2f51c187a7d5f,
        payload: {
            requestKey: requestKey,
            organizations: organizations,
            emailAddresses: emailAddresses,
            accountIds: accountIds,
            isUserMentioned: isUserMentioned,
            mentionedUserName: mentionedUserName,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation
        }
    });
const $0e53a6ce21977e80$export$375ec276b5b0476c = (id)=>({
        type: $0e53a6ce21977e80$export$7fb10a1857e0e02a,
        payload: {
            id: id
        }
    });
const $0e53a6ce21977e80$export$69175c2908a46e20 = ()=>({
        type: $0e53a6ce21977e80$export$3a407eae5b6f60b
    });
const $0e53a6ce21977e80$export$e72771314c1d54 = (portalId, requestKey, transitionId, comment, createAnalyticsEvent)=>({
        type: $0e53a6ce21977e80$export$a966f1a0c1a920e7,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            transitionId: transitionId,
            comment: comment,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $0e53a6ce21977e80$export$18f56c137e75378a = (error)=>({
        type: $0e53a6ce21977e80$export$fd4af480b5082555,
        payload: {
            error: error
        }
    });
const $0e53a6ce21977e80$export$20cf1fa346e88708 = ()=>({
        type: $0e53a6ce21977e80$export$9e405a82dd6dd4e1
    });
const $0e53a6ce21977e80$export$2a15b079e3f46654 = (portalId, requestId, requestKey, comment, fileIds, xsrftoken, numberOfMentionedUsers, meta)=>({
        type: $0e53a6ce21977e80$export$b2aae42fb0a19db3,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey,
            comment: comment,
            fileIds: fileIds,
            xsrftoken: xsrftoken,
            numberOfMentionedUsers: numberOfMentionedUsers,
            meta: meta
        }
    });
const $0e53a6ce21977e80$export$e993efecfd9a08b4 = (requestKey, response)=>({
        type: $0e53a6ce21977e80$export$5e5d6c973a5c4e53,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $0e53a6ce21977e80$export$5e212521c28e6663 = ()=>({
        type: $0e53a6ce21977e80$export$423d075659092bbe,
        payload: {}
    });
const $0e53a6ce21977e80$export$c62f8329852c0c3e = (portalId, requestId, requestKey)=>({
        type: $0e53a6ce21977e80$export$6e57eb44a84791a7,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey
        }
    });
const $0e53a6ce21977e80$export$1c3602ad787f66de = (requestKey, response)=>({
        type: $0e53a6ce21977e80$export$710f501aa8462ae0,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $0e53a6ce21977e80$export$c1fdee8bb31030c2 = ()=>({
        type: $0e53a6ce21977e80$export$73373e74567a5c83,
        payload: {}
    });

});



parcelRegister("4QT8R", function(module, exports) {
$parcel$export(module.exports, "requestListEpic", () => $29aa7d96f2de601f$export$ab46e56cc8f700e6);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("evnRm");
var $4H6hH = parcelRequire("4H6hH");
const $29aa7d96f2de601f$export$ab46e56cc8f700e6 = (action$)=>{
    return action$.ofType((0, $4H6hH.FETCH_REQUEST_LIST_MODEL)).switchMap((action)=>{
        return (0, $b4gcU.default)(action.payload).filter((response)=>response.allReqFilter !== undefined && 'requestList' in response.allReqFilter && Array.isArray(response.allReqFilter.requestList)).flatMap((response)=>{
            const filter = action.payload.params.filter;
            // TypeScript's Observable.filter() does not narrow types, so response.allReqFilter
            // is still typed as RequestListResponse | undefined here even though the preceding
            // .filter() guarantees it is defined and has a valid requestList array.
            const requestListModel = response.allReqFilter;
            return (0, $jFk35.Observable).of((0, $4H6hH.fetchRequestListSuccess)({
                ...requestListModel,
                filter: filter
            }));
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $4H6hH.fetchRequestListFailure)(error));
        });
    });
};

});
parcelRegister("evnRm", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => (parcelRequire("4H6hH")).FETCH_REQUEST_LIST_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => (parcelRequire("4H6hH")).FETCH_REQUEST_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => (parcelRequire("4H6hH")).FETCH_REQUEST_LIST_FAILURE);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => (parcelRequire("4H6hH")).MARK_INITIAL_PAGE_LOAD_RENDERED);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => (parcelRequire("4H6hH")).INVALIDATE_PAGES);
$parcel$export(module.exports, "fetchRequestListModel", () => (parcelRequire("4H6hH")).fetchRequestListModel);
$parcel$export(module.exports, "fetchRequestListSuccess", () => (parcelRequire("4H6hH")).fetchRequestListSuccess);
$parcel$export(module.exports, "fetchRequestListFailure", () => (parcelRequire("4H6hH")).fetchRequestListFailure);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => (parcelRequire("4H6hH")).markInitialPageLoadRendered);
$parcel$export(module.exports, "invalidatePages", () => (parcelRequire("4H6hH")).invalidatePages);

var $4H6hH = parcelRequire("4H6hH");

});
parcelRegister("4H6hH", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => $5105cba50479b7a1$export$7ee1e1fb4cf5db91);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => $5105cba50479b7a1$export$f9ff6948957ba5c5);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => $5105cba50479b7a1$export$f5e5c834c1e2e455);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => $5105cba50479b7a1$export$4f7af1d62055a261);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => $5105cba50479b7a1$export$d772cf5cfb44df9);
$parcel$export(module.exports, "fetchRequestListModel", () => $5105cba50479b7a1$export$decc5f94205f709e);
$parcel$export(module.exports, "invalidatePages", () => $5105cba50479b7a1$export$64b565f3a0ba7cb5);
$parcel$export(module.exports, "fetchRequestListSuccess", () => $5105cba50479b7a1$export$132d3416d8175125);
$parcel$export(module.exports, "fetchRequestListFailure", () => $5105cba50479b7a1$export$a842eadee8280475);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => $5105cba50479b7a1$export$b643261c092a4f6);

var $dv0hN = parcelRequire("dv0hN");
const $5105cba50479b7a1$export$7ee1e1fb4cf5db91 = 'epic.model.FETCH_REQUEST_LIST_MODEL';
const $5105cba50479b7a1$export$f9ff6948957ba5c5 = 'state.persisted.request.List.FETCH_REQUEST_LIST_SUCCESS';
const $5105cba50479b7a1$export$f5e5c834c1e2e455 = 'state.persisted.request.List.FETCH_REQUEST_LIST_FAILURE';
const $5105cba50479b7a1$export$4f7af1d62055a261 = 'state.persisted.request.List.MARK_INITIAL_PAGE_LOAD_RENDERED';
const $5105cba50479b7a1$export$d772cf5cfb44df9 = 'state.persisted.request.List.INVALIDATE_PAGES';
const $5105cba50479b7a1$export$decc5f94205f709e = (0, $dv0hN.buildModelsActionCreator)($5105cba50479b7a1$export$7ee1e1fb4cf5db91, 'allReqFilter');
const $5105cba50479b7a1$export$64b565f3a0ba7cb5 = (currentPage)=>({
        type: $5105cba50479b7a1$export$d772cf5cfb44df9,
        payload: currentPage
    });
const $5105cba50479b7a1$export$132d3416d8175125 = (requestListModel)=>({
        type: $5105cba50479b7a1$export$f9ff6948957ba5c5,
        payload: requestListModel
    });
const $5105cba50479b7a1$export$a842eadee8280475 = (error)=>({
        type: $5105cba50479b7a1$export$f5e5c834c1e2e455,
        payload: {
            error: error
        }
    });
const $5105cba50479b7a1$export$b643261c092a4f6 = ()=>({
        type: $5105cba50479b7a1$export$4f7af1d62055a261
    });

});



parcelRegister("k3HpB", function(module, exports) {
$parcel$export(module.exports, "reqSlasEpic", () => $6033a4f1690d747b$export$426760a75e6f1897);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("plzke");
var $gJbwY = parcelRequire("gJbwY");

var $x2dJZ = parcelRequire("x2dJZ");
const $6033a4f1690d747b$export$426760a75e6f1897 = (action$)=>{
    return action$.ofType((0, $x2dJZ.FETCH_REQ_SLAS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>response.reqSlas !== undefined).map((response)=>(0, $gJbwY.updateReqSlasModelAction)(action.payload.params.key, response.reqSlas)).catch(()=>(0, $jFk35.Observable).never()));
};

});
parcelRegister("plzke", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQ_SLAS_MODEL", () => (parcelRequire("gJbwY")).UPDATE_REQ_SLAS_MODEL);
$parcel$export(module.exports, "updateReqSlasModelAction", () => (parcelRequire("gJbwY")).updateReqSlasModelAction);

var $gJbwY = parcelRequire("gJbwY");

});
parcelRegister("gJbwY", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQ_SLAS_MODEL", () => $37f80c73cbd30026$export$14a7b72e42866a9e);
$parcel$export(module.exports, "updateReqSlasModelAction", () => $37f80c73cbd30026$export$75741563899043b4);
const $37f80c73cbd30026$export$14a7b72e42866a9e = 'state.persisted.reqSlas.UPDATE_REQ_SLAS_MODEL';
const $37f80c73cbd30026$export$75741563899043b4 = (requestKey, reqSlas)=>({
        type: $37f80c73cbd30026$export$14a7b72e42866a9e,
        payload: {
            requestKey: requestKey,
            reqSlas: reqSlas
        }
    });

});


parcelRegister("x2dJZ", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQ_SLAS_MODEL", () => $78f53a5f8c03c233$export$38987f165c420e6c);
$parcel$export(module.exports, "fetchReqSlasModelAction", () => $78f53a5f8c03c233$export$15b0feb96f424331);

var $dv0hN = parcelRequire("dv0hN");
const $78f53a5f8c03c233$export$38987f165c420e6c = 'epic.model.FETCH_REQ_SLAS_MODEL';
const $78f53a5f8c03c233$export$15b0feb96f424331 = (0, $dv0hN.buildModelsActionCreator)($78f53a5f8c03c233$export$38987f165c420e6c, 'reqSlas');

});


parcelRegister("bADwM", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionEpic", () => $8f08c225d0cae42b$export$6dca1de129d1f3d9);

var $jFk35 = parcelRequire("jFk35");
parcelRequire("d6CKA");
var $7dQWi = parcelRequire("7dQWi");

var $b4gcU = parcelRequire("b4gcU");
const $8f08c225d0cae42b$export$6dca1de129d1f3d9 = (action$)=>{
    return action$.ofType((0, $7dQWi.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.suggestedRequestTypes).map((response)=>(0, $7dQWi.fetchRequestTypeSuggestionSuccess)(response.suggestedRequestTypes))// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $jFk35.Observable).never()));
};

});
parcelRegister("d6CKA", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => (parcelRequire("7dQWi")).FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => (parcelRequire("7dQWi")).FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => (parcelRequire("7dQWi")).fetchRequestTypeSuggestionAction);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => (parcelRequire("7dQWi")).fetchRequestTypeSuggestionSuccess);

var $7dQWi = parcelRequire("7dQWi");

});
parcelRegister("7dQWi", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => $ec168f4b35548409$export$19c1cce5df18edab);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => $ec168f4b35548409$export$16165835dcce301e);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => $ec168f4b35548409$export$2eae5c2f108f9b38);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => $ec168f4b35548409$export$677aa00fa9ff8a57);

var $dv0hN = parcelRequire("dv0hN");
const $ec168f4b35548409$export$19c1cce5df18edab = 'epic.model.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL';
const $ec168f4b35548409$export$16165835dcce301e = 'state.persisted.request-type-suggestion.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS';
const $ec168f4b35548409$export$2eae5c2f108f9b38 = (0, $dv0hN.buildModelsActionCreator)($ec168f4b35548409$export$19c1cce5df18edab, 'suggestedRequestTypes');
const $ec168f4b35548409$export$677aa00fa9ff8a57 = (requestTypeSuggestions)=>({
        payload: requestTypeSuggestions,
        type: $ec168f4b35548409$export$16165835dcce301e
    });

});



parcelRegister("iFYPT", function(module, exports) {
$parcel$export(module.exports, "requestsColumnSettingsEpic", () => $a4d0cc8847fcc5ae$export$3d5be110c2cef28d);

var $jFk35 = parcelRequire("jFk35");

var $beT51 = parcelRequire("beT51");

var $b4gcU = parcelRequire("b4gcU");
const $a4d0cc8847fcc5ae$export$3d5be110c2cef28d = (action$)=>{
    return action$.ofType((0, $beT51.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.requestsColumnSettings).map((response)=>{
            return (0, $beT51.fetchRequestsColumnSettingsSuccess)(response.requestsColumnSettings || []);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $beT51.fetchRequestsColumnSettingsFailure)(error));
        }));
};

});
parcelRegister("beT51", function(module, exports) {
$parcel$export(module.exports, "CUSTOMIZING_REQUEST_LIST_COLUMN", () => $47384a96e31df65b$export$71e1a7c3232c719e);
$parcel$export(module.exports, "TOGGLE_COLUMN_RE_ORDER_WIDGET", () => $47384a96e31df65b$export$839cbba59bbe0238);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_MODEL", () => $47384a96e31df65b$export$abc90ee82ed578f);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $47384a96e31df65b$export$47e32c3c3500bef2);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $47384a96e31df65b$export$10398b8018af3940);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL", () => $47384a96e31df65b$export$f90917a8f5386b09);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $47384a96e31df65b$export$e560350e06e586db);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $47384a96e31df65b$export$79deac20d43b585c);
$parcel$export(module.exports, "RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS", () => $47384a96e31df65b$export$29dc39ddf284347c);
$parcel$export(module.exports, "REORDER_REQUEST_LIST_COLUMNS", () => $47384a96e31df65b$export$8d4d9dae0354b673);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL", () => $47384a96e31df65b$export$ff2ed1ddece23eaa);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS", () => $47384a96e31df65b$export$70626e2ee8f09144);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE", () => $47384a96e31df65b$export$3fe3cdc959a8c16a);
$parcel$export(module.exports, "customizingRequestListColumn", () => $47384a96e31df65b$export$cef6e00d44beb902);
$parcel$export(module.exports, "toggleColumnReOrderWidget", () => $47384a96e31df65b$export$82755465bec7b53d);
$parcel$export(module.exports, "fetchRequestsColumnSettingsModel", () => $47384a96e31df65b$export$2ddd8f55c6e79cad);
$parcel$export(module.exports, "fetchRequestsColumnSettingsSuccess", () => $47384a96e31df65b$export$91fa974aae399c3e);
$parcel$export(module.exports, "fetchRequestsColumnSettingsFailure", () => $47384a96e31df65b$export$358a9b23c953cceb);
$parcel$export(module.exports, "updateRequestsColumnSettingsModel", () => $47384a96e31df65b$export$d283121346cbb92e);
$parcel$export(module.exports, "updateRequestsColumnSettingsSuccess", () => $47384a96e31df65b$export$46519305d1bd5dcc);
$parcel$export(module.exports, "updateRequestsColumnSettingsFailure", () => $47384a96e31df65b$export$a9e9b393ae51b9eb);
$parcel$export(module.exports, "resetCustomizeRequestsColumnSettings", () => $47384a96e31df65b$export$b835f37760c00124);
$parcel$export(module.exports, "reOrderRequestListColumns", () => $47384a96e31df65b$export$7401badd435f0b7c);
$parcel$export(module.exports, "updateOrderedRequestListColumnsModel", () => $47384a96e31df65b$export$bca82c1325293cdd);
$parcel$export(module.exports, "updateOrderedRequestListColumnsSuccess", () => $47384a96e31df65b$export$7e3f487fe57e88e3);
$parcel$export(module.exports, "updateOrderedRequestListColumnsFailure", () => $47384a96e31df65b$export$98a8373db0072493);

var $dv0hN = parcelRequire("dv0hN");
const $47384a96e31df65b$export$71e1a7c3232c719e = 'state.ui.requests.column.settings.CUSTOMIZING_REQUEST_LIST_COLUMN';
const $47384a96e31df65b$export$839cbba59bbe0238 = 'state.ui.requests.column.settings.TOGGLE_COLUMN_RE_ORDER_WIDGET';
const $47384a96e31df65b$export$abc90ee82ed578f = 'epic.model.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL';
const $47384a96e31df65b$export$47e32c3c3500bef2 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $47384a96e31df65b$export$10398b8018af3940 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $47384a96e31df65b$export$f90917a8f5386b09 = 'epic.requests-column-settings.UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL';
const $47384a96e31df65b$export$e560350e06e586db = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $47384a96e31df65b$export$79deac20d43b585c = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $47384a96e31df65b$export$29dc39ddf284347c = 'state.ui.requests.column.settings.RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS';
const $47384a96e31df65b$export$8d4d9dae0354b673 = 'state.ui.requests.column.settings.REORDER_REQUEST_LIST_COLUMNS';
const $47384a96e31df65b$export$ff2ed1ddece23eaa = 'epic.requests-column-settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL';
const $47384a96e31df65b$export$70626e2ee8f09144 = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS';
const $47384a96e31df65b$export$3fe3cdc959a8c16a = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE';
const $47384a96e31df65b$export$cef6e00d44beb902 = (isCustomizing)=>({
        type: $47384a96e31df65b$export$71e1a7c3232c719e,
        payload: isCustomizing
    });
const $47384a96e31df65b$export$82755465bec7b53d = (isReOrdering)=>({
        type: $47384a96e31df65b$export$839cbba59bbe0238,
        payload: isReOrdering
    });
const $47384a96e31df65b$export$2ddd8f55c6e79cad = (0, $dv0hN.buildModelsActionCreator)($47384a96e31df65b$export$abc90ee82ed578f, 'requestsColumnSettings');
const $47384a96e31df65b$export$91fa974aae399c3e = (requestsColumnSettingsModel)=>({
        type: $47384a96e31df65b$export$47e32c3c3500bef2,
        payload: requestsColumnSettingsModel
    });
const $47384a96e31df65b$export$358a9b23c953cceb = (error)=>({
        type: $47384a96e31df65b$export$10398b8018af3940,
        payload: {
            error: error
        }
    });
const $47384a96e31df65b$export$d283121346cbb92e = (requestsColumnSettingsModel, meta)=>({
        meta: meta,
        type: $47384a96e31df65b$export$f90917a8f5386b09,
        payload: requestsColumnSettingsModel
    });
const $47384a96e31df65b$export$46519305d1bd5dcc = (requestsColumnSettingsModel)=>({
        type: $47384a96e31df65b$export$e560350e06e586db,
        payload: requestsColumnSettingsModel
    });
const $47384a96e31df65b$export$a9e9b393ae51b9eb = (error)=>({
        type: $47384a96e31df65b$export$79deac20d43b585c,
        payload: {
            error: error
        }
    });
const $47384a96e31df65b$export$b835f37760c00124 = ()=>({
        type: $47384a96e31df65b$export$29dc39ddf284347c
    });
const $47384a96e31df65b$export$7401badd435f0b7c = (newOrder)=>({
        type: $47384a96e31df65b$export$8d4d9dae0354b673,
        payload: newOrder
    });
const $47384a96e31df65b$export$bca82c1325293cdd = (newOrder, meta)=>{
    return {
        meta: meta,
        type: $47384a96e31df65b$export$ff2ed1ddece23eaa,
        payload: newOrder
    };
};
const $47384a96e31df65b$export$7e3f487fe57e88e3 = (requestsColumnSettings)=>({
        type: $47384a96e31df65b$export$70626e2ee8f09144,
        payload: requestsColumnSettings
    });
const $47384a96e31df65b$export$98a8373db0072493 = (error)=>({
        type: $47384a96e31df65b$export$3fe3cdc959a8c16a,
        payload: {
            error: error
        }
    });

});


parcelRegister("cCChy", function(module, exports) {
$parcel$export(module.exports, "timezonesEpic", () => $4e1e2419fe669055$export$be7068db419e43b3);
$parcel$export(module.exports, "timezoneRegionsEpic", () => $4e1e2419fe669055$export$f2ed825e49baebf1);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("jBSrG");
var $itms7 = parcelRequire("itms7");

var $fASm6 = parcelRequire("fASm6");
const $4e1e2419fe669055$export$be7068db419e43b3 = (action$)=>{
    return action$.ofType((0, $itms7.FETCH_TIMEZONES_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.timezones).map((response)=>{
            return (0, $itms7.fetchTimezonesSuccess)(response.timezones || []);
        }).catch((_)=>{
            return (0, $jFk35.Observable).of((0, $5kfOu.showErrorFlag)((0, $fASm6.genericError).title, (0, $fASm6.genericError).description));
        }));
};
const $4e1e2419fe669055$export$f2ed825e49baebf1 = (action$)=>{
    return action$.ofType((0, $itms7.FETCH_TIMEZONE_REGIONS_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.timezoneRegions).map((response)=>{
            return (0, $itms7.fetchTimezoneRegionsSuccess)(response.timezoneRegions || []);
        }).catch((_)=>{
            return (0, $jFk35.Observable).of((0, $5kfOu.showErrorFlag)((0, $fASm6.genericError).title, (0, $fASm6.genericError).description));
        }));
};

});
parcelRegister("jBSrG", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => (parcelRequire("itms7")).FETCH_TIMEZONES_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => (parcelRequire("itms7")).FETCH_TIMEZONE_REGIONS_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => (parcelRequire("itms7")).FETCH_TIMEZONES_SUCCESS);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => (parcelRequire("itms7")).FETCH_TIMEZONE_REGIONS_SUCCESS);
$parcel$export(module.exports, "fetchTimezonesModel", () => (parcelRequire("itms7")).fetchTimezonesModel);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => (parcelRequire("itms7")).fetchTimezoneRegionsModel);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => (parcelRequire("itms7")).fetchTimezonesSuccess);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => (parcelRequire("itms7")).fetchTimezoneRegionsSuccess);

var $itms7 = parcelRequire("itms7");

});
parcelRegister("itms7", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => $be6902cb376a6c29$export$932af27e6d5887a0);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => $be6902cb376a6c29$export$3b699f83ba8d2c06);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => $be6902cb376a6c29$export$6b053ef4439b07a6);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => $be6902cb376a6c29$export$6932839fde3fd591);
$parcel$export(module.exports, "fetchTimezonesModel", () => $be6902cb376a6c29$export$f02c0cf38058cca0);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => $be6902cb376a6c29$export$2ac437e497040cf4);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => $be6902cb376a6c29$export$f577dd22c3538327);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => $be6902cb376a6c29$export$219ccd71bd1012b);

var $dv0hN = parcelRequire("dv0hN");
const $be6902cb376a6c29$export$932af27e6d5887a0 = 'epic.model.FETCH_TIMEZONES_MODEL';
const $be6902cb376a6c29$export$3b699f83ba8d2c06 = 'epic.model.FETCH_TIMEZONE_REGIONS_MODEL';
const $be6902cb376a6c29$export$6b053ef4439b07a6 = 'state.persisted.timezone.FETCH_TIMEZONEs_SUCCESS';
const $be6902cb376a6c29$export$6932839fde3fd591 = 'state.persisted.timezone.FETCH_TIMEZONE_REGIONS_SUCCESS';
const $be6902cb376a6c29$export$f02c0cf38058cca0 = (0, $dv0hN.buildModelsActionCreator)($be6902cb376a6c29$export$932af27e6d5887a0, 'timezones');
const $be6902cb376a6c29$export$2ac437e497040cf4 = (0, $dv0hN.buildModelsActionCreator)($be6902cb376a6c29$export$3b699f83ba8d2c06, 'timezoneRegions');
const $be6902cb376a6c29$export$f577dd22c3538327 = (timezoneRegions)=>({
        type: $be6902cb376a6c29$export$6932839fde3fd591,
        payload: {
            timezoneRegions: timezoneRegions
        }
    });
const $be6902cb376a6c29$export$219ccd71bd1012b = (timezones)=>({
        type: $be6902cb376a6c29$export$6b053ef4439b07a6,
        payload: {
            timezones: timezones
        }
    });

});



parcelRegister("faaon", function(module, exports) {
$parcel$export(module.exports, "uiModificationsEpic", () => $a40ff8c8ffcb0518$export$b3e7540861af6314);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("6afVg");
var $aXlr1 = parcelRequire("aXlr1");
const $a40ff8c8ffcb0518$export$b3e7540861af6314 = (action$)=>{
    return action$.ofType((0, $aXlr1.FETCH_UI_MODIFICATIONS_MODEL)).mergeMap((action)=>{
        var _action$payload, _action$payload2;
        const portalId = (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.params) === null || _action$payload === void 0 ? void 0 : _action$payload.portalId;
        const requestTypeId = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 || (_action$payload2 = _action$payload2.params) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.requestTypeId;
        // Guard clause: ensure required params are defined
        // If params are missing, don't emit any action (nothing meaningful to store)
        if (portalId === undefined || requestTypeId === undefined) return (0, $jFk35.Observable).empty();
        return (0, $b4gcU.default)(action.payload).filter((response)=>{
            return !!response.uiModifications;
        }).mergeMap((response)=>{
            const uiModifications = response.uiModifications;
            // Check if the response contains an error object
            if ('error' in uiModifications && uiModifications.error) {
                const error = uiModifications.error;
                return (0, $jFk35.Observable).of((0, $aXlr1.fetchUiModificationsFailure)(portalId, requestTypeId, {
                    status: 500,
                    errorMessages: [
                        error.message || error.code || 'Unknown error'
                    ]
                }));
            }
            return (0, $jFk35.Observable).of((0, $aXlr1.fetchUiModificationsSuccess)(portalId, requestTypeId, uiModifications));
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $aXlr1.fetchUiModificationsFailure)(portalId, requestTypeId, error));
        });
    });
};

});
parcelRegister("6afVg", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => (parcelRequire("aXlr1")).FETCH_UI_MODIFICATIONS_MODEL);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => (parcelRequire("aXlr1")).FETCH_UI_MODIFICATIONS_SUCCESS);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => (parcelRequire("aXlr1")).FETCH_UI_MODIFICATIONS_FAILURE);
$parcel$export(module.exports, "fetchUiModificationsAction", () => (parcelRequire("aXlr1")).fetchUiModificationsAction);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => (parcelRequire("aXlr1")).fetchUiModificationsSuccess);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => (parcelRequire("aXlr1")).fetchUiModificationsFailure);

var $aXlr1 = parcelRequire("aXlr1");

});
parcelRegister("aXlr1", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => $d28a6410ef9894df$export$8dbb39b6146e28fc);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => $d28a6410ef9894df$export$7165d2daf9f7546b);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => $d28a6410ef9894df$export$f2bc8b8032fa83f9);
$parcel$export(module.exports, "fetchUiModificationsAction", () => $d28a6410ef9894df$export$d5c10586cf66ad48);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => $d28a6410ef9894df$export$5811aa4798efe56f);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => $d28a6410ef9894df$export$aa1b71ac6d05f568);

var $dv0hN = parcelRequire("dv0hN");
const $d28a6410ef9894df$export$8dbb39b6146e28fc = 'epic.model.FETCH_UI_MODIFICATIONS_MODEL';
const $d28a6410ef9894df$export$7165d2daf9f7546b = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_SUCCESS';
const $d28a6410ef9894df$export$f2bc8b8032fa83f9 = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_FAILURE';
const $d28a6410ef9894df$export$d5c10586cf66ad48 = (0, $dv0hN.buildModelsActionCreator)($d28a6410ef9894df$export$8dbb39b6146e28fc, 'uiModifications');
const $d28a6410ef9894df$export$5811aa4798efe56f = (portalId, requestTypeId, uiModifications)=>({
        type: $d28a6410ef9894df$export$7165d2daf9f7546b,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            uiModifications: uiModifications
        }
    });
const $d28a6410ef9894df$export$aa1b71ac6d05f568 = (portalId, requestTypeId, error)=>({
        type: $d28a6410ef9894df$export$f2bc8b8032fa83f9,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error
        }
    });

});



parcelRegister("btn7V", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationEpic", () => $c6a650dce68f8562$export$a5c82ee4d4a62853);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("ay41d");
var $eog6E = parcelRequire("eog6E");

var $eJwdb = parcelRequire("eJwdb");
const $c6a650dce68f8562$export$a5c82ee4d4a62853 = (action$)=>{
    return action$.ofType((0, $eJwdb.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.unsubscribedConfirmation && !!response.unsubscribedConfirmation.requestKey).map((response)=>{
            return (0, $eog6E.fetchUnsubscribedConfirmationSuccess)(response.unsubscribedConfirmation);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $eog6E.fetchUnsubscribedConfirmationFailure)(error));
        }));
};

});
parcelRegister("ay41d", function(module, exports) {
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => (parcelRequire("eog6E")).fetchUnsubscribedConfirmationSuccess);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => (parcelRequire("eog6E")).fetchUnsubscribedConfirmationFailure);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => (parcelRequire("eog6E")).FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => (parcelRequire("eog6E")).FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS);

var $eog6E = parcelRequire("eog6E");

});
parcelRegister("eog6E", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => $6a50e36f5e2ddfb3$export$f72ddca71405b95d);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => $6a50e36f5e2ddfb3$export$ebaa1597e87c25cb);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => $6a50e36f5e2ddfb3$export$c1bfe5b0bc39b67c);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => $6a50e36f5e2ddfb3$export$97f97477d437893);
const $6a50e36f5e2ddfb3$export$f72ddca71405b95d = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS';
const $6a50e36f5e2ddfb3$export$ebaa1597e87c25cb = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE';
const $6a50e36f5e2ddfb3$export$c1bfe5b0bc39b67c = (unsubscribedConfirmationModel)=>({
        payload: unsubscribedConfirmationModel,
        type: $6a50e36f5e2ddfb3$export$f72ddca71405b95d
    });
const $6a50e36f5e2ddfb3$export$97f97477d437893 = (error)=>({
        type: $6a50e36f5e2ddfb3$export$ebaa1597e87c25cb,
        payload: {
            error: error
        }
    });

});


parcelRegister("eJwdb", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL", () => $c3a567d1e08dd903$export$2e46ab911cbec5e7);
$parcel$export(module.exports, "fetchUnsubscribedConfirmation", () => $c3a567d1e08dd903$export$4b67c7752a799aa6);

var $dv0hN = parcelRequire("dv0hN");
const $c3a567d1e08dd903$export$2e46ab911cbec5e7 = 'epic.model.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL';
const $c3a567d1e08dd903$export$4b67c7752a799aa6 = (0, $dv0hN.buildModelsActionCreator)($c3a567d1e08dd903$export$2e46ab911cbec5e7, 'unsubscribedConfirmation');

});


parcelRegister("52CG5", function(module, exports) {
$parcel$export(module.exports, "visitPortalEpic", () => $8ab118678eb44c5e$export$b0dd3b8f13c4a9ce);

var $jFk35 = parcelRequire("jFk35");

var $b4gcU = parcelRequire("b4gcU");
parcelRequire("6ukid");
var $fdqjK = parcelRequire("fdqjK");
const $8ab118678eb44c5e$export$b0dd3b8f13c4a9ce = (action$)=>{
    return action$.ofType((0, $fdqjK.FETCH_VISIT_PORTAL_MODEL)).mergeMap((action)=>(0, $b4gcU.default)(action.payload).filter((response)=>!!response.visitPortal && !!response.visitPortal.email).map((response)=>{
            return (0, $fdqjK.fetchVisitPortalSuccess)(response.visitPortal);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $fdqjK.fetchVisitPortalFailure)(error));
        }));
};

});


parcelRegister("8PGmP", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncementsEpic", () => $49205d68fc449839$export$e4577247bf7a5bb1);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $iuaXR = parcelRequire("iuaXR");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");

var $aIVqJ = parcelRequire("aIVqJ");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");

var $ja4bY = parcelRequire("ja4bY");
const $49205d68fc449839$export$e4577247bf7a5bb1 = (action$)=>{
    return action$.ofType((0, $hijaX.UPDATE_PORTAL_ANNOUNCEMENT_MODEL)).mergeMap((action)=>{
        const { meta: meta, portalId: portalId } = action;
        return (0, $iuaXR.updatePortalAnnouncements)(action.payload, portalId).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $hijaX.updatePortalAnnouncementSuccess)(response)));
        }).catch((error)=>{
            if ((0, $17nJI.isNetworkOrClientErrorCode)(error.status)) // Filter out client errors
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            else {
                if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)((0, $ja4bY.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.failure({
                    metadata: {
                        error: (0, $aIVqJ.getErrorData)(error)
                    }
                });
            }
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $hijaX.updatePortalAnnouncementFailure)(error)), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("iuaXR", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncements", () => $5043e633ac1db0b1$export$9e961f2770667246);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $5043e633ac1db0b1$export$9e961f2770667246 = (payload, portalId, context = (0, $diqlM.contextPath))=>{
    const portalAnnouncementUpdateURI = `${context}/rest/servicedesk/1/servicedesk-data/announcement/portal/${portalId}`;
    const contentType = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(portalAnnouncementUpdateURI, payload, contentType)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $4Q7yw.Observable).throw(e));
};

});


parcelRegister("4wKih", function(module, exports) {
$parcel$export(module.exports, "changeRequestSubscriptionEpic", () => $2cb031c74ac89fc8$export$43fea900952d51e2);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $54Q27 = parcelRequire("54Q27");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");
const $2cb031c74ac89fc8$export$43fea900952d51e2 = (action$)=>{
    return action$.ofType((0, $kV2FF.CHANGE_SUBSCRIPTION)).mergeMap((changeSubscriptionAction)=>{
        const { shouldSubscribe: shouldSubscribe, requestId: requestId, requestKey: requestKey } = changeSubscriptionAction.payload;
        const restCall = shouldSubscribe ? (0, $54Q27.subscribe) : (0, $54Q27.unsubscribe);
        return restCall(requestId).map(()=>{
            return (0, $kV2FF.changeSubscriptionSuccess)(requestKey, shouldSubscribe);
        }).catch((error)=>{
            return (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("54Q27", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $22ab45e5833cab04$export$ec068583843480e7);
$parcel$export(module.exports, "unsubscribe", () => $22ab45e5833cab04$export$f500693cef883ffd);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $22ab45e5833cab04$export$ec068583843480e7 = (requestId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $bTjsX.put)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};
const $22ab45e5833cab04$export$f500693cef883ffd = (requestId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $bTjsX.doDelete)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};

});


parcelRegister("2awzr", function(module, exports) {
$parcel$export(module.exports, "createCommentEpic", () => $f8afbd2eec086d96$export$3d130ce773bd2648);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $j08Rr = parcelRequire("j08Rr");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");

var $5hmyz = parcelRequire("5hmyz");
const $f8afbd2eec086d96$export$3d130ce773bd2648 = (action$)=>{
    return action$.ofType((0, $kV2FF.CREATE_COMMENT)).mergeMap((createCommentAction)=>{
        const payload = createCommentAction.payload;
        return (0, $j08Rr.createComment)(payload.requestId, payload.comment, payload.fileIds, payload.xsrftoken).flatMap((createCommentResponse)=>{
            const { meta: meta, numberOfMentionedUsers: numberOfMentionedUsers } = payload;
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) {
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // oxlint-disable-next-line no-shadow
                meta === null || meta === void 0 || meta.analyticsSuccessEvent.update((payload)=>({
                        ...payload,
                        count: numberOfMentionedUsers || 0
                    }));
                (0, $aIVqJ.legacySendEvent)(meta === null || meta === void 0 ? void 0 : meta.analyticsSuccessEvent);
            }
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $kV2FF.createCommentSuccess)(payload.requestKey, createCommentResponse)), (0, $jFk35.Observable).of((0, $kV2FF.getReadCredentials)(payload.portalId, payload.requestId, payload.requestKey)));
        }).catch((error)=>{
            const meta = payload.meta;
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent);
            const isShowErrorFlag = payload.numberOfMentionedUsers && payload.numberOfMentionedUsers > 0 && !(0, $17nJI.isNetworkErrorCode)(error.status);
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $kV2FF.createCommentFailure)()), (0, $jFk35.Observable).of(isShowErrorFlag ? (0, $5kfOu.showErrorFlag)((0, $5hmyz.default).commentCreateWithMentionsFailedTitle, (0, $5hmyz.default).commentCreateWithMentionsFailedDescription) : (0, $5kfOu.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("j08Rr", function(module, exports) {
$parcel$export(module.exports, "createComment", () => $ab76993452cc7f11$export$2a15b079e3f46654);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");
const $ab76993452cc7f11$export$2a15b079e3f46654 = (issueId, comment, fileIds, xsrfToken, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/customer/comment`;
    const body = {
        issueId: issueId,
        comment: comment,
        fileIds: fileIds,
        xsrfToken: xsrfToken
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).catch((e)=>{
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("5hmyz", function(module, exports) {
$parcel$export(module.exports, "default", () => $05cf3defb8c0c4e1$export$2e2bcd8739ae039);
/* Note: these messages are not final */ 
var $8p5Cv = parcelRequire("8p5Cv");
var $05cf3defb8c0c4e1$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    commentCreateWithMentionsFailedTitle: {
        defaultMessage: "We couldn\u2019t add this comment",
        description: 'Comment containing user mentions failed to create title',
        id: 'sd.comment.create.with.mentions.failed.title'
    },
    commentCreateWithMentionsFailedDescription: {
        defaultMessage: 'Try adding it again in a few minutes. ',
        description: 'Comment containing user mentions failed to create description',
        id: 'sd.comment.create.with.mentions.failed.description'
    }
});

});


parcelRegister("4Sh87", function(module, exports) {
$parcel$export(module.exports, "decideApprovalEpic", () => $f004911d8e8925ff$export$d61d906dee97954f);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $hN5YJ = parcelRequire("hN5YJ");

var $5kfOu = parcelRequire("5kfOu");

var $gdtFG = parcelRequire("gdtFG");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $7Xy60 = parcelRequire("7Xy60");
const $f004911d8e8925ff$var$isClientSideError = (error)=>error.status >= 400 && error.status < 500;
const $f004911d8e8925ff$export$d61d906dee97954f = (action$)=>{
    return action$.ofType((0, $kV2FF.DECIDE_APPROVAL)).mergeMap((decideApprovalAction)=>{
        const payload = decideApprovalAction.payload;
        const restCall = payload.approve ? (0, $gdtFG.approve)(payload.approvalId) : (0, $gdtFG.decline)(payload.approvalId);
        return restCall.map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'recorded'
            });
            if (successEvent) {
                successEvent.context.push({
                    componentName: 'approverDecision'
                });
                (0, $aIVqJ.legacySendEvent)(successEvent);
            }
            return (0, $kV2FF.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        })// @ts-ignore
        .catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                statusCode: $f004911d8e8925ff$var$isClientSideError(error) ? '4XX' : '5XX'
            });
            if (failEvent) {
                failEvent.context.push({
                    componentName: 'portalRequestDetailsScreen.answerApprovalService'
                });
                (0, $aIVqJ.legacySendEvent)(failEvent);
            }
            if (error.status === 409) return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $kV2FF.decideApprovalFailure)()), (0, $jFk35.Observable).of((0, $kV2FF.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            })), (0, $jFk35.Observable).of((0, $5kfOu.showErrorFlag)((0, $7Xy60.default).conflictErrorTitle, (0, $hN5YJ.isItsmIssueRenamingEnabled)() ? (0, $7Xy60.default).conflictErrorDescriptionIssueTermRefresh : (0, $7Xy60.default).conflictErrorDescription)));
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $kV2FF.decideApprovalFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("gdtFG", function(module, exports) {
$parcel$export(module.exports, "approve", () => $3a6ba61066882728$export$5ba7c78c9d5e2122);
$parcel$export(module.exports, "decline", () => $3a6ba61066882728$export$ff9b5abb0defe452);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $3a6ba61066882728$export$5ba7c78c9d5e2122 = (approvalId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/approve`;
    return (0, $bTjsX.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};
const $3a6ba61066882728$export$ff9b5abb0defe452 = (approvalId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/reject`;
    return (0, $bTjsX.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};

});

parcelRegister("7Xy60", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f5f85842196fc35$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $9f5f85842196fc35$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    conflictErrorTitle: {
        defaultMessage: 'Error',
        description: 'Conflict error when user clicking a stale approval panel decision button.',
        id: 'sd.stale.approval.panel.conflict.title'
    },
    conflictErrorDescription: {
        defaultMessage: 'An approval response has already been submitted for this issue.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description'
    },
    conflictErrorDescriptionIssueTermRefresh: {
        defaultMessage: 'An approval response has already been submitted for this work item.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description-issue-term-refresh'
    }
});

});


parcelRegister("1ExnT", function(module, exports) {
$parcel$export(module.exports, "getMediaReadCredentialsEpic", () => $c6c87b10e9ec51bd$export$248d895b14907a3);

var $jFk35 = parcelRequire("jFk35");

var $cD8ok = parcelRequire("cD8ok");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");
const $c6c87b10e9ec51bd$export$248d895b14907a3 = (action$)=>{
    return action$.ofType((0, $kV2FF.GET_MEDIA_READ_CREDENTIALS)).mergeMap((getReadCredentialsAction)=>{
        const payload = getReadCredentialsAction.payload;
        return (0, $cD8ok.getReadCredentialsForRequest)(payload.portalId, payload.requestId).map((getReadCredentialsResponse)=>{
            return (0, $kV2FF.getReadCredentialsSuccess)(payload.requestKey, getReadCredentialsResponse);
        }).catch((_)=>{
            return (0, $jFk35.Observable).of((0, $kV2FF.getReadCredentialsFailure)());
        });
    });
};

});

parcelRegister("batva", function(module, exports) {
$parcel$export(module.exports, "removeOrganisationEpic", () => $cd0fa11399e52e58$export$b62b13475aa4d5e);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $30E9D = parcelRequire("30E9D");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $gzLyJ = parcelRequire("gzLyJ");
const $cd0fa11399e52e58$export$b62b13475aa4d5e = (action$)=>{
    return action$.ofType((0, $kV2FF.REMOVE_ORGANISATION)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, organisationId: organisationId } = removeParticipantAction.payload;
        return (0, $30E9D.removeOrganisation)(requestKey, organisationId).map(()=>{
            return (0, $kV2FF.removeOrganisationSuccess)(requestKey, organisationId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $jFk35.Observable).of(isPermissionDenied ? (0, $5kfOu.showErrorFlag)((0, $gzLyJ.default).permissionDeniedErrorTitle, (0, $gzLyJ.default).permissionDeniedErrorDescription) : (0, $5kfOu.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("30E9D", function(module, exports) {
$parcel$export(module.exports, "removeUsingAccountId", () => $24ef96af46eb583d$export$d06c11dbdb4f724e);
$parcel$export(module.exports, "removeOrganisation", () => $24ef96af46eb583d$export$66d4278db03b2954);
$parcel$export(module.exports, "search", () => $24ef96af46eb583d$export$d76128d007d19019);
$parcel$export(module.exports, "addParticipants", () => $24ef96af46eb583d$export$600fe12d720e6ff9);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $6dipk = parcelRequire("6dipk");

var $diqlM = parcelRequire("diqlM");
const $24ef96af46eb583d$export$d06c11dbdb4f724e = (requestKey, accountId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeParticipant`;
    const body = {
        accountId: accountId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $jFk35.Observable).throw(e));
};
const $24ef96af46eb583d$export$66d4278db03b2954 = (requestKey, organisationId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeOrganisation`;
    const body = {
        organisationId: organisationId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $jFk35.Observable).throw(e));
};
const $24ef96af46eb583d$export$d76128d007d19019 = (requestKey, query = '', context = (0, $diqlM.contextPath))=>{
    const queryString = $6dipk.stringify({
        q: query
    });
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/search?${queryString}`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response).catch((e)=>Promise.reject(e));
};
const $24ef96af46eb583d$export$600fe12d720e6ff9 = (requestKey, accountIds, organizationIds, emailAddresses, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/add`;
    const body = {
        accountIds: accountIds,
        organisationIds: organizationIds,
        emails: emailAddresses
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.put)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("gzLyJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $39dc6c3bf6e9a0b0$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $39dc6c3bf6e9a0b0$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.organization.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.organization.permission.denied.description'
    }
});

});


parcelRegister("2t7ls", function(module, exports) {
$parcel$export(module.exports, "removeParticipantEpic", () => $df24d6fe4fa9367f$export$3f20d6b824d24e4c);

var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $30E9D = parcelRequire("30E9D");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $bmlPy = parcelRequire("bmlPy");
const $df24d6fe4fa9367f$export$3f20d6b824d24e4c = (action$)=>{
    return action$.ofType((0, $kV2FF.REMOVE_PARTICIPANT)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, accountId: accountId } = removeParticipantAction.payload;
        return (0, $30E9D.removeUsingAccountId)(requestKey, accountId).map(()=>{
            return (0, $kV2FF.removeParticipantSuccess)(requestKey, accountId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $jFk35.Observable).of(isPermissionDenied ? (0, $5kfOu.showErrorFlag)((0, $bmlPy.default).permissionDeniedErrorTitle, (0, $bmlPy.default).permissionDeniedErrorDescription) : (0, $5kfOu.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("bmlPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c1d2da13fbcb60f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $6c1d2da13fbcb60f$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.participants.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.participants.permission.denied.description'
    }
});

});


parcelRegister("E7hpf", function(module, exports) {
$parcel$export(module.exports, "shareRequestEpic", () => $2205c8a0c185350b$export$d11c340ce54e3cbb);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $30E9D = parcelRequire("30E9D");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $gbWwh = parcelRequire("gbWwh");
const $2205c8a0c185350b$export$d11c340ce54e3cbb = (action$)=>action$.ofType((0, $kV2FF.SHARE_REQUEST)).mergeMap((shareRequestAction)=>{
        const { requestKey: requestKey, organizations: organizations, emailAddresses: emailAddresses, accountIds: accountIds, isUserMentioned: isUserMentioned, mentionedUserName: mentionedUserName, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation } = shareRequestAction.payload;
        return (0, $30E9D.addParticipants)(requestKey, accountIds, organizations, emailAddresses).flatMap((response)=>{
            if (isUserMentioned) {
                const messageTitle = mentionedUserName ? (0, $gbWwh.default).requestSharedWithSingleMentionedUserSuccessTitle : (0, $gbWwh.default).requestSharedWithMentionedUsersSuccessTitle;
                const messageDescription = mentionedUserName ? (0, $gbWwh.default).requestSharedWithSingleMentionedUserSuccessDescription : (0, $gbWwh.default).requestSharedWithMentionedUsersSuccessDescription;
                const descriptionValues = mentionedUserName ? {
                    userName: mentionedUserName
                } : undefined;
                return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $kV2FF.addParticipantsSuccess)(requestKey, response, userMentionedDuringRequestCreation)), (0, $jFk35.Observable).of((0, $5kfOu.showSuccessFlag)(messageTitle, undefined, messageDescription, undefined, descriptionValues)));
            }
            return (0, $jFk35.Observable).of((0, $kV2FF.addParticipantsSuccess)(requestKey, response));
        }).catch((error)=>{
            const isShowErrorFlag = isUserMentioned;
            const messageTitle = mentionedUserName ? (0, $gbWwh.default).requestSharedWithSingleMentionedUserFailureTitle : (0, $gbWwh.default).requestSharedWithMentionedUsersFailureTitle;
            const messageDescription = mentionedUserName ? (0, $gbWwh.default).requestSharedWithSingleMentionedUserFailureDescription : (0, $gbWwh.default).requestSharedWithMentionedUsersFailureDescription;
            const descriptionValues = mentionedUserName ? {
                userName: mentionedUserName
            } : undefined;
            return (0, $jFk35.Observable).of(isShowErrorFlag ? (0, $5kfOu.showErrorFlag)(messageTitle, messageDescription, undefined, undefined, descriptionValues) : (0, $5kfOu.handleAjaxError)(error));
        });
    });

});
parcelRegister("gbWwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba730237aa7537a9$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ba730237aa7537a9$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    requestSharedWithSingleMentionedUserSuccessTitle: {
        defaultMessage: 'New request participant added',
        description: 'request shared with the single user mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.title'
    },
    requestSharedWithSingleMentionedUserSuccessDescription: {
        defaultMessage: '{userName} has been added as a request participant to this request.',
        description: 'request shared with the single user mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.description'
    },
    requestSharedWithMentionedUsersSuccessTitle: {
        defaultMessage: 'New request participants added',
        description: 'request shared with users mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.title'
    },
    requestSharedWithMentionedUsersSuccessDescription: {
        defaultMessage: 'The users you mentioned have been added as request participants to this request.',
        description: 'request shared with users mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.description'
    },
    requestSharedWithSingleMentionedUserFailureTitle: {
        defaultMessage: "We couldn\u2019t add this request participant",
        description: 'requests sharing with single user failed title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.title'
    },
    requestSharedWithSingleMentionedUserFailureDescription: {
        defaultMessage: "{userName} couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing with single user failed description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.description'
    },
    requestSharedWithMentionedUsersFailureTitle: {
        defaultMessage: "We couldn\u2019t add these request participants",
        description: 'Title shown when sharing request with multiple mentioned users fails',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.title'
    },
    requestSharedWithMentionedUsersFailureDescription: {
        defaultMessage: "The users you mentioned couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing failed description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.description'
    }
});

});


parcelRegister("9gzKO", function(module, exports) {
$parcel$export(module.exports, "transitionRequestEpic", () => $89e8be406a70a0ba$export$2b9c3ffd3e776468);

var $jFk35 = parcelRequire("jFk35");

var $lgDHI = parcelRequire("lgDHI");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $fASm6 = parcelRequire("fASm6");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
const $89e8be406a70a0ba$export$2b9c3ffd3e776468 = (action$, store)=>{
    return action$.ofType((0, $kV2FF.TRANSITION_REQUEST)).mergeMap((transitionAction)=>{
        const payload = transitionAction.payload;
        return (0, $lgDHI.transition)(payload.requestKey, payload.transitionId, payload.comment).map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'customerTransition',
                projectId: (0, $9D9SX.getProjectId)(store.getState(), payload.portalId)
            });
            successEvent && (0, $aIVqJ.legacySendEvent)(successEvent);
            return (0, $kV2FF.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        }).catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'customerTransition'
            });
            failEvent && (0, $aIVqJ.legacySendEvent)(failEvent);
            return (0, $jFk35.Observable).of((0, $kV2FF.transitionRequestFailure)((0, $fASm6.getJiraErrorOrDefault)(error)));
        });
    });
};

});
parcelRegister("lgDHI", function(module, exports) {
$parcel$export(module.exports, "transition", () => $dc497d90bfc0017b$export$66bb15e2994e6a26);

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $dc497d90bfc0017b$export$66bb15e2994e6a26 = (issueKey, transitionId, comment, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/requests/transition`;
    const body = {
        issueKey: issueKey,
        transitionId: transitionId,
        comment: comment
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.put)(uri, body, headers);
};

});

parcelRegister("57GTn", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => (parcelRequire("9D9SX")).getPortalAnalyticAttributes);
$parcel$export(module.exports, "getName", () => (parcelRequire("9D9SX")).getName);
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("9D9SX")).getLogoUrl);
$parcel$export(module.exports, "getDescription", () => (parcelRequire("9D9SX")).getDescription);
$parcel$export(module.exports, "getPortalLocale", () => (parcelRequire("9D9SX")).getPortalLocale);
$parcel$export(module.exports, "getPortalI18nTranslations", () => (parcelRequire("9D9SX")).getPortalI18nTranslations);
$parcel$export(module.exports, "getCategories", () => (parcelRequire("9D9SX")).getCategories);
$parcel$export(module.exports, "getCategory", () => (parcelRequire("9D9SX")).getCategory);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("9D9SX")).getIsKbEnabled);
$parcel$export(module.exports, "getIsKbServer", () => (parcelRequire("9D9SX")).getIsKbServer);
$parcel$export(module.exports, "getIsPortalLoaded", () => (parcelRequire("9D9SX")).getIsPortalLoaded);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("9D9SX")).getProjectId);
$parcel$export(module.exports, "getProjectKey", () => (parcelRequire("9D9SX")).getProjectKey);
$parcel$export(module.exports, "getPortalRequestGroups", () => (parcelRequire("9D9SX")).getPortalRequestGroups);
$parcel$export(module.exports, "getPortalRequestTypes", () => (parcelRequire("9D9SX")).getPortalRequestTypes);
$parcel$export(module.exports, "getPortalRequestType", () => (parcelRequire("9D9SX")).getPortalRequestType);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => (parcelRequire("9D9SX")).getPortalRequestTypesForRequestGroup);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => (parcelRequire("9D9SX")).getPortalRequestTypesNotInRequestGroup);
$parcel$export(module.exports, "getPortal", () => (parcelRequire("9D9SX")).getPortal);
$parcel$export(module.exports, "getPortalOrError", () => (parcelRequire("9D9SX")).getPortalOrError);
$parcel$export(module.exports, "getPortalAnnouncement", () => (parcelRequire("9D9SX")).getPortalAnnouncement);
$parcel$export(module.exports, "getCanAdministerProject", () => (parcelRequire("9D9SX")).getCanAdministerProject);
$parcel$export(module.exports, "getIsProjectSimplified", () => (parcelRequire("9D9SX")).getIsProjectSimplified);
$parcel$export(module.exports, "getPortalLink", () => (parcelRequire("9D9SX")).getPortalLink);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => (parcelRequire("9D9SX")).getRequestGroupsForRequestType);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => (parcelRequire("9D9SX")).getIsRequestTypeBelongsToGroup);
$parcel$export(module.exports, "canCreateRequest", () => (parcelRequire("9D9SX")).canCreateRequest);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => (parcelRequire("9D9SX")).getPortalAnnouncementPersisted);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => (parcelRequire("9D9SX")).getPortalAnnouncementsUI);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("9D9SX")).isSaveInProgress);
$parcel$export(module.exports, "isSaveFailed", () => (parcelRequire("9D9SX")).isSaveFailed);
$parcel$export(module.exports, "getServiceDeskId", () => (parcelRequire("9D9SX")).getServiceDeskId);
$parcel$export(module.exports, "getKbSuggestions", () => (parcelRequire("9D9SX")).getKbSuggestions);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => (parcelRequire("9D9SX")).getKbLinkDomainURLs);
$parcel$export(module.exports, "getMediaApiUploadToken", () => (parcelRequire("9D9SX")).getMediaApiUploadToken);
$parcel$export(module.exports, "getMediaApiError", () => (parcelRequire("9D9SX")).getMediaApiError);

var $9D9SX = parcelRequire("9D9SX");

});
parcelRegister("9D9SX", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => $5877324ff3770940$export$c60f1a869d2c2c74);
$parcel$export(module.exports, "getPortal", () => $5877324ff3770940$export$e16cb606b6ef4a60);
$parcel$export(module.exports, "getName", () => $5877324ff3770940$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getLogoUrl", () => $5877324ff3770940$export$976f80239b15365);
$parcel$export(module.exports, "getDescription", () => $5877324ff3770940$export$67580b1c13935958);
$parcel$export(module.exports, "getPortalLocale", () => $5877324ff3770940$export$7bcd1890b058c84b);
$parcel$export(module.exports, "getPortalI18nTranslations", () => $5877324ff3770940$export$c02a81e0fafa0a40);
$parcel$export(module.exports, "getIsPortalLoaded", () => $5877324ff3770940$export$bf5e3f9152d94e3b);
$parcel$export(module.exports, "getPortalRequestGroups", () => $5877324ff3770940$export$78d9d04100263c2d);
$parcel$export(module.exports, "getPortalRequestTypes", () => $5877324ff3770940$export$64da133fb6380f70);
$parcel$export(module.exports, "getPortalRequestType", () => $5877324ff3770940$export$d1bf58a210f1b84e);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => $5877324ff3770940$export$4965f91d890eed3b);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => $5877324ff3770940$export$5a1e358eca2c7b0a);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => $5877324ff3770940$export$2f20ba1ff04c787e);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => $5877324ff3770940$export$3e60634ba4e73f5f);
$parcel$export(module.exports, "getProjectKey", () => $5877324ff3770940$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $5877324ff3770940$export$89040d072f281f85);
$parcel$export(module.exports, "getPortalOrError", () => $5877324ff3770940$export$aa66ead34639a340);
$parcel$export(module.exports, "getIsKbEnabled", () => $5877324ff3770940$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getIsKbServer", () => $5877324ff3770940$export$62e14b755e26ac1e);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => $5877324ff3770940$export$8f367c2862b9eaf4);
$parcel$export(module.exports, "getPortalAnnouncement", () => $5877324ff3770940$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $5877324ff3770940$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $5877324ff3770940$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $5877324ff3770940$export$7a0f33e8df10bd94);
$parcel$export(module.exports, "getCategory", () => $5877324ff3770940$export$410364bbb673ddbc);
$parcel$export(module.exports, "getPortalLink", () => $5877324ff3770940$export$ed7921430af91c7c);
$parcel$export(module.exports, "canCreateRequest", () => $5877324ff3770940$export$f609845398295f39);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => $5877324ff3770940$export$65fec43abdb7eb83);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => $5877324ff3770940$export$bf2c3b9a218e4a01);
$parcel$export(module.exports, "isSaveInProgress", () => $5877324ff3770940$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isSaveFailed", () => $5877324ff3770940$export$3620a86b3ad94622);
$parcel$export(module.exports, "getServiceDeskId", () => $5877324ff3770940$export$f65464f8f75f45bc);
$parcel$export(module.exports, "getKbSuggestions", () => $5877324ff3770940$export$e8626520ddba5456);
$parcel$export(module.exports, "getMediaApiUploadToken", () => $5877324ff3770940$export$b87c6f04552c18ef);
$parcel$export(module.exports, "getMediaApiError", () => $5877324ff3770940$export$ddddbd1696231d6a);

var $aYMdQ = parcelRequire("aYMdQ");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
const $5877324ff3770940$export$c60f1a869d2c2c74 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.analyticAttributes;
};
const $5877324ff3770940$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.name;
};
const $5877324ff3770940$export$976f80239b15365 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.logoUrl;
};
const $5877324ff3770940$export$67580b1c13935958 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.description;
};
const $5877324ff3770940$export$7bcd1890b058c84b = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.locale;
};
const $5877324ff3770940$export$c02a81e0fafa0a40 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.i18nTranslations;
};
const $5877324ff3770940$export$bf5e3f9152d94e3b = (state, portalId)=>!!$5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
const $5877324ff3770940$export$78d9d04100263c2d = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqGroups : [];
};
const $5877324ff3770940$export$8a8ef1c92929d685 = (state, portalId, requestGroupId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    if (!portal) return undefined;
    const requestGroupWithId = portal.reqGroups.find((reqGroup)=>reqGroup.id === requestGroupId);
    return requestGroupWithId;
};
const $5877324ff3770940$export$64da133fb6380f70 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqTypes : [];
};
const $5877324ff3770940$export$d1bf58a210f1b84e = (state, portalId, requestTypeId)=>{
    if ((0, $aYMdQ.isNil)(portalId) || (0, $aYMdQ.isNil)(requestTypeId)) return undefined;
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.reqTypes.find((reqType)=>reqType.id === String(requestTypeId));
};
const $5877324ff3770940$export$4965f91d890eed3b = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $5877324ff3770940$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $5877324ff3770940$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return [];
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesInGroup = reqTypesIdsInSelectedGroup// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((id)=>allRequestTypesInPortal.find((rt)=>rt.id === id)).filter(Boolean);
    return requestTypesInGroup;
};
const $5877324ff3770940$export$5a1e358eca2c7b0a = ({ state: state, portalId: portalId, requestTypeId: requestTypeId })=>{
    const requestGroups = $5877324ff3770940$export$78d9d04100263c2d(state, portalId);
    return requestGroups.filter((group)=>group.reqTypes.includes(String(requestTypeId)));
};
const $5877324ff3770940$export$2f20ba1ff04c787e = (state, portalId, requestGroupId, requestTypeId)=>{
    const requestGroups = $5877324ff3770940$export$5a1e358eca2c7b0a({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return (requestGroups || []).filter((requestGroup)=>requestGroup.id === requestGroupId).length > 0;
};
const $5877324ff3770940$export$3e60634ba4e73f5f = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $5877324ff3770940$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $5877324ff3770940$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return allRequestTypesInPortal;
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesNotInSelectedGroup = allRequestTypesInPortal.filter(({ id: idInPortal })=>// only include request types that are not in the specified group
        !reqTypesIdsInSelectedGroup.some((idInGroup)=>idInGroup === idInPortal));
    return requestTypesNotInSelectedGroup;
};
const $5877324ff3770940$export$667f2a0f99c75faa = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && portal.projectKey && portal.projectKey.toUpperCase();
};
const $5877324ff3770940$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $aYMdQ.isNil)(portalId)) return undefined;
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $5877324ff3770940$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $aYMdQ.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $5877324ff3770940$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $5877324ff3770940$export$d56e4bff0fec91ad = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && !!portal.knowledgeBase;
};
const $5877324ff3770940$export$62e14b755e26ac1e = (state, portalId)=>{
    var _portal$knowledgeBase;
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return Boolean(portal === null || portal === void 0 || (_portal$knowledgeBase = portal.knowledgeBase) === null || _portal$knowledgeBase === void 0 || (_portal$knowledgeBase = _portal$knowledgeBase.kbLink) === null || _portal$knowledgeBase === void 0 ? void 0 : _portal$knowledgeBase.isServer);
};
const $5877324ff3770940$export$8f367c2862b9eaf4 = (state, portalId)=>{
    var _portal$knowledgeBase2;
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return (portal === null || portal === void 0 || (_portal$knowledgeBase2 = portal.knowledgeBase) === null || _portal$knowledgeBase2 === void 0 ? void 0 : _portal$knowledgeBase2.kbLinkDomainURLs) || [];
};
const $5877324ff3770940$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $5877324ff3770940$export$b88ee522e5c6bc90 = (state, portalId)=>{
    const portalAnnouncement = $5877324ff3770940$export$78e1a2ab89c0908b(state, portalId);
    return !!portalAnnouncement && portalAnnouncement.canEditAnnouncement;
};
const $5877324ff3770940$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $5877324ff3770940$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement && portalAnnouncement.canAdministerProject;
};
const $5877324ff3770940$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.isProjectSimplified : undefined;
};
const $5877324ff3770940$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};
const $5877324ff3770940$export$410364bbb673ddbc = (state, portalId, categoryId)=>{
    if (!categoryId || !portalId) return undefined;
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        if (Array.isArray(categoryOrError)) return categoryOrError.find((category)=>category.id === categoryId);
        return categoryOrError;
    }
    return undefined;
};
const $5877324ff3770940$export$ed7921430af91c7c = (state, portalId)=>{
    const requestGroups = $5877324ff3770940$export$78d9d04100263c2d(state, portalId);
    // If the user has exactly 1 request group and request type, we link them directly to that form.
    // Otherwise we direct them to the request groups
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    let portalLink = `/portal/${portalId}/group/-1`;
    if (requestGroups.length === 1) {
        const [requestGroup] = requestGroups;
        if (requestGroup.reqTypes.length === 1) {
            const [requestTypeId] = requestGroup.reqTypes;
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            portalLink = `/portal/${portalId}/group/${requestGroup.id}/create/${requestTypeId}`;
        }
    }
    return portalLink;
};
const $5877324ff3770940$export$f609845398295f39 = (state, portalId)=>{
    if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) return false;
    return Object.keys($5877324ff3770940$export$78d9d04100263c2d(state, Number(portalId))).length > 0;
};
const $5877324ff3770940$export$65fec43abdb7eb83 = (state, payload)=>{
    const portalAnnouncement = $5877324ff3770940$export$78e1a2ab89c0908b(state, payload === null || payload === void 0 ? void 0 : payload.portalId);
    return portalAnnouncement ? portalAnnouncement : undefined;
};
const $5877324ff3770940$export$bf2c3b9a218e4a01 = (state)=>state.ui.portals.portalAnnouncementsResponse;
const $5877324ff3770940$export$2b75ac2de7a23db1 = (state)=>state.ui.portals.isSaveInProgress;
const $5877324ff3770940$export$3620a86b3ad94622 = (state)=>state.ui.portals.isSaveFailed;
const $5877324ff3770940$export$f65464f8f75f45bc = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.serviceDeskId;
};
const $5877324ff3770940$export$e8626520ddba5456 = (state, portalId)=>{
    var _portal$knowledgeBase3;
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    const kbSuggestions = portal && !('error' in portal) && ((_portal$knowledgeBase3 = portal.knowledgeBase) === null || _portal$knowledgeBase3 === void 0 ? void 0 : _portal$knowledgeBase3.kbArticleSuggestions);
    if (kbSuggestions === false || kbSuggestions === undefined) return [];
    return kbSuggestions;
};
const $5877324ff3770940$export$b87c6f04552c18ef = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiUploadToken;
};
const $5877324ff3770940$export$ddddbd1696231d6a = (state, portalId)=>{
    const portal = $5877324ff3770940$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiError;
};

});



parcelRegister("cQWEe", function(module, exports) {
$parcel$export(module.exports, "requestGroupsEpic", () => $5c17c37ed2f64245$export$194ec9e5a7b72182);
parcelRequire("e19ob");
var $eSm63 = parcelRequire("eSm63");

var $iVSzR = parcelRequire("iVSzR");

var $cGrLn = parcelRequire("cGrLn");

var $fcEE9 = parcelRequire("fcEE9");

var $9VIFk = parcelRequire("9VIFk");
const $5c17c37ed2f64245$export$194ec9e5a7b72182 = (0, $eSm63.combineEpics)((0, $iVSzR.addRequestGroupEpic), (0, $9VIFk.reorderRequestGroupEpic), (0, $fcEE9.removeRequestGroupEpic), (0, $cGrLn.getAllRequestGroupsEpic));

});
parcelRegister("iVSzR", function(module, exports) {
$parcel$export(module.exports, "addRequestGroupEpic", () => $3e3e2516279bc079$export$8362a74d5020b3ae);

var $jFk35 = parcelRequire("jFk35");

var $foLSF = parcelRequire("foLSF");
parcelRequire("hXvMi");
var $d8CDI = parcelRequire("d8CDI");
parcelRequire("hPZpM");
var $hDMR6 = parcelRequire("hDMR6");

var $fASm6 = parcelRequire("fASm6");

var $aIVqJ = parcelRequire("aIVqJ");
const $3e3e2516279bc079$export$8362a74d5020b3ae = (action$)=>{
    return action$.ofType((0, $d8CDI.ADD_REQUEST_GROUP)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId, groupName: groupName, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        return (0, $foLSF.addRequestGroup)(groupName, projectId).map((response)=>{
            if (analyticsEvent) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEvent.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $aIVqJ.legacySendEvent)(analyticsEvent);
            }
            return (0, $hDMR6.getRequestGroupsAction)(projectId, portalId);
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(analyticsFailureEvent);
            return (0, $jFk35.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $d8CDI.addRequestGroupFailedAction)((0, $fASm6.getFirstMessageFromJiraError)(error.response), groupName));
        });
    });
};

});
parcelRegister("foLSF", function(module, exports) {
$parcel$export(module.exports, "addRequestGroup", () => $6d44a13749a05b68$export$2a108ddc24673b82);
$parcel$export(module.exports, "updateRequestGroup", () => $6d44a13749a05b68$export$6343ebb5dbd23e24);
$parcel$export(module.exports, "fetchAllRequestGroups", () => $6d44a13749a05b68$export$1baf2ae38689e29e);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $6d44a13749a05b68$export$2a108ddc24673b82 = (name, projectId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $bTjsX.post)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $4Q7yw.Observable).throw(e);
    });
};
const $6d44a13749a05b68$export$6343ebb5dbd23e24 = ({ name: name, projectId: projectId, requestGroupId: requestGroupId, context: context = (0, $diqlM.contextPath) })=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}`;
    return (0, $bTjsX.put)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $4Q7yw.Observable).throw(e));
};
const $6d44a13749a05b68$export$1baf2ae38689e29e = (projectId, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $bTjsX.get)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $4Q7yw.Observable).throw(e));
};

});

parcelRegister("hXvMi", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => (parcelRequire("d8CDI")).ADD_REQUEST_GROUP);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => (parcelRequire("d8CDI")).ADD_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestGroupAction", () => (parcelRequire("d8CDI")).addRequestGroupAction);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => (parcelRequire("d8CDI")).addRequestGroupFailedAction);

var $d8CDI = parcelRequire("d8CDI");

});
parcelRegister("d8CDI", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => $a7a9b9b0bef479f4$export$8e1d62e25202aae2);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => $a7a9b9b0bef479f4$export$3098f04a186c7a1a);
$parcel$export(module.exports, "addRequestGroupAction", () => $a7a9b9b0bef479f4$export$207b3b17fddc56c6);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => $a7a9b9b0bef479f4$export$668bfa1c007e18ef);
const $a7a9b9b0bef479f4$export$8e1d62e25202aae2 = 'epic.request-groups.ADD_REQUEST_GROUP';
const $a7a9b9b0bef479f4$export$3098f04a186c7a1a = 'epic.request-groups.ADD_REQUEST_GROUP_FAILED';
const $a7a9b9b0bef479f4$export$207b3b17fddc56c6 = (payload)=>({
        payload: payload,
        type: $a7a9b9b0bef479f4$export$8e1d62e25202aae2
    });
const $a7a9b9b0bef479f4$export$668bfa1c007e18ef = (message, groupNameThatCausedError)=>({
        payload: {
            message: message,
            groupNameThatCausedError: groupNameThatCausedError
        },
        type: $a7a9b9b0bef479f4$export$3098f04a186c7a1a
    });

});


parcelRegister("hPZpM", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => (parcelRequire("hDMR6")).GET_ALL_REQUEST_GROUPS);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => (parcelRequire("hDMR6")).GET_ALL_REQUEST_GROUPS_FAILURE);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => (parcelRequire("hDMR6")).GET_ALL_REQUEST_GROUPS_SUCCESS);
$parcel$export(module.exports, "getRequestGroupsAction", () => (parcelRequire("hDMR6")).getRequestGroupsAction);
$parcel$export(module.exports, "getRequestGroupsFailure", () => (parcelRequire("hDMR6")).getRequestGroupsFailure);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => (parcelRequire("hDMR6")).getRequestGroupsSuccess);
parcelRequire("hDMR6");

});
parcelRegister("hDMR6", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => $712e502f31d58dc1$export$4385e1518ec9ee53);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => $712e502f31d58dc1$export$b61d00db9e210ef);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => $712e502f31d58dc1$export$80b563f5e425073f);
$parcel$export(module.exports, "getRequestGroupsAction", () => $712e502f31d58dc1$export$9c0c7a1030efe8de);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => $712e502f31d58dc1$export$c1f5fa36efe1c1c7);
$parcel$export(module.exports, "getRequestGroupsFailure", () => $712e502f31d58dc1$export$a8d060d6575e9dfb);
const $712e502f31d58dc1$export$4385e1518ec9ee53 = 'epic.request-groups.GET_ALL_REQUEST_GROUPS';
const $712e502f31d58dc1$export$b61d00db9e210ef = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_SUCCESS';
const $712e502f31d58dc1$export$80b563f5e425073f = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_FAILURE';
const $712e502f31d58dc1$export$9c0c7a1030efe8de = (projectId, portalId)=>({
        payload: {
            projectId: projectId,
            portalId: portalId
        },
        type: $712e502f31d58dc1$export$4385e1518ec9ee53
    });
const $712e502f31d58dc1$export$c1f5fa36efe1c1c7 = (payload)=>({
        payload: payload,
        type: $712e502f31d58dc1$export$b61d00db9e210ef
    });
const $712e502f31d58dc1$export$a8d060d6575e9dfb = (payload)=>({
        payload: payload,
        type: $712e502f31d58dc1$export$80b563f5e425073f
    });

});



parcelRegister("cGrLn", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsEpic", () => $ef2aa0d30db38af5$export$53dc813939b78da1);

var $4Q7yw = parcelRequire("4Q7yw");

var $foLSF = parcelRequire("foLSF");
parcelRequire("hPZpM");
var $hDMR6 = parcelRequire("hDMR6");

var $fASm6 = parcelRequire("fASm6");
const $ef2aa0d30db38af5$export$53dc813939b78da1 = (action$)=>action$.ofType((0, $hDMR6.GET_ALL_REQUEST_GROUPS)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId } = action.payload;
        return (0, $foLSF.fetchAllRequestGroups)(projectId).map((requestGroups)=>(0, $hDMR6.getRequestGroupsSuccess)({
                portalId: portalId,
                requestGroups: requestGroups
            })).catch((e)=>{
            const errorMessage = (0, $fASm6.getFirstMessageFromJiraError)(e.response);
            return (0, $4Q7yw.Observable).of((0, $hDMR6.getRequestGroupsFailure)({
                errorMessage: errorMessage,
                projectId: projectId
            }));
        });
    });

});

parcelRegister("fcEE9", function(module, exports) {
$parcel$export(module.exports, "removeRequestGroupEpic", () => $92b063ef04f1757d$export$7a528fd4d213cd7);

var $jFk35 = parcelRequire("jFk35");

var $56rrB = parcelRequire("56rrB");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("5BWZD");
var $lTkP7 = parcelRequire("lTkP7");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $aIVqJ = parcelRequire("aIVqJ");
const $92b063ef04f1757d$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $92b063ef04f1757d$export$7a528fd4d213cd7 = (action$, store)=>{
    return action$.ofType((0, $lTkP7.REMOVE_REQUEST_GROUP)).mergeMap(({ payload: { portalId: portalId, deletedId: deletedId, onRemoveGroupSuccess: onRemoveGroupSuccess, onRemoveGroupError: onRemoveGroupError, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $9D9SX.getProjectId)(state, portalId);
        const requestGroups = (0, $9D9SX.getPortalRequestGroups)(state, portalId);
        const newOrder = requestGroups.map(({ id: id })=>id).filter((id)=>id !== deletedId);
        // Perform the rest call to update groups
        return (0, $56rrB.requestGroupReorder)({
            projectId: projectId,
            order: newOrder,
            id: $92b063ef04f1757d$var$REQUEST_ID,
            deleted: [
                deletedId
            ],
            inline: true
        })// On success, refresh the model
        .map(()=>{
            analyticsEvent && (0, $aIVqJ.legacySendEvent)(analyticsEvent);
            if (onRemoveGroupSuccess) onRemoveGroupSuccess();
            return (0, $hijaX.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        })// On fail, clear the ui state to reverse optimistic update
        .catch(()=>{
            if (onRemoveGroupError) onRemoveGroupError();
            if (analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $lTkP7.removeRequestGroupFailedAction)());
        });
    });
};

});
parcelRegister("56rrB", function(module, exports) {
$parcel$export(module.exports, "requestGroupReorder", () => $6053ee1ce44af657$export$e26022a90e227660);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");
const $6053ee1ce44af657$export$e26022a90e227660 = ({ id: id, deleted: deleted, order: order, inline: inline, projectId: projectId })=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    const body = {
        id: id,
        deleted: deleted,
        order: order,
        inline: inline
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.put)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("5BWZD", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => (parcelRequire("lTkP7")).REMOVE_REQUEST_GROUP);
$parcel$export(module.exports, "removeRequestGroupAction", () => (parcelRequire("lTkP7")).removeRequestGroupAction);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => (parcelRequire("lTkP7")).removeRequestGroupFailedAction);

var $lTkP7 = parcelRequire("lTkP7");

});
parcelRegister("lTkP7", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => $fa530075de2ba09c$export$7aaaf575c1ef21c8);
$parcel$export(module.exports, "removeRequestGroupAction", () => $fa530075de2ba09c$export$fe2120d3bdfd11a7);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => $fa530075de2ba09c$export$35f1f33f6fdb929d);
const $fa530075de2ba09c$export$7aaaf575c1ef21c8 = 'epic.request-groups.REMOVE_REQUEST_GROUP';
const $fa530075de2ba09c$var$REMOVE_REQUEST_GROUP_FAILED = 'epic.request-groups.REMOVE_REQUEST_GROUP_FAILED';
const $fa530075de2ba09c$export$fe2120d3bdfd11a7 = (payload)=>{
    return {
        payload: payload,
        type: $fa530075de2ba09c$export$7aaaf575c1ef21c8
    };
};
const $fa530075de2ba09c$export$35f1f33f6fdb929d = ()=>{
    return {
        type: $fa530075de2ba09c$var$REMOVE_REQUEST_GROUP_FAILED
    };
};

});



parcelRegister("9VIFk", function(module, exports) {
$parcel$export(module.exports, "reorderRequestGroupEpic", () => $e497f5c58b705eec$export$691172c527fd88df);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $56rrB = parcelRequire("56rrB");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("25e17");
var $irHmR = parcelRequire("irHmR");
parcelRequire("hPZpM");
var $hDMR6 = parcelRequire("hDMR6");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("e2CVD");
var $hj1wl = parcelRequire("hj1wl");

var $aIVqJ = parcelRequire("aIVqJ");
const $e497f5c58b705eec$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $e497f5c58b705eec$export$691172c527fd88df = (action$, store)=>{
    return action$.ofType((0, $irHmR.UPDATE_REQUEST_GROUPS_ORDER))// User may perform updates (reorders and deletes) rapidly but we want to minimise unnecessary REST calls
    // We could debounce but we want ALL the analytics events so instead we buffer, get ALL the analytics events
    // and then just process the most recent event and if successful fire ALL analytics events
    .bufferTime(500).mergeMap((bufferedActions)=>{
        // First, create list of buffered analytic events (ALL will be fired if `update request groups` REST call is successful)
        const analyticsEvents = bufferedActions.map((action)=>action.payload.analyticsEvent).filter(Boolean);
        const analyticsFailureEvents = bufferedActions.map((action)=>action.payload.analyticsFailureEvent).filter(Boolean);
        // Second, pop the most recently published action
        const mostRecentAction = bufferedActions.pop();
        if (!mostRecentAction) return (0, $jFk35.Observable).empty();
        const { portalId: portalId, order: order } = mostRecentAction.payload;
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $9D9SX.getProjectId)(state, portalId);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const requestGroups = (0, $hj1wl.getUIRequestGroups)(state, portalId);
        const deletedIds = requestGroups.map(({ id: id })=>id).filter((id)=>!order.includes(id));
        // Perform the rest call to update groups
        return (0, $56rrB.requestGroupReorder)({
            projectId: projectId,
            order: order,
            deleted: deletedIds,
            id: $e497f5c58b705eec$var$REQUEST_ID,
            inline: true
        })// On success, refresh the model
        .mergeMap(()=>{
            // Success; fire ALL analytics events
            analyticsEvents.forEach((0, $aIVqJ.legacySendEvent));
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $hDMR6.getRequestGroupsAction)(projectId, portalId)), (0, $jFk35.Observable).of((0, $hijaX.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            })));
        })// On fail, clear the ui state to reverse optimistic update
        .catch((_)=>{
            analyticsFailureEvents.forEach((0, $aIVqJ.legacySendEvent));
            return (0, $jFk35.Observable).of((0, $irHmR.clearRequestGroupsOrderAction)());
        });
    });
};

});
parcelRegister("25e17", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => (parcelRequire("irHmR")).UPDATE_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => (parcelRequire("irHmR")).CLEAR_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => (parcelRequire("irHmR")).CLEAR_ERROR_MESSAGE);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => (parcelRequire("irHmR")).CLEAR_REQUEST_TYPES_ORDER);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => (parcelRequire("irHmR")).updateRequestGroupsOrderAction);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => (parcelRequire("irHmR")).clearRequestGroupsOrderAction);
$parcel$export(module.exports, "clearErrorMessageAction", () => (parcelRequire("irHmR")).clearErrorMessageAction);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => (parcelRequire("irHmR")).clearRequestTypesOrderAction);

var $irHmR = parcelRequire("irHmR");

});
parcelRegister("irHmR", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => $4b03e351a4811fe2$export$3206afd0265da736);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => $4b03e351a4811fe2$export$cef961ec6e406565);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => $4b03e351a4811fe2$export$954b6cd4735c91da);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => $4b03e351a4811fe2$export$896c4eec286cc76c);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => $4b03e351a4811fe2$export$c362b5f333b2372c);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => $4b03e351a4811fe2$export$1a19c76107cb4b0c);
$parcel$export(module.exports, "clearErrorMessageAction", () => $4b03e351a4811fe2$export$a72b98a8de57346e);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => $4b03e351a4811fe2$export$8e8d01bbfddde092);
const $4b03e351a4811fe2$export$3206afd0265da736 = 'state.ui.portal-customisation.UPDATE_REQUEST_GROUPS_ORDER';
const $4b03e351a4811fe2$export$cef961ec6e406565 = 'state.ui.portal-customisation.CLEAR_REQUEST_GROUPS_ORDER';
const $4b03e351a4811fe2$export$954b6cd4735c91da = 'state.ui.portal-customisation.CLEAR_ERROR_MESSAGE';
const $4b03e351a4811fe2$export$896c4eec286cc76c = 'state.ui.portal-customisation.CLEAR_REQUEST_TYPES_ORDER';
const $4b03e351a4811fe2$export$c362b5f333b2372c = (payload)=>({
        payload: payload,
        type: $4b03e351a4811fe2$export$3206afd0265da736
    });
const $4b03e351a4811fe2$export$1a19c76107cb4b0c = ()=>({
        type: $4b03e351a4811fe2$export$cef961ec6e406565
    });
const $4b03e351a4811fe2$export$a72b98a8de57346e = ()=>({
        type: $4b03e351a4811fe2$export$954b6cd4735c91da
    });
const $4b03e351a4811fe2$export$8e8d01bbfddde092 = ()=>({
        type: $4b03e351a4811fe2$export$896c4eec286cc76c
    });

});


parcelRegister("e2CVD", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => (parcelRequire("hj1wl")).getAllRequestGroupsWithRequestTypesForPortal);
$parcel$export(module.exports, "getErrorMessage", () => (parcelRequire("hj1wl")).getErrorMessage);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => (parcelRequire("hj1wl")).getGroupNameThatCausedError);
$parcel$export(module.exports, "getPortalCustomisationError", () => (parcelRequire("hj1wl")).getPortalCustomisationError);
$parcel$export(module.exports, "getRequestGroupById", () => (parcelRequire("hj1wl")).getRequestGroupById);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => (parcelRequire("hj1wl")).getUIIsParentRequestGroupsLoading);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => (parcelRequire("hj1wl")).getUIParentRequestGroupsForRequestType);
$parcel$export(module.exports, "getUIRequestGroups", () => (parcelRequire("hj1wl")).getUIRequestGroups);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => (parcelRequire("hj1wl")).getUIRequestGroupsOrder);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => (parcelRequire("hj1wl")).getUIRequestGroupsWithRequestTypes);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => (parcelRequire("hj1wl")).getUIRequestTypesInRequestGroupById);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => (parcelRequire("hj1wl")).getUIRequestTypesNotInRequestGroupById);
parcelRequire("hj1wl");

});
parcelRegister("hj1wl", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => $271fb789f1580327$export$eafd9d6b190f9991);
$parcel$export(module.exports, "getErrorMessage", () => $271fb789f1580327$export$82f46aa4e6535a45);
$parcel$export(module.exports, "getRequestGroupById", () => $271fb789f1580327$export$c93f0b0a861dcf03);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => $271fb789f1580327$export$13689122403cb761);
$parcel$export(module.exports, "getUIRequestGroups", () => $271fb789f1580327$export$5b1cb606e38791c6);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => $271fb789f1580327$export$5d023274645990b2);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => $271fb789f1580327$export$3257afc3359cfce);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => $271fb789f1580327$export$9abf85e04ff9329b);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => $271fb789f1580327$export$1863e442385dba5c);
$parcel$export(module.exports, "getPortalCustomisationError", () => $271fb789f1580327$export$7b32ab9a7ad364f3);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => $271fb789f1580327$export$9f49200face9760d);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => $271fb789f1580327$export$5f6e3f684cf8395b);
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
/**
 *
 *  Persisted Portal Customisation state selectors
 *
 */ const $271fb789f1580327$var$withRequestTypesPopulated = (groupsWithTypes)=>(reqGroup)=>{
        const existingReqTypes = groupsWithTypes.find((rg)=>rg.id === reqGroup.id);
        return {
            ...reqGroup,
            reqTypes: !!existingReqTypes ? existingReqTypes.reqTypes : []
        };
    };
const $271fb789f1580327$export$25ec121fd14d9df3 = (state)=>state.persisted.portalCustomisation.allRequestGroups;
const $271fb789f1580327$export$514a0edc3b518db9 = (state, portalId)=>{
    const allRequestGroups = $271fb789f1580327$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return allRequestGroups[portalId];
};
const $271fb789f1580327$export$eafd9d6b190f9991 = (state, portalId)=>{
    const allRequestGroups = $271fb789f1580327$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    const groupsWithExistingRequestTypes = (0, $9D9SX.getPortalRequestGroups)(state, portalId);
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const requestGroupsWithRequestTypes = allRequestGroups[portalId].map($271fb789f1580327$var$withRequestTypesPopulated(groupsWithExistingRequestTypes));
    return requestGroupsWithRequestTypes;
};
const $271fb789f1580327$export$82f46aa4e6535a45 = (state)=>state.persisted.portalCustomisation.errorMessage;
const $271fb789f1580327$export$c93f0b0a861dcf03 = (state, portalId, requestGroupId)=>{
    const requestGroups = $271fb789f1580327$export$eafd9d6b190f9991(state, portalId);
    return !!requestGroups ? requestGroups.find((group)=>group.id === requestGroupId) : undefined;
};
const $271fb789f1580327$export$13689122403cb761 = (state)=>state.ui.portalCustomisation.requestGroupsOrder;
const $271fb789f1580327$export$f7da43c7a00426c = (state)=>state.ui.portalCustomisation.requestTypesOrder;
const $271fb789f1580327$export$5b1cb606e38791c6 = (state, portalId)=>state.ui.portalCustomisation.requestGroups || $271fb789f1580327$export$514a0edc3b518db9(state, portalId);
const $271fb789f1580327$export$5d023274645990b2 = (state, portalId)=>state.ui.portalCustomisation.requestGroups ? state.ui.portalCustomisation.requestGroups.map($271fb789f1580327$var$withRequestTypesPopulated((0, $9D9SX.getPortalRequestGroups)(state, portalId))) : $271fb789f1580327$export$eafd9d6b190f9991(state, portalId);
const $271fb789f1580327$export$3257afc3359cfce = (state, portalId, requestGroupId)=>{
    let requestTypesInRequestGroup = state.ui.portalCustomisation.requestTypesInRequestGroup || (0, $9D9SX.getPortalRequestTypesForRequestGroup)(state, portalId, requestGroupId);
    const requestTypesOrder = $271fb789f1580327$export$f7da43c7a00426c(state);
    if (requestTypesOrder) requestTypesInRequestGroup = requestTypesOrder.map((requestTypeId)=>requestTypesInRequestGroup.find((rt)=>Number(rt.id) === requestTypeId)).filter(Boolean);
    return requestTypesInRequestGroup;
};
const $271fb789f1580327$export$9abf85e04ff9329b = (state, portalId, requestTypeId)=>{
    const parentRequestGroups = state.ui.portalCustomisation.parentRequestGroups || (0, $9D9SX.getRequestGroupsForRequestType)({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return [
        ...parentRequestGroups
    ].sort((first, second)=>first.name.toLowerCase().localeCompare(second.name.toLowerCase()));
};
const $271fb789f1580327$export$1863e442385dba5c = (state)=>{
    return state.ui.portalCustomisation.isParentRequestGroupsLoading;
};
const $271fb789f1580327$export$7b32ab9a7ad364f3 = (state)=>state.ui.portalCustomisation.error;
const $271fb789f1580327$export$9f49200face9760d = (state)=>state.ui.portalCustomisation.groupNameThatCausedError;
const $271fb789f1580327$export$5f6e3f684cf8395b = (state, portalId, requestGroupId)=>{
    return state.ui.portalCustomisation.requestTypesNotInRequestGroup || (0, $9D9SX.getPortalRequestTypesNotInRequestGroup)(state, portalId, requestGroupId);
};

});




parcelRegister("kLsp0", function(module, exports) {
$parcel$export(module.exports, "addRequestTypeToRequestGroupEpic", () => $d3bf38873e215b2e$export$7219fe759636c43a);

var $jFk35 = parcelRequire("jFk35");

var $aYMdQ = parcelRequire("aYMdQ");

var $1Up2V = parcelRequire("1Up2V");
parcelRequire("ERi1L");
var $3wJyi = parcelRequire("3wJyi");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("e2CVD");
var $hj1wl = parcelRequire("hj1wl");

var $fASm6 = parcelRequire("fASm6");

var $aIVqJ = parcelRequire("aIVqJ");
const $d3bf38873e215b2e$var$getAssociatedGroups = (requestType, requestGroup, requestGroups)=>{
    const associatedRequestGroups = (0, $aYMdQ.uniqBy)(requestGroups, 'id').filter((reqGroup)=>reqGroup.reqTypes.includes(requestType.id));
    // Add group association to request type if not already added
    if (!associatedRequestGroups.includes(requestGroup)) associatedRequestGroups.push(requestGroup);
    return associatedRequestGroups;
};
const $d3bf38873e215b2e$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $d3bf38873e215b2e$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $d3bf38873e215b2e$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroup, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $d3bf38873e215b2e$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $d3bf38873e215b2e$var$getSanitizedText(requestType.descriptionHtml),
        groups: $d3bf38873e215b2e$var$getAssociatedGroups(requestType, requestGroup, requestGroups)
    });
const $d3bf38873e215b2e$export$7219fe759636c43a = (action$, store)=>{
    return action$.ofType((0, $3wJyi.ADD_REQUEST_TYPE_TO_REQUEST_GROUP)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroup: requestGroup, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        const requestGroups = (0, $hj1wl.getAllRequestGroupsWithRequestTypesForPortal)(state, portalId) || [];
        return (0, $1Up2V.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: requestGroup.id,
            requestGroupId: requestGroup.id,
            requestType: $d3bf38873e215b2e$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroup, requestGroups)
        }).map(()=>{
            analyticsEvent && (0, $aIVqJ.legacySendEvent)(analyticsEvent);
            return (0, $hijaX.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $3wJyi.addRequestTypeToRequestGroupFailedAction)((0, $fASm6.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("1Up2V", function(module, exports) {
$parcel$export(module.exports, "setRequestGroupsForRequestType", () => $c3da9a3c593b8098$export$9067d57db9e6b38e);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");
const $c3da9a3c593b8098$export$9067d57db9e6b38e = ({ isProjectSimplified: isProjectSimplified, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroupId: requestGroupId, projectId: projectId, context: context = (0, $diqlM.contextPath) })=>{
    if (isProjectSimplified) {
        const nextGenUri = (groupId)=>`${context}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${groupId}/${requestType.id}`;
        const isAdded = requestType.groups.some(({ id: id })=>id === updatedRequestTypeGroupId);
        const httpMethod = isAdded ? (0, $bTjsX.put) : (0, $bTjsX.doDelete);
        return httpMethod(nextGenUri(updatedRequestTypeGroupId))// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response).catch((e)=>{
            // Rethrow error
            return (0, $jFk35.Observable).throw(e);
        });
    }
    // In Classic:
    // The request type <-> group association is stored on a request type in the backend
    // We call the update request type endpoint with the request type in the body with the new group associsation
    const classicUri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestType.id}`;
    return (0, $bTjsX.put)(classicUri, requestType, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $jFk35.Observable).throw(e);
    });
};

});

parcelRegister("ERi1L", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => (parcelRequire("3wJyi")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => (parcelRequire("3wJyi")).addRequestTypeToRequestGroupAction);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => (parcelRequire("3wJyi")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => (parcelRequire("3wJyi")).addRequestTypeToRequestGroupFailedAction);

var $3wJyi = parcelRequire("3wJyi");

});
parcelRegister("3wJyi", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => $46430f732eb9437b$export$eb48643df0521b0d);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => $46430f732eb9437b$export$196767c05c5a3485);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => $46430f732eb9437b$export$e0f4630e32187ebc);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => $46430f732eb9437b$export$87cedd1ffa234cc5);
const $46430f732eb9437b$export$eb48643df0521b0d = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP';
const $46430f732eb9437b$export$196767c05c5a3485 = (payload)=>{
    return {
        payload: payload,
        type: $46430f732eb9437b$export$eb48643df0521b0d
    };
};
const $46430f732eb9437b$var$ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED';
const $46430f732eb9437b$export$e0f4630e32187ebc = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED';
const $46430f732eb9437b$export$87cedd1ffa234cc5 = (message)=>({
        payload: {
            message: message
        },
        type: $46430f732eb9437b$export$e0f4630e32187ebc
    });

});



parcelRegister("5pKkD", function(module, exports) {
$parcel$export(module.exports, "createGroupWithRequestTypeEpic", () => $ab38d122414fde9a$export$2d5fcba5bbcf0933);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $foLSF = parcelRequire("foLSF");
parcelRequire("diqb8");
var $6g8yl = parcelRequire("6g8yl");
parcelRequire("hPZpM");
var $hDMR6 = parcelRequire("hDMR6");
parcelRequire("klmhp");
var $lArI5 = parcelRequire("lArI5");

var $fASm6 = parcelRequire("fASm6");

var $aIVqJ = parcelRequire("aIVqJ");
const $ab38d122414fde9a$export$2d5fcba5bbcf0933 = (action$)=>{
    return action$.ofType((0, $6g8yl.CREATE_GROUP_WITH_REQUEST_TYPE)).mergeMap((action)=>{
        const { isProjectSimplified: isProjectSimplified, projectId: projectId, portalId: portalId, groupName: groupName, analyticsEventRequestGroupCreated: analyticsEventRequestGroupCreated, analyticsEventRequestGroupUpdated: analyticsEventRequestGroupUpdated, requestType: requestType, requestGroups: requestGroups, analyticsEventRequestGroupCreatedFailure: analyticsEventRequestGroupCreatedFailure, analyticsEventRequestGroupUpdatedFailure: analyticsEventRequestGroupUpdatedFailure } = action.payload;
        return (0, $foLSF.addRequestGroup)(groupName, projectId).mergeMap((response)=>{
            if (analyticsEventRequestGroupCreated) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEventRequestGroupCreated.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $aIVqJ.legacySendEvent)(analyticsEventRequestGroupCreated);
            }
            if (analyticsEventRequestGroupUpdated) // Update the analytics event with newly created Request type group's ID as the actionSubjectId
            analyticsEventRequestGroupUpdated.update((payload)=>({
                    ...payload,
                    actionSubjectId: response.id
                }));
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $hDMR6.getRequestGroupsAction)(projectId, portalId)), (0, $jFk35.Observable).of((0, $lArI5.setRequestTypeGroupsAction)({
                isProjectSimplified: isProjectSimplified,
                portalId: portalId,
                projectId: projectId,
                requestType: requestType,
                updatedRequestTypeGroupId: response.id,
                analyticsEvent: analyticsEventRequestGroupUpdated,
                requestGroups: [
                    ...requestGroups,
                    response
                ]
            })));
        }).catch((error)=>{
            [
                analyticsEventRequestGroupCreatedFailure,
                analyticsEventRequestGroupUpdatedFailure
            ].filter((x)=>x).forEach((event)=>{
                (0, $aIVqJ.legacySendEvent)(event);
            });
            return (0, $jFk35.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $6g8yl.createGroupWithRequestTypeFailedAction)((0, $fASm6.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("diqb8", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => (parcelRequire("6g8yl")).CREATE_GROUP_WITH_REQUEST_TYPE);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => (parcelRequire("6g8yl")).CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => (parcelRequire("6g8yl")).CREATE_GROUP_WITH_REQUEST_TYPE_FAILED);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => (parcelRequire("6g8yl")).createGroupWithRequestTypeAction);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => (parcelRequire("6g8yl")).createGroupWithRequestTypeFailedAction);

var $6g8yl = parcelRequire("6g8yl");

});
parcelRegister("6g8yl", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => $b5deeff54d03c80e$export$c69550447058b57a);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => $b5deeff54d03c80e$export$c456181637c5858e);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => $b5deeff54d03c80e$export$71c9976978aa32b4);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => $b5deeff54d03c80e$export$10336454f9456d40);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => $b5deeff54d03c80e$export$729bba13ddb7a330);
const $b5deeff54d03c80e$export$c69550447058b57a = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE';
const $b5deeff54d03c80e$export$c456181637c5858e = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED';
const $b5deeff54d03c80e$export$71c9976978aa32b4 = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED';
const $b5deeff54d03c80e$export$10336454f9456d40 = (payload)=>({
        payload: payload,
        type: $b5deeff54d03c80e$export$c69550447058b57a
    });
const $b5deeff54d03c80e$export$8bd250cf41846ec6 = ()=>({
        type: $b5deeff54d03c80e$export$c456181637c5858e
    });
const $b5deeff54d03c80e$export$729bba13ddb7a330 = (message)=>({
        payload: {
            message: message
        },
        type: $b5deeff54d03c80e$export$71c9976978aa32b4
    });

});


parcelRegister("klmhp", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => (parcelRequire("lArI5")).SET_REQUEST_TYPE_GROUPS);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => (parcelRequire("lArI5")).setRequestTypeGroupsAction);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => (parcelRequire("lArI5")).SET_REQUEST_TYPE_GROUPS_FAILED);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => (parcelRequire("lArI5")).setRequestTypeGroupsFailedAction);

var $lArI5 = parcelRequire("lArI5");

});
parcelRegister("lArI5", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => $dd499a660f9706ff$export$44dbc716b23b5565);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => $dd499a660f9706ff$export$9d952046e09fb735);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => $dd499a660f9706ff$export$509c65d9f883a62a);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => $dd499a660f9706ff$export$337a82f6e04125f9);
const $dd499a660f9706ff$export$44dbc716b23b5565 = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS';
const $dd499a660f9706ff$export$9d952046e09fb735 = (payload)=>{
    return {
        payload: payload,
        type: $dd499a660f9706ff$export$44dbc716b23b5565
    };
};
const $dd499a660f9706ff$export$509c65d9f883a62a = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS_FAILED';
const $dd499a660f9706ff$export$337a82f6e04125f9 = (message)=>({
        payload: {
            message: message
        },
        type: $dd499a660f9706ff$export$509c65d9f883a62a
    });

});



parcelRegister("6nVoo", function(module, exports) {
$parcel$export(module.exports, "deleteRequestTypeFromGroupEpic", () => $24cd7ffbc1db3887$export$d1c43b1bbe33b61c);

var $jFk35 = parcelRequire("jFk35");

var $lnYeg = parcelRequire("lnYeg");
parcelRequire("8txpj");
var $fAQue = parcelRequire("fAQue");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("25e17");
var $irHmR = parcelRequire("irHmR");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $aIVqJ = parcelRequire("aIVqJ");
const $24cd7ffbc1db3887$export$d1c43b1bbe33b61c = (action$, store)=>{
    return action$.ofType((0, $fAQue.DELETE_REQUEST_TYPE_FROM_GROUP)).mergeMap((action)=>{
        const state = store.getState();
        const { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroupId: requestGroupId, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        const updatedRequestGroups = (0, $9D9SX.getRequestGroupsForRequestType)({
            state: state,
            portalId: portalId,
            requestTypeId: Number(requestType.id)
        }).filter((requestGroup)=>requestGroup.id !== requestGroupId);
        const body = {
            ...requestType,
            groups: updatedRequestGroups
        };
        return (0, $lnYeg.deleteRequestTypeFromGroup)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            requestGroupId: requestGroupId,
            requestType: body
        }).map(()=>{
            analyticsEvent && (0, $aIVqJ.legacySendEvent)(analyticsEvent);
            return (0, $hijaX.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $irHmR.clearRequestTypesOrderAction)());
        });
    });
};

});
parcelRegister("lnYeg", function(module, exports) {
$parcel$export(module.exports, "requestTypeReorder", () => $73e52d2f203ab1a5$export$f7d2151053714646);
$parcel$export(module.exports, "deleteRequestTypeFromGroup", () => $73e52d2f203ab1a5$export$4ef0a9afff40ad59);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");
const $73e52d2f203ab1a5$export$f7d2151053714646 = ({ projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, body: body })=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}/move`;
    return (0, $bTjsX.post)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $jFk35.Observable).throw(e));
};
const $73e52d2f203ab1a5$export$4ef0a9afff40ad59 = ({ isProjectSimplified: isProjectSimplified, projectId: projectId, requestGroupId: requestGroupId, requestType: toUpdate })=>{
    const { id: requestTypeId } = toUpdate;
    if (isProjectSimplified) {
        const nextGenUri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${requestGroupId}/${requestTypeId}`;
        return (0, $bTjsX.doDelete)(nextGenUri, undefined).map(({ response: response })=>response).catch((e)=>(0, $jFk35.Observable).throw(e));
    }
    const classicUri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}`;
    return (0, $bTjsX.put)(classicUri, toUpdate, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $jFk35.Observable).throw(e));
};

});

parcelRegister("8txpj", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => (parcelRequire("fAQue")).DELETE_REQUEST_TYPE_FROM_GROUP);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => (parcelRequire("fAQue")).deleteRequestTypeFromGroupAction);
parcelRequire("fAQue");

});
parcelRegister("fAQue", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => $3c07a278f4d9a648$export$37d5cf3470d18d4a);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => $3c07a278f4d9a648$export$dd2f56a17442f2c4);
const $3c07a278f4d9a648$export$37d5cf3470d18d4a = 'epic.request-types.DELETE_REQUEST_TYPE_FROM_GROUP';
const $3c07a278f4d9a648$export$dd2f56a17442f2c4 = (payload)=>({
        payload: payload,
        type: $3c07a278f4d9a648$export$37d5cf3470d18d4a
    });

});



parcelRegister("72u69", function(module, exports) {
$parcel$export(module.exports, "reorderRequestTypeEpic", () => $d08a34c0644049bc$export$efb6288a30e93a3a);

var $jFk35 = parcelRequire("jFk35");

var $lnYeg = parcelRequire("lnYeg");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("25e17");
var $irHmR = parcelRequire("irHmR");
parcelRequire("hVkR1");
var $jBKKK = parcelRequire("jBKKK");

var $aIVqJ = parcelRequire("aIVqJ");
const $d08a34c0644049bc$export$efb6288a30e93a3a = (action$)=>action$.ofType((0, $jBKKK.REORDER_REQUEST_TYPE)).mergeMap(({ payload: { portalId: portalId, projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex, requestTypes: requestTypes, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const body = $d08a34c0644049bc$var$getReorderPayload({
            requestTypes: requestTypes,
            fromIndex: fromIndex,
            toIndex: toIndex,
            projectId: projectId,
            requestGroupId: requestGroupId
        });
        return (0, $lnYeg.requestTypeReorder)({
            requestTypeId: requestTypeId,
            projectId: projectId,
            requestGroupId: requestGroupId,
            body: body
        }).map(()=>{
            analyticsEvent && (0, $aIVqJ.legacySendEvent)(analyticsEvent);
            return (0, $hijaX.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $irHmR.clearRequestTypesOrderAction)());
        });
    });
// The POST endpoint for reordering request types expects the body payload of POST request to look like:
// { position: 'First' } - when dragging a request type to the top of the list
// and { after: [url + requestTypeId] } - where requestTypeId is the id of the request type which the dragged req type will be under.
function $d08a34c0644049bc$var$getReorderPayload({ requestTypes: requestTypes, projectId: projectId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex }) {
    if (toIndex === 0) return {
        position: 'First'
    };
    let requestTypeAfter;
    if (toIndex < fromIndex) // if we're dragging UP the list we want it to set 'after' to the item above
    requestTypeAfter = requestTypes[toIndex - 1];
    else requestTypeAfter = requestTypes[toIndex];
    return {
        after: `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeAfter.id}`
    };
}

});
parcelRegister("hVkR1", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => (parcelRequire("jBKKK")).REORDER_REQUEST_TYPE);
$parcel$export(module.exports, "reorderRequestTypeAction", () => (parcelRequire("jBKKK")).reorderRequestTypeAction);
parcelRequire("jBKKK");

});
parcelRegister("jBKKK", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => $0ff214bf26864f8c$export$46dd7d5218860986);
$parcel$export(module.exports, "reorderRequestTypeAction", () => $0ff214bf26864f8c$export$f0a9fcf0696aeebb);
const $0ff214bf26864f8c$export$46dd7d5218860986 = 'epic.request-types.REORDER_REQUEST_TYPE';
const $0ff214bf26864f8c$export$f0a9fcf0696aeebb = (payload)=>({
        payload: payload,
        type: $0ff214bf26864f8c$export$46dd7d5218860986
    });

});



parcelRegister("c23cN", function(module, exports) {
$parcel$export(module.exports, "setRequestTypeGroupsEpic", () => $0f2f9de7462328c8$export$da9fdc969ff1b05d);

var $jFk35 = parcelRequire("jFk35");

var $1Up2V = parcelRequire("1Up2V");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("klmhp");
var $lArI5 = parcelRequire("lArI5");

var $fASm6 = parcelRequire("fASm6");

var $aIVqJ = parcelRequire("aIVqJ");
const $0f2f9de7462328c8$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $0f2f9de7462328c8$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $0f2f9de7462328c8$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $0f2f9de7462328c8$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $0f2f9de7462328c8$var$getSanitizedText(requestType.descriptionHtml),
        groups: requestGroups
    });
const $0f2f9de7462328c8$export$da9fdc969ff1b05d = (action$)=>{
    return action$.ofType((0, $lArI5.SET_REQUEST_TYPE_GROUPS)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroups: requestGroups, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        return (0, $1Up2V.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: updatedRequestTypeGroupId,
            requestGroupId: 'hidden',
            requestType: $0f2f9de7462328c8$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroups)
        }).map(()=>{
            if (analyticsEvent) (0, $aIVqJ.legacySendEvent)(analyticsEvent);
            return (0, $hijaX.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $aIVqJ.legacySendEvent)(analyticsFailureEvent);
            return (0, $jFk35.Observable).of((0, $lArI5.setRequestTypeGroupsFailedAction)((0, $fASm6.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});

parcelRegister("70sQ9", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmailEpic", () => $849e3d909c542b6a$export$a8c26f01f6ef2d73);

var $jFk35 = parcelRequire("jFk35");

var $iXife = parcelRequire("iXife");
parcelRequire("9zH7Q");
var $gEJnZ = parcelRequire("gEJnZ");
const $849e3d909c542b6a$export$a8c26f01f6ef2d73 = (action$)=>{
    return action$.ofType((0, $gEJnZ.FETCH_RESEND_VERIFY_EMAIL)).mergeMap((action)=>{
        const { emailAddress: emailAddress, portalId: portalId } = action.payload.params;
        const errorResponse = {
            status: 503
        };
        return (0, $iXife.resendVerifyEmail)(emailAddress, portalId).map((response)=>{
            if (response.status === 204) return (0, $gEJnZ.fetchResendVerificationSuccess)();
            return (0, $gEJnZ.fetchResendVerificationFailure)(errorResponse);
        }).catch((error)=>(0, $jFk35.Observable).of((0, $gEJnZ.fetchResendVerificationFailure)(error)));
    });
};

});
parcelRegister("iXife", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmail", () => $e71cecb7223a1fd0$export$da8af7e7b05b444);

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $e71cecb7223a1fd0$var$getResendVerifyEmailRequestBody = (email, portalId)=>({
        email: email,
        verificationContext: {
            portalId: portalId
        }
    });
const $e71cecb7223a1fd0$export$da8af7e7b05b444 = (email, portalId)=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/pages/user/resend-verification-email`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const body = $e71cecb7223a1fd0$var$getResendVerifyEmailRequestBody(email, portalId);
    return (0, $bTjsX.post)(uri, body, headers);
};

});

parcelRegister("9zH7Q", function(module, exports) {
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => (parcelRequire("gEJnZ")).fetchResendVerifyEmailAction);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => (parcelRequire("gEJnZ")).fetchResendVerificationFailure);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => (parcelRequire("gEJnZ")).fetchResendVerificationSuccess);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => (parcelRequire("gEJnZ")).FETCH_RESEND_VERIFICATION_FAILURE);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => (parcelRequire("gEJnZ")).FETCH_RESEND_VERIFICATION_SUCCESS);
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => (parcelRequire("gEJnZ")).FETCH_RESEND_VERIFY_EMAIL);

var $gEJnZ = parcelRequire("gEJnZ");

});
parcelRegister("gEJnZ", function(module, exports) {
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => $cd5a80ac43d21a5c$export$c41322ca6fdfdd1f);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => $cd5a80ac43d21a5c$export$5d8d6d17a7bb9f46);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => $cd5a80ac43d21a5c$export$7517f0d1f77dd091);
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => $cd5a80ac43d21a5c$export$33f84eb26dff7a8d);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => $cd5a80ac43d21a5c$export$548d04925c9d810e);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => $cd5a80ac43d21a5c$export$ccba2c058636a09f);
const $cd5a80ac43d21a5c$export$c41322ca6fdfdd1f = 'epic.verify-email.FETCH_RESEND_VERIFY_EMAIL';
const $cd5a80ac43d21a5c$export$5d8d6d17a7bb9f46 = 'state.ui.resendVerifyEmail.FAILED';
const $cd5a80ac43d21a5c$export$7517f0d1f77dd091 = 'state.ui.resendVerifyEmail.SUCCEEDED';
const $cd5a80ac43d21a5c$export$33f84eb26dff7a8d = ({ emailAddress: emailAddress, portalId: portalId })=>{
    return {
        type: $cd5a80ac43d21a5c$export$c41322ca6fdfdd1f,
        payload: {
            params: {
                emailAddress: emailAddress,
                portalId: portalId
            }
        }
    };
};
const $cd5a80ac43d21a5c$export$548d04925c9d810e = ()=>({
        type: $cd5a80ac43d21a5c$export$7517f0d1f77dd091
    });
const $cd5a80ac43d21a5c$export$ccba2c058636a09f = (error)=>({
        type: $cd5a80ac43d21a5c$export$5d8d6d17a7bb9f46,
        payload: {
            error: error
        }
    });

});



parcelRegister("fRUO0", function(module, exports) {
$parcel$export(module.exports, "resetPasswordEpic", () => $b2630cc9174b2058$export$eb399c940b1a806e);

var $jFk35 = parcelRequire("jFk35");

var $eaz7S = parcelRequire("eaz7S");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("5Hg3e");
var $k7T2u = parcelRequire("k7T2u");

var $fASm6 = parcelRequire("fASm6");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");
const $b2630cc9174b2058$export$eb399c940b1a806e = (action$)=>{
    return action$.ofType((0, $k7T2u.RESET_PASSWORD)).mergeMap((resetPasswordAction)=>{
        const { emailAddress: emailAddress, password: password, token: token, resetPasswordJwt: resetPasswordJwt, createAnalyticsEvent: createAnalyticsEvent, redirectUrl: redirectUrl } = resetPasswordAction.payload;
        return (0, $eaz7S.resetPassword)({
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt
        }).map(()=>{
            return (0, $6oW6S.loginAttempt)({
                password: password,
                email: emailAddress,
                continueParam: redirectUrl ?? null
            });
        }).catch((error)=>{
            if (createAnalyticsEvent && error.status === 400) {
                const event = createAnalyticsEvent({
                    analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                    actionSubject: 'submitNewPassword',
                    action: 'failed'
                });
                (0, $aIVqJ.legacySendEvent)(event);
            }
            return (0, $jFk35.Observable).of((0, $k7T2u.resetPasswordFailure)((0, $fASm6.getDefaultError)(error)));
        });
    });
};

});
parcelRegister("eaz7S", function(module, exports) {
$parcel$export(module.exports, "resetPassword", () => $20fac0e13aa36db7$export$dc726c8e334dd814);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");
const $20fac0e13aa36db7$export$dc726c8e334dd814 = (params)=>{
    const { emailAddress: emailAddress, password: password, resetPasswordJwt: resetPasswordJwt, token: token, context: context = (0, $diqlM.contextPath) } = params;
    const uri = resetPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/user/resetpassword?jwt=${resetPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/user/resetpassword`;
    const body = {
        emailAddress: emailAddress,
        password: password,
        ...token.length > 0 ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $jFk35.Observable).throw(e));
};

});

parcelRegister("5Hg3e", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => (parcelRequire("k7T2u")).RESET_PASSWORD);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => (parcelRequire("k7T2u")).RESET_PASSWORD_FAILURE);
$parcel$export(module.exports, "resetPassword", () => (parcelRequire("k7T2u")).resetPassword);
$parcel$export(module.exports, "resetPasswordFailure", () => (parcelRequire("k7T2u")).resetPasswordFailure);

var $k7T2u = parcelRequire("k7T2u");

});
parcelRegister("k7T2u", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => $c0eed0d8fdc4073f$export$bf768f070251ce56);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => $c0eed0d8fdc4073f$export$682377d29726ee75);
$parcel$export(module.exports, "resetPassword", () => $c0eed0d8fdc4073f$export$dc726c8e334dd814);
$parcel$export(module.exports, "resetPasswordFailure", () => $c0eed0d8fdc4073f$export$70c45c9f946d241a);
const $c0eed0d8fdc4073f$export$bf768f070251ce56 = 'state.persisted.RESET_PASSWORD';
const $c0eed0d8fdc4073f$export$682377d29726ee75 = 'state.persisted.RESET_PASSWORD_FAILURE';
const $c0eed0d8fdc4073f$export$dc726c8e334dd814 = (emailAddress, password, token, resetPasswordJwt, createAnalyticsEvent, redirectUrl)=>({
        payload: {
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt,
            createAnalyticsEvent: createAnalyticsEvent,
            redirectUrl: redirectUrl
        },
        type: $c0eed0d8fdc4073f$export$bf768f070251ce56
    });
const $c0eed0d8fdc4073f$export$70c45c9f946d241a = (error)=>({
        payload: {
            error: error
        },
        type: $c0eed0d8fdc4073f$export$682377d29726ee75
    });

});



parcelRegister("7FKRy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7a5c5937d850d08$export$2e2bcd8739ae039);
parcelRequire("e19ob");
var $eSm63 = parcelRequire("eSm63");

var $ahIKu = parcelRequire("ahIKu");

var $dZzy8 = parcelRequire("dZzy8");

var $1QNQC = parcelRequire("1QNQC");
var $c7a5c5937d850d08$export$2e2bcd8739ae039 = (0, $eSm63.combineEpics)((0, $dZzy8.default), (0, $ahIKu.default), (0, $1QNQC.searchEpic), (0, $1QNQC.fetchSearchResultsEpic), (0, $1QNQC.fetchKbSearchResultsEpic));

});
parcelRegister("ahIKu", function(module, exports) {
$parcel$export(module.exports, "context", () => $79a0c3feb08dfb01$export$a078c61943f9dbbe);
$parcel$export(module.exports, "default", () => $79a0c3feb08dfb01$export$2e2bcd8739ae039);

var $jFk35 = parcelRequire("jFk35");
parcelRequire("bAzYZ");
var $hncVy = parcelRequire("hncVy");

var $diqlM = parcelRequire("diqlM");

var $6rayQ = parcelRequire("6rayQ");
const $79a0c3feb08dfb01$export$a078c61943f9dbbe = 'from-location';
const $79a0c3feb08dfb01$var$epic = (_, store)=>{
    return (0, $diqlM.historyObservable).mergeMap(({ action: action })=>{
        const queryParams = $6rayQ.getAll();
        const hasQueryParams = queryParams && queryParams.hasOwnProperty && queryParams.hasOwnProperty('q');
        if (action === 'POP') {
            if (hasQueryParams) return (0, $jFk35.Observable).of($hncVy.search(queryParams.q, {
                context: $79a0c3feb08dfb01$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (action === 'PUSH') {
            if (hasQueryParams) return (0, $jFk35.Observable).of($hncVy.updateSearch(queryParams.q, {
                context: $79a0c3feb08dfb01$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (!hasQueryParams) {
            const state = store.getState();
            if (state.ui.search.shown) return (0, $jFk35.Observable).of($hncVy.showSearch(false, {
                context: $79a0c3feb08dfb01$export$a078c61943f9dbbe
            }));
            return (0, $jFk35.Observable).empty();
        }
        return (0, $jFk35.Observable).empty();
    });
};
var $79a0c3feb08dfb01$export$2e2bcd8739ae039 = $79a0c3feb08dfb01$var$epic;

});
parcelRegister("bAzYZ", function(module, exports) {
$parcel$export(module.exports, "SEARCH", () => (parcelRequire("hncVy")).SEARCH);
$parcel$export(module.exports, "search", () => (parcelRequire("hncVy")).search);
$parcel$export(module.exports, "resetSearch", () => (parcelRequire("hncVy")).resetSearch);
$parcel$export(module.exports, "RESET_SEARCH", () => (parcelRequire("hncVy")).RESET_SEARCH);
$parcel$export(module.exports, "SHOW_SEARCH", () => (parcelRequire("hncVy")).SHOW_SEARCH);
$parcel$export(module.exports, "showSearch", () => (parcelRequire("hncVy")).showSearch);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => (parcelRequire("hncVy")).CLEAR_SEARCH_RESULTS);
$parcel$export(module.exports, "clearSearchResults", () => (parcelRequire("hncVy")).clearSearchResults);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => (parcelRequire("hncVy")).FETCH_SEARCH_RESULTS);
$parcel$export(module.exports, "fetchSearchResultsAction", () => (parcelRequire("hncVy")).fetchSearchResultsAction);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => (parcelRequire("hncVy")).FETCH_KB_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => (parcelRequire("hncVy")).UPDATE_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => (parcelRequire("hncVy")).UPDATE_SEARCH_RESULTS_BY_TYPE);
$parcel$export(module.exports, "updateSearchResultsByType", () => (parcelRequire("hncVy")).updateSearchResultsByType);
$parcel$export(module.exports, "UPDATE_SEARCH", () => (parcelRequire("hncVy")).UPDATE_SEARCH);
$parcel$export(module.exports, "updateSearch", () => (parcelRequire("hncVy")).updateSearch);

var $hncVy = parcelRequire("hncVy");

});
parcelRegister("hncVy", function(module, exports) {
$parcel$export(module.exports, "SHOW_SEARCH", () => $28cd56a658cd84a3$export$c3d32479efe3cefd);
$parcel$export(module.exports, "SEARCH", () => $28cd56a658cd84a3$export$a6b9aaee40d49fd0);
$parcel$export(module.exports, "RESET_SEARCH", () => $28cd56a658cd84a3$export$1357260dfbbdd047);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => $28cd56a658cd84a3$export$51c1b519f9597fb6);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => $28cd56a658cd84a3$export$ada24bdba9b1de5);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => $28cd56a658cd84a3$export$41015fa2c6363474);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => $28cd56a658cd84a3$export$83fbaab84674965e);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => $28cd56a658cd84a3$export$e8fd6ac9f3290dd1);
$parcel$export(module.exports, "UPDATE_SEARCH", () => $28cd56a658cd84a3$export$e88baa2479d0f7d);
$parcel$export(module.exports, "fetchSearchResultsAction", () => $28cd56a658cd84a3$export$e6c9557a57e930cb);
$parcel$export(module.exports, "showSearch", () => $28cd56a658cd84a3$export$6a74a1717b2c4c0);
$parcel$export(module.exports, "resetSearch", () => $28cd56a658cd84a3$export$f4d94e8b97ed073f);
$parcel$export(module.exports, "search", () => $28cd56a658cd84a3$export$d76128d007d19019);
$parcel$export(module.exports, "updateSearchResultsByType", () => $28cd56a658cd84a3$export$d929024984f1b2ad);
$parcel$export(module.exports, "clearSearchResults", () => $28cd56a658cd84a3$export$20893a65977b35d3);
$parcel$export(module.exports, "updateSearch", () => $28cd56a658cd84a3$export$b14c90fc27f0b629);
const $28cd56a658cd84a3$export$c3d32479efe3cefd = 'ui.search.SHOW_SEARCH';
const $28cd56a658cd84a3$export$a6b9aaee40d49fd0 = 'ui.search.SEARCH';
const $28cd56a658cd84a3$export$1357260dfbbdd047 = 'ui.search.RESET_SEARCH';
const $28cd56a658cd84a3$export$51c1b519f9597fb6 = 'epic.search.FETCH_KB_SEARCH_RESULTS';
const $28cd56a658cd84a3$export$ada24bdba9b1de5 = 'epic.search.FETCH_SEARCH_RESULTS';
const $28cd56a658cd84a3$export$41015fa2c6363474 = 'ui.search.UPDATE_SEARCH_RESULTS';
const $28cd56a658cd84a3$export$83fbaab84674965e = 'ui.search.UPDATE_SEARCH_RESULTS_BY_TYPE';
const $28cd56a658cd84a3$export$e8fd6ac9f3290dd1 = 'ui.search.CLEAR_SEARCH_RESULTS';
const $28cd56a658cd84a3$export$e88baa2479d0f7d = 'ui.search.UPDATE_SEARCH';
const $28cd56a658cd84a3$export$e6c9557a57e930cb = (term, searchStartTime, meta)=>({
        payload: {
            term: term,
            searchStartTime: searchStartTime,
            meta: meta
        },
        type: $28cd56a658cd84a3$export$ada24bdba9b1de5
    });
const $28cd56a658cd84a3$export$6a74a1717b2c4c0 = (show, options = {})=>({
        payload: {
            show: show,
            ...options
        },
        type: $28cd56a658cd84a3$export$c3d32479efe3cefd
    });
const $28cd56a658cd84a3$export$f4d94e8b97ed073f = ()=>({
        type: $28cd56a658cd84a3$export$1357260dfbbdd047
    });
const $28cd56a658cd84a3$export$d76128d007d19019 = (term, { time: time = Date.now(), show: show = true, ...options } = {}, meta)=>({
        type: $28cd56a658cd84a3$export$a6b9aaee40d49fd0,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options,
            meta: meta
        }
    });
const $28cd56a658cd84a3$export$1ef413033527da6d = ({ term: term, limit: limit, expandPortal: expandPortal, meta: meta, categoryIds: categoryIds, portalIds: portalIds })=>{
    return {
        type: $28cd56a658cd84a3$export$51c1b519f9597fb6,
        payload: {
            term: term,
            limit: limit,
            expandPortal: expandPortal,
            categoryIds: categoryIds,
            portalIds: portalIds,
            meta: meta
        }
    };
};
//export type SearchType = 'portals' | 'requestTypes' | 'kbs';
const $28cd56a658cd84a3$var$searchTypes = [
    'portals',
    'requestTypes',
    'kbs'
];
const $28cd56a658cd84a3$export$d929024984f1b2ad = (searchResult, searchType)=>({
        searchType: searchType,
        type: $28cd56a658cd84a3$export$83fbaab84674965e,
        payload: searchResult
    });
const $28cd56a658cd84a3$export$20893a65977b35d3 = ()=>({
        type: $28cd56a658cd84a3$export$e8fd6ac9f3290dd1
    });
const $28cd56a658cd84a3$export$b14c90fc27f0b629 = (term, { time: time = Date.now(), show: show = true, ...options } = {})=>({
        type: $28cd56a658cd84a3$export$e88baa2479d0f7d,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options
        }
    });

});



parcelRegister("dZzy8", function(module, exports) {
$parcel$export(module.exports, "default", () => $42b6631ae5b2ebb7$export$2e2bcd8739ae039);
parcelRequire("bAzYZ");
var $hncVy = parcelRequire("hncVy");

var $6rayQ = parcelRequire("6rayQ");

var $ahIKu = parcelRequire("ahIKu");
const $42b6631ae5b2ebb7$var$isValidSearchAction = (action)=>(action.type === (0, $hncVy.SHOW_SEARCH) || action.type === (0, $hncVy.SEARCH) || action.type === (0, $hncVy.UPDATE_SEARCH)) && action.payload.context !== (0, $ahIKu.context);
const $42b6631ae5b2ebb7$var$setSearchQueryParams = (term, replaceRoute = false)=>{
    $6rayQ.set({
        q: term
    }, replaceRoute);
};
const $42b6631ae5b2ebb7$var$epic = (action$, store)=>{
    return action$.filter($42b6631ae5b2ebb7$var$isValidSearchAction).do((action)=>{
        if ((action.type === (0, $hncVy.SEARCH) || action.type === (0, $hncVy.UPDATE_SEARCH)) && action.payload.show) {
            const shouldReplaceRoute = $6rayQ.get('q') !== undefined;
            $42b6631ae5b2ebb7$var$setSearchQueryParams(action.payload.term, shouldReplaceRoute);
            return;
        }
        if (action.type === (0, $hncVy.SHOW_SEARCH)) {
            if (action.payload.show) {
                const state = store.getState();
                if (state.ui.search.term) {
                    $42b6631ae5b2ebb7$var$setSearchQueryParams(state.ui.search.term);
                    return;
                }
                $42b6631ae5b2ebb7$var$setSearchQueryParams('');
                return;
            }
            $42b6631ae5b2ebb7$var$setSearchQueryParams(undefined);
        }
    }).ignoreElements();
};
var $42b6631ae5b2ebb7$export$2e2bcd8739ae039 = $42b6631ae5b2ebb7$var$epic;

});

parcelRegister("1QNQC", function(module, exports) {
$parcel$export(module.exports, "searchEpic", () => $077d2be557350e6d$export$54e39fbf71be6145);
$parcel$export(module.exports, "fetchSearchResultsEpic", () => $077d2be557350e6d$export$afbb5f5d68ce3b2b);
$parcel$export(module.exports, "fetchKbSearchResultsEpic", () => $077d2be557350e6d$export$afb8d00d671f0126);
/**
 * Epic for performing the search request
 */ 
var $9mazR = parcelRequire("9mazR");

var $jFk35 = parcelRequire("jFk35");
parcelRequire("bAzYZ");
var $hncVy = parcelRequire("hncVy");

var $3i7om = parcelRequire("3i7om");
const $077d2be557350e6d$var$SEARCH_PROVIDERS = [
    (0, $3i7om.KbSearchProvider),
    (0, $3i7om.RequestTypeSearchProvider),
    (0, $3i7om.PortalSearchProvider)
];
const $077d2be557350e6d$export$54e39fbf71be6145 = (action$)=>{
    return action$.ofType((0, $hncVy.SEARCH)).map((action)=>{
        const { meta: meta, term: query } = action.payload;
        if (!query || query.trim() === '') return (0, $hncVy.clearSearchResults)();
        return (0, $hncVy.fetchSearchResultsAction)(query, performance.now(), meta);
    });
};
const $077d2be557350e6d$export$afbb5f5d68ce3b2b = (action$, store)=>{
    return action$.ofType((0, $hncVy.FETCH_SEARCH_RESULTS)).debounceTime((0, $9mazR.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        // This cast is necessary otherwise TS doesn't know that this action can only be a FetchSearchResultsAction
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta } = action.payload;
        const observablesToWaitFor = $077d2be557350e6d$var$SEARCH_PROVIDERS.map((provider)=>provider.execute(term, state, meta));
        return (0, $jFk35.Observable).from(observablesToWaitFor).mergeMap((observable)=>{
            return observable.map((response)=>(0, $hncVy.updateSearchResultsByType)(response, Object.keys(response)[0]));
        });
    }).takeUntil(action$.ofType((0, $hncVy.CLEAR_SEARCH_RESULTS))).repeat();
};
const $077d2be557350e6d$export$afb8d00d671f0126 = (action$, store)=>{
    return action$.ofType((0, $hncVy.FETCH_KB_SEARCH_RESULTS)).debounceTime((0, $9mazR.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta, limit: limit, expandPortal: expandPortal, categoryIds: categoryIds, portalIds: portalIds } = action.payload;
        return (0, $3i7om.KbSearchProvider).execute(term, state, meta, limit, expandPortal, categoryIds, portalIds).map((response)=>(0, $hncVy.updateSearchResultsByType)(response, Object.keys(response)[0]));
    }).takeUntil(action$.ofType((0, $hncVy.CLEAR_SEARCH_RESULTS))).repeat();
};

});
parcelRegister("3i7om", function(module, exports) {
$parcel$export(module.exports, "KbSearchProvider", () => $e1285a6ca30f8056$export$96508bc27743153d);
$parcel$export(module.exports, "RequestTypeSearchProvider", () => $e1285a6ca30f8056$export$836cf63ac20b672f);
$parcel$export(module.exports, "PortalSearchProvider", () => $e1285a6ca30f8056$export$c437cd06ecaa9215);

var $jFk35 = parcelRequire("jFk35");

var $5w7ep = parcelRequire("5w7ep");
var $fmac8 = parcelRequire("fmac8");
var $krrAB = parcelRequire("krrAB");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $aIVqJ = parcelRequire("aIVqJ");

var $17nJI = parcelRequire("17nJI");
const $e1285a6ca30f8056$export$1e7a22c99c64fffc = 30;
const $e1285a6ca30f8056$export$96508bc27743153d = {
    execute: (query, state, meta, resultLimit, expandPortal, categoryIds, portalIds)=>{
        const DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL = 8;
        return $e1285a6ca30f8056$var$searchKbSuppressError(query.trim(), state, resultLimit || DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL, meta, expandPortal, categoryIds, portalIds);
    }
};
const $e1285a6ca30f8056$var$searchKbSuppressError = (query, state, resultLimit, meta, expandPortal, categoryIds, portalIds)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    const projectId = (0, $9D9SX.getProjectId)(state, portalId);
    if (portalId) {
        // If the portal model is available and the kb is disabled then we will not make the kb search request.
        // i.e. if there is no portal model we will still make a kb request regardless
        if ((0, $9D9SX.getIsPortalLoaded)(state, portalId) && !(0, $9D9SX.getIsKbEnabled)(state, portalId)) return (0, $jFk35.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    } else if ((0, $ePyx3.getIsLoaded)(state) && !(0, $ePyx3.getIsKbEnabled)(state)) // We will only NOT make a KB search request if the help center is loaded and kb is disabled
    return (0, $jFk35.Observable).of({
        kbs: {
            articles: [],
            totalSize: 0
        }
    });
    const kbsQuery = {
        categoryIds: categoryIds,
        portalIds: portalIds,
        query: query,
        projectId: projectId,
        resultLimit: resultLimit,
        expandPortalName: expandPortal
    };
    return (0, $5w7ep.searchKbs)(kbsQuery).map((response)=>{
        var _meta$analyticsSucces;
        if (meta !== null && meta !== void 0 && (_meta$analyticsSucces = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces !== void 0 && _meta$analyticsSucces.kb) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent.kb);
        return {
            kbs: response
        };
    }).catch((error)=>{
        var _meta$analyticsFailur;
        if (meta !== null && meta !== void 0 && (_meta$analyticsFailur = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur !== void 0 && _meta$analyticsFailur.kb && !(0, $17nJI.isNetworkOrClientErrorCode)(error.status)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent.kb);
        return (0, $jFk35.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    });
};
const $e1285a6ca30f8056$export$836cf63ac20b672f = {
    execute: (query, state, meta)=>{
        var _performance;
        const DEFAULT_MAX_RT_RESULTS = 5;
        const requestTypeQuery = {
            query: query,
            resultLimit: DEFAULT_MAX_RT_RESULTS,
            includeRequestTypesFromOtherPortals: true,
            serviceDeskId: (0, $dFKzv.getPortalId)(state)
        };
        const start = (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.now();
        return (0, $krrAB.searchRequestTypes)(requestTypeQuery).map((response)=>{
            var _meta$analyticsSucces2;
            const uiAnalyticsEvent = meta === null || meta === void 0 || (_meta$analyticsSucces2 = meta.analyticsSuccessEvent) === null || _meta$analyticsSucces2 === void 0 ? void 0 : _meta$analyticsSucces2.requestType;
            uiAnalyticsEvent === null || uiAnalyticsEvent === void 0 || uiAnalyticsEvent.update((payload)=>{
                var _performance2;
                return {
                    ...payload,
                    timeTaken: ((_performance2 = performance) === null || _performance2 === void 0 ? void 0 : _performance2.now()) - start
                };
            });
            if (uiAnalyticsEvent) (0, $aIVqJ.legacySendEvent)(uiAnalyticsEvent);
            return {
                requestTypes: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur2;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur2 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur2 !== void 0 && _meta$analyticsFailur2.requestType && !(0, $17nJI.isNetworkOrClientErrorCode)(error.status)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent.requestType);
            return (0, $jFk35.Observable).of({
                requestTypes: []
            });
        });
    }
};
const $e1285a6ca30f8056$export$c437cd06ecaa9215 = {
    execute: (query, state, meta)=>{
        const DEFAULT_MAX_PORTAL_RESULTS = 3;
        const portalQuery = {
            query: query,
            limit: DEFAULT_MAX_PORTAL_RESULTS,
            excludedPortalId: (0, $dFKzv.getPortalId)(state)
        };
        return (0, $fmac8.searchPortals)(portalQuery).map((response)=>{
            var _meta$analyticsSucces3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsSucces3 = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces3 !== void 0 && _meta$analyticsSucces3.portal) (0, $aIVqJ.legacySendEvent)(meta.analyticsSuccessEvent.portal);
            return {
                portals: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur3 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur3 !== void 0 && _meta$analyticsFailur3.portal && !(0, $17nJI.isNetworkOrClientErrorCode)(error.status)) (0, $aIVqJ.legacySendEvent)(meta.analyticsFailureEvent.portal);
            return (0, $jFk35.Observable).of({
                portals: []
            });
        });
    }
};

});
parcelRegister("5w7ep", function(module, exports) {
$parcel$export(module.exports, "searchKbs", () => $09ec8c8fd697f539$export$14f2b1f126d32b28);

var $bTjsX = parcelRequire("bTjsX");

var $6LH8a = parcelRequire("6LH8a");

var $6dipk = parcelRequire("6dipk");

var $f60co = parcelRequire("f60co");
const $09ec8c8fd697f539$export$14f2b1f126d32b28 = (kbsQuery)=>{
    const { projectId: projectId, query: query, resultLimit: resultLimit, expandPortalName: expandPortalName, categoryIds: categoryIds, portalIds: portalIds, labels: labels, requestTypeId: requestTypeId } = kbsQuery;
    const queryParams = {
        labels: labels,
        portalIds: portalIds,
        categoryIds: categoryIds,
        searchQuery: query,
        limit: resultLimit,
        expand: expandPortalName ? 'portal' : undefined
    };
    const queryString = $6dipk.stringify(queryParams);
    let uri;
    const activationId = (0, $6LH8a.getMeta)('activation-id');
    if (projectId) {
        if (requestTypeId) uri = `${0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
        else uri = `${0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
    } else uri = `${0, $f60co.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/articles?${queryString}`;
    return (0, $bTjsX.get)(uri, {
        'Content-Type': 'application/json'
    }).map((ajaxResponse)=>{
        const result = ajaxResponse.response;
        return {
            ...result,
            articles: result.articles.map((article)=>({
                    id: article.articleId,
                    name: article.articleTitle,
                    articleSnippet: article.articleSnippet,
                    pageVersion: article.articleVersion,
                    score: article.snippetScore,
                    isSmartSnippet: article.isSmartSnippet,
                    linkedPortals: article.linkedPortals,
                    sourceType: article.articleSource,
                    articleUrl: article.articleUrl
                }))
        };
    });
};

});

parcelRegister("fmac8", function(module, exports) {
$parcel$export(module.exports, "searchPortals", () => $7409e49403680316$export$89b85885f9d0f13);

var $bTjsX = parcelRequire("bTjsX");

var $aYMdQ = parcelRequire("aYMdQ");

var $6dipk = parcelRequire("6dipk");

var $diqlM = parcelRequire("diqlM");
const $7409e49403680316$export$89b85885f9d0f13 = (portalsQuery)=>{
    const sanitizedQuery = (0, $aYMdQ.pickBy)(portalsQuery, (prop)=>!(0, $aYMdQ.isNil)(prop));
    const queryString = $6dipk.stringify(sanitizedQuery);
    return (0, $bTjsX.get)(`${(0, $diqlM.contextPath)}/rest/servicedesk/search/1/search/portals?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.portals;
    });
};

});

parcelRegister("krrAB", function(module, exports) {
$parcel$export(module.exports, "searchRequestTypes", () => $545da6254c27f492$export$c3cad6e5e6fca0f1);

var $bTjsX = parcelRequire("bTjsX");

var $aYMdQ = parcelRequire("aYMdQ");

var $6dipk = parcelRequire("6dipk");

var $diqlM = parcelRequire("diqlM");
const $545da6254c27f492$export$c3cad6e5e6fca0f1 = (requestTypesQuery)=>{
    const sanitizedQuery = (0, $aYMdQ.pickBy)(requestTypesQuery, (prop)=>!(0, $aYMdQ.isNil)(prop));
    const queryString = $6dipk.stringify(sanitizedQuery);
    return (0, $bTjsX.get)(`${(0, $diqlM.contextPath)}/rest/servicedesk/search/1/search/request-type?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.requestTypes;
    });
};

});

parcelRegister("grTfP", function(module, exports) {
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("ePyx3")).getLogoUrl);
$parcel$export(module.exports, "getSharedPortalName", () => (parcelRequire("ePyx3")).getSharedPortalName);
$parcel$export(module.exports, "getThemeColor", () => (parcelRequire("ePyx3")).getThemeColor);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("ePyx3")).getIsKbEnabled);
$parcel$export(module.exports, "getIsLoaded", () => (parcelRequire("ePyx3")).getIsLoaded);
$parcel$export(module.exports, "getHelpCenterBanner", () => (parcelRequire("ePyx3")).getHelpCenterBanner);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => (parcelRequire("ePyx3")).getHelpCenterTitleColor);
$parcel$export(module.exports, "getCanCustomize", () => (parcelRequire("ePyx3")).getCanCustomize);
$parcel$export(module.exports, "getHelpCenterState", () => (parcelRequire("ePyx3")).getHelpCenterState);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => (parcelRequire("ePyx3")).getDefaultSiteLanguageTag);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => (parcelRequire("ePyx3")).getHelpCenterStateTranslationPersisted);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => (parcelRequire("ePyx3")).getKbHelpCenterLinkDomainURLs);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => (parcelRequire("ePyx3")).getHelpCenterBrandingLoader);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => (parcelRequire("ePyx3")).getHelpCenterTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => (parcelRequire("ePyx3")).getHelpCenterPersistedTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => (parcelRequire("ePyx3")).getHelpCenterTopBarColor);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => (parcelRequire("ePyx3")).getHelpCenterTopBarTextColor);

var $ePyx3 = parcelRequire("ePyx3");

});
parcelRegister("ePyx3", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterState", () => $d65e4cc1d1b394ff$export$85757b7e55ef3c9f);
$parcel$export(module.exports, "getLogoUrl", () => $d65e4cc1d1b394ff$export$976f80239b15365);
$parcel$export(module.exports, "getSharedPortalName", () => $d65e4cc1d1b394ff$export$bef10d4690ba4a95);
$parcel$export(module.exports, "getThemeColor", () => $d65e4cc1d1b394ff$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getIsLoaded", () => $d65e4cc1d1b394ff$export$c2ab4f36d4c3d60a);
$parcel$export(module.exports, "getIsKbEnabled", () => $d65e4cc1d1b394ff$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => $d65e4cc1d1b394ff$export$16e1b34e36aec9ef);
$parcel$export(module.exports, "getHelpCenterBanner", () => $d65e4cc1d1b394ff$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getCanCustomize", () => $d65e4cc1d1b394ff$export$eb9b5e885139dc39);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => $d65e4cc1d1b394ff$export$4b8ac8e47961f765);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => $d65e4cc1d1b394ff$export$62574aae884b522a);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => $d65e4cc1d1b394ff$export$76facf9cf6c06c3);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => $d65e4cc1d1b394ff$export$8dce832817c5aeef);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => $d65e4cc1d1b394ff$export$734cf776f7b0100e);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => $d65e4cc1d1b394ff$export$eaa9a84fffbc3381);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => $d65e4cc1d1b394ff$export$8b6136ed26edce36);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => $d65e4cc1d1b394ff$export$7a7dbec5ebf74e05);

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
const $d65e4cc1d1b394ff$export$85757b7e55ef3c9f = (state)=>(0, $aYMdQ.mergeWith)({}, state.persisted.helpCenter, state.ui.helpCenterPreview, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    (_, srcValue)=>{
        // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
        // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
const $d65e4cc1d1b394ff$var$getTranslation = (state, language)=>$d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).translations[language];
const $d65e4cc1d1b394ff$export$976f80239b15365 = (state)=>$d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).logoUrl;
const $d65e4cc1d1b394ff$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $7RWiC.getLocale)(state);
    const translation = userLocale && $d65e4cc1d1b394ff$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $d65e4cc1d1b394ff$export$e22c5d06d177c3fa = (state)=>$d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).themeColor;
const $d65e4cc1d1b394ff$export$c2ab4f36d4c3d60a = (state)=>state.persisted.helpCenter.isLoaded;
const $d65e4cc1d1b394ff$export$d56e4bff0fec91ad = (state)=>{
    return !!state.persisted.helpCenter.knowledgeBase;
};
const $d65e4cc1d1b394ff$export$f18b5fbfa1271f69 = (state)=>{
    return state.persisted.helpCenter.rawBrandingResponse;
};
const $d65e4cc1d1b394ff$export$16e1b34e36aec9ef = (state)=>{
    const rawBrandingResponse = $d65e4cc1d1b394ff$export$f18b5fbfa1271f69(state);
    return rawBrandingResponse !== undefined ? rawBrandingResponse.siteDefaultLanguageTag : undefined;
};
const $d65e4cc1d1b394ff$export$3b3c747bea011f3c = (state)=>$d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
const $d65e4cc1d1b394ff$export$eb9b5e885139dc39 = (state)=>$d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
const $d65e4cc1d1b394ff$export$899cf8c7a36d20bc = (state)=>{
    const userLocale = (0, $7RWiC.getLocale)(state);
    const translation = userLocale && $d65e4cc1d1b394ff$var$getTranslation(state, userLocale);
    const helpCenterTitle = translation && translation.helpCenterTitle ? translation.helpCenterTitle : $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).helpCenterTitle;
    return helpCenterTitle;
};
const $d65e4cc1d1b394ff$export$4b8ac8e47961f765 = (state)=>{
    return $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).helpCenterTitleColor;
};
const $d65e4cc1d1b394ff$export$62574aae884b522a = (state)=>{
    return $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).isBrandingLoaded;
};
const $d65e4cc1d1b394ff$export$76facf9cf6c06c3 = (state)=>{
    return $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).hasTopBarBeenSplit;
};
const $d65e4cc1d1b394ff$export$8dce832817c5aeef = (state)=>{
    var _state$persisted$help;
    return (_state$persisted$help = state.persisted.helpCenter) === null || _state$persisted$help === void 0 ? void 0 : _state$persisted$help.hasTopBarBeenSplit;
};
const $d65e4cc1d1b394ff$export$734cf776f7b0100e = (state)=>{
    return $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).topBarColor;
};
const $d65e4cc1d1b394ff$export$eaa9a84fffbc3381 = (state)=>{
    return $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state).topBarTextColor;
};
const $d65e4cc1d1b394ff$export$33a08d7ce0f06d3 = (state)=>{
    const helpCenterState = $d65e4cc1d1b394ff$export$85757b7e55ef3c9f(state);
    const announcementHeader = helpCenterState.announcementHeader ? helpCenterState.announcementHeader : undefined;
    const announcementMessage = helpCenterState.announcementMessage ? helpCenterState.announcementMessage : undefined;
    return {
        announcementHeader: announcementHeader,
        announcementMessage: announcementMessage
    };
};
const $d65e4cc1d1b394ff$export$8b6136ed26edce36 = (state)=>{
    var _state$persisted$help2;
    return ((_state$persisted$help2 = state.persisted.helpCenter) === null || _state$persisted$help2 === void 0 || (_state$persisted$help2 = _state$persisted$help2.knowledgeBase) === null || _state$persisted$help2 === void 0 ? void 0 : _state$persisted$help2.kbLinkDomainURLs) || [];
};
const $d65e4cc1d1b394ff$export$7a7dbec5ebf74e05 = (state)=>{
    return state.persisted.helpCenter.translations ?? {};
};

});





parcelRegister("d12gF", function(module, exports) {
$parcel$export(module.exports, "resendValidationEmailEpic", () => $49dc4d8a26e8fcb4$export$a58a5733508cf172);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $6tjxC = parcelRequire("6tjxC");
parcelRequire("eDtG6");
var $5Eeij = parcelRequire("5Eeij");

var $c7KEy = parcelRequire("c7KEy");
const $49dc4d8a26e8fcb4$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS = 5000;
const $49dc4d8a26e8fcb4$export$a58a5733508cf172 = (action$)=>{
    return action$.ofType((0, $5Eeij.RESEND_VALIDATION_EMAIL)).mergeMap((transitionAction)=>{
        const { email: email, portalId: portalId, redirectUrl: redirectUrl } = transitionAction.payload;
        return (0, $6tjxC.resendValidationEmail)(email, portalId, redirectUrl).flatMap(()=>(0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $5kfOu.showSuccessFlag)((0, $c7KEy.default).emailSentSuccessMessage, {
                emailAddress: email
            })), (0, $jFk35.Observable).of((0, $5Eeij.resendValidationEmailSuccess)()), (0, $jFk35.Observable).of((0, $5Eeij.enableResendValidationEmailLink)()).delay($49dc4d8a26e8fcb4$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS))).catch((error)=>{
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $5Eeij.resendValidationEmailFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error)), (0, $jFk35.Observable).of((0, $5Eeij.enableResendValidationEmailLink)()));
        });
    });
};

});
parcelRegister("c7KEy", function(module, exports) {
$parcel$export(module.exports, "default", () => $56484b40716ab545$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $56484b40716ab545$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    documentTitle: {
        defaultMessage: 'Verify your email',
        description: 'The text is shown as the browser document title on the email verification page, displayed in the browser tab after the user registers and is prompted to verify their email address.',
        id: 'cv.sign.up.check.email.document.title'
    },
    emailSentSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'The text is shown in a success notification after the user requests a verification email resend. The placeholder {emailAddress} will be substituted with the recipient email address.',
        id: 'cv.sign.up.check.email.resend.success.message'
    },
    checkEmailToFinishSignup: {
        defaultMessage: 'Check your email to set your password',
        description: 'The text is shown as the main heading on the sign-up email verification page, instructing the user to check their inbox to complete the password setup process.',
        id: 'cv.sign.up.check.your.email.to.signup'
    },
    emailSentHint: {
        defaultMessage: "We've sent information on how to set your password to {emailAddress}.",
        description: 'help text to explain that and email has been sent and that the user has to check his inbox',
        id: 'cv.sign.up.check.email.sub.title'
    },
    resendSignupLink: {
        defaultMessage: 'Resend password setup link',
        description: 'The text is shown on a button on the email verification page that allows the user to resend the password setup email if they did not receive it.',
        id: 'cv.sign.up.resend.signup.link.button'
    }
});

});


parcelRegister("lovgD", function(module, exports) {
$parcel$export(module.exports, "updateUserProfileEpic", () => $084a40046fe94b6d$export$776b3daee68de137);
$parcel$export(module.exports, "validateAndSavePasswordChangeEpic", () => $084a40046fe94b6d$export$dbb7ca6f3fcbf9c2);
$parcel$export(module.exports, "validateEpic", () => $084a40046fe94b6d$export$4a45b80683fc2fca);
$parcel$export(module.exports, "changePasswordEpic", () => $084a40046fe94b6d$export$2ab2d1c48dcca790);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $3C1PA = parcelRequire("3C1PA");

var $keYO2 = parcelRequire("keYO2");
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");

var $fASm6 = parcelRequire("fASm6");

var $72rBD = parcelRequire("72rBD");

var $4C8pV = parcelRequire("4C8pV");
const $084a40046fe94b6d$export$776b3daee68de137 = (action$)=>{
    return action$.ofType((0, $7m3Xa.SAVE_USER_PROFILE)).mergeMap((updateUserProfileAction)=>{
        const { displayName: displayName, language: language, timezone: timezone } = updateUserProfileAction.payload;
        const languageKey = language === undefined ? undefined : language.originalKey;
        const timezoneId = timezone === undefined ? undefined : timezone.id;
        return (0, $keYO2.updateUserProfile)(displayName, languageKey, timezoneId).flatMap(()=>(0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $7m3Xa.saveUserProfileSuccess)(displayName, language, timezone)), (0, $jFk35.Observable).of((0, $5kfOu.showSuccessFlag)((0, $4C8pV.default).profileDetailsUpdatedHeaderMessage, undefined, (0, $4C8pV.default).profileDetailsUpdatedBodyMessage)))).catch((error)=>(0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $7m3Xa.saveUserProfileFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.handleAjaxError)(error))));
    });
};
const $084a40046fe94b6d$export$dbb7ca6f3fcbf9c2 = (action$)=>{
    return action$.ofType((0, $7m3Xa.VALIDATE_AND_SAVE_PASSWORD_CHANGE)).mergeMap((validateAndSavePasswordChangeAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validateAndSavePasswordChangeAction.payload;
        const validationErrors = $084a40046fe94b6d$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $7m3Xa.changePassword)(currentPassword, newPassword, confirmPassword);
        return (0, $jFk35.Observable).of(result);
    });
};
const $084a40046fe94b6d$export$4a45b80683fc2fca = (action$)=>{
    return action$.ofType((0, $7m3Xa.VALIDATE_PASSWORD)).mergeMap((validatePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validatePasswordAction.payload;
        const validationErrors = $084a40046fe94b6d$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $7m3Xa.validatePasswordSuccess)();
        return (0, $jFk35.Observable).of(result);
    });
};
const $084a40046fe94b6d$var$validate = (currentPassword, newPassword, confirmPassword)=>{
    const currentPasswordError = !currentPassword.trim() ? (0, $4C8pV.default).currentPasswordMissingError : undefined;
    let newPasswordError = !newPassword.trim() ? (0, $4C8pV.default).newPasswordMissingError : undefined;
    let confirmPasswordError = !confirmPassword.trim() ? (0, $4C8pV.default).confirmPasswordMissingError : undefined;
    if (!newPasswordError && newPassword.length < (0, $72rBD.MIN_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $4C8pV.default).newPasswordTooShortError;
    if (!newPasswordError && newPassword.length > (0, $72rBD.MAX_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $4C8pV.default).newPasswordTooLongError;
    if (!newPasswordError && !confirmPasswordError && confirmPassword !== newPassword) confirmPasswordError = (0, $4C8pV.default).confirmPasswordDoesNotMatchError;
    if (currentPasswordError || newPasswordError || confirmPasswordError) return (0, $7m3Xa.changePasswordFailure)(currentPasswordError, newPasswordError, confirmPasswordError, undefined);
    return undefined;
};
const $084a40046fe94b6d$export$2ab2d1c48dcca790 = (action$)=>{
    return action$.ofType((0, $7m3Xa.CHANGE_PASSWORD)).mergeMap((receivedChangePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = receivedChangePasswordAction.payload;
        return (0, $keYO2.changePassword)(currentPassword, newPassword, confirmPassword).map(()=>{
            return (0, $3C1PA.logOutAction)();
        }).catch((error)=>{
            const jiraError = (0, $fASm6.getJiraErrorResponse)(error);
            if (jiraError) return (0, $jFk35.Observable).of($084a40046fe94b6d$var$getJiraErrorFailure(jiraError, error));
            return (0, $jFk35.Observable).of($084a40046fe94b6d$var$getGenericErrorFailure(error));
        });
    });
};
const $084a40046fe94b6d$var$getJiraErrorFailure = (jiraError, ajaxError)=>{
    const currentError = $084a40046fe94b6d$var$getPasswordError(jiraError, 'current');
    const newError = $084a40046fe94b6d$var$getPasswordError(jiraError, 'password');
    const confirmError = $084a40046fe94b6d$var$getPasswordError(jiraError, 'confirm');
    if (currentError === undefined && newError === undefined && confirmError === undefined) return $084a40046fe94b6d$var$getGenericErrorFailure(ajaxError);
    return (0, $7m3Xa.changePasswordFailure)(currentError, newError, confirmError, undefined);
};
const $084a40046fe94b6d$var$getPasswordError = (error, field)=>{
    return error.errors.filter((e)=>e.field === field).map((e)=>e.errorMessage)[0];
};
const $084a40046fe94b6d$var$getGenericErrorFailure = (error)=>{
    return (0, $7m3Xa.changePasswordFailure)(undefined, undefined, undefined, (0, $fASm6.getDefaultError)(error));
};

});
parcelRegister("72rBD", function(module, exports) {
$parcel$export(module.exports, "MAX_FULL_NAME_LENGTH_IN_CHARS", () => $0c71065116baf98d$export$abf6aa48eca27616);
$parcel$export(module.exports, "MAX_PASSWORD_LENGTH_IN_CHARS", () => $0c71065116baf98d$export$778010a9ee5e9c9b);
$parcel$export(module.exports, "MIN_PASSWORD_LENGTH_IN_CHARS", () => $0c71065116baf98d$export$5dbee9b10a861405);
$parcel$export(module.exports, "validateAll", () => $0c71065116baf98d$export$d1393b0ce6100c11);
$parcel$export(module.exports, "validateFullName", () => $0c71065116baf98d$export$8369f6c309ebe358);
$parcel$export(module.exports, "validatePassword", () => $0c71065116baf98d$export$4d2a7159fda5dc93);

var $1Dca6 = parcelRequire("1Dca6");
const $0c71065116baf98d$export$abf6aa48eca27616 = 255;
const $0c71065116baf98d$export$778010a9ee5e9c9b = 72;
const $0c71065116baf98d$export$5dbee9b10a861405 = 8;
function $0c71065116baf98d$export$d1393b0ce6100c11(fullName, password) {
    const fullNameError = $0c71065116baf98d$export$8369f6c309ebe358(fullName);
    const passwordError = $0c71065116baf98d$export$4d2a7159fda5dc93(password);
    if (fullNameError || passwordError) return {
        fullNameError: fullNameError,
        passwordError: passwordError
    };
    return undefined;
}
function $0c71065116baf98d$export$8369f6c309ebe358(fullName) {
    const trimmedFullName = fullName.trim();
    if (trimmedFullName.length === 0) return (0, $1Dca6.default).fullNameMissingError;
    if (trimmedFullName.length > $0c71065116baf98d$export$abf6aa48eca27616) return (0, $1Dca6.default).fullNameTooLongError;
    return undefined;
}
function $0c71065116baf98d$export$4d2a7159fda5dc93(password) {
    if (password.trim().length === 0) return (0, $1Dca6.default).passwordMissingError;
    if (password.length < $0c71065116baf98d$export$5dbee9b10a861405) return (0, $1Dca6.default).passwordTooShortError;
    if (password.length > $0c71065116baf98d$export$778010a9ee5e9c9b) return (0, $1Dca6.default).passwordTooLongError;
    return undefined;
}

});
parcelRegister("1Dca6", function(module, exports) {
$parcel$export(module.exports, "default", () => $727531bbb3696268$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $727531bbb3696268$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    fullNameMissingError: {
        defaultMessage: 'You must enter a full name',
        description: 'Error message when the full name field is blank',
        id: 'cv.sign.up.full.name.empty.error'
    },
    fullNameTooLongError: {
        defaultMessage: 'Full name must be less than 255 characters',
        description: 'Error message when the full name field value is too long',
        id: 'cv.sign.up.full.name.too.long.error'
    },
    passwordMissingError: {
        defaultMessage: 'You must enter a password',
        description: 'Error message when the password field is blank',
        id: 'cv.sign.up.password.empty.error'
    },
    passwordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.sign.up.password.too.short.error'
    },
    passwordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.sign.up.password.too.long.error.old'
    }
});

});


parcelRegister("4C8pV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b53a6416108eab5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $2b53a6416108eab5$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    currentPasswordMissingError: {
        defaultMessage: 'You must type your current password',
        description: 'error message when the current password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.current.error'
    },
    newPasswordMissingError: {
        defaultMessage: 'You must specify a new password',
        description: 'error message when the new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.new.error'
    },
    newPasswordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.user.profile.change.password.new.too.short.error'
    },
    newPasswordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.user.profile.change.password.too.new.long.error'
    },
    confirmPasswordMissingError: {
        defaultMessage: 'You must re-type the new password',
        description: 'error message when the confirm new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.error'
    },
    confirmPasswordDoesNotMatchError: {
        defaultMessage: 'Passwords do not match',
        description: 'error message when the confirmation password does not match the new password in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.mismatch.error'
    },
    profileDetailsUpdatedHeaderMessage: {
        defaultMessage: 'Profile details updated',
        description: 'message header when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.header'
    },
    profileDetailsUpdatedBodyMessage: {
        defaultMessage: 'Your changes may take up to five minutes to appear.',
        description: 'message body when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.body'
    }
});

});


parcelRegister("cMUG2", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $95bc32902a1b5765$export$cb36b6e8b9a45314);

var $9aoKF = parcelRequire("9aoKF");
var $jFk35 = parcelRequire("jFk35");

var $5kfOu = parcelRequire("5kfOu");

var $epDUQ = parcelRequire("epDUQ");
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");

var $fASm6 = parcelRequire("fASm6");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $bVcFq = parcelRequire("bVcFq");
const $95bc32902a1b5765$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $7m3Xa.USER_PROFILE_FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, createAnalyticsEvent: createAnalyticsEvent } = forgotPasswordAction.payload;
        return (0, $epDUQ.forgotPassword)(resetUrl, email).flatMap(()=>{
            const successEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'sent',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            successEvent && (0, $aIVqJ.legacySendEvent)(successEvent);
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $7m3Xa.forgotPasswordSuccess)()), (0, $jFk35.Observable).of((0, $5kfOu.showSuccessFlag)((0, $bVcFq.default).forgotPasswordSuccessFlagTitle, undefined, (0, $bVcFq.default).forgotPasswordSuccessFlagDescription, undefined, {
                emailAddress: email
            })));
        }).catch((error)=>{
            const failEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            failEvent && (0, $aIVqJ.legacySendEvent)(failEvent);
            const parsedError = (0, $fASm6.getUserProfileForgotPasswordFailedError)(error);
            const errorAction = parsedError.action === undefined ? undefined : [
                parsedError.action
            ];
            return (0, $9aoKF.concat)((0, $jFk35.Observable).of((0, $7m3Xa.forgotPasswordFailure)()), (0, $jFk35.Observable).of((0, $5kfOu.showErrorFlag)(parsedError.title, parsedError.description, errorAction)));
        });
    });
};

});
parcelRegister("bVcFq", function(module, exports) {
$parcel$export(module.exports, "default", () => $74d93fda33fdaeb9$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $74d93fda33fdaeb9$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    forgotPasswordSuccessFlagTitle: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Message title for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.title'
    },
    forgotPasswordSuccessFlagDescription: {
        defaultMessage: "We've sent a reset password link to {emailAddress}.",
        description: 'Message descritpion for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.description'
    }
});

});



parcelRegister("ivlng", function(module, exports) {
$parcel$export(module.exports, "getCombinedPersistedReducer", () => $129dd92b83ed5315$export$1e1389697ca32ad5);
$parcel$export(module.exports, "default", () => $129dd92b83ed5315$export$2e2bcd8739ae039);
parcelRequire("UZaDE");
var $bLO8A = parcelRequire("bLO8A");
parcelRequire("ifoEP");
var $hwMna = parcelRequire("hwMna");
parcelRequire("7uuR6");
var $kyjJ0 = parcelRequire("kyjJ0");
parcelRequire("ed87e");
var $9NrPQ = parcelRequire("9NrPQ");
parcelRequire("8dXyO");
var $j8uuz = parcelRequire("j8uuz");
parcelRequire("lHje4");
var $lRUE4 = parcelRequire("lRUE4");
parcelRequire("aIpge");
var $jMSFD = parcelRequire("jMSFD");
parcelRequire("2PtML");
var $fxrKs = parcelRequire("fxrKs");
parcelRequire("inbGO");
var $2iK1O = parcelRequire("2iK1O");
parcelRequire("a0m8d");
var $V2PDG = parcelRequire("V2PDG");
parcelRequire("2gFPB");
var $b2cpk = parcelRequire("b2cpk");
parcelRequire("hsHQs");
var $4VlGq = parcelRequire("4VlGq");
parcelRequire("byPkC");
var $4fiL9 = parcelRequire("4fiL9");
parcelRequire("1w8mW");
var $kWTPI = parcelRequire("kWTPI");
parcelRequire("aaBug");
var $67qKz = parcelRequire("67qKz");
parcelRequire("xqu6y");
var $F1hMq = parcelRequire("F1hMq");
parcelRequire("jPvc0");
var $edwRG = parcelRequire("edwRG");
parcelRequire("cJyJ4");
var $gwHjP = parcelRequire("gwHjP");
parcelRequire("J5CJJ");
var $lqQHa = parcelRequire("lqQHa");
parcelRequire("fq5i8");
var $jrq8X = parcelRequire("jrq8X");
parcelRequire("cNftW");
var $jrNvH = parcelRequire("jrNvH");
parcelRequire("llGdE");
var $1VIKK = parcelRequire("1VIKK");
parcelRequire("4STZl");
var $497QK = parcelRequire("497QK");
parcelRequire("huFmW");
var $aUmTb = parcelRequire("aUmTb");
parcelRequire("fDFdh");
var $ejEYa = parcelRequire("ejEYa");
parcelRequire("ifzIY");
var $aa2cM = parcelRequire("aa2cM");
parcelRequire("jOkQU");
var $2MQfX = parcelRequire("2MQfX");
parcelRequire("1wPHB");
var $gm7O6 = parcelRequire("gm7O6");
parcelRequire("h366n");
var $6Tf6K = parcelRequire("6Tf6K");
parcelRequire("6OSNu");
var $75OBY = parcelRequire("75OBY");
parcelRequire("7gEH8");
var $bOeP3 = parcelRequire("bOeP3");
parcelRequire("ikZEU");
var $bhXhS = parcelRequire("bhXhS");
parcelRequire("3iwCc");
var $2MJkf = parcelRequire("2MJkf");
parcelRequire("6MEO1");
var $4LSIm = parcelRequire("4LSIm");
parcelRequire("hSY5L");
var $kULOY = parcelRequire("kULOY");
parcelRequire("kLOyD");
var $2Cd5i = parcelRequire("2Cd5i");
const $129dd92b83ed5315$var$reducerCollection = {
    helpCenter: (0, $4VlGq.default),
    portals: (0, $jrq8X.default),
    user: (0, $2MJkf.default),
    env: (0, $2iK1O.default),
    meta: (0, $gwHjP.default),
    organisations: (0, $lqQHa.default),
    requestCreate: (0, $497QK.default),
    requestTypeSuggestion: (0, $2MQfX.default),
    connectFragments: (0, $fxrKs.default),
    kbArticles: (0, $4fiL9.default),
    portalCustomisation: (0, $jrNvH.portalCustomisationReducer),
    unsubscribedConfirmation: (0, $bhXhS.unsubscribedConfirmationReducer),
    login: (0, $F1hMq.loginReducer),
    forgotPassword: (0, $b2cpk.forgotPasswordReducer),
    // Preserve the legacy state contract while accepting Jira's stricter Redux declarations.
    // This reducer can return partial request details during creation; model that state and
    // its consumers separately rather than changing runtime behavior for hoisting (JIV-23832).
    requestDetails: (0, $aUmTb.requestDetailsReducer),
    reqSlas: (0, $aa2cM.reqSlasReducer),
    timezones: (0, $75OBY.timezonesReducer),
    languages: (0, $kWTPI.languagesReducer),
    profileWebFragments: (0, $1VIKK.profileWebFragmentReducer),
    requestList: (0, $ejEYa.requestListReducer),
    approvalList: (0, $j8uuz.approvalListReducer),
    visitPortal: (0, $2Cd5i.visitPortalReducer),
    resetPassword: (0, $gm7O6.resetPasswordReducer),
    completeSignup: (0, $jMSFD.completeSignupReducer),
    verifyEmail: (0, $kULOY.verifyEmailReducer),
    signUp: (0, $6Tf6K.signUpReducer),
    userRequestsCounts: (0, $4LSIm.default),
    anonymousApproval: (0, $9NrPQ.anonymousApprovalReducer),
    featuredAndSortedPortals: (0, $V2PDG.featuredAndSortedPortalsReducer),
    loginAnnouncements: (0, $edwRG.loginAnnouncementsReducer),
    blockedAppsBanner: (0, $hwMna.default),
    aiAnswerFeedbackPage: (0, $kyjJ0.aiAnswerReducer),
    linkedSpaces: (0, $67qKz.default),
    branding: (0, $lRUE4.brandingReducer),
    uiModifications: (0, $bOeP3.uiModificationsReducer)
};
const $129dd92b83ed5315$export$1e1389697ca32ad5 = (asyncReducers)=>(0, $bLO8A.default)({
        ...$129dd92b83ed5315$var$reducerCollection,
        ...asyncReducers
    });
var $129dd92b83ed5315$export$2e2bcd8739ae039 = (0, $bLO8A.default)($129dd92b83ed5315$var$reducerCollection);

});
parcelRegister("ifoEP", function(module, exports) {
$parcel$export(module.exports, "blockedAppsBannerReducer", () => (parcelRequire("hwMna")).default);

var $hwMna = parcelRequire("hwMna");

});
parcelRegister("hwMna", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsBanner", () => $63d55794e94caebd$export$de142fee58ebb9a8);
$parcel$export(module.exports, "mapConnectDispatchToPropsBanner", () => $63d55794e94caebd$export$b08e00302c3c215c);
$parcel$export(module.exports, "default", () => $63d55794e94caebd$export$2e2bcd8739ae039);
const $63d55794e94caebd$export$e872b6f4d4c58319 = 'state.persisted.blockedAppsBanner.SHOW_BANNER';
const $63d55794e94caebd$export$8c1102f190441ac3 = 'state.persisted.blockedAppsBanner.SHOW_CONNECT_BANNER';
const $63d55794e94caebd$export$c23ca0c98b7b93db = 'state.persisted.blockedAppsBanner.RESET_BANNER_STATE';
const $63d55794e94caebd$export$24e8a154ba80b759 = 'state.persisted.blockedAppsBanner.RESET_CONNECT_BANNER_STATE';
const $63d55794e94caebd$export$ad5fb8b7cdde24d7 = 'create_request';
const $63d55794e94caebd$export$1f3af91a079bff22 = 'csm_create_request';
const $63d55794e94caebd$export$e63cec9acfdad935 = 'view_request';
const $63d55794e94caebd$export$ac4d91f5203d82ae = 'portal';
const $63d55794e94caebd$var$defaultState = {
    create_request: false,
    portal: false,
    view_request: false,
    csm_create_request: false,
    connect: {
        create_request: false,
        view_request: false,
        portal: false
    }
};
const $63d55794e94caebd$export$4a89ccf10a725e56 = (page)=>({
        type: $63d55794e94caebd$export$e872b6f4d4c58319,
        payload: {
            page: page
        }
    });
const $63d55794e94caebd$export$cf79152bba576f84 = (page)=>({
        type: $63d55794e94caebd$export$8c1102f190441ac3,
        payload: {
            page: page
        }
    });
const $63d55794e94caebd$export$4d7eca3346df6596 = (page)=>({
        type: $63d55794e94caebd$export$c23ca0c98b7b93db,
        payload: {
            page: page
        }
    });
const $63d55794e94caebd$export$9a8e10487635d611 = (page)=>({
        type: $63d55794e94caebd$export$24e8a154ba80b759,
        payload: {
            page: page
        }
    });
const $63d55794e94caebd$export$e04d0f37424da45e = (connectPageName)=>{
    switch(connectPageName){
        case 'PORTAL':
            return $63d55794e94caebd$export$ac4d91f5203d82ae;
        case 'CREATE_REQUEST':
            return $63d55794e94caebd$export$ad5fb8b7cdde24d7;
        case 'VIEW_REQUEST':
            return $63d55794e94caebd$export$e63cec9acfdad935;
        default:
            return null;
    }
};
const $63d55794e94caebd$export$912af6a6ce89d10c = (forgePageName)=>{
    let screen;
    switch(forgePageName){
        case 'create_request':
            screen = $63d55794e94caebd$export$ad5fb8b7cdde24d7;
            break;
        case 'portal':
            screen = $63d55794e94caebd$export$ac4d91f5203d82ae;
            break;
        case 'view_request':
            screen = $63d55794e94caebd$export$e63cec9acfdad935;
            break;
        case 'csm_create_request':
            screen = $63d55794e94caebd$export$1f3af91a079bff22;
            break;
        default:
            screen = null;
    }
    return screen;
};
const $63d55794e94caebd$export$a1659b54bac3252a = ()=>{
    return {
        ...$63d55794e94caebd$var$defaultState
    };
};
const $63d55794e94caebd$export$de142fee58ebb9a8 = (dispatch)=>{
    return {
        showBanner: (forgePageName)=>{
            return dispatch($63d55794e94caebd$export$4a89ccf10a725e56($63d55794e94caebd$export$912af6a6ce89d10c(forgePageName)));
        },
        resetBannerState: (forgePageName)=>{
            return dispatch($63d55794e94caebd$export$4d7eca3346df6596($63d55794e94caebd$export$912af6a6ce89d10c(forgePageName)));
        }
    };
};
const $63d55794e94caebd$export$b08e00302c3c215c = {
    showBanner: (connectPageName)=>{
        return $63d55794e94caebd$export$cf79152bba576f84($63d55794e94caebd$export$e04d0f37424da45e(connectPageName));
    },
    resetBannerState: (connectPageName)=>{
        return $63d55794e94caebd$export$9a8e10487635d611($63d55794e94caebd$export$e04d0f37424da45e(connectPageName));
    }
};
function $63d55794e94caebd$export$2e2bcd8739ae039(currentState = $63d55794e94caebd$export$a1659b54bac3252a(), action) {
    const newState = {
        ...currentState
    };
    switch(action.type){
        case $63d55794e94caebd$export$e872b6f4d4c58319:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = true;
                return newState;
            }
        case $63d55794e94caebd$export$8c1102f190441ac3:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: true
                };
                return newState;
            }
        case $63d55794e94caebd$export$c23ca0c98b7b93db:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = false;
                return newState;
            }
        case $63d55794e94caebd$export$24e8a154ba80b759:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: false
                };
                return newState;
            }
        default:
            return currentState;
    }
}

});


parcelRegister("7uuR6", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => (parcelRequire("kyjJ0")).aiAnswerReducer);

var $kyjJ0 = parcelRequire("kyjJ0");

});
parcelRegister("kyjJ0", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => $6b014094eea0f755$export$2a26170741a0330c);
parcelRequire("h705Q");
var $bYbKZ = parcelRequire("bYbKZ");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $6b014094eea0f755$var$defaultState = {
    feedback: '',
    issueKey: '',
    projectId: 0,
    initialError: undefined
};
const $6b014094eea0f755$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.aiAnswerFeedbackPage) return initialModelState.aiAnswerFeedbackPage;
    return $6b014094eea0f755$var$defaultState;
};
function $6b014094eea0f755$export$2a26170741a0330c(state = $6b014094eea0f755$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $bYbKZ.FETCH_AI_ANSWER_FEEDBACK_SUCCESS:
            return $6b014094eea0f755$var$handleFetchAiAnswerFeedbackSuccess(state, action);
        case 0, $bYbKZ.FETCH_AI_ANSWER_FEEDBACK_FAILURE:
            return $6b014094eea0f755$var$handleFetchAiAnswerFeedbackFailure(state, action);
        default:
            return state;
    }
}
function $6b014094eea0f755$var$handleFetchAiAnswerFeedbackSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        feedback: response.feedback,
        issueKey: response.issueKey,
        projectId: response.projectId
    };
}
function $6b014094eea0f755$var$handleFetchAiAnswerFeedbackFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("ed87e", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => (parcelRequire("9NrPQ")).anonymousApprovalReducer);

var $9NrPQ = parcelRequire("9NrPQ");

});
parcelRegister("9NrPQ", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => $adcffe071fa3d982$export$12846d9286d41238);

var $bKaMP = parcelRequire("bKaMP");
const $adcffe071fa3d982$var$defaultState = {
    token: '',
    requestDetailsUrl: '',
    loggedIn: false,
    initialError: undefined
};
const $adcffe071fa3d982$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.anonymousApproval) return initialModelState.anonymousApproval;
    return $adcffe071fa3d982$var$defaultState;
};
const $adcffe071fa3d982$export$12846d9286d41238 = (state = $adcffe071fa3d982$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("8dXyO", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => (parcelRequire("j8uuz")).approvalListReducer);

var $j8uuz = parcelRequire("j8uuz");

});
parcelRegister("j8uuz", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => $83aecd8e24b84bd7$export$18397d0445d17954);
parcelRequire("8knRH");
var $kXd9e = parcelRequire("kXd9e");

var $hN5YJ = parcelRequire("hN5YJ");
const $83aecd8e24b84bd7$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    },
    portalsRequestTypes: []
};
const $83aecd8e24b84bd7$var$defaultState = $83aecd8e24b84bd7$var$emptyState;
function $83aecd8e24b84bd7$export$18397d0445d17954(state = $83aecd8e24b84bd7$var$defaultState, action) {
    switch(action.type){
        case 0, $kXd9e.FETCH_APPROVAL_LIST_SUCCESS:
            return $83aecd8e24b84bd7$var$handleFetchApprovalListSuccess(state, action);
        default:
            return state;
    }
}
function $83aecd8e24b84bd7$var$handleFetchApprovalListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.totalResults !== state.totalResults;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requests.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requests : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        approvalFilter: response.approvalFilterValue,
        portalId: response.portalId,
        requestTypeId: response.requestTypeId,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        nextToken: response.nextToken,
        allRows: newRows,
        pages: {
            isInitialPageLoad: false,
            [response.selectedPage]: response.requests
        },
        portalsRequestTypes: response.portalRequestTypes
    };
}
function $83aecd8e24b84bd7$var$handleFetchApprovalListSuccess(state, action) {
    if ((0, $hN5YJ.isApprovalListInfiniteScrollEnabled)()) return $83aecd8e24b84bd7$var$handleFetchApprovalListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) return {
            ...state,
            pages: {
                ...state.pages,
                [response.selectedPage]: response.requests
            }
        };
        return {
            approvalFilter: response.approvalFilterValue,
            portalId: response.portalId,
            requestTypeId: response.requestTypeId,
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requests
            },
            portalsRequestTypes: response.portalRequestTypes
        };
    }
    return state;
}

});


parcelRegister("lHje4", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => (parcelRequire("lRUE4")).brandingReducer);

var $lRUE4 = parcelRequire("lRUE4");

});
parcelRegister("lRUE4", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => $c73b5ea9cc91db1f$export$77a6a980433b33f5);

var $bKaMP = parcelRequire("bKaMP");
const $c73b5ea9cc91db1f$var$defaultState = {
    id: '',
    key: '',
    name: '',
    portalBaseUrl: ''
};
const $c73b5ea9cc91db1f$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.branding) return initialModelState.branding;
    return $c73b5ea9cc91db1f$var$defaultState;
};
const $c73b5ea9cc91db1f$export$77a6a980433b33f5 = (state = $c73b5ea9cc91db1f$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("aIpge", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => (parcelRequire("jMSFD")).completeSignupReducer);

var $jMSFD = parcelRequire("jMSFD");

});
parcelRegister("jMSFD", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => $52cebc49009528c5$export$b5b8ee9188984cd7);
parcelRequire("23jTe");
var $bAYOu = parcelRequire("bAYOu");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $52cebc49009528c5$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: undefined,
    portalId: undefined,
    initialError: undefined
};
const $52cebc49009528c5$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.completeSignup) return initialModelState.completeSignup;
    return $52cebc49009528c5$var$defaultState;
};
function $52cebc49009528c5$export$b5b8ee9188984cd7(state = $52cebc49009528c5$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $bAYOu.FETCH_COMPLETE_SIGNUP_SUCCESS:
            return $52cebc49009528c5$var$handleFetchCompleteSignupSuccess(state, action);
        case 0, $bAYOu.FETCH_COMPLETE_SIGNUP_FAILURE:
            return $52cebc49009528c5$var$handleFetchCompleteSignupFailure(state, action);
        default:
            return state;
    }
}
function $52cebc49009528c5$var$handleFetchCompleteSignupSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        signupToken: response.signupToken,
        emailAddress: response.emailAddress,
        validationOutcome: response.validationOutcome,
        portalId: response.portalId,
        redirectUrl: response.redirectUrl
    };
}
function $52cebc49009528c5$var$handleFetchCompleteSignupFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("2PtML", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsReducer", () => (parcelRequire("fxrKs")).default);
$parcel$export(module.exports, "generateKey", () => (parcelRequire("fxrKs")).generateKey);

var $fxrKs = parcelRequire("fxrKs");

});
parcelRegister("fxrKs", function(module, exports) {
$parcel$export(module.exports, "generateKey", () => $cb1698f3656623b0$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "default", () => $cb1698f3656623b0$export$2e2bcd8739ae039);
parcelRequire("lgOtA");
var $03HuP = parcelRequire("03HuP");

var $bKaMP = parcelRequire("bKaMP");
const $cb1698f3656623b0$export$3a7728e868aa3ebd = (portalPageName, portalId, requestTypeId, requestKey)=>`${portalPageName}_${portalId || 'none'}_${requestTypeId || 'none'}${`_${requestKey || 'none'}`}`;
const $cb1698f3656623b0$export$a1659b54bac3252a = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    const { portal: portal, portalWebFragments: portalWebFragments, reqCreate: reqCreate } = initialModelState;
    const initialState = {
        HELP_CENTER_none_none: {},
        PORTAL_none_none: {},
        CREATE_REQUEST_none_none: {},
        REQUEST_DETAILS_none_none: {},
        PROFILE_none_none: {}
    };
    if (portal && portalWebFragments && reqCreate) {
        const { id: portalId } = portal;
        const { id: requestTypeId } = reqCreate;
        const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = portalWebFragments;
        const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
        return {
            ...initialState,
            [$cb1698f3656623b0$export$3a7728e868aa3ebd('CREATE_REQUEST', Number(portalId), requestTypeId, undefined)]: {
                headerPanels: headerPanels,
                subheaderPanels: subheaderPanels,
                footerPanels: footerPanels,
                propertyPanels: propertyPanels
            }
        };
    }
    return initialState;
};
const $cb1698f3656623b0$export$49d5fc8cba920a0 = $cb1698f3656623b0$export$a1659b54bac3252a();
function $cb1698f3656623b0$export$2e2bcd8739ae039(state = $cb1698f3656623b0$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $03HuP.FETCH_CONNECT_FRAGMENTS_SUCCESS:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey } = action.payload;
                const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = connectFragments;
                const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
                return {
                    ...state,
                    [$cb1698f3656623b0$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        headerPanels: headerPanels,
                        subheaderPanels: subheaderPanels,
                        footerPanels: footerPanels,
                        propertyPanels: propertyPanels
                    }
                };
            }
        case 0, $03HuP.FETCH_CONNECT_FRAGMENTS_FAILURE:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey } = action.payload;
                return {
                    ...state,
                    [$cb1698f3656623b0$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        error: error
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("inbGO", function(module, exports) {
$parcel$export(module.exports, "envReducer", () => (parcelRequire("2iK1O")).default);

var $2iK1O = parcelRequire("2iK1O");

});
parcelRegister("2iK1O", function(module, exports) {
$parcel$export(module.exports, "default", () => $21f3149d07bd6ca1$export$2e2bcd8739ae039);
parcelRequire("kzuYB");
var $5QO1D = parcelRequire("5QO1D");

var $7lN8e = parcelRequire("7lN8e");
const $21f3149d07bd6ca1$var$getStateFromEnvObject = (envObject)=>({
        headless: envObject.headless,
        wacLink: envObject.wacLink,
        xsrfToken: envObject.xsrfToken,
        baseUrl: envObject.baseUrl,
        mediaApiAppClientId: envObject.mediaApiAppClientId,
        mediaApiExternalUrl: envObject.mediaApiExternalUrl,
        serviceDeskVersion: envObject.serviceDeskVersion,
        featureFlags: envObject.featureFlags,
        contactLink: envObject.contactLink,
        anonymousEnabled: envObject.anonymousEnabled,
        fabricEmojiUrl: envObject.fabricEmojiUrl,
        jiraDisplayUrl: envObject.jiraDisplayUrl,
        helpCenterType: envObject.helpCenterType,
        featuredValues: envObject.featuredValues,
        hoistedProjectKey: envObject.hoistedProjectKey,
        hoistedProjectId: envObject.hoistedProjectId,
        customerAccountAvailabilty: envObject.customerAccountAvailabilty
    });
const $21f3149d07bd6ca1$var$defaultState = $21f3149d07bd6ca1$var$getStateFromEnvObject((0, $7lN8e.getEnv)());
function $21f3149d07bd6ca1$export$2e2bcd8739ae039(state = $21f3149d07bd6ca1$var$defaultState, action) {
    switch(action.type){
        case 0, $5QO1D.UPDATE_ENV:
            {
                const newState = $21f3149d07bd6ca1$var$getStateFromEnvObject(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $5QO1D.UPDATE_XSRF:
            return {
                ...state,
                xsrfToken: action.payload
            };
        default:
            return state;
    }
}

});


parcelRegister("a0m8d", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("V2PDG")).featuredAndSortedPortalsReducer);

var $V2PDG = parcelRequire("V2PDG");

});
parcelRegister("V2PDG", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $a0fa6f1aa3a90f55$export$be9fe934804fce97);
parcelRequire("csZtW");
var $gD2hW = parcelRequire("gD2hW");
parcelRequire("7h8sD");
var $8EcmC = parcelRequire("8EcmC");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $a0fa6f1aa3a90f55$var$FEATURED_PORTALS_LIMIT = 15;
const $a0fa6f1aa3a90f55$export$1c29b8ca59adcf6d = {
    portals: {},
    orderedPortalIds: [],
    sortBy: 'POPULARITY',
    limit: $a0fa6f1aa3a90f55$var$FEATURED_PORTALS_LIMIT,
    total: 0,
    isPortalHidingEnabled: false
};
const $a0fa6f1aa3a90f55$export$eb6ead3c9b4f1957 = (portals)=>{
    return portals.reduce((acc, portalSummary)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[portalSummary.id] = {
            id: portalSummary.id,
            key: portalSummary.key,
            name: portalSummary.name,
            description: portalSummary.description,
            logoUrl: portalSummary.logoUrl,
            isFeatured: 'isFeatured' in portalSummary && portalSummary.isFeatured,
            rank: 'rank' in portalSummary && portalSummary.rank,
            isPortalNotVisibleOnHelpCentre: portalSummary.isPortalNotVisibleOnHelpCentre,
            hiddenFromHomeScreen: 'hiddenFromHomeScreen' in portalSummary && portalSummary.hiddenFromHomeScreen
        };
        return acc;
    }, {});
};
const $a0fa6f1aa3a90f55$export$67c021876d6362b9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals) {
        const modelResponse = initialModelState.featuredAndSortedPortals;
        return {
            portals: $a0fa6f1aa3a90f55$export$eb6ead3c9b4f1957(modelResponse.portals),
            orderedPortalIds: modelResponse.portals.map((portal)=>portal.id),
            sortBy: modelResponse.sortBy ? modelResponse.sortBy : 'POPULARITY',
            limit: modelResponse.limit ? modelResponse.limit : $a0fa6f1aa3a90f55$var$FEATURED_PORTALS_LIMIT,
            total: modelResponse.total ? modelResponse.total : 0,
            isPortalHidingEnabled: modelResponse.isPortalHidingEnabled
        };
    }
    return $a0fa6f1aa3a90f55$export$1c29b8ca59adcf6d;
};
const $a0fa6f1aa3a90f55$var$defaultState = $a0fa6f1aa3a90f55$export$67c021876d6362b9();
/**
 * This method is to return only those portals which are not already stored
 * This ensures that the rank and isFeatured values stored in existing data will not get overridden with new data missing these values
 */ const $a0fa6f1aa3a90f55$var$getPortalsNotAlreadyStored = (storedPortals, portals)=>{
    return portals.filter((portal)=>!storedPortals[portal.id]);
};
const $a0fa6f1aa3a90f55$var$updateFeaturedPortals = (state, updatedFeaturedPortalIds, updatedOrderedPortalIds, hiddenPortalIds)=>{
    const portals = {};
    updatedOrderedPortalIds.forEach((portalId)=>{
        portals[portalId] = {
            id: portalId,
            key: state.portals[portalId].key,
            name: state.portals[portalId].name,
            description: state.portals[portalId].description,
            logoUrl: state.portals[portalId].logoUrl,
            isPortalNotVisibleOnHelpCentre: state.portals[portalId].isPortalNotVisibleOnHelpCentre,
            isFeatured: false,
            hiddenFromHomeScreen: hiddenPortalIds.includes(portalId),
            rank: -1
        };
    });
    updatedFeaturedPortalIds.forEach((portalId, index)=>{
        portals[portalId] = {
            ...portals[portalId],
            isFeatured: true,
            rank: index
        };
    });
    return portals;
};
function $a0fa6f1aa3a90f55$export$be9fe934804fce97(state = $a0fa6f1aa3a90f55$var$defaultState, action) {
    switch(action.type){
        case 0, $gD2hW.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $a0fa6f1aa3a90f55$var$handleFetchFeaturedAndSortedPortalsSuccess(action, state);
        case 0, $gD2hW.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $a0fa6f1aa3a90f55$var$handleFetchFeaturedAndSortedPortalsFailure(action, state);
        case 0, $gD2hW.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $a0fa6f1aa3a90f55$var$handleUpdatePortalReorderSettingsSuccess(action, state);
        default:
            return state;
    }
}
const $a0fa6f1aa3a90f55$var$handleFetchFeaturedAndSortedPortalsSuccess = (action, state)=>{
    const { portals: portals, sortBy: sortBy, limit: limit, total: total, isPortalHidingEnabled: isPortalHidingEnabled } = action.payload;
    /* On help seeker screen */ if (!action.requestParams.isPortalReorderingSelected) {
        /* On clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            portals: {
                ...state.portals,
                ...$a0fa6f1aa3a90f55$export$eb6ead3c9b4f1957($a0fa6f1aa3a90f55$var$getPortalsNotAlreadyStored(state.portals, portals))
            },
            orderedPortalIds: portals.map((portal)=>portal.id)
        };
        /* initial load */ return {
            ...state,
            isPortalHidingEnabled: isPortalHidingEnabled,
            portals: $a0fa6f1aa3a90f55$export$eb6ead3c9b4f1957(portals),
            orderedPortalIds: portals.map((portal)=>portal.id),
            sortBy: sortBy ? sortBy : 'POPULARITY',
            limit: limit ? limit : $a0fa6f1aa3a90f55$var$FEATURED_PORTALS_LIMIT,
            total: total ? total : 0,
            error: undefined
        };
    }
    /* On Portal reordering screen initial load */ if (!action.requestParams.sortBy) return {
        ...state,
        isPortalHidingEnabled: isPortalHidingEnabled,
        portals: $a0fa6f1aa3a90f55$export$eb6ead3c9b4f1957(portals),
        orderedPortalIds: portals.map((portal)=>portal.id),
        sortBy: sortBy ? sortBy : 'POPULARITY',
        limit: limit ? limit : $a0fa6f1aa3a90f55$var$FEATURED_PORTALS_LIMIT,
        total: total ? total : 0,
        error: undefined
    };
    return state;
};
const $a0fa6f1aa3a90f55$var$handleFetchFeaturedAndSortedPortalsFailure = (action, state)=>{
    const { error: error } = action.payload;
    const errorObject = {
        status: error.status,
        message: (error.errorMessages || [])[0],
        callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    /* Error in both help center and portal reordering view initial loads */ if (!action.requestParams.sortBy) return {
        ...state,
        error: errorObject
    };
    return state;
};
const $a0fa6f1aa3a90f55$var$handleUpdatePortalReorderSettingsSuccess = (action, state)=>{
    const { featuredPortalIds: featuredPortalIds, sortBy: sortBy, orderedPortalIds: orderedPortalIds, hiddenPortalIds: hiddenPortalIds } = action.payload;
    const portals = $a0fa6f1aa3a90f55$var$updateFeaturedPortals(state, featuredPortalIds, orderedPortalIds, hiddenPortalIds);
    const total = Object.values(portals).filter((portal)=>!(0, $8EcmC.isHiddenPortal)(portal)).length;
    return {
        ...state,
        sortBy: sortBy,
        orderedPortalIds: orderedPortalIds,
        portals: portals,
        total: total
    };
};

});
parcelRegister("7h8sD", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => (parcelRequire("8EcmC")).getFeaturedPortalsInSortedOrderByRank);
$parcel$export(module.exports, "isFeaturedPortal", () => (parcelRequire("8EcmC")).isFeaturedPortal);
$parcel$export(module.exports, "isHiddenPortal", () => (parcelRequire("8EcmC")).isHiddenPortal);
$parcel$export(module.exports, "getPortals", () => (parcelRequire("8EcmC")).getPortals);
$parcel$export(module.exports, "getSortBy", () => (parcelRequire("8EcmC")).getSortBy);
$parcel$export(module.exports, "getLimit", () => (parcelRequire("8EcmC")).getLimit);
$parcel$export(module.exports, "getIsDirty", () => (parcelRequire("8EcmC")).getIsDirty);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => (parcelRequire("8EcmC")).getIsReorderingExperienceLoading);
$parcel$export(module.exports, "getIsSortedDataLoading", () => (parcelRequire("8EcmC")).getIsSortedDataLoading);
$parcel$export(module.exports, "getTotal", () => (parcelRequire("8EcmC")).getTotal);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => (parcelRequire("8EcmC")).getfeaturedAndSortedPortalsError);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => (parcelRequire("8EcmC")).getUIFeaturedPortalIds);
$parcel$export(module.exports, "getUISortBy", () => (parcelRequire("8EcmC")).getUISortBy);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => (parcelRequire("8EcmC")).getUIOrderedPortalIds);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => (parcelRequire("8EcmC")).getPersistedOrderedPortalIds);
$parcel$export(module.exports, "getIsSaveInProgress", () => (parcelRequire("8EcmC")).getIsSaveInProgress);
$parcel$export(module.exports, "getDefaultViewLoading", () => (parcelRequire("8EcmC")).getDefaultViewLoading);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => (parcelRequire("8EcmC")).getIsPortalReorderingDataLoaded);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => (parcelRequire("8EcmC")).getUIHiddenPortalIds);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => (parcelRequire("8EcmC")).getIsPortalHidingEnabled);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => (parcelRequire("8EcmC")).getTotalVisiblePortalCount);
$parcel$export(module.exports, "getAllVisiblePortals", () => (parcelRequire("8EcmC")).getAllVisiblePortals);
$parcel$export(module.exports, "getDefaultViewPortals", () => (parcelRequire("8EcmC")).getDefaultViewPortals);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => (parcelRequire("8EcmC")).getFeaturedPortalsUI);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => (parcelRequire("8EcmC")).getUnFeaturedPortalsUI);

var $8EcmC = parcelRequire("8EcmC");

});
parcelRegister("8EcmC", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => $6445c1c533bbacfb$export$92cc2a471200c3dd);
$parcel$export(module.exports, "isFeaturedPortal", () => $6445c1c533bbacfb$export$4758cf9aa2bbe6ae);
$parcel$export(module.exports, "isHiddenPortal", () => $6445c1c533bbacfb$export$40fc3a80f8881250);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => $6445c1c533bbacfb$export$22d41892c655b6a1);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => $6445c1c533bbacfb$export$9d389d624d531812);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => $6445c1c533bbacfb$export$8bc764a453455857);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => $6445c1c533bbacfb$export$e907b47f94c1ad77);
$parcel$export(module.exports, "getUISortBy", () => $6445c1c533bbacfb$export$3d2a08be86a3576b);
$parcel$export(module.exports, "getPortals", () => $6445c1c533bbacfb$export$9fa4c2091a9d3b38);
$parcel$export(module.exports, "getSortBy", () => $6445c1c533bbacfb$export$c7052c2989e7b681);
$parcel$export(module.exports, "getLimit", () => $6445c1c533bbacfb$export$fb8ce379717a383d);
$parcel$export(module.exports, "getIsDirty", () => $6445c1c533bbacfb$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getTotal", () => $6445c1c533bbacfb$export$94860ac4a286a8d9);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => $6445c1c533bbacfb$export$9a33f9aea44dc01f);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => $6445c1c533bbacfb$export$8cc97acec2e1b274);
$parcel$export(module.exports, "getIsSortedDataLoading", () => $6445c1c533bbacfb$export$20cc91a7c763745e);
$parcel$export(module.exports, "getIsSaveInProgress", () => $6445c1c533bbacfb$export$3f495b2b37e734f1);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => $6445c1c533bbacfb$export$3e1f7fc063cfb951);
$parcel$export(module.exports, "getDefaultViewLoading", () => $6445c1c533bbacfb$export$2b83ab3fa69f277d);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => $6445c1c533bbacfb$export$6113b36bf23cc2fe);
$parcel$export(module.exports, "getAllVisiblePortals", () => $6445c1c533bbacfb$export$30b34a0e1d7ec1fa);
$parcel$export(module.exports, "getDefaultViewPortals", () => $6445c1c533bbacfb$export$35863edd27d88bac);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => $6445c1c533bbacfb$export$22b4f0e1072fa163);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => $6445c1c533bbacfb$export$2650dad54aca58e1);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => $6445c1c533bbacfb$export$2834f451d5fc36b1);

var $2n2bS = parcelRequire("2n2bS");

var $cf3fd = parcelRequire("cf3fd");
const $6445c1c533bbacfb$var$MAX_PORTAL_CARDS = 9;
const $6445c1c533bbacfb$var$getPersistedPortals = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $6445c1c533bbacfb$var$nanToZero = (rank)=>rank || 0;
const $6445c1c533bbacfb$export$92cc2a471200c3dd = (portals)=>{
    return Object.values(portals).filter((portal)=>$6445c1c533bbacfb$export$4758cf9aa2bbe6ae(portal)).sort((portal1, portal2)=>$6445c1c533bbacfb$var$nanToZero(portal1.rank) - $6445c1c533bbacfb$var$nanToZero(portal2.rank));
};
const $6445c1c533bbacfb$export$4758cf9aa2bbe6ae = (portal)=>'isFeatured' in portal && portal.isFeatured;
const $6445c1c533bbacfb$export$40fc3a80f8881250 = (portal)=>'hiddenFromHomeScreen' in portal && !!portal.hiddenFromHomeScreen;
const $6445c1c533bbacfb$export$50625c10d80bbff6 = (portal)=>'isFeatured' in portal && !portal.isFeatured;
const $6445c1c533bbacfb$export$22d41892c655b6a1 = (state)=>{
    return state.persisted.featuredAndSortedPortals.orderedPortalIds;
};
const $6445c1c533bbacfb$export$9d389d624d531812 = (state)=>{
    return state.ui.featuredAndSortedPortals.featuredPortalIds;
};
const $6445c1c533bbacfb$export$8bc764a453455857 = (state)=>{
    return state.ui.featuredAndSortedPortals.hiddenPortalIds;
};
const $6445c1c533bbacfb$export$e907b47f94c1ad77 = (state)=>{
    return state.ui.featuredAndSortedPortals.orderedPortalIds;
};
const $6445c1c533bbacfb$export$3d2a08be86a3576b = (state)=>{
    return state.ui.featuredAndSortedPortals.sortBy;
};
const $6445c1c533bbacfb$export$9fa4c2091a9d3b38 = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $6445c1c533bbacfb$export$c7052c2989e7b681 = (state)=>{
    return state.persisted.featuredAndSortedPortals.sortBy;
};
const $6445c1c533bbacfb$export$fb8ce379717a383d = (state)=>{
    return state.persisted.featuredAndSortedPortals.limit;
};
const $6445c1c533bbacfb$export$4b1964ee9ad6f220 = (state)=>{
    return state.ui.featuredAndSortedPortals.isDirty;
};
const $6445c1c533bbacfb$export$94860ac4a286a8d9 = (state)=>{
    return state.persisted.featuredAndSortedPortals.total;
};
const $6445c1c533bbacfb$export$9a33f9aea44dc01f = (state)=>{
    return state.persisted.featuredAndSortedPortals.error;
};
const $6445c1c533bbacfb$export$8cc97acec2e1b274 = (state)=>{
    return state.ui.featuredAndSortedPortals.isReorderingExperienceLoading;
};
const $6445c1c533bbacfb$export$20cc91a7c763745e = (state)=>{
    return state.ui.featuredAndSortedPortals.isSortedDataLoading;
};
const $6445c1c533bbacfb$export$3f495b2b37e734f1 = (state)=>{
    return state.ui.featuredAndSortedPortals.isSaveInProgress;
};
const $6445c1c533bbacfb$export$3e1f7fc063cfb951 = (state)=>{
    return state.ui.featuredAndSortedPortals.isPortalReorderingDataLoaded;
};
const $6445c1c533bbacfb$export$2b83ab3fa69f277d = (state)=>{
    return state.ui.featuredAndSortedPortals.isDefaultViewLoading;
};
const $6445c1c533bbacfb$export$2cff399032fd66c7 = (state)=>{
    return state.ui.featuredAndSortedPortals.isExpandedViewLoading;
};
const $6445c1c533bbacfb$export$6113b36bf23cc2fe = (state)=>{
    return state.persisted.featuredAndSortedPortals.isPortalHidingEnabled;
};
const $6445c1c533bbacfb$export$30b34a0e1d7ec1fa = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, (persistedPortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return Object.values(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre);
});
const $6445c1c533bbacfb$export$731766e21e298d5 = (0, $2n2bS.createSelector)($6445c1c533bbacfb$export$30b34a0e1d7ec1fa, (allVisiblePortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.values(allVisiblePortals).filter((portal)=>!$6445c1c533bbacfb$export$40fc3a80f8881250(portal));
});
const $6445c1c533bbacfb$export$35863edd27d88bac = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    const featuredPortals = $6445c1c533bbacfb$export$92cc2a471200c3dd(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).filter((portal)=>!$6445c1c533bbacfb$export$40fc3a80f8881250(portal));
    if (featuredPortals.length > 0) return featuredPortals;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$6445c1c533bbacfb$export$40fc3a80f8881250(portal)).slice(0, Math.min(persistedOrderedPortalIds.length, $6445c1c533bbacfb$var$MAX_PORTAL_CARDS));
});
const $6445c1c533bbacfb$export$22b4f0e1072fa163 = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)()) return persistedOrderedPortalIds.length;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).length;
});
const $6445c1c533bbacfb$export$7a3c1f03fc45a503 = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>{
        var _persistedPortals$por;
        return !((_persistedPortals$por = persistedPortals[portalId]) !== null && _persistedPortals$por !== void 0 && _persistedPortals$por.isPortalNotVisibleOnHelpCentre);
    }).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$6445c1c533bbacfb$export$40fc3a80f8881250(portal)).length;
});
const $6445c1c533bbacfb$export$7574c566fd98dead = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$35863edd27d88bac, $6445c1c533bbacfb$export$22d41892c655b6a1, (persistedPortals, defaultViewPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>!defaultViewPortals.some((defaultViewPortal)=>portalId === defaultViewPortal.id) && !persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$6445c1c533bbacfb$export$40fc3a80f8881250(portal));
});
const $6445c1c533bbacfb$export$bf663b849d73b99a = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, (persistedPortals)=>{
    return $6445c1c533bbacfb$export$92cc2a471200c3dd(persistedPortals);
});
const $6445c1c533bbacfb$export$e666136461a3c9a3 = (0, $2n2bS.createSelector)($6445c1c533bbacfb$export$bf663b849d73b99a, (featuredPortals)=>{
    return featuredPortals.filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).length;
});
const $6445c1c533bbacfb$export$2706ef7f7cb3a94c = (0, $2n2bS.createSelector)($6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.map((portalId)=>persistedPortals[portalId]).filter($6445c1c533bbacfb$export$50625c10d80bbff6);
});
const $6445c1c533bbacfb$export$2650dad54aca58e1 = (0, $2n2bS.createSelector)($6445c1c533bbacfb$export$9d389d624d531812, $6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$8bc764a453455857, (uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiFeaturedPortalIds.map((portalId)=>{
        const portal = persistedPortals[portalId];
        return {
            ...portal,
            isFeatured: true,
            rank: $6445c1c533bbacfb$export$4758cf9aa2bbe6ae(portal) ? portal.rank : -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        };
    });
});
const $6445c1c533bbacfb$export$2834f451d5fc36b1 = (0, $2n2bS.createSelector)($6445c1c533bbacfb$export$e907b47f94c1ad77, $6445c1c533bbacfb$export$9d389d624d531812, $6445c1c533bbacfb$var$getPersistedPortals, $6445c1c533bbacfb$export$8bc764a453455857, (uiOrderedPortalIds, uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiOrderedPortalIds.filter((portalId)=>!uiFeaturedPortalIds.includes(portalId)).map((portalId)=>({
            ...persistedPortals[portalId],
            isFeatured: false,
            rank: -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        }));
});

});




parcelRegister("2gFPB", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => (parcelRequire("b2cpk")).forgotPasswordReducer);

var $b2cpk = parcelRequire("b2cpk");

});
parcelRegister("b2cpk", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => $8eb5d17622ef365d$export$545b1c441fc64b70);

var $hO6iq = parcelRequire("hO6iq");
parcelRequire("aBure");
var $imKPc = parcelRequire("imKPc");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $8eb5d17622ef365d$export$4ad260a5db9e01cf = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.forgotPassword) return {
        forgotPassword: initialModelState.forgotPassword
    };
    return {};
};
const $8eb5d17622ef365d$var$defaultState = $8eb5d17622ef365d$export$4ad260a5db9e01cf();
function $8eb5d17622ef365d$export$545b1c441fc64b70(state = $8eb5d17622ef365d$var$defaultState, action) {
    switch(action.type){
        case 0, $hO6iq.FETCH_FORGOT_PASSWORD_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $imKPc.FETCH_FORGOT_PASSWORD_FAILURE:
            {
                const fetchForgotPasswordFailureAction = action;
                const { error: error } = fetchForgotPasswordFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $imKPc.FETCH_FORGOT_PASSWORD_SUCCESS:
            {
                const fetchPForgotPasswordSuccessAction = action;
                const response = fetchPForgotPasswordSuccessAction.payload;
                return {
                    forgotPassword: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("hsHQs", function(module, exports) {
$parcel$export(module.exports, "helpcenterReducer", () => (parcelRequire("4VlGq")).default);

var $4VlGq = parcelRequire("4VlGq");

});
parcelRegister("4VlGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $7474b62c976d7015$export$2e2bcd8739ae039);

var $hN5YJ = parcelRequire("hN5YJ");

var $2N6q5 = parcelRequire("2N6q5");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("jjuxZ");
var $gwluP = parcelRequire("gwluP");

var $cf3fd = parcelRequire("cf3fd");

var $cf3fd = parcelRequire("cf3fd");

var $bKaMP = parcelRequire("bKaMP");
function $7474b62c976d7015$var$reduceHCBrandingToState(helpCenterBrandingResponse) {
    const translationState = (0, $aYMdQ.mapValues)(helpCenterBrandingResponse.translations, (translation)=>({
            ...translation
        }));
    const isAdvancedHelpCenterThemingEnabled = (0, $hN5YJ.isCustomThemingEnabled)() && ((0, $cf3fd.isAdvancedHelpCenter)() || (0, $cf3fd.isDefaultHelpCenter)());
    const portalThemeColor = helpCenterBrandingResponse.portalThemeColor || '#0074e0';
    return {
        logoUrl: helpCenterBrandingResponse.logoUrl,
        logoMediaApiFileId: helpCenterBrandingResponse.logoId,
        sharedPortalName: helpCenterBrandingResponse.sharedPortalName,
        translations: translationState,
        helpCenterBannerUrl: helpCenterBrandingResponse.useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($2N6q5))) : helpCenterBrandingResponse.bannerMediaApiUrl,
        bannerMediaApiFileId: helpCenterBrandingResponse.bannerMediaApiFileId,
        canCustomizeHelpCenter: !!helpCenterBrandingResponse.canEditAnnouncement,
        helpCenterTitle: helpCenterBrandingResponse.helpCenterTitle,
        helpCenterTitleColor: helpCenterBrandingResponse.helpCenterTitleColor,
        ...(0, $hN5YJ.isUseHelpCenterRefresh)() ? {
            topBarColor: helpCenterBrandingResponse.topBarColor || portalThemeColor,
            topBarTextColor: helpCenterBrandingResponse.topBarTextColor || helpCenterBrandingResponse.helpCenterTitleColor,
            hasTopBarBeenSplit: helpCenterBrandingResponse.hasTopBarBeenSplit ?? false
        } : {},
        rawBrandingResponse: helpCenterBrandingResponse,
        announcementHeader: helpCenterBrandingResponse.userInitialAnnouncementHeader,
        announcementMessage: helpCenterBrandingResponse.userInitialAnnouncementMessageWiki,
        useDefaultBanner: helpCenterBrandingResponse.useDefaultBanner,
        isLoaded: true,
        ...isAdvancedHelpCenterThemingEnabled ? {} : {
            themeColor: portalThemeColor
        }
    };
}
function $7474b62c976d7015$var$reduceHelpCenterToState(helpCenterResponse) {
    const newState = helpCenterResponse.kbs && helpCenterResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            appLinkUrl: helpCenterResponse.kbs.appLinkUrl,
            kbLinkDomainURLs: helpCenterResponse.kbs.kbLinkDomainURLs
        }
    } : {};
    return {
        ...newState,
        isLoaded: true
    };
}
const $7474b62c976d7015$var$getInitialBrandingState = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.helpCenterBranding) return $7474b62c976d7015$var$reduceHCBrandingToState(initialModelState.helpCenterBranding);
    return undefined;
};
const $7474b62c976d7015$var$getInitialHelpCenterState = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.sharedPortal) return $7474b62c976d7015$var$reduceHelpCenterToState(initialModelState.sharedPortal);
    return undefined;
};
const $7474b62c976d7015$var$getInitialIsBrandingLoadedFlag = ()=>{
    if ((0, $hN5YJ.isIncreasedFlexibilityEnabled)()) {
        const initialModelState = (0, $bKaMP.default)();
        if (initialModelState && initialModelState.helpCenterBranding) return true;
    }
    return false;
};
const $7474b62c976d7015$var$getDefaultState = ()=>({
        sharedPortalName: '',
        helpCenterTitle: '',
        helpCenterTitleColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarTextColor: '#0D1424',
        // do not tokenize as of now (this might fail on the polished methods)
        translations: {
            'en-US': {
                sharedPortalName: '',
                helpCenterTitle: '',
                localeDisplayName: ''
            }
        },
        canCustomizeHelpCenter: false,
        isLoaded: false,
        themeColor: '#0052CC',
        // do not tokenize as of now (this will fail on the polished methods)
        useDefaultBanner: true,
        ...$7474b62c976d7015$var$getInitialHelpCenterState(),
        ...$7474b62c976d7015$var$getInitialBrandingState(),
        isBrandingLoaded: $7474b62c976d7015$var$getInitialIsBrandingLoadedFlag()
    });
function $7474b62c976d7015$export$2e2bcd8739ae039(state = $7474b62c976d7015$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $gwluP.UPDATE_HELP_CENTER_THEME_COLOR:
            return {
                ...state,
                ...action.payload
            };
        case 0, $gwluP.UPDATE_HELP_CENTER_MODEL:
            {
                const newState = $7474b62c976d7015$var$reduceHelpCenterToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $gwluP.UPDATE_HELP_CENTER_BRANDING_MODEL:
            {
                const newState = $7474b62c976d7015$var$reduceHCBrandingToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $gwluP.UPDATE_HELP_CENTER_BRANDING_LOADER:
            return {
                ...state,
                isBrandingLoaded: action.payload.loaded
            };
        default:
            return state;
    }
}

});
parcelRegister("2N6q5", function(module, exports) {
module.exports = new URL("../images/default-banner.8e21c182.png", import.meta.url).toString();

});



parcelRegister("byPkC", function(module, exports) {
$parcel$export(module.exports, "articlesReducer", () => (parcelRequire("4fiL9")).default);

var $4fiL9 = parcelRequire("4fiL9");

});
parcelRegister("4fiL9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7719ca61a2929b6c$export$2e2bcd8739ae039);

var $2EMow = parcelRequire("2EMow");
parcelRequire("1zrpx");
var $1EWnP = parcelRequire("1EWnP");

var $lmrcQ = parcelRequire("lmrcQ");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $7719ca61a2929b6c$var$reduceArticle = (article)=>({
        editUrl: '',
        id: `${article.id}`,
        isFeatured: false,
        friendlyLastModified: '',
        lastModified: '',
        shareUrl: '',
        summaryExcerpt: '',
        title: article.title,
        titleExcerpt: article.title,
        viewCount: -1,
        viewUrl: article.url,
        projects: article.projects,
        space: article.space,
        hostname: article.hostname
    });
const $7719ca61a2929b6c$var$getArticleId = (article)=>article.idInString;
const $7719ca61a2929b6c$var$getInitialState = ()=>{
    const models = (0, $bKaMP.default)();
    return {
        articles: {},
        legacyArticles: models.kbPage ? {
            [$7719ca61a2929b6c$var$getArticleId(models.kbPage)]: $7719ca61a2929b6c$var$reduceArticle(models.kbPage)
        } : {}
    };
};
const $7719ca61a2929b6c$var$defaultState = $7719ca61a2929b6c$var$getInitialState();
function $7719ca61a2929b6c$export$2e2bcd8739ae039(state = $7719ca61a2929b6c$var$defaultState, action) {
    switch(action.type){
        case 0, $2EMow.FETCH_ARTICLES:
            {
                const { categoryId: categoryId } = action.payload;
                if (state.articles[categoryId] && 'error' in state.articles[categoryId]) {
                    const newState = {
                        ...state,
                        articles: {
                            ...state.articles
                        }
                    };
                    delete newState.articles[categoryId];
                    return newState;
                }
                return state;
            }
        case 0, $lmrcQ.FETCH_ARTICLES_SUCCESS:
            {
                const { categoryId: categoryId, response: { results: articles } } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: articles.map(({ featuredInCategories: featuredInCategories, ...article })=>({
                                    ...article,
                                    isFeatured: !!featuredInCategories && featuredInCategories.includes(categoryId)
                                }))
                        }
                    }
                };
            }
        case 0, $lmrcQ.FETCH_ARTICLES_FAILURE:
            {
                const { portalId: portalId, categoryId: categoryId, error: apolloError } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: [],
                            error: {
                                error: {
                                    status: apolloError.statusCode,
                                    message: apolloError.errorMessage,
                                    callToActionText: 'Go back',
                                    callToActionUrl: `/portal/${portalId}`
                                }
                            }
                        }
                    }
                };
            }
        case 0, $1EWnP.FETCH_ARTICLE:
            {
                const { id: id } = action.payload.params;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $1EWnP.FETCH_ARTICLE_SUCCESS:
            {
                const articleId = action.payload.idInString;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [articleId]: $7719ca61a2929b6c$var$reduceArticle(action.payload)
                    }
                };
            }
        case 0, $1EWnP.FETCH_ARTICLE_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [action.payload.id]: {
                            error: {
                                // We really only care about the first error message
                                // grab it and throw the rest away
                                status: error.status,
                                message: (error.errorMessages || [])[0],
                                // Remove basename from the URL, we don't need it as the basename
                                // is already set inside react router.
                                // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                                callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                                callToActionText: error.nextActionDisplayText || ''
                            }
                        }
                    }
                };
            }
        case 0, $1EWnP.FETCH_CROSS_SITE_ARTICLE:
            {
                const { articleId: id } = action.payload;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        default:
            return state;
    }
}

});


parcelRegister("1w8mW", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => (parcelRequire("kWTPI")).languagesReducer);

var $kWTPI = parcelRequire("kWTPI");

});
parcelRegister("kWTPI", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => $cada16d3940b5e77$export$675c3b6bfa6435e6);
parcelRequire("9CX1u");
var $fYB4S = parcelRequire("fYB4S");

var $8s5M7 = parcelRequire("8s5M7");

var $bKaMP = parcelRequire("bKaMP");
const $cada16d3940b5e77$export$ef8b6f0b1af42002 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState) {
        const languages = initialModelState.availableLanguages === undefined ? [] : (0, $8s5M7.ensureConsistentResponses)(initialModelState.availableLanguages);
        return {
            languages: languages
        };
    }
    return {
        languages: []
    };
};
const $cada16d3940b5e77$var$defaultState = $cada16d3940b5e77$export$ef8b6f0b1af42002();
function $cada16d3940b5e77$export$675c3b6bfa6435e6(state = $cada16d3940b5e77$var$defaultState, action) {
    switch(action.type){
        case 0, $fYB4S.FETCH_LANGUAGES_SUCCESS:
            return $cada16d3940b5e77$var$handleFetchLanguagesSuccess(state, action);
        default:
            return state;
    }
}
const $cada16d3940b5e77$var$handleFetchLanguagesSuccess = (state, action)=>({
        ...state,
        languages: (0, $8s5M7.ensureConsistentResponses)(action.payload.languages)
    });

});
parcelRegister("8s5M7", function(module, exports) {
$parcel$export(module.exports, "ensureConsistentKey", () => $9842d248cb975a9a$export$6117ad7803ddf800);
$parcel$export(module.exports, "ensureConsistentResponses", () => $9842d248cb975a9a$export$131bf7a7b9860e71);
const $9842d248cb975a9a$export$6117ad7803ddf800 = (localeKey)=>localeKey.replace('_', '-');
const $9842d248cb975a9a$var$ensureConsistentResponse = (response)=>({
        key: $9842d248cb975a9a$export$6117ad7803ddf800(response.key),
        originalKey: response.key,
        displayName: response.displayName
    });
const $9842d248cb975a9a$export$131bf7a7b9860e71 = (responses)=>responses.map((response)=>$9842d248cb975a9a$var$ensureConsistentResponse(response));

});



parcelRegister("aaBug", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("67qKz")).default);

var $67qKz = parcelRequire("67qKz");

});
parcelRegister("67qKz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cab6c2a613096fa$export$2e2bcd8739ae039);
parcelRequire("9a3MY");
var $8dMoV = parcelRequire("8dMoV");
const $1cab6c2a613096fa$var$defaultState = {
    linkedSpaces: [],
    hasLoaded: false
};
function $1cab6c2a613096fa$export$2e2bcd8739ae039(state = $1cab6c2a613096fa$var$defaultState, action) {
    switch(action.type){
        case 0, $8dMoV.FETCH_LINKED_SPACES:
            return {
                ...state,
                error: undefined
            };
        case 0, $8dMoV.FETCH_LINKED_SPACES_SUCCESS:
            {
                const { linkedSpaces: linkedSpaces } = action.payload;
                return {
                    ...state,
                    linkedSpaces: linkedSpaces || [],
                    hasLoaded: true,
                    error: undefined
                };
            }
        case 0, $8dMoV.FETCH_LINKED_SPACES_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    hasLoaded: true,
                    error: {
                        error: {
                            status: error.status,
                            message: error.message || 'Failed to fetch linked spaces',
                            callToActionText: '',
                            callToActionUrl: ''
                        }
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("xqu6y", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => (parcelRequire("F1hMq")).loginReducer);

var $F1hMq = parcelRequire("F1hMq");

});
parcelRegister("F1hMq", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => $9586083b16cdcadc$export$3d13b312f34d11e5);

var $1wdH4 = parcelRequire("1wdH4");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $9586083b16cdcadc$export$5b80378ff66478a5 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.login) return {
        login: initialModelState.login
    };
    return {};
};
const $9586083b16cdcadc$var$defaultState = $9586083b16cdcadc$export$5b80378ff66478a5();
function $9586083b16cdcadc$export$3d13b312f34d11e5(state = $9586083b16cdcadc$var$defaultState, action) {
    switch(action.type){
        case 0, $1wdH4.FETCH_LOGIN_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $6oW6S.FETCH_LOGIN_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $6oW6S.FETCH_LOGIN_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const response = fetchPortalSuccessAction.payload;
                return {
                    login: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("jPvc0", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("edwRG")).loginAnnouncementsReducer);

var $edwRG = parcelRequire("edwRG");

});
parcelRegister("edwRG", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $813c3592dbbf86ce$export$14afe2784a94db4d);

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("700aU");
var $dxx1m = parcelRequire("dxx1m");

var $bKaMP = parcelRequire("bKaMP");
const $813c3592dbbf86ce$export$d383b838c87089ae = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements) return initialModelState.loginAnnouncements;
    return {
        defaultLocale: '',
        translatedLoginAnnouncements: {}
    };
};
const $813c3592dbbf86ce$var$defaultState = $813c3592dbbf86ce$export$d383b838c87089ae();
function $813c3592dbbf86ce$export$14afe2784a94db4d(state = $813c3592dbbf86ce$var$defaultState, action) {
    switch(action.type){
        case 0, $dxx1m.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return action.payload;
        case 0, $dxx1m.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
            {
                const { payload: payload } = action;
                if ((0, $aYMdQ.isEmpty)(payload)) return state;
                return {
                    defaultLocale: state.defaultLocale,
                    translatedLoginAnnouncements: Object.keys(payload.translatedLogInAnnouncements).reduce((acc, languageKey)=>{
                        var _state$translatedLogi;
                        return {
                            ...acc,
                            [languageKey]: {
                                header: payload.translatedLogInAnnouncements[languageKey].header,
                                message: payload.translatedLogInAnnouncements[languageKey].message,
                                localeDisplayName: (_state$translatedLogi = state.translatedLoginAnnouncements[languageKey]) === null || _state$translatedLogi === void 0 ? void 0 : _state$translatedLogi.localeDisplayName
                            }
                        };
                    }, {})
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("cJyJ4", function(module, exports) {
$parcel$export(module.exports, "metaReducer", () => (parcelRequire("gwHjP")).default);

var $gwHjP = parcelRequire("gwHjP");

});
parcelRegister("gwHjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $feddf63b4c059884$export$2e2bcd8739ae039);
parcelRequire("3WjHd");
var $et0Rx = parcelRequire("et0Rx");
const $feddf63b4c059884$var$defaultState = {};
function $feddf63b4c059884$export$2e2bcd8739ae039(state = $feddf63b4c059884$var$defaultState, action) {
    if (action.type === (0, $et0Rx.UPDATE_META)) {
        const newState = action.payload;
        return {
            ...state,
            ...newState
        };
    }
    return state;
}

});
parcelRegister("3WjHd", function(module, exports) {
$parcel$export(module.exports, "updateMetaAction", () => (parcelRequire("et0Rx")).updateMetaAction);
$parcel$export(module.exports, "UPDATE_META", () => (parcelRequire("et0Rx")).UPDATE_META);

var $et0Rx = parcelRequire("et0Rx");

});
parcelRegister("et0Rx", function(module, exports) {
$parcel$export(module.exports, "UPDATE_META", () => $833eedaf147b7588$export$7db07bf896c7e69b);
$parcel$export(module.exports, "updateMetaAction", () => $833eedaf147b7588$export$4a183f4e7a49f459);
const $833eedaf147b7588$export$7db07bf896c7e69b = 'state.persisted.env.UPDATE_META';
const $833eedaf147b7588$export$4a183f4e7a49f459 = (meta)=>({
        payload: meta,
        type: $833eedaf147b7588$export$7db07bf896c7e69b
    });

});




parcelRegister("J5CJJ", function(module, exports) {
$parcel$export(module.exports, "organisationsReducer", () => (parcelRequire("lqQHa")).default);

var $lqQHa = parcelRequire("lqQHa");

});
parcelRegister("lqQHa", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c7b929448cdf229$export$2e2bcd8739ae039);
parcelRequire("lQHAL");
var $lrRyo = parcelRequire("lrRyo");

var $bKaMP = parcelRequire("bKaMP");
const $9c7b929448cdf229$var$emptyState = {
    organisations: []
};
const $9c7b929448cdf229$export$a7f9736258a0bacb = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.organisations) return {
        organisations: initialModelState.organisations.organisations
    };
    return $9c7b929448cdf229$var$emptyState;
};
const $9c7b929448cdf229$var$defaultState = $9c7b929448cdf229$export$a7f9736258a0bacb();
function $9c7b929448cdf229$export$2e2bcd8739ae039(state = $9c7b929448cdf229$var$defaultState, action) {
    switch(action.type){
        case 0, $lrRyo.UPDATE_ORGANISATIONS_MODEL:
            {
                const organisations = action.payload.organisations.map((org)=>({
                        id: org.id,
                        name: org.name
                    }));
                const newState = {
                    organisations: organisations
                };
                return {
                    ...state,
                    ...newState
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("fq5i8", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("jrq8X")).default);

var $jrq8X = parcelRequire("jrq8X");

});
parcelRegister("jrq8X", function(module, exports) {
$parcel$export(module.exports, "default", () => $78c081bed69ec458$export$2e2bcd8739ae039);

var $9tWp4 = parcelRequire("9tWp4");
parcelRequire("2hp8E");
var $2hqAY = parcelRequire("2hqAY");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("exdqy");
var $6YXMD = parcelRequire("6YXMD");
parcelRequire("ljSph");
var $1mt5N = parcelRequire("1mt5N");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $78c081bed69ec458$var$getMediaUploadToken = (mediaApiUploadInformation)=>{
    if ('token' in mediaApiUploadInformation) return {
        clientId: mediaApiUploadInformation.clientId,
        token: mediaApiUploadInformation.token,
        endpointUrl: mediaApiUploadInformation.endpointUrl,
        targetCollection: mediaApiUploadInformation.targetCollection,
        tokenDurationInMins: mediaApiUploadInformation.tokenDurationInMins
    };
    return undefined;
};
const $78c081bed69ec458$var$getMediaError = (mediaApiUploadInformation)=>{
    if ('error' in mediaApiUploadInformation) return mediaApiUploadInformation.error;
    return undefined;
};
function $78c081bed69ec458$var$reducePortalResponseToState(portalResponse, oldState = {}) {
    const portalId = parseInt(portalResponse.id, 10);
    const mediaApiUploadInformation = portalResponse.mediaApiUploadInformation;
    const mediaApiUploadToken = mediaApiUploadInformation && $78c081bed69ec458$var$getMediaUploadToken(mediaApiUploadInformation);
    const mediaApiError = mediaApiUploadInformation && $78c081bed69ec458$var$getMediaError(mediaApiUploadInformation);
    const newSinglePortalState = {
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiError: mediaApiError,
        id: portalId,
        name: portalResponse.name,
        logoUrl: portalResponse.logoUrl,
        description: portalResponse.description,
        projectKey: portalResponse.key,
        projectId: portalResponse.projectId,
        portalAnnouncement: portalResponse.portalAnnouncement,
        isProjectSimplified: portalResponse.isProjectSimplified,
        serviceDeskId: portalResponse.serviceDeskId,
        reqGroups: [],
        reqTypes: [],
        // Omitted rather than set to undefined so existing state snapshots keep matching.
        ...portalResponse.locale !== undefined ? {
            locale: portalResponse.locale
        } : {},
        ...portalResponse.i18nTranslations !== undefined ? {
            i18nTranslations: portalResponse.i18nTranslations
        } : {}
    };
    const categoriesData = portalResponse.categories;
    const categories = categoriesData !== null && categoriesData !== void 0 && categoriesData.categoriesSupported ? categoriesData.categories : undefined;
    const kbState = portalResponse.kbs && portalResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            kbLink: portalResponse.kbs.kbLink,
            kbLinkDomainURLs: portalResponse.kbs.kbLinkDomainURLs,
            kbCategories: categories
        }
    } : {};
    // If there is KB we try to maintain the previous categories
    if (!!kbState.knowledgeBase) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingPortal = oldState[portalId];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingCategories = existingPortal && !('error' in existingPortal) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase.kbCategories;
        if (existingCategories) // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        kbState.knowledgeBase = {
            ...kbState.knowledgeBase,
            kbCategories: existingCategories
        };
    }
    const reqTypesState = portalResponse.reqTypes ? {
        reqTypes: portalResponse.reqTypes.map((reqtype)=>({
                id: reqtype.id,
                name: reqtype.name,
                // This is actually the description, not the intro.
                // The backend is wrecked.
                descriptionHtml: reqtype.introHtml,
                // This is actually the help text, not the description.
                // The backend is wrecked.
                helpTextHtml: reqtype.descriptionHtml,
                // Icon id here is required to pass backend validation of req type when removing from group
                // can remove once backend change JDW-292 is complete
                icon: reqtype.icon,
                iconUrl: reqtype.iconUrl || `${0, $diqlM.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${reqtype.icon}`
            }))
    } : {};
    const orderMapping = portalResponse.orderMapping || {};
    const reqGroupsState = (portalResponse.reqGroups || []).map((reqGroup)=>({
            id: reqGroup.id,
            name: reqGroup.name,
            reqTypes: (orderMapping[reqGroup.id] || []).map(String)
        }));
    const { analyticsContext: analyticsContext } = portalResponse;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const oldPortalState = oldState[portalId];
    const analyticAttributesState = analyticsContext ? {
        analyticAttributes: {
            jsdRole: analyticsContext.jsdRole,
            initialProjectTemplate: analyticsContext.initialProjectTemplate,
            openAccess: analyticsContext.openAccess,
            publicSignup: analyticsContext.publicSignup,
            nextGenProject: analyticsContext.nextGenProject,
            demoProject: analyticsContext.demoProject,
            eapOptedIn: analyticsContext.eapOptedIn,
            jsdDwCohort: analyticsContext.jsdDwCohort,
            previousSupportedProjects: analyticsContext.previousSupportedProjects,
            supportedProjects: analyticsContext.supportedProjects
        }
    } : {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...oldPortalState && oldPortalState.analyticAttributes ? // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        {
            analyticAttributes: oldPortalState.analyticAttributes
        } : {}
    };
    return {
        [portalId]: {
            ...newSinglePortalState,
            ...kbState,
            ...reqTypesState,
            ...analyticAttributesState,
            reqGroups: reqGroupsState
        }
    };
}
const $78c081bed69ec458$export$6189f5b9656c1eb4 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.portal) {
        if (initialModelState.branding) return $78c081bed69ec458$var$reducePortalResponseToState({
            ...initialModelState.branding,
            ...initialModelState.portal
        });
        return $78c081bed69ec458$var$reducePortalResponseToState({
            ...initialModelState.portal,
            logoUrl: undefined,
            theme: {}
        });
    }
    return {};
};
const $78c081bed69ec458$var$defaultState = $78c081bed69ec458$export$6189f5b9656c1eb4();
function $78c081bed69ec458$export$2e2bcd8739ae039(state = $78c081bed69ec458$var$defaultState, action) {
    switch(action.type){
        case 0, $hijaX.FETCH_PORTAL_MODEL:
            {
                const fetchPortalAction = action;
                const portalId = fetchPortalAction.payload.params && fetchPortalAction.payload.params.id;
                if (portalId) {
                    const portal = state[portalId];
                    if (portal && 'error' in portal) {
                        const newState = {
                            ...state
                        };
                        delete newState[portalId];
                        return newState;
                    }
                }
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $1mt5N.FETCH_REQUEST_CREATE_FAILURE:
        case 0, $hijaX.FETCH_PORTAL_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error, portalId: portalId } = fetchPortalFailureAction.payload;
                return {
                    ...state,
                    [portalId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || '',
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders
                        }
                    }
                };
            }
        case 0, $hijaX.FETCH_PORTAL_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                return {
                    ...state,
                    ...$78c081bed69ec458$var$reducePortalResponseToState(fetchPortalSuccessAction.payload, state)
                };
            }
        case 0, $2hqAY.FETCH_CATEGORIES_SUCCESS:
            {
                const categoriesSuccessAction = action;
                const { portalId: portalId, categories: categories } = categoriesSuccessAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: categories
                        }
                    }
                };
            }
        case 0, $2hqAY.FETCH_CATEGORIES_FAILURE:
            {
                const categoriesFailureAction = action;
                const { portalId: portalId, error: categoryError } = categoriesFailureAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: {
                                error: {
                                    status: categoryError.statusCode,
                                    message: categoryError.errorMessage,
                                    callToActionUrl: '/portal/',
                                    callToActionText: 'Go back'
                                }
                            }
                        }
                    }
                };
            }
        case 0, $hijaX.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
            {
                const { payload: payload } = action;
                if (!payload) return state;
                const { portalId: portalId } = payload;
                const portal = state[portalId];
                const portalAnnouncement = payload ?? portal.portalAnnouncement;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        portalAnnouncement: portalAnnouncement
                    }
                };
            }
        case 0, $9tWp4.FETCH_KB_SUGGESTIONS_SUCCESS:
            {
                const { kbArticleSuggestions: kbArticleSuggestions, portalId: portalId } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (!portal || 'error' in portal) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbArticleSuggestions: kbArticleSuggestions
                        }
                    }
                };
            }
        case 0, $6YXMD.PROFORMA_FORM_LOADED:
            {
                const { portalId: portalId, proformaFormIsLoaded: proformaFormIsLoaded } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        proformaFormIsLoaded: proformaFormIsLoaded
                    }
                };
            }
        case 0, $hijaX.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS:
            {
                const { portalId: portalId, mediaApiUploadInformation: mediaApiUploadInformation } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (portal && !('error' in portal)) return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        mediaApiUploadToken: $78c081bed69ec458$var$getMediaUploadToken(mediaApiUploadInformation)
                    }
                };
                return state;
            }
        default:
            return state;
    }
}

});
parcelRegister("9tWp4", function(module, exports) {
$parcel$export(module.exports, "FETCH_KB_SUGGESTIONS_SUCCESS", () => $1bd06f5bc1dcc5c4$export$1b2c5db514ac0bd7);
$parcel$export(module.exports, "fetchKBSuggestionsSuccessAction", () => $1bd06f5bc1dcc5c4$export$ce6a80dfe554c3b6);
const $1bd06f5bc1dcc5c4$export$1b2c5db514ac0bd7 = 'epic.model.FETCH_KB_SUGGESTIONS';
const $1bd06f5bc1dcc5c4$export$ce6a80dfe554c3b6 = (params)=>{
    return {
        type: $1bd06f5bc1dcc5c4$export$1b2c5db514ac0bd7,
        payload: params
    };
};

});

parcelRegister("exdqy", function(module, exports) {
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => (parcelRequire("6YXMD")).fetchPortalAndRequestTypesModel);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => (parcelRequire("6YXMD")).fetchPortalsAndRequestTypesSuccess);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => (parcelRequire("6YXMD")).FETCH_PORTAL_AND_REQUEST_TYPES);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => (parcelRequire("6YXMD")).FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => (parcelRequire("6YXMD")).PROFORMA_FORM_LOADED);

var $6YXMD = parcelRequire("6YXMD");

});
parcelRegister("6YXMD", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => $3f58b514086ff2a3$export$172324766a8910d6);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => $3f58b514086ff2a3$export$5f63fa3daf3ecef8);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => $3f58b514086ff2a3$export$4c0299a035f236e5);
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => $3f58b514086ff2a3$export$b4741ec41baec80b);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => $3f58b514086ff2a3$export$da57d2f9cae3a05f);

var $dv0hN = parcelRequire("dv0hN");
const $3f58b514086ff2a3$export$172324766a8910d6 = 'epic.model.FETCH_PORTAL_AND_REQUEST_TYPES';
const $3f58b514086ff2a3$export$5f63fa3daf3ecef8 = 'state.persisted.portals-and-request-types.FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS';
const $3f58b514086ff2a3$export$4c0299a035f236e5 = 'state.persisted.portals-and-request-types.PROFORMA_FORM_LOADED';
const $3f58b514086ff2a3$export$b4741ec41baec80b = (payload = {}, meta)=>({
        meta: meta,
        ...(0, $dv0hN.buildModelsActionCreator)($3f58b514086ff2a3$export$172324766a8910d6, 'portalsAndRequestTypes')(payload)
    });
const $3f58b514086ff2a3$export$da57d2f9cae3a05f = (portalsAndRequestTypesModel)=>({
        payload: portalsAndRequestTypesModel,
        type: $3f58b514086ff2a3$export$5f63fa3daf3ecef8
    });

});




parcelRegister("cNftW", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("jrNvH")).portalCustomisationReducer);

var $jrNvH = parcelRequire("jrNvH");

});
parcelRegister("jrNvH", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => $5a432ee7736c8463$export$b5745e15c8a52df8);
parcelRequire("hPZpM");
var $hDMR6 = parcelRequire("hDMR6");
const $5a432ee7736c8463$export$49d5fc8cba920a0 = {
    allRequestGroups: {},
    errorMessage: undefined
};
function $5a432ee7736c8463$export$b5745e15c8a52df8(state = $5a432ee7736c8463$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $hDMR6.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { portalId: portalId, requestGroups: requestGroups } = action.payload;
                return {
                    errorMessage: undefined,
                    allRequestGroups: {
                        ...state.allRequestGroups,
                        [portalId]: requestGroups
                    }
                };
            }
        case 0, $hDMR6.GET_ALL_REQUEST_GROUPS_FAILURE:
            {
                const { errorMessage: errorMessage } = action.payload;
                return {
                    ...state,
                    errorMessage: errorMessage
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("llGdE", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => (parcelRequire("1VIKK")).profileWebFragmentReducer);

var $1VIKK = parcelRequire("1VIKK");

});
parcelRegister("1VIKK", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => $4a40a9aaabb862c0$export$530037ab477140ce);
parcelRequire("lgOtA");
var $03HuP = parcelRequire("03HuP");

var $bKaMP = parcelRequire("bKaMP");
const $4a40a9aaabb862c0$export$f9c142b09e8e12af = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.profileWebFragments) return {
        ...initialModelState.profileWebFragments
    };
    return {};
};
const $4a40a9aaabb862c0$export$49d5fc8cba920a0 = $4a40a9aaabb862c0$export$f9c142b09e8e12af();
const $4a40a9aaabb862c0$var$handleFetchProfileConnectFragmentsSuccess = (state, action)=>({
        ...state,
        ...action.payload.fragments
    });
const $4a40a9aaabb862c0$var$handleFetchProfileConnectFragmentsFailure = (state, action)=>({
        ...state,
        panels: action.payload
    });
function $4a40a9aaabb862c0$export$530037ab477140ce(state = $4a40a9aaabb862c0$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $03HuP.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS:
            return $4a40a9aaabb862c0$var$handleFetchProfileConnectFragmentsSuccess(state, action);
        case 0, $03HuP.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE:
            return $4a40a9aaabb862c0$var$handleFetchProfileConnectFragmentsFailure(state, action);
        default:
            return state;
    }
}

});


parcelRegister("4STZl", function(module, exports) {
$parcel$export(module.exports, "requestCreateReducer", () => (parcelRequire("497QK")).default);

var $497QK = parcelRequire("497QK");

});
parcelRegister("497QK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1f4e11b9af9bc89$export$2e2bcd8739ae039);

var $hN5YJ = parcelRequire("hN5YJ");

var $ay3bN = parcelRequire("ay3bN");
parcelRequire("ljSph");
var $1mt5N = parcelRequire("1mt5N");

var $YWCnr = parcelRequire("YWCnr");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");

var $g81wt = parcelRequire("g81wt");

var $giewv = parcelRequire("giewv");
const $b1f4e11b9af9bc89$var$buildStoreKey = (portalId, requestCreateId)=>`${portalId || 'undefined'}/${requestCreateId}`;
const $b1f4e11b9af9bc89$var$convertHydratedFieldValuesToInitialValues = (hydratedUrlParamOverrides, fieldStates)=>{
    const fieldStateMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    return Object.fromEntries(Object.entries(hydratedUrlParamOverrides).map(([fieldId, valueOverride])=>{
        const fieldState = fieldStateMap[fieldId];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let overrideValue; // Setting this so TS can pick up the correct return value type
        if (!fieldState) {
            overrideValue = [
                fieldId,
                null
            ];
            return overrideValue;
        }
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.map((value)=>value.value)
                ];
                break;
            case 'userpicker':
            case 'reporter':
                overrideValue = [
                    fieldId,
                    valueOverride.accountId
                ];
                break;
            case 'multiuserpicker':
                {
                    const users = valueOverride;
                    overrideValue = [
                        fieldId,
                        users.map((user)=>user.accountId).join(',')
                    ];
                    break;
                }
            case 'organisationpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.id
                ];
                break;
            case 'entitlementpicker':
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
                break;
            case 'multiservicepicker':
                {
                    const services = valueOverride;
                    overrideValue = [
                        fieldId,
                        services
                    ];
                    break;
                }
            default:
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
        }
        return overrideValue;
    }).filter(([_, initialValue])=>initialValue !== null));
};
function $b1f4e11b9af9bc89$var$reduceReqCreateResponseToState(reqCreateResponse) {
    var _reqCreateResponse$is, _reqCreateResponse$is2;
    const { hydratedUrlParamOverrides: hydratedUrlParamOverrides, portalId: portalId, id: requestCreateId } = reqCreateResponse;
    const storeId = $b1f4e11b9af9bc89$var$buildStoreKey(portalId, requestCreateId);
    const { showRecaptcha: showRecaptcha, siteKey: siteKey, proformaTemplateForm: proformaTemplateForm, form: { name: name, intro: intro, instructions: instructions, descriptionHtml: descriptionHtml, icon: icon, iconUrl: iconUrl } } = reqCreateResponse;
    const form = {
        name: name,
        intro: intro,
        instructions: instructions,
        descriptionHtml: descriptionHtml,
        iconUrl: iconUrl || `${0, $diqlM.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${icon}`,
        captchaEnabled: showRecaptcha,
        sitekey: siteKey
    };
    const kbState = reqCreateResponse.kbs && reqCreateResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            spaceKey: reqCreateResponse.kbs.kbLink.spaceKey,
            labels: reqCreateResponse.kbs.labels,
            projectKey: reqCreateResponse.kbs.projectKey
        }
    } : {};
    const dateFormat = (0, $giewv.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateIfFormat);
    const dateTimeFormat = (0, $giewv.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateTimeIfFormat);
    const firstDay = reqCreateResponse.calendarParams.firstDay;
    const useISO8601WeekNumbers = reqCreateResponse.calendarParams.useISO8601WeekNumbers;
    const fields = (0, $YWCnr.toFieldStates)(reqCreateResponse.fields);
    let initialFieldValues = fields.reduce((values, field)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[field.id] = field.value;
        return values;
    }, {});
    const { lastSavedFormData: lastSavedFormData } = reqCreateResponse;
    if (lastSavedFormData && lastSavedFormData.portalId === portalId && lastSavedFormData.requestId === requestCreateId) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    initialFieldValues = {
        ...initialFieldValues,
        ...lastSavedFormData.formInput
    };
    let urlParamFieldValueOverrides;
    if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)()) {
        urlParamFieldValueOverrides = hydratedUrlParamOverrides;
        if (Object.keys(hydratedUrlParamOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...$b1f4e11b9af9bc89$var$convertHydratedFieldValuesToInitialValues(hydratedUrlParamOverrides, fields)
        };
    } else {
        urlParamFieldValueOverrides = (0, $ay3bN.parseFieldUrlParams)(fields);
        if (Object.keys(urlParamFieldValueOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...urlParamFieldValueOverrides
        };
    }
    const organisationsForCurrentUser = reqCreateResponse.userOrganisations;
    const requestCreateFormState = {
        form: form,
        fields: fields,
        initialFieldValues: initialFieldValues,
        urlParamFieldValueOverrides: urlParamFieldValueOverrides,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        organisationsForCurrentUser: organisationsForCurrentUser,
        firstDay: firstDay,
        useISO8601WeekNumbers: useISO8601WeekNumbers,
        proformaTemplateForm: proformaTemplateForm,
        id: reqCreateResponse.id,
        projectId: reqCreateResponse.projectId,
        issueType: (_reqCreateResponse$is = reqCreateResponse.issueType) === null || _reqCreateResponse$is === void 0 ? void 0 : _reqCreateResponse$is.name,
        issueTypeId: (_reqCreateResponse$is2 = reqCreateResponse.issueType) === null || _reqCreateResponse$is2 === void 0 ? void 0 : _reqCreateResponse$is2.id,
        canBrowseUsers: !!reqCreateResponse.canBrowseUsers,
        canCreateUsers: !!reqCreateResponse.canSubmitWithEmailAddress,
        projectHasProformaForms: !!reqCreateResponse.hasProformaForm,
        proforma: reqCreateResponse.proforma,
        proformaFormIsLoaded: false,
        proformaFormIsDirty: false
    };
    return {
        [storeId]: {
            ...requestCreateFormState,
            ...kbState,
            initialFieldValues: initialFieldValues
        }
    };
}
const $b1f4e11b9af9bc89$export$f7e14415d5a64cdc = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.reqCreate) {
        const portalId = (0, $g81wt.toNumber)(initialModelState.portal && initialModelState.portal.id);
        const initialState = $b1f4e11b9af9bc89$var$reduceReqCreateResponseToState({
            portalId: portalId,
            ...initialModelState.reqCreate,
            hydratedUrlParamOverrides: {}
        });
        // When the jsm_portal_rovo_integration flag is on, pre-fill logic runs in the epic
        // asynchronously. If URL params are present for any field, we need to delay rendering
        // the form until the epic resolves and dispatches FETCH_REQUEST_CREATE_SUCCESS with the
        // hydrated values. Without this, Formik initialises with empty values before the epic
        // completes, and the pre-fill data has no effect.
        if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)()) {
            const storeKey = $b1f4e11b9af9bc89$var$buildStoreKey(portalId, initialModelState.reqCreate.id);
            const formState = initialState[storeKey];
            if (formState) {
                const urlParamOverrides = (0, $ay3bN.parseFieldUrlParams)(formState.fields);
                if (Object.keys(urlParamOverrides).length > 0) return {
                    [storeKey]: {
                        ...formState,
                        prefillPending: true
                    }
                };
            }
        }
        return initialState;
    }
    return {};
};
const $b1f4e11b9af9bc89$var$defaultState = $b1f4e11b9af9bc89$export$f7e14415d5a64cdc();
function $b1f4e11b9af9bc89$export$2e2bcd8739ae039(state = $b1f4e11b9af9bc89$var$defaultState, action) {
    switch(action.type){
        case 0, $1mt5N.FETCH_REQUEST_CREATE_MODEL:
            {
                const requestCreateId = action.payload.params && action.payload.params.id;
                const portalId = action.payload.params && action.payload.params.portalId;
                if (requestCreateId && portalId) {
                    const storeId = $b1f4e11b9af9bc89$var$buildStoreKey(portalId, requestCreateId);
                    const requestCreate = state[storeId];
                    if (requestCreate && 'error' in requestCreate) {
                        const newState = {
                            ...state
                        };
                        delete newState[storeId];
                        return newState;
                    }
                }
                return state;
            }
        case 0, $1mt5N.FETCH_REQUEST_CREATE_FAILURE:
            {
                const { error: error, portalId: portalId, requestCreateId: requestCreateId } = action.payload;
                const storeId = $b1f4e11b9af9bc89$var$buildStoreKey(portalId, requestCreateId);
                return {
                    ...state,
                    [storeId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders,
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || ''
                        }
                    }
                };
            }
        case 0, $1mt5N.FETCH_REQUEST_CREATE_SUCCESS:
            return {
                ...state,
                ...$b1f4e11b9af9bc89$var$reduceReqCreateResponseToState(action.payload)
            };
        case 0, $1mt5N.PROFORMA_FORM_DIRTY:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, isDirty: isDirty } = action.payload;
                const storeId = $b1f4e11b9af9bc89$var$buildStoreKey(portalId, requestTypeId);
                if (!state[storeId]) return state;
                return {
                    ...state,
                    [storeId]: {
                        ...state[storeId],
                        proformaFormIsDirty: isDirty
                    }
                };
            }
        case 0, $1mt5N.RESET_REQUEST_CREATE_STATE:
            // Reset the state to the default initial state
            return $b1f4e11b9af9bc89$export$f7e14415d5a64cdc();
        default:
            return state;
    }
}

});
parcelRegister("g81wt", function(module, exports) {
$parcel$export(module.exports, "toNumber", () => $6afb4366f8d2a349$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "toString", () => $6afb4366f8d2a349$export$f84e8e69fd4488a5);
// This exists as a shorthand func to return a default value if the parsed
// string was somehow not a valid number.
const $6afb4366f8d2a349$export$a0a81dc3380ce7d3 = (str, defaultValue)=>{
    if (typeof str === 'number') return str;
    if (str) {
        const parsedNumber = parseInt(str, 10);
        if (!isNaN(parsedNumber)) return parsedNumber;
    }
    return defaultValue;
};
const $6afb4366f8d2a349$export$f84e8e69fd4488a5 = (num)=>{
    if (num) return String(num);
    return undefined;
};

});

parcelRegister("giewv", function(module, exports) {
$parcel$export(module.exports, "convertToDateFnsFormat", () => $e2aa80aa8dfd17e4$export$e007e5b3b423e0a6);
$parcel$export(module.exports, "splitDateTimeFormat", () => $e2aa80aa8dfd17e4$export$b565d8b0afadc612);
/**
 * Utility to convert a subset of the unix date time format to data-fns.
 * Date-fns format: https://date-fns.org/v2.30.0/docs/format
 * Unix date time format: http://old-www.cs.dartmouth.edu/~cs50/data/tse/wikipedia/wiki/Date_(Unix).html#Formatting
 */ /**
 * This is a mapping of all equivalent time formats between unix and date-fns.
 *
 * There are a number of commented out unix time formats, these are the unix time formats that we don't support. There are no
 * direct equivalent for any of these between unix time format and date fns. I have left the closest matching date fns time format
 * for each of these keys if there are any, or I marked it as INCOMPATIBLE if there are no date fns that even remotely matches the
 * unix time format.
 */ const $e2aa80aa8dfd17e4$var$UNIX_TO_DATE_FNS_MAPPING = {
    '%a': 'iii',
    '%A': 'iiii',
    '%d': 'dd',
    '%e': 'd',
    '%j': 'DDD',
    '%u': 'i',
    // '%w': 'd',
    // '%U': 'WW',
    // '%W': 'WW',
    '%V': 'II',
    '%m': 'MM',
    '%h': 'MMM',
    '%b': 'MMM',
    '%B': 'MMMM',
    '%y': 'yy',
    '%Y': 'yyyy',
    // '%g': 'YY',
    // '%G': 'YYYY',
    // '%C': 'INCOMPATIBLE',
    '%D': 'MM/dd/yy',
    // '%x': "INCOMPATIBLE",
    '%F': 'yyyy-MM-dd',
    '%l': 'h',
    '%I': 'hh',
    '%k': 'H',
    '%H': 'HH',
    '%p': 'a',
    '%P': 'aaaa',
    '%M': 'mm',
    '%s': 't',
    '%S': 'ss',
    // '%N': 'INCOMPATIBLE',
    '%r': 'hh:mm:ss',
    '%R': 'HH:mm',
    '%T': 'HH:mm:ss',
    // '%X': 'INCOMPATIBLE',
    // '%c': 'INCOMPATIBLE',
    '%z': 'xx'
};
/**
 * These are the date-fns characters that are associated with 'time', time in this case refers to hour, minute, second and timezone.
 * This is used by splitDateTimeFormat to determine which sections of a date format is associated with time and which are associated  * with day.
 * This list IS case sensitive as capital M is month and not minute, see https://date-fns.org/v2.30.0/docs/format for full list.
 */ const $e2aa80aa8dfd17e4$var$LIST_OF_TIME_CHARS = [
    'h',
    // Hour
    'H',
    // Hour
    'm',
    // Minute (NOTE: capital M is month not minute)
    's',
    // Second
    'S',
    // Part of a second
    'a',
    // AM PM
    'xxx',
    // Timezone
    't',
    // Timestamp
    'T' // Timestamp
];
// eslint-disable-next-line no-useless-escape
const $e2aa80aa8dfd17e4$var$unixTimeFormatTokenRegex = /\%\w/gi;
const $e2aa80aa8dfd17e4$var$escapeRegExp = (literalString)=>literalString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string;
/**
 * Converts a unix date time format to its closest equivalent in date-fns format
 * @param unixDateTimeFormat The unix date time format you want to convert
 */ function $e2aa80aa8dfd17e4$export$e007e5b3b423e0a6(unixDateTimeFormat) {
    let transformedString = unixDateTimeFormat;
    const incompatibleFormatString = [];
    const matches = unixDateTimeFormat.match($e2aa80aa8dfd17e4$var$unixTimeFormatTokenRegex);
    if (matches) matches.forEach((match)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const equivalentDateFnsFunctionString = $e2aa80aa8dfd17e4$var$UNIX_TO_DATE_FNS_MAPPING[match];
        if (equivalentDateFnsFunctionString) // Replaces all cases of the match with it's equivalent in date-fns time format
        transformedString = transformedString.replace(new RegExp($e2aa80aa8dfd17e4$var$escapeRegExp(match), 'g'), equivalentDateFnsFunctionString);
        else incompatibleFormatString.push(match);
    });
    return transformedString;
}
/**
 * Naively splits a date fns time format between date and time components. It is split by matching each individual character
 * Naively in this case means that there is a distinct separate between date and time, i.e. they're not mixed in between each other.
 */ function $e2aa80aa8dfd17e4$export$b565d8b0afadc612(dateFnsTimeFormat) {
    const matches = dateFnsTimeFormat.match(/\w/g);
    let lastMatchType;
    let indexOfMatchTypeChange = dateFnsTimeFormat.length;
    if (matches) {
        for (const match of matches){
            // We assume that any keys that are not time keys are used to represent date, date in this case refers to years, months, weeks and days
            const isTime = $e2aa80aa8dfd17e4$var$LIST_OF_TIME_CHARS.includes(match);
            const matchType = isTime ? 'time' : 'date';
            if (!lastMatchType) lastMatchType = matchType;
            else if (matchType !== lastMatchType) {
                // If the match type has changed, i.e. from date -> time or from time -> date we will stop and use this match to
                // split the date time to date and time.
                indexOfMatchTypeChange = dateFnsTimeFormat.indexOf(match);
                break;
            }
        }
        if (lastMatchType === 'date') // If we went from date -> time
        return {
            dateFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            timeFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
        // splitDateTimeFormat went from time -> date
        return {
            timeFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            dateFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
    }
    return {
        timeFormat: 'hh:mm a',
        dateFormat: 'yyyy-MM-dd'
    };
}

});



parcelRegister("huFmW", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("aUmTb")).requestDetailsReducer);

var $aUmTb = parcelRequire("aUmTb");

});
parcelRegister("aUmTb", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => $f079c786ec606937$export$dfa3e5ac1f5274b8);

var $aYMdQ = parcelRequire("aYMdQ");

var $9xUrm = parcelRequire("9xUrm");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $f079c786ec606937$export$efef4e30b826ddbf = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.reqDetails) return {
        [initialModelState.reqDetails.key]: initialModelState.reqDetails
    };
    return {};
};
const $f079c786ec606937$var$defaultState = $f079c786ec606937$export$efef4e30b826ddbf();
function $f079c786ec606937$export$dfa3e5ac1f5274b8(state = $f079c786ec606937$var$defaultState, action) {
    switch(action.type){
        case 0, $kV2FF.FETCH_REQUEST_DETAILS_MODEL:
            return $f079c786ec606937$var$handleFetchRequestDetailsModel(state, action);
        case 0, $kV2FF.FETCH_REQUEST_DETAILS_FAILURE:
            return $f079c786ec606937$var$handleFetchRequestDetailsFailureAction(state, action);
        case 0, $kV2FF.FETCH_REQUEST_DETAILS_SUCCESS:
            return $f079c786ec606937$var$handleFetchRequestDetailsSuccessAction(state, action);
        case 0, $kV2FF.CREATE_COMMENT_SUCCESS:
            return $f079c786ec606937$var$handleCreateCommentSuccessAction(state, action);
        case 0, $kV2FF.CHANGE_SUBSCRIPTION_SUCCESS:
            return $f079c786ec606937$var$handleChangeSubscriptionSuccessAction(state, action);
        case 0, $kV2FF.REMOVE_PARTICIPANT_SUCCESS:
            return $f079c786ec606937$var$handleRemoveParticipant(state, action);
        case 0, $kV2FF.REMOVE_ORGANISATION_SUCCESS:
            return $f079c786ec606937$var$handleRemoveOrganisation(state, action);
        case 0, $kV2FF.GET_MEDIA_READ_CREDENTIALS_SUCCESS:
            return $f079c786ec606937$var$handleGetReadCredentialsSuccess(state, action);
        case 0, $kV2FF.ADD_PARTICIPANTS_SUCCESS:
            return $f079c786ec606937$var$handleAddParticipantsSuccess(state, action);
        default:
            return state;
    }
}
function $f079c786ec606937$var$handleFetchRequestDetailsModel(state, action) {
    const requestKey = action.payload.params.key;
    if (requestKey) {
        const requestDetails = state[requestKey];
        if (requestDetails && 'error' in requestDetails) {
            const newState = {
                ...state
            };
            delete newState[requestKey];
            return newState;
        }
    }
    return state;
}
function $f079c786ec606937$var$handleFetchRequestDetailsFailureAction(state, action) {
    const { requestKey: requestKey, error: error } = action.payload;
    const errorObject = {
        // We really only care about the first error message
        // grab it and throw the rest away
        status: error.status,
        message: (error.errorMessages || [])[0] || '',
        // Remove basename from the URL, we don't need it as the basename
        // is already set inside react router.
        // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
        callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    return {
        ...state,
        [requestKey]: {
            error: errorObject
        }
    };
}
function $f079c786ec606937$var$populateWithPreexistingState(preExistingRequestDetails, response) {
    let preExistingProperties;
    if (preExistingRequestDetails && !('error' in preExistingRequestDetails)) {
        if (preExistingRequestDetails.userMentionedDuringRequestCreation) preExistingProperties = {
            participants: (0, $aYMdQ.uniqBy)([
                ...preExistingRequestDetails.participants,
                ...response.participants
            ], 'accountId'),
            userMentionedDuringRequestCreation: false
        };
    }
    return preExistingProperties;
}
function $f079c786ec606937$var$handleFetchRequestDetailsSuccessAction(state, action) {
    const response = action.payload;
    const requestKey = response.key;
    const preExistingProperties = $f079c786ec606937$var$populateWithPreexistingState(state[requestKey], response);
    return {
        ...state,
        [requestKey]: {
            ...response,
            ...preExistingProperties
        }
    };
}
function $f079c786ec606937$var$handleChangeSubscriptionSuccessAction(state, action) {
    const { requestKey: requestKey, shouldSubscribe: shouldSubscribe } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) {
        let newSubscribeAction = (0, $9xUrm.SUBSCRIBE_ACTION_KEY);
        if (shouldSubscribe) newSubscribeAction = (0, $9xUrm.UNSUBSCRIBE_ACTION_KEY);
        return {
            ...state,
            [requestKey]: {
                ...requestDetails,
                subscribeAction: newSubscribeAction
            }
        };
    }
    return state;
}
function $f079c786ec606937$var$handleCreateCommentSuccessAction(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                activityStream: [
                    ...requestDetails.issue.activityStream,
                    response.comment
                ],
                status: response.status
            }
        }
    };
    return state;
}
function $f079c786ec606937$var$handleRemoveOrganisation(state, action) {
    const { requestKey: requestKey, organisationId: organisationId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            organisations: requestDetails.organisations.filter((organisation)=>organisation.id !== organisationId),
            issue: {
                ...requestDetails.issue,
                organisations: requestDetails.issue.organisations.filter((organisation)=>organisation.id !== organisationId)
            }
        }
    };
    return state;
}
const $f079c786ec606937$var$filterRemovedParticipant = (participants, removedUserAccountId)=>participants.filter((participant)=>participant.accountId !== removedUserAccountId);
function $f079c786ec606937$var$handleRemoveParticipant(state, action) {
    const { requestKey: requestKey, accountId: accountId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            participants: $f079c786ec606937$var$filterRemovedParticipant(requestDetails.participants, accountId),
            issue: {
                ...requestDetails.issue,
                participants: $f079c786ec606937$var$filterRemovedParticipant(requestDetails.issue.participants, accountId)
            }
        }
    };
    return state;
}
function $f079c786ec606937$var$handleGetReadCredentialsSuccess(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            readFileMediaCredentials: response
        }
    };
    return state;
}
function $f079c786ec606937$var$handleAddParticipantsSuccess(state, action) {
    const { requestKey: requestKey, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation, addParticipantsSuccessResponse: addParticipantsSuccessResponse } = action.payload;
    const requestDetails = state[requestKey];
    const { participants: updatedParticipants, organisations: updatedOrganisations } = addParticipantsSuccessResponse;
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                participants: updatedParticipants,
                organisations: updatedOrganisations
            },
            participants: updatedParticipants,
            organisations: updatedOrganisations
        }
    };
    if (!requestDetails && userMentionedDuringRequestCreation) return {
        ...state,
        [requestKey]: {
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            issue: {
                participants: updatedParticipants,
                activityStream: [],
                fields: []
            },
            participants: updatedParticipants,
            approvalStatus: []
        }
    };
    return state;
}

});
parcelRegister("9xUrm", function(module, exports) {
$parcel$export(module.exports, "SUBSCRIBE_ACTION_KEY", () => $bdb588ef495f0bf0$export$2f3123aa49f16a3c);
$parcel$export(module.exports, "UNSUBSCRIBE_ACTION_KEY", () => $bdb588ef495f0bf0$export$5a45f83be8b212b8);
const $bdb588ef495f0bf0$export$2f3123aa49f16a3c = 'subscribe';
const $bdb588ef495f0bf0$export$5a45f83be8b212b8 = 'unsubscribe';
const $bdb588ef495f0bf0$export$f10e0fb31f869e32 = 'none';

});



parcelRegister("fDFdh", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("ejEYa")).requestListReducer);

var $ejEYa = parcelRequire("ejEYa");

});
parcelRegister("ejEYa", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $959be30107ce2b5e$export$476a1a148617ffd3);
parcelRequire("evnRm");
var $4H6hH = parcelRequire("4H6hH");

var $bKaMP = parcelRequire("bKaMP");

var $hN5YJ = parcelRequire("hN5YJ");
const $959be30107ce2b5e$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    }
};
const $959be30107ce2b5e$export$c1708a8d295610ca = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.allReqFilter) {
        const { resultsPerPage: resultsPerPage, totalResults: totalResults, sortBy: sortBy, sortOrder: sortOrder, requestList: requestList, nextToken: nextToken } = initialModelState.allReqFilter;
        const baseState = {
            resultsPerPage: resultsPerPage,
            totalResults: totalResults,
            sortBy: sortBy,
            sortOrder: sortOrder,
            pages: {
                isInitialPageLoad: true,
                [initialModelState.allReqFilter.selectedPage]: requestList
            }
        };
        if ((0, $hN5YJ.isRequestListInfiniteScrollEnabled)()) {
            baseState.nextToken = nextToken;
            baseState.allRows = requestList ?? [];
            baseState.filter = initialModelState.allReqFilter.filter ?? '';
        }
        return baseState;
    }
    return $959be30107ce2b5e$var$emptyState;
};
const $959be30107ce2b5e$var$defaultState = $959be30107ce2b5e$export$c1708a8d295610ca();
function $959be30107ce2b5e$export$476a1a148617ffd3(state = $959be30107ce2b5e$var$defaultState, action) {
    switch(action.type){
        case 0, $4H6hH.FETCH_REQUEST_LIST_SUCCESS:
            return $959be30107ce2b5e$var$handleFetchRequestListSuccess(state, action);
        case 0, $4H6hH.MARK_INITIAL_PAGE_LOAD_RENDERED:
            return $959be30107ce2b5e$var$handleMarkInitialPageLoadRendered(state);
        case 0, $4H6hH.INVALIDATE_PAGES:
            return $959be30107ce2b5e$var$handleInvalidatePages(state, action);
        default:
            return state;
    }
}
function $959be30107ce2b5e$var$handleInvalidatePages(state, action) {
    const currentPage = action.payload;
    return {
        ...state,
        pages: {
            isInitialPageLoad: false,
            [currentPage]: state.pages[currentPage]
        }
    };
}
function $959be30107ce2b5e$var$handleFetchRequestListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder || response.totalResults !== state.totalResults || response.filter !== state.filter;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requestList.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requestList : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        sortBy: response.sortBy,
        sortOrder: response.sortOrder,
        nextToken: response.nextToken,
        filter: response.filter,
        allRows: newRows,
        // The `pages` object (keyed by selectedPage) is only used by the non-infinite-scroll
        // pagination path. In the infinite scroll path, `allRows` is the canonical source of
        // truth for all fetched rows, so we do not populate `pages[selectedPage]` here.
        // Doing so would store stale page-indexed data that is never consumed by infinite
        // scroll consumers, and `selectedPage` is irrelevant in nextToken-based pagination.
        pages: {
            isInitialPageLoad: false
        }
    };
}
function $959be30107ce2b5e$var$handleFetchRequestListSuccess(state, action) {
    if ((0, $hN5YJ.isRequestListInfiniteScrollEnabled)()) return $959be30107ce2b5e$var$handleFetchRequestListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) {
            if (response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder) {
                if (response.selectedPage === 1) return {
                    ...state,
                    sortOrder: response.sortOrder,
                    sortBy: response.sortBy,
                    pages: {
                        isInitialPageLoad: false,
                        [response.selectedPage]: response.requestList
                    }
                };
            }
            return {
                ...state,
                pages: {
                    ...state.pages,
                    isInitialPageLoad: false,
                    [response.selectedPage]: response.requestList
                }
            };
        }
        return {
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            sortBy: response.sortBy,
            sortOrder: response.sortOrder,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requestList
            }
        };
    }
    return state;
}
const $959be30107ce2b5e$var$handleMarkInitialPageLoadRendered = (state)=>({
        ...state,
        pages: {
            ...state.pages,
            isInitialPageLoad: false
        }
    });

});


parcelRegister("ifzIY", function(module, exports) {
$parcel$export(module.exports, "reqSlasReducer", () => (parcelRequire("aa2cM")).reqSlasReducer);

var $aa2cM = parcelRequire("aa2cM");

});
parcelRegister("aa2cM", function(module, exports) {
$parcel$export(module.exports, "reqSlasReducer", () => $8d4f94759ce19bc4$export$55a46cf03dbe4d53);

var $bKaMP = parcelRequire("bKaMP");
parcelRequire("plzke");
var $gJbwY = parcelRequire("gJbwY");
const $8d4f94759ce19bc4$export$3bc01640ec2791f4 = ()=>{
    const { reqDetails: reqDetails, reqSlas: reqSlas } = (0, $bKaMP.default)();
    return reqDetails && reqSlas ? {
        [reqDetails.key]: reqSlas
    } : {};
};
const $8d4f94759ce19bc4$export$55a46cf03dbe4d53 = (state = $8d4f94759ce19bc4$export$3bc01640ec2791f4(), action)=>{
    switch(action.type){
        case 0, $gJbwY.UPDATE_REQ_SLAS_MODEL:
            return {
                ...state,
                [action.payload.requestKey]: action.payload.reqSlas
            };
        default:
            return state;
    }
};

});


parcelRegister("jOkQU", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionReducer", () => (parcelRequire("2MQfX")).default);
/**
 * This should be normalized with the normal request type model at some point
 */ 
var $2MQfX = parcelRequire("2MQfX");

});
parcelRegister("2MQfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e43ff2f4d605ca4f$export$2e2bcd8739ae039);
parcelRequire("d6CKA");
var $7dQWi = parcelRequire("7dQWi");

var $diqlM = parcelRequire("diqlM");
const $e43ff2f4d605ca4f$var$defaultState = {
    suggestions: [],
    isLoaded: false
};
function $e43ff2f4d605ca4f$export$2e2bcd8739ae039(state = $e43ff2f4d605ca4f$var$defaultState, action) {
    switch(action.type){
        case 0, $7dQWi.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL:
            // When we are making a new request for the request type model we will reset the state
            return {
                suggestions: [],
                isLoaded: false
            };
        case 0, $7dQWi.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS:
            {
                const requestTypeSuggestions = action.payload.map((suggestion)=>{
                    const requestTypeId = parseInt(String(suggestion.id), 10);
                    return {
                        id: requestTypeId,
                        portalId: suggestion.cvId,
                        portalName: suggestion.portalName,
                        name: suggestion.name,
                        descriptionHtml: suggestion.descriptionHtml,
                        iconUrl: suggestion.iconUrl || `${0, $diqlM.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${suggestion.icon}`
                    };
                });
                return {
                    suggestions: requestTypeSuggestions,
                    isLoaded: true
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("1wPHB", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("gm7O6")).resetPasswordReducer);

var $gm7O6 = parcelRequire("gm7O6");

});
parcelRegister("gm7O6", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $c3e04d74eb49b77a$export$b0c3be5071e95c02);

var $bKaMP = parcelRequire("bKaMP");
const $c3e04d74eb49b77a$var$defaultState = {
    emailAddress: undefined,
    username: undefined,
    resetPasswordJwt: undefined
};
const $c3e04d74eb49b77a$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.resetPassword) return {
        ...$c3e04d74eb49b77a$var$defaultState,
        ...initialModelState.resetPassword
    };
    return $c3e04d74eb49b77a$var$defaultState;
};
const $c3e04d74eb49b77a$export$b0c3be5071e95c02 = (state = $c3e04d74eb49b77a$export$53ac33307b5acee9())=>state;

});


parcelRegister("h366n", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => (parcelRequire("6Tf6K")).signUpReducer);

var $6Tf6K = parcelRequire("6Tf6K");

});
parcelRegister("6Tf6K", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => $043d68143d15c4b7$export$a3d522c435cab174);
parcelRequire("eDtG6");
var $5Eeij = parcelRequire("5Eeij");

var $dbYz0 = parcelRequire("dbYz0");

var $bKaMP = parcelRequire("bKaMP");
const $043d68143d15c4b7$var$defaultState = {
    authInfo: {
        accountStage: (0, $dbYz0.AccountStageType).SIGNUP,
        authMethods: new Map([
            [
                (0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    emailAddress: null,
    requestKey: null,
    requestSummary: null
};
const $043d68143d15c4b7$var$getInitialState = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.signUp && initialModelState.signUp.emailAddress) return {
        ...$043d68143d15c4b7$var$defaultState,
        ...initialModelState.signUp
    };
    return $043d68143d15c4b7$var$defaultState;
};
const $043d68143d15c4b7$export$a3d522c435cab174 = (state = $043d68143d15c4b7$var$getInitialState(), action)=>{
    switch(action.type){
        case 0, $5Eeij.SET_SIGN_UP_DATA:
            return {
                ...state,
                emailAddress: action.payload.email,
                authInfo: action.payload.authInfo
            };
        default:
            return state;
    }
};

});


parcelRegister("6OSNu", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => (parcelRequire("75OBY")).timezonesReducer);

var $75OBY = parcelRequire("75OBY");

});
parcelRegister("75OBY", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => $9c7ad27b6ef656b1$export$98e58b85fdd67f49);
parcelRequire("jBSrG");
var $itms7 = parcelRequire("itms7");

var $bKaMP = parcelRequire("bKaMP");
const $9c7ad27b6ef656b1$export$84faa4a7b0294c11 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState) return {
        timezoneRegions: initialModelState.timezoneRegions || [],
        timezones: initialModelState.timezones || []
    };
    return {
        timezoneRegions: [],
        timezones: []
    };
};
const $9c7ad27b6ef656b1$var$defaultState = $9c7ad27b6ef656b1$export$84faa4a7b0294c11();
function $9c7ad27b6ef656b1$export$98e58b85fdd67f49(state = $9c7ad27b6ef656b1$var$defaultState, action) {
    switch(action.type){
        case 0, $itms7.FETCH_TIMEZONES_SUCCESS:
            return $9c7ad27b6ef656b1$var$handleFetchTimezonesSuccess(state, action);
        case 0, $itms7.FETCH_TIMEZONE_REGIONS_SUCCESS:
            return $9c7ad27b6ef656b1$var$handleFetchTimezoneRegionsSuccess(state, action);
        default:
            return state;
    }
}
const $9c7ad27b6ef656b1$var$handleFetchTimezonesSuccess = (state, action)=>({
        ...state,
        timezones: action.payload.timezones
    });
const $9c7ad27b6ef656b1$var$handleFetchTimezoneRegionsSuccess = (state, action)=>({
        ...state,
        timezoneRegions: action.payload.timezoneRegions
    });

});


parcelRegister("7gEH8", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => (parcelRequire("bOeP3")).uiModificationsReducer);

var $bOeP3 = parcelRequire("bOeP3");

});
parcelRegister("bOeP3", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => $2cd64e7733e5b657$export$821013f52f243078);
parcelRequire("6afVg");
var $aXlr1 = parcelRequire("aXlr1");
const $2cd64e7733e5b657$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $2cd64e7733e5b657$var$defaultState = {};
function $2cd64e7733e5b657$export$821013f52f243078(state = $2cd64e7733e5b657$var$defaultState, action) {
    switch(action.type){
        case 0, $aXlr1.FETCH_UI_MODIFICATIONS_SUCCESS:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, uiModifications: uiModifications } = action.payload;
                const storeKey = $2cd64e7733e5b657$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: uiModifications,
                        error: undefined
                    }
                };
            }
        case 0, $aXlr1.FETCH_UI_MODIFICATIONS_FAILURE:
            {
                var _error$errorMessages;
                const { portalId: portalId, requestTypeId: requestTypeId, error: error } = action.payload;
                const storeKey = $2cd64e7733e5b657$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: undefined,
                        error: ((_error$errorMessages = error.errorMessages) === null || _error$errorMessages === void 0 ? void 0 : _error$errorMessages[0]) ?? 'Failed to fetch UI modifications'
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("ikZEU", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => (parcelRequire("bhXhS")).unsubscribedConfirmationReducer);

var $bhXhS = parcelRequire("bhXhS");

});
parcelRegister("bhXhS", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => $1b772eb6b2f7fc4b$export$ac175372d3d2c582);

var $eJwdb = parcelRequire("eJwdb");
parcelRequire("ay41d");
var $eog6E = parcelRequire("eog6E");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $1b772eb6b2f7fc4b$export$c8b25b5da8be069b = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.unsubscribedConfirmation) return {
        unsubscribedConfirmation: initialModelState.unsubscribedConfirmation
    };
    return {};
};
const $1b772eb6b2f7fc4b$var$defaultState = $1b772eb6b2f7fc4b$export$c8b25b5da8be069b();
function $1b772eb6b2f7fc4b$export$ac175372d3d2c582(state = $1b772eb6b2f7fc4b$var$defaultState, action) {
    switch(action.type){
        case 0, $eJwdb.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL:
            {
                const unsubscribedConfirmation = state.unsubscribedConfirmation;
                if (unsubscribedConfirmation && 'error' in unsubscribedConfirmation) return {};
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $eog6E.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    ...state,
                    unsubscribedConfirmation: {
                        error: errorObject
                    }
                };
            }
        case 0, $eog6E.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const requestKey = fetchPortalSuccessAction.payload.requestKey;
                const unsubscribedConfirmation = {
                    requestKey: requestKey,
                    requestUrl: fetchPortalSuccessAction.payload.requestUrl,
                    summary: fetchPortalSuccessAction.payload.summary
                };
                return {
                    ...state,
                    unsubscribedConfirmation: unsubscribedConfirmation
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("3iwCc", function(module, exports) {
$parcel$export(module.exports, "userReducer", () => (parcelRequire("2MJkf")).default);

var $2MJkf = parcelRequire("2MJkf");

});
parcelRegister("2MJkf", function(module, exports) {
$parcel$export(module.exports, "default", () => $70fd8e5310f67cda$export$2e2bcd8739ae039);
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");

var $44fTH = parcelRequire("44fTH");

var $8s5M7 = parcelRequire("8s5M7");

var $bKaMP = parcelRequire("bKaMP");
function $70fd8e5310f67cda$var$reduceResponseToState(userResponse) {
    const state = {
        language: {
            key: (0, $8s5M7.ensureConsistentKey)(userResponse.language.key),
            originalKey: userResponse.language.key,
            displayName: userResponse.language.displayName
        },
        storedLanguage: {
            key: (0, $8s5M7.ensureConsistentKey)(userResponse.storedLanguage.key),
            originalKey: userResponse.storedLanguage.key,
            displayName: userResponse.storedLanguage.displayName
        },
        timezone: {
            id: userResponse.timezone.id,
            regionKey: userResponse.timezone.regionKey,
            city: userResponse.timezone.city,
            gmtOffset: userResponse.timezone.gmtOffset
        },
        avatars: userResponse.avatars,
        userRequests: {},
        isLoaded: true,
        isLoggedIn: !!userResponse.accountId,
        customMenuLinks: userResponse.customMenuLinks ? userResponse.customMenuLinks : [],
        canAdministerJIRA: userResponse.canAdministerJIRA,
        hasSiteAdministerAccess: userResponse.hasSiteAdministerAccess ?? false,
        agentForPortal: userResponse.agentForPortal,
        accountId: userResponse.accountId,
        displayName: userResponse.displayName,
        email: userResponse.email,
        atlassianAccountManaged: userResponse.atlassianAccountManaged,
        scimManaged: userResponse.scimManaged ?? false,
        externalCustomer: userResponse.externalCustomer
    };
    return state;
}
const $70fd8e5310f67cda$export$180605366c04f0cd = ()=>$44fTH.getMeta('user-locale') || $44fTH.getMeta('ajs-user-locale') || '';
const $70fd8e5310f67cda$var$getInitialUserState = ()=>{
    const initialState = (0, $bKaMP.default)();
    if (initialState && initialState.user) return $70fd8e5310f67cda$var$reduceResponseToState(initialState.user);
    return undefined;
};
const $70fd8e5310f67cda$var$anonymousState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $8s5M7.ensureConsistentKey)($70fd8e5310f67cda$export$180605366c04f0cd()),
        originalKey: $70fd8e5310f67cda$export$180605366c04f0cd(),
        displayName: $70fd8e5310f67cda$export$180605366c04f0cd()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $8s5M7.ensureConsistentKey)($70fd8e5310f67cda$export$180605366c04f0cd()),
        originalKey: $70fd8e5310f67cda$export$180605366c04f0cd(),
        displayName: $70fd8e5310f67cda$export$180605366c04f0cd()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: true,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false
};
const $70fd8e5310f67cda$var$defaultState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $8s5M7.ensureConsistentKey)($70fd8e5310f67cda$export$180605366c04f0cd()),
        originalKey: $70fd8e5310f67cda$export$180605366c04f0cd(),
        displayName: $70fd8e5310f67cda$export$180605366c04f0cd()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $8s5M7.ensureConsistentKey)($70fd8e5310f67cda$export$180605366c04f0cd()),
        originalKey: $70fd8e5310f67cda$export$180605366c04f0cd(),
        displayName: $70fd8e5310f67cda$export$180605366c04f0cd()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: false,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false,
    // Initial user state spreads _last_ just in case there are things on the server that should
    // override initial (local) state.
    ...$70fd8e5310f67cda$var$getInitialUserState()
};
function $70fd8e5310f67cda$export$2e2bcd8739ae039(state = $70fd8e5310f67cda$var$defaultState, action) {
    switch(action.type){
        case 0, $7m3Xa.UPDATE_USER_MODEL:
            {
                const userResponse = action.payload;
                const newState = $70fd8e5310f67cda$var$reduceResponseToState(userResponse);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $7m3Xa.UPDATE_USER_TO_ANON:
            return {
                ...$70fd8e5310f67cda$var$anonymousState
            };
        case 0, $7m3Xa.SAVE_USER_PROFILE_SUCCESS:
            return $70fd8e5310f67cda$var$handleUpdateUserProfileSuccessAction(state, action);
        case 0, $7m3Xa.SUCCESSFULLY_LOGGED_IN:
            return $70fd8e5310f67cda$var$handleSuccessfullyLoggedIn(state);
        default:
            return state;
    }
}
function $70fd8e5310f67cda$var$handleUpdateUserProfileSuccessAction(state, action) {
    const displayName = action.payload.displayName || state.displayName;
    const language = action.payload.language || state.storedLanguage;
    const timezone = action.payload.timezone || state.timezone;
    return {
        ...state,
        displayName: displayName,
        timezone: timezone,
        storedLanguage: {
            key: (0, $8s5M7.ensureConsistentKey)(language.originalKey),
            originalKey: language.originalKey,
            displayName: language.displayName
        }
    };
}
const $70fd8e5310f67cda$var$handleSuccessfullyLoggedIn = (state)=>({
        ...state,
        isLoggedIn: true
    });

});


parcelRegister("6MEO1", function(module, exports) {
$parcel$export(module.exports, "userRequestsCountsReducer", () => (parcelRequire("4LSIm")).default);

var $4LSIm = parcelRequire("4LSIm");

});
parcelRegister("4LSIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfc82a9b762119af$export$2e2bcd8739ae039);
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");
function $dfc82a9b762119af$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 0, $7m3Xa.UPDATE_USER_REQUESTS_COUNTS_MODEL:
            {
                const userRequestCountResponse = action.payload;
                return {
                    myRequestCount: userRequestCountResponse.allOpenRequestsCount,
                    pendingApprovalCount: userRequestCountResponse.pendingApprovalsCount,
                    approvalCount: userRequestCountResponse.approvalsCount
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("hSY5L", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => (parcelRequire("kULOY")).verifyEmailReducer);

var $kULOY = parcelRequire("kULOY");

});
parcelRegister("kULOY", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => $f9e5f8fa1aad45c4$export$681ecd52c505c479);

var $glkRu = parcelRequire("glkRu");

var $bKaMP = parcelRequire("bKaMP");
const $f9e5f8fa1aad45c4$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: (0, $glkRu.SUCCESSFUL_VERIFICATION_OUTCOMES).SUCCEEDED,
    portalName: null,
    portalId: null
};
const $f9e5f8fa1aad45c4$export$681ecd52c505c479 = (state = $f9e5f8fa1aad45c4$export$53ac33307b5acee9())=>state;
const $f9e5f8fa1aad45c4$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.verifyEmail) return initialModelState.verifyEmail;
    return $f9e5f8fa1aad45c4$var$defaultState;
};

});
parcelRegister("glkRu", function(module, exports) {
$parcel$export(module.exports, "FAILED_VERIFICATION_OUTCOMES", () => $4f42b7fc1366bfbf$export$d054ec592d4dac6f);
$parcel$export(module.exports, "SUCCESSFUL_VERIFICATION_OUTCOMES", () => $4f42b7fc1366bfbf$export$a94c4b05d26d720a);
const $4f42b7fc1366bfbf$export$d054ec592d4dac6f = {
    IDENTITY_ERROR: 'IDENTITY_ERROR',
    TOKEN_INVALID: 'TOKEN_INVALID',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    PROCESSING_ERROR: 'PROCESSING_ERROR'
};
const $4f42b7fc1366bfbf$export$a94c4b05d26d720a = {
    SUCCEEDED: 'SUCCEEDED'
};

});



parcelRegister("kLOyD", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => (parcelRequire("2Cd5i")).visitPortalReducer);

var $2Cd5i = parcelRequire("2Cd5i");

});
parcelRegister("2Cd5i", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => $3955d8307549cd0e$export$8f27b2a880eeba34);
parcelRequire("6ukid");
var $fdqjK = parcelRequire("fdqjK");

var $diqlM = parcelRequire("diqlM");

var $bKaMP = parcelRequire("bKaMP");
const $3955d8307549cd0e$var$defaultState = {
    loggedInBeforeCheck: false,
    email: '',
    portalName: '',
    initialError: undefined,
    setPasswordJwt: undefined
};
const $3955d8307549cd0e$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    if (initialModelState && initialModelState.visitPortal) return initialModelState.visitPortal;
    return $3955d8307549cd0e$var$defaultState;
};
function $3955d8307549cd0e$export$8f27b2a880eeba34(state = $3955d8307549cd0e$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $fdqjK.FETCH_VISIT_PORTAL_SUCCESS:
            return $3955d8307549cd0e$var$handleFetchVisitPortalSuccess(state, action);
        case 0, $fdqjK.FETCH_VISIT_PORTAL_FAILURE:
            return $3955d8307549cd0e$var$handleFetchVisitPortalFailure(state, action);
        default:
            return state;
    }
}
function $3955d8307549cd0e$var$handleFetchVisitPortalSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        loggedInBeforeCheck: response.loggedInBeforeCheck,
        email: response.email,
        portalName: response.portalName,
        setPasswordJwt: response.setPasswordJwt
    };
}
function $3955d8307549cd0e$var$handleFetchVisitPortalFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $diqlM.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});



parcelRegister("d6WEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f13874ef2d4c5a9$export$2e2bcd8739ae039);
parcelRequire("UZaDE");
var $bLO8A = parcelRequire("bLO8A");

var $ivlng = parcelRequire("ivlng");

var $j0mQl = parcelRequire("j0mQl");
var $7f13874ef2d4c5a9$export$2e2bcd8739ae039 = (0, $bLO8A.default)({
    persisted: $ivlng.default,
    ui: $j0mQl.default
});

});
parcelRegister("j0mQl", function(module, exports) {
$parcel$export(module.exports, "getCombinedUIReducer", () => $9014379255d7747e$export$7d44d6add2bebf09);
$parcel$export(module.exports, "default", () => $9014379255d7747e$export$2e2bcd8739ae039);
parcelRequire("UZaDE");
var $bLO8A = parcelRequire("bLO8A");
parcelRequire("1ce3R");
var $60rQJ = parcelRequire("60rQJ");
parcelRequire("krqla");
var $hby7B = parcelRequire("hby7B");
parcelRequire("hJyTk");
var $dC4SZ = parcelRequire("dC4SZ");
parcelRequire("22ezI");
var $fORpR = parcelRequire("fORpR");
parcelRequire("f6Sio");
var $1iz1x = parcelRequire("1iz1x");
parcelRequire("bnAyO");
var $bxpLh = parcelRequire("bxpLh");
parcelRequire("jkU6I");
var $4CJ1U = parcelRequire("4CJ1U");
parcelRequire("9aVxn");
var $1PW9L = parcelRequire("1PW9L");
parcelRequire("gARaA");
var $3l2e7 = parcelRequire("3l2e7");
parcelRequire("eXtTC");
var $d2vRY = parcelRequire("d2vRY");
parcelRequire("97Glj");
var $eOl3l = parcelRequire("eOl3l");
parcelRequire("ayDbS");
var $jvpTe = parcelRequire("jvpTe");
parcelRequire("coAll");
var $cbmsd = parcelRequire("cbmsd");
parcelRequire("ff88W");
var $bFbzg = parcelRequire("bFbzg");
parcelRequire("1TDUH");
var $88tWo = parcelRequire("88tWo");
parcelRequire("lHJtM");
var $ecAZc = parcelRequire("ecAZc");
parcelRequire("gEAzz");
var $6pwYT = parcelRequire("6pwYT");
parcelRequire("4qWt7");
var $gFntF = parcelRequire("gFntF");
parcelRequire("lkkwd");
var $a94lS = parcelRequire("a94lS");
parcelRequire("dC0ZE");
var $4ca1f = parcelRequire("4ca1f");
parcelRequire("G3Jkm");
var $9nQ8n = parcelRequire("9nQ8n");
const $9014379255d7747e$var$reducerCollection = {
    context: (0, $fORpR.default),
    search: (0, $gFntF.default),
    helpCenterPreview: (0, $1PW9L.default),
    portalCustomisation: (0, $cbmsd.default),
    requestDetails: (0, $bFbzg.requestDetailsReducer),
    requestList: (0, $88tWo.requestListReducer),
    approvalList: (0, $60rQJ.approvalistReducer),
    flags: (0, $4CJ1U.flagsReducer),
    userProfile: (0, $9nQ8n.userProfileReducer),
    login: (0, $d2vRY.loginUiReducer),
    loginAnnouncements: (0, $eOl3l.loginAnnouncementsReducer),
    invitedSignUp: (0, $3l2e7.invitedSignUpUiReducer),
    resetPassword: (0, $6pwYT.resetPasswordReducer),
    completeSignup: (0, $dC4SZ.completeSignupUiReducer),
    signUpCheckEmail: (0, $a94lS.checkEmailUiReducer),
    featuredAndSortedPortals: (0, $1iz1x.featuredAndSortedPortalsReducer),
    feedbackCollector: (0, $bxpLh.feedbackCollectorReducer),
    portals: (0, $jvpTe.portalReducer),
    resendVerifyEmail: (0, $ecAZc.resendVerifyReducer),
    topics: (0, $4ca1f.default),
    chatDetails: (0, $hby7B.chatDetailsReducer)
};
const $9014379255d7747e$export$7d44d6add2bebf09 = (asyncReducers)=>(0, $bLO8A.default)({
        ...$9014379255d7747e$var$reducerCollection,
        ...asyncReducers
    });
var $9014379255d7747e$export$2e2bcd8739ae039 = (0, $bLO8A.default)($9014379255d7747e$var$reducerCollection);

});
parcelRegister("1ce3R", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => (parcelRequire("60rQJ")).approvalistReducer);

var $60rQJ = parcelRequire("60rQJ");

});
parcelRegister("60rQJ", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => $b01182aef4d31be5$export$b467bcef5b3409ab);
parcelRequire("8knRH");
var $kXd9e = parcelRequire("kXd9e");
const $b01182aef4d31be5$var$defaultState = {
    isLoading: false
};
function $b01182aef4d31be5$export$b467bcef5b3409ab(state = $b01182aef4d31be5$var$defaultState, action) {
    switch(action.type){
        case 0, $kXd9e.FETCH_APPROVAL_LIST_MODEL:
            return $b01182aef4d31be5$var$handleFetchApprovalListAction(state);
        case 0, $kXd9e.FETCH_APPROVAL_LIST_SUCCESS:
            return $b01182aef4d31be5$var$handleFetchApprovalListSuccess(state);
        case 0, $kXd9e.FETCH_APPROVAL_LIST_FAILURE:
            return $b01182aef4d31be5$var$handleFetchApprovalListFailure(state);
        default:
            return state;
    }
}
const $b01182aef4d31be5$var$handleFetchApprovalListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $b01182aef4d31be5$var$handleFetchApprovalListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $b01182aef4d31be5$var$handleFetchApprovalListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("krqla", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => (parcelRequire("hby7B")).chatDetailsReducer);

var $hby7B = parcelRequire("hby7B");

});
parcelRegister("hby7B", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => $f06c18abccd40559$export$38fe3740469ec1e6);
parcelRequire("5BjLS");
var $jbwFT = parcelRequire("jbwFT");
const $f06c18abccd40559$export$29e68d440392d68e = {
    isChatSideBarOpen: false
};
function $f06c18abccd40559$export$38fe3740469ec1e6(state = $f06c18abccd40559$export$29e68d440392d68e, action) {
    if (action.type === (0, $jbwFT.OPEN_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: true
    };
    if (action.type === (0, $jbwFT.CLOSE_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: false
    };
    return state;
}

});
parcelRegister("5BjLS", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => (parcelRequire("jbwFT")).OPEN_CHAT_SIDE_BAR);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => (parcelRequire("jbwFT")).CLOSE_CHAT_SIDE_BAR);
$parcel$export(module.exports, "openChatSideBar", () => (parcelRequire("jbwFT")).openChatSideBar);
$parcel$export(module.exports, "closeChatSideBar", () => (parcelRequire("jbwFT")).closeChatSideBar);

var $jbwFT = parcelRequire("jbwFT");

});
parcelRegister("jbwFT", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => $06d6db13d3776299$export$dc5a6dd48e3ba8bf);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => $06d6db13d3776299$export$c4de34e9e1c374f8);
$parcel$export(module.exports, "openChatSideBar", () => $06d6db13d3776299$export$348d5042d1099e44);
$parcel$export(module.exports, "closeChatSideBar", () => $06d6db13d3776299$export$7fb0f09e601a69a9);
const $06d6db13d3776299$export$dc5a6dd48e3ba8bf = 'state.ui.chat-details.OPEN_CHAT_SIDE_BAR';
const $06d6db13d3776299$export$c4de34e9e1c374f8 = 'state.ui.chat-details.CLOSE_CHAT_SIDE_BAR';
const $06d6db13d3776299$export$348d5042d1099e44 = ()=>({
        type: $06d6db13d3776299$export$dc5a6dd48e3ba8bf
    });
const $06d6db13d3776299$export$7fb0f09e601a69a9 = ()=>({
        type: $06d6db13d3776299$export$c4de34e9e1c374f8
    });

});




parcelRegister("hJyTk", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => (parcelRequire("dC4SZ")).completeSignupUiReducer);

var $dC4SZ = parcelRequire("dC4SZ");

});
parcelRegister("dC4SZ", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => $9a3a24edc98c579e$export$11cdd5afa8f3d37e);
parcelRequire("23jTe");
var $bAYOu = parcelRequire("bAYOu");
const $9a3a24edc98c579e$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    submitError: undefined,
    isNewSignupLinkBeingSent: false,
    newSignupLinkSuccessfullySent: false
};
function $9a3a24edc98c579e$export$11cdd5afa8f3d37e(state = $9a3a24edc98c579e$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $bAYOu.COMPLETE_SIGNUP:
            return $9a3a24edc98c579e$var$handleCompleteSignup(state);
        case 0, $bAYOu.COMPLETE_SIGNUP_FAILURE:
            return $9a3a24edc98c579e$var$handleCompleteSignupFailure(state, action);
        case 0, $bAYOu.SEND_NEW_SIGNUP_LINK:
            return $9a3a24edc98c579e$var$handleSendNewSignupLink(state);
        case 0, $bAYOu.SEND_NEW_SIGNUP_LINK_SUCCESS:
            return $9a3a24edc98c579e$var$handleSendNewSignupLinkSuccess(state);
        case 0, $bAYOu.SEND_NEW_SIGNUP_LINK_FAILURE:
            return $9a3a24edc98c579e$var$handleSendNewSignupLinkFailure(state);
        default:
            return state;
    }
}
const $9a3a24edc98c579e$var$handleCompleteSignup = (state)=>({
        ...state,
        isSubmitting: true,
        submitError: undefined
    });
const $9a3a24edc98c579e$var$handleCompleteSignupFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        submitError: action.payload.error
    });
const $9a3a24edc98c579e$var$handleSendNewSignupLink = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: true
    });
const $9a3a24edc98c579e$var$handleSendNewSignupLinkSuccess = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false,
        newSignupLinkSuccessfullySent: true
    });
const $9a3a24edc98c579e$var$handleSendNewSignupLinkFailure = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false
    });

});


parcelRegister("22ezI", function(module, exports) {
$parcel$export(module.exports, "contextReducer", () => (parcelRequire("fORpR")).default);

var $fORpR = parcelRequire("fORpR");

});
parcelRegister("fORpR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f33505c125cc2b9$export$2e2bcd8739ae039);
parcelRequire("gC4ux");
var $kecDY = parcelRequire("kecDY");

var $bKaMP = parcelRequire("bKaMP");

var $g81wt = parcelRequire("g81wt");
const $2f33505c125cc2b9$export$53ac33307b5acee9 = ()=>{
    var _initialModelState$po;
    const initialModelState = (0, $bKaMP.default)();
    const initialState = initialModelState !== null && initialModelState !== void 0 && initialModelState.portal ? {
        portalId: Number((_initialModelState$po = initialModelState.portal) === null || _initialModelState$po === void 0 ? void 0 : _initialModelState$po.id)
    } : {};
    return initialState;
};
const $2f33505c125cc2b9$export$49d5fc8cba920a0 = $2f33505c125cc2b9$export$53ac33307b5acee9();
function $2f33505c125cc2b9$export$2e2bcd8739ae039(state = $2f33505c125cc2b9$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $kecDY.UPDATE_CONTEXT:
            {
                const { pathname: pathname, pathParams: pathParams, routeName: routeName } = action.payload;
                let portalId;
                if (pathParams) portalId = (0, $g81wt.toNumber)(pathParams.portalId);
                return {
                    portalId: portalId,
                    pathname: pathname,
                    routeName: routeName
                };
            }
        case 0, $kecDY.CLEAR_CONTEXT:
            return {};
        default:
            return state;
    }
}

});
parcelRegister("gC4ux", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => (parcelRequire("kecDY")).UPDATE_CONTEXT);
$parcel$export(module.exports, "updateContextAction", () => (parcelRequire("kecDY")).updateContextAction);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => (parcelRequire("kecDY")).CLEAR_CONTEXT);
$parcel$export(module.exports, "clearContextAction", () => (parcelRequire("kecDY")).clearContextAction);

var $kecDY = parcelRequire("kecDY");

});
parcelRegister("kecDY", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => $ff557dfaf7b49cf9$export$5f26c565ccbc9352);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => $ff557dfaf7b49cf9$export$58f534967683dfbc);
$parcel$export(module.exports, "updateContextAction", () => $ff557dfaf7b49cf9$export$42bc3ab9d92c16ac);
$parcel$export(module.exports, "clearContextAction", () => $ff557dfaf7b49cf9$export$a40d7f795b5e0d7d);
const $ff557dfaf7b49cf9$export$5f26c565ccbc9352 = 'state.ui.context.UPDATE_CONTEXT';
const $ff557dfaf7b49cf9$export$58f534967683dfbc = 'state.ui.context.CLEAR_CONTEXT';
const $ff557dfaf7b49cf9$export$42bc3ab9d92c16ac = (context)=>({
        type: $ff557dfaf7b49cf9$export$5f26c565ccbc9352,
        payload: context
    });
const $ff557dfaf7b49cf9$export$a40d7f795b5e0d7d = ()=>({
        type: $ff557dfaf7b49cf9$export$58f534967683dfbc
    });

});




parcelRegister("f6Sio", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("1iz1x")).featuredAndSortedPortalsReducer);

var $1iz1x = parcelRequire("1iz1x");

});
parcelRegister("1iz1x", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $465709c9bb19577e$export$be9fe934804fce97);

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("csZtW");
var $gD2hW = parcelRequire("gD2hW");
parcelRequire("7h8sD");
var $8EcmC = parcelRequire("8EcmC");

var $bKaMP = parcelRequire("bKaMP");
const $465709c9bb19577e$export$aa8b8e485fe6d2cc = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    return {
        featuredPortalIds: [],
        orderedPortalIds: [],
        hiddenPortalIds: [],
        sortBy: 'POPULARITY',
        isDefaultViewLoading: !(initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals),
        isExpandedViewLoading: false,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false,
        isDirty: false,
        isSaveInProgress: false,
        isPortalReorderingDataLoaded: false
    };
};
const $465709c9bb19577e$export$95d7509c19bcb89a = (rank)=>rank || 0;
const $465709c9bb19577e$var$defaultState = $465709c9bb19577e$export$aa8b8e485fe6d2cc();
function $465709c9bb19577e$export$be9fe934804fce97(state = $465709c9bb19577e$var$defaultState, action) {
    switch(action.type){
        case 0, $gD2hW.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL:
            return $465709c9bb19577e$var$handleFetchFeaturedAndSortedPortalsAction(state, action);
        case 0, $gD2hW.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $465709c9bb19577e$var$handleFetchFeaturedAndSortedPortalsSuccess(state, action);
        case 0, $gD2hW.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $465709c9bb19577e$var$handleFetchFeaturedAndSortedPortalsFailure(state, action);
        case 0, $gD2hW.MARK_PORTAL_FEATURED:
            return $465709c9bb19577e$var$handleMarkPortalFeatured(state, action);
        case 0, $gD2hW.TOGGLE_PORTAL_VISIBILITY:
            return $465709c9bb19577e$var$handleTogglePortalVisibility(state, action);
        case 0, $gD2hW.REORDER_FEATURED_PORTAL:
            return $465709c9bb19577e$var$handleReorderFeaturedPortal(state, action);
        case 0, $gD2hW.UPDATE_PORTAL_REORDER_SETTINGS_MODEL:
            return $465709c9bb19577e$var$handleUpdatePortalReorderSettings(state);
        case 0, $gD2hW.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS:
            return $465709c9bb19577e$var$handleUpdatePortalReorderSettingsModelSuccess(state);
        case 0, $gD2hW.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE:
            return $465709c9bb19577e$var$handleUpdatePortalReorderSettingsModelFailure(state);
        case 0, $gD2hW.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $465709c9bb19577e$var$handleUpdatePortalReorderSettingsSuccess(state);
        case 0, $gD2hW.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE:
            return $465709c9bb19577e$var$handleUpdatePortalReorderSettingsFailure(state);
        case 0, $gD2hW.RESET_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $465709c9bb19577e$var$handleResetPortalReorderSettingsSuccess(state, action);
        case 0, $gD2hW.MARK_PORTAL_REORDER_SETTINGS_DIRTY:
            return $465709c9bb19577e$var$handleMarkPortalReorderSettingsDirty(state);
        default:
            return state;
    }
}
const $465709c9bb19577e$var$handleFetchFeaturedAndSortedPortalsAction = (state, action)=>{
    if (action.payload.params.exploreAll) {
        /* On help seekers view, and clicked on exploreAll */ if (!action.payload.params.isPortalReorderingSelected) return {
            ...state,
            isExpandedViewLoading: true
        };
        /* on changing sorted preference on portal reordering screen */ if (action.payload.params.sortBy) return {
            ...state,
            isSortedDataLoading: true,
            sortBy: action.payload.params.sortBy ? action.payload.params.sortBy : 'POPULARITY'
        };
        /* on initial page load for portal reordering screen */ return {
            ...state,
            isReorderingExperienceLoading: true
        };
    }
    /* On help seekers view, initial loading for featured portals or top 6 sorted portals */ return {
        ...state,
        isDefaultViewLoading: true
    };
};
const $465709c9bb19577e$var$handleFetchFeaturedAndSortedPortalsSuccess = (state, action)=>{
    if (!action.requestParams.isPortalReorderingSelected) {
        /* on Help seeker view - on clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            isExpandedViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
        /* on Help seeker view - initial loading */ return {
            ...state,
            isDefaultViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
    }
    /* on portal reordering screen - on changing sortBy option */ if (action.requestParams.sortBy) return {
        ...state,
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isSortedDataLoading: false,
        sortBy: action.requestParams.sortBy || state.sortBy
    };
    /* on portal reordering screen - initial load */ return {
        ...state,
        featuredPortalIds: action.payload.portals.filter((0, $8EcmC.isFeaturedPortal)).sort((portal1, portal2)=>$465709c9bb19577e$export$95d7509c19bcb89a(portal1.rank) - $465709c9bb19577e$export$95d7509c19bcb89a(portal2.rank)).map((portal)=>portal.id),
        hiddenPortalIds: action.payload.portals.filter((0, $8EcmC.isHiddenPortal)).map((portal)=>portal.id),
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isReorderingExperienceLoading: false,
        sortBy: action.payload.sortBy || state.sortBy,
        isPortalReorderingDataLoaded: true
    };
};
const $465709c9bb19577e$var$handleFetchFeaturedAndSortedPortalsFailure = (state, action)=>{
    /* Error in  help seekers view*/ if (!action.requestParams.isPortalReorderingSelected) return {
        ...state,
        isExpandedViewLoading: false,
        isDefaultViewLoading: false
    };
    /* Error in portal reordering view */ return {
        ...state,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false
    };
};
const $465709c9bb19577e$var$handleMarkPortalFeatured = (state, action)=>{
    const { id: id, isFeatured: isFeatured } = action.payload;
    const { featuredPortalIds: featuredPortalIds } = state;
    const updateFeaturedPortalIds = [
        ...featuredPortalIds
    ];
    if (isFeatured) updateFeaturedPortalIds.push(id);
    else (0, $aYMdQ.remove)(updateFeaturedPortalIds, (item)=>item === id);
    return {
        ...state,
        featuredPortalIds: updateFeaturedPortalIds,
        isDirty: true
    };
};
const $465709c9bb19577e$var$handleTogglePortalVisibility = (state, action)=>{
    const { id: id, hiddenFromHomeScreen: hiddenFromHomeScreen } = action.payload;
    const { hiddenPortalIds: hiddenPortalIds } = state;
    const updatedHiddenPortalIds = [
        ...hiddenPortalIds
    ];
    if (hiddenFromHomeScreen) updatedHiddenPortalIds.push(id);
    else (0, $aYMdQ.remove)(updatedHiddenPortalIds, (item)=>item === id);
    return {
        ...state,
        hiddenPortalIds: (0, $aYMdQ.uniq)(updatedHiddenPortalIds),
        isDirty: true
    };
};
const $465709c9bb19577e$var$reOrder = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const $465709c9bb19577e$var$handleReorderFeaturedPortal = (state, action)=>{
    const { oldIndex: oldIndex, newIndex: newIndex } = action.payload;
    return {
        ...state,
        featuredPortalIds: $465709c9bb19577e$var$reOrder(state.featuredPortalIds, oldIndex, newIndex),
        isDirty: true
    };
};
const $465709c9bb19577e$var$handleUpdatePortalReorderSettings = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $465709c9bb19577e$var$handleUpdatePortalReorderSettingsModelSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $465709c9bb19577e$var$handleUpdatePortalReorderSettingsModelFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $465709c9bb19577e$var$handleUpdatePortalReorderSettingsSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false
    };
};
const $465709c9bb19577e$var$handleUpdatePortalReorderSettingsFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: true
    };
};
// Common logic for both Reset and Cancel action
const $465709c9bb19577e$var$handleResetPortalReorderSettingsSuccess = (state, action)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false,
        sortBy: action.payload.sortBy,
        featuredPortalIds: action.payload.featuredPortalIds,
        orderedPortalIds: action.payload.orderedPortalIds
    };
};
const $465709c9bb19577e$var$handleMarkPortalReorderSettingsDirty = (state)=>{
    return {
        ...state,
        isDirty: true
    };
};

});


parcelRegister("bnAyO", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => (parcelRequire("bxpLh")).feedbackCollectorReducer);

var $bxpLh = parcelRequire("bxpLh");

});
parcelRegister("bxpLh", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => $bbf4550e22fcf50a$export$8085646591e2a0b2);
parcelRequire("kIRNU");
var $din2c = parcelRequire("din2c");

var $7lN8e = parcelRequire("7lN8e");
const $bbf4550e22fcf50a$var$addPortalPrefix = (featureName)=>{
    return 'JSM Portal '.concat(featureName);
};
const $bbf4550e22fcf50a$export$fe349eba520514db = {
    shouldOpenFeedbackWidget: false,
    showTypeField: false,
    additionalFields: {}
};
const $bbf4550e22fcf50a$var$defaultState = $bbf4550e22fcf50a$export$fe349eba520514db;
function $bbf4550e22fcf50a$export$8085646591e2a0b2(state = $bbf4550e22fcf50a$var$defaultState, action) {
    switch(action.type){
        case 0, $din2c.SHOW_FEEDACK_COLLECTOR:
            return $bbf4550e22fcf50a$var$handleFeedbackCollector(state, action);
        case 0, $din2c.HIDE_FEEDACK_COLLECTOR:
            return $bbf4550e22fcf50a$var$handleFeedbackCollector(state, action);
        case 0, $din2c.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR:
            return $bbf4550e22fcf50a$var$handleUpdateAdditionalFieldsInFeedbackCollector(state, action);
        default:
            return state;
    }
}
const $bbf4550e22fcf50a$var$handleFeedbackCollector = (state, action)=>{
    if (action.type === (0, $din2c.HIDE_FEEDACK_COLLECTOR)) return {
        ...state,
        shouldOpenFeedbackWidget: false
    };
    const { showTypeField: showTypeField, CustomComponent: CustomComponent, featureName: featureName, env: env } = action.payload;
    const newState = {
        ...state,
        showTypeField: showTypeField,
        CustomComponent: CustomComponent,
        shouldOpenFeedbackWidget: true
    };
    if (env === (0, $7lN8e.EnvType).PROD) {
        newState.additionalFields = {
            // Do not change this field as this is an actual custom field in https://jira-feedback.atlassian.net. Changing this will break feedback collector in production.
            customfield_10076: $bbf4550e22fcf50a$var$addPortalPrefix(featureName)
        };
        return newState;
    }
    newState.additionalFields = {
        // Do not change this field as this is an actual custom field in https://arajpal.atlassian.net. Changing this will break feedback collector in staging.
        customfield_10094: $bbf4550e22fcf50a$var$addPortalPrefix(featureName)
    };
    return newState;
};
const $bbf4550e22fcf50a$var$handleUpdateAdditionalFieldsInFeedbackCollector = (state, action)=>{
    return {
        ...state,
        additionalFields: {
            ...state.additionalFields,
            ...action.payload.additionalFields
        }
    };
};

});
parcelRegister("kIRNU", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => (parcelRequire("din2c")).SHOW_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "showFeedbackCollector", () => (parcelRequire("din2c")).showFeedbackCollector);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => (parcelRequire("din2c")).HIDE_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "hideFeedbackCollector", () => (parcelRequire("din2c")).hideFeedbackCollector);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => (parcelRequire("din2c")).UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => (parcelRequire("din2c")).updateAdditionalFieldsInFeedbackCollector);

var $din2c = parcelRequire("din2c");

});
parcelRegister("din2c", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => $4671103a65f52483$export$e920d8568364aa72);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => $4671103a65f52483$export$20dd51f415d7804e);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => $4671103a65f52483$export$3366d0333401654a);
$parcel$export(module.exports, "showFeedbackCollector", () => $4671103a65f52483$export$c759098e05f62ce0);
$parcel$export(module.exports, "hideFeedbackCollector", () => $4671103a65f52483$export$92f2211d73785c9);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => $4671103a65f52483$export$41e78cf91821ccad);
const $4671103a65f52483$export$e920d8568364aa72 = 'state.ui.feedback-collector.SHOW_FEEDACK_COLLECTOR';
const $4671103a65f52483$export$20dd51f415d7804e = 'state.ui.feedback-collector.HIDE_FEEDACK_COLLECTOR';
const $4671103a65f52483$export$3366d0333401654a = 'state.ui.feedback-collector.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR';
const $4671103a65f52483$export$c759098e05f62ce0 = (payload)=>({
        payload: payload,
        type: $4671103a65f52483$export$e920d8568364aa72
    });
const $4671103a65f52483$export$92f2211d73785c9 = ()=>({
        type: $4671103a65f52483$export$20dd51f415d7804e
    });
const $4671103a65f52483$export$41e78cf91821ccad = (additionalFields)=>({
        type: $4671103a65f52483$export$3366d0333401654a,
        payload: {
            additionalFields: additionalFields
        }
    });

});




parcelRegister("jkU6I", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => (parcelRequire("4CJ1U")).flagsReducer);

var $4CJ1U = parcelRequire("4CJ1U");

});
parcelRegister("4CJ1U", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => $8d70f2318dadc79d$export$64fc5b4c35b25733);

var $5kfOu = parcelRequire("5kfOu");
const $8d70f2318dadc79d$var$MAX_FLAG_ID = 99999;
const $8d70f2318dadc79d$var$defaultState = {
    flags: []
};
function $8d70f2318dadc79d$export$64fc5b4c35b25733(state = $8d70f2318dadc79d$var$defaultState, action) {
    switch(action.type){
        case 0, $5kfOu.SHOW_ERROR_FLAG:
            return $8d70f2318dadc79d$var$handleShowErrorFlag(state, action);
        case 0, $5kfOu.SHOW_WARNING_FLAG:
            return $8d70f2318dadc79d$var$handleShowWarningFlag(state, action);
        case 0, $5kfOu.SHOW_SUCCESS_FLAG:
            return $8d70f2318dadc79d$var$handleShowSuccessFlag(state, action);
        case 0, $5kfOu.DISMISS_FLAG:
            return $8d70f2318dadc79d$var$handleFlagDismissal(state, action);
        case 0, $5kfOu.SHOW_BOLD_APPEARANCE_FLAG:
            return $8d70f2318dadc79d$var$handleShowBoldAppearanceFlag(state, action);
        default:
            return state;
    }
}
function $8d70f2318dadc79d$var$handleShowErrorFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8d70f2318dadc79d$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'error'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $8d70f2318dadc79d$var$handleShowWarningFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8d70f2318dadc79d$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'warning'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $8d70f2318dadc79d$var$handleShowSuccessFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8d70f2318dadc79d$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'success'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $8d70f2318dadc79d$var$handleShowBoldAppearanceFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $8d70f2318dadc79d$var$generateFlagId(),
        appearance: action.payload.appearance,
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        dismissActionValue: action.payload.dismissActionValue,
        type: 'bold'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
const $8d70f2318dadc79d$var$generateFlagId = ()=>// Integer between 0 and MAX_FLAG_ID
    Math.floor(Math.random() * Math.floor($8d70f2318dadc79d$var$MAX_FLAG_ID));
function $8d70f2318dadc79d$var$handleFlagDismissal(state, action) {
    const updatedFlags = state.flags.filter((flag)=>flag.id !== action.payload.flagId);
    return {
        ...state,
        flags: updatedFlags
    };
}

});


parcelRegister("9aVxn", function(module, exports) {
$parcel$export(module.exports, "helpcenterPreviewReducer", () => (parcelRequire("1PW9L")).default);

var $1PW9L = parcelRequire("1PW9L");

});
parcelRegister("1PW9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $66c3abd9a5246041$export$2e2bcd8739ae039);

var $alVAg = parcelRequire("alVAg");

var $aYMdQ = parcelRequire("aYMdQ");
const $66c3abd9a5246041$var$getDefaultState = ()=>({
        isCustomizing: false,
        isSaveInProgress: false,
        translations: {},
        uploadsInProgress: {}
    });
function $66c3abd9a5246041$export$2e2bcd8739ae039(state = $66c3abd9a5246041$var$getDefaultState(), action) {
    switch(action.type){
        case $alVAg.UPDATE_HELP_CENTER_PREVIEW_MODEL:
            {
                const newState = (0, $aYMdQ.mergeWith)({}, {
                    ...state
                }, {
                    ...action.payload
                }, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/ban-types
                (_, srcValue)=>{
                    // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
                    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
                    if (srcValue === undefined) return null;
                    // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
                    return undefined;
                });
                return {
                    ...newState
                };
            }
        case $alVAg.EDITING_HELP_CENTER:
            return {
                ...state,
                isCustomizing: action.payload
            };
        case $alVAg.CLEAR_HELP_CENTER_PREVIEW_MODEL:
            return {
                translations: {},
                uploadsInProgress: {},
                isCustomizing: false,
                isSaveInProgress: false
            };
        case $alVAg.UPDATE_HELP_CENTER_BRANDING:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $alVAg.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $alVAg.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $alVAg.UPDATE_HELP_CENTER_BRANDING_SAVE_START:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $alVAg.UPDATE_HELP_CENTER_BRANDING_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $alVAg.UPLOAD_START:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: true
                }
            };
        case $alVAg.UPLOAD_END:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: false
                }
            };
        default:
            return state;
    }
}

});


parcelRegister("gARaA", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => (parcelRequire("3l2e7")).invitedSignUpUiReducer);

var $3l2e7 = parcelRequire("3l2e7");

});
parcelRegister("3l2e7", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => $22230bd130e885ee$export$cbd9046ae6d17b9c);
parcelRequire("6ukid");
var $fdqjK = parcelRequire("fdqjK");
const $22230bd130e885ee$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    error: undefined
};
function $22230bd130e885ee$export$cbd9046ae6d17b9c(state = $22230bd130e885ee$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $fdqjK.INVITED_SIGN_UP:
            return $22230bd130e885ee$var$handleInvitedSignUp(state);
        case 0, $fdqjK.INVITED_SIGN_UP_FAILURE:
            return $22230bd130e885ee$var$handleInvitedSignUpFailure(state, action);
        default:
            return state;
    }
}
const $22230bd130e885ee$var$handleInvitedSignUp = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $22230bd130e885ee$var$handleInvitedSignUpFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("eXtTC", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => (parcelRequire("d2vRY")).loginUiReducer);

var $d2vRY = parcelRequire("d2vRY");

});
parcelRegister("d2vRY", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => $2b3c340eb4bac845$export$b52e2813f588ee78);
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");

var $dbYz0 = parcelRequire("dbYz0");
const $2b3c340eb4bac845$export$49d5fc8cba920a0 = {
    email: '',
    atlassianAccountCheckPerformed: false,
    isSubmitting: false,
    isSendingForgotPasswordEmail: false,
    isSendingCreatePasswordEmail: false,
    authInfo: {
        accountStage: (0, $dbYz0.AccountStageType).LOGIN,
        authMethods: new Map([
            [
                (0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    showPasswordConfirmation: false,
    showSsoTestModeErrorPage: false,
    showLoginConsentErrorPage: false
};
function $2b3c340eb4bac845$export$b52e2813f588ee78(state = $2b3c340eb4bac845$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $6oW6S.CHANGE_EMAIL_INPUT:
            return $2b3c340eb4bac845$var$handleChangeEmailInput(state, action);
        case 0, $6oW6S.CHECK_LOGIN_ACTION:
            return $2b3c340eb4bac845$var$handleCheckLoginActionAction(state);
        case 0, $6oW6S.CHECK_LOGIN_ACTION_SUCCESS:
            return $2b3c340eb4bac845$var$handleCheckLoginActionSuccess(state, action);
        case 0, $6oW6S.CHECK_LOGIN_ACTION_FAILURE:
            return $2b3c340eb4bac845$var$handleCheckLoginActionFailure(state, action);
        case 0, $6oW6S.CREATE_PASSWORD:
            return $2b3c340eb4bac845$var$handleCreatePassword(state);
        case 0, $6oW6S.FORGOT_PASSWORD:
            return $2b3c340eb4bac845$var$handleForgotPassword(state);
        case 0, $6oW6S.FORGOT_PASSWORD_FAILURE:
            return $2b3c340eb4bac845$var$handleForgotPasswordFailure(state);
        case 0, $6oW6S.FORGOT_PASSWORD_SUCCESS:
            return $2b3c340eb4bac845$var$handleForgotPasswordSuccess(state);
        case 0, $6oW6S.CREATE_PASSWORD_SUCCESS:
            return $2b3c340eb4bac845$var$handleCreatePasswordSuccess(state);
        case 0, $6oW6S.LOGIN_ATTEMPT:
            return $2b3c340eb4bac845$var$handleLoginAttempt(state);
        case 0, $6oW6S.LOGIN_ATTEMPT_SUCCESS:
            return $2b3c340eb4bac845$var$handleLoginAttemptSuccess(state, action);
        case 0, $6oW6S.LOGIN_ATTEMPT_FAILURE:
            return $2b3c340eb4bac845$var$handleLoginAttemptFailure(state, action);
        case 0, $6oW6S.CA_SSO_TEST_MODE_FAILURE:
            return $2b3c340eb4bac845$var$handleCaSsoTestModeFailure(state);
        case 0, $6oW6S.LOGIN_CONSENT_FAILURE:
            return $2b3c340eb4bac845$var$handleLoginConsentFailure(state);
        case 0, $6oW6S.RESET_LOGIN:
            return $2b3c340eb4bac845$var$resetLogin(action);
        default:
            return state;
    }
}
const $2b3c340eb4bac845$var$handleChangeEmailInput = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        email: action.payload.email
    });
const $2b3c340eb4bac845$var$handleCheckLoginActionAction = (state)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: undefined
    });
const $2b3c340eb4bac845$var$handleCheckLoginActionSuccess = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: true,
        authInfo: {
            ...state.authInfo,
            accountStage: action.payload.authInfo.accountStage,
            authMethods: action.payload.authInfo.authMethods
        },
        error: undefined
    });
const $2b3c340eb4bac845$var$handleCaSsoTestModeFailure = (state)=>({
        ...state,
        showSsoTestModeErrorPage: true
    });
const $2b3c340eb4bac845$var$handleLoginConsentFailure = (state)=>({
        ...state,
        showLoginConsentErrorPage: true
    });
const $2b3c340eb4bac845$var$handleCheckLoginActionFailure = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: action.payload.error
    });
const $2b3c340eb4bac845$var$handleCreatePassword = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: true
    });
const $2b3c340eb4bac845$var$handleCreatePasswordSuccess = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: false,
        showPasswordConfirmation: true
    });
const $2b3c340eb4bac845$var$handleForgotPassword = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: true
    });
const $2b3c340eb4bac845$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false
    });
const $2b3c340eb4bac845$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false,
        showPasswordConfirmation: true
    });
const $2b3c340eb4bac845$var$handleLoginAttempt = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined,
        loginAttemptResponse: undefined
    });
function $2b3c340eb4bac845$var$handleLoginAttemptSuccess(state, action) {
    const { loginAttemptResponse: loginAttemptResponse } = action.payload;
    const defaultValues = {
        loginAttemptResponse: loginAttemptResponse,
        isSubmitting: false,
        error: undefined
    };
    if (loginAttemptResponse.loginSucceeded) return {
        ...state,
        ...defaultValues,
        email: '',
        atlassianAccountCheckPerformed: false
    };
    return {
        ...state,
        ...defaultValues
    };
}
const $2b3c340eb4bac845$var$handleLoginAttemptFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        loginAttemptResponse: undefined,
        error: action.payload.error
    });
const $2b3c340eb4bac845$var$resetLogin = (action)=>({
        ...$2b3c340eb4bac845$export$49d5fc8cba920a0,
        email: action.payload.email
    });

});


parcelRegister("97Glj", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("eOl3l")).loginAnnouncementsReducer);

var $eOl3l = parcelRequire("eOl3l");

});
parcelRegister("eOl3l", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $92bc89b22446b12e$export$14afe2784a94db4d);
parcelRequire("700aU");
var $dxx1m = parcelRequire("dxx1m");

var $bKaMP = parcelRequire("bKaMP");
const $92bc89b22446b12e$export$13a9a218541141cd = ()=>{
    const initialModelState = (0, $bKaMP.default)();
    return {
        loginAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements ? initialModelState.loginAnnouncements : {
            defaultLocale: '',
            translatedLoginAnnouncements: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $92bc89b22446b12e$var$doesContainLocaleDisplayName = (translatedLoginAnnouncement)=>{
    return 'localeDisplayName' in translatedLoginAnnouncement && !!translatedLoginAnnouncement.localeDisplayName;
};
const $92bc89b22446b12e$export$49d5fc8cba920a0 = $92bc89b22446b12e$export$13a9a218541141cd();
const $92bc89b22446b12e$export$a85783f8b89d3dc8 = (payload, state)=>{
    return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$loginAnnouncem;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $92bc89b22446b12e$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$loginAnnouncem = state.loginAnnouncementsResponse.translatedLoginAnnouncements[languageKey]) === null || _state$loginAnnouncem === void 0 ? void 0 : _state$loginAnnouncem.localeDisplayName
            }
        };
    }, {});
};
function $92bc89b22446b12e$export$14afe2784a94db4d(state = $92bc89b22446b12e$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $dxx1m.FETCH_LOGIN_ANNOUNCEMENTS:
            return $92bc89b22446b12e$var$handleFetchLoginAnnouncements(state, true);
        case 0, $dxx1m.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return $92bc89b22446b12e$var$handleFetchLoginAnnouncementsSuccess(state, action.payload, false);
        case 0, $dxx1m.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE:
            return $92bc89b22446b12e$var$handleFetchLoginAnnouncements(state, false);
        case 0, $dxx1m.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL:
            {
                const newState = {
                    ...state,
                    loginAnnouncementsResponse: {
                        ...state.loginAnnouncementsResponse,
                        translatedLoginAnnouncements: $92bc89b22446b12e$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $dxx1m.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $dxx1m.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                loginAnnouncementsResponse: {
                    ...state.loginAnnouncementsResponse,
                    translatedLoginAnnouncements: $92bc89b22446b12e$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                }
            };
        case 0, $dxx1m.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
        case 0, $dxx1m.RESET_LOGIN_ANNOUNCEMENTS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}
const $92bc89b22446b12e$var$handleFetchLoginAnnouncementsSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        loginAnnouncementsResponse: {
            ...state.loginAnnouncementsResponse,
            defaultLocale: payload.defaultLocale,
            translatedLoginAnnouncements: $92bc89b22446b12e$export$a85783f8b89d3dc8(payload.translatedLoginAnnouncements, state)
        },
        isSaveFailed: false
    });
const $92bc89b22446b12e$var$handleFetchLoginAnnouncements = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });

});


parcelRegister("ayDbS", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("jvpTe")).portalReducer);

var $jvpTe = parcelRequire("jvpTe");

});
parcelRegister("jvpTe", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => $9ec3b3a81f179784$export$7b4acfe1c1a43b7c);

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");

var $bKaMP = parcelRequire("bKaMP");
const $9ec3b3a81f179784$export$db2e6bec0a5d318f = ()=>{
    var _initialModelState$po, _initialModelState$po2;
    const initialModelState = (0, $bKaMP.default)();
    return {
        portalAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && (_initialModelState$po = initialModelState.portal) !== null && _initialModelState$po !== void 0 && _initialModelState$po.portalAnnouncement ? initialModelState === null || initialModelState === void 0 || (_initialModelState$po2 = initialModelState.portal) === null || _initialModelState$po2 === void 0 ? void 0 : _initialModelState$po2.portalAnnouncement : {
            canAdministerProject: false,
            canEditAnnouncement: false,
            defaultLanguageDisplayName: '',
            defaultLanguageHeader: '',
            defaultLanguageMessage: '',
            isUsingLanguageSupport: false,
            portalId: 0,
            portalProjectKey: '',
            userLanguageHeader: '',
            userLanguageMessageWiki: '',
            translations: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $9ec3b3a81f179784$var$doesContainLocaleDisplayName = (translatedPortalAnnouncement)=>'localeDisplayName' in translatedPortalAnnouncement && !!translatedPortalAnnouncement.localeDisplayName;
const $9ec3b3a81f179784$export$49d5fc8cba920a0 = $9ec3b3a81f179784$export$db2e6bec0a5d318f();
const $9ec3b3a81f179784$export$76e9a6f613765d59 = (payload, state)=>{
    if (payload && !(0, $aYMdQ.isEmpty)(payload)) return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$portalAnnounce;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $9ec3b3a81f179784$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$portalAnnounce = state.portalAnnouncementsResponse.translations) === null || _state$portalAnnounce === void 0 || (_state$portalAnnounce = _state$portalAnnounce[languageKey]) === null || _state$portalAnnounce === void 0 ? void 0 : _state$portalAnnounce.localeDisplayName
            }
        };
    }, {});
    return {};
};
const $9ec3b3a81f179784$var$handleFetchPortalSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        portalAnnouncementsResponse: {
            ...payload,
            defaultLanguageDisplayName: payload.defaultLanguageDisplayName,
            translations: $9ec3b3a81f179784$export$76e9a6f613765d59(payload.translations, state)
        },
        isSaveFailed: false
    });
const $9ec3b3a81f179784$var$handleFetchPortal = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });
function $9ec3b3a81f179784$export$7b4acfe1c1a43b7c(state = $9ec3b3a81f179784$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $hijaX.FETCH_PORTAL_MODEL:
            return $9ec3b3a81f179784$var$handleFetchPortal(state, true);
        case 0, $hijaX.FETCH_PORTAL_SUCCESS:
            return $9ec3b3a81f179784$var$handleFetchPortalSuccess(state, action.payload.portalAnnouncement, false);
        case 0, $hijaX.FETCH_PORTAL_FAILURE:
            return $9ec3b3a81f179784$var$handleFetchPortal(state, false);
        case 0, $hijaX.UPDATE_PORTAL_ANNOUNCEMENT_MODEL:
            {
                const newState = {
                    ...state,
                    portalAnnouncementsResponse: {
                        ...state.portalAnnouncementsResponse,
                        translations: $9ec3b3a81f179784$export$76e9a6f613765d59(action.payload.translations, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $hijaX.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $hijaX.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                portalAnnouncementsResponse: {
                    ...state.portalAnnouncementsResponse,
                    ...action.payload,
                    translations: $9ec3b3a81f179784$export$76e9a6f613765d59(action.payload.translations, state)
                }
            };
        case 0, $hijaX.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}

});


parcelRegister("coAll", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("cbmsd")).default);
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => (parcelRequire("cbmsd")).PLACEHOLDER_REQUEST_GROUP_ID);

var $cbmsd = parcelRequire("cbmsd");

});
parcelRegister("cbmsd", function(module, exports) {
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => $355b9be970883582$export$1d5c0939993f01ba);
$parcel$export(module.exports, "default", () => $355b9be970883582$export$2e2bcd8739ae039);
parcelRequire("hXvMi");
var $d8CDI = parcelRequire("d8CDI");
parcelRequire("ERi1L");
var $3wJyi = parcelRequire("3wJyi");
parcelRequire("diqb8");
var $6g8yl = parcelRequire("6g8yl");
parcelRequire("8txpj");
var $fAQue = parcelRequire("fAQue");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("25e17");
var $irHmR = parcelRequire("irHmR");
parcelRequire("hVkR1");
var $jBKKK = parcelRequire("jBKKK");
parcelRequire("hPZpM");
var $hDMR6 = parcelRequire("hDMR6");
parcelRequire("klmhp");
var $lArI5 = parcelRequire("lArI5");
parcelRequire("jMOeN");
var $88u99 = parcelRequire("88u99");
const $355b9be970883582$export$1d5c0939993f01ba = -1;
const $355b9be970883582$var$getDefaultState = ()=>({
        requestGroups: undefined,
        requestGroupsOrder: undefined,
        requestTypesOrder: undefined,
        requestTypesInRequestGroup: undefined,
        requestTypesNotInRequestGroup: undefined,
        parentRequestGroups: undefined,
        error: undefined,
        groupNameThatCausedError: undefined,
        isParentRequestGroupsLoading: false
    });
function $355b9be970883582$export$2e2bcd8739ae039(state = $355b9be970883582$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $irHmR.UPDATE_REQUEST_GROUPS_ORDER:
            return {
                ...state,
                requestGroupsOrder: action.payload.order
            };
        case 0, $d8CDI.ADD_REQUEST_GROUP:
            {
                const newGroup = {
                    name: action.payload.groupName,
                    id: $355b9be970883582$export$1d5c0939993f01ba // We don't have an id yet because the request hasn't completed, we put in a fake number temporarily. the groups here will get cleared when the persisted model is fetched
                };
                return {
                    ...state,
                    requestGroups: [
                        ...action.payload.existingGroups,
                        newGroup
                    ],
                    error: undefined,
                    groupNameThatCausedError: undefined
                };
            }
        case 0, $d8CDI.ADD_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestGroups: undefined,
                error: action.payload.message,
                groupNameThatCausedError: action.payload.groupNameThatCausedError
            };
        case 0, $6g8yl.CREATE_GROUP_WITH_REQUEST_TYPE:
            return {
                ...state,
                isParentRequestGroupsLoading: true
            };
        case 0, $6g8yl.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $6g8yl.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $fAQue.DELETE_REQUEST_TYPE_FROM_GROUP:
            {
                const { requestTypes: requestTypes, index: index } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const udpatedRequestTypeIds = (0, $88u99.deleteFromList)(requestTypeIds, index);
                return {
                    ...state,
                    requestTypesInRequestGroup: undefined,
                    requestTypesNotInRequestGroup: undefined,
                    requestTypesOrder: udpatedRequestTypeIds
                };
            }
        case 0, $lArI5.SET_REQUEST_TYPE_GROUPS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    parentRequestGroups: requestGroups
                };
            }
        case 0, $lArI5.SET_REQUEST_TYPE_GROUPS_FAILED:
            return {
                ...state,
                parentRequestGroups: undefined
            };
        case 0, $jBKKK.REORDER_REQUEST_TYPE:
            {
                const { requestTypes: requestTypes, fromIndex: fromIndex, toIndex: toIndex } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const updatedRequestTypeIds = (0, $88u99.reorderList)(requestTypeIds, fromIndex, toIndex);
                return {
                    ...state,
                    requestTypesOrder: updatedRequestTypeIds
                };
            }
        case 0, $hijaX.FETCH_PORTAL_SUCCESS:
            return $355b9be970883582$var$getDefaultState();
        case 0, $3wJyi.ADD_REQUEST_TYPE_TO_REQUEST_GROUP:
            {
                const { requestType: requestType, requestTypesNotInRequestGroup: requestTypesNotInRequestGroup, requestTypesInRequestGroup: requestTypesInRequestGroup } = action.payload;
                // Remove request type from requestTypesNotInRequestGroup used for request type search options
                const optimisticRequestTypesNotInRequestGroup = requestTypesNotInRequestGroup.filter((requestTypeNotInRequestGroup)=>requestTypeNotInRequestGroup.id !== requestType.id);
                // Add request type as the last element of requestTypesInRequestGroup used to render request types in group
                const optimisticRequestTypesInRequestGroup = [
                    ...requestTypesInRequestGroup,
                    requestType
                ];
                // This will have the new request type as the last index (the order will then be persisted)
                const requestTypeIds = optimisticRequestTypesInRequestGroup.map(({ id: requestTypeId })=>Number(requestTypeId));
                return {
                    ...state,
                    requestTypesOrder: requestTypeIds,
                    requestTypesInRequestGroup: [
                        ...optimisticRequestTypesInRequestGroup
                    ],
                    requestTypesNotInRequestGroup: [
                        ...optimisticRequestTypesNotInRequestGroup
                    ],
                    error: undefined
                };
            }
        case 0, $3wJyi.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestTypesOrder: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: action.payload.message
            };
        case 0, $irHmR.CLEAR_REQUEST_TYPES_ORDER:
            return {
                ...state,
                requestGroups: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: undefined,
                requestTypesOrder: undefined
            };
        case 0, $irHmR.CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                error: undefined,
                groupNameThatCausedError: undefined,
                requestTypesOrder: undefined
            };
        // Reset any errors and clear the UI state version of request groups so it can be populated with the newly persisted list as the new source of truth
        case 0, $irHmR.CLEAR_REQUEST_GROUPS_ORDER:
            return $355b9be970883582$var$getDefaultState();
        // On successful edit clear UI state order, and use the newly persisted request groups state as the source of truth for the request groups list.
        case 0, $hDMR6.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    requestGroups: requestGroups,
                    requestGroupsOrder: undefined
                };
            }
        default:
            return state;
    }
}

});
parcelRegister("jMOeN", function(module, exports) {
$parcel$export(module.exports, "deleteFromList", () => (parcelRequire("88u99")).deleteFromList);
$parcel$export(module.exports, "reorderList", () => (parcelRequire("88u99")).reorderList);
parcelRequire("88u99");

});
parcelRegister("88u99", function(module, exports) {
$parcel$export(module.exports, "reorderList", () => $6a5d01b17ecf2af1$export$1c97eb4883130bfd);
$parcel$export(module.exports, "deleteFromList", () => $6a5d01b17ecf2af1$export$e786ade68cfa1610);
/** Utility functions to assist managing drop events in React Beautiful DnD */ 
var $aYMdQ = parcelRequire("aYMdQ");
const $6a5d01b17ecf2af1$export$1c97eb4883130bfd = (list, fromIndex, toIndex)=>{
    const newList = Array.from(list);
    if (!(0, $aYMdQ.isNil)(toIndex) && !(0, $aYMdQ.isNil)(fromIndex)) {
        newList.splice(fromIndex, 1);
        newList.splice(toIndex, 0, list[fromIndex]);
    }
    return newList;
};
const $6a5d01b17ecf2af1$export$e786ade68cfa1610 = (list, index)=>{
    const newList = Array.from(list);
    if (!(0, $aYMdQ.isNil)(index)) newList.splice(index, 1);
    return newList;
};

});




parcelRegister("ff88W", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("bFbzg")).requestDetailsReducer);
$parcel$export(module.exports, "ApprovalDecision", () => (parcelRequire("bFbzg")).ApprovalDecision);

var $bFbzg = parcelRequire("bFbzg");

});
parcelRegister("bFbzg", function(module, exports) {
$parcel$export(module.exports, "ApprovalDecision", () => $098fcb414ea0f6e5$export$b84e6e5b33fd1d21);
$parcel$export(module.exports, "requestDetailsReducer", () => $098fcb414ea0f6e5$export$dfa3e5ac1f5274b8);
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");
var $098fcb414ea0f6e5$export$b84e6e5b33fd1d21 = /*#__PURE__*/ function(ApprovalDecision) {
    ApprovalDecision[ApprovalDecision["APPROVE"] = 0] = "APPROVE";
    ApprovalDecision[ApprovalDecision["DECLINE"] = 1] = "DECLINE";
    return ApprovalDecision;
}({});
const $098fcb414ea0f6e5$var$defaultState = {
    commentSubmitting: false,
    commentBeingSubmitted: undefined
};
function $098fcb414ea0f6e5$export$dfa3e5ac1f5274b8(state = $098fcb414ea0f6e5$var$defaultState, action) {
    switch(action.type){
        case 0, $kV2FF.TRANSITION_REQUEST:
            return $098fcb414ea0f6e5$var$handleTransition(state, action);
        case 0, $kV2FF.TRANSITION_REQUEST_FAILURE:
            return $098fcb414ea0f6e5$var$handleTransitionFailure(state, action);
        case 0, $kV2FF.CLEAR_TRANSITION_REQUEST_FAILURE:
            return $098fcb414ea0f6e5$var$handleClearTransitionFailure(state);
        case 0, $kV2FF.FETCH_REQUEST_DETAILS_SUCCESS:
            return $098fcb414ea0f6e5$var$defaultState;
        case 0, $kV2FF.CREATE_COMMENT:
            return $098fcb414ea0f6e5$var$handleCommentCreate(state, action);
        case 0, $kV2FF.CREATE_COMMENT_SUCCESS:
            return $098fcb414ea0f6e5$var$handleCommentCreateSuccess(state);
        case 0, $kV2FF.CREATE_COMMENT_FAILURE:
            return $098fcb414ea0f6e5$var$handleCommentCreateFailure(state);
        case 0, $kV2FF.SHOW_TRANSITION_DIALOG:
            return $098fcb414ea0f6e5$var$handleShowTransitionDialog(state, action);
        case 0, $kV2FF.HIDE_TRANSITION_DIALOG:
            return $098fcb414ea0f6e5$var$handleHideTransitionDialog(state);
        case 0, $kV2FF.DECIDE_APPROVAL:
            return $098fcb414ea0f6e5$var$handleDecideApproval(state, action);
        case 0, $kV2FF.DECIDE_APPROVAL_FAILURE:
            return $098fcb414ea0f6e5$var$handleDecideApprovalFailure(state);
        default:
            return state;
    }
}
const $098fcb414ea0f6e5$var$handleShowTransitionDialog = (state, action)=>({
        ...state,
        visibleTransitionDialog: action.payload.id
    });
const $098fcb414ea0f6e5$var$handleHideTransitionDialog = (state)=>({
        ...state,
        visibleTransitionDialog: undefined
    });
const $098fcb414ea0f6e5$var$handleTransition = (state, action)=>({
        ...state,
        inProgressTransitionId: action.payload.transitionId,
        transitionFailure: undefined
    });
function $098fcb414ea0f6e5$var$handleDecideApproval(state, action) {
    const approvalDecision = action.payload.approve ? 0 : 1;
    return {
        ...state,
        inProgressApprovalAction: approvalDecision
    };
}
const $098fcb414ea0f6e5$var$handleDecideApprovalFailure = (state)=>({
        ...state,
        inProgressApprovalAction: undefined
    });
const $098fcb414ea0f6e5$var$handleTransitionFailure = (state, action)=>({
        ...state,
        inProgressTransitionId: undefined,
        transitionFailure: action.payload.error
    });
const $098fcb414ea0f6e5$var$handleClearTransitionFailure = (state)=>({
        ...state,
        transitionFailure: undefined
    });
const $098fcb414ea0f6e5$var$handleCommentCreate = (state, action)=>({
        ...state,
        commentSubmitting: true,
        commentBeingSubmitted: action.payload.comment
    });
const $098fcb414ea0f6e5$var$handleCommentCreateSuccess = (state)=>({
        ...state,
        commentSubmitting: false,
        commentBeingSubmitted: undefined
    });
const $098fcb414ea0f6e5$var$handleCommentCreateFailure = (state)=>({
        ...state,
        commentSubmitting: false
    });

});


parcelRegister("1TDUH", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("88tWo")).requestListReducer);

var $88tWo = parcelRequire("88tWo");

});
parcelRegister("88tWo", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $e9e69e51ac478bdf$export$476a1a148617ffd3);
parcelRequire("evnRm");
var $4H6hH = parcelRequire("4H6hH");
const $e9e69e51ac478bdf$var$defaultState = {
    isLoading: false
};
function $e9e69e51ac478bdf$export$476a1a148617ffd3(state = $e9e69e51ac478bdf$var$defaultState, action) {
    switch(action.type){
        case 0, $4H6hH.FETCH_REQUEST_LIST_MODEL:
            return $e9e69e51ac478bdf$var$handleFetchRequestListAction(state);
        case 0, $4H6hH.FETCH_REQUEST_LIST_SUCCESS:
            return $e9e69e51ac478bdf$var$handleFetchRequestListSuccess(state);
        case 0, $4H6hH.FETCH_REQUEST_LIST_FAILURE:
            return $e9e69e51ac478bdf$var$handleFetchRequestListFailure(state);
        default:
            return state;
    }
}
const $e9e69e51ac478bdf$var$handleFetchRequestListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $e9e69e51ac478bdf$var$handleFetchRequestListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $e9e69e51ac478bdf$var$handleFetchRequestListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("lHJtM", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => (parcelRequire("ecAZc")).resendVerifyReducer);

var $ecAZc = parcelRequire("ecAZc");

});
parcelRegister("ecAZc", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => $50b24b99d9973928$export$92942a05b04ae72);
parcelRequire("9zH7Q");
var $gEJnZ = parcelRequire("gEJnZ");

var $aQyha = parcelRequire("aQyha");
const $50b24b99d9973928$export$49d5fc8cba920a0 = {
    value: (0, $aQyha.ResendStatus).NONE
};
function $50b24b99d9973928$export$92942a05b04ae72(state = $50b24b99d9973928$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $gEJnZ.FETCH_RESEND_VERIFY_EMAIL:
            return {
                value: (0, $aQyha.ResendStatus).RESENDING
            };
        case 0, $gEJnZ.FETCH_RESEND_VERIFICATION_SUCCESS:
            return {
                value: (0, $aQyha.ResendStatus).SUCCEEDED
            };
        case 0, $gEJnZ.FETCH_RESEND_VERIFICATION_FAILURE:
            return {
                errorStatus: action.payload.error,
                value: (0, $aQyha.ResendStatus).FAILED
            };
        default:
            return state;
    }
}

});
parcelRegister("aQyha", function(module, exports) {
$parcel$export(module.exports, "ResendStatus", () => $c13144b494879825$export$167f7de0a3de3f78);
const $c13144b494879825$export$167f7de0a3de3f78 = {
    NONE: 'NONE',
    RESENDING: 'RESENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};

});



parcelRegister("gEAzz", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("6pwYT")).resetPasswordReducer);

var $6pwYT = parcelRequire("6pwYT");

});
parcelRegister("6pwYT", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $677396c7cacc619b$export$b0c3be5071e95c02);
parcelRequire("5Hg3e");
var $k7T2u = parcelRequire("k7T2u");
const $677396c7cacc619b$var$defaultState = {
    isSubmitting: false
};
function $677396c7cacc619b$export$b0c3be5071e95c02(state = $677396c7cacc619b$var$defaultState, action) {
    switch(action.type){
        case 0, $k7T2u.RESET_PASSWORD:
            return $677396c7cacc619b$var$handleResetPassword(state);
        case 0, $k7T2u.RESET_PASSWORD_FAILURE:
            return $677396c7cacc619b$var$handleResetPasswordFailure(state, action);
        default:
            return state;
    }
}
const $677396c7cacc619b$var$handleResetPassword = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $677396c7cacc619b$var$handleResetPasswordFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("4qWt7", function(module, exports) {
$parcel$export(module.exports, "searchReducer", () => (parcelRequire("gFntF")).default);

var $gFntF = parcelRequire("gFntF");

});
parcelRegister("gFntF", function(module, exports) {
$parcel$export(module.exports, "default", () => $c449cc9725519cce$export$2e2bcd8739ae039);
parcelRequire("bAzYZ");
var $hncVy = parcelRequire("hncVy");

var $diqlM = parcelRequire("diqlM");

var $6rayQ = parcelRequire("6rayQ");
const $c449cc9725519cce$var$generateDefaultSearchResults = ()=>{
    return {
        portals: [],
        requestTypes: [],
        knowledgeBase: {
            articles: [],
            totalSize: 0
        }
    };
};
const $c449cc9725519cce$var$generateDefaultState = ()=>{
    const strings = $6rayQ.getAll();
    if (strings && strings.q !== undefined) return {
        shown: true,
        term: strings.q,
        time: strings.q_time ? +strings.q_time : undefined,
        hasError: false,
        isSearching: true,
        results: $c449cc9725519cce$var$generateDefaultSearchResults(),
        isSearchingPortals: true,
        isSearchingKb: true,
        isSearchingRequestTypes: true
    };
    return {
        shown: false,
        term: '',
        portalIds: [],
        time: undefined,
        hasError: false,
        isSearching: false,
        results: $c449cc9725519cce$var$generateDefaultSearchResults()
    };
};
const $c449cc9725519cce$var$portalResponseToState = (portal)=>({
        id: portal.id,
        name: portal.name,
        iconUrl: portal.logoUrl
    });
const $c449cc9725519cce$var$requestTypesResponseToState = (requestType)=>({
        id: requestType.id,
        portalId: requestType.cvId,
        name: requestType.name,
        portalName: requestType.portalName,
        iconUrl: requestType.iconUrl || `${0, $diqlM.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${requestType.icon}`,
        searchMetaData: requestType.searchMetaData
    });
function $c449cc9725519cce$export$2e2bcd8739ae039(state = $c449cc9725519cce$var$generateDefaultState(), action) {
    switch(action.type){
        case 0, $hncVy.SHOW_SEARCH:
            return {
                ...state,
                shown: action.payload.show,
                searchStartTime: undefined
            };
        case 0, $hncVy.RESET_SEARCH:
            return {
                shown: false,
                term: '',
                time: undefined,
                hasError: false,
                isSearching: false,
                results: $c449cc9725519cce$var$generateDefaultSearchResults()
            };
        case 0, $hncVy.SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined,
                isSearchingPortals: true,
                isSearchingKb: true,
                isSearchingRequestTypes: true
            };
        case 0, $hncVy.FETCH_KB_SEARCH_RESULTS:
            return {
                ...state,
                isSearchingKb: true
            };
        case 0, $hncVy.UPDATE_SEARCH_RESULTS:
            {
                const result = action.payload;
                const newResultState = {
                    portals: result.portals ? result.portals.map($c449cc9725519cce$var$portalResponseToState) : [],
                    requestTypes: result.requestTypes ? result.requestTypes.map($c449cc9725519cce$var$requestTypesResponseToState) : [],
                    knowledgeBase: $c449cc9725519cce$var$mapKnowledgeBaseResponseToState(result)
                };
                return {
                    ...state,
                    results: newResultState,
                    isSearching: false
                };
            }
        case 0, $hncVy.UPDATE_SEARCH_RESULTS_BY_TYPE:
            {
                var _newResultState;
                const { searchType: searchType, payload: result } = action;
                let newResultState;
                if (searchType === 'portals') newResultState = {
                    results: {
                        ...state.results,
                        portals: result.portals ? result.portals.map($c449cc9725519cce$var$portalResponseToState) : []
                    },
                    isSearchingPortals: false
                };
                if (searchType === 'requestTypes') newResultState = {
                    results: {
                        ...state.results,
                        requestTypes: result.requestTypes ? result.requestTypes.map($c449cc9725519cce$var$requestTypesResponseToState) : []
                    },
                    isSearchingRequestTypes: false
                };
                if (searchType === 'kbs') newResultState = {
                    results: {
                        ...state.results,
                        knowledgeBase: $c449cc9725519cce$var$mapKnowledgeBaseResponseToState(result)
                    },
                    isSearchingKb: false
                };
                return {
                    ...state,
                    ...newResultState ?? {},
                    isSearching: ((_newResultState = newResultState) === null || _newResultState === void 0 ? void 0 : _newResultState.isSearchingKb) === false ? false : state.isSearching
                };
            }
        case 0, $hncVy.CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                isSearching: false,
                results: $c449cc9725519cce$var$generateDefaultSearchResults(),
                searchStartTime: undefined
            };
        case 0, $hncVy.FETCH_SEARCH_RESULTS:
            return {
                ...state,
                searchStartTime: action.payload.searchStartTime
            };
        case 0, $hncVy.UPDATE_SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined
            };
        default:
            return state;
    }
}
const $c449cc9725519cce$var$mapKnowledgeBaseResponseToState = (result)=>{
    return result.kbs ? result.kbs : {
        articles: [],
        totalSize: 0
    };
};

});


parcelRegister("lkkwd", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => (parcelRequire("a94lS")).checkEmailUiReducer);

var $a94lS = parcelRequire("a94lS");

});
parcelRegister("a94lS", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => $94de28541ed31454$export$a518ffb70e2a23c8);
parcelRequire("eDtG6");
var $5Eeij = parcelRequire("5Eeij");
const $94de28541ed31454$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    resendValidationLinkDisabled: false
};
function $94de28541ed31454$export$a518ffb70e2a23c8(state = $94de28541ed31454$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $5Eeij.ENABLE_RESEND_VALIDATION_EMAIL_LINK:
            return $94de28541ed31454$var$handleEnableResendValidationLink(state);
        case 0, $5Eeij.RESEND_VALIDATION_EMAIL:
            return $94de28541ed31454$var$handleResendValidationEmail(state);
        case 0, $5Eeij.RESEND_VALIDATION_EMAIL_SUCCESS:
            return $94de28541ed31454$var$handleResendValidationEmailSuccess(state);
        case 0, $5Eeij.RESEND_VALIDATION_EMAIL_FAILURE:
            return $94de28541ed31454$var$handleResendValidationEmailFailure(state);
        default:
            return state;
    }
}
const $94de28541ed31454$var$handleEnableResendValidationLink = (state)=>({
        ...state,
        resendValidationLinkDisabled: false
    });
const $94de28541ed31454$var$handleResendValidationEmail = (state)=>({
        ...state,
        isSubmitting: true,
        resendValidationLinkDisabled: true
    });
const $94de28541ed31454$var$handleResendValidationEmailSuccess = (state)=>({
        ...state,
        isSubmitting: false
    });
const $94de28541ed31454$var$handleResendValidationEmailFailure = (state)=>({
        ...state,
        isSubmitting: false
    });

});


parcelRegister("dC0ZE", function(module, exports) {
$parcel$export(module.exports, "topicsReducer", () => (parcelRequire("4ca1f")).default);

var $4ca1f = parcelRequire("4ca1f");

});
parcelRegister("4ca1f", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7183d546c8de780$export$2e2bcd8739ae039);
parcelRequire("88ZJe");
var $48epN = parcelRequire("48epN");
const $b7183d546c8de780$export$b81eca7e0c669bb0 = {
    fetchKey: 0
};
function $b7183d546c8de780$export$2e2bcd8739ae039(state = $b7183d546c8de780$export$b81eca7e0c669bb0, action) {
    if (action.type === (0, $48epN.UPDATE_TOPICS_FETCH_KEY)) return {
        ...state,
        fetchKey: state.fetchKey + 1
    };
    return state;
}

});
parcelRegister("88ZJe", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => (parcelRequire("48epN")).UPDATE_TOPICS_FETCH_KEY);

var $48epN = parcelRequire("48epN");

});
parcelRegister("48epN", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => $73e974a8e5b9185e$export$9b3f2f1c719b0f8e);
const $73e974a8e5b9185e$export$9b3f2f1c719b0f8e = 'state.ui.topics.UPDATE_TOPICS_FETCH_KEY';
const $73e974a8e5b9185e$export$ff571764686d6022 = ()=>({
        type: $73e974a8e5b9185e$export$9b3f2f1c719b0f8e
    });

});




parcelRegister("G3Jkm", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => (parcelRequire("9nQ8n")).userProfileReducer);

var $9nQ8n = parcelRequire("9nQ8n");

});
parcelRegister("9nQ8n", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => $5dcbc33576c9703d$export$6a0a871f19e6c5f6);
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");
const $5dcbc33576c9703d$var$defaultState = {
    saveInProgress: false,
    changePasswordInProgress: false,
    showChangePasswordDialog: false,
    changePasswordErrors: {},
    saveUserProfileErrors: {},
    sendForgotPasswordEmailInProgress: false
};
function $5dcbc33576c9703d$export$6a0a871f19e6c5f6(state = $5dcbc33576c9703d$var$defaultState, action) {
    switch(action.type){
        case 0, $7m3Xa.SAVE_USER_PROFILE:
            return $5dcbc33576c9703d$var$handleSaveUserProfile(state);
        case 0, $7m3Xa.SAVE_USER_PROFILE_FAILURE:
            return $5dcbc33576c9703d$var$handleSaveUserProfileFailure(state);
        case 0, $7m3Xa.SET_USER_PROFILE_VALIDATION_ERRORS:
            return $5dcbc33576c9703d$var$handleSetUserProfileValidationErrors(state, action);
        case 0, $7m3Xa.SAVE_USER_PROFILE_SUCCESS:
            return $5dcbc33576c9703d$var$handleSaveUserProfileSuccess(state);
        case 0, $7m3Xa.SHOW_CHANGE_PASSWORD_DIALOG:
            return $5dcbc33576c9703d$var$handleShowChangePasswordDialog(state);
        case 0, $7m3Xa.CLOSE_CHANGE_PASSWORD_DIALOG:
            return $5dcbc33576c9703d$var$handleCloseChangePasswordDialog(state);
        case 0, $7m3Xa.CHANGE_PASSWORD:
            return $5dcbc33576c9703d$var$handleChangePassword(state);
        case 0, $7m3Xa.CHANGE_PASSWORD_SUCCESS:
            return $5dcbc33576c9703d$var$handleChangePasswordSuccess(state);
        case 0, $7m3Xa.CHANGE_PASSWORD_FAILURE:
            return $5dcbc33576c9703d$var$handleChangePasswordFailure(state, action);
        case 0, $7m3Xa.VALIDATE_PASSWORD_SUCCESS:
            return $5dcbc33576c9703d$var$handleValidatePasswordSuccess(state);
        case 0, $7m3Xa.USER_PROFILE_FORGOT_PASSWORD:
            return $5dcbc33576c9703d$var$handleForgotPassword(state);
        case 0, $7m3Xa.USER_PROFILE_FORGOT_PASSWORD_FAILURE:
            return $5dcbc33576c9703d$var$handleForgotPasswordFailure(state);
        case 0, $7m3Xa.USER_PROFILE_FORGOT_PASSWORD_SUCCESS:
            return $5dcbc33576c9703d$var$handleForgotPasswordSuccess(state);
        default:
            return state;
    }
}
const $5dcbc33576c9703d$var$handleSaveUserProfile = (state)=>({
        ...state,
        saveInProgress: true
    });
const $5dcbc33576c9703d$var$handleSaveUserProfileFailure = (state)=>({
        ...state,
        saveInProgress: false
    });
function $5dcbc33576c9703d$var$handleSetUserProfileValidationErrors(state, action) {
    const { nameError: nameError, timezoneError: timezoneError } = action.payload;
    return {
        ...state,
        saveUserProfileErrors: {
            nameError: nameError,
            timezoneError: timezoneError
        }
    };
}
const $5dcbc33576c9703d$var$handleSaveUserProfileSuccess = (state)=>({
        ...state,
        saveInProgress: false
    });
const $5dcbc33576c9703d$var$handleShowChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: true
    });
const $5dcbc33576c9703d$var$handleCloseChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordErrors: {}
    });
const $5dcbc33576c9703d$var$handleValidatePasswordSuccess = (state)=>({
        ...state,
        changePasswordErrors: {}
    });
const $5dcbc33576c9703d$var$handleChangePassword = (state)=>({
        ...state,
        changePasswordInProgress: true,
        changePasswordErrors: {}
    });
const $5dcbc33576c9703d$var$handleChangePasswordSuccess = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordInProgress: false,
        changePasswordErrors: {}
    });
const $5dcbc33576c9703d$var$handleChangePasswordFailure = (state, action)=>({
        ...state,
        changePasswordInProgress: false,
        changePasswordErrors: {
            currentPasswordError: action.payload.currentPasswordError,
            newPasswordError: action.payload.newPasswordError,
            confirmPasswordError: action.payload.confirmPasswordError,
            generalError: action.payload.generalError
        }
    });
const $5dcbc33576c9703d$var$handleForgotPassword = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: true,
        showChangePasswordDialog: true
    });
const $5dcbc33576c9703d$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: true
    });
const $5dcbc33576c9703d$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: false
    });

});





parcelRegister("cYiNs", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerTypeProvider", () => $f92ff671809214fb$export$e70650df369196ac);

var $fc4bM = parcelRequire("fc4bM");

var $cKOBE = parcelRequire("cKOBE");

var $lOioC = parcelRequire("lOioC");

var $eENmG = parcelRequire("eENmG");
const $f92ff671809214fb$export$e70650df369196ac = ({ children: children })=>{
    const [helpSeekerTypeAttributes, setHelpSeekerTypeAttributes] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState({
        isUserDomainSameAsAdmin: (0, $cKOBE.helpSeekerTypeAttributeValue).UNIDENTIFIED,
        isUserDomainInApprovedDomains: (0, $cKOBE.helpSeekerTypeAttributeValue).UNIDENTIFIED
    });
    const config = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $lOioC.AtlassianHelpConfigContext));
    const constructHelpSeekerTypeResponse = (isUserDomainSameAsAdmin, isUserDomainInApprovedDomains, isUserLoggedIn)=>({
            isUserDomainSameAsAdmin: isUserDomainSameAsAdmin,
            isUserDomainInApprovedDomains: isUserDomainInApprovedDomains,
            isUserLoggedIn: isUserLoggedIn
        });
    const evaluateHelpSeekerTypeAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        if (config.accountType === 'customer') (0, $cKOBE.getHelpSeekerTypeAttributes)().subscribe((response)=>{
            setHelpSeekerTypeAttributes({
                ...response,
                isUserLoggedIn: true
            });
        });
        else if (config.accountType === 'atlassian') setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $cKOBE.helpSeekerTypeAttributeValue).YES, (0, $cKOBE.helpSeekerTypeAttributeValue).YES, true));
        else setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $cKOBE.helpSeekerTypeAttributeValue).NO, (0, $cKOBE.helpSeekerTypeAttributeValue).NO, false));
    }, [
        config
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        evaluateHelpSeekerTypeAttributes();
    }, [
        evaluateHelpSeekerTypeAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eENmG.AnalyticsContext), {
        attributes: helpSeekerTypeAttributes
    }, children);
};

});
parcelRegister("cKOBE", function(module, exports) {
$parcel$export(module.exports, "helpSeekerTypeAttributeValue", () => $75046e220ad97414$export$5f93b09705cc6a59);
$parcel$export(module.exports, "getHelpSeekerTypeAttributes", () => $75046e220ad97414$export$ea5de7279b843e51);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");

var $2AdoZ = parcelRequire("2AdoZ");
const $75046e220ad97414$export$5f93b09705cc6a59 = Object.freeze({
    YES: 'Yes',
    NO: 'No',
    UNIDENTIFIED: 'Unidentified'
});
const $75046e220ad97414$export$ea5de7279b843e51 = (basePath = (0, $diqlM.contextPath))=>{
    const uri = `${basePath}/rest/servicedesk/1/customer/analytics/help-seeker/type`;
    const localStorageHelpSeekerTypeResponse = (0, $2AdoZ.getLocalStorageItem)('help-seeker-type');
    if (localStorageHelpSeekerTypeResponse) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $jFk35.Observable).of(JSON.parse(localStorageHelpSeekerTypeResponse));
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        (0, $2AdoZ.setLocalStorageItem)('help-seeker-type', JSON.stringify(response));
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response;
    }).catch(()=>{
        return (0, $jFk35.Observable).of({
            isUserDomainSameAsAdmin: $75046e220ad97414$export$5f93b09705cc6a59.UNIDENTIFIED,
            isUserDomainInApprovedDomains: $75046e220ad97414$export$5f93b09705cc6a59.UNIDENTIFIED
        });
    });
};

});

parcelRegister("lOioC", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelpConfigContext", () => $494b3d0f04796073$export$15b13d6286254aba);
$parcel$export(module.exports, "default", () => $494b3d0f04796073$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");
const $494b3d0f04796073$export$eec32b9030a890bc = (config)=>({
        accountId: config.accountId,
        accountType: config.accountType,
        userLocale: config.userLocale,
        sdPluginVersion: config.sdPluginVersion || '',
        contextPath: config.contextPath,
        environment: config.environment,
        tenantId: config.tenantId,
        activationId: config.activationId,
        helpCenterARI: config.helpCenterARI
    });
const $494b3d0f04796073$export$b5f4a66c86673938 = (config)=>({
        environment: config.environment,
        featureFlags: config.featureFlags || {},
        wacLink: config.wacLink,
        contactLink: config.contactLink,
        headless: config.headless || false,
        serviceDeskVersion: config.serviceDeskVersion || '',
        contextPath: config.contextPath,
        xsrfToken: config.xsrfToken || '',
        baseUrl: config.baseUrl,
        relativeBaseUrl: config.relativeBaseUrl,
        anonymousEnabled: config.anonymousEnabled || false,
        requestIntroEnabled: config.requestIntroEnabled || false,
        mediaApiExternalUrl: config.mediaApiExternalUrl || '',
        mediaApiAppClientId: config.mediaApiAppClientId || '',
        fabricEmojiUrl: config.fabricEmojiUrl || '',
        jiraDisplayUrl: config.jiraDisplayUrl,
        featuredValues: config.featuredValues || {},
        siteDefaultLanguageTag: config.siteDefaultLanguageTag || 'en-US',
        helpCenterType: config.helpCenterType || (0, $9mazR.DEFAULT_HELP_CENTER_TYPE),
        hoistedProjectKey: config.hoistedProjectKey || undefined,
        hoistedProjectId: config.hoistedProjectId,
        helpCenterHomePageSlug: config.helpCenterHomePageSlug || '',
        customerAccountAvailabilty: config.customerAccountAvailabilty || (0, $9mazR.DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY)
    });
const $494b3d0f04796073$export$15b13d6286254aba = /*#__PURE__*/ $fc4bM.createContext({});
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
const $494b3d0f04796073$var$MetaDataProvider = ({ children: children, config: config, updateEnvAction: updateEnvAction, updateMetaAction: updateMetaAction })=>{
    // We can add React context here in the future once relay is introduced and get rid of reducers altogether
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    const Env = $494b3d0f04796073$export$b5f4a66c86673938(config);
    const Meta = $494b3d0f04796073$export$eec32b9030a890bc(config);
    $fc4bM.useMemo(()=>{
        updateMetaAction(Meta);
        updateEnvAction(Env);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        Env,
        Meta
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($494b3d0f04796073$export$15b13d6286254aba.Provider, {
        value: config
    }, children);
};
var $494b3d0f04796073$export$2e2bcd8739ae039 = $494b3d0f04796073$var$MetaDataProvider;

});


parcelRegister("bqVIG", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => (parcelRequire("9uFN1")).EngagementProviderWrapper);

var $9uFN1 = parcelRequire("9uFN1");

});
parcelRegister("9uFN1", function(module, exports) {
$parcel$export(module.exports, "EngagementProviderWrapper", () => $5ddad54c0de28eed$export$a055f8fe7b78f866);

var $fc4bM = parcelRequire("fc4bM");

var $7CgCI = parcelRequire("7CgCI");

var $djGht = parcelRequire("djGht");

var $iya1I = parcelRequire("iya1I");

var $7wx9B = parcelRequire("7wx9B");
const $5ddad54c0de28eed$export$a055f8fe7b78f866 = ({ config: config, analyticsClientInstance: analyticsClientInstance, children: children })=>{
    const epConfig = {
        environment: config.environment,
        cloudId: config.tenantId,
        aaid: config.accountId,
        locale: config.userLocale,
        product: 'jira',
        subProduct: 'serviceDesk',
        stargateUrl: '/gateway/api'
    };
    const renderOnError = (0, $fc4bM.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        id: 'engagement-provider-error',
        renderError: renderOnError,
        onError: (0, $7wx9B.reportError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7CgCI.default), {
        config: epConfig,
        analyticsClientInstance: analyticsClientInstance,
        coordinationOptions: {
            enableChoreographer: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $djGht.EngagementMessages), null), children)));
};

});
parcelRegister("7CgCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $527aae49e02f005d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");

var $9gtPX = parcelRequire("9gtPX");

var $l3h7c = parcelRequire("l3h7c");

var $a1iHX = parcelRequire("a1iHX");
const $527aae49e02f005d$var$EngagementProviderWithEvents = (0, $azARG.default)()((0, $a1iHX.EngagementProvider));
const $527aae49e02f005d$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($527aae49e02f005d$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $l3h7c.default)(props.config)
    });
};
// eslint-disable-next-line camelcase
const $527aae49e02f005d$var$_default_1 = (0, $9gtPX.default)($527aae49e02f005d$var$EngagementProviderWithDefaultStore);
var // eslint-disable-next-line camelcase
$527aae49e02f005d$export$2e2bcd8739ae039 = $527aae49e02f005d$var$_default_1;

});
parcelRegister("9gtPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $dadf23e7e617a734$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $dadf23e7e617a734$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props))));
    };
}

});

parcelRegister("l3h7c", function(module, exports) {
$parcel$export(module.exports, "store", () => $586ddd8169b70ff3$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $586ddd8169b70ff3$export$2e2bcd8739ae039);

var $3ZJj6 = parcelRequire("3ZJj6");
parcelRequire("UZaDE");
var $6tkGS = parcelRequire("6tkGS");

var $cqgav = parcelRequire("cqgav");

var $7fTuJ = parcelRequire("7fTuJ");

var $aWhkW = parcelRequire("aWhkW");

var $1NxpF = parcelRequire("1NxpF");
const $586ddd8169b70ff3$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $586ddd8169b70ff3$var$processMessagesCancellationToken = (0, $cqgav.createCancellationToken)();
function $586ddd8169b70ff3$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $586ddd8169b70ff3$export$6f57813fe9f31bf9 = (0, $6tkGS.default)((state = $586ddd8169b70ff3$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $aWhkW.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $aWhkW.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $aWhkW.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $586ddd8169b70ff3$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $aWhkW.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $aWhkW.RESET_STORE:
            return $586ddd8169b70ff3$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $586ddd8169b70ff3$export$2e2bcd8739ae039 = (config)=>{
    const state = $586ddd8169b70ff3$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $586ddd8169b70ff3$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $586ddd8169b70ff3$var$processMessagesCancellationToken.isCancelled = true;
        $586ddd8169b70ff3$var$processMessagesCancellationToken = (0, $cqgav.createCancellationToken)();
        $586ddd8169b70ff3$export$6f57813fe9f31bf9.dispatch((0, $aWhkW.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $586ddd8169b70ff3$export$6f57813fe9f31bf9.dispatch((0, $aWhkW.initialize)(newConfig));
    if ((0, $7fTuJ.isMessagingEnabled)()) (0, $1NxpF.processMessages)($586ddd8169b70ff3$export$6f57813fe9f31bf9, newConfig, $586ddd8169b70ff3$var$processMessagesCancellationToken);
    return $586ddd8169b70ff3$export$6f57813fe9f31bf9;
};

});
parcelRegister("3ZJj6", function(module, exports) {

var $6iJje = parcelRequire("6iJje");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $2e8a36a47f3485c1$var$isEqual(value, other) {
    return $6iJje(value, other);
}
module.exports = $2e8a36a47f3485c1$var$isEqual;

});

parcelRegister("cqgav", function(module, exports) {
$parcel$export(module.exports, "createCancellationToken", () => $4863a5385ab57a3c$export$eac027797b968991);
function $4863a5385ab57a3c$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("7fTuJ", function(module, exports) {
$parcel$export(module.exports, "isMessagingEnabled", () => $2953903212dc308a$export$a77934ac158768dd);

var $7rEw1 = parcelRequire("7rEw1");
function $2953903212dc308a$export$a77934ac158768dd() {
    return !(0, $7rEw1.isFedRamp)();
}

});

parcelRegister("aWhkW", function(module, exports) {
$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $389e77dc1cad502d$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $389e77dc1cad502d$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $389e77dc1cad502d$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $389e77dc1cad502d$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $389e77dc1cad502d$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $389e77dc1cad502d$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $389e77dc1cad502d$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $389e77dc1cad502d$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $389e77dc1cad502d$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $389e77dc1cad502d$export$96105f873ade39d7);
const $389e77dc1cad502d$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $389e77dc1cad502d$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $389e77dc1cad502d$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $389e77dc1cad502d$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $389e77dc1cad502d$export$a9319af002a4c677 = 'SET_CURRENT';
const $389e77dc1cad502d$export$a20a1205b2a2b7e4 = ()=>({
        type: $389e77dc1cad502d$export$874c5149d7f0e3b8
    });
const $389e77dc1cad502d$export$2a47f398eeff8b01 = (config)=>({
        type: $389e77dc1cad502d$export$eacd3ec165715d8,
        config: config
    });
const $389e77dc1cad502d$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $389e77dc1cad502d$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $389e77dc1cad502d$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $389e77dc1cad502d$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $389e77dc1cad502d$export$96105f873ade39d7() {
    return {
        type: $389e77dc1cad502d$export$cb5041d68cb18859
    };
}

});

parcelRegister("1NxpF", function(module, exports) {
$parcel$export(module.exports, "processMessages", () => $879ffd38856cbfad$export$d2e92820f98a2592);

var $1bWUp = parcelRequire("1bWUp");

var $aWhkW = parcelRequire("aWhkW");

var $l3h7c = parcelRequire("l3h7c");
const $879ffd38856cbfad$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $879ffd38856cbfad$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $l3h7c.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $1bWUp.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $879ffd38856cbfad$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $aWhkW.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $879ffd38856cbfad$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("1bWUp", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $c705ce1699f0ebc8$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $c705ce1699f0ebc8$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $c705ce1699f0ebc8$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $c705ce1699f0ebc8$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $c705ce1699f0ebc8$export$3683393f780c6905);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ 
var $4bWm5 = parcelRequire("4bWm5");
const $c705ce1699f0ebc8$export$f4d1b02d312560f5 = '2';
async function $c705ce1699f0ebc8$export$8c20ab16ac9cf14f(_cloudId, _stargateUrl, _product, _locale) {
    return {
        messages: [],
        interval: 0
    };
}
var $c705ce1699f0ebc8$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $c705ce1699f0ebc8$var$choreographerPlugin;
async function $c705ce1699f0ebc8$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $c705ce1699f0ebc8$var$startMessageWithChoreographer(startMessageConfig, options);
    return $c705ce1699f0ebc8$var$startMessageWithCoordination(startMessageConfig);
}
async function $c705ce1699f0ebc8$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $c705ce1699f0ebc8$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $c705ce1699f0ebc8$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $c705ce1699f0ebc8$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$c705ce1699f0ebc8$var$choreographerPlugin) $c705ce1699f0ebc8$var$choreographerPlugin = new (0, $4bWm5.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $c705ce1699f0ebc8$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$c705ce1699f0ebc8$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $c705ce1699f0ebc8$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$c705ce1699f0ebc8$var$choreographerPlugin) $c705ce1699f0ebc8$var$choreographerPlugin = new (0, $4bWm5.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $c705ce1699f0ebc8$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$c705ce1699f0ebc8$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $c705ce1699f0ebc8$var$startMessageWithCoordination(_startMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $c705ce1699f0ebc8$var$stopMessageWithCoordination(_stopMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $c705ce1699f0ebc8$export$e1fd1449cf83c1f5(_cloudId, _stargateUrl, _messageId, _payload) {
    return Promise.resolve();
}
async function $c705ce1699f0ebc8$export$3683393f780c6905(_seenMessageConfig) {
    return Promise.resolve();
}

});
parcelRegister("4bWm5", function(module, exports) {
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $7ecf1271d46df036$export$da23bd36e2d631b);

var $jVG9w = parcelRequire("jVG9w");

var $k5pFc = parcelRequire("k5pFc");

var $19m4B = parcelRequire("19m4B");

var $acI0T = parcelRequire("acI0T");

var $73Epl = parcelRequire("73Epl");
const $7ecf1271d46df036$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $7ecf1271d46df036$export$da23bd36e2d631b extends (0, $73Epl.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $k5pFc.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $k5pFc.MessageAction).START || event.action !== (0, $k5pFc.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $jVG9w.Choreographer).getInstance().getCurrentMessage() ?? (0, $jVG9w.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $7ecf1271d46df036$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $19m4B.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $k5pFc.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $acI0T.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $k5pFc.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $k5pFc.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $19m4B.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $k5pFc.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("jVG9w", function(module, exports) {
$parcel$export(module.exports, "Choreographer", () => $2e4e6cc4f402dd61$export$236158f15971c92e);

var $dRkX9 = parcelRequire("dRkX9");

var $k5pFc = parcelRequire("k5pFc");

var $19m4B = parcelRequire("19m4B");

var $acI0T = parcelRequire("acI0T");

var $gOklo = parcelRequire("gOklo");

var $4uc0Z = parcelRequire("4uc0Z");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $2e4e6cc4f402dd61$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $2e4e6cc4f402dd61$var$singleton;
class $2e4e6cc4f402dd61$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        if (typeof window !== 'undefined') {
            var _window$postOffice, _window$postOffice2;
            if ((_window$postOffice = window.postOffice) !== null && _window$postOffice !== void 0 && (_window$postOffice = _window$postOffice.choreographer) !== null && _window$postOffice !== void 0 && _window$postOffice.singleton) return window.postOffice.choreographer.singleton;
            window.postOffice = {
                ...window.postOffice,
                choreographer: {
                    ...(_window$postOffice2 = window.postOffice) === null || _window$postOffice2 === void 0 ? void 0 : _window$postOffice2.choreographer,
                    singleton: new this()
                }
            };
            return window.postOffice.choreographer.singleton;
        }
        if (!$2e4e6cc4f402dd61$var$singleton) $2e4e6cc4f402dd61$var$singleton = new this();
        return $2e4e6cc4f402dd61$var$singleton;
    }
    constructor(){
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            var _this$state$seenTrans;
            /*
     * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
     * of how many transactional messages we are showing to users.
     *
     * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
     * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
     * messages that are actually being shown to users.
     *
     * Thus, we track which messages have been seen and only log the first time we see a transactional message.
     */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = (props === null || props === void 0 ? void 0 : props.messageType) === (0, $k5pFc.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $dRkX9.fg)('post-office_choreographer_log_transactional_msg');
            const seen = (props === null || props === void 0 ? void 0 : props.messageId) && ((_this$state$seenTrans = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans === void 0 ? void 0 : _this$state$seenTrans.has(props.messageId));
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && (props === null || props === void 0 ? void 0 : props[toggleableProp]);
            if (isTransactional && props !== null && props !== void 0 && props.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                var _this$state$seenTrans2, _this$getCurrentMessa;
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                (_this$state$seenTrans2 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans2 === void 0 || _this$state$seenTrans2.add(props.messageId);
                const logger = new (0, $acI0T.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: (_this$getCurrentMessa = this.getCurrentMessage()) === null || _this$getCurrentMessa === void 0 ? void 0 : _this$getCurrentMessa.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $gOklo.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                timestamp: Date.now(),
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   *
   * @param [plugin] An optional plugin instance
   */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            var _this$state$currentMe, _this$state$currentMe2, _this$state$currentMe3, _this$state$currentMe4;
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $k5pFc.MessageAction).START;
            const logger = new (0, $acI0T.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $19m4B.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: (_this$state$currentMe = this.state.currentMessage) === null || _this$state$currentMe === void 0 ? void 0 : _this$state$currentMe.productId,
                blockedByMessageId: (_this$state$currentMe2 = this.state.currentMessage) === null || _this$state$currentMe2 === void 0 ? void 0 : _this$state$currentMe2.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $k5pFc.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: (_this$state$currentMe3 = this.state.currentMessage) === null || _this$state$currentMe3 === void 0 ? void 0 : _this$state$currentMe3.productId,
                    blockedByMessageId: (_this$state$currentMe4 = this.state.currentMessage) === null || _this$state$currentMe4 === void 0 ? void 0 : _this$state$currentMe4.messageId
                }
            });
            resolve((0, $k5pFc.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $2e4e6cc4f402dd61$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Returns a snapshot of messages currently queued behind an in-flight start or stop request.
   */ getQueuedMessages() {
        return this.state.messageQueue.map(({ messageId: messageId, productId: productId, timestamp: timestamp })=>({
                messageId: messageId,
                productId: productId,
                timestamp: timestamp
            }));
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
   * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
   * may conflict with messages shown in parent frames.
   *
   * If called outside an iframe then this function is a noop.
   *
   * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
   */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $4uc0Z.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        var _this$state$currentMe5;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this$state$currentMe5 = this.state.currentMessage) === null || _this$state$currentMe5 === void 0 ? void 0 : _this$state$currentMe5.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * Returns the registered messages for a product. This is used by diagnostics and tests to inspect
   * the current Choreographer registry without mutating it.
   *
   * @param productId Unique identifier for the product whose messages are being requested.
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $19m4B.DebugLogger)(productId, messageId);
        const actionSubject = (0, $k5pFc.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $acI0T.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$start;
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $k5pFc.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $k5pFc.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                var _this$state$queueingB, _this$state$queueingB2;
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${(_this$state$queueingB = this.state.queueingBehindMessage) === null || _this$state$queueingB === void 0 ? void 0 : _this$state$queueingB.productId} ${(_this$state$queueingB2 = this.state.queueingBehindMessage) === null || _this$state$queueingB2 === void 0 ? void 0 : _this$state$queueingB2.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                var _this$state$currentMe6, _this$state$currentMe7, _this$state$currentMe8, _this$state$currentMe9;
                logger.blocked({
                    blockedByProductId: (_this$state$currentMe6 = this.state.currentMessage) === null || _this$state$currentMe6 === void 0 ? void 0 : _this$state$currentMe6.productId,
                    blockedByMessageId: (_this$state$currentMe7 = this.state.currentMessage) === null || _this$state$currentMe7 === void 0 ? void 0 : _this$state$currentMe7.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $k5pFc.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: (_this$state$currentMe8 = this.state.currentMessage) === null || _this$state$currentMe8 === void 0 ? void 0 : _this$state$currentMe8.productId,
                        blockedByMessageId: (_this$state$currentMe9 = this.state.currentMessage) === null || _this$state$currentMe9 === void 0 ? void 0 : _this$state$currentMe9.messageId
                    }
                });
                return (0, $k5pFc.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await ((_message$start = message.start) === null || _message$start === void 0 ? void 0 : _message$start.call(message)) ?? true;
            if (didStart) {
                var _message$onStart;
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                (_message$onStart = message.onStart) === null || _message$onStart === void 0 || _message$onStart.call(message);
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $k5pFc.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $k5pFc.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $k5pFc.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $k5pFc.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $k5pFc.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $k5pFc.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $19m4B.DebugLogger)(productId, messageId);
        const actionSubject = (0, $k5pFc.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $acI0T.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$stop;
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $k5pFc.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $k5pFc.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await ((_message$stop = message.stop) === null || _message$stop === void 0 ? void 0 : _message$stop.call(message)) ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    var _message$onStop;
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    (_message$onStop = message.onStop) === null || _message$onStop === void 0 || _message$onStop.call(message);
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $k5pFc.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $k5pFc.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $k5pFc.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $k5pFc.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $k5pFc.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $k5pFc.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        var _this$state$messages$, _this$state$messages$2;
        return Boolean((_this$state$messages$ = this.state.messages.get(productId)) === null || _this$state$messages$ === void 0 || (_this$state$messages$2 = _this$state$messages$.has) === null || _this$state$messages$2 === void 0 ? void 0 : _this$state$messages$2.call(_this$state$messages$, messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        var _this$state$messages$3, _this$state$messages$4;
        (_this$state$messages$3 = this.state.messages.get(productId)) === null || _this$state$messages$3 === void 0 || (_this$state$messages$4 = _this$state$messages$3.delete) === null || _this$state$messages$4 === void 0 || _this$state$messages$4.call(_this$state$messages$3, messageId);
    }
    /**
   * This should only be used for test cleanup purposes.
   * Clears the seen transactional messages cache for a given productId.
   *
   * @param productId Unique identifier to clear the seen transactional messages cache for.
   */ clearSeenTransactionalMessages(productId) {
        var _this$state$seenTrans3;
        (_this$state$seenTrans3 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans3 === void 0 || _this$state$seenTrans3.clear();
    }
}

});
parcelRegister("k5pFc", function(module, exports) {
$parcel$export(module.exports, "MessageEventType", () => $29d15e4ab4e48af2$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $29d15e4ab4e48af2$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $29d15e4ab4e48af2$export$7fb117db98868be6);
$parcel$export(module.exports, "MessageTypesEnum", () => $29d15e4ab4e48af2$export$94e85cf3348f045a);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $29d15e4ab4e48af2$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $29d15e4ab4e48af2$export$865c0eaaa43d90f8);
const $29d15e4ab4e48af2$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $29d15e4ab4e48af2$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $29d15e4ab4e48af2$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    ProductIds["TRELLO"] = "trello";
    return ProductIds;
}({});
const $29d15e4ab4e48af2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $29d15e4ab4e48af2$export$dbe9e38c9d6f26d0 = [
    $29d15e4ab4e48af2$export$94e85cf3348f045a.ENGAGEMENT,
    $29d15e4ab4e48af2$export$94e85cf3348f045a.MARKETING
];
const $29d15e4ab4e48af2$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $29d15e4ab4e48af2$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("19m4B", function(module, exports) {
$parcel$export(module.exports, "DebugLogger", () => $6fe23fafd9f739d3$export$21e6cc849c1dc1ab);
function $6fe23fafd9f739d3$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $6fe23fafd9f739d3$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($6fe23fafd9f739d3$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $6fe23fafd9f739d3$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($6fe23fafd9f739d3$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $6fe23fafd9f739d3$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. log.info and log.verbose, which are functions that take an
   * object of any key/value pairs, which will be merged with the productId
   * and the messageId values passed to the constructor, and output via
   * console.table.
   *
   * Example: debugLogger.log({
   *   info: { foo: true },
   *   verbose: {
   *     foo: true,
   *     bar: 123,
   *     baz 'abc',
   *     timestamp: performance.now()
   *   },
   * });
   *
   * @param messages Record<LoggingLevels, Record<string, unknown>> An object
   * keyed by the desired log-level, with each value being an object of any
   * key/value pairs to be output to console.table.
   */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $6fe23fafd9f739d3$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. trace.info and trace.verbose, which are functions that take
   * a string to be used as the label for a stack trace via console.trace.
   *
   * Example: debugLogger.trace({
   *   info: 'This is a stack trace',
   *   verbose: `This is a stack trace with a much more verbose message which
   * contains data about the ${productId} and ${messageId} within my function,
   * invoked at ${performance.now()}ms`,
   * });
   *
   * @param messages Record<LoggingLevels, string> An object keyed by the
   * desired log-level, with each value being a string to be output as the
   * label to console.trace.
   */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $6fe23fafd9f739d3$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("acI0T", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $882687f7aca039fc$export$efa9a398d6368992);

var $k5pFc = parcelRequire("k5pFc");
class $882687f7aca039fc$export$efa9a398d6368992 {
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   * @param [plugin] An optional plugin instance.
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        var _plugin$shouldLogEven;
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if ((plugin === null || plugin === void 0 || (_plugin$shouldLogEven = plugin.shouldLogEvent) === null || _plugin$shouldLogEven === void 0 ? void 0 : _plugin$shouldLogEven.call(plugin, event)) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $k5pFc.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $k5pFc.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $k5pFc.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $k5pFc.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $k5pFc.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $k5pFc.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
}

});

parcelRegister("gOklo", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $ed13bc5a4eaacefd$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $ed13bc5a4eaacefd$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $ed13bc5a4eaacefd$export$7c574bc7a8b74124);

var $fc4bM = parcelRequire("fc4bM");

var $k5pFc = parcelRequire("k5pFc");
const $ed13bc5a4eaacefd$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions === null || coordinationOptions === void 0 ? void 0 : coordinationOptions.enableChoreographer) && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && (0, $k5pFc.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $ed13bc5a4eaacefd$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $fc4bM.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $ed13bc5a4eaacefd$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $fc4bM.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("4uc0Z", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $b143033118cf86ce$export$e6c5ffa684aac4d7);
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $b143033118cf86ce$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}

});


parcelRegister("73Epl", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPlugin", () => $cf7c44977ce1a20e$export$71324a662782c710);

var $2mgM4 = parcelRequire("2mgM4");

var $8BjzM = parcelRequire("8BjzM");

var $jVG9w = parcelRequire("jVG9w");
class $cf7c44977ce1a20e$export$71324a662782c710 {
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Returns the Analytics Web Client instance for this plugin.
   *
   * @returns AnalyticsWebClient instance
   */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $jVG9w.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $jVG9w.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $jVG9w.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $jVG9w.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $jVG9w.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $jVG9w.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp // TODO: Remove this once we no longer need transactional logs
    ) {
        return (0, $jVG9w.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $jVG9w.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $8BjzM.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $2mgM4.originType).WEB
        });
        return analyticsClient;
    }
}

});





parcelRegister("a1iHX", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $fc4bM = parcelRequire("fc4bM");

var $gI3BB = parcelRequire("gI3BB");

var $l6v5q = parcelRequire("l6v5q");

var $dso8W = parcelRequire("dso8W");

var $3riYO = parcelRequire("3riYO");

var $bcAyF = parcelRequire("bcAyF");

var $hH2zO = parcelRequire("hH2zO");

var $k5pFc = parcelRequire("k5pFc");

var $gOklo = parcelRequire("gOklo");

var $1bWUp = parcelRequire("1bWUp");

var $hxS8h = parcelRequire("hxS8h");

var $z0Dn5 = parcelRequire("z0Dn5");

var $hAt5Y = parcelRequire("hAt5Y");

var $7fTuJ = parcelRequire("7fTuJ");

var $aWhkW = parcelRequire("aWhkW");

var $eaL68 = parcelRequire("eaL68");
const $b5e7b3e6846bd245$var$MAX_EVENT_QUEUE_SIZE = 100;
const $b5e7b3e6846bd245$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $b5e7b3e6846bd245$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $b5e7b3e6846bd245$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $b5e7b3e6846bd245$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($gI3BB)))(payload, trigger);
    });
}
function $b5e7b3e6846bd245$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $bcAyF.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $b5e7b3e6846bd245$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $b5e7b3e6846bd245$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $b5e7b3e6846bd245$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $1bWUp.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $1bWUp.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $b5e7b3e6846bd245$var$fireExposureEvent($b5e7b3e6846bd245$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $1bWUp.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions !== null && coordinationOptions !== void 0 && coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $k5pFc.MessageDeliveryStatus).STARTED : (0, $k5pFc.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $b5e7b3e6846bd245$var$fireExposureEvent($b5e7b3e6846bd245$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $aWhkW.setCurrent)(eventMapping));
        }
    } else {
        $b5e7b3e6846bd245$var$fireExposureEvent($b5e7b3e6846bd245$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $aWhkW.setCurrent)(eventMapping));
    }
}
class $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c extends (0, $fc4bM.Component) {
    static #_ = this.componentConfig = new Map();
    static #_2 = this.childContextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
    };
    static #_3 = this.defaultProps = {
        eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($3riYO)))
    };
    static #_4 = /*
   * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
   * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
   */ this.hasInitializedAtLeastOneEngagementProvider = false;
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $z0Dn5.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $b5e7b3e6846bd245$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            var _eventMapping$compone;
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $b5e7b3e6846bd245$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $hAt5Y.default)({
                eventName: $b5e7b3e6846bd245$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $7fTuJ.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $b5e7b3e6846bd245$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if ((_eventMapping$compone = eventMapping.component) !== null && _eventMapping$compone !== void 0 && _eventMapping$compone.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $b5e7b3e6846bd245$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $b5e7b3e6846bd245$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            var _this$props$coordinat;
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean((_this$props$coordinat = this.props.coordinationOptions) === null || _this$props$coordinat === void 0 ? void 0 : _this$props$coordinat.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig !== null && componentConfig !== void 0 && componentConfig.messageType ? // Use the component's individual choreographer configuration, if defined,
                // regardless of the EngagementProvider's coordinationOptions
                (0, $gOklo.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $hxS8h.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $hxS8h.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $hxS8h.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $eaL68.default)($b5e7b3e6846bd245$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($l6v5q)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $1bWUp.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $k5pFc.MessageDeliveryStatus).STOPPED : (0, $k5pFc.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $b5e7b3e6846bd245$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $aWhkW.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
            channel: "*",
            onEvent: this.onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
            channel: "engagement",
            onEvent: this.onEngagementEvent
        }, this.props.children));
    }
}

});
parcelRegister("gI3BB", function(module, exports) {

var $7pq2K = parcelRequire("7pq2K");

var $ctnb9 = parcelRequire("ctnb9");
/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */ function $c2a38d677c2f8757$var$isMatch(object, source) {
    return object === source || $7pq2K(object, source, $ctnb9(source));
}
module.exports = $c2a38d677c2f8757$var$isMatch;

});

parcelRegister("l6v5q", function(module, exports) {

var $k3DoT = parcelRequire("k3DoT");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $f5d245a218762e6f$var$once(func) {
    return $k3DoT(2, func);
}
module.exports = $f5d245a218762e6f$var$once;

});
parcelRegister("k3DoT", function(module, exports) {

var $8G70j = parcelRequire("8G70j");
/** Error message constants. */ var $e9a2a69527c56c0b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $e9a2a69527c56c0b$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($e9a2a69527c56c0b$var$FUNC_ERROR_TEXT);
    n = $8G70j(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
module.exports = $e9a2a69527c56c0b$var$before;

});
parcelRegister("8G70j", function(module, exports) {

var $d0gN0 = parcelRequire("d0gN0");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6517add9816d8c38$var$toInteger(value) {
    var result = $d0gN0(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $6517add9816d8c38$var$toInteger;

});
parcelRegister("d0gN0", function(module, exports) {

var $gBct1 = parcelRequire("gBct1");
/** Used as references for various `Number` constants. */ var $97784c7811a456be$var$INFINITY = 1 / 0, $97784c7811a456be$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $97784c7811a456be$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $gBct1(value);
    if (value === $97784c7811a456be$var$INFINITY || value === -$97784c7811a456be$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $97784c7811a456be$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $97784c7811a456be$var$toFinite;

});
parcelRegister("gBct1", function(module, exports) {

var $iJOHE = parcelRequire("iJOHE");

var $e3M82 = parcelRequire("e3M82");

var $4NuiV = parcelRequire("4NuiV");
/** Used as references for various `Number` constants. */ var $c159c5c14b751aec$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $c159c5c14b751aec$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c159c5c14b751aec$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c159c5c14b751aec$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c159c5c14b751aec$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c159c5c14b751aec$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($4NuiV(value)) return $c159c5c14b751aec$var$NAN;
    if ($e3M82(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e3M82(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $iJOHE(value);
    var isBinary = $c159c5c14b751aec$var$reIsBinary.test(value);
    return isBinary || $c159c5c14b751aec$var$reIsOctal.test(value) ? $c159c5c14b751aec$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c159c5c14b751aec$var$reIsBadHex.test(value) ? $c159c5c14b751aec$var$NAN : +value;
}
module.exports = $c159c5c14b751aec$var$toNumber;

});
parcelRegister("iJOHE", function(module, exports) {

var $e91cA = parcelRequire("e91cA");
/** Used to match leading whitespace. */ var $da43c282ae0445de$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $da43c282ae0445de$var$baseTrim(string) {
    return string ? string.slice(0, $e91cA(string) + 1).replace($da43c282ae0445de$var$reTrimStart, '') : string;
}
module.exports = $da43c282ae0445de$var$baseTrim;

});
parcelRegister("e91cA", function(module, exports) {
/** Used to match a single whitespace character. */ var $a4c2d6a58837b608$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $a4c2d6a58837b608$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $a4c2d6a58837b608$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $a4c2d6a58837b608$var$trimmedEndIndex;

});







parcelRegister("3riYO", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("hxS8h", function(module, exports) {
$parcel$export(module.exports, "sendScreenEvent", () => $7d9a885d0974c932$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $7d9a885d0974c932$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $7d9a885d0974c932$export$e5f89b51c6d4e36b);
function $7d9a885d0974c932$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $7d9a885d0974c932$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $7d9a885d0974c932$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("z0Dn5", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $e266cf1cb0c39426$export$6c724a6ffa2dc3e1);
const $e266cf1cb0c39426$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $e266cf1cb0c39426$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $e266cf1cb0c39426$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $e266cf1cb0c39426$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $e266cf1cb0c39426$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $e266cf1cb0c39426$export$cda2203640e08931;
}

});

parcelRegister("hAt5Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb3536e6e9da8f0$export$2e2bcd8739ae039);
const $7cb3536e6e9da8f0$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $7cb3536e6e9da8f0$export$2e2bcd8739ae039 = $7cb3536e6e9da8f0$var$createCustomEvent;

});

parcelRegister("eaL68", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4b5ba538a320b6b$export$2e2bcd8739ae039);
class $a4b5ba538a320b6b$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("djGht", function(module, exports) {
$parcel$export(module.exports, "EngagementMessages", () => $a6b84254baf30f0d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $1dTKP = parcelRequire("1dTKP");

var $8e3DG = parcelRequire("8e3DG");

var $11vA2 = parcelRequire("11vA2");
class $a6b84254baf30f0d$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $11vA2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8e3DG.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1dTKP.default), null));
    }
}

});
parcelRegister("1dTKP", function(module, exports) {
$parcel$export(module.exports, "ContextualSurveyWithEvents", () => $357d4adb2fbb5633$export$42b694a35bb75eda);
$parcel$export(module.exports, "default", () => $357d4adb2fbb5633$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ContextualSurvey", () => (parcelRequire("jEdLK")).default);
// eslint-disable-next-line import/order

var $2q3ue = parcelRequire("2q3ue");

var $2Aekc = parcelRequire("2Aekc");

var $jEdLK = parcelRequire("jEdLK");
const $357d4adb2fbb5633$export$42b694a35bb75eda = (0, $2q3ue.default)((0, $jEdLK.default));
// eslint-disable-next-line camelcase
const $357d4adb2fbb5633$var$_default_1 = (0, $2Aekc.default)($357d4adb2fbb5633$export$42b694a35bb75eda, 'contextualSurvey');
var // eslint-disable-next-line camelcase
$357d4adb2fbb5633$export$2e2bcd8739ae039 = $357d4adb2fbb5633$var$_default_1;

});
parcelRegister("2q3ue", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb8e7a1241d7a4d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");
var $bfb8e7a1241d7a4d$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $fc4bM.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $azARG.default)()(EngagementEventsWrapper);
};

});

parcelRegister("2Aekc", function(module, exports) {
$parcel$export(module.exports, "default", () => $16854ee40342ea4e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");
var $16854ee40342ea4e$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $fc4bM.Component) {
        static #_ = this.contextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
        };
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $fc4bM.useState)(null);
        const unsubscribeRef = (0, $fc4bM.useRef)(null);
        const removeConfigRef = (0, $fc4bM.useRef)(null);
        const canSubscribe = (0, $fc4bM.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.subscribeEngagementState);
        }, [
            context
        ]);
        const canSetConfig = (0, $fc4bM.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.setComponentConfig);
        }, [
            context
        ]);
        const onStoreChange = (0, $fc4bM.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $fc4bM.useCallback)(()=>{
            var _context$subscribeEng;
            return context === null || context === void 0 || (_context$subscribeEng = context.subscribeEngagementState) === null || _context$subscribeEng === void 0 ? void 0 : _context$subscribeEng.call(context, onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $fc4bM.useCallback)((propsToUse = props)=>{
            var _context$setComponent;
            return context === null || context === void 0 || (_context$setComponent = context.setComponentConfig) === null || _context$setComponent === void 0 ? void 0 : _context$setComponent.call(context, getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $fc4bM.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $fc4bM.useRef)(engagementId);
        const previousMessageType = (0, $fc4bM.useRef)(messageType);
        const previousOnMessageDisposition = (0, $fc4bM.useRef)(onMessageDisposition);
        (0, $fc4bM.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("jEdLK", function(module, exports) {
$parcel$export(module.exports, "default", () => $51cb833110f132ad$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $jNqLG = parcelRequire("jNqLG");

var $1bWUp = parcelRequire("1bWUp");

var $ciE6N = parcelRequire("ciE6N");

var $9VoV9 = parcelRequire("9VoV9");
function $51cb833110f132ad$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jNqLG.default), {
        shouldShow: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9VoV9.default), {
            markAsSeenAndFatigued: (0, $1bWUp.markAsSeenAndFatigued),
            sendUserResponse: (0, $1bWUp.sendUserResponse),
            getFlag: (0, $ciE6N.getFlag),
            setFlag: (0, $ciE6N.setFlag),
            ...props
        }));
}

});
parcelRegister("jNqLG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b5e0e7a011569a4$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $iXBtU = parcelRequire("iXBtU");

var $jCsvE = parcelRequire("jCsvE");
// 8px is the base unit in pixels
const $1b5e0e7a011569a4$var$surveyOffset = "var(--ds-space-600, 48px)";
const $1b5e0e7a011569a4$var$marshalLayoutStyles = null;
const $1b5e0e7a011569a4$var$marshalMotionLayerStyles = null;
function $1b5e0e7a011569a4$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
        appear: true,
        children: shouldShow && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jCsvE.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            children: (motionProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    ref: motionProps.ref,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- motion keyframes
                    className: (0, $2R2iS.default)([
                        "_kqsw1n9t _1xi2oahv _94n5oahv",
                        "_1pbyni7l",
                        motionProps.className
                    ]),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- motion animation styles
                    style: motionProps.style,
                    children: children()
                })
        }, "contextual-survey-marshal")
    });
}

});

parcelRegister("ciE6N", function(module, exports) {
$parcel$export(module.exports, "getFlag", () => $0458e4a4319165f3$export$a19b74191e00c5e);
$parcel$export(module.exports, "setFlag", () => $0458e4a4319165f3$export$5e165df1e30a1331);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ async function $0458e4a4319165f3$export$a19b74191e00c5e(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return {
        status: false,
        lastSeenDate: ''
    };
}
async function $0458e4a4319165f3$export$5e165df1e30a1331(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return Promise.resolve();
}

});

parcelRegister("9VoV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $74258d0c8d1c5767$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bHNGw = parcelRequire("bHNGw");
const $74258d0c8d1c5767$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $74258d0c8d1c5767$export$2e2bcd8739ae039 extends (0, $fc4bM.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bHNGw.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $bHNGw.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        }, this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $74258d0c8d1c5767$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        }, this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        }, this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $74258d0c8d1c5767$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}

});
parcelRegister("bHNGw", function(module, exports) {
$parcel$export(module.exports, "DismissTrigger", () => $056d243730c1f6e0$export$151efc60ac534d42);
$parcel$export(module.exports, "default", () => $056d243730c1f6e0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $bXzcJ = parcelRequire("bXzcJ");

var $8lg1D = parcelRequire("8lg1D");

var $81dBa = parcelRequire("81dBa");

var $4664b = parcelRequire("4664b");

var $dr94L = parcelRequire("dr94L");

var $1QTC1 = parcelRequire("1QTC1");
var $056d243730c1f6e0$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
const $056d243730c1f6e0$export$3e8963a077f85f25 = 8000;
var $056d243730c1f6e0$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
    const autoDisappearTimeoutRef = (0, $fc4bM.useRef)(null);
    // only allow a single dismiss for a component
    const isDismissedRef = (0, $fc4bM.useRef)(false);
    const tryDismiss = (0, $fc4bM.useCallback)((trigger)=>{
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    const [currentStep, setCurrentStep] = (0, $fc4bM.useState)('SURVEY');
    const trySetCurrentStep = (0, $fc4bM.useCallback)((step)=>{
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    const onDismissRef = (0, $fc4bM.useRef)(onDismiss);
    (0, $fc4bM.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    // reset isDismissedRef.current on mount to be compatible with double render in react18 strict mode
    (0, $fc4bM.useEffect)(()=>{
        isDismissedRef.current = false;
    }, []);
    const tryClearTimeout = (0, $fc4bM.useCallback)(()=>{
        const id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $fc4bM.useEffect)(()=>{
        return function unmount() {
            tryClearTimeout();
            tryDismiss("UNMOUNT");
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    const onSurveySubmit = (0, $fc4bM.useCallback)(async (formValues, _form, callback = ()=>{})=>{
        // Submitting form: Phase 1 complete
        await onSubmit(formValues);
        // Note: need to call callback just before we navigate away
        // It cleans up the form (required)
        // Optional Phase 2: Asking to join Atlassian Research Group
        // Only enter phase 2 if:
        // 1. not already dismissed; AND
        // 2. permission given to contact; AND
        // 3. user has previously not answered mailing list question (getUserHasAnsweredMailingList returns false)
        // Not entering phase 2: User has dismissed while the submit promise was resolving
        if (isDismissedRef.current) {
            callback();
            return;
        }
        // Not entering phase 2: no permission given to respond to feedback
        if (!formValues.canContact) {
            callback();
            trySetCurrentStep('POST_SURVEY_NO_CONSENT');
            return;
        }
        const userHasAnswered = await getUserHasAnsweredMailingList();
        callback();
        // Not entering phase 2: user has already answered this question
        if (userHasAnswered) {
            trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
            return;
        }
        // Enter phase 2
        trySetCurrentStep('SIGN_UP_PROMPT');
    }, [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    const onMailingListResponse = (0, $fc4bM.useCallback)(async (answer)=>{
        await onMailingListAnswer(answer);
        if (answer) {
            trySetCurrentStep('SIGN_UP_SUCCESS');
            return;
        }
        // We have already thanked to user, we can simply close
        tryDismiss("FINISHED");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $fc4bM.useEffect)(()=>{
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            'SIGN_UP_SUCCESS',
            'POST_SURVEY_NO_CONSENT',
            'POST_SURVEY_HAS_SIGN_UP'
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $056d243730c1f6e0$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $1QTC1.default)({
        onDismiss: ()=>tryDismiss("MANUAL")
    });
    const content = (()=>{
        if (currentStep === 'SURVEY') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dr94L.default), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === 'SIGN_UP_PROMPT') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8lg1D.default), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === 'SIGN_UP_SUCCESS') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $81dBa.default), {});
        if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bXzcJ.default), {});
        return null;
    })();
    const manualDismiss = (0, $fc4bM.useCallback)(()=>{
        // clear any pending timers
        tryClearTimeout();
        tryDismiss("MANUAL");
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4664b.default), {
        onDismiss: manualDismiss,
        children: content
    });
};

});
parcelRegister("bXzcJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9efd5223ad5331f$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $1hJdJ = parcelRequire("1hJdJ");

var $7j6Zl = parcelRequire("7j6Zl");
var $b9efd5223ad5331f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7j6Zl.default), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
            size: "xsmall",
            children: "Thanks for your feedback"
        })
    });

});
parcelRegister("7j6Zl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8b4b5e1a2922c11$export$2e2bcd8739ae039);
/* SuccessContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fBVBf = parcelRequire("fBVBf");
const $e8b4b5e1a2922c11$var$sectionStyles = null;
const $e8b4b5e1a2922c11$var$iconContainerStyles = null;
var $e8b4b5e1a2922c11$export$2e2bcd8739ae039 = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsxs)("section", {
        className: (0, $2R2iS.default)([
            "_18u01jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_kqswstnw _154iv47k _1ltv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
                    spacing: "spacious",
                    label: "",
                    "aria-hidden": true,
                    color: "var(--ds-icon-success, #6A9A23)"
                })
            }),
            children
        ]
    });

});


parcelRegister("8lg1D", function(module, exports) {
$parcel$export(module.exports, "default", () => $884c6d8e216e0c45$export$2e2bcd8739ae039);
/* SignUpPrompt.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $5dzEI = parcelRequire("5dzEI");

var $1hJdJ = parcelRequire("1hJdJ");

var $dM0Q8 = parcelRequire("dM0Q8");

var $dBtOK = parcelRequire("dBtOK");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $7j6Zl = parcelRequire("7j6Zl");
const $884c6d8e216e0c45$var$buttonContainerStyles = null;
var $884c6d8e216e0c45$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
    const [pending, setPending] = (0, $fc4bM.useState)(null);
    const answeredWith = (0, $fc4bM.useCallback)(async (answer)=>{
        setPending(answer ? 'yes' : 'no');
        await onAnswer(answer);
    }, [
        setPending,
        onAnswer
    ]);
    const isDisabled = Boolean(pending);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $7j6Zl.default), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                size: "xsmall",
                children: "Thanks for your feedback"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                paddingBlockStart: "space.150",
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                            as: "p",
                            children: "Are you interested in participating in our research?"
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $k8Adr.Text), {
                            as: "p",
                            children: [
                                "Sign up for the",
                                ' ',
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dM0Q8.default), {
                                    href: "https://www.atlassian.com/research-group",
                                    target: "_blank",
                                    children: "Atlassian Research Group"
                                }),
                                ' ',
                                "and we may contact you in the future with research opportunities."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                className: (0, $2R2iS.default)([
                    "_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                        appearance: "subtle",
                        onClick: ()=>answeredWith(false),
                        isDisabled: isDisabled,
                        isLoading: pending === 'no',
                        children: "No, thanks"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                        appearance: "primary",
                        onClick: ()=>answeredWith(true),
                        isDisabled: isDisabled,
                        isLoading: pending === 'yes',
                        children: "Yes, sign me up"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5dzEI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f6533d7b016527d9$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7ncUj = parcelRequire("7ncUj");

var $6m8y3 = parcelRequire("6m8y3");

var $dw5IO = parcelRequire("dw5IO");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $f6533d7b016527d9$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $7ncUj.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6m8y3.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                    icon: iconBefore,
                    spacing: spacing
                })
            }),
            children && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6m8y3.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6m8y3.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                    icon: iconAfter,
                    spacing: spacing
                })
            })
        ]
    });
}));
$f6533d7b016527d9$var$Button.displayName = 'Button';
var $f6533d7b016527d9$export$2e2bcd8739ae039 = $f6533d7b016527d9$var$Button;

});

parcelRegister("dM0Q8", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe21d32b416a6d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4Cnkn = parcelRequire("4Cnkn");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $dBtOK = parcelRequire("dBtOK");
const $6fe21d32b416a6d8$var$styles = {
    base: "_2rkolb4i _ect4ttxp",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $6fe21d32b416a6d8$var$iconStyles = null;
const $6fe21d32b416a6d8$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5Ny1Q.Anchor), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $4Cnkn.cx)($6fe21d32b416a6d8$var$styles.base, appearance === 'default' && $6fe21d32b416a6d8$var$styles.defaultAppearance, appearance === 'subtle' && $6fe21d32b416a6d8$var$styles.subtleAppearance, appearance === 'inverse' && $6fe21d32b416a6d8$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $6fe21d32b416a6d8$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $dBtOK.Box), {
                as: "span",
                xcss: $6fe21d32b416a6d8$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $2R2iS.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $6fe21d32b416a6d8$var$Link = /*#__PURE__*/ (0, $fc4bM.forwardRef)($6fe21d32b416a6d8$var$LinkWithoutRef);
var $6fe21d32b416a6d8$export$2e2bcd8739ae039 = $6fe21d32b416a6d8$var$Link;

});
parcelRegister("5Ny1Q", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $7fb3dc02a67f10fd$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ /* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jdt4T = parcelRequire("jdt4T");

var $DNksS = parcelRequire("DNksS");

var $7iKPB = parcelRequire("7iKPB");

var $b7gcM = parcelRequire("b7gcM");

var $9JZL9 = parcelRequire("9JZL9");

var $3zBNx = parcelRequire("3zBNx");

var $fVzQQ = parcelRequire("fVzQQ");

var $dVxDa = parcelRequire("dVxDa");

var $ipCDL = parcelRequire("ipCDL");
const $7fb3dc02a67f10fd$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $7fb3dc02a67f10fd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $7fb3dc02a67f10fd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $7fb3dc02a67f10fd$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $9JZL9.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $3zBNx.useId)();
    const onClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $b7gcM.useRouterLink)();
    const isExternal = typeof href === 'string' && $7fb3dc02a67f10fd$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $7fb3dc02a67f10fd$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $DNksS.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $ipCDL.Focusable), {
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $jdt4T.cx)($7fb3dc02a67f10fd$var$styles.root, $7fb3dc02a67f10fd$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
const $7fb3dc02a67f10fd$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $fc4bM.forwardRef)($7fb3dc02a67f10fd$var$AnchorNoRef);

});
parcelRegister("b7gcM", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $f8b8a67a4ec3eba2$export$6d558eab13290f59);

var $fc4bM = parcelRequire("fc4bM");

var $4Ilay = parcelRequire("4Ilay");
const $f8b8a67a4ec3eba2$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $fc4bM.useContext)((0, $4Ilay.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("4Ilay", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $74d571ce6d23ecb3$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $74d571ce6d23ecb3$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $74d571ce6d23ecb3$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $fc4bM.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $74d571ce6d23ecb3$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)($74d571ce6d23ecb3$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$74d571ce6d23ecb3$export$2e2bcd8739ae039 = $74d571ce6d23ecb3$var$RouterLinkProvider;

});




parcelRegister("k8Adr", function(module, exports) {
$parcel$export(module.exports, "Text", () => $2cc9d114efaf8424$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v3.0.2 */ /* text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $DNksS = parcelRequire("DNksS");

var $hgmo6 = parcelRequire("hgmo6");

var $gPFyv = parcelRequire("gPFyv");

var $lJOeE = parcelRequire("lJOeE");
const $2cc9d114efaf8424$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $2cc9d114efaf8424$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $gPFyv.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($2cc9d114efaf8424$var$inverseColorMap.hasOwnProperty(surface)) return $2cc9d114efaf8424$var$inverseColorMap[surface];
    return 'color.text';
};
const $2cc9d114efaf8424$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $2cc9d114efaf8424$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $2cc9d114efaf8424$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $2cc9d114efaf8424$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $2cc9d114efaf8424$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $2cc9d114efaf8424$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $DNksS.default)($2cc9d114efaf8424$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $lJOeE.useHasTextAncestor)();
    const color = $2cc9d114efaf8424$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        id: id,
        className: (0, $2R2iS.default)([
            $2cc9d114efaf8424$var$styles.root,
            size && $2cc9d114efaf8424$var$fontSizeMap[size],
            color && $2cc9d114efaf8424$var$textColorMap[color],
            maxLines && $2cc9d114efaf8424$var$styles.truncation,
            maxLines === 1 && $2cc9d114efaf8424$var$styles.breakAll,
            align && $2cc9d114efaf8424$var$styles[`textAlign.${align}`],
            weight && $2cc9d114efaf8424$var$fontWeightMap[weight],
            Component === 'em' && $2cc9d114efaf8424$var$styles['as.em'],
            Component === 'strong' && $2cc9d114efaf8424$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hgmo6.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});

});
parcelRegister("hgmo6", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $ae3e5ce8965f61a7$export$ae933c6cbe5643ad);

var $9eVtz = parcelRequire("9eVtz");
const $ae3e5ce8965f61a7$export$ae933c6cbe5643ad = (0, $9eVtz.HasTextAncestorContext).Provider;

});
parcelRegister("9eVtz", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $e834ce98cd5aafb4$export$19538d0bfc69c6e0);

var $fc4bM = parcelRequire("fc4bM");
const $e834ce98cd5aafb4$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $fc4bM.createContext)(false);

});


parcelRegister("lJOeE", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $965b146a60b7fed1$export$9322276ec105d055);

var $fc4bM = parcelRequire("fc4bM");

var $9eVtz = parcelRequire("9eVtz");
const $965b146a60b7fed1$export$9322276ec105d055 = ()=>(0, $fc4bM.useContext)((0, $9eVtz.HasTextAncestorContext));

});



parcelRegister("81dBa", function(module, exports) {
$parcel$export(module.exports, "default", () => $405dc7171815eca9$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $1hJdJ = parcelRequire("1hJdJ");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $7j6Zl = parcelRequire("7j6Zl");
var $405dc7171815eca9$export$2e2bcd8739ae039 = ({})=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7j6Zl.default), {
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                    size: "xsmall",
                    children: "Thanks for signing up"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                    as: "p",
                    children: "We may reach out to you in the future to participate in additional research."
                })
            ]
        })
    });

});

parcelRegister("4664b", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fd62a993925239a$export$2e2bcd8739ae039);
/* SurveyContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fRCnG = parcelRequire("fRCnG");

var $gV8E5 = parcelRequire("gV8E5");
const $6fd62a993925239a$var$containerStyles = null;
const $6fd62a993925239a$var$buttonWrapperStyles = null;
var $6fd62a993925239a$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        style: {},
        className: (0, $2R2iS.default)([
            "_2rkofajl _bfhk1bhr _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qs130s _1bsb1vif"
        ]),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_kqswstnw _154ipxbi _1xi2pxbi"
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))),
                    label: "Dismiss",
                    appearance: "subtle",
                    onClick: onDismiss
                })
            }),
            children
        ]
    });
};

});

parcelRegister("dr94L", function(module, exports) {
$parcel$export(module.exports, "default", () => $790f411d461a1765$export$2e2bcd8739ae039);
/* SurveyForm.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gPQv9 = parcelRequire("gPQv9");

var $e8E8t = parcelRequire("e8E8t");

var $1hJdJ = parcelRequire("1hJdJ");

var $8TnyV = parcelRequire("8TnyV");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $95sEm = parcelRequire("95sEm");

var $bPgnG = parcelRequire("bPgnG");
const $790f411d461a1765$var$transitionBaseStyles = null;
const $790f411d461a1765$var$TRANSITION_DURATION = 200;
var $790f411d461a1765$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
    const [expanded, setExpanded] = (0, $fc4bM.useState)(false);
    const [canContactDefault, setCanContactDefault] = (0, $fc4bM.useState)(false);
    const hasAutoFilledCanContactRef = (0, $fc4bM.useRef)(false);
    const onScoreSelect = (0, $fc4bM.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    const onFeedbackChange = (0, $fc4bM.useCallback)(()=>{
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    const resizingHeightProps = (0, $8TnyV.useResizingHeight)({
        duration: ()=>$790f411d461a1765$var$TRANSITION_DURATION,
        timingFunction: ()=>'ease-in-out'
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("section", {
        "aria-labelledby": "contextualSurveyQuestion",
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                        id: "contextualSurveyQuestion",
                        size: "xsmall",
                        as: "h2",
                        children: question
                    }),
                    statement && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                        as: "p",
                        id: "contextualSurveyStatement",
                        children: statement
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e8E8t.default), {
                onSubmit: onSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $3LM7S.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gPQv9.default), {
                                name: "feedbackScore",
                                isDisabled: submitting,
                                isRequired: true,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $95sEm.default), {
                                        ...fieldProps,
                                        onChange: (score)=>{
                                            fieldProps.onChange(score);
                                            onScoreSelect();
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                ...resizingHeightProps,
                                className: (0, $2R2iS.default)([
                                    "_1reo15vq _18m915vq"
                                ]),
                                children: expanded ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bPgnG.SurveyFormExpandedFeedback), {
                                    canContactDefault: canContactDefault,
                                    onFeedbackChange: onFeedbackChange,
                                    submitting: submitting,
                                    textLabel: textLabel,
                                    textPlaceholder: textPlaceholder
                                }) : null
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("gPQv9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6545592f9453633c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $3zBNx = parcelRequire("3zBNx");

var $2xHR5 = parcelRequire("2xHR5");

var $rvrkN = parcelRequire("rvrkN");

var $2ciQm = parcelRequire("2ciQm");

var $ecwhF = parcelRequire("ecwhF");

var $l2jEz = parcelRequire("l2jEz");

var $c4WgE = parcelRequire("c4WgE");

var $11sVc = parcelRequire("11sVc");

var $9Zxa0 = parcelRequire("9Zxa0");

var $93O7D = parcelRequire("93O7D");
const $6545592f9453633c$var$fieldWrapperStyles = null;
function $6545592f9453633c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $6545592f9453633c$var$isFunction(x) {
    return typeof x === 'function';
}
function $6545592f9453633c$var$usePreviousRef(current) {
    const ref = (0, $fc4bM.useRef)(current);
    // will be updated on the next render
    (0, $fc4bM.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $6545592f9453633c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $6545592f9453633c$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $fc4bM.useContext)((0, $2ciQm.FormContext));
    const isDisabled = (0, $fc4bM.useContext)((0, $l2jEz.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $6545592f9453633c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $6545592f9453633c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$6545592f9453633c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $fc4bM.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-expect-error -- An optional defaultValue can be undefined, but field state requires FieldValue.
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $6545592f9453633c$var$usePreviousRef(state);
    (0, $fc4bM.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-expect-error -- An optional defaultValue can be undefined, but registerField requires a value or initializer.
        isDefaultValueChanged || $6545592f9453633c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($6545592f9453633c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $3zBNx.useId)();
    const fieldId = (0, $fc4bM.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $2R2iS.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $c4WgE.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9Zxa0.RequiredAsterisk), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $rvrkN.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $11sVc.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ecwhF.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2xHR5.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $93O7D.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("2xHR5", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $c237dbc6dc62995e$export$915e9e7bd4f0f96d);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $rvrkN = parcelRequire("rvrkN");

var $lSPiz = parcelRequire("lSPiz");

var $b1o0N = parcelRequire("b1o0N");
const $c237dbc6dc62995e$export$915e9e7bd4f0f96d = ({ children: children, iconLabel: iconLabel, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $rvrkN.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $lSPiz.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                iconLabel: iconLabel,
                testId: testId,
                children: children
            })
    });
(0, $b1o0N.default).mark($c237dbc6dc62995e$export$915e9e7bd4f0f96d);

});
parcelRegister("rvrkN", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $e0c67645bfec2c3c$export$3c4232819458a302);

var $fc4bM = parcelRequire("fc4bM");
const $e0c67645bfec2c3c$export$3c4232819458a302 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});

parcelRegister("lSPiz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a83f710cd60376c$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gDsF8 = parcelRequire("gDsF8");

var $fBVBf = parcelRequire("fBVBf");

var $2ggqN = parcelRequire("2ggqN");

var $dRkX9 = parcelRequire("dRkX9");

var $2ciQm = parcelRequire("2ciQm");

var $6KXNV = parcelRequire("6KXNV");

var $Gpl5o = parcelRequire("Gpl5o");
const $4a83f710cd60376c$var$messageStyles = null;
const $4a83f710cd60376c$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $4a83f710cd60376c$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $4a83f710cd60376c$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            $4a83f710cd60376c$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $4a83f710cd60376c$var$getMessageIcon = (appearance, iconLabel)=>{
    if (appearance === 'error') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        color: "currentColor",
        label: iconLabel ?? 'error',
        size: "small"
    });
    if (appearance === 'valid') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
        color: "currentColor",
        label: iconLabel ?? 'success',
        size: "small"
    });
};
const $4a83f710cd60376c$var$getContextIconLabel = (appearance, errorMessageLabel, validMessageLabel)=>{
    if (appearance === 'error') return errorMessageLabel;
    if (appearance === 'valid') return validMessageLabel;
};
const $4a83f710cd60376c$var$MessageRow = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, iconLabel: iconLabel, isExiting: isExiting = false, testId: testId })=>{
    const { errorMessageLabel: errorMessageLabel, validMessageLabel: validMessageLabel } = (0, $fc4bM.useContext)((0, $2ciQm.FormContext));
    const contextIconLabel = $4a83f710cd60376c$var$getContextIconLabel(appearance, errorMessageLabel, validMessageLabel);
    const icon = $4a83f710cd60376c$var$getMessageIcon(appearance, iconLabel ?? contextIconLabel);
    const { isWrapper: isWrapper } = (0, $fc4bM.useContext)((0, $6KXNV.MessageWrapperContext));
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        "data-testid": testId,
        id: isExiting ? undefined : fieldId,
        // Let the wrapper own announcements from the first render when present.
        "aria-live": isWrapper ? undefined : 'polite',
        "aria-hidden": isExiting ? true : undefined,
        className: (0, $2R2iS.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $4a83f710cd60376c$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $3LM7S.jsx)($4a83f710cd60376c$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $4a83f710cd60376c$var$MotionMessage = (props)=>{
    const isErrorMessage = props.appearance === 'error';
    const { hasMotionBoundary: hasMotionBoundary, transition: transition } = (0, $fc4bM.useContext)((0, $6KXNV.MessageWrapperContext));
    const shouldAnimate = isErrorMessage || hasMotionBoundary;
    const { ref: ref, state: state } = (0, $2ggqN.useMotion)({
        initialState: shouldAnimate && transition !== 'instant' ? undefined : 'visible'
    });
    const row = /*#__PURE__*/ (0, $3LM7S.jsx)($4a83f710cd60376c$var$MessageRow, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        iconLabel: props.iconLabel,
        isExiting: state === 'exiting',
        testId: props.testId,
        children: props.children
    });
    if (!shouldAnimate) return row;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $Gpl5o.default), {
        state: state,
        transition: transition,
        motionRef: ref,
        testId: props.testId && `${props.testId}-motion`,
        children: row
    });
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const $4a83f710cd60376c$var$Message = (props)=>{
    if (!(0, $dRkX9.fg)('platform-dst-motion-uplift-input')) return /*#__PURE__*/ (0, $3LM7S.jsx)($4a83f710cd60376c$var$MessageRow, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        iconLabel: props.iconLabel,
        testId: props.testId,
        children: props.children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($4a83f710cd60376c$var$MotionMessage, {
        appearance: props.appearance,
        fieldId: props.fieldId,
        iconLabel: props.iconLabel,
        testId: props.testId,
        children: props.children
    });
};
var $4a83f710cd60376c$export$2e2bcd8739ae039 = $4a83f710cd60376c$var$Message;

});
parcelRegister("2ciQm", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $0c95d83667f0f68c$export$c24727297075ec6a);

var $fc4bM = parcelRequire("fc4bM");
const $0c95d83667f0f68c$export$c24727297075ec6a = /*#__PURE__*/ (0, $fc4bM.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("6KXNV", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $43a31961a9949800$export$579aef2c392a54d4);

var $fc4bM = parcelRequire("fc4bM");
const $43a31961a9949800$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    isWrapper: false,
    hasMotionBoundary: false,
    transition: 'row'
});

});

parcelRegister("Gpl5o", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5c4b1aaa4fb4eb6$export$2e2bcd8739ae039);
/* message-track.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $d5c4b1aaa4fb4eb6$var$expandRow = null;
const $d5c4b1aaa4fb4eb6$var$collapseRow = null;
const $d5c4b1aaa4fb4eb6$var$messageTrackStyles = {
    root: "_1e0c11p5 _2z05hkll",
    row: "_1tkeidpf",
    hidden: "_2z0563bf _3um015vq",
    invisible: "_3um015vq",
    enteringExpand: "_y44vum57 _1bumglyw",
    exitingCollapse: "_y44vhopr _1bumglyw",
    entering: "_y44v17p6 _1bumglyw",
    exiting: "_y44vst8y _1bumglyw",
    exitingInstant: "_1e0cglyw"
};
const $d5c4b1aaa4fb4eb6$var$MessageTrack = ({ children: children, transition: transition, motionRef: motionRef, state: state, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: motionRef,
        "aria-hidden": state === 'exiting' ? true : undefined,
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $d5c4b1aaa4fb4eb6$var$messageTrackStyles.root,
            transition === 'row' && (state === 'init' || state === 'hidden') && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.hidden,
            transition === 'groupEnter' && (state === 'init' || state === 'hidden') && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.invisible,
            transition === 'row' && state === 'entering' && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.enteringExpand,
            transition === 'row' && state === 'exiting' && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.exitingCollapse,
            transition === 'groupEnter' && state === 'entering' && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.entering,
            transition === 'groupExit' && state === 'exiting' && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.exiting,
            transition === 'instant' && state === 'exiting' && $d5c4b1aaa4fb4eb6$var$messageTrackStyles.exitingInstant
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                $d5c4b1aaa4fb4eb6$var$messageTrackStyles.row
            ]),
            children: children
        })
    });
var $d5c4b1aaa4fb4eb6$export$2e2bcd8739ae039 = $d5c4b1aaa4fb4eb6$var$MessageTrack;

});


parcelRegister("b1o0N", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc12ba551e585531$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $bc12ba551e585531$var$messageMotionCapability = Symbol.for('@atlaskit/form/message-motion-capable');
const $bc12ba551e585531$var$messageMotion = {
    mark (component) {
        Object.defineProperty(component, $bc12ba551e585531$var$messageMotionCapability, {
            value: true
        });
    },
    isCapable (child) {
        if (!/*#__PURE__*/ (0, $fc4bM.isValidElement)(child)) return false;
        const childType = child.type;
        return (typeof childType === 'function' || typeof childType === 'object' && childType !== null) && Reflect.get(childType, $bc12ba551e585531$var$messageMotionCapability) === true;
    }
};
var $bc12ba551e585531$export$2e2bcd8739ae039 = $bc12ba551e585531$var$messageMotion;

});


parcelRegister("ecwhF", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $e52221f55e03fa3a$export$8fbe3c7d0ed2c683);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $rvrkN = parcelRequire("rvrkN");

var $lSPiz = parcelRequire("lSPiz");

var $b1o0N = parcelRequire("b1o0N");
const $e52221f55e03fa3a$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $rvrkN.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $lSPiz.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
(0, $b1o0N.default).mark($e52221f55e03fa3a$export$8fbe3c7d0ed2c683);

});

parcelRegister("l2jEz", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $c5f908aaefe0853a$export$c17cf6b332a82dbc);

var $fc4bM = parcelRequire("fc4bM");
const $c5f908aaefe0853a$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $fc4bM.createContext)(false);

});

parcelRegister("c4WgE", function(module, exports) {
$parcel$export(module.exports, "Label", () => $432ad0f74ac22341$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $432ad0f74ac22341$var$fieldsetLabelStyles = null;
const $432ad0f74ac22341$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });

});

parcelRegister("11sVc", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $65ba2874e18a1b6c$export$ec445f12f63100a5);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iXBtU = parcelRequire("iXBtU");

var $dRkX9 = parcelRequire("dRkX9");

var $dOTpB = parcelRequire("dOTpB");

var $6KXNV = parcelRequire("6KXNV");

var $35Rmo = parcelRequire("35Rmo");

var $b1o0N = parcelRequire("b1o0N");
const $65ba2874e18a1b6c$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true,
        hasMotionBoundary: false,
        transition: 'row'
    };
    const shouldProvideMotionBoundary = (0, $dRkX9.fg)('platform-dst-motion-uplift-input') && (0, $fc4bM.Children).toArray(children).every((0, $b1o0N.default).isCapable);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6KXNV.MessageWrapperContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: shouldProvideMotionBoundary ? /*#__PURE__*/ (0, $3LM7S.jsx)($65ba2874e18a1b6c$var$MotionMessages, {
                children: children
            }) : children
        })
    });
};
const $65ba2874e18a1b6c$var$getChildKeys = (children)=>(0, $fc4bM.Children).toArray(children).filter((0, $fc4bM.isValidElement)).map((child)=>child.key).filter((key)=>key !== null);
const $65ba2874e18a1b6c$var$getTransition = (previousKeys, currentKeys)=>{
    const previous = new Set(previousKeys);
    const current = new Set(currentKeys);
    const removedCount = previousKeys.filter((key)=>!current.has(key)).length;
    const addedCount = currentKeys.filter((key)=>!previous.has(key)).length;
    if (removedCount > 0 && addedCount > 0) return 'instant';
    if (previousKeys.length === 0 && addedCount > 1) return 'groupEnter';
    if (currentKeys.length === 0 && removedCount > 1) return 'groupExit';
    return 'row';
};
const $65ba2874e18a1b6c$var$MotionMessages = ({ children: children })=>{
    const currentKeys = $65ba2874e18a1b6c$var$getChildKeys(children);
    const submitCount = (0, $fc4bM.useContext)((0, $dOTpB.FormSubmitContext));
    const [transition, setTransition] = (0, $fc4bM.useState)(()=>({
            keys: currentKeys,
            mode: 'row',
            submitCount: submitCount
        }));
    const hasKeyChange = currentKeys.length !== transition.keys.length || currentKeys.some((key, index)=>key !== transition.keys[index]);
    const isSubmitUpdate = submitCount !== transition.submitCount;
    if (hasKeyChange || isSubmitUpdate) setTransition({
        keys: currentKeys,
        mode: !hasKeyChange ? transition.mode : isSubmitUpdate ? 'instant' : $65ba2874e18a1b6c$var$getTransition(transition.keys, currentKeys),
        submitCount: submitCount
    });
    const motionContextValue = (0, $fc4bM.useMemo)(()=>({
            isWrapper: true,
            hasMotionBoundary: true,
            transition: transition.mode
        }), [
        transition.mode
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6KXNV.MessageWrapperContext).Provider, {
        value: motionContextValue,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $35Rmo.default), {
            transition: transition.mode,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
                appear: true,
                children: children
            })
        })
    });
};

});
parcelRegister("dOTpB", function(module, exports) {
$parcel$export(module.exports, "FormSubmitContext", () => $b0b5fe9f8632d2eb$export$8f3f615a5fb5d1d6);

var $fc4bM = parcelRequire("fc4bM");
const $b0b5fe9f8632d2eb$export$8f3f615a5fb5d1d6 = /*#__PURE__*/ (0, $fc4bM.createContext)(0);

});

parcelRegister("35Rmo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c8a63390f723c31$export$2e2bcd8739ae039);
/* message-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $2c8a63390f723c31$var$expandRow = null;
const $2c8a63390f723c31$var$collapseRow = null;
const $2c8a63390f723c31$var$messageGroupStyles = {
    root: "_1e0c11p5 _2z05hkll",
    row: "_1tkeidpf",
    expand: "_y44vl7y1 _1bumglyw",
    collapse: "_y44v1avz _1bumglyw"
};
const $2c8a63390f723c31$var$MessageGroup = ({ children: children, transition: transition })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": "message-wrapper-motion",
        className: (0, $2R2iS.default)([
            $2c8a63390f723c31$var$messageGroupStyles.root,
            transition === 'groupEnter' && $2c8a63390f723c31$var$messageGroupStyles.expand,
            transition === 'groupExit' && $2c8a63390f723c31$var$messageGroupStyles.collapse
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                $2c8a63390f723c31$var$messageGroupStyles.row
            ]),
            children: children
        })
    });
var $2c8a63390f723c31$export$2e2bcd8739ae039 = $2c8a63390f723c31$var$MessageGroup;

});


parcelRegister("9Zxa0", function(module, exports) {
$parcel$export(module.exports, "RequiredAsterisk", () => $80ee83ba09c87b62$export$a4bb55a1e3b8a49f);
/* required-asterisk.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $80ee83ba09c87b62$var$requiredIndicatorStyles = null;
function $80ee83ba09c87b62$export$a4bb55a1e3b8a49f() {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $2R2iS.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("93O7D", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $9cde849459c30a9f$export$5505afb209a532c8);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $rvrkN = parcelRequire("rvrkN");

var $lSPiz = parcelRequire("lSPiz");

var $b1o0N = parcelRequire("b1o0N");
const $9cde849459c30a9f$export$5505afb209a532c8 = ({ children: children, iconLabel: iconLabel, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $rvrkN.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $lSPiz.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                iconLabel: iconLabel,
                testId: testId,
                children: children
            })
    });
(0, $b1o0N.default).mark($9cde849459c30a9f$export$5505afb209a532c8);

});


parcelRegister("e8E8t", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea550d2b7ca4bee8$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v3.0.2 */ /* form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7fg08 = parcelRequire("7fg08");

var $2qGPQ = parcelRequire("2qGPQ");

var $6YyOO = parcelRequire("6YyOO");

var $lNkaK = parcelRequire("lNkaK");

var $4dCfH = parcelRequire("4dCfH");

var $dRkX9 = parcelRequire("dRkX9");

var $2ciQm = parcelRequire("2ciQm");

var $dOTpB = parcelRequire("dOTpB");

var $l2jEz = parcelRequire("l2jEz");

var $KZ6b5 = parcelRequire("KZ6b5");
const $ea550d2b7ca4bee8$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $fc4bM.useRef)(null);
    const onSubmitRef = (0, $fc4bM.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $fc4bM.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $7fg08.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($6YyOO)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($6YyOO)))(values, name, value);
                    }
                }
            }
        });
        (0, $2qGPQ.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $KZ6b5.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $fc4bM.useState)({
        dirty: false,
        submitting: false
    });
    const [submitCount, setSubmitCount] = (0, $fc4bM.useState)(0);
    (0, $fc4bM.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $fc4bM.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        if ((0, $dRkX9.fg)('platform-dst-motion-uplift-input')) setSubmitCount((count)=>count + 1);
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children, errorMessageLabel: errorMessageLabel, validMessageLabel: validMessageLabel } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $fc4bM.useCallback)((name)=>{
        const formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $fc4bM.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe,
            errorMessageLabel: errorMessageLabel,
            validMessageLabel: validMessageLabel
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe,
        errorMessageLabel,
        validMessageLabel
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $4dCfH.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $3LM7S.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2ciQm.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dOTpB.FormSubmitContext).Provider, {
            value: submitCount,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $l2jEz.IsDisabledContext).Provider, {
                value: isDisabled,
                children: childrenContent
            })
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $ea550d2b7ca4bee8$var$Form = (0, $lNkaK.default)($ea550d2b7ca4bee8$var$FormBase);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ea550d2b7ca4bee8$export$2e2bcd8739ae039 = $ea550d2b7ca4bee8$var$Form;

});
parcelRegister("7fg08", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $5466589fdfa9f097$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $5466589fdfa9f097$export$f681a8129d2e9d28);

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");
//      
var $5466589fdfa9f097$var$charCodeOfDot = ".".charCodeAt(0);
var $5466589fdfa9f097$var$reEscapeChar = /\\(\\)?/g;
var $5466589fdfa9f097$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $5466589fdfa9f097$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $5466589fdfa9f097$var$charCodeOfDot) result.push("");
    string.replace($5466589fdfa9f097$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($5466589fdfa9f097$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $5466589fdfa9f097$var$keysCache = {};
var $5466589fdfa9f097$var$keysRegex = /[.[\]]+/;
var $5466589fdfa9f097$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($5466589fdfa9f097$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $5466589fdfa9f097$var$keysCache[key] = key.split($5466589fdfa9f097$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $5466589fdfa9f097$var$keysCache[key] = $5466589fdfa9f097$var$stringToPath(key);
    }
    return $5466589fdfa9f097$var$keysCache[key];
};
//      
var $5466589fdfa9f097$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $5466589fdfa9f097$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $5466589fdfa9f097$var$_toPropertyKey(arg) {
    var key = $5466589fdfa9f097$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5466589fdfa9f097$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $5466589fdfa9f097$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1ZwRz.default)(current, [
                key
            ].map($5466589fdfa9f097$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $hHCeM.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $5466589fdfa9f097$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $5466589fdfa9f097$var$setInRecursor(state, 0, $5466589fdfa9f097$var$toPath(key), value1, destroyArrays);
};
var $5466589fdfa9f097$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $5466589fdfa9f097$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $5466589fdfa9f097$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $5466589fdfa9f097$export$c52e5867d5879e24(values, name);
    var error = $5466589fdfa9f097$export$c52e5867d5879e24(errors, name);
    if (error && error[$5466589fdfa9f097$export$735bebc8ffabf28a]) error = error[$5466589fdfa9f097$export$735bebc8ffabf28a];
    var submitError = submitErrors && $5466589fdfa9f097$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $5466589fdfa9f097$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($5466589fdfa9f097$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $5466589fdfa9f097$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $5466589fdfa9f097$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $5466589fdfa9f097$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$5466589fdfa9f097$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $5466589fdfa9f097$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $5466589fdfa9f097$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $5466589fdfa9f097$var$subscriptionFilter(result, state, previousState, subscription, $5466589fdfa9f097$export$41e855cb628c1b55, $5466589fdfa9f097$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $5466589fdfa9f097$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $5466589fdfa9f097$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $5466589fdfa9f097$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $5466589fdfa9f097$var$subscriptionFilter(result, state, previousState, subscription, $5466589fdfa9f097$export$f1ff97b9d1c7a3c3, $5466589fdfa9f097$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $5466589fdfa9f097$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$5466589fdfa9f097$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $5466589fdfa9f097$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $5466589fdfa9f097$export$83d89fbfd8236492 = "4.20.10";
var $5466589fdfa9f097$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $5466589fdfa9f097$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $5466589fdfa9f097$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $5466589fdfa9f097$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $5466589fdfa9f097$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $5466589fdfa9f097$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $5466589fdfa9f097$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $5466589fdfa9f097$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($5466589fdfa9f097$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $5466589fdfa9f097$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $hHCeM.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $hHCeM.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $5466589fdfa9f097$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $hHCeM.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $hHCeM.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $hHCeM.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $5466589fdfa9f097$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $5466589fdfa9f097$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $5466589fdfa9f097$export$e6bdf135a54e021b,
                    shallowEqual: $5466589fdfa9f097$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $hHCeM.default)({}, state.formState.values)); // clone to avoid writing
            if ($5466589fdfa9f097$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($5466589fdfa9f097$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $5466589fdfa9f097$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $5466589fdfa9f097$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $hHCeM.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $hHCeM.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $5466589fdfa9f097$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $5466589fdfa9f097$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $5466589fdfa9f097$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$5466589fdfa9f097$export$735bebc8ffabf28a]) {
                    var existing = $5466589fdfa9f097$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$5466589fdfa9f097$export$735bebc8ffabf28a] = error[$5466589fdfa9f097$export$735bebc8ffabf28a];
                    merged = $5466589fdfa9f097$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$5466589fdfa9f097$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$5466589fdfa9f097$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $hHCeM.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $5466589fdfa9f097$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $5466589fdfa9f097$var$notify(fieldSubscriber, fieldState, lastFieldState, $5466589fdfa9f097$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $5466589fdfa9f097$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $hHCeM.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($5466589fdfa9f097$export$c52e5867d5879e24(formState.values, key), $5466589fdfa9f097$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($5466589fdfa9f097$export$c52e5867d5879e24(formState.values, key), $5466589fdfa9f097$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$5466589fdfa9f097$var$hasAnyError(formState.errors) && !(formState.submitErrors && $5466589fdfa9f097$var$hasAnyError(formState.submitErrors));
        var nextFormState = $5466589fdfa9f097$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $5466589fdfa9f097$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $5466589fdfa9f097$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $5466589fdfa9f097$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $5466589fdfa9f097$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $5466589fdfa9f097$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $5466589fdfa9f097$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $5466589fdfa9f097$var$notify(state.subscribers, nextFormState, lastFormState, $5466589fdfa9f097$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $hHCeM.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($5466589fdfa9f097$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $hHCeM.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $hHCeM.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($5466589fdfa9f097$export$c52e5867d5879e24(formState.values, key), $5466589fdfa9f097$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $5466589fdfa9f097$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $5466589fdfa9f097$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $5466589fdfa9f097$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $5466589fdfa9f097$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $5466589fdfa9f097$export$c52e5867d5879e24(state.formState.values, name) === $5466589fdfa9f097$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $5466589fdfa9f097$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $5466589fdfa9f097$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $hHCeM.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $hHCeM.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $hHCeM.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $5466589fdfa9f097$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$5466589fdfa9f097$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $hHCeM.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $5466589fdfa9f097$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $5466589fdfa9f097$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $5466589fdfa9f097$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $5466589fdfa9f097$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("2qGPQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4f3ca43db9a27b$export$2e2bcd8739ae039);

var $7fg08 = parcelRequire("7fg08");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $1c4f3ca43db9a27b$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $1c4f3ca43db9a27b$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($1c4f3ca43db9a27b$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $1c4f3ca43db9a27b$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $7fg08.getIn)(errors, input.name);
    });
};
//      
var $1c4f3ca43db9a27b$var$noop = function noop() {};
var $1c4f3ca43db9a27b$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $1c4f3ca43db9a27b$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $1c4f3ca43db9a27b$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $1c4f3ca43db9a27b$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $1c4f3ca43db9a27b$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($1c4f3ca43db9a27b$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$1c4f3ca43db9a27b$export$2e2bcd8739ae039 = $1c4f3ca43db9a27b$var$createDecorator;

});

parcelRegister("6YyOO", function(module, exports) {

var $kedrj = parcelRequire("kedrj");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $51435ae6f0f1d038$var$set(object, path, value) {
    return object == null ? object : $kedrj(object, path, value);
}
module.exports = $51435ae6f0f1d038$var$set;

});

parcelRegister("lNkaK", function(module, exports) {
$parcel$export(module.exports, "default", () => $244e5eaeb161c391$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $244e5eaeb161c391$export$2e2bcd8739ae039 = (0, $fc4bM.forwardRef);

});

parcelRegister("KZ6b5", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $18bf94859b16b306$export$fc06342dc8588d3b);

var $7fg08 = parcelRequire("7fg08");
const $18bf94859b16b306$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $7fg08.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $7fg08.getIn)(errors, input.name);
    });
};

});


parcelRegister("8TnyV", function(module, exports) {
$parcel$export(module.exports, "useResizingHeight", () => $88d25502b52ba449$export$da99457d6430d83);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $fc4bM = parcelRequire("fc4bM");

var $1Ry06 = parcelRequire("1Ry06");

var $9dmSL = parcelRequire("9dmSL");

var $kUMs0 = parcelRequire("kUMs0");

var $iGr40 = parcelRequire("iGr40");

var $1JUTA = parcelRequire("1JUTA");

var $1pnHp = parcelRequire("1pnHp");

var $8Xjx2 = parcelRequire("8Xjx2");

var $157Yz = parcelRequire("157Yz");
const $88d25502b52ba449$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $9dmSL.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $1Ry06.easeInOut) } = {})=>{
    const prevDimensions = (0, $fc4bM.useRef)();
    const [element, setElementRef] = (0, $iGr40.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $8Xjx2.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $1pnHp.useRequestAnimationFrame)();
    (0, $157Yz.useSnapshotBeforeUpdate)(()=>{
        if ((0, $kUMs0.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $1JUTA.useLayoutEffect)(()=>{
        if ((0, $kUMs0.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("1Ry06", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $0e59cc85a54bc321$export$c07234257a03d5e9);
$parcel$export(module.exports, "easeOut", () => $0e59cc85a54bc321$export$57636bb43b1ccbb0);
const $0e59cc85a54bc321$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $0e59cc85a54bc321$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $0e59cc85a54bc321$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $0e59cc85a54bc321$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $0e59cc85a54bc321$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $0e59cc85a54bc321$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $0e59cc85a54bc321$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("iGr40", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $0b98c6d7a271cdfc$export$ff879f35a69d56b7);

var $fc4bM = parcelRequire("fc4bM");
const $0b98c6d7a271cdfc$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $fc4bM.useRef)(null);
    const setRef = (0, $fc4bM.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("1pnHp", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $ef7b76dc3b5a06f6$export$1775f27e7c8051ca);

var $fc4bM = parcelRequire("fc4bM");
const $ef7b76dc3b5a06f6$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $ef7b76dc3b5a06f6$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $fc4bM.useRef)([]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ef7b76dc3b5a06f6$var$getHookDeps(opts));
    return (0, $fc4bM.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("157Yz", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $39b64aa8d413b685$export$9e95200239cd148b);

var $fc4bM = parcelRequire("fc4bM");

var $1JUTA = parcelRequire("1JUTA");
const $39b64aa8d413b685$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $fc4bM.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $1JUTA.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("95sEm", function(module, exports) {
$parcel$export(module.exports, "default", () => $955f725cf6cb4924$export$2e2bcd8739ae039);
/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $5dzEI = parcelRequire("5dzEI");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");
const $955f725cf6cb4924$var$tooltipMessage = [
    'Strongly disagree',
    'Disagree',
    'Slightly disagree',
    'Neutral',
    'Slightly agree',
    'Agree',
    'Strongly agree'
];
const $955f725cf6cb4924$var$buttonWrapperStyles = null;
const $955f725cf6cb4924$var$descriptionWrapperStyles = null;
var $955f725cf6cb4924$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>/*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _12eju2gc"
                ]),
                children: Array.from({
                    length: 7
                }, (_, i)=>{
                    const score = i + 1;
                    const isSelected = value === score;
                    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
                        content: $955f725cf6cb4924$var$tooltipMessage[i],
                        hideTooltipOnClick: true,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                            onClick: ()=>onChange(score),
                            isSelected: isSelected,
                            "aria-pressed": isSelected,
                            "aria-describedby": "contextualSurveyStatement",
                            "aria-label": $955f725cf6cb4924$var$tooltipMessage[i],
                            shouldFitContainer: true,
                            children: score
                        })
                    }, score);
                })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                "aria-hidden": true,
                className: (0, $2R2iS.default)([
                    "_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "start",
                        children: "Strongly disagree"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "center",
                        children: "Neutral"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "end",
                        children: "Strongly agree"
                    })
                ]
            })
        ]
    });

});

parcelRegister("bPgnG", function(module, exports) {
$parcel$export(module.exports, "SurveyFormExpandedFeedback", () => $16d8b7ad813d8654$export$103c6e57bfbd4a99);
/* SurveyFormExpandedFeedback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5dzEI = parcelRequire("5dzEI");

var $kDn5h = parcelRequire("kDn5h");

var $hq2b2 = parcelRequire("hq2b2");

var $gPQv9 = parcelRequire("gPQv9");

var $e2QOk = parcelRequire("e2QOk");

var $96kXu = parcelRequire("96kXu");
function $16d8b7ad813d8654$export$103c6e57bfbd4a99({ canContactDefault: canContactDefault, onFeedbackChange: onFeedbackChange, submitting: submitting, textLabel: textLabel, textPlaceholder: textPlaceholder }) {
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gPQv9.default), {
                name: "writtenFeedback",
                defaultValue: "",
                isDisabled: submitting,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $96kXu.default), {
                        ...fieldProps,
                        "aria-label": textLabel,
                        placeholder: textPlaceholder,
                        onChange: (event)=>{
                            fieldProps.onChange(event);
                            onFeedbackChange();
                        }
                    })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hq2b2.CheckboxField), {
                name: "canContact",
                isDisabled: submitting,
                defaultIsChecked: canContactDefault,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $kDn5h.Checkbox), {
                        ...fieldProps,
                        label: "Atlassian can contact me about this feedback"
                    })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e2QOk.FormFooter), {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                    type: "submit",
                    appearance: "primary",
                    isLoading: submitting,
                    children: "Submit"
                })
            })
        ]
    });
}

});
parcelRegister("kDn5h", function(module, exports) {
$parcel$export(module.exports, "Checkbox", () => $9e7a9e62d8d454aa$export$48513f6b9f8ce62d);
$parcel$export(module.exports, "default", () => $9e7a9e62d8d454aa$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7iKPB = parcelRequire("7iKPB");

var $4dCfH = parcelRequire("4dCfH");

var $hS2Va = parcelRequire("hS2Va");

var $ijdfR = parcelRequire("ijdfR");

var $5dPRt = parcelRequire("5dPRt");

var $2ckNM = parcelRequire("2ckNM");
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ const $9e7a9e62d8d454aa$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
const $9e7a9e62d8d454aa$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $fc4bM.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $fc4bM.useRef)(null);
    const mergedRefs = (0, $4dCfH.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $fc4bM.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $ijdfR.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                // It is necessary only for Safari. It allows to render focus styles.
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $2R2iS.default)([
                    $9e7a9e62d8d454aa$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hS2Va.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5dPRt.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2ckNM.default), {})
                ]
            })
        ]
    });
}));
$9e7a9e62d8d454aa$export$48513f6b9f8ce62d.displayName = 'Checkbox';
var // keep the default export for backwards compatibility
$9e7a9e62d8d454aa$export$2e2bcd8739ae039 = $9e7a9e62d8d454aa$export$48513f6b9f8ce62d;

});
parcelRegister("hS2Va", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5df59fab84ed183$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const $e5df59fab84ed183$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
// Cross-fade colors and glyphs without moving the input or focus outline.
// Semantic tokens keep SVG colors, borders and indicators aligned with input motion.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $e5df59fab84ed183$var$motionStyles = {
    root: "_v564109b",
    selected: "_tzy4kb7n",
    glyph: "_v564109b _tzy4idpf _1hdqglyw",
    border: "_v564109b"
};
function $e5df59fab84ed183$var$getIcon(isIndeterminate, isChecked, motionState) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit",
        className: (0, $2R2iS.default)([
            motionState && $e5df59fab84ed183$var$motionStyles.glyph,
            motionState === 'visible' && $e5df59fab84ed183$var$motionStyles.selected
        ])
    });
    if (isChecked) return /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit",
        className: (0, $2R2iS.default)([
            motionState && $e5df59fab84ed183$var$motionStyles.glyph,
            motionState === 'visible' && $e5df59fab84ed183$var$motionStyles.selected
        ])
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $e5df59fab84ed183$var$CheckboxIcon = /*#__PURE__*/ (0, $fc4bM.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const hasMotion = (0, $dRkX9.fg)('platform_design_system_selection_radial_fade');
    const icon = (0, $fc4bM.useMemo)(()=>$e5df59fab84ed183$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $2R2iS.default)([
            $e5df59fab84ed183$var$svgStyles.root,
            hasMotion && $e5df59fab84ed183$var$motionStyles.root
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $2R2iS.default)([
                        $e5df59fab84ed183$var$svgStyles.rect,
                        hasMotion && $e5df59fab84ed183$var$motionStyles.border
                    ])
                }),
                hasMotion ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
                    children: [
                        $e5df59fab84ed183$var$getIcon(false, true, isChecked && !isIndeterminate ? 'visible' : 'hidden'),
                        $e5df59fab84ed183$var$getIcon(true, false, isIndeterminate ? 'visible' : 'hidden')
                    ]
                }) : icon
            ]
        })
    });
});
var $e5df59fab84ed183$export$2e2bcd8739ae039 = $e5df59fab84ed183$var$CheckboxIcon;

});

parcelRegister("ijdfR", function(module, exports) {
$parcel$export(module.exports, "default", () => $bde79a6f12cdfd73$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const $bde79a6f12cdfd73$var$baseStyles = null;
const $bde79a6f12cdfd73$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
const $bde79a6f12cdfd73$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const $bde79a6f12cdfd73$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
const $bde79a6f12cdfd73$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
const $bde79a6f12cdfd73$var$disabledCheckedStyles = null;
function $bde79a6f12cdfd73$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("label", {
        className: (0, $2R2iS.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("5dPRt", function(module, exports) {
$parcel$export(module.exports, "default", () => $76509e455495fcfc$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $76509e455495fcfc$var$labelTextStyles = null;
function $76509e455495fcfc$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("2ckNM", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c7f623f55be32e$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $25c7f623f55be32e$var$requiredIndicatorStyles = null;
function $25c7f623f55be32e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2R2iS.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("hq2b2", function(module, exports) {
$parcel$export(module.exports, "CheckboxField", () => $1ad9a72da6fae093$export$94195a47b94ed396);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gPQv9 = parcelRequire("gPQv9");
const $1ad9a72da6fae093$export$94195a47b94ed396 = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $fc4bM.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gPQv9.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gPQv9.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};

});

parcelRegister("e2QOk", function(module, exports) {
$parcel$export(module.exports, "FormFooter", () => $e42401cbceb35d07$export$e7277fd05612133d);
/* form-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $e42401cbceb35d07$var$formFooterWrapperStyles = null;
const $e42401cbceb35d07$var$justifyContentStyles = null;
function $e42401cbceb35d07$export$e7277fd05612133d({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("footer", {
        className: (0, $2R2iS.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("96kXu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b754f43b318264ee$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $dRkX9 = parcelRequire("dRkX9");
const $b754f43b318264ee$var$packageName = undefined;
const $b754f43b318264ee$var$packageVersion = undefined;
const $b754f43b318264ee$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $b754f43b318264ee$var$packageName,
    packageVersion: $b754f43b318264ee$var$packageVersion
};
const $b754f43b318264ee$var$lineHeightBase = 20;
const $b754f43b318264ee$var$lineHeightCompact = 16;
const $b754f43b318264ee$var$compactVerticalPadding = 2;
const $b754f43b318264ee$var$verticalPadding = 6;
const $b754f43b318264ee$var$borderWidth = 2;
const $b754f43b318264ee$var$baseStyles = null;
const $b754f43b318264ee$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $b754f43b318264ee$var$finessePlaceholderStyles = null;
const $b754f43b318264ee$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
const $b754f43b318264ee$var$atomicBaseStyles = null;
const $b754f43b318264ee$var$atomicAppearanceStyles = {
    standard: "_1dqonqa1 _1h6drsbi _bfhk1j9a _27uwbk0g _cun9187o _19wtrsbi _12yml4ek _858u1v1w _jomrr01l _7ehivyy1",
    subtle: "_1dqonqa1 _1h6d1j28 _bfhk1j28 _19wtrsbi _12yml4ek _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _1h6d1j28 _bfhk1j28 _19wt1j28 _12ym1j28 _858u1j28 _jomr1j28 _7ehi3sij"
};
const $b754f43b318264ee$var$atomicInlinePaddingStyles = {
    bordered: "_bozg1v6z _y4ti1v6z",
    borderless: "_bozg12x7 _y4ti12x7"
};
const $b754f43b318264ee$var$atomicInvalidStyles = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $b754f43b318264ee$var$fontStyles = {
    default: "_11c8fhey _j4tm1d4k",
    monospace: "_11c8fhey _ect4zzfg _j4tm1d4k _1f2r1vhz"
};
// Density padding is selected directly from React props.
const $b754f43b318264ee$var$atomicDensityStyles = {
    compact: "_1q51v77o _85i5v77o",
    default: "_1q5112x7 _85i512x7"
};
const $b754f43b318264ee$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $b754f43b318264ee$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $b754f43b318264ee$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $b754f43b318264ee$var$InnerTextArea = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const ourRef = (0, $fc4bM.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const isInputMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = (0, $fc4bM.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $b754f43b318264ee$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$b754f43b318264ee$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$b754f43b318264ee$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $fc4bM.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $b754f43b318264ee$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': (0, $dRkX9.fg)('platform-textarea-atomic-styles') ? undefined : isInvalid || undefined,
        'data-compact': (0, $dRkX9.fg)('platform-textarea-atomic-styles') ? undefined : isCompact || undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $2R2iS.default)([
            (0, $dRkX9.fg)('platform-textarea-atomic-styles') ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1qi0 _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _16qsglyw _syazi7uo _slp31hna _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1idr1rpy _1lep1gmx" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1qi0 _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            !isInputMotionEnabled && $b754f43b318264ee$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $b754f43b318264ee$var$inputMotionStyles.base,
            (0, $dRkX9.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
            (0, $dRkX9.fg)('platform-textarea-atomic-styles') ? $b754f43b318264ee$var$atomicAppearanceStyles[appearance] : $b754f43b318264ee$var$appearanceStyles[appearance],
            (0, $dRkX9.fg)('platform-textarea-atomic-styles') && $b754f43b318264ee$var$atomicInlinePaddingStyles[appearance === 'none' ? 'borderless' : 'bordered'],
            (0, $dRkX9.fg)('platform-textarea-atomic-styles') && isInvalid && "_1h6d1bqt _bfhk1j9a _16qsizbr _19wt1bqt _12yml4ek _1vp3izbr _858u1v1w _jomrr01l _7ehivyy1",
            $b754f43b318264ee$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            (0, $dRkX9.fg)('platform-textarea-atomic-styles') && $b754f43b318264ee$var$atomicDensityStyles[isCompact ? 'compact' : 'default'],
            $b754f43b318264ee$var$resizeStyles[resize],
            !(0, $dRkX9.fg)('platform-textarea-atomic-styles') && "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Runtime density must override the mobile font shorthand, which sorts after atomic longhands.
            ...(0, $dRkX9.fg)('platform-textarea-atomic-styles') && !(style !== null && style !== void 0 && style.font) && {
                lineHeight: isCompact ? $b754f43b318264ee$var$lineHeightCompact / 14 : $b754f43b318264ee$var$lineHeightBase / 14
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Minimum row height is calculated from runtime props.
            ...(0, $dRkX9.fg)('platform-textarea-atomic-styles') && {
                minHeight: `${(isCompact ? $b754f43b318264ee$var$lineHeightCompact : $b754f43b318264ee$var$lineHeightBase) * minimumRows + (isCompact ? $b754f43b318264ee$var$compactVerticalPadding : $b754f43b318264ee$var$verticalPadding) * 2 + borderHeight * 2}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $8xbhL.default)($b754f43b318264ee$var$lineHeightCompact * minimumRows + $b754f43b318264ee$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $8xbhL.default)($b754f43b318264ee$var$lineHeightBase * minimumRows + $b754f43b318264ee$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $b754f43b318264ee$var$TextArea = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $3LM7S.jsx)($b754f43b318264ee$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$b754f43b318264ee$var$TextArea.displayName = 'TextArea';
var $b754f43b318264ee$export$2e2bcd8739ae039 = $b754f43b318264ee$var$TextArea;

});
parcelRegister("8xbhL", function(module, exports) {
$parcel$export(module.exports, "default", () => $636a28dc23e433f5$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $636a28dc23e433f5$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});




parcelRegister("1QTC1", function(module, exports) {
$parcel$export(module.exports, "default", () => $14c7a65d258e6118$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $14c7a65d258e6118$export$4e7f196112fea3c5 = 27;
function $14c7a65d258e6118$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $14c7a65d258e6118$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    const inTextArea = Boolean(target.closest('textarea'));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $14c7a65d258e6118$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
    const onDismissRef = (0, $fc4bM.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $fc4bM.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $fc4bM.useEffect)(()=>{
        let unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $14c7a65d258e6118$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$14c7a65d258e6118$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $14c7a65d258e6118$var$bind(window, 'keydown', // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}

});





parcelRegister("8e3DG", function(module, exports) {
$parcel$export(module.exports, "FlagWithEvents", () => $220610c9dfc1e0e1$export$8423d11067fbf579);
$parcel$export(module.exports, "default", () => $220610c9dfc1e0e1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Flag", () => (parcelRequire("4EV6C")).default);
// eslint-disable-next-line import/order

var $2q3ue = parcelRequire("2q3ue");

var $2Aekc = parcelRequire("2Aekc");

var $4EV6C = parcelRequire("4EV6C");
const $220610c9dfc1e0e1$export$8423d11067fbf579 = (0, $2q3ue.default)((0, $4EV6C.default));
// eslint-disable-next-line camelcase
const $220610c9dfc1e0e1$var$_default_1 = (0, $2Aekc.default)($220610c9dfc1e0e1$export$8423d11067fbf579, 'flag');
var // eslint-disable-next-line camelcase
$220610c9dfc1e0e1$export$2e2bcd8739ae039 = $220610c9dfc1e0e1$var$_default_1;

});
parcelRegister("4EV6C", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e55eaf45a1c5bf0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aUAhb = parcelRequire("aUAhb");

var $eBDNv = parcelRequire("eBDNv");

var $bAQQ9 = parcelRequire("bAQQ9");

var $d3PnT = parcelRequire("d3PnT");

var $8yWjn = parcelRequire("8yWjn");

var $chzKG = parcelRequire("chzKG");
class $2e55eaf45a1c5bf0$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    static #_ = this.defaultProps = {
        fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($aUAhb))),
        primaryText: null,
        primaryAction: null,
        secondaryText: null,
        secondaryAction: null,
        icon: 'smallInfo'
    };
    onClickActionHandler(action) {
        if (action && action.type === (0, $d3PnT.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $chzKG.default)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bAQQ9.default), {
            onDismissed: this.onDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eBDNv.default), {
            id: "engagement-flag",
            appearance: "normal",
            icon: FlagIcon,
            title: title,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8yWjn.default), {
                html: body
            }),
            actions: actions
        }));
    }
    constructor(...args){
        super(...args), this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        }, this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        }, this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}

});
parcelRegister("d3PnT", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $7a2b354c3b272135$export$e7d79186651244da);
const $7a2b354c3b272135$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("8yWjn", function(module, exports) {
$parcel$export(module.exports, "default", () => $50ed21b7ecc71749$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
class $50ed21b7ecc71749$export$2e2bcd8739ae039 extends (0, $fc4bM.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("chzKG", function(module, exports) {
$parcel$export(module.exports, "default", () => $18528e581a5b5a75$export$2e2bcd8739ae039);

var $er8WQ = parcelRequire("er8WQ");

var $3UAb3 = parcelRequire("3UAb3");

var $3Z7XN = parcelRequire("3Z7XN");

var $24pGP = parcelRequire("24pGP");

var $gDsF8 = parcelRequire("gDsF8");

var $fKWgA = parcelRequire("fKWgA");

var $7ZdBj = parcelRequire("7ZdBj");
const $18528e581a5b5a75$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($er8WQ))),
        label: 'success',
        color: "var(--ds-icon-success, #6A9A23)"
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))),
        label: 'error',
        color: "var(--ds-icon-danger, #C9372C)"
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))),
        label: 'info',
        color: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))),
        label: 'warning',
        color: "var(--ds-icon-warning, #E06C00)"
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))),
        label: 'info',
        color: "var(--ds-icon-discovery, #AF59E1)"
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3Z7XN))),
        label: 'download',
        color: "var(--ds-icon, #292A2E)"
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($24pGP))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    }
};
var $18528e581a5b5a75$export$2e2bcd8739ae039 = $18528e581a5b5a75$var$flagMapping;

});
parcelRegister("er8WQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a82a873b7de8db1c$var$_react = $a82a873b7de8db1c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a82a873b7de8db1c$var$_iconNew = $a82a873b7de8db1c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a82a873b7de8db1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a82a873b7de8db1c$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $a82a873b7de8db1c$var$_react.default.createElement($a82a873b7de8db1c$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$a82a873b7de8db1c$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $a82a873b7de8db1c$var$_default = module.exports.default = $a82a873b7de8db1c$var$CheckCircleIcon;

});

parcelRegister("3UAb3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f20400a5f6ff94df1dafee093c930a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d92aa1ac77e4da2$var$_react = $2d92aa1ac77e4da2$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2d92aa1ac77e4da2$var$_iconNew = $2d92aa1ac77e4da2$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2d92aa1ac77e4da2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/comment
 * Usage guidance:
 * Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d92aa1ac77e4da2$var$CommentIcon = (props)=>/*#__PURE__*/ $2d92aa1ac77e4da2$var$_react.default.createElement($2d92aa1ac77e4da2$var$_iconNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$2d92aa1ac77e4da2$var$CommentIcon.displayName = 'CommentIcon';
var $2d92aa1ac77e4da2$var$_default = module.exports.default = $2d92aa1ac77e4da2$var$CommentIcon;

});

parcelRegister("3Z7XN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78b6099804234b515b62cf480a885222>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e6d3efecbcc7e88$var$_react = $2e6d3efecbcc7e88$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2e6d3efecbcc7e88$var$_iconNew = $2e6d3efecbcc7e88$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2e6d3efecbcc7e88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/download
 * Usage guidance:
 * Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e6d3efecbcc7e88$var$DownloadIcon = (props)=>/*#__PURE__*/ $2e6d3efecbcc7e88$var$_react.default.createElement($2e6d3efecbcc7e88$var$_iconNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$2e6d3efecbcc7e88$var$DownloadIcon.displayName = 'DownloadIcon';
var $2e6d3efecbcc7e88$var$_default = module.exports.default = $2e6d3efecbcc7e88$var$DownloadIcon;

});

parcelRegister("24pGP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2f2a7460880bea3d59fe6a53c49b2e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $181fe1f43c6388fb$var$_react = $181fe1f43c6388fb$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $181fe1f43c6388fb$var$_iconNew = $181fe1f43c6388fb$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $181fe1f43c6388fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/feedback
 * Usage guidance:
 * Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $181fe1f43c6388fb$var$FeedbackIcon = (props)=>/*#__PURE__*/ $181fe1f43c6388fb$var$_react.default.createElement($181fe1f43c6388fb$var$_iconNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$181fe1f43c6388fb$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $181fe1f43c6388fb$var$_default = module.exports.default = $181fe1f43c6388fb$var$FeedbackIcon;

});




parcelRegister("11vA2", function(module, exports) {
$parcel$export(module.exports, "ModalDialogWithEvents", () => $1fc302107a3f0153$export$404a075b2b026e91);
$parcel$export(module.exports, "default", () => $1fc302107a3f0153$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ModalDialog", () => (parcelRequire("4WIFT")).default);
// eslint-disable-next-line import/order

var $2q3ue = parcelRequire("2q3ue");

var $2Aekc = parcelRequire("2Aekc");

var $4WIFT = parcelRequire("4WIFT");
const $1fc302107a3f0153$export$404a075b2b026e91 = (0, $2q3ue.default)((0, $4WIFT.default));
// eslint-disable-next-line camelcase
const $1fc302107a3f0153$var$_default_1 = (0, $2Aekc.default)($1fc302107a3f0153$export$404a075b2b026e91, 'modalDialog');
var // eslint-disable-next-line camelcase
$1fc302107a3f0153$export$2e2bcd8739ae039 = $1fc302107a3f0153$var$_default_1;

});
parcelRegister("4WIFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef37d20d371e0400$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bsMWf = parcelRequire("bsMWf");

var $d3PnT = parcelRequire("d3PnT");

var $8yWjn = parcelRequire("8yWjn");
function $ef37d20d371e0400$var$header() {
    return null;
}
class $ef37d20d371e0400$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $d3PnT.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $ef37d20d371e0400$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bsMWf.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8yWjn.default), {
            html: body
        }));
    }
    constructor(...args){
        super(...args), this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        }, this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}

});
parcelRegister("bsMWf", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f33369e344a980$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $k7lry = parcelRequire("k7lry");

var $6zR5w = parcelRequire("6zR5w");

var $31cO8 = parcelRequire("31cO8");

var $dkw9k = parcelRequire("dkw9k");

var $2u7SO = parcelRequire("2u7SO");

var $i6UwG = parcelRequire("i6UwG");

var $eTYDi = parcelRequire("eTYDi");
class $11f33369e344a980$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    render() {
        const { actions: _actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $31cO8.useModal)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i6UwG.ModalHeading), {
                id: titleId
            }, heading);
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i6UwG.ModalBody), null, heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(CustomHeader, null), children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Footer, null)));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i6UwG.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6zR5w.default).Provider, {
                    value: (0, $eTYDi.modalButtonTheme)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i6UwG.ModalActionContainer), {
                    shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                    const variant = idx ? 'subtle-link' : 'primary';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i6UwG.ModalActionItem), {
                        key: key || (typeof text === 'string' ? text : `${idx}`)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k7lry.default), {
                        appearance: variant,
                        autoFocus: !idx,
                        ...rest
                    }, text));
                }))) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("31cO8", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $f048467f70baf9ca$export$33ffd74ebf07f060);

var $fc4bM = parcelRequire("fc4bM");

var $kcUtj = parcelRequire("kcUtj");
const $f048467f70baf9ca$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $fc4bM.useContext)((0, $kcUtj.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("kcUtj", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $19595a6ff05702a5$export$ab57792b9b6974a6);

var $fc4bM = parcelRequire("fc4bM");
const $19595a6ff05702a5$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);

});


parcelRegister("dkw9k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a39e4ad5292aa60d$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $7Po8P = parcelRequire("7Po8P");

var $31cO8 = parcelRequire("31cO8");

var $hEZp3 = parcelRequire("hEZp3");

var $at6OL = parcelRequire("at6OL");
const $a39e4ad5292aa60d$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $a39e4ad5292aa60d$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $31cO8.useModal)();
    const shouldScrollInViewport = (0, $at6OL.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $a39e4ad5292aa60d$var$styles.root,
            hasInlinePadding && $a39e4ad5292aa60d$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7Po8P.TouchScrollable), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hEZp3.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                "data-testid": testId,
                className: (0, $2R2iS.default)([
                    $a39e4ad5292aa60d$var$styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $a39e4ad5292aa60d$var$styles.paddingBlock,
                    hasInlinePadding && $a39e4ad5292aa60d$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
var $a39e4ad5292aa60d$export$2e2bcd8739ae039 = $a39e4ad5292aa60d$var$ModalBody;

});
parcelRegister("7Po8P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $abRQb = parcelRequire("abRQb");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $5b3005c989824b32$var$_interopRequireDefault($abRQb).default;
    }
});

var $kYeVd = parcelRequire("kYeVd");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $kYeVd.TouchScrollable;
    }
});
function $5b3005c989824b32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("abRQb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $76b4b21e42c52819$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fc4bM = parcelRequire("fc4bM");
var $76b4b21e42c52819$var$_react2 = $76b4b21e42c52819$var$_interopRequireDefault($fc4bM);

var $vN13J = parcelRequire("vN13J");

var $kYeVd = parcelRequire("kYeVd");

var $3tcQO = parcelRequire("3tcQO");
var $76b4b21e42c52819$var$_withLockSheet2 = $76b4b21e42c52819$var$_interopRequireDefault($3tcQO);

var $affQr = parcelRequire("affQr");
var $76b4b21e42c52819$var$_withTouchListeners2 = $76b4b21e42c52819$var$_interopRequireDefault($affQr);

var $hGCUA = parcelRequire("hGCUA");
function $76b4b21e42c52819$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76b4b21e42c52819$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $76b4b21e42c52819$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $76b4b21e42c52819$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $76b4b21e42c52819$var$ScrollLock = function(_PureComponent) {
    $76b4b21e42c52819$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $76b4b21e42c52819$var$_classCallCheck(this, ScrollLock);
        return $76b4b21e42c52819$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $76b4b21e42c52819$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$vN13J.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $76b4b21e42c52819$var$_react2.default.createElement($kYeVd.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($fc4bM.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $76b4b21e42c52819$var$compose = (0, $hGCUA.pipe)($76b4b21e42c52819$var$_withTouchListeners2.default, $76b4b21e42c52819$var$_withLockSheet2.default);
var $76b4b21e42c52819$var$SheetLock = $76b4b21e42c52819$var$compose($76b4b21e42c52819$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $76b4b21e42c52819$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $76b4b21e42c52819$var$_react2.default.createElement($76b4b21e42c52819$var$SheetLock, props) : props.children;
};
$76b4b21e42c52819$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $76b4b21e42c52819$var$LockToggle;

});
parcelRegister("vN13J", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("kYeVd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $f444fc65cfd726cf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f444fc65cfd726cf$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fc4bM = parcelRequire("fc4bM");

var $vN13J = parcelRequire("vN13J");

var $hGCUA = parcelRequire("hGCUA");
function $f444fc65cfd726cf$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $f444fc65cfd726cf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f444fc65cfd726cf$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f444fc65cfd726cf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $f444fc65cfd726cf$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $f444fc65cfd726cf$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $f444fc65cfd726cf$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $f444fc65cfd726cf$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $f444fc65cfd726cf$var$_possibleConstructorReturn(_this, _ret);
    }
    $f444fc65cfd726cf$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$vN13J.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $hGCUA.preventInertiaScroll, $hGCUA.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $hGCUA.allowTouchMove, $hGCUA.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$vN13J.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $hGCUA.preventInertiaScroll, $hGCUA.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $hGCUA.allowTouchMove, $hGCUA.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $f444fc65cfd726cf$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $fc4bM.cloneElement)(children, $f444fc65cfd726cf$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($fc4bM.PureComponent);

});
parcelRegister("hGCUA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $ce048af0343f09eb$var$preventTouchMove;
module.exports.allowTouchMove = $ce048af0343f09eb$var$allowTouchMove;
module.exports.preventInertiaScroll = $ce048af0343f09eb$var$preventInertiaScroll;
module.exports.isTouchDevice = $ce048af0343f09eb$var$isTouchDevice;
module.exports.camelToKebab = $ce048af0343f09eb$var$camelToKebab;
module.exports.parse = $ce048af0343f09eb$var$parse;
module.exports.getPadding = $ce048af0343f09eb$var$getPadding;
module.exports.getWindowHeight = $ce048af0343f09eb$var$getWindowHeight;
module.exports.getDocumentHeight = $ce048af0343f09eb$var$getDocumentHeight;
module.exports.makeStyleTag = $ce048af0343f09eb$var$makeStyleTag;
module.exports.injectStyles = $ce048af0343f09eb$var$injectStyles;
module.exports.insertStyleTag = $ce048af0343f09eb$var$insertStyleTag;

var $vN13J = parcelRequire("vN13J");
var $ce048af0343f09eb$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $ce048af0343f09eb$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $ce048af0343f09eb$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $ce048af0343f09eb$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ce048af0343f09eb$var$isTouchDevice() {
    if (!$vN13J.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $ce048af0343f09eb$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $ce048af0343f09eb$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $ce048af0343f09eb$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $ce048af0343f09eb$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($ce048af0343f09eb$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $ce048af0343f09eb$var$getPadding() {
    if (!$vN13J.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $ce048af0343f09eb$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($vN13J.canUseDOM) return window.innerHeight * multiplier;
}
function $ce048af0343f09eb$var$getDocumentHeight() {
    if ($vN13J.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $ce048af0343f09eb$var$makeStyleTag() {
    if (!$vN13J.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $ce048af0343f09eb$var$injectStyles(tag, css) {
    if (!$vN13J.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ce048af0343f09eb$var$insertStyleTag(tag) {
    if (!$vN13J.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("3tcQO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $286e0c73d56f5439$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $286e0c73d56f5439$var$withLockSheet;

var $fc4bM = parcelRequire("fc4bM");
var $286e0c73d56f5439$var$_react2 = $286e0c73d56f5439$var$_interopRequireDefault($fc4bM);

var $hGCUA = parcelRequire("hGCUA");
function $286e0c73d56f5439$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $286e0c73d56f5439$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $286e0c73d56f5439$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $286e0c73d56f5439$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $286e0c73d56f5439$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $286e0c73d56f5439$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $286e0c73d56f5439$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $286e0c73d56f5439$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $hGCUA.makeStyleTag)();
                if (!sheet) return;
                (0, $hGCUA.injectStyles)(sheet, styles);
                (0, $hGCUA.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $hGCUA.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $hGCUA.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $286e0c73d56f5439$var$_possibleConstructorReturn(_this, _ret);
        }
        $286e0c73d56f5439$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $286e0c73d56f5439$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($fc4bM.PureComponent);
}

});

parcelRegister("affQr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $775798882b329ed8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $775798882b329ed8$var$withTouchListeners;

var $fc4bM = parcelRequire("fc4bM");
var $775798882b329ed8$var$_react2 = $775798882b329ed8$var$_interopRequireDefault($fc4bM);

var $vN13J = parcelRequire("vN13J");

var $hGCUA = parcelRequire("hGCUA");
function $775798882b329ed8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $775798882b329ed8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $775798882b329ed8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $775798882b329ed8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $775798882b329ed8$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $775798882b329ed8$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $775798882b329ed8$var$_classCallCheck(this, TouchProvider);
            return $775798882b329ed8$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $775798882b329ed8$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$vN13J.canUseDOM || !(0, $hGCUA.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $hGCUA.preventTouchMove, $hGCUA.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$vN13J.canUseDOM || !(0, $hGCUA.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $hGCUA.preventTouchMove, $hGCUA.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $775798882b329ed8$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($fc4bM.PureComponent);
}

});



parcelRegister("hEZp3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a4c6f4303bc1f6d$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $PIUl3 = parcelRequire("PIUl3");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $9JZL9 = parcelRequire("9JZL9");

var $3yLdm = parcelRequire("3yLdm");

var $ipCDL = parcelRequire("ipCDL");
const $9a4c6f4303bc1f6d$var$keylineColor = "var(--ds-border, #0B120E24)";
const $9a4c6f4303bc1f6d$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
const $9a4c6f4303bc1f6d$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $9a4c6f4303bc1f6d$var$ScrollContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $fc4bM.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $fc4bM.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $fc4bM.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $fc4bM.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $fc4bM.useEffect)(()=>{
        const schedule = (0, $PIUl3.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $3yLdm.default)((0, $PIUl3.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $9a4c6f4303bc1f6d$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $9a4c6f4303bc1f6d$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $fc4bM.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $6Zi52.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $9JZL9.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ipCDL.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $4dCfH.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $4Cnkn.cx)($9a4c6f4303bc1f6d$var$styles.base, showTopKeyline && $9a4c6f4303bc1f6d$var$styles.topKeyline, showBottomKeyline && $9a4c6f4303bc1f6d$var$styles.bottomKeyline),
        children: children
    });
});
$9a4c6f4303bc1f6d$var$ScrollContainer.displayName = 'ScrollContainer';
var $9a4c6f4303bc1f6d$export$2e2bcd8739ae039 = $9a4c6f4303bc1f6d$var$ScrollContainer;

});
parcelRegister("3yLdm", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc993ea51ec671fd$export$2e2bcd8739ae039);

var $hh4XR = parcelRequire("hh4XR");
function $dc993ea51ec671fd$export$2e2bcd8739ae039(callback) {
    const ref = (0, $hh4XR.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("hh4XR", function(module, exports) {
$parcel$export(module.exports, "default", () => $96196ca2e66b44a6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $96196ca2e66b44a6$var$uniqueReferencedValue = {};
function $96196ca2e66b44a6$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $fc4bM.useRef)($96196ca2e66b44a6$var$uniqueReferencedValue);
    if (ref.current === $96196ca2e66b44a6$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("at6OL", function(module, exports) {
$parcel$export(module.exports, "default", () => $272e227c8bf46698$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $d3Rkd = parcelRequire("d3Rkd");
function $272e227c8bf46698$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $fc4bM.useContext)((0, $d3Rkd.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});
parcelRegister("d3Rkd", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $7abd7d3de341d657$export$dece24112a937f92);

var $fc4bM = parcelRequire("fc4bM");
const $7abd7d3de341d657$export$dece24112a937f92 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);

});



parcelRegister("2u7SO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $df41f424f872f9c4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9yylO = parcelRequire("9yylO");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $df41f424f872f9c4$var$ModalWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9yylO.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$df41f424f872f9c4$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$df41f424f872f9c4$export$2e2bcd8739ae039 = $df41f424f872f9c4$var$ModalWrapper;

});
parcelRegister("9yylO", function(module, exports) {
$parcel$export(module.exports, "default", () => $271c3cfa6cea6b3b$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $l7yZL = parcelRequire("l7yZL");

var $7Po8P = parcelRequire("7Po8P");

var $7iKPB = parcelRequire("7iKPB");

var $dOWZ7 = parcelRequire("dOWZ7");

var $9JZL9 = parcelRequire("9JZL9");

var $8PakO = parcelRequire("8PakO");

var $3zBNx = parcelRequire("3zBNx");

var $k9Tam = parcelRequire("k9Tam");

var $jlwk8 = parcelRequire("jlwk8");

var $dVK9d = parcelRequire("dVK9d");

var $8vg2n = parcelRequire("8vg2n");

var $4CgiI = parcelRequire("4CgiI");

var $khBwH = parcelRequire("khBwH");

var $dRkX9 = parcelRequire("dRkX9");

var $cufVT = parcelRequire("cufVT");

var $gXHCV = parcelRequire("gXHCV");

var $2SWSA = parcelRequire("2SWSA");

var $goFzc = parcelRequire("goFzc");

var $eIprM = parcelRequire("eIprM");

var $5STbE = parcelRequire("5STbE");

var $kcUtj = parcelRequire("kcUtj");

var $3R7SH = parcelRequire("3R7SH");

var $5TOeE = parcelRequire("5TOeE");

var $h52v3 = parcelRequire("h52v3");

var $jOkSF = parcelRequire("jOkSF");

var $ixWNF = parcelRequire("ixWNF");

var $d3Rkd = parcelRequire("d3Rkd");

var $24i4z = parcelRequire("24i4z");

var $2Ma0k = parcelRequire("2Ma0k");
const $271c3cfa6cea6b3b$var$fillScreenStyles = null;
/**
 * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
 */ const $271c3cfa6cea6b3b$var$dialogStyles = {
    'body-scroll': "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug",
    'viewport-scroll': "_ln19p27b _1bsbauwl _4t3i1kxc",
    'full-screen': ""
};
// Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $271c3cfa6cea6b3b$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
/**
 * Styles applied to the visual modal surface.
 */ const $271c3cfa6cea6b3b$var$surfaceStyles = {
    root: "_1e0c1txw _2lx21bp4 _bfhk1bhr _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_2rkoidpf _epkxpb1k"
};
const $271c3cfa6cea6b3b$var$topLayerScrollModeStyles = {
    'full-screen': "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
    'viewport-scroll': "_4t3i1kxc _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _1mpv184x _1jyk17ks _g7116m9r _we1i18uh",
    'body-scroll': "_1bsbauwl _4t3i1kxc _1jyk17ks _g7116m9r _we1i18uh"
};
const $271c3cfa6cea6b3b$var$topLayerAutoHeightStyles = null;
const $271c3cfa6cea6b3b$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
    // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
// Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $271c3cfa6cea6b3b$var$useModalCloseHandler(providedOnClose) {
    return (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $9JZL9.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
}
function $271c3cfa6cea6b3b$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $271c3cfa6cea6b3b$var$isWidthName(value) {
    return (0, $24i4z.width).values.includes(value);
}
function $271c3cfa6cea6b3b$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($271c3cfa6cea6b3b$var$isWidthName(input)) return `${(0, $24i4z.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $271c3cfa6cea6b3b$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $271c3cfa6cea6b3b$var$getDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
    // Backdrop clicks only: `Dialog` asks on both, and `onDialogAsk` ignores Escape.
    if (shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    return 'none';
}
/**
 * Top-layer rendering path (platform-dst-top-layer).
 *
 * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
 * management with native <dialog> via @atlaskit/top-layer/dialog.
 *
 * Key decisions:
 * - Animation: CSS transitions via @starting-style / allow-discrete.
 * - Close gating: matches legacy while open. Dialog asks on Escape and backdrop
 *   clicks (the consumer may refuse any number of times). During the exit they
 *   do not call `onClose` again.
 * - A close that Dialog did not ask about (e.g. `<form method="dialog">`): not
 *   supported. Dialog shows the modal again, and `onClose` does not run.
 * - onClose event param: undefined - consumers should use close reason.
 * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
 *   returnFocus (see accessibility-criteria.md).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * top-layer path, so it never shares a hook sequence with the legacy path.
 */ function $271c3cfa6cea6b3b$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $9JZL9.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $3R7SH.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $271c3cfa6cea6b3b$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $8vg2n.useExitingPersistence)();
    // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $3zBNx.useId)();
    const titleId = `modal-dialog-title-${id}`;
    // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $fc4bM.useRef)(null);
    // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $fc4bM.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
    // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $fc4bM.useRef)(null);
    const hasProvidedOnClose = Boolean(providedOnClose);
    const modalDialogContext = (0, $fc4bM.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        hasProvidedOnClose,
        isFullScreen
    ]);
    // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract. Dialog calls this
    // for an allowed Escape or backdrop click.
    const onDialogClose = (0, $fc4bM.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $goFzc.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]);
    /**
   * Dialog asks on an allowed Escape or backdrop click. Ignoring an Escape ask refuses it:
   * Dialog still cancels the Escape `keydown`, so nothing else closes.
   */ const onDialogAsk = (0, $fc4bM.useCallback)(({ reason: reason })=>{
        if (reason === 'escape' && !shouldCloseOnEscapePress) return;
        onDialogClose({
            reason: reason
        });
    }, [
        onDialogClose,
        shouldCloseOnEscapePress
    ]);
    // Unlike legacy, Escape and backdrop clicks during the exit do not call `onClose` again.
    // See `@atlaskit/top-layer` notes: `decisions/dialog-close-flow.md`.
    // Dialog could not reopen after a close it did not ask about (its parent layer is closed), so
    // the `<dialog>` is already gone. End the exit.
    (0, $fc4bM.useEffect)(()=>{
        if (isExiting && !dialogRef.current) onExitFinish === null || onExitFinish === void 0 || onExitFinish();
    }, [
        isExiting,
        onExitFinish
    ]);
    // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $fc4bM.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish === null || onExitFinish === void 0 || onExitFinish();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    const handleDialogEnterFinish = (0, $fc4bM.useCallback)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]);
    // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $fc4bM.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []);
    // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $8PakO.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object' && !UNSAFE__disableInitialAutoFocus);
    // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $fc4bM.useEffect)(()=>{
        return (0, $gXHCV.combine)((0, $h52v3.disableDraggingToCrossOriginIFramesForElement)(), (0, $ixWNF.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $jOkSF.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $271c3cfa6cea6b3b$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $eIprM.Dialog), {
        ref: dialogRef,
        onClose: onDialogAsk,
        dismissedBy: $271c3cfa6cea6b3b$var$getDismissedBy({
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
        }),
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        onEnterFinish: handleDialogEnterFinish,
        shouldHideBackdrop: isBlanketHidden,
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        xcss: $271c3cfa6cea6b3b$var$dialogStyles[scrollMode],
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5STbE.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                ref: contentRef,
                style: {
                    '--modal-dialog-height': $271c3cfa6cea6b3b$var$getTopLayerSurfaceHeight(height),
                    '--modal-dialog-width': $271c3cfa6cea6b3b$var$getTopLayerSurfaceWidth(width)
                },
                className: (0, $2R2iS.default)([
                    $271c3cfa6cea6b3b$var$surfaceStyles.root,
                    !isFullScreen && $271c3cfa6cea6b3b$var$surfaceStyles.borderRadius,
                    $271c3cfa6cea6b3b$var$topLayerScrollModeStyles[scrollMode],
                    !height && !isFullScreen && "_e8uo1ris"
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kcUtj.ModalContext).Provider, {
                    value: modalDialogContext,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d3Rkd.ScrollContext).Provider, {
                        value: shouldScrollInViewport,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                            children: children
                        })
                    })
                })
            })
        ]
    });
}
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $271c3cfa6cea6b3b$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $9JZL9.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $3R7SH.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    // If no ref is provided, autofocus on first element
    const autoFocusLock = !UNSAFE__disableInitialAutoFocus && !(typeof autoFocus === 'object');
    const onCloseHandler = $271c3cfa6cea6b3b$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $fc4bM.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $fc4bM.useCallback)((element)=>$271c3cfa6cea6b3b$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $5TOeE.default)();
    // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $jlwk8.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $9JZL9.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dOWZ7.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Ma0k.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                children: children
            })
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $9JZL9.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k9Tam.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cufVT.default), {
            zIndex: (0, $2SWSA.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, $dRkX9.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVK9d.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, $2R2iS.default)([
                        "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
                    ]),
                    children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $l7yZL.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Po8P))), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7Po8P.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4CgiI.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        ...fadeInProps,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: (0, $2R2iS.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $l7yZL.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Po8P))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7Po8P.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
});
// Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $271c3cfa6cea6b3b$var$InternalModalWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    if ((0, $dRkX9.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ (0, $3LM7S.jsx)($271c3cfa6cea6b3b$var$ModalWrapperTopLayer, {
        ...props
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($271c3cfa6cea6b3b$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$271c3cfa6cea6b3b$export$2e2bcd8739ae039 = $271c3cfa6cea6b3b$var$InternalModalWrapper;

});
parcelRegister("l7yZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f60565c2f0f0e561$export$2e2bcd8739ae039);

var $d0nXw = parcelRequire("d0nXw");

var $f60565c2f0f0e561$export$2e2bcd8739ae039 = (0, $d0nXw.default);

});
parcelRegister("d0nXw", function(module, exports) {
$parcel$export(module.exports, "default", () => $977ddc342bc654c7$export$2e2bcd8739ae039);

var $1ZwRz = parcelRequire("1ZwRz");

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");

var $dQwEa = parcelRequire("dQwEa");

var $2ZHpx = parcelRequire("2ZHpx");
var $977ddc342bc654c7$var$FocusLockCombination = /*#__PURE__*/ $fc4bM.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $fc4bM.createElement((0, $dQwEa.default), (0, $hHCeM.default)({
        sideCar: (0, $2ZHpx.default),
        ref: ref
    }, props));
});
var $977ddc342bc654c7$var$_ref = (0, $dQwEa.default).propTypes || {}, $977ddc342bc654c7$var$sideCar = $977ddc342bc654c7$var$_ref.sideCar, $977ddc342bc654c7$var$propTypes = (0, $1ZwRz.default)($977ddc342bc654c7$var$_ref, [
    "sideCar"
]);
$977ddc342bc654c7$var$FocusLockCombination.propTypes = {};
var $977ddc342bc654c7$export$2e2bcd8739ae039 = $977ddc342bc654c7$var$FocusLockCombination;

});
parcelRegister("dQwEa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14974ad97263e9f$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");


var $aewXc = parcelRequire("aewXc");

var $cX3YH = parcelRequire("cX3YH");

var $7mbE0 = parcelRequire("7mbE0");

var $3JYtk = parcelRequire("3JYtk");

var $6kswW = parcelRequire("6kswW");
var $a14974ad97263e9f$var$emptyArray = [];
var $a14974ad97263e9f$var$FocusLock = /*#__PURE__*/ $fc4bM.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $fc4bM.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $fc4bM.useRef();
    var isActive = $fc4bM.useRef(false);
    var originalFocusedElement = $fc4bM.useRef(null);
    var _React$useState2 = $fc4bM.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $a14974ad97263e9f$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $fc4bM.useState({}), id = _React$useState3[0];
    var onActivation = $fc4bM.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $fc4bM.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $fc4bM.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $fc4bM.useCallback(function(event) {
        if (isActive.current) (0, $3JYtk.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $3JYtk.mediumBlur).useMedium;
    var setObserveNode = $fc4bM.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $hHCeM.default)((_extends2 = {}, _extends2[$aewXc.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$aewXc.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $cX3YH.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $fc4bM.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $fc4bM.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $7mbE0.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $fc4bM.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $7mbE0.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $fc4bM.createElement(SideCar, {
        id: id,
        sideCar: (0, $3JYtk.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $fc4bM.createElement(Container, (0, $hHCeM.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $fc4bM.createElement((0, $6kswW.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $7mbE0.hiddenGuard)
    }));
});
$a14974ad97263e9f$var$FocusLock.propTypes = {};
var $a14974ad97263e9f$export$2e2bcd8739ae039 = $a14974ad97263e9f$var$FocusLock;

});
parcelRegister("aewXc", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $7734c6288ae57639$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $7734c6288ae57639$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $7734c6288ae57639$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $7734c6288ae57639$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $7734c6288ae57639$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $7734c6288ae57639$export$4f9a06cb7441a087 = 'data-focus-lock';
var $7734c6288ae57639$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $7734c6288ae57639$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $7734c6288ae57639$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $7734c6288ae57639$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("cX3YH", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $96de14b10c18df9e$export$74665b213cb5c4cf);

var $fc4bM = parcelRequire("fc4bM");

var $eHXaD = parcelRequire("eHXaD");

var $g4Nox = parcelRequire("g4Nox");
var $96de14b10c18df9e$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $fc4bM.useLayoutEffect : $fc4bM.useEffect;
var $96de14b10c18df9e$var$currentValues = new WeakMap();
function $96de14b10c18df9e$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $g4Nox.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $eHXaD.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $96de14b10c18df9e$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $96de14b10c18df9e$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $eHXaD.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $eHXaD.assignRef)(ref, current_1);
            });
        }
        $96de14b10c18df9e$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("eHXaD", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $ab52fae2ac53e33a$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $ab52fae2ac53e33a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("g4Nox", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $bb4355d851dc07aa$export$25bec8c6f54ee79a);

var $fc4bM = parcelRequire("fc4bM");
function $bb4355d851dc07aa$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $fc4bM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("7mbE0", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $55b39ec4fed14a6b$export$b8c7b07253306600);

var $fc4bM = parcelRequire("fc4bM");

var $55b39ec4fed14a6b$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $55b39ec4fed14a6b$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $55b39ec4fed14a6b$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $fc4bM.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $55b39ec4fed14a6b$export$b8c7b07253306600
    }));
};
$55b39ec4fed14a6b$var$InFocusGuard.propTypes = {};
var $55b39ec4fed14a6b$export$2e2bcd8739ae039 = $55b39ec4fed14a6b$var$InFocusGuard;

});

parcelRegister("3JYtk", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $2b947b8956dcd348$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $2b947b8956dcd348$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $2b947b8956dcd348$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $2b947b8956dcd348$export$892cbf28e5518020);

var $cNH4A = parcelRequire("cNH4A");
var $2b947b8956dcd348$export$5733e022b1d538cb = (0, $cNH4A.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $2b947b8956dcd348$export$b3e9a9312f73723c = (0, $cNH4A.createMedium)();
var $2b947b8956dcd348$export$3a1d52767cbc07b8 = (0, $cNH4A.createMedium)();
var $2b947b8956dcd348$export$892cbf28e5518020 = (0, $cNH4A.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("cNH4A", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $951b7905832f1706$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $951b7905832f1706$export$e13ec7dd7a14088d);

var $5lpFe = parcelRequire("5lpFe");
function $951b7905832f1706$var$ItoI(a) {
    return a;
}
function $951b7905832f1706$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $951b7905832f1706$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $951b7905832f1706$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $951b7905832f1706$var$ItoI;
    return $951b7905832f1706$var$innerCreateMedium(defaults, middleware);
}
function $951b7905832f1706$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $951b7905832f1706$var$innerCreateMedium(null);
    medium.options = (0, $5lpFe.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("6kswW", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $49babdd9338f82d3$export$f5272e9b1168239c);

var $fc4bM = parcelRequire("fc4bM");
var $49babdd9338f82d3$export$f5272e9b1168239c = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});


parcelRegister("2ZHpx", function(module, exports) {
$parcel$export(module.exports, "default", () => $22e2f3c633346db9$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");


var $dJZsV = parcelRequire("dJZsV");

var $iEqyx = parcelRequire("iEqyx");
var $2SNXc = parcelRequire("2SNXc");
var $4rG4M = parcelRequire("4rG4M");
var $dz9ox = parcelRequire("dz9ox");
var $4WkHe = parcelRequire("4WkHe");parcelRequire("aAMOh");
var $gSulF = parcelRequire("gSulF");

var $hfD8U = parcelRequire("hfD8U");

var $3JYtk = parcelRequire("3JYtk");
var $22e2f3c633346db9$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $22e2f3c633346db9$var$isFreeFocus = function isFreeFocus() {
    return $22e2f3c633346db9$var$focusOnBody() || (0, $4WkHe.focusIsHidden)();
};
var $22e2f3c633346db9$var$lastActiveTrap = null;
var $22e2f3c633346db9$var$lastActiveFocus = null;
var $22e2f3c633346db9$var$lastPortaledElement = null;
var $22e2f3c633346db9$var$focusWasOutsideWindow = false;
var $22e2f3c633346db9$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $22e2f3c633346db9$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($22e2f3c633346db9$var$lastActiveTrap.whiteList || $22e2f3c633346db9$var$defaultWhitelist)(activeElement);
};
var $22e2f3c633346db9$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $22e2f3c633346db9$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $22e2f3c633346db9$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $22e2f3c633346db9$var$lastPortaledElement && $22e2f3c633346db9$var$lastPortaledElement.portaledElement === element;
};
function $22e2f3c633346db9$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $22e2f3c633346db9$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($22e2f3c633346db9$var$focusWasOutsideWindow);
    return $22e2f3c633346db9$var$focusWasOutsideWindow === 'meanwhile';
};
var $22e2f3c633346db9$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $22e2f3c633346db9$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $22e2f3c633346db9$var$checkInHost(activeElement, area, area);
    });
};
var $22e2f3c633346db9$var$activateTrap = function activateTrap() {
    var result = false;
    if ($22e2f3c633346db9$var$lastActiveTrap) {
        var _lastActiveTrap = $22e2f3c633346db9$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $22e2f3c633346db9$var$lastPortaledElement && $22e2f3c633346db9$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $hfD8U.extractRef)).filter(Boolean));
            if (!activeElement || $22e2f3c633346db9$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $22e2f3c633346db9$var$focusWasOutside(crossFrame) || !$22e2f3c633346db9$var$isFreeFocus() || !$22e2f3c633346db9$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $dz9ox.focusInside)(workingArea) || activeElement && $22e2f3c633346db9$var$withinHost(activeElement, workingArea) || $22e2f3c633346db9$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$22e2f3c633346db9$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $gSulF.moveFocusInside)(workingArea, $22e2f3c633346db9$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $22e2f3c633346db9$var$lastPortaledElement = {};
                        }
                    }
                    $22e2f3c633346db9$var$focusWasOutsideWindow = false;
                    $22e2f3c633346db9$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2SNXc.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $22e2f3c633346db9$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $22e2f3c633346db9$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $22e2f3c633346db9$var$onTrap = function onTrap(event) {
    if ($22e2f3c633346db9$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $22e2f3c633346db9$var$onBlur = function onBlur() {
    return (0, $hfD8U.deferAction)($22e2f3c633346db9$var$activateTrap);
};
var $22e2f3c633346db9$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $22e2f3c633346db9$var$recordPortal(currentNode, source);
};
var $22e2f3c633346db9$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $22e2f3c633346db9$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        onBlur: $22e2f3c633346db9$var$onBlur,
        onFocus: $22e2f3c633346db9$var$onFocus
    }, children);
};
$22e2f3c633346db9$var$FocusTrap.propTypes = {};
var $22e2f3c633346db9$var$onWindowBlur = function onWindowBlur() {
    $22e2f3c633346db9$var$focusWasOutsideWindow = 'just';
    (0, $hfD8U.deferAction)(function() {
        $22e2f3c633346db9$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $22e2f3c633346db9$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $22e2f3c633346db9$var$onTrap);
    document.addEventListener('focusout', $22e2f3c633346db9$var$onBlur);
    window.addEventListener('blur', $22e2f3c633346db9$var$onWindowBlur);
};
var $22e2f3c633346db9$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $22e2f3c633346db9$var$onTrap);
    document.removeEventListener('focusout', $22e2f3c633346db9$var$onBlur);
    window.removeEventListener('blur', $22e2f3c633346db9$var$onWindowBlur);
};
function $22e2f3c633346db9$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $22e2f3c633346db9$var$focusLockAPI = {
    moveFocusInside: (0, $gSulF.moveFocusInside),
    focusInside: (0, $dz9ox.focusInside),
    focusNextElement: (0, $4rG4M.focusNextElement),
    focusPrevElement: (0, $4rG4M.focusPrevElement),
    focusFirstElement: (0, $4rG4M.focusFirstElement),
    focusLastElement: (0, $4rG4M.focusLastElement),
    captureFocusRestore: (0, $iEqyx.captureFocusRestore)
};
function $22e2f3c633346db9$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$22e2f3c633346db9$var$lastActiveTrap) $22e2f3c633346db9$var$attachHandler();
    var lastTrap = $22e2f3c633346db9$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $22e2f3c633346db9$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $22e2f3c633346db9$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($22e2f3c633346db9$var$focusLockAPI);
        $22e2f3c633346db9$var$activateTrap(true);
        (0, $hfD8U.deferAction)($22e2f3c633346db9$var$activateTrap);
    } else {
        $22e2f3c633346db9$var$detachHandler();
        $22e2f3c633346db9$var$lastActiveFocus = null;
    }
}
(0, $3JYtk.mediumFocus).assignSyncMedium($22e2f3c633346db9$var$onFocus);
(0, $3JYtk.mediumBlur).assignMedium($22e2f3c633346db9$var$onBlur);
(0, $3JYtk.mediumEffect).assignMedium(function(cb) {
    return cb($22e2f3c633346db9$var$focusLockAPI);
});
var $22e2f3c633346db9$export$2e2bcd8739ae039 = (0, $dJZsV.default)($22e2f3c633346db9$var$reducePropsToState, $22e2f3c633346db9$var$handleStateChangeOnClient)($22e2f3c633346db9$var$FocusWatcher);

});
parcelRegister("dJZsV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a00f281d7a9abd77$export$2e2bcd8739ae039);

var $i1Sqh = parcelRequire("i1Sqh");

var $bD5s2 = parcelRequire("bD5s2");

var $fc4bM = parcelRequire("fc4bM");
function $a00f281d7a9abd77$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $i1Sqh.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $fc4bM.PureComponent));
        (0, $bD5s2.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $a00f281d7a9abd77$export$2e2bcd8739ae039 = $a00f281d7a9abd77$var$withSideEffect;

});

parcelRegister("iEqyx", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $d9408fe29e7e4f8c$export$d357db6e554ff59a);

var $lMJgD = parcelRequire("lMJgD");
function $d9408fe29e7e4f8c$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $d9408fe29e7e4f8c$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $d9408fe29e7e4f8c$var$weakRef(currentElement),
            parent: $d9408fe29e7e4f8c$var$weakRef(currentElement.parentElement),
            left: $d9408fe29e7e4f8c$var$weakRef(currentElement.previousElementSibling),
            right: $d9408fe29e7e4f8c$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $d9408fe29e7e4f8c$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $d9408fe29e7e4f8c$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $lMJgD.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $d9408fe29e7e4f8c$export$d357db6e554ff59a = function(targetElement) {
    var location = $d9408fe29e7e4f8c$export$5061a7725be48ff9(targetElement);
    return function() {
        return $d9408fe29e7e4f8c$var$restoreFocusTo(location);
    };
};

});
parcelRegister("lMJgD", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $fdc131d28fb8cb48$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $fdc131d28fb8cb48$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $fdc131d28fb8cb48$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $fdc131d28fb8cb48$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $fdc131d28fb8cb48$export$2344b14b097df817);

var $eLnCB = parcelRequire("eLnCB");

var $bk5Xx = parcelRequire("bk5Xx");

var $6nEhV = parcelRequire("6nEhV");

var $6cK0F = parcelRequire("6cK0F");
var $fdc131d28fb8cb48$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $eLnCB.toArray)(nodes).filter(function(node) {
        return (0, $bk5Xx.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $bk5Xx.notHiddenInput)(node);
    });
};
var $fdc131d28fb8cb48$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $eLnCB.toArray)(nodes).filter(function(node) {
        return (0, $bk5Xx.isAutoFocusAllowedCached)(cache, node);
    });
};
var $fdc131d28fb8cb48$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $6nEhV.orderByTabIndex)($fdc131d28fb8cb48$export$6266a5cd5915dc33((0, $6cK0F.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $fdc131d28fb8cb48$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $6nEhV.orderByTabIndex)($fdc131d28fb8cb48$export$6266a5cd5915dc33((0, $6cK0F.getFocusables)(topNodes), visibilityCache), false);
};
var $fdc131d28fb8cb48$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $fdc131d28fb8cb48$export$6266a5cd5915dc33((0, $6cK0F.getParentAutofocusables)(topNode), visibilityCache);
};
var $fdc131d28fb8cb48$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $fdc131d28fb8cb48$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $eLnCB.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $fdc131d28fb8cb48$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $fdc131d28fb8cb48$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("eLnCB", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $02c60f99b55a0162$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $02c60f99b55a0162$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $02c60f99b55a0162$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $02c60f99b55a0162$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $02c60f99b55a0162$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $02c60f99b55a0162$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("bk5Xx", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $83e62f58687fc776$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $83e62f58687fc776$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $83e62f58687fc776$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $83e62f58687fc776$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $83e62f58687fc776$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $83e62f58687fc776$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $83e62f58687fc776$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $83e62f58687fc776$export$4e62c701997796c1);

var $aewXc = parcelRequire("aewXc");
var $83e62f58687fc776$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $83e62f58687fc776$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $83e62f58687fc776$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $83e62f58687fc776$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $83e62f58687fc776$var$isVisibleUncached = function(node, checkParent) {
    return !node || $83e62f58687fc776$var$isTopNode(node) || !$83e62f58687fc776$var$isElementHidden(node) && !$83e62f58687fc776$var$isInert(node) && checkParent($83e62f58687fc776$var$getParentNode(node));
};
var $83e62f58687fc776$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $83e62f58687fc776$var$isVisibleUncached(node, $83e62f58687fc776$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $83e62f58687fc776$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$83e62f58687fc776$var$isTopNode(node) ? $83e62f58687fc776$export$b8550e27de209d85(node) ? checkParent($83e62f58687fc776$var$getParentNode(node)) : false : true;
};
var $83e62f58687fc776$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $83e62f58687fc776$var$isAutoFocusAllowedUncached(node, $83e62f58687fc776$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $83e62f58687fc776$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $83e62f58687fc776$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $83e62f58687fc776$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $83e62f58687fc776$export$9d74f6fbc6f469d0 = function(node) {
    return $83e62f58687fc776$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $83e62f58687fc776$export$8197b0ea56b3b055 = function(node) {
    return !(($83e62f58687fc776$export$88a6ceeed5737ba3(node) || $83e62f58687fc776$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $83e62f58687fc776$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $aewXc.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $83e62f58687fc776$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $83e62f58687fc776$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $83e62f58687fc776$export$602e5a0d338d7750 = function(node) {
    return !$83e62f58687fc776$export$d94b8b58ec2f30eb(node);
};
var $83e62f58687fc776$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("6nEhV", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $4a5424752a41e56f$export$cb40ee071f0d5226);

var $eLnCB = parcelRequire("eLnCB");
var $4a5424752a41e56f$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $4a5424752a41e56f$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $4a5424752a41e56f$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $eLnCB.toArray)(nodes).map(function(node, index) {
        var tabIndex = $4a5424752a41e56f$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($4a5424752a41e56f$export$350ee6c095d98996);
};

});

parcelRegister("6cK0F", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $48478da638205bfd$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $48478da638205bfd$export$853fa94d922e78b9);

var $aewXc = parcelRequire("aewXc");

var $eLnCB = parcelRequire("eLnCB");

var $42ujy = parcelRequire("42ujy");
var $48478da638205bfd$var$queryTabbables = (0, $42ujy.tabbables).join(',');
var $48478da638205bfd$var$queryGuardTabbables = "".concat($48478da638205bfd$var$queryTabbables, ", [data-focus-guard]");
var $48478da638205bfd$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $eLnCB.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $48478da638205bfd$var$queryGuardTabbables : $48478da638205bfd$var$queryTabbables) ? [
            child
        ] : [], $48478da638205bfd$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $48478da638205bfd$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $48478da638205bfd$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $48478da638205bfd$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $48478da638205bfd$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $48478da638205bfd$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $eLnCB.toArray)(parent.parentNode.querySelectorAll($48478da638205bfd$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $48478da638205bfd$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $aewXc.FOCUS_AUTO), "]"));
    return (0, $eLnCB.toArray)(parentFocus).map(function(node) {
        return $48478da638205bfd$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("42ujy", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $2f0edd274e35c77d$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $2f0edd274e35c77d$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("2SNXc", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $21975fb0d9abb219$export$f89ac71e91767111);

var $hcKyq = parcelRequire("hcKyq");

var $bk5Xx = parcelRequire("bk5Xx");

var $9t4tM = parcelRequire("9t4tM");

var $6nEhV = parcelRequire("6nEhV");

var $6cK0F = parcelRequire("6cK0F");
var $21975fb0d9abb219$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $hcKyq.getAllAffectedNodes)(topNode).filter((0, $bk5Xx.isNotAGuard));
    var commonParent = (0, $9t4tM.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $6nEhV.orderByTabIndex)((0, $6cK0F.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $6cK0F.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $bk5Xx.isGuard)(node)
        };
    });
};

});
parcelRegister("hcKyq", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $c867ab5db92da58c$export$7e87c4720b9b279b);

var $aewXc = parcelRequire("aewXc");

var $eLnCB = parcelRequire("eLnCB");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $c867ab5db92da58c$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $c867ab5db92da58c$var$getTopParent = function(node) {
    return node.parentNode ? $c867ab5db92da58c$var$getTopParent(node.parentNode) : node;
};
var $c867ab5db92da58c$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $eLnCB.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $aewXc.FOCUS_GROUP));
        acc.push.apply(acc, group ? $c867ab5db92da58c$var$filterNested((0, $eLnCB.toArray)($c867ab5db92da58c$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $aewXc.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $aewXc.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("9t4tM", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $6e4a4bfa1bd60a99$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $6e4a4bfa1bd60a99$export$8f99714c70a37db1);

var $lMJgD = parcelRequire("lMJgD");

var $eLnCB = parcelRequire("eLnCB");
var $6e4a4bfa1bd60a99$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $6e4a4bfa1bd60a99$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $6e4a4bfa1bd60a99$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $6e4a4bfa1bd60a99$var$getParents(nodeA);
    var parentsB = $6e4a4bfa1bd60a99$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $6e4a4bfa1bd60a99$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $eLnCB.asArray)(baseActiveElement);
    var leftEntries = (0, $eLnCB.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $6e4a4bfa1bd60a99$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $6e4a4bfa1bd60a99$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $lMJgD.contains)(common, topCommon)) topCommon = common;
                else topCommon = $6e4a4bfa1bd60a99$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $6e4a4bfa1bd60a99$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $lMJgD.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("4rG4M", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $33ca527740c09ac7$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $33ca527740c09ac7$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $33ca527740c09ac7$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $33ca527740c09ac7$export$6a79073ddabfd6c3);

var $lzL4K = parcelRequire("lzL4K");

var $lMJgD = parcelRequire("lMJgD");

var $eLnCB = parcelRequire("eLnCB");
var $33ca527740c09ac7$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $eLnCB.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $lMJgD.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $lMJgD.getTabbableNodes)(shards, new Map()) : (0, $lMJgD.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $33ca527740c09ac7$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $lMJgD.getTabbableNodes)((0, $eLnCB.asArray)(shards), new Map()) : (0, $lMJgD.getFocusableNodes)((0, $eLnCB.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $33ca527740c09ac7$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $33ca527740c09ac7$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $33ca527740c09ac7$var$defaultOptions(options);
    var solution = $33ca527740c09ac7$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $lzL4K.focusOn)(target.node, newOptions.focusOptions);
};
var $33ca527740c09ac7$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $33ca527740c09ac7$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $33ca527740c09ac7$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $33ca527740c09ac7$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $33ca527740c09ac7$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $33ca527740c09ac7$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $lzL4K.focusOn)(node.node, options.focusOptions);
};
var $33ca527740c09ac7$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $33ca527740c09ac7$var$pickBoundary(scope, options, 'first');
};
var $33ca527740c09ac7$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $33ca527740c09ac7$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("lzL4K", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $fb516218e4dd494f$export$c12b3da842c43a8);
var $fb516218e4dd494f$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("dz9ox", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $9e05d4d4886abb81$export$20115f8da7baa6fa);

var $lMJgD = parcelRequire("lMJgD");

var $hcKyq = parcelRequire("hcKyq");

var $eLnCB = parcelRequire("eLnCB");

var $7jTFU = parcelRequire("7jTFU");
var $9e05d4d4886abb81$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $9e05d4d4886abb81$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $eLnCB.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $9e05d4d4886abb81$var$focusInFrame(node, activeElement);
    }));
};
var $9e05d4d4886abb81$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $7jTFU.getActiveElement)((0, $eLnCB.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $hcKyq.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $lMJgD.contains)(node, activeElement) || $9e05d4d4886abb81$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("7jTFU", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $55457e9dd6db0a18$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $jfWbV = parcelRequire("jfWbV");
var $55457e9dd6db0a18$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $55457e9dd6db0a18$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $jfWbV.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $55457e9dd6db0a18$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("jfWbV", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $e04c8e9955ec444a$export$78d20aae35adef88);
var $e04c8e9955ec444a$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("4WkHe", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $398ca21058355a63$export$be6b21806d3fd485);

var $aewXc = parcelRequire("aewXc");

var $lMJgD = parcelRequire("lMJgD");

var $eLnCB = parcelRequire("eLnCB");

var $7jTFU = parcelRequire("7jTFU");
var $398ca21058355a63$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $7jTFU.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $eLnCB.toArray)(inDocument.querySelectorAll("[".concat((0, $aewXc.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $lMJgD.contains)(node, activeElement);
    });
};

});

parcelRegister("aAMOh", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("gSulF")).moveFocusInside);

var $aewXc = parcelRequire("aewXc");

var $dz9ox = parcelRequire("dz9ox");

var $4WkHe = parcelRequire("4WkHe");


var $2SNXc = parcelRequire("2SNXc");

var $gSulF = parcelRequire("gSulF");

var $iEqyx = parcelRequire("iEqyx");

var $4rG4M = parcelRequire("4rG4M");

var $lMJgD = parcelRequire("lMJgD");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $7b6320cb6a630396$export$1a988e7317c65621 = $aewXc;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $7b6320cb6a630396$var$deprecated_default_moveFocusInside = (0, $gSulF.moveFocusInside);
var $7b6320cb6a630396$export$2e2bcd8739ae039 //
 = $7b6320cb6a630396$var$deprecated_default_moveFocusInside;

});
parcelRegister("gSulF", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $c4993b0d67349b4d$export$cd599851e879a025);

var $lzL4K = parcelRequire("lzL4K");

var $5x7zM = parcelRequire("5x7zM");
var $c4993b0d67349b4d$var$guardCount = 0;
var $c4993b0d67349b4d$var$lockDisabled = false;
var $c4993b0d67349b4d$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $5x7zM.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($c4993b0d67349b4d$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($c4993b0d67349b4d$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $c4993b0d67349b4d$var$lockDisabled = true;
            setTimeout(function() {
                $c4993b0d67349b4d$var$lockDisabled = false;
            }, 1);
            return;
        }
        $c4993b0d67349b4d$var$guardCount++;
        (0, $lzL4K.focusOn)(focusable.node, options.focusOptions);
        $c4993b0d67349b4d$var$guardCount--;
    }
};

});
parcelRegister("5x7zM", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $4075e94789dc3e40$export$305758c744b57f6f);

var $eB16h = parcelRequire("eB16h");

var $lMJgD = parcelRequire("lMJgD");

var $hcKyq = parcelRequire("hcKyq");

var $eLnCB = parcelRequire("eLnCB");

var $hJ0HK = parcelRequire("hJ0HK");

var $7jTFU = parcelRequire("7jTFU");

var $bk5Xx = parcelRequire("bk5Xx");

var $9t4tM = parcelRequire("9t4tM");
var $4075e94789dc3e40$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $bk5Xx.isDefined));
};
var $4075e94789dc3e40$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $7jTFU.getActiveElement)((0, $eLnCB.asArray)(topNode).length > 0 ? document : (0, $eLnCB.getFirst)(topNode).ownerDocument);
    var entries = (0, $hcKyq.getAllAffectedNodes)(topNode).filter((0, $bk5Xx.isNotAGuard));
    var commonParent = (0, $9t4tM.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $lMJgD.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $bk5Xx.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $lMJgD.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $4075e94789dc3e40$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $eB16h.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $eB16h.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $hJ0HK.pickAutofocus)(anyFocusable, innerTabbable, (0, $9t4tM.allParentAutofocusables)(entries, visibilityCache)) || (0, $hJ0HK.pickAutofocus)(anyFocusable, innerFocusables, (0, $9t4tM.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("eB16h", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $aa055fdc2c6d6389$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $aa055fdc2c6d6389$export$65842178e9bb4205);

var $82h4p = parcelRequire("82h4p");

var $bq50U = parcelRequire("bq50U");

var $bk5Xx = parcelRequire("bk5Xx");
var $aa055fdc2c6d6389$export$85710b12cf912438 = 'NEW_FOCUS';
var $aa055fdc2c6d6389$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $bk5Xx.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $aa055fdc2c6d6389$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $aa055fdc2c6d6389$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $82h4p.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $bq50U.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $bq50U.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("82h4p", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $5d9bc0690ad58bce$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $5d9bc0690ad58bce$export$4a5a72a7124e45f9);

var $bk5Xx = parcelRequire("bk5Xx");
var $5d9bc0690ad58bce$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $bk5Xx.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $5d9bc0690ad58bce$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $bk5Xx.isRadioElement)(node) && node.name) return $5d9bc0690ad58bce$var$findSelectedRadio(node, nodes);
    return node;
};
var $5d9bc0690ad58bce$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($5d9bc0690ad58bce$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("bq50U", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $8506030d2298c5a8$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $8506030d2298c5a8$export$e06728ee87c96122);

var $82h4p = parcelRequire("82h4p");
var $8506030d2298c5a8$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $82h4p.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $8506030d2298c5a8$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $82h4p.correctNode)(node, nodes));
};

});


parcelRegister("hJ0HK", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $ce772f924925475c$export$cfb742983e257555);

var $lMJgD = parcelRequire("lMJgD");

var $bq50U = parcelRequire("bq50U");

var $bk5Xx = parcelRequire("bk5Xx");
var $ce772f924925475c$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $bk5Xx.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $ce772f924925475c$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $lMJgD.filterAutoFocusable)(nodes.filter($ce772f924925475c$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $bq50U.pickFirstFocus)(autoFocusable);
    return (0, $bq50U.pickFirstFocus)((0, $lMJgD.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("hfD8U", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $c8f23350dc9879e3$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $c8f23350dc9879e3$export$c613fed06e332533);
function $c8f23350dc9879e3$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $c8f23350dc9879e3$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $c8f23350dc9879e3$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("dOWZ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0c4e8b13e1a02fb$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");
const $c0c4e8b13e1a02fb$var$packageName = undefined;
const $c0c4e8b13e1a02fb$var$packageVersion = undefined;
const $c0c4e8b13e1a02fb$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $c0c4e8b13e1a02fb$var$packageName,
    packageVersion: $c0c4e8b13e1a02fb$var$packageVersion
};
const $c0c4e8b13e1a02fb$var$baseStyles = null;
const $c0c4e8b13e1a02fb$var$shouldAllowClickThroughStyles = null;
const $c0c4e8b13e1a02fb$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $c0c4e8b13e1a02fb$var$Blanket = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $9JZL9.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $fc4bM.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$c0c4e8b13e1a02fb$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $fc4bM.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $fc4bM.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $2R2iS.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        children: children
    });
}));
$c0c4e8b13e1a02fb$var$Blanket.displayName = 'Blanket';
var $c0c4e8b13e1a02fb$export$2e2bcd8739ae039 = $c0c4e8b13e1a02fb$var$Blanket;

});

parcelRegister("k9Tam", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $346ffba576c677ae$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $8aNU1 = parcelRequire("8aNU1");

var $eKkYK = parcelRequire("eKkYK");

var $fiSZs = parcelRequire("fiSZs");

var $7LOIw = parcelRequire("7LOIw");
const $346ffba576c677ae$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $fc4bM.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return ()=>{
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eKkYK.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fiSZs.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $346ffba576c677ae$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $fc4bM.useContext)((0, $eKkYK.LevelContext));
    const parentNode = (0, $fc4bM.useContext)((0, $fiSZs.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $fc4bM.useRef)(new (0, $8aNU1.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $3LM7S.jsx)($346ffba576c677ae$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7LOIw.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("8aNU1", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $7dd11a4d7fd84de3$export$da4f61fd78d35243);
class $7dd11a4d7fd84de3$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("eKkYK", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $3bc4bb08face4009$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");
const $3bc4bb08face4009$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $fc4bM.createContext)(0);

});

parcelRegister("fiSZs", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $0ac0e8855aa164a8$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");
const $0ac0e8855aa164a8$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    current: null
});

});

parcelRegister("7LOIw", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $0aaa65cd8c2e9d74$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");
const $0aaa65cd8c2e9d74$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    current: null
});

});


parcelRegister("gXHCV", function(module, exports) {
$parcel$export(module.exports, "combine", () => $94515c9bd6ed09f0$export$1be1fc439b849fdf);
function $94515c9bd6ed09f0$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("goFzc", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $e14e328c2d3861b0$export$330cd73b9da5838b);
function $e14e328c2d3861b0$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("eIprM", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $1022eead99794342$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ /* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $jdt4T = parcelRequire("jdt4T");

var $6Zi52 = parcelRequire("6Zi52");

var $4dCfH = parcelRequire("4dCfH");

var $9kfe7 = parcelRequire("9kfe7");

var $5rfGa = parcelRequire("5rfGa");

var $izfOd = parcelRequire("izfOd");

var $TvYCN = parcelRequire("TvYCN");

var $eTIZK = parcelRequire("eTIZK");

var $DEC99 = parcelRequire("DEC99");

var $4fp7x = parcelRequire("4fp7x");
/**
 * **Surface reset**, including `color` (the UA `dialog` rule sets `CanvasText`).
 *
 * KEEP IN SYNC with `surfaceResetStyles` in `popover/popover.tsx`.
 */ const $1022eead99794342$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $1022eead99794342$var$dialogStyles = {
    root: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fglyw _lzhqglyw _mkdmze3t _lizuze3t _dbnbze3t _v12pze3t _1yd01wug _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1dqv1n9t _6hkqidpf _1rec1j28 _722r1ule",
    motion: "_k8m011k7 _1oeci9qs _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v7kvq",
    exit: "_y44vgeqi"
};
const $1022eead99794342$var$backdropStyles = {
    root: "_1ltk1i5c",
    hidden: "_1ltk1j28",
    enter: "_1m5exbuz",
    exit: "_1m5e1op4"
};
function $1022eead99794342$var$isEscapeAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape' || dismissedBy === 'escape-and-outside-click';
}
function $1022eead99794342$var$isBackdropClickAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape-and-outside-click';
}
// Whether every `<dialog>` and `[popover]` that contains the node is open. Crosses shadow roots.
function $1022eead99794342$var$isEveryAncestorLayerOpen({ node: node }) {
    const parent = node.parentNode instanceof ShadowRoot ? node.parentNode.host : node.parentElement;
    if (!parent) return true;
    if (parent instanceof HTMLElement && (parent instanceof HTMLDialogElement || parent.hasAttribute('popover')) && !(0, $5rfGa.isNativeElementOpen)({
        element: parent
    })) return false;
    return $1022eead99794342$var$isEveryAncestorLayerOpen({
        node: parent
    });
}
/**
 * Safety net for a close that `Dialog` did not ask about (for example `dialog.close()` or a
 * `<form method="dialog">` submit). Consumers should not close the native dialog. `isOpen` is the
 * source of truth, so show the dialog again.
 *
 * Skipped inside a closed layer: an open modal there is invisible but still makes the page inert.
 *
 * Returns `true` when this call showed the dialog again.
 */ function $1022eead99794342$var$reopenAfterUnaskedClose({ dialog: dialog }) {
    if (dialog.open || !$1022eead99794342$var$isEveryAncestorLayerOpen({
        node: dialog
    })) return false;
    try {
        dialog.showModal();
    } catch  {
        return false;
    }
    return dialog.open;
}
const $1022eead99794342$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, dismissedBy: dismissedBy = 'escape-and-outside-click', onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $fc4bM.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $fc4bM.useRef)(null);
    const combinedRef = (0, $4dCfH.default)([
        ownRef,
        ref
    ]);
    const dismissedByRef = (0, $fc4bM.useRef)(dismissedBy);
    const onCloseRef = (0, $fc4bM.useRef)(onClose);
    const isOpenRef = (0, $fc4bM.useRef)(isOpen);
    // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $9kfe7.useLayoutEffect)(()=>{
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
        isOpenRef.current = isOpen;
    }, [
        dismissedBy,
        onClose,
        isOpen
    ]);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $izfOd.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Bind the lifecycle listeners before the `isOpen` effect below calls `showModal()` or
    // `close()`: `beforetoggle` fires synchronously during those calls.
    (0, $9kfe7.useLayoutEffect)(()=>{
        if (!isMounted) return;
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $6Zi52.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                type: 'toggle',
                listener (event) {
                    // The consumer unmounted the dialog in `onClose`. Do not schedule
                    // `onExitFinish` after unmount.
                    if (!dialog.isConnected) return;
                    // Safety net: something closed the native dialog while `isOpen` is `true`, so
                    // show it again. Runs before `onToggle`, so the exit never settles.
                    if (event.newState === 'closed' && isOpenRef.current && $1022eead99794342$var$reopenAfterUnaskedClose({
                        dialog: dialog
                    })) return;
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at the boundary
    // (A → B → C → body → A). `useFocusWrap` handles Tab and wraps directly (A → B → C → A), as in
    // the WAI-ARIA APG pattern. `phase` keeps the listener during the exit animation (WCAG 2.4.3 Focus
    // Order regression guard).
    (0, $TvYCN.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Show or close the native dialog to match `isOpen`.
    (0, $9kfe7.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Standard path: Escape.
    const handleEscape = (0, $fc4bM.useCallback)(()=>{
        if (!$1022eead99794342$var$isEscapeAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
        // Commit the consumer's `isOpen` answer before the keydown ends.
        (0, $bTkYf.flushSync)(()=>{
            onCloseRef.current({
                reason: 'escape'
            });
        });
    }, []);
    (0, $4fp7x.useEscapeKeydown)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onEscape: handleEscape
    });
    // Standard path: backdrop click.
    const handleBackdropClick = (0, $fc4bM.useCallback)(()=>{
        if (!$1022eead99794342$var$isBackdropClickAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
        // Commit the consumer's `isOpen` answer before the click ends.
        (0, $bTkYf.flushSync)(()=>{
            onCloseRef.current({
                reason: 'overlay-click'
            });
        });
    }, []);
    (0, $eTIZK.useBackdropClick)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onBackdropClick: handleBackdropClick
    });
    // Fallback: only in browsers without `closedby`.
    (0, $DEC99.useCancelFallback)({
        dialogRef: ownRef,
        isMounted: isMounted
    });
    // After the exit, render nothing, so no empty `role="dialog"` element stays in the accessibility
    // tree. The next open mounts a new `<dialog>`, and the effects above run again for it.
    if (!isMounted) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // No `aria-modal`: `showModal()` already tells assistive technology that the dialog is
        // modal (NVDA, JAWS and VoiceOver read it from the platform accessibility API). With
        // `aria-modal`, a dialog opened with `show()` would also appear modal.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        // The browser never closes the dialog for a user action. `Dialog` handles Escape and
        // backdrop clicks itself. Always `none` (no feature check), so the server and the client
        // render the same markup.
        closedby: "none",
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            // Dialog styles
            $1022eead99794342$var$dialogStyles.root,
            $1022eead99794342$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $1022eead99794342$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $1022eead99794342$var$dialogStyles.exit,
            shouldAnimate && $1022eead99794342$var$dialogStyles.motion,
            shouldHideBackdrop ? $1022eead99794342$var$backdropStyles.hidden : $1022eead99794342$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $1022eead99794342$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $1022eead99794342$var$backdropStyles.exit,
            (0, $jdt4T.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("eTIZK", function(module, exports) {
$parcel$export(module.exports, "useBackdropClick", () => $b439322cd38a70eb$export$a18054e824c0afa5);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");
function $b439322cd38a70eb$export$a18054e824c0afa5({ dialogRef: dialogRef, isMounted: isMounted, onBackdropClick: onBackdropClick }) {
    (0, $fc4bM.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        /**
     * Matches native dialog light dismiss: the `pointerdown` and `pointerup` targets must match.
     * A `click` alone is not enough, as it fires on the common ancestor of both targets.
     * https://html.spec.whatwg.org/multipage/interactive-elements.html#dialog-light-dismiss
     */ let isBackdropPress = false;
        return (0, $6Zi52.bindAll)(dialog, [
            {
                type: 'pointerdown',
                listener (event) {
                    // Primary button only. `!button`: jsdom has no `PointerEvent`, so `button` is undefined.
                    isBackdropPress = event.target === dialog && !event.button;
                }
            },
            {
                type: 'pointerup',
                listener (event) {
                    isBackdropPress = isBackdropPress && event.target === dialog;
                }
            },
            {
                type: 'pointercancel',
                listener () {
                    isBackdropPress = false;
                }
            },
            {
                type: 'click',
                listener (event) {
                    // Each press is used once.
                    const wasBackdropPress = isBackdropPress;
                    isBackdropPress = false;
                    if (!wasBackdropPress || event.target !== dialog || !dialog.open) return;
                    onBackdropClick();
                }
            }
        ]);
    }, [
        dialogRef,
        isMounted,
        onBackdropClick
    ]);
}

});

parcelRegister("DEC99", function(module, exports) {
$parcel$export(module.exports, "useCancelFallback", () => $e77b39c92d2374ef$export$91a60beba8b292ad);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");
/**
 * Whether the browser supports the `closedby` attribute on `<dialog>`.
 *
 * Read on the client only (in an effect), so it never changes the server markup.
 */ function $e77b39c92d2374ef$var$isClosedBySupported() {
    // eslint-disable-next-line compat/compat -- every browser in the browser policy has `<dialog>`
    return 'closedBy' in HTMLDialogElement.prototype;
}
function $e77b39c92d2374ef$export$91a60beba8b292ad({ dialogRef: dialogRef, isMounted: isMounted }) {
    (0, $fc4bM.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog || $e77b39c92d2374ef$var$isClosedBySupported()) return;
        // Native `cancel` does not bubble, so a nested dialog's `cancel` does not reach this listener.
        return (0, $6Zi52.bind)(dialog, {
            type: 'cancel',
            listener (event) {
                event.preventDefault();
            }
        });
    }, [
        dialogRef,
        isMounted
    ]);
}

});

parcelRegister("4fp7x", function(module, exports) {
$parcel$export(module.exports, "useEscapeKeydown", () => $913eb9a434f029c6$export$3a72a57244d6e765);

var $6Zi52 = parcelRequire("6Zi52");

var $9kfe7 = parcelRequire("9kfe7");

var $bhmax = parcelRequire("bhmax");

var $hAQA2 = parcelRequire("hAQA2");

var $8GcYV = parcelRequire("8GcYV");

var $ks7MS = parcelRequire("ks7MS");

var $8tWJs = parcelRequire("8tWJs");

var $fLKU9 = parcelRequire("fLKU9");

var $gKA44 = parcelRequire("gKA44");
function $913eb9a434f029c6$export$3a72a57244d6e765({ dialogRef: dialogRef, isMounted: isMounted, onEscape: onEscape }) {
    (0, $fLKU9.useStartOpenOrderTracking)();
    // A layout effect, so the dialog is marked and listening as soon as it opens, even from a timer
    // outside a React event.
    (0, $9kfe7.useLayoutEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        let shouldOwnEscapeRequest = false;
        return (0, $bhmax.combine)(// `closedby="none"` hides the dialog from other layers' checks. Mark it.
        (0, $gKA44.setAttribute)({
            element: dialog,
            name: (0, $8tWJs.manualEscapeLayerAttribute),
            value: ''
        }), // Target and phase matter. See the listener order in `claim-escape`.
        (0, $6Zi52.bindAll)(window, [
            {
                // Capture: decide while every layer is still open. An inner layer may close on this
                // keydown before the bubble listener runs.
                type: 'keydown',
                listener (event) {
                    if (event.key === 'Escape') shouldOwnEscapeRequest = dialog.open && !(0, $8GcYV.hasEscapeOwnerAbove)({
                        element: dialog,
                        isLayer: true
                    });
                },
                options: {
                    capture: true
                }
            },
            {
                // Bubble: inner handlers run first.
                type: 'keydown',
                listener (event) {
                    // `defaultPrevented`: an inner handler took this Escape, so one press undoes one thing (as
                    // with a native `<dialog>`). Legacy ModalDialog closes anyway; the flag changes that.
                    if (!(0, $ks7MS.isEscapeToHandle)({
                        event: event
                    }) || !shouldOwnEscapeRequest || !dialog.open) return;
                    // `claimEscape()` stops the browser's close request. It would skip this `closedby="none"`
                    // dialog and close the next close watcher (for example a parent `auto` popover), or fire
                    // `cancel` without `closedby` support. A held key asks once.
                    if (!(0, $hAQA2.claimEscape)({
                        event: event
                    })) return;
                    onEscape();
                }
            }
        ]));
    }, [
        dialogRef,
        isMounted,
        onEscape
    ]);
}

});
parcelRegister("hAQA2", function(module, exports) {
$parcel$export(module.exports, "claimEscape", () => $99f990457c7a09d2$export$7bfc69962e56136);
/**
 * **Listener order**
 *
 * One Escape `keydown` reaches the listeners in this order:
 *
 * 1. `Dialog`, `window` capture: decides if the Escape is its own while every layer is still open.
 * 2. `useCloseOnUnclaimedEscape` with a `targetRef`: on that element, so only while focus is in it.
 * 3. React handlers, on the React root (bubble).
 * 4. `useManualLightDismiss` and `useCloseOnUnclaimedEscape` without a `targetRef`: on `document`
 *    (bubble), in bind order. React binds child effects first.
 * 5. `Dialog`, `window` bubble: closes the dialog.
 * 6. The browser, unless a listener called `preventDefault()`: closes the topmost close watcher (an
 *    open `auto` or `hint` popover, or a `<dialog>` that closes on Escape). A `Dialog` has
 *    `closedby="none"`, so it is skipped.
 *
 * The open layers decide which layer takes Escape, not focus. But the `keydown` starts at the
 * focused element, so a handler on its path can take the Escape first, and step 2 hears it only
 * while focus is inside its element.
 *
 * Rules:
 *
 * - A listener that takes an Escape calls `claimEscape()`, and every listener checks
 *   `isEscapeToHandle()` first. So later listeners and the browser leave their layers open.
 * - An owner claims the Escape even when it declines to close.
 * - `defaultPrevented` only shows earlier listeners. A listener that runs before a layer above it
 *   must find that layer itself, with `hasEscapeOwnerAbove`:
 *   - `Dialog` asks in step 1, because the browser (step 6) closes `auto` and `hint` popovers.
 *   - A page surface on an element (step 2) runs before `manual` popovers (step 4), so it counts
 *     them too.
 *   - `document` listeners (step 4) run in bind order, not open order, so `manual` popovers and
 *     page surfaces there also ask.
 * - `hasEscapeOwnerAbove` orders owners: the later open is above, but a descendant is always above
 *   its ancestors. A marked page surface ranks just above its nearest containing layer.
 * - `stopPropagation()` before `document` (for example in a React handler) skips steps 4 and 5, not
 *   step 6: the browser closes the topmost `auto` or `hint` popover, and a `Dialog` stays open.
 *
 * Check these rules before moving a listener to another target or phase. For example, a `Dialog`
 * listener on `document` could run before a `manual` popover inside it, and close the dialog
 * instead of the popover.
 */ /**
 * Takes this Escape for a layer. `preventDefault()` stops ancestor layers and the browser from also
 * closing, so one press acts on one layer, as with a native close watcher. This is true even when
 * the layer stays open.
 *
 * Returns `true` when the layer should ask to close. Returns `false` for a held-key repeat: the
 * layer still takes the Escape, but asks to close once per key press.
 */ function $99f990457c7a09d2$export$7bfc69962e56136({ event: event }) {
    event.preventDefault();
    return !event.repeat;
}

});

parcelRegister("8GcYV", function(module, exports) {
$parcel$export(module.exports, "hasEscapeOwnerAbove", () => $f6d8f435e96dfa74$export$34d7e67eba469e06);

var $3sogF = parcelRequire("3sogF");

var $471Vs = parcelRequire("471Vs");

var $Sw0le = parcelRequire("Sw0le");

var $i9zuG = parcelRequire("i9zuG");
/**
 * The stack position of an Escape owner. Higher is above.
 *
 * - A layer ranks by its open order. No open order means it opened before tracking started, so it
 *   ranks `0`, below every later layer.
 * - A page surface is not in the top layer, so it has no open order. It ranks just above its
 *   nearest containing layer, and below every layer that opened after that one. Outside every
 *   layer, it ranks below every layer.
 */ function $f6d8f435e96dfa74$var$getRank({ element: element, layers: layers, isLayer: isLayer }) {
    if (isLayer) return (0, $Sw0le.openOrderTracker).getOpenOrder({
        element: element
    }) ?? 0;
    const containingLayer = (0, $3sogF.getNearestContainingLayer)({
        element: element,
        layers: layers
    });
    if (!containingLayer) return Number.NEGATIVE_INFINITY;
    return ((0, $Sw0le.openOrderTracker).getOpenOrder({
        element: containingLayer
    }) ?? 0) + 0.5;
}
/**
 * `true` when `candidate` is above `element`, as with native close watchers: the later open is
 * above.
 *
 * A descendant is always above its ancestors. This fixes the open order when React opens the child
 * first (child effects run first), or when the ancestor opens again.
 *
 * A page surface ranks just above its nearest containing layer (see `getRank`). This prevents a
 * cycle where an older manual popover waits for a newer one, the newer one waits for a page surface
 * inside it, and that surface waits for the older popover.
 */ function $f6d8f435e96dfa74$var$isCandidateAbove({ element: element, isElementLayer: isElementLayer, candidate: candidate, layers: layers }) {
    if (element === candidate || candidate.contains(element)) return false;
    if (element.contains(candidate)) return true;
    return $f6d8f435e96dfa74$var$getRank({
        element: candidate,
        layers: layers,
        isLayer: layers.includes(candidate)
    }) > $f6d8f435e96dfa74$var$getRank({
        element: element,
        layers: layers,
        isLayer: isElementLayer
    });
}
function $f6d8f435e96dfa74$export$34d7e67eba469e06({ element: element, isLayer: isLayer = false }) {
    const { ownerDocument: ownerDocument } = element;
    const layers = (0, $471Vs.getOpenLayersTakingEscape)({
        within: ownerDocument
    });
    // The hook can attach before its popover opens. Compare it anyway.
    if (isLayer && !layers.includes(element)) layers.push(element);
    const surfaces = Array.from(ownerDocument.querySelectorAll(`[${(0, $i9zuG.pageSurfaceEscapeAttribute)}]`));
    return [
        ...layers,
        ...surfaces
    ].some((candidate)=>$f6d8f435e96dfa74$var$isCandidateAbove({
            element: element,
            isElementLayer: isLayer,
            candidate: candidate,
            layers: layers
        }));
}

});
parcelRegister("3sogF", function(module, exports) {
$parcel$export(module.exports, "getNearestContainingLayer", () => $b6d0f30478a153a3$export$a866a64ce12fcfe5);
/**
 * The deepest layer in `layers` that contains `element` (not `element` itself), or `null`.
 */ function $b6d0f30478a153a3$export$a866a64ce12fcfe5({ element: element, layers: layers }) {
    const containingLayers = layers.filter((layer)=>layer !== element && layer.contains(element));
    // The deepest containing layer contains no other containing layer.
    return containingLayers.find((layer)=>!containingLayers.some((otherLayer)=>otherLayer !== layer && layer.contains(otherLayer))) ?? null;
}

});

parcelRegister("471Vs", function(module, exports) {
$parcel$export(module.exports, "getOpenLayersTakingEscape", () => $491a1dff5cc244eb$export$f07656e15ea7b8be);

var $jPfmf = parcelRequire("jPfmf");
function $491a1dff5cc244eb$export$f07656e15ea7b8be({ within: within }) {
    return Array.from(within.querySelectorAll('dialog, [popover]')).filter((element)=>(0, $jPfmf.isOpenLayerTakingEscape)({
            element: element
        }));
}

});
parcelRegister("jPfmf", function(module, exports) {
$parcel$export(module.exports, "isOpenLayerTakingEscape", () => $ddd89dc98d808abc$export$53614d3ce6b06e6);

var $5rfGa = parcelRequire("5rfGa");

var $ihdTD = parcelRequire("ihdTD");

var $8tWJs = parcelRequire("8tWJs");
/**
 * `true` when an open `<dialog>` takes Escape, as the browser decides:
 *
 * - A `Dialog` has `closedby="none"` but takes Escape itself, so it marks itself with
 *   `manualEscapeLayerAttribute` while open.
 * - With `closedby` support, `closedBy` is the computed state: `"closerequest"` for a modal dialog
 *   without the attribute, `"none"` for a non-modal one. `closedby="none"` does not take Escape
 *   even when modal: the browser sends the close request past it.
 * - Without `closedby` support (Safari 27), only a modal dialog closes on Escape.
 *
 * A dialog that does not take Escape is part of the layer around it. Counting it would stop that
 * layer from closing.
 */ function $ddd89dc98d808abc$var$isDialogTakingEscape({ element: element }) {
    if (!element.open) return false;
    if (element.hasAttribute((0, $8tWJs.manualEscapeLayerAttribute))) return true;
    if (!('closedBy' in element)) return (0, $ihdTD.isModalDialog)({
        element: element
    });
    return element.closedBy !== 'none';
}
function $ddd89dc98d808abc$export$53614d3ce6b06e6({ element: element }) {
    if (element instanceof HTMLDialogElement) return $ddd89dc98d808abc$var$isDialogTakingEscape({
        element: element
    });
    if (!(0, $5rfGa.isNativeElementOpen)({
        element: element
    })) return false;
    if (element.popover === 'auto' || element.popover === 'hint') return true;
    return element.hasAttribute((0, $8tWJs.manualEscapeLayerAttribute));
}

});
parcelRegister("ihdTD", function(module, exports) {
$parcel$export(module.exports, "isModalDialog", () => $91ceb32290b8269e$export$cebb092bf393cc5);
/**
 * `true` for an open modal `<dialog>`.
 */ function $91ceb32290b8269e$export$cebb092bf393cc5({ element: element }) {
    if (!element.open) return false;
    // Some DOM implementations throw on `:modal`.
    try {
        return element.matches(':modal');
    } catch  {
        return false;
    }
}

});

parcelRegister("8tWJs", function(module, exports) {
$parcel$export(module.exports, "manualEscapeLayerAttribute", () => $865fef30dd0892fe$export$e9d791a989444609);
/**
 * Marks an open layer that takes Escape itself where the browser would not: a `manual` popover
 * with `useManualLightDismiss`, or a `Dialog` (`closedby="none"`), while it listens for Escape.
 *
 * A string, so it works across copies of `@atlaskit/top-layer`.
 *
 * An attribute, not a registry: the DOM is the record of open layers. The browser opens and closes
 * layers without our code (light dismiss, Escape), and layers from other code or older copies do
 * not register, so a registry would miss them. The mark only adds what the DOM cannot show, and it
 * goes away with its element.
 */ const $865fef30dd0892fe$export$e9d791a989444609 = 'data-top-layer-takes-escape';

});



parcelRegister("Sw0le", function(module, exports) {
$parcel$export(module.exports, "openOrderTracker", () => $d0b47db5dbf6a830$export$859fb18bafe6a3cf);

var $6Zi52 = parcelRequire("6Zi52");
function $d0b47db5dbf6a830$var$createOpenOrderTracker() {
    // A `WeakMap`, so a removed element is not kept alive.
    const openOrders = new WeakMap();
    let lastOpenOrder = 0;
    let isTracking = false;
    function record({ element: element }) {
        lastOpenOrder += 1;
        openOrders.set(element, lastOpenOrder);
    }
    return {
        start () {
            if (isTracking) return;
            isTracking = true;
            /**
       * - Never unbound: it must see every open for the life of the page.
       * - `beforetoggle`, not `toggle`: `beforetoggle` fires synchronously on open. `toggle` is
       *   task-queued, and in Chrome it can arrive after an Escape that follows the open.
       * - Capture: `beforetoggle` does not bubble, and an inner `stopPropagation()` cannot hide
       *   an open from a capture listener on `document`.
       */ // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- open order is tracked for the whole document
            (0, $6Zi52.bind)(document, {
                type: 'beforetoggle',
                listener (event) {
                    if (event.newState !== 'open' || !(event.target instanceof Element)) return;
                    // An element that opens again gets a new, higher order.
                    record({
                        element: event.target
                    });
                },
                options: {
                    capture: true
                }
            });
        },
        getOpenOrder ({ element: element }) {
            return openOrders.get(element) ?? null;
        },
        ensureOpenOrder ({ element: element }) {
            if (openOrders.has(element)) return;
            record({
                element: element
            });
        }
    };
}
const $d0b47db5dbf6a830$export$859fb18bafe6a3cf = $d0b47db5dbf6a830$var$createOpenOrderTracker();

});

parcelRegister("i9zuG", function(module, exports) {
$parcel$export(module.exports, "pageSurfaceEscapeAttribute", () => $f6f14797b6cc9af9$export$890961b3d10b17dc);
/**
 * Marks the surface element of an open page surface while `useCloseOnUnclaimedEscape` listens for
 * Escape on `document`. A `manual` popover around the surface also listens on `document`, in bind
 * order. The mark lets the popover leave the Escape to the surface, whatever the bind order.
 *
 * A string, so it works across copies of `@atlaskit/top-layer`.
 */ const $f6f14797b6cc9af9$export$890961b3d10b17dc = 'data-top-layer-surface-takes-escape';

});


parcelRegister("ks7MS", function(module, exports) {
$parcel$export(module.exports, "isEscapeToHandle", () => $e49062bf2c2799e3$export$da0a8943df86d627);
/**
 * `true` for an Escape keydown that a layer should act on.
 */ function $e49062bf2c2799e3$export$da0a8943df86d627({ event: event }) {
    if (event.key !== 'Escape') return false;
    // Something else already handled this Escape.
    if (event.defaultPrevented) return false;
    /**
   * The user is typing with an IME (input method editor), such as for Japanese or Chinese text.
   * While a composition is open, Escape cancels the composition, so it must not also close a layer.
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/isComposing
   */ if (event.isComposing) return false;
    return true;
}

});

parcelRegister("fLKU9", function(module, exports) {
$parcel$export(module.exports, "useStartOpenOrderTracking", () => $8fb1b5b8a6697b39$export$67e00e6e0682a61c);

var $fc4bM = parcelRequire("fc4bM");

var $Sw0le = parcelRequire("Sw0le");
function $8fb1b5b8a6697b39$export$67e00e6e0682a61c() {
    /**
   * **Why `useInsertionEffect`**
   *
   * - It must run before any popover or dialog in this commit opens. `Popover` and `Dialog` open
   *   in layout effects, and React runs child effects first, so our own `useLayoutEffect` can run
   *   after a child layer has opened. React runs every insertion effect of a commit before any
   *   layout effect.
   * - Not during render: render also runs on the server, and binding a `document` listener there
   *   breaks SSR in a DOM test environment. Effects never run on the server.
   */ (0, $fc4bM.useInsertionEffect)(()=>{
        (0, $Sw0le.openOrderTracker).start();
    }, []);
}

});

parcelRegister("gKA44", function(module, exports) {
$parcel$export(module.exports, "setAttribute", () => $42ba4a20e5eabc00$export$9fec4d97f1922e0b);
/**
 * Sets an attribute on an element and returns a cleanup function that removes it.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     setAttribute({ element, name: 'data-example', value: '' }),
 *     bind(window, { type: 'keydown', listener: onKeyDown }),
 *   );
 * }, []);
 * ```
 */ function $42ba4a20e5eabc00$export$9fec4d97f1922e0b({ element: element, name: name, value: value }) {
    element.setAttribute(name, value);
    return function cleanup() {
        element.removeAttribute(name);
    };
}

});



parcelRegister("5STbE", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $996798b2072a18cd$export$e458030908e2d723);

var $j5N6B = parcelRequire("j5N6B");

var $9kfe7 = parcelRequire("9kfe7");
function $996798b2072a18cd$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $9kfe7.useLayoutEffect)(()=>{
        var _getDocument;
        if (!isOpen) return;
        const body = (_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

});

parcelRegister("3R7SH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2821803880607b1d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $3yLdm = parcelRequire("3yLdm");

var $ijhy8 = parcelRequire("ijhy8");

var $7WEnW = parcelRequire("7WEnW");

var $8vg2n = parcelRequire("8vg2n");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $2821803880607b1d$var$modalStackRegister = [];
function $2821803880607b1d$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $8vg2n.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $7WEnW.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $ijhy8.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $3yLdm.default)(()=>{
        const newStackIndex = $2821803880607b1d$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $fc4bM.useEffect)(()=>{
        const currentStackIndex = $2821803880607b1d$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $2821803880607b1d$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $2821803880607b1d$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $2821803880607b1d$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $fc4bM.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $2821803880607b1d$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $2821803880607b1d$var$modalStackRegister.splice(currentStackIndex, 1);
                $2821803880607b1d$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("ijhy8", function(module, exports) {
$parcel$export(module.exports, "default", () => $900b64e66b02494e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $900b64e66b02494e$export$2e2bcd8739ae039(value) {
    const ref = (0, $fc4bM.useRef)();
    (0, $fc4bM.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("7WEnW", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdbef181e7762105$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $cdbef181e7762105$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $fc4bM.useState)(initialState);
    const valueRef = (0, $fc4bM.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("5TOeE", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf394b965f098a31$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $cf394b965f098a31$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $cf394b965f098a31$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $fc4bM.useState)(0);
    (0, $fc4bM.useLayoutEffect)(()=>{
        setScrollTopOffset($cf394b965f098a31$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $fc4bM.useCallback)(()=>{
        if ($cf394b965f098a31$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return (0, $6Zi52.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("h52v3", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $a12cf1ac22fffaba$export$ec28e97c7d8b1b35);

var $6Zi52 = parcelRequire("6Zi52");

var $c8sLM = parcelRequire("c8sLM");

var $gXHCV = parcelRequire("gXHCV");

var $9z5hK = parcelRequire("9z5hK");
function $a12cf1ac22fffaba$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $6Zi52.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $c8sLM.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $gXHCV.combine)(unbindEvents, unbindMonitor);
}
function $a12cf1ac22fffaba$var$watchForInteractionStart({ start: start }) {
    return (0, $6Zi52.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $a12cf1ac22fffaba$var$api = (0, $9z5hK.makeFixForAdapter)({
    watchForInteractionStart: $a12cf1ac22fffaba$var$watchForInteractionStart,
    watchForInteractionEnd: $a12cf1ac22fffaba$var$watchForInteractionEnd
});
function $a12cf1ac22fffaba$export$ec28e97c7d8b1b35() {
    return $a12cf1ac22fffaba$var$api.registerUsage();
}

});
parcelRegister("c8sLM", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $3a24b612c6363bef$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $3a24b612c6363bef$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $3a24b612c6363bef$export$c746a5152d4ba26c);

var $6Zi52 = parcelRequire("6Zi52");

var $4RoqO = parcelRequire("4RoqO");

var $1fgnB = parcelRequire("1fgnB");

var $fxTAU = parcelRequire("fxTAU");

var $gXHCV = parcelRequire("gXHCV");

var $9Z0cf = parcelRequire("9Z0cf");

var $j8Xkk = parcelRequire("j8Xkk");

var $9QxPo = parcelRequire("9QxPo");

var $bn53K = parcelRequire("bn53K");

var $hMdy3 = parcelRequire("hMdy3");

var $fZxd0 = parcelRequire("fZxd0");

var $dTc7T = parcelRequire("dTc7T");
const $3a24b612c6363bef$var$draggableRegistry = new WeakMap();
function $3a24b612c6363bef$var$addToRegistry(args) {
    $3a24b612c6363bef$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $3a24b612c6363bef$var$draggableRegistry.delete(args.element);
    };
}
const $3a24b612c6363bef$var$honeyPotFix = (0, $1fgnB.makeHoneyPotFix)();
const $3a24b612c6363bef$var$adapter = (0, $fxTAU.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $gXHCV.combine)($3a24b612c6363bef$var$honeyPotFix.bindEvents(), (0, $6Zi52.bind)(document, {
            type: 'dragstart',
            listener (event) {
                var _entry$getInitialData, _entry$getInitialData2;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $3a24b612c6363bef$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ const input = (0, $bn53K.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $4RoqO.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ const nativeData = ((_entry$getInitialData = entry.getInitialDataForExternal) === null || _entry$getInitialData === void 0 ? void 0 : _entry$getInitialData.call(entry, feedback)) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $9QxPo.isAndroid)() && !event.dataTransfer.types.includes((0, $hMdy3.textMediaType)) && !event.dataTransfer.types.includes((0, $fZxd0.URLMediaType))) event.dataTransfer.setData((0, $hMdy3.textMediaType), (0, $9QxPo.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $dTc7T.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: ((_entry$getInitialData2 = entry.getInitialData) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $3a24b612c6363bef$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $3a24b612c6363bef$var$honeyPotFix.getOnPostDispatch()
});
const $3a24b612c6363bef$export$e7140b68045b5036 = $3a24b612c6363bef$var$adapter.dropTarget;
const $3a24b612c6363bef$export$59a074bac4c54f54 = $3a24b612c6363bef$var$adapter.monitor;
function $3a24b612c6363bef$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $gXHCV.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $3a24b612c6363bef$var$adapter.registerUsage(), $3a24b612c6363bef$var$addToRegistry(args), (0, $j8Xkk.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $9Z0cf.once)(cleanup);
}

});
parcelRegister("4RoqO", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $07247a8a462e8af3$export$81d0353f25f5dd);

var $jql5V = parcelRequire("jql5V");
function $07247a8a462e8af3$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $jql5V.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("jql5V", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $481af8ddc78a45e9$export$821bdcd739a2706b);

var $beTQU = parcelRequire("beTQU");
function $481af8ddc78a45e9$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $beTQU.honeyPotDataAttribute));
}

});
parcelRegister("beTQU", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $4eab1d2a5a296838$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $4eab1d2a5a296838$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("1fgnB", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $08f054c4d766622c$export$8ecad27c959e89e0);

var $6Zi52 = parcelRequire("6Zi52");

var $ypesA = parcelRequire("ypesA");

var $gwsTK = parcelRequire("gwsTK");

var $gYlcm = parcelRequire("gYlcm");

var $beTQU = parcelRequire("beTQU");
const $08f054c4d766622c$var$honeyPotSize = 2;
const $08f054c4d766622c$var$halfHoneyPotSize = $08f054c4d766622c$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $08f054c4d766622c$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $08f054c4d766622c$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $08f054c4d766622c$var$halfHoneyPotSize,
        y: point.y - $08f054c4d766622c$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $08f054c4d766622c$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $08f054c4d766622c$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $08f054c4d766622c$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $08f054c4d766622c$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $08f054c4d766622c$var$getHoneyPotRectFor({ client: client }) {
    const point = $08f054c4d766622c$var$preventGoingForwardsOffScreen($08f054c4d766622c$var$preventGoingBackwardsOffScreen($08f054c4d766622c$var$pullBackByHalfHoneyPotSize($08f054c4d766622c$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $08f054c4d766622c$var$honeyPotSize,
        height: $08f054c4d766622c$var$honeyPotSize
    });
}
function $08f054c4d766622c$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $08f054c4d766622c$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $08f054c4d766622c$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $beTQU.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $gYlcm.supportsPopover)()) // eslint-disable-next-line @atlaskit/design-system/no-native-popover-or-dialog -- paints above the page during a drag; it never takes Escape or closes on an outside press
    element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $08f054c4d766622c$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $gYlcm.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $gwsTK.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $ypesA.maxZIndex)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$08f054c4d766622c$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $gYlcm.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ const unbindPointerMove = (0, $6Zi52.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $08f054c4d766622c$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $08f054c4d766622c$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($08f054c4d766622c$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $6Zi52.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $08f054c4d766622c$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $6Zi52.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $08f054c4d766622c$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                const { input: input } = payload.location.current;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("ypesA", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $e22fe213fe2712e7$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $e22fe213fe2712e7$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("gwsTK", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $39900dce2c62e3e8$export$74004cb910cdc478);
const $39900dce2c62e3e8$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("gYlcm", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $26939d533db07059$export$1150b66d0ff92823);

var $9Z0cf = parcelRequire("9Z0cf");
const $26939d533db07059$export$1150b66d0ff92823 = (0, $9Z0cf.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("9Z0cf", function(module, exports) {
$parcel$export(module.exports, "once", () => $50304c48393b0a2c$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $50304c48393b0a2c$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("fxTAU", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $eedfc3f53b3c9f29$export$2aa3a33160990d96);

var $ab46a = parcelRequire("ab46a");

var $kJGmw = parcelRequire("kJGmw");

var $2PWXi = parcelRequire("2PWXi");

var $j0LTy = parcelRequire("j0LTy");
function $eedfc3f53b3c9f29$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $j0LTy.makeMonitor)();
    const dropTargetAPI = (0, $2PWXi.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $ab46a.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $ab46a.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $kJGmw.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("ab46a", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $4997e79b52fd11fb$export$3efdceeb8ca25c51);

var $6Zi52 = parcelRequire("6Zi52");

var $4RoqO = parcelRequire("4RoqO");

var $jql5V = parcelRequire("jql5V");

var $gWuwz = parcelRequire("gWuwz");

var $lOA9P = parcelRequire("lOA9P");

var $bn53K = parcelRequire("bn53K");

var $a1pfX = parcelRequire("a1pfX");
const $4997e79b52fd11fb$var$globalState = {
    isActive: false
};
function $4997e79b52fd11fb$var$canStart() {
    return !$4997e79b52fd11fb$var$globalState.isActive;
}
function $4997e79b52fd11fb$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $4997e79b52fd11fb$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $4997e79b52fd11fb$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$4997e79b52fd11fb$var$canStart()) return;
    const initial = $4997e79b52fd11fb$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $4997e79b52fd11fb$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $4997e79b52fd11fb$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $a1pfX.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $4997e79b52fd11fb$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $bn53K.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $jql5V.isHoneyPotElement)(event.target) ? (0, $4RoqO.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $4997e79b52fd11fb$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $4997e79b52fd11fb$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $6Zi52.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $gWuwz.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $bn53K.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $4997e79b52fd11fb$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $bn53K.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $lOA9P.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $4997e79b52fd11fb$var$getNativeSetDragImage(event)
    });
}
function $4997e79b52fd11fb$var$setDropEffectOnEvent({ event: event, current: current }) {
    var _current$;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $4997e79b52fd11fb$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $bn53K.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $4997e79b52fd11fb$export$3efdceeb8ca25c51 = {
    canStart: $4997e79b52fd11fb$var$canStart,
    start: $4997e79b52fd11fb$var$start
};

});
parcelRegister("gWuwz", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $01b3c9ede123c9b6$export$57d220c74e84a273);

var $hK2Sl = parcelRequire("hK2Sl");

var $9bmoJ = parcelRequire("9bmoJ");

var $aaJZh = parcelRequire("aaJZh");

var $3kFNk = parcelRequire("3kFNk");
function $01b3c9ede123c9b6$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $9bmoJ.isSafari)()) return (0, $3kFNk.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $hK2Sl.isFirefox)()) return (0, $aaJZh.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("hK2Sl", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $95c27d99357e7f28$export$b7d78993b74f766d);

var $9Z0cf = parcelRequire("9Z0cf");
const $95c27d99357e7f28$export$b7d78993b74f766d = (0, $9Z0cf.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("9bmoJ", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $680f0fdec55d32fd$export$95df08bae54cb4df);

var $9Z0cf = parcelRequire("9Z0cf");
const $680f0fdec55d32fd$export$95df08bae54cb4df = (0, $9Z0cf.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("aaJZh", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $650f4311f2731e32$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $650f4311f2731e32$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $650f4311f2731e32$export$e46810fef53b5b0e(eventTarget) {
    return $650f4311f2731e32$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});

parcelRegister("3kFNk", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $8db2a9d36b918c2e$export$f21837c338005454);

var $9bmoJ = parcelRequire("9bmoJ");

var $2uhKJ = parcelRequire("2uhKJ");
function $8db2a9d36b918c2e$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $9bmoJ.isSafari)()) return false;
    return dragLeave.hasOwnProperty((0, $2uhKJ.symbols).isLeavingWindow);
}

});
parcelRegister("2uhKJ", function(module, exports) {
$parcel$export(module.exports, "symbols", () => $778361615b6bbc70$export$47616e9f7f5fe113);

var $6Zi52 = parcelRequire("6Zi52");

var $9bmoJ = parcelRequire("9bmoJ");
const $778361615b6bbc70$export$47616e9f7f5fe113 = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $9bmoJ.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $6Zi52.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$778361615b6bbc70$export$47616e9f7f5fe113.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$778361615b6bbc70$export$47616e9f7f5fe113.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});



parcelRegister("lOA9P", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $a3ca954af0c2276d$export$ac5e5b0daf997b2);
function $a3ca954af0c2276d$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("bn53K", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $aee9fa8e70202a46$export$7c112ceec8941e67);
function $aee9fa8e70202a46$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("a1pfX", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $54dde31b393ecc48$export$9f13ecc44e83d682);

var $PIUl3 = parcelRequire("PIUl3");
const $54dde31b393ecc48$var$scheduleOnDrag = (0, $PIUl3.default)((fn)=>fn());
const $54dde31b393ecc48$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $54dde31b393ecc48$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $54dde31b393ecc48$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $54dde31b393ecc48$var$dragStart.flush();
            $54dde31b393ecc48$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $54dde31b393ecc48$var$scheduleOnDrag(()=>{
                $54dde31b393ecc48$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $54dde31b393ecc48$var$dragStart.flush();
            $54dde31b393ecc48$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("kJGmw", function(module, exports) {
$parcel$export(module.exports, "register", () => $7c62adc606f3fdc5$export$6503ec6e8aabbaf);
const $7c62adc606f3fdc5$var$ledger = new Map();
function $7c62adc606f3fdc5$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $7c62adc606f3fdc5$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $7c62adc606f3fdc5$var$ledger.set(typeKey, initial);
    return initial;
}
function $7c62adc606f3fdc5$export$6503ec6e8aabbaf(args) {
    const entry = $7c62adc606f3fdc5$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $7c62adc606f3fdc5$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("2PWXi", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $65920b371cdfba41$export$47d10e7bd9c81890);

var $gXHCV = parcelRequire("gXHCV");

var $9Z0cf = parcelRequire("9Z0cf");

var $j8Xkk = parcelRequire("j8Xkk");
function $65920b371cdfba41$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $65920b371cdfba41$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $gXHCV.combine)((0, $j8Xkk.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $9Z0cf.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        var _args$getData, _args$getDropEffect;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = ((_args$getData = args.getData) === null || _args$getData === void 0 ? void 0 : _args$getData.call(args, feedback)) ?? {};
        const dropEffect = ((_args$getDropEffect = args.getDropEffect) === null || _args$getDropEffect === void 0 ? void 0 : _args$getDropEffect.call(args, feedback)) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            var _entry$eventName;
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                var _entry$onDropTargetCh;
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) {
                    var _entry$onDragLeave;
                    entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                }
            }
            for (const record of payload.location.current.dropTargets){
                var _entry$onDropTargetCh2, _entry$onDragEnter;
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry === null || entry === void 0 || (_entry$onDropTargetCh2 = entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(entry, args);
                entry === null || entry === void 0 || (_entry$onDragEnter = entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(entry, args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $65920b371cdfba41$var$copyReverse(current);
        const actualCaptureOrdered = $65920b371cdfba41$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $65920b371cdfba41$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("j8Xkk", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $72da8c49bd3d8870$export$5dcb5c23b6ba980a);
function $72da8c49bd3d8870$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("j0LTy", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $3fd04aaa508d32df$export$5dd4ed888d5b12ca);

var $9Z0cf = parcelRequire("9Z0cf");
function $3fd04aaa508d32df$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $9Z0cf.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) {
            var _monitor$eventName;
            // @ts-expect-error: I cannot get this type working!
            (_monitor$eventName = monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(monitor, payload);
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("9QxPo", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $97bb3d46e132725b$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $97bb3d46e132725b$export$aceb3ed8b7f7bd2c);

var $9Z0cf = parcelRequire("9Z0cf");
const $97bb3d46e132725b$export$a11b0059900ceec8 = (0, $9Z0cf.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $97bb3d46e132725b$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("hMdy3", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $5cdba08e9bd1c68e$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $5cdba08e9bd1c68e$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("fZxd0", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $ad9496901a365639$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $ad9496901a365639$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("dTc7T", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $606ee94eb23b7c7c$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $606ee94eb23b7c7c$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});


parcelRegister("9z5hK", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $d6efbcc64142c7bf$export$a74bff2507e6126b);

var $gXHCV = parcelRequire("gXHCV");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $d6efbcc64142c7bf$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $d6efbcc64142c7bf$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $d6efbcc64142c7bf$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$d6efbcc64142c7bf$var$hasSameOrigin(window.location.href, iframe.src);
}
const $d6efbcc64142c7bf$var$registry = new Map();
function $d6efbcc64142c7bf$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($d6efbcc64142c7bf$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $d6efbcc64142c7bf$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $d6efbcc64142c7bf$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $d6efbcc64142c7bf$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $d6efbcc64142c7bf$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $gXHCV.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $d6efbcc64142c7bf$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $d6efbcc64142c7bf$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("jOkSF", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $436b44fb50b07d3a$export$27d79116d3a4e7d5);

var $jK44n = parcelRequire("jK44n");

var $9z5hK = parcelRequire("9z5hK");
function $436b44fb50b07d3a$var$watchForInteractionStart({ start: start }) {
    return (0, $jK44n.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $436b44fb50b07d3a$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $jK44n.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $436b44fb50b07d3a$var$api = (0, $9z5hK.makeFixForAdapter)({
    watchForInteractionStart: $436b44fb50b07d3a$var$watchForInteractionStart,
    watchForInteractionEnd: $436b44fb50b07d3a$var$watchForInteractionEnd
});
function $436b44fb50b07d3a$export$27d79116d3a4e7d5() {
    return $436b44fb50b07d3a$var$api.registerUsage();
}

});
parcelRegister("jK44n", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $40fd9864582e56e3$export$bb1740f3194979c1);

var $3w2fH = parcelRequire("3w2fH");
function $40fd9864582e56e3$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return (0, $3w2fH.adapter).monitor(args);
}

});
parcelRegister("3w2fH", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $402bbdbe523f399f$export$e00c9c6684b0ace);

var $6Zi52 = parcelRequire("6Zi52");

var $fxTAU = parcelRequire("fxTAU");

var $eWT48 = parcelRequire("eWT48");

var $lOA9P = parcelRequire("lOA9P");

var $hv2b3 = parcelRequire("hv2b3");

var $2rU8V = parcelRequire("2rU8V");

var $dGCDr = parcelRequire("dGCDr");
let $402bbdbe523f399f$var$didDragStartLocally = false;
const $402bbdbe523f399f$export$e00c9c6684b0ace = (0, $fxTAU.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $6Zi52.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($402bbdbe523f399f$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $eWT48.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = (0, $2rU8V.getAvailableTypes)(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = (0, $hv2b3.getAvailableItems)(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!(0, $dGCDr.isAnAvailableType)({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $402bbdbe523f399f$export$e00c9c6684b0ace.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $402bbdbe523f399f$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $6Zi52.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $lOA9P.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $6Zi52.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $402bbdbe523f399f$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("eWT48", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $cc066856cff640d5$export$d1c6f249e893cdf4);

var $hK2Sl = parcelRequire("hK2Sl");

var $9bmoJ = parcelRequire("9bmoJ");

var $a4AAl = parcelRequire("a4AAl");

var $aaJZh = parcelRequire("aaJZh");
function $cc066856cff640d5$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $9bmoJ.isSafari)()) return (0, $a4AAl.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $hK2Sl.isFirefox)()) return (0, $aaJZh.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("a4AAl", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $b510e914ff9eeb43$export$de68634bd94ed596);

var $9bmoJ = parcelRequire("9bmoJ");

var $2uhKJ = parcelRequire("2uhKJ");
function $b510e914ff9eeb43$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $9bmoJ.isSafari)()) return false;
    return dragEnter.hasOwnProperty((0, $2uhKJ.symbols).isEnteringWindow);
}

});


parcelRegister("hv2b3", function(module, exports) {
$parcel$export(module.exports, "getAvailableItems", () => $f15d0b5e07060d4a$export$8d28cfecded8dcab);

var $dGCDr = parcelRequire("dGCDr");
function $f15d0b5e07060d4a$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || (0, $dGCDr.isAnAvailableType)({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}

});
parcelRegister("dGCDr", function(module, exports) {
$parcel$export(module.exports, "isAnAvailableType", () => $4eb35872781a52e1$export$a8e56a860d7957c7);

var $9QxPo = parcelRequire("9QxPo");

var $hMdy3 = parcelRequire("hMdy3");

var $dTc7T = parcelRequire("dTc7T");
function $4eb35872781a52e1$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $dTc7T.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $hMdy3.textMediaType) && value === (0, $9QxPo.androidFallbackText)) return false;
    return true;
}

});


parcelRegister("2rU8V", function(module, exports) {
$parcel$export(module.exports, "getAvailableTypes", () => $0f6bc3fdd2d83fd6$export$8c257a3856120a77);

var $dGCDr = parcelRequire("dGCDr");
function $0f6bc3fdd2d83fd6$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>(0, $dGCDr.isAnAvailableType)({
            type: type,
            value: transfer.getData(type)
        }));
}

});




parcelRegister("ixWNF", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $48a6aaa3e96d065c$export$9c0606fcefb5d1e2);

var $6Zi52 = parcelRequire("6Zi52");

var $bL4wb = parcelRequire("bL4wb");

var $gXHCV = parcelRequire("gXHCV");

var $9z5hK = parcelRequire("9z5hK");
function $48a6aaa3e96d065c$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $6Zi52.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $bL4wb.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $gXHCV.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $48a6aaa3e96d065c$var$watchForInteractionStart({ start: start }) {
    return (0, $6Zi52.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $48a6aaa3e96d065c$var$api = (0, $9z5hK.makeFixForAdapter)({
    watchForInteractionStart: $48a6aaa3e96d065c$var$watchForInteractionStart,
    watchForInteractionEnd: $48a6aaa3e96d065c$var$watchForInteractionEnd
});
function $48a6aaa3e96d065c$export$9c0606fcefb5d1e2() {
    return $48a6aaa3e96d065c$var$api.registerUsage();
}

});
parcelRegister("bL4wb", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $4d160707e8656404$export$2e178e3647f5e6e9);

var $aasGs = parcelRequire("aasGs");
function $4d160707e8656404$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return (0, $aasGs.adapter).monitor(args);
}

});
parcelRegister("aasGs", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $6801c75662337c8f$export$e00c9c6684b0ace);

var $6Zi52 = parcelRequire("6Zi52");

var $fxTAU = parcelRequire("fxTAU");

var $gXHCV = parcelRequire("gXHCV");

var $f0P8I = parcelRequire("f0P8I");

var $hMdy3 = parcelRequire("hMdy3");

var $dTc7T = parcelRequire("dTc7T");

var $cMEsJ = parcelRequire("cMEsJ");

var $ihjDG = parcelRequire("ihjDG");
const $6801c75662337c8f$export$e00c9c6684b0ace = (0, $fxTAU.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $gXHCV.combine)((0, $ihjDG.honeyPotFix).bindEvents(), (0, $6Zi52.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $dTc7T.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $hMdy3.textMediaType))) return;
                const target = (0, $cMEsJ.findTextNode)(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $hMdy3.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $f0P8I.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: (0, $ihjDG.honeyPotFix).getOnPostDispatch()
});
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $6801c75662337c8f$export$e00c9c6684b0ace.registerUsage();
})();

});
parcelRegister("f0P8I", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $264cec01052efc59$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $264cec01052efc59$export$338a9f6c7a1f02b0 = 'text/html';

});

parcelRegister("cMEsJ", function(module, exports) {
$parcel$export(module.exports, "findTextNode", () => $1f0ae574c37695b5$export$c15c0fde2d293bb4);

var $9bmoJ = parcelRequire("9bmoJ");

var $hMdy3 = parcelRequire("hMdy3");
function $1f0ae574c37695b5$export$c15c0fde2d293bb4(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $9bmoJ.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $hMdy3.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}

});

parcelRegister("ihjDG", function(module, exports) {
$parcel$export(module.exports, "honeyPotFix", () => $04f77a031bca023a$export$f17744ed5439c0ab);

var $1fgnB = parcelRequire("1fgnB");
const $04f77a031bca023a$export$f17744ed5439c0ab = (0, $1fgnB.makeHoneyPotFix)();

});




parcelRegister("24i4z", function(module, exports) {
$parcel$export(module.exports, "width", () => $8265a067a9d3f7d7$export$7e3df82ee760448c);
const $8265a067a9d3f7d7$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("2Ma0k", function(module, exports) {
$parcel$export(module.exports, "default", () => $54b5ef842c195455$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $8PakO = parcelRequire("8PakO");

var $3zBNx = parcelRequire("3zBNx");

var $e9xUn = parcelRequire("e9xUn");

var $8cuhG = parcelRequire("8cuhG");

var $dVK9d = parcelRequire("dVK9d");

var $4CgiI = parcelRequire("4CgiI");

var $dRkX9 = parcelRequire("dRkX9");

var $gXHCV = parcelRequire("gXHCV");

var $kcUtj = parcelRequire("kcUtj");

var $iEPRC = parcelRequire("iEPRC");

var $h52v3 = parcelRequire("h52v3");

var $jOkSF = parcelRequire("jOkSF");

var $ixWNF = parcelRequire("ixWNF");

var $d3Rkd = parcelRequire("d3Rkd");

var $aV2Ai = parcelRequire("aV2Ai");

var $gADFe = parcelRequire("gADFe");

var $eLfID = parcelRequire("eLfID");
const $54b5ef842c195455$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $54b5ef842c195455$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
const $54b5ef842c195455$var$viewportScrollStyles = null;
const $54b5ef842c195455$var$bodyScrollStyles = null;
const $54b5ef842c195455$var$ModalDialog = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $3zBNx.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $fc4bM.useEffect)(()=>// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $gXHCV.combine)((0, $h52v3.disableDraggingToCrossOriginIFramesForElement)(), (0, $ixWNF.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $jOkSF.disableDraggingToCrossOriginIFramesForExternal)()), []);
    (0, $8PakO.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object' && !UNSAFE__disableInitialAutoFocus);
    const [motionRef, onMotionFinish] = (0, $iEPRC.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $fc4bM.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $e9xUn.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $8cuhG.useLayering)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eLfID.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kcUtj.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d3Rkd.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, $dRkX9.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVK9d.default), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, $4Cnkn.cx)($54b5ef842c195455$var$dialogStyles.motion, isFullScreen && $54b5ef842c195455$var$dialogStyles.fullscreen),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-width': (0, $gADFe.dialogWidth)(width),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-height': (0, $aV2Ai.dialogHeight)(height)
                    },
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("section", {
                        "aria-label": label,
                        ref: (0, $4dCfH.default)([
                            motionRef,
                            ref
                        ]),
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': (0, $gADFe.dialogWidth)(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': (0, $aV2Ai.dialogHeight)(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, $2R2iS.default)([
                            $54b5ef842c195455$var$dialogStyles.root,
                            $54b5ef842c195455$var$dialogStyles.rootMotion,
                            !isFullScreen && $54b5ef842c195455$var$dialogStyles.borderRadius,
                            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4CgiI.default), {
                    /**
         * We don't want a 'slide in' for the full screen modals.
         */ entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $4dCfH.default)([
                                bottomFadeInProps.ref,
                                motionRef,
                                ref
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $gADFe.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $aV2Ai.dialogHeight)(height)
                            },
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                            className: (0, $2R2iS.default)([
                                $54b5ef842c195455$var$dialogStyles.root,
                                !isFullScreen && $54b5ef842c195455$var$dialogStyles.borderRadius,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
$54b5ef842c195455$export$2e2bcd8739ae039 = $54b5ef842c195455$var$ModalDialog;

});
parcelRegister("e9xUn", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $9777fc109a0cfb3b$export$4a4bf067ea9e7886);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $8cuhG = parcelRequire("8cuhG");
const $9777fc109a0cfb3b$var$ESCAPE = 'Escape';
function $9777fc109a0cfb3b$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled, isEnabled: isEnabled = true }) {
    const escapePressed = (0, $fc4bM.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $8cuhG.useLayering)({
        isEnabled: isEnabled
    });
    const onKeyDown = (0, $fc4bM.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9777fc109a0cfb3b$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $fc4bM.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $6Zi52.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        isEnabled,
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("8cuhG", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $d391a2463ed16d07$export$c8b4d54e03dee6ed);

var $fc4bM = parcelRequire("fc4bM");

var $eKkYK = parcelRequire("eKkYK");

var $fiSZs = parcelRequire("fiSZs");

var $7LOIw = parcelRequire("7LOIw");
function $d391a2463ed16d07$export$c8b4d54e03dee6ed({ isEnabled: isEnabled = true } = {}) {
    const levelFromContext = (0, $fc4bM.useContext)((0, $eKkYK.LevelContext));
    const currentLevel = isEnabled ? levelFromContext : 0;
    const layerNode = (0, $fc4bM.useContext)((0, $fiSZs.LevelNodeContext));
    const rootNode = (0, $fc4bM.useContext)((0, $7LOIw.RootNodeContext));
    const isLayerDisabled = (0, $fc4bM.useCallback)(()=>{
        if (!isEnabled) return false;
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        isEnabled,
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $fc4bM.useCallback)(()=>{
        if (!isEnabled) return null;
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        isEnabled,
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("iEPRC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b765ff0ac797511a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $b765ff0ac797511a$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $fc4bM.useRef)(null);
    const onMotionFinish = (0, $fc4bM.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("aV2Ai", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $bf2c3fe3bcd8878c$export$ceba93bf0bdd16f2);
const $bf2c3fe3bcd8878c$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("gADFe", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $2ad8d299d78125d3$export$a3da89b899389ed8);

var $24i4z = parcelRequire("24i4z");
const $2ad8d299d78125d3$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $24i4z.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $24i4z.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("eLfID", function(module, exports) {
$parcel$export(module.exports, "default", () => $523700a59c70429f$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $1Ry06 = parcelRequire("1Ry06");

var $9dmSL = parcelRequire("9dmSL");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $523700a59c70429f$var$positionerStyles = null;
const $523700a59c70429f$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const $523700a59c70429f$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $523700a59c70429f$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $523700a59c70429f$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $523700a59c70429f$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $9dmSL.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $1Ry06.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $523700a59c70429f$var$stackStyles.stackTransition,
            stackIndex > 0 ? $523700a59c70429f$var$stackStyles.stackTransform : $523700a59c70429f$var$stackStyles.stackIdle,
            $523700a59c70429f$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$523700a59c70429f$export$2e2bcd8739ae039 = $523700a59c70429f$var$Positioner;

});




parcelRegister("i6UwG", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $6ed97895b5a07e93$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $6ed97895b5a07e93$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $6ed97895b5a07e93$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $6ed97895b5a07e93$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $6ed97895b5a07e93$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dBtOK = parcelRequire("dBtOK");
const $6ed97895b5a07e93$var$modalBodyStyles = null;
const $6ed97895b5a07e93$var$modalHeadingStyles = null;
const $6ed97895b5a07e93$var$modalImageStyles = null;
const $6ed97895b5a07e93$var$modalActionContainerStyles = null;
const $6ed97895b5a07e93$var$modalActionContainerReversedStyles = null;
const $6ed97895b5a07e93$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $6ed97895b5a07e93$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ])
    }, children);
const $6ed97895b5a07e93$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ $fc4bM.createElement("h1", {
        id: id,
        className: (0, $2R2iS.default)([
            "_11c81af2 _syaz1kw7 _6rthu2gc"
        ])
    }, children);
};
const $6ed97895b5a07e93$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ $fc4bM.createElement("img", {
        alt: alt,
        src: src,
        className: (0, $2R2iS.default)([
            "_1bsb1osq _4t3i1wug _5fbcfajl _1s1gfajl _j722idpf"
        ])
    });
const $6ed97895b5a07e93$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ])
    }, children);
const $6ed97895b5a07e93$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $6ed97895b5a07e93$var$modalActionItemStyles.root
    }, children);

});

parcelRegister("eTYDi", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $e4d507e3f488821e$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $e4d507e3f488821e$export$d131eb21ba4cbd16);
const $e4d507e3f488821e$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #0515240F)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $e4d507e3f488821e$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #0515240F)",
                dark: "var(--ds-background-disabled, #0515240F)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $e4d507e3f488821e$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $e4d507e3f488821e$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$e4d507e3f488821e$var$extract($e4d507e3f488821e$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $e4d507e3f488821e$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$e4d507e3f488821e$var$extract($e4d507e3f488821e$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});







parcelRegister("l6Vqg", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("j8HEB")).default);

var $78iOz = parcelRequire("78iOz");
parcelRequire("6GVwj");
var $j8HEB = parcelRequire("j8HEB");

});
parcelRegister("78iOz", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("6GVwj");
var $j8HEB = parcelRequire("j8HEB");
const $d4b3c323c51c77ed$var$FeatureFlag = ({ children: children, name: name, defaultValue: defaultValue, showIf: showIf = 'enabled' })=>{
    const flags = (0, $fc4bM.useContext)((0, $j8HEB.FeatureFlagsContext));
    let value = defaultValue;
    if ((0, $aYMdQ.has)(flags, name)) value = !!flags[name];
    const shouldShow = showIf === 'enabled' ? value : !value;
    return shouldShow ? children : null;
};
var $d4b3c323c51c77ed$export$2e2bcd8739ae039 = $d4b3c323c51c77ed$var$FeatureFlag;

});
parcelRegister("6GVwj", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("j8HEB")).default);
$parcel$export(module.exports, "FeatureFlagsContext", () => (parcelRequire("j8HEB")).FeatureFlagsContext);

var $j8HEB = parcelRequire("j8HEB");

});
parcelRegister("j8HEB", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagsContext", () => $ba77bb9d706df5b0$export$778f04ce1f3940a0);
$parcel$export(module.exports, "default", () => $ba77bb9d706df5b0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $ba77bb9d706df5b0$export$778f04ce1f3940a0 = /*#__PURE__*/ $fc4bM.createContext({});
const $ba77bb9d706df5b0$var$FeatureFlagProvider = ({ featureFlags: featureFlags, children: children })=>/*#__PURE__*/ $fc4bM.createElement($ba77bb9d706df5b0$export$778f04ce1f3940a0.Provider, {
        value: featureFlags
    }, children);
var $ba77bb9d706df5b0$export$2e2bcd8739ae039 = $ba77bb9d706df5b0$var$FeatureFlagProvider;

});




parcelRegister("i9uyX", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => (parcelRequire("qzyFS")).TFECacheProvider);

var $qzyFS = parcelRequire("qzyFS");

});
parcelRegister("qzyFS", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => $99d457ff36f5a43f$export$55b822f5d1bfb2cf);

var $fc4bM = parcelRequire("fc4bM");

var $hqTXx = parcelRequire("hqTXx");

var $ffc9o = parcelRequire("ffc9o");

var $hwT0O = parcelRequire("hwT0O");

var $jEubQ = parcelRequire("jEubQ");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");

var $aeF17 = parcelRequire("aeF17");
parcelRequire("6tdA4");
var $7QLam = parcelRequire("7QLam");
const $99d457ff36f5a43f$var$FIVE_MINUTE_IN_SECONDS = 300;
const $99d457ff36f5a43f$var$batchedGetExtensions = (0, $aeF17.default)((0, $ffc9o.fetchTFExtensions), 0);
const $99d457ff36f5a43f$var$batchedGetExtensionsV2 = (0, $hwT0O.default)((0, $ffc9o.fetchTFExtensions), 0);
const $99d457ff36f5a43f$export$55b822f5d1bfb2cf = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const cacheRef = $fc4bM.useRef(new (0, (/*@__PURE__*/$parcel$interopDefault($hqTXx)))({
        stdTTL: $99d457ff36f5a43f$var$FIVE_MINUTE_IN_SECONDS,
        checkperiod: $99d457ff36f5a43f$var$FIVE_MINUTE_IN_SECONDS * 0.5,
        useClones: false
    }));
    const getExtensionsByType = (type, page)=>{
        const extensionsByType = cacheRef.current.get(type);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $99d457ff36f5a43f$var$batchedGetExtensions(type);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: property,
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $aIVqJ.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const getExtensionsByTypeV2 = (type, resourceContext, page)=>{
        const { resourceId: resourceId } = resourceContext || {};
        const key = constructKey(resourceId, type);
        const extensionsByType = cacheRef.current.get(key);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $99d457ff36f5a43f$var$batchedGetExtensionsV2(type, resourceContext);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: constructKey(resourceId, property),
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $aIVqJ.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const constructKey = (resourceId, property)=>resourceId ? resourceId.concat('-'.concat(property)) : property;
    return /*#__PURE__*/ $fc4bM.createElement((0, $7QLam.TFECacheContext).Provider, {
        value: {
            getExtensionsByType: getExtensionsByType,
            getExtensionsByTypeV2: getExtensionsByTypeV2
        }
    }, children);
};
var $99d457ff36f5a43f$export$2e2bcd8739ae039 = $99d457ff36f5a43f$export$55b822f5d1bfb2cf;

});
parcelRegister("ffc9o", function(module, exports) {
$parcel$export(module.exports, "fetchTFExtensions", () => $62d94d1453b26944$export$d3cc23e3d22de5ea);

var $bTjsX = parcelRequire("bTjsX");

var $1HEEa = parcelRequire("1HEEa");

var $aIVqJ = parcelRequire("aIVqJ");

var $diqlM = parcelRequire("diqlM");
const $62d94d1453b26944$export$d3cc23e3d22de5ea = (types, resourceContext)=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/servicedesk-data/forge/fetch-extensions`;
    let body;
    const { resourceType: resourceType } = resourceContext || {};
    if (resourceType === (0, $1HEEa.RESOURCE_TYPE_ISSUE) || resourceType === (0, $1HEEa.RESOURCE_TYPE_PROJECT)) body = {
        resourceContext: resourceContext,
        extensionTypes: types
    };
    else body = {
        extensionTypes: types
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    return (0, $bTjsX.post)(uri, body, headers).map(({ response: response })=>response.extensions).catch((e)=>{
        (0, $aIVqJ.trackError)('forge-tfe.fetch.failed', {}, e);
        return Promise.reject(e);
    }).toPromise();
};

});
parcelRegister("1HEEa", function(module, exports) {
$parcel$export(module.exports, "FORGE_HELP_CENTER", () => $7f266de9c144fb9d$export$5fb35f580fb0ead9);
$parcel$export(module.exports, "FORGE_PORTAL_HOME", () => $7f266de9c144fb9d$export$f54ea43d8fdbc220);
$parcel$export(module.exports, "FORGE_REQUEST_CREATE", () => $7f266de9c144fb9d$export$7fba94cefb87c359);
$parcel$export(module.exports, "FORGE_REQUEST_DETAILS", () => $7f266de9c144fb9d$export$bc84cd79c53ab7bc);
$parcel$export(module.exports, "FORGE_REQUEST_LIST", () => $7f266de9c144fb9d$export$6089843c57d171a8);
$parcel$export(module.exports, "FORGE_PROFILE", () => $7f266de9c144fb9d$export$6c0b0fa4877ce128);
$parcel$export(module.exports, "FORGE_CSM_REQUEST_DETAILS", () => $7f266de9c144fb9d$export$4fb482ff92f899c1);
$parcel$export(module.exports, "FORGE_CSM_REQUEST_CREATE", () => $7f266de9c144fb9d$export$5487c011fec95f35);
$parcel$export(module.exports, "FORGE_CSM_HELP_CENTER", () => $7f266de9c144fb9d$export$4a57418ad478379b);
$parcel$export(module.exports, "REQUEST_DETAIL_MAIN_SECTION_MODULE", () => $7f266de9c144fb9d$export$a5069caad77a64d4);
$parcel$export(module.exports, "REQUEST_DETAIL_SIDE_SECTION_MODULE", () => $7f266de9c144fb9d$export$6df357f715dfd2f4);
$parcel$export(module.exports, "PORTAL_HEADER_MODULE", () => $7f266de9c144fb9d$export$463e8578e35a18ba);
$parcel$export(module.exports, "PORTAL_FOOTER_MODULE", () => $7f266de9c144fb9d$export$70cbbad22fbf0821);
$parcel$export(module.exports, "PORTAL_SUBHEADER_MODULE", () => $7f266de9c144fb9d$export$19ebf81efc141cb9);
$parcel$export(module.exports, "PROFILE_PANEL_MODULE", () => $7f266de9c144fb9d$export$d47ce30c5cdcdaa7);
$parcel$export(module.exports, "USER_MENU_ACTION_SECTION_MODULE", () => $7f266de9c144fb9d$export$b7f7df64576d21aa);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_MODULE", () => $7f266de9c144fb9d$export$2cdcdb01b87d24f8);
$parcel$export(module.exports, "PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE", () => $7f266de9c144fb9d$export$4df0942241cd5cc);
$parcel$export(module.exports, "HELP_CENTER_LAYOUT_ELEMENT_MODULE", () => $7f266de9c144fb9d$export$9183c6a9b59c394c);
$parcel$export(module.exports, "CSM_REQUEST_DETAIL_MODULE", () => $7f266de9c144fb9d$export$3b8e5fc21e252d78);
$parcel$export(module.exports, "CUSTOM_FIELD", () => $7f266de9c144fb9d$export$522be55130e84de4);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE", () => $7f266de9c144fb9d$export$96b7ba112deb79bf);
$parcel$export(module.exports, "UI_MODIFICATIONS", () => $7f266de9c144fb9d$export$c1878e6e4b67d4ad);
$parcel$export(module.exports, "JIRA_MODULES", () => $7f266de9c144fb9d$export$f9e7f55440c76553);
$parcel$export(module.exports, "USER_MENU_ACTION_COMPONENT", () => $7f266de9c144fb9d$export$84b6b6a1a76815b6);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_COMPONENT", () => $7f266de9c144fb9d$export$bec9cdaa83793785);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE", () => $7f266de9c144fb9d$export$7c5d9a7c5f30e041);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT", () => $7f266de9c144fb9d$export$39205aa8618a798);
$parcel$export(module.exports, "RESOURCE_TYPE_UNKNOWN", () => $7f266de9c144fb9d$export$a62b153e8eb10906);
$parcel$export(module.exports, "TOP_LEVEL_COMPONENTS", () => $7f266de9c144fb9d$export$fa9195e99a5ec8a7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $7f266de9c144fb9d$export$2b8aeda236486576);
const $7f266de9c144fb9d$export$5fb35f580fb0ead9 = 'help_center';
const $7f266de9c144fb9d$export$f54ea43d8fdbc220 = 'portal';
const $7f266de9c144fb9d$export$7fba94cefb87c359 = 'create_request';
const $7f266de9c144fb9d$export$bc84cd79c53ab7bc = 'view_request';
const $7f266de9c144fb9d$export$6089843c57d171a8 = 'my_requests';
const $7f266de9c144fb9d$export$6c0b0fa4877ce128 = 'profile';
const $7f266de9c144fb9d$export$4fb482ff92f899c1 = 'csm_view_request';
const $7f266de9c144fb9d$export$5487c011fec95f35 = 'csm_create_request';
const $7f266de9c144fb9d$export$4a57418ad478379b = 'csm_help_center';
const $7f266de9c144fb9d$export$a5069caad77a64d4 = 'jiraServiceManagement:portalRequestDetail';
const $7f266de9c144fb9d$export$6df357f715dfd2f4 = 'jiraServiceManagement:portalRequestDetailPanel';
const $7f266de9c144fb9d$export$463e8578e35a18ba = 'jiraServiceManagement:portalHeader';
const $7f266de9c144fb9d$export$70cbbad22fbf0821 = 'jiraServiceManagement:portalFooter';
const $7f266de9c144fb9d$export$19ebf81efc141cb9 = 'jiraServiceManagement:portalSubheader';
const $7f266de9c144fb9d$export$d47ce30c5cdcdaa7 = 'jiraServiceManagement:portalProfilePanel';
const $7f266de9c144fb9d$export$b7f7df64576d21aa = 'jiraServiceManagement:portalUserMenuAction';
const $7f266de9c144fb9d$export$2cdcdb01b87d24f8 = 'jiraServiceManagement:portalRequestViewAction';
const $7f266de9c144fb9d$export$4df0942241cd5cc = 'jiraServiceManagement:portalRequestCreatePropertyPanel';
const $7f266de9c144fb9d$export$9183c6a9b59c394c = 'jiraServiceManagement:helpCenterLayoutElement';
const $7f266de9c144fb9d$export$3b8e5fc21e252d78 = 'customerServiceManagement:requestDetail';
const $7f266de9c144fb9d$export$522be55130e84de4 = 'jira:customField';
const $7f266de9c144fb9d$export$96b7ba112deb79bf = 'jira:customFieldType';
const $7f266de9c144fb9d$export$c1878e6e4b67d4ad = 'jira:uiModifications';
const $7f266de9c144fb9d$export$f9e7f55440c76553 = [
    $7f266de9c144fb9d$export$522be55130e84de4,
    $7f266de9c144fb9d$export$96b7ba112deb79bf,
    $7f266de9c144fb9d$export$c1878e6e4b67d4ad
];
const $7f266de9c144fb9d$export$84b6b6a1a76815b6 = 'PortalUserMenuAction';
const $7f266de9c144fb9d$export$bec9cdaa83793785 = 'PortalRequestViewAction';
const $7f266de9c144fb9d$export$7c5d9a7c5f30e041 = 'ISSUE';
const $7f266de9c144fb9d$export$39205aa8618a798 = 'PROJECT';
const $7f266de9c144fb9d$export$a62b153e8eb10906 = 'UNKNOWN';
const $7f266de9c144fb9d$export$fa9195e99a5ec8a7 = {
    [$7f266de9c144fb9d$export$a5069caad77a64d4]: 'PortalRequestDetail',
    [$7f266de9c144fb9d$export$6df357f715dfd2f4]: 'PortalRequestDetailPanel',
    [$7f266de9c144fb9d$export$463e8578e35a18ba]: 'PortalHeader',
    [$7f266de9c144fb9d$export$70cbbad22fbf0821]: 'PortalFooter',
    [$7f266de9c144fb9d$export$19ebf81efc141cb9]: 'PortalSubheader',
    [$7f266de9c144fb9d$export$d47ce30c5cdcdaa7]: 'PortalProfilePanel',
    [$7f266de9c144fb9d$export$4df0942241cd5cc]: 'PortalRequestCreatePropertyPanel',
    [$7f266de9c144fb9d$export$3b8e5fc21e252d78]: 'CsmRequestDetail'
};
const $7f266de9c144fb9d$export$2b8aeda236486576 = 'edit';

});


parcelRegister("hwT0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa7f89b38d5e3854$export$2e2bcd8739ae039);

var $aYMdQ = parcelRequire("aYMdQ");
const $fa7f89b38d5e3854$var$defer = ()=>{
    let resolve = ()=>{
        throw new Error('Resolve function not implememnted');
    };
    let reject = ()=>{
        throw new Error('Reject function not implemented');
    };
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $fa7f89b38d5e3854$var$proxyFunctionV2 = (func, wait, options = {})=>{
    const arrMap = new Map();
    const auxillaryMap = new Map();
    let deferred = $fa7f89b38d5e3854$var$defer();
    const callThenResetArgs = (arrMap1, auxillaryMap1)=>{
        try {
            const promiseArr = [];
            arrMap1.forEach((value, key)=>promiseArr.push(func(value, auxillaryMap1.get(key))));
            promiseArr.forEach((value)=>{
                deferred.resolve(value);
            });
        } catch (err) {
            deferred.reject(err);
        }
        arrMap.clear();
        auxillaryMap.clear();
        deferred = $fa7f89b38d5e3854$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $aYMdQ.debounce)(callThenResetArgs, wait, options);
    return (arg, resourceContext)=>{
        const { resourceId: resourceId } = resourceContext || {};
        if (!resourceContext || resourceId === undefined) return deferred.promise;
        if (arrMap.has(resourceId)) {
            var _arrMap$get;
            if (!((_arrMap$get = arrMap.get(resourceId)) !== null && _arrMap$get !== void 0 && _arrMap$get.includes(arg))) {
                var _arrMap$get2;
                (_arrMap$get2 = arrMap.get(resourceId)) === null || _arrMap$get2 === void 0 || _arrMap$get2.push(arg);
            }
        } else {
            const arr = [];
            arr.push(arg);
            arrMap.set(resourceId, arr);
            auxillaryMap.set(resourceId, resourceContext);
        }
        debouncedFunc(arrMap, auxillaryMap);
        return deferred.promise;
    };
};
var $fa7f89b38d5e3854$export$2e2bcd8739ae039 = $fa7f89b38d5e3854$var$proxyFunctionV2;

});

parcelRegister("6tdA4", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => (parcelRequire("7QLam")).TFECacheContext);

var $7QLam = parcelRequire("7QLam");

});
parcelRegister("7QLam", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => $97e1c35e0b8f070f$export$2a99743cd152f1d4);

var $fc4bM = parcelRequire("fc4bM");

var $ffc9o = parcelRequire("ffc9o");

var $hwT0O = parcelRequire("hwT0O");

var $aeF17 = parcelRequire("aeF17");
const $97e1c35e0b8f070f$var$batchedGetExtensions = (0, $aeF17.default)((0, $ffc9o.fetchTFExtensions), 0);
const $97e1c35e0b8f070f$var$batchedGetExtensionsV2 = (0, $hwT0O.default)((0, $ffc9o.fetchTFExtensions), 0);
const $97e1c35e0b8f070f$export$2a99743cd152f1d4 = /*#__PURE__*/ $fc4bM.createContext({
    getExtensionsByType: $97e1c35e0b8f070f$var$batchedGetExtensions,
    getExtensionsByTypeV2: $97e1c35e0b8f070f$var$batchedGetExtensionsV2
});
$97e1c35e0b8f070f$export$2a99743cd152f1d4.displayName = 'TFECacheContext';

});




parcelRegister("kOWPe", function(module, exports) {
$parcel$export(module.exports, "LazyPushingCustomizeSidebar", () => $50a771eeaa5f3d70$export$1ccd6783fcfdc887);
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("1fQE4")).default);
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("bwpot")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("bwpot")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("bwpot")).useSetCustomiseSidebarTrigger);
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("f4bRA");
var $1fQE4 = parcelRequire("1fQE4");
parcelRequire("GyTW3");
var $bwpot = parcelRequire("bwpot");

const $50a771eeaa5f3d70$export$1ccd6783fcfdc887 = (0, $dohmo.lazy)(()=>(parcelRequire("5NuYg")), {
    moduleId: "./src/view/common/pushing-customize-sidebar/pushing-customize-sidebar.tsx"
});

});
parcelRegister("f4bRA", function(module, exports) {
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("1fQE4")).default);
$parcel$export(module.exports, "PusherConsumer", () => (parcelRequire("1fQE4")).PusherConsumer);

var $1fQE4 = parcelRequire("1fQE4");

});
parcelRegister("1fQE4", function(module, exports) {
$parcel$export(module.exports, "PusherConsumer", () => $1f46af54784eecef$export$693eb5228d48f25d);
$parcel$export(module.exports, "default", () => $1f46af54784eecef$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $k3ktd = parcelRequire("k3ktd");

var $3DjOo = parcelRequire("3DjOo");

var $6F3K7 = parcelRequire("6F3K7");

var $aYMdQ = parcelRequire("aYMdQ");

var $90b8y = parcelRequire("90b8y");
const $1f46af54784eecef$var$PusherContext = /*#__PURE__*/ $fc4bM.createContext({
    onOpen: (0, $aYMdQ.noop),
    onClose: (0, $aYMdQ.noop)
});
const $1f46af54784eecef$export$693eb5228d48f25d = $1f46af54784eecef$var$PusherContext.Consumer;
class $1f46af54784eecef$export$2e2bcd8739ae039 extends $fc4bM.Component {
    render() {
        const { children: children, className: className } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ $fc4bM.createElement($1f46af54784eecef$var$PusherContext.Provider, {
            value: {
                onOpen: this.handleOpen,
                onClose: this.handleClose
            }
        }, /*#__PURE__*/ $fc4bM.createElement($1f46af54784eecef$var$ContainerPusher, {
            className: className,
            isOpen: isOpen
        }, children));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false
        }, this.handleOpen = ()=>{
            this.setState({
                isOpen: true
            });
        }, this.handleClose = ()=>{
            this.setState({
                isOpen: false
            });
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1f46af54784eecef$var$ContainerPusher = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-sak91x-0"
})`will-change:padding-right;transition:padding-right ${(props)=>props.isOpen ? $6F3K7.timingFunctions.easeOut : $6F3K7.timingFunctions.easeIn} ${(0, $90b8y.EXPAND_TIME_MS)}ms;${(props)=>$3DjOo.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $luz1X.css)`padding:${(0, $90b8y.SIDEBAR_HEIGHT_SMALL_VIEWPORT)} 0 0 0;`)};${$k3ktd.fromMedium.css`
        ${(props)=>$3DjOo.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $luz1X.css)`padding:0 ${(0, $90b8y.SIDEBAR_WIDTH_LARGE_VIEWPORT)} 0 0;`)};
    `};`;

});
parcelRegister("k3ktd", function(module, exports) {
$parcel$export(module.exports, "fromCustom", () => $c0e92b3f11c0e3f1$export$932b0cf23a178537);
$parcel$export(module.exports, "fromXSmall", () => $c0e92b3f11c0e3f1$export$b7a79c964fba7552);
$parcel$export(module.exports, "fromSmall", () => $c0e92b3f11c0e3f1$export$639a1bf83d3a4645);
$parcel$export(module.exports, "fromMedium", () => $c0e92b3f11c0e3f1$export$e95a160cb61e118);
$parcel$export(module.exports, "fromLarge", () => $c0e92b3f11c0e3f1$export$a37dde2f785d088f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $lXJd8 = parcelRequire("lXJd8");
const $c0e92b3f11c0e3f1$var$generateBreakpoint = (minSize, maxSize)=>{
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emMinSize = minSize / 16;
    const emMaxSize = maxSize && maxSize / 16;
    let mediaQuery;
    if (emMinSize && emMaxSize) mediaQuery = `(min-width: ${emMinSize}em) and (max-width: ${emMaxSize})`;
    else if (emMinSize) mediaQuery = `(min-width: ${emMinSize}em)`;
    else if (emMaxSize) mediaQuery = `(max-width: ${emMaxSize}em)`;
    const func = (strings, ...interpolations)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        (0, $luz1X.css)`@media ${mediaQuery}{${(0, $luz1X.css)(// @ts-expect-error -- css overloads doesn't like this, but this is the exact root type we allow, confirmed to work via Storybook
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        strings, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        ...interpolations)};}`;
    return {
        // So we get syntax highlighting easily.
        css: func
    };
};
const $c0e92b3f11c0e3f1$export$932b0cf23a178537 = (minSize, maxSize)=>$c0e92b3f11c0e3f1$var$generateBreakpoint(minSize, maxSize);
const $c0e92b3f11c0e3f1$export$4da665ccee8caf55 = $c0e92b3f11c0e3f1$var$generateBreakpoint(0, (0, $lXJd8.sizes).xxsmall);
const $c0e92b3f11c0e3f1$export$9f4ec08b07b6fafc = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).xxsmall);
const $c0e92b3f11c0e3f1$export$b7a79c964fba7552 = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).xsmall);
const $c0e92b3f11c0e3f1$export$639a1bf83d3a4645 = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).small);
const $c0e92b3f11c0e3f1$export$e95a160cb61e118 = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).medium);
const $c0e92b3f11c0e3f1$export$a37dde2f785d088f = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).large);
const $c0e92b3f11c0e3f1$export$3621f41c276f9a6f = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).xlarge);
const $c0e92b3f11c0e3f1$export$86edc938645eb2d4 = $c0e92b3f11c0e3f1$var$generateBreakpoint((0, $lXJd8.sizes).xxlarge);

});
parcelRegister("lXJd8", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $ca0f72256de87f00$export$c647cb0ee6e282fe);
const $ca0f72256de87f00$export$c647cb0ee6e282fe = {
    xxlarge: 1600,
    xlarge: 1440,
    large: 1280,
    medium: 960,
    small: 840,
    xsmall: 600,
    xxsmall: 480,
    tablet: 800
};

});


parcelRegister("3DjOo", function(module, exports) {
$parcel$export(module.exports, "focusRing", () => $956cc3166b89cd29$export$8e24544ddba725ee);
$parcel$export(module.exports, "borderBox", () => $956cc3166b89cd29$export$ed32643c9618a26);
$parcel$export(module.exports, "flexCenter", () => $956cc3166b89cd29$export$6f9e4349aad79600);
$parcel$export(module.exports, "center", () => $956cc3166b89cd29$export$3481c78889e8fbe8);
$parcel$export(module.exports, "breakWord", () => $956cc3166b89cd29$export$7cb287253100bd3f);
$parcel$export(module.exports, "borderRadius", () => $956cc3166b89cd29$export$7a57f79000377ca2);
$parcel$export(module.exports, "borderRadiusLarge", () => $956cc3166b89cd29$export$d05a297a442a387);
$parcel$export(module.exports, "borderRadiusValue", () => $956cc3166b89cd29$export$56a32ffee3e5ef01);
$parcel$export(module.exports, "clamp", () => $956cc3166b89cd29$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "multiLineClamp", () => $956cc3166b89cd29$export$6a2fc6dc0ea84acc);
$parcel$export(module.exports, "applyIf", () => $956cc3166b89cd29$export$64120c40e5147be9);
$parcel$export(module.exports, "placeholder", () => $956cc3166b89cd29$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "raiseUpOnHoverOrFocus", () => $956cc3166b89cd29$export$44d27400011e4794);
$parcel$export(module.exports, "subtleThemeColorBackground", () => $956cc3166b89cd29$export$b2d8a5f61fea402f);
$parcel$export(module.exports, "toolTipPrimitiveStyle", () => $956cc3166b89cd29$export$2c414b247dcd2e5d);
$parcel$export(module.exports, "panelExpansionAnimationFix", () => $956cc3166b89cd29$export$de6b6b015066ff26);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $k2M4v = parcelRequire("k2M4v");

var $4rovU = parcelRequire("4rovU");

var $fOCtI = parcelRequire("fOCtI");

var $6F3K7 = parcelRequire("6F3K7");
/**
 * TODO: Replace with `@atlaskit/focus-ring`.
 */ const $956cc3166b89cd29$var$atlaskitFocusRing = {
    focusRing: (color = "var(--ds-border-focused, #4C9AFF)", outlineWidth = 2)=>`
        &:focus {
          outline: none;
          box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
        }
      `,
    noFocusRing: ()=>`
        box-shadow: none;
      `
};
const $956cc3166b89cd29$var$defaultFocusRing = $956cc3166b89cd29$var$atlaskitFocusRing.focusRing();
const $956cc3166b89cd29$var$noFocusRing = $956cc3166b89cd29$var$atlaskitFocusRing.noFocusRing();
const $956cc3166b89cd29$export$8e24544ddba725ee = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    default: (0, $luz1X.css)`&:focus-visible{${$956cc3166b89cd29$var$defaultFocusRing};}&:focus:not(:focus-visible){outline:0;}`,
    none: $956cc3166b89cd29$var$noFocusRing
};
const $956cc3166b89cd29$export$ed32643c9618a26 = /*#__PURE__*/ (0, $luz1X.css)`box-sizing:border-box;*{box-sizing:border-box;}`;
const $956cc3166b89cd29$export$6f9e4349aad79600 = /*#__PURE__*/ (0, $luz1X.css)`display:flex;align-items:center;justify-content:center;`;
const $956cc3166b89cd29$export$3481c78889e8fbe8 = (position)=>(0, $luz1X.css)`position:${position};top:50%;left:50%;transform:translate3d(-50%,-50%,0);`;
const $956cc3166b89cd29$export$7cb287253100bd3f = /*#__PURE__*/ (0, $luz1X.css)`white-space:pre-wrap;word-break:break-word;`;
const $956cc3166b89cd29$export$7a57f79000377ca2 = /*#__PURE__*/ (0, $luz1X.css)`border-radius:${"var(--ds-radius-small, 3px)"};`;
const $956cc3166b89cd29$export$d05a297a442a387 = /*#__PURE__*/ (0, $luz1X.css)({
    borderRadius: "var(--ds-radius-large, 8px)"
});
const $956cc3166b89cd29$export$56a32ffee3e5ef01 = `${"var(--ds-radius-small, 0.25rem)"}`;
const $956cc3166b89cd29$export$7d15b64cf5a3a4c4 = /*#__PURE__*/ (0, $luz1X.css)`text-overflow:ellipsis;overflow:hidden;white-space:nowrap;`;
const $956cc3166b89cd29$export$6a2fc6dc0ea84acc = (lines, lineHeight = $fOCtI.multiple(2.5).unitless)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $luz1X.css)`display:-webkit-box;-webkit-line-clamp:${lines};-webkit-box-orient:vertical;max-height:${lineHeight * lines}px;overflow:hidden;`;
const $956cc3166b89cd29$export$64120c40e5147be9 = (predicateResult, mixin)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $luz1X.css)`${predicateResult ? mixin : ''};`;
const $956cc3166b89cd29$export$c7187bbd1a7a9244 = (color)=>(0, $luz1X.css)`&::-webkit-input-placeholder{color:${color};}&::-moz-placeholder{color:${color};opacity:1;}&::-ms-input-placeholder{color:${color};}&:-moz-placeholder{color:${color};opacity:1;}&:-ms-input-placeholder{color:${color};}`;
const $956cc3166b89cd29$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $956cc3166b89cd29$var$isHcAdsDropCommit2Enabled = ()=>(0, $k2M4v.default).checkGate($956cc3166b89cd29$var$HC_ADS_DROP_COMMIT_2);
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $956cc3166b89cd29$var$raiseUpOnHoverPsuedoElement = /*#__PURE__*/ (0, $luz1X.css)`${$956cc3166b89cd29$export$7a57f79000377ca2};${()=>$956cc3166b89cd29$var$isHcAdsDropCommit2Enabled() && $956cc3166b89cd29$export$d05a297a442a387} content:'';position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};`;
const $956cc3166b89cd29$export$44d27400011e4794 = (fromElevation = $4rovU.e100, toElevation = $4rovU.e200)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $luz1X.css)`position:relative;transition:transform ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};&::before{${$956cc3166b89cd29$var$raiseUpOnHoverPsuedoElement};${fromElevation};z-index:inherit;}&::after{${$956cc3166b89cd29$var$raiseUpOnHoverPsuedoElement};${toElevation};opacity:0;z-index:inherit;}&:focus,&:hover{transform:translate3d(0,-2px,0);&::after{opacity:1;}&::before{opacity:0;}}`;
const $956cc3166b89cd29$export$b2d8a5f61fea402f = /*#__PURE__*/ (0, $luz1X.css)`background-image:linear-gradient(to right,rgba(255,255,255,0.85),rgba(255,255,255,0.85)),linear-gradient(to right,${(props)=>props.theme.color},${(props)=>props.theme.color});`;
// Overrides the @atlaskit/css-reset focus ring with our own
// wrapper that only shows it if you interact by keyboard.
(0, $luz1X.injectGlobal)`a{${$956cc3166b89cd29$export$8e24544ddba725ee.default};}`;
const $956cc3166b89cd29$export$2c414b247dcd2e5d = /*#__PURE__*/ (0, $luz1X.css)`color:${"var(--ds-text-inverse, #FFFFFF)"};background-color:${"var(--ds-text, #172B4D)"};padding:${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"};border-radius:${$956cc3166b89cd29$export$7a57f79000377ca2};`;
const $956cc3166b89cd29$export$de6b6b015066ff26 = /*#__PURE__*/ (0, $luz1X.css)`> div > div{box-sizing:content-box;}.rah-animating{overflow:visible !important;filter:opacity(0.05);}`;

});
parcelRegister("4rovU", function(module, exports) {
$parcel$export(module.exports, "e100", () => $a20affc23ef2b2cd$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $a20affc23ef2b2cd$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e400", () => $a20affc23ef2b2cd$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "newElevationsFromDesignSystems", () => $a20affc23ef2b2cd$export$78129b34f80acd5f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $5ZHKM = parcelRequire("5ZHKM");
const $a20affc23ef2b2cd$export$b390b459b8b8d8d0 = /*#__PURE__*/ (0, $luz1X.css)`box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};z-index:${$5ZHKM.card};`;
const $a20affc23ef2b2cd$export$3c35fb2adfe0992 = /*#__PURE__*/ (0, $luz1X.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$5ZHKM.dialog};`;
const $a20affc23ef2b2cd$export$f330dca4c33ed51f = /*#__PURE__*/ (0, $luz1X.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 8px 16px -4px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$5ZHKM.modal};`;
const $a20affc23ef2b2cd$export$3c7c047ca0ed675e = /*#__PURE__*/ (0, $luz1X.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 12px 24px -6px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$5ZHKM.panel};`;
const $a20affc23ef2b2cd$export$e6af781b0d301e56 = /*#__PURE__*/ (0, $luz1X.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 20px 32px -8px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$5ZHKM.flag};`;
const $a20affc23ef2b2cd$export$78129b34f80acd5f = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e100: (0, $luz1X.css)`z-index:${$5ZHKM.card};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};`,
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e200: (0, $luz1X.css)`z-index:${$5ZHKM.dialog};box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};`
};

});
parcelRegister("5ZHKM", function(module, exports) {
$parcel$export(module.exports, "modal", () => $d5701cffc5a94d17$export$96e4b36520c26a2c);
$parcel$export(module.exports, "card", () => $d5701cffc5a94d17$export$aa3e815946b80764);
$parcel$export(module.exports, "dialog", () => $d5701cffc5a94d17$export$518824cf31321346);
$parcel$export(module.exports, "panel", () => $d5701cffc5a94d17$export$21f42ab9b6679f44);
$parcel$export(module.exports, "flag", () => $d5701cffc5a94d17$export$42405f212471e8a2);
$parcel$export(module.exports, "layer", () => $d5701cffc5a94d17$export$50a222d9023da98b);
$parcel$export(module.exports, "pushingCustomizeSidebarSmall", () => $d5701cffc5a94d17$export$d937b725511051a5);
$parcel$export(module.exports, "pushingCustomizeSidebarLarge", () => $d5701cffc5a94d17$export$6d600c1f7c7bf904);
$parcel$export(module.exports, "pageInBannerLayout", () => $d5701cffc5a94d17$export$b3a6c753aad12c21);
$parcel$export(module.exports, "banner", () => $d5701cffc5a94d17$export$bb5ee47d9ea2348e);
$parcel$export(module.exports, "portalCardLayout", () => $d5701cffc5a94d17$export$1f2452f153db200);
$parcel$export(module.exports, "forgeLoadingComponent", () => $d5701cffc5a94d17$export$6bbd03fd9ab1103f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $2SWSA = parcelRequire("2SWSA");
const $d5701cffc5a94d17$export$96e4b36520c26a2c = (0, $2SWSA.layers).modal();
const $d5701cffc5a94d17$export$aa3e815946b80764 = (0, $2SWSA.layers).card();
const $d5701cffc5a94d17$export$518824cf31321346 = (0, $2SWSA.layers).dialog();
const $d5701cffc5a94d17$export$21f42ab9b6679f44 = (0, $2SWSA.layers).navigation();
const $d5701cffc5a94d17$export$42405f212471e8a2 = (0, $2SWSA.layers).flag();
const $d5701cffc5a94d17$export$50a222d9023da98b = (0, $2SWSA.layers).layer();
const $d5701cffc5a94d17$export$4e6f96734dfe12f4 = (0, $2SWSA.layers).tooltip();
const $d5701cffc5a94d17$export$f2ea4ab276c3e3fa = 502; // This has to be > atlaskit blanket which has a z-index of 500 and smaller than the modal layer which is at 510
const $d5701cffc5a94d17$export$312cd8ab1e0faaaa = $d5701cffc5a94d17$export$f2ea4ab276c3e3fa;
const $d5701cffc5a94d17$export$cb3a20fdbbf963aa = $d5701cffc5a94d17$export$312cd8ab1e0faaaa + 1;
const $d5701cffc5a94d17$export$d937b725511051a5 = $d5701cffc5a94d17$export$cb3a20fdbbf963aa + 1;
const $d5701cffc5a94d17$export$6d600c1f7c7bf904 = $d5701cffc5a94d17$export$96e4b36520c26a2c - 50;
const $d5701cffc5a94d17$export$363009303e3f9227 = 1;
const $d5701cffc5a94d17$export$b339878b6d12ef6c = 2;
const $d5701cffc5a94d17$export$980027fe3bc5cfbc = 3;
const $d5701cffc5a94d17$export$b3a6c753aad12c21 = -1;
const $d5701cffc5a94d17$export$bb5ee47d9ea2348e = -2;
const $d5701cffc5a94d17$export$1f2452f153db200 = 0;
const $d5701cffc5a94d17$export$6bbd03fd9ab1103f = 500;

});


parcelRegister("fOCtI", function(module, exports) {
$parcel$export(module.exports, "unitless", () => $d70e549480576640$export$c6b9faa6b723d31a);
$parcel$export(module.exports, "multiple", () => $d70e549480576640$export$939ddaa3205df08e);
$parcel$export(module.exports, "SINGLE_LINE_PARAGRAPH_HEIGHT", () => $d70e549480576640$export$7a95f3449f53d741);
const $d70e549480576640$export$c6b9faa6b723d31a = 8;
const $d70e549480576640$export$91c0eda1d06bf008 = '8px';
const $d70e549480576640$export$939ddaa3205df08e = (multiplier)=>({
        px: `${multiplier * 8}px`,
        unitless: multiplier * 8,
        multiple: (additionalMultiplier)=>$d70e549480576640$export$939ddaa3205df08e(multiplier * additionalMultiplier)
    });
const $d70e549480576640$export$7a95f3449f53d741 = 20;

});

parcelRegister("6F3K7", function(module, exports) {
$parcel$export(module.exports, "timingFunctions", () => $3c3da5dbd9152e75$export$61210fa83792a81);
$parcel$export(module.exports, "speedMs", () => $3c3da5dbd9152e75$export$e913427a0c9547b);
$parcel$export(module.exports, "fadeInOutTiming", () => $3c3da5dbd9152e75$export$44a465aba7fd9c0a);
$parcel$export(module.exports, "fadeInOut", () => $3c3da5dbd9152e75$export$6c232a6cba05a953);
$parcel$export(module.exports, "slideInOutFromTop", () => $3c3da5dbd9152e75$export$cb4674081b5c3c03);
$parcel$export(module.exports, "slideInOutFromRight", () => $3c3da5dbd9152e75$export$cb755d7f610bdc3b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
const $3c3da5dbd9152e75$export$61210fa83792a81 = {
    easeOut: 'ease-out',
    easeIn: 'ease-in',
    easeInOut: 'ease-in-out',
    // http://cubic-bezier.com/#.47,0,0,1.19
    easeInOutSpring: 'cubic-bezier(.79,.22,0,1.19)',
    linear: 'linear',
    // Same easing used in Atlaskit modal:
    // https://bitbucket.org/atlassian/atlaskit-mk-2/src/fd22974e576281b2f4d158b0a0df3badc4ed9ab2/packages/core/modal-dialog/src/components/Animation.js?at=master&fileviewer=file-view-default
    easeInOutQuad: 'cubic-bezier(0.23, 1, 0.32, 1)'
};
const $3c3da5dbd9152e75$export$e913427a0c9547b = {
    superFast: 50,
    fast: 140,
    medium: 200,
    slow: 300
};
const $3c3da5dbd9152e75$var$fadeInOutOpacityMap = {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0
};
const $3c3da5dbd9152e75$export$44a465aba7fd9c0a = (ms, delay = 0)=>(0, $luz1X.css)`transition:opacity ${ms}ms;transition-delay:${delay}ms;transition-timing-function:${$3c3da5dbd9152e75$export$61210fa83792a81.easeOut};`;
const $3c3da5dbd9152e75$export$6c232a6cba05a953 = (ms, delay = 0)=>(0, $luz1X.css)`${$3c3da5dbd9152e75$export$44a465aba7fd9c0a(ms, delay)};opacity:${(props)=>$3c3da5dbd9152e75$var$fadeInOutOpacityMap[props.state]};`;
const $3c3da5dbd9152e75$export$e83f174dbf56adcc = (ms = $3c3da5dbd9152e75$export$e913427a0c9547b.fast)=>(0, $luz1X.css)`transition:transform ${ms}ms;transition-timing-function:${$3c3da5dbd9152e75$export$61210fa83792a81.easeInOut};transform:scale(1.1);`;
const $3c3da5dbd9152e75$var$slideInOutFromTopTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(0, -100%, 0)',
    exited: 'translate3d(0, -100%, 0)'
};
const $3c3da5dbd9152e75$var$slideInOutFromRightTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(100%, 0, 0)',
    exited: 'translate3d(100%, 0, 0)'
};
const $3c3da5dbd9152e75$var$slideInOutTransitionMap = (ms)=>({
        /* This will ease out when entering, and ease-in when leaving. */ entering: `transform ${ms}ms ${$3c3da5dbd9152e75$export$61210fa83792a81.easeOut}`,
        entered: `transform ${ms}ms ${$3c3da5dbd9152e75$export$61210fa83792a81.easeOut}`,
        exiting: `transform ${ms}ms ${$3c3da5dbd9152e75$export$61210fa83792a81.easeIn}`
    });
const $3c3da5dbd9152e75$export$cb4674081b5c3c03 = (ms)=>(0, $luz1X.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $3c3da5dbd9152e75$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$3c3da5dbd9152e75$var$slideInOutFromTopTransformMap[props.state]};`;
const $3c3da5dbd9152e75$export$cb755d7f610bdc3b = (ms)=>(0, $luz1X.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $3c3da5dbd9152e75$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$3c3da5dbd9152e75$var$slideInOutFromRightTransformMap[props.state]};`;

});


parcelRegister("90b8y", function(module, exports) {
$parcel$export(module.exports, "EXPAND_TIME_MS", () => $536ccf9e62f6b5df$export$a718feb2020f924e);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_MULTIPLIER", () => $536ccf9e62f6b5df$export$916ffa0b867d54d8);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_VIEWPORT", () => $536ccf9e62f6b5df$export$66e2a13bbb493bde);
$parcel$export(module.exports, "SIDEBAR_HEIGHT_SMALL_VIEWPORT", () => $536ccf9e62f6b5df$export$3d0c478f72970318);
$parcel$export(module.exports, "SIDEBAR_FULL_HEIGHT_SMALL_VIEWPORT", () => $536ccf9e62f6b5df$export$aea0de5dee32e42e);
$parcel$export(module.exports, "TAG_BUTTON_HEIGHT", () => $536ccf9e62f6b5df$export$9aa6c06b2eb3bd9e);

var $fOCtI = parcelRequire("fOCtI");

var $6F3K7 = parcelRequire("6F3K7");
const $536ccf9e62f6b5df$export$a718feb2020f924e = $6F3K7.speedMs.medium;
const $536ccf9e62f6b5df$export$916ffa0b867d54d8 = 50;
const $536ccf9e62f6b5df$export$66e2a13bbb493bde = $fOCtI.multiple($536ccf9e62f6b5df$export$916ffa0b867d54d8).px;
const $536ccf9e62f6b5df$export$3d0c478f72970318 = '40vh';
const $536ccf9e62f6b5df$export$aea0de5dee32e42e = '100vh';
const $536ccf9e62f6b5df$export$9aa6c06b2eb3bd9e = $fOCtI.unitless * 5;

});



parcelRegister("GyTW3", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("bwpot")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("bwpot")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("bwpot")).useSetCustomiseSidebarTrigger);

var $bwpot = parcelRequire("bwpot");

});
parcelRegister("bwpot", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => $9cadb64e6276dfb5$export$80c1c1cfdf49ec8a);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => $9cadb64e6276dfb5$export$2ffc1f557dddded2);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => $9cadb64e6276dfb5$export$d2c4b172b3db92fb);

var $fc4bM = parcelRequire("fc4bM");
const $9cadb64e6276dfb5$var$TriggerRefContext = /*#__PURE__*/ $fc4bM.createContext(null);
const $9cadb64e6276dfb5$export$80c1c1cfdf49ec8a = ({ children: children })=>{
    const triggerRef = $fc4bM.useRef(null);
    const setTriggerElement = $fc4bM.useCallback((element)=>{
        // Using a mutable ref pattern since we can't reassign .current on a RefObject
        triggerRef.current = element;
    }, []);
    const value = $fc4bM.useMemo(()=>({
            triggerRef: triggerRef,
            setTriggerElement: setTriggerElement
        }), [
        setTriggerElement
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($9cadb64e6276dfb5$var$TriggerRefContext.Provider, {
        value: value
    }, children);
};
const $9cadb64e6276dfb5$export$2ffc1f557dddded2 = ()=>{
    const context = $fc4bM.useContext($9cadb64e6276dfb5$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.triggerRef;
};
const $9cadb64e6276dfb5$export$d2c4b172b3db92fb = ()=>{
    const context = $fc4bM.useContext($9cadb64e6276dfb5$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.setTriggerElement;
};

});


parcelRegister("5NuYg", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("i8XXW").then(()=>parcelRequire('4wWMd'));

});


parcelRegister("llvqx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a368d751488b1226$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $5NcB7 = parcelRequire("5NcB7");

var $cFXRY = parcelRequire("cFXRY");

var $irt1V = parcelRequire("irt1V");

var $1LbNU = parcelRequire("1LbNU");

var $9Ar0y = parcelRequire("9Ar0y");

var $kQuRg = parcelRequire("kQuRg");

var $jKBaN = parcelRequire("jKBaN");

var $gyQWf = parcelRequire("gyQWf");

var $4DNen = parcelRequire("4DNen");

var $5mCd1 = parcelRequire("5mCd1");

var $7CWlY = parcelRequire("7CWlY");

var $8WjJw = parcelRequire("8WjJw");

var $1IUS0 = parcelRequire("1IUS0");

var $42IE4 = parcelRequire("42IE4");

var $czthQ = parcelRequire("czthQ");

var $kPTDf = parcelRequire("kPTDf");

var $afTgE = parcelRequire("afTgE");

var $5Xqwh = parcelRequire("5Xqwh");

var $7sILx = parcelRequire("7sILx");

var $55k25 = parcelRequire("55k25");

var $21BkE = parcelRequire("21BkE");

var $38vAg = parcelRequire("38vAg");
const $a368d751488b1226$var$listenerMap = {
    [(0, $38vAg.FabricChannel).a2ui]: (0, $5NcB7.default),
    [(0, $38vAg.FabricChannel).elements]: (0, $gyQWf.default),
    [(0, $38vAg.FabricChannel).editor]: (0, $jKBaN.default),
    [(0, $38vAg.FabricChannel).atlaskit]: (0, $1LbNU.default),
    [(0, $38vAg.FabricChannel).navigation]: (0, $1IUS0.default),
    [(0, $38vAg.FabricChannel).media]: (0, $8WjJw.default),
    [(0, $38vAg.FabricChannel).peopleTeams]: (0, $kPTDf.default),
    [(0, $38vAg.FabricChannel).notifications]: (0, $42IE4.default),
    [(0, $38vAg.FabricChannel).recentWork]: (0, $5Xqwh.default),
    [(0, $38vAg.FabricChannel).atlas]: (0, $irt1V.default),
    [(0, $38vAg.FabricChannel).crossFlow]: (0, $kQuRg.default),
    [(0, $38vAg.FabricChannel).linkingPlatform]: (0, $7CWlY.default),
    [(0, $38vAg.FabricChannel).postOffice]: (0, $afTgE.default),
    [(0, $38vAg.FabricChannel).aiMate]: (0, $cFXRY.default),
    [(0, $38vAg.FabricChannel).avp]: (0, $9Ar0y.default),
    [(0, $38vAg.FabricChannel).growth]: (0, $4DNen.default),
    [(0, $38vAg.FabricChannel).omniChannel]: (0, $czthQ.default),
    [(0, $38vAg.FabricChannel).townsquareHome]: (0, $21BkE.default),
    [(0, $38vAg.FabricChannel).rovoExtension]: (0, $7sILx.default),
    [(0, $38vAg.FabricChannel).teamworkGraph]: (0, $55k25.default)
};
class $a368d751488b1226$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $5mCd1.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($a368d751488b1226$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$a368d751488b1226$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Listener, {
                client: client,
                logger: this.logger
            }, prev), children);
        return listeners;
    }
}
var $a368d751488b1226$export$2e2bcd8739ae039 = $a368d751488b1226$var$FabricAnalyticsListeners;

});
parcelRegister("5NcB7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed6fbb8165032679$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $9xiot = parcelRequire("9xiot");
function $ed6fbb8165032679$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).a2ui,
        processEvent: (0, $9xiot.default)
    });
}

});
parcelRegister("asqkb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b28bca272f7307a1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hH2zO = parcelRequire("hH2zO");

var $1kpTg = parcelRequire("1kpTg");
class $b28bca272f7307a1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $1kpTg.sendEvent)(logger, client)(payload);
        };
    }
}

});
parcelRegister("1kpTg", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $d4d031078992d0c6$export$7329bcdc3edcd90e);
const $d4d031078992d0c6$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $d4d031078992d0c6$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($d4d031078992d0c6$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});


parcelRegister("38vAg", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $0f379cb5077614e8$export$8faa0b115ef0268b);
var $0f379cb5077614e8$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["a2ui"] = "a2ui";
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("9xiot", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dd34332f1316d7c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $9dd34332f1316d7c$var$A2UI_CONTEXT = 'a2ui';
const $9dd34332f1316d7c$var$A2UI_TAG = 'a2ui';
const $9dd34332f1316d7c$var$listenerVersion = undefined;
var /**
 * This util exists to convert A2UI analytics-next events into the analytics platform format.
 */ $9dd34332f1316d7c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, $9dd34332f1316d7c$var$A2UI_CONTEXT);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, $9dd34332f1316d7c$var$A2UI_CONTEXT);
    const components = (0, $iD76A.getComponents)(event, $9dd34332f1316d7c$var$A2UI_CONTEXT);
    const packages = (0, $bu7M7.getPackageInfo)(event, $9dd34332f1316d7c$var$A2UI_CONTEXT);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(packages) ?? {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId, containerType: containerType, name: name, objectId: objectId, objectType: objectType, path: path, url: url } = event.payload;
    const attributes = {
        listenerVersion: $9dd34332f1316d7c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    tags.add($9dd34332f1316d7c$var$A2UI_TAG);
    switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags),
                ...path && {
                    path: path
                },
                ...url && {
                    url: url
                }
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("aDo1D", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $9d63b9b799b29606$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $9d63b9b799b29606$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $9d63b9b799b29606$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $9d63b9b799b29606$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $9d63b9b799b29606$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $9d63b9b799b29606$export$a1562d08625f5d7e = 'ui';
const $9d63b9b799b29606$export$947dac6c72b26f81 = 'track';
const $9d63b9b799b29606$export$f1d537d508d2945a = 'screen';
const $9d63b9b799b29606$export$12346a674644c156 = 'operational';
const $9d63b9b799b29606$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("iD76A", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $6a3d8f0b3a07c6ab$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $iuJUF = parcelRequire("iuJUF");
const $6a3d8f0b3a07c6ab$export$4e811121b221213b = (event, contextName)=>(0, $iuJUF.extractFromEventContext)([
        'component',
        'componentName'
    ], event, false, contextName);

});
parcelRegister("iuJUF", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $c6d75e2f4c7b0985$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $c6d75e2f4c7b0985$export$9b947b4502cd2705 = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);

});


parcelRegister("fufbe", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $957b372bdccda125$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $eVfhL = parcelRequire("eVfhL");

var $iuJUF = parcelRequire("iuJUF");
const $957b372bdccda125$export$67c3590839ebecdd = (event, contextName)=>(0, $iuJUF.extractFromEventContext)([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(result, extraAttributes), {});

});

parcelRegister("bu7M7", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $9207c2c4aad497ff$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $9207c2c4aad497ff$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);

});

parcelRegister("lj5LR", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $fff0b815add1d32a$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $iuJUF = parcelRequire("iuJUF");
const $fff0b815add1d32a$export$5f9bc633b116660f = (event, contextName)=>(0, $iuJUF.extractFromEventContext)([
        'source'
    ], event, false, contextName);

});



parcelRegister("cFXRY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8cc2443427daf91$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $ibez8 = parcelRequire("ibez8");
function $d8cc2443427daf91$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).aiMate,
        processEvent: (0, $ibez8.default)
    });
}

});
parcelRegister("ibez8", function(module, exports) {
$parcel$export(module.exports, "default", () => $8700230f2ae76a79$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $9Q4Ep = parcelRequire("9Q4Ep");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $8700230f2ae76a79$var$AI_MATE_TAG = 'aiMate';
const $8700230f2ae76a79$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $8700230f2ae76a79$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $9Q4Ep.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $9Q4Ep.AI_MATE_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $9Q4Ep.AI_MATE_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $9Q4Ep.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $9Q4Ep.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name, objectId: objectId, objectType: objectType, containerType: containerType, containerId: containerId, path: path, url: url } = event.payload;
    const attributes = {
        listenerVersion: $8700230f2ae76a79$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($8700230f2ae76a79$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags),
                ...path && {
                    path: path
                },
                ...url && {
                    url: url
                }
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("9Q4Ep", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $7ee1f11c875a4f70$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $7ee1f11c875a4f70$export$de3826c30468da26);

var $4Cyej = parcelRequire("4Cyej");
const $7ee1f11c875a4f70$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $7ee1f11c875a4f70$export$de3826c30468da26 = (0, $4Cyej.default)($7ee1f11c875a4f70$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});
parcelRegister("4Cyej", function(module, exports) {
$parcel$export(module.exports, "default", () => $6724df29e0b30288$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");
const $6724df29e0b30288$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $6724df29e0b30288$export$2e2bcd8739ae039 = $6724df29e0b30288$var$createNamespaceContext;

});




parcelRegister("irt1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $32d07fe2eb66c652$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $bj7il = parcelRequire("bj7il");
function $32d07fe2eb66c652$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).atlas,
        processEvent: (0, $bj7il.default)
    });
}

});
parcelRegister("bj7il", function(module, exports) {
$parcel$export(module.exports, "default", () => $eff4359ea6057b1a$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $5U1Z1 = parcelRequire("5U1Z1");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $eff4359ea6057b1a$var$ATLAS_TAG = 'atlas';
const $eff4359ea6057b1a$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $eff4359ea6057b1a$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $5U1Z1.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $5U1Z1.ATLAS_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $5U1Z1.ATLAS_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $5U1Z1.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $5U1Z1.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $eff4359ea6057b1a$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($eff4359ea6057b1a$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("5U1Z1", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $99575e98d3cb48c5$export$4906017439f33fc0);

var $4Cyej = parcelRequire("4Cyej");
const $99575e98d3cb48c5$export$4906017439f33fc0 = 'atlasCtx';
const $99575e98d3cb48c5$export$43ebbe41370d4543 = (0, $4Cyej.default)($99575e98d3cb48c5$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});



parcelRegister("1LbNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f2534e50331f3b5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $jjteT = parcelRequire("jjteT");
function $0f2534e50331f3b5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).atlaskit,
        processEvent: (0, $jjteT.default)
    });
}

});
parcelRegister("jjteT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1638335dab212852$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $aabbp = parcelRequire("aabbp");

var $gXeBj = parcelRequire("gXeBj");

var $9zKtG = parcelRequire("9zKtG");

var $3VX7Y = parcelRequire("3VX7Y");

var $lENOA = parcelRequire("lENOA");

var $bxyiG = parcelRequire("bxyiG");
const $1638335dab212852$var$ATLASKIT_TAG = 'atlaskit';
const $1638335dab212852$var$listenerVersion = undefined;
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1638335dab212852$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bxyiG.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $9zKtG.getExtraAttributes)(event);
    const components = (0, $gXeBj.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $lENOA.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $1638335dab212852$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $3VX7Y.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1638335dab212852$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $aDo1D.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $aabbp.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $aDo1D.TRACK_EVENT_TYPE) || eventType === (0, $aDo1D.OPERATIONAL_EVENT_TYPE) || eventType === (0, $aDo1D.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("aabbp", function(module, exports) {
$parcel$export(module.exports, "getActionSubject", () => $872d0fbb3a5c58b8$export$6f40cdf6d42c018d);
/**
 * Largely taken from analytics-web-react
 */ 
var $78A4i = parcelRequire("78A4i");
const $872d0fbb3a5c58b8$export$6f40cdf6d42c018d = (event)=>{
    const overrides = (0, $78A4i.extractFromEventContext)('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};

});
parcelRegister("78A4i", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $654ad8c6006b4b33$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $654ad8c6006b4b33$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);

});


parcelRegister("gXeBj", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $331e6ec05ee61b0b$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $78A4i = parcelRequire("78A4i");
const $331e6ec05ee61b0b$export$4e811121b221213b = (event)=>(0, $78A4i.extractFromEventContext)('component', event);

});

parcelRegister("9zKtG", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $b02f8b1ea1a1207c$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $eVfhL = parcelRequire("eVfhL");

var $78A4i = parcelRequire("78A4i");
const $b02f8b1ea1a1207c$export$67c3590839ebecdd = (event)=>(0, $78A4i.extractFromEventContext)('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(result, extraAttributes), {});

});

parcelRegister("3VX7Y", function(module, exports) {
$parcel$export(module.exports, "getPackageHierarchy", () => $4d632cc635f96607$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $lENOA = parcelRequire("lENOA");
function $4d632cc635f96607$export$4e0b83da1896ebc7(event) {
    const packages = (0, $lENOA.getPackageInfo)(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});
parcelRegister("lENOA", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $e16237589a15192f$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $e16237589a15192f$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);

});


parcelRegister("bxyiG", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $74c66244cf1db457$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $78A4i = parcelRequire("78A4i");
const $74c66244cf1db457$export$5f9bc633b116660f = (event)=>(0, $78A4i.extractFromEventContext)('source', event);

});



parcelRegister("9Ar0y", function(module, exports) {
$parcel$export(module.exports, "default", () => $c793b0451b2ae90d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $bRLGE = parcelRequire("bRLGE");
function $c793b0451b2ae90d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).avp,
        processEvent: (0, $bRLGE.default)
    });
}

});
parcelRegister("bRLGE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b9d659844461a43$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $8WstS = parcelRequire("8WstS");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $7b9d659844461a43$var$AVP_TAG = 'avp';
const $7b9d659844461a43$var$AVP_PLATFORM_TAG = 'analyticsVisualizationPlatform';
const $7b9d659844461a43$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7b9d659844461a43$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $8WstS.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $8WstS.AVP_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $8WstS.AVP_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $8WstS.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $8WstS.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $7b9d659844461a43$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))({}, ...event.context)
    };
    // Put the registered platform tag first for product attribution, retaining the legacy tag.
    const tags = new Set([
        $7b9d659844461a43$var$AVP_PLATFORM_TAG,
        $7b9d659844461a43$var$AVP_TAG,
        ...event.payload.tags || []
    ]);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("8WstS", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $79d0ef5c78e6e8c5$export$c2a811a4e42f4af5);

var $4Cyej = parcelRequire("4Cyej");
const $79d0ef5c78e6e8c5$export$c2a811a4e42f4af5 = 'avpCtx';
const $79d0ef5c78e6e8c5$export$da383e8879a25b03 = (0, $4Cyej.default)($79d0ef5c78e6e8c5$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});



parcelRegister("kQuRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b4e4b8aef32d8b0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $c8J1x = parcelRequire("c8J1x");
function $0b4e4b8aef32d8b0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).crossFlow,
        processEvent: (0, $c8J1x.default)
    });
}

});
parcelRegister("c8J1x", function(module, exports) {
$parcel$export(module.exports, "default", () => $308c3efd5c3d4de3$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $aDo1D = parcelRequire("aDo1D");

var $aGcDH = parcelRequire("aGcDH");

var $9zKtG = parcelRequire("9zKtG");

var $bxyiG = parcelRequire("bxyiG");

var $fufbe = parcelRequire("fufbe");
const $308c3efd5c3d4de3$var$CROSS_FLOW_TAG = 'crossFlow';
var $308c3efd5c3d4de3$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $bxyiG.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $9zKtG.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $fufbe.getExtraAttributes)(event, (0, $aGcDH.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($308c3efd5c3d4de3$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("aGcDH", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $5275e99c2bcae948$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $5275e99c2bcae948$export$d0a82da1a0b94929);

var $4Cyej = parcelRequire("4Cyej");
const $5275e99c2bcae948$export$1fd3aad76a7c6788 = 'navigationCtx';
const $5275e99c2bcae948$export$d0a82da1a0b94929 = (0, $4Cyej.default)($5275e99c2bcae948$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});



parcelRegister("jKBaN", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $248b1f8c67e2b8a7$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $248b1f8c67e2b8a7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hH2zO = parcelRequire("hH2zO");

var $38vAg = parcelRequire("38vAg");

var $ebza6 = parcelRequire("ebza6");
const $248b1f8c67e2b8a7$export$a1d9dc589a29b3aa = 'editor';
const $248b1f8c67e2b8a7$export$8aa0d788f94a809 = 'fabricEditor';
class $248b1f8c67e2b8a7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $38vAg.FabricChannel).editor
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $ebza6.handleEvent)(event, [
                $248b1f8c67e2b8a7$export$a1d9dc589a29b3aa,
                $248b1f8c67e2b8a7$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("ebza6", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $b787910989078577$export$d6e5ca10785815df);

var $1kpTg = parcelRequire("1kpTg");

var $7LGGR = parcelRequire("7LGGR");
const $b787910989078577$export$d6e5ca10785815df = (event, tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $7LGGR.processEventPayload)(event, tags);
    (0, $1kpTg.sendEvent)(logger, client)(payload);
};

});
parcelRegister("7LGGR", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $482a7ac54bb680aa$export$c37d638b7f2ca192);

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $hykpf = parcelRequire("hykpf");

var $7RAao = parcelRequire("7RAao");

var $jKBaN = parcelRequire("jKBaN");

var $gyQWf = parcelRequire("gyQWf");
const $482a7ac54bb680aa$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(result, item), {});
const $482a7ac54bb680aa$var$fieldExtractor = (contextKey)=>$482a7ac54bb680aa$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $482a7ac54bb680aa$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $gyQWf.ELEMENTS_TAG:
            return 0, $7RAao.ELEMENTS_CONTEXT;
        case 0, $jKBaN.EDITOR_TAG:
            return 0, $hykpf.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $482a7ac54bb680aa$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $aDo1D.DEFAULT_SOURCE),
        ...event.payload
    };
    const contextKey = $482a7ac54bb680aa$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $482a7ac54bb680aa$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $aDo1D.DEFAULT_SOURCE),
        ...fields,
        ...event.payload
    };
};
const $482a7ac54bb680aa$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $482a7ac54bb680aa$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $482a7ac54bb680aa$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $482a7ac54bb680aa$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$482a7ac54bb680aa$var$updatePayloadWithContext(primaryTag, event),
        tags: $482a7ac54bb680aa$var$addTags(tagsArray, event.payload.tags)
    };
};

});
parcelRegister("hykpf", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $805cbf6399c37ebd$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $805cbf6399c37ebd$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $805cbf6399c37ebd$export$629cada6c5e621e1);

var $4Cyej = parcelRequire("4Cyej");
const $805cbf6399c37ebd$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $805cbf6399c37ebd$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $805cbf6399c37ebd$export$629cada6c5e621e1 = (0, $4Cyej.default)($805cbf6399c37ebd$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("7RAao", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $efcc2ad478039f55$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $efcc2ad478039f55$export$3fe25500478a635c);

var $4Cyej = parcelRequire("4Cyej");
const $efcc2ad478039f55$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $efcc2ad478039f55$export$3fe25500478a635c = (0, $4Cyej.default)($efcc2ad478039f55$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});

parcelRegister("gyQWf", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $9b7b4d402bf73f38$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $9b7b4d402bf73f38$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hH2zO = parcelRequire("hH2zO");

var $38vAg = parcelRequire("38vAg");

var $ebza6 = parcelRequire("ebza6");
const $9b7b4d402bf73f38$export$ed71ae78997933a = 'fabricElements';
class $9b7b4d402bf73f38$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $38vAg.FabricChannel).elements
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $ebza6.handleEvent)(event, $9b7b4d402bf73f38$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("4DNen", function(module, exports) {
$parcel$export(module.exports, "default", () => $defe124b1b7b9c5b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $1lR1U = parcelRequire("1lR1U");
function $defe124b1b7b9c5b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).growth,
        processEvent: (0, $1lR1U.default)
    });
}

});
parcelRegister("1lR1U", function(module, exports) {
$parcel$export(module.exports, "default", () => $67a8bc92c2f1e982$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $jBJBO = parcelRequire("jBJBO");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $67a8bc92c2f1e982$var$GROWTH_TAG = 'growth';
const $67a8bc92c2f1e982$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $67a8bc92c2f1e982$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $jBJBO.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $jBJBO.GROWTH_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $jBJBO.GROWTH_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $jBJBO.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $jBJBO.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $67a8bc92c2f1e982$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($67a8bc92c2f1e982$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("jBJBO", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $6f5192da764f21fb$export$82023f2f4bfb06c1);

var $4Cyej = parcelRequire("4Cyej");
const $6f5192da764f21fb$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $6f5192da764f21fb$export$84980182680018f = (0, $4Cyej.default)($6f5192da764f21fb$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});



parcelRegister("5mCd1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5ab9508fc51b7a1$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $e5ab9508fc51b7a1$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $e5ab9508fc51b7a1$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $e5ab9508fc51b7a1$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $e5ab9508fc51b7a1$export$ffe0c436e29512cf.DEBUG && logLevel <= $e5ab9508fc51b7a1$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $e5ab9508fc51b7a1$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($e5ab9508fc51b7a1$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($e5ab9508fc51b7a1$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($e5ab9508fc51b7a1$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($e5ab9508fc51b7a1$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("7CWlY", function(module, exports) {
$parcel$export(module.exports, "default", () => $48f9488757845f04$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $1UVdg = parcelRequire("1UVdg");
function $48f9488757845f04$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).linkingPlatform,
        processEvent: (0, $1UVdg.default)
    });
}

});
parcelRegister("1UVdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $b94e4a08001f1c61$export$2e2bcd8739ae039);

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $k0gAc = parcelRequire("k0gAc");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");

var $38vAg = parcelRequire("38vAg");
const $b94e4a08001f1c61$var$listenerVersion = undefined;
var $b94e4a08001f1c61$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $k0gAc.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $k0gAc.LINKING_PLATFORM_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $k0gAc.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $k0gAc.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $38vAg.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $b94e4a08001f1c61$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});
parcelRegister("k0gAc", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $d3c8bce8578fe34d$export$3240443bf2b83834);

var $4Cyej = parcelRequire("4Cyej");
const $d3c8bce8578fe34d$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $d3c8bce8578fe34d$export$6d568da622ce0a08 = (0, $4Cyej.default)($d3c8bce8578fe34d$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});



parcelRegister("8WjJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca080586e3ae6aad$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $gEeqH = parcelRequire("gEeqH");
function $ca080586e3ae6aad$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).media,
        processEvent: (0, $gEeqH.processEvent)
    });
}

});
parcelRegister("gEeqH", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $369f05f38bb4e02c$export$22af68e3614bf024);

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $egppF = parcelRequire("egppF");

var $78A4i = parcelRequire("78A4i");

var $gXeBj = parcelRequire("gXeBj");

var $9zKtG = parcelRequire("9zKtG");

var $3VX7Y = parcelRequire("3VX7Y");

var $lENOA = parcelRequire("lENOA");

var $bxyiG = parcelRequire("bxyiG");
const $369f05f38bb4e02c$var$listenerVersion = undefined;
function $369f05f38bb4e02c$var$getMediaContexts(event) {
    return (0, $78A4i.extractFromEventContext)((0, $egppF.MEDIA_CONTEXT), event);
}
function $369f05f38bb4e02c$var$getMediaRegion() {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $369f05f38bb4e02c$export$22af68e3614bf024(event) {
    const sources = (0, $bxyiG.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $lENOA.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $9zKtG.getExtraAttributes)(event);
    const mediaContexts = $369f05f38bb4e02c$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $gXeBj.getComponents)(event);
    const mediaRegion = $369f05f38bb4e02c$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $3VX7Y.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $369f05f38bb4e02c$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});
parcelRegister("egppF", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $a0ce8d0f14c0da3b$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $a0ce8d0f14c0da3b$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});



parcelRegister("1IUS0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7718b6d478ee8dd6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $iBNBl = parcelRequire("iBNBl");
function $7718b6d478ee8dd6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).navigation,
        processEvent: (0, $iBNBl.default)
    });
}

});
parcelRegister("iBNBl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6b8f411c7cb299c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $aGcDH = parcelRequire("aGcDH");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $e6b8f411c7cb299c$var$NAVIGATION_TAG = 'navigation';
const $e6b8f411c7cb299c$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e6b8f411c7cb299c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $aGcDH.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $aGcDH.NAVIGATION_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $aGcDH.NAVIGATION_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $aGcDH.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $aGcDH.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e6b8f411c7cb299c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e6b8f411c7cb299c$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("42IE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0191cf51ff96b8f8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $jqEMF = parcelRequire("jqEMF");
function $0191cf51ff96b8f8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).notifications,
        processEvent: (0, $jqEMF.default)
    });
}

});
parcelRegister("jqEMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $fff79ff5557fcd57$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $7uLYM = parcelRequire("7uLYM");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");

var $38vAg = parcelRequire("38vAg");
const $fff79ff5557fcd57$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $fff79ff5557fcd57$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $7uLYM.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $7uLYM.NOTIFICATIONS_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $7uLYM.NOTIFICATIONS_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $7uLYM.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $7uLYM.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $fff79ff5557fcd57$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $38vAg.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("7uLYM", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $24a39fb804390ada$export$da1befb791e93c7e);

var $4Cyej = parcelRequire("4Cyej");
const $24a39fb804390ada$export$da1befb791e93c7e = 'NotificationsCtx';
const $24a39fb804390ada$export$6f8e7ff1e3feafd7 = (0, $4Cyej.default)($24a39fb804390ada$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});



parcelRegister("czthQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a93ea128465da17$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $aLSbw = parcelRequire("aLSbw");
const $9a93ea128465da17$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).omniChannel,
        processEvent: (0, $aLSbw.default)
    });
};
var $9a93ea128465da17$export$2e2bcd8739ae039 = $9a93ea128465da17$var$OmniChannelAnalyticsListener;

});
parcelRegister("aLSbw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c3dac99ae751e85$export$2e2bcd8739ae039);

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $3FhZW = parcelRequire("3FhZW");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");

var $38vAg = parcelRequire("38vAg");
const $0c3dac99ae751e85$var$listenerVersion = undefined;
var $0c3dac99ae751e85$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $3FhZW.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $3FhZW.OMNI_CHANNEL_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $3FhZW.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $3FhZW.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $3FhZW.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $0c3dac99ae751e85$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $38vAg.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("3FhZW", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $02543d599506f39d$export$6d3c48fd1b3e4f3b);

var $4Cyej = parcelRequire("4Cyej");
const $02543d599506f39d$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $02543d599506f39d$export$e4e6df99270bbbb1 = (0, $4Cyej.default)($02543d599506f39d$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});



parcelRegister("kPTDf", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd6f4d2ae98e1dd0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $8VItV = parcelRequire("8VItV");
function $fd6f4d2ae98e1dd0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).peopleTeams,
        processEvent: (0, $8VItV.default)
    });
}

});
parcelRegister("8VItV", function(module, exports) {
$parcel$export(module.exports, "default", () => $824657e4832f3094$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $9Datw = parcelRequire("9Datw");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $824657e4832f3094$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $824657e4832f3094$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $824657e4832f3094$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $9Datw.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $9Datw.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $9Datw.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $9Datw.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $9Datw.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $824657e4832f3094$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($824657e4832f3094$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("9Datw", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $a8afe7df168f79b9$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $a8afe7df168f79b9$export$4119ddb38ccbfb87);

var $4Cyej = parcelRequire("4Cyej");
const $a8afe7df168f79b9$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $a8afe7df168f79b9$export$4119ddb38ccbfb87 = (0, $4Cyej.default)($a8afe7df168f79b9$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});



parcelRegister("afTgE", function(module, exports) {
$parcel$export(module.exports, "default", () => $97d274afd15fabc7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $6rplT = parcelRequire("6rplT");
function $97d274afd15fabc7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).postOffice,
        processEvent: (0, $6rplT.default)
    });
}

});
parcelRegister("6rplT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f3f5b4c0a75eed3$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $hopeZ = parcelRequire("hopeZ");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");

var $38vAg = parcelRequire("38vAg");
const $1f3f5b4c0a75eed3$var$POST_OFFICE_TAG = (0, $38vAg.FabricChannel).postOffice;
const $1f3f5b4c0a75eed3$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1f3f5b4c0a75eed3$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $hopeZ.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $hopeZ.POST_OFFICE_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $hopeZ.POST_OFFICE_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $hopeZ.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $hopeZ.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $1f3f5b4c0a75eed3$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1f3f5b4c0a75eed3$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("hopeZ", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $a06fcaf903cf607c$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $a06fcaf903cf607c$export$dcd232f3be312f94);

var $4Cyej = parcelRequire("4Cyej");
const $a06fcaf903cf607c$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $a06fcaf903cf607c$export$dcd232f3be312f94 = (0, $4Cyej.default)($a06fcaf903cf607c$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});



parcelRegister("5Xqwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d04a160438173bf$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $8eFGq = parcelRequire("8eFGq");
function $1d04a160438173bf$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).recentWork,
        processEvent: (0, $8eFGq.default)
    });
}

});
parcelRegister("8eFGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c9c985f2b884d95$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $4MPLJ = parcelRequire("4MPLJ");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");

var $38vAg = parcelRequire("38vAg");
const $6c9c985f2b884d95$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $6c9c985f2b884d95$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $4MPLJ.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $4MPLJ.RECENT_WORK_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $4MPLJ.RECENT_WORK_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $4MPLJ.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $4MPLJ.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $6c9c985f2b884d95$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $38vAg.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("4MPLJ", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $a3f5715d761cac70$export$fc7a65795610cb71);

var $4Cyej = parcelRequire("4Cyej");
const $a3f5715d761cac70$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $a3f5715d761cac70$export$745926731087ebe2 = (0, $4Cyej.default)($a3f5715d761cac70$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});



parcelRegister("7sILx", function(module, exports) {
$parcel$export(module.exports, "default", () => $171a3daa7bf66d8a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $bu9V2 = parcelRequire("bu9V2");
function $171a3daa7bf66d8a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).rovoExtension,
        processEvent: (0, $bu9V2.default)
    });
}

});
parcelRegister("bu9V2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7390a1ea5267814$export$2e2bcd8739ae039);

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $6fENj = parcelRequire("6fENj");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $f7390a1ea5267814$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $f7390a1ea5267814$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $f7390a1ea5267814$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $6fENj.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $6fENj.ROVO_EXTENSION_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $6fENj.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $6fENj.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $6fENj.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f7390a1ea5267814$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($f7390a1ea5267814$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("6fENj", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $54a5b32c8a227278$export$fae437eb1dd9520c);

var $4Cyej = parcelRequire("4Cyej");
const $54a5b32c8a227278$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $54a5b32c8a227278$export$7fcecc25ee38fbef = (0, $4Cyej.default)($54a5b32c8a227278$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});



parcelRegister("55k25", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff618142ac13b77a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $cbp5A = parcelRequire("cbp5A");
function $ff618142ac13b77a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).teamworkGraph,
        processEvent: (0, $cbp5A.processEvent)
    });
}

});
parcelRegister("cbp5A", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $baf7e6b6e2293f02$export$22af68e3614bf024);

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $gXeBj = parcelRequire("gXeBj");

var $9zKtG = parcelRequire("9zKtG");

var $3VX7Y = parcelRequire("3VX7Y");

var $lENOA = parcelRequire("lENOA");

var $bxyiG = parcelRequire("bxyiG");
const $baf7e6b6e2293f02$var$listenerVersion = undefined;
function $baf7e6b6e2293f02$export$22af68e3614bf024(event) {
    var _event$payload$tags;
    const sources = (0, $bxyiG.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $lENOA.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $9zKtG.getExtraAttributes)(event);
    const tags = (_event$payload$tags = event.payload.tags) !== null && _event$payload$tags !== void 0 && _event$payload$tags.length ? Array.from(new Set(event.payload.tags)) : undefined;
    const components = (0, $gXeBj.getComponents)(event);
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        ...tags ? {
            tags: tags
        } : {},
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))({}, extraAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $3VX7Y.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $baf7e6b6e2293f02$var$listenerVersion
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("21BkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $27df1f3e9cb45727$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $asqkb = parcelRequire("asqkb");

var $38vAg = parcelRequire("38vAg");

var $jJFTj = parcelRequire("jJFTj");
function $27df1f3e9cb45727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asqkb.default), {
        ...props,
        channel: (0, $38vAg.FabricChannel).townsquareHome,
        processEvent: (0, $jJFTj.default)
    });
}

});
parcelRegister("jJFTj", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a3f245af0114c6$export$2e2bcd8739ae039);

var $1VqtZ = parcelRequire("1VqtZ");

var $eVfhL = parcelRequire("eVfhL");

var $aDo1D = parcelRequire("aDo1D");

var $cG2at = parcelRequire("cG2at");

var $iD76A = parcelRequire("iD76A");

var $fufbe = parcelRequire("fufbe");

var $bu7M7 = parcelRequire("bu7M7");

var $lj5LR = parcelRequire("lj5LR");
const $95a3f245af0114c6$var$TOWNSQUARE_TAG = 'townsquare';
const $95a3f245af0114c6$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $95a3f245af0114c6$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $95a3f245af0114c6$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $lj5LR.getSources)(event, (0, $cG2at.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(sources) || (0, $aDo1D.DEFAULT_SOURCE);
    const extraAttributes = (0, $fufbe.getExtraAttributes)(event, (0, $cG2at.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $iD76A.getComponents)(event, (0, $cG2at.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $bu7M7.getPackageInfo)(event, (0, $cG2at.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))((0, $bu7M7.getPackageInfo)(event, (0, $cG2at.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $aDo1D.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $95a3f245af0114c6$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($95a3f245af0114c6$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($95a3f245af0114c6$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $aDo1D.UI_EVENT_TYPE:
        case 0, $aDo1D.OPERATIONAL_EVENT_TYPE:
        case 0, $aDo1D.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $aDo1D.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("cG2at", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $0eb978f42bcfef3d$export$aa18ab4fff926c9e);

var $4Cyej = parcelRequire("4Cyej");
const $0eb978f42bcfef3d$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $0eb978f42bcfef3d$export$d283110f5d85c8f2 = (0, $4Cyej.default)($0eb978f42bcfef3d$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});




parcelRegister("2czqN", function(module, exports) {
$parcel$export(module.exports, "setAccountMetaTag", () => $e851f3583fd70ba4$export$3ffe5752aad15e0d);

var $aYMdQ = parcelRequire("aYMdQ");

var $6lbrU = parcelRequire("6lbrU");

var $6LH8a = parcelRequire("6LH8a");
const $e851f3583fd70ba4$export$3ffe5752aad15e0d = (isAtlassianManaged, accountId)=>{
    if (!accountId) return;
    const accountTypeMeta = (0, $6LH8a.getMetaFromHTML)('ajs-account-type');
    const accountIdMeta = (0, $6LH8a.getMetaFromHTML)('ajs-atlassian-account-id');
    if (!(0, $aYMdQ.isNil)(accountTypeMeta) && !(0, $aYMdQ.isNil)(accountIdMeta) && accountIdMeta === accountId) return;
    (0, $6LH8a.setHTMLMeta)('ajs-atlassian-account-id', accountId);
    (0, $6LH8a.setHTMLMeta)('account-id', accountId);
    if (isAtlassianManaged) (0, $6LH8a.setHTMLMeta)('ajs-account-type', 'atlassian');
    else (0, $6LH8a.setHTMLMeta)('ajs-account-type', 'customer');
    (0, $6lbrU.updateUserInfo)(accountId);
};

});

parcelRegister("hN8HB", function(module, exports) {
$parcel$export(module.exports, "CustomDomainsAnalyticsProvider", () => $609de60b6a9af41b$export$8bf41bf02d1555eb);

var $fc4bM = parcelRequire("fc4bM");

var $eENmG = parcelRequire("eENmG");
const $609de60b6a9af41b$export$8bf41bf02d1555eb = ({ children: children, baseUrl: baseUrl })=>{
    const atlassianDomains = [
        'atlassian.net',
        'jira-dev.com',
        'atlassian.com',
        'jira.com',
        'atl-paas.net',
        'trello.com',
        'bitbucket.org'
    ];
    if (atlassianDomains.some((domain)=>baseUrl.toLowerCase().includes(domain))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eENmG.AnalyticsContext), {
        attributes: {
            isCustomDomain: false
        }
    }, children);
    const customDomain = new URL(baseUrl).hostname;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eENmG.AnalyticsContext), {
        attributes: {
            customDomain: customDomain,
            isCustomDomain: true
        }
    }, children);
};

});

parcelRegister("6ilSv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d1327db81a32f7f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $eENmG = parcelRequire("eENmG");
const $2d1327db81a32f7f$var$extractFlags = ()=>Object.entries($hN5YJ).reduce((acc, [key, value])=>{
        if (typeof value !== 'function') return acc;
        return {
            ...acc,
            [key]: value()
        };
    }, {});
const $2d1327db81a32f7f$var$FeatureFlagContext = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eENmG.AnalyticsContext), {
        attributes: $2d1327db81a32f7f$var$extractFlags()
    }, children);
var $2d1327db81a32f7f$export$2e2bcd8739ae039 = $2d1327db81a32f7f$var$FeatureFlagContext;

});

parcelRegister("6wrSQ", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsContext", () => $0629e36afd5b890c$export$156073b6afb2624e);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $grEyy = parcelRequire("grEyy");
const $0629e36afd5b890c$var$selector = (state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    const attributes = (0, $9D9SX.getPortalAnalyticAttributes)(state, portalId);
    return {
        attributes: attributes
    };
};
const $0629e36afd5b890c$export$156073b6afb2624e = (0, $6umft.default)($0629e36afd5b890c$var$selector)((0, $grEyy.default));

});
parcelRegister("grEyy", function(module, exports) {
$parcel$export(module.exports, "default", () => $73b02d29578985bf$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eENmG = parcelRequire("eENmG");
const $73b02d29578985bf$var$PortalContext = ({ children: children, attributes: attributes })=>/*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
        sourceName: "portalUnknown",
        sourceType: (0, $eENmG.ScreenTypes).SCREEN,
        attributes: {
            context: 'Portal',
            ...attributes
        }
    }, children);
var $73b02d29578985bf$export$2e2bcd8739ae039 = $73b02d29578985bf$var$PortalContext;

});


parcelRegister("caiWY", function(module, exports) {
$parcel$export(module.exports, "withCoordinationClient", () => $724835b8dd6c3596$export$eeb046361df75e84);
$parcel$export(module.exports, "default", () => $724835b8dd6c3596$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $6LH8a = parcelRequire("6LH8a");

var $58y5x = parcelRequire("58y5x");

var $7wx9B = parcelRequire("7wx9B");
const $724835b8dd6c3596$export$a91cdb60d3cc20e2 = /*#__PURE__*/ $fc4bM.createContext({
    coordinationClient: undefined
});

const $724835b8dd6c3596$var$CoordinationClientProvider = ({ cloudId: cloudId, children: children })=>{
    const [coordinationClient, setCoordinationClient] = $fc4bM.useState(undefined);
    $fc4bM.useEffect(()=>{
        (0, $58y5x.promiseWithRetries)(()=>(parcelRequire("1JbVQ"))).then((module)=>{
            setCoordinationClient(new module.CoordinationClient(cloudId, '/gateway/api'));
        }).catch((error)=>{
            (0, $7wx9B.reportError)(error);
        });
    }, [
        cloudId
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($724835b8dd6c3596$export$a91cdb60d3cc20e2.Provider, {
        value: {
            coordinationClient: coordinationClient
        }
    }, children);
};
const $724835b8dd6c3596$export$eeb046361df75e84 = (InnerComponent)=>{
    const Component = (props)=>{
        const { coordinationClient: coordinationClient } = $fc4bM.useContext($724835b8dd6c3596$export$a91cdb60d3cc20e2);
        return /*#__PURE__*/ $fc4bM.createElement(InnerComponent, {
            ...props,
            coordinationClient: coordinationClient
        });
    };
    return Component;
};
const $724835b8dd6c3596$var$mapStateToProps = ()=>{
    return {
        cloudId: (0, $6LH8a.getMeta)('tenant-id')
    };
};
var $724835b8dd6c3596$export$2e2bcd8739ae039 = (0, $6umft.default)($724835b8dd6c3596$var$mapStateToProps)($724835b8dd6c3596$var$CoordinationClientProvider);

});
parcelRegister("58y5x", function(module, exports) {
$parcel$export(module.exports, "promiseWithRetries", () => $314d1db37c1024ce$export$e27278bd94558912);
const $314d1db37c1024ce$var$DEFAULT_TIMEOUT_MS = 1000;
const $314d1db37c1024ce$var$DEFAULT_NUMBER_OF_RETRIES = 3;
const $314d1db37c1024ce$var$delay = (timeMs)=>new Promise((resolve)=>setTimeout(resolve, timeMs));
const $314d1db37c1024ce$export$e27278bd94558912 = (promise, config = {})=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { numberOfRetries: numberOfRetries = $314d1db37c1024ce$var$DEFAULT_NUMBER_OF_RETRIES, timeoutMs: timeoutMs = $314d1db37c1024ce$var$DEFAULT_TIMEOUT_MS, error: error = null } = config;
    if (numberOfRetries <= 0) return Promise.reject(error);
    return promise().catch((promiseError)=>$314d1db37c1024ce$var$delay(timeoutMs).then(()=>// Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            $314d1db37c1024ce$export$e27278bd94558912(promise, {
                ...config,
                numberOfRetries: numberOfRetries - 1,
                error: promiseError
            })));
};

});

parcelRegister("1JbVQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3c0Ij"),
    $9dnsd("f4rlg")
]).then(()=>parcelRequire('9TlXA'));

});


parcelRegister("cs1mQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4d393cf9d3da327$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $9QSw4 = parcelRequire("9QSw4");
const $b4d393cf9d3da327$var$selector = (0, $2n2bS.createSelector)((0, $7RWiC.getLocale), (locale)=>({
        locale: locale
    }));
var $b4d393cf9d3da327$export$2e2bcd8739ae039 = (0, $6umft.default)($b4d393cf9d3da327$var$selector)((0, $9QSw4.DeferredWrmResourceProvider));

});
parcelRegister("9QSw4", function(module, exports) {
$parcel$export(module.exports, "DeferredWrmResourceContext", () => $b881dff8cfa5f290$export$266fd8d1fd8c9019);
$parcel$export(module.exports, "DeferredWrmResourceProvider", () => $b881dff8cfa5f290$export$f1f3f896300d60a3);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $8PRsU = parcelRequire("8PRsU");

var $7Q2vg = parcelRequire("7Q2vg");
const $b881dff8cfa5f290$export$266fd8d1fd8c9019 = /*#__PURE__*/ $fc4bM.createContext({
    resourcesLoaded: false,
    setResourcesLoaded: (0, $aYMdQ.noop)
});
const $b881dff8cfa5f290$var$DEFERRED_WRM_CONTEXT = [
    'deferred.customer.portal.wrm'
];
const $b881dff8cfa5f290$var$getDeferredWrmContexts = (0, $8PRsU.default)((locale)=>[
        ...$b881dff8cfa5f290$var$DEFERRED_WRM_CONTEXT,
        `jira.webresources:calendar-${locale}`
    ]);
const $b881dff8cfa5f290$export$f1f3f896300d60a3 = ({ children: children, locale: locale })=>{
    const [resourcesLoaded, setLoaded] = $fc4bM.useState(false);
    const setResourcesLoaded = $fc4bM.useCallback(()=>{
        setLoaded(true);
    }, [
        setLoaded
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($b881dff8cfa5f290$export$266fd8d1fd8c9019.Provider, {
        value: {
            resourcesLoaded: resourcesLoaded,
            setResourcesLoaded: setResourcesLoaded
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7Q2vg.default), {
        onResourcesLoaded: setResourcesLoaded,
        resourceKeys: $b881dff8cfa5f290$var$getDeferredWrmContexts(locale)
    }), children);
};

});
parcelRegister("8PRsU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6267c6f5b5cbc26c$export$2e2bcd8739ae039);
/**
 * Copied from https://github.com/alexreardon/memoize-one/tree/master/src
 *
 *
 * Delete this folder when https://github.com/alexreardon/memoize-one/issues/37 is resolved and we can use the package directly
 * turning on esModuleInterop breaks a whole bunch of other tests, so for now this is the least intrusive workaround to get this utility
 *
 */ function $6267c6f5b5cbc26c$var$areInputsEqual(newInputs, lastInputs) {
    // no checks needed if the inputs length has changed
    if (newInputs.length !== lastInputs.length) return false;
    // Using for loop for speed. It generally performs better than array.every
    // https://github.com/alexreardon/memoize-one/pull/59
    for(let i = 0; i < newInputs.length; i++){
        // using shallow equality check
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $6267c6f5b5cbc26c$export$2e2bcd8739ae039(resultFn, isEqual = $6267c6f5b5cbc26c$var$areInputsEqual) {
    let lastThis;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    // breaking cache when context (this) or arguments change
    function memoized(...newArgs) {
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        // Throwing during an assignment aborts the assignment: https://codepen.io/alexreardon/pen/RYKoaz
        // Doing the lastResult assignment first so that if it throws
        // nothing will be overwritten
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        // @typescript-eslint upgrade to v5.61.0
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

});

parcelRegister("7Q2vg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4a1e18e670aa675$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $aIVqJ = parcelRequire("aIVqJ");

var $4MjGQ = parcelRequire("4MjGQ");

var $c2DGH = parcelRequire("c2DGH");
const $c4a1e18e670aa675$var$createScriptResource = (url)=>Object.assign(document.createElement('script'), {
        type: 'text/javascript',
        charset: 'utf-8',
        async: true,
        src: url
    });
const $c4a1e18e670aa675$var$createCssResource = (url)=>Object.assign(document.createElement('link'), {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });
const $c4a1e18e670aa675$var$createResource = (resourceDescriptor)=>{
    const { resourceType: resourceType, url: url } = resourceDescriptor;
    if (resourceType === 'CSS') return $c4a1e18e670aa675$var$createCssResource(url);
    return $c4a1e18e670aa675$var$createScriptResource(url);
};
const $c4a1e18e670aa675$var$loadResources = (0, $aYMdQ.once)((wrmResources, unparsedData)=>{
    window.WRM = {
        _unparsedData: {
            ...unparsedData
        }
    };
    const resources = wrmResources.map((resource)=>new Promise((resolve)=>{
            resource.onload = ()=>{
                resolve();
            };
            resource.onerror = (error)=>{
                (0, $aIVqJ.trackError)(`deferred.wrm.resource.load.failed`, {}, error.message);
                (0, $4MjGQ.operationalEvent)({
                    action: 'failed',
                    actionSubject: 'loadWrmResources',
                    source: 'unknownSource',
                    attributes: {
                        errorMessage: error.message
                    }
                });
            };
            document.head.appendChild(resource);
        }));
    return Promise.all(resources);
});
const $c4a1e18e670aa675$var$WrmModuleLoader = ({ onResourcesLoaded: onResourcesLoaded, resourceKeys: resourceKeys })=>{
    const asyncWrmRequire = $fc4bM.useCallback(async ()=>{
        try {
            const { unparsedData: unparsedData, resources: resourceDescriptors } = await (0, $c2DGH.fetchWrmResourceDescriptors)(resourceKeys);
            const wrmResources = resourceDescriptors.map((resourceDescriptor)=>$c4a1e18e670aa675$var$createResource(resourceDescriptor));
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $c4a1e18e670aa675$var$loadResources(wrmResources, unparsedData).then(()=>{
                onResourcesLoaded();
            });
        } catch (e) {
            (0, $aIVqJ.trackError)('fetchWrmResourceDescriptors.fetch.failed', {}, e);
            (0, $4MjGQ.operationalEvent)({
                action: 'failed',
                actionSubject: 'fetchWrmResourceDescriptors',
                source: 'unknownSource',
                attributes: {
                    resourceKeys: resourceKeys,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    errorMessage: e.message
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (0, $c2DGH.fetchWrmResourceDescriptors)
    ]);
    $fc4bM.useEffect(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        asyncWrmRequire();
    }, [
        asyncWrmRequire
    ]);
    return null;
};
var $c4a1e18e670aa675$export$2e2bcd8739ae039 = $c4a1e18e670aa675$var$WrmModuleLoader;

});
parcelRegister("c2DGH", function(module, exports) {
$parcel$export(module.exports, "fetchWrmResourceDescriptors", () => $7900d63bf90b0030$export$25121547929106be);

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $7900d63bf90b0030$var$getRequestBody = ({ webResources: webResources = [], contexts: contexts = [], excludedContexts: excludedContexts = [], excludedWebResources: excludedWebResources = [] })=>({
        r: webResources,
        c: contexts,
        xc: excludedContexts,
        xr: excludedWebResources
    });
const $7900d63bf90b0030$export$25121547929106be = (resources)=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/webResources/1.0/resources`;
    const body = $7900d63bf90b0030$var$getRequestBody({
        contexts: resources
    });
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise().catch((e)=>Promise.reject(e));
};

});




parcelRegister("54cCj", function(module, exports) {
$parcel$export(module.exports, "adaptAnalyticsWebClientForXpc", () => (parcelRequire("br4PW")).adaptAnalyticsWebClientForXpc);
$parcel$export(module.exports, "HelpCenterXpcNavigationObserver", () => (parcelRequire("br4PW")).HelpCenterXpcNavigationObserver);

var $br4PW = parcelRequire("br4PW");

});
parcelRegister("br4PW", function(module, exports) {
$parcel$export(module.exports, "adaptAnalyticsWebClientForXpc", () => $25ae3c1e6311a958$export$82cba7d1b57233b6);
$parcel$export(module.exports, "HelpCenterXpcNavigationObserver", () => $25ae3c1e6311a958$export$c8250fab5cd98a28);

var $fc4bM = parcelRequire("fc4bM");

var $8vLFW = parcelRequire("8vLFW");

var $2U2bt = parcelRequire("2U2bt");

var $iTErH = parcelRequire("iTErH");

var $7n4eZ = parcelRequire("7n4eZ");

var $hMeYk = parcelRequire("hMeYk");

var $j5N6B = parcelRequire("j5N6B");

var $k2M4v = parcelRequire("k2M4v");
const $25ae3c1e6311a958$export$82cba7d1b57233b6 = (analyticsClient)=>({
        sendTrackEvent: (event)=>{
            analyticsClient.sendTrackEvent(event);
            return Promise.resolve();
        }
    });
const $25ae3c1e6311a958$var$XPC_STREAM3_OBSERVATION_GATE = 'studio_xpc_stream3_observation';
const $25ae3c1e6311a958$var$HELP_CENTER_XPC_REGISTRY = (0, $2U2bt.createXpcDefaultDestinationRegistry)();
const $25ae3c1e6311a958$var$HELP_CENTER_XPC_SOURCE = {
    product: (0, $iTErH.XpcDestinationResolver).createProductId('jira'),
    subProduct: (0, $iTErH.XpcDestinationResolver).createSubProductId('help-center')
};
const $25ae3c1e6311a958$var$HELP_CENTER_XPC_SURFACES = {
    native: (0, $hMeYk.XpcNavigationObservation).createSurface('help-center-root')
};
const $25ae3c1e6311a958$var$isHelpCenterXpcStream3ObservationEnabled = ()=>(0, $k2M4v.default).checkGate($25ae3c1e6311a958$var$XPC_STREAM3_OBSERVATION_GATE);
const $25ae3c1e6311a958$var$getHelpCenterInitialArrivalUrl = (root)=>{
    var _root$defaultView, _root$defaultView$get;
    const initialNavigationUrl = root === null || root === void 0 || (_root$defaultView = root.defaultView) === null || _root$defaultView === void 0 || (_root$defaultView = _root$defaultView.performance) === null || _root$defaultView === void 0 || (_root$defaultView$get = _root$defaultView.getEntriesByType) === null || _root$defaultView$get === void 0 || (_root$defaultView$get = _root$defaultView$get.call(_root$defaultView, 'navigation')[0]) === null || _root$defaultView$get === void 0 ? void 0 : _root$defaultView$get.name;
    return initialNavigationUrl ?? (root === null || root === void 0 ? void 0 : root.location.href);
};
const $25ae3c1e6311a958$export$c8250fab5cd98a28 = ({ analyticsClient: analyticsClient, children: children, initialArrivalUrl: initialArrivalUrl, root: root = (0, $j5N6B.getDocument)() })=>{
    const [resolvedInitialArrivalUrl] = (0, $fc4bM.useState)(()=>initialArrivalUrl ?? $25ae3c1e6311a958$var$getHelpCenterInitialArrivalUrl(root));
    const reporter = (0, $fc4bM.useMemo)(()=>(0, $8vLFW.createXpcAwcNavigationReporter)(analyticsClient), [
        analyticsClient
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $7n4eZ.XpcNavigationProvider), {
        baseUrl: (root === null || root === void 0 ? void 0 : root.baseURI) ?? 'https://support.atlassian.com',
        initialArrivalUrl: resolvedInitialArrivalUrl,
        isEnabled: $25ae3c1e6311a958$var$isHelpCenterXpcStream3ObservationEnabled,
        registry: $25ae3c1e6311a958$var$HELP_CENTER_XPC_REGISTRY,
        reporter: reporter,
        root: root,
        source: $25ae3c1e6311a958$var$HELP_CENTER_XPC_SOURCE,
        surfaces: $25ae3c1e6311a958$var$HELP_CENTER_XPC_SURFACES
    }, children);
};

});
parcelRegister("8vLFW", function(module, exports) {
$parcel$export(module.exports, "createXpcAwcNavigationReporter", () => $8cb7e6c65e7414b4$export$bb0601d3c56100cf);
const $8cb7e6c65e7414b4$var$toTrackAttributes = (observation)=>{
    const destination = observation.destination.outcome === 'same' || observation.destination.outcome === 'cross' ? {
        destinationProduct: observation.destination.destinationProduct,
        ...observation.destination.destinationSubProduct ? {
            destinationSubProduct: observation.destination.destinationSubProduct
        } : {},
        destinationMatcherId: observation.destination.matcherId,
        ...observation.destination.routeFamily ? {
            destinationRouteFamily: observation.destination.routeFamily
        } : {}
    } : {};
    return {
        schemaVersion: observation.schemaVersion,
        taxonomyVersion: observation.taxonomyVersion,
        sourceProduct: observation.sourceProduct,
        ...observation.sourceSubProduct ? {
            sourceSubProduct: observation.sourceSubProduct
        } : {},
        destinationOutcome: observation.destination.outcome,
        destinationReason: observation.destination.reason,
        destinationClassificationMethod: observation.destination.classificationMethod,
        destinationConfidence: observation.destination.confidence,
        ...destination,
        handoffOutcome: observation.handoffOutcome,
        surface: observation.surface,
        captureMethod: observation.captureMethod,
        navigationMechanism: observation.navigationMechanism,
        instrumentationClass: observation.instrumentationClass,
        ...observation.xpisVersion ? {
            xpisVersion: observation.xpisVersion
        } : {}
    };
};
const $8cb7e6c65e7414b4$var$toArrivalTrackAttributes = (observation)=>({
        schemaVersion: observation.schemaVersion,
        taxonomyVersion: observation.taxonomyVersion,
        destinationProduct: observation.destinationProduct,
        ...observation.destinationSubProduct ? {
            destinationSubProduct: observation.destinationSubProduct
        } : {},
        ...observation.destinationRouteFamily ? {
            destinationRouteFamily: observation.destinationRouteFamily
        } : {},
        arrivalMethod: observation.arrivalMethod,
        ...observation.xpisVersion ? {
            xpisVersion: observation.xpisVersion
        } : {}
    });
const $8cb7e6c65e7414b4$export$bb0601d3c56100cf = (analyticsClient)=>({
        reportArrival: (observation)=>{
            try {
                analyticsClient.sendTrackEvent({
                    action: 'arrivalObserved',
                    actionSubject: 'xpcNavigation',
                    attributes: $8cb7e6c65e7414b4$var$toArrivalTrackAttributes(observation),
                    source: observation.destinationProduct
                }).catch(()=>undefined);
            } catch  {
            // Observation must never affect product loading.
            }
        },
        reportDeparture: (observation)=>{
            try {
                analyticsClient.sendTrackEvent({
                    action: 'departureObserved',
                    actionSubject: 'xpcNavigation',
                    attributes: $8cb7e6c65e7414b4$var$toTrackAttributes(observation),
                    source: observation.sourceProduct
                }).catch(()=>undefined);
            } catch  {
            // Observation must never affect navigation.
            }
        }
    });

});

parcelRegister("2U2bt", function(module, exports) {
$parcel$export(module.exports, "createXpcDefaultDestinationRegistry", () => $9214b630bd432b5a$export$d728da229be977ec);

var $iTErH = parcelRequire("iTErH");
const $9214b630bd432b5a$var$product = {
    admin: (0, $iTErH.XpcDestinationResolver).createProductId('admin'),
    confluence: (0, $iTErH.XpcDestinationResolver).createProductId('confluence'),
    home: (0, $iTErH.XpcDestinationResolver).createProductId('home'),
    jira: (0, $iTErH.XpcDestinationResolver).createProductId('jira'),
    studio: (0, $iTErH.XpcDestinationResolver).createProductId('studio')
};
const $9214b630bd432b5a$var$routeFamily = {
    admin: (0, $iTErH.XpcDestinationResolver).createRouteFamily('admin'),
    confluenceContent: (0, $iTErH.XpcDestinationResolver).createRouteFamily('content-page'),
    home: (0, $iTErH.XpcDestinationResolver).createRouteFamily('home'),
    jiraIssue: (0, $iTErH.XpcDestinationResolver).createRouteFamily('issue-view'),
    jiraProduct: (0, $iTErH.XpcDestinationResolver).createRouteFamily('jira-product'),
    studio: (0, $iTErH.XpcDestinationResolver).createRouteFamily('studio')
};
const $9214b630bd432b5a$export$d728da229be977ec = ({ localhostProduct: localhostProduct } = {})=>({
        allowedHttpHosts: localhostProduct ? [
            'localhost'
        ] : [],
        atlassianHostSuffixes: [
            'atlassian.com',
            'atlassian.net',
            'atl-paas.net',
            'jira-dev.com'
        ],
        rules: [
            ...localhostProduct ? [
                {
                    host: 'localhost',
                    id: (0, $iTErH.XpcDestinationResolver).createMatcherId('local-product'),
                    precedence: 200,
                    product: localhostProduct,
                    routeFamily: (0, $iTErH.XpcDestinationResolver).createRouteFamily('local-product')
                }
            ] : [],
            {
                host: 'studio.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('studio-production'),
                precedence: 200,
                product: $9214b630bd432b5a$var$product.studio,
                routeFamily: $9214b630bd432b5a$var$routeFamily.studio
            },
            {
                host: 'studio-next.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('studio-next-production'),
                precedence: 200,
                product: $9214b630bd432b5a$var$product.studio,
                routeFamily: $9214b630bd432b5a$var$routeFamily.studio
            },
            {
                host: 'studio.stg.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('studio-staging'),
                precedence: 200,
                product: $9214b630bd432b5a$var$product.studio,
                routeFamily: $9214b630bd432b5a$var$routeFamily.studio
            },
            {
                host: 'atlassian.net',
                hostMatch: 'suffix',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('confluence-wiki-route'),
                pathPrefix: '/wiki',
                precedence: 100,
                product: $9214b630bd432b5a$var$product.confluence,
                routeFamily: $9214b630bd432b5a$var$routeFamily.confluenceContent
            },
            {
                host: 'atlassian.net',
                hostMatch: 'suffix',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('jira-issue-route'),
                pathPrefix: '/browse',
                precedence: 100,
                product: $9214b630bd432b5a$var$product.jira,
                routeFamily: $9214b630bd432b5a$var$routeFamily.jiraIssue
            },
            {
                host: 'atlassian.net',
                hostMatch: 'suffix',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('jira-product-route'),
                pathPrefix: '/jira',
                precedence: 100,
                product: $9214b630bd432b5a$var$product.jira,
                routeFamily: $9214b630bd432b5a$var$routeFamily.jiraProduct
            },
            {
                host: 'jira-dev.com',
                hostMatch: 'suffix',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('confluence-wiki-route-staging'),
                pathPrefix: '/wiki',
                precedence: 100,
                product: $9214b630bd432b5a$var$product.confluence,
                routeFamily: $9214b630bd432b5a$var$routeFamily.confluenceContent
            },
            {
                host: 'jira-dev.com',
                hostMatch: 'suffix',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('jira-issue-route-staging'),
                pathPrefix: '/browse',
                precedence: 100,
                product: $9214b630bd432b5a$var$product.jira,
                routeFamily: $9214b630bd432b5a$var$routeFamily.jiraIssue
            },
            {
                host: 'jira-dev.com',
                hostMatch: 'suffix',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('jira-product-route-staging'),
                pathPrefix: '/jira',
                precedence: 100,
                product: $9214b630bd432b5a$var$product.jira,
                routeFamily: $9214b630bd432b5a$var$routeFamily.jiraProduct
            },
            {
                host: 'home.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('atlassian-home-production'),
                precedence: 100,
                product: $9214b630bd432b5a$var$product.home,
                routeFamily: $9214b630bd432b5a$var$routeFamily.home
            },
            {
                host: 'home.stg.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('atlassian-home-staging'),
                precedence: 100,
                product: $9214b630bd432b5a$var$product.home,
                routeFamily: $9214b630bd432b5a$var$routeFamily.home
            },
            {
                host: 'admin.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('atlassian-admin-production'),
                precedence: 100,
                product: $9214b630bd432b5a$var$product.admin,
                routeFamily: $9214b630bd432b5a$var$routeFamily.admin
            },
            {
                host: 'admin.stg.atlassian.com',
                id: (0, $iTErH.XpcDestinationResolver).createMatcherId('atlassian-admin-staging'),
                precedence: 100,
                product: $9214b630bd432b5a$var$product.admin,
                routeFamily: $9214b630bd432b5a$var$routeFamily.admin
            }
        ],
        taxonomyVersion: 2
    });

});
parcelRegister("iTErH", function(module, exports) {
$parcel$export(module.exports, "XpcDestinationResolver", () => $a7de2db292d15a82$export$7077f6a19b6f2829);
const $a7de2db292d15a82$var$CONTROLLED_VALUE_PATTERN = /^[a-z][a-z0-9-]*$/;
const $a7de2db292d15a82$var$createControlledValue = (value, kind)=>{
    if (!$a7de2db292d15a82$var$CONTROLLED_VALUE_PATTERN.test(value)) throw new Error(`Invalid controlled XPC ${kind} value`);
    return value;
};
const $a7de2db292d15a82$var$createXpcProductId = (value)=>$a7de2db292d15a82$var$createControlledValue(value, 'product');
const $a7de2db292d15a82$var$createXpcSubProductId = (value)=>$a7de2db292d15a82$var$createControlledValue(value, 'subProduct');
const $a7de2db292d15a82$var$createXpcRouteFamily = (value)=>$a7de2db292d15a82$var$createControlledValue(value, 'routeFamily');
const $a7de2db292d15a82$var$createXpcMatcherId = (value)=>$a7de2db292d15a82$var$createControlledValue(value, 'matcher');
const $a7de2db292d15a82$var$normalizeHost = (host)=>host.toLowerCase().replace(/\.$/, '');
const $a7de2db292d15a82$var$matchesHost = (candidate, rule)=>{
    const ruleHost = $a7de2db292d15a82$var$normalizeHost(rule.host);
    if (rule.hostMatch !== 'suffix') return candidate === ruleHost;
    return candidate === ruleHost || candidate.endsWith(`.${ruleHost}`);
};
const $a7de2db292d15a82$var$matchesPath = (pathname, pathPrefix)=>{
    if (!pathPrefix) return true;
    return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
};
const $a7de2db292d15a82$var$matchesSuffix = (host, suffix)=>{
    const normalizedSuffix = $a7de2db292d15a82$var$normalizeHost(suffix);
    return host === normalizedSuffix || host.endsWith(`.${normalizedSuffix}`);
};
const $a7de2db292d15a82$var$excluded = (registry, reason)=>({
        outcome: 'excluded',
        classificationMethod: 'sharedUrlClassifier',
        confidence: 'none',
        reason: reason,
        taxonomyVersion: registry.taxonomyVersion
    });
const $a7de2db292d15a82$var$resolveXpcDestination = ({ baseUrl: baseUrl, registry: registry, source: source, url: url })=>{
    var _registry$allowedHttp, _matchingRules$;
    let parsedUrl;
    try {
        parsedUrl = new URL(url, baseUrl);
    } catch  {
        return $a7de2db292d15a82$var$excluded(registry, 'invalidUrl');
    }
    const host = $a7de2db292d15a82$var$normalizeHost(parsedUrl.hostname);
    const allowedHttpHosts = ((_registry$allowedHttp = registry.allowedHttpHosts) === null || _registry$allowedHttp === void 0 ? void 0 : _registry$allowedHttp.map($a7de2db292d15a82$var$normalizeHost)) ?? [];
    const isAllowedProtocol = parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:' && allowedHttpHosts.includes(host);
    if (!isAllowedProtocol) return $a7de2db292d15a82$var$excluded(registry, 'unsupportedScheme');
    const matchingRules = registry.rules.filter((rule)=>$a7de2db292d15a82$var$matchesHost(host, rule) && $a7de2db292d15a82$var$matchesPath(parsedUrl.pathname, rule.pathPrefix)).sort((left, right)=>right.precedence - left.precedence);
    const highestPrecedence = (_matchingRules$ = matchingRules[0]) === null || _matchingRules$ === void 0 ? void 0 : _matchingRules$.precedence;
    const strongestMatches = matchingRules.filter((rule)=>rule.precedence === highestPrecedence);
    if (strongestMatches.length > 1) {
        const identities = new Set(strongestMatches.map((rule)=>`${rule.product}:${rule.subProduct ?? ''}:${rule.routeFamily ?? ''}`));
        if (identities.size > 1) return {
            outcome: 'unknown',
            classificationMethod: 'sharedUrlClassifier',
            confidence: 'none',
            reason: 'ambiguousSharedHost',
            taxonomyVersion: registry.taxonomyVersion
        };
    }
    const match = strongestMatches[0];
    if (match) {
        const isSameProduct = match.product === source.product;
        const knownDestination = {
            destinationProduct: match.product,
            ...match.subProduct ? {
                destinationSubProduct: match.subProduct
            } : {},
            ...match.routeFamily ? {
                routeFamily: match.routeFamily
            } : {},
            classificationMethod: 'sharedUrlClassifier',
            confidence: 'exact',
            matcherId: match.id,
            taxonomyVersion: registry.taxonomyVersion
        };
        if (isSameProduct) return {
            ...knownDestination,
            outcome: 'same',
            reason: 'sameKnownProduct'
        };
        return {
            ...knownDestination,
            outcome: 'cross',
            reason: 'differentKnownProduct'
        };
    }
    if (registry.atlassianHostSuffixes.some((suffix)=>$a7de2db292d15a82$var$matchesSuffix(host, suffix))) return {
        outcome: 'unknown',
        classificationMethod: 'sharedUrlClassifier',
        confidence: 'none',
        reason: 'recognizedHostUnknownRoute',
        taxonomyVersion: registry.taxonomyVersion
    };
    return $a7de2db292d15a82$var$excluded(registry, 'thirdParty');
};
class $a7de2db292d15a82$export$7077f6a19b6f2829 {
    static #_ = this.createMatcherId = $a7de2db292d15a82$var$createXpcMatcherId;
    static #_2 = this.createProductId = $a7de2db292d15a82$var$createXpcProductId;
    static #_3 = this.createRouteFamily = $a7de2db292d15a82$var$createXpcRouteFamily;
    static #_4 = this.createSubProductId = $a7de2db292d15a82$var$createXpcSubProductId;
    static #_5 = this.resolve = $a7de2db292d15a82$var$resolveXpcDestination;
}

});


parcelRegister("7n4eZ", function(module, exports) {
$parcel$export(module.exports, "XpcNavigationProvider", () => $cf496850ede9b6af$export$a020cce2cde1621f);

var $fc4bM = parcelRequire("fc4bM");

var $29IuY = parcelRequire("29IuY");

var $hAVUr = parcelRequire("hAVUr");

var $iTErH = parcelRequire("iTErH");

var $gRXKL = parcelRequire("gRXKL");

var $ktD8W = parcelRequire("ktD8W");

var $hMeYk = parcelRequire("hMeYk");
const $cf496850ede9b6af$export$a020cce2cde1621f = ({ baseUrl: baseUrl, children: children, initialArrivalUrl: initialArrivalUrl, isEnabled: isEnabled, parseCompatibleXpis: parseCompatibleXpis = (0, $hMeYk.XpcNavigationObservation).parseCompatibleXpis, registry: registry, reporter: reporter, root: root, source: source, surfaces: surfaces })=>{
    const coordinator = (0, $fc4bM.useMemo)(()=>new (0, $29IuY.XpcActivationCoordinator)(), []);
    const arrivalReported = (0, $fc4bM.useRef)(false);
    const context = (0, $fc4bM.useMemo)(()=>({
            baseUrl: baseUrl,
            coordinator: coordinator,
            isEnabled: isEnabled,
            parseCompatibleXpis: parseCompatibleXpis,
            registry: registry,
            reporter: reporter,
            source: source,
            surfaces: surfaces
        }), [
        baseUrl,
        coordinator,
        isEnabled,
        parseCompatibleXpis,
        registry,
        reporter,
        source,
        surfaces
    ]);
    const nativeCapture = (0, $fc4bM.useMemo)(()=>{
        if (!root) return;
        return new (0, $gRXKL.XpcNativeDepartureCapture)({
            baseUrl: baseUrl,
            coordinator: coordinator,
            isEnabled: isEnabled,
            parseCompatibleXpis: parseCompatibleXpis,
            reporter: reporter,
            resolveDestination: (url)=>(0, $iTErH.XpcDestinationResolver).resolve({
                    baseUrl: baseUrl,
                    registry: registry,
                    source: source,
                    url: url
                }),
            root: root,
            source: source,
            surface: surfaces.native
        });
    }, [
        baseUrl,
        coordinator,
        isEnabled,
        parseCompatibleXpis,
        registry,
        reporter,
        root,
        source,
        surfaces.native
    ]);
    (0, $fc4bM.useEffect)(()=>{
        nativeCapture === null || nativeCapture === void 0 || nativeCapture.start();
        return ()=>nativeCapture === null || nativeCapture === void 0 ? void 0 : nativeCapture.stop();
    }, [
        nativeCapture
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!initialArrivalUrl || arrivalReported.current) return;
        arrivalReported.current = true;
        (0, $hAVUr.captureXpcArrival)({
            arrivalMethod: 'frontendInitialLoad',
            baseUrl: baseUrl,
            destinationProduct: source.product,
            destinationSubProduct: source.subProduct,
            isEnabled: isEnabled,
            parseCompatibleXpis: parseCompatibleXpis,
            reporter: reporter,
            taxonomyVersion: registry.taxonomyVersion,
            url: initialArrivalUrl
        });
    }, [
        baseUrl,
        initialArrivalUrl,
        isEnabled,
        parseCompatibleXpis,
        registry.taxonomyVersion,
        reporter,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ktD8W.XpcNavigationContext).Provider, {
        value: context
    }, children);
};

});
parcelRegister("29IuY", function(module, exports) {
$parcel$export(module.exports, "XpcActivationCoordinator", () => $938ad3b49dc2f74d$export$6852b286e9c6edc4);
class $938ad3b49dc2f74d$export$6852b286e9c6edc4 {
    beginNativeCandidate(event) {
        const existingCandidate = this.nativeCandidates.get(event);
        if (existingCandidate) return existingCandidate;
        const token = this.beginOwnedHandoff();
        this.nativeCandidates.set(event, token);
        return token;
    }
    getNativeCandidate(event) {
        return this.nativeCandidates.get(event);
    }
    claimNativeCandidate(event) {
        const token = this.nativeCandidates.get(event);
        if (!token || this.activationStates.get(token) !== 'pending') return undefined;
        this.activationStates.set(token, 'claimed');
        return token;
    }
    beginOwnedHandoff() {
        const token = {};
        this.activationStates.set(token, 'pending');
        return token;
    }
    completeOnce(token, complete) {
        const state = this.activationStates.get(token);
        if (state === 'completed' || state === 'cancelled' || state === undefined) return false;
        this.activationStates.set(token, 'completed');
        complete();
        return true;
    }
    cancel(token) {
        const state = this.activationStates.get(token);
        if (state === 'completed' || state === 'cancelled' || state === undefined) return false;
        this.activationStates.set(token, 'cancelled');
        return true;
    }
    isPending(token) {
        const state = this.activationStates.get(token);
        return state === 'pending' || state === 'claimed';
    }
    isNativeFallbackPending(token) {
        return this.activationStates.get(token) === 'pending';
    }
    constructor(){
        this.activationStates = new WeakMap();
        this.nativeCandidates = new WeakMap();
    }
}

});

parcelRegister("hAVUr", function(module, exports) {
$parcel$export(module.exports, "captureXpcArrival", () => $1f160bbbeb27bae9$export$d16dfaf6040075f3);

var $hMeYk = parcelRequire("hMeYk");
const $1f160bbbeb27bae9$export$d16dfaf6040075f3 = ({ arrivalMethod: arrivalMethod, baseUrl: baseUrl, destinationProduct: destinationProduct, destinationRouteFamily: destinationRouteFamily, destinationSubProduct: destinationSubProduct, isEnabled: isEnabled, parseCompatibleXpis: parseCompatibleXpis, reporter: reporter, taxonomyVersion: taxonomyVersion, url: url })=>{
    if ((isEnabled === null || isEnabled === void 0 ? void 0 : isEnabled()) === false || !reporter.reportArrival) return;
    try {
        const xpis = (0, $hMeYk.XpcNavigationObservation).inspectXpis({
            baseUrl: baseUrl,
            parseCompatibleValue: parseCompatibleXpis,
            url: url
        });
        if (xpis.kind !== 'present' && xpis.kind !== 'compatible') return;
        reporter.reportArrival((0, $hMeYk.XpcNavigationObservation).createArrival({
            arrivalMethod: arrivalMethod,
            destinationProduct: destinationProduct,
            destinationRouteFamily: destinationRouteFamily,
            destinationSubProduct: destinationSubProduct,
            taxonomyVersion: taxonomyVersion,
            xpis: xpis
        }));
    } catch  {
    // Observation must never affect product loading.
    }
};

});
parcelRegister("hMeYk", function(module, exports) {
$parcel$export(module.exports, "XpcNavigationObservation", () => $bc272ed024286c59$export$68c4acb8a5fc660e);
const $bc272ed024286c59$var$CONTROLLED_SURFACE_PATTERN = /^[a-z][a-z0-9-]*$/;
const $bc272ed024286c59$var$COMPATIBLE_XPIS_FIELD_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/;
const $bc272ed024286c59$var$INTERACTION_SESSION_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;
const $bc272ed024286c59$var$MAX_CONTROLLED_SURFACE_LENGTH = 64;
const $bc272ed024286c59$var$createXpcSurface = (value)=>{
    if (value.length > $bc272ed024286c59$var$MAX_CONTROLLED_SURFACE_LENGTH || !$bc272ed024286c59$var$CONTROLLED_SURFACE_PATTERN.test(value)) throw new Error('Invalid controlled XPC surface value');
    return value;
};
const $bc272ed024286c59$var$inspectXpis = ({ baseUrl: baseUrl, parseCompatibleValue: parseCompatibleValue, url: url })=>{
    let parsedUrl;
    try {
        parsedUrl = new URL(url, baseUrl);
    } catch  {
        return {
            kind: 'unreadable'
        };
    }
    const values = parsedUrl.searchParams.getAll('xpis');
    if (values.length === 0) return {
        kind: 'absent'
    };
    if (values.length !== 1 || !parseCompatibleValue) return {
        kind: 'present',
        occurrenceCount: values.length
    };
    const compatibleValue = parseCompatibleValue(values[0]);
    if (!compatibleValue || !$bc272ed024286c59$var$INTERACTION_SESSION_ID_PATTERN.test(compatibleValue.interactionSessionId) || !Number.isSafeInteger(compatibleValue.version) || compatibleValue.version < 1) return {
        kind: 'present',
        occurrenceCount: 1
    };
    return {
        kind: 'compatible',
        occurrenceCount: 1,
        interactionSessionId: compatibleValue.interactionSessionId,
        version: compatibleValue.version
    };
};
const $bc272ed024286c59$var$getInstrumentationClass = ({ provenance: provenance, xpis: xpis })=>{
    if (provenance) return provenance;
    return xpis.kind === 'absent' ? 'observedOnly' : 'xpisPresent';
};
const $bc272ed024286c59$var$parseCompatibleXpis = (encodedValue)=>{
    try {
        const value = JSON.parse(globalThis.atob(encodedValue));
        if (!value || typeof value !== 'object') return null;
        const { bridge: bridge, id: id, source: source, version: version = 1 } = value;
        if (typeof bridge !== 'string' || !$bc272ed024286c59$var$COMPATIBLE_XPIS_FIELD_PATTERN.test(bridge) || typeof id !== 'string' || typeof source !== 'string' || !$bc272ed024286c59$var$COMPATIBLE_XPIS_FIELD_PATTERN.test(source) || version !== 1) return null;
        return {
            interactionSessionId: id,
            version: version
        };
    } catch  {
        return null;
    }
};
const $bc272ed024286c59$var$copyDestination = (destination)=>{
    if (destination.outcome === 'same' || destination.outcome === 'cross') {
        const knownDestination = {
            classificationMethod: destination.classificationMethod,
            confidence: destination.confidence,
            destinationProduct: destination.destinationProduct,
            ...destination.destinationSubProduct ? {
                destinationSubProduct: destination.destinationSubProduct
            } : {},
            matcherId: destination.matcherId,
            ...destination.routeFamily ? {
                routeFamily: destination.routeFamily
            } : {},
            taxonomyVersion: destination.taxonomyVersion
        };
        if (destination.outcome === 'same') return {
            ...knownDestination,
            outcome: destination.outcome,
            reason: destination.reason
        };
        return {
            ...knownDestination,
            outcome: destination.outcome,
            reason: destination.reason
        };
    }
    if (destination.outcome === 'unknown') return {
        classificationMethod: destination.classificationMethod,
        confidence: destination.confidence,
        outcome: destination.outcome,
        reason: destination.reason,
        taxonomyVersion: destination.taxonomyVersion
    };
    return {
        classificationMethod: destination.classificationMethod,
        confidence: destination.confidence,
        outcome: destination.outcome,
        reason: destination.reason,
        taxonomyVersion: destination.taxonomyVersion
    };
};
const $bc272ed024286c59$var$createXpcDepartureObservation = ({ captureMethod: captureMethod, destination: destination, handoffOutcome: handoffOutcome, navigationMechanism: navigationMechanism, provenance: provenance, source: source, surface: surface, xpis: xpis })=>{
    const compatibleXpis = xpis.kind === 'compatible' ? xpis : undefined;
    return {
        schemaVersion: 1,
        taxonomyVersion: destination.taxonomyVersion,
        type: 'xpcDepartureObserved',
        sourceProduct: source.product,
        ...source.subProduct ? {
            sourceSubProduct: source.subProduct
        } : {},
        destination: $bc272ed024286c59$var$copyDestination(destination),
        handoffOutcome: handoffOutcome,
        surface: surface,
        captureMethod: captureMethod,
        navigationMechanism: navigationMechanism,
        instrumentationClass: $bc272ed024286c59$var$getInstrumentationClass({
            provenance: provenance,
            xpis: xpis
        }),
        ...compatibleXpis ? {
            interactionSessionId: compatibleXpis.interactionSessionId,
            xpisVersion: compatibleXpis.version
        } : {}
    };
};
const $bc272ed024286c59$var$createXpcArrivalObservation = ({ arrivalMethod: arrivalMethod, destinationProduct: destinationProduct, destinationRouteFamily: destinationRouteFamily, destinationSubProduct: destinationSubProduct, taxonomyVersion: taxonomyVersion, xpis: xpis })=>{
    const compatibleXpis = xpis.kind === 'compatible' ? xpis : undefined;
    return {
        schemaVersion: 1,
        taxonomyVersion: taxonomyVersion,
        type: 'xpcArrivalObserved',
        destinationProduct: destinationProduct,
        ...destinationSubProduct ? {
            destinationSubProduct: destinationSubProduct
        } : {},
        ...destinationRouteFamily ? {
            destinationRouteFamily: destinationRouteFamily
        } : {},
        arrivalMethod: arrivalMethod,
        ...compatibleXpis ? {
            interactionSessionId: compatibleXpis.interactionSessionId,
            xpisVersion: compatibleXpis.version
        } : {}
    };
};
class $bc272ed024286c59$export$68c4acb8a5fc660e {
    static #_ = this.createArrival = $bc272ed024286c59$var$createXpcArrivalObservation;
    static #_2 = this.createDeparture = $bc272ed024286c59$var$createXpcDepartureObservation;
    static #_3 = this.createSurface = $bc272ed024286c59$var$createXpcSurface;
    static #_4 = this.inspectXpis = $bc272ed024286c59$var$inspectXpis;
    static #_5 = this.parseCompatibleXpis = $bc272ed024286c59$var$parseCompatibleXpis;
    static #_6 = this.noopReporter = {
        reportDeparture: ()=>{}
    };
}

});


parcelRegister("gRXKL", function(module, exports) {
$parcel$export(module.exports, "XpcNativeDepartureCapture", () => $4461e76f2a26ab86$export$874086ed780295db);

var $29IuY = parcelRequire("29IuY");

var $hMeYk = parcelRequire("hMeYk");
const $4461e76f2a26ab86$var$defaultScheduleAfterDispatch = (callback)=>{
    const timeout = setTimeout(callback, 0);
    return ()=>clearTimeout(timeout);
};
const $4461e76f2a26ab86$var$findAnchor = (event)=>{
    for (const target of event.composedPath()){
        if (target instanceof HTMLAnchorElement) return target;
    }
    return undefined;
};
const $4461e76f2a26ab86$var$isQualifyingActivation = (event, anchor)=>(event.button === 0 || event.button === 1) && Boolean(anchor.href) && !anchor.hasAttribute('download');
class $4461e76f2a26ab86$export$874086ed780295db {
    constructor(options){
        this.options = options;
        this.cancelScheduled = new Set();
        this.pendingActivations = new Set();
        this.started = false;
        this.onActivation = (event)=>{
            var _this$options$isEnabl2, _this$options2;
            if (((_this$options$isEnabl2 = (_this$options2 = this.options).isEnabled) === null || _this$options$isEnabl2 === void 0 ? void 0 : _this$options$isEnabl2.call(_this$options2)) === false) return;
            const anchor = $4461e76f2a26ab86$var$findAnchor(event);
            if (!anchor || !$4461e76f2a26ab86$var$isQualifyingActivation(event, anchor)) return;
            const activation = {
                anchor: anchor,
                event: event,
                token: this.coordinator.beginNativeCandidate(event)
            };
            this.pendingActivations.add(activation);
            const schedule = this.options.scheduleAfterDispatch ?? $4461e76f2a26ab86$var$defaultScheduleAfterDispatch;
            let cancel = ()=>{};
            cancel = schedule(()=>{
                this.cancelScheduled.delete(cancel);
                this.finalize(activation);
            });
            if (this.pendingActivations.has(activation)) this.cancelScheduled.add(cancel);
        };
        this.flushPending = ()=>{
            for (const activation of [
                ...this.pendingActivations
            ])this.finalize(activation);
        };
        this.coordinator = options.coordinator ?? new (0, $29IuY.XpcActivationCoordinator)();
    }
    start() {
        var _this$options$isEnabl, _this$options, _this$options$root$de;
        if (this.started || ((_this$options$isEnabl = (_this$options = this.options).isEnabled) === null || _this$options$isEnabl === void 0 ? void 0 : _this$options$isEnabl.call(_this$options)) === false) return;
        this.started = true;
        this.options.root.addEventListener('click', this.onActivation, true);
        this.options.root.addEventListener('auxclick', this.onActivation, true);
        (_this$options$root$de = this.options.root.defaultView) === null || _this$options$root$de === void 0 || _this$options$root$de.addEventListener('pagehide', this.flushPending);
    }
    stop() {
        var _this$options$root$de2;
        if (!this.started) return;
        this.started = false;
        this.options.root.removeEventListener('click', this.onActivation, true);
        this.options.root.removeEventListener('auxclick', this.onActivation, true);
        (_this$options$root$de2 = this.options.root.defaultView) === null || _this$options$root$de2 === void 0 || _this$options$root$de2.removeEventListener('pagehide', this.flushPending);
        for (const cancel of this.cancelScheduled)cancel();
        this.cancelScheduled.clear();
        for (const activation of this.pendingActivations)this.coordinator.cancel(activation.token);
        this.pendingActivations.clear();
    }
    finalize(activation) {
        var _this$options$isEnabl3, _this$options3;
        if (!this.pendingActivations.delete(activation)) return;
        if (((_this$options$isEnabl3 = (_this$options3 = this.options).isEnabled) === null || _this$options$isEnabl3 === void 0 ? void 0 : _this$options$isEnabl3.call(_this$options3)) === false) {
            this.coordinator.cancel(activation.token);
            return;
        }
        if (!this.coordinator.isNativeFallbackPending(activation.token)) return;
        if (activation.event.defaultPrevented) {
            this.coordinator.cancel(activation.token);
            return;
        }
        try {
            const destination = this.options.resolveDestination(activation.anchor.href);
            const xpis = (0, $hMeYk.XpcNavigationObservation).inspectXpis({
                baseUrl: this.options.baseUrl,
                parseCompatibleValue: this.options.parseCompatibleXpis,
                url: activation.anchor.href
            });
            if (xpis.kind === 'unreadable') {
                this.coordinator.cancel(activation.token);
                return;
            }
            const observation = (0, $hMeYk.XpcNavigationObservation).createDeparture({
                captureMethod: 'nativeDocument',
                destination: destination,
                handoffOutcome: 'accepted',
                navigationMechanism: 'nativeAnchor',
                source: this.options.source,
                surface: this.options.surface,
                xpis: xpis
            });
            this.coordinator.completeOnce(activation.token, ()=>{
                this.options.reporter.reportDeparture(observation);
            });
        } catch  {
            this.coordinator.cancel(activation.token);
        }
    }
}

});

parcelRegister("ktD8W", function(module, exports) {
$parcel$export(module.exports, "XpcNavigationContext", () => $b1adeb6a007e0245$export$a4cede8a391a2e0a);

var $fc4bM = parcelRequire("fc4bM");
const $b1adeb6a007e0245$export$a4cede8a391a2e0a = (0, $fc4bM.createContext)(undefined);

});




parcelRegister("9KawQ", function(module, exports) {
$parcel$export(module.exports, "MetaDataProvider", () => (parcelRequire("lenHW")).default);

var $lenHW = parcelRequire("lenHW");

var $lOioC = parcelRequire("lOioC");

});
parcelRegister("lenHW", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc9e714d29c1153$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("kzuYB");
var $5QO1D = parcelRequire("5QO1D");
parcelRequire("3WjHd");
var $et0Rx = parcelRequire("et0Rx");

var $lOioC = parcelRequire("lOioC");
const $5fc9e714d29c1153$var$mapDispatchToProps = {
    updateEnvAction: $5QO1D.updateEnvAction,
    updateMetaAction: $et0Rx.updateMetaAction
};
var $5fc9e714d29c1153$export$2e2bcd8739ae039 = (0, $6umft.default)(null, $5fc9e714d29c1153$var$mapDispatchToProps)((0, $lOioC.default));

});



parcelRegister("9KCPm", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => (parcelRequire("43htV")).default);

var $43htV = parcelRequire("43htV");

});
parcelRegister("43htV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a48c38db2ffae97$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $3A2Rb = parcelRequire("3A2Rb");

var $jnegp = parcelRequire("jnegp");

var $fd880 = parcelRequire("fd880");

var $12QfD = parcelRequire("12QfD");

var $1hJdJ = parcelRequire("1hJdJ");

var $4T8rw = parcelRequire("4T8rw");

var $7yidP = parcelRequire("7yidP");

var $6Pd4T = parcelRequire("6Pd4T");
const $3a48c38db2ffae97$var$GenericErrorPage = ({ title: title, message: message, hideFooter: hideFooter })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $jnegp.Root), null, /*#__PURE__*/ $fc4bM.createElement((0, $jnegp.Container), null, /*#__PURE__*/ $fc4bM.createElement((0, $jnegp.PageErrorIcon), null), /*#__PURE__*/ $fc4bM.createElement((0, $jnegp.MessageContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
            space: "space.200",
            alignInline: "center"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
            size: "xlarge"
        }, title ? title : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $3A2Rb.default).errorTitle)), /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), {
            align: "center"
        }, message ? message : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $3A2Rb.default).errorMessage)))
    }, /*#__PURE__*/ $fc4bM.createElement((0, $jnegp.ErrorMessage), null, title ? title : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $3A2Rb.default).errorTitle)), /*#__PURE__*/ $fc4bM.createElement((0, $jnegp.HelpText), null, message ? message : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $3A2Rb.default).errorMessage))))), !hideFooter && /*#__PURE__*/ $fc4bM.createElement((0, $12QfD.Footer), null));
};
var $3a48c38db2ffae97$export$2e2bcd8739ae039 = $3a48c38db2ffae97$var$GenericErrorPage;

});
parcelRegister("3A2Rb", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ff85f6848588247$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $5ff85f6848588247$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorTitle: {
        defaultMessage: "We're on it",
        description: 'Error title to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.title'
    },
    errorMessage: {
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'Error message to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.message'
    }
});

});

parcelRegister("jnegp", function(module, exports) {
$parcel$export(module.exports, "Root", () => $50c9a6f120248bb9$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Container", () => $50c9a6f120248bb9$export$42a852a2b6b56249);
$parcel$export(module.exports, "ErrorMessage", () => $50c9a6f120248bb9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "HelpText", () => $50c9a6f120248bb9$export$a67c0bc59081311a);
$parcel$export(module.exports, "MessageContainer", () => $50c9a6f120248bb9$export$616d763e306cba45);
$parcel$export(module.exports, "PageErrorIcon", () => $50c9a6f120248bb9$export$4e475cfbf52c9b29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $7IHUT = parcelRequire("7IHUT");
const $50c9a6f120248bb9$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-16pz4j-0"
})`${$3DjOo.flexCenter};height:100%;flex:1 1 auto;flex-direction:column;`;
const $50c9a6f120248bb9$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-16pz4j-1"
})`${$3DjOo.flexCenter};flex:1 1 auto;flex-direction:column;margin-bottom:${"var(--ds-space-800, 64px)"};padding-bottom:${"var(--ds-space-100, 8px)"};`;
const $50c9a6f120248bb9$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $luz1X.default).h1.withConfig({
    componentId: "sc-16pz4j-2"
})`${$imLe4.h800};`;
const $50c9a6f120248bb9$export$a67c0bc59081311a = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-16pz4j-3"
})`margin-top:${"var(--ds-space-200, 16px)"};`;
const $50c9a6f120248bb9$export$616d763e306cba45 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-16pz4j-4"
})`text-align:center;padding:0 ${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-300, 24px)"};max-width:${$fOCtI.multiple(53).px};`;
const $50c9a6f120248bb9$export$4e475cfbf52c9b29 = /*#__PURE__*/ (0, $luz1X.default)((0, $7IHUT.default)).withConfig({
    componentId: "sc-16pz4j-5"
})`width:${$fOCtI.multiple(34).px};`;

});
parcelRegister("imLe4", function(module, exports) {
$parcel$export(module.exports, "small", () => $50acebc450c5a0f9$export$3c17b0e969a90510);
$parcel$export(module.exports, "regular", () => $50acebc450c5a0f9$export$28a535dd448ffda4);
$parcel$export(module.exports, "medium", () => $50acebc450c5a0f9$export$649ecc744817b5c7);
$parcel$export(module.exports, "mediumLarge", () => $50acebc450c5a0f9$export$eab9f63b1324bb90);
$parcel$export(module.exports, "xsmall", () => $50acebc450c5a0f9$export$53e73bcd5097e50d);
$parcel$export(module.exports, "h800", () => $50acebc450c5a0f9$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $50acebc450c5a0f9$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $50acebc450c5a0f9$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $50acebc450c5a0f9$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $50acebc450c5a0f9$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $50acebc450c5a0f9$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $50acebc450c5a0f9$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $50acebc450c5a0f9$export$dfc0e69214efdc3c);
/* eslint-disable @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css -- Disabled to upgrade atlaskit/theme */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
const $50acebc450c5a0f9$export$3c17b0e969a90510 = /*#__PURE__*/ (0, $luz1X.css)`font-size:12px;`;
const $50acebc450c5a0f9$export$28a535dd448ffda4 = /*#__PURE__*/ (0, $luz1X.css)`font-size:14px;`;
const $50acebc450c5a0f9$export$649ecc744817b5c7 = /*#__PURE__*/ (0, $luz1X.css)`font-size:16px;`;
const $50acebc450c5a0f9$export$eab9f63b1324bb90 = /*#__PURE__*/ (0, $luz1X.css)`font-size:18px;`;
const $50acebc450c5a0f9$export$53e73bcd5097e50d = /*#__PURE__*/ (0, $luz1X.css)`font-size:11px;`;
const $50acebc450c5a0f9$export$3953fb6fbd158d23 = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '2.071em',
    fontStyle: 'inherit',
    lineHeight: 1.103
});
const $50acebc450c5a0f9$export$e4f993a313607daa = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '1.714em',
    fontStyle: 'inherit',
    lineHeight: 1.167
});
const $50acebc450c5a0f9$export$1e8b2acea3fb3119 = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/use-tokens-space
    marginTop: '28px',
    fontSize: '1.429em',
    fontStyle: 'inherit',
    lineHeight: 1.2
});
const $50acebc450c5a0f9$export$85aa43a9b9f06707 = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    marginTop: "var(--ds-space-300, 24px)",
    fontSize: '1.143em',
    fontStyle: 'inherit',
    lineHeight: 1.25
});
const $50acebc450c5a0f9$export$fcb7764b80bd908f = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '1em',
    fontStyle: 'inherit',
    lineHeight: 1.143
});
const $50acebc450c5a0f9$export$a0e59c3bbc05e815 = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-250, 20px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333,
    textTransform: 'uppercase'
});
const $50acebc450c5a0f9$export$7ccf32eb2150ac7e = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333
});
const $50acebc450c5a0f9$export$dfc0e69214efdc3c = /*#__PURE__*/ (0, $luz1X.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.786em',
    fontStyle: 'inherit',
    lineHeight: 1.455
});

});

parcelRegister("7IHUT", function(module, exports) {
$parcel$export(module.exports, "default", () => $526463d5cea160ec$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $526463d5cea160ec$var$SvgPageerrorreact = (props)=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 244.1 215.54",
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient",
        x1: 161.63,
        y1: 110.9,
        x2: 64.3,
        y2: 156.29,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-2",
        x1: 14.8,
        y1: 230.34,
        x2: 229.01,
        y2: 16.13,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0,
        stopColor: "#c1c7d0"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 1,
        stopColor: "#fafbfc"
    })), /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-3",
        x1: 44.97,
        y1: 136.36,
        x2: 187.42,
        y2: -6.09,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0,
        stopColor: "#fafbfc",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0.82,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-4",
        x1: 68.71,
        y1: 188.85,
        x2: 148.65,
        y2: 108.91,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0,
        stopColor: "#ebecf0",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 1,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "page_error_react_svg__clip-path"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "page_error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    })), /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "page_error_react_svg__clip-path-2"
    }, /*#__PURE__*/ $fc4bM.createElement("rect", {
        id: "page_error_react_svg___Rectangle_",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    })), /*#__PURE__*/ $fc4bM.createElement("style", null, ".page_error_react_svg__cls-1{fill:#fff}.page_error_react_svg__cls-2{fill:url(#page_error_react_svg__linear-gradient)}.page_error_react_svg__cls-7{fill:#253858}.page_error_react_svg__cls-15{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $fc4bM.createElement("g", {
        style: {
            isolation: "isolate"
        }
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        id: "page_error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        id: "page_error_react_svg__Software"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "page_error_react_svg___Rectangle_2",
        "data-name": "<Rectangle>",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-2)"
        },
        d: "M0 30.92h243.81v184.62H0z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        style: {
            fill: "#ebecf0"
        },
        d: "M0 30.92h243.81v19.67H0z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M244.1 67.68c-69.18-6-108.85.91-132.52 8.71-4.66 1.53-10.66 3.75-20.52 6.35-35.63 9.41-68.6 9.94-90.77 8.93V50.59H244.1Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-3)",
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("circle", {
        className: "page_error_react_svg__cls-7",
        cx: 15.69,
        cy: 40.69,
        r: 5.11
    }), /*#__PURE__*/ $fc4bM.createElement("circle", {
        cx: 32.37,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#a5adba"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("circle", {
        cx: 49.05,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#0065ff"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("rect", {
        id: "page_error_react_svg___Rectangle_3",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    }), /*#__PURE__*/ $fc4bM.createElement("g", {
        style: {
            clipPath: "url(#page_error_react_svg__clip-path-2)"
        }
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "page_error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        d: "m118 78.83 47.32 82A10.81 10.81 0 0 1 156 177H61.36A10.81 10.81 0 0 1 52 160.8l47.32-82a10.81 10.81 0 0 1 18.68.03Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-4)",
            mixBlendMode: "multiply"
        }
    })), /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "page_error_react_svg___Polygon_3",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "page_error_react_svg__cls-7",
        d: "m128.41 130.33 2.05-31.59a6.54 6.54 0 0 0-6.53-7 6.54 6.54 0 0 0-6.53 7l2.05 31.59a4.49 4.49 0 0 0 4.48 4.2 4.49 4.49 0 0 0 4.48-4.2ZM117.13 147.1a6.79 6.79 0 0 0 7.4 6.82 6.89 6.89 0 0 0-.64-13.76 6.87 6.87 0 0 0-6.76 6.94Z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M134.17 26.76 126.87.44a.6.6 0 0 0-1.17.05l-4.59 24.72-5.71-1.06a.6.6 0 0 0-.69.75L122 51.23a.6.6 0 0 0 1.17-.05l4.59-24.72 5.71 1.06a.6.6 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "m108 41.19-10.73-8.43a.26.26 0 0 0-.4.32l5.44 11.26-2.62 1.27a.26.26 0 0 0 0 .45l10.71 8.42a.26.26 0 0 0 .4-.32l-5.49-11.26 2.62-1.27a.26.26 0 0 0 .07-.44Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M157.26 36c-1.15 1.57-10.83-5.52-12-3.95s8.53 8.66 7.38 10.23-10.83-5.52-12-3.94 8.53 8.66 7.38 10.23-10.84-5.51-12-3.94 8.53 8.66 7.38 10.24",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "page_error_react_svg__cls-15",
        d: "M162 63.22c-1.44 1.31-6.95-4.71-8.38-3.39s4.07 7.34 2.63 8.65-6.95-4.71-8.38-3.39c-.67.61.16 2.23 1.1 3.93M88 63.09c1.79.76 5-6.77 6.76-6s-1.37 8.28.42 9 5-6.77 6.76-6c.83.35.6 2.16.29 4.07"
    })))));
var $526463d5cea160ec$export$2e2bcd8739ae039 = $526463d5cea160ec$var$SvgPageerrorreact;

});


parcelRegister("12QfD", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $da229eaa3240b842$export$a06f1c675e846f6f);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");

var $2BxGT = parcelRequire("2BxGT");
const $da229eaa3240b842$var$selector = (0, $2n2bS.createSelector)((0, $fYLlE.getWacLink), (linkTo)=>({
        linkTo: linkTo
    }));
const $da229eaa3240b842$export$a06f1c675e846f6f = (0, $6umft.default)($da229eaa3240b842$var$selector)((0, $2BxGT.default));

});
parcelRegister("2BxGT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7dcb02a75941dee$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $g9mbo = parcelRequire("g9mbo");

var $imLe4 = parcelRequire("imLe4");

var $6F3K7 = parcelRequire("6F3K7");

var $cHuC4 = parcelRequire("cHuC4");

var $fd880 = parcelRequire("fd880");

var $3TJLC = parcelRequire("3TJLC");

var $i3riz = parcelRequire("i3riz");

var $lDLEr = parcelRequire("lDLEr");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $87rOb = parcelRequire("87rOb");

var $ku1lj = parcelRequire("ku1lj");
const $b7dcb02a75941dee$var$Footer = ({ linkTo: linkTo, className: className, isCSM: isCSM })=>{
    // isCSM check is used for generating correct footer in CSMRequest Type Previews
    const showCSMFooter = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) || isCSM;
    const renderWacFooterLink = ()=>{
        const footerLink = /*#__PURE__*/ $fc4bM.createElement($b7dcb02a75941dee$var$FooterLink, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation",
            target: "_blank",
            rel: "noopener noreferrer",
            href: linkTo,
            actionSubjectId: "waclink"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
            ...(0, $87rOb.default).footer,
            values: {
                iconHtml: /*#__PURE__*/ $fc4bM.createElement($b7dcb02a75941dee$var$FooterJsdIcon, null)
            }
        }));
        return /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, footerLink, /*#__PURE__*/ $fc4bM.createElement((0, $lDLEr.CookiePreferencesButton), {
            isInClassicHelpCenter: true
        }));
    };
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            source: 'footer'
        }
    }, /*#__PURE__*/ $fc4bM.createElement($b7dcb02a75941dee$var$FooterContainer, {
        id: "portal-layout-footer",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        "data-testid": "portal-layout-footer"
    }, showCSMFooter ? null : renderWacFooterLink()));
};
var $b7dcb02a75941dee$export$2e2bcd8739ae039 = $b7dcb02a75941dee$var$Footer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b7dcb02a75941dee$var$FooterContainer = /*#__PURE__*/ (0, $luz1X.default).footer.withConfig({
    componentId: "sc-1d68q8x-0"
})`padding:${`var(--ds-space-600, ${`${(0, $ku1lj.footerPadding)}px`})`} 0;text-align:center;white-space:nowrap;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b7dcb02a75941dee$var$FooterJsdIcon = /*#__PURE__*/ (0, $luz1X.default)((0, $cHuC4.default)).withConfig({
    componentId: "sc-1d68q8x-1"
})`object-fit:contain;height:${`var(--ds-space-250, ${`${(0, $ku1lj.footerJsdIconHeight)}px`})`};vertical-align:middle;opacity:0.5;transition:opacity ${$6F3K7.timingFunctions.easeInOut} ${$6F3K7.speedMs.fast}ms;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b7dcb02a75941dee$var$FooterLink = /*#__PURE__*/ (0, $luz1X.default)((0, $g9mbo.HtmlAnchor)).withConfig({
    componentId: "sc-1d68q8x-2"
})`${$imLe4.small};color:${"var(--ds-text-subtlest, #5E6C84)"};cursor:pointer;:hover,:active{color:${"var(--ds-text-subtlest, #5E6C84)"};text-decoration:none;${$b7dcb02a75941dee$var$FooterJsdIcon}{opacity:1;stop:first-child{stop-color:${"var(--ds-background-brand-bold-hovered, #0052CC)"};}stop:last-child{stop-color:${"var(--ds-background-brand-bold, #2684FF)"};}> g > g > path:last-child{fill:${"var(--ds-background-brand-bold, #2684FF)"};}}}`;

});
parcelRegister("g9mbo", function(module, exports) {
$parcel$export(module.exports, "HtmlAnchor", () => $602fc3f9efc7a31f$export$acca9dc24cfe2034);

var $fc4bM = parcelRequire("fc4bM");

var $asUgz = parcelRequire("asUgz");
const $602fc3f9efc7a31f$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...anchorProps })=>{
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content
    return /*#__PURE__*/ $fc4bM.createElement("a", anchorProps);
};
const $602fc3f9efc7a31f$export$acca9dc24cfe2034 = (0, $asUgz.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($602fc3f9efc7a31f$var$InstrumentedLink);

});
parcelRegister("asUgz", function(module, exports) {
$parcel$export(module.exports, "default", () => $d43f62aa19696106$export$2e2bcd8739ae039);

var $aYMdQ = parcelRequire("aYMdQ");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $eENmG = parcelRequire("eENmG");
/**
 * Will create and fire a UI event when the callback is called.
 * Works like the following:
 *
 * YOU NEED TO PASS IN PROPS UNFORTUNATELY SORRY LIMITATION W/ TYPESCRIPT!
 * This means your default props probably won't work. And your props won't be set correctly on the wrapped component.
 * JUST PASS IN TPROPS!
 */ const $d43f62aa19696106$var$withCreateFireUIAnalytics = (actionSubject, analyticsDefinition)=>{
    return (Component)=>{
        const mappedAnalyticsDefinition = (0, $aYMdQ.mapValues)(analyticsDefinition, (val)=>{
            return (create, props)=>{
                const payload = val(props);
                const event = create({
                    ...payload,
                    ...props.attributes,
                    actionSubjectId: props.actionSubjectId,
                    analyticsType: (0, $eENmG.UI_EVENT_TYPE)
                });
                event.fire();
                return event;
            };
        });
        const WrappedComponent = (0, $613oU.default)({
            componentName: actionSubject
        })(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $azARG.default)(mappedAnalyticsDefinition)(Component));
        WrappedComponent.displayName = `withCreateFireUIAnalytics(${Component.displayName || Component.name})`;
        return WrappedComponent;
    };
};
var $d43f62aa19696106$export$2e2bcd8739ae039 = $d43f62aa19696106$var$withCreateFireUIAnalytics;

});


parcelRegister("cHuC4", function(module, exports) {
$parcel$export(module.exports, "default", () => $89be9681e88762c5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $89be9681e88762c5$var$SvgJsdIconreact = (props)=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        width: 15,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        x1: "38.04%",
        y1: "6.64%",
        x2: "59.86%",
        y2: "63.78%",
        id: "jsd-icon_react_svg__a"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        stopColor: "#344563",
        offset: "0%"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        stopColor: "#5E6C84",
        offset: "100%"
    }))), /*#__PURE__*/ $fc4bM.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M-9-6h32v32H-9z"
    }), /*#__PURE__*/ $fc4bM.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "m8.93 7.56 5.2.02a.81.81 0 0 1 .65 1.3L7.09 19.14A5.46 5.46 0 0 1 6 11.5l2.94-3.94z",
        fill: "url(#jsd-icon_react_svg__a)"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "m5.98 11.5-5.17-.04a.81.81 0 0 1-.65-1.3L7.77 0a5.46 5.46 0 0 1 1.11 7.64l-2.9 3.86z",
        fill: "#5E6C84"
    }))));
var $89be9681e88762c5$export$2e2bcd8739ae039 = $89be9681e88762c5$var$SvgJsdIconreact;

});

parcelRegister("lDLEr", function(module, exports) {
$parcel$export(module.exports, "CookiePreferencesButton", () => $9bc2af7d06d09dea$export$931ce0f255e8e770);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $5dzEI = parcelRequire("5dzEI");

var $EawnW = parcelRequire("EawnW");

var $dRIvB = parcelRequire("dRIvB");

// Lazy-loaded so the modal bundle is only fetched on interaction, not on initial paint.
const $9bc2af7d06d09dea$var$PreferenceModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>Promise.resolve((parcelRequire("3c0fv"))).then((m)=>({
            default: m.PreferenceModal
        })));
const $9bc2af7d06d09dea$var$styles = {
    classicHelpCenter: "_2rko12b0 _11c8wadc _v564k6bl _1rjc12x7 _18zrutpp _1e0c116y _4cvr1h6o _bfhksm61 _syaz1rc1 _k48pi7a9 _t9ec1qs1 _80omtlke _irr31dpa _1ggl5xtf _1di6fcek"
};
const $9bc2af7d06d09dea$export$931ce0f255e8e770 = ({ appearance: appearance = 'subtle', spacing: spacing = 'compact', isInClassicHelpCenter: isInClassicHelpCenter = false })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    const handleOpen = (0, $fc4bM.useCallback)(()=>setIsOpen(true), []);
    const handleClose = (0, $fc4bM.useCallback)(()=>setIsOpen(false), []);
    const label = formatMessage((0, $dRIvB.default).cookiePreferences);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: [
            isInClassicHelpCenter ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
                xcss: $9bc2af7d06d09dea$var$styles.classicHelpCenter,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- xcss fontFamily only accepts ADS tokens; 'inherit' (needed to match the sibling link's system font) is static but has no token, so it must live on the style prop
                style: {
                    fontFamily: 'inherit'
                },
                onClick: handleOpen,
                children: label
            }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                appearance: appearance,
                spacing: spacing,
                onClick: handleOpen,
                children: label
            }),
            isOpen && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)($9bc2af7d06d09dea$var$PreferenceModal, {
                    onClose: handleClose,
                    onSubmit: handleClose
                })
            })
        ]
    });
};

});
parcelRegister("dRIvB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f8e62b4d02414cc$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $7f8e62b4d02414cc$var$cookiePreferencesMessages = (0, $8p5Cv.defineMessages)({
    cookiePreferences: {
        id: 'hub.cookie-preferences-button.cookiePreferences',
        defaultMessage: 'Cookie preferences',
        description: 'Label for a button that opens a modal where users can review and change their cookie and privacy preferences.'
    }
});
var $7f8e62b4d02414cc$export$2e2bcd8739ae039 = $7f8e62b4d02414cc$var$cookiePreferencesMessages;

});

parcelRegister("3c0fv", function(module, exports) {
$parcel$export(module.exports, "PreferenceModal", () => $87bc106af982e166$export$94c5684831c222e7);

var $fc4bM = parcelRequire("fc4bM");

var $c4StN = parcelRequire("c4StN");

var $dRkX9 = parcelRequire("dRkX9");

var $g5Y6L = parcelRequire("g5Y6L");

var $8dlZC = parcelRequire("8dlZC");

var $3k55j = parcelRequire("3k55j");

var $2jQ6M = parcelRequire("2jQ6M");

var $eGlBA = parcelRequire("eGlBA");

var $6QxR4 = parcelRequire("6QxR4");

var $jFHxM = parcelRequire("jFHxM");
const $87bc106af982e166$export$94c5684831c222e7 = (props)=>{
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $dRkX9.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($87bc106af982e166$export$30df3cfccbe10e6e, props);
};
const $87bc106af982e166$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $fc4bM.useState)(true);
    const isEventSent = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $g5Y6L.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $jFHxM.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $2jQ6M.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $fc4bM.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $g5Y6L.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $eGlBA.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $g5Y6L.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag === null || showSuccessFlag === void 0 || showSuccessFlag();
            } catch (e) {
                (0, $3k55j.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
            }
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 || onSubmit();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6QxR4.PresentationalPreferenceModal), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $2jQ6M.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, shouldAddWrappers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c4StN.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8dlZC.BSCIntlProvider), null, modalContent)) : modalContent);
};

});
parcelRegister("c4StN", function(module, exports) {
$parcel$export(module.exports, "FlagsProvider", () => $08925df8128b5aff$export$a4270ab432ac8a58);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jS4uw = parcelRequire("jS4uw");

var $eBDNv = parcelRequire("eBDNv");

var $HfuUp = parcelRequire("HfuUp");

var $bAQQ9 = parcelRequire("bAQQ9");
const $08925df8128b5aff$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $08925df8128b5aff$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $fc4bM.useState)([]);
    const removeFlag = (0, $fc4bM.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $fc4bM.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $08925df8128b5aff$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $HfuUp.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bAQQ9.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $jS4uw.default) : (0, $eBDNv.default);
                    return /*#__PURE__*/ (0, $fc4bM.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}

});
parcelRegister("HfuUp", function(module, exports) {
$parcel$export(module.exports, "FlagContext", () => $6e54efdace4a0565$export$2eb95677cf2465e1);

var $fc4bM = parcelRequire("fc4bM");
const $6e54efdace4a0565$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(null);

});


parcelRegister("8dlZC", function(module, exports) {
$parcel$export(module.exports, "BSCIntlProvider", () => $4484e7b345ffbdc6$export$9aa38aed134c207f);

var $fc4bM = parcelRequire("fc4bM");

var $5lw64 = parcelRequire("5lw64");

var $inc6E = parcelRequire("inc6E");
var $iwFrI = parcelRequire("iwFrI");
const $4484e7b345ffbdc6$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5lw64.default), {
        defaultMessages: (0, $inc6E.default),
        loaderFn: (0, $iwFrI.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("5lw64", function(module, exports) {
$parcel$export(module.exports, "default", () => $efa1f4ec55532989$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8MaoS = parcelRequire("8MaoS");

var $bz7Tm = parcelRequire("bz7Tm");

var $3AF6I = parcelRequire("3AF6I");
function $efa1f4ec55532989$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $3AF6I.useSafeIntl)();
    const messages = (0, $bz7Tm.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $fc4bM.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("bz7Tm", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $9cd9865b25cc1186$export$4d17e2d9c5348842);

var $fc4bM = parcelRequire("fc4bM");

var $6c5Ox = parcelRequire("6c5Ox");
function $9cd9865b25cc1186$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $fc4bM.useState)((0, $6c5Ox.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $fc4bM.useRef)(localeState.locale);
    (0, $fc4bM.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("6c5Ox", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $fc88277119cc5e85$export$79618bef82c02d4c);
const $fc88277119cc5e85$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("3AF6I", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $0d9147f1a4ee1029$export$f752ac21ea3960a5);

var $fc4bM = parcelRequire("fc4bM");

var $hzT1C = parcelRequire("hzT1C");
var $kezTY = parcelRequire("kezTY");
var $fcCIH = parcelRequire("fcCIH");

var $6c5Ox = parcelRequire("6c5Ox");
// Prevents memory leaks
const $0d9147f1a4ee1029$var$cache = (0, $kezTY.createIntlCache)();
const $0d9147f1a4ee1029$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $fc4bM.useContext)((0, $fcCIH.Context));
    if (!context) return (0, $hzT1C.createIntl)((0, $6c5Ox.DEFAULT_LOCALE_STATE), $0d9147f1a4ee1029$var$cache);
    return context;
};

});


parcelRegister("inc6E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3c247e10b748d8ce$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eiwHe = parcelRequire("eiwHe");
var $3c247e10b748d8ce$export$2e2bcd8739ae039 = (0, $eiwHe.default);

});
parcelRegister("eiwHe", function(module, exports) {
$parcel$export(module.exports, "default", () => $1372a18f5b597983$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $1372a18f5b597983$export$2e2bcd8739ae039 = {
    "browser-storage-controls.consent-banner-modal.analytical.description.101024": "Measures usage to improve product performance.",
    "browser-storage-controls.consent-banner-modal.analytical.description.101024-appify": "Measures usage to improve app performance.",
    "browser-storage-controls.consent-banner-modal.analytical.option.082624": "Allow analytical cookies",
    "browser-storage-controls.consent-banner-modal.cancel.button": "Cancel",
    "browser-storage-controls.consent-banner-modal.confirm.button": "Confirm",
    "browser-storage-controls.consent-banner-modal.functional.description.082624": "Provides enhanced functionality and personalization.",
    "browser-storage-controls.consent-banner-modal.functional.option.082624": "Allow functional cookies",
    "browser-storage-controls.consent-banner-modal.marketing.description.082624": "Used for targeted advertising.",
    "browser-storage-controls.consent-banner-modal.marketing.option.082624": "Allow marketing cookies",
    "browser-storage-controls.consent-banner-modal.strict.description.082624": "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    "browser-storage-controls.consent-banner-modal.strict.description.082624-appify": "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    "browser-storage-controls.consent-banner-modal.summary.description.082624": "Because we value your privacy, you can select which cookies you allow. {link}",
    "browser-storage-controls.consent-banner-modal.title": "Cookie preferences",
    "browser-storage-controls.consent-banner-modal.tracking.link.082624": "Review our cookies and tracking notice",
    "browser-storage-controls.consent-banner.accept-all.button": "Accept all",
    "browser-storage-controls.consent-banner.cookies-description.text": "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}",
    "browser-storage-controls.consent-banner.cookies-description.text.no.link": "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.",
    "browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024": "Atlassian cookies and tracking notice",
    "browser-storage-controls.consent-banner.error-flag.description": "Try again in a few minutes.",
    "browser-storage-controls.consent-banner.error-flag.title": "We're unable to update the policy",
    "browser-storage-controls.consent-banner.only-necessary.button": "Only necessary",
    "browser-storage-controls.consent-banner.preferences.button": "Preferences",
    "browser-storage-controls.consent-banner.success-flag.description": "You can change this at any time in your Atlassian account.",
    "browser-storage-controls.consent-banner.success-flag.description-local-only": "Your preferences will only affect this site.",
    "browser-storage-controls.consent-banner.success-flag.title": "Cookie preferences saved",
    "browser-storage-controls.consent-banner.toast.error": "Error",
    "browser-storage-controls.consent-banner.toast.success": "Success"
};

});


parcelRegister("iwFrI", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $a779b1fc67732f6b$export$2b153a2030b0feb2);

var $inc6E = parcelRequire("inc6E");




























const $a779b1fc67732f6b$var$locales = {
    cs: ()=>(parcelRequire("wBzfR")),
    da: ()=>(parcelRequire("cx1y4")),
    de: ()=>(parcelRequire("4lg2x")),
    'en-GB': ()=>(parcelRequire("4Kuwl")),
    'en-ZZ': ()=>(parcelRequire("gCQPO")),
    en: ()=>Promise.resolve((parcelRequire("inc6E"))),
    es: ()=>(parcelRequire("5C8SB")),
    fi: ()=>(parcelRequire("9p7Sh")),
    fr: ()=>(parcelRequire("4mpzj")),
    hu: ()=>(parcelRequire("iDSAI")),
    it: ()=>(parcelRequire("21AQ4")),
    ja: ()=>(parcelRequire("an5Ar")),
    ko: ()=>(parcelRequire("bQ4iX")),
    nb: ()=>(parcelRequire("kickX")),
    nl: ()=>(parcelRequire("aOmIA")),
    pl: ()=>(parcelRequire("eqWaW")),
    'pt-BR': ()=>(parcelRequire("92VTL")),
    ru: ()=>(parcelRequire("hZgTi")),
    sl: ()=>(parcelRequire("5p9xK")),
    sr_RS: ()=>(parcelRequire("dF7aK")),
    sr_YR: ()=>(parcelRequire("8382s")),
    sv: ()=>(parcelRequire("3aOP0")),
    th: ()=>(parcelRequire("7hRbW")),
    tr: ()=>(parcelRequire("fkUF8")),
    uk: ()=>(parcelRequire("e1e0b")),
    vi: ()=>(parcelRequire("9Sda1")),
    zh_TW: ()=>(parcelRequire("jupuV")),
    zh: ()=>(parcelRequire("a6uNd"))
};
const $a779b1fc67732f6b$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $a779b1fc67732f6b$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $a779b1fc67732f6b$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("wBzfR", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gPuco").then(()=>parcelRequire('bXo8U'));

});

parcelRegister("cx1y4", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("f15zt").then(()=>parcelRequire('frA6o'));

});

parcelRegister("4lg2x", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("lPcKQ").then(()=>parcelRequire('fzUUO'));

});

parcelRegister("4Kuwl", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("60wbt").then(()=>parcelRequire('b477m'));

});

parcelRegister("gCQPO", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bnkQJ").then(()=>parcelRequire('8sWAT'));

});

parcelRegister("5C8SB", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("iPKjD").then(()=>parcelRequire('fxsPf'));

});

parcelRegister("9p7Sh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4hDGY").then(()=>parcelRequire('ku5GW'));

});

parcelRegister("4mpzj", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("b40Dd").then(()=>parcelRequire('f6yc6'));

});

parcelRegister("iDSAI", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ebwe0").then(()=>parcelRequire('dycEf'));

});

parcelRegister("21AQ4", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("l0zQs").then(()=>parcelRequire('4EfzF'));

});

parcelRegister("an5Ar", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("2O0zK").then(()=>parcelRequire('f0AUs'));

});

parcelRegister("bQ4iX", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("52iIY").then(()=>parcelRequire('5nBWy'));

});

parcelRegister("kickX", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("fQGpN").then(()=>parcelRequire('gIaxI'));

});

parcelRegister("aOmIA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("i4WUA").then(()=>parcelRequire('daqDz'));

});

parcelRegister("eqWaW", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7So4v").then(()=>parcelRequire('1YbWx'));

});

parcelRegister("92VTL", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("c9Cwi").then(()=>parcelRequire('1uKxg'));

});

parcelRegister("hZgTi", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kTn5s").then(()=>parcelRequire('3Mfuq'));

});

parcelRegister("5p9xK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6QCZT").then(()=>parcelRequire('7LMj5'));

});

parcelRegister("dF7aK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4yXIw").then(()=>parcelRequire('jQeT7'));

});

parcelRegister("8382s", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7q0ZK").then(()=>parcelRequire('dS6BY'));

});

parcelRegister("3aOP0", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ktAwo").then(()=>parcelRequire('fkyFg'));

});

parcelRegister("7hRbW", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1LssT").then(()=>parcelRequire('b7VSD'));

});

parcelRegister("fkUF8", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("g55RU").then(()=>parcelRequire('6uJtx'));

});

parcelRegister("e1e0b", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("fRApR").then(()=>parcelRequire('272CS'));

});

parcelRegister("9Sda1", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("27IWP").then(()=>parcelRequire('dFXBS'));

});

parcelRegister("jupuV", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("d9nUT").then(()=>parcelRequire('cBjKG'));

});

parcelRegister("a6uNd", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("63UXt").then(()=>parcelRequire('fQPUp'));

});



parcelRegister("eGlBA", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", () => $190a0928e6441b83$export$7bb3e177c1a1e841);

var $eqqb5 = parcelRequire("eqqb5");

var $2jQ6M = parcelRequire("2jQ6M");

var $cjHoj = parcelRequire("cjHoj");

var $3HcNt = parcelRequire("3HcNt");

var $fIv8k = parcelRequire("fIv8k");

var $dzMIZ = parcelRequire("dzMIZ");
const $190a0928e6441b83$var$emptyDisplayedTextMap = {
    [(0, $cjHoj.PreferenceCategory).Analytics]: '',
    [(0, $cjHoj.PreferenceCategory).Functional]: '',
    [(0, $cjHoj.PreferenceCategory).Marketing]: '',
    [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $cjHoj.PreferenceCategory).Unknown]: ''
};
async function $190a0928e6441b83$export$7bb3e177c1a1e841(preferences, displayedTextMap = $190a0928e6441b83$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $eqqb5.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $dzMIZ.packUserPreferences)(preferences);
        (0, $fIv8k.setStrictlyNecessaryCookie)((0, $2jQ6M.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $3HcNt.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("3HcNt", function(module, exports) {
$parcel$export(module.exports, "setConsentToken", () => $3a36a81177dd0b57$export$fbf549fe6f0e91dc);

var $3k55j = parcelRequire("3k55j");

var $cXyAq = parcelRequire("cXyAq");

var $lmMgc = parcelRequire("lmMgc");

var $cjHoj = parcelRequire("cjHoj");

var $9W30i = parcelRequire("9W30i");

var $dzMIZ = parcelRequire("dzMIZ");

var $klFE0 = parcelRequire("klFE0");
const $3a36a81177dd0b57$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $dzMIZ.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $lmMgc.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $klFE0.onlySetFallbackIfDifferent)(consentToken);
    else (0, $9W30i.setConsentTokenFallbackCookie)(consentToken);
    (0, $9W30i.setConsentTokenCookie)(consentToken);
    (0, $9W30i.setShouldShowBannerCookie)(consentToken);
};
const $3a36a81177dd0b57$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $lmMgc.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $lmMgc.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $dzMIZ.packUserPreferences)({
        ...mergedPrefs,
        [(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible // Indicates we were unable to hit ConsentHub when the consents were created
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $3k55j.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $klFE0.onlySetFallbackIfDifferent)(consentToken);
        (0, $9W30i.setConsentTokenCookie)(consentToken);
        (0, $9W30i.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down beyond the short-lived
    // consent token cookie's expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $3k55j.Logger).error('Token failed to save');
    (0, $klFE0.onlySetFallbackIfDifferent)(consentToken);
    (0, $9W30i.setShouldShowBannerCookie)(consentToken);
};
const $3a36a81177dd0b57$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $klFE0.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $cXyAq.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $3a36a81177dd0b57$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $3a36a81177dd0b57$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("klFE0", function(module, exports) {
$parcel$export(module.exports, "mergeConsentUpdates", () => $05623f021fc18e46$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $05623f021fc18e46$export$a023a0b818522757);

var $2jQ6M = parcelRequire("2jQ6M");

var $cjHoj = parcelRequire("cjHoj");

var $k8XFy = parcelRequire("k8XFy");

var $9W30i = parcelRequire("9W30i");

var $dzMIZ = parcelRequire("dzMIZ");
const $05623f021fc18e46$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $cjHoj.PreferenceCategory).StrictlyNecessary],
        [(0, $cjHoj.PreferenceCategory).Functional]: updatedPreferences[(0, $cjHoj.PreferenceCategory).Functional],
        [(0, $cjHoj.PreferenceCategory).Analytics]: updatedPreferences[(0, $cjHoj.PreferenceCategory).Analytics],
        [(0, $cjHoj.PreferenceCategory).Marketing]: updatedPreferences[(0, $cjHoj.PreferenceCategory).Marketing],
        [(0, $cjHoj.PreferenceCategory).Unknown]: updatedPreferences[(0, $cjHoj.PreferenceCategory).Unknown]
    };
};
const $05623f021fc18e46$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable]);
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault]);
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $cjHoj.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $cjHoj.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $cjHoj.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $05623f021fc18e46$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $dzMIZ.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $2jQ6M.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$05623f021fc18e46$var$pruneLegacyProperties(updatedPreferences),
            ...$05623f021fc18e46$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $2jQ6M.DEFAULT_PREFERENCES),
            ...$05623f021fc18e46$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $2jQ6M.DEFAULT_PREFERENCES),
        ...$05623f021fc18e46$var$pruneLegacyProperties(updatedPreferences),
        ...$05623f021fc18e46$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $05623f021fc18e46$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $9W30i.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("6QxR4", function(module, exports) {
$parcel$export(module.exports, "PresentationalPreferenceModal", () => $96e894b9e5e92ce8$export$9921ee7829a3ba4);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $kTVlm = parcelRequire("kTVlm");

var $e8E8t = parcelRequire("e8E8t");

var $2hfaK = parcelRequire("2hfaK");

var $dkw9k = parcelRequire("dkw9k");

var $2u7SO = parcelRequire("2u7SO");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $dRkX9 = parcelRequire("dRkX9");

var $bQrkt = parcelRequire("bQrkt");

var $5a4EU = parcelRequire("5a4EU");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $g5Y6L = parcelRequire("g5Y6L");

var $bdFEn = parcelRequire("bdFEn");

var $cjHoj = parcelRequire("cjHoj");

var $eNS8t = parcelRequire("eNS8t");

var $a7plR = parcelRequire("a7plR");
const $96e894b9e5e92ce8$var$categoryNameStyles = (0, $kig2V.xcss)({
    fontWeight: 'font.weight.bold'
});
const $96e894b9e5e92ce8$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($96e894b9e5e92ce8$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node)) {
        if (node.props.children) return $96e894b9e5e92ce8$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $96e894b9e5e92ce8$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $a7plR.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $a7plR.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $dRkX9.fg)('product-terminology-refresh') ? (0, $a7plR.i18n).strictDescriptionAppify : (0, $a7plR.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $96e894b9e5e92ce8$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $96e894b9e5e92ce8$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $cjHoj.PreferenceCategory).Functional,
            title: (0, $a7plR.i18n).functionalOption,
            description: (0, $a7plR.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $cjHoj.PreferenceCategory).Analytics,
            title: (0, $a7plR.i18n).analyticalOption,
            description: (0, $dRkX9.fg)('product-terminology-refresh') ? (0, $a7plR.i18n).analyticalOptionDescriptionAppify : (0, $a7plR.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $cjHoj.PreferenceCategory).Marketing,
            title: (0, $a7plR.i18n).marketingOption,
            description: (0, $a7plR.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $bdFEn.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $96e894b9e5e92ce8$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $96e894b9e5e92ce8$var$categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $96e894b9e5e92ce8$var$noop = ()=>{};
const $96e894b9e5e92ce8$var$CustomHeader = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2hfaK.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $a7plR.i18n).title)));
};
const $96e894b9e5e92ce8$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $96e894b9e5e92ce8$var$noop, onSubmit: onSubmit = $96e894b9e5e92ce8$var$noop, onClose: onClose = $96e894b9e5e92ce8$var$noop, setIsOpen: setIsOpen = $96e894b9e5e92ce8$var$noop })=>{
    const intl = (0, $gpjDl.default)();
    const onCloseModal = (0, $fc4bM.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $fc4bM.useCallback)(()=>{
        onCloseModal();
        (0, $g5Y6L.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $fc4bM.useCallback)(()=>{
        onCloseModal();
        (0, $g5Y6L.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $fc4bM.useCallback)(()=>{
        onCloseModal();
        (0, $g5Y6L.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $fc4bM.useCallback)(()=>{
        (0, $g5Y6L.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $fc4bM.useMemo)(()=>{
        return $96e894b9e5e92ce8$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $fc4bM.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        onClose: onClickBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e8E8t.default), {
        onSubmit: handleSubmission
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($96e894b9e5e92ce8$var$CustomHeader, {
        onClose: onClickClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $a7plR.i18n).summaryDescription,
        values: {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bQrkt.Anchor), {
                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $a7plR.i18n).trackingLink))
        },
        tagName: 'p'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $dRkX9.fg)('product-terminology-refresh') ? (0, $a7plR.i18n).strictDescriptionAppify : (0, $a7plR.i18n).strictDescription,
        values: {
            bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
                    weight: "bold"
                }, msg)
        },
        tagName: 'p'
    })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eNS8t.CookieCategorySection), {
            category: category,
            titleElement: titleElement,
            titleString: titleString,
            descriptionElement: description,
            isChecked: (preferences && preferences[category]) ?? false,
            setPreferencesData: setPreferencesData
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        appearance: "subtle",
        onClick: onClickCancel,
        testId: "consent-preference-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $a7plR.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        type: "submit",
        appearance: "primary",
        onClick: handleSubmission,
        testId: "consent-preference-confirm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $a7plR.i18n).confirmBtn))))));
};

});
parcelRegister("2hfaK", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $bf2997002febd9d1$export$de65de8213222d10);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fRCnG = parcelRequire("fRCnG");

var $gV8E5 = parcelRequire("gV8E5");
const $bf2997002febd9d1$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

});

parcelRegister("8qwF5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $20770fc584324078$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $31cO8 = parcelRequire("31cO8");
const $20770fc584324078$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $20770fc584324078$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $31cO8.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $20770fc584324078$export$2e2bcd8739ae039 = $20770fc584324078$var$ModalFooter;

});

parcelRegister("2NqAY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $937c791479c8a9e4$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $26fPW = parcelRequire("26fPW");

var $2hfaK = parcelRequire("2hfaK");

var $31cO8 = parcelRequire("31cO8");
const $937c791479c8a9e4$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $937c791479c8a9e4$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false, closeButtonLabel: closeButtonLabel } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $31cO8.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $937c791479c8a9e4$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $26fPW.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $937c791479c8a9e4$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2hfaK.CloseButton), {
                        label: closeButtonLabel,
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $937c791479c8a9e4$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
var $937c791479c8a9e4$export$2e2bcd8739ae039 = $937c791479c8a9e4$var$ModalHeader;

});

parcelRegister("5t2KI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8cb396477980e868$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gDsF8 = parcelRequire("gDsF8");

var $7ZdBj = parcelRequire("7ZdBj");

var $31cO8 = parcelRequire("31cO8");
const $8cb396477980e868$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $8cb396477980e868$var$iconStyles = null;
const $8cb396477980e868$var$titleStyles = null;
const $8cb396477980e868$var$textStyles = null;
const $8cb396477980e868$var$truncatedTextStyles = null;
const $8cb396477980e868$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))) : (0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj)));
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            label: appearance,
            color: $8cb396477980e868$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $8cb396477980e868$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $31cO8.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $3LM7S.jsx)($8cb396477980e868$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $2R2iS.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $8cb396477980e868$export$2e2bcd8739ae039 = $8cb396477980e868$var$ModalTitle;

});

parcelRegister("ggkex", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $037d0c71dc8ed498$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $iXBtU = parcelRequire("iXBtU");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $037d0c71dc8ed498$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $037d0c71dc8ed498$export$2e2bcd8739ae039 = $037d0c71dc8ed498$var$ModalTransition;

});

parcelRegister("bQrkt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Anchor", () => $ad72ab57bc8a8399$export$b688253958b8dfe7);
$parcel$export(module.exports, "default", () => $ad72ab57bc8a8399$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $DNksS = parcelRequire("DNksS");

var $7iKPB = parcelRequire("7iKPB");

var $b7gcM = parcelRequire("b7gcM");

var $9JZL9 = parcelRequire("9JZL9");

var $3zBNx = parcelRequire("3zBNx");

var $fVzQQ = parcelRequire("fVzQQ");

var $dVxDa = parcelRequire("dVxDa");

var $6sDmn = parcelRequire("6sDmn");

var $d8xIF = parcelRequire("d8xIF");

var $8nNtm = parcelRequire("8nNtm");

var $aVlMc = parcelRequire("aVlMc");

var $hg0W2 = parcelRequire("hg0W2");

var $gkD7x = parcelRequire("gkD7x");
function $ad72ab57bc8a8399$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $ad72ab57bc8a8399$var$focusRingStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $d8xIF.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $gkD7x.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $8nNtm.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $8nNtm.borderWidthMap)['border.width']} solid`
        }
    }
});
const $ad72ab57bc8a8399$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $ad72ab57bc8a8399$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $ad72ab57bc8a8399$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ad72ab57bc8a8399$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $ad72ab57bc8a8399$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $ad72ab57bc8a8399$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $9JZL9.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $3zBNx.useId)();
    const onClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $hg0W2.parseXcss)(xcss);
    const RouterLink = (0, $b7gcM.useRouterLink)();
    const isExternal = typeof href === 'string' && $ad72ab57bc8a8399$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ad72ab57bc8a8399$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $DNksS.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $jctmk.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $ad72ab57bc8a8399$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $ad72ab57bc8a8399$var$baseStyles,
            $ad72ab57bc8a8399$var$positionStyles,
            $ad72ab57bc8a8399$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $6sDmn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $aVlMc.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $aVlMc.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $aVlMc.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $aVlMc.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $aVlMc.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $aVlMc.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $aVlMc.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $jctmk.jsx)((0, $dVxDa.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $ad72ab57bc8a8399$var$OPENS_NEW_WINDOW_LABEL}`));
};
const $ad72ab57bc8a8399$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $fc4bM.forwardRef)($ad72ab57bc8a8399$var$AnchorNoRef);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ad72ab57bc8a8399$export$2e2bcd8739ae039 = $ad72ab57bc8a8399$export$b688253958b8dfe7;

});

parcelRegister("7yidP", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $179b323a23d1d8c2$export$694e0d28c7ffc90c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $kig2V = parcelRequire("kig2V");

var $1JdzP = parcelRequire("1JdzP");
const $179b323a23d1d8c2$var$flexGrowMap = {
    hug: (0, $kig2V.xcss)({
        flexGrow: 0
    }),
    fill: (0, $kig2V.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $179b323a23d1d8c2$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $179b323a23d1d8c2$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $1JdzP.Flex), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$179b323a23d1d8c2$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$179b323a23d1d8c2$export$2e2bcd8739ae039 = $179b323a23d1d8c2$export$694e0d28c7ffc90c;

});

parcelRegister("4T8rw", function(module, exports) {
$parcel$export(module.exports, "Text", () => $13afbf0252e1b8ba$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "default", () => $13afbf0252e1b8ba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $DNksS = parcelRequire("DNksS");

var $hgmo6 = parcelRequire("hgmo6");

var $gPFyv = parcelRequire("gPFyv");

var $lJOeE = parcelRequire("lJOeE");

var $3tX4e = parcelRequire("3tX4e");

var $6CsE4 = parcelRequire("6CsE4");

var $aQ2rE = parcelRequire("aQ2rE");

var $hrIDf = parcelRequire("hrIDf");
function $13afbf0252e1b8ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $13afbf0252e1b8ba$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $13afbf0252e1b8ba$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $13afbf0252e1b8ba$var$strongStyles = {
    name: "17rayov",
    styles: "font-weight:var(--ds-font-weight-bold, 653)"
};
const $13afbf0252e1b8ba$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $13afbf0252e1b8ba$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $13afbf0252e1b8ba$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $13afbf0252e1b8ba$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $13afbf0252e1b8ba$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $gPFyv.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $3tX4e.inverseColorMap).hasOwnProperty(surface)) return (0, $3tX4e.inverseColorMap)[surface];
    return 'color.text';
};
const $13afbf0252e1b8ba$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $DNksS.default)($13afbf0252e1b8ba$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $lJOeE.useHasTextAncestor)();
    const color = $13afbf0252e1b8ba$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $jctmk.jsx)(Component, {
        ref: ref,
        css: [
            $13afbf0252e1b8ba$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $aQ2rE.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $6CsE4.textColorStylesMap)[color],
            maxLines && $13afbf0252e1b8ba$var$truncationStyles,
            maxLines === 1 && $13afbf0252e1b8ba$var$wordBreakMap.breakAll,
            align && $13afbf0252e1b8ba$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $hrIDf.textWeightStylesMap)[weight],
            Component === 'em' && $13afbf0252e1b8ba$var$emStyles,
            Component === 'strong' && $13afbf0252e1b8ba$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $jctmk.jsx)((0, $hgmo6.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$13afbf0252e1b8ba$export$2e2bcd8739ae039 = $13afbf0252e1b8ba$export$5f1af8db9871e1d6;

});
parcelRegister("6CsE4", function(module, exports) {
$parcel$export(module.exports, "textColorStylesMap", () => $32a1b387d26e65a9$export$3a1bcba60b23d7f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hDCFn = parcelRequire("hDCFn");

var $1tNk5 = parcelRequire("1tNk5");
const $32a1b387d26e65a9$export$3a1bcba60b23d7f0 = (0, $hDCFn.getSerializedStylesMap)('color', (0, $1tNk5.textColorMap));

});

parcelRegister("aQ2rE", function(module, exports) {
$parcel$export(module.exports, "textSizeStylesMap", () => $9351469b65d1ff8b$export$219d364c0da35ae4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hDCFn = parcelRequire("hDCFn");

var $azwJc = parcelRequire("azwJc");
const $9351469b65d1ff8b$export$219d364c0da35ae4 = (0, $hDCFn.getSerializedStylesMap)('font', (0, $azwJc.textSizeMap));

});
parcelRegister("azwJc", function(module, exports) {
$parcel$export(module.exports, "textSizeMap", () => $80cd3d52be8ac066$export$236bfe3a33ef1292);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fd3eebcc815c6c62e80e08d3ca4f843>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $80cd3d52be8ac066$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});


parcelRegister("hrIDf", function(module, exports) {
$parcel$export(module.exports, "textWeightStylesMap", () => $9cc1ddbe87d4d616$export$38845ca010b93505);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hDCFn = parcelRequire("hDCFn");

var $kKkfK = parcelRequire("kKkfK");
const $9cc1ddbe87d4d616$export$38845ca010b93505 = (0, $hDCFn.getSerializedStylesMap)('fontWeight', (0, $kKkfK.textWeightMap));

});
parcelRegister("kKkfK", function(module, exports) {
$parcel$export(module.exports, "textWeightMap", () => $bee51c15651ba294$export$855cfd311192d666);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8120a44c21b94ee961979aa2a9470314>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $bee51c15651ba294$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};

});



parcelRegister("bdFEn", function(module, exports) {
$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $aea30e28bdc3047a$export$99df83ca0f45bd54);

var $cjHoj = parcelRequire("cjHoj");
const $aea30e28bdc3047a$export$99df83ca0f45bd54 = [
    (0, $cjHoj.PreferenceCategory).Analytics,
    (0, $cjHoj.PreferenceCategory).Functional,
    (0, $cjHoj.PreferenceCategory).Marketing,
    (0, $cjHoj.PreferenceCategory).StrictlyNecessary,
    (0, $cjHoj.PreferenceCategory).Unknown
];

});

parcelRegister("eNS8t", function(module, exports) {
$parcel$export(module.exports, "CookieCategorySection", () => $cfa2ce087e30f857$export$3c97a3b492e10ae9);

var $fc4bM = parcelRequire("fc4bM");

var $kDn5h = parcelRequire("kDn5h");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $g5Y6L = parcelRequire("g5Y6L");

var $cjHoj = parcelRequire("cjHoj");
const $cfa2ce087e30f857$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $cfa2ce087e30f857$var$categoryBoxStyles = (0, $kig2V.xcss)({
    paddingBlockStart: 'space.200'
});
const $cfa2ce087e30f857$var$categoryDescriptionStyles = (0, $kig2V.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $cfa2ce087e30f857$var$categoryToEventSubjectMap = {
    [(0, $cjHoj.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $cjHoj.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $cjHoj.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $cjHoj.PreferenceCategory).Unknown]: null,
    [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: null
};
const $cfa2ce087e30f857$var$categoryToTestIdMap = {
    [(0, $cjHoj.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $cjHoj.PreferenceCategory).Analytics]: 'analytics',
    [(0, $cjHoj.PreferenceCategory).Functional]: 'functional',
    [(0, $cjHoj.PreferenceCategory).Marketing]: 'marketing',
    [(0, $cjHoj.PreferenceCategory).Unknown]: null
};
const $cfa2ce087e30f857$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $fc4bM.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $cjHoj.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $cfa2ce087e30f857$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $g5Y6L.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${$cfa2ce087e30f857$var$categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $cfa2ce087e30f857$var$categoryBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kDn5h.Checkbox), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${$cfa2ce087e30f857$var$tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`,
        testId: `consent-preference-${$cfa2ce087e30f857$var$categoryToTestIdMap[category]}`,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $cfa2ce087e30f857$var$categoryDescriptionStyles,
        id: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        size: "small",
        color: "color.text.subtle"
    }, descriptionElement)));
};

});

parcelRegister("a7plR", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $c3a46ed5f21e24a9$export$a7357cdd1f0b0168);

var $8p5Cv = parcelRequire("8p5Cv");
const $c3a46ed5f21e24a9$export$a7357cdd1f0b0168 = (0, $8p5Cv.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});

});


parcelRegister("jFHxM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0c8a6c80e4b1559$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dzMIZ = parcelRequire("dzMIZ");

var $fWQ0G = parcelRequire("fWQ0G");

var $eGlBA = parcelRequire("eGlBA");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $e0c8a6c80e4b1559$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $fWQ0G.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $e0c8a6c80e4b1559$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
   * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
   *  during the initial render. Without this flag, the application might incorrectly display a banner based on
   * incomplete or missing preference data. During the rehydration process, this initial render triggers
   * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
   * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
   * and the client-rendered state.
   */ const isInitialRender = (0, $fc4bM.useRef)(true);
    const prefetchedPreferencesData = (0, $fc4bM.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $fc4bM.useState)((0, $dzMIZ.initializePreferencesData)(initialPreferences));
    (0, $fc4bM.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $dzMIZ.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $eGlBA.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $e0c8a6c80e4b1559$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.prefs,
        isPrefetchedPreferencesState: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $e0c8a6c80e4b1559$export$2e2bcd8739ae039 = $e0c8a6c80e4b1559$var$usePreferences;

});



parcelRegister("87rOb", function(module, exports) {
$parcel$export(module.exports, "default", () => $332a9580ce015b5c$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $332a9580ce015b5c$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    footer: {
        defaultMessage: 'Powered by {iconHtml} Jira Service Management',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.servicemanagement'
    },
    csmFooter: {
        defaultMessage: 'Powered by Jira Customer Service',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.atlassiancustomercollection.non-final'
    }
});

});

parcelRegister("ku1lj", function(module, exports) {
$parcel$export(module.exports, "footerPadding", () => $efac77196554e951$export$7d9aba7536a61853);
$parcel$export(module.exports, "footerJsdIconHeight", () => $efac77196554e951$export$220c44e1c3ab6f4);
$parcel$export(module.exports, "FOOTER_HEIGHT", () => $efac77196554e951$export$a2dd5f25b5a4e5d2);

var $fOCtI = parcelRequire("fOCtI");
const $efac77196554e951$export$7d9aba7536a61853 = $fOCtI.multiple(6).unitless;
const $efac77196554e951$export$220c44e1c3ab6f4 = $fOCtI.multiple(2.5).unitless;
const $efac77196554e951$export$a2dd5f25b5a4e5d2 = $efac77196554e951$export$7d9aba7536a61853 * 2 + $efac77196554e951$export$220c44e1c3ab6f4;

});



parcelRegister("6Pd4T", function(module, exports) {
$parcel$export(module.exports, "useIsCSMTypographyMigrationEnabled", () => $de8a8eee446f071d$export$f77c7e452595da18);
$parcel$export(module.exports, "UseTypographyMigratedComponent", () => $de8a8eee446f071d$export$527b88b630251664);

var $k2M4v = parcelRequire("k2M4v");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
const $de8a8eee446f071d$export$f77c7e452595da18 = (useWhiteListedRouteNamesCheck = false)=>{
    if (useWhiteListedRouteNamesCheck) return (0, $k2M4v.default).checkGate('enable_typography_token_migration_for_csm') && (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    return (0, $k2M4v.default).checkGate('enable_typography_token_migration_for_csm') && (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
};
const $de8a8eee446f071d$export$527b88b630251664 = (props)=>{
    const isCSMTypographyMigrationEnabled = $de8a8eee446f071d$export$f77c7e452595da18();
    return isCSMTypographyMigrationEnabled ? props.migratedComponent : props.children;
};

});



parcelRegister("esMAf", function(module, exports) {
$parcel$export(module.exports, "App", () => (parcelRequire("2607U")).default);

var $2607U = parcelRequire("2607U");

});
parcelRegister("2607U", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b66f49c5dab2396$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");

var $4N8Pa = parcelRequire("4N8Pa");

var $1dREW = parcelRequire("1dREW");
parcelRequire("6UkEX");
var $ixYp4 = parcelRequire("ixYp4");
parcelRequire("9T6l6");
var $cCqrh = parcelRequire("cCqrh");

var $b2D9t = parcelRequire("b2D9t");

var $7ZdBj = parcelRequire("7ZdBj");

var $5PQxp = parcelRequire("5PQxp");

var $eENmG = parcelRequire("eENmG");

var $cf3fd = parcelRequire("cf3fd");

var $cf3fd = parcelRequire("cf3fd");

var $2bGke = parcelRequire("2bGke");

var $7kSUA = parcelRequire("7kSUA");

var $fEfF7 = parcelRequire("fEfF7");

var $7lN8e = parcelRequire("7lN8e");

var $fc3Rm = parcelRequire("fc3Rm");

var $2WmjE = parcelRequire("2WmjE");
parcelRequire("6cjXx");
var $gW9CN = parcelRequire("gW9CN");

var $6Nd92 = parcelRequire("6Nd92");

var $isIRC = parcelRequire("isIRC");

var $dWW6g = parcelRequire("dWW6g");

var $hBWs0 = parcelRequire("hBWs0");

var $iMyUt = parcelRequire("iMyUt");

var $3D8fH = parcelRequire("3D8fH");

var $5LZ4m = parcelRequire("5LZ4m");
parcelRequire("4kdFG");
var $ehNa5 = parcelRequire("ehNa5");

var $3etYC = parcelRequire("3etYC");

var $ebrC6 = parcelRequire("ebrC6");
var $1b66f49c5dab2396$var$_window$JSD_CUSTOMER_;
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $1b66f49c5dab2396$var$BUILD_KEY = (($1b66f49c5dab2396$var$_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || $1b66f49c5dab2396$var$_window$JSD_CUSTOMER_ === void 0 ? void 0 : $1b66f49c5dab2396$var$_window$JSD_CUSTOMER_.buildKey) || 'local';
const $1b66f49c5dab2396$export$86fbec116b87613f = (props)=>{
    const { serviceDeskVersion: serviceDeskVersion } = props;
    const isHelpCentersManagementPath = (0, $cf3fd.isHelpCentersManagement)();
    const shouldUseCsmRouter = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) || (0, $cf3fd.isJcsOnlyRestrictedRoute)((0, $7lN8e.getEnv)().customerAccountAvailabilty);
    const shouldUseHubRouter = (0, $iMyUt.getHelpCenterRouteFamily)((0, $7lN8e.getEnv)().helpCenterType) === (0, $iMyUt.HUB_ROUTE_FAMILY);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    (0, $6Nd92.useUFOComponentExperience)((0, $hBWs0.helpCenterViewHomePageExperience));
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $cf3fd.getIsHelpHub)()) return (0, $4N8Pa.initializeRequestCreatePreviousLocationTracking)();
        return undefined;
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $fc3Rm.hasValidHelpCenterARI)()) {
                (0, $7kSUA.fireAnalyticsForEmptyHelpCenterAri)();
                const traceId = (0, $7lN8e.getEnv)().traceId ?? '';
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $hBWs0.helpCenterViewHomePageExperience).failure({
                    metadata: {
                        error: `Empty Help Center Ari, traceId: ${traceId}`
                    }
                });
            } else // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $hBWs0.helpCenterViewHomePageExperience).success();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $6LH8a.isValidLayoutAriPresent)()) (0, $fEfF7.fireAnalyticsForEmptyHelpCenterLayoutAri)();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    const analyticData = {
        version: serviceDeskVersion,
        application: 'jira-servicedesk',
        buildKey: $1b66f49c5dab2396$var$BUILD_KEY
    };
    const isAdvancedHelpCenterThemingEnabled = ((0, $cf3fd.isAdvancedHelpCenter)() || (0, $cf3fd.isDefaultHelpCenter)()) && (0, $hN5YJ.isCustomThemingEnabled)();
    const isCsmAccessControlSplitFgEnabled = (0, $hN5YJ.isCsmAccessControlSplitEnabled)();
    const getResourceRouter = $fc4bM.useCallback(()=>{
        if (shouldUseCsmRouter) {
            if (isCsmAccessControlSplitFgEnabled) return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $fc4bM.createElement((0, $isIRC.AppContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $dWW6g.CSMResourceRouterNew), null)) : /*#__PURE__*/ $fc4bM.createElement((0, $dWW6g.CSMResourceRouterNew), null);
            return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $fc4bM.createElement((0, $isIRC.AppContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $dWW6g.default), null)) : /*#__PURE__*/ $fc4bM.createElement((0, $dWW6g.default), null);
        }
        if (isHelpCentersManagementPath) return /*#__PURE__*/ $fc4bM.createElement((0, $3D8fH.default), null);
        if (shouldUseHubRouter) return /*#__PURE__*/ $fc4bM.createElement((0, $5LZ4m.default), null);
        return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $fc4bM.createElement((0, $isIRC.AppContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $3etYC.default), null)) : /*#__PURE__*/ $fc4bM.createElement((0, $3etYC.default), null);
    }, [
        shouldUseCsmRouter,
        isHelpCentersManagementPath,
        shouldUseHubRouter,
        isAdvancedHelpCenterThemingEnabled,
        isCsmAccessControlSplitFgEnabled
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $5PQxp.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
        attributes: analyticData
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2bGke.BrowserMetricsScreenTransitionStatusProvider), null, /*#__PURE__*/ $fc4bM.createElement((0, $ehNa5.SSRSafeJSMCookieConsentBanner), null), (0, $2WmjE.isBrowserUnsupported)() && /*#__PURE__*/ $fc4bM.createElement((0, $b2D9t.default), {
        appearance: "warning",
        icon: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))), {
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $ebrC6.default).unsupportedBrowser)), getResourceRouter(), /*#__PURE__*/ $fc4bM.createElement((0, $ixYp4.default), null), /*#__PURE__*/ $fc4bM.createElement((0, $1dREW.FeedbackCollector), null), /*#__PURE__*/ $fc4bM.createElement((0, $gW9CN.Heartbeat), null), /*#__PURE__*/ $fc4bM.createElement((0, $cCqrh.MarkAppMounted), null))));
};
const $1b66f49c5dab2396$var$selector = (0, $2n2bS.createSelector)((0, $fYLlE.getServiceDeskVersion), (serviceDeskVersion)=>({
        serviceDeskVersion: serviceDeskVersion
    }));
var $1b66f49c5dab2396$export$2e2bcd8739ae039 = (0, $6umft.default)($1b66f49c5dab2396$var$selector)($1b66f49c5dab2396$export$86fbec116b87613f);

});
parcelRegister("4N8Pa", function(module, exports) {
$parcel$export(module.exports, "initializeRequestCreatePreviousLocationTracking", () => $7bbe2b82e29510b5$export$815420257eb7d834);
$parcel$export(module.exports, "canNavigateBackFromRequestCreate", () => $7bbe2b82e29510b5$export$5c540869b5908f35);

var $diqlM = parcelRequire("diqlM");
let $7bbe2b82e29510b5$var$canNavigateBack = false;
// Modern Help Center request create forms use the direct path, for example */portal/1/create/2
function $7bbe2b82e29510b5$var$isRequestCreateLocation(location) {
    return /^\/portal\/\d+\/create\/[^/]+\/?$/.test(location.pathname);
}
const $7bbe2b82e29510b5$export$815420257eb7d834 = ()=>{
    let currentLocation = (0, $diqlM.default).location;
    const unlisten = (0, $diqlM.default).listen((nextLocation, action)=>{
        $7bbe2b82e29510b5$var$canNavigateBack = action === 'PUSH' && $7bbe2b82e29510b5$var$isRequestCreateLocation(nextLocation) && !$7bbe2b82e29510b5$var$isRequestCreateLocation(currentLocation);
        currentLocation = nextLocation;
    });
    return ()=>{
        $7bbe2b82e29510b5$var$canNavigateBack = false;
        unlisten();
    };
};
const $7bbe2b82e29510b5$export$5c540869b5908f35 = ()=>$7bbe2b82e29510b5$var$canNavigateBack;

});

parcelRegister("1dREW", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollector", () => $046cf722b515016a$export$fa63c8dd87ea8148);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $046cf722b515016a$export$fa63c8dd87ea8148 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("g8NId")), {
        moduleId: "./src/view/common/feedback-collector/hocs.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("bQkfB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2156a20b2cd8ac$export$2e2bcd8739ae039);

var $ghdGx = parcelRequire("ghdGx");
/**
 * This will generically handle async loading of components with a
 * loading, timeout, and errored states. If you need more specific
 * handling use react-loosely-lazy directly.
 *
 * Use the preload option if you want the component to start loading
 * immediately.
 */ const $fa2156a20b2cd8ac$var$withAsync = (options)=>{
    const LoadableComponent = (0, $ghdGx.default)({
        loader: options.loader,
        LoadingSkeleton: options.LoadingSkeleton,
        loadingPosition: options.loadingPosition,
        timeout: 5000
    });
    if (options.preload) LoadableComponent.preload();
    return LoadableComponent;
};
var $fa2156a20b2cd8ac$export$2e2bcd8739ae039 = $fa2156a20b2cd8ac$var$withAsync;

});
parcelRegister("ghdGx", function(module, exports) {
$parcel$export(module.exports, "default", () => $e268eaf15cdfe3b8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("ieUrC");
var $euVUr = parcelRequire("euVUr");

var $1QSxn = parcelRequire("1QSxn");
var $nNBrf = parcelRequire("nNBrf");
var $aRlKY = parcelRequire("aRlKY");
const $e268eaf15cdfe3b8$var$LooselyLoadableWrapper = (options)=>{
    const Component = options.loader;
    const LazyComponent = (props)=>{
        const renderError = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aRlKY.LoadingComponent), {
                error: error,
                LoadingSkeleton: options.LoadingSkeleton
            });
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1QSxn.ErrorBoundaryAnalytics), {
            renderError: renderError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nNBrf.Fallback), options)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props)));
    };
    LazyComponent.preload = options.loader.preload;
    return LazyComponent;
};
var $e268eaf15cdfe3b8$export$2e2bcd8739ae039 = $e268eaf15cdfe3b8$var$LooselyLoadableWrapper;

});
parcelRegister("1QSxn", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryAnalytics", () => $e91d63ec2410bb50$export$627f773fbbb39e);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");
class $e91d63ec2410bb50$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        if (error.name !== 'ChunkLoadError') {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent !== undefined) {
                // This analytics will help us to note any errors which were previously marked as chunk errors. This might get triggered multiple times if islooselyLazyJsErrorsToSentryEnabled is true.
                const analyticsEvent = createAnalyticsEvent({
                    analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                    action: 'failed',
                    errorMessage: error.message,
                    errorName: error.name,
                    stack: error.stack
                });
                const finalId = 'looselyLazyErrorBoundary';
                const finalPackage = 'looselyLazyPackage';
                const actionSubject = `${finalPackage}.${finalId}`;
                analyticsEvent.context.push({
                    componentName: actionSubject
                });
                analyticsEvent.fire();
            }
        }
        if ((0, $hN5YJ.islooselyLazyJsErrorsToSentryEnabled)()) {
            // Differentiate between a chunkLoadError and other JS error.
            if (error.name === 'ChunkLoadError') {
                var _this$props$onError, _this$props;
                (0, $aIVqJ.trackError)('async.loader.failed', {}, error);
                (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props, error);
            } else {
                var _this$props$onError2, _this$props2;
                (_this$props$onError2 = (_this$props2 = this.props).onError) === null || _this$props$onError2 === void 0 || _this$props$onError2.call(_this$props2, error);
                // this error will be caught by ScreenErrorBoundary at route level which will add it to sentry with packageName derived from route ScreenName
                throw error;
            }
        } else {
            var _this$props$onError3, _this$props3;
            (0, $aIVqJ.trackError)('async.loader.failed', {}, error);
            (_this$props$onError3 = (_this$props3 = this.props).onError) === null || _this$props$onError3 === void 0 || _this$props$onError3.call(_this$props3, error);
        }
    }
    render() {
        const error = this.state.error;
        return error ? this.props.renderError(error) : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
const $e91d63ec2410bb50$export$627f773fbbb39e = (0, $613oU.default)()((0, $azARG.default)()($e91d63ec2410bb50$var$ErrorBoundary));

});

parcelRegister("nNBrf", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $cde57c6b554a90b5$export$fb8d7f40caaeea67);

var $fc4bM = parcelRequire("fc4bM");

var $d7r8x = parcelRequire("d7r8x");

var $aRlKY = parcelRequire("aRlKY");
const $cde57c6b554a90b5$export$fb8d7f40caaeea67 = (options)=>{
    let displayName = 'unknown';
    if ('loader' in options) displayName = options.loader.displayName || 'unknown';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aRlKY.LoadingComponent), {
        LoadingSkeleton: options.LoadingSkeleton,
        timeout: options.timeout
    }));
};

});
parcelRegister("d7r8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $e18bef51ab642807$export$2e2bcd8739ae039);

var $eYui3 = parcelRequire("eYui3");
var $e18bef51ab642807$export$2e2bcd8739ae039 = (0, $eYui3.default);

});
parcelRegister("eYui3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fac13431670f85e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $5hPkM = parcelRequire("5hPkM");

var $9UyEJ = parcelRequire("9UyEJ");

var $8o5rd = parcelRequire("8o5rd");

var $clVtP = parcelRequire("clVtP");
const $9fac13431670f85e$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $9fac13431670f85e$var$useInteractionIdValue() {
    const interactionId = (0, $fc4bM.useContext)((0, $8o5rd.default));
    const [currentId, setCurrentId] = (0, $fc4bM.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
    $9fac13431670f85e$var$useLayoutEffectSAFE(()=>{
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        const unsubscribe = (0, $clVtP.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $9fac13431670f85e$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $5hPkM.isUFOEnabled)();
    const currentInteractionId = $9fac13431670f85e$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $fc4bM.useContext)((0, $9UyEJ.default));
    $9fac13431670f85e$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children) : null;
}

});


parcelRegister("aRlKY", function(module, exports) {
$parcel$export(module.exports, "LoadingComponent", () => $f73c30b4bfa49c37$export$7db30d367db7d20a);

var $fc4bM = parcelRequire("fc4bM");

var $aUHFa = parcelRequire("aUHFa");
const $f73c30b4bfa49c37$export$7db30d367db7d20a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(function LoadingComponent({ error: error, LoadingSkeleton: LoadingSkeleton, timeout: timeout, loadingPosition: loadingPosition }) {
    const [isTimedOut, setIsTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        let timer;
        if (timeout) timer = setTimeout(()=>{
            setIsTimedOut(true);
        }, timeout);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        timeout
    ]);
    if (LoadingSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(LoadingSkeleton, {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aUHFa.default), {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition,
        timedOut: isTimedOut
    });
});

});
parcelRegister("aUHFa", function(module, exports) {
$parcel$export(module.exports, "ChunkLoadErrorMessage", () => $0d2d60f913a31388$export$7bbd51879bbec526);
$parcel$export(module.exports, "SkeletonLoadingWrapper", () => $0d2d60f913a31388$export$48d1937c6c46b883);
$parcel$export(module.exports, "default", () => $0d2d60f913a31388$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $9mazR = parcelRequire("9mazR");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $fd880 = parcelRequire("fd880");

var $gDsF8 = parcelRequire("gDsF8");

var $hculA = parcelRequire("hculA");

var $2aaQG = parcelRequire("2aaQG");

var $8PITw = parcelRequire("8PITw");
const $0d2d60f913a31388$var$ICON_SIZE = $fOCtI.multiple(6);
const $0d2d60f913a31388$export$7bbd51879bbec526 = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: "",
        size: "medium",
        spacing: "spacious"
    }), /*#__PURE__*/ $fc4bM.createElement($0d2d60f913a31388$var$Message, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2aaQG.default).error)));
};
const $0d2d60f913a31388$export$fead96407cda089b = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-11ukfs2-0"
})`margin-top:${"var(--ds-space-025, 2px)"};`;
const $0d2d60f913a31388$export$48d1937c6c46b883 = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $fc4bM.createElement($0d2d60f913a31388$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $8PITw.LoadingSkeletonFields), null), props.timedOut && /*#__PURE__*/ $fc4bM.createElement($0d2d60f913a31388$var$Message, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2aaQG.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $8PITw.AbsoluteFillContainer) : $0d2d60f913a31388$var$Container;
    return /*#__PURE__*/ $fc4bM.createElement($0d2d60f913a31388$export$fead96407cda089b, null, /*#__PURE__*/ $fc4bM.createElement(Wrapper, null, content));
};
const $0d2d60f913a31388$var$Loading = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $fc4bM.createElement($0d2d60f913a31388$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $hculA.default), {
        interactionName: props.interactionName || 'help-center-unknown-loader',
        delay: (0, $9mazR.SPINNER_DELAY),
        appearance: "inherit",
        size: $0d2d60f913a31388$var$ICON_SIZE.unitless
    }), props.timedOut && /*#__PURE__*/ $fc4bM.createElement($0d2d60f913a31388$var$Message, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2aaQG.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $8PITw.AbsoluteFillContainer) : $0d2d60f913a31388$var$Container;
    return /*#__PURE__*/ $fc4bM.createElement(Wrapper, {
        "data-testid": "loading-container"
    }, content);
};
var $0d2d60f913a31388$export$2e2bcd8739ae039 = $0d2d60f913a31388$var$Loading;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0d2d60f913a31388$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-11ukfs2-1"
})`${$3DjOo.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0d2d60f913a31388$var$Message = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-11ukfs2-2"
})`${$imLe4.small};margin-top:${"var(--ds-space-100, 8px)"};`;

});
parcelRegister("2aaQG", function(module, exports) {
$parcel$export(module.exports, "default", () => $545bbbd4b520e2f3$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $545bbbd4b520e2f3$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    error: {
        defaultMessage: 'There was a problem loading, please refresh and try again.',
        description: 'Error message shown when something could not be loaded.',
        id: 'cv.loading.component.error'
    },
    timeout: {
        defaultMessage: 'Taking longer than usual...',
        description: 'Message shown when loading is taking a long time.',
        id: 'cv.loading.component.timeout'
    }
});

});

parcelRegister("8PITw", function(module, exports) {
$parcel$export(module.exports, "AbsoluteFillContainer", () => $c70468016ce3fbea$export$c55b13eeae4b9470);
$parcel$export(module.exports, "LoadingSkeleton", () => $c70468016ce3fbea$export$44c18d210d5de37b);
$parcel$export(module.exports, "FieldLoadingSkeleton", () => $c70468016ce3fbea$export$e2529b450e72f74e);
$parcel$export(module.exports, "AvatarLoadingSkeleton", () => $c70468016ce3fbea$export$281e083a77da722c);
$parcel$export(module.exports, "LoadingSkeletonFields", () => $c70468016ce3fbea$export$1844a556d867ecb4);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $aYMdQ = parcelRequire("aYMdQ");
const $c70468016ce3fbea$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ovlcu-0"
})`${$3DjOo.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
const $c70468016ce3fbea$export$c55b13eeae4b9470 = /*#__PURE__*/ (0, $luz1X.default)($c70468016ce3fbea$export$42a852a2b6b56249).withConfig({
    componentId: "sc-3ovlcu-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;`;
const $c70468016ce3fbea$var$fromPositionX = -400;
const $c70468016ce3fbea$var$toPositionX = 800;
const $c70468016ce3fbea$var$shimmer = /*#__PURE__*/ (0, $luz1X.keyframes)({
    '0%': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        backgroundPosition: `${$c70468016ce3fbea$var$fromPositionX}px 0`
    },
    '100%': {
        backgroundPosition: `${$c70468016ce3fbea$var$toPositionX}px 0`
    }
});
const $c70468016ce3fbea$export$44c18d210d5de37b = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ovlcu-2"
})`${$3DjOo.borderRadius};height:${(props)=>`${props.height}px`};background-color:${(props)=>props.backgroundColor};background-image:linear-gradient( to right,${(props)=>props.backgroundColor} 10%,${"var(--ds-surface, #FFFFFF)"} 40%,${(props)=>props.backgroundColor} 50% );background-repeat:no-repeat;animation-duration:0.8s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$c70468016ce3fbea$var$shimmer};animation-timing-function:ease-in;`;
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c70468016ce3fbea$var$FieldSkeletonWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ovlcu-3"
})`${$3DjOo.borderRadius};border:${"var(--ds-border-width-selected, 2px)"} solid;border-color:${"var(--ds-border, #DFE1E6)"};`;
const $c70468016ce3fbea$export$e2529b450e72f74e = ()=>/*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$var$FieldSkeletonWrapper, null, /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$44c18d210d5de37b, {
        height: 150,
        backgroundColor: "var(--ds-skeleton-subtle, #FAFBFC)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c70468016ce3fbea$var$AvatarSkeletonWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ovlcu-4"
})`min-width:${$fOCtI.multiple(4.5).px};border-radius:50%;overflow:hidden;`;
const $c70468016ce3fbea$export$281e083a77da722c = ()=>/*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$var$AvatarSkeletonWrapper, null, /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$44c18d210d5de37b, {
        height: 36,
        backgroundColor: "var(--ds-skeleton, #EBECF0)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c70468016ce3fbea$var$TextFieldLoadingSkeletonWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ovlcu-5"
})`margin-top:${"var(--ds-space-500, 40px)"};margin-bottom:${"var(--ds-space-500, 40px)"};`;
const $c70468016ce3fbea$export$66b8cea0c448285 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ovlcu-6"
})`width:100%;`;
const $c70468016ce3fbea$export$37ec45a296aa56b5 = ({ shortText: shortText })=>{
    return /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$var$TextFieldLoadingSkeletonWrapper, null, /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$44c18d210d5de37b, {
        height: shortText ? $fOCtI.multiple(5).unitless : $fOCtI.multiple(22).unitless,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    }));
};
const $c70468016ce3fbea$export$1844a556d867ecb4 = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$66b8cea0c448285, null, (0, $aYMdQ.range)(3).map((ndx)=>/*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$37ec45a296aa56b5, {
            key: ndx,
            shortText: true
        })), /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$37ec45a296aa56b5, {
        shortText: false
    }), /*#__PURE__*/ $fc4bM.createElement($c70468016ce3fbea$export$37ec45a296aa56b5, {
        shortText: true
    })));
};

});






parcelRegister("g8NId", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1ne6N"),
    $9dnsd("1i8q5")
]).then(()=>parcelRequire('ckdYw'));

});


parcelRegister("9T6l6", function(module, exports) {
$parcel$export(module.exports, "MarkAppMounted", () => (parcelRequire("cCqrh")).MarkAppMounted);
$parcel$export(module.exports, "isAppMounted", () => (parcelRequire("cCqrh")).isAppMounted);

var $cCqrh = parcelRequire("cCqrh");

});
parcelRegister("cCqrh", function(module, exports) {
$parcel$export(module.exports, "isAppMounted", () => $7f81f2227ec483c4$export$495d224993f5c3c8);
$parcel$export(module.exports, "MarkAppMounted", () => $7f81f2227ec483c4$export$2525a7fc0773bc4d);

var $fc4bM = parcelRequire("fc4bM");
let $7f81f2227ec483c4$var$isMounted = false;
function $7f81f2227ec483c4$var$setIsMounted(value) {
    $7f81f2227ec483c4$var$isMounted = value;
}
const $7f81f2227ec483c4$export$495d224993f5c3c8 = {
    /** Readonly value and is set only from MarkAppMounted */ get value () {
        return $7f81f2227ec483c4$var$isMounted;
    }
};
const $7f81f2227ec483c4$export$2525a7fc0773bc4d = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        $7f81f2227ec483c4$var$setIsMounted(true);
    }, []);
    return null;
};

});


parcelRegister("b2D9t", function(module, exports) {
$parcel$export(module.exports, "default", () => $658c9f49267499b5$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");
const $658c9f49267499b5$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $658c9f49267499b5$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $658c9f49267499b5$var$textStyles = {
    root: "_11c8fhey _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $658c9f49267499b5$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $658c9f49267499b5$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $658c9f49267499b5$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $658c9f49267499b5$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $658c9f49267499b5$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $658c9f49267499b5$var$Banner = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $658c9f49267499b5$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $658c9f49267499b5$var$containerStyles.root,
        backgroundColor: $658c9f49267499b5$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $658c9f49267499b5$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    as: "span",
                    xcss: $658c9f49267499b5$var$iconWrapperStyles.root,
                    style: {
                        fill: $658c9f49267499b5$var$tokenBackgroundColors[appearanceType],
                        color: $658c9f49267499b5$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    style: {
                        [$658c9f49267499b5$var$CSS_VAR_TEXT_COLOR]: $658c9f49267499b5$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $2R2iS.default)([
                        $658c9f49267499b5$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $658c9f49267499b5$export$2e2bcd8739ae039 = $658c9f49267499b5$var$Banner;

});

parcelRegister("5PQxp", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $5e5b315d2598b353$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightConsumer", () => $5e5b315d2598b353$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $5e5b315d2598b353$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");

var $9JZL9 = parcelRequire("9JZL9");

var $iXBtU = parcelRequire("iXBtU");

var $4CgiI = parcelRequire("4CgiI");

var $cufVT = parcelRequire("cufVT");

var $eicwU = parcelRequire("eicwU");

var $3jCFs = parcelRequire("3jCFs");
const $5e5b315d2598b353$var$dest = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $5e5b315d2598b353$export$f643dd64c1952cc8 = $5e5b315d2598b353$var$dest.Consumer;
const $5e5b315d2598b353$var$TargetProvider = $5e5b315d2598b353$var$dest.Provider;
const $5e5b315d2598b353$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $fc4bM.createContext)({
    opened: (0, $9JZL9.default),
    closed: (0, $9JZL9.default),
    targets: {}
});
const $5e5b315d2598b353$export$3503199acd121708 = $5e5b315d2598b353$export$7b5aa0f5b37a336d.Consumer;
const $5e5b315d2598b353$var$SpotlightStateProvider = $5e5b315d2598b353$export$7b5aa0f5b37a336d.Provider;
const $5e5b315d2598b353$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Wrapper, null, children);
class $5e5b315d2598b353$export$2e2bcd8739ae039 extends (0, $fc4bM.PureComponent) {
    static #_ = this.defaultProps = {
        blanketIsTinted: true
    };
    componentDidMount() {
        typeof $3jCFs;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5e5b315d2598b353$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5e5b315d2598b353$var$TargetProvider, {
            value: this.getTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5e5b315d2598b353$var$Container, {
            component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iXBtU.default), null, isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4CgiI.default), {
            duration: "medium"
        }, ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cufVT.default), {
                zIndex: 700
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eicwU.default), {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                style: style,
                isTinted: blanketIsTinted,
                onBlanketClicked: onBlanketClicked
            })))), children)));
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
   * When enabling React Streaming in Confluence, a
   * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
   * error happens.
   * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
   */ this.getTargetRef = (name)=>(element)=>{
                (0, $fc4bM.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $jiju3.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("eicwU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1cfda0217715eb5$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $f1cfda0217715eb5$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $f1cfda0217715eb5$var$Blanket = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $f1cfda0217715eb5$export$2e2bcd8739ae039 = $f1cfda0217715eb5$var$Blanket;

});


parcelRegister("2bGke", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusContext", () => $a1bc431ba7580182$export$2b9bf691adcf6b30);
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusProvider", () => $a1bc431ba7580182$export$71210ed9cdfad1f5);
$parcel$export(module.exports, "default", () => $a1bc431ba7580182$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aZfc9 = parcelRequire("aZfc9");

var $jgb8T = parcelRequire("jgb8T");
const $a1bc431ba7580182$export$2b9bf691adcf6b30 = /*#__PURE__*/ $fc4bM.createContext({
    preventBrowserMetricsTimerResetOnScreenMount: false,
    startBrowserMetricsTransitionToNewScreen: ()=>undefined,
    stopBrowserMetricsTransitionToNewScreen: ()=>undefined
});
class $a1bc431ba7580182$export$71210ed9cdfad1f5 extends $fc4bM.Component {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement($a1bc431ba7580182$export$2b9bf691adcf6b30.Provider, {
            value: {
                preventBrowserMetricsTimerResetOnScreenMount: this.state.preventBrowserMetricsTimerResetOnScreenMount,
                startBrowserMetricsTransitionToNewScreen: this.startTransitionToNewScreen,
                stopBrowserMetricsTransitionToNewScreen: this.stopTransitionToNewScreen
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            preventBrowserMetricsTimerResetOnScreenMount: false
        }, /**
   * Explicitly start the browsermetrics timer,
   * and set state that will prevent the timer from being reset when we eventually transition to the new screen.
   */ this.startTransitionToNewScreen = (screenName)=>{
            (0, $jgb8T.devLog)('Browser metrics: starting timer for new screen before transition:', screenName);
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: true
            });
            /**
     * Browser metrics v3 start page load
     */ (0, $aZfc9.startPageLoad)(screenName);
        }, /**
   * Stop measuring any transition that may have been started.
   * This must be called any time the transition does not go ahead, e.g. if there are errors in a form submission
   * This will also be called any time an AnalyticsScreen component is mounted,
   * so you won't need to call this yourself if the transition is successful
   */ this.stopTransitionToNewScreen = ()=>{
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: false
            });
        };
    }
}
const $a1bc431ba7580182$var$withBrowserMetricsScreenTransitionStatus = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $fc4bM.createElement($a1bc431ba7580182$export$2b9bf691adcf6b30.Consumer, null, (value)=>/*#__PURE__*/ $fc4bM.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $a1bc431ba7580182$export$2e2bcd8739ae039 = $a1bc431ba7580182$var$withBrowserMetricsScreenTransitionStatus;

});

parcelRegister("7kSUA", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterAri", () => $465507130865ea72$export$ac08ed49e9190090);

var $4MjGQ = parcelRequire("4MjGQ");

var $7lN8e = parcelRequire("7lN8e");
const $465507130865ea72$export$ac08ed49e9190090 = ()=>{
    const traceId = (0, $7lN8e.getEnv)().traceId;
    (0, $4MjGQ.operationalEvent)({
        action: 'emptyHelpCenterAriReceived',
        actionSubject: 'help-center-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("fEfF7", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterLayoutAri", () => $62677d56d5754011$export$c36b085b938f36b6);

var $4MjGQ = parcelRequire("4MjGQ");

var $7lN8e = parcelRequire("7lN8e");
const $62677d56d5754011$export$c36b085b938f36b6 = ()=>{
    const traceId = (0, $7lN8e.getEnv)().traceId;
    (0, $4MjGQ.operationalEvent)({
        action: 'emptyHelpCenterLayoutAriReceived',
        actionSubject: 'help-center-layout-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("fc3Rm", function(module, exports) {
$parcel$export(module.exports, "hasValidHelpCenterARI", () => $948bb02dfed39dbd$export$a15bc0aef789ec4c);

var $6LH8a = parcelRequire("6LH8a");
const $948bb02dfed39dbd$var$EMPTY_VALUES_LIST = [
    'undefined',
    'null'
];
const $948bb02dfed39dbd$export$a15bc0aef789ec4c = ()=>{
    const helpCenterAri = (0, $6LH8a.getHelpCenterAri)();
    return Boolean(helpCenterAri) && !$948bb02dfed39dbd$var$EMPTY_VALUES_LIST.includes(helpCenterAri);
};

});

parcelRegister("2WmjE", function(module, exports) {
$parcel$export(module.exports, "isBrowserUnsupported", () => $7f9504216e06c4f0$export$dfffa53722e06033);
$parcel$export(module.exports, "isOldSafari", () => $7f9504216e06c4f0$export$572d6d0be4ae9ec5);
$parcel$export(module.exports, "isIE7", () => $7f9504216e06c4f0$export$e7ef7234dd9b1f65);
/**
 * Unsupported browsers regex generated using command -
 * npx browserslist-useragent-regexp "Firefox 60 , Firefox 61, Firefox 68, Firefox 72, Safari 12, Safari 15, iOS 12, iOS 15".
 * All unsupported browser versions can be viewed on https://browserslist.dev/, using above query.
 * These browser versions do not support Intersection Observer API.
 * Safari > 12.0 and iOS > 12.1 supports this API but does not support "options.root" parameter to be a Document
 * */ const $7f9504216e06c4f0$export$67d4cb90585439f7 = new RegExp(/Firefox\/(6[01]\.0|68\.0|72\.0)(\.\d+|)|Maci.+ Version\/(12\.0|15\.0)([,.]\d+|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(12[._][01]|15[._][01])([._]\d+|)/);
const $7f9504216e06c4f0$export$dfffa53722e06033 = (regex = $7f9504216e06c4f0$export$67d4cb90585439f7)=>{
    if (!(navigator && navigator.userAgent)) return true;
    if (regex && regex.test) return regex.test(navigator.userAgent);
    return false;
};
function $7f9504216e06c4f0$export$572d6d0be4ae9ec5() {
    const userAgentString = navigator.userAgent;
    const safariAgent = userAgentString.indexOf('Safari') > -1;
    // If the current browser is Safari
    if (safariAgent) {
        var _userAgentString$spli;
        const safariVersion = parseInt((_userAgentString$spli = userAgentString.split('Version/')) === null || _userAgentString$spli === void 0 || (_userAgentString$spli = _userAgentString$spli[1]) === null || _userAgentString$spli === void 0 ? void 0 : _userAgentString$spli.split(' Safari')[0], 10);
        // If the Safari version is less than 14
        if (safariVersion < 14) return true;
    }
    return false;
}
function $7f9504216e06c4f0$export$e7ef7234dd9b1f65() {
    const userAgentString = navigator.userAgent;
    const msieAgent = userAgentString.indexOf('MSIE') > -1;
    // If the current browser is Internet Explorer
    if (msieAgent) {
        const ieVersion = parseInt(userAgentString.split('MSIE ')[1].split(';')[0], 10);
        // If the IE version is 7
        if (ieVersion === 7) return true;
    }
    return false;
}

});

parcelRegister("6cjXx", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => (parcelRequire("gW9CN")).Heartbeat);

var $gW9CN = parcelRequire("gW9CN");

});
parcelRegister("gW9CN", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => $866d443c44b51932$export$38f39b921d5551c1);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $3BiGe = parcelRequire("3BiGe");

var $5DhmT = parcelRequire("5DhmT");
const $866d443c44b51932$export$b5257641a9b528be = ()=>{
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments.includes('login')) return;
    if (pathSegments.includes('helpcenter-management')) {
        window.location.href = `/servicedesk/customer/user/login`;
        return;
    }
    const path = window.location.pathname + window.location.search;
    const match = path.match(/\/portal\/(\d+)/);
    const portalId = match ? Number(match[1]) : undefined;
    const basePath = pathSegments.slice(0, 2).join('/');
    const loginBasePath = portalId ? `/${basePath}/portal/${portalId}/user/login` : `/${basePath}/user/login`;
    const destination = pathSegments.slice(2).join('/');
    window.location.href = `${loginBasePath}?destination=${encodeURIComponent(destination + window.location.search)}`;
};
const $866d443c44b51932$export$461970fb9101e674 = ({ isLoggedIn: isLoggedIn })=>{
    return isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5DhmT.AsyncHeartbeat), {
        idleTime: 1200000,
        onAuthenticationFailed: $866d443c44b51932$export$b5257641a9b528be
    }) : null;
};
const $866d443c44b51932$export$38f39b921d5551c1 = (0, $6umft.default)((state)=>{
    return {
        isLoggedIn: (0, $3BiGe.isLoggedIn)(state)
    };
})($866d443c44b51932$export$461970fb9101e674);

});
parcelRegister("3BiGe", function(module, exports) {
$parcel$export(module.exports, "getAccountId", () => $8eb058cf61d7f579$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getEmail", () => $8eb058cf61d7f579$export$d29968a6889079e0);
$parcel$export(module.exports, "getDisplayName", () => $8eb058cf61d7f579$export$be63e0664592e141);
$parcel$export(module.exports, "isLoggedIn", () => $8eb058cf61d7f579$export$256a5a3564694cfc);
$parcel$export(module.exports, "getLocale", () => $8eb058cf61d7f579$export$180605366c04f0cd);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $8eb058cf61d7f579$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $8eb058cf61d7f579$export$c5f994129d97ed23);
$parcel$export(module.exports, "getCustomMenuLinks", () => $8eb058cf61d7f579$export$bf9a934424e2dbf1);
$parcel$export(module.exports, "getAvatarSrc", () => $8eb058cf61d7f579$export$35125d98e6f1484);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => $8eb058cf61d7f579$export$9055c338585b9def);
const $8eb058cf61d7f579$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $8eb058cf61d7f579$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $8eb058cf61d7f579$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName || state.persisted.user.email || '';
};
const $8eb058cf61d7f579$export$256a5a3564694cfc = (state)=>{
    return state.persisted.user.isLoggedIn;
};
const $8eb058cf61d7f579$export$180605366c04f0cd = (state)=>{
    return state.persisted.user.language.key;
};
const $8eb058cf61d7f579$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $8eb058cf61d7f579$export$c5f994129d97ed23 = (state)=>{
    var _state$persisted$user;
    return ((_state$persisted$user = state.persisted.user) === null || _state$persisted$user === void 0 ? void 0 : _state$persisted$user.hasSiteAdministerAccess) || false;
};
const $8eb058cf61d7f579$export$bf9a934424e2dbf1 = (state)=>{
    return state.persisted.user.customMenuLinks;
};
const $8eb058cf61d7f579$export$35125d98e6f1484 = (state)=>{
    var _state$persisted$user2;
    return (_state$persisted$user2 = state.persisted.user.avatars) === null || _state$persisted$user2 === void 0 ? void 0 : _state$persisted$user2.xlarge;
};
const $8eb058cf61d7f579$export$9055c338585b9def = (state)=>{
    return state.persisted.user.atlassianAccountManaged;
};

});

parcelRegister("5DhmT", function(module, exports) {
$parcel$export(module.exports, "AsyncHeartbeat", () => $67bfcb683a422d3c$export$503c0e70c2bcbfc7);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $67bfcb683a422d3c$export$503c0e70c2bcbfc7 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("cBezn")), {
        moduleId: "../platform/packages/security/heartbeat/src/index.ts"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("cBezn", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("g5HEU").then(()=>parcelRequire('ej5sZ'));

});




parcelRegister("isIRC", function(module, exports) {
$parcel$export(module.exports, "AppContainer", () => $d287d7ddf7a5159b$export$7469f2cda7546515);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $d287d7ddf7a5159b$export$7469f2cda7546515 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("6xrRz")), {
        moduleId: "./src/view/app-container/app-container.tsx"
    })
});

});
parcelRegister("6xrRz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("2i8w7").then(()=>parcelRequire('4OMZH'));

});


parcelRegister("dWW6g", function(module, exports) {
$parcel$export(module.exports, "CSMResourceRouterNew", () => $f50f1278810099ef$export$a487b0571b6a921a);
$parcel$export(module.exports, "default", () => $f50f1278810099ef$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $luz1X = parcelRequire("luz1X");

var $hN5YJ = parcelRequire("hN5YJ");

var $2p58l = parcelRequire("2p58l");

var $gxSIz = parcelRequire("gxSIz");

parcelRequire("a3Wd7");
var $3iZvk = parcelRequire("3iZvk");
var $2drpp = parcelRequire("2drpp");

var $4MFtS = parcelRequire("4MFtS");

var $iidRB = parcelRequire("iidRB");

var $fQ6nv = parcelRequire("fQ6nv");

var $8Nv7y = parcelRequire("8Nv7y");

var $5u1WA = parcelRequire("5u1WA");

var $5OVHl = parcelRequire("5OVHl");

var $h3GiS = parcelRequire("h3GiS");

var $eZNbv = parcelRequire("eZNbv");

var $6MlVB = parcelRequire("6MlVB");

var $21XEi = parcelRequire("21XEi");

var $fU9IO = parcelRequire("fU9IO");

var $ciXwj = parcelRequire("ciXwj");

var $fHOft = parcelRequire("fHOft");

var $1NjiO = parcelRequire("1NjiO");

var $eKYgj = parcelRequire("eKYgj");

var $icz03 = parcelRequire("icz03");

var $4WfeP = parcelRequire("4WfeP");

var $d9md5 = parcelRequire("d9md5");

var $kM3gF = parcelRequire("kM3gF");

var $gp1kG = parcelRequire("gp1kG");

var $8cc0X = parcelRequire("8cc0X");

var $9fFmP = parcelRequire("9fFmP");

var $bT4AH = parcelRequire("bT4AH");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $jB96H = parcelRequire("jB96H");
parcelRequire("fQ7Me");
var $5J3cB = parcelRequire("5J3cB");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $iDxNX = parcelRequire("iDxNX");

var $3etYC = parcelRequire("3etYC");

var $aWLgo = parcelRequire("aWLgo");
parcelRequire("5sUPt");
var $dTc6i = parcelRequire("dTc6i");
var $173qD = parcelRequire("173qD");
// Helper function to determine which requests list route to use
const $f50f1278810099ef$var$getRequestsListRoute = ()=>{
    const isHubsEnabled = (0, $hN5YJ.isHubsEnabledInHelpCenter)();
    if (isHubsEnabled) return (0, $5J3cB.getCsmRequestsListRouteWithHubShell)();
    return 0, $6MlVB.csmRequestsListRoute;
};
const $f50f1278810099ef$var$getCustomPageRoutes = ()=>{
    return (0, $7lN8e.getIsHCCustomizationEnabled)() ? [
        (0, $fU9IO.getEditCustomPageRoute)(),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getHubCustompageRoute)() : (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $5OVHl.getViewCustomPageRoute)())
    ] : [];
};
const $f50f1278810099ef$var$getAnonymousRoutes = ()=>{
    return [
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getLoginRouteWithHubShell)() : (0, $icz03.loginRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getResetPasswordRouteWithHubShell)() : (0, $8cc0X.userResetPasswordRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getSignupRouteWithHubShell)() : (0, $8cc0X.userSignupRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCompleteSignupRouteWithHubShell)() : (0, $8cc0X.userCompleteSignupRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCheckEmailRouteWithHubShell)() : (0, $8cc0X.userCheckMailRoute)
    ];
};
const $f50f1278810099ef$var$getActiveCsmRoutes = ()=>{
    return {
        activeViewArticleRoute: (0, $eZNbv.csmViewArticleRoute),
        activeKbPageRoute: (0, $eZNbv.csmViewKbPageRoute),
        activeCrossSiteArticleRoute: (0, $eZNbv.csmViewCrossSiteArticleRoute),
        activeUserProfileRoute: (0, $21XEi.csmUserProfileRoute)
    };
};
const $f50f1278810099ef$var$getAccessAndAuthenticationRoutes = ()=>{
    return [
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getPortalAccessForbiddenRouteWithHubShell)() : (0, $4WfeP.portalAccessForbiddenRoute),
        (0, $icz03.portalLoginRoute),
        (0, $8cc0X.portalSignupRoute),
        (0, $8cc0X.portalResetPasswordRoute),
        (0, $8cc0X.portalCompleteSignupRoute),
        (0, $8cc0X.portalInvitedSignupRoute)
    ];
};
const $f50f1278810099ef$var$getUserProfileRoute = ()=>{
    const { activeUserProfileRoute: activeUserProfileRoute } = $f50f1278810099ef$var$getActiveCsmRoutes();
    return (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmUserProfileRouteWithHubShell)() : activeUserProfileRoute);
};
const $f50f1278810099ef$var$getSearchAndArticleRoutes = ()=>{
    const { activeViewArticleRoute: activeViewArticleRoute, activeKbPageRoute: activeKbPageRoute, activeCrossSiteArticleRoute: activeCrossSiteArticleRoute } = $f50f1278810099ef$var$getActiveCsmRoutes();
    return [
        (0, $iDxNX.routeWithAiWidgetConfigResource)(activeKbPageRoute),
        (0, $eKYgj.viewAllSearchResultsRoute),
        (0, $eKYgj.viewPortalAllSearchResultsRoute),
        (0, $eKYgj.viewPortalCategoryArticleRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmViewPortalArticleRouteWithHubShell)() : (0, $eKYgj.viewPortalArticleRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmViewCrossSitePortalArticleRouteWithHubShell)() : (0, $eKYgj.viewCrossSitePortalArticleRoute),
        (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmViewArticleRouteWithHubShell)() : activeViewArticleRoute),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmViewCrossSiteArticleRouteWithHubShell)() : activeCrossSiteArticleRoute
    ];
};
const $f50f1278810099ef$var$getContactUsRoute = ()=>{
    return (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmContactUsRouteWithHubShell)() : (0, $5u1WA.csmContactUsRoute));
};
const $f50f1278810099ef$export$30b4ff4634181478 = ()=>{
    const isAdvancedOrFlexiHCEnabled = (0, $cf3fd.isAdvancedHelpCenter)() || (0, $cf3fd.isFlexiHCEnabledInDefaultHC)();
    return [
        ...(0, $hN5YJ.isHubsEnabledInHelpCenter)() ? [
            (0, $5J3cB.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $4MFtS.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $4MFtS.getEditHomePageRoute)()
        ] : [],
        ...(0, $hN5YJ.isEmailVerifiedSignalEnabled)() ? [
            (0, $bT4AH.userVerifyEmailRoute)
        ] : [],
        (0, $iidRB.aiAnswerRoute),
        (0, $8Nv7y.consentFormRoute),
        ...$f50f1278810099ef$var$getAnonymousRoutes(),
        ...$f50f1278810099ef$var$getAccessAndAuthenticationRoutes(),
        (0, $dTc6i.requestFeedbackRoute),
        (0, $dTc6i.unsubscribeRoute),
        (0, $1NjiO.getHelpCenterRoute)(),
        (0, $gp1kG.requestDetailsRoute),
        ...$f50f1278810099ef$var$getSearchAndArticleRoutes(),
        (0, $iDxNX.routeWithAiWidgetConfigResource)($f50f1278810099ef$var$getRequestsListRoute()),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmRequestDetailsRouteWithHubShell)() : (0, $6MlVB.csmRequestDetailsRoute),
        (0, $dTc6i.helpCenterRequestFeedbackRoute),
        (0, $fQ6nv.approvalsRoute),
        (0, $kM3gF.requestApprovalRoute),
        $f50f1278810099ef$var$getUserProfileRoute(),
        (0, $eKYgj.viewPortalKnowledgeCategoryRoute),
        (0, $dTc6i.anonymousRequestSuccessRoute),
        (0, $dTc6i.getRequestCreateRoute)(),
        (0, $d9md5.getPortalHomeRoutes)(),
        (0, $fHOft.getEmbedCreateRequestRoute)(),
        (0, $fHOft.embedSinglePortalRoute),
        (0, $fHOft.embedKBArticleRoute),
        (0, $173qD.portalReorderRoute)(true),
        (0, $ciXwj.editTopicRoute),
        (0, $ciXwj.addTopicRoute),
        (0, $9fFmP.getViewTopicRoute)(),
        $f50f1278810099ef$var$getContactUsRoute(),
        (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmFolderRouteWithHubShell)() : (0, $h3GiS.csmFolderRoute)),
        ...$f50f1278810099ef$var$getCustomPageRoutes(),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getNotFoundRouteWithHubShell)() : (0, $dTc6i.notFoundErrorRoute)
    ];
};
const $f50f1278810099ef$export$8dfc12d998aeca9c = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $2p58l.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $2p58l.lightenColor)(themeColor);
    const routes = (0, $fc4bM.useMemo)(()=>{
        return $f50f1278810099ef$export$30b4ff4634181478();
    }, []);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $luz1X.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2drpp.Router), {
        routes: routes,
        history: (0, $diqlM.default),
        isGlobal: false,
        plugins: [
            (0, $aWLgo.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxSIz.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jB96H.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3iZvk.RouteComponent), null)));
};
const $f50f1278810099ef$var$selectorOld = (0, $2n2bS.createSelector)((0, $fYLlE.getHeadless), (0, $ePyx3.getThemeColor), (0, $ePyx3.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
const $f50f1278810099ef$export$2f7745f2f5ab3897 = ({ externalCustomer: externalCustomer })=>{
    // Routes that are restricted to non external users when
    // base path is /servicedesk/customer and customerAccountAvailabilty is JCS_ONLY
    const isAdvancedOrFlexiHCEnabled = (0, $cf3fd.isAdvancedHelpCenter)() || (0, $cf3fd.isFlexiHCEnabledInDefaultHC)();
    const restrictedRoutes = [
        ...(0, $hN5YJ.isHubsEnabledInHelpCenter)() ? [
            (0, $5J3cB.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $4MFtS.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $4MFtS.getEditHomePageRoute)()
        ] : [],
        ...(0, $hN5YJ.isEmailVerifiedSignalEnabled)() ? [
            (0, $bT4AH.userVerifyEmailRoute)
        ] : [],
        (0, $iidRB.aiAnswerRoute),
        (0, $8Nv7y.consentFormRoute),
        ...$f50f1278810099ef$var$getAnonymousRoutes(),
        ...$f50f1278810099ef$var$getAccessAndAuthenticationRoutes(),
        (0, $dTc6i.requestFeedbackRoute),
        (0, $dTc6i.unsubscribeRoute),
        (0, $1NjiO.getHelpCenterRoute)(),
        (0, $gp1kG.requestDetailsRoute),
        ...$f50f1278810099ef$var$getSearchAndArticleRoutes(),
        (0, $iDxNX.routeWithAiWidgetConfigResource)($f50f1278810099ef$var$getRequestsListRoute()),
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmRequestDetailsRouteWithHubShell)() : (0, $6MlVB.csmRequestDetailsRoute),
        (0, $dTc6i.helpCenterRequestFeedbackRoute),
        (0, $fQ6nv.approvalsRoute),
        (0, $kM3gF.requestApprovalRoute),
        $f50f1278810099ef$var$getUserProfileRoute(),
        (0, $fHOft.getEmbedCreateRequestRoute)(),
        (0, $fHOft.embedSinglePortalRoute),
        (0, $fHOft.embedKBArticleRoute),
        $f50f1278810099ef$var$getContactUsRoute(),
        (0, $iDxNX.routeWithAiWidgetConfigResource)((0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getCsmFolderRouteWithHubShell)() : (0, $h3GiS.csmFolderRoute)),
        ...$f50f1278810099ef$var$getCustomPageRoutes()
    ];
    return [
        ...(0, $cf3fd.isJcsOnlyRestrictedRoute)((0, $7lN8e.getEnv)().customerAccountAvailabilty) && externalCustomer ? [] : restrictedRoutes,
        (0, $hN5YJ.isHubsEnabledInHelpCenter)() ? (0, $5J3cB.getNotFoundRouteWithHubShell)() : (0, $dTc6i.notFoundErrorRoute)
    ];
};
const $f50f1278810099ef$export$7abc1d14de40c7e1 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor, user: user } = props;
    const readableTextColorFromTheme = (0, $2p58l.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $2p58l.lightenColor)(themeColor);
    const routes = (0, $fc4bM.useMemo)(()=>{
        return $f50f1278810099ef$export$2f7745f2f5ab3897({
            externalCustomer: user === null || user === void 0 ? void 0 : user.externalCustomer
        });
    }, [
        user
    ]);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    // If JCS_ONLY and accessing a JSM route (path starts with /servicedesk/customer) and the user is not external, redirect to JSM
    if ((0, $cf3fd.isJcsOnlyRestrictedRoute)((0, $7lN8e.getEnv)().customerAccountAvailabilty) && !(user !== null && user !== void 0 && user.externalCustomer)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3etYC.default), null);
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $luz1X.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2drpp.Router), {
        routes: routes,
        history: (0, $diqlM.default),
        isGlobal: false,
        plugins: [
            (0, $aWLgo.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxSIz.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jB96H.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3iZvk.RouteComponent), null)));
};
const $f50f1278810099ef$var$selector = (0, $2n2bS.createSelector)((0, $fYLlE.getHeadless), (0, $ePyx3.getThemeColor), (0, $ePyx3.getHelpCenterTitleColor), (state)=>(0, $7RWiC.getUserState)(state), (headerless, themeColor, titleColor, userState)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor,
        user: {
            externalCustomer: userState.externalCustomer
        }
    }));
const $f50f1278810099ef$export$a487b0571b6a921a = (0, $6umft.default)($f50f1278810099ef$var$selector)($f50f1278810099ef$export$7abc1d14de40c7e1);
var $f50f1278810099ef$export$2e2bcd8739ae039 = (0, $6umft.default)($f50f1278810099ef$var$selectorOld)($f50f1278810099ef$export$8dfc12d998aeca9c);

});
parcelRegister("2p58l", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $998bd74a9ad72b6d$export$3d31854eb05903e0);
$parcel$export(module.exports, "lightenColor", () => $998bd74a9ad72b6d$export$3abf4abc58accee2);

var $jQpH9 = parcelRequire("jQpH9");
const $998bd74a9ad72b6d$export$3d31854eb05903e0 = (color)=>{
    return (0, $jQpH9.getLuminance)(color) > 0.5 ? "var(--ds-text, #172B4D)" : "var(--ds-text-inverse, #FFFFFF)";
};
const $998bd74a9ad72b6d$export$3abf4abc58accee2 = (color)=>{
    return (0, $jQpH9.transparentize)(0.8, color);
};

});
parcelRegister("jQpH9", function(module, exports) {
$parcel$export(module.exports, "darken", () => $e726ce1fffa22f74$export$4b073707ff63303);
$parcel$export(module.exports, "getLuminance", () => $e726ce1fffa22f74$export$c852d90bf7403b62);
$parcel$export(module.exports, "lighten", () => $e726ce1fffa22f74$export$c0816ed86df316af);
$parcel$export(module.exports, "transparentize", () => $e726ce1fffa22f74$export$d11da87e55cc498f);

var $hHCeM = parcelRequire("hHCeM");

var $aGbjT = parcelRequire("aGbjT");
// @private
function $e726ce1fffa22f74$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $e726ce1fffa22f74$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $e726ce1fffa22f74$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $e726ce1fffa22f74$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $e726ce1fffa22f74$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$e726ce1fffa22f74$var$generateProperty(property, $e726ce1fffa22f74$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e726ce1fffa22f74$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $e726ce1fffa22f74$var$generateStyles(property, valuesWithDefaults);
}
function $e726ce1fffa22f74$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $e726ce1fffa22f74$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $e726ce1fffa22f74$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$e726ce1fffa22f74$var$endsWith(pxval, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
            newPxval = $e726ce1fffa22f74$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$e726ce1fffa22f74$var$endsWith(base, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
            newBase = $e726ce1fffa22f74$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        if (typeof newBase === 'string') throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        return "" + newPxval / newBase + to;
    };
};
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $e726ce1fffa22f74$export$c63c6f932822f543 = /*#__PURE__*/ $e726ce1fffa22f74$var$pxtoFactory('em');
var $e726ce1fffa22f74$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */ function $e726ce1fffa22f74$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($e726ce1fffa22f74$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
var $e726ce1fffa22f74$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $e726ce1fffa22f74$var$getRatio(ratioName) {
    return $e726ce1fffa22f74$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $e726ce1fffa22f74$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$e726ce1fffa22f74$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $e726ce1fffa22f74$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $e726ce1fffa22f74$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
    return realBase * Math.pow(realRatio, steps) + "em";
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $e726ce1fffa22f74$export$fb1897a40d146f7f = /*#__PURE__*/ $e726ce1fffa22f74$var$pxtoFactory('rem');
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $e726ce1fffa22f74$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $e726ce1fffa22f74$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $e726ce1fffa22f74$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $e726ce1fffa22f74$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $e726ce1fffa22f74$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $e726ce1fffa22f74$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $e726ce1fffa22f74$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $e726ce1fffa22f74$export$a5b94313d6908893(width) {
    if (width === void 0) width = '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $e726ce1fffa22f74$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _extends2, _extends3;
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var obj = _ref;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $hHCeM.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $e726ce1fffa22f74$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $hHCeM.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $hHCeM.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref2, _ref3, _ref4;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
        return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = $e726ce1fffa22f74$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
    }
}
function $e726ce1fffa22f74$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")";
    });
    return fileFontReferences.join(', ');
}
function $e726ce1fffa22f74$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $e726ce1fffa22f74$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($e726ce1fffa22f74$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($e726ce1fffa22f74$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $e726ce1fffa22f74$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $e726ce1fffa22f74$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        } // Removes undefined fields for cleaner css object.
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $e726ce1fffa22f74$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $e726ce1fffa22f74$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $e726ce1fffa22f74$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $e726ce1fffa22f74$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $e726ce1fffa22f74$export$c7187bbd1a7a9244(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = (0, $hHCeM.default)({}, styles), _ref[parent + ":-moz-placeholder"] = (0, $hHCeM.default)({}, styles), _ref[parent + "::-moz-placeholder"] = (0, $hHCeM.default)({}, styles), _ref[parent + ":-ms-input-placeholder"] = (0, $hHCeM.default)({}, styles), _ref;
}
function $e726ce1fffa22f74$var$_templateObject() {
    var data = (0, $aGbjT.default)([
        "radial-gradient(",
        "",
        "",
        "",
        ")"
    ]);
    $e726ce1fffa22f74$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e726ce1fffa22f74$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $e726ce1fffa22f74$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i]; // Adds leading coma if properties preceed color-stops
        if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
        else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e726ce1fffa22f74$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $e726ce1fffa22f74$var$parseFallback(colorStops),
        backgroundImage: $e726ce1fffa22f74$var$constructGradientValue($e726ce1fffa22f74$var$_templateObject(), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $e726ce1fffa22f74$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
     // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$e726ce1fffa22f74$export$e79006618d7c6cc3()] = (0, $hHCeM.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $e726ce1fffa22f74$export$7c69810f7b8835c9(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '';
    return _ref = {}, _ref[parent + "::-moz-selection"] = (0, $hHCeM.default)({}, styles), _ref[parent + "::selection"] = (0, $hHCeM.default)({}, styles), _ref;
}
/* eslint-disable key-spacing */ var $e726ce1fffa22f74$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $e726ce1fffa22f74$var$getTimingFunction(functionName) {
    return $e726ce1fffa22f74$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e726ce1fffa22f74$export$61210fa83792a81(timingFunction) {
    return $e726ce1fffa22f74$var$getTimingFunction(timingFunction);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $e726ce1fffa22f74$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
var $e726ce1fffa22f74$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];
        case 'left':
            return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";
        case 'bottom':
            return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];
        case 'right':
            return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
}; // needed for border-color
var $e726ce1fffa22f74$var$reverseDirection = [
    'bottom',
    'left',
    'top',
    'right'
];
var $e726ce1fffa22f74$var$NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $e726ce1fffa22f74$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = [
        parseFloat(width),
        String(width).replace($e726ce1fffa22f74$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    var heightAndUnit = [
        parseFloat(height),
        String(height).replace($e726ce1fffa22f74$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    var reverseDirectionIndex = $e726ce1fffa22f74$var$reverseDirection.indexOf(pointingDirection);
    return (0, $hHCeM.default)({
        width: '0',
        height: '0',
        borderWidth: $e726ce1fffa22f74$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
        borderStyle: 'solid'
    }, $e726ce1fffa22f74$export$e7fb0694ba2404fc.apply(void 0, Array.from({
        length: 4
    }).map(function(_, index) {
        return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
    })));
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $e726ce1fffa22f74$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $e726ce1fffa22f74$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $e726ce1fffa22f74$var$convertToInt(red, green, blue) {
    return $e726ce1fffa22f74$var$colorToInt(red) + "," + $e726ce1fffa22f74$var$colorToInt(green) + "," + $e726ce1fffa22f74$var$colorToInt(blue);
}
function $e726ce1fffa22f74$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $e726ce1fffa22f74$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $e726ce1fffa22f74$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $e726ce1fffa22f74$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $e726ce1fffa22f74$var$namedColorMap[normalizedColorName] ? "#" + $e726ce1fffa22f74$var$namedColorMap[normalizedColorName] : color;
}
var $e726ce1fffa22f74$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $e726ce1fffa22f74$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $e726ce1fffa22f74$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $e726ce1fffa22f74$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $e726ce1fffa22f74$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $e726ce1fffa22f74$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $e726ce1fffa22f74$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $e726ce1fffa22f74$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $e726ce1fffa22f74$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $e726ce1fffa22f74$var$nameToHex(color);
    if (normalizedColor.match($e726ce1fffa22f74$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($e726ce1fffa22f74$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($e726ce1fffa22f74$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($e726ce1fffa22f74$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $e726ce1fffa22f74$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $e726ce1fffa22f74$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $e726ce1fffa22f74$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $e726ce1fffa22f74$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $e726ce1fffa22f74$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $e726ce1fffa22f74$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $e726ce1fffa22f74$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $e726ce1fffa22f74$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
function $e726ce1fffa22f74$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $e726ce1fffa22f74$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $e726ce1fffa22f74$var$rgbToHsl($e726ce1fffa22f74$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $e726ce1fffa22f74$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $e726ce1fffa22f74$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $e726ce1fffa22f74$var$colorToHex(color) {
    return $e726ce1fffa22f74$var$numberToHex(Math.round(color * 255));
}
function $e726ce1fffa22f74$var$convertToHex(red, green, blue) {
    return $e726ce1fffa22f74$var$reduceHexValue("#" + $e726ce1fffa22f74$var$colorToHex(red) + $e726ce1fffa22f74$var$colorToHex(green) + $e726ce1fffa22f74$var$colorToHex(blue));
}
function $e726ce1fffa22f74$var$hslToHex(hue, saturation, lightness) {
    return $e726ce1fffa22f74$var$hslToRgb(hue, saturation, lightness, $e726ce1fffa22f74$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $e726ce1fffa22f74$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $e726ce1fffa22f74$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $e726ce1fffa22f74$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $e726ce1fffa22f74$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $e726ce1fffa22f74$var$hslToHex(value, saturation, lightness) : "rgba(" + $e726ce1fffa22f74$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $e726ce1fffa22f74$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $e726ce1fffa22f74$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $e726ce1fffa22f74$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $e726ce1fffa22f74$var$reduceHexValue("#" + $e726ce1fffa22f74$var$numberToHex(value) + $e726ce1fffa22f74$var$numberToHex(green) + $e726ce1fffa22f74$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $e726ce1fffa22f74$var$reduceHexValue("#" + $e726ce1fffa22f74$var$numberToHex(value.red) + $e726ce1fffa22f74$var$numberToHex(value.green) + $e726ce1fffa22f74$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $e726ce1fffa22f74$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $e726ce1fffa22f74$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $e726ce1fffa22f74$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $e726ce1fffa22f74$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
var $e726ce1fffa22f74$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $e726ce1fffa22f74$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $e726ce1fffa22f74$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $e726ce1fffa22f74$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $e726ce1fffa22f74$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e726ce1fffa22f74$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($e726ce1fffa22f74$var$errMsg);
    if ($e726ce1fffa22f74$var$isRgba(color)) return $e726ce1fffa22f74$export$4e46ac54fc82cf3b(color);
    if ($e726ce1fffa22f74$var$isRgb(color)) return $e726ce1fffa22f74$export$8972dc0e6ad9238f(color);
    if ($e726ce1fffa22f74$var$isHsla(color)) return $e726ce1fffa22f74$export$810b04175080204c(color);
    if ($e726ce1fffa22f74$var$isHsl(color)) return $e726ce1fffa22f74$export$8f4a7c0bb78e6ea8(color);
    throw new Error($e726ce1fffa22f74$var$errMsg);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $e726ce1fffa22f74$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $e726ce1fffa22f74$var$curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function $e726ce1fffa22f74$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $e726ce1fffa22f74$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$adjustHue(degree, color) {
    var hslColor = $e726ce1fffa22f74$export$1286688e1b3fde9c(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, hslColor, {
        hue: (hslColor.hue + parseFloat(degree)) % 360
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$2b372a09365374d6 = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$adjustHue);
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e726ce1fffa22f74$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $e726ce1fffa22f74$export$1286688e1b3fde9c(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $e726ce1fffa22f74$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$darken(amount, color) {
    var hslColor = $e726ce1fffa22f74$export$1286688e1b3fde9c(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, hslColor, {
        lightness: $e726ce1fffa22f74$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$4b073707ff63303 = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$darken);
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$desaturate(amount, color) {
    var hslColor = $e726ce1fffa22f74$export$1286688e1b3fde9c(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, hslColor, {
        saturation: $e726ce1fffa22f74$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$fb75607d98509d9 = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$desaturate);
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $e726ce1fffa22f74$export$c852d90bf7403b62(color) {
    var rgbColor = $e726ce1fffa22f74$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e726ce1fffa22f74$export$6f416a6db2dfcd5c(color) {
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, $e726ce1fffa22f74$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $e726ce1fffa22f74$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $e726ce1fffa22f74$export$2f48baff6995707a(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$lighten(amount, color) {
    var hslColor = $e726ce1fffa22f74$export$1286688e1b3fde9c(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, hslColor, {
        lightness: $e726ce1fffa22f74$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$c0816ed86df316af = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$lighten);
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $e726ce1fffa22f74$var$mix(weight, color, otherColor) {
    var parsedColor1 = $e726ce1fffa22f74$export$2f48baff6995707a(color);
    var color1 = (0, $hHCeM.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $e726ce1fffa22f74$export$2f48baff6995707a(otherColor);
    var color2 = (0, $hHCeM.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
    };
    return $e726ce1fffa22f74$export$4e46ac54fc82cf3b(mixedColor);
} // prettier-ignore
var $e726ce1fffa22f74$export$2c9e8a9632a706b2 = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$mix);
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$opacify(amount, color) {
    var parsedColor = $e726ce1fffa22f74$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $hHCeM.default)({}, parsedColor, {
        alpha: $e726ce1fffa22f74$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $e726ce1fffa22f74$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $e726ce1fffa22f74$export$f4f50e3877dd0530 = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$opacify);
/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $e726ce1fffa22f74$export$61654c1796c44811(color) {
    return $e726ce1fffa22f74$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$saturate(amount, color) {
    var hslColor = $e726ce1fffa22f74$export$1286688e1b3fde9c(color);
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, hslColor, {
        saturation: $e726ce1fffa22f74$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$5fcac96f5a87e3db = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$saturate);
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$setHue(hue, color) {
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, $e726ce1fffa22f74$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$3bf58ce3e497a846 = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$setHue);
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$setLightness(lightness, color) {
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, $e726ce1fffa22f74$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$7ef5d725337b805d = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$setLightness);
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $e726ce1fffa22f74$var$setSaturation(saturation, color) {
    return $e726ce1fffa22f74$export$42fe740cdf79b2df((0, $hHCeM.default)({}, $e726ce1fffa22f74$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
} // prettier-ignore
var $e726ce1fffa22f74$export$b40fe421ea7a4f7e = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$setSaturation);
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $e726ce1fffa22f74$var$shade(percentage, color) {
    return $e726ce1fffa22f74$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore
var $e726ce1fffa22f74$export$3e32adda0df4ef5d = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $e726ce1fffa22f74$var$tint(percentage, color) {
    return $e726ce1fffa22f74$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore
var $e726ce1fffa22f74$export$fc176dd65a27d98b = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$tint);
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $e726ce1fffa22f74$var$transparentize(amount, color) {
    var parsedColor = $e726ce1fffa22f74$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $hHCeM.default)({}, parsedColor, {
        alpha: $e726ce1fffa22f74$var$guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
    });
    return $e726ce1fffa22f74$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $e726ce1fffa22f74$export$d11da87e55cc498f = /*#__PURE__*/ $e726ce1fffa22f74$var$curry($e726ce1fffa22f74$var$transparentize);
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $e726ce1fffa22f74$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $e726ce1fffa22f74$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $e726ce1fffa22f74$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $e726ce1fffa22f74$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $e726ce1fffa22f74$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $e726ce1fffa22f74$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $e726ce1fffa22f74$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $e726ce1fffa22f74$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $e726ce1fffa22f74$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $e726ce1fffa22f74$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $e726ce1fffa22f74$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $e726ce1fffa22f74$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $e726ce1fffa22f74$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $e726ce1fffa22f74$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $e726ce1fffa22f74$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $e726ce1fffa22f74$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($e726ce1fffa22f74$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $e726ce1fffa22f74$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $e726ce1fffa22f74$var$template(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $e726ce1fffa22f74$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e726ce1fffa22f74$var$statefulSelectors(states, $e726ce1fffa22f74$var$template, $e726ce1fffa22f74$var$stateMap);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $e726ce1fffa22f74$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e726ce1fffa22f74$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $e726ce1fffa22f74$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $e726ce1fffa22f74$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($e726ce1fffa22f74$var$positionMap$1.indexOf(positionKeyword) >= 0) return (0, $hHCeM.default)({
        position: positionKeyword
    }, $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $e726ce1fffa22f74$export$4fc00c04dd60af95.apply(void 0, [
            '',
            firstValue
        ].concat(values));
    }
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $e726ce1fffa22f74$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $e726ce1fffa22f74$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $e726ce1fffa22f74$var$template$1(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $e726ce1fffa22f74$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e726ce1fffa22f74$var$statefulSelectors(states, $e726ce1fffa22f74$var$template$1, $e726ce1fffa22f74$var$stateMap$1);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $e726ce1fffa22f74$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new Error('Property must be a string value.');
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}

});
parcelRegister("aGbjT", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c669b82b4be87e4$export$2e2bcd8739ae039);
function $7c669b82b4be87e4$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}

});



parcelRegister("gxSIz", function(module, exports) {
$parcel$export(module.exports, "GlobalStyled", () => $56cf350416af46b4$export$b606131378921a7b);
$parcel$export(module.exports, "NewGlobalBGColor", () => $56cf350416af46b4$export$aa61b57bede93357);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
parcelRequire("hzZg3");
var $6znAn = parcelRequire("6znAn");

var $h46Vs = parcelRequire("h46Vs");
const $56cf350416af46b4$var$getLinkColorToken = (props)=>{
    if (props !== null && props !== void 0 && props.isCsm) {
        const generatedColors = (0, $h46Vs.generateThemeBranding)(props.theme.color);
        return `var(--ds-link, ${generatedColors.color900})`;
    }
    return `var(--ds-link, ${props.theme.color})`;
};
const $56cf350416af46b4$export$b606131378921a7b = /*#__PURE__*/ (0, $luz1X.default)((0, $6znAn.default)).withConfig({
    componentId: "sc-15eor0s-0"
})`background-color:${"var(--ds-surface, #FFFFFF)"};font:${"var(--ds-font-body, normal 400 14px/1.42857142857143 -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"};a:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']),a:hover:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']){color:${(props)=>$56cf350416af46b4$var$getLinkColorToken(props)};}h1,h2{letter-spacing:-0.001em;}:root{--ds-space-0:0;--ds-space-025:0.125rem;--ds-space-050:0.25rem;--ds-space-075:0.375rem;--ds-space-100:0.5rem;--ds-space-150:0.75rem;--ds-space-200:1rem;--ds-space-250:1.25rem;--ds-space-300:1.5rem;--ds-space-400:2rem;--ds-space-500:2.5rem;--ds-space-600:3rem;--ds-space-800:4rem;--ds-space-1000:5rem;--ds-font-family-monospace:'SFMono-Medium','SF Mono','Segoe UI Mono','Roboto Mono','Ubuntu Mono',Menlo,Consolas,Courier,monospace;--ds-font-family-sans:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;--ds-font-size-050:11px;--ds-font-size-075:12px;--ds-font-size-100:14px;--ds-font-size-200:16px;--ds-font-size-300:20px;--ds-font-size-400:24px;--ds-font-size-500:29px;--ds-font-size-600:35px;--ds-font-weight-bold:700;--ds-font-weight-medium:500;--ds-font-weight-regular:400;--ds-font-weight-semibold:600;--ds-font-lineHeight-100:1rem;--ds-font-lineHeight-200:1.25rem;--ds-font-lineHeight-300:1.5rem;--ds-font-lineHeight-400:1.75rem;--ds-font-lineHeight-500:2rem;--ds-font-lineHeight-600:2.5rem;}`;
const $56cf350416af46b4$export$aa61b57bede93357 = /*#__PURE__*/ (0, $luz1X.default)((0, $6znAn.default)).withConfig({
    componentId: "sc-15eor0s-1"
})`background-color:${"var(--ds-surface, #FFFFFF)"};`;

});
parcelRegister("hzZg3", function(module, exports) {
$parcel$export(module.exports, "BodyClassName", () => (parcelRequire("6znAn")).default);

var $6znAn = parcelRequire("6znAn");

});
parcelRegister("6znAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0450caae7e1268f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $him7m = parcelRequire("him7m");
class $c0450caae7e1268f$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    constructor(props){
        super(props);
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            classes.forEach((className)=>{
                (0, $him7m.default).addClassName('body', className);
            });
        }
    }
    componentWillUnmount() {
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            classes.forEach((className)=>document.body.classList.remove(className));
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.className !== this.props.className) {
            if (prevProps.className) {
                const prevClasses = prevProps.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.remove(...prevClasses);
            }
            if (this.props.className) {
                const classes = this.props.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.add(...classes);
            }
        }
    }
    render() {
        return null;
    }
}

});


parcelRegister("h46Vs", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $74d83aa1d2c837b1$export$c1410db1c88d6e0f);

var $imqB2 = parcelRequire("imqB2");

var $jcUeK = parcelRequire("jcUeK");
/**
 * Default primary color for CSM branding
 */ const $74d83aa1d2c837b1$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR = '#B5B5B5';
const $74d83aa1d2c837b1$export$c1410db1c88d6e0f = (primaryColour)=>(0, $imqB2.generateColorRamps)((0, $jcUeK.isValidHex)(primaryColour) ? primaryColour : $74d83aa1d2c837b1$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR);

});
parcelRegister("imqB2", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $60d7938a8375a09d$export$3a180ce5632a9d57);

var $gX73U = parcelRequire("gX73U");

var $dt7ei = parcelRequire("dt7ei");

var $gAfCy = parcelRequire("gAfCy");

var $8QrQh = parcelRequire("8QrQh");
const $60d7938a8375a09d$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $60d7938a8375a09d$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $60d7938a8375a09d$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $gX73U.deltaE)((0, $gX73U.hexToRgb)(value), (0, $gX73U.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $60d7938a8375a09d$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $gX73U.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $gX73U.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $gX73U.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $60d7938a8375a09d$var$lowLuminanceContrastRatios : $60d7938a8375a09d$var$highLuminanceContrastRatios;
    const brandRgba = (0, $gX73U.hexToRgbA)(brandColor);
    const hctColor = (0, $8QrQh.Hct).fromInt((0, $dt7ei.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $dt7ei.rgbaFromArgb)((0, $8QrQh.Hct).from(hctColor.hue, hctColor.chroma, (0, $gAfCy.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $gX73U.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $60d7938a8375a09d$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $60d7938a8375a09d$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $60d7938a8375a09d$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("gX73U", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $39483c95f101e1f4$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $39483c95f101e1f4$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $39483c95f101e1f4$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $39483c95f101e1f4$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $39483c95f101e1f4$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $39483c95f101e1f4$export$e770b01b744f3745);
$parcel$export(module.exports, "deltaE", () => $39483c95f101e1f4$export$e8ddad763b4bebf9);

var $jcUeK = parcelRequire("jcUeK");
function $39483c95f101e1f4$export$34d09c4a771c46ef(r, g, b) {
    const chars = (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return `#${chars}`;
}
function $39483c95f101e1f4$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $39483c95f101e1f4$export$b36dbdb4f463f05c(hex) {
    if (!(0, $jcUeK.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $39483c95f101e1f4$export$1212645cf40ebf71(hex)
    ];
}
function $39483c95f101e1f4$export$5a544e13ad4e1fa5(hex) {
    if (!(0, $jcUeK.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $39483c95f101e1f4$export$47ea145a83f50dc0(hex) {
    if (!(0, $jcUeK.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $39483c95f101e1f4$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $39483c95f101e1f4$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $39483c95f101e1f4$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $jcUeK.isValidHex)(foreground) || !(0, $jcUeK.isValidHex)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $39483c95f101e1f4$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $39483c95f101e1f4$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $39483c95f101e1f4$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $39483c95f101e1f4$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $39483c95f101e1f4$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $39483c95f101e1f4$var$rgbToLab(rgbA);
    let labB = $39483c95f101e1f4$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $39483c95f101e1f4$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});
parcelRegister("jcUeK", function(module, exports) {
$parcel$export(module.exports, "isValidHex", () => $1b23c8ee78599280$export$944f75ec5697b362);
const $1b23c8ee78599280$export$944f75ec5697b362 = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

});


parcelRegister("dt7ei", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $95ad3b4b05069249$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $95ad3b4b05069249$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $95ad3b4b05069249$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $95ad3b4b05069249$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $95ad3b4b05069249$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $95ad3b4b05069249$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $95ad3b4b05069249$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $95ad3b4b05069249$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $95ad3b4b05069249$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $95ad3b4b05069249$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $lCkap = parcelRequire("lCkap");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $95ad3b4b05069249$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $95ad3b4b05069249$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $95ad3b4b05069249$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $95ad3b4b05069249$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $95ad3b4b05069249$export$7928ddf440518d19(linrgb) {
    const r = $95ad3b4b05069249$export$777e26aa2ec02b1(linrgb[0]);
    const g = $95ad3b4b05069249$export$777e26aa2ec02b1(linrgb[1]);
    const b = $95ad3b4b05069249$export$777e26aa2ec02b1(linrgb[2]);
    return $95ad3b4b05069249$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $95ad3b4b05069249$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $95ad3b4b05069249$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $95ad3b4b05069249$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $95ad3b4b05069249$var$blueFromArgb(argb) {
    return argb & 255;
}
function $95ad3b4b05069249$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $95ad3b4b05069249$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $95ad3b4b05069249$export$777e26aa2ec02b1(linearR);
    const g = $95ad3b4b05069249$export$777e26aa2ec02b1(linearG);
    const b = $95ad3b4b05069249$export$777e26aa2ec02b1(linearB);
    return $95ad3b4b05069249$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $95ad3b4b05069249$var$xyzFromArgb(argb) {
    const r = $95ad3b4b05069249$export$dec6bcda7bf47f2c($95ad3b4b05069249$var$redFromArgb(argb));
    const g = $95ad3b4b05069249$export$dec6bcda7bf47f2c($95ad3b4b05069249$var$greenFromArgb(argb));
    const b = $95ad3b4b05069249$export$dec6bcda7bf47f2c($95ad3b4b05069249$var$blueFromArgb(argb));
    return $lCkap.matrixMultiply([
        r,
        g,
        b
    ], $95ad3b4b05069249$var$SRGB_TO_XYZ);
}
function $95ad3b4b05069249$export$ae8c227f6d0cbddb(lstar) {
    const y = $95ad3b4b05069249$export$7f3071c4a5db05a0(lstar);
    const component = $95ad3b4b05069249$export$777e26aa2ec02b1(y);
    return $95ad3b4b05069249$export$58a74b9f8e513b7b(component, component, component);
}
function $95ad3b4b05069249$export$8b8f7ef2e0a71c61(argb) {
    const y = $95ad3b4b05069249$var$xyzFromArgb(argb)[1];
    return 116.0 * $95ad3b4b05069249$var$labF(y / 100.0) - 16.0;
}
function $95ad3b4b05069249$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $95ad3b4b05069249$var$labInvf((lstar + 16.0) / 116.0);
}
function $95ad3b4b05069249$export$bfc0d1dd9c64ada2(y) {
    return $95ad3b4b05069249$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $95ad3b4b05069249$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $95ad3b4b05069249$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $lCkap.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $95ad3b4b05069249$export$d4534a444c6526c3() {
    return $95ad3b4b05069249$var$WHITE_POINT_D65;
}
function $95ad3b4b05069249$export$fb1fd26c787a8662(argb) {
    const r = $95ad3b4b05069249$var$redFromArgb(argb);
    const g = $95ad3b4b05069249$var$greenFromArgb(argb);
    const b = $95ad3b4b05069249$var$blueFromArgb(argb);
    const a = $95ad3b4b05069249$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $95ad3b4b05069249$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $95ad3b4b05069249$var$clampComponent(r);
    const gValue = $95ad3b4b05069249$var$clampComponent(g);
    const bValue = $95ad3b4b05069249$var$clampComponent(b);
    const aValue = $95ad3b4b05069249$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $95ad3b4b05069249$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $95ad3b4b05069249$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $95ad3b4b05069249$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("lCkap", function(module, exports) {
$parcel$export(module.exports, "signum", () => $fd934478e967b5b8$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $fd934478e967b5b8$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $fd934478e967b5b8$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $fd934478e967b5b8$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $fd934478e967b5b8$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $fd934478e967b5b8$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $fd934478e967b5b8$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $fd934478e967b5b8$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $fd934478e967b5b8$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $fd934478e967b5b8$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $fd934478e967b5b8$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $fd934478e967b5b8$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("gAfCy", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $ca57c88c3ae3b019$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $dt7ei = parcelRequire("dt7ei");

var $lCkap = parcelRequire("lCkap");
class $ca57c88c3ae3b019$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $lCkap.clampDouble(0.0, 100.0, toneA);
        toneB = $lCkap.clampDouble(0.0, 100.0, toneB);
        return $ca57c88c3ae3b019$export$656ae42051d0ca86.ratioOfYs($dt7ei.yFromLstar(toneA), $dt7ei.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $dt7ei.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $ca57c88c3ae3b019$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $dt7ei.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $dt7ei.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $ca57c88c3ae3b019$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $dt7ei.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $ca57c88c3ae3b019$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $ca57c88c3ae3b019$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("8QrQh", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $6dbed0ba0491782a$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dt7ei = parcelRequire("dt7ei");

var $lCkap = parcelRequire("lCkap");
class $6dbed0ba0491782a$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $6dbed0ba0491782a$export$91d2e033b3924566($6dbed0ba0491782a$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $6dbed0ba0491782a$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($6dbed0ba0491782a$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($6dbed0ba0491782a$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($6dbed0ba0491782a$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $6dbed0ba0491782a$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $dt7ei.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $6dbed0ba0491782a$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $dt7ei.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $6dbed0ba0491782a$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $6dbed0ba0491782a$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $6dbed0ba0491782a$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $6dbed0ba0491782a$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $dt7ei.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $6dbed0ba0491782a$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $6dbed0ba0491782a$var$Cam16.fromIntInViewingConditions(argb, $6dbed0ba0491782a$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $dt7ei.linearized(red);
        const greenL = $dt7ei.linearized(green);
        const blueL = $dt7ei.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $lCkap.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $lCkap.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $lCkap.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $6dbed0ba0491782a$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $6dbed0ba0491782a$var$Cam16.fromJchInViewingConditions(j, c, h, $6dbed0ba0491782a$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $6dbed0ba0491782a$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $6dbed0ba0491782a$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $6dbed0ba0491782a$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $6dbed0ba0491782a$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($6dbed0ba0491782a$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $lCkap.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $lCkap.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $lCkap.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $dt7ei.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $lCkap.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $lCkap.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $lCkap.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $6dbed0ba0491782a$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $lCkap.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $lCkap.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $lCkap.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $6dbed0ba0491782a$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $lCkap.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $lCkap.matrixMultiply(linrgb, $6dbed0ba0491782a$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $6dbed0ba0491782a$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $6dbed0ba0491782a$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $6dbed0ba0491782a$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $6dbed0ba0491782a$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $6dbed0ba0491782a$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $6dbed0ba0491782a$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $6dbed0ba0491782a$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $6dbed0ba0491782a$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $6dbed0ba0491782a$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $6dbed0ba0491782a$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($6dbed0ba0491782a$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($6dbed0ba0491782a$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($6dbed0ba0491782a$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $6dbed0ba0491782a$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $6dbed0ba0491782a$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $6dbed0ba0491782a$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($6dbed0ba0491782a$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $6dbed0ba0491782a$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $6dbed0ba0491782a$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $6dbed0ba0491782a$var$HctSolver.criticalPlaneBelow($6dbed0ba0491782a$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $6dbed0ba0491782a$var$HctSolver.criticalPlaneAbove($6dbed0ba0491782a$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $6dbed0ba0491782a$var$HctSolver.criticalPlaneAbove($6dbed0ba0491782a$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $6dbed0ba0491782a$var$HctSolver.criticalPlaneBelow($6dbed0ba0491782a$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $6dbed0ba0491782a$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $6dbed0ba0491782a$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $6dbed0ba0491782a$var$HctSolver.hueOf(mid);
                    if ($6dbed0ba0491782a$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $6dbed0ba0491782a$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $lCkap.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $6dbed0ba0491782a$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $6dbed0ba0491782a$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $6dbed0ba0491782a$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $6dbed0ba0491782a$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $lCkap.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $6dbed0ba0491782a$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $6dbed0ba0491782a$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $6dbed0ba0491782a$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $6dbed0ba0491782a$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $dt7ei.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $dt7ei.argbFromLstar(lstar);
        hueDegrees = $lCkap.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $dt7ei.yFromLstar(lstar);
        const exactAnswer = $6dbed0ba0491782a$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $6dbed0ba0491782a$var$HctSolver.bisectToLimit(y, hueRadians);
        return $dt7ei.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $6dbed0ba0491782a$var$Cam16.fromInt($6dbed0ba0491782a$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $6dbed0ba0491782a$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $6dbed0ba0491782a$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $dt7ei.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $dt7ei.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $lCkap.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $lCkap.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $dt7ei.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $6dbed0ba0491782a$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});




parcelRegister("4MFtS", function(module, exports) {
$parcel$export(module.exports, "getFlexiHelpCenterRoute", () => $54017c8202e67c75$export$21b2409877effae5);
$parcel$export(module.exports, "getViewHomePageRoute", () => $54017c8202e67c75$export$2601c63db4e9c5eb);
$parcel$export(module.exports, "getEditHomePageRoute", () => $54017c8202e67c75$export$ce4073fcfac7d40d);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");

var $6HUAM = parcelRequire("6HUAM");

var $cjFOK = parcelRequire("cjFOK");

var $bQkfB = parcelRequire("bQkfB");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("hG7Ne");
var $bOyxS = parcelRequire("bOyxS");
parcelRequire("5sUPt");
var $dTc6i = parcelRequire("dTc6i");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");
parcelRequire("kEool");
var $dRMig = parcelRequire("dRMig");
parcelRequire("jDBRI");
var $ju0hb = parcelRequire("ju0hb");

var $80yPZ = parcelRequire("80yPZ");

var $azARG = parcelRequire("azARG");

var $eENmG = parcelRequire("eENmG");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $joDHD = parcelRequire("joDHD");

var $jyAYs = parcelRequire("jyAYs");

var $oEu1q = parcelRequire("oEu1q");
const $54017c8202e67c75$var$VIEW_HOMEPAGE_PATH = '(/)?';
const $54017c8202e67c75$var$EDIT_HOMEPAGE_PATH = '/edit';

const $54017c8202e67c75$var$AsyncViewHomepage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("330UU")), {
        moduleId: "./src/view/advanced-help-center/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6HUAM.default), null)
});

const $54017c8202e67c75$var$AsyncCSMViewHomepage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("h84iT")), {
        moduleId: "./src/view/customer-service/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6HUAM.default), null)
});
const $54017c8202e67c75$export$21b2409877effae5 = (name = 'help-center', path = $54017c8202e67c75$var$VIEW_HOMEPAGE_PATH, screenName = (0, $9mazR.ScreenName).VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = [
        (0, $oEu1q.brandingResource),
        (0, $cjFOK.ViewHomepageResource),
        (0, $cjFOK.searchComponentVirtualAgentResource)
    ];
    return (0, $joDHD.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $54017c8202e67c75$var$AsyncViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $cjFOK.ViewHomepageResource),
            (0, $cjFOK.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $54017c8202e67c75$export$fc52ccc4768cd164 = (name = 'help-center', path = $54017c8202e67c75$var$VIEW_HOMEPAGE_PATH, screenName = (0, $9mazR.ScreenName).CSM_VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = [
        (0, $oEu1q.brandingResource),
        (0, $cjFOK.ViewHomepageResource),
        (0, $cjFOK.searchComponentVirtualAgentResource)
    ];
    return (0, $joDHD.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $54017c8202e67c75$var$AsyncCSMViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $cjFOK.ViewHomepageResource),
            (0, $cjFOK.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};
const $54017c8202e67c75$export$2601c63db4e9c5eb = ()=>{
    if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) return $54017c8202e67c75$export$fc52ccc4768cd164();
    return $54017c8202e67c75$export$21b2409877effae5();
};

const $54017c8202e67c75$export$400d7e0667f80c3f = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("84Thx")), {
        moduleId: "./src/view/advanced-help-center/edit-homepage-v2/index.tsx"
    }),
    LoadingSkeleton: ()=>(0, $hN5YJ.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bOyxS.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6HUAM.default), {
            showActionBar: true
        })
});
const $54017c8202e67c75$export$96880615462f6c7f = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: props.location.pathname
    }), (0, $aylSc.default)({
        message: formatMessage((0, $80yPZ.authPageMessage)),
        callToActionText: formatMessage((0, $80yPZ.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dRMig.default), {
            path: $54017c8202e67c75$var$EDIT_HOMEPAGE_PATH,
            component: $54017c8202e67c75$export$400d7e0667f80c3f,
            screenName: (0, $9mazR.ScreenName).EDIT_HOMEPAGE,
            isFooterHidden: (0, $hN5YJ.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ju0hb.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props));
};
const $54017c8202e67c75$export$ce4073fcfac7d40d = (name = 'edit-homepage', path = '/edit')=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        resources: [
            (0, $jyAYs.EditHomepageV2Resource)
        ],
        exact: true,
        component: (0, $7lN8e.getIsHCCustomizationEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo($54017c8202e67c75$export$96880615462f6c7f) : (0, $eENmG.withAnalyticsContext)({
            componentName: 'notFoundPage'
        })(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        (0, $azARG.default)({})((0, $dTc6i.NotFoundPage)))
    };
    return editHomePageRoute;
};

});
parcelRegister("6HUAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ba909152778162e$export$2e2bcd8739ae039);
/* flexible-homepage-loader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $8PITw = parcelRequire("8PITw");

var $iG0dO = parcelRequire("iG0dO");
parcelRequire("cpuUs");
var $2MBcW = parcelRequire("2MBcW");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $d7r8x = parcelRequire("d7r8x");
const $8ba909152778162e$var$SECTION_HEIGHT = 232;
const $8ba909152778162e$var$FlexibleHomepageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "flexible-homepage-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8ba909152778162e$var$skeletonContainer
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2MBcW.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8ba909152778162e$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $iG0dO.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8ba909152778162e$var$SectionLoader, {
            key: `flexibleHCLoader_${index}`,
            "data-testid": "flexible-hc-section-skeleton",
            height: $8ba909152778162e$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        });
    })));
};
const $8ba909152778162e$var$skeletonContainer = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $8ba909152778162e$var$headerContainer = (0, $kig2V.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8ba909152778162e$var$SectionLoader = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $8PITw.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_2rko12b0 _1bsb1osq _19pk1ejb _69lw94vn _9wd01ejb _n71h1ejb",
            __cmplp.className
        ])
    });
});
var $8ba909152778162e$export$2e2bcd8739ae039 = $8ba909152778162e$var$FlexibleHomepageLoader;

});
parcelRegister("iG0dO", function(module, exports) {
$parcel$export(module.exports, "BANNER_HEIGHT", () => $f99eae733dc6782a$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $f99eae733dc6782a$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "SEARCH_INPUT_FONT_SIZE", () => $f99eae733dc6782a$export$1d74cef432cdcb55);
$parcel$export(module.exports, "FilterContainer", () => $f99eae733dc6782a$export$2f96f6f204f87534);
$parcel$export(module.exports, "FormErrorContainer", () => $f99eae733dc6782a$export$ae0c09a310b3720b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");
const $f99eae733dc6782a$export$c09feb53ddd4034b = 300;
const $f99eae733dc6782a$export$ed7cc0d417ee89e = $fOCtI.multiple(44);
const $f99eae733dc6782a$export$cdb7fd9d999c7168 = $fOCtI.unitless * 7;
const $f99eae733dc6782a$export$1d74cef432cdcb55 = $imLe4.mediumLarge;
const $f99eae733dc6782a$export$2f96f6f204f87534 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1pch1g4-0"
})`display:flex;flex-wrap:wrap;margin-top:${"var(--ds-space-negative-100, -8px)"};margin-right:${"var(--ds-space-negative-200, -16px)"};> *{flex-basis:0;margin-right:${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-100, 8px)"};min-width:${$fOCtI.multiple(27.5).px};flex-grow:1;}`;
const $f99eae733dc6782a$export$ae0c09a310b3720b = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1pch1g4-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("cpuUs", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => (parcelRequire("2MBcW")).ActionBarStateless);

var $2MBcW = parcelRequire("2MBcW");

});
parcelRegister("2MBcW", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => $91dfe5017c48023d$export$dc910ca71acdb8f0);
/* action-bar-stateless.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $MPQAF = parcelRequire("MPQAF");

var $3syVB = parcelRequire("3syVB");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("eo3iN");
var $jigFz = parcelRequire("jigFz");

var $44Krk = parcelRequire("44Krk");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $kMCZr = parcelRequire("kMCZr");
const $91dfe5017c48023d$export$cc312d5a7378bea1 = 'Help Centers customize page layout';
const $91dfe5017c48023d$export$dc910ca71acdb8f0 = ({ isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, isPublishing: isPublishing, onPublish: onPublish, onClose: onClose, publishButtonDisabled: publishButtonDisabled, previewButtonDisabled: previewButtonDisabled, children: children, isPageInPreviewMode: isPageInPreviewMode, togglePreviewMode: togglePreviewMode })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (isPageInBrandingPreviewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$ActionsWrapper, {
        isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jigFz.BrandingPreviewBanner), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$ActionsWrapper, {
        id: "advance-customization-action-bar",
        isPageInBrandingPreviewMode: !!isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$ButtonContainer, null, !isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $91dfe5017c48023d$var$buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$ButtonWrapper, {
        actionSubjectId: "backToHomePage",
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $kMCZr.default).backToSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3syVB.default), {
        showIcon: true,
        showTypeField: true,
        featureName: $91dfe5017c48023d$export$cc312d5a7378bea1,
        buttonLabel: (0, $kMCZr.default).giveFeedback,
        analyticsSubjectId: "customizePageLayoutFeedbackButton"
    })), isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$PreviewButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $44Krk.default), {
        appearance: "info",
        title: formatMessage((0, $kMCZr.default).previewMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.Button), {
        isDisabled: previewButtonDisabled,
        actionSubjectId: "preview",
        appearance: "default",
        onClick: togglePreviewMode
    }, isPageInPreviewMode ? formatMessage((0, $kMCZr.default).exitPreview) : formatMessage((0, $kMCZr.default).preview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91dfe5017c48023d$var$ActionButton, {
        appearance: "primary",
        actionSubjectId: "publish",
        isDisabled: publishButtonDisabled,
        onClick: onPublish,
        isLoading: isPublishing
    }, formatMessage((0, $kMCZr.default).publish)))), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $91dfe5017c48023d$var$ButtonWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $MPQAF.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_18u0xmi2",
            __cmplp.className
        ])
    });
});
const $91dfe5017c48023d$var$ButtonGroup = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $91dfe5017c48023d$var$buttonGroup = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'row',
    gap: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $91dfe5017c48023d$var$ActionButton = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $MPQAF.LoadingButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $91dfe5017c48023d$var$ActionsWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt46hdp _154iidpf _1ltvidpf _1bsb1osq _kqsw1if8 _16qsfihs _vchhusvi _1pbyaft6",
            __cmplp.isPageInBrandingPreviewMode ? "_bfhkb7r6" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $91dfe5017c48023d$var$ButtonContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $91dfe5017c48023d$var$PreviewButtonWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("MPQAF", function(module, exports) {
$parcel$export(module.exports, "Button", () => $7ba4a7a97f284176$export$353f5b6fc5456de1);
$parcel$export(module.exports, "IconButton", () => $7ba4a7a97f284176$export$c25acd513dcc8062);
$parcel$export(module.exports, "LoadingButton", () => $7ba4a7a97f284176$export$4ec83e90d030b2f3);
$parcel$export(module.exports, "ThemedButton", () => $7ba4a7a97f284176$export$f67fb575035cc7d0);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $kTVlm = parcelRequire("kTVlm");

var $k7lry = parcelRequire("k7lry");

var $jtb5V = parcelRequire("jtb5V");

var $fRCnG = parcelRequire("fRCnG");
const $7ba4a7a97f284176$export$353f5b6fc5456de1 = /*#__PURE__*/ $fc4bM.memo(/*#__PURE__*/ $fc4bM.forwardRef(function Button({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $kTVlm.default), {
        ...props,
        ref: ref
    }));
}));
const $7ba4a7a97f284176$export$c25acd513dcc8062 = /*#__PURE__*/ $fc4bM.memo(/*#__PURE__*/ $fc4bM.forwardRef(function IconButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fRCnG.default), {
        ...props,
        ref: ref
    }));
}));
const $7ba4a7a97f284176$export$4ec83e90d030b2f3 = /*#__PURE__*/ $fc4bM.memo(/*#__PURE__*/ $fc4bM.forwardRef(function LoadingButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $jtb5V.default), {
        ...props,
        ref: ref
    }));
}));
const $7ba4a7a97f284176$export$f67fb575035cc7d0 = /*#__PURE__*/ $fc4bM.memo(/*#__PURE__*/ $fc4bM.forwardRef(function ThemedButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $k7lry.default), {
        ...props,
        ref: ref
    }));
}));

});
parcelRegister("jtb5V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0bc25a05180f1a3e$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $kTVlm = parcelRequire("kTVlm");

var $3wc6l = parcelRequire("3wc6l");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $0bc25a05180f1a3e$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kTVlm.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3wc6l.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$0bc25a05180f1a3e$var$LoadingButton.displayName = 'LoadingButton';
var $0bc25a05180f1a3e$export$2e2bcd8739ae039 = $0bc25a05180f1a3e$var$LoadingButton;

});


parcelRegister("3syVB", function(module, exports) {
$parcel$export(module.exports, "default", () => $40ef28599ebd978b$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $5kfOu = parcelRequire("5kfOu");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("kIRNU");
var $din2c = parcelRequire("din2c");
parcelRequire("jBTVi");
var $4llD6 = parcelRequire("4llD6");

var $7lN8e = parcelRequire("7lN8e");

var $2Sey0 = parcelRequire("2Sey0");
const $40ef28599ebd978b$var$selector = (0, $2n2bS.createSelector)((0, $4llD6.getFlags), (0, $7lN8e.getEnv), (flags, env)=>({
        flags: flags,
        env: env.environment
    }));
const $40ef28599ebd978b$var$mapDispatchToProps = {
    showFeedbackCollector: $din2c.showFeedbackCollector,
    dismissFlag: $5kfOu.dismissFlag
};
var $40ef28599ebd978b$export$2e2bcd8739ae039 = (0, $6umft.default)($40ef28599ebd978b$var$selector, $40ef28599ebd978b$var$mapDispatchToProps)((0, $fcCIH.default)((0, $2Sey0.FeedbackCollectorButton)));

});
parcelRegister("2Sey0", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorButton", () => $9fa83b41bea05c4a$export$b39479f42d974760);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $iK1uY = parcelRequire("iK1uY");

var $24pGP = parcelRequire("24pGP");

var $3yZwQ = parcelRequire("3yZwQ");
const $9fa83b41bea05c4a$export$b39479f42d974760 = ({ intl: intl, env: env, flags: flags, showIcon: showIcon, featureName: featureName, showTypeField: showTypeField, buttonLabel: buttonLabel, analyticsSubjectId: analyticsSubjectId, dismissFlagMessage: dismissFlagMessage, dismissFlag: dismissFlag, showFeedbackCollector: showFeedbackCollector, appearance: appearance = 'subtle', spacing: spacing = 'default', useTheme: useTheme = false, useSideNavButton: useSideNavButton = false })=>{
    const openFeedbackCollector = $fc4bM.useCallback(()=>{
        const showFeedbackCollectorPayload = {
            env: env,
            showTypeField: showTypeField,
            featureName: featureName,
            shouldOpenFeedbackWidget: true
        };
        if (dismissFlagMessage) {
            const successFlag = flags.filter(// @ts-ignore TS(2532) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Object is possibly 'undefined'.
            (flag)=>flag.titleMessage.defaultMessage.localeCompare(dismissFlagMessage.defaultMessage) === 0)[0];
            successFlag && dismissFlag(successFlag.id);
        }
        showFeedbackCollector(showFeedbackCollectorPayload);
    }, [
        env,
        showTypeField,
        featureName,
        dismissFlagMessage,
        flags,
        dismissFlag,
        showFeedbackCollector
    ]);
    if (useSideNavButton) return /*#__PURE__*/ $fc4bM.createElement((0, $3yZwQ.ButtonItem), {
        iconBefore: showIcon ? /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24pGP))), {
            spacing: "spacious",
            label: ""
        }) : undefined,
        onClick: openFeedbackCollector
    }, intl.formatMessage(buttonLabel));
    const ButtonComponent = useTheme ? (0, $iK1uY.ThemedButton) : (0, $MPQAF.Button);
    return /*#__PURE__*/ $fc4bM.createElement(ButtonComponent, {
        iconBefore: showIcon ? /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24pGP))), {
            spacing: "spacious",
            label: "feedback"
        }) : undefined,
        appearance: appearance,
        onClick: openFeedbackCollector,
        actionSubjectId: analyticsSubjectId,
        spacing: spacing
    }, intl.formatMessage(buttonLabel));
};

});
parcelRegister("iK1uY", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $db4a7ef207717744$export$f67fb575035cc7d0);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $MPQAF = parcelRequire("MPQAF");

var $jQpH9 = parcelRequire("jQpH9");

var $h46Vs = parcelRequire("h46Vs");
const $db4a7ef207717744$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $luz1X.withTheme)(({ innerRef: innerRef, ...props })=>/*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.ThemedButton), {
        ...props,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...styles } = currentTheme(themeProps);
            let customTheme;
            if (props.appearance === 'primary' && !props.isDisabled) {
                const backgroundColor = {
                    default: props.theme.color,
                    focus: props.theme.color,
                    hover: (0, $jQpH9.lighten)(0.05, props.theme.color),
                    active: (0, $jQpH9.darken)(0.05, props.theme.color)
                };
                customTheme = {
                    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    // Suppressing existing violation. Please fix this.
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    backgroundColor: props.overrideThemeColor || backgroundColor[themeProps.state],
                    color: `${props.theme.readableTextColor} !important` // we need to add !important here for buttons with the href attribute
                };
            }
            if (props.appearance === 'link') {
                const primaryColor = props.overrideThemeColor || props.theme.color;
                const generatedThemeVariations = (0, $h46Vs.generateThemeBranding)(primaryColor);
                customTheme = {
                    color: `${generatedThemeVariations.color900} !important`
                };
            }
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...customTheme
                },
                ...styles
            };
        }
    }));

});

parcelRegister("3yZwQ", function(module, exports) {
$parcel$export(module.exports, "ButtonItem", () => $77f46203dc0a45b8$export$2b4d63c9ba9e72d1);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $eaozo = parcelRequire("eaozo");

var $bRQHU = parcelRequire("bRQHU");
const $77f46203dc0a45b8$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    rootMotion: "_v564hxmd _o7kshxmd _1ggl87vo",
    selectedMotion: "_v5641rrn _o7kshxmd _1ggl87vo"
};
const $77f46203dc0a45b8$export$2b4d63c9ba9e72d1 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $bRQHU.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eaozo.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            $77f46203dc0a45b8$var$styles.root,
            $77f46203dc0a45b8$var$styles.rootMotion,
            props.isSelected && $77f46203dc0a45b8$var$styles.selectedStyles,
            props.isSelected && $77f46203dc0a45b8$var$styles.selectedMotion,
            className
        ]),
        ...props
    });
});

});
parcelRegister("eaozo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bafa6112e09c2644$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fVzQQ = parcelRequire("fVzQQ");

var $8SiHp = parcelRequire("8SiHp");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $bafa6112e09c2644$var$ButtonItem = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8SiHp.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $3LM7S.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $bafa6112e09c2644$export$2e2bcd8739ae039 = $bafa6112e09c2644$var$ButtonItem;

});
parcelRegister("8SiHp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e13b0143a63d3a8$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $i3riz = parcelRequire("i3riz");

var $7kcwn = parcelRequire("7kcwn");

var $8ZObF = parcelRequire("8ZObF");
const $8e13b0143a63d3a8$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        ...props
    });
const $8e13b0143a63d3a8$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
const $8e13b0143a63d3a8$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $8e13b0143a63d3a8$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $8e13b0143a63d3a8$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $fc4bM.useContext)((0, $7kcwn.SpacingContext));
    const selectionStyle = (0, $fc4bM.useContext)((0, $8ZObF.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $2R2iS.default)([
                (0, $2R2iS.default)([
                    $8e13b0143a63d3a8$var$styles.root,
                    $8e13b0143a63d3a8$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $8e13b0143a63d3a8$var$styles.unselected,
                    !isDisabled && !isSelected && $8e13b0143a63d3a8$var$styles.motionUnselected,
                    !isDisabled && isSelected && $8e13b0143a63d3a8$var$styles.selected,
                    !isDisabled && isSelected && $8e13b0143a63d3a8$var$styles.motionSelected,
                    !isDisabled && isSelected && $8e13b0143a63d3a8$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $8e13b0143a63d3a8$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $8e13b0143a63d3a8$var$styles.selectedNotch,
                    isDisabled && $8e13b0143a63d3a8$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $8e13b0143a63d3a8$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $2R2iS.default)([
                            $8e13b0143a63d3a8$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                        className: (0, $2R2iS.default)([
                            $8e13b0143a63d3a8$var$styles.content
                        ]),
                        children: [
                            $8e13b0143a63d3a8$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $2R2iS.default)([
                                    $8e13b0143a63d3a8$var$styles.title,
                                    shouldTitleWrap ? $8e13b0143a63d3a8$var$styles.wordBreak : $8e13b0143a63d3a8$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $2R2iS.default)([
                                    $8e13b0143a63d3a8$var$styles.description,
                                    isDisabled && $8e13b0143a63d3a8$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $8e13b0143a63d3a8$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $8e13b0143a63d3a8$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $2R2iS.default)([
                            $8e13b0143a63d3a8$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
var $8e13b0143a63d3a8$export$2e2bcd8739ae039 = $8e13b0143a63d3a8$var$MenuItemPrimitive;

});
parcelRegister("7kcwn", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $60b28e07ade617a8$export$443076ec7ebce042);

var $fc4bM = parcelRequire("fc4bM");
const $60b28e07ade617a8$export$443076ec7ebce042 = /*#__PURE__*/ (0, $fc4bM.createContext)('cozy');

});

parcelRegister("8ZObF", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $ef0c9c4df3586c1e$export$9ca534b70725964d);

var $fc4bM = parcelRequire("fc4bM");
const $ef0c9c4df3586c1e$export$9ca534b70725964d = /*#__PURE__*/ (0, $fc4bM.createContext)('border');

});



parcelRegister("bRQHU", function(module, exports) {
$parcel$export(module.exports, "useShouldNestedElementRender", () => $bf13103946463976$export$37e8646a1abfc3e6);

var $fc4bM = parcelRequire("fc4bM");

var $dgK4T = parcelRequire("dgK4T");
const $bf13103946463976$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $fc4bM.useContext)((0, $dgK4T.NestedContext));
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});
parcelRegister("dgK4T", function(module, exports) {
$parcel$export(module.exports, "NestedContext", () => $f6b7da0cfca0deee$export$46b2c2071c8c725a);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");
const $f6b7da0cfca0deee$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});





parcelRegister("eo3iN", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => (parcelRequire("jigFz")).BrandingPreviewBanner);

var $jigFz = parcelRequire("jigFz");

});
parcelRegister("jigFz", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => $c5796576d323f87d$export$f6521d01859545a5);
/* branding-preview-banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $bqWPH = parcelRequire("bqWPH");

var $9TDk5 = parcelRequire("9TDk5");
const $c5796576d323f87d$export$f6521d01859545a5 = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c5796576d323f87d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c5796576d323f87d$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bqWPH))), {
        label: "watch-icon",
        size: "small",
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", null, formatMessage((0, $9TDk5.default).brandingPreviewText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c5796576d323f87d$var$Wrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt412x7 _1e0c1txw _1bah1h6o _syaz15cr",
            __cmplp.className
        ])
    });
});
const $c5796576d323f87d$var$IconWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt4otz2 _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bqWPH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f89c1aa1a1fc190805d6b0905c17361>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $852fc25f89a43f73$var$_react = $852fc25f89a43f73$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $852fc25f89a43f73$var$_iconNew = $852fc25f89a43f73$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $852fc25f89a43f73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open
 * Usage guidance:
 * Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $852fc25f89a43f73$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $852fc25f89a43f73$var$_react.default.createElement($852fc25f89a43f73$var$_iconNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$852fc25f89a43f73$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $852fc25f89a43f73$var$_default = module.exports.default = $852fc25f89a43f73$var$EyeOpenIcon;

});

parcelRegister("9TDk5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc6a2ea893e67dad$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $bc6a2ea893e67dad$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    brandingPreviewText: {
        defaultMessage: 'You are currently previewing your global branding changes',
        description: 'Global Branding Preview Banner Text',
        id: 'cv.branding.preview.banner.text.non-final'
    }
});

});



parcelRegister("44Krk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a41d4913f2d4f09f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $3zBNx = parcelRequire("3zBNx");

var $4EPUx = parcelRequire("4EPUx");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $EawnW = parcelRequire("EawnW");

var $k8Adr = parcelRequire("k8Adr");

var $8LiXR = parcelRequire("8LiXR");
const $a41d4913f2d4f09f$var$styles = {
    contentStyles: "_1reo1wug _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $a41d4913f2d4f09f$var$iconColor = {
    connectivity: "_x5v91ft0",
    confirmation: "_x5v94pcx",
    info: "_x5v9qm1h",
    warning: "_x5v9ervl",
    error: "_x5v9s4qr"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $a41d4913f2d4f09f$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    const id = (0, $3zBNx.useId)();
    const toggleDialog = (0, $fc4bM.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $fc4bM.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $a41d4913f2d4f09f$var$styles.rootStyles,
            $a41d4913f2d4f09f$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4EPUx.Popup), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    xcss: $a41d4913f2d4f09f$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $a41d4913f2d4f09f$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8LiXR.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $a41d4913f2d4f09f$export$2e2bcd8739ae039 = $a41d4913f2d4f09f$var$InlineMessage;

});
parcelRegister("4EPUx", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $96bf9c26835dfa91$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3zBNx = parcelRequire("3zBNx");

var $k9Tam = parcelRequire("k9Tam");

var $jlwk8 = parcelRequire("jlwk8");

var $iXBtU = parcelRequire("iXBtU");

var $dRkX9 = parcelRequire("dRkX9");

var $k2PlB = parcelRequire("k2PlB");

var $5q4nr = parcelRequire("5q4nr");

var $cufVT = parcelRequire("cufVT");

var $dBtOK = parcelRequire("dBtOK");

var $3JsGV = parcelRequire("3JsGV");

var $lQh0t = parcelRequire("lQh0t");

var $2JNCT = parcelRequire("2JNCT");

var $dSoQX = parcelRequire("dSoQX");

var $2lVlF = parcelRequire("2lVlF");
const $96bf9c26835dfa91$var$defaultLayer = 400;
const $96bf9c26835dfa91$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $96bf9c26835dfa91$var$PopupLegacy = (props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, zIndex: zIndex = $96bf9c26835dfa91$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $fc4bM.useState)(null);
    const getMergedTriggerRef = (0, $dSoQX.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $2lVlF.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $3zBNx.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $2JNCT.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $fc4bM.useCallback)(()=>{
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $jlwk8.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k9Tam.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3JsGV.default), {
            xcss: xcssPassthrough.value,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: UNSAFE__disableInitialAutoFocus ? false : autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            zIndex: zIndex,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $k2PlB.Manager), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5q4nr.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $dRkX9.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $dRkX9.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $dRkX9.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cufVT.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $dRkX9.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
                appear: true,
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cufVT.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $96bf9c26835dfa91$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
};
const $96bf9c26835dfa91$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $fc4bM.memo)((props)=>{
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $dRkX9.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lQh0t.PopupTopLayer), {
        ...props
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($96bf9c26835dfa91$var$PopupLegacy, {
        ...props
    });
});

});
parcelRegister("k2PlB", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $f743ed1fbb6e45c6$export$d0d38e7dec7a1a61);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $ikgDL = parcelRequire("ikgDL");

var $kwZKX = parcelRequire("kwZKX");

var $9fasA = parcelRequire("9fasA");

var $iBYJt = parcelRequire("iBYJt");
function $f743ed1fbb6e45c6$export$d0d38e7dec7a1a61({ children: children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor: anchor, setAnchor: setAnchor } = (0, $iBYJt.useAnchorState)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ikgDL.Manager), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9fasA.AnchorSetterContext).Provider, {
            value: setAnchor,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kwZKX.AnchorContext).Provider, {
                value: anchor,
                children: children
            })
        })
    });
}

});
parcelRegister("9fasA", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $7751ce32a7a977e1$export$804169e6eecdff16);

var $fc4bM = parcelRequire("fc4bM");
const $7751ce32a7a977e1$export$804169e6eecdff16 = /*#__PURE__*/ (0, $fc4bM.createContext)(()=>undefined);

});

parcelRegister("iBYJt", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $7ddad3713501902c$export$1b1b50fdcd7ac375);

var $fc4bM = parcelRequire("fc4bM");
function $7ddad3713501902c$export$1b1b50fdcd7ac375() {
    const [anchor, setAnchor] = (0, $fc4bM.useState)(null);
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("5q4nr", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $1b6446ba8c1286fe$export$e0be378c32fb70a7);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lStGF = parcelRequire("lStGF");

var $4dCfH = parcelRequire("4dCfH");

var $67TJp = parcelRequire("67TJp");
function $1b6446ba8c1286fe$export$e0be378c32fb70a7({ children: children, innerRef: innerRef }) {
    const publishAnchor = (0, $67TJp.useManagerAnchorSetter)();
    const composedRef = (0, $fc4bM.useMemo)(()=>(0, $4dCfH.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lStGF.Reference), {
        innerRef: composedRef,
        children: children
    });
}

});
parcelRegister("lStGF", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $fed5ab5e846c2924$export$e0be378c32fb70a7);

var $fc4bM = parcelRequire("fc4bM");

var $j8RUH = parcelRequire("j8RUH");

var $ikgDL = parcelRequire("ikgDL");

var $58q6a = parcelRequire("58q6a");
function $fed5ab5e846c2924$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $fc4bM.useContext((0, $ikgDL.ManagerReferenceNodeSetterContext));
    var refHandler = $fc4bM.useCallback(function(node) {
        (0, $58q6a.setRef)(innerRef, node);
        (0, $58q6a.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $fc4bM.useEffect(function() {
        return function() {
            return (0, $58q6a.setRef)(innerRef, null);
        };
    }, []);
    $fc4bM.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($j8RUH)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $58q6a.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("j8RUH", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $def895c28307c59e$var$__DEV__ = false;
var $def895c28307c59e$var$warning = function() {};
if ($def895c28307c59e$var$__DEV__) {
    var $def895c28307c59e$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $def895c28307c59e$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $def895c28307c59e$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $def895c28307c59e$var$warning;

});


parcelRegister("67TJp", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $83c0fd40647f979a$export$fcdda419d7091b3);

var $fc4bM = parcelRequire("fc4bM");

var $9fasA = parcelRequire("9fasA");
function $83c0fd40647f979a$export$fcdda419d7091b3() {
    return (0, $fc4bM.useContext)((0, $9fasA.AnchorSetterContext));
}

});


parcelRegister("3JsGV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1593cc7c89cf780$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $8cuhG = parcelRequire("8cuhG");

var $dVK9d = parcelRequire("dVK9d");

var $khBwH = parcelRequire("khBwH");

var $dRkX9 = parcelRequire("dRkX9");

var $dgKcj = parcelRequire("dgKcj");

var $7NBlA = parcelRequire("7NBlA");

var $cHLuW = parcelRequire("cHLuW");

var $3rdAy = parcelRequire("3rdAy");
const $e1593cc7c89cf780$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $e1593cc7c89cf780$var$fullWidthStyles = null;
const $e1593cc7c89cf780$var$wrapperStyles = {
    root: "_2rko1mok _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
const $e1593cc7c89cf780$var$scrollableStyles = null;
const $e1593cc7c89cf780$var$blanketStyles = null;
const $e1593cc7c89cf780$var$modalStyles = null;
const $e1593cc7c89cf780$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $e1593cc7c89cf780$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $e1593cc7c89cf780$var$DefaultPopupComponent = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            $e1593cc7c89cf780$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $dRkX9.fg)('platform-dst-motion-uplift-popup') ? ref : undefined,
        children: children
    });
});
function $e1593cc7c89cf780$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $e1593cc7c89cf780$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $fc4bM.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $fc4bM.useState)(null);
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $3rdAy.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $cHLuW.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $8cuhG.useLayering)();
    const mergedModifiers = (0, $fc4bM.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dgKcj.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $3LM7S.jsx)(PopupContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $2R2iS.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $dRkX9.fg)('platform-design-system-apply-popup-wrapper-focus') && $e1593cc7c89cf780$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $dRkX9.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: (0, $dRkX9.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7NBlA.RepositionOnUpdate), {
                    update: update,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                        children: content({
                            update: update,
                            isOpen: isOpen,
                            onClose: onClose,
                            setInitialFocusRef: setInitialFocusRef
                        })
                    })
                })
            });
            const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
            const container = /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: zIndex
                },
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $2R2iS.default)([
                    shouldFitContainer && $e1593cc7c89cf780$var$wrapperStyles.fullWidth
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVK9d.default), {
                    enteringAnimation: !isAutoPlacement ? $e1593cc7c89cf780$var$placementMap[placement].enter : undefined,
                    exitingAnimation: !isAutoPlacement ? $e1593cc7c89cf780$var$placementMap[placement].exit : undefined,
                    xcss: $e1593cc7c89cf780$var$wrapperStyles.motion,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
                children: [
                    (0, $dRkX9.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        className: (0, $2R2iS.default)([
                            "_1r04idpf _kqsw1n9t _bfhk1i5c"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e1593cc7c89cf780$export$2e2bcd8739ae039 = $e1593cc7c89cf780$var$PopperWrapper;

});
parcelRegister("7NBlA", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $40dee774cadd4066$export$51eddd7655ca235a);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $40dee774cadd4066$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $fc4bM.useRef)(true);
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
        children: children
    });
};

});

parcelRegister("cHLuW", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $f805920b829c2d4c$export$92dae2778ae88f9d);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $9JZL9 = parcelRequire("9JZL9");

var $8cuhG = parcelRequire("8cuhG");

var $dRkX9 = parcelRequire("dRkX9");

var $faj9t = parcelRequire("faj9t");

var $6I21v = parcelRequire("6I21v");
const $f805920b829c2d4c$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $8cuhG.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $6I21v.useAnimationFrame)();
    const mouseDownTarget = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $9JZL9.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event)) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    currentLevel = ((_event$target$closest = event.target.closest(`[data-ds--level]`)) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level')) ?? null;
                }
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $dRkX9.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                var _target$closest;
                const layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, `[data-ds--level]`);
                if (layeredElement) {
                    const closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $faj9t.isInteractiveElement)(document.activeElement) && (0, $dRkX9.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $dRkX9.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                const levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $dRkX9.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $9JZL9.default);
        if ((0, $dRkX9.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $6Zi52.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $6Zi52.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $9JZL9.default);
        unbindBlur = (0, $6Zi52.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $dRkX9.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("faj9t", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $2de4b5c8184bb267$export$3dee5e4542c672d9);
const $2de4b5c8184bb267$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $2de4b5c8184bb267$export$3dee5e4542c672d9 = (element)=>{
    if ($2de4b5c8184bb267$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("6I21v", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $3b2af1739cd84c73$export$641fa9c94086b46e);

var $fc4bM = parcelRequire("fc4bM");
const $3b2af1739cd84c73$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $fc4bM.useRef)([]);
    const requestFrame = (0, $fc4bM.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $fc4bM.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $fc4bM.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("3rdAy", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $c7e99ef6d2e08c1f$export$10c5169755ce7bd7);

var $fc4bM = parcelRequire("fc4bM");

var $fL0NK = parcelRequire("fL0NK");

var $9JZL9 = parcelRequire("9JZL9");

var $8cuhG = parcelRequire("8cuhG");

var $dRkX9 = parcelRequire("dRkX9");

var $6I21v = parcelRequire("6I21v");
const $c7e99ef6d2e08c1f$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $6I21v.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $8cuhG.useLayering)();
    (0, $fc4bM.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $9JZL9.default;
        if (shouldDisableFocusTrap && (0, $dRkX9.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $9JZL9.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $dRkX9.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fL0NK)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
            if (((0, $dRkX9.fg)('platform-dst-popup-trigger-focus-fix') || (0, $dRkX9.fg)('platform_dst-popup-trigger-initial-focus-ref')) && shouldReturnFocus) requestFrame(()=>{
                if (triggerRef !== null && triggerRef !== void 0 && triggerRef.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("fL0NK", function(module, exports) {

var $kjjwO = parcelRequire("kjjwO");
var $b78bddefa18af4b3$var$listeningFocusTrap = null;
function $b78bddefa18af4b3$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $b78bddefa18af4b3$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($b78bddefa18af4b3$var$listeningFocusTrap) $b78bddefa18af4b3$var$listeningFocusTrap.pause();
        $b78bddefa18af4b3$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $b78bddefa18af4b3$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $b78bddefa18af4b3$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $b78bddefa18af4b3$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $b78bddefa18af4b3$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $b78bddefa18af4b3$var$tryFocus(lastTabbableNode);
            return $b78bddefa18af4b3$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $b78bddefa18af4b3$var$tryFocus(firstTabbableNode);
        $b78bddefa18af4b3$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $kjjwO(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $b78bddefa18af4b3$var$tryFocus(lastTabbableNode);
        $b78bddefa18af4b3$var$tryFocus(firstTabbableNode);
    }
}
function $b78bddefa18af4b3$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $b78bddefa18af4b3$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $b78bddefa18af4b3$var$focusTrap;

});
parcelRegister("kjjwO", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $ec94bae80645e291$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $ec94bae80645e291$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("lQh0t", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $c206fe5fc36ddd2d$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $khBwH = parcelRequire("khBwH");

var $hjRaA = parcelRequire("hjRaA");

var $j5ggC = parcelRequire("j5ggC");

var $28XcR = parcelRequire("28XcR");

var $aMgNY = parcelRequire("aMgNY");

var $GyLDf = parcelRequire("GyLDf");

var $lz1tR = parcelRequire("lz1tR");

var $02Byl = parcelRequire("02Byl");

var $i3E5d = parcelRequire("i3E5d");

var $a7kKa = parcelRequire("a7kKa");

var $lLwhW = parcelRequire("lLwhW");

var $aoeNp = parcelRequire("aoeNp");
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $c206fe5fc36ddd2d$var$EMPTY_STYLE = {};
/**
 * `Popover` props for `mode`. A manual popover gets `onClose` only when the consumer gave one, so
 * without it `requestClosePopovers()` cannot close the popup.
 */ function $c206fe5fc36ddd2d$var$getModeProps({ isManual: isManual, hasOnClose: hasOnClose, handleOnClose: handleOnClose }) {
    if (!isManual) return {
        mode: 'auto',
        onClose: handleOnClose
    };
    if (!hasOnClose) return {
        mode: 'manual'
    };
    return {
        mode: 'manual',
        onClose: handleOnClose
    };
}
const $c206fe5fc36ddd2d$export$e24b8cb659609dee = /*#__PURE__*/ (0, $fc4bM.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus, trigger: trigger, content: content, onClose: providedOnClose, mode: mode = 'auto', placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, // top-layer: initial focus follows `role`. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
autoFocus: _autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: maps onto `'max-available'`, capping the popup to the space
// between the trigger and the viewport edge. `PopoverSurface` already owns
// `overflow: auto`, so the capped surface scrolls.
//
// Keep the explicit `false`: `undefined` previously reached an
// `isEnabled = true` default and silently enabled fitting for every popup
// that omitted the prop.
shouldFitViewport = false, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const onClose = providedOnClose ?? (0, $9JZL9.default);
    const triggerRef = (0, $fc4bM.useRef)(null);
    const popoverRef = (0, $fc4bM.useRef)(null);
    /**
   * Consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref. `Popover` reads it as `initialFocusRef` when it opens. For a
   * role that moves focus, a target inside the popup takes focus instead
   * of the role default, and focus moves once. Other roles ignore it. `autoFocus` has no effect here: role and focus go
   * together. See `@atlaskit/top-layer` `notes/decisions/role-and-focus.md`.
   */ const consumerInitialFocusRef = (0, $fc4bM.useRef)(null);
    const setInitialFocusRef = (0, $fc4bM.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    const popoverId = (0, $i3E5d.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $fc4bM.useMemo)(()=>(0, $j5ggC.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $lz1tR.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $a7kKa.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $fc4bM.useCallback)(({ reason: reason })=>{
        onClose((0, $aMgNY.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    /**
   * Manual mode: the browser never light-dismisses the popover, so a press on the trigger does not
   * close it. With `onClose`, an outside press or Escape calls it, as on an auto popup. The trigger
   * is exempt.
   */ const isManual = mode === 'manual';
    const triggerRefs = (0, $fc4bM.useMemo)(()=>[
            triggerRef
        ], []);
    const handleManualLightDismiss = (0, $fc4bM.useCallback)(({ reason: reason })=>{
        if (reason !== 'light-dismiss') {
            handleOnClose({
                reason: reason
            });
            return;
        }
        // Native light dismiss does not restore focus, but the consumer's programmatic close does
        // when focus is inside the popover. The press usually moved focus out already. If not (for
        // example an outside `mousedown` called `preventDefault()`), blur first, as an auto light
        // dismiss would.
        const popover = popoverRef.current;
        const activeElement = popover === null || popover === void 0 ? void 0 : popover.ownerDocument.activeElement;
        if (activeElement instanceof HTMLElement && popover !== null && popover !== void 0 && popover.contains(activeElement)) activeElement.blur();
        handleOnClose({
            reason: reason
        });
    }, [
        handleOnClose
    ]);
    (0, $02Byl.useManualLightDismiss)({
        isOpen: isOpen && isManual && Boolean(providedOnClose),
        popoverRef: popoverRef,
        additionalInsideElementRefs: triggerRefs,
        onClose: handleManualLightDismiss
    });
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    // The args always hold the setter; the `TPopup` types decide who can see it.
    const contentProps = (0, $fc4bM.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $9JZL9.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $aoeNp.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId,
        initialFocusRef: consumerInitialFocusRef
    });
    const resolvedPopoverId = providedId ?? popoverId;
    const ariaAttributes = (0, $hjRaA.getAriaForTrigger)({
        role: (0, $lLwhW.getTriggerRole)({
            role: roleProps.role
        }),
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            trigger(triggerProps),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
                ref: popoverRef,
                id: resolvedPopoverId,
                ...roleProps,
                UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus,
                isOpen: isOpen,
                ...$c206fe5fc36ddd2d$var$getModeProps({
                    isManual: isManual,
                    hasOnClose: Boolean(providedOnClose),
                    handleOnClose: handleOnClose
                }),
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--container`,
                children: Container ? /*#__PURE__*/ (0, $3LM7S.jsx)(Container, {
                    style: $c206fe5fc36ddd2d$var$EMPTY_STYLE,
                    id: providedId,
                    "data-placement": placement,
                    "data-testid": testId,
                    tabIndex: -1,
                    xcss: xcss,
                    // Forwarded because several in-tree containers key their own
                    // `overflow: auto` branch off it.
                    shouldFitViewport: shouldFitViewport,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                        children: content(contentProps)
                    })
                }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
                // same element, so it is the scroll container. The wrapper exists only
                // to carry the consumer's `xcss`: `PopoverSurface` exposes no
                // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
                // surface. `width` works there; surface-level declarations apply one
                // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $28XcR.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: xcss,
                        "data-testid": testId,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khBwH.default), {
                            children: content(contentProps)
                        })
                    })
                })
            })
        ]
    });
});

});
parcelRegister("hjRaA", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $246c495a0944deb6$export$9dd1d61dd4d4755);
/**
 * The `aria-haspopup` value for each role in `TAriaForTriggerRole`: the popup type that the
 * trigger announces. ARIA has no `alertdialog` value, so `alertdialog` uses `'dialog'`.
 *
 * `true` is not a value. The function returns only the explicit tokens, never
 * `aria-haspopup="true"`.
 */ const $246c495a0944deb6$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $246c495a0944deb6$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `aria-controls` is `undefined` while closed: the popover element is not in the DOM after its
    // exit animation, so the `id` would point to nothing.
    return {
        'aria-haspopup': role ? $246c495a0944deb6$var$roleToAriaHasPopup[role] : undefined,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("28XcR", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $75a7b33b2ca0ea88$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $75a7b33b2ca0ea88$var$styles = {
    root: "_2rko1mok _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $75a7b33b2ca0ea88$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            $75a7b33b2ca0ea88$var$styles.root
        ]),
        children: children
    });
}

});

parcelRegister("aMgNY", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $4195cda4cf7131da$export$27b4de066896ac63);
function $4195cda4cf7131da$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("02Byl", function(module, exports) {
$parcel$export(module.exports, "useManualLightDismiss", () => $ac85e4194fafc189$export$798a205e5e823858);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $DNksS = parcelRequire("DNksS");

var $bhmax = parcelRequire("bhmax");

var $hAQA2 = parcelRequire("hAQA2");

var $8GcYV = parcelRequire("8GcYV");

var $ks7MS = parcelRequire("ks7MS");

var $8tWJs = parcelRequire("8tWJs");

var $Sw0le = parcelRequire("Sw0le");

var $fLKU9 = parcelRequire("fLKU9");

var $gKA44 = parcelRequire("gKA44");

var $6j6ur = parcelRequire("6j6ur");

var $kFmHs = parcelRequire("kFmHs");
function $ac85e4194fafc189$export$798a205e5e823858({ popoverRef: popoverRef, mode: mode = 'popover', additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onClose: onClose }) {
    // Latest callback, so the listeners do not re-bind each render.
    const onCloseRef = (0, $fc4bM.useRef)(onClose);
    onCloseRef.current = onClose;
    const isPopover = mode === 'popover';
    (0, $fLKU9.useStartOpenOrderTracking)();
    (0, $kFmHs.useOutsidePress)({
        elementRef: popoverRef,
        additionalInsideElementRefs: additionalInsideElementRefs,
        isOpen: isOpen,
        onOutsidePress: ()=>onCloseRef.current({
                reason: 'light-dismiss'
            })
    });
    // Page surface: Escape closes it only while no owner is above it.
    (0, $6j6ur.useCloseOnUnclaimedEscape)({
        isEnabled: isOpen && !isPopover,
        onClose: ()=>onCloseRef.current({
                reason: 'escape'
            }),
        surfaceRef: popoverRef
    });
    // A passive effect, not a layout effect, so SSR in a DOM test environment does not warn. Until it
    // runs, the popover is not marked or listening.
    (0, $fc4bM.useEffect)(()=>{
        if (!isOpen || !isPopover) return;
        const popover = popoverRef.current;
        // Other layers find layers by `[popover]`, and the open order comes from `beforetoggle`. A plain
        // element has neither.
        (0, $DNksS.default)(!popover || popover.hasAttribute('popover'), "useManualLightDismiss: `popoverRef` must be a `[popover]` element. Use `mode: 'page-surface'` for an element that is not in the top layer.");
        // The open order lives outside the hook, so an effect re-run keeps it. A popover that opened
        // before tracking started is ordered from now.
        if (popover) (0, $Sw0le.openOrderTracker).ensureOpenOrder({
            element: popover
        });
        return (0, $bhmax.combine)(// Mark it as a layer that takes Escape, for other layers' checks.
        popover ? (0, $gKA44.setAttribute)({
            element: popover,
            name: (0, $8tWJs.manualEscapeLayerAttribute),
            value: ''
        }) : undefined, // Target and phase matter. See the listener order in `claim-escape`.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Escape reaches the popover from anywhere on the page
        (0, $6Zi52.bind)(document, {
            type: 'keydown',
            listener (event) {
                if (!(0, $ks7MS.isEscapeToHandle)({
                    event: event
                })) return;
                const element = popoverRef.current;
                // Not attached: no place in the stack. Nothing dismisses, and the Escape goes on to the
                // next layer.
                if (!element) return;
                if ((0, $8GcYV.hasEscapeOwnerAbove)({
                    element: element,
                    isLayer: true
                })) return;
                // Take the Escape even if `onClose` keeps the popover open, as a native close watcher
                // does: an ancestor `Dialog` sees `defaultPrevented`, and the browser sends no close
                // request to an ancestor auto popover. A held-key repeat is taken but does not call
                // `onClose`.
                if (!(0, $hAQA2.claimEscape)({
                    event: event
                })) return;
                onCloseRef.current({
                    reason: 'escape'
                });
            }
        }));
    }, [
        isOpen,
        isPopover,
        popoverRef
    ]);
}

});
parcelRegister("6j6ur", function(module, exports) {
$parcel$export(module.exports, "useCloseOnUnclaimedEscape", () => $030f0bcf439c5030$export$30d0a7083b150871);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $bhmax = parcelRequire("bhmax");

var $hAQA2 = parcelRequire("hAQA2");

var $3sogF = parcelRequire("3sogF");

var $471Vs = parcelRequire("471Vs");

var $8GcYV = parcelRequire("8GcYV");

var $ks7MS = parcelRequire("ks7MS");

var $i9zuG = parcelRequire("i9zuG");

var $fLKU9 = parcelRequire("fLKU9");

var $gKA44 = parcelRequire("gKA44");
/**
 * `true` when `surface` is inside an open layer that takes Escape.
 */ function $030f0bcf439c5030$var$isInsideOpenLayer({ surface: surface }) {
    return (0, $3sogF.getNearestContainingLayer)({
        element: surface,
        layers: (0, $471Vs.getOpenLayersTakingEscape)({
            within: surface.ownerDocument
        })
    }) !== null;
}
/**
 * `true` when the document has an open layer that takes Escape, or a marked page surface.
 */ function $030f0bcf439c5030$var$hasAnyEscapeOwner({ ownerDocument: ownerDocument }) {
    return (0, $471Vs.getOpenLayersTakingEscape)({
        within: ownerDocument
    }).length > 0 || ownerDocument.querySelector(`[${(0, $i9zuG.pageSurfaceEscapeAttribute)}]`) !== null;
}
/**
 * `true` when an Escape owner is above the surface. With no surface element, the surface is the
 * whole page, so every owner is inside it, and above it.
 */ function $030f0bcf439c5030$var$hasEscapeOwnerAboveSurface({ surface: surface, target: target }) {
    if (surface) return (0, $8GcYV.hasEscapeOwnerAbove)({
        element: surface
    });
    return $030f0bcf439c5030$var$hasAnyEscapeOwner({
        ownerDocument: target instanceof Document ? target : target.ownerDocument
    });
}
function $030f0bcf439c5030$export$30d0a7083b150871({ isEnabled: isEnabled, onClose: onClose, shouldClose: shouldClose, targetRef: targetRef, surfaceRef: surfaceRef }) {
    // Latest callbacks, so the listener does not re-bind each render.
    const onCloseRef = (0, $fc4bM.useRef)(onClose);
    onCloseRef.current = onClose;
    const shouldCloseRef = (0, $fc4bM.useRef)(shouldClose);
    shouldCloseRef.current = shouldClose;
    (0, $fLKU9.useStartOpenOrderTracking)();
    (0, $fc4bM.useEffect)(()=>{
        if (!isEnabled) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- page surfaces listen on the document by default
        const target = targetRef ? targetRef.current : document;
        if (!target) return;
        // A manual popover around the surface also listens on `document` and may run first. The mark
        // tells it to leave the Escape to this surface. On an element target this listener runs first
        // anyway.
        const surfaceToMark = target instanceof HTMLElement ? null : (surfaceRef === null || surfaceRef === void 0 ? void 0 : surfaceRef.current) ?? null;
        return (0, $bhmax.combine)(surfaceToMark ? (0, $gKA44.setAttribute)({
            element: surfaceToMark,
            name: (0, $i9zuG.pageSurfaceEscapeAttribute),
            value: ''
        }) : undefined, // Target and phase matter. See the listener order in `claim-escape`.
        (0, $6Zi52.bind)(target, {
            type: 'keydown',
            listener (event) {
                if (!(0, $ks7MS.isEscapeToHandle)({
                    event: event
                })) return;
                const surface = (surfaceRef === null || surfaceRef === void 0 ? void 0 : surfaceRef.current) ?? (target instanceof HTMLElement ? target : null);
                if ($030f0bcf439c5030$var$hasEscapeOwnerAboveSurface({
                    surface: surface,
                    target: target
                })) return;
                const isInsideLayer = surface !== null && $030f0bcf439c5030$var$isInsideOpenLayer({
                    surface: surface
                });
                // `shouldClose` runs before `claimEscape()`, so it sees the event as not yet claimed.
                const shouldCloseSurface = !event.repeat && (!shouldCloseRef.current || shouldCloseRef.current({
                    event: event
                }));
                // Take the Escape even on a veto or repeat, so the layer around the surface stays open.
                if (isInsideLayer) (0, $hAQA2.claimEscape)({
                    event: event
                });
                if (!shouldCloseSurface) return;
                onCloseRef.current({
                    event: event
                });
            }
        }));
    }, [
        isEnabled,
        surfaceRef,
        targetRef
    ]);
}

});

parcelRegister("kFmHs", function(module, exports) {
$parcel$export(module.exports, "useOutsidePress", () => $b148cff6768d79b7$export$8e766307d54318cb);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");
function $b148cff6768d79b7$var$isInside({ ref: ref, target: target }) {
    var _ref$current;
    return Boolean((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(target));
}
function $b148cff6768d79b7$export$8e766307d54318cb({ elementRef: elementRef, additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onOutsidePress: onOutsidePress }) {
    const onOutsidePressRef = (0, $fc4bM.useRef)(onOutsidePress);
    onOutsidePressRef.current = onOutsidePress;
    // Read at event time, so a new (inline) array does not re-bind the listeners mid-press.
    const additionalInsideElementRefsRef = (0, $fc4bM.useRef)(additionalInsideElementRefs);
    additionalInsideElementRefsRef.current = additionalInsideElementRefs;
    (0, $fc4bM.useEffect)(()=>{
        if (!isOpen) return;
        function isOutside({ target: target }) {
            var _additionalInsideElem;
            // Without the element, nothing is outside it.
            if (!(target instanceof Node) || !elementRef.current) return false;
            return !($b148cff6768d79b7$var$isInside({
                ref: elementRef,
                target: target
            }) || (_additionalInsideElem = additionalInsideElementRefsRef.current) !== null && _additionalInsideElem !== void 0 && _additionalInsideElem.some((ref)=>$b148cff6768d79b7$var$isInside({
                    ref: ref,
                    target: target
                })));
        }
        /**
     * Whether the current press started outside. The press that opened the popover came before
     * the listeners were bound, so it cannot dismiss.
     */ const press = {
            isStartedOutside: false
        };
        return (0, $6Zi52.bindAll)(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- light dismiss listens on the whole document
        document, [
            {
                type: 'pointerdown',
                listener (event) {
                    press.isStartedOutside = isOutside({
                        target: event.target
                    });
                }
            },
            {
                // As native light dismiss: dismiss when a press that started outside ends outside.
                type: 'pointerup',
                listener (event) {
                    const isStartedOutside = press.isStartedOutside;
                    press.isStartedOutside = false;
                    if (!isStartedOutside || !isOutside({
                        target: event.target
                    })) return;
                    onOutsidePressRef.current();
                }
            },
            {
                // A touch scroll or a native drag ends the press with no `pointerup`.
                type: 'pointercancel',
                listener () {
                    press.isStartedOutside = false;
                }
            }
        ], // Capture, so `stopPropagation()` on the target does not stop the dismiss.
        {
            capture: true
        });
    }, [
        isOpen,
        elementRef
    ]);
}

});


parcelRegister("a7kKa", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $85651499df26cd41$export$60eb6c71554f82c4);
function $85651499df26cd41$export$60eb6c71554f82c4({ shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport }) {
    const blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("lLwhW", function(module, exports) {
$parcel$export(module.exports, "getTriggerRole", () => $3b30e33e0d7177a7$export$7647c858fbf2aa3);
/**
 * Narrows a popup `role` to one that `getAriaForTrigger` accepts.
 *
 * Tooltip-family roles and no role give `undefined`, so the trigger gets no `aria-haspopup`.
 */ function $3b30e33e0d7177a7$export$7647c858fbf2aa3({ role: role }) {
    if (role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox' || role === 'tree' || role === 'grid') return role;
    return undefined;
}

});

parcelRegister("aoeNp", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $91cddcb609671c09$export$892580369e97d8b9);

var $fc4bM = parcelRequire("fc4bM");
function $91cddcb609671c09$export$892580369e97d8b9({ role: role, label: label, titleId: titleId, initialFocusRef: initialFocusRef }) {
    return (0, $fc4bM.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId,
                initialFocusRef: initialFocusRef
            };
            return {
                role: role,
                label: label ?? 'Popup',
                initialFocusRef: initialFocusRef
            };
        }
        if (role === 'listbox') return {
            role: role,
            label: label,
            initialFocusRef: initialFocusRef
        };
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId,
        initialFocusRef
    ]);
}

});


parcelRegister("2JNCT", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $9b94a1b57e405260$export$4065aef1d79a5730);

var $fc4bM = parcelRequire("fc4bM");

var $9YEIZ = parcelRequire("9YEIZ");
function $9b94a1b57e405260$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
   * Only subscribe to the below-sm boundary when the popup can become a modal,
   * to avoid unnecessary state changes for every other popup
   */ const mq = (0, $9YEIZ.UNSAFE_useMediaQuery)('below.sm', canBecomeModal ? (e)=>{
        setIsSmallViewport(!!e.matches);
    } : undefined);
    const [isSmallViewport, setIsSmallViewport] = (0, $fc4bM.useState)(!!(mq !== null && mq !== void 0 && mq.matches));
    const appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("9YEIZ", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $c72c98c74d45594d$export$49e55ae2c03d6045);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $jSdow = parcelRequire("jSdow");
var $c72c98c74d45594d$var$_window, $c72c98c74d45594d$var$_window$matchMedia, $c72c98c74d45594d$var$_window2, $c72c98c74d45594d$var$_window2$matchMedia, $c72c98c74d45594d$var$_window3, $c72c98c74d45594d$var$_window3$matchMedia, $c72c98c74d45594d$var$_window4, $c72c98c74d45594d$var$_window4$matchMedia, $c72c98c74d45594d$var$_window5, $c72c98c74d45594d$var$_window5$matchMedia, $c72c98c74d45594d$var$_window6, $c72c98c74d45594d$var$_window6$matchMedia, $c72c98c74d45594d$var$_window7, $c72c98c74d45594d$var$_window7$matchMedia, $c72c98c74d45594d$var$_window8, $c72c98c74d45594d$var$_window8$matchMedia, $c72c98c74d45594d$var$_window9, $c72c98c74d45594d$var$_window9$matchMedia, $c72c98c74d45594d$var$_window0, $c72c98c74d45594d$var$_window0$matchMedia, $c72c98c74d45594d$var$_window1, $c72c98c74d45594d$var$_window1$matchMedia;
const $c72c98c74d45594d$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window = window) === null || $c72c98c74d45594d$var$_window === void 0 || ($c72c98c74d45594d$var$_window$matchMedia = $c72c98c74d45594d$var$_window.matchMedia) === null || $c72c98c74d45594d$var$_window$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window$matchMedia.call($c72c98c74d45594d$var$_window, (0, $jSdow.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window2 = window) === null || $c72c98c74d45594d$var$_window2 === void 0 || ($c72c98c74d45594d$var$_window2$matchMedia = $c72c98c74d45594d$var$_window2.matchMedia) === null || $c72c98c74d45594d$var$_window2$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window2$matchMedia.call($c72c98c74d45594d$var$_window2, (0, $jSdow.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window3 = window) === null || $c72c98c74d45594d$var$_window3 === void 0 || ($c72c98c74d45594d$var$_window3$matchMedia = $c72c98c74d45594d$var$_window3.matchMedia) === null || $c72c98c74d45594d$var$_window3$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window3$matchMedia.call($c72c98c74d45594d$var$_window3, (0, $jSdow.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window4 = window) === null || $c72c98c74d45594d$var$_window4 === void 0 || ($c72c98c74d45594d$var$_window4$matchMedia = $c72c98c74d45594d$var$_window4.matchMedia) === null || $c72c98c74d45594d$var$_window4$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window4$matchMedia.call($c72c98c74d45594d$var$_window4, (0, $jSdow.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window5 = window) === null || $c72c98c74d45594d$var$_window5 === void 0 || ($c72c98c74d45594d$var$_window5$matchMedia = $c72c98c74d45594d$var$_window5.matchMedia) === null || $c72c98c74d45594d$var$_window5$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window5$matchMedia.call($c72c98c74d45594d$var$_window5, (0, $jSdow.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window6 = window) === null || $c72c98c74d45594d$var$_window6 === void 0 || ($c72c98c74d45594d$var$_window6$matchMedia = $c72c98c74d45594d$var$_window6.matchMedia) === null || $c72c98c74d45594d$var$_window6$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window6$matchMedia.call($c72c98c74d45594d$var$_window6, (0, $jSdow.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window7 = window) === null || $c72c98c74d45594d$var$_window7 === void 0 || ($c72c98c74d45594d$var$_window7$matchMedia = $c72c98c74d45594d$var$_window7.matchMedia) === null || $c72c98c74d45594d$var$_window7$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window7$matchMedia.call($c72c98c74d45594d$var$_window7, (0, $jSdow.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window8 = window) === null || $c72c98c74d45594d$var$_window8 === void 0 || ($c72c98c74d45594d$var$_window8$matchMedia = $c72c98c74d45594d$var$_window8.matchMedia) === null || $c72c98c74d45594d$var$_window8$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window8$matchMedia.call($c72c98c74d45594d$var$_window8, (0, $jSdow.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window9 = window) === null || $c72c98c74d45594d$var$_window9 === void 0 || ($c72c98c74d45594d$var$_window9$matchMedia = $c72c98c74d45594d$var$_window9.matchMedia) === null || $c72c98c74d45594d$var$_window9$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window9$matchMedia.call($c72c98c74d45594d$var$_window9, (0, $jSdow.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window0 = window) === null || $c72c98c74d45594d$var$_window0 === void 0 || ($c72c98c74d45594d$var$_window0$matchMedia = $c72c98c74d45594d$var$_window0.matchMedia) === null || $c72c98c74d45594d$var$_window0$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window0$matchMedia.call($c72c98c74d45594d$var$_window0, (0, $jSdow.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($c72c98c74d45594d$var$_window1 = window) === null || $c72c98c74d45594d$var$_window1 === void 0 || ($c72c98c74d45594d$var$_window1$matchMedia = $c72c98c74d45594d$var$_window1.matchMedia) === null || $c72c98c74d45594d$var$_window1$matchMedia === void 0 ? void 0 : $c72c98c74d45594d$var$_window1$matchMedia.call($c72c98c74d45594d$var$_window1, (0, $jSdow.media).below.xl.replace('@media ', '').trim())
};
const $c72c98c74d45594d$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $fc4bM.useRef)(listener);
    (0, $fc4bM.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $c72c98c74d45594d$var$queries[queryString];
    (0, $fc4bM.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $6Zi52.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("jSdow", function(module, exports) {
$parcel$export(module.exports, "media", () => $7ccdf89e2e6fa336$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $7ccdf89e2e6fa336$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("dSoQX", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $88a074a9efedd41c$export$7cc5c058dd769dff);

var $fc4bM = parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");
const $88a074a9efedd41c$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $fc4bM.useState)(()=>(0, $jiju3.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("2lVlF", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $96e4d9a58ff231fd$export$5d3a2de79e07b376);

var $fc4bM = parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");
const $96e4d9a58ff231fd$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $fc4bM.useState)(()=>(0, $jiju3.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("8LiXR", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc808b1ee4dbc74b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jDPaS = parcelRequire("jDPaS");
const $dc808b1ee4dbc74b$var$iconColor = {
    connectivity: "_syaz1ft0",
    confirmation: "_syaz4pcx",
    info: "_syazqm1h",
    warning: "_syazervl",
    error: "_syazs4qr"
};
const $dc808b1ee4dbc74b$var$iconWrapperStyles = null;
const $dc808b1ee4dbc74b$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $dc808b1ee4dbc74b$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $jDPaS.typesMapping);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $2R2iS.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o",
            $dc808b1ee4dbc74b$var$iconColor[appearance],
            isOpen && "_syaz1kum"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $dc808b1ee4dbc74b$export$2e2bcd8739ae039 = $dc808b1ee4dbc74b$var$SelectedIcon;

});
parcelRegister("jDPaS", function(module, exports) {
$parcel$export(module.exports, "typesMapping", () => $7e417e698177fa55$export$4d111645c0b39d5d);

var $gDsF8 = parcelRequire("gDsF8");

var $fKWgA = parcelRequire("fKWgA");

var $fBVBf = parcelRequire("fBVBf");

var $7ZdBj = parcelRequire("7ZdBj");
const $7e417e698177fa55$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("kMCZr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0728a99ba910577e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $0728a99ba910577e$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    backToSettings: {
        defaultMessage: 'Cancel',
        description: 'Action label for the cancel/back button in the action bar of the help center layout builder screen',
        id: 'cv.portal.customization.action.cancel.help.center.settings'
    },
    giveFeedback: {
        defaultMessage: 'Give feedback',
        description: 'Action label for the give feedback button in the action bar of the help center layout builder screen',
        id: 'cv.portal.customization.action.give.feedback.help.center.settings'
    },
    publish: {
        defaultMessage: 'Publish',
        description: 'Label for the publish button in the action bar of the help center layout builder',
        id: 'cv.portal.customization.action.publish.layout.label'
    },
    preview: {
        defaultMessage: 'Preview',
        description: 'Label for the preview button in the action bar of the help center layout builder',
        id: 'cv.portal.customization.action.preview.layout.label'
    },
    previewMessage: {
        defaultMessage: 'This is a preview of the changes you made to the page layout.',
        description: 'Informational message displayed in the action bar when the user is previewing layout changes in the help center layout builder',
        id: 'cv.portal.customization.action.preview.layout.message'
    },
    exitPreview: {
        defaultMessage: 'Back',
        description: 'Label for the back button that exits the preview mode in the help center layout builder',
        id: 'cv.portal.customization.action.exit.preview.layout.label'
    }
});

});




parcelRegister("cjFOK", function(module, exports) {
$parcel$export(module.exports, "ViewHomepageResource", () => $4b8c9d8b6a136e7b$export$6527e8b974db86ba);
$parcel$export(module.exports, "searchComponentVirtualAgentResource", () => $4b8c9d8b6a136e7b$export$b92a87df2da13e74);

var $6LH8a = parcelRequire("6LH8a");

var $drLWP = parcelRequire("drLWP");

var $33BYp = parcelRequire("33BYp");

var $k2M4v = parcelRequire("k2M4v");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $8zK3E = parcelRequire("8zK3E");

var $luyS0 = parcelRequire("luyS0");
const $4b8c9d8b6a136e7b$export$6527e8b974db86ba = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) ? (0, $8zK3E.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $33BYp.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}) : (0, $8zK3E.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $drLWP.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $4b8c9d8b6a136e7b$export$b92a87df2da13e74 = (0, $8zK3E.createRelayResource)({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, isUserLoggedIn: isUserLoggedIn })=>{
        const isLoggedIn = (0, $k2M4v.default).checkGate('jsd-search-router-login-logic-removal') ? Boolean((0, $6LH8a.getMeta)('ajs-atlassian-account-id')) : isUserLoggedIn;
        return {
            parameters: (0, $luyS0.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: isLoggedIn
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("drLWP", function(module, exports) {
$parcel$export(module.exports, "default", () => $927e08ab3ccdd358$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<528eb58a638804d653f316e7c8c17c1d>>
 * @relayHash 52150ef5f0d7c47144a859118fbd07a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14c76222fff73d5c344c4dbaf7f9cbba582818f6f65793980afa0a5fcbe0c9b0
const $927e08ab3ccdd358$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14c76222fff73d5c344c4dbaf7f9cbba582818f6f65793980afa0a5fcbe0c9b0",
            "metadata": {},
            "name": "viewHomepageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$927e08ab3ccdd358$var$node.hash = "42b522e52d1baf895f59577f86f4867c";
var $927e08ab3ccdd358$export$2e2bcd8739ae039 = $927e08ab3ccdd358$var$node;

});

parcelRegister("33BYp", function(module, exports) {
$parcel$export(module.exports, "default", () => $55241e5aa34a4a3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<458f53226bb2432219d88352bf96afc7>>
 * @relayHash 75bedb2759687e5e6f48516802def4db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71c95185f2dd2b29635a3a3395cbc06e341c004da231c2e1a9bf5a4c18842223
const $55241e5aa34a4a3a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71c95185f2dd2b29635a3a3395cbc06e341c004da231c2e1a9bf5a4c18842223",
            "metadata": {},
            "name": "viewHomepageForCsmQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$55241e5aa34a4a3a$var$node.hash = "6e15b917f113b3de216943c357988704";
var $55241e5aa34a4a3a$export$2e2bcd8739ae039 = $55241e5aa34a4a3a$var$node;

});

parcelRegister("8zK3E", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $61b7112f74aa524f$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $61b7112f74aa524f$export$42ca7b248c7aaee);

var $hN5YJ = parcelRequire("hN5YJ");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");
var $VTASg = parcelRequire("VTASg");

var $5KQKg = parcelRequire("5KQKg");

var $1xOZp = parcelRequire("1xOZp");
const $61b7112f74aa524f$export$1cc887c62079ea32 = ({ type: type, getQuery: getQuery })=>(0, $fOvEc.createResource)({
        type: `RELAY_RESOURCE_TYPE_${type}`,
        getKey: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $hN5YJ.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return 'RELAY_RESOURCE_DISABLED';
            }
            //@ts-ignore this key does not really matter since max-age is set to zero. This util is a polyfill and will be done away with once we adopt Relay entry points.
            const request = (0, $5KQKg.getRequest)(parameters);
            const params = request.params;
            const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, options: options, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $hN5YJ.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return Promise.resolve(null);
            }
            const queryReference = (0, $3BZyK.loadQuery)((0, $1xOZp.getRelayEnvironment)(), parameters, variables || {}, options);
            return Promise.resolve(queryReference);
        },
        maxAge: 0
    });
const $61b7112f74aa524f$export$42ca7b248c7aaee = (resource)=>{
    const { refresh: refresh, data: queryReference } = (0, $VTASg.useResource)(resource);
    return {
        queryReference: queryReference,
        refresh: refresh
    };
};

});

parcelRegister("luyS0", function(module, exports) {
$parcel$export(module.exports, "default", () => $789c3f32e9a3227f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cd94073415fdd0bbf4409dae41a9174>>
 * @relayHash 078d7490b0e32c04c06ec9ee114c1d15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da
const $789c3f32e9a3227f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v5 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da",
            "metadata": {},
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$789c3f32e9a3227f$var$node.hash = "fb84e9b37fd41dce66a7b8b53fc81357";
var $789c3f32e9a3227f$export$2e2bcd8739ae039 = $789c3f32e9a3227f$var$node;

});


parcelRegister("hG7Ne", function(module, exports) {
$parcel$export(module.exports, "FlexibleEditpageLoader", () => (parcelRequire("bOyxS")).default);

var $bOyxS = parcelRequire("bOyxS");

});
parcelRegister("bOyxS", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e438dc4522efc4$export$2e2bcd8739ae039);
/* flexible-edit-page-loader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $8PITw = parcelRequire("8PITw");

var $iG0dO = parcelRequire("iG0dO");
parcelRequire("cpuUs");
var $2MBcW = parcelRequire("2MBcW");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $d7r8x = parcelRequire("d7r8x");
const $91e438dc4522efc4$var$SECTION_HEIGHT = 232;
const $91e438dc4522efc4$var$FlexibleEditpageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "flexible-edit-page-loader"
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2MBcW.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $91e438dc4522efc4$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "main",
        xcss: $91e438dc4522efc4$var$skeletonContainerWithSidebar,
        style: {
            marginRight: '340px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $91e438dc4522efc4$var$layoutBuilderWrapper
    }, !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $91e438dc4522efc4$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $iG0dO.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $91e438dc4522efc4$var$sectionLoader,
            key: `flexibleHCLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            "data-testid": "flexible-hc-section-skeleton",
            height: $91e438dc4522efc4$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "aside",
        xcss: $91e438dc4522efc4$var$sidebarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $91e438dc4522efc4$var$breadcrumbContainer
    }, Array(3).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $91e438dc4522efc4$var$breadCrumbItem,
            key: `breadCrumbLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91e438dc4522efc4$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })))), Array(4).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: [
                $91e438dc4522efc4$var$configWrapper,
                index === 0 && $91e438dc4522efc4$var$configWrapper24PxWidth,
                index === 3 && $91e438dc4522efc4$var$configWrapper146PxWidth
            ],
            key: `ConfigPanelLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($91e438dc4522efc4$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))));
};
const $91e438dc4522efc4$var$skeletonContainerWithSidebar = (0, $kig2V.xcss)({
    position: 'relative',
    padding: 'space.150',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: 'elevation.surface.hovered',
    alignItems: 'center',
    overflowY: 'auto',
    height: 'calc(100vh - 56px)'
});
const $91e438dc4522efc4$var$headerContainer = (0, $kig2V.xcss)({
    width: '100%'
});
const $91e438dc4522efc4$var$container = (0, $kig2V.xcss)({
    display: 'flex',
    justifyContent: 'stretch',
    flex: '1 1 auto'
});
const $91e438dc4522efc4$var$sidebarWrapper = (0, $kig2V.xcss)({
    flex: 0,
    position: 'fixed',
    right: 'space.0',
    width: '340px',
    backgroundColor: 'elevation.surface',
    zIndex: 'navigation',
    minHeight: '-webkit-fill-available',
    boxShadow: 'elevation.shadow.overlay',
    height: 'calc(100vh - 56px)'
});
const $91e438dc4522efc4$var$layoutBuilderWrapper = (0, $kig2V.xcss)({
    position: 'relative',
    width: '100%',
    borderRadius: 'radius.large',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised',
    overflow: 'visible'
});
const $91e438dc4522efc4$var$sectionLoader = (0, $kig2V.xcss)({
    padding: 'space.400',
    borderRadius: 'radius.large'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $91e438dc4522efc4$var$SidePanelLoader = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $8PITw.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $91e438dc4522efc4$var$breadcrumbContainer = (0, $kig2V.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    textAlign: 'left',
    padding: 'space.100',
    borderBottomColor: 'color.border',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid'
});
const $91e438dc4522efc4$var$breadCrumbItem = (0, $kig2V.xcss)({
    width: '84px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: 'space.100'
});
const $91e438dc4522efc4$var$configWrapper = (0, $kig2V.xcss)({
    width: '100%',
    height: 'space.250',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 'space.300',
    paddingBottom: 'space.0'
});
const $91e438dc4522efc4$var$configWrapper24PxWidth = (0, $kig2V.xcss)({
    width: '72px'
});
const $91e438dc4522efc4$var$configWrapper146PxWidth = (0, $kig2V.xcss)({
    width: '194px'
});
var $91e438dc4522efc4$export$2e2bcd8739ae039 = $91e438dc4522efc4$var$FlexibleEditpageLoader;

});


parcelRegister("5sUPt", function(module, exports) {
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => (parcelRequire("dTc6i")).anonymousRequestSuccessRoute);
$parcel$export(module.exports, "getRequestCreateRoute", () => (parcelRequire("dTc6i")).getRequestCreateRoute);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => (parcelRequire("dTc6i")).helpCenterRequestFeedbackRoute);
$parcel$export(module.exports, "notFoundErrorRoute", () => (parcelRequire("dTc6i")).notFoundErrorRoute);
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("dTc6i")).NotFoundPage);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("173qD")).portalReorderRoute);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => (parcelRequire("dTc6i")).RenderCreateAnonymousSuccess);
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => (parcelRequire("dTc6i")).RenderRequestCreateForHubs);
$parcel$export(module.exports, "requestFeedbackRoute", () => (parcelRequire("dTc6i")).requestFeedbackRoute);
$parcel$export(module.exports, "unsubscribeRoute", () => (parcelRequire("dTc6i")).unsubscribeRoute);
$parcel$export(module.exports, "userProfileRoute", () => (parcelRequire("dTc6i")).userProfileRoute);
parcelRequire("dTc6i");

});
parcelRegister("dTc6i", function(module, exports) {
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => $891a9654e3cc2b50$export$a877efa523a67c07);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => $891a9654e3cc2b50$export$1d1b8e06f48bd2d4);
$parcel$export(module.exports, "userProfileRoute", () => $891a9654e3cc2b50$export$abc0ddbfeed2cc26);
$parcel$export(module.exports, "NotFoundPage", () => $891a9654e3cc2b50$export$31641b61980e511f);
$parcel$export(module.exports, "getRequestCreateRoute", () => $891a9654e3cc2b50$export$b0cc27459efb2ff4);
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => $891a9654e3cc2b50$export$ea05b9ec1342627e);
$parcel$export(module.exports, "requestFeedbackRoute", () => $891a9654e3cc2b50$export$a3cf9a79f03e97df);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => $891a9654e3cc2b50$export$45634ebe4da270df);
$parcel$export(module.exports, "unsubscribeRoute", () => $891a9654e3cc2b50$export$7dfcaf0a6ac7c9fe);
$parcel$export(module.exports, "notFoundErrorRoute", () => $891a9654e3cc2b50$export$5443dabb022476b2);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("173qD")).portalReorderRoute);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $9J2wU = parcelRequire("9J2wU");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

parcelRequire("dRiEG");
var $7hPHG = parcelRequire("7hPHG");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");

var $dFIgM = parcelRequire("dFIgM");

var $5KL18 = parcelRequire("5KL18");

var $gFjPV = parcelRequire("gFjPV");

var $1qVIU = parcelRequire("1qVIU");

var $jr9Qn = parcelRequire("jr9Qn");

var $iLQ5e = parcelRequire("iLQ5e");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $k2M4v = parcelRequire("k2M4v");

var $eENmG = parcelRequire("eENmG");

var $dkrfZ = parcelRequire("dkrfZ");

var $joDHD = parcelRequire("joDHD");

var $eMdst = parcelRequire("eMdst");

var $173qD = parcelRequire("173qD");
const $891a9654e3cc2b50$var$HUBS_REQUEST_CREATE_KB_SUGGESTIONS = 'hubs_request_create_kb_suggestions';
const $891a9654e3cc2b50$var$isHubsRequestCreateKbSuggestionsEnabled = ()=>(0, $k2M4v.default).checkGate($891a9654e3cc2b50$var$HUBS_REQUEST_CREATE_KB_SUGGESTIONS);
const $891a9654e3cc2b50$var$portalRoutePrefix = '/portal/:portalId(\\d+)';
const $891a9654e3cc2b50$export$4340468daf4d707e = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkrfZ.default), {
        screenName: (0, $9mazR.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4xX38.default), {
        screenName: (0, $9mazR.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eMdst.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5KL18.RequestCreatePage), routerState))));
};
const $891a9654e3cc2b50$export$a877efa523a67c07 = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkrfZ.default), {
        screenName: (0, $9mazR.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4xX38.default), {
        screenName: (0, $9mazR.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eMdst.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gFjPV.RequestCreatePageForHubs), routerState))), $891a9654e3cc2b50$var$isHubsRequestCreateKbSuggestionsEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7hPHG.default), {
        match: routerState.match,
        location: routerState.location,
        route: routerState.route
    }));
};
const $891a9654e3cc2b50$export$1d1b8e06f48bd2d4 = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkrfZ.default), {
        screenName: (0, $9mazR.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4xX38.default), {
        screenName: (0, $9mazR.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dFIgM.RequestCreateAnonymousSuccess), routeContext)));
};
const $891a9654e3cc2b50$export$abc0ddbfeed2cc26 = (0, $joDHD.createRouteWithLayout)({
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $iLQ5e.UserProfile)
}, (0, $9mazR.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});
const $891a9654e3cc2b50$export$31641b61980e511f = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent && createAnalyticsEvent({
        action: 'rendered',
        analyticsType: (0, $eENmG.UI_EVENT_TYPE)
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9J2wU.default), {
        error: {
            status: (0, $9mazR.HTTP).NOT_FOUND,
            message: '',
            callToActionUrl: '',
            callToActionText: ''
        }
    }, '');
};
const $891a9654e3cc2b50$export$b0cc27459efb2ff4 = ()=>(0, $joDHD.createRouteWithLayout)({
        name: 'request-create',
        path: '/portal/:portalId/create/:requestTypeId',
        exact: true,
        component: $891a9654e3cc2b50$export$4340468daf4d707e,
        resources: []
    }, (0, $9mazR.ScreenName).REQUEST_CREATE, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });
const $891a9654e3cc2b50$export$ea05b9ec1342627e = (0, $joDHD.createRouteWithLayout)({
    name: 'request-create-anonymous-success',
    path: '/portal/:portalId/create/:requestTypeId/confirm',
    exact: true,
    component: $891a9654e3cc2b50$export$1d1b8e06f48bd2d4,
    resources: []
}, (0, $9mazR.ScreenName).KNOWLEDGE_CATEGORY, {
    fadeInSearchModal: true
});
const $891a9654e3cc2b50$export$a3cf9a79f03e97df = (0, $joDHD.createRouteWithLayout)({
    name: 'request-feedback',
    path: `${$891a9654e3cc2b50$var$portalRoutePrefix}/:requestKey/feedback`,
    exact: true,
    component: (0, $1qVIU.RequestFeedback),
    resources: []
}, (0, $9mazR.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $891a9654e3cc2b50$export$45634ebe4da270df = (0, $joDHD.createRouteWithLayout)({
    name: 'request-feedback',
    path: `/user/requests/:requestKey/feedback`,
    exact: true,
    component: (0, $1qVIU.RequestFeedback),
    resources: []
}, (0, $9mazR.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $891a9654e3cc2b50$export$7dfcaf0a6ac7c9fe = (0, $joDHD.createRouteWithLayout)({
    name: 'unsubscribeRoute',
    path: `${$891a9654e3cc2b50$var$portalRoutePrefix}/:requestKey/unsubscribe`,
    exact: true,
    component: (0, $jr9Qn.Unsubscribe),
    resources: []
}, (0, $9mazR.ScreenName).UNSUBSCRIBE, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $891a9654e3cc2b50$export$5443dabb022476b2 = (0, $joDHD.createRouteWithLayout)({
    name: 'not-found-error-page',
    path: '(.*)',
    exact: true,
    component: (0, $613oU.default)({
        componentName: 'notFoundPage'
    })((0, $azARG.default)({})($891a9654e3cc2b50$export$31641b61980e511f)),
    resources: []
}, (0, $9mazR.ScreenName).ERROR_NOT_FOUND, {
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("9J2wU", function(module, exports) {
$parcel$export(module.exports, "withErrorPage", () => $d7e865e715766768$export$60ebd61e40e72272);
$parcel$export(module.exports, "default", () => $d7e865e715766768$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $4zyaU = parcelRequire("4zyaU");

var $9mazR = parcelRequire("9mazR");

var $aHS3M = parcelRequire("aHS3M");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $4Pqwt = parcelRequire("4Pqwt");

var $7IsHf = parcelRequire("7IsHf");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("blonq");
var $4m70N = parcelRequire("4m70N");

var $1hJdJ = parcelRequire("1hJdJ");

var $4T8rw = parcelRequire("4T8rw");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $cf3fd = parcelRequire("cf3fd");

var $6Pd4T = parcelRequire("6Pd4T");

var $7lN8e = parcelRequire("7lN8e");

var $jibrf = parcelRequire("jibrf");

var $csYQe = parcelRequire("csYQe");
const $d7e865e715766768$var$isUnhandledError = (statusCode)=>{
    // We want to report on any 5xx errors for the experience tracker.
    return `${statusCode}`.startsWith('5');
};
const $d7e865e715766768$export$5d56d6fe10c95f05 = ({ error: error, intl: intl })=>{
    let Icon;
    let heading = '';
    let description = '';
    const isCSMHelpCenterEnabled = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    switch(error.status){
        case (0, $9mazR.HTTP).FORBIDDEN:
            heading = intl.formatMessage((0, $csYQe.default).permissionDenied);
            description = intl.formatMessage((0, $csYQe.default).permissionDeniedMessage);
            Icon = (0, $7IsHf.default);
            break;
        case (0, $9mazR.HTTP).NOT_FOUND:
            heading = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $csYQe.default).notFoundV2 : (0, $csYQe.default).notFound);
            description = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $csYQe.default).notFoundMessageV2 : (0, $csYQe.default).notFoundMessage);
            Icon = (0, $4Pqwt.default);
            break;
        case (0, $9mazR.HTTP).OFFLINE:
            heading = intl.formatMessage((0, $csYQe.default).offlineHeading);
            description = intl.formatMessage((0, $csYQe.default).offlineMessage);
            Icon = (0, $4Pqwt.default);
            break;
        case (0, $9mazR.HTTP).SERVER:
        default:
            heading = intl.formatMessage((0, $csYQe.default).genericHeading);
            description = intl.formatMessage((0, $csYQe.default).genericMessage);
            Icon = (0, $4Pqwt.default);
            break;
    }
    if (error.message) // If there is a message with the error we override it.
    description = typeof error.message === 'string' ? error.message : intl.formatMessage(error.message);
    if (error.heading) heading = typeof error.heading === 'string' ? error.heading : intl.formatMessage(error.heading);
    return {
        heading: heading,
        description: description,
        Icon: Icon
    };
};
const $d7e865e715766768$export$c120a0e80fd44ca6 = ({ error: error, children: children, intl: intl, config: config })=>{
    if (!!error) {
        const { Icon: Icon, heading: heading, description: description } = $d7e865e715766768$export$5d56d6fe10c95f05({
            error: error,
            intl: intl
        });
        // failure logging to be avoided only if the traceId is absent and the config is set to exclude empty traceId logs
        const shouldLogFailure = error.traceId ? true : !(config !== null && config !== void 0 && config.isEmptyTraceIdLogExcluded);
        const shouldRenderExperienceFailure = $d7e865e715766768$var$isUnhandledError(error.status) && shouldLogFailure;
        return /*#__PURE__*/ $fc4bM.createElement((0, $aHS3M.default), {
            title: description
        }, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.PaperContent), null, /*#__PURE__*/ $fc4bM.createElement($d7e865e715766768$var$Container, null, /*#__PURE__*/ $fc4bM.createElement($d7e865e715766768$var$IconContainer, null, /*#__PURE__*/ $fc4bM.createElement(Icon, null)), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
                space: "space.100",
                alignInline: "center",
                xcss: $d7e865e715766768$var$errorMessageContainerStyle
            }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                size: "medium",
                as: "div"
            }, heading), /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), {
                align: "center"
            }, description))
        }, /*#__PURE__*/ $fc4bM.createElement($d7e865e715766768$export$f69c19e57285b83a, null, heading), /*#__PURE__*/ $fc4bM.createElement($d7e865e715766768$var$Description, null, description)), error.status !== (0, $9mazR.HTTP).OFFLINE && /*#__PURE__*/ $fc4bM.createElement((0, $jibrf.ErrorLink), {
            callToActionUrl: error.callToActionUrl
        }, error.callToActionText), shouldRenderExperienceFailure && /*#__PURE__*/ $fc4bM.createElement((0, $4zyaU.ExperienceFailure), {
            location: "error-page",
            errorMessage: description,
            traceId: error.traceId,
            responseHeaders: error.responseHeaders,
            status: error.status
        }))));
    }
    return $fc4bM.Children.only(children);
};
const $d7e865e715766768$var$IntlErrorPage = (0, $fcCIH.default)($d7e865e715766768$export$c120a0e80fd44ca6);
const $d7e865e715766768$export$60ebd61e40e72272 = (WrappedComponent, config)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $fc4bM.createElement($d7e865e715766768$var$IntlErrorPage, {
            ...props,
            error: props.error,
            config: config
        }, /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props));
var $d7e865e715766768$export$2e2bcd8739ae039 = $d7e865e715766768$var$IntlErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d7e865e715766768$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-a8w8t7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d7e865e715766768$var$IconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-a8w8t7-1"
})`width:${$fOCtI.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d7e865e715766768$var$Description = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-a8w8t7-2"
})`${$imLe4.regular};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
const $d7e865e715766768$export$f69c19e57285b83a = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-a8w8t7-3"
})`${$imLe4.h600};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
const $d7e865e715766768$var$errorMessageContainerStyle = (0, $kig2V.xcss)({
    marginBlockEnd: 'space.100'
});

});
parcelRegister("4zyaU", function(module, exports) {
$parcel$export(module.exports, "withExperienceNotifier", () => $cbf689b246a9953c$export$43b8ee6172152b23);
$parcel$export(module.exports, "ExperienceSuccess", () => $cbf689b246a9953c$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceFailure", () => $cbf689b246a9953c$export$eed1d73ebdd8c7ab);

var $fc4bM = parcelRequire("fc4bM");

var $fUtao = parcelRequire("fUtao");
// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
const $cbf689b246a9953c$var$createExperienceNotifier = (type)=>// eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $fc4bM.createElement((0, $fUtao.default), {
            ...props,
            type: type
        });
const $cbf689b246a9953c$export$43b8ee6172152b23 = (experienceLocation)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $fc4bM.createElement((0, $fUtao.default), {
                type: "CAN_SUCCEED_OR_FAIL",
                location: experienceLocation
            }, (notify)=>/*#__PURE__*/ $fc4bM.createElement(Component, {
                    ...props,
                    ...notify
                }));
        };
const $cbf689b246a9953c$export$4962f3898bd5c829 = $cbf689b246a9953c$var$createExperienceNotifier('IMMEDIATE_SUCCESS');
const $cbf689b246a9953c$export$eed1d73ebdd8c7ab = $cbf689b246a9953c$var$createExperienceNotifier('IMMEDIATE_FAILURE');

});
parcelRegister("fUtao", function(module, exports) {
$parcel$export(module.exports, "default", () => $d714a59930a2fb88$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $2WmjE = parcelRequire("2WmjE");

var $7egf9 = parcelRequire("7egf9");
class $d714a59930a2fb88$export$2e2bcd8739ae039 extends $fc4bM.Component {
    static #_ = this.contextType = (0, $7egf9.ExperienceContext);
    componentDidMount() {
        const { type: type, location: location, errorMessage: errorMessage, traceId: traceId, responseHeaders: responseHeaders, status: status } = this.props;
        if (type !== 'CAN_FAIL') this.context.onPending();
        if (type === 'IMMEDIATE_FAILURE') this.onFailure(errorMessage || location, traceId, responseHeaders, status);
        else if (type === 'IMMEDIATE_SUCCESS') this.onSuccess();
    // Otherwise we wait for the child to either throw an error or call `onExperienceSuccess`.
    }
    componentWillUnmount() {
        // If this component is being unmounted and still hasn't notified - assume it was successful.
        if (this.props.type !== 'CAN_FAIL') this.onSuccess();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        if (!(0, $2WmjE.isIE7)()) this.context.onFailure({
            errorMessage: message,
            errorName: name,
            traceId: this.props.traceId,
            unhandledError: true,
            errorLocation: this.props.location
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    render() {
        const { children: children } = this.props;
        const markup = typeof children === 'function' ? children({
            notifySuccess: this.onSuccess,
            notifyFailure: this.onFailure
        }) : children;
        return markup || null;
    }
    constructor(...args){
        super(...args), this.hasSignalledSuccess = false, this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess) {
                this.hasSignalledSuccess = true;
                this.context.onSuccess();
            }
        }, this.onFailure = (errorMessage, traceId, responseHeaders, status)=>{
            if (!(0, $2WmjE.isIE7)()) this.context.onFailure({
                errorMessage: errorMessage,
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: status,
                errorName: 'NotifyFailure',
                unhandledError: false,
                errorLocation: this.props.location
            });
        };
    }
}
const $d714a59930a2fb88$export$eed1d73ebdd8c7ab = ({ experience: experience, config: config })=>{
    $fc4bM.useEffect(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.failure(config);
    }, [
        experience,
        config
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null);
};

});
parcelRegister("7egf9", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $8b26b41035f2b3de$export$fb99266658f5da06);
$parcel$export(module.exports, "default", () => $8b26b41035f2b3de$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");

var $ee3uC = parcelRequire("ee3uC");
const $8b26b41035f2b3de$export$fb99266658f5da06 = /*#__PURE__*/ $fc4bM.createContext({
    onFailure: (0, $aYMdQ.noop),
    onPending: (0, $aYMdQ.noop),
    onSuccess: (0, $aYMdQ.noop)
});
const $8b26b41035f2b3de$export$9c9c79fc1d105790 = (errorMessage)=>{
    if (!errorMessage) return false;
    return errorMessage.includes('Converting circular structure to JSON') && errorMessage.includes('__reactFiber$');
};
class $8b26b41035f2b3de$export$c90b54e658fc4d7c extends $fc4bM.Component {
    static #_ = this.checkNotifiersInterval = 1000;
    static #_2 = this.defaultProps = {
        isExperienceReady: true
    };
    componentDidMount() {
        this.checkAndStartTimer();
        this.trackExperience('taskStart');
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    checkAndStartTimer() {
        if (this.notifierHasBegunPending && this.props.isExperienceReady) this.startTimer();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackFailure({
            errorMessage: message,
            errorName: name,
            unhandledError: true,
            errorLocation: this.props.name
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = window.setTimeout(()=>{
            if (this.pendingCount === 0) this.trackSuccess();
        }, $8b26b41035f2b3de$export$c90b54e658fc4d7c.checkNotifiersInterval);
    }
    trackSuccess() {
        this.trackExperience('taskSuccess');
    }
    trackFailure(failure) {
        // HOT-127428: exclude the third-party DOM-patch client error from the experience SLO.
        // We skip emitting the taskFail event (so it doesn't count against view-help-center) and
        // mark the experience as tracked to mirror an abort.
        if ($8b26b41035f2b3de$export$9c9c79fc1d105790(failure === null || failure === void 0 ? void 0 : failure.errorMessage)) {
            this.hasTrackedExperience = true;
            return;
        }
        this.trackExperience('taskFail', failure);
    }
    trackExperience(action, errorFailure) {
        if (this.hasTrackedExperience) // Ignore any follow up tracking fired after the experience has been tracked.
        return;
        const { createAnalyticsEvent: createAnalyticsEvent, experienceId: experienceId, name: name } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const event = createAnalyticsEvent({});
        switch(action){
            case 'taskFail':
                (0, $ee3uC.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    error: errorFailure
                }, event);
                break;
            case 'taskSuccess':
                (0, $ee3uC.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
            case 'taskStart':
            default:
                (0, $ee3uC.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
        }
        if (action !== 'taskStart') this.hasTrackedExperience = true;
    }
    render() {
        return /*#__PURE__*/ $fc4bM.createElement($8b26b41035f2b3de$export$fb99266658f5da06.Provider, {
            value: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), /**
   * This value is needed so the timer doesn't start until
   * at least one notifier has been turned on.
   */ this.notifierHasBegunPending = false, this.timerId = undefined, this.pendingCount = 0, this.hasTrackedExperience = false, /**
   * Called when a descendant experience notifier is waiting to see if it is successful or not.
   */ this.onPending = ()=>{
            this.pendingCount += 1;
            this.notifierHasBegunPending = true;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier successfully loaded.
   * ALL descendant experience notifiers need to successfully load for a SUCCESS
   * to be considered.
   */ this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier failed to load.
   * This caused the entire experience to FAIL.
   */ this.onFailure = (failure)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackFailure(failure);
        };
    }
}
var // Use "componentName" as a drop-in replacement for "actionSubject"
// analytics-web-react getEvent() currently only supports TRACK events
// setting it directly.
$8b26b41035f2b3de$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'ui'
})((0, $azARG.default)()($8b26b41035f2b3de$export$c90b54e658fc4d7c));

});
parcelRegister("ee3uC", function(module, exports) {
$parcel$export(module.exports, "default", () => $93b9d7bbe0ac8c42$export$2e2bcd8739ae039);

var $16GaT = parcelRequire("16GaT");

var $aVQWM = parcelRequire("aVQWM");
const $93b9d7bbe0ac8c42$var$createAnalyticsPayload = ({ name: name, action: action, experienceId: experienceId, ...rest })=>{
    const error = 'error' in rest ? rest.error : undefined;
    return {
        action: action,
        task: name,
        taskId: experienceId,
        reason: error && error.errorMessage,
        ...error
    };
};
var $93b9d7bbe0ac8c42$export$2e2bcd8739ae039 = (experienceDescription, analyticsEvent)=>{
    const payload = $93b9d7bbe0ac8c42$var$createAnalyticsPayload(experienceDescription);
    const { action: action, ...rest } = payload;
    (0, $16GaT.fireAnalytics)(analyticsEvent, (0, $aVQWM.OPERATIONAL_EVENT_TYPE), {
        action: action,
        attributes: rest
    });
};

});
parcelRegister("16GaT", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $d366b16d72b41891$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $d366b16d72b41891$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $d366b16d72b41891$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $d366b16d72b41891$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $d366b16d72b41891$export$6f46fb37ad7d962b);

var $1VqtZ = parcelRequire("1VqtZ");

var $aVQWM = parcelRequire("aVQWM");

var $crhi4 = parcelRequire("crhi4");
const $d366b16d72b41891$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $aVQWM.ANALYTICS_BRIDGE_CHANNEL));
};
const $d366b16d72b41891$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1VqtZ)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $d366b16d72b41891$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $crhi4.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $d366b16d72b41891$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $d366b16d72b41891$export$34ac71ce24cddec2(event, (0, $aVQWM.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $d366b16d72b41891$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $crhi4.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $d366b16d72b41891$export$34ac71ce24cddec2(event, (0, $aVQWM.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $d366b16d72b41891$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $crhi4.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $d366b16d72b41891$export$34ac71ce24cddec2(event, (0, $aVQWM.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $d366b16d72b41891$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $crhi4.getImperativeAnalyticsDataFromArguments)(rest);
    $d366b16d72b41891$export$34ac71ce24cddec2(event, (0, $aVQWM.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};

});
parcelRegister("crhi4", function(module, exports) {
$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $7b5a456f18c95432$export$e6baab532ef8c6bf);
const $7b5a456f18c95432$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $7b5a456f18c95432$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $7b5a456f18c95432$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $7b5a456f18c95432$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $7b5a456f18c95432$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $7b5a456f18c95432$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $7b5a456f18c95432$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $7b5a456f18c95432$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $7b5a456f18c95432$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $7b5a456f18c95432$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $7b5a456f18c95432$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $7b5a456f18c95432$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});






parcelRegister("aHS3M", function(module, exports) {
$parcel$export(module.exports, "default", () => $32de102ef2b3da54$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9hi1 = parcelRequire("j9hi1");

var $fcCIH = parcelRequire("fcCIH");

var $30zho = parcelRequire("30zho");
const $32de102ef2b3da54$export$dd5ad0b65cf665da = ({ children: children, title: title, intl: intl, ignoreBaseTitle: ignoreBaseTitle })=>{
    let documentTitle = intl.formatMessage((0, $30zho.default).defaultTitle);
    if (ignoreBaseTitle && title) documentTitle = title;
    else if (title) documentTitle = intl.formatMessage((0, $30zho.default).baseTitle, {
        title: title
    });
    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($j9hi1))), {
        title: documentTitle
    }, children);
};
var $32de102ef2b3da54$export$2e2bcd8739ae039 = (0, $fcCIH.default)($32de102ef2b3da54$export$dd5ad0b65cf665da);

});
parcelRegister("j9hi1", function(module, exports) {
'use strict';

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $gnVMX = parcelRequire("gnVMX");
function $df0c44f5d46073b3$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $df0c44f5d46073b3$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $df0c44f5d46073b3$var$DocumentTitle() {}
$df0c44f5d46073b3$var$DocumentTitle.prototype = Object.create($fc4bM.Component.prototype);
$df0c44f5d46073b3$var$DocumentTitle.displayName = 'DocumentTitle';
$df0c44f5d46073b3$var$DocumentTitle.propTypes = {
    title: $dso8W.string.isRequired
};
$df0c44f5d46073b3$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $fc4bM.Children.only(this.props.children);
    else return null;
};
module.exports = $gnVMX($df0c44f5d46073b3$var$reducePropsToState, $df0c44f5d46073b3$var$handleStateChangeOnClient)($df0c44f5d46073b3$var$DocumentTitle);

});
parcelRegister("gnVMX", function(module, exports) {
'use strict';
function $bedb9eebe87b16ce$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $fc4bM = parcelRequire("fc4bM");
var $bedb9eebe87b16ce$var$React__default = $bedb9eebe87b16ce$var$_interopDefault($fc4bM);

var $bedb9eebe87b16ce$var$shallowEqual = $bedb9eebe87b16ce$var$_interopDefault((parcelRequire("fk6GG")));
function $bedb9eebe87b16ce$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bedb9eebe87b16ce$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bedb9eebe87b16ce$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $bedb9eebe87b16ce$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $bedb9eebe87b16ce$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$bedb9eebe87b16ce$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $bedb9eebe87b16ce$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($fc4bM.Component);
        $bedb9eebe87b16ce$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $bedb9eebe87b16ce$var$_defineProperty(SideEffect, "canUseDOM", $bedb9eebe87b16ce$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $bedb9eebe87b16ce$var$withSideEffect;

});
parcelRegister("fk6GG", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("30zho", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9f51e9947a5a08d$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $f9f51e9947a5a08d$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    defaultTitle: {
        defaultMessage: 'Jira Service Management',
        description: 'Default document page title',
        id: 'cv.jsm.document.page.title.default'
    },
    baseTitle: {
        defaultMessage: '{title} - Jira Service Management',
        description: 'Base document page title appended to custom document titles.',
        id: 'cv.jsm.document.page.title.base'
    }
});

});


parcelRegister("4Pqwt", function(module, exports) {
$parcel$export(module.exports, "default", () => $22b19b8501f4d63a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $22b19b8501f4d63a$var$SvgErrorreact = (props)=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 163.28 218",
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: "error_react_svg__linear-gradient",
        x1: 133.86,
        y1: 136.43,
        x2: -2.79,
        y2: 200.15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "error_react_svg__clip-path"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    })), /*#__PURE__*/ $fc4bM.createElement("style", null, ".error_react_svg__cls-1{fill:url(#error_react_svg__linear-gradient)}.error_react_svg__cls-2{fill:#253858}.error_react_svg__cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $fc4bM.createElement("g", {
        id: "error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        id: "error_react_svg__Software"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "error_react_svg__cls-2",
        d: "m87.22 163.71 2.88-44.35a9.18 9.18 0 0 0-9.16-9.78 9.18 9.18 0 0 0-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89 6.3 6.3 0 0 0 6.28-5.89ZM71.38 187.25a9.53 9.53 0 0 0 10.39 9.58 9.68 9.68 0 0 0-.9-19.32 9.64 9.64 0 0 0-9.49 9.74Z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M91.7 27.17 84.29.45A.61.61 0 0 0 83.1.5l-4.66 25.1-5.8-1.08a.61.61 0 0 0-.7.76L79.35 52a.61.61 0 0 0 1.19 0l4.66-25.1 5.8 1.03a.61.61 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "m65.12 41.81-10.88-8.55a.27.27 0 0 0-.41.33L59.36 45l-2.66 1.31a.27.27 0 0 0 0 .45l10.87 8.55a.27.27 0 0 0 .41-.33l-5.57-11.43 2.66-1.29a.27.27 0 0 0 .05-.45Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M115.15 36.6c-1.17 1.59-11-5.6-12.16-4s8.66 8.79 7.5 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "error_react_svg__cls-6",
        d: "M119.92 64.19c-1.46 1.33-7.05-4.78-8.51-3.44s4.13 7.45 2.67 8.78-7.05-4.78-8.51-3.44c-.68.62.16 2.27 1.11 4M44.8 64c1.82.77 5-6.87 6.86-6.1s-1.39 8.4.43 9.17 5-6.87 6.86-6.1c.85.36.61 2.19.29 4.13"
    }))));
var $22b19b8501f4d63a$export$2e2bcd8739ae039 = $22b19b8501f4d63a$var$SvgErrorreact;

});

parcelRegister("7IsHf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef9b36aa3577c6f8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $ef9b36aa3577c6f8$var$SvgLockreact = (props)=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 168.837 221.487",
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: "lock_react_svg__linear-gradient",
        x1: 49.42,
        y1: 59.767,
        x2: 122.662,
        y2: 59.767,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0,
        stopColor: "#0065ff"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0.219,
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 0.6,
        stopColor: "#2780ff"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: 1,
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ $fc4bM.createElement("style", null, ".lock_react_svg__cls-2{fill:#de350b}.lock_react_svg__cls-3{fill:#ff5630}")), /*#__PURE__*/ $fc4bM.createElement("g", {
        id: "lock_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        id: "lock_react_svg__Objects"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M122.662 119.535H49.42V36.62a36.621 36.621 0 0 1 73.242 0zm-61.242-12h49.242V36.62a24.621 24.621 0 0 0-49.242 0z",
        fill: "url(#lock_react_svg__linear-gradient)"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "lock_react_svg__cls-2",
        d: "M160.324 111.17a65.496 65.496 0 0 1-5.657-46.117l.002-.009a5.053 5.053 0 0 0-4.904-6.273H19.072a5.053 5.053 0 0 0-4.904 6.273l.002.006a66.149 66.149 0 0 1-5.785 46.367 75.49 75.49 0 0 0 65.21 110.047h17.866a75.491 75.491 0 0 0 68.863-110.294z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "m154.667 65.053.002-.009a5.053 5.053 0 0 0-4.904-6.273H36.94a5.053 5.053 0 0 0-4.904 6.273l.001.006a66.15 66.15 0 0 1-5.784 46.367 75.485 75.485 0 1 0 134.072-.247 65.496 65.496 0 0 1-5.657-46.117z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "lock_react_svg___Path_",
        "data-name": "<Path>",
        d: "M93.352 213.6q-.845 0-1.697-.02a67.603 67.603 0 0 1-58.396-98.539A74.376 74.376 0 0 0 40.47 66.66h105.762a73.488 73.488 0 0 0 7.098 48.16 67.6 67.6 0 0 1-59.975 98.78z",
        fill: "#ff7452"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "M90.007 176.885a16.308 16.308 0 0 1-16.115-18.82l2.23-14.32A24.148 24.148 0 0 1 92.21 102.69c.382-.017.766-.026 1.144-.026a24.15 24.15 0 0 1 17.229 41.08l2.23 14.32a16.31 16.31 0 0 1-16.114 18.82z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        id: "lock_react_svg___Path_2",
        "data-name": "<Path>",
        className: "lock_react_svg__cls-2",
        d: "M108.481 126.824a15.061 15.061 0 0 1-4.83 11.067 7.222 7.222 0 0 0-2.122 6.412l2.36 15.154a7.278 7.278 0 0 1-7.192 8.398h-6.69a7.278 7.278 0 0 1-7.192-8.398l2.388-15.332a7.232 7.232 0 0 0-2.269-6.345 15.064 15.064 0 0 1-4.69-11.753 15.13 15.13 0 0 1 30.237.797z"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M82.815 159.457a7.256 7.256 0 1 0 14.333 0l-2.36-15.154a7.221 7.221 0 0 1 2.122-6.412 15.104 15.104 0 0 0-6.945-25.804 15.268 15.268 0 0 0-11.722 13.94 15.063 15.063 0 0 0 4.691 11.753 7.232 7.232 0 0 1 2.268 6.345z",
        fill: "#344563"
    }))));
var $ef9b36aa3577c6f8$export$2e2bcd8739ae039 = $ef9b36aa3577c6f8$var$SvgLockreact;

});

parcelRegister("blonq", function(module, exports) {
$parcel$export(module.exports, "Paper", () => (parcelRequire("6Mfyl")).default);
$parcel$export(module.exports, "PaperContent", () => (parcelRequire("4m70N")).PaperContent);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => (parcelRequire("4m70N")).SmallPaddingPaperContent);

var $6Mfyl = parcelRequire("6Mfyl");

var $4m70N = parcelRequire("4m70N");

});
parcelRegister("6Mfyl", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a4b6e82b9ae2da$export$2e2bcd8739ae039);
/* paper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("5Kuf4");
var $anLkS = parcelRequire("anLkS");
parcelRequire("jEqr0");
var $gpJGQ = parcelRequire("gpJGQ");

var $4m70N = parcelRequire("4m70N");
const $01a4b6e82b9ae2da$var$SkipToMainContent = ({ children: children })=>/*#__PURE__*/ $fc4bM.createElement((0, $gpJGQ.MainContentSkipLinkWrapper), null, /*#__PURE__*/ $fc4bM.createElement($01a4b6e82b9ae2da$var$MainContentSkipLink, null, children));
// We want to delay fade in until after the paper transition is complete
const $01a4b6e82b9ae2da$var$FadeContent = (0, $anLkS.default)({
    fadeInTime: (0, $4m70N.paperTransitionTime),
    delay: (0, $4m70N.paperTransitionTime)
})((0, $4m70N.Content));
class $01a4b6e82b9ae2da$var$Paper extends $fc4bM.Component {
    render() {
        const { children: children, pageKey: pageKey, isCSM: isCSM } = this.props;
        const hide = this.props.appearance === 'none';
        const appearance = this.props.appearance || 'normal';
        if (appearance === 'note') return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.PaperBackground), {
            appearance: "none",
            hide: true
        }), /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.NoteContent), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.NoteBackground), null, children), /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.StyledFooter), null)));
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.PaperBackground), {
            appearance: appearance,
            hide: hide
        }), /*#__PURE__*/ $fc4bM.createElement($01a4b6e82b9ae2da$var$FadeContent, {
            appearance: appearance,
            hide: hide,
            key: pageKey
        }, /*#__PURE__*/ $fc4bM.createElement($01a4b6e82b9ae2da$var$SkipToMainContent, null, children, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.StyledFooter), {
            isCSM: isCSM
        }))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $01a4b6e82b9ae2da$var$MainContentSkipLink = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx21bp4 _1tke1osq",
            __cmplp.className
        ])
    });
});
var $01a4b6e82b9ae2da$export$2e2bcd8739ae039 = $01a4b6e82b9ae2da$var$Paper;

});
parcelRegister("5Kuf4", function(module, exports) {
$parcel$export(module.exports, "withFadeIn", () => (parcelRequire("anLkS")).default);

var $anLkS = parcelRequire("anLkS");

});
parcelRegister("anLkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6acbf139db8609f6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $6F3K7 = parcelRequire("6F3K7");

var $1IFGQ = parcelRequire("1IFGQ");
parcelRequire("9T6l6");
var $cCqrh = parcelRequire("cCqrh");

var $7lN8e = parcelRequire("7lN8e");
const $6acbf139db8609f6$var$withFadeIn = (options)=>(WrappedComponent)=>{
        const defaultOptions = {
            fadeInTime: $6F3K7.speedMs.slow,
            delay: 0
        };
        const mergedOptions = {
            ...defaultOptions,
            ...options
        };
        // eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        const ComponentWithFadeIn = /*#__PURE__*/ (0, $luz1X.default)(WrappedComponent).withConfig({
            componentId: "sc-1uyl3wn-0"
        })`${$6F3K7.fadeInOut(mergedOptions.fadeInTime, mergedOptions.delay)};`;
        const ReturnComponent = (props)=>{
            const shouldSkipTransition = $fc4bM.useMemo(()=>!(0, $cCqrh.isAppMounted).value, []);
            /**
     * In server side rendering -  component should appear
     * on First time load from SSR - component should appear
     * on next time onwards - component should transition
     * on client only - component should transition
     */ const shouldTransitOnMount = ()=>{
                // Invalid report.
                // eslint-disable-next-line testing-library/render-result-naming-convention
                const isPageServerSideRendered = (0, $7lN8e.getIsPageServerSideRendered)();
                if (isPageServerSideRendered && shouldSkipTransition) return false;
                return true;
            };
            return /*#__PURE__*/ $fc4bM.createElement((0, $1IFGQ.default), {
                in: true,
                timeout: 0,
                mountOnEnter: true,
                appear: shouldTransitOnMount()
            }, (state)=>// Spreading props blows type checking up for some reason. Why??
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                /*#__PURE__*/ $fc4bM.createElement(ComponentWithFadeIn, {
                    ...props,
                    state: state
                }));
        };
        return ReturnComponent;
    };
var $6acbf139db8609f6$export$2e2bcd8739ae039 = $6acbf139db8609f6$var$withFadeIn;

});
parcelRegister("1IFGQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $140a3d4d82698986$export$2e2bcd8739ae039, (v) => $140a3d4d82698986$export$2e2bcd8739ae039 = v);
var $140a3d4d82698986$export$1e511d4a378977f5;
var $140a3d4d82698986$export$2e2bcd8739ae039;
var $140a3d4d82698986$export$4aacc83d4d59139f;
var $140a3d4d82698986$export$78e9e6e3e014d60a;
var $140a3d4d82698986$export$df38205c966be359;
var $140a3d4d82698986$export$84cbff306f539230;
var $140a3d4d82698986$export$bb38bb9a1161268;
"use strict";
$140a3d4d82698986$export$1e511d4a378977f5 = true;
$140a3d4d82698986$export$2e2bcd8739ae039 = $140a3d4d82698986$export$4aacc83d4d59139f = $140a3d4d82698986$export$78e9e6e3e014d60a = $140a3d4d82698986$export$df38205c966be359 = $140a3d4d82698986$export$84cbff306f539230 = $140a3d4d82698986$export$bb38bb9a1161268 = void 0;

var $140a3d4d82698986$var$PropTypes = $140a3d4d82698986$var$_interopRequireWildcard((parcelRequire("dso8W")));

var $140a3d4d82698986$var$_react = $140a3d4d82698986$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $140a3d4d82698986$var$_reactDom = $140a3d4d82698986$var$_interopRequireDefault((parcelRequire("bTkYf")));

var $lV5vI = parcelRequire("lV5vI");

function $140a3d4d82698986$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $140a3d4d82698986$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $140a3d4d82698986$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $140a3d4d82698986$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $140a3d4d82698986$var$UNMOUNTED = 'unmounted';
$140a3d4d82698986$export$bb38bb9a1161268 = $140a3d4d82698986$var$UNMOUNTED;
var $140a3d4d82698986$var$EXITED = 'exited';
$140a3d4d82698986$export$84cbff306f539230 = $140a3d4d82698986$var$EXITED;
var $140a3d4d82698986$var$ENTERING = 'entering';
$140a3d4d82698986$export$df38205c966be359 = $140a3d4d82698986$var$ENTERING;
var $140a3d4d82698986$var$ENTERED = 'entered';
$140a3d4d82698986$export$78e9e6e3e014d60a = $140a3d4d82698986$var$ENTERED;
var $140a3d4d82698986$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $140a3d4d82698986$export$4aacc83d4d59139f = $140a3d4d82698986$var$EXITING;
var $140a3d4d82698986$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $140a3d4d82698986$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $140a3d4d82698986$var$EXITED;
                _this.appearStatus = $140a3d4d82698986$var$ENTERING;
            } else initialStatus = $140a3d4d82698986$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $140a3d4d82698986$var$UNMOUNTED;
        else initialStatus = $140a3d4d82698986$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $140a3d4d82698986$var$UNMOUNTED) return {
            status: $140a3d4d82698986$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $140a3d4d82698986$var$ENTERING && status !== $140a3d4d82698986$var$ENTERED) nextStatus = $140a3d4d82698986$var$ENTERING;
            } else if (status === $140a3d4d82698986$var$ENTERING || status === $140a3d4d82698986$var$ENTERED) nextStatus = $140a3d4d82698986$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $140a3d4d82698986$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $140a3d4d82698986$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $140a3d4d82698986$var$EXITED) this.setState({
            status: $140a3d4d82698986$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $140a3d4d82698986$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $140a3d4d82698986$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $140a3d4d82698986$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $140a3d4d82698986$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $140a3d4d82698986$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $140a3d4d82698986$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $140a3d4d82698986$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $140a3d4d82698986$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $140a3d4d82698986$var$_react.default.Children.only(children);
        return $140a3d4d82698986$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($140a3d4d82698986$var$_react.default.Component);
$140a3d4d82698986$var$Transition.contextTypes = {
    transitionGroup: $140a3d4d82698986$var$PropTypes.object
};
$140a3d4d82698986$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$140a3d4d82698986$var$Transition.propTypes = {};
function $140a3d4d82698986$var$noop() {}
$140a3d4d82698986$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $140a3d4d82698986$var$noop,
    onEntering: $140a3d4d82698986$var$noop,
    onEntered: $140a3d4d82698986$var$noop,
    onExit: $140a3d4d82698986$var$noop,
    onExiting: $140a3d4d82698986$var$noop,
    onExited: $140a3d4d82698986$var$noop
};
$140a3d4d82698986$var$Transition.UNMOUNTED = 0;
$140a3d4d82698986$var$Transition.EXITED = 1;
$140a3d4d82698986$var$Transition.ENTERING = 2;
$140a3d4d82698986$var$Transition.ENTERED = 3;
$140a3d4d82698986$var$Transition.EXITING = 4;
var $140a3d4d82698986$var$_default = (0, $lV5vI.polyfill)($140a3d4d82698986$var$Transition);
$140a3d4d82698986$export$2e2bcd8739ae039 = $140a3d4d82698986$var$_default;

});
parcelRegister("lV5vI", function(module, exports) {
$parcel$export(module.exports, "polyfill", () => $ff533220ae36396b$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $ff533220ae36396b$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $ff533220ae36396b$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $ff533220ae36396b$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$ff533220ae36396b$var$componentWillMount.__suppressDeprecationWarning = true;
$ff533220ae36396b$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$ff533220ae36396b$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $ff533220ae36396b$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $ff533220ae36396b$var$componentWillMount;
        prototype.componentWillReceiveProps = $ff533220ae36396b$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $ff533220ae36396b$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});




parcelRegister("jEqr0", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => (parcelRequire("gpJGQ")).MainContentSkipLinkWrapper);

var $gpJGQ = parcelRequire("gpJGQ");

});
parcelRegister("gpJGQ", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => $9f5b904aeb7160ee$export$505b93f76cb5cb5c);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $ftqVM = parcelRequire("ftqVM");

var $4CgbU = parcelRequire("4CgbU");
const $9f5b904aeb7160ee$export$505b93f76cb5cb5c = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ftqVM.default), {
        id: "main",
        skipLinkTitle: formatMessage((0, $4CgbU.default).skipToMainA11yLabel),
        testId: "main"
    }, children);
};

});
parcelRegister("ftqVM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ea80afe680a06ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $1Ry06 = parcelRequire("1Ry06");

var $b5xMz = parcelRequire("b5xMz");

var $ieqE6 = parcelRequire("ieqE6");

var $gMNCr = parcelRequire("gMNCr");

var $JakqB = parcelRequire("JakqB");

var $aj0hJ = parcelRequire("aj0hJ");
var $kGKYz = parcelRequire("kGKYz");

var $5OEc0 = parcelRequire("5OEc0");
function $2ea80afe680a06ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $2ea80afe680a06ec$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $jctmk.css)((0, $b5xMz.prefersReducedMotion)());
const $2ea80afe680a06ec$var$mainStyles = /*#__PURE__*/ (0, $jctmk.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s`
});
const $2ea80afe680a06ec$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $2ea80afe680a06ec$var$flyoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $ieqE6.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $ieqE6.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $ieqE6.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $2ea80afe680a06ec$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $kGKYz.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $JakqB.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $fc4bM.useContext)((0, $aj0hJ.SidebarResizeContext));
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5OEc0.default), null, ({ className: className })=>/*#__PURE__*/ (0, $jctmk.jsx)("main", {
            "data-testid": testId,
            css: [
                $2ea80afe680a06ec$var$mainStyles,
                isDragging && $2ea80afe680a06ec$var$draggingStyles,
                isFlyoutOpen && !isFixed && $2ea80afe680a06ec$var$flyoutStyles,
                $2ea80afe680a06ec$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $gMNCr.getPageLayoutSlotSelector)('main')
        }, children));
};
var $2ea80afe680a06ec$export$2e2bcd8739ae039 = $2ea80afe680a06ec$var$Main;

});
parcelRegister("b5xMz", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $b15a047132ced046$export$ff7706047246b98b);

var $cIC5k = parcelRequire("cIC5k");
const $b15a047132ced046$export$ff7706047246b98b = ()=>(0, $cIC5k.reduceMotionAsPerUserPreference);

});
parcelRegister("cIC5k", function(module, exports) {
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $a56d2e32aa53fe04$export$f0f789643ba5a83c);
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $a56d2e32aa53fe04$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

});


parcelRegister("ieqE6", function(module, exports) {
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $4d57e549ddaffa8f$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $4d57e549ddaffa8f$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $4d57e549ddaffa8f$export$b6744d31294864fd);
$parcel$export(module.exports, "LEFT_PANEL", () => $4d57e549ddaffa8f$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $4d57e549ddaffa8f$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $4d57e549ddaffa8f$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $4d57e549ddaffa8f$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $4d57e549ddaffa8f$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $4d57e549ddaffa8f$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $4d57e549ddaffa8f$export$539e68c09584883a);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $4d57e549ddaffa8f$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $4d57e549ddaffa8f$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $4d57e549ddaffa8f$export$991d5285ad765a3d);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $4d57e549ddaffa8f$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $4d57e549ddaffa8f$export$3749e1104328fde4);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $4d57e549ddaffa8f$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $4d57e549ddaffa8f$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $4d57e549ddaffa8f$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $4d57e549ddaffa8f$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $4d57e549ddaffa8f$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $4d57e549ddaffa8f$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $4d57e549ddaffa8f$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $4d57e549ddaffa8f$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $4d57e549ddaffa8f$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $4d57e549ddaffa8f$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $4d57e549ddaffa8f$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $4d57e549ddaffa8f$export$d2fa14f05b61e66);
// dimension vars
const $4d57e549ddaffa8f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $4d57e549ddaffa8f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $4d57e549ddaffa8f$export$c103b605cd368aed = 'rightSidebarWidth';
const $4d57e549ddaffa8f$export$fa34f417972d6341 = 'rightPanelWidth';
const $4d57e549ddaffa8f$export$3a6a779d9181047c = 'topNavigationHeight';
const $4d57e549ddaffa8f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $4d57e549ddaffa8f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $4d57e549ddaffa8f$export$344062f7cfc9528e = 'left-panel';
const $4d57e549ddaffa8f$export$c7139cc2d6110b5f = 'right-panel';
const $4d57e549ddaffa8f$export$238d30785c4bca84 = 'banner';
const $4d57e549ddaffa8f$export$bec6dca2e63de4ae = 'top-navigation';
const $4d57e549ddaffa8f$export$d1213e82613ff4df = 'content';
const $4d57e549ddaffa8f$export$be83e7118304b28e = 56;
const $4d57e549ddaffa8f$export$4a98ee0bd1ae362 = 56;
const $4d57e549ddaffa8f$export$539e68c09584883a = 240;
const $4d57e549ddaffa8f$export$b92df8810d2fcd01 = 280;
const $4d57e549ddaffa8f$export$c3e41153b9288bcf = 368;
const $4d57e549ddaffa8f$export$c4d6152f86ea28f6 = 368;
const $4d57e549ddaffa8f$export$46acf8758e9e2636 = 20;
const $4d57e549ddaffa8f$export$70740f5ad8360a78 = 16;
const $4d57e549ddaffa8f$export$991d5285ad765a3d = 240;
const $4d57e549ddaffa8f$export$6949d4f32b161684 = 200;
const $4d57e549ddaffa8f$export$d6e7e8af042815bb = 350;
const $4d57e549ddaffa8f$export$3749e1104328fde4 = 300;
const $4d57e549ddaffa8f$export$1074d925b0b82be5 = 200;
const $4d57e549ddaffa8f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $4d57e549ddaffa8f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $4d57e549ddaffa8f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $4d57e549ddaffa8f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $4d57e549ddaffa8f$export$48a43f91e4becf4e = 'data-grab-area';
const $4d57e549ddaffa8f$export$dac2fb31a9f6844d = 'data-resize-button';
const $4d57e549ddaffa8f$export$9ecd22db14e6c70e = 'data-resize-control';
const $4d57e549ddaffa8f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $4d57e549ddaffa8f$export$206a08f7f8beb554 = 'Skip to:';
const $4d57e549ddaffa8f$export$659ee746b31b360d = 'data-layout-container';
const $4d57e549ddaffa8f$export$f963aecf2d4465bd = `var(--${$4d57e549ddaffa8f$export$cbfb0f5b2869b17b}, 0px)`;
const $4d57e549ddaffa8f$export$750459958906793 = `var(--${$4d57e549ddaffa8f$export$fa34f417972d6341}, 0px)`;
const $4d57e549ddaffa8f$export$f897e1ed9f8ed251 = `var(--${$4d57e549ddaffa8f$export$a30f2e00489a8957}, 0px)`;
const $4d57e549ddaffa8f$export$b44ab66843c05a69 = `var(--${$4d57e549ddaffa8f$export$c103b605cd368aed}, 0px)`;
const $4d57e549ddaffa8f$export$aeff86a16f13529 = `var(--${$4d57e549ddaffa8f$export$3a6a779d9181047c}, 0px)`;
const $4d57e549ddaffa8f$export$ed7cc0d417ee89e = `var(--${$4d57e549ddaffa8f$export$bcd94a6a792e7f96}, 0px)`;
const $4d57e549ddaffa8f$export$d2fa14f05b61e66 = `var(--${$4d57e549ddaffa8f$export$b6744d31294864fd}, ${$4d57e549ddaffa8f$export$991d5285ad765a3d}px)`;

});

parcelRegister("gMNCr", function(module, exports) {
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $78fa53db04beb8fa$export$e895e3e8b708ae2a);

var $ieqE6 = parcelRequire("ieqE6");
const $78fa53db04beb8fa$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $ieqE6.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });

});

parcelRegister("JakqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7816f805ea21c8cb$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $ieqE6 = parcelRequire("ieqE6");
const $7816f805ea21c8cb$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ieqE6.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $7816f805ea21c8cb$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $fc4bM.useState)($7816f805ea21c8cb$var$getIsDragging);
    (0, $fc4bM.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($7816f805ea21c8cb$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ieqE6.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $7816f805ea21c8cb$export$2e2bcd8739ae039 = $7816f805ea21c8cb$var$useIsSidebarDragging;

});

parcelRegister("aj0hJ", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeContext", () => $6909e1bac3536cbf$export$aa5a712eea4c2ae8);

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");
const $6909e1bac3536cbf$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $6909e1bac3536cbf$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $9JZL9.default),
    collapseLeftSidebar: (0, $9JZL9.default),
    leftSidebarState: $6909e1bac3536cbf$var$leftSidebarState,
    setLeftSidebarState: (0, $9JZL9.default),
    toggleLeftSidebar: (0, $9JZL9.default)
});

});

parcelRegister("kGKYz", function(module, exports) {
$parcel$export(module.exports, "useSkipLink", () => $31efb9133db8d965$export$89d9323301efc7d6);

var $fc4bM = parcelRequire("fc4bM");

var $luuro = parcelRequire("luuro");
const $31efb9133db8d965$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $luuro.useSkipLinks)();
    (0, $fc4bM.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("luuro", function(module, exports) {
$parcel$export(module.exports, "useSkipLinks", () => $cd264f3faea12c54$export$c9d9cb2ee9590f87);

var $fc4bM = parcelRequire("fc4bM");

var $2teat = parcelRequire("2teat");
const $cd264f3faea12c54$export$c9d9cb2ee9590f87 = ()=>(0, $fc4bM.useContext)((0, $2teat.SkipLinksContext));

});
parcelRegister("2teat", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $97af527f5b46849a$export$4c5cc3b14c7678a);

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");
const $97af527f5b46849a$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $fc4bM.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $9JZL9.default),
    unregisterSkipLink: (0, $9JZL9.default)
});

});



parcelRegister("5OEc0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a52ac25fd0c3a0ba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");
const $a52ac25fd0c3a0ba$var$focusStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $a52ac25fd0c3a0ba$var$sidebarFocusStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $a52ac25fd0c3a0ba$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $jctmk.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($a52ac25fd0c3a0ba$var$sidebarFocusStyles) : css($a52ac25fd0c3a0ba$var$focusStyles)
        }));
};
var $a52ac25fd0c3a0ba$export$2e2bcd8739ae039 = $a52ac25fd0c3a0ba$var$SlotFocusRing;

});


parcelRegister("4CgbU", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc4dbf75dbade227$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $fc4dbf75dbade227$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    skipToMainA11yLabel: {
        defaultMessage: 'Skip to Main Content',
        description: 'A11y Label for Skip to Main Content',
        id: 'sd.view.common.skip.links.main-content-skip-link.a11y-label'
    }
});

});



parcelRegister("4m70N", function(module, exports) {
$parcel$export(module.exports, "paperTransitionTime", () => $30cc0326f1f96b70$export$c04d9b45b952bb2f);
$parcel$export(module.exports, "Content", () => $30cc0326f1f96b70$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "NoteContent", () => $30cc0326f1f96b70$export$fe2e0d4376bdc305);
$parcel$export(module.exports, "NoteBackground", () => $30cc0326f1f96b70$export$8eb56b799bce002f);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => $30cc0326f1f96b70$export$80c4326e65e7230d);
$parcel$export(module.exports, "PaperContent", () => $30cc0326f1f96b70$export$bf9cd54d94ffe52b);
$parcel$export(module.exports, "PaperBackground", () => $30cc0326f1f96b70$export$69bd0e70980f4e9f);
$parcel$export(module.exports, "StyledFooter", () => $30cc0326f1f96b70$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $k3ktd = parcelRequire("k3ktd");

var $4rovU = parcelRequire("4rovU");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $6F3K7 = parcelRequire("6F3K7");

var $5ZHKM = parcelRequire("5ZHKM");

var $iG0dO = parcelRequire("iG0dO");

var $12QfD = parcelRequire("12QfD");
// This is the width of the paper without any scaling
// It's fixed at 1000px for easy calculation.
const $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS = $fOCtI.multiple(125);
// 800px is normal width
const $30cc0326f1f96b70$var$PAPER_NORMAL_WIDTH = $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.multiple(0.8).unitless;
// 1000px is wide width
const $30cc0326f1f96b70$var$PAPER_WIDE_WIDTH = $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.multiple(1).unitless;
// 1100px is extra wide width
const $30cc0326f1f96b70$var$PAPER_XWIDE_WIDTH = $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.multiple(1.1).unitless;
// 1200px is extra wide width
const $30cc0326f1f96b70$var$PAPER_XXWIDE_WIDTH = $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.multiple(1.2).unitless;
const $30cc0326f1f96b70$var$PAPER_NOTE_WIDTH = $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.multiple(0.48).unitless;
const $30cc0326f1f96b70$var$PAPER_PADDING_TOP = "var(--ds-space-300, 24px)";
const $30cc0326f1f96b70$var$PAPER_PADDING_RIGHT_MOBILE = "var(--ds-space-400, 32px)";
const $30cc0326f1f96b70$var$PAPER_PADDING_LEFT_MOBILE = "var(--ds-space-400, 32px)";
const $30cc0326f1f96b70$var$PAPER_PADDING_RIGHT_DESKTOP = $fOCtI.multiple(13.5).unitless;
const $30cc0326f1f96b70$var$PAPER_PADDING_LEFT_DESKTOP = $fOCtI.multiple(11).unitless;
const $30cc0326f1f96b70$var$PAPER_PADDING_SMALL = "var(--ds-space-600, 48px)";
const $30cc0326f1f96b70$var$PAPER_NOTE_HEIGHT = $fOCtI.multiple(52).unitless;
const $30cc0326f1f96b70$var$PAPER_NOTE_MARGIN_TOP = $fOCtI.multiple(20).unitless - (0, $iG0dO.HEADER_HEIGHT);
const $30cc0326f1f96b70$export$c04d9b45b952bb2f = $6F3K7.speedMs.slow;
const $30cc0326f1f96b70$var$getContentWidth = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $30cc0326f1f96b70$var$PAPER_XXWIDE_WIDTH;
        case 'xwide':
            return $30cc0326f1f96b70$var$PAPER_XWIDE_WIDTH;
        case 'wide':
            return $30cc0326f1f96b70$var$PAPER_WIDE_WIDTH;
        case 'note':
            return $30cc0326f1f96b70$var$PAPER_NOTE_WIDTH;
        default:
            return $30cc0326f1f96b70$var$PAPER_NORMAL_WIDTH;
    }
};
const $30cc0326f1f96b70$var$getScale = (appearance)=>$30cc0326f1f96b70$var$getContentWidth(appearance) / $30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.unitless;
const $30cc0326f1f96b70$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $luz1X.default).main.withConfig({
    componentId: "sc-1jc43ym-0"
})`box-sizing:border-box;display:flex;flex-direction:column;flex:1 1 auto;margin:${"var(--ds-space-0, 0px)"} auto;width:100%;max-width:${(props)=>props.hide ? '100%' : `${$30cc0326f1f96b70$var$getContentWidth(props.appearance)}px`};min-height:100%;${$k3ktd.fromCustom($30cc0326f1f96b70$var$PAPER_NOTE_WIDTH).css`
        min-height: ${(props)=>props.appearance === 'note' ? `${$30cc0326f1f96b70$var$PAPER_NOTE_HEIGHT}px` : '100%'};
        margin-top: ${(props)=>props.appearance === 'note' ? `${$30cc0326f1f96b70$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $30cc0326f1f96b70$export$fe2e0d4376bdc305 = /*#__PURE__*/ (0, $luz1X.default)($30cc0326f1f96b70$export$7c6e2c02157bb7d2).attrs({
    appearance: 'note'
}).withConfig({
    componentId: "sc-1jc43ym-1"
})`align-self:flex-start;max-width:${(props)=>props.hide ? '100%' : `${$30cc0326f1f96b70$var$getContentWidth(props.appearance)}px`};`;
const $30cc0326f1f96b70$export$8eb56b799bce002f = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1jc43ym-2"
})`${$4rovU.e100};border-radius:${"var(--ds-radius-large, 8px)"};background-color:${"var(--ds-surface, #FFFFFF)"};min-height:inherit;`;
const $30cc0326f1f96b70$export$80c4326e65e7230d = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1jc43ym-3"
})`display:flex;flex-direction:column;flex:1 1 auto;padding-top:${$30cc0326f1f96b70$var$PAPER_PADDING_TOP};padding-left:${$30cc0326f1f96b70$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$30cc0326f1f96b70$var$PAPER_PADDING_RIGHT_MOBILE};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};${$k3ktd.fromCustom($30cc0326f1f96b70$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$30cc0326f1f96b70$var$PAPER_PADDING_SMALL};
        padding-right: ${$30cc0326f1f96b70$var$PAPER_PADDING_SMALL};
    `};`;
const $30cc0326f1f96b70$export$49f7b90a0c83f2b0 = /*#__PURE__*/ (0, $luz1X.css)`padding-top:${$30cc0326f1f96b70$var$PAPER_PADDING_TOP};padding-left:${$30cc0326f1f96b70$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$30cc0326f1f96b70$var$PAPER_PADDING_RIGHT_MOBILE};${$k3ktd.fromCustom($30cc0326f1f96b70$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$30cc0326f1f96b70$var$PAPER_PADDING_LEFT_DESKTOP}px;
        padding-right: ${$30cc0326f1f96b70$var$PAPER_PADDING_RIGHT_DESKTOP}px;
    `};`;
const $30cc0326f1f96b70$export$bf9cd54d94ffe52b = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1jc43ym-4"
})`display:flex;flex-direction:column;flex:1 1 auto;${$30cc0326f1f96b70$export$49f7b90a0c83f2b0};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};`;
const $30cc0326f1f96b70$export$69bd0e70980f4e9f = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1jc43ym-5"
})`position:absolute;width:${$30cc0326f1f96b70$var$PAPER_WIDTH_BASIS.px};height:inherit;right:0;bottom:0;top:0;left:50%;${$3DjOo.borderRadius};border-bottom-left-radius:0;border-bottom-right-radius:0;background-color:${"var(--ds-surface, #FFFFFF)"};box-shadow:${`var(--ds-shadow-overlay, ${`0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} -${$fOCtI.multiple(0.5).px} ${'rgba(9, 30, 66, 0.25)'}, 0 0 1px ${'rgba(9, 30, 66, 0.31)'}`})`};z-index:${$5ZHKM.pageInBannerLayout};transition:transform ${$6F3K7.timingFunctions.easeInOutQuad} ${$30cc0326f1f96b70$export$c04d9b45b952bb2f}ms;transform:${(props)=>`translate3d(-50%, ${props.hide ? '100%' : '0'}, 0) scale3d(${$30cc0326f1f96b70$var$getScale(props.appearance)}, 1, 1)`};${$k3ktd.fromCustom($30cc0326f1f96b70$var$PAPER_NOTE_WIDTH).css`
        height: ${(props)=>props.appearance === 'note' ? `${$30cc0326f1f96b70$var$PAPER_NOTE_HEIGHT}px` : 'inherit'};
        top: ${(props)=>props.appearance === 'note' ? `${$30cc0326f1f96b70$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $30cc0326f1f96b70$export$61905ae62c7860fb = /*#__PURE__*/ (0, $luz1X.default)((0, $12QfD.Footer)).withConfig({
    componentId: "sc-1jc43ym-6"
})`left:0;right:0;height:${$fOCtI.multiple(6).px};padding:${"var(--ds-space-600, 48px)"} 0 ${"var(--ds-space-100, 8px)"} 0;display:flex;align-items:center;justify-content:center;`;

});



parcelRegister("jibrf", function(module, exports) {
$parcel$export(module.exports, "ErrorLink", () => $3e71f31ea39ed52b$export$d2c8415987899609);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $g9mbo = parcelRequire("g9mbo");

var $fRgxR = parcelRequire("fRgxR");

var $diqlM = parcelRequire("diqlM");

var $ivtaS = parcelRequire("ivtaS");
const $3e71f31ea39ed52b$export$d2c8415987899609 = ({ callToActionUrl: callToActionUrl, children: children })=>{
    if (callToActionUrl.includes((0, $ivtaS.LOGIN_ROUTE))) return /*#__PURE__*/ $fc4bM.createElement($3e71f31ea39ed52b$export$f13d6b6525b315e0, {
        actionSubjectId: "redirectToLogin",
        href: (0, $diqlM.getRelativeBasePath)() + callToActionUrl
    }, children);
    return /*#__PURE__*/ $fc4bM.createElement($3e71f31ea39ed52b$export$a6c7ac8248d6e38a, {
        actionSubjectId: "callToAction",
        to: callToActionUrl
    }, children);
};
$3e71f31ea39ed52b$export$d2c8415987899609.displayName = 'ErrorLink';
const $3e71f31ea39ed52b$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $luz1X.default)((0, $fRgxR.default)).withConfig({
    componentId: "sc-1mmbyta-0"
})`text-align:center;`;
const $3e71f31ea39ed52b$export$f13d6b6525b315e0 = /*#__PURE__*/ (0, $luz1X.default)((0, $g9mbo.HtmlAnchor)).withConfig({
    componentId: "sc-1mmbyta-1"
})`text-align:center;`;

});
parcelRegister("fRgxR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7daacfc810550e49$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");
const $7daacfc810550e49$export$1d567c320f4763bc = /*#__PURE__*/ (0, $luz1X.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};${(props)=>props.hasUnderline && 'text-decoration: underline;'} &:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7daacfc810550e49$var$ThemedLink = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-1tr99za-0"
})`${$7daacfc810550e49$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$7daacfc810550e49$export$2e2bcd8739ae039 = $7daacfc810550e49$var$ThemedLink;

});
parcelRegister("io4o2", function(module, exports) {
$parcel$export(module.exports, "Link", () => $52b080b5a8990cd8$export$a6c7ac8248d6e38a);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $hi8gb = parcelRequire("hi8gb");

var $asUgz = parcelRequire("asUgz");

var $Meqgy = parcelRequire("Meqgy");
const $52b080b5a8990cd8$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...props })=>{
    const { to: to, target: target, ...rest } = props;
    if (typeof to === 'string') return /*#__PURE__*/ $fc4bM.createElement((0, $Meqgy.default), {
        to: to,
        target: target,
        ...rest
    });
    return /*#__PURE__*/ $fc4bM.createElement((0, $hi8gb.default), props);
};
const $52b080b5a8990cd8$export$a6c7ac8248d6e38a = (0, $asUgz.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($52b080b5a8990cd8$var$InstrumentedLink);

});
parcelRegister("Meqgy", function(module, exports) {
$parcel$export(module.exports, "default", () => $02e487926c68e353$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $b2AyF = parcelRequire("b2AyF");
parcelRequire("a3Wd7");
var $hi8gb = parcelRequire("hi8gb");
var $dpoZ0 = parcelRequire("dpoZ0");

const $02e487926c68e353$export$d3010bc2e9cc1386 = (to, currentLocation)=>{
    // @ts-ignore the location provided by RRR is compatible with history location
    return (0, $b2AyF.createLocation)(to, null, undefined, currentLocation);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $02e487926c68e353$var$isModifiedEvent = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
/**
 * In server side rendering we use memory history, which doesn't have the base name. hence append basename manually
 */ function $02e487926c68e353$var$getHref(history, location) {
    return history.createHref(location);
}
/**
 * React resource router doesn't support baseUrl if the "to" property is a string.
 * We have to introduce this wrapper to workaround it otherwise the migration's surface area become too large.
 * Moving forward we should use "route" instead of string for the link component since it is better supported.
 *
 *  @deprecated this component shouldn't be used directly.
 */ const $02e487926c68e353$var$BaseUrlRespectLink = (props)=>{
    const { to: to, onClick: onClick, history: history, location: location, ...rest } = props;
    const toAsLocation = $02e487926c68e353$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $02e487926c68e353$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $fc4bM.useCallback)((e)=>{
        try {
            onClick && onClick(e);
        } catch (ex) {
            e.preventDefault();
            throw ex;
        }
        if (!e.defaultPrevented && (// onClick prevented default
        e.button === 0 || e.keyCode === 13) && // ignore everything but left clicks or enter
        (!props.target || props.target === '_self') && // let browser handle "target=_blank" etc.
        !$02e487926c68e353$var$isModifiedEvent(e) // ignore clicks with modifier keys
        ) {
            e.preventDefault();
            const method = props.replace ? history.replace : history.push;
            method(toAsLocation);
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    return /*#__PURE__*/ $fc4bM.createElement((0, $hi8gb.default), {
        href: href,
        ...rest,
        onClick: wrappedOnClick
    });
};
const $02e487926c68e353$var$BaseUrlRespectLinkWithRouter = (props)=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $dpoZ0.RouterSubscriber), null, ({ location: location, history: // @ts-ignore access private `history` store property
    history })=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        /*#__PURE__*/ $fc4bM.createElement($02e487926c68e353$var$BaseUrlRespectLink, {
            location: location,
            history: history,
            ...props
        }));
};
var $02e487926c68e353$export$2e2bcd8739ae039 = $02e487926c68e353$var$BaseUrlRespectLinkWithRouter;

});



parcelRegister("ivtaS", function(module, exports) {
$parcel$export(module.exports, "PORTAL_ROUTE_PREFIX", () => $0b414734bbb2277a$export$2b06f7190715126f);
$parcel$export(module.exports, "LOGIN_ROUTE", () => $0b414734bbb2277a$export$9f22ab6dfd3d5ec5);
$parcel$export(module.exports, "PROJECT_NAME", () => $0b414734bbb2277a$export$cb77c55dd12a845e);
$parcel$export(module.exports, "anonymousScreenLayout", () => $0b414734bbb2277a$export$205bfffc91265169);
const $0b414734bbb2277a$export$2b06f7190715126f = '/portal/:portalId(\\d+)';
const $0b414734bbb2277a$export$9f22ab6dfd3d5ec5 = '/user/login';
const $0b414734bbb2277a$export$cb77c55dd12a845e = 'jira-servicedesk.ondemand';
const $0b414734bbb2277a$export$205bfffc91265169 = Object.freeze({
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});

});


parcelRegister("csYQe", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fbffd90dc95f4f6$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $6fbffd90dc95f4f6$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    permissionDenied: {
        defaultMessage: 'No Access',
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.error'
    },
    permissionDeniedMessage: {
        defaultMessage: "Sorry you're not allowed to see this.",
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.message'
    },
    notFound: {
        defaultMessage: 'Not Found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error'
    },
    notFoundMessage: {
        defaultMessage: 'We are having trouble finding that. Check the details and try again.',
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message'
    },
    notFoundV2: {
        defaultMessage: 'Site not found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error.v2'
    },
    notFoundMessageV2: {
        defaultMessage: "We couldn\u2019t find the site. Check the details and try again.",
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message.v2'
    },
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.heading'
    },
    genericMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.message'
    },
    offlineHeading: {
        defaultMessage: "You're disconnected from the internet",
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.heading'
    },
    offlineMessage: {
        defaultMessage: 'The internet may be out to lunch. Check your network connection and try again.',
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.message'
    }
});

});


parcelRegister("dRiEG", function(module, exports) {
$parcel$export(module.exports, "ContextSetter", () => (parcelRequire("7hPHG")).default);

var $7hPHG = parcelRequire("7hPHG");

});
parcelRegister("7hPHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cf8dd448fd084d1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("gC4ux");
var $kecDY = parcelRequire("kecDY");
class $6cf8dd448fd084d1$export$28f8b4e4081c59b0 extends $fc4bM.Component {
    updateContextAction(props) {
        const { location: location, match: match, route: route } = props;
        const pathParams = match && match.params || {};
        const pathname = location && location.pathname;
        const routeName = route.name;
        props.updateContextAction({
            pathParams: pathParams,
            pathname: pathname,
            routeName: routeName
        });
    }
    // eslint-disable-next-line react/no-deprecated
    componentWillUpdate(nextProps) {
        this.updateContextAction(nextProps);
    }
    // We use componentDidMount (instead of componentWillMount) here because we need the mount method to be
    // called after all the previous ContextSetters have been unmounted.
    componentDidMount() {
        this.updateContextAction(this.props);
    }
    componentWillUnmount() {
        this.props.clearContextAction();
    }
    render() {
        return null;
    }
}
var $6cf8dd448fd084d1$export$2e2bcd8739ae039 = (0, $6umft.default)(null, {
    updateContextAction: $kecDY.updateContextAction,
    clearContextAction: $kecDY.clearContextAction
})($6cf8dd448fd084d1$export$28f8b4e4081c59b0);

});


parcelRegister("6OVhp", function(module, exports) {
$parcel$export(module.exports, "ScreenErrorBoundary", () => (parcelRequire("4xX38")).default);

var $4xX38 = parcelRequire("4xX38");

});
parcelRegister("4xX38", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaa3d0f3d9a36f54$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");
const $aaa3d0f3d9a36f54$var$ScreenErrorBoundary = ({ screenName: screenName, children: children, renderError: renderError })=>// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
        packageName: screenName,
        id: `${screenName}Screen`,
        renderError: renderError
    }, children);
var $aaa3d0f3d9a36f54$export$2e2bcd8739ae039 = $aaa3d0f3d9a36f54$var$ScreenErrorBoundary;

});


parcelRegister("dFIgM", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAnonymousSuccess", () => $73c486a280347dab$export$c343a4f818004f01);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $73c486a280347dab$export$c343a4f818004f01 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("hEW9C")), {
        moduleId: "./src/view/request-create-anonymous-success/request-create-anonymous-success.tsx"
    })
});

});
parcelRegister("hEW9C", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("aAwZg").then(()=>parcelRequire('kKVQm'));

});


parcelRegister("5KL18", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePage", () => $376128f125a95c3b$export$cf665508b87b4a0f);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $376128f125a95c3b$var$loader = (0, $dohmo.lazyForPaint)(()=>{
    return (parcelRequire("cGF7E"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hocs.tsx"
});
const $376128f125a95c3b$export$cf665508b87b4a0f = (0, $bQkfB.default)({
    loader: $376128f125a95c3b$var$loader
});

});
parcelRegister("cGF7E", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8g0FF").then(()=>parcelRequire('cIC7R'));

});


parcelRegister("gFjPV", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePageForHubs", () => $ae0ea0cd22e7c8e1$export$43b5a631464c5e8e);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $ae0ea0cd22e7c8e1$var$loader = (0, $dohmo.lazyForPaint)(()=>{
    return (parcelRequire("k5k8F"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hub-variant/hub-variant.tsx"
});
const $ae0ea0cd22e7c8e1$export$43b5a631464c5e8e = (0, $bQkfB.default)({
    loader: $ae0ea0cd22e7c8e1$var$loader
});

});
parcelRegister("k5k8F", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bmLFd"),
    $9dnsd("lv25e"),
    $9dnsd("9Fw1L"),
    $9dnsd("4NKrY"),
    $9dnsd("kE1ct"),
    $9dnsd("je1qw"),
    $9dnsd("5sb3y"),
    $9dnsd("aejHq"),
    $9dnsd("cFGPX"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("bMKAA"),
    $9dnsd("h05a5"),
    $9dnsd("SIJqa"),
    $9dnsd("1NZ7T")
]).then(()=>parcelRequire('6OYY4'));

});


parcelRegister("1qVIU", function(module, exports) {
$parcel$export(module.exports, "RequestFeedback", () => $26b9e42a7c8a777e$export$3dcde5242ce8b346);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $26b9e42a7c8a777e$export$3dcde5242ce8b346 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("cqSj7")), {
        moduleId: "./src/view/request-feedback/hocs.tsx"
    })
});

});
parcelRegister("cqSj7", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hggw5").then(()=>parcelRequire('iYxSr'));

});


parcelRegister("jr9Qn", function(module, exports) {
$parcel$export(module.exports, "Unsubscribe", () => $3406d140d8beb314$export$cf424b9d16eab6b0);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $3406d140d8beb314$export$cf424b9d16eab6b0 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("lP5Of")), {
        moduleId: "./src/view/unsubscribe/hocs.tsx"
    })
});

});
parcelRegister("lP5Of", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kB7rf").then(()=>parcelRequire('imMl3'));

});


parcelRegister("iLQ5e", function(module, exports) {
$parcel$export(module.exports, "UserProfile", () => $b1597d09b642b814$export$b7b58f2e100445f7);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $b1597d09b642b814$var$loader = (0, $dohmo.lazyForPaint)(()=>(parcelRequire("ehPsw")), {
    moduleId: "./src/view/user-profile/hocs.tsx"
});
const $b1597d09b642b814$export$b7b58f2e100445f7 = (0, $bQkfB.default)({
    loader: $b1597d09b642b814$var$loader
});

});
parcelRegister("ehPsw", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("3ky1E").then(()=>parcelRequire('danfP'));

});


parcelRegister("dkrfZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f2f722c6a88c74a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eENmG = parcelRequire("eENmG");

var $aZfc9 = parcelRequire("aZfc9");

var $2bGke = parcelRequire("2bGke");

var $hIWb6 = parcelRequire("hIWb6");

var $jgb8T = parcelRequire("jgb8T");
class $2f2f722c6a88c74a$var$PortalScreenWithBrowserMetrics extends $fc4bM.Component {
    constructor(props){
        super(props), this.state = {
            screenWasHidden: false
        }, this.startTimer = (screenName)=>{
            const { preventBrowserMetricsTimerResetOnScreenMount: preventBrowserMetricsTimerResetOnScreenMount, stopBrowserMetricsTransitionToNewScreen: stopBrowserMetricsTransitionToNewScreen } = this.props;
            if (!preventBrowserMetricsTimerResetOnScreenMount) {
                (0, $jgb8T.devLog)('Browser metrics: starting timer for screen:', screenName);
                /**
       * Browser metrics v3 start page load
       */ (0, $aZfc9.startPageLoad)(screenName);
            } else stopBrowserMetricsTransitionToNewScreen();
        }, this.handleVisibilityChange = ()=>{
            this.setState({
                screenWasHidden: true
            });
        };
        this.startTimer(props.screenName);
    }
    // this must be called before post-mount and post-update lifecycle methods
    // to ensure it is called before `endTimer` is called.
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { screenName: screenName, screenId: screenId } = this.props;
        if (nextProps.screenName !== screenName || nextProps.screenId !== screenId) {
            this.setState({
                screenWasHidden: false
            });
            this.startTimer(nextProps.screenName);
        }
    }
    componentDidMount() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    render() {
        const { screenName: screenName, children: children, screenId: screenId } = this.props;
        // We need to set the screen name to undefined if the window visibility changed
        // so the browser metrics event never gets fired.
        // If the user changes tabs while the page is loading, the time to load is calculated incorrectly.
        // So we're discarding these events as a workaround. See FSD-3537.
        const screenNameForBrowserMetrics = this.state.screenWasHidden ? undefined : screenName;
        return /*#__PURE__*/ $fc4bM.createElement((0, $hIWb6.ScreenNameProvider), {
            params: {
                screenId: screenId,
                screenName: screenNameForBrowserMetrics
            }
        }, /*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
            sourceName: screenName,
            sourceType: (0, $eENmG.ScreenTypes).SCREEN
        }, children));
    }
}
/**
 * Establishes a new screen for analytics and browsermetrics purposes.
 * Will set analytics context, and start a browsermetrics timer for the screen.
 * @param screenName the name of the screen, fired in the event
 * @param screenId an optional further identifier for cases when a user can navigate between two
 * different screens with the same name, e.g. two request create screens for different request types
 */ const $2f2f722c6a88c74a$var$AnalyticsScreen = (props)=>{
    const { screenName: screenName, children: children, screenId: screenId } = props;
    return /*#__PURE__*/ $fc4bM.createElement((0, $2bGke.BrowserMetricsScreenTransitionStatusContext).Consumer, null, (value)=>/*#__PURE__*/ $fc4bM.createElement($2f2f722c6a88c74a$var$PortalScreenWithBrowserMetrics, {
            screenName: screenName,
            screenId: screenId,
            preventBrowserMetricsTimerResetOnScreenMount: value.preventBrowserMetricsTimerResetOnScreenMount,
            stopBrowserMetricsTransitionToNewScreen: value.stopBrowserMetricsTransitionToNewScreen
        }, children));
};
var $2f2f722c6a88c74a$export$2e2bcd8739ae039 = $2f2f722c6a88c74a$var$AnalyticsScreen;

});
parcelRegister("hIWb6", function(module, exports) {
$parcel$export(module.exports, "ScreenNameProvider", () => $6bfa9d078cd38b86$export$e037354b8fc39c88);
$parcel$export(module.exports, "clearScreenName", () => $6bfa9d078cd38b86$export$d4736a6a534144a);
$parcel$export(module.exports, "default", () => $6bfa9d078cd38b86$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $6bfa9d078cd38b86$var$ScreenNameContext = /*#__PURE__*/ $fc4bM.createContext({
    screenName: undefined
});
const $6bfa9d078cd38b86$export$e037354b8fc39c88 = (props)=>/*#__PURE__*/ $fc4bM.createElement($6bfa9d078cd38b86$var$ScreenNameContext.Provider, {
        value: props.params
    }, props.children);
const $6bfa9d078cd38b86$export$d4736a6a534144a = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $fc4bM.createElement($6bfa9d078cd38b86$var$ScreenNameContext.Provider, {
            value: {
                screenName: undefined
            }
        }, /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props));
const $6bfa9d078cd38b86$var$withScreenName = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $fc4bM.createElement($6bfa9d078cd38b86$var$ScreenNameContext.Consumer, null, (value)=>/*#__PURE__*/ $fc4bM.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $6bfa9d078cd38b86$export$2e2bcd8739ae039 = $6bfa9d078cd38b86$var$withScreenName;

});


parcelRegister("joDHD", function(module, exports) {
$parcel$export(module.exports, "createRouteWithLayout", () => $ec18519c70b3b332$export$64cff199c78ee95d);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("imh0G");
var $d041D = parcelRequire("d041D");
const $ec18519c70b3b332$var$selector = (0, $2n2bS.createSelector)((0, $fYLlE.getHeadless), (headerless)=>({
        headerless: headerless
    }));
const $ec18519c70b3b332$export$64cff199c78ee95d = (route, screenName, layoutProps)=>{
    const { path: path, component: component } = route;
    const LayoutRouteComponent = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d041D.BannerWithPaperLayoutRoute), {
            path: path,
            component: component,
            layoutProps: {
                headerless: props.headerless,
                ...layoutProps
            },
            screenName: screenName
        });
    };
    return {
        ...route,
        component: (0, $7tc2B.withRouter)((0, $6umft.default)($ec18519c70b3b332$var$selector)(LayoutRouteComponent))
    };
};

});
parcelRegister("imh0G", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => (parcelRequire("d041D")).BannerWithPaperLayoutRoute);

var $d041D = parcelRequire("d041D");

});
parcelRegister("d041D", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => $94973d87968a62ee$export$fd1a0cfe11934244);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("btLr7");
var $bJ9hx = parcelRequire("bJ9hx");

var $d7r8x = parcelRequire("d7r8x");

var $7hRmh = parcelRequire("7hRmh");
parcelRequire("1D1ic");
var $47PFR = parcelRequire("47PFR");
parcelRequire("j9whS");
var $dQIWS = parcelRequire("dQIWS");
parcelRequire("aQGvL");
var $jAOGD = parcelRequire("jAOGD");
const $94973d87968a62ee$export$75ef22cdda92e1da = (props)=>{
    const { children: children, helpCenterBanner: helpCenterBanner, ...restProps } = props;
    // Use the useCachedUrl hook to handle the banner URL
    const { cachedBannerUrl: cachedBannerUrl, isLoading: isBannerImageLoading } = (0, $7hRmh.useCachedUrl)(helpCenterBanner);
    if ((0, $hN5YJ.isUseHelpCenterRefresh)()) return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), /*#__PURE__*/ $fc4bM.createElement((0, $47PFR.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), /*#__PURE__*/ $fc4bM.createElement((0, $dQIWS.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
};
const $94973d87968a62ee$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getHelpCenterBanner), (0, $bJ9hx.getShown), (0, $ePyx3.getHelpCenterBrandingLoader), (helpCenterBanner, searchShown, isBrandingLoaded)=>({
        helpCenterBanner: helpCenterBanner,
        searchShown: searchShown,
        isBrandingLoaded: isBrandingLoaded
    }));
const $94973d87968a62ee$var$ConnectedBannerWithPaperLayout = (0, $6umft.default)($94973d87968a62ee$var$selector)($94973d87968a62ee$export$75ef22cdda92e1da);
const $94973d87968a62ee$export$fd1a0cfe11934244 = (0, $jAOGD.default)($94973d87968a62ee$var$ConnectedBannerWithPaperLayout);
var $94973d87968a62ee$export$2e2bcd8739ae039 = $94973d87968a62ee$var$ConnectedBannerWithPaperLayout;

});
parcelRegister("btLr7", function(module, exports) {
$parcel$export(module.exports, "getShown", () => (parcelRequire("bJ9hx")).getShown);
$parcel$export(module.exports, "getTerm", () => (parcelRequire("bJ9hx")).getTerm);

var $bJ9hx = parcelRequire("bJ9hx");

});
parcelRegister("bJ9hx", function(module, exports) {
$parcel$export(module.exports, "getShown", () => $93f779836d3a3dfa$export$75d5ea8092347462);
$parcel$export(module.exports, "getTerm", () => $93f779836d3a3dfa$export$3947fb2f9e53bfd);
const $93f779836d3a3dfa$export$75d5ea8092347462 = (state)=>state.ui.search.shown;
const $93f779836d3a3dfa$export$3947fb2f9e53bfd = (state)=>state.ui.search.term;

});


parcelRegister("7hRmh", function(module, exports) {
$parcel$export(module.exports, "useCachedUrl", () => $2bd6357dcb5187b4$export$6c4a7056bc19c165);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $aVQWM = parcelRequire("aVQWM");

var $eENmG = parcelRequire("eENmG");

var $8lYjN = parcelRequire("8lYjN");
const $2bd6357dcb5187b4$export$6c4a7056bc19c165 = function(inputUrl) {
    const [cachedBannerUrl, setCachedBannerUrl] = (0, $fc4bM.useState)();
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        if (!!inputUrl && inputUrl.startsWith('blob:')) {
            setCachedBannerUrl(inputUrl);
            setIsLoading(false);
        } else if (!!inputUrl) (0, $8lYjN.getObjectURLFromMediaURLWithCaching)(inputUrl).then((url)=>{
            setCachedBannerUrl(url);
            setIsLoading(false);
        }).catch((error)=>{
            setIsLoading(false);
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'useCachedUrl',
                attributes: {
                    errorMessage: error.message
                }
            }).fire((0, $aVQWM.ANALYTICS_BRIDGE_CHANNEL));
        });
        else {
            setCachedBannerUrl(null);
            setIsLoading(false);
        }
    }, [
        createAnalyticsEvent,
        inputUrl,
        setCachedBannerUrl
    ]);
    return {
        cachedBannerUrl: cachedBannerUrl,
        isLoading: isLoading
    };
};

});
parcelRegister("8lYjN", function(module, exports) {
$parcel$export(module.exports, "getObjectURLFromMediaURLWithCaching", () => $b7b9cdc0bbde27df$export$183e77d363d2e63e);

var $6dipk = parcelRequire("6dipk");

var $hBskT = parcelRequire("hBskT");
const $b7b9cdc0bbde27df$var$PARAM_KEY_TOKEN = 'token';
const $b7b9cdc0bbde27df$var$PARAM_KEY_MAX_AGE = 'max-age';
const $b7b9cdc0bbde27df$var$PARAM_KEY_HEIGHT = 'height';
const $b7b9cdc0bbde27df$var$DEFAULT_PARAM_VALUE_MAX_AGE = '31536000'; // maximum value for max-age supported by media services
const $b7b9cdc0bbde27df$var$HEIGHT_MAX_PARAM_VALUE = '4096'; // maximum value for height supported by media services
const $b7b9cdc0bbde27df$var$MAX_RETRIES = 5;
const $b7b9cdc0bbde27df$var$MS_BETWEEN_TRIES = 500;
const $b7b9cdc0bbde27df$var$USE_ASYNC = true;
// A local cache for the blob URLs to avoid polluting blob storage
const $b7b9cdc0bbde27df$var$BLOB_CACHE = {};
const $b7b9cdc0bbde27df$export$183e77d363d2e63e = (completeUrl, msBetweenTries = $b7b9cdc0bbde27df$var$MS_BETWEEN_TRIES)=>{
    return $b7b9cdc0bbde27df$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries);
};
const $b7b9cdc0bbde27df$var$internalGetObjectURLFromMediaURLWithCaching = (completeUrl, msBetweenTries = $b7b9cdc0bbde27df$var$MS_BETWEEN_TRIES, tryNumber = 1)=>{
    // Suppressing existing violation. Please fix this.
    const { url: url, token: token } = $b7b9cdc0bbde27df$var$parseUrl(completeUrl);
    // if we already created a blob url for this url, just finish.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if ($b7b9cdc0bbde27df$var$BLOB_CACHE[url]) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    return Promise.resolve($b7b9cdc0bbde27df$var$BLOB_CACHE[url]);
    const req = new XMLHttpRequest();
    req.open('GET', url, $b7b9cdc0bbde27df$var$USE_ASYNC);
    req.responseType = 'arraybuffer';
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    token && req.setRequestHeader('Authorization', `Bearer ${token}`);
    return new Promise((resolve, reject)=>{
        req.onload = ()=>{
            if (req.status === 200) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const blobUrl = (0, $hBskT.createObjectURLFromResponse)(req.response, req.getResponseHeader('content-type'));
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                $b7b9cdc0bbde27df$var$BLOB_CACHE[url] = blobUrl;
                resolve(blobUrl);
            } else reject(req.statusText);
        };
        req.onerror = ()=>{
            if (req.status === 404 && tryNumber < $b7b9cdc0bbde27df$var$MAX_RETRIES) $b7b9cdc0bbde27df$var$wait(msBetweenTries).then(()=>$b7b9cdc0bbde27df$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries, tryNumber + 1)).then(resolve, reject);
            else reject(req.statusText);
        };
        req.send();
    });
};
const $b7b9cdc0bbde27df$var$parseUrl = (completeUrl)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { url: url, query: query } = $6dipk.parseUrl(completeUrl);
    // parse the url and token
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const mediaApiJwt = query[$b7b9cdc0bbde27df$var$PARAM_KEY_TOKEN];
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    delete query[$b7b9cdc0bbde27df$var$PARAM_KEY_TOKEN];
    // prepare the query string
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$b7b9cdc0bbde27df$var$PARAM_KEY_MAX_AGE] = $b7b9cdc0bbde27df$var$DEFAULT_PARAM_VALUE_MAX_AGE;
    // ensure no cropping/fitting/scaling of the image until we release the cropper
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$b7b9cdc0bbde27df$var$PARAM_KEY_HEIGHT] = $b7b9cdc0bbde27df$var$HEIGHT_MAX_PARAM_VALUE;
    const parsedUrl = `${url}?${$6dipk.stringify(query)}`;
    return {
        url: parsedUrl,
        token: mediaApiJwt
    };
};
const $b7b9cdc0bbde27df$export$d2adf65b87e47523 = ()=>{
    Object.keys($b7b9cdc0bbde27df$var$BLOB_CACHE).forEach((cachedItem)=>{
        delete $b7b9cdc0bbde27df$var$BLOB_CACHE[cachedItem];
    });
};
const $b7b9cdc0bbde27df$var$wait = (msBetweenTries)=>new Promise((r)=>setTimeout(r, msBetweenTries));

});
parcelRegister("hBskT", function(module, exports) {
$parcel$export(module.exports, "createObjectURLFromResponse", () => $1ce91cc84612b68f$export$c1dfa855638dae6c);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1ce91cc84612b68f$export$c1dfa855638dae6c = (response, contentType)=>{
    const arrayBuffer = [
        response
    ];
    const blob = new Blob(arrayBuffer, {
        type: contentType
    });
    return URL.createObjectURL(blob);
};

});



parcelRegister("1D1ic", function(module, exports) {
$parcel$export(module.exports, "BannerWithGridLayoutDumb", () => (parcelRequire("47PFR")).default);

var $47PFR = parcelRequire("47PFR");

});
parcelRegister("47PFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $67fde0c667c94b72$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");
parcelRequire("hzZg3");
var $6znAn = parcelRequire("6znAn");
parcelRequire("8GFfy");
var $1Zb3e = parcelRequire("1Zb3e");
parcelRequire("kOWPe");
var $1fQE4 = parcelRequire("1fQE4");

var $babis = parcelRequire("babis");

var $6BtWW = parcelRequire("6BtWW");

var $6920b = parcelRequire("6920b");

var $e5EYe = parcelRequire("e5EYe");
parcelRequire("3zOhM");
var $fUMxw = parcelRequire("fUMxw");
parcelRequire("bQkW5");
var $m7L3g = parcelRequire("m7L3g");
const $67fde0c667c94b72$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6920b.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6BtWW.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $67fde0c667c94b72$var$BannerWithGridLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, searchShown: searchShown, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent })=>{
    const showCompressedBanner = ![
        'none',
        'note'
    ].includes(paperAppearance || 'normal');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($67fde0c667c94b72$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($67fde0c667c94b72$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($67fde0c667c94b72$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($67fde0c667c94b72$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6znAn.default), {
        className: "px-paper-layout"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e5EYe.BannerWithLayoutHeaderMemoizedHOC), {
        isAnonymous: isAnonymous,
        removeHeader: removeHeader,
        headerless: headerless,
        hideSearchButton: hideSearchButton,
        helpCenterBanner: helpCenterBanner,
        hideBanner: hideBanner,
        prefetchBrandingModel: prefetchBrandingModel,
        renderForPaperLayout: !showCompressedBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fUMxw.default), {
        appearance: paperAppearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $m7L3g.default), {
        appearance: paperAppearance,
        isCSM: isCSM,
        hideSkipToMainContent: hideSkipToMainContent
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $babis.AutoHeightBody), null)))));
};
var $67fde0c667c94b72$export$2e2bcd8739ae039 = $67fde0c667c94b72$var$BannerWithGridLayoutDumb;
const $67fde0c667c94b72$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $67fde0c667c94b72$var$SidebarPusherRoot = /*#__PURE__*/ (0, $luz1X.default)((0, $1fQE4.default)).withConfig({
    componentId: "sc-kh8qt6-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $67fde0c667c94b72$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-kh8qt6-1"
})`display:flex;flex-direction:column;min-height:${$67fde0c667c94b72$var$CONTAINER_MIN_HEIGHT};`;
const $67fde0c667c94b72$export$36525627ce333d44 = /*#__PURE__*/ (0, $luz1X.default)((0, $1Zb3e.Flipper)).withConfig({
    componentId: "sc-kh8qt6-2"
})`display:flex;flex-direction:column;`;

});
parcelRegister("8GFfy", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("1Zb3e")).Flipper);

var $1Zb3e = parcelRequire("1Zb3e");

});
parcelRegister("1Zb3e", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => $a6f66706142b8c43$export$3e759dc50fe56038);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("8ybvi");
var $gPNbi = parcelRequire("gPNbi");
var $cnF16 = parcelRequire("cnF16");
const $a6f66706142b8c43$export$3e759dc50fe56038 = (props)=>/*#__PURE__*/ $fc4bM.createElement((0, $cnF16.default), {
        ...props,
        spring: {
            stiffness: 600,
            damping: 40
        }
    }, props.children);
const $a6f66706142b8c43$export$c3816ea9cb166de0 = (props)=>/*#__PURE__*/ $fc4bM.createElement((0, $gPNbi.default), props, props.children);

});
parcelRegister("8ybvi", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("cnF16")).default);
$parcel$export(module.exports, "Flipped", () => (parcelRequire("gPNbi")).default);

var $cnF16 = parcelRequire("cnF16");

var $gPNbi = parcelRequire("gPNbi");

var $c34Mp = parcelRequire("c34Mp");
var // for umd build
$639a6c23176cddbe$export$2e2bcd8739ae039 = {
    Flipper: (0, $cnF16.default),
    Flipped: (0, $gPNbi.default),
    ExitContainer: (0, $c34Mp.default)
};

});
parcelRegister("cnF16", function(module, exports) {
$parcel$export(module.exports, "FlipContext", () => $90377317b9c572aa$export$aa77f7b4e64b9ea9);
$parcel$export(module.exports, "PortalContext", () => $90377317b9c572aa$export$60d741e20e0aa309);
$parcel$export(module.exports, "default", () => $90377317b9c572aa$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");


var $kZRPn = parcelRequire("kZRPn");

var $f3bCI = parcelRequire("f3bCI");
function $90377317b9c572aa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $90377317b9c572aa$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $90377317b9c572aa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $90377317b9c572aa$export$aa77f7b4e64b9ea9 = (0, $fc4bM.createContext)("flip");
var $90377317b9c572aa$export$60d741e20e0aa309 = (0, $fc4bM.createContext)("portal");
var $90377317b9c572aa$var$Flipper = function(_Component) {
    $90377317b9c572aa$var$_inherits(Flipper, _Component);
    function Flipper(props) {
        $90377317b9c572aa$var$_classCallCheck(this, Flipper);
        var _this = $90377317b9c572aa$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.inProgressAnimations = {};
        _this.flipCallbacks = {};
        return _this;
    }
    Flipper.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.flipKey !== this.props.flipKey) return (0, $f3bCI.getFlippedElementPositionsBeforeUpdate)({
            element: this.el,
            // if onExit callbacks exist here, we'll cache the DOM node
            flipCallbacks: this.flipCallbacks,
            inProgressAnimations: this.inProgressAnimations,
            portalKey: this.props.portalKey
        });
        return null;
    };
    Flipper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, cachedData) {
        if (this.props.flipKey !== prevProps.flipKey) (0, $kZRPn.default)({
            cachedFlipChildrenPositions: cachedData.flippedElementPositions,
            cachedOrderedFlipIds: cachedData.cachedOrderedFlipIds,
            containerEl: this.el,
            inProgressAnimations: this.inProgressAnimations,
            flipCallbacks: this.flipCallbacks,
            applyTransformOrigin: this.props.applyTransformOrigin,
            spring: this.props.spring,
            debug: this.props.debug,
            portalKey: this.props.portalKey,
            staggerConfig: this.props.staggerConfig,
            handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
            decisionData: {
                prev: prevProps.decisionData,
                current: this.props.decisionData
            }
        });
    };
    Flipper.prototype.render = function render() {
        var _this2 = this;
        var _props = this.props, element = _props.element, className = _props.className, portalKey = _props.portalKey;
        var Element = element;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($90377317b9c572aa$export$60d741e20e0aa309.Provider, {
            value: portalKey
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($90377317b9c572aa$export$aa77f7b4e64b9ea9.Provider, {
            value: this.flipCallbacks
        }, (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Element, {
            className: className,
            ref: function ref(el) {
                return _this2.el = el;
            }
        }, this.props.children)));
    };
    return Flipper;
}((0, $fc4bM.Component));
$90377317b9c572aa$var$Flipper.propTypes = {};
$90377317b9c572aa$var$Flipper.defaultProps = {
    applyTransformOrigin: true,
    element: "div"
};
var $90377317b9c572aa$export$2e2bcd8739ae039 = $90377317b9c572aa$var$Flipper;

});
parcelRegister("kZRPn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f49342353d91ce6a$export$2e2bcd8739ae039);

var $iHBPW = parcelRequire("iHBPW");

var $8zoJq = parcelRequire("8zoJq");

var $f3bCI = parcelRequire("f3bCI");

var $1LjeJ = parcelRequire("1LjeJ");

var $1vVXb = parcelRequire("1vVXb");
var $f49342353d91ce6a$var$createScopedSelector = function createScopedSelector(element, portalKey) {
    if (portalKey) return function(selector) {
        return document.querySelectorAll("[" + $1LjeJ.DATA_PORTAL_KEY + "=" + portalKey + "]" + selector);
    };
    else return function(selector) {
        return element.querySelectorAll(selector);
    };
};
var $f49342353d91ce6a$var$createGetElementFunc = function createGetElementFunc(element, portalKey) {
    // this should only ever return 1 element
    return function(id) {
        return $f49342353d91ce6a$var$createScopedSelector(element, portalKey)("[" + $1LjeJ.DATA_FLIP_ID + "=\"" + id + "\"]")[0];
    };
};
var $f49342353d91ce6a$var$onFlipKeyUpdate = function onFlipKeyUpdate(_ref) {
    var _ref$cachedOrderedFli = _ref.cachedOrderedFlipIds, cachedOrderedFlipIds = _ref$cachedOrderedFli === undefined ? [] : _ref$cachedOrderedFli, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, _ref$cachedFlipChildr = _ref.cachedFlipChildrenPositions, cachedFlipChildrenPositions = _ref$cachedFlipChildr === undefined ? {} : _ref$cachedFlipChildr, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, containerEl = _ref.containerEl, applyTransformOrigin = _ref.applyTransformOrigin, spring = _ref.spring, debug = _ref.debug, portalKey = _ref.portalKey, _ref$staggerConfig = _ref.staggerConfig, staggerConfig = _ref$staggerConfig === undefined ? {} : _ref$staggerConfig, _ref$decisionData = _ref.decisionData, decisionData = _ref$decisionData === undefined ? {} : _ref$decisionData, handleEnterUpdateDelete = _ref.handleEnterUpdateDelete;
    var newFlipChildrenPositions = (0, $f3bCI.getFlippedElementPositionsAfterUpdate)({
        element: containerEl,
        portalKey: portalKey
    });
    var scopedSelector = $f49342353d91ce6a$var$createScopedSelector(containerEl, portalKey);
    var getElement = $f49342353d91ce6a$var$createGetElementFunc(containerEl, portalKey);
    var isFlipped = function isFlipped(id) {
        return cachedFlipChildrenPositions[id] && newFlipChildrenPositions[id];
    };
    var unflippedIds = Object.keys(cachedFlipChildrenPositions).concat(Object.keys(newFlipChildrenPositions)).filter(function(id) {
        return !isFlipped(id);
    });
    var baseArgs = {
        flipCallbacks: flipCallbacks,
        getElement: getElement,
        cachedFlipChildrenPositions: cachedFlipChildrenPositions,
        newFlipChildrenPositions: newFlipChildrenPositions,
        inProgressAnimations: inProgressAnimations
    };
    var _animateUnflippedElem = (0, $iHBPW.default)((0, $1vVXb.assign)({}, baseArgs, {
        unflippedIds: unflippedIds
    })), hideEnteringElements = _animateUnflippedElem.hideEnteringElements, animateEnteringElements = _animateUnflippedElem.animateEnteringElements, animateExitingElements = _animateUnflippedElem.animateExitingElements;
    var flippedIds = cachedOrderedFlipIds.filter(isFlipped);
    var animateFlippedElementsArgs = (0, $1vVXb.assign)({}, baseArgs, {
        flippedIds: flippedIds,
        applyTransformOrigin: applyTransformOrigin,
        spring: spring,
        debug: debug,
        staggerConfig: staggerConfig,
        decisionData: decisionData,
        scopedSelector: scopedSelector
    });
    // the function handles putting flipped elements back in their original positions
    // and returns another function to actually call flip
    var flip = (0, $8zoJq.default)(animateFlippedElementsArgs);
    if (handleEnterUpdateDelete) handleEnterUpdateDelete({
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements,
        animateFlippedElements: flip
    });
    else {
        hideEnteringElements();
        animateExitingElements().then(animateEnteringElements);
        flip();
    }
};
var $f49342353d91ce6a$export$2e2bcd8739ae039 = $f49342353d91ce6a$var$onFlipKeyUpdate;

});
parcelRegister("iHBPW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9d997c09af30893$export$2e2bcd8739ae039);
var $d9d997c09af30893$var$animateUnflippedElements = function animateUnflippedElements(_ref) {
    var unflippedIds = _ref.unflippedIds, flipCallbacks = _ref.flipCallbacks, getElement = _ref.getElement, newFlipChildrenPositions = _ref.newFlipChildrenPositions, cachedFlipChildrenPositions = _ref.cachedFlipChildrenPositions, inProgressAnimations = _ref.inProgressAnimations;
    var enteringElements = unflippedIds.filter(function(id) {
        return newFlipChildrenPositions[id] && flipCallbacks[id];
    });
    var exitingElementIds = unflippedIds.filter(function(id) {
        return cachedFlipChildrenPositions[id] && flipCallbacks[id] && flipCallbacks[id].onExit;
    });
    var hideEnteringElements = function hideEnteringElements() {
        enteringElements.forEach(function(id) {
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) {
                var element = getElement(id);
                element.style.opacity = "0";
            }
        });
    };
    var animateEnteringElements = function animateEnteringElements() {
        enteringElements.forEach(function(id, i) {
            var element = getElement(id);
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) flipCallbacks[id].onAppear(element, i);
        });
    };
    var closureResolve = void 0;
    var promiseToReturn = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var fragmentTuples = [];
    var exitingElementCount = 0;
    var onExitCallbacks = exitingElementIds.map(function(id, i) {
        var _cachedFlipChildrenPo = cachedFlipChildrenPositions[id].domData, element = _cachedFlipChildrenPo.element, parent = _cachedFlipChildrenPo.parent, _cachedFlipChildrenPo2 = _cachedFlipChildrenPo.childPosition, top = _cachedFlipChildrenPo2.top, left = _cachedFlipChildrenPo2.left, width = _cachedFlipChildrenPo2.width, height = _cachedFlipChildrenPo2.height;
        // insert back into dom
        if (getComputedStyle(parent).position === "static") parent.style.position = "relative";
        element.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
        element.style.position = "absolute";
        element.style.top = top + "px";
        element.style.left = left + "px";
        // taken out of the dom flow, the element might have lost these dimensions
        element.style.height = height + "px";
        element.style.width = width + "px";
        var fragmentTuple = fragmentTuples.filter(function(t) {
            return t[0] === parent;
        })[0];
        if (!fragmentTuple) {
            fragmentTuple = [
                parent,
                document.createDocumentFragment()
            ];
            fragmentTuples.push(fragmentTuple);
        }
        fragmentTuple[1].appendChild(element);
        exitingElementCount += 1;
        var stop = function stop() {
            try {
                parent.removeChild(element);
                exitingElementCount -= 1;
                if (exitingElementCount === 0) closureResolve();
            } catch (DOMException) {
            // the element is already gone
            }
        };
        inProgressAnimations[id] = {
            stop: stop
        };
        return function() {
            return flipCallbacks[id].onExit(element, i, stop);
        };
    });
    // now append all the fragments from the onExit callbacks
    // (we use fragments for performance)
    fragmentTuples.forEach(function(t) {
        var parent = t[0];
        var fragment = t[1];
        parent.appendChild(fragment);
    });
    if (!onExitCallbacks.length) closureResolve();
    var animateExitingElements = function animateExitingElements() {
        onExitCallbacks.forEach(function(c) {
            return c();
        });
        return promiseToReturn;
    };
    return {
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements
    };
};
var $d9d997c09af30893$export$2e2bcd8739ae039 = $d9d997c09af30893$var$animateUnflippedElements;

});

parcelRegister("8zoJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $63d4c6d3a3926ac5$export$2e2bcd8739ae039);

var $apSCE = parcelRequire("apSCE");

var $bBRqR = parcelRequire("bBRqR");

var $1vVXb = parcelRequire("1vVXb");

var $1LjeJ = parcelRequire("1LjeJ");

var $9min7 = parcelRequire("9min7");

var $5F8ZU = parcelRequire("5F8ZU");
var $63d4c6d3a3926ac5$export$3bb3cb1a74f66649 = function convertMatrix3dArrayTo2dArray(matrix) {
    return [
        0,
        1,
        4,
        5,
        12,
        13
    ].map(function(index) {
        return matrix[index];
    });
};
var $63d4c6d3a3926ac5$export$ae3bd8c5261b681e = function convertMatrix2dArrayToString(matrix) {
    return "matrix(" + matrix.join(", ") + ")";
};
var $63d4c6d3a3926ac5$export$7fd64b870f6a7bb9 = function invertTransformsForChildren(_ref) {
    var invertedChildren = _ref.invertedChildren, matrix = _ref.matrix, body = _ref.body;
    invertedChildren.forEach(function(_ref2) {
        var child = _ref2[0], childFlipConfig = _ref2[1];
        if (!body.contains(child)) return;
        var scaleX = matrix[0];
        var scaleY = matrix[3];
        var translateX = matrix[4];
        var translateY = matrix[5];
        var inverseVals = {
            translateX: 0,
            translateY: 0,
            scaleX: 1,
            scaleY: 1
        };
        var transformString = "";
        if (childFlipConfig.translate) {
            inverseVals.translateX = -translateX / scaleX;
            inverseVals.translateY = -translateY / scaleY;
            transformString += "translate(" + inverseVals.translateX + "px, " + inverseVals.translateY + "px)";
        }
        if (childFlipConfig.scale) {
            inverseVals.scaleX = 1 / scaleX;
            inverseVals.scaleY = 1 / scaleY;
            transformString += " scale(" + inverseVals.scaleX + ", " + inverseVals.scaleY + ")";
        }
        child.style.transform = transformString;
    });
};
var $63d4c6d3a3926ac5$export$ca4fe190a8429f9e = function createApplyStylesFunc(_ref3) {
    var element = _ref3.element, invertedChildren = _ref3.invertedChildren, body = _ref3.body;
    return function(_ref4) {
        var matrix = _ref4.matrix, opacity = _ref4.opacity, forceMinVals = _ref4.forceMinVals;
        if ((0, $1vVXb.isNumber)(opacity)) element.style.opacity = opacity;
        if (forceMinVals) {
            element.style.minHeight = "1px";
            element.style.minWidth = "1px";
        }
        if (!matrix) return;
        var stringTransform = $63d4c6d3a3926ac5$export$ae3bd8c5261b681e(matrix);
        // keep a tiny, (hopefully) invisible rotateZ transform on the element to try to
        // prevent Chrome from pixel-snapping when scale transforms
        // are removed
        stringTransform = stringTransform === "matrix(1, 0, 0, 1, 0, 0)" ? "matrix(1, 0.00001, -0.00001, 1, 0, 0)" : stringTransform;
        element.style.transform = stringTransform;
        if (invertedChildren) $63d4c6d3a3926ac5$export$7fd64b870f6a7bb9({
            invertedChildren: invertedChildren,
            matrix: matrix,
            body: body
        });
    };
};
var $63d4c6d3a3926ac5$export$90503d75ca6e7d46 = function rectInViewport(_ref5) {
    var top = _ref5.top, bottom = _ref5.bottom, left = _ref5.left, right = _ref5.right;
    return top < window.innerHeight && bottom > 0 && left < window.innerWidth && right > 0;
};
var $63d4c6d3a3926ac5$var$getInvertedChildren = function getInvertedChildren(element, id) {
    return (0, $1vVXb.toArray)(element.querySelectorAll("[" + $1LjeJ.DATA_INVERSE_FLIP_ID + "=\"" + id + "\"]"));
};
var $63d4c6d3a3926ac5$export$3ec95ebfc77511bd = function tweenProp(start, end, position) {
    return start + (end - start) * position;
};
var $63d4c6d3a3926ac5$var$animateFlippedElements = function animateFlippedElements(_ref6) {
    var flippedIds = _ref6.flippedIds, flipCallbacks = _ref6.flipCallbacks, inProgressAnimations = _ref6.inProgressAnimations, cachedFlipChildrenPositions = _ref6.cachedFlipChildrenPositions, newFlipChildrenPositions = _ref6.newFlipChildrenPositions, applyTransformOrigin = _ref6.applyTransformOrigin, spring = _ref6.spring, getElement = _ref6.getElement, debug = _ref6.debug, staggerConfig = _ref6.staggerConfig, decisionData = _ref6.decisionData, scopedSelector = _ref6.scopedSelector;
    var body = document.querySelector("body");
    // the stuff below is used so we can return a promise that resolves when all FLIP animations have
    // completed
    var closureResolve = void 0;
    var flipCompletedPromise = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var withInitFuncs = void 0;
    var completedAnimationIds = [];
    if (debug) // eslint-disable-next-line no-console
    console.error('[react-flip-toolkit]\nThe "debug" prop is set to true. All FLIP animations will return at the beginning of the transition.');
    var duplicateFlipIds = (0, $1vVXb.getDuplicateValsAsStrings)(flippedIds);
    if (duplicateFlipIds.length) // eslint-disable-next-line no-console
    console.error("[react-flip-toolkit]\nThere are currently multiple elements with the same flipId on the page.\nThe animation will only work if each Flipped component has a unique flipId.\nDuplicate flipId" + (duplicateFlipIds.length > 1 ? "s" : "") + ": " + duplicateFlipIds.join("\n"));
    var flipDataArray = flippedIds// take all the measurements we need
    // and return an object with animation functions + necessary data
    .map(function(id) {
        var prevRect = cachedFlipChildrenPositions[id].rect;
        var currentRect = newFlipChildrenPositions[id].rect;
        var prevOpacity = cachedFlipChildrenPositions[id].opacity;
        var currentOpacity = newFlipChildrenPositions[id].opacity;
        var needsForcedMinVals = currentRect.width < 1 || currentRect.height < 1;
        // don't animate elements outside of the user's viewport
        if (!$63d4c6d3a3926ac5$export$90503d75ca6e7d46(prevRect) && !$63d4c6d3a3926ac5$export$90503d75ca6e7d46(currentRect)) return false;
        // it's never going to be visible, so dont animate it
        if (prevRect.width === 0 && currentRect.width === 0 || prevRect.height === 0 && currentRect.height === 0) return false;
        var element = getElement(id);
        // this might happen if we are rapidly adding & removing elements(?)
        if (!element) return false;
        var flipConfig = JSON.parse(element.dataset.flipConfig);
        var springConfig = (0, $bBRqR.getSpringConfig)({
            flipperSpring: spring,
            flippedSpring: flipConfig.spring
        });
        var stagger = flipConfig.stagger === true ? "default" : flipConfig.stagger;
        var toReturn = {
            element: element,
            id: id,
            stagger: stagger,
            springConfig: springConfig,
            noOp: true
        };
        if (flipCallbacks[id] && flipCallbacks[id].shouldFlip) {
            var elementShouldFlip = flipCallbacks[id].shouldFlip(decisionData.prev, decisionData.current);
            // this element wont be animated, but its children might be
            if (!elementShouldFlip) return toReturn;
        }
        // don't animate elements that didn't change
        // but we might want to animate children
        if (prevRect.left === currentRect.left && prevRect.top === currentRect.top && prevRect.width === currentRect.width && prevRect.height === currentRect.height && prevOpacity === currentOpacity) // this element wont be animated, but its children might be
        return toReturn;
        toReturn.noOp = false;
        var currentTransform = $apSCE.parse(newFlipChildrenPositions[id].transform);
        var toVals = {
            matrix: currentTransform
        };
        var fromVals = {};
        var transformsArray = [
            currentTransform
        ];
        // we're only going to animate the values that the child wants animated
        if (flipConfig.translate) {
            transformsArray.push($apSCE.translateX(prevRect.left - currentRect.left));
            transformsArray.push($apSCE.translateY(prevRect.top - currentRect.top));
        }
        // going any smaller than 1px breaks transitions in Chrome
        if (flipConfig.scale) {
            transformsArray.push($apSCE.scaleX(Math.max(prevRect.width, 1) / Math.max(currentRect.width, 1)));
            transformsArray.push($apSCE.scaleY(Math.max(prevRect.height, 1) / Math.max(currentRect.height, 1)));
        }
        if (flipConfig.opacity) {
            fromVals.opacity = prevOpacity;
            toVals.opacity = currentOpacity;
        }
        var invertedChildren = [];
        if (!flipCallbacks[id] || !flipCallbacks[id].shouldInvert || flipCallbacks[id].shouldInvert(decisionData.prev, decisionData.current)) invertedChildren = $63d4c6d3a3926ac5$var$getInvertedChildren(element, id).map(function(c) {
            return [
                c,
                JSON.parse(c.dataset.flipConfig)
            ];
        });
        fromVals.matrix = $63d4c6d3a3926ac5$export$3bb3cb1a74f66649(transformsArray.reduce($apSCE.multiply));
        toVals.matrix = $63d4c6d3a3926ac5$export$3bb3cb1a74f66649(toVals.matrix);
        var applyStyles = $63d4c6d3a3926ac5$export$ca4fe190a8429f9e({
            element: element,
            invertedChildren: invertedChildren,
            body: body
        });
        var onComplete = void 0;
        if (flipCallbacks[id] && flipCallbacks[id].onComplete) {
            // must cache or else this could cause an error
            var cachedOnComplete = flipCallbacks[id].onComplete;
            onComplete = function onComplete() {
                return cachedOnComplete(element, decisionData.prev, decisionData.current);
            };
        }
        // this should be called when animation ends naturally
        // but also when it is interrupted
        // when it is called, the animation has already been cancelled
        var onAnimationEnd = function onAnimationEnd() {
            delete inProgressAnimations[id];
            (0, $1vVXb.isFunction)(onComplete) && onComplete();
            if (needsForcedMinVals && element) {
                element.style.minHeight = "";
                element.style.minWidth = "";
            }
            completedAnimationIds.push(id);
            if (completedAnimationIds.length >= withInitFuncs.length) // we can theoretically call multiple times since a promise only resolves 1x
            // but that shouldnt happen
            closureResolve();
        };
        var animateOpacity = (0, $1vVXb.isNumber)(fromVals.opacity) && fromVals.opacity !== toVals.opacity;
        var onStartCalled = false;
        var getOnUpdateFunc = function getOnUpdateFunc(stop) {
            inProgressAnimations[id] = {
                stop: stop,
                onComplete: onComplete
            };
            return function(spring) {
                //trigger the user provided onStart function
                if (!onStartCalled) {
                    onStartCalled = true;
                    if (flipCallbacks[id] && flipCallbacks[id].onStart) flipCallbacks[id].onStart(element, decisionData.prev, decisionData.current);
                }
                var currentValue = spring.getCurrentValue();
                if (!body.contains(element)) {
                    stop();
                    return;
                }
                var vals = {};
                vals.matrix = fromVals.matrix.map(function(fromVal, index) {
                    return $63d4c6d3a3926ac5$export$3ec95ebfc77511bd(fromVal, toVals.matrix[index], currentValue);
                });
                if (animateOpacity) vals.opacity = $63d4c6d3a3926ac5$export$3ec95ebfc77511bd(fromVals.opacity, toVals.opacity, currentValue);
                applyStyles(vals);
            };
        };
        var initializeFlip = function initializeFlip() {
            // before animating, immediately apply FLIP styles to prevent flicker
            applyStyles({
                matrix: fromVals.matrix,
                opacity: animateOpacity && fromVals.opacity,
                forceMinVals: needsForcedMinVals
            });
            // and batch any other style updates if necessary
            if (flipConfig.transformOrigin) element.style.transformOrigin = flipConfig.transformOrigin;
            else if (applyTransformOrigin) element.style.transformOrigin = "0 0";
            invertedChildren.forEach(function(_ref7) {
                var child = _ref7[0], childFlipConfig = _ref7[1];
                if (childFlipConfig.transformOrigin) child.style.transformOrigin = childFlipConfig.transformOrigin;
                else if (applyTransformOrigin) child.style.transformOrigin = "0 0";
            });
        };
        return (0, $1vVXb.assign)({}, toReturn, {
            stagger: stagger,
            springConfig: springConfig,
            getOnUpdateFunc: getOnUpdateFunc,
            initializeFlip: initializeFlip,
            onAnimationEnd: onAnimationEnd
        });
    }).filter(function(x) {
        return x;
    });
    // we use this array to compare with completed animations
    // to decide when all animations are completed
    withInitFuncs = flipDataArray.filter(function(_ref8) {
        var initializeFlip = _ref8.initializeFlip;
        return Boolean(initializeFlip);
    });
    //  put items back in place
    withInitFuncs.forEach(function(_ref9) {
        var initializeFlip = _ref9.initializeFlip;
        return initializeFlip();
    });
    if (debug) return;
    var flipDict = flipDataArray.reduce(function(acc, curr) {
        acc[curr.id] = curr;
        return acc;
    }, {});
    // this function modifies flipDataArray in-place
    // by removing references to non-direct children
    // to enable recursive stagger
    var _filterFlipDescendant = (0, $9min7.default)({
        flipDict: flipDict,
        flippedIds: flippedIds,
        scopedSelector: scopedSelector
    }), topLevelChildren = _filterFlipDescendant.topLevelChildren;
    return function() {
        // there are no active FLIP animations, so immediately resolve the
        // returned promise
        if (!withInitFuncs.length) closureResolve();
        (0, $5F8ZU.default)({
            topLevelChildren: topLevelChildren,
            flipDict: flipDict,
            staggerConfig: staggerConfig
        });
        return flipCompletedPromise;
    };
};
var $63d4c6d3a3926ac5$export$2e2bcd8739ae039 = $63d4c6d3a3926ac5$var$animateFlippedElements;

});
parcelRegister("apSCE", function(module, exports) {
$parcel$export(module.exports, "multiply", () => $79569c0e8ba770b0$export$2060d2db72cce88f);
$parcel$export(module.exports, "parse", () => $79569c0e8ba770b0$export$98e6a39c04603d36);
$parcel$export(module.exports, "scaleX", () => $79569c0e8ba770b0$export$55295ade51f88202);
$parcel$export(module.exports, "scaleY", () => $79569c0e8ba770b0$export$2092e2a44ac13bb2);
$parcel$export(module.exports, "translateX", () => $79569c0e8ba770b0$export$5667f2d3f182f284);
$parcel$export(module.exports, "translateY", () => $79569c0e8ba770b0$export$a1f0f3245f0cf0a4);
/*! @license Rematrix v0.2.3

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $79569c0e8ba770b0$export$d9468344d3651243(source) {
    if (source.constructor !== Array) throw new TypeError('Expected array.');
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError('Expected array with either 6 or 16 values.');
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function $79569c0e8ba770b0$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $79569c0e8ba770b0$export$70ae2c07e401031b(source) {
    var m = $79569c0e8ba770b0$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error('Inverse determinant attempted to divide by zero.');
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function $79569c0e8ba770b0$export$2060d2db72cce88f(m, x) {
    var fm = $79569c0e8ba770b0$export$d9468344d3651243(m);
    var fx = $79569c0e8ba770b0$export$d9468344d3651243(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * **Tip:** In virtually all cases, this method is used to convert
 * a CSS matrix (retrieved as a `string` from computed styles) to
 * its equivalent array format.
 *
 * @param  {string} source - String containing a valid CSS `matrix` or `matrix3d` property.
 * @return {array}
 */ function $79569c0e8ba770b0$export$98e6a39c04603d36(source) {
    if (typeof source === 'string') {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(', ').map(parseFloat);
            return $79569c0e8ba770b0$export$d9468344d3651243(raw);
        }
    }
    return $79569c0e8ba770b0$export$f0954fd7d5368655();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $79569c0e8ba770b0$export$bb628a54ab399bc9(angle) {
    return $79569c0e8ba770b0$export$ea6eae3365de5b9c(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $79569c0e8ba770b0$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $79569c0e8ba770b0$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $79569c0e8ba770b0$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function $79569c0e8ba770b0$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === 'number' ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $79569c0e8ba770b0$export$55295ade51f88202(scalar) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $79569c0e8ba770b0$export$2092e2a44ac13bb2(scalar) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $79569c0e8ba770b0$export$13034b1ece9569d5(scalar) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function $79569c0e8ba770b0$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $79569c0e8ba770b0$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function $79569c0e8ba770b0$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function $79569c0e8ba770b0$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $79569c0e8ba770b0$export$5667f2d3f182f284(distance) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $79569c0e8ba770b0$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $79569c0e8ba770b0$export$6e43fd17fc519956(distance) {
    var matrix = $79569c0e8ba770b0$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}

});

parcelRegister("bBRqR", function(module, exports) {
$parcel$export(module.exports, "getSpringConfig", () => $873c98f09408ac56$export$29bc3b1ca84e38c8);

var $1vVXb = parcelRequire("1vVXb");
var $873c98f09408ac56$export$31bbaa982ba04c49 = {
    noWobble: {
        stiffness: 200,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    veryGentle: {
        stiffness: 130,
        damping: 17
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 260,
        damping: 26
    }
};
var $873c98f09408ac56$export$29bc3b1ca84e38c8 = function getSpringConfig() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, flipperSpring = _ref.flipperSpring, flippedSpring = _ref.flippedSpring;
    var normalizeSpring = function normalizeSpring(spring) {
        if ((0, $1vVXb.isObject)(spring)) return spring;
        else if ($873c98f09408ac56$export$31bbaa982ba04c49[spring]) return $873c98f09408ac56$export$31bbaa982ba04c49[spring];
        else return {};
    };
    return (0, $1vVXb.assign)({}, $873c98f09408ac56$export$31bbaa982ba04c49.noWobble, normalizeSpring(flipperSpring), normalizeSpring(flippedSpring));
};

});
parcelRegister("1vVXb", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $11a5a40b5f39a924$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $11a5a40b5f39a924$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $11a5a40b5f39a924$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toArray", () => $11a5a40b5f39a924$export$45b10814cc054894);
$parcel$export(module.exports, "getDuplicateValsAsStrings", () => $11a5a40b5f39a924$export$b118174c74c51022);
$parcel$export(module.exports, "assign", () => $11a5a40b5f39a924$export$e6e34fd1f2686227);
var $11a5a40b5f39a924$export$7e4aa119212bc614 = function isNumber(x) {
    return typeof x === "number";
};
var $11a5a40b5f39a924$export$f6e2535fb5126e54 = function isFunction(x) {
    return typeof x === "function";
};
var $11a5a40b5f39a924$export$a6cdc56e425d0d0a = function isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
};
var $11a5a40b5f39a924$export$45b10814cc054894 = function toArray(arrayLike) {
    return Array.prototype.slice.apply(arrayLike);
};
var $11a5a40b5f39a924$export$b118174c74c51022 = function getDuplicateValsAsStrings(arr) {
    var obj = arr.reduce(function(acc, curr) {
        acc[curr] = acc[curr] ? acc[curr] + 1 : 1;
        return acc;
    }, {});
    return Object.keys(obj).filter(function(val) {
        return obj[val] > 1;
    });
};
var $11a5a40b5f39a924$export$e6e34fd1f2686227 = function assign(target) {
    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    args.forEach(function(arg) {
        if (!arg) return;
        // Skip over if undefined or null
        for(var nextKey in arg)// Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(arg, nextKey)) target[nextKey] = arg[nextKey];
    });
    return target;
};

});


parcelRegister("1LjeJ", function(module, exports) {
$parcel$export(module.exports, "DATA_FLIP_ID", () => $14891a369e8ad014$export$4e7d89757a685662);
$parcel$export(module.exports, "DATA_INVERSE_FLIP_ID", () => $14891a369e8ad014$export$6e4fe3c088b4bf3f);
$parcel$export(module.exports, "DATA_FLIP_CONFIG", () => $14891a369e8ad014$export$94198d9f80ac9749);
$parcel$export(module.exports, "DATA_PORTAL_KEY", () => $14891a369e8ad014$export$a5965b078f441f7e);
$parcel$export(module.exports, "DATA_EXIT_CONTAINER", () => $14891a369e8ad014$export$ee2a39d85d3284e4);
var $14891a369e8ad014$export$4e7d89757a685662 = "data-flip-id";
var $14891a369e8ad014$export$6e4fe3c088b4bf3f = "data-inverse-flip-id";
var $14891a369e8ad014$export$49e62738b103b74e = "data-flip-component-id";
var $14891a369e8ad014$export$94198d9f80ac9749 = "data-flip-config";
var $14891a369e8ad014$export$a5965b078f441f7e = "data-portal-key";
var $14891a369e8ad014$export$ee2a39d85d3284e4 = "data-exit-container";

});

parcelRegister("9min7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d046b64431ea2db$export$2e2bcd8739ae039);

var $1vVXb = parcelRequire("1vVXb");

var $1LjeJ = parcelRequire("1LjeJ");
// scoped selector makes sure we're querying inside the right Flipper
// container, either internally or with the right portal key
var $6d046b64431ea2db$var$selectFlipChildIds = function selectFlipChildIds(scopedSelector, selector, flippedIds) {
    var childIds = (0, $1vVXb.toArray)(scopedSelector(selector)).map(function(el) {
        return el.dataset.flipId;
    });
    // now return an array ordered by the original order in the DOM
    return flippedIds.filter(function(id) {
        return childIds.indexOf(id) > -1;
    });
};
var $6d046b64431ea2db$var$baseSelector = "[" + $1LjeJ.DATA_FLIP_ID + "]";
var $6d046b64431ea2db$export$2e2bcd8739ae039 = function(_ref) {
    var flipDict = _ref.flipDict, flippedIds = _ref.flippedIds, scopedSelector = _ref.scopedSelector;
    var levelToChildren = {};
    var buildHierarchy = function buildHierarchy(selector, level, oldResult) {
        var newSelector = selector + " " + $6d046b64431ea2db$var$baseSelector;
        // make sure this is scoped to the Flipper element in case there are
        // mulitiple Flipper elements on the page
        var newResult = $6d046b64431ea2db$var$selectFlipChildIds(scopedSelector, newSelector, flippedIds);
        var oldLevelChildren = oldResult.filter(function(id) {
            return newResult.indexOf(id) === -1;
        });
        levelToChildren[level] = oldLevelChildren;
        oldLevelChildren.forEach(function(childId) {
            if (flipDict[childId]) flipDict[childId].level = level;
        });
        if (newResult.length !== 0) buildHierarchy(newSelector, level + 1, newResult);
    };
    // the top level selectChildFlipIds should use the scopedSelector,
    buildHierarchy($6d046b64431ea2db$var$baseSelector, 0, $6d046b64431ea2db$var$selectFlipChildIds(scopedSelector, $6d046b64431ea2db$var$baseSelector, flippedIds));
    // now make sure childIds in each flippedData contains only direct children
    // since to enable nested stagger  we want each parent to be able to kick off
    // the animations only for its direct children
    Object.keys(flipDict).forEach(function(flipId) {
        var data = flipDict[flipId];
        // scop by parent element
        data.childIds = $6d046b64431ea2db$var$selectFlipChildIds(function(selector) {
            return data.element.querySelectorAll(selector);
        }, $6d046b64431ea2db$var$baseSelector, flippedIds);
        data.childIds = data.childIds.filter(function(id) {
            return levelToChildren[data.level + 1] && levelToChildren[data.level + 1].indexOf(id) > -1;
        });
    });
    return {
        topLevelChildren: levelToChildren["0"]
    };
};

});

parcelRegister("5F8ZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $41f7c2d4d959665c$export$2e2bcd8739ae039);

var $2Kt9Z = parcelRequire("2Kt9Z");
var $41f7c2d4d959665c$var$initiateImmediateAnimations = function initiateImmediateAnimations(immediate) {
    if (!immediate) return;
    immediate.forEach(function(flipped) {
        (0, $2Kt9Z.createSpring)(flipped);
        initiateImmediateAnimations(flipped.immediate);
    });
};
var $41f7c2d4d959665c$export$5e8092f8b030bcec = function createCallTree(_ref) {
    var flipDict = _ref.flipDict, topLevelChildren = _ref.topLevelChildren, initiateStaggeredAnimations = _ref.initiateStaggeredAnimations;
    //build a data struct to run the springs
    var tree = {
        root: {
            staggeredChildren: {},
            immediateChildren: []
        }
    };
    var appendChild = function appendChild(parent, childId) {
        var flipData = flipDict[childId];
        // might have been filtered (e.g. because it was off screen)
        if (!flipData) return;
        if (flipData.stagger) parent.staggeredChildren[flipData.stagger] ? parent.staggeredChildren[flipData.stagger].push(flipData) : parent.staggeredChildren[flipData.stagger] = [
            flipData
        ];
        else parent.immediateChildren.push(flipData);
        // only when the spring is first activated, activate the child animations as well
        // this enables nested stagger
        flipData.onSpringActivate = function() {
            $41f7c2d4d959665c$var$initiateImmediateAnimations(flipData.immediateChildren);
            initiateStaggeredAnimations(flipData.staggeredChildren);
        };
        flipData.staggeredChildren = {};
        flipData.immediateChildren = [];
        flipData.childIds.forEach(function(childId) {
            return appendChild(flipData, childId);
        });
    };
    // create the nested structure
    topLevelChildren.forEach(function(c) {
        appendChild(tree.root, c);
    });
    return tree;
};
var $41f7c2d4d959665c$export$2e2bcd8739ae039 = function(_ref2) {
    var staggerConfig = _ref2.staggerConfig, flipDict = _ref2.flipDict, topLevelChildren = _ref2.topLevelChildren;
    var initiateStaggeredAnimations = function initiateStaggeredAnimations(staggered) {
        if (!staggered || !Object.keys(staggered).length) return;
        Object.keys(staggered).forEach(function(staggerKey) {
            return (0, $2Kt9Z.staggeredSprings)(staggered[staggerKey], staggerConfig[staggerKey]);
        });
    };
    var tree = $41f7c2d4d959665c$export$5e8092f8b030bcec({
        flipDict: flipDict,
        topLevelChildren: topLevelChildren,
        initiateStaggeredAnimations: initiateStaggeredAnimations
    });
    $41f7c2d4d959665c$var$initiateImmediateAnimations(tree.root.immediateChildren);
    initiateStaggeredAnimations(tree.root.staggeredChildren);
};

});
parcelRegister("2Kt9Z", function(module, exports) {
$parcel$export(module.exports, "createSpring", () => $20067f3d7d91f648$export$d1f8fcb84651afa9);
$parcel$export(module.exports, "staggeredSprings", () => $20067f3d7d91f648$export$ac7d870a005a890f);
parcelRequire("fvLAU");
var $j1kqe = parcelRequire("j1kqe");
// this should get created only 1x
var $20067f3d7d91f648$var$springSystem = new (0, $j1kqe.default)();
var $20067f3d7d91f648$export$1c192fd9ecdd1c80 = function createSuspendedSpring(_ref) {
    var _ref$springConfig = _ref.springConfig, stiffness = _ref$springConfig.stiffness, damping = _ref$springConfig.damping, overshootClamping = _ref$springConfig.overshootClamping, noOp = _ref.noOp, onSpringActivate = _ref.onSpringActivate, getOnUpdateFunc = _ref.getOnUpdateFunc, onAnimationEnd = _ref.onAnimationEnd;
    if (noOp) return;
    var spring = $20067f3d7d91f648$var$springSystem.createSpring(stiffness, damping);
    spring.setOvershootClampingEnabled(!!overshootClamping);
    spring.addListener({
        onSpringActivate: onSpringActivate,
        onSpringUpdate: getOnUpdateFunc(spring.destroy.bind(spring)),
        onSpringAtRest: function onSpringAtRest() {
            // prevent SpringSystem from caching unused springs
            spring.destroy();
            onAnimationEnd();
        }
    });
    return spring;
};
var $20067f3d7d91f648$export$d1f8fcb84651afa9 = function createSpring(flipped) {
    var spring = $20067f3d7d91f648$export$1c192fd9ecdd1c80(flipped);
    if (spring) spring.setEndValue(1);
    else // even if it was a noop,
    // we still need to call onSpringActivate in case it calls
    // cascading flip initiation functions
    flipped.onSpringActivate();
};
var $20067f3d7d91f648$export$ac7d870a005a890f = function staggeredSprings(flippedArray) {
    var staggerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!flippedArray || !flippedArray.length) return;
    if (staggerConfig.reverse) flippedArray.reverse();
    var normalizedSpeed = staggerConfig.speed ? 1 + Math.max(Math.min(staggerConfig.speed, 0), 1) : 1.1;
    var nextThreshold = 1 / Math.max(Math.min(flippedArray.length, 100), 10);
    var springFuncs = flippedArray.filter(function(flipped) {
        return !flipped.noOp;
    }).map(function(flipped, i) {
        var cachedGetOnUpdate = flipped.getOnUpdateFunc;
        // modify the update function to adjust
        // the end value of the trailing Flipped component
        flipped.getOnUpdateFunc = function(stop) {
            var onUpdate = cachedGetOnUpdate(stop);
            return function(spring) {
                var currentValue = spring.getCurrentValue();
                if (currentValue > nextThreshold) springFuncs[i + 1] && springFuncs[i + 1].setEndValue(Math.min(currentValue * normalizedSpeed, 1));
                // now call the actual update function
                onUpdate(spring);
            };
        };
        return flipped;
    }).map(function(flipped) {
        return $20067f3d7d91f648$export$1c192fd9ecdd1c80(flipped);
    });
    springFuncs[0] && springFuncs[0].setEndValue(1);
};

});
parcelRegister("fvLAU", function(module, exports) {
$parcel$export(module.exports, "SpringSystem", () => (parcelRequire("j1kqe")).default);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *      
 */ 
var $j1kqe = parcelRequire("j1kqe");

var $75zh2 = parcelRequire("75zh2");

});
parcelRegister("j1kqe", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd8df3b514a330e3$export$2e2bcd8739ae039);

var $hUCzj = parcelRequire("hUCzj");

var $eao6R = parcelRequire("eao6R");

var $75zh2 = parcelRequire("75zh2");
function $dd8df3b514a330e3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * A set of Springs that all run on the same physics
 * timing loop. To get started with a Rebound animation, first
 * create a new SpringSystem and then add springs to it.
 * @public
 */ var $dd8df3b514a330e3$var$SpringSystem = function() {
    function SpringSystem(looper) {
        $dd8df3b514a330e3$var$_classCallCheck(this, SpringSystem);
        this.looper = looper || new (0, $hUCzj.AnimationLooper)();
        this.looper.springSystem = this;
        this.listeners = [];
        this._activeSprings = [];
        this._idleSpringIndices = [];
        this._isIdle = true;
        this._lastTimeMillis = -1;
        this._springRegistry = {};
    }
    /**
   * Add a new spring to this SpringSystem. This Spring will now be solved for
   * during the physics iteration loop. By default the spring will use the
   * default Origami spring config with 40 tension and 7 friction, but you can
   * also provide your own values here.
   * @public
   */ SpringSystem.prototype.createSpring = function createSpring(tension, friction) {
        return this.createSpringWithConfig({
            tension: tension,
            friction: friction
        });
    };
    /**
   * Add a spring with the provided SpringConfig.
   * @public
   */ SpringSystem.prototype.createSpringWithConfig = function createSpringWithConfig(springConfig) {
        var spring = new (0, $eao6R.default)(this);
        this.registerSpring(spring);
        spring.setSpringConfig(springConfig);
        return spring;
    };
    /**
   * Check if a SpringSystem is idle or active. If all of the Springs in the
   * SpringSystem are at rest, i.e. the physics forces have reached equilibrium,
   * then this method will return true.
   * @public
   */ SpringSystem.prototype.getIsIdle = function getIsIdle() {
        return this._isIdle;
    };
    /**
   * Manually add a spring to this system. This is called automatically
   * if a Spring is created with SpringSystem#createSpring.
   *
   * This method sets the spring up in the registry so that it can be solved
   * in the solver loop.
   * @public
   */ SpringSystem.prototype.registerSpring = function registerSpring(spring) {
        this._springRegistry[spring.getId()] = spring;
    };
    /**
   * Deregister a spring with this SpringSystem. The SpringSystem will
   * no longer consider this Spring during its integration loop once
   * this is called. This is normally done automatically for you when
   * you call Spring#destroy.
   * @public
   */ SpringSystem.prototype.deregisterSpring = function deregisterSpring(spring) {
        (0, $75zh2.removeFirst)(this._activeSprings, spring);
        delete this._springRegistry[spring.getId()];
    };
    SpringSystem.prototype.advance = function advance(time, deltaTime) {
        while(this._idleSpringIndices.length > 0)this._idleSpringIndices.pop();
        for(var i = 0, len = this._activeSprings.length; i < len; i++){
            var spring = this._activeSprings[i];
            // note from alex: had to add this otherwise deleting springs caused errors
            if (!spring) return;
            if (spring.systemShouldAdvance()) spring.advance(time / 1000.0, deltaTime / 1000.0);
            else this._idleSpringIndices.push(this._activeSprings.indexOf(spring));
        }
        while(this._idleSpringIndices.length > 0){
            var idx = this._idleSpringIndices.pop();
            idx >= 0 && this._activeSprings.splice(idx, 1);
        }
    };
    /**
   * This is the main solver loop called to move the simulation
   * forward through time. Before each pass in the solver loop
   * onBeforeIntegrate is called on an any listeners that have
   * registered themeselves with the SpringSystem. This gives you
   * an opportunity to apply any constraints or adjustments to
   * the springs that should be enforced before each iteration
   * loop. Next the advance method is called to move each Spring in
   * the systemShouldAdvance forward to the current time. After the
   * integration step runs in advance, onAfterIntegrate is called
   * on any listeners that have registered themselves with the
   * SpringSystem. This gives you an opportunity to run any post
   * integration constraints or adjustments on the Springs in the
   * SpringSystem.
   * @public
   */ SpringSystem.prototype.loop = function loop(currentTimeMillis) {
        var listener = void 0;
        if (this._lastTimeMillis === -1) this._lastTimeMillis = currentTimeMillis - 1;
        var ellapsedMillis = currentTimeMillis - this._lastTimeMillis;
        this._lastTimeMillis = currentTimeMillis;
        var i = 0;
        var len = this.listeners.length;
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onBeforeIntegrate && listener.onBeforeIntegrate(this);
        }
        this.advance(currentTimeMillis, ellapsedMillis);
        if (this._activeSprings.length === 0) {
            this._isIdle = true;
            this._lastTimeMillis = -1;
        }
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onAfterIntegrate && listener.onAfterIntegrate(this);
        }
        if (!this._isIdle) this.looper.run();
    };
    /**
   * Used to notify the SpringSystem that a Spring has become displaced.
   * The system responds by starting its solver loop up if it is currently idle.
   */ SpringSystem.prototype.activateSpring = function activateSpring(springId) {
        var spring = this._springRegistry[springId];
        if (this._activeSprings.indexOf(spring) === -1) this._activeSprings.push(spring);
        if (this.getIsIdle()) {
            this._isIdle = false;
            this.looper.run();
        }
    };
    return SpringSystem;
}();
var $dd8df3b514a330e3$export$2e2bcd8739ae039 = $dd8df3b514a330e3$var$SpringSystem;

});
parcelRegister("hUCzj", function(module, exports) {
$parcel$export(module.exports, "AnimationLooper", () => $d0a59590afc8fd28$export$253af54c72735e05);

var $75zh2 = parcelRequire("75zh2");
function $d0a59590afc8fd28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $d0a59590afc8fd28$export$253af54c72735e05 = function() {
    function AnimationLooper() {
        $d0a59590afc8fd28$var$_classCallCheck(this, AnimationLooper);
    }
    AnimationLooper.prototype.run = function run() {
        var _this = this;
        (0, $75zh2.onFrame)(function() {
            _this.springSystem.loop((0, $75zh2.performanceNow)());
        });
    };
    return AnimationLooper;
}();

});
parcelRegister("75zh2", function(module, exports) {
$parcel$export(module.exports, "onFrame", () => $52945ca8a9931220$export$1241ca3c22b48b34);
$parcel$export(module.exports, "performanceNow", () => $52945ca8a9931220$export$fb4230f160368c88);
$parcel$export(module.exports, "removeFirst", () => $52945ca8a9931220$export$2529f734547e2830);

var $5xEkd = parcelRequire("5xEkd");
var $52945ca8a9931220$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $52945ca8a9931220$export$1241ca3c22b48b34(func) {
    return (0, $5xEkd.default)(func);
}
var $52945ca8a9931220$var$start = Date.now();
var $52945ca8a9931220$export$fb4230f160368c88 = (typeof performance === "undefined" ? "undefined" : $52945ca8a9931220$var$_typeof(performance)) === "object" && typeof performance.now === "function" ? function() {
    return performance.now();
} : function() {
    return Date.now() - $52945ca8a9931220$var$start;
};
function $52945ca8a9931220$export$2529f734547e2830(array, item) {
    var idx = array.indexOf(item);
    idx !== -1 && array.splice(idx, 1);
}

});
parcelRegister("5xEkd", function(module, exports) {
$parcel$export(module.exports, "default", () => $408f5082ad4ffd23$export$2e2bcd8739ae039);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *
 */ var $408f5082ad4ffd23$var$_onFrame = void 0;
if (typeof window !== "undefined") $408f5082ad4ffd23$var$_onFrame = window.requestAnimationFrame;
$408f5082ad4ffd23$var$_onFrame = $408f5082ad4ffd23$var$_onFrame || function(callback) {
    window.setTimeout(callback, 1000 / 60);
};
var $408f5082ad4ffd23$export$2e2bcd8739ae039 = $408f5082ad4ffd23$var$_onFrame;

});



parcelRegister("eao6R", function(module, exports) {
$parcel$export(module.exports, "default", () => $a504b385aeac27c7$export$2e2bcd8739ae039);

var $75zh2 = parcelRequire("75zh2");
function $a504b385aeac27c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $a504b385aeac27c7$var$PhysicsState = function PhysicsState() {
    $a504b385aeac27c7$var$_classCallCheck(this, PhysicsState);
    this.position = 0;
    this.velocity = 0;
};
/**
 * Provides a model of a classical spring acting to
 * resolve a body to equilibrium. Springs have configurable
 * tension which is a force multipler on the displacement of the
 * spring from its rest point or `endValue` as defined by [Hooke's
 * law](http://en.wikipedia.org/wiki/Hooke's_law). Springs also have
 * configurable friction, which ensures that they do not oscillate
 * infinitely. When a Spring is displaced by updating it's resting
 * or `currentValue`, the SpringSystems that contain that Spring
 * will automatically start looping to solve for equilibrium. As each
 * timestep passes, `SpringListener` objects attached to the Spring
 * will be notified of the updates providing a way to drive an
 * animation off of the spring's resolution curve.
 * @public
 */ var $a504b385aeac27c7$var$Spring = function() {
    function Spring(springSystem) {
        $a504b385aeac27c7$var$_classCallCheck(this, Spring);
        this._id = "s" + Spring._ID++;
        this._springSystem = springSystem;
        this.listeners = [];
        this._startValue = 0;
        this._currentState = new $a504b385aeac27c7$var$PhysicsState();
        this._displacementFromRestThreshold = 0.001;
        this._endValue = 0;
        this._overshootClampingEnabled = false;
        this._previousState = new $a504b385aeac27c7$var$PhysicsState();
        this._restSpeedThreshold = 0.001;
        this._tempState = new $a504b385aeac27c7$var$PhysicsState();
        this._timeAccumulator = 0;
        this._wasAtRest = true;
    }
    Spring.prototype.getId = function getId() {
        return this._id;
    };
    /**
   * Remove a Spring from simulation and clear its listeners.
   * @public
   */ Spring.prototype.destroy = function destroy() {
        this.listeners = [];
        this._springSystem.deregisterSpring(this);
    };
    /**
   * Set the configuration values for this Spring. A SpringConfig
   * contains the tension and friction values used to solve for the
   * equilibrium of the Spring in the physics loop.
   * @public
   */ Spring.prototype.setSpringConfig = function setSpringConfig(springConfig) {
        this._springConfig = springConfig;
        return this;
    };
    /**
   * Retrieve the current value of the Spring.
   * @public
   */ Spring.prototype.getCurrentValue = function getCurrentValue() {
        return this._currentState.position;
    };
    /**
   * Get the absolute distance of the Spring from a given state value
   */ Spring.prototype.getDisplacementDistanceForState = function getDisplacementDistanceForState(state) {
        return Math.abs(this._endValue - state.position);
    };
    /**
   * Set the endValue or resting position of the spring. If this
   * value is different than the current value, the SpringSystem will
   * be notified and will begin running its solver loop to resolve
   * the Spring to equilibrium. Any listeners that are registered
   * for onSpringEndStateChange will also be notified of this update
   * immediately.
   * @public
   */ Spring.prototype.setEndValue = function setEndValue(endValue) {
        if (this._endValue === endValue && this.isAtRest()) return this;
        this._startValue = this.getCurrentValue();
        this._endValue = endValue;
        this._springSystem.activateSpring(this.getId());
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            var onChange = listener.onSpringEndStateChange;
            onChange && onChange(this);
        }
        return this;
    };
    /**
   * Set the current velocity of the Spring, in pixels per second. As
   * previously mentioned, this can be useful when you are performing
   * a direct manipulation gesture. When a UI element is released you
   * may call setVelocity on its animation Spring so that the Spring
   * continues with the same velocity as the gesture ended with. The
   * friction, tension, and displacement of the Spring will then
   * govern its motion to return to rest on a natural feeling curve.
   * @public
   */ Spring.prototype.setVelocity = function setVelocity(velocity) {
        if (velocity === this._currentState.velocity) return this;
        this._currentState.velocity = velocity;
        this._springSystem.activateSpring(this.getId());
        return this;
    };
    /**
   * Enable overshoot clamping. This means that the Spring will stop
   * immediately when it reaches its resting position regardless of
   * any existing momentum it may have. This can be useful for certain
   * types of animations that should not oscillate such as a scale
   * down to 0 or alpha fade.
   * @public
   */ Spring.prototype.setOvershootClampingEnabled = function setOvershootClampingEnabled(enabled) {
        this._overshootClampingEnabled = enabled;
        return this;
    };
    /**
   * Check if the Spring has gone past its end point by comparing
   * the direction it was moving in when it started to the current
   * position and end value.
   * @public
   */ Spring.prototype.isOvershooting = function isOvershooting() {
        var start = this._startValue;
        var end = this._endValue;
        return this._springConfig.tension > 0 && (start < end && this.getCurrentValue() > end || start > end && this.getCurrentValue() < end);
    };
    /**
   * The main solver method for the Spring. It takes
   * the current time and delta since the last time step and performs
   * an RK4 integration to get the new position and velocity state
   * for the Spring based on the tension, friction, velocity, and
   * displacement of the Spring.
   * @public
   */ Spring.prototype.advance = function advance(time, realDeltaTime) {
        var isAtRest = this.isAtRest();
        if (isAtRest && this._wasAtRest) return;
        var adjustedDeltaTime = realDeltaTime;
        if (realDeltaTime > Spring.MAX_DELTA_TIME_SEC) adjustedDeltaTime = Spring.MAX_DELTA_TIME_SEC;
        this._timeAccumulator += adjustedDeltaTime;
        var tension = this._springConfig.tension;
        var friction = this._springConfig.friction;
        var position = this._currentState.position;
        var velocity = this._currentState.velocity;
        var tempPosition = this._tempState.position;
        var tempVelocity = this._tempState.velocity;
        var aVelocity = void 0;
        var aAcceleration = void 0;
        var bVelocity = void 0;
        var bAcceleration = void 0;
        var cVelocity = void 0;
        var cAcceleration = void 0;
        var dVelocity = void 0;
        var dAcceleration = void 0;
        var dxdt = void 0;
        var dvdt = void 0;
        while(this._timeAccumulator >= Spring.SOLVER_TIMESTEP_SEC){
            this._timeAccumulator -= Spring.SOLVER_TIMESTEP_SEC;
            if (this._timeAccumulator < Spring.SOLVER_TIMESTEP_SEC) {
                this._previousState.position = position;
                this._previousState.velocity = velocity;
            }
            aVelocity = velocity;
            aAcceleration = tension * (this._endValue - tempPosition) - friction * velocity;
            tempPosition = position + aVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + aAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            bVelocity = tempVelocity;
            bAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + bVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + bAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            cVelocity = tempVelocity;
            cAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + cVelocity * Spring.SOLVER_TIMESTEP_SEC;
            tempVelocity = velocity + cAcceleration * Spring.SOLVER_TIMESTEP_SEC;
            dVelocity = tempVelocity;
            dAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            dxdt = 1.0 / 6.0 * (aVelocity + 2.0 * (bVelocity + cVelocity) + dVelocity);
            dvdt = 1.0 / 6.0 * (aAcceleration + 2.0 * (bAcceleration + cAcceleration) + dAcceleration);
            position += dxdt * Spring.SOLVER_TIMESTEP_SEC;
            velocity += dvdt * Spring.SOLVER_TIMESTEP_SEC;
        }
        this._tempState.position = tempPosition;
        this._tempState.velocity = tempVelocity;
        this._currentState.position = position;
        this._currentState.velocity = velocity;
        if (this._timeAccumulator > 0) this._interpolate(this._timeAccumulator / Spring.SOLVER_TIMESTEP_SEC);
        if (this.isAtRest() || this._overshootClampingEnabled && this.isOvershooting()) {
            if (this._springConfig.tension > 0) {
                this._startValue = this._endValue;
                this._currentState.position = this._endValue;
            } else {
                this._endValue = this._currentState.position;
                this._startValue = this._endValue;
            }
            this.setVelocity(0);
            isAtRest = true;
        }
        var notifyActivate = false;
        if (this._wasAtRest) {
            this._wasAtRest = false;
            notifyActivate = true;
        }
        var notifyAtRest = false;
        if (isAtRest) {
            this._wasAtRest = true;
            notifyAtRest = true;
        }
        this.notifyPositionUpdated(notifyActivate, notifyAtRest);
    };
    Spring.prototype.notifyPositionUpdated = function notifyPositionUpdated(notifyActivate, notifyAtRest) {
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            if (notifyActivate && listener.onSpringActivate) listener.onSpringActivate(this);
            if (listener.onSpringUpdate) listener.onSpringUpdate(this);
            if (notifyAtRest && listener.onSpringAtRest) listener.onSpringAtRest(this);
        }
    };
    /**
   * Check if the SpringSystem should advance. Springs are advanced
   * a final frame after they reach equilibrium to ensure that the
   * currentValue is exactly the requested endValue regardless of the
   * displacement threshold.
   * @public
   */ Spring.prototype.systemShouldAdvance = function systemShouldAdvance() {
        return !this.isAtRest() || !this.wasAtRest();
    };
    Spring.prototype.wasAtRest = function wasAtRest() {
        return this._wasAtRest;
    };
    /**
   * Check if the Spring is atRest meaning that it's currentValue and
   * endValue are the same and that it has no velocity. The previously
   * described thresholds for speed and displacement define the bounds
   * of this equivalence check. If the Spring has 0 tension, then it will
   * be considered at rest whenever its absolute velocity drops below the
   * restSpeedThreshold.
   * @public
   */ Spring.prototype.isAtRest = function isAtRest() {
        return Math.abs(this._currentState.velocity) < this._restSpeedThreshold && (this.getDisplacementDistanceForState(this._currentState) <= this._displacementFromRestThreshold || this._springConfig.tension === 0);
    };
    Spring.prototype._interpolate = function _interpolate(alpha) {
        this._currentState.position = this._currentState.position * alpha + this._previousState.position * (1 - alpha);
        this._currentState.velocity = this._currentState.velocity * alpha + this._previousState.velocity * (1 - alpha);
    };
    Spring.prototype.addListener = function addListener(newListener) {
        this.listeners.push(newListener);
        return this;
    };
    Spring.prototype.removeListener = function removeListener(listenerToRemove) {
        (0, $75zh2.removeFirst)(this.listeners, listenerToRemove);
        return this;
    };
    return Spring;
}();
$a504b385aeac27c7$var$Spring._ID = 0;
$a504b385aeac27c7$var$Spring.MAX_DELTA_TIME_SEC = 0.064;
$a504b385aeac27c7$var$Spring.SOLVER_TIMESTEP_SEC = 0.001;
var $a504b385aeac27c7$export$2e2bcd8739ae039 = $a504b385aeac27c7$var$Spring;

});






parcelRegister("f3bCI", function(module, exports) {
$parcel$export(module.exports, "getFlippedElementPositionsBeforeUpdate", () => $af5026fc83c419fb$export$45700a1d2c971fdb);
$parcel$export(module.exports, "getFlippedElementPositionsAfterUpdate", () => $af5026fc83c419fb$export$df23be7918af8adb);

var $1vVXb = parcelRequire("1vVXb");

var $1LjeJ = parcelRequire("1LjeJ");
var $af5026fc83c419fb$var$cancelInProgressAnimations = function cancelInProgressAnimations(inProgressAnimations) {
    Object.keys(inProgressAnimations).forEach(function(id) {
        if (inProgressAnimations[id].stop) inProgressAnimations[id].stop();
        delete inProgressAnimations[id];
    });
};
var $af5026fc83c419fb$var$addTupleToObject = function addTupleToObject(acc, curr) {
    var _assign;
    return (0, $1vVXb.assign)(acc, (_assign = {}, _assign[curr[0]] = curr[1], _assign));
};
var $af5026fc83c419fb$export$b087c5eb899bb598 = function getAllElements(element, portalKey) {
    if (portalKey) return (0, $1vVXb.toArray)(document.querySelectorAll("[" + $1LjeJ.DATA_PORTAL_KEY + "=\"" + portalKey + "\"]"));
    else return (0, $1vVXb.toArray)(element.querySelectorAll("[" + $1LjeJ.DATA_FLIP_ID + "]"));
};
var $af5026fc83c419fb$export$45700a1d2c971fdb = function getFlippedElementPositionsBeforeUpdate(_ref) {
    var element = _ref.element, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, portalKey = _ref.portalKey;
    var flippedElements = $af5026fc83c419fb$export$b087c5eb899bb598(element, portalKey);
    var inverseFlippedElements = (0, $1vVXb.toArray)(element.querySelectorAll("[" + $1LjeJ.DATA_INVERSE_FLIP_ID + "]"));
    var childIdsToParentBCRs = {};
    var parentBCRs = [];
    var childIdsToParents = {};
    // this is for exit animations so we can re-insert exiting elements in the
    // DOM later
    flippedElements.filter(function(el) {
        return flipCallbacks && flipCallbacks[el.dataset.flipId] && flipCallbacks[el.dataset.flipId].onExit;
    }).forEach(function(el) {
        var parent = el.parentNode;
        // this won't work for IE11
        if (el.closest) {
            var exitContainer = el.closest("[" + $1LjeJ.DATA_EXIT_CONTAINER + "]");
            if (exitContainer) parent = exitContainer;
        }
        var bcrIndex = parentBCRs.findIndex(function(n) {
            return n[0] === parent;
        });
        if (bcrIndex === -1) {
            parentBCRs.push([
                parent,
                parent.getBoundingClientRect()
            ]);
            bcrIndex = parentBCRs.length - 1;
        }
        childIdsToParentBCRs[el.dataset.flipId] = parentBCRs[bcrIndex][1];
        childIdsToParents[el.dataset.flipId] = parent;
    });
    var flippedElementPositions = flippedElements.map(function(child) {
        var domData = {};
        var childBCR = child.getBoundingClientRect();
        // only cache extra data for exit animations
        // if the element has an onExit listener
        if (flipCallbacks && flipCallbacks[child.dataset.flipId] && flipCallbacks[child.dataset.flipId].onExit) {
            var parentBCR = childIdsToParentBCRs[child.dataset.flipId];
            (0, $1vVXb.assign)(domData, {
                element: child,
                parent: childIdsToParents[child.dataset.flipId],
                childPosition: {
                    top: childBCR.top - parentBCR.top,
                    left: childBCR.left - parentBCR.left,
                    width: childBCR.width,
                    height: childBCR.height
                }
            });
        }
        return [
            child.dataset.flipId,
            {
                rect: childBCR,
                opacity: parseFloat(window.getComputedStyle(child).opacity),
                domData: domData
            }
        ];
    }).reduce($af5026fc83c419fb$var$addTupleToObject, {});
    // do this at the very end since we want to cache positions of elements
    // while they are mid-transition
    $af5026fc83c419fb$var$cancelInProgressAnimations(inProgressAnimations);
    flippedElements.concat(inverseFlippedElements).forEach(function(el) {
        el.style.transform = "";
        el.style.opacity = "";
    });
    return {
        flippedElementPositions: flippedElementPositions,
        cachedOrderedFlipIds: flippedElements.map(function(el) {
            return el.dataset.flipId;
        })
    };
};
var $af5026fc83c419fb$export$df23be7918af8adb = function getFlippedElementPositionsAfterUpdate(_ref2) {
    var element = _ref2.element, portalKey = _ref2.portalKey;
    return $af5026fc83c419fb$export$b087c5eb899bb598(element, portalKey).map(function(child) {
        var computedStyle = window.getComputedStyle(child);
        var rect = child.getBoundingClientRect();
        return [
            child.dataset.flipId,
            {
                rect: rect,
                opacity: parseFloat(computedStyle.opacity),
                domData: {},
                transform: computedStyle.transform
            }
        ];
    }).reduce($af5026fc83c419fb$var$addTupleToObject, {});
};

});



parcelRegister("gPNbi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4178f20ec7c8ca1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $cnF16 = parcelRequire("cnF16");

var $1LjeJ = parcelRequire("1LjeJ");

var $1vVXb = parcelRequire("1vVXb");
var $c4178f20ec7c8ca1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $c4178f20ec7c8ca1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4178f20ec7c8ca1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c4178f20ec7c8ca1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $c4178f20ec7c8ca1$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $c4178f20ec7c8ca1$var$customPropCheck = function customPropCheck(props, propName) {
    if (props.flipId && props.inverseFlipId) return new Error('Please only provide one of the two: "FlipId" or "inverseFlipID"');
    else if (props.flipId === undefined && props.inverseFlipId === undefined) return new Error("Must provide either a \"FlipId\" or an \"InverseFlipId\" prop");
    else if (props[propName] && typeof props[propName] !== "string") return new Error(propName + " must be a string");
};
var $c4178f20ec7c8ca1$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
    ]).isRequired,
    inverseFlipId: $c4178f20ec7c8ca1$var$customPropCheck,
    flipId: $c4178f20ec7c8ca1$var$customPropCheck,
    opacity: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).bool,
    translate: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).bool,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).bool,
    transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).string,
    spring: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).object
    ]),
    onStart: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    onAppear: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    shouldFlip: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    shouldInvert: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func,
    portalKey: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).string,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).bool
    ])
};
function $c4178f20ec7c8ca1$export$c3816ea9cb166de0(_ref) {
    var _dataAttributes;
    var children = _ref.children, flipId = _ref.flipId, inverseFlipId = _ref.inverseFlipId, portalKey = _ref.portalKey, rest = $c4178f20ec7c8ca1$var$_objectWithoutProperties(_ref, [
        "children",
        "flipId",
        "inverseFlipId",
        "portalKey"
    ]);
    var child = children;
    var isFunctionAsChildren = typeof child === 'function';
    if (!isFunctionAsChildren) try {
        child = (0, $fc4bM.Children).only(children);
    } catch (e) {
        throw new Error("Each Flipped component must wrap a single child");
    }
    // if nothing is being animated, assume everything is being animated
    if (!rest.scale && !rest.translate && !rest.opacity) (0, $1vVXb.assign)(rest, {
        translate: true,
        scale: true,
        opacity: true
    });
    var dataAttributes = (_dataAttributes = {}, _dataAttributes[$1LjeJ.DATA_FLIP_ID] = flipId, _dataAttributes[$1LjeJ.DATA_INVERSE_FLIP_ID] = inverseFlipId, _dataAttributes[$1LjeJ.DATA_FLIP_CONFIG] = JSON.stringify(rest), _dataAttributes);
    if (portalKey) dataAttributes[$1LjeJ.DATA_PORTAL_KEY] = portalKey;
    return isFunctionAsChildren ? child(dataAttributes) : (0, $fc4bM.cloneElement)(child, dataAttributes);
}
var $c4178f20ec7c8ca1$var$FlippedWithContext = function(_Component) {
    $c4178f20ec7c8ca1$var$_inherits(FlippedWithContext, _Component);
    function FlippedWithContext() {
        $c4178f20ec7c8ca1$var$_classCallCheck(this, FlippedWithContext);
        return $c4178f20ec7c8ca1$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    FlippedWithContext.prototype.render = function render() {
        var _props = this.props, children = _props.children, flipId = _props.flipId, shouldFlip = _props.shouldFlip, shouldInvert = _props.shouldInvert, onAppear = _props.onAppear, onStart = _props.onStart, onComplete = _props.onComplete, onExit = _props.onExit, rest = $c4178f20ec7c8ca1$var$_objectWithoutProperties(_props, [
            "children",
            "flipId",
            "shouldFlip",
            "shouldInvert",
            "onAppear",
            "onStart",
            "onComplete",
            "onExit"
        ]);
        if (rest.inverseFlipId) return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c4178f20ec7c8ca1$export$c3816ea9cb166de0, rest, children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cnF16.PortalContext).Consumer, null, function(portalKey) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cnF16.FlipContext).Consumer, null, function(data) {
                // if there is no surrounding Flipper component,
                // we don't want to throw an error, so check
                // that data exists and is not the default string
                if ((0, $1vVXb.isObject)(data)) data[flipId] = {
                    shouldFlip: shouldFlip,
                    shouldInvert: shouldInvert,
                    onAppear: onAppear,
                    onStart: onStart,
                    onComplete: onComplete,
                    onExit: onExit
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c4178f20ec7c8ca1$export$c3816ea9cb166de0, $c4178f20ec7c8ca1$var$_extends({
                    flipId: flipId
                }, rest, {
                    portalKey: portalKey
                }), children);
            });
        });
    };
    return FlippedWithContext;
}((0, $fc4bM.Component));
$c4178f20ec7c8ca1$var$FlippedWithContext.propTypes = {};
var $c4178f20ec7c8ca1$export$2e2bcd8739ae039 = $c4178f20ec7c8ca1$var$FlippedWithContext;

});

parcelRegister("c34Mp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c5979004d91fd1f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $1LjeJ = parcelRequire("1LjeJ");
var $8c5979004d91fd1f$var$ExitContainer = function ExitContainer(_ref) {
    var _cloneElement;
    var children = _ref.children;
    return (0, $fc4bM.cloneElement)(children, (_cloneElement = {}, _cloneElement[0, $1LjeJ.DATA_EXIT_CONTAINER] = true, _cloneElement));
};
var $8c5979004d91fd1f$export$2e2bcd8739ae039 = $8c5979004d91fd1f$var$ExitContainer;

});




parcelRegister("babis", function(module, exports) {
$parcel$export(module.exports, "AutoHeightBody", () => $99fada013f11f906$export$9a6247d807712c45);
$parcel$export(module.exports, "StyledFooter", () => $99fada013f11f906$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");
parcelRequire("hzZg3");
var $6znAn = parcelRequire("6znAn");

var $12QfD = parcelRequire("12QfD");
const $99fada013f11f906$export$9a6247d807712c45 = /*#__PURE__*/ (0, $luz1X.default)((0, $6znAn.default)).withConfig({
    componentId: "sc-vv1aut-0"
})`min-height:100%;height:auto !important;position:relative;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $99fada013f11f906$var$stickyBottom = /*#__PURE__*/ (0, $luz1X.css)`position:absolute;bottom:0;left:50%;transform:translateX(-50%);`;
const $99fada013f11f906$export$61905ae62c7860fb = /*#__PURE__*/ (0, $luz1X.default)((0, $12QfD.Footer)).withConfig({
    componentId: "sc-vv1aut-1"
})`${(props)=>props.sticky ? $99fada013f11f906$var$stickyBottom : ''};`;
const $99fada013f11f906$export$2598938b3673d496 = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-vv1aut-2"
})`text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}`;

});

parcelRegister("6BtWW", function(module, exports) {
$parcel$export(module.exports, "default", () => $68c0b612e7edca37$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");

var $ieqE6 = parcelRequire("ieqE6");
const $68c0b612e7edca37$var$contentStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ieqE6.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $68c0b612e7edca37$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": testId,
        css: $68c0b612e7edca37$var$contentStyles
    }, children);
};
var $68c0b612e7edca37$export$2e2bcd8739ae039 = $68c0b612e7edca37$var$Content;

});

parcelRegister("6920b", function(module, exports) {
$parcel$export(module.exports, "default", () => $31cc8fc3db0aca0b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");


var $gEQiC = parcelRequire("gEQiC");

var $ieqE6 = parcelRequire("ieqE6");

var $32VLy = parcelRequire("32VLy");
var $kFB21 = parcelRequire("kFB21");

var $a3lmQ = parcelRequire("a3lmQ");

var $3jCFs = parcelRequire("3jCFs");
const $31cc8fc3db0aca0b$var$pageLayoutSelector = {
    [(0, $ieqE6.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $31cc8fc3db0aca0b$var$gridTemplateAreasMobile = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $ieqE6.LEFT_PANEL)} ${(0, $ieqE6.BANNER)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $ieqE6.LEFT_PANEL)} ${(0, $ieqE6.TOP_NAVIGATION)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $ieqE6.LEFT_PANEL)} ${(0, $ieqE6.CONTENT)}"
 `;
const $31cc8fc3db0aca0b$var$gridTemplateAreas = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $ieqE6.LEFT_PANEL)} ${(0, $ieqE6.BANNER)} ${(0, $ieqE6.RIGHT_PANEL)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $ieqE6.LEFT_PANEL)} ${(0, $ieqE6.TOP_NAVIGATION)} ${(0, $ieqE6.RIGHT_PANEL)}"
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $ieqE6.LEFT_PANEL)} ${(0, $ieqE6.CONTENT)} ${(0, $ieqE6.RIGHT_PANEL)}"
 `;
const $31cc8fc3db0aca0b$var$gridStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $31cc8fc3db0aca0b$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $ieqE6.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $ieqE6.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $ieqE6.BANNER_HEIGHT)} ${(0, $ieqE6.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $31cc8fc3db0aca0b$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $gEQiC.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $31cc8fc3db0aca0b$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $ieqE6.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $31cc8fc3db0aca0b$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $ieqE6.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    typeof $3jCFs;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $kFB21.SkipLinksController), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $a3lmQ.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ...$31cc8fc3db0aca0b$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $31cc8fc3db0aca0b$var$gridStyles,
            $31cc8fc3db0aca0b$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $32VLy.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $31cc8fc3db0aca0b$export$2e2bcd8739ae039 = $31cc8fc3db0aca0b$var$PageLayout;

});
parcelRegister("gEQiC", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $54e8738c7a4002a4$export$c881183ca713c214);

var $1zYKE = parcelRequire("1zYKE");
const $54e8738c7a4002a4$export$c881183ca713c214 = (0, $1zYKE.media);

});
parcelRegister("1zYKE", function(module, exports) {
$parcel$export(module.exports, "media", () => $a83f7dc7bc961034$export$987d49ffe1b0900f);
const $a83f7dc7bc961034$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("32VLy", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeController", () => $31ced1292634872f$export$850bd1bba41f1448);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $9JZL9 = parcelRequire("9JZL9");

var $kUMs0 = parcelRequire("kUMs0");

var $dqrA3 = parcelRequire("dqrA3");

var $ieqE6 = parcelRequire("ieqE6");

var $6Ak93 = parcelRequire("6Ak93");

var $aj0hJ = parcelRequire("aj0hJ");
const $31ced1292634872f$var$handleDataAttributesAndCb = (callback = (0, $9JZL9.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $ieqE6.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $31ced1292634872f$var$leftSidebarSelector = (0, $6Ak93.getPageLayoutSlotCSSSelector)('left-sidebar');
const $31ced1292634872f$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $fc4bM.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $fc4bM.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $fc4bM.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $fc4bM.useRef)(null);
    const mobileMediaQuery = (0, $dqrA3.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $fc4bM.useCallback)(()=>{
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ieqE6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $31ced1292634872f$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $ieqE6.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $31ced1292634872f$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($31ced1292634872f$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $kUMs0.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $6Zi52.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $fc4bM.useCallback)((_event, collapseWithoutTransition)=>{
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ieqE6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $31ced1292634872f$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $ieqE6.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $ieqE6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $31ced1292634872f$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($31ced1292634872f$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $kUMs0.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $6Zi52.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ const toggleLeftSidebar = (0, $fc4bM.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $fc4bM.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    const context = (0, $fc4bM.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: // Technically this isn't quite true, but with mobile it's a bit safer if apps are using this to roll their own collapse/expand
            expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $aj0hJ.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});
parcelRegister("dqrA3", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $c5891ed3f7390b33$export$49e55ae2c03d6045);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $9kfe7 = parcelRequire("9kfe7");

var $gEQiC = parcelRequire("gEQiC");
var $c5891ed3f7390b33$var$_window, $c5891ed3f7390b33$var$_window$matchMedia, $c5891ed3f7390b33$var$_window2, $c5891ed3f7390b33$var$_window2$matchMedia, $c5891ed3f7390b33$var$_window3, $c5891ed3f7390b33$var$_window3$matchMedia, $c5891ed3f7390b33$var$_window4, $c5891ed3f7390b33$var$_window4$matchMedia, $c5891ed3f7390b33$var$_window5, $c5891ed3f7390b33$var$_window5$matchMedia, $c5891ed3f7390b33$var$_window6, $c5891ed3f7390b33$var$_window6$matchMedia, $c5891ed3f7390b33$var$_window7, $c5891ed3f7390b33$var$_window7$matchMedia, $c5891ed3f7390b33$var$_window8, $c5891ed3f7390b33$var$_window8$matchMedia, $c5891ed3f7390b33$var$_window9, $c5891ed3f7390b33$var$_window9$matchMedia, $c5891ed3f7390b33$var$_window0, $c5891ed3f7390b33$var$_window0$matchMedia, $c5891ed3f7390b33$var$_window1, $c5891ed3f7390b33$var$_window1$matchMedia;
const $c5891ed3f7390b33$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window = window) === null || $c5891ed3f7390b33$var$_window === void 0 || ($c5891ed3f7390b33$var$_window$matchMedia = $c5891ed3f7390b33$var$_window.matchMedia) === null || $c5891ed3f7390b33$var$_window$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window$matchMedia.call($c5891ed3f7390b33$var$_window, (0, $gEQiC.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window2 = window) === null || $c5891ed3f7390b33$var$_window2 === void 0 || ($c5891ed3f7390b33$var$_window2$matchMedia = $c5891ed3f7390b33$var$_window2.matchMedia) === null || $c5891ed3f7390b33$var$_window2$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window2$matchMedia.call($c5891ed3f7390b33$var$_window2, (0, $gEQiC.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window3 = window) === null || $c5891ed3f7390b33$var$_window3 === void 0 || ($c5891ed3f7390b33$var$_window3$matchMedia = $c5891ed3f7390b33$var$_window3.matchMedia) === null || $c5891ed3f7390b33$var$_window3$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window3$matchMedia.call($c5891ed3f7390b33$var$_window3, (0, $gEQiC.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window4 = window) === null || $c5891ed3f7390b33$var$_window4 === void 0 || ($c5891ed3f7390b33$var$_window4$matchMedia = $c5891ed3f7390b33$var$_window4.matchMedia) === null || $c5891ed3f7390b33$var$_window4$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window4$matchMedia.call($c5891ed3f7390b33$var$_window4, (0, $gEQiC.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window5 = window) === null || $c5891ed3f7390b33$var$_window5 === void 0 || ($c5891ed3f7390b33$var$_window5$matchMedia = $c5891ed3f7390b33$var$_window5.matchMedia) === null || $c5891ed3f7390b33$var$_window5$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window5$matchMedia.call($c5891ed3f7390b33$var$_window5, (0, $gEQiC.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window6 = window) === null || $c5891ed3f7390b33$var$_window6 === void 0 || ($c5891ed3f7390b33$var$_window6$matchMedia = $c5891ed3f7390b33$var$_window6.matchMedia) === null || $c5891ed3f7390b33$var$_window6$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window6$matchMedia.call($c5891ed3f7390b33$var$_window6, (0, $gEQiC.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window7 = window) === null || $c5891ed3f7390b33$var$_window7 === void 0 || ($c5891ed3f7390b33$var$_window7$matchMedia = $c5891ed3f7390b33$var$_window7.matchMedia) === null || $c5891ed3f7390b33$var$_window7$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window7$matchMedia.call($c5891ed3f7390b33$var$_window7, (0, $gEQiC.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window8 = window) === null || $c5891ed3f7390b33$var$_window8 === void 0 || ($c5891ed3f7390b33$var$_window8$matchMedia = $c5891ed3f7390b33$var$_window8.matchMedia) === null || $c5891ed3f7390b33$var$_window8$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window8$matchMedia.call($c5891ed3f7390b33$var$_window8, (0, $gEQiC.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window9 = window) === null || $c5891ed3f7390b33$var$_window9 === void 0 || ($c5891ed3f7390b33$var$_window9$matchMedia = $c5891ed3f7390b33$var$_window9.matchMedia) === null || $c5891ed3f7390b33$var$_window9$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window9$matchMedia.call($c5891ed3f7390b33$var$_window9, (0, $gEQiC.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window0 = window) === null || $c5891ed3f7390b33$var$_window0 === void 0 || ($c5891ed3f7390b33$var$_window0$matchMedia = $c5891ed3f7390b33$var$_window0.matchMedia) === null || $c5891ed3f7390b33$var$_window0$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window0$matchMedia.call($c5891ed3f7390b33$var$_window0, (0, $gEQiC.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($c5891ed3f7390b33$var$_window1 = window) === null || $c5891ed3f7390b33$var$_window1 === void 0 || ($c5891ed3f7390b33$var$_window1$matchMedia = $c5891ed3f7390b33$var$_window1.matchMedia) === null || $c5891ed3f7390b33$var$_window1$matchMedia === void 0 ? void 0 : $c5891ed3f7390b33$var$_window1$matchMedia.call($c5891ed3f7390b33$var$_window1, (0, $gEQiC.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $c5891ed3f7390b33$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $fc4bM.useRef)(listener);
    (0, $fc4bM.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $c5891ed3f7390b33$var$queries[queryString];
    (0, $9kfe7.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $6Zi52.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("6Ak93", function(module, exports) {
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $1922c135e0cac1b1$export$218ece2c32b7db0e);

var $ieqE6 = parcelRequire("ieqE6");
const $1922c135e0cac1b1$export$218ece2c32b7db0e = (slotName)=>`[${0, $ieqE6.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});


parcelRegister("kFB21", function(module, exports) {
$parcel$export(module.exports, "SkipLinksController", () => $1a0f5d96516ae50b$export$da7be99d6a868f3d);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $ieqE6 = parcelRequire("ieqE6");

var $2teat = parcelRequire("2teat");
const $1a0f5d96516ae50b$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $ieqE6.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $1a0f5d96516ae50b$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $fc4bM.useState)([]);
    const registerSkipLink = (0, $fc4bM.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($1a0f5d96516ae50b$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $fc4bM.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2teat.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("a3lmQ", function(module, exports) {
$parcel$export(module.exports, "SkipLinkWrapper", () => $10b5feb6c0a0afc7$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");

var $1Ry06 = parcelRequire("1Ry06");

var $b5xMz = parcelRequire("b5xMz");

var $ieqE6 = parcelRequire("ieqE6");

var $luuro = parcelRequire("luuro");

var $t6r8O = parcelRequire("t6r8O");
function $10b5feb6c0a0afc7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $10b5feb6c0a0afc7$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $jctmk.css)((0, $b5xMz.prefersReducedMotion)());
const $10b5feb6c0a0afc7$var$skipLinkStyles = /*#__PURE__*/ (0, $jctmk.css)({
    margin: "var(--ds-space-250, 20px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $1Ry06.easeOut)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $10b5feb6c0a0afc7$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $10b5feb6c0a0afc7$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $10b5feb6c0a0afc7$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $10b5feb6c0a0afc7$var$assignIndex(num + 1, arr);
};
const $10b5feb6c0a0afc7$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $luuro.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $10b5feb6c0a0afc7$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $ieqE6.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    const label = skipLinksLabel || (0, $ieqE6.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $10b5feb6c0a0afc7$var$skipLinkStyles,
            $10b5feb6c0a0afc7$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $jctmk.jsx)("p", {
        css: $10b5feb6c0a0afc7$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $jctmk.jsx)("ol", {
        css: $10b5feb6c0a0afc7$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $t6r8O.SkipLink), {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};

});
parcelRegister("t6r8O", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $a57736a7d8eff18c$export$ef95c37428582a65);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");

var $dM0Q8 = parcelRequire("dM0Q8");
function $a57736a7d8eff18c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a57736a7d8eff18c$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $a57736a7d8eff18c$var$handleBlur = (event)=>{
    const target = event.currentTarget;
    if (!(target instanceof Element)) return;
    target.removeAttribute('tabindex');
    target.removeEventListener('blur', $a57736a7d8eff18c$var$handleBlur);
};
const $a57736a7d8eff18c$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            targetRef.addEventListener('blur', $a57736a7d8eff18c$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $a57736a7d8eff18c$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("li", {
        css: $a57736a7d8eff18c$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $dM0Q8.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $a57736a7d8eff18c$var$focusTargetRef(href)
    }, children));
};

});



parcelRegister("e5EYe", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoizedHOC", () => $d2ddbece0a3d17e8$export$f0da0221ee5515ac);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $4Pjk5 = parcelRequire("4Pjk5");
const $d2ddbece0a3d17e8$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getThemeColor), (0, $ePyx3.getHelpCenterBrandingLoader), (0, $ePyx3.getHelpCenterTopBarSplitFlag), (themeColor, isBrandingLoaded, hasTopBarBeenSplit)=>({
        themeColor: themeColor,
        isBrandingLoaded: isBrandingLoaded,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
const $d2ddbece0a3d17e8$var$ConnectedBannerWithLayoutHeader = (0, $6umft.default)($d2ddbece0a3d17e8$var$selector)((0, $4Pjk5.BannerWithLayoutHeader));
var $d2ddbece0a3d17e8$export$2e2bcd8739ae039 = $d2ddbece0a3d17e8$var$ConnectedBannerWithLayoutHeader;
const $d2ddbece0a3d17e8$export$f0da0221ee5515ac = (0, $6umft.default)($d2ddbece0a3d17e8$var$selector)((0, $4Pjk5.BannerWithLayoutHeaderMemoized));

});
parcelRegister("4Pjk5", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeader", () => $b8e7c8279734734c$export$dc6fa5f6f452943b);
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoized", () => $b8e7c8279734734c$export$2e33b09d9c57faa1);
/* banner-with-layout-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $hN5YJ = parcelRequire("hN5YJ");

var $8PITw = parcelRequire("8PITw");

var $fOCtI = parcelRequire("fOCtI");

var $iG0dO = parcelRequire("iG0dO");
parcelRequire("7gJkl");
var $5ke1o = parcelRequire("5ke1o");
parcelRequire("jDBRI");
var $ju0hb = parcelRequire("ju0hb");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $d7r8x = parcelRequire("d7r8x");
const $b8e7c8279734734c$export$ed7cc0d417ee89e = $fOCtI.unitless * 23; // 184
const $b8e7c8279734734c$export$6ba969052247c298 = $fOCtI.unitless * 23 + (0, $iG0dO.HEADER_HEIGHT); // 240
const $b8e7c8279734734c$export$87562042682a224f = $fOCtI.unitless * 37; // 296
const $b8e7c8279734734c$export$f6510fb522c3cc26 = 300;
const $b8e7c8279734734c$export$5c538a381f9a90ef = $fOCtI.unitless * 22; // 176
const $b8e7c8279734734c$var$BANNER_WITH_REDUCED_HEIGHT = 152;
const $b8e7c8279734734c$export$60963c14ec4e3ee7 = 'layout-banner';
const $b8e7c8279734734c$export$dc6fa5f6f452943b = ({ themeColor: themeColor, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, isBrandingLoaded: isBrandingLoaded, hideBanner: hideBanner, prefetchBrandingModel: prefetchBrandingModel, hasTopBarBeenSplit: hasTopBarBeenSplit, renderForPaperLayout: renderForPaperLayout })=>{
    // Update CSS variable when helpCenterBanner changes
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty('--banner-bg-image', helpCenterBanner ? `url(${helpCenterBanner})` : 'none');
    }, [
        helpCenterBanner
    ]);
    let updatedBannerHeight = hasTopBarBeenSplit ? $b8e7c8279734734c$export$ed7cc0d417ee89e : $b8e7c8279734734c$var$BANNER_WITH_REDUCED_HEIGHT;
    if (renderForPaperLayout) updatedBannerHeight = hasTopBarBeenSplit ? $b8e7c8279734734c$export$f6510fb522c3cc26 : $b8e7c8279734734c$export$87562042682a224f + (0, $iG0dO.HEADER_HEIGHT); // in login page we render paper layout
    if ((0, $hN5YJ.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) updatedBannerHeight = $b8e7c8279734734c$var$BANNER_WITH_REDUCED_HEIGHT;
    const bannerCustomProp = {
        style: {
            height: `${updatedBannerHeight}px`,
            backgroundColor: themeColor,
            backgroundImage: 'var(--banner-bg-image)',
            borderRadius: hasTopBarBeenSplit ? "var(--ds-radius-large, 8px)" : 'initial'
        }
    };
    const showBannerWithLoader = ()=>{
        if (hideBanner) return null;
        if ((0, $hN5YJ.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $b8e7c8279734734c$var$bannerContainerStyleWithReducedHeight
        }, isBrandingLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            "data-testId": $b8e7c8279734734c$export$60963c14ec4e3ee7,
            xcss: $b8e7c8279734734c$var$bannerStyle,
            ...bannerCustomProp
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
        const bannerContainerCustomPropPaperLayout = {
            style: {
                height: `${updatedBannerHeight + (hasTopBarBeenSplit ? 16 : 0) * 2}px`,
                top: renderForPaperLayout && hasTopBarBeenSplit ? `${0, $iG0dO.HEADER_HEIGHT}px` : 'initial',
                bottom: renderForPaperLayout ? 'initial' : 0,
                paddingTop: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingBottom: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingLeft: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)",
                paddingRight: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)"
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8e7c8279734734c$var$BannerContainer, {
            ...bannerContainerCustomPropPaperLayout,
            "data-testid": 'BannerContainer'
        }, !isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })), isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8e7c8279734734c$var$BannerStyleWithImage, {
            "data-testid": $b8e7c8279734734c$export$60963c14ec4e3ee7,
            ...bannerCustomProp
        }));
    };
    let containerHeight = renderForPaperLayout ? (0, $iG0dO.HEADER_HEIGHT) : $b8e7c8279734734c$var$BANNER_WITH_REDUCED_HEIGHT;
    if ((0, $hN5YJ.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) containerHeight = (0, $iG0dO.HEADER_HEIGHT) + $b8e7c8279734734c$var$BANNER_WITH_REDUCED_HEIGHT + 32;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8e7c8279734734c$var$Container, {
        "data-testid": 'outer-BannerContainer',
        style: {
            height: removeHeader || headerless || hideBanner ? 'auto' : `${containerHeight}px`
        }
    }, showBannerWithLoader(), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ju0hb.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8e7c8279734734c$var$HeaderContainerStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5ke1o.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    })), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8e7c8279734734c$var$EmptyHeader, {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            height: `${(0, $iG0dO.HEADER_HEIGHT)}px`
        }
    }));
};
const $b8e7c8279734734c$export$2e33b09d9c57faa1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo($b8e7c8279734734c$export$dc6fa5f6f452943b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b8e7c8279734734c$var$Container = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8e7c8279734734c$var$BannerStyleWithImage = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1bsb1osq _4t3i1osq _1lrw1dfr _12vemgnk _ouxl1ssb _bfhk1pom _1itk8q6q",
            __cmplp.className
        ])
    });
});
const $b8e7c8279734734c$var$BannerContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_kqswstnw _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $b8e7c8279734734c$var$bannerContainerStyleWithReducedHeight = (0, $kig2V.xcss)({
    position: 'absolute',
    width: '100%',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.400',
    paddingRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    bottom: 'space.0',
    height: `${$b8e7c8279734734c$var$BANNER_WITH_REDUCED_HEIGHT + 32}px`
});
const $b8e7c8279734734c$var$bannerStyle = (0, $kig2V.xcss)({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: 'radius.large',
    backgroundColor: 'color.background.brand.bold'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b8e7c8279734734c$var$HeaderContainerStyle = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_kqswh2mm _1pbykuz3",
            __cmplp.className
        ])
    });
});
const $b8e7c8279734734c$var$EmptyHeader = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7gJkl", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("5ke1o")).default);

var $5ke1o = parcelRequire("5ke1o");

});
parcelRegister("5ke1o", function(module, exports) {
$parcel$export(module.exports, "default", () => $33ffd9403a88d405$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $fecgs = parcelRequire("fecgs");

var $8PITw = parcelRequire("8PITw");

var $eXcu8 = parcelRequire("eXcu8");

var $1eY13 = parcelRequire("1eY13");

var $haEws = parcelRequire("haEws");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("86gJQ");
var $aiLVt = parcelRequire("aiLVt");
parcelRequire("3b1ix");
var $eK6et = parcelRequire("eK6et");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("aGypY");
var $hzlql = parcelRequire("hzlql");

var $iG0dO = parcelRequire("iG0dO");

var $d7r8x = parcelRequire("d7r8x");

var $cf3fd = parcelRequire("cf3fd");

var $gioQl = parcelRequire("gioQl");
parcelRequire("1OWFf");
var $bttxB = parcelRequire("bttxB");
const $33ffd9403a88d405$var$getHeaderLoginUrl = (state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    return (0, $gioQl.getLoginUrl)({
        portalId: portalId,
        isAbsolute: true,
        redirectUrl: (0, $dFKzv.getPathname)(state)
    });
};
const $33ffd9403a88d405$var$userRequestsSelector = (state)=>{
    return (0, $hzlql.getUserRequestsCounts)(state);
};
const $33ffd9403a88d405$var$selector = (0, $2n2bS.createSelector)((0, $7RWiC.isLoggedIn), $33ffd9403a88d405$var$getHeaderLoginUrl, (0, $7RWiC.isUserLoaded), (0, $aiLVt.isCustomizing), $33ffd9403a88d405$var$userRequestsSelector, (0, $eK6et.getOrganisations), (0, $fYLlE.getIsAnonymousEnabled), (0, $ePyx3.getHelpCenterBrandingLoader), (0, $ePyx3.getHelpCenterTopBarColor), (0, $ePyx3.getHelpCenterTopBarSplitFlag), (0, $ePyx3.getLogoUrl), (0, $ePyx3.getSharedPortalName), (userLoggedIn, loginUrl, userLoaded, customizing, userRequest, organisations, anonymousEnabled, isBrandingLoaded, topBarColor, hasTopBarBeenSplit, logoUrl, name)=>({
        userLoggedIn: userLoggedIn,
        loginUrl: loginUrl,
        userRequest: userRequest,
        organisations: organisations,
        anonymousEnabled: anonymousEnabled,
        name: name,
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded,
        isCustomizing: customizing,
        headerBackgroundColor: hasTopBarBeenSplit ? topBarColor : undefined,
        logoUrl: logoUrl ?? undefined
    }));
class $33ffd9403a88d405$var$Header extends $fc4bM.Component {
    componentDidMount() {
        if (!this.props.isModelCallPrefetched) {
            if (!(0, $cf3fd.isHelpCentersManagement)()) this.props.fetchBranding();
            if (!this.props.isAnonymous) {
                this.props.fetchUser();
                this.props.fetchOrganisations();
                this.props.fetchUserRequestsCounts();
            }
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous && !this.props.isModelCallPrefetched) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)() && !(0, $cf3fd.isHelpCentersManagement)()) {
            if (this.props.isBrandingLoaded) return /*#__PURE__*/ $fc4bM.createElement((0, $bttxB.default), this.props);
            return /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
                name: "header-loader"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $8PITw.LoadingSkeleton), {
                "data-testid": "header-skeleton",
                height: (0, $iG0dO.HEADER_HEIGHT),
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        }
        return /*#__PURE__*/ $fc4bM.createElement((0, $bttxB.default), this.props);
    }
}
var $33ffd9403a88d405$export$2e2bcd8739ae039 = (0, $6umft.default)($33ffd9403a88d405$var$selector, {
    fetchBranding: (0, $eXcu8.fetchHelpCenterBrandingAction),
    fetchUser: (0, $fecgs.fetchUserModelAction),
    fetchOrganisations: (0, $1eY13.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $haEws.fetchUserRequestsCountsAction)
})($33ffd9403a88d405$var$Header);

});
parcelRegister("86gJQ", function(module, exports) {
$parcel$export(module.exports, "isAnyUploadInProgress", () => (parcelRequire("aiLVt")).isAnyUploadInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("aiLVt")).isCustomizing);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("aiLVt")).isSaveInProgress);
$parcel$export(module.exports, "isUploadInProgress", () => (parcelRequire("aiLVt")).isUploadInProgress);
parcelRequire("aiLVt");

});
parcelRegister("aiLVt", function(module, exports) {
$parcel$export(module.exports, "isCustomizing", () => $c2f13ed9fce4ace1$export$ce3eed7c98304744);
$parcel$export(module.exports, "isSaveInProgress", () => $c2f13ed9fce4ace1$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isUploadInProgress", () => $c2f13ed9fce4ace1$export$cf866b9449681342);
$parcel$export(module.exports, "isAnyUploadInProgress", () => $c2f13ed9fce4ace1$export$4dfd840e8ddac89d);
const $c2f13ed9fce4ace1$export$ce3eed7c98304744 = (state)=>state.ui.helpCenterPreview.isCustomizing;
const $c2f13ed9fce4ace1$export$2b75ac2de7a23db1 = (state)=>state.ui.helpCenterPreview.isSaveInProgress;
const $c2f13ed9fce4ace1$export$cf866b9449681342 = (state, fileCollection)=>!!state.ui.helpCenterPreview.uploadsInProgress[fileCollection];
const $c2f13ed9fce4ace1$export$4dfd840e8ddac89d = (state)=>{
    const { uploadsInProgress: uploadsInProgress } = state.ui.helpCenterPreview;
    return Object.keys(uploadsInProgress).find((uploadKey)=>uploadsInProgress[uploadKey]) !== undefined;
};

});


parcelRegister("3b1ix", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("eK6et")).getOrganisations);

var $eK6et = parcelRequire("eK6et");

});
parcelRegister("eK6et", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => $e9eb6936440a0370$export$17495f9c20464b8);
const $e9eb6936440a0370$export$17495f9c20464b8 = (state)=>state.persisted.organisations.organisations;

});


parcelRegister("aGypY", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => (parcelRequire("hzlql")).getUserRequestsCounts);

var $hzlql = parcelRequire("hzlql");

});
parcelRegister("hzlql", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $fd215e911d6afd75$export$be73da9c8fdefffb);
const $fd215e911d6afd75$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});


parcelRegister("1OWFf", function(module, exports) {
$parcel$export(module.exports, "DumbHeader", () => (parcelRequire("bttxB")).default);

var $bttxB = parcelRequire("bttxB");

});
parcelRegister("bttxB", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdccc4721e7b9654$export$2e2bcd8739ae039);
/** @jsxFrag React.Fragment */ 
var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");

var $MPQAF = parcelRequire("MPQAF");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");
parcelRequire("kYt5D");
var $5c45h = parcelRequire("5c45h");

var $iG0dO = parcelRequire("iG0dO");

var $3TJLC = parcelRequire("3TJLC");

var $k2M4v = parcelRequire("k2M4v");

var $lfFx3 = parcelRequire("lfFx3");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $d7r8x = parcelRequire("d7r8x");

var $3MmH8 = parcelRequire("3MmH8");
parcelRequire("iyjHn");
var $cScvY = parcelRequire("cScvY");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $gioQl = parcelRequire("gioQl");
parcelRequire("6AnW7");
var $6FAhw = parcelRequire("6FAhw");
parcelRequire("7fXGb");
var $dNLxc = parcelRequire("dNLxc");

var $gi59x = parcelRequire("gi59x");
const $cdccc4721e7b9654$var$Header = ({ isAnonymous: isAnonymous, isUserLoaded: isUserLoaded, userLoggedIn: userLoggedIn, loginUrl: loginUrl, logoTextColor: logoTextColor, hideSearchButton: hideSearchButton, anonymousEnabled: anonymousEnabled, showThemedBackground: showThemedBackground, disableAllHeaderLinks: disableAllHeaderLinks, headerBackgroundColor: headerBackgroundColor, logoUrl: logoUrl, name: name })=>{
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const showPortalLink = isCSM ? !!logoUrl : true;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const defaultLoginUrl = `/user/login?destination=${(0, $gioQl.getHelpCenterUrl)().replace(/\//g, '')}`;
    const authenticatedNavLinks = $fc4bM.useMemo(()=>/*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$NavItem, null, /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'customizeMenu'
        }, /*#__PURE__*/ $fc4bM.createElement((0, $dNLxc.default), {
            disableCustomiseMenu: disableAllHeaderLinks
        }))), isCSM && /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
            packageName: "viewLayoutHeaderDumb",
            id: "CsmRequestsHeaderLink"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
            xcss: $cdccc4721e7b9654$var$requestsLinkStyles
        }, /*#__PURE__*/ $fc4bM.createElement((0, $3MmH8.CsmRequestsHeaderLink), null)))), /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$NavItem, null, /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: {
                actionSubjectId: 'navbarAvatar'
            }
        }, /*#__PURE__*/ $fc4bM.createElement((0, $cScvY.default), {
            disableAvatarMenu: disableAllHeaderLinks
        })))), [
        disableAllHeaderLinks,
        isCSM
    ]);
    const unauthenticatedNavLinks = /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$NavItem, {
        role: "listitem"
    }, /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$export$7d5b37ae6eb004e5, null, /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$LoginButton, {
        href: loginUrl ? loginUrl : defaultLoginUrl,
        actionSubjectId: "navbarLogin"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $gi59x.default).login))));
    const anonymousAccessNotEnbledAndUserNotLoggedIn = !(!!anonymousEnabled || !!userLoggedIn);
    let portalLinkUrl;
    let portalLinkAriaLabel;
    if (isAnonymous || anonymousAccessNotEnbledAndUserNotLoggedIn) {
        portalLinkUrl = defaultLoginUrl;
        portalLinkAriaLabel = formatMessage((0, $gi59x.default).helpCenter);
    } else {
        portalLinkUrl = (0, $gioQl.getHelpCenterUrl)();
        portalLinkAriaLabel = name ? name : formatMessage((0, $gi59x.default).helpCenter);
    }
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            source: 'navbar'
        }
    }, /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$Root, {
        showThemedBackground: Boolean(showThemedBackground),
        headerBackgroundColor: headerBackgroundColor
    }, showPortalLink && /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$PortalLink, {
        to: portalLinkUrl,
        logoTextColor: logoTextColor,
        actionSubjectId: "navbarHelpCenter",
        disabled: Boolean(disableAllHeaderLinks),
        tabIndex: disableAllHeaderLinks ? -1 : undefined,
        "aria-label": portalLinkAriaLabel
    }, /*#__PURE__*/ $fc4bM.createElement($fc4bM.Suspense, {
        fallback: /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
            name: "header-dumb-logo-fallback"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $lfFx3.default), {
            appearance: "square",
            size: "medium"
        }))
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5c45h.LogoMemoizedHOC), null))), /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$Nav, null, /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$NavList, {
        role: "list"
    }, isUserLoaded && /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, hideSearchButton || /*#__PURE__*/ $fc4bM.createElement($cdccc4721e7b9654$var$NavItem, {
        role: "listitem"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $6FAhw.default), {
        trigger: "icon",
        disableSearch: disableAllHeaderLinks
    })), userLoggedIn ? authenticatedNavLinks : unauthenticatedNavLinks)))));
};
var $cdccc4721e7b9654$export$2e2bcd8739ae039 = $cdccc4721e7b9654$var$Header;
// Nav line height set to 0 so it is correctly vertically aligned.
const $cdccc4721e7b9654$var$NAV_LINE_HEIGHT = 0;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $cdccc4721e7b9654$var$Root = /*#__PURE__*/ (0, $luz1X.default).header.withConfig({
    componentId: "sc-l83nge-0"
})`display:flex;justify-content:space-between;align-items:center;${()=>{
    if ((0, $hN5YJ.isUseHelpCenterRefresh)()) return `
                padding-left: ${"var(--ds-space-200, 16px)"};
            `;
    return `
            padding-left: ${"var(--ds-space-100, 8px)"};
            `;
}} padding-right:${"var(--ds-space-100, 8px)"};height:${(0, $iG0dO.HEADER_HEIGHT)}px;overflow:${()=>(0, $k2M4v.default).checkGate('post-office_help-center-migration-onboarding') ? 'clip' : 'hidden'};${(props)=>{
    if (props.headerBackgroundColor) return props.headerBackgroundColor ? `background-color: ${props.headerBackgroundColor}` : '';
    return props.showThemedBackground ? `background-color: ${props.theme.color}` : '';
}}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve,rulesdir/styled-component-order
const $cdccc4721e7b9654$var$Nav = /*#__PURE__*/ (0, $luz1X.default).nav.withConfig({
    componentId: "sc-l83nge-1"
})`line-height:${$cdccc4721e7b9654$var$NAV_LINE_HEIGHT};margin-left:auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $cdccc4721e7b9654$var$NavList = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l83nge-2"
})`margin:0;padding:0;display:flex;align-items:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $cdccc4721e7b9654$var$NavItem = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l83nge-3"
})`display:inline;margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $cdccc4721e7b9654$var$LoginButton = /*#__PURE__*/ (0, $luz1X.default)((props)=>/*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.Button), props)).withConfig({
    componentId: "sc-l83nge-4"
})`&&{padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};}`;
const $cdccc4721e7b9654$export$7d5b37ae6eb004e5 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-l83nge-5"
})`${$3DjOo.subtleThemeColorBackground};border:${"var(--ds-border-width-selected, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"} solid;border-radius:${$fOCtI.multiple(2).px};margin-left:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $cdccc4721e7b9654$var$PortalLink = /*#__PURE__*/ (0, $luz1X.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
({ logoTextColor: logoTextColor, ...props })=>// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $fc4bM.createElement((0, $io4o2.Link), props)).attrs({
    className: 'cv-exclude-from-customisation'
}).withConfig({
    componentId: "sc-l83nge-6"
})`color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};}pointer-events:${(props)=>props.disabled ? 'none' : 'auto'};`;
const $cdccc4721e7b9654$var$requestsLinkStyles = (0, $kig2V.xcss)({
    marginInlineEnd: 'space.075'
});

});
parcelRegister("kYt5D", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => (parcelRequire("5c45h")).LogoMemoizedHOC);

var $5c45h = parcelRequire("5c45h");

});
parcelRegister("5c45h", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => $2a09665e9e436b61$export$299f731b9b12cd90);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $gGw1p = parcelRequire("gGw1p");
const $2a09665e9e436b61$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getLogoUrl), (0, $ePyx3.getSharedPortalName), (0, $ePyx3.getHelpCenterTopBarTextColor), (0, $ePyx3.getHelpCenterTopBarSplitFlag), (url, name, topBarTextColor, hasTopBarBeenSplit)=>({
        url: url,
        name: name,
        topBarTextColor: hasTopBarBeenSplit ? topBarTextColor : undefined
    }));
const $2a09665e9e436b61$export$299f731b9b12cd90 = (0, $6umft.default)($2a09665e9e436b61$var$selector)((0, $gGw1p.LogoMemoized));
var $2a09665e9e436b61$export$2e2bcd8739ae039 = (0, $6umft.default)($2a09665e9e436b61$var$selector)((0, $gGw1p.Logo));

});
parcelRegister("gGw1p", function(module, exports) {
$parcel$export(module.exports, "Logo", () => $8be95463df157c5d$export$e6ff31bff12b7ff4);
$parcel$export(module.exports, "LogoMemoized", () => $8be95463df157c5d$export$acb5f09fe495ae97);

var $bGFjD = parcelRequire("bGFjD");

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $aQHsE = parcelRequire("aQHsE");

var $3BZyK = parcelRequire("3BZyK");

var $d7r8x = parcelRequire("d7r8x");

var $cf3fd = parcelRequire("cf3fd");

var $8lYjN = parcelRequire("8lYjN");
parcelRequire("djnWG");
var $99JZ1 = parcelRequire("99JZ1");
const $8be95463df157c5d$export$e6ff31bff12b7ff4 = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    var _helpCenter$helpCente, _helpCenter$helpCente2;
    const isFetchingData = (0, $hN5YJ.isCustomThemingEnabled)();
    const [stateUrl, setStateUrl] = $fc4bM.useState('');
    const [shouldHoldUFO, setShouldHoldUFO] = $fc4bM.useState(true);
    const { helpCenter: helpCenter } = (0, $3BZyK.useLazyLoadQuery)((0, $bGFjD.default), {
        cloudId: (0, $6LH8a.getCloudId)(),
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        skip: !isFetchingData
    });
    const advancedName = (helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente = helpCenter.helpCenterById) === null || _helpCenter$helpCente === void 0 || (_helpCenter$helpCente = _helpCenter$helpCente.name) === null || _helpCenter$helpCente === void 0 ? void 0 : _helpCenter$helpCente.default) || name;
    const advancedUrl = helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente2 = helpCenter.helpCenterById) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.helpCenterBranding) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.logo) === null || _helpCenter$helpCente2 === void 0 ? void 0 : _helpCenter$helpCente2.url;
    $fc4bM.useEffect(()=>{
        if (!isFetchingData && url && !url.startsWith('blob:')) (0, $8lYjN.getObjectURLFromMediaURLWithCaching)(url).then(setStateUrl).catch(()=>setStateUrl('')).finally(()=>setShouldHoldUFO(false));
        else {
            setStateUrl(url || '');
            setShouldHoldUFO(false);
        }
    }, [
        url,
        isFetchingData
    ]);
    const isHelpCentersManagementPage = (0, $cf3fd.isHelpCentersManagement)();
    const getUrl = $fc4bM.useCallback(()=>{
        if (isFetchingData) return advancedUrl;
        if (isHelpCentersManagementPage) return 0, (/*@__PURE__*/$parcel$interopDefault($aQHsE));
        return stateUrl;
    }, [
        advancedUrl,
        isFetchingData,
        isHelpCentersManagementPage,
        stateUrl
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, shouldHoldUFO && /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
        name: "help-center-common-logo"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $99JZ1.default), {
        url: getUrl(),
        name: advancedName,
        topBarTextColor: topBarTextColor
    }));
};
const $8be95463df157c5d$export$acb5f09fe495ae97 = /*#__PURE__*/ $fc4bM.memo($8be95463df157c5d$export$e6ff31bff12b7ff4);

});
parcelRegister("bGFjD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f462a5fb2ec572ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c8437f71d8ffa7c62d1c0fe41e32f02>>
 * @relayHash 89b5ac4560edc5779e88acaa2f693808
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360
const $f462a5fb2ec572ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360",
            "metadata": {},
            "name": "logoQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f462a5fb2ec572ec$var$node.hash = "50f3d8eb5808e1ee69db4f8e639d0b3e";
var $f462a5fb2ec572ec$export$2e2bcd8739ae039 = $f462a5fb2ec572ec$var$node;

});

parcelRegister("aQHsE", function(module, exports) {
module.exports = new URL("../images/atlassian-icon.632e3804.png", import.meta.url).toString();

});

parcelRegister("djnWG", function(module, exports) {
$parcel$export(module.exports, "LogoStateless", () => (parcelRequire("99JZ1")).default);

var $99JZ1 = parcelRequire("99JZ1");

});
parcelRegister("99JZ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f93ab52804eba7e8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fOCtI = parcelRequire("fOCtI");
const $f93ab52804eba7e8$var$LogoStateless = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    const content = url ? /*#__PURE__*/ $fc4bM.createElement($f93ab52804eba7e8$var$ImageStyled, {
        src: url,
        alt: name
    }) : /*#__PURE__*/ $fc4bM.createElement("span", null, name);
    return /*#__PURE__*/ $fc4bM.createElement($f93ab52804eba7e8$var$RootStyled, {
        topBarTextColor: topBarTextColor
    }, content);
};
var $f93ab52804eba7e8$export$2e2bcd8739ae039 = $f93ab52804eba7e8$var$LogoStateless;
const $f93ab52804eba7e8$var$imageHeight = $fOCtI.unitless * 5;
// Styled-components version (legacy)
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f93ab52804eba7e8$var$RootStyled = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-prcwi5-0"
})`height:${$f93ab52804eba7e8$var$imageHeight}px;display:inline-flex;align-items:center;justify-content:center;padding:${"var(--ds-space-075, 6px)"};font-weight:600;color:${(props)=>props.topBarTextColor || 'inherit'};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f93ab52804eba7e8$var$ImageStyled = /*#__PURE__*/ (0, $luz1X.default).img.withConfig({
    componentId: "sc-prcwi5-1"
})`height:${$f93ab52804eba7e8$var$imageHeight}px;`;

});





parcelRegister("3MmH8", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsHeaderLink", () => $c265c893b127bf47$export$45f0a19e0c7c461b);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $9mazR = parcelRequire("9mazR");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $jOinY = parcelRequire("jOinY");

var $eM7mn = parcelRequire("eM7mn");

var $lftf9 = parcelRequire("lftf9");

var $76UhV = parcelRequire("76UhV");
const $c265c893b127bf47$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getHelpCenterTopBarTextColor), (primaryColor)=>({
        primaryColor: primaryColor
    }));
const $c265c893b127bf47$var$CsmRequestsHeaderLinkDumb = ({ primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push, baseUrl: baseUrl } = (0, $lftf9.useLinkPush)();
    const href = baseUrl + (0, $9mazR.RoutePath).CSM_REQUESTS_LIST_PATH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jOinY.default), {
        shape: "circle",
        href: href,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
                style: {
                    color: primaryColor
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eM7mn))), iconProps)),
        label: formatMessage((0, $76UhV.default).requests),
        onClick: (event)=>{
            push((0, $9mazR.RoutePath).CSM_REQUESTS_LIST_PATH, event);
        }
    });
};
const $c265c893b127bf47$export$45f0a19e0c7c461b = (0, $6umft.default)($c265c893b127bf47$var$selector, {})($c265c893b127bf47$var$CsmRequestsHeaderLinkDumb);

});
parcelRegister("jOinY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8779afe1319ef792$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ /* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $8PakO = parcelRequire("8PakO");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $bcTS3 = parcelRequire("bcTS3");

var $dVxDa = parcelRequire("dVxDa");

var $6m8y3 = parcelRequire("6m8y3");

var $dw5IO = parcelRequire("dw5IO");
const $8779afe1319ef792$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $8779afe1319ef792$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $8779afe1319ef792$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $8779afe1319ef792$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _irr31afz _1di61kru"
};
const $8779afe1319ef792$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $8779afe1319ef792$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $8779afe1319ef792$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $8779afe1319ef792$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, newWindowLabel: newWindowLabel, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $fc4bM.useRef)(null);
    (0, $8PakO.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Ny1Q.Anchor), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                newWindowLabel: newWindowLabel,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    var _triggerProps$onClick;
                    onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: (0, $4dCfH.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $4Cnkn.cx)($8779afe1319ef792$var$styles.base, !isDisabled && $8779afe1319ef792$var$styles.interactiveMotion, appearance === 'default' && $8779afe1319ef792$var$defaultStyles.root, appearance === 'primary' && $8779afe1319ef792$var$primaryStyles.root, appearance === 'rovo' && $8779afe1319ef792$var$rovoStyles.root, appearance === 'discovery' && $8779afe1319ef792$var$discoveryStyles.root, appearance === 'subtle' && $8779afe1319ef792$var$subtleStyles.root, $8779afe1319ef792$var$styles.linkDecorationUnset, isSelected && $8779afe1319ef792$var$selectedStyles.root, isSelected && appearance === 'discovery' && $8779afe1319ef792$var$selectedStyles.discovery, isDisabled && $8779afe1319ef792$var$styles.disabled, $8779afe1319ef792$var$styles.iconButton, spacing === 'compact' && $8779afe1319ef792$var$styles.spacingCompact, shape === 'circle' && $8779afe1319ef792$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6m8y3.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                            icon: icon,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Ny1Q.Anchor), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        newWindowLabel: newWindowLabel,
        ref: (0, $4dCfH.default)([
            localRef,
            ref
        ]),
        xcss: (0, $4Cnkn.cx)($8779afe1319ef792$var$styles.base, !isDisabled && $8779afe1319ef792$var$styles.interactiveMotion, appearance === 'default' && $8779afe1319ef792$var$defaultStyles.root, appearance === 'primary' && $8779afe1319ef792$var$primaryStyles.root, appearance === 'rovo' && $8779afe1319ef792$var$rovoStyles.root, appearance === 'discovery' && $8779afe1319ef792$var$discoveryStyles.root, appearance === 'subtle' && $8779afe1319ef792$var$subtleStyles.root, $8779afe1319ef792$var$styles.linkDecorationUnset, isSelected && $8779afe1319ef792$var$selectedStyles.root, isSelected && appearance === 'discovery' && $8779afe1319ef792$var$selectedStyles.discovery, isDisabled && $8779afe1319ef792$var$styles.disabled, $8779afe1319ef792$var$styles.iconButton, spacing === 'compact' && $8779afe1319ef792$var$styles.spacingCompact, shape === 'circle' && $8779afe1319ef792$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6m8y3.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                    icon: icon,
                    spacing: spacing
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $8779afe1319ef792$var$WithRef = /*#__PURE__*/ (0, $fc4bM.forwardRef)($8779afe1319ef792$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $8779afe1319ef792$var$LinkIconButton = /*#__PURE__*/ (0, $fc4bM.memo)($8779afe1319ef792$var$WithRef);
var $8779afe1319ef792$export$2e2bcd8739ae039 = $8779afe1319ef792$var$LinkIconButton;

});

parcelRegister("eM7mn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fa04d7bec8552f7cf5d65f57f0111e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac1b41eb6a0d488d$var$_react = $ac1b41eb6a0d488d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ac1b41eb6a0d488d$var$_iconNew = $ac1b41eb6a0d488d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ac1b41eb6a0d488d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/inbox
 * Usage guidance:
 * Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac1b41eb6a0d488d$var$InboxIcon = (props)=>/*#__PURE__*/ $ac1b41eb6a0d488d$var$_react.default.createElement($ac1b41eb6a0d488d$var$_iconNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$ac1b41eb6a0d488d$var$InboxIcon.displayName = 'InboxIcon';
var $ac1b41eb6a0d488d$var$_default = module.exports.default = $ac1b41eb6a0d488d$var$InboxIcon;

});

parcelRegister("lftf9", function(module, exports) {
$parcel$export(module.exports, "useLinkPush", () => $7b97f171b031933c$export$52eec4f7709b743e);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $jEubQ = parcelRequire("jEubQ");

var $eENmG = parcelRequire("eENmG");

var $7lN8e = parcelRequire("7lN8e");
const $7b97f171b031933c$export$52eec4f7709b743e = ()=>{
    var _env$baseUrl;
    const env = (0, $7lN8e.getEnv)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const linkPush = (0, $fc4bM.useCallback)((targetUrl, event, analyticsAttributes)=>{
        if (analyticsAttributes) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            ...analyticsAttributes
        }).fire();
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        push(targetUrl);
    }, [
        push,
        createAnalyticsEvent
    ]);
    return {
        push: linkPush,
        baseUrl: (_env$baseUrl = env.baseUrl) === null || _env$baseUrl === void 0 ? void 0 : _env$baseUrl.replace(/\/+$/, '')
    };
};

});

parcelRegister("76UhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f797fac647e8dfca$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $f797fac647e8dfca$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    requests: {
        id: 'csm-requests-header-link.requests',
        defaultMessage: 'Requests',
        description: 'The text is shown as the label for a navigation link in the page header that takes the user to the list of their submitted customer service requests.'
    }
});

});


parcelRegister("iyjHn", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("cScvY")).default);
$parcel$export(module.exports, "UpdateHelpCenterSpotlight", () => (parcelRequire("dtoUQ")).UpdateHelpCenterSpotlight);
parcelRequire("bn0uU");
var $cScvY = parcelRequire("cScvY");
parcelRequire("knBhf");
var $dtoUQ = parcelRequire("dtoUQ");

});
parcelRegister("bn0uU", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("cScvY")).default);

var $cScvY = parcelRequire("cScvY");

});
parcelRegister("cScvY", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb5afabf3b763b00$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("5xojH");
var $jeUw6 = parcelRequire("jeUw6");

var $a8iyM = parcelRequire("a8iyM");

var $ejcvX = parcelRequire("ejcvX");

var $jtp0M = parcelRequire("jtp0M");

var $2zWQA = parcelRequire("2zWQA");

var $4TWBM = parcelRequire("4TWBM");

var $3BiGe = parcelRequire("3BiGe");

var $gvDpV = parcelRequire("gvDpV");

var $alVAg = parcelRequire("alVAg");

var $beT51 = parcelRequire("beT51");

var $dksPI = parcelRequire("dksPI");
parcelRequire("3xD3Y");
var $4lqz9 = parcelRequire("4lqz9");
const $bb5afabf3b763b00$var$getCustomMenuLinksProps = (state)=>{
    const customMenuLinks = (0, $3BiGe.getCustomMenuLinks)(state);
    return customMenuLinks.map((menuLink)=>{
        return {
            id: menuLink.id,
            key: menuLink.key,
            label: menuLink.label,
            href: menuLink.href,
            styleClass: menuLink.styleClass
        };
    });
};
const $bb5afabf3b763b00$var$selector = (0, $2n2bS.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $a8iyM.getPortalId)(state);
    const routeName = (0, $a8iyM.getRoutename)(state);
    const portal = {
        id: portalId,
        name: (0, $2zWQA.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $2zWQA.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $2zWQA.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $2zWQA.getIsProjectSimplified)(state, portalId))
    };
    const areCustomerServiceSettingsLinksAvailable = (0, $ejcvX.getHelpCenterType)(state) === (0, $dksPI.CUSTOMER_SERVICE_HELP_CENTER_TYPE) && !!(0, $ejcvX.getHoistedProjectKey)(state);
    return {
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: (0, $3BiGe.getAvatarSrc)(state),
        displayName: (0, $3BiGe.getDisplayName)(state),
        email: (0, $3BiGe.getEmail)(state),
        customMenuLinks: $bb5afabf3b763b00$var$getCustomMenuLinksProps(state),
        canAdministerJIRA: (0, $3BiGe.getCanAdministerJIRA)(state),
        canCustomiseHelpCenter: (0, $jtp0M.getCanCustomize)(state),
        pendingApprovalCount: (0, $gvDpV.getUserRequestsCounts)(state).pendingApprovalCount,
        myRequestCount: (0, $gvDpV.getUserRequestsCounts)(state).myRequestCount,
        defaultColumnSettings: (0, $4TWBM.getRequestsColumnSettings)(state),
        approvalCount: (0, $gvDpV.getUserRequestsCounts)(state).approvalCount,
        jsmAIConfigEnabled: (0, $ejcvX.getJsmAIConfigEnabled)(state),
        hoistedProjectKey: (0, $ejcvX.getHoistedProjectKey)(state),
        jiraDisplayUrl: (0, $ejcvX.getJiraDisplayUrl)(state),
        hasSiteAdministerAccess: (0, $3BiGe.getHasSiteAdministerAccess)(state)
    };
}, ({ portal: portal, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, avatarSrc: avatarSrc, displayName: displayName, email: email, customMenuLinks: customMenuLinks, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, routeName: routeName, defaultColumnSettings: defaultColumnSettings, pendingApprovalCount: pendingApprovalCount, myRequestCount: myRequestCount, approvalCount: approvalCount, jsmAIConfigEnabled: jsmAIConfigEnabled, hoistedProjectKey: hoistedProjectKey, jiraDisplayUrl: jiraDisplayUrl, hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: avatarSrc,
        displayName: displayName,
        email: email,
        customMenuLinks: customMenuLinks,
        canAdministerJIRA: canAdministerJIRA,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        pendingApprovalCount: pendingApprovalCount,
        approvalCount: approvalCount,
        defaultColumnSettings: defaultColumnSettings,
        myRequestCount: myRequestCount,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        hoistedProjectKey: hoistedProjectKey,
        jiraDisplayUrl: jiraDisplayUrl,
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
var $bb5afabf3b763b00$export$2e2bcd8739ae039 = (0, $6umft.default)($bb5afabf3b763b00$var$selector, {
    onLogoutClick: (0, $jeUw6.logOutAction),
    openHelpCenterCustomizationSidebar: ()=>(0, $alVAg.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $beT51.customizingRequestListColumn)(true)
})((0, $4lqz9.default));

});
parcelRegister("5xojH", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("2qvOc")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("2qvOc")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("kM7Mj")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("4AxVG")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("l81MK")).fetchCategoriesAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("jeUw6")).logOutAction);

var $2qvOc = parcelRequire("2qvOc");

var $kM7Mj = parcelRequire("kM7Mj");

var $4AxVG = parcelRequire("4AxVG");

var $l81MK = parcelRequire("l81MK");

var $jeUw6 = parcelRequire("jeUw6");

});
parcelRegister("2qvOc", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => $32465dfa7739a733$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $32465dfa7739a733$export$42cfcdfd4935cc23);

var $l0q18 = parcelRequire("l0q18");
const $32465dfa7739a733$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $32465dfa7739a733$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $32465dfa7739a733$export$61e2f9e78cb604c7 = (0, $l0q18.buildModelsActionCreator)($32465dfa7739a733$export$5586a78b777598b9, 'sharedPortal');
const $32465dfa7739a733$export$42cfcdfd4935cc23 = (0, $l0q18.buildModelsActionCreator)($32465dfa7739a733$export$d8cc5374b8afc050, 'helpCenterBranding');

});
parcelRegister("l0q18", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $40d54b43404e3dfa$export$9f8a38b5e77ac29);
const $40d54b43404e3dfa$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});


parcelRegister("kM7Mj", function(module, exports) {
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $20fb9bf734e12d89$export$cbdd5d7a098d34a2);

var $l0q18 = parcelRequire("l0q18");
const $20fb9bf734e12d89$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $20fb9bf734e12d89$export$cbdd5d7a098d34a2 = (0, $l0q18.buildModelsActionCreator)($20fb9bf734e12d89$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("4AxVG", function(module, exports) {
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $0e86e49684e299c1$export$71172847a48a08a6);

var $l0q18 = parcelRequire("l0q18");
const $0e86e49684e299c1$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $0e86e49684e299c1$export$71172847a48a08a6 = (0, $l0q18.buildModelsActionCreator)($0e86e49684e299c1$export$dfecf710cdf030b1, 'userRequestsCounts');

});

parcelRegister("l81MK", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => $0e3bc103b4fd413a$export$10813fa84276d50);
const $0e3bc103b4fd413a$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $0e3bc103b4fd413a$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $0e3bc103b4fd413a$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});

parcelRegister("jeUw6", function(module, exports) {
$parcel$export(module.exports, "logOutAction", () => $b33e4f635048f6ef$export$1a3865346be34527);
const $b33e4f635048f6ef$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $b33e4f635048f6ef$export$1a3865346be34527 = ()=>{
    return {
        type: $b33e4f635048f6ef$export$cb307dad255adf47
    };
};

});


parcelRegister("a8iyM", function(module, exports) {
$parcel$export(module.exports, "getPortalId", () => $56601af8ebf7c9b5$export$79c9b12a0a57147a);
$parcel$export(module.exports, "getRoutename", () => $56601af8ebf7c9b5$export$6c570a1091322ad4);
const $56601af8ebf7c9b5$export$f71e6ac2c1d88be0 = (state)=>{
    var _state$ui, _state$ui2, _state$ui3;
    return ((_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.context.portalId) !== undefined && ((_state$ui2 = state.ui) === null || _state$ui2 === void 0 ? void 0 : _state$ui2.context.portalId) !== null && !isNaN(((_state$ui3 = state.ui) === null || _state$ui3 === void 0 ? void 0 : _state$ui3.context.portalId) || NaN);
};
const $56601af8ebf7c9b5$export$79c9b12a0a57147a = (state)=>{
    var _state$ui4;
    if (!$56601af8ebf7c9b5$export$f71e6ac2c1d88be0(state)) return undefined;
    return (_state$ui4 = state.ui) === null || _state$ui4 === void 0 ? void 0 : _state$ui4.context.portalId;
};
const $56601af8ebf7c9b5$export$6c570a1091322ad4 = (state)=>{
    var _state$ui5;
    return (_state$ui5 = state.ui) === null || _state$ui5 === void 0 ? void 0 : _state$ui5.context.routeName;
};

});

parcelRegister("ejcvX", function(module, exports) {
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $07e516f8d5e66804$export$a90992f5204fc247);
$parcel$export(module.exports, "getHelpCenterType", () => $07e516f8d5e66804$export$7972e6e7445f0142);
$parcel$export(module.exports, "getHoistedProjectKey", () => $07e516f8d5e66804$export$3b0fd0e16a94f75);
$parcel$export(module.exports, "getHoistedProjectId", () => $07e516f8d5e66804$export$23a8be9c477ed0ba);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $07e516f8d5e66804$export$9679fa5312e1354b);
const $07e516f8d5e66804$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $07e516f8d5e66804$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $07e516f8d5e66804$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $07e516f8d5e66804$export$23a8be9c477ed0ba = (state)=>state.persisted.env.hoistedProjectId;
const $07e516f8d5e66804$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;

});

parcelRegister("jtp0M", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterBanner", () => $b393a81af2f5666e$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getThemeColor", () => $b393a81af2f5666e$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getCanCustomize", () => $b393a81af2f5666e$export$eb9b5e885139dc39);

var $aYMdQ = parcelRequire("aYMdQ");

var $3BiGe = parcelRequire("3BiGe");
const $b393a81af2f5666e$export$85757b7e55ef3c9f = (state)=>{
    var _state$ui;
    return (0, $aYMdQ.mergeWith)({}, state.persisted.helpCenter, (_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.helpCenterPreview, // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
    (_, srcValue)=>{
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
};
const $b393a81af2f5666e$export$3b3c747bea011f3c = (state)=>{
    return $b393a81af2f5666e$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
};
const $b393a81af2f5666e$export$e22c5d06d177c3fa = (state)=>{
    return $b393a81af2f5666e$export$85757b7e55ef3c9f(state).themeColor;
};
const $b393a81af2f5666e$var$getTranslation = (state, language)=>$b393a81af2f5666e$export$85757b7e55ef3c9f(state).translations[language];
const $b393a81af2f5666e$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $3BiGe.getLocale)(state);
    const translation = userLocale && $b393a81af2f5666e$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $b393a81af2f5666e$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $b393a81af2f5666e$export$eb9b5e885139dc39 = (state)=>{
    return $b393a81af2f5666e$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
};

});

parcelRegister("2zWQA", function(module, exports) {
$parcel$export(module.exports, "getPortalOrError", () => $1323a1c5720f530e$export$aa66ead34639a340);
$parcel$export(module.exports, "getProjectId", () => $1323a1c5720f530e$export$89040d072f281f85);
$parcel$export(module.exports, "getName", () => $1323a1c5720f530e$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getPortalAnnouncement", () => $1323a1c5720f530e$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $1323a1c5720f530e$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $1323a1c5720f530e$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $1323a1c5720f530e$export$7a0f33e8df10bd94);

var $aYMdQ = parcelRequire("aYMdQ");
const $1323a1c5720f530e$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $1323a1c5720f530e$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $aYMdQ.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $1323a1c5720f530e$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $1323a1c5720f530e$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $1323a1c5720f530e$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $aYMdQ.isNil)(portalId)) return undefined;
    const portal = $1323a1c5720f530e$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $1323a1c5720f530e$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $1323a1c5720f530e$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.name : undefined;
};
const $1323a1c5720f530e$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $1323a1c5720f530e$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $1323a1c5720f530e$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $1323a1c5720f530e$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement ? portalAnnouncement.canAdministerProject : false;
};
const $1323a1c5720f530e$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $1323a1c5720f530e$export$e16cb606b6ef4a60(state, portalId);
    return portal ? !!portal.isProjectSimplified : false;
};
const $1323a1c5720f530e$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $1323a1c5720f530e$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};

});

parcelRegister("4TWBM", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $5ea65631a2ce53bf$export$a5e47ac90fcdaee8);
/**
 * Request column settings selectors for accessing column configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */ /**
 * Get the full requests column settings state (includes columns and statusFilter).
 */ const $5ea65631a2ce53bf$var$getRequestsColumnSettingsState = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $5ea65631a2ce53bf$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $5ea65631a2ce53bf$var$getRequestsColumnSettingsState(state);
    return settingsState.columns || [];
};

});

parcelRegister("gvDpV", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $5698118c278bfa43$export$be73da9c8fdefffb);
const $5698118c278bfa43$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});

parcelRegister("dksPI", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_HELP_CENTER_TYPE", () => $dc7c97577255a18f$export$fc172486e4a9f1fa);
const $dc7c97577255a18f$export$fc172486e4a9f1fa = 'CUSTOMER_SERVICE';

});

parcelRegister("3xD3Y", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuDumbV2", () => (parcelRequire("4lqz9")).default);

var $4lqz9 = parcelRequire("4lqz9");

});
parcelRegister("4lqz9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fcfea28be9d4efe$export$2e2bcd8739ae039);
/* avatar-menu-dumb-v2.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $7VVXk = parcelRequire("7VVXk");

var $MPQAF = parcelRequire("MPQAF");
var $io4o2 = parcelRequire("io4o2");

var $g9mbo = parcelRequire("g9mbo");

var $fTpep = parcelRequire("fTpep");

var $8qhwO = parcelRequire("8qhwO");

var $9mazR = parcelRequire("9mazR");

var $5ryST = parcelRequire("5ryST");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $g97N1 = parcelRequire("g97N1");

var $1HEEa = parcelRequire("1HEEa");

var $js98a = parcelRequire("js98a");

var $3C7EO = parcelRequire("3C7EO");

var $6LH8a = parcelRequire("6LH8a");

var $8ULdj = parcelRequire("8ULdj");

var $fOCtI = parcelRequire("fOCtI");

var $lXJd8 = parcelRequire("lXJd8");

var $6geXm = parcelRequire("6geXm");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $3TJLC = parcelRequire("3TJLC");

var $jEubQ = parcelRequire("jEubQ");

var $itdHE = parcelRequire("itdHE");

var $cWkQ8 = parcelRequire("cWkQ8");

var $k2M4v = parcelRequire("k2M4v");

var $euRd1 = parcelRequire("euRd1");

var $bKfoa = parcelRequire("bKfoa");

var $T88uF = parcelRequire("T88uF");

var $gSOfb = parcelRequire("gSOfb");

var $3rlj9 = parcelRequire("3rlj9");

var $5PQxp = parcelRequire("5PQxp");

var $byPAM = parcelRequire("byPAM");

var $fXMxe = parcelRequire("fXMxe");

var $4EPUx = parcelRequire("4EPUx");

var $5a4EU = parcelRequire("5a4EU");

var $l3fZT = parcelRequire("l3fZT");

var $kig2V = parcelRequire("kig2V");

var $2SWSA = parcelRequire("2SWSA");

var $gvvtK = parcelRequire("gvvtK");

var $eENmG = parcelRequire("eENmG");

var $4MoYu = parcelRequire("4MoYu");

var $80SfI = parcelRequire("80SfI");

var $lh6uV = parcelRequire("lh6uV");

var $cJsi5 = parcelRequire("cJsi5");

var $asC5r = parcelRequire("asC5r");

var $kJiHZ = parcelRequire("kJiHZ");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $bzsGe = parcelRequire("bzsGe");

var $g8fua = parcelRequire("g8fua");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");

var $uYmrU = parcelRequire("uYmrU");

var $6Nd92 = parcelRequire("6Nd92");
parcelRequire("l5sYc");
var $6oPaA = parcelRequire("6oPaA");

var $4G9Kl = parcelRequire("4G9Kl");
parcelRequire("knBhf");
var $dtoUQ = parcelRequire("dtoUQ");

var $eQkdB = parcelRequire("eQkdB");

var $1i5tj = parcelRequire("1i5tj");

var $lEU2a = parcelRequire("lEU2a");

var $2xdpH = parcelRequire("2xdpH");
const $5fcfea28be9d4efe$export$c0b4c34c7506f4d = ()=>(0, $k2M4v.default).checkGate('jsm_help_center_one-click_rovo_agent');
const $5fcfea28be9d4efe$export$e0ae4b37130667df = ({ onClose: onClose })=>{
    const { data: { extensionTitles: extensionTitles }, methods: { setExtensionToDisplay: onClick } } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $js98a.ForgeModalContext));
    const forgeActionLinkOnClick = (id, onClickApp)=>()=>{
            onClose('navBarForgeApp');
            return onClickApp(id);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, extensionTitles.map(({ id: id, title: title })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            id: id,
            key: `forge-title_${id}`,
            component: $5fcfea28be9d4efe$var$CustomButton,
            actionSubjectId: "navBarForgeApp",
            onClick: forgeActionLinkOnClick(id, onClick)
        }, title);
    }));
};
const $5fcfea28be9d4efe$var$menuBottomSection = (onClose, isHelpCenterManagementScreen, onLogoutClick)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
        hasSeparator: true
    }, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        actionSubjectId: "navbarProfile",
        key: `bottom-menu-management-screen-navbarProfile`,
        component: $5fcfea28be9d4efe$var$CustomAnchor,
        href: '/servicedesk/customer/user/profile',
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).profile)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        key: `bottom-menu-navbarProfile`,
        component: $5fcfea28be9d4efe$var$CustomLink,
        to: '/user/profile',
        actionSubjectId: "navbarProfile",
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).profile)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: 'navbarLogout'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        component: $5fcfea28be9d4efe$var$CustomButton,
        actionSubjectId: "navbarLogout",
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": 'logout',
        onClick: onLogoutClick,
        "data-test-id": "logout-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).logout))));
};
const $5fcfea28be9d4efe$export$a552d0e5a7a35aad = ({ customMenuLinks: customMenuLinks, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-test-id": "custom-menu-link"
    }, customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: `custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            actionSubjectId: 'custom-menu-link',
            component: $5fcfea28be9d4efe$var$CustomAnchor,
            href: menuLink.href,
            onClick: ()=>onClose('custom-menu-link'),
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label))));
const $5fcfea28be9d4efe$var$buildCustomMenuLinks = (customMenuLinks, onClose)=>{
    return customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: `build-custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            actionSubjectId: 'custom-menu-link',
            component: $5fcfea28be9d4efe$var$CustomAnchor,
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            onClick: ()=>onClose('custom-menu-link'),
            href: menuLink.href,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label)));
};
const $5fcfea28be9d4efe$var$TopMenu = (myRequestCount, onClose, pendingApprovalCount, approvalCount, isHelpCenterManagementScreen)=>{
    const customizeMenu = [
        {
            onClick: ()=>onClose('navbarUserRequests'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/requests?reporter=all&statuses=open' : '/user/requests?reporter=all&statuses=open',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).requests),
            actionSubjectId: 'navbarUserRequests',
            iconAfter: myRequestCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fTpep.default), null, myRequestCount) : undefined,
            isVisible: !(0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType),
            dataTestId: 'requests-link'
        },
        {
            onClick: ()=>onClose('navbarUserApprovals'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/approvals' : '/user/approvals',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).approvals),
            actionSubjectId: 'navbarUserApprovals',
            iconAfter: pendingApprovalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fTpep.default), null, pendingApprovalCount) : undefined,
            isVisible: approvalCount > 0 || pendingApprovalCount > 0,
            dataTestId: 'approvals-link'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            actionSubjectId: menu.actionSubjectId,
            key: `top-menu-management-screen_${menu.actionSubjectId}`,
            component: $5fcfea28be9d4efe$var$CustomAnchor,
            href: menu.link,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            key: `top-menu_${menu.actionSubjectId}`,
            component: $5fcfea28be9d4efe$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $5fcfea28be9d4efe$var$CustomMenuItems = ({ menu: menu })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        component: menu.component ?? $5fcfea28be9d4efe$var$CustomLink,
        to: menu.link,
        actionSubjectId: menu.actionSubjectId,
        onClick: menu.onClick,
        testId: menu.testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
            appearance: "discovery"
        }, formatMessage((0, $1i5tj.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
            appearance: "discovery"
        }, formatMessage((0, $1i5tj.default).newLozenge)), menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
            appearance: "discovery"
        }, formatMessage((0, $1i5tj.default).premiumLozenge)))
    }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gvvtK.FireUIAnalytics), {
        action: "viewed",
        actionSubject: menu.actionSubjectId
    }));
};
const $5fcfea28be9d4efe$var$CustomPressable = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $l3fZT.Pressable), {
        componentName: "link",
        xcss: $5fcfea28be9d4efe$var$customPressableStyles,
        ...rest
    }, children);
/**
 * Feature gate: premium_benefits_modal_config_driven
 *
 * When enabled, open the new config-driven edition-benefits-modal via its async
 * entrypoint (`editionBenefitsModalEntryPoint` + `ModalTrigger`) instead of the
 * legacy `PremiumBenefitModalTrigger`. The entrypoint loads on demand, keeping
 * the modal's assets out of the initial bundle.
 *
 * Rollout: Pending — gate created 2026-07-15, default off
 * Target: TBD
 * Owner: Sequoia (SQA-4082)
 */ const $5fcfea28be9d4efe$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN = 'premium_benefits_modal_config_driven';
const $5fcfea28be9d4efe$var$isPremiumBenefitsModalConfigDrivenEnabled = ()=>(0, $k2M4v.default).checkGate($5fcfea28be9d4efe$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN);
const $5fcfea28be9d4efe$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const isConfigDriven = $5fcfea28be9d4efe$var$isPremiumBenefitsModalConfigDrivenEnabled();
    const edition = (0, $7lN8e.getEnv)().edition ?? 'unknown';
    // The config-driven ModalTrigger path doesn't emit the trigger analytics that the
    // legacy PremiumBenefitModalTrigger did, so replicate them here for parity.
    const fireTriggerEvent = (0, $fc4bM.useCallback)((action)=>createAnalyticsEvent({
            action: action,
            eventType: 'ui',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                edition: edition,
                touchpointId: menu.pbmTouchpointId,
                product: 'jira-service-management',
                variantId: 'help-center-customization',
                packageName: '@atlassian/edition-benefits-modal',
                source: 'editionBenefitsModal'
            }
        }).fire('growth'), // FabricChannel.growth
    [
        createAnalyticsEvent,
        edition,
        menu.pbmTouchpointId
    ]);
    const hasFiredViewed = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        // Fire the trigger "viewed" event once when the config-driven trigger is shown.
        if (isConfigDriven && !hasFiredViewed.current) {
            hasFiredViewed.current = true;
            fireTriggerEvent('viewed');
        }
    }, [
        isConfigDriven,
        fireTriggerEvent
    ]);
    const renderTrigger = ({ ref: ref, onTriggerClick: onTriggerClick, props: triggerProps })=>// CustomItem doesn't forward testId to custom components, so we add it to the Box wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            ref: ref,
            ...triggerProps,
            testId: menu.testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$CustomMenuItems, {
            menu: {
                ...menu,
                component: $5fcfea28be9d4efe$var$CustomPressable,
                // Compose the trigger analytics with the item's own handler so the "clicked"
                // event fires on the element itself rather than relying on event bubbling.
                ...onTriggerClick ? {
                    onClick: (event)=>{
                        var _menu$onClick;
                        onTriggerClick();
                        (_menu$onClick = menu.onClick) === null || _menu$onClick === void 0 || _menu$onClick.call(menu, event);
                    }
                } : {}
            }
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).HELP_CENTER,
        id: `help-center-${menu.pbmTouchpointId}`,
        renderError: ()=>null
    }, isConfigDriven ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kJiHZ.ModalTrigger), {
        entryPoint: (0, $cJsi5.editionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: (0, $6LH8a.getCloudId)(),
            product: 'jira-service-management'
        },
        entryPointProps: {
            variantId: 'help-center-customization',
            touchpointId: menu.pbmTouchpointId
        },
        modalProps: (0, $lh6uV.MODAL_CONFIG)
    }, ({ ref: ref })=>renderTrigger({
            ref: ref,
            props: {},
            onTriggerClick: ()=>fireTriggerEvent('clicked')
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $80SfI.PremiumBenefitModalTrigger), {
        cloudId: (0, $6LH8a.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: menu.pbmTouchpointId,
        edition: edition
    }, renderTrigger));
};
const $5fcfea28be9d4efe$var$ListItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "li",
        xcss: $5fcfea28be9d4efe$var$listItemStyles
    }, children);
};
const $5fcfea28be9d4efe$export$7ed443719af866bf = ({ customizeMenu: customizeMenu = [] })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $fc4bM.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.isAnchor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            component: $5fcfea28be9d4efe$var$CustomAnchor,
            href: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                appearance: "discovery"
            }, formatMessage((0, $1i5tj.default).beta)),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: `customize-menu_spotlight_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8ULdj.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $byPAM.default), {
                name: (0, $9mazR.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
                key: `customize-menu_${menu.actionSubjectId}`,
                component: $5fcfea28be9d4efe$var$CustomLink,
                to: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                    appearance: "discovery"
                }, formatMessage((0, $1i5tj.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                    appearance: "discovery"
                }, formatMessage((0, $1i5tj.default).newLozenge)))
            }, menu.label))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fXMxe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5ryST.default), {
            messageId: (0, $9mazR.EngagementMessages).ONBOARD_VA_REPORTING,
            key: (0, $9mazR.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6geXm.VaOnboardingSpotlight), {
            setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
        })))));
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: `customize-menu_custom_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(menu.customRenderer, {
            menu: menu
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            component: $5fcfea28be9d4efe$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                appearance: "discovery"
            }, formatMessage((0, $1i5tj.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                appearance: "discovery"
            }, formatMessage((0, $1i5tj.default).newLozenge))),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $5fcfea28be9d4efe$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub)=>{
    const isHomePage = routeName === 'help-center' || routeName === 'view-homepage';
    const customizeMenu = [];
    const helpCenterId = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)()).helpCenterId;
    const isVisible = areCustomerServiceSettingsLinksAvailable && !!jiraDisplayUrl && !!hoistedProjectKey && !!helpCenterId && (isHomePage || isServiceHub) && canAdministerJIRA;
    const helpCenterSettingsUrl = (0, $hN5YJ.isCsmAppification)() ? `${jiraDisplayUrl ?? ''}/jira/customer-service-management/experiences/${hoistedProjectKey ?? ''}/settings/${helpCenterId}/details` : `${jiraDisplayUrl ?? ''}/jira/helpcenter/projects/${hoistedProjectKey ?? ''}/settings/${helpCenterId}/details`;
    const additionalMenuItems = [
        {
            isVisible: isVisible,
            isAnchor: true,
            link: helpCenterSettingsUrl,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).customerHubSettings),
            actionSubjectId: 'helpCenterSettings',
            testId: 'help-center-settings'
        }
    ];
    customizeMenu.push(...additionalMenuItems);
    const hideSection = ()=>customizeMenu.every((item)=>!item.isVisible);
    if (hideSection()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$export$7ed443719af866bf, {
        customizeMenu: customizeMenu
    });
};
const $5fcfea28be9d4efe$var$RenderHCSection = ({ onClick: onClick, showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells, jiraDisplayUrl: jiraDisplayUrl })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
    const customizeMenu = [
        {
            link: `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).manageHc),
            actionSubjectId: 'manageHelpCenter',
            isVisible: true,
            onClick: ()=>onClick('manageHelpCenter'),
            testId: 'manage-hc-link'
        },
        {
            link: (0, $7lN8e.getIsMultiHCEnabled)() ? (0, $4G9Kl.getHelpCenterCreationUrl)(jiraDisplayUrl) : '#',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).createHc),
            actionSubjectId: 'createHelpCenter',
            isVisible: showAvatarMenuItemsUpsells,
            pbmTouchpointId: 'portal-avatar-menu-create-help-center',
            customRenderer: (0, $7lN8e.getIsHCCustomizationEnabled)() ? undefined : $5fcfea28be9d4efe$var$PremiumBenefitsModalRenderer,
            onClick: ()=>onClick('createHelpCenter'),
            testId: 'create-hc-link',
            isPremium: !(0, $7lN8e.getIsHCCustomizationEnabled)()
        },
        {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).managePages),
            actionSubjectId: 'manageHelpCenterPages',
            isVisible: showAvatarMenuItemsUpsells,
            pbmTouchpointId: 'portal-avatar-menu-landing-pages',
            onClick: ()=>onClick('manageHelpCenterPages'),
            testId: 'manage-hc-pages',
            link: `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/pages`,
            isPremium: !(0, $7lN8e.getIsHCCustomizationEnabled)(),
            customRenderer: (0, $7lN8e.getIsHCCustomizationEnabled)() ? undefined : $5fcfea28be9d4efe$var$PremiumBenefitsModalRenderer,
            showSpotlight: false,
            messageDescription: (0, $1i5tj.default).landingPagesNonPremiumDescription
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $T88uF.default), {
        id: "avatar-menu-hc-section-heading"
    }, formatMessage((0, $1i5tj.default).helpCenter)), customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(menu.customRenderer, {
            menu: menu
        }), menu.actionSubjectId === 'manageHelpCenterPages' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gvvtK.FireUIAnalytics), {
            action: "viewed",
            actionSubject: menu.actionSubjectId
        })));
        const SpotlightAnchor = menu.actionSubjectId === 'manageHelpCenter' ? (0, $dtoUQ.ProfileMenuUpdateSpotlight) : (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment;
        const renderMenuItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
                key: `hc-section-menu_${menu.actionSubjectId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(SpotlightAnchor, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
                component: $5fcfea28be9d4efe$var$CustomAnchor,
                href: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                iconAfter: menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                    appearance: "discovery"
                }, formatMessage((0, $1i5tj.default).premiumLozenge)),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation"
            }, menu.label)), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gvvtK.FireUIAnalytics), {
                action: "viewed",
                actionSubject: menu.actionSubjectId
            })));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8ULdj.default), {
            delay: 100,
            key: menu.actionSubjectId
        }, ()=>renderMenuItem());
        return renderMenuItem();
    }));
};
const $5fcfea28be9d4efe$var$UserProfileConnectActionLinks = (0, $g8fua.withDeferredWrmLoaded)($5fcfea28be9d4efe$export$a552d0e5a7a35aad, (0, $8qhwO.initializeConnect));
const $5fcfea28be9d4efe$var$AvatarMenuDumbV2 = (props)=>{
    // Reading the from useRouter even thought we are getting from props because
    // there is an unneccessary rerender happening in the component which is causing the Engagement client
    // to make an unnecessary start call
    // Keep useRouter hook call to preserve hook ordering
    (0, $7lAXH.useRouter)();
    const isHomepage = (props === null || props === void 0 ? void 0 : props.routeName) === 'help-center' || (props === null || props === void 0 ? void 0 : props.routeName) === 'view-homepage';
    (0, $6Nd92.useUFOComponentExperience)((0, $eQkdB.avatarMenuExperience));
    const isHelpCenterManagementScreen = (0, $diqlM.getRelativeBasePath)() === (0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const basePath = (0, $cf3fd.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(!!props.isOpen);
    const [isOpenedForUpdateSpotlight, setIsOpenedForUpdateSpotlight] = (0, $fc4bM.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $b52IZ.useQueryParams)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const isSmallScreen = window.innerWidth < (0, $lXJd8.sizes).xsmall;
    // Keep the hook call to preserve hook ordering
    (0, $3BZyK.useRelayEnvironment)();
    const onOpenChange = (0, $fc4bM.useCallback)((open)=>{
        setIsOpen(open);
        setIsOpenedForUpdateSpotlight(false);
        // if customize is true and experience is not set, clear customize from the queryParam
        if (!open && customize === 'true' && !experience) (0, $bzsGe.clearSidebarExperienceAndCustomize)();
    }, [
        customize,
        experience
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'avatarMenu',
            version: '2',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    // This state is used to track if the landing pages changeboarding spotlight has been viewed so that the avatar menu is not opened again on state change within same session of seeing change boarding spotlight.
    const [_, setAvatarMenuOpenedOnceForChangeboarding] = (0, $fc4bM.useState)(false);
    const content = ()=>{
        const { myRequestCount: myRequestCount, customMenuLinks: customMenuLinks, onLogoutClick: onLogoutClick, openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, routeName: routeName, pendingApprovalCount: pendingApprovalCount, approvalCount: approvalCount, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, avatarSrc: avatarSrc, displayName: displayName, email: email, hoistedProjectKey: hoistedProjectKey, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, jiraDisplayUrl: jiraDisplayUrl } = props;
        const isServiceHub = !!hoistedProjectKey;
        const virtualAgentAllowed = (0, $7VVXk.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        const showAvatarMenuItemsUpsells = (0, $7lN8e.getIsHCCustomizationEnabled)() || Boolean(hasSiteAdministerAccess);
        const showVirtualAgentMenu = !(0, $hN5YJ.isHideVsaEndpointsEnabled)() && canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && virtualAgentAllowed && (!hasSiteAdministerAccess || (0, $7lN8e.getIsHCCustomizationEnabled)());
        // Feature gate: jsm_help_center_one-click_rovo_agent
        // Rovo Agent menu is independent of VSA settings
        const rovoAgentAllowed = (0, $7VVXk.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent');
        const showRovoAgentMenu = canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && rovoAgentAllowed;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$Wrapper, {
            "aria-label": formatMessage((0, $1i5tj.default).tooltip),
            "data-testid": "avatar-menu-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gSOfb.default), {
            maxHeight: $5fcfea28be9d4efe$var$maxHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6oPaA.AccountDetails), {
            avatarSrc: avatarSrc,
            displayName: displayName,
            email: email
        }), $5fcfea28be9d4efe$var$TopMenu(myRequestCount || 0, onItemClick, pendingApprovalCount || 0, approvalCount || 0, isHelpCenterManagementScreen), !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, canAdministerJIRA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
            hasSeparator: !isSmallScreen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "ul",
            xcss: $5fcfea28be9d4efe$var$listItemStyles,
            key: "help-center-menu",
            // @ts-ignore - aria-label is valid for ul elements
            "aria-label": formatMessage((0, $1i5tj.default).helpCenterMenuOptions)
        }, !isSmallScreen && !isServiceHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$RenderHCSection, {
            showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells,
            onClick: onItemClick,
            jiraDisplayUrl: jiraDisplayUrl
        }), canCustomiseHelpCenter && (isHomepage || isServiceHub) && $5fcfea28be9d4efe$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub), showRovoAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: "customize-menu_rovo_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lEU2a.RovoAgentMenu), {
            onClose: onItemClick,
            component: $5fcfea28be9d4efe$var$CustomAnchor
        })), showVirtualAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ListItemWrapper, {
            key: "customize-menu_virtual_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2xdpH.VirtualAgentMenu), {
            onClose: onItemClick,
            component: $5fcfea28be9d4efe$var$CustomAnchor
        })))), customMenuLinks && customMenuLinks.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
            hasSeparator: customMenuLinks && customMenuLinks.length > 0
        }, (0, $hN5YJ.isWrmOptimizationsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$UserProfileConnectActionLinks, {
            customMenuLinks: customMenuLinks,
            onClose: onItemClick
        }) : $5fcfea28be9d4efe$var$buildCustomMenuLinks(customMenuLinks, onItemClick)) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$export$e0ae4b37130667df, {
            onClose: onItemClick
        })), $5fcfea28be9d4efe$var$menuBottomSection(onItemClick, isHelpCenterManagementScreen, onLogoutClick)), displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
            experience: (0, $eQkdB.avatarMenuExperience)
        }));
    };
    const Trigger = (0, $fc4bM.useCallback)((triggerProps)=>{
        const { avatarSrc: avatarSrc, disableAvatarMenu: disableAvatarMenu = false, pendingApprovalCount: pendingApprovalCount = 0, myRequestCount: myRequestCount = 0 } = props;
        const totalRequests = pendingApprovalCount + myRequestCount;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, !(0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && totalRequests > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$StyledAvatarBadge, null, totalRequests), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$ProfileContainer, {
            disabled: disableAvatarMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $byPAM.default), {
            name: (0, $9mazR.EngagementMessagesTarget).CHANGE_BOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $itdHE.Profile), {
            ...triggerProps,
            isDisabled: disableAvatarMenu,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWkQ8.default), {
                src: avatarSrc,
                borderColor: "var(--ds-border-inverse, #FFFFFF)"
            }),
            isSelected: isOpen,
            onClick: ()=>{
                onOpenChange(!isOpen);
            },
            "aria-label": formatMessage((0, $1i5tj.default).tooltip),
            tooltip: formatMessage((0, $1i5tj.default).tooltip),
            testId: "user-avatar-container-2"
        }))));
    }, [
        props,
        isOpen,
        formatMessage,
        onOpenChange
    ]);
    const renderDropdownMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5PQxp.default), {
            blanketIsTinted: true,
            onBlanketClicked: ()=>setAvatarMenuOpenedOnceForChangeboarding(true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asC5r.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
            isOpen: isOpen,
            // Opened on page load for the update spotlight, so don't take focus from the page.
            autoFocus: !isOpenedForUpdateSpotlight,
            shouldRenderToParent: true,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            zIndex: (0, $2SWSA.layers).modal(),
            content: content,
            trigger: Trigger,
            // This is required to close the open menu when clicking outside of the menu
            // A complex use case hence attaching a video of the same https://www.loom.com/share/95aa9f0112dd4e028194397e8dfeabea?sid=ef970902-843d-4b62-a578-3ec0f1f1b273
            // shouldUseCaptureOnOutsideClick
            key: 'avatar-menu-dumb-v2-popup'
        })));
    };
    // Mirrors when View all help centers, the update spotlight's anchor, is shown. The spotlight
    // tells admins to use the update tool, so it also needs help center migration.
    const isUpdateSpotlightEnabled = !!props.canAdministerJIRA && !isHelpCenterManagementScreen && !isSmallScreen && !props.hoistedProjectKey && (0, $k2M4v.default).checkGate('enable-help-hub-migration');
    const openForUpdateSpotlight = (0, $fc4bM.useCallback)(()=>{
        setIsOpen(true);
        setIsOpenedForUpdateSpotlight(true);
    }, []);
    const renderError = (0, $fc4bM.useCallback)((error)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eQkdB.AvatarMenuExperienceFailure), {
            message: error.message
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        onError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5fcfea28be9d4efe$var$AvatarMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dtoUQ.ProfileMenuUpdateSpotlightProvider), {
        isEnabled: isUpdateSpotlightEnabled,
        isMenuOpen: isOpen,
        onOpenMenu: openForUpdateSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3C7EO.ForgeModalContextProvider), {
        type: (0, $1HEEa.USER_MENU_ACTION_SECTION_MODULE)
    }, renderDropdownMenu(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g97N1.ForgeActionModule), {
        type: (0, $1HEEa.USER_MENU_ACTION_SECTION_MODULE),
        componentName: (0, $1HEEa.USER_MENU_ACTION_COMPONENT)
    })))));
};
$5fcfea28be9d4efe$var$AvatarMenuDumbV2.defaultProps = {
    customMenuLinks: []
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5fcfea28be9d4efe$var$AvatarMenuContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_u5f3u2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$NoUnderlineLink = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $io4o2.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$Wrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1tvnsw3": (0, $8xbhL.default)($fOCtI.multiple(29.25).px),
            "--_1rpxolo": (0, $8xbhL.default)($fOCtI.multiple(100).px)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1ul94vv4 _p12f15fr _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$StyledAvatarBadge = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $fTpep.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_kqswstnw _1ltvidpf _94n5idpf _1pby1kze",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$CustomLink = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = $5fcfea28be9d4efe$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_syaz261p _b8xz168b",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$CustomButton = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $MPQAF.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$CustomAnchor = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $g9mbo.HtmlAnchor), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz261p _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$ProfileContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "",
            __cmplp.disabled ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $5fcfea28be9d4efe$var$maxHeight = `calc(100vh - ${$fOCtI.multiple(24).px}`;
const $5fcfea28be9d4efe$var$customPressableStyles = (0, $kig2V.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $5fcfea28be9d4efe$var$listItemStyles = (0, $kig2V.xcss)({
    listStyleType: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
var $5fcfea28be9d4efe$export$2e2bcd8739ae039 = $5fcfea28be9d4efe$var$AvatarMenuDumbV2;

});
parcelRegister("fTpep", function(module, exports) {
$parcel$export(module.exports, "default", () => $fca4124f29979e5a$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
// This is the current styling of Badge in AtlasKit. It
// has been duplicated here since AtlasKit does not allow
// color styling at the moment.
// Changed to use atlaskit/badge once https://ecosystem.atlassian.net/browse/AK-4187 resolved
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $fca4124f29979e5a$var$ThemedBadge = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1s9354m-0"
})`background-color:${(props)=>`var(--ds-background-selected-bold, ${props.theme.color})`};border-radius:2em;color:${(props)=>props.theme.readableTextColor};display:inline-block;font-size:12px;font-weight:normal;line-height:1;min-width:1px;padding:0.16666666666667em ${"var(--ds-space-075, 6px)"};text-align:center;`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$fca4124f29979e5a$export$2e2bcd8739ae039 = $fca4124f29979e5a$var$ThemedBadge;

});

parcelRegister("8qhwO", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", () => $b81c570925c0e6ad$export$36d45daa6a4925b8);
$parcel$export(module.exports, "ConnectFragment", () => $b81c570925c0e6ad$export$aa8ab018415f92e4);
$parcel$export(module.exports, "ConnectFragmentDumb", () => $b81c570925c0e6ad$export$3cdf4f8c52fabf27);
$parcel$export(module.exports, "ConnectFragmentsDumb", () => $b81c570925c0e6ad$export$93e3ab580ab70dd6);

var $hN5YJ = parcelRequire("hN5YJ");

var $aYMdQ = parcelRequire("aYMdQ");

var $aIVqJ = parcelRequire("aIVqJ");

var $4MjGQ = parcelRequire("4MjGQ");

var $cfAtN = parcelRequire("cfAtN");

var $aeJDa = parcelRequire("aeJDa");

var $g8fua = parcelRequire("g8fua");

var $9Bdk5 = parcelRequire("9Bdk5");

var $1yEgh = parcelRequire("1yEgh");

var $dMBja = parcelRequire("dMBja");

var $04E2Q = parcelRequire("04E2Q");
const $b81c570925c0e6ad$export$36d45daa6a4925b8 = (0, $aYMdQ.once)(()=>{
    try {
        (0, $cfAtN.awaitGlobal)('connectHost', (0, $aeJDa.default));
    } catch (e) {
        (0, $aIVqJ.trackError)('connect.fragment.init.failed', {}, e);
        (0, $4MjGQ.operationalEvent)({
            action: 'failed',
            actionSubject: 'connectFragmentInit',
            source: 'unknownSource',
            attributes: {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                errorMessage: e.message
            }
        });
    }
});
const $b81c570925c0e6ad$export$aa8ab018415f92e4 = (0, $hN5YJ.isWrmOptimizationsEnabled)() ? (0, $g8fua.withDeferredWrmLoaded)((0, $dMBja.default), $b81c570925c0e6ad$export$36d45daa6a4925b8) : (0, $dMBja.default);
const $b81c570925c0e6ad$export$3cdf4f8c52fabf27 = (0, $hN5YJ.isWrmOptimizationsEnabled)() ? (0, $g8fua.withDeferredWrmLoaded)((0, $9Bdk5.default), $b81c570925c0e6ad$export$36d45daa6a4925b8) : (0, $9Bdk5.default);
const $b81c570925c0e6ad$export$93e3ab580ab70dd6 = (0, $hN5YJ.isWrmOptimizationsEnabled)() ? (0, $g8fua.withDeferredWrmLoaded)((0, $1yEgh.default), $b81c570925c0e6ad$export$36d45daa6a4925b8) : (0, $1yEgh.default);

});
parcelRegister("g8fua", function(module, exports) {
$parcel$export(module.exports, "withDeferredWrmLoaded", () => $b1d0bbb7a28fe120$export$ae0e017d29ba244d);

var $fc4bM = parcelRequire("fc4bM");

var $9QSw4 = parcelRequire("9QSw4");
const $b1d0bbb7a28fe120$export$ae0e017d29ba244d = (Component, onLoad)=>{
    const ComponentWithDeferredWrmLoaded = (props)=>{
        const { resourcesLoaded: resourcesLoaded } = $fc4bM.useContext((0, $9QSw4.DeferredWrmResourceContext));
        $fc4bM.useEffect(()=>{
            if (resourcesLoaded) onLoad();
        }, [
            resourcesLoaded
        ]);
        if (!resourcesLoaded) return null;
        return /*#__PURE__*/ $fc4bM.createElement(Component, props);
    };
    return ComponentWithDeferredWrmLoaded;
};

});

parcelRegister("dMBja", function(module, exports) {
$parcel$export(module.exports, "default", () => $59bb5cb495e09c55$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("lgOtA");
var $03HuP = parcelRequire("03HuP");

var $hwMna = parcelRequire("hwMna");
parcelRequire("1Qg1o");
var $auzgq = parcelRequire("auzgq");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $04E2Q = parcelRequire("04E2Q");
const $59bb5cb495e09c55$var$selector = (0, $2n2bS.createSelector)((state, componentProps)=>{
    const { page: page, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = componentProps;
    const projectId = state ? (0, $9D9SX.getProjectId)(state, portalId) : undefined;
    const connectFragments = (0, $auzgq.getConnectAddonPanels)({
        state: state,
        location: location,
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey,
        pageName: page
    });
    return {
        connectFragments: connectFragments,
        projectId: projectId
    };
}, (props)=>props);
const $59bb5cb495e09c55$var$ConnectFragmentWithAnalytics = (0, $613oU.default)({
    componentName: 'ConnectFragment'
})((0, $azARG.default)({})((0, $04E2Q.ConnectFragment)));
var $59bb5cb495e09c55$export$2e2bcd8739ae039 = (0, $6umft.default)($59bb5cb495e09c55$var$selector, {
    fetchConnectFragments: (0, $03HuP.fetchConnectFragmentsAction),
    ...(0, $hwMna.mapConnectDispatchToPropsBanner)
})($59bb5cb495e09c55$var$ConnectFragmentWithAnalytics);

});
parcelRegister("1Qg1o", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => (parcelRequire("auzgq")).getConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => (parcelRequire("auzgq")).getProfileConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => (parcelRequire("auzgq")).getProfileConnectAddonActions);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => (parcelRequire("auzgq")).getRequestSpecificConnectAddonPanels);
$parcel$export(module.exports, "isConnectFragmentsResolved", () => (parcelRequire("auzgq")).isConnectFragmentsResolved);

var $auzgq = parcelRequire("auzgq");

});
parcelRegister("auzgq", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => $406e263f24bbb91c$export$be753636105743d4);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => $406e263f24bbb91c$export$5d04f04eeff342cb);
$parcel$export(module.exports, "isConnectFragmentsResolved", () => $406e263f24bbb91c$export$f5f011115184d299);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => $406e263f24bbb91c$export$e91bb9a5dede3485);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => $406e263f24bbb91c$export$43a1e23f8855f249);
parcelRequire("2PtML");
var $fxrKs = parcelRequire("fxrKs");
const $406e263f24bbb91c$export$be753636105743d4 = ({ state: state, pageName: pageName, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>{
    switch(location){
        case 'detailsPanels':
        case 'optionPanels':
            return $406e263f24bbb91c$export$5d04f04eeff342cb({
                state: state,
                location: location,
                requestKey: requestKey
            });
        default:
            {
                const page = state.persisted.connectFragments[(0, $fxrKs.generateKey)(pageName, portalId, requestTypeId, requestKey)];
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return page && page[location];
            }
    }
};
const $406e263f24bbb91c$export$5d04f04eeff342cb = ({ state: state, location: location, requestKey: requestKey })=>{
    const requestDetailsForKey = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    requestKey && state && state.persisted && state.persisted.requestDetails[requestKey];
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return requestDetailsForKey ? requestDetailsForKey[location] : [];
};
const $406e263f24bbb91c$export$f5f011115184d299 = ({ state: state, pageName: pageName, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>{
    const page = state.persisted.connectFragments[(0, $fxrKs.generateKey)(pageName, portalId, requestTypeId, requestKey)];
    if (!page) return false;
    if ('error' in page) return true;
    return 'headerPanels' in page || 'subheaderPanels' in page || 'footerPanels' in page || 'propertyPanels' in page;
};
const $406e263f24bbb91c$export$e91bb9a5dede3485 = (state)=>{
    return state.persisted.profileWebFragments.panels;
};
const $406e263f24bbb91c$export$43a1e23f8855f249 = (state)=>{
    return state.persisted.profileWebFragments.actions;
};

});




parcelRegister("5ryST", function(module, exports) {
$parcel$export(module.exports, "default", () => $03e63982d2291984$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $5Nd2Y = parcelRequire("5Nd2Y");

var $caiWY = parcelRequire("caiWY");
const $03e63982d2291984$export$25215e4c8f710ceb = ({ coordinationClient: coordinationClient, messageId: messageId, children: children })=>{
    if (!coordinationClient) return null;
    return /*#__PURE__*/ $fc4bM.createElement((0, $5Nd2Y.default), {
        client: coordinationClient,
        messageId: messageId
    }, children);
};
var $03e63982d2291984$export$2e2bcd8739ae039 = (0, $caiWY.withCoordinationClient)($03e63982d2291984$export$25215e4c8f710ceb);

});
parcelRegister("5Nd2Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $431d611b6d10238a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
class $431d611b6d10238a$export$2e2bcd8739ae039 extends (0, $fc4bM.PureComponent) {
    static #_ = this.defaultProps = {
        fallback: null
    };
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $fc4bM.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});


parcelRegister("g97N1", function(module, exports) {
$parcel$export(module.exports, "ForgeActionModule", () => $f834a545f317a925$export$3f817dccc12b0bb3);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $f834a545f317a925$export$3f817dccc12b0bb3 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("j3qDW")), {
        moduleId: "./packages/common-utils/forge-action/src/forge-action.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("j3qDW", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("zu3lW"),
    $9dnsd("4DHcp")
]).then(()=>parcelRequire('aXKIU'));

});


parcelRegister("js98a", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContext", () => $796736804c9ffb11$export$7ec9d631dd0c629a);
$parcel$export(module.exports, "ForgeModalContextConsumer", () => $796736804c9ffb11$export$15f67e1b244563e3);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");
const $796736804c9ffb11$export$7ec9d631dd0c629a = /*#__PURE__*/ $fc4bM.createContext({
    data: {
        extensions: new Map(),
        extensionToDisplay: '',
        extensionTitles: []
    },
    methods: {
        setExtensionToDisplay: (0, $aYMdQ.noop)
    }
});
$796736804c9ffb11$export$7ec9d631dd0c629a.displayName = 'ForgeModalContext';
const $796736804c9ffb11$export$15f67e1b244563e3 = $796736804c9ffb11$export$7ec9d631dd0c629a.Consumer;

});

parcelRegister("3C7EO", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContextProvider", () => $e48bf26f1c5f5289$export$35485b69e4da19ba);

var $8PITw = parcelRequire("8PITw");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $e48bf26f1c5f5289$export$35485b69e4da19ba = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("kN7P6")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/modal-context-provider/modal-context-provider.tsx"
    }),
    LoadingSkeleton: (0, $8PITw.AvatarLoadingSkeleton)
});

});
parcelRegister("kN7P6", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("9Xz2D").then(()=>parcelRequire('g0Wz1'));

});


parcelRegister("8ULdj", function(module, exports) {
$parcel$export(module.exports, "default", () => $44346732d6928723$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
class $44346732d6928723$export$2e2bcd8739ae039 extends $fc4bM.Component {
    componentDidMount() {
        const renderNextAnimationFrame = ()=>{
            window.requestAnimationFrame(()=>{
                window.requestAnimationFrame(()=>{
                    this.setState({
                        render: true
                    });
                });
            });
        };
        if (this.props.delay) window.setTimeout(renderNextAnimationFrame, this.props.delay);
        else renderNextAnimationFrame();
    }
    render() {
        return this.state.render ? this.props.children() : null;
    }
    constructor(...args){
        super(...args), this.state = {
            render: false
        };
    }
}

});

parcelRegister("6geXm", function(module, exports) {
$parcel$export(module.exports, "VaOnboardingSpotlight", () => $db740fe06bbdd664$export$9900d5bc23cb734);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $db740fe06bbdd664$export$9900d5bc23cb734 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("7JBuU")), {
        moduleId: "./packages/common-utils/va-reporting-onboarding/src/va-reporting-onboarding.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("7JBuU", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("keANI"),
    $9dnsd("3c0Ij"),
    $9dnsd("6YBny")
]).then(()=>parcelRequire('eYcA1'));

});


parcelRegister("itdHE", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $c965d654a732ed9d$export$5120f2d0b8d4cab8);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lWnWg = parcelRequire("lWnWg");
const $c965d654a732ed9d$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lWnWg.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("lWnWg", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $3d3a2685811ad44c$export$c25acd513dcc8062);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $k7lry = parcelRequire("k7lry");

var $bcTS3 = parcelRequire("bcTS3");

var $2vZS1 = parcelRequire("2vZS1");

var $2t4SO = parcelRequire("2t4SO");
const $3d3a2685811ad44c$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $2vZS1.useTheme)();
    const button = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k7lry.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $2t4SO.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});

});
parcelRegister("2vZS1", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $9d33661ffb64ba1d$export$93d4e7f90805808f);

var $fc4bM = parcelRequire("fc4bM");

var $bWIV7 = parcelRequire("bWIV7");
const $9d33661ffb64ba1d$export$93d4e7f90805808f = ()=>(0, $fc4bM.useContext)((0, $bWIV7.ThemeContext));

});
parcelRegister("bWIV7", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $921c7c15cb944271$export$2c657da244d00bd6);

var $fc4bM = parcelRequire("fc4bM");

var $cafSq = parcelRequire("cafSq");
const $921c7c15cb944271$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $fc4bM.createContext)((0, $cafSq.defaultTheme));

});
parcelRegister("cafSq", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $076d89401817b957$export$164de7ab8df77ef0);

var $gkUZy = parcelRequire("gkUZy");
const $076d89401817b957$export$164de7ab8df77ef0 = (0, $gkUZy.atlassianTheme);

});
parcelRegister("gkUZy", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $7e84d98557af4894$export$eeee8619e1b91cb0);

var $lWGGD = parcelRequire("lWGGD");

var $4ZDJC = parcelRequire("4ZDJC");
const $7e84d98557af4894$export$eeee8619e1b91cb0 = (0, $4ZDJC.generateTheme)({
    name: (0, $lWGGD.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});
parcelRegister("lWGGD", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $719a5427b82e2c40$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $719a5427b82e2c40$export$2e2bcd8739ae039);
const $719a5427b82e2c40$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $719a5427b82e2c40$var$defaultThemeCopy = JSON.parse(JSON.stringify($719a5427b82e2c40$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$719a5427b82e2c40$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$719a5427b82e2c40$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $719a5427b82e2c40$export$2491e13b198e597d = 'atlassian';
var $719a5427b82e2c40$export$2e2bcd8739ae039 = $719a5427b82e2c40$var$defaultTheme;

});

parcelRegister("4ZDJC", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $00f48de8ad53f8a8$export$2e4ecffaca289a18);

var $lWGGD = parcelRequire("lWGGD");

var $eHkOw = parcelRequire("eHkOw");

var $9GRMW = parcelRequire("9GRMW");

var $1Fyf1 = parcelRequire("1Fyf1");

var $2tSvT = parcelRequire("2tSvT");

var $fHeCl = parcelRequire("fHeCl");
const $00f48de8ad53f8a8$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $00f48de8ad53f8a8$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $00f48de8ad53f8a8$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $fHeCl.hexToRGBA)(backgroundColor, 0.65) : (0, $2tSvT.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $1Fyf1.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $1Fyf1.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $fHeCl.hexToRGBA)(backgroundColor, 0.8) : (0, $2tSvT.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $1Fyf1.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $2tSvT.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $1Fyf1.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $2tSvT.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $1Fyf1.getBoxShadow)('transparent')
        }
    };
};
const $00f48de8ad53f8a8$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $9GRMW.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $00f48de8ad53f8a8$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $9GRMW.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $lWGGD.DEFAULT_THEME_NAME)) return 0, $eHkOw.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $00f48de8ad53f8a8$var$generateButtonCSSStates($00f48de8ad53f8a8$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $00f48de8ad53f8a8$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $00f48de8ad53f8a8$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $fHeCl.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $fHeCl.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $fHeCl.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $1Fyf1.getBoxShadow)((0, $fHeCl.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $2tSvT.getContrastColor)(0.1, $00f48de8ad53f8a8$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("eHkOw", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $135cbbecb878f1d2$export$77823bc9863eaa03);

var $lWGGD = parcelRequire("lWGGD");
const $135cbbecb878f1d2$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $lWGGD.default)));
const $135cbbecb878f1d2$export$77823bc9863eaa03 = $135cbbecb878f1d2$var$defaultThemeCopy;

});

parcelRegister("9GRMW", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $a901ed9bec68f01d$export$10a10e7cd1193377);

var $6btXR = parcelRequire("6btXR");

var $dSZAy = parcelRequire("dSZAy");
const $a901ed9bec68f01d$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $dSZAy.convertHexShorthand)(color);
    return (0, $6btXR.default).contrastRatio(converted).hex;
};

});
parcelRegister("6btXR", function(module, exports) {
$parcel$export(module.exports, "default", () => $480b03817cca11b4$export$2e2bcd8739ae039);
function $480b03817cca11b4$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $480b03817cca11b4$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $480b03817cca11b4$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $480b03817cca11b4$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $480b03817cca11b4$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $480b03817cca11b4$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $480b03817cca11b4$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $480b03817cca11b4$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $480b03817cca11b4$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $480b03817cca11b4$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $480b03817cca11b4$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $480b03817cca11b4$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $480b03817cca11b4$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $480b03817cca11b4$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $480b03817cca11b4$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $480b03817cca11b4$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $480b03817cca11b4$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $480b03817cca11b4$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $480b03817cca11b4$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $480b03817cca11b4$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $480b03817cca11b4$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $480b03817cca11b4$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $480b03817cca11b4$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $480b03817cca11b4$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $480b03817cca11b4$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $480b03817cca11b4$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $480b03817cca11b4$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $480b03817cca11b4$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $480b03817cca11b4$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $480b03817cca11b4$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $480b03817cca11b4$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $480b03817cca11b4$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $480b03817cca11b4$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $480b03817cca11b4$var$fromHex_1 = $480b03817cca11b4$var$fromHex, $480b03817cca11b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $480b03817cca11b4$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $480b03817cca11b4$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $480b03817cca11b4$var$fromRgb_1 = $480b03817cca11b4$var$fromRgb, $480b03817cca11b4$var$fromCssRgb_1 = $480b03817cca11b4$var$fromCssRgb, $480b03817cca11b4$var$fromHsl_1 = $480b03817cca11b4$var$fromHsl, $480b03817cca11b4$var$fromCssHsl_1 = $480b03817cca11b4$var$fromCssHsl, $480b03817cca11b4$var$fromHsv_1 = $480b03817cca11b4$var$fromHsv, $480b03817cca11b4$var$fromCmyk_1 = $480b03817cca11b4$var$fromCmyk, $480b03817cca11b4$var$fromYiq_1 = $480b03817cca11b4$var$fromYiq, $480b03817cca11b4$var$fromXYZ_1 = $480b03817cca11b4$var$fromXYZ, $480b03817cca11b4$var$fromxyY_1 = $480b03817cca11b4$var$fromxyY, $480b03817cca11b4$var$fromLms_1 = $480b03817cca11b4$var$fromLms, $480b03817cca11b4$var$fromCieLab_1 = $480b03817cca11b4$var$fromCieLab, $480b03817cca11b4$var$fromCieLuv_1 = $480b03817cca11b4$var$fromCieLuv, $480b03817cca11b4$var$fromCieLch_1 = $480b03817cca11b4$var$fromCieLch, $480b03817cca11b4$var$fromHsluv = $480b03817cca11b4$var$fromCieLch$1, $480b03817cca11b4$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $480b03817cca11b4$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $480b03817cca11b4$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $480b03817cca11b4$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $480b03817cca11b4$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $480b03817cca11b4$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $480b03817cca11b4$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $480b03817cca11b4$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $480b03817cca11b4$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $480b03817cca11b4$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $480b03817cca11b4$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $480b03817cca11b4$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $480b03817cca11b4$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $480b03817cca11b4$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $480b03817cca11b4$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $480b03817cca11b4$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $480b03817cca11b4$var$fromHsluv
    }
}, $480b03817cca11b4$var$adapt_1 = $480b03817cca11b4$var$adapt, $480b03817cca11b4$var$adjacent_1 = $480b03817cca11b4$var$adjacent, $480b03817cca11b4$var$brightness_1 = $480b03817cca11b4$var$brightness, $480b03817cca11b4$var$complementary_1 = $480b03817cca11b4$var$complementary, $480b03817cca11b4$var$contrast_1 = $480b03817cca11b4$var$contrast, $480b03817cca11b4$var$contrastRatio_1 = $480b03817cca11b4$var$contrastRatio, $480b03817cca11b4$var$convert_1 = $480b03817cca11b4$var$convert, $480b03817cca11b4$var$difference_1 = $480b03817cca11b4$var$difference, $480b03817cca11b4$var$fade_1 = $480b03817cca11b4$var$fade, $480b03817cca11b4$var$greyscale_1 = $480b03817cca11b4$var$greyscale, $480b03817cca11b4$var$hue_1 = $480b03817cca11b4$var$hue, $480b03817cca11b4$var$invert_1 = $480b03817cca11b4$var$invert, $480b03817cca11b4$var$invertLightness_1 = $480b03817cca11b4$var$invertLightness, $480b03817cca11b4$var$mid_1 = $480b03817cca11b4$var$mid, $480b03817cca11b4$var$multiply_1 = $480b03817cca11b4$var$multiply, $480b03817cca11b4$var$saturation_1 = $480b03817cca11b4$var$saturation, $480b03817cca11b4$var$sepia_1 = $480b03817cca11b4$var$sepia, $480b03817cca11b4$var$shade_1 = $480b03817cca11b4$var$shade, $480b03817cca11b4$var$temperature_1 = $480b03817cca11b4$var$temperature, $480b03817cca11b4$var$tetrad_1 = $480b03817cca11b4$var$tetrad, $480b03817cca11b4$var$triad_1 = $480b03817cca11b4$var$triad, $480b03817cca11b4$var$index$2 = {
    adapt: $480b03817cca11b4$var$adapt_1,
    adjacent: $480b03817cca11b4$var$adjacent_1,
    brightness: $480b03817cca11b4$var$brightness_1,
    complementary: $480b03817cca11b4$var$complementary_1,
    contrast: $480b03817cca11b4$var$contrast_1,
    contrastRatio: $480b03817cca11b4$var$contrastRatio_1,
    convert: $480b03817cca11b4$var$convert_1,
    difference: $480b03817cca11b4$var$difference_1,
    fade: $480b03817cca11b4$var$fade_1,
    greyscale: $480b03817cca11b4$var$greyscale_1,
    hue: $480b03817cca11b4$var$hue_1,
    invert: $480b03817cca11b4$var$invert_1,
    invertLightness: $480b03817cca11b4$var$invertLightness_1,
    mid: $480b03817cca11b4$var$mid_1,
    multiply: $480b03817cca11b4$var$multiply_1,
    saturation: $480b03817cca11b4$var$saturation_1,
    sepia: $480b03817cca11b4$var$sepia_1,
    shade: $480b03817cca11b4$var$shade_1,
    temperature: $480b03817cca11b4$var$temperature_1,
    tetrad: $480b03817cca11b4$var$tetrad_1,
    triad: $480b03817cca11b4$var$triad_1
}, $480b03817cca11b4$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $480b03817cca11b4$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $480b03817cca11b4$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($480b03817cca11b4$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $480b03817cca11b4$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($480b03817cca11b4$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $480b03817cca11b4$var$api_1 = $480b03817cca11b4$var$api, $480b03817cca11b4$var$helpers = {
    getIlluminant: function(r) {
        return $480b03817cca11b4$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $480b03817cca11b4$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $480b03817cca11b4$var$index)if ($480b03817cca11b4$var$index.hasOwnProperty(e) && $480b03817cca11b4$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $480b03817cca11b4$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $480b03817cca11b4$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $480b03817cca11b4$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $480b03817cca11b4$var$constants, s));
            default:
                return null;
        }
    }
}, $480b03817cca11b4$var$helpers_1 = $480b03817cca11b4$var$helpers, $480b03817cca11b4$var$dependencies = {
    conversions: $480b03817cca11b4$var$index,
    operations: $480b03817cca11b4$var$index$2,
    helpers: $480b03817cca11b4$var$helpers_1
}, $480b03817cca11b4$var$entry = $480b03817cca11b4$var$api_1($480b03817cca11b4$var$dependencies, $480b03817cca11b4$var$constants);
var $480b03817cca11b4$export$2e2bcd8739ae039 = $480b03817cca11b4$var$entry;

});

parcelRegister("dSZAy", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $bef590469c692668$export$db8d2130677f868c);
const $bef590469c692668$var$hex = '[a-z0-9]';
const $bef590469c692668$var$shortHandHexColorPattern = new RegExp(`#(${$bef590469c692668$var$hex})(${$bef590469c692668$var$hex})(${$bef590469c692668$var$hex})`, 'i');
const $bef590469c692668$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $bef590469c692668$var$isShortHexColor = (color)=>color && color.length === 4;
const $bef590469c692668$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$bef590469c692668$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $bef590469c692668$var$completeTriplet = (colors)=>`#${$bef590469c692668$var$repeat(colors[1], 6)}`;
const $bef590469c692668$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $bef590469c692668$export$db8d2130677f868c = (color)=>{
    if ($bef590469c692668$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($bef590469c692668$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($bef590469c692668$var$isTriplet(colors)) return $bef590469c692668$var$completeTriplet(colors);
            else return $bef590469c692668$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("1Fyf1", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $a66658a533a4c423$export$bba5a971afe05444);
const $a66658a533a4c423$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("2tSvT", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $806993a633038eb5$export$77a1051494882576);

var $6btXR = parcelRequire("6btXR");

var $fHeCl = parcelRequire("fHeCl");
const $806993a633038eb5$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $fHeCl.hexToRGBA)((0, $6btXR.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("fHeCl", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $39754fcdfebe18af$export$7229be6d7219ee6a);

var $6btXR = parcelRequire("6btXR");
const $39754fcdfebe18af$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $6btXR.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});







parcelRegister("2t4SO", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", () => $a9e54ccb4feb048e$export$f32bddcb857301f3);
const $a9e54ccb4feb048e$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("euRd1", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc0ea98c2fb0dc2b$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $9wELi = parcelRequire("9wELi");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $bc0ea98c2fb0dc2b$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $bc0ea98c2fb0dc2b$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $bc0ea98c2fb0dc2b$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $bc0ea98c2fb0dc2b$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $bc0ea98c2fb0dc2b$var$LegacyLozenge = /*#__PURE__*/ (0, $fc4bM.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $fc4bM.useMemo)(()=>$bc0ea98c2fb0dc2b$var$appearanceTypes.includes(appearance) || $bc0ea98c2fb0dc2b$var$newSemanticColors.includes(appearance) ? $bc0ea98c2fb0dc2b$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $bc0ea98c2fb0dc2b$var$styles.container,
            $bc0ea98c2fb0dc2b$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $bc0ea98c2fb0dc2b$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $bc0ea98c2fb0dc2b$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            style: {
                color: style === null || style === void 0 ? void 0 : style.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $2R2iS.default)([
                $bc0ea98c2fb0dc2b$var$styles.text,
                $bc0ea98c2fb0dc2b$var$styles.customLetterspacing,
                $bc0ea98c2fb0dc2b$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$bc0ea98c2fb0dc2b$var$LegacyLozenge.displayName = 'Lozenge';
var $bc0ea98c2fb0dc2b$export$2e2bcd8739ae039 = (0, $9wELi.default);

});
parcelRegister("9wELi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4de7b341858d8d7$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5O5Ib = parcelRequire("5O5Ib");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $d4de7b341858d8d7$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5O5Ib.default), {
        ...baseProps,
        children: children
    });
};
$d4de7b341858d8d7$var$Lozenge.displayName = 'Lozenge';
var $d4de7b341858d8d7$export$2e2bcd8739ae039 = $d4de7b341858d8d7$var$Lozenge;

});
parcelRegister("5O5Ib", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0499865b057bd05$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7d9ex = parcelRequire("7d9ex");

var $4Cnkn = parcelRequire("4Cnkn");

var $9kfe7 = parcelRequire("9kfe7");

var $13zmE = parcelRequire("13zmE");

var $6pO2N = parcelRequire("6pO2N");

var $dRkX9 = parcelRequire("dRkX9");

var $l3fZT = parcelRequire("l3fZT");

var $hculA = parcelRequire("hculA");

var $eoYlg = parcelRequire("eoYlg");

var $h5k6q = parcelRequire("h5k6q");

var $9UFJM = parcelRequire("9UFJM");
// Get the pressed background color for the selected lozenge dropdown trigger
const $d0499865b057bd05$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $d0499865b057bd05$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
const $d0499865b057bd05$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $d0499865b057bd05$var$LozengeBase = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const enableTruncationFixFG = (0, $dRkX9.fg)('platform-dst-motion-lozenge-truncation-fix');
    const [resizing, setResizing] = (0, $fc4bM.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $fc4bM.useState)(false);
    const textRef = (0, $fc4bM.useRef)(null);
    const onFinishMotion = ()=>setResizing(false);
    // `onStartMotion` fires while the element is at its natural layout, just before the resize
    // animation starts, this allows us to calculate whether the text will be truncated at its
    // final state
    const onStartMotion = ()=>{
        const textElement = textRef.current;
        if (textElement) setIsTruncated(textElement.scrollWidth > textElement.clientWidth);
    };
    const resizingWidth = (0, $6pO2N.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion,
        onStartMotion: enableTruncationFixFG ? onStartMotion : undefined
    });
    const isInitialRender = (0, $fc4bM.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $9UFJM.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $eoYlg.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $9UFJM.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $9kfe7.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $dRkX9.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ (0, $3LM7S.jsxs)("span", {
        "data-testid": testId ? `${testId}--content` : undefined,
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $2R2iS.default)([
            $d0499865b057bd05$var$styles.content,
            spacing === 'spacious' && $d0499865b057bd05$var$styles.contentSpacious,
            isInteractive && $d0499865b057bd05$var$styles.loadingMotion,
            isLoading && $d0499865b057bd05$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $d0499865b057bd05$var$styles.maxWidth
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $h5k6q.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                ref: textRef,
                style: {
                    // The text fills 100% of the inner content wrapper. The container's
                    // own max-width (set on the container via commonStyleOverrides) handles
                    // the actual size constraint, so the text just needs to fill the available
                    // space and truncate when it overflows.
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style === null || style === void 0 ? void 0 : style.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $2R2iS.default)([
                    $d0499865b057bd05$var$styles.text,
                    enableMotionFG && resizing && (enableTruncationFixFG ? !isTruncated : // Clip during animating width changes, but not when a maxWidth is specified
                    !maxWidth) ? $d0499865b057bd05$var$styles.textClip : $d0499865b057bd05$var$styles.textEllipsis,
                    spacing === 'spacious' && $d0499865b057bd05$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $2R2iS.default)([
                    $d0499865b057bd05$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7d9ex.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $l3fZT.default), {
        ref: ref,
        xcss: (0, $4Cnkn.cx)($d0499865b057bd05$var$styles.container, !isLoading ? $d0499865b057bd05$var$interactiveMotionStyles.motion : enableMotionFG && $d0499865b057bd05$var$styles.motionContainer, spacing === 'spacious' && $d0499865b057bd05$var$styles.containerSpacious, !isSelected && $d0499865b057bd05$var$styles.iconBorderFilter, $d0499865b057bd05$var$styles[colorStyleKey], !isLoading && $d0499865b057bd05$var$styles[interactiveStyleKey], hasTrailingMetric && $d0499865b057bd05$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $d0499865b057bd05$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $d0499865b057bd05$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        },
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                "data-testid": testId ? `${testId}--loading-overlay` : undefined,
                className: (0, $2R2iS.default)([
                    $d0499865b057bd05$var$styles.loadingOverlay,
                    $d0499865b057bd05$var$styles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $d0499865b057bd05$var$styles.container,
            spacing === 'spacious' && $d0499865b057bd05$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $d0499865b057bd05$var$styles.containerBadgePadding,
            $d0499865b057bd05$var$styles[colorStyleKey],
            $d0499865b057bd05$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $d0499865b057bd05$var$styles.containerBadgeNeutralAppearance
        ]),
        children: innerContent
    });
}));
var $d0499865b057bd05$export$2e2bcd8739ae039 = $d0499865b057bd05$var$LozengeBase;

});
parcelRegister("7d9ex", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0039f44d004df92$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $k8Adr = parcelRequire("k8Adr");

var $anluN = parcelRequire("anluN");

var $ciiOL = parcelRequire("ciiOL");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
const $b0039f44d004df92$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $b0039f44d004df92$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $ciiOL.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ const $b0039f44d004df92$var$BadgeNew = /*#__PURE__*/ (0, $fc4bM.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2R2iS.default)([
            $b0039f44d004df92$var$stylesNew.root,
            $b0039f44d004df92$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $b0039f44d004df92$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $b0039f44d004df92$export$2e2bcd8739ae039 = $b0039f44d004df92$var$BadgeNew;

});
parcelRegister("anluN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "useThemeObserver", () => $cacdef2583776d3f$export$3dd7971102e44fa8);

var $fc4bM = parcelRequire("fc4bM");

var $hvzwL = parcelRequire("hvzwL");

var $2cpQq = parcelRequire("2cpQq");
const $cacdef2583776d3f$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $fc4bM.useState)((0, $hvzwL.getGlobalTheme)());
    (0, $fc4bM.useEffect)(()=>{
        const observer = new (0, $2cpQq.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $cacdef2583776d3f$export$2e2bcd8739ae039 = $cacdef2583776d3f$export$3dd7971102e44fa8;

});

parcelRegister("ciiOL", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $4abe8eb7fd949584$export$7c4d25c0c3217d8c);
function $4abe8eb7fd949584$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $4abe8eb7fd949584$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $4abe8eb7fd949584$var$getSafeValue(value);
    const safeMax = $4abe8eb7fd949584$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("6pO2N", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $10af67a75fb77f17$export$a300664a1a230956);

var $fc4bM = parcelRequire("fc4bM");

var $kUMs0 = parcelRequire("kUMs0");

var $iGr40 = parcelRequire("iGr40");

var $1JUTA = parcelRequire("1JUTA");

var $1pnHp = parcelRequire("1pnHp");

var $8Xjx2 = parcelRequire("8Xjx2");

var $157Yz = parcelRequire("157Yz");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $10af67a75fb77f17$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $10af67a75fb77f17$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $10af67a75fb77f17$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $10af67a75fb77f17$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $fc4bM.useRef)();
    const [element, setElementRef] = (0, $iGr40.useElementRef)();
    const setTimeout = (0, $8Xjx2.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $1pnHp.useRequestAnimationFrame)();
    (0, $157Yz.useSnapshotBeforeUpdate)(()=>{
        if ((0, $kUMs0.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $1JUTA.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $kUMs0.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$10af67a75fb77f17$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion === null || onStartMotion === void 0 || onStartMotion();
        const propertyList = $10af67a75fb77f17$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $10af67a75fb77f17$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});

parcelRegister("l3fZT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Pressable", () => $0a5f8ea40e8add41$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $0a5f8ea40e8add41$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $fVzQQ = parcelRequire("fVzQQ");

var $6sDmn = parcelRequire("6sDmn");

var $d8xIF = parcelRequire("d8xIF");

var $8nNtm = parcelRequire("8nNtm");

var $aVlMc = parcelRequire("aVlMc");

var $hg0W2 = parcelRequire("hg0W2");

var $gkD7x = parcelRequire("gkD7x");
function $0a5f8ea40e8add41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $0a5f8ea40e8add41$var$focusRingStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $d8xIF.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $gkD7x.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $8nNtm.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $8nNtm.borderWidthMap)['border.width']} solid`
        }
    }
});
const $0a5f8ea40e8add41$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $0a5f8ea40e8add41$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $0a5f8ea40e8add41$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $0a5f8ea40e8add41$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $9JZL9.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $hg0W2.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $jctmk.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $0a5f8ea40e8add41$var$baseStyles,
            $0a5f8ea40e8add41$var$focusRingStyles,
            isDisabled ? $0a5f8ea40e8add41$var$disabledStyles : $0a5f8ea40e8add41$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $6sDmn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $aVlMc.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $aVlMc.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $aVlMc.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $aVlMc.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $aVlMc.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $aVlMc.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $aVlMc.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0a5f8ea40e8add41$export$2e2bcd8739ae039 = $0a5f8ea40e8add41$export$27c701ed9e449e99;

});

parcelRegister("eoYlg", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $1e6941b211db114c$export$a3fc04b8551e006a);
const $1e6941b211db114c$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("h5k6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $358c700d563ef9de$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $358c700d563ef9de$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $358c700d563ef9de$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ const $358c700d563ef9de$var$IconRenderer = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $358c700d563ef9de$var$getIconColor(color);
    return (0, $dRkX9.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $358c700d563ef9de$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$358c700d563ef9de$export$2e2bcd8739ae039 = $358c700d563ef9de$var$IconRenderer;

});

parcelRegister("9UFJM", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $d74c623b9b47ae90$export$acf5d2b7dc999bda);
// Map legacy appearance to new color values
const $d74c623b9b47ae90$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $d74c623b9b47ae90$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $d74c623b9b47ae90$var$legacyAppearanceMap[appearance] ?? appearance;
};

});




parcelRegister("bKfoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d9e9ba45fd707e$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fVzQQ = parcelRequire("fVzQQ");

var $8SiHp = parcelRequire("8SiHp");
const $03d9e9ba45fd707e$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * @deprecated
 * CustomItem must not be used and will be deleted soon. Custom menu items are not supported.
 * Use ButtonItem or LinkItem instead. If you need a custom list item, do not use `@atlaskit/menu`.
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $03d9e9ba45fd707e$var$CustomItem = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8SiHp.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $03d9e9ba45fd707e$var$preventEvent
                },
                onMouseDown: isDisabled ? $03d9e9ba45fd707e$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $03d9e9ba45fd707e$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined,
                children: children
            })
    });
}));
var $03d9e9ba45fd707e$export$2e2bcd8739ae039 = $03d9e9ba45fd707e$var$CustomItem;

});

parcelRegister("T88uF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9991d17cfc604561$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $9991d17cfc604561$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $9991d17cfc604561$var$HeadingItem = /*#__PURE__*/ (0, $fc4bM.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $9991d17cfc604561$export$2e2bcd8739ae039 = $9991d17cfc604561$var$HeadingItem;

});

parcelRegister("gSOfb", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3534e1a2a953079$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7kcwn = parcelRequire("7kcwn");

var $8ZObF = parcelRequire("8ZObF");
const $f3534e1a2a953079$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $f3534e1a2a953079$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7kcwn.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8ZObF.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $2R2iS.default)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
var $f3534e1a2a953079$export$2e2bcd8739ae039 = $f3534e1a2a953079$var$MenuGroup;

});

parcelRegister("3rlj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $8217ecf983582ca5$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $T88uF = parcelRequire("T88uF");
const $8217ecf983582ca5$var$itemHeadingTopMargin = 20;
const $8217ecf983582ca5$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $8217ecf983582ca5$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $8217ecf983582ca5$var$skeletonHeadingHeight = 8;
const $8217ecf983582ca5$var$skeletonHeadingMarginOffset = 3;
const $8217ecf983582ca5$var$skeletonHeadingTopMargin = $8217ecf983582ca5$var$itemHeadingTopMargin + ($8217ecf983582ca5$var$itemHeadingContentHeight - $8217ecf983582ca5$var$skeletonHeadingHeight) - $8217ecf983582ca5$var$skeletonHeadingMarginOffset;
const $8217ecf983582ca5$var$sectionPaddingTopBottom = 6;
const $8217ecf983582ca5$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $8217ecf983582ca5$var$Section = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $3LM7S.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $fc4bM.Children).map((0, $fc4bM.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $3LM7S.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $T88uF.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $2R2iS.default)([
                    isSideNavSection && $8217ecf983582ca5$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            $8217ecf983582ca5$var$styles.root,
            isScrollable ? $8217ecf983582ca5$var$styles.scrollable : $8217ecf983582ca5$var$styles.unscrollable,
            hasSeparator ? $8217ecf983582ca5$var$styles.thinSeparator : $8217ecf983582ca5$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $8217ecf983582ca5$export$2e2bcd8739ae039 = $8217ecf983582ca5$var$Section;

});

parcelRegister("byPAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f314ee19c142718b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $lyJwM = parcelRequire("lyJwM");

var $5PQxp = parcelRequire("5PQxp");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f314ee19c142718b$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5PQxp.TargetConsumer), null, (getTargetRef)=>{
        if (typeof children === 'function') return children({
            targetRef: getTargetRef === null || getTargetRef === void 0 ? void 0 : getTargetRef(name)
        });
        return getTargetRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lyJwM.default), {
            name: name,
            hasNodeResolver: !(0, $dRkX9.fg)('platform_design_system_team_onboarding_noderesolve'),
            getTargetRef: getTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children)) : children;
    });
$f314ee19c142718b$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f314ee19c142718b$export$2e2bcd8739ae039 = $f314ee19c142718b$var$SpotlightTarget;

});
parcelRegister("lyJwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $241594115cab13a1$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $031yx = parcelRequire("031yx");
const $241594115cab13a1$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $241594115cab13a1$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) {
            var _divRef$current;
            targetRef((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.firstElementChild);
        }
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($031yx))), {
        innerRef: getTargetRef(name)
    }, children);
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        ref: divRef,
        className: (0, $2R2iS.default)([
            "_1e0c1bgi"
        ])
    }, children);
};
$241594115cab13a1$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $241594115cab13a1$export$2e2bcd8739ae039 = $241594115cab13a1$var$NodeResolverSpotlightTarget;

});
parcelRegister("031yx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2zZ4x = parcelRequire("2zZ4x");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $00917cec60a40c0d$var$_interopRequireDefault($2zZ4x).default;
    }
});
function $00917cec60a40c0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2zZ4x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1e0e394d411b8513$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");
function $1e0e394d411b8513$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1e0e394d411b8513$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1e0e394d411b8513$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1e0e394d411b8513$var$NodeResolver = function(_Component) {
    $1e0e394d411b8513$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $1e0e394d411b8513$var$_classCallCheck(this, NodeResolver);
        return $1e0e394d411b8513$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $1e0e394d411b8513$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $bTkYf.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($fc4bM.Component);
module.exports.default = $1e0e394d411b8513$var$NodeResolver;

});




parcelRegister("fXMxe", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $fd9b5818bc13d3c5$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $fd9b5818bc13d3c5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");
const $fd9b5818bc13d3c5$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    isOpen: true,
    onExited: (0, $9JZL9.default)
});
// checks if children exist and are truthy
const $fd9b5818bc13d3c5$var$hasChildren = (children)=>{
    var _React$Children$map;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.count(children) > 0 && (((_React$Children$map = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children || false, (child)=>!!child)) === null || _React$Children$map === void 0 || (_React$Children$map = _React$Children$map.filter(Boolean)) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.length) || 0) > 0;
};
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $fd9b5818bc13d3c5$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $fd9b5818bc13d3c5$var$hasChildren(previousChildren) && !$fd9b5818bc13d3c5$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($fd9b5818bc13d3c5$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $fd9b5818bc13d3c5$var$hasChildren(this.props.children)
            }
        }, this.state.currentChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $fd9b5818bc13d3c5$export$7d63b19b854c2fe8 = $fd9b5818bc13d3c5$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$fd9b5818bc13d3c5$export$2e2bcd8739ae039 = $fd9b5818bc13d3c5$var$SpotlightTransition;

});

parcelRegister("gvvtK", function(module, exports) {
$parcel$export(module.exports, "FireUIAnalytics", () => $e155805f857d1004$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $e155805f857d1004$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireScreenAnalytics", () => $e155805f857d1004$export$2ccf161b817b43b);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");

var $aVQWM = parcelRequire("aVQWM");

var $16GaT = parcelRequire("16GaT");
const $e155805f857d1004$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $e155805f857d1004$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $e155805f857d1004$var$FireComponent extends (0, $fc4bM.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $e155805f857d1004$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $e155805f857d1004$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $16GaT.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $e155805f857d1004$var$WithAnalytics = (0, $azARG.default)()($e155805f857d1004$var$FireComponent);
const $e155805f857d1004$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e155805f857d1004$var$WithAnalytics, {
        ...props,
        type: (0, $aVQWM.UI_EVENT_TYPE)
    });
const $e155805f857d1004$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e155805f857d1004$var$WithAnalytics, {
        ...props,
        type: (0, $aVQWM.TRACK_EVENT_TYPE)
    });
const $e155805f857d1004$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e155805f857d1004$var$WithAnalytics, {
        ...props,
        type: (0, $aVQWM.OPERATIONAL_EVENT_TYPE)
    });
const $e155805f857d1004$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e155805f857d1004$var$WithAnalytics, {
        ...props,
        type: (0, $aVQWM.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    });

});

parcelRegister("4MoYu", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $37af048c9a1a40a2$export$a75f3c98d930b258);

var $8gzC2 = parcelRequire("8gzC2");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/help/help-center/manifest.ts
var $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $8gzC2.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $8gzC2.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/help-center/index.ts
var $37af048c9a1a40a2$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $37af048c9a1a40a2$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("8gzC2", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $604b71462d83d2a5$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $604b71462d83d2a5$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $604b71462d83d2a5$export$a4af98a27b4568ee = "help", $604b71462d83d2a5$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("80SfI", function(module, exports) {
$parcel$export(module.exports, "PremiumBenefitModalTrigger", () => $66c1218c504ff28e$export$6f0c4c8beb8e608a);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $asC5r = parcelRequire("asC5r");

var $kJiHZ = parcelRequire("kJiHZ");

var $b1qW8 = parcelRequire("b1qW8");

var $kg2mL = parcelRequire("kg2mL");

var $fe5C4 = parcelRequire("fe5C4");

var $lh6uV = parcelRequire("lh6uV");

var $1x4Nw = parcelRequire("1x4Nw");

var $jLgmq = parcelRequire("jLgmq");

var $hut32 = parcelRequire("hut32");

var $1U9sH = parcelRequire("1U9sH");
const $66c1218c504ff28e$var$PremiumBenefitModalTriggerBase = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, showPreconditionMessage: showPreconditionMessage, preconditionCtaLink: preconditionCtaLink, ...pressableProps })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fe5C4.useAnalytics)();
    const { onClick: originalOnClick, ...restPressableProps } = pressableProps;
    const handleOnClick = (0, $fc4bM.useCallback)((e, analyticsEvent)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
        // Call the original onClick if it exists
        originalOnClick === null || originalOnClick === void 0 || originalOnClick(e, analyticsEvent);
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition,
        originalOnClick
    ]);
    const handleOnClose = (0, $fc4bM.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismiss',
            actionSubject: 'modal',
            actionSubjectId: 'editionBenefitsModal',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kJiHZ.ModalTrigger), {
        entryPoint: (0, $1U9sH.premiumEditionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: cloudId,
            product: product
        },
        entryPointProps: {
            variantId: variantId,
            touchpointId: touchpointId,
            edition: edition,
            onClose: handleOnClose,
            showPreconditionMessage: showPreconditionMessage,
            preconditionCtaLink: preconditionCtaLink
        },
        modalProps: (0, $lh6uV.MODAL_CONFIG)
    }, ({ ref: ref })=>children ? children({
            ref: ref,
            props: {
                ...restPressableProps,
                onClick: handleOnClick
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $b1qW8.DiscoveryCTAButton), {
            ref: ref,
            buttonStyle: "default",
            ...restPressableProps,
            onClick: handleOnClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $hut32.messages).buttonTriggerTryItFree))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kg2mL.UiViewedEvent), {
        actionSubject: "modalTrigger",
        actionSubjectId: "editionBenefitsModalTrigger",
        attributes: {
            touchpointId: touchpointId,
            product: product,
            edition: edition,
            variantId: variantId
        }
    }));
};
const $66c1218c504ff28e$export$6f0c4c8beb8e608a = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, useInternalModalContextProvider: useInternalModalContextProvider, ...pressableProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jLgmq.ErrorBoundary), {
        variantId: variantId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1x4Nw.IntlProvider), null, useInternalModalContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asC5r.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($66c1218c504ff28e$var$PremiumBenefitModalTriggerBase, {
        cloudId: cloudId,
        product: product,
        children: children,
        variantId: variantId,
        touchpointId: touchpointId,
        edition: edition,
        ...pressableProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($66c1218c504ff28e$var$PremiumBenefitModalTriggerBase, {
        cloudId: cloudId,
        product: product,
        children: children,
        variantId: variantId,
        touchpointId: touchpointId,
        edition: edition,
        ...pressableProps
    })));

});
parcelRegister("asC5r", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $bb27bc249bd46d50$export$7c9538f5f3c365e9);

var $fc4bM = parcelRequire("fc4bM");

var $ggkex = parcelRequire("ggkex");

var $fp8NM = parcelRequire("fp8NM");
const $bb27bc249bd46d50$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $fc4bM.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $fc4bM.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $bb27bc249bd46d50$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $fc4bM.useRef)(1);
    const [modals, setModals] = (0, $fc4bM.useState)([]);
    const modalContext = (0, $fc4bM.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fp8NM.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bb27bc249bd46d50$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}

});
parcelRegister("fp8NM", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $3e81ca6e56ea4bfb$export$ab57792b9b6974a6);

var $fc4bM = parcelRequire("fc4bM");
const $3e81ca6e56ea4bfb$export$a862d8e2bf1b05e9 = {
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
};
const $3e81ca6e56ea4bfb$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $fc4bM.createContext)($3e81ca6e56ea4bfb$export$a862d8e2bf1b05e9);

});


parcelRegister("kJiHZ", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $c7f317937d4892e5$export$fb10b32cfe19f1e);

var $fc4bM = parcelRequire("fc4bM");

var $3BZyK = parcelRequire("3BZyK");

var $cX3YH = parcelRequire("cX3YH");

var $2u7SO = parcelRequire("2u7SO");

var $dRkX9 = parcelRequire("dRkX9");

var $htldd = parcelRequire("htldd");

var $9Tm0w = parcelRequire("9Tm0w");

var $bqiWl = parcelRequire("bqiWl");

var $lJX27 = parcelRequire("lJX27");

var $fp8NM = parcelRequire("fp8NM");

var $iEGgB = parcelRequire("iEGgB");

var $9L7ZF = parcelRequire("9L7ZF");

var $c1Y6G = parcelRequire("c1Y6G");

var $jEstI = parcelRequire("jEstI");

var $jGONl = parcelRequire("jGONl");
const $c7f317937d4892e5$var$emptyEntryPointParams = {};
const $c7f317937d4892e5$var$emptyEntryPointProps = {};
function $c7f317937d4892e5$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, errorFallback: ErrorFallbackComponent, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, onRequestClose: onRequestClose, source: source, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText, errorTitle: errorTitle, errorText: errorText, errorCloseText: errorCloseText }) {
    const { openModal: openModal } = (0, $fc4bM.useContext)((0, $fp8NM.ModalContext));
    const environmentProvider = (0, $lJX27.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $htldd.useEntryPointConfig)();
    const ModalErrorFallback = ErrorFallbackComponent ?? GlobalModalErrorFallback;
    const modalRef = (0, $fc4bM.useRef)(null);
    const statusAnnouncementRef = (0, $fc4bM.useRef)(null);
    const { onContentReady: onContentReady, resetContentReady: resetContentReady, waitForContentReady: waitForContentReady } = (0, $iEGgB.useContentReadySignal)();
    const { id: id, packageName: packageName, teamName: teamName } = source ?? {};
    const metricName = (0, $fc4bM.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $fc4bM.useCallback)(()=>(0, $3BZyK.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $c7f317937d4892e5$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $fc4bM.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            resetContentReady();
            const clearStatusAnnouncement = ()=>{
                var _statusAnnouncementRe;
                return (_statusAnnouncementRe = statusAnnouncementRef.current) === null || _statusAnnouncementRe === void 0 ? void 0 : _statusAnnouncementRe.clear();
            };
            const requestClose = (request)=>{
                var _entryPointProps$onCl;
                if ((onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose(request.event)) === false) return;
                clearStatusAnnouncement();
                entryPointProps === null || entryPointProps === void 0 || (_entryPointProps$onCl = entryPointProps.onClose) === null || _entryPointProps$onCl === void 0 || _entryPointProps$onCl.call(entryPointProps, request.entryPointCloseArgument);
                closeModal();
                dispose();
            };
            const onInternalClose = (extraInformation)=>{
                requestClose({
                    entryPointCloseArgument: extraInformation
                });
            };
            const onUserInteractionClose = (event)=>{
                requestClose({
                    event: event,
                    entryPointCloseArgument: event
                });
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bqiWl.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ModalErrorFallback, {
                        error: error,
                        id: id ?? metricName,
                        teamName: teamName,
                        packageName: packageName,
                        closeModal: onInternalClose,
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c1Y6G.ErrorFallback), {
                            error: error,
                            closeModal: onInternalClose,
                            errorTitle: errorTitle,
                            title: title,
                            errorText: errorText,
                            errorCloseText: errorCloseText
                        })
                    }),
                onContentReady: ()=>{
                    clearStatusAnnouncement();
                    onContentReady();
                },
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    var _statusAnnouncementRe2;
                    (_statusAnnouncementRe2 = statusAnnouncementRef.current) === null || _statusAnnouncementRe2 === void 0 || _statusAnnouncementRe2.announce(errorText ?? 'Something went wrong while loading the dialog content.');
                    onError === null || onError === void 0 || onError({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Fallback, {
                    onClose: onInternalClose
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jGONl.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $c7f317937d4892e5$var$emptyEntryPointProps,
                    onClose: onInternalClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
                ...modalProps,
                UNSAFE__disableInitialAutoFocus: (0, $dRkX9.fg)('platform_dst-automated_focus'),
                ref: modalRef,
                onClose: onUserInteractionClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnOverlayClick),
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnEscapePress)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9L7ZF.DelayedStatusAnnouncement), {
                ref: statusAnnouncementRef
            }, loadingText ?? 'Loading dialog content...'), container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jEstI.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps === null || modalProps === void 0 ? void 0 : modalProps.autoFocus,
                modalRef: modalRef,
                waitForContentReady: waitForContentReady
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        id,
        packageName,
        teamName,
        entryPointProps,
        ModalErrorFallback,
        onError,
        onRequestClose,
        loadingText,
        errorTitle,
        errorText,
        errorCloseText,
        onContentReady,
        resetContentReady,
        waitForContentReady
    ]);
    const triggerRef = (0, $9Tm0w.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $cX3YH.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef,
        'aria-haspopup': 'dialog'
    });
}

});
parcelRegister("htldd", function(module, exports) {
$parcel$export(module.exports, "useEntryPointConfig", () => $96e5ad7fa6c3491e$export$dfa96f26176fa91f);

var $9X5OC = parcelRequire("9X5OC");
function $96e5ad7fa6c3491e$export$dfa96f26176fa91f() {
    return 0, $9X5OC.entryPointConfig;
}

});
parcelRegister("9X5OC", function(module, exports) {
$parcel$export(module.exports, "entryPointConfig", () => $1a139f50ca63d975$export$ec2e992e3170c3c4);

var $flPQp = parcelRequire("flPQp");
const $1a139f50ca63d975$export$ec2e992e3170c3c4 = (0, $flPQp.defaultEntryPointConfig);

});
parcelRegister("flPQp", function(module, exports) {
$parcel$export(module.exports, "defaultEntryPointConfig", () => $584e67561eeb87d4$export$7ca620c75cbaadf0);

var $fc4bM = parcelRequire("fc4bM");

var $dGxDH = parcelRequire("dGxDH");

var $kv786 = parcelRequire("kv786");

var $hgQYR = parcelRequire("hgQYR");

var $pMGlN = parcelRequire("pMGlN");
function $584e67561eeb87d4$var$SuspensePlaceholder({ children: children, fallback: fallback, name: name }) {
    return (0, $fc4bM.createElement)((0, $hgQYR.default), {
        children: children,
        fallback: fallback,
        interactionName: name
    });
}
const $584e67561eeb87d4$var$GlobalModalErrorFallback = ({ closeModal: closeModal, fallback: fallback })=>{
    const hasFallback = fallback != null;
    (0, $fc4bM.useEffect)(()=>{
        if (!hasFallback) closeModal();
    }, [
        closeModal,
        hasFallback
    ]);
    return fallback ?? null;
};
const $584e67561eeb87d4$export$7ca620c75cbaadf0 = {
    PlaceholderComponent: (0, $dGxDH.componentWithFG)('platform-dst-top-layer', $584e67561eeb87d4$var$SuspensePlaceholder, (0, $kv786.default)),
    UFOSegmentComponent: (0, $pMGlN.default),
    GlobalModalErrorFallback: $584e67561eeb87d4$var$GlobalModalErrorFallback
};

});
parcelRegister("dGxDH", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $0bc6a98023fed968$export$cf56d0f54cfcce4);

var $dRkX9 = parcelRequire("dRkX9");

var $fzRvL = parcelRequire("fzRvL");
const $0bc6a98023fed968$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $fzRvL.componentWithCondition)(()=>(0, $dRkX9.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});

parcelRegister("kv786", function(module, exports) {
$parcel$export(module.exports, "default", () => $37bf6615b148f14a$export$2e2bcd8739ae039);

var $jevVz = parcelRequire("jevVz");
var $37bf6615b148f14a$export$2e2bcd8739ae039 = (0, $jevVz.default);

});
parcelRegister("jevVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b530a39c3500955e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $d7r8x = parcelRequire("d7r8x");

var $e7W1M = parcelRequire("e7W1M");

var $ba6nk = parcelRequire("ba6nk");
function $b530a39c3500955e$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $fc4bM.useContext)((0, $ba6nk.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e7W1M.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: name,
            hold: shouldHold
        })),
        name: name
    }, children);
}

});
parcelRegister("e7W1M", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $4c8a52fdecea30ec$export$256c542058532d6f);

var $fc4bM = parcelRequire("fc4bM");
const $4c8a52fdecea30ec$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $4c8a52fdecea30ec$var$LazySuspenseContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $4c8a52fdecea30ec$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($4c8a52fdecea30ec$var$LazySuspenseContext);
    (0, $fc4bM.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$4c8a52fdecea30ec$var$DynamicFallback.displayName = 'DynamicFallback';
const $4c8a52fdecea30ec$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $fc4bM.useState)(null);
    const mountedRef = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $fc4bM.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($4c8a52fdecea30ec$var$DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($4c8a52fdecea30ec$var$LazySuspenseContext.Provider, {
        value: contextValue
    }, $4c8a52fdecea30ec$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: renderFallback(false)
    }, children), (!mountedRef.current || hydrationFallback) && renderFallback(true)));
};
$4c8a52fdecea30ec$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("ba6nk", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $d73339e69a2fcdf4$export$9ba3fe09d15de47b);

var $fc4bM = parcelRequire("fc4bM");
const $d73339e69a2fcdf4$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $fc4bM.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});



parcelRegister("hgQYR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a538688ff1bf1f85$export$2e2bcd8739ae039);

var $7GSyu = parcelRequire("7GSyu");
var $a538688ff1bf1f85$export$2e2bcd8739ae039 = (0, $7GSyu.default);

});
parcelRegister("7GSyu", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c361dd12ca6c464$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $d7r8x = parcelRequire("d7r8x");
const $3c361dd12ca6c464$var$Suspense = ({ children: children, fallback: fallback, interactionName: interactionName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: interactionName
        }, fallback)
    }, children);
};
var $3c361dd12ca6c464$export$2e2bcd8739ae039 = $3c361dd12ca6c464$var$Suspense;

});





parcelRegister("9Tm0w", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $bb7bb27f0a4e6122$export$1ff47f24e06a5d2d);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $dRkX9 = parcelRequire("dRkX9");

var $jGfDW = parcelRequire("jGfDW");
const $bb7bb27f0a4e6122$var$disabledTriggerSelector = ':disabled, [disabled], [aria-disabled="true"]';
function $bb7bb27f0a4e6122$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $fc4bM.useRef)(null);
    const eventListeners = (0, $fc4bM.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $jGfDW.useEntryPointPreload)(load);
    const clickListener = (0, $fc4bM.useMemo)(()=>{
        return ()=>{
            var _nodeRef$current;
            if ((_nodeRef$current = nodeRef.current) !== null && _nodeRef$current !== void 0 && _nodeRef$current.matches($bb7bb27f0a4e6122$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        cancelPreload,
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $fc4bM.useMemo)(()=>{
        return ()=>{
            var _nodeRef$current2;
            if ((_nodeRef$current2 = nodeRef.current) !== null && _nodeRef$current2 !== void 0 && _nodeRef$current2.matches($bb7bb27f0a4e6122$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            eagerLoad();
        };
    }, [
        cancelPreload,
        eagerLoad
    ]);
    const mouseEnterListener = (0, $fc4bM.useMemo)(()=>{
        return ()=>{
            var _nodeRef$current3;
            if ((_nodeRef$current3 = nodeRef.current) !== null && _nodeRef$current3 !== void 0 && _nodeRef$current3.matches($bb7bb27f0a4e6122$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            preloadReference();
        };
    }, [
        cancelPreload,
        preloadReference
    ]);
    const focusListener = (0, $fc4bM.useCallback)(()=>{
        // focus() can emit trusted events when a popup or modal restores focus on close.
        // Only keyboard traversal expresses fresh focus-preload intent in that case.
        if ((0, $dRkX9.fg)('platform_dst-popup-trigger-dispose-on-close')) return;
        mouseEnterListener();
    }, [
        mouseEnterListener
    ]);
    const cleanUpEventListeners = (0, $fc4bM.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $fc4bM.useCallback)((element, type, callback)=>{
        const unbind = (0, $6Zi52.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $fc4bM.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', mouseEnterListener);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', focusListener);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        mouseEnterListener,
        focusListener,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});
parcelRegister("jGfDW", function(module, exports) {
$parcel$export(module.exports, "useEntryPointPreload", () => $369f67b9f38d1e9c$export$57effc2a5e3611f);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
const $369f67b9f38d1e9c$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $369f67b9f38d1e9c$var$TIME_TO_INTENT = 200;
const $369f67b9f38d1e9c$var$PRELOAD_DISPOSE_DELAY = 1000;
function $369f67b9f38d1e9c$export$57effc2a5e3611f(load) {
    const actions = (0, $fc4bM.useMemo)(()=>{
        const request = {};
        const clearPreloadIntentTimeout = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
        };
        const clearPreloadTimeouts = ()=>{
            clearPreloadIntentTimeout();
            if ((0, $dRkX9.fg)('platform_relay_entrypoint_preload_lifecycle')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            } else if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $dRkX9.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreloadDisposal = ()=>{
            if (request.preloadDisposeTimeout !== undefined) {
                clearTimeout(request.preloadDisposeTimeout);
                delete request.preloadDisposeTimeout;
            }
        };
        const disposePreload = ()=>{
            if ((0, $dRkX9.fg)('platform_relay_entrypoint_preload_lifecycle')) {
                // Keep max-age eviction active until the preload is disposed or consumed.
                clearPreloadIntentTimeout();
                cancelPreloadDisposal();
                if (request.preload) request.preloadDisposeTimeout = setTimeout(()=>{
                    var _request$preload;
                    (_request$preload = request.preload) === null || _request$preload === void 0 || _request$preload.dispose();
                    clearPreloadTimeouts();
                }, $369f67b9f38d1e9c$var$PRELOAD_DISPOSE_DELAY);
            } else clearPreloadTimeouts();
        };
        const cleanupPreload = ()=>{
            var _request$preload2;
            if ((0, $dRkX9.fg)('platform_relay_entrypoint_preload_lifecycle')) {
                cancelPreloadDisposal();
                clearPreloadTimeouts();
            }
            (_request$preload2 = request.preload) === null || _request$preload2 === void 0 || _request$preload2.dispose();
            // Preserve legacy max-age cleanup when the lifecycle gate is disabled.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $dRkX9.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            var _request$preload3;
            if (request.load) return request.load;
            const reference = ((_request$preload3 = request.preload) === null || _request$preload3 === void 0 ? void 0 : _request$preload3.reference) ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            if ((0, $dRkX9.fg)('platform_relay_entrypoint_preload_lifecycle')) cancelPreloadDisposal();
            return loadReference();
        };
        const preloadReference = ()=>{
            if ((0, $dRkX9.fg)('platform_relay_entrypoint_preload_lifecycle')) cancelPreloadDisposal();
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    var _request$preload4;
                    if ((0, $dRkX9.fg)('platform_relay_entrypoint_preload_lifecycle')) cancelPreloadDisposal();
                    (_request$preload4 = request.preload) === null || _request$preload4 === void 0 || _request$preload4.dispose();
                }, $369f67b9f38d1e9c$var$PRELOAD_MAX_AGE);
            }, $369f67b9f38d1e9c$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: disposePreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}

});


parcelRegister("bqiWl", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $a13896e416ce9312$export$5d4dc37edd8a3adb);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $3BZyK = parcelRequire("3BZyK");

var $9PWjZ = parcelRequire("9PWjZ");

var $iSOdp = parcelRequire("iSOdp");

var $htldd = parcelRequire("htldd");
function $a13896e416ce9312$var$ContentReady({ onContentReady: onContentReady }) {
    (0, $fc4bM.useEffect)(()=>{
        onContentReady === null || onContentReady === void 0 || onContentReady();
    }, [
        onContentReady
    ]);
    return null;
}
function $a13896e416ce9312$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, onContentReady: onContentReady, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $htldd.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $9PWjZ.useUFOReportError)();
    const onError = (0, $fc4bM.useCallback)((error, errorInfo)=>{
        onErrorLocal === null || onErrorLocal === void 0 || onErrorLocal({
            error: error,
            errorInfo: errorInfo
        });
        (0, $iSOdp.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) ?? 'Unknown error',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $fc4bM.useCallback)(({ error: error })=>{
        const onClose = (runtimeProps === null || runtimeProps === void 0 ? void 0 : runtimeProps.onClose) ?? (()=>{});
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a13896e416ce9312$var$ContentReady, {
            onContentReady: onContentReady
        }));
    }, [
        errorFallback,
        onContentReady,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PlaceholderComponent, {
        name: placeholderName ?? 'internal-internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3BZyK.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a13896e416ce9312$var$ContentReady, {
        onContentReady: onContentReady
    })));
}
function $a13896e416ce9312$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $htldd.useEntryPointConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(UFOSegmentComponent, {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a13896e416ce9312$var$InternalEntryPointContainerInner, props));
}

});
parcelRegister("9PWjZ", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $ecc6f17ce2b22d8f$export$75d40f522062f923);

var $51dxT = parcelRequire("51dxT");

var $jQYQa = parcelRequire("jQYQa");
function $ecc6f17ce2b22d8f$export$75d40f522062f923() {
    const ufoContext = (0, $51dxT.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $jQYQa.getActiveInteraction)();
        if (interaction !== null && interaction !== void 0 && interaction.id) (0, $jQYQa.addError)(interaction.id, error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $jQYQa.addErrorToAll)(error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});

parcelRegister("iSOdp", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $f8d92db961e34c42$export$b33b857ad1d9900e);

var $dRkX9 = parcelRequire("dRkX9");
const $f8d92db961e34c42$var$buffer = [];
let $f8d92db961e34c42$var$push = (payload)=>{
    $f8d92db961e34c42$var$buffer.push(payload);
};
function $f8d92db961e34c42$export$b33b857ad1d9900e(payload) {
    $f8d92db961e34c42$var$push(payload);
}
function $f8d92db961e34c42$export$abd5747ea77ecab9(handler) {
    if ((0, $dRkX9.fg)('moving_jira_entry-points_api_under_platform')) {
        $f8d92db961e34c42$var$push = handler;
        $f8d92db961e34c42$var$buffer.forEach((payload)=>handler(payload));
        $f8d92db961e34c42$var$buffer.length = 0;
    }
}

});


parcelRegister("lJX27", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $3cbf5aee41204e8d$export$6c22afad970ad5ac);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $3cbf5aee41204e8d$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $3cbf5aee41204e8d$export$e237a628f59c9f4e);

var $fc4bM = parcelRequire("fc4bM");

var $3BZyK = parcelRequire("3BZyK");

var $dRkX9 = parcelRequire("dRkX9");

var $cUcXT = parcelRequire("cUcXT");

var $l9Gq2 = parcelRequire("l9Gq2");
function $3cbf5aee41204e8d$export$6c22afad970ad5ac({ children: children }) {
    const existingRelayContext = (0, $fc4bM.useContext)((0, $3BZyK.ReactRelayContext));
    // If a compatible relay environment (one created via `createRelayEnvironment`) is already present
    // in the tree, reuse it instead of shadowing it with our own internal environment.
    if (existingRelayContext != null && (0, $cUcXT.isAtlassianRelayEnvironment)(existingRelayContext.environment) && (0, $dRkX9.fg)('relay_environment_-_reuse_product_env_when_exist')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    // Otherwise, fall back to providing the default internal relay environment.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3BZyK.RelayEnvironmentProvider), {
        environment: (0, $l9Gq2.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $3cbf5aee41204e8d$export$43b1f3e917d65526 = $3cbf5aee41204e8d$export$6c22afad970ad5ac;
const $3cbf5aee41204e8d$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $fc4bM.useContext)((0, $3BZyK.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3cbf5aee41204e8d$export$6c22afad970ad5ac, null, children);
};
function $3cbf5aee41204e8d$export$e237a628f59c9f4e() {
    const environment = (0, $3BZyK.useRelayEnvironment)();
    return (0, $fc4bM.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("l9Gq2", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $22ff05e0619c000e$export$df54517d175e6d6b);

var $dRkX9 = parcelRequire("dRkX9");

var $cUcXT = parcelRequire("cUcXT");

var $dH7Ej = parcelRequire("dH7Ej");

var $ldsDp = parcelRequire("ldsDp");
const $22ff05e0619c000e$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $22ff05e0619c000e$export$4a639ebead870a0c = new (0, $ldsDp.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $22ff05e0619c000e$export$df54517d175e6d6b = (0, $cUcXT.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $22ff05e0619c000e$var$getLoggingAndMetricsHelper,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                var _response$extensions;
                const requestId = response === null || response === void 0 || (_response$extensions = response.extensions) === null || _response$extensions === void 0 || (_response$extensions = _response$extensions.gateway) === null || _response$extensions === void 0 ? void 0 : _response$extensions.request_id;
                (0, $dH7Ej.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $dRkX9.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $dH7Ej.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $22ff05e0619c000e$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("dH7Ej", function(module, exports) {
$parcel$export(module.exports, "captureErrors", () => $2bbfb5a67c7936a6$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isStepUpAuthError", () => $2bbfb5a67c7936a6$export$60fba4117567a49b);

var $eUgRu = parcelRequire("eUgRu");
const $2bbfb5a67c7936a6$var$errorCollector = new Map();
const $2bbfb5a67c7936a6$export$da396ad2a542b095 = 120000; // 2min
const $2bbfb5a67c7936a6$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $2bbfb5a67c7936a6$var$errorCollector.delete(key);
    }, $2bbfb5a67c7936a6$export$da396ad2a542b095);
};
const $2bbfb5a67c7936a6$export$c211170518c6d0f6 = (key = (0, $eUgRu.default)())=>{
    $2bbfb5a67c7936a6$var$errorCollector.set(key, []);
    $2bbfb5a67c7936a6$var$scheduleCleanup(key);
    return key;
};
const $2bbfb5a67c7936a6$export$e0491a0d974dadfa = (key)=>{
    const errors = $2bbfb5a67c7936a6$var$errorCollector.get(key);
    $2bbfb5a67c7936a6$var$errorCollector.delete(key);
    return errors || [];
};
const $2bbfb5a67c7936a6$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $2bbfb5a67c7936a6$var$errorCollector.forEach((value, key)=>{
        $2bbfb5a67c7936a6$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $2bbfb5a67c7936a6$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $2bbfb5a67c7936a6$export$60fba4117567a49b = (errors)=>{
    var _stepUpError$extensio;
    const stepUpError = errors.find((error)=>{
        var _error$extensions, _error$extensions2;
        return error.message.startsWith('Step-up authentication is required.') && ((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode) === 303 && ((_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.stepUpUrl);
    });
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: (stepUpError === null || stepUpError === void 0 || (_stepUpError$extensio = stepUpError.extensions) === null || _stepUpError$extensio === void 0 ? void 0 : _stepUpError$extensio.stepUpUrl) ?? undefined
    };
};

});

parcelRegister("ldsDp", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $f0013168880e2669$export$be21c283b097d175);

var $5KQKg = parcelRequire("5KQKg");
function $f0013168880e2669$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $5KQKg.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $f0013168880e2669$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $f0013168880e2669$export$be21c283b097d175 extends (0, $5KQKg.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        var _window, _window2, _window3;
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 || (_window = _window.SPA_STATE) === null || _window === void 0 ? void 0 : _window[cacheName]) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.SKELETON_NAVIGATION) === null || _window2 === void 0 ? void 0 : _window2[cacheName]) || ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.__PLATFORM_SSR_AGG_CACHE__) === null || _window3 === void 0 ? void 0 : _window3[cacheName]) || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback === null || timeoutCallback === void 0 || timeoutCallback(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $f0013168880e2669$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});



parcelRegister("iEGgB", function(module, exports) {
$parcel$export(module.exports, "useContentReadySignal", () => $4883735aaa2ac68e$export$16e5184805aaf31a);

var $fc4bM = parcelRequire("fc4bM");
function $4883735aaa2ac68e$export$16e5184805aaf31a() {
    const isContentReadyRef = (0, $fc4bM.useRef)(false);
    const onContentReadyRef = (0, $fc4bM.useRef)(null);
    const resetContentReady = (0, $fc4bM.useCallback)(()=>{
        isContentReadyRef.current = false;
        onContentReadyRef.current = null;
    }, []);
    const onContentReady = (0, $fc4bM.useCallback)(()=>{
        isContentReadyRef.current = true;
        const callback = onContentReadyRef.current;
        onContentReadyRef.current = null;
        callback === null || callback === void 0 || callback();
    }, []);
    const waitForContentReady = (0, $fc4bM.useCallback)((callback)=>{
        if (isContentReadyRef.current) {
            callback();
            return ()=>{};
        }
        onContentReadyRef.current = callback;
        return ()=>{
            if (onContentReadyRef.current === callback) onContentReadyRef.current = null;
        };
    }, []);
    return {
        onContentReady: onContentReady,
        resetContentReady: resetContentReady,
        waitForContentReady: waitForContentReady
    };
}

});

parcelRegister("9L7ZF", function(module, exports) {
$parcel$export(module.exports, "DelayedStatusAnnouncement", () => $4267d3f18cdecef7$export$7c9fbb304eeb36b7);

var $fc4bM = parcelRequire("fc4bM");

var $fKRoj = parcelRequire("fKRoj");
const $4267d3f18cdecef7$export$4ec0bb9f176673e7 = 100;
const $4267d3f18cdecef7$export$7c9fbb304eeb36b7 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function DelayedStatusAnnouncement({ children: children }, ref) {
    const [announcement, setAnnouncement] = (0, $fc4bM.useState)('');
    const timeoutRef = (0, $fc4bM.useRef)(null);
    const clear = (0, $fc4bM.useCallback)(()=>{
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setAnnouncement('');
    }, []);
    const announce = (0, $fc4bM.useCallback)((message)=>{
        clear();
        if (message === undefined || message === null) return;
        timeoutRef.current = setTimeout(()=>{
            timeoutRef.current = null;
            setAnnouncement(message);
        }, $4267d3f18cdecef7$export$4ec0bb9f176673e7);
    }, [
        clear
    ]);
    (0, $fc4bM.useImperativeHandle)(ref, ()=>({
            announce: announce,
            clear: clear
        }), [
        announce,
        clear
    ]);
    (0, $fc4bM.useEffect)(()=>{
        announce(children);
        return clear;
    }, [
        announce,
        clear,
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fKRoj.StatusAnnouncement), null, announcement);
});

});
parcelRegister("fKRoj", function(module, exports) {
$parcel$export(module.exports, "StatusAnnouncement", () => $8838f37db96de539$export$1144e05dc01c8ac);
/* status-announcement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $dVxDa = parcelRequire("dVxDa");
const $8838f37db96de539$var$styles = {
    container: "_kqsw1n9t _152tidpf _1e02idpf _1bsbidpf _4t3iidpf _lcxvglyw"
};
function $8838f37db96de539$export$1144e05dc01c8ac({ children: children, contentRef: contentRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $8838f37db96de539$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVxDa.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        ref: contentRef,
        role: "status"
    }, children)));
}

});


parcelRegister("c1Y6G", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $5ee976408a3ccca6$export$8a7ad05c3ee0c78a);

var $fc4bM = parcelRequire("fc4bM");

var $5dzEI = parcelRequire("5dzEI");

var $dkw9k = parcelRequire("dkw9k");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $k8Adr = parcelRequire("k8Adr");
const $5ee976408a3ccca6$var$defaultErrorTitle = "Couldn't load dialog content";
const $5ee976408a3ccca6$var$defaultErrorText = 'Something went wrong while loading the dialog content. Dismiss to go back';
const $5ee976408a3ccca6$var$defaultCloseLabel = 'Close';
const $5ee976408a3ccca6$export$8a7ad05c3ee0c78a = ({ error: _, closeModal: closeModal, errorTitle: errorTitle, title: title, errorText: errorText = $5ee976408a3ccca6$var$defaultErrorText, errorCloseText: errorCloseText = $5ee976408a3ccca6$var$defaultCloseLabel })=>{
    const modalTitle = errorTitle ?? title ?? $5ee976408a3ccca6$var$defaultErrorTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), {
        hasCloseButton: true,
        closeButtonLabel: errorCloseText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), {
        appearance: "danger"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        as: "p"
    }, errorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "primary",
        onClick: closeModal
    }, errorCloseText)));
};

});

parcelRegister("jEstI", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $9abdcefb17a0f8a7$export$eb58c1f6b41ee511);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $hjfZU = parcelRequire("hjfZU");

var $1jBJ5 = parcelRequire("1jBJ5");

var $hD6UU = parcelRequire("hD6UU");
function $9abdcefb17a0f8a7$var$FocusInsideOnLoadInner({ autoFocusRef: autoFocusRef, modalRef: modalRef, waitForContentReady: waitForContentReady }) {
    (0, $fc4bM.useEffect)(()=>{
        const modalElement = modalRef.current;
        if (!modalElement) return;
        const focusContent = ()=>{
            if ((0, $dRkX9.fg)('platform_dst-automated_focus')) {
                const result = (0, $hjfZU.applyInitialFocus)({
                    container: modalElement,
                    // Modal Dialog permits a ref whose current value is `undefined`; the
                    // shared focus contract treats that the same as an unset ref.
                    initialFocusRef: autoFocusRef,
                    role: 'dialog'
                });
                if (!result.applied) modalElement.focus();
                return;
            }
            // If ref provided, use that first. Else find first focusable element or
            // container if not exists
            if (autoFocusRef !== null && autoFocusRef !== void 0 && autoFocusRef.current) {
                autoFocusRef.current.focus();
                return;
            }
            const firstFocusable = (0, $1jBJ5.getFirstFocusable)({
                container: modalElement
            });
            if (firstFocusable) {
                firstFocusable.focus();
                return;
            }
            modalElement.focus();
        };
        if (!(0, $dRkX9.fg)('platform_dst-trigger-focus-after-content')) {
            focusContent();
            return;
        }
        return waitForContentReady(focusContent);
    }, [
        autoFocusRef,
        modalRef,
        waitForContentReady
    ]);
    return null;
}
function $9abdcefb17a0f8a7$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef, waitForContentReady: waitForContentReady }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hD6UU.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9abdcefb17a0f8a7$var$FocusInsideOnLoadInner, {
        autoFocusRef: autoFocusRef,
        modalRef: modalRef,
        waitForContentReady: waitForContentReady
    }));
}

});
parcelRegister("hD6UU", function(module, exports) {
$parcel$export(module.exports, "WaitForEntryPointLoad", () => $bbce0b615157660d$export$ed96a854f3831b66);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $9JZL9 = parcelRequire("9JZL9");
function $bbce0b615157660d$var$SuspendUntilLoaded({ entryPointReference: entryPointReference, children: children }) {
    // The result is intentionally unused — this call exists purely to gate
    // the mount of children on the load completing.
    entryPointReference.getComponent();
    return children;
}
function $bbce0b615157660d$export$ed96a854f3831b66({ entryPointReference: entryPointReference, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        fallbackRender: ()=>children,
        onError: (0, $9JZL9.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bbce0b615157660d$var$SuspendUntilLoaded, {
        entryPointReference: entryPointReference
    }, children)));
}

});


parcelRegister("jGONl", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $0bc79d3dcfb0a185$export$669f6ea7d267feaf);

var $fc4bM = parcelRequire("fc4bM");

var $dkw9k = parcelRequire("dkw9k");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $9Zqs7 = parcelRequire("9Zqs7");
const $0bc79d3dcfb0a185$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Zqs7.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null));

});
parcelRegister("9Zqs7", function(module, exports) {
$parcel$export(module.exports, "LoadingContent", () => $6fe0a17e67da9cf0$export$4ab3512e4872e6ff);

var $fc4bM = parcelRequire("fc4bM");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $hculA = parcelRequire("hculA");
const $6fe0a17e67da9cf0$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cJzRi.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        color: "color.text.subtle"
    }, loadingText));
};

});



parcelRegister("b1qW8", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCTAButton", () => $d97e1cc8f53d237d$export$1f81fec3cd5490ae);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $aFz2K = parcelRequire("aFz2K");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $EawnW = parcelRequire("EawnW");
const $d97e1cc8f53d237d$var$styles = {
    base: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1qi0 _v5649dqc _1e0c116y _u5f3utpp _19bvu2gc _ca0qidpf _n3tdidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _o5721q9c",
    defaultSpacing: "_1tkezwfg",
    compactSpacing: "_1tke1tcg",
    default: "_syaz15cr _bfhkya33 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31af5 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _1di66cze",
    inverted: "_189ee4h9 _1dqonqa1 _1h6d1hqq _syazdv2p _bfhkvuon _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3kca2 _30l3dv2p _1nrm1r31 _c2waglyw _1iohnqa1 _1di61jbm",
    subtle: "_bfhksm61 _syazqmo9 _o5721q9c _irr3kca2 _1di61jbm",
    contentContainer: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconContainer: "_1e0c1txw _1bsb1tcg _4t3i1tcg _1bah1h6o _4cvr1h6o"
};
const $d97e1cc8f53d237d$export$1f81fec3cd5490ae = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ buttonStyle: buttonStyle, children: children, spacing: spacing, ...buttonProps }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $EawnW.Pressable), {
        ref: ref,
        ...buttonProps,
        xcss: (0, $4Cnkn.cx)($d97e1cc8f53d237d$var$styles.base, buttonStyle === 'default' && $d97e1cc8f53d237d$var$styles.default, buttonStyle === 'inverted' && $d97e1cc8f53d237d$var$styles.inverted, buttonStyle === 'subtle' && $d97e1cc8f53d237d$var$styles.subtle, spacing === 'compact' ? $d97e1cc8f53d237d$var$styles.compactSpacing : $d97e1cc8f53d237d$var$styles.defaultSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $d97e1cc8f53d237d$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $d97e1cc8f53d237d$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFz2K))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), null, children)));
});

});
parcelRegister("aFz2K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b7ce0838881bb0eb6f29b86e8b3a459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c48ea9c3deb87c4$var$_react = $7c48ea9c3deb87c4$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $7c48ea9c3deb87c4$var$_iconNew = $7c48ea9c3deb87c4$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $7c48ea9c3deb87c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/editions
 * Usage guidance:
 * Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c48ea9c3deb87c4$var$EditionsIcon = (props)=>/*#__PURE__*/ $7c48ea9c3deb87c4$var$_react.default.createElement($7c48ea9c3deb87c4$var$_iconNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$7c48ea9c3deb87c4$var$EditionsIcon.displayName = 'EditionsIcon';
var $7c48ea9c3deb87c4$var$_default = module.exports.default = $7c48ea9c3deb87c4$var$EditionsIcon;

});


parcelRegister("kg2mL", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $0f381f1f9f445b73$export$d0a9edec5c713764);

var $fc4bM = parcelRequire("fc4bM");

var $fe5C4 = parcelRequire("fe5C4");
function $0f381f1f9f445b73$export$d0a9edec5c713764({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fe5C4.useAnalytics)();
    const hasSent = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});
parcelRegister("fe5C4", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $4ac08e3d46fa5f3e$export$e955abb82869dc84);
$parcel$export(module.exports, "useOperationalAnalytics", () => $4ac08e3d46fa5f3e$export$18e9461e904f638a);

var $fc4bM = parcelRequire("fc4bM");

var $38vAg = parcelRequire("38vAg");

var $ZyrkS = parcelRequire("ZyrkS");

var $jEubQ = parcelRequire("jEubQ");
const $4ac08e3d46fa5f3e$export$85183a312807388d = (0, $38vAg.FabricChannel).growth;
const $4ac08e3d46fa5f3e$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-benefits-modal',
    source: 'editionBenefitsModal'
};
const $4ac08e3d46fa5f3e$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $4ac08e3d46fa5f3e$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const sendAnalyticsEvent = (0, $fc4bM.useCallback)((payload)=>{
        if (payload instanceof (0, $ZyrkS.default)) {
            const contextAttributes = $4ac08e3d46fa5f3e$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...payload.payload.attributes,
                    ...$4ac08e3d46fa5f3e$export$38cd8db2db178f58
                }
            }).fire($4ac08e3d46fa5f3e$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    ...$4ac08e3d46fa5f3e$export$38cd8db2db178f58
                }
            });
            const contextAttributes = $4ac08e3d46fa5f3e$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($4ac08e3d46fa5f3e$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
};
function $4ac08e3d46fa5f3e$export$18e9461e904f638a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    return (0, $fc4bM.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...$4ac08e3d46fa5f3e$export$38cd8db2db178f58,
                ...attributes
            }
        });
        const contextAttributes = $4ac08e3d46fa5f3e$export$d97c97ed77ff09e8(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire($4ac08e3d46fa5f3e$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
}

});


parcelRegister("lh6uV", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONFIG", () => $b99fb780adeb3a52$export$310af821ace1b0a4);
$parcel$export(module.exports, "SERVICE_COLLECTION_PRICING_PAGE_URL", () => $b99fb780adeb3a52$export$73d1ac3f0d282717);
$parcel$export(module.exports, "ADMIN_BILLING_PATH", () => $b99fb780adeb3a52$export$fe159292463016ac);
$parcel$export(module.exports, "JSM_STORAGE_MANAGEMENT_PATH", () => $b99fb780adeb3a52$export$2ef4407f4b54d009);
$parcel$export(module.exports, "CSM_STORAGE_MANAGEMENT_PATH", () => $b99fb780adeb3a52$export$1f6e874869664558);
$parcel$export(module.exports, "CANCEL_SUBSCRIPTION_SAC_URL", () => $b99fb780adeb3a52$export$5911f793141d3670);
$parcel$export(module.exports, "JSM_PRICING_PAGE_URL", () => $b99fb780adeb3a52$export$f3616073c30968f9);
$parcel$export(module.exports, "INCIDENTS_SLACK_INTEGRATION_VIDEO_URL", () => $b99fb780adeb3a52$export$6a49267b3da8f732);
const $b99fb780adeb3a52$export$310af821ace1b0a4 = {
    width: 'x-large',
    shouldScrollInViewport: true
};
const $b99fb780adeb3a52$export$e2be65a9b817a3d8 = {
    ...$b99fb780adeb3a52$export$310af821ace1b0a4,
    width: 960
};
const $b99fb780adeb3a52$export$73d1ac3f0d282717 = 'https://www.atlassian.com/collections/service/pricing';
const $b99fb780adeb3a52$export$fe159292463016ac = '/admin/billing';
const $b99fb780adeb3a52$export$2ef4407f4b54d009 = '/jira/settings/products/jira-service-management-storage-management';
const $b99fb780adeb3a52$export$1f6e874869664558 = '/jira/settings/products/customerservice/storage-management';
const $b99fb780adeb3a52$export$5911f793141d3670 = 'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';
const $b99fb780adeb3a52$export$f3616073c30968f9 = 'http://www.atlassian.com/software/jira/service-management/product-pricing';
const $b99fb780adeb3a52$export$6a49267b3da8f732 = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;

});

parcelRegister("1x4Nw", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $73addbf3fbe52790$export$480518999dfc4151);

var $fc4bM = parcelRequire("fc4bM");

var $5lw64 = parcelRequire("5lw64");

var $4EUBs = parcelRequire("4EUBs");

var $eI8TL = parcelRequire("eI8TL");

var $4jqul = parcelRequire("4jqul");

var $eGB35 = parcelRequire("eGB35");

var $b5ZbB = parcelRequire("b5ZbB");
const $73addbf3fbe52790$var$defaultMessagesWithStandardBenefits = {
    ...(0, $4jqul.defaultLocale),
    ...(0, $b5ZbB.standardBenefitsFallbackMessages),
    ...(0, $eI8TL.examplesSectionFallbackMessages),
    ...(0, $eGB35.popupFallbackMessages),
    [(0, $4EUBs.messages).label.id]: (0, $4EUBs.messages).label.defaultMessage,
    [(0, $4EUBs.messages).helperText.id]: (0, $4EUBs.messages).helperText.defaultMessage
};
const $73addbf3fbe52790$export$480518999dfc4151 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5lw64.default), {
        defaultMessages: $73addbf3fbe52790$var$defaultMessagesWithStandardBenefits,
        loaderFn: (0, $4jqul.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("4EUBs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $926f7f66a10918f5$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $926f7f66a10918f5$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    helperText: {
        id: 'edition-benefits-modal.shared.premium-trial-request-reason-messages.helperText',
        defaultMessage: 'Max 300 characters',
        description: 'Helper text showing the maximum length of the optional Premium trial request reason.'
    },
    label: {
        id: 'edition-benefits-modal.shared.premium-trial-request-reason-messages.label',
        defaultMessage: 'Reason for request (optional)',
        description: 'Label for an optional explanation sent to an administrator with a Premium trial request.'
    }
});

});

parcelRegister("eI8TL", function(module, exports) {
$parcel$export(module.exports, "examplesSectionFallbackMessages", () => $e57a59fc27109252$export$7ea3822e86d2fcfd);

var $6Eg2t = parcelRequire("6Eg2t");
function $e57a59fc27109252$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $e57a59fc27109252$export$7ea3822e86d2fcfd = Object.fromEntries(Object.values((0, $6Eg2t.examplesSectionMessages)).filter($e57a59fc27109252$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("6Eg2t", function(module, exports) {
$parcel$export(module.exports, "examplesSectionMessages", () => $6ca83b29c1b6bfad$export$1edce390ed9bf8d2);

var $8p5Cv = parcelRequire("8p5Cv");
const $6ca83b29c1b6bfad$export$1edce390ed9bf8d2 = (0, $8p5Cv.defineMessages)({
    incidentsVideoIframeTitle: {
        id: '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title',
        defaultMessage: 'YouTube video player',
        description: 'Accessible title for the incidents Slack integration YouTube embed iframe'
    }
});

});


parcelRegister("4jqul", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $20a198034678cc96$export$d7f512c98c859244);
$parcel$export(module.exports, "fetchMessagesForLocale", () => $20a198034678cc96$export$2b153a2030b0feb2);

var $dB5h2 = parcelRequire("dB5h2");

var $dHYzF = parcelRequire("dHYzF");
const $20a198034678cc96$export$d7f512c98c859244 = (0, $dHYzF.default);
const $20a198034678cc96$var$localeMap = {
    pt: 'pt_BR',
    'pt-PT': 'pt_BR',
    'en-AU': 'en_GB'
};
const $20a198034678cc96$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($20a198034678cc96$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (!targetLocale) throw new Error('No mapped locale');
        const messages = await (0, $dB5h2.locales)[targetLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await (0, $dB5h2.locales)[parentLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return $20a198034678cc96$export$d7f512c98c859244;
};

});
parcelRegister("dB5h2", function(module, exports) {
$parcel$export(module.exports, "locales", () => $afa2d396c4231620$export$df1c34db1371eeed);





























const $afa2d396c4231620$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("jHdqv")),
    da: ()=>(parcelRequire("iT5Xo")),
    de: ()=>(parcelRequire("4cmPK")),
    en_GB: ()=>(parcelRequire("6KT8n")),
    en_ZZ: ()=>(parcelRequire("f6pTQ")),
    en: ()=>Promise.resolve((parcelRequire("dHYzF"))),
    es: ()=>(parcelRequire("aH3j1")),
    fi: ()=>(parcelRequire("9ENfa")),
    fr: ()=>(parcelRequire("8gxAA")),
    hr: ()=>(parcelRequire("lcIKu")),
    hu: ()=>(parcelRequire("6NttW")),
    it: ()=>(parcelRequire("fKLqd")),
    ja: ()=>(parcelRequire("fErEX")),
    ko: ()=>(parcelRequire("aQlls")),
    nb: ()=>(parcelRequire("50YcK")),
    nl: ()=>(parcelRequire("h2NCl")),
    pl: ()=>(parcelRequire("5lwe8")),
    pt_BR: ()=>(parcelRequire("dY7IN")),
    ru: ()=>(parcelRequire("kRPJB")),
    sl: ()=>(parcelRequire("gULIX")),
    sr_RS: ()=>(parcelRequire("2rurn")),
    sr_YR: ()=>(parcelRequire("50IYh")),
    sv: ()=>(parcelRequire("uZUA9")),
    th: ()=>(parcelRequire("aXs1E")),
    tr: ()=>(parcelRequire("fesBh")),
    uk: ()=>(parcelRequire("d6rVj")),
    vi: ()=>(parcelRequire("cF5xT")),
    zh_TW: ()=>(parcelRequire("7VxNH")),
    zh: ()=>(parcelRequire("fVuHT"))
};

});
parcelRegister("jHdqv", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("31tiG").then(()=>parcelRequire('174WH'));

});

parcelRegister("iT5Xo", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jT6rX").then(()=>parcelRequire('5khC9'));

});

parcelRegister("4cmPK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("lpvIX").then(()=>parcelRequire('9awMA'));

});

parcelRegister("6KT8n", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6biRX").then(()=>parcelRequire('hxhwR'));

});

parcelRegister("f6pTQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cxaxn").then(()=>parcelRequire('d6rqn'));

});

parcelRegister("dHYzF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c3473b45473401be$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fH7Vc = parcelRequire("fH7Vc");
var $c3473b45473401be$export$2e2bcd8739ae039 = (0, $fH7Vc.default);

});
parcelRegister("fH7Vc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a68bc0faacc0b352$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $a68bc0faacc0b352$export$2e2bcd8739ae039 = {
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.bradley": "Bradley",
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.knowledgeArticle": "Knowledge article",
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.rovoServiceAgent": "Rovo service agent",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.bradley": "Bradley",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.csm01": "CSM-01",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.customerServiceAgent": "Customer service agent",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.customerSupportRequest": "Customer support request",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.resolved": "Resolved",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.rovoServiceAgent": "Rovo service agent",
    "@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.slash": "/",
    "@atlassian/edition-benefits-modal.assetsCSMSupportCompanionIllustration.request": "Request",
    "@atlassian/edition-benefits-modal.assetsCSMSupportCompanionIllustration.supportCompanion": "Support Companion",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.active": "ACTIVE",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.app": "App",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.objectGraph": "Object graph",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.owningTeam": "Owning team",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.percentage": "300%",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.request": "Request",
    "@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.service": "Service",
    "@atlassian/edition-benefits-modal.benefits-section.button.maybe-later": "Maybe later",
    "@atlassian/edition-benefits-modal.benefits-section.button.try-it-free": "Try it free",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1": "<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2": "<strong>Customize your help center</strong> to match your brand.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3": "<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1": "Coordinate fast with <strong>automatically created Slack channels</strong> with the right people",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2": "Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3": "<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1": "Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2": "Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
    "@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3": "Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.",
    "@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization": "Try advanced Help Center customization with Premium",
    "@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration": "Resolve incidents with AI in Slack, try Premium now",
    "@atlassian/edition-benefits-modal.benefits-section.link.pricing": "See more Premium features and pricing",
    "@atlassian/edition-benefits-modal.benefits-section.subtitle": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.button-trigger.open-modal": "Open modal",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature1": "<strong>Resolve incidents faster</strong> with AI-powered alerting, auto-grouping, and root cause analysis.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature2": "<strong>Deploy safely with AI risk scoring,</strong> automated approvals, and change calendars.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature3": "<strong>Scale confidently</strong> with 24/7 Premium Support, and unlimited storage.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.branded-front-door": "<strong>Give every team a branded front door</strong> with multiple help centres",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.description": "AI-powered alerts group related incidents and surfaces root causes.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.title": "<strong>Resolve incidents faster</strong>",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.description": "24/7 Premium support and unlimited storage keep your team moving.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.title": "<strong>Scale your services confidently</strong>",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.self-service": "<strong>Improve self service</strong> with AI-powered virtual agent and no-code journeys.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.description": "Automated risk scoring and approvals to keep your deploys safe.",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.title": "<strong>Ship changes without the risk</strong>",
    "@atlassian/edition-benefits-modal.contextualized-premium.benefit.track-team-dependencies": "<strong>Track what your teams rely on</strong> with AI-driven workflows and up to 50,000 objects in Assets",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.alert-grouping": "AI alert grouping with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.change-management": "Try Change management with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.journeys": "Try Journeys with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.playbooks": "Try Playbooks with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.post-incident-reviews": "Try Post-incident reviews with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.heading.problem-management": "Try Problem management with Premium",
    "@atlassian/edition-benefits-modal.contextualized-premium.trial-description": "Try free for 30 days. We\u2019ll remind you before it ends. Cancel anytime.",
    "@atlassian/edition-benefits-modal.data-manager-artwork.active": "Active",
    "@atlassian/edition-benefits-modal.data-manager-artwork.card": "Access card",
    "@atlassian/edition-benefits-modal.data-manager-artwork.graph": "Object graph",
    "@atlassian/edition-benefits-modal.data-manager-artwork.laptop": "Laptop",
    "@atlassian/edition-benefits-modal.data-manager-artwork.new-card": "New access card",
    "@atlassian/edition-benefits-modal.data-manager-artwork.new-laptop": "New laptop",
    "@atlassian/edition-benefits-modal.data-manager-artwork.onboarding": "New employee onboarding",
    "@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title": "YouTube video player",
    "@atlassian/edition-benefits-modal.features-section.buttons.premium.maybe-later": "Maybe later",
    "@atlassian/edition-benefits-modal.features-section.buttons.premium.try-it-free": "Try it free",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access": "Request access",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-error-description": "Your request couldn't be sent. Please try again.",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-error-title": "Something went wrong",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-requested": "Access requested",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-success-description": "A request has been sent to your organization admin. You'll receive a notification if they grant you access.",
    "@atlassian/edition-benefits-modal.features-section.buttons.request-access-success-title": "Access requested",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.add-payment-details": "Add payment details",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-ai-enabled-forms": "Explore handoff",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-assets": "Explore Assets",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-automations": "Explore Automations",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-customer-service-agent": "Explore Customer service agent",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-knowledge-base": "Explore Knowledge base",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-ops-agent": "Explore Rovo Ops agent",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-service-agent": "Explore Rovo Service agent",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-support-companion": "Explore Support Companion",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.invite-more-agents": "Invite more agents",
    "@atlassian/edition-benefits-modal.features-section.buttons.standard.manage-storage": "Manage storage",
    "@atlassian/edition-benefits-modal.features-section.description.help-center-customization": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.features-section.description.incidents-slack-integration": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.features-section.description.workforce-optimization": "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    "@atlassian/edition-benefits-modal.features-section.header.help-center-customization": "Try advanced Help Center customization with Premium",
    "@atlassian/edition-benefits-modal.features-section.header.incidents-slack-integration": "Resolve incidents with AI in Slack, try Premium now",
    "@atlassian/edition-benefits-modal.features-section.header.standard-modal": "Explore your Standard trial",
    "@atlassian/edition-benefits-modal.features-section.header.standard-storage-limits": "You've reached your storage limit",
    "@atlassian/edition-benefits-modal.features-section.header.workforce-optimization": "Auto routing powered by agent schedules and capacity",
    "@atlassian/edition-benefits-modal.features-section.link.pricing": "See more Premium features and pricing",
    "@atlassian/edition-benefits-modal.features-section.request-access-warning.icon-label": "Information",
    "@atlassian/edition-benefits-modal.features-section.request-access-warning.text": "You must be a Customer Service Management user to access the AI customer service agent.",
    "@atlassian/edition-benefits-modal.hardware-asset-management-artwork.collaborator": "Matthew",
    "@atlassian/edition-benefits-modal.hardware-asset-management-artwork.dashboard": "Hardware assets",
    "@atlassian/edition-benefits-modal.hardware-asset-management-artwork.devices": "Total Devices",
    "@atlassian/edition-benefits-modal.hardware-asset-management-artwork.due-date": "27 MAY, 11:30 pm",
    "@atlassian/edition-benefits-modal.hardware-asset-management-artwork.laptops": "Total Laptops",
    "@atlassian/edition-benefits-modal.hardware-asset-management-artwork.request": "Laptop replacement request",
    "@atlassian/edition-benefits-modal.precondition-message.link-text": "allow Rovo access for Jira Service Management",
    "@atlassian/edition-benefits-modal.precondition-message.text": "To use AI alert grouping during your Premium trial, {link}.",
    "@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free": "Try it free",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.at": "@",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.major-incident": "MAJOR INCIDENT",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.raised-a": "Raised a",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.rovo-ops": "Rovo Ops",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.summary": "Summary",
    "@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.what-you-can-do-next": "What you can do next",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.bradley": "Bradley",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.helpCenter": "Help center",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.resolved": "Resolved",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.rovo": "Rovo",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.rovoServiceAgent": "Rovo service agent",
    "@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.slash": "/",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link": "cancel anytime.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content": "Add your payment details by <strong>{date}</strong> to continue using {edition}. {plansLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user": "To continue using {edition}, contact your billing admin to add payment details before your trial ends on <strong>{billingDate}</strong>.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date": "To continue using {edition}, contact your billing admin to add payment details before your trial ends.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered": "Your {edition} trial ends on <strong>{billingDate}</strong>.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date": "Your {edition} trial is ending soon.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date": "Add your payment details before your trial ends to continue using {edition}. {plansLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered": "You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date": "You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link": "See all plans.",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link": "See plans",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details": "Add payment details",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.close": "Close",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms": "Explore AI enabled Forms",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets": "Explore Assets",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations": "Explore Automations",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent": "Explore Customer service agent",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base": "Explore Knowledge base",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent": "Explore Rovo Ops agent",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent": "Explore Rovo Service agent",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion": "Explore Rovo Support Companion",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents": "Invite more agents",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description": "Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description": "Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description": "Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-customer-service-agent.description": "Use <strong>AI-powered Customer Service agent</strong> to deflect common requests and resolve them faster",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-limits.description": "<strong>250 GB storage</strong> to support your customers",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.support-articles.description": "Power your Rovo agent with <strong>AI written support articles</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description": "Scale your support with <strong>unlimited support agents</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description": "See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description": "Move forward faster with <strong>10x Automation rule runs</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description": "Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description": "Scale your support with <strong>unlimited support agents</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description": "Keep your requests moving with <strong>10x Automation rule runs</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description": "Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description": "Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.storage-limits.description": "<strong>250 GB storage</strong> to support your customers",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.support-articles.description": "Power your Rovo agent with <strong>AI written support articles</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description": "Scale your support with <strong>unlimited support agents</strong>",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.attachments": "Attachments",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.button": "Drag and drop files",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.name": "Service request",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.illustration.title": "Help center",
    "@atlassian/edition-benefits-modal.standard-benefits-modal.title": "Explore your trial",
    "@atlassian/edition-benefits-modal.unlimitedAgentsServiceTeam.request": "Request",
    "@atlassian/growth.edition-benefits-modal.automtion-service-team.automation": "Automation",
    "@atlassian/growth.edition-benefits-modal.automtion-service-team.automation-runs": "automation runs",
    "@atlassian/growth.edition-benefits-modal.automtion-service-team.x10": "x10",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.customer": "Customer",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.customerServiceAgent": "Customer service agent",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.resolved": "Resolved",
    "@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.support": "Support",
    "edition-benefits-modal.alert-grouping-artwork.acknowledge": "Ack all",
    "edition-benefits-modal.alert-grouping-artwork.alerts": "Alerts",
    "edition-benefits-modal.alert-grouping-artwork.group": "Alert group",
    "edition-benefits-modal.automation-ai-artwork.incoming": "Incoming work items",
    "edition-benefits-modal.automation-ai-artwork.key": "Key",
    "edition-benefits-modal.automation-ai-artwork.prompt": "Which incoming work items are similar to each other",
    "edition-benefits-modal.automation-ai-artwork.reporter": "Reporter",
    "edition-benefits-modal.automation-ai-artwork.similar": "Similar work items",
    "edition-benefits-modal.automation-ai-artwork.status": "Status",
    "edition-benefits-modal.automation-ai-artwork.summary": "Summary",
    "edition-benefits-modal.automation-ai-artwork.thinking": "Rovo is thinking",
    "edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature1": "<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.",
    "edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature2": "<strong>Ship changes safely</strong> with automated risk scoring and approvals.",
    "edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature3": "<strong>Scale your services confidently</strong> with 24/7 Premium support and unlimited storage.",
    "edition-benefits-modal.carousel.next": "Next Premium benefit",
    "edition-benefits-modal.carousel.previous": "Previous Premium benefit",
    "edition-benefits-modal.carousel.slide": "{title}, slide {index} of {count}",
    "edition-benefits-modal.ea-pill-artwork.assets": "Hardware assets",
    "edition-benefits-modal.ea-pill-artwork.devices": "Total Devices",
    "edition-benefits-modal.ea-pill-artwork.incoming": "Incoming work items",
    "edition-benefits-modal.ea-pill-artwork.key": "Key",
    "edition-benefits-modal.ea-pill-artwork.laptops": "Total Laptops",
    "edition-benefits-modal.ea-pill-artwork.prompt": "Which incoming work items are similar to each other",
    "edition-benefits-modal.ea-pill-artwork.reporter": "Reporter",
    "edition-benefits-modal.ea-pill-artwork.request": "Laptop replacement request",
    "edition-benefits-modal.ea-pill-artwork.similar": "Similar work items",
    "edition-benefits-modal.ea-pill-artwork.status": "Status",
    "edition-benefits-modal.ea-pill-artwork.summary": "Summary",
    "edition-benefits-modal.ea-pill-artwork.support-chat": "Ask anything to get started",
    "edition-benefits-modal.ea-pill-artwork.support-greeting": "Hi, how can we help?",
    "edition-benefits-modal.ea-pill-artwork.support-search": "Ask us anything",
    "edition-benefits-modal.ea-pill-artwork.thinking": "Rovo is thinking",
    "edition-benefits-modal.edition-benefits-popup.actions-group-label": "Trial actions",
    "edition-benefits-modal.edition-benefits-popup.auto-upgrade.title": "You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
    "edition-benefits-modal.edition-benefits-popup.direct-trial.title": "You're on a free trial of our {edition} plan",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details": "You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date": "You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details": "Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date": "Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details": "You won't be charged until your next billing date. <a>See plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details": "Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.",
    "edition-benefits-modal.edition-benefits-popup.manual-trial.title": "Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started",
    "edition-benefits-modal.edition-benefits-popup.primary-button": "Explore {edition}",
    "edition-benefits-modal.edition-benefits-popup.secondary-button": "Add payment details",
    "edition-benefits-modal.incident-management-artwork.incident": "Incident",
    "edition-benefits-modal.incident-management-artwork.summarize": "Summarize incident with Rovo Ops",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.group": "<strong>Group related alerts</strong> with AI so responders can focus on what matters.",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.incidents": "<strong>Turn critical alerts into incidents</strong> with AI-assisted triage and a clear timeline.",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.patterns": "<strong>Spot emerging alert patterns</strong> with AI before they become bigger issues.",
    "edition-benefits-modal.modal.v2.configs.alert-grouping-messages.title": "Try AI alert grouping with Premium",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.incidents": "<strong>Link assets to incidents and changes</strong> so you troubleshoot faster and cut risk.",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.inventory": "<strong>Bring every asset into one trusted inventory</strong> - no duplicates, no guesswork.",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.objects": "Map everything that matters, with <strong>10x the included objects</strong> to grow into.",
    "edition-benefits-modal.modal.v2.configs.assets-data-manager-messages.titleCapitalized": "Try Data Manager with Premium",
    "edition-benefits-modal.modal.v2.configs.automation-ai-messages.agents": "<strong>Put Rovo agents to work</strong> across your daily workflows with the credit headroom to match.",
    "edition-benefits-modal.modal.v2.configs.automation-ai-messages.automation": "<strong>Automate twice as much</strong> routine service work to free up your team.",
    "edition-benefits-modal.modal.v2.configs.automation-ai-messages.credits": "<strong>Give everyone more AI</strong> to search, chat, and summarize with nearly 3x the Rovo credits.",
    "edition-benefits-modal.modal.v2.configs.automation-ai-messages.title": "Increase automation and AI usage with Premium",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.assets": "<strong>Bring every asset into one trusted inventory</strong> with Data Manager and Hardware Asset Management.",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.assetsCaption": "Hardware asset management",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.rovo": "<strong>Put Rovo agents to work</strong> across your daily workflows with the credit headroom to match.",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.rovoCaption": "Rovo",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.support": "<strong>Get 24/7 Premium support</strong> from Atlassian anytime you need it.",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.supportCaption": "24/7 support",
    "edition-benefits-modal.modal.v2.configs.ea-pill-default-messages.title": "Ready for more? Try Premium today",
    "edition-benefits-modal.modal.v2.configs.hardware-asset-management-messages.title": "Try hardware asset management with Premium",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.align": "<strong>Keep the team aligned in Slack or Microsoft Teams</strong>, with a clear timeline of what happened.",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.resolve": "<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.review": "<strong>Let AI write the post-incident review</strong> so you capture learnings while fresh.",
    "edition-benefits-modal.modal.v2.configs.incident-management-messages.title": "Try advanced incident management with Premium",
    "edition-benefits-modal.modal.v2.precondition-message-v2.iconLabel": "Information",
    "edition-benefits-modal.shared.premium-trial-button.dismiss": "Dismiss",
    "edition-benefits-modal.shared.premium-trial-button.requestTrial": "Request trial",
    "edition-benefits-modal.shared.premium-trial-button.successDescription": "Your admin has been notified.",
    "edition-benefits-modal.shared.premium-trial-button.successTitle": "Your trial request has been sent",
    "edition-benefits-modal.shared.premium-trial-request-reason-messages.helperText": "Max 300 characters",
    "edition-benefits-modal.shared.premium-trial-request-reason-messages.label": "Reason for request (optional)"
};

});


parcelRegister("aH3j1", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("dGaj2").then(()=>parcelRequire('9mbxi'));

});

parcelRegister("9ENfa", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("324Ke").then(()=>parcelRequire('dCjhP'));

});

parcelRegister("8gxAA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kKfGI").then(()=>parcelRequire('8eYtw'));

});

parcelRegister("lcIKu", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ib0j9").then(()=>parcelRequire('ab8tL'));

});

parcelRegister("6NttW", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("301Ct").then(()=>parcelRequire('friQm'));

});

parcelRegister("fKLqd", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("11bwc").then(()=>parcelRequire('bVQpz'));

});

parcelRegister("fErEX", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cf3s1").then(()=>parcelRequire('kp8MY'));

});

parcelRegister("aQlls", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1KYHG").then(()=>parcelRequire('iixEL'));

});

parcelRegister("50YcK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("3Hy0o").then(()=>parcelRequire('dt7Gx'));

});

parcelRegister("h2NCl", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bFj7A").then(()=>parcelRequire('cjalt'));

});

parcelRegister("5lwe8", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1Rint").then(()=>parcelRequire('j2gQI'));

});

parcelRegister("dY7IN", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jdqV4").then(()=>parcelRequire('juK4N'));

});

parcelRegister("kRPJB", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4rUql").then(()=>parcelRequire('82l5Q'));

});

parcelRegister("gULIX", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7LEqn").then(()=>parcelRequire('gll0d'));

});

parcelRegister("2rurn", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7mnit").then(()=>parcelRequire('h9kmr'));

});

parcelRegister("50IYh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1ZiYn").then(()=>parcelRequire('g6FYr'));

});

parcelRegister("uZUA9", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7Iraz").then(()=>parcelRequire('7QvzF'));

});

parcelRegister("aXs1E", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7gYYn").then(()=>parcelRequire('i6A5p'));

});

parcelRegister("fesBh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("3rf1t").then(()=>parcelRequire('5M09m'));

});

parcelRegister("d6rVj", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("79VNv").then(()=>parcelRequire('cDPgT'));

});

parcelRegister("cF5xT", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("2V7va").then(()=>parcelRequire('2IyWz'));

});

parcelRegister("7VxNH", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("eEI4t").then(()=>parcelRequire('8ITjd'));

});

parcelRegister("fVuHT", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("dsNPD").then(()=>parcelRequire('2oU6Z'));

});



parcelRegister("eGB35", function(module, exports) {
$parcel$export(module.exports, "popupFallbackMessages", () => $f3f1fa4031532a20$export$a16b273775b597f7);

var $e7G9i = parcelRequire("e7G9i");
function $f3f1fa4031532a20$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $f3f1fa4031532a20$export$a16b273775b597f7 = Object.fromEntries(Object.values((0, $e7G9i.messages)).filter($f3f1fa4031532a20$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("e7G9i", function(module, exports) {
$parcel$export(module.exports, "messages", () => $77ecd5faf2707308$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $77ecd5faf2707308$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    starPopupAutoUpgradeTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.auto-upgrade.title',
        defaultMessage: "You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
        description: 'Edition awareness button popup title'
    },
    starPopupManualTrialTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.manual-trial.title',
        defaultMessage: 'Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started',
        description: 'Edition awareness button popup title'
    },
    starPopupDirectTrialTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.direct-trial.title',
        defaultMessage: "You're on a free trial of our {edition} plan",
        description: 'Edition awareness button popup title'
    },
    starPopupDisclaimerWithoutPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details',
        defaultMessage: 'Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer'
    },
    starPopupDisclaimerWithoutPaymentDetailsNoDate: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer for billing admins without payment details when next billing date is unavailable'
    },
    starPopupEndUserDisclaimerWithoutPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer for end users without payment details when next billing date is unavailable'
    },
    starPopupPrimaryButton: {
        id: 'edition-benefits-modal.edition-benefits-popup.primary-button',
        defaultMessage: 'Explore {edition}',
        description: 'Edition awareness button popup primary button to explore the edition'
    },
    starPopupSecondaryButton: {
        id: 'edition-benefits-modal.edition-benefits-popup.secondary-button',
        defaultMessage: 'Add payment details',
        description: 'Edition awareness button popup secondary button to add payment details'
    },
    starPopupActionsGroupLabel: {
        id: 'edition-benefits-modal.edition-benefits-popup.actions-group-label',
        defaultMessage: 'Trial actions',
        description: 'Accessible name for the group containing the edition awareness popup action buttons'
    },
    starPopupDisclaimerWithPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details',
        defaultMessage: "You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
        description: 'Edition awareness button popup disclaimer'
    },
    starPopupDisclaimerWithPaymentDetailsNoDate: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date',
        defaultMessage: "You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
        description: 'Edition awareness button popup disclaimer for billing admins with payment details when next billing date is unavailable'
    },
    starPopupEndUserDisclaimerWithPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details',
        defaultMessage: "You won't be charged until your next billing date. <a>See plans</a>.",
        description: 'Edition awareness button popup disclaimer for end users with payment details when next billing date is unavailable'
    }
});

});


parcelRegister("b5ZbB", function(module, exports) {
$parcel$export(module.exports, "standardBenefitsFallbackMessages", () => $d7038fe998c1f79d$export$188a81d8a9b070a0);

var $h6Tnm = parcelRequire("h6Tnm");
function $d7038fe998c1f79d$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $d7038fe998c1f79d$export$188a81d8a9b070a0 = Object.fromEntries(Object.values((0, $h6Tnm.standardMessages)).filter($d7038fe998c1f79d$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("h6Tnm", function(module, exports) {
$parcel$export(module.exports, "standardMessages", () => $46f64cf056e16fb0$export$e196fa8d430d87b);

var $8p5Cv = parcelRequire("8p5Cv");
const $46f64cf056e16fb0$export$e196fa8d430d87b = (0, $8p5Cv.defineMessages)({
    closeButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.close',
        defaultMessage: 'Close',
        description: 'Aria-label for the close button in the edition benefits modal'
    },
    standardBenefitsModalTitle: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.title',
        defaultMessage: 'Explore your trial',
        description: 'Title for the standard benefits modal'
    },
    standardBenefitsModalBillingContent: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content',
        defaultMessage: 'Add your payment details by <strong>{date}</strong> to continue using {edition}. {plansLink}',
        description: "Billing content for the standard benefits modal. {plansLink} is the \u201CSee all plans\u201D link to pricing."
    },
    standardBenefitsModalBillingContentNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. {plansLink}',
        description: 'Billing content when billing date is unavailable. {edition} is the plan name; {plansLink} is the plans link.'
    },
    standardBenefitsModalBillingPlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link',
        defaultMessage: 'See all plans.',
        description: "Link label for the billing line \u201CSee all plans\u201D in the standard benefits modal"
    },
    standardBenefitsModalBillingContentPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered',
        defaultMessage: 'You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}',
        description: 'Billing line when payment details are on file. {billingDate} is the next billing date; {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingContentPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date',
        defaultMessage: 'You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}',
        description: 'Billing line when payment is on file but billing date is unavailable. {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingSeePlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link',
        defaultMessage: 'See plans',
        description: "Link label \u201CSee plans\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingCancelAnytimeLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link',
        defaultMessage: 'cancel anytime.',
        description: "Link label \u201Ccancel anytime.\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingContentEndUserPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered',
        defaultMessage: 'Your {edition} trial ends on <strong>{billingDate}</strong>.',
        description: 'Billing line for end users (non-billing admins) with payment on file and a known billing date.'
    },
    standardBenefitsModalBillingContentEndUserPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date',
        defaultMessage: 'Your {edition} trial is ending soon.',
        description: 'Billing line for end users (non-billing admins) with payment on file when billing date is unavailable.'
    },
    standardBenefitsModalBillingContentEndUser: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user',
        defaultMessage: 'To continue using {edition}, contact your billing admin to add payment details before your trial ends on <strong>{billingDate}</strong>.',
        description: 'Billing line for end users (non-billing admins) without payment details and a known billing date.'
    },
    standardBenefitsModalBillingContentEndUserNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date',
        defaultMessage: 'To continue using {edition}, contact your billing admin to add payment details before your trial ends.',
        description: 'Billing line for end users (non-billing admins) without payment details when billing date is unavailable.'
    },
    standardBenefitsModalAddPaymentDetailsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details',
        defaultMessage: 'Add payment details',
        description: 'Text for the add payment details button in the standard benefits modal'
    },
    standardBenefitsModalExploreRovoServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent',
        defaultMessage: 'Explore Rovo Service agent',
        description: 'Text for the explore Rovo Service agent button in the standard benefits modal'
    },
    standardBenefitsModalExploreKnowledgeBaseButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base',
        defaultMessage: 'Explore Knowledge base',
        description: 'Text for the explore Knowledge base primary button when that feature is selected'
    },
    standardBenefitsModalExploreAutomationsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations',
        defaultMessage: 'Explore Automations',
        description: 'Text for the explore Automations primary button when that feature is selected'
    },
    standardBenefitsModalInviteMoreAgentsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents',
        defaultMessage: 'Invite more agents',
        description: 'Text for the invite more agents primary button when unlimited agents is selected'
    },
    // CTA — CSM
    standardBenefitsModalExploreCustomerServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent',
        defaultMessage: 'Explore Customer service agent',
        description: 'Primary CTA when Customer service agent feature is selected (CSM)'
    },
    standardBenefitsModalExploreRovoSupportCompanionButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion',
        defaultMessage: 'Explore Rovo Support Companion',
        description: 'Primary CTA when Rovo Support Companion feature is selected (CSM)'
    },
    standardBenefitsModalExploreAiEnabledFormsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms',
        defaultMessage: 'Explore AI enabled Forms',
        description: 'Primary CTA when AI enabled Forms feature is selected (CSM)'
    },
    // CTA — Ops
    standardBenefitsModalExploreRovoOpsAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent',
        defaultMessage: 'Explore Rovo Ops agent',
        description: 'Primary CTA when Rovo Ops agent feature is selected (Ops)'
    },
    standardBenefitsModalExploreAssetsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets',
        defaultMessage: 'Explore Assets',
        description: 'Primary CTA when Assets feature is selected (Ops)'
    },
    // Feature: Service Teams
    serviceTeamsFeatureRovoAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster',
        description: 'Description for the Rovo Service Agents feature'
    },
    serviceTeamsFeatureKnowledgeBaseDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>',
        description: 'Description for the Knowledge Base feature'
    },
    serviceTeamsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description',
        defaultMessage: 'Keep your requests moving with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation Rules feature'
    },
    serviceTeamsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited Agents feature'
    },
    // Feature: CSM
    csmFeatureCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description',
        defaultMessage: 'Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload',
        description: 'Description for the Customer service agent feature (CSM)'
    },
    csmFeatureRovoSupportCompanionDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description',
        defaultMessage: 'Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses',
        description: 'Description for the Rovo Support Companion feature (CSM)'
    },
    csmFeatureAiEnabledFormsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description',
        defaultMessage: 'Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed',
        description: 'Description for the handoff feature (CSM)'
    },
    csmFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited agents feature (CSM)'
    },
    // Feature: CSM Storage Limits
    csmFeatureStorageCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-customer-service-agent.description',
        defaultMessage: 'Use <strong>AI-powered Customer Service agent</strong> to deflect common requests and resolve them faster',
        description: 'Description for the Customer Service agent feature in storage limits variant (CSM)'
    },
    csmFeatureSupportArticlesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.support-articles.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written support articles</strong>',
        description: 'Description for the Knowledge Base feature in storage limits variant (CSM)'
    },
    csmFeatureStorageLimitsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-limits.description',
        defaultMessage: '<strong>250 GB storage</strong> to support your customers',
        description: 'Description for the Storage Limits feature (CSM)'
    },
    // Feature: JSM Storage Limits
    jsmTeamsFeatureSupportArticlesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.support-articles.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written support articles</strong>',
        description: 'Description for the Knowledge Base feature in storage limits variant (service teams)'
    },
    jsmTeamsFeatureStorageLimitsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.storage-limits.description',
        defaultMessage: '<strong>250 GB storage</strong> to support your customers',
        description: 'Description for the Storage Limits feature (service teams)'
    },
    // Feature: Ops
    opsFeatureRovoOpsAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents',
        description: 'Description for the Rovo Ops agent feature (Ops)'
    },
    opsFeatureAssetsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description',
        defaultMessage: 'See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>',
        description: 'Description for the Assets feature (Ops)'
    },
    opsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description',
        defaultMessage: 'Move forward faster with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation rule runs feature (Ops)'
    },
    opsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited agents feature (Ops)'
    }
});

});



parcelRegister("jLgmq", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $98a612e8e1f14821$export$e926676385687eaf);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $jQYQa = parcelRequire("jQYQa");

var $51dxT = parcelRequire("51dxT");

var $022Hx = parcelRequire("022Hx");
const $98a612e8e1f14821$export$e926676385687eaf = ({ children: children, variantId: variantId })=>{
    const handleOnError = (0, $022Hx.useErrorAnalytics)({
        variantId: variantId
    });
    const ufoContext = (0, $51dxT.useInteractionContext)();
    const onError = (0, $fc4bM.useCallback)((error, errorInfo)=>{
        const interaction = (0, $jQYQa.getActiveInteraction)();
        handleOnError(error, errorInfo);
        if (interaction && ufoContext) (0, $jQYQa.addError)(interaction === null || interaction === void 0 ? void 0 : interaction.id, error.name, ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack, 'interaction error', error.message, error.stack);
        else (0, $jQYQa.addErrorToAll)(`ErrorBoundary:edition-benefits-modal${variantId ? `:${variantId}` : ''}`, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, 'interaction error', error.message);
    }, [
        handleOnError,
        variantId,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null)
    }, children);
};

});
parcelRegister("022Hx", function(module, exports) {
$parcel$export(module.exports, "useErrorAnalytics", () => $216921f630ea609e$export$e2d4523bbccd2343);

var $fc4bM = parcelRequire("fc4bM");

var $fe5C4 = parcelRequire("fe5C4");
/**
 * Errors which we ignore from SLO reporting to ensure we're only reporting on actionable errors
 */ const $216921f630ea609e$var$nonSLOErrors = [
    /**
 * These occur when the fetch request fails (usually due to network being offline)
 */ /failed to fetch/i,
    /**
 * These occur when the fetch request fails due to a server response (e.g. 401)
 */ /Error server response:/i
];
function $216921f630ea609e$var$isSLOError(error) {
    // Just checks that none of our non-SLO errors match the error
    return !$216921f630ea609e$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $216921f630ea609e$export$e2d4523bbccd2343({ variantId: variantId, operation: operation } = {}) {
    const sendOperationalEvent = (0, $fe5C4.useOperationalAnalytics)();
    return (0, $fc4bM.useCallback)((error, errorInfo)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-benefits-modal.edition-benefits-modal',
            attributes: {
                ...operation ? {
                    operation: operation
                } : {},
                variantId: variantId,
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                componentStack: errorInfo.componentStack,
                isSLOError: $216921f630ea609e$var$isSLOError(error)
            }
        });
    }, [
        sendOperationalEvent,
        variantId,
        operation
    ]);
}

});


parcelRegister("hut32", function(module, exports) {
$parcel$export(module.exports, "messages", () => $05bb0dfb7fe85b5b$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $05bb0dfb7fe85b5b$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    benefitsSectionButtonMaybeLater: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later',
        defaultMessage: 'Maybe later',
        description: 'Button in the edition benefits modal that allows the user to dismiss the upgrade prompt and return to it later.'
    },
    benefitsSectionButtonTryItFree: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Primary call-to-action button in the edition benefits modal that initiates a free trial of Premium features.'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1',
        defaultMessage: '<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
        description: 'Text for first feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2',
        defaultMessage: '<strong>Customise your help center</strong> to match your brand.',
        description: 'Text for second feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3',
        defaultMessage: '<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
        description: 'Text for third feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1',
        defaultMessage: 'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
        description: 'Text for first feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2',
        defaultMessage: 'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
        description: 'Text for second feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3',
        defaultMessage: '<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
        description: 'Text for third feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1',
        defaultMessage: 'Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.',
        description: 'Workforce Optimization feature row: scheduling'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2',
        defaultMessage: "Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
        description: 'Workforce Optimization feature row: capacity utilization'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3',
        defaultMessage: 'Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.',
        description: 'Workforce Optimization feature row: real-time auto routing'
    },
    benefitsSectionHeadingHelpCenterCustomization: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization',
        defaultMessage: 'Try advanced Help Center customisation with Premium',
        description: 'Heading for help-center-customization variant'
    },
    benefitsSectionHeadingIncidentsSlackIntegration: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration',
        defaultMessage: 'Resolve incidents with AI in Slack, try Premium now',
        description: 'Heading for incidents-slack-integration variant'
    },
    benefitsSectionLinkPricing: {
        id: '@atlassian/edition-benefits-modal.benefits-section.link.pricing',
        defaultMessage: 'See more Premium features and pricing',
        description: 'Link in the edition benefits modal that navigates the user to a page listing Premium features and their pricing.'
    },
    benefitsSectionSubtitle: {
        id: '@atlassian/edition-benefits-modal.benefits-section.subtitle',
        defaultMessage: "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
        description: 'Subtitle displayed in the benefits section of the edition benefits modal, explaining the free trial offer for Premium features.'
    },
    buttonTriggerOpenModal: {
        id: '@atlassian/edition-benefits-modal.button-trigger.open-modal',
        defaultMessage: 'Open modal',
        description: 'Text for the button that opens the edition benefits modal'
    },
    buttonTriggerTryItFree: {
        id: '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Button text for to trigger opening the premium benefits modal'
    },
    benefitsSectionHeadingJourneys: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.journeys',
        defaultMessage: 'Try Journeys with Premium',
        description: 'Heading for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionSubtitleContextualizedPremium: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.trial-description',
        defaultMessage: "Try free for 30 days. We\u2019ll remind you before it ends. Cancel anytime.",
        description: 'Subtitle for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextJourneysFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.self-service',
        defaultMessage: '<strong>Improve self service</strong> with AI-powered virtual agent and no-code journeys.',
        description: 'First feature row for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextJourneysFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.branded-front-door',
        defaultMessage: '<strong>Give every team a branded front door</strong> with multiple help centres',
        description: 'Second feature row for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextJourneysFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.track-team-dependencies',
        defaultMessage: '<strong>Track what your teams rely on</strong> with AI-driven workflows and up to 50,000 objects in Assets',
        description: 'Third feature row for the Journeys contextualised upgrade variant.'
    },
    benefitsSectionHeadingChangeManagement: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.change-management',
        defaultMessage: 'Try Change management with Premium',
        description: 'Heading for the change-management contextualised upgrade variant.'
    },
    benefitsSectionHeadingProblemManagement: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.problem-management',
        defaultMessage: 'Try Problem management with Premium',
        description: 'Heading for the problem-management contextualised upgrade variant.'
    },
    benefitsSectionHeadingPostIncidentReviews: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.post-incident-reviews',
        defaultMessage: 'Try Post-incident reviews with Premium',
        description: 'Heading for the post-incident-reviews contextualised upgrade variant.'
    },
    benefitsSectionHeadingPlaybooks: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.playbooks',
        defaultMessage: 'Try Playbooks with Premium',
        description: 'Heading for the playbooks contextualised upgrade variant.'
    },
    benefitsSectionFeatureTitleOperationalFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.title',
        defaultMessage: '<strong>Resolve incidents faster</strong>',
        description: 'First benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureDescriptionOperationalFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.resolve-incidents-faster.description',
        defaultMessage: 'AI-powered alerts group related incidents and surfaces root causes.',
        description: 'First benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTitleOperationalFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.title',
        defaultMessage: '<strong>Ship changes without the risk</strong>',
        description: 'Second benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureDescriptionOperationalFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.ship-changes-safely.description',
        defaultMessage: 'Automated risk scoring and approvals to keep your deploys safe.',
        description: 'Second benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTitleOperationalFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.title',
        defaultMessage: '<strong>Scale your services confidently</strong>',
        description: 'Third benefit title for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureDescriptionOperationalFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.scale-services-confidently.description',
        defaultMessage: '24/7 Premium support and unlimited storage keep your team moving.',
        description: 'Third benefit description for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTextOperationalFeature1: {
        id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature1',
        defaultMessage: '<strong>Resolve incidents faster</strong> with AI-powered alerts that group related incidents and surface root causes.',
        description: 'First feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTextOperationalFeature2: {
        id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature2',
        defaultMessage: '<strong>Ship changes safely</strong> with automated risk scoring and approvals.',
        description: 'Second feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionFeatureTextOperationalFeature3: {
        id: 'edition-benefits-modal.benefitsSectionFeatureTextOperationalFeature3',
        defaultMessage: '<strong>Scale your services confidently</strong> with 24/7 Premium support and unlimited storage.',
        description: 'Third feature row for the problem-management, change-management, post-incident-reviews, and playbooks contextualised upgrade variants.'
    },
    benefitsSectionHeadingAlertGrouping: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.heading.alert-grouping',
        defaultMessage: 'AI alert grouping with Premium',
        description: 'Heading for the AI alert grouping contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextAlertGroupingFeature1: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature1',
        defaultMessage: '<strong>Resolve incidents faster</strong> with AI-powered alerting, auto-grouping, and root cause analysis.',
        description: 'First feature row for the AI alert grouping contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextAlertGroupingFeature2: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature2',
        defaultMessage: '<strong>Deploy safely with AI risk scoring,</strong> automated approvals, and change calendars.',
        description: 'Second feature row for the AI alert grouping contextualised upgrade variant.'
    },
    benefitsSectionFeatureTextAlertGroupingFeature3: {
        id: '@atlassian/edition-benefits-modal.contextualized-premium.benefit.alert-grouping.feature3',
        defaultMessage: '<strong>Scale confidently</strong> with 24/7 Premium Support, and unlimited storage.',
        description: 'Third feature row for the AI alert grouping contextualised upgrade variant.'
    }
});

});

parcelRegister("1U9sH", function(module, exports) {
$parcel$export(module.exports, "premiumEditionBenefitsModalEntryPoint", () => $4762db297ab1dc37$export$262ed5b18480f6c7);

var $1iT7n = parcelRequire("1iT7n");

var $d9f9n = parcelRequire("d9f9n");

var $9YkWt = parcelRequire("9YkWt");

var $27H6j = parcelRequire("27H6j");

const $4762db297ab1dc37$export$262ed5b18480f6c7 = (0, $d9f9n.createEntryPoint)({
    root: (0, $1iT7n.JSResourceForInteraction)(()=>(parcelRequire("35yD2")), {
        moduleId: "cb5e16cf",
        priority: "interaction",
        moduleId: 'edition-benefits-modal-premium-benefits-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                premiumBenefitsModalQuery: {
                    parameters: (0, $27H6j.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $9YkWt.getHamsKey)(product)
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                product: product
            }
        })
});

});
parcelRegister("1iT7n", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $049437800beb59eb$export$e83743682263315a);

var $34FWm = parcelRequire("34FWm");

var $8m5B2 = parcelRequire("8m5B2");

var $52hJB = parcelRequire("52hJB");
const $049437800beb59eb$var$cache = (0, $34FWm.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $049437800beb59eb$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $049437800beb59eb$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$049437800beb59eb$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    const { chain: chain } = opts ?? {};
    return $049437800beb59eb$var$cache.get(opts.moduleId, ()=>(0, $8m5B2.PreloadableJSResource)(()=>(0, $52hJB.postTask)(chain ? ()=>chain(Promise.resolve(loaderOrPath())) : loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("34FWm", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $c0848622752d0dca$export$cf6fa0bbcc94b912);
function $c0848622752d0dca$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("8m5B2", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $79c7370a209dd336$export$4fe5fba5bb1d3c09);

var $cUxpS = parcelRequire("cUxpS");
function $79c7370a209dd336$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $cUxpS.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("cUxpS", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $b5b4bca829e6e8ad$export$148e45a6d4b4d65);

var $6tZne = parcelRequire("6tZne");

var $ilALr = parcelRequire("ilALr");

var $46vei = parcelRequire("46vei");
function $b5b4bca829e6e8ad$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $ilALr.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $ilALr.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners){
                var _listener$onError;
                (_listener$onError = listener.onError) === null || _listener$onError === void 0 || _listener$onError.call(listener, error);
            }
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6tZne.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $ilALr.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $46vei.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError === null || onError === void 0 || onError(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("6tZne", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $612d5e95d46a8bd0$export$567fc7097e064344);
let $612d5e95d46a8bd0$var$id = 100000;
function $612d5e95d46a8bd0$export$567fc7097e064344() {
    $612d5e95d46a8bd0$var$id += 1;
    return $612d5e95d46a8bd0$var$id.toString();
}

});

parcelRegister("ilALr", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $0aebfb9edebda6bc$export$10dc3edfc20c8ff);
function $0aebfb9edebda6bc$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $0aebfb9edebda6bc$export$10dc3edfc20c8ff = $0aebfb9edebda6bc$var$createEventEmitter();

});

parcelRegister("46vei", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $2903c237a24daecf$export$3b514faac3ba993c);
function $2903c237a24daecf$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("52hJB", function(module, exports) {
$parcel$export(module.exports, "postTask", () => $d4010b947c67834c$export$13c9d02ca54955a3);
async function $d4010b947c67834c$var$toPromise(callback) {
    return callback();
}
function $d4010b947c67834c$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d4010b947c67834c$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d4010b947c67834c$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("4uCUv")).then(()=>$d4010b947c67834c$var$getScheduler(globalThis).postTask(callback, options));
        return $d4010b947c67834c$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("4uCUv", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("e5yvg").then(()=>parcelRequire('8RUAL'));

});



parcelRegister("d9f9n", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $9936f53accfd76d7$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/no-empty-object-type */ function $9936f53accfd76d7$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("9YkWt", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $951efa39de8fd008$export$291d012eb0744b34);
const $951efa39de8fd008$var$ProductKeyToHAMSMap = {
    ['jira']: 'jira-software',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['confluence']: 'confluence',
    ['jira-customer-service']: 'jira-customer-service'
};
// Pre-built reverse lookup for `getProductFromHamsKey`, so the map is not rebuilt on every call.
const $951efa39de8fd008$var$HAMSToProductKeyMap = Object.fromEntries(Object.entries($951efa39de8fd008$var$ProductKeyToHAMSMap).map(([product, hamsKey])=>[
        hamsKey,
        product
    ]));
const $951efa39de8fd008$export$291d012eb0744b34 = (product)=>{
    return $951efa39de8fd008$var$ProductKeyToHAMSMap[product];
};
const $951efa39de8fd008$export$3658e62040c7be00 = (hamsProductKey)=>{
    return $951efa39de8fd008$var$HAMSToProductKeyMap[hamsProductKey] ?? 'jira-service-management';
};

});

parcelRegister("27H6j", function(module, exports) {
$parcel$export(module.exports, "default", () => $c17b3f230baa957f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f71f4408d1068bddb46758e4ae198ef1>>
 * @relayHash 0364ebf04a149c5cd5b923316a2324ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845

var $5KQKg = parcelRequire("5KQKg");
const $c17b3f230baa957f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845",
            "metadata": {},
            "name": "premiumBenefitsModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c17b3f230baa957f$var$node.hash = "0854408facd8d9c64a16089df4b3226a";
(0, $5KQKg.PreloadableQueryRegistry).set($c17b3f230baa957f$var$node.params.id, $c17b3f230baa957f$var$node);
var $c17b3f230baa957f$export$2e2bcd8739ae039 = $c17b3f230baa957f$var$node;

});

parcelRegister("35yD2", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3KK3D"),
    $9dnsd("aPyl4"),
    $9dnsd("hOTnS"),
    $9dnsd("6Df0C"),
    $9dnsd("4SQTv"),
    $9dnsd("aPbFz"),
    $9dnsd("kQR2c")
]).then(()=>parcelRequire('ialWw'));

});



parcelRegister("cJsi5", function(module, exports) {
$parcel$export(module.exports, "editionBenefitsModalEntryPoint", () => $6200c1f6cb4ece7e$export$4708c4eaa8d901cd);

var $1iT7n = parcelRequire("1iT7n");

var $d9f9n = parcelRequire("d9f9n");

var $9YkWt = parcelRequire("9YkWt");

var $iH8mf = parcelRequire("iH8mf");

var $2uJw0 = parcelRequire("2uJw0");

const $6200c1f6cb4ece7e$export$4708c4eaa8d901cd = (0, $d9f9n.createEntryPoint)({
    root: (0, $1iT7n.JSResourceForInteraction)(()=>(parcelRequire("bacVA")), {
        moduleId: "f335c645",
        priority: "interaction",
        moduleId: 'edition-benefits-modal-relay'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                editionBenefitsModalRelayQuery: {
                    parameters: (0, $2uJw0.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $9YkWt.getHamsKey)(product),
                        projectType: (0, $iH8mf.getProjectType)(product)
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                product: product
            }
        })
});

});
parcelRegister("iH8mf", function(module, exports) {
$parcel$export(module.exports, "getProjectType", () => $3ee73842ca77cf0d$export$3dd0da95519c1a33);
const $3ee73842ca77cf0d$export$3dd0da95519c1a33 = (product)=>{
    switch(product){
        case 'jira-service-management':
            return 'SERVICE_DESK';
        case 'jira-customer-service':
            return 'CUSTOMER_SERVICE';
        case 'jira':
            return 'SOFTWARE';
        case 'jira-product-discovery':
            return 'PRODUCT_DISCOVERY';
        case 'confluence':
            throw new Error('Confluence is not supported');
        default:
            throw new Error('Product not supported');
    }
};

});

parcelRegister("2uJw0", function(module, exports) {
$parcel$export(module.exports, "default", () => $df4b496f22d12be1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74a53ad6421f1c8d7280d9877d928236>>
 * @relayHash ef1111bd15d10eaaab0f3bd5698ebf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228

var $5KQKg = parcelRequire("5KQKg");
const $df4b496f22d12be1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudUrl"
    }, v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "product",
                "value": "jira"
            }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            }
        ],
        "storageKey": "activationIdByProduct(product:\"jira\")"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            },
            {
                "alias": "changeToStandard",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Standard"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v7 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            }
        ]
    }, v9 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v11 = {
        "concreteType": "CcpBillingPeriodDetails",
        "kind": "LinkedField",
        "name": "billingPeriodDetails",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "nextBillingTimestamp"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v13 = {
        "concreteType": "CcpInvoiceGroupExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "configurePaymentV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v16 = {
        "concreteType": "CcpTransactionAccountExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "addPaymentMethodV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            v20 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228",
            "metadata": {},
            "name": "editionBenefitsModalRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$df4b496f22d12be1$var$node.hash = "4adcf3c0d1fd080dc809373daae7326c";
(0, $5KQKg.PreloadableQueryRegistry).set($df4b496f22d12be1$var$node.params.id, $df4b496f22d12be1$var$node);
var $df4b496f22d12be1$export$2e2bcd8739ae039 = $df4b496f22d12be1$var$node;

});

parcelRegister("bacVA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("e5Mjn"),
    $9dnsd("l2eNU"),
    $9dnsd("lpRgZ"),
    $9dnsd("4gopr"),
    $9dnsd("3KK3D"),
    $9dnsd("aPyl4"),
    $9dnsd("dLsDK"),
    $9dnsd("1so0j"),
    $9dnsd("hOTnS"),
    $9dnsd("5nj3m"),
    $9dnsd("h5Ikc"),
    $9dnsd("5GRLL"),
    $9dnsd("fS2tZ"),
    $9dnsd("dxPDb"),
    $9dnsd("3ckMX"),
    $9dnsd("5sb3y"),
    $9dnsd("gjCvi"),
    $9dnsd("7Xeve"),
    $9dnsd("6Df0C"),
    $9dnsd("8QhuV"),
    $9dnsd("4SQTv"),
    $9dnsd("cMYEM"),
    $9dnsd("7etds"),
    $9dnsd("aPbFz"),
    $9dnsd("jA2KX")
]).then(()=>parcelRequire('gWpuO'));

});


parcelRegister("bzsGe", function(module, exports) {
$parcel$export(module.exports, "clearSidebarExperienceAndCustomize", () => $04ebaef26f53196f$export$4367df47a43e5f96);

var $6rayQ = parcelRequire("6rayQ");
const $04ebaef26f53196f$export$47b19daccaa881f2 = ()=>{
    return (0, $6rayQ.get)('experience');
};
const $04ebaef26f53196f$export$4367df47a43e5f96 = ()=>{
    (0, $6rayQ.set)({
        customize: undefined,
        experience: undefined
    });
};

});

parcelRegister("4ZWZy", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => (parcelRequire("eFtAu")).ARTICLES_RESULT_LIMIT);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => (parcelRequire("eFtAu")).INITIAL_ARTICLES_LIMIT);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => (parcelRequire("eFtAu")).PORTALS_RESULT_LIMIT);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => (parcelRequire("eFtAu")).REQUEST_FORMS_NEW_LIMIT);
$parcel$export(module.exports, "SEARCH_QUERY_CHARACTER_LIMIT", () => (parcelRequire("eFtAu")).SEARCH_QUERY_CHARACTER_LIMIT);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => (parcelRequire("eFtAu")).SEARCH_QUERY_DEBOUNCE_TIME);
$parcel$export(module.exports, "DropdownOptionList", () => (parcelRequire("cd2Ru")).DropdownOptionList);
$parcel$export(module.exports, "Img", () => (parcelRequire("cd2Ru")).Img);
$parcel$export(module.exports, "InlineResultLink", () => (parcelRequire("cd2Ru")).InlineResultLink);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => (parcelRequire("cd2Ru")).InlineResultsHeadingWrapper);
$parcel$export(module.exports, "ResultList", () => (parcelRequire("cd2Ru")).ResultList);
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => (parcelRequire("cd2Ru")).SEARCH_BAR_HEIGHT);
$parcel$export(module.exports, "formatText", () => (parcelRequire("b52IZ")).formatText);
$parcel$export(module.exports, "formatToCleanText", () => (parcelRequire("b52IZ")).formatToCleanText);
$parcel$export(module.exports, "getIdsArray", () => (parcelRequire("b52IZ")).getIdsArray);
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("b52IZ")).getPortalIdAsNumber);
$parcel$export(module.exports, "isSearchQueryOverCharacterLimit", () => (parcelRequire("b52IZ")).isSearchQueryOverCharacterLimit);
$parcel$export(module.exports, "isSinglePortalSearch", () => (parcelRequire("b52IZ")).isSinglePortalSearch);
$parcel$export(module.exports, "isValidSearchTerm", () => (parcelRequire("b52IZ")).isValidSearchTerm);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => (parcelRequire("b52IZ")).sendSearchOperationalAnalyticEvents);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => (parcelRequire("b52IZ")).sendSearchUIAnalyticEvents);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("b52IZ")).useQueryParams);
$parcel$export(module.exports, "useVisibilityState", () => (parcelRequire("b52IZ")).useVisibilityState);
parcelRequire("eFtAu");
parcelRequire("cd2Ru");
parcelRequire("b52IZ");

});
parcelRegister("eFtAu", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => $7c1c0a24d6921465$export$38c99458b97d4d4);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => $7c1c0a24d6921465$export$d687c15f4e8fd960);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => $7c1c0a24d6921465$export$f63f00916950640a);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => $7c1c0a24d6921465$export$95aa4d213e66754b);
$parcel$export(module.exports, "SEARCH_QUERY_CHARACTER_LIMIT", () => $7c1c0a24d6921465$export$5a87aa56eba7a19a);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => $7c1c0a24d6921465$export$16da0cbbeac3310c);
const $7c1c0a24d6921465$export$38c99458b97d4d4 = 30;
const $7c1c0a24d6921465$export$d687c15f4e8fd960 = 5;
const $7c1c0a24d6921465$export$f63f00916950640a = 10;
const $7c1c0a24d6921465$export$95aa4d213e66754b = 300;
const $7c1c0a24d6921465$export$5a87aa56eba7a19a = 750;
const $7c1c0a24d6921465$export$16da0cbbeac3310c = 15;

});

parcelRegister("cd2Ru", function(module, exports) {
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => $5e5cdbe4ba916446$export$9ac4f4162406e081);
$parcel$export(module.exports, "ResultList", () => $5e5cdbe4ba916446$export$7ebf7682ef098fb8);
$parcel$export(module.exports, "Img", () => $5e5cdbe4ba916446$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => $5e5cdbe4ba916446$export$a8317adc66cb9be6);
$parcel$export(module.exports, "InlineResultLink", () => $5e5cdbe4ba916446$export$5a34ff55d4e5e484);
$parcel$export(module.exports, "DropdownOptionList", () => $5e5cdbe4ba916446$export$b5e293376cc6b1ce);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $io4o2 = parcelRequire("io4o2");
const $5e5cdbe4ba916446$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $5e5cdbe4ba916446$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $5e5cdbe4ba916446$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $5e5cdbe4ba916446$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $5e5cdbe4ba916446$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $io4o2.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $5e5cdbe4ba916446$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b52IZ", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $a64c08805f2a0537$export$905fe28a7c283e1d);
$parcel$export(module.exports, "formatToCleanText", () => $a64c08805f2a0537$export$519cc8c1640d01b8);
$parcel$export(module.exports, "useQueryParams", () => $a64c08805f2a0537$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "isSinglePortalSearch", () => $a64c08805f2a0537$export$3bdd4cf348080703);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $a64c08805f2a0537$export$c36431be801010b);
$parcel$export(module.exports, "isValidSearchTerm", () => $a64c08805f2a0537$export$34d09b0baed7315d);
$parcel$export(module.exports, "isSearchQueryOverCharacterLimit", () => $a64c08805f2a0537$export$cdf01900fed9ff7d);
$parcel$export(module.exports, "getIdsArray", () => $a64c08805f2a0537$export$b78190df63b1b0c4);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => $a64c08805f2a0537$export$c8b38685f22f1bb2);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => $a64c08805f2a0537$export$653243929c3168a8);
$parcel$export(module.exports, "useVisibilityState", () => $a64c08805f2a0537$export$54299a3c81f5425);

var $fc4bM = parcelRequire("fc4bM");

var $hl35j = parcelRequire("hl35j");

var $6Hr8Z = parcelRequire("6Hr8Z");

var $eSHpe = parcelRequire("eSHpe");

var $ikzOZ = parcelRequire("ikzOZ");

var $cQB7H = parcelRequire("cQB7H");

var $6dipk = parcelRequire("6dipk");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $eFtAu = parcelRequire("eFtAu");
const $a64c08805f2a0537$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $a64c08805f2a0537$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $a64c08805f2a0537$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $cQB7H.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $a64c08805f2a0537$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $cQB7H.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $a64c08805f2a0537$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $7lAXH.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $fc4bM.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($6dipk))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $fc4bM.useMemo)(()=>$a64c08805f2a0537$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $fc4bM.useMemo)(()=>$a64c08805f2a0537$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $a64c08805f2a0537$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $a64c08805f2a0537$export$c36431be801010b(portalId) !== 0;
const $a64c08805f2a0537$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $a64c08805f2a0537$export$cdf01900fed9ff7d = (term)=>Boolean(term && term.length > (0, $eFtAu.SEARCH_QUERY_CHARACTER_LIMIT));
const $a64c08805f2a0537$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ikzOZ)))(portalId);
};
const $a64c08805f2a0537$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6Hr8Z)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($eSHpe)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($hl35j)))(ids) ? ids : [];
    }
    return [];
};
const $a64c08805f2a0537$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId, isInlineResult)=>{
    if (isInlineResult) eventProperties.actionSubjectId = 'inlineResult';
    else eventProperties.actionSubjectId = portalId ? 'singlePortal' : 'portalHomePage';
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: eventProperties.actionSubjectId,
        ...eventProperties
    }).fire();
};
const $a64c08805f2a0537$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    const statusCode = eventProperties.statusCode;
    if (statusCode !== 403 && statusCode !== 429) createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $a64c08805f2a0537$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $fc4bM.useState)(false);
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $fc4bM.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});
parcelRegister("6Hr8Z", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $4e0bd071b71a7089$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $4e0bd071b71a7089$var$isNumber(value) {
    return typeof value == 'number' || $8GSh0(value) && $daBML(value) == $4e0bd071b71a7089$var$numberTag;
}
module.exports = $4e0bd071b71a7089$var$isNumber;

});

parcelRegister("eSHpe", function(module, exports) {

var $daBML = parcelRequire("daBML");

var $hl35j = parcelRequire("hl35j");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $ad57c75c3c56d9f4$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $ad57c75c3c56d9f4$var$isString(value) {
    return typeof value == 'string' || !$hl35j(value) && $8GSh0(value) && $daBML(value) == $ad57c75c3c56d9f4$var$stringTag;
}
module.exports = $ad57c75c3c56d9f4$var$isString;

});

parcelRegister("ikzOZ", function(module, exports) {

var $hvPlV = parcelRequire("hvPlV");

var $8G70j = parcelRequire("8G70j");
/** Used as references for various `Number` constants. */ var $d585e1a0e8f7d14b$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */ function $d585e1a0e8f7d14b$var$toSafeInteger(value) {
    return value ? $hvPlV($8G70j(value), -$d585e1a0e8f7d14b$var$MAX_SAFE_INTEGER, $d585e1a0e8f7d14b$var$MAX_SAFE_INTEGER) : value === 0 ? value : 0;
}
module.exports = $d585e1a0e8f7d14b$var$toSafeInteger;

});
parcelRegister("hvPlV", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $cbfd2a7b54f4de2d$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $cbfd2a7b54f4de2d$var$baseClamp;

});


parcelRegister("cQB7H", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fb5b70250863b3e$export$2e2bcd8739ae039);

var $aYMdQ = parcelRequire("aYMdQ");
function $4fb5b70250863b3e$export$2e2bcd8739ae039(textHtml, keyword) {
    const escapedTextHtml = (0, $aYMdQ.escape)(textHtml);
    if (keyword) {
        const dynamicRegex = new RegExp(`([^_\\s,-]*)${(0, $aYMdQ.escapeRegExp)((0, $aYMdQ.escape)(keyword))}([^_\\s,-]*)`, 'gi');
        return escapedTextHtml.replace(dynamicRegex, (match)=>{
            return `<strong>${match}</strong>`;
        });
    }
    return escapedTextHtml;
}

});



parcelRegister("uYmrU", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccess", () => $744df54251bb1007$export$4962f3898bd5c829);

var $fc4bM = parcelRequire("fc4bM");
const $744df54251bb1007$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $fc4bM.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("l5sYc", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => (parcelRequire("6oPaA")).AccountDetails);

var $6oPaA = parcelRequire("6oPaA");

});
parcelRegister("6oPaA", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $08444efb16432265$export$66e04d0aacdb3b2);
/* account-details.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $cWkQ8 = parcelRequire("cWkQ8");

var $9v7Ro = parcelRequire("9v7Ro");

var $3rlj9 = parcelRequire("3rlj9");
const $08444efb16432265$export$66e04d0aacdb3b2 = ({ avatarSrc: avatarSrc, displayName: displayName, email: email })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($08444efb16432265$var$NonInteractiveLinkItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($08444efb16432265$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($08444efb16432265$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWkQ8.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($08444efb16432265$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($08444efb16432265$var$DisplayName, null, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("small", null, email)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08444efb16432265$var$NonInteractiveLinkItem = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $9v7Ro.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_lcxvglyw _syaz261p",
            __cmplp.className
        ])
    });
});
const $08444efb16432265$var$ProfileWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $08444efb16432265$var$AvatarWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $08444efb16432265$var$DisplayName = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $08444efb16432265$var$DetailsWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9v7Ro", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a6d36833ffd1b00$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $b7gcM = parcelRequire("b7gcM");

var $fVzQQ = parcelRequire("fVzQQ");

var $8SiHp = parcelRequire("8SiHp");
const $0a6d36833ffd1b00$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $0a6d36833ffd1b00$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $0a6d36833ffd1b00$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $0a6d36833ffd1b00$var$LinkItem = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $b7gcM.useRouterLink)();
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const handleClick = (0, $fc4bM.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $0a6d36833ffd1b00$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $0a6d36833ffd1b00$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8SiHp.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $0a6d36833ffd1b00$var$preventEvent
                },
                onMouseDown: isDisabled ? $0a6d36833ffd1b00$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $0a6d36833ffd1b00$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref,
                children: children
            })
    });
}));
var $0a6d36833ffd1b00$export$2e2bcd8739ae039 = $0a6d36833ffd1b00$var$LinkItem;

});



parcelRegister("4G9Kl", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterCreationUrl", () => $e98e61bb62458b32$export$67b3de424cdc98a6);

var $9mazR = parcelRequire("9mazR");

var $k2M4v = parcelRequire("k2M4v");
const $e98e61bb62458b32$var$HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
const $e98e61bb62458b32$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT = 'jira_sidebar_show_helpcenter';
const $e98e61bb62458b32$export$67b3de424cdc98a6 = (jiraDisplayUrl = '')=>(0, $k2M4v.default).checkGate($e98e61bb62458b32$var$HELP_HUB_MIGRATION_GATE) && (0, $k2M4v.default).getExperimentValue($e98e61bb62458b32$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT, 'isEnabled', false) ? `${jiraDisplayUrl}/jira/helpcenter-management?create=true` : `${0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH}?create=true`;

});

parcelRegister("knBhf", function(module, exports) {
$parcel$export(module.exports, "ProfileMenuUpdateSpotlight", () => (parcelRequire("dtoUQ")).ProfileMenuUpdateSpotlight);
$parcel$export(module.exports, "ProfileMenuUpdateSpotlightProvider", () => (parcelRequire("dtoUQ")).ProfileMenuUpdateSpotlightProvider);
$parcel$export(module.exports, "UpdateHelpCenterSpotlight", () => (parcelRequire("dtoUQ")).UpdateHelpCenterSpotlight);

var $dtoUQ = parcelRequire("dtoUQ");

});
parcelRegister("dtoUQ", function(module, exports) {
$parcel$export(module.exports, "UpdateHelpCenterSpotlight", () => $d3e104fb0f0b94f0$export$5ca51dbe4e2132dc);
$parcel$export(module.exports, "ProfileMenuUpdateSpotlightProvider", () => $d3e104fb0f0b94f0$export$87b65999579a1a85);
$parcel$export(module.exports, "ProfileMenuUpdateSpotlight", () => $d3e104fb0f0b94f0$export$2bc3d1630435667e);
/* update-help-center-spotlight.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $j5N6B = parcelRequire("j5N6B");

var $k2M4v = parcelRequire("k2M4v");

var $egr3p = parcelRequire("egr3p");

var $dBtOK = parcelRequire("dBtOK");

var $dZSRd = parcelRequire("dZSRd");

var $jZIg5 = parcelRequire("jZIg5");

var $dpvO8 = parcelRequire("dpvO8");

var $lUS3A = parcelRequire("lUS3A");

var $2GRNQ = parcelRequire("2GRNQ");

var $fNKQE = parcelRequire("fNKQE");

var $KeOHl = parcelRequire("KeOHl");

var $6vMv1 = parcelRequire("6vMv1");

var $hjiim = parcelRequire("hjiim");

var $jHTNF = parcelRequire("jHTNF");

var $8Bu6G = parcelRequire("8Bu6G");

var $7YSeN = parcelRequire("7YSeN");

var $apntv = parcelRequire("apntv");

var $bcTS3 = parcelRequire("bcTS3");

var $e8sGC = parcelRequire("e8sGC");

var $6q6nO = parcelRequire("6q6nO");

var $6F0AN = parcelRequire("6F0AN");
parcelRequire("l12iT");
var $aHrj0 = parcelRequire("aHrj0");
const $d3e104fb0f0b94f0$export$19f63e8f1043cd39 = 'post-office_help-center-migration-onboarding';
const $d3e104fb0f0b94f0$export$6c9deb1363deebc3 = 'jsm-help-center-management-update-help-center-onboarding';
/** The spotlight of the Post Office template anchored on the Update help center button. */ const $d3e104fb0f0b94f0$var$MANAGEMENT_PAGE_FEATURE_ID = 'update-help-center';
/** The spotlight anchored on View all help centers in the avatar menu. */ const $d3e104fb0f0b94f0$var$PROFILE_MENU_FEATURE_ID = 'update-help-center-profile-menu';
// The card renders in place, so it would otherwise inherit its anchor's text styles: the page
// header actions' `white-space: nowrap` stops its copy wrapping, and the help center header's
// `line-height: 0` stacks the lines of its body on top of each other.
const $d3e104fb0f0b94f0$var$styles = {
    card: "_11c81jhk _o5724jg8",
    highlightedItem: "_bfhk1dpa"
};
const $d3e104fb0f0b94f0$var$useSpotlightMessage = (featureId)=>{
    const { messageInstanceIds: messageInstanceIds, PostOfficeMessageInstance: PostOfficeMessageInstance, dismissMessage: dismissMessage } = (0, $e8sGC.useMessageInstances)({
        placementId: 'headless',
        messageTemplateId: $d3e104fb0f0b94f0$export$6c9deb1363deebc3
    }, {
        match: ({ data: data, matchBuilder: matchBuilder })=>matchBuilder.messageContext((context)=>context.featureId === featureId).match(data)
    });
    return {
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissMessage: dismissMessage,
        messageInstanceId: messageInstanceIds[0]
    };
};
const $d3e104fb0f0b94f0$var$UpdateHelpCenterSpotlightCard = ({ children: children, message: message, placement: placement, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { messageInstanceId: messageInstanceId, PostOfficeMessageInstance: PostOfficeMessageInstance, dismissMessage: dismissMessage } = message;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8Bu6G.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7YSeN.PopoverTarget), null, children), messageInstanceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PostOfficeMessageInstance, {
        messageInstanceId: messageInstanceId
    }, (_message, interactions)=>{
        const handleGotIt = ()=>{
            interactions === null || interactions === void 0 || interactions.onAcknowledged({
                interactionIdentifier: 'got-it'
            });
            dismissMessage(messageInstanceId);
        };
        const handleClose = (interactionIdentifier)=>{
            interactions === null || interactions === void 0 || interactions.onClosed({
                interactionIdentifier: interactionIdentifier
            });
            dismissMessage(messageInstanceId);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jHTNF.PopoverContent), {
            isVisible: true,
            placement: placement,
            dismiss: ()=>handleClose('popover-dismiss')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            xcss: $d3e104fb0f0b94f0$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dpvO8.SpotlightCard), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $KeOHl.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6vMv1.SpotlightHeadline), null, formatMessage((0, $6F0AN.default).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lUS3A.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
            content: formatMessage((0, $6F0AN.default).dismiss)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2GRNQ.SpotlightDismissControl), {
            autoFocus: false,
            onClick: ()=>handleClose('dismiss'),
            testId: `${testId}-dismiss`
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hjiim.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $egr3p.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6q6nO))),
            alt: "",
            testId: `${testId}-illustration`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jZIg5.SpotlightBody), null, formatMessage((0, $6F0AN.default).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fNKQE.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dZSRd.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apntv.SpotlightPrimaryAction), {
            onClick: handleGotIt,
            testId: `${testId}-got-it`
        }, formatMessage((0, $6F0AN.default).gotIt)))))));
    }) : null);
};
const $d3e104fb0f0b94f0$export$5ca51dbe4e2132dc = ({ children: children })=>{
    if (!(0, $j5N6B.getDocument)() || !(0, $k2M4v.default).checkGate($d3e104fb0f0b94f0$export$19f63e8f1043cd39)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aHrj0.PostOfficeScope), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3e104fb0f0b94f0$var$ManagementPageSpotlight, null, children));
};
const $d3e104fb0f0b94f0$var$ManagementPageSpotlight = ({ children: children })=>{
    const message = $d3e104fb0f0b94f0$var$useSpotlightMessage($d3e104fb0f0b94f0$var$MANAGEMENT_PAGE_FEATURE_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3e104fb0f0b94f0$var$UpdateHelpCenterSpotlightCard, {
        message: message,
        placement: "bottom-start",
        testId: "update-help-center-spotlight"
    }, children);
};
const $d3e104fb0f0b94f0$var$ProfileMenuSpotlightContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $d3e104fb0f0b94f0$export$87b65999579a1a85 = ({ children: children, isEnabled: isEnabled, ...props })=>{
    if (!isEnabled || !(0, $j5N6B.getDocument)() || !(0, $k2M4v.default).checkGate($d3e104fb0f0b94f0$export$19f63e8f1043cd39)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aHrj0.PostOfficeScope), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3e104fb0f0b94f0$var$ProfileMenuSpotlightMessage, props, children));
};
const $d3e104fb0f0b94f0$var$ProfileMenuSpotlightMessage = ({ children: children, isMenuOpen: isMenuOpen, onOpenMenu: onOpenMenu })=>{
    const message = $d3e104fb0f0b94f0$var$useSpotlightMessage($d3e104fb0f0b94f0$var$PROFILE_MENU_FEATURE_ID);
    const { messageInstanceId: messageInstanceId, dismissMessage: dismissMessage } = message;
    const hasMenuOpened = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        if (messageInstanceId) onOpenMenu();
    }, [
        messageInstanceId,
        onOpenMenu
    ]);
    // Closing the menu any other way, e.g. from the avatar or Escape, ends the spotlight too.
    (0, $fc4bM.useEffect)(()=>{
        if (!messageInstanceId) return;
        if (isMenuOpen) hasMenuOpened.current = true;
        else if (hasMenuOpened.current) dismissMessage(messageInstanceId);
    }, [
        dismissMessage,
        isMenuOpen,
        messageInstanceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3e104fb0f0b94f0$var$ProfileMenuSpotlightContext.Provider, {
        value: message
    }, children);
};
const $d3e104fb0f0b94f0$export$2bc3d1630435667e = ({ children: children })=>{
    const message = (0, $fc4bM.useContext)($d3e104fb0f0b94f0$var$ProfileMenuSpotlightContext);
    if (!message) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3e104fb0f0b94f0$var$UpdateHelpCenterSpotlightCard, {
        message: message,
        placement: "left-end",
        testId: "avatar-menu-update-help-center-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: message.messageInstanceId ? $d3e104fb0f0b94f0$var$styles.highlightedItem : undefined,
        testId: "avatar-menu-update-help-center-spotlight-target"
    }, children));
};

});
parcelRegister("egr3p", function(module, exports) {
$parcel$export(module.exports, "default", () => $e848b0a92ca30dc6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $78V0m = parcelRequire("78V0m");

var $anluN = parcelRequire("anluN");
const $e848b0a92ca30dc6$var$baseImageStyles = null;
function $e848b0a92ca30dc6$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $fc4bM.useRef)(null);
    const providedColorMode = (0, $78V0m.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $anluN.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $fc4bM.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("78V0m", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $6b2cef1377d9759c$export$ce91654eb9fea460);

var $fc4bM = parcelRequire("fc4bM");

var $9ulCF = parcelRequire("9ulCF");
function $6b2cef1377d9759c$export$ce91654eb9fea460() {
    const value = (0, $fc4bM.useContext)((0, $9ulCF.ColorModeContext));
    return value;
}

});


parcelRegister("dZSRd", function(module, exports) {
$parcel$export(module.exports, "SpotlightActions", () => $4490206136b44e68$export$205c28213090dc52);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $26fPW = parcelRequire("26fPW");
const $4490206136b44e68$var$styles = {
    root: "_1bsb1osq"
};
const $4490206136b44e68$export$205c28213090dc52 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
        ref: ref,
        testId: testId,
        xcss: $4490206136b44e68$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});

});

parcelRegister("jZIg5", function(module, exports) {
$parcel$export(module.exports, "SpotlightBody", () => $adbaaa375ff8897b$export$4ae665cf62a00c3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $adbaaa375ff8897b$var$styles = {
    root: "_18zrpxbi _syaz15cr _1q51u2gc"
};
const $adbaaa375ff8897b$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        ref: ref,
        xcss: $adbaaa375ff8897b$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("dpvO8", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $f626ffa03817e584$export$14710e13fc01d383);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $5oInf = parcelRequire("5oInf");

var $gDFwV = parcelRequire("gDFwV");
const $f626ffa03817e584$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>(0, $dRkX9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gDFwV.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5oInf.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }));

});
parcelRegister("5oInf", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $b5ba45c695aeb134$export$14710e13fc01d383);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ /* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4Cnkn = parcelRequire("4Cnkn");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $dClHM = parcelRequire("dClHM");

var $g9uCU = parcelRequire("g9uCU");
const $b5ba45c695aeb134$var$styles = {
    root: "_1bsb1ns9",
    container: "_kqswh2mm",
    card: "_2rko1mok _zulpu2gc _kqswstnw _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax"
};
const $b5ba45c695aeb134$var$placementStyles = {
    'top-start': "_u7co12x7 _rjxpc7mi",
    'top-center': "_u7co12x7 _1e021qz4",
    'top-end': "_u7co12x7 _1e02c7mi",
    'right-start': "_1e0212x7 _u7comgjw",
    'right-end': "_1e0212x7 _152tmgjw",
    'bottom-start': "_152t12x7 _rjxpc7mi",
    'bottom-center': "_152t12x7 _1e021qz4",
    'bottom-end': "_152t12x7 _1e02c7mi",
    'left-start': "_rjxp12x7 _u7comgjw",
    'left-end': "_rjxp12x7 _152tmgjw"
};
const $b5ba45c695aeb134$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const cardRef = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $2R2iS.default)([
            $b5ba45c695aeb134$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
            className: (0, $2R2iS.default)([
                $b5ba45c695aeb134$var$styles.container
            ]),
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $g9uCU.Caret), {
                    placement: placement || card.placement
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    ref: cardRef,
                    backgroundColor: "color.background.neutral.bold",
                    xcss: (0, $4Cnkn.cx)($b5ba45c695aeb134$var$styles.card, $b5ba45c695aeb134$var$placementStyles[placement || card.placement]),
                    children: children
                })
            ]
        })
    });
    if ((0, $dRkX9.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $3LM7S.jsx)(Motion, {
            children: content
        });
        else return content;
    }
    return content;
});

});
parcelRegister("dClHM", function(module, exports) {
$parcel$export(module.exports, "SpotlightContext", () => $b6059bb41912050b$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightContextProvider", () => $b6059bb41912050b$export$ad26233dae620a42);
/* context.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $b6059bb41912050b$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $fc4bM.createContext)({
    card: {
        ref: null,
        setRef: ()=>undefined,
        placement: 'bottom-end',
        setPlacement: ()=>undefined,
        motion: undefined,
        setMotion: ()=>undefined
    },
    heading: {
        id: '',
        setId: ()=>undefined
    },
    popoverContent: {
        ref: undefined,
        setRef: ()=>undefined,
        positionArea: undefined,
        setPositionArea: ()=>undefined,
        update: ()=>new Promise(()=>null),
        setUpdate: ()=>new Promise(()=>null),
        dismiss: {
            current: ()=>undefined
        },
        setDismiss: ()=>undefined
    },
    target: {
        ref: {
            current: null
        },
        setRef: ()=>undefined
    },
    primaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    },
    secondaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    }
});
const $b6059bb41912050b$export$ad26233dae620a42 = ({ children: children, targetRef: targetRef })=>{
    const id = (0, $fc4bM.useId)();
    const defaultTargetRef = (0, $fc4bM.useRef)(null);
    const [motion, setMotion] = (0, $fc4bM.useState)();
    const [placement, setPlacement] = (0, $fc4bM.useState)('bottom-end');
    const [headingId, setHeadingId] = (0, $fc4bM.useState)(`${id}-heading`);
    const [update, setUpdate] = (0, $fc4bM.useState)(()=>async ()=>undefined);
    const [popoverRef, setPopoverRef] = (0, $fc4bM.useState)();
    const [positionArea, setPositionArea] = (0, $fc4bM.useState)();
    const [cardRef, setCardRef] = (0, $fc4bM.useState)(null);
    const [internalTargetRef, setInternalTargetRef] = (0, $fc4bM.useState)(defaultTargetRef);
    // `targetRef` (the prop) takes precedence when provided. Its identity is
    // allowed to change over time; downstream consumers that depend on
    // `target.ref` identity (e.g. `useAnchoredPopover`'s effect deps) will
    // re-run accordingly.
    const effectiveTargetRef = targetRef ?? internalTargetRef;
    const dismissRef = (0, $fc4bM.useRef)(()=>undefined);
    const setDismiss = (dismissFn)=>{
        dismissRef.current = dismissFn;
    };
    const secondaryActionRef = (0, $fc4bM.useRef)(()=>undefined);
    const setSecondaryAction = (actionFn)=>{
        secondaryActionRef.current = actionFn;
    };
    const primaryActionRef = (0, $fc4bM.useRef)(()=>undefined);
    const setPrimaryAction = (actionFn)=>{
        primaryActionRef.current = actionFn;
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)($b6059bb41912050b$export$7b5aa0f5b37a336d.Provider, {
        value: {
            card: {
                ref: cardRef,
                setRef: setCardRef,
                placement: placement,
                setPlacement: setPlacement,
                motion: motion,
                setMotion: setMotion
            },
            heading: {
                id: headingId,
                setId: setHeadingId
            },
            popoverContent: {
                ref: popoverRef,
                setRef: setPopoverRef,
                positionArea: positionArea,
                setPositionArea: setPositionArea,
                update: update,
                setUpdate: setUpdate,
                dismiss: dismissRef,
                setDismiss: setDismiss
            },
            target: {
                ref: effectiveTargetRef,
                setRef: setInternalTargetRef
            },
            primaryAction: {
                action: primaryActionRef,
                setAction: setPrimaryAction
            },
            secondaryAction: {
                action: secondaryActionRef,
                setAction: setSecondaryAction
            }
        },
        children: children
    });
};

});

parcelRegister("g9uCU", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $5115c7ce5232557e$export$88fca06e22f21720);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $fdEom = parcelRequire("fdEom");

var $6QSyV = parcelRequire("6QSyV");
const $5115c7ce5232557e$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    return (0, $dRkX9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6QSyV.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fdEom.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    });
});

});
parcelRegister("fdEom", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $d4850ae302674c40$export$88fca06e22f21720);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dClHM = parcelRequire("dClHM");
const $d4850ae302674c40$var$styles = {
    root: "_bfhk1aqn _mkrzmhja _4t3io7ao _kqswh2mm _1bsbo7ao _1pby1fw0",
    'top-start': "_t9ec71a3",
    'top-center': "_t9ec71a3",
    'top-end': "_t9ec71a3",
    'bottom-start': "_t9ec1hke",
    'bottom-center': "_t9ec1hke",
    'bottom-end': "_t9ec1hke",
    'right-start': "_t9ecjyd4",
    'right-end': "_t9ecjyd4",
    'left-start': "_t9ecebzf",
    'left-end': "_t9ecebzf"
};
const $d4850ae302674c40$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $2R2iS.default)([
            $d4850ae302674c40$var$styles.root,
            $d4850ae302674c40$var$styles[placement || card.placement]
        ])
    });
});

});

parcelRegister("6QSyV", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $f533ce4de30caf80$export$88fca06e22f21720);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dClHM = parcelRequire("dClHM");

var $jkBB6 = parcelRequire("jkBB6");
const $f533ce4de30caf80$var$styles = {
    root: "_bfhk1aqn _mkrzmhja _4t3io7ao _kqswstnw _1bsbo7ao",
    'start span-start': "_u7coze3t _rjxpv47k _t9ec71a3",
    'block-start': "_u7coze3t _1e02srgr _t9ec71a3",
    'start span-end': "_u7coze3t _1e02183y _t9ec71a3",
    'inline-start': "_rjxpze3t _152tsrgr _t9ecebzf",
    'inline-end': "_1e02ze3t _152tsrgr _t9ecjyd4",
    'span-start end': "_1e02ze3t _u7codlk8 _t9ecjyd4",
    'span-end end': "_1e02ze3t _152t8jkm _t9ecjyd4",
    'span-start start': "_rjxpze3t _u7codlk8 _t9ecebzf",
    'span-end start': "_rjxpze3t _152t8jkm _t9ecebzf",
    'end span-start': "_152tze3t _rjxpgktf _t9ec1hke",
    'block-end': "_152tze3t _1e02srgr _t9ec1hke",
    'end span-end': "_152tze3t _1e02183y _t9ec1hke"
};
const $f533ce4de30caf80$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const positionArea = (0, $jkBB6.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $2R2iS.default)([
            $f533ce4de30caf80$var$styles.root,
            $f533ce4de30caf80$var$styles[positionArea]
        ])
    });
});

});
parcelRegister("jkBB6", function(module, exports) {
$parcel$export(module.exports, "getResolvedPositionArea", () => $7c23a45d3816fa4d$export$3aecfab3bd204999);
const $7c23a45d3816fa4d$var$caretPositionMap = {
    'top-start': 'start span-start',
    'top-center': 'block-start',
    'top-end': 'start span-end',
    'left-start': 'span-start start',
    'right-start': 'span-start end',
    'left-end': 'span-end start',
    'right-end': 'span-end end',
    'bottom-start': 'end span-start',
    'bottom-center': 'block-end',
    'bottom-end': 'end span-end'
};
const $7c23a45d3816fa4d$export$3aecfab3bd204999 = (placement, positionArea)=>{
    if (!positionArea || positionArea === 'none') return $7c23a45d3816fa4d$var$caretPositionMap[placement];
    return positionArea;
};

});




parcelRegister("gDFwV", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $31ad9a80c813daff$export$14710e13fc01d383);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $dClHM = parcelRequire("dClHM");

var $jkBB6 = parcelRequire("jkBB6");

var $g9uCU = parcelRequire("g9uCU");
const $31ad9a80c813daff$var$styles = {
    root: "_kqswh2mm _1bsb1ns9",
    card: "_2rko1mok _zulpu2gc _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax",
    'start span-start': "_85i512x7",
    'block-start': "_85i512x7",
    'start span-end': "_85i512x7",
    'end span-start': "_1q5112x7",
    'block-end': "_1q5112x7",
    'end span-end': "_1q5112x7",
    'inline-start': "_y4ti12x7",
    'inline-end': "_bozg12x7",
    'span-start end': "_bozg12x7",
    'span-end end': "_bozg12x7",
    'span-start start': "_y4ti12x7",
    'span-end start': "_y4ti12x7"
};
const $31ad9a80c813daff$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const cardRef = (0, $fc4bM.useRef)(null);
    const positionArea = (0, $jkBB6.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    (0, $fc4bM.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $2R2iS.default)([
            $31ad9a80c813daff$var$styles.root,
            $31ad9a80c813daff$var$styles[positionArea]
        ]),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $g9uCU.Caret), {
                placement: placement
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: $31ad9a80c813daff$var$styles.card,
                children: children
            })
        ]
    });
    if ((0, $dRkX9.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $3LM7S.jsx)(Motion, {
            children: content
        });
    }
    return content;
});

});


parcelRegister("lUS3A", function(module, exports) {
$parcel$export(module.exports, "SpotlightControls", () => $f59a0f240eda6128$export$67fb68d4ebe55a86);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $f59a0f240eda6128$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21sbv"
};
const $f59a0f240eda6128$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $2R2iS.default)([
            $f59a0f240eda6128$var$styles.root
        ]),
        children: children
    });
});

});

parcelRegister("2GRNQ", function(module, exports) {
$parcel$export(module.exports, "SpotlightDismissControl", () => $caa89767cb596e61$export$4eef19754b0d485e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $gV8E5 = parcelRequire("gV8E5");

var $EawnW = parcelRequire("EawnW");

var $dClHM = parcelRequire("dClHM");
const $caa89767cb596e61$var$styles = {
    root: "_2rko1qi0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $caa89767cb596e61$export$4eef19754b0d485e = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $4Cnkn.cx)($caa89767cb596e61$var$styles.root),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
            label: "Close"
        })
    });
});

});

parcelRegister("fNKQE", function(module, exports) {
$parcel$export(module.exports, "SpotlightFooter", () => $d4ee38a6eb40b8ec$export$f76dbc85ba76ccc2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $26fPW = parcelRequire("26fPW");
const $d4ee38a6eb40b8ec$var$styles = {
    root: "_bozgpxbi _y4tiutpp _1bsb1osq"
};
const $d4ee38a6eb40b8ec$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
        ref: ref,
        testId: testId,
        xcss: $d4ee38a6eb40b8ec$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});

});

parcelRegister("KeOHl", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeader", () => $6b6d4d4fb94e1194$export$d646029b3ba8ab76);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $26fPW = parcelRequire("26fPW");
const $6b6d4d4fb94e1194$var$styles = {
    root: "_bozgpxbi _y4tiutpp"
};
const $6b6d4d4fb94e1194$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
        ref: ref,
        testId: testId,
        xcss: $6b6d4d4fb94e1194$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});

});

parcelRegister("6vMv1", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeadline", () => $d84ec5b0293d0a5c$export$b57275b1b6b9863b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $1hJdJ = parcelRequire("1hJdJ");

var $dClHM = parcelRequire("dClHM");
const $d84ec5b0293d0a5c$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});

});

parcelRegister("hjiim", function(module, exports) {
$parcel$export(module.exports, "SpotlightMedia", () => $2bf44d5428972ab5$export$cf33151c3f01cd9a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $2bf44d5428972ab5$var$styles = {
    root: "_1reo15vq _18m915vq _1bsbaq3k _4t3ihcro"
};
const $2bf44d5428972ab5$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        ref: ref,
        xcss: $2bf44d5428972ab5$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("jHTNF", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $b3c501eb3ebc5f7d$export$d7e1f420b25549ff);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $2f5e6 = parcelRequire("2f5e6");

var $biybo = parcelRequire("biybo");
/**
 * __PopoverContent__
 *
 * A `PopoverContent` is the element that is shown as a popover.
 */ const $b3c501eb3ebc5f7d$var$renderPopoverContent = (Component, { children: children, placement: placement, motion: motion, isVisible: isVisible, shouldDismissOnClickOutside: shouldDismissOnClickOutside, dismiss: dismiss, back: back, testId: testId, offset: offset, strategy: strategy, ...actionProps })=>{
    if ('next' in actionProps && actionProps.next) return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        next: actionProps.next,
        children: children
    });
    if ('done' in actionProps && actionProps.done) return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        done: actionProps.done,
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        children: children
    });
};
const $b3c501eb3ebc5f7d$export$d7e1f420b25549ff = (props)=>(0, $dRkX9.fg)('platform-dst-top-layer-spotlight') ? $b3c501eb3ebc5f7d$var$renderPopoverContent((0, $biybo.PopoverContent), props) : $b3c501eb3ebc5f7d$var$renderPopoverContent((0, $2f5e6.PopoverContent), props);

});
parcelRegister("2f5e6", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $bc62e9b890d5059c$export$d7e1f420b25549ff);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4dCfH = parcelRequire("4dCfH");

var $dVK9d = parcelRequire("dVK9d");

var $dRkX9 = parcelRequire("dRkX9");

var $dgKcj = parcelRequire("dgKcj");

var $dClHM = parcelRequire("dClHM");

var $cnWJu = parcelRequire("cnWJu");

var $8niY1 = parcelRequire("8niY1");

var $XAvnr = parcelRequire("XAvnr");

var $860oK = parcelRequire("860oK");
const $bc62e9b890d5059c$var$styles = {
    root: "_1pby1fw0"
};
/**
 * The `transform: rotate(45deg);` styles used to rotate the `Caret` component result in the corners of
 * the caret extending beyond the bounding box (by roughly 2px). So, apply an offset to ensure
 * the caret points to the very edge of the target element.
 *
 * Note: `@atlaskit/popper` maps the offset to the placement, so we only need to define `[0, 2]` and
 * the offset will get correctly rotated depending on the placement.
 */ const $bc62e9b890d5059c$var$defaultOffset = [
    0,
    2
];
/**
 * The Spotlight card can be positioned in many different configurations, but the caret should always point to
 * the center of the target element. `@atlaskit/popper` uses `'top' | 'right' | 'bottom' | 'left'` values for
 * this center alignment along the respective face. So we translate between the Spotlight position, and the
 * Popper position using this map.
 */ const $bc62e9b890d5059c$var$popperPlacementMap = {
    'top-start': 'top',
    'top-center': 'top',
    'top-end': 'top',
    'bottom-start': 'bottom',
    'bottom-center': 'bottom',
    'bottom-end': 'bottom',
    'right-start': 'right',
    'right-end': 'right',
    'left-start': 'left',
    'left-end': 'left'
};
const $bc62e9b890d5059c$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVK9d.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
const $bc62e9b890d5059c$export$d7e1f420b25549ff = (props)=>{
    const { children: children, placement: placement, motion: motion = $bc62e9b890d5059c$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset = $bc62e9b890d5059c$var$defaultOffset, strategy: strategy } = props;
    /**
   * A user should only be able to pass a `done` or a `next`. Not both.
   * The type is set up as a discriminant union. So, we need a typeguard
   * here to destructure it properly.
   */ const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const updateRef = (0, $fc4bM.useRef)(()=>new Promise(()=>undefined));
    const ref = (0, $fc4bM.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const focusWithin = (0, $cnWJu.useFocusWithin)(popoverContent.ref);
    (0, $fc4bM.useEffect)(()=>{
        popoverContent.setRef(ref);
    }, [
        ref,
        popoverContent
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $fc4bM.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (updateRef.current) popoverContent.setUpdate(()=>updateRef.current);
    }, [
        popoverContent
    ]);
    (0, $XAvnr.useOnEscape)((event)=>{
        if (!focusWithin) return;
        popoverContent.dismiss.current(event);
    });
    (0, $8niY1.useOnClickOutside)((event)=>{
        if (!shouldDismissOnClickOutside) return;
        popoverContent.dismiss.current(event);
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dgKcj.Popper), {
        offset: offset,
        strategy: strategy,
        placement: $bc62e9b890d5059c$var$popperPlacementMap[placement],
        children: ({ ref: localRef, style: style, update: update })=>{
            if (!isVisible && !(0, $dRkX9.fg)('platform-dst-motion-uplift-spotlight')) return;
            updateRef.current = update;
            return (0, $dRkX9.fg)('platform-dst-motion-uplift-spotlight') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $860oK.ConditionalExitingPersistence), {
                children: isVisible && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    role: "dialog",
                    "data-testid": testId,
                    "aria-labelledby": heading.id,
                    ref: (0, $4dCfH.default)([
                        ref,
                        localRef
                    ]),
                    style: style,
                    className: (0, $2R2iS.default)([
                        $bc62e9b890d5059c$var$styles.root
                    ]),
                    children: children
                })
            }) : /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                role: "dialog",
                "data-testid": testId,
                "aria-labelledby": heading.id,
                ref: (0, $4dCfH.default)([
                    ref,
                    localRef
                ]),
                style: style,
                className: (0, $2R2iS.default)([
                    $bc62e9b890d5059c$var$styles.root
                ]),
                children: children
            });
        }
    });
};

});
parcelRegister("cnWJu", function(module, exports) {
$parcel$export(module.exports, "useFocusWithin", () => $5d065a44409034eb$export$420e68273165f4ec);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");
const $5d065a44409034eb$export$420e68273165f4ec = (ref)=>{
    const [active, setActive] = (0, $fc4bM.useState)(null);
    const updateFocusedElement = (0, $fc4bM.useCallback)(()=>{
        const doc = (0, $j5N6B.getDocument)();
        const activeElement = (doc === null || doc === void 0 ? void 0 : doc.activeElement) || null;
        if (!ref || !ref.current) {
            setActive(null);
            return;
        }
        if (!activeElement) {
            setActive(null);
            return;
        }
        // Check if the focused element is within the ref element
        if (!ref.current.contains(activeElement)) {
            setActive(null);
            return;
        }
        setActive(activeElement);
    }, [
        ref
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const doc = (0, $j5N6B.getDocument)();
        if (!doc) return;
        updateFocusedElement();
        const unbindFocusIn = (0, $6Zi52.bind)(doc, {
            type: 'focusin',
            listener: updateFocusedElement
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        updateFocusedElement
    ]);
    return active;
};

});

parcelRegister("8niY1", function(module, exports) {
$parcel$export(module.exports, "useOnClickOutside", () => $1a691754c61042fc$export$9afc64c180e82dc4);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");

var $dClHM = parcelRequire("dClHM");
const $1a691754c61042fc$export$9afc64c180e82dc4 = (onClickOutside)=>{
    const { card: card } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const ref = card.ref;
    (0, $fc4bM.useEffect)(()=>{
        const doc = (0, $j5N6B.getDocument)();
        if (!doc) return;
        const unbindMouseUp = (0, $6Zi52.bind)(doc, {
            type: 'mouseup',
            listener: (event)=>{
                if (!ref || !ref.current) return;
                const target = event.target instanceof Node ? event.target : null;
                if (ref.current.contains(target)) return;
                onClickOutside(event);
            }
        });
        return ()=>{
            unbindMouseUp();
        };
    }, [
        onClickOutside,
        ref
    ]);
};

});

parcelRegister("XAvnr", function(module, exports) {
$parcel$export(module.exports, "useOnEscape", () => $88ea850eb92b97ad$export$795d56022f0285ed);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");
const $88ea850eb92b97ad$var$onKeyDown = (event, { onEscape: onEscape })=>{
    switch(event.key){
        case 'Escape':
            onEscape();
            break;
        default:
            break;
    }
};
const $88ea850eb92b97ad$export$795d56022f0285ed = (onEscape)=>{
    (0, $fc4bM.useEffect)(()=>{
        const doc = (0, $j5N6B.getDocument)();
        if (!doc) return;
        const unbindFocusIn = (0, $6Zi52.bind)(doc, {
            type: 'keydown',
            listener: (event)=>$88ea850eb92b97ad$var$onKeyDown(event, {
                    onEscape: ()=>onEscape(event)
                })
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        onEscape
    ]);
};

});

parcelRegister("860oK", function(module, exports) {
$parcel$export(module.exports, "ConditionalExitingPersistence", () => $f57e94571b1535aa$export$4c013c06aa0aee51);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iXBtU = parcelRequire("iXBtU");

var $dClHM = parcelRequire("dClHM");
const $f57e94571b1535aa$export$4c013c06aa0aee51 = ({ children: children })=>{
    const { card: card } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    if (card.motion) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
        children: children
    });
    return children;
};

});


parcelRegister("biybo", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $d51266bf7463599e$export$d7e1f420b25549ff);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dVK9d = parcelRequire("dVK9d");

var $aMgNY = parcelRequire("aMgNY");

var $GyLDf = parcelRequire("GyLDf");

var $lz1tR = parcelRequire("lz1tR");

var $02Byl = parcelRequire("02Byl");

var $dClHM = parcelRequire("dClHM");

var $ir2Wm = parcelRequire("ir2Wm");

var $3r3X8 = parcelRequire("3r3X8");
const $d51266bf7463599e$var$noopUpdate = ()=>Promise.resolve();
const $d51266bf7463599e$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVK9d.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
const $d51266bf7463599e$export$d7e1f420b25549ff = (props)=>{
    /**
   * This composes the low-level `@atlaskit/top-layer` `Popover` primitive directly
   * (rather than `@atlaskit/popup` or a higher-level wrapper) for two reasons:
   *
   * 1. Spotlight has bespoke positioning, dismiss, and motion requirements that
   *    are coupled to the surrounding `SpotlightContext` (heading id, card
   *    placement, primary/secondary actions, etc.). Building on the primitive
   *    keeps that wiring local to spotlight without leaking into a shared popup.
   * 2. Spotlight's public API exposes a `dismiss(event)` callback that takes a
   *    `KeyboardEvent` / `MouseEvent`, while the top-layer primitive surfaces a
   *    structured `{ reason }`. Bridging that contract here (via
   *    `createPopoverCloseEvent`) preserves backwards compatibility for existing
   *    consumers as we migrate behind the `platform-dst-top-layer-spotlight` gate.
   */ const { children: children, placement: placement, motion: motion = $d51266bf7463599e$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset } = props;
    const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const popoverRef = (0, $fc4bM.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction, target: target } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    (0, $lz1tR.useAnchoredPopover)({
        anchorRef: target.ref,
        popoverRef: popoverRef,
        placement: (0, $3r3X8.getPlacementWithOffset)({
            placement: placement,
            offset: offset
        }),
        isOpen: isVisible
    });
    (0, $02Byl.useManualLightDismiss)({
        popoverRef: popoverRef,
        isOpen: isVisible,
        onClose: ({ reason: reason })=>{
            if (reason === 'light-dismiss' && !shouldDismissOnClickOutside) return;
            // `createPopoverCloseEvent` is typed as `KeyboardEvent | MouseEvent | Event`
            // for forward-compatibility, but only `escape` / `light-dismiss` are
            // possible here, so the result is always a Keyboard/MouseEvent.
            dismiss((0, $aMgNY.createPopoverCloseEvent)({
                reason: reason
            }));
        }
    });
    (0, $fc4bM.useEffect)(()=>{
        popoverContent.setRef(popoverRef);
        popoverContent.setUpdate(()=>$d51266bf7463599e$var$noopUpdate);
    }, [
        popoverContent
    ]);
    const positionArea = (0, $ir2Wm.usePositionArea)(popoverRef);
    (0, $fc4bM.useEffect)(()=>{
        popoverContent.setPositionArea(positionArea);
    }, [
        popoverContent,
        positionArea
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $fc4bM.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
        ref: popoverRef,
        isOpen: isVisible,
        mode: "manual",
        role: "dialog",
        labelledBy: heading.id,
        testId: testId,
        children: children
    });
};

});
parcelRegister("ir2Wm", function(module, exports) {
$parcel$export(module.exports, "usePositionArea", () => $bd0e4c8092a569fb$export$c25d226a9f6a64fa);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");
const $bd0e4c8092a569fb$export$c25d226a9f6a64fa = (ref)=>{
    const [positionArea, setPositionArea] = (0, $fc4bM.useState)(undefined);
    (0, $fc4bM.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const readPositionArea = ()=>{
            try {
                var _el$computedStyleMap$;
                return (_el$computedStyleMap$ = el.computedStyleMap().get('position-area')) === null || _el$computedStyleMap$ === void 0 ? void 0 : _el$computedStyleMap$.toString();
            } catch  {
                // Some old browsers do not support computedStyleMap, so fall back to getPropertyValue
                return window.getComputedStyle(el).getPropertyValue('position-area').trim();
            }
        };
        const read = ()=>{
            const positionArea = readPositionArea();
            setPositionArea(positionArea);
        };
        read();
        /**
     * requestAnimationFrame ensures that initial renders are in a different position
     * to the supplied prop value (e.g. the viewport is too small so the position is
     * recalculated) are rendered correctly.
     */ const rafId = window.requestAnimationFrame(read);
        // Check if the viewport resizes
        const unbindResize = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: read,
            options: {
                passive: true
            }
        });
        // Check if the viewport scrolls
        const unbindScroll = (0, $6Zi52.bind)(window, {
            type: 'scroll',
            listener: read,
            options: {
                passive: true,
                capture: true
            }
        });
        return ()=>{
            window.cancelAnimationFrame(rafId);
            unbindResize();
            unbindScroll();
        };
    }, [
        ref
    ]);
    return positionArea;
};

});

parcelRegister("3r3X8", function(module, exports) {
$parcel$export(module.exports, "getPlacementWithOffset", () => $098f1481e97f7b4d$export$ca1bb198c4ca0115);

var $ePbSH = parcelRequire("ePbSH");
const $098f1481e97f7b4d$var$DEFAULT_GAP = "var(--ds-space-050, 4px)";
function $098f1481e97f7b4d$var$normalizeOffsetMember({ value: value }) {
    return value ?? 0;
}
function $098f1481e97f7b4d$var$addCssLength({ base: base, delta: delta }) {
    if (delta === 0) return base;
    if (typeof base === 'number') return base + delta;
    const operator = delta > 0 ? '+' : '-';
    return `calc(${base} ${operator} ${Math.abs(delta)}px)`;
}
function $098f1481e97f7b4d$var$toSignedCrossAxisShiftValue({ crossAxisShift: crossAxisShift }) {
    const baseValue = crossAxisShift.value ?? 0;
    if (crossAxisShift.direction === 'forwards') return baseValue;
    if (typeof baseValue === 'number') return -baseValue;
    return `calc(-1 * ${baseValue})`;
}
function $098f1481e97f7b4d$var$getCrossAxisShiftWithOffset({ baseCrossAxisShift: baseCrossAxisShift, along: along }) {
    if (!baseCrossAxisShift) {
        if (along === 0) return undefined;
        return {
            value: along,
            direction: 'forwards'
        };
    }
    if (along === 0) return baseCrossAxisShift;
    // Collapse sign into the CSS length so additive composition works even
    // when the existing shift is already expressed as a `calc(...)` string.
    return {
        value: $098f1481e97f7b4d$var$addCssLength({
            base: $098f1481e97f7b4d$var$toSignedCrossAxisShiftValue({
                crossAxisShift: baseCrossAxisShift
            }),
            delta: along
        }),
        direction: 'forwards'
    };
}
function $098f1481e97f7b4d$export$ca1bb198c4ca0115({ placement: placement, offset: offset }) {
    var _basePlacement$offset, _basePlacement$offset2;
    const basePlacement = (0, $ePbSH.placementMap)[placement];
    if (!offset) return basePlacement;
    const [alongRaw, awayRaw] = offset;
    const along = $098f1481e97f7b4d$var$normalizeOffsetMember({
        value: alongRaw
    });
    const away = $098f1481e97f7b4d$var$normalizeOffsetMember({
        value: awayRaw
    });
    if (along === 0 && away === 0) return basePlacement;
    const gap = $098f1481e97f7b4d$var$addCssLength({
        base: ((_basePlacement$offset = basePlacement.offset) === null || _basePlacement$offset === void 0 ? void 0 : _basePlacement$offset.gap) ?? $098f1481e97f7b4d$var$DEFAULT_GAP,
        delta: away
    });
    const crossAxisShift = $098f1481e97f7b4d$var$getCrossAxisShiftWithOffset({
        baseCrossAxisShift: (_basePlacement$offset2 = basePlacement.offset) === null || _basePlacement$offset2 === void 0 ? void 0 : _basePlacement$offset2.crossAxisShift,
        along: along
    });
    return {
        ...basePlacement,
        offset: {
            ...basePlacement.offset,
            gap: gap,
            ...crossAxisShift ? {
                crossAxisShift: crossAxisShift
            } : {}
        }
    };
}

});
parcelRegister("ePbSH", function(module, exports) {
$parcel$export(module.exports, "placementMap", () => $0e990211ead5a97e$export$168f55451c1c934);
const $0e990211ead5a97e$var$GAP = "var(--ds-space-050, 4px)";
/**
 * Cross-axis shift toward target centre on block-axis placements (CSS anchor path).
 */ const $0e990211ead5a97e$var$INLINE_TARGET_CENTER_SHIFT = 'calc(anchor-size(width) / 2 - 28px)';
/**
 * Cross-axis shift toward target centre on inline-axis placements (CSS anchor path).
 */ const $0e990211ead5a97e$var$BLOCK_TARGET_CENTER_SHIFT = 'calc(anchor-size(height) / 2 - 22px)';
const $0e990211ead5a97e$export$168f55451c1c934 = {
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: $0e990211ead5a97e$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center',
        offset: {
            gap: $0e990211ead5a97e$var$GAP
        }
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: $0e990211ead5a97e$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: $0e990211ead5a97e$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center',
        offset: {
            gap: $0e990211ead5a97e$var$GAP
        }
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: $0e990211ead5a97e$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: $0e990211ead5a97e$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: `calc(${$0e990211ead5a97e$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: $0e990211ead5a97e$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $0e990211ead5a97e$var$GAP,
            crossAxisShift: {
                value: `calc(${$0e990211ead5a97e$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    }
};

});




parcelRegister("8Bu6G", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $c383f3d8aca7ee4b$export$bf694c7c431c162a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $bBK8c = parcelRequire("bBK8c");

var $9PkRK = parcelRequire("9PkRK");
const $c383f3d8aca7ee4b$export$bf694c7c431c162a = ({ children: children })=>(0, $dRkX9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9PkRK.PopoverProvider), {
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bBK8c.PopoverProvider), {
        children: children
    });

});
parcelRegister("bBK8c", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $9b4e9178d6f744a6$export$bf694c7c431c162a);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $k2PlB = parcelRequire("k2PlB");

var $dClHM = parcelRequire("dClHM");
const $9b4e9178d6f744a6$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dClHM.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k2PlB.Manager), {
            children: children
        })
    });
};

});

parcelRegister("9PkRK", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $65d041b860846f83$export$bf694c7c431c162a);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dClHM = parcelRequire("dClHM");
const $65d041b860846f83$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dClHM.SpotlightContextProvider), {
        children: children
    });
};

});


parcelRegister("7YSeN", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $a8f872a5e16e0a15$export$5ad0c0856b469f13);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $g0z2e = parcelRequire("g0z2e");

var $fBZdv = parcelRequire("fBZdv");
const $a8f872a5e16e0a15$export$5ad0c0856b469f13 = ({ children: children })=>(0, $dRkX9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fBZdv.PopoverTarget), {
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $g0z2e.PopoverTarget), {
        children: children
    });

});
parcelRegister("g0z2e", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $175f1f4e399fb07f$export$5ad0c0856b469f13);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5q4nr = parcelRequire("5q4nr");
const $175f1f4e399fb07f$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5q4nr.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};

});

parcelRegister("fBZdv", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $f333687a3ace2bbd$export$5ad0c0856b469f13);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dClHM = parcelRequire("dClHM");
const $f333687a3ace2bbd$export$5ad0c0856b469f13 = ({ children: children })=>{
    const localRef = (0, $fc4bM.useRef)(null);
    const { target: target } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    (0, $fc4bM.useLayoutEffect)(()=>{
        target.setRef(localRef);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: localRef,
        children: children
    });
};

});


parcelRegister("apntv", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryAction", () => $f3a216d9c8d0b14a$export$eea27caf91a85655);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $EawnW = parcelRequire("EawnW");

var $k8Adr = parcelRequire("k8Adr");

var $dClHM = parcelRequire("dClHM");
const $f3a216d9c8d0b14a$var$styles = {
    root: "_2rko12b0 _syaz15cr",
    outline: "_1dqonqa1 _189ee4h9 _1h6d8yml _bfhk1aqn _irr31ibz _1di6of27",
    primary: "_1dqonqa1 _189ee4h9 _1h6da755 _bfhk1856 _irr3hf2y _1di6g6ey"
};
const $f3a216d9c8d0b14a$export$eea27caf91a85655 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, appearance: appearance = 'outline', testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $fc4bM.useContext)((0, $dClHM.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $4Cnkn.cx)($f3a216d9c8d0b14a$var$styles.root, $f3a216d9c8d0b14a$var$styles[appearance]),
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("e8sGC", function(module, exports) {
$parcel$export(module.exports, "useMessageInstances", () => $5ecacc3611ce1371$export$92bc057879827fcf);

var $fc4bM = parcelRequire("fc4bM");

var $lJA3W = parcelRequire("lJA3W");

var $j4gq5 = parcelRequire("j4gq5");

var $9sGOM = parcelRequire("9sGOM");

var $lWus1 = parcelRequire("lWus1");
function $5ecacc3611ce1371$export$92bc057879827fcf(selector, options) {
    const { placementId: placementId = 'headless', messageTemplateId: messageTemplateId } = selector;
    const { match: match, validate: validate, dataSource: dataSource, queryString: queryString } = options ?? {};
    const dataOutsideWrapper = (options === null || options === void 0 ? void 0 : options.dataOutsideWrapper) ?? false;
    // Store match/validate in refs so inline arrow functions passed by callers don't cause
    // the useMemo to re-run on every render. The latest value is always read inside the memo.
    const matchRef = (0, $fc4bM.useRef)(match);
    matchRef.current = match;
    const validateRef = (0, $fc4bM.useRef)(validate);
    validateRef.current = validate;
    const { data: data, dismissedIds: dismissedIds, isLoading: isLoading, error: fetchError, dismissMessage: dismissMessage, traceId: traceId } = (0, $9sGOM.usePlacementData)(placementId, {
        dataSource: dataSource,
        queryString: queryString
    });
    const traceIdRef = (0, $fc4bM.useRef)(traceId);
    traceIdRef.current = traceId;
    const { templateMessages: templateMessages, validationError: validationError } = (0, $fc4bM.useMemo)(()=>{
        if (!data) return {
            templateMessages: [],
            validationError: undefined
        };
        let candidates;
        try {
            const result = matchRef.current ? matchRef.current({
                data: data,
                matchBuilder: (0, $lWus1.createMatchBuilder)()
            }) : data.messages ?? [];
            const resolved = (0, $lWus1.isMatchBuilder)(result) ? result.match(data) : result;
            candidates = resolved;
        } catch (err) {
            if (err instanceof (0, $lWus1.PlacementLocationError)) return {
                templateMessages: [],
                validationError: err
            };
            return {
                templateMessages: [],
                validationError: (0, $lWus1.toHookError)(err)
            };
        }
        const templateMatches = candidates.filter((m)=>m.messageTemplateId === messageTemplateId);
        const guard = validateRef.current ?? (0, $lWus1.isPlacementMessage);
        let failedCount;
        try {
            failedCount = templateMatches.filter((m)=>!guard(m)).length;
        } catch (err) {
            return {
                templateMessages: [],
                validationError: (0, $lWus1.toHookError)(err)
            };
        }
        if (failedCount > 0) return {
            templateMessages: [],
            validationError: new (0, $lWus1.PlacementValidationError)({
                placementId: placementId,
                failedCount: failedCount
            })
        };
        return {
            templateMessages: templateMatches,
            validationError: undefined
        };
    }, [
        data,
        messageTemplateId,
        placementId
    ]);
    const messages = (0, $fc4bM.useMemo)(()=>{
        return templateMessages.filter((m)=>!dismissedIds.has(m.messageInstanceId));
    }, [
        dismissedIds,
        templateMessages
    ]);
    const messageInstanceIds = (0, $fc4bM.useMemo)(()=>messages.map((m)=>m.messageInstanceId), [
        messages
    ]);
    // Build lookup from validated template data (not dismissed-filtered messages)
    // so dismissals and data refreshes don't change PostOfficeMessageInstance identity and remount callers.
    const messageByMessageInstanceId = (0, $fc4bM.useMemo)(()=>{
        const lookup = {};
        for (const message of templateMessages)lookup[message.messageInstanceId] = message;
        return lookup;
    }, [
        templateMessages
    ]);
    const messageByMessageInstanceIdRef = (0, $fc4bM.useRef)({});
    messageByMessageInstanceIdRef.current = messageByMessageInstanceId;
    // Single wrapper closed over placementId + messageTemplateId.
    // messageInstanceId is passed per-render by the caller.
    const PostOfficeMessageInstance = (0, $fc4bM.useMemo)(()=>{
        return ({ children: children, ...props })=>{
            const message = messageByMessageInstanceIdRef.current[props.messageInstanceId];
            const messageCategory = message === null || message === void 0 ? void 0 : message.messageCategory;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lJA3W.PostOfficeMessage), {
                placementId: placementId,
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory,
                ...(0, $j4gq5.transformPlacementMessageToMessageLifecycleProps)({
                    message: message
                }),
                ...props,
                traceId: traceIdRef.current
            }, (interactions)=>children(message, interactions));
        };
    }, [
        messageTemplateId,
        placementId
    ]);
    return dataOutsideWrapper ? {
        messages: messages,
        messageInstanceIds: messageInstanceIds,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage,
        traceId: traceId
    } : {
        messageInstanceIds: messageInstanceIds,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage,
        traceId: traceId
    };
}

});
parcelRegister("lJA3W", function(module, exports) {
$parcel$export(module.exports, "PostOfficeMessage", () => $1b0e634012f88cc0$export$7356a355af87a394);

var $fc4bM = parcelRequire("fc4bM");

var $j4SCE = parcelRequire("j4SCE");

var $k2M4v = parcelRequire("k2M4v");

var $dRkX9 = parcelRequire("dRkX9");

var $3HoCN = parcelRequire("3HoCN");

var $MCcGE = parcelRequire("MCcGE");

var $dw3GQ = parcelRequire("dw3GQ");

var $enWoH = parcelRequire("enWoH");

var $jNx9z = parcelRequire("jNx9z");

var $fohTj = parcelRequire("fohTj");

var $3LFgp = parcelRequire("3LFgp");

var $9Pihb = parcelRequire("9Pihb");
/**
 * Fires the Post Office "viewed" analytics events on mount.
 *
 * This is a separate inner component so that it only mounts when the choreographer
 * allows the message to render. It fires all three viewed events exactly once:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed()
 *   - messageInstanceDeliveredSuccessfully()
 *
 * Must be rendered inside a MessageContextProvider and PlacementProvider so that
 * useMessageViewed() can read the required context values.
 */ const $1b0e634012f88cc0$var$ViewedOnMount = ()=>{
    const messageViewed = (0, $fohTj.useMessageViewed)();
    (0, $fc4bM.useEffect)(()=>{
        messageViewed();
    // We intentionally omit deps — this should fire exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $1b0e634012f88cc0$var$MessageDisplayTracking = ({ children: children, displayTracking: displayTracking })=>{
    if (displayTracking === 'host') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jNx9z.HostMessageDisplayProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$ViewedOnMount, null), children);
};
/**
 * Defers evaluation of the children render prop until the message is mounted.
 *
 * This ensures that any side effects in the render prop only execute when the
 * choreographer allows the message to render, not when it is blocked.
 */ const $1b0e634012f88cc0$var$RenderedChildren = ({ children: children })=>{
    const interactions = (0, $MCcGE.usePostOfficeUserInteractions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(interactions));
};
const $1b0e634012f88cc0$var$ChoreographedMessage = ({ children: children, messageId: messageId, useChoreographedRender: useChoreographedRender, shouldClaim: shouldClaim, onMessageDisposition: onMessageDisposition })=>{
    const mounted = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useLayoutEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const reportDisposition = (0, $fc4bM.useCallback)((value)=>{
        // The factory also reports async stop results during cleanup. They are not
        // a new delivery decision for the response's next selected message.
        if (mounted.current) onMessageDisposition === null || onMessageDisposition === void 0 || onMessageDisposition(value);
    }, [
        onMessageDisposition
    ]);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        ...shouldClaim && {
            shouldClaim: shouldClaim
        },
        ...onMessageDisposition && {
            onMessageDisposition: reportDisposition
        }
    });
    if (!shouldRender) return null;
    // Post Office is actively choreographing this message. Signal it to descendants
    // so nested product/PO choreographer-wrapped components (e.g. JiraSpotlight, or
    // Confluence components built on the ipm-choreographer engine) defer instead of
    // starting a second, colliding choreographer over the same subtree.
    if ((0, $k2M4v.default).checkGate('post-office_enable_choreographer-ancestor-context')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3HoCN.AncestorChoreographerProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
};
// Mounted only on the choreographed path, inside the message/placement providers and
// after pre-render checks. Creating the callback does not evaluate the experiment.
const $1b0e634012f88cc0$var$ExperimentChoreographedMessage = ({ inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, shouldClaim: productShouldClaim, ...props })=>{
    const narrowExposureShouldClaim = (0, $3LFgp.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldClaim = (0, $fc4bM.useCallback)(()=>(!productShouldClaim || productShouldClaim()) && (!narrowExposureShouldClaim || narrowExposureShouldClaim()), [
        productShouldClaim,
        narrowExposureShouldClaim
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$ChoreographedMessage, {
        ...props,
        shouldClaim: shouldClaim
    });
};
/**
 * Render-time Isolated Cloud gate.
 *
 * Returns `null` when the prop is enabled AND the tenant is in an Isolated Cloud
 * environment. Mirrors the headful behaviour wired by
 * `createBasePlacementComponentV2` (`options.hideInIsolatedCloud`).
 *
 * SSR handling is delegated to `isIsolatedCloud()` itself, which falls back to
 * `globalThis.ssrContext?.isInIC` when `document` is undefined.
 */ const $1b0e634012f88cc0$var$IsolatedCloudGate = ({ children: children, hideInIsolatedCloud: hideInIsolatedCloud })=>{
    if (hideInIsolatedCloud && (0, $j4SCE.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
};
/**
 * Choreographer gating using the `ChoreographerContext` provided by
 * `StableChoreographerProvider` (from `@atlassian/post-office-context/choreographer`).
 *
 * Experiment-configured messages are hidden while narrow-exposure handling is disabled.
 *
 * When the choreographer is disabled or its factory is not yet loaded,
 * the message renders unconditionally.
 *
 * When `disableChoreographer` is `true`, the gate short-circuits and renders
 * children unconditionally — bypassing the choreographer entirely for this message.
 */ const $1b0e634012f88cc0$var$ChoreographerGate = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer, awaitChoreographerFactory: awaitChoreographerFactory, shouldClaim: shouldClaim, onMessageDisposition: onMessageDisposition, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    // Hooks must run on every render to preserve hook order — do not short-circuit
    // before calling them, even when `disableChoreographer` is set.
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $dw3GQ.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $k2M4v.default).checkGate('enable_choreographed_post_office_messages');
    const isExperimentUnavailable = !!inAppNarrowExposureExperiment && !(0, $dRkX9.fg)('post-office_enable_headless-narrow-exposure');
    (0, $fc4bM.useEffect)(()=>{
        if (isExperimentUnavailable) onMessageDisposition === null || onMessageDisposition === void 0 || onMessageDisposition('canceled');
    }, [
        isExperimentUnavailable,
        onMessageDisposition
    ]);
    // Never show an experiment-configured message while experiment handling is disabled.
    if (isExperimentUnavailable) return null;
    if (disableChoreographer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    if (awaitChoreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && !choreographerFactory) return null;
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $k2M4v.default).checkGate('post-office_use_template_id_for_choreo');
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            const Message = (0, $dRkX9.fg)('post-office_enable_headless-narrow-exposure') ? $1b0e634012f88cc0$var$ExperimentChoreographedMessage : $1b0e634012f88cc0$var$ChoreographedMessage;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Message, {
                messageId: choreographerMessageId,
                useChoreographedRender: useChoreographedRender,
                shouldClaim: shouldClaim,
                onMessageDisposition: onMessageDisposition,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment
            }, children);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
};
/**
 * Provides the choreographer context this component's gating depends on, so headless
 * consumers do not have to mount `StableChoreographerProvider` themselves.
 *
 * Nesting is safe: the underlying choreographer factory is a per-product singleton
 * held on `window`, so a provider mounted here resolves to the same factory (and
 * therefore the same fatigue/concurrency queue) as one mounted by an ancestor.
 *
 */ const $1b0e634012f88cc0$var$ChoreographerProvider = ({ children: children, placementId: placementId, enabled: enabled })=>{
    if (!enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dw3GQ.StableChoreographerProvider), {
        placementId: placementId
    }, children);
};
const $1b0e634012f88cc0$export$7356a355af87a394 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, traceId: traceId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, displayTracking: displayTracking, shouldClaim: shouldClaim, onMessageDisposition: onMessageDisposition, children: children })=>{
    const messageContext = (0, $fc4bM.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        triggerId,
        messageCreationType,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const placementContext = (0, $fc4bM.useMemo)(()=>({
            placementId: placementId,
            traceId: traceId
        }), [
        placementId,
        traceId
    ]);
    const providesChoreographer = !disableChoreographer && (0, $k2M4v.default).checkGate('post-office_enable_choreographer_provider');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$ChoreographerProvider, {
        placementId: placementId,
        enabled: providesChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$IsolatedCloudGate, {
        hideInIsolatedCloud: hideInIsolatedCloud
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Pihb.PlacementProvider), {
        value: placementContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $enWoH.MessageContextProvider), {
        value: messageContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$ChoreographerGate, {
        messageId: messageInstanceId,
        shouldClaim: shouldClaim,
        onMessageDisposition: onMessageDisposition,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        disableChoreographer: disableChoreographer,
        awaitChoreographerFactory: providesChoreographer,
        inAppNarrowExposureExperiment: inAppNarrowExposureExperiment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$MessageDisplayTracking, {
        displayTracking: displayTracking
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1b0e634012f88cc0$var$RenderedChildren, null, children)))))));
};

});
parcelRegister("3HoCN", function(module, exports) {
$parcel$export(module.exports, "AncestorChoreographerProvider", () => $d0609fdc837a76c8$export$6bbbd27ff914855a);
$parcel$export(module.exports, "useIsChoreographedByAncestor", () => $d0609fdc837a76c8$export$1995d416b134f323);

var $fc4bM = parcelRequire("fc4bM");
/**
 * Tracks whether an ancestor is already choreographing this subtree.
 *
 * The Post Office message wrapper (and any other outer choreographer) applies
 * choreography once, at the top of a message. A choreographer-wrapped component
 * rendered further down — e.g. a product spotlight such as `JiraSpotlight`, or a
 * Confluence component built on `@confluence/choreographer-services` — would
 * otherwise start a *second*, independent choreographer over the same subtree.
 * Two choreographers gating the same DOM collide and the message can silently
 * fail to render.
 *
 * When this context is `true`, choreographer-wrapped components skip their own
 * choreography and render their children directly, deferring to the ancestor.
 */ const $d0609fdc837a76c8$var$IsChoreographedByAncestorContext = /*#__PURE__*/ (0, $fc4bM.createContext)(false);
const $d0609fdc837a76c8$export$6bbbd27ff914855a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d0609fdc837a76c8$var$IsChoreographedByAncestorContext.Provider, {
        value: true
    }, children);
const $d0609fdc837a76c8$export$1995d416b134f323 = ()=>(0, $fc4bM.useContext)($d0609fdc837a76c8$var$IsChoreographedByAncestorContext);

});

parcelRegister("MCcGE", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeUserInteractions", () => $4568872543c1d3f1$export$ee30c4b9efd02415);

var $fc4bM = parcelRequire("fc4bM");

var $fohTj = parcelRequire("fohTj");

var $2xBXO = parcelRequire("2xBXO");
const $4568872543c1d3f1$export$ee30c4b9efd02415 = ()=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $fohTj.useMessageInstanceEvent)();
    const record = (0, $fc4bM.useCallback)((interaction)=>{
        // Dispatch is fire-and-forget: the caller must not wait for analytics before
        // continuing a UI action, and recording an interaction must never break the
        // message.
        messageInstanceClicked((0, $2xBXO.mapInteractionToClickedEvent)(interaction)).catch(()=>{});
    }, [
        messageInstanceClicked
    ]);
    const onCtaActioned = (0, $fc4bM.useCallback)((input)=>record({
            kind: 'ctaActioned',
            ...input
        }), [
        record
    ]);
    const onAcknowledged = (0, $fc4bM.useCallback)((input)=>record({
            kind: 'acknowledged',
            ...input
        }), [
        record
    ]);
    const onDeclined = (0, $fc4bM.useCallback)((input)=>record({
            kind: 'declined',
            ...input
        }), [
        record
    ]);
    const onSnoozed = (0, $fc4bM.useCallback)((input)=>record({
            kind: 'snoozed',
            ...input
        }), [
        record
    ]);
    const onClosed = (0, $fc4bM.useCallback)((input)=>record({
            kind: 'closed',
            ...input
        }), [
        record
    ]);
    const onStepChanged = (0, $fc4bM.useCallback)((input)=>record({
            kind: 'stepChanged',
            ...input
        }), [
        record
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            onCtaActioned: onCtaActioned,
            onAcknowledged: onAcknowledged,
            onDeclined: onDeclined,
            onSnoozed: onSnoozed,
            onClosed: onClosed,
            onStepChanged: onStepChanged
        }), [
        onCtaActioned,
        onAcknowledged,
        onDeclined,
        onSnoozed,
        onClosed,
        onStepChanged
    ]);
};

});
parcelRegister("fohTj", function(module, exports) {
$parcel$export(module.exports, "useMessageInstanceEvent", () => $54d14871ce8d594a$export$39b0f5626e96f41e);
$parcel$export(module.exports, "useMessageViewed", () => $54d14871ce8d594a$export$f847ba3acec566f4);
/**
 * Message lifecycle hooks for Post Office headless consumers.
 *
 * Provides `useMessageViewed` — a single hook that fires viewed and delivery
 * analytics events on mount:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed() (message-instance-event endpoint)
 *   - messageInstanceDeliveredSuccessfully() (message-instance-event endpoint)
 *
 * Also provides `useMessageCooldown`, which records a server-enforced lifecycle
 * snooze without removing the message that is currently being rendered.
 *
 * This module is hoisted into @atlassian/post-office-context so that platform
 * packages can consume it without cross-workspace @post-office/* imports.
 *
 * Canonical sources this was inlined from:
 *   post-office/packages/clients/message-lifecycle
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $fg655 = parcelRequire("fg655");
var $im5M7 = parcelRequire("im5M7");

var $enWoH = parcelRequire("enWoH");

var $cgK27 = parcelRequire("cgK27");

var $9HZEg = parcelRequire("9HZEg");

var $3ED3W = parcelRequire("3ED3W");

var $9Pihb = parcelRequire("9Pihb");

var $lUl1y = parcelRequire("lUl1y");

var $d7ngk = parcelRequire("d7ngk");
class $54d14871ce8d594a$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $54d14871ce8d594a$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}
/**
 * Post Office fires its own operational events on a dedicated channel so that platform
 * health can be dashboarded and alerted on independently of product analytics.
 */ const $54d14871ce8d594a$var$ANALYTICS_CHANNEL = 'postOffice';
const $54d14871ce8d594a$export$a0dea339c6cbd667 = 'failed';
const $54d14871ce8d594a$export$55cf5651c143da83 = 'messageInstanceEvent';
/**
 * Reports a message instance event that could not be sent because Post Office-owned context
 * was missing.
 *
 * This lives at the client level, rather than in each caller, so that every lifecycle event
 * is covered by one implementation.
 *
 * The GASv3 event is the source of truth in production, including when the host surface has
 * not mounted a `postOffice` channel listener, in which case `fire()` is a silent no-op.
 * This is the failure path of every in-app message instance event.
 *
 * The console message is dev-only and deliberately ungated, matching `useGasv3Listener` in
 * this same package — it gives Message Makers immediate feedback while wiring up
 * instrumentation.
 */ const $54d14871ce8d594a$var$useReportMissingEventContext = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    return (0, $fc4bM.useCallback)(({ messageEventType: messageEventType, missingFields: missingFields, messageTemplateId: messageTemplateId, placementId: placementId, interactionIdentifier: interactionIdentifier, actionType: actionType })=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: $54d14871ce8d594a$export$a0dea339c6cbd667,
            actionSubject: $54d14871ce8d594a$export$55cf5651c143da83,
            actionSubjectId: messageEventType,
            side: 'client',
            attributes: {
                reason: 'missingContext',
                missingFields: missingFields,
                messageTemplateId: messageTemplateId,
                placementId: placementId,
                interactionIdentifier: interactionIdentifier,
                actionType: actionType
            },
            tags: [
                'postOffice'
            ]
        }).fire($54d14871ce8d594a$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
};
const $54d14871ce8d594a$export$39b0f5626e96f41e = ()=>{
    var _globalThis$window, _globalThis$window2;
    // globalThis resolves to window in the browser, this will therefore attach at window.window, but we should not change until we are sure what is relying on this path.
    if (typeof window !== 'undefined' && !(globalThis !== null && globalThis !== void 0 && (_globalThis$window = globalThis.window) !== null && _globalThis$window !== void 0 && _globalThis$window.postOfficeMessageInstanceEventClient)) {
        // If we are in the browser but there is no window.window
        if (typeof globalThis.window === 'undefined') globalThis.window = {};
        globalThis.window.postOfficeMessageInstanceEventClient = new (0, $9HZEg.MessageInstanceEventClient)();
    }
    const messageInstanceEventClientRef = (0, $fc4bM.useRef)((globalThis === null || globalThis === void 0 || (_globalThis$window2 = globalThis.window) === null || _globalThis$window2 === void 0 ? void 0 : _globalThis$window2.postOfficeMessageInstanceEventClient) ?? new (0, $9HZEg.MessageInstanceEventClient)());
    // This falls back to creation per call in the case window is not defined. It is not the best behaviour as this could cause too many object to be created but is
    // better than an uncontrolled error in SSR. This function needs to be made SSR safe in a safter manner.
    const client = messageInstanceEventClientRef.current;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null, configSetId: configSetId } = (0, $enWoH.useMessageContext)();
    const { placementId: placementId, traceId: traceId } = (0, $9Pihb.usePlacementContext)();
    const browserContext = (0, $im5M7.usePostOfficeContext)();
    const { entityId: entityId, sessionId: sessionId, itemFeatureSetId: itemFeatureSetId } = (0, $lUl1y.useRecommendationContext)();
    const reportMissingEventContext = $54d14871ce8d594a$var$useReportMissingEventContext();
    const messageInstanceDeliveredSuccessfully = (0, $fc4bM.useCallback)(async (additionalMetadataFromFrontend)=>{
        const eventContext = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            placementId: placementId,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId
        };
        if (!(0, $3ED3W.hasCompleteMessageInstanceEventContext)(eventContext)) {
            reportMissingEventContext({
                messageEventType: 'deliverySuccessful',
                missingFields: (0, $3ED3W.getMissingMessageInstanceEventContext)(eventContext),
                messageTemplateId: messageTemplateId,
                placementId: placementId
            });
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: eventContext.messageInstanceId,
            messageTemplateId: eventContext.messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: eventContext.placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: eventContext.placementId,
                recommendation: (0, $3ED3W.recommendationFromContext)({
                    entityId: entityId,
                    sessionId: sessionId,
                    itemFeatureSetId: itemFeatureSetId
                })
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: eventContext.messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: eventContext.messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        entityId,
        sessionId,
        itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId,
        reportMissingEventContext
    ]);
    const messageInstanceViewed = (0, $fc4bM.useCallback)(async (additionalMetadataFromFrontend)=>{
        const eventContext = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            placementId: placementId,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId
        };
        if (!(0, $3ED3W.hasCompleteMessageInstanceEventContext)(eventContext)) {
            reportMissingEventContext({
                messageEventType: 'viewed',
                missingFields: (0, $3ED3W.getMissingMessageInstanceEventContext)(eventContext),
                messageTemplateId: messageTemplateId,
                placementId: placementId
            });
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: eventContext.messageInstanceId,
            messageTemplateId: eventContext.messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: eventContext.placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: eventContext.placementId,
                recommendation: (0, $3ED3W.recommendationFromContext)({
                    entityId: entityId,
                    sessionId: sessionId,
                    itemFeatureSetId: itemFeatureSetId
                })
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: eventContext.messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: eventContext.messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        entityId,
        sessionId,
        itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId,
        reportMissingEventContext
    ]);
    const messageInstanceClicked = (0, $fc4bM.useCallback)(async (params)=>{
        const eventContext = {
            messageInstanceId: params.messageInstanceId || messageInstanceId,
            messageTemplateId: params.messageTemplateId || messageTemplateId,
            placementId: placementId,
            messageCreationType: params.messageCreationType || messageCreationType,
            messageTriggerId: params.messageTriggerId || messageTriggerId
        };
        if (!(0, $3ED3W.hasCompleteMessageInstanceEventContext)(eventContext)) {
            var _params$action;
            reportMissingEventContext({
                messageEventType: 'clicked',
                missingFields: (0, $3ED3W.getMissingMessageInstanceEventContext)(eventContext),
                messageTemplateId: params.messageTemplateId || messageTemplateId,
                placementId: placementId,
                interactionIdentifier: params.interactionIdentifier,
                actionType: (_params$action = params.action) === null || _params$action === void 0 ? void 0 : _params$action.actionType
            });
            return;
        }
        await client.sendMessageInstanceEvent({
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: eventContext.placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: eventContext.placementId,
                recommendation: (0, $3ED3W.recommendationFromContext)({
                    entityId: entityId,
                    sessionId: sessionId,
                    itemFeatureSetId: itemFeatureSetId
                })
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        entityId,
        sessionId,
        itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId,
        reportMissingEventContext
    ]);
    const messageInstanceDropped = (0, $fc4bM.useCallback)((dropDetails, message)=>(0, $d7ngk.sendMessageInstanceDropped)({
            client: client,
            browserContext: browserContext,
            placementId: (message === null || message === void 0 ? void 0 : message.placementId) ?? placementId,
            traceId: traceId,
            reportMissingEventContext: reportMissingEventContext
        }, // List selectors supply identity before a per-message context exists.
        message ?? {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: messageTriggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            transactionAccountId: transactionAccountId,
            analyticsDetails: analyticsDetails,
            recommendation: {
                entityId: entityId,
                sessionId: sessionId,
                itemFeatureSetId: itemFeatureSetId
            }
        }, dropDetails), [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        entityId,
        sessionId,
        itemFeatureSetId,
        journeyId,
        journeyTriggerId,
        configSetId,
        traceId,
        reportMissingEventContext
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked,
        messageInstanceDropped: messageInstanceDropped
    };
};
const $54d14871ce8d594a$export$f847ba3acec566f4 = ()=>{
    // -- message-lifecycle (legacy) client --
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $cgK27.MessageEventClient)();
    const legacyClient = globalThis.window.postOfficeMessageEventClient;
    // -- message-instance-event client --
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $9HZEg.MessageInstanceEventClient)();
    const instanceClient = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId } = (0, $enWoH.useMessageContext)();
    const { placementId: placementId } = (0, $9Pihb.usePlacementContext)();
    const browserContext = (0, $im5M7.usePostOfficeContext)();
    const recommendationContext = (0, $lUl1y.useRecommendationContext)();
    const { markViewedFromPlacement: markViewedFromPlacement } = (0, $fg655.useMessagePlacementHooks)();
    const reportMissingEventContext = $54d14871ce8d594a$var$useReportMissingEventContext();
    return async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) {
            reportMissingEventContext({
                messageEventType: 'viewed',
                missingFields: [
                    [
                        'messageInstanceId',
                        messageInstanceId
                    ],
                    [
                        'messageTemplateId',
                        messageTemplateId
                    ],
                    [
                        'placementId',
                        placementId
                    ]
                ].filter(([, value])=>!value).map(([field])=>field),
                messageTemplateId: messageTemplateId,
                placementId: placementId
            });
            return;
        }
        const sharedContext = {
            ...browserContext,
            source: placementId,
            recommendation: (0, $3ED3W.recommendationFromContext)(recommendationContext)
        };
        // 1. Legacy lifecycle event (messageViewed)
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        legacyClient.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cgK27.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: {
                browser: browserContext,
                recommendation: recommendationContext
            }
        });
        // 2. messageInstanceViewed
        await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType ?? 'implicit',
            messageTriggerId: messageTriggerId ?? '',
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails
            },
            timestamp: Date.now()
        });
        // 3. messageInstanceDeliveredSuccessfully
        if (messageCreationType && messageTriggerId) await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails
            },
            timestamp: Date.now()
        });
    };
};
const $54d14871ce8d594a$var$MESSAGE_COOLDOWN_INTERACTION_IDENTIFIER = 'messageDisplayedCooldown';
const $54d14871ce8d594a$export$6c31029f3dbc9d82 = ()=>{
    const { messageInstanceClicked: messageInstanceClicked } = $54d14871ce8d594a$export$39b0f5626e96f41e();
    const { messageTemplateId: messageTemplateId } = (0, $enWoH.useMessageContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    return (0, $fc4bM.useCallback)((durationDays)=>{
        if (typeof window === 'undefined' || !Number.isFinite(durationDays) || durationDays <= 0) return;
        messageInstanceClicked({
            messageEventType: 'clicked',
            interactionIdentifier: $54d14871ce8d594a$var$MESSAGE_COOLDOWN_INTERACTION_IDENTIFIER,
            clickedElement: (0, $9HZEg.notApplicableClickedElement)($54d14871ce8d594a$var$MESSAGE_COOLDOWN_INTERACTION_IDENTIFIER),
            action: {
                actionType: 'snooze',
                snoozeDuration: durationDays
            }
        }).catch(()=>{
            if (messageTemplateId === 'rovo-chat-csat-survey') createAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'messageCooldown',
                attributes: {
                    messageTemplateId: 'rovo-chat-csat-survey',
                    reason: 'deliveryFailed'
                }
            }).fire($54d14871ce8d594a$var$ANALYTICS_CHANNEL);
            // Do not log the event or response: they can contain recipient context.
            // eslint-disable-next-line no-console
            console.error('[Post Office] Display cooldown delivery failed; suppression is not confirmed.');
        });
    }, [
        messageInstanceClicked,
        messageTemplateId,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("fg655", function(module, exports) {
$parcel$export(module.exports, "createMessagePlacementValues", () => $1af6f3476088e9bf$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $1af6f3476088e9bf$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $1af6f3476088e9bf$export$89f8e1f623d8f5ac);

var $fc4bM = parcelRequire("fc4bM");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $1af6f3476088e9bf$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
   * Subscribes a callback function to the pub-sub system.
   * @param {Callback} subscriber - The callback function to subscribe.
   * @returns A function to unsubscribe the callback.
   */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
   * Publishes the payload to all subscribed callbacks.
   * @param {Callback} payload - The payload to publish to the subscribers.
   */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $1af6f3476088e9bf$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $1af6f3476088e9bf$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $1af6f3476088e9bf$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $1af6f3476088e9bf$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $1af6f3476088e9bf$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $1af6f3476088e9bf$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $1af6f3476088e9bf$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $fc4bM.createContext)($1af6f3476088e9bf$export$a28a0c048b24fc5a());
const $1af6f3476088e9bf$export$c7535f8ebc5b75a9 = $1af6f3476088e9bf$export$ea58328f3ceee4d4.Provider;
const $1af6f3476088e9bf$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1af6f3476088e9bf$export$c7535f8ebc5b75a9, {
            value: $1af6f3476088e9bf$export$a28a0c048b24fc5a()
        }, children);
const $1af6f3476088e9bf$export$89f8e1f623d8f5ac = ()=>(0, $fc4bM.useContext)($1af6f3476088e9bf$export$ea58328f3ceee4d4);

});

parcelRegister("im5M7", function(module, exports) {
$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $ec63a4835b7c3f1b$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $ec63a4835b7c3f1b$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "usePostOfficeContext", () => $ec63a4835b7c3f1b$export$5bd9099e0ae94a43);

var $fc4bM = parcelRequire("fc4bM");
const $ec63a4835b7c3f1b$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $ec63a4835b7c3f1b$export$a228be81fcb77b42 = (0, $fc4bM.createContext)($ec63a4835b7c3f1b$export$da5dc9062cba6715);
const $ec63a4835b7c3f1b$export$3a10495c2cd2db0c = $ec63a4835b7c3f1b$export$a228be81fcb77b42.Provider;
const $ec63a4835b7c3f1b$export$b77983be89bb0a4e = $ec63a4835b7c3f1b$export$3a10495c2cd2db0c;
const $ec63a4835b7c3f1b$export$5bd9099e0ae94a43 = ()=>(0, $fc4bM.useContext)($ec63a4835b7c3f1b$export$a228be81fcb77b42);

});

parcelRegister("enWoH", function(module, exports) {
$parcel$export(module.exports, "MessageContextProvider", () => $3181dfcce55cfbb7$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $3181dfcce55cfbb7$export$a5b6d14a2e25725a);
/**
 * Canonical message context implementation.
 *
 * This is the source of truth for message context consumers.
 * Consumers should import via:
 *   import { useMessageContext, MessageContextProvider } from '@atlassian/post-office-context/message-context';
 */ 
var $fc4bM = parcelRequire("fc4bM");
const $3181dfcce55cfbb7$var$initialValue = {};
const $3181dfcce55cfbb7$export$b060d577040138d8 = (0, $fc4bM.createContext)($3181dfcce55cfbb7$var$initialValue);
const $3181dfcce55cfbb7$export$42de33f7652dc3de = $3181dfcce55cfbb7$export$b060d577040138d8.Provider;
const $3181dfcce55cfbb7$export$a5b6d14a2e25725a = ()=>(0, $fc4bM.useContext)($3181dfcce55cfbb7$export$b060d577040138d8);

});

parcelRegister("cgK27", function(module, exports) {
$parcel$export(module.exports, "InAppMessageEventType", () => $c41a250e7bf17bbe$export$b31ffc6f7c85f1b);
$parcel$export(module.exports, "MessageEventClient", () => $c41a250e7bf17bbe$export$ae86a6dabe385178);
/**
 * Canonical MessageEventClient implementation.
 *
 * This is the source of truth. `@post-office/message-lifecycle` uses this via
 * `@atlassian/post-office-context/message-lifecycle`.
 */ // ---------------------------------------------------------------------------
// Types (inlined from @post-office/message-lifecycle/src/types.ts)
// ---------------------------------------------------------------------------
var $c41a250e7bf17bbe$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $c41a250e7bf17bbe$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $c41a250e7bf17bbe$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $c41a250e7bf17bbe$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("7k5kG"));
class $c41a250e7bf17bbe$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $c41a250e7bf17bbe$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $c41a250e7bf17bbe$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $c41a250e7bf17bbe$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($c41a250e7bf17bbe$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $c41a250e7bf17bbe$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $c41a250e7bf17bbe$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("7k5kG", function(module, exports) {
$parcel$export(module.exports, "Headers", () => $554e899b4633cc8c$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $554e899b4633cc8c$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $554e899b4633cc8c$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $554e899b4633cc8c$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $554e899b4633cc8c$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $554e899b4633cc8c$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $554e899b4633cc8c$var$support = {
    searchParams: 'URLSearchParams' in $554e899b4633cc8c$var$g,
    iterable: 'Symbol' in $554e899b4633cc8c$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $554e899b4633cc8c$var$g && 'Blob' in $554e899b4633cc8c$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $554e899b4633cc8c$var$g,
    arrayBuffer: 'ArrayBuffer' in $554e899b4633cc8c$var$g
};
function $554e899b4633cc8c$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($554e899b4633cc8c$var$support.arrayBuffer) {
    var $554e899b4633cc8c$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $554e899b4633cc8c$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $554e899b4633cc8c$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $554e899b4633cc8c$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $554e899b4633cc8c$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $554e899b4633cc8c$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($554e899b4633cc8c$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $554e899b4633cc8c$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $554e899b4633cc8c$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $554e899b4633cc8c$var$normalizeName(name);
    value = $554e899b4633cc8c$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$554e899b4633cc8c$var$normalizeName(name)];
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $554e899b4633cc8c$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($554e899b4633cc8c$var$normalizeName(name));
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$554e899b4633cc8c$var$normalizeName(name)] = $554e899b4633cc8c$var$normalizeValue(value);
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $554e899b4633cc8c$var$iteratorFor(items);
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $554e899b4633cc8c$var$iteratorFor(items);
};
$554e899b4633cc8c$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $554e899b4633cc8c$var$iteratorFor(items);
};
if ($554e899b4633cc8c$var$support.iterable) $554e899b4633cc8c$export$79b704688b15c0f4.prototype[Symbol.iterator] = $554e899b4633cc8c$export$79b704688b15c0f4.prototype.entries;
function $554e899b4633cc8c$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $554e899b4633cc8c$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $554e899b4633cc8c$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $554e899b4633cc8c$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $554e899b4633cc8c$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $554e899b4633cc8c$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $554e899b4633cc8c$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $554e899b4633cc8c$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $554e899b4633cc8c$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($554e899b4633cc8c$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($554e899b4633cc8c$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($554e899b4633cc8c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($554e899b4633cc8c$var$support.arrayBuffer && $554e899b4633cc8c$var$support.blob && $554e899b4633cc8c$var$isDataView(body)) {
            this._bodyArrayBuffer = $554e899b4633cc8c$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($554e899b4633cc8c$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $554e899b4633cc8c$var$isArrayBufferView(body))) this._bodyArrayBuffer = $554e899b4633cc8c$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($554e899b4633cc8c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($554e899b4633cc8c$var$support.blob) this.blob = function() {
        var rejected = $554e899b4633cc8c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $554e899b4633cc8c$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($554e899b4633cc8c$var$support.blob) return this.blob().then($554e899b4633cc8c$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $554e899b4633cc8c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $554e899b4633cc8c$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($554e899b4633cc8c$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($554e899b4633cc8c$var$support.formData) this.formData = function() {
        return this.text().then($554e899b4633cc8c$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $554e899b4633cc8c$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $554e899b4633cc8c$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $554e899b4633cc8c$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $554e899b4633cc8c$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $554e899b4633cc8c$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $554e899b4633cc8c$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $554e899b4633cc8c$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $554e899b4633cc8c$export$79b704688b15c0f4(options.headers);
    this.method = $554e899b4633cc8c$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $554e899b4633cc8c$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$554e899b4633cc8c$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $554e899b4633cc8c$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $554e899b4633cc8c$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $554e899b4633cc8c$var$parseHeaders(rawHeaders) {
    var headers = new $554e899b4633cc8c$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$554e899b4633cc8c$var$Body.call($554e899b4633cc8c$export$7fa6c5b6f8193917.prototype);
function $554e899b4633cc8c$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $554e899b4633cc8c$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $554e899b4633cc8c$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$554e899b4633cc8c$var$Body.call($554e899b4633cc8c$export$9f633d56d7ec90d3.prototype);
$554e899b4633cc8c$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $554e899b4633cc8c$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $554e899b4633cc8c$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$554e899b4633cc8c$export$9f633d56d7ec90d3.error = function() {
    var response = new $554e899b4633cc8c$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $554e899b4633cc8c$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$554e899b4633cc8c$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($554e899b4633cc8c$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $554e899b4633cc8c$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $554e899b4633cc8c$export$fe58bcf938607f6a = $554e899b4633cc8c$var$g.DOMException;
try {
    new $554e899b4633cc8c$export$fe58bcf938607f6a();
} catch (err) {
    $554e899b4633cc8c$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $554e899b4633cc8c$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $554e899b4633cc8c$export$fe58bcf938607f6a.prototype.constructor = $554e899b4633cc8c$export$fe58bcf938607f6a;
}
function $554e899b4633cc8c$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $554e899b4633cc8c$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $554e899b4633cc8c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $554e899b4633cc8c$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $554e899b4633cc8c$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $554e899b4633cc8c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $554e899b4633cc8c$var$g.location.href ? $554e899b4633cc8c$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($554e899b4633cc8c$var$support.blob) xhr.responseType = 'blob';
            else if ($554e899b4633cc8c$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $554e899b4633cc8c$export$79b704688b15c0f4 || $554e899b4633cc8c$var$g.Headers && init.headers instanceof $554e899b4633cc8c$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($554e899b4633cc8c$var$normalizeName(name));
                xhr.setRequestHeader(name, $554e899b4633cc8c$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$554e899b4633cc8c$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$554e899b4633cc8c$var$g.fetch) {
    $554e899b4633cc8c$var$g.fetch = $554e899b4633cc8c$export$e7aa7bc5c1b3cfb3;
    $554e899b4633cc8c$var$g.Headers = $554e899b4633cc8c$export$79b704688b15c0f4;
    $554e899b4633cc8c$var$g.Request = $554e899b4633cc8c$export$7fa6c5b6f8193917;
    $554e899b4633cc8c$var$g.Response = $554e899b4633cc8c$export$9f633d56d7ec90d3;
}

});


parcelRegister("9HZEg", function(module, exports) {
$parcel$export(module.exports, "notApplicableClickedElement", () => $d7878d35adc69d54$export$5450bf854325d564);
$parcel$export(module.exports, "MessageInstanceEventClient", () => $d7878d35adc69d54$export$4564cfc2de39be55);
/**
 * Canonical MessageInstanceEventClient implementation.
 *
 * This is the source of truth for frontend in-app message instance events.
 * `@atlassian/message-instance-event-frontend-client/message-instance-event-client` and the legacy
 * `@atlassian/message-instance-event-frontend-client` exports this implementation.
 */ 
var $dRkX9 = parcelRequire("dRkX9");
const $d7878d35adc69d54$export$5450bf854325d564 = (clickIdentifier)=>({
        clickIdentifier: clickIdentifier,
        clickedElement: 'not-applicable'
    });
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $d7878d35adc69d54$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $d7878d35adc69d54$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $d7878d35adc69d54$var$MESSAGE_EVENTS_BATCH_SIZE = 30;
const $d7878d35adc69d54$var$CSAT_COOLDOWN_MAX_ATTEMPTS = 3;
const $d7878d35adc69d54$var$CSAT_COOLDOWN_RETRY_WINDOW_MS = 30000;
const $d7878d35adc69d54$var$CSAT_COOLDOWN_REQUEST_TIMEOUT_MS = 5000;
const $d7878d35adc69d54$var$retryAfterMilliseconds = (response)=>{
    const value = response === null || response === void 0 ? void 0 : response.headers.get('Retry-After');
    if (!value) return 0;
    const delay = /^\d+$/.test(value) ? Number(value) * 1000 : Date.parse(value) - Date.now();
    return Number.isNaN(delay) ? 0 : Math.max(0, delay);
};
// Retry only the CSAT display cooldown, not viewed events or other templates' interactions.
// Replays may extend expiry and duplicate cooldown analytics if an earlier attempt was accepted.
// Keep the window short and never treat HTTP acceptance as proof of durable persistence.
const $d7878d35adc69d54$var$sendCsatCooldown = async (endpointUrl, body)=>{
    const deadline = Date.now() + $d7878d35adc69d54$var$CSAT_COOLDOWN_RETRY_WINDOW_MS;
    for(let attempt = 0; attempt < $d7878d35adc69d54$var$CSAT_COOLDOWN_MAX_ATTEMPTS; attempt++){
        var _response;
        const remaining = deadline - Date.now();
        if (remaining <= 0) break;
        const controller = new AbortController();
        const timeout = globalThis.setTimeout(()=>controller.abort(), Math.min($d7878d35adc69d54$var$CSAT_COOLDOWN_REQUEST_TIMEOUT_MS, remaining));
        let response;
        try {
            response = await fetch(endpointUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body,
                keepalive: true,
                signal: controller.signal
            });
        } catch (error) {
            if (!(error instanceof TypeError) && !(error instanceof DOMException && error.name === 'AbortError')) throw error;
        } finally{
            globalThis.clearTimeout(timeout);
        }
        if ((_response = response) !== null && _response !== void 0 && _response.ok) return;
        if (response && ![
            408,
            429,
            500,
            502,
            503,
            504
        ].includes(response.status)) break;
        if (attempt === $d7878d35adc69d54$var$CSAT_COOLDOWN_MAX_ATTEMPTS - 1) break;
        const delay = Math.max(1000 * 2 ** attempt + Math.floor(Math.random() * 250), $d7878d35adc69d54$var$retryAfterMilliseconds(response));
        // Do not shorten Retry-After or replay a stale event after a suspended tab resumes.
        if (Date.now() + delay >= deadline) break;
        await new Promise((resolve)=>globalThis.setTimeout(resolve, delay));
    }
    throw new Error('Post Office CSAT display cooldown delivery failed');
};

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("7k5kG"));
class $d7878d35adc69d54$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        if (event.messageEventType === 'clicked' && event.interactionIdentifier === 'messageDisplayedCooldown' && event.action.actionType === 'snooze') {
            if (event.messageTemplateId === 'rovo-chat-csat-survey') return $d7878d35adc69d54$var$sendCsatCooldown(this.endpointUrl, JSON.stringify([
                event
            ]));
            // Display cooldowns must not wait behind (or be lost by) the analytics batch.
            // Keep this path separate: other lifecycle events retain their existing delivery.
            const response = await fetch(this.endpointUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify([
                    event
                ]),
                keepalive: true
            });
            if (!response.ok) throw new Error(`Post Office display cooldown request failed: ${response.status}`);
            // Other templates retain their single-attempt delivery contract.
            return;
        }
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $d7878d35adc69d54$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if ((0, $dRkX9.fg)('post-office_enable_safe-event-batching')) return this.flushBatchEventsSafely();
        if (this.batchEvents.length > $d7878d35adc69d54$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $d7878d35adc69d54$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($d7878d35adc69d54$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $d7878d35adc69d54$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    async flushBatchEventsSafely() {
        // Detach the attempted batch so events arriving during fetch remain queued.
        const batch = this.batchEvents.splice(0, $d7878d35adc69d54$var$MESSAGE_EVENTS_BATCH_SIZE);
        try {
            await this.sendEventsToBackend(batch);
        } catch  {
            // eslint-disable-next-line no-console
            console.error('Failed to send event to analytics endpoint');
        } finally{
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = this.batchEvents.length > 0 ? globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $d7878d35adc69d54$var$FLUSH_BATCH_EVENTS_TIMEOUT) : null;
        }
    }
    constructor(){
        this.endpointUrl = $d7878d35adc69d54$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("3ED3W", function(module, exports) {
$parcel$export(module.exports, "getMissingMessageInstanceEventContext", () => $cce97cdaa7928927$export$879037ebacefbb96);
$parcel$export(module.exports, "hasCompleteMessageInstanceEventContext", () => $cce97cdaa7928927$export$43c572a5ed8b78fb);
$parcel$export(module.exports, "recommendationFromContext", () => $cce97cdaa7928927$export$48527f9a3b2d15c5);

var $dRkX9 = parcelRequire("dRkX9");
/**
 * The Post Office-owned context every message instance event needs before it can be sent.
 */ const $cce97cdaa7928927$var$REQUIRED_MESSAGE_INSTANCE_EVENT_CONTEXT = [
    'messageInstanceId',
    'messageTemplateId',
    'placementId',
    'messageCreationType',
    'messageTriggerId'
];
const $cce97cdaa7928927$export$879037ebacefbb96 = (context)=>$cce97cdaa7928927$var$REQUIRED_MESSAGE_INSTANCE_EVENT_CONTEXT.filter((field)=>!context[field]);
const $cce97cdaa7928927$export$43c572a5ed8b78fb = (context)=>$cce97cdaa7928927$export$879037ebacefbb96(context).length === 0;
const $cce97cdaa7928927$export$a92cb617963dd715 = 'post-office_enable_null-recommendation-ids';
const $cce97cdaa7928927$var$toNullableId = (value)=>value ? value : null;
const $cce97cdaa7928927$export$48527f9a3b2d15c5 = (reco)=>{
    if ((0, $dRkX9.fg)($cce97cdaa7928927$export$a92cb617963dd715)) return {
        recommendationSessionId: $cce97cdaa7928927$var$toNullableId(reco.sessionId),
        recommendationEntityId: $cce97cdaa7928927$var$toNullableId(reco.entityId),
        itemFeatureSetId: $cce97cdaa7928927$var$toNullableId(reco.itemFeatureSetId)
    };
    return {
        recommendationSessionId: reco.sessionId ?? '',
        recommendationEntityId: reco.entityId ?? '',
        itemFeatureSetId: reco.itemFeatureSetId ?? ''
    };
};

});

parcelRegister("9Pihb", function(module, exports) {
$parcel$export(module.exports, "PlacementProvider", () => $a050002cc0f8087e$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $a050002cc0f8087e$export$4fc0446ee742ad80);
/**
 * Canonical placement context implementation.
 *
 * This is the source of truth for placement context consumers.
 * Consumers should import via:
 *   import { PlacementProvider, usePlacementContext } from '@atlassian/post-office-context/placement-context';
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $hopeZ = parcelRequire("hopeZ");

var $kO6GI = parcelRequire("kO6GI");
const $a050002cc0f8087e$export$6394bf86db095a8 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    placementId: undefined
});
const $a050002cc0f8087e$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $fc4bM.useMemo)(()=>({
            placementId: value.placementId,
            traceId: value.traceId
        }), [
        value.placementId,
        value.traceId
    ]);
    const analyticsValue = (0, $fc4bM.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $kO6GI.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a050002cc0f8087e$export$6394bf86db095a8.Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hopeZ.PostOfficeAnalyticsContext), {
        data: analyticsValue
    }, children));
};
const $a050002cc0f8087e$export$4fc0446ee742ad80 = ()=>(0, $fc4bM.useContext)($a050002cc0f8087e$export$6394bf86db095a8);

});
parcelRegister("kO6GI", function(module, exports) {
$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $b13ec2f5b091521f$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $b13ec2f5b091521f$export$f51d04a086368016);

var $fc4bM = parcelRequire("fc4bM");

var $lAHKa = parcelRequire("lAHKa");

var $paAR0 = parcelRequire("paAR0");
const $b13ec2f5b091521f$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $b13ec2f5b091521f$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    placements: $b13ec2f5b091521f$var$initialPlacementState
});
const $b13ec2f5b091521f$export$70e19226ddeaf957 = ()=>(0, $fc4bM.useContext)($b13ec2f5b091521f$var$PostOfficeScreenContext);
const $b13ec2f5b091521f$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $b13ec2f5b091521f$export$5d27c0ee02be2a23 = ()=>(0, $fc4bM.useContext)($b13ec2f5b091521f$var$PostOfficeScreenUpdateContext);
const $b13ec2f5b091521f$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $fc4bM.useState)($b13ec2f5b091521f$var$initialPlacementState);
    const placementMount = (0, $fc4bM.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $paAR0.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $paAR0.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $fc4bM.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $fc4bM.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $fc4bM.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    (0, $lAHKa.useExtensionBridge)(placements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b13ec2f5b091521f$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b13ec2f5b091521f$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $b13ec2f5b091521f$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $b13ec2f5b091521f$export$5d27c0ee02be2a23();
    (0, $fc4bM.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("lAHKa", function(module, exports) {
$parcel$export(module.exports, "useExtensionBridge", () => $3e7590eb1831ad40$export$8259063deb54485c);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $juO81 = parcelRequire("juO81");

var $7ZXZX = parcelRequire("7ZXZX");
const $3e7590eb1831ad40$var$useIsomorphicLayoutEffect = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
const $3e7590eb1831ad40$export$8259063deb54485c = (placements)=>{
    const isExtensionControlEnabled = (0, $dRkX9.fg)('post-office_enable_extension-control');
    $3e7590eb1831ad40$var$useIsomorphicLayoutEffect(()=>{
        if (!isExtensionControlEnabled) return;
        // Exposes the gated, page-owned bridge for the DevTools extension to read
        // placement state and configure simulations without fetch interception.
        const cleanup = (0, $juO81.installExtensionBridge)();
        return ()=>{
            // Removes only the bridge installed by this hook instance and clears the
            // screen snapshot so an unmounted screen cannot be observed by DevTools.
            cleanup();
            (0, $7ZXZX.extensionBridgeStore).resetScreenPlacementsForExtension();
        };
    }, [
        isExtensionControlEnabled
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isExtensionControlEnabled) return;
        (0, $7ZXZX.extensionBridgeStore).setScreenPlacementsForExtension(placements);
    }, [
        isExtensionControlEnabled,
        placements
    ]);
};

});
parcelRegister("juO81", function(module, exports) {
$parcel$export(module.exports, "installExtensionBridge", () => $673d75885f2bfa1c$export$afb661e8e04a13db);

var $dRkX9 = parcelRequire("dRkX9");

var $7ZXZX = parcelRequire("7ZXZX");
const $673d75885f2bfa1c$var$getWindow = ()=>typeof window === 'undefined' ? undefined : window;
const $673d75885f2bfa1c$export$afb661e8e04a13db = ()=>{
    const currentWindow = $673d75885f2bfa1c$var$getWindow();
    if (!currentWindow) return ()=>{};
    if (!(0, $dRkX9.fg)('post-office_enable_extension-control')) {
        var _currentWindow$postOf;
        if ((_currentWindow$postOf = currentWindow.postOffice) !== null && _currentWindow$postOf !== void 0 && _currentWindow$postOf.extensionControl) currentWindow.postOffice.extensionControl = undefined;
        return ()=>{};
    }
    const bridge = {
        clearPlacementConfig: (placementId)=>(0, $7ZXZX.extensionBridgeStore).clearPlacementSimulationConfig(placementId),
        getConfig: ()=>(0, $7ZXZX.extensionBridgeStore).getSimulationConfig(),
        getPlacementConfig: (placementId)=>(0, $7ZXZX.extensionBridgeStore).getPlacementSimulationConfig(placementId),
        getScreenPlacements: ()=>(0, $7ZXZX.extensionBridgeStore).getScreenPlacementsForExtension(),
        reset: ()=>(0, $7ZXZX.extensionBridgeStore).resetSimulationConfig(),
        setPlacementConfig: (placementId, config)=>(0, $7ZXZX.extensionBridgeStore).setPlacementSimulationConfig(placementId, config),
        subscribe: (listener)=>(0, $7ZXZX.extensionBridgeStore).subscribeSimulationConfig(listener)
    };
    currentWindow.postOffice = {
        ...currentWindow.postOffice,
        extensionControl: bridge
    };
    return ()=>{
        var _currentWindow$postOf2;
        if (((_currentWindow$postOf2 = currentWindow.postOffice) === null || _currentWindow$postOf2 === void 0 ? void 0 : _currentWindow$postOf2.extensionControl) === bridge) currentWindow.postOffice.extensionControl = undefined;
    };
};

});
parcelRegister("7ZXZX", function(module, exports) {
$parcel$export(module.exports, "extensionBridgeStore", () => $64f84ec52de572b7$export$f7be8dd409e65174);
const $64f84ec52de572b7$var$EMPTY_STATE = {
    placements: {}
};
const $64f84ec52de572b7$var$EMPTY_SCREEN_PLACEMENTS = {
    currentlyMounted: [],
    hasMounted: []
};
const $64f84ec52de572b7$var$cloneSimulationParams = (params)=>Object.fromEntries(Object.entries(params).map(([key, value])=>[
            key,
            Array.isArray(value) ? [
                ...value
            ] : value
        ]));
const $64f84ec52de572b7$var$clonePlacementSimulationConfig = (config)=>({
        enabled: config.enabled,
        params: $64f84ec52de572b7$var$cloneSimulationParams(config.params)
    });
const $64f84ec52de572b7$var$cloneState = (next)=>({
        placements: Object.fromEntries(Object.entries(next.placements).map(([placementId, config])=>[
                placementId,
                $64f84ec52de572b7$var$clonePlacementSimulationConfig(config)
            ]))
    });
const $64f84ec52de572b7$var$cloneScreenPlacements = (next)=>({
        currentlyMounted: [
            ...next.currentlyMounted
        ],
        hasMounted: [
            ...next.hasMounted
        ]
    });
const $64f84ec52de572b7$var$areScreenPlacementsEqual = (a, b)=>a.currentlyMounted.length === b.currentlyMounted.length && a.hasMounted.length === b.hasMounted.length && a.currentlyMounted.every((id, index)=>id === b.currentlyMounted[index]) && a.hasMounted.every((id, index)=>id === b.hasMounted[index]);
class $64f84ec52de572b7$export$c77fe7cfaf785a6 {
    getSimulationConfig() {
        return $64f84ec52de572b7$var$cloneState(this.state);
    }
    getPlacementSimulationConfig(placementId) {
        const entry = this.state.placements[placementId];
        return entry ? $64f84ec52de572b7$var$clonePlacementSimulationConfig(entry) : undefined;
    }
    /**
   * Returns simulate params for a placement only when that placement's toggle is
   * on. Disabled or missing placements return `undefined` so callers can leave
   * the request untouched.
   */ getEnabledSimulationParams(placementId) {
        const params = this.getEnabledSimulationParamsSnapshot(placementId);
        return params ? $64f84ec52de572b7$var$cloneSimulationParams(params) : undefined;
    }
    /**
   * Returns the store-owned params reference for React's external-store snapshot.
   * This is intentionally not re-exported from the bridge's public entry point:
   * public callers must receive a clone so they cannot mutate store state without
   * notifying subscribers.
   */ getEnabledSimulationParamsSnapshot(placementId) {
        const entry = this.state.placements[placementId];
        if (!(entry !== null && entry !== void 0 && entry.enabled)) return undefined;
        return entry.params;
    }
    setPlacementSimulationConfig(placementId, config) {
        this.state = {
            placements: {
                ...this.state.placements,
                [placementId]: $64f84ec52de572b7$var$clonePlacementSimulationConfig(config)
            }
        };
        this.notify();
    }
    clearPlacementSimulationConfig(placementId) {
        if (!(placementId in this.state.placements)) return;
        const { [placementId]: _removed, ...placements } = this.state.placements;
        this.state = {
            placements: placements
        };
        this.notify();
    }
    resetSimulationConfig() {
        if (Object.keys(this.state.placements).length === 0) return;
        this.state = $64f84ec52de572b7$var$EMPTY_STATE;
        this.notify();
    }
    getScreenPlacementsForExtension() {
        return $64f84ec52de572b7$var$cloneScreenPlacements(this.screenPlacements);
    }
    /**
   * Mirrors Post Office screen-context placement IDs for the extension bridge.
   * Notifies subscribers when the on-screen snapshot changes.
   */ setScreenPlacementsForExtension(placements) {
        const next = $64f84ec52de572b7$var$cloneScreenPlacements(placements);
        if ($64f84ec52de572b7$var$areScreenPlacementsEqual(this.screenPlacements, next)) return;
        this.screenPlacements = next;
        this.notify();
    }
    resetScreenPlacementsForExtension() {
        if ($64f84ec52de572b7$var$areScreenPlacementsEqual(this.screenPlacements, $64f84ec52de572b7$var$EMPTY_SCREEN_PLACEMENTS)) return;
        this.screenPlacements = $64f84ec52de572b7$var$EMPTY_SCREEN_PLACEMENTS;
        this.notify();
    }
    subscribeSimulationConfig(listener) {
        this.listeners.add(listener);
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    notify() {
        this.listeners.forEach((listener)=>listener());
    }
    constructor(){
        this.state = $64f84ec52de572b7$var$EMPTY_STATE;
        this.screenPlacements = $64f84ec52de572b7$var$EMPTY_SCREEN_PLACEMENTS;
        this.listeners = new Set();
    }
}
const $64f84ec52de572b7$export$f7be8dd409e65174 = new $64f84ec52de572b7$export$c77fe7cfaf785a6();

});



parcelRegister("paAR0", function(module, exports) {
$parcel$export(module.exports, "uniqueArray", () => $d7da302d66d83476$export$bbd17ecb0679edd7);
const $d7da302d66d83476$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});



parcelRegister("lUl1y", function(module, exports) {
$parcel$export(module.exports, "useRecommendationContext", () => $a3ab29ffd027b581$export$3321c0b02f750bcc);
/**
 * Canonical recommendation context implementation.
 *
 * This is the source of truth for recommendation context consumers.
 * Consumers should import via `@atlassian/post-office-context/message-lifecycle`.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");
const $a3ab29ffd027b581$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    sessionId: undefined,
    entityId: undefined,
    itemFeatureSetId: undefined
});
const $a3ab29ffd027b581$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a3ab29ffd027b581$export$ba2f44035effd9c1.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: value
    }, children));
};
const $a3ab29ffd027b581$export$3321c0b02f750bcc = ()=>(0, $fc4bM.useContext)($a3ab29ffd027b581$export$ba2f44035effd9c1);

});

parcelRegister("d7ngk", function(module, exports) {
$parcel$export(module.exports, "sendMessageInstanceDropped", () => $3afc433f9cdcbc91$export$6dbb4d899a712f64);

var $3ED3W = parcelRequire("3ED3W");
const $3afc433f9cdcbc91$export$6dbb4d899a712f64 = async ({ client: client, browserContext: browserContext, placementId: placementId, traceId: traceId, reportMissingEventContext: reportMissingEventContext }, message, { dropReason: dropReason, narrowExposureExperiment: narrowExposureExperiment })=>{
    const eventContext = {
        messageInstanceId: message.messageInstanceId,
        messageTemplateId: message.messageTemplateId,
        placementId: placementId,
        messageCreationType: message.messageCreationType,
        messageTriggerId: message.triggerId
    };
    if (!(0, $3ED3W.hasCompleteMessageInstanceEventContext)(eventContext)) {
        reportMissingEventContext({
            messageEventType: 'dropped',
            missingFields: (0, $3ED3W.getMissingMessageInstanceEventContext)(eventContext),
            messageTemplateId: message.messageTemplateId,
            placementId: placementId
        });
        return;
    }
    await client.sendMessageInstanceEvent({
        messageEventType: 'dropped',
        messageInstanceId: eventContext.messageInstanceId,
        messageTemplateId: eventContext.messageTemplateId,
        deliveryChannel: 'in-app',
        placementId: eventContext.placementId,
        channelType: 'pull',
        context: {
            ...browserContext,
            source: eventContext.placementId,
            recommendation: (0, $3ED3W.recommendationFromContext)(message.recommendation)
        },
        dropReason: dropReason,
        narrowExposureExperiment: narrowExposureExperiment,
        additionalMetadataFromFrontend: {
            transactionAccountId: message.transactionAccountId ?? null,
            ...message.analyticsDetails
        },
        ...traceId ? {
            placementTraceId: traceId
        } : {},
        messageTriggerId: eventContext.messageTriggerId,
        journeyId: message.journeyId,
        journeyTriggerId: message.journeyTriggerId,
        messageCreationType: eventContext.messageCreationType,
        configSetId: message.configSetId,
        timestamp: Date.now()
    });
};

});


parcelRegister("2xBXO", function(module, exports) {
$parcel$export(module.exports, "mapInteractionToClickedEvent", () => $e5739d563b15738a$export$4f02cad8854e08a4);

var $9HZEg = parcelRequire("9HZEg");
/**
 * The legacy `clickedElement` shape for kinds that downstream consumers still read as a
 * primary click. Presentation is not intent — this is emitted for backward compatibility
 * only and is removed once consumers read `action.actionType` alone.
 */ const $e5739d563b15738a$var$primaryButton = (interactionIdentifier)=>({
        clickIdentifier: interactionIdentifier,
        clickedElement: 'button',
        buttonType: 'primary'
    });
/**
 * The legacy `clickedElement` shape for kinds whose meaning does not depend on a rendered
 * element. `closed` in particular covers Escape, click-outside and navigating away.
 *
 * Delegates to `notApplicableClickedElement` rather than building the literal directly —
 * that factory is the only way to produce this branded, PO-owned value.
 */ const $e5739d563b15738a$var$notApplicable = (interactionIdentifier)=>(0, $9HZEg.notApplicableClickedElement)(interactionIdentifier);
/**
 * Maps a semantic interaction to the `clickedElement` and `action` pair defined by the
 * canonical compatibility mapping.
 *
 * The switch is deliberately exhaustive with no `default`: adding a kind to
 * `SemanticInteraction` without mapping it here is a compile error.
 *
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/7480820497/LYT+IPMs+Semantic+Interaction+Contract+Proposal+Rationale+and+Mapping#1.7-End-to-end-mapping
 */ const $e5739d563b15738a$var$toClickedEventCore = (interaction)=>{
    const identifier = interaction.interactionIdentifier;
    switch(interaction.kind){
        case 'ctaActioned':
            return {
                clickedElement: $e5739d563b15738a$var$primaryButton(identifier),
                action: {
                    actionType: 'open',
                    ...interaction.destinationUrl !== undefined && {
                        destinationUrl: interaction.destinationUrl
                    },
                    ...interaction.trackingLinkId !== undefined && {
                        trackingLinkId: interaction.trackingLinkId
                    }
                }
            };
        case 'acknowledged':
            return {
                clickedElement: $e5739d563b15738a$var$primaryButton(identifier),
                action: {
                    actionType: 'acknowledge'
                }
            };
        case 'declined':
            return {
                clickedElement: $e5739d563b15738a$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'snoozed':
            return {
                clickedElement: $e5739d563b15738a$var$notApplicable(identifier),
                action: {
                    actionType: 'snooze',
                    snoozeDuration: interaction.durationDays
                }
            };
        case 'closed':
            // Compatibility mode: `closed` maps to `dismiss` because there is no native
            // `close` actionType yet. Native support is tracked separately, and the split
            // between `declined` and `closed` is preserved in `interactionIdentifier`.
            return {
                clickedElement: $e5739d563b15738a$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'stepChanged':
            return {
                clickedElement: $e5739d563b15738a$var$notApplicable(identifier),
                action: {
                    actionType: interaction.direction,
                    currentStep: interaction.toStep,
                    previousStep: interaction.fromStep,
                    ...interaction.stepName !== undefined && {
                        stepName: interaction.stepName
                    }
                }
            };
    }
};
const $e5739d563b15738a$export$4f02cad8854e08a4 = (interaction)=>({
        messageEventType: 'clicked',
        interactionIdentifier: interaction.interactionIdentifier,
        ...$e5739d563b15738a$var$toClickedEventCore(interaction),
        ...interaction.additionalMetadata !== undefined && {
            additionalMetadataFromFrontend: interaction.additionalMetadata
        }
    });

});


parcelRegister("dw3GQ", function(module, exports) {
$parcel$export(module.exports, "StableChoreographerProvider", () => $32eeab8fc0452d3e$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $32eeab8fc0452d3e$export$cab5a8adbabcee23);

var $fc4bM = parcelRequire("fc4bM");

var $im5M7 = parcelRequire("im5M7");
var $f6Kyi = parcelRequire("f6Kyi");

var $dd1Zn = parcelRequire("dd1Zn");

var $jq1Bd = parcelRequire("jq1Bd");
// @twood: NEVER CHANGE THIS DEFAULT VALUE
const $32eeab8fc0452d3e$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $32eeab8fc0452d3e$var$choreographerLogger = (0, $dd1Zn.createInBrowserDebugLogger)('Choreographer');
const $32eeab8fc0452d3e$var$defaultContext = {
    choreographerEnabled: $32eeab8fc0452d3e$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $32eeab8fc0452d3e$var$ChoreographerContext = /*#__PURE__*/ (0, $fc4bM.createContext)($32eeab8fc0452d3e$var$defaultContext);
// Helper to automatically handle ESM and non-ESM imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $32eeab8fc0452d3e$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        $32eeab8fc0452d3e$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        $32eeab8fc0452d3e$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof (mod === null || mod === void 0 ? void 0 : mod.default) === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        $32eeab8fc0452d3e$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $32eeab8fc0452d3e$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};

const $32eeab8fc0452d3e$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $fc4bM.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $fc4bM.useState)((choreographer === null || choreographer === void 0 ? void 0 : choreographer.isDefaultEnabled) ?? $32eeab8fc0452d3e$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $f6Kyi.usePostOfficeEnvironment)();
    const context = (0, $im5M7.usePostOfficeContext)();
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $jq1Bd.shouldBypassChoreographerFromDevtools)()) setChoreographerEnabled(false);
    }, [
        setChoreographerEnabled
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (choreographerEnabled) // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("1O3py")).then((m)=>{
            const ChoreographerRegistryClass = $32eeab8fc0452d3e$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $32eeab8fc0452d3e$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $32eeab8fc0452d3e$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $32eeab8fc0452d3e$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $32eeab8fc0452d3e$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $fc4bM.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    (0, $fc4bM.useEffect)(()=>{
        $32eeab8fc0452d3e$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return (0, $jq1Bd.installChoreographerDevtoolsBridge)({
            setChoreographerEnabled: setChoreographerEnabled
        });
    }, [
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($32eeab8fc0452d3e$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext
    }, children);
};
const $32eeab8fc0452d3e$export$cab5a8adbabcee23 = ()=>(0, $fc4bM.useContext)($32eeab8fc0452d3e$var$ChoreographerContext);

});
parcelRegister("f6Kyi", function(module, exports) {
$parcel$export(module.exports, "buildDefaultEnvironmentValues", () => $61b08219cb0ba8a9$export$5dba87a2097d7fb2);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $61b08219cb0ba8a9$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $61b08219cb0ba8a9$export$877b97169cc75e8b);

var $fc4bM = parcelRequire("fc4bM");

var $irLab = parcelRequire("irLab");
const $61b08219cb0ba8a9$export$5dba87a2097d7fb2 = (isFedRampCompliantUrlsEnabled = false)=>{
    return {
        currentEnv: 'local',
        envConfigs: {
            'test-server': {
                remoteModule: {
                    origin: (0, $irLab.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $irLab.API_ORIGIN_TEST_SERVER),
                    pathname: (0, $irLab.API_ORIGIN_TEST_SERVER),
                    searchParams: undefined
                }
            },
            test: {
                remoteModule: {
                    origin: (0, $irLab.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $irLab.API_ORIGIN_LOCAL),
                    pathname: (0, $irLab.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $irLab.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $irLab.API_ORIGIN_LOCAL),
                    pathname: (0, $irLab.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $irLab.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $irLab.API_ORIGIN_LOCAL),
                    pathname: (0, $irLab.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $irLab.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $irLab.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $irLab.REMOTE_MODULE_URI_STG_FEDM) : (0, $irLab.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $irLab.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $irLab.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $irLab.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $irLab.REMOTE_MODULE_URI_PROD_FEDM) : (0, $irLab.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $irLab.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            }
        }
    };
};
const $61b08219cb0ba8a9$export$b4ede87479bfcf09 = $61b08219cb0ba8a9$export$5dba87a2097d7fb2();
const $61b08219cb0ba8a9$export$fceca2c399b32565 = (0, $fc4bM.createContext)($61b08219cb0ba8a9$export$b4ede87479bfcf09);
const $61b08219cb0ba8a9$export$604607f913ef367c = $61b08219cb0ba8a9$export$fceca2c399b32565.Provider;
const $61b08219cb0ba8a9$export$877b97169cc75e8b = ()=>(0, $fc4bM.useContext)($61b08219cb0ba8a9$export$fceca2c399b32565);

});
parcelRegister("irLab", function(module, exports) {
$parcel$export(module.exports, "API_ORIGIN_TEST_SERVER", () => $5aff7ab0b6b1836d$export$5ca004be156a127a);
$parcel$export(module.exports, "API_ORIGIN_LOCAL", () => $5aff7ab0b6b1836d$export$1e9fed4c0197724c);
$parcel$export(module.exports, "API_PATHNAME_LOCAL", () => $5aff7ab0b6b1836d$export$919a9569bce66f17);
$parcel$export(module.exports, "API_PATHNAME_STG_PROD", () => $5aff7ab0b6b1836d$export$d4fe3482c88e73a8);
$parcel$export(module.exports, "REMOTE_MODULE_URI_LOCAL", () => $5aff7ab0b6b1836d$export$67be2569ef5d7666);
$parcel$export(module.exports, "REMOTE_MODULE_URI_STG", () => $5aff7ab0b6b1836d$export$b49738b89db261cd);
$parcel$export(module.exports, "REMOTE_MODULE_URI_PROD", () => $5aff7ab0b6b1836d$export$bbd96cd490b0df63);
$parcel$export(module.exports, "REMOTE_MODULE_URI_STG_FEDM", () => $5aff7ab0b6b1836d$export$a2ac4fea250cfcb6);
$parcel$export(module.exports, "REMOTE_MODULE_URI_PROD_FEDM", () => $5aff7ab0b6b1836d$export$4db578e7ea13bd1b);
const $5aff7ab0b6b1836d$export$5ca004be156a127a = 'http://localhost:4224';
const $5aff7ab0b6b1836d$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $5aff7ab0b6b1836d$export$1e9fed4c0197724c = 'http://localhost:8081';
const $5aff7ab0b6b1836d$export$919a9569bce66f17 = '/api/v1/placements/';
const $5aff7ab0b6b1836d$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $5aff7ab0b6b1836d$export$67be2569ef5d7666 = 'http://localhost:9009';
const $5aff7ab0b6b1836d$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $5aff7ab0b6b1836d$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
const $5aff7ab0b6b1836d$export$a2ac4fea250cfcb6 = 'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
const $5aff7ab0b6b1836d$export$4db578e7ea13bd1b = 'https://post-office-rml-frontend.frontend.cdn.atlassian-us-gov-mod.com';

});


parcelRegister("dd1Zn", function(module, exports) {
$parcel$export(module.exports, "createInBrowserDebugLogger", () => $66ea23e4dc3d1800$export$806eda59584e395d);
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components.
 *
 * NOTE: This is a copy of
 * `post-office/packages/util/shared-contracts/src/util/in-browser-debug-logger.ts`
 * to avoid a cross-workspace import. You may want to keep them in sync.
 *
 * Usage:
 * - Enable:  window.postOffice{Component}Debug = true
 * - Disable: window.postOffice{Component}Debug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $66ea23e4dc3d1800$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};

});

parcelRegister("jq1Bd", function(module, exports) {
$parcel$export(module.exports, "shouldBypassChoreographerFromDevtools", () => $4abe672d77cd3877$export$8e299e8aab3a0cc6);
$parcel$export(module.exports, "installChoreographerDevtoolsBridge", () => $4abe672d77cd3877$export$606f928dbd560712);
parcelRequire("bhV4A");
var $6EzEO = parcelRequire("6EzEO");

var $dRkX9 = parcelRequire("dRkX9");
const $4abe672d77cd3877$var$DEBUG_BYPASS_SESSION_STORAGE_KEY = 'postOffice.choreographer.debug';
const $4abe672d77cd3877$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY = 'bypassEnabled';
const $4abe672d77cd3877$var$getStorageClient = ()=>new (0, $6EzEO.StorageClient)($4abe672d77cd3877$var$DEBUG_BYPASS_SESSION_STORAGE_KEY, {
        storageEngine: 'sessionStorage'
    });
const $4abe672d77cd3877$var$getWindow = ()=>typeof window === 'undefined' ? undefined : window;
const $4abe672d77cd3877$var$getPersistedBypassEnabled = ()=>{
    return $4abe672d77cd3877$var$getStorageClient().getItem($4abe672d77cd3877$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY) === true;
};
const $4abe672d77cd3877$export$8e299e8aab3a0cc6 = ()=>{
    return (0, $dRkX9.fg)('post-office_choreographer_devtools_bridge') && $4abe672d77cd3877$var$getPersistedBypassEnabled();
};
const $4abe672d77cd3877$var$setPersistedBypassEnabled = (isEnabled)=>{
    // The devtools bridge should never break message rendering when browser storage is blocked.
    // StorageClient handles exceptions internally.
    $4abe672d77cd3877$var$getStorageClient().setItemWithExpiry($4abe672d77cd3877$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY, isEnabled);
};
const $4abe672d77cd3877$var$getChoreographerSingleton = ()=>{
    var _getWindow;
    return (_getWindow = $4abe672d77cd3877$var$getWindow()) === null || _getWindow === void 0 || (_getWindow = _getWindow.postOffice) === null || _getWindow === void 0 || (_getWindow = _getWindow.choreographer) === null || _getWindow === void 0 ? void 0 : _getWindow.singleton;
};
const $4abe672d77cd3877$var$getRegisteredPluginIds = ()=>{
    var _getWindow2;
    return [
        ...((_getWindow2 = $4abe672d77cd3877$var$getWindow()) === null || _getWindow2 === void 0 || (_getWindow2 = _getWindow2.choreographerRegistry) === null || _getWindow2 === void 0 ? void 0 : _getWindow2.keys()) ?? []
    ];
};
const $4abe672d77cd3877$var$getSnapshot = ()=>{
    const singleton = $4abe672d77cd3877$var$getChoreographerSingleton();
    const registeredPlugins = $4abe672d77cd3877$var$getRegisteredPluginIds();
    return {
        activeMessage: (singleton === null || singleton === void 0 ? void 0 : singleton.getCurrentMessage()) ?? null,
        bypassEnabled: $4abe672d77cd3877$export$8e299e8aab3a0cc6(),
        pendingMessage: (singleton === null || singleton === void 0 ? void 0 : singleton.getCurrentPendingMessage()) ?? null,
        queuedMessages: (singleton === null || singleton === void 0 ? void 0 : singleton.getQueuedMessages()) ?? [],
        recentEvents: [],
        registeredMessages: registeredPlugins.map((productId)=>({
                productId: productId,
                messageIds: [
                    ...(singleton === null || singleton === void 0 ? void 0 : singleton.getMessages(productId).keys()) ?? []
                ]
            })),
        registeredPlugins: registeredPlugins,
        updatedAt: Date.now()
    };
};
const $4abe672d77cd3877$export$606f928dbd560712 = ({ setChoreographerEnabled: setChoreographerEnabled })=>{
    var _currentWindow$postOf2;
    const currentWindow = $4abe672d77cd3877$var$getWindow();
    if (!currentWindow) return ()=>{};
    if (!(0, $dRkX9.fg)('post-office_choreographer_devtools_bridge')) {
        var _currentWindow$postOf;
        (_currentWindow$postOf = currentWindow.postOffice) === null || _currentWindow$postOf === void 0 || (_currentWindow$postOf = _currentWindow$postOf.choreographer) === null || _currentWindow$postOf === void 0 || delete _currentWindow$postOf.debug;
        return ()=>{};
    }
    const bridge = {
        getSnapshot: $4abe672d77cd3877$var$getSnapshot,
        isBypassEnabled: $4abe672d77cd3877$export$8e299e8aab3a0cc6,
        setBypassEnabled: (isEnabled)=>{
            $4abe672d77cd3877$var$setPersistedBypassEnabled(isEnabled);
            setChoreographerEnabled(!isEnabled);
        }
    };
    currentWindow.postOffice = {
        ...currentWindow.postOffice,
        choreographer: {
            ...(_currentWindow$postOf2 = currentWindow.postOffice) === null || _currentWindow$postOf2 === void 0 ? void 0 : _currentWindow$postOf2.choreographer,
            debug: bridge
        }
    };
    return ()=>{
        var _currentWindow$postOf3;
        if (((_currentWindow$postOf3 = currentWindow.postOffice) === null || _currentWindow$postOf3 === void 0 || (_currentWindow$postOf3 = _currentWindow$postOf3.choreographer) === null || _currentWindow$postOf3 === void 0 ? void 0 : _currentWindow$postOf3.debug) === bridge) delete currentWindow.postOffice.choreographer.debug;
    };
};

});
parcelRegister("bhV4A", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("6EzEO")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $6EzEO = parcelRequire("6EzEO");

var $8f00b457bf6c925d$export$2e2bcd8739ae039 = (0, $6EzEO.StorageClient);

});
parcelRegister("6EzEO", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => $4da9020c52ea0dc8$export$6c85f5032e75eff9);

var $gQiJV = parcelRequire("gQiJV");

var $49aDS = parcelRequire("49aDS");
class $4da9020c52ea0dc8$export$6c85f5032e75eff9 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        const storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || (0, $49aDS.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $gQiJV.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        var _this$handlers;
        if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("gQiJV", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $f1a36844e65c5ac5$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $f1a36844e65c5ac5$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $f1a36844e65c5ac5$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$f1a36844e65c5ac5$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});

parcelRegister("49aDS", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_STORAGE_ENGINE", () => $1d78c463d3b8ede0$export$3364800d9d60baf9);
const $1d78c463d3b8ede0$export$3364800d9d60baf9 = 'localStorage';

});




parcelRegister("1O3py", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3c0Ij"),
    $9dnsd("9eEaI")
]).then(()=>parcelRequire('gg78y'));

});


parcelRegister("jNx9z", function(module, exports) {
$parcel$export(module.exports, "HostMessageDisplayProvider", () => $b925430e6227dac2$export$9ed1478610ab917b);

var $fc4bM = parcelRequire("fc4bM");

var $fohTj = parcelRequire("fohTj");
const $b925430e6227dac2$var$MessageDisplayedContext = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $b925430e6227dac2$export$9ed1478610ab917b = ({ children: children })=>{
    const messageViewed = (0, $fohTj.useMessageViewed)();
    const hasDisplayed = (0, $fc4bM.useRef)(false);
    const recordDisplay = (0, $fc4bM.useCallback)(()=>{
        if (hasDisplayed.current) return;
        hasDisplayed.current = true;
        messageViewed();
    }, [
        messageViewed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b925430e6227dac2$var$MessageDisplayedContext.Provider, {
        value: recordDisplay
    }, children);
};
const $b925430e6227dac2$export$59a0be196d7d3e75 = ()=>(0, $fc4bM.useContext)($b925430e6227dac2$var$MessageDisplayedContext);

});

parcelRegister("3LFgp", function(module, exports) {
$parcel$export(module.exports, "useNarrowExposureShouldClaim", () => $f11d2ea66555c631$export$9da5ef057718f55e);

var $fc4bM = parcelRequire("fc4bM");

var $fohTj = parcelRequire("fohTj");

var $enWoH = parcelRequire("enWoH");

var $dtqj1 = parcelRequire("dtqj1");

var $78XSI = parcelRequire("78XSI");
const $f11d2ea66555c631$export$9da5ef057718f55e = (config)=>{
    const { messageInstanceId: messageInstanceId } = (0, $enWoH.useMessageContext)();
    const { messageInstanceDropped: messageInstanceDropped } = (0, $fohTj.useMessageInstanceEvent)();
    return (0, $fc4bM.useMemo)(()=>{
        if (!config) return undefined;
        return ()=>{
            const decision = (0, $78XSI.evaluateCohort)(config);
            if (decision.outcome === 'show') return true;
            (0, $dtqj1.postNarrowExposureDrop)(messageInstanceDropped, messageInstanceId, config, decision);
            return false;
        };
    }, [
        config,
        messageInstanceId,
        messageInstanceDropped
    ]);
};

});
parcelRegister("dtqj1", function(module, exports) {
$parcel$export(module.exports, "postNarrowExposureDrop", () => $254838e114c82217$export$7f0a287bfc29bd88);

var $01Rrd = parcelRequire("01Rrd");
const $254838e114c82217$var$postedDrops = new Set();
const $254838e114c82217$export$7f0a287bfc29bd88 = (messageInstanceDropped, messageInstanceId, { statsigExperiment: statsigExperiment, statsigParameterName: statsigParameterName }, decision)=>{
    const cohort = decision.outcome === 'drop' ? decision.cohort : (0, $01Rrd.UNEVALUATED_COHORT);
    if (messageInstanceId) {
        const key = `${messageInstanceId}:${statsigExperiment}:${String(cohort)}`;
        if ($254838e114c82217$var$postedDrops.has(key)) return;
        $254838e114c82217$var$postedDrops.add(key);
    }
    // A failed drop post must not stop the next queued message being offered.
    messageInstanceDropped({
        dropReason: (0, $01Rrd.NARROW_EXPOSURE_DROP_REASON),
        narrowExposureExperiment: {
            statsigExperiment: statsigExperiment,
            statsigParameterName: statsigParameterName,
            cohort: cohort
        }
    }).catch(()=>undefined);
};

});
parcelRegister("01Rrd", function(module, exports) {
$parcel$export(module.exports, "NARROW_EXPOSURE_DROP_REASON", () => $6ba6ab263fa8f60f$export$a0c7bcdd7b49b7);
$parcel$export(module.exports, "UNEVALUATED_COHORT", () => $6ba6ab263fa8f60f$export$c034fa4166be9a5a);
/** Keep in sync with `InAppNarrowExposureCohort` in `@post-office/message-template-contracts`. */ const $6ba6ab263fa8f60f$export$a0c7bcdd7b49b7 = 'narrowExposureExperiment';
const $6ba6ab263fa8f60f$export$c034fa4166be9a5a = 'unevaluated';

});


parcelRegister("78XSI", function(module, exports) {
$parcel$export(module.exports, "evaluateCohort", () => $30b3b052eb8ff82d$export$3e91358020cdecec);

var $8EvCx = parcelRequire("8EvCx");

var $99rLL = parcelRequire("99rLL");
const $30b3b052eb8ff82d$var$UNEVALUATED = {
    outcome: 'unevaluated'
};
const $30b3b052eb8ff82d$export$3e91358020cdecec = (config)=>{
    const { statsigExperiment: statsigExperiment, statsigParameterName: statsigParameterName } = config;
    let cohort = null;
    try {
        cohort = (0, $8EvCx.expVal)(statsigExperiment, statsigParameterName, null);
    } catch  {
    // The Statsig client swallows SDK errors; this covers a missing or replaced client.
    }
    if (typeof cohort !== 'string' && typeof cohort !== 'boolean') return $30b3b052eb8ff82d$var$UNEVALUATED;
    const showCohorts = config.showCohorts;
    const dropCohorts = config.dropCohorts;
    const inShow = showCohorts.includes(cohort);
    const inDrop = dropCohorts.includes(cohort);
    if (inShow && inDrop) {
        (0, $99rLL.logDevError)(`[Post Office] Narrow exposure experiment "${statsigExperiment}" has an invalid config: cohort "${String(cohort)}" is in both showCohorts and dropCohorts.`);
        return $30b3b052eb8ff82d$var$UNEVALUATED;
    }
    if (!inShow && !inDrop) {
        (0, $99rLL.logDevError)(`[Post Office] Narrow exposure experiment "${statsigExperiment}" has an unrecognised cohort "${String(cohort)}" that is in neither showCohorts nor dropCohorts.`);
        return $30b3b052eb8ff82d$var$UNEVALUATED;
    }
    return {
        outcome: inShow ? 'show' : 'drop',
        cohort: cohort
    };
};

});
parcelRegister("8EvCx", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $af80b3cefdee22f5$export$9db1624a8af791a4);

var $hXxmh = parcelRequire("hXxmh");
function $af80b3cefdee22f5$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $hXxmh.expValInternal)(experimentName, param, defaultValue, true);
}

});
parcelRegister("hXxmh", function(module, exports) {
$parcel$export(module.exports, "expValInternal", () => $71f1aa01a16df641$export$48708229abf6ab93);

var $k2M4v = parcelRequire("k2M4v");

var $2Eign = parcelRequire("2Eign");

var $s2sCW = parcelRequire("s2sCW");
function $71f1aa01a16df641$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $s2sCW.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $s2sCW.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $2Eign.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $k2M4v.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $k2M4v.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $2Eign.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}

});
parcelRegister("s2sCW", function(module, exports) {
$parcel$export(module.exports, "devOverrides", () => $0e5453634a1eb7f3$export$89f9222be8849d61);
const $0e5453634a1eb7f3$export$89f9222be8849d61 = new Map();
let $0e5453634a1eb7f3$export$1443858d5f82511f = false;
function $0e5453634a1eb7f3$export$6bce865e33a255c3(value) {
    $0e5453634a1eb7f3$export$1443858d5f82511f = value;
}

});



parcelRegister("99rLL", function(module, exports) {
$parcel$export(module.exports, "logDevError", () => $c769702a815fe8e1$export$7e911eb07414fb1b);
/**
 * Dev/staging console errors for invalid experiment config.
 *
 * `NODE_ENV` is compile-time inlined in product bundles, so staging (`*.jira-dev.com`,
 * `*.stg.atlassian.com`, `*.stg-<location>.frontend.public.atl-paas.net`) is production as far
 * as that check is concerned. Hostname is the runtime signal message makers will actually see.
 *
 * `prod-<location>.frontend.public.atl-paas.net` is production and must not match.
 *
 * Hostname is read from `globalThis.location` so SSR without a location polyfill is a no-op.
 */ const $c769702a815fe8e1$var$STAGING_HOSTNAME_PATTERN = /(?:^|\.)(?:jira-dev\.com|stg(?:\.internal)?\.atlassian\.com|stg-[a-z0-9]+\.frontend\.public\.atl-paas\.net)$/;
const $c769702a815fe8e1$var$readHostname = ()=>{
    try {
        var _globalThis$location;
        const hostname = (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
        return typeof hostname === 'string' && hostname.length > 0 ? hostname : undefined;
    } catch  {
        return undefined;
    }
};
const $c769702a815fe8e1$export$93090b6c6be1ab46 = ()=>{
    const hostname = $c769702a815fe8e1$var$readHostname();
    return hostname !== undefined && $c769702a815fe8e1$var$STAGING_HOSTNAME_PATTERN.test(hostname);
};
const $c769702a815fe8e1$export$7e911eb07414fb1b = (message)=>{
    if ($c769702a815fe8e1$export$93090b6c6be1ab46()) // eslint-disable-next-line no-console
    console.error(message);
};

});




parcelRegister("j4gq5", function(module, exports) {
$parcel$export(module.exports, "transformPlacementMessageToMessageLifecycleProps", () => $c4c27bf417a90e0d$export$61e95755e67323e4);
const $c4c27bf417a90e0d$var$transformMessageCreationTypeToPostOfficeMessageCreationType = ({ messageCreationType: messageCreationType })=>{
    if (messageCreationType === 'implicit' || messageCreationType === 'explicit') return messageCreationType;
    return undefined;
};
const $c4c27bf417a90e0d$export$61e95755e67323e4 = ({ message: message })=>({
        configSetId: message === null || message === void 0 ? void 0 : message.configSetId,
        journeyId: message === null || message === void 0 ? void 0 : message.journeyId,
        journeyTriggerId: message === null || message === void 0 ? void 0 : message.journeyTriggerId,
        messageCreationType: $c4c27bf417a90e0d$var$transformMessageCreationTypeToPostOfficeMessageCreationType({
            messageCreationType: message === null || message === void 0 ? void 0 : message.messageCreationType
        }),
        triggerId: message === null || message === void 0 ? void 0 : message.triggerId,
        inAppNarrowExposureExperiment: message === null || message === void 0 ? void 0 : message.inAppNarrowExposureExperiment
    });

});

parcelRegister("9sGOM", function(module, exports) {
$parcel$export(module.exports, "usePlacementData", () => $4cc25157d15c9f4b$export$a9668c1d52481a0f);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $iZgWP = parcelRequire("iZgWP");

var $jyJkm = parcelRequire("jyJkm");

var $fg655 = parcelRequire("fg655");

var $im5M7 = parcelRequire("im5M7");

var $5abGA = parcelRequire("5abGA");

var $6bRJe = parcelRequire("6bRJe");

var $acjrF = parcelRequire("acjrF");

var $lJA3W = parcelRequire("lJA3W");
/**
 * Foundation hook for the Post Office Headless API.
 *
 * Fetches raw Placement API data for a given `placementId` and tracks which
 * message instances have been dismissed in the current session via the Post
 * Office pub/sub system.
 *
 * All higher-level hooks (`useAllMessages`, `useMessageInstances`, `useMessageData`) compose on top
 * of this hook.
 *
 * Automatically reads the current `PostOfficeContext` (product, locale, tenantId, workspaceAri,
 * etc.) via `usePostOfficeContext` and forwards it to the Placement API request as query
 * parameters. No manual context threading is required.
 *
 * Requires `PlacementFetchingProvider` and `MessagePlacementProvider` (or
 * `PostOfficeProvider`) to be present in the React tree.
 *
 * @example
 * ```tsx
 * const { data, dismissedIds, isLoading, error, dismissMessage } = usePlacementData(
 *   'some-placement',
 * );
 *
 * const visibleMessages = data?.messages.filter(
 *   m => !dismissedIds.has(m.messageInstanceId)
 * ) ?? [];
 * ```
 *
 * @typeParam TMessage - A {@link PlacementMessageDiscriminant} or union thereof.
 *   Provide a union to model multiple template types with narrowable `context`:
 *   `usePlacementData<{ messageTemplateId: 'banner'; context: BannerCtx } | { messageTemplateId: 'flag'; context: FlagCtx }>(id)`
 * @typeParam TExtension - Additional top-level fields to expect in the `data` shape.
 * @param placementId - The ID of the placement to fetch data for. Defaults to `'headless'`.
 * @param options - Optional configuration. Pass `{ dataSource: 'DEV_SERVER' }` to point the hook
 *   at the local placement dev server (`yarn placement:v2 dev`, default port `4224`).
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/6764207116
 */ /** Base URL used when `dataSource` is `'DEV_SERVER'`. Only included in non-production builds. */ const $4cc25157d15c9f4b$var$DEV_SERVER_BASE_URL = 'http://localhost:4224';
const $4cc25157d15c9f4b$export$a9668c1d52481a0f = (placementId = 'headless', options)=>{
    var _response$data, _response$data2;
    const fetcher = (0, $5abGA.usePlacementFetchingContext)();
    const { onMessageDismiss: onMessageDismiss, dismissMessageFromPlacement: dismissMessageFromPlacement } = (0, $fg655.useMessagePlacementHooks)();
    const postOfficeContext = (0, $im5M7.usePostOfficeContext)();
    const simulationParams = (0, $iZgWP.useExtensionBridgeSimulationParams)(placementId);
    const { dataSource: dataSource = 'PRODUCTION', queryString: queryString, refreshInterval: refreshInterval = 0 } = options ?? {};
    const arePlacementsGloballyDisabled = (0, $dRkX9.fg)('post-office-enable-headless-disable-placement') && (0, $jyJkm.isPostOfficePlacementsGloballyDisabled)(postOfficeContext);
    const placementIdToFetch = arePlacementsGloballyDisabled ? null : placementId;
    // When targeting the dev server, override the fetch so the request goes to
    // `http://localhost:4224` instead of the production gateway. The dev server
    // exposes the same URL path as production.
    let effectiveFetcher = fetcher;
    if (dataSource === 'DEV_SERVER') effectiveFetcher = {
        fetch: (url, init)=>{
            // Replace the origin with the dev server base URL, keeping the path intact.
            // Guard against SSR environments where window is not defined.
            const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            const originalUrl = new URL(url, origin);
            const devUrl = `${$4cc25157d15c9f4b$var$DEV_SERVER_BASE_URL}${originalUrl.pathname}${originalUrl.search}`;
            return fetcher.fetch(devUrl, init);
        }
    };
    // Merge any caller-provided `queryString` params with the PostOfficeContext params.
    // This is additive only: context values always take precedence, so callers can never
    // override the context-derived query parameters — they can only add new ones.
    // Gated behind `post-office-enable-headless-query`: when the gate is off the caller
    // `queryString` is ignored entirely and only the context-derived params are sent,
    // preserving the pre-existing request shape.
    // Memoised on the stringified queryString so the SWR request key stays stable across
    // renders when an inline object with identical contents is passed.
    //
    // When `post-office_enable_extension-control` is on and this placement has simulation
    // enabled, per-placement simulate params are merged in the same additive way —
    // never overriding PostOfficeContext keys, and never leaking to sibling placements.
    const isHeadlessQueryEnabled = (0, $dRkX9.fg)('post-office-enable-headless-query');
    const queryStringKey = isHeadlessQueryEnabled && queryString ? JSON.stringify(queryString) : undefined;
    const simulationParamsKey = simulationParams ? JSON.stringify(simulationParams) : undefined;
    const requestContext = (0, $fc4bM.useMemo)(()=>{
        const additiveParams = {
            ...simulationParams,
            ...isHeadlessQueryEnabled && queryString ? queryString : {}
        };
        return Object.keys(additiveParams).length > 0 ? {
            ...additiveParams,
            ...postOfficeContext
        } : postOfficeContext;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- keys are stable stringifications of the source objects
    [
        postOfficeContext,
        queryStringKey,
        isHeadlessQueryEnabled,
        simulationParamsKey
    ]);
    const response = (0, $acjrF.useFetchPlacementData)(placementIdToFetch, 'headless', requestContext, effectiveFetcher, undefined, {
        refreshInterval: refreshInterval,
        revalidateIfStale: refreshInterval > 0,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [dismissedIds, setDismissedIds] = (0, $fc4bM.useState)(()=>new Set());
    // Synchronously reset dismissedIds in the render path when placementId changes.
    // A useEffect-based reset fires after paint, leaving a one-render window where
    // the new placement is painted with stale dismissed IDs from the previous one.
    // Calling setState during render causes React to discard this render and
    // immediately re-render with the new state; consumers never observe stale IDs.
    //
    // Infinite re-render safety — two independent guards prevent looping:
    //   1. prevPlacementIdRef.current is written BEFORE setDismissedIds is called.
    //      On the re-render React immediately triggers, the ref already equals
    //      placementId so the outer `if` is false — no further setState occurs.
    //   2. After the reset, dismissedIds.size === 0, so the inner size guard is
    //      also false — a second guard independent of the ref. Either alone is
    //      sufficient; both together make the loop prevention unconditional.
    // See: 'infinite re-render safety' tests in usePlacementData.test.tsx.
    const prevPlacementIdRef = (0, $fc4bM.useRef)(placementId);
    const placementChanged = prevPlacementIdRef.current !== placementId;
    // Return an empty set immediately on the first render with a new placementId —
    // including the discarded render that React produces when setState is called
    // during rendering. This ensures no render ever exposes stale dismissed IDs
    // from the previous placement, even transiently.
    // Reference stability: when dismissedIds is already empty we reuse the same
    // Set reference (no new object, no unnecessary re-render).
    const effectiveDismissedIds = placementChanged && dismissedIds.size > 0 ? new Set() : dismissedIds;
    if (placementChanged) {
        prevPlacementIdRef.current = placementId;
        // Only reset if the set is non-empty to avoid an unnecessary extra render.
        if (dismissedIds.size > 0) setDismissedIds(new Set());
    }
    const { mutate: mutate } = response;
    // Subscribe to pub/sub dismiss events on mount, unsubscribe on unmount.
    (0, $fc4bM.useEffect)(()=>{
        const unsubscribe = onMessageDismiss(({ messageInstanceId: messageInstanceId })=>{
            setDismissedIds((prev)=>{
                // Guard: do not create a new Set reference if the ID is already dismissed.
                if (prev.has(messageInstanceId)) return prev;
                return new Set([
                    ...prev,
                    messageInstanceId
                ]);
            });
            // `dismissedIds` is in-memory only, but SWR data is global + localStorage-backed and reused
            // on remount (no stale revalidation here). Remove the dismissed message from cached payload
            // as well so it does not reappear after remount; do this optimistically (`revalidate: false`)
            // to avoid a backend refetch that may still return it, as sending the dismissal analytic can
            // take a few seconds.
            mutate((current)=>{
                var _current$data;
                if (!(current !== null && current !== void 0 && (_current$data = current.data) !== null && _current$data !== void 0 && (_current$data = _current$data.messages) !== null && _current$data !== void 0 && _current$data.some((m)=>m.messageInstanceId === messageInstanceId))) return current;
                return {
                    ...current,
                    data: {
                        ...current.data,
                        messages: current.data.messages.filter((m)=>m.messageInstanceId !== messageInstanceId)
                    }
                };
            }, {
                revalidate: false
            });
        });
        return unsubscribe;
    }, [
        onMessageDismiss,
        mutate
    ]);
    const dismissMessage = (0, $fc4bM.useCallback)((messageInstanceId)=>{
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
    }, [
        dismissMessageFromPlacement
    ]);
    const { isLoading: isLoading, error: error } = response;
    const traceId = (0, $6bRJe.getPlacementTraceId)(response.data);
    const traceIdRef = (0, $fc4bM.useRef)(traceId);
    traceIdRef.current = traceId;
    const PostOfficePlacementMessage = (0, $fc4bM.useMemo)(()=>({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lJA3W.PostOfficeMessage), {
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                placementId: placementId,
                traceId: traceIdRef.current,
                messageCategory: messageCategory,
                triggerId: triggerId,
                messageCreationType: messageCreationType,
                journeyId: journeyId,
                journeyTriggerId: journeyTriggerId,
                configSetId: configSetId
            }, children), [
        placementId
    ]);
    return {
        data: (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data,
        errors: ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errors) ?? [],
        dismissedIds: effectiveDismissedIds,
        isLoading: isLoading,
        error: error,
        dismissMessage: dismissMessage,
        traceId: traceId,
        PostOfficePlacementMessage: PostOfficePlacementMessage
    };
};

});
parcelRegister("iZgWP", function(module, exports) {
$parcel$export(module.exports, "useExtensionBridgeSimulationParams", () => $f3fdee2e43c1f060$export$8cb502483eccaaa7);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $7ZXZX = parcelRequire("7ZXZX");
const $f3fdee2e43c1f060$var$getExtensionBridge = ()=>{
    var _postOffice;
    if (typeof window === 'undefined') return undefined;
    return (_postOffice = window.postOffice) === null || _postOffice === void 0 ? void 0 : _postOffice.extensionControl;
};
const $f3fdee2e43c1f060$export$8cb502483eccaaa7 = (placementId)=>{
    const isEnabled = (0, $dRkX9.fg)('post-office_enable_extension-control');
    const subscribe = (0, $fc4bM.useCallback)((onStoreChange)=>{
        var _getExtensionBridge;
        if (!isEnabled) return ()=>{};
        return ((_getExtensionBridge = $f3fdee2e43c1f060$var$getExtensionBridge()) === null || _getExtensionBridge === void 0 ? void 0 : _getExtensionBridge.subscribe(onStoreChange)) ?? (()=>{});
    }, [
        isEnabled
    ]);
    const getSnapshot = (0, $fc4bM.useCallback)(()=>{
        if (!isEnabled) return undefined;
        return (0, $7ZXZX.extensionBridgeStore).getEnabledSimulationParamsSnapshot(placementId);
    }, [
        isEnabled,
        placementId
    ]);
    return (0, $fc4bM.useSyncExternalStore)(subscribe, getSnapshot, ()=>undefined);
};

});

parcelRegister("jyJkm", function(module, exports) {
$parcel$export(module.exports, "isPostOfficePlacementsGloballyDisabled", () => $d04efdbd3c483e3a$export$be54ac815726b4bd);

var $bKWnN = parcelRequire("bKWnN");
const $d04efdbd3c483e3a$export$be54ac815726b4bd = (context)=>{
    // Only evaluate the config when the host opts in, so placements that never
    // set disableAllPlacements don't touch Statsig at all.
    if (context.disableAllPlacements !== true) return false;
    // This operational config must not emit experiment exposures.
    return (0, $bKWnN.UNSAFE_expValNoExposure)('post-office_placements_global-disable-check', 'value', false) === true;
};

});
parcelRegister("bKWnN", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_expValNoExposure", () => $2087dd9a6784b69a$export$da472ee01c19d92e);

var $hXxmh = parcelRequire("hXxmh");
function $2087dd9a6784b69a$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $hXxmh.expValInternal)(experimentName, param, defaultValue, false);
}

});


parcelRegister("5abGA", function(module, exports) {
$parcel$export(module.exports, "usePlacementFetchingContext", () => $06c97e0347ac5e2f$export$e1e2cdb0425a9fa8);

var $fc4bM = parcelRequire("fc4bM");
const $06c97e0347ac5e2f$export$afec669dc416ee7e = /*#__PURE__*/ (0, $fc4bM.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $06c97e0347ac5e2f$export$e1e2cdb0425a9fa8 = ()=>(0, $fc4bM.useContext)($06c97e0347ac5e2f$export$afec669dc416ee7e);
const $06c97e0347ac5e2f$export$e6d4e8801dff09b9 = ()=>{
    try {
        return (0, $fc4bM.useContext)($06c97e0347ac5e2f$export$afec669dc416ee7e);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
        return undefined;
    }
};
const $06c97e0347ac5e2f$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $fc4bM.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($06c97e0347ac5e2f$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};
const $06c97e0347ac5e2f$export$a088c81282679a25 = ({ fetch: fetch, children: children })=>{
    if (!fetch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($06c97e0347ac5e2f$export$5f25a6ddf0324fa8, {
        fetch: fetch
    }, children);
};

});

parcelRegister("6bRJe", function(module, exports) {
$parcel$export(module.exports, "readPlacementTraceId", () => $4ce43e7da0aab536$export$fec61cc13a109a6c);
$parcel$export(module.exports, "getPlacementTraceId", () => $4ce43e7da0aab536$export$4055cd949f2f6e31);
/**
 * B3 trace ids are 16 or 32 hex characters. The placement pipeline stores
 * `x-b3-traceid`; the edge exposes that value to the browser as `x-trace-id`
 * and copies it to `atl-traceid`. `atl-request-id` is a different, dashed id.
 */ const $4ce43e7da0aab536$var$B3_TRACE_ID = /^(?:[0-9a-f]{32}|[0-9a-f]{16})$/i;
const $4ce43e7da0aab536$var$isB3TraceId = (value)=>typeof value === 'string' && $4ce43e7da0aab536$var$B3_TRACE_ID.test(value);
const $4ce43e7da0aab536$export$fec61cc13a109a6c = (response)=>{
    try {
        const value = response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid');
        return $4ce43e7da0aab536$var$isB3TraceId(value) ? value : undefined;
    } catch  {
        return undefined;
    }
};
const $4ce43e7da0aab536$export$4055cd949f2f6e31 = (data)=>{
    if (data === null || typeof data !== 'object' || !('traceId' in data)) return undefined;
    const { traceId: traceId } = data;
    return $4ce43e7da0aab536$var$isB3TraceId(traceId) ? traceId : undefined;
};

});

parcelRegister("acjrF", function(module, exports) {
$parcel$export(module.exports, "useFetchPlacementData", () => $d49a7602fef0ad6b$export$ef70136078f15deb);

var $harDk = parcelRequire("harDk");

var $bPVeO = parcelRequire("bPVeO");

var $6bRJe = parcelRequire("6bRJe");
const $d49a7602fef0ad6b$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $d49a7602fef0ad6b$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $d49a7602fef0ad6b$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = (0, $bPVeO.buildSearchParams)(context);
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$d49a7602fef0ad6b$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $harDk.default)(placementId ? url : null, (url)=>{
        var _fetcher$fetch;
        return (_fetcher$fetch = fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$d49a7602fef0ad6b$var$defaultHeaders,
                ...requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers
            }
        })) === null || _fetcher$fetch === void 0 ? void 0 : _fetcher$fetch.then(async (res)=>{
            if (!res) throw new Error('No response from fetch');
            const body = await res.json();
            const traceId = (0, $6bRJe.readPlacementTraceId)(res);
            if (!traceId || !body || typeof body !== 'object' || Array.isArray(body)) return body;
            return {
                ...body,
                traceId: traceId
            };
        });
    }, useSWROptions);
};

});
parcelRegister("harDk", function(module, exports) {
$parcel$export(module.exports, "SWRConfig", () => $c7f8ce4292e6b1a3$export$4c7bbecdacc3ca2c);
$parcel$export(module.exports, "default", () => $c7f8ce4292e6b1a3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6R5ln = parcelRequire("6R5ln");

var $6HiXF = parcelRequire("6HiXF");parcelRequire("6BXtB");
var $6HiXF = parcelRequire("6HiXF");
var $6BXtB = parcelRequire("6BXtB");
var $94djj = parcelRequire("94djj");
// Shared state between server components and client components
const $c7f8ce4292e6b1a3$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $c7f8ce4292e6b1a3$var$UNDEFINED = /*#__NOINLINE__*/ $c7f8ce4292e6b1a3$var$noop();
const $c7f8ce4292e6b1a3$var$OBJECT = Object;
const $c7f8ce4292e6b1a3$var$isUndefined = (v)=>v === $c7f8ce4292e6b1a3$var$UNDEFINED;
const $c7f8ce4292e6b1a3$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $c7f8ce4292e6b1a3$var$table = new WeakMap();
const $c7f8ce4292e6b1a3$var$getTypeName = (value)=>$c7f8ce4292e6b1a3$var$OBJECT.prototype.toString.call(value);
const $c7f8ce4292e6b1a3$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $c7f8ce4292e6b1a3$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $c7f8ce4292e6b1a3$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $c7f8ce4292e6b1a3$var$getTypeName(arg);
    const isDate = $c7f8ce4292e6b1a3$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $c7f8ce4292e6b1a3$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $c7f8ce4292e6b1a3$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($c7f8ce4292e6b1a3$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $c7f8ce4292e6b1a3$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$c7f8ce4292e6b1a3$var$counter + '~';
        $c7f8ce4292e6b1a3$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $c7f8ce4292e6b1a3$var$stableHash(arg[index]) + ',';
            $c7f8ce4292e6b1a3$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $c7f8ce4292e6b1a3$var$OBJECT.keys(arg).sort();
            while(!$c7f8ce4292e6b1a3$var$isUndefined(index = keys.pop()))if (!$c7f8ce4292e6b1a3$var$isUndefined(arg[index])) result += index + ':' + $c7f8ce4292e6b1a3$var$stableHash(arg[index]) + ',';
            $c7f8ce4292e6b1a3$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $c7f8ce4292e6b1a3$var$serialize = (key)=>{
    if ($c7f8ce4292e6b1a3$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $c7f8ce4292e6b1a3$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $c7f8ce4292e6b1a3$export$dbab534a48e651ef = (key)=>$c7f8ce4292e6b1a3$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $c7f8ce4292e6b1a3$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $c7f8ce4292e6b1a3$var$WITH_DEDUPE = {
    dedupe: true
};
const $c7f8ce4292e6b1a3$var$resolvedUndef = Promise.resolve((0, $6HiXF.U));
/**
 * The core implementation of the useSWR hook.
 *
 * This is the main handler function that implements all SWR functionality including
 * data fetching, caching, revalidation, error handling, and state management.
 * It manages the complete lifecycle of SWR requests from initialization through
 * cleanup.
 *
 * Key responsibilities:
 * - Key serialization and normalization
 * - Cache state management and synchronization
 * - Automatic and manual revalidation
 * - Error handling and retry logic
 * - Suspense integration
 * - Loading state management
 * - Effect cleanup and memory management
 *
 * @template Data - The type of data returned by the fetcher
 * @template Error - The type of error that can be thrown
 *
 * @param _key - The SWR key (string, array, object, function, or falsy)
 * @param fetcher - The fetcher function to retrieve data, or null to disable fetching
 * @param config - Complete SWR configuration object with both public and internal options
 *
 * @returns SWRResponse object containing data, error, mutate function, and loading states
 *
 * @internal This is the internal implementation. Use `useSWR` instead.
 */ const $c7f8ce4292e6b1a3$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData, strictServerPrefetchWarning: strictServerPrefetchWarning } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $6HiXF.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $6HiXF.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $fc4bM.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $fc4bM.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $fc4bM.useRef)(key);
    const fetcherRef = (0, $fc4bM.useRef)(fetcher);
    const configRef = (0, $fc4bM.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $6HiXF.z)(cache, key);
    const stateDependencies = (0, $fc4bM.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $6HiXF.e)(fallbackData) ? (0, $6HiXF.e)(config.fallback) ? (0, $6HiXF.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $6HiXF.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $fc4bM.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $6HiXF.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $6HiXF.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $6R5ln.useSyncExternalStore)((0, $fc4bM.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $6HiXF.e)(cachedData) ? fallback && (0, $6HiXF.B)(fallback) ? $c7f8ce4292e6b1a3$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $fc4bM.useRef)(data);
    const returnedData = keepPreviousData ? (0, $6HiXF.e)(cachedData) ? (0, $6HiXF.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    const hasKeyButNoData = key && (0, $6HiXF.e)(data);
    // Note: the conditionally hook call is fine because the environment
    // `IS_SERVER` never changes.
    const isHydration = !(0, $6HiXF.r) && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6R5ln.useSyncExternalStore)(()=>(0, $6HiXF.A), ()=>false, ()=>true);
    // During the initial SSR render, warn if the key has no data pre-fetched via:
    // - fallback data
    // - preload calls
    // - initial data from the cache provider
    // We only warn once for each key during SSR.
    if (strictServerPrefetchWarning && isHydration && !suspense && hasKeyButNoData) console.warn(`Missing pre-initiated data for serialized key "${key}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $6HiXF.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $6HiXF.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $6HiXF.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $6HiXF.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $6HiXF.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $6HiXF.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $fc4bM.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $6HiXF.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $6HiXF.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $6HiXF.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $6HiXF.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $6HiXF.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $6HiXF.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $6HiXF.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $94djj).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $fc4bM.useCallback)((...args)=>{
        return (0, $6HiXF.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $6HiXF.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $6HiXF.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $6HiXF.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $6HiXF.U), $c7f8ce4292e6b1a3$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $94djj).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $94djj).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $94djj).MUTATE_EVENT) return revalidate();
            else if (type == (0, $94djj).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $6BXtB.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $6HiXF.e)(data) || (0, $6HiXF.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $6HiXF.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $6HiXF.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $6HiXF.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($c7f8ce4292e6b1a3$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $fc4bM.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $6HiXF.I) && (0, $6HiXF.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $6HiXF.e)(req) && hasKeyButNoData ? boundMutate(req) : $c7f8ce4292e6b1a3$var$resolvedUndef;
        $c7f8ce4292e6b1a3$var$use(mutateReq);
        if (!(0, $6HiXF.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($c7f8ce4292e6b1a3$var$WITH_DEDUPE) : $c7f8ce4292e6b1a3$var$resolvedUndef;
        if (!(0, $6HiXF.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $c7f8ce4292e6b1a3$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $c7f8ce4292e6b1a3$export$4c7bbecdacc3ca2c = (0, $6HiXF.O).defineProperty((0, $6HiXF.g), 'defaultValue', {
    value: (0, $6HiXF.d)
});
/**
 * A hook to fetch data.
 *
 * @see {@link https://swr.vercel.app}
 *
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $c7f8ce4292e6b1a3$export$2e2bcd8739ae039 = (0, $6BXtB.withArgs)($c7f8ce4292e6b1a3$var$useSWRHandler);

});
parcelRegister("6HiXF", function(module, exports) {
$parcel$export(module.exports, "b", () => $4e0577957778e22a$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "A", () => $4e0577957778e22a$export$ebd11618f299a286);
$parcel$export(module.exports, "U", () => $4e0577957778e22a$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "O", () => $4e0577957778e22a$export$c4ce752e73470fba);
$parcel$export(module.exports, "e", () => $4e0577957778e22a$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $4e0577957778e22a$export$407448d2b89b1813);
$parcel$export(module.exports, "m", () => $4e0577957778e22a$export$953cecd6e717a553);
$parcel$export(module.exports, "B", () => $4e0577957778e22a$export$ef35774e6d314e91);
$parcel$export(module.exports, "i", () => $4e0577957778e22a$export$23f2a1d2818174ef);
$parcel$export(module.exports, "z", () => $4e0577957778e22a$export$df995fae86a55f06);
$parcel$export(module.exports, "I", () => $4e0577957778e22a$export$9bb611d729802a56);
$parcel$export(module.exports, "r", () => $4e0577957778e22a$export$43caf9889c228507);
$parcel$export(module.exports, "t", () => $4e0577957778e22a$export$625550452a3fa3ec);
$parcel$export(module.exports, "u", () => $4e0577957778e22a$export$3b14a55fb2447963);
$parcel$export(module.exports, "s", () => $4e0577957778e22a$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "o", () => $4e0577957778e22a$export$ae1af26003f05816);
$parcel$export(module.exports, "n", () => $4e0577957778e22a$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "c", () => $4e0577957778e22a$export$db3b6bfb95261072);
$parcel$export(module.exports, "d", () => $4e0577957778e22a$export$4368d992c4eafac0);
$parcel$export(module.exports, "f", () => $4e0577957778e22a$export$2d1720544b23b823);
$parcel$export(module.exports, "S", () => $4e0577957778e22a$export$25ce5a424b770e84);
$parcel$export(module.exports, "g", () => $4e0577957778e22a$export$39b482c5e57630a8);

var $fc4bM = parcelRequire("fc4bM");

var $94djj = parcelRequire("94djj");

var $hEEeh = parcelRequire("hEEeh");
'use client';
// Global state used to deduplicate requests and store listeners
const $4e0577957778e22a$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $4e0577957778e22a$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $4e0577957778e22a$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $4e0577957778e22a$export$ebd11618f299a286();
const $4e0577957778e22a$export$c4ce752e73470fba = Object;
const $4e0577957778e22a$export$f1e1789686576879 = (v)=>v === $4e0577957778e22a$export$3a6d5c9ae78a2c08;
const $4e0577957778e22a$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $4e0577957778e22a$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $4e0577957778e22a$export$ef35774e6d314e91 = (x)=>$4e0577957778e22a$export$407448d2b89b1813(x.then);
const $4e0577957778e22a$var$EMPTY_CACHE = {};
const $4e0577957778e22a$var$INITIAL_CACHE = {};
const $4e0577957778e22a$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $4e0577957778e22a$export$23f2a1d2818174ef = typeof window != $4e0577957778e22a$var$STR_UNDEFINED;
const $4e0577957778e22a$export$efccba1c4a2ef57b = typeof document != $4e0577957778e22a$var$STR_UNDEFINED;
const $4e0577957778e22a$export$d141bba7fdc215a3 = $4e0577957778e22a$export$23f2a1d2818174ef && 'Deno' in window;
const $4e0577957778e22a$export$4a5767248b18ef41 = ()=>$4e0577957778e22a$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $4e0577957778e22a$var$STR_UNDEFINED;
const $4e0577957778e22a$export$df995fae86a55f06 = (cache, key)=>{
    const state = $4e0577957778e22a$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$4e0577957778e22a$export$f1e1789686576879(key) && cache.get(key) || $4e0577957778e22a$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$4e0577957778e22a$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $4e0577957778e22a$var$INITIAL_CACHE)) $4e0577957778e22a$var$INITIAL_CACHE[key] = prev;
                state[5](key, $4e0577957778e22a$export$953cecd6e717a553(prev, info), prev || $4e0577957778e22a$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$4e0577957778e22a$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $4e0577957778e22a$var$INITIAL_CACHE) return $4e0577957778e22a$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$4e0577957778e22a$export$f1e1789686576879(key) && cache.get(key) || $4e0577957778e22a$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $4e0577957778e22a$var$online = true;
const $4e0577957778e22a$var$isOnline = ()=>$4e0577957778e22a$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$4e0577957778e22a$var$onWindowEvent, $4e0577957778e22a$var$offWindowEvent] = $4e0577957778e22a$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $4e0577957778e22a$export$ebd11618f299a286,
    $4e0577957778e22a$export$ebd11618f299a286
];
const $4e0577957778e22a$var$isVisible = ()=>{
    const visibilityState = $4e0577957778e22a$export$efccba1c4a2ef57b && document.visibilityState;
    return $4e0577957778e22a$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $4e0577957778e22a$var$initFocus = (callback)=>{
    // focus revalidate
    if ($4e0577957778e22a$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $4e0577957778e22a$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($4e0577957778e22a$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $4e0577957778e22a$var$offWindowEvent('focus', callback);
    };
};
const $4e0577957778e22a$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $4e0577957778e22a$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $4e0577957778e22a$var$online = false;
    };
    $4e0577957778e22a$var$onWindowEvent('online', onOnline);
    $4e0577957778e22a$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $4e0577957778e22a$var$offWindowEvent('online', onOnline);
        $4e0577957778e22a$var$offWindowEvent('offline', onOffline);
    };
};
const $4e0577957778e22a$export$ffb5f4729a158638 = {
    isOnline: $4e0577957778e22a$var$isOnline,
    isVisible: $4e0577957778e22a$var$isVisible
};
const $4e0577957778e22a$export$9e5f44173e64f162 = {
    initFocus: $4e0577957778e22a$var$initFocus,
    initReconnect: $4e0577957778e22a$var$initReconnect
};
const $4e0577957778e22a$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useId;
const $4e0577957778e22a$export$43caf9889c228507 = !$4e0577957778e22a$export$23f2a1d2818174ef || $4e0577957778e22a$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $4e0577957778e22a$export$625550452a3fa3ec = (f)=>$4e0577957778e22a$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $4e0577957778e22a$export$3b14a55fb2447963 = $4e0577957778e22a$export$43caf9889c228507 ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $4e0577957778e22a$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $4e0577957778e22a$export$90a7f3efeed30595 = !$4e0577957778e22a$export$43caf9889c228507 && $4e0577957778e22a$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($4e0577957778e22a$var$navigatorConnection.effectiveType) || $4e0577957778e22a$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $4e0577957778e22a$var$table = new WeakMap();
const $4e0577957778e22a$var$getTypeName = (value)=>$4e0577957778e22a$export$c4ce752e73470fba.prototype.toString.call(value);
const $4e0577957778e22a$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $4e0577957778e22a$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $4e0577957778e22a$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $4e0577957778e22a$var$getTypeName(arg);
    const isDate = $4e0577957778e22a$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $4e0577957778e22a$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $4e0577957778e22a$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($4e0577957778e22a$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $4e0577957778e22a$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$4e0577957778e22a$var$counter + '~';
        $4e0577957778e22a$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $4e0577957778e22a$export$882b5998b3b9117c(arg[index]) + ',';
            $4e0577957778e22a$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $4e0577957778e22a$export$c4ce752e73470fba.keys(arg).sort();
            while(!$4e0577957778e22a$export$f1e1789686576879(index = keys.pop()))if (!$4e0577957778e22a$export$f1e1789686576879(arg[index])) result += index + ':' + $4e0577957778e22a$export$882b5998b3b9117c(arg[index]) + ',';
            $4e0577957778e22a$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $4e0577957778e22a$export$2408f22a0fab9ae5 = (key)=>{
    if ($4e0577957778e22a$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $4e0577957778e22a$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $4e0577957778e22a$var$__timestamp = 0;
const $4e0577957778e22a$export$ae1af26003f05816 = ()=>++$4e0577957778e22a$var$__timestamp;
async function $4e0577957778e22a$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $4e0577957778e22a$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($4e0577957778e22a$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $4e0577957778e22a$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $4e0577957778e22a$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $4e0577957778e22a$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $4e0577957778e22a$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($94djj.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $4e0577957778e22a$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$4e0577957778e22a$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $4e0577957778e22a$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $4e0577957778e22a$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($4e0577957778e22a$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $4e0577957778e22a$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $4e0577957778e22a$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($4e0577957778e22a$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $4e0577957778e22a$export$3a6d5c9ae78a2c08,
                        _c: $4e0577957778e22a$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $4e0577957778e22a$export$3a6d5c9ae78a2c08,
                    _c: $4e0577957778e22a$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $4e0577957778e22a$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $4e0577957778e22a$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $4e0577957778e22a$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $4e0577957778e22a$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$4e0577957778e22a$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $4e0577957778e22a$export$953cecd6e717a553($4e0577957778e22a$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $4e0577957778e22a$export$7ccc53e8f1e7dfc5.bind($4e0577957778e22a$export$3a6d5c9ae78a2c08, provider);
        let unmount = $4e0577957778e22a$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$4e0577957778e22a$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $4e0577957778e22a$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$4e0577957778e22a$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($4e0577957778e22a$export$3a6d5c9ae78a2c08, $4e0577957778e22a$var$revalidateAllKeys.bind($4e0577957778e22a$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $94djj.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($4e0577957778e22a$export$3a6d5c9ae78a2c08, $4e0577957778e22a$var$revalidateAllKeys.bind($4e0577957778e22a$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $94djj.RECONNECT_EVENT)));
                    unmount = ()=>{
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseFocus && releaseFocus();
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $4e0577957778e22a$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $4e0577957778e22a$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $4e0577957778e22a$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$4e0577957778e22a$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $4e0577957778e22a$export$342063e11d6c3cad = (0, $hEEeh.dequal);
// Default cache provider
const [$4e0577957778e22a$export$db3b6bfb95261072, $4e0577957778e22a$export$35e795649ee09318] = $4e0577957778e22a$export$dda1d9f60106f0e9(new Map());
// Default config
const $4e0577957778e22a$export$4368d992c4eafac0 = $4e0577957778e22a$export$953cecd6e717a553({
    // events
    onLoadingSlow: $4e0577957778e22a$export$ebd11618f299a286,
    onSuccess: $4e0577957778e22a$export$ebd11618f299a286,
    onError: $4e0577957778e22a$export$ebd11618f299a286,
    onErrorRetry: $4e0577957778e22a$var$onErrorRetry,
    onDiscarded: $4e0577957778e22a$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $4e0577957778e22a$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $4e0577957778e22a$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $4e0577957778e22a$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $4e0577957778e22a$export$db3b6bfb95261072,
    mutate: $4e0577957778e22a$export$35e795649ee09318,
    fallback: {}
}, $4e0577957778e22a$export$ffb5f4729a158638);
const $4e0577957778e22a$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $4e0577957778e22a$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $4e0577957778e22a$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $4e0577957778e22a$export$25ce5a424b770e84 = (0, $fc4bM.createContext)({});
const $4e0577957778e22a$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $fc4bM.useContext)($4e0577957778e22a$export$25ce5a424b770e84);
    const isFunctionalConfig = $4e0577957778e22a$export$407448d2b89b1813(value);
    const config = (0, $fc4bM.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $fc4bM.useMemo)(()=>isFunctionalConfig ? config : $4e0577957778e22a$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $fc4bM.useRef)($4e0577957778e22a$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $4e0577957778e22a$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $4e0577957778e22a$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $4e0577957778e22a$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $fc4bM.createElement)($4e0577957778e22a$export$25ce5a424b770e84.Provider, $4e0577957778e22a$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};

});
parcelRegister("94djj", function(module, exports) {
$parcel$export(module.exports, "FOCUS_EVENT", () => $699ecffa2e4c9a97$export$831c820ad60f9d12);
$parcel$export(module.exports, "RECONNECT_EVENT", () => $699ecffa2e4c9a97$export$24e9454cb99a11dc);
$parcel$export(module.exports, "MUTATE_EVENT", () => $699ecffa2e4c9a97$export$75ea288459391154);
$parcel$export(module.exports, "ERROR_REVALIDATE_EVENT", () => $699ecffa2e4c9a97$export$b019c3839228f243);
const $699ecffa2e4c9a97$export$831c820ad60f9d12 = 0;
const $699ecffa2e4c9a97$export$24e9454cb99a11dc = 1;
const $699ecffa2e4c9a97$export$75ea288459391154 = 2;
const $699ecffa2e4c9a97$export$b019c3839228f243 = 3;

});

parcelRegister("hEEeh", function(module, exports) {
$parcel$export(module.exports, "dequal", () => $03511e76e1f73844$export$de8294bb3be0322f);
var $03511e76e1f73844$var$has = Object.prototype.hasOwnProperty;
function $03511e76e1f73844$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $03511e76e1f73844$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($03511e76e1f73844$var$has.call(foo, ctor) && ++len && !$03511e76e1f73844$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$03511e76e1f73844$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("6BXtB", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $4d04559445c36f9e$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $4d04559445c36f9e$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $4d04559445c36f9e$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("6HiXF")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("6HiXF")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("6HiXF")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("6HiXF")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("6HiXF")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("6HiXF")).s);

var $6HiXF = parcelRequire("6HiXF");

var $94djj = parcelRequire("94djj");

var $eDZpG = parcelRequire("eDZpG");

var $fc4bM = parcelRequire("fc4bM");

// @ts-expect-error
const $4d04559445c36f9e$var$enableDevtools = (0, $6HiXF.i) && window.__SWR_DEVTOOLS_USE__;
const $4d04559445c36f9e$var$use = $4d04559445c36f9e$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $4d04559445c36f9e$var$setupDevTools = ()=>{
    if ($4d04559445c36f9e$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM)));
};
const $4d04559445c36f9e$export$a3295358bff77e = (args)=>{
    return (0, $6HiXF.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $4d04559445c36f9e$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $fc4bM.useContext)((0, $6HiXF.S));
    const mergedConfig = (0, $fc4bM.useMemo)(()=>(0, $6HiXF.m)((0, $6HiXF.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $4d04559445c36f9e$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $6HiXF.s)(key_);
    const [, , , PRELOAD] = (0, $6HiXF.b).get((0, $6HiXF.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $4d04559445c36f9e$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $6HiXF.s)(key_);
            const [, , , PRELOAD] = (0, $6HiXF.b).get((0, $6HiXF.c));
            if (key.startsWith((0, $eDZpG.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $6HiXF.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $4d04559445c36f9e$var$BUILT_IN_MIDDLEWARE = $4d04559445c36f9e$var$use.concat($4d04559445c36f9e$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $4d04559445c36f9e$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $4d04559445c36f9e$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $4d04559445c36f9e$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $6HiXF.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($4d04559445c36f9e$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $4d04559445c36f9e$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $4d04559445c36f9e$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $4d04559445c36f9e$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$4d04559445c36f9e$var$setupDevTools();

});
parcelRegister("eDZpG", function(module, exports) {
$parcel$export(module.exports, "INFINITE_PREFIX", () => $aa94589fc35426c9$export$8667f065faedc62c);
const $aa94589fc35426c9$export$8667f065faedc62c = '$inf$';

});



parcelRegister("bPVeO", function(module, exports) {
$parcel$export(module.exports, "buildSearchParams", () => $26d9cd198e7e69a4$export$1ee5f9be618fd29e);
const $26d9cd198e7e69a4$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $26d9cd198e7e69a4$export$1ee5f9be618fd29e = (context)=>{
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(context)){
        if (Array.isArray(value)) value.filter($26d9cd198e7e69a4$var$isNotEmpty).forEach((element)=>params.append(key, String(element)));
        else if ($26d9cd198e7e69a4$var$isNotEmpty(value)) params.append(key, String(value));
    }
    params.sort();
    return params;
};

});



parcelRegister("lWus1", function(module, exports) {
$parcel$export(module.exports, "PlacementValidationError", () => $df23e09ff31e5c62$export$70abd424e1cca8c3);
$parcel$export(module.exports, "PlacementLocationError", () => $df23e09ff31e5c62$export$17455b84f403213b);
$parcel$export(module.exports, "isPlacementMessage", () => $df23e09ff31e5c62$export$a8ba7e6c095216ec);
$parcel$export(module.exports, "toHookError", () => $df23e09ff31e5c62$export$8364e41b11fd7d3b);
$parcel$export(module.exports, "isMatchBuilder", () => $df23e09ff31e5c62$export$be507563b85af550);
$parcel$export(module.exports, "createMatchBuilder", () => $df23e09ff31e5c62$export$861b204abcaa015d);
/** Shared utilities for post-office headless API hooks. */ class $df23e09ff31e5c62$export$70abd424e1cca8c3 extends Error {
    constructor({ placementId: placementId, failedCount: failedCount }){
        super('One or more messages failed structural validation'), this.name = 'PlacementValidationError';
        this.placementId = placementId;
        this.failedCount = failedCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $df23e09ff31e5c62$export$fc2b8b9bcb86a0d0 extends Error {
    constructor({ placementId: placementId, messageTemplateId: messageTemplateId, instanceCount: instanceCount }){
        super('Multiple message instances found; the hook is in an unexpected state and no message will be returned. Use useMessageInstances if multiple instances are expected.'), this.name = 'MultipleMessageInstancesError';
        this.placementId = placementId;
        this.messageTemplateId = messageTemplateId;
        this.instanceCount = instanceCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $df23e09ff31e5c62$export$17455b84f403213b extends Error {
    constructor({ locationKey: locationKey, invalidCount: invalidCount }){
        super('All items at the message location must be valid PlacementMessage objects'), this.name = 'PlacementLocationError';
        this.locationKey = locationKey;
        this.invalidCount = invalidCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $df23e09ff31e5c62$export$a8ba7e6c095216ec = (item)=>{
    if (typeof item !== 'object' || item === null) return false;
    const msg = item;
    return typeof msg.messageTemplateId === 'string' && typeof msg.messageInstanceId === 'string' && typeof msg.context === 'object' && msg.context !== null;
};
const $df23e09ff31e5c62$export$8364e41b11fd7d3b = (thrown, fallbackMessage = 'Hook callback threw')=>{
    if (thrown instanceof Error) return thrown;
    if (typeof thrown === 'string') return new Error(thrown);
    return new Error(fallbackMessage);
};
// Match Builder
/** @internal — used to tag match-builder objects in place of `instanceof`. */ const $df23e09ff31e5c62$var$MATCH_BUILDER_TAG = Symbol('MatchBuilder');
/** @internal — creates a builder with the given accumulated state (location already resolved). */ const $df23e09ff31e5c62$var$makeMatchBuilder = (locationKey, contextPredicates, dataPredicates)=>{
    const builder = {
        messageContext (predicate) {
            return $df23e09ff31e5c62$var$makeMatchBuilder(locationKey, [
                ...contextPredicates,
                predicate
            ], dataPredicates);
        },
        custom (predicate) {
            return $df23e09ff31e5c62$var$makeMatchBuilder(locationKey, contextPredicates, [
                ...dataPredicates,
                predicate
            ]);
        },
        match (data) {
            if (dataPredicates.some((p)=>!p(data))) return [];
            const raw = data[locationKey] ?? [];
            if (!Array.isArray(raw)) throw new $df23e09ff31e5c62$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: 1
            });
            const items = raw;
            const invalidCount = items.filter((item)=>!$df23e09ff31e5c62$export$a8ba7e6c095216ec(item)).length;
            if (invalidCount > 0) throw new $df23e09ff31e5c62$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: invalidCount
            });
            const candidates = items;
            return candidates.filter((message)=>contextPredicates.every((p)=>p(message.context)));
        }
    };
    // Tag the builder with a non-enumerable symbol so isMatchBuilder can identify it without
    // relying on instanceof (which would break across module boundaries or after minification).
    Object.defineProperty(builder, $df23e09ff31e5c62$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return builder;
};
/** @internal — creates the initial builder with `messageLocation` available. */ const $df23e09ff31e5c62$var$makeInitialMatchBuilder = ()=>{
    const initial = {
        messageLocation (key) {
            return $df23e09ff31e5c62$var$makeMatchBuilder(key, [], []);
        },
        messageContext (predicate) {
            return $df23e09ff31e5c62$var$makeMatchBuilder('messages', [
                predicate
            ], []);
        },
        custom (predicate) {
            return $df23e09ff31e5c62$var$makeMatchBuilder('messages', [], [
                predicate
            ]);
        },
        match (data) {
            return $df23e09ff31e5c62$var$makeMatchBuilder('messages', [], []).match(data);
        }
    };
    Object.defineProperty(initial, $df23e09ff31e5c62$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return initial;
};
const $df23e09ff31e5c62$export$be507563b85af550 = (value)=>{
    return typeof value === 'object' && value !== null && value[$df23e09ff31e5c62$var$MATCH_BUILDER_TAG] === true;
};
const $df23e09ff31e5c62$export$861b204abcaa015d = ()=>$df23e09ff31e5c62$var$makeInitialMatchBuilder();

});


parcelRegister("6q6nO", function(module, exports) {
module.exports = new URL("../images/update-help-center.27c1f9e5.svg", import.meta.url).toString();

});

parcelRegister("6F0AN", function(module, exports) {
$parcel$export(module.exports, "default", () => $255e24d1b9554314$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $255e24d1b9554314$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    headline: {
        defaultMessage: 'Update your help center to the latest features',
        description: 'Headline of the onboarding spotlight pointing existing admins at where they can update their help center.',
        id: 'avatar.menu.v2.update.help.center.spotlight.headline'
    },
    body: {
        defaultMessage: 'Use the update tool to convert your help center from here.',
        description: 'Body of the onboarding spotlight pointing existing admins at where they can update their help center.',
        id: 'avatar.menu.v2.update.help.center.spotlight.body'
    },
    gotIt: {
        defaultMessage: 'Got it',
        description: 'Button that acknowledges and closes the Update help center onboarding spotlight.',
        id: 'avatar.menu.v2.update.help.center.spotlight.got.it'
    },
    dismiss: {
        defaultMessage: 'Dismiss',
        description: 'Tooltip for the cross icon that closes the Update help center onboarding spotlight.',
        id: 'avatar.menu.v2.update.help.center.spotlight.dismiss'
    }
});

});

parcelRegister("l12iT", function(module, exports) {
$parcel$export(module.exports, "PostOfficeScope", () => (parcelRequire("aHrj0")).PostOfficeScope);

var $aHrj0 = parcelRequire("aHrj0");

});
parcelRegister("aHrj0", function(module, exports) {
$parcel$export(module.exports, "PostOfficeScope", () => $d3aaf1632893655c$export$907d820dda0b6e0d);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $6LH8a = parcelRequire("6LH8a");

var $7lN8e = parcelRequire("7lN8e");

var $2S7eu = parcelRequire("2S7eu");
const $d3aaf1632893655c$var$POST_OFFICE_ENV = {
    [(0, $7lN8e.EnvType).LOCAL]: 'local',
    [(0, $7lN8e.EnvType).DEV]: 'dev',
    [(0, $7lN8e.EnvType).STAGING]: 'staging',
    [(0, $7lN8e.EnvType).PROD]: 'production'
};
const $d3aaf1632893655c$export$907d820dda0b6e0d = ({ children: children })=>{
    const { locale: locale } = (0, $gpjDl.default)();
    const environment = (0, $fc4bM.useMemo)(()=>({
            env: $d3aaf1632893655c$var$POST_OFFICE_ENV[(0, $7lN8e.getEnv)().environment]
        }), []);
    const context = (0, $fc4bM.useMemo)(()=>({
            current: {
                locale: locale,
                product: 'jira',
                subproduct: 'service_desk',
                tenantId: (0, $6LH8a.getCloudId)()
            }
        }), [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2S7eu.PostOfficeProvider), {
        context: context,
        environment: environment
    }, children);
};

});
parcelRegister("2S7eu", function(module, exports) {
$parcel$export(module.exports, "PostOfficeProvider", () => $e7ce799e3a596203$export$fb465b6e855c1e85);

var $fc4bM = parcelRequire("fc4bM");

var $harDk = parcelRequire("harDk");

var $hH2zO = parcelRequire("hH2zO");

var $dRkX9 = parcelRequire("dRkX9");

var $im5M7 = parcelRequire("im5M7");

var $f6Kyi = parcelRequire("f6Kyi");

var $csaDS = parcelRequire("csaDS");

var $3ztdy = parcelRequire("3ztdy");

var $kO6GI = parcelRequire("kO6GI");

var $hhqHX = parcelRequire("hhqHX");

var $4lPZG = parcelRequire("4lPZG");

var $kb6vC = parcelRequire("kb6vC");

var $8f1cg = parcelRequire("8f1cg");

var $fg655 = parcelRequire("fg655");

var $hL6u6 = parcelRequire("hL6u6");

var $6ZP46 = parcelRequire("6ZP46");
const $e7ce799e3a596203$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isFedRampCompliantUrlsEnabled = (0, $dRkX9.fg)('post-office-rml-fedramp-compliant-urls');
    const environmentValues = (0, $fc4bM.useMemo)(()=>(0, $f6Kyi.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled), [
        isFedRampCompliantUrlsEnabled
    ]);
    const stableEnvironment = (0, $4lPZG.useStableObject)((0, $hL6u6.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides));
    const stableContext = (0, $4lPZG.useStableObject)($e7ce799e3a596203$var$composeConfig((0, $im5M7.defaultPostOfficeContextValue), context.current));
    const contextSettled = context.settled ?? true;
    const memoizedMessagePlacementValues = (0, $fc4bM.useMemo)(()=>(0, $fg655.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e7ce799e3a596203$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $f6Kyi.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kb6vC.PostOfficeContextSettledProvider), {
        value: contextSettled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $im5M7.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kO6GI.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fg655.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3ztdy.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hhqHX.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e7ce799e3a596203$var$MaybeAnalyticsListener, {
        analyticsClientInstance: analyticsClientInstance
    }, children)))))))));
};
const $e7ce799e3a596203$var$swrConfig = {
    provider: (0, $6ZP46.localStorageCacheProvider),
    use: [
        (0, $6ZP46.postOfficeCacheMiddleware)
    ]
};
const $e7ce799e3a596203$var$MaybePostOfficeCacheProvider = ({ children: children })=>{
    if ((0, $dRkX9.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $harDk.SWRConfig), {
        value: $e7ce799e3a596203$var$swrConfig
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
};
const $e7ce799e3a596203$var$MaybeAnalyticsListener = ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isEPExposuresListenerEnabled = (0, $dRkX9.fg)('post-office_ep_exposures_enabled');
    const isAnalyticsListenerEnabled = (0, $dRkX9.fg)('post-office-analytics-listener-enabled');
    let content = children;
    if (isEPExposuresListenerEnabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8f1cg.EPExposuresListener), {
        analyticsClientInstance: analyticsClientInstance
    }, content);
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $csaDS.postOfficeGasv3ListenerStore);
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
            channel: "*",
            onEvent: handleEvent
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, content);
};
const $e7ce799e3a596203$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("csaDS", function(module, exports) {
$parcel$export(module.exports, "postOfficeGasv3ListenerStore", () => $f6a77c4f1eb66662$export$19b95495a42be187);

var $gI3BB = parcelRequire("gI3BB");
function $f6a77c4f1eb66662$var$getSubscribers() {
    var _window$postOffice;
    if (typeof window !== 'undefined' && (_window$postOffice = window.postOffice) !== null && _window$postOffice !== void 0 && (_window$postOffice = _window$postOffice.gasv3Listener) !== null && _window$postOffice !== void 0 && _window$postOffice.subscribers) return window.postOffice.gasv3Listener.subscribers;
    if (typeof window !== 'undefined') {
        var _window$postOffice2;
        window.postOffice = {
            ...window.postOffice,
            gasv3Listener: {
                ...(_window$postOffice2 = window.postOffice) === null || _window$postOffice2 === void 0 ? void 0 : _window$postOffice2.gasv3Listener,
                subscribers: new Map()
            }
        };
        return window.postOffice.gasv3Listener.subscribers;
    }
    return new Map();
}
const $f6a77c4f1eb66662$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = $f6a77c4f1eb66662$var$getSubscribers();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gI3BB)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $f6a77c4f1eb66662$export$19b95495a42be187 = $f6a77c4f1eb66662$var$createPostOfficeGasv3ListenerStore();

});

parcelRegister("3ztdy", function(module, exports) {
$parcel$export(module.exports, "RouteListenerProvider", () => $c7b1b98a341da475$export$31986273b686f5ea);

var $fc4bM = parcelRequire("fc4bM");

var $duSjZ = parcelRequire("duSjZ");

var $1Vax2 = parcelRequire("1Vax2");
const $c7b1b98a341da475$var$noop = ()=>{};
const $c7b1b98a341da475$var$RouteListenerContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    update: $c7b1b98a341da475$var$noop
});
const $c7b1b98a341da475$export$7a2084f4baac29a7 = ()=>(0, $duSjZ.createSimplePubSub)();
const $c7b1b98a341da475$export$72fd8977abf03d60 = ()=>(0, $fc4bM.useContext)($c7b1b98a341da475$var$RouteListenerContext);
const $c7b1b98a341da475$export$755edb1665399d41 = ()=>{
    const ref = (0, $fc4bM.useRef)();
    if (!ref.current) ref.current = $c7b1b98a341da475$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $fc4bM.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $fc4bM.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $c7b1b98a341da475$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $c7b1b98a341da475$export$72fd8977abf03d60();
    (0, $fc4bM.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $c7b1b98a341da475$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $c7b1b98a341da475$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c7b1b98a341da475$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1Vax2.PostOfficeRouteProvider), route, children));
};

});
parcelRegister("duSjZ", function(module, exports) {
$parcel$export(module.exports, "createSimplePubSub", () => $5730803f3f55d008$export$92469b55607f005b);
const $5730803f3f55d008$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});

parcelRegister("1Vax2", function(module, exports) {
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $00b20d6d8c3b70b7$export$89eadc6b3e5f4e9e);

var $fc4bM = parcelRequire("fc4bM");

var $6R5ln = parcelRequire("6R5ln");

var $4lPZG = parcelRequire("4lPZG");
const $00b20d6d8c3b70b7$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $00b20d6d8c3b70b7$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        var _routeChange$next, _routeChange$next2, _routeChange$next3;
        const next = (_routeChange$next = routeChange.next) === null || _routeChange$next === void 0 ? void 0 : _routeChange$next.toString();
        if (next === state.current && state.searchParams === ((_routeChange$next2 = routeChange.next) === null || _routeChange$next2 === void 0 ? void 0 : _routeChange$next2.searchParams)) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: (_routeChange$next3 = routeChange.next) === null || _routeChange$next3 === void 0 ? void 0 : _routeChange$next3.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $00b20d6d8c3b70b7$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $6R5ln.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4lPZG.useStableObject)(route);
};
const $00b20d6d8c3b70b7$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $00b20d6d8c3b70b7$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$00b20d6d8c3b70b7$var$initialState,
        current: initialUrl ? initialUrl === null || initialUrl === void 0 ? void 0 : initialUrl.toString() : undefined,
        searchParams: initialUrl === null || initialUrl === void 0 ? void 0 : initialUrl.searchParams
    });
const $00b20d6d8c3b70b7$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $fc4bM.createContext)($00b20d6d8c3b70b7$var$initialState);
const $00b20d6d8c3b70b7$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $fc4bM.useRef)();
    if (!ref.current) ref.current = $00b20d6d8c3b70b7$export$98c77e1bd702ed15(props);
    const route = $00b20d6d8c3b70b7$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($00b20d6d8c3b70b7$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $00b20d6d8c3b70b7$export$79301b66f7808cd8 = ()=>(0, $fc4bM.useContext)($00b20d6d8c3b70b7$export$f7f47a74e8b47b1f); //Route listener

});
parcelRegister("4lPZG", function(module, exports) {
$parcel$export(module.exports, "useStableObject", () => $7a63fa43498525c5$export$ed02d4adf2068b08);

var $fc4bM = parcelRequire("fc4bM");
function $7a63fa43498525c5$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $7a63fa43498525c5$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $fc4bM.useMemo)(()=>obj, $7a63fa43498525c5$export$cdf98ded28406f69(obj));
}

});



parcelRegister("hhqHX", function(module, exports) {
$parcel$export(module.exports, "TriggerContextProvider", () => $ee09cb3fc7ed8626$export$e80a5720bb4c8fe3);

var $fc4bM = parcelRequire("fc4bM");
const $ee09cb3fc7ed8626$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $ee09cb3fc7ed8626$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $ee09cb3fc7ed8626$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext($ee09cb3fc7ed8626$var$initialActiveTriggerState);
const $ee09cb3fc7ed8626$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext($ee09cb3fc7ed8626$var$initialTriggerDispatchState);
const $ee09cb3fc7ed8626$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $fc4bM.useState)({});
    const setTriggerState = (0, $fc4bM.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $fc4bM.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $fc4bM.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ee09cb3fc7ed8626$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ee09cb3fc7ed8626$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $ee09cb3fc7ed8626$export$454c1d7c35958f5e = ()=>(0, $fc4bM.useContext)($ee09cb3fc7ed8626$var$TriggerContext);
const $ee09cb3fc7ed8626$export$23cbf084e08bdb93 = ()=>(0, $fc4bM.useContext)($ee09cb3fc7ed8626$var$TriggerDispatchContext);
const $ee09cb3fc7ed8626$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $ee09cb3fc7ed8626$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $ee09cb3fc7ed8626$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $ee09cb3fc7ed8626$export$23cbf084e08bdb93();
    const fireTrigger = (0, $fc4bM.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $ee09cb3fc7ed8626$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $ee09cb3fc7ed8626$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $ee09cb3fc7ed8626$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $ee09cb3fc7ed8626$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $ee09cb3fc7ed8626$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $fc4bM.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $fc4bM.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $fc4bM.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};

});

parcelRegister("kb6vC", function(module, exports) {
$parcel$export(module.exports, "PostOfficeContextSettledProvider", () => $1ccbc12547fb56e8$export$461246659964e94e);

var $fc4bM = parcelRequire("fc4bM");
const $1ccbc12547fb56e8$var$PostOfficeContextSettledContext = (0, $fc4bM.createContext)(true);
const $1ccbc12547fb56e8$export$461246659964e94e = $1ccbc12547fb56e8$var$PostOfficeContextSettledContext.Provider;
const $1ccbc12547fb56e8$export$a0132d27bc11e627 = ()=>(0, $fc4bM.useContext)($1ccbc12547fb56e8$var$PostOfficeContextSettledContext);

});

parcelRegister("8f1cg", function(module, exports) {
$parcel$export(module.exports, "EPExposuresListener", () => $9eae896db5be5db3$export$3476bc3bd0845b44);

var $fc4bM = parcelRequire("fc4bM");

var $2mgM4 = parcelRequire("2mgM4");

var $hH2zO = parcelRequire("hH2zO");
const $9eae896db5be5db3$var$ENGAGEMENT_PLATFORM_CHANNEL = 'engagementPlatform';
const $9eae896db5be5db3$var$isPromise = (value)=>{
    return value && typeof value.then === 'function';
};
const $9eae896db5be5db3$export$3476bc3bd0845b44 = ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const handleEvent = (0, $fc4bM.useCallback)((event)=>{
        if (!analyticsClientInstance) return;
        const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
        const userId = (restPayload === null || restPayload === void 0 ? void 0 : restPayload.userId) || (attributes === null || attributes === void 0 ? void 0 : attributes.userId);
        const tenantId = (restPayload === null || restPayload === void 0 ? void 0 : restPayload.tenantId) || (attributes === null || attributes === void 0 ? void 0 : attributes.tenantId);
        if (eventType !== 'track' && eventType !== 'operational') return;
        if (!userId || !tenantId) return;
        // Handle Promise if analyticsClientInstance is a Promise
        const processEvent = (client)=>{
            // Update client with user and tenant info
            try {
                if (tenantId) client.setTenantInfo((0, $2mgM4.tenantType).CLOUD_ID, tenantId);
                if (userId) client.setUserInfo((0, $2mgM4.userType).ATLASSIAN_ACCOUNT, userId);
            } catch (error) {
                return;
            }
            // Build payload with tenantId at top level (userId is automatically included via setUserInfo)
            const gasPayload = {
                ...restPayload,
                tenantId: tenantId,
                ...attributes ? {
                    attributes: attributes
                } : {}
            };
            if (eventType === 'track') client.sendTrackEvent(gasPayload);
            else if (eventType === 'operational') client.sendOperationalEvent(gasPayload);
        };
        if ($9eae896db5be5db3$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
        else processEvent(analyticsClientInstance);
    }, [
        analyticsClientInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
        channel: $9eae896db5be5db3$var$ENGAGEMENT_PLATFORM_CHANNEL,
        onEvent: handleEvent
    }, children);
};

});

parcelRegister("hL6u6", function(module, exports) {
$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $a5a0955a53d74d62$export$ae3dab16eb1fc2cc);
const $a5a0955a53d74d62$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    var _overrides$remoteModu, _overrides$remoteModu2, _overrides$remoteModu3, _overrides$api, _overrides$api2, _overrides$api3;
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: (overrides === null || overrides === void 0 || (_overrides$remoteModu = overrides.remoteModule) === null || _overrides$remoteModu === void 0 ? void 0 : _overrides$remoteModu.origin) ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: (overrides === null || overrides === void 0 || (_overrides$remoteModu2 = overrides.remoteModule) === null || _overrides$remoteModu2 === void 0 ? void 0 : _overrides$remoteModu2.pathname) ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: (overrides === null || overrides === void 0 || (_overrides$remoteModu3 = overrides.remoteModule) === null || _overrides$remoteModu3 === void 0 ? void 0 : _overrides$remoteModu3.searchParams) ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: (overrides === null || overrides === void 0 || (_overrides$api = overrides.api) === null || _overrides$api === void 0 ? void 0 : _overrides$api.origin) ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: (overrides === null || overrides === void 0 || (_overrides$api2 = overrides.api) === null || _overrides$api2 === void 0 ? void 0 : _overrides$api2.pathname) ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: (overrides === null || overrides === void 0 || (_overrides$api3 = overrides.api) === null || _overrides$api3 === void 0 ? void 0 : _overrides$api3.searchParams) ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});

parcelRegister("6ZP46", function(module, exports) {
$parcel$export(module.exports, "localStorageCacheProvider", () => $ff65ba59d02f51ea$export$54eb3e634424b746);
$parcel$export(module.exports, "postOfficeCacheMiddleware", () => $ff65ba59d02f51ea$export$711c5bb855c82238);

var $fc4bM = parcelRequire("fc4bM");

var $6BXtB = parcelRequire("6BXtB");
parcelRequire("bhV4A");
var $6EzEO = parcelRequire("6EzEO");
const $ff65ba59d02f51ea$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $ff65ba59d02f51ea$var$CACHE_KEY = 'placement-api';
const $ff65ba59d02f51ea$var$CACHE_EXPIRY = 120000; // 2 minutes
const $ff65ba59d02f51ea$var$storageClient = new (0, $6EzEO.StorageClient)($ff65ba59d02f51ea$var$STORAGE_KEY);
const $ff65ba59d02f51ea$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $ff65ba59d02f51ea$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $ff65ba59d02f51ea$var$storageClient.setItemWithExpiry($ff65ba59d02f51ea$var$CACHE_KEY, appCache, $ff65ba59d02f51ea$var$CACHE_EXPIRY);
    }
};
const $ff65ba59d02f51ea$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $ff65ba59d02f51ea$var$storageClient.getItem($ff65ba59d02f51ea$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $ff65ba59d02f51ea$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $6BXtB.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
     * This will execute even when data is pulled from the local storage cache.
     * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
     *
     * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
     */ (0, $fc4bM.useEffect)(()=>{
            if (swr.data !== undefined) $ff65ba59d02f51ea$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};

});






parcelRegister("eQkdB", function(module, exports) {
$parcel$export(module.exports, "avatarMenuExperience", () => $0ff7e75dd31078c7$export$90a7234d224ce2c4);
$parcel$export(module.exports, "AvatarMenuExperienceFailure", () => $0ff7e75dd31078c7$export$2d5d3fcf414ca903);

var $fc4bM = parcelRequire("fc4bM");

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $0ff7e75dd31078c7$export$90a7234d224ce2c4 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.avatarMenuExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $0ff7e75dd31078c7$export$2d5d3fcf414ca903 = (props)=>{
    (0, $fc4bM.useEffect)(()=>{
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $0ff7e75dd31078c7$export$90a7234d224ce2c4.failure({
            metadata: props
        });
    }, [
        props
    ]);
    return null;
};

});

parcelRegister("1i5tj", function(module, exports) {
$parcel$export(module.exports, "default", () => $877f03d37cf5c30f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $877f03d37cf5c30f$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user requests section.',
        id: 'avatar.menu.v2.header.requests'
    },
    requestListHeading: {
        defaultMessage: 'REQUESTS LIST',
        description: 'Requests list header in menu request subsection',
        id: 'avatar.menu.v2.header.requests-list'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in menu request subsection',
        id: 'avatar.menu.v2.header.manage-column'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user approvals section.',
        id: 'avatar.menu.v2.header.approvals'
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user profile page.',
        id: 'avatar.menu.v2.header.profile'
    },
    logout: {
        defaultMessage: 'Log out',
        description: 'The text is shown on the log out button in the avatar drop-down menu that signs the user out of their account.',
        id: 'avatar.menu.v2.logout'
    },
    pageLayout: {
        defaultMessage: 'Page layout',
        description: 'Topics and Portals in avatar drop-down menu',
        id: 'avatar.menu.v2.topic'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in avatar drop-down menu',
        id: 'avatar.menu.v2.label.beta'
    },
    newLozenge: {
        defaultMessage: 'New',
        description: 'BeNewta lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.newLozenge'
    },
    topicsAndPortals: {
        defaultMessage: 'Topics and portals',
        description: 'Topics and Portals in avatar drop-down menu when advanced customization enabled',
        id: 'avatar.menu.v2.topics.and.portals'
    },
    look: {
        defaultMessage: 'Look and feel',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the look and feel customization settings.',
        id: 'avatar.menu.v2.look'
    },
    announcement: {
        defaultMessage: 'Announcements',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the announcements settings page.',
        id: 'avatar.menu.v2.announcement'
    },
    signIn: {
        defaultMessage: 'Log in message',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the log in message customization settings.',
        id: 'avatar.menu.v2.signIn'
    },
    helpCenterSettings: {
        defaultMessage: 'Service hub settings',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the service hub settings page.',
        id: 'avatar.menu.v2.helpCenterSettings'
    },
    customerHubSettings: {
        defaultMessage: 'Customer experience settings',
        description: 'Customer experience settings navigation item',
        id: 'avatar.menu.v2.customerHubSettings'
    },
    tooltip: {
        defaultMessage: 'Profile and settings',
        description: 'The text is shown as a tooltip when the user hovers over the avatar icon, indicating it opens the profile and settings menu.',
        id: 'avatar.profile.v2.tooltip'
    },
    reporting: {
        defaultMessage: 'Performance',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the Performance reporting page.',
        id: 'avatar.menu.v2.reporting'
    },
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the virtual service agent configuration page.',
        id: 'avatar.menu.v2.virtualServiceAgent'
    },
    portalAnnouncement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu portal subsection',
        id: 'avatar.menu.v2.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Portal groups',
        description: 'portal groups item in menu portal subsection',
        id: 'avatar.menu.v2.requestTypeGroup'
    },
    portal: {
        defaultMessage: 'PORTAL',
        description: 'Portal heading for menu portal subsection',
        id: 'avatar.menu.v2.portal.section'
    },
    helpCenter: {
        defaultMessage: 'HELP CENTER',
        description: 'Help Center heading for menu multi hc subsection',
        id: 'avatar.menu.v2.helpCenter.section'
    },
    onboardingDescriptionCreateOrHcClickWithLink: {
        defaultMessage: 'Upgrade to Jira Service Management Premium to create and manage multiple help centers on your site and ',
        description: 'Upgrade modal description a help center is clicked or create a help center is clicked',
        id: 'uh.home.downgrade.modal.description.create.or.hc.with.link'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    onboardingTitleHCClick: {
        defaultMessage: 'Serve different audiences with multiple help centers',
        description: 'Upgrade modal title when help center is clicked',
        id: 'uh.home.downgrade.modal.title.hc'
    },
    freeStandardAdminsChangeBoardingHeading: {
        defaultMessage: 'Your help center settings have moved here',
        description: 'Heading text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.heading'
    },
    freeStandardAdminsChangeBoardingContent: {
        defaultMessage: 'Manage profile settings, view your requests, and customize your help center from here.',
        description: 'Content for topics Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.content'
    },
    freeStandardAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.button'
    },
    singlePortalScreenAdminsChangeBoardingHeading: {
        defaultMessage: 'Your portal settings have moved here',
        description: 'Heading text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.heading.'
    },
    singlePortalScreenAdminsChangeBoardingContent: {
        defaultMessage: 'Access your requests, profile settings, and customize the portal experience from here',
        description: 'Content for topics Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.content'
    },
    singlePortalScreenAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.button'
    },
    manageHc: {
        defaultMessage: 'View all help centers',
        description: 'Message for navigating to hc-management screen in avatar menu',
        id: 'avatar.menu.v2.manageHc'
    },
    managePages: {
        defaultMessage: 'Landing pages',
        description: 'Message for navigating to landing pages screen in avatar menu',
        id: 'avatar.menu.v2.help.center.pages'
    },
    rovoAgent: {
        defaultMessage: 'Rovo Agent',
        description: 'Label for create cutomized rovo agent button in avatar menue which is used to create a customized rovo agent',
        id: 'avatar.menu.v2.rovoAgent'
    },
    createHc: {
        defaultMessage: 'Create a help center',
        description: 'Label for create help center button in avatar menu which is used to navigate to the help center management page',
        id: 'avatar.menu.v2.createHc'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.description'
    },
    pageLayoutTryItNowButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.try.it.now.button'
    },
    premiumLozenge: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.premium.lozenge'
    },
    landingPagesNonPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create landing pages in a help center.',
        description: 'Non premium description for landing pages',
        id: 'avatar.menu.v2.landing.pages.non.premium.customer.description'
    },
    helpCenterMenuOptions: {
        defaultMessage: 'Help center menu options',
        description: 'Aria label for help center menu navigation list',
        id: 'avatar.menu.v2.helpCenter.menu.options'
    }
});

});

parcelRegister("lEU2a", function(module, exports) {
$parcel$export(module.exports, "RovoAgentMenu", () => $14152fc5f6af5c36$export$6cf91bfbf0fffa69);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $6LH8a = parcelRequire("6LH8a");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $euRd1 = parcelRequire("euRd1");

var $bKfoa = parcelRequire("bKfoa");

var $4MoYu = parcelRequire("4MoYu");

var $1i5tj = parcelRequire("1i5tj");
const $14152fc5f6af5c36$export$6cf91bfbf0fffa69 = ({ onClose: onClose, component: component })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarRovoAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        key: "customize-menu_navBarRovoAgent",
        component: component,
        href: `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/rovo-agent`,
        actionSubjectId: "navBarRovoAgent",
        onClick: handleClick,
        testId: "rovo-agent-link",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
            appearance: "discovery"
        }, formatMessage((0, $1i5tj.default).newLozenge)),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).rovoAgent));
};

});

parcelRegister("2xdpH", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentMenu", () => $24cda179077f10c3$export$3d3173207fec7a12);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $5ryST = parcelRequire("5ryST");

var $6LH8a = parcelRequire("6LH8a");

var $8ULdj = parcelRequire("8ULdj");

var $6geXm = parcelRequire("6geXm");

var $fd880 = parcelRequire("fd880");

var $bKfoa = parcelRequire("bKfoa");

var $byPAM = parcelRequire("byPAM");

var $fXMxe = parcelRequire("fXMxe");

var $4MoYu = parcelRequire("4MoYu");

var $1i5tj = parcelRequire("1i5tj");
const $24cda179077f10c3$export$3d3173207fec7a12 = ({ onClose: onClose, component: component })=>{
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $fc4bM.useState)(true);
    const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarVirtualAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8ULdj.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $byPAM.default), {
            name: (0, $9mazR.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT,
            key: "navBarVirtualAgent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            key: `customize-menu_navBarVirtualAgent`,
            component: component,
            href: `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/virtual-agent`,
            actionSubjectId: "navBarVirtualAgent",
            onClick: handleClick,
            testId: "virtual-agent-link",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $1i5tj.default).virtualServiceAgent)))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fXMxe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5ryST.default), {
        messageId: (0, $9mazR.EngagementMessages).ONBOARD_VA_REPORTING,
        key: (0, $9mazR.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6geXm.VaOnboardingSpotlight), {
        setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
    }))));
};

});






parcelRegister("6AnW7", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("6FAhw")).default);

var $6FAhw = parcelRequire("6FAhw");

});
parcelRegister("6FAhw", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d14019eff853ebc$export$2e2bcd8739ae039);

var $luyS0 = parcelRequire("luyS0");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("5xojH");
var $2qvOc = parcelRequire("2qvOc");

var $9mazR = parcelRequire("9mazR");

var $cjFOK = parcelRequire("cjFOK");

var $eXQnZ = parcelRequire("eXQnZ");
parcelRequire("ieUrC");
var $euVUr = parcelRequire("euVUr");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("bAzYZ");
var $hncVy = parcelRequire("hncVy");
parcelRequire("btLr7");
var $bJ9hx = parcelRequire("bJ9hx");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("gqVRw");
var $ghGWZ = parcelRequire("ghGWZ");

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");

var $k2M4v = parcelRequire("k2M4v");

var $aWDCT = parcelRequire("aWDCT");

var $iSFD9 = parcelRequire("iSFD9");

var $8zK3E = parcelRequire("8zK3E");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
parcelRequire("hCUGT");
var $ehOS8 = parcelRequire("ehOS8");
parcelRequire("dRJCQ");
var $2PUk1 = parcelRequire("2PUk1");
parcelRequire("7MlZR");
var $6BTpW = parcelRequire("6BTpW");
parcelRequire("lI4yE");
var $8l26f = parcelRequire("8l26f");
const $5d14019eff853ebc$export$4b85d3515bd863a5 = ({ term: term, trigger: trigger, isOpen: isOpen, onSearch: onSearch, onClose: onClose, onOpen: onOpen, resetSearch: resetSearch, fetchHelpCenter: fetchHelpCenter, fetchPortals: fetchPortals, disableSearch: disableSearch, isVSAOnHCEnabled: isVSAOnHCEnabled })=>{
    const searchButtonRef = (0, $fc4bM.useRef)(null);
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $b52IZ.isSinglePortalSearch)(portalId)) fetchPortals({
            id: (0, $b52IZ.getPortalIdAsNumber)(portalId),
            expand: [
                'kbs',
                'reqTypes',
                'reqGroups',
                'orderMapping'
            ]
        });
    }, [
        portalId,
        fetchHelpCenter,
        fetchPortals
    ]);
    const onReturnFocus = (0, $fc4bM.useCallback)((_)=>{
        //FocusLock trap is still active due to that we deffer setting focus with zero-timeout
        setTimeout(()=>{
            var _searchButtonRef$curr;
            searchButtonRef === null || searchButtonRef === void 0 || (_searchButtonRef$curr = searchButtonRef.current) === null || _searchButtonRef$curr === void 0 || _searchButtonRef$curr.focus();
        }, 0);
        return true;
    }, []);
    (0, $fc4bM.useEffect)(()=>()=>{
            resetSearch();
        }, [
        resetSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6BTpW.default), {
        isOpen: isOpen,
        term: term,
        portalId: portalId,
        onSearch: onSearch,
        onClose: onClose,
        onReturnFocus: onReturnFocus,
        isVSAOnHCEnabled: isVSAOnHCEnabled
    }), trigger === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ghGWZ.default), {
        ref: searchButtonRef,
        shown: isOpen,
        onClick: onOpen,
        disableSearch: disableSearch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ehOS8.InlineResultsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8l26f.default), {
        term: term,
        disableSearch: disableSearch,
        isVSAOnHCEnabled: !!isVSAOnHCEnabled
    }))));
};
const $5d14019eff853ebc$var$SearchWithVirtualAgentAvailability = (props)=>{
    var _data$helpCenter, _data$helpCenter2, _data$virtualAgent;
    const { queryReference: queryReference, ...rest } = props;
    const data = (0, $3BZyK.usePreloadedQuery)((0, $luyS0.default), props.queryReference);
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5d14019eff853ebc$export$4b85d3515bd863a5, rest);
    const isVirtualAgentEnabled = ((_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.virtualAgentEnabled) ?? false;
    const isVirtualAgentAvailable = ((_data$virtualAgent = data.virtualAgent) === null || _data$virtualAgent === void 0 ? void 0 : _data$virtualAgent.virtualAgentAvailability) ?? false;
    const isVSAOnHCEnabled = isVirtualAgentEnabled && isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5d14019eff853ebc$export$4b85d3515bd863a5, {
        isVSAOnHCEnabled: isVSAOnHCEnabled,
        ...rest
    });
};
const $5d14019eff853ebc$export$ab176425b2a52b00 = (props)=>{
    const { userLoggedIn: userLoggedIn } = props;
    const { queryReference: queryReference, refresh: refresh } = (0, $8zK3E.useRelayResource)((0, $cjFOK.searchComponentVirtualAgentResource));
    const prevUserLoggedInState = (0, $iSFD9.usePrevious)(userLoggedIn);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if ((0, $k2M4v.default).checkGate('jsd-search-router-login-logic-removal') && !prevUserLoggedInState && userLoggedIn) // fire refresh only if user has logged in same session, e.g., Portal only customer login
        refresh();
    }, [
        prevUserLoggedInState,
        userLoggedIn,
        refresh
    ]);
    const renderError = (0, $fc4bM.useCallback)(()=>{
        // We fallback to non-VSA search if there is an error occurs in this loader, All the other errors should be handled by the SearchErrorBoundary default renderError
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2PUk1.default), {
            id: "help-center-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5d14019eff853ebc$export$4b85d3515bd863a5, props));
    }, [
        props
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2PUk1.default), {
        id: "help-center-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5d14019eff853ebc$export$4b85d3515bd863a5, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2PUk1.default), {
        id: "help-center-search",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5d14019eff853ebc$export$4b85d3515bd863a5, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5d14019eff853ebc$var$SearchWithVirtualAgentAvailability, {
        queryReference: queryReference,
        ...props
    })));
};
const $5d14019eff853ebc$var$selector = (0, $2n2bS.createSelector)((0, $bJ9hx.getShown), (0, $bJ9hx.getTerm), (0, $7RWiC.isLoggedIn), (shown, term, userLoggedIn)=>({
        term: term,
        userLoggedIn: userLoggedIn,
        isOpen: shown
    }));
const $5d14019eff853ebc$var$ConnectedSearch = (0, $6umft.default)($5d14019eff853ebc$var$selector, {
    onOpen: ()=>(0, $hncVy.showSearch)(true),
    onClose: ()=>(0, $hncVy.showSearch)(false),
    onSearch: (term)=>(0, $hncVy.updateSearch)(term, {}),
    resetSearch: (0, $hncVy.resetSearch),
    fetchPortals: (0, $hijaX.fetchPortalAction),
    fetchHelpCenter: (0, $2qvOc.fetchHelpCenterAction)
})((0, $aWDCT.PortalAnalyticsModal)((0, $9mazR.ScreenName).HELP_CENTER_SEARCH)(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
(0, $eXQnZ.default)((0, $613oU.default)({
    component: (0, $9mazR.ScreenName).HELP_CENTER_SEARCH
})((0, $azARG.default)()($5d14019eff853ebc$export$ab176425b2a52b00)))));
var $5d14019eff853ebc$export$2e2bcd8739ae039 = $5d14019eff853ebc$var$ConnectedSearch;

});
parcelRegister("eXQnZ", function(module, exports) {
$parcel$export(module.exports, "PathParamsProvider", () => $a54abd275cf52659$export$ebcbd875f0707321);
$parcel$export(module.exports, "withPathParamProvider", () => $a54abd275cf52659$export$e8aa4f1b1a2e784c);
$parcel$export(module.exports, "default", () => $a54abd275cf52659$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
const $a54abd275cf52659$var$RouteParamContext = /*#__PURE__*/ $fc4bM.createContext({});
const $a54abd275cf52659$export$ebcbd875f0707321 = (props)=>/*#__PURE__*/ $fc4bM.createElement($a54abd275cf52659$var$RouteParamContext.Provider, {
        value: props.params
    }, props.children);
const $a54abd275cf52659$var$withPathParams = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $fc4bM.createElement($a54abd275cf52659$var$RouteParamContext.Consumer, null, (value)=>/*#__PURE__*/ $fc4bM.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
const $a54abd275cf52659$export$e8aa4f1b1a2e784c = (Component)=>{
    // eslint-disable-next-line react/display-name
    return (props)=>{
        const [{ match: match }] = (0, $7lAXH.useRouter)();
        return /*#__PURE__*/ $fc4bM.createElement($a54abd275cf52659$export$ebcbd875f0707321, {
            params: match.params
        }, /*#__PURE__*/ $fc4bM.createElement(Component, props));
    };
};
var $a54abd275cf52659$export$2e2bcd8739ae039 = $a54abd275cf52659$var$withPathParams;

});

parcelRegister("gqVRw", function(module, exports) {
$parcel$export(module.exports, "SearchButton", () => (parcelRequire("ghGWZ")).default);

var $ghGWZ = parcelRequire("ghGWZ");

});
parcelRegister("ghGWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $96cee01fcc0dc34e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $kTVlm = parcelRequire("kTVlm");

var $8K7DG = parcelRequire("8K7DG");
const $96cee01fcc0dc34e$export$690bcf3a1f1e9f2f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ onClick: onClick, disableSearch: disableSearch }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($96cee01fcc0dc34e$var$StyledSearchIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        isDisabled: disableSearch,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        style: {
            borderRadius: '50%'
        },
        ref: ref,
        onClick: onClick,
        appearance: "subtle",
        shouldFitContainer: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            spacing: "spacious",
            label: "Search",
            color: "var(--ds-icon, #42526E)"
        }),
        analyticsContext: {
            actionSubjectId: 'navbarSearch'
        }
    }));
});
$96cee01fcc0dc34e$export$690bcf3a1f1e9f2f.displayName = 'SearchButton';
var $96cee01fcc0dc34e$export$2e2bcd8739ae039 = $96cee01fcc0dc34e$export$690bcf3a1f1e9f2f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $96cee01fcc0dc34e$var$StyledSearchIconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-tktwuw-0"
})`display:flex;height:${"var(--ds-space-400, 32px)"};width:${"var(--ds-space-400, 32px)"};align-items:stretch;background-color:${"var(--ds-surface-overlay, #EBECF0)"};border-radius:50%;flex-direction:column;justify-content:center;transform:translateZ(0);transition:transform 200ms,opacity 200ms;box-shadow:${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"};border:none;margin:${"var(--ds-space-150, 12px)"};padding:0;cursor:pointer;`;

});
parcelRegister("8K7DG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455ddf841838a21b0f783ea6448b0f9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01a4866150bfb54e$var$_react = $01a4866150bfb54e$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $01a4866150bfb54e$var$_iconNew = $01a4866150bfb54e$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $01a4866150bfb54e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $01a4866150bfb54e$var$SearchIcon = (props)=>/*#__PURE__*/ $01a4866150bfb54e$var$_react.default.createElement($01a4866150bfb54e$var$_iconNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$01a4866150bfb54e$var$SearchIcon.displayName = 'SearchIcon';
var $01a4866150bfb54e$var$_default = module.exports.default = $01a4866150bfb54e$var$SearchIcon;

});



parcelRegister("aWDCT", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsInlineDialog", () => $974c5800904e2f5f$export$4de18d88452d7a08);
$parcel$export(module.exports, "PortalAnalyticsModal", () => $974c5800904e2f5f$export$e80acabac337720d);
$parcel$export(module.exports, "PortalAnalyticsDrawer", () => $974c5800904e2f5f$export$3b1f159f4ab6aaae);

var $eENmG = parcelRequire("eENmG");

var $hIWb6 = parcelRequire("hIWb6");
function $974c5800904e2f5f$var$screenWithoutBrowserMetrics(name, sourceType, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes) {
    const analyticsWrapper = (0, $eENmG.withAnalyticsContext)({
        sourceType: sourceType,
        sourceName: name,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        attributes: {
            ...attributes,
            context: 'Portal'
        }
    });
    return (component)=>(0, $hIWb6.clearScreenName)(analyticsWrapper(component));
}
const $974c5800904e2f5f$export$4de18d88452d7a08 = (name, attributes)=>$974c5800904e2f5f$var$screenWithoutBrowserMetrics(name, (0, $eENmG.ScreenTypes).INLINE_DIALOG, attributes);
const $974c5800904e2f5f$export$e80acabac337720d = (name, attributes)=>$974c5800904e2f5f$var$screenWithoutBrowserMetrics(name, (0, $eENmG.ScreenTypes).MODAL, attributes);
const $974c5800904e2f5f$export$3b1f159f4ab6aaae = (name, attributes)=>$974c5800904e2f5f$var$screenWithoutBrowserMetrics(name, (0, $eENmG.ScreenTypes).DRAWER, attributes);

});

parcelRegister("iSFD9", function(module, exports) {
$parcel$export(module.exports, "useMounted", () => $e937c3da1df8e869$export$bce3bfec9f56c837);
$parcel$export(module.exports, "usePrevious", () => $e937c3da1df8e869$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useIsoMorphicLayoutEffect", () => $e937c3da1df8e869$export$3d58f1da4ac28ebc);

var $fc4bM = parcelRequire("fc4bM");
function $e937c3da1df8e869$export$bce3bfec9f56c837() {
    const referenceToMounted = $fc4bM.useRef(false);
    $fc4bM.useEffect(()=>{
        if (!referenceToMounted.current) referenceToMounted.current = true;
        return ()=>{
            if (referenceToMounted.current) referenceToMounted.current = false;
        };
    }, []);
    return referenceToMounted.current;
}
function $e937c3da1df8e869$export$5cae361ad82dce8b(value) {
    const referenceToValue = $fc4bM.useRef();
    $fc4bM.useEffect(()=>{
        referenceToValue.current = value;
    }, [
        value
    ]);
    return referenceToValue.current;
}
const $e937c3da1df8e869$export$3d58f1da4ac28ebc = (0, $fc4bM.useLayoutEffect);

});

parcelRegister("hCUGT", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => (parcelRequire("ehOS8")).InlineResultsContextProvider);
$parcel$export(module.exports, "useInlineResultsContext", () => (parcelRequire("ehOS8")).useInlineResultsContext);

var $ehOS8 = parcelRequire("ehOS8");

});
parcelRegister("ehOS8", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => $ae86104c80656c8a$export$55d16b7f4336c4d7);
$parcel$export(module.exports, "useInlineResultsContext", () => $ae86104c80656c8a$export$243a7c3fd4b96b3e);

var $fc4bM = parcelRequire("fc4bM");
const $ae86104c80656c8a$var$InlineResultsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(null);
const $ae86104c80656c8a$export$55d16b7f4336c4d7 = ({ children: children })=>{
    const [resultsCount, setResultsCount] = (0, $fc4bM.useState)(null);
    const updateSearchResultsCount = (0, $fc4bM.useCallback)((resourceType, resourceCount)=>setResultsCount((state)=>({
                ...state,
                [resourceType]: resourceCount
            })), [
        setResultsCount
    ]);
    const clearSearchResultsCount = (0, $fc4bM.useCallback)(()=>setResultsCount(null), [
        setResultsCount
    ]);
    const contextValue = (0, $fc4bM.useMemo)(()=>({
            resultsCount: resultsCount,
            clearSearchResultsCount: clearSearchResultsCount,
            updateSearchResultsCount: updateSearchResultsCount
        }), [
        resultsCount,
        clearSearchResultsCount,
        updateSearchResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ae86104c80656c8a$var$InlineResultsContext.Provider, {
        value: contextValue
    }, children);
};
const $ae86104c80656c8a$export$243a7c3fd4b96b3e = ()=>{
    const context = (0, $fc4bM.useContext)($ae86104c80656c8a$var$InlineResultsContext);
    if (!context) throw new Error('useInlineResultsContext must be used within InlineResultsContextProvider');
    return context;
};

});


parcelRegister("dRJCQ", function(module, exports) {
$parcel$export(module.exports, "SearchErrorBoundary", () => (parcelRequire("2PUk1")).default);

var $2PUk1 = parcelRequire("2PUk1");

});
parcelRegister("2PUk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a20720f179bbbc6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $aYMdQ = parcelRequire("aYMdQ");

var $cf3fd = parcelRequire("cf3fd");

var $hIWb6 = parcelRequire("hIWb6");

var $7lN8e = parcelRequire("7lN8e");

var $c0Y6o = parcelRequire("c0Y6o");
parcelRequire("akDDT");
var $5V9ux = parcelRequire("5V9ux");

var $89aYe = parcelRequire("89aYe");
const $8a20720f179bbbc6$var$SearchErrorBoundary = ({ screenName: screenName, id: id, children: children, renderError: renderError })=>{
    /**
   * If any error unrecoverable occurs inside search
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure using UFO
   */ const markExperienceFailed = (0, $fc4bM.useCallback)((error)=>{
        if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) {
            const metadata = {
                id: id,
                error: error === null || error === void 0 ? void 0 : error.message,
                failureEvent: screenName
            };
            (0, $89aYe.searchExperience).failure({
                metadata: metadata
            }).then((0, $aYMdQ.noop)).catch((0, $aYMdQ.noop));
            if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) (0, $89aYe.csmSearchExperience).failure({
                metadata: metadata
            }).then((0, $aYMdQ.noop)).catch((0, $aYMdQ.noop));
            (0, $89aYe.inlineSearchExperience).failure({
                metadata: metadata
            }).then((0, $aYMdQ.noop)).catch((0, $aYMdQ.noop));
        }
    }, [
        id,
        screenName
    ]);
    const defaultRenderError = (0, $fc4bM.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5V9ux.default), null);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: screenName,
        id: id,
        renderError: renderError ? renderError : defaultRenderError,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(children));
};
var $8a20720f179bbbc6$export$2e2bcd8739ae039 = (0, $hIWb6.default)($8a20720f179bbbc6$var$SearchErrorBoundary);

});
parcelRegister("akDDT", function(module, exports) {
$parcel$export(module.exports, "SearchResultError", () => (parcelRequire("5V9ux")).default);

var $5V9ux = parcelRequire("5V9ux");

});
parcelRegister("5V9ux", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a65d46389493ccd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fRgxR = parcelRequire("fRgxR");

var $1wGm1 = parcelRequire("1wGm1");

var $gpjDl = parcelRequire("gpjDl");

var $1hJdJ = parcelRequire("1hJdJ");

var $7yidP = parcelRequire("7yidP");

var $gioQl = parcelRequire("gioQl");
parcelRequire("4ZWZy");
var $cd2Ru = parcelRequire("cd2Ru");

var $aHyR5 = parcelRequire("aHyR5");
const $3a65d46389493ccd$var$SearchResultError = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1wGm1)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "xsmall"
    }, formatMessage((0, $aHyR5.default).searchErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("p", {
        style: {
            textAlign: 'center'
        }
    }, formatMessage((0, $aHyR5.default).searchErrorText, {
        helpCenterLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRgxR.default), {
            to: (0, $gioQl.getHelpCenterUrl)(),
            actionSubjectId: "helpCenterLink"
        }, formatMessage((0, $aHyR5.default).helpCenter))
    })));
};
var $3a65d46389493ccd$export$2e2bcd8739ae039 = $3a65d46389493ccd$var$SearchResultError;

});
parcelRegister("1wGm1", function(module, exports) {
module.exports = new URL("../images/search-modal-error.b0f67bec.svg", import.meta.url).toString();

});

parcelRegister("aHyR5", function(module, exports) {
$parcel$export(module.exports, "default", () => $332d44762ea11e25$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $332d44762ea11e25$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    searchErrorTitle: {
        defaultMessage: 'We couldn\u2019t load your search results',
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.error.title'
    },
    searchErrorText: {
        defaultMessage: 'Refresh the page and try again. Or go back to the { helpCenterLink }.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.error.message'
    },
    helpCenter: {
        defaultMessage: 'help center',
        description: 'Text to render help center link',
        id: 'cv.search.error.help-center'
    }
});

});



parcelRegister("89aYe", function(module, exports) {
$parcel$export(module.exports, "searchExperience", () => $5e84a233bb648afd$export$478fc2b872b7df27);
$parcel$export(module.exports, "csmSearchExperience", () => $5e84a233bb648afd$export$c32ff69c6cd0bb0b);
$parcel$export(module.exports, "inlineSearchExperience", () => $5e84a233bb648afd$export$e3eaed2128f58e6a);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $5e84a233bb648afd$export$478fc2b872b7df27 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.searchExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageLoad
});
const $5e84a233bb648afd$export$c32ff69c6cd0bb0b = new (0, $9LFKj.UFOExperience)('csm-help-center-search', {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $5e84a233bb648afd$export$e3eaed2128f58e6a = new (0, $9LFKj.UFOExperience)((0, $fCHdA.inlineSearchExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("7MlZR", function(module, exports) {
$parcel$export(module.exports, "SearchModal", () => (parcelRequire("6BTpW")).default);

var $6BTpW = parcelRequire("6BTpW");

});
parcelRegister("6BTpW", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e7c678290d5e47$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $2zWQA = parcelRequire("2zWQA");

var $3BiGe = parcelRequire("3BiGe");

var $6LH8a = parcelRequire("6LH8a");

var $fIzAI = parcelRequire("fIzAI");

var $6dipk = parcelRequire("6dipk");

var $h9AtO = parcelRequire("h9AtO");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $dOWZ7 = parcelRequire("dOWZ7");

var $4CgiI = parcelRequire("4CgiI");

var $cufVT = parcelRequire("cufVT");

var $5a4EU = parcelRequire("5a4EU");

var $jVMDF = parcelRequire("jVMDF");

var $lgMZ2 = parcelRequire("lgMZ2");

var $1zYKE = parcelRequire("1zYKE");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $2SWSA = parcelRequire("2SWSA");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $039iL = parcelRequire("039iL");

var $fzCD5 = parcelRequire("fzCD5");

var $4twPz = parcelRequire("4twPz");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
var $cd2Ru = parcelRequire("cd2Ru");
parcelRequire("8zDH6");
var $aCpsw = parcelRequire("aCpsw");
parcelRequire("3AYuL");
var $fQUMP = parcelRequire("fQUMP");
parcelRequire("l8mG7");
var $5nnCc = parcelRequire("5nnCc");

var $gw7Xx = parcelRequire("gw7Xx");

var $hN5YJ = parcelRequire("hN5YJ");
const $89e7c678290d5e47$var$SearchModal = ({ isOpen: isOpen, term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, isLoggedIn: isLoggedIn, portalId: portalId, projectId: projectId, onSearch: onSearch, onClose: onClose, onReturnFocus: onReturnFocus })=>{
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const showSearchResults = (0, $b52IZ.isValidSearchTerm)(term);
    const scope = portalId ? 'portal' : 'helpCenter';
    const cloudId = (0, $6LH8a.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $039iL.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const isVirtualAgentAvailableForPortal = scope === 'portal' && isVirtualAgentAvailableForProject;
    const isVirtualAgentAvailableForHelpCenter = scope === 'helpCenter' && isVSAOnHCEnabled;
    const isVirtualAgentAvailable = (isVirtualAgentAvailableForPortal || isVirtualAgentAvailableForHelpCenter) && !(0, $hN5YJ.isHideVsaEndpointsEnabled)();
    const onKeyUp = (0, $fc4bM.useCallback)((event)=>{
        if (event.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const [{ location: location }, { replace: replace }] = (0, $7lAXH.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $b52IZ.useQueryParams)();
    const { portalIds: portalIds, categoryIds: categoryIds } = queryStringParams;
    const portalIdAsNumber = (0, $b52IZ.getPortalIdAsNumber)(portalId);
    const showCategoryFilter = (0, $b52IZ.isSinglePortalSearch)(portalIdAsNumber);
    const onServiceDeskFilterChange = (0, $fc4bM.useCallback)((options)=>{
        const selectedPortalIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($6dipk))).stringify({
            ...queryStringParams,
            portalIds: selectedPortalIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const onCategoryFilterChange = (0, $fc4bM.useCallback)((options)=>{
        const selectedCategoryIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($6dipk))).stringify({
            ...queryStringParams,
            categoryIds: selectedCategoryIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const renderResults = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
            gap: "space.200",
            templateColumns: "1fr",
            alignItems: "center",
            xcss: $89e7c678290d5e47$var$responsiveStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null), showSearchResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), null, isVirtualAgentAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $89e7c678290d5e47$var$virtualBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fzCD5.VirtualAgentBanner), {
            cloudId: cloudId,
            portalId: portalId
        })), !isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
            xcss: $89e7c678290d5e47$var$filterStyles
        }, showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4twPz.default), {
            onChange: onCategoryFilterChange,
            portalId: portalIdAsNumber,
            projectId: projectId,
            categoryIds: categoryIds
        }), !showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gw7Xx.default), {
            onChange: onServiceDeskFilterChange,
            portalIds: portalIds
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5nnCc.SearchResult), {
            term: term
        })) : // Show empty query state if invalid search term
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aCpsw.SearchResultNone), {
            term: term
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4CgiI.default), {
        duration: "small",
        entranceDirection: "bottom"
    }, (fadeInProps)=>isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cufVT.default), {
            zIndex: (0, $2SWSA.layers).dialog()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            ...fadeInProps,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                width: '100vw',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: '100vh',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                position: 'fixed',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: '0px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                left: '0px'
            },
            role: "dialog",
            "aria-modal": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $h9AtO.default), {
            autoFocus: true,
            returnFocus: onReturnFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fIzAI.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dOWZ7.default), {
            shouldAllowClickThrough: false,
            isTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $kig2V.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: `calc(100% - ${(0, $cd2Ru.SEARCH_BAR_HEIGHT)})`
            }),
            onKeyUp: onKeyUp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fQUMP.SearchBar), {
            term: term,
            onChange: onSearch,
            onClose: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            id: "dynamic-search-result",
            "aria-live": "polite",
            "aria-atomic": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $kig2V.xcss)({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: (0, $cd2Ru.SEARCH_BAR_HEIGHT),
                backgroundColor: 'elevation.surface.overlay',
                paddingTop: 'space.300',
                paddingBottom: 'space.200',
                overflow: 'auto'
            })
        }, renderResults())))))));
};
var $89e7c678290d5e47$export$2e2bcd8739ae039 = (0, $6umft.default)((0, $2n2bS.createSelector)((0, $3BiGe.isLoggedIn), (state, { portalId: portalId })=>({
        portalId: portalId,
        projectId: (0, $2zWQA.getProjectId)(state, (0, $b52IZ.getPortalIdAsNumber)(portalId))
    }), (isLoggedIn, { portalId: portalId, projectId: projectId })=>({
        isLoggedIn: isLoggedIn,
        portalId: portalId,
        projectId: projectId
    })))($89e7c678290d5e47$var$SearchModal);
const $89e7c678290d5e47$var$virtualBannerStyles = (0, $kig2V.xcss)({
    marginBottom: 'space.200'
});
const $89e7c678290d5e47$var$filterStyles = (0, $kig2V.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.300'
});
const $89e7c678290d5e47$var$responsiveStyles = (0, $kig2V.xcss)({
    [(0, $1zYKE.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $1zYKE.media).above.md]: {
        gridTemplateColumns: '1fr 965px 1fr',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    }
});

});
parcelRegister("fIzAI", function(module, exports) {
$parcel$export(module.exports, "default", () => $400cff19ff6d0bdc$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");
parcelRequire("hzZg3");
var $6znAn = parcelRequire("6znAn");

var $6vGy3 = parcelRequire("6vGy3");
const $400cff19ff6d0bdc$export$38d08b04f5a0ce72 = /*#__PURE__*/ (0, $luz1X.default)((0, $6znAn.default)).withConfig({
    componentId: "sc-1eshvn8-0"
})`overflow:hidden;position:relative;box-sizing:border-box;padding-right:${(props)=>props.scrollbarWidth}px;`;
class $400cff19ff6d0bdc$export$2e2bcd8739ae039 extends $fc4bM.Component {
    componentDidMount() {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        if (!document.body) return;
        const scrollbarWidth = (0, $6vGy3.windowInnerWidth)() - (0, $6vGy3.bodyClientWidth)();
        this.setState({
            scrollbarWidth: scrollbarWidth,
            show: true
        });
    }
    render() {
        return this.state.show ? /*#__PURE__*/ $fc4bM.createElement($400cff19ff6d0bdc$export$38d08b04f5a0ce72, {
            scrollbarWidth: this.state.scrollbarWidth
        }) : null;
    }
    constructor(...args){
        super(...args), this.state = {
            scrollbarWidth: 0,
            show: false
        };
    }
}

});
parcelRegister("6vGy3", function(module, exports) {
$parcel$export(module.exports, "windowInnerWidth", () => $5be3094fba871cfe$export$c2f81cb82ec2bad8);
$parcel$export(module.exports, "bodyClientWidth", () => $5be3094fba871cfe$export$d31820d1c745406f);
const $5be3094fba871cfe$export$c2f81cb82ec2bad8 = ()=>window.innerWidth;
const $5be3094fba871cfe$export$d31820d1c745406f = ()=>document.body.clientWidth;

});


parcelRegister("h9AtO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7cf9317288443bc$export$2e2bcd8739ae039);

var $1pQ9c = parcelRequire("1pQ9c");

var $c7cf9317288443bc$export$2e2bcd8739ae039 = (0, $1pQ9c.default);

});
parcelRegister("1pQ9c", function(module, exports) {
$parcel$export(module.exports, "default", () => $108093a07ceeb3b1$export$2e2bcd8739ae039);

var $1ZwRz = parcelRequire("1ZwRz");

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");

var $4wLRI = parcelRequire("4wLRI");

var $fn5Aj = parcelRequire("fn5Aj");
var $108093a07ceeb3b1$var$FocusLockCombination = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4wLRI.default), (0, $hHCeM.default)({
        sideCar: (0, $fn5Aj.default),
        ref: ref
    }, props));
});
var $108093a07ceeb3b1$var$_ref = (0, $4wLRI.default).propTypes || {}, $108093a07ceeb3b1$var$sideCar = $108093a07ceeb3b1$var$_ref.sideCar, $108093a07ceeb3b1$var$propTypes = (0, $1ZwRz.default)($108093a07ceeb3b1$var$_ref, [
    "sideCar"
]);
$108093a07ceeb3b1$var$FocusLockCombination.propTypes = {};
var $108093a07ceeb3b1$export$2e2bcd8739ae039 = $108093a07ceeb3b1$var$FocusLockCombination;

});
parcelRegister("4wLRI", function(module, exports) {
$parcel$export(module.exports, "default", () => $34bf47a7ef291c67$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");


var $aewXc = parcelRequire("aewXc");

var $cX3YH = parcelRequire("cX3YH");

var $hoTVY = parcelRequire("hoTVY");

var $3bAOz = parcelRequire("3bAOz");

var $bUfpH = parcelRequire("bUfpH");
var $34bf47a7ef291c67$var$emptyArray = [];
var $34bf47a7ef291c67$var$FocusLock = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $fc4bM.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $fc4bM.useRef)();
    var isActive = (0, $fc4bM.useRef)(false);
    var originalFocusedElement = (0, $fc4bM.useRef)(null);
    var _useState2 = (0, $fc4bM.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $34bf47a7ef291c67$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $fc4bM.useState)({}), id = _useState3[0];
    var onActivation = (0, $fc4bM.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $fc4bM.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $fc4bM.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $fc4bM.useCallback)(function(event) {
        if (isActive.current) (0, $3bAOz.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $3bAOz.mediumBlur).useMedium;
    var setObserveNode = (0, $fc4bM.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $hHCeM.default)((_extends2 = {}, _extends2[0, $aewXc.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $aewXc.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $cX3YH.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $fc4bM.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $hoTVY.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $hoTVY.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(SideCar, {
        id: id,
        sideCar: (0, $3bAOz.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Container, (0, $hHCeM.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bUfpH.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $hoTVY.hiddenGuard)
    }));
});
$34bf47a7ef291c67$var$FocusLock.propTypes = {};
var $34bf47a7ef291c67$export$2e2bcd8739ae039 = $34bf47a7ef291c67$var$FocusLock;

});
parcelRegister("hoTVY", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $cab010e527eb8bc6$export$b8c7b07253306600);

var $fc4bM = parcelRequire("fc4bM");

var $cab010e527eb8bc6$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $cab010e527eb8bc6$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cab010e527eb8bc6$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cab010e527eb8bc6$export$b8c7b07253306600
    }));
};
$cab010e527eb8bc6$var$InFocusGuard.propTypes = {};
var $cab010e527eb8bc6$export$2e2bcd8739ae039 = $cab010e527eb8bc6$var$InFocusGuard;

});

parcelRegister("3bAOz", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $251ef4c91572b2cf$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $251ef4c91572b2cf$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $251ef4c91572b2cf$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $251ef4c91572b2cf$export$892cbf28e5518020);

var $cNH4A = parcelRequire("cNH4A");
var $251ef4c91572b2cf$export$5733e022b1d538cb = (0, $cNH4A.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $251ef4c91572b2cf$export$b3e9a9312f73723c = (0, $cNH4A.createMedium)();
var $251ef4c91572b2cf$export$3a1d52767cbc07b8 = (0, $cNH4A.createMedium)();
var $251ef4c91572b2cf$export$892cbf28e5518020 = (0, $cNH4A.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("bUfpH", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $8ab0e177f95bb7b7$export$f5272e9b1168239c);

var $fc4bM = parcelRequire("fc4bM");
var $8ab0e177f95bb7b7$export$f5272e9b1168239c = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});


parcelRegister("fn5Aj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b30d5602258ab7b2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");


var $dJZsV = parcelRequire("dJZsV");

var $iEqyx = parcelRequire("iEqyx");
var $2SNXc = parcelRequire("2SNXc");
var $4rG4M = parcelRequire("4rG4M");
var $dz9ox = parcelRequire("dz9ox");
var $4WkHe = parcelRequire("4WkHe");
var $lMJgD = parcelRequire("lMJgD");parcelRequire("aAMOh");
var $gSulF = parcelRequire("gSulF");

var $5ooqK = parcelRequire("5ooqK");

var $3bAOz = parcelRequire("3bAOz");
var $b30d5602258ab7b2$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $b30d5602258ab7b2$var$isFreeFocus = function isFreeFocus() {
    return $b30d5602258ab7b2$var$focusOnBody() || (0, $4WkHe.focusIsHidden)();
};
var $b30d5602258ab7b2$var$lastActiveTrap = null;
var $b30d5602258ab7b2$var$lastActiveFocus = null;
var $b30d5602258ab7b2$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $b30d5602258ab7b2$var$lastPortaledElement = null;
var $b30d5602258ab7b2$var$focusWasOutsideWindow = false;
var $b30d5602258ab7b2$var$windowFocused = false;
var $b30d5602258ab7b2$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $b30d5602258ab7b2$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($b30d5602258ab7b2$var$lastActiveTrap.whiteList || $b30d5602258ab7b2$var$defaultWhitelist)(activeElement);
};
var $b30d5602258ab7b2$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $b30d5602258ab7b2$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $b30d5602258ab7b2$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $b30d5602258ab7b2$var$lastPortaledElement && $b30d5602258ab7b2$var$lastPortaledElement.portaledElement === element;
};
function $b30d5602258ab7b2$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $b30d5602258ab7b2$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($b30d5602258ab7b2$var$focusWasOutsideWindow);
    return $b30d5602258ab7b2$var$focusWasOutsideWindow === 'meanwhile';
};
var $b30d5602258ab7b2$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $b30d5602258ab7b2$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $b30d5602258ab7b2$var$checkInHost(activeElement, area, area);
    });
};
var $b30d5602258ab7b2$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $lMJgD.getFocusableNodes)(nodes, new Map());
};
var $b30d5602258ab7b2$var$isNotFocusable = function isNotFocusable(node) {
    return !$b30d5602258ab7b2$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $b30d5602258ab7b2$var$activateTrap = function activateTrap() {
    var result = false;
    if ($b30d5602258ab7b2$var$lastActiveTrap) {
        var _lastActiveTrap = $b30d5602258ab7b2$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $b30d5602258ab7b2$var$lastPortaledElement && $b30d5602258ab7b2$var$lastPortaledElement.portaledElement;
        if ($b30d5602258ab7b2$var$focusOnBody() && $b30d5602258ab7b2$var$lastActiveFocus && $b30d5602258ab7b2$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($b30d5602258ab7b2$var$lastActiveFocus) || $b30d5602258ab7b2$var$isNotFocusable($b30d5602258ab7b2$var$lastActiveFocus)) {
                var newTarget = $b30d5602258ab7b2$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $5ooqK.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$b30d5602258ab7b2$var$focusWasOutside(crossFrame) || !noFocusGuards || !$b30d5602258ab7b2$var$lastActiveFocus || $b30d5602258ab7b2$var$windowFocused) return false;
                var nodes = $b30d5602258ab7b2$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $b30d5602258ab7b2$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $b30d5602258ab7b2$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$b30d5602258ab7b2$var$isFreeFocus() || !$b30d5602258ab7b2$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $dz9ox.focusInside)(workingArea) || activeElement && $b30d5602258ab7b2$var$withinHost(activeElement, workingArea) || $b30d5602258ab7b2$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$b30d5602258ab7b2$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $gSulF.moveFocusInside)(workingArea, $b30d5602258ab7b2$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $b30d5602258ab7b2$var$lastPortaledElement = {};
                        }
                    }
                    $b30d5602258ab7b2$var$lastActiveFocus = document && document.activeElement;
                    if ($b30d5602258ab7b2$var$lastActiveFocus !== document.body) $b30d5602258ab7b2$var$tryRestoreFocus = (0, $iEqyx.captureFocusRestore)($b30d5602258ab7b2$var$lastActiveFocus);
                    $b30d5602258ab7b2$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2SNXc.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $b30d5602258ab7b2$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $b30d5602258ab7b2$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $b30d5602258ab7b2$var$onTrap = function onTrap(event) {
    if ($b30d5602258ab7b2$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $b30d5602258ab7b2$var$onBlur = function onBlur() {
    return (0, $5ooqK.deferAction)($b30d5602258ab7b2$var$activateTrap);
};
var $b30d5602258ab7b2$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $b30d5602258ab7b2$var$recordPortal(currentNode, source);
};
var $b30d5602258ab7b2$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $b30d5602258ab7b2$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        onBlur: $b30d5602258ab7b2$var$onBlur,
        onFocus: $b30d5602258ab7b2$var$onFocus
    }, children);
};
$b30d5602258ab7b2$var$FocusTrap.propTypes = {};
var $b30d5602258ab7b2$var$onWindowFocus = function onWindowFocus() {
    $b30d5602258ab7b2$var$windowFocused = true;
};
var $b30d5602258ab7b2$var$onWindowBlur = function onWindowBlur() {
    $b30d5602258ab7b2$var$windowFocused = false;
    $b30d5602258ab7b2$var$focusWasOutsideWindow = 'just';
    (0, $5ooqK.deferAction)(function() {
        $b30d5602258ab7b2$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $b30d5602258ab7b2$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $b30d5602258ab7b2$var$onTrap);
    document.addEventListener('focusout', $b30d5602258ab7b2$var$onBlur);
    window.addEventListener('focus', $b30d5602258ab7b2$var$onWindowFocus);
    window.addEventListener('blur', $b30d5602258ab7b2$var$onWindowBlur);
};
var $b30d5602258ab7b2$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $b30d5602258ab7b2$var$onTrap);
    document.removeEventListener('focusout', $b30d5602258ab7b2$var$onBlur);
    window.removeEventListener('focus', $b30d5602258ab7b2$var$onWindowFocus);
    window.removeEventListener('blur', $b30d5602258ab7b2$var$onWindowBlur);
};
function $b30d5602258ab7b2$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $b30d5602258ab7b2$var$focusLockAPI = {
    moveFocusInside: (0, $gSulF.moveFocusInside),
    focusInside: (0, $dz9ox.focusInside),
    focusNextElement: (0, $4rG4M.focusNextElement),
    focusPrevElement: (0, $4rG4M.focusPrevElement),
    focusFirstElement: (0, $4rG4M.focusFirstElement),
    focusLastElement: (0, $4rG4M.focusLastElement),
    captureFocusRestore: (0, $iEqyx.captureFocusRestore)
};
function $b30d5602258ab7b2$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$b30d5602258ab7b2$var$lastActiveTrap) $b30d5602258ab7b2$var$attachHandler();
    var lastTrap = $b30d5602258ab7b2$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $b30d5602258ab7b2$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $b30d5602258ab7b2$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($b30d5602258ab7b2$var$focusLockAPI);
        $b30d5602258ab7b2$var$activateTrap(true);
        (0, $5ooqK.deferAction)($b30d5602258ab7b2$var$activateTrap);
    } else {
        $b30d5602258ab7b2$var$detachHandler();
        $b30d5602258ab7b2$var$lastActiveFocus = null;
    }
}
(0, $3bAOz.mediumFocus).assignSyncMedium($b30d5602258ab7b2$var$onFocus);
(0, $3bAOz.mediumBlur).assignMedium($b30d5602258ab7b2$var$onBlur);
(0, $3bAOz.mediumEffect).assignMedium(function(cb) {
    return cb($b30d5602258ab7b2$var$focusLockAPI);
});
var $b30d5602258ab7b2$export$2e2bcd8739ae039 = (0, $dJZsV.default)($b30d5602258ab7b2$var$reducePropsToState, $b30d5602258ab7b2$var$handleStateChangeOnClient)($b30d5602258ab7b2$var$FocusWatcher);

});
parcelRegister("5ooqK", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $3ed225094885b0b9$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $3ed225094885b0b9$export$c613fed06e332533);
function $3ed225094885b0b9$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $3ed225094885b0b9$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $3ed225094885b0b9$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("jVMDF", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $6fc707ccef1c2673$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $hg0W2 = parcelRequire("hg0W2");

var $2FCAn = parcelRequire("2FCAn");
function $6fc707ccef1c2673$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6fc707ccef1c2673$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $6fc707ccef1c2673$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $6fc707ccef1c2673$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $6fc707ccef1c2673$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $6fc707ccef1c2673$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $6fc707ccef1c2673$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $6fc707ccef1c2673$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $6fc707ccef1c2673$var$baseStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$6fc707ccef1c2673$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$6fc707ccef1c2673$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$6fc707ccef1c2673$var$gridTemplateRowsVar})`
});
const $6fc707ccef1c2673$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $6fc707ccef1c2673$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $hg0W2.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $fc4bM.useMemo)(()=>({
            [$6fc707ccef1c2673$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$6fc707ccef1c2673$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$6fc707ccef1c2673$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $6fc707ccef1c2673$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $2FCAn.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $2FCAn.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $2FCAn.spaceStylesMap).rowGap[rowGap],
            alignItems && $6fc707ccef1c2673$var$alignItemsMap[alignItems],
            alignContent && $6fc707ccef1c2673$var$alignContentMap[alignContent],
            justifyContent && $6fc707ccef1c2673$var$justifyContentMap[justifyContent],
            autoFlow && $6fc707ccef1c2673$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$6fc707ccef1c2673$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("039iL", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentAvailability", () => $521ed0bd5bbf47b2$export$4cf57cfa614a5585);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $eENmG = parcelRequire("eENmG");

var $c0Y6o = parcelRequire("c0Y6o");
const $521ed0bd5bbf47b2$var$initialState = {
    isVirtualAgentAvailable: false,
    isVirtualAgentEnabled: false,
    isLoading: true
};
const $521ed0bd5bbf47b2$var$reducer = (state, action)=>{
    switch(action.type){
        case 'RESET':
            return {
                ...$521ed0bd5bbf47b2$var$initialState,
                isLoading: false
            };
        case 'LOAD_AVAILABLITY':
            return $521ed0bd5bbf47b2$var$initialState;
        case 'SET_AVAILABILITY':
            return {
                isVirtualAgentAvailable: action.isVirtualAgentAvailable,
                isVirtualAgentEnabled: action.isVirtualAgentEnabled,
                isLoading: false
            };
        default:
            return state;
    }
};
const $521ed0bd5bbf47b2$export$4cf57cfa614a5585 = ({ isLoggedIn: isLoggedIn, projectId: projectId, cloudId: cloudId, baseUrl: baseUrl = '' })=>{
    const [{ isVirtualAgentAvailable: isVirtualAgentAvailable, isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isLoading }, dispatch] = (0, $fc4bM.useReducer)($521ed0bd5bbf47b2$var$reducer, $521ed0bd5bbf47b2$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        const canAccess = isLoggedIn;
        if (!canAccess) {
            dispatch({
                type: 'RESET'
            });
            return;
        }
        if (projectId === undefined) {
            dispatch({
                type: 'LOAD_AVAILABLITY'
            });
            return;
        }
        dispatch({
            type: 'LOAD_AVAILABLITY'
        });
        (0, $c0Y6o.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${encodeURIComponent(cloudId)}/public/api/v1/virtualagent/byprojectid/${encodeURIComponent(projectId)}/availability`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: true,
                isVirtualAgentEnabled: response.isVirtualAgentEnabled
            });
        }).catch((err)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: false,
                isVirtualAgentEnabled: false
            });
            if ('status' in err && typeof err.status === 'number' && err.status === 403) // AI is disabled or the user lacks permission, so this is not an error
            return;
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'virtualAgentAvailability',
                attributes: {
                    error: err.message
                }
            }).fire();
        });
    }, [
        createAnalyticsEvent,
        baseUrl,
        isLoggedIn,
        cloudId,
        projectId
    ]);
    return {
        isVirtualAgentAvailable: isVirtualAgentAvailable,
        isLoading: isLoading,
        isVirtualAgentEnabled: isVirtualAgentEnabled
    };
};

});

parcelRegister("fzCD5", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBanner", () => $392cec241eaff8f7$export$c79d8d330f0b0297);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $jEubQ = parcelRequire("jEubQ");

var $kTVlm = parcelRequire("kTVlm");

var $1hJdJ = parcelRequire("1hJdJ");

var $3UAb3 = parcelRequire("3UAb3");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $lgMZ2 = parcelRequire("lgMZ2");

var $eENmG = parcelRequire("eENmG");

var $lvRbB = parcelRequire("lvRbB");

var $2HXYW = parcelRequire("2HXYW");
const $392cec241eaff8f7$export$c79d8d330f0b0297 = ({ cloudId: cloudId, portalId: portalId })=>{
    const scope = portalId ? 'portal' : 'helpCenter';
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const [, { push: push }] = (0, $7lAXH.useRouter)();
    const chatWithVirtualAgentForPortal = (0, $fc4bM.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/66942
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButton'
        }).fire();
        if (portalId) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push(`/portal/${portalId}/conversation`);
    }, [
        push,
        portalId,
        createAnalyticsEvent
    ]);
    const chatWithVirtualAgentForHelpCenter = (0, $fc4bM.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButtonOnHelpCenter'
        }).fire();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        push,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $392cec241eaff8f7$var$containerStyles,
        role: "status",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        spread: "space-between",
        space: "space.100",
        xcss: $392cec241eaff8f7$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $2HXYW.default).virtualAgentBannerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($392cec241eaff8f7$var$Message, null, formatMessage((0, $2HXYW.default).virtualServiceAgentEAPBannerDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))), {
            label: ""
        }),
        appearance: "primary",
        onClick: scope === 'portal' ? chatWithVirtualAgentForPortal : chatWithVirtualAgentForHelpCenter
    }, formatMessage((0, $2HXYW.default).buttonTextV2))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvRbB.FireScreenEventOnMount), {
        customData: {
            name: 'virtualAgentBanner',
            attributes: {
                cloudId: cloudId,
                portalId: portalId,
                state: 'visible'
            }
        }
    }));
};
const $392cec241eaff8f7$var$containerStyles = (0, $kig2V.xcss)({
    background: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    padding: 'space.300',
    borderRadius: 'radius.small'
});
const $392cec241eaff8f7$var$contentStyles = (0, $kig2V.xcss)({
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $392cec241eaff8f7$var$Message = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lvRbB", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMount", () => $cbcad6957e659cf3$export$787df3507b9eb1ae);

var $7OpLR = parcelRequire("7OpLR");

var $hIWb6 = parcelRequire("hIWb6");
const $cbcad6957e659cf3$export$787df3507b9eb1ae = (0, $hIWb6.default)((0, $7OpLR.FireScreenEventOnMountStateless));
// Manually set the display name for sensible snapshots
$cbcad6957e659cf3$export$787df3507b9eb1ae.displayName = 'FireScreenEventOnMount';

});
parcelRegister("7OpLR", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMountStateless", () => $f57c641f90fe8aba$export$641a363dc7c73107);

var $fc4bM = parcelRequire("fc4bM");

var $16GaT = parcelRequire("16GaT");

var $aVQWM = parcelRequire("aVQWM");

var $2Mveg = parcelRequire("2Mveg");

var $1NC3I = parcelRequire("1NC3I");

var $jgb8T = parcelRequire("jgb8T");

var $aZfc9 = parcelRequire("aZfc9");

var $4MjGQ = parcelRequire("4MjGQ");
class $f57c641f90fe8aba$export$641a363dc7c73107 extends $fc4bM.Component {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement((0, $2Mveg.MountEvent), {
            onMount: this.onMount,
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            key: `${this.props.screenName}-${this.props.screenId}`
        });
    }
    constructor(...args){
        super(...args), this.endBrowserMetricsV3 = (screenName)=>{
            const { customData: customData } = this.props;
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const metric = (0, $1NC3I.default)[screenName];
            /**
     * This is used to support the previously created performance mark
     */ (0, $aZfc9.perfMark)('second.data.loaded');
            (0, $jgb8T.devLog)('Browser Metrics v3: ending timer and firing event for screen:', screenName);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            metric.stop({
                customData: customData
            });
        }, this.onMount = (analyticsEvent)=>{
            const { screenName: screenName } = this.props;
            (0, $16GaT.fireScreenAnalytics)(analyticsEvent, (0, $4MjGQ.AnalyticsTrackActions).VIEWED);
            /**
     * Fire jsm-ui viewed event along with screen event
     * 1. This is done to for anti abuse spam work to detect human or bot spam
     * 2. We are firing this instead of `ui viewed` because that event is used for overall Atlassian MAU calculations.
     * 3. Event registration -> https://data-portal.internal.atlassian.com/analytics/registry/59264?tabIndex=Details
     */ const uiAnalyticsEvent = analyticsEvent.clone();
            (0, $16GaT.fireAnalytics)(uiAnalyticsEvent, (0, $aVQWM.UI_EVENT_TYPE), {
                actionSubject: 'jsm-ui',
                action: (0, $4MjGQ.AnalyticsTrackActions).VIEWED
            });
            /**
     * Trigger Stop timer for for Page load metric only if
     * 1. screenName exists
     * 2. metrics is instrumented for that screen
     * 3. BM3 feature flag is enabled
     */ if (screenName && (0, $1NC3I.isPageLoadInstrumented)(screenName)) this.endBrowserMetricsV3(screenName);
        };
    }
}

});
parcelRegister("2Mveg", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $8e3f47f2b3a60b1a$export$2c6963927dbc68f1);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");
class $8e3f47f2b3a60b1a$var$MountEventComponent extends (0, $fc4bM.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $8e3f47f2b3a60b1a$var$MountEventComponentWithHOC = (0, $azARG.default)()($8e3f47f2b3a60b1a$var$MountEventComponent);
const $8e3f47f2b3a60b1a$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8e3f47f2b3a60b1a$var$MountEventComponentWithHOC, props);

});



parcelRegister("2HXYW", function(module, exports) {
$parcel$export(module.exports, "default", () => $91530059298a1e76$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $91530059298a1e76$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    virtualAgentBannerHeading: {
        defaultMessage: 'Spend less time hunting for the right request form',
        description: 'Heading in section message displayed when user is on the portal and virtual service agent search is turned on.',
        id: 'virtual-agent.virtual-agent-banner-heading'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    virtualServiceAgentEAPBannerDescription: {
        defaultMessage: 'Ask any question and give our AI-powered virtual service agent a try.',
        description: 'Desription in section message displayed when user is on the portal and virtual service agent search is turned on for EAP.',
        id: 'virtual-agent.virtual-service-agent-EAP-banner-description'
    },
    iconAlt: {
        defaultMessage: 'Atlassian Intelligence',
        description: 'Alternative text for Atlassian Intelligence logo.',
        id: 'virtual-agent.virtual-agent-banner-icon-alt'
    },
    buttonTextV2: {
        defaultMessage: 'Chat with virtual service agent',
        description: 'Text for button which will take the user to the virtual agent conversation page.',
        id: 'virtual-agent.virtual-agent-banner-button-text-v-2'
    }
});

});


parcelRegister("4twPz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab4c811deb7ccd3e$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("5xojH");
var $l81MK = parcelRequire("l81MK");

var $2zWQA = parcelRequire("2zWQA");

var $5nUxk = parcelRequire("5nUxk");
const $ab4c811deb7ccd3e$var$selector = (0, $2n2bS.createSelector)((state, props)=>(0, $2zWQA.getCategories)(state, props.portalId), (maybeCategories)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories
    };
});
const $ab4c811deb7ccd3e$var$CategoryFilter = (0, $6umft.default)($ab4c811deb7ccd3e$var$selector, {
    fetchCategories: (0, $l81MK.fetchCategoriesAction)
})((0, $5nUxk.default));
var $ab4c811deb7ccd3e$export$2e2bcd8739ae039 = $ab4c811deb7ccd3e$var$CategoryFilter;

});
parcelRegister("5nUxk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b465ec04a014d64e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("3jC5I");
var $lIb0m = parcelRequire("lIb0m");

var $fGE0T = parcelRequire("fGE0T");
const $b465ec04a014d64e$var$CategoryFilter = ({ portalId: portalId, fetchCategories: fetchCategories, categories: categories, categoryIds: categoryIds, onChange: onChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [values, _] = $fc4bM.useState(categoryIds ?? []);
    $fc4bM.useEffect(()=>{
        if (!projectId || !portalId) return;
        fetchCategories(projectId, portalId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectId,
        portalId
    ]);
    const options = $fc4bM.useMemo(()=>{
        return categories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories
    ]);
    const preSelectedOptions = $fc4bM.useMemo(()=>{
        const preselectedCategories = categories.filter((category)=>values.find((id)=>id === category.id));
        return preselectedCategories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories,
        values
    ]);
    return categories.length > 1 ? /*#__PURE__*/ $fc4bM.createElement((0, $lIb0m.default), {
        fieldId: "category_filter",
        fieldLabel: formatMessage((0, $fGE0T.default).categoryFilter),
        testId: "categoryFilter",
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange
    }) : null;
};
var $b465ec04a014d64e$export$2e2bcd8739ae039 = $b465ec04a014d64e$var$CategoryFilter;

});
parcelRegister("3jC5I", function(module, exports) {
$parcel$export(module.exports, "SimplePicker", () => (parcelRequire("lIb0m")).default);

var $lIb0m = parcelRequire("lIb0m");

});
parcelRegister("lIb0m", function(module, exports) {
$parcel$export(module.exports, "default", () => $c868b4a100d4dc38$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $iwMlR = parcelRequire("iwMlR");

var $aYMdQ = parcelRequire("aYMdQ");

var $3TJLC = parcelRequire("3TJLC");
const $c868b4a100d4dc38$export$a250605dcad5aca0 = (str, toMatch)=>{
    if (!str) return false;
    return toMatch ? str.toLowerCase().includes(toMatch.toLowerCase()) : true;
};
const $c868b4a100d4dc38$export$60d56ed3961c839c = (0, $aYMdQ.memoize)((options, searchText)=>{
    if ((0, $aYMdQ.isEmpty)(searchText)) return options;
    const filteredOptions = [];
    for (const option of options)if ($c868b4a100d4dc38$export$a250605dcad5aca0(option.label, searchText)) filteredOptions.push(option);
    return filteredOptions;
}, (...args)=>JSON.stringify(args));
const $c868b4a100d4dc38$var$Picker = ({ options: options, preSelectedOptions: preSelectedOptions, onChange: onChange, fieldId: fieldId, testId: testId, fieldLabel: fieldLabel })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [selectedValues, setSelectedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(preSelectedOptions ?? []);
    const onPickerTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        setIsOpen(true);
    }, []);
    const onClose = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        setIsOpen(false);
    }, []);
    const onFilterChange = (0, $fc4bM.useCallback)((selectedOptions)=>{
        onChange(selectedOptions);
        setSelectedValues(selectedOptions);
    }, [
        onChange
    ]);
    const onFilterClearValues = (0, $fc4bM.useCallback)(()=>{
        onChange([]);
        setSelectedValues([]);
    }, [
        onChange
    ]);
    const onLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((search, _enableFullList, _showFullList, _showMore, _lastOption, cb)=>{
        const filteredOptions = $c868b4a100d4dc38$export$60d56ed3961c839c(options, search);
        cb({
            options: filteredOptions,
            totalCount: filteredOptions.length
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: fieldId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iwMlR.default), {
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        isOpen: isOpen,
        value: selectedValues,
        enablePagination: false,
        onOpen: onOpen,
        onClose: onClose,
        onChange: onFilterChange,
        onLoadOptions: onLoadOptions,
        onClearValues: onFilterClearValues,
        onPickerTriggerClick: onPickerTriggerClick,
        testId: testId
    }));
};
var $c868b4a100d4dc38$export$2e2bcd8739ae039 = $c868b4a100d4dc38$var$Picker;

});
parcelRegister("iwMlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $970f5e6b50885c50$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $h1owE = parcelRequire("h1owE");

var $3B0Nu = parcelRequire("3B0Nu");

var $k9qaS = parcelRequire("k9qaS");
const $970f5e6b50885c50$var$PaginatedFilter = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, value: value, fieldId: fieldId, fieldLabel: fieldLabel, onChange: onChange, onLoadOptions: onLoadOptions, onClearValues: onClearValues, onPickerTriggerClick: onPickerTriggerClick, testId: testId, enablePagination: enablePagination = true } = props;
    const paginationConfig = enablePagination ? {
        enableFullList: false
    } : undefined;
    const onTrigger = $fc4bM.useCallback(({ ref: ref })=>{
        return /*#__PURE__*/ $fc4bM.createElement((0, $k9qaS.default), {
            hasValues: value.length > 0,
            onClick: onPickerTriggerClick,
            isSelected: isOpen,
            isInvalid: value.some((val)=>val.invalid),
            ref: ref,
            testId: testId
        }, (0, $3B0Nu.formatLabel)(fieldLabel, value));
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        value,
        onOpen,
        isOpen,
        fieldLabel,
        onPickerTriggerClick
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($970f5e6b50885c50$var$PaginatedFilterWrapper, null, /*#__PURE__*/ $fc4bM.createElement((0, $h1owE.Picker), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: value,
        pagination: paginationConfig,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onChange: onChange,
        onLoadOptions: onLoadOptions,
        onTrigger: onTrigger,
        onClearValues: onClearValues
    }));
};
var $970f5e6b50885c50$export$2e2bcd8739ae039 = $970f5e6b50885c50$var$PaginatedFilter;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $970f5e6b50885c50$var$PaginatedFilterWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-6q3nln-0"
})`display:flex;`;

});
parcelRegister("h1owE", function(module, exports) {
$parcel$export(module.exports, "Picker", () => $bda6f2e38e902c96$export$ba25329847403e11);

var $fc4bM = parcelRequire("fc4bM");

var $4EPUx = parcelRequire("4EPUx");

var $8CUOw = parcelRequire("8CUOw");

var $a7MCo = parcelRequire("a7MCo");

var $6kNwQ = parcelRequire("6kNwQ");

var $iTo7X = parcelRequire("iTo7X");
const $bda6f2e38e902c96$export$ba25329847403e11 = ({ ariaLabel: ariaLabel, isOpen: isOpen, value: value, onClose: onClose, onClearValues: onClearValues, fieldId: fieldId, fieldLabel: fieldLabel, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $6kNwQ.default), onLoadOptions: onLoadOptions, pagination: pagination, PopupComponent: PopupComponent, onTrigger: onTrigger, hideClearSelection: hideClearSelection, initiallyAddSelectedFirst: initiallyAddSelectedFirst = true, isMulti: isMulti = true, showFooter: showFooter = true, popupProps: popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8CUOw.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iTo7X.DialogInner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $a7MCo.default), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                hideClearSelection: hideClearSelection,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                isMulti: isMulti,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            })),
        ...popupProps
    }));

});
parcelRegister("8CUOw", function(module, exports) {
$parcel$export(module.exports, "PaginatedPickerIntlProvider", () => $1cb466d2113caddd$export$b61655080b0a1f32);

var $fc4bM = parcelRequire("fc4bM");

var $8MaoS = parcelRequire("8MaoS");
var $gpjDl = parcelRequire("gpjDl");

var $7u5vH = parcelRequire("7u5vH");
const $1cb466d2113caddd$var$i18n = $7u5vH;
const $1cb466d2113caddd$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
const $1cb466d2113caddd$export$b61655080b0a1f32 = ({ children: children })=>{
    const intl = (0, $gpjDl.default)();
    const { language: language, country: country } = $1cb466d2113caddd$var$getCodesFromLocale(intl.locale.toString());
    const messages = $1cb466d2113caddd$var$i18n[`${language}_${country}`] || $1cb466d2113caddd$var$i18n[language] || $1cb466d2113caddd$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};

});
parcelRegister("7u5vH", function(module, exports) {
$parcel$export(module.exports, "cs", () => (parcelRequire("bfK6k")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("9evU3")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("eOGRO")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("kNAzI")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("gj2Tx")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("3i6Lq")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("ck7YE")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("a9QMV")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("lsexj")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("8wPTU")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("1JHGg")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("2fFOg")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("18n74")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("85b2N")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("dwnFJ")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("3D0sf")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("591Pq")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("eYcOF")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("flvag")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("1Qwee")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("Shrlp")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("caOj2")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("fkLYz")).default);
$parcel$export(module.exports, "zh", () => (parcelRequire("7QyW3")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("2bQkq")).default);

var $bfK6k = parcelRequire("bfK6k");

var $9evU3 = parcelRequire("9evU3");

var $eOGRO = parcelRequire("eOGRO");

var $kNAzI = parcelRequire("kNAzI");

var $gj2Tx = parcelRequire("gj2Tx");

var $3i6Lq = parcelRequire("3i6Lq");

var $ck7YE = parcelRequire("ck7YE");

var $a9QMV = parcelRequire("a9QMV");

var $lsexj = parcelRequire("lsexj");

var $8wPTU = parcelRequire("8wPTU");

var $1JHGg = parcelRequire("1JHGg");

var $2fFOg = parcelRequire("2fFOg");

var $18n74 = parcelRequire("18n74");

var $85b2N = parcelRequire("85b2N");

var $dwnFJ = parcelRequire("dwnFJ");

var $3D0sf = parcelRequire("3D0sf");

var $591Pq = parcelRequire("591Pq");

var $eYcOF = parcelRequire("eYcOF");

var $flvag = parcelRequire("flvag");

var $1Qwee = parcelRequire("1Qwee");

var $Shrlp = parcelRequire("Shrlp");

var $caOj2 = parcelRequire("caOj2");

var $fkLYz = parcelRequire("fkLYz");

var $7QyW3 = parcelRequire("7QyW3");

var $2bQkq = parcelRequire("2bQkq");

});
parcelRegister("bfK6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa6600869ceb7636$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lfLPQ = parcelRequire("lfLPQ");
var $fa6600869ceb7636$export$2e2bcd8739ae039 = (0, $lfLPQ.default);

});
parcelRegister("lfLPQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b48cc2caeace986$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Czech
var $9b48cc2caeace986$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Zru\u0161it v\xfdb\u011Br",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Na\u010Dten\xed dat se nezda\u0159ilo.",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Kliknut\xedm opakovat",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Na\u010D\xedt\xe1n\xed\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Zobrazit v\xedce",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} v\xfdsledk\u016F",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} z\xa0{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    "paginated-picker.async-select.select.option.error-message": "Na\u010Dten\xed dat se nezda\u0159ilo.",
    "paginated-picker.async-select.select.option.retry-message": "Kliknut\xedm opakovat",
    "paginated-picker.async-select.select.search-placeholder": "Vyhledat",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Zobrazit \xfapln\xfd seznam"
};

});


parcelRegister("9evU3", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd2e92c13b6de9e3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hyOKl = parcelRequire("hyOKl");
var $cd2e92c13b6de9e3$export$2e2bcd8739ae039 = (0, $hyOKl.default);

});
parcelRegister("hyOKl", function(module, exports) {
$parcel$export(module.exports, "default", () => $27f90c1be6d4850a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Danish (Denmark)
var $27f90c1be6d4850a$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Ryd valgte",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Data kunne ikke hentes",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klik for at pr\xf8ve igen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Indl\xe6ser ...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Vis mere",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultater",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} af {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Ingen match fundet",
    "paginated-picker.async-select.select.option.error-message": "Data kunne ikke hentes",
    "paginated-picker.async-select.select.option.retry-message": "Klik for at pr\xf8ve igen",
    "paginated-picker.async-select.select.search-placeholder": "S\xf8g",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Vis hele listen"
};

});


parcelRegister("eOGRO", function(module, exports) {
$parcel$export(module.exports, "default", () => $27b4eeefd41e8dbe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hTogN = parcelRequire("hTogN");
var $27b4eeefd41e8dbe$export$2e2bcd8739ae039 = (0, $hTogN.default);

});
parcelRegister("hTogN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3339f6fc1d89a508$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //German (Germany)
var $3339f6fc1d89a508$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Auswahl l\xf6schen",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Daten konnten nicht abgerufen werden.",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klicken, um es erneut zu versuchen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "L\xe4dt\xa0...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Mehr anzeigen",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount}\xa0Ergebnisse",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} von {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Keine Treffer gefunden",
    "paginated-picker.async-select.select.option.error-message": "Daten konnten nicht abgerufen werden.",
    "paginated-picker.async-select.select.option.retry-message": "Klicken, um es erneut zu versuchen",
    "paginated-picker.async-select.select.search-placeholder": "Suchen",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Vollst\xe4ndige Liste anzeigen"
};

});


parcelRegister("kNAzI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dd1c8a92a688654$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cRpm1 = parcelRequire("cRpm1");
var $8dd1c8a92a688654$export$2e2bcd8739ae039 = (0, $cRpm1.default);

});
parcelRegister("cRpm1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d79b4a70d58b469$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $5d79b4a70d58b469$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Clear selection",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Click to retry",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Loading...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Show more",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} results",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} of {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "No matches found",
    "paginated-picker.async-select.select.option.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.select.option.retry-message": "Click to retry",
    "paginated-picker.async-select.select.search-placeholder": "Search",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Show full list"
};

});


parcelRegister("gj2Tx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c6c7e849c5b191b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $qK8jW = parcelRequire("qK8jW");
var $6c6c7e849c5b191b$export$2e2bcd8739ae039 = (0, $qK8jW.default);

});
parcelRegister("qK8jW", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a678c85ca2310bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //English (United Kingdom)
var $5a678c85ca2310bb$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Clear selection",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Click to retry",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Loading...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Show more",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} results",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} of {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "No matches found",
    "paginated-picker.async-select.select.option.error-message": "Couldn't retrieve data",
    "paginated-picker.async-select.select.option.retry-message": "Click to retry",
    "paginated-picker.async-select.select.search-placeholder": "Search",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Show full list"
};

});


parcelRegister("3i6Lq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4f083a617eb3ca0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6HMh6 = parcelRequire("6HMh6");
var $e4f083a617eb3ca0$export$2e2bcd8739ae039 = (0, $6HMh6.default);

});
parcelRegister("6HMh6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ea6063f26d64040$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $2ea6063f26d64040$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u2063\u2062{itemsCount} results\u2060\u2060\u061C\u206E\u206C\u206B\u200D\u061C\x90\u061C\u206B\u206E\u206F\u061C\x8d\u206B\u206C\x90\u061C\u061C\u200D\x8d\x8d\u206A\x9d\u2061\u2061\u2060\u061C\x9d\u206D\x8f\u2063\u2064",
    "paginated-picker.async-select.pagination-details.of-total-count": "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    "paginated-picker.async-select.select.option.error-message": "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    "paginated-picker.async-select.select.option.retry-message": "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    "paginated-picker.async-select.select.search-placeholder": "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};

});


parcelRegister("ck7YE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a734126ec3b9fa28$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $gFgcN = parcelRequire("gFgcN");
var $a734126ec3b9fa28$export$2e2bcd8739ae039 = (0, $gFgcN.default);

});
parcelRegister("gFgcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f9e87e2a136c66e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Spanish (International)
var $0f9e87e2a136c66e$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Borrar selecci\xf3n",
    "paginated-picker.async-select.menu-list.error-message.error-message": "No se han podido recuperar los datos",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Haz clic para intentarlo de nuevo",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Cargando\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Mostrar m\xe1s",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultados",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} de {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "No se han encontrado coincidencias",
    "paginated-picker.async-select.select.option.error-message": "No se han podido recuperar los datos",
    "paginated-picker.async-select.select.option.retry-message": "Haz clic para intentarlo de nuevo",
    "paginated-picker.async-select.select.search-placeholder": "Buscar",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Mostrar lista completa"
};

});


parcelRegister("a9QMV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c3dcc5e922a9636$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6IlXl = parcelRequire("6IlXl");
var $5c3dcc5e922a9636$export$2e2bcd8739ae039 = (0, $6IlXl.default);

});
parcelRegister("6IlXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $abf31cdc96c47128$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Finnish
var $abf31cdc96c47128$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Tyhjenn\xe4 valinta",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Tietoja ei voitu noutaa",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Yrit\xe4 uudelleen napsauttamalla",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Ladataan...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "N\xe4yt\xe4 lis\xe4\xe4",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} tulosta",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Ei hakutuloksia",
    "paginated-picker.async-select.select.option.error-message": "Tietoja ei voitu noutaa",
    "paginated-picker.async-select.select.option.retry-message": "Yrit\xe4 uudelleen napsauttamalla",
    "paginated-picker.async-select.select.search-placeholder": "Hae",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "N\xe4yt\xe4 koko luettelo"
};

});


parcelRegister("lsexj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dc83f6b49fe1e66$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $193h8 = parcelRequire("193h8");
var $6dc83f6b49fe1e66$export$2e2bcd8739ae039 = (0, $193h8.default);

});
parcelRegister("193h8", function(module, exports) {
$parcel$export(module.exports, "default", () => $38d215f6de9820a9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //French (France)
var $38d215f6de9820a9$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Effacer la s\xe9lection",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Cliquez pour r\xe9essayer",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Chargement en cours\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Afficher plus",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount}\xa0r\xe9sultats",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} sur {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "R\xe9sultats introuvables",
    "paginated-picker.async-select.select.option.error-message": "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    "paginated-picker.async-select.select.option.retry-message": "Cliquez pour r\xe9essayer",
    "paginated-picker.async-select.select.search-placeholder": "Rechercher",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Afficher toute la liste"
};

});


parcelRegister("8wPTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $48a8b765c010f63d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $f9eIf = parcelRequire("f9eIf");
var $48a8b765c010f63d$export$2e2bcd8739ae039 = (0, $f9eIf.default);

});
parcelRegister("f9eIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc18558671f631d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Hungarian
var $5fc18558671f631d$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Nem siker\xfclt lek\xe9rni az adatokat",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Bet\xf6lt\xe9s\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "T\xf6bb",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} tal\xe1lat",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nincs egyez\xe9s",
    "paginated-picker.async-select.select.option.error-message": "Nem siker\xfclt lek\xe9rni az adatokat",
    "paginated-picker.async-select.select.option.retry-message": "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    "paginated-picker.async-select.select.search-placeholder": "Keres\xe9s",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Teljes lista megjelen\xedt\xe9se"
};

});


parcelRegister("1JHGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $16322febacb3bafe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $gxBAM = parcelRequire("gxBAM");
var $16322febacb3bafe$export$2e2bcd8739ae039 = (0, $gxBAM.default);

});
parcelRegister("gxBAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c5cd6b8757d68e8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Italian (Italy)
var $7c5cd6b8757d68e8$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Cancella selezione",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Impossibile recuperare i dati",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Clicca per riprovare",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Caricamento in corso...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Mostra altro",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} risultati",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} di {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nessuna corrispondenza trovata",
    "paginated-picker.async-select.select.option.error-message": "Impossibile recuperare i dati",
    "paginated-picker.async-select.select.option.retry-message": "Clicca per riprovare",
    "paginated-picker.async-select.select.search-placeholder": "Ricerca",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Mostra l'elenco completo"
};

});


parcelRegister("2fFOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $45075e6d17f7532a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $etyaf = parcelRequire("etyaf");
var $45075e6d17f7532a$export$2e2bcd8739ae039 = (0, $etyaf.default);

});
parcelRegister("etyaf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be45a181f5856e0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Japanese
var $3be45a181f5856e0$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u9078\u629E\u3092\u89E3\u9664",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u8868\u793A\u3092\u5897\u3084\u3059",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} \u4EF6\u306E\u7D50\u679C",
    "paginated-picker.async-select.pagination-details.of-total-count": "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    "paginated-picker.async-select.select.option.error-message": "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    "paginated-picker.async-select.select.option.retry-message": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    "paginated-picker.async-select.select.search-placeholder": "\u691C\u7D22",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};

});


parcelRegister("18n74", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f92e09fd02f893$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iotzW = parcelRequire("iotzW");
var $85f92e09fd02f893$export$2e2bcd8739ae039 = (0, $iotzW.default);

});
parcelRegister("iotzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c779f89e2c52fa5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Korean
var $1c779f89e2c52fa5$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\uB85C\uB4DC \uC911...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\uB354 \uBCF4\uAE30",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount}\uAC1C \uACB0\uACFC",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    "paginated-picker.async-select.select.option.error-message": "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    "paginated-picker.async-select.select.option.retry-message": "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    "paginated-picker.async-select.select.search-placeholder": "\uAC80\uC0C9",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};

});


parcelRegister("85b2N", function(module, exports) {
$parcel$export(module.exports, "default", () => $b97d864591363d04$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1lb0X = parcelRequire("1lb0X");
var $b97d864591363d04$export$2e2bcd8739ae039 = (0, $1lb0X.default);

});
parcelRegister("1lb0X", function(module, exports) {
$parcel$export(module.exports, "default", () => $b91f24ac22b6e6d4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Norwegian (Bokmål)
var $b91f24ac22b6e6d4$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Fjern valg",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Kan ikke hente data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klikk for \xe5 pr\xf8ve igjen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Laster\xa0\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Vis mer",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultater",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} av {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Finner ingen treff",
    "paginated-picker.async-select.select.option.error-message": "Kan ikke hente data",
    "paginated-picker.async-select.select.option.retry-message": "Klikk for \xe5 pr\xf8ve igjen",
    "paginated-picker.async-select.select.search-placeholder": "S\xf8k",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Vis fullstendig liste"
};

});


parcelRegister("dwnFJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $79a1249add00704e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3IzJY = parcelRequire("3IzJY");
var $79a1249add00704e$export$2e2bcd8739ae039 = (0, $3IzJY.default);

});
parcelRegister("3IzJY", function(module, exports) {
$parcel$export(module.exports, "default", () => $aee7e9f3dd7432cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Dutch (Netherlands)
var $aee7e9f3dd7432cb$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Selectie wissen",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Gegevens konden niet worden opgehaald",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klik om het opnieuw te proberen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Laden...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Meer tonen",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultaten",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} van {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Geen overeenkomsten gevonden",
    "paginated-picker.async-select.select.option.error-message": "Gegevens konden niet worden opgehaald",
    "paginated-picker.async-select.select.option.retry-message": "Klik om het opnieuw te proberen",
    "paginated-picker.async-select.select.search-placeholder": "Zoeken",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Volledige lijst weergeven"
};

});


parcelRegister("3D0sf", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f6483a8982accac$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $40ege = parcelRequire("40ege");
var $0f6483a8982accac$export$2e2bcd8739ae039 = (0, $40ege.default);

});
parcelRegister("40ege", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5f32251ef6bbe5f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Polish (Poland)
var $f5f32251ef6bbe5f$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Wyczy\u015B\u0107 wyb\xf3r",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Nie mo\u017Cna pobra\u0107 danych",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0141adowanie...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Poka\u017C wi\u0119cej",
    "paginated-picker.async-select.pagination-details.loadedCount": "Wyniki {itemsCount}",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} z {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nie znaleziono dopasowa\u0144",
    "paginated-picker.async-select.select.option.error-message": "Nie mo\u017Cna pobra\u0107 danych",
    "paginated-picker.async-select.select.option.retry-message": "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    "paginated-picker.async-select.select.search-placeholder": "Szukaj",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Poka\u017C pe\u0142n\u0105 list\u0119"
};

});


parcelRegister("591Pq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5406929c5fea2da3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $jenKx = parcelRequire("jenKx");
var $5406929c5fea2da3$export$2e2bcd8739ae039 = (0, $jenKx.default);

});
parcelRegister("jenKx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f87cc00faabe282d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Portuguese (Brazil)
var $f87cc00faabe282d$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Limpar sele\xe7\xe3o",
    "paginated-picker.async-select.menu-list.error-message.error-message": "N\xe3o foi poss\xedvel recuperar os dados",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Clique para tentar de novo",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Carregando...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Ver mais",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultados",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} de {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Nenhuma correspond\xeancia encontrada",
    "paginated-picker.async-select.select.option.error-message": "N\xe3o foi poss\xedvel recuperar os dados",
    "paginated-picker.async-select.select.option.retry-message": "Clique para tentar de novo",
    "paginated-picker.async-select.select.search-placeholder": "Pesquisar",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Mostrar lista completa"
};

});


parcelRegister("eYcOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $31a8433d4636e691$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $01dPI = parcelRequire("01dPI");
var $31a8433d4636e691$export$2e2bcd8739ae039 = (0, $01dPI.default);

});
parcelRegister("01dPI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d6323c60a2272e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Russian
var $b1d6323c60a2272e$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432: {itemsCount}",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} \u0438\u0437 {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    "paginated-picker.async-select.select.option.error-message": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    "paginated-picker.async-select.select.option.retry-message": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    "paginated-picker.async-select.select.search-placeholder": "\u041F\u043E\u0438\u0441\u043A",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("flvag", function(module, exports) {
$parcel$export(module.exports, "default", () => $eea04b2165be9386$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aWKMF = parcelRequire("aWKMF");
var $eea04b2165be9386$export$2e2bcd8739ae039 = (0, $aWKMF.default);

});
parcelRegister("aWKMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e411e2de4f50ad8e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Swedish
var $e411e2de4f50ad8e$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Rensa urval",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Det gick inte att h\xe4mta data",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "L\xe4ser in ...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Visa mer",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} resultat",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} av {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Inga tr\xe4ffar hittades",
    "paginated-picker.async-select.select.option.error-message": "Det gick inte att h\xe4mta data",
    "paginated-picker.async-select.select.option.retry-message": "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    "paginated-picker.async-select.select.search-placeholder": "S\xf6k",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Visa fullst\xe4ndig lista"
};

});


parcelRegister("1Qwee", function(module, exports) {
$parcel$export(module.exports, "default", () => $5732d21a2f8ee829$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cLi5y = parcelRequire("cLi5y");
var $5732d21a2f8ee829$export$2e2bcd8739ae039 = (0, $cLi5y.default);

});
parcelRegister("cLi5y", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2d1ffe1605efd79$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Thai (Thailand)
var $f2d1ffe1605efd79$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C {itemsCount} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    "paginated-picker.async-select.select.option.error-message": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    "paginated-picker.async-select.select.option.retry-message": "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    "paginated-picker.async-select.select.search-placeholder": "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};

});


parcelRegister("Shrlp", function(module, exports) {
$parcel$export(module.exports, "default", () => $37a0e0e0614c1b49$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8cTPr = parcelRequire("8cTPr");
var $37a0e0e0614c1b49$export$2e2bcd8739ae039 = (0, $8cTPr.default);

});
parcelRegister("8cTPr", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e52fc0cabf17fbf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Turkish (Turkey)
var $7e52fc0cabf17fbf$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "Se\xe7imi temizle",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Veriler al\u0131namad\u0131",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "Y\xfckleniyor...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Daha fazla g\xf6ster",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} sonu\xe7",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "E\u015Fle\u015Fme bulunamad\u0131",
    "paginated-picker.async-select.select.option.error-message": "Veriler al\u0131namad\u0131",
    "paginated-picker.async-select.select.option.retry-message": "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    "paginated-picker.async-select.select.search-placeholder": "Ara",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Tam listeyi g\xf6ster"
};

});


parcelRegister("caOj2", function(module, exports) {
$parcel$export(module.exports, "default", () => $54313af8cdeaabfd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $64ANG = parcelRequire("64ANG");
var $54313af8cdeaabfd$export$2e2bcd8739ae039 = (0, $64ANG.default);

});
parcelRegister("64ANG", function(module, exports) {
$parcel$export(module.exports, "default", () => $585335175c1de022$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Ukrainian (Ukraine)
var $585335175c1de022$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    "paginated-picker.async-select.pagination-details.loadedCount": "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432: {itemsCount}",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount} \u0437 {totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    "paginated-picker.async-select.select.option.error-message": "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    "paginated-picker.async-select.select.option.retry-message": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    "paginated-picker.async-select.select.search-placeholder": "\u041F\u043E\u0448\u0443\u043A",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("fkLYz", function(module, exports) {
$parcel$export(module.exports, "default", () => $09e1f2300c27c062$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1YeX3 = parcelRequire("1YeX3");
var $09e1f2300c27c062$export$2e2bcd8739ae039 = (0, $1YeX3.default);

});
parcelRegister("1YeX3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d7f9924b8adf71$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Vietnamese (Vietnam)
var $a0d7f9924b8adf71$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    "paginated-picker.async-select.menu-list.error-message.error-message": "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u0110ang t\u1EA3i...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "Hi\u1EC3n th\u1ECB th\xeam",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} k\u1EBFt qu\u1EA3",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    "paginated-picker.async-select.select.option.error-message": "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    "paginated-picker.async-select.select.option.retry-message": "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    "paginated-picker.async-select.select.search-placeholder": "T\xecm ki\u1EBFm",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};

});


parcelRegister("7QyW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d6662f47a15a760$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7FvYm = parcelRequire("7FvYm");
var $5d6662f47a15a760$export$2e2bcd8739ae039 = (0, $7FvYm.default);

});
parcelRegister("7FvYm", function(module, exports) {
$parcel$export(module.exports, "default", () => $03e0b44a6d74dc10$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Chinese (Simplified)
var $03e0b44a6d74dc10$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u6E05\u7A7A\u9009\u62E9",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u70B9\u51FB\u91CD\u8BD5",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u6B63\u5728\u52A0\u8F7D...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u663E\u793A\u66F4\u591A",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} \u4E2A\u7ED3\u679C",
    "paginated-picker.async-select.pagination-details.of-total-count": "{itemsCount}/{totalCount}",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u672A\u627E\u5230\u5339\u914D\u9879",
    "paginated-picker.async-select.select.option.error-message": "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    "paginated-picker.async-select.select.option.retry-message": "\u70B9\u51FB\u91CD\u8BD5",
    "paginated-picker.async-select.select.search-placeholder": "\u641C\u7D22",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};

});


parcelRegister("2bQkq", function(module, exports) {
$parcel$export(module.exports, "default", () => $1df8ac2a7a4fd100$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $A6VJc = parcelRequire("A6VJc");
var $1df8ac2a7a4fd100$export$2e2bcd8739ae039 = (0, $A6VJc.default);

});
parcelRegister("A6VJc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b514dff2b6d2b28f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //Chinese (Traditional)
var $b514dff2b6d2b28f$export$2e2bcd8739ae039 = {
    "paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text": "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    "paginated-picker.async-select.menu-list.error-message.error-message": "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    "paginated-picker.async-select.menu-list.error-message.retry-message": "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    "paginated-picker.async-select.menu-list.loading-message.loading-message": "\u6B63\u5728\u8F09\u5165...",
    "paginated-picker.async-select.menu-list.show-more-button.show-more-button-text": "\u986F\u793A\u8F03\u591A",
    "paginated-picker.async-select.pagination-details.loadedCount": "{itemsCount} \u500B\u7D50\u679C",
    "paginated-picker.async-select.pagination-details.of-total-count": "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    "paginated-picker.async-select.select.no-options-message.no-options-message": "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    "paginated-picker.async-select.select.option.error-message": "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    "paginated-picker.async-select.select.option.retry-message": "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    "paginated-picker.async-select.select.search-placeholder": "\u641C\u5C0B",
    "paginated-picker.async-select.show-full-list-button.show-full-list-button-text": "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};

});




parcelRegister("a7MCo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f98789704d1d6de$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $1f0im = parcelRequire("1f0im");

var $2pNN1 = parcelRequire("2pNN1");

var $e1eEo = parcelRequire("e1eEo");

var $hAfhq = parcelRequire("hAfhq");

var $gS9gy = parcelRequire("gS9gy");

var $bOy64 = parcelRequire("bOy64");

var $9d1np = parcelRequire("9d1np");

var $87jcs = parcelRequire("87jcs");

var $cGunW = parcelRequire("cGunW");
const $8f98789704d1d6de$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $8f98789704d1d6de$var$paginatedComponents = {
    ...(0, $9d1np.selectComponents),
    MenuList: $gS9gy.MenuList
};
const $8f98789704d1d6de$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ selectOptions: selectOptions, ...props }, ref)=>{
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9d1np.LocalBaseSelect), {
        ...props,
        options: selectOptions,
        ref: ref
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9d1np.LocalBaseSelect), {
        ...props,
        ref: ref
    });
});
$8f98789704d1d6de$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
const $8f98789704d1d6de$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef((props, ref)=>{
    const baseSelectProps = (0, $e1eEo.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8f98789704d1d6de$var$ProxyBaseSelect, {
        ...props,
        ...baseSelectProps,
        ref: ref
    });
});
$8f98789704d1d6de$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ const $8f98789704d1d6de$var$addUniqueOptions = (keys, options, option)=>{
    if (option.optionType === 'group') {
        const groupOptions = [];
        option.options.forEach((groupOption)=>{
            $8f98789704d1d6de$var$addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push({
            ...option,
            options: groupOptions
        });
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
const $8f98789704d1d6de$var$generateOptions = (selectedValues, newOptions, addSelectedFirst, previousOptions)=>{
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) selectedValues.forEach((option)=>{
        $8f98789704d1d6de$var$addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach((option)=>{
        $8f98789704d1d6de$var$addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach((option)=>{
        $8f98789704d1d6de$var$addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
const $8f98789704d1d6de$var$getLastCursorOption = (options)=>(0, (/*@__PURE__*/$parcel$interopDefault($2pNN1)))(options, (option)=>'cursor' in option && !!option.cursor);
// Needed to disable filtering from react-select
const $8f98789704d1d6de$var$noFilterOptions = ()=>true;
const $8f98789704d1d6de$var$noLoadOptions = ()=>Promise.resolve();
const $8f98789704d1d6de$export$54319cf8344f1691 = (options)=>options.map((option)=>option.optionType === 'group' ? option.options.length : 1).reduce((sumSoFar, count)=>sumSoFar + count, 0);
const $8f98789704d1d6de$export$fccf54b4cac6e0b3 = ({ ariaLabel: ariaLabel, field: field, isMulti: isMulti = true, value: value, onChange: onChange, onClear: onClear, hideClearSelection: hideClearSelection = false, initiallyAddSelectedFirst: initiallyAddSelectedFirst, showFooter: showFooter, ...restProps })=>{
    var _field$pagination;
    const selectRef = (0, $fc4bM.useRef)(null);
    const [page, setPage] = (0, $fc4bM.useState)(0);
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $fc4bM.useState)(false);
    const [inputValue, setInputValue] = (0, $fc4bM.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $fc4bM.useState)([]);
    const [enableFullList, setEnableFullList] = (0, $fc4bM.useState)(((_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) ?? false);
    const [totalCount, setTotalCount] = (0, $fc4bM.useState)(null);
    const [hasMore, setHasMore] = (0, $fc4bM.useState)();
    const [error, setError] = (0, $fc4bM.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const getTotalCountWithFunctions = (0, $fc4bM.useCallback)((newTotalCount)=>{
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        const { pagination: { keywordValues: keywordValues } } = field;
        const newTotalCountWithKeywords = newTotalCount + value.filter((option)=>keywordValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $8f98789704d1d6de$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $8f98789704d1d6de$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    const checkIfError = (0, $fc4bM.useCallback)((_search, options, onRetry)=>{
        if (options.some((option)=>option.optionType === 'error')) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $fc4bM.useCallback)((search)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, ({ options: options, totalCount: newTotalCount, hasMore: newHasMore })=>{
            if (checkIfError(search, options, ()=>handleLoadOptions(search))) return;
            setLoadedOptions($8f98789704d1d6de$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setHasMore(newHasMore);
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $fc4bM.useCallback)((showFullList = false, isRetry = false)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        let originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $8f98789704d1d6de$var$getLastCursorOption(loadedOptions), ({ options: options, totalCount: newTotalCount, hasMore: newHasMore })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($8f98789704d1d6de$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setHasMore(newHasMore);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    const handleShowFullList = (0, $fc4bM.useCallback)(()=>{
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $fc4bM.useCallback)((newInputValue)=>{
        const { onInputChange: onInputChange } = field;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    const handleOnChange = (0, $fc4bM.useCallback)((options, action)=>{
        let selectData;
        if ('option' in action) {
            const actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1f0im)))(loadedOptions, (option)=>'value' in option && option.value === actionOption.value)
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleClear = (0, $fc4bM.useCallback)(()=>{
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(()=>{
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $fc4bM.useEffect)(()=>{
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsCount = $8f98789704d1d6de$export$54319cf8344f1691(loadedOptions);
    const showClearSelection = !hideClearSelection && !!value.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8f98789704d1d6de$var$AsyncSelect, {
        ref: selectRef,
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $8f98789704d1d6de$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $8f98789704d1d6de$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        isMulti: isMulti,
        selectOptions: loadedOptions,
        onFilterOption: $8f98789704d1d6de$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: hasMore !== undefined ? hasMore : totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value,
        ...restProps
    }), (showFooter || showClearSelection) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cGunW.Footer), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $87jcs.ShowFullListButton), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), showClearSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hAfhq.ClearSelectedItemsButton), {
        onClear: handleClear,
        type: field.key
    }), showFooter && !enableFullList && (totalCount !== null || hasMore !== undefined) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bOy64.PaginationDetails), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $8f98789704d1d6de$export$2e2bcd8739ae039 = $8f98789704d1d6de$export$fccf54b4cac6e0b3;

});
parcelRegister("1f0im", function(module, exports) {

var $daajz = parcelRequire("daajz");

var $lNhdb = parcelRequire("lNhdb");

var $8G70j = parcelRequire("8G70j");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0e776bc89fcc618b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $0e776bc89fcc618b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $8G70j(fromIndex);
    if (index < 0) index = $0e776bc89fcc618b$var$nativeMax(length + index, 0);
    return $daajz(array, $lNhdb(predicate, 3), index);
}
module.exports = $0e776bc89fcc618b$var$findIndex;

});

parcelRegister("2pNN1", function(module, exports) {

var $60Z4v = parcelRequire("60Z4v");

var $1INnH = parcelRequire("1INnH");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $1c2489bfbc30d546$var$findLast = $60Z4v($1INnH);
module.exports = $1c2489bfbc30d546$var$findLast;

});
parcelRegister("60Z4v", function(module, exports) {

var $lNhdb = parcelRequire("lNhdb");

var $4kWWy = parcelRequire("4kWWy");

var $auIsz = parcelRequire("auIsz");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $46121db66d62619f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$4kWWy(collection)) {
            var iteratee = $lNhdb(predicate, 3);
            collection = $auIsz(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $46121db66d62619f$var$createFind;

});

parcelRegister("1INnH", function(module, exports) {

var $daajz = parcelRequire("daajz");

var $lNhdb = parcelRequire("lNhdb");

var $8G70j = parcelRequire("8G70j");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1410349872bec3f2$var$nativeMax = Math.max, $1410349872bec3f2$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $1410349872bec3f2$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $8G70j(fromIndex);
        index = fromIndex < 0 ? $1410349872bec3f2$var$nativeMax(length + index, 0) : $1410349872bec3f2$var$nativeMin(index, length - 1);
    }
    return $daajz(array, $lNhdb(predicate, 3), index, true);
}
module.exports = $1410349872bec3f2$var$findLastIndex;

});


parcelRegister("e1eEo", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfb0d1b004f2c6c1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $cfb0d1b004f2c6c1$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $cfb0d1b004f2c6c1$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $fc4bM.useRef)(undefined);
    const mounted = (0, $fc4bM.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $fc4bM.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $fc4bM.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $fc4bM.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $fc4bM.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $fc4bM.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $fc4bM.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $fc4bM.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $fc4bM.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $fc4bM.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $fc4bM.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $fc4bM.useCallback)((newValue, actionMeta)=>{
        const inputValue = $cfb0d1b004f2c6c1$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("hAfhq", function(module, exports) {
$parcel$export(module.exports, "ClearSelectedItemsButton", () => $e4c2eaf77aacf370$export$1d4b7cda9e589b53);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $kTVlm = parcelRequire("kTVlm");

var $jp1HX = parcelRequire("jp1HX");
const $e4c2eaf77aacf370$export$1d4b7cda9e589b53 = ({ onClear: onClear /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClearSelectedItems = (0, $fc4bM.useCallback)(()=>{
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $jp1HX.default).clearAllSelectedItemsButtonText));
};
var $e4c2eaf77aacf370$export$2e2bcd8739ae039 = $e4c2eaf77aacf370$export$1d4b7cda9e589b53;

});
parcelRegister("jp1HX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea13b1e20edcd007$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $ea13b1e20edcd007$var$message = (0, $8p5Cv.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});
var $ea13b1e20edcd007$export$2e2bcd8739ae039 = $ea13b1e20edcd007$var$message;

});


parcelRegister("gS9gy", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $9d76bfe876c46ffa$export$d4c4e98c5044dc8);

var $fc4bM = parcelRequire("fc4bM");

var $9MLZi = parcelRequire("9MLZi");

var $hculA = parcelRequire("hculA");

var $2WusX = parcelRequire("2WusX");

var $kyuTj = parcelRequire("kyuTj");

var $j45Jf = parcelRequire("j45Jf");

var $kzCFc = parcelRequire("kzCFc");
const $9d76bfe876c46ffa$export$d4c4e98c5044dc8 = (props)=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const [clickCount, setClickCount] = (0, $fc4bM.useState)(1);
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
    const handleOnShowMore = (0, $fc4bM.useCallback)(()=>{
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9MLZi.components).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kyuTj.LoadingMessage), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2WusX.default), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kzCFc.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $j45Jf.default), {
        onShowMore: handleOnShowMore
    })));
};
var $9d76bfe876c46ffa$export$2e2bcd8739ae039 = $9d76bfe876c46ffa$export$d4c4e98c5044dc8;

});
parcelRegister("9MLZi", function(module, exports) {
$parcel$export(module.exports, "components", () => $bf243f9076ba6e8c$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $bf243f9076ba6e8c$export$71abc632aa29e6fe);

var $xq2Wy = parcelRequire("xq2Wy");

var $84jWs = parcelRequire("84jWs");

var $bZT48 = parcelRequire("bZT48");

var $KGV9x = parcelRequire("KGV9x");

var $1JfFs = parcelRequire("1JfFs");

var $5faSM = parcelRequire("5faSM");

var $i0TzV = parcelRequire("i0TzV");

var $k4AKV = parcelRequire("k4AKV");

var $hHD7f = parcelRequire("hHD7f");

var $7FVn8 = parcelRequire("7FVn8");

var $59sN9 = parcelRequire("59sN9");

var $1Lnfw = parcelRequire("1Lnfw");

var $aARHI = parcelRequire("aARHI");

var $jLJ5k = parcelRequire("jLJ5k");

var $7xr7K = parcelRequire("7xr7K");

var $37kfT = parcelRequire("37kfT");

var $ieqMj = parcelRequire("ieqMj");

var $kf3nM = parcelRequire("kf3nM");

var $aYKOw = parcelRequire("aYKOw");

var $hsZqz = parcelRequire("hsZqz");

var $bWxAu = parcelRequire("bWxAu");

var $iSklz = parcelRequire("iSklz");
const $bf243f9076ba6e8c$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $k4AKV.ClearIndicator),
    Control: (0, $1JfFs.default),
    DropdownIndicator: (0, $hHD7f.DropdownIndicator),
    Group: (0, $5faSM.default),
    GroupHeading: (0, $i0TzV.GroupHeading),
    IndicatorsContainer: (0, $xq2Wy.IndicatorsContainer),
    Input: (0, $59sN9.default),
    LoadingIndicator: (0, $7FVn8.LoadingIndicator),
    Menu: (0, $1Lnfw.default),
    MenuList: (0, $aARHI.MenuList),
    MenuPortal: (0, $37kfT.MenuPortal),
    LoadingMessage: (0, $jLJ5k.LoadingMessage),
    NoOptionsMessage: (0, $7xr7K.NoOptionsMessage),
    MultiValue: (0, $ieqMj.default),
    MultiValueContainer: (0, $84jWs.MultiValueContainer),
    MultiValueLabel: (0, $kf3nM.MultiValueLabel),
    MultiValueRemove: (0, $aYKOw.MultiValueRemove),
    Option: (0, $hsZqz.default),
    Placeholder: (0, $bWxAu.default),
    SelectContainer: (0, $bZT48.SelectContainer),
    SingleValue: (0, $iSklz.default),
    ValueContainer: (0, $KGV9x.ValueContainer)
};
const $bf243f9076ba6e8c$export$71abc632aa29e6fe = (props)=>({
        ...$bf243f9076ba6e8c$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("xq2Wy", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $469f5ed4abbc36f1$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* indicators-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");
const $469f5ed4abbc36f1$var$indicatorContainerStyles = null;
const $469f5ed4abbc36f1$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $jdt4T.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("2GKQh", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $88162b8e0bafe8d7$export$26417cabd806a658);
const $88162b8e0bafe8d7$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("84jWs", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $7f95a68d63ae450e$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");
const $7f95a68d63ae450e$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $7f95a68d63ae450e$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $7f95a68d63ae450e$var$multiValueStyles.root,
            isDisabled && $7f95a68d63ae450e$var$multiValueStyles.disabled,
            isFocused && $7f95a68d63ae450e$var$multiValueStyles.focused,
            (0, $jdt4T.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};

});

parcelRegister("bZT48", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $a6792f351af2f232$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* select-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");
const $a6792f351af2f232$var$containerStyles = {
    default: "_11c8fhey _kqswh2mm _lcxv1rj4 _j4tm1d4k",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const $a6792f351af2f232$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $2GKQh.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $a6792f351af2f232$var$containerStyles.default,
            isRtl && $a6792f351af2f232$var$containerStyles.rtl,
            isDisabled && $a6792f351af2f232$var$containerStyles.disabled,
            (0, $jdt4T.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};

});

parcelRegister("KGV9x", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $25e9ce42bc5708e2$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* value-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");
const $25e9ce42bc5708e2$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const $25e9ce42bc5708e2$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const tagUpliftMultiVertical = isMulti;
    const tagUpliftChipRow = isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $25e9ce42bc5708e2$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $25e9ce42bc5708e2$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $25e9ce42bc5708e2$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $25e9ce42bc5708e2$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $25e9ce42bc5708e2$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $25e9ce42bc5708e2$var$valueContainerStyles.flex,
            tagUpliftChipRow && $25e9ce42bc5708e2$var$valueContainerStyles.flexWithGap,
            (0, $jdt4T.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};

});

parcelRegister("1JfFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98dbde64b06be83$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v3.0.2 */ /* control.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $dRkX9 = parcelRequire("dRkX9");

var $2GKQh = parcelRequire("2GKQh");
const $f98dbde64b06be83$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rko1qi0 _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
const $f98dbde64b06be83$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $f98dbde64b06be83$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    const isInputMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-input');
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $f98dbde64b06be83$var$styles.default,
            !isInputMotionEnabled && $f98dbde64b06be83$var$inputMotionStyles.legacy,
            isInputMotionEnabled && !isDisabled && $f98dbde64b06be83$var$inputMotionStyles.base,
            isDisabled && $f98dbde64b06be83$var$styles.disabled,
            isInvalid && $f98dbde64b06be83$var$styles.invalid,
            isCompact && $f98dbde64b06be83$var$styles.compact,
            appearance === 'subtle' && $f98dbde64b06be83$var$styles.subtle,
            appearance === 'subtle' && isFocused && $f98dbde64b06be83$var$styles.subtleFocused,
            isFocused && $f98dbde64b06be83$var$styles.focused,
            appearance === 'none' && $f98dbde64b06be83$var$styles.none,
            (0, $jdt4T.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": (0, $dRkX9.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f98dbde64b06be83$export$2e2bcd8739ae039 = $f98dbde64b06be83$var$Control;

});

parcelRegister("5faSM", function(module, exports) {
$parcel$export(module.exports, "default", () => $27b56790a4e8a83e$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");
const $27b56790a4e8a83e$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const $27b56790a4e8a83e$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $27b56790a4e8a83e$var$styles.root,
            (0, $jdt4T.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $3LM7S.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                children: children
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$27b56790a4e8a83e$export$2e2bcd8739ae039 = $27b56790a4e8a83e$var$Group;

});

parcelRegister("i0TzV", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $328db2f56a64bf09$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* group-heading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");

var $bpHX1 = parcelRequire("bpHX1");
const $328db2f56a64bf09$var$headingStyles = null;
const $328db2f56a64bf09$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $bpHX1.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $jdt4T.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};

});
parcelRegister("bpHX1", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $0bb86fd973bd535c$export$8e9fd4287627890c);
// Clean Common Props
// ==============================
const $0bb86fd973bd535c$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};

});


parcelRegister("k4AKV", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $a41f782206e0af31$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* clear-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $48hlF = parcelRequire("48hlF");

var $dRkX9 = parcelRequire("dRkX9");

var $EawnW = parcelRequire("EawnW");

var $2GKQh = parcelRequire("2GKQh");
const $a41f782206e0af31$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $a41f782206e0af31$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    finesse: "_syazdgkc _30l31q3r"
};
const $a41f782206e0af31$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $a41f782206e0af31$var$clearIndicatorStyles.default,
            (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $a41f782206e0af31$var$clearIndicatorStyles.finesse,
            isCompact && $a41f782206e0af31$var$clearIndicatorStyles.compact,
            (0, $jdt4T.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
            xcss: $a41f782206e0af31$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};

});

parcelRegister("hHD7f", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $0eea3db66a9ed376$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* dropdown-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $13zmE = parcelRequire("13zmE");

var $dRkX9 = parcelRequire("dRkX9");

var $i3riz = parcelRequire("i3riz");

var $EawnW = parcelRequire("EawnW");

var $2GKQh = parcelRequire("2GKQh");
const $0eea3db66a9ed376$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
const $0eea3db66a9ed376$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
const $0eea3db66a9ed376$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
const $0eea3db66a9ed376$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx",
    finesse: "_syazdgkc",
    finesseDisabled: "_syaz2sac"
};
const $0eea3db66a9ed376$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps = {}, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    const { 'aria-hidden': ariaHidden, ...restInnerProps } = innerProps;
    const isVoiceControlAccessible = (0, $dRkX9.fg)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    const wrapperTestId = restInnerProps['data-testid'] ? `${restInnerProps['data-testid']}-children` : undefined;
    const voiceControlAccessibleIndicator = children ? /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId,
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $0eea3db66a9ed376$var$voiceControlPressableStyles.root,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $0eea3db66a9ed376$var$voiceControlPressableSizeReset,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
            as: "span",
            xcss: $0eea3db66a9ed376$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $0eea3db66a9ed376$var$dropdownStyles.default,
            (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $0eea3db66a9ed376$var$dropdownStyles.finesse,
            isDisabled && $0eea3db66a9ed376$var$dropdownStyles.disabled,
            isDisabled && (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $0eea3db66a9ed376$var$dropdownStyles.finesseDisabled,
            isCompact && $0eea3db66a9ed376$var$dropdownStyles.compact,
            (0, $jdt4T.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...restInnerProps,
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden,
        children: isVoiceControlAccessible ? voiceControlAccessibleIndicator : children ?? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
            as: "span",
            xcss: $0eea3db66a9ed376$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};

});

parcelRegister("7FVn8", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $141b44741e1714cf$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ /* loading-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $hculA = parcelRequire("hculA");

var $2GKQh = parcelRequire("2GKQh");
const $141b44741e1714cf$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $141b44741e1714cf$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $141b44741e1714cf$var$loadingIndicatorStyles.default,
            isCompact && $141b44741e1714cf$var$loadingIndicatorStyles.compact,
            (0, $jdt4T.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
            size: "small"
        })
    });
};

});

parcelRegister("59sN9", function(module, exports) {
$parcel$export(module.exports, "default", () => $1584179a994d0a7e$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v3.0.2 */ /* input.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $dRkX9 = parcelRequire("dRkX9");

var $2GKQh = parcelRequire("2GKQh");

var $bpHX1 = parcelRequire("bpHX1");
const $1584179a994d0a7e$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $1584179a994d0a7e$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $1584179a994d0a7e$var$nativeInputStylesOld = null;
const $1584179a994d0a7e$var$nativeInputStyles = null;
const $1584179a994d0a7e$var$hidden = null;
const $1584179a994d0a7e$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $bpHX1.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'input', {
        'input-container': true
    });
    if ((0, $dRkX9.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $1584179a994d0a7e$var$inputStyles.root,
            isMulti && $1584179a994d0a7e$var$inputStyles.labellingFFStyles,
            isDisabled && $1584179a994d0a7e$var$inputStyles.disabled,
            (0, $jdt4T.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $2R2iS.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $1584179a994d0a7e$var$inputStylesOld.root,
            isMulti && $1584179a994d0a7e$var$inputStylesOld.labellingFFStyles,
            isDisabled && $1584179a994d0a7e$var$inputStylesOld.disabled,
            (0, $jdt4T.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $2R2iS.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1584179a994d0a7e$export$2e2bcd8739ae039 = $1584179a994d0a7e$var$Input;

});

parcelRegister("1Lnfw", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f42e38afca26e8$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $dRkX9 = parcelRequire("dRkX9");

var $2GKQh = parcelRequire("2GKQh");
const $47f42e38afca26e8$var$menuStyles = {
    root: "_2rko1mok _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    bottom: "_152t1osq",
    top: "_u7co1osq",
    topLayer: "_kqswh2mm _1e0c1txw _2lx21bp4 _ugzyidpf _6rthidpf _1pfhidpf"
};
const $47f42e38afca26e8$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $47f42e38afca26e8$var$menuStyles.root,
            (0, $dRkX9.fg)('platform-dst-top-layer') ? $47f42e38afca26e8$var$menuStyles.topLayer : $47f42e38afca26e8$var$menuStyles[placement],
            (0, $jdt4T.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47f42e38afca26e8$export$2e2bcd8739ae039 = $47f42e38afca26e8$var$Menu;

});

parcelRegister("aARHI", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $ee782da56ce23add$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");
const $ee782da56ce23add$var$menuListStyles = null;
const $ee782da56ce23add$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            "_2rko1mok _kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $jdt4T.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};

});

parcelRegister("jLJ5k", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $627cb28b388595ea$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-loading-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $k8Adr = parcelRequire("k8Adr");

var $2GKQh = parcelRequire("2GKQh");
const $627cb28b388595ea$var$noticeStyles = null;
const $627cb28b388595ea$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $jdt4T.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};

});

parcelRegister("7xr7K", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $86d4f861ceb2e401$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-no-options-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $k8Adr = parcelRequire("k8Adr");

var $2GKQh = parcelRequire("2GKQh");
const $86d4f861ceb2e401$var$noticeStyles = null;
const $86d4f861ceb2e401$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $jdt4T.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};

});

parcelRegister("37kfT", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $679863247711308a$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-portal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bTkYf = parcelRequire("bTkYf");

var $jdt4T = parcelRequire("jdt4T");

var $fgT7D = parcelRequire("fgT7D");

var $dRkX9 = parcelRequire("dRkX9");

var $2GKQh = parcelRequire("2GKQh");

var $91EMH = parcelRequire("91EMH");

var $i26Al = parcelRequire("i26Al");
function $679863247711308a$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $679863247711308a$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $679863247711308a$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $679863247711308a$var$MenuPortalLegacy(props) {
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $fc4bM.useRef)(null);
    const cleanupRef = (0, $fc4bM.useRef)(null);
    const [placement, setPortalPlacement] = (0, $fc4bM.useState)($679863247711308a$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $fc4bM.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $fc4bM.useState)(null);
    const updateComputedPosition = (0, $fc4bM.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $679863247711308a$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $fc4bM.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $fgT7D.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $fc4bM.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $679863247711308a$var$menuPortalStyles.root,
            (0, $jdt4T.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $91EMH.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $bTkYf.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
}
const $679863247711308a$export$793392f970497feb = (props)=>{
    if ((0, $dRkX9.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i26Al.MenuPortalTopLayer), {
        ...props
    });
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $3LM7S.jsx)($679863247711308a$var$MenuPortalLegacy, {
        ...props
    });
};

});
parcelRegister("fgT7D", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $b1e31bc4260081fa$export$deee3a793edee05f);

var $4BMDD = parcelRequire("4BMDD");
var $eKear = parcelRequire("eKear");

var $eKear = parcelRequire("eKear");

var $bc0to = parcelRequire("bc0to");
function $b1e31bc4260081fa$var$getCssDimensions(element) {
    const css = (0, $bc0to.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $bc0to.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $eKear.round)(width) !== offsetWidth || (0, $eKear.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $b1e31bc4260081fa$var$unwrapElement(element) {
    return !(0, $bc0to.isElement)(element) ? element.contextElement : element;
}
function $b1e31bc4260081fa$var$getScale(element) {
    const domElement = $b1e31bc4260081fa$var$unwrapElement(element);
    if (!(0, $bc0to.isHTMLElement)(domElement)) return (0, $eKear.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $b1e31bc4260081fa$var$getCssDimensions(domElement);
    let x = ($ ? (0, $eKear.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $eKear.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $b1e31bc4260081fa$var$noOffsets = /*#__PURE__*/ (0, $eKear.createCoords)(0);
function $b1e31bc4260081fa$var$getVisualOffsets(element) {
    const win = (0, $bc0to.getWindow)(element);
    if (!(0, $bc0to.isWebKit)() || !win.visualViewport) return $b1e31bc4260081fa$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $b1e31bc4260081fa$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $bc0to.getWindow)(element);
}
function $b1e31bc4260081fa$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $b1e31bc4260081fa$var$unwrapElement(element);
    let scale = (0, $eKear.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $bc0to.isElement)(offsetParent)) scale = $b1e31bc4260081fa$var$getScale(offsetParent);
        } else scale = $b1e31bc4260081fa$var$getScale(element);
    }
    const visualOffsets = $b1e31bc4260081fa$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $b1e31bc4260081fa$var$getVisualOffsets(domElement) : (0, $eKear.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $bc0to.getWindow)(domElement);
        const offsetWin = (0, $bc0to.isElement)(offsetParent) ? (0, $bc0to.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $bc0to.getFrameElement)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $b1e31bc4260081fa$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $bc0to.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $bc0to.getWindow)(currentIFrame);
            currentIFrame = (0, $bc0to.getFrameElement)(currentWin);
        }
    }
    return (0, $eKear.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $b1e31bc4260081fa$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $bc0to.getNodeScroll)(element).scrollLeft;
    if (!rect) return $b1e31bc4260081fa$var$getBoundingClientRect((0, $bc0to.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $b1e31bc4260081fa$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $b1e31bc4260081fa$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $b1e31bc4260081fa$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $bc0to.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $bc0to.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $eKear.createCoords)(1);
    const offsets = (0, $eKear.createCoords)(0);
    const isOffsetParentAnElement = (0, $bc0to.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $bc0to.getNodeName)(offsetParent) !== 'body' || (0, $bc0to.isOverflowElement)(documentElement)) scroll = (0, $bc0to.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $b1e31bc4260081fa$var$getBoundingClientRect(offsetParent);
            scale = $b1e31bc4260081fa$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $b1e31bc4260081fa$var$getHTMLOffset(documentElement, scroll) : (0, $eKear.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $b1e31bc4260081fa$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $b1e31bc4260081fa$var$getDocumentRect(html) {
    const scroll = (0, $bc0to.getNodeScroll)(html);
    const body = html.ownerDocument.body;
    const width = (0, $eKear.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $eKear.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $b1e31bc4260081fa$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $bc0to.getComputedStyle)(body).direction === 'rtl') x += (0, $eKear.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $b1e31bc4260081fa$var$SCROLLBAR_MAX = 25;
function $b1e31bc4260081fa$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $bc0to.getWindow)(element);
    const html = (0, $bc0to.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $bc0to.isWebKit)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $b1e31bc4260081fa$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $b1e31bc4260081fa$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $b1e31bc4260081fa$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $b1e31bc4260081fa$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $b1e31bc4260081fa$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $b1e31bc4260081fa$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $b1e31bc4260081fa$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $b1e31bc4260081fa$var$getDocumentRect((0, $bc0to.getDocumentElement)(element));
    else if ((0, $bc0to.isElement)(clippingAncestor)) rect = $b1e31bc4260081fa$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $b1e31bc4260081fa$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $eKear.rectToClientRect)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $b1e31bc4260081fa$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $bc0to.getOverflowAncestors)(element, [], false).filter((el)=>(0, $bc0to.isElement)(el) && (0, $bc0to.getNodeName)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $bc0to.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $bc0to.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $bc0to.isElement)(currentNode) && !(0, $bc0to.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $bc0to.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $bc0to.isContainingBlock)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $bc0to.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $b1e31bc4260081fa$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $bc0to.isTopLayer)(element) ? [] : $b1e31bc4260081fa$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $b1e31bc4260081fa$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $b1e31bc4260081fa$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $eKear.max)(rect.top, top);
        right = (0, $eKear.min)(rect.right, right);
        bottom = (0, $eKear.min)(rect.bottom, bottom);
        left = (0, $eKear.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $b1e31bc4260081fa$var$getDimensions(element) {
    const { width: width, height: height } = $b1e31bc4260081fa$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $b1e31bc4260081fa$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $bc0to.isHTMLElement)(offsetParent);
    const documentElement = (0, $bc0to.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $b1e31bc4260081fa$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $eKear.createCoords)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $bc0to.getNodeName)(offsetParent) !== 'body' || (0, $bc0to.isOverflowElement)(documentElement)) scroll = (0, $bc0to.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $b1e31bc4260081fa$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $b1e31bc4260081fa$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $b1e31bc4260081fa$var$getHTMLOffset(documentElement, scroll) : (0, $eKear.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $b1e31bc4260081fa$var$isStaticPositioned(element) {
    return (0, $bc0to.getComputedStyle)(element).position === 'static';
}
function $b1e31bc4260081fa$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $bc0to.isHTMLElement)(element) || (0, $bc0to.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $bc0to.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $b1e31bc4260081fa$var$getOffsetParent(element, polyfill) {
    const win = (0, $bc0to.getWindow)(element);
    if ((0, $bc0to.isTopLayer)(element)) return win;
    if (!(0, $bc0to.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $bc0to.getParentNode)(element);
        while(svgOffsetParent && !(0, $bc0to.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $bc0to.isElement)(svgOffsetParent) && !$b1e31bc4260081fa$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $bc0to.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $b1e31bc4260081fa$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $bc0to.isTableElement)(offsetParent) && $b1e31bc4260081fa$var$isStaticPositioned(offsetParent))offsetParent = $b1e31bc4260081fa$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $bc0to.isLastTraversableNode)(offsetParent) && $b1e31bc4260081fa$var$isStaticPositioned(offsetParent) && !(0, $bc0to.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $bc0to.getContainingBlock)(element) || win;
}
const $b1e31bc4260081fa$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $b1e31bc4260081fa$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $b1e31bc4260081fa$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $b1e31bc4260081fa$var$isRTL(element) {
    return (0, $bc0to.getComputedStyle)(element).direction === 'rtl';
}
const $b1e31bc4260081fa$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $b1e31bc4260081fa$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $bc0to.getDocumentElement,
    getClippingRect: $b1e31bc4260081fa$var$getClippingRect,
    getOffsetParent: $b1e31bc4260081fa$var$getOffsetParent,
    getElementRects: $b1e31bc4260081fa$var$getElementRects,
    getClientRects: $b1e31bc4260081fa$var$getClientRects,
    getDimensions: $b1e31bc4260081fa$var$getDimensions,
    getScale: $b1e31bc4260081fa$var$getScale,
    isElement: $bc0to.isElement,
    isRTL: $b1e31bc4260081fa$var$isRTL
};
function $b1e31bc4260081fa$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $b1e31bc4260081fa$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $bc0to.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $eKear.floor)(top);
        const insetRight = (0, $eKear.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $eKear.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $eKear.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $eKear.max)(0, (0, $eKear.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$b1e31bc4260081fa$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $bc0to.getWindow)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $b1e31bc4260081fa$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $b1e31bc4260081fa$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $bc0to.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $bc0to.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $b1e31bc4260081fa$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $b1e31bc4260081fa$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $b1e31bc4260081fa$var$getBoundingClientRect(reference);
        if (prevRefRect && !$b1e31bc4260081fa$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $b1e31bc4260081fa$export$37b6bde19b108ecc = (0, $4BMDD.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b1e31bc4260081fa$export$cc800923e997bb8 = (0, $4BMDD.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b1e31bc4260081fa$export$91fb6ecbd551914 = (0, $4BMDD.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b1e31bc4260081fa$export$fba63a578e423eb = (0, $4BMDD.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b1e31bc4260081fa$export$8a83211c878a3f1f = (0, $4BMDD.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b1e31bc4260081fa$export$346677f925de839c = (0, $4BMDD.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b1e31bc4260081fa$export$fe8985bb6374093c = (0, $4BMDD.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b1e31bc4260081fa$export$f2120bbfa5450bd2 = (0, $4BMDD.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b1e31bc4260081fa$export$18c8ad048e32c7d5 = (0, $4BMDD.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b1e31bc4260081fa$export$7bf07e38f3dc4b69 = (0, $4BMDD.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $b1e31bc4260081fa$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$b1e31bc4260081fa$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $4BMDD.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("4BMDD", function(module, exports) {
$parcel$export(module.exports, "detectOverflow", () => $35b058a8d8d1c582$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $35b058a8d8d1c582$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $35b058a8d8d1c582$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $35b058a8d8d1c582$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $35b058a8d8d1c582$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $35b058a8d8d1c582$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $35b058a8d8d1c582$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $35b058a8d8d1c582$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $35b058a8d8d1c582$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $35b058a8d8d1c582$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $35b058a8d8d1c582$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("eKear")).rectToClientRect);

var $eKear = parcelRequire("eKear");
function $35b058a8d8d1c582$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $eKear.getSideAxis)(placement);
    const alignmentAxis = (0, $eKear.getAlignmentAxis)(placement);
    const alignLength = (0, $eKear.getAxisLength)(alignmentAxis);
    const side = (0, $eKear.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $eKear.getAlignment)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $35b058a8d8d1c582$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $eKear.evaluate)(options, state);
    const paddingObject = (0, $eKear.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $eKear.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $eKear.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $35b058a8d8d1c582$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $35b058a8d8d1c582$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $35b058a8d8d1c582$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $35b058a8d8d1c582$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $35b058a8d8d1c582$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $35b058a8d8d1c582$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $35b058a8d8d1c582$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $eKear.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $eKear.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $eKear.getAlignmentAxis)(placement);
            const length = (0, $eKear.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $eKear.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $eKear.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $eKear.clamp)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $eKear.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $35b058a8d8d1c582$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $eKear.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $eKear.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $eKear.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $eKear.getAlignment)(placement) === alignment || (autoAlignment ? (0, $eKear.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $35b058a8d8d1c582$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $eKear.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $eKear.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $eKear.placements) ? $35b058a8d8d1c582$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $eKear.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $eKear.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $eKear.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $eKear.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $35b058a8d8d1c582$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $eKear.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $eKear.getSide)(placement);
            const initialSideAxis = (0, $eKear.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $eKear.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $eKear.getOppositePlacement)(initialPlacement)
            ] : (0, $eKear.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $eKear.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $eKear.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $eKear.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $eKear.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $eKear.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $35b058a8d8d1c582$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $35b058a8d8d1c582$var$isAnySideFullyClipped(overflow) {
    return (0, $eKear.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $35b058a8d8d1c582$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $eKear.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $35b058a8d8d1c582$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $35b058a8d8d1c582$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $35b058a8d8d1c582$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $35b058a8d8d1c582$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $35b058a8d8d1c582$var$getBoundingRect(rects) {
    const minX = (0, $eKear.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $eKear.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $eKear.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $eKear.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $35b058a8d8d1c582$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $eKear.rectToClientRect)($35b058a8d8d1c582$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $35b058a8d8d1c582$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $eKear.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $35b058a8d8d1c582$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $eKear.rectToClientRect)($35b058a8d8d1c582$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $eKear.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $eKear.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $eKear.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $eKear.rectToClientRect)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $eKear.getSide)(placement) === 'left';
                    const maxRight = (0, $eKear.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $eKear.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $eKear.rectToClientRect)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $35b058a8d8d1c582$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $35b058a8d8d1c582$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $eKear.getSide)(placement);
    const alignment = (0, $eKear.getAlignment)(placement);
    const isVertical = (0, $eKear.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $35b058a8d8d1c582$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $eKear.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $35b058a8d8d1c582$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $35b058a8d8d1c582$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $35b058a8d8d1c582$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $eKear.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $eKear.getSideAxis)(placement);
            const mainAxis = (0, $eKear.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $eKear.clamp)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $35b058a8d8d1c582$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $eKear.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $eKear.getSideAxis)(placement);
            const mainAxis = (0, $eKear.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $eKear.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $35b058a8d8d1c582$var$originSides.has((0, $eKear.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $35b058a8d8d1c582$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $eKear.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $eKear.getSide)(placement);
            const alignment = (0, $eKear.getAlignment)(placement);
            const isYAxis = (0, $eKear.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $eKear.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $eKear.min)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $eKear.max)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $eKear.max)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("eKear", function(module, exports) {
$parcel$export(module.exports, "sides", () => $abc059e665bf5cd0$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $abc059e665bf5cd0$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $abc059e665bf5cd0$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $abc059e665bf5cd0$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $abc059e665bf5cd0$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $abc059e665bf5cd0$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $abc059e665bf5cd0$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $abc059e665bf5cd0$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $abc059e665bf5cd0$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $abc059e665bf5cd0$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $abc059e665bf5cd0$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $abc059e665bf5cd0$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $abc059e665bf5cd0$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $abc059e665bf5cd0$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $abc059e665bf5cd0$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $abc059e665bf5cd0$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $abc059e665bf5cd0$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $abc059e665bf5cd0$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $abc059e665bf5cd0$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $abc059e665bf5cd0$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $abc059e665bf5cd0$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $abc059e665bf5cd0$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $abc059e665bf5cd0$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abc059e665bf5cd0$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $abc059e665bf5cd0$export$803cd8101b6c182b = /*#__PURE__*/ $abc059e665bf5cd0$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $abc059e665bf5cd0$export$27b07d8a310ed8b5[0], side + "-" + $abc059e665bf5cd0$export$27b07d8a310ed8b5[1]), []);
const $abc059e665bf5cd0$export$96ec731ed4dcb222 = Math.min;
const $abc059e665bf5cd0$export$8960430cfd85939f = Math.max;
const $abc059e665bf5cd0$export$2077e0241d6afd3c = Math.round;
const $abc059e665bf5cd0$export$a3fe094919f356fd = Math.floor;
const $abc059e665bf5cd0$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $abc059e665bf5cd0$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $abc059e665bf5cd0$export$7d15b64cf5a3a4c4(start, value, end) {
    return $abc059e665bf5cd0$export$8960430cfd85939f(start, $abc059e665bf5cd0$export$96ec731ed4dcb222(value, end));
}
function $abc059e665bf5cd0$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $abc059e665bf5cd0$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $abc059e665bf5cd0$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $abc059e665bf5cd0$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $abc059e665bf5cd0$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $abc059e665bf5cd0$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $abc059e665bf5cd0$export$2b57e0052a6d6d4c(placement) {
    return $abc059e665bf5cd0$export$8a000a963141ac32($abc059e665bf5cd0$export$f28e8f882010718a(placement));
}
function $abc059e665bf5cd0$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $abc059e665bf5cd0$export$f0989780f32bfcda(placement);
    const alignmentAxis = $abc059e665bf5cd0$export$2b57e0052a6d6d4c(placement);
    const length = $abc059e665bf5cd0$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $abc059e665bf5cd0$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $abc059e665bf5cd0$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $abc059e665bf5cd0$export$496432a3699e50b1(placement) {
    const oppositePlacement = $abc059e665bf5cd0$export$9c5e28bad23365fa(placement);
    return [
        $abc059e665bf5cd0$export$2b182c584985588b(placement),
        oppositePlacement,
        $abc059e665bf5cd0$export$2b182c584985588b(oppositePlacement)
    ];
}
function $abc059e665bf5cd0$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $abc059e665bf5cd0$var$lrPlacement = [
    'left',
    'right'
];
const $abc059e665bf5cd0$var$rlPlacement = [
    'right',
    'left'
];
const $abc059e665bf5cd0$var$tbPlacement = [
    'top',
    'bottom'
];
const $abc059e665bf5cd0$var$btPlacement = [
    'bottom',
    'top'
];
function $abc059e665bf5cd0$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $abc059e665bf5cd0$var$rlPlacement : $abc059e665bf5cd0$var$lrPlacement;
            return isStart ? $abc059e665bf5cd0$var$lrPlacement : $abc059e665bf5cd0$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $abc059e665bf5cd0$var$tbPlacement : $abc059e665bf5cd0$var$btPlacement;
        default:
            return [];
    }
}
function $abc059e665bf5cd0$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $abc059e665bf5cd0$export$f0989780f32bfcda(placement);
    let list = $abc059e665bf5cd0$var$getSideList($abc059e665bf5cd0$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($abc059e665bf5cd0$export$2b182c584985588b));
    }
    return list;
}
function $abc059e665bf5cd0$export$9c5e28bad23365fa(placement) {
    const side = $abc059e665bf5cd0$export$3c915306cb7fc97a(placement);
    return $abc059e665bf5cd0$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $abc059e665bf5cd0$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $abc059e665bf5cd0$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $abc059e665bf5cd0$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $abc059e665bf5cd0$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("bc0to", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $82612ea812da90df$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $82612ea812da90df$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $82612ea812da90df$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $82612ea812da90df$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $82612ea812da90df$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $82612ea812da90df$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $82612ea812da90df$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $82612ea812da90df$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $82612ea812da90df$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $82612ea812da90df$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $82612ea812da90df$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $82612ea812da90df$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $82612ea812da90df$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $82612ea812da90df$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $82612ea812da90df$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $82612ea812da90df$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $82612ea812da90df$export$7bf1f8740e3e34af);
function $82612ea812da90df$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $82612ea812da90df$export$651544f548703224(node) {
    if ($82612ea812da90df$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $82612ea812da90df$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $82612ea812da90df$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($82612ea812da90df$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $82612ea812da90df$export$8ee0fc9ee280b4ee(value) {
    if (!$82612ea812da90df$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $82612ea812da90df$export$38b2d434cce3ea22(value).Node;
}
function $82612ea812da90df$export$45a5e7f76e0caa8d(value) {
    if (!$82612ea812da90df$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $82612ea812da90df$export$38b2d434cce3ea22(value).Element;
}
function $82612ea812da90df$export$1b3bfaa9684536aa(value) {
    if (!$82612ea812da90df$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $82612ea812da90df$export$38b2d434cce3ea22(value).HTMLElement;
}
function $82612ea812da90df$export$af51f0f06c0f328a(value) {
    if (!$82612ea812da90df$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $82612ea812da90df$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $82612ea812da90df$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $82612ea812da90df$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $82612ea812da90df$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($82612ea812da90df$export$651544f548703224(element));
}
function $82612ea812da90df$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $82612ea812da90df$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $82612ea812da90df$var$containRe = /paint|layout|strict|content/;
const $82612ea812da90df$var$isNotNone = (value)=>!!value && value !== 'none';
let $82612ea812da90df$var$isWebKitValue;
function $82612ea812da90df$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $82612ea812da90df$export$45a5e7f76e0caa8d(elementOrCss) ? $82612ea812da90df$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $82612ea812da90df$var$isNotNone(css.transform) || $82612ea812da90df$var$isNotNone(css.translate) || $82612ea812da90df$var$isNotNone(css.scale) || $82612ea812da90df$var$isNotNone(css.rotate) || $82612ea812da90df$var$isNotNone(css.perspective) || !$82612ea812da90df$export$78551043582a6a98() && ($82612ea812da90df$var$isNotNone(css.backdropFilter) || $82612ea812da90df$var$isNotNone(css.filter)) || $82612ea812da90df$var$willChangeRe.test(css.willChange || '') || $82612ea812da90df$var$containRe.test(css.contain || '');
}
function $82612ea812da90df$export$940d8225183e1404(element) {
    let currentNode = $82612ea812da90df$export$4e12058fc4d51d56(element);
    while($82612ea812da90df$export$1b3bfaa9684536aa(currentNode) && !$82612ea812da90df$export$d1162fb0b6d4cd51(currentNode)){
        if ($82612ea812da90df$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($82612ea812da90df$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $82612ea812da90df$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $82612ea812da90df$export$78551043582a6a98() {
    if ($82612ea812da90df$var$isWebKitValue == null) $82612ea812da90df$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $82612ea812da90df$var$isWebKitValue;
}
function $82612ea812da90df$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($82612ea812da90df$export$651544f548703224(node));
}
function $82612ea812da90df$export$3735103072e4a80(element) {
    return $82612ea812da90df$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $82612ea812da90df$export$dc8fc79fa2800137(element) {
    if ($82612ea812da90df$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $82612ea812da90df$export$4e12058fc4d51d56(node) {
    if ($82612ea812da90df$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $82612ea812da90df$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $82612ea812da90df$export$e495491855dc5418(node);
    return $82612ea812da90df$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $82612ea812da90df$export$7cd01a57c8ca906c(node) {
    const parentNode = $82612ea812da90df$export$4e12058fc4d51d56(node);
    if ($82612ea812da90df$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($82612ea812da90df$export$1b3bfaa9684536aa(parentNode) && $82612ea812da90df$export$989e911fa9af580a(parentNode)) return parentNode;
    return $82612ea812da90df$export$7cd01a57c8ca906c(parentNode);
}
function $82612ea812da90df$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $82612ea812da90df$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $82612ea812da90df$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $82612ea812da90df$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $82612ea812da90df$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $82612ea812da90df$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $82612ea812da90df$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $82612ea812da90df$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("91EMH", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $a36a9f1493baf601$export$e001f626511a0ead);

var $fc4bM = parcelRequire("fc4bM");
const $a36a9f1493baf601$export$e001f626511a0ead = /*#__PURE__*/ (0, $fc4bM.createContext)(null);

});

parcelRegister("i26Al", function(module, exports) {
$parcel$export(module.exports, "MenuPortalTopLayer", () => $d6533c12a0bfae3c$export$1f5427c7f5364d0b);
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $GyLDf = parcelRequire("GyLDf");

var $lz1tR = parcelRequire("lz1tR");

var $02Byl = parcelRequire("02Byl");

var $2GKQh = parcelRequire("2GKQh");

var $i0F9y = parcelRequire("i0F9y");
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $d6533c12a0bfae3c$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const $d6533c12a0bfae3c$var$menuPortalStyles = {
    root: "_1e0c1txw _2lx21bp4 _ugzyidpf"
};
function $d6533c12a0bfae3c$export$1f5427c7f5364d0b(props) {
    const { additionalInsideElementRefs: additionalInsideElementRefsProp, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, $fc4bM.useContext)((0, $i0F9y.MenuPortalCloseContext));
    const popoverRef = (0, $fc4bM.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, $fc4bM.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null;
    const additionalInsideElementRefs = (0, $fc4bM.useMemo)(()=>[
            anchorRef,
            ...additionalInsideElementRefsProp ?? []
        ], [
        additionalInsideElementRefsProp,
        anchorRef
    ]);
    // Inline rather than memoised: `useAnchoredPopover` re-derives a stable
    // placement from the primitive fields.
    (0, $lz1tR.useAnchoredPopover)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $d6533c12a0bfae3c$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            // Keep the popover separated from the control, even when it flips to the opposite side.
            offset: {
                gap: "var(--ds-space-100, 8px)"
            }
        },
        isOpen: isAnchored,
        inlineSize: 'match-anchor',
        // Fit long menus into available space, rather than only capping at the full viewport height.
        blockSize: 'max-available'
    });
    const handlePopoverClose = (0, $fc4bM.useCallback)((args)=>{
        if (closeSelect) closeSelect(args);
    }, [
        closeSelect
    ]);
    (0, $02Byl.useManualLightDismiss)({
        popoverRef: popoverRef,
        additionalInsideElementRefs: additionalInsideElementRefs,
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className: className } = (0, $2GKQh.getStyleProps)({
        ...props,
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }, 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // Select owns dismissal so both its external control and menu count as inside.
    //
    // Passing `onClose` makes the menu a closable open layer: `hasOpenDialogOrPopover()`
    // counts it, and `requestClosePopovers()` (Modal / Drawer) closes it
    // through `onClose({ reason: 'programmatic' })`.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // `className` carries consumer `styles.menuPortal({...})` output,
            // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
            // is a legacy selector hook kept for parity with MenuPortalLegacy.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
            className: (0, $2R2iS.default)([
                $d6533c12a0bfae3c$var$menuPortalStyles.root,
                (0, $jdt4T.cx)(className, xcss, '-MenuPortal')
            ]),
            ...innerProps,
            children: children
        })
    });
}

});
parcelRegister("i0F9y", function(module, exports) {
$parcel$export(module.exports, "MenuPortalCloseContext", () => $c37329d98a135138$export$a0d5b29fa9affc38);

var $fc4bM = parcelRequire("fc4bM");
const $c37329d98a135138$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});



parcelRegister("ieqMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3d0d65506693c2$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value.tsx generated by @compiled/babel-plugin v3.0.2 */ // Renders default multi-value content while the shared wrapper owns layout motion and truncation.

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2qXP3 = parcelRequire("2qXP3");

var $2GKQh = parcelRequire("2GKQh");

var $1hHgV = parcelRequire("1hHgV");

var $84jWs = parcelRequire("84jWs");

var $kf3nM = parcelRequire("kf3nM");

var $avowk = parcelRequire("avowk");
const $ad3d0d65506693c2$var$multiValueTagWrapperStyles = {
    root: "_1e0c1bgi"
};
// Tag-like color styles
const $ad3d0d65506693c2$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
const $ad3d0d65506693c2$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $ad3d0d65506693c2$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $ad3d0d65506693c2$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
const $ad3d0d65506693c2$var$MultiValueContent = (contentProps)=>{
    const { hasEllipsis: hasEllipsis, multiValueProps: props, motionState: motionState, truncationRef: truncationRef } = contentProps;
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $ad3d0d65506693c2$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const isEnteringWithMotion = motionState === 'entering';
    const isExitingWithMotion = motionState === 'exiting';
    const isWidthAnimating = isEnteringWithMotion || isExitingWithMotion;
    const { css: containerCss, className: containerClassName } = (0, $2GKQh.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $2GKQh.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $2GKQh.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $kf3nM.MultiValueLabel);
    const hasCustomContainer = Container !== (0, $84jWs.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $1hHgV.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onMouseDown: (event)=>{
                if (event.target instanceof Element && event.target.closest('button')) {
                    var _removeProps$onMouseD;
                    (_removeProps$onMouseD = removeProps.onMouseDown) === null || _removeProps$onMouseD === void 0 || _removeProps$onMouseD.call(removeProps, event);
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $2R2iS.default)([
                $ad3d0d65506693c2$var$multiValueTagWrapperStyles.root,
                (0, $jdt4T.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2qXP3.default), {
                text: labelText,
                isRemovable: !isDisabled,
                onBeforeRemoveAction: ()=>{
                    var _removeProps$onClick;
                    (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    }
    // tag-like path for custom content
    if (!hasCustomContainer) {
        const colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $2R2iS.default)([
                $ad3d0d65506693c2$var$multiValueTagLikeStyles.root,
                $ad3d0d65506693c2$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $ad3d0d65506693c2$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $ad3d0d65506693c2$var$tagLikeColorStyles.green,
                colorKey === 'red' && $ad3d0d65506693c2$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $ad3d0d65506693c2$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $ad3d0d65506693c2$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $ad3d0d65506693c2$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $ad3d0d65506693c2$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $ad3d0d65506693c2$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $ad3d0d65506693c2$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $ad3d0d65506693c2$var$multiValueTagLikeStyles.disabled,
                isFocused && $ad3d0d65506693c2$var$multiValueTagLikeStyles.focused,
                (0, $jdt4T.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    className: (0, $2R2iS.default)([
                        $ad3d0d65506693c2$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName,
                            ref: truncationRef
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: (cropWithEllipsis || cropWithEllipsis === undefined) && (!isWidthAnimating || hasEllipsis),
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, $3LM7S.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName,
                    ref: truncationRef
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
const $ad3d0d65506693c2$var$MotionMultiValue = ({ multiValueProps: multiValueProps })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $avowk.default), {
        onMotionFinish: multiValueProps.onMotionFinish,
        shouldMeasureTruncation: true,
        children: ({ hasEllipsis: hasEllipsis, motionState: motionState, truncationRef: truncationRef })=>/*#__PURE__*/ (0, $3LM7S.jsx)($ad3d0d65506693c2$var$MultiValueContent, {
                hasEllipsis: hasEllipsis,
                multiValueProps: multiValueProps,
                motionState: motionState,
                truncationRef: truncationRef
            })
    });
const $ad3d0d65506693c2$var$MultiValue = (props)=>{
    const { Container: Container, Label: Label } = props.components;
    const selectStyles = props.selectProps.styles;
    const selectClassNames = props.selectProps.classNames;
    const selectGetStyles = (0, $1hHgV.useSelectGetStyles)();
    // The standard Tag already owns its width and truncation motion. Tag-like custom values do not,
    // so they continue through MultiValueMotion below.
    const hasSelfManagedTagMotion = typeof props.children === 'string' && Label === (0, $kf3nM.MultiValueLabel) && Container === (0, $84jWs.MultiValueContainer) && !(selectStyles !== null && selectStyles !== void 0 && selectStyles.multiValue) && !(selectStyles !== null && selectStyles !== void 0 && selectStyles.multiValueLabel) && !(selectStyles !== null && selectStyles !== void 0 && selectStyles.multiValueRemove) && !(selectClassNames !== null && selectClassNames !== void 0 && selectClassNames.multiValue) && !(selectClassNames !== null && selectClassNames !== void 0 && selectClassNames.multiValueLabel) && !(selectClassNames !== null && selectClassNames !== void 0 && selectClassNames.multiValueRemove) && (selectGetStyles === undefined || props.getStyles === selectGetStyles);
    if (props.isMotionEnabled && !hasSelfManagedTagMotion) return /*#__PURE__*/ (0, $3LM7S.jsx)($ad3d0d65506693c2$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($ad3d0d65506693c2$var$MultiValueContent, {
        multiValueProps: props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ad3d0d65506693c2$export$2e2bcd8739ae039 = $ad3d0d65506693c2$var$MultiValue;

});
parcelRegister("2qXP3", function(module, exports) {
$parcel$export(module.exports, "default", () => $04b3c2ec29688ab0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5F9eY = parcelRequire("5F9eY");

var $9JZL9 = parcelRequire("9JZL9");

var $lsag9 = parcelRequire("lsag9");

var $6grAF = parcelRequire("6grAF");

var $gVOWU = parcelRequire("gVOWU");

var $e1Lq5 = parcelRequire("e1Lq5");
const $04b3c2ec29688ab0$var$packageName = undefined;
const $04b3c2ec29688ab0$var$packageVersion = undefined;
const $04b3c2ec29688ab0$var$defaultBeforeRemoveAction = ()=>true;
const $04b3c2ec29688ab0$var$RemovableTagComponent = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $04b3c2ec29688ab0$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $9JZL9.default), maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }, ref)=>{
    const normalizedText = (0, $6grAF.getTagText)(text);
    // Wrap the analytics dispatcher so it fires synchronously when removal is
    // confirmed (matching the pre-flag-removal behaviour where analytics fired
    // immediately on button click, not after the CSS exit animation).
    const fireRemovedAnalytics = (0, $5F9eY.useCallbackWithAnalytics)((0, $9JZL9.default), {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $04b3c2ec29688ab0$var$packageName,
            packageVersion: $04b3c2ec29688ab0$var$packageVersion
        }
    }, 'atlaskit');
    // Intercept onBeforeRemoveAction: fire analytics and call onAfterRemoveAction
    // synchronously when removal is approved. This matches the pre-feature-flag
    // behaviour where both fired immediately on button click, not after the CSS
    // exit animation completes (which never fires in jsdom test environments).
    const onBeforeRemoveActionWithAnalytics = (0, $fc4bM.useCallback)(()=>{
        const shouldRemove = onBeforeRemoveAction();
        if (shouldRemove) {
            fireRemovedAnalytics(normalizedText);
            onAfterRemoveAction(normalizedText);
        }
        return shouldRemove;
    }, [
        onBeforeRemoveAction,
        fireRemovedAnalytics,
        normalizedText,
        onAfterRemoveAction
    ]);
    // TagNew handles its own animation internally via RemovableWrapper
    const newColor = (0, $lsag9.colorMapping)[color || 'standard'];
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e1Lq5.default), {
        ref: ref,
        color: newColor,
        text: normalizedText,
        elemBefore: elemBefore,
        href: href,
        linkComponent: linkComponent,
        testId: testId,
        isRemovable: isRemovable,
        removeButtonLabel: removeButtonLabel,
        onBeforeRemoveAction: onBeforeRemoveActionWithAnalytics,
        maxWidth: maxWidth,
        hasMargin: hasMargin,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $04b3c2ec29688ab0$var$RemovableTag = (0, $gVOWU.markAsTagMotionCapable)(/*#__PURE__*/ (0, $fc4bM.memo)($04b3c2ec29688ab0$var$RemovableTagComponent));
var $04b3c2ec29688ab0$export$2e2bcd8739ae039 = $04b3c2ec29688ab0$var$RemovableTag;

});
parcelRegister("5F9eY", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $394ab44c53b5cd94$export$53c2b9c37c40e0d8);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $7nxW1 = parcelRequire("7nxW1");
const $394ab44c53b5cd94$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const methodRef = (0, $7nxW1.useTrackedRef)(method);
    const payloadRef = (0, $7nxW1.useTrackedRef)(payload);
    return (0, $fc4bM.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("lsag9", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $2cdd1a2f71cbcc91$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $2cdd1a2f71cbcc91$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("6grAF", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $c3d68f0a8a687742$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $c3d68f0a8a687742$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;

});

parcelRegister("gVOWU", function(module, exports) {
$parcel$export(module.exports, "markAsTagMotionCapable", () => $d0509af4fade9553$export$88b132e52a65ec37);
const $d0509af4fade9553$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $d0509af4fade9553$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $d0509af4fade9553$var$tagMotionCapability, {
        value: true
    });
    return component;
}

});

parcelRegister("e1Lq5", function(module, exports) {
$parcel$export(module.exports, "default", () => $100d65d16a4a49b4$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v3.0.2 */ /* tag-new.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // Clips tag text during motion and restores ellipsis only when the settled label truncates.

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $13zmE = parcelRequire("13zmE");

var $dRkX9 = parcelRequire("dRkX9");

var $EawnW = parcelRequire("EawnW");

var $hculA = parcelRequire("hculA");

var $lsag9 = parcelRequire("lsag9");

var $6grAF = parcelRequire("6grAF");

var $eYm4L = parcelRequire("eYm4L");

var $bahGN = parcelRequire("bahGN");

var $7B3zf = parcelRequire("7B3zf");

var $ecmAg = parcelRequire("ecmAg");

var $gVOWU = parcelRequire("gVOWU");

var $30G3Y = parcelRequire("30G3Y");

var $5srgP = parcelRequire("5srgP");

var $hOqtj = parcelRequire("hOqtj");

var $kfoZL = parcelRequire("kfoZL");
const $100d65d16a4a49b4$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61 _1rfu1q9c",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $100d65d16a4a49b4$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $100d65d16a4a49b4$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $100d65d16a4a49b4$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const $100d65d16a4a49b4$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $100d65d16a4a49b4$var$TagNewComponent = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $6grAF.getTagText)(text);
    const isMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-labels');
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $kfoZL.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $fc4bM.useCallback)(()=>{
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $5srgP.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $30G3Y.useButtonInteraction)();
    const removeButton = (0, $hOqtj.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const renderTagContent = (tagRef, isEntering = false, isExiting = false, hasEllipsis = null)=>/*#__PURE__*/ (0, $3LM7S.jsxs)("span", {
            ...other,
            ref: tagRef,
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- maxWidth is a runtime consumer value
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $2R2iS.default)([
                $100d65d16a4a49b4$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $100d65d16a4a49b4$var$styles.noMarginStyles,
                $100d65d16a4a49b4$var$colorStyles[color],
                $100d65d16a4a49b4$var$borderIconFilterStyles.root,
                isLink && $100d65d16a4a49b4$var$styles.interactiveBaseStyles,
                isLink && $100d65d16a4a49b4$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $100d65d16a4a49b4$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $100d65d16a4a49b4$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $100d65d16a4a49b4$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $100d65d16a4a49b4$var$styles.interactiveHoverStyles,
                isRemovable && $100d65d16a4a49b4$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $100d65d16a4a49b4$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $100d65d16a4a49b4$var$styles.trailingMetricEndPadding
            ]),
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $eYm4L.LinkWrapper), {
                    isLink: isLink,
                    href: href,
                    LinkComponent: LinkComponent,
                    testId: testId,
                    linkHandlers: linkHandlers,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7B3zf.default), {
                            colorKey: color,
                            swatchBefore: swatchBefore,
                            swatchBeforeLabel: swatchBeforeLabel,
                            swatchBeforeRole: swatchBeforeRole
                        }),
                        elemBefore && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                            className: (0, $2R2iS.default)([
                                $100d65d16a4a49b4$var$styles.beforeStyles
                            ]),
                            children: elemBefore
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                            "data-tag-text": true,
                            className: (0, $2R2iS.default)([
                                $100d65d16a4a49b4$var$styles.textStyles,
                                hasEllipsis === false ? $100d65d16a4a49b4$var$styles.textClip : $100d65d16a4a49b4$var$styles.textEllipsis
                            ]),
                            children: normalizedText
                        }),
                        trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                            "data-testid": testId && `${testId}--metric`,
                            className: (0, $2R2iS.default)([
                                $100d65d16a4a49b4$var$styles.trailingMetric
                            ]),
                            children: trailingMetric
                        })
                    ]
                }),
                removeButton && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    className: (0, $2R2iS.default)([
                        $100d65d16a4a49b4$var$styles.afterStyles,
                        isMotionEnabled && $100d65d16a4a49b4$var$styles.afterMotionStyles
                    ]),
                    children: !isExiting && removeButton
                })
            ]
        });
    if (isMotionEnabled) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ecmAg.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status,
        children: ({ hasEllipsis: hasEllipsis, isEntering: isEntering, isExiting: isExiting, ref: motionRef })=>renderTagContent(motionRef, isEntering, isExiting, hasEllipsis)
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bahGN.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: renderTagContent(ref)
    });
});
const $100d65d16a4a49b4$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $lsag9.colorMapping)[color] || 'gray';
    const isMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $EawnW.Pressable), {
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $jdt4T.cx)($100d65d16a4a49b4$var$styles.baseStyles, !hasMargin && $100d65d16a4a49b4$var$styles.noMarginStyles, $100d65d16a4a49b4$var$colorStyles[resolvedColor], $100d65d16a4a49b4$var$borderIconFilterStyles.root, $100d65d16a4a49b4$var$dropdownStyles.interactive, $100d65d16a4a49b4$var$styles.focusRingStyles, $100d65d16a4a49b4$var$borderIconInteractiveFilterStyles.root, isSelected && $100d65d16a4a49b4$var$dropdownStyles.selected, isMotionEnabled && $100d65d16a4a49b4$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $100d65d16a4a49b4$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsxs)("span", {
                className: (0, $2R2iS.default)([
                    $100d65d16a4a49b4$var$dropdownStyles.content,
                    isMotionEnabled && $100d65d16a4a49b4$var$dropdownStyles.loadingMotion,
                    isLoading && $100d65d16a4a49b4$var$dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7B3zf.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore,
                        swatchBeforeLabel: swatchBeforeLabel,
                        swatchBeforeRole: swatchBeforeRole
                    }),
                    elemBefore && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                        className: (0, $2R2iS.default)([
                            $100d65d16a4a49b4$var$styles.beforeStyles,
                            isSelected && $100d65d16a4a49b4$var$styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $2R2iS.default)([
                            $100d65d16a4a49b4$var$styles.textStyles,
                            $100d65d16a4a49b4$var$styles.textEllipsis,
                            isSelected && $100d65d16a4a49b4$var$styles.textStylesSelected
                        ]),
                        children: (0, $6grAF.getTagText)(text)
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $2R2iS.default)([
                            $100d65d16a4a49b4$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    }),
                    hasChevron && /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && `${testId}--chevron`
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                className: (0, $2R2iS.default)([
                    $100d65d16a4a49b4$var$dropdownStyles.loadingOverlay,
                    isMotionEnabled && $100d65d16a4a49b4$var$dropdownStyles.loadingOverlayMotion
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
});
/**
 * __Tag new__
 */ const $100d65d16a4a49b4$var$TagNew = (0, $gVOWU.markAsTagMotionCapable)(/*#__PURE__*/ (0, $fc4bM.memo)($100d65d16a4a49b4$var$TagNewComponent));
var $100d65d16a4a49b4$export$2e2bcd8739ae039 = $100d65d16a4a49b4$var$TagNew;

});
parcelRegister("eYm4L", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $979dce6cd414ae75$export$ce4b6a469c26f53f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
function $979dce6cd414ae75$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $3LM7S.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
        children: children
    });
}

});

parcelRegister("bahGN", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $a69ff03a8a073d44$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $iXBtU = parcelRequire("iXBtU");

var $9kv6p = parcelRequire("9kv6p");

var $kpaYu = parcelRequire("kpaYu");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const $a69ff03a8a073d44$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $a69ff03a8a073d44$var$motionWrapperStyles = null;
function $a69ff03a8a073d44$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
        children: !(status === (0, $kpaYu.TagStatus).Removed) && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9kv6p.default), {
            onFinish: onShrinkOutExitComplete ? (phase)=>{
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: (motion)=>/*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    ref: motion.ref,
                    className: (0, $2R2iS.default)([
                        "_1e0c116y"
                    ]),
                    children: children
                })
        }, $a69ff03a8a073d44$var$removableShrinkOutChildKey)
    });
    return children;
}

});
parcelRegister("9kv6p", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc08486cc58a63a2$export$2e2bcd8739ae039);

var $9dmSL = parcelRequire("9dmSL");

var $kUMs0 = parcelRequire("kUMs0");

var $iGr40 = parcelRequire("iGr40");

var $1JUTA = parcelRequire("1JUTA");

var $1pnHp = parcelRequire("1pnHp");

var $8Xjx2 = parcelRequire("8Xjx2");

var $8vg2n = parcelRequire("8vg2n");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $fc08486cc58a63a2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $iGr40.useElementRef)();
    const exiting = (0, $8vg2n.useExitingPersistence)();
    const requestAnimationFrame = (0, $1pnHp.useRequestAnimationFrame)();
    const setTimeout = (0, $8Xjx2.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $1JUTA.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $kUMs0.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $9dmSL.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $9dmSL.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $fc08486cc58a63a2$export$2e2bcd8739ae039 = $fc08486cc58a63a2$var$ShrinkOut;

});

parcelRegister("kpaYu", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $38a45b4011666726$export$74452314b63acabc);
// Tag status enum
var $38a45b4011666726$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("7B3zf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4ee3bdf270b9f7d$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $b4ee3bdf270b9f7d$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $b4ee3bdf270b9f7d$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $b4ee3bdf270b9f7d$export$2e2bcd8739ae039({ colorKey: colorKey, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...swatchBeforeLabel && swatchBeforeRole ? {
            'aria-label': swatchBeforeLabel,
            role: swatchBeforeRole
        } : {},
        className: (0, $2R2iS.default)([
            $b4ee3bdf270b9f7d$var$tagSwatchBeforeStyles.swatch,
            $b4ee3bdf270b9f7d$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...swatchBeforeLabel && swatchBeforeRole ? {
            'aria-label': swatchBeforeLabel,
            role: swatchBeforeRole
        } : {},
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $2R2iS.default)([
            $b4ee3bdf270b9f7d$var$tagSwatchBeforeStyles.swatch
        ])
    });
}

});

parcelRegister("ecmAg", function(module, exports) {
$parcel$export(module.exports, "TagMotion", () => $6737a4fa226c537c$export$6adae1772ccf137c);
/* tag-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Measures settled truncation in onStart while useMotion drives each width animation phase.

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4dCfH = parcelRequire("4dCfH");

var $2ggqN = parcelRequire("2ggqN");

var $iXBtU = parcelRequire("iXBtU");

var $8vg2n = parcelRequire("8vg2n");

var $kpaYu = parcelRequire("kpaYu");
const $6737a4fa226c537c$var$tagMotionKey = 'atlaskit-tag-motion';
const $6737a4fa226c537c$var$motionWrapperStyles = {
    root: "_1reo15vq _18m915vq _1e0c1n7u _yv0ei47z",
    entering: "_y44vkz8f",
    exiting: "_y44v1rag",
    reducedMotion: "_1bumglyw"
};
const $6737a4fa226c537c$var$motionContentStyles = {
    root: "_1rjc1b66 _18zr1b66 _1e0c1txw _1ul9idpf"
};
function $6737a4fa226c537c$var$TagMotionContent({ children: children, forwardedRef: forwardedRef, hasMargin: hasMargin, onExitComplete: onExitComplete }) {
    const [motionPhase, setMotionPhase] = (0, $fc4bM.useState)(null);
    const [hasEllipsis, setHasEllipsis] = (0, $fc4bM.useState)(null);
    const motionElementRef = (0, $fc4bM.useRef)(null);
    const { ref: motionRef, state: state } = (0, $2ggqN.useMotion)({
        onStart: (phase)=>{
            if (motionElementRef.current) {
                const motionElement = motionElementRef.current;
                const inlineAnimation = motionElement.style.animation;
                motionElement.style.animation = 'none';
                const textElement = motionElement.querySelector('[data-tag-text]');
                setHasEllipsis(Boolean(textElement && textElement.scrollWidth > textElement.clientWidth));
                motionElement.style.animation = inlineAnimation;
            }
            setMotionPhase(phase);
        },
        onFinish: (phase)=>{
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    });
    const mergedMotionRef = (0, $fc4bM.useMemo)(()=>(0, $4dCfH.default)([
            motionElementRef,
            motionRef
        ]), [
        motionRef
    ]);
    const onAnimationEnd = (0, $fc4bM.useCallback)((event)=>{
        if (event.target === event.currentTarget) setMotionPhase(null);
    }, []);
    const activeMotionPhase = state === 'entering' || state === 'exiting' ? state : motionPhase;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ref: mergedMotionRef,
        onAnimationEnd: onAnimationEnd,
        className: (0, $2R2iS.default)([
            $6737a4fa226c537c$var$motionWrapperStyles.root,
            activeMotionPhase === 'entering' && $6737a4fa226c537c$var$motionWrapperStyles.entering,
            activeMotionPhase === 'exiting' && $6737a4fa226c537c$var$motionWrapperStyles.exiting,
            $6737a4fa226c537c$var$motionWrapperStyles.reducedMotion
        ]),
        children: hasMargin ? /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            className: (0, $2R2iS.default)([
                $6737a4fa226c537c$var$motionContentStyles.root
            ]),
            children: children({
                hasEllipsis: hasEllipsis,
                isEntering: activeMotionPhase === 'entering',
                isExiting: activeMotionPhase === 'exiting',
                ref: forwardedRef
            })
        }) : children({
            hasEllipsis: hasEllipsis,
            isEntering: activeMotionPhase === 'entering',
            isExiting: activeMotionPhase === 'exiting',
            ref: forwardedRef
        })
    });
}
function $6737a4fa226c537c$export$6adae1772ccf137c({ children: children, forwardedRef: forwardedRef, hasMargin: hasMargin, onExitComplete: onExitComplete, status: status }) {
    const outerPresence = (0, $8vg2n.useExitingPersistence)();
    const isRemoved = status === (0, $kpaYu.TagStatus).Removed || outerPresence.isExiting;
    const shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    const latestExitState = (0, $fc4bM.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    const onMotionExitComplete = (0, $fc4bM.useCallback)(()=>{
        const latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $kpaYu.TagStatus).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
        appear: shouldAppear,
        children: !isRemoved && /*#__PURE__*/ (0, $3LM7S.jsx)($6737a4fa226c537c$var$TagMotionContent, {
            forwardedRef: forwardedRef,
            hasMargin: hasMargin,
            onExitComplete: onMotionExitComplete,
            children: children
        }, $6737a4fa226c537c$var$tagMotionKey)
    });
}

});

parcelRegister("30G3Y", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $6b63bda52d269099$export$84acd183858d8235);

var $fc4bM = parcelRequire("fc4bM");
function $6b63bda52d269099$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $fc4bM.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $fc4bM.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $fc4bM.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $fc4bM.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $fc4bM.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $fc4bM.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $fc4bM.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("5srgP", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $4bc2ec18c97d1a79$export$dcf14c9974fe2767);

var $dM0Q8 = parcelRequire("dM0Q8");
function $4bc2ec18c97d1a79$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $dM0Q8.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("hOqtj", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $0f6a4d1e1729a517$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $Ed6O7 = parcelRequire("Ed6O7");
function $0f6a4d1e1729a517$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $fc4bM.useCallback)(()=>{
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $fc4bM.useCallback)(()=>{
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $fc4bM.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $Ed6O7.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("Ed6O7", function(module, exports) {
$parcel$export(module.exports, "default", () => $755a86a62c2b4f1b$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v3.0.2 */ /* remove-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $gV8E5 = parcelRequire("gV8E5");

var $EawnW = parcelRequire("EawnW");
const $755a86a62c2b4f1b$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const $755a86a62c2b4f1b$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
        xcss: (0, $4Cnkn.cx)($755a86a62c2b4f1b$var$removeButtonStyles.root, shape === 'circle' && $755a86a62c2b4f1b$var$removeButtonStyles.circle, $755a86a62c2b4f1b$var$removeButtonStyles.newIcon, $755a86a62c2b4f1b$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$755a86a62c2b4f1b$export$2e2bcd8739ae039 = $755a86a62c2b4f1b$var$RemoveButton;

});


parcelRegister("kfoZL", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $fb0a1efa3b20e89f$export$f26019543e9f862f);

var $fc4bM = parcelRequire("fc4bM");

var $cHodE = parcelRequire("cHodE");

var $kpaYu = parcelRequire("kpaYu");
function $fb0a1efa3b20e89f$export$f26019543e9f862f(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $fc4bM.useState)((0, $kpaYu.TagStatus).Showing);
    const handleRemoveRequest = (0, $fc4bM.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $cHodE.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $kpaYu.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $fc4bM.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $fc4bM.useCallback)(()=>setStatus((0, $kpaYu.TagStatus).Removing), []);
    const showingTag = (0, $fc4bM.useCallback)(()=>setStatus((0, $kpaYu.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("cHodE", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $7bbb8482ceac9014$export$279e7025ed114474);
const $7bbb8482ceac9014$export$279e7025ed114474 = ()=>true;

});




parcelRegister("1hHgV", function(module, exports) {
$parcel$export(module.exports, "useSelectGetStyles", () => $b4805e4591969dff$export$2a533455c10aa11f);
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $9T6kV = parcelRequire("9T6kV");
const $b4805e4591969dff$export$2a533455c10aa11f = ()=>(0, $fc4bM.useContext)((0, $9T6kV.SelectGetStylesContext));

});
parcelRegister("9T6kV", function(module, exports) {
$parcel$export(module.exports, "SelectGetStylesContext", () => $0c89d7e4aff8a0f2$export$50727c0a52da4015);
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $fc4bM = parcelRequire("fc4bM");
const $0c89d7e4aff8a0f2$export$50727c0a52da4015 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);

});


parcelRegister("kf3nM", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $66f1cb3d7de174c1$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value-label.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");
const $66f1cb3d7de174c1$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $66f1cb3d7de174c1$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $66f1cb3d7de174c1$var$multiValueLabelStyles.root,
            isDisabled && $66f1cb3d7de174c1$var$multiValueLabelStyles.disabled,
            hasEllipsis && $66f1cb3d7de174c1$var$multiValueLabelStyles.ellipsis,
            (0, $jdt4T.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};

});

parcelRegister("avowk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba1325eefc1de0b7$export$2e2bcd8739ae039);
/* multi-value-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Reflows any multi-value renderer with shared label motion and optional settled truncation.

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4dCfH = parcelRequire("4dCfH");

var $2ggqN = parcelRequire("2ggqN");
const $ba1325eefc1de0b7$var$motionWrapperStyles = {
    root: "_1reo15vq _18m915vq _1e0c1n7u _yv0ei47z",
    entering: "_y44vkz8f",
    exiting: "_y44v1rag",
    reducedMotion: "_1bumglyw"
};
function $ba1325eefc1de0b7$export$2e2bcd8739ae039({ children: children, onMotionFinish: onMotionFinish, shouldMeasureTruncation: shouldMeasureTruncation = false }) {
    const truncationElementRef = (0, $fc4bM.useRef)(null);
    const motionElementRef = (0, $fc4bM.useRef)(null);
    const [hasEllipsis, setHasEllipsis] = (0, $fc4bM.useState)(false);
    const updateMultiValueTruncation = (0, $fc4bM.useCallback)(()=>{
        const label = truncationElementRef.current;
        const motionElement = motionElementRef.current;
        if (label && motionElement) {
            const inlineAnimation = motionElement.style.animation;
            motionElement.style.animation = 'none';
            setHasEllipsis(label.scrollWidth > label.clientWidth);
            motionElement.style.animation = inlineAnimation;
        }
    }, []);
    const truncationRef = (0, $fc4bM.useCallback)((node)=>{
        truncationElementRef.current = node;
    }, []);
    const { ref: motionRef, state: state } = (0, $2ggqN.useMotion)({
        onStart: shouldMeasureTruncation ? updateMultiValueTruncation : undefined,
        onFinish: (motionState)=>{
            if (motionState === 'exiting') onMotionFinish === null || onMotionFinish === void 0 || onMotionFinish();
        }
    });
    const mergedMotionRef = (0, $fc4bM.useMemo)(()=>(0, $4dCfH.default)([
            motionElementRef,
            motionRef
        ]), [
        motionRef
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: mergedMotionRef,
        className: (0, $2R2iS.default)([
            $ba1325eefc1de0b7$var$motionWrapperStyles.root,
            state === 'entering' && $ba1325eefc1de0b7$var$motionWrapperStyles.entering,
            state === 'exiting' && $ba1325eefc1de0b7$var$motionWrapperStyles.exiting,
            $ba1325eefc1de0b7$var$motionWrapperStyles.reducedMotion
        ]),
        children: children({
            hasEllipsis: hasEllipsis,
            motionState: state,
            truncationRef: truncationRef
        })
    });
}

});


parcelRegister("aYKOw", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $20ae36f934a93fba$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v3.0.2 */ /* multi-value-remove.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $gV8E5 = parcelRequire("gV8E5");
const $20ae36f934a93fba$var$disabledStyles = null;
const $20ae36f934a93fba$var$enabledStyles = null;
const $20ae36f934a93fba$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $20ae36f934a93fba$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $20ae36f934a93fba$var$multiValueRemoveStyles.root,
            isFocused && $20ae36f934a93fba$var$multiValueRemoveStyles.focused,
            (0, $jdt4T.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $2R2iS.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}

});

parcelRegister("hsZqz", function(module, exports) {
$parcel$export(module.exports, "default", () => $18bc340d1002b58a$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v3.0.2 */ /* option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $dRkX9 = parcelRequire("dRkX9");

var $2GKQh = parcelRequire("2GKQh");
const $18bc340d1002b58a$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    finesseFocused: "_16qsglyw _112eglyw",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
const $18bc340d1002b58a$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $18bc340d1002b58a$var$optionStyles.root,
            !isDisabled && !isSelected && $18bc340d1002b58a$var$optionStyles.motion,
            isFocused && $18bc340d1002b58a$var$optionStyles.focused,
            isFocused && !isSelected && (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $18bc340d1002b58a$var$optionStyles.finesseFocused,
            isSelected && $18bc340d1002b58a$var$optionStyles.selected,
            isFocused && isSelected && $18bc340d1002b58a$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && $18bc340d1002b58a$var$optionStyles.motionSelected,
            isDisabled && $18bc340d1002b58a$var$optionStyles.disabled,
            (0, $jdt4T.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18bc340d1002b58a$export$2e2bcd8739ae039 = $18bc340d1002b58a$var$Option;

});

parcelRegister("bWxAu", function(module, exports) {
$parcel$export(module.exports, "default", () => $98351560211bc214$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* placeholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $dRkX9 = parcelRequire("dRkX9");

var $2GKQh = parcelRequire("2GKQh");
const $98351560211bc214$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx",
    finesse: "_syazazsu"
};
const $98351560211bc214$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $98351560211bc214$var$placeholderStyles.root,
            (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $98351560211bc214$var$placeholderStyles.finesse,
            isDisabled && $98351560211bc214$var$placeholderStyles.disabled,
            (0, $jdt4T.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98351560211bc214$export$2e2bcd8739ae039 = $98351560211bc214$var$Placeholder;

});

parcelRegister("iSklz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a6de1b002ea1265$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v3.0.2 */ /* single-value.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $2GKQh = parcelRequire("2GKQh");
const $2a6de1b002ea1265$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $2a6de1b002ea1265$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $2GKQh.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2R2iS.default)([
            $2a6de1b002ea1265$var$styles.root,
            isDisabled && $2a6de1b002ea1265$var$styles.disalbed,
            (0, $jdt4T.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2a6de1b002ea1265$export$2e2bcd8739ae039 = $2a6de1b002ea1265$var$SingleValue;

});


parcelRegister("2WusX", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ca0673b0a199843$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $kTVlm = parcelRequire("kTVlm");

var $gDsF8 = parcelRequire("gDsF8");

var $fZH7o = parcelRequire("fZH7o");

var $hzrh0 = parcelRequire("hzrh0");
const $1ca0673b0a199843$var$ErrorMessage = ({ onRetry: onRetry })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = (0, $fc4bM.useCallback)(()=>{
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledBox), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $hzrh0.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $hzrh0.default).retryMessage)));
};
var $1ca0673b0a199843$export$2e2bcd8739ae039 = $1ca0673b0a199843$var$ErrorMessage;

});
parcelRegister("fZH7o", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $d74a141af0e051b9$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $d74a141af0e051b9$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $d74a141af0e051b9$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $d74a141af0e051b9$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $d74a141af0e051b9$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $d74a141af0e051b9$export$6833d6d22987ee7f);
$parcel$export(module.exports, "StyledInvalidCheckboxOption", () => $d74a141af0e051b9$export$e786733cafde97b9);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// Uses @compiled/react because descendant/child selectors and !important are not supported by the strict @atlaskit/css API.
const $d74a141af0e051b9$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    text: "_11c81qyo _19pku2gc",
    control: "_16qs130s _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    closeIconWrapper: "_80omtlke _syaz1rpy _f8pjazsu _30l3azsu"
};
const $d74a141af0e051b9$var$displayWrapperStyles = {
    shown: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
const $d74a141af0e051b9$var$styledBoxStyles = {
    box: "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1f4z _1bah1h6o"
};
const $d74a141af0e051b9$var$styledBoxIconStyles = {
    boxIcon: "_w8l5achg _1752achg"
};
const $d74a141af0e051b9$var$styledInvalidCheckboxOptionStyles = {
    invalidCheckboxOption: "_bfhk1gly _1e0c1txw _2lx2vrvc _4cvr1h6o _u5f3u2gc _w1w3jdj5"
};
const $d74a141af0e051b9$export$30c615a45297e297 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$styles.dropdownIndicatorWrapper
        ])
    }, children);
const $d74a141af0e051b9$export$d675f139b342d51a = ({ height: height, iconSize: iconSize, children: children, style: style, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        style: {
            '--paginated-picker-box-height': `${height || 128}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- runtime-only custom property derived from the iconSize prop
            ...iconSize ? {
                '--paginated-picker-icon-size': `${iconSize}px`
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- forwards a caller-provided runtime style object
            ...style
        },
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$styledBoxStyles.box,
            iconSize && ""
        ])
    }, children);
const $d74a141af0e051b9$export$31ea92f3997410dd = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$styles.text
        ])
    }, children);
const $d74a141af0e051b9$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$styles.control
        ])
    }, children));
const $d74a141af0e051b9$export$94756becb802e330 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$styles.closeIconWrapper
        ])
    }, children);
const $d74a141af0e051b9$export$6833d6d22987ee7f = ({ displayFlag: displayFlag, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$displayWrapperStyles[displayFlag ? 'shown' : 'hidden']
        ])
    }, children);
const $d74a141af0e051b9$export$e786733cafde97b9 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $d74a141af0e051b9$var$styledInvalidCheckboxOptionStyles.invalidCheckboxOption
        ])
    }, children);

});

parcelRegister("hzrh0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8ea4c5362b8db62$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $e8ea4c5362b8db62$var$message = (0, $8p5Cv.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});
var $e8ea4c5362b8db62$export$2e2bcd8739ae039 = $e8ea4c5362b8db62$var$message;

});


parcelRegister("kyuTj", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $869c26f4856f2abc$export$e928a71d039d3102);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $hculA = parcelRequire("hculA");

var $fZH7o = parcelRequire("fZH7o");

var $i1hjJ = parcelRequire("i1hjJ");
const $869c26f4856f2abc$export$e928a71d039d3102 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $i1hjJ.default).loadingMessage)));

});
parcelRegister("i1hjJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e5dad75e72abed7$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $4e5dad75e72abed7$var$message = (0, $8p5Cv.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});
var $4e5dad75e72abed7$export$2e2bcd8739ae039 = $4e5dad75e72abed7$var$message;

});


parcelRegister("j45Jf", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dc32131771481bb$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $kTVlm = parcelRequire("kTVlm");

var $k9cuH = parcelRequire("k9cuH");
const $7dc32131771481bb$var$ShowMoreButton = ({ onShowMore: onShowMore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $k9cuH.default).showMoreButtonText));
var $7dc32131771481bb$export$2e2bcd8739ae039 = $7dc32131771481bb$var$ShowMoreButton;

});
parcelRegister("k9cuH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5268c930e9f95c35$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $5268c930e9f95c35$var$message = (0, $8p5Cv.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});
var $5268c930e9f95c35$export$2e2bcd8739ae039 = $5268c930e9f95c35$var$message;

});


parcelRegister("kzCFc", function(module, exports) {
$parcel$export(module.exports, "LoadingWrapper", () => $3a1d4c9349defa4e$export$43a792a870d28db2);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $3a1d4c9349defa4e$var$styles = {
    loadingWrapper: "_1e0c1txw _1bah1h6o _19pk1b66 _otyr1b66"
};
const $3a1d4c9349defa4e$export$43a792a870d28db2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $3a1d4c9349defa4e$var$styles.loadingWrapper
        ])
    }, children);

});


parcelRegister("bOy64", function(module, exports) {
$parcel$export(module.exports, "PaginationDetails", () => $36fa2dd1534b0142$export$33eb0288c0936a84);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $kd4cI = parcelRequire("kd4cI");

var $kb2of = parcelRequire("kb2of");
const $36fa2dd1534b0142$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kb2of.PaginationDetailsStyled), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...totalCount === null ? (0, $kd4cI.default).loadedCount : (0, $kd4cI.default).ofTotalCount,
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    }));
var $36fa2dd1534b0142$export$2e2bcd8739ae039 = $36fa2dd1534b0142$export$33eb0288c0936a84;

});
parcelRegister("kd4cI", function(module, exports) {
$parcel$export(module.exports, "default", () => $97f881a645d0a2b6$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $97f881a645d0a2b6$var$message = (0, $8p5Cv.defineMessages)({
    loadedCount: {
        id: 'paginated-picker.async-select.pagination-details.loadedCount',
        defaultMessage: '{itemsCount} results',
        description: 'Shown in a paginated picker footer when the overall total is unknown. itemsCount is the number of results available so far.'
    },
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.'
    }
});
var $97f881a645d0a2b6$export$2e2bcd8739ae039 = $97f881a645d0a2b6$var$message;

});

parcelRegister("kb2of", function(module, exports) {
$parcel$export(module.exports, "PaginationDetailsStyled", () => $3b685ea9aa247463$export$fff9218028c24180);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $3b685ea9aa247463$var$styles = {
    paginationDetails: "_16jlkb7n _1o9zkb7n _i0dlf1ug _11c8fhey _y3gnusic _19pku2gc _otyru2gc _18u0pxbi _2hwxpxbi _syaz1rpy"
};
const $3b685ea9aa247463$export$fff9218028c24180 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $3b685ea9aa247463$var$styles.paginationDetails
        ])
    }, children);

});


parcelRegister("9d1np", function(module, exports) {
$parcel$export(module.exports, "selectComponents", () => $60a675b2abcb1926$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "LocalBaseSelect", () => $60a675b2abcb1926$export$51cc13ac81e51592);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $5vDl3 = parcelRequire("5vDl3");

var $aU5V0 = parcelRequire("aU5V0");

var $3ac6U = parcelRequire("3ac6U");

var $5N1Xu = parcelRequire("5N1Xu");

var $hkMBc = parcelRequire("hkMBc");

var $cnBYN = parcelRequire("cnBYN");

var $baVSx = parcelRequire("baVSx");
const $60a675b2abcb1926$export$c34d65c0f5a1c617 = {
    Control: $3ac6U.Control,
    DropdownIndicator: $5N1Xu.DropdownIndicator,
    LoadingIndicator: null,
    Menu: $hkMBc.Menu,
    Option: $baVSx.Option
};
const $60a675b2abcb1926$var$onIsOptionDisabled = (option)=>'error' in option ? !!option.error : false;
const $60a675b2abcb1926$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ onFilterOption: onFilterOption, placeholder: placeholder, ...restProps }, ref)=>{
    const intl = (0, $gpjDl.default)();
    const { ariaLabel: ariaLabelProp, isMulti: isMulti = true, onChange: onChangeProp, onInputChange: onInputChangeProp, inputValue: inputValueProp, value: value } = restProps;
    const effectiveIsMulti = isMulti;
    const [inputValue, setInputValue] = (0, $fc4bM.useState)(inputValueProp || '');
    const onInputChange = (0, $fc4bM.useCallback)((newValue, actionMeta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $aU5V0.MetaActions).setValue,
            (0, $aU5V0.MetaActions).inputBlur,
            (0, $aU5V0.MetaActions).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    const onChange = (0, $fc4bM.useCallback)((newValue, actionMeta)=>{
        // Keep this wrapper unconditional for both modes so hook creation stays stable.
        // In multiselect mode `newValue` is already an array, making this a no-op; in
        // single-select mode Atlaskit returns one option (or null), which we normalize
        // back to the array contract expected by the paginated-filter stack.
        const normalizedNewValue = Array.isArray(newValue) ? newValue : newValue ? [
            newValue
        ] : [];
        onChangeProp === null || onChangeProp === void 0 || onChangeProp(normalizedNewValue, actionMeta);
    }, [
        onChangeProp
    ]);
    const normalizedValue = effectiveIsMulti ? value : Array.isArray(value) ? value[0] ?? null : value ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5vDl3.default), {
        ...restProps,
        ref: ref,
        "aria-label": ariaLabelProp || intl.formatMessage((0, $cnBYN.default).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: !effectiveIsMulti,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: effectiveIsMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: ()=>intl.formatMessage((0, $cnBYN.default).noOptionsMessage),
        // Typescript fix: normalized onChange signature (single/multi) is not directly assignable to Select's onChange type
        onChange: onChange,
        onInputChange: onInputChange,
        isOptionDisabled: $60a675b2abcb1926$var$onIsOptionDisabled,
        filterOption: onFilterOption,
        placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $cnBYN.default).searchPlaceholder),
        // Typescript fix: normalized value shape (scalar vs array) is not assignable to Select's typed value
        value: normalizedValue
    });
});
$60a675b2abcb1926$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';

});
parcelRegister("5vDl3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ea3dd2c8f7f55748$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $8lxUN = parcelRequire("8lxUN");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $4eNkY = parcelRequire("4eNkY");
const $ea3dd2c8f7f55748$var$packageName = undefined;
const $ea3dd2c8f7f55748$var$packageVersion = undefined;
const $ea3dd2c8f7f55748$var$createAndFireEventOnAtlaskit = (0, $8lxUN.default)('atlaskit');
const $ea3dd2c8f7f55748$var$Select = (0, $613oU.default)({
    componentName: 'select',
    packageName: $ea3dd2c8f7f55748$var$packageName,
    packageVersion: $ea3dd2c8f7f55748$var$packageVersion
})((0, $azARG.default)({
    onChange: $ea3dd2c8f7f55748$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $ea3dd2c8f7f55748$var$packageName,
            packageVersion: $ea3dd2c8f7f55748$var$packageVersion
        }
    })
})((0, $4eNkY.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ea3dd2c8f7f55748$export$2e2bcd8739ae039 = $ea3dd2c8f7f55748$var$Select;

});
parcelRegister("8lxUN", function(module, exports) {
$parcel$export(module.exports, "default", () => $80c297fac0af8fe1$export$2e2bcd8739ae039);
var $80c297fac0af8fe1$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("4eNkY", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $b08c952fd8517ebb$export$d1de3b251ccaa8a3);

var $X9ALI = parcelRequire("X9ALI");

var $5eTWm = parcelRequire("5eTWm");
const $b08c952fd8517ebb$export$d1de3b251ccaa8a3 = (0, $5eTWm.default)((0, $X9ALI.default));

});
parcelRegister("X9ALI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f774a5a32a63fb79$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iM7Ff = parcelRequire("iM7Ff");

var $e1eEo = parcelRequire("e1eEo");

var $iJY8V = parcelRequire("iJY8V");
const $f774a5a32a63fb79$var$AsyncSelect = /*#__PURE__*/ (0, $fc4bM.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $e1eEo.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $iJY8V.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iM7Ff.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f774a5a32a63fb79$export$2e2bcd8739ae039 = $f774a5a32a63fb79$var$AsyncSelect;

});
parcelRegister("iM7Ff", function(module, exports) {
$parcel$export(module.exports, "default", () => $f210d7e14741e091$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v3.0.2 */ // Applies presence motion at the value-list boundary so default and custom values reflow together.

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $lGyLn = parcelRequire("lGyLn");

var $R8XYI = parcelRequire("R8XYI");

var $9JZL9 = parcelRequire("9JZL9");

var $iXBtU = parcelRequire("iXBtU");

var $dRkX9 = parcelRequire("dRkX9");

var $9MLZi = parcelRequire("9MLZi");

var $eVngU = parcelRequire("eVngU");

var $ibGZY = parcelRequire("ibGZY");

var $cFNB8 = parcelRequire("cFNB8");

var $avowk = parcelRequire("avowk");

var $jR8Mt = parcelRequire("jR8Mt");

var $73Tk8 = parcelRequire("73Tk8");

var $2Vsv2 = parcelRequire("2Vsv2");

var $71RWc = parcelRequire("71RWc");

var $cb0Va = parcelRequire("cb0Va");

var $8rkHO = parcelRequire("8rkHO");

var $6cdtc = parcelRequire("6cdtc");

var $i0F9y = parcelRequire("i0F9y");

var $f7TH6 = parcelRequire("f7TH6");

var $i4fs4 = parcelRequire("i4fs4");

var $jzr50 = parcelRequire("jzr50");

var $dL6OM = parcelRequire("dL6OM");

var $hy4p5 = parcelRequire("hy4p5");

var $9T6kV = parcelRequire("9T6kV");

var $aoBPB = parcelRequire("aoBPB");

var $bxhpS = parcelRequire("bxhpS");

var $cL6R7 = parcelRequire("cL6R7");
const $f210d7e14741e091$var$noop = (0, $9JZL9.default);
function $f210d7e14741e091$var$notNullish(item) {
    return item != null;
}
function $f210d7e14741e091$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $hy4p5.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $hy4p5.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $f210d7e14741e091$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $f210d7e14741e091$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const $f210d7e14741e091$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $f210d7e14741e091$var$elemBeforeCSS = null;
// Matches the duration of `motion.label.exit`; used only if a consumer render path
// unmounts the exiting values before their motion completion callback can run.
const $f210d7e14741e091$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS = 100;
const $f210d7e14741e091$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $f210d7e14741e091$var$isTouchCapable(),
    captureMenuScroll: !$f210d7e14741e091$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $jR8Mt.createFilter)(),
    formatGroupLabel: (0, $73Tk8.formatGroupLabel),
    getOptionLabel: (0, $2Vsv2.getOptionLabel),
    getOptionValue: (0, $71RWc.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $cL6R7.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$f210d7e14741e091$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $f210d7e14741e091$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $f210d7e14741e091$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $f210d7e14741e091$var$isOptionSelected(props, option, selectValue);
    const label = $f210d7e14741e091$var$getOptionLabel(props, option);
    const value = $f210d7e14741e091$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $f210d7e14741e091$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        // @ts-expect-error -- Option is unconstrained, but this check requires an object.
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$f210d7e14741e091$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$f210d7e14741e091$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $f210d7e14741e091$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $f210d7e14741e091$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($f210d7e14741e091$var$notNullish);
}
function $f210d7e14741e091$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $f210d7e14741e091$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $f210d7e14741e091$var$buildFocusableOptions(props, selectValue) {
    return $f210d7e14741e091$var$buildFocusableOptionsFromCategorizedOptions($f210d7e14741e091$var$buildCategorizedOptions(props, selectValue));
}
function $f210d7e14741e091$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$f210d7e14741e091$var$shouldHideSelectedOptions(props) || !isSelected) && $f210d7e14741e091$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $f210d7e14741e091$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $f210d7e14741e091$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $f210d7e14741e091$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    var _focusableOptionsWith;
    const focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find((option)=>option.data === focusedOption)) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
const $f210d7e14741e091$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $f210d7e14741e091$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $f210d7e14741e091$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $f210d7e14741e091$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $f210d7e14741e091$var$getOptionValue(props, option);
    return selectValue.some((i)=>$f210d7e14741e091$var$getOptionValue(props, i) === candidate);
}
function $f210d7e14741e091$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $f210d7e14741e091$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $f210d7e14741e091$var$instanceId = 1;
class $f210d7e14741e091$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    static #_ = this.defaultProps = $f210d7e14741e091$export$9c21a3269931e1e6;
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null,
            isMultiValueExiting: false,
            hasCompletedMultiValueExit: false
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.openAfterClick = null, this.scrollToFocusedOptionOnUpdate = false, this.multiValueExitFallbackTimeout = null, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, $dRkX9.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, this.onMultiValueMotionFinish = ()=>{
            if (this.state.isMultiValueExiting) this.setState({
                isMultiValueExiting: false,
                hasCompletedMultiValueExit: true,
                selectValue: []
            });
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onControlClick = ()=>{
            const focusOption = this.openAfterClick;
            this.openAfterClick = null;
            if (focusOption && !this.props.menuIsOpen) this.openMenu(focusOption);
        }, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $f7TH6.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $f7TH6.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $aoBPB.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $aoBPB.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $bxhpS.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $bxhpS.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $bxhpS.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $f210d7e14741e091$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $f210d7e14741e091$var$buildFocusableOptionsWithIds($f210d7e14741e091$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $cb0Va.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $f210d7e14741e091$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $f210d7e14741e091$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $f210d7e14741e091$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>{
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        }, this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $9MLZi.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$f210d7e14741e091$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$f210d7e14741e091$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterClick('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterClick('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $6cdtc.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer until
                // click. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterClick('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $dRkX9.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $f210d7e14741e091$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if ((0, $dRkX9.fg)('platform-dst-top-layer')) {
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            return;
                        }
                        if (isClearable && escapeClearsValue) {
                            this.clearValue();
                            return;
                        }
                        // With no open menu, leave native dismissal of containing popovers alone.
                        return;
                    }
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleMenuCloseSignal = (args)=>{
            if ((args === null || args === void 0 ? void 0 : args.reason) === 'escape') this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$f210d7e14741e091$var$instanceId);
        this.state.selectValue = (0, $8rkHO.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $f210d7e14741e091$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $8rkHO.cleanValue)(value);
        let isTagMotionEnabled = false;
        if (isMulti) {
            const ffTagMotion = (0, $dRkX9.fg)('platform-dst-motion-uplift-labels');
            isTagMotionEnabled = ffTagMotion;
        }
        const hasCompletedMultiValueExit = selectValue.length > 0 ? false : state.hasCompletedMultiValueExit;
        const isMultiValueExiting = isTagMotionEnabled && selectValue.length === 0 && !hasCompletedMultiValueExit && (state.isMultiValueExiting || state.selectValue.length > 0 && value !== (prevProps === null || prevProps === void 0 ? void 0 : prevProps.value));
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $f210d7e14741e091$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $f210d7e14741e091$var$buildFocusableOptionsWithIds($f210d7e14741e091$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $f210d7e14741e091$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $f210d7e14741e091$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $f210d7e14741e091$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $bxhpS.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus,
            isMultiValueExiting: isMultiValueExiting,
            hasCompletedMultiValueExit: hasCompletedMultiValueExit
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $f210d7e14741e091$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps, prevState) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        // A consumer can cause the value subtree to unmount while the final tags are exiting.
        // The fallback keeps the placeholder out for the exit duration, then restores it even
        // when the individual MultiValue completion callback cannot fire.
        if (!prevState.isMultiValueExiting && this.state.isMultiValueExiting) this.multiValueExitFallbackTimeout = setTimeout(()=>{
            this.onMultiValueMotionFinish();
        }, $f210d7e14741e091$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS);
        else if (prevState.isMultiValueExiting && !this.state.isMultiValueExiting) {
            if (this.multiValueExitFallbackTimeout) {
                clearTimeout(this.multiValueExitFallbackTimeout);
                this.multiValueExitFallbackTimeout = null;
            }
        }
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $f210d7e14741e091$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
        if (this.multiValueExitFallbackTimeout) {
            clearTimeout(this.multiValueExitFallbackTimeout);
            this.multiValueExitFallbackTimeout = null;
        }
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open until the in-flight click completes.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss can close the menu during the opening
   * gesture. Today only the top-layer path needs it.
   */ shouldDeferOpenUntilClick() {
        return (0, $dRkX9.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current click, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser performs light-dismiss during the pointer gesture. Deferring
   * until `click` ensures light-dismiss has completed before the popover opens.
   * Off the top-layer path we open synchronously as before.
   */ openMenuAfterClick(focusOption) {
        if (!this.shouldDeferOpenUntilClick()) {
            this.openMenu(focusOption);
            return;
        }
        this.openAfterClick = focusOption;
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $R8XYI.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            var _this$inputRef;
            (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) {
                    var _this$inputRef2;
                    (_this$inputRef2 = this.inputRef) === null || _this$inputRef2 === void 0 || _this$inputRef2.setAttribute('aria-label', normalizedLabel);
                } else {
                    var _this$inputRef3;
                    (_this$inputRef3 = this.inputRef) === null || _this$inputRef3 === void 0 || _this$inputRef3.removeAttribute('aria-label');
                }
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options === null || options === void 0 ? void 0 : options.find((option)=>{
            var _groupCandidate$optio;
            const groupCandidate = option;
            return ((_groupCandidate$optio = groupCandidate.options) === null || _groupCandidate$optio === void 0 ? void 0 : _groupCandidate$optio.some(isOptionFocused)) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = (groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) ?? 0;
            const totalLength = options === null || options === void 0 ? void 0 : options.reduce((acc, currentGroup)=>{
                var _group$options;
                const group = currentGroup;
                acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options === null || options === void 0 ? void 0 : options.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $f210d7e14741e091$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $f210d7e14741e091$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $f210d7e14741e091$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        var _this$props$component;
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option)) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                    className: (0, $2R2iS.default)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const isDisabledA11yFixEnabled = (0, $dRkX9.fg)('platform_dst_select_disabled_a11y_fix');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $dRkX9.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $dRkX9.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            // Using aria-disabled so the element remains in the a11y tree.
            ...isDisabledA11yFixEnabled && {
                'aria-disabled': isDisabled || undefined
            },
            ...this.calculateDescription()
        };
        const effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eVngU.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $f210d7e14741e091$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: effectiveTabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $3LM7S.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: effectiveTabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const isCustomMultiValue = MultiValue !== (0, $9MLZi.components).MultiValue;
        const customMultiValueOwnsTagMotion = isCustomMultiValue && MultiValue != null && Reflect.get(MultiValue, Symbol.for('@atlaskit/tag/motion-capable')) === true;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        const renderMultiValues = (isMotionEnabled = false)=>selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                const multiValue = /*#__PURE__*/ (0, $fc4bM.createElement)(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    isMotionEnabled: isMotionEnabled && !isCustomMultiValue,
                    onMotionFinish: this.onMultiValueMotionFinish,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        },
                        ...testId && {
                            'data-testid': `${testId}-select--multivalue-${index}-remove`
                        },
                        id: `${this.getElementId('selected-value')}-${index}-remove`
                    },
                    data: opt,
                    innerProps: {
                        ...testId && {
                            'data-testid': `${testId}-select--multivalue-${index}`
                        },
                        id: `${this.getElementId('selected-value')}-${index}`
                    }
                }, this.formatOptionLabel(opt, 'value'));
                if (isMotionEnabled && isCustomMultiValue && !customMultiValueOwnsTagMotion) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $avowk.default), {
                    onMotionFinish: this.onMultiValueMotionFinish,
                    children: ()=>multiValue
                }, key);
                return multiValue;
            });
        const placeholderElement = inputValue ? null : /*#__PURE__*/ (0, $fc4bM.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) {
            const ffTagMotion = (0, $dRkX9.fg)('platform-dst-motion-uplift-labels');
            const isTagMotionEnabled = ffTagMotion;
            if (isTagMotionEnabled) return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iXBtU.default), {
                        children: controlShouldRenderValue ? renderMultiValues(true) : null
                    }),
                    (!this.hasValue() || !controlShouldRenderValue) && !this.state.isMultiValueExiting && placeholderElement
                ]
            });
            if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
            return renderMultiValues();
        }
        if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $3LM7S.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value'),
                // Hide from AT so the value is only announced via aria-describedby on the combobox.
                ...isDisabled && (0, $dRkX9.fg)('platform_dst_select_disabled_a11y_fix') && {
                    'aria-hidden': true
                }
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $3LM7S.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $3LM7S.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
            // children only, keeping the voice-control button visible to AT.
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $3LM7S.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, additionalInsideElementRefs: additionalInsideElementRefs, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $fc4bM.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $fc4bM.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $3LM7S.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $3LM7S.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cFNB8.default), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $3LM7S.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dL6OM.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>{
                            var _this$inputRef4, _this$inputRef5;
                            return /*#__PURE__*/ (0, $3LM7S.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': ((_this$inputRef4 = this.inputRef) === null || _this$inputRef4 === void 0 ? void 0 : _this$inputRef4.id) || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $R8XYI.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': ((_this$inputRef5 = this.inputRef) === null || _this$inputRef5 === void 0 ? void 0 : _this$inputRef5.id) || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            });
                        }
                    })
                })
        });
        // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, $dRkX9.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
        // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, $dRkX9.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, $3LM7S.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            additionalInsideElementRefs: additionalInsideElementRefs,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        });
        // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, $dRkX9.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i0F9y.MenuPortalCloseContext).Provider, {
            value: this.handleMenuCloseSignal,
            children: menuPortal
        });
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jzr50.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ibGZY.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9T6kV.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, $3LM7S.jsxs)(SelectContainer, {
                ...commonProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown,
                    ...testId && {
                        'data-testid': testId && `${testId}-select--container`
                    }
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, $3LM7S.jsxs)(Control, {
                        ...commonProps,
                        innerRef: this.getControlRef,
                        innerProps: {
                            onMouseDown: this.onControlMouseDown,
                            onClick: this.onControlClick,
                            onTouchEnd: this.onControlTouchEnd,
                            ...testId && {
                                'data-testid': `${testId}-select--control`
                            }
                        },
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, $3LM7S.jsxs)(ValueContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                hasValue: commonProps.hasValue || this.state.isMultiValueExiting,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--value-container`
                                    },
                                    ...commonProps.isMulti && commonProps.hasValue && !(0, $lGyLn.isAppleDevice)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }
                                },
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0, $3LM7S.jsxs)(IndicatorsContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--indicators-container`
                                    }
                                },
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            })
                        ]
                    }),
                    this.renderMenu(),
                    this.renderFormField(),
                    !(0, $dRkX9.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i4fs4.NotifyOpenLayerObserver), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleMenuCloseSignal
                    })
                ]
            })
        });
    }
}

});
parcelRegister("lGyLn", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $ef111f3dfde7b801$export$e1865c3bedcd822b);
function $ef111f3dfde7b801$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $ef111f3dfde7b801$var$isIPhone() {
    return $ef111f3dfde7b801$var$testPlatform(/^iPhone/i);
}
function $ef111f3dfde7b801$var$isIPad() {
    return $ef111f3dfde7b801$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $ef111f3dfde7b801$var$isMac() && navigator.maxTouchPoints > 1;
}
function $ef111f3dfde7b801$var$isMac() {
    return $ef111f3dfde7b801$var$testPlatform(/^Mac/i);
}
function $ef111f3dfde7b801$var$isIOS() {
    return $ef111f3dfde7b801$var$isIPhone() || $ef111f3dfde7b801$var$isIPad();
}
function $ef111f3dfde7b801$export$e1865c3bedcd822b() {
    return $ef111f3dfde7b801$var$isMac() || $ef111f3dfde7b801$var$isIOS();
}

});

parcelRegister("eVngU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c8d28d310487201$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $2c8d28d310487201$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $2c8d28d310487201$var$dummyInputStyles = null;
function $2c8d28d310487201$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $2c8d28d310487201$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
        ref: innerRef,
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("ibGZY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9b47a29feedff7$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $98UMy = parcelRequire("98UMy");

var $cNwUH = parcelRequire("cNwUH");
const $ad9b47a29feedff7$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $fc4bM.useMemo)(()=>({
            ...(0, $98UMy.defaultAriaLiveMessages),
            ...ariaLiveMessages
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $fc4bM.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $fc4bM.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cNwUH.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cNwUH.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ad9b47a29feedff7$export$2e2bcd8739ae039 = $ad9b47a29feedff7$var$LiveRegion;

});
parcelRegister("98UMy", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $f70f61bad87f48e3$export$a7265767c78f9bae);
const $f70f61bad87f48e3$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("cNwUH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3a2d13a28ae1cbc$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
// Assistive text to describe visual elements. Hidden for sighted users.
const $c3a2d13a28ae1cbc$var$styles = null;
const $c3a2d13a28ae1cbc$var$A11yText = (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $c3a2d13a28ae1cbc$export$2e2bcd8739ae039 = $c3a2d13a28ae1cbc$var$A11yText;

});


parcelRegister("cFNB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8cfa0b2c70bfc78$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $dRkX9 = parcelRequire("dRkX9");

var $91EMH = parcelRequire("91EMH");
const $e8cfa0b2c70bfc78$var$noop = (0, $9JZL9.default);
function $e8cfa0b2c70bfc78$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $e8cfa0b2c70bfc78$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $e8cfa0b2c70bfc78$var$normalizedHeight(el) {
    if ($e8cfa0b2c70bfc78$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $e8cfa0b2c70bfc78$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e8cfa0b2c70bfc78$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $e8cfa0b2c70bfc78$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e8cfa0b2c70bfc78$var$getScrollTop(el) {
    if ($e8cfa0b2c70bfc78$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e8cfa0b2c70bfc78$var$animatedScrollTo(element, to, duration = 200, callback = $e8cfa0b2c70bfc78$var$noop) {
    const start = $e8cfa0b2c70bfc78$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $e8cfa0b2c70bfc78$var$easeOutCubic(currentTime, start, change, duration);
        $e8cfa0b2c70bfc78$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $e8cfa0b2c70bfc78$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $e8cfa0b2c70bfc78$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $e8cfa0b2c70bfc78$var$normalizedHeight(scrollParent);
    const scrollTop = $e8cfa0b2c70bfc78$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e8cfa0b2c70bfc78$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e8cfa0b2c70bfc78$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e8cfa0b2c70bfc78$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e8cfa0b2c70bfc78$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e8cfa0b2c70bfc78$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $e8cfa0b2c70bfc78$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $e8cfa0b2c70bfc78$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $fc4bM.useContext)((0, $91EMH.PortalPlacementContext)) || {};
    const ref = (0, $fc4bM.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $fc4bM.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $fc4bM.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $fc4bM.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $dRkX9.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $e8cfa0b2c70bfc78$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $e8cfa0b2c70bfc78$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
var $e8cfa0b2c70bfc78$export$2e2bcd8739ae039 = $e8cfa0b2c70bfc78$var$MenuPlacer;

});

parcelRegister("jR8Mt", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $01fd1982838e919b$export$5d81789ff4aeccdf);

var $jiju3 = parcelRequire("jiju3");

var $4KwLL = parcelRequire("4KwLL");
const $01fd1982838e919b$var$memoizedStripDiacriticsForInput = (0, $jiju3.default)((0, $4KwLL.stripDiacritics));
const $01fd1982838e919b$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $01fd1982838e919b$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $01fd1982838e919b$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $01fd1982838e919b$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $01fd1982838e919b$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $01fd1982838e919b$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $01fd1982838e919b$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $4KwLL.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("4KwLL", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $6174027279410251$export$b5bee4b27048330b);
const $6174027279410251$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $6174027279410251$var$anyDiacritic = new RegExp('[' + $6174027279410251$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $6174027279410251$var$diacriticToBase = {};
for(let i = 0; i < $6174027279410251$var$diacritics.length; i++){
    let diacritic = $6174027279410251$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$6174027279410251$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $6174027279410251$export$b5bee4b27048330b = (str)=>{
    return str.replace($6174027279410251$var$anyDiacritic, (match)=>$6174027279410251$var$diacriticToBase[match]);
};

});


parcelRegister("73Tk8", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $a2a8500a6a68b976$export$f4da216a6ca54656);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $a2a8500a6a68b976$export$f4da216a6ca54656 = (group)=>group.label;

});

parcelRegister("2Vsv2", function(module, exports) {
$parcel$export(module.exports, "getOptionLabel", () => $cf575116e69c298e$export$dac6ace3020563ca);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $cf575116e69c298e$export$dac6ace3020563ca = (option)=>option.label;

});

parcelRegister("71RWc", function(module, exports) {
$parcel$export(module.exports, "getOptionValue", () => $afd73a4789747ab6$export$40be908210c5a79c);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $afd73a4789747ab6$export$40be908210c5a79c = (option)=>option.value;

});

parcelRegister("cb0Va", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $f857e4424cb96cfb$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $f857e4424cb96cfb$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $f857e4424cb96cfb$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$f857e4424cb96cfb$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

});

parcelRegister("8rkHO", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $f12a9b32c2cf857a$export$33f062f47f21a01);
const $f12a9b32c2cf857a$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("6cdtc", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $172cf3810a02dbd2$export$d8a62a489b442872);
function $172cf3810a02dbd2$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("f7TH6", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $64ba1c59bdcb7e6d$export$d1ca752ec761b95b);
function $64ba1c59bdcb7e6d$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("i4fs4", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $ccfe07af4e98a206$export$17baa7c95b6ba1b8);

var $jlwk8 = parcelRequire("jlwk8");
function $ccfe07af4e98a206$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $jlwk8.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("jzr50", function(module, exports) {
$parcel$export(module.exports, "default", () => $42d1704feeefebfd$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $9JZL9 = parcelRequire("9JZL9");
const $42d1704feeefebfd$var$styles = null;
const $42d1704feeefebfd$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $3LM7S.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $9JZL9.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$42d1704feeefebfd$export$2e2bcd8739ae039 = $42d1704feeefebfd$var$RequiredInput;

});

parcelRegister("dL6OM", function(module, exports) {
$parcel$export(module.exports, "default", () => $20cd2c6b13d9a8c4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $ccgTu = parcelRequire("ccgTu");

var $11hIA = parcelRequire("11hIA");
const $20cd2c6b13d9a8c4$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $20cd2c6b13d9a8c4$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $ccgTu.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $11hIA.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                onClick: $20cd2c6b13d9a8c4$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("ccgTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe66e4b1642fa490$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $g1zRZ = parcelRequire("g1zRZ");
const $fe66e4b1642fa490$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $fe66e4b1642fa490$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $fc4bM.useRef)(false);
    const isTop = (0, $fc4bM.useRef)(false);
    const touchStart = (0, $fc4bM.useRef)(0);
    const scrollTarget = (0, $fc4bM.useRef)(null);
    const handleEventDelta = (0, $fc4bM.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $fe66e4b1642fa490$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $fc4bM.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $fc4bM.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $fc4bM.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $fc4bM.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $g1zRZ.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $fc4bM.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});
parcelRegister("g1zRZ", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $2b8355cbc9bbf10c$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $9JZL9 = parcelRequire("9JZL9");
const $2b8355cbc9bbf10c$var$noop = (0, $9JZL9.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $2b8355cbc9bbf10c$var$passiveOptionAccessed = false;
const $2b8355cbc9bbf10c$var$options = {
    get passive () {
        return $2b8355cbc9bbf10c$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $2b8355cbc9bbf10c$var$w = typeof window !== 'undefined' ? window : {};
if ($2b8355cbc9bbf10c$var$w.addEventListener && $2b8355cbc9bbf10c$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $2b8355cbc9bbf10c$var$w.addEventListener('p', $2b8355cbc9bbf10c$var$noop, $2b8355cbc9bbf10c$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $2b8355cbc9bbf10c$var$w.removeEventListener('p', $2b8355cbc9bbf10c$var$noop, false);
}
const $2b8355cbc9bbf10c$export$b0622a6911dbeaf5 = $2b8355cbc9bbf10c$var$passiveOptionAccessed;

});


parcelRegister("11hIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $58fd146b5d472f23$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $58fd146b5d472f23$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $58fd146b5d472f23$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $58fd146b5d472f23$var$preventTouchMove(e) {
    e.preventDefault();
}
function $58fd146b5d472f23$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $58fd146b5d472f23$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $58fd146b5d472f23$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $58fd146b5d472f23$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $58fd146b5d472f23$var$activeScrollLocks = 0;
const $58fd146b5d472f23$var$listenerOptions = {
    capture: false,
    passive: false
};
function $58fd146b5d472f23$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $fc4bM.useRef)({});
    const scrollTarget = (0, $fc4bM.useRef)(null);
    const addScrollLock = (0, $fc4bM.useCallback)((touchScrollTarget)=>{
        if (!$58fd146b5d472f23$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $58fd146b5d472f23$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $58fd146b5d472f23$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($58fd146b5d472f23$var$LOCK_STYLES).forEach((key)=>{
                const val = $58fd146b5d472f23$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $58fd146b5d472f23$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $58fd146b5d472f23$var$preventTouchMove, $58fd146b5d472f23$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $58fd146b5d472f23$var$preventInertiaScroll, $58fd146b5d472f23$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $58fd146b5d472f23$var$allowTouchMove, $58fd146b5d472f23$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $58fd146b5d472f23$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $fc4bM.useCallback)((touchScrollTarget)=>{
        if (!$58fd146b5d472f23$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $58fd146b5d472f23$var$activeScrollLocks = Math.max($58fd146b5d472f23$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $58fd146b5d472f23$var$activeScrollLocks < 1) $58fd146b5d472f23$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $58fd146b5d472f23$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $58fd146b5d472f23$var$preventTouchMove, $58fd146b5d472f23$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $58fd146b5d472f23$var$preventInertiaScroll, $58fd146b5d472f23$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $58fd146b5d472f23$var$allowTouchMove, $58fd146b5d472f23$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("hy4p5", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $2a8fd4fc55e50721$export$3f99968195accfaf);

var $6cdtc = parcelRequire("6cdtc");
function $2a8fd4fc55e50721$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $6cdtc.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("aoBPB", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $39a9c5a8eaed93d4$export$dea4763e29237f4c);
function $39a9c5a8eaed93d4$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("bxhpS", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $f3921b17f9be976d$export$40fb9515c784cc3b);
function $f3921b17f9be976d$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});

parcelRegister("cL6R7", function(module, exports) {
$parcel$export(module.exports, "isOptionDisabled", () => $5c3a5533c3470aa6$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $5c3a5533c3470aa6$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});


parcelRegister("iJY8V", function(module, exports) {
$parcel$export(module.exports, "default", () => $706c4d25b62ff4f4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $706c4d25b62ff4f4$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $fc4bM.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $fc4bM.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $fc4bM.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $fc4bM.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $fc4bM.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $fc4bM.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $fc4bM.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    // @ts-expect-error -- Spreading generic AdditionalProps cannot prove that all required select props are present.
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("5eTWm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eca20c1d0db1af25$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $eca20c1d0db1af25$var$InlineMenuPortal = ({ children: children })=>children;
const $eca20c1d0db1af25$var$InlineMenu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...innerProps,
        // MenuList owns this ID; forwarding it here would create duplicate listbox IDs.
        id: undefined,
        children: children
    });
function $eca20c1d0db1af25$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, components: components, isInvalid: isInvalid, menuRenderMode: // TODO: set to true when cleaning up validationState prop so it has a default value
        menuRenderMode = 'popup', onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $fc4bM.useRef)(null);
        const inlineMenuComponents = (0, $fc4bM.useMemo)(()=>({
                ...components,
                MenuPortal: $eca20c1d0db1af25$var$InlineMenuPortal,
                Menu: $eca20c1d0db1af25$var$InlineMenu
            }), [
            components
        ]);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $fc4bM.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: ()=>{
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            }), []);
        if (menuRenderMode === 'inline') return /*#__PURE__*/ (0, $3LM7S.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            components: inlineMenuComponents,
            menuIsOpen: props.menuIsOpen ?? true,
            tabSelectsValue: tabSelectsValue,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            components: components,
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});



parcelRegister("aU5V0", function(module, exports) {
$parcel$export(module.exports, "MetaActions", () => $c0b110de54a5835e$export$50531cf3046c5956);
const $c0b110de54a5835e$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("3ac6U", function(module, exports) {
$parcel$export(module.exports, "Control", () => $b4d2f6e4cf7d8fc5$export$7a7fa4424cb20976);

var $fc4bM = parcelRequire("fc4bM");

var $fZH7o = parcelRequire("fZH7o");
const $b4d2f6e4cf7d8fc5$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledControl), {
        ...innerProps,
        ref: innerRef
    }, children);
};

});

parcelRegister("5N1Xu", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $9983041b35d4d3eb$export$ec98719d3db7f2e4);

var $fc4bM = parcelRequire("fc4bM");

var $48hlF = parcelRequire("48hlF");

var $8K7DG = parcelRequire("8K7DG");

var $9MLZi = parcelRequire("9MLZi");

var $fZH7o = parcelRequire("fZH7o");
const $9983041b35d4d3eb$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9MLZi.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.DropdownIndicatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.DisplayWrapper), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.CloseIconWrapper), {
        onClick: (event)=>{
            var _props$selectProps$on, _props$selectProps;
            event.preventDefault();
            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
        color: "currentColor",
        label: ""
    }))));

});

parcelRegister("hkMBc", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $cdab0b746eb5f362$export$d9b273488cd8ce6f);

var $fc4bM = parcelRequire("fc4bM");
const $cdab0b746eb5f362$export$d9b273488cd8ce6f = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);

});

parcelRegister("cnBYN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c17bb149b0e02c1$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $6c17bb149b0e02c1$var$message = (0, $8p5Cv.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});
var $6c17bb149b0e02c1$export$2e2bcd8739ae039 = $6c17bb149b0e02c1$var$message;

});

parcelRegister("baVSx", function(module, exports) {
$parcel$export(module.exports, "Option", () => $24a8d00dd0aa9df1$export$36d18380658d5d20);

var $fc4bM = parcelRequire("fc4bM");

var $gDsF8 = parcelRequire("gDsF8");

var $gGDvE = parcelRequire("gGDvE");

var $4yGHu = parcelRequire("4yGHu");

var $bcTS3 = parcelRequire("bcTS3");

var $fZH7o = parcelRequire("fZH7o");
const $24a8d00dd0aa9df1$var$renderOption = (props)=>props.isMulti ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gGDvE.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4yGHu.RadioOption), props);
const $24a8d00dd0aa9df1$export$36d18380658d5d20 = (props)=>{
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZH7o.StyledInvalidCheckboxOption), null, $24a8d00dd0aa9df1$var$renderOption(props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: "Test",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return $24a8d00dd0aa9df1$var$renderOption(props);
};

});
parcelRegister("gGDvE", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $46a08104fe531602$export$d40cc97ecda916f9);
/* checkbox-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bMPE4 = parcelRequire("bMPE4");
const $46a08104fe531602$var$svgStyles = null;
const $46a08104fe531602$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $46a08104fe531602$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $bMPE4.ControlOption), {
        Icon: $46a08104fe531602$var$CheckboxIcon,
        ...props
    });

});
parcelRegister("bMPE4", function(module, exports) {
$parcel$export(module.exports, "ControlOption", () => $40a428ec9a0d654a$export$e41f7c07e51665da);
/* control-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");
const $40a428ec9a0d654a$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    finesseFocused: "_16qsglyw _112eglyw",
    disabled: "_syaz1gmx",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo"
};
// the primary color represents the outer or background element
const $40a428ec9a0d654a$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $40a428ec9a0d654a$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $40a428ec9a0d654a$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $40a428ec9a0d654a$var$baseIconStyles = null;
const $40a428ec9a0d654a$var$baseOptionStyles = null;
const $40a428ec9a0d654a$export$e41f7c07e51665da = (props)=>{
    const [isActive, setIsActive] = (0, $fc4bM.useState)(false);
    const onMouseDown = (0, $fc4bM.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $fc4bM.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $fc4bM.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            $40a428ec9a0d654a$var$optionStyles.default,
            !isDisabled && $40a428ec9a0d654a$var$optionStyles.motion,
            isFocused && $40a428ec9a0d654a$var$optionStyles.focused,
            isFocused && (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $40a428ec9a0d654a$var$optionStyles.finesseFocused,
            isDisabled && $40a428ec9a0d654a$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $40a428ec9a0d654a$var$iconStyles.inherit : $40a428ec9a0d654a$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
                    label: "",
                    primaryColor: $40a428ec9a0d654a$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $40a428ec9a0d654a$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};

});


parcelRegister("4yGHu", function(module, exports) {
$parcel$export(module.exports, "RadioOption", () => $c6d40a11a89a5701$export$82ab7168879267a7);
/* radio-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bMPE4 = parcelRequire("bMPE4");
const $c6d40a11a89a5701$var$svgStyles = null;
const $c6d40a11a89a5701$var$RadioIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $c6d40a11a89a5701$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bMPE4.ControlOption), {
        Icon: $c6d40a11a89a5701$var$RadioIcon,
        ...props
    });

});



parcelRegister("87jcs", function(module, exports) {
$parcel$export(module.exports, "ShowFullListButton", () => $cdfc99dd761c1f4d$export$bf0956d66cd7566b);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $kTVlm = parcelRequire("kTVlm");

var $58Db3 = parcelRequire("58Db3");
const $cdfc99dd761c1f4d$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const handleShowFullList = (0, $fc4bM.useCallback)(()=>{
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $58Db3.default).showFullListButtonText));
};
var $cdfc99dd761c1f4d$export$2e2bcd8739ae039 = $cdfc99dd761c1f4d$export$bf0956d66cd7566b;

});
parcelRegister("58Db3", function(module, exports) {
$parcel$export(module.exports, "default", () => $62b259826cc0e616$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $62b259826cc0e616$var$message = (0, $8p5Cv.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});
var $62b259826cc0e616$export$2e2bcd8739ae039 = $62b259826cc0e616$var$message;

});


parcelRegister("cGunW", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $f6ab675616bcb02c$export$a06f1c675e846f6f);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
const $f6ab675616bcb02c$var$styles = {
    focusPadding: "_19bv1b66 _u5f31b66",
    footer: "_uwhk1dm9 _15a5nqa1 _1i531l7x _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o"
};
const $f6ab675616bcb02c$export$a06f1c675e846f6f = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $f6ab675616bcb02c$var$styles.footer,
            (0, $dRkX9.fg)('adminhub_paginated_picker_focus_fixes') && $f6ab675616bcb02c$var$styles.focusPadding
        ])
    }, children);

});


parcelRegister("6kNwQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $665c15e92c3d4c34$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $l2MT8 = parcelRequire("l2MT8");

var $hvFos = parcelRequire("hvFos");

var $2QEmD = parcelRequire("2QEmD");
const $665c15e92c3d4c34$var$formatOptionLabel = (option)=>{
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hvFos.IconOptionLabel), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $l2MT8.AvatarOptionLabel), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2QEmD.LozengeOptionLabel), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null);
};
var $665c15e92c3d4c34$export$2e2bcd8739ae039 = $665c15e92c3d4c34$var$formatOptionLabel;

});
parcelRegister("l2MT8", function(module, exports) {
$parcel$export(module.exports, "AvatarOptionLabel", () => $8ec905b4cdb023d2$export$fe00f602c942368a);

var $fc4bM = parcelRequire("fc4bM");

var $cWkQ8 = parcelRequire("cWkQ8");

var $4ZJpX = parcelRequire("4ZJpX");
const $8ec905b4cdb023d2$export$fe00f602c942368a = ({ avatarOption: avatarOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWkQ8.default), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xxsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledChild), null, avatarOption.label));

});
parcelRegister("4ZJpX", function(module, exports) {
$parcel$export(module.exports, "StyledChild", () => $52197a047cc5f151$export$8133811dea85f484);
$parcel$export(module.exports, "StyledOption", () => $52197a047cc5f151$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledItem", () => $52197a047cc5f151$export$7c16ae7705e422c4);
$parcel$export(module.exports, "StyledChildIcon", () => $52197a047cc5f151$export$c23e66fb1706d7dd);
$parcel$export(module.exports, "StyledOptionIcon", () => $52197a047cc5f151$export$20da797b837461ca);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $52197a047cc5f151$var$styles = {
    child: "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf",
    option: "_4cvr1h6o _1e0c1txw",
    item: "_1e0c1txw",
    childIcon: "_18u0u2gc",
    optionIcon: "_2rko1rr0 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
const $52197a047cc5f151$export$8133811dea85f484 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $52197a047cc5f151$var$styles.child
        ])
    }, children);
const $52197a047cc5f151$export$844bee7de236d7ec = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $52197a047cc5f151$var$styles.option
        ])
    }, children);
const $52197a047cc5f151$export$7c16ae7705e422c4 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $52197a047cc5f151$var$styles.item
        ])
    }, children);
const $52197a047cc5f151$export$c23e66fb1706d7dd = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $52197a047cc5f151$var$styles.childIcon
        ])
    }, children);
const $52197a047cc5f151$export$20da797b837461ca = ({ alt: alt = '', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
        alt: alt,
        ...props,
        className: (0, $2R2iS.default)([
            $52197a047cc5f151$var$styles.optionIcon
        ])
    });

});


parcelRegister("hvFos", function(module, exports) {
$parcel$export(module.exports, "IconOptionLabel", () => $c0cded5d80ad7b17$export$914fa095fc1e0a45);

var $fc4bM = parcelRequire("fc4bM");

var $4ZJpX = parcelRequire("4ZJpX");
const $c0cded5d80ad7b17$export$914fa095fc1e0a45 = ({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledItem), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledOptionIcon), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledChildIcon), null, option.label)));

});

parcelRegister("2QEmD", function(module, exports) {
$parcel$export(module.exports, "LozengeOptionLabel", () => $d1ab6a5e2b5ba1c9$export$5f70fe304106fcb1);

var $fc4bM = parcelRequire("fc4bM");

var $9wELi = parcelRequire("9wELi");

var $4ZJpX = parcelRequire("4ZJpX");
const $d1ab6a5e2b5ba1c9$export$5f70fe304106fcb1 = ({ lozengeOption: lozengeOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledChild), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4ZJpX.StyledItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9wELi.default), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));

});


parcelRegister("iTo7X", function(module, exports) {
$parcel$export(module.exports, "DialogInner", () => $e845a54649d4a05b$export$999ca5bf223f627);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $e845a54649d4a05b$var$styles = {
    dialogInner: "_1reo15vq _18m915vq _1ul91wdt"
};
const $e845a54649d4a05b$export$999ca5bf223f627 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $e845a54649d4a05b$var$styles.dialogInner
        ])
    }, children);

});


parcelRegister("3B0Nu", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $f06ca24043765111$export$957d7daebd899f12);

var $fc4bM = parcelRequire("fc4bM");

var $lpWRK = parcelRequire("lpWRK");

var $k8Adr = parcelRequire("k8Adr");

var $iaWtE = parcelRequire("iaWtE");
const $f06ca24043765111$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : !!value;
const $f06ca24043765111$export$957d7daebd899f12 = (label = '', value)=>{
    if (!value || !$f06ca24043765111$export$96bdbc84526f3739(value)) return label;
    const [firstValue, ...otherValues] = value.map((v)=>v.label ?? '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iaWtE.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        as: "strong",
        color: "inherit"
    }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iaWtE.LabelValueWrapper), null, firstValue, otherValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iaWtE.BadgeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lpWRK.default), null, `+${otherValues.length}`))));
};

});
parcelRegister("lpWRK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cb8d2a0e178754ae$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $8ubDR = parcelRequire("8ubDR");

var $7d9ex = parcelRequire("7d9ex");

var $9Ro1o = parcelRequire("9Ro1o");
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in `children`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $cb8d2a0e178754ae$var$Badge = /*#__PURE__*/ (0, $fc4bM.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // Map old appearance names to new ones
    const newAppearance = (0, $8ubDR.appearanceMapping)[appearance];
    // Pre-format the value using the backward-compatible formatter (supports negative numbers)
    // then pass max={false} to BadgeNew so it doesn't apply its own (clamping) formatting.
    const formattedValue = typeof children === 'number' && typeof max === 'number' ? (0, $9Ro1o.formatValueWithNegativeSupport)(children, max) : children;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7d9ex.default), {
        appearance: newAppearance,
        max: false,
        style: style,
        testId: testId,
        children: formattedValue
    });
});
var $cb8d2a0e178754ae$export$2e2bcd8739ae039 = $cb8d2a0e178754ae$var$Badge;

});
parcelRegister("8ubDR", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $ce5b380d2c0f8e24$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $ce5b380d2c0f8e24$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("9Ro1o", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $5130f0b82791690c$export$4b844743568d5983);
function $5130f0b82791690c$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $5130f0b82791690c$export$4b844743568d5983(value, max) {
    const safeValue = $5130f0b82791690c$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $5130f0b82791690c$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("iaWtE", function(module, exports) {
$parcel$export(module.exports, "BadgeWrapper", () => $3bff3c6696cd62a8$export$1a37a8b7ddf809ac);
$parcel$export(module.exports, "Container", () => $3bff3c6696cd62a8$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelValueWrapper", () => $3bff3c6696cd62a8$export$8f3477ca2c4ba51a);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// Uses @compiled/react because fractional opacity (0.5) is not an allowed value in the strict @atlaskit/css types.
const $3bff3c6696cd62a8$var$badgeWrapperStyles = {
    badge: "_1e0c116y _18u01b66 _tzy4105o"
};
const $3bff3c6696cd62a8$var$styles = {
    container: "_1e0c116y _4cvr1h6o",
    labelValue: "_18u01b66 _1e0c116y _4cvr1h6o"
};
const $3bff3c6696cd62a8$export$1a37a8b7ddf809ac = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $3bff3c6696cd62a8$var$badgeWrapperStyles.badge
        ])
    }, children);
const $3bff3c6696cd62a8$export$42a852a2b6b56249 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $3bff3c6696cd62a8$var$styles.container
        ])
    }, children);
const $3bff3c6696cd62a8$export$8f3477ca2c4ba51a = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $3bff3c6696cd62a8$var$styles.labelValue
        ])
    }, children);

});


parcelRegister("k9qaS", function(module, exports) {
$parcel$export(module.exports, "default", () => $0282a751e9a4bee5$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $5dzEI = parcelRequire("5dzEI");

var $13zmE = parcelRequire("13zmE");

var $dBtOK = parcelRequire("dBtOK");

var $8CUOw = parcelRequire("8CUOw");

var $5IP5E = parcelRequire("5IP5E");

var $az3Md = parcelRequire("az3Md");

var $iDzNI = parcelRequire("iDzNI");
const $0282a751e9a4bee5$var$textPadding = {
    root: "_u5f3utpp"
};
const $0282a751e9a4bee5$export$d7b370c39c0de454 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, hideSelectedIndicator: hideSelectedIndicator, triggerIcon: triggerIcon, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, isDisabled: isDisabled, ariaLabel: ariaLabel }, ref)=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8CUOw.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $az3Md.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        isSelected: !hideSelectedIndicator && isSelected,
        iconBefore: triggerIcon,
        testId: testId
    }, children)));
    const afterTriggerIcon = onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iDzNI.StyledClose), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5IP5E.ClearButton), {
        onClick: (e)=>{
            e.stopPropagation();
            onClear === null || onClear === void 0 || onClear();
        },
        label: "Remove criteria"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
        color: "currentColor",
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8CUOw.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iDzNI.ButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: isInvalid ? 'danger' : 'default',
        isSelected: !hideSelectedIndicator && (isSelected || hasValues),
        iconBefore: triggerIcon,
        iconAfter: ()=>afterTriggerIcon,
        onClick: onClick,
        ref: ref,
        testId: testId,
        "aria-expanded": isSelected,
        isDisabled: isDisabled,
        "aria-label": ariaLabel && ariaLabel
    }, onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $0282a751e9a4bee5$var$textPadding.root
    }, children) : children)));
});
var $0282a751e9a4bee5$export$2e2bcd8739ae039 = $0282a751e9a4bee5$export$d7b370c39c0de454;

});
parcelRegister("5IP5E", function(module, exports) {
$parcel$export(module.exports, "ClearButton", () => $f4059dc8f2fb26c4$export$13ec83e50bf04290);

var $fc4bM = parcelRequire("fc4bM");

var $gV8E5 = parcelRequire("gV8E5");

var $SiB1U = parcelRequire("SiB1U");
const $f4059dc8f2fb26c4$export$13ec83e50bf04290 = ({ label: label, isSelected: isSelected, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $SiB1U.StyledClearButton), {
        ...props,
        "data-testid": "paginated-picker.ui.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
$f4059dc8f2fb26c4$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $f4059dc8f2fb26c4$export$2e2bcd8739ae039 = $f4059dc8f2fb26c4$export$13ec83e50bf04290;

});
parcelRegister("SiB1U", function(module, exports) {
$parcel$export(module.exports, "StyledClearButton", () => $5835fb8ec96697f0$export$969a0501aa28855a);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
const $5835fb8ec96697f0$var$styledClearButtonStyles = {
    clearButton: "_2rkolb4i _189eidpf _1dqoglyw _bfhk1j28 _syaz1rpy _80omtlke _4t3i1ejb _vwz4kb7n _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _18u0v77o _k8m01v7i _1oecfnf5 _1bsb1ejb _f8pjazsu _30l3azsu"
};
const $5835fb8ec96697f0$export$969a0501aa28855a = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $5835fb8ec96697f0$var$styledClearButtonStyles.clearButton
        ])
    }, children);

});


parcelRegister("az3Md", function(module, exports) {
$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $30d619cadf9db6b8$export$c7a90a9f6120efb7);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// Uses @compiled/react because keyframes() is not available from @atlaskit/css.
const $30d619cadf9db6b8$var$flickerAnimation = null;
const $30d619cadf9db6b8$var$loadingStateAnimationWrapperStyles = {
    wrapper: "_kqswh2mm _j7hq3y00 _5sagymdr _tip812c5"
};
const $30d619cadf9db6b8$export$c7a90a9f6120efb7 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $30d619cadf9db6b8$var$loadingStateAnimationWrapperStyles.wrapper
        ])
    }, children);

});

parcelRegister("iDzNI", function(module, exports) {
$parcel$export(module.exports, "ButtonWrapper", () => $af5e54492de94424$export$d53c836cccbb0d90);
$parcel$export(module.exports, "StyledClose", () => $af5e54492de94424$export$cd8104a6ec6bb897);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
const $af5e54492de94424$var$styles = {
    buttonWrapper: "_kqswh2mm"
};
const $af5e54492de94424$var$styledCloseStyles = {
    close: "_189eidpf _1dqoglyw _bfhk1j28 _4t3i1ejb _vwz4kb7n _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1xi2r5cr _154i1ssb _19pkxmi2 _1bsb1ejb"
};
const $af5e54492de94424$export$d53c836cccbb0d90 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $af5e54492de94424$var$styles.buttonWrapper
        ])
    }, children);
const $af5e54492de94424$export$cd8104a6ec6bb897 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...props,
        className: (0, $2R2iS.default)([
            $af5e54492de94424$var$styledCloseStyles.close
        ])
    }, children);

});





parcelRegister("fGE0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $960a80f2347a81fb$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $960a80f2347a81fb$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Label for the category picker filter used to narrow article search results',
        id: 'sd.all.articles.result.category.filter.name'
    }
});

});



parcelRegister("8zDH6", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => (parcelRequire("aCpsw")).SearchResultNone);

var $aCpsw = parcelRequire("aCpsw");

});
parcelRegister("aCpsw", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => $1758aa52f6c27b07$export$149a2f9a7f0755fb);

var $fc4bM = parcelRequire("fc4bM");

var $i8qFc = parcelRequire("i8qFc");

var $6Y4Lg = parcelRequire("6Y4Lg");

var $gpjDl = parcelRequire("gpjDl");

var $1hJdJ = parcelRequire("1hJdJ");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");

var $uYmrU = parcelRequire("uYmrU");
parcelRequire("4ZWZy");
var $cd2Ru = parcelRequire("cd2Ru");

var $89aYe = parcelRequire("89aYe");

var $jZHQe = parcelRequire("jZHQe");
const $1758aa52f6c27b07$export$149a2f9a7f0755fb = ({ term: term })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (term === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i8qFc))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $jZHQe.default).noSearchQueryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        align: "center"
    }, formatMessage((0, $jZHQe.default).noSearchQueryBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $89aYe.searchExperience)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Y4Lg))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $jZHQe.default).noSearchResultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        align: "center"
    }, formatMessage((0, $jZHQe.default).noSearchResultBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $89aYe.searchExperience)
    }));
};

});
parcelRegister("i8qFc", function(module, exports) {
module.exports = new URL("../images/empty-search-query.f4548b48.svg", import.meta.url).toString();

});

parcelRegister("6Y4Lg", function(module, exports) {
module.exports = new URL("../images/empty-search-results.00e234d0.svg", import.meta.url).toString();

});

parcelRegister("jZHQe", function(module, exports) {
$parcel$export(module.exports, "default", () => $e439a7a4aa5f9810$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $e439a7a4aa5f9810$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    noSearchResultTitle: {
        defaultMessage: 'We couldn\u2019t find a match for your search',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.none.no-search-result-title'
    },
    noSearchResultText: {
        defaultMessage: 'We couldn\u2019t find any matches for \u2018{ term }\u2019. Check your search for typos, or try another search term.',
        description: 'Title text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-text'
    },
    noSearchResultBody: {
        defaultMessage: 'Check your search for typos, or try another search term.',
        description: 'Body text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-body'
    },
    noSearchQueryTitle: {
        defaultMessage: 'Looking for something?',
        description: 'Title text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-title'
    },
    noSearchQueryBody: {
        defaultMessage: 'Enter your search term above to get started.',
        description: 'Body text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-body'
    }
});

});



parcelRegister("3AYuL", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => (parcelRequire("fQUMP")).SearchBar);

var $fQUMP = parcelRequire("fQUMP");

});
parcelRegister("fQUMP", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => $8e1eb6e6d3e71757$export$79d13b60110f33be);

var $fc4bM = parcelRequire("fc4bM");

var $eoSpX = parcelRequire("eoSpX");

var $aYMdQ = parcelRequire("aYMdQ");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $azARG = parcelRequire("azARG");

var $k2M4v = parcelRequire("k2M4v");

var $gV8E5 = parcelRequire("gV8E5");

var $8K7DG = parcelRequire("8K7DG");

var $gDsF8 = parcelRequire("gDsF8");

var $4EPUx = parcelRequire("4EPUx");

var $5a4EU = parcelRequire("5a4EU");

var $jVMDF = parcelRequire("jVMDF");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");

var $1zYKE = parcelRequire("1zYKE");

var $aEtFp = parcelRequire("aEtFp");

var $6rayQ = parcelRequire("6rayQ");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
var $cd2Ru = parcelRequire("cd2Ru");
var $eFtAu = parcelRequire("eFtAu");

var $5qFsk = parcelRequire("5qFsk");
const $8e1eb6e6d3e71757$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON = 'searchQueryCharacterLimitErrorIcon';
const $8e1eb6e6d3e71757$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER = 'searchQueryCharacterLimitErrorPopover';
const $8e1eb6e6d3e71757$var$HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const $8e1eb6e6d3e71757$var$MOBILE_SEARCH_BAR_BREAKPOINT_WIDTH = 768;
const $8e1eb6e6d3e71757$var$isHelpCenterSearchLimitEnabled = ()=>(0, $k2M4v.default).checkGate($8e1eb6e6d3e71757$var$HELP_CENTER_SEARCH_LIMIT_GATE);
const $8e1eb6e6d3e71757$var$getBackButtonText = (width)=>width < $8e1eb6e6d3e71757$var$MOBILE_SEARCH_BAR_BREAKPOINT_WIDTH ? '' : undefined;
const $8e1eb6e6d3e71757$var$fireSearchCharacterLimitAnalytics = (createAnalyticsEvent, action, actionSubject, actionSubjectId)=>{
    createAnalyticsEvent === null || createAnalyticsEvent === void 0 || createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        analyticsType: 'UI'
    }).fire();
};
const $8e1eb6e6d3e71757$export$79d13b60110f33be = (props)=>{
    if ($8e1eb6e6d3e71757$var$isHelpCenterSearchLimitEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8e1eb6e6d3e71757$var$SearchBarWithSearchLimit, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8e1eb6e6d3e71757$var$SearchBarLegacy, props);
};
const $8e1eb6e6d3e71757$var$SearchBarLegacy = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [backButtonText, setBackButtonText] = (0, $fc4bM.useState)();
    const searchBarRef = (0, $fc4bM.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, $fc4bM.useState)(term);
    (0, $fc4bM.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText(entry.contentRect.width < 768 ? '' : undefined);
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            if (currentSearchBarRefRef) observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const debouncedOnChangeMethod = (0, $fc4bM.useMemo)(()=>(0, $aYMdQ.debounce)((value)=>{
            onChange(value);
        }, (0, $eFtAu.SEARCH_QUERY_DEBOUNCE_TIME)), [
        onChange
    ]);
    const onSearchTermChange = (0, $fc4bM.useCallback)((e)=>{
        setSearchQuery(e.target.value);
        if ((0, $k2M4v.default).checkGate('debounce_change_in_portal_search')) debouncedOnChangeMethod(e.target.value);
        else onChange(e.target.value);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        debouncedOnChangeMethod,
        onChange
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $8whFx.useRouterActions)();
    const onBackButtonClick = (0, $fc4bM.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $b52IZ.useQueryParams)();
    const onCrossIconClick = (0, $fc4bM.useCallback)(()=>{
        setSearchQuery('');
        onChange('');
        push((0, $6rayQ.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: $8e1eb6e6d3e71757$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        gap: "space.200",
        templateColumns: "25fr 50fr 25fr",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8e1eb6e6d3e71757$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eoSpX.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8e1eb6e6d3e71757$var$textFieldLegacyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
        id: "search-bar-input",
        value: searchQuery,
        name: formatMessage((0, $5qFsk.default).inputLabel),
        "aria-label": formatMessage((0, $5qFsk.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $5qFsk.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $8e1eb6e6d3e71757$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "button",
            "aria-label": formatMessage((0, $5qFsk.default).clearLabel),
            xcss: $8e1eb6e6d3e71757$var$crossIconStyles,
            onClick: onCrossIconClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
            label: formatMessage((0, $5qFsk.default).clearLabel),
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        // Disabling existing violations, should be fixed when revisited.
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null)));
};
const $8e1eb6e6d3e71757$var$SearchBarWithSearchLimit = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [backButtonText, setBackButtonText] = (0, $fc4bM.useState)(()=>typeof window === 'undefined' ? undefined : $8e1eb6e6d3e71757$var$getBackButtonText(window.innerWidth));
    const searchBarRef = (0, $fc4bM.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, $fc4bM.useState)(term);
    const [isCharacterLimitErrorOpen, setIsCharacterLimitErrorOpen] = (0, $fc4bM.useState)(false);
    const isSearchQueryOverLimit = (0, $b52IZ.isSearchQueryOverCharacterLimit)(searchQuery);
    (0, $fc4bM.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (currentSearchBarRefRef) setBackButtonText($8e1eb6e6d3e71757$var$getBackButtonText(currentSearchBarRefRef.getBoundingClientRect().width));
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText($8e1eb6e6d3e71757$var$getBackButtonText(entry.contentRect.width));
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            var _observer;
            if (currentSearchBarRefRef) (_observer = observer) === null || _observer === void 0 || _observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const debouncedOnChangeMethod = (0, $fc4bM.useMemo)(()=>(0, $aYMdQ.debounce)((value)=>{
            onChange(value);
        }, (0, $eFtAu.SEARCH_QUERY_DEBOUNCE_TIME)), [
        onChange
    ]);
    const onSearchTermChange = (0, $fc4bM.useCallback)((e)=>{
        const newSearchQuery = e.target.value;
        const isNewSearchQueryOverLimit = (0, $b52IZ.isSearchQueryOverCharacterLimit)(newSearchQuery);
        setSearchQuery(newSearchQuery);
        setIsCharacterLimitErrorOpen(false);
        if (isNewSearchQueryOverLimit) return;
        if ((0, $k2M4v.default).checkGate('debounce_change_in_portal_search')) debouncedOnChangeMethod(newSearchQuery);
        else onChange(newSearchQuery);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        debouncedOnChangeMethod,
        onChange
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $8whFx.useRouterActions)();
    const onBackButtonClick = (0, $fc4bM.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $b52IZ.useQueryParams)();
    const onCrossIconClick = (0, $fc4bM.useCallback)(()=>{
        setSearchQuery('');
        setIsCharacterLimitErrorOpen(false);
        onChange('');
        push((0, $6rayQ.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    const onCharacterLimitErrorIconClick = (0, $fc4bM.useCallback)(()=>{
        $8e1eb6e6d3e71757$var$fireSearchCharacterLimitAnalytics(createAnalyticsEvent, 'clicked', 'button', $8e1eb6e6d3e71757$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON);
        const nextIsOpen = !isCharacterLimitErrorOpen;
        setIsCharacterLimitErrorOpen(nextIsOpen);
        if (nextIsOpen) $8e1eb6e6d3e71757$var$fireSearchCharacterLimitAnalytics(createAnalyticsEvent, 'rendered', 'popover', $8e1eb6e6d3e71757$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER);
    }, [
        createAnalyticsEvent,
        isCharacterLimitErrorOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: $8e1eb6e6d3e71757$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        gap: "space.200",
        templateColumns: "auto minmax(0, 1fr) auto",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8e1eb6e6d3e71757$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eoSpX.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick,
        allowEmptyText: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $8e1eb6e6d3e71757$var$textFieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
        id: "search-bar-input",
        value: searchQuery,
        name: formatMessage((0, $5qFsk.default).inputLabel),
        "aria-label": formatMessage((0, $5qFsk.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $5qFsk.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        isInvalid: isSearchQueryOverLimit,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $8e1eb6e6d3e71757$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: isSearchQueryOverLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
            isOpen: isCharacterLimitErrorOpen,
            onClose: ()=>setIsCharacterLimitErrorOpen(false),
            placement: "bottom-end",
            autoFocus: false,
            shouldRenderToParent: true,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                    ...triggerProps,
                    as: "button",
                    type: "button",
                    "aria-label": formatMessage((0, $5qFsk.default).characterLimitErrorIconLabel),
                    xcss: $8e1eb6e6d3e71757$var$searchErrorIconStyles,
                    onClick: onCharacterLimitErrorIconClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon-danger, #C9372C)"
                })),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                    xcss: $8e1eb6e6d3e71757$var$characterLimitErrorStyles,
                    role: "alert"
                }, formatMessage((0, $5qFsk.default).characterLimitExceeded, {
                    limit: (0, $eFtAu.SEARCH_QUERY_CHARACTER_LIMIT)
                }))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "button",
            "aria-label": formatMessage((0, $5qFsk.default).clearLabel),
            xcss: $8e1eb6e6d3e71757$var$crossIconStyles,
            onClick: onCrossIconClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
            label: formatMessage((0, $5qFsk.default).clearLabel),
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        // Disabling existing violations, should be fixed when revisited.
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null)));
};
const $8e1eb6e6d3e71757$var$containerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    width: '100vw',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    height: (0, $cd2Ru.SEARCH_BAR_HEIGHT),
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #EBECF0)",
    zIndex: 'modal'
});
const $8e1eb6e6d3e71757$var$backButtonStyles = (0, $kig2V.xcss)({
    [(0, $1zYKE.media).above.xxs]: {
        marginLeft: 'space.050'
    },
    [(0, $1zYKE.media).above.xs]: {
        marginLeft: 'space.100'
    },
    [(0, $1zYKE.media).above.sm]: {
        marginLeft: 'space.200'
    }
});
const $8e1eb6e6d3e71757$var$textFieldStyles = (0, $kig2V.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    width: '100%',
    [(0, $1zYKE.media).above.xs]: {
        width: '432px'
    },
    [(0, $1zYKE.media).above.sm]: {
        width: '692px'
    },
    [(0, $1zYKE.media).above.md]: {
        width: '965px'
    }
});
const $8e1eb6e6d3e71757$var$textFieldLegacyStyles = (0, $kig2V.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    [(0, $1zYKE.media).above.xxs]: {
        width: '348px'
    },
    [(0, $1zYKE.media).above.xs]: {
        width: '432px'
    },
    [(0, $1zYKE.media).above.sm]: {
        width: '692px'
    },
    [(0, $1zYKE.media).above.md]: {
        width: '965px'
    }
});
const $8e1eb6e6d3e71757$var$searchIconStyles = (0, $kig2V.xcss)({
    padding: 'space.100'
});
const $8e1eb6e6d3e71757$var$searchErrorIconStyles = (0, $kig2V.xcss)({
    background: 'transparent',
    cursor: 'pointer',
    padding: 'space.100'
});
const $8e1eb6e6d3e71757$var$crossIconStyles = (0, $kig2V.xcss)({
    background: 'transparent',
    cursor: 'pointer'
});
const $8e1eb6e6d3e71757$var$characterLimitErrorStyles = (0, $kig2V.xcss)({
    color: 'color.text',
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    textAlign: 'right'
});
var $8e1eb6e6d3e71757$export$2e2bcd8739ae039 = (0, $azARG.default)()($8e1eb6e6d3e71757$export$79d13b60110f33be);

});
parcelRegister("eoSpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fafb5391d28fdb0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $gpjDl = parcelRequire("gpjDl");

var $k2M4v = parcelRequire("k2M4v");

var $i2XJe = parcelRequire("i2XJe");

var $cNhg9 = parcelRequire("cNhg9");
const $2fafb5391d28fdb0$var$HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const $2fafb5391d28fdb0$var$isHelpCenterSearchLimitEnabled = ()=>(0, $k2M4v.default).checkGate($2fafb5391d28fdb0$var$HELP_CENTER_SEARCH_LIMIT_GATE);
const $2fafb5391d28fdb0$var$BackButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { onClick: onClick, actionSubjectId: actionSubjectId, text: text, allowEmptyText: allowEmptyText = false } = props;
    if (allowEmptyText && $2fafb5391d28fdb0$var$isHelpCenterSearchLimitEnabled()) {
        const defaultBackButtonText = formatMessage((0, $cNhg9.default).backButtonText);
        const gatedBackButtonText = text === undefined ? defaultBackButtonText : text;
        const accessibleLabel = text ? text : defaultBackButtonText;
        return /*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.Button), {
            appearance: "subtle",
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            "aria-label": accessibleLabel,
            iconBefore: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($i2XJe))), {
                label: "",
                size: "small",
                spacing: "compact",
                color: "var(--ds-icon, #42526E)"
            }),
            "data-test-id": "back-button"
        }, gatedBackButtonText);
    }
    const backButtonText = text ? text : formatMessage((0, $cNhg9.default).backButtonText);
    return /*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.Button), {
        appearance: "subtle",
        actionSubjectId: actionSubjectId,
        onClick: onClick,
        "aria-label": backButtonText,
        iconBefore: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($i2XJe))), {
            label: "",
            size: "small",
            spacing: "compact",
            color: "var(--ds-icon, #42526E)"
        }),
        "data-test-id": "back-button"
    }, backButtonText);
};
var $2fafb5391d28fdb0$export$2e2bcd8739ae039 = $2fafb5391d28fdb0$var$BackButton;

});
parcelRegister("i2XJe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d485ff62f9140a59decb65646f9f10e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d236bec49bb5bdd5$var$_react = $d236bec49bb5bdd5$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d236bec49bb5bdd5$var$_iconNew = $d236bec49bb5bdd5$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d236bec49bb5bdd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d236bec49bb5bdd5$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $d236bec49bb5bdd5$var$_react.default.createElement($d236bec49bb5bdd5$var$_iconNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$d236bec49bb5bdd5$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $d236bec49bb5bdd5$var$_default = module.exports.default = $d236bec49bb5bdd5$var$ArrowLeftIcon;

});

parcelRegister("cNhg9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3beee701f3a5b50a$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $3beee701f3a5b50a$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    backButtonText: {
        defaultMessage: 'Back',
        description: 'Back button text',
        id: 'sd.common.back-button.text'
    }
});

});


parcelRegister("aEtFp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c6d48baedee7cdc$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $dRkX9 = parcelRequire("dRkX9");
const $9c6d48baedee7cdc$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $9c6d48baedee7cdc$var$inputMediaDisabled = null;
const $9c6d48baedee7cdc$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $9c6d48baedee7cdc$var$disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $9c6d48baedee7cdc$var$invalidStyle = null;
const $9c6d48baedee7cdc$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $9c6d48baedee7cdc$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $9c6d48baedee7cdc$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $9c6d48baedee7cdc$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $9c6d48baedee7cdc$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $9c6d48baedee7cdc$var$getMaxWidth = (width)=>!width ? `100%` : width in $9c6d48baedee7cdc$var$widthMap ? `${$9c6d48baedee7cdc$var$widthMap[width]}px` : `${+width}px`;
const $9c6d48baedee7cdc$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $9c6d48baedee7cdc$var$containerStyles = null;
const $9c6d48baedee7cdc$var$inputDisabledStyle = null;
const $9c6d48baedee7cdc$var$inputCompactStyle = null;
const $9c6d48baedee7cdc$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textfield uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $9c6d48baedee7cdc$var$inputStyle = null;
const $9c6d48baedee7cdc$var$atomicInputStyle = null;
// The bounded CSS API does not support this pointer media query; preserve the input's mobile sizing.
const $9c6d48baedee7cdc$var$atomicInputSpacing = {
    compact: "_85i51b66 _1q511b66 _xn00v77o _1st5v77o",
    default: "_85i5u2gc _1q51u2gc _xn0012x7 _1st512x7"
};
const $9c6d48baedee7cdc$var$finessePlaceholderStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $9c6d48baedee7cdc$var$Textfield = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const isInputMotionEnabled = (0, $dRkX9.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const inputRef = (0, $fc4bM.useRef)(null);
    const handleOnFocus = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$9c6d48baedee7cdc$var$analyticsParams
    });
    const handleOnBlur = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$9c6d48baedee7cdc$var$analyticsParams
    });
    const handleOnMouseDown = (0, $fc4bM.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $fc4bM.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$9c6d48baedee7cdc$var$getMaxWidth(width)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1qi0",
            !isInputMotionEnabled && $9c6d48baedee7cdc$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $9c6d48baedee7cdc$var$inputMotionStyles.base,
            $9c6d48baedee7cdc$var$getContainerTextBgAndBorderColor[appearance],
            $9c6d48baedee7cdc$var$containerStyleAppearance[appearance],
            !isDisabled && $9c6d48baedee7cdc$var$focusWithinStyle[appearance],
            !isDisabled && $9c6d48baedee7cdc$var$hoverStyle[appearance],
            isDisabled && $9c6d48baedee7cdc$var$containerMedia.disabled,
            isDisabled && $9c6d48baedee7cdc$var$disabledStyle[appearance],
            isInvalid && $9c6d48baedee7cdc$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // TODO: When removing legacy theming fix this.
                "data-compact": isCompact && !(0, $dRkX9.fg)('platform-textfield-atomic-styles') ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $2R2iS.default)([
                    (0, $dRkX9.fg)('platform-textfield-atomic-styles') ? "_19itidpf _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _y4ti12x7 _bozg12x7 _13xeglyw _1n7e1l2s _1idr1rpy _j4tm1d4k" : "_19itidpf _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _j4tm1d4k _1tmk12x7 _npz312x7 _1j6u12x7 _1ark12x7",
                    (0, $dRkX9.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
                    isMonospaced && "_ect4zzfg _1f2rzzfg",
                    !(0, $dRkX9.fg)('platform-textfield-atomic-styles') && isCompact && "_11zp1b66 _1l021b66 _daj712x7 _141f12x7 _rzs1v77o _141av77o _mwav12x7 _1aex12x7",
                    (0, $dRkX9.fg)('platform-textfield-atomic-styles') && $9c6d48baedee7cdc$var$atomicInputSpacing[isCompact ? 'compact' : 'default'],
                    isDisabled && "_syaz1gmx _1idr1gmx",
                    isDisabled && "_1fnx18qt"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $9c6d48baedee7cdc$export$2e2bcd8739ae039 = $9c6d48baedee7cdc$var$Textfield;

});

parcelRegister("5qFsk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c60f40b29647d6af$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $c60f40b29647d6af$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    inputPlaceholder: {
        defaultMessage: 'Search for help resources',
        description: 'Placeholder message for the search bar describing what they can look for',
        id: 'cv.search.search-bar.input.placeholder'
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-bar.close'
    },
    inputLabel: {
        defaultMessage: 'Search bar input',
        description: 'Label message for the search bar input',
        id: 'cv.search.search-bar.input-label'
    },
    searchIconLabel: {
        defaultMessage: 'Search icon',
        description: 'Label message for the search bar input icon',
        id: 'cv.search.search-bar.search-icon-label'
    },
    clearLabel: {
        defaultMessage: 'clear',
        description: 'Label for the clear button which clears the search input',
        id: 'cv.search.search-bar.clear-label'
    },
    characterLimitExceeded: {
        defaultMessage: 'Search queries must be {limit, number} characters or less.',
        description: 'Error message shown when the search query exceeds the character limit.',
        id: 'cv.search.search-bar.character-limit-exceeded'
    },
    characterLimitErrorIconLabel: {
        defaultMessage: 'Search query is too long',
        description: 'Accessible label for the error icon shown when the search query is too long.',
        id: 'cv.search.search-bar.character-limit-error-icon-label'
    }
});

});



parcelRegister("l8mG7", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => (parcelRequire("5nnCc")).SearchResult);

var $5nnCc = parcelRequire("5nnCc");

});
parcelRegister("5nnCc", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $2f55e913bba2809b$export$a2def421b23768aa);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("ieUrC");
var $euVUr = parcelRequire("euVUr");

var $jVMDF = parcelRequire("jVMDF");

var $1zYKE = parcelRequire("1zYKE");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $iSFD9 = parcelRequire("iSFD9");

var $gc44Y = parcelRequire("gc44Y");
parcelRequire("athLx");
var $3vHuP = parcelRequire("3vHuP");
parcelRequire("4ZWZy");
var $eFtAu = parcelRequire("eFtAu");

var $89aYe = parcelRequire("89aYe");
parcelRequire("hnrtx");
var $iW0i8 = parcelRequire("iW0i8");
parcelRequire("8zDH6");
var $aCpsw = parcelRequire("aCpsw");
parcelRequire("btDGN");
var $atgtc = parcelRequire("atgtc");
parcelRequire("gPNlv");
var $eMr3b = parcelRequire("eMr3b");
const $2f55e913bba2809b$export$e9a269813a6315a4 = ({ term: term, updateResultsCount: updateResultsCount })=>{
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const onlyRenderArticles = isCSM;
    if (onlyRenderArticles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iW0i8.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3vHuP.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $2f55e913bba2809b$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iW0i8.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3vHuP.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iW0i8.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eMr3b.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iW0i8.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $atgtc.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }))));
};
const $2f55e913bba2809b$export$a2def421b23768aa = ({ term: term })=>{
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const [totalCount, setTotalCount] = (0, $fc4bM.useState)(-1);
    const resultsCount = (0, $fc4bM.useRef)(-1);
    const callBackCount = (0, $fc4bM.useRef)(0);
    const debouncedTerm = (0, $gc44Y.default)(term, (0, $eFtAu.SEARCH_QUERY_DEBOUNCE_TIME));
    // Every time this callback will be called, that resource will increment callBackCount through acknowledgement
    const updateResultsCount = (0, $fc4bM.useCallback)((count, acknowledgement)=>{
        if (resultsCount.current < 0) resultsCount.current = 0;
        resultsCount.current += count;
        if (acknowledgement) callBackCount.current += acknowledgement;
        // Update state only when articles, portals and requestForms all have updated the results
        if (callBackCount.current === 3) {
            // Since callbackCount will persist across states, setting it back to 0
            callBackCount.current = 0;
            setTotalCount(resultsCount.current);
        }
    }, []);
    (0, $iSFD9.useIsoMorphicLayoutEffect)(()=>{
        // Reset count to initial state on term change
        resultsCount.current = -1;
        setTotalCount(-1);
        callBackCount.current = 0;
    }, [
        debouncedTerm
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        isCSM ? (0, $89aYe.csmSearchExperience).start() : (0, $89aYe.searchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            isCSM ? (0, $89aYe.csmSearchExperience).abort() : (0, $89aYe.searchExperience).abort();
        };
    }, [
        debouncedTerm,
        isCSM
    ]);
    const isEmptyResultsState = totalCount === 0;
    const isEmptyQueryState = debouncedTerm === '';
    const showEmptyState = isEmptyQueryState || isEmptyResultsState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iW0i8.SearchResultsLoader), null)
    }, showEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aCpsw.SearchResultNone), {
        term: debouncedTerm
    }), !isEmptyResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($2f55e913bba2809b$export$e9a269813a6315a4, {
        term: term,
        updateResultsCount: updateResultsCount
    }));
};
const $2f55e913bba2809b$var$responsiveStyles = (0, $kig2V.xcss)({
    [(0, $1zYKE.media).above.xxs]: {
        gridTemplateColumns: '1fr'
    },
    [(0, $1zYKE.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});

});
parcelRegister("gc44Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $86d8ef2e3721c888$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
/**
 * If the 'value' changes multiple times in quick succession, within the specified 'delay' time frame,
 * the 'debouncedValue' only changes once and equals the latest 'value'
 */ const $86d8ef2e3721c888$var$useDebouncedValue = (value, delay)=>{
    const [debouncedValue, setDebouncedValue] = (0, $fc4bM.useState)(value);
    // useEffect schedules an update to 'debouncedValue' after the delay
    // if the 'value' changes before the delay, the previous timeout is cleared, and a new one is started
    (0, $fc4bM.useEffect)(()=>{
        const timeoutID = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timeoutID);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
var $86d8ef2e3721c888$export$2e2bcd8739ae039 = $86d8ef2e3721c888$var$useDebouncedValue;

});

parcelRegister("athLx", function(module, exports) {
$parcel$export(module.exports, "Articles", () => (parcelRequire("3vHuP")).default);

var $3vHuP = parcelRequire("3vHuP");

});
parcelRegister("3vHuP", function(module, exports) {
$parcel$export(module.exports, "default", () => $82ce1409a80da714$export$2e2bcd8739ae039);

var $bQ8qt = parcelRequire("bQ8qt");

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $iK1uY = parcelRequire("iK1uY");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $azARG = parcelRequire("azARG");

var $1hJdJ = parcelRequire("1hJdJ");

var $13zmE = parcelRequire("13zmE");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $1HrSr = parcelRequire("1HrSr");

var $uYmrU = parcelRequire("uYmrU");
parcelRequire("1jNSU");
var $1mvg0 = parcelRequire("1mvg0");
parcelRequire("4ZWZy");
var $eFtAu = parcelRequire("eFtAu");
var $b52IZ = parcelRequire("b52IZ");
var $cd2Ru = parcelRequire("cd2Ru");

var $89aYe = parcelRequire("89aYe");
parcelRequire("8zDH6");
var $aCpsw = parcelRequire("aCpsw");

var $eDb29 = parcelRequire("eDb29");
const $82ce1409a80da714$export$b9fde6c411c336c6 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const CSMPortalId = isCSM ? (0, $7lN8e.getEnv)().hoistedPortalId : undefined;
    const { portalIds: portalIds, categoryIds: categoryIds } = (0, $b52IZ.useQueryParams)();
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    const getSelectedPortalIds = ()=>{
        if (CSMPortalId) return (0, $b52IZ.getIdsArray)(CSMPortalId);
        if ((0, $b52IZ.isSinglePortalSearch)(portalId)) return (0, $b52IZ.getIdsArray)(portalId);
        return (0, $b52IZ.getIdsArray)(portalIds);
    };
    const cloudId = (0, $6LH8a.getCloudId)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $bQ8qt.default), {
        cloudId: cloudId,
        categoryIds: categoryIds,
        queryTerm: term,
        portalIds: getSelectedPortalIds(),
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        limit: (0, $eFtAu.ARTICLES_RESULT_LIMIT),
        highlight: true,
        isSourceSystemEnabled: true
    });
    const [numberOfResultsShown, setNumberOfResultsShown] = (0, $fc4bM.useState)((0, $eFtAu.INITIAL_ARTICLES_LIMIT));
    const articles = (0, $fc4bM.useMemo)(()=>{
        var _data$helpObjectStore;
        return ((_data$helpObjectStore = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreArticleSearchResults' ? data.helpObjectStore_searchArticles.results : [];
    }, [
        data.helpObjectStore_searchArticles
    ]);
    const numOfResults = articles.length;
    const hasMoreResults = numOfResults > numberOfResultsShown;
    const showMoreArticlesButton = numberOfResultsShown < 30 && hasMoreResults;
    const slicedArticles = articles.slice(0, numberOfResultsShown) || [];
    const showSection = numOfResults > 0;
    const sourceSystem = (0, $fc4bM.useMemo)(()=>articles.reduce((records, item)=>{
            const currentSourceSystem = item.sourceSystem;
            const value = currentSourceSystem ? records[currentSourceSystem] ?? 0 : 0;
            return {
                ...records,
                ...currentSourceSystem && {
                    [currentSourceSystem]: value + 1
                }
            };
        }, {}), [
        articles
    ]);
    (0, $fc4bM.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreArticleSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchArticles.results.forEach((article)=>{
                if (article) {
                    const { metadata: metadata } = article;
                    const { searchStrategy: searchStrategy } = metadata;
                    const isExternal = article.sourceSystem === 'EXTERNAL';
                    if (isExternal) externalResourcesCount += 1;
                    if (searchStrategy === 'CONTENT_SEARCH') firstPartySearchPlatformResourcesCount += 1;
                }
            });
            (0, $b52IZ.sendSearchOperationalAnalyticEvents)({
                sourceSystem: sourceSystem,
                action: portalId ? 'KBArticleSinglePortalSearch success' : 'KBArticleHomePageSearch success',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $b52IZ.sendSearchUIAnalyticEvents)({
                sourceSystem: sourceSystem,
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'article',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
        }
    }, [
        showSection,
        createAnalyticsEvent,
        portalId,
        sourceSystem,
        data
    ]);
    (0, $fc4bM.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchArticles;
            (0, $b52IZ.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                action: portalId ? 'KBArticleSinglePortalSearch failed' : 'KBArticleHomePageSearch failed',
                statusCode: extensions.length > 0 ? extensions[0].statusCode : undefined,
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        updateResultsCount(slicedArticles.length, 1);
    }, [
        term,
        slicedArticles.length,
        updateResultsCount
    ]);
    const onShowMoreClick = ()=>{
        if (numberOfResultsShown < 30) setNumberOfResultsShown((0, $eFtAu.ARTICLES_RESULT_LIMIT));
    };
    if (!showSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aCpsw.SearchResultNone), {
        term: term
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $eDb29.default).articles)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1HrSr.ThirdPartyCardConnector), {
        type: "card",
        connectors: [
            'googleDrive',
            'sharepoint'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.ResultList), {
        role: "list"
    }, slicedArticles.map((resource, index)=>{
        const itemOrder = index + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("li", {
            key: itemOrder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1mvg0.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    })), showMoreArticlesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iK1uY.ThemedButton), {
        "data-test-id": "show-more-button",
        appearance: "link",
        actionSubjectId: "showMoreButton",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            size: "small",
            spacing: "spacious",
            label: formatMessage((0, $eDb29.default).showMoreIcon)
        }),
        onClick: onShowMoreClick
    }, formatMessage((0, $eDb29.default).showMore))), isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $89aYe.csmSearchExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $89aYe.searchExperience)
    }));
};
var $82ce1409a80da714$export$2e2bcd8739ae039 = (0, $azARG.default)()($82ce1409a80da714$export$b9fde6c411c336c6);

});
parcelRegister("bQ8qt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a266c3234b02484$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1721f64acd5bfb357c7a70051aa8f6af>>
 * @relayHash 0d77121bf6717adbc116ac50a5fadabf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b
const $3a266c3234b02484$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "highlight"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSourceSystemEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "categoryIds",
            "variableName": "categoryIds"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "highlight",
            "variableName": "highlight"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalIds",
            "variableName": "portalIds"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "HelpObjectStoreArticleMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "sourceSystem"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isSourceSystemEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isSourceSystemEnabled",
                                                    "variableName": "isSourceSystemEnabled"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "articleItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "ari"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "containerName"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b",
            "metadata": {},
            "name": "articlesSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3a266c3234b02484$var$node.hash = "21465f36d9753aacb064065974751749";
var $3a266c3234b02484$export$2e2bcd8739ae039 = $3a266c3234b02484$var$node;

});

parcelRegister("1HrSr", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyCardConnector", () => $eb2f46fefe1c5dac$export$3ebb74b46e82b89e);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $eb2f46fefe1c5dac$export$3ebb74b46e82b89e = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazy)(()=>(parcelRequire("hWXAo")), {
        moduleId: "./packages/help-center/thirdparty-connectors/src/ui/connectors/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("hWXAo", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("2fJs2").then(()=>parcelRequire('je91i'));

});


parcelRegister("1jNSU", function(module, exports) {
$parcel$export(module.exports, "ArticleItem", () => (parcelRequire("1mvg0")).default);

var $1mvg0 = parcelRequire("1mvg0");

});
parcelRegister("1mvg0", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff246ef5ceb68256$export$2e2bcd8739ae039);

var $dZkHA = parcelRequire("dZkHA");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $io4o2 = parcelRequire("io4o2");

var $jtp0M = parcelRequire("jtp0M");

var $3BiGe = parcelRequire("3BiGe");

var $fJq3t = parcelRequire("fJq3t");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $azARG = parcelRequire("azARG");

var $k2M4v = parcelRequire("k2M4v");

var $dVoLr = parcelRequire("dVoLr");

var $5a4EU = parcelRequire("5a4EU");

var $jVMDF = parcelRequire("jVMDF");

var $kig2V = parcelRequire("kig2V");

var $4T8rw = parcelRequire("4T8rw");

var $h46Vs = parcelRequire("h46Vs");

var $cf3fd = parcelRequire("cf3fd");

var $a1I28 = parcelRequire("a1I28");

var $7lN8e = parcelRequire("7lN8e");

var $3GHVc = parcelRequire("3GHVc");
parcelRequire("jolUD");
var $3kiUl = parcelRequire("3kiUl");

var $eDb29 = parcelRequire("eDb29");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
parcelRequire("1KMlx");
var $4VcZ1 = parcelRequire("4VcZ1");
const $ff246ef5ceb68256$export$3a909d935747d7f7 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useFragment)((0, $dZkHA.default), result);
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    const { title: title, excerpt: excerpt, displayLink: displayLink, metadata: metadata, ari: ari, sourceSystem: sourceSystem } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const isExternal = sourceSystem === 'EXTERNAL';
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVoLr))), {
        label: formatMessage((0, $eDb29.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $b52IZ.formatText)(title, term) : '';
    const highlightedDescription = excerpt ? (0, $b52IZ.formatText)(excerpt, term) : '';
    const displayLinkWithSource = (0, $a1I28.addSourceToUrl)(displayLink, 'search', (0, $a1I28.is3pOrExternalSource)(sourceSystem));
    const linkProps = (0, $3GHVc.urlRefsAndTarget)({
        displayLink: displayLinkWithSource,
        isAnExternalResource: (0, $a1I28.is3pOrExternalSource)(sourceSystem)
    });
    (0, $fc4bM.useEffect)(()=>{
        (0, $b52IZ.sendSearchUIAnalyticEvents)({
            sourceSystem: sourceSystem,
            ari: ari,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'article'
        }, createAnalyticsEvent, portalId);
    }, [
        ari,
        createAnalyticsEvent,
        portalId,
        searchStrategy,
        sourceSystem
    ]);
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $b52IZ.useVisibilityState)();
    const isJcsSearchExperienceEnabled = (0, $k2M4v.default).checkGate('jcs_search_experience');
    const disableMetadata = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && isJcsSearchExperienceEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        key: ari,
        xcss: $ff246ef5ceb68256$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $ff246ef5ceb68256$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4VcZ1.default), {
        displayLink: displayLink,
        entityType: "ARTICLE",
        sourceSystem: sourceSystem,
        isExternal: isExternal,
        variant: "tile"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $ff246ef5ceb68256$var$headingAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $io4o2.Link), {
        key: ari,
        actionSubjectId: isExternal ? 'external-article-link' : 'article-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            ari: ari,
            itemOrder: itemOrder,
            searchStrategy: searchStrategy,
            sourceSystem: sourceSystem,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        style: {
            color: (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $h46Vs.generateThemeBranding)(themeColor).color900 : themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $fJq3t.sanitize)(highlightedTitle)
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: [
            $ff246ef5ceb68256$var$subheadingLeftAreaStyles,
            $ff246ef5ceb68256$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, !disableMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3kiUl.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: isShortcutIconVisible ? $ff246ef5ceb68256$var$headerRightAreaStylesVisible : $ff246ef5ceb68256$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: disableMetadata ? $ff246ef5ceb68256$var$jcsBodyAreaStyles : $ff246ef5ceb68256$var$bodyAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("p", {
        dangerouslySetInnerHTML: {
            __html: (0, $fJq3t.sanitize)(highlightedDescription)
        }
    })))));
};
const $ff246ef5ceb68256$var$ConnectedArticleItem = (0, $6umft.default)((state)=>{
    return {
        isLoggedIn: (0, $3BiGe.isLoggedIn)(state),
        themeColor: (0, $jtp0M.getThemeColor)(state)
    };
})($ff246ef5ceb68256$export$3a909d935747d7f7);
var $ff246ef5ceb68256$export$2e2bcd8739ae039 = (0, $azARG.default)()($ff246ef5ceb68256$var$ConnectedArticleItem);
const $ff246ef5ceb68256$var$containerStyles = (0, $kig2V.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $ff246ef5ceb68256$var$iconAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'icon',
    width: 'size.300',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    textDecoration: 'none'
});
const $ff246ef5ceb68256$var$headingAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.large'
});
const $ff246ef5ceb68256$var$subheadingStyles = (0, $kig2V.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $ff246ef5ceb68256$var$subheadingLeftAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $ff246ef5ceb68256$var$headerRightAreaStylesInVisible = (0, $kig2V.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $ff246ef5ceb68256$var$headerRightAreaStylesVisible = (0, $kig2V.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $ff246ef5ceb68256$var$bodyAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $ff246ef5ceb68256$var$jcsBodyAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'body',
    marginTop: 'space.0',
    overflowWrap: 'break-word'
});

});
parcelRegister("dZkHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3d7e25ad83820f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e955bfb536b6c8db2982e28cab94e966>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3d7e25ad83820f9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSourceSystemEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "articleItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "excerpt"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "condition": "isSourceSystemEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sourceSystem"
                }
            ]
        },
        {
            "concreteType": "HelpObjectStoreArticleMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "articleMetadataFragmentV2"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$a3d7e25ad83820f9$var$node.hash = "7da1cbe6e7f48ee2d870a75fe8f1d82c";
var $a3d7e25ad83820f9$export$2e2bcd8739ae039 = $a3d7e25ad83820f9$var$node;

});

parcelRegister("fJq3t", function(module, exports) {


module.exports = self.DOMPurify || (self.DOMPurify = (parcelRequire("1LqX3")).default || (parcelRequire("1LqX3")));

});
parcelRegister("1LqX3", function(module, exports) {
/*! @license DOMPurify 3.4.12 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.12/LICENSE */ 'use strict';
function $148f163621fa2d18$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $148f163621fa2d18$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $148f163621fa2d18$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $148f163621fa2d18$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $148f163621fa2d18$var$_slicedToArray(r, e) {
    return $148f163621fa2d18$var$_arrayWithHoles(r) || $148f163621fa2d18$var$_iterableToArrayLimit(r, e) || $148f163621fa2d18$var$_unsupportedIterableToArray(r, e) || $148f163621fa2d18$var$_nonIterableRest();
}
function $148f163621fa2d18$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $148f163621fa2d18$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $148f163621fa2d18$var$_arrayLikeToArray(r, a) : void 0;
    }
}
const $148f163621fa2d18$var$entries = Object.entries, $148f163621fa2d18$var$setPrototypeOf = Object.setPrototypeOf, $148f163621fa2d18$var$isFrozen = Object.isFrozen, $148f163621fa2d18$var$getPrototypeOf = Object.getPrototypeOf, $148f163621fa2d18$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let $148f163621fa2d18$var$freeze = Object.freeze, $148f163621fa2d18$var$seal = Object.seal, $148f163621fa2d18$var$create = Object.create; // eslint-disable-line import/no-mutable-exports
let $148f163621fa2d18$var$_ref = typeof Reflect !== 'undefined' && Reflect, $148f163621fa2d18$var$apply = $148f163621fa2d18$var$_ref.apply, $148f163621fa2d18$var$construct = $148f163621fa2d18$var$_ref.construct;
if (!$148f163621fa2d18$var$freeze) $148f163621fa2d18$var$freeze = function freeze(x) {
    return x;
};
if (!$148f163621fa2d18$var$seal) $148f163621fa2d18$var$seal = function seal(x) {
    return x;
};
if (!$148f163621fa2d18$var$apply) $148f163621fa2d18$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$148f163621fa2d18$var$construct) $148f163621fa2d18$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $148f163621fa2d18$var$arrayForEach = $148f163621fa2d18$var$unapply(Array.prototype.forEach);
const $148f163621fa2d18$var$arrayLastIndexOf = $148f163621fa2d18$var$unapply(Array.prototype.lastIndexOf);
const $148f163621fa2d18$var$arrayPop = $148f163621fa2d18$var$unapply(Array.prototype.pop);
const $148f163621fa2d18$var$arrayPush = $148f163621fa2d18$var$unapply(Array.prototype.push);
const $148f163621fa2d18$var$arraySplice = $148f163621fa2d18$var$unapply(Array.prototype.splice);
const $148f163621fa2d18$var$arrayIsArray = Array.isArray;
const $148f163621fa2d18$var$stringToLowerCase = $148f163621fa2d18$var$unapply(String.prototype.toLowerCase);
const $148f163621fa2d18$var$stringToString = $148f163621fa2d18$var$unapply(String.prototype.toString);
const $148f163621fa2d18$var$stringMatch = $148f163621fa2d18$var$unapply(String.prototype.match);
const $148f163621fa2d18$var$stringReplace = $148f163621fa2d18$var$unapply(String.prototype.replace);
const $148f163621fa2d18$var$stringIndexOf = $148f163621fa2d18$var$unapply(String.prototype.indexOf);
const $148f163621fa2d18$var$stringTrim = $148f163621fa2d18$var$unapply(String.prototype.trim);
const $148f163621fa2d18$var$numberToString = $148f163621fa2d18$var$unapply(Number.prototype.toString);
const $148f163621fa2d18$var$booleanToString = $148f163621fa2d18$var$unapply(Boolean.prototype.toString);
const $148f163621fa2d18$var$bigintToString = typeof BigInt === 'undefined' ? null : $148f163621fa2d18$var$unapply(BigInt.prototype.toString);
const $148f163621fa2d18$var$symbolToString = typeof Symbol === 'undefined' ? null : $148f163621fa2d18$var$unapply(Symbol.prototype.toString);
const $148f163621fa2d18$var$objectHasOwnProperty = $148f163621fa2d18$var$unapply(Object.prototype.hasOwnProperty);
const $148f163621fa2d18$var$objectToString = $148f163621fa2d18$var$unapply(Object.prototype.toString);
const $148f163621fa2d18$var$regExpTest = $148f163621fa2d18$var$unapply(RegExp.prototype.test);
const $148f163621fa2d18$var$typeErrorCreate = $148f163621fa2d18$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $148f163621fa2d18$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $148f163621fa2d18$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $148f163621fa2d18$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $148f163621fa2d18$var$construct(Func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $148f163621fa2d18$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $148f163621fa2d18$var$stringToLowerCase;
    if ($148f163621fa2d18$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $148f163621fa2d18$var$setPrototypeOf(set, null);
    if (!$148f163621fa2d18$var$arrayIsArray(array)) return set;
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$148f163621fa2d18$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $148f163621fa2d18$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $148f163621fa2d18$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $148f163621fa2d18$var$clone(object) {
    const newObject = $148f163621fa2d18$var$create(null);
    for (const _ref2 of $148f163621fa2d18$var$entries(object)){
        var _ref3 = $148f163621fa2d18$var$_slicedToArray(_ref2, 2);
        const property = _ref3[0];
        const value = _ref3[1];
        const isPropertyExist = $148f163621fa2d18$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if ($148f163621fa2d18$var$arrayIsArray(value)) newObject[property] = $148f163621fa2d18$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $148f163621fa2d18$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */ function $148f163621fa2d18$var$stringifyValue(value) {
    switch(typeof value){
        case 'string':
            return value;
        case 'number':
            return $148f163621fa2d18$var$numberToString(value);
        case 'boolean':
            return $148f163621fa2d18$var$booleanToString(value);
        case 'bigint':
            return $148f163621fa2d18$var$bigintToString ? $148f163621fa2d18$var$bigintToString(value) : '0';
        case 'symbol':
            return $148f163621fa2d18$var$symbolToString ? $148f163621fa2d18$var$symbolToString(value) : 'Symbol()';
        case 'undefined':
            return $148f163621fa2d18$var$objectToString(value);
        case 'function':
        case 'object':
            {
                if (value === null) return $148f163621fa2d18$var$objectToString(value);
                const valueAsRecord = value;
                const valueToString = $148f163621fa2d18$var$lookupGetter(valueAsRecord, 'toString');
                if (typeof valueToString === 'function') {
                    const stringified = valueToString(valueAsRecord);
                    return typeof stringified === 'string' ? stringified : $148f163621fa2d18$var$objectToString(stringified);
                }
                return $148f163621fa2d18$var$objectToString(value);
            }
        default:
            return $148f163621fa2d18$var$objectToString(value);
    }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $148f163621fa2d18$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $148f163621fa2d18$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $148f163621fa2d18$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $148f163621fa2d18$var$unapply(desc.value);
        }
        object = $148f163621fa2d18$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
function $148f163621fa2d18$var$isRegex(value) {
    try {
        $148f163621fa2d18$var$regExpTest(value, '');
        return true;
    } catch (_unused) {
        return false;
    }
}
const $148f163621fa2d18$var$html$1 = $148f163621fa2d18$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $148f163621fa2d18$var$svg$1 = $148f163621fa2d18$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $148f163621fa2d18$var$svgFilters = $148f163621fa2d18$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $148f163621fa2d18$var$svgDisallowed = $148f163621fa2d18$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $148f163621fa2d18$var$mathMl$1 = $148f163621fa2d18$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $148f163621fa2d18$var$mathMlDisallowed = $148f163621fa2d18$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $148f163621fa2d18$var$text = $148f163621fa2d18$var$freeze([
    '#text'
]);
const $148f163621fa2d18$var$html = $148f163621fa2d18$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'command',
    'commandfor',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns'
]);
const $148f163621fa2d18$var$svg = $148f163621fa2d18$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dominant-baseline',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-orientation',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $148f163621fa2d18$var$mathMl = $148f163621fa2d18$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $148f163621fa2d18$var$xml = $148f163621fa2d18$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
const $148f163621fa2d18$var$MUSTACHE_EXPR = $148f163621fa2d18$var$seal(/{{[\w\W]*|^[\w\W]*}}/g);
const $148f163621fa2d18$var$ERB_EXPR = $148f163621fa2d18$var$seal(/<%[\w\W]*|^[\w\W]*%>/g);
const $148f163621fa2d18$var$TMPLIT_EXPR = $148f163621fa2d18$var$seal(/\${[\w\W]*/g);
const $148f163621fa2d18$var$DATA_ATTR = $148f163621fa2d18$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $148f163621fa2d18$var$ARIA_ATTR = $148f163621fa2d18$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $148f163621fa2d18$var$IS_ALLOWED_URI = $148f163621fa2d18$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $148f163621fa2d18$var$IS_SCRIPT_OR_DATA = $148f163621fa2d18$var$seal(/^(?:\w+script|data):/i);
const $148f163621fa2d18$var$ATTR_WHITESPACE = $148f163621fa2d18$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $148f163621fa2d18$var$DOCTYPE_NAME = $148f163621fa2d18$var$seal(/^html$/i);
const $148f163621fa2d18$var$CUSTOM_ELEMENT = $148f163621fa2d18$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
// Markup-significant character probes used by _sanitizeElements.
// Shared module-level instances are safe despite the sticky /g flags:
// unapply() resets lastIndex for RegExp receivers before every call.
const $148f163621fa2d18$var$ELEMENT_MARKUP_PROBE = $148f163621fa2d18$var$seal(/<[/\w!]/g);
const $148f163621fa2d18$var$COMMENT_MARKUP_PROBE = $148f163621fa2d18$var$seal(/<[/\w]/g);
const $148f163621fa2d18$var$FALLBACK_TAG_CLOSE = $148f163621fa2d18$var$seal(/<\/no(script|embed|frames)/i);
const $148f163621fa2d18$var$SELF_CLOSING_TAG = $148f163621fa2d18$var$seal(/\/>/i);
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $148f163621fa2d18$var$NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    processingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12 // Deprecated
};
const $148f163621fa2d18$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $148f163621fa2d18$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $148f163621fa2d18$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
/**
 * Resolve a set-valued configuration option: a fresh set built from
 * cfg[key] when it is an own array property (seeded with a clone of
 * options.base when given, case-normalized via options.transform),
 * the fallback set otherwise.
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param fallback the set to use when the option is absent or not an array
 * @param options transform and optional base set to merge into
 * @returns the resolved set
 */ const $148f163621fa2d18$var$_resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
    return $148f163621fa2d18$var$objectHasOwnProperty(cfg, key) && $148f163621fa2d18$var$arrayIsArray(cfg[key]) ? $148f163621fa2d18$var$addToSet(options.base ? $148f163621fa2d18$var$clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
function $148f163621fa2d18$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $148f163621fa2d18$var$getGlobal();
    const DOMPurify = (root)=>$148f163621fa2d18$var$createDOMPurify(root);
    DOMPurify.version = '3.4.12';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $148f163621fa2d18$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let document = window1.document;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    window1.DocumentFragment;
    const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
    _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
    window1.HTMLFormElement;
    const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
    const ElementPrototype = Element.prototype;
    const cloneNode = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'parentNode');
    const getShadowRoot = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'shadowRoot');
    const getAttributes = $148f163621fa2d18$var$lookupGetter(ElementPrototype, 'attributes');
    const getNodeType = Node && Node.prototype ? $148f163621fa2d18$var$lookupGetter(Node.prototype, 'nodeType') : null;
    const getNodeName = Node && Node.prototype ? $148f163621fa2d18$var$lookupGetter(Node.prototype, 'nodeName') : null;
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    // The instance's own internal Trusted Types policy. Unlike a caller-supplied
    // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
    // on duplicate policy names — and is the only policy allowed to persist
    // across configurations and survive `clearConfig()`.
    let defaultTrustedTypesPolicy;
    let defaultTrustedTypesPolicyResolved = false;
    // Tracks whether we are already inside a call to the configured Trusted Types
    // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
    // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
    // re-enter the policy and recurse until the stack overflows. We detect that
    // re-entry and throw a clear, actionable error instead. The guard is shared
    // across both callbacks, because either one re-entering `sanitize` triggers
    // the same unbounded recursion.
    let IN_TRUSTED_TYPES_POLICY = 0;
    const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
        if (IN_TRUSTED_TYPES_POLICY > 0) throw $148f163621fa2d18$var$typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
    };
    const _createTrustedHTML = function _createTrustedHTML(html) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createHTML(html);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
        _assertNotInTrustedTypesPolicy();
        IN_TRUSTED_TYPES_POLICY++;
        try {
            return trustedTypesPolicy.createScriptURL(scriptUrl);
        } finally{
            IN_TRUSTED_TYPES_POLICY--;
        }
    };
    // Lazily resolve (and cache) the instance's internal default policy.
    // Resolution is attempted at most once: a successful `createPolicy` cannot be
    // repeated (Trusted Types throws on duplicate names), and a failed or
    // unsupported attempt must not be retried on every parse.
    const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
        if (!defaultTrustedTypesPolicyResolved) {
            defaultTrustedTypesPolicy = $148f163621fa2d18$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            defaultTrustedTypesPolicyResolved = true;
        }
        return defaultTrustedTypesPolicy;
    };
    const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
    const importNode = originalDocument.importNode;
    let hooks = $148f163621fa2d18$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $148f163621fa2d18$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const MUSTACHE_EXPR$1 = $148f163621fa2d18$var$MUSTACHE_EXPR, ERB_EXPR$1 = $148f163621fa2d18$var$ERB_EXPR, TMPLIT_EXPR$1 = $148f163621fa2d18$var$TMPLIT_EXPR, DATA_ATTR$1 = $148f163621fa2d18$var$DATA_ATTR, ARIA_ATTR$1 = $148f163621fa2d18$var$ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = $148f163621fa2d18$var$IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = $148f163621fa2d18$var$ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = $148f163621fa2d18$var$CUSTOM_ELEMENT;
    let IS_ALLOWED_URI$1 = $148f163621fa2d18$var$IS_ALLOWED_URI;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $148f163621fa2d18$var$addToSet({}, [
        ...$148f163621fa2d18$var$html$1,
        ...$148f163621fa2d18$var$svg$1,
        ...$148f163621fa2d18$var$svgFilters,
        ...$148f163621fa2d18$var$mathMl$1,
        ...$148f163621fa2d18$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $148f163621fa2d18$var$addToSet({}, [
        ...$148f163621fa2d18$var$html,
        ...$148f163621fa2d18$var$svg,
        ...$148f163621fa2d18$var$mathMl,
        ...$148f163621fa2d18$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($148f163621fa2d18$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal($148f163621fa2d18$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Pristine allowlist bindings captured at setConfig() time. On the
   * persistent-config path sanitize() restores the sets from these before
   * the per-walk hook clone-guard, so a hook's in-call widening cannot
   * carry across calls. Null until setConfig() is called; reset by
   * clearConfig(). */ let SET_CONFIG_ALLOWED_TAGS = null;
    let SET_CONFIG_ALLOWED_ATTR = null;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $148f163621fa2d18$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
        // the UA (customizable <select>) — including any on* handlers — and the
        // engine re-mirrors synchronously whenever a removal changes which
        // option/selectedcontent is current, even inside DOMPurify's inert
        // DOMParser document. Hoisting its children on removal re-inserts a fresh
        // mirror target ahead of the walk, which the engine refills, looping
        // forever (DoS) and amplifying output. Dropping its content on removal
        // (rather than hoisting) breaks that cascade; the content is a duplicate
        // of the option, which is sanitized on its own. See campaign-3 F1/F6.
        'selectedcontent',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $148f163621fa2d18$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $148f163621fa2d18$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $148f163621fa2d18$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $148f163621fa2d18$var$stringToString);
    const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = $148f163621fa2d18$var$freeze([
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let MATHML_TEXT_INTEGRATION_POINTS = $148f163621fa2d18$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    const DEFAULT_HTML_INTEGRATION_POINTS = $148f163621fa2d18$var$freeze([
        'annotation-xml'
    ]);
    let HTML_INTEGRATION_POINTS = $148f163621fa2d18$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $148f163621fa2d18$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $148f163621fa2d18$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $148f163621fa2d18$var$stringToString : $148f163621fa2d18$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $148f163621fa2d18$var$_resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
            transform: transformCaseFunc
        });
        ALLOWED_ATTR = $148f163621fa2d18$var$_resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
            transform: transformCaseFunc
        });
        ALLOWED_NAMESPACES = $148f163621fa2d18$var$_resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
            transform: $148f163621fa2d18$var$stringToString
        });
        URI_SAFE_ATTRIBUTES = $148f163621fa2d18$var$_resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
            transform: transformCaseFunc,
            base: DEFAULT_URI_SAFE_ATTRIBUTES
        });
        DATA_URI_TAGS = $148f163621fa2d18$var$_resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
            transform: transformCaseFunc,
            base: DEFAULT_DATA_URI_TAGS
        });
        FORBID_CONTENTS = $148f163621fa2d18$var$_resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
            transform: transformCaseFunc
        });
        FORBID_TAGS = $148f163621fa2d18$var$_resolveSetOption(cfg, 'FORBID_TAGS', $148f163621fa2d18$var$clone({}), {
            transform: transformCaseFunc
        });
        FORBID_ATTR = $148f163621fa2d18$var$_resolveSetOption(cfg, 'FORBID_ATTR', $148f163621fa2d18$var$clone({}), {
            transform: transformCaseFunc
        });
        USE_PROFILES = $148f163621fa2d18$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? $148f163621fa2d18$var$clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = $148f163621fa2d18$var$isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : $148f163621fa2d18$var$IS_ALLOWED_URI; // Default regexp
        NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
        MATHML_TEXT_INTEGRATION_POINTS = $148f163621fa2d18$var$objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? $148f163621fa2d18$var$clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : $148f163621fa2d18$var$addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS); // Default built-in map
        HTML_INTEGRATION_POINTS = $148f163621fa2d18$var$objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? $148f163621fa2d18$var$clone(cfg.HTML_INTEGRATION_POINTS) : $148f163621fa2d18$var$addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS); // Default built-in map
        const customElementHandling = $148f163621fa2d18$var$objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? $148f163621fa2d18$var$clone(cfg.CUSTOM_ELEMENT_HANDLING) : $148f163621fa2d18$var$create(null);
        CUSTOM_ELEMENT_HANDLING = $148f163621fa2d18$var$create(null);
        if ($148f163621fa2d18$var$objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
        if ($148f163621fa2d18$var$objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
        if ($148f163621fa2d18$var$objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
        $148f163621fa2d18$var$seal(CUSTOM_ELEMENT_HANDLING);
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $148f163621fa2d18$var$addToSet({}, $148f163621fa2d18$var$text);
            ALLOWED_ATTR = $148f163621fa2d18$var$create(null);
            if (USE_PROFILES.html === true) {
                $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, $148f163621fa2d18$var$html$1);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, $148f163621fa2d18$var$svg$1);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$svg);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, $148f163621fa2d18$var$svgFilters);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$svg);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, $148f163621fa2d18$var$mathMl$1);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$mathMl);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, $148f163621fa2d18$var$xml);
            }
        }
        /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        /* Merge configuration parameters */ if ($148f163621fa2d18$var$objectHasOwnProperty(cfg, 'ADD_TAGS')) {
            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else if ($148f163621fa2d18$var$arrayIsArray(cfg.ADD_TAGS)) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $148f163621fa2d18$var$clone(ALLOWED_TAGS);
                $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if ($148f163621fa2d18$var$objectHasOwnProperty(cfg, 'ADD_ATTR')) {
            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else if ($148f163621fa2d18$var$arrayIsArray(cfg.ADD_ATTR)) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $148f163621fa2d18$var$clone(ALLOWED_ATTR);
                $148f163621fa2d18$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if ($148f163621fa2d18$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && $148f163621fa2d18$var$arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) $148f163621fa2d18$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if ($148f163621fa2d18$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && $148f163621fa2d18$var$arrayIsArray(cfg.FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $148f163621fa2d18$var$clone(FORBID_CONTENTS);
            $148f163621fa2d18$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if ($148f163621fa2d18$var$objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && $148f163621fa2d18$var$arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $148f163621fa2d18$var$clone(FORBID_CONTENTS);
            $148f163621fa2d18$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $148f163621fa2d18$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        // Re-derive the active Trusted Types policy from this configuration on
        // every parse. The active policy must never be sticky closure state that
        // outlives the config that set it: a caller-supplied policy left in place
        // after `clearConfig()` — or after a later call that supplied none, or
        // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
        // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
        // See GHSA-vxr8-fq34-vvx9.
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $148f163621fa2d18$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $148f163621fa2d18$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // A caller-supplied policy applies to this configuration only.
            const previousTrustedTypesPolicy = trustedTypesPolicy;
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`. If the supplied policy's
            // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
            // throws via the re-entrancy guard. Restore the previous policy first so
            // the instance is not left in a poisoned state. See #1422.
            try {
                emptyHTML = _createTrustedHTML('');
            } catch (error) {
                trustedTypesPolicy = previousTrustedTypesPolicy;
                throw error;
            }
        } else if (cfg.TRUSTED_TYPES_POLICY === null) {
            // Explicit opt-out for this call: perform no Trusted Types signing and
            // create nothing (so a strict `trusted-types` CSP that disallows a
            // `dompurify` policy can still call `sanitize` from inside its own
            // policy — see #1422). Resetting to `undefined` rather than a sticky
            // `null` also drops any previously retained caller policy, so it cannot
            // resurface on a later call, while still allowing the next config-less
            // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
            trustedTypesPolicy = undefined;
            emptyHTML = '';
        } else {
            // No policy supplied: keep the currently active policy if one is set — a
            // previously supplied policy is intentionally sticky across config-less
            // calls — otherwise fall back to the instance's own internal policy,
            // created at most once. (A policy supplied for a *single* call still
            // lingers by design; what must not linger is a policy whose configuration
            // has been torn down via `clearConfig()`, which restores the default.)
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
            // Sign internal variables only when a policy is active. A falsy policy
            // (Trusted Types unsupported, creation failed, or an explicit opt-out)
            // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
            // a non-policy and throw. See #1422.
            if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($148f163621fa2d18$var$freeze) $148f163621fa2d18$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $148f163621fa2d18$var$addToSet({}, [
        ...$148f163621fa2d18$var$svg$1,
        ...$148f163621fa2d18$var$svgFilters,
        ...$148f163621fa2d18$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $148f163621fa2d18$var$addToSet({}, [
        ...$148f163621fa2d18$var$mathMl$1,
        ...$148f163621fa2d18$var$mathMlDisallowed
    ]);
    /**
   * Namespace rules for an element in the SVG namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
        // The only way to switch from MathML to SVG is via <svg>
        // if the parent is either <annotation-xml> or a MathML
        // text integration point.
        if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the MathML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
    };
    /**
   * Namespace rules for an element in the HTML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    };
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $148f163621fa2d18$var$stringToLowerCase(element.tagName);
        const parentTagName = $148f163621fa2d18$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
        if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $148f163621fa2d18$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            /* The normal detach failed — this is reached for a parentless node
         (getParentNode() is null, so .removeChild throws). Element.prototype
         .remove() is itself a spec no-op on a parentless node, so a recorded
         "removal" would otherwise hand the caller back an intact,
         payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
         the style-with-element-child rule decided to kill). Fail closed by
         throwing — exactly as a clobbered root does at the IN_PLACE entry —
         rather than trying to "neutralize" the node via its own methods.
         Neutralizing would mean calling getAttributeNames()/removeAttribute()
         on the node, both of which a <form> root can clobber via a named child
         (and _isClobbered does not even probe getAttributeNames), so the
         neutralize step could itself be silently defeated, leaving the payload
         intact. A throw touches only the cached, clobber-safe remove() and
         getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
         to every root-kill reason. REPORT-3.
                This lives inside the catch, so it never fires for a normally-removed
         in-tree node: those have a parent, removeChild() succeeds, and the
         catch is not entered. Only a kept (parentless) root reaches here. */ remove(node);
            if (!getParentNode(node)) throw $148f163621fa2d18$var$typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
        }
    };
    /**
   * _neutralizeRoot
   *
   * Fail-closed teardown of an in-place root after the sanitize walk aborts
   * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
   * custom element's reaction detaches a node so `_forceRemove`'s deliberate
   * parentless guard throws, or any other re-entrant engine mutation — would
   * otherwise leave the caller's *live* tree half-sanitized, with everything
   * after the abort point still carrying its handlers. There is no safe way
   * to resume the walk (the tree mutated under us), so we strip the root bare:
   * remove every child and every attribute, then let the caller's catch see
   * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
   * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
   *
   * @param root the in-place root to empty
   */ const _neutralizeRoot = function _neutralizeRoot(root) {
        /* Strip every disallowed attribute (on* handlers included) off the whole
       subtree BEFORE detaching anything. Detaching first would hand back
       handler-bearing originals (e.g. an already-loading `<img onerror>`)
       whose queued resource event still fires in page scope after we throw.
       Clobber-safe reads; a doomed clobbered node's own attributes are
       irrelevant while its non-clobbered descendants are reached and scrubbed. */ _neutralizeSubtree(root);
        const childNodes = getChildNodes(root);
        if (childNodes) {
            const snapshot = [];
            $148f163621fa2d18$var$arrayForEach(childNodes, (child)=>{
                $148f163621fa2d18$var$arrayPush(snapshot, child);
            });
            $148f163621fa2d18$var$arrayForEach(snapshot, (child)=>{
                try {
                    remove(child);
                } catch (_) {
                /* Best-effort teardown; a still-attached child is handled below */ }
            });
        }
        const attributes = getAttributes(root);
        if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name === 'string') try {
                root.removeAttribute(name);
            } catch (_) {
            /* Clobbered removeAttribute — ignore (fail-closed best effort) */ }
        }
    };
    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
        try {
            $148f163621fa2d18$var$arrayPush(DOMPurify.removed, {
                attribute: element.getAttributeNode(name),
                from: element
            });
        } catch (_) {
            $148f163621fa2d18$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: element
            });
        }
        element.removeAttribute(name);
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _stripDisallowedAttributes
   *
   * Removes every attribute the active configuration does not allow from a
   * single element, using the same allowlist as the main attribute pass (so
   * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
   * neutralise nodes that are being discarded from an in-place tree.
   *
   * @param element the element to strip
   */ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
        const attributes = getAttributes(element);
        if (!attributes) return;
        for(let i = attributes.length - 1; i >= 0; --i){
            const attribute = attributes[i];
            const name = attribute && attribute.name;
            if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
            try {
                element.removeAttribute(name);
            } catch (_) {
            /* Clobbered removeAttribute on a doomed node — ignore */ }
        }
    };
    /**
   * _neutralizeSubtree
   *
   * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
   * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
   * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
   * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
   * those dropped nodes are detached from the caller's LIVE tree but a
   * handler-bearing original among them (an `<img onerror>`/`<video>` that was
   * loading) keeps its queued resource event, which fires in page scope after
   * sanitize returns. This walks a removed subtree and strips every attribute
   * the active configuration does not allow — so `on*` handlers are cancelled
   * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
   * blocklist. Run synchronously before sanitize returns, i.e. before any
   * queued event can fire. Hook-free by design: these nodes leave the output,
   * so firing attribute hooks for them would be surprising. Clobber-safe reads;
   * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
   * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
   * the `<img>`, are reached and scrubbed).
   *
   * @param root the root of a removed subtree to neutralise
   */ const _neutralizeSubtree = function _neutralizeSubtree(root) {
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            if (nodeType === $148f163621fa2d18$var$NODE_TYPE.element) _stripDisallowedAttributes(node);
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _neutralizePatchLinkage
   *
   * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
   * hardening, https://github.com/WICG/declarative-partial-updates).
   *
   * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
   * markers (PIs / markup comments) node-by-node, in document order, AS it
   * reaches each node. On a live in-place root that leaves a window: from the
   * moment the root is connected until the walk arrives at a given node, that
   * node's linkage is live. A patch applied on connection/stream can fire as
   * a microtask during the walk and inject or teleport an unsanitized DOM
   * range into a region the iterator has already passed and will not revisit,
   * so the post-return "tree is sanitized" contract is violated. Sweep the
   * whole tree once up front and sever every linkage before the walk begins,
   * closing that window.
   *
   * This CANNOT undo a patch that already fired before sanitize ran — that is
   * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
   * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
   * to group with the rest of the declarative-partial-updates handling and
   * stay overridable, consistent with the codebase.
   *
   * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
   * clobbered root cannot defeat the sweep of its non-clobbered descendants.
   *
   * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
   * .html Q1): this mirrors the existing policy of keeping `for` on
   * <label>/<output>. If the shipping feature can drive a patch through a
   * surviving `for`-on-label/output + `id` pair, this pre-pass and the
   * attribute check at _isBasicCustomElement's caller must additionally drop
   * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
   *
   * @param root the in-place root to sweep
   */ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
        if (!SAFE_FOR_XML) return;
        const stack = [
            root
        ];
        while(stack.length > 0){
            const node = stack.pop();
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            /* Remove range markers (the target side of a patch linkage): every
         processing instruction, and any markup-bearing comment. */ if (nodeType === $148f163621fa2d18$var$NODE_TYPE.processingInstruction || nodeType === $148f163621fa2d18$var$NODE_TYPE.comment && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$COMMENT_MARKUP_PROBE, node.data)) {
                try {
                    remove(node);
                } catch (_) {
                /* Best-effort */ }
                continue;
            }
            /* Strip patch-source attributes (the source side) off elements. */ if (nodeType === $148f163621fa2d18$var$NODE_TYPE.element) {
                const element = node;
                const lcTag = transformCaseFunc(getNodeName ? getNodeName(node) : node.nodeName);
                try {
                    if (element.hasAttribute && element.hasAttribute('patchsrc')) element.removeAttribute('patchsrc');
                    if (element.hasAttribute && element.hasAttribute('for') && lcTag !== 'label' && lcTag !== 'output') element.removeAttribute('for');
                } catch (_) {
                /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */ }
            }
            const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $148f163621fa2d18$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * Replace template expression syntax (mustache, ERB, template
   * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
   * sites. Order matters: mustache, then ERB, then template literal.
   *
   * @param value the string to scrub
   * @returns the scrubbed string
   */ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
        value = $148f163621fa2d18$var$stringReplace(value, MUSTACHE_EXPR$1, ' ');
        value = $148f163621fa2d18$var$stringReplace(value, ERB_EXPR$1, ' ');
        value = $148f163621fa2d18$var$stringReplace(value, TMPLIT_EXPR$1, ' ');
        return value;
    };
    /**
   * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
   * character data of an element subtree. Used as the final safety net for
   * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
   * which only form after text-node normalization (e.g. fragments split across
   * stripped elements) cannot survive into a template-evaluating framework.
   *
   * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
   * in place rather than round-tripping through innerHTML. This preserves
   * descendant node references (important for IN_PLACE callers), avoids a
   * serialize/reparse cycle, and reads literal character data — which means
   * `<%...%>` in text content matches the ERB regex against its real bytes
   * instead of the HTML-entity-escaped form innerHTML would produce.
   *
   * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
   * attributes is performed during the per-node `_sanitizeAttributes` pass.
   *
   * @param node The root element whose character data should be scrubbed.
   */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
        var _node$querySelectorAl;
        node.normalize();
        const walker = createNodeIterator.call(node.ownerDocument || node, node, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
        let currentNode = walker.nextNode();
        while(currentNode){
            currentNode.data = _stripTemplateExpressions(currentNode.data);
            currentNode = walker.nextNode();
        }
        // NodeIterator does not descend into <template>.content per the DOM spec,
        // so we must explicitly recurse into each template's content fragment,
        // mirroring the approach used by _sanitizeShadowDOM.
        const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
        if (templates) $148f163621fa2d18$var$arrayForEach(templates, (tmpl)=>{
            if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
        });
    };
    /**
   * _isClobbered
   *
   * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
   * interface with [LegacyOverrideBuiltIns]; a descendant element with a
   * `name` attribute matching a prototype property shadows that property
   * on direct reads. We use this check at the IN_PLACE entry-point and
   * during attribute sanitization to refuse clobbered forms.
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        // Realm-independent tag-name probe. If we can't determine the tag
        // name at all, we can't reason about clobbering — return false
        // (the caller's other defences still apply).
        const realTagName = getNodeName ? getNodeName(element) : null;
        if (typeof realTagName !== 'string') return false;
        if (transformCaseFunc(realTagName) !== 'form') return false;
        return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
        // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
        // makes the direct read diverge from the cached read; a clean form
        // (same-realm OR foreign-realm) has both reads pointing at the same
        // canonical NamedNodeMap.
        element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
        // returns the integer 1 for any Element regardless of realm; direct
        // read on a clobbered form (e.g. <input name="nodeType">) returns
        // the named child element. Cheap addition — nodeType is read from
        // an internal slot, no serialization cost — and removes a residual
        // clobbering surface used by several mXSS / PI / comment branches
        // in _sanitizeElements that compare currentNode.nodeType directly.
        element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
        // "childNodes" shadows the prototype getter. Direct reads of
        // form.childNodes from a clobbered form return the named child
        // instead of the real NodeList, so any walk that reads it directly
        // skips the form's real children. Compare the direct read to the
        // cached Node.prototype getter — when the form's named-property
        // getter intercepts the read, the two values differ and we flag
        // the form. This catches every clobbering child type (input,
        // select, etc.) regardless of whether the named child happens to
        // carry a numeric .length, which a typeof-based probe would miss
        // (e.g. HTMLSelectElement.length is a defined unsigned-long).
        element.childNodes !== getChildNodes(element);
    };
    /**
   * Checks whether the given value is a DocumentFragment from any realm.
   *
   * The realm-independent replacement reads `nodeType` through the cached
   * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
   * constant (11). nodeType is a numeric value resolved from the node's
   * internal slot, identical across realms for the same kind of node.
   *
   * @param value object to check
   * @return true if value is a DocumentFragment-shaped node from any realm
   */ const _isDocumentFragment = function _isDocumentFragment(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return getNodeType(value) === $148f163621fa2d18$var$NODE_TYPE.documentFragment;
        } catch (_) {
            return false;
        }
    };
    /**
   * Checks whether the given object is a DOM node, including nodes that
   * originate from a different window/realm (e.g. an iframe's
   * contentDocument). The previous `value instanceof Node` check was
   * realm-bound: nodes from a different window failed it, causing
   * sanitize() to silently stringify them and reset IN_PLACE to false,
   * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
   *
   * @param value object to check whether it's a DOM node
   * @return true if value is a DOM node from any realm
   */ const _isNode = function _isNode(value) {
        if (!getNodeType || typeof value !== 'object' || value === null) return false;
        try {
            return typeof getNodeType(value) === 'number';
        } catch (_) {
            return false;
        }
    };
    function _executeHooks(hooks, currentNode, data) {
        if (hooks.length === 0) return;
        $148f163621fa2d18$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * Structural-threat checks that condemn a node regardless of the
   * allowlists: mXSS via namespace confusion, risky CSS construction,
   * processing instructions, markup-bearing comments. Pure predicate;
   * the caller removes. Check order is load-bearing.
   *
   * @param currentNode the node to inspect
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node must be removed
   */ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$ELEMENT_MARKUP_PROBE, currentNode.textContent) && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
        /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) return true;
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $148f163621fa2d18$var$NODE_TYPE.processingInstruction) return true;
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $148f163621fa2d18$var$NODE_TYPE.comment && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$COMMENT_MARKUP_PROBE, currentNode.data)) return true;
        return false;
    };
    /**
   * Handle a node whose tag is forbidden or not allowlisted: keep
   * allowed custom elements (false return exits _sanitizeElements
   * early - the namespace and fallback-tag removal checks are
   * intentionally skipped for kept custom elements), else hoist
   * content per KEEP_CONTENT and remove.
   *
   * A kept custom element is the ONLY case in which this function
   * returns false, so the caller uses that return value to run the
   * afterSanitizeElements hook on the kept element and keep the
   * element-hook lifecycle consistent with normal allowlisted
   * elements (GHSA-c2j3-45gr-mqc4).
   *
   * @param currentNode the disallowed node
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node was removed, false if kept
   */ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName) {
        /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $148f163621fa2d18$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements.
         Use the cached prototype getters exclusively — the previous code
         had `|| currentNode.parentNode` / `|| currentNode.childNodes`
         fallbacks, but the cached getters always return the canonical
         value (or null for a real parent-less node), so the fallback
         path was dead in safe cases and a clobbering surface in unsafe
         ones. Falsy cached results stay falsy; the `if (childNodes &&
         parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            const parentNode = getParentNode(currentNode);
            const childNodes = getChildNodes(currentNode);
            if (childNodes && parentNode) {
                const childCount = childNodes.length;
                /* In-place: hoist the *original* children so the iterator visits
             and sanitises them through the same allowlist pass as every other
             node. The caller built the tree in the live document, so the
             originals carry already-queued resource events (`<img onerror>`,
             `<video>`/`<audio>` error, lazy/`onload`, …); cloning would leave
             those originals detached but still armed, firing in page scope
             while the returned tree looked clean. Moving is safe in-place: the
             root is pre-validated as an allowed tag and so is never the node
             being removed, which keeps `parentNode` inside the iterator root
             and the relocated child inside the serialised tree.
                      Otherwise (string / DOM-copy paths): clone. The iterator is rooted
             at — and the result serialised from — `body`, so a restrictive
             ALLOWED_TAGS that removes `body` itself must leave its content in
             place, which only cloning does; and those paths parse into an
             inert document, so their discarded originals never had a queued
             event to neutralise.
                      `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
             valid whether we move (drops the trailing entry) or clone (leaves
             the list intact). */ for(let i = childCount - 1; i >= 0; --i){
                    const hoisted = IN_PLACE ? childNodes[i] : cloneNode(childNodes[i], true);
                    parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                }
            }
        }
        _forceRemove(currentNode);
        return true;
    };
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ // eslint-disable-next-line complexity
    const _sanitizeElements = function _sanitizeElements(currentNode, root) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* A hook may have detached the node — treat it as removed (see the
       detached-node comment after the uponSanitizeElement hook below). */ if (currentNode !== root && getParentNode(currentNode) === null) return true;
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(getNodeName ? getNodeName(currentNode) : currentNode.nodeName);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* A hook may have detached the node from the tree — a long-standing
       user pattern (issue #469; draw.io-style foreignObject filtering).
       Per the cached, unclobberable parentNode getter the node is
       genuinely out of the tree, so it can reach neither the serialized
       output nor an IN_PLACE live tree; treat it as removed and stop
       processing it. Without this guard, the unsafe-node / namespace
       checks below would call _forceRemove on a parentless node and hit
       the REPORT-3 fail-closed throw — which exists for nodes DOMPurify
       wants gone but *cannot* detach (clobbered / parentless roots), the
       opposite of a node that is already safely gone. The walk root is
       exempt: a detached IN_PLACE root is legitimate input and must still
       be fully sanitized, and a kill-decision on it must keep hitting the
       REPORT-3 throw. Nodes detached by hooks are the hook's
       responsibility: they are not recorded in DOMPurify.removed and are
       not neutralized by the post-walk IN_PLACE pass. */ if (currentNode !== root && getParentNode(currentNode) === null) return true;
        /* Remove mXSS vectors, processing instructions and risky comments */ if (_isUnsafeNode(currentNode, tagName)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            const removed = _sanitizeDisallowedNode(currentNode, tagName);
            /* A false return means the node is a custom element kept via
         CUSTOM_ELEMENT_HANDLING - the only keep path through
         _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
         element-hook lifecycle matches normal allowlisted elements: a
         security policy applied in this hook (e.g. stripping an attribute
         from every surviving element) must not silently skip kept custom
         elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
         tail below - the hook runs, then the walker's subsequent
         _sanitizeAttributes pass sanitizes the element's attributes. The
         deliberately skipped namespace and fallback-tag removal checks stay
         skipped; they are removal decisions, not the hook contract. */ if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return removed;
        }
        /* Check whether element has a valid namespace.
       Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
       nodeType getter rather than `instanceof Element`, which is realm-
       bound and short-circuits to false for any node minted in a different
       realm — letting a foreign-realm element with a forbidden namespace
       slip past the namespace check entirely. */ const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
        if (nt === $148f163621fa2d18$var$NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $148f163621fa2d18$var$NODE_TYPE.text) {
            /* Get the element's text content */ const content = _stripTemplateExpressions(currentNode.textContent);
            if (currentNode.textContent !== content) {
                $148f163621fa2d18$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
        /* Reject declarative-partial-updates patch-linkage attributes
       (https://github.com/WICG/declarative-partial-updates).
            Empirical note (Chrome 150, verified — see
       test/declarative-patch-probe-v3.html): expansion is NOT applied after
       sanitization. For the string path it fires during sanitize()'s own
       parse, so the walk sees and sanitizes the fully materialized expanded
       tree — teleports into MathML/SVG integration points included; a
       weaponized `<template for>`->`<img onerror>` comes back with the handler
       stripped. For the IN_PLACE path it fires on connection, before the walk.
       Either way DOMPurify is NOT blind to the patch.
            This removal is therefore defense-in-depth rather than the sole barrier:
       it prevents live linkage from surviving into the OUTPUT and re-expanding
       in the caller's context, and keeps behaviour deterministic if a future
       engine defers expansion. `for` is legitimate only on <label>/<output>;
       anywhere else (notably <template for>) it links the element to a patch
       target and teleports or removes an arbitrary DOM range by id/marker name.
       `patchsrc` fetches remote markup and is treated as a script-loading
       mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
       other structural-threat checks and stays overridable, consistent with
       the rest of the codebase. PI range markers are already removed by
       _isUnsafeNode. */ if (SAFE_FOR_XML && lcName === 'patchsrc') return false;
        if (SAFE_FOR_XML && lcName === 'for' && lcTag !== 'label' && lcTag !== 'output') return false;
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && $148f163621fa2d18$var$regExpTest(DATA_ATTR$1, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $148f163621fa2d18$var$regExpTest(ARIA_ATTR$1, lcName)) ;
        else if (!nameIsPermitted) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $148f163621fa2d18$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $148f163621fa2d18$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $148f163621fa2d18$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($148f163621fa2d18$var$regExpTest(IS_ALLOWED_URI$1, $148f163621fa2d18$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $148f163621fa2d18$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$148f163621fa2d18$var$regExpTest(IS_SCRIPT_OR_DATA$1, $148f163621fa2d18$var$stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
        else if (value) return false;
        return true;
    };
    /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = $148f163621fa2d18$var$addToSet({}, [
        'annotation-xml',
        'color-profile',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'missing-glyph'
    ]);
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return !RESERVED_CUSTOM_ELEMENT_NAMES[$148f163621fa2d18$var$stringToLowerCase(tagName)] && $148f163621fa2d18$var$regExpTest(CUSTOM_ELEMENT$1, tagName);
    };
    /**
   * Wrap an attribute value in the matching Trusted Types object when
   * the active policy requires it. Namespaced attributes pass through
   * unchanged (no TT support yet, see
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
   *
   * @param lcTag lowercase tag name of the containing element
   * @param lcName lowercase attribute name
   * @param namespaceURI the attribute's namespace, if any
   * @param value the attribute value to wrap
   * @return the value, wrapped when Trusted Types demand it
   */ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
        if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
            case 'TrustedHTML':
                return _createTrustedHTML(value);
            case 'TrustedScriptURL':
                return _createTrustedScriptURL(value);
        }
        return value;
    };
    /**
   * Write a modified attribute value back onto the element. On
   * success, re-probe for clobbering introduced by the new value and
   * remove the element when found; otherwise pop the removal entry
   * recorded by the earlier _removeAttribute (long-standing pairing
   * with the SANITIZE_NAMED_PROPS path - do not "fix" casually). On
   * failure, remove the attribute instead.
   *
   * @param currentNode the element carrying the attribute
   * @param name the attribute name as present on the element
   * @param namespaceURI the attribute's namespace, if any
   * @param value the new attribute value
   */ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
        try {
            if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
            else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
            if (_isClobbered(currentNode)) _forceRemove(currentNode);
            else $148f163621fa2d18$var$arrayPop(DOMPurify.removed);
        } catch (_) {
            _removeAttribute(name, currentNode);
        }
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const attributes = currentNode.attributes;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        const lcTag = transformCaseFunc(currentNode.nodeName);
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $148f163621fa2d18$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && $148f163621fa2d18$var$stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            // Else: already prefixed, leave the attribute alone — the prefix is
            // itself the clobbering protection, and re-applying it is incorrect.
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $148f163621fa2d18$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && $148f163621fa2d18$var$stringMatch(value, 'href')) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Did the hooks force-keep the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$SELF_CLOSING_TAG, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
            /* Is `value` valid for this attribute? */ if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Handle attributes that require Trusted Types */ value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) _setAttributeValue(currentNode, name, namespaceURI, value);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode, fragment);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
         DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
         recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
            /* An element iterated here may itself host an attached
         shadow root. The default NodeIterator does not enter shadow
         trees, so a shadow root nested inside template.content was
         previously reached by no walk at all (the pre-pass at
         _sanitizeAttachedShadowRoots descends via childNodes, which
         doesn't enter template.content; the template-content recursion
         above iterates the content but never inspected shadowRoot).
         Walk it explicitly. The nodeType guard avoids reading
         shadowRoot off text / comment / CDATA / PI nodes that the
         iterator also surfaces. */ const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
            if (shadowNodeType === $148f163621fa2d18$var$NODE_TYPE.element) {
                const innerSr = getShadowRoot(shadowNode);
                if (_isDocumentFragment(innerSr)) {
                    _sanitizeAttachedShadowRoots(innerSr);
                    _sanitizeShadowDOM2(innerSr);
                }
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    /**
   * _sanitizeAttachedShadowRoots
   *
   * Walks `root` and feeds every attached shadow root we encounter into
   * the existing _sanitizeShadowDOM pipeline. The default node iterator
   * does not descend into shadow trees, so nodes inside an attached
   * shadow root would otherwise be skipped entirely.
   *
   * Two real input paths put attached shadow roots in front of us:
   *   1. IN_PLACE on a DOM node that already has shadow roots attached.
   *   2. DOM-node input where importNode(dirty, true) deep-clones the
   *      shadow root because it was created with `clonable: true`.
   *
   * This pass runs once, up front, so the main iteration loop (and the
   * existing _sanitizeShadowDOM template-content recursion) stay
   * untouched — string-input paths are not affected.
   *
   * @param root the subtree root to walk for attached shadow roots
   */ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
        /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
       impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
       built straight into the DOM — the IN_PLACE surface) deeper than the JS
       call-stack budget would otherwise overflow native recursion here and
       throw at the IN_PLACE entry pre-pass, before a single node is
       sanitized, leaving the caller's live tree untouched (fail-open). See
       campaign-3 F4. A heap stack keeps depth off the call stack.
            Each work item is either a node to descend into, or a deferred
       `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
       form preserves the original post-order discipline: a shadow root's
       nested shadow roots are discovered before the outer shadow is
       sanitized (which may remove hosts). Pushes are in reverse of the
       desired processing order (LIFO): template content, then children, then
       the shadow-sanitize, then the shadow walk — so the order matches the
       previous recursion exactly. */ const stack = [
            {
                node: root,
                shadow: null
            }
        ];
        while(stack.length > 0){
            const item = stack.pop();
            /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */ if (item.shadow) {
                _sanitizeShadowDOM2(item.shadow);
                continue;
            }
            const node = item.node;
            const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
            const isElement = nodeType === $148f163621fa2d18$var$NODE_TYPE.element;
            /* (pushed last → processed first) Children, snapshotted in reverse so
         the first child is processed first. Snapshotting matters because a
         hook may detach siblings mid-walk. */ const childNodes = getChildNodes(node);
            if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                node: childNodes[i],
                shadow: null
            });
            /* (pushed before children → processed after them, matching the old
         "template content last" order) When the node is a <template>,
         descend into its content. */ if (isElement) {
                const rootName = getNodeName ? getNodeName(node) : null;
                if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                    const content = node.content;
                    if (_isDocumentFragment(content)) stack.push({
                        node: content,
                        shadow: null
                    });
                }
            }
            /* Shadow root (processed first): walk its subtree, then sanitise it.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
         rather than `instanceof DocumentFragment`, which is realm-bound and
         silently skipped foreign-realm shadow roots (e.g.
         iframe.contentDocument attachShadow). */ if (isElement) {
                const sr = getShadowRoot(node);
                if (_isDocumentFragment(sr)) /* Push the deferred sanitise first so it pops after the shadow
             walk we push next, i.e. nested shadow roots are discovered
             before this one is sanitised. */ stack.push({
                    node: null,
                    shadow: sr
                }, {
                    node: sr,
                    shadow: null
                });
            }
        }
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            dirty = $148f163621fa2d18$var$stringifyValue(dirty);
            if (typeof dirty !== 'string') throw $148f163621fa2d18$var$typeErrorCreate('dirty is not a string, aborting');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (SET_CONFIG) {
            /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
       * not re-derived per call. Restore them from the pristine bindings
       * captured at setConfig() time so a previous call's hook clone (mutated
       * below) does not carry over. */ ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
            ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
        } else _parseConfig(cfg);
        /* Clone the hook-mutable allowlists before the walk whenever an
     * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
     * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
     * a hook that widens them would otherwise mutate the shared set
     * permanently: across later calls and across every element. Cloning per
     * walk keeps documented in-call widening working while scoping it to the
     * call. A single guard for both config paths - the per-call path rebinds
     * the sets in _parseConfig each call, the persistent path restores them
     * from the captured bindings just above - so the two cannot diverge. */ if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = $148f163621fa2d18$var$clone(ALLOWED_TAGS);
        if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = $148f163621fa2d18$var$clone(ALLOWED_ATTR);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Resolve IN_PLACE for this call without mutating persistent config.
       Writing the IN_PLACE closure variable here leaks under setConfig(),
       where _parseConfig is skipped on later calls: a single string call would
       disable in-place mode for every subsequent node call, returning a
       sanitized copy while leaving the caller's node — which in-place callers
       keep using and whose return value they ignore — unsanitized. REPORT-2. */ const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
        if (inPlace) {
            /* Declarative-partial-updates / streaming pre-pass: sever every patch
         linkage across the live tree BEFORE the walk, so no patch can fire
         mid-walk and inject into an already-processed region. Runs first, so
         it also covers the forbidden/clobbered roots that throw below. */ _neutralizePatchLinkage(dirty);
            /* Do some early pre-sanitization to avoid unsafe root nodes.
         Read nodeName through the cached prototype getter — a clobbering
         child named "nodeName" on the form root would otherwise shadow
         the property and let this check skip the root-allowlist
         validation entirely. */ const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
            if (typeof nn === 'string') {
                const tagName = transformCaseFunc(nn);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                    /* Fail closed on a live root: neutralize handlers/children before
             throwing, exactly as the mid-walk abort path does. */ _neutralizeRoot(dirty);
                    throw $148f163621fa2d18$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            }
            /* Pre-flight the root through _isClobbered. The iterator-driven
         removal path can not detach a parent-less root: _forceRemove
         falls through to Element.prototype.remove(), which per spec
         is a no-op on a node with no parent. A clobbered root would
         then survive the main loop with its attributes uninspected,
         because _sanitizeAttributes early-returns on _isClobbered. The
         result would be an attacker-controlled form, complete with any
         event-handler attributes the caller passed in, handed back to
         the application unsanitized. Refuse to sanitize such a root
         the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) {
                /* Fail closed on a live clobbered root before throwing.
           _neutralizeRoot's reads are clobber-safe (cached getters); the
           form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */ _neutralizeRoot(dirty);
                throw $148f163621fa2d18$var$typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
            }
            /* Sanitize attached shadow roots before the main iterator runs.
         The iterator does not descend into shadow trees. Same fail-closed
         barrier as the main walk (campaign-3 F2): a custom-element reaction
         inside a shadow root could abort this pre-pass before the walk runs,
         which would otherwise leave the entire live tree unsanitized. */ try {
                _sanitizeAttachedShadowRoots(dirty);
            } catch (error) {
                _neutralizeRoot(dirty);
                throw error;
            }
        } else if (_isNode(dirty)) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $148f163621fa2d18$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
            /* Clonable shadow roots are deep-cloned by importNode(); sanitize
         them before the main iterator runs, since the iterator does not
         descend into shadow trees. The walk routes every read through a
         cached prototype getter so clobbering descendants on a form root
         cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const walkRoot = inPlace ? dirty : body;
        const nodeIterator = _createNodeIterator(walkRoot);
        /* Now start iterating over the created document.
       The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
       engine/custom-element mutation can detach a node mid-walk so
       `_forceRemove`'s parentless guard throws, aborting the loop. Without the
       barrier the caller's in-place tree would be left half-sanitized with the
       unvisited tail still armed. On any throw we fail closed — strip the
       in-place root bare — then rethrow so the existing throw contract is
       preserved. (String/DOM-copy paths never return the partial body, so the
       propagating throw is already fail-closed there.) */ try {
            while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode, walkRoot);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
            }
        } catch (error) {
            if (inPlace) {
                _neutralizeRoot(dirty);
                /* Nodes _forceRemove'd earlier in the aborted walk are already
           detached from the root, so _neutralizeRoot's subtree pass does not
           reach them. Defuse them too, mirroring the success-path loop below. */ $148f163621fa2d18$var$arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) _neutralizeSubtree(entry.element);
                });
            }
            throw error;
        }
        /* If we sanitized `dirty` in-place, return it. */ if (inPlace) {
            /* Fail-closed completion of the audit-5 F1 fix: every node removed from
         the caller's live tree is detached but may still hold a queued
         resource-event handler that fires in page scope after we return. The
         move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
         non-allow-listed attributes off every other removed subtree (clobber,
         mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
         cancelled before any event can fire. Runs synchronously, pre-return. */ $148f163621fa2d18$var$arrayForEach(DOMPurify.removed, (entry)=>{
                if (entry.element) _neutralizeSubtree(entry.element);
            });
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
            return dirty;
        }
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $148f163621fa2d18$var$regExpTest($148f163621fa2d18$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
        SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
        SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
        SET_CONFIG_ALLOWED_TAGS = null;
        SET_CONFIG_ALLOWED_ATTR = null;
        // Drop any caller-supplied Trusted Types policy so it cannot poison later
        // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
        // never recreated — Trusted Types throws on duplicate names) is restored by
        // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
        trustedTypesPolicy = defaultTrustedTypesPolicy;
        emptyHTML = '';
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        /* Reject unknown entry points. Without this, a non-hook key (e.g.
     * '__proto__') indexes off the prototype chain rather than a real
     * hook array, and arrayPush then writes to Object.prototype. Guard
     * with an own-property check against the known hook names. */ if (!$148f163621fa2d18$var$objectHasOwnProperty(hooks, entryPoint)) return;
        $148f163621fa2d18$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (!$148f163621fa2d18$var$objectHasOwnProperty(hooks, entryPoint)) return undefined;
        if (hookFunction !== undefined) {
            const index = $148f163621fa2d18$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $148f163621fa2d18$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $148f163621fa2d18$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        if (!$148f163621fa2d18$var$objectHasOwnProperty(hooks, entryPoint)) return;
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $148f163621fa2d18$var$_createHooksMap();
    };
    return DOMPurify;
}
var $148f163621fa2d18$var$purify = $148f163621fa2d18$var$createDOMPurify();
module.exports = $148f163621fa2d18$var$purify;

});


parcelRegister("dVoLr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18c15eecb44e6bc7dee9727eae68b36d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a233cedef4055e77$var$_react = $a233cedef4055e77$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a233cedef4055e77$var$_iconNew = $a233cedef4055e77$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a233cedef4055e77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shortcut
 * Usage guidance:
 * Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a233cedef4055e77$var$ShortcutIcon = (props)=>/*#__PURE__*/ $a233cedef4055e77$var$_react.default.createElement($a233cedef4055e77$var$_iconNew.default, Object.assign({
        name: "ShortcutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$a233cedef4055e77$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $a233cedef4055e77$var$_default = module.exports.default = $a233cedef4055e77$var$ShortcutIcon;

});

parcelRegister("a1I28", function(module, exports) {
$parcel$export(module.exports, "addSourceToUrl", () => $eef96ee28e0b3cf8$export$cae9c63f58ebbe6f);
$parcel$export(module.exports, "is3pOrExternalSource", () => $eef96ee28e0b3cf8$export$d1565b01286b6c95);

var $k2M4v = parcelRequire("k2M4v");

var $6rayQ = parcelRequire("6rayQ");
const $eef96ee28e0b3cf8$export$cae9c63f58ebbe6f = (url, source, shouldReturnUrlWithoutSource = false)=>{
    if (shouldReturnUrlWithoutSource || !(0, $k2M4v.default).checkGate('jsm_kb_source_value_in_query_param')) return url;
    return (0, $6rayQ.addParamsToUrl)(url, {
        source: source
    });
};
const $eef96ee28e0b3cf8$export$d1565b01286b6c95 = (sourceSystem)=>{
    return sourceSystem === 'EXTERNAL' || sourceSystem === 'SHAREPOINT' || sourceSystem === 'GOOGLE_DRIVE';
};

});

parcelRegister("3GHVc", function(module, exports) {
$parcel$export(module.exports, "typeMap", () => $b74f6b892020466f$export$ca0f3793b4450a5d);
$parcel$export(module.exports, "isExternalResource", () => $b74f6b892020466f$export$fe3f86d8e6082cf);
$parcel$export(module.exports, "isThirdPartyArticle", () => $b74f6b892020466f$export$97275da1bf1c8425);
$parcel$export(module.exports, "urlRefsAndTarget", () => $b74f6b892020466f$export$a54b3eec1418fa47);

var $diqlM = parcelRequire("diqlM");
const $b74f6b892020466f$export$ca0f3793b4450a5d = {
    REQUEST_FORM: 'REQUEST_FORM',
    ARTICLE: 'ARTICLE',
    EXTERNAL_RESOURCE: 'ati:cloud:jira-servicedesk:external-resource'
};
const $b74f6b892020466f$export$fe3f86d8e6082cf = (entityKey)=>{
    return entityKey === $b74f6b892020466f$export$ca0f3793b4450a5d.EXTERNAL_RESOURCE;
};
const $b74f6b892020466f$export$97275da1bf1c8425 = (sourceType)=>{
    return !!sourceType && [
        'GOOGLE_DRIVE',
        'SHAREPOINT',
        'EXTERNAL_RESOURCES'
    ].includes(sourceType);
};
const $b74f6b892020466f$var$getUrlForRouter = (displayLink)=>{
    return displayLink.startsWith('/') ? displayLink.replace((0, $diqlM.getRelativeBasePath)(), '') : displayLink.replace(`${location.origin}${(0, $diqlM.getRelativeBasePath)()}`, '');
};
const $b74f6b892020466f$export$a54b3eec1418fa47 = ({ displayLink: displayLink, isAnExternalResource: isAnExternalResource })=>isAnExternalResource ? {
        href: displayLink,
        target: '_blank'
    } : {
        to: $b74f6b892020466f$var$getUrlForRouter(displayLink),
        target: '_self'
    };

});

parcelRegister("jolUD", function(module, exports) {
$parcel$export(module.exports, "ArticleMetadata", () => (parcelRequire("3kiUl")).default);

var $3kiUl = parcelRequire("3kiUl");

});
parcelRegister("3kiUl", function(module, exports) {
$parcel$export(module.exports, "default", () => $40b21a03e9655c6a$export$2e2bcd8739ae039);

var $3XBvA = parcelRequire("3XBvA");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $3BiGe = parcelRequire("3BiGe");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("hCjrZ");
var $iu172 = parcelRequire("iu172");

var $5a4EU = parcelRequire("5a4EU");

var $7uWFh = parcelRequire("7uWFh");
const $40b21a03e9655c6a$export$9f18a4080cf334b5 = ({ isLoggedIn: isLoggedIn, result: result })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useFragment)((0, $3XBvA.default), result);
    const { ari: ari, displayLink: displayLink, sourceSystem: sourceSystem, containerName: containerName } = data;
    const isExternal = sourceSystem === 'EXTERNAL';
    const { data: { source: source } } = (0, $iu172.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const confluencePageText = containerName ? formatMessage((0, $7uWFh.default).confluencePage, {
        value: containerName
    }) : '';
    const showSeparator = source && containerName;
    const externalResourceParts = [
        source || '',
        showSeparator ? "\u2022" : '',
        containerName || ''
    ].filter(Boolean);
    const externalResourceText = externalResourceParts.join(' ');
    const metaData = !isExternal ? confluencePageText : externalResourceText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        key: ari
    }, metaData);
};
const $40b21a03e9655c6a$var$ConnectedArticleMetadata = (0, $6umft.default)((state)=>{
    return {
        isLoggedIn: (0, $3BiGe.isLoggedIn)(state)
    };
})($40b21a03e9655c6a$export$9f18a4080cf334b5);
var $40b21a03e9655c6a$export$2e2bcd8739ae039 = $40b21a03e9655c6a$var$ConnectedArticleMetadata;

});
parcelRegister("3XBvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb0edcaca355e1c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed87ad72d807d002234b458a7dcc7707>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cb0edcaca355e1c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleMetadataFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "kind": "ScalarField",
            "name": "containerName"
        },
        {
            "kind": "ScalarField",
            "name": "sourceSystem"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$cb0edcaca355e1c4$var$node.hash = "4c3cfc8aeff9894de53a0b5480f56516";
var $cb0edcaca355e1c4$export$2e2bcd8739ae039 = $cb0edcaca355e1c4$var$node;

});

parcelRegister("hCjrZ", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => (parcelRequire("iu172")).useExternalLink);

var $iu172 = parcelRequire("iu172");

});
parcelRegister("iu172", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => $87def185306bb5b7$export$408a40e8acea91be);

var $fc4bM = parcelRequire("fc4bM");

var $hpKQ5 = parcelRequire("hpKQ5");

var $khKHK = parcelRequire("khKHK");

var $aeF17 = parcelRequire("aeF17");
const $87def185306bb5b7$export$2c4a28c399ed5beb = (urls)=>{
    return (0, $khKHK.fetchObjectsFromUrls)(urls).toPromise().then((response)=>{
        return urls.reduce((ref, url, index)=>({
                ...ref,
                [url]: response[index]
            }), {});
    });
};
const $87def185306bb5b7$var$batchedFetchIcon = (0, $aeF17.default)($87def185306bb5b7$export$2c4a28c399ed5beb, 0);
const $87def185306bb5b7$export$7666a60147fbe378 = {};
const $87def185306bb5b7$var$addExternalLinkToCache = (key, value)=>{
    $87def185306bb5b7$export$7666a60147fbe378[key] = value;
};
function $87def185306bb5b7$export$408a40e8acea91be({ isLoggedIn: isLoggedIn, link: url }) {
    const initialState = (0, $fc4bM.useMemo)(()=>({
            name: null,
            iconUrl: null,
            source: null
        }), []);
    const [data, setData] = (0, $fc4bM.useState)(initialState);
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(true);
    const markDataLoaded = (key, value)=>{
        setIsLoading(false);
        setData(value);
        $87def185306bb5b7$var$addExternalLinkToCache(key, value);
    };
    (0, $fc4bM.useEffect)(()=>{
        let href = url;
        if (!isLoggedIn) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Try to parse the url and extract out the href
     * if it fails return null as the icon url
     */ try {
            href = new URL(url).href;
        } catch (error) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Origin is null for other supported url forms like `tel:` and `mail:`
     * return null so that ui can fallback to default icons
     */ if (new URL(url).origin === 'null') {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * check is there is already entry in cache
     * if yes, return the icon url
     * else, make a call to object resolver service
     */ if (Object.keys($87def185306bb5b7$export$7666a60147fbe378).includes(href)) {
            setData($87def185306bb5b7$export$7666a60147fbe378[href]);
            setIsLoading(false);
        } else $87def185306bb5b7$var$batchedFetchIcon(href).then((response)=>{
            var _response$href, _response$href2, _response$href3;
            const source = (_response$href = response[href]) === null || _response$href === void 0 || (_response$href = _response$href.body.data) === null || _response$href === void 0 || (_response$href = _response$href.generator) === null || _response$href === void 0 ? void 0 : _response$href.name;
            /**
         * ORS returns old Confluence icon
         * Until the icon is updated in ORS we should use the new icon from assets
         */ const iconUrl = source === 'Confluence' ? (0, (/*@__PURE__*/$parcel$interopDefault($hpKQ5))) : (_response$href2 = response[href]) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.body) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.data) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.generator) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.icon) === null || _response$href2 === void 0 ? void 0 : _response$href2.url;
            markDataLoaded(href, {
                iconUrl: iconUrl,
                source: source,
                name: (_response$href3 = response[href]) === null || _response$href3 === void 0 || (_response$href3 = _response$href3.body.data) === null || _response$href3 === void 0 ? void 0 : _response$href3.name
            });
        }).catch(()=>{
            return null;
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        initialState,
        isLoggedIn,
        url
    ]);
    return {
        data: data,
        isLoading: isLoading
    };
}

});
parcelRegister("hpKQ5", function(module, exports) {
module.exports = new URL("../images/confluence-icon.3f9a0ccd.svg", import.meta.url).toString();

});

parcelRegister("khKHK", function(module, exports) {
$parcel$export(module.exports, "fetchObjectsFromUrls", () => $bcddcde6ebccaa4c$export$bf4b9b9bdb5d08c9);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");
const $bcddcde6ebccaa4c$export$bf4b9b9bdb5d08c9 = (urls)=>{
    return (0, $bTjsX.post)('/gateway/api/object-resolver/resolve/batch', urls.map((url)=>({
            resourceUrl: url
        })), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $4Q7yw.Observable).throw(e));
};

});



parcelRegister("7uWFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0cfca0e90779628$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $c0cfca0e90779628$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Label showing a Confluence page result belongs to a specific space ({value})',
        id: 'cv.search.articles.metadata'
    }
});

});



parcelRegister("eDb29", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2a25b52f088b426$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $b2a25b52f088b426$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    showMore: {
        defaultMessage: 'Show more',
        description: 'Text on show more results button',
        id: 'cv.search.articles.show-more'
    },
    showMoreIcon: {
        defaultMessage: 'Show more icon',
        description: 'Text for label on show more results icon',
        id: 'cv.search.articles.show-more-icon'
    },
    shortcutIcon: {
        defaultMessage: 'Shortcut icon',
        description: 'Text for label on shortcut icon',
        id: 'cv.search.articles.shortcut-icon'
    },
    articles: {
        defaultMessage: 'Self-help resources',
        description: 'Text for section resource type in search results',
        id: 'cv.search.articles.articles'
    }
});

});

parcelRegister("1KMlx", function(module, exports) {
$parcel$export(module.exports, "ResourceIcon", () => (parcelRequire("4VcZ1")).default);

var $4VcZ1 = parcelRequire("4VcZ1");

});
parcelRegister("4VcZ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dfec23eeb181902$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $jtp0M = parcelRequire("jtp0M");

var $3BiGe = parcelRequire("3BiGe");

var $bsIOe = parcelRequire("bsIOe");
parcelRequire("hCjrZ");
var $iu172 = parcelRequire("iu172");

var $1AiIz = parcelRequire("1AiIz");

var $3UAb3 = parcelRequire("3UAb3");

var $dgs90 = parcelRequire("dgs90");

var $dS86g = parcelRequire("dS86g");

var $78Y6r = parcelRequire("78Y6r");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $h46Vs = parcelRequire("h46Vs");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $fxJE6 = parcelRequire("fxJE6");
const $6dfec23eeb181902$export$99eb8fbf40c7d2bc = ({ entityType: entityType, displayLink: displayLink, isLoggedIn: isLoggedIn, isExternal: isExternal, themeColor: themeColor, iconUrl: iconUrl, sourceSystem: sourceSystem, variant: variant = 'default' })=>{
    const { data: { iconUrl: externalResourceIconUrl }, isLoading: isIconLoading } = (0, $iu172.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const isValidResourceIconUrl = !!iconUrl;
    const isValidExternalResourceIconUrl = !!externalResourceIconUrl && externalResourceIconUrl !== '';
    const getDefaultIcon = (0, $fc4bM.useMemo)(()=>{
        switch(entityType){
            case 'ARTICLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                    label: "",
                    testId: "article-icon",
                    spacing: "spacious"
                });
            case 'REQUEST_FORM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dgs90))), {
                    label: "",
                    testId: "request-form-icon",
                    spacing: "spacious"
                });
            case 'PORTAL':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($78Y6r))), {
                    label: "",
                    testId: "portal-icon",
                    spacing: "spacious"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))), {
                    label: "",
                    testId: "question-icon",
                    spacing: "spacious"
                });
        }
    }, [
        entityType
    ]);
    const getThirdPartyIcon = (0, $fc4bM.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fxJE6.IntegrationProviderMeta).sharepoint.icon, {
            label: "sharepoint"
        });
        if (sourceSystem === 'GOOGLE_DRIVE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fxJE6.IntegrationProviderMeta).googleDrive.icon, {
            label: "googledrive"
        });
        return null;
    }, [
        sourceSystem
    ]);
    const getThirdPartyIconComponent = (0, $fc4bM.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return (0, $fxJE6.IntegrationProviderMeta).sharepoint.icon;
        if (sourceSystem === 'GOOGLE_DRIVE') return (0, $fxJE6.IntegrationProviderMeta).googleDrive.icon;
        return null;
    }, [
        sourceSystem
    ]);
    const shouldUseArticleIconTile = variant === 'tile' && entityType === 'ARTICLE' && !isExternal && !isIconLoading && !isValidResourceIconUrl;
    const getExternalResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bsIOe.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidExternalResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "img",
            xcss: $6dfec23eeb181902$var$imgStyles,
            testId: "external-resource-icon",
            src: externalResourceIconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    const getResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bsIOe.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            as: "img",
            xcss: $6dfec23eeb181902$var$imgStyles,
            testId: "resource-icon",
            src: iconUrl,
            alt: ""
        });
        return getThirdPartyIcon ?? getDefaultIcon;
    };
    if (shouldUseArticleIconTile) {
        const ThirdPartyIconInTile = ({ label: label })=>{
            if (getThirdPartyIcon) return getThirdPartyIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                label: label
            });
        };
        const IconComponent = getThirdPartyIconComponent ? ThirdPartyIconInTile : (0, (/*@__PURE__*/$parcel$interopDefault($dS86g)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $6dfec23eeb181902$var$iconTileStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1AiIz.default), {
            appearance: "blue",
            icon: IconComponent,
            label: "Article icon",
            size: "medium",
            testId: "article-icon-tile"
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $6dfec23eeb181902$var$imgStyles,
        style: {
            color: (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $h46Vs.generateThemeBranding)(themeColor).color900 : themeColor
        }
    }, isExternal ? getExternalResourceIcon() : getResourceIcon());
};
const $6dfec23eeb181902$var$ConnectedResourceIcon = (0, $6umft.default)((state)=>{
    return {
        isLoggedIn: (0, $3BiGe.isLoggedIn)(state),
        themeColor: (0, $jtp0M.getThemeColor)(state)
    };
})($6dfec23eeb181902$export$99eb8fbf40c7d2bc);
var $6dfec23eeb181902$export$2e2bcd8739ae039 = $6dfec23eeb181902$var$ConnectedResourceIcon;
const $6dfec23eeb181902$var$imgStyles = (0, $kig2V.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
});
const $6dfec23eeb181902$var$iconTileStyles = (0, $kig2V.xcss)({
    width: 'size.300',
    height: 'size.300',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("bsIOe", function(module, exports) {
$parcel$export(module.exports, "SkeletonItem", () => $93040e7d0fd71a5f$export$fbc0ea7debdb77e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
const $93040e7d0fd71a5f$var$shimmer = /*#__PURE__*/ (0, $luz1X.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
});
const $93040e7d0fd71a5f$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1p3akxf-0"
})`animation-duration:1.2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$93040e7d0fd71a5f$var$shimmer};animation-timing-function:linear;background-color:${"var(--ds-skeleton, #F4F5F7)"};background-image:linear-gradient( to right,${"var(--ds-skeleton, #F4F5F7)"} 10%,${"var(--ds-skeleton-subtle, #EBECF0)"} 20%,${"var(--ds-skeleton, #F4F5F7)"} 30% );background-repeat:no-repeat;border-radius:${({ isCircle: isCircle })=>isCircle ? '50%' : "var(--ds-radius-small, 4px)"};height:${({ height: height })=>height};width:${({ width: width })=>width};`;

});

parcelRegister("1AiIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $dab6c1881cec3fe8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $A0kxW = parcelRequire("A0kxW");
// Icon color mapping for Tile-based icons
const $dab6c1881cec3fe8$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
const $dab6c1881cec3fe8$var$iconWrapperStyles = {
    root: "_vwz4idpf"
};
// Background color mapping for Tile component
const $dab6c1881cec3fe8$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $dab6c1881cec3fe8$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'medium', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $A0kxW.default), {
        size: size,
        backgroundColor: $dab6c1881cec3fe8$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            className: (0, $2R2iS.default)([
                $dab6c1881cec3fe8$var$iconColorMap[appearance],
                $dab6c1881cec3fe8$var$iconWrapperStyles.root
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: "",
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("A0kxW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3478002b614d2ab8$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

// Pixel sizes per tile size, used for retina validation
const $3478002b614d2ab8$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $3478002b614d2ab8$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq _1jpx1dfr"
};
const $3478002b614d2ab8$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $3478002b614d2ab8$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $3478002b614d2ab8$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $3478002b614d2ab8$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $fc4bM.useRef)(null);
    // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $fc4bM.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $2R2iS.default)([
            $3478002b614d2ab8$var$styles.root,
            $3478002b614d2ab8$var$sizeMap[size],
            isInset ? $3478002b614d2ab8$var$styles.inset : $3478002b614d2ab8$var$styles.nonInset,
            isInset && $3478002b614d2ab8$var$insetSizeMap[size],
            $3478002b614d2ab8$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $3478002b614d2ab8$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("dgs90", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::403d648a4ec6dc7540968c496b0b831a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a8299da575e4558$var$_react = $9a8299da575e4558$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9a8299da575e4558$var$_iconNew = $9a8299da575e4558$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9a8299da575e4558$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a8299da575e4558$var$DashboardIcon = (props)=>/*#__PURE__*/ $9a8299da575e4558$var$_react.default.createElement($9a8299da575e4558$var$_iconNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$9a8299da575e4558$var$DashboardIcon.displayName = 'DashboardIcon';
var $9a8299da575e4558$var$_default = module.exports.default = $9a8299da575e4558$var$DashboardIcon;

});

parcelRegister("dS86g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119715e64d85c4bab14810bd2a82a088>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a19699ff70c0070c$var$_react = $a19699ff70c0070c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a19699ff70c0070c$var$_iconNew = $a19699ff70c0070c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a19699ff70c0070c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/page
 * Usage guidance:
 * Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a19699ff70c0070c$var$PageIcon = (props)=>/*#__PURE__*/ $a19699ff70c0070c$var$_react.default.createElement($a19699ff70c0070c$var$_iconNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$a19699ff70c0070c$var$PageIcon.displayName = 'PageIcon';
var $a19699ff70c0070c$var$_default = module.exports.default = $a19699ff70c0070c$var$PageIcon;

});

parcelRegister("78Y6r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdf3bc92d1fef1a18b299001cd420653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5337e6f1ddc6d899$var$_react = $5337e6f1ddc6d899$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5337e6f1ddc6d899$var$_iconNew = $5337e6f1ddc6d899$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5337e6f1ddc6d899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/screen
 * Usage guidance:
 * Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5337e6f1ddc6d899$var$ScreenIcon = (props)=>/*#__PURE__*/ $5337e6f1ddc6d899$var$_react.default.createElement($5337e6f1ddc6d899$var$_iconNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5337e6f1ddc6d899$var$ScreenIcon.displayName = 'ScreenIcon';
var $5337e6f1ddc6d899$var$_default = module.exports.default = $5337e6f1ddc6d899$var$ScreenIcon;

});

parcelRegister("fxJE6", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyConnectionStatusEndpoint", () => $dd866ad10ff392a3$export$b6b331ef111f4609);
$parcel$export(module.exports, "IntegrationProviderMeta", () => $dd866ad10ff392a3$export$3b0a1c80b07fd43a);

var $kxTmS = parcelRequire("kxTmS");

var $672Ue = parcelRequire("672Ue");
const $dd866ad10ff392a3$export$b6b331ef111f4609 = ()=>`/gateway/api/third-party-configuration/connected-data-sources`;
const $dd866ad10ff392a3$export$3b0a1c80b07fd43a = {
    sharepoint: {
        name: 'SharePoint',
        icon: (0, $672Ue.default),
        integrationId: 'ari:cloud:platform::integration/microsoft',
        type: 'sharepoint-connector'
    },
    googleDrive: {
        name: 'Google Drive',
        icon: (0, $kxTmS.default),
        integrationId: 'ari:cloud:platform::integration/google',
        type: 'google-drive-connector'
    }
};

});
parcelRegister("kxTmS", function(module, exports) {
$parcel$export(module.exports, "default", () => $24d279cbfcbfe278$export$2e2bcd8739ae039);
/* google-drive-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $24d279cbfcbfe278$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $24d279cbfcbfe278$var$GoogleDriveIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $2R2iS.default)([
            size && $24d279cbfcbfe278$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
        fill: "#3777E3"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
        fill: "#FFCF63"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
        fill: "#11A861"
    }));
/**
 * __GoogleDriveIcon__
 */ const $24d279cbfcbfe278$var$GoogleDriveIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $fc4bM.createElement($24d279cbfcbfe278$var$GoogleDriveIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $24d279cbfcbfe278$export$2e2bcd8739ae039 = $24d279cbfcbfe278$var$GoogleDriveIcon;

});

parcelRegister("672Ue", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd8d011a8a553ebc$export$2e2bcd8739ae039);
/* sharepoint-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $bd8d011a8a553ebc$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $bd8d011a8a553ebc$var$SharePointIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $2R2iS.default)([
            size && $bd8d011a8a553ebc$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        clipPath: "url(#clip0_271_181641)"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        clipPath: "url(#clip1_271_181641)"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        opacity: "0.1",
        d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
        fill: "black"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        opacity: "0.2",
        d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        opacity: "0.2",
        d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        opacity: "0.2",
        d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
        fill: "white"
    }))), /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "clip0_271_181641"
    }, /*#__PURE__*/ $fc4bM.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    })), /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "clip1_271_181641"
    }, /*#__PURE__*/ $fc4bM.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
/**
 * __SharePointIcon__
 */ const $bd8d011a8a553ebc$var$SharePointIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $fc4bM.createElement($bd8d011a8a553ebc$var$SharePointIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $bd8d011a8a553ebc$export$2e2bcd8739ae039 = $bd8d011a8a553ebc$var$SharePointIcon;

});








parcelRegister("hnrtx", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => (parcelRequire("iW0i8")).ArticleResultsLoader);
$parcel$export(module.exports, "SidePanelResultsLoader", () => (parcelRequire("iW0i8")).SidePanelResultsLoader);
$parcel$export(module.exports, "NewSearchResultsLoader", () => (parcelRequire("iW0i8")).SearchResultsLoader);

var $iW0i8 = parcelRequire("iW0i8");

});
parcelRegister("iW0i8", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => $f303e86219647e1d$export$777dd415ac1ad4be);
$parcel$export(module.exports, "SidePanelResultsLoader", () => $f303e86219647e1d$export$9575789db02c1cec);
$parcel$export(module.exports, "SearchResultsLoader", () => $f303e86219647e1d$export$628e0e0af087a588);

var $fc4bM = parcelRequire("fc4bM");

var $8PITw = parcelRequire("8PITw");

var $5a4EU = parcelRequire("5a4EU");

var $jVMDF = parcelRequire("jVMDF");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $1zYKE = parcelRequire("1zYKE");

var $lgMZ2 = parcelRequire("lgMZ2");

var $4T8rw = parcelRequire("4T8rw");
parcelRequire("4ZWZy");
var $cd2Ru = parcelRequire("cd2Ru");
const $f303e86219647e1d$export$777dd415ac1ad4be = ()=>{
    const articleItemLoader = (0, $fc4bM.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $f303e86219647e1d$var$headingAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const resourceIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $f303e86219647e1d$var$iconAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $f303e86219647e1d$var$loadingIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
                height: 24,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const metadataContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: [
                    $f303e86219647e1d$var$subheadingLeftAreaStyles,
                    $f303e86219647e1d$var$subheadingStyles
                ],
                testId: "article-metadata-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $f303e86219647e1d$var$metadataLoadingStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const shortcutIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: [
                    $f303e86219647e1d$var$headerRightAreaStylesVisible
                ],
                testId: "shortcut-icon-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const descriptionContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $f303e86219647e1d$var$bodyAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            role: "listitem",
            xcss: $f303e86219647e1d$var$containerStyles,
            testId: "article-item-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body'
            ],
            templateColumns: "auto 1fr auto"
        }, resourceIconContainer(), linkContainer(), metadataContainer(), shortcutIconContainer(), descriptionContainer())));
    }, []);
    const articlesListLoader = (0, $fc4bM.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            role: "list",
            xcss: $f303e86219647e1d$var$containerStyles,
            testId: "articles-list-loader"
        }, articleItemLoader, articleItemLoader, articleItemLoader, articleItemLoader);
    }, [
        articleItemLoader
    ]);
    const sectionHeadingLoader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, sectionHeadingLoader(), articlesListLoader, articlesListLoader);
};
const $f303e86219647e1d$export$9575789db02c1cec = ()=>{
    const resourceIconContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $f303e86219647e1d$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $f303e86219647e1d$var$sidePanelIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            height: 24,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    const descriptionContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $f303e86219647e1d$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $f303e86219647e1d$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))));
    };
    const sidePaneItemLoader = (0, $fc4bM.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                xcss: $f303e86219647e1d$var$sidePaneLinkContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
                xcss: $f303e86219647e1d$var$sidePaneLinkStyles,
                space: "space.100"
            }, resourceIconContainer(), descriptionContainer()));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $f303e86219647e1d$var$sidePanelItemStyles
        }, linkContainer());
    }, []);
    const sidePanelLoader = (0, $fc4bM.useMemo)(()=>{
        const resultTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $f303e86219647e1d$var$sidePanelStyles
        }, resultTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.ResultList), {
            role: "list"
        }, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader));
    }, [
        sidePaneItemLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        testId: "side-panel-results-loader",
        xcss: $f303e86219647e1d$var$sidePanelContainerStyles
    }, sidePanelLoader);
};
const $f303e86219647e1d$export$628e0e0af087a588 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $f303e86219647e1d$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f303e86219647e1d$export$777dd415ac1ad4be, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f303e86219647e1d$export$9575789db02c1cec, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f303e86219647e1d$export$9575789db02c1cec, null)));
};
const $f303e86219647e1d$var$containerStyles = (0, $kig2V.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $f303e86219647e1d$var$iconAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $f303e86219647e1d$var$headingAreaStyles = (0, $kig2V.xcss)({
    width: '200px',
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.large'
});
const $f303e86219647e1d$var$subheadingStyles = (0, $kig2V.xcss)({
    width: '350px',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $f303e86219647e1d$var$subheadingLeftAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $f303e86219647e1d$var$headerRightAreaStylesVisible = (0, $kig2V.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $f303e86219647e1d$var$responsiveStyles = (0, $kig2V.xcss)({
    [(0, $1zYKE.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        width: '100%'
    },
    [(0, $1zYKE.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});
const $f303e86219647e1d$var$bodyAreaStyles = (0, $kig2V.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $f303e86219647e1d$var$loadingIconStyles = (0, $kig2V.xcss)({
    width: '100%'
});
const $f303e86219647e1d$var$metadataLoadingStyles = (0, $kig2V.xcss)({
    width: '100%'
});
const $f303e86219647e1d$var$sidePanelIconStyles = (0, $kig2V.xcss)({
    width: 'size.200'
});
const $f303e86219647e1d$var$sidePanelDescriptionStyles = (0, $kig2V.xcss)({
    width: '100%'
});
const $f303e86219647e1d$var$sidePaneLinkContainerStyles = (0, $kig2V.xcss)({
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $f303e86219647e1d$var$sidePaneLinkStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $f303e86219647e1d$var$sidePanelItemStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $f303e86219647e1d$var$sidePanelContainerStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    minWidth: '320px',
    width: '100%',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100'
});
const $f303e86219647e1d$var$sidePanelStyles = (0, $kig2V.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});

});


parcelRegister("btDGN", function(module, exports) {
$parcel$export(module.exports, "Portals", () => (parcelRequire("atgtc")).default);

var $atgtc = parcelRequire("atgtc");

});
parcelRegister("atgtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $43a37d3d3b379916$export$2e2bcd8739ae039);

var $6BVlr = parcelRequire("6BVlr");

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $azARG = parcelRequire("azARG");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $1zYKE = parcelRequire("1zYKE");

var $kig2V = parcelRequire("kig2V");

var $uYmrU = parcelRequire("uYmrU");
parcelRequire("4ZWZy");
var $eFtAu = parcelRequire("eFtAu");
var $cd2Ru = parcelRequire("cd2Ru");
var $b52IZ = parcelRequire("b52IZ");

var $89aYe = parcelRequire("89aYe");
parcelRequire("9J9dZ");
var $h6t70 = parcelRequire("h6t70");

var $4mBUe = parcelRequire("4mBUe");
const $43a37d3d3b379916$export$7083bd6220bb1bc7 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const cloudId = (0, $6LH8a.getCloudId)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $6BVlr.default), {
        cloudId: cloudId,
        queryTerm: term,
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        limit: (0, $eFtAu.PORTALS_RESULT_LIMIT)
    });
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    const portals = ((_data$helpObjectStore = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStorePortalSearchResults' ? data.helpObjectStore_searchPortals.results : [];
    const showSection = portals.length > 0;
    (0, $fc4bM.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStorePortalSearchResults') {
            const externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchPortals.results.forEach((portal)=>{
                if (portal.metadata.searchStrategy === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $b52IZ.sendSearchOperationalAnalyticEvents)({
                action: 'portalSearchSucceeded',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $b52IZ.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'portal',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchPortals;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $b52IZ.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                is4XXFailure: is4XXFailure,
                statusCode: statusCode,
                action: 'portalSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        updateResultsCount(portals.length, 1);
    }, [
        term,
        portals.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $43a37d3d3b379916$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $43a37d3d3b379916$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $4mBUe.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.ResultList), {
        role: "list"
    }, portals.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $h6t70.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $89aYe.searchExperience)
    }));
};
const $43a37d3d3b379916$var$containerStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $1zYKE.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $1zYKE.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $43a37d3d3b379916$var$headingStyles = (0, $kig2V.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $43a37d3d3b379916$export$2e2bcd8739ae039 = (0, $azARG.default)()($43a37d3d3b379916$export$7083bd6220bb1bc7);

});
parcelRegister("6BVlr", function(module, exports) {
$parcel$export(module.exports, "default", () => $04ce7508d3ee132f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0b5f48857c921e08b0faf15fc282bb1>>
 * @relayHash b4c5cb2add64b92e5fa0a81f307c32d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1
const $04ce7508d3ee132f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "HelpObjectStorePortalMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1",
            "metadata": {},
            "name": "portalsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$04ce7508d3ee132f$var$node.hash = "5fbada5df4e3a5676426867e2805de0f";
var $04ce7508d3ee132f$export$2e2bcd8739ae039 = $04ce7508d3ee132f$var$node;

});

parcelRegister("9J9dZ", function(module, exports) {
$parcel$export(module.exports, "PortalItem", () => (parcelRequire("h6t70")).default);

var $h6t70 = parcelRequire("h6t70");

});
parcelRegister("h6t70", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0ced38a0611515c$export$2e2bcd8739ae039);

var $52BBO = parcelRequire("52BBO");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $io4o2 = parcelRequire("io4o2");

var $jtp0M = parcelRequire("jtp0M");

var $fJq3t = parcelRequire("fJq3t");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $azARG = parcelRequire("azARG");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");

var $4T8rw = parcelRequire("4T8rw");

var $5a4EU = parcelRequire("5a4EU");

var $3GHVc = parcelRequire("3GHVc");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
parcelRequire("1KMlx");
var $4VcZ1 = parcelRequire("4VcZ1");
const $c0ced38a0611515c$export$dd92e87a60cfa662 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const data = (0, $3BZyK.useFragment)((0, $52BBO.default), result);
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $b52IZ.useVisibilityState)();
    const highlightedTitle = title ? (0, $b52IZ.formatText)(title, term) : '';
    const linkProps = (0, $3GHVc.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: false
    });
    (0, $fc4bM.useEffect)(()=>{
        (0, $b52IZ.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'portal'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $c0ced38a0611515c$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: [
            $c0ced38a0611515c$var$headingStyles,
            $c0ced38a0611515c$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4VcZ1.default), {
        entityType: "PORTAL",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $io4o2.Link), {
        key: id,
        actionSubjectId: 'portal-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $fJq3t.sanitize)(highlightedTitle)
        }
    })))));
};
const $c0ced38a0611515c$var$ConnectedPortalItem = (0, $6umft.default)((state)=>{
    return {
        themeColor: (0, $jtp0M.getThemeColor)(state)
    };
})($c0ced38a0611515c$export$dd92e87a60cfa662);
var $c0ced38a0611515c$export$2e2bcd8739ae039 = (0, $azARG.default)()($c0ced38a0611515c$var$ConnectedPortalItem);
const $c0ced38a0611515c$var$containerStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $c0ced38a0611515c$var$headingStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $c0ced38a0611515c$var$headingAlignmentStyles = (0, $kig2V.xcss)({
    alignItems: 'center'
});

});
parcelRegister("52BBO", function(module, exports) {
$parcel$export(module.exports, "default", () => $523f127d7ad10363$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<401e38e258ab2a07d01ca48a65a435ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $523f127d7ad10363$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStorePortalMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStorePortalSearchResult"
};
$523f127d7ad10363$var$node.hash = "e844983974d9732ca3ef706885375f3f";
var $523f127d7ad10363$export$2e2bcd8739ae039 = $523f127d7ad10363$var$node;

});



parcelRegister("4mBUe", function(module, exports) {
$parcel$export(module.exports, "default", () => $2afb4e0e3d63521a$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $2afb4e0e3d63521a$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals'
    }
});

});



parcelRegister("gPNlv", function(module, exports) {
$parcel$export(module.exports, "RequestForms", () => (parcelRequire("eMr3b")).default);

var $eMr3b = parcelRequire("eMr3b");

});
parcelRegister("eMr3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $18f0a7fc8887e04f$export$2e2bcd8739ae039);

var $6p4V9 = parcelRequire("6p4V9");

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $azARG = parcelRequire("azARG");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $1zYKE = parcelRequire("1zYKE");

var $kig2V = parcelRequire("kig2V");

var $uYmrU = parcelRequire("uYmrU");
parcelRequire("4ZWZy");
var $eFtAu = parcelRequire("eFtAu");
var $cd2Ru = parcelRequire("cd2Ru");
var $b52IZ = parcelRequire("b52IZ");

var $89aYe = parcelRequire("89aYe");
parcelRequire("826ng");
var $8KK9g = parcelRequire("8KK9g");

var $it499 = parcelRequire("it499");
const $18f0a7fc8887e04f$export$d7562fc7136a7ea2 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const cloudId = (0, $6LH8a.getCloudId)();
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $6p4V9.default), {
        cloudId: cloudId,
        portalId: portalId,
        queryTerm: term,
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        limit: (0, $eFtAu.REQUEST_FORMS_NEW_LIMIT)
    });
    const requestForms = ((_data$helpObjectStore = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreRequestTypeSearchResults' ? data.helpObjectStore_searchRequestTypes.results : [];
    const showSection = requestForms.length > 0;
    (0, $fc4bM.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreRequestTypeSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchRequestTypes.results.forEach((requestForm)=>{
                const { metadata: metadata } = requestForm;
                const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
                if (isExternal) externalResourcesCount += 1;
                if (searchStrategy === 'SEARCH_PLATFORM_KEYWORD_BASED') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $b52IZ.sendSearchOperationalAnalyticEvents)({
                action: 'requestTypeSearchSucceeded',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $b52IZ.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'request-form',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchRequestTypes;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $b52IZ.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                statusCode: statusCode,
                is4XXFailure: is4XXFailure,
                action: 'requestTypeSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        updateResultsCount(requestForms.length, 1);
    }, [
        term,
        requestForms.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $18f0a7fc8887e04f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $18f0a7fc8887e04f$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $it499.default).requestForms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cd2Ru.ResultList), {
        role: "list"
    }, requestForms.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8KK9g.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $89aYe.searchExperience)
    }));
};
const $18f0a7fc8887e04f$var$containerStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $1zYKE.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $1zYKE.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $18f0a7fc8887e04f$var$headingStyles = (0, $kig2V.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $18f0a7fc8887e04f$export$2e2bcd8739ae039 = (0, $azARG.default)()($18f0a7fc8887e04f$export$d7562fc7136a7ea2);

});
parcelRegister("6p4V9", function(module, exports) {
$parcel$export(module.exports, "default", () => $00ca0764f924e35f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c730a03ebb5021ead8eb56adb78276ae>>
 * @relayHash 4db5964fda1ef7ad6bb403c6a9420d56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9
const $00ca0764f924e35f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalId",
            "variableName": "portalId"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpObjectStoreRequestTypeMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "requestFormItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9",
            "metadata": {},
            "name": "requestFormsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$00ca0764f924e35f$var$node.hash = "6a4749a62d9236563bcbeca7d18c02eb";
var $00ca0764f924e35f$export$2e2bcd8739ae039 = $00ca0764f924e35f$var$node;

});

parcelRegister("826ng", function(module, exports) {
$parcel$export(module.exports, "RequestFormItem", () => (parcelRequire("8KK9g")).default);

var $8KK9g = parcelRequire("8KK9g");

});
parcelRegister("8KK9g", function(module, exports) {
$parcel$export(module.exports, "default", () => $91dc8caf66010697$export$2e2bcd8739ae039);

var $cVu7V = parcelRequire("cVu7V");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $io4o2 = parcelRequire("io4o2");

var $jtp0M = parcelRequire("jtp0M");

var $fJq3t = parcelRequire("fJq3t");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $azARG = parcelRequire("azARG");

var $dVoLr = parcelRequire("dVoLr");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");

var $4T8rw = parcelRequire("4T8rw");

var $3GHVc = parcelRequire("3GHVc");

var $eDb29 = parcelRequire("eDb29");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
parcelRequire("1KMlx");
var $4VcZ1 = parcelRequire("4VcZ1");
const $91dc8caf66010697$export$c5555d4e61cdd47a = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useFragment)((0, $cVu7V.default), result);
    const [portalId] = (0, $lJu6R.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $b52IZ.useVisibilityState)();
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVoLr))), {
        label: formatMessage((0, $eDb29.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $b52IZ.formatText)(title, term) : '';
    const linkProps = (0, $3GHVc.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $fc4bM.useEffect)(()=>{
        (0, $b52IZ.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'request-form'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $91dc8caf66010697$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: [
            $91dc8caf66010697$var$headingStyles,
            $91dc8caf66010697$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4VcZ1.default), {
        entityType: "REQUEST_FORM",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $io4o2.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-request-form-link' : 'request-form-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $fJq3t.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: isShortcutIconVisible ? $91dc8caf66010697$var$headerRightAreaStylesVisible : $91dc8caf66010697$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $91dc8caf66010697$var$ConnectedRequestFormItem = (0, $6umft.default)((state)=>{
    return {
        themeColor: (0, $jtp0M.getThemeColor)(state)
    };
})($91dc8caf66010697$export$c5555d4e61cdd47a);
var $91dc8caf66010697$export$2e2bcd8739ae039 = (0, $azARG.default)()($91dc8caf66010697$var$ConnectedRequestFormItem);
const $91dc8caf66010697$var$containerStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $91dc8caf66010697$var$headingStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $91dc8caf66010697$var$headingAlignmentStyles = (0, $kig2V.xcss)({
    alignItems: 'center'
});
const $91dc8caf66010697$var$headerRightAreaStylesInVisible = (0, $kig2V.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $91dc8caf66010697$var$headerRightAreaStylesVisible = (0, $kig2V.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("cVu7V", function(module, exports) {
$parcel$export(module.exports, "default", () => $defd8937b8f0b6a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32278cf5dc0e7086ec41d31040a6e7d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $defd8937b8f0b6a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestFormItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStoreRequestTypeMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isExternal"
                },
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStoreRequestTypeSearchResult"
};
$defd8937b8f0b6a9$var$node.hash = "3676027039798345dde34e2948999172";
var $defd8937b8f0b6a9$export$2e2bcd8739ae039 = $defd8937b8f0b6a9$var$node;

});



parcelRegister("it499", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc309981a86c40aa$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $fc309981a86c40aa$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    requestForms: {
        defaultMessage: 'Request forms',
        description: 'Text for section resource type in search results',
        id: 'cv.search.request-forms.request-forms'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Text for portal name in description',
        id: 'cv.search.request-forms.portal'
    }
});

});





parcelRegister("gw7Xx", function(module, exports) {
$parcel$export(module.exports, "default", () => $73328202efa297c2$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("csZtW");
var $gD2hW = parcelRequire("gD2hW");
parcelRequire("7h8sD");
var $8EcmC = parcelRequire("8EcmC");

var $kNzex = parcelRequire("kNzex");
const $73328202efa297c2$var$selector = (0, $2n2bS.createSelector)((0, $8EcmC.getAllVisiblePortals), (0, $8EcmC.getfeaturedAndSortedPortalsError), (portals, featuredAndSortedPortalsError)=>({
        featuredAndSortedPortalsError: featuredAndSortedPortalsError,
        portals: portals
    }));
var $73328202efa297c2$export$2e2bcd8739ae039 = (0, $6umft.default)($73328202efa297c2$var$selector, {
    fetchPortals: (0, $gD2hW.fetchFeaturedAndSortedPortalsModel)
})((0, $kNzex.default));

});
parcelRegister("kNzex", function(module, exports) {
$parcel$export(module.exports, "default", () => $00fab0ac3510bf81$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("3jC5I");
var $lIb0m = parcelRequire("lIb0m");

var $61SJN = parcelRequire("61SJN");
const $00fab0ac3510bf81$var$ServiceDeskFilter = ({ portals: portals, portalIds: portalIds, fetchPortals: fetchPortals, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [values, _] = $fc4bM.useState(portalIds ?? []);
    $fc4bM.useEffect(()=>{
        fetchPortals({
            exploreAll: true,
            sortBy: 'POPULARITY'
        }, false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const options = $fc4bM.useMemo(()=>{
        return portals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals
    ]);
    const preSelectedOptions = $fc4bM.useMemo(()=>{
        const preselectedPortals = portals.filter((portal)=>values.find((id)=>id === portal.id.toString()));
        return preselectedPortals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals,
        values
    ]);
    return portals.length > 1 ? /*#__PURE__*/ $fc4bM.createElement((0, $lIb0m.default), {
        fieldId: "servicedesk_filter",
        fieldLabel: formatMessage((0, $61SJN.default).portal),
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange,
        testId: "serviceDeskFilter"
    }) : null;
};
var $00fab0ac3510bf81$export$2e2bcd8739ae039 = $00fab0ac3510bf81$var$ServiceDeskFilter;

});
parcelRegister("61SJN", function(module, exports) {
$parcel$export(module.exports, "default", () => $53261c26c7769c0e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $53261c26c7769c0e$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    serviceDeskFilter: {
        defaultMessage: 'Service desk',
        description: 'Label for the service desk filter option in the search results picker',
        id: 'sd.all.articles.result.servicedesk.filter.name'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Label for the portal filter option in the search results picker',
        id: 'cv.search.servicedesk-filter.portal'
    }
});

});





parcelRegister("lI4yE", function(module, exports) {
$parcel$export(module.exports, "SearchTextboxV2", () => (parcelRequire("8l26f")).default);

var $8l26f = parcelRequire("8l26f");

});
parcelRegister("8l26f", function(module, exports) {
$parcel$export(module.exports, "default", () => $699d9f76601e13c5$export$2e2bcd8739ae039);
/* search-textbox-v2.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $l3fPD = parcelRequire("l3fPD");

var $aYMdQ = parcelRequire("aYMdQ");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");
var $7lAXH = parcelRequire("7lAXH");
parcelRequire("7e7Tg");
var $g2GJC = parcelRequire("g2GJC");

var $6BbQe = parcelRequire("6BbQe");

var $kZaOC = parcelRequire("kZaOC");

var $iG0dO = parcelRequire("iG0dO");
parcelRequire("kctXj");
var $5J1Fh = parcelRequire("5J1Fh");

var $jEubQ = parcelRequire("jEubQ");

var $613oU = parcelRequire("613oU");

var $k2M4v = parcelRequire("k2M4v");

var $8K7DG = parcelRequire("8K7DG");

var $gDsF8 = parcelRequire("gDsF8");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $k8Adr = parcelRequire("k8Adr");

var $kig2V = parcelRequire("kig2V");

var $4gVCP = parcelRequire("4gVCP");

var $eENmG = parcelRequire("eENmG");

var $fgUje = parcelRequire("fgUje");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $c0Y6o = parcelRequire("c0Y6o");

var $0iMl4 = parcelRequire("0iMl4");

var $8xKBm = parcelRequire("8xKBm");

var $DFeDK = parcelRequire("DFeDK");

var $2R60X = parcelRequire("2R60X");

var $4q8Dn = parcelRequire("4q8Dn");

var $3QNa8 = parcelRequire("3QNa8");

var $2Dm35 = parcelRequire("2Dm35");

var $ihvuu = parcelRequire("ihvuu");

var $9mBuf = parcelRequire("9mBuf");

var $dofBo = parcelRequire("dofBo");

var $2EIFN = parcelRequire("2EIFN");

var $bHG0Y = parcelRequire("bHG0Y");
parcelRequire("4ZWZy");
var $b52IZ = parcelRequire("b52IZ");
parcelRequire("hCUGT");
var $ehOS8 = parcelRequire("ehOS8");

var $7ewOR = parcelRequire("7ewOR");

var $daevt = parcelRequire("daevt");
const $699d9f76601e13c5$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON = 'searchQueryCharacterLimitErrorIcon';
const $699d9f76601e13c5$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER = 'searchQueryCharacterLimitErrorPopover';
const $699d9f76601e13c5$var$HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const $699d9f76601e13c5$var$isHelpCenterSearchLimitEnabled = ()=>(0, $k2M4v.default).checkGate($699d9f76601e13c5$var$HELP_CENTER_SEARCH_LIMIT_GATE);
const $699d9f76601e13c5$var$usePopularPortalsWithVA = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const [popularPortalsWithVA, setPopularPortalsWithVA] = (0, $fc4bM.useState)([]);
    const [isFetching, setIsFetching] = (0, $fc4bM.useState)(false);
    const cloudId = (0, $fc4bM.useMemo)(()=>(0, $6LH8a.getCloudId)(), []);
    const fetchData = (0, $fc4bM.useCallback)(async ()=>{
        setIsFetching(true);
        try {
            const { mostPopularVAsPortalData: mostPopularVAsPortalData } = await (0, $c0Y6o.fetchJson)(`/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/virtualagent/mostPopularVAs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    helpCenterId: (0, $6LH8a.getHelpCenterAri)()
                })
            });
            setPopularPortalsWithVA(mostPopularVAsPortalData);
        } catch (error) {
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.UI_EVENT_TYPE),
                action: 'failed',
                actionSubjectId: 'fetchPopularPortalsWithVA'
            }).fire();
        } finally{
            setIsFetching(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        setIsFetching,
        setPopularPortalsWithVA
    ]);
    return {
        isFetching: isFetching,
        popularPortalsWithVA: popularPortalsWithVA,
        fetchData: fetchData
    };
};
// Extracted component to reduce duplication
const $699d9f76601e13c5$var$SearchHintWithEnterIcon = ({ message: message, isVisible: isVisible })=>{
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $699d9f76601e13c5$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l3fPD))),
        alt: ""
    })));
};
const $699d9f76601e13c5$var$SearchPopupContentWithRef = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function SearchPopupContent(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const ariaDescriptionId = (0, $fc4bM.useId)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, ...triggerProps } = searchPopupContentProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        ...(0, $7ewOR.isRemoveInvalidSearchPopupAriaEnabled)() ? {} : triggerProps,
        ref: ref,
        xcss: $699d9f76601e13c5$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4gVCP.WidthObserver), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $699d9f76601e13c5$var$searchBoxStyles,
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "span",
        id: ariaDescriptionId,
        xcss: $699d9f76601e13c5$var$visuallyHiddenStyles
    }, formatMessage((0, $daevt.default).ariaDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$Input, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $daevt.default).inputAriaLabel) : formatMessage((0, $daevt.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $daevt.default).inputPlaceholder) : formatMessage((0, $daevt.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        "aria-describedby": ariaDescriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $699d9f76601e13c5$var$hiddenDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        id: ariaDescriptionId
    }, formatMessage((0, $daevt.default).ariaDescription))), (0, $b52IZ.isValidSearchTerm)(inputValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchHintWithEnterIcon, {
        message: isVirtualAgentEnabled ? formatMessage((0, $daevt.default).askTheVirtualServiceAgent) : formatMessage((0, $daevt.default).search),
        isVisible: isVirtualAgentEnabled || isFetchingResults || visibleResultsCount !== 0
    }))));
});
const $699d9f76601e13c5$var$SearchPopupContentWithSearchLimitRef = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function SearchPopupContentWithSearchLimit(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const ariaDescriptionId = (0, $fc4bM.useId)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, isSearchQueryOverLimit: isSearchQueryOverLimit, onCharacterLimitErrorIconClick: onCharacterLimitErrorIconClick, ...triggerProps } = searchPopupContentProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        ...(0, $7ewOR.isRemoveInvalidSearchPopupAriaEnabled)() ? {} : triggerProps,
        ref: ref,
        xcss: $699d9f76601e13c5$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4gVCP.WidthObserver), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $699d9f76601e13c5$var$searchBoxStyles,
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$InputWithSearchLimit, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        hasTrailingErrorIcon: isSearchQueryOverLimit,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $daevt.default).inputAriaLabel) : formatMessage((0, $daevt.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $daevt.default).inputPlaceholder) : formatMessage((0, $daevt.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        "aria-describedby": ariaDescriptionId,
        "aria-invalid": isSearchQueryOverLimit ? true : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $699d9f76601e13c5$var$hiddenDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        id: ariaDescriptionId
    }, formatMessage((0, $daevt.default).ariaDescription))), isSearchQueryOverLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "button",
        type: "button",
        xcss: $699d9f76601e13c5$var$errorIconWrapperStyles,
        "aria-label": formatMessage((0, $daevt.default).characterLimitErrorIconLabel),
        onClick: onCharacterLimitErrorIconClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchHintWithEnterIcon, {
        message: isVirtualAgentEnabled ? formatMessage((0, $daevt.default).askTheVirtualServiceAgent) : formatMessage((0, $daevt.default).search),
        isVisible: (0, $b52IZ.isValidSearchTerm)(inputValue) && (isVirtualAgentEnabled || isFetchingResults || visibleResultsCount !== 0)
    }))));
});
const $699d9f76601e13c5$var$SearchTextboxV2 = (props)=>{
    if ($699d9f76601e13c5$var$isHelpCenterSearchLimitEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchTextboxV2WithSearchLimit, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchTextboxV2Legacy, props);
};
const $699d9f76601e13c5$var$SearchTextboxV2Legacy = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $fc4bM.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $fc4bM.useState)(false);
    const [inputValue, setInputValue] = (0, $fc4bM.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $fc4bM.useState)();
    const [{ location: location }, { push: push }] = (0, $7lAXH.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $6BbQe.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $g2GJC.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $ehOS8.useInlineResultsContext)();
    const environment = (0, $3BZyK.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $699d9f76601e13c5$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $dofBo.useSubscriptionAction)();
    (0, $fc4bM.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $2R60X.useCreateConversationWithMessage)();
    const openChoicesIfPresent = (0, $fc4bM.useCallback)(()=>{
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $b52IZ.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled
    ]);
    const handleInputChange = (0, $fc4bM.useCallback)((event)=>{
        const newQuery = event.target.value;
        setInputValue(newQuery);
        setIsChoiceOpen((0, $b52IZ.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen
    ]);
    const onSeeSearchResults = (0, $fc4bM.useCallback)(()=>{
        if (!(0, $b52IZ.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $fc4bM.useCallback)(async ()=>{
        if (!(0, $b52IZ.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $hN5YJ.isOmnichannelEnabledForHC)()) {
            const subscriptionId = await (0, $9mBuf.generateUniqueSubscriptionID)({
                environment: environment
            });
            const omniChannelMetaData = await (0, $3QNa8.fetchOmnichannelMeta)(environment);
            await (0, $4q8Dn.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                subscriptionId: subscriptionId,
                draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                isConversationClosed: false,
                isConversationExpired: false,
                disableInput: false,
                isReplyPending: false,
                subscriptionTriggered: true,
                subscriptionStatus: 'TRIGGERED'
            });
            const disposable = (0, $2Dm35.establishSubscriptionToOmnichannel)({
                environment: environment,
                subscriptionId: subscriptionId
            });
            setSubscriptionDisposer(disposable);
            if (omniChannelMetaData.connectionId) createConversationWithMessage({
                subscriptionId: subscriptionId,
                workspaceAri: (0, $6LH8a.getWorkspaceAri)(),
                conversationContextAri: (0, $6LH8a.getHelpCenterAri)(),
                isTestConversation: false,
                message: inputValue.trim(),
                connectionId: omniChannelMetaData.connectionId
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $DFeDK.initialIntentMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $ihvuu.omnichannelPageLoadExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $DFeDK.initialAIMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $8xKBm.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $bHG0Y.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $aYMdQ.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $aYMdQ.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $aYMdQ.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $fc4bM.useCallback)((event)=>{
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if ((0, $k2M4v.default).checkGate('jsm_hc_search_composing_fix') && event.nativeEvent.isComposing) return;
        if (event.key === 'Enter') {
            if (!!isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $5J1Fh.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults
    ]);
    (0, $fc4bM.useEffect)(()=>{
        setIsChoiceOpen((0, $b52IZ.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen
    ]);
    const [requestIdParam] = (0, $lJu6R.usePathParam)('requestId');
    (0, $fc4bM.useEffect)(()=>{
        var _searchBarRef$current;
        if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && requestIdParam) return;
        // Avoid scrolling the page to a bottom-positioned search banner on load (JSDCLOUD-15743).
        (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 || _searchBarRef$current.focus({
            preventScroll: true
        });
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, isVSAOnHCEnabled && (0, $hN5YJ.isOmnichannelEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2EIFN.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7ewOR.SearchPromptPopup), {
        isOpen: isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>setIsChoiceOpen(false),
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchPopupContentWithRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount
            });
        }
    }));
};
const $699d9f76601e13c5$var$SearchTextboxV2WithSearchLimit = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $fc4bM.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $fc4bM.useState)(false);
    const [isCharacterLimitPopoverOpen, setIsCharacterLimitPopoverOpen] = (0, $fc4bM.useState)(false);
    const [inputValue, setInputValue] = (0, $fc4bM.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $fc4bM.useState)();
    const [{ location: location }, { push: push }] = (0, $7lAXH.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $6BbQe.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $g2GJC.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $ehOS8.useInlineResultsContext)();
    const environment = (0, $3BZyK.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $699d9f76601e13c5$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $dofBo.useSubscriptionAction)();
    (0, $fc4bM.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $2R60X.useCreateConversationWithMessage)();
    const isSearchQueryOverLimit = (0, $b52IZ.isSearchQueryOverCharacterLimit)(inputValue);
    const openChoicesIfPresent = (0, $fc4bM.useCallback)(()=>{
        if (isSearchQueryOverLimit) return;
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $b52IZ.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled,
        isSearchQueryOverLimit
    ]);
    const handleInputChange = (0, $fc4bM.useCallback)((event)=>{
        const newQuery = event.target.value;
        const isNewQueryOverLimit = (0, $b52IZ.isSearchQueryOverCharacterLimit)(newQuery);
        setInputValue(newQuery);
        setIsCharacterLimitPopoverOpen(false);
        setIsChoiceOpen(!isNewQueryOverLimit && (0, $b52IZ.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen,
        setIsCharacterLimitPopoverOpen
    ]);
    const onSeeSearchResults = (0, $fc4bM.useCallback)(()=>{
        if (!(0, $b52IZ.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $fc4bM.useCallback)(async ()=>{
        if (!(0, $b52IZ.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $hN5YJ.isOmnichannelEnabledForHC)()) {
            const subscriptionId = await (0, $9mBuf.generateUniqueSubscriptionID)({
                environment: environment
            });
            const omniChannelMetaData = await (0, $3QNa8.fetchOmnichannelMeta)(environment);
            await (0, $4q8Dn.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                subscriptionId: subscriptionId,
                draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                isConversationClosed: false,
                isConversationExpired: false,
                disableInput: false,
                isReplyPending: false,
                subscriptionTriggered: true,
                subscriptionStatus: 'TRIGGERED'
            });
            const disposable = (0, $2Dm35.establishSubscriptionToOmnichannel)({
                environment: environment,
                subscriptionId: subscriptionId
            });
            setSubscriptionDisposer(disposable);
            if (omniChannelMetaData.connectionId) createConversationWithMessage({
                subscriptionId: subscriptionId,
                workspaceAri: (0, $6LH8a.getWorkspaceAri)(),
                conversationContextAri: (0, $6LH8a.getHelpCenterAri)(),
                isTestConversation: false,
                message: inputValue.trim(),
                connectionId: omniChannelMetaData.connectionId
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $DFeDK.initialIntentMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $ihvuu.omnichannelPageLoadExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $DFeDK.initialAIMessageHCExperience).start();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $8xKBm.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $bHG0Y.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $aYMdQ.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $aYMdQ.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $aYMdQ.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $fc4bM.useCallback)((event)=>{
        if (isSearchQueryOverLimit) return;
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if ((0, $k2M4v.default).checkGate('jsm_hc_search_composing_fix') && event.nativeEvent.isComposing) return;
        if (event.key === 'Enter') {
            if (isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $5J1Fh.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults,
        isSearchQueryOverLimit
    ]);
    (0, $fc4bM.useEffect)(()=>{
        setIsChoiceOpen(!isSearchQueryOverLimit && (0, $b52IZ.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        isSearchQueryOverLimit,
        setIsChoiceOpen
    ]);
    const onCharacterLimitErrorIconClick = (0, $fc4bM.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $699d9f76601e13c5$var$SEARCH_CHARACTER_LIMIT_ERROR_ICON,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }).fire();
        const nextIsOpen = !isCharacterLimitPopoverOpen;
        setIsCharacterLimitPopoverOpen(nextIsOpen);
        if (nextIsOpen) createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'rendered',
            actionSubject: 'popover',
            actionSubjectId: $699d9f76601e13c5$var$SEARCH_CHARACTER_LIMIT_ERROR_POPOVER,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }).fire();
    }, [
        createAnalyticsEvent,
        isCharacterLimitPopoverOpen
    ]);
    const [requestIdParam] = (0, $lJu6R.usePathParam)('requestId');
    (0, $fc4bM.useEffect)(()=>{
        var _searchBarRef$current2;
        if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && requestIdParam) return;
        // Avoid scrolling the page to a bottom-positioned search banner on load (JSDCLOUD-15743).
        (_searchBarRef$current2 = searchBarRef.current) === null || _searchBarRef$current2 === void 0 || _searchBarRef$current2.focus({
            preventScroll: true
        });
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, isVSAOnHCEnabled && (0, $hN5YJ.isOmnichannelEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2EIFN.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7ewOR.SearchPromptPopup), {
        isOpen: isSearchQueryOverLimit ? isCharacterLimitPopoverOpen : isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>{
            setIsChoiceOpen(false);
            setIsCharacterLimitPopoverOpen(false);
        },
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        isSearchQueryOverLimit: isSearchQueryOverLimit,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$SearchPopupContentWithSearchLimitRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount,
                isSearchQueryOverLimit: isSearchQueryOverLimit,
                onCharacterLimitErrorIconClick: onCharacterLimitErrorIconClick
            });
        }
    }));
};
$699d9f76601e13c5$var$SearchTextboxV2.displayName = 'SearchTextboxV2';
const $699d9f76601e13c5$var$WrappedComponent = (0, $0iMl4.withHelpCenterConversationStateContainer)($699d9f76601e13c5$var$SearchTextboxV2);
const $699d9f76601e13c5$var$SearchTextBoxV2withConversationContainers = (props)=>{
    const contextId = (0, $6LH8a.getHelpCenterAri)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($699d9f76601e13c5$var$WrappedComponent, {
        ...props,
        contextId: contextId
    });
};
var $699d9f76601e13c5$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: (0, $9mazR.ScreenName).HELP_CENTER_SEARCH
})($699d9f76601e13c5$var$SearchTextBoxV2withConversationContainers);
const $699d9f76601e13c5$var$hiddenDescriptionStyles = (0, $kig2V.xcss)({
    display: 'none'
});
const $699d9f76601e13c5$var$searchBoxWrapperStyles = (0, $kig2V.xcss)({
    position: 'relative'
});
const $699d9f76601e13c5$var$visuallyHiddenStyles = (0, $kig2V.xcss)({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    userSelect: 'none',
    whiteSpace: 'nowrap'
});
const $699d9f76601e13c5$var$searchBoxStyles = (0, $kig2V.xcss)({
    backgroundColor: 'color.background.input',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border.input',
    borderRadius: 'radius.medium',
    ':focus-within': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused'
    }
});
const $699d9f76601e13c5$var$getInputPaddingRight = (props)=>{
    if (props.hasTrailingErrorIcon) return "var(--ds-space-600, 48px)";
    if (props.isAiAnswersEnabled) return '148px';
    return "var(--ds-space-600, 48px)";
};
const $699d9f76601e13c5$var$getMobileInputPaddingRight = (props)=>{
    if (!(0, $hN5YJ.isUseHelpCenterRefresh)()) return '';
    if (props.hasTrailingErrorIcon) return `padding-right: ${"var(--ds-space-600, 48px)"};`;
    return `padding-right: ${"var(--ds-space-050, 4px)"};`;
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $699d9f76601e13c5$var$Input = /*#__PURE__*/ (0, $luz1X.default).input.withConfig({
    componentId: "sc-d7rq06-0"
})`${(0, $iG0dO.SEARCH_INPUT_FONT_SIZE)};${$3DjOo.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};border-radius:${"var(--ds-radius-medium, 6px)"};padding:${$fOCtI.multiple(2.125).px}  ${(props)=>props.isAiAnswersEnabled ? '148px' : "var(--ds-space-600, 48px)"} ${$fOCtI.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${(0, $hN5YJ.isUseHelpCenterRefresh)() ? `padding-right: ${"var(--ds-space-050, 4px)"};` : ''}}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $699d9f76601e13c5$var$InputWithSearchLimit = /*#__PURE__*/ (0, $luz1X.default).input.withConfig({
    componentId: "sc-d7rq06-1"
})`${(0, $iG0dO.SEARCH_INPUT_FONT_SIZE)};${$3DjOo.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};border-radius:${"var(--ds-radius-medium, 6px)"};padding:${$fOCtI.multiple(2.125).px} ${$699d9f76601e13c5$var$getInputPaddingRight} ${$fOCtI.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${$699d9f76601e13c5$var$getMobileInputPaddingRight}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $699d9f76601e13c5$var$SearchIconWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt4119w _4t3i1osq _1ltvidpf _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1wpz1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});
const $699d9f76601e13c5$var$askAiHintStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    color: 'color.text.subtle',
    top: 'space.0',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 11
});
const $699d9f76601e13c5$var$errorIconWrapperStyles = (0, $kig2V.xcss)({
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    textAlign: 'right',
    top: 'space.0',
    bottom: 'space.0'
});

});
parcelRegister("l3fPD", function(module, exports) {
module.exports = new URL("../images/enter-icon.6e72b8c1.svg", import.meta.url).toString();

});

parcelRegister("7e7Tg", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => (parcelRequire("g2GJC")).useSendMessage);
$parcel$export(module.exports, "useIsGenerating", () => (parcelRequire("bNsww")).useIsGenerating);
$parcel$export(module.exports, "useIsInputEnabled", () => (parcelRequire("1hXlf")).useIsInputEnabled);
$parcel$export(module.exports, "useHasMessages", () => (parcelRequire("auzYQ")).useHasMessages);
$parcel$export(module.exports, "useStopGenerating", () => (parcelRequire("kcpRM")).useStopGenerating);
$parcel$export(module.exports, "useGetMaxChars", () => (parcelRequire("dfO3l")).useGetMaxChars);
$parcel$export(module.exports, "useIsInputShown", () => (parcelRequire("jM4Ug")).useIsInputShown);
$parcel$export(module.exports, "useClearConversation", () => (parcelRequire("7RiDJ")).useClearConversation);
$parcel$export(module.exports, "useHandOffConversation", () => (parcelRequire("92RpZ")).useHandOffConversation);

var $g2GJC = parcelRequire("g2GJC");

var $bNsww = parcelRequire("bNsww");

var $1hXlf = parcelRequire("1hXlf");

var $auzYQ = parcelRequire("auzYQ");

var $kcpRM = parcelRequire("kcpRM");

var $dfO3l = parcelRequire("dfO3l");

var $jM4Ug = parcelRequire("jM4Ug");

var $7RiDJ = parcelRequire("7RiDJ");

var $92RpZ = parcelRequire("92RpZ");

});
parcelRegister("g2GJC", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $c261b0c1ec11f252$export$fe8707b58c509543);

var $8xKBm = parcelRequire("8xKBm");

var $i2wCX = parcelRequire("i2wCX");

var $bHG0Y = parcelRequire("bHG0Y");

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $6BbQe = parcelRequire("6BbQe");
const $c261b0c1ec11f252$export$fe8707b58c509543 = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const { sendMessage: sendVirtualAgentMessage } = (0, $i2wCX.useSendMessage)();
    const { addHelpseekerMessage: addAIAnswersMessage } = (0, $6BbQe.useActions)();
    const sendMessage = (message)=>{
        provider === (0, $etQ17.ConversationProvider).AI_ANSWERS ? addAIAnswersMessage(message) : sendVirtualAgentMessage(message);
        if (provider === (0, $etQ17.ConversationProvider).AI_ANSWERS) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $bHG0Y.AIAnswerExperience).start();
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $8xKBm.intentAnswerExperience).start();
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("8xKBm", function(module, exports) {
$parcel$export(module.exports, "intentAnswerExperience", () => $49e0c7b8a732b71a$export$b0aa4ee2c3e0b407);
$parcel$export(module.exports, "initialIntentMessageExperience", () => $49e0c7b8a732b71a$export$1bc905fb9e119ab8);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $49e0c7b8a732b71a$var$intentAnswerExperienceId = 'service-management.help-center.virtual-agent.intent-message';
const $49e0c7b8a732b71a$var$initialIntentMessageExperienceId = 'service-management.help-center.virtual-agent.intent-initial-message-reply';
const $49e0c7b8a732b71a$export$b0aa4ee2c3e0b407 = new (0, $9LFKj.UFOExperience)($49e0c7b8a732b71a$var$intentAnswerExperienceId, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $49e0c7b8a732b71a$export$1bc905fb9e119ab8 = new (0, $9LFKj.UFOExperience)($49e0c7b8a732b71a$var$initialIntentMessageExperienceId, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("i2wCX", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $24c1da39c057f607$export$fe8707b58c509543);

var $dODsu = parcelRequire("dODsu");

var $c6Gzm = parcelRequire("c6Gzm");

var $d04aK = parcelRequire("d04aK");
const $24c1da39c057f607$export$fe8707b58c509543 = ()=>{
    const { addMessage: addMessage, addJiraFieldMessage: addJiraFieldMessage } = (0, $d04aK.useActions)();
    const jiraField = (0, $d04aK.useFieldFromLastMessage)();
    const baseUrl = (0, $d04aK.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $dODsu.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const sendMessage = (message)=>{
        if (jiraField && (0, $c6Gzm.isTextField)(jiraField.fieldId, requestTypeFields)) addJiraFieldMessage(jiraField.fieldId, message);
        else addMessage(message);
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("dODsu", function(module, exports) {
$parcel$export(module.exports, "useRequestTypeFields", () => $af27dd7490ccdf27$export$6fa5557c101e4783);

var $fc4bM = parcelRequire("fc4bM");

var $c0Y6o = parcelRequire("c0Y6o");

var $iS9fM = parcelRequire("iS9fM");
const $af27dd7490ccdf27$export$6fa5557c101e4783 = ({ baseUrl: baseUrl = '' })=>{
    const { setRequestTypeFieldsMap: setRequestTypeFieldsMap, setIsLoading: setIsLoading, setError: setError } = (0, $iS9fM.useActions)();
    const fieldStore = (0, $iS9fM.useStore)();
    const requestTypeFieldPromise = (0, $iS9fM.useRequestTypeFieldPromise)();
    const getRequestTypeFieldsEndpoint = (0, $fc4bM.useCallback)((projectId, requestTypeId)=>{
        if (!requestTypeId) return '';
        const projectIdentifier = `projectId:${projectId}`;
        return `${baseUrl}/rest/servicedeskapi/servicedesk/${encodeURIComponent(projectIdentifier)}/requesttype/${encodeURIComponent(requestTypeId)}/field`;
    }, [
        baseUrl
    ]);
    const convertedRequestTypeFieldMap = (0, $fc4bM.useCallback)((response)=>{
        return new Map(response === null || response === void 0 ? void 0 : response.requestTypeFields.map((field)=>[
                field.fieldId,
                field
            ]));
    }, []);
    const fetchRequestTypeFields = (0, $fc4bM.useCallback)(async (projectId, requestTypeId)=>{
        try {
            if (!requestTypeId) throw new Error('requestTypeId is undefined');
            const response = await (0, $c0Y6o.fetchJson)(getRequestTypeFieldsEndpoint(projectId, requestTypeId), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const convertedMap = convertedRequestTypeFieldMap(response);
            setRequestTypeFieldsMap(convertedMap);
            return convertedMap;
        } catch (err) {
            setError(err);
            return undefined;
        }
    }, [
        getRequestTypeFieldsEndpoint,
        convertedRequestTypeFieldMap,
        setRequestTypeFieldsMap,
        setError
    ]);
    const cacheIsInvalid = (0, $fc4bM.useCallback)((projectId, requestTypeId)=>{
        if (!fieldStore.cacheIds) return true;
        return projectId !== fieldStore.cacheIds.projectId || requestTypeId !== fieldStore.cacheIds.requestTypeId;
    }, [
        fieldStore.cacheIds
    ]);
    const fetchFieldsOrUseCache = (0, $fc4bM.useCallback)(async (projectId, requestTypeId)=>{
        if (cacheIsInvalid(projectId, requestTypeId)) {
            const request = fetchRequestTypeFields(projectId, requestTypeId);
            setIsLoading({
                projectId: projectId,
                requestTypeId: requestTypeId
            }, request);
            return request;
        }
        return requestTypeFieldPromise;
    }, [
        cacheIsInvalid,
        fetchRequestTypeFields,
        requestTypeFieldPromise,
        setIsLoading
    ]);
    return [
        {
            loading: fieldStore.loading,
            data: fieldStore.requestTypeFieldsMap,
            error: fieldStore.error
        },
        {
            fetchRequestTypeFields: fetchFieldsOrUseCache
        }
    ];
};

});
parcelRegister("iS9fM", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $b0290e9e385d905b$export$6ccbb43953eebf8);
$parcel$export(module.exports, "useActions", () => $b0290e9e385d905b$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useRequestTypeFieldPromise", () => $b0290e9e385d905b$export$c9a90d3a86a18942);

var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");

var $GN60m = parcelRequire("GN60m");
const $b0290e9e385d905b$var$initialState = {
    loading: false,
    cacheIds: undefined,
    requestTypeFieldsMap: new Map()
};
const $b0290e9e385d905b$export$b6b2c03d619b3cc5 = (0, $ipn74.createStore)({
    initialState: $b0290e9e385d905b$var$initialState,
    actions: $GN60m.actions,
    name: 'requestTypeFields'
});
const $b0290e9e385d905b$export$6ccbb43953eebf8 = (0, $5nVr1.createStateHook)($b0290e9e385d905b$export$b6b2c03d619b3cc5);
const $b0290e9e385d905b$export$bc923229a7fa61e7 = (0, $5nVr1.createActionsHook)($b0290e9e385d905b$export$b6b2c03d619b3cc5);
const $b0290e9e385d905b$export$c9a90d3a86a18942 = (0, $5nVr1.createStateHook)($b0290e9e385d905b$export$b6b2c03d619b3cc5, {
    selector: (state)=>state.inFlightRequest ? state.inFlightRequest : state.requestTypeFieldsMap
});

});
parcelRegister("GN60m", function(module, exports) {
$parcel$export(module.exports, "actions", () => $084adb832386829c$export$e324594224ef24da);

var $9wfiI = parcelRequire("9wfiI");
const $084adb832386829c$var$setRequestTypeFieldsMap = (requestTypeFieldsMap)=>({ setState: setState })=>{
        setState({
            requestTypeFieldsMap: requestTypeFieldsMap,
            error: undefined,
            inFlightRequest: undefined,
            loading: false
        });
    };
const $084adb832386829c$var$setIsLoading = (cacheIds, inFlightRequest)=>({ setState: setState })=>{
        setState({
            cacheIds: cacheIds,
            inFlightRequest: inFlightRequest,
            loading: true
        });
    };
const $084adb832386829c$var$setError = (e)=>({ setState: setState })=>{
        const error = e instanceof Error ? e : new Error('Unknown error');
        (0, $9wfiI.sendErrorEvent)({
            error: error,
            actionSubject: 'fetchRequestTypeFields'
        });
        setState({
            error: error,
            loading: false
        });
    };
const $084adb832386829c$export$e324594224ef24da = {
    setRequestTypeFieldsMap: $084adb832386829c$var$setRequestTypeFieldsMap,
    setIsLoading: $084adb832386829c$var$setIsLoading,
    setError: $084adb832386829c$var$setError
};

});
parcelRegister("9wfiI", function(module, exports) {
$parcel$export(module.exports, "sendUIEvent", () => $0652a12628b00663$export$1aecf263098db667);
$parcel$export(module.exports, "sendTrackEvent", () => $0652a12628b00663$export$1ba525b8a711eaac);
$parcel$export(module.exports, "sendErrorEvent", () => $0652a12628b00663$export$c9036e6c0dcd8835);

var $aVQWM = parcelRequire("aVQWM");

var $6lbrU = parcelRequire("6lbrU");
const $0652a12628b00663$var$getVASource = ()=>{
    return `virtualAgent${0, $aVQWM.SCREEN}`;
};
const $0652a12628b00663$export$1aecf263098db667 = (event)=>{
    const analyticsClient = (0, $6lbrU.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendUIEvent({
        ...event,
        source: $0652a12628b00663$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send UI analytics event ${error}`);
    });
};
const $0652a12628b00663$export$22a3b1671f38a193 = ({ name: name, attributes: attributes })=>{
    const event = {
        name: name,
        attributes: {
            ...attributes,
            source: $0652a12628b00663$var$getVASource()
        }
    };
    const analyticsClient = (0, $6lbrU.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendScreenEvent(event).catch((error)=>{
        throw new Error(`Failure to send screen analytics event ${error}`);
    });
};
const $0652a12628b00663$export$1ba525b8a711eaac = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    const analyticsClient = (0, $6lbrU.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendTrackEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        source: $0652a12628b00663$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send track analytics event ${error}`);
    });
};
const $0652a12628b00663$export$e5f89b51c6d4e36b = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $0652a12628b00663$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        action: 'success'
    });
};
const $0652a12628b00663$export$c9036e6c0dcd8835 = ({ error: error, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $0652a12628b00663$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: 'failed',
        attributes: {
            ...attributes,
            error: error
        }
    });
};
const $0652a12628b00663$var$sendOperationalOrErrorAnalyticsEvent = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, action: action, attributes: attributes })=>{
    const analyticsClient = (0, $6lbrU.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendOperationalEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes,
        source: $0652a12628b00663$var$getVASource()
    }).catch((err)=>{
        throw new Error(`Failure to send operational analytics event ${err}`);
    });
};

});




parcelRegister("c6Gzm", function(module, exports) {
$parcel$export(module.exports, "SHORT_TEXT_FIELD_TYPE", () => $216925f6a82b4628$export$4351cd1d22652b1a);
$parcel$export(module.exports, "PARAGRAPH_FIELD_TYPE", () => $216925f6a82b4628$export$a66f2119b5091b7e);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_TYPE", () => $216925f6a82b4628$export$dbe52b9d883d2625);
$parcel$export(module.exports, "DATE_PICKER_FIELD_TYPE", () => $216925f6a82b4628$export$4a9ce2f29e91e07);
$parcel$export(module.exports, "getFieldType", () => $216925f6a82b4628$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isTextField", () => $216925f6a82b4628$export$1cda748695867c48);
const $216925f6a82b4628$export$4351cd1d22652b1a = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $216925f6a82b4628$export$a66f2119b5091b7e = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $216925f6a82b4628$export$dbe52b9d883d2625 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $216925f6a82b4628$export$4a9ce2f29e91e07 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $216925f6a82b4628$export$b9089a6e41ed43aa = (fieldId, data)=>{
    const field = data.get(fieldId);
    if (!field) return undefined;
    if ('custom' in field.jiraSchema) return field.jiraSchema.custom;
    return undefined;
};
const $216925f6a82b4628$export$1cda748695867c48 = (fieldId, data)=>{
    const fieldType = $216925f6a82b4628$export$b9089a6e41ed43aa(fieldId, data);
    return fieldType === $216925f6a82b4628$export$4351cd1d22652b1a || fieldType === $216925f6a82b4628$export$a66f2119b5091b7e;
};

});

parcelRegister("d04aK", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $edc79f96bf81023c$export$4d17e2d9c5348842);
$parcel$export(module.exports, "useIsLoading", () => $edc79f96bf81023c$export$4dface15d86304a4);
$parcel$export(module.exports, "useError", () => $edc79f96bf81023c$export$5027865de34f9ec6);
$parcel$export(module.exports, "useBaseUrl", () => $edc79f96bf81023c$export$d791fbc58bd47703);
$parcel$export(module.exports, "useFieldFromLastMessage", () => $edc79f96bf81023c$export$c011746629259c11);
$parcel$export(module.exports, "useIsLastMessage", () => $edc79f96bf81023c$export$cd2e50d12ce4b586);
$parcel$export(module.exports, "useConversationHasMessages", () => $edc79f96bf81023c$export$400cd0867e25f460);
$parcel$export(module.exports, "useActions", () => $edc79f96bf81023c$export$bc923229a7fa61e7);

var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");

var $7kHHp = parcelRequire("7kHHp");

var $1jmCw = parcelRequire("1jmCw");

var $kQjts = parcelRequire("kQjts");
const $edc79f96bf81023c$var$initialState = {
    conversationProvider: {
        sendMessage: ()=>Promise.reject(new Error('No conversation provider')),
        startConversation: ()=>Promise.reject(new Error('No conversation provider'))
    },
    messages: []
};
const $edc79f96bf81023c$var$store = (0, $ipn74.createStore)({
    actions: $7kHHp.actions,
    initialState: $edc79f96bf81023c$var$initialState,
    name: 'Conversation',
    containedBy: (0, $1jmCw.ConversationStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            },
        onContainerUpdate: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            }
    }
});
const $edc79f96bf81023c$export$4d17e2d9c5348842 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (state)=>state.messages
});
const $edc79f96bf81023c$export$4dface15d86304a4 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (state)=>state.isLoading
});
const $edc79f96bf81023c$export$5027865de34f9ec6 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (state)=>state.error
});
const $edc79f96bf81023c$export$d791fbc58bd47703 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (state)=>state.baseUrl
});
const $edc79f96bf81023c$export$de966b4845cf82cc = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (0, $kQjts.getAppendicesFromLastMessage)
});
const $edc79f96bf81023c$export$c011746629259c11 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (0, $kQjts.getJiraFieldFromLastMessage)
});
const $edc79f96bf81023c$export$314d3fbd2eb8690 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (0, $kQjts.getLastHelpseekerMessage)
});
const $edc79f96bf81023c$export$cd2e50d12ce4b586 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (0, $kQjts.getIsLastMessage)
});
const $edc79f96bf81023c$export$400cd0867e25f460 = (0, $5nVr1.createStateHook)($edc79f96bf81023c$var$store, {
    selector: (state)=>state.messages.length > 0
});
const $edc79f96bf81023c$export$bc923229a7fa61e7 = (0, $5nVr1.createActionsHook)($edc79f96bf81023c$var$store);

});
parcelRegister("7kHHp", function(module, exports) {
$parcel$export(module.exports, "actions", () => $037d63ed5cc624a5$export$e324594224ef24da);

var $gcgQT = parcelRequire("gcgQT");

var $bX75e = parcelRequire("bX75e");

var $fCsNB = parcelRequire("fCsNB");

var $AQBDQ = parcelRequire("AQBDQ");

var $KQrVv = parcelRequire("KQrVv");

var $52kFe = parcelRequire("52kFe");
const $037d63ed5cc624a5$export$e324594224ef24da = {
    addMessage: $bX75e.addMessage,
    selectOption: $52kFe.selectOption,
    clearConversation: $fCsNB.clearConversation,
    addJiraFieldMessage: $gcgQT.addJiraFieldMessage,
    retryLastHelpseekerMessage: $KQrVv.retryLastHelpseekerMessage,
    resetState: $AQBDQ.resetState
};

});
parcelRegister("gcgQT", function(module, exports) {
$parcel$export(module.exports, "addJiraFieldMessage", () => $93a8ea8694ec8f77$export$73f4cb8f39bccbbf);

var $8xKBm = parcelRequire("8xKBm");

var $ifJrP = parcelRequire("ifJrP");

var $9R9rZ = parcelRequire("9R9rZ");
const $93a8ea8694ec8f77$export$73f4cb8f39bccbbf = (fieldId, value, messageContent)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $ifJrP.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            content: messageContent || value,
            jiraField: {
                fieldId: fieldId,
                value: value
            }
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $8xKBm.intentAnswerExperience).start();
        return dispatch((0, $9R9rZ.sendHelpseekerMessage)(helpseekerMessage));
    };

});
parcelRegister("ifJrP", function(module, exports) {
$parcel$export(module.exports, "constructHelpseekerMessage", () => $4a7df130797101d2$export$8ea190576bc1c325);

var $4h23n = parcelRequire("4h23n");

var $j2vls = parcelRequire("j2vls");

var $f5LPR = parcelRequire("f5LPR");
const $4a7df130797101d2$export$8ea190576bc1c325 = (messageBody)=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId } = getState();
        const helpseekerMessage = {
            message: {
                ...messageBody,
                content: (0, $j2vls.doc)((0, $f5LPR.paragraph)(messageBody.content))
            },
            id: `client::${(0, $4h23n.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || ''
        };
        // add user message
        setState({
            isLoading: true,
            messages: [
                ...messages,
                helpseekerMessage
            ]
        });
        return helpseekerMessage;
    };

});
parcelRegister("4h23n", function(module, exports) {

var $7zFYh = parcelRequire("7zFYh");

var $enIjH = parcelRequire("enIjH");
var $31ca57bcb2693faa$var$uuid = $enIjH;
$31ca57bcb2693faa$var$uuid.v1 = $7zFYh;
$31ca57bcb2693faa$var$uuid.v4 = $enIjH;
module.exports = $31ca57bcb2693faa$var$uuid;

});
parcelRegister("7zFYh", function(module, exports) {

var $6pyXl = parcelRequire("6pyXl");

var $aDGD7 = parcelRequire("aDGD7");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $016c54102b4904fd$var$_nodeId;
var $016c54102b4904fd$var$_clockseq;
// Previous uuid creation time
var $016c54102b4904fd$var$_lastMSecs = 0;
var $016c54102b4904fd$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $016c54102b4904fd$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $016c54102b4904fd$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $016c54102b4904fd$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $6pyXl();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $016c54102b4904fd$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $016c54102b4904fd$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $016c54102b4904fd$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $016c54102b4904fd$var$_lastMSecs + (nsecs - $016c54102b4904fd$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $016c54102b4904fd$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $016c54102b4904fd$var$_lastMSecs = msecs;
    $016c54102b4904fd$var$_lastNSecs = nsecs;
    $016c54102b4904fd$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $aDGD7(b);
}
module.exports = $016c54102b4904fd$var$v1;

});
parcelRegister("6pyXl", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $4ab0316fa501f8fc$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($4ab0316fa501f8fc$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $4ab0316fa501f8fc$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $4ab0316fa501f8fc$var$getRandomValues($4ab0316fa501f8fc$var$rnds8);
        return $4ab0316fa501f8fc$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $4ab0316fa501f8fc$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $4ab0316fa501f8fc$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $4ab0316fa501f8fc$var$rnds;
    };
}

});

parcelRegister("aDGD7", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $7bee9d4e3b44a23b$var$byteToHex = [];
for(var $7bee9d4e3b44a23b$var$i = 0; $7bee9d4e3b44a23b$var$i < 256; ++$7bee9d4e3b44a23b$var$i)$7bee9d4e3b44a23b$var$byteToHex[$7bee9d4e3b44a23b$var$i] = ($7bee9d4e3b44a23b$var$i + 0x100).toString(16).substr(1);
function $7bee9d4e3b44a23b$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $7bee9d4e3b44a23b$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $7bee9d4e3b44a23b$var$bytesToUuid;

});


parcelRegister("enIjH", function(module, exports) {

var $6pyXl = parcelRequire("6pyXl");

var $aDGD7 = parcelRequire("aDGD7");
function $a785971268bef612$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $6pyXl)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $aDGD7(rnds);
}
module.exports = $a785971268bef612$var$v4;

});


parcelRegister("j2vls", function(module, exports) {
$parcel$export(module.exports, "doc", () => $641c86a301c92199$export$2a111da947c407d2);
const $641c86a301c92199$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("f5LPR", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $8a1f6de6ad773b68$export$9c206ddddb32a9b);

var $easPp = parcelRequire("easPp");
const $8a1f6de6ad773b68$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $easPp.createTextNodes)(content)
    });

});
parcelRegister("easPp", function(module, exports) {
$parcel$export(module.exports, "createTextNodes", () => $e4a06f22e386f53f$export$3a269a5941b62f04);

var $iTdsV = parcelRequire("iTdsV");
function $e4a06f22e386f53f$export$3a269a5941b62f04(nodes) {
    return nodes.map((0, $iTdsV.createTextFromString));
}

});
parcelRegister("iTdsV", function(module, exports) {
$parcel$export(module.exports, "createTextFromString", () => $bd2e6e63b41df800$export$72b9432ea0656b50);

var $2VxTd = parcelRequire("2VxTd");
function $bd2e6e63b41df800$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $2VxTd.text)(str) : str;
}

});
parcelRegister("2VxTd", function(module, exports) {
$parcel$export(module.exports, "text", () => $1b0370d725dd4793$export$6f093cfa640b7166);
const $1b0370d725dd4793$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});





parcelRegister("9R9rZ", function(module, exports) {
$parcel$export(module.exports, "sendHelpseekerMessage", () => $18fb26a3d759ad86$export$78d52c3c7b67d769);

var $aYMdQ = parcelRequire("aYMdQ");

var $bHG0Y = parcelRequire("bHG0Y");

var $9wfiI = parcelRequire("9wfiI");

var $8xKBm = parcelRequire("8xKBm");

var $71ljT = parcelRequire("71ljT");
const $18fb26a3d759ad86$export$78d52c3c7b67d769 = (message)=>({ getState: getState, setState: setState, dispatch: dispatch }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent, abortController: abortController } = getState();
        if (!conversationId || !abortController) {
            dispatch((0, $71ljT.sendMessageErrorHandler)());
            return;
        }
        conversationProvider.sendMessage(message, abortController.signal).then(async (response)=>{
            var _last;
            // https://data-portal.internal.atlassian.com/analytics/registry/65969
            (0, $9wfiI.sendTrackEvent)({
                action: 'sent',
                actionSubject: 'conversationMessage',
                actionSubjectId: conversationId,
                attributes: {
                    conversationId: conversationId,
                    contextId: contextId,
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $8xKBm.initialIntentMessageExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $8xKBm.intentAnswerExperience).success();
            if (handleEscalateFromVirtualAgent && response.length && response[response.length - 1].conversationState === 'escalated') {
                handleEscalateFromVirtualAgent();
                return;
            }
            if ((_last = (0, $aYMdQ.last)(response)) !== null && _last !== void 0 && _last.shouldHandoff) {
                const { messages: messages } = getState();
                if (handleHandOff) await handleHandOff(messages, conversationId, contextId);
                const metricMetaData = {
                    contextId: contextId,
                    conversationId: conversationId,
                    handOff: true,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $8xKBm.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $8xKBm.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $bHG0Y.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $bHG0Y.initialAIAnswerExperience).start();
                return;
            }
            for(let i = 0; i < response.length; i++)setTimeout(()=>{
                const { messages: newMessages } = getState();
                setState({
                    messages: newMessages.concat(response[i])
                });
            }, 500 * i); // 500ms delay between each message
        }).catch(()=>{
            dispatch((0, $71ljT.sendMessageErrorHandler)());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $8xKBm.initialIntentMessageExperience).failure();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $8xKBm.intentAnswerExperience).failure();
        }).finally(()=>setState({
                isLoading: false
            }));
    };

});
parcelRegister("bHG0Y", function(module, exports) {
$parcel$export(module.exports, "AIAnswerExperience", () => $9ada5f5081e484d3$export$1b78ddffe984ff3a);
$parcel$export(module.exports, "initialAIAnswerExperience", () => $9ada5f5081e484d3$export$7cb0088260227065);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $9ada5f5081e484d3$var$AIAnswerExperienceId = 'service-management.help-center.ai-message';
const $9ada5f5081e484d3$var$initialAIAnswerExperienceId = 'service-management.help-center.ai-initial-message-reply';
const $9ada5f5081e484d3$export$1b78ddffe984ff3a = new (0, $9LFKj.UFOExperience)($9ada5f5081e484d3$var$AIAnswerExperienceId, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $9ada5f5081e484d3$export$7cb0088260227065 = new (0, $9LFKj.UFOExperience)($9ada5f5081e484d3$var$initialAIAnswerExperienceId, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("71ljT", function(module, exports) {
$parcel$export(module.exports, "sendMessageErrorHandler", () => $ff54ecfba4e42d58$export$30fe8f944e81bd35);

var $4h23n = parcelRequire("4h23n");

var $9wfiI = parcelRequire("9wfiI");
const $ff54ecfba4e42d58$export$30fe8f944e81bd35 = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId } = getState();
        // https://data-portal.internal.atlassian.com/analytics/registry/65971
        (0, $9wfiI.sendTrackEvent)({
            action: 'failed',
            actionSubject: 'conversationSendMessage',
            actionSubjectId: conversationId || '',
            attributes: {
                conversationId: conversationId,
                contextId: contextId,
                portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
            }
        });
        const errorMessage = {
            id: `client::${(0, $4h23n.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || '',
            message: {
                authorType: 'ERROR'
            }
        };
        setState({
            messages: [
                ...messages,
                errorMessage
            ]
        });
    };

});



parcelRegister("bX75e", function(module, exports) {
$parcel$export(module.exports, "addMessage", () => $4bed0f316fc29c21$export$16fdb433d434f08);

var $ifJrP = parcelRequire("ifJrP");

var $9R9rZ = parcelRequire("9R9rZ");

var $iUtbe = parcelRequire("iUtbe");
const $4bed0f316fc29c21$export$180697e5b334e664 = (message)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { conversationId: conversationId } = getState();
        try {
            const helpseekerMessage = dispatch((0, $ifJrP.constructHelpseekerMessage)({
                authorType: 'HELPSEEKER',
                content: message
            }));
            // start new conversation if no conversation id
            if (!conversationId) {
                const newConversationId = await dispatch((0, $iUtbe.startConversation)(helpseekerMessage));
                if (!newConversationId) throw new Error('A conversation id for this conversation already exists.');
                helpseekerMessage.conversationChannelId = newConversationId;
            }
            return dispatch((0, $9R9rZ.sendHelpseekerMessage)(helpseekerMessage));
        } catch (error) {
            setState({
                isLoading: false
            });
            return undefined;
        }
    };
const $4bed0f316fc29c21$export$16fdb433d434f08 = (message)=>({ dispatch: dispatch })=>{
        dispatch($4bed0f316fc29c21$export$180697e5b334e664(message)).catch(()=>{
            return undefined;
        });
    };

});
parcelRegister("iUtbe", function(module, exports) {
$parcel$export(module.exports, "startConversation", () => $d011b79ae2a8b3b7$export$263d31a093aceb09);

var $bHG0Y = parcelRequire("bHG0Y");

var $9wfiI = parcelRequire("9wfiI");

var $8xKBm = parcelRequire("8xKBm");
const $d011b79ae2a8b3b7$export$263d31a093aceb09 = (helpseekerMessage)=>async ({ getState: getState, setState: setState }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { projectId: projectId, portalId: portalId, contextId: contextId } = getState();
        const abortController = new AbortController();
        setState({
            abortController: abortController
        });
        const handleError = (error)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/65973
            (0, $9wfiI.sendTrackEvent)({
                action: 'failed',
                actionSubject: 'startConversation',
                attributes: {
                    contextId: contextId,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            setState({
                error: error
            });
            throw new Error(error);
        };
        try {
            const response = await conversationProvider.startConversation(abortController.signal, helpseekerMessage === null || helpseekerMessage === void 0 ? void 0 : helpseekerMessage.message);
            if (abortController.signal.aborted) return undefined;
            if (!(response !== null && response !== void 0 && response.id)) throw Error('No conversation id.');
            // https://data-portal.internal.atlassian.com/analytics/registry/65970
            (0, $9wfiI.sendTrackEvent)({
                action: 'started',
                actionSubject: 'conversation',
                actionSubjectId: response.id,
                attributes: {
                    contextId: contextId,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            if (response.shouldHandoff && handleHandOff) {
                const messages = helpseekerMessage ? [
                    helpseekerMessage
                ] : [];
                const metricMetaData = {
                    contextId: contextId,
                    handOff: true,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $8xKBm.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $8xKBm.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $bHG0Y.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $bHG0Y.initialAIAnswerExperience).start();
                return handleHandOff(messages, response.id, contextId);
            }
            setState({
                conversationId: response.id
            });
            return response.id;
        } catch (error) {
            if (error instanceof Error) return handleError(error.message);
            return handleError('Failed to start conversation.');
        }
    };

});


parcelRegister("fCsNB", function(module, exports) {
$parcel$export(module.exports, "clearConversation", () => $831aebf9ccffa1f9$export$2c9f6ca76cd8a6bc);

var $9wfiI = parcelRequire("9wfiI");
const $831aebf9ccffa1f9$export$2c9f6ca76cd8a6bc = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, abortController: abortController } = getState();
        if (!messages.length && !conversationId) return;
        // https://data-portal.internal.atlassian.com/analytics/registry/69030
        (0, $9wfiI.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'clearConversationButton'
        });
        if (abortController) abortController.abort();
        setState({
            messages: [],
            conversationId: undefined,
            isLoading: false,
            abortController: undefined
        });
    };

});

parcelRegister("AQBDQ", function(module, exports) {
$parcel$export(module.exports, "resetState", () => $b4ac7cfc10559b5f$export$8e84bad0b35de9e8);
const $b4ac7cfc10559b5f$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
        setState({
            conversationProvider: conversationProvider,
            portalId: portalId,
            projectId: projectId,
            contextId: contextId,
            baseUrl: baseUrl,
            isTestConversation: isTestConversation,
            handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
        });
    };

});

parcelRegister("KQrVv", function(module, exports) {
$parcel$export(module.exports, "retryLastHelpseekerMessage", () => $40d139c672800a34$export$f34b435044a39700);

var $4h23n = parcelRequire("4h23n");

var $kQjts = parcelRequire("kQjts");

var $9R9rZ = parcelRequire("9R9rZ");
const $40d139c672800a34$export$f34b435044a39700 = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const state = getState();
        const lastMessage = (0, $kQjts.getLastHelpseekerMessage)(state);
        if (!lastMessage) return;
        const retryMessage = {
            ...lastMessage,
            id: `client::${(0, $4h23n.v4)()}`,
            timeCreated: new Date().toISOString()
        };
        setState({
            isLoading: true,
            messages: [
                ...state.messages,
                retryMessage
            ]
        });
        dispatch((0, $9R9rZ.sendHelpseekerMessage)(retryMessage));
    };

});
parcelRegister("kQjts", function(module, exports) {
$parcel$export(module.exports, "getAppendicesFromLastMessage", () => $a758c3ec8ba9e1f4$export$3d8caa938a084e16);
$parcel$export(module.exports, "getJiraFieldFromLastMessage", () => $a758c3ec8ba9e1f4$export$84b2c2cda37f9350);
$parcel$export(module.exports, "getLastHelpseekerMessage", () => $a758c3ec8ba9e1f4$export$1596bd9bbfc2b67c);
$parcel$export(module.exports, "getIsLastMessage", () => $a758c3ec8ba9e1f4$export$660eeeb2ec021068);

var $aYMdQ = parcelRequire("aYMdQ");
const $a758c3ec8ba9e1f4$export$3d8caa938a084e16 = (state)=>{
    const lastMessage = (0, $aYMdQ.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) === 'AGENT') return lastMessage.message.appendices;
    return undefined;
};
const $a758c3ec8ba9e1f4$export$84b2c2cda37f9350 = (state)=>{
    const lastMessage = (0, $aYMdQ.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) !== 'AGENT' || !(lastMessage !== null && lastMessage !== void 0 && lastMessage.message.appendices)) return undefined;
    const jiraField = lastMessage.message.appendices.find((appendix)=>appendix.type === 'JIRA_FIELD');
    return jiraField;
};
const $a758c3ec8ba9e1f4$export$1596bd9bbfc2b67c = (state)=>(0, $aYMdQ.findLast)(state.messages, (message)=>message.message.authorType === 'HELPSEEKER');
const $a758c3ec8ba9e1f4$export$660eeeb2ec021068 = (state, messageId)=>{
    var _findLast;
    return messageId === ((_findLast = (0, $aYMdQ.findLast)(state.messages)) === null || _findLast === void 0 ? void 0 : _findLast.id);
};

});


parcelRegister("52kFe", function(module, exports) {
$parcel$export(module.exports, "selectOption", () => $2147c60fa0076f5c$export$f6a817e077493ad8);

var $8xKBm = parcelRequire("8xKBm");

var $ifJrP = parcelRequire("ifJrP");

var $9R9rZ = parcelRequire("9R9rZ");
const $2147c60fa0076f5c$export$f6a817e077493ad8 = (option)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $ifJrP.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            optionId: option.id,
            content: option.label || ''
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $8xKBm.intentAnswerExperience).start();
        return dispatch((0, $9R9rZ.sendHelpseekerMessage)(helpseekerMessage));
    };

});


parcelRegister("1jmCw", function(module, exports) {
$parcel$export(module.exports, "ConversationStateContainer", () => $bb8c7439f42dc3d0$export$2d1cf1e83cc748b3);

var $ik3UL = parcelRequire("ik3UL");
const $bb8c7439f42dc3d0$export$2d1cf1e83cc748b3 = (0, $ik3UL.createContainer)();

});



parcelRegister("crB7D", function(module, exports) {
$parcel$export(module.exports, "useProvider", () => $357f38eb516feec3$export$693cdb10cec23617);
$parcel$export(module.exports, "useIsRouting", () => $357f38eb516feec3$export$f2eec64eca530862);
$parcel$export(module.exports, "useActions", () => $357f38eb516feec3$export$bc923229a7fa61e7);

var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");

var $etQ17 = parcelRequire("etQ17");

var $6VOp7 = parcelRequire("6VOp7");

var $3Cfsu = parcelRequire("3Cfsu");
const $357f38eb516feec3$var$initialState = {
    provider: (0, $etQ17.ConversationProvider).VIRTUAL_AGENT,
    contextId: '',
    isRouting: false
};
const $357f38eb516feec3$var$store = (0, $ipn74.createStore)({
    initialState: $357f38eb516feec3$var$initialState,
    actions: {
        setProvider: $6VOp7.setProvider,
        resetState: $6VOp7.resetState
    },
    name: 'VIRTUAL_AGENT_ROUTING',
    containedBy: (0, $3Cfsu.RoutingStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { contextId: contextId })=>{
                setState({
                    contextId: contextId
                });
            }
    }
});
const $357f38eb516feec3$export$693cdb10cec23617 = (0, $5nVr1.createStateHook)($357f38eb516feec3$var$store, {
    selector: (state)=>state.provider
});
const $357f38eb516feec3$export$f2eec64eca530862 = (0, $5nVr1.createStateHook)($357f38eb516feec3$var$store, {
    selector: (state)=>state.isRouting
});
const $357f38eb516feec3$export$bc923229a7fa61e7 = (0, $5nVr1.createActionsHook)($357f38eb516feec3$var$store);

});
parcelRegister("etQ17", function(module, exports) {
$parcel$export(module.exports, "ASSISTANT_MESSAGE_STATUS", () => $e96b6d27d24b6eef$export$75eb63d2758dd11a);
$parcel$export(module.exports, "FeedbackType", () => $e96b6d27d24b6eef$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ChannelMessageTypes", () => $e96b6d27d24b6eef$export$2468909fd00fe251);
$parcel$export(module.exports, "ConversationProvider", () => $e96b6d27d24b6eef$export$1c69fe0757d799c5);
var $e96b6d27d24b6eef$export$75eb63d2758dd11a = /*#__PURE__*/ function(ASSISTANT_MESSAGE_STATUS) {
    ASSISTANT_MESSAGE_STATUS["IDLE"] = "idle";
    ASSISTANT_MESSAGE_STATUS["LOADING_RESPONSE"] = "loadingResponse";
    ASSISTANT_MESSAGE_STATUS["AWAITING_RESPONSE"] = "awaitingResponse";
    ASSISTANT_MESSAGE_STATUS["TYPING_RESPONSE"] = "typingResponse";
    ASSISTANT_MESSAGE_STATUS["ABORTED_RESPONSE"] = "abortedResponse";
    ASSISTANT_MESSAGE_STATUS["SYNCED_RESPONSE"] = "syncedResponse";
    return ASSISTANT_MESSAGE_STATUS;
}({});
var $e96b6d27d24b6eef$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["POSITIVE"] = "positive";
    FeedbackType["NEGATIVE"] = "negative";
    return FeedbackType;
}({});
var $e96b6d27d24b6eef$export$2468909fd00fe251 = /*#__PURE__*/ function(ChannelMessageTypes) {
    ChannelMessageTypes["CHANNEL_FAILURE"] = "CHANNEL_FAILURE";
    ChannelMessageTypes["CHANNEL_EXPIRY"] = "CHANNEL_EXPIRY";
    ChannelMessageTypes["CHANNEL_CONVERSATION_OVER"] = "CHANNEL_CONVERSATION_OVER";
    return ChannelMessageTypes;
}({});
const $e96b6d27d24b6eef$export$1c69fe0757d799c5 = {
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
    AI_ANSWERS: 'AI_ANSWERS'
};

});

parcelRegister("6VOp7", function(module, exports) {
$parcel$export(module.exports, "setProvider", () => $6f5d680bbf86e15a$export$1572b3eade6662f9);
$parcel$export(module.exports, "resetState", () => $6f5d680bbf86e15a$export$8e84bad0b35de9e8);

var $etQ17 = parcelRequire("etQ17");
const $6f5d680bbf86e15a$export$1572b3eade6662f9 = (provider)=>({ setState: setState })=>setState({
            provider: provider
        });
const $6f5d680bbf86e15a$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { contextId: contextId })=>{
        setState({
            contextId: contextId,
            provider: (0, $etQ17.ConversationProvider).VIRTUAL_AGENT,
            isRouting: false
        });
    };

});

parcelRegister("3Cfsu", function(module, exports) {
$parcel$export(module.exports, "RoutingStateContainer", () => $b473a653143f7d11$export$92282a62d0a1b5d4);

var $ik3UL = parcelRequire("ik3UL");
const $b473a653143f7d11$export$92282a62d0a1b5d4 = (0, $ik3UL.createContainer)();

});


parcelRegister("6BbQe", function(module, exports) {
$parcel$export(module.exports, "useConversation", () => $7158e3260ead3075$export$626f7ff9a7747889);
$parcel$export(module.exports, "useConversationId", () => $7158e3260ead3075$export$27499dbe4de0e477);
$parcel$export(module.exports, "useConversationActions", () => $7158e3260ead3075$export$325b6e88f398f098);
$parcel$export(module.exports, "useIsTesting", () => $7158e3260ead3075$export$6747b41fb9e7b49a);
$parcel$export(module.exports, "useFeedbackCollectorConfig", () => $7158e3260ead3075$export$f0e236cf8822a84c);
$parcel$export(module.exports, "useIsChannelErrorPresent", () => $7158e3260ead3075$export$adfa38c4df66c906);
$parcel$export(module.exports, "getMessageFeedback", () => $7158e3260ead3075$export$ee9551cc487e053e);
$parcel$export(module.exports, "getCsatScore", () => $7158e3260ead3075$export$df253d0caf8deb0d);
$parcel$export(module.exports, "getLastMessageId", () => $7158e3260ead3075$export$63f3452801f9da26);
$parcel$export(module.exports, "useIsLastAssistantMessageGenerated", () => $7158e3260ead3075$export$dbf2a467a43e692a);
$parcel$export(module.exports, "useActions", () => $7158e3260ead3075$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useIsLastMessageFromHelpSeeker", () => $7158e3260ead3075$export$c095b9ac465c114e);
$parcel$export(module.exports, "useIsFeedbackSkipped", () => $7158e3260ead3075$export$d82a5ee85cfb7890);
$parcel$export(module.exports, "useIsCsatSkipped", () => $7158e3260ead3075$export$df5c667a37af1373);

var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");

var $etQ17 = parcelRequire("etQ17");

var $kTtUv = parcelRequire("kTtUv");

var $jnZ2v = parcelRequire("jnZ2v");
const $7158e3260ead3075$var$store = (0, $ipn74.createStore)({
    initialState: $jnZ2v.initialState,
    actions: {
        fetchChannelId: $kTtUv.fetchChannelId,
        startNewConversation: $kTtUv.startNewConversation,
        onPipelineChange: $kTtUv.onPipelineChange,
        setTesting: $kTtUv.setTesting,
        setConversationScrollBarWidth: $kTtUv.setConversationScrollBarWidth,
        recordFeedbackForConversation: $kTtUv.recordFeedbackForConversation,
        refetchConversation: $kTtUv.refetchConversation,
        addHelpseekerMessage: $kTtUv.addHelpseekerMessage,
        addHelpseekerMessageOnlyForUI: $kTtUv.addHelpseekerMessageOnlyForUI,
        addFeedbackResponseOnlyForUI: $kTtUv.addFeedbackResponseOnlyForUI,
        addRetryMessageOnlyForUI: $kTtUv.addRetryMessageOnlyForUI,
        setFeedbackCollectorConfig: $kTtUv.setFeedbackCollectorConfig,
        clearConversation: $kTtUv.clearConversation,
        abortConversation: $kTtUv.abortConversation,
        takeOverConversationFromVA: $kTtUv.takeOverConversationFromVA,
        addCsatResponseOnlyForUI: $kTtUv.addCsatResponseOnlyForUI
    },
    name: 'CONVERSE'
});
const $7158e3260ead3075$export$626f7ff9a7747889 = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>state.conversation
});
const $7158e3260ead3075$export$27499dbe4de0e477 = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>{
        var _state$conversation;
        return (_state$conversation = state.conversation) === null || _state$conversation === void 0 ? void 0 : _state$conversation.conversationId;
    }
});
const $7158e3260ead3075$export$325b6e88f398f098 = (0, $5nVr1.createActionsHook)($7158e3260ead3075$var$store);
const $7158e3260ead3075$export$6747b41fb9e7b49a = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>state.isTesting
});
const $7158e3260ead3075$export$f0e236cf8822a84c = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>state.feedbackCollectorConfig
});
const $7158e3260ead3075$var$findBotOrAssistantMessage = (messageId)=>(chatMessage)=>{
        return chatMessage && chatMessage.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) && chatMessage.messageMetadata.messageId === messageId;
    };
const $7158e3260ead3075$export$adfa38c4df66c906 = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>{
        if (!state.conversation) return false;
        const lastMessage = state.conversation.history.slice(-1)[0];
        return (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.userType) === 'channelMessage';
    }
});
const $7158e3260ead3075$export$ee9551cc487e053e = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation2;
        const message = (_state$conversation2 = state.conversation) === null || _state$conversation2 === void 0 ? void 0 : _state$conversation2.history.find($7158e3260ead3075$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.messageFeedback : undefined;
    }
});
const $7158e3260ead3075$export$df253d0caf8deb0d = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation3;
        const message = (_state$conversation3 = state.conversation) === null || _state$conversation3 === void 0 ? void 0 : _state$conversation3.history.find($7158e3260ead3075$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.csatScore : undefined;
    }
});
const $7158e3260ead3075$var$findHelpSeekerOrAssistantMessage = (chatMessage)=>{
    return chatMessage && (chatMessage.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) || chatMessage.userType === (0, $jnZ2v.HELP_SEEKER_USER_TYPE));
};
const $7158e3260ead3075$export$63f3452801f9da26 = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>{
        var _state$conversation4;
        const message = (_state$conversation4 = state.conversation) === null || _state$conversation4 === void 0 ? void 0 : _state$conversation4.history.filter($7158e3260ead3075$var$findHelpSeekerOrAssistantMessage).at(-1);
        return message && 'messageMetadata' in message ? message.messageMetadata.messageId : undefined;
    }
});
const $7158e3260ead3075$export$dbf2a467a43e692a = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>{
        const { conversation: conversation, isLoading: isLoading } = state;
        const lastMessage = conversation === null || conversation === void 0 ? void 0 : conversation.history.slice(-1)[0];
        const storeAbortController = conversation === null || conversation === void 0 ? void 0 : conversation.storeAbortController;
        if (lastMessage && lastMessage.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) && storeAbortController) {
            const { messageMetadata: { status: status } } = lastMessage;
            if (!status) return false;
            return [
                (0, $etQ17.ASSISTANT_MESSAGE_STATUS).IDLE,
                (0, $etQ17.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
            ].indexOf(status) !== -1 && !isLoading;
        }
        return true;
    }
});
const $7158e3260ead3075$export$bc923229a7fa61e7 = (0, $5nVr1.createActionsHook)($7158e3260ead3075$var$store);
const $7158e3260ead3075$export$c095b9ac465c114e = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state)=>{
        var _state$conversation5, _state$conversation6;
        return(// After first message, conversation is an object but has no history
        // To stop the user from sending another message here, we are waiting for history array to be filled
        ((_state$conversation5 = state.conversation) === null || _state$conversation5 === void 0 ? void 0 : _state$conversation5.history.length) === 0 || ((_state$conversation6 = state.conversation) === null || _state$conversation6 === void 0 || (_state$conversation6 = _state$conversation6.history.slice(-1)[0]) === null || _state$conversation6 === void 0 ? void 0 : _state$conversation6.userType) === (0, $jnZ2v.HELP_SEEKER_USER_TYPE));
    }
});
const $7158e3260ead3075$export$d82a5ee85cfb7890 = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation7;
        const message = (_state$conversation7 = state.conversation) === null || _state$conversation7 === void 0 ? void 0 : _state$conversation7.history.find($7158e3260ead3075$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.isFeedbackSkipped : undefined;
    }
});
const $7158e3260ead3075$export$df5c667a37af1373 = (0, $5nVr1.createHook)($7158e3260ead3075$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation8;
        const message = (_state$conversation8 = state.conversation) === null || _state$conversation8 === void 0 ? void 0 : _state$conversation8.history.find($7158e3260ead3075$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.isCsatSkipped : undefined;
    }
});

});
parcelRegister("kTtUv", function(module, exports) {
$parcel$export(module.exports, "fetchChannelId", () => $bd7a3bb4782f2731$export$92b5f8fb222eed7e);
$parcel$export(module.exports, "startNewConversation", () => $bd7a3bb4782f2731$export$ec10fd022bf0d0a1);
$parcel$export(module.exports, "addHelpseekerMessageOnlyForUI", () => $bd7a3bb4782f2731$export$7d26299426387884);
$parcel$export(module.exports, "onPipelineChange", () => $bd7a3bb4782f2731$export$5690758dea68962c);
$parcel$export(module.exports, "setTesting", () => $bd7a3bb4782f2731$export$c0371739272785cf);
$parcel$export(module.exports, "setConversationScrollBarWidth", () => $bd7a3bb4782f2731$export$3549374a7ffc1e0f);
$parcel$export(module.exports, "recordFeedbackForConversation", () => $bd7a3bb4782f2731$export$d775316ddbd97650);
$parcel$export(module.exports, "refetchConversation", () => $bd7a3bb4782f2731$export$f84e8215cf018fc2);
$parcel$export(module.exports, "addHelpseekerMessage", () => $bd7a3bb4782f2731$export$39e5a890dd0d70ff);
$parcel$export(module.exports, "addFeedbackResponseOnlyForUI", () => $bd7a3bb4782f2731$export$8bc7344bcdeb6569);
$parcel$export(module.exports, "addCsatResponseOnlyForUI", () => $bd7a3bb4782f2731$export$193f22ef45a60fb9);
$parcel$export(module.exports, "addRetryMessageOnlyForUI", () => $bd7a3bb4782f2731$export$2024ac9dac025c83);
$parcel$export(module.exports, "setFeedbackCollectorConfig", () => $bd7a3bb4782f2731$export$5e2723610064e2d9);
$parcel$export(module.exports, "clearConversation", () => $bd7a3bb4782f2731$export$2c9f6ca76cd8a6bc);
$parcel$export(module.exports, "abortConversation", () => $bd7a3bb4782f2731$export$882bd6a6d00830a0);
$parcel$export(module.exports, "takeOverConversationFromVA", () => $bd7a3bb4782f2731$export$9ff6f230516497d2);
/* eslint-disable @typescript-eslint/require-await */ 
var $hN5YJ = parcelRequire("hN5YJ");

var $j2vls = parcelRequire("j2vls");

var $f5LPR = parcelRequire("f5LPR");

var $6r9Ft = parcelRequire("6r9Ft");

var $fgUje = parcelRequire("fgUje");

var $bHG0Y = parcelRequire("bHG0Y");

var $etQ17 = parcelRequire("etQ17");

var $hf5yS = parcelRequire("hf5yS");

var $25NE3 = parcelRequire("25NE3");

var $lFfXl = parcelRequire("lFfXl");

var $e3lmc = parcelRequire("e3lmc");

var $1T7Wz = parcelRequire("1T7Wz");

var $ce1c2 = parcelRequire("ce1c2");

var $gCyLn = parcelRequire("gCyLn");

var $lmdBP = parcelRequire("lmdBP");

var $4s5nM = parcelRequire("4s5nM");

var $1nqlT = parcelRequire("1nqlT");

var $creqK = parcelRequire("creqK");

var $kZaOC = parcelRequire("kZaOC");

var $jnZ2v = parcelRequire("jnZ2v");
const $bd7a3bb4782f2731$var$CHANNEL_EXPIRY_TIME = 300000; // 5mins
const $bd7a3bb4782f2731$var$ONE_DAY = 86400000; // 24 Hours
const $bd7a3bb4782f2731$var$getChannelExpiryTime = ()=>{
    return (0, $hN5YJ.isAiAnswer24HourTimeoutEnabled)() ? $bd7a3bb4782f2731$var$ONE_DAY : $bd7a3bb4782f2731$var$CHANNEL_EXPIRY_TIME;
};
const $bd7a3bb4782f2731$export$92b5f8fb222eed7e = (vaConversationId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        try {
            var _getState$conversatio;
            const channelId = await (0, $hf5yS.getChannelId)();
            const history = ((_getState$conversatio = getState().conversation) === null || _getState$conversatio === void 0 ? void 0 : _getState$conversatio.history) || [];
            dispatch($bd7a3bb4782f2731$var$resetTimer(channelId));
            if (channelId) setState({
                isLoading: false,
                conversation: {
                    conversationId: channelId,
                    externalConversationId: vaConversationId,
                    history: [
                        ...history
                    ]
                }
            });
            else throw new Error('No channel id!');
        } catch (e) {
            await dispatch($bd7a3bb4782f2731$var$addChannelMessage((0, $etQ17.ChannelMessageTypes).CHANNEL_EXPIRY));
        }
    };
const $bd7a3bb4782f2731$var$resetTimer = (channelId, timer = $bd7a3bb4782f2731$var$getChannelExpiryTime())=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const currentTimer = getState().activeTimer;
        const analyticsClient = (0, $1nqlT.getAnalyticsWebClient)();
        if (currentTimer) clearTimeout(currentTimer);
        const activeTimer = setTimeout(()=>{
            dispatch($bd7a3bb4782f2731$var$cleanFollowUps());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            dispatch($bd7a3bb4782f2731$var$addChannelMessage((0, $etQ17.ChannelMessageTypes).CHANNEL_EXPIRY));
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhConversationScreen',
                action: 'expired',
                actionSubject: 'conversation',
                attributes: {
                    conversationId: channelId,
                    ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
                }
            });
        }, timer);
        setState({
            activeTimer: activeTimer
        });
    };
const $bd7a3bb4782f2731$export$ec10fd022bf0d0a1 = (term)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        setState({
            isLoading: true,
            conversation: {
                conversationId: null,
                history: []
            }
        });
        await dispatch($bd7a3bb4782f2731$export$92b5f8fb222eed7e());
        const conversation = getState().conversation;
        if (conversation && conversation.conversationId) {
            dispatch($bd7a3bb4782f2731$export$7d26299426387884(term));
            /**
     * Mark conversation start when the first conversation message is sent
     */ setState({
                conversationStartTime: Date.now()
            });
            dispatch($bd7a3bb4782f2731$var$fetchConversation(term));
        }
    };
const $bd7a3bb4782f2731$export$5690758dea68962c = (pipeline)=>async ({ setState: setState })=>{
        setState({
            pipeline: pipeline
        });
    };
const $bd7a3bb4782f2731$export$c0371739272785cf = (isTesting)=>async ({ setState: setState })=>{
        setState({
            isTesting: isTesting
        });
    };
const $bd7a3bb4782f2731$export$3549374a7ffc1e0f = (conversationScrollBarWidth)=>({ setState: setState })=>{
        setState({
            ui: {
                conversationScrollBarWidth: conversationScrollBarWidth
            }
        });
    };
const $bd7a3bb4782f2731$var$addChannelMessage = (type)=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            conversationId: null,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'channelMessage',
                    messageType: type
                }
            ]
        };
        setState({
            conversation: conversation,
            isLoading: false
        });
    };
const $bd7a3bb4782f2731$export$d775316ddbd97650 = (id, { feedbackLabel: feedbackLabel, feedbackType: feedbackType, detailedFeedback: detailedFeedback })=>async ({ getState: getState, setState: setState })=>{
        const analyticsClient = (0, $1nqlT.getAnalyticsWebClient)();
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        (0, $25NE3.storeFeedback)({
            feedbackLabel: feedbackLabel,
            channelId: conversation.conversationId,
            messageId: id,
            feedback: feedbackType === (0, $etQ17.FeedbackType).POSITIVE ? 'LIKE' : 'DISLIKE'
        }).catch(()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhAiMateFeedbackRequest',
                action: 'feedbackRequestFailed',
                actionSubject: 'feedback',
                actionSubjectId: conversation.conversationId || '',
                attributes: {
                    isAiMate: true,
                    ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
                }
            });
        });
        const updatedConversationHistory = conversation.history.map((message)=>{
            if (message.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE)) {
                const { messageId: messageId } = message.messageMetadata;
                if (messageId && messageId === id) return {
                    ...message,
                    messageMetadata: {
                        ...message.messageMetadata,
                        messageFeedback: {
                            feedbackType: feedbackType,
                            feedbackLabel: feedbackLabel,
                            detailedFeedback: detailedFeedback
                        }
                    }
                };
            }
            return message;
        });
        const updatedConversation = {
            ...conversation,
            history: updatedConversationHistory
        };
        setState({
            conversation: updatedConversation
        });
    };
const $bd7a3bb4782f2731$var$getDefaultErrorState = (conversation)=>{
    let updatedConversationHistory = conversation.history;
    const lastMessageUserType = conversation.history[conversation.history.length - 1].userType;
    if (lastMessageUserType === (0, $jnZ2v.ASSISTANT_USER_TYPE)) updatedConversationHistory = updatedConversationHistory.slice(0, -1);
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            {
                userType: 'error'
            }
        ]
    };
};
const $bd7a3bb4782f2731$export$f84e8215cf018fc2 = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        var _helpSeekerMessages$m;
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) return;
        const history = conversation.history;
        const helpSeekerMessages = history.filter((chatMessage)=>chatMessage.userType === (0, $jnZ2v.HELP_SEEKER_USER_TYPE));
        const term = (_helpSeekerMessages$m = helpSeekerMessages[helpSeekerMessages.length - 1].messageMetadata) === null || _helpSeekerMessages$m === void 0 ? void 0 : _helpSeekerMessages$m.originalQuery;
        if (term) dispatch($bd7a3bb4782f2731$var$fetchConversation(term));
    };
const $bd7a3bb4782f2731$var$fetchConversation = (message)=>async ({ getState: getState, setState: setState })=>{
        var _metadata, _metadata2, _metadata3, _metadata4, _metadata5, _metadata6, _metadata7;
        const { conversation: conversation } = getState();
        const analyticsClient = (0, $1nqlT.getAnalyticsWebClient)();
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        if (conversation.storeAbortController) // Silently aborting if there is another operation in progress
        return;
        try {
            const { storeAbortController: storeAbortController } = (0, $4s5nM.createStoreAbortController)();
            setState({
                isLoading: true
            });
            (0, $creqK.sendUIEventForAskedQuestion)(analyticsClient, conversation.conversationId, conversation.history.length, message.length, conversation.externalConversationId);
            const answerId = (0, $lFfXl.genIntId)();
            let assistantMessage = (0, $e3lmc.initialAssistantMessage)(answerId);
            let generator;
            let isAnswerPartAnalyticsFired = false;
            let isFallbackMessage = false;
            const startTime = performance.now();
            let finishTime;
            try {
                generator = await (0, $hf5yS.sendMessageStream)(message, conversation.conversationId, storeAbortController);
            } catch (e) {
                setState({
                    conversation: $bd7a3bb4782f2731$var$getDefaultErrorState(conversation)
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                analyticsClient.sendTrackEvent({
                    source: 'uhAiMateRequest',
                    action: 'streaming_fetch_failed',
                    actionSubject: 'conversation',
                    actionSubjectId: conversation.conversationId,
                    attributes: {
                        isAiMate: true,
                        ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $bHG0Y.initialAIAnswerExperience).failure();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $bHG0Y.AIAnswerExperience).failure();
                return;
            }
            if (!generator) return;
            setState({
                conversation: {
                    ...(0, $lmdBP.addAssistantMessage)(assistantMessage, conversation),
                    storeAbortController: storeAbortController
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $bHG0Y.initialAIAnswerExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $bHG0Y.AIAnswerExperience).success();
            for await (const streamMessage of generator){
                if (storeAbortController.signal.aborted) break;
                const { conversation: recentConversation } = getState();
                if (!recentConversation || !recentConversation.conversationId) return;
                const { type: type, content: content } = (0, $6r9Ft.getUHUpdatedMessage)(streamMessage, assistantMessage.aiMateConversationResponse.message) ?? {
                    type: ''
                };
                let metadata;
                let updatedConversation;
                let totalSources;
                let totalRequestForms;
                let totalHelpDesks;
                switch(type){
                    case 'FOLLOW_UP_QUERIES':
                        setState({
                            conversation: (0, $lmdBP.updateFollowUpMessage)(recentConversation, content)
                        });
                        break;
                    case 'CONTENT_SEARCH':
                        assistantMessage = (0, $lmdBP.updateKeywords)(assistantMessage, content);
                        assistantMessage = (0, $lmdBP.updateAssistantMessageStatusToLoadingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $lmdBP.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANALYSING_STATE':
                        assistantMessage = (0, $lmdBP.updateSources)(assistantMessage, content);
                        setState({
                            conversation: (0, $lmdBP.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANSWER_PART':
                        assistantMessage = (0, $lmdBP.updateMessage)(assistantMessage, content);
                        assistantMessage = (0, $lmdBP.updateAssistantMessageStatusToTypingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $lmdBP.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        setState({
                            isLoading: false
                        });
                        !isAnswerPartAnalyticsFired && (0, $creqK.sendTrackEventForAnswerStreamingStarted)(analyticsClient, conversation.conversationId, performance.now() - startTime, conversation.externalConversationId);
                        isAnswerPartAnalyticsFired = true;
                        break;
                    case 'FINAL_RESPONSE':
                        metadata = content === null || content === void 0 ? void 0 : content.message_metadata;
                        isFallbackMessage = !!((_metadata = metadata) !== null && _metadata !== void 0 && _metadata.isFallbackMessage);
                        assistantMessage = (0, $lmdBP.updateFinalMessage)(assistantMessage, content, isFallbackMessage);
                        if (isFallbackMessage) {
                            var _assistantMessage$aiM, _assistantMessage$mes;
                            const retryMessage = $bd7a3bb4782f2731$var$getRetryMessage((_assistantMessage$aiM = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message_metadata) === null || _assistantMessage$aiM === void 0 ? void 0 : _assistantMessage$aiM.originalQuery, (_assistantMessage$mes = assistantMessage.messageMetadata) === null || _assistantMessage$mes === void 0 ? void 0 : _assistantMessage$mes.messageId, isFallbackMessage);
                            updatedConversation = (0, $lmdBP.replaceLastAssistantMessage)(retryMessage, recentConversation);
                        } else updatedConversation = (0, $lmdBP.replaceLastAssistantMessage)(assistantMessage, recentConversation);
                        setState({
                            conversation: updatedConversation
                        });
                        finishTime = performance.now();
                        totalSources = (0, $gCyLn.getTotalSources)(content);
                        totalHelpDesks = (0, $1T7Wz.getTotalHelpDesks)(content);
                        totalRequestForms = (0, $ce1c2.getTotalRequestForms)(content);
                        (0, $creqK.sendTrackEventForFetchedResponse)(analyticsClient, finishTime - startTime, (_metadata2 = metadata) === null || _metadata2 === void 0 ? void 0 : _metadata2.confidenceScore, (_metadata3 = metadata) === null || _metadata3 === void 0 ? void 0 : _metadata3.isFallbackMessage, (_metadata4 = metadata) === null || _metadata4 === void 0 ? void 0 : _metadata4.isConfluenceLicensedUser, (_metadata5 = metadata) === null || _metadata5 === void 0 ? void 0 : _metadata5.isVagueQuery, (_metadata6 = metadata) === null || _metadata6 === void 0 ? void 0 : _metadata6.searchResultCount, (_metadata7 = metadata) === null || _metadata7 === void 0 ? void 0 : _metadata7.totalSearchResultCount, recentConversation.conversationId, totalSources, totalHelpDesks, totalRequestForms, assistantMessage.messageMetadata.messageId, recentConversation.externalConversationId);
                        break;
                    case 'ERROR':
                        setState({
                            conversation: $bd7a3bb4782f2731$var$getDefaultErrorState(recentConversation)
                        });
                        (0, $creqK.sendTrackEventForFailure)(analyticsClient, recentConversation.conversationId, false, recentConversation.externalConversationId);
                        break;
                    default:
                        break;
                }
            }
        } finally{
            const { conversation: currentConversation } = getState();
            setState({
                conversation: currentConversation ? {
                    ...currentConversation,
                    storeAbortController: undefined
                } : null,
                isLoading: false
            });
        }
    };
const $bd7a3bb4782f2731$export$39e5a890dd0d70ff = (term)=>async ({ getState: getState, dispatch: dispatch })=>{
        var _getState$conversatio2;
        dispatch($bd7a3bb4782f2731$var$resetTimer((_getState$conversatio2 = getState().conversation) === null || _getState$conversatio2 === void 0 ? void 0 : _getState$conversatio2.conversationId));
        dispatch($bd7a3bb4782f2731$var$cleanFollowUps());
        dispatch($bd7a3bb4782f2731$export$7d26299426387884(term));
        dispatch($bd7a3bb4782f2731$var$fetchConversation(term));
    };
const $bd7a3bb4782f2731$var$cleanFollowUps = ()=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: conversation.history.filter((item)=>item.userType !== 'followUp')
        };
        setState({
            conversation: conversation
        });
    };
const $bd7a3bb4782f2731$export$7d26299426387884 = (term)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'helpseeker',
                    messageContentAdf: (0, $j2vls.doc)((0, $f5LPR.paragraph)(term)),
                    messageMetadata: {
                        originalQuery: term
                    }
                }
            ]
        };
        setState({
            conversation: conversation
        });
    };
const $bd7a3bb4782f2731$export$8bc7344bcdeb6569 = (response, id, isResolved)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const responseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $j2vls.doc)((0, $f5LPR.paragraph)(response))
        };
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(indexOfAssistantMessage + 1, 0, responseObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
        if (isResolved) {
            var _getState$conversatio3;
            dispatch($bd7a3bb4782f2731$var$addCsatDropdownMessageOnlyForUI(indexOfAssistantMessage, id));
            dispatch($bd7a3bb4782f2731$var$cleanFollowUps());
            dispatch($bd7a3bb4782f2731$var$resetTimer((_getState$conversatio3 = getState().conversation) === null || _getState$conversatio3 === void 0 ? void 0 : _getState$conversatio3.conversationId, $bd7a3bb4782f2731$var$ONE_DAY));
        }
    };
const $bd7a3bb4782f2731$export$193f22ef45a60fb9 = (response, id)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        conversation.history[indexOfAssistantMessage].messageMetadata.csatScore = response.id;
        const helpseekerResponseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $j2vls.doc)((0, $f5LPR.paragraph)(response.label))
        };
        // the CSAT response will be shown after, Feedback Response: 'Yes' and CSAT Dropdown Message, so we have to hop 3 indices
        const targetIndex = indexOfAssistantMessage + 3;
        const newHistory = [
            ...conversation.history
        ];
        const closeConversationObject = {
            userType: 'channelMessage',
            messageType: (0, $etQ17.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
        };
        newHistory.splice(targetIndex, 0, helpseekerResponseObject, closeConversationObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $bd7a3bb4782f2731$var$addCsatDropdownMessageOnlyForUI = (indexOfAssistantMessage, messageId)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const csatDropdownMessageObject = {
            userType: 'csatDropdown',
            messageMetadata: {
                messageId: messageId
            }
        };
        const newHistory = [
            ...conversation.history
        ];
        // the CSAT Dropdown will be shown after, Feedback Response: 'Yes', so we have to hop 2 indices
        newHistory.splice(indexOfAssistantMessage + 2, 0, csatDropdownMessageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $bd7a3bb4782f2731$var$getRetryMessage = (originalQuery, messageId, isFallbackMessage)=>({
        userType: 'retry',
        messageMetadata: {
            originalQuery: originalQuery,
            messageId: messageId,
            isFallbackMessage: isFallbackMessage
        }
    });
const $bd7a3bb4782f2731$export$2024ac9dac025c83 = (id)=>async ({ getState: getState, setState: setState })=>{
        var _assistantMessage$aiM2, _assistantMessage$aiM3;
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const relativeFeedbackResponseIndex = conversation.history.slice(indexOfAssistantMessage).findIndex((message)=>message.userType === 'feedbackResponse');
        const feedbackResponseIndex = relativeFeedbackResponseIndex === -1 ? -1 : relativeFeedbackResponseIndex + indexOfAssistantMessage;
        if (feedbackResponseIndex === -1) return;
        const assistantMessage = conversation.history[indexOfAssistantMessage];
        const messageObject = $bd7a3bb4782f2731$var$getRetryMessage(assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM2 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message_metadata) === null || _assistantMessage$aiM2 === void 0 ? void 0 : _assistantMessage$aiM2.originalQuery, id, assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM3 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message_metadata) === null || _assistantMessage$aiM3 === void 0 ? void 0 : _assistantMessage$aiM3.isFallbackMessage);
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(feedbackResponseIndex + 1, 0, messageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $bd7a3bb4782f2731$export$5e2723610064e2d9 = (isVisible, messageId)=>async ({ getState: getState, setState: setState })=>{
        const { messageId: existingMessageId } = getState().feedbackCollectorConfig;
        setState({
            feedbackCollectorConfig: {
                isVisible: isVisible,
                messageId: messageId || existingMessageId
            }
        });
    };
const $bd7a3bb4782f2731$export$2c9f6ca76cd8a6bc = ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { activeTimer: activeTimer, conversation: conversation } = getState();
        const analyticsClient = (0, $1nqlT.getAnalyticsWebClient)();
        const { conversationId: conversationId, externalConversationId: externalConversationId } = conversation || {};
        if (activeTimer) clearTimeout(activeTimer);
        if (conversationId) {
            dispatch($bd7a3bb4782f2731$export$882bd6a6d00830a0());
            (0, $creqK.sendUIEventForClearConversation)(analyticsClient, conversationId, externalConversationId);
        }
        setState({
            ...(0, $jnZ2v.initialState)
        });
    };
const $bd7a3bb4782f2731$export$882bd6a6d00830a0 = ()=>async ({ setState: setState, getState: getState })=>{
        const { conversation: conversation } = getState();
        if (!conversation || !conversation.conversationId || !conversation.storeAbortController) return;
        const lastAssistantMessage = conversation.history.slice(-1);
        if (lastAssistantMessage !== null && lastAssistantMessage !== void 0 && lastAssistantMessage.length && lastAssistantMessage[0].userType === (0, $jnZ2v.ASSISTANT_USER_TYPE)) {
            const abortedMessage = (0, $lmdBP.updateAbortedAssistantMessage)(lastAssistantMessage[0]);
            setState({
                conversation: (0, $lmdBP.replaceLastAssistantMessage)(abortedMessage, conversation),
                isLoading: false
            });
            conversation.storeAbortController.abort();
        }
    };
const $bd7a3bb4782f2731$export$9ff6f230516497d2 = (vaConversationId, history)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _history$find;
        setState({
            isLoading: true
        });
        await dispatch($bd7a3bb4782f2731$export$92b5f8fb222eed7e(vaConversationId));
        const { conversation: conversation } = getState();
        if (!conversation) throw new Error('No conversation!');
        const originalQuery = ((_history$find = history.find((message)=>message.userType === 'helpseeker')) === null || _history$find === void 0 || (_history$find = _history$find.messageMetadata) === null || _history$find === void 0 ? void 0 : _history$find.originalQuery) || '';
        setState({
            conversationStartTime: Date.now(),
            conversation: {
                ...conversation,
                history: history
            }
        });
        dispatch($bd7a3bb4782f2731$var$fetchConversation(originalQuery));
    };

});
parcelRegister("6r9Ft", function(module, exports) {
$parcel$export(module.exports, "getUHUpdatedMessage", () => $9485dd10ba90e25e$export$ed355c3a875c71ab);

var $diiav = parcelRequire("diiav");

var $7CSHX = parcelRequire("7CSHX");

var $9s5I7 = parcelRequire("9s5I7");
const $9485dd10ba90e25e$export$ed355c3a875c71ab = (streamMessage, currentMessage)=>{
    if ((0, $9s5I7.isUHTraceContentSearch)(streamMessage)) {
        var _streamMessage$messag;
        return {
            type: 'CONTENT_SEARCH',
            content: ((_streamMessage$messag = streamMessage.message) === null || _streamMessage$messag === void 0 ? void 0 : _streamMessage$messag.formulated_query) || ''
        };
    }
    if ((0, $7CSHX.isUHTraceAnalyzingState)(streamMessage)) {
        var _streamMessage$messag2;
        return {
            type: 'ANALYSING_STATE',
            content: ((_streamMessage$messag2 = streamMessage.message) === null || _streamMessage$messag2 === void 0 ? void 0 : _streamMessage$messag2.sources) || ''
        };
    }
    if ((0, $diiav.isStreamAnswerPart)(streamMessage)) return {
        type: 'ANSWER_PART',
        content: {
            ...currentMessage,
            content: currentMessage.content.toString() + streamMessage.message.content
        }
    };
    if ((0, $diiav.isStreamResponse)(streamMessage)) return {
        type: 'FINAL_RESPONSE',
        content: {
            ...streamMessage.message.message
        }
    };
    if ((0, $diiav.isStreamError)(streamMessage)) return {
        type: 'ERROR'
    };
    if ((0, $diiav.isFollowUpMessage)(streamMessage)) {
        var _streamMessage$messag3;
        return {
            type: 'FOLLOW_UP_QUERIES',
            content: ((_streamMessage$messag3 = streamMessage.message.follow_ups) === null || _streamMessage$messag3 === void 0 ? void 0 : _streamMessage$messag3.map((f)=>f.text)) ?? []
        };
    }
    return null;
};

});
parcelRegister("diiav", function(module, exports) {
$parcel$export(module.exports, "isSSEMessage", () => $c09ae64fecb63be5$export$f78edfe5a93b58af);
$parcel$export(module.exports, "ACCEPTABLE_USE_VIOLATIONS_ERROR", () => $c09ae64fecb63be5$export$c424fe9570a5f2d9);
$parcel$export(module.exports, "isHumanMessage", () => $c09ae64fecb63be5$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $c09ae64fecb63be5$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $c09ae64fecb63be5$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $c09ae64fecb63be5$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $c09ae64fecb63be5$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $c09ae64fecb63be5$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $c09ae64fecb63be5$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamTrace", () => $c09ae64fecb63be5$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isFollowUpMessage", () => $c09ae64fecb63be5$export$aeae5b4fda357302);
$parcel$export(module.exports, "isChannelNotFoundError", () => $c09ae64fecb63be5$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isRateLimitedError", () => $c09ae64fecb63be5$export$bc96a6a479480590);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $c09ae64fecb63be5$export$b454081350f4a578);
$parcel$export(module.exports, "isStreamPromptRedaction", () => $c09ae64fecb63be5$export$f4111656f23d9b9b);
$parcel$export(module.exports, "isStreamPromptBlock", () => $c09ae64fecb63be5$export$c43cf9ba6a2176ef);
$parcel$export(module.exports, "isStreamResponseRedaction", () => $c09ae64fecb63be5$export$f16ff8eb19967a97);
$parcel$export(module.exports, "isStreamResponseBlock", () => $c09ae64fecb63be5$export$55f7bd80eacbc51b);
$parcel$export(module.exports, "isStreamAttachmentBlock", () => $c09ae64fecb63be5$export$a1be74470d3c1fe9);

var $5rwNT = parcelRequire("5rwNT");

var $9QQIE = parcelRequire("9QQIE");
const $c09ae64fecb63be5$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $c09ae64fecb63be5$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $c09ae64fecb63be5$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $c09ae64fecb63be5$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $c09ae64fecb63be5$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $c09ae64fecb63be5$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $c09ae64fecb63be5$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $c09ae64fecb63be5$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $c09ae64fecb63be5$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $c09ae64fecb63be5$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $c09ae64fecb63be5$export$77c9504201bdfdea = 'PROMPT_TILE';
const $c09ae64fecb63be5$export$7fe06c6ae176663 = 'third-party';
const $c09ae64fecb63be5$export$31883fad14b55ba5 = 'FINAL_RESPONSE';
const $c09ae64fecb63be5$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $c09ae64fecb63be5$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $c09ae64fecb63be5$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $c09ae64fecb63be5$export$fb661125ffb29bd6 = (message)=>{
    return $c09ae64fecb63be5$export$a69fab2afb88c2eb(message) || $c09ae64fecb63be5$export$6f965deda7f0960c(message) || $c09ae64fecb63be5$export$b4631726cbc1440a(message);
};
const $c09ae64fecb63be5$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $c09ae64fecb63be5$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $c09ae64fecb63be5$export$1af37a4715539580 = (message)=>{
    var _message$message_meta;
    return Boolean((_message$message_meta = message.message_metadata) === null || _message$message_meta === void 0 ? void 0 : _message$message_meta.sharedFromMessageId);
};
const $c09ae64fecb63be5$export$a6e5100ca2770191 = (message)=>message instanceof Object && $c09ae64fecb63be5$export$6f965deda7f0960c(message.message);
const $c09ae64fecb63be5$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $c09ae64fecb63be5$export$5c1c15675df13ae5 = (message)=>{
    var _message$message;
    return $c09ae64fecb63be5$export$b4631726cbc1440a(message) && ((_message$message = message.message) === null || _message$message === void 0 || (_message$message = _message$message.message) === null || _message$message === void 0 ? void 0 : _message$message.async_status) === 'IN_PROGRESS';
};
const $c09ae64fecb63be5$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $c09ae64fecb63be5$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $c09ae64fecb63be5$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $c09ae64fecb63be5$export$2d3cb9d520902824 = (message)=>{
    if (!$c09ae64fecb63be5$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$c09ae64fecb63be5$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$c09ae64fecb63be5$var$isRecord(message.metadata) || !$c09ae64fecb63be5$var$isOptionalNullableString(message.metadata.request_id) || !$c09ae64fecb63be5$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $c09ae64fecb63be5$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $c09ae64fecb63be5$export$7919ac51b50b97eb = (message)=>message instanceof Object && message.type === 'AI_CREDIT_DENIED';
const $c09ae64fecb63be5$export$1e1cf807ece63df4 = (message)=>{
    var _message$message2;
    return $c09ae64fecb63be5$export$d422a2733a3b5def(message) && ((_message$message2 = message.message) === null || _message$message2 === void 0 ? void 0 : _message$message2.message_template) === $c09ae64fecb63be5$export$c424fe9570a5f2d9;
};
const $c09ae64fecb63be5$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $c09ae64fecb63be5$var$isNonEmptyString = (value)=>typeof value === 'string' && value.length > 0;
const $c09ae64fecb63be5$export$a29b8eb13b54e91f = (message)=>$c09ae64fecb63be5$var$isRecord(message) && message.type === 'ANSWER_UI_PART' && $c09ae64fecb63be5$var$isNonEmptyString(message.part_id);
const $c09ae64fecb63be5$export$eee53d3475c29169 = (message)=>{
    if (!$c09ae64fecb63be5$var$isRecord(message) || message.type !== 'ANSWER_UI_CONTENT' || !$c09ae64fecb63be5$var$isNonEmptyString(message.part_id)) return false;
    if (message.state === 'failed') return true;
    return message.state === 'ready' && $c09ae64fecb63be5$var$isRecord(message.message) && message.message.format === 'lumina_v1' && $c09ae64fecb63be5$var$isNonEmptyString(message.message.content);
};
const $c09ae64fecb63be5$var$isRawEntityAnnotation = (value)=>$c09ae64fecb63be5$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $c09ae64fecb63be5$export$6fb760a9d35f0551 = (message)=>$c09ae64fecb63be5$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $c09ae64fecb63be5$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($c09ae64fecb63be5$var$isRawEntityAnnotation);
const $c09ae64fecb63be5$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $c09ae64fecb63be5$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $c09ae64fecb63be5$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $c09ae64fecb63be5$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $c09ae64fecb63be5$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $c09ae64fecb63be5$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $c09ae64fecb63be5$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $c09ae64fecb63be5$export$9082a8e48d820016 = (message)=>{
    if (!$c09ae64fecb63be5$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$c09ae64fecb63be5$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $c09ae64fecb63be5$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $c09ae64fecb63be5$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $c09ae64fecb63be5$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $c09ae64fecb63be5$var$isNullableString(payload.action_key) && $c09ae64fecb63be5$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $c09ae64fecb63be5$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $c09ae64fecb63be5$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $c09ae64fecb63be5$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $c09ae64fecb63be5$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $c09ae64fecb63be5$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $c09ae64fecb63be5$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $c09ae64fecb63be5$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $c09ae64fecb63be5$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $c09ae64fecb63be5$export$5cfcb66b0fc392d6 = (message)=>typeof message === 'object' && message !== null && 'type' in message && message.type === 'CONCIERGE_AGENT_SELECTED';
const $c09ae64fecb63be5$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $c09ae64fecb63be5$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $c09ae64fecb63be5$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $c09ae64fecb63be5$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $c09ae64fecb63be5$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $c09ae64fecb63be5$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $c09ae64fecb63be5$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $c09ae64fecb63be5$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $c09ae64fecb63be5$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $c09ae64fecb63be5$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $c09ae64fecb63be5$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $c09ae64fecb63be5$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $c09ae64fecb63be5$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($c09ae64fecb63be5$export$7898cc38956b9052(message) || $c09ae64fecb63be5$export$bb608d13a1268633(message));
const $c09ae64fecb63be5$export$d95e474df0d530df = (message)=>{
    var _message$message3;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message3 = message.message) === null || _message$message3 === void 0 ? void 0 : _message$message3.message_template) === 'MEMORY_UPDATE';
};
const $c09ae64fecb63be5$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($c09ae64fecb63be5$export$46e0fb5e4b019a49(message)) return false;
    if ($c09ae64fecb63be5$export$cde91b49af35d559(message)) return false;
    if ($c09ae64fecb63be5$export$6f74311d40862a9f(message)) return false;
    if ($c09ae64fecb63be5$export$b65c73c7e2d8d96f(message)) return false;
    if ($c09ae64fecb63be5$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $c09ae64fecb63be5$export$682514f3a8131b98 = (message)=>{
    var _message$message4;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message4 = message.message) === null || _message$message4 === void 0 ? void 0 : _message$message4.message_template) === 'THINK_DEEPER_TRIGGERED';
};
const $c09ae64fecb63be5$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $c09ae64fecb63be5$export$6275ff996073145e = (message)=>{
    var _data$message;
    if (!$c09ae64fecb63be5$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray((_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.content);
};
const $c09ae64fecb63be5$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $c09ae64fecb63be5$export$b8391261162989d9 = (message)=>{
    var _message$message_meta2, _message$message_meta3;
    return $c09ae64fecb63be5$export$6f965deda7f0960c(message) && ((message === null || message === void 0 || (_message$message_meta2 = message.message_metadata) === null || _message$message_meta2 === void 0 ? void 0 : _message$message_meta2.is_action_execution) ?? false) && (message === null || message === void 0 || (_message$message_meta3 = message.message_metadata) === null || _message$message_meta3 === void 0 ? void 0 : _message$message_meta3.action_execution_result) === 'SUCCESS';
};
const $c09ae64fecb63be5$export$1060c4fa97e34fa7 = (payloadContext)=>{
    var _payloadContext$resol;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol = payloadContext.resolution) === null || _payloadContext$resol === void 0 ? void 0 : _payloadContext$resol.type) === 'cancel';
};
const $c09ae64fecb63be5$export$6ce1ccc24e75456f = (error)=>{
    var _error$errorAttribute;
    return (0, $9QQIE.isApiError)(error) && ((_error$errorAttribute = error.errorAttributes) === null || _error$errorAttribute === void 0 ? void 0 : _error$errorAttribute.errorCode) === $c09ae64fecb63be5$export$5945515082cc2cbf;
};
const $c09ae64fecb63be5$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $c09ae64fecb63be5$export$bc96a6a479480590 = (error)=>(0, $9QQIE.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $c09ae64fecb63be5$export$f8b1b75846492611 = (error)=>(0, $9QQIE.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $5rwNT.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $c09ae64fecb63be5$export$d263dc5d64f36d48 = (error)=>{
    var _error$detail;
    return error instanceof Object && (error === null || error === void 0 || (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.type) === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $c09ae64fecb63be5$export$c424fe9570a5f2d9;
};
const $c09ae64fecb63be5$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $c09ae64fecb63be5$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $c09ae64fecb63be5$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $c09ae64fecb63be5$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $c09ae64fecb63be5$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $c09ae64fecb63be5$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $c09ae64fecb63be5$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $c09ae64fecb63be5$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $c09ae64fecb63be5$export$4af48296a8d61cec(payloadContext) {
    var _payloadContext$resol2;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol2 = payloadContext.resolution) === null || _payloadContext$resol2 === void 0 ? void 0 : _payloadContext$resol2.type) === 'confirm';
}

});
parcelRegister("5rwNT", function(module, exports) {
$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $c20c6a03edfdd116$export$1106bf31edf2a9b8);
const $c20c6a03edfdd116$export$e8114853eca81277 = 'ai-mate';
const $c20c6a03edfdd116$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $c20c6a03edfdd116$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};

});

parcelRegister("9QQIE", function(module, exports) {
$parcel$export(module.exports, "ApiError", () => $df230d6a144c02c5$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $df230d6a144c02c5$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $df230d6a144c02c5$export$3c02d1a328d4d808);
const $df230d6a144c02c5$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $df230d6a144c02c5$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        this.data = data;
    }
}
const $df230d6a144c02c5$export$89d83cc97c52a37 = (error)=>error instanceof $df230d6a144c02c5$export$f2e832acab1bdd79;
const $df230d6a144c02c5$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $df230d6a144c02c5$var$getApiErrorAttributes = (error)=>{
    var _getRecord;
    if ($df230d6a144c02c5$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $df230d6a144c02c5$var$getRecord((_getRecord = $df230d6a144c02c5$var$getRecord(error)) === null || _getRecord === void 0 ? void 0 : _getRecord.errorAttributes);
};
const $df230d6a144c02c5$var$getStructuredErrorData = (error)=>{
    var _getRecord2;
    const errorRecord = $df230d6a144c02c5$var$getRecord(error);
    return $df230d6a144c02c5$var$getRecord(errorRecord === null || errorRecord === void 0 ? void 0 : errorRecord.data) ?? $df230d6a144c02c5$var$getRecord((_getRecord2 = $df230d6a144c02c5$var$getRecord(errorRecord === null || errorRecord === void 0 ? void 0 : errorRecord.errorAttributes)) === null || _getRecord2 === void 0 ? void 0 : _getRecord2.data);
};
const $df230d6a144c02c5$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $df230d6a144c02c5$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $df230d6a144c02c5$var$getApiErrorAttributes(error);
    if ((errorAttributes === null || errorAttributes === void 0 ? void 0 : errorAttributes.errorCode) !== $df230d6a144c02c5$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $df230d6a144c02c5$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $df230d6a144c02c5$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $df230d6a144c02c5$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $df230d6a144c02c5$export$3c02d1a328d4d808 = (error)=>{
    if ($df230d6a144c02c5$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $df230d6a144c02c5$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("7CSHX", function(module, exports) {
$parcel$export(module.exports, "isUHTraceAnalyzingState", () => $143e8c365491203c$export$b7ca9806367cbd80);
const $143e8c365491203c$export$b7ca9806367cbd80 = (message)=>message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';

});

parcelRegister("9s5I7", function(module, exports) {
$parcel$export(module.exports, "isUHTraceContentSearch", () => $70d4f44f5fc203e1$export$a9fb9dc1a9b2c5ba);
const $70d4f44f5fc203e1$export$a9fb9dc1a9b2c5ba = (message)=>message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';

});


parcelRegister("fgUje", function(module, exports) {
$parcel$export(module.exports, "ExperienceType", () => $6576d724001fc47b$export$7814caf20640a89e);
var $6576d724001fc47b$export$7814caf20640a89e = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["UNIFIED_HELP"] = "unified-help";
    return ExperienceType;
}({});

});

parcelRegister("hf5yS", function(module, exports) {
$parcel$export(module.exports, "getChannelId", () => $a9440860dd50e91a$export$98f3eb54b6f833b6);
$parcel$export(module.exports, "sendMessageStream", () => $a9440860dd50e91a$export$5dd6208dff317c60);

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $fgUje = parcelRequire("fgUje");

var $cf3fd = parcelRequire("cf3fd");

var $1nqlT = parcelRequire("1nqlT");

var $kZaOC = parcelRequire("kZaOC");

var $aQGxC = parcelRequire("aQGxC");

var $jn8Ij = parcelRequire("jn8Ij");
const $a9440860dd50e91a$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $a9440860dd50e91a$var$helpcenterSlugHeader = {
    'X-Helpcenter-Slug': (0, $cf3fd.getSlugForHelpCenter)() ?? ''
};
const $a9440860dd50e91a$var$getChannelIdPath = ()=>{
    return (0, $6LH8a.getMeta)('ajs-account-type') === 'customer' && (0, $hN5YJ.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel` : `/gateway/api/assist/chat/v1/channel`;
};
const $a9440860dd50e91a$var$getMessageStreamPath = (channelId)=>{
    return (0, $6LH8a.getMeta)('ajs-account-type') === 'customer' && (0, $hN5YJ.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel/${channelId}/message/stream` : `/gateway/api/assist/chat/v1/channel/${channelId}/message/stream`;
};
const $a9440860dd50e91a$export$98f3eb54b6f833b6 = async ()=>{
    const analyticsClient = (0, $1nqlT.getAnalyticsWebClient)();
    let channelId = null;
    try {
        const channelResponse = await (0, $aQGxC.fetchJson)($a9440860dd50e91a$var$getChannelIdPath(), 'POST', {
            body: JSON.stringify({}),
            headers: $a9440860dd50e91a$var$commonHeaders
        });
        channelId = channelResponse.id;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetched',
            actionSubject: 'channelId',
            actionSubjectId: channelId,
            attributes: {
                ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
            }
        });
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetch_failed',
            actionSubject: 'channelId',
            attributes: {
                ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
            }
        });
        channelId = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'portalHomeScreen',
        action: 'initiated',
        actionSubject: 'aiInteraction',
        actionSubjectId: channelId ?? '',
        attributes: {
            aiFeatureName: 'aiAnswer',
            aiInteractionID: channelId,
            aiInteractionType: 'conversationId',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        }
    });
    return channelId;
};
const $a9440860dd50e91a$export$5dd6208dff317c60 = async (content, channelId, abortController)=>{
    const body = {
        content: content,
        recipient_agent_named_id: 'unified_help_agent'
    };
    const options = {
        method: 'POST',
        headers: {
            ...$a9440860dd50e91a$var$commonHeaders,
            'content-type': 'application/json;charset=UTF-8',
            ...$a9440860dd50e91a$var$helpcenterSlugHeader,
            'X-Helpcenter-Ari': (0, $6LH8a.getHelpCenterAri)()
        },
        body: JSON.stringify(body),
        signal: abortController.signal
    };
    return (0, $jn8Ij.fetchStream)($a9440860dd50e91a$var$getMessageStreamPath(channelId), options);
};

});
parcelRegister("1nqlT", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $3ba235f9a656b383$export$e9ba7ef9458d1a4a);
//import AnalyticsClient, { envType, originType, userType, tenantType } from '@atlassiansox/analytics-web-client';
//@ts-ignore
//import Cookie from 'js-cookie';
//import { getMeta } from '@helpcenter/meta';

var $6lbrU = parcelRequire("6lbrU");
const $3ba235f9a656b383$export$e9ba7ef9458d1a4a = ()=>(0, $6lbrU.getAnalyticsWebClient)().getInstance();

});

parcelRegister("kZaOC", function(module, exports) {
$parcel$export(module.exports, "getProductIdentifierAttributes", () => $57d098512bb7b177$export$414440f1585883f4);

var $6LH8a = parcelRequire("6LH8a");
const $57d098512bb7b177$export$414440f1585883f4 = (experienceId)=>({
        experienceId: experienceId,
        helpcenterId: (0, $6LH8a.getHelpCenterAri)().split('/').pop()
    });

});

parcelRegister("aQGxC", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $22f52c9a8cd1ac33$export$6d71b655afe1638d);
const $22f52c9a8cd1ac33$export$6d71b655afe1638d = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        headers: {
            ...options === null || options === void 0 ? void 0 : options.headers,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw {
        error: new Error(`Request failed: ${response.status} ${response.statusText}`),
        status: response.status
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const data = await response.json();
    return data;
};

});

parcelRegister("jn8Ij", function(module, exports) {
$parcel$export(module.exports, "fetchStream", () => $fa93fb6ec6004724$export$93163a9030575d92);

var $1VcaX = parcelRequire("1VcaX");
const $fa93fb6ec6004724$export$93163a9030575d92 = async (path, options)=>{
    const response = await fetch(path, options);
    return (0, $1VcaX.readJsonStream)(response);
};

});
parcelRegister("1VcaX", function(module, exports) {
$parcel$export(module.exports, "readJsonStream", () => $bb213f87d95eda3c$export$1f24b2b263bcfa75);

var $dRkX9 = parcelRequire("dRkX9");

var $3uBqL = parcelRequire("3uBqL");
async function* $bb213f87d95eda3c$export$1f24b2b263bcfa75(response) {
    const reader = (0, $3uBqL.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $dRkX9.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("3uBqL", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $c78cf0bab0df5aaa$export$f6383c3ea1307da9);
const $c78cf0bab0df5aaa$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});




parcelRegister("25NE3", function(module, exports) {
$parcel$export(module.exports, "storeFeedback", () => $73ca43543611c1dc$export$f3438d7da4ca94e9);

var $4JnMM = parcelRequire("4JnMM");
const $73ca43543611c1dc$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $73ca43543611c1dc$export$f3438d7da4ca94e9 = async ({ channelId: channelId, messageId: messageId, feedback: feedback, feedbackLabel: feedbackLabel })=>{
    if (!messageId) return;
    await (0, $4JnMM.fetchNothing)(`/gateway/api/assist/chat/v1/channel/${channelId}/message/${messageId}/feedback`, 'PUT', {
        headers: {
            ...$73ca43543611c1dc$var$commonHeaders,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            feedback_value: feedback,
            feedback_message: feedbackLabel
        })
    });
};

});
parcelRegister("4JnMM", function(module, exports) {
$parcel$export(module.exports, "fetchNothing", () => $686f021976bfb483$export$734eba776b437e7e);
const $686f021976bfb483$export$734eba776b437e7e = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`Request failed: ${response.status} ${response.statusText}`);
};

});


parcelRegister("lFfXl", function(module, exports) {
$parcel$export(module.exports, "genIntId", () => $22842e843658f335$export$99db4f5154ec67b);
const $22842e843658f335$export$99db4f5154ec67b = ()=>Math.floor(Math.random() * 1000000);

});

parcelRegister("e3lmc", function(module, exports) {
$parcel$export(module.exports, "initialAssistantMessage", () => $c6b0cd196bc5b04a$export$b1cea82f2a755388);

var $etQ17 = parcelRequire("etQ17");
const $c6b0cd196bc5b04a$export$b1cea82f2a755388 = (answerId)=>({
        aiMateConversationResponse: {
            message: {
                id: String(answerId),
                time_created: '',
                user_ari: '',
                role: 'assistant',
                content: '',
                plugin_invocations: []
            }
        },
        userType: 'assistant',
        messageMetadata: {
            status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
            messageId: answerId.toString()
        }
    });

});

parcelRegister("1T7Wz", function(module, exports) {
$parcel$export(module.exports, "getTotalHelpDesks", () => $a65055487c8a3cae$export$826b9b61b3b7d76d);
const $a65055487c8a3cae$export$826b9b61b3b7d76d = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'helpDesk')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("ce1c2", function(module, exports) {
$parcel$export(module.exports, "getTotalRequestForms", () => $26a973bcdcfb06b8$export$859320f8ebb3caf3);
const $26a973bcdcfb06b8$export$859320f8ebb3caf3 = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'requestForm')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("gCyLn", function(module, exports) {
$parcel$export(module.exports, "getTotalSources", () => $92f917f25816c74d$export$75f436fca26bdba1);
const $92f917f25816c74d$export$75f436fca26bdba1 = (message)=>{
    var _message$sources;
    return (message === null || message === void 0 || (_message$sources = message.sources) === null || _message$sources === void 0 ? void 0 : _message$sources.length) ?? 0;
};

});

parcelRegister("lmdBP", function(module, exports) {
$parcel$export(module.exports, "updateKeywords", () => $f1bd9e8116d96131$export$9c6f66d1d405561d);
$parcel$export(module.exports, "updateSources", () => $f1bd9e8116d96131$export$6c4da287bd77d75c);
$parcel$export(module.exports, "updateMessage", () => $f1bd9e8116d96131$export$829153c748a07de7);
$parcel$export(module.exports, "updateFinalMessage", () => $f1bd9e8116d96131$export$95204cf9f69c856a);
$parcel$export(module.exports, "addAssistantMessage", () => $f1bd9e8116d96131$export$ce06e1b90807a0c0);
$parcel$export(module.exports, "replaceLastAssistantMessage", () => $f1bd9e8116d96131$export$a1def0348b9f1873);
$parcel$export(module.exports, "updateFollowUpMessage", () => $f1bd9e8116d96131$export$9143429366a9249);
$parcel$export(module.exports, "updateAssistantMessageStatusToTypingResponse", () => $f1bd9e8116d96131$export$e1c963c90a5d08ee);
$parcel$export(module.exports, "updateAssistantMessageStatusToLoadingResponse", () => $f1bd9e8116d96131$export$c2814dbaf6592faa);
$parcel$export(module.exports, "updateAbortedAssistantMessage", () => $f1bd9e8116d96131$export$5d7bc912c91053cd);

var $etQ17 = parcelRequire("etQ17");

var $jnZ2v = parcelRequire("jnZ2v");
const $f1bd9e8116d96131$export$9c6f66d1d405561d = (assistantMessage, keywords = '')=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                keywords: keywords.split('|')
            }
        }
    });
const $f1bd9e8116d96131$export$6c4da287bd77d75c = (assistantMessage, sources)=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                sources: sources
            }
        }
    });
const $f1bd9e8116d96131$export$829153c748a07de7 = (assistantMessage, message)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        }
    });
const $f1bd9e8116d96131$export$95204cf9f69c856a = (assistantMessage, message, isFallbackMessage)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        },
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            isFallbackMessage: isFallbackMessage,
            messageId: message.id.toString(),
            status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).IDLE,
            showFeedback: !isFallbackMessage
        }
    });
const $f1bd9e8116d96131$export$ce06e1b90807a0c0 = (assistantMessage, conversation)=>({
        ...conversation,
        history: [
            ...conversation.history,
            assistantMessage
        ]
    });
const $f1bd9e8116d96131$export$a1def0348b9f1873 = (message, conversation)=>{
    const updatedConversationHistory = conversation.history[conversation.history.length - 1].userType === (0, $jnZ2v.ASSISTANT_USER_TYPE) ? conversation.history.slice(0, -1) : conversation.history;
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            message
        ]
    };
};
const $f1bd9e8116d96131$export$9143429366a9249 = (conversation, queries)=>({
        ...conversation,
        history: [
            ...conversation.history,
            {
                queries: queries,
                userType: 'followUp'
            }
        ]
    });
const $f1bd9e8116d96131$export$e1c963c90a5d08ee = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE
        }
    });
const $f1bd9e8116d96131$export$c2814dbaf6592faa = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE
        }
    });
const $f1bd9e8116d96131$export$5d7bc912c91053cd = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
        }
    });

});
parcelRegister("jnZ2v", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $875bf328e86745a9$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "ASSISTANT_USER_TYPE", () => $875bf328e86745a9$export$93622d3dc67e9e9b);
$parcel$export(module.exports, "HELP_SEEKER_USER_TYPE", () => $875bf328e86745a9$export$fa4d1d4ff5355f70);
const $875bf328e86745a9$export$d4c72bab9d6cc13a = {
    isLoading: false,
    conversation: null,
    searchAll: false,
    pipeline: '',
    isTesting: false,
    feedbackCollectorConfig: {
        isVisible: false,
        messageId: undefined
    },
    activeTimer: null,
    ui: {
        conversationScrollBarWidth: '0px'
    }
};
const $875bf328e86745a9$export$93622d3dc67e9e9b = 'assistant';
const $875bf328e86745a9$export$fa4d1d4ff5355f70 = 'helpseeker';

});


parcelRegister("4s5nM", function(module, exports) {
$parcel$export(module.exports, "createStoreAbortController", () => $3d73677a52461520$export$cb6128fc3a3c8081);
const $3d73677a52461520$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    const abort = ()=>{
        abortController.abort();
    };
    const signal = abortController.signal;
    return {
        storeAbortController: {
            abort: abort,
            signal: signal
        }
    };
};

});

parcelRegister("creqK", function(module, exports) {
$parcel$export(module.exports, "sendUIEventForAskedQuestion", () => $1430a03360f0cdb9$export$2bf225029007d9aa);
$parcel$export(module.exports, "sendUIEventForClearConversation", () => $1430a03360f0cdb9$export$e33202cdfb6e8294);
$parcel$export(module.exports, "sendTrackEventForAnswerStreamingStarted", () => $1430a03360f0cdb9$export$1ad079e189e166f0);
$parcel$export(module.exports, "sendTrackEventForFetchedResponse", () => $1430a03360f0cdb9$export$b13699b81838287b);
$parcel$export(module.exports, "sendTrackEventForFailure", () => $1430a03360f0cdb9$export$d40db612c63a38bf);
$parcel$export(module.exports, "sendUIEventForFollowUpSelection", () => $1430a03360f0cdb9$export$6d1d2cd3a3ab5d10);

var $fgUje = parcelRequire("fgUje");

var $kZaOC = parcelRequire("kZaOC");
const $1430a03360f0cdb9$export$2bf225029007d9aa = (analyticsClient, conversationId, totalMessageCount, messageLength, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'uhConversationScreen',
        action: 'asked',
        actionSubject: 'question',
        attributes: {
            conversationId: conversationId,
            messageLength: messageLength,
            totalMessageCount: totalMessageCount,
            externalConversationId: externalConversationId,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $1430a03360f0cdb9$export$e33202cdfb6e8294 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'clear',
        actionSubject: 'conversation',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $1430a03360f0cdb9$export$1ad079e189e166f0 = (analyticsClient, conversationId, messageLatency, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'started',
        actionSubject: 'streaming',
        attributes: {
            messageLatency: messageLatency,
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $1430a03360f0cdb9$export$b13699b81838287b = (analyticsClient, messageLatency, confidenceScore, isFallbackMessage, isConfluenceLicensedUser, isVagueQuery, searchResultCount, totalSearchResultCount, conversationId, totalSources, totalHelpDesk, totalRequestForm, messageId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'fetched',
        actionSubject: 'conversation',
        actionSubjectId: conversationId,
        attributes: {
            externalConversationId: externalConversationId,
            messageLatency: messageLatency,
            confidenceScore: confidenceScore,
            isFallbackMessage: isFallbackMessage,
            isConfluenceLicensedUser: isConfluenceLicensedUser,
            isVagueQuery: isVagueQuery,
            searchResultCount: searchResultCount,
            totalSearchResultCount: totalSearchResultCount,
            totalSources: totalSources,
            totalHelpDesk: totalHelpDesk,
            totalRequestForm: totalRequestForm,
            messageId: messageId,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $1430a03360f0cdb9$export$d40db612c63a38bf = (analyticsClient, channelId, isRateLimitingError, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: isRateLimitingError ? 'rateLimited' : 'fetch_failed',
        actionSubject: 'conversation',
        actionSubjectId: channelId,
        attributes: {
            externalConversationId: externalConversationId,
            isAiMate: true,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $1430a03360f0cdb9$export$6d1d2cd3a3ab5d10 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'selected',
        actionSubject: 'followUpQuery',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $kZaOC.getProductIdentifierAttributes)((0, $fgUje.ExperienceType).UNIFIED_HELP)
        }
    });
};

});




parcelRegister("bNsww", function(module, exports) {
$parcel$export(module.exports, "useIsGenerating", () => $555f3f263f12d999$export$d04302655294f9a5);

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $6BbQe = parcelRequire("6BbQe");
const $555f3f263f12d999$export$d04302655294f9a5 = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const [isLastAssistantMessageGenerated] = (0, $6BbQe.useIsLastAssistantMessageGenerated)();
    if (!provider || provider === (0, $etQ17.ConversationProvider).VIRTUAL_AGENT) return false;
    return !isLastAssistantMessageGenerated;
};

});

parcelRegister("1hXlf", function(module, exports) {
$parcel$export(module.exports, "useIsInputEnabled", () => $7680e13514f989b7$export$335460cd33393c4b);

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $6BbQe = parcelRequire("6BbQe");
const $7680e13514f989b7$export$335460cd33393c4b = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const isRouting = (0, $crB7D.useIsRouting)();
    const [isLastMessageFromHelpSeeker] = (0, $6BbQe.useIsLastMessageFromHelpSeeker)();
    const [isLastAssistantMessageGenerated] = (0, $6BbQe.useIsLastAssistantMessageGenerated)();
    if (isRouting) return false;
    if (!provider || provider === (0, $etQ17.ConversationProvider).VIRTUAL_AGENT) return true;
    return isLastAssistantMessageGenerated && !isLastMessageFromHelpSeeker;
};

});

parcelRegister("auzYQ", function(module, exports) {
$parcel$export(module.exports, "useHasMessages", () => $822de15320a10c79$export$cd077d7865053739);

var $d04aK = parcelRequire("d04aK");

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $6BbQe = parcelRequire("6BbQe");
const $822de15320a10c79$export$cd077d7865053739 = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const [AIAnswersConversation] = (0, $6BbQe.useConversation)();
    const VAMessages = (0, $d04aK.useMessages)();
    if (provider === (0, $etQ17.ConversationProvider).VIRTUAL_AGENT) return VAMessages.length > 0;
    return !!AIAnswersConversation;
};

});

parcelRegister("kcpRM", function(module, exports) {
$parcel$export(module.exports, "useStopGenerating", () => $e79b86815d99a245$export$177960b8f80ddb1c);

var $crB7D = parcelRequire("crB7D");

var $6BbQe = parcelRequire("6BbQe");
const $e79b86815d99a245$export$177960b8f80ddb1c = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const { abortConversation: abortConversation } = (0, $6BbQe.useActions)();
    const stopGenerating = ()=>{
        if (provider === 'AI_ANSWERS') abortConversation();
    };
    return {
        stopGenerating: stopGenerating
    };
};

});

parcelRegister("dfO3l", function(module, exports) {
$parcel$export(module.exports, "useGetMaxChars", () => $56ebb0e94929732f$export$6fdff492f3dfb4bb);

var $4ku8A = parcelRequire("4ku8A");

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $gGQzj = parcelRequire("gGQzj");
const $56ebb0e94929732f$export$6fdff492f3dfb4bb = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const { getJiraFieldMaxChars: getJiraFieldMaxChars } = (0, $4ku8A.useGetJiraFieldMaxChars)();
    const getMaxChars = ()=>{
        if (provider === (0, $etQ17.ConversationProvider).VIRTUAL_AGENT) {
            const maxJiraFieldChars = getJiraFieldMaxChars();
            if (maxJiraFieldChars) return maxJiraFieldChars;
        }
        return 0, $gGQzj.MAX_CHARS;
    };
    return {
        getMaxChars: getMaxChars
    };
};

});
parcelRegister("4ku8A", function(module, exports) {
$parcel$export(module.exports, "useGetJiraFieldMaxChars", () => $372dc6cb612313ea$export$1c551de6ec5f7e66);

var $ctTFy = parcelRequire("ctTFy");

var $dODsu = parcelRequire("dODsu");

var $c6Gzm = parcelRequire("c6Gzm");

var $d04aK = parcelRequire("d04aK");
const $372dc6cb612313ea$export$1c551de6ec5f7e66 = ()=>{
    const jiraField = (0, $d04aK.useFieldFromLastMessage)();
    const baseUrl = (0, $d04aK.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $dODsu.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const fieldType = jiraField && (0, $c6Gzm.getFieldType)(jiraField.fieldId, requestTypeFields);
    const getJiraFieldMaxChars = ()=>{
        if (fieldType === (0, $c6Gzm.SHORT_TEXT_FIELD_TYPE)) return 0, $ctTFy.MAX_SHORT_TEXT_FIELD_CHARS;
        if (fieldType === (0, $c6Gzm.PARAGRAPH_FIELD_TYPE)) return 0, $ctTFy.MAX_PARAGRAPH_FIELD_CHARS;
        return undefined;
    };
    return {
        getJiraFieldMaxChars: getJiraFieldMaxChars
    };
};

});
parcelRegister("ctTFy", function(module, exports) {
$parcel$export(module.exports, "MAX_SHORT_TEXT_FIELD_CHARS", () => $39e44de7adeef4bd$export$91e0b38c91e2cd5c);
$parcel$export(module.exports, "MAX_PARAGRAPH_FIELD_CHARS", () => $39e44de7adeef4bd$export$44efb9aa2d3aca69);
$parcel$export(module.exports, "CONVERSATION_TIME_OUT", () => $39e44de7adeef4bd$export$2efd43ac8eb281e1);
const $39e44de7adeef4bd$export$91e0b38c91e2cd5c = 250;
const $39e44de7adeef4bd$export$44efb9aa2d3aca69 = 1000;
const $39e44de7adeef4bd$export$2efd43ac8eb281e1 = 120000; // 2 minutes

});


parcelRegister("gGQzj", function(module, exports) {
$parcel$export(module.exports, "PIPELINE_LOCAL_STORAGE_KEY", () => $316830cc2bf8811a$export$1d9b669fd4b51619);
$parcel$export(module.exports, "DEFAULT_PIPELINE", () => $316830cc2bf8811a$export$dfea82974f95546a);
$parcel$export(module.exports, "LINK_CLICKED_EVENT", () => $316830cc2bf8811a$export$c3919a87590ab58a);
$parcel$export(module.exports, "MAX_CHARS", () => $316830cc2bf8811a$export$3fd15502aa7f615e);
const $316830cc2bf8811a$export$1d9b669fd4b51619 = 'pipeline';
const $316830cc2bf8811a$export$dfea82974f95546a = 'DEFAULT_PIPELINE';
const $316830cc2bf8811a$export$478ff1f86cdd0b2 = 480;
const $316830cc2bf8811a$export$90f94aac6f3ac32d = 744;
const $316830cc2bf8811a$export$460a6c74e2815558 = 1440;
const $316830cc2bf8811a$export$d7ccb212e23ab442 = 1025;
const $316830cc2bf8811a$export$ba668ebd2a2d0856 = 1200;
const $316830cc2bf8811a$export$c3919a87590ab58a = 'link clicked';
const $316830cc2bf8811a$export$3fd15502aa7f615e = 1000;

});


parcelRegister("jM4Ug", function(module, exports) {
$parcel$export(module.exports, "useIsInputShown", () => $43627689d19df8af$export$ae7b9f18d03cb232);

var $crB7D = parcelRequire("crB7D");

var $6BbQe = parcelRequire("6BbQe");
const $43627689d19df8af$export$ae7b9f18d03cb232 = ()=>{
    const provider = (0, $crB7D.useProvider)();
    const [isChannelErrorPresent] = (0, $6BbQe.useIsChannelErrorPresent)();
    if (provider === 'AI_ANSWERS') return !isChannelErrorPresent;
    return true;
};

});

parcelRegister("7RiDJ", function(module, exports) {
$parcel$export(module.exports, "useClearConversation", () => $5bca478cd0ca1a33$export$6dc4e5ebda459b3);

var $d04aK = parcelRequire("d04aK");

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $6BbQe = parcelRequire("6BbQe");
const $5bca478cd0ca1a33$export$6dc4e5ebda459b3 = ()=>{
    const { clearConversation: clearAIAnswerConversation } = (0, $6BbQe.useActions)();
    const { clearConversation: clearVirtualAgentConversation } = (0, $d04aK.useActions)();
    const { setProvider: setProvider } = (0, $crB7D.useActions)();
    const clearConversation = ()=>{
        clearAIAnswerConversation();
        clearVirtualAgentConversation();
        setProvider((0, $etQ17.ConversationProvider).VIRTUAL_AGENT);
    };
    return {
        clearConversation: clearConversation
    };
};

});

parcelRegister("92RpZ", function(module, exports) {
$parcel$export(module.exports, "useHandOffConversation", () => $26af5bcf431d9cd7$export$ad87f5d1da6cbafb);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $9RIwK = parcelRequire("9RIwK");

var $6lbrU = parcelRequire("6lbrU");

var $crB7D = parcelRequire("crB7D");

var $etQ17 = parcelRequire("etQ17");

var $6BbQe = parcelRequire("6BbQe");
const $26af5bcf431d9cd7$export$ad87f5d1da6cbafb = ()=>{
    const { setProvider: setProvider } = (0, $crB7D.useActions)();
    const { takeOverConversationFromVA: takeOverConversationFromVA } = (0, $6BbQe.useActions)();
    const analyticsClient = (0, $6lbrU.getAnalyticsWebClient)().getInstance();
    const sendHandOffAnalyticsEvent = (0, $fc4bM.useCallback)((conversationId, contextId)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/70690
        analyticsClient.sendTrackEvent({
            action: 'rejected',
            actionSubject: 'inferIntent',
            actionSubjectId: 'globalInferIntentFast',
            attributes: {
                conversationId: conversationId,
                contextId: contextId
            },
            source: (0, $9mazR.ScreenName).CONVERSATION_PAGE
        }).catch((error)=>{
            throw new Error(`Failure to send track analytics event ${error}`);
        });
    }, [
        analyticsClient
    ]);
    const handleHandOff = (0, $fc4bM.useCallback)(async (vaMessages, conversationId, contextId)=>{
        sendHandOffAnalyticsEvent(conversationId, contextId);
        if (!vaMessages.length || vaMessages[0].message.authorType !== 'HELPSEEKER') throw Error('Cannot hand off conversation without a helpseeker message');
        const history = vaMessages.map($26af5bcf431d9cd7$var$transformVAMessageToAIAnswersMessage).filter((message)=>message !== null);
        await takeOverConversationFromVA(conversationId, history);
        setProvider((0, $etQ17.ConversationProvider).AI_ANSWERS);
    }, [
        sendHandOffAnalyticsEvent,
        setProvider,
        takeOverConversationFromVA
    ]);
    return {
        handleHandOff: handleHandOff
    };
};
const $26af5bcf431d9cd7$var$extractMessageContent = (message)=>{
    let originalContent = '';
    (0, $9RIwK.traverse)(message.content, {
        text: (node)=>{
            originalContent += node.text;
        }
    });
    return originalContent;
};
const $26af5bcf431d9cd7$var$transformVAMessageToAIAnswersMessage = (message, index)=>{
    switch(message.message.authorType){
        case 'HELPSEEKER':
            return {
                userType: 'helpseeker',
                messageContentAdf: message.message.content,
                messageMetadata: {
                    ...index === 0 ? {
                        originalQuery: $26af5bcf431d9cd7$var$extractMessageContent(message.message)
                    } : {}
                }
            };
        case 'AGENT':
            return {
                userType: 'assistant',
                aiMateConversationResponse: {
                    message: {
                        content: $26af5bcf431d9cd7$var$parseMessageContent(message.message),
                        role: 'assistant',
                        id: String(index),
                        //
                        time_created: message.timeCreated,
                        user_ari: '',
                        plugin_invocations: []
                    }
                },
                messageMetadata: {
                    status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).SYNCED_RESPONSE
                }
            };
        default:
            return null;
    }
};
const $26af5bcf431d9cd7$var$parseMessageContent = (message)=>{
    if (message.contentMimetype === 'application/json+adf') return JSON.parse(message.content);
    return message.content;
};

});


parcelRegister("kctXj", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => (parcelRequire("5J1Fh")).ElementKeyMap);
$parcel$export(module.exports, "isMacOs", () => (parcelRequire("5J1Fh")).isMacOs);
parcelRequire("5J1Fh");

});
parcelRegister("5J1Fh", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => $c062a8243144228c$export$6fa2af2018b3f7a3);
$parcel$export(module.exports, "isMacOs", () => $c062a8243144228c$export$c5e71f489eb3970b);
var $c062a8243144228c$export$6fa2af2018b3f7a3 = /*#__PURE__*/ function(ElementKeyMap) {
    ElementKeyMap["IMAGE"] = "HelpLayoutImageAtomicElement";
    ElementKeyMap["HEADING"] = "HelpLayoutHeadingAtomicElement";
    ElementKeyMap["PARAGRAPH"] = "HelpLayoutParagraphAtomicElement";
    ElementKeyMap["EDITOR"] = "HelpLayoutEditorElement";
    ElementKeyMap["SEARCH"] = "HelpLayoutSearchAtomicElement";
    ElementKeyMap["LINK_CARD"] = "HelpLayoutLinkCardCompositeElement";
    return ElementKeyMap;
}({});
const $c062a8243144228c$export$c5e71f489eb3970b = ()=>navigator.userAgent.includes('Mac');

});


parcelRegister("4gVCP", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $36d47dc56ad18473$export$b2ad68b9bc407b80);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iwD7c = parcelRequire("iwD7c");
const $36d47dc56ad18473$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iwD7c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});

});
parcelRegister("iwD7c", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $a80c07b40d18e78c$export$ff983d2a2b6112ea);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $a01X0 = parcelRequire("a01X0");
const $a80c07b40d18e78c$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $a01X0.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("a01X0", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $07d3fcef8db90adf$export$2f62ee6831462844);

var $fc4bM = parcelRequire("fc4bM");
function $07d3fcef8db90adf$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("0iMl4", function(module, exports) {
$parcel$export(module.exports, "withHelpCenterConversationStateContainer", () => $6c03936576dc5937$export$8bee59b293b5a56c);

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");
var $6FZlb = parcelRequire("6FZlb");
var $7lAXH = parcelRequire("7lAXH");

var $iSFD9 = parcelRequire("iSFD9");

var $crB7D = parcelRequire("crB7D");

var $gGrB8 = parcelRequire("gGrB8");
parcelRequire("7e7Tg");
var $7RiDJ = parcelRequire("7RiDJ");
var $92RpZ = parcelRequire("92RpZ");

var $6icI7 = parcelRequire("6icI7");

var $luVbf = parcelRequire("luVbf");

var $1jmCw = parcelRequire("1jmCw");

var $d04aK = parcelRequire("d04aK");
const $6c03936576dc5937$export$8bee59b293b5a56c = (WrappedComponent)=>{
    const WithConversationStateContainer = (props)=>{
        const { contextId: contextId } = props;
        const [isTestConversationParam] = (0, $6FZlb.useQueryParam)('isTestConversation');
        const [portalId] = (0, $lJu6R.usePathParam)('portalId');
        const isTestConversation = isTestConversationParam === 'true';
        const { handleHandOff: handleHandOff } = (0, $92RpZ.useHandOffConversation)();
        const conversationProvider = (0, $6icI7.useVirtualAgentConversationV2Provider)({
            isTestConversation: isTestConversation,
            contextId: contextId,
            cloudId: (0, $6LH8a.getCloudId)(),
            channelType: portalId ? (0, $luVbf.ChannelType).Portal : (0, $luVbf.ChannelType).HelpCenter
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1jmCw.ConversationStateContainer), {
            conversationProvider: conversationProvider,
            contextId: contextId,
            handleHandOff: handleHandOff,
            isTestConversation: isTestConversation,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($6c03936576dc5937$var$GlobalConversationStateManager, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props));
    };
    return (0, $gGrB8.withRoutingStateContainer)(WithConversationStateContainer);
};
/*
 * With react-sweet-state, we can not persistence the state of the store when there is no consumer, in this case, we have to
 * use a global state to preserve the state of the store when the consumer is unmounted, and use this component to reset
 * the state of the store when the user navigates away from the conversation page.
 */ const $6c03936576dc5937$var$GlobalConversationStateManager = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    const { resetState: resetState } = (0, $crB7D.useActions)();
    const { clearConversation: clearConversation } = (0, $7RiDJ.useClearConversation)();
    const { resetState: resetVAState } = (0, $d04aK.useActions)();
    (0, $iSFD9.useIsoMorphicLayoutEffect)(()=>{
        if (routerState.location.pathname !== '/conversation') {
            clearConversation();
            resetState();
            resetVAState();
        }
    }, [
        routerState.location.pathname,
        resetState,
        resetVAState,
        clearConversation
    ]);
    return null;
};

});
parcelRegister("gGrB8", function(module, exports) {
$parcel$export(module.exports, "withRoutingStateContainer", () => $299083e197b96a5d$export$fcbcda437b73d924);

var $fc4bM = parcelRequire("fc4bM");

var $3Cfsu = parcelRequire("3Cfsu");
const $299083e197b96a5d$export$fcbcda437b73d924 = (WrappedComponent)=>{
    const WithRoutingStateContainer = (props)=>{
        const { contextId: contextId } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3Cfsu.RoutingStateContainer), {
            contextId: contextId,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props));
    };
    return WithRoutingStateContainer;
};

});

parcelRegister("6icI7", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentConversationV2Provider", () => $2fd7969b88e839c6$export$2e4d3c305d19e2ad);

var $fc4bM = parcelRequire("fc4bM");

var $c0Y6o = parcelRequire("c0Y6o");

var $luVbf = parcelRequire("luVbf");
const $2fd7969b88e839c6$export$2e4d3c305d19e2ad = ({ contextId: contextId, cloudId: cloudId, isTestConversation: isTestConversation, channelType: channelType, baseUrl: baseUrl = '' })=>{
    const startConversation = (0, $fc4bM.useCallback)(async (abortSignal, message)=>{
        try {
            const requestMessage = message ? {
                message: {
                    content: JSON.stringify(message.content)
                }
            } : null;
            const response = await (0, $c0Y6o.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    channelType: channelType,
                    contextId: contextId,
                    createdAt: new Date().toISOString(),
                    isTestConversation: isTestConversation === true,
                    ...requestMessage
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return undefined;
            throw error;
        }
    }, [
        baseUrl,
        cloudId,
        isTestConversation,
        channelType,
        contextId
    ]);
    const sendMessage = (0, $fc4bM.useCallback)(async (message, abortSignal)=>{
        try {
            const response = await (0, $c0Y6o.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation/message`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    externalSource: channelType === (0, $luVbf.ChannelType).HelpCenter ? (0, $luVbf.ExternalSource).Orchestrator : (0, $luVbf.ExternalSource).Portal,
                    message: {
                        content: JSON.stringify(message.message.content),
                        optionId: message.message.optionId,
                        jiraField: message.message.jiraField
                    },
                    timeCreated: message.timeCreated,
                    conversationChannelId: message.conversationChannelId
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return [];
            throw error;
        }
    }, [
        baseUrl,
        channelType,
        cloudId
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            startConversation: startConversation,
            sendMessage: sendMessage
        }), [
        sendMessage,
        startConversation
    ]);
};

});
parcelRegister("luVbf", function(module, exports) {
$parcel$export(module.exports, "ChannelType", () => $bcae51c543f9591c$export$36655de2868043ae);
$parcel$export(module.exports, "ExternalSource", () => $bcae51c543f9591c$export$ffc19e40a21f08eb);
const $bcae51c543f9591c$export$36655de2868043ae = {
    Portal: 'JSM_PORTAL',
    HelpCenter: 'JSM_HELP_CENTER',
    Widget: 'JSM_WIDGET'
};
const $bcae51c543f9591c$export$ffc19e40a21f08eb = {
    Portal: 'JSM_PORTAL',
    Orchestrator: 'JSM_ORCHESTRATOR'
};

});



parcelRegister("DFeDK", function(module, exports) {
$parcel$export(module.exports, "initialIntentMessageHCExperience", () => $579c44048fa5a444$export$f0696c364409ed69);
$parcel$export(module.exports, "initialAIMessageHCExperience", () => $579c44048fa5a444$export$25016be9b5cc2f74);
$parcel$export(module.exports, "omnichannelGreetingMessageExperience", () => $579c44048fa5a444$export$c63387a0d6893aba);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $579c44048fa5a444$export$f0696c364409ed69 = new (0, $9LFKj.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message', {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $579c44048fa5a444$export$25016be9b5cc2f74 = new (0, $9LFKj.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message.ai', {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $579c44048fa5a444$export$c63387a0d6893aba = new (0, $9LFKj.UFOExperience)('service-management.help-center.omnichannel.greeting-message', {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("2R60X", function(module, exports) {
$parcel$export(module.exports, "useCreateConversationWithMessage", () => $458b5e70fdc64773$export$d1fc804b2f86fc4);

var $a8Ifq = parcelRequire("a8Ifq");

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $3BZyK = parcelRequire("3BZyK");

var $5KQKg = parcelRequire("5KQKg");

var $j2vls = parcelRequire("j2vls");

var $f5LPR = parcelRequire("f5LPR");

var $DFeDK = parcelRequire("DFeDK");

var $hshIP = parcelRequire("hshIP");

var $4q8Dn = parcelRequire("4q8Dn");

var $3QNa8 = parcelRequire("3QNa8");

var $kDHA8 = parcelRequire("kDHA8");
const $458b5e70fdc64773$export$d1fc804b2f86fc4 = ()=>{
    const [commitMutation, isLoading] = (0, $3BZyK.useMutation)((0, $a8Ifq.default));
    const environment = (0, $3BZyK.useRelayEnvironment)();
    const handleMutationError = (0, $fc4bM.useCallback)(({ message: message, nodeId: nodeId, connectionId: connectionId, subscriptionId: subscriptionId })=>{
        (0, $4q8Dn.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: false
        });
        if (!(0, $hN5YJ.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $3QNa8.deleteNodeFromConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: nodeId
        });
        const metadata = {
            connectionId: connectionId,
            subscriptionId: subscriptionId
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $kDHA8.createConversationWithMessageExperience).failure({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $DFeDK.initialIntentMessageHCExperience).abort({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $DFeDK.initialAIMessageHCExperience).abort({
            metadata: metadata
        });
        (0, $hshIP.addMessageToConnection)({
            message: message,
            environment: environment,
            connectionId: connectionId,
            authorType: 'CombinedAPIError'
        });
    }, [
        environment
    ]);
    const createConversationWithMessage = (0, $fc4bM.useCallback)(({ workspaceAri: workspaceAri, conversationContextAri: conversationContextAri, connectionId: connectionId, onError: onError, message: message, subscriptionId: subscriptionId, isTestConversation: isTestConversation = false })=>{
        const nodeId = (0, $5KQKg.generateUniqueClientID)();
        const content = JSON.stringify((0, $j2vls.doc)((0, $f5LPR.paragraph)(message)));
        (0, $3QNa8.addOptimisticResponseToConnection)({
            environment: environment,
            nodeId: nodeId,
            content: content,
            connectionId: connectionId,
            message: message
        });
        (0, $4q8Dn.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: true
        });
        (0, $3QNa8.updateMessageStatusToHelpseeker)({
            environment: environment
        });
        (0, $3QNa8.resetTimer)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $kDHA8.createConversationWithMessageExperience).start();
        if ((0, $hN5YJ.isOmnichannelGreetingAPIEnabled)()) (0, $3QNa8.addGreetingMessageToConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: (0, $5KQKg.generateUniqueClientID)()
        });
        return commitMutation({
            onCompleted: (response)=>{
                var _response$jsmChat, _response$jsmChat2, _response$jsmChat3, _responseData$convers, _responseData$convers3;
                if (!(response !== null && response !== void 0 && (_response$jsmChat = response.jsmChat) !== null && _response$jsmChat !== void 0 && (_response$jsmChat = _response$jsmChat.initializeAndSendMessage) !== null && _response$jsmChat !== void 0 && _response$jsmChat.success) || !(response !== null && response !== void 0 && (_response$jsmChat2 = response.jsmChat) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessage) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessageResponse) !== null && _response$jsmChat2 !== void 0 && _response$jsmChat2.conversationId)) {
                    handleMutationError({
                        nodeId: nodeId,
                        message: message,
                        connectionId: connectionId,
                        subscriptionId: subscriptionId
                    });
                    return;
                }
                const responseData = (_response$jsmChat3 = response.jsmChat) === null || _response$jsmChat3 === void 0 || (_response$jsmChat3 = _response$jsmChat3.initializeAndSendMessage) === null || _response$jsmChat3 === void 0 ? void 0 : _response$jsmChat3.initializeAndSendMessageResponse;
                (0, $4q8Dn.updateOmniChannelConversationMeta)({
                    environment: environment,
                    workspaceAri: workspaceAri,
                    conversationContextAri: conversationContextAri,
                    conversationId: responseData === null || responseData === void 0 ? void 0 : responseData.conversationId
                });
                (0, $3QNa8.clearTimer)(environment);
                if (responseData.conversationId && (_responseData$convers = responseData.conversation) !== null && _responseData$convers !== void 0 && (_responseData$convers = _responseData$convers.node) !== null && _responseData$convers !== void 0 && _responseData$convers.id) {
                    var _responseData$convers2;
                    (0, $3QNa8.updateRelayRecordId)({
                        environment: environment,
                        nodeId: nodeId,
                        newId: (_responseData$convers2 = responseData.conversation) === null || _responseData$convers2 === void 0 || (_responseData$convers2 = _responseData$convers2.node) === null || _responseData$convers2 === void 0 ? void 0 : _responseData$convers2.id
                    });
                }
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $kDHA8.createConversationWithMessageExperience).success({
                    metadata: {
                        subscriptionId: subscriptionId,
                        conversationId: (_responseData$convers3 = responseData.conversation) === null || _responseData$convers3 === void 0 || (_responseData$convers3 = _responseData$convers3.node) === null || _responseData$convers3 === void 0 ? void 0 : _responseData$convers3.id
                    }
                });
            },
            onError: (error)=>{
                handleMutationError({
                    nodeId: nodeId,
                    message: message,
                    connectionId: connectionId,
                    subscriptionId: subscriptionId
                });
                onError === null || onError === void 0 || onError(error);
            },
            variables: {
                workspaceAri: workspaceAri,
                conversationContextAri: conversationContextAri,
                subscriptionId: subscriptionId,
                isTestChannel: isTestConversation,
                message: content
            }
        });
    }, [
        commitMutation,
        environment,
        handleMutationError
    ]);
    return {
        isLoading: isLoading,
        createConversationWithMessage: createConversationWithMessage
    };
};

});
parcelRegister("a8Ifq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f820df4aea86b8d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14f2364d6978501de330e59cb80b7f3b>>
 * @relayHash 6466481040e3141b45532075b56408d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694
const $2f820df4aea86b8d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "conversationContextAri"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isTestChannel"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subscriptionId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "channelExperienceId",
                    "value": "HELPCENTER"
                },
                {
                    "kind": "Variable",
                    "name": "conversationContextAri",
                    "variableName": "conversationContextAri"
                },
                {
                    "kind": "Variable",
                    "name": "isTestChannel",
                    "variableName": "isTestChannel"
                },
                {
                    "kind": "Variable",
                    "name": "message",
                    "variableName": "message"
                },
                {
                    "kind": "Variable",
                    "name": "subscriptionId",
                    "variableName": "subscriptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "concreteType": "JsmChatInitializeAndSendMessageResponse",
        "kind": "LinkedField",
        "name": "initializeAndSendMessageResponse",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "conversationId"
            },
            {
                "concreteType": "JsmChatMessageEdge",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsmChatCreateWebConversationMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "content"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "authorType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "contentType"
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694",
            "metadata": {},
            "name": "createConversationWithMessageMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2f820df4aea86b8d$var$node.hash = "b29d0beea262991f003cc1fee9761127";
var $2f820df4aea86b8d$export$2e2bcd8739ae039 = $2f820df4aea86b8d$var$node;

});

parcelRegister("hshIP", function(module, exports) {
$parcel$export(module.exports, "addMessageToConnection", () => $4ddace05ade6e0be$export$8dbc74cf18f1a65e);
$parcel$export(module.exports, "addNodeToConnection", () => $4ddace05ade6e0be$export$7163757da5dc49f0);
$parcel$export(module.exports, "addNodeToCurrentConnection", () => $4ddace05ade6e0be$export$d88c7883f045ee5);

var $5KQKg = parcelRequire("5KQKg");

var $4h23n = parcelRequire("4h23n");
const $4ddace05ade6e0be$export$8dbc74cf18f1a65e = ({ environment: environment, connectionId: connectionId, message: message, authorType: authorType })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const nodeId = `client:jsmChat:conversation:${(0, $4h23n.v4)()}:customMessage:node`;
        const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
        node.setValue(nodeId, 'id');
        node.setValue(authorType, 'authorType');
        if (message) node.setValue(message, 'content');
        node.setValue('ADF', 'contentType');
        node.setValue(null, 'appendices');
        const newEdge = (0, $5KQKg.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
        (0, $5KQKg.ConnectionHandler).insertEdgeAfter(connection, newEdge);
    });
};
const $4ddace05ade6e0be$export$7163757da5dc49f0 = ({ store: store, recordId: recordId, connectionId: connectionId, edgeName: edgeName })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $5KQKg.ConnectionHandler).createEdge(store, connection, node, edgeName);
    (0, $5KQKg.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};
const $4ddace05ade6e0be$export$d88c7883f045ee5 = ({ store: store, connectionId: connectionId, recordId: recordId })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $5KQKg.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
    (0, $5KQKg.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};

});

parcelRegister("4q8Dn", function(module, exports) {
$parcel$export(module.exports, "updateOmniChannelConversationMeta", () => $b6492fc21b0be5eb$export$8c33322c5b64f409);
$parcel$export(module.exports, "updateOmniChannelConversationMetaPromise", () => $b6492fc21b0be5eb$export$b90325dd8c9d560b);

var $5KQKg = parcelRequire("5KQKg");
const $b6492fc21b0be5eb$export$8c33322c5b64f409 = ({ environment: environment, ...remainingParams })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        Object.keys(remainingParams).forEach((key)=>{
            jsmChatQuery.setValue(remainingParams[key], key);
        });
    });
};
const $b6492fc21b0be5eb$export$b90325dd8c9d560b = ({ environment: environment, ...remainingParams })=>{
    return new Promise((resolve)=>{
        (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            Object.keys(remainingParams).forEach((key)=>{
                jsmChatQuery.setValue(remainingParams[key], key);
            });
            resolve(undefined);
        });
    });
};

});

parcelRegister("3QNa8", function(module, exports) {
$parcel$export(module.exports, "cleanFollowups", () => $d52c3224c9ea9ec9$export$8ce7049bbf52d43c);
$parcel$export(module.exports, "createFollowupMessageNode", () => $d52c3224c9ea9ec9$export$2e2870a1f1e8fe34);
$parcel$export(module.exports, "generateAIResponseNodeId", () => $d52c3224c9ea9ec9$export$de38df1b227321b8);
$parcel$export(module.exports, "addOptimisticResponseToConnection", () => $d52c3224c9ea9ec9$export$fbc4600ca9d78672);
$parcel$export(module.exports, "deleteNodeFromConnection", () => $d52c3224c9ea9ec9$export$7da93f9af6d9769b);
$parcel$export(module.exports, "updateRelayRecordId", () => $d52c3224c9ea9ec9$export$1424edefd4c57a66);
$parcel$export(module.exports, "addInteractionMessageToConnection", () => $d52c3224c9ea9ec9$export$8c802e3a762f0d7b);
$parcel$export(module.exports, "convertInteractionMessageToErrorMessage", () => $d52c3224c9ea9ec9$export$e868b53e9633f590);
$parcel$export(module.exports, "resetTimer", () => $d52c3224c9ea9ec9$export$148d61ea341bbff7);
$parcel$export(module.exports, "clearTimer", () => $d52c3224c9ea9ec9$export$4ffebd63913d6ea0);
$parcel$export(module.exports, "updateLastAIConversationAbortStatus", () => $d52c3224c9ea9ec9$export$3c299bb7936c424a);
$parcel$export(module.exports, "updateMessageStatusToHelpseeker", () => $d52c3224c9ea9ec9$export$c179851fb8c72922);
$parcel$export(module.exports, "getInteractionMetaFromNode", () => $d52c3224c9ea9ec9$export$9a8b1bfde220a901);
$parcel$export(module.exports, "getLastHelpSeekerMessage", () => $d52c3224c9ea9ec9$export$7d3bdcb2e57adde1);
$parcel$export(module.exports, "setDraftMessage", () => $d52c3224c9ea9ec9$export$ae6e25e430bcd18b);
$parcel$export(module.exports, "handleActionParamFromSubscription", () => $d52c3224c9ea9ec9$export$55d3e467a155fb59);
$parcel$export(module.exports, "fetchOmnichannelMeta", () => $d52c3224c9ea9ec9$export$b0fec83cc7daf9d0);
$parcel$export(module.exports, "getConnectionIdFromStore", () => $d52c3224c9ea9ec9$export$dd1db642ae57c18e);
$parcel$export(module.exports, "addGreetingMessageToConnection", () => $d52c3224c9ea9ec9$export$18db76d681ccfece);

var $5KQKg = parcelRequire("5KQKg");

var $etQ17 = parcelRequire("etQ17");

var $5f8Wg = parcelRequire("5f8Wg");

var $DFeDK = parcelRequire("DFeDK");

var $ifag0 = parcelRequire("ifag0");

var $6Lqco = parcelRequire("6Lqco");

var $hshIP = parcelRequire("hshIP");
const $d52c3224c9ea9ec9$export$8ce7049bbf52d43c = ({ environment: environment, connectionId: connectionId })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Followup_Message') (0, $5KQKg.ConnectionHandler).deleteNode(connection, node.getDataID());
        });
    });
};
const $d52c3224c9ea9ec9$export$2e2870a1f1e8fe34 = (content, store)=>{
    const nodeId = (0, $5KQKg.generateUniqueClientID)();
    const followupNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    followupNode.setValue(nodeId, 'id');
    followupNode.setValue('Followup_Message', 'authorType');
    followupNode.setValue(JSON.stringify(content), 'content');
    return nodeId;
};
const $d52c3224c9ea9ec9$export$de38df1b227321b8 = (id)=>{
    return `client::jsmChat::aiResponse::${id}`;
};
const $d52c3224c9ea9ec9$export$50d7b649a01ab7a5 = ({ content: content, store: store, nodeId: nodeId, message: message })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue('Reporter', 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    node.setValue(message, 'message');
    return node;
};
const $d52c3224c9ea9ec9$export$fbc4600ca9d78672 = ({ environment: environment, connectionId: connectionId, content: content, nodeId: nodeId, message: message })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        $d52c3224c9ea9ec9$export$50d7b649a01ab7a5({
            content: content,
            store: store,
            nodeId: nodeId,
            message: message
        });
        (0, $hshIP.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $d52c3224c9ea9ec9$export$7da93f9af6d9769b = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('id');
            if (authorType === nodeId) {
                (0, $5KQKg.ConnectionHandler).deleteNode(connection, node.getDataID());
                store.delete(node.getDataID());
            }
        });
    });
};
const $d52c3224c9ea9ec9$export$1424edefd4c57a66 = ({ environment: environment, nodeId: nodeId, newId: newId })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) node.setValue(newId, 'id');
    });
};
const $d52c3224c9ea9ec9$export$8c802e3a762f0d7b = ({ environment: environment, message: message, nodeId: nodeId, connectionId: connectionId, interactionMeta: interactionMeta })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const node = $d52c3224c9ea9ec9$export$50d7b649a01ab7a5({
            store: store,
            nodeId: nodeId,
            message: interactionMeta.message,
            content: message
        });
        node.setValue('InteractionMessage', 'authorType');
        node.setValue(JSON.stringify(interactionMeta), 'interactionFieldMeta');
        (0, $hshIP.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $d52c3224c9ea9ec9$export$e868b53e9633f590 = ({ nodeId: nodeId, environment: environment, message: message })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) {
            node.setValue('InteractionError', 'authorType');
            node.setValue(message, 'content');
        }
    });
};
const $d52c3224c9ea9ec9$export$148d61ea341bbff7 = ({ environment: environment, expiry: expiry = (0, $5f8Wg.CHANNEL_EXPIRY_TIME_24HRS), channelMessage: channelMessage = (0, $etQ17.ChannelMessageTypes).CHANNEL_EXPIRY })=>{
    $d52c3224c9ea9ec9$export$4ffebd63913d6ea0(environment);
    const timer = setTimeout(()=>{
        (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) return;
            const channelMessageNode = $d52c3224c9ea9ec9$export$3c157ef8b8581f8d(store, channelMessage);
            (0, $hshIP.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: channelMessageNode.getDataID(),
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isConversationExpired');
            const connection = store.get(connectionId);
            if (!connection) return;
            const edges = connection.getLinkedRecords('edges');
            if (!edges) return;
            edges.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                if (!node) return;
                const authorType = node.getValue('authorType');
                if (authorType === 'Followup_Message') (0, $5KQKg.ConnectionHandler).deleteNode(connection, node.getDataID());
            });
        });
    }, expiry);
    $d52c3224c9ea9ec9$export$6467bd9f4ef23cb9(environment, timer);
};
const $d52c3224c9ea9ec9$export$6467bd9f4ef23cb9 = (environment, timer)=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(timer, 'timer');
    });
};
const $d52c3224c9ea9ec9$export$4ffebd63913d6ea0 = (environment)=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const timerId = jsmChatQuery.getValue('timer') ?? 0;
        clearTimeout(timerId);
    });
};
const $d52c3224c9ea9ec9$export$3c157ef8b8581f8d = (store, type)=>{
    const nodeId = (0, $5KQKg.generateUniqueClientID)();
    const channelMessageNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    channelMessageNode.setValue(nodeId, 'id');
    channelMessageNode.setValue('ChannelMessage', 'authorType');
    channelMessageNode.setValue(type, 'content');
    return channelMessageNode;
};
const $d52c3224c9ea9ec9$export$3c299bb7936c424a = ({ environment: environment, status: status })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        if (!connectionId) return;
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        for (const edge of edges.reverse()){
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Assistant_Message') {
                const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
                assistantMessageNode.setValue(status, 'isAborted');
                return;
            }
        }
    });
};
const $d52c3224c9ea9ec9$export$c179851fb8c72922 = ({ environment: environment })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue((0, $ifag0.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
    });
};
const $d52c3224c9ea9ec9$export$4941c3f3a49f3f68 = ({ environment: environment, nodeId: nodeId, action: action })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (!node) return;
        node.setValue(action, 'action');
    });
};
const $d52c3224c9ea9ec9$export$9a8b1bfde220a901 = ({ environment: environment, nodeId: nodeId })=>{
    return new Promise((resolve, reject)=>{
        (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
            const node = store.get(nodeId);
            if (!node) {
                reject(new Error('No Node found'));
                return;
            }
            const interactionMeta = node === null || node === void 0 ? void 0 : node.getValue('interactionFieldMeta');
            if (!interactionMeta) {
                reject(new Error('No InteractionMeta found'));
                return;
            }
            resolve((0, $6Lqco.parseJson)(interactionMeta));
        });
    });
};
const $d52c3224c9ea9ec9$export$7d3bdcb2e57adde1 = ({ environment: environment })=>{
    return new Promise((resolve, reject)=>{
        (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) {
                reject(new Error('No ConnectionID Found'));
                return;
            }
            const connection = store.get(connectionId);
            if (!connection) {
                reject(new Error('No Connection Found'));
                return;
            }
            const edges = connection.getLinkedRecords('edges');
            if (!edges) {
                reject(new Error('No Messages Found'));
                return;
            }
            for (const edge of edges.reverse()){
                const node = edge.getLinkedRecord('node');
                const authorType = node === null || node === void 0 ? void 0 : node.getValue('authorType');
                if (authorType === 'Reporter') {
                    resolve(node === null || node === void 0 ? void 0 : node.getValue('message'));
                    return;
                }
            }
        });
    });
};
const $d52c3224c9ea9ec9$export$ae6e25e430bcd18b = ({ environment: environment, message: message })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(message, 'draftMessage');
    });
};
const $d52c3224c9ea9ec9$export$55d3e467a155fb59 = ({ action: action, environment: environment, nodeId: nodeId, connectionId: connectionId })=>{
    // oxlint-disable-next-line default-case
    switch(action){
        case 'REDIRECT_TO_SEARCH':
            $d52c3224c9ea9ec9$export$4941c3f3a49f3f68({
                environment: environment,
                nodeId: nodeId,
                action: action
            });
            break;
        case 'CLOSE_CONVERSATION':
            $d52c3224c9ea9ec9$export$148d61ea341bbff7({
                environment: environment,
                expiry: 0,
                channelMessage: (0, $etQ17.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
            });
            break;
        case 'DISABLE_INPUT':
            if (connectionId) {
                $d52c3224c9ea9ec9$export$8ce7049bbf52d43c({
                    environment: environment,
                    connectionId: connectionId
                });
                $d52c3224c9ea9ec9$export$ede71f104937b4ea(environment, true);
            }
            break;
    }
};
const $d52c3224c9ea9ec9$export$ede71f104937b4ea = (environment, status)=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(status, 'disableInput');
    });
};
const $d52c3224c9ea9ec9$export$b0fec83cc7daf9d0 = (environment)=>{
    return new Promise((resolve, reject)=>{
        (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            if (!root) reject(new Error('No Root Found'));
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const conversationId = jsmChatQuery.getValue('conversationId');
            const connectionId = jsmChatQuery.getValue('connectionId');
            const conversationContextAri = jsmChatQuery.getValue('conversationContextAri');
            const hasMessage = jsmChatQuery.getValue('hasMessage');
            const isReplyPending = jsmChatQuery.getValue('isReplyPending');
            const aiAnswerStatus = jsmChatQuery.getValue('aiAnswerStatus');
            const draftMessage = jsmChatQuery.getValue('draftMessage');
            const isConversationExpired = jsmChatQuery.getValue('isConversationExpired');
            const isConversationClosed = jsmChatQuery.getValue('isConversationClosed');
            const disableInput = jsmChatQuery.getValue('disableInput');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            const greetingMessage = jsmChatQuery.getValue('greetingMessage');
            const subscriptionTriggered = jsmChatQuery.getValue('subscriptionTriggered');
            subscriptionTriggered;
            resolve({
                conversationId: conversationId,
                connectionId: connectionId,
                conversationContextAri: conversationContextAri,
                hasMessage: hasMessage,
                isReplyPending: isReplyPending,
                aiAnswerStatus: aiAnswerStatus,
                draftMessage: draftMessage,
                isConversationExpired: isConversationExpired,
                isConversationClosed: isConversationClosed,
                disableInput: disableInput,
                subscriptionId: subscriptionId,
                greetingMessage: greetingMessage,
                subscriptionTriggered: subscriptionTriggered
            });
        });
    });
};
const $d52c3224c9ea9ec9$export$dd1db642ae57c18e = (store)=>{
    const root = store.getRoot();
    const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
    return jsmChatQuery.getValue('connectionId');
};
const $d52c3224c9ea9ec9$export$87805a37c19b2fb7 = ({ content: content, store: store, nodeId: nodeId, authorType: authorType })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue(authorType, 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    return node;
};
const $d52c3224c9ea9ec9$export$18db76d681ccfece = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const content = jsmChatQuery.getValue('greetingMessage') ?? '';
        const isGreetingMessageAdded = jsmChatQuery.getValue('isGreetingMessageAdded') ?? false;
        if (!isGreetingMessageAdded) {
            const authorType = content !== '' ? 'VirtualAgent' : 'GreetingMessage';
            $d52c3224c9ea9ec9$export$87805a37c19b2fb7({
                content: content,
                store: store,
                nodeId: nodeId,
                authorType: authorType
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $DFeDK.omnichannelGreetingMessageExperience).success({
                metadata: {
                    connectionId: connectionId,
                    conversationId: jsmChatQuery.getValue('conversationId') ?? ''
                }
            });
            (0, $hshIP.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: nodeId,
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isGreetingMessageAdded');
        }
    });
};

});
parcelRegister("5f8Wg", function(module, exports) {
$parcel$export(module.exports, "MAX_CHARS", () => $3cfc36a9f3add47a$export$3fd15502aa7f615e);
$parcel$export(module.exports, "CHANNEL_EXPIRY_TIME_24HRS", () => $3cfc36a9f3add47a$export$76a18595b547627f);
const $3cfc36a9f3add47a$export$3fd15502aa7f615e = 1000; // Used in Input component
const $3cfc36a9f3add47a$export$10482ada0e471d1d = 300000; // 5mins
const $3cfc36a9f3add47a$export$76a18595b547627f = 86400000; // 24 Hrs

});

parcelRegister("ifag0", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerMessageStatus", () => $46d935563373cd29$export$2cdf090c2d29ef5f);
var $46d935563373cd29$export$2cdf090c2d29ef5f = /*#__PURE__*/ function(HelpSeekerMessageStatus) {
    HelpSeekerMessageStatus["IDLE"] = "helpseeker_idle";
    return HelpSeekerMessageStatus;
}({});

});

parcelRegister("6Lqco", function(module, exports) {
$parcel$export(module.exports, "parseJson", () => $7ee1c106916dca7c$export$18c43dcebf00e571);
$parcel$export(module.exports, "isMessageGenerated", () => $7ee1c106916dca7c$export$c2e15cdb6fbfcd43);

var $etQ17 = parcelRequire("etQ17");

var $ifag0 = parcelRequire("ifag0");
const $7ee1c106916dca7c$export$18c43dcebf00e571 = (value)=>{
    try {
        return typeof value === 'string' ? JSON.parse(value) : undefined;
    } catch (e) {
        return undefined;
    }
};
const $7ee1c106916dca7c$export$c2e15cdb6fbfcd43 = (status)=>{
    if (!status) return true;
    if (status === (0, $ifag0.HelpSeekerMessageStatus).IDLE) return true;
    return [
        (0, $etQ17.ASSISTANT_MESSAGE_STATUS).IDLE,
        (0, $etQ17.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
    ].indexOf(status) !== -1;
};

});


parcelRegister("kDHA8", function(module, exports) {
$parcel$export(module.exports, "createConversationWithMessageExperience", () => $b2cdb6fc8b29a4f3$export$bcb43460f5483389);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $b2cdb6fc8b29a4f3$var$createConversationWithMessageExperienceId = 'service-management.help-center.omnichannel.combined-api';
const $b2cdb6fc8b29a4f3$export$bcb43460f5483389 = new (0, $9LFKj.UFOExperience)($b2cdb6fc8b29a4f3$var$createConversationWithMessageExperienceId, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("2Dm35", function(module, exports) {
$parcel$export(module.exports, "establishSubscriptionToOmnichannel", () => $330b13ea6c23d49c$export$190438bc49e7cd0e);

var $cewsl = parcelRequire("cewsl");

var $hN5YJ = parcelRequire("hN5YJ");

var $5KQKg = parcelRequire("5KQKg");

var $2xOCW = parcelRequire("2xOCW");

var $9wfiI = parcelRequire("9wfiI");

var $DFeDK = parcelRequire("DFeDK");

var $6Lqco = parcelRequire("6Lqco");

var $hshIP = parcelRequire("hshIP");

var $5g9hl = parcelRequire("5g9hl");

var $4q8Dn = parcelRequire("4q8Dn");

var $3QNa8 = parcelRequire("3QNa8");

var $ihvuu = parcelRequire("ihvuu");
const $330b13ea6c23d49c$var$SubscriptionGL = (0, $cewsl.default);
const $330b13ea6c23d49c$export$190438bc49e7cd0e = ({ environment: environment, subscriptionId: subscriptionId })=>{
    const metadata = {
        subscriptionId: subscriptionId
    };
    (0, $ihvuu.subscriptionConnectionExperience).start();
    return (0, $5KQKg.requestSubscription)(environment, {
        onError: (error)=>{
            if ((0, $hN5YJ.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $4q8Dn.updateOmniChannelConversationMeta)({
                environment: environment,
                subscriptionStatus: 'FAILED'
            });
            (0, $DFeDK.initialAIMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $DFeDK.initialIntentMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $ihvuu.subscriptionConnectionExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $9wfiI.sendErrorEvent)({
                error: error,
                actionSubject: 'omnichannelSubscription',
                attributes: {
                    ...metadata
                }
            });
        },
        onNext: (data)=>{
            var _data$jsmChat, _data$jsmChat2, _data$jsmChat6, _node$content;
            if ((data === null || data === void 0 || (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.updateConversation) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.result) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__typename) === 'JsmChatWebSubscriptionEstablishedPayload') {
                if ((0, $hN5YJ.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $4q8Dn.updateOmniChannelConversationMeta)({
                    environment: environment,
                    subscriptionStatus: 'ACTIVE'
                });
                (0, $ihvuu.subscriptionConnectionExperience).success({
                    metadata: metadata
                });
                return;
            }
            if ((data === null || data === void 0 || (_data$jsmChat2 = data.jsmChat) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.updateConversation) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.result) === null || _data$jsmChat2 === void 0 ? void 0 : _data$jsmChat2.__typename) === 'JsmChatWebConversationUpdateQueryError') {
                var _data$jsmChat3, _data$jsmChat4, _data$jsmChat5;
                (0, $9wfiI.sendErrorEvent)({
                    error: new Error((data === null || data === void 0 || (_data$jsmChat3 = data.jsmChat) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.updateConversation) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.result) === null || _data$jsmChat3 === void 0 ? void 0 : _data$jsmChat3.message) ?? 'Payload Error in Subscription'),
                    actionSubject: 'omnichannelSubscription',
                    attributes: {
                        ...metadata
                    }
                });
                (0, $DFeDK.initialIntentMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat4 = data.jsmChat) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.updateConversation) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.result) === null || _data$jsmChat4 === void 0 ? void 0 : _data$jsmChat4.message) ?? 'Payload Error in Subscription'
                    }
                });
                (0, $DFeDK.initialAIMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat5 = data.jsmChat) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.updateConversation) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.result) === null || _data$jsmChat5 === void 0 ? void 0 : _data$jsmChat5.message) ?? 'Payload Error in Subscription'
                    }
                });
            }
            if (!(data !== null && data !== void 0 && (_data$jsmChat6 = data.jsmChat) !== null && _data$jsmChat6 !== void 0 && (_data$jsmChat6 = _data$jsmChat6.updateConversation) !== null && _data$jsmChat6 !== void 0 && _data$jsmChat6.conversation)) {
                (0, $4q8Dn.updateOmniChannelConversationMeta)({
                    environment: environment,
                    isReplyPending: false
                });
                return;
            }
            const node = data.jsmChat.updateConversation.conversation.node;
            if (!node) return;
            const recordId = (0, $2xOCW.getRelayDataId)(node === null || node === void 0 ? void 0 : node.id, 'JsmChatCreateWebConversationMessage');
            const action = data.jsmChat.updateConversation.action;
            (0, $3QNa8.handleActionParamFromSubscription)({
                action: action,
                environment: environment,
                connectionId: undefined,
                nodeId: recordId
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((_node$content = node.content) !== null && _node$content !== void 0 && _node$content.aiResponse) {
                var _node$content2;
                (0, $DFeDK.initialAIMessageHCExperience).success({
                    metadata: metadata
                });
                (0, $DFeDK.initialIntentMessageHCExperience).abort({
                    metadata: {
                        ...metadata,
                        actionSubject: 'aiReceived'
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                const aiResponse = (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.aiResponse;
                const aiResponseNodeId = (0, $3QNa8.generateAIResponseNodeId)(recordId);
                (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
                    let aiResponseNode = store.get(aiResponseNodeId);
                    if (!aiResponseNode) {
                        aiResponseNode = store.create(aiResponseNodeId, 'JsmChatCreateWebConversationMessage');
                        aiResponseNode.setValue(aiResponseNodeId, 'id');
                        aiResponseNode.setValue('Assistant_Message', 'authorType');
                        const connectionId = (0, $3QNa8.getConnectionIdFromStore)(store);
                        if (connectionId) (0, $hshIP.addNodeToCurrentConnection)({
                            store: store,
                            connectionId: connectionId,
                            recordId: aiResponseNodeId
                        });
                    }
                    store.delete(recordId);
                });
                const streamingMessages = (0, $6Lqco.parseJson)(aiResponse);
                streamingMessages === null || streamingMessages === void 0 || streamingMessages.forEach((streamingMessage)=>{
                    (0, $5g9hl.updateStreamingMessageInStore)({
                        environment: environment,
                        streamingMessage: streamingMessage,
                        connectionId: undefined,
                        recordId: aiResponseNodeId
                    });
                });
            } else {
                if (!action || action !== 'GREETING_MESSAGE') {
                    (0, $DFeDK.initialIntentMessageHCExperience).success({
                        metadata: metadata
                    });
                    (0, $DFeDK.initialAIMessageHCExperience).abort({
                        metadata: {
                            ...metadata,
                            actionSubject: 'intentReceived'
                        }
                    });
                }
                (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
                    const connectionId = (0, $3QNa8.getConnectionIdFromStore)(store);
                    if (connectionId) (0, $hshIP.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: recordId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                });
            }
            if (!action || action !== 'GREETING_MESSAGE') (0, $4q8Dn.updateOmniChannelConversationMeta)({
                environment: environment,
                isReplyPending: false
            });
        },
        subscription: $330b13ea6c23d49c$var$SubscriptionGL,
        variables: {
            conversationId: subscriptionId
        }
    });
};

});
parcelRegister("cewsl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b37b5006351d6773$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98280c1b5202d924d397fb90d5594f34>>
 * @relayHash 66ceed11481c815b912f0ffeaa5b68cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0
const $b37b5006351d6773$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "concreteType": "JsmChatSubscription",
            "kind": "LinkedField",
            "name": "jsmChat",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "conversationId",
                            "variableName": "conversationId"
                        }
                    ],
                    "concreteType": "JsmChatWebSubscriptionResponse",
                    "kind": "LinkedField",
                    "name": "updateConversation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "result",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JsmChatWebSubscriptionEstablishedPayload"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "JsmChatWebConversationUpdateQueryError"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "concreteType": "JsmChatMessageEdge",
                            "kind": "LinkedField",
                            "name": "conversation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "authorType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "content"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentType"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "appendices",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "requestTypeId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jiraProjectId"
                                                        }
                                                    ],
                                                    "type": "JsmChatJiraFieldAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "redirectAction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "baseUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "query"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatOptionAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "placeholder"
                                                        },
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatDropdownAppendix"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0",
            "metadata": {},
            "name": "communicationChannelSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$b37b5006351d6773$var$node.hash = "44da5305c7ec49b7ef2bab1de243b217";
var $b37b5006351d6773$export$2e2bcd8739ae039 = $b37b5006351d6773$var$node;

});

parcelRegister("5g9hl", function(module, exports) {
$parcel$export(module.exports, "updateStreamingMessageInStore", () => $1a41db4c6aa60b8e$export$648f4e23156d6dfe);

var $hN5YJ = parcelRequire("hN5YJ");

var $3BZyK = parcelRequire("3BZyK");

var $6r9Ft = parcelRequire("6r9Ft");

var $etQ17 = parcelRequire("etQ17");

var $ifag0 = parcelRequire("ifag0");

var $6Lqco = parcelRequire("6Lqco");

var $hshIP = parcelRequire("hshIP");

var $3QNa8 = parcelRequire("3QNa8");
const $1a41db4c6aa60b8e$var$getMessageMetaFromStore = (assistantMessage, recordId)=>{
    const DEFAULT_ASSISNTANT_MESSAGE = {
        status: (0, $etQ17.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
        messageId: recordId
    };
    if (!assistantMessage) return DEFAULT_ASSISNTANT_MESSAGE;
    const messageMeta = assistantMessage === null || assistantMessage === void 0 ? void 0 : assistantMessage.getValue('message_metaData');
    try {
        return (0, $6Lqco.parseJson)(messageMeta) ?? DEFAULT_ASSISNTANT_MESSAGE;
    } catch  {
        return DEFAULT_ASSISNTANT_MESSAGE;
    }
};
const $1a41db4c6aa60b8e$export$648f4e23156d6dfe = ({ environment: environment, recordId: recordId, streamingMessage: streamingMessage })=>{
    (0, $3BZyK.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(recordId);
        const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
        const messageContent = (assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('content')) ?? '';
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        const { type: type, content: content } = (0, $6r9Ft.getUHUpdatedMessage)(streamingMessage, {
            content: messageContent,
            role: '',
            id: '0',
            time_created: '',
            user_ari: '',
            plugin_invocations: []
        }) ?? {
            type: ''
        };
        const metaData = $1a41db4c6aa60b8e$var$getMessageMetaFromStore(assistantMessageNode, recordId);
        // AI Conversation can be aborted from `stopGenerating` CTA in Input Box
        const abortStatus = assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('isAborted');
        if (abortStatus) {
            metaData.status = (0, $etQ17.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE;
            jsmChatQuery.setValue((0, $etQ17.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE, 'aiAnswerStatus');
            assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
            return;
        }
        switch(type){
            case 'FOLLOW_UP_QUERIES':
                if ((0, $hN5YJ.isFollowupEnabledForPortal)()) {
                    const nodeId = (0, $3QNa8.createFollowupMessageNode)(content, store);
                    (0, $hshIP.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: nodeId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                }
                break;
            case 'CONTENT_SEARCH':
                metaData.keywords = content.split('|');
                metaData.status = (0, $etQ17.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                jsmChatQuery.setValue((0, $etQ17.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'ANALYSING_STATE':
                metaData.sources = content;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                break;
            case 'ANSWER_PART':
                metaData.status = (0, $etQ17.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(content.content, 'content');
                jsmChatQuery.setValue((0, $etQ17.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'FINAL_RESPONSE':
                {
                    var _aiMetaData$message_m;
                    const aiMetaData = content;
                    metaData.status = (0, $etQ17.ASSISTANT_MESSAGE_STATUS).IDLE;
                    metaData.messageId = aiMetaData.id.toString();
                    const isFallbackMessage = !!((_aiMetaData$message_m = aiMetaData.message_metadata) !== null && _aiMetaData$message_m !== void 0 && _aiMetaData$message_m.isFallbackMessage);
                    metaData.showFeedback = !isFallbackMessage;
                    metaData.isFallbackMessage = isFallbackMessage;
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(content.plugin_invocations), 'pluginInvocation');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(aiMetaData), 'aiMateConversationResponse');
                    jsmChatQuery.setValue((0, $etQ17.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                    if (isFallbackMessage) {
                        node === null || node === void 0 || node.setValue('Init', 'authorType');
                        jsmChatQuery.setValue((0, $ifag0.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
                    }
                    break;
                }
            case 'ERROR':
                node === null || node === void 0 || node.setValue('Assistant_Error', 'authorType');
                jsmChatQuery.setValue((0, $etQ17.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                node === null || node === void 0 || node.setValue(null, 'content');
                break;
            default:
                break;
        }
    });
};

});

parcelRegister("ihvuu", function(module, exports) {
$parcel$export(module.exports, "subscriptionConnectionExperience", () => $88a4d9ab55750ca6$export$1c1eb834db2f7128);
$parcel$export(module.exports, "omnichannelPageLoadExperience", () => $88a4d9ab55750ca6$export$4feb855a2be04fbe);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $88a4d9ab55750ca6$export$1c1eb834db2f7128 = new (0, $9LFKj.UFOExperience)('service-management.help-center.omnichannel-v2.subscription-connection', {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $88a4d9ab55750ca6$export$4feb855a2be04fbe = new (0, $9LFKj.UFOExperience)('service-management.help-center.omnichannel-v2.page-load', {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("9mBuf", function(module, exports) {
$parcel$export(module.exports, "generateUniqueSubscriptionID", () => $b7995bc6e72374db$export$b84750da6cd46f95);

var $6LH8a = parcelRequire("6LH8a");

var $5KQKg = parcelRequire("5KQKg");

var $4h23n = parcelRequire("4h23n");
const $b7995bc6e72374db$export$b84750da6cd46f95 = ({ environment: environment })=>{
    return new Promise((resolve)=>{
        (0, $5KQKg.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            if (!subscriptionId) {
                const newSubscriptionID = `ari:cloud:conversational-help:${(0, $6LH8a.getCloudId)()}:conversation/${(0, $4h23n.v4)()}`;
                jsmChatQuery.setValue(newSubscriptionID, 'subscriptionId');
                jsmChatQuery.setValue(null, 'connectionId');
                resolve(newSubscriptionID);
            }
            resolve(subscriptionId);
        });
    });
};

});

parcelRegister("dofBo", function(module, exports) {
$parcel$export(module.exports, "useSubscriptionStore", () => $1a65c0d57cd961f3$export$554946cac481f18a);
$parcel$export(module.exports, "useSubscriptionAction", () => $1a65c0d57cd961f3$export$b9e415294ecd1592);

var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");

var $k0yjU = parcelRequire("k0yjU");
const $1a65c0d57cd961f3$var$initialState = {
    subscription: {
        dispose: ()=>undefined
    }
};
const $1a65c0d57cd961f3$var$store = (0, $ipn74.createStore)({
    actions: $k0yjU.actions,
    initialState: $1a65c0d57cd961f3$var$initialState,
    name: 'OmnichannelSubscriptionStore'
});
const $1a65c0d57cd961f3$export$554946cac481f18a = (0, $5nVr1.createHook)($1a65c0d57cd961f3$var$store);
const $1a65c0d57cd961f3$export$b9e415294ecd1592 = (0, $5nVr1.createActionsHook)($1a65c0d57cd961f3$var$store);

});
parcelRegister("k0yjU", function(module, exports) {
$parcel$export(module.exports, "actions", () => $c845dccd2bc4cade$export$e324594224ef24da);

var $gMGUo = parcelRequire("gMGUo");
const $c845dccd2bc4cade$export$e324594224ef24da = {
    setSubscriptionDisposer: $gMGUo.setSubscriptionDisposer
};

});
parcelRegister("gMGUo", function(module, exports) {
$parcel$export(module.exports, "setSubscriptionDisposer", () => $e45dc1ee3ab77fb5$export$398a2526d7502a0f);
const $e45dc1ee3ab77fb5$export$398a2526d7502a0f = (disposable)=>({ setState: setState })=>{
        setState({
            subscription: disposable
        });
    };

});



parcelRegister("2EIFN", function(module, exports) {
$parcel$export(module.exports, "OmnichannelClientConnection", () => $7fb326c301ad500a$export$ca9674c8e6a24427);

var $jxHni = parcelRequire("jxHni");

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("ieUrC");
var $euVUr = parcelRequire("euVUr");

var $3BZyK = parcelRequire("3BZyK");

var $f1RIz = parcelRequire("f1RIz");

var $4q8Dn = parcelRequire("4q8Dn");

var $uYmrU = parcelRequire("uYmrU");

var $6Nd92 = parcelRequire("6Nd92");

var $9mBuf = parcelRequire("9mBuf");

var $hITX8 = parcelRequire("hITX8");
const $7fb326c301ad500a$export$8bbd1b8324c70f51 = ()=>{
    var _data$jsmChat;
    const metaData = (0, $f1RIz.useOmnichannelMetaQuery)();
    const subscriptionId = metaData.subscriptionId;
    (0, $6Nd92.useUFOComponentExperience)((0, $hITX8.omnichannelGetConversationExperience));
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $jxHni.default), {
        conversationId: subscriptionId ?? '',
        isEmptyConversation: !subscriptionId
    });
    const newConnectionId = (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.getWebConversation) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__id;
    const environment = (0, $3BZyK.useRelayEnvironment)();
    (0, $fc4bM.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9mBuf.generateUniqueSubscriptionID)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $hITX8.omnichannelGetConversationExperience).start();
    }, [
        environment
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (newConnectionId && metaData.connectionId !== newConnectionId) (0, $4q8Dn.updateOmniChannelConversationMeta)({
            environment: environment,
            connectionId: newConnectionId
        });
    }, [
        environment,
        metaData.connectionId,
        newConnectionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $hITX8.omnichannelGetConversationExperience)
    });
};
const $7fb326c301ad500a$export$ca9674c8e6a24427 = ({ renderError: renderError })=>{
    const onError = (0, $fc4bM.useCallback)((error)=>{
        (0, $hITX8.omnichannelGetConversationExperience).failure({
            metadata: {
                error: error === null || error === void 0 ? void 0 : error.message,
                statusCode: error === null || error === void 0 ? void 0 : error.status
            }
        }).then((0, $aYMdQ.noop)).catch((0, $aYMdQ.noop));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).CONVERSATION_PAGE,
        id: "omnichannel-helpcenter-conversation",
        onError: onError,
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7fb326c301ad500a$export$8bbd1b8324c70f51, null)));
};

});
parcelRegister("jxHni", function(module, exports) {
$parcel$export(module.exports, "default", () => $64936eb7d013ebf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b88b33f9954ab0bdeac663c7a0d645e2>>
 * @relayHash f6c352f48eeebb85cf0c9fbc89dbddb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319
const $64936eb7d013ebf5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEmptyConversation"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v6 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "last",
            "value": 1
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "content"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "getWebConversation",
                                    "args": [
                                        v1 /*: any*/ 
                                    ],
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "__Connection__getWebConversation_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "messageRendererFragment"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "getWebConversation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "authorType"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "action"
                                                                },
                                                                {
                                                                    "concreteType": "JsmChatAssistantMessage",
                                                                    "kind": "LinkedField",
                                                                    "name": "assistantMessage",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pluginInvocation"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "aiMateConversationResponse"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message_metaData"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "appendices",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJsmChatConversationAppendixAction"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatDropdownAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "requestTypeId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraProjectId"
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatJiraFieldAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "redirectAction",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "baseUrl"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "query"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatOptionAppendix"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "conversationId"
                                    ],
                                    "handle": "connection",
                                    "key": "Connection__getWebConversation",
                                    "kind": "LinkedHandle",
                                    "name": "getWebConversation"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "backward",
                        "path": [
                            "jsmChat",
                            "getWebConversation"
                        ]
                    }
                ]
            },
            "name": "omnichannelClientConnectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$64936eb7d013ebf5$var$node.hash = "8ddd798333f81ebc8a31a378348e8046";
var $64936eb7d013ebf5$export$2e2bcd8739ae039 = $64936eb7d013ebf5$var$node;

});

parcelRegister("f1RIz", function(module, exports) {
$parcel$export(module.exports, "useOmnichannelMetaQuery", () => $fbadb09d5917a18c$export$bc28f1e9de226671);

var $iytaA = parcelRequire("iytaA");

var $3BZyK = parcelRequire("3BZyK");
const $fbadb09d5917a18c$export$bc28f1e9de226671 = ()=>{
    var _data$jsmChatConversa, _data$jsmChatConversa2, _data$jsmChatConversa3, _data$jsmChatConversa4, _data$jsmChatConversa5, _data$jsmChatConversa6, _data$jsmChatConversa7, _data$jsmChatConversa8, _data$jsmChatConversa9, _data$jsmChatConversa0, _data$jsmChatConversa1, _data$jsmChatConversa10, _data$jsmChatConversa11;
    const data = (0, $3BZyK.useClientQuery)((0, $iytaA.default), {});
    return {
        conversationId: data === null || data === void 0 || (_data$jsmChatConversa = data.jsmChatConversationMeta) === null || _data$jsmChatConversa === void 0 ? void 0 : _data$jsmChatConversa.conversationId,
        conversationContextAri: data === null || data === void 0 || (_data$jsmChatConversa2 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa2 === void 0 ? void 0 : _data$jsmChatConversa2.conversationContextAri,
        workspaceAri: data === null || data === void 0 || (_data$jsmChatConversa3 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa3 === void 0 ? void 0 : _data$jsmChatConversa3.workspaceAri,
        connectionId: data === null || data === void 0 || (_data$jsmChatConversa4 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa4 === void 0 ? void 0 : _data$jsmChatConversa4.connectionId,
        isReplyPending: !!(data !== null && data !== void 0 && (_data$jsmChatConversa5 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa5 !== void 0 && _data$jsmChatConversa5.isReplyPending),
        isConversationExpired: !!(data !== null && data !== void 0 && (_data$jsmChatConversa6 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa6 !== void 0 && _data$jsmChatConversa6.isConversationExpired),
        aiAnswerStatus: data === null || data === void 0 || (_data$jsmChatConversa7 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa7 === void 0 ? void 0 : _data$jsmChatConversa7.aiAnswerStatus,
        isConversationClosed: !!(data !== null && data !== void 0 && (_data$jsmChatConversa8 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa8 !== void 0 && _data$jsmChatConversa8.isConversationClosed),
        draftMessage: data === null || data === void 0 || (_data$jsmChatConversa9 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa9 === void 0 ? void 0 : _data$jsmChatConversa9.draftMessage,
        disableInput: !!(data !== null && data !== void 0 && (_data$jsmChatConversa0 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa0 !== void 0 && _data$jsmChatConversa0.disableInput),
        subscriptionId: data === null || data === void 0 || (_data$jsmChatConversa1 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa1 === void 0 ? void 0 : _data$jsmChatConversa1.subscriptionId,
        subscriptionTriggered: !!(data !== null && data !== void 0 && (_data$jsmChatConversa10 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa10 !== void 0 && _data$jsmChatConversa10.subscriptionTriggered),
        subscriptionStatus: (data === null || data === void 0 || (_data$jsmChatConversa11 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa11 === void 0 ? void 0 : _data$jsmChatConversa11.subscriptionStatus) ?? 'NONE'
    };
};

});
parcelRegister("iytaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5ae7b1a031c4b3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d0112a424e829068aee0ce4b184f82e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c5ae7b1a031c4b3b$var$node = function() {
    var v0 = [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "concreteType": "JsmChatConversationMeta",
                    "kind": "LinkedField",
                    "name": "jsmChatConversationMeta",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "conversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "conversationContextAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "workspaceAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "connectionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReplyPending"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationExpired"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "aiAnswerStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationClosed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "draftMessage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "disableInput"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionTriggered"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "9615b9f4fbe1d3c4564d22bfc3ed4951",
            "id": null,
            "metadata": {},
            "name": "omnichannelMetaQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c5ae7b1a031c4b3b$var$node.hash = "96778225e661ec1b102bb65714d88315";
var $c5ae7b1a031c4b3b$export$2e2bcd8739ae039 = $c5ae7b1a031c4b3b$var$node;

});


parcelRegister("hITX8", function(module, exports) {
$parcel$export(module.exports, "omnichannelGetConversationExperience", () => $ce7aa5d5f79445d8$export$3ca91a525bd30f3f);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $ce7aa5d5f79445d8$var$omnichannelGetConversationExperienceId = 'service-management.help-center.omnichannel.get-conversation';
const $ce7aa5d5f79445d8$export$3ca91a525bd30f3f = new (0, $9LFKj.UFOExperience)($ce7aa5d5f79445d8$var$omnichannelGetConversationExperienceId, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("7ewOR", function(module, exports) {
$parcel$export(module.exports, "isRemoveInvalidSearchPopupAriaEnabled", () => $07093e929fee7d5e$export$b8287abc1a8f3561);
$parcel$export(module.exports, "SearchPromptPopup", () => $07093e929fee7d5e$export$392e007cdca1b718);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
var $euVUr = parcelRequire("euVUr");
var $fMoeW = parcelRequire("fMoeW");

var $k2M4v = parcelRequire("k2M4v");

const $07093e929fee7d5e$export$48d2544cca703af5 = (0, $dohmo.lazy)(()=>(parcelRequire("aquXO")).then((module)=>module.SearchPromptPopup), {
    moduleId: "./packages/help-center/search/src/search-prompt-popup/search-prompt-popup.tsx"
});
const $07093e929fee7d5e$export$e96ae8d1e74f6354 = 'jsm_hc_search_remove_invalid_popup_aria';
const $07093e929fee7d5e$export$b8287abc1a8f3561 = ()=>(0, $k2M4v.default).checkGate($07093e929fee7d5e$export$e96ae8d1e74f6354);
const $07093e929fee7d5e$var$getFallbackTriggerProps = ()=>$07093e929fee7d5e$export$b8287abc1a8f3561() ? {
        ref: null
    } : {
        ref: null,
        'aria-expanded': false,
        'aria-haspopup': false
    };
const $07093e929fee7d5e$export$392e007cdca1b718 = (props)=>{
    const fallbackTriggerProps = $07093e929fee7d5e$var$getFallbackTriggerProps();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, props.trigger(fallbackTriggerProps))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fMoeW.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($07093e929fee7d5e$export$48d2544cca703af5, props)));
};

});
parcelRegister("aquXO", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gFpRx").then(()=>parcelRequire('4jz9O'));

});


parcelRegister("daevt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ad3bc49d27c78de$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $1ad3bc49d27c78de$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.input.clear'
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.ai'
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputAriaLabelNoAI: {
        defaultMessage: 'Search for information',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.no-ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.no-ai'
    },
    askTheVirtualServiceAgent: {
        defaultMessage: 'Ask the virtual service agent',
        description: 'Hint to the user to initiate the virtual service agent conversation',
        id: 'search.input.placeholder.ai.ask-the-virtual-service-agent'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Hint to the user to press enter to go to search results page',
        id: 'search.input.hint'
    },
    ariaDescription: {
        defaultMessage: 'Typing letters in the search input updates the search results in below data table',
        description: 'description for screen reader users when they focus on the search bar ',
        id: 'search.input.aria-description'
    },
    characterLimitExceeded: {
        defaultMessage: 'Search queries must be {limit, number} characters or less.',
        description: 'Error message shown when the search query exceeds the character limit.',
        id: 'search.input.character-limit-exceeded'
    },
    characterLimitErrorIconLabel: {
        defaultMessage: 'Search query is too long',
        description: 'Accessible label for the error icon shown when the search query is too long.',
        id: 'search.input.character-limit-error-icon-label'
    }
});

});





parcelRegister("7fXGb", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenu", () => (parcelRequire("dNLxc")).default);

var $dNLxc = parcelRequire("dNLxc");

});
parcelRegister("dNLxc", function(module, exports) {
$parcel$export(module.exports, "default", () => $f31894332a36e84d$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $alVAg = parcelRequire("alVAg");

var $beT51 = parcelRequire("beT51");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("kDyYN");
var $55JDS = parcelRequire("55JDS");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("420HT");
var $czHxO = parcelRequire("czHxO");
const $f31894332a36e84d$var$selector = (0, $2n2bS.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $dFKzv.getPortalId)(state);
    const portal = {
        id: portalId,
        name: (0, $9D9SX.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $9D9SX.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $9D9SX.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $9D9SX.getIsProjectSimplified)(state, portalId))
    };
    return {
        portal: portal,
        canAdministerJIRA: (0, $7RWiC.getCanAdministerJIRA)(state),
        hasSiteAdministerAccess: (0, $7RWiC.getHasSiteAdministerAccess)(state),
        canCustomiseHelpCenter: (0, $ePyx3.getCanCustomize)(state),
        defaultColumnSettings: (0, $55JDS.getRequestsColumnSettings)(state),
        jsmAIConfigEnabled: (0, $fYLlE.getJsmAIConfigEnabled)(state),
        projectKey: (0, $9D9SX.getProjectKey)(state, portalId)
    };
}, ({ portal: portal, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, jsmAIConfigEnabled: jsmAIConfigEnabled, projectKey: projectKey })=>({
        portal: portal,
        canAdministerJIRA: canAdministerJIRA,
        hasSiteAdministerAccess: hasSiteAdministerAccess,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        defaultColumnSettings: defaultColumnSettings,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        projectKey: projectKey
    }));
var $f31894332a36e84d$export$2e2bcd8739ae039 = (0, $6umft.default)($f31894332a36e84d$var$selector, {
    openHelpCenterCustomizationSidebar: ()=>(0, $alVAg.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $beT51.customizingRequestListColumn)(true)
})((0, $czHxO.default));

});
parcelRegister("kDyYN", function(module, exports) {
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => (parcelRequire("55JDS")).getEnabledRequestsColumnSettings);
$parcel$export(module.exports, "getRequestsColumnSettings", () => (parcelRequire("55JDS")).getRequestsColumnSettings);
$parcel$export(module.exports, "getStatusFilter", () => (parcelRequire("55JDS")).getStatusFilter);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("55JDS")).isSaveInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("55JDS")).isCustomizing);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => (parcelRequire("55JDS")).getOrderedRequestsColumnSettings);
$parcel$export(module.exports, "isReOrdering", () => (parcelRequire("55JDS")).isReOrdering);

var $55JDS = parcelRequire("55JDS");

});
parcelRegister("55JDS", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $aec2f66c568de9f1$export$a5e47ac90fcdaee8);
$parcel$export(module.exports, "getStatusFilter", () => $aec2f66c568de9f1$export$118cb57d68780367);
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => $aec2f66c568de9f1$export$821f60d0d1e0f967);
$parcel$export(module.exports, "isSaveInProgress", () => $aec2f66c568de9f1$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isCustomizing", () => $aec2f66c568de9f1$export$ce3eed7c98304744);
$parcel$export(module.exports, "isReOrdering", () => $aec2f66c568de9f1$export$f63ec727b3081523);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => $aec2f66c568de9f1$export$3e30ecdbb6a12b60);

var $2n2bS = parcelRequire("2n2bS");

var $4MjGQ = parcelRequire("4MjGQ");
const $aec2f66c568de9f1$export$29021bb8222c3223 = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $aec2f66c568de9f1$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $aec2f66c568de9f1$export$29021bb8222c3223(state);
    return settingsState.columns || [];
};
const $aec2f66c568de9f1$export$118cb57d68780367 = (state)=>{
    const settingsState = $aec2f66c568de9f1$export$29021bb8222c3223(state);
    return settingsState.statusFilter;
};
const $aec2f66c568de9f1$export$821f60d0d1e0f967 = (0, $2n2bS.createSelector)($aec2f66c568de9f1$export$a5e47ac90fcdaee8, (requestsColumnSettings)=>{
    return requestsColumnSettings.filter((column)=>column.isEnabled);
});
const $aec2f66c568de9f1$export$20bb0d907fbbe433 = (state)=>{
    if (!state.ui.requestsColumnSettings) return true;
    return Boolean(state.ui.requestsColumnSettings.isLoading);
};
const $aec2f66c568de9f1$export$2b75ac2de7a23db1 = (state)=>{
    var _state$ui$requestsCol;
    return Boolean((_state$ui$requestsCol = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol === void 0 ? void 0 : _state$ui$requestsCol.isSaveInProgress);
};
const $aec2f66c568de9f1$export$ce3eed7c98304744 = (state)=>{
    var _state$ui$requestsCol2;
    return Boolean((_state$ui$requestsCol2 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol2 === void 0 ? void 0 : _state$ui$requestsCol2.isCustomizing);
};
const $aec2f66c568de9f1$export$f63ec727b3081523 = (state)=>{
    var _state$ui$requestsCol3;
    return Boolean((_state$ui$requestsCol3 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol3 === void 0 ? void 0 : _state$ui$requestsCol3.isReOrdering);
};
const $aec2f66c568de9f1$export$c7b5b7c6c2c6936 = (state)=>{
    var _state$ui$requestsCol4;
    return (_state$ui$requestsCol4 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol4 === void 0 ? void 0 : _state$ui$requestsCol4.columnsOrder;
};
const $aec2f66c568de9f1$export$3e30ecdbb6a12b60 = (0, $2n2bS.createSelector)($aec2f66c568de9f1$export$821f60d0d1e0f967, $aec2f66c568de9f1$export$c7b5b7c6c2c6936, (enabledColumnSettings, columnsOrder)=>{
    if (columnsOrder && columnsOrder.length > 0) return columnsOrder.map((index)=>enabledColumnSettings === null || enabledColumnSettings === void 0 ? void 0 : enabledColumnSettings[index]);
    const filteredColumns = enabledColumnSettings.filter((column)=>column.order);
    if (filteredColumns.length > 0) return filteredColumns.sort((a, b)=>{
        if (a.order && b.order) return a.order - b.order;
        return 1;
    });
    /*
   * We fire analytics when enabledColumnSettings is not empty (to filter out noise) and filteredColumns
   * is empty implying that order is prop is undefined for all the columns. This is an erroneous state
   * since we expect at least one column to have order prop defined. If this happens, we return enabledColumnSettings
   * as is.
   */ if (enabledColumnSettings && enabledColumnSettings.length > 0) (0, $4MjGQ.operationalEvent)({
        action: 'emptyOrderedRequestColumnSettingsReceived',
        actionSubject: 'request-list-filters-and-table',
        source: 'RequestList'
    });
    return enabledColumnSettings;
});

});


parcelRegister("420HT", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenuDumb", () => (parcelRequire("czHxO")).default);

var $czHxO = parcelRequire("czHxO");

});
parcelRegister("czHxO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3b1679963b90455$export$2e2bcd8739ae039);
/* customise-menu-dumb.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $6SuMw = parcelRequire("6SuMw");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $MPQAF = parcelRequire("MPQAF");
var $io4o2 = parcelRequire("io4o2");

var $g9mbo = parcelRequire("g9mbo");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $6LH8a = parcelRequire("6LH8a");

var $fOCtI = parcelRequire("fOCtI");

var $lXJd8 = parcelRequire("lXJd8");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
parcelRequire("kOWPe");
var $bwpot = parcelRequire("bwpot");
parcelRequire("gcRsK");
var $dJF35 = parcelRequire("dJF35");

var $jEubQ = parcelRequire("jEubQ");

var $3TJLC = parcelRequire("3TJLC");

var $k2M4v = parcelRequire("k2M4v");

var $i8V2i = parcelRequire("i8V2i");

var $euRd1 = parcelRequire("euRd1");

var $bKfoa = parcelRequire("bKfoa");

var $gSOfb = parcelRequire("gSOfb");

var $3rlj9 = parcelRequire("3rlj9");

var $4EPUx = parcelRequire("4EPUx");

var $5a4EU = parcelRequire("5a4EU");

var $l3fZT = parcelRequire("l3fZT");

var $kig2V = parcelRequire("kig2V");

var $2SWSA = parcelRequire("2SWSA");

var $gvvtK = parcelRequire("gvvtK");

var $eENmG = parcelRequire("eENmG");

var $80SfI = parcelRequire("80SfI");

var $lh6uV = parcelRequire("lh6uV");

var $cJsi5 = parcelRequire("cJsi5");

var $asC5r = parcelRequire("asC5r");

var $kJiHZ = parcelRequire("kJiHZ");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $gioQl = parcelRequire("gioQl");

var $kNuLt = parcelRequire("kNuLt");

var $k8rwX = parcelRequire("k8rwX");

var $aiQn2 = parcelRequire("aiQn2");
parcelRequire("91kpr");
var $2jSm0 = parcelRequire("2jSm0");

var $9INjF = parcelRequire("9INjF");
const $d3b1679963b90455$var$HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $d3b1679963b90455$var$isSmallScreen = window.innerWidth < (0, $lXJd8.sizes).xsmall;
const $d3b1679963b90455$var$CustomPressable = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $l3fZT.Pressable), {
        componentName: "link",
        xcss: $d3b1679963b90455$var$customPressableStyles,
        ...rest
    }, children);
};
/**
 * Feature gate: premium_benefits_modal_config_driven
 *
 * When enabled, open the new config-driven edition-benefits-modal via its async
 * entrypoint (`editionBenefitsModalEntryPoint` + `ModalTrigger`) instead of the
 * legacy `PremiumBenefitModalTrigger`. The entrypoint loads on demand, keeping
 * the modal's assets out of the initial bundle.
 *
 * Rollout: Pending — gate created 2026-07-15, default off
 * Target: TBD
 * Owner: Sequoia (SQA-4082)
 */ const $d3b1679963b90455$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN = 'premium_benefits_modal_config_driven';
const $d3b1679963b90455$var$isPremiumBenefitsModalConfigDrivenEnabled = ()=>(0, $k2M4v.default).checkGate($d3b1679963b90455$var$PREMIUM_BENEFITS_MODAL_CONFIG_DRIVEN);
const $d3b1679963b90455$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const isConfigDriven = $d3b1679963b90455$var$isPremiumBenefitsModalConfigDrivenEnabled();
    const edition = (0, $7lN8e.getEnv)().edition ?? 'unknown';
    // The config-driven ModalTrigger path doesn't emit the trigger analytics that the
    // legacy PremiumBenefitModalTrigger did, so replicate them here for parity.
    const fireTriggerEvent = (0, $fc4bM.useCallback)((action)=>createAnalyticsEvent({
            action: action,
            eventType: 'ui',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                edition: edition,
                touchpointId: 'portal-customise-menu-edit-page-layout',
                product: 'jira-service-management',
                variantId: 'help-center-customization',
                packageName: '@atlassian/edition-benefits-modal',
                source: 'editionBenefitsModal'
            }
        }).fire('growth'), // FabricChannel.growth
    [
        createAnalyticsEvent,
        edition
    ]);
    const hasFiredViewed = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        // Fire the trigger "viewed" event once when the config-driven trigger is shown.
        if (isConfigDriven && !hasFiredViewed.current) {
            hasFiredViewed.current = true;
            fireTriggerEvent('viewed');
        }
    }, [
        isConfigDriven,
        fireTriggerEvent
    ]);
    const renderTrigger = ({ ref: ref, onTriggerClick: onTriggerClick, props: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            ref: ref,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            component: $d3b1679963b90455$var$CustomPressable,
            // Compose the trigger analytics with the item's own handler so the "clicked"
            // event fires on the element itself rather than relying on event bubbling.
            onClick: onTriggerClick ? (event)=>{
                var _menu$onClick;
                onTriggerClick();
                (_menu$onClick = menu.onClick) === null || _menu$onClick === void 0 || _menu$onClick.call(menu, event);
            } : menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).HELP_CENTER,
        id: "help-center-customise-menu-edit-page-layout",
        renderError: ()=>null
    }, isConfigDriven ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kJiHZ.ModalTrigger), {
        entryPoint: (0, $cJsi5.editionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: (0, $6LH8a.getCloudId)(),
            product: 'jira-service-management'
        },
        entryPointProps: {
            variantId: 'help-center-customization',
            touchpointId: 'portal-customise-menu-edit-page-layout'
        },
        modalProps: (0, $lh6uV.MODAL_CONFIG)
    }, ({ ref: ref })=>renderTrigger({
            ref: ref,
            props: {},
            onTriggerClick: ()=>fireTriggerEvent('clicked')
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $80SfI.PremiumBenefitModalTrigger), {
        cloudId: (0, $6LH8a.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: "portal-customise-menu-edit-page-layout",
        edition: edition
    }, renderTrigger));
};
const $d3b1679963b90455$export$a3cd28217da1103e = ({ helpCenterAri: helpCenterAri, migration: migration, slug: slug, type: type, baseUrl: baseUrl })=>{
    if (type === 'HELP_HUB') return undefined;
    const migrationState = (0, $kNuLt.resolveMigrationManagementState)(migration);
    if (migrationState.action === 'update') return {
        action: 'update',
        href: `${0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH}?migrationStep=select&migrationSourceHelpCenterAri=${encodeURIComponent(helpCenterAri)}`
    };
    if (migrationState.action === 'review' && slug) return {
        action: 'review',
        href: (0, $aiQn2.buildMigratedHelpCenterReviewUrl)({
            baseUrl: baseUrl,
            slug: slug
        })
    };
    return undefined;
};
const $d3b1679963b90455$var$MigrationMenuAction = ({ onClose: onClose })=>{
    var _data$helpCenter, _helpCenter$migration, _helpCenter$migration2;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const helpCenterAri = (0, $6LH8a.getHelpCenterAri)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $6SuMw.default), {
        helpCenterAri: helpCenterAri,
        cloudId: (0, $6LH8a.getCloudId)()
    });
    const helpCenter = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    if ((helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.__typename) !== 'HelpCenter') return null;
    const action = $d3b1679963b90455$export$a3cd28217da1103e({
        helpCenterAri: helpCenterAri,
        migration: {
            migratedHubAri: ((_helpCenter$migration = helpCenter.migration) === null || _helpCenter$migration === void 0 ? void 0 : _helpCenter$migration.migratedHubAri) ?? null,
            state: ((_helpCenter$migration2 = helpCenter.migration) === null || _helpCenter$migration2 === void 0 ? void 0 : _helpCenter$migration2.state) ?? null
        },
        slug: helpCenter.slug,
        type: helpCenter.type,
        baseUrl: (0, $7lN8e.getEnv)().baseUrl
    });
    if (!action) return null;
    const actionSubjectId = action.action === 'update' ? 'navbarUpdateHelpCenter' : 'navbarReviewHelpCenterMigration';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        component: (0, $g9mbo.HtmlAnchor),
        href: action.href,
        actionSubjectId: actionSubjectId,
        onClick: ()=>onClose(actionSubjectId),
        testId: "help-center-migration-action",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, formatMessage(action.action === 'update' ? (0, $k8rwX.default).helpCenterUpdateButtonText : (0, $k8rwX.default).helpCenterReviewUpdateButtonText)));
};
const $d3b1679963b90455$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomePage, basePath)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const isCsmHelpCenter = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const showPortalReorderButton = !isCsmHelpCenter && isHomePage && canAdministerJIRA && !$d3b1679963b90455$var$isSmallScreen;
    const customizeMenu = [
        {
            link: `${basePath}?customize=true&experience=help-center-announcement`,
            label: formatMessage((0, $9INjF.default).announcement),
            actionSubjectId: 'navbarAnnouncement',
            isVisible: isHomePage && !$d3b1679963b90455$var$isSmallScreen,
            onClick: ()=>onClick('navbarAnnouncement'),
            testId: 'announcement-link'
        },
        {
            link: `${basePath}?customize=true&experience=theme`,
            label: formatMessage((0, $9INjF.default).look),
            actionSubjectId: 'navbarLookAndFeel',
            isVisible: isHomePage && canAdministerJIRA,
            onClick: ()=>onClick('navbarLookAndFeel'),
            testId: 'look-and-feel-link'
        },
        {
            link: `${basePath}?customize=true&experience=login-announcement`,
            label: formatMessage((0, $9INjF.default).logInMessage),
            actionSubjectId: 'navbarLoginAnnouncement',
            isVisible: isHomePage && canAdministerJIRA && !$d3b1679963b90455$var$isSmallScreen,
            onClick: ()=>onClick('navbarLoginAnnouncement'),
            testId: 'login-announcement-link'
        },
        {
            link: '/settings/portal-reorder',
            label: formatMessage((0, $9INjF.default).topicsAndPortals),
            actionSubjectId: 'navbarPortalReorder',
            isVisible: showPortalReorderButton,
            onClick: ()=>onClick('navbarPortalReorder'),
            testId: 'topics-link'
        },
        {
            link: '/edit',
            label: formatMessage((0, $9INjF.default).pageLayout),
            actionSubjectId: 'navbarHideAndReorder',
            isVisible: showEditLayoutButton,
            onClick: ()=>onClick('navbarHideAndReorder', !(0, $7lN8e.getIsHCCustomizationEnabled)()),
            testId: 'hide-and-reorder-link',
            customRenderer: (0, $7lN8e.getIsHCCustomizationEnabled)() ? undefined : $d3b1679963b90455$var$PremiumBenefitsModalRenderer,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, (0, $7lN8e.getIsHCCustomizationEnabled)() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                appearance: "discovery"
            }, formatMessage((0, $9INjF.default).premium)))
        }
    ];
    const onClick = (actionSubjectId, closeSidebar)=>{
        onClose(actionSubjectId);
        if (!closeSidebar) openHelpCenterCustomizationSidebar();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(menu.customRenderer, {
            key: `customize-menu_${menu.actionSubjectId}`,
            menu: menu
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            key: `customize-menu_${menu.actionSubjectId}`,
            component: $d3b1679963b90455$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $d3b1679963b90455$var$PortalLinks = ({ onClose: onClose, canCustomiseHelpCenter: canCustomiseHelpCenter, portal: portal, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (!portal) return null;
    const { isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, canEditAnnouncement: canEditAnnouncement } = portal;
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const shouldRenderConfigurePortal = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const shouldRenderCustomizeRequestTypes = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const shouldRenderCustomizePortalGroups = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const shouldRenderTeamManagedPortalGroupSettings = ()=>isProjectAdmin && isProjectSimplified && !shouldRenderAsPortalAnnouncement() && Boolean(projectKey === null || projectKey === void 0 ? void 0 : projectKey.length);
    const customizeMenu = [
        {
            link: '?customize=true&experience=add-announcement',
            onClick: ()=>onClose('navbarPortalAnnouncement'),
            label: formatMessage((0, $9INjF.default).portalAnnouncement),
            actionSubjectId: 'navbarPortalAnnouncement',
            isVisible: canEditAnnouncement || shouldRenderAsPortalAnnouncement()
        },
        {
            href: (0, $gioQl.getTeamManagedPortalGroupSettingsUrl)(projectKey ?? ''),
            onClick: ()=>onClose('navbarRequestTypeGroup'),
            label: formatMessage((0, $9INjF.default).portalRequestTypeGroup),
            actionSubjectId: 'navbarRequestTypeGroup',
            isVisible: shouldRenderTeamManagedPortalGroupSettings(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings`,
            onClick: ()=>onClose('navbarConfigurePortal'),
            label: formatMessage((0, $9INjF.default).configurePortal),
            actionSubjectId: 'navbarConfigurePortal',
            isVisible: shouldRenderConfigurePortal(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/${isProjectSimplified ? 'issuetypes' : 'request-types'}/`,
            onClick: ()=>onClose('navbarCustomizeRequestTypes'),
            label: formatMessage((0, $9INjF.default).customizeRequestTypes),
            actionSubjectId: 'navbarCustomizeRequestTypes',
            isVisible: shouldRenderCustomizeRequestTypes(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings/portal-groups`,
            onClick: ()=>onClose('navbarManagePortalGroups'),
            label: formatMessage((0, $9INjF.default).managePortalGroups),
            actionSubjectId: 'navbarManagePortalGroups',
            isVisible: shouldRenderCustomizePortalGroups(),
            target: '_blank'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, customizeMenu.map(({ isVisible: isVisible, actionSubjectId: actionSubjectId, onClick: onClick, link: link, href: href, label: label, target: target })=>{
        if (!isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            key: `portal-link_${actionSubjectId}`,
            component: $d3b1679963b90455$var$CustomLink,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            ...link ? {
                to: link
            } : {},
            ...href ? {
                href: href
            } : {},
            testId: `portal-link_${actionSubjectId}`,
            // Made this check of menu.target === '_blank' to avoid the eslint error
            target: target === '_blank' ? '_blank' : '_self',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, label);
    }));
};
const $d3b1679963b90455$var$CustomPageLinks = ({ showEditCustomPages: showEditCustomPages })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [{ match: match }] = (0, $7lAXH.useRouter)();
    const pageId = match.params.id || '';
    const customizeMenu = [
        {
            link: `/page/edit/${pageId}`,
            label: formatMessage((0, $9INjF.default).pageLayout),
            actionSubjectId: 'navbarEditCustomPage',
            isVisible: showEditCustomPages
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            key: `custom-page-link_${menu.actionSubjectId}`,
            component: $d3b1679963b90455$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $d3b1679963b90455$var$RequestList = (onClose, openRequestListCustomizationSidebar)=>{
    const onClick = (actionSubjectId)=>{
        onClose(actionSubjectId);
        openRequestListCustomizationSidebar();
    };
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        component: $d3b1679963b90455$var$CustomButton,
        actionSubjectId: "navbarUserRequestListCustomize",
        "aria-label": formatMessage((0, $9INjF.default).customizeRequestList),
        onClick: ()=>onClick('navbarUserRequestListCustomize'),
        "data-test-id": "requests-list-page-link"
    }, formatMessage((0, $9INjF.default).customizeRequestList)));
};
const $d3b1679963b90455$var$CustomiseMenu = (props)=>{
    const [{ route: route }] = (0, $7lAXH.useRouter)();
    const { name: routeName } = route;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $dJF35.useQueryParams)();
    (0, $fc4bM.useEffect)(()=>{
        // if customize is true and experience is not set, open the customise menu
        if (customize === 'true' && !experience) setIsOpen(true);
    }, [
        customize,
        experience
    ]);
    const isHomepage = routeName === 'help-center' || routeName === 'view-homepage';
    const isCustomPage = routeName === (0, $9mazR.RouteName).VIEW_CUSTOM_PAGE;
    const showEditCustomPageButton = props.canAdministerJIRA && !$d3b1679963b90455$var$isSmallScreen && isCustomPage;
    const showEditLayoutButtonUpsell = (0, $7lN8e.getIsHCCustomizationEnabled)() || (props.hasSiteAdministerAccess ?? false);
    const showEditLayoutButton = isHomepage && props.canAdministerJIRA && !$d3b1679963b90455$var$isSmallScreen && showEditLayoutButtonUpsell;
    const isHelpCenterManagementScreen = (0, $diqlM.getRelativeBasePath)() === (0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const isHelpHubMigrationEnabled = (0, $k2M4v.default).checkGate($d3b1679963b90455$var$HELP_HUB_MIGRATION_GATE);
    const basePath = (0, $cf3fd.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(!!props.isOpen);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const onOpenChange = (0, $fc4bM.useCallback)((open)=>{
        setIsOpen(open);
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const setCustomiseSidebarTrigger = (0, $bwpot.useSetCustomiseSidebarTrigger)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'customizeMenu',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    const allowRouteList = [
        'help-center',
        'view-homepage',
        'portal-home',
        'requests-list',
        (0, $9mazR.RouteName).VIEW_CUSTOM_PAGE
    ];
    const hideCustomizeButton = ()=>{
        var _props$portal, _props$portal2;
        return !allowRouteList.includes(routeName) || isHelpCenterManagementScreen || isHomepage && !props.canCustomiseHelpCenter || //Hide for Agents with Edit Permission in mobile view
        isHomepage && props.canCustomiseHelpCenter && !props.canAdministerJIRA && $d3b1679963b90455$var$isSmallScreen || routeName === 'portal-home' && !((_props$portal = props.portal) !== null && _props$portal !== void 0 && _props$portal.isProjectAdmin || (_props$portal2 = props.portal) !== null && _props$portal2 !== void 0 && _props$portal2.canEditAnnouncement) || routeName === 'requests-list' && !props.canAdministerJIRA || isCustomPage && !props.canAdministerJIRA;
    };
    const content = ()=>{
        const { openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, openRequestListCustomizationSidebar: openRequestListCustomizationSidebar, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, portal: portal, projectKey: projectKey } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $d3b1679963b90455$var$popupContainerStyles,
            "aria-label": formatMessage((0, $9INjF.default).customizeAriaLabel),
            testId: 'customize-menu-content',
            role: "group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gSOfb.default), {
            maxHeight: $d3b1679963b90455$var$maxHeight
        }, !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, canCustomiseHelpCenter && isHomepage && $d3b1679963b90455$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomepage, basePath), isHomepage && canAdministerJIRA && isHelpHubMigrationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
            packageName: (0, $9mazR.ScreenName).HELP_CENTER,
            id: "customize-menu-migration-action",
            renderError: ()=>null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3b1679963b90455$var$MigrationMenuAction, {
            onClose: onItemClick
        }))), routeName === 'portal-home' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3b1679963b90455$var$PortalLinks, {
            onClose: onItemClick,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            portal: portal,
            projectKey: projectKey
        }), routeName === 'requests-list' && canAdministerJIRA && Boolean(defaultColumnSettings === null || defaultColumnSettings === void 0 ? void 0 : defaultColumnSettings.length) && $d3b1679963b90455$var$RequestList(onItemClick, openRequestListCustomizationSidebar), isCustomPage && showEditCustomPageButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3b1679963b90455$var$CustomPageLinks, {
            showEditCustomPages: showEditCustomPageButton
        }))), showEditLayoutButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gvvtK.FireUIAnalytics), {
            action: "viewed",
            actionSubject: "editPageLayout"
        }));
    };
    const Trigger = (0, $fc4bM.useCallback)(({ ref: ref, ...triggerProps })=>{
        const combinedRef = (element)=>{
            if (typeof ref === 'function') ref(element);
            else if (ref && typeof ref === 'object' && 'current' in ref) ref.current = element;
            setCustomiseSidebarTrigger === null || setCustomiseSidebarTrigger === void 0 || setCustomiseSidebarTrigger(element);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2jSm0.default), {
            label: formatMessage((0, $9INjF.default).customizeBtnLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i8V2i))), {
                label: "customise",
                size: "small",
                spacing: "spacious"
            }),
            disabled: props.disableCustomiseMenu,
            onClick: ()=>{
                onOpenChange(!isOpen);
                createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'navbarCustomise',
                    analyticsType: (0, $eENmG.UI_EVENT_TYPE)
                }).fire();
            },
            forwardedRef: combinedRef,
            ...triggerProps
        }));
    }, [
        formatMessage,
        props.disableCustomiseMenu,
        onOpenChange,
        isOpen,
        createAnalyticsEvent,
        setCustomiseSidebarTrigger
    ]);
    const renderDropdownMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asC5r.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
            isOpen: isOpen,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            shouldRenderToParent: true,
            zIndex: (0, $2SWSA.layers).modal(),
            content: content,
            trigger: Trigger,
            key: 'customise-menu-dumb-popup'
        }));
    if (hideCustomizeButton()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $d3b1679963b90455$var$CustomiseBtnWrapperStyles
    }, renderDropdownMenu());
};
const $d3b1679963b90455$var$CustomiseBtnWrapperStyles = (0, $kig2V.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d3b1679963b90455$var$NoUnderlineLink = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $io4o2.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $d3b1679963b90455$var$popupContainerStyles = (0, $kig2V.xcss)({
    minWidth: '234px',
    maxWidth: '800px',
    color: 'color.text'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d3b1679963b90455$var$CustomLink = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = $d3b1679963b90455$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_syaz261p _1y3i1r31 _92x4glyw _109f1o36 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $d3b1679963b90455$var$customPressableStyles = (0, $kig2V.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d3b1679963b90455$var$CustomButton = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $MPQAF.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $d3b1679963b90455$var$maxHeight = `calc(100vh - ${$fOCtI.multiple(24).px}`;
var $d3b1679963b90455$export$2e2bcd8739ae039 = $d3b1679963b90455$var$CustomiseMenu;

});
parcelRegister("6SuMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6edf99431d0c38d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0fd551cf9d12a8431ca0fa60e3389c6>>
 * @relayHash 89862e89702e0591c663bc7cb385db1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fb531fb8c9608e3099d1a273882ae83e52887e3fcb359aea54e8f86b6d733e1
const $6edf99431d0c38d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "slug"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "HelpCenterMigrationInfo",
                "kind": "LinkedField",
                "name": "migration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "migratedHubAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customiseMenuDumbMigrationActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customiseMenuDumbMigrationActionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9fb531fb8c9608e3099d1a273882ae83e52887e3fcb359aea54e8f86b6d733e1",
            "metadata": {},
            "name": "customiseMenuDumbMigrationActionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6edf99431d0c38d4$var$node.hash = "1af1147940ad61a0f56be07e50b0c9bb";
var $6edf99431d0c38d4$export$2e2bcd8739ae039 = $6edf99431d0c38d4$var$node;

});

parcelRegister("gcRsK", function(module, exports) {
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("dJF35")).useQueryParams);
parcelRequire("5dfyX");
parcelRequire("aMDBq");
parcelRequire("dJF35");

});
parcelRegister("5dfyX", function(module, exports) {
const $83b0452ef173dbdd$export$f14c45907e18a763 = 31;
const $83b0452ef173dbdd$export$49754c91e8c4555b = 11;
const $83b0452ef173dbdd$export$5c16d76778f8ba6d = 5;
const $83b0452ef173dbdd$export$de93546541b3e2e = 3;
const $83b0452ef173dbdd$export$897393da5c49885d = 30;
const $83b0452ef173dbdd$export$7652aee25e1c7c1e = 30;
const $83b0452ef173dbdd$export$95aa4d213e66754b = 300;

});

parcelRegister("aMDBq", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");

var $3DjOo = parcelRequire("3DjOo");
const $1a04ffe78afd1a0d$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $1a04ffe78afd1a0d$export$f99233281efd08a0 = /*#__PURE__*/ (0, $luz1X.default).h3.withConfig({
    componentId: "sc-19gahx3-0"
})`${$3DjOo.clamp};margin:0;font-weight:normal;font-size:${"var(--ds-space-200, 16px)"};`;
const $1a04ffe78afd1a0d$export$10c56fa12fda26f9 = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-19gahx3-1"
})`color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-100, 8px)"};padding-right:${"var(--ds-space-200, 16px)"};${$3DjOo.multiLineClamp(3, 20)};`;
const $1a04ffe78afd1a0d$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-19gahx3-2"
})`display:flex;border-radius:${"var(--ds-radius-small, 3px)"};${$3DjOo.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};padding:${"var(--ds-space-200, 16px)"};margin:${"var(--ds-space-100, 8px)"} 0 0;&:hover,&:focus{background:${"var(--ds-surface-raised, #FFFFFF)"};text-decoration:none;}&:hover h3,&:focus h3{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
const $1a04ffe78afd1a0d$export$d971b98a124cabfc = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_ca0qpxbi _19pkze3t _1p1dangw _1wybutpp _k48p8n31 _syaz117m",
            __cmplp.className
        ])
    });
});
const $1a04ffe78afd1a0d$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $1a04ffe78afd1a0d$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $1a04ffe78afd1a0d$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $1a04ffe78afd1a0d$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = (0, $io4o2.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $1a04ffe78afd1a0d$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dJF35", function(module, exports) {
$parcel$export(module.exports, "useQueryParams", () => $d9548614cd31c41f$export$b37ee0d76c6d2fbc);

var $fc4bM = parcelRequire("fc4bM");

var $hl35j = parcelRequire("hl35j");

var $6Hr8Z = parcelRequire("6Hr8Z");

var $eSHpe = parcelRequire("eSHpe");

var $ikzOZ = parcelRequire("ikzOZ");

var $cQB7H = parcelRequire("cQB7H");

var $6dipk = parcelRequire("6dipk");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
const $d9548614cd31c41f$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $d9548614cd31c41f$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $d9548614cd31c41f$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $cQB7H.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $d9548614cd31c41f$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $cQB7H.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $d9548614cd31c41f$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $7lAXH.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $fc4bM.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($6dipk))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $fc4bM.useMemo)(()=>$d9548614cd31c41f$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $fc4bM.useMemo)(()=>$d9548614cd31c41f$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $d9548614cd31c41f$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $d9548614cd31c41f$export$c36431be801010b(portalId) !== 0;
const $d9548614cd31c41f$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $d9548614cd31c41f$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ikzOZ)))(portalId);
};
const $d9548614cd31c41f$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6Hr8Z)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($eSHpe)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($hl35j)))(ids) ? ids : [];
    }
    return [];
};
const $d9548614cd31c41f$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $d9548614cd31c41f$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $d9548614cd31c41f$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $fc4bM.useState)(false);
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $fc4bM.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});


parcelRegister("i8V2i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::420bb8ab33e730f674ad3a512c5bab6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d355377f7eb9ef6b$var$_react = $d355377f7eb9ef6b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d355377f7eb9ef6b$var$_iconNew = $d355377f7eb9ef6b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d355377f7eb9ef6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBrush".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/paint-brush
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d355377f7eb9ef6b$var$PaintBrushIcon = (props)=>/*#__PURE__*/ $d355377f7eb9ef6b$var$_react.default.createElement($d355377f7eb9ef6b$var$_iconNew.default, Object.assign({
        name: "PaintBrushIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 .75.75V9a2 2 0 0 1-2 2H10v3a2 2 0 1 1-4 0v-3H4.5a2 2 0 0 1-2-2zM7.5 11v3a.5.5 0 0 0 1 0v-3zM4 1.5v5h8v-5h-1.5V4H9V1.5H7V3H5.5V1.5zM12 8H4v1a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 12 9z" clip-rule="evenodd"/>`
    }, props));
$d355377f7eb9ef6b$var$PaintBrushIcon.displayName = 'PaintBrushIcon';
var $d355377f7eb9ef6b$var$_default = module.exports.default = $d355377f7eb9ef6b$var$PaintBrushIcon;

});

parcelRegister("kNuLt", function(module, exports) {
$parcel$export(module.exports, "resolveMigrationManagementState", () => $b0efcffbe7a3471a$export$71e43b572ead9b23);
const $b0efcffbe7a3471a$var$legacyManagementState = (action, migratedHubAri = null)=>({
        action: action,
        migratedHubAri: migratedHubAri,
        shouldShowLegacyCard: true,
        shouldWarnBeforeLegacyEdit: false
    });
const $b0efcffbe7a3471a$export$71e43b572ead9b23 = ({ migratedHubAri: migratedHubAri, state: state })=>{
    switch(state){
        case null:
        case 'NOT_STARTED':
            return $b0efcffbe7a3471a$var$legacyManagementState('update');
        case 'IN_PROGRESS':
            return $b0efcffbe7a3471a$var$legacyManagementState('resume');
        case 'FAILED':
            return $b0efcffbe7a3471a$var$legacyManagementState('retry');
        case 'MIGRATED':
            return migratedHubAri ? {
                action: 'review',
                migratedHubAri: migratedHubAri,
                shouldShowLegacyCard: true,
                shouldWarnBeforeLegacyEdit: true
            } : $b0efcffbe7a3471a$var$legacyManagementState('none');
        case 'PUBLISHED':
            return {
                action: 'none',
                migratedHubAri: null,
                shouldShowLegacyCard: false,
                shouldWarnBeforeLegacyEdit: false
            };
        case '%future added value':
        default:
            return $b0efcffbe7a3471a$var$legacyManagementState('none');
    }
};

});

parcelRegister("k8rwX", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc66521ed25220c1$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $dc66521ed25220c1$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    migrationUpdating: {
        defaultMessage: 'Updating...',
        description: 'Status shown on a help center card while its update is in progress.',
        id: 'help.center.card.migration.updating'
    },
    migrationProgress: {
        defaultMessage: '75%',
        description: 'Fixed visible progress shown while a help center update is in progress.',
        id: 'help.center.card.migration.progress'
    },
    migrationProgressAccessibleLabel: {
        defaultMessage: 'Updating... 75%',
        description: 'Accessible determinate progress label for an in-progress help center update.',
        id: 'help.center.card.migration.progress.accessible-label'
    },
    resumeMigration: {
        defaultMessage: 'View fullscreen',
        description: 'Action that restores the fullscreen view for an in-progress help center update.',
        id: 'help.center.card.migration.resume'
    },
    migrationActions: {
        defaultMessage: 'Help center actions',
        description: 'Label for the help center actions button, unavailable while an update is in progress.',
        id: 'help.center.card.migration.actions'
    },
    migrationUpdatedOn: {
        defaultMessage: 'Last updated {date}',
        description: 'Last updated date on a help center card while its update is in progress.',
        id: 'help.center.card.migration.updated-on'
    },
    helpCenterGenericErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Generic description message for help center error',
        id: 'help.center.card.update.error.description.generic'
    },
    helpCenterErrorDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{value}',
        description: 'Description message for help center error',
        id: 'help.center.card.update.error.description'
    },
    helpCenterDeleteErrorTitleText: {
        defaultMessage: "We couldn\u2019t delete \u2018{value}\u2019",
        description: 'Title message for delete help center error',
        id: 'help.center.delete.error.title.text'
    },
    helpCenterDeleteErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Description message for delete help center error',
        id: 'help.center.delete.error.desc'
    },
    helpCenterDeleteSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 deleted",
        description: 'Delete help center success message',
        id: 'help.center.delete.success.title.text'
    },
    helpCenterUpdatedOn: {
        defaultMessage: 'Last updated: {date}',
        description: 'Label showing when the help center was last updated; {date} is the formatted date',
        id: 'help.center.updated.on.text'
    },
    helpCenterCustomizeButtonText: {
        defaultMessage: 'Customize look and feel',
        description: 'Help center customize button text',
        id: 'help.center.customize.button.text'
    },
    helpCenterUpdateButtonText: {
        defaultMessage: 'Update Help Center',
        description: 'Action that starts updating a legacy help center to a help hub',
        id: 'help.center.card.migration.update.button'
    },
    helpCenterReviewUpdateButtonText: {
        defaultMessage: 'Review update',
        description: 'Action that opens the updated help center draft for review',
        id: 'help.center.card.update.review.button'
    },
    helpCenterEditWarningTitle: {
        defaultMessage: 'Edit current help center?',
        description: 'Title warning that changes to the current help center will not sync to its draft',
        id: 'help.center.card.migration.edit.warning.title'
    },
    helpCenterEditWarningDescription: {
        defaultMessage: "Changes you make here won\u2019t sync to your new help center draft. We recommend reviewing and editing the draft instead.",
        description: 'Warning shown before editing a legacy help center that has a migrated draft',
        id: 'help.center.card.migration.edit.warning.description'
    },
    helpCenterEditWarningCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Action that cancels editing the current help center',
        id: 'help.center.card.migration.edit.warning.cancel'
    },
    helpCenterEditWarningGoToDraftButton: {
        defaultMessage: 'Go to draft',
        description: 'Action that opens the migrated help center draft',
        id: 'help.center.card.migration.edit.warning.go.to.draft'
    },
    helpCenterEditWarningEditAnywayButton: {
        defaultMessage: 'Edit anyway',
        description: 'Action that continues editing the current help center despite the warning',
        id: 'help.center.card.migration.edit.warning.edit.anyway'
    },
    helpHubCustomizeButtonText: {
        defaultMessage: 'Customize',
        description: 'Help center customize button text',
        id: 'help.hub.customize.button.text'
    },
    helpCenterSettingsButtonText: {
        defaultMessage: 'Settings',
        description: 'Help center settings button text',
        id: 'help.center.settings.button.text'
    },
    helpCenterDeleteButtonText: {
        defaultMessage: 'Delete',
        description: 'Help center delete button text',
        id: 'help.center.delete.button.text'
    },
    helpCenterDeleteDialogTitle: {
        defaultMessage: 'Delete help center?',
        description: 'Help center delete dialog title',
        id: 'help.center.delete.dialog.title'
    },
    helpCenterDeleteDialogDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: `\u{2018}{value}\u{2019}  and any customizations you applied to it will be permanently deleted. This cannot be undone.`,
        description: 'Help center delete dialog description',
        id: 'help.center.delete.dialog.desc'
    },
    helpCenterDeleteDialogDeleteButton: {
        defaultMessage: 'Delete',
        description: 'Help center delete dialog delete button text',
        id: 'help.center.delete.dialog.delete.button'
    },
    helpCenterDeleteDialogCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Help center delete dialog cancel button text',
        id: 'help.center.delete.dialog.cancel.button'
    },
    helpCenterDisabledDeleteButtonTooltip: {
        defaultMessage: `Your default help center can't be deleted.`,
        description: 'Help center disabled delete button tooltip text',
        id: 'help.center.disabled.delete.button.tooltip'
    },
    helpCenterDisabledMessagePopup: {
        defaultMessage: `You need to be on a Premium or Enterprise plan to access multiple help centers on your site.`,
        description: 'Help center disabled message to upgrade popup',
        id: 'help.center.disabled.message.popup'
    },
    defaultLozenge: {
        defaultMessage: 'Default',
        description: 'Lozenge for default help center',
        id: 'help.center.default.lozenge.message'
    },
    mappedProjectCount: {
        defaultMessage: '{count, plural, one {# linked project} other {# linked projects}}',
        description: 'Lozenge for mapped projects count',
        id: 'help.center.project.map.count'
    },
    mappedSpaceCountGalaxia: {
        defaultMessage: '{count, plural, one {# linked space} other {# linked spaces}}',
        description: 'Lozenge for mapped spaces count',
        id: 'help.center.project.map.count-galaxia'
    },
    mappedProjectCountAll: {
        defaultMessage: 'All projects linked',
        description: 'Lozenge indicating all projects are linked to the help center',
        id: 'help.center.project.map.all.count'
    },
    mappedSpaceCountAllGalaxia: {
        defaultMessage: 'All spaces linked',
        description: 'Lozenge indicating all spaces are linked to the help center',
        id: 'help.center.project.map.all.count-galaxia'
    },
    upgradeLozenge: {
        defaultMessage: 'Upgrade to access',
        description: 'Lozenge for upgrade to access help center',
        id: 'help.center.upgrade.lozenge.message'
    },
    helpCenterVirtualServiceAgentButtonText: {
        defaultMessage: 'Virtual service agent',
        description: 'Help center virtual service agent button text',
        id: 'help.center.virtual.service.agent.button.text'
    },
    changeBoardingDescription: {
        defaultMessage: 'Manage help center details, link and unlink your projects, and track virtual service agent performance from here.',
        description: 'Onboarding tooltip body text for the help center management card',
        id: 'help.center.card.change.boarding.description'
    },
    changeBoardingDescriptionGalaxia: {
        defaultMessage: 'Manage help center details, link and unlink your spaces, and track virtual service agent performance from here.',
        description: 'Onboarding tooltip body text for the help center card in Galaxia layout',
        id: 'help.center.card.change.boarding.description-galaxia'
    },
    changeBoardingTitle: {
        defaultMessage: 'Take charge of your help center',
        description: 'Heading text for the onboarding tooltip on the help center card',
        id: 'help.center.card.change.boarding.title'
    },
    changeBoardingButtonText: {
        defaultMessage: 'OK',
        description: 'Dismiss button label for the help center onboarding tooltip',
        id: 'help.center.card.change.boarding.button.description'
    }
});

});

parcelRegister("aiQn2", function(module, exports) {
$parcel$export(module.exports, "buildMigratedHelpCenterReviewUrl", () => $2e70a4bf0f10568a$export$dabc9b07d93b119f);
/**
 * Builds the sandbox URL used for reviewing a migrated Help Center draft.
 *
 * Keep this shared by migration entry points. Multi-help-center routes use the
 * legacy help center slug as the review-route identifier. The default Help
 * Center has no slug and continues to use its legacy portals route.
 */ const $2e70a4bf0f10568a$export$dabc9b07d93b119f = ({ baseUrl: baseUrl, slug: slug })=>new URL(slug ? `/helpcenter/test/${encodeURIComponent(slug)}` : '/servicedesk/customer/test/portals', baseUrl).toString();

});

parcelRegister("91kpr", function(module, exports) {
$parcel$export(module.exports, "DynamicThemingButton", () => (parcelRequire("2jSm0")).default);

var $2jSm0 = parcelRequire("2jSm0");

});
parcelRegister("2jSm0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2633a714251a747$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $1JdzP = parcelRequire("1JdzP");

var $kig2V = parcelRequire("kig2V");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");
function $e2633a714251a747$var$DynamicThemingButton({ label: label, ariaLabel: ariaLabel, themeColor: themeColor, disabled: disabled, icon: icon, onClick: onClick, forwardedRef: forwardedRef, textColor: textColor, customStyles: customStyles = {}, ...customProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.default), {
        ...customProps,
        ref: forwardedRef,
        disabled: disabled,
        "aria-label": ariaLabel ? ariaLabel : label,
        as: "button",
        onClick: onClick,
        xcss: $e2633a714251a747$var$buttonStyles,
        style: {
            backgroundImage: `linear-gradient(
                to right,
                rgba(255, 255, 255, 0.8),
                rgba(255, 255, 255, 0.8)
            ),
            linear-gradient(to right, ${themeColor}, ${themeColor})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
        gap: "space.050",
        alignItems: "center"
    }, icon, textColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.default), {
        color: textColor,
        as: "span"
    }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.default), {
        as: "span"
    }, label)));
}
const $e2633a714251a747$var$buttonStyles = (0, $kig2V.xcss)({
    position: 'relative',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderRadius: 'radius.full',
    borderColor: 'color.border.inverse',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    color: 'color.text',
    cursor: 'pointer',
    height: '36px',
    '::after': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        bottom: 'space.0',
        left: 'space.0',
        borderRadius: 'radius.full',
        background: `${"var(--ds-interaction-hovered, rgba(9, 30, 66, 0.60))"}`,
        opacity: 0,
        pointerEvents: 'none'
    },
    ':hover::after': {
        opacity: 0.6,
        transition: 'opacity 200ms'
    },
    ':active': {
        transform: 'scale(0.97)',
        transition: 'transform 50ms'
    },
    ':disabled': {
        pointerEvents: 'none'
    }
});
const $e2633a714251a747$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
var $e2633a714251a747$export$2e2bcd8739ae039 = (0, $6umft.default)($e2633a714251a747$var$selector, {})($e2633a714251a747$var$DynamicThemingButton);

});


parcelRegister("9INjF", function(module, exports) {
$parcel$export(module.exports, "default", () => $367c6991a65a10f6$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $367c6991a65a10f6$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    customizeBtnLabel: {
        defaultMessage: 'Customize',
        description: 'Button label for customize button beside avatar menu in header to open list of customization options in a popup',
        id: 'customize.menu.header.customizeBtnLabel'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in customize menu in request list screen',
        id: 'customize.menu.header.manage-column'
    },
    pageLayout: {
        defaultMessage: 'Edit page layout',
        description: 'Edit page layout item in customize drop-down menu',
        id: 'customize.menu.header.pageLayout'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.beta'
    },
    premium: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.premium'
    },
    topicsAndPortals: {
        defaultMessage: 'Manage topics and portals',
        description: 'Manage Topics and Portals item in customize drop-down menu when advanced customization enabled',
        id: 'customize.menu.header.topicsAndPortals'
    },
    look: {
        defaultMessage: 'Customize look and feel',
        description: 'Customize look and feel item in customize menu',
        id: 'customize.menu.header.look'
    },
    announcement: {
        defaultMessage: 'Manage announcements',
        description: 'Announcement item in customize menu',
        id: 'customize.menu.header.announcement'
    },
    logInMessage: {
        defaultMessage: 'Add login page message',
        description: 'Add login page message item in customize menu',
        id: 'customize.menu.header.logInMessage'
    },
    customizeAriaLabel: {
        defaultMessage: 'Customization options',
        description: 'Aria label for screen readers while opening customize pop up menu from customize button in header',
        id: 'customize.menu.header.customizeAriaLabel'
    },
    portalAnnouncement: {
        defaultMessage: 'Manage announcements',
        description: 'Manage announcement item in customize menu in portal screen',
        id: 'customize.menu.header.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Organize portal groups',
        description: 'Organize portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.requestTypeGroup'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.description'
    },
    pageLayoutTryButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.try.button'
    },
    configurePortal: {
        defaultMessage: 'Configure portal',
        description: 'Configure portal item in customize menu for portal screen',
        id: 'customize.menu.header.configurePortal'
    },
    customizeRequestTypes: {
        defaultMessage: 'Customize request types',
        description: 'Customize request types item in customize menu for portal screen',
        id: 'customize.menu.header.customizeRequestTypes'
    },
    managePortalGroups: {
        defaultMessage: 'Manage portal groups',
        description: 'Manage portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.managePortalGroups'
    }
});

});





parcelRegister("gi59x", function(module, exports) {
$parcel$export(module.exports, "default", () => $35f7eb216736a64f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $35f7eb216736a64f$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    login: {
        defaultMessage: 'Log in',
        description: 'Text message for header in Customer Portal when a user is not logged in',
        id: 'cv.login.title'
    },
    helpCenter: {
        defaultMessage: 'Help Center',
        description: 'Text message for header in Customer Portal when a user is logged in',
        id: 'cv.help.center.title'
    }
});

});





parcelRegister("jDBRI", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => (parcelRequire("ju0hb")).default);

var $ju0hb = parcelRequire("ju0hb");

});
parcelRegister("ju0hb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9ead62b41229092$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $fecgs = parcelRequire("fecgs");

var $eXcu8 = parcelRequire("eXcu8");

var $1eY13 = parcelRequire("1eY13");

var $haEws = parcelRequire("haEws");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $eKQdX = parcelRequire("eKQdX");
const $d9ead62b41229092$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getHelpCenterBrandingLoader), (0, $7RWiC.isUserLoaded), (isBrandingLoaded, userLoaded)=>({
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded
    }));
var $d9ead62b41229092$export$2e2bcd8739ae039 = (0, $6umft.default)($d9ead62b41229092$var$selector, {
    fetchBranding: (0, $eXcu8.fetchHelpCenterBrandingAction),
    fetchUser: (0, $fecgs.fetchUserModelAction),
    fetchOrganisations: (0, $1eY13.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $haEws.fetchUserRequestsCountsAction)
})((0, $eKQdX.PrefetchBrandingModel));

});
parcelRegister("eKQdX", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => $8991fafe8923b5bd$export$f08bae07abcc5a9d);

var $fc4bM = parcelRequire("fc4bM");

var $cf3fd = parcelRequire("cf3fd");
class $8991fafe8923b5bd$export$f08bae07abcc5a9d extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        if (!(0, $cf3fd.isHelpCentersManagement)() && !this.props.isBrandingLoaded) this.props.fetchBranding();
        if (!this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchOrganisations();
            this.props.fetchUserRequestsCounts();
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        return null;
    }
}

});





parcelRegister("3zOhM", function(module, exports) {
$parcel$export(module.exports, "AnnouncementBanner", () => (parcelRequire("fUMxw")).default);

var $fUMxw = parcelRequire("fUMxw");

});
parcelRegister("fUMxw", function(module, exports) {
$parcel$export(module.exports, "default", () => $86fc0ffcde18a4d5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $luz1X = parcelRequire("luz1X");

var $dbhrd = parcelRequire("dbhrd");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("blonq");
var $4m70N = parcelRequire("4m70N");

var $k2M4v = parcelRequire("k2M4v");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $d7r8x = parcelRequire("d7r8x");

var $m7L3g = parcelRequire("m7L3g");
const $86fc0ffcde18a4d5$var$Announcement = ({ announcement: announcement, hasTopBarBeenSplit: hasTopBarBeenSplit, isPortalLoaded: isPortalLoaded, appearance: contentAppearance })=>{
    const [{ route: route }] = (0, $7lAXH.useRouter)();
    const { name: name } = route;
    const whiteListedRouteNames = [
        'portal-home',
        'request-create'
    ];
    const AnnouncementInnerContainerDeprecated = /*#__PURE__*/ (0, $fc4bM.memo)(({ children: children })=>{
        const hide = contentAppearance === 'none';
        const appearance = contentAppearance || 'normal';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $m7L3g.GridContentWrapper), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($86fc0ffcde18a4d5$var$PaperInnerContainer, {
            "data-testid": "paper-inner-container"
        }, children));
    });
    AnnouncementInnerContainerDeprecated.displayName = 'AnnouncementInnerContainer';
    const AnnouncementInnerContainer = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        const Component = ({ children: children })=>{
            const hide = contentAppearance === 'none';
            const appearance = contentAppearance || 'normal';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $m7L3g.GridContentWrapper), {
                appearance: appearance,
                hide: hide
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($86fc0ffcde18a4d5$var$PaperInnerContainer, {
                "data-testid": "paper-inner-container"
            }, children));
        };
        Component.displayName = 'AnnouncementInnerContainer';
        return Component;
    }, [
        contentAppearance
    ]);
    if ((0, $hN5YJ.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $86fc0ffcde18a4d5$var$announcementContainer,
        testId: 'increased-flexibility-container'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dbhrd.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $k2M4v.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dbhrd.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $k2M4v.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    }));
};
const $86fc0ffcde18a4d5$var$selector = (0, $2n2bS.createSelector)((state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    const portal = (0, $9D9SX.getPortal)(state, portalId);
    const announcement = (0, $9D9SX.getPortalAnnouncement)(state, portalId);
    return {
        announcement: announcement,
        isPortalLoaded: Boolean(portal)
    };
}, (0, $ePyx3.getHelpCenterTopBarSplitFlag), ({ announcement: announcement, isPortalLoaded: isPortalLoaded }, hasTopBarBeenSplit)=>{
    return {
        announcement: announcement,
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        isPortalLoaded: isPortalLoaded
    };
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $86fc0ffcde18a4d5$var$PaperInnerContainer = /*#__PURE__*/ (0, $luz1X.default)((0, $4m70N.PaperContent)).withConfig({
    componentId: "sc-117mmoe-0"
})({
    paddingTop: 0
});
const $86fc0ffcde18a4d5$var$announcementContainer = (0, $kig2V.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.400',
    marginRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    // make sure extra margin is not added in case announcement is not present
    ':empty': {
        display: 'none'
    }
});
var $86fc0ffcde18a4d5$export$2e2bcd8739ae039 = (0, $6umft.default)($86fc0ffcde18a4d5$var$selector)($86fc0ffcde18a4d5$var$Announcement);

});
parcelRegister("dbhrd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e5c89d0f10649b9$export$2e2bcd8739ae039);

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");

var $6Ynsr = parcelRequire("6Ynsr");
var $4e5c89d0f10649b9$export$2e2bcd8739ae039 = (0, $613oU.default)({
    componentName: 'banner'
})((0, $azARG.default)()((0, $6Ynsr.default)));

});
parcelRegister("6Ynsr", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d23afb1cfd201e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fOCtI = parcelRequire("fOCtI");

var $eENmG = parcelRequire("eENmG");

var $fhYB5 = parcelRequire("fhYB5");

var $cm6cS = parcelRequire("cm6cS");
/**
 * This is used for the clamping logic inside the announcement.
 * It is VERY brittle and WILL break if you change font-size/line-height
 * inside the announcement. Watch out!
 */ const $37d23afb1cfd201e$var$SINGLE_LINE_TITLE_HEIGHT = 23;
/**
 * This component will have big problems if/when we do SSR. Be careful out there.
 */ class $37d23afb1cfd201e$var$AnnouncementBanner extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        InnerContainerComponent: $fc4bM.Fragment
    };
    componentDidMount() {
        // On mount we will calculate the height of the header/message and set isExpandable accordingly.
        // This will only be set once (on mount) - if we eventually want to dynamically update this we
        // will want to implement a componentDidUpdate() method, check if header/message changed, and
        // recalculate.
        this.calculateIfExpandable();
    }
    fireAnalytics(action) {
        const { createAnalyticsEvent: createAnalyticsEvent, actionSubjectId: actionSubjectId } = this.props;
        const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
        if (createAnalyticsEvent) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubjectId: actionSubjectId,
                action: action,
                analyticsType: (0, $eENmG.UI_EVENT_TYPE),
                attributes: {
                    messageCharCount: messageCharCount,
                    titleCharCount: headerCharCount
                }
            });
            analyticsEvent.fire();
        }
    }
    calculateIfExpandable() {
        let isExpandable = false;
        // If advanced customization is enabled and the layout is in edit mode, the banner should not be expandable.
        if (this.props.isLayoutInEditMode) {
            this.setState({
                isExpandable: false,
                isExpanded: true
            });
            return;
        }
        if (this.headerRef || this.messageRef) {
            const headerHeight = this.headerRef && (0, $fhYB5.getBoundingBox)(this.headerRef).height || 0;
            const messageHeight = this.messageRef && (0, $fhYB5.getBoundingBox)(this.messageRef).height || 0;
            const headerOverOneLine = headerHeight > $37d23afb1cfd201e$var$SINGLE_LINE_TITLE_HEIGHT;
            const messageOverOneLine = messageHeight > (0, $fOCtI.SINGLE_LINE_PARAGRAPH_HEIGHT);
            isExpandable = headerOverOneLine || messageOverOneLine;
        }
        // The announcement banner is expanded by default.
        this.setState({
            isExpandable: isExpandable,
            isExpanded: true
        });
    }
    render() {
        const { header: header, messageHtml: messageHtml, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isLayoutInEditMode: isLayoutInEditMode, isLayoutInPreviewMode: isLayoutInPreviewMode, removePadding: removePadding } = this.props;
        const { isExpanded: isExpanded, isExpandable: isExpandable } = this.state;
        return /*#__PURE__*/ $fc4bM.createElement((0, $cm6cS.default), {
            header: header,
            isExpanded: isExpanded,
            isExpandable: isExpandable,
            messageHtml: messageHtml,
            onHeaderRef: this.onHeaderRef,
            onMessageRef: this.onMessageRef,
            expandBanner: this.expandBanner,
            shrinkBanner: this.collapseBanner,
            InnerContainerComponent: InnerContainerComponent,
            removeBgColor: removeBgColor,
            isCursorGrab: isLayoutInEditMode && isLayoutInPreviewMode === false,
            removePadding: removePadding
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // We expand the announcement banner initially so we can calculate if it is expandable or not on mount.
            isExpanded: true,
            isExpandable: false
        }, this.onHeaderRef = (refNode)=>{
            this.headerRef = refNode;
            this.calculateIfExpandable();
        }, this.onMessageRef = (refNode)=>{
            this.messageRef = refNode;
            this.calculateIfExpandable();
        }, this.expandBanner = ()=>{
            const { onExpandClicked: onExpandClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onExpandClicked && onExpandClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('expanded');
            this.setState({
                isExpanded: true
            });
        }, this.collapseBanner = ()=>{
            const { onCollapseClicked: onCollapseClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onCollapseClicked && onCollapseClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('collapsed');
            this.setState({
                isExpanded: false
            });
        }, /**
   * This will return char counts for the header and message. It uses inner text so it can ignore
   * HTML markup in the calculation.
   */ this.getAnnouncementCharCounts = ()=>{
            const headerCharCount = this.headerRef && this.headerRef.innerText ? this.headerRef.innerText.length : undefined;
            const messageCharCount = this.messageRef && this.messageRef.innerText ? this.messageRef.innerText.length : undefined;
            return {
                headerCharCount: headerCharCount,
                messageCharCount: messageCharCount
            };
        };
    }
}
var $37d23afb1cfd201e$export$2e2bcd8739ae039 = $37d23afb1cfd201e$var$AnnouncementBanner;

});
parcelRegister("fhYB5", function(module, exports) {
$parcel$export(module.exports, "getBoundingBox", () => $7d3b724827060329$export$895c5e634403eaa7);
$parcel$export(module.exports, "getElementHeight", () => $7d3b724827060329$export$8e0f1520ce23a388);
$parcel$export(module.exports, "blur", () => $7d3b724827060329$export$2cc7ff91bcacba5e);
$parcel$export(module.exports, "focus", () => $7d3b724827060329$export$d7ddd398f22d79ef);
const $7d3b724827060329$export$895c5e634403eaa7 = (element)=>element.getBoundingClientRect();
const $7d3b724827060329$export$8e0f1520ce23a388 = (element)=>element.clientHeight;
function $7d3b724827060329$export$2cc7ff91bcacba5e(id) {
    const element = document.getElementById(id);
    if (element) element.blur();
}
function $7d3b724827060329$export$d7ddd398f22d79ef(id) {
    const element = document.getElementById(id);
    if (element) element.focus();
}

});

parcelRegister("cm6cS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ad855d17ce24ce4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $25eLu = parcelRequire("25eLu");

var $k3ktd = parcelRequire("k3ktd");

var $imLe4 = parcelRequire("imLe4");

var $3DjOo = parcelRequire("3DjOo");

var $6F3K7 = parcelRequire("6F3K7");

var $fcCIH = parcelRequire("fcCIH");

var $13zmE = parcelRequire("13zmE");

var $f69ft = parcelRequire("f69ft");

var $iE2ki = parcelRequire("iE2ki");
class $1ad855d17ce24ce4$export$76695f5f5a9db4b2 extends $fc4bM.Component {
    renderChevrons() {
        const { isExpandable: isExpandable, isExpanded: isExpanded, intl: intl } = this.props;
        if (isExpandable) return /*#__PURE__*/ $fc4bM.createElement($1ad855d17ce24ce4$export$281662cd1c27e560, {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-controls": "announcement-message",
            "aria-label": intl.formatMessage((0, $iE2ki.default).view),
            onClick: this.handleClick,
            "data-testid": "view-announcement-btn"
        }, isExpanded ? /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f69ft))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronUpIcon",
            label: ""
        }) : /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronDownIcon",
            label: ""
        }));
        return null;
    }
    render() {
        const { isExpanded: isExpanded, header: header, messageHtml: messageHtml, onMessageRef: onMessageRef, onHeaderRef: onHeaderRef, className: className, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isCursorGrab: isCursorGrab, removePadding: removePadding } = this.props;
        const rootProps = {
            role: 'region',
            'aria-labelledby': 'announcement-header',
            skipFocus: true
        };
        if (!!header || !!messageHtml) return /*#__PURE__*/ $fc4bM.createElement($1ad855d17ce24ce4$export$be92b6f5f03c0fe9, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            removeBgColor: removeBgColor,
            isExpanded: isExpanded,
            isCursorGrab: isCursorGrab,
            ...rootProps
        }, /*#__PURE__*/ $fc4bM.createElement(InnerContainerComponent, null, /*#__PURE__*/ $fc4bM.createElement($1ad855d17ce24ce4$var$Container, {
            removePadding: removePadding
        }, /*#__PURE__*/ $fc4bM.createElement($1ad855d17ce24ce4$export$758c5636f09cf302, {
            onClick: this.stopPropagationForLinks,
            onKeyDown: this.stopPropagationForLinks
        }, header && /*#__PURE__*/ $fc4bM.createElement($1ad855d17ce24ce4$export$95911024f008ea42, {
            id: "announcement-header",
            "data-testid": "announcement-banner-header",
            innerRef: onHeaderRef,
            isExpanded: isExpanded
        }, header), messageHtml && /*#__PURE__*/ $fc4bM.createElement($1ad855d17ce24ce4$export$f69c19e57285b83a, {
            id: "announcement-message",
            innerRef: onMessageRef,
            isExpanded: isExpanded,
            dangerouslySetInnerHTML: {
                __html: messageHtml
            }
        })), this.renderChevrons())));
        return null;
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { isExpanded: isExpanded, shrinkBanner: shrinkBanner, expandBanner: expandBanner } = this.props;
            isExpanded ? shrinkBanner() : expandBanner();
        }, /**
   * This will stop propagation for any anchor element clicked or key pressed.
   * If we see a need for this elsewhere - this could be a good generic component with minimal lines
   * of code.
   */ this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') e.stopPropagation();
        };
    }
}
var $1ad855d17ce24ce4$export$2e2bcd8739ae039 = (0, $fcCIH.default)($1ad855d17ce24ce4$export$76695f5f5a9db4b2);
/**
 * Watch out! Changing anything that will affect height (fontsize, padding, etc) in here will
 * break the clamping logic inside announcement-banner.tsx (look for SINGLE_LINE_TITLE_HEIGHT).
 * If you change anything here make sure it still works!
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1ad855d17ce24ce4$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-sxf8hv-0"
})`display:flex;justify-content:space-between;padding-top:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};padding-bottom:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};`;
const $1ad855d17ce24ce4$export$f2e4196c0d2b5bb8 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-sxf8hv-1"
})`flex-shrink:0;${$k3ktd.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut},${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};border-radius:50%;}`;
const $1ad855d17ce24ce4$export$281662cd1c27e560 = /*#__PURE__*/ (0, $luz1X.default).button.withConfig({
    componentId: "sc-sxf8hv-2"
})`flex-shrink:0;border:none;background:transparent;align-self:flex-start;cursor:pointer;${$k3ktd.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut},${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};border-radius:50%;}&:focus-visible,&:hover{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $1ad855d17ce24ce4$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $luz1X.default)((0, $25eLu.default)).withConfig({
    componentId: "sc-sxf8hv-3"
})`${$3DjOo.borderRadius};${(props)=>$3DjOo.applyIf(!props.removeBgColor, $3DjOo.subtleThemeColorBackground)};${$imLe4.regular};display:block;width:100%;text-align:left;transition:color ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};color:${"var(--ds-text, #172B4D)"};box-sizing:border-box;overflow:hidden;&:focus-visible,&:hover ${$1ad855d17ce24ce4$export$f2e4196c0d2b5bb8}{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $1ad855d17ce24ce4$export$95911024f008ea42 = /*#__PURE__*/ (0, $luz1X.default).h2.withConfig({
    componentId: "sc-sxf8hv-4"
})`${$imLe4.medium};${(props)=>$3DjOo.applyIf(!props.isExpanded, $3DjOo.clamp)};margin-top:0;margin-bottom:${"var(--ds-space-100, 8px)"};font-weight:600;`;
const $1ad855d17ce24ce4$export$f69c19e57285b83a = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-sxf8hv-5"
})`${(props)=>$3DjOo.applyIf(!props.isExpanded, $3DjOo.multiLineClamp(1))}`;
const $1ad855d17ce24ce4$export$758c5636f09cf302 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-sxf8hv-6"
})`display:flex;flex-direction:column;width:100%;overflow:hidden;flex-shrink:0;`;

});
parcelRegister("25eLu", function(module, exports) {
$parcel$export(module.exports, "default", () => $3793c52c73e71155$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bYhFu = parcelRequire("bYhFu");
class $3793c52c73e71155$export$2e2bcd8739ae039 extends $fc4bM.Component {
    render() {
        const { children: children, disabled: disabled, isExpanded: isExpanded, isCursorGrab: isCursorGrab, role: role, skipFocus: skipFocus, className: className = '' } = this.props;
        const skipFocusStyle = skipFocus ? ' no-focus' : '';
        const fakeBtnClassName = className + skipFocusStyle;
        return /*#__PURE__*/ $fc4bM.createElement((0, $bYhFu.default), {
            "data-testid": "fake-button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: fakeBtnClassName,
            role: role || 'button',
            tabIndex: disabled || skipFocus ? -1 : 0,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            "aria-disabled": disabled,
            "aria-hidden": disabled,
            "aria-expanded": isExpanded ? true : false,
            isCursorGrab: isCursorGrab
        }, children);
    }
    constructor(...args){
        super(...args), this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') {
                e.stopPropagation();
                return true;
            }
            return false;
        }, this.handleKeyDown = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === 'Enter') onClick && onClick(e);
            else if (e.key === ' ') // Prevent default so scrolling doesn't happen when we press spacebar.
            e.preventDefault();
        }, this.handleClick = (e)=>{
            if (this.stopPropagationForLinks(e)) return;
            this.props.onClick && this.props.onClick(e);
        }, this.handleKeyUp = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === ' ') onClick && onClick(e);
        };
    }
}

});
parcelRegister("bYhFu", function(module, exports) {
$parcel$export(module.exports, "default", () => $daaf205ad4d2f172$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $3DjOo = parcelRequire("3DjOo");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $daaf205ad4d2f172$var$FakeButtonContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1kveg5f-0"
})`${$3DjOo.focusRing.default};display:inline-block;${(props)=>props.skipFocus ? 'cursor: default' : 'cursor: pointer'};&.no-focus,&[aria-disabled='true']{${$3DjOo.focusRing.none};${(props)=>props.isCursorGrab ? 'cursor: grab' : 'cursor: default'};}`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$daaf205ad4d2f172$export$2e2bcd8739ae039 = $daaf205ad4d2f172$var$FakeButtonContainer;

});


parcelRegister("iE2ki", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2f615a3d79c6f58$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $a2f615a3d79c6f58$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    expand: {
        defaultMessage: 'Expand announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.expand'
    },
    shrink: {
        defaultMessage: 'Shrink announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.shrink'
    },
    view: {
        defaultMessage: 'View announcement',
        description: 'Label for viewing the announcement.',
        id: 'sd.common.announcement.view'
    }
});

});




parcelRegister("m7L3g", function(module, exports) {
$parcel$export(module.exports, "SkipToMainContent", () => $004e7ea752e9236c$export$5a2051bae734c99d);
$parcel$export(module.exports, "GridContentWrapper", () => $004e7ea752e9236c$export$2e1fb94eeb76eca0);
$parcel$export(module.exports, "default", () => $004e7ea752e9236c$export$2e2bcd8739ae039);
/* grid-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $5a4EU = parcelRequire("5a4EU");

var $jVMDF = parcelRequire("jVMDF");

var $kig2V = parcelRequire("kig2V");
parcelRequire("jEqr0");
var $gpJGQ = parcelRequire("gpJGQ");

var $4m70N = parcelRequire("4m70N");

var $8TtZr = parcelRequire("8TtZr");
const $004e7ea752e9236c$export$5a2051bae734c99d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gpJGQ.MainContentSkipLinkWrapper), null, (0, $dRkX9.fg)('do_not_use_banner_colour_for_hyperlinks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        testId: "skip-to-main-content",
        xcss: $004e7ea752e9236c$var$mainContentSkipLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            "_43ds1ohs _oxk41ohs"
        ])
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        testId: "skip-to-main-content",
        xcss: $004e7ea752e9236c$var$mainContentSkipLinkStyles
    }, children));
const $004e7ea752e9236c$export$2e1fb94eeb76eca0 = ({ children: children, appearance: appearance, hide: hide })=>{
    const gridWidth = (0, $8TtZr.getContentWidth)(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        testId: "grid-content-wrapper",
        xcss: $004e7ea752e9236c$var$staticWrapperStyles,
        style: {
            maxWidth: hide ? '100%' : gridWidth
        }
    }, children);
};
const $004e7ea752e9236c$var$GridContainer = ({ children: children, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent, appearance: contentAppearance })=>{
    const hide = contentAppearance === 'none';
    const appearance = contentAppearance || 'normal';
    if (appearance === 'note') {
        const noteContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m70N.NoteContent), {
            appearance: appearance,
            hide: hide,
            "data-testid": "note-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m70N.NoteBackground), {
            "data-testid": "note-background"
        }, children));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $004e7ea752e9236c$var$noteContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $004e7ea752e9236c$var$noteColumnStyles
        }, noteContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $004e7ea752e9236c$var$footerAtBottomStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m70N.StyledFooter), null))));
    }
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m70N.StyledFooter), {
        isCSM: isCSM
    });
    // A11Y-29321: footer rendered as a sibling of the `<main>` landmark (outside it), pinned to the bottom.
    const mainAndFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $004e7ea752e9236c$var$mainColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($004e7ea752e9236c$export$5a2051bae734c99d, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $004e7ea752e9236c$var$footerAtBottomStyles
    }, footer));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "section",
        xcss: $004e7ea752e9236c$var$sectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($004e7ea752e9236c$export$2e1fb94eeb76eca0, {
        appearance: appearance,
        hide: hide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        xcss: $004e7ea752e9236c$var$gridContainerStyles,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        xcss: $004e7ea752e9236c$var$gridItemStyles
    }, hideSkipToMainContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children, footer) : mainAndFooter))));
};
const $004e7ea752e9236c$var$wrapperStyles = null;
const $004e7ea752e9236c$var$sectionStyles = (0, $kig2V.xcss)({
    flex: 1
});
const $004e7ea752e9236c$var$staticWrapperStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    margin: '0 auto'
});
const $004e7ea752e9236c$var$gridContainerStyles = (0, $kig2V.xcss)({
    flex: 1,
    gridTemplateColumns: 'repeat(12, 1fr)'
});
const $004e7ea752e9236c$var$gridItemStyles = (0, $kig2V.xcss)({
    gridColumn: 'span 12'
});
const $004e7ea752e9236c$var$mainContentSkipLinkStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
// A11Y-29321: flex column holding the `<main>` landmark and the footer as siblings so the footer
// can sit outside `<main>` while staying pinned to the bottom of the page.
const $004e7ea752e9236c$var$mainColumnStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
const $004e7ea752e9236c$var$noteColumnStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
// A11Y-29321: pins the footer to the bottom of the flex column while it sits outside `<main>`.
const $004e7ea752e9236c$var$footerAtBottomStyles = (0, $kig2V.xcss)({
    marginTop: 'auto'
});
const $004e7ea752e9236c$var$noteContainerStyles = (0, $kig2V.xcss)({
    position: 'relative',
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});
var $004e7ea752e9236c$export$2e2bcd8739ae039 = $004e7ea752e9236c$var$GridContainer;

});
parcelRegister("8TtZr", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $dd9adacc008a3e3e$export$f61abf052f87399f);
// 800px is normal width
const $dd9adacc008a3e3e$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $dd9adacc008a3e3e$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $dd9adacc008a3e3e$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $dd9adacc008a3e3e$var$GRID_XXWIDE_WIDTH = '1200px';
const $dd9adacc008a3e3e$var$GRID_NOTE_WIDTH = '480px';
const $dd9adacc008a3e3e$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $dd9adacc008a3e3e$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $dd9adacc008a3e3e$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $dd9adacc008a3e3e$var$GRID_WIDE_WIDTH;
        case 'note':
            return $dd9adacc008a3e3e$var$GRID_NOTE_WIDTH;
        default:
            return $dd9adacc008a3e3e$var$GRID_NORMAL_WIDTH;
    }
};

});




parcelRegister("bQkW5", function(module, exports) {
$parcel$export(module.exports, "GridContainer", () => (parcelRequire("m7L3g")).default);
$parcel$export(module.exports, "SkipToMainContent", () => (parcelRequire("m7L3g")).SkipToMainContent);

var $m7L3g = parcelRequire("m7L3g");

});



parcelRegister("j9whS", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutDumb", () => (parcelRequire("dQIWS")).default);

var $dQIWS = parcelRequire("dQIWS");

});
parcelRegister("dQIWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce171c483ac7a603$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $8PITw = parcelRequire("8PITw");

var $5ZHKM = parcelRequire("5ZHKM");
parcelRequire("hzZg3");
var $6znAn = parcelRequire("6znAn");
parcelRequire("8GFfy");
var $1Zb3e = parcelRequire("1Zb3e");
parcelRequire("kOWPe");
var $1fQE4 = parcelRequire("1fQE4");

var $iG0dO = parcelRequire("iG0dO");
parcelRequire("7gJkl");
var $5ke1o = parcelRequire("5ke1o");
parcelRequire("blonq");
var $6Mfyl = parcelRequire("6Mfyl");
parcelRequire("jDBRI");
var $ju0hb = parcelRequire("ju0hb");

var $babis = parcelRequire("babis");

var $6BtWW = parcelRequire("6BtWW");

var $6920b = parcelRequire("6920b");

var $d7r8x = parcelRequire("d7r8x");

var $cf3fd = parcelRequire("cf3fd");
const $ce171c483ac7a603$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6920b.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6BtWW.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $ce171c483ac7a603$var$BannerWithPaperLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, path: path, searchShown: searchShown, isBrandingLoaded: isBrandingLoaded, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM })=>{
    const showBannerWithLoader = ()=>{
        if (isBrandingLoaded) return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$Banner, {
            imageSrc: helpCenterBanner
        });
        return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8PITw.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: (0, $iG0dO.BANNER_HEIGHT).unitless,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6znAn.default), {
        className: "px-paper-layout"
    }), (0, $cf3fd.isKoshEnabledForDefaultHelpCenter)() ? showBannerWithLoader() : !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$Banner, {
        imageSrc: helpCenterBanner
    }), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ju0hb.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5ke1o.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    }), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$EmptyHeader, {
        "data-testid": "empty-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce171c483ac7a603$var$PaperContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6Mfyl.default), {
        appearance: paperAppearance,
        pageKey: path,
        isCSM: isCSM
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $babis.AutoHeightBody), null)))));
};
var $ce171c483ac7a603$export$2e2bcd8739ae039 = $ce171c483ac7a603$var$BannerWithPaperLayoutDumb;
const $ce171c483ac7a603$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ce171c483ac7a603$var$SidebarPusherRoot = /*#__PURE__*/ (0, $luz1X.default)((0, $1fQE4.default)).withConfig({
    componentId: "sc-ku2ur3-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ce171c483ac7a603$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ku2ur3-1"
})`position:relative;overflow-x:hidden;display:flex;flex-direction:column;min-height:${$ce171c483ac7a603$var$CONTAINER_MIN_HEIGHT};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ce171c483ac7a603$var$PaperContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ku2ur3-2"
})`position:relative;display:flex;flex:1 1 auto;overflow:hidden;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ce171c483ac7a603$var$Banner = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ku2ur3-3"
})`position:absolute;top:0;left:0;right:0;height:${(0, $iG0dO.BANNER_HEIGHT).px};z-index:${$5ZHKM.banner};background-color:${(props)=>`var(--ds-background-brand-bold, ${props.theme.color})`};background-image:${(props)=>!!props.imageSrc ? `url(${props.imageSrc})` : 'none'};background-size:cover;background-repeat:no-repeat;background-position:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ce171c483ac7a603$var$LoadingContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ku2ur3-4"
})`position:absolute;top:0;left:0;right:0;height:${(0, $iG0dO.BANNER_HEIGHT).px};z-index:${$5ZHKM.banner};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ce171c483ac7a603$var$EmptyHeader = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ku2ur3-5"
})`height:${(0, $iG0dO.HEADER_HEIGHT)}px;width:100%;`;
const $ce171c483ac7a603$export$36525627ce333d44 = /*#__PURE__*/ (0, $luz1X.default)((0, $1Zb3e.Flipper)).withConfig({
    componentId: "sc-ku2ur3-6"
})`display:flex;flex-direction:column;`;

});


parcelRegister("aQGvL", function(module, exports) {
$parcel$export(module.exports, "withLayoutRoute", () => (parcelRequire("jAOGD")).default);

var $jAOGD = parcelRequire("jAOGD");

});
parcelRegister("jAOGD", function(module, exports) {
$parcel$export(module.exports, "default", () => $00ff7be1709966e6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eXQnZ = parcelRequire("eXQnZ");

var $6dipk = parcelRequire("6dipk");
parcelRequire("a3Wd7");
var $dpoZ0 = parcelRequire("dpoZ0");
parcelRequire("dRiEG");
var $7hPHG = parcelRequire("7hPHG");

var $c7fhU = parcelRequire("c7fhU");

var $dkrfZ = parcelRequire("dkrfZ");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");
parcelRequire("7oeOH");
var $1foAT = parcelRequire("1foAT");
/**
 * This will return a component which will pass the Layout and children into a <Route />.
 * It will capture all path params and set them into redux, as well as providing them to withPathParams() higher order component.
 * @param Layout Layout component we're wrapping.
 */ function $00ff7be1709966e6$var$withLayoutRoute(Layout) {
    return class LayoutRoute extends $fc4bM.Component {
        render() {
            const LayoutWithChildren = this.LayoutWithChildren;
            return /*#__PURE__*/ $fc4bM.createElement((0, $dpoZ0.RouterSubscriber), null, (routerState)=>{
                return /*#__PURE__*/ $fc4bM.createElement(LayoutWithChildren, routerState);
            });
        }
        constructor(...args){
            super(...args), // Create an instance Component to pass down react router props to ChildrenComponent as well block
            // any extraneous rendering from query params updating.
            this.LayoutWithChildren = (0, $1foAT.default)((innerRouteProps)=>{
                const { renderError: renderError, layoutProps: layoutProps, path: path, isFooterHidden: isFooterHidden, screenName: screenName, component: ChildrenComponent } = this.props;
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const query = $6dipk.parse(innerRouteProps.location.search);
                const component = /*#__PURE__*/ $fc4bM.createElement((0, $eXQnZ.PathParamsProvider), {
                    params: innerRouteProps.match.params
                }, /*#__PURE__*/ $fc4bM.createElement((0, $c7fhU.OnboardingProvider), {
                    query: query
                }, /*#__PURE__*/ $fc4bM.createElement(Layout, {
                    ...layoutProps,
                    path: path,
                    isFooterHidden: isFooterHidden
                }, /*#__PURE__*/ $fc4bM.createElement((0, $4xX38.default), {
                    screenName: screenName,
                    renderError: renderError
                }, /*#__PURE__*/ $fc4bM.createElement(ChildrenComponent, innerRouteProps)))), /*#__PURE__*/ $fc4bM.createElement((0, $7hPHG.default), innerRouteProps));
                return screenName ? /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
                    screenName: screenName,
                    screenId: innerRouteProps.match.url
                }, component) : component;
            }, ()=>this.props.reRenderOnQueryParameterChanges || []);
        }
    };
}
var $00ff7be1709966e6$export$2e2bcd8739ae039 = $00ff7be1709966e6$var$withLayoutRoute;

});
parcelRegister("c7fhU", function(module, exports) {
$parcel$export(module.exports, "OnboardingProvider", () => $0b31b43e34edefc7$export$54ba648a75d332de);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $eXQnZ = parcelRequire("eXQnZ");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $g81wt = parcelRequire("g81wt");

var $664yX = parcelRequire("664yX");
const $0b31b43e34edefc7$var$mapStateToProps = (state, props)=>({
        projectId: (0, $9D9SX.getProjectId)(state, (0, $g81wt.toNumber)(props.portalId)),
        showRequestTypeOnboarding: (0, $9D9SX.getCanAdministerProject)(state, (0, $g81wt.toNumber)(props.portalId))
    });
const $0b31b43e34edefc7$export$54ba648a75d332de = (0, $eXQnZ.default)((0, $6umft.default)($0b31b43e34edefc7$var$mapStateToProps)((0, $664yX.default)));

});
parcelRegister("664yX", function(module, exports) {
$parcel$export(module.exports, "default", () => $703ab80b4c3e8ed1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hiDQB = parcelRequire("hiDQB");
const $703ab80b4c3e8ed1$export$19b38316c9e7b045 = /*#__PURE__*/ $fc4bM.createContext({
    isLoading: true,
    isRequestCreated: false,
    isDemoProject: false
});
const $703ab80b4c3e8ed1$export$87a388960a322f14 = $703ab80b4c3e8ed1$export$19b38316c9e7b045.Consumer;
class $703ab80b4c3e8ed1$export$2e2bcd8739ae039 extends $fc4bM.Component {
    async componentDidMount() {
        await this.fetchOnboarding();
    }
    async componentDidUpdate(prevProps) {
        const projectIdChanged = prevProps.projectId !== this.props.projectId;
        if (projectIdChanged) await this.fetchOnboarding();
    }
    render() {
        const { children: children, query: query } = this.props;
        const { isLoading: isLoading, isDemoProject: isDemoProject } = this.state;
        const isRequestCreated = !!query.created;
        return /*#__PURE__*/ $fc4bM.createElement($703ab80b4c3e8ed1$export$19b38316c9e7b045.Provider, {
            value: {
                isLoading: isLoading,
                isDemoProject: isDemoProject,
                isRequestCreated: isRequestCreated
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: true,
            isDemoProject: false
        }, /**
   * fetchOnboarding()
   * This method should fetch all onboarding and then set the results appropriately.
   * Remember: Only one onboarding should be shown at a time.
   */ this.fetchOnboarding = async ()=>{
            // Extend this later to fetch all onboarding sources.
            const { projectId: projectId, showRequestTypeOnboarding: showRequestTypeOnboarding } = this.props;
            if (!projectId) return;
            let newState = {};
            if (showRequestTypeOnboarding) {
                const isDemoProject = await (0, $hiDQB.getIsDemoProject)(projectId);
                newState = {
                    ...newState,
                    isDemoProject: isDemoProject,
                    isLoading: false
                };
            }
            this.setState(newState);
        };
    }
}

});
parcelRegister("hiDQB", function(module, exports) {
$parcel$export(module.exports, "getIsDemoProject", () => $9134e92d5e93f941$export$2156daeb7d24c1fc);

var $bTjsX = parcelRequire("bTjsX");

var $jFk35 = parcelRequire("jFk35");

var $diqlM = parcelRequire("diqlM");
const $9134e92d5e93f941$export$2156daeb7d24c1fc = (projectId)=>{
    const uri = `${(0, $diqlM.contextPath)}/rest/internal/latest/frontendconfig/properties?projectId=${projectId}&project=isDemo`;
    return (0, $bTjsX.get)(uri).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (ajaxResponse.response && ajaxResponse.response.project) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return !!ajaxResponse.response.project.isDemo;
        return false;
    }).catch(()=>(0, $jFk35.Observable).of(false)).toPromise();
};

});



parcelRegister("7oeOH", function(module, exports) {
$parcel$export(module.exports, "withIgnoreQueryParamUpdates", () => (parcelRequire("1foAT")).default);

var $1foAT = parcelRequire("1foAT");

});
parcelRegister("1foAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aee7c1f0e9ef219$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");

var $6dipk = parcelRequire("6dipk");
/**
 * Higher order component which implements a shouldComponentUpdate() to block re-rendering if only the query
 * param updated from the react router props.
 * @param renderChild Render function that will return JSX.
 * @param whiteListedQueryParametersSupplier
 */ const $3aee7c1f0e9ef219$var$withIgnoreQueryParamUpdates = (renderChild, whiteListedQueryParametersSupplier)=>{
    return class GeneratedLayout extends $fc4bM.Component {
        areWhiteListedQueryParametersDifferent(search, nextSearch) {
            const whiteListedQueryParameters = whiteListedQueryParametersSupplier();
            if (whiteListedQueryParameters.length > 0) {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedSearch = $6dipk.parse(search);
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedNextSearch = $6dipk.parse(nextSearch);
                let i = 0;
                for(i; i < whiteListedQueryParameters.length; i++){
                    const whiteListedProp = whiteListedQueryParameters[i];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const value = parsedSearch[whiteListedProp];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const nextValue = parsedNextSearch[whiteListedProp];
                    if (value !== nextValue) return true;
                }
            }
            return false;
        }
        shouldComponentUpdate(nextProps) {
            const { location: location, ...remainingProps } = this.props;
            const { location: nextLocation, ...remainingNextProps } = nextProps;
            const nonQueryLocationChanged = GeneratedLayout.hasNonQueryLocationChanged(location, nextLocation);
            if (nonQueryLocationChanged) return true;
            if (!(0, $aYMdQ.isEqual)(remainingProps, remainingNextProps)) return true;
            return this.areWhiteListedQueryParametersDifferent(location.search, nextLocation.search);
        }
        static hasNonQueryLocationChanged(location, nextLocation) {
            const { search: search, ...remainingLocationProps } = location;
            const { search: nextSearch, ...remainingNextLocationProps } = nextLocation;
            // If any props other than query parameter changed then we will update
            return !(0, $aYMdQ.isEqual)(remainingLocationProps, remainingNextLocationProps);
        }
        render() {
            return renderChild(this.props);
        }
    };
};
var $3aee7c1f0e9ef219$export$2e2bcd8739ae039 = $3aee7c1f0e9ef219$var$withIgnoreQueryParamUpdates;

});







parcelRegister("eMdst", function(module, exports) {
$parcel$export(module.exports, "UiModificationsContainer", () => $ac972c866884450e$export$1834060b93715de7);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $9d0Fc = parcelRequire("9d0Fc");

var $bfYTF = parcelRequire("bfYTF");

var $gO5n7 = parcelRequire("gO5n7");
const $ac972c866884450e$export$1834060b93715de7 = ({ children: children })=>{
    return (0, $hN5YJ.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9d0Fc.BaseUiModificationsContainer), {
        scope: (0, $bfYTF.REQUEST_CREATE_VIEW_TYPE),
        viewType: (0, $bfYTF.REQUEST_CREATE_VIEW_TYPE),
        viewConfiguration: (0, $gO5n7.RequestCreateViewConfiguration)
    }, children) : children;
};

});
parcelRegister("9d0Fc", function(module, exports) {
$parcel$export(module.exports, "BaseUiModificationsContainer", () => $3c0025696c274eb3$export$8b7a045f60eb9797);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $g4H12 = parcelRequire("g4H12");

var $2pYXn = parcelRequire("2pYXn");

var $2O5nf = parcelRequire("2O5nf");
const $3c0025696c274eb3$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    (0, $2O5nf.useLoadViewConfiguration)(viewType, viewConfiguration);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2pYXn.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g4H12.UiModificationContextContainer), {
        scope: scope
    }, children));
};

});
parcelRegister("g4H12", function(module, exports) {
$parcel$export(module.exports, "store", () => $fcd019b47fc02cff$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $fcd019b47fc02cff$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $fcd019b47fc02cff$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $fcd019b47fc02cff$export$5eb9c167b683d125);

var $5nVr1 = parcelRequire("5nVr1");
var $ik3UL = parcelRequire("ik3UL");
var $ipn74 = parcelRequire("ipn74");
const $fcd019b47fc02cff$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $fcd019b47fc02cff$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($fcd019b47fc02cff$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $fcd019b47fc02cff$export$6f57813fe9f31bf9 = (0, $ipn74.createStore)({
    name: 'issue-adjustments-context',
    initialState: $fcd019b47fc02cff$var$initialState,
    actions: $fcd019b47fc02cff$export$e324594224ef24da
});
const $fcd019b47fc02cff$export$a12f82a132dee079 = (0, $5nVr1.createHook)($fcd019b47fc02cff$export$6f57813fe9f31bf9);
const $fcd019b47fc02cff$export$358ad850b2f6d6fe = (0, $5nVr1.createStateHook)($fcd019b47fc02cff$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $fcd019b47fc02cff$export$4f2729981f4b81d2 = (0, $5nVr1.createActionsHook)($fcd019b47fc02cff$export$6f57813fe9f31bf9);
const $fcd019b47fc02cff$export$5eb9c167b683d125 = (0, $ik3UL.createContainer)($fcd019b47fc02cff$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("2pYXn", function(module, exports) {
$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $8490a38a742cf9cb$export$b087a12fbb84e8ac);

var $ik3UL = parcelRequire("ik3UL");

var $kzQWi = parcelRequire("kzQWi");
const $8490a38a742cf9cb$export$b087a12fbb84e8ac = (0, $ik3UL.createContainer)((0, $kzQWi.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("kzQWi", function(module, exports) {
$parcel$export(module.exports, "store", () => $be07691f21d6b982$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedFields", () => $be07691f21d6b982$export$c76e674a29843e21);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $be07691f21d6b982$export$cb9a014ec14556d8);
// eslint-disable-next-line import/order

var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");

var $2D6FW = parcelRequire("2D6FW");

var $hPb2D = parcelRequire("hPb2D");

var $6wuVZ = parcelRequire("6wuVZ");

var $azpg0 = parcelRequire("azpg0");

var $869fR = parcelRequire("869fR");

var $g5fhN = parcelRequire("g5fhN");

var $8dWYV = parcelRequire("8dWYV");

var $8jqFd = parcelRequire("8jqFd");

var $frQbL = parcelRequire("frQbL");

var $7tF5h = parcelRequire("7tF5h");

var $5btgo = parcelRequire("5btgo");

var $3scmc = parcelRequire("3scmc");

var $ivhfC = parcelRequire("ivhfC");

var $eJXpL = parcelRequire("eJXpL");

var $hQyMs = parcelRequire("hQyMs");
const $be07691f21d6b982$var$name = 'issue-adjustments';
const $be07691f21d6b982$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $be07691f21d6b982$var$triggerFieldInitializationKey, viewType: $be07691f21d6b982$var$scopedViewType, numberOfSupportedFields: $be07691f21d6b982$var$numberOfSupportedFields, ...$be07691f21d6b982$var$stateForResetAllFields } = $be07691f21d6b982$export$d4c72bab9d6cc13a;
const $be07691f21d6b982$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $7tF5h.processChange,
    setFieldValue: $3scmc.setFieldValue,
    initializeField: $g5fhN.initializeField,
    initializeFields: $g5fhN.initializeFields,
    startFieldsInitialisationTimeout: $869fR.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $869fR.successFieldsInitalisation,
    registerFields: $5btgo.registerFields,
    unregisterFields: $5btgo.unregisterFields,
    updateFields: $eJXpL.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($be07691f21d6b982$var$stateForResetAllFields);
        },
    setError: $azpg0.setError,
    resetError: $azpg0.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
   * This is used to block onInit for specific case like Issue View background refresh loading.
   */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $2D6FW.setAppErrors,
    resetAppErrors: $2D6FW.resetAppErrors,
    addAppsErrors: $2D6FW.addAppsErrors,
    initializeNoScreenTab: $8dWYV.initializeNoScreenTab,
    initializeScreenTabs: $8jqFd.initializeScreenTabs,
    updateScreenTabs: $hQyMs.updateScreenTabs,
    updateActiveScreenTab: $ivhfC.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hPb2D.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $6wuVZ.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $6wuVZ.collectFieldsAppliedChangesHistory,
    setNotification: $frQbL.setNotification,
    resetNotification: $frQbL.resetNotification
};
const $be07691f21d6b982$export$6f57813fe9f31bf9 = (0, $ipn74.createStore)({
    name: $be07691f21d6b982$var$name,
    initialState: $be07691f21d6b982$export$d4c72bab9d6cc13a,
    actions: $be07691f21d6b982$export$e324594224ef24da
});
const $be07691f21d6b982$export$37792a602e748c08 = (0, $5nVr1.createHook)($be07691f21d6b982$export$6f57813fe9f31bf9);
const $be07691f21d6b982$var$stableEmptyFieldFromIframe = {};
const $be07691f21d6b982$export$c76e674a29843e21 = (0, $5nVr1.createHook)($be07691f21d6b982$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $be07691f21d6b982$export$df4b0714e8177e0e = (0, $5nVr1.createHook)($be07691f21d6b982$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>{
        var _state$appliedChanges;
        return ((_state$appliedChanges = state.appliedChanges) === null || _state$appliedChanges === void 0 ? void 0 : _state$appliedChanges[fieldId]) || $be07691f21d6b982$var$stableEmptyFieldFromIframe;
    }
});
const $be07691f21d6b982$export$cb9a014ec14556d8 = (0, $5nVr1.createActionsHook)($be07691f21d6b982$export$6f57813fe9f31bf9);
const $be07691f21d6b982$export$677b3e34bd14c681 = (0, $5nVr1.createHook)($be07691f21d6b982$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("2D6FW", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $e1d944f3748690ec$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $e1d944f3748690ec$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $e1d944f3748690ec$export$24c821207687a907);
const $e1d944f3748690ec$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $e1d944f3748690ec$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $e1d944f3748690ec$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hPb2D", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $d2d66a71995e6ac6$export$90d94f20d157e756);

var $hWDOW = parcelRequire("hWDOW");

var $6uIU4 = parcelRequire("6uIU4");

var $2D6FW = parcelRequire("2D6FW");

var $frQbL = parcelRequire("frQbL");

var $czW0G = parcelRequire("czW0G");
const $d2d66a71995e6ac6$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $d2d66a71995e6ac6$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $d2d66a71995e6ac6$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $d2d66a71995e6ac6$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $d2d66a71995e6ac6$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId === null || appliedChangesHistoryChangeId === void 0 ? void 0 : appliedChangesHistoryChangeId.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $6uIU4.ON_INIT_CHANGE_ID) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $czW0G.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $2D6FW.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $frQbL.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("hWDOW", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $7719b6838b02ce9c$export$a1fb57756f0de62b);

var $8lxUN = parcelRequire("8lxUN");

var $aVQWM = parcelRequire("aVQWM");

var $d9XyX = parcelRequire("d9XyX");
const $7719b6838b02ce9c$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $8lxUN.default)((0, $d9XyX.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $aVQWM.OPERATIONAL_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});
parcelRegister("d9XyX", function(module, exports) {
$parcel$export(module.exports, "UI_MODIFICATIONS_ANALYTICS_CHANNEL", () => $3c28dc17693d8b05$export$8280e5c6104c5b40);
const $3c28dc17693d8b05$export$8280e5c6104c5b40 = 'ui-modifications';

});


parcelRegister("6uIU4", function(module, exports) {
$parcel$export(module.exports, "ON_INIT_CHANGE_ID", () => $286a407993be5a32$export$415cc1afa6445f90);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $286a407993be5a32$export$811b7f067a43b422);
const $286a407993be5a32$export$415cc1afa6445f90 = 'onInitChangeId';
const $286a407993be5a32$export$811b7f067a43b422 = 'jira:uiModifications';

});

parcelRegister("frQbL", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $a147f4816609b193$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $a147f4816609b193$export$caafa3945f199bc7);
const $a147f4816609b193$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $a147f4816609b193$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("czW0G", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $e4e553eeac7aa39a$export$a06103ec99e4e394);

var $6IHjK = parcelRequire("6IHjK");

var $h7jt0 = parcelRequire("h7jt0");

var $eKEBo = parcelRequire("eKEBo");

var $8pUt8 = parcelRequire("8pUt8");
const $e4e553eeac7aa39a$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $e4e553eeac7aa39a$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $8pUt8.SCREEN_TABS_HISTORY_TYPE)) return {
            type: (0, $h7jt0.MULTIPLE_APPS_CONFLICT),
            cause: (0, $h7jt0.MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$e4e553eeac7aa39a$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $eKEBo.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $h7jt0.MULTIPLE_APPS_CONFLICT),
            cause: (0, $h7jt0.MULTIPLE_APPS_CONFLICT_CAUSE_FIELD),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$e4e553eeac7aa39a$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $e4e553eeac7aa39a$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($6IHjK)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $e4e553eeac7aa39a$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("6IHjK", function(module, exports) {

var $40ghw = parcelRequire("40ghw");

var $18U9h = parcelRequire("18U9h");

var $bCf2H = parcelRequire("bCf2H");

var $6oSaQ = parcelRequire("6oSaQ");

var $aTpkk = parcelRequire("aTpkk");

var $3OJcL = parcelRequire("3OJcL");

var $f4mG0 = parcelRequire("f4mG0");

var $dGq8D = parcelRequire("dGq8D");
/** Used to compose bitmasks for cloning. */ var $4e48741c5f420612$var$CLONE_DEEP_FLAG = 1, $4e48741c5f420612$var$CLONE_FLAT_FLAG = 2, $4e48741c5f420612$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $4e48741c5f420612$var$omit = $f4mG0(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $40ghw(paths, function(path) {
        path = $6oSaQ(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $aTpkk(object, $dGq8D(object), result);
    if (isDeep) result = $18U9h(result, $4e48741c5f420612$var$CLONE_DEEP_FLAG | $4e48741c5f420612$var$CLONE_FLAT_FLAG | $4e48741c5f420612$var$CLONE_SYMBOLS_FLAG, $3OJcL);
    var length = paths.length;
    while(length--)$bCf2H(result, paths[length]);
    return result;
});
module.exports = $4e48741c5f420612$var$omit;

});
parcelRegister("18U9h", function(module, exports) {

var $h9qpk = parcelRequire("h9qpk");

var $bCswF = parcelRequire("bCswF");

var $54JYx = parcelRequire("54JYx");

var $fi5wL = parcelRequire("fi5wL");

var $ghwPJ = parcelRequire("ghwPJ");

var $8mc0c = parcelRequire("8mc0c");

var $7v5LO = parcelRequire("7v5LO");

var $7B6QG = parcelRequire("7B6QG");

var $jrYUE = parcelRequire("jrYUE");

var $256zW = parcelRequire("256zW");

var $dGq8D = parcelRequire("dGq8D");

var $eZ3ti = parcelRequire("eZ3ti");

var $jIM12 = parcelRequire("jIM12");

var $3gBoK = parcelRequire("3gBoK");

var $2BLEs = parcelRequire("2BLEs");

var $hl35j = parcelRequire("hl35j");

var $kA7Y3 = parcelRequire("kA7Y3");

var $5PtAi = parcelRequire("5PtAi");

var $e3M82 = parcelRequire("e3M82");

var $2B7hk = parcelRequire("2B7hk");

var $auIsz = parcelRequire("auIsz");

var $gyE4m = parcelRequire("gyE4m");
/** Used to compose bitmasks for cloning. */ var $0d5217c1ebec7b8d$var$CLONE_DEEP_FLAG = 1, $0d5217c1ebec7b8d$var$CLONE_FLAT_FLAG = 2, $0d5217c1ebec7b8d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $0d5217c1ebec7b8d$var$argsTag = '[object Arguments]', $0d5217c1ebec7b8d$var$arrayTag = '[object Array]', $0d5217c1ebec7b8d$var$boolTag = '[object Boolean]', $0d5217c1ebec7b8d$var$dateTag = '[object Date]', $0d5217c1ebec7b8d$var$errorTag = '[object Error]', $0d5217c1ebec7b8d$var$funcTag = '[object Function]', $0d5217c1ebec7b8d$var$genTag = '[object GeneratorFunction]', $0d5217c1ebec7b8d$var$mapTag = '[object Map]', $0d5217c1ebec7b8d$var$numberTag = '[object Number]', $0d5217c1ebec7b8d$var$objectTag = '[object Object]', $0d5217c1ebec7b8d$var$regexpTag = '[object RegExp]', $0d5217c1ebec7b8d$var$setTag = '[object Set]', $0d5217c1ebec7b8d$var$stringTag = '[object String]', $0d5217c1ebec7b8d$var$symbolTag = '[object Symbol]', $0d5217c1ebec7b8d$var$weakMapTag = '[object WeakMap]';
var $0d5217c1ebec7b8d$var$arrayBufferTag = '[object ArrayBuffer]', $0d5217c1ebec7b8d$var$dataViewTag = '[object DataView]', $0d5217c1ebec7b8d$var$float32Tag = '[object Float32Array]', $0d5217c1ebec7b8d$var$float64Tag = '[object Float64Array]', $0d5217c1ebec7b8d$var$int8Tag = '[object Int8Array]', $0d5217c1ebec7b8d$var$int16Tag = '[object Int16Array]', $0d5217c1ebec7b8d$var$int32Tag = '[object Int32Array]', $0d5217c1ebec7b8d$var$uint8Tag = '[object Uint8Array]', $0d5217c1ebec7b8d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0d5217c1ebec7b8d$var$uint16Tag = '[object Uint16Array]', $0d5217c1ebec7b8d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $0d5217c1ebec7b8d$var$cloneableTags = {};
$0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$argsTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$arrayTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$arrayBufferTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$dataViewTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$boolTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$dateTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$float32Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$float64Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$int8Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$int16Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$int32Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$mapTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$numberTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$objectTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$regexpTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$setTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$stringTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$symbolTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$uint8Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$uint8ClampedTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$uint16Tag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$uint32Tag] = true;
$0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$errorTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$funcTag] = $0d5217c1ebec7b8d$var$cloneableTags[$0d5217c1ebec7b8d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $0d5217c1ebec7b8d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $0d5217c1ebec7b8d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $0d5217c1ebec7b8d$var$CLONE_FLAT_FLAG, isFull = bitmask & $0d5217c1ebec7b8d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$e3M82(value)) return value;
    var isArr = $hl35j(value);
    if (isArr) {
        result = $jIM12(value);
        if (!isDeep) return $7v5LO(value, result);
    } else {
        var tag = $eZ3ti(value), isFunc = tag == $0d5217c1ebec7b8d$var$funcTag || tag == $0d5217c1ebec7b8d$var$genTag;
        if ($kA7Y3(value)) return $8mc0c(value, isDeep);
        if (tag == $0d5217c1ebec7b8d$var$objectTag || tag == $0d5217c1ebec7b8d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $2BLEs(value);
            if (!isDeep) return isFlat ? $jrYUE(value, $ghwPJ(result, value)) : $7B6QG(value, $fi5wL(result, value));
        } else {
            if (!$0d5217c1ebec7b8d$var$cloneableTags[tag]) return object ? value : {};
            result = $3gBoK(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $h9qpk);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($2B7hk(value)) value.forEach(function(subValue) {
        result.add($0d5217c1ebec7b8d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($5PtAi(value)) value.forEach(function(subValue, key) {
        result.set(key, $0d5217c1ebec7b8d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $dGq8D : $256zW : isFlat ? $gyE4m : $auIsz;
    var props = isArr ? undefined : keysFunc(value);
    $bCswF(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $54JYx(result, key, $0d5217c1ebec7b8d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $0d5217c1ebec7b8d$var$baseClone;

});
parcelRegister("bCswF", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $87595ef5b210fc5f$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $87595ef5b210fc5f$var$arrayEach;

});

parcelRegister("fi5wL", function(module, exports) {

var $aTpkk = parcelRequire("aTpkk");

var $auIsz = parcelRequire("auIsz");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b21cd3189f9c42a2$var$baseAssign(object, source) {
    return object && $aTpkk(source, $auIsz(source), object);
}
module.exports = $b21cd3189f9c42a2$var$baseAssign;

});

parcelRegister("ghwPJ", function(module, exports) {

var $aTpkk = parcelRequire("aTpkk");

var $gyE4m = parcelRequire("gyE4m");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $bda7b3e13fca05b5$var$baseAssignIn(object, source) {
    return object && $aTpkk(source, $gyE4m(source), object);
}
module.exports = $bda7b3e13fca05b5$var$baseAssignIn;

});

parcelRegister("7B6QG", function(module, exports) {

var $aTpkk = parcelRequire("aTpkk");

var $adEWj = parcelRequire("adEWj");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $58814d1ae48d88f3$var$copySymbols(source, object) {
    return $aTpkk(source, $adEWj(source), object);
}
module.exports = $58814d1ae48d88f3$var$copySymbols;

});

parcelRegister("jrYUE", function(module, exports) {

var $aTpkk = parcelRequire("aTpkk");

var $k2Qdc = parcelRequire("k2Qdc");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e28fc9f2281fa037$var$copySymbolsIn(source, object) {
    return $aTpkk(source, $k2Qdc(source), object);
}
module.exports = $e28fc9f2281fa037$var$copySymbolsIn;

});

parcelRegister("jIM12", function(module, exports) {
/** Used for built-in method references. */ var $e5b75f52d0287de2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e5b75f52d0287de2$var$hasOwnProperty = $e5b75f52d0287de2$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $e5b75f52d0287de2$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $e5b75f52d0287de2$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $e5b75f52d0287de2$var$initCloneArray;

});

parcelRegister("3gBoK", function(module, exports) {

var $339Qm = parcelRequire("339Qm");

var $dPRv7 = parcelRequire("dPRv7");

var $aGB2t = parcelRequire("aGB2t");

var $fV9WT = parcelRequire("fV9WT");

var $7Ogd2 = parcelRequire("7Ogd2");
/** `Object#toString` result references. */ var $260fe03cb06856c1$var$boolTag = '[object Boolean]', $260fe03cb06856c1$var$dateTag = '[object Date]', $260fe03cb06856c1$var$mapTag = '[object Map]', $260fe03cb06856c1$var$numberTag = '[object Number]', $260fe03cb06856c1$var$regexpTag = '[object RegExp]', $260fe03cb06856c1$var$setTag = '[object Set]', $260fe03cb06856c1$var$stringTag = '[object String]', $260fe03cb06856c1$var$symbolTag = '[object Symbol]';
var $260fe03cb06856c1$var$arrayBufferTag = '[object ArrayBuffer]', $260fe03cb06856c1$var$dataViewTag = '[object DataView]', $260fe03cb06856c1$var$float32Tag = '[object Float32Array]', $260fe03cb06856c1$var$float64Tag = '[object Float64Array]', $260fe03cb06856c1$var$int8Tag = '[object Int8Array]', $260fe03cb06856c1$var$int16Tag = '[object Int16Array]', $260fe03cb06856c1$var$int32Tag = '[object Int32Array]', $260fe03cb06856c1$var$uint8Tag = '[object Uint8Array]', $260fe03cb06856c1$var$uint8ClampedTag = '[object Uint8ClampedArray]', $260fe03cb06856c1$var$uint16Tag = '[object Uint16Array]', $260fe03cb06856c1$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $260fe03cb06856c1$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $260fe03cb06856c1$var$arrayBufferTag:
            return $339Qm(object);
        case $260fe03cb06856c1$var$boolTag:
        case $260fe03cb06856c1$var$dateTag:
            return new Ctor(+object);
        case $260fe03cb06856c1$var$dataViewTag:
            return $dPRv7(object, isDeep);
        case $260fe03cb06856c1$var$float32Tag:
        case $260fe03cb06856c1$var$float64Tag:
        case $260fe03cb06856c1$var$int8Tag:
        case $260fe03cb06856c1$var$int16Tag:
        case $260fe03cb06856c1$var$int32Tag:
        case $260fe03cb06856c1$var$uint8Tag:
        case $260fe03cb06856c1$var$uint8ClampedTag:
        case $260fe03cb06856c1$var$uint16Tag:
        case $260fe03cb06856c1$var$uint32Tag:
            return $7Ogd2(object, isDeep);
        case $260fe03cb06856c1$var$mapTag:
            return new Ctor;
        case $260fe03cb06856c1$var$numberTag:
        case $260fe03cb06856c1$var$stringTag:
            return new Ctor(object);
        case $260fe03cb06856c1$var$regexpTag:
            return $aGB2t(object);
        case $260fe03cb06856c1$var$setTag:
            return new Ctor;
        case $260fe03cb06856c1$var$symbolTag:
            return $fV9WT(object);
    }
}
module.exports = $260fe03cb06856c1$var$initCloneByTag;

});
parcelRegister("dPRv7", function(module, exports) {

var $339Qm = parcelRequire("339Qm");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $a12989ed47e0948e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $339Qm(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $a12989ed47e0948e$var$cloneDataView;

});

parcelRegister("aGB2t", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7c7a8ecd4d123ac6$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7c7a8ecd4d123ac6$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7c7a8ecd4d123ac6$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7c7a8ecd4d123ac6$var$cloneRegExp;

});

parcelRegister("fV9WT", function(module, exports) {

var $etweZ = parcelRequire("etweZ");
/** Used to convert symbols to primitives and strings. */ var $b973e582ac125dc5$var$symbolProto = $etweZ ? $etweZ.prototype : undefined, $b973e582ac125dc5$var$symbolValueOf = $b973e582ac125dc5$var$symbolProto ? $b973e582ac125dc5$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $b973e582ac125dc5$var$cloneSymbol(symbol) {
    return $b973e582ac125dc5$var$symbolValueOf ? Object($b973e582ac125dc5$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $b973e582ac125dc5$var$cloneSymbol;

});


parcelRegister("5PtAi", function(module, exports) {

var $gMqjQ = parcelRequire("gMqjQ");

var $eKaiJ = parcelRequire("eKaiJ");

var $affWm = parcelRequire("affWm");
/* Node.js helper references. */ var $43e8a9fedbb36421$var$nodeIsMap = $affWm && $affWm.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $43e8a9fedbb36421$var$isMap = $43e8a9fedbb36421$var$nodeIsMap ? $eKaiJ($43e8a9fedbb36421$var$nodeIsMap) : $gMqjQ;
module.exports = $43e8a9fedbb36421$var$isMap;

});
parcelRegister("gMqjQ", function(module, exports) {

var $eZ3ti = parcelRequire("eZ3ti");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $c3758b728a32480c$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $c3758b728a32480c$var$baseIsMap(value) {
    return $8GSh0(value) && $eZ3ti(value) == $c3758b728a32480c$var$mapTag;
}
module.exports = $c3758b728a32480c$var$baseIsMap;

});


parcelRegister("2B7hk", function(module, exports) {

var $lFpL9 = parcelRequire("lFpL9");

var $eKaiJ = parcelRequire("eKaiJ");

var $affWm = parcelRequire("affWm");
/* Node.js helper references. */ var $1e44aed11d0417a1$var$nodeIsSet = $affWm && $affWm.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $1e44aed11d0417a1$var$isSet = $1e44aed11d0417a1$var$nodeIsSet ? $eKaiJ($1e44aed11d0417a1$var$nodeIsSet) : $lFpL9;
module.exports = $1e44aed11d0417a1$var$isSet;

});
parcelRegister("lFpL9", function(module, exports) {

var $eZ3ti = parcelRequire("eZ3ti");

var $8GSh0 = parcelRequire("8GSh0");
/** `Object#toString` result references. */ var $fc6168a1b21eed58$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $fc6168a1b21eed58$var$baseIsSet(value) {
    return $8GSh0(value) && $eZ3ti(value) == $fc6168a1b21eed58$var$setTag;
}
module.exports = $fc6168a1b21eed58$var$baseIsSet;

});



parcelRegister("bCf2H", function(module, exports) {

var $6oSaQ = parcelRequire("6oSaQ");

var $1VqtZ = parcelRequire("1VqtZ");

var $4Dnns = parcelRequire("4Dnns");

var $bLWBt = parcelRequire("bLWBt");
/** Used for built-in method references. */ var $874ee97043cecba0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $874ee97043cecba0$var$hasOwnProperty = $874ee97043cecba0$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $874ee97043cecba0$var$baseUnset(object, path) {
    path = $6oSaQ(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $bLWBt(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$874ee97043cecba0$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $4Dnns(object, path);
    return obj == null || delete obj[$bLWBt($1VqtZ(path))];
}
module.exports = $874ee97043cecba0$var$baseUnset;

});
parcelRegister("4Dnns", function(module, exports) {

var $9Mhzz = parcelRequire("9Mhzz");

var $6pPhS = parcelRequire("6pPhS");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $35fcf031215faf5b$var$parent(object, path) {
    return path.length < 2 ? object : $9Mhzz(object, $6pPhS(path, 0, -1));
}
module.exports = $35fcf031215faf5b$var$parent;

});
parcelRegister("6pPhS", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $4abcdc7da16be2b5$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $4abcdc7da16be2b5$var$baseSlice;

});



parcelRegister("3OJcL", function(module, exports) {

var $kESXO = parcelRequire("kESXO");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $2c791b5854b3f92b$var$customOmitClone(value) {
    return $kESXO(value) ? undefined : value;
}
module.exports = $2c791b5854b3f92b$var$customOmitClone;

});

parcelRegister("f4mG0", function(module, exports) {

var $dRaYf = parcelRequire("dRaYf");

var $l3XAa = parcelRequire("l3XAa");

var $4vNCV = parcelRequire("4vNCV");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $af88d1d2032f124a$var$flatRest(func) {
    return $4vNCV($l3XAa(func, undefined, $dRaYf), func + '');
}
module.exports = $af88d1d2032f124a$var$flatRest;

});


parcelRegister("h7jt0", function(module, exports) {
$parcel$export(module.exports, "SCREENTABS_VALIDATION_ERROR", () => $09aff2fc4a3bcab1$export$fd26696d109785a0);
$parcel$export(module.exports, "FIELD_VALIDATION_ERROR", () => $09aff2fc4a3bcab1$export$d1996cb46a690190);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT", () => $09aff2fc4a3bcab1$export$2a3fdceaae2188d5);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_FIELD", () => $09aff2fc4a3bcab1$export$e4ac32edd5da2ee7);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS", () => $09aff2fc4a3bcab1$export$877da1000325f8b5);
const $09aff2fc4a3bcab1$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $09aff2fc4a3bcab1$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $09aff2fc4a3bcab1$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $09aff2fc4a3bcab1$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $09aff2fc4a3bcab1$export$e4ac32edd5da2ee7 = 'FIELD';
const $09aff2fc4a3bcab1$export$877da1000325f8b5 = 'SCREENTABS';

});

parcelRegister("eKEBo", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $ea39d3209223b1b1$export$e1cc7da28a1c4bb7);
const $ea39d3209223b1b1$var$SET_NAME_METHOD = 'setName';
const $ea39d3209223b1b1$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $ea39d3209223b1b1$var$SET_VISIBLE_METHOD = 'setVisible';
const $ea39d3209223b1b1$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $ea39d3209223b1b1$var$SET_VALUE_METHOD = 'setValue';
const $ea39d3209223b1b1$var$SET_REQUIRED_METHOD = 'setRequired';
const $ea39d3209223b1b1$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $ea39d3209223b1b1$export$8325709d137b2606 = {
    fieldName: $ea39d3209223b1b1$var$SET_NAME_METHOD,
    description: $ea39d3209223b1b1$var$SET_DESCRIPTION_METHOD,
    isVisible: $ea39d3209223b1b1$var$SET_VISIBLE_METHOD,
    isReadOnly: $ea39d3209223b1b1$var$SET_READ_ONLY_METHOD,
    value: $ea39d3209223b1b1$var$SET_VALUE_METHOD,
    isRequired: $ea39d3209223b1b1$var$SET_REQUIRED_METHOD,
    optionsVisibility: $ea39d3209223b1b1$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $ea39d3209223b1b1$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $ea39d3209223b1b1$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("8pUt8", function(module, exports) {
$parcel$export(module.exports, "SCREEN_TABS_HISTORY_TYPE", () => $5ab2d88f9dd853bc$export$f674b7a3bbd94b5);
$parcel$export(module.exports, "FIELD_HISTORY_TYPE", () => $5ab2d88f9dd853bc$export$4a9f236a0db33834);
const $5ab2d88f9dd853bc$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $5ab2d88f9dd853bc$export$4a9f236a0db33834 = 'FIELD';

});



parcelRegister("6wuVZ", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $c510f897c8d2d49b$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $c510f897c8d2d49b$export$7d0f534e5b16dcc9);

var $8pUt8 = parcelRequire("8pUt8");

var $anFWJ = parcelRequire("anFWJ");
const $c510f897c8d2d49b$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    var _appliedChangesHistor;
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = ((_appliedChangesHistor = appliedChangesHistoryChangeId.apps) === null || _appliedChangesHistor === void 0 ? void 0 : _appliedChangesHistor[appId]) ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $c510f897c8d2d49b$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $c510f897c8d2d49b$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $8pUt8.SCREEN_TABS_HISTORY_TYPE)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $c510f897c8d2d49b$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $anFWJ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $c510f897c8d2d49b$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("anFWJ", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b44c94a5e9b3a430$export$8a23b3e9a1749620);

var $8pUt8 = parcelRequire("8pUt8");
const $b44c94a5e9b3a430$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $8pUt8.FIELD_HISTORY_TYPE)
        };
        return acc;
    }, {});
};
const $b44c94a5e9b3a430$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b44c94a5e9b3a430$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("azpg0", function(module, exports) {
$parcel$export(module.exports, "setError", () => $30f138dd2150d248$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $30f138dd2150d248$export$7e5930c6217b1d4e);
const $30f138dd2150d248$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $30f138dd2150d248$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("869fR", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $8ebabc53af610f6d$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $8ebabc53af610f6d$export$cf768a695e83eefa);

var $hWDOW = parcelRequire("hWDOW");

var $kLX2P = parcelRequire("kLX2P");

var $azpg0 = parcelRequire("azpg0");
const $8ebabc53af610f6d$var$getTimeout = ()=>50000;
const $8ebabc53af610f6d$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $8ebabc53af610f6d$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $8ebabc53af610f6d$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($8ebabc53af610f6d$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $8ebabc53af610f6d$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $8ebabc53af610f6d$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($8ebabc53af610f6d$var$isFieldInitialisationComplete(status) || (0, $kLX2P.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $azpg0.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $8ebabc53af610f6d$var$getTimeout(),
                fieldsInitializationTime: $8ebabc53af610f6d$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $8ebabc53af610f6d$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($8ebabc53af610f6d$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $8ebabc53af610f6d$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("kLX2P", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $de62f21763151663$export$4cadeedb8c3f31f7);

var $g6dQg = parcelRequire("g6dQg");
const $de62f21763151663$export$4cadeedb8c3f31f7 = (0, $g6dQg.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("g5fhN", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $754d270419760988$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $754d270419760988$export$4a6b4707110b0552);

var $hJAkC = parcelRequire("hJAkC");
const $754d270419760988$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
            fieldType: field.fieldType,
            extraData: metadata === null || metadata === void 0 ? void 0 : metadata.extraData
        };
        const publicValue = (0, $hJAkC.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $754d270419760988$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
                fieldType: field.fieldType,
                extraData: metadata === null || metadata === void 0 ? void 0 : metadata.extraData
            };
            const publicValue = (0, $hJAkC.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("hJAkC", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $6db53c373f2b2f0f$export$50806045b617d116);

var $jok5A = parcelRequire("jok5A");

var $5YXrV = parcelRequire("5YXrV");
const $6db53c373f2b2f0f$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        var _getSupportedFieldCon;
        const valueTransformer = (_getSupportedFieldCon = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.internalToPublicTransformers.value;
        if (valueTransformer) /**
       * We trust that the internal field data is in the correct shape.
       * Data that is in the incorrect shape will result in error events
       * being logged for further investigation. In this error case we will
       * pass `null` as the value to unblock onInit for the apps
       *
       * The `fieldRenderer` passed to the `valueTransformer` is used only for
       * rich text fields and will be `undefined` for most of the executions
       */ value = valueTransformer(internalFieldValue, fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $jok5A.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("jok5A", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $2e9928e32e93e6e2$export$a27c21aa3ed8f0f1);

var $8xOOU = parcelRequire("8xOOU");

var $aHRpV = parcelRequire("aHRpV");
const $2e9928e32e93e6e2$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $2e9928e32e93e6e2$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, analyticsViewType: analyticsViewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $aHRpV.getErrorType)(error);
    // Name the event after the canonical viewType (when given) so overlay traffic
    // lands in the same bucket; the real viewType still goes into attributes below.
    const packageName = `${analyticsViewType ?? viewType}jiraUiModifications`;
    (0, $8xOOU.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $2e9928e32e93e6e2$export$1bee4e6be783dd26(error.message) : error.message,
            viewType: // Keep the real viewType in attributes so we know where the error came from.
            viewType,
            ...attributes
        }
    });
};

});
parcelRegister("8xOOU", function(module, exports) {
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $7aa917e2b24af6c9$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $7aa917e2b24af6c9$export$2e2bcd8739ae039);

var $5W771 = parcelRequire("5W771");

var $gK90j = parcelRequire("gK90j");

var $j5wIQ = parcelRequire("j5wIQ");

var $16GaT = parcelRequire("16GaT");

var $lG7vm = parcelRequire("lG7vm");
let $7aa917e2b24af6c9$var$analyticsClient;
const $7aa917e2b24af6c9$export$d4079397f9611138 = (client)=>{
    $7aa917e2b24af6c9$var$analyticsClient = client;
};
const $7aa917e2b24af6c9$export$bf406c01a195b215 = ()=>{
    $7aa917e2b24af6c9$var$analyticsClient = undefined;
};
const $7aa917e2b24af6c9$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $j5wIQ.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($gK90j)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5W771))));
        if (event && event.context) {
            const fullEvent = (0, $j5wIQ.extractAWCDataFromEvent)(event);
            (0, $lG7vm.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $lG7vm.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $16GaT.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($7aa917e2b24af6c9$var$analyticsClient && $7aa917e2b24af6c9$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $7aa917e2b24af6c9$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $lG7vm.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $7aa917e2b24af6c9$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $7aa917e2b24af6c9$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $7aa917e2b24af6c9$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $7aa917e2b24af6c9$export$2e2bcd8739ae039 = $7aa917e2b24af6c9$var$fireErrorAnalytics;

});
parcelRegister("lG7vm", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $3174a52e5dda924c$export$f5282963edea4a68);

var $4t2qx = parcelRequire("4t2qx");
const $3174a52e5dda924c$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $4t2qx.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $3174a52e5dda924c$export$f5282963edea4a68 = (location, error, details = {})=>(0, $4t2qx.default).captureException(location, error, details);

});
parcelRegister("4t2qx", function(module, exports) {
$parcel$export(module.exports, "default", () => $233d0235aa75899b$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $2tNS7 = parcelRequire("2tNS7");
var $REREP = parcelRequire("REREP");
var $6SODg = parcelRequire("6SODg");

var $6bYxd = parcelRequire("6bYxd");
var $9lf56 = parcelRequire("9lf56");
var $f5Ruk = parcelRequire("f5Ruk");
var $1DQAA = parcelRequire("1DQAA");

var $l8G72 = parcelRequire("l8G72");
const $233d0235aa75899b$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $233d0235aa75899b$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $233d0235aa75899b$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $233d0235aa75899b$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $233d0235aa75899b$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $REREP.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $233d0235aa75899b$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$233d0235aa75899b$var$getFilteredIntegrations(integrations),
                new $9lf56.Dedupe(),
                new $f5Ruk.ExtraErrorData(),
                new $1DQAA.Transaction(),
                new $6bYxd.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $6SODg.init({
        ...defaultConfig,
        ...config
    });
    try {
        $2tNS7.setExtras(getExtraContext());
    } catch (e) {
        $2tNS7.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $233d0235aa75899b$var$tags = [
    'packageName',
    'teamName'
];
const $233d0235aa75899b$var$captureException = (location, error, details)=>{
    $2tNS7.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($233d0235aa75899b$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $2tNS7.captureException(error);
};
const $233d0235aa75899b$var$sentryErrorHandler = {
    installGlobalHandler: $233d0235aa75899b$var$installGlobalHandler,
    captureException: $233d0235aa75899b$var$captureException
};
var $233d0235aa75899b$export$2e2bcd8739ae039 = $233d0235aa75899b$var$sentryErrorHandler;

});
parcelRegister("6bYxd", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $4822ba17369eb0c6$export$25a43cb5b5c58c08);
parcelRequire("dMeSH");
var $KqrRx = parcelRequire("KqrRx");
var $fKSzi = parcelRequire("fKSzi");
var $j0N8V = parcelRequire("j0N8V");
var $1tu1w = parcelRequire("1tu1w");
var $QUwn3 = parcelRequire("QUwn3");
var $4822ba17369eb0c6$var$global = (0, $j0N8V.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $4822ba17369eb0c6$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $KqrRx.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $4822ba17369eb0c6$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $4822ba17369eb0c6$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $fKSzi.fill)($4822ba17369eb0c6$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $QUwn3.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $1tu1w.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $1tu1w.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($4822ba17369eb0c6$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("9lf56", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $6cd1c61186cac1f2$export$688d98c249d31ad3);
parcelRequire("dMeSH");
var $KqrRx = parcelRequire("KqrRx");

var $fBP6R = parcelRequire("fBP6R");
/** Deduplication filter */ var $6cd1c61186cac1f2$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($6cd1c61186cac1f2$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $fBP6R.IS_DEBUG_BUILD) && (0, $KqrRx.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $6cd1c61186cac1f2$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6cd1c61186cac1f2$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6cd1c61186cac1f2$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $6cd1c61186cac1f2$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6cd1c61186cac1f2$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6cd1c61186cac1f2$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $6cd1c61186cac1f2$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $6cd1c61186cac1f2$var$_getExceptionFromEvent(previousEvent);
    var currentException = $6cd1c61186cac1f2$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6cd1c61186cac1f2$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6cd1c61186cac1f2$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $6cd1c61186cac1f2$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $6cd1c61186cac1f2$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $6cd1c61186cac1f2$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $6cd1c61186cac1f2$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $6cd1c61186cac1f2$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $6cd1c61186cac1f2$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("fBP6R", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $b5d1f508c0d7ac5e$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $b5d1f508c0d7ac5e$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("f5Ruk", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $afd0d0424283cef2$export$56d961ef3a52a072);

var $5lpFe = parcelRequire("5lpFe");
parcelRequire("dMeSH");
var $fZ517 = parcelRequire("fZ517");
var $KqrRx = parcelRequire("KqrRx");
var $3NuAA = parcelRequire("3NuAA");

var $fBP6R = parcelRequire("fBP6R");
/** Patch toString calls to return proper name for wrapped functions */ var $afd0d0424283cef2$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $5lpFe.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $fZ517.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $5lpFe.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $3NuAA.normalize)(errorData, this._options.depth);
            if ((0, $fZ517.isPlainObject)(normalizedErrorData)) contexts = (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $5lpFe.__assign)({}, normalizedErrorData), _a));
            return (0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $5lpFe.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $fZ517.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $5lpFe.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $fZ517.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $fBP6R.IS_DEBUG_BUILD) && (0, $KqrRx.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("1DQAA", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $13223a0ed145ef41$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $13223a0ed145ef41$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});




parcelRegister("aHRpV", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $c644ea4b948aa9a1$export$e19f9f08a6d79fd2);

var $e9vEX = parcelRequire("e9vEX");
const $c644ea4b948aa9a1$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c644ea4b948aa9a1$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c644ea4b948aa9a1$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c644ea4b948aa9a1$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c644ea4b948aa9a1$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c644ea4b948aa9a1$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c644ea4b948aa9a1$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c644ea4b948aa9a1$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c644ea4b948aa9a1$var$BAD_REQUEST = 400;
const $c644ea4b948aa9a1$var$REQUEST_TIMEOUT = 408;
const $c644ea4b948aa9a1$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c644ea4b948aa9a1$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>{
        var _error$stack;
        return Boolean(typeof error === 'object' && error.name === 'TimeoutError' && ((_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.includes(timedOutResource)));
    };
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c644ea4b948aa9a1$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = (match === null || match === void 0 ? void 0 : match[1]) ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c644ea4b948aa9a1$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c644ea4b948aa9a1$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c644ea4b948aa9a1$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c644ea4b948aa9a1$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c644ea4b948aa9a1$var$BAD_REQUEST;
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c644ea4b948aa9a1$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c644ea4b948aa9a1$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c644ea4b948aa9a1$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c644ea4b948aa9a1$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $e9vEX.isClientFetchError)(error)) return $c644ea4b948aa9a1$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("e9vEX", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $cd7e9fdf7c8c7177$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd7e9fdf7c8c7177$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd7e9fdf7c8c7177$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd7e9fdf7c8c7177$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd7e9fdf7c8c7177$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd7e9fdf7c8c7177$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd7e9fdf7c8c7177$export$3876cb851aa46193.includes(error.name) || $cd7e9fdf7c8c7177$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd7e9fdf7c8c7177$export$3876cb851aa46193.includes(error.cause.name) || $cd7e9fdf7c8c7177$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("5YXrV", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $11a152b81b1e7fbd$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $11a152b81b1e7fbd$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $11a152b81b1e7fbd$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $11a152b81b1e7fbd$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $11a152b81b1e7fbd$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $11a152b81b1e7fbd$export$ef45e4471aa21b27);

var $jok5A = parcelRequire("jok5A");

var $2O5nf = parcelRequire("2O5nf");
const $11a152b81b1e7fbd$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $11a152b81b1e7fbd$var$noop = ()=>{};
/**
 * Returned by `getAnalytics` when the requested view type has no registered
 * configuration yet and the guard gate is on, so callers (e.g. `useSubmit`)
 * keep working instead of throwing while configs register lazily.
 */ const $11a152b81b1e7fbd$var$UNSUPPORTED_VIEW_TYPE_FALLBACK_ANALYTICS = {
    stopTTI: $11a152b81b1e7fbd$var$noop,
    cancelTTI: $11a152b81b1e7fbd$var$noop,
    markIframeLoad: $11a152b81b1e7fbd$var$noop,
    markFieldsRegistered: $11a152b81b1e7fbd$var$noop,
    markOnInitResolved: $11a152b81b1e7fbd$var$noop
};
const $11a152b81b1e7fbd$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $2O5nf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $11a152b81b1e7fbd$export$e48d55f9cf9962ce(viewType) {
    return (0, $2O5nf.getViewConfiguration)(viewType) !== undefined;
}
function $11a152b81b1e7fbd$export$8fc8d6775f1842b8(viewType, fieldType) {
    // View configurations register lazily; until the requested view type is
    // registered, treat the field as unsupported instead of throwing.
    if (!$11a152b81b1e7fbd$export$e48d55f9cf9962ce(viewType)) return undefined;
    const fieldsConfiguration = $11a152b81b1e7fbd$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$11a152b81b1e7fbd$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $jok5A.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $11a152b81b1e7fbd$export$e4330d77fd93d1de = (viewType)=>{
    if (!$11a152b81b1e7fbd$export$e48d55f9cf9962ce(viewType)) return [];
    return $11a152b81b1e7fbd$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
};
function $11a152b81b1e7fbd$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $11a152b81b1e7fbd$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $11a152b81b1e7fbd$export$20eabd2b3ada6bf3(viewType) {
    return $11a152b81b1e7fbd$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $11a152b81b1e7fbd$export$b768d6a95f7a930(context) {
    if (!$11a152b81b1e7fbd$export$e48d55f9cf9962ce(context.viewType)) return false;
    return $11a152b81b1e7fbd$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $11a152b81b1e7fbd$export$b0297573c90085aa(viewType) {
    if (!$11a152b81b1e7fbd$export$e48d55f9cf9962ce(viewType)) return $11a152b81b1e7fbd$var$UNSUPPORTED_VIEW_TYPE_FALLBACK_ANALYTICS;
    return $11a152b81b1e7fbd$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $11a152b81b1e7fbd$export$c0728caa743a409e(viewType) {
    if (!$11a152b81b1e7fbd$export$e48d55f9cf9962ce(viewType)) return new Set();
    return $11a152b81b1e7fbd$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $11a152b81b1e7fbd$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $11a152b81b1e7fbd$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("2O5nf", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $267807fe18c5b7d3$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $267807fe18c5b7d3$export$f0022a21ccd1f6be);

var $fc4bM = parcelRequire("fc4bM");
const $267807fe18c5b7d3$var$VIEW_CONFIGURATIONS = new Map();
const $267807fe18c5b7d3$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$267807fe18c5b7d3$var$VIEW_CONFIGURATIONS.has(viewType)) $267807fe18c5b7d3$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $267807fe18c5b7d3$export$176b6e68da08ffa2 = (viewType)=>$267807fe18c5b7d3$var$VIEW_CONFIGURATIONS.get(viewType);
const $267807fe18c5b7d3$export$e8091eff40c4f16e = ()=>{
    $267807fe18c5b7d3$var$VIEW_CONFIGURATIONS.clear();
};
const $267807fe18c5b7d3$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    /**
   * Uses useMemo to load view configuration during the first render, before mount.
   */ (0, $fc4bM.useMemo)(()=>{
        $267807fe18c5b7d3$export$cda1ad403b37fe70(viewType, new configurationClass());
    }, [
        viewType,
        configurationClass
    ]);
};

});




parcelRegister("8dWYV", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $6b8626a6d05049ed$export$93459ad9bfd6c380);
const $6b8626a6d05049ed$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8jqFd", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $8deeb2c9ca20524f$export$7f7be235f64f029b);
const $8deeb2c9ca20524f$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs === null || internalScreenTabs === void 0 ? void 0 : internalScreenTabs.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("7tF5h", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $aa86c299ab921866$export$352dfcce04d66748);

var $5sffh = parcelRequire("5sffh");

var $5YXrV = parcelRequire("5YXrV");

var $3haAi = parcelRequire("3haAi");
const $aa86c299ab921866$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        var _internalFormMetadata, _getSupportedFieldCon;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = (_internalFormMetadata = internalFormMetadata[fieldId]) === null || _internalFormMetadata === void 0 ? void 0 : _internalFormMetadata.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (_getSupportedFieldCon = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $3haAi.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
   * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
   * Otherwise, UIM app may not be notified about every single change.
   */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($5sffh)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("5sffh", function(module, exports) {

var $2YOY3 = parcelRequire("2YOY3");
/** Used to generate unique IDs. */ var $3f8b64ba4b17a113$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $3f8b64ba4b17a113$var$uniqueId(prefix) {
    var id = ++$3f8b64ba4b17a113$var$idCounter;
    return $2YOY3(prefix) + id;
}
module.exports = $3f8b64ba4b17a113$var$uniqueId;

});

parcelRegister("3haAi", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $239facd12f307657$export$25441a03bb8f1cb0);

var $3ZJj6 = parcelRequire("3ZJj6");

var $hJAkC = parcelRequire("hJAkC");
const $239facd12f307657$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    var _formData$fieldId;
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $hJAkC.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = (_formData$fieldId = formData[fieldId]) === null || _formData$fieldId === void 0 ? void 0 : _formData$fieldId.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("5btgo", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $5e4ca6acb4a288e8$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e4ca6acb4a288e8$export$1ca69a85bb7273de);

var $6IHjK = parcelRequire("6IHjK");

var $l8G72 = parcelRequire("l8G72");
const $5e4ca6acb4a288e8$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e4ca6acb4a288e8$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($6IHjK)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("3scmc", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $b2d4a56a34270a5f$export$6556d46d2662453c);

var $3haAi = parcelRequire("3haAi");
const $b2d4a56a34270a5f$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
   * We can set new field value only if the field was initialized.
   * This checks the field metedata that indicates the successfull initialization.
   */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $3haAi.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("ivhfC", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $ffd0f1e4a9b29b01$export$21363496760d39cd);
const $ffd0f1e4a9b29b01$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("eJXpL", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $588bd7b2d273b704$export$cceae62fd4d1ef0a);

var $5W771 = parcelRequire("5W771");

var $hWDOW = parcelRequire("hWDOW");

var $87Mi2 = parcelRequire("87Mi2");

var $gl0Ji = parcelRequire("gl0Ji");

var $hu03C = parcelRequire("hu03C");

var $hfWqn = parcelRequire("hfWqn");

var $clJp1 = parcelRequire("clJp1");

var $gJRFa = parcelRequire("gJRFa");

var $4D9QI = parcelRequire("4D9QI");

var $2D6FW = parcelRequire("2D6FW");

var $6wuVZ = parcelRequire("6wuVZ");

var $lcJ2L = parcelRequire("lcJ2L");
const $588bd7b2d273b704$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $hfWqn.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $2D6FW.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY)]: internalMetadata.allowedValues,
                [(0, $87Mi2.LOOKUP_SOURCE_USERS_ASYNC_DATA)]: lookupDataFromApi[0, $87Mi2.LOOKUP_SOURCE_USERS_ASYNC_DATA],
                [(0, $87Mi2.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA)]: lookupDataFromApi[0, $87Mi2.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA],
                [(0, $87Mi2.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA)]: lookupDataFromApi[0, $87Mi2.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA],
                [(0, $87Mi2.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA)]: lookupDataFromApi[0, $87Mi2.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $lcJ2L.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl,
                fieldExtraData: internalMetadata.extraData
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $4D9QI.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $clJp1.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $gl0Ji.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($5W771)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5W771)))(errorsByField)) throw new (0, $hu03C.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $gJRFa.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $6wuVZ.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
parcelRegister("87Mi2", function(module, exports) {
$parcel$export(module.exports, "LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY", () => $02499907dc5a83e1$export$a1cacdcf198da901);
$parcel$export(module.exports, "LOOKUP_SOURCE_USERS_ASYNC_DATA", () => $02499907dc5a83e1$export$3a106242c8f57ac2);
$parcel$export(module.exports, "LOOKUP_SOURCE_PROJECTS_ASYNC_DATA", () => $02499907dc5a83e1$export$e10d4d251d909c59);
$parcel$export(module.exports, "LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA", () => $02499907dc5a83e1$export$45fd2b84447c8617);
$parcel$export(module.exports, "LOOKUP_SOURCE_VERSIONS_ASYNC_DATA", () => $02499907dc5a83e1$export$b23dae8d7ea7032f);
$parcel$export(module.exports, "AUTOMATIC_ID", () => $02499907dc5a83e1$export$f5d5f6bb902f1027);
const $02499907dc5a83e1$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $02499907dc5a83e1$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $02499907dc5a83e1$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $02499907dc5a83e1$export$45fd2b84447c8617 = 'LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA';
const $02499907dc5a83e1$export$b23dae8d7ea7032f = 'LOOKUP_SOURCE_VERSIONS_ASYNC_DATA';
const $02499907dc5a83e1$export$f5d5f6bb902f1027 = '-1';
const $02499907dc5a83e1$export$106087dcfd4fb129 = 100;

});

parcelRegister("gl0Ji", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $e0ed411749a7b14e$export$4027d961191df7c3);
function $e0ed411749a7b14e$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (fieldsChanges && (lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.changeId) === changeId) {
        const fid = lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("hu03C", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $43f379ad350e3281$export$9e8b5e552e255163);

var $bTH3p = parcelRequire("bTH3p");
class $43f379ad350e3281$export$9e8b5e552e255163 extends (0, $bTH3p.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("bTH3p", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $2694e9a9091141d1$export$6e8165c81a6a65df);
class $2694e9a9091141d1$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("hfWqn", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $00ed6e81366e2256$export$fbe9157c12cb4e7b);
const $00ed6e81366e2256$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>{
    var _registeredFields$app;
    return !!((_registeredFields$app = registeredFields[appId]) !== null && _registeredFields$app !== void 0 && (_registeredFields$app = _registeredFields$app[changeId]) !== null && _registeredFields$app !== void 0 && _registeredFields$app.includes(fieldId));
};

});

parcelRegister("clJp1", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $40910c36c2ecf868$export$460820f27643954e);

var $5YXrV = parcelRequire("5YXrV");
const $40910c36c2ecf868$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("gJRFa", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $a701c44a3510050b$export$e1fce51bc5be90b7);
const $a701c44a3510050b$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("4D9QI", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $a99620c9ea89de6e$export$aa453854f74fab);

var $jok5A = parcelRequire("jok5A");

var $5YXrV = parcelRequire("5YXrV");
const $a99620c9ea89de6e$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jok5A.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.optionsVisibility) try {
        const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jok5A.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("lcJ2L", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $bbc310da48e303fe$export$d14f85c01e334a1);

var $5W771 = parcelRequire("5W771");

var $dRkX9 = parcelRequire("dRkX9");

var $c8dk3 = parcelRequire("c8dk3");

var $5YXrV = parcelRequire("5YXrV");

var $h7jt0 = parcelRequire("h7jt0");

var $eKEBo = parcelRequire("eKEBo");

var $kKEek = parcelRequire("kKEek");

var $h3Isa = parcelRequire("h3Isa");
const $bbc310da48e303fe$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl, fieldExtraData: fieldExtraData })=>{
    const fieldConfiguration = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $kKEek.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldContext = fieldExtraData && (0, $dRkX9.fg)('ditto_uim_jsm_user_picker_email') ? {
        fieldId: fieldId,
        extraData: fieldExtraData
    } : {
        fieldId: fieldId
    };
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $kKEek.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $c8dk3.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $h7jt0.FIELD_VALIDATION_ERROR),
                        method: (0, $eKEBo.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $h3Isa.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($5W771)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $h3Isa.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("c8dk3", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $8046ab4d112459cb$export$73c2f0689b6c4a5a);
class $8046ab4d112459cb$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("kKEek", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $1794e5256b37e137$export$ee79e3ab53b8db79);
const $1794e5256b37e137$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("h3Isa", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $fd26ef3f278faa03$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $fd26ef3f278faa03$export$ddd005554aecd409);
const $fd26ef3f278faa03$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $fd26ef3f278faa03$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("hQyMs", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $6b1ce18a0c7bcc79$export$131c67fd312b8a11);

var $eAAzO = parcelRequire("eAAzO");

var $dYB6G = parcelRequire("dYB6G");

var $6wuVZ = parcelRequire("6wuVZ");

var $b9mM8 = parcelRequire("b9mM8");
const $6b1ce18a0c7bcc79$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $b9mM8.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $b9mM8.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $6wuVZ.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $eAAzO.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $b9mM8.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $dYB6G.toScreenTabsValidationError))
        });
    };

});
parcelRegister("eAAzO", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $63f040b1238a9e01$export$faf1f1824ee0a136);

var $bTH3p = parcelRequire("bTH3p");
class $63f040b1238a9e01$export$faf1f1824ee0a136 extends (0, $bTH3p.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("dYB6G", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $871b8353216735ab$export$b2675440ade984fb);

var $h7jt0 = parcelRequire("h7jt0");
const $871b8353216735ab$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $h7jt0.SCREENTABS_VALIDATION_ERROR)
    });

});

parcelRegister("b9mM8", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $1f03ef6b66975295$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $1f03ef6b66975295$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $1f03ef6b66975295$export$62d63af83dac7315);
const $1f03ef6b66975295$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $1f03ef6b66975295$var$isValidScreenTabId = (internalScreenTabs, id)=>$1f03ef6b66975295$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $1f03ef6b66975295$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $1f03ef6b66975295$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $1f03ef6b66975295$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$1f03ef6b66975295$var$isValidScreenTabId(internalScreenTabs, id) && $1f03ef6b66975295$var$isValidScreenTabIsVisible(isVisible) && $1f03ef6b66975295$var$isValidScreenTabIsActive(isActive);
const $1f03ef6b66975295$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($1f03ef6b66975295$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $1f03ef6b66975295$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($1f03ef6b66975295$var$isValidScreenTabIsActive(isActive) && isActive && $1f03ef6b66975295$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $1f03ef6b66975295$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    var _screenTabsInternalUp;
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof ((_screenTabsInternalUp = screenTabsInternalUpdated[0]) === null || _screenTabsInternalUp === void 0 ? void 0 : _screenTabsInternalUp.isActive) !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $1f03ef6b66975295$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$1f03ef6b66975295$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($1f03ef6b66975295$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($1f03ef6b66975295$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $1f03ef6b66975295$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    screenTabsFromApp.forEach((tab)=>{
        if (!$1f03ef6b66975295$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$1f03ef6b66975295$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$1f03ef6b66975295$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$1f03ef6b66975295$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($1f03ef6b66975295$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($1f03ef6b66975295$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("bfYTF", function(module, exports) {
$parcel$export(module.exports, "REQUEST_CREATE_VIEW_TYPE", () => $870b5f9162d5c294$export$f5706508058e3b54);
const $870b5f9162d5c294$export$f5706508058e3b54 = 'JSMRequestCreate';

});

parcelRegister("gO5n7", function(module, exports) {
$parcel$export(module.exports, "RequestCreateViewConfiguration", () => $d1fa73ae921bf62a$export$4193c77f3bdf79ba);

var $hN5YJ = parcelRequire("hN5YJ");

var $8wPDv = parcelRequire("8wPDv");

var $jiju3 = parcelRequire("jiju3");

var $k2M4v = parcelRequire("k2M4v");

var $87Mi2 = parcelRequire("87Mi2");

var $aOra6 = parcelRequire("aOra6");

var $gof4Q = parcelRequire("gof4Q");

var $aIzZ9 = parcelRequire("aIzZ9");

var $79bzZ = parcelRequire("79bzZ");

var $l6hzB = parcelRequire("l6hzB");

var $dnN1g = parcelRequire("dnN1g");

var $juzow = parcelRequire("juzow");

var $eRN71 = parcelRequire("eRN71");

var $41MjD = parcelRequire("41MjD");

var $ab3Gy = parcelRequire("ab3Gy");

var $2HMpF = parcelRequire("2HMpF");

var $8h9pD = parcelRequire("8h9pD");

var $4NwRr = parcelRequire("4NwRr");

var $865Q5 = parcelRequire("865Q5");

var $ctBfk = parcelRequire("ctBfk");

var $6XW18 = parcelRequire("6XW18");

var $d5UkQ = parcelRequire("d5UkQ");

var $iphBT = parcelRequire("iphBT");

var $7WEla = parcelRequire("7WEla");

var $jG9r8 = parcelRequire("jG9r8");
const $d1fa73ae921bf62a$export$b3302682bd74b905 = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_embedded_request_page');
const $d1fa73ae921bf62a$export$97cf619b5c503901 = ()=>(0, $k2M4v.default).checkGate('uim_jsm_textfield_support');
const $d1fa73ae921bf62a$export$3d9060e51ab7079e = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_multi_select_support');
const $d1fa73ae921bf62a$export$5377338157c93a4a = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_number_field_support');
const $d1fa73ae921bf62a$export$ca4e8050793caa6 = ()=>(0, $k2M4v.default).checkGate('uim_jsm_duedate_support');
const $d1fa73ae921bf62a$export$a3127feadc5f63ef = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_datetime_field_support');
const $d1fa73ae921bf62a$export$120971fff910541d = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_description_support');
const $d1fa73ae921bf62a$export$b738c6acf33d051a = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_cascading_select_support');
const $d1fa73ae921bf62a$export$1df7079ae40c80e4 = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_datepicker_field_support');
const $d1fa73ae921bf62a$export$d16c700a701ab994 = ()=>(0, $k2M4v.default).checkGate('ditto_uim_jsm_user_picker_support');
class $d1fa73ae921bf62a$export$4193c77f3bdf79ba {
    getAnalytics() {
        return this.analytics;
    }
    /**
   * On other views in Jira, we check if we support a specific project type available from execution context
   * Here, in JSM, there is nothing specific available from Execution Context that we should check
   */ isExecutionContextSupported() {
        return true;
    }
    getConsentMessage() {
        return (0, $7WEla.default).obligatoryUimRequestCreateConsentMessage;
    }
    getSupportedTriggerPointsConfiguration() {
        if ($d1fa73ae921bf62a$export$b3302682bd74b905()) return new Set([
            (0, $dnN1g.DEFAULT),
            (0, $dnN1g.EMBEDDED_REQUEST_CREATE)
        ]);
        return new Set([
            (0, $dnN1g.DEFAULT)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $l6hzB.stopTTI,
            cancelTTI: $l6hzB.cancelTTI,
            markIframeLoad: $l6hzB.markIframeLoad,
            markFieldsRegistered: $l6hzB.markFieldsRegistered,
            markOnInitResolved: $l6hzB.markOnInitResolved
        };
        /**
   * memoizeOne is used to avoid recreating the config objects.
   */ this.getSupportedFieldsConfiguration = (0, $jiju3.default)(()=>{
            const commonFieldValidators = (0, $aOra6.getCommonFieldValidators)();
            const userPickerSupportEnabled = $d1fa73ae921bf62a$export$d16c700a701ab994();
            // Only check the email gate when user picker support is on, so its exposure is scoped to user pickers
            const userPickerEmailSupportEnabled = userPickerSupportEnabled && (0, $hN5YJ.isUserPickerEmailSupportEnabled)();
            return {
                [(0, $dnN1g.SUMMARY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $aIzZ9.validateSingleLineTextValue)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, $ctBfk.singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur',
                    modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                },
                [(0, $dnN1g.SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $gof4Q.selectSetValueValidator),
                        optionsVisibility: (0, $79bzZ.validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, $865Q5.selectSetValueTransformer),
                        optionsVisibility: (0, $865Q5.transformSelectSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $865Q5.selectGetValueTransformer),
                        optionsVisibility: (0, $865Q5.transformSelectGetOptionsVisibility)
                    },
                    lookupSource: (0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    emitChangeOn: 'change',
                    modifyValueToBasic: (0, $865Q5.modifySelectValueToBasic)
                },
                ...$d1fa73ae921bf62a$export$97cf619b5c503901() && {
                    [(0, $dnN1g.TEXT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $aIzZ9.validateSingleLineTextValue)
                        },
                        publicToInternalTransformers: {},
                        internalToPublicTransformers: {
                            value: (0, $ctBfk.singleLineTextFieldGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    }
                },
                ...$d1fa73ae921bf62a$export$5377338157c93a4a() && {
                    [(0, $dnN1g.NUMBER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $8h9pD.validateNumberValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $8h9pD.transformNumberToInternalValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $8h9pD.transformNumberToPublicValue)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    }
                },
                ...$d1fa73ae921bf62a$export$3d9060e51ab7079e() && {
                    [(0, $dnN1g.MULTI_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $2HMpF.validateMultiCheckboxSetValue),
                            optionsVisibility: (0, $79bzZ.validateSetOptionsVisibilityRule)
                        },
                        publicToInternalTransformers: {
                            value: (0, $2HMpF.multiCheckboxSetValueTransformer),
                            optionsVisibility: (0, $2HMpF.multiCheckboxSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $2HMpF.multiCheckboxGetValueTransformer),
                            optionsVisibility: (0, $2HMpF.multiCheckboxGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        propertyMapping: {
                            optionsVisibility: 'options'
                        },
                        modifyValueToBasic: (0, $2HMpF.modifyMultiSelectValueToBasic)
                    }
                },
                ...(0, $hN5YJ.isRadioButtonsSupportEnabled)() && {
                    [(0, $dnN1g.RADIO_BUTTONS_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $gof4Q.selectSetValueValidator),
                            optionsVisibility: (0, $jG9r8.validateSetOptionsVisibility)
                        },
                        publicToInternalTransformers: {
                            value: (0, $6XW18.radioButtonsSetValueTransformer),
                            optionsVisibility: (0, $6XW18.radioButtonsSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $6XW18.radioButtonsGetValueTransformer),
                            optionsVisibility: (0, $6XW18.radioButtonsGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'items',
                            value: 'value'
                        },
                        propertyMapping: {
                            optionsVisibility: 'items'
                        },
                        transformInitialValue: (value, field)=>(0, $6XW18.radioButtonsValueToSelectedOptionTransformer)(value, field.items),
                        transformUrlParamValue: (value, field)=>(0, $6XW18.radioButtonsValueToSelectedOptionTransformer)(value, field.items),
                        modifyValueToBasic: (0, $6XW18.modifyRadioButtonsValueToBasic)
                    }
                },
                ...(0, $hN5YJ.isMultiCheckboxSupportEnabled)() && {
                    [(0, $dnN1g.MULTI_CHECKBOX_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $2HMpF.validateMultiCheckboxSetValue),
                            optionsVisibility: (0, $jG9r8.validateSetOptionsVisibility)
                        },
                        publicToInternalTransformers: {
                            value: (0, $2HMpF.multiCheckboxSetValueTransformer),
                            optionsVisibility: (0, $2HMpF.multiCheckboxSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $2HMpF.multiCheckboxGetValueTransformer),
                            optionsVisibility: (0, $2HMpF.multiCheckboxGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'items',
                            value: 'value'
                        },
                        propertyMapping: {
                            optionsVisibility: 'items'
                        },
                        modifyValueToBasic: (0, $2HMpF.modifyMultiSelectValueToBasic),
                        transformInitialValue: (value, field)=>(0, $2HMpF.multiCheckboxValueToSelectedOptionsTransformer)(value, field.items),
                        transformUrlParamValue: (urlParamValue, field)=>(0, $2HMpF.multiCheckboxValueToSelectedOptionsTransformer)(urlParamValue, field.items)
                    }
                },
                [(0, $dnN1g.PRIORITY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $4NwRr.validatePrioritySetValue),
                        optionsVisibility: (0, $jG9r8.validateSetOptionsVisibility)
                    },
                    publicToInternalTransformers: {
                        value: (0, $4NwRr.prioritySetValueTransformer),
                        optionsVisibility: (0, $4NwRr.prioritySetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $4NwRr.priorityGetValueTransformer),
                        optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    modifyValueToBasic: (0, $4NwRr.modifyPriorityValueToBasic)
                },
                ...$d1fa73ae921bf62a$export$ca4e8050793caa6() && {
                    [(0, $dnN1g.DUE_DATE_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $eRN71.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $eRN71.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $eRN71.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    }
                },
                ...$d1fa73ae921bf62a$export$a3127feadc5f63ef() && {
                    [(0, $dnN1g.DATETIME_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $41MjD.validateDateTimePickerSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $41MjD.transformDateTimePickerSetValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $41MjD.transformDateTimePickerGetValue)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    }
                },
                [(0, $dnN1g.TEXT_AREA_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $d5UkQ.validateTextAreaValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, $d5UkQ.textAreaSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, $d5UkQ.textAreaGetValueTransformer)
                    },
                    emitChangeOn: 'blur',
                    modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                },
                ...$d1fa73ae921bf62a$export$120971fff910541d() && {
                    [(0, $dnN1g.DESCRIPTION_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $d5UkQ.validateTextAreaValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $d5UkQ.textAreaSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $d5UkQ.textAreaGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    }
                },
                ...$d1fa73ae921bf62a$export$b738c6acf33d051a() && {
                    [(0, $dnN1g.CASCADING_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $juzow.validateCascadingSelectSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $juzow.transformSetValueCascadingSelect)
                        },
                        internalToPublicTransformers: {
                            value: (0, $juzow.transformGetValueCascadingSelect)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $87Mi2.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        modifyValueToBasic: (0, $juzow.transformValueToBasicCascadingSelect),
                        transformUrlParamValue: (urlParamValue, field)=>(0, $juzow.transformCascadingSelectUrlParamValue)(urlParamValue, field.options)
                    }
                },
                ...$d1fa73ae921bf62a$export$1df7079ae40c80e4() && {
                    [(0, $dnN1g.DATEPICKER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $eRN71.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $eRN71.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $eRN71.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($8wPDv)))
                    }
                },
                [(0, $dnN1g.LABELS_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $ab3Gy.labelsSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, $ab3Gy.labelsSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, $ab3Gy.labelsGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    initializeFieldPropertyMapping: {
                        value: 'defaultLabels'
                    },
                    modifyValueToBasic: (0, $ab3Gy.modifyLabelsValueToBasic)
                },
                ...userPickerSupportEnabled && {
                    [(0, $dnN1g.USER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $iphBT.validateUserPickerSetValue)
                        },
                        publicToInternalTransformers: {
                            // With the gate on, the transformer uses the Portal's own user search, so the
                            // core's user lookup isn't needed
                            value: userPickerEmailSupportEnabled ? (0, $iphBT.userPickerPortalSetValueTransformer) : (0, $iphBT.userPickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $iphBT.userPickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        ...!userPickerEmailSupportEnabled && {
                            lookupSource: (0, $87Mi2.LOOKUP_SOURCE_USERS_ASYNC_DATA)
                        },
                        initializeFieldPropertyMapping: {
                            value: 'defaultUser'
                        },
                        modifyValueToBasic: (0, $iphBT.modifyUserPickerValueToBasic)
                    }
                }
            };
        });
        this.getSupportedFieldTypes = (0, $jiju3.default)(()=>{
            return Object.keys(this.getSupportedFieldsConfiguration());
        });
        // Note: should be removed by bumping @atlassian/ui-modifications-core to the next minor version. Behavior will default to being true.
        this.isScreenTabsSupportEnabled = ()=>true;
    }
}

});
parcelRegister("aOra6", function(module, exports) {
$parcel$export(module.exports, "getCommonFieldValidators", () => $c579dc76bbd8415c$export$68248012b0fecf7d);
const $c579dc76bbd8415c$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $c579dc76bbd8415c$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $c579dc76bbd8415c$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    return true;
};

});

parcelRegister("gof4Q", function(module, exports) {
$parcel$export(module.exports, "selectSetValueValidator", () => $bb4a66f8c91873c0$export$c02b1c2a574ca4c7);

var $eD9Eb = parcelRequire("eD9Eb");

var $jXSiw = parcelRequire("jXSiw");
const $bb4a66f8c91873c0$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $jXSiw.isNotEmptyString)(value);
const $bb4a66f8c91873c0$export$f22935386c756879 = (value)=>value === null || (0, $jXSiw.isNotEmptyString)(value) && (0, $eD9Eb.isAriResourceIdValid)(value);

});
parcelRegister("eD9Eb", function(module, exports) {
$parcel$export(module.exports, "isAriResourceIdValid", () => $d56084435184bbe0$export$4d1e9901084f3bf6);

var $21LVc = parcelRequire("21LVc");
const $d56084435184bbe0$var$CLOUD_ID_MOCK = 'cloud-id';
const $d56084435184bbe0$var$ACTIVATION_ID_MOCK = 'activation-id';
const $d56084435184bbe0$var$FIELD_ID_MOCK = 'field-1';
const $d56084435184bbe0$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $21LVc.JiraIssueFieldOptionAri).create({
            siteId: $d56084435184bbe0$var$CLOUD_ID_MOCK,
            activationId: $d56084435184bbe0$var$ACTIVATION_ID_MOCK,
            fieldId: $d56084435184bbe0$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("21LVc", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $17a0d8fa58b6b534$export$e3bc1ec22f941fbe);

var $6hXjj = parcelRequire("6hXjj");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/jira/issue-field-option/manifest.ts
var $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $6hXjj.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $6hXjj.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $17a0d8fa58b6b534$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $17a0d8fa58b6b534$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("6hXjj", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $4942566e5f35b3b4$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $4942566e5f35b3b4$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $4942566e5f35b3b4$export$eb4f4cf0880fe5a8 = "jira", $4942566e5f35b3b4$export$4bec333360908e78 = "issue-field-option";

});



parcelRegister("jXSiw", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyString", () => $59b95dbf6657c2da$export$582443c7ead02173);
const $59b95dbf6657c2da$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});


parcelRegister("aIzZ9", function(module, exports) {
$parcel$export(module.exports, "validateSingleLineTextValue", () => $9e0bd6b3cbe2aebd$export$88db43fe998a9953);
const $9e0bd6b3cbe2aebd$export$88db43fe998a9953 = (value)=>typeof value === 'string';

});

parcelRegister("79bzZ", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $7a040d91436cba3e$export$cb8a43658ea03ec7);

var $e3M82 = parcelRequire("e3M82");

var $jXSiw = parcelRequire("jXSiw");
const $7a040d91436cba3e$export$cb8a43658ea03ec7 = (optionsVisibility)=>(0, (/*@__PURE__*/$parcel$interopDefault($e3M82)))(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $jXSiw.isNotEmptyString));

});

parcelRegister("l6hzB", function(module, exports) {
$parcel$export(module.exports, "startScreenTTIWithUIModifications", () => $bd5f929877a0123c$export$750bc2c2ef1a94b6);
$parcel$export(module.exports, "stopTTI", () => $bd5f929877a0123c$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $bd5f929877a0123c$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $bd5f929877a0123c$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $bd5f929877a0123c$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $bd5f929877a0123c$export$d86f4868694f2aa7);

var $yIOXv = parcelRequire("yIOXv");
const $bd5f929877a0123c$export$376630eeb367a07a = (0, $yIOXv.metrics).interaction({
    key: 'request-create-tti-with-ui-modifications',
    timings: [
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $bd5f929877a0123c$export$750bc2c2ef1a94b6 = ()=>{
    $bd5f929877a0123c$export$376630eeb367a07a.start();
};
const $bd5f929877a0123c$export$30ca4c461fab486c = (customData)=>{
    $bd5f929877a0123c$export$376630eeb367a07a.stop({
        customData: customData
    });
};
const $bd5f929877a0123c$export$27f2445288b528c = ()=>{
    $bd5f929877a0123c$export$376630eeb367a07a.cancel();
};
const $bd5f929877a0123c$export$7a2709fc1e33401a = ()=>{
    $bd5f929877a0123c$export$376630eeb367a07a.mark('iframe-load');
};
const $bd5f929877a0123c$export$cf3893335c93e33b = ()=>{
    $bd5f929877a0123c$export$376630eeb367a07a.mark('fields-registered');
};
const $bd5f929877a0123c$export$d86f4868694f2aa7 = ()=>{
    $bd5f929877a0123c$export$376630eeb367a07a.mark('oninit-resolved');
};

});

parcelRegister("dnN1g", function(module, exports) {
$parcel$export(module.exports, "SUMMARY_TYPE", () => $d1c6656c95f79157$export$907219511d14ba3d);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $d1c6656c95f79157$export$22ac48a51c014e4b);
$parcel$export(module.exports, "USER_CF_TYPE", () => $d1c6656c95f79157$export$c491a4b98394028e);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $d1c6656c95f79157$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $d1c6656c95f79157$export$39cd48613b53ce2f);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $d1c6656c95f79157$export$c5d13ea26562d57a);
$parcel$export(module.exports, "MULTI_CHECKBOX_CF_TYPE", () => $d1c6656c95f79157$export$8293a3964f8ad43a);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $d1c6656c95f79157$export$65524be5675e57e6);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $d1c6656c95f79157$export$34740f8d07d23ac0);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $d1c6656c95f79157$export$c7faa96db185cfc6);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $d1c6656c95f79157$export$42d097f7b1622ef1);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $d1c6656c95f79157$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $d1c6656c95f79157$export$5e7324042f1d6b31);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $d1c6656c95f79157$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "DATEPICKER_CF_TYPE", () => $d1c6656c95f79157$export$69c9cc9ff399807f);
$parcel$export(module.exports, "LABELS_TYPE", () => $d1c6656c95f79157$export$43b6e33ec70f2272);
$parcel$export(module.exports, "DEFAULT", () => $d1c6656c95f79157$export$e6952b12ade67489);
$parcel$export(module.exports, "EMBEDDED_REQUEST_CREATE", () => $d1c6656c95f79157$export$75d9313789677296);
const $d1c6656c95f79157$export$907219511d14ba3d = 'summary';
const $d1c6656c95f79157$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $d1c6656c95f79157$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $d1c6656c95f79157$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $d1c6656c95f79157$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $d1c6656c95f79157$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $d1c6656c95f79157$export$8293a3964f8ad43a = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $d1c6656c95f79157$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $d1c6656c95f79157$export$34740f8d07d23ac0 = 'priority';
const $d1c6656c95f79157$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $d1c6656c95f79157$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $d1c6656c95f79157$export$b159f8b8f27aae4c = 'duedate';
const $d1c6656c95f79157$export$5e7324042f1d6b31 = 'description';
const $d1c6656c95f79157$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $d1c6656c95f79157$export$69c9cc9ff399807f = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $d1c6656c95f79157$export$43b6e33ec70f2272 = 'labels';
const $d1c6656c95f79157$export$e6952b12ade67489 = 'default';
const $d1c6656c95f79157$export$75d9313789677296 = 'embedded-request-create';

});

parcelRegister("juzow", function(module, exports) {
$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $a99327818579c8cb$export$2d586ab6ce4d7126);
$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $a99327818579c8cb$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $a99327818579c8cb$export$47e9770ed0d1c344);
$parcel$export(module.exports, "transformCascadingSelectUrlParamValue", () => $a99327818579c8cb$export$ceeb970e37fe21da);
$parcel$export(module.exports, "normalizeCascadingSelectValue", () => $a99327818579c8cb$export$e9eb61f6a3bc0438);
$parcel$export(module.exports, "transformValueToBasicCascadingSelect", () => $a99327818579c8cb$export$4fe225ca7554ff11);

var $c8dk3 = parcelRequire("c8dk3");

var $jXSiw = parcelRequire("jXSiw");
const $a99327818579c8cb$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.value === parentId);
    if (!foundOption) throw new (0, $c8dk3.FieldValueLookupError)();
    const childOption = childId !== null && foundOption.children ? foundOption.children.find((child)=>child.value === childId) || null : null;
    const value = {
        parent: foundOption,
        children: childOption
    };
    return value;
};
const $a99327818579c8cb$export$2d586ab6ce4d7126 = (value)=>{
    return value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $jXSiw.isNotEmptyString)(value.parentId) && ((0, $jXSiw.isNotEmptyString)(value.childId) || value.childId === null);
};
const $a99327818579c8cb$export$905a8d55c641a71e = (value, lookupData)=>{
    if (value === null || value.parentId === null) return null;
    const cascadingSelectValue = $a99327818579c8cb$var$findCascadingSelectLookupValues(lookupData, value.parentId, value.childId);
    return {
        primaryValue: cascadingSelectValue.parent,
        children: cascadingSelectValue.children
    };
};
const $a99327818579c8cb$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue || !cascadingValue.primaryValue) return null;
    const { primaryValue: primaryValue, children: children } = cascadingValue;
    return {
        parent: {
            id: primaryValue.value,
            value: primaryValue.label
        },
        child: children ? {
            id: children.value,
            value: children.label
        } : null
    };
};
const $a99327818579c8cb$var$isCascadingSelectUrlParamValue = (value)=>{
    if (!value || typeof value !== 'object' || !('primaryValue' in value)) return false;
    const primaryValue = value.primaryValue;
    const children = 'children' in value ? value.children : undefined;
    return typeof primaryValue === 'string' && (children === undefined || typeof children === 'string');
};
const $a99327818579c8cb$export$ceeb970e37fe21da = (urlParamValue, lookupData)=>{
    if (!$a99327818579c8cb$var$isCascadingSelectUrlParamValue(urlParamValue) || !lookupData) return null;
    const { primaryValue: parentId, children: childId } = urlParamValue;
    const parentOption = lookupData.find((opt)=>opt.value === parentId);
    if (!parentOption) return null;
    const childOption = childId !== undefined && parentOption.children ? parentOption.children.find((opt)=>opt.value === childId) ?? null : null;
    return {
        primaryValue: parentOption,
        children: childOption
    };
};
const $a99327818579c8cb$export$e9eb61f6a3bc0438 = (value)=>{
    var _children, _value$primaryValue;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    // If it's already NestedFieldValueType (string-based primaryValue)
    if (typeof value.primaryValue === 'string' || value.primaryValue === null) return value;
    // If it's object-based, extract string values
    const childrenValue = (_children = value.children) === null || _children === void 0 ? void 0 : _children.value;
    return {
        primaryValue: ((_value$primaryValue = value.primaryValue) === null || _value$primaryValue === void 0 ? void 0 : _value$primaryValue.value) || null,
        children: childrenValue || null
    };
};
const $a99327818579c8cb$export$4fe225ca7554ff11 = (value)=>{
    var _value$primaryValue2, _value$children;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    return {
        primaryValue: ((_value$primaryValue2 = value.primaryValue) === null || _value$primaryValue2 === void 0 ? void 0 : _value$primaryValue2.value) || null,
        children: ((_value$children = value.children) === null || _value$children === void 0 ? void 0 : _value$children.value) || null
    };
};

});

parcelRegister("eRN71", function(module, exports) {
$parcel$export(module.exports, "datePickerSetValueValidator", () => $7cbe026e3135bc7b$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $7cbe026e3135bc7b$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $7cbe026e3135bc7b$export$e844c6ac3a5cbef7);

var $iY5sc = parcelRequire("iY5sc");
var $abJ7q = parcelRequire("abJ7q");
var $2vjAH = parcelRequire("2vjAH");
var $4o5S4 = parcelRequire("4o5S4");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $7cbe026e3135bc7b$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $2vjAH.default)(date, dateFormat, new Date());
    return (0, $abJ7q.default)(parsedDate);
};
const $7cbe026e3135bc7b$export$c003579a97a2459e = (value)=>value === null || $7cbe026e3135bc7b$var$dateHasExpectedFormat(value);
const $7cbe026e3135bc7b$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $7cbe026e3135bc7b$export$e844c6ac3a5cbef7 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $4o5S4.default)(value);
    if ((0, $abJ7q.default)(parsedDate)) return (0, $iY5sc.default)(parsedDate, 'yyyy-MM-dd');
    return null;
};

});
parcelRegister("2vjAH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d2dac62fb57da23$export$2e2bcd8739ae039);

var $6XyXV = parcelRequire("6XyXV");

var $14XqU = parcelRequire("14XqU");

var $HzLXG = parcelRequire("HzLXG");

var $4xhXe = parcelRequire("4xhXe");

var $a3cTc = parcelRequire("a3cTc");

var $c4IKR = parcelRequire("c4IKR");

var $jRPwQ = parcelRequire("jRPwQ");

var $hHLVj = parcelRequire("hHLVj");

var $eTCip = parcelRequire("eTCip");

var $1Cu8A = parcelRequire("1Cu8A");

var $3mokv = parcelRequire("3mokv");

var $k2dGj = parcelRequire("k2dGj");

var $7FTTL = parcelRequire("7FTTL");

var $4WP6t = parcelRequire("4WP6t");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $1d2dac62fb57da23$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $1d2dac62fb57da23$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $1d2dac62fb57da23$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $1d2dac62fb57da23$var$doubleQuoteRegExp = /''/g;
var $1d2dac62fb57da23$var$notWhitespaceRegExp = /\S/;
var $1d2dac62fb57da23$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $1d2dac62fb57da23$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $3mokv.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $4WP6t.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $HzLXG.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $1Cu8A.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $1Cu8A.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $a3cTc.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $k2dGj.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($1d2dac62fb57da23$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $jRPwQ.default)) {
            var longFormatter = (0, $jRPwQ.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($1d2dac62fb57da23$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $14XqU.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $eTCip.isProtectedWeekYearToken)(token)) (0, $eTCip.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $eTCip.isProtectedDayOfYearToken)(token)) (0, $eTCip.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $7FTTL.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($1d2dac62fb57da23$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $1d2dac62fb57da23$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $6XyXV.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $1d2dac62fb57da23$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $a3cTc.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $4xhXe.default)(date, (0, $hHLVj.default)(date));
    var flags = {};
    var _iterator2 = (0, $14XqU.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $c4IKR.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $1d2dac62fb57da23$var$cleanEscapedString(input) {
    return input.match($1d2dac62fb57da23$var$escapedStringRegExp)[1].replace($1d2dac62fb57da23$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("14XqU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c94445947f083e9$export$2e2bcd8739ae039);

var $hxN7D = parcelRequire("hxN7D");
function $0c94445947f083e9$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $hxN7D.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("hxN7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc5b9f6239f6118a$export$2e2bcd8739ae039);

var $jf9XR = parcelRequire("jf9XR");
function $cc5b9f6239f6118a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $jf9XR.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $jf9XR.default)(r, a) : void 0;
    }
}

});
parcelRegister("jf9XR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e02725c15cb738eb$export$2e2bcd8739ae039);
function $e02725c15cb738eb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("c4IKR", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca8931fe0179099$export$2e2bcd8739ae039);
function $8ca8931fe0179099$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("k2dGj", function(module, exports) {
$parcel$export(module.exports, "ValueSetter", () => $e95e9b68535c611d$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $e95e9b68535c611d$export$5aaf7ff7f09ea4ee);

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $bD5s2 = parcelRequire("bD5s2");
var $e95e9b68535c611d$var$TIMEZONE_UNIT_PRIORITY = 10;
var $e95e9b68535c611d$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $aME1J.default)(this, Setter);
        (0, $bD5s2.default)(this, "priority", void 0);
        (0, $bD5s2.default)(this, "subPriority", 0);
    }
    (0, $bTrwr.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $e95e9b68535c611d$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $llKvF.default)(ValueSetter, _Setter);
    var _super = (0, $jFtew.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $aME1J.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $bTrwr.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($e95e9b68535c611d$export$81d53e3678089a6);
var $e95e9b68535c611d$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $llKvF.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $jFtew.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $aME1J.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this2), "priority", $e95e9b68535c611d$var$TIMEZONE_UNIT_PRIORITY);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $bTrwr.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($e95e9b68535c611d$export$81d53e3678089a6);

});
parcelRegister("llKvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8afa30059ddc9ec$export$2e2bcd8739ae039);

var $iPop6 = parcelRequire("iPop6");
function $f8afa30059ddc9ec$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $iPop6.default)(t, e);
}

});

parcelRegister("jFtew", function(module, exports) {
$parcel$export(module.exports, "default", () => $e51885c3c182eccf$export$2e2bcd8739ae039);

var $6kB8F = parcelRequire("6kB8F");

var $9KapC = parcelRequire("9KapC");

var $ePN5B = parcelRequire("ePN5B");
function $e51885c3c182eccf$export$2e2bcd8739ae039(t) {
    var r = (0, $9KapC.default)();
    return function() {
        var e, o = (0, $6kB8F.default)(t);
        if (r) {
            var s = (0, $6kB8F.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $ePN5B.default)(this, e);
    };
}

});
parcelRegister("6kB8F", function(module, exports) {
$parcel$export(module.exports, "default", () => $49c16b5688ee7c44$export$2e2bcd8739ae039);
function $49c16b5688ee7c44$export$2e2bcd8739ae039(t) {
    return $49c16b5688ee7c44$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $49c16b5688ee7c44$export$2e2bcd8739ae039(t);
}

});

parcelRegister("9KapC", function(module, exports) {
$parcel$export(module.exports, "default", () => $71807c9421c0992b$export$2e2bcd8739ae039);
function $71807c9421c0992b$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($71807c9421c0992b$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("ePN5B", function(module, exports) {
$parcel$export(module.exports, "default", () => $accbe83bc661afa4$export$2e2bcd8739ae039);

var $6XyXV = parcelRequire("6XyXV");

var $ac5sj = parcelRequire("ac5sj");
function $accbe83bc661afa4$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6XyXV.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $ac5sj.default)(t);
}

});


parcelRegister("aME1J", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d9d6f9b4d7e2730$export$2e2bcd8739ae039);
function $7d9d6f9b4d7e2730$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bTrwr", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a8a2e1e49b29a90$export$2e2bcd8739ae039);

var $85rQ1 = parcelRequire("85rQ1");
function $8a8a2e1e49b29a90$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $85rQ1.default)(o.key), o);
    }
}
function $8a8a2e1e49b29a90$export$2e2bcd8739ae039(e, r, t) {
    return r && $8a8a2e1e49b29a90$var$_defineProperties(e.prototype, r), t && $8a8a2e1e49b29a90$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});


parcelRegister("7FTTL", function(module, exports) {
$parcel$export(module.exports, "parsers", () => $5967b902f622eccd$export$19131010e7fd8373);

var $aL6NP = parcelRequire("aL6NP");

var $7WUuD = parcelRequire("7WUuD");

var $fZmCh = parcelRequire("fZmCh");

var $2aZV9 = parcelRequire("2aZV9");

var $laZRB = parcelRequire("laZRB");

var $lMA2X = parcelRequire("lMA2X");

var $kUXKR = parcelRequire("kUXKR");

var $5b8gM = parcelRequire("5b8gM");

var $flAVv = parcelRequire("flAVv");

var $lMGyp = parcelRequire("lMGyp");

var $dCURS = parcelRequire("dCURS");

var $29akA = parcelRequire("29akA");

var $5EE1M = parcelRequire("5EE1M");

var $6OiQV = parcelRequire("6OiQV");

var $diDMa = parcelRequire("diDMa");

var $3nqV0 = parcelRequire("3nqV0");

var $iGib6 = parcelRequire("iGib6");

var $eatcU = parcelRequire("eatcU");

var $5eUyV = parcelRequire("5eUyV");

var $iDRzY = parcelRequire("iDRzY");

var $f3FKA = parcelRequire("f3FKA");

var $iDVQA = parcelRequire("iDVQA");

var $gcCRR = parcelRequire("gcCRR");

var $2XXdX = parcelRequire("2XXdX");

var $hihaf = parcelRequire("hihaf");

var $8uiRK = parcelRequire("8uiRK");

var $mymz3 = parcelRequire("mymz3");

var $a1Vy3 = parcelRequire("a1Vy3");

var $2Rnwi = parcelRequire("2Rnwi");

var $58Fey = parcelRequire("58Fey");

var $iyQ5H = parcelRequire("iyQ5H");
var $5967b902f622eccd$export$19131010e7fd8373 = {
    G: new (0, $aL6NP.EraParser)(),
    y: new (0, $7WUuD.YearParser)(),
    Y: new (0, $fZmCh.LocalWeekYearParser)(),
    R: new (0, $2aZV9.ISOWeekYearParser)(),
    u: new (0, $laZRB.ExtendedYearParser)(),
    Q: new (0, $lMA2X.QuarterParser)(),
    q: new (0, $kUXKR.StandAloneQuarterParser)(),
    M: new (0, $5b8gM.MonthParser)(),
    L: new (0, $flAVv.StandAloneMonthParser)(),
    w: new (0, $lMGyp.LocalWeekParser)(),
    I: new (0, $dCURS.ISOWeekParser)(),
    d: new (0, $29akA.DateParser)(),
    D: new (0, $5EE1M.DayOfYearParser)(),
    E: new (0, $6OiQV.DayParser)(),
    e: new (0, $diDMa.LocalDayParser)(),
    c: new (0, $3nqV0.StandAloneLocalDayParser)(),
    i: new (0, $iGib6.ISODayParser)(),
    a: new (0, $eatcU.AMPMParser)(),
    b: new (0, $5eUyV.AMPMMidnightParser)(),
    B: new (0, $iDRzY.DayPeriodParser)(),
    h: new (0, $f3FKA.Hour1to12Parser)(),
    H: new (0, $iDVQA.Hour0to23Parser)(),
    K: new (0, $gcCRR.Hour0To11Parser)(),
    k: new (0, $2XXdX.Hour1To24Parser)(),
    m: new (0, $hihaf.MinuteParser)(),
    s: new (0, $8uiRK.SecondParser)(),
    S: new (0, $mymz3.FractionOfSecondParser)(),
    X: new (0, $a1Vy3.ISOTimezoneWithZParser)(),
    x: new (0, $2Rnwi.ISOTimezoneParser)(),
    t: new (0, $58Fey.TimestampSecondsParser)(),
    T: new (0, $iyQ5H.TimestampMillisecondsParser)()
};

});
parcelRegister("aL6NP", function(module, exports) {
$parcel$export(module.exports, "EraParser", () => $7d5392053895e244$export$8e5a1d3f85a9688);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");
var $7d5392053895e244$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(EraParser, _Parser);
    var _super = (0, $jFtew.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $aME1J.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 140);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $2uGOI.Parser));

});
parcelRegister("2uGOI", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $1d0f98a7b070a452$export$7acfa6ed01010e37);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $bD5s2 = parcelRequire("bD5s2");

var $k2dGj = parcelRequire("k2dGj");
var $1d0f98a7b070a452$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $aME1J.default)(this, Parser);
        (0, $bD5s2.default)(this, "incompatibleTokens", void 0);
        (0, $bD5s2.default)(this, "priority", void 0);
        (0, $bD5s2.default)(this, "subPriority", void 0);
    }
    (0, $bTrwr.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $k2dGj.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("7WUuD", function(module, exports) {
$parcel$export(module.exports, "YearParser", () => $5c99c588785cd46a$export$48d352de7cd4a988);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $5c99c588785cd46a$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(YearParser, _Parser);
    var _super = (0, $jFtew.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $aME1J.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 130);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $fvHsE.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $fvHsE.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $2uGOI.Parser));

});
parcelRegister("fvHsE", function(module, exports) {
$parcel$export(module.exports, "mapValue", () => $b4ab76b7f94ce5d4$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $b4ab76b7f94ce5d4$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $b4ab76b7f94ce5d4$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $b4ab76b7f94ce5d4$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $b4ab76b7f94ce5d4$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $b4ab76b7f94ce5d4$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $b4ab76b7f94ce5d4$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $b4ab76b7f94ce5d4$export$3d50627710b84d75);

var $8Krj2 = parcelRequire("8Krj2");

var $eUYl3 = parcelRequire("eUYl3");
function $b4ab76b7f94ce5d4$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b4ab76b7f94ce5d4$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $8Krj2.millisecondsInHour) + minutes * (0, $8Krj2.millisecondsInMinute) + seconds * (0, $8Krj2.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b4ab76b7f94ce5d4$export$d931c43c4608a164(dateString) {
    return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).anyDigitsSigned, dateString);
}
function $b4ab76b7f94ce5d4$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).singleDigit, dateString);
        case 2:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).twoDigits, dateString);
        case 3:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).threeDigits, dateString);
        case 4:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).fourDigits, dateString);
        default:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $b4ab76b7f94ce5d4$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388((0, $eUYl3.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $b4ab76b7f94ce5d4$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $b4ab76b7f94ce5d4$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $b4ab76b7f94ce5d4$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $b4ab76b7f94ce5d4$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("8Krj2", function(module, exports) {
$parcel$export(module.exports, "millisecondsInMinute", () => $65e7cd02b5809dc7$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $65e7cd02b5809dc7$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $65e7cd02b5809dc7$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $65e7cd02b5809dc7$export$dfd9b671c89acc8e = 7;
var $65e7cd02b5809dc7$export$3913210603d8e9ae = 365.2425;
var $65e7cd02b5809dc7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $65e7cd02b5809dc7$export$91246f0b9bd9beff = 60000;
var $65e7cd02b5809dc7$export$7f72910d6dfd237a = 3600000;
var $65e7cd02b5809dc7$export$397c2d5776aa9055 = 1000;
var $65e7cd02b5809dc7$export$4dec998e48f9c246 = -$65e7cd02b5809dc7$export$81caae6e1cc7a622;
var $65e7cd02b5809dc7$export$f2f5ae5a8e2d8f9f = 60;
var $65e7cd02b5809dc7$export$3c58128db900d44e = 3;
var $65e7cd02b5809dc7$export$80d7e435f744f319 = 12;
var $65e7cd02b5809dc7$export$4db7641526e3241f = 4;
var $65e7cd02b5809dc7$export$698aec755e92c695 = 3600;
var $65e7cd02b5809dc7$export$a77c1a7ebebe2a5a = 60;
var $65e7cd02b5809dc7$export$815a9362476d2fe3 = $65e7cd02b5809dc7$export$698aec755e92c695 * 24;
var $65e7cd02b5809dc7$export$34804a017b31e2fe = $65e7cd02b5809dc7$export$815a9362476d2fe3 * 7;
var $65e7cd02b5809dc7$export$7271e9e3478110d1 = $65e7cd02b5809dc7$export$815a9362476d2fe3 * $65e7cd02b5809dc7$export$3913210603d8e9ae;
var $65e7cd02b5809dc7$export$8e6600bbdee7dabb = $65e7cd02b5809dc7$export$7271e9e3478110d1 / 12;
var $65e7cd02b5809dc7$export$be1dccf2de902d31 = $65e7cd02b5809dc7$export$8e6600bbdee7dabb * 3;

});

parcelRegister("eUYl3", function(module, exports) {
$parcel$export(module.exports, "numericPatterns", () => $adc5199dffced636$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $adc5199dffced636$export$a7ee192b982af9c1);
var $adc5199dffced636$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $adc5199dffced636$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("fZmCh", function(module, exports) {
$parcel$export(module.exports, "LocalWeekYearParser", () => $03010065d874f242$export$b8ef38dfcf05d5db);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");

var $16hSb = parcelRequire("16hSb");

var $l7lcF = parcelRequire("l7lcF");
var $03010065d874f242$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $jFtew.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $aME1J.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 130);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $fvHsE.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $16hSb.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $fvHsE.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $l7lcF.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $l7lcF.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $2uGOI.Parser));

});

parcelRegister("2aZV9", function(module, exports) {
$parcel$export(module.exports, "ISOWeekYearParser", () => $195c8c21194ce66f$export$951d1df011fde06f);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");

var $gNdRc = parcelRequire("gNdRc");
var $195c8c21194ce66f$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $jFtew.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $aME1J.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 130);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $fvHsE.parseNDigitsSigned)(4, dateString);
                return (0, $fvHsE.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $gNdRc.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $2uGOI.Parser));

});

parcelRegister("laZRB", function(module, exports) {
$parcel$export(module.exports, "ExtendedYearParser", () => $f6aa84f7116b8e15$export$bad9d2ea38e8f1a);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $f6aa84f7116b8e15$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(ExtendedYearParser, _Parser);
    var _super = (0, $jFtew.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $aME1J.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 130);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $fvHsE.parseNDigitsSigned)(4, dateString);
                return (0, $fvHsE.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $2uGOI.Parser));

});

parcelRegister("lMA2X", function(module, exports) {
$parcel$export(module.exports, "QuarterParser", () => $fdba0ac7a70e1b9a$export$5cb0f701186dde1d);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $fdba0ac7a70e1b9a$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(QuarterParser, _Parser);
    var _super = (0, $jFtew.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $aME1J.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 120);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $2uGOI.Parser));

});

parcelRegister("kUXKR", function(module, exports) {
$parcel$export(module.exports, "StandAloneQuarterParser", () => $f3a763afd8d57652$export$300c0c2990e20e6d);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $f3a763afd8d57652$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $jFtew.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $aME1J.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 120);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $2uGOI.Parser));

});

parcelRegister("5b8gM", function(module, exports) {
$parcel$export(module.exports, "MonthParser", () => $3c546504821b0e7a$export$400dd8b40ef138a3);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $fvHsE = parcelRequire("fvHsE");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");
var $3c546504821b0e7a$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(MonthParser, _Parser);
    var _super = (0, $jFtew.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $aME1J.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 110);
        return _this;
    }
    (0, $bTrwr.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $fvHsE.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $2uGOI.Parser));

});

parcelRegister("flAVv", function(module, exports) {
$parcel$export(module.exports, "StandAloneMonthParser", () => $b2c576004d0f317f$export$1d7eaa53eaa5deba);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $b2c576004d0f317f$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $jFtew.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $aME1J.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 110);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $fvHsE.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $2uGOI.Parser));

});

parcelRegister("lMGyp", function(module, exports) {
$parcel$export(module.exports, "LocalWeekParser", () => $fdbf16fe60fc3ec2$export$c4005ffc174e07c0);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");

var $kmY5e = parcelRequire("kmY5e");

var $l7lcF = parcelRequire("l7lcF");
var $fdbf16fe60fc3ec2$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(LocalWeekParser, _Parser);
    var _super = (0, $jFtew.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $aME1J.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 100);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $l7lcF.default)((0, $kmY5e.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $2uGOI.Parser));

});
parcelRegister("kmY5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed44780948f993d0$export$2e2bcd8739ae039);

var $1Cu8A = parcelRequire("1Cu8A");

var $a3cTc = parcelRequire("a3cTc");

var $8cu26 = parcelRequire("8cu26");

var $3mokv = parcelRequire("3mokv");
function $ed44780948f993d0$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $3mokv.default)(2, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var week = (0, $1Cu8A.default)(dirtyWeek);
    var diff = (0, $8cu26.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("dCURS", function(module, exports) {
$parcel$export(module.exports, "ISOWeekParser", () => $9ebaefc9d382f60c$export$6fc8dbedd560a6af);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");

var $3zegp = parcelRequire("3zegp");

var $gNdRc = parcelRequire("gNdRc");
var $9ebaefc9d382f60c$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(ISOWeekParser, _Parser);
    var _super = (0, $jFtew.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $aME1J.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 100);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $gNdRc.default)((0, $3zegp.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $2uGOI.Parser));

});
parcelRegister("3zegp", function(module, exports) {
$parcel$export(module.exports, "default", () => $298fb46f0fedc80e$export$2e2bcd8739ae039);

var $1Cu8A = parcelRequire("1Cu8A");

var $a3cTc = parcelRequire("a3cTc");

var $6x2h9 = parcelRequire("6x2h9");

var $3mokv = parcelRequire("3mokv");
function $298fb46f0fedc80e$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $3mokv.default)(2, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var isoWeek = (0, $1Cu8A.default)(dirtyISOWeek);
    var diff = (0, $6x2h9.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("29akA", function(module, exports) {
$parcel$export(module.exports, "DateParser", () => $19046f934e611970$export$e8d4b28a20981dd2);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $fvHsE = parcelRequire("fvHsE");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");
var $19046f934e611970$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $19046f934e611970$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $19046f934e611970$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(DateParser, _Parser);
    var _super = (0, $jFtew.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $aME1J.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 90);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "subPriority", 1);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $fvHsE.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $19046f934e611970$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $19046f934e611970$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $2uGOI.Parser));

});

parcelRegister("5EE1M", function(module, exports) {
$parcel$export(module.exports, "DayOfYearParser", () => $41dfbcdb0f2f10cb$export$6cfe0d613455f615);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $41dfbcdb0f2f10cb$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(DayOfYearParser, _Parser);
    var _super = (0, $jFtew.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $aME1J.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 90);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "subpriority", 1);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $fvHsE.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $2uGOI.Parser));

});

parcelRegister("6OiQV", function(module, exports) {
$parcel$export(module.exports, "DayParser", () => $4f560953c67b77db$export$1b03c8b76262f7bd);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $gZ6I9 = parcelRequire("gZ6I9");
var $4f560953c67b77db$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(DayParser, _Parser);
    var _super = (0, $jFtew.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $aME1J.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 90);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gZ6I9.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $2uGOI.Parser));

});
parcelRegister("gZ6I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d78c844fe9556c$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");

var $1Cu8A = parcelRequire("1Cu8A");

var $4WP6t = parcelRequire("4WP6t");
function $c5d78c844fe9556c$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3mokv.default)(2, arguments);
    var defaultOptions = (0, $4WP6t.getDefaultOptions)();
    var weekStartsOn = (0, $1Cu8A.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = (0, $1Cu8A.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("diDMa", function(module, exports) {
$parcel$export(module.exports, "LocalDayParser", () => $9aebcf7820ae676c$export$44d1c127ab42c480);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");

var $gZ6I9 = parcelRequire("gZ6I9");
var $9aebcf7820ae676c$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(LocalDayParser, _Parser);
    var _super = (0, $jFtew.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $aME1J.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 90);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $fvHsE.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gZ6I9.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $2uGOI.Parser));

});

parcelRegister("3nqV0", function(module, exports) {
$parcel$export(module.exports, "StandAloneLocalDayParser", () => $275866887d290344$export$e447a647caaaec1d);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");

var $gZ6I9 = parcelRequire("gZ6I9");
var $275866887d290344$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $jFtew.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $aME1J.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 90);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $fvHsE.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gZ6I9.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $2uGOI.Parser));

});

parcelRegister("iGib6", function(module, exports) {
$parcel$export(module.exports, "ISODayParser", () => $d99a4003900bb463$export$693fb1e525095b2a);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");

var $9Bcnx = parcelRequire("9Bcnx");
var $d99a4003900bb463$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(ISODayParser, _Parser);
    var _super = (0, $jFtew.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $aME1J.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 90);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $fvHsE.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $fvHsE.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $fvHsE.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $fvHsE.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $9Bcnx.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $2uGOI.Parser));

});
parcelRegister("9Bcnx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fd12be2341b2a53$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");

var $1Cu8A = parcelRequire("1Cu8A");
function $6fd12be2341b2a53$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $3mokv.default)(2, arguments);
    var day = (0, $1Cu8A.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $a3cTc.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("eatcU", function(module, exports) {
$parcel$export(module.exports, "AMPMParser", () => $a508a7c9dc6604cf$export$8d1e08492351df91);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $a508a7c9dc6604cf$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(AMPMParser, _Parser);
    var _super = (0, $jFtew.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $aME1J.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 80);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fvHsE.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $2uGOI.Parser));

});

parcelRegister("5eUyV", function(module, exports) {
$parcel$export(module.exports, "AMPMMidnightParser", () => $3d0a22a7c49b00ad$export$73ca2bd0a17d273);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $3d0a22a7c49b00ad$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $jFtew.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $aME1J.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 80);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fvHsE.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $2uGOI.Parser));

});

parcelRegister("iDRzY", function(module, exports) {
$parcel$export(module.exports, "DayPeriodParser", () => $d9256e41057f2126$export$bb9212adf05373db);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $d9256e41057f2126$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(DayPeriodParser, _Parser);
    var _super = (0, $jFtew.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $aME1J.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 80);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fvHsE.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $2uGOI.Parser));

});

parcelRegister("f3FKA", function(module, exports) {
$parcel$export(module.exports, "Hour1to12Parser", () => $af678594900f2e5a$export$8a04050a727a1756);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $af678594900f2e5a$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(Hour1to12Parser, _Parser);
    var _super = (0, $jFtew.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $aME1J.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 70);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $2uGOI.Parser));

});

parcelRegister("iDVQA", function(module, exports) {
$parcel$export(module.exports, "Hour0to23Parser", () => $d928bdbd2149c267$export$e56f4dea2c3e56dd);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $d928bdbd2149c267$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(Hour0to23Parser, _Parser);
    var _super = (0, $jFtew.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $aME1J.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 70);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $2uGOI.Parser));

});

parcelRegister("gcCRR", function(module, exports) {
$parcel$export(module.exports, "Hour0To11Parser", () => $bcbbeaa18021dcf0$export$cbbe855312f87d77);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $bcbbeaa18021dcf0$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(Hour0To11Parser, _Parser);
    var _super = (0, $jFtew.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $aME1J.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 70);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $2uGOI.Parser));

});

parcelRegister("2XXdX", function(module, exports) {
$parcel$export(module.exports, "Hour1To24Parser", () => $228f082943c24155$export$6008046d2b34b6a5);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $228f082943c24155$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(Hour1To24Parser, _Parser);
    var _super = (0, $jFtew.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $aME1J.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 70);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $2uGOI.Parser));

});

parcelRegister("hihaf", function(module, exports) {
$parcel$export(module.exports, "MinuteParser", () => $c9716e8f29b0a3b2$export$2b52670d9e2be53);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $c9716e8f29b0a3b2$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(MinuteParser, _Parser);
    var _super = (0, $jFtew.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $aME1J.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 60);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $2uGOI.Parser));

});

parcelRegister("8uiRK", function(module, exports) {
$parcel$export(module.exports, "SecondParser", () => $62dfc275dc01bde6$export$94d46d540cf1366a);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $62dfc275dc01bde6$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(SecondParser, _Parser);
    var _super = (0, $jFtew.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $aME1J.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 50);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $fvHsE.parseNumericPattern)((0, $eUYl3.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $fvHsE.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $2uGOI.Parser));

});

parcelRegister("mymz3", function(module, exports) {
$parcel$export(module.exports, "FractionOfSecondParser", () => $043cb5f3e98e90c8$export$b8e6f8b2d70893b1);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $043cb5f3e98e90c8$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $jFtew.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $aME1J.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 30);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $fvHsE.mapValue)((0, $fvHsE.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $2uGOI.Parser));

});

parcelRegister("a1Vy3", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $74d6a3464fd8f008$export$104d901d49fea29b);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $74d6a3464fd8f008$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $jFtew.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $aME1J.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 10);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $2uGOI.Parser));

});

parcelRegister("2Rnwi", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneParser", () => $2152c68d08c2460b$export$12910e5204b52b9);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $eUYl3 = parcelRequire("eUYl3");

var $fvHsE = parcelRequire("fvHsE");
var $2152c68d08c2460b$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $jFtew.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $aME1J.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 10);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $bTrwr.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $fvHsE.parseTimezonePattern)((0, $eUYl3.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $2uGOI.Parser));

});

parcelRegister("58Fey", function(module, exports) {
$parcel$export(module.exports, "TimestampSecondsParser", () => $3bddaf45de7a81fe$export$2cd8bf877a05e96);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $3bddaf45de7a81fe$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $jFtew.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $aME1J.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 40);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $bTrwr.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $fvHsE.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $2uGOI.Parser));

});

parcelRegister("iyQ5H", function(module, exports) {
$parcel$export(module.exports, "TimestampMillisecondsParser", () => $d833cf28644b8759$export$6d8f69c6906d6368);

var $aME1J = parcelRequire("aME1J");

var $bTrwr = parcelRequire("bTrwr");

var $ac5sj = parcelRequire("ac5sj");

var $llKvF = parcelRequire("llKvF");

var $jFtew = parcelRequire("jFtew");

var $bD5s2 = parcelRequire("bD5s2");

var $2uGOI = parcelRequire("2uGOI");

var $fvHsE = parcelRequire("fvHsE");
var $d833cf28644b8759$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $llKvF.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $jFtew.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $aME1J.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "priority", 20);
        (0, $bD5s2.default)((0, $ac5sj.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $bTrwr.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $fvHsE.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $2uGOI.Parser));

});



parcelRegister("4o5S4", function(module, exports) {
$parcel$export(module.exports, "default", () => $331df52c0ad0c0d9$export$2e2bcd8739ae039);

var $8Krj2 = parcelRequire("8Krj2");

var $3mokv = parcelRequire("3mokv");

var $1Cu8A = parcelRequire("1Cu8A");
function $331df52c0ad0c0d9$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3mokv.default)(1, arguments);
    var additionalDigits = (0, $1Cu8A.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $331df52c0ad0c0d9$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $331df52c0ad0c0d9$var$parseYear(dateStrings.date, additionalDigits);
        date = $331df52c0ad0c0d9$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $331df52c0ad0c0d9$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $331df52c0ad0c0d9$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $331df52c0ad0c0d9$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $331df52c0ad0c0d9$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $331df52c0ad0c0d9$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $331df52c0ad0c0d9$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $331df52c0ad0c0d9$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($331df52c0ad0c0d9$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($331df52c0ad0c0d9$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($331df52c0ad0c0d9$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $331df52c0ad0c0d9$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $331df52c0ad0c0d9$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $331df52c0ad0c0d9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($331df52c0ad0c0d9$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $331df52c0ad0c0d9$var$parseDateUnit(captures[1]);
    var month = $331df52c0ad0c0d9$var$parseDateUnit(captures[2]) - 1;
    var day = $331df52c0ad0c0d9$var$parseDateUnit(captures[3]);
    var week = $331df52c0ad0c0d9$var$parseDateUnit(captures[4]);
    var dayOfWeek = $331df52c0ad0c0d9$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$331df52c0ad0c0d9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $331df52c0ad0c0d9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$331df52c0ad0c0d9$var$validateDate(year, month, day) || !$331df52c0ad0c0d9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $331df52c0ad0c0d9$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $331df52c0ad0c0d9$var$parseTime(timeString) {
    var captures = timeString.match($331df52c0ad0c0d9$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $331df52c0ad0c0d9$var$parseTimeUnit(captures[1]);
    var minutes = $331df52c0ad0c0d9$var$parseTimeUnit(captures[2]);
    var seconds = $331df52c0ad0c0d9$var$parseTimeUnit(captures[3]);
    if (!$331df52c0ad0c0d9$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $8Krj2.millisecondsInHour) + minutes * (0, $8Krj2.millisecondsInMinute) + seconds * 1000;
}
function $331df52c0ad0c0d9$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $331df52c0ad0c0d9$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($331df52c0ad0c0d9$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$331df52c0ad0c0d9$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $8Krj2.millisecondsInHour) + minutes * (0, $8Krj2.millisecondsInMinute));
}
function $331df52c0ad0c0d9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $331df52c0ad0c0d9$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $331df52c0ad0c0d9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $331df52c0ad0c0d9$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($331df52c0ad0c0d9$var$daysInMonths[month] || ($331df52c0ad0c0d9$var$isLeapYearIndex(year) ? 29 : 28));
}
function $331df52c0ad0c0d9$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($331df52c0ad0c0d9$var$isLeapYearIndex(year) ? 366 : 365);
}
function $331df52c0ad0c0d9$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $331df52c0ad0c0d9$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $331df52c0ad0c0d9$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});


parcelRegister("41MjD", function(module, exports) {
$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $5ab5591d7edf31e4$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $5ab5591d7edf31e4$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $5ab5591d7edf31e4$export$4cb6c79fda4a9c74);

var $iY5sc = parcelRequire("iY5sc");
var $aUANI = parcelRequire("aUANI");
var $abJ7q = parcelRequire("abJ7q");
var $4o5S4 = parcelRequire("4o5S4");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $5ab5591d7edf31e4$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $5ab5591d7edf31e4$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $aUANI.default)(fullDate, $5ab5591d7edf31e4$var$formatString) && (0, $abJ7q.default)((0, $4o5S4.default)(fullDate));
};
const $5ab5591d7edf31e4$export$7930ddff407505cc = (value)=>{
    return value === null || $5ab5591d7edf31e4$export$a886f5166a4d311e(value);
};
const $5ab5591d7edf31e4$export$e81204f19744e19f = (publicValue)=>{
    return publicValue === null ? '' : publicValue;
};
const $5ab5591d7edf31e4$export$4cb6c79fda4a9c74 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $4o5S4.default)(value);
    if ((0, $abJ7q.default)(parsedDate)) return (0, $iY5sc.default)(parsedDate, $5ab5591d7edf31e4$var$formatString);
    return null;
};

});
parcelRegister("aUANI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f1bae36b3f60f35$export$2e2bcd8739ae039);

var $2vjAH = parcelRequire("2vjAH");

var $abJ7q = parcelRequire("abJ7q");

var $3mokv = parcelRequire("3mokv");
function $7f1bae36b3f60f35$export$2e2bcd8739ae039(dateString, formatString, options) {
    (0, $3mokv.default)(2, arguments);
    return (0, $abJ7q.default)((0, $2vjAH.default)(dateString, formatString, new Date(), options));
}

});


parcelRegister("ab3Gy", function(module, exports) {
$parcel$export(module.exports, "labelsSetValueValidator", () => $4d0bf961de2874fb$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $4d0bf961de2874fb$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $4d0bf961de2874fb$export$b0b12fd0b1cd9d3a);
$parcel$export(module.exports, "modifyLabelsValueToBasic", () => $4d0bf961de2874fb$export$627e5994af99713c);
const $4d0bf961de2874fb$export$e67b5652c846b5f = (value)=>Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $4d0bf961de2874fb$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            label: label,
            value: label
        }));
const $4d0bf961de2874fb$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);
const $4d0bf961de2874fb$export$627e5994af99713c = (data)=>{
    if (Array.isArray(data)) return data.map((item)=>item.value);
    return [];
};

});

parcelRegister("2HMpF", function(module, exports) {
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $758a941de850c094$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $758a941de850c094$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxValueToSelectedOptionsTransformer", () => $758a941de850c094$export$67585ccde04b97e0);
$parcel$export(module.exports, "normalizeMultiCheckboxValue", () => $758a941de850c094$export$e31e24357d17bcec);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $758a941de850c094$export$6d15ce1cc0bdffe7);
$parcel$export(module.exports, "multiCheckboxSetOptionsVisibilityTransformer", () => $758a941de850c094$export$e9bad46ddf6f220a);
$parcel$export(module.exports, "multiCheckboxGetOptionsVisibilityTransformer", () => $758a941de850c094$export$2873e4aff600baf0);
$parcel$export(module.exports, "modifyMultiSelectValueToBasic", () => $758a941de850c094$export$1c5664946e66ba46);

var $eD9Eb = parcelRequire("eD9Eb");

var $jXSiw = parcelRequire("jXSiw");
const $758a941de850c094$export$106087dcfd4fb129 = 100;
const $758a941de850c094$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.length <= $758a941de850c094$export$106087dcfd4fb129 && value.every((0, $jXSiw.isNotEmptyString));
const $758a941de850c094$export$45b7d122d1400fe0 = (value)=>Array.isArray(value) && value.length <= $758a941de850c094$export$106087dcfd4fb129 && value.every((val)=>(0, $jXSiw.isNotEmptyString)(val) && (0, $eD9Eb.isAriResourceIdValid)(val));
const $758a941de850c094$export$9ba1ee83cc9456ba = (optionIds, options)=>{
    const selectedOptions = options.filter((option)=>optionIds.includes(option.value));
    return selectedOptions;
};
const $758a941de850c094$var$isMultiCheckboxValue = (value)=>Array.isArray(value) && value.every((0, $jXSiw.isNotEmptyString));
const $758a941de850c094$export$67585ccde04b97e0 = (value, allowedValues)=>{
    if (!$758a941de850c094$var$isMultiCheckboxValue(value) || !allowedValues) return [];
    return $758a941de850c094$export$9ba1ee83cc9456ba(value, allowedValues);
};
const $758a941de850c094$export$e31e24357d17bcec = (value)=>(value === null || value === void 0 ? void 0 : value.map((item)=>typeof item === 'string' ? item : item.value)) ?? [];
const $758a941de850c094$export$6d15ce1cc0bdffe7 = (selectedOptionData)=>{
    return selectedOptionData.map((option)=>{
        return {
            id: option.value,
            value: option === null || option === void 0 ? void 0 : option.label
        };
    });
};
const $758a941de850c094$export$e9bad46ddf6f220a = (optionsVisibility, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
};
const $758a941de850c094$export$2873e4aff600baf0 = (optionsVisibility, lookupValues)=>{
    const filteredLookupValues = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
    return {
        options: (filteredLookupValues === null || filteredLookupValues === void 0 ? void 0 : filteredLookupValues.map(({ value: value })=>value)) ?? [],
        isVisible: optionsVisibility.isVisible
    };
};
const $758a941de850c094$export$1c5664946e66ba46 = (selectedOptions)=>(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 ? selectedOptions.map((option)=>option.value) : [];

});

parcelRegister("8h9pD", function(module, exports) {
$parcel$export(module.exports, "validateNumberValue", () => $f28e356f7ff5b8f4$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "transformNumberToInternalValue", () => $f28e356f7ff5b8f4$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $f28e356f7ff5b8f4$export$8bdc28b51a4acc44);
const $f28e356f7ff5b8f4$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $f28e356f7ff5b8f4$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $f28e356f7ff5b8f4$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);

});

parcelRegister("4NwRr", function(module, exports) {
$parcel$export(module.exports, "validatePrioritySetValue", () => $48a6ae582fcd7535$export$feb916d6d9ca4953);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $48a6ae582fcd7535$export$c6ef424ead917b72);
$parcel$export(module.exports, "prioritySetOptionsVisibility", () => $48a6ae582fcd7535$export$28c18b75fec0308d);
$parcel$export(module.exports, "priorityGetValueTransformer", () => $48a6ae582fcd7535$export$a3dcdeebcccb44cd);
$parcel$export(module.exports, "modifyPriorityValueToBasic", () => $48a6ae582fcd7535$export$8be86fe3b85cdd48);

var $jXSiw = parcelRequire("jXSiw");
const $48a6ae582fcd7535$export$feb916d6d9ca4953 = (value)=>(0, $jXSiw.isNotEmptyString)(value);
const $48a6ae582fcd7535$export$c6ef424ead917b72 = (optionId, options)=>{
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $48a6ae582fcd7535$export$28c18b75fec0308d = ({ options: options, isVisible: isVisible }, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
};
const $48a6ae582fcd7535$export$a3dcdeebcccb44cd = (data)=>{
    if (!data) return null;
    return {
        id: data.value,
        name: data.label
    };
};
const $48a6ae582fcd7535$export$8be86fe3b85cdd48 = (data)=>data === null || data === void 0 ? void 0 : data.value;

});

parcelRegister("865Q5", function(module, exports) {
$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $737aadb411f89aaf$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $737aadb411f89aaf$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $737aadb411f89aaf$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $737aadb411f89aaf$export$fd4db924c90bd0e2);
$parcel$export(module.exports, "modifySelectValueToBasic", () => $737aadb411f89aaf$export$24495edee70b381);
const $737aadb411f89aaf$export$81990085f8ab114b = ({ options: options, isVisible: isVisible }, lookupValues)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
const $737aadb411f89aaf$export$7c7ca81813eb0f65 = ({ options: options, isVisible: isVisible }, lookupValues)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.some((val)=>val.value === option))
    });
const $737aadb411f89aaf$export$136c42b919fdec83 = (optionId, options)=>{
    if (optionId === null) return null;
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $737aadb411f89aaf$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $737aadb411f89aaf$export$24495edee70b381 = (selectedOption)=>{
    if (selectedOption === null) return null;
    return selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
};

});

parcelRegister("ctBfk", function(module, exports) {
$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $083db8a5630a8a59$export$161c77b6b09fc494);
const $083db8a5630a8a59$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("6XW18", function(module, exports) {
$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $26b39e28428d5723$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $26b39e28428d5723$export$624bfe758f4ad3c6);
$parcel$export(module.exports, "radioButtonsSetOptionsVisibilityTransformer", () => $26b39e28428d5723$export$aadb0d8b636b9e19);
$parcel$export(module.exports, "radioButtonsGetOptionsVisibilityTransformer", () => $26b39e28428d5723$export$1a20bcf25e1f19dc);
$parcel$export(module.exports, "modifyRadioButtonsValueToBasic", () => $26b39e28428d5723$export$7343aeb896776ca4);
$parcel$export(module.exports, "radioButtonsValueToSelectedOptionTransformer", () => $26b39e28428d5723$export$814c69030a08410c);
$parcel$export(module.exports, "normalizeRadioButtonsValue", () => $26b39e28428d5723$export$586e4addfd1305f6);

var $865Q5 = parcelRequire("865Q5");
const $26b39e28428d5723$export$d23713245ea192a9 = (0, $865Q5.selectSetValueTransformer);
const $26b39e28428d5723$export$624bfe758f4ad3c6 = (0, $865Q5.selectGetValueTransformer);
const $26b39e28428d5723$export$aadb0d8b636b9e19 = (0, $865Q5.transformSelectSetOptionsVisibility);
const $26b39e28428d5723$export$1a20bcf25e1f19dc = (0, $865Q5.transformSelectGetOptionsVisibility);
const $26b39e28428d5723$export$7343aeb896776ca4 = (0, $865Q5.modifySelectValueToBasic);
const $26b39e28428d5723$export$814c69030a08410c = (value, allowedValues)=>{
    if (value === null) return null;
    if (typeof value !== 'string' || !allowedValues) return null;
    return $26b39e28428d5723$export$d23713245ea192a9(value, allowedValues) ?? null;
};
const $26b39e28428d5723$export$586e4addfd1305f6 = (value)=>{
    if (!value) return '';
    return typeof value === 'string' ? value : value.value;
};

});

parcelRegister("d5UkQ", function(module, exports) {
$parcel$export(module.exports, "validateTextAreaValue", () => $e5889e297c96ff98$export$af1bd7b4775c21f5);
$parcel$export(module.exports, "textAreaGetValueTransformer", () => $e5889e297c96ff98$export$f8779084d2efe971);
$parcel$export(module.exports, "textAreaSetValueTransformer", () => $e5889e297c96ff98$export$b26179f27360223b);

var $71fHC = parcelRequire("71fHC");

var $2eOU2 = parcelRequire("2eOU2");

var $3OzEX = parcelRequire("3OzEX");
const $e5889e297c96ff98$export$c7bf565312b59b06 = 'atlassian-wiki-renderer';
const $e5889e297c96ff98$export$af1bd7b4775c21f5 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    if (fieldRenderer === $e5889e297c96ff98$export$c7bf565312b59b06) {
        var _extra$currentField;
        return (0, $3OzEX.isValidADF)({
            newValue: value,
            currentValue: (_extra$currentField = extra.currentField) === null || _extra$currentField === void 0 ? void 0 : _extra$currentField.value
        });
    }
    return Promise.resolve(typeof value === 'string');
};
const $e5889e297c96ff98$export$f8779084d2efe971 = (value, fieldRenderer)=>{
    if (!value) return fieldRenderer === $e5889e297c96ff98$export$c7bf565312b59b06 ? (0, $71fHC.getEmptyADF)() : '';
    try {
        return (0, $2eOU2.parseAdf)(value);
    } catch (e) {
        return value;
    }
};
const $e5889e297c96ff98$export$b26179f27360223b = (value)=>{
    // Check if value is string, if not convert it to string
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
};

});
parcelRegister("71fHC", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $6e373ca6d0810c62$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aVCUs = parcelRequire("aVCUs");
const $6e373ca6d0810c62$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("aVCUs", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $3283caafe1d12cdf$export$dd1bc94b04021eeb);
const $3283caafe1d12cdf$export$dd1bc94b04021eeb = (node)=>{
    var _node$content;
    return !(node !== null && node !== void 0 && (_node$content = node.content) !== null && _node$content !== void 0 && _node$content.length);
};

});


parcelRegister("3OzEX", function(module, exports) {
$parcel$export(module.exports, "isValidADF", () => $68c8f772fa201fa6$export$94ea512f7afe62e4);

var $cl2x9 = parcelRequire("cl2x9");

var $3ZJj6 = parcelRequire("3ZJj6");

var $j2vls = parcelRequire("j2vls");

var $9RIwK = parcelRequire("9RIwK");

const $68c8f772fa201fa6$var$getADFValidator = async ()=>{
    const { validator: validator } = await Promise.resolve((parcelRequire("77DyS")));
    return validator;
};
const $68c8f772fa201fa6$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $9RIwK.traverse)(adf, {
            media: (node)=>{
                var _node$attrs, _node$attrs2;
                if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.type) === 'external' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url) !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $68c8f772fa201fa6$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $68c8f772fa201fa6$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($cl2x9)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $j2vls.doc)(...foundDiffNodes);
    return $68c8f772fa201fa6$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $68c8f772fa201fa6$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue })=>{
    const validator = await $68c8f772fa201fa6$var$getADFValidator();
    const validate = validator();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $68c8f772fa201fa6$export$6f13dd7501a16a00(newValue, currentValue);
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("cl2x9", function(module, exports) {

var $99yUY = parcelRequire("99yUY");

var $8kW7W = parcelRequire("8kW7W");

var $5bKlg = parcelRequire("5bKlg");

var $66gHu = parcelRequire("66gHu");

var $1VqtZ = parcelRequire("1VqtZ");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $8fb96953639c8cca$var$differenceWith = $5bKlg(function(array, values) {
    var comparator = $1VqtZ(values);
    if ($66gHu(comparator)) comparator = undefined;
    return $66gHu(array) ? $99yUY(array, $8kW7W(values, 1, $66gHu, true), undefined, comparator) : [];
});
module.exports = $8fb96953639c8cca$var$differenceWith;

});
parcelRegister("99yUY", function(module, exports) {

var $7SHMG = parcelRequire("7SHMG");

var $cm9vO = parcelRequire("cm9vO");

var $89kNo = parcelRequire("89kNo");

var $40ghw = parcelRequire("40ghw");

var $eKaiJ = parcelRequire("eKaiJ");

var $2QtyU = parcelRequire("2QtyU");
/** Used as the size to enable large array optimizations. */ var $6aa00a4a8ad295e8$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $6aa00a4a8ad295e8$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $cm9vO, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $40ghw(values, $eKaiJ(iteratee));
    if (comparator) {
        includes = $89kNo;
        isCommon = false;
    } else if (values.length >= $6aa00a4a8ad295e8$var$LARGE_ARRAY_SIZE) {
        includes = $2QtyU;
        isCommon = false;
        values = new $7SHMG(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $6aa00a4a8ad295e8$var$baseDifference;

});


parcelRegister("77DyS", function(module, exports) {
$parcel$export(module.exports, "validator", () => $2895c23f45401805$export$956325f45c5d174a);

var $dRkX9 = parcelRequire("dRkX9");

var $a4iAO = parcelRequire("a4iAO");

var $f1Tcf = parcelRequire("f1Tcf");

var $kWsvl = parcelRequire("kWsvl");

var $5dQm8 = parcelRequire("5dQm8");

var $gOADJ = parcelRequire("gOADJ");

var $f1zLf = parcelRequire("f1zLf");

var $6wTws = parcelRequire("6wTws");

var $7sgLM = parcelRequire("7sgLM");

var $4BDl4 = parcelRequire("4BDl4");

var $5ajqD = parcelRequire("5ajqD");

var $6DuaV = parcelRequire("6DuaV");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2895c23f45401805$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2895c23f45401805$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 */ const $2895c23f45401805$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
/**
 * Resolve one content-item name against `specs`. Variant specs are stored as tuples (arrays), so a
 * name that refers to one (e.g. `paragraph_with_no_marks`) resolves to that tuple. A plain node
 * name (e.g. `table`) has no tuple in `specs` and is returned unchanged for the matcher to handle
 * by name.
 */ const $2895c23f45401805$var$resolveContentItemName = (name)=>{
    const referencedSpec = (0, $6DuaV.specs)[name];
    return Array.isArray(referencedSpec) ? referencedSpec : name;
};
/**
 * Expand the content item NAMES inside a variant tuple's override so they resolve the same way a
 * base spec's content does. A variant such as `panel_c1` is `['panel', { props: { content: { items:
 * [['paragraph_with_no_marks', ..., 'table']] } } }]`; those inner names are validator variant
 * names. Unlike a base spec's content (which `createSpec` resolves), the override names are left
 * raw, so the variant branch matches only plainly-named children (e.g. `table`) and rejects
 * variant-named ones (e.g. a normal `paragraph`). Resolve each name one level, leaving plain node
 * names untouched.
 */ const $2895c23f45401805$var$resolveVariantOverrideContentItems = (variantTuple)=>{
    var _variantSpec$props;
    const [baseNodeType, variantSpec] = variantTuple;
    const content = variantSpec === null || variantSpec === void 0 || (_variantSpec$props = variantSpec.props) === null || _variantSpec$props === void 0 ? void 0 : _variantSpec$props.content;
    if (!content || !Array.isArray(content.items)) return variantTuple;
    // Each entry in `content.items` is either a single name or an `$or` group (a list of
    // alternative names). Resolve the names inside each `$or` group; pass single names through.
    const resolvedItems = content.items.map((entry)=>Array.isArray(entry) ? entry.map($2895c23f45401805$var$resolveContentItemName) : entry);
    return [
        baseNodeType,
        {
            ...variantSpec,
            props: {
                ...variantSpec.props,
                content: {
                    ...content,
                    items: resolvedItems
                }
            }
        }
    ];
};
function $2895c23f45401805$export$a49afc9edc88765c(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys((0, $6DuaV.specs)).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...(0, $6DuaV.specs)[k]
        };
        if ($2895c23f45401805$var$isVariant(spec)) {
            // Their override content items are variant names, which match no child by type, so resolve
            // them one level or valid content gets wrapped as `unsupportedBlock`. For non-panel variants
            // like `mediaSingle_full` the names are already plain, so this is a no-op.
            const resolved = $2895c23f45401805$var$resolveVariantOverrideContentItems([
                spec[0],
                spec[1]
            ]);
            spec = {
                ...spec,
                1: resolved[1]
            };
        }
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $7sgLM.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = (0, $6DuaV.specs)[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items.map((item)=>(0, $7sgLM.isString)(item) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray((0, $6DuaV.specs)[item]) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (0, $6DuaV.specs)[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>{
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const resolved = (0, $6DuaV.specs)[subItem];
                        if (Array.isArray(resolved)) // Resolve the variant tuple's own override content names so a nested match works.
                        return $2895c23f45401805$var$resolveVariantOverrideContentItems(resolved);
                        // Now `NoMark` produces `items: []`, should be fixed in generator
                        return (0, $7sgLM.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ];
                    })// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$1$props;
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                // Only a variant tuple carries an override spec to read; `['text', spec]` above
                                // builds the same shape, so both are covered.
                                const overrideItems = $2895c23f45401805$var$isVariant(subItem) ? (_subItem$1$props = subItem[1].props) === null || _subItem$1$props === void 0 || (_subItem$1$props = _subItem$1$props.content) === null || _subItem$1$props === void 0 ? void 0 : _subItem$1$props.items : undefined;
                                // The node-list check below only holds when the override lists child node names. A
                                // nested `$or` list (`string[][]`, as `panel_c1` has) never matches, which would
                                // drop the variant entirely, so keep it and validate its children recursively.
                                const overrideListsChildNodeNames = Array.isArray(overrideItems) && overrideItems.every((item)=>typeof item === 'string');
                                if (isMainNodeSupported && overrideListsChildNodeNames) return overrideItems.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
        * TODO: Probably try something like immer, but it's 3.3kb gzipped.
        * Not worth it just for this.
        */ [
                            subItem[0],
                            $2895c23f45401805$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2895c23f45401805$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $2895c23f45401805$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $2895c23f45401805$export$66c739158ef99a42(spec, value) {
    if (!(0, $5dQm8.isDefined)(value)) return !!spec.optional;
    if ($2895c23f45401805$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $2895c23f45401805$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $2895c23f45401805$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $5dQm8.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $kWsvl.isBoolean)(value);
        case 'number':
            return (0, $f1zLf.isNumber)(value) && ((0, $5dQm8.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $5dQm8.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $gOADJ.isInteger)(value) && ((0, $5dQm8.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $5dQm8.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $5dQm8.isDefined)((0, $5ajqD.validatorFnMap)[rule]) && (0, $5ajqD.validatorFnMap)[rule](value);
            return (0, $7sgLM.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $5dQm8.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $5dQm8.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $6wTws.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$2895c23f45401805$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$2895c23f45401805$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $7sgLM.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $2895c23f45401805$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $2895c23f45401805$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $2895c23f45401805$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $2895c23f45401805$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else {
        var _parentSpec$props;
        return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message,
            meta: {
                parentType: parentSpec === null || parentSpec === void 0 || (_parentSpec$props = parentSpec.props) === null || _parentSpec$props === void 0 || (_parentSpec$props = _parentSpec$props.type) === null || _parentSpec$props === void 0 ? void 0 : _parentSpec$props.values[0]
            }
        }, $2895c23f45401805$var$getUnsupportedOptions(parentSpec));
    }
};
const $2895c23f45401805$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $2895c23f45401805$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $2895c23f45401805$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Copies the containers that validation writes to, keeping the caller's document read-only.
 *
 * Repairing unsupported content mutates the entity in place: `wrapUnSupportedNodeAttributes` deletes
 * keys from `attrs` and appends an `unsupportedNodeAttribute` mark to `marks`. A plain spread shares
 * both containers with the input, so those writes would escape into the caller's document and the
 * candidate-spec retry would re-validate an already-emptied `attrs`.
 *
 * Only `attrs` and `marks` need copying; nothing writes below that level.
 */ const $2895c23f45401805$var$cloneEntityForValidation = (entity)=>{
    const clone = {
        ...entity
    };
    if (entity.attrs) clone.attrs = {
        ...entity.attrs
    };
    if (entity.marks) clone.marks = entity.marks.map((mark)=>({
            ...mark
        }));
    return clone;
};
function $2895c23f45401805$export$956325f45c5d174a(nodes, marks, options = {}) {
    const { allowPrivateAttributes: allowPrivateAttributes, mode: mode = 'strict', stage0: stage0 } = options;
    // Whether specs that only exist in the stage-0 schema are declined for this caller.
    const rejectStage0Specs = !stage0;
    // Whether an empty `marks` array is dropped from a node that only ever takes an empty one. Resolved
    // once for the same reasons as above. Gate off keeps such a node rejected.
    const acceptEmptyMarks = (0, $dRkX9.fg)('platform_editor_adf_validator_empty_marks');
    const validatorSpecs = $2895c23f45401805$export$a49afc9edc88765c(nodes, marks);
    // `extractAllowedContent` scans all of `validatorSpecs` for one node type's candidates, and
    // `validate` calls it per node. It depends only on `validatorSpecs` — fixed once
    // `applyVariantSpecOverrides` has run — and `entity.type`, so it caches per type. Sharing one array
    // across nodes of a type is safe: `getOptionsForType` only iterates it, and the specs inside were
    // already shared via `validatorSpecs`.
    const allowedContentByType = new Map();
    const getAllowedContent = (entity)=>{
        const { type: type } = entity;
        if (typeof type !== 'string') return (0, $f1Tcf.extractAllowedContent)(validatorSpecs, entity);
        let allowedContent = allowedContentByType.get(type);
        if (allowedContent === undefined) {
            allowedContent = (0, $f1Tcf.extractAllowedContent)(validatorSpecs, entity);
            allowedContentByType.set(type, allowedContent);
        }
        return allowedContent;
    };
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of getAllowedContent(entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = $2895c23f45401805$var$cloneEntityForValidation(entity);
        const err = (code, msg, meta)=>{
            const message = $2895c23f45401805$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $2895c23f45401805$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            var _typeOptions$meta;
            const typeOptions = $2895c23f45401805$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            // A spec carrying `meta.stage0` exists only in the stage-0 schema. It reaches here as the
            // candidate the parent offers for this entity, so declining the candidate lets the caller's
            // candidate loop fall through to the next spec, normally the base one. Reading the flag from
            // `parentSpec` would reject the entity's own children and marks instead, emptying a node that
            // matches a stage-0 variant.
            //
            // The rule is partial, and errs towards accepting: `typeOptions` carries variant
            // candidates only, so a stage-0-only base node such as `extensionFrame` reaches here with
            // `{}` and is accepted; `applyVariantSpecOverrides` copies a variant's `props` onto its base
            // without `meta`; and `withoutStage0Meta` clears the flag from variants that also carry
            // `breakout`. Also reading `validatorSpecs[type].meta` would cover the base-node case, but
            // only holds while the generator flags stage-0-only specs and nothing else.
            if (rejectStage0Specs && (_typeOptions$meta = typeOptions.meta) !== null && _typeOptions$meta !== void 0 && _typeOptions$meta.stage0) return {
                valid: false
            };
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    /**
   * Whether the node declares a `marks` property that no mark type may go into, which ADF spells as
   * `marks: { type: 'array', maxItems: 0 }` — `paragraph`, `heading`, `extension` and `codeBlock` all
   * do. An empty array is then the property's only legal value, so it says nothing about the node and
   * carries nothing to reject.
   *
   * The declaration is read off the BASE spec, not the candidate the parent offered. A variant only
   * ever widens the mark types (`extension_with_marks` adds `dataConsumer` and `fragment`), which
   * cannot make the empty list illegal. Reading the candidate instead would leave a root `extension`
   * out, since `doc` offers it as `extension_with_marks`.
   *
   * A node with no `marks` property at all (`rule`, `panel`, `mediaGroup`) is excluded: for those,
   * `marks` is a property ADF does not define, so an empty array is still redundant.
   */ function declaresEmptyMarksOnly(baseSpec) {
        var _baseSpec$props;
        return !!((_baseSpec$props = baseSpec.props) !== null && _baseSpec$props !== void 0 && _baseSpec$props.marks) && allowedMarksFor(baseSpec).length === 0;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $2895c23f45401805$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        // Attribute validation may have already put an `unsupportedNodeAttribute` mark on `newEntity`.
        // It is not in `prevEntity.marks`, so rebuilding from those alone loses the only record of the
        // unknown attribute. The check above only covers the mark being on the original entity, which
        // held while the validated entity still aliased the caller's marks array.
        const prevMarkTypes = new Set(currentMarks.map((mark)=>mark.type));
        const synthesizedMarks = (newEntity.marks ?? []).filter((mark)=>!prevMarkTypes.has(mark.type));
        const allMarks = newMarks.concat(synthesizedMarks);
        if (allMarks.length) {
            newEntity.marks = allMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $5dQm8.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $5dQm8.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$2895c23f45401805$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $5dQm8.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $5dQm8.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $4BDl4.makeArray)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $2895c23f45401805$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $2895c23f45401805$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $2895c23f45401805$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $2895c23f45401805$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $2895c23f45401805$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $2895c23f45401805$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $2895c23f45401805$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $2895c23f45401805$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $5dQm8.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $a4iAO.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $2895c23f45401805$var$partitionObject(validatorSpec.props, (k, v)=>{
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $5dQm8.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $2895c23f45401805$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            // `marksValidationOutput` is derived from the ORIGINAL marks, so it omits marks
                            // synthesized during validation. The `unsupportedNodeAttribute` mark is one of those
                            // and is the only record of an unknown attribute, so rebuilding from the output alone
                            // destroys it. This survived by accident before entities were deep-cloned.
                            const validatedMarkTypes = new Set(marksValidationOutput.map((markResult)=>{
                                var _markResult$originalM;
                                return (_markResult$originalM = markResult.originalMark) === null || _markResult$originalM === void 0 ? void 0 : _markResult$originalM.type;
                            }));
                            const synthesizedMarks = childEntity.marks.filter((mark)=>!validatedMarkTypes.has(mark.type));
                            const allMarks = finalMarks.concat(synthesizedMarks);
                            if (allMarks.length) childEntity.marks = allMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $4BDl4.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $4BDl4.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $2895c23f45401805$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $2895c23f45401805$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) {
            // An empty array on a node that only ever takes an empty array is dropped rather than
            // validated. Mark validation has nothing to reject in it, so it reports the node valid with an
            // empty `marksValidationOutput`, which reads to the parent's `validateChildMarks` as every
            // mark on the child having been rejected, and the candidate spec gets declined.
            if (acceptEmptyMarks && prevEntity.marks.length === 0 && declaresEmptyMarksOnly(spec)) {
                delete newEntity.marks;
                return specBasedValidationResult;
            }
            return {
                hasValidated: true,
                result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
            };
        }
        return specBasedValidationResult;
    }
}

});
parcelRegister("a4iAO", function(module, exports) {
$parcel$export(module.exports, "copy", () => $fb3cfb70ec47fb89$export$784d13d8ee351f07);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fb3cfb70ec47fb89$export$784d13d8ee351f07 = (source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};

});

parcelRegister("f1Tcf", function(module, exports) {
$parcel$export(module.exports, "extractAllowedContent", () => $daf6d90a256bc8c6$export$7d2123bc001cdbf8);
function $daf6d90a256bc8c6$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($daf6d90a256bc8c6$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($daf6d90a256bc8c6$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$daf6d90a256bc8c6$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $daf6d90a256bc8c6$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}

});

parcelRegister("kWsvl", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $25dfde8a32e67023$export$f9ce7b637dfbe238);
const $25dfde8a32e67023$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';

});

parcelRegister("5dQm8", function(module, exports) {
$parcel$export(module.exports, "isDefined", () => $39efce9db4366314$export$4e62c701997796c1);
const $39efce9db4366314$export$4e62c701997796c1 = (x)=>x != null;

});

parcelRegister("gOADJ", function(module, exports) {
$parcel$export(module.exports, "isInteger", () => $2abb664345cce40a$export$a287f47fed4544b8);
const $2abb664345cce40a$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;

});

parcelRegister("f1zLf", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $21cc5fb1fdcf95b5$export$7e4aa119212bc614);
const $21cc5fb1fdcf95b5$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);

});

parcelRegister("6wTws", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $0c6f2e5ec9c60c9a$export$53b83ca8eaab0383);
const $0c6f2e5ec9c60c9a$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);

});

parcelRegister("7sgLM", function(module, exports) {
$parcel$export(module.exports, "isString", () => $d4d7dd724b562ad0$export$844ec244b1367d54);
// This is a kludge, might replace with something like _.isString in future
const $d4d7dd724b562ad0$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;

});

parcelRegister("4BDl4", function(module, exports) {
$parcel$export(module.exports, "makeArray", () => $920bc31a243efc49$export$7b85fd78dd236198);
// Helpers
const $920bc31a243efc49$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("5ajqD", function(module, exports) {
$parcel$export(module.exports, "validatorFnMap", () => $60d0843af5b178c8$export$d1b377ca77ac267d);

var $9ISAz = parcelRequire("9ISAz");
const $60d0843af5b178c8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $9ISAz.isSafeUrl)
};

});
parcelRegister("9ISAz", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $eadcaa41c06b6ac1$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $eadcaa41c06b6ac1$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $eadcaa41c06b6ac1$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $eadcaa41c06b6ac1$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};

});


parcelRegister("6DuaV", function(module, exports) {
$parcel$export(module.exports, "specs", () => $86fad0f2d2891486$export$13afbb83a3ae2576);
// This is a lookup map consumed by `createSpec`, not an entry point re-exporting the schema
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3EuDg = parcelRequire("3EuDg");
const $86fad0f2d2891486$export$13afbb83a3ae2576 = {
    alignment: $3EuDg.alignment,
    annotation: $3EuDg.annotation,
    backgroundColor: $3EuDg.backgroundColor,
    blockCard: $3EuDg.blockCard,
    blockRootOnly: $3EuDg.blockRootOnly,
    blockTaskItem: $3EuDg.blockTaskItem,
    block_content: $3EuDg.block_content,
    blockquote: $3EuDg.blockquote,
    bodiedExtension: $3EuDg.bodiedExtension,
    bodiedExtension_root_only: $3EuDg.bodiedExtension_root_only,
    bodiedExtension_with_marks: $3EuDg.bodiedExtension_with_marks,
    bodiedRule: $3EuDg.bodiedRule,
    bodiedRule_root_only: $3EuDg.bodiedRule_root_only,
    bodiedSyncBlock: $3EuDg.bodiedSyncBlock,
    border: $3EuDg.border,
    breakout: $3EuDg.breakout,
    bulletList: $3EuDg.bulletList,
    caption: $3EuDg.caption,
    code: $3EuDg.code,
    codeBlock: $3EuDg.codeBlock,
    codeBlock_root_only: $3EuDg.codeBlock_root_only,
    confluenceInlineComment: $3EuDg.confluenceInlineComment,
    dataConsumer: $3EuDg.dataConsumer,
    date: $3EuDg.date,
    decisionItem: $3EuDg.decisionItem,
    decisionList: $3EuDg.decisionList,
    doc: $3EuDg.doc,
    em: $3EuDg.em,
    embedCard: $3EuDg.embedCard,
    emoji: $3EuDg.emoji,
    expand: $3EuDg.expand,
    expand_root_only: $3EuDg.expand_root_only,
    extension: $3EuDg.extension,
    extensionFrame: $3EuDg.extensionFrame,
    extension_root_only: $3EuDg.extension_root_only,
    extension_root_only_with_annotation: $3EuDg.extension_root_only_with_annotation,
    extension_with_annotation: $3EuDg.extension_with_annotation,
    extension_with_marks: $3EuDg.extension_with_marks,
    fontSize: $3EuDg.fontSize,
    fragment: $3EuDg.fragment,
    hardBreak: $3EuDg.hardBreak,
    heading: $3EuDg.heading,
    heading_with_alignment: $3EuDg.heading_with_alignment,
    heading_with_indentation: $3EuDg.heading_with_indentation,
    heading_with_no_marks: $3EuDg.heading_with_no_marks,
    indentation: $3EuDg.indentation,
    inlineCard: $3EuDg.inlineCard,
    inlineExtension: $3EuDg.inlineExtension,
    inlineExtension_with_marks: $3EuDg.inlineExtension_with_marks,
    inline_content: $3EuDg.inline_content,
    layoutColumn: $3EuDg.layoutColumn,
    layoutSection: $3EuDg.layoutSection,
    layoutSection_full: $3EuDg.layoutSection_full,
    layoutSection_with_single_column: $3EuDg.layoutSection_with_single_column,
    link: $3EuDg.link,
    listItem: $3EuDg.listItem,
    media: $3EuDg.media,
    mediaGroup: $3EuDg.mediaGroup,
    mediaInline: $3EuDg.mediaInline,
    mediaSingle: $3EuDg.mediaSingle,
    mediaSingle_caption: $3EuDg.mediaSingle_caption,
    mediaSingle_full: $3EuDg.mediaSingle_full,
    mention: $3EuDg.mention,
    multiBodiedExtension: $3EuDg.multiBodiedExtension,
    multiBodiedExtension_root_only: $3EuDg.multiBodiedExtension_root_only,
    nestedExpand: $3EuDg.nestedExpand,
    nestedExpand_content: $3EuDg.nestedExpand_content,
    nestedExpand_with_no_marks: $3EuDg.nestedExpand_with_no_marks,
    non_nestable_block_content: $3EuDg.non_nestable_block_content,
    orderedList: $3EuDg.orderedList,
    panel: $3EuDg.panel,
    panel_c1: $3EuDg.panel_c1,
    panel_c1_root_only: $3EuDg.panel_c1_root_only,
    panel_root_only: $3EuDg.panel_root_only,
    paragraph: $3EuDg.paragraph,
    paragraph_with_alignment: $3EuDg.paragraph_with_alignment,
    paragraph_with_font_size: $3EuDg.paragraph_with_font_size,
    paragraph_with_indentation: $3EuDg.paragraph_with_indentation,
    paragraph_with_no_marks: $3EuDg.paragraph_with_no_marks,
    placeholder: $3EuDg.placeholder,
    rule: $3EuDg.rule,
    rule_root_only: $3EuDg.rule_root_only,
    rule_with_attrs: $3EuDg.rule_with_attrs,
    rule_with_attrs_root_only: $3EuDg.rule_with_attrs_root_only,
    status: $3EuDg.status,
    strike: $3EuDg.strike,
    strong: $3EuDg.strong,
    subsup: $3EuDg.subsup,
    syncBlock: $3EuDg.syncBlock,
    table: $3EuDg.table,
    tableCell: $3EuDg.tableCell,
    tableHeader: $3EuDg.tableHeader,
    tableRow: $3EuDg.tableRow,
    taskItem: $3EuDg.taskItem,
    taskList: $3EuDg.taskList,
    text: $3EuDg.text,
    textColor: $3EuDg.textColor,
    text_code_inline: $3EuDg.text_code_inline,
    text_formatted: $3EuDg.text_formatted,
    text_link_inline: $3EuDg.text_link_inline,
    text_with_no_marks: $3EuDg.text_with_no_marks,
    underline: $3EuDg.underline
};

});
parcelRegister("3EuDg", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $ef5d9b9ce1f8572d$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $ef5d9b9ce1f8572d$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $ef5d9b9ce1f8572d$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $ef5d9b9ce1f8572d$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $ef5d9b9ce1f8572d$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $ef5d9b9ce1f8572d$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $ef5d9b9ce1f8572d$export$ebb5393736e9ba23);
$parcel$export(module.exports, "blockTaskItem", () => $ef5d9b9ce1f8572d$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $ef5d9b9ce1f8572d$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_root_only", () => $ef5d9b9ce1f8572d$export$b7a532f6e202d8ea);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $ef5d9b9ce1f8572d$export$ee052cc5b2356e83);
$parcel$export(module.exports, "bodiedRule", () => $ef5d9b9ce1f8572d$export$2069efcbff2f0292);
$parcel$export(module.exports, "bodiedRule_root_only", () => $ef5d9b9ce1f8572d$export$ab41d73148acae83);
$parcel$export(module.exports, "bodiedSyncBlock", () => $ef5d9b9ce1f8572d$export$e92c7e4302dd4371);
$parcel$export(module.exports, "border", () => $ef5d9b9ce1f8572d$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $ef5d9b9ce1f8572d$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $ef5d9b9ce1f8572d$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $ef5d9b9ce1f8572d$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $ef5d9b9ce1f8572d$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $ef5d9b9ce1f8572d$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $ef5d9b9ce1f8572d$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $ef5d9b9ce1f8572d$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $ef5d9b9ce1f8572d$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $ef5d9b9ce1f8572d$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $ef5d9b9ce1f8572d$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $ef5d9b9ce1f8572d$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $ef5d9b9ce1f8572d$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $ef5d9b9ce1f8572d$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $ef5d9b9ce1f8572d$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $ef5d9b9ce1f8572d$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $ef5d9b9ce1f8572d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $ef5d9b9ce1f8572d$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $ef5d9b9ce1f8572d$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_root_only", () => $ef5d9b9ce1f8572d$export$8eba3df128e25335);
$parcel$export(module.exports, "extension_root_only_with_annotation", () => $ef5d9b9ce1f8572d$export$9dccb771264f1ee3);
$parcel$export(module.exports, "extension_with_annotation", () => $ef5d9b9ce1f8572d$export$a3b88288627564ec);
$parcel$export(module.exports, "extension_with_marks", () => $ef5d9b9ce1f8572d$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $ef5d9b9ce1f8572d$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fontSize", () => $ef5d9b9ce1f8572d$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $ef5d9b9ce1f8572d$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $ef5d9b9ce1f8572d$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $ef5d9b9ce1f8572d$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $ef5d9b9ce1f8572d$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $ef5d9b9ce1f8572d$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $ef5d9b9ce1f8572d$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $ef5d9b9ce1f8572d$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $ef5d9b9ce1f8572d$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $ef5d9b9ce1f8572d$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $ef5d9b9ce1f8572d$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $ef5d9b9ce1f8572d$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $ef5d9b9ce1f8572d$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $ef5d9b9ce1f8572d$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $ef5d9b9ce1f8572d$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $ef5d9b9ce1f8572d$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $ef5d9b9ce1f8572d$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $ef5d9b9ce1f8572d$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $ef5d9b9ce1f8572d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $ef5d9b9ce1f8572d$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $ef5d9b9ce1f8572d$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $ef5d9b9ce1f8572d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $ef5d9b9ce1f8572d$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $ef5d9b9ce1f8572d$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $ef5d9b9ce1f8572d$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $ef5d9b9ce1f8572d$export$c3c04d555a8b9013);
$parcel$export(module.exports, "multiBodiedExtension_root_only", () => $ef5d9b9ce1f8572d$export$78421d8497ebdea6);
$parcel$export(module.exports, "nestedExpand", () => $ef5d9b9ce1f8572d$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $ef5d9b9ce1f8572d$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $ef5d9b9ce1f8572d$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $ef5d9b9ce1f8572d$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $ef5d9b9ce1f8572d$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $ef5d9b9ce1f8572d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panel_c1", () => $ef5d9b9ce1f8572d$export$a08c7bcc7e61d424);
$parcel$export(module.exports, "panel_c1_root_only", () => $ef5d9b9ce1f8572d$export$76e58fb94da2bf88);
$parcel$export(module.exports, "panel_root_only", () => $ef5d9b9ce1f8572d$export$9388c8efa26ea154);
$parcel$export(module.exports, "paragraph", () => $ef5d9b9ce1f8572d$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $ef5d9b9ce1f8572d$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_font_size", () => $ef5d9b9ce1f8572d$export$f745a1f9fa5e1ca8);
$parcel$export(module.exports, "paragraph_with_indentation", () => $ef5d9b9ce1f8572d$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $ef5d9b9ce1f8572d$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $ef5d9b9ce1f8572d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $ef5d9b9ce1f8572d$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "rule_root_only", () => $ef5d9b9ce1f8572d$export$5bc14ade5ae67510);
$parcel$export(module.exports, "rule_with_attrs", () => $ef5d9b9ce1f8572d$export$74942eaebdd7ffe);
$parcel$export(module.exports, "rule_with_attrs_root_only", () => $ef5d9b9ce1f8572d$export$b64c73d0ec95c7d3);
$parcel$export(module.exports, "status", () => $ef5d9b9ce1f8572d$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $ef5d9b9ce1f8572d$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $ef5d9b9ce1f8572d$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $ef5d9b9ce1f8572d$export$b3401ee80eb31041);
$parcel$export(module.exports, "syncBlock", () => $ef5d9b9ce1f8572d$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $ef5d9b9ce1f8572d$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $ef5d9b9ce1f8572d$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $ef5d9b9ce1f8572d$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $ef5d9b9ce1f8572d$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $ef5d9b9ce1f8572d$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $ef5d9b9ce1f8572d$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $ef5d9b9ce1f8572d$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $ef5d9b9ce1f8572d$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $ef5d9b9ce1f8572d$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $ef5d9b9ce1f8572d$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $ef5d9b9ce1f8572d$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $ef5d9b9ce1f8572d$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $ef5d9b9ce1f8572d$export$425327af25286e5e);
const $ef5d9b9ce1f8572d$export$8e53000a4ec837 = {
    props: {
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$8512c9afa7b24c3b = {
    props: {
        attrs: {
            props: {
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                },
                id: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$8c5a050822fd698c = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule_with_attrs',
    'rule',
    'bodiedRule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'extension_with_annotation',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $ef5d9b9ce1f8572d$export$c4c2f833baaebdb8 = {
    props: {
        attrs: [
            {
                props: {
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    layout: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        optional: true,
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $ef5d9b9ce1f8572d$export$67dc04e652a298ca = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $ef5d9b9ce1f8572d$export$16018c61064a18df = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks',
                    'extension_with_annotation'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$27903d543b563e39 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$b7a532f6e202d8ea = [
    'bodiedExtension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$2069efcbff2f0292 = {
    meta: {
        stage0: true
    },
    props: {
        attrs: {
            props: {
                alignment: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'start',
                        'center',
                        'end'
                    ]
                },
                color: {
                    optional: true,
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'solid',
                        'dashed',
                        'dotted',
                        'sketch',
                        'fade'
                    ]
                },
                weight: {
                    maximum: 3,
                    minimum: 1,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks'
                ]
            ],
            maxItems: 1,
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedRule'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$ab41d73148acae83 = [
    'bodiedRule',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$e92c7e4302dd4371 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel_c1',
                    'panel',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$1edee58a52776cd9 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                size: {
                    maximum: 3,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$89015c65f1c75e3f = {
    props: {
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$a140c94e5ea26bee = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$8e3c2dfdc4f0453d = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$7bb0d5c671655cc4 = {
    props: {
        attrs: {
            optional: true,
            props: {
                hideLineNumbers: {
                    optional: true,
                    type: 'boolean'
                },
                language: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                uniqueId: {
                    optional: true,
                    type: 'string'
                },
                wrap: {
                    optional: true,
                    type: 'boolean'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            maxItems: 0,
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$f3b72f8fc4684ecd = {
    props: {
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$3024f02c495408d6 = {
    props: {
        attrs: {
            props: {
                sources: {
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1,
                    type: 'array'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$324d90190a8b822a = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$6959e16eeff859b4 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$62d45a65fb43d95e = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'decisionItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$2a111da947c407d2 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'panel_c1',
                    'rule_with_attrs_root_only',
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'panel_root_only',
                    'panel_c1_root_only',
                    'rule_root_only',
                    'bodiedRule_root_only',
                    'extension_root_only',
                    'extension_root_only_with_annotation',
                    'bodiedExtension_root_only',
                    'multiBodiedExtension_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$be4283d9a1cb1ff6 = {
    props: {
        attrs: {
            props: {
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                originalHeight: {
                    optional: true,
                    type: 'number'
                },
                originalWidth: {
                    optional: true,
                    type: 'number'
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$a19185d1233fc4b2 = {
    props: {
        attrs: {
            props: {
                id: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$9f77e0932fb78f72 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            maxItems: 0,
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$1b45514b112dd749 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$8eba3df128e25335 = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$9dccb771264f1ee3 = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'annotation',
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$a3b88288627564ec = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'annotation',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$4fdcae991fd743e7 = {
    meta: {
        stage0: true
    },
    props: {
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$85e3c3ca0c6fb93 = {
    props: {
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$f00aeb236b6f05af = {
    props: {
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$371da9dd35aba193 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'enum',
                    values: [
                        '\n'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$46e4a324ac90507f = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                },
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'alignment'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'indentation'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$480c699bd4ec0d86 = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $ef5d9b9ce1f8572d$export$cbf8224b64e0d942 = {
    props: {
        attrs: [
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $ef5d9b9ce1f8572d$export$16b353b2649bd8d9 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$ab76e7c03cd6f650 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'panel_c1',
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$b3b6a70a7fa4a5be = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'layoutColumn'
            ],
            maxItems: 3,
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 3,
                minItems: 2,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$e0e9834198e8601d = [
    'layoutSection',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    columnRuleStyle: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            },
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 5,
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$9c30223ca0a664fb = {
    props: {
        attrs: {
            props: {
                collection: {
                    optional: true,
                    type: 'string'
                },
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                id: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$76c7e83ecc9cdf05 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$987d49ffe1b0900f = {
    props: {
        attrs: [
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            }
        ],
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $ef5d9b9ce1f8572d$export$2855e964765eac9 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                'media'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$38bab695e3f720f1 = {
    props: {
        attrs: {
            props: {
                alt: {
                    optional: true,
                    type: 'string'
                },
                collection: {
                    type: 'string'
                },
                data: {
                    optional: true,
                    type: 'object'
                },
                height: {
                    optional: true,
                    type: 'number'
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                type: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ]
                },
                url: {
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$969fe3781ca15058 = {
    props: {
        attrs: [
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        maximum: 100,
                        minimum: 0,
                        optional: true,
                        type: 'number'
                    },
                    widthType: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'percentage'
                        ]
                    }
                }
            },
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        minimum: 0,
                        type: 'number'
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    }
                }
            }
        ],
        marks: {
            items: [
                'link'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                maxItems: 2,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$db83999c14438df4 = {
    props: {
        attrs: {
            props: {
                accessLevel: {
                    optional: true,
                    type: 'string'
                },
                id: {
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                },
                userType: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ]
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$c3c04d555a8b9013 = {
    meta: {
        stage0: true
    },
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'extensionFrame'
            ],
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$78421d8497ebdea6 = [
    'multiBodiedExtension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$63cadbf5f4296627 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: 'nestedExpand_content',
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $ef5d9b9ce1f8572d$export$9584f52f3ebd5d7e = {
    allowUnsupportedBlock: true,
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule_with_attrs',
            'rule',
            'bodiedRule',
            'panel',
            'blockquote',
            'extension_with_marks',
            'extension_with_annotation'
        ]
    ],
    minItems: 1,
    type: 'array'
};
const $ef5d9b9ce1f8572d$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule_with_attrs',
    'rule',
    'bodiedRule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $ef5d9b9ce1f8572d$export$a5dc81035676e7a = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                order: {
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$21f42ab9b6679f44 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                panelColor: {
                    optional: true,
                    type: 'string'
                },
                panelIcon: {
                    optional: true,
                    type: 'string'
                },
                panelIconId: {
                    optional: true,
                    type: 'string'
                },
                panelIconText: {
                    optional: true,
                    type: 'string'
                },
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'decisionList',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$a08c7bcc7e61d424 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule_with_attrs',
                        'rule',
                        'bodiedRule',
                        'decisionList',
                        'extension_with_marks',
                        'extension_with_annotation',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$76e58fb94da2bf88 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule_with_attrs',
                        'rule',
                        'bodiedRule',
                        'decisionList',
                        'extension_with_marks',
                        'extension_with_annotation',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$9388c8efa26ea154 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$9c206ddddb32a9b = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    'fontSize'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$c7187bbd1a7a9244 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$fbeb3a3956e8a3c7 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$5bc14ade5ae67510 = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$74942eaebdd7ffe = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    color: {
                        optional: true,
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    style: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid',
                            'dashed',
                            'dotted',
                            'sketch',
                            'fade'
                        ]
                    },
                    weight: {
                        maximum: 3,
                        minimum: 1,
                        optional: true,
                        type: 'number'
                    }
                }
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$b64c73d0ec95c7d3 = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    color: {
                        optional: true,
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    style: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid',
                            'dashed',
                            'dotted',
                            'sketch',
                            'fade'
                        ]
                    },
                    weight: {
                        maximum: 3,
                        minimum: 1,
                        optional: true,
                        type: 'number'
                    }
                }
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$471f7ae5c4103ae1 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^(neutral|purple|blue|red|yellow|green|#[0-9a-fA-F]{6})$',
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$b3401ee80eb31041 = {
    props: {
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$faab0ca9701d7048 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$9852986a3ec5f6a0 = {
    props: {
        attrs: {
            optional: true,
            props: {
                displayMode: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ]
                },
                isNumberColumnEnabled: {
                    optional: true,
                    type: 'boolean'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'tableRow'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'fragment'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$e1e720e5f4603e6a = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $ef5d9b9ce1f8572d$export$48884d2a5190dc73 = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule_with_attrs',
                    'rule',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $ef5d9b9ce1f8572d$export$ce666bf02318c957 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$6d8b0ef52e2e6390 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$375b6afcc5f4d291 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$6f093cfa640b7166 = {
    props: {
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        text: {
            minLength: 1,
            type: 'string'
        },
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    'link'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $ef5d9b9ce1f8572d$export$32f78bffcd82ff28 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        }
    }
};
const $ef5d9b9ce1f8572d$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});





parcelRegister("iphBT", function(module, exports) {
$parcel$export(module.exports, "validateUserPickerSetValue", () => $50928a45a28b0f8e$export$3dc07da29c05fcd);
$parcel$export(module.exports, "userPickerSetValueTransformer", () => $50928a45a28b0f8e$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerPortalSetValueTransformer", () => $50928a45a28b0f8e$export$ff5e806e6042411b);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $50928a45a28b0f8e$export$e87b0f36be178543);
$parcel$export(module.exports, "modifyUserPickerValueToBasic", () => $50928a45a28b0f8e$export$ef961f8b571be395);

var $aIVqJ = parcelRequire("aIVqJ");

var $c0Y6o = parcelRequire("c0Y6o");

var $diqlM = parcelRequire("diqlM");

var $c8dk3 = parcelRequire("c8dk3");

var $1RhjL = parcelRequire("1RhjL");

var $jXSiw = parcelRequire("jXSiw");
/**
 * Finds a user in the lookup data by their account ID.
 *
 * @param lookupData - Array of users to search through
 * @param accountId - The account ID to search for
 * @returns The matching user object or null if not found
 */ const $50928a45a28b0f8e$var$findUserLookupValue = (lookupData, accountId)=>{
    if (!lookupData || !Array.isArray(lookupData)) return null;
    return lookupData.find((user)=>user.accountId === accountId) || null;
};
const $50928a45a28b0f8e$export$3dc07da29c05fcd = (value)=>value === null || (0, $jXSiw.isNotEmptyString)(value) && (0, $1RhjL.isNotAutomaticId)(value);
const $50928a45a28b0f8e$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundUser = $50928a45a28b0f8e$var$findUserLookupValue(lookupValues || [], value);
    if (!foundUser) throw new (0, $c8dk3.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    return {
        label: foundUser.name,
        email: '',
        iconUrl: foundUser.picture,
        accountId: foundUser.accountId,
        value: foundUser.accountId
    };
};
const $50928a45a28b0f8e$export$f2798b13cb02e004 = (fieldContext)=>{
    var _fieldContext$extraDa;
    const fieldConfigId = fieldContext === null || fieldContext === void 0 || (_fieldContext$extraDa = fieldContext.extraData) === null || _fieldContext$extraDa === void 0 ? void 0 : _fieldContext$extraDa.fieldConfigId;
    return typeof fieldConfigId === 'string' && fieldConfigId ? {
        fieldConfigId: fieldConfigId
    } : {};
};
const $50928a45a28b0f8e$export$ff5e806e6042411b = async (value, _lookupValues, transformerContext)=>{
    var _transformerContext$e, _transformerContext$f;
    if (value === null) return null;
    const portalId = transformerContext === null || transformerContext === void 0 || (_transformerContext$e = transformerContext.executionContext) === null || _transformerContext$e === void 0 || (_transformerContext$e = _transformerContext$e.portal) === null || _transformerContext$e === void 0 ? void 0 : _transformerContext$e.id;
    const fieldName = transformerContext === null || transformerContext === void 0 || (_transformerContext$f = transformerContext.fieldContext) === null || _transformerContext$f === void 0 ? void 0 : _transformerContext$f.fieldId;
    if (!portalId || !fieldName) throw new (0, $c8dk3.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    const searchParams = new URLSearchParams({
        fieldName: fieldName,
        query: value
    });
    // The field's configuration applies its user filter (groups or project roles), so the
    // search only returns users the Portal picker would offer
    const { fieldConfigId: fieldConfigId } = $50928a45a28b0f8e$export$f2798b13cb02e004(transformerContext === null || transformerContext === void 0 ? void 0 : transformerContext.fieldContext);
    if (fieldConfigId) searchParams.append('fieldConfigId', fieldConfigId);
    const queryString = searchParams.toString();
    const uri = `${(0, $diqlM.contextPath)}/rest/servicedesk/1/customer/portal/${portalId}/user-search?${queryString}`;
    let users;
    try {
        users = await (0, $c0Y6o.fetchJson)(uri, {
            method: 'GET'
        });
    } catch (error) {
        (0, $aIVqJ.trackError)('finduser.fetch.failed', {}, error instanceof Error ? error : undefined);
        throw error;
    }
    // The search matches on more than the account ID, so only an exact match counts
    const foundUser = Array.isArray(users) ? users.find((user)=>user.accountId === value) : undefined;
    if (!foundUser) throw new (0, $c8dk3.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    return {
        label: foundUser.displayName,
        email: foundUser.emailAddress ?? '',
        iconUrl: foundUser.avatar,
        accountId: foundUser.accountId,
        value: foundUser.accountId
    };
};
const $50928a45a28b0f8e$export$e87b0f36be178543 = (value)=>{
    if (!value || !value.accountId) return null;
    return {
        accountId: value.accountId
    };
};
const $50928a45a28b0f8e$export$ef961f8b571be395 = (value)=>{
    if (!value) return null;
    return value.accountId;
};

});
parcelRegister("1RhjL", function(module, exports) {
$parcel$export(module.exports, "isNotAutomaticId", () => $fded352e8b0efe70$export$ab4c3a3c49d7add);

var $87Mi2 = parcelRequire("87Mi2");
const $fded352e8b0efe70$export$ab4c3a3c49d7add = (value)=>value !== (0, $87Mi2.AUTOMATIC_ID);

});


parcelRegister("7WEla", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d2e26b9ba95450e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var // TODO: to be refined in https://ecosystem-platform.atlassian.net/browse/UIM-2463
$3d2e26b9ba95450e$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    obligatoryUimRequestCreateConsentMessage: {
        id: 'ui-modifications-fields-configuration.common.utils.views.request-create.obligatory-uim-request-create-consent-message',
        defaultMessage: 'You must allow "{appTitle}" to access your Atlassian products to create this work item.',
        description: 'When a user opens a context the first time, we require that they give consent for their data otherwise they cannot get the UIM`s applied'
    }
});

});

parcelRegister("jG9r8", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $cf69341480d2507e$export$973aead813665e25);

var $79bzZ = parcelRequire("79bzZ");
const $cf69341480d2507e$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $cf69341480d2507e$export$973aead813665e25 = (optionsVisibility)=>(0, $79bzZ.validateSetOptionsVisibilityRule)(optionsVisibility) && $cf69341480d2507e$export$914c7f5212c4c649(optionsVisibility);

});



parcelRegister("173qD", function(module, exports) {
$parcel$export(module.exports, "portalReorderRoute", () => $dc3dc31bbabba57e$export$f321c3c48e8f4288);
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");

var $80yPZ = parcelRequire("80yPZ");

var $bGHjz = parcelRequire("bGHjz");
const $dc3dc31bbabba57e$export$f321c3c48e8f4288 = (shouldLoadHelpEditTopicsResource = false)=>{
    const resources = [];
    if (shouldLoadHelpEditTopicsResource) resources.push((0, $bGHjz.helpEditTopicsResource));
    resources.push((0, $bGHjz.hiddenSectionWarningResource));
    return {
        resources: resources,
        path: '/settings/portal-reorder',
        exact: true,
        component: (0, $7tc2B.withRouter)((0, $80yPZ.PortalReorderingRoute)),
        name: 'portal-reorder'
    };
};

});
parcelRegister("80yPZ", function(module, exports) {
$parcel$export(module.exports, "PortalReorderingRoute", () => $8b4c06c50e8e4756$export$d8bb1160246519d9);
$parcel$export(module.exports, "callToActionUrlText", () => $8b4c06c50e8e4756$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $8b4c06c50e8e4756$export$5342e2a00fe6d647);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $9mazR = parcelRequire("9mazR");

var $bQkfB = parcelRequire("bQkfB");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");
parcelRequire("kEool");
var $dRMig = parcelRequire("dRMig");

var $8wJ98 = parcelRequire("8wJ98");
parcelRequire("1bkQS");
var $bAkWS = parcelRequire("bAkWS");

const $8b4c06c50e8e4756$export$73a0508c941788d6 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("373cy")), {
        moduleId: "./src/view/portal-reorder-experience/hocs.tsx"
    }),
    LoadingSkeleton: (0, $bAkWS.default),
    loadingPosition: 'fill-container'
});
const $8b4c06c50e8e4756$var$PORTAL_REORDERING_PATH = '/settings/portal-reorder';
const $8b4c06c50e8e4756$export$d8bb1160246519d9 = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: $8b4c06c50e8e4756$var$PORTAL_REORDERING_PATH
    }), (0, $aylSc.default)({
        message: formatMessage((0, $8wJ98.default).authPageMessage),
        callToActionText: formatMessage((0, $8wJ98.default).callToActionUrlText),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dRMig.default), {
            path: $8b4c06c50e8e4756$var$PORTAL_REORDERING_PATH,
            component: $8b4c06c50e8e4756$export$73a0508c941788d6,
            screenName: (0, $9mazR.ScreenName).PORTAL_REORDER_SETTINGS
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
$8b4c06c50e8e4756$export$d8bb1160246519d9.displayName = 'PortalReorderingRoute';
const $8b4c06c50e8e4756$export$d96795d242b62963 = (0, $8wJ98.default).callToActionUrlText;
const $8b4c06c50e8e4756$export$5342e2a00fe6d647 = (0, $8wJ98.default).authPageMessage;

});
parcelRegister("4WWde", function(module, exports) {
$parcel$export(module.exports, "withOnlyJiraAdmin", () => (parcelRequire("aylSc")).default);

var $aylSc = parcelRequire("aylSc");

});
parcelRegister("aylSc", function(module, exports) {
$parcel$export(module.exports, "default", () => $18292d90a91b8bc3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $9mazR = parcelRequire("9mazR");

var $9J2wU = parcelRequire("9J2wU");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("imh0G");
var $d041D = parcelRequire("d041D");
const $18292d90a91b8bc3$var$selector = (0, $2n2bS.createSelector)((0, $7RWiC.getCanAdministerJIRA), (canAdministerJira)=>({
        canAdministerJira: canAdministerJira
    }));
const $18292d90a91b8bc3$var$connector = (0, $6umft.default)($18292d90a91b8bc3$var$selector, null);
const $18292d90a91b8bc3$var$withOnlyJiraAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { canAdministerJira: canAdministerJira } = props;
            if (canAdministerJira) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $fc4bM.createElement((0, $d041D.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $fc4bM.createElement((0, $9J2wU.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $9mazR.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $18292d90a91b8bc3$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyJiraAdmin';
        return ConnectedComponent;
    };
var $18292d90a91b8bc3$export$2e2bcd8739ae039 = $18292d90a91b8bc3$var$withOnlyJiraAdmin;

});


parcelRegister("hS5Dr", function(module, exports) {
$parcel$export(module.exports, "withOnlyLoggedIn", () => (parcelRequire("aEq46")).default);

var $aEq46 = parcelRequire("aEq46");

});
parcelRegister("aEq46", function(module, exports) {
$parcel$export(module.exports, "default", () => $1add356b20b94d74$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $g9ziK = parcelRequire("g9ziK");

var $gioQl = parcelRequire("gioQl");
const $1add356b20b94d74$var$selector = (0, $2n2bS.createSelector)((0, $7RWiC.isLoggedIn), (isLoggedIn)=>({
        isLoggedIn: isLoggedIn
    }));
const $1add356b20b94d74$var$connector = (0, $6umft.default)($1add356b20b94d74$var$selector, null);
const $1add356b20b94d74$var$withOnlyLoggedIn = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isLoggedIn: isLoggedIn } = props;
            if (isLoggedIn) // @ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props);
            const { redirectUrl: redirectUrl } = options;
            const loginUrl = (0, $gioQl.getLoginUrl)({
                redirectUrl: redirectUrl,
                isAbsolute: false
            });
            return /*#__PURE__*/ $fc4bM.createElement((0, $g9ziK.Redirect), {
                to: loginUrl
            });
        };
        const ConnectedComponent = $1add356b20b94d74$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyLoggedIn';
        return ConnectedComponent;
    };
var $1add356b20b94d74$export$2e2bcd8739ae039 = $1add356b20b94d74$var$withOnlyLoggedIn;

});
parcelRegister("g9ziK", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $6d6332ed238003ef$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "PushRedirectWithState", () => $6d6332ed238003ef$export$e3f5537ca0fe1626);
$parcel$export(module.exports, "PushRedirect", () => $6d6332ed238003ef$export$74676119665a0bf8);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $klylS = parcelRequire("klylS");
var $7tc2B = parcelRequire("7tc2B");
const $6d6332ed238003ef$export$2d8d895a0a0f636e = (props)=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $klylS.Redirect), props);
};
const $6d6332ed238003ef$export$e3f5537ca0fe1626 = (0, $7tc2B.withRouter)(({ history: history, to: to, state: state })=>{
    (0, $fc4bM.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to, state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        to,
        state
    ]);
    return null;
});
const $6d6332ed238003ef$export$74676119665a0bf8 = (0, $7tc2B.withRouter)(({ history: history, to: to })=>{
    (0, $fc4bM.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to);
    }, [
        history,
        to
    ]);
    return null;
});

});



parcelRegister("kEool", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("dRMig")).default);
parcelRequire("cEaLH");
var $dRMig = parcelRequire("dRMig");

});
parcelRegister("cEaLH", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("dRMig")).default);

var $dRMig = parcelRequire("dRMig");

});
parcelRegister("dRMig", function(module, exports) {
$parcel$export(module.exports, "default", () => $761f61ee85a7933d$export$2e2bcd8739ae039);
/* splash-layout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $6BtWW = parcelRequire("6BtWW");

var $6920b = parcelRequire("6920b");
parcelRequire("jEqr0");
var $gpJGQ = parcelRequire("gpJGQ");

var $babis = parcelRequire("babis");
parcelRequire("aQGvL");
var $jAOGD = parcelRequire("jAOGD");
const $761f61ee85a7933d$export$2400592c1982dcfe = ({ children: children, isFooterHidden: isFooterHidden })=>/*#__PURE__*/ $fc4bM.createElement((0, $6920b.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $6BtWW.default), null, /*#__PURE__*/ $fc4bM.createElement($761f61ee85a7933d$var$StyledContent, null, /*#__PURE__*/ $fc4bM.createElement("main", null, /*#__PURE__*/ $fc4bM.createElement((0, $gpJGQ.MainContentSkipLinkWrapper), null, children)), !isFooterHidden && /*#__PURE__*/ $fc4bM.createElement((0, $babis.StyledFooter), {
        sticky: false
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $761f61ee85a7933d$var$StyledContent = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
var $761f61ee85a7933d$export$2e2bcd8739ae039 = (0, $jAOGD.default)($761f61ee85a7933d$export$2400592c1982dcfe);

});



parcelRegister("8wJ98", function(module, exports) {
$parcel$export(module.exports, "default", () => $7065e4b6f10bac39$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7065e4b6f10bac39$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    limitErrorFlagTitle: {
        defaultMessage: "You\u2019ve already featured {limit, plural, one {# portal} other {# portals}}",
        description: 'Title of the error flag shown when the user has already featured the maximum number of portals',
        id: 'cv.portal.reordering.experience.limit.error.title.v2'
    },
    limitErrorFlagDescription: {
        defaultMessage: 'Remove a portal from the featured section to add another one.',
        description: 'Body text of the error flag shown when the user exceeds the featured portals limit',
        id: 'cv.portal.reordering.experience.limit.error.description.v2'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.text'
    },
    portalSectionHeader: {
        defaultMessage: 'Portals',
        description: 'This section divides the topic from the service desk edit section',
        id: 'cv.portal.reordering.experience.service.desk.section.header.text'
    },
    publishTopicsErrorTitle: {
        defaultMessage: "We couldn\u2019t publish your changes",
        description: 'Title of the message shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.title'
    },
    publishTopicsErrorDescription: {
        defaultMessage: 'Refresh the page and try publishing again.',
        description: 'Description of the message shown shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.description'
    },
    portalsHiddenWarningTitle: {
        defaultMessage: 'Portals are hidden from your home page',
        description: 'Warning title when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.title'
    },
    portalsHiddenWarningDescription: {
        defaultMessage: 'The portals section on your home page is hidden. Edit page layout to show portals on the home page.',
        description: 'Warning description when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.description'
    },
    editPageLayoutAction: {
        defaultMessage: 'Edit page layout',
        description: 'Action to show the portals section.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.action'
    }
});

});

parcelRegister("1bkQS", function(module, exports) {
$parcel$export(module.exports, "PortalReorderExperienceLoader", () => (parcelRequire("bAkWS")).default);

var $bAkWS = parcelRequire("bAkWS");

});
parcelRegister("bAkWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f56c4271567276ef$export$2e2bcd8739ae039);
/* portal-reorder-experience-loader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $aUHFa = parcelRequire("aUHFa");

var $aYMdQ = parcelRequire("aYMdQ");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("jHmjJ");
var $9vIkD = parcelRequire("9vIkD");
parcelRequire("8AFbH");
var $9TIDs = parcelRequire("9TIDs");
parcelRequire("cUefK");
var $7l4iG = parcelRequire("7l4iG");

var $k1GO8 = parcelRequire("k1GO8");

var $2sf66 = parcelRequire("2sf66");
const $f56c4271567276ef$export$1b7c65f90ce5d7ad = (props)=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $k1GO8.Wrapper), null, /*#__PURE__*/ $fc4bM.createElement((0, $9TIDs.default), {
        isDirty: false,
        openPublishPrompt: (0, $aYMdQ.noop),
        openCancelPrompt: (0, $aYMdQ.noop)
    }), /*#__PURE__*/ $fc4bM.createElement((0, $k1GO8.ExperienceContainer), null, props.error ? /*#__PURE__*/ $fc4bM.createElement($f56c4271567276ef$var$LoaderContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($f56c4271567276ef$var$FeaturedPortalsWrapper, null, /*#__PURE__*/ $fc4bM.createElement("h2", null, props.intl.formatMessage((0, $2sf66.default).featuredPortalsTitle)), /*#__PURE__*/ $fc4bM.createElement((0, $k1GO8.CardsContainer), null, Array.from({
        length: 3
    }).map((_, index)=>/*#__PURE__*/ $fc4bM.createElement((0, $9vIkD.default), {
            key: index,
            isFeatured: true
        })))), /*#__PURE__*/ $fc4bM.createElement($f56c4271567276ef$var$UnFeaturedPortalsWrapper, null, /*#__PURE__*/ $fc4bM.createElement((0, $7l4iG.default), {
        isDisabled: true,
        value: "POPULARITY",
        onChange: (0, $aYMdQ.noop)
    }), /*#__PURE__*/ $fc4bM.createElement((0, $k1GO8.CardsContainer), null, Array.from({
        length: 9
    }).map((_, index)=>/*#__PURE__*/ $fc4bM.createElement((0, $9vIkD.default), {
            key: index,
            isFeatured: true
        })))))));
};
var $f56c4271567276ef$export$2e2bcd8739ae039 = (0, $fcCIH.default)($f56c4271567276ef$export$1b7c65f90ce5d7ad);
const $f56c4271567276ef$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f56c4271567276ef$var$LoaderContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1tken9zg",
            __cmplp.className
        ])
    });
});
const $f56c4271567276ef$var$UnFeaturedPortalsWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $f56c4271567276ef$var$FeaturedPortalsWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_n7zl1dd9 _19pkpxbi _13jwangw _1n46ze3t _1gnpu2gc _7e5b1jfw _1advidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jHmjJ", function(module, exports) {
$parcel$export(module.exports, "ProjectCardSkeleton", () => (parcelRequire("9vIkD")).default);

var $9vIkD = parcelRequire("9vIkD");

});
parcelRegister("9vIkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $362e89cfa61bbf84$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $bsIOe = parcelRequire("bsIOe");

var $fOCtI = parcelRequire("fOCtI");

var $kzYZ0 = parcelRequire("kzYZ0");

var $7tzpi = parcelRequire("7tzpi");

var $jgcpV = parcelRequire("jgcpV");
parcelRequire("8SUS8");
var $dBgE8 = parcelRequire("dBgE8");
parcelRequire("dyOsq");
var $7DzPA = parcelRequire("7DzPA");
parcelRequire("bdhRL");
var $dBgE8 = parcelRequire("dBgE8");
var $bdhRL = parcelRequire("bdhRL");
const $362e89cfa61bbf84$var$ProjectsCardSkeleton = ({ isBasic: isBasic, isFeatured: isFeatured })=>{
    return /*#__PURE__*/ $fc4bM.createElement($362e89cfa61bbf84$var$Root, {
        "data-testid": 'project-card-skeleton'
    }, /*#__PURE__*/ $fc4bM.createElement((0, $dBgE8.Container), {
        hasIcon: true
    }, !isBasic && isFeatured && /*#__PURE__*/ $fc4bM.createElement($362e89cfa61bbf84$var$ActionsLeft, null, /*#__PURE__*/ $fc4bM.createElement((0, $7DzPA.DragHandlerWrapper), null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kzYZ0))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $dBgE8.IconContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: $fOCtI.multiple(6).px,
        height: $fOCtI.multiple(6).px
    })), /*#__PURE__*/ $fc4bM.createElement((0, $dBgE8.Content), null, /*#__PURE__*/ $fc4bM.createElement($362e89cfa61bbf84$var$NameWrapper, null, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: $fOCtI.multiple(11).px,
        height: (0, $bdhRL.titleSkeletonHeight)
    })), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: $fOCtI.multiple(18).px,
        height: "14px"
    })), !isBasic && /*#__PURE__*/ $fc4bM.createElement($362e89cfa61bbf84$var$Actions, null, isFeatured ? /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7tzpi))), {
        label: "star-filled-icon",
        size: "medium"
    })) : /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgcpV))), {
        label: "start-icon",
        size: "medium"
    }))));
};
var $362e89cfa61bbf84$export$2e2bcd8739ae039 = $362e89cfa61bbf84$var$ProjectsCardSkeleton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $362e89cfa61bbf84$var$Root = /*#__PURE__*/ (0, $luz1X.default).li.withConfig({
    componentId: "sc-12n7yik-0"
})`${(0, $dBgE8.cardStyle)} ${(0, $7DzPA.cardGutterStyle)} border:solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #DFE1E6)"};background-color:${"var(--ds-surface-raised, #FFFFFF)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $362e89cfa61bbf84$var$NameWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-12n7yik-1"
})`margin-bottom:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $362e89cfa61bbf84$var$Actions = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-12n7yik-2"
})`display:flex;flex-direction:column;align-items:center;position:absolute;color:${"var(--ds-skeleton, #F4F5F7)"};top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $362e89cfa61bbf84$var$ActionsLeft = /*#__PURE__*/ (0, $luz1X.default)($362e89cfa61bbf84$var$Actions).withConfig({
    componentId: "sc-12n7yik-3"
})`position:initial;width:${$fOCtI.multiple(5).px};margin-top:-${$fOCtI.multiple(6).px};`;

});
parcelRegister("kzYZ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8da0453588db1ecd928d81f929e2bf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efb6617ca6104347$var$_react = $efb6617ca6104347$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $efb6617ca6104347$var$_iconNew = $efb6617ca6104347$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $efb6617ca6104347$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/drag-handle-vertical
 * Usage guidance:
 * Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efb6617ca6104347$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $efb6617ca6104347$var$_react.default.createElement($efb6617ca6104347$var$_iconNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$efb6617ca6104347$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $efb6617ca6104347$var$_default = module.exports.default = $efb6617ca6104347$var$DragHandleVerticalIcon;

});

parcelRegister("7tzpi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::232da4c32cb25e3c0fe9fd325fd5dbc9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5716b4f0fc3ff025$var$_react = $5716b4f0fc3ff025$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5716b4f0fc3ff025$var$_iconNew = $5716b4f0fc3ff025$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5716b4f0fc3ff025$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-starred
 * Usage guidance:
 * Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5716b4f0fc3ff025$var$StarStarredIcon = (props)=>/*#__PURE__*/ $5716b4f0fc3ff025$var$_react.default.createElement($5716b4f0fc3ff025$var$_iconNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$5716b4f0fc3ff025$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $5716b4f0fc3ff025$var$_default = module.exports.default = $5716b4f0fc3ff025$var$StarStarredIcon;

});

parcelRegister("jgcpV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53379c98771562c0fa194d02f1725934>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e05924b6587961f5$var$_react = $e05924b6587961f5$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e05924b6587961f5$var$_iconNew = $e05924b6587961f5$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e05924b6587961f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-unstarred
 * Usage guidance:
 * Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e05924b6587961f5$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $e05924b6587961f5$var$_react.default.createElement($e05924b6587961f5$var$_iconNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$e05924b6587961f5$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $e05924b6587961f5$var$_default = module.exports.default = $e05924b6587961f5$var$StarUnstarredIcon;

});

parcelRegister("8SUS8", function(module, exports) {
$parcel$export(module.exports, "PortalCard", () => (parcelRequire("cxURg")).default);
$parcel$export(module.exports, "PortalName", () => (parcelRequire("dBgE8")).PortalName);
$parcel$export(module.exports, "cardStyle", () => (parcelRequire("dBgE8")).cardStyle);
$parcel$export(module.exports, "PortalCardContainer", () => (parcelRequire("dBgE8")).Container);

var $cxURg = parcelRequire("cxURg");

var $dBgE8 = parcelRequire("dBgE8");

});
parcelRegister("cxURg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c60972de91d2285f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $2KIJl = parcelRequire("2KIJl");

var $lrwXH = parcelRequire("lrwXH");

var $k3ktd = parcelRequire("k3ktd");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $6F3K7 = parcelRequire("6F3K7");

var $5ZHKM = parcelRequire("5ZHKM");

var $fJq3t = parcelRequire("fJq3t");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");
parcelRequire("fQxpy");
var $1JcSo = parcelRequire("1JcSo");

var $3TJLC = parcelRequire("3TJLC");

var $jEubQ = parcelRequire("jEubQ");

var $eENmG = parcelRequire("eENmG");

var $7lN8e = parcelRequire("7lN8e");

var $esgVk = parcelRequire("esgVk");

var $dBgE8 = parcelRequire("dBgE8");
var $c60972de91d2285f$var$_customPurifyIsomorph;
const $c60972de91d2285f$export$292d791731e624a3 = $fJq3t;
($c60972de91d2285f$var$_customPurifyIsomorph = $c60972de91d2285f$export$292d791731e624a3.addHook) === null || $c60972de91d2285f$var$_customPurifyIsomorph === void 0 || $c60972de91d2285f$var$_customPurifyIsomorph.call($c60972de91d2285f$export$292d791731e624a3, 'afterSanitizeAttributes', (node)=>{
    if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT') node.setAttribute('tabIndex', '-1');
});
const $c60972de91d2285f$var$PortalCard = ({ onClick: onClick, index: index, id: id, portalName: portalName, description: description, portalUrl: portalUrl, iconUrl: iconUrl, openInNewTab: openInNewTab })=>{
    const [isPageInEditMode] = (0, $1JcSo.useIsPageInEditMode)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const hasIcon = !!iconUrl;
    const hasPortalUrl = !!portalUrl;
    const hasDescription = !!description;
    const hasOnlyPortalName = !description && !iconUrl;
    const memoizedOnClick = $fc4bM.useCallback(()=>{
        const event = createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'portal'
        });
        event.context.push({
            componentName: 'link',
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        });
        event.fire();
        if (openInNewTab) {
            const { baseUrl: baseUrl } = (0, $7lN8e.getEnv)();
            (0, $esgVk.open)(`${baseUrl}${portalUrl}`, '_blank');
        } else push(portalUrl);
        onClick && onClick(index);
    }, [
        createAnalyticsEvent,
        index,
        hasIcon,
        hasPortalUrl,
        hasDescription,
        id,
        push,
        portalUrl,
        onClick,
        openInNewTab
    ]);
    const sanitizedDescription = $c60972de91d2285f$export$292d791731e624a3.sanitize(description || '');
    const content = /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$Container, {
        hasIcon: hasIcon
    }, !!iconUrl && /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$IconContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $2KIJl.default), {
        src: iconUrl,
        alt: '',
        draggable: "false"
    })), /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$Content, null, /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$PortalName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: portalName
    }, portalName), !!description && /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$Description, {
        title: description,
        dangerouslySetInnerHTML: {
            __html: sanitizedDescription
        }
    })));
    const portalCardContent = /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$CardRoot, {
        "aria-label": portalName,
        onClick: memoizedOnClick,
        "data-test-id": `portal:${portalName}`,
        role: "link"
    }, content);
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        }
    }, isPageInEditMode ? /*#__PURE__*/ $fc4bM.createElement($c60972de91d2285f$var$RootWhenEditingLayout, null, content) : portalCardContent);
};
var $c60972de91d2285f$export$2e2bcd8739ae039 = $c60972de91d2285f$var$PortalCard;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$PortalName = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ob3s3l-0"
})`${$imLe4.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $fOCtI.multiple(2).unitless;
    return $3DjOo.multiLineClamp(lines, lineHeight);
}};${$k3ktd.fromXSmall.css`
        ${$imLe4.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $fOCtI.multiple(7.5).px : $fOCtI.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$Description = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ob3s3l-1"
})`${$imLe4.xsmall};${$3DjOo.multiLineClamp(3, $fOCtI.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$fOCtI.multiple(2.25).px};${$k3ktd.fromXSmall.css`
        ${$imLe4.regular};
        line-height: ${$fOCtI.multiple(2.5).px};
        max-height: ${$fOCtI.multiple(7.5).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$Content = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ob3s3l-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $c60972de91d2285f$var$CardRoot = /*#__PURE__*/ (0, $luz1X.default)((0, $lrwXH.InteractiveElement)).withConfig({
    componentId: "sc-ob3s3l-3"
})`${(0, $dBgE8.cardStyle)} ${$3DjOo.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$5ZHKM.portalCardLayout};text-decoration:none;}cursor:pointer;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$RootWhenEditingLayout = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ob3s3l-4"
})`${(0, $dBgE8.cardStyle)} box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$6F3K7.speedMs.fast}ms ${$6F3K7.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$5ZHKM.portalCardLayout};text-decoration:none;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$IconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ob3s3l-5"
})`${$3DjOo.flexCenter};height:${$fOCtI.multiple(5).px};width:${$fOCtI.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$k3ktd.fromXSmall.css`
        height: ${$fOCtI.multiple(6).px};
        width: ${$fOCtI.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$largePadding = /*#__PURE__*/ (0, $luz1X.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$k3ktd.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$smallPadding = /*#__PURE__*/ (0, $luz1X.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$k3ktd.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c60972de91d2285f$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-ob3s3l-6"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $c60972de91d2285f$var$smallPadding : $c60972de91d2285f$var$largePadding};`;

});
parcelRegister("2KIJl", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f4a6b8715c17da8$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9f4a6b8715c17da8$var$AutoScaledImage = /*#__PURE__*/ (0, $luz1X.default).img.withConfig({
    componentId: "sc-1gbtcy6-0"
})`height:100%;width:${({ inheritWidth: inheritWidth })=>inheritWidth ? 'inherit' : '100%'};object-fit:${(props)=>props.objectFit || 'contain'};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$9f4a6b8715c17da8$export$2e2bcd8739ae039 = $9f4a6b8715c17da8$var$AutoScaledImage;

});

parcelRegister("lrwXH", function(module, exports) {
$parcel$export(module.exports, "InteractiveElement", () => $b7f399fc2e7b090d$export$c0db965635c41eb6);

var $fc4bM = parcelRequire("fc4bM");
const $b7f399fc2e7b090d$export$c0db965635c41eb6 = ({ onClick: onClick, children: children, role: role = 'button', tagName: TagName = 'div', ...props })=>{
    const handleKeyDown = (0, $fc4bM.useCallback)((event)=>{
        // Runs onClick on space and enter key press for accessibility
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(TagName, {
        tabIndex: 0,
        role: role,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        ...props
    }, children);
};
var $b7f399fc2e7b090d$export$2e2bcd8739ae039 = $b7f399fc2e7b090d$export$c0db965635c41eb6;

});

parcelRegister("fQxpy", function(module, exports) {
$parcel$export(module.exports, "useConfigPanelUI", () => (parcelRequire("1JcSo")).useConfigPanelUI);
$parcel$export(module.exports, "useDeletedModulesCount", () => (parcelRequire("1JcSo")).useDeletedModulesCount);
$parcel$export(module.exports, "useElementRenderer", () => (parcelRequire("1JcSo")).useElementRenderer);
$parcel$export(module.exports, "useIsDirty", () => (parcelRequire("1JcSo")).useIsDirty);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => (parcelRequire("1JcSo")).useIsPageInBrandingPreviewMode);
$parcel$export(module.exports, "useIsPageInEditMode", () => (parcelRequire("1JcSo")).useIsPageInEditMode);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => (parcelRequire("1JcSo")).useIsPageInPreviewMode);
$parcel$export(module.exports, "useIsPublishDisabled", () => (parcelRequire("1JcSo")).useIsPublishDisabled);
$parcel$export(module.exports, "useIsPublishing", () => (parcelRequire("1JcSo")).useIsPublishing);
$parcel$export(module.exports, "useLayoutActions", () => (parcelRequire("1JcSo")).useLayoutActions);
$parcel$export(module.exports, "useLayoutConfig", () => (parcelRequire("1JcSo")).useLayoutConfig);
$parcel$export(module.exports, "useLayoutIds", () => (parcelRequire("1JcSo")).useLayoutIds);
$parcel$export(module.exports, "useMediaConfig", () => (parcelRequire("1JcSo")).useMediaConfig);
$parcel$export(module.exports, "useReorderedModulesCount", () => (parcelRequire("1JcSo")).useReorderedModulesCount);
$parcel$export(module.exports, "useSectionPicker", () => (parcelRequire("1JcSo")).useSectionPicker);
$parcel$export(module.exports, "useSelectedPrimitive", () => (parcelRequire("1JcSo")).useSelectedPrimitive);
parcelRequire("1JcSo");

});
parcelRegister("1JcSo", function(module, exports) {
$parcel$export(module.exports, "LayoutBuilderContainer", () => $65de107c32ff3097$export$b4aab0ffc58aaa5);
$parcel$export(module.exports, "useIsPageInEditMode", () => $65de107c32ff3097$export$7be577f8255e624c);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => $65de107c32ff3097$export$20672b722d2aa4d4);
$parcel$export(module.exports, "useSectionPicker", () => $65de107c32ff3097$export$1672d32e0a0e6fce);
$parcel$export(module.exports, "useSelectedPrimitive", () => $65de107c32ff3097$export$66366b49ee6cbaa2);
$parcel$export(module.exports, "useIsPublishing", () => $65de107c32ff3097$export$b9b3eff0a656013d);
$parcel$export(module.exports, "useIsPublishDisabled", () => $65de107c32ff3097$export$122ac12905cb91a9);
$parcel$export(module.exports, "useIsDirty", () => $65de107c32ff3097$export$9b9cd7e7602f602f);
$parcel$export(module.exports, "useMediaConfig", () => $65de107c32ff3097$export$7f746b47c356effa);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => $65de107c32ff3097$export$dbe8a2a3e19e92cf);
$parcel$export(module.exports, "useLayoutConfig", () => $65de107c32ff3097$export$6bc9f3ef36ce1121);
$parcel$export(module.exports, "useLayoutIds", () => $65de107c32ff3097$export$5fb152f2612e3297);
$parcel$export(module.exports, "useElementRenderer", () => $65de107c32ff3097$export$68c713430d820919);
$parcel$export(module.exports, "useDeletedModulesCount", () => $65de107c32ff3097$export$2056c520eb48ec8b);
$parcel$export(module.exports, "useReorderedModulesCount", () => $65de107c32ff3097$export$4010704f08b334ba);
$parcel$export(module.exports, "useConfigPanelUI", () => $65de107c32ff3097$export$7eebf066d70abd18);
$parcel$export(module.exports, "useLayoutActions", () => $65de107c32ff3097$export$1069bba51f142634);

var $hN5YJ = parcelRequire("hN5YJ");

var $ik3UL = parcelRequire("ik3UL");
var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");
var $jlH1f = parcelRequire("jlH1f");

var $7lN8e = parcelRequire("7lN8e");

var $asilc = parcelRequire("asilc");

var $gLFTD = parcelRequire("gLFTD");
if ((0, $7lN8e.getEnv)().environment !== (0, $7lN8e.EnvType).PROD) (0, $jlH1f.default).devtools = true;
const $65de107c32ff3097$export$c78554af6dbb181d = ()=>{
    return (0, $hN5YJ.isIncreasedFlexibilityEnabled)() ? {
        hideCatalogue: false,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: true,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    } : {
        hideCatalogue: true,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: false,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    };
};
const $65de107c32ff3097$var$emptyLayoutId = {
    sectionId: undefined,
    elementId: undefined
};
const $65de107c32ff3097$export$1cb7963f0d33db7c = {
    HelpLayoutHeroElement: $65de107c32ff3097$var$emptyLayoutId,
    HelpLayoutAnnouncementElement: $65de107c32ff3097$var$emptyLayoutId,
    HelpLayoutTopicsListElement: $65de107c32ff3097$var$emptyLayoutId,
    HelpLayoutPortalsListElement: $65de107c32ff3097$var$emptyLayoutId,
    HelpLayoutSuggestedRequestFormsListElement: $65de107c32ff3097$var$emptyLayoutId,
    HelpLayoutForgeElement: [],
    HelpLayoutConnectElement: []
};
const $65de107c32ff3097$export$d4c72bab9d6cc13a = {
    layoutIds: $65de107c32ff3097$export$1cb7963f0d33db7c,
    isPageInEditMode: false,
    isPageInPreviewMode: false,
    isPageInBrandingPreviewMode: false,
    isPublishing: false,
    isPublishDisabled: true,
    isDirty: false,
    mediaConfig: {},
    deletedModulesCount: 0,
    reorderedModulesCount: 0,
    screenName: undefined,
    experience: undefined,
    traceId: undefined,
    events: {
        selected: undefined,
        hovered: undefined,
        dragged: undefined,
        sectionPickerId: undefined
    },
    configPanel: {
        ui: null
    },
    config: $65de107c32ff3097$export$c78554af6dbb181d()
};
const $65de107c32ff3097$export$6f57813fe9f31bf9 = (0, $ipn74.createStore)({
    initialState: $65de107c32ff3097$export$d4c72bab9d6cc13a,
    actions: $asilc.actions,
    name: 'LayoutBuilderStore'
});
const $65de107c32ff3097$export$13f23e293cec2ec3 = ()=>({ setState: setState }, { configPanelUI: configPanelUI, editMode: editMode, ElementRenderer: ElementRenderer, screenName: screenName, experience: experience, traceId: traceId, mediaConfig: mediaConfig, pageType: pageType, config: config = {}, events: events = {} })=>{
        setState({
            events: events,
            mediaConfig: mediaConfig,
            ElementRenderer: ElementRenderer,
            screenName: screenName,
            experience: experience,
            traceId: traceId,
            pageType: pageType,
            isPageInEditMode: editMode,
            isPageInPreviewMode: false,
            config: {
                ...$65de107c32ff3097$export$c78554af6dbb181d(),
                ...config
            },
            configPanel: {
                ui: configPanelUI
            }
        });
    };
const $65de107c32ff3097$export$b4aab0ffc58aaa5 = (0, $ik3UL.createContainer)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    onInit: $65de107c32ff3097$export$13f23e293cec2ec3,
    displayName: 'LayoutBuilderContainer'
});
const $65de107c32ff3097$export$7be577f8255e624c = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getIsPageInEditMode)
});
const $65de107c32ff3097$export$20672b722d2aa4d4 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getIsPageInPreviewMode)
});
const $65de107c32ff3097$export$1672d32e0a0e6fce = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getSectionPickerId)
});
const $65de107c32ff3097$export$66366b49ee6cbaa2 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getSelectedPrimitive)
});
const $65de107c32ff3097$export$b9b3eff0a656013d = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getIsPublishing)
});
const $65de107c32ff3097$export$122ac12905cb91a9 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getIsPublishDisabled)
});
const $65de107c32ff3097$export$9b9cd7e7602f602f = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getIsDirty)
});
const $65de107c32ff3097$export$7f746b47c356effa = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getMediaConfig)
});
const $65de107c32ff3097$export$dbe8a2a3e19e92cf = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getIsPageInBrandingPreviewMode)
});
const $65de107c32ff3097$export$6bc9f3ef36ce1121 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getLayoutConfig)
});
const $65de107c32ff3097$export$5fb152f2612e3297 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getLayoutIds)
});
const $65de107c32ff3097$export$68c713430d820919 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getElementRenderer)
});
const $65de107c32ff3097$export$2056c520eb48ec8b = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (state)=>state.deletedModulesCount
});
const $65de107c32ff3097$export$4010704f08b334ba = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (state)=>state.reorderedModulesCount
});
const $65de107c32ff3097$export$7eebf066d70abd18 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (0, $gLFTD.getConfigPanelUI)
});
const $65de107c32ff3097$export$4ca74c2ebe5e7020 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageType
});
const $65de107c32ff3097$export$1069bba51f142634 = (0, $5nVr1.createHook)($65de107c32ff3097$export$6f57813fe9f31bf9);

});
parcelRegister("asilc", function(module, exports) {
$parcel$export(module.exports, "actions", () => $24bd51b7050c6fd9$export$e324594224ef24da);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("1lJf3");
var $amNdx = parcelRequire("amNdx");
const $24bd51b7050c6fd9$export$eed4cbff0d0952a0 = ()=>({ getState: getState, setState: setState })=>{
        var _currentState$events$, _currentState$events$2;
        const currentState = getState();
        const pageDataId = (_currentState$events$ = currentState.events.selected) === null || _currentState$events$ === void 0 || (_currentState$events$ = _currentState$events$.path[0]) === null || _currentState$events$ === void 0 ? void 0 : _currentState$events$.dataId;
        setState({
            events: {
                hovered: undefined,
                selected: (0, $hN5YJ.isIncreasedFlexibilityEnabled)() && pageDataId ? {
                    dataId: pageDataId,
                    path: ((_currentState$events$2 = currentState.events.selected) === null || _currentState$events$2 === void 0 ? void 0 : _currentState$events$2.path.slice(0, 1)) || []
                } : undefined,
                sectionPickerId: undefined
            },
            configPanel: {
                ui: (0, $hN5YJ.isIncreasedFlexibilityEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $amNdx.ConfigPanelEmptyState), null)
            }
        });
    };
const $24bd51b7050c6fd9$export$2b82c83704d16f1e = (dataId, path)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                selected: {
                    dataId: dataId,
                    path: path
                }
            }
        });
    };
const $24bd51b7050c6fd9$export$63f1a53b56db7e60 = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                hovered: dataId
            }
        });
    };
const $24bd51b7050c6fd9$export$703359b98869d7ca = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                dragged: dataId
            }
        });
    };
const $24bd51b7050c6fd9$export$f03c06073cab57c8 = (sectionId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                hovered: undefined,
                selected: undefined,
                sectionPickerId: sectionId
            }
        });
    };
const $24bd51b7050c6fd9$export$7cc839743e7817e1 = (isPublishing)=>({ setState: setState })=>{
        setState({
            isPublishing: isPublishing
        });
    };
const $24bd51b7050c6fd9$export$e1757f155540af7b = (isPublishDisabled)=>({ setState: setState })=>{
        setState({
            isPublishDisabled: isPublishDisabled
        });
    };
const $24bd51b7050c6fd9$export$12e1d22d39b53fc8 = (isDirty)=>({ setState: setState })=>{
        setState({
            isDirty: isDirty
        });
    };
const $24bd51b7050c6fd9$export$8170ce9a15707844 = (isPageInBrandingPreviewMode)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
        });
    };
const $24bd51b7050c6fd9$export$6c5886565b08070e = (sectionId, elementId, typename)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (typename === 'HelpLayoutForgeElement' || typename === 'HelpLayoutConnectElement') {
            const updatedLayoutIds = {
                ...currentState.layoutIds
            };
            updatedLayoutIds[typename] = [
                ...updatedLayoutIds[typename] || [],
                {
                    sectionId: sectionId,
                    elementId: elementId
                }
            ];
            setState({
                ...currentState,
                layoutIds: updatedLayoutIds
            });
            return;
        }
        setState({
            ...currentState,
            layoutIds: {
                ...currentState.layoutIds,
                [typename]: {
                    sectionId: sectionId,
                    elementId: elementId
                }
            }
        });
    };
const $24bd51b7050c6fd9$export$18ae1b41966470b5 = ()=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentPreviewMode = currentState.isPageInPreviewMode;
        setState({
            ...currentState,
            isPageInPreviewMode: !currentPreviewMode
        });
    };
const $24bd51b7050c6fd9$export$59e3de019265ab87 = (deletedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            deletedModulesCount: deletedModulesCount
        });
    };
const $24bd51b7050c6fd9$export$dd986587ada0d176 = (ui)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            configPanel: {
                ui: ui
            }
        });
    };
const $24bd51b7050c6fd9$export$de05f3d90acd4969 = (reorderedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            reorderedModulesCount: reorderedModulesCount
        });
    };
const $24bd51b7050c6fd9$export$20a1a9b113e6ba3a = (mediaConfig)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            mediaConfig: mediaConfig
        });
    };
const $24bd51b7050c6fd9$export$e324594224ef24da = {
    markPageSelected: $24bd51b7050c6fd9$export$eed4cbff0d0952a0,
    markSelected: $24bd51b7050c6fd9$export$2b82c83704d16f1e,
    markHovered: $24bd51b7050c6fd9$export$63f1a53b56db7e60,
    markDragged: $24bd51b7050c6fd9$export$703359b98869d7ca,
    markSectionDialogOpen: $24bd51b7050c6fd9$export$f03c06073cab57c8,
    markIsPublishing: $24bd51b7050c6fd9$export$7cc839743e7817e1,
    markIsPublishDisabled: $24bd51b7050c6fd9$export$e1757f155540af7b,
    markIsDirty: $24bd51b7050c6fd9$export$12e1d22d39b53fc8,
    markBrandingPreviewMode: $24bd51b7050c6fd9$export$8170ce9a15707844,
    setLayoutId: $24bd51b7050c6fd9$export$6c5886565b08070e,
    togglePreviewMode: $24bd51b7050c6fd9$export$18ae1b41966470b5,
    setDeletedModulesCount: $24bd51b7050c6fd9$export$59e3de019265ab87,
    setReorderedModulesCount: $24bd51b7050c6fd9$export$de05f3d90acd4969,
    setMediaConfig: $24bd51b7050c6fd9$export$20a1a9b113e6ba3a,
    setConfigPanelUI: $24bd51b7050c6fd9$export$dd986587ada0d176
};

});
parcelRegister("1lJf3", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => (parcelRequire("amNdx")).ConfigPanelEmptyState);

var $amNdx = parcelRequire("amNdx");

});
parcelRegister("amNdx", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => $e93f06093ce13f36$export$2fdc624ef67f147b);

var $fc4bM = parcelRequire("fc4bM");

var $8CR87 = parcelRequire("8CR87");

var $gpjDl = parcelRequire("gpjDl");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $kTwsM = parcelRequire("kTwsM");
const $e93f06093ce13f36$export$2fdc624ef67f147b = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "medium",
        as: "h3"
    }, formatMessage((0, $kTwsM.default).emptyConfigPanelHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $e93f06093ce13f36$var$emptyConfigPanelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8CR87))),
        alt: formatMessage((0, $kTwsM.default).emptyConfigPanelImageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        align: "center",
        as: "p"
    }, formatMessage((0, $kTwsM.default).emptyConfigPanelText, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("b", null, chunks)
    }))));
};
const $e93f06093ce13f36$var$emptyConfigPanelStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 'space.400',
    gap: 'space.200'
});

});
parcelRegister("8CR87", function(module, exports) {
module.exports = new URL("../images/config-panel-default.4e21e8e2.svg", import.meta.url).toString();

});

parcelRegister("kTwsM", function(module, exports) {
$parcel$export(module.exports, "default", () => $095188a2f53b87d4$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $095188a2f53b87d4$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    emptyConfigPanelHeading: {
        defaultMessage: 'Edit page layout',
        description: 'Heading to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.heading'
    },
    emptyConfigPanelText: {
        defaultMessage: 'Pages are made of horizontal blocks called <b>sections</b> to which you can add <b>rich content.</b> Select an existing section or add a new one to get started.',
        description: 'Text to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.text'
    },
    emptyConfigPanelImageAltText: {
        defaultMessage: 'The config panel is empty',
        description: 'Alt text for image to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.image.alt'
    }
});

});




parcelRegister("gLFTD", function(module, exports) {
$parcel$export(module.exports, "getIsPageInEditMode", () => $a5ee30119035be5d$export$31efc24b85422f28);
$parcel$export(module.exports, "getIsPageInPreviewMode", () => $a5ee30119035be5d$export$b16c6dd5c9190b1a);
$parcel$export(module.exports, "getSectionPickerId", () => $a5ee30119035be5d$export$c00ca6bc45704b1a);
$parcel$export(module.exports, "getSelectedPrimitive", () => $a5ee30119035be5d$export$12c45f99974b2f6);
$parcel$export(module.exports, "getIsPublishing", () => $a5ee30119035be5d$export$114b0b1eb879caeb);
$parcel$export(module.exports, "getIsPublishDisabled", () => $a5ee30119035be5d$export$8626e45ed1d507a4);
$parcel$export(module.exports, "getIsDirty", () => $a5ee30119035be5d$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getMediaConfig", () => $a5ee30119035be5d$export$e0c7d660f7459c46);
$parcel$export(module.exports, "getIsPageInBrandingPreviewMode", () => $a5ee30119035be5d$export$5f742d52a7bee27e);
$parcel$export(module.exports, "getLayoutConfig", () => $a5ee30119035be5d$export$61bd5e607ff26d43);
$parcel$export(module.exports, "getLayoutIds", () => $a5ee30119035be5d$export$c3b66d8cabe26730);
$parcel$export(module.exports, "getElementRenderer", () => $a5ee30119035be5d$export$21591c7e677a0342);
$parcel$export(module.exports, "getConfigPanelUI", () => $a5ee30119035be5d$export$eab87a6b2cabf1fe);
const $a5ee30119035be5d$export$31efc24b85422f28 = (state)=>state.isPageInEditMode;
const $a5ee30119035be5d$export$b16c6dd5c9190b1a = (state)=>state.isPageInPreviewMode;
const $a5ee30119035be5d$export$c00ca6bc45704b1a = (state)=>state.events.sectionPickerId;
const $a5ee30119035be5d$export$12c45f99974b2f6 = (state)=>state.events.selected;
const $a5ee30119035be5d$export$114b0b1eb879caeb = (state)=>state.isPublishing;
const $a5ee30119035be5d$export$8626e45ed1d507a4 = (state)=>state.isPublishDisabled;
const $a5ee30119035be5d$export$4b1964ee9ad6f220 = (state)=>state.isDirty;
const $a5ee30119035be5d$export$e0c7d660f7459c46 = (state)=>state.mediaConfig;
const $a5ee30119035be5d$export$5f742d52a7bee27e = (state)=>state.isPageInBrandingPreviewMode;
const $a5ee30119035be5d$export$61bd5e607ff26d43 = (state)=>state.config;
const $a5ee30119035be5d$export$c3b66d8cabe26730 = (state)=>state.layoutIds;
const $a5ee30119035be5d$export$21591c7e677a0342 = (state)=>state.ElementRenderer;
const $a5ee30119035be5d$export$eab87a6b2cabf1fe = (state)=>state.configPanel.ui;

});



parcelRegister("dBgE8", function(module, exports) {
$parcel$export(module.exports, "PortalName", () => $20f7a14b9664ddde$export$388673bc95b650ac);
$parcel$export(module.exports, "Description", () => $20f7a14b9664ddde$export$393edc798c47379d);
$parcel$export(module.exports, "Content", () => $20f7a14b9664ddde$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "cardStyle", () => $20f7a14b9664ddde$export$20fbd02c8b16da77);
$parcel$export(module.exports, "IconContainer", () => $20f7a14b9664ddde$export$8f314e512d92575f);
$parcel$export(module.exports, "Container", () => $20f7a14b9664ddde$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $k3ktd = parcelRequire("k3ktd");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $5ZHKM = parcelRequire("5ZHKM");

var $k2M4v = parcelRequire("k2M4v");
const $20f7a14b9664ddde$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $20f7a14b9664ddde$var$isHcAdsDropCommit2Enabled = ()=>(0, $k2M4v.default).checkGate($20f7a14b9664ddde$var$HC_ADS_DROP_COMMIT_2);
const $20f7a14b9664ddde$export$388673bc95b650ac = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ics84-0"
})`${$imLe4.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $fOCtI.multiple(2).unitless;
    return $3DjOo.multiLineClamp(lines, lineHeight);
}};${$k3ktd.fromXSmall.css`
        ${$imLe4.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $fOCtI.multiple(7.5).px : $fOCtI.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
const $20f7a14b9664ddde$export$393edc798c47379d = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ics84-1"
})`${$imLe4.xsmall};${$3DjOo.multiLineClamp(3, $fOCtI.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$fOCtI.multiple(2.25).px};${$k3ktd.fromXSmall.css`
        ${$imLe4.regular};
        line-height: ${$fOCtI.multiple(2.5).px};
        max-height: ${$fOCtI.multiple(7.5).px};
    `};`;
const $20f7a14b9664ddde$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ics84-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
const $20f7a14b9664ddde$export$20fbd02c8b16da77 = /*#__PURE__*/ (0, $luz1X.css)`${$3DjOo.borderRadius};${()=>// hc_ads_drop_commit_2: ADS drop 2 bumps card radius to radius.large.
    // Overrides mixins.borderRadius above via source order; TODO remove with the flag.
    $20f7a14b9664ddde$var$isHcAdsDropCommit2Enabled() && `border-radius: ${"var(--ds-radius-large, 8px)"};`} ${$3DjOo.focusRing.default};box-sizing:border-box;display:block;position:relative;height:${$fOCtI.multiple(14).px};width:${$fOCtI.multiple(33).px};z-index:${$5ZHKM.portalCardLayout};${$k3ktd.fromXSmall.css`
    height: ${$fOCtI.multiple(18).px};
    width: ${$fOCtI.multiple(42).px};
`};`;
const $20f7a14b9664ddde$export$8f314e512d92575f = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ics84-3"
})`${$3DjOo.flexCenter};height:${$fOCtI.multiple(5).px};width:${$fOCtI.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$k3ktd.fromXSmall.css`
        height: ${$fOCtI.multiple(6).px};
        width: ${$fOCtI.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $20f7a14b9664ddde$var$largePadding = /*#__PURE__*/ (0, $luz1X.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$k3ktd.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $20f7a14b9664ddde$var$smallPadding = /*#__PURE__*/ (0, $luz1X.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$k3ktd.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
const $20f7a14b9664ddde$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-3ics84-4"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $20f7a14b9664ddde$var$smallPadding : $20f7a14b9664ddde$var$largePadding};`;

});



parcelRegister("dyOsq", function(module, exports) {
$parcel$export(module.exports, "ProjectCard", () => (parcelRequire("IkyCf")).default);
$parcel$export(module.exports, "Overlay", () => (parcelRequire("7DzPA")).Overlay);
$parcel$export(module.exports, "DragHandlerWrapper", () => (parcelRequire("7DzPA")).DragHandlerWrapper);
$parcel$export(module.exports, "cardGutterStyle", () => (parcelRequire("7DzPA")).cardGutterStyle);
$parcel$export(module.exports, "Root", () => (parcelRequire("7DzPA")).Root);
$parcel$export(module.exports, "Wrapper", () => (parcelRequire("7DzPA")).Wrapper);

var $IkyCf = parcelRequire("IkyCf");

var $7DzPA = parcelRequire("7DzPA");

});
parcelRegister("IkyCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b3d34e7034fd993$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("7h8sD");
var $8EcmC = parcelRequire("8EcmC");

var $7DzPA = parcelRequire("7DzPA");
const $8b3d34e7034fd993$var$mapStateToProps = (state)=>{
    return {
        isPortalHidingEnabled: (0, $8EcmC.getIsPortalHidingEnabled)(state)
    };
};
var $8b3d34e7034fd993$export$2e2bcd8739ae039 = (0, $6umft.default)($8b3d34e7034fd993$var$mapStateToProps)((0, $7DzPA.default));

});
parcelRegister("7DzPA", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $1d015f8471ab2d0a$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Root", () => $1d015f8471ab2d0a$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "DragHandlerWrapper", () => $1d015f8471ab2d0a$export$5761cab24db81fb9);
$parcel$export(module.exports, "ScreenReaderInstruction", () => $1d015f8471ab2d0a$export$a5ddd0c37fc6764f);
$parcel$export(module.exports, "default", () => $1d015f8471ab2d0a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cardGutterStyle", () => $1d015f8471ab2d0a$export$c83f43d52281dc9d);
$parcel$export(module.exports, "Overlay", () => $1d015f8471ab2d0a$export$c6fdb837b070b4ff);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $2KIJl = parcelRequire("2KIJl");

var $k3ktd = parcelRequire("k3ktd");

var $4rovU = parcelRequire("4rovU");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");

var $5ZHKM = parcelRequire("5ZHKM");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("9pBM3");
var $f97Sg = parcelRequire("f97Sg");

var $kzYZ0 = parcelRequire("kzYZ0");

var $bqWPH = parcelRequire("bqWPH");

var $3Q3UJ = parcelRequire("3Q3UJ");

var $7tzpi = parcelRequire("7tzpi");

var $jgcpV = parcelRequire("jgcpV");
parcelRequire("8SUS8");
var $dBgE8 = parcelRequire("dBgE8");

var $dBgE8 = parcelRequire("dBgE8");

var $79dju = parcelRequire("79dju");
const $1d015f8471ab2d0a$export$bacf8f04493bf68c = ({ id: id, name: name, description: description, iconUrl: iconUrl, isFeatured: isFeatured, isDropped: isDropped, className: className, intl: intl, hiddenFromHomeScreen: hiddenFromHomeScreen, hideActionButtons: hideActionButtons, isPortalHidingEnabled: isPortalHidingEnabled, onToggleFeatured: onToggleFeatured, onToggleVisibility: onToggleVisibility })=>{
    const hasIcon = !!iconUrl;
    const hasOnlyPortalName = !description && !iconUrl;
    const onFeaturedStarClick = $fc4bM.useCallback(()=>{
        onToggleFeatured && onToggleFeatured(id, !isFeatured);
    }, [
        id,
        isFeatured,
        onToggleFeatured
    ]);
    const onVisibilityIconClick = $fc4bM.useCallback(()=>{
        onToggleVisibility && onToggleVisibility(id, !hiddenFromHomeScreen);
    }, [
        id,
        hiddenFromHomeScreen,
        onToggleVisibility
    ]);
    const rootProps = isFeatured ? {
        isDropped: isDropped,
        isFeatured: true
    } : {
        isFeatured: false
    };
    const featuredProjectToolTip = intl.formatMessage((0, $79dju.default).featuredProjectTooltip);
    const unFeaturedProjectToolTip = intl.formatMessage((0, $79dju.default).unFeaturedProjectTooltip);
    const visibleProjectTooltip = intl.formatMessage((0, $79dju.default).visibleProjectTooltip);
    const hiddenProjectTooltip = intl.formatMessage((0, $79dju.default).hiddenProjectTooltip);
    const featureToolTip = {
        highlightedMessage: featuredProjectToolTip,
        unHighlightedMessage: unFeaturedProjectToolTip
    };
    const featureAriaLabel = {
        highlightedLabel: featuredProjectToolTip,
        unHighlightedLabel: unFeaturedProjectToolTip
    };
    const visibilityToolTip = {
        highlightedMessage: visibleProjectTooltip,
        unHighlightedMessage: hiddenProjectTooltip
    };
    const visibilityAriaLabel = {
        highlightedLabel: visibleProjectTooltip,
        unHighlightedLabel: hiddenProjectTooltip
    };
    const ariaAttributes = isFeatured ? {
        tabIndex: 0,
        role: 'button',
        'aria-labelledby': `project-card-content-${id}`,
        'aria-roledescription': 'Draggable item',
        'aria-describedby': 'featured-portals-screen-reader-description'
    } : {};
    return /*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$export$e6dfd72ab29f8598, {
        "data-test-id": isFeatured ? `featured-card-${id}` : null,
        "data-testid": isFeatured ? `featured-card-${id}` : 'unfeatured-card',
        ...className ? {
            className: className
        } : {},
        ...ariaAttributes
    }, /*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$export$be92b6f5f03c0fe9, rootProps, /*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$var$Container, {
        hasIcon: hasIcon,
        isDraggable: isFeatured
    }, isFeatured && /*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$export$5761cab24db81fb9, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kzYZ0))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    })), hasIcon && /*#__PURE__*/ $fc4bM.createElement((0, $dBgE8.IconContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $2KIJl.default), {
        src: iconUrl,
        alt: "icon"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $dBgE8.Content), {
        id: `project-card-content-${id}`
    }, /*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$var$ProjectName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: name
    }, name), !!description && /*#__PURE__*/ $fc4bM.createElement((0, $dBgE8.Description), {
        title: description,
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), !hideActionButtons && /*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$var$Actions, null, isPortalHidingEnabled && (!isFeatured || hiddenFromHomeScreen) && /*#__PURE__*/ $fc4bM.createElement((0, $f97Sg.default), {
        isHighlighted: !hiddenFromHomeScreen,
        highlightHandler: onVisibilityIconClick,
        toolTip: visibilityToolTip,
        ariaLabel: visibilityAriaLabel,
        actionSubjectId: hiddenFromHomeScreen ? 'hiddenCard' : 'visibleCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3Q3UJ))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bqWPH)))
        }
    }), (!isPortalHidingEnabled || !hiddenFromHomeScreen) && /*#__PURE__*/ $fc4bM.createElement((0, $f97Sg.default), {
        isHighlighted: isFeatured,
        highlightHandler: onFeaturedStarClick,
        toolTip: featureToolTip,
        ariaLabel: featureAriaLabel,
        actionSubjectId: isFeatured ? 'featuredCard' : 'unFeaturedCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7tzpi))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jgcpV)))
        },
        color: {
            highlightedColor: "var(--ds-background-accent-yellow-subtler, #FFC400)"
        }
    })))));
};
const $1d015f8471ab2d0a$export$a5ddd0c37fc6764f = ({ intl: intl })=>/*#__PURE__*/ $fc4bM.createElement($1d015f8471ab2d0a$var$SortableCardDescription, {
        id: "featured-portals-screen-reader-description"
    }, intl.formatMessage((0, $79dju.default).screenReaderInstructionsForReordering));
var $1d015f8471ab2d0a$export$2e2bcd8739ae039 = /*#__PURE__*/ $fc4bM.memo((0, $fcCIH.default)($1d015f8471ab2d0a$export$bacf8f04493bf68c));
const $1d015f8471ab2d0a$export$c83f43d52281dc9d = /*#__PURE__*/ (0, $luz1X.css)`margin:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"};${$k3ktd.fromLarge.css`
margin: ${"var(--ds-space-200, 16px)"} ${$fOCtI.multiple(4.75).px};
`}`;
const $1d015f8471ab2d0a$var$rootBackgroundColor = (props)=>props.isDropped ? "var(--ds-surface-raised-pressed, #DEEBFF)" : "var(--ds-surface-raised, #FFFFFF)";
const $1d015f8471ab2d0a$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1tkctfp-0"
})`${(0, $dBgE8.cardStyle)} ${(props)=>props.isFeatured ? $3DjOo.raiseUpOnHoverOrFocus((0, $4rovU.newElevationsFromDesignSystems).e100, (0, $4rovU.newElevationsFromDesignSystems).e200) : (0, $4rovU.newElevationsFromDesignSystems).e100};${(props)=>$3DjOo.applyIf(!Boolean(props.isFeatured), 'z-index: 0;')} background-color:${$1d015f8471ab2d0a$var$rootBackgroundColor};user-select:none;${(props)=>props.isFeatured && !props.isDropped && (0, $luz1X.css)({
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #F4F5F7)"
        }
    })};&:hover,&:focus{z-index:${$5ZHKM.portalCardLayout};text-decoration:none;}&::after{cursor:${(props)=>{
    return props.isFeatured ? 'grab' : 'auto';
}};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1d015f8471ab2d0a$var$Actions = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1tkctfp-1"
})`display:flex;flex-direction:row;align-items:center;position:absolute;top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1d015f8471ab2d0a$var$Container = /*#__PURE__*/ (0, $luz1X.default)((0, $dBgE8.Container)).withConfig({
    componentId: "sc-1tkctfp-2"
})`padding-right:${$fOCtI.multiple(5.5).px};${({ isDraggable: isDraggable })=>isDraggable ? `padding-left: ${"var(--ds-space-500, 40px)"}` : ''};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1d015f8471ab2d0a$var$ProjectName = /*#__PURE__*/ (0, $luz1X.default)((0, $dBgE8.PortalName)).withConfig({
    componentId: "sc-1tkctfp-3"
})`color:${"var(--ds-text, #172B4D)"};`;
const $1d015f8471ab2d0a$var$boxShadow = `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} rgba(0, 0, 0, 0.15)`;
const $1d015f8471ab2d0a$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $luz1X.default).li.withConfig({
    componentId: "sc-1tkctfp-4"
})`${$1d015f8471ab2d0a$export$c83f43d52281dc9d} touch-action:none;list-style:none;&:focus{${$3DjOo.focusRing.default};& ${$1d015f8471ab2d0a$export$be92b6f5f03c0fe9}{&:hover{transform:translate3d(0,0,0);}}}&.sortable-helper{cursor:grabbing !important;pointer-events:auto !important;list-style:none;${$1d015f8471ab2d0a$export$be92b6f5f03c0fe9}{background-color:${$1d015f8471ab2d0a$var$rootBackgroundColor};&::after{cursor:grabbing;}&:hover{cursor:grabbing;background-color:${"var(--ds-surface-raised, #FFFFFF)"};}box-shadow:${`var(--ds-shadow-overlay, ${$1d015f8471ab2d0a$var$boxShadow})`};}}`;
const $1d015f8471ab2d0a$export$5761cab24db81fb9 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1tkctfp-5"
})`left:${"var(--ds-space-050, 4px)"};position:absolute;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1d015f8471ab2d0a$var$SortableCardDescription = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1tkctfp-6"
})`display:none;`;
const $1d015f8471ab2d0a$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1tkctfp-7"
})`${(0, $dBgE8.cardStyle)} ${$1d015f8471ab2d0a$export$c83f43d52281dc9d} background-color:${(props)=>props.show ? "var(--ds-background-selected-hovered, #B3D4FF)" : "var(--ds-surface-raised, transparent)"};opacity:0.3;transition:all 0.2s;`;

});
parcelRegister("9pBM3", function(module, exports) {
$parcel$export(module.exports, "Highlighter", () => (parcelRequire("f97Sg")).default);

var $f97Sg = parcelRequire("f97Sg");

});
parcelRegister("f97Sg", function(module, exports) {
$parcel$export(module.exports, "default", () => $45a6cc28c11ab8c3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $MPQAF = parcelRequire("MPQAF");

var $5ZHKM = parcelRequire("5ZHKM");

var $bcTS3 = parcelRequire("bcTS3");
const $45a6cc28c11ab8c3$export$7cc17c9bd3240823 = ({ isHighlighted: isHighlighted, highlightHandler: highlightHandler, toolTip: toolTip, ariaLabel: ariaLabel, actionSubjectId: actionSubjectId, icon: icon, color: color })=>{
    const toolTipMessage = isHighlighted ? toolTip.highlightedMessage : toolTip.unHighlightedMessage;
    const ariaLabelContent = isHighlighted ? ariaLabel.highlightedLabel : ariaLabel.unHighlightedLabel;
    const { HighlightedIcon: HighlightedIcon, UnHighlightedIcon: UnHighlightedIcon } = icon;
    return /*#__PURE__*/ $fc4bM.createElement($45a6cc28c11ab8c3$var$HighlighterButtonContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $bcTS3.default), {
        content: toolTipMessage,
        position: "top",
        "aria-hidden": "true",
        hasNewContentOnTriggerClick: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.Button), {
        type: "button",
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "project-card-action-button",
        onClick: highlightHandler,
        actionSubjectId: actionSubjectId,
        iconBefore: isHighlighted ? /*#__PURE__*/ $fc4bM.createElement(HighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.highlightedColor,
            size: "medium"
        }) : /*#__PURE__*/ $fc4bM.createElement(UnHighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.unHighlightedColor,
            size: "medium"
        })
    })));
};
var $45a6cc28c11ab8c3$export$2e2bcd8739ae039 = /*#__PURE__*/ $fc4bM.memo($45a6cc28c11ab8c3$export$7cc17c9bd3240823);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $45a6cc28c11ab8c3$var$HighlighterButtonContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1h5r30-0"
})`background:transparent;border:0;cursor:pointer;z-index:${(0, $5ZHKM.layer)};`;

});


parcelRegister("3Q3UJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad6bc939fa088c881fa9ff72e2efb30f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cb943aa1624b68b$var$_react = $2cb943aa1624b68b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2cb943aa1624b68b$var$_iconNew = $2cb943aa1624b68b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2cb943aa1624b68b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open-filled
 * Usage guidance:
 * Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cb943aa1624b68b$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $2cb943aa1624b68b$var$_react.default.createElement($2cb943aa1624b68b$var$_iconNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$2cb943aa1624b68b$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $2cb943aa1624b68b$var$_default = module.exports.default = $2cb943aa1624b68b$var$EyeOpenFilledIcon;

});

parcelRegister("79dju", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a129094cdf1de5a$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $6a129094cdf1de5a$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    featuredProjectTooltip: {
        defaultMessage: 'Remove from featured section',
        description: 'Tootip message when hovered on remove from featured button',
        id: 'cv.portal.reordering.experience.featured.card.tooltip'
    },
    unFeaturedProjectTooltip: {
        defaultMessage: 'Feature this portal',
        description: 'Tootip message when hovered on feature portal button',
        id: 'cv.portal.reordering.experience.unfeatured.card.tooltip'
    },
    visibleProjectTooltip: {
        defaultMessage: 'Hide from home page',
        description: 'Tootip message when hovered on hide button',
        id: 'cv.portal.reordering.experience.shown.card.tooltip.non-final'
    },
    hiddenProjectTooltip: {
        defaultMessage: 'Show on home page',
        description: 'Tootip message when hovered on show project button',
        id: 'cv.portal.reordering.experience.hidden.card.tooltip.non-final'
    },
    screenReaderInstructionsForReordering: {
        defaultMessage: 'Press space to pick up a portal. Use the up and down arrow keys to move it to a new position. Press space or enter to drop it in a new position, or press escape to cancel',
        description: 'message to be readout by screen reader when a project card is focused',
        id: 'cv.portal.reordering.experience.screen.reader.instruction'
    }
});

});




parcelRegister("bdhRL", function(module, exports) {
$parcel$export(module.exports, "titleSkeletonHeight", () => $5b0be6d24c096ce3$export$627219b6093d39c1);
$parcel$export(module.exports, "IconContainer", () => (parcelRequire("dBgE8")).IconContainer);
$parcel$export(module.exports, "Content", () => (parcelRequire("dBgE8")).Content);
$parcel$export(module.exports, "Container", () => (parcelRequire("dBgE8")).Container);

var $dBgE8 = parcelRequire("dBgE8");
const $5b0be6d24c096ce3$export$627219b6093d39c1 = '21px';

});



parcelRegister("8AFbH", function(module, exports) {
$parcel$export(module.exports, "ActionBarWithButtonsStateless", () => (parcelRequire("9TIDs")).default);

var $9TIDs = parcelRequire("9TIDs");

});
parcelRegister("9TIDs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cd5c5c167c1cf69$export$2e2bcd8739ae039);
/* action-bar-with-buttons-stateless.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $MPQAF = parcelRequire("MPQAF");

var $fOCtI = parcelRequire("fOCtI");

var $fcCIH = parcelRequire("fcCIH");

var $lHYHS = parcelRequire("lHYHS");

var $1hJdJ = parcelRequire("1hJdJ");

var $byPAM = parcelRequire("byPAM");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $9n6Xx = parcelRequire("9n6Xx");
const $2cd5c5c167c1cf69$export$f749d3fa2628ac53 = ({ intl: intl, isDirty: isDirty, openCancelPrompt: openCancelPrompt, openPublishPrompt: openPublishPrompt })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $byPAM.default), {
        name: "portal-reordering-action-buttons"
    }, /*#__PURE__*/ $fc4bM.createElement($2cd5c5c167c1cf69$var$ButtonContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $lHYHS.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.Button), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "portal-reordering-cancel-button",
        onClick: openCancelPrompt,
        actionSubjectId: "cancelPortalsReorder",
        "data-test-id": "cancel-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $9n6Xx.default).cancelButtonLabel)), /*#__PURE__*/ $fc4bM.createElement((0, $MPQAF.Button), {
        appearance: "primary",
        isDisabled: !isDirty,
        onClick: openPublishPrompt,
        actionSubjectId: "publishPortalsReorder",
        "data-test-id": "publish-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $9n6Xx.default).publishButtonLabel)))));
};
class $2cd5c5c167c1cf69$export$ec006b65f267cb6c extends $fc4bM.Component {
    renderHeading() {
        const { intl: intl } = this.props;
        if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) return intl.formatMessage((0, $9n6Xx.default).actionBarTitleCSM);
        return intl.formatMessage((0, $9n6Xx.default).actionBarTitleNew);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement($2cd5c5c167c1cf69$var$Wrapper, null, /*#__PURE__*/ $fc4bM.createElement($2cd5c5c167c1cf69$var$PageHeaderWrapper, null, /*#__PURE__*/ $fc4bM.createElement($2cd5c5c167c1cf69$var$PageHeader, null, /*#__PURE__*/ $fc4bM.createElement($2cd5c5c167c1cf69$var$Title, null, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
            size: "medium",
            as: "div"
        }, this.renderHeading())), /*#__PURE__*/ $fc4bM.createElement($2cd5c5c167c1cf69$export$f749d3fa2628ac53, this.props)), children));
    }
}
var $2cd5c5c167c1cf69$export$2e2bcd8739ae039 = (0, $fcCIH.default)($2cd5c5c167c1cf69$export$ec006b65f267cb6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2cd5c5c167c1cf69$var$Wrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_16qs1viy _1pby16oo _154iidpf _1ltvidpf _1bsb1osq _kqsw1n9t _bfhk1bhr _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $2cd5c5c167c1cf69$var$PageHeaderWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1jphezo": (0, $8xbhL.default)($fOCtI.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt4zdiv _1bsb1osq _1bah1h6o _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $2cd5c5c167c1cf69$var$ButtonContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b2vlsk": (0, $8xbhL.default)($fOCtI.multiple(96).px)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt41b66 _p12feuys",
            __cmplp.className
        ])
    });
});
const $2cd5c5c167c1cf69$var$Title = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19pkidpf _otyrpxbi _19zoidpf",
            __cmplp.className
        ])
    });
});
const $2cd5c5c167c1cf69$var$PageHeader = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_18s8r2fv _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1yb4 _tyxhvrvc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lHYHS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $64edf3ceaf1a418e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");
function $64edf3ceaf1a418e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64edf3ceaf1a418e$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $64edf3ceaf1a418e$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $64edf3ceaf1a418e$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("9n6Xx", function(module, exports) {
$parcel$export(module.exports, "default", () => $158ddd6a57329134$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $158ddd6a57329134$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    actionBarTitle: {
        defaultMessage: 'Edit home page layout',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title'
    },
    actionBarTitleNew: {
        defaultMessage: 'Manage topics and portals',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title.topics.portals'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    actionBarTitleCSM: {
        defaultMessage: 'Manage topics',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title-csm.topics.portals'
    },
    cancelButtonLabel: {
        defaultMessage: 'Cancel',
        description: 'Label of cancel button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.cancel'
    },
    publishButtonLabel: {
        defaultMessage: 'Publish layout',
        description: 'Label of publish button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.publish'
    }
});

});



parcelRegister("cUefK", function(module, exports) {
$parcel$export(module.exports, "SortByFilter", () => (parcelRequire("7l4iG")).default);

var $7l4iG = parcelRequire("7l4iG");

});
parcelRegister("7l4iG", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcea42cfe8d21a5b$export$2e2bcd8739ae039);
/* sort-by-filter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $g43xT = parcelRequire("g43xT");

var $fOCtI = parcelRequire("fOCtI");

var $fcCIH = parcelRequire("fcCIH");

var $1hJdJ = parcelRequire("1hJdJ");

var $byPAM = parcelRequire("byPAM");

var $bw2Ix = parcelRequire("bw2Ix");
const $bcea42cfe8d21a5b$var$selectCustomStyle = {
    container: (provided)=>({
            ...provided,
            marginLeft: "var(--ds-space-200, 16px)",
            width: $fOCtI.multiple(18).px
        })
};
const $bcea42cfe8d21a5b$export$38d77f5667d0a049 = ({ intl: intl, isDisabled: isDisabled, value: value, shouldHideLabel: shouldHideLabel, onChange: onChange })=>{
    const sortBySelectOptions = {
        ALPHABETICALLY: intl.formatMessage((0, $bw2Ix.default).alphabeticOption),
        POPULARITY: intl.formatMessage((0, $bw2Ix.default).popularityOption)
    };
    const options = Object.entries(sortBySelectOptions).map(([key, label])=>({
            label: label,
            value: key
        }));
    const sortByChange = $fc4bM.useCallback((option)=>{
        if (option && option.value !== value) onChange(option.value);
    }, [
        onChange,
        value
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $byPAM.default), {
        name: "sort-by-filter"
    }, /*#__PURE__*/ $fc4bM.createElement($bcea42cfe8d21a5b$var$FilterWrapper, null, /*#__PURE__*/ $fc4bM.createElement($bcea42cfe8d21a5b$var$FilterContent, null, !shouldHideLabel && /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ $fc4bM.createElement("label", {
        htmlFor: "sort-by-filter"
    }, intl.formatMessage((0, $bw2Ix.default).sortByFilterLabel))), /*#__PURE__*/ $fc4bM.createElement((0, $g43xT.Select), {
        classNamePrefix: "portal-reorder-experience-sort-by-filter",
        actionSubjectId: "sortByFilter",
        value: {
            value: value,
            label: sortBySelectOptions[value]
        },
        options: options,
        styles: $bcea42cfe8d21a5b$var$selectCustomStyle,
        isSearchable: false,
        isDisabled: isDisabled,
        onChange: sortByChange,
        inputId: "sort-by-filter",
        instanceId: "sort-by-filter"
    }))));
};
var $bcea42cfe8d21a5b$export$2e2bcd8739ae039 = /*#__PURE__*/ $fc4bM.memo((0, $fcCIH.default)($bcea42cfe8d21a5b$export$38d77f5667d0a049));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bcea42cfe8d21a5b$var$FilterWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8vhf38": (0, $8xbhL.default)($fOCtI.multiple(28).px)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1bsb1sn1 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _18u0mgjw",
            __cmplp.className
        ])
    });
});
const $bcea42cfe8d21a5b$var$FilterContent = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _4cvr1h6o _18u01jfw _89vyidpf _5rvhidpf _32nkidpf _wws0idpf _nw4oangw _1t2qnoz8 _r5bjidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g43xT", function(module, exports) {
$parcel$export(module.exports, "Select", () => $a5e340aba04b4063$export$ef9b1a59e592288f);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $5vDl3 = parcelRequire("5vDl3");
class $a5e340aba04b4063$export$ef9b1a59e592288f extends $fc4bM.PureComponent {
    render() {
        const { actionSubjectId: actionSubjectId, ...selectProps } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: {
                actionSubjectId: actionSubjectId
            }
        }, /*#__PURE__*/ $fc4bM.createElement((0, $5vDl3.default), selectProps));
    }
}

});

parcelRegister("bw2Ix", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d24d841be94f0cb$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $5d24d841be94f0cb$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    sortByFilterLabel: {
        defaultMessage: 'Sort by',
        description: 'Label for the sort by dropdown filter in the portal reorder experience',
        id: 'cv.portal.reordering.experience.sortBy.filter.label'
    },
    popularityOption: {
        defaultMessage: 'Popularity',
        description: 'Label for the sort by popularity option',
        id: 'cv.portal.reordering.experience.sortBy.filter.popularity.label'
    },
    alphabeticOption: {
        defaultMessage: 'Name: A to Z',
        description: 'Label for the sort by alphabetical option',
        id: 'cv.portal.reordering.experience.sortBy.filter.alphabetical.label'
    }
});

});



parcelRegister("k1GO8", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $92b0cb2ca7b86672$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "ExperienceContainer", () => $92b0cb2ca7b86672$export$4d17725865d2ba3c);
$parcel$export(module.exports, "CardsContainer", () => $92b0cb2ca7b86672$export$8e547173d545e862);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $fOCtI = parcelRequire("fOCtI");

var $ku1lj = parcelRequire("ku1lj");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $92b0cb2ca7b86672$var$HEADER_HEIGHT = `${$fOCtI.multiple(10).px}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $92b0cb2ca7b86672$var$WRAPPER_MIN_HEIGHT = `calc(100vh - ${(0, $ku1lj.FOOTER_HEIGHT)}px - ${$92b0cb2ca7b86672$var$HEADER_HEIGHT})`;
const $92b0cb2ca7b86672$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ans5n9": (0, $8xbhL.default)($92b0cb2ca7b86672$var$WRAPPER_MIN_HEIGHT)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1yt41r39 _1tke1j5i _138y1jfw",
            __cmplp.className
        ])
    });
});
const $92b0cb2ca7b86672$export$4d17725865d2ba3c = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ebxqrc": (0, $8xbhL.default)($fOCtI.multiple(42).px),
            "--_1l8apj8": (0, $8xbhL.default)($fOCtI.multiple(90).px),
            "--_1jphezo": (0, $8xbhL.default)($fOCtI.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _kqswh2mm _19pk1ejb _p12ffptw _hclcjj99 _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $92b0cb2ca7b86672$export$8e547173d545e862 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1aqg72h": (0, $8xbhL.default)($fOCtI.multiple(-5).px)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_18s81u5k _19itg9nf _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1n261g80 _kqswh2mm _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2sf66", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca50955f7b7b7244$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ca50955f7b7b7244$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    featuredPortalsTitle: {
        defaultMessage: 'Featured',
        description: 'Title for featured portals loader section',
        id: 'cv.portal.reordering.experience.loader.featured.portals.title'
    }
});

});



parcelRegister("373cy", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5Flnk"),
    $9dnsd("4cJBF"),
    $9dnsd("VNsDq"),
    $9dnsd("hgR6q"),
    $9dnsd("ed06v"),
    $9dnsd("lWdqq"),
    $9dnsd("lv25e"),
    $9dnsd("hCVB4"),
    $9dnsd("cAuei"),
    $9dnsd("8IYZ8"),
    $9dnsd("2g5QR"),
    $9dnsd("jUsD2"),
    $9dnsd("2KLau"),
    $9dnsd("dQB15"),
    $9dnsd("cUraa"),
    $9dnsd("ciGzL"),
    $9dnsd("h566j"),
    $9dnsd("1AKkv"),
    $9dnsd("6VzBn"),
    $9dnsd("aejHq"),
    $9dnsd("g80ld"),
    $9dnsd("kaxju"),
    $9dnsd("gQ9dB")
]).then(()=>parcelRequire('2hS5m'));

});


parcelRegister("bGHjz", function(module, exports) {
$parcel$export(module.exports, "helpEditTopicsResource", () => $e631bccbce813b93$export$8b5129935a2eae3c);
$parcel$export(module.exports, "hiddenSectionWarningResource", () => $e631bccbce813b93$export$79066689501876c);

var $eoYgn = parcelRequire("eoYgn");

var $NwHH4 = parcelRequire("NwHH4");

var $8zK3E = parcelRequire("8zK3E");
const $e631bccbce813b93$export$8b5129935a2eae3c = (0, $8zK3E.createRelayResource)({
    type: 'EDIT_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $eoYgn.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});
const $e631bccbce813b93$export$79066689501876c = (0, $8zK3E.createRelayResource)({
    type: 'HIDDEN_LAYOUT_SECTION_WARNING',
    getQuery: (_, { cloudId: cloudId, layoutAri: layoutAri })=>({
            parameters: (0, $NwHH4.default),
            variables: {
                cloudId: cloudId,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("eoYgn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1544219b371b5b9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79f064f566608c64fe4afe3c780b232c>>
 * @relayHash 2b93fcbc8c19a342658c7aff002a8cd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1
const $1544219b371b5b9e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sortableTopicsContainerFragment"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "hiddenTopicsExpandedFragment"
                                        },
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "editableTopicFragment"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 3
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "items(first:3)"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "order"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1",
            "metadata": {},
            "name": "topicsEditQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1544219b371b5b9e$var$node.hash = "ccda9262ffa2b20f017478c5ac8b7353";
var $1544219b371b5b9e$export$2e2bcd8739ae039 = $1544219b371b5b9e$var$node;

});

parcelRegister("NwHH4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0adaac3e8ed65455$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1517e57be5d4aea1e7182378d54efdc1>>
 * @relayHash 186c8bbb9834e8623ccdc1e2f59099c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78
const $0adaac3e8ed65455$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "layoutAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v3 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hidden"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v2 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "HelpLayoutSectionConnection",
                                                "kind": "LinkedField",
                                                "name": "sections",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "HelpLayoutSectionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSection",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v3 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "HelpLayoutSubsection",
                                                                        "kind": "LinkedField",
                                                                        "name": "subsections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "elements",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v4 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayout"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78",
            "metadata": {},
            "name": "hiddenLayoutSectionWarningQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0adaac3e8ed65455$var$node.hash = "f2fd5d711a9bee2d942b12cdd41c9d79";
var $0adaac3e8ed65455$export$2e2bcd8739ae039 = $0adaac3e8ed65455$var$node;

});





parcelRegister("jyAYs", function(module, exports) {
$parcel$export(module.exports, "EditHomepageV2Resource", () => $bee26cfa1495f4cb$export$3e8c7fe01574cb7a);

var $5300k = parcelRequire("5300k");

var $8zK3E = parcelRequire("8zK3E");
const $bee26cfa1495f4cb$export$3e8c7fe01574cb7a = (0, $8zK3E.createRelayResource)({
    type: 'EDIT_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $5300k.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("5300k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9902969989c8a137$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bf616c28e62c7c65a524ac219b76e27>>
 * @relayHash 212a5d5e632802bde54e59d17573c070
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 79f56f1ec11b4cd0e0c952f194e9e5a31cfa81fc6ead00da309b64fc3ef6f1a6
const $9902969989c8a137$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v7 = {
        "alias": "layoutId",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpLayoutSubsectionConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "span"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "adf"
    }, v10 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v11 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v12 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v20 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "useLayoutServiceVisualConfigData",
                "selections": v21 /*: any*/ ,
                "argumentDefinitions": []
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "useGlobalSettings"
    }, v24 = [
        v22 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "expandButtonTextColor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "forgeElementPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "forgeElementType"
    }, v28 = {
        "kind": "ScalarField",
        "name": "connectElementPage"
    }, v29 = {
        "kind": "ScalarField",
        "name": "connectElementType"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v33 = [
        v14 /*: any*/ ,
        v13 /*: any*/ 
    ], v34 = {
        "kind": "ScalarField",
        "name": "id"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v37 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v38 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v39 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v40 = [
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v42 = {
        "kind": "ScalarField",
        "name": "key"
    }, v43 = {
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v45 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v46 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v47 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v48 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v49 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v50 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v51 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalBrandingSettingsPanelFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "pageBuilderFragment"
                                            },
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "useLayoutServiceFragment",
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpLayoutSectionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "HelpLayoutSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "HelpLayoutSubsection",
                                                                                "kind": "LinkedField",
                                                                                "name": "subsections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v8 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "elements",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceEditorElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v9 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutEditorElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceHeroElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v23 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutHeroElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceAnnouncementElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceTopicsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutTopicsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceListOfPortalsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v25 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceForgeElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v26 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutForgeElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceConnectElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            v29 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutConnectElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceBreadcrumbElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutBreadcrumbElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v22 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v22 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v31 /*: any*/ 
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageBuilderMediaConfigFragment"
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "elementsCatalogueFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v34 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v44 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v34 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        },
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extensions",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCode"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v41 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v39 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "79f56f1ec11b4cd0e0c952f194e9e5a31cfa81fc6ead00da309b64fc3ef6f1a6",
            "metadata": {},
            "name": "editHomepageV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9902969989c8a137$var$node.hash = "a727ab2637500ee1215ac6f7895b25c2";
var $9902969989c8a137$export$2e2bcd8739ae039 = $9902969989c8a137$var$node;

});


parcelRegister("oEu1q", function(module, exports) {
$parcel$export(module.exports, "brandingResource", () => $3c51237a615d66b7$export$407a6849bf62b25c);
/*
These resources are a temporary solution to help with the server side rendering of multi help center home page.
This module will not be needed, once we move to the Flexible home page built on top of the Layout system.
*/ 
var $eXcu8 = parcelRequire("eXcu8");

var $4OMBM = parcelRequire("4OMBM");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");

var $5KQKg = parcelRequire("5KQKg");
parcelRequire("csZtW");
var $gD2hW = parcelRequire("gD2hW");
parcelRequire("jjuxZ");
var $gwluP = parcelRequire("gwluP");

var $gQ5cR = parcelRequire("gQ5cR");

var $bJx48 = parcelRequire("bJx48");

var $eKtVN = parcelRequire("eKtVN");

var $k2M4v = parcelRequire("k2M4v");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $3O0Ex = parcelRequire("3O0Ex");


var $8zK3E = parcelRequire("8zK3E");
const $3c51237a615d66b7$var$JSM_SSR_NON_DEFAULT_HC_BRANDING = 'jsm_help_center_ssr_non_default_hc_branding';
const $3c51237a615d66b7$var$isJsmSSRNonDefaultHCBrandingEnabled = ()=>(0, $k2M4v.default).checkGate($3c51237a615d66b7$var$JSM_SSR_NON_DEFAULT_HC_BRANDING);
const $3c51237a615d66b7$var$getBrandingKey = (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
    const request = (0, $5KQKg.getRequest)((0, $eKtVN.default));
    const params = request.params;
    return `${String(params.id)}${JSON.stringify({
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    })}`;
};
const $3c51237a615d66b7$export$407a6849bf62b25c = (0, $fOvEc.createResource)({
    type: 'RELAY_HELP_CENTER_BRANDING',
    getKey: $3c51237a615d66b7$var$getBrandingKey,
    getData: ()=>{
        (0, $4OMBM.store).dispatch((0, $eXcu8.fetchHelpCenterBrandingAction)());
        return Promise.resolve(null);
    }
});
const $3c51237a615d66b7$export$e009cd2a6d5e5a45 = (0, $fOvEc.createResource)({
    type: 'RELAY_JSM_NON_DEFAULT_HELP_CENTER_BRANDING',
    getKey: $3c51237a615d66b7$var$getBrandingKey,
    getData: ()=>{
        if (!$3c51237a615d66b7$var$isJsmSSRNonDefaultHCBrandingEnabled() || (0, $cf3fd.isDefaultHelpCenter)() || (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) return Promise.resolve(null);
        const brandingPromise = (0, $3O0Ex.fetchBrandingData)().toPromise().then((response)=>{
            const branding = (0, $3O0Ex.convertToHCBrandingResponse)(response);
            if (branding) (0, $4OMBM.store).dispatch((0, $gwluP.updateHCBrandingModelAction)(branding));
            (0, $4OMBM.store).dispatch((0, $gwluP.updateHCBrandingLoaderAction)(true));
            return null;
        }).catch(()=>{
            (0, $4OMBM.store).dispatch((0, $gwluP.updateHCBrandingLoaderAction)(true));
            return null;
        });
        return brandingPromise;
    }
});
const $3c51237a615d66b7$export$19af4b0b8cda6b11 = (0, $fOvEc.createResource)({
    type: 'RELAY_HELP_CENTER_PORTALS',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $5KQKg.getRequest)((0, $bJx48.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $4OMBM.store).dispatch((0, $gD2hW.fetchFeaturedAndSortedPortalsModel)({}, false));
        return Promise.resolve(null);
    }
});
const $3c51237a615d66b7$export$b08096b7aea23d43 = (0, $8zK3E.createRelayResource)({
    type: 'HELP_CENTER_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $gQ5cR.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("gQ5cR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2b94abf5c012846$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0932329082ebc356c0b0ebaf8fd46cc>>
 * @relayHash da0c9595f56db7cf97a352c0fe8277b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364
const $b2b94abf5c012846$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicFragment"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364",
            "metadata": {},
            "name": "topicsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b2b94abf5c012846$var$node.hash = "6c3fee571c0b47bf0526627e402d85f8";
var $b2b94abf5c012846$export$2e2bcd8739ae039 = $b2b94abf5c012846$var$node;

});


parcelRegister("330UU", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gP2dE"),
    $9dnsd("aenbe"),
    $9dnsd("5Flnk"),
    $9dnsd("hgR6q"),
    $9dnsd("2g5QR"),
    $9dnsd("5jDDb")
]).then(()=>parcelRequire('42PrP'));

});

parcelRegister("h84iT", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gP2dE"),
    $9dnsd("aenbe"),
    $9dnsd("5Flnk"),
    $9dnsd("hgR6q"),
    $9dnsd("2g5QR"),
    $9dnsd("giGRB")
]).then(()=>parcelRequire('7MsI8'));

});

parcelRegister("84Thx", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gP2dE"),
    $9dnsd("5Flnk"),
    $9dnsd("4cJBF"),
    $9dnsd("VNsDq"),
    $9dnsd("hgR6q"),
    $9dnsd("ed06v"),
    $9dnsd("lv25e"),
    $9dnsd("hCVB4"),
    $9dnsd("cAuei"),
    $9dnsd("8IYZ8"),
    $9dnsd("2g5QR"),
    $9dnsd("jUsD2"),
    $9dnsd("2KLau"),
    $9dnsd("dQB15"),
    $9dnsd("ciGzL"),
    $9dnsd("h566j"),
    $9dnsd("1AKkv"),
    $9dnsd("6VzBn"),
    $9dnsd("aejHq"),
    $9dnsd("g80ld"),
    $9dnsd("kaxju"),
    $9dnsd("67gVZ")
]).then(()=>parcelRequire('cBCnH'));

});


parcelRegister("iidRB", function(module, exports) {
$parcel$export(module.exports, "aiAnswerRoute", () => $4af701cdb60b8f0b$export$aa89d187b9409394);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $9J2wU = parcelRequire("9J2wU");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");

var $d60Kz = parcelRequire("d60Kz");

var $a3bin = parcelRequire("a3bin");

var $dkrfZ = parcelRequire("dkrfZ");

var $diqlM = parcelRequire("diqlM");

var $joDHD = parcelRequire("joDHD");

var $ivtaS = parcelRequire("ivtaS");
const $4af701cdb60b8f0b$var$RenderAiAnswerRoute = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkrfZ.default), {
        screenName: (0, $9mazR.ScreenName).AI_ANSWER,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4xX38.default), {
        screenName: (0, $9mazR.ScreenName).AI_ANSWER,
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9J2wU.default), {
                error: {
                    status: 500,
                    message: formatMessage((0, $a3bin.default).genericErrorMessage),
                    callToActionUrl: '/servicedesk/customer/portals'.replace((0, $diqlM.getBaseName)(), ''),
                    callToActionText: formatMessage((0, $a3bin.default).genericRedirectMessage)
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d60Kz.AiAnswerFeedbackPage), null)));
};
const $4af701cdb60b8f0b$var$route = {
    name: (0, $9mazR.ScreenName).AI_ANSWER,
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/:requestKey/aianswer`,
    exact: true,
    component: $4af701cdb60b8f0b$var$RenderAiAnswerRoute
};
const $4af701cdb60b8f0b$var$screenName = (0, $9mazR.ScreenName).AI_ANSWER;
const $4af701cdb60b8f0b$export$aa89d187b9409394 = (0, $joDHD.createRouteWithLayout)($4af701cdb60b8f0b$var$route, $4af701cdb60b8f0b$var$screenName, (0, $ivtaS.anonymousScreenLayout));

});
parcelRegister("d60Kz", function(module, exports) {
$parcel$export(module.exports, "AiAnswerFeedbackPage", () => $9cffa61779aacf8a$export$589a347fe318e529);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $9cffa61779aacf8a$export$589a347fe318e529 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("7ceH1")), {
        moduleId: "./packages/virtual-agent/ai-answer/src/ui/ai-answer-feedback-page/hocs.tsx"
    })
});

});
parcelRegister("7ceH1", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1ne6N"),
    $9dnsd("fqZtg")
]).then(()=>parcelRequire('c5FFL'));

});


parcelRegister("a3bin", function(module, exports) {
$parcel$export(module.exports, "default", () => $265eb9117952edd6$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $265eb9117952edd6$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    helpfulPageHeading: {
        id: 'ai-answer.feedback-form.helpful-page-heading',
        defaultMessage: 'Awesome!',
        description: 'Heading for the feedback form helpful page'
    },
    helpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.helpful-page-sub-heading',
        defaultMessage: 'Glad we could help.',
        description: 'Subheading for the feedback form helpful page'
    },
    nonHelpfulPageHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-heading',
        defaultMessage: "Sorry, it wasn\u2019t helpful.",
        description: 'Heading for the feedback form non-helpful page'
    },
    nonHelpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-sub-heading',
        defaultMessage: "We're working on your request.",
        description: 'Subheading for the feedback form non-helpful page'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    additionalFeedbackCTALabel: {
        id: 'ai-answer.feedback-form.additional-feedback-label',
        defaultMessage: 'Give additional feedback',
        description: 'Label for the additional feedback button'
    },
    feedbackTitle: {
        id: 'ai-answer.feedback-form.feedback-title',
        defaultMessage: 'Help us improve',
        description: 'The text is shown as the title heading of the feedback dialog that appears when a user wants to provide feedback on an AI-generated answer.'
    },
    sendFeedbackLabel: {
        defaultMessage: 'Send Feedback',
        description: 'Feedback dialog Submit button label',
        id: 'ai-answer.feedback-form.feedback-submit-button-label'
    },
    cancelLabel: {
        defaultMessage: 'Cancel',
        description: 'Feedback dialog cancel button label',
        id: 'ai-answer.feedback-form.feedback-cancel-button-label'
    },
    contactLabel: {
        defaultMessage: 'Contact me for more details about this feedback',
        description: 'Feedback dialog can contact label',
        id: 'ai-answer.feedback-form.feedback-can-contact-label'
    },
    summary: {
        defaultMessage: 'Summary',
        description: 'Label for the summary text field in the feedback dialog',
        id: 'ai-answer.feedback-form.feedback-summary'
    },
    subHeading: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Sub-heading in the feedback dialog indicating required fields are marked with an asterisk',
        id: 'ai-answer.feedback-form.feedback-sub-heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-heading'
    },
    genericRedirectMessage: {
        defaultMessage: 'Go to the portal.',
        description: 'Generic redirect link message when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-redirect-message'
    },
    summaryPlaceholder: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Message which will be shown inside the summary text field',
        id: 'ai-answer.feedback-form.feedback-summary-placeholder'
    },
    enrolInResearchLabel: {
        defaultMessage: "I'd like to participate in product research",
        description: 'Message which will be shown next to the enrol in research checkbox',
        id: 'ai-answer.feedback-form.feedback-enrol-in-research-label'
    }
});

});


parcelRegister("fQ6nv", function(module, exports) {
$parcel$export(module.exports, "approvalsRoute", () => $d9d5254d05143b38$export$ee55f71d9820cd66);

var $9mazR = parcelRequire("9mazR");

var $kYptZ = parcelRequire("kYptZ");

var $joDHD = parcelRequire("joDHD");
const $d9d5254d05143b38$var$route = {
    name: 'user-approvals',
    path: `/user/approvals`,
    exact: true,
    component: (0, $kYptZ.ApprovalList)
};
const $d9d5254d05143b38$var$screenName = (0, $9mazR.ScreenName).APPROVAL_LIST;
const $d9d5254d05143b38$var$paperAppearance = 'wide';
const $d9d5254d05143b38$var$layoutProps = {
    paperAppearance: $d9d5254d05143b38$var$paperAppearance,
    fadeInSearchModal: true
};
const $d9d5254d05143b38$export$ee55f71d9820cd66 = (0, $joDHD.createRouteWithLayout)($d9d5254d05143b38$var$route, $d9d5254d05143b38$var$screenName, $d9d5254d05143b38$var$layoutProps);

});
parcelRegister("kYptZ", function(module, exports) {
$parcel$export(module.exports, "ApprovalList", () => $744ccb7fc7c05518$export$dfa534f59b1c1487);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $744ccb7fc7c05518$export$dfa534f59b1c1487 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("jajgH")), {
        moduleId: "./src/view/approval-list/approval-list.tsx"
    })
});

});
parcelRegister("jajgH", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("lWGLS").then(()=>parcelRequire('f6iLZ'));

});



parcelRegister("8Nv7y", function(module, exports) {
$parcel$export(module.exports, "consentFormRoute", () => $0313b19a617c97b7$export$f978586bc0d52692);

var $9mazR = parcelRequire("9mazR");

var $2Ae5y = parcelRequire("2Ae5y");

var $joDHD = parcelRequire("joDHD");
const $0313b19a617c97b7$var$consentForm = {
    resources: [],
    name: 'consent-form',
    path: `/user/consent`,
    exact: true,
    component: (0, $2Ae5y.ConsentForm)
};
const $0313b19a617c97b7$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true
};
const $0313b19a617c97b7$export$f978586bc0d52692 = (0, $joDHD.createRouteWithLayout)($0313b19a617c97b7$var$consentForm, (0, $9mazR.ScreenName).CONSENT_FORM_PAGE, $0313b19a617c97b7$var$layoutProps);

});
parcelRegister("2Ae5y", function(module, exports) {
$parcel$export(module.exports, "ConsentForm", () => $3c4ae2097bd7bd7d$export$723d7f2fb08b9d80);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $3c4ae2097bd7bd7d$export$723d7f2fb08b9d80 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("4xrf5")), {
        moduleId: "./src/view/consent-form/hocs.tsx"
    })
});

});
parcelRegister("4xrf5", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8OgDF").then(()=>parcelRequire('aRSg6'));

});



parcelRegister("5u1WA", function(module, exports) {
$parcel$export(module.exports, "csmContactUsRoute", () => $b45ceb7a3a30c76c$export$3979346dcb7ef96d);

var $9mazR = parcelRequire("9mazR");

var $8SQxC = parcelRequire("8SQxC");

var $6kWsJ = parcelRequire("6kWsJ");

var $joDHD = parcelRequire("joDHD");
const $b45ceb7a3a30c76c$var$contactUs = {
    resources: [
        (0, $6kWsJ.mediaUploadCredentialsResource)
    ],
    name: (0, $9mazR.RouteName).CSM_CONTACT_US_PAGE,
    path: (0, $9mazR.RoutePath).CSM_CONTACT_US_PATH,
    exact: true,
    component: (0, $8SQxC.CsmContactUs)
};
const $b45ceb7a3a30c76c$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $b45ceb7a3a30c76c$export$3979346dcb7ef96d = (0, $joDHD.createRouteWithLayout)($b45ceb7a3a30c76c$var$contactUs, (0, $9mazR.ScreenName).CSM_CONTACT_US, $b45ceb7a3a30c76c$var$layoutProps);

});
parcelRegister("8SQxC", function(module, exports) {
$parcel$export(module.exports, "CsmContactUs", () => $8df46118c31d73ae$export$961253a0ef353f1);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $8df46118c31d73ae$export$961253a0ef353f1 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("3TERD")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/ui/csm-contact-page.tsx"
    })
});

});
parcelRegister("3TERD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("e2nF0"),
    $9dnsd("bmLFd"),
    $9dnsd("jsVEa"),
    $9dnsd("9Fw1L"),
    $9dnsd("kE1ct"),
    $9dnsd("39YZp"),
    $9dnsd("5nj3m"),
    $9dnsd("hHYFE"),
    $9dnsd("6VzBn"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("bMKAA"),
    $9dnsd("8QEJW"),
    $9dnsd("6vflX")
]).then(()=>parcelRequire('9WDxX'));

});


parcelRegister("6kWsJ", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $3501614815d1e8aa$export$fac4b16282dd90f6);

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");

var $4MoYu = parcelRequire("4MoYu");

var $c0Y6o = parcelRequire("c0Y6o");
const $3501614815d1e8aa$export$fac4b16282dd90f6 = (0, $fOvEc.createResource)({
    type: 'MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-upload-credentials`,
    getData: async ()=>{
        const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
        return (0, $c0Y6o.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});


parcelRegister("5OVHl", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $cb1aa973a018c899$export$3dddbf9f405aac5c);

var $9mazR = parcelRequire("9mazR");

var $8bJBz = parcelRequire("8bJBz");

var $joDHD = parcelRequire("joDHD");
parcelRequire("79xHh");
var $6wcnv = parcelRequire("6wcnv");

var $oEu1q = parcelRequire("oEu1q");
const $cb1aa973a018c899$export$3dddbf9f405aac5c = (name = (0, $9mazR.RouteName).VIEW_CUSTOM_PAGE, path = (0, $9mazR.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $oEu1q.brandingResource),
        (0, $8bJBz.ViewCustomPageResource)
    ];
    return (0, $joDHD.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: (0, $6wcnv.ViewCustomPageWithAiAgent),
        resources: [
            (0, $8bJBz.ViewCustomPageResource)
        ]
    }, (0, $9mazR.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};

});
parcelRegister("8bJBz", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPageResource", () => $1e4dc2be7c93fed5$export$15c85a1b3a2577c9);

var $6LH8a = parcelRequire("6LH8a");

var $gK5mb = parcelRequire("gK5mb");

var $8zK3E = parcelRequire("8zK3E");

var $k9E65 = parcelRequire("k9E65");
const $1e4dc2be7c93fed5$export$15c85a1b3a2577c9 = (0, $8zK3E.createRelayResource)({
    type: 'VIEW_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id || '';
        const helpCenterPageAri = (0, $gK5mb.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $6LH8a.getActivationId)()
        }).toString();
        return {
            parameters: (0, $k9E65.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("gK5mb", function(module, exports) {
$parcel$export(module.exports, "HelpPageAri", () => $c30518f7fc751ba1$export$7855a3c68b5a0b04);

var $9SZfe = parcelRequire("9SZfe");

var $bDhZ4 = parcelRequire("bDhZ4");

var $4UxLu = parcelRequire("4UxLu");
// src/help/page/manifest.ts
var $c30518f7fc751ba1$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $9SZfe.HelpPageAriResourceOwner),
    resourceType: (0, $9SZfe.HelpPageAriResourceType),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $c30518f7fc751ba1$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $bDhZ4.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c30518f7fc751ba1$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $c30518f7fc751ba1$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c30518f7fc751ba1$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $c30518f7fc751ba1$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $4UxLu.AriParser).fromOpts(derivedOpts, $c30518f7fc751ba1$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $4UxLu.AriParser).fromString(maybeAri, $c30518f7fc751ba1$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("9SZfe", function(module, exports) {
$parcel$export(module.exports, "HelpPageAriResourceOwner", () => $7328aa22740bb348$export$b6fe1f05324d51ea);
$parcel$export(module.exports, "HelpPageAriResourceType", () => $7328aa22740bb348$export$e6c9af890e88f3eb);
// src/help/page/types.ts
var $7328aa22740bb348$export$b6fe1f05324d51ea = "help", $7328aa22740bb348$export$e6c9af890e88f3eb = "page";

});


parcelRegister("k9E65", function(module, exports) {
$parcel$export(module.exports, "default", () => $b60f8bbb16b2c62a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8716921b8ad1a3339f001341db72213>>
 * @relayHash e15342ecc9d5d6d6fa16dbd150a7b3d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0584ba15db65176e105b407e15300f519202ee96f3cabce1e1cd9dd5ec97bb4
const $b60f8bbb16b2c62a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v8 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "HelpCenterPageDescription",
        "kind": "LinkedField",
        "name": "description",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "QueryError"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v21 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v23 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v27 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v28 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v12 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layoutByParentId",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    v11 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v6 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v13 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v16 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v25 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c0584ba15db65176e105b407e15300f519202ee96f3cabce1e1cd9dd5ec97bb4",
            "metadata": {},
            "name": "viewCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b60f8bbb16b2c62a$var$node.hash = "eb1a4ed7177899c5f9bd15d20468d07f";
var $b60f8bbb16b2c62a$export$2e2bcd8739ae039 = $b60f8bbb16b2c62a$var$node;

});


parcelRegister("79xHh", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => (parcelRequire("6wcnv")).ViewCustomPage);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => (parcelRequire("6wcnv")).ViewCustomPageWithAiAgent);
$parcel$export(module.exports, "EditCustomPage", () => (parcelRequire("j27yh")).EditCustomPage);

var $6wcnv = parcelRequire("6wcnv");

var $j27yh = parcelRequire("j27yh");

});
parcelRegister("6wcnv", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => $50c3e9fc7118a3ec$export$445268d8b5206a5d);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => $50c3e9fc7118a3ec$export$e4a1d2bae0fd7812);

var $fc4bM = parcelRequire("fc4bM");

var $6HUAM = parcelRequire("6HUAM");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $50c3e9fc7118a3ec$export$445268d8b5206a5d = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("4CPh9")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/view-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6HUAM.default), null)
});

const $50c3e9fc7118a3ec$export$e4a1d2bae0fd7812 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("cfSkm")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/csm-variants/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6HUAM.default), null)
});

});
parcelRegister("4CPh9", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("aenbe"),
    $9dnsd("5Flnk"),
    $9dnsd("hgR6q"),
    $9dnsd("2g5QR"),
    $9dnsd("fHVHm")
]).then(()=>parcelRequire('boAwD'));

});

parcelRegister("cfSkm", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("aenbe"),
    $9dnsd("5Flnk"),
    $9dnsd("hgR6q"),
    $9dnsd("fHVHm"),
    $9dnsd("2g5QR"),
    $9dnsd("fCR92")
]).then(()=>parcelRequire('fBKDZ'));

});


parcelRegister("j27yh", function(module, exports) {
$parcel$export(module.exports, "EditCustomPage", () => $db4fa9465872e296$export$7fc1d63603c0df32);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $6HUAM = parcelRequire("6HUAM");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("hG7Ne");
var $bOyxS = parcelRequire("bOyxS");

const $db4fa9465872e296$export$7fc1d63603c0df32 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("h6nKS")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/edit-custom-page/edit-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>(0, $hN5YJ.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bOyxS.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6HUAM.default), {
            showActionBar: true
        })
});

});
parcelRegister("h6nKS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5Flnk"),
    $9dnsd("4cJBF"),
    $9dnsd("VNsDq"),
    $9dnsd("hgR6q"),
    $9dnsd("ed06v"),
    $9dnsd("lv25e"),
    $9dnsd("hCVB4"),
    $9dnsd("cAuei"),
    $9dnsd("8IYZ8"),
    $9dnsd("2g5QR"),
    $9dnsd("jUsD2"),
    $9dnsd("2KLau"),
    $9dnsd("dQB15"),
    $9dnsd("ciGzL"),
    $9dnsd("h566j"),
    $9dnsd("1AKkv"),
    $9dnsd("6VzBn"),
    $9dnsd("aejHq"),
    $9dnsd("g80ld"),
    $9dnsd("kaxju"),
    $9dnsd("ikxBT")
]).then(()=>parcelRequire('7rlU2'));

});




parcelRegister("h3GiS", function(module, exports) {
$parcel$export(module.exports, "csmFolderRoute", () => $0ce08c297e3d761e$export$27c939ab49e382d2);

var $9mazR = parcelRequire("9mazR");

var $cearm = parcelRequire("cearm");

var $eMhka = parcelRequire("eMhka");

var $k2kQM = parcelRequire("k2kQM");

var $joDHD = parcelRequire("joDHD");
const $0ce08c297e3d761e$var$folder = {
    resources: [
        (0, $k2kQM.CsmFolderResource),
        (0, $eMhka.CsmEmptyFolderResource)
    ],
    name: (0, $9mazR.RouteName).CSM_FOLDER_PAGE,
    path: (0, $9mazR.RoutePath).CSM_FOLDER_PATH,
    exact: true,
    component: (0, $cearm.CsmFolder)
};
const $0ce08c297e3d761e$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $0ce08c297e3d761e$export$27c939ab49e382d2 = (0, $joDHD.createRouteWithLayout)($0ce08c297e3d761e$var$folder, (0, $9mazR.ScreenName).CSM_FOLDER, $0ce08c297e3d761e$var$layoutProps);

});
parcelRegister("cearm", function(module, exports) {
$parcel$export(module.exports, "CsmFolder", () => $482504316575fbc5$export$56c9caef0ff41b5c);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $482504316575fbc5$export$56c9caef0ff41b5c = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("iWsMx")), {
        moduleId: "./packages/customer-service/csm-folder/src/ui/csm-folder.tsx"
    })
});

});
parcelRegister("iWsMx", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6ODTf").then(()=>parcelRequire('jK9AM'));

});


parcelRegister("eMhka", function(module, exports) {
$parcel$export(module.exports, "CsmEmptyFolderResource", () => $2029a0ee8cf5bf6a$export$acacebd3c63c516);

var $8zK3E = parcelRequire("8zK3E");

var $c7hR3 = parcelRequire("c7hR3");

var $1dz3g = parcelRequire("1dz3g");
const $2029a0ee8cf5bf6a$export$acacebd3c63c516 = (0, $8zK3E.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $c7hR3.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $1dz3g.MAX_ITEMS_PER_PAGE),
                input: {
                    articleIds: [
                        pageId
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("c7hR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd3f50f46bdb742c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b395b2f764ccd459bcc11cb4b79c1761>>
 * @relayHash be67b91b3b5b3d2fbcf3fcc898595c20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365
const $dd3f50f46bdb742c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "emptyStateRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "EmptyStateRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365",
            "metadata": {},
            "name": "emptyStateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dd3f50f46bdb742c$var$node.hash = "0f924812359a442723962628434695a3";
var $dd3f50f46bdb742c$export$2e2bcd8739ae039 = $dd3f50f46bdb742c$var$node;

});

parcelRegister("1dz3g", function(module, exports) {
$parcel$export(module.exports, "MAX_ITEMS_PER_PAGE", () => $a6e72ff49e711d5a$export$e7a0dcb737d8e4ee);
const $a6e72ff49e711d5a$export$e7a0dcb737d8e4ee = 24;

});


parcelRegister("k2kQM", function(module, exports) {
$parcel$export(module.exports, "CsmFolderResource", () => $721580785e1e705f$export$c37e0f6e8d7653a0);

var $8zK3E = parcelRequire("8zK3E");

var $8Jkpx = parcelRequire("8Jkpx");

var $1dz3g = parcelRequire("1dz3g");
const $721580785e1e705f$var$ANCESTORS = 'ANCESTORS';
const $721580785e1e705f$export$c37e0f6e8d7653a0 = (0, $8zK3E.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $8Jkpx.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $1dz3g.MAX_ITEMS_PER_PAGE),
                input: {
                    parentId: Number(pageId),
                    expand: [
                        $721580785e1e705f$var$ANCESTORS
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("8Jkpx", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbde49af9c843748$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67d2bbd7d59b1ab8335ec1f2e3d8b5b0>>
 * @relayHash ca6bf320095164b2c7bf8c7a0da7ff96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 545cafff76808c8fbdaa985de5b3004568e314aaecfce1af44e865ce4984f817
const $fbde49af9c843748$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "mainCsmFolderItemsRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "contentType"
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleRelative",
                                                    "kind": "LinkedField",
                                                    "name": "ancestors",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleURLInfo",
                                                    "kind": "LinkedField",
                                                    "name": "urlInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shareUrl"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "CsmFolderItemsRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "545cafff76808c8fbdaa985de5b3004568e314aaecfce1af44e865ce4984f817",
            "metadata": {},
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fbde49af9c843748$var$node.hash = "4e2df91a41eb5d8ce8ae2f48a0e1068e";
var $fbde49af9c843748$export$2e2bcd8739ae039 = $fbde49af9c843748$var$node;

});



parcelRegister("eZNbv", function(module, exports) {
$parcel$export(module.exports, "csmViewKbPageRoute", () => $0768e9f00386d49f$export$ef20b2dba68d2a8);
$parcel$export(module.exports, "csmViewArticleRoute", () => $0768e9f00386d49f$export$b346ad0264655ca1);
$parcel$export(module.exports, "csmViewCrossSiteArticleRoute", () => $0768e9f00386d49f$export$cfb51b854559f2b3);

var $9mazR = parcelRequire("9mazR");

var $jcOpK = parcelRequire("jcOpK");

var $joDHD = parcelRequire("joDHD");
const $0768e9f00386d49f$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $jcOpK.CsmArticle)
};
const $0768e9f00386d49f$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $jcOpK.CsmArticle)
};
const $0768e9f00386d49f$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $jcOpK.CsmArticle)
};
const $0768e9f00386d49f$var$layoutProps = {
    paperAppearance: 'xxwide',
    fadeInSearchModal: true
};
const $0768e9f00386d49f$export$ef20b2dba68d2a8 = (0, $joDHD.createRouteWithLayout)($0768e9f00386d49f$var$viewKbPage, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $0768e9f00386d49f$var$layoutProps);
const $0768e9f00386d49f$export$b346ad0264655ca1 = (0, $joDHD.createRouteWithLayout)($0768e9f00386d49f$var$viewArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $0768e9f00386d49f$var$layoutProps);
const $0768e9f00386d49f$export$cfb51b854559f2b3 = (0, $joDHD.createRouteWithLayout)($0768e9f00386d49f$var$viewCrossSiteArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $0768e9f00386d49f$var$layoutProps);

});
parcelRegister("jcOpK", function(module, exports) {
$parcel$export(module.exports, "CsmArticle", () => $30b51cf285c6ed47$export$630a6bc855af0b24);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $30b51cf285c6ed47$export$630a6bc855af0b24 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("b9r3H")), {
        moduleId: "./src/view/article/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("b9r3H", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3aoyb"),
    $9dnsd("5Qtzw"),
    $9dnsd("khWqP")
]).then(()=>parcelRequire('1XY1X'));

});



parcelRegister("6MlVB", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListRoute", () => $e5eedabcb4061c8b$export$416674a9ebdb2ee0);
$parcel$export(module.exports, "csmRequestDetailsRoute", () => $e5eedabcb4061c8b$export$c1779627ae2c6baa);

var $9mazR = parcelRequire("9mazR");

var $bagyb = parcelRequire("bagyb");

var $aWXCW = parcelRequire("aWXCW");

var $dAKXg = parcelRequire("dAKXg");

var $0290X = parcelRequire("0290X");

var $3vF82 = parcelRequire("3vF82");

var $5IyQ6 = parcelRequire("5IyQ6");

var $EXfS9 = parcelRequire("EXfS9");

var $joDHD = parcelRequire("joDHD");
const $e5eedabcb4061c8b$export$416674a9ebdb2ee0 = (0, $joDHD.createRouteWithLayout)({
    name: (0, $9mazR.RouteName).CSM_REQUESTS_LIST_PAGE,
    path: (0, $9mazR.RoutePath).CSM_REQUESTS_LIST_PATH,
    exact: true,
    component: (0, $5IyQ6.CsmRequestsList),
    resources: [
        (0, $EXfS9.csmRequestsListQueryResource)
    ]
}, (0, $9mazR.ScreenName).CSM_REQUESTS_LIST, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
});
const $e5eedabcb4061c8b$export$c1779627ae2c6baa = (0, $joDHD.createRouteWithLayout)({
    name: (0, $9mazR.RouteName).CSM_REQUEST_DETAILS_PAGE,
    path: (0, $9mazR.RoutePath).CSM_REQUEST_DETAILS_PATH,
    exact: true,
    component: (0, $3vF82.AsyncCsmRequestDetails),
    resources: [
        (0, $bagyb.csmRequestDetailsQueryResource),
        (0, $0290X.requestConversationResource),
        (0, $aWXCW.mediaReadCredentialsResource),
        (0, $dAKXg.mediaUploadCredentialsResource)
    ]
}, (0, $9mazR.ScreenName).CSM_REQUEST_DETAILS, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true,
    hideBanner: true
});

});
parcelRegister("bagyb", function(module, exports) {
$parcel$export(module.exports, "csmRequestDetailsQueryResource", () => $20679df0314dfae4$export$54cc49ad6240b8cc);

var $6LH8a = parcelRequire("6LH8a");

var $8zK3E = parcelRequire("8zK3E");

var $4X3i4 = parcelRequire("4X3i4");
const $20679df0314dfae4$export$54cc49ad6240b8cc = (0, $8zK3E.createRelayResource)({
    type: 'CSM_REQUEST_DETAILS_QUERY',
    getQuery: ({ match: { params: { requestKey: requestKey } } }, { cloudId: cloudId })=>({
            parameters: (0, $4X3i4.default),
            variables: {
                cloudId: cloudId,
                issueKey: requestKey ?? '',
                helpCenterId: (0, $6LH8a.getMeta)('help-center-ari') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("4X3i4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a1a616c5fb80728$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e90d29b1c257942bb16bc8a5b0d2cfdd>>
 * @relayHash a7ebdbf07408265d75c2cc406c04f0f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58fe90f9c78b8407af5972c275e67b09ebfa78c8abaeff457cdb8404b2327720
const $2a1a616c5fb80728$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterId",
            "variableName": "helpCenterId"
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "question"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "requestByIssueKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceRequestSharedOrganization",
                                                    "kind": "LinkedField",
                                                    "name": "sharedOrganizations",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_csmRequestDetails"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formView_csmRequestDetails"
                                                }
                                            ],
                                            "type": "CustomerServiceRequest"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_csmCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "requestByIssueKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceRequestSharedOrganization",
                                            "kind": "LinkedField",
                                            "name": "sharedOrganizations",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "createdOn"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCategoryName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reporterDisplayName"
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestParticipant",
                                            "kind": "LinkedField",
                                            "name": "participants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestFormDataConnection",
                                            "kind": "LinkedField",
                                            "name": "formData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestFormDataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "textAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "adfAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryRichTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "multiSelectTextAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryMultiSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fileIds"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryAttachmentField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceRequest"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "58fe90f9c78b8407af5972c275e67b09ebfa78c8abaeff457cdb8404b2327720",
            "metadata": {},
            "name": "csmRequestDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2a1a616c5fb80728$var$node.hash = "97d1776fa449082ee1e26453e32fcdac";
var $2a1a616c5fb80728$export$2e2bcd8739ae039 = $2a1a616c5fb80728$var$node;

});


parcelRegister("aWXCW", function(module, exports) {
$parcel$export(module.exports, "mediaReadCredentialsResource", () => $8bd999b7a4c71d30$export$bb777640a2b36f94);

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");

var $4MoYu = parcelRequire("4MoYu");

var $c0Y6o = parcelRequire("c0Y6o");
const $8bd999b7a4c71d30$export$bb777640a2b36f94 = (0, $fOvEc.createResource)({
    type: 'MEDIA_READ_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-read-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
        return (0, $c0Y6o.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/read`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("dAKXg", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $268d9c74eab871c8$export$fac4b16282dd90f6);

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");

var $4MoYu = parcelRequire("4MoYu");

var $c0Y6o = parcelRequire("c0Y6o");
const $268d9c74eab871c8$export$fac4b16282dd90f6 = (0, $fOvEc.createResource)({
    type: 'CSM_MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`csm-media-upload-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
        return (0, $c0Y6o.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 600000 // 10 minutes
});

});

parcelRegister("0290X", function(module, exports) {
$parcel$export(module.exports, "requestConversationResource", () => $69cfe713144720f1$export$9062b1d7764a6617);

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");

var $4MoYu = parcelRequire("4MoYu");

var $c0Y6o = parcelRequire("c0Y6o");
const $69cfe713144720f1$export$9062b1d7764a6617 = (0, $fOvEc.createResource)({
    type: 'REQUEST_CONVERSATION_RESOURCE',
    getKey: ()=>`request-conversation`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse((0, $6LH8a.getHelpCenterAri)());
        return (0, $c0Y6o.fetchJson)(`/gateway/api/jsm/csm/api/v1/request/form/helpcenter/${helpCenterId}/conversation/history?issueIdOrKey=${match.params.requestKey || ''}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("3vF82", function(module, exports) {
$parcel$export(module.exports, "AsyncCsmRequestDetails", () => $4fff46ca58f3680e$export$c654e93ddb89d705);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $4fff46ca58f3680e$export$c654e93ddb89d705 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("5PSQS")), {
        moduleId: "./packages/customer-service/csm-request-details/src/ui/csm-request-details.tsx"
    })
});

});
parcelRegister("5PSQS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("lv25e"),
    $9dnsd("26NYz"),
    $9dnsd("aqyjy"),
    $9dnsd("dWNMl"),
    $9dnsd("h05a5"),
    $9dnsd("iRg4t")
]).then(()=>parcelRequire('cuXFF'));

});


parcelRegister("5IyQ6", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsList", () => $a7e977120be36ab0$export$790b773cc5ea9295);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $a7e977120be36ab0$export$790b773cc5ea9295 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("dAJ1u")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/ui/csm-requests-list.tsx"
    })
});

});
parcelRegister("dAJ1u", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("ftxV4"),
    $9dnsd("bVBnH"),
    $9dnsd("aqyjy"),
    $9dnsd("hs3rY"),
    $9dnsd("cT544"),
    $9dnsd("d3iv7")
]).then(()=>parcelRequire('7SZNx'));

});


parcelRegister("EXfS9", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListQueryResource", () => $45d778f5e095705a$export$a6363e566cdd7bae);

var $6LH8a = parcelRequire("6LH8a");

var $8zK3E = parcelRequire("8zK3E");

var $9zmVm = parcelRequire("9zmVm");

var $7ANau = parcelRequire("7ANau");
const $45d778f5e095705a$export$a6363e566cdd7bae = (0, $8zK3E.createRelayResource)({
    type: 'CSM_REQUESTS_LIST_QUERY',
    getQuery: (_, { cloudId: cloudId })=>({
            parameters: (0, $7ANau.default),
            variables: {
                cloudId: cloudId,
                accountId: (0, $6LH8a.getMeta)('account-id') ?? '',
                helpCenterId: (0, $6LH8a.getMeta)('help-center-ari') ?? '',
                count: (0, $9zmVm.PAGINATION_SIZE)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("9zmVm", function(module, exports) {
$parcel$export(module.exports, "PAGINATION_SIZE", () => $807fa0acbdc14892$export$cb638d1fae624fbf);
const $807fa0acbdc14892$export$cb638d1fae624fbf = 30;

});

parcelRegister("7ANau", function(module, exports) {
$parcel$export(module.exports, "default", () => $4947031b918b0bfe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aee4d632d08e3f91f0b91b1450b78035>>
 * @relayHash 3681b7ed328fbc24d7c85e9a38792f1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7d208559ac8563e6f5acd98cc24a4f3985b7efb2b89c69336bd060de1c4967a
const $4947031b918b0bfe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v5 = {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v8 = {
        "kind": "Variable",
        "name": "helpCenterId",
        "variableName": "helpCenterId"
    }, v9 = [
        v6 /*: any*/ 
    ], v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CustomerServiceExternalStatus",
                "kind": "LinkedField",
                "name": "externalStatuses",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "externalLabel"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraStatusIds"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "statusCategory"
                    }
                ]
            }
        ],
        "type": "CustomerServiceExternalStatusesResponse"
    }, v12 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v8 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "requestsTable_csmRequestsList"
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "CustomerServiceRequestConnection",
                                            "kind": "LinkedField",
                                            "name": "requests",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceRequest",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalStatus"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusCategoryName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "reporterDisplayName"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceRequestSharedOrganization",
                                                                    "kind": "LinkedField",
                                                                    "name": "sharedOrganizations",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "name"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createdOn"
                                                                },
                                                                v17 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v16 /*: any*/ ,
                                            "filters": [
                                                "helpCenterId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "requestsTable_requests",
                                            "kind": "LinkedHandle",
                                            "name": "requests"
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v17 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c7d208559ac8563e6f5acd98cc24a4f3985b7efb2b89c69336bd060de1c4967a",
            "metadata": {},
            "name": "csmRequestsListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4947031b918b0bfe$var$node.hash = "cb6332bdb26c3936c3393e7e0eb0eafc";
var $4947031b918b0bfe$export$2e2bcd8739ae039 = $4947031b918b0bfe$var$node;

});



parcelRegister("21XEi", function(module, exports) {
$parcel$export(module.exports, "csmUserProfileRoute", () => $688a875a39058c1c$export$e41fe4b9d1161823);

var $9mazR = parcelRequire("9mazR");

var $dus88 = parcelRequire("dus88");

var $joDHD = parcelRequire("joDHD");
const $688a875a39058c1c$var$viewUserProfilePage = {
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $dus88.CsmUserProfile)
};
const $688a875a39058c1c$export$e41fe4b9d1161823 = (0, $joDHD.createRouteWithLayout)($688a875a39058c1c$var$viewUserProfilePage, (0, $9mazR.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("dus88", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfile", () => $25e67b2161070d64$export$3d0c667f8fc698fc);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $25e67b2161070d64$export$3d0c667f8fc698fc = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("4Mf1H")), {
        moduleId: "./src/view/user-profile/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("4Mf1H", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3ky1E"),
    $9dnsd("cvU93")
]).then(()=>parcelRequire('6HJOx'));

});



parcelRegister("fU9IO", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $3fdce302ee230140$export$3dddbf9f405aac5c);
$parcel$export(module.exports, "getEditCustomPageRoute", () => $3fdce302ee230140$export$c998bed8122ef3dd);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $9mazR = parcelRequire("9mazR");

var $aH22O = parcelRequire("aH22O");

var $8bJBz = parcelRequire("8bJBz");

var $hN5YJ = parcelRequire("hN5YJ");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");

var $9L0nY = parcelRequire("9L0nY");
parcelRequire("kEool");
var $dRMig = parcelRequire("dRMig");
parcelRequire("jDBRI");
var $ju0hb = parcelRequire("ju0hb");

var $80yPZ = parcelRequire("80yPZ");

var $joDHD = parcelRequire("joDHD");
parcelRequire("79xHh");
var $j27yh = parcelRequire("j27yh");
var $6wcnv = parcelRequire("6wcnv");

var $oEu1q = parcelRequire("oEu1q");
const $3fdce302ee230140$var$ViewCustomPageWithRovoWidget = (0, $9L0nY.withHelpCenterRovoWidget)((0, $6wcnv.ViewCustomPage));
const $3fdce302ee230140$export$3dddbf9f405aac5c = (name = (0, $9mazR.RouteName).VIEW_CUSTOM_PAGE, path = (0, $9mazR.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $oEu1q.brandingResource),
        (0, $8bJBz.ViewCustomPageResource)
    ];
    return (0, $joDHD.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $3fdce302ee230140$var$ViewCustomPageWithRovoWidget,
        resources: [
            (0, $8bJBz.ViewCustomPageResource)
        ]
    }, (0, $9mazR.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $3fdce302ee230140$export$366de07628c8a4b = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: props.location.pathname
    }), (0, $aylSc.default)({
        message: formatMessage((0, $80yPZ.authPageMessage)),
        callToActionText: formatMessage((0, $80yPZ.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dRMig.default), {
            path: (0, $9mazR.RoutePath).EDIT_CUSTOM_PAGE,
            component: (0, $j27yh.EditCustomPage),
            screenName: (0, $9mazR.ScreenName).EDIT_CUSTOM_PAGE,
            isFooterHidden: (0, $hN5YJ.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ju0hb.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props));
};
const $3fdce302ee230140$export$c998bed8122ef3dd = (name = (0, $9mazR.RouteName).EDIT_CUSTOM_PAGE, path = (0, $9mazR.RoutePath).EDIT_CUSTOM_PAGE)=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        exact: true,
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo($3fdce302ee230140$export$366de07628c8a4b),
        resources: [
            (0, $aH22O.EditCustomPageResource)
        ]
    };
    return editHomePageRoute;
};

});
parcelRegister("aH22O", function(module, exports) {
$parcel$export(module.exports, "EditCustomPageResource", () => $7700bc9caaeea5a0$export$bb1f5be367194159);

var $6LH8a = parcelRequire("6LH8a");

var $gK5mb = parcelRequire("gK5mb");

var $8zK3E = parcelRequire("8zK3E");

var $eU9Tj = parcelRequire("eU9Tj");
const $7700bc9caaeea5a0$export$bb1f5be367194159 = (0, $8zK3E.createRelayResource)({
    type: 'EDIT_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id;
        if (!pageId) throw Error('No page id for custom page.');
        const helpCenterPageAri = (0, $gK5mb.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $6LH8a.getActivationId)()
        }).toString();
        return {
            parameters: (0, $eU9Tj.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("eU9Tj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c796ee0b185a6f45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afecf275bf1b1f87e33cdaf8ea455f40>>
 * @relayHash cac39a5aff5256ed1e3f136528873758
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cef9c5e37d4002685f206f54e0b958adb8cf7bb43e38583cc6a57589c4fd1d31
const $c796ee0b185a6f45$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v10 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = [
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "message"
    }, v15 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            v15 /*: any*/ 
        ],
        "type": "QueryError"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v19 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v20 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v22 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v24 = {
        "kind": "ScalarField",
        "name": "key"
    }, v25 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v26 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "url"
    }, v31 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v33 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v34 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v35 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v36 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v39 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v40 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v41 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v42 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v43 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v44 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v29 /*: any*/ 
        ]
    }, v45 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v11 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "HelpLayoutQueryApi",
                        "kind": "LinkedField",
                        "name": "helpLayout",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v12 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "layoutByParentId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "pageBuilderFragment"
                                                }
                                            ],
                                            "type": "HelpLayout"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "HelpLayoutMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "mediaConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "pageBuilderMediaConfigFragment"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "elementTypes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "elementsCatalogueFragment"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v7 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v13 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v28 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v5 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v34 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                v40 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v15 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "layoutId",
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v28 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cef9c5e37d4002685f206f54e0b958adb8cf7bb43e38583cc6a57589c4fd1d31",
            "metadata": {},
            "name": "editCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c796ee0b185a6f45$var$node.hash = "ced1fe6aab72feb794e7063ba7fe32c0";
var $c796ee0b185a6f45$export$2e2bcd8739ae039 = $c796ee0b185a6f45$var$node;

});


parcelRegister("9L0nY", function(module, exports) {
$parcel$export(module.exports, "HelpCenterRovoWidget", () => $ce5d0c767b31fec0$export$1948af5813162381);
$parcel$export(module.exports, "withHelpCenterRovoWidget", () => $ce5d0c767b31fec0$export$75e5cfdb2c692e61);

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $k2M4v = parcelRequire("k2M4v");

var $dQMHQ = parcelRequire("dQMHQ");
const $ce5d0c767b31fec0$var$ENHANCE_JSM_WIDGET_STABILITY = 'enhance_jsm_widget_stability';
const $ce5d0c767b31fec0$var$isEnhancedJsmWidgetStabilityEnabled = ()=>(0, $k2M4v.default).checkGate($ce5d0c767b31fec0$var$ENHANCE_JSM_WIDGET_STABILITY);
const $ce5d0c767b31fec0$export$1948af5813162381 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dQMHQ.RovoServiceAgentWidgetInjector), {
        surface: "HELP_CENTER",
        siteId: (0, $6LH8a.getCloudId)(),
        widgetId: (0, $6LH8a.getHelpCenterAri)()
    });
const $ce5d0c767b31fec0$export$75e5cfdb2c692e61 = (Page)=>{
    const PageWithHelpCenterRovoWidget = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Page, props), $ce5d0c767b31fec0$var$isEnhancedJsmWidgetStabilityEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce5d0c767b31fec0$export$1948af5813162381, null));
    PageWithHelpCenterRovoWidget.displayName = `withHelpCenterRovoWidget(${Page.displayName || Page.name || 'Component'})`;
    return PageWithHelpCenterRovoWidget;
};

});
parcelRegister("dQMHQ", function(module, exports) {
$parcel$export(module.exports, "RovoServiceAgentWidgetInjector", () => $913e018113cf8a70$export$19e4074f6781b5f7);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $eBDNv = parcelRequire("eBDNv");

var $bAQQ9 = parcelRequire("bAQQ9");

var $gDsF8 = parcelRequire("gDsF8");

var $gq5Zl = parcelRequire("gq5Zl");

var $eef75 = parcelRequire("eef75");

var $16GaT = parcelRequire("16GaT");

var $aVQWM = parcelRequire("aVQWM");

var $7rEw1 = parcelRequire("7rEw1");
var $j4SCE = parcelRequire("j4SCE");

var $7vxZb = parcelRequire("7vxZb");

var $9KJfa = parcelRequire("9KJfa");
const $913e018113cf8a70$var$InjectRovoServiceAgentWidgetScript = /*#__PURE__*/ (0, $fc4bM.memo)(function RovoServiceAgentWidget({ siteId: siteId, widgetId: widgetId, surface: surface, brandPrimaryColor: brandPrimaryColor }) {
    const [error, setError] = (0, $fc4bM.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { locale: locale } = (0, $gpjDl.default)();
    const handleOnOpen = (0, $fc4bM.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88552
        (0, $16GaT.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget opened');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClose = (0, $fc4bM.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88553
        (0, $16GaT.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget closed');
    }, [
        createAnalyticsEvent
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const loadScript = async ()=>{
            const startTime = performance.now();
            try {
                setError(null);
                await (0, $9KJfa.loadRovoWidgetSDKScript)({
                    siteId: siteId,
                    widgetId: widgetId,
                    surface: surface,
                    locale: locale,
                    brandPrimaryColor: brandPrimaryColor,
                    onOpen: handleOnOpen,
                    onClose: handleOnClose
                });
                // Measure widget load time (non-blocking, fire-and-forget)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $16GaT.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration
                    }
                }), 'rovoServiceAgentWidget scriptLoaded');
            } catch (err) {
                // Measure failed load time (non-blocking)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $16GaT.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration,
                        error: err instanceof Error ? err.message : 'Unknown error'
                    }
                }), 'rovoServiceAgentWidget scriptFailed');
                setError(err instanceof Error ? err : new Error('Failed to load widget script'));
            }
        };
        // The error handler is inside loadScript, so we don't need to handle it here
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadScript();
    }, [
        widgetId,
        siteId,
        handleOnClose,
        handleOnOpen,
        surface,
        locale,
        createAnalyticsEvent,
        brandPrimaryColor
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            (0, $9KJfa.cleanupRovoWidgetSDKScript)();
        };
    }, []);
    if (error) throw error;
    // Return null without blocking UFO experience - widget loads asynchronously
    return null;
});
const $913e018113cf8a70$export$19e4074f6781b5f7 = ({ siteId: siteId, widgetId: widgetId, surface: surface, brandPrimaryColor: brandPrimaryColor })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const renderError = (0, $fc4bM.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bAQQ9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eBDNv.default), {
            id: "rovo-widget-error-flag",
            appearance: "error",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
                label: ""
            }),
            title: formatMessage((0, $7vxZb.default).widgetErrorTitle),
            description: formatMessage((0, $7vxZb.default).widgetErrorDescription),
            testId: "rovo-widget-error-flag"
        }));
    }, [
        formatMessage
    ]);
    // RSA widget script (https://<site>/rovo/widget/script.js) is not deployed
    // on FedRAMP or Isolated Cloud tenants, so do not attempt to inject it there.
    if ((0, $7rEw1.isFedRamp)() || (0, $j4SCE.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gq5Zl.default), {
        name: "rovo-service-agent-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: "rovo-service-agent",
        id: "widget-injector",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eef75.ContextWrapper), {
        sourceName: "rovoServiceAgent",
        sourceType: (0, $aVQWM.MODAL),
        attributes: {
            siteId: siteId,
            widgetId: widgetId,
            surface: surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($913e018113cf8a70$var$InjectRovoServiceAgentWidgetScript, {
        siteId: siteId,
        widgetId: widgetId,
        surface: surface,
        brandPrimaryColor: brandPrimaryColor
    }))));
};

});
parcelRegister("eef75", function(module, exports) {
$parcel$export(module.exports, "ContextWrapper", () => $2e2340aec2c4065f$export$34282a1f95511a11);

var $fc4bM = parcelRequire("fc4bM");

var $bomqv = parcelRequire("bomqv");

var $gK90j = parcelRequire("gK90j");

var $3TJLC = parcelRequire("3TJLC");
const $2e2340aec2c4065f$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gK90j)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bomqv))));
};
const $2e2340aec2c4065f$export$34282a1f95511a11 = (props)=>{
    const data = $2e2340aec2c4065f$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, props.children));
};

});

parcelRegister("7vxZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $5368443253b6e9e7$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $5368443253b6e9e7$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    widgetErrorTitle: {
        id: 'rovo.service-agent.widget.error-boundary.title.non-final',
        defaultMessage: 'Rovo Service Agent widget unavailable',
        description: 'Title for the error flag for when the widget failed to load'
    },
    widgetErrorDescription: {
        id: 'rovo.service-agent.widget.error-boundary.description.non-final',
        defaultMessage: 'The Rovo Service Agent failed to load. Please refresh the page to try again.',
        description: 'Description for the error flag for when the widget failed to load'
    }
});

});

parcelRegister("9KJfa", function(module, exports) {
$parcel$export(module.exports, "loadRovoWidgetSDKScript", () => $f62f21b24f255eb4$export$7547b32d5aede92f);
$parcel$export(module.exports, "cleanupRovoWidgetSDKScript", () => $f62f21b24f255eb4$export$8b3a5cba31576b8a);
let $f62f21b24f255eb4$var$promise = null;
const $f62f21b24f255eb4$var$SCRIPT_ID = 'rovo-service-agent-widget-script';
const $f62f21b24f255eb4$export$7bcdf693772d0a65 = ()=>{
    const q = function WidgetQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};
const $f62f21b24f255eb4$export$2319c1f51535cb1c = ()=>{
    if (typeof window === 'undefined') throw new Error('Failed to load CSM SDK: window is undefined');
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    if (!body) throw new Error('Document body not found');
};
const $f62f21b24f255eb4$export$e0c468a317b25666 = (onOpen, onClose)=>{
    if (typeof window.ROVO_WIDGET === 'undefined') {
        window.ROVO_WIDGET = $f62f21b24f255eb4$export$7bcdf693772d0a65();
        if (onOpen) window.ROVO_WIDGET('onOpen', onOpen);
        if (onClose) window.ROVO_WIDGET('onClose', onClose);
        window.ROVO_WIDGET('open');
    }
};
const $f62f21b24f255eb4$export$bb8c6503cfd42bb6 = ()=>{
    return !!(window.ROVO_WIDGET && !('__q__' in window.ROVO_WIDGET));
};
const $f62f21b24f255eb4$export$8e6c9489c906e450 = (siteId, widgetId, surface, locale, brandPrimaryColor)=>{
    const site = window.location.hostname;
    const src = new URL(`https://${site}/rovo/widget/script.js`);
    src.searchParams.set('siteId', siteId);
    src.searchParams.set('site', site);
    src.searchParams.set('widgetId', widgetId);
    src.searchParams.set('surface', surface);
    src.searchParams.set('locale', locale);
    // Only the Help Hub corner widget passes a colour; every other host keeps a byte-identical URL.
    if (brandPrimaryColor) {
        src.searchParams.set('brandPrimaryColor', brandPrimaryColor);
        src.searchParams.set('brandVibe', 'vibrant');
    }
    return src.toString();
};
const $f62f21b24f255eb4$export$9b542085e8be8f80 = (resolve, reject)=>{
    if ($f62f21b24f255eb4$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
    else if (window.ROVO_WIDGET && '__q__' in window.ROVO_WIDGET) {
        $f62f21b24f255eb4$export$57f8607478cbbab6();
        if ($f62f21b24f255eb4$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
        else {
            $f62f21b24f255eb4$var$promise = null;
            reject(new Error('SDK failed to initialize properly - still in queue mode'));
        }
    } else {
        $f62f21b24f255eb4$var$promise = null;
        reject(new Error('Failed to load ROVO_WIDGET SDK script: window.ROVO_WIDGET is undefined'));
    }
};
const $f62f21b24f255eb4$export$c20f7df29b9552b6 = (reject)=>{
    $f62f21b24f255eb4$var$promise = null;
    reject(new Error('Failed to load ROVO_WIDGET SDK script: onerror'));
};
const $f62f21b24f255eb4$export$a8c9f8edf0911bff = (scriptURL, resolve, reject)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    script.id = $f62f21b24f255eb4$var$SCRIPT_ID;
    script.onerror = ()=>$f62f21b24f255eb4$export$c20f7df29b9552b6(reject);
    script.onload = ()=>$f62f21b24f255eb4$export$9b542085e8be8f80(resolve, reject);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    body === null || body === void 0 || body.appendChild(script);
};
const $f62f21b24f255eb4$export$57f8607478cbbab6 = ()=>{
    if (window.ROVO_WIDGET_REINIT) window.ROVO_WIDGET_REINIT();
};
const $f62f21b24f255eb4$export$7547b32d5aede92f = ({ siteId: siteId, widgetId: widgetId, surface: surface, locale: locale, onOpen: onOpen, onClose: onClose, brandPrimaryColor: brandPrimaryColor })=>{
    if (!$f62f21b24f255eb4$var$promise) $f62f21b24f255eb4$var$promise = new Promise((resolve, reject)=>{
        try {
            $f62f21b24f255eb4$export$2319c1f51535cb1c();
            $f62f21b24f255eb4$export$e0c468a317b25666(onOpen, onClose);
            // If SDK is already loaded (not a queue), resolve immediately
            if ($f62f21b24f255eb4$export$bb8c6503cfd42bb6()) {
                resolve(window.ROVO_WIDGET);
                return;
            }
            const scriptURL = $f62f21b24f255eb4$export$8e6c9489c906e450(siteId, widgetId, surface, locale, brandPrimaryColor);
            $f62f21b24f255eb4$export$a8c9f8edf0911bff(scriptURL, resolve, reject);
        } catch (error) {
            reject(error);
        }
    });
    return $f62f21b24f255eb4$var$promise;
};
const $f62f21b24f255eb4$export$8b3a5cba31576b8a = ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const scriptElement = document.getElementById($f62f21b24f255eb4$var$SCRIPT_ID);
    if (scriptElement) // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.body.removeChild(scriptElement);
    if (window.ROVO_WIDGET_CLEANUP) window.ROVO_WIDGET_CLEANUP();
    if (window.ROVO_WIDGET) delete window.ROVO_WIDGET;
    // Reset the tracking variables
    $f62f21b24f255eb4$var$promise = null;
};

});




parcelRegister("ciXwj", function(module, exports) {
$parcel$export(module.exports, "TOPIC_BASE_PATH", () => $493de8eeef112bdb$export$fcfe7b179287e200);
$parcel$export(module.exports, "editTopicRoute", () => $493de8eeef112bdb$export$60c0f814fe4b3a12);
$parcel$export(module.exports, "addTopicRoute", () => $493de8eeef112bdb$export$9d8f7fd5bc61f52f);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $9mazR = parcelRequire("9mazR");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");

var $HgXms = parcelRequire("HgXms");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");
parcelRequire("kEool");
var $dRMig = parcelRequire("dRMig");

var $80yPZ = parcelRequire("80yPZ");

var $4rIwL = parcelRequire("4rIwL");
const $493de8eeef112bdb$export$fcfe7b179287e200 = `/topic`;
const $493de8eeef112bdb$var$ADD_TOPIC_PATH = `${$493de8eeef112bdb$export$fcfe7b179287e200}/add`;
const $493de8eeef112bdb$var$EDIT_TOPIC_PATH = `${$493de8eeef112bdb$export$fcfe7b179287e200}/edit/:id`;
const $493de8eeef112bdb$export$7285959833dc0185 = (0, $fcCIH.default)((props)=>{
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: props.location.pathname
    }), (0, $aylSc.default)({
        message: props.intl.formatMessage((0, $80yPZ.authPageMessage)),
        callToActionText: props.intl.formatMessage((0, $80yPZ.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dRMig.default), {
            path: $493de8eeef112bdb$var$EDIT_TOPIC_PATH,
            component: (0, $HgXms.EditTopicPage),
            screenName: (0, $9mazR.ScreenName).EDIT_TOPIC
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props);
});
const $493de8eeef112bdb$export$60c0f814fe4b3a12 = {
    name: (0, $9mazR.ScreenName).EDIT_TOPIC,
    path: $493de8eeef112bdb$var$EDIT_TOPIC_PATH,
    exact: true,
    component: (0, $7tc2B.withRouter)($493de8eeef112bdb$export$7285959833dc0185),
    resources: [
        (0, $4rIwL.editTopicResource)
    ]
};
const $493de8eeef112bdb$export$9d8f7fd5bc61f52f = {
    name: (0, $9mazR.ScreenName).EDIT_TOPIC,
    path: $493de8eeef112bdb$var$ADD_TOPIC_PATH,
    exact: true,
    component: (0, $7tc2B.withRouter)($493de8eeef112bdb$export$7285959833dc0185),
    resources: [
        (0, $4rIwL.editTopicResource)
    ]
};

});
parcelRegister("HgXms", function(module, exports) {
$parcel$export(module.exports, "EditTopicPage", () => $de84aeb8327cc38a$export$167706eed2563765);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

var $jNOKR = parcelRequire("jNOKR");

const $de84aeb8327cc38a$export$167706eed2563765 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("93hzF")).then((module)=>{
            const { registerHelpObjectEpicsAndReducers: registerHelpObjectEpicsAndReducers } = module;
            registerHelpObjectEpicsAndReducers();
            return module.default;
        }), {
        moduleId: "./src/topics/src/ui/edit-topic/main.tsx"
    }),
    LoadingSkeleton: (0, $jNOKR.EditTopicLoader)
});

});
parcelRegister("jNOKR", function(module, exports) {
$parcel$export(module.exports, "EditTopicLoader", () => $eeb0aaa42f2e8d0f$export$c00c0ab43fa4f914);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $aUHFa = parcelRequire("aUHFa");
var $8PITw = parcelRequire("8PITw");

var $fOCtI = parcelRequire("fOCtI");

var $5a4EU = parcelRequire("5a4EU");

var $hculA = parcelRequire("hculA");

var $hACnb = parcelRequire("hACnb");
const $eeb0aaa42f2e8d0f$export$c00c0ab43fa4f914 = (props)=>{
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, props.error ? /*#__PURE__*/ $fc4bM.createElement($eeb0aaa42f2e8d0f$var$LoaderContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $fc4bM.createElement((0, $hACnb.Container), null, /*#__PURE__*/ $fc4bM.createElement((0, $hACnb.TopicContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingInline: "space.500"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $hACnb.SpinnerWrapper), null, /*#__PURE__*/ $fc4bM.createElement((0, $hculA.default), {
        size: 'medium'
    })))), /*#__PURE__*/ $fc4bM.createElement((0, $hACnb.HelpObjectContainer), null, /*#__PURE__*/ $fc4bM.createElement($eeb0aaa42f2e8d0f$var$Row, null, /*#__PURE__*/ $fc4bM.createElement((0, $8PITw.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $fc4bM.createElement($eeb0aaa42f2e8d0f$var$Row, null, /*#__PURE__*/ $fc4bM.createElement((0, $8PITw.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $fc4bM.createElement($eeb0aaa42f2e8d0f$var$Row, null, /*#__PURE__*/ $fc4bM.createElement((0, $8PITw.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })))));
};
const $eeb0aaa42f2e8d0f$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $eeb0aaa42f2e8d0f$var$LoaderContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-16axg55-0"
})`min-height:${$eeb0aaa42f2e8d0f$var$LOADER_MIN_HEIGHT};display:flex;align-items:center;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $eeb0aaa42f2e8d0f$var$Row = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-16axg55-1"
})`margin-top:${"var(--ds-space-200, 16px)"};width:${$fOCtI.multiple(50).px};`;

});
parcelRegister("hACnb", function(module, exports) {
$parcel$export(module.exports, "Container", () => $5ebd8bc399670d55$export$42a852a2b6b56249);
$parcel$export(module.exports, "TopicContainer", () => $5ebd8bc399670d55$export$3906a519f454d518);
$parcel$export(module.exports, "HelpObjectContainer", () => $5ebd8bc399670d55$export$7e8e7bb92ce298ab);
$parcel$export(module.exports, "SpinnerWrapper", () => $5ebd8bc399670d55$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $3DjOo = parcelRequire("3DjOo");

var $ku1lj = parcelRequire("ku1lj");
const $5ebd8bc399670d55$var$topicContainerWidth = '70%';
const $5ebd8bc399670d55$var$topicContainerMinHeight = `calc(100vh - ${(0, $ku1lj.FOOTER_HEIGHT)}px)`;
const $5ebd8bc399670d55$var$helpObjectContainerWidth = '30%';
const $5ebd8bc399670d55$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-7u94c0-0"
})`display:flex;flex-wrap:wrap;justify-content:space-between;border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};`;
const $5ebd8bc399670d55$export$3906a519f454d518 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-7u94c0-1"
})`width:${$5ebd8bc399670d55$var$topicContainerWidth};padding:${"var(--ds-space-400, 32px)"} ${"var(--ds-space-1000, 80px)"};background-color:${"var(--ds-surface, #FFFFFF)"};border-right:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};box-sizing:border-box;min-height:${$5ebd8bc399670d55$var$topicContainerMinHeight};`;
const $5ebd8bc399670d55$export$7e8e7bb92ce298ab = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-7u94c0-2"
})`width:${$5ebd8bc399670d55$var$helpObjectContainerWidth};box-sizing:border-box;padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"};`;
const $5ebd8bc399670d55$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-7u94c0-3"
})`${$3DjOo.flexCenter};margin-top:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("93hzF", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2g5QR"),
    $9dnsd("61osU"),
    $9dnsd("84PLG"),
    $9dnsd("jBz2s"),
    $9dnsd("7D0l2")
]).then(()=>parcelRequire('3IQey'));

});


parcelRegister("4rIwL", function(module, exports) {
$parcel$export(module.exports, "editTopicResource", () => $02b05fa7aef6960a$export$414824bab2e11c29);

var $eoYgn = parcelRequire("eoYgn");

var $8zK3E = parcelRequire("8zK3E");
const $02b05fa7aef6960a$export$414824bab2e11c29 = (0, $8zK3E.createRelayResource)({
    type: 'EDIT_TOPIC',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $eoYgn.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});


parcelRegister("fHOft", function(module, exports) {
$parcel$export(module.exports, "getEmbedCreateRequestRoute", () => $f47a30d57e32b9f3$export$ed25ec64c8131f29);
$parcel$export(module.exports, "embedSinglePortalRoute", () => $f47a30d57e32b9f3$export$f8f6af866fe5eb29);
$parcel$export(module.exports, "embedKBArticleRoute", () => $f47a30d57e32b9f3$export$50b320f40299497c);
$parcel$export(module.exports, "embedFeaturedPortalsRoute", () => $f47a30d57e32b9f3$export$89cf0aa4f08ce120);
$parcel$export(module.exports, "embedLoginSuccessRoute", () => $f47a30d57e32b9f3$export$a493105cf7e63414);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $9mazR = parcelRequire("9mazR");

var $fOCtI = parcelRequire("fOCtI");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
var $7tc2B = parcelRequire("7tc2B");
parcelRequire("dRiEG");
var $7hPHG = parcelRequire("7hPHG");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");

var $dkrfZ = parcelRequire("dkrfZ");
const $f47a30d57e32b9f3$export$2e9e2f006c89796d = (WrappedComponent, screenName)=>{
    const ComponentWithEmbeddedPage = (props)=>{
        const [routerState] = (0, $7lAXH.useRouter)();
        const { basePath: basePath, ...routeContext } = routerState;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkrfZ.default), {
            screenName: screenName,
            screenId: routeContext.match.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4xX38.default), {
            screenName: screenName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f47a30d57e32b9f3$var$EmbedComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7hPHG.default), routeContext), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, {
            isEmbeddedRoute: true,
            ...routeContext,
            ...props
        }))));
    };
    return ComponentWithEmbeddedPage;
};

// Route for embeddable request create page
const $f47a30d57e32b9f3$var$AsyncEmbedCreateRequestPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("hCV7E")), {
        moduleId: "./src/view/request-create-page/embed-request-create-page/index.tsx"
    })
});
const $f47a30d57e32b9f3$export$ed25ec64c8131f29 = ()=>({
        name: 'embed-request-create',
        path: `/embeds/portal/:portalId/create/:requestTypeId`,
        exact: true,
        component: (0, $7tc2B.withRouter)($f47a30d57e32b9f3$export$2e9e2f006c89796d($f47a30d57e32b9f3$var$AsyncEmbedCreateRequestPage, (0, $9mazR.ScreenName).EMBED_REQUEST_CREATE)),
        resources: []
    });

// Route for embeddable single portal page
const $f47a30d57e32b9f3$var$AsyncEmbedSinglePortalPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("9YfJn")), {
        moduleId: "./src/view/help-center/help-center-content/embed-single-portal/index.tsx"
    })
});
const $f47a30d57e32b9f3$export$f8f6af866fe5eb29 = {
    name: 'embed-single-portal',
    path: `/embeds/portal/:portalId`,
    exact: true,
    component: (0, $7tc2B.withRouter)($f47a30d57e32b9f3$export$2e9e2f006c89796d($f47a30d57e32b9f3$var$AsyncEmbedSinglePortalPage, (0, $9mazR.ScreenName).EMBED_SINGLE_PORTAL))
};

// Route for embeddable knowledge base article page
const $f47a30d57e32b9f3$var$AsyncEmbedKBArticlePage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("2YkvM")), {
        moduleId: "./src/view/article/embed-kb-article/index.tsx"
    })
});
const $f47a30d57e32b9f3$export$50b320f40299497c = {
    name: 'embed-kb-article',
    path: `/embeds/portal/:portalId/:topic?/:categoryId?/:article/:articleId`,
    exact: true,
    component: (0, $7tc2B.withRouter)($f47a30d57e32b9f3$export$2e9e2f006c89796d($f47a30d57e32b9f3$var$AsyncEmbedKBArticlePage, (0, $9mazR.ScreenName).EMBED_KB_ARTICLE))
};

// Route for embeddable featured portals page
const $f47a30d57e32b9f3$var$AsyncEmbedFeaturedPortalsPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("1lAdD")), {
        moduleId: "./src/view/help-center/embed-featured-portals/index.tsx"
    })
});
const $f47a30d57e32b9f3$export$89cf0aa4f08ce120 = {
    name: 'embed-featured-portals',
    path: `/embeds/portals`,
    exact: true,
    component: (0, $7tc2B.withRouter)($f47a30d57e32b9f3$export$2e9e2f006c89796d($f47a30d57e32b9f3$var$AsyncEmbedFeaturedPortalsPage, (0, $9mazR.ScreenName).EMBED_FEATURED_PORTALS))
};

// Route for embedded login success page
const $f47a30d57e32b9f3$var$AsyncEmbedLoginSuccessPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("4i347")), {
        moduleId: "./src/view/login/embed-login-success/index.tsx"
    })
});
const $f47a30d57e32b9f3$export$a493105cf7e63414 = {
    name: 'embed-login-success',
    path: `/embeds/login-success`,
    exact: true,
    component: (0, $7tc2B.withRouter)($f47a30d57e32b9f3$export$2e9e2f006c89796d($f47a30d57e32b9f3$var$AsyncEmbedLoginSuccessPage, (0, $9mazR.ScreenName).EMBED_LOGIN_SUCCESS))
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f47a30d57e32b9f3$var$EmbedComponentWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-168unha-0"
})`display:flex;flex-direction:column;min-height:100%;border:${$fOCtI.multiple(1 / 8).px} solid ${"var(--ds-border-bold, #EBECF0)"};border-radius:${$fOCtI.multiple(3 / 8).px};box-sizing:border-box;`;

});
parcelRegister("hCV7E", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jiQf3").then(()=>parcelRequire('lS3JR'));

});

parcelRegister("9YfJn", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5Flnk"),
    $9dnsd("f0pKH")
]).then(()=>parcelRequire('c4rNp'));

});

parcelRegister("2YkvM", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cNxBs").then(()=>parcelRequire('kJPkx'));

});

parcelRegister("1lAdD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bMKAA"),
    $9dnsd("DQIDP")
]).then(()=>parcelRequire('95GJd'));

});

parcelRegister("4i347", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ajjMw").then(()=>parcelRequire('15fRA'));

});


parcelRegister("1NjiO", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterRoute", () => $886d9e72430ff323$export$4e7002b7e4a938bc);

var $9mazR = parcelRequire("9mazR");

var $4MFtS = parcelRequire("4MFtS");
const $886d9e72430ff323$export$4e7002b7e4a938bc = ()=>{
    const name = 'help-center';
    const path = '/portals';
    const screenName = (0, $9mazR.ScreenName).HELP_CENTER;
    return (0, $4MFtS.getFlexiHelpCenterRoute)(name, path, screenName);
};

});

parcelRegister("eKYgj", function(module, exports) {
$parcel$export(module.exports, "RenderArticlesSearchRoute", () => $4ae577469dedc6ae$export$b8c7cf9fcb5a9882);
$parcel$export(module.exports, "viewKbPageRoute", () => $4ae577469dedc6ae$export$7770cb0c6ff06b3a);
$parcel$export(module.exports, "viewAllSearchResultsRoute", () => $4ae577469dedc6ae$export$b9392cfe93dd18c7);
$parcel$export(module.exports, "viewPortalAllSearchResultsRoute", () => $4ae577469dedc6ae$export$ecf8460d0ec6e97);
$parcel$export(module.exports, "viewPortalKnowledgeCategoryRoute", () => $4ae577469dedc6ae$export$4704dfed5640c7f);
$parcel$export(module.exports, "viewPortalCategoryArticleRoute", () => $4ae577469dedc6ae$export$c875ec1eb313d3e6);
$parcel$export(module.exports, "viewPortalArticleRoute", () => $4ae577469dedc6ae$export$ad9d4a1dd23783b4);
$parcel$export(module.exports, "viewArticleRoute", () => $4ae577469dedc6ae$export$95b4792c2f78259d);
$parcel$export(module.exports, "viewCrossSitePortalArticleRoute", () => $4ae577469dedc6ae$export$d549c8909c9cf794);
$parcel$export(module.exports, "viewCrossSiteArticleRoute", () => $4ae577469dedc6ae$export$10ea759d4b0b4d21);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
var $7tc2B = parcelRequire("7tc2B");

var $e4v4V = parcelRequire("e4v4V");
parcelRequire("dRiEG");
var $7hPHG = parcelRequire("7hPHG");

var $35DN9 = parcelRequire("35DN9");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");

var $dkrfZ = parcelRequire("dkrfZ");

var $joDHD = parcelRequire("joDHD");

var $ivtaS = parcelRequire("ivtaS");

const $4ae577469dedc6ae$var$AllSearchResults = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("bDo58")), {
        moduleId: "./packages/help-center/search/src/all-results/index.tsx"
    })
});
const $4ae577469dedc6ae$var$RenderKnowledgeCategoryRoute = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
        screenName: (0, $9mazR.ScreenName).KNOWLEDGE_CATEGORY,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4xX38.default), {
        screenName: (0, $9mazR.ScreenName).KNOWLEDGE_CATEGORY
    }, /*#__PURE__*/ $fc4bM.createElement((0, $35DN9.KnowledgeCategory), routeContext)));
};
const $4ae577469dedc6ae$export$b8c7cf9fcb5a9882 = ()=>{
    const [routerState] = (0, $7lAXH.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
        screenName: (0, $9mazR.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4xX38.default), {
        screenName: (0, $9mazR.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS
    }, /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $7hPHG.default), routeContext), /*#__PURE__*/ $fc4bM.createElement($4ae577469dedc6ae$var$AllSearchResults, routeContext))));
};
const $4ae577469dedc6ae$export$319de0a85a85b4cd = (isArticleView)=>{
    return isArticleView ? 'xxwide' : 'xwide';
};
const $4ae577469dedc6ae$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $e4v4V.Article)
};
const $4ae577469dedc6ae$var$portalKnowledgeCategory = {
    resources: [],
    name: 'view-portal-kb-category',
    path: `/portal/:portalId/topic/:categoryId`,
    exact: true,
    component: $4ae577469dedc6ae$var$RenderKnowledgeCategoryRoute
};
const $4ae577469dedc6ae$var$viewPortalCategoryArticle = {
    resources: [],
    name: 'view-portal-kb-category-article',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/topic/:categoryId/article/:articleId`,
    exact: true,
    component: (0, $e4v4V.Article)
};
const $4ae577469dedc6ae$var$viewPortalArticle = {
    resources: [],
    name: 'view-portal-kb-article',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
    exact: true,
    component: (0, $e4v4V.Article)
};
const $4ae577469dedc6ae$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $e4v4V.Article)
};
const $4ae577469dedc6ae$var$viewCrossSitePortalArticle = {
    resources: [],
    name: 'view-portal-cross-site-kb-article',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $e4v4V.Article)
};
const $4ae577469dedc6ae$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $e4v4V.Article)
};
const $4ae577469dedc6ae$var$viewAllSearchResults = {
    resources: [],
    name: 'view-all-search-results',
    path: `/articles/search`,
    exact: true,
    component: $4ae577469dedc6ae$var$AllSearchResults
};
const $4ae577469dedc6ae$var$viewPortalAllSearchResults = {
    resources: [],
    name: 'view-portal-all-search-results',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/articles/search`,
    exact: true,
    component: $4ae577469dedc6ae$var$AllSearchResults
};
const $4ae577469dedc6ae$var$categoryLayoutProps = {
    paperAppearance: $4ae577469dedc6ae$export$319de0a85a85b4cd(false),
    fadeInSearchModal: true
};
const $4ae577469dedc6ae$var$layoutProps = {
    paperAppearance: $4ae577469dedc6ae$export$319de0a85a85b4cd(true),
    fadeInSearchModal: true
};
const $4ae577469dedc6ae$export$7770cb0c6ff06b3a = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$viewKbPage, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $4ae577469dedc6ae$var$layoutProps);
const $4ae577469dedc6ae$export$b9392cfe93dd18c7 = {
    ...$4ae577469dedc6ae$var$viewAllSearchResults,
    component: (0, $7tc2B.withRouter)($4ae577469dedc6ae$export$b8c7cf9fcb5a9882)
};
const $4ae577469dedc6ae$export$ecf8460d0ec6e97 = {
    ...$4ae577469dedc6ae$var$viewPortalAllSearchResults,
    component: (0, $7tc2B.withRouter)($4ae577469dedc6ae$export$b8c7cf9fcb5a9882)
};
const $4ae577469dedc6ae$export$4704dfed5640c7f = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$portalKnowledgeCategory, (0, $9mazR.ScreenName).KNOWLEDGE_CATEGORY, $4ae577469dedc6ae$var$categoryLayoutProps);
const $4ae577469dedc6ae$export$c875ec1eb313d3e6 = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$viewPortalCategoryArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $4ae577469dedc6ae$var$layoutProps);
const $4ae577469dedc6ae$export$ad9d4a1dd23783b4 = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$viewPortalArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $4ae577469dedc6ae$var$layoutProps);
const $4ae577469dedc6ae$export$95b4792c2f78259d = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$viewArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $4ae577469dedc6ae$var$layoutProps);
const $4ae577469dedc6ae$export$d549c8909c9cf794 = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$viewCrossSitePortalArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $4ae577469dedc6ae$var$layoutProps);
const $4ae577469dedc6ae$export$10ea759d4b0b4d21 = (0, $joDHD.createRouteWithLayout)($4ae577469dedc6ae$var$viewCrossSiteArticle, (0, $9mazR.ScreenName).KNOWLEDGE_ARTICLE, $4ae577469dedc6ae$var$layoutProps);

});
parcelRegister("e4v4V", function(module, exports) {
$parcel$export(module.exports, "Article", () => $1737b2f805017bc3$export$89693000420c0acd);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $1737b2f805017bc3$export$89693000420c0acd = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("6CzPk")), {
        moduleId: "./src/view/article/hocs.tsx"
    })
});

});
parcelRegister("6CzPk", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5Qtzw"),
    $9dnsd("3aoyb")
]).then(()=>parcelRequire('lBmRj'));

});


parcelRegister("35DN9", function(module, exports) {
$parcel$export(module.exports, "KnowledgeCategory", () => $45b858ddf9de746e$export$b0a220e8bdf61c72);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2EMow = parcelRequire("2EMow");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("3cm1i");
var $kftqr = parcelRequire("kftqr");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $kFBfx = parcelRequire("kFBfx");
const $45b858ddf9de746e$var$mapStateToProps = (state, props)=>{
    let portalId;
    let categoryId;
    if (props.match.params) {
        portalId = Number(props.match.params.portalId);
        categoryId = props.match.params.categoryId;
    }
    const showRequestCreateButton = (0, $9D9SX.canCreateRequest)(state, portalId);
    const portal = (0, $9D9SX.getPortalOrError)(state, portalId);
    const portalName = (0, $9D9SX.getName)(state, portalId);
    const projectId = (0, $9D9SX.getProjectId)(state, portalId);
    const shouldFetchPortalOnMount = !portal;
    const portalLink = (0, $9D9SX.getPortalLink)(state, portalId);
    const categoryOrError = (0, $9D9SX.getCategory)(state, portalId, categoryId);
    const articlesOrError = (0, $kftqr.getArticles)(state, categoryId);
    const category = !!categoryOrError && 'name' in categoryOrError ? categoryOrError : undefined;
    // we show a different loading spinner specifically for articles,
    // this way we can still display the user the category information and the bread-crumbs as soon as we have that data
    const isArticlesLoading = !articlesOrError;
    const portalError = !!portal && 'error' in portal ? portal : undefined;
    const articleFetchError = !!articlesOrError && 'error' in articlesOrError ? articlesOrError : undefined;
    let error;
    if (!!portalError) error = portalError;
    // any errors that occur when fetching categories will be available in articleFetchError
    // as the two calls are combined on initial page load
    if (!!articleFetchError && !isArticlesLoading) error = articleFetchError;
    const isLoading = !portal;
    const articles = Array.isArray(articlesOrError) ? articlesOrError : undefined;
    return {
        portalId: portalId,
        categoryId: categoryId,
        projectId: projectId,
        category: category,
        articles: articles,
        portalName: portalName,
        isLoading: isLoading,
        isArticlesLoading: isArticlesLoading,
        shouldFetchPortalOnMount: shouldFetchPortalOnMount,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        error: error ? error.error : undefined
    };
};
const $45b858ddf9de746e$export$b0a220e8bdf61c72 = (0, $6umft.default)($45b858ddf9de746e$var$mapStateToProps, {
    fetchPortal: (0, $hijaX.fetchPortalAction),
    fetchArticles: (0, $2EMow.fetchArticlesAction)
})((0, $kFBfx.default));

});
parcelRegister("3cm1i", function(module, exports) {
$parcel$export(module.exports, "getArticle", () => (parcelRequire("kftqr")).getArticle);
$parcel$export(module.exports, "getArticles", () => (parcelRequire("kftqr")).getArticles);
$parcel$export(module.exports, "getArticleTitle", () => (parcelRequire("kftqr")).getArticleTitle);
parcelRequire("kftqr");

});
parcelRegister("kftqr", function(module, exports) {
$parcel$export(module.exports, "getArticles", () => $7400961d156cb7d9$export$59baee6c0c5ecafe);
$parcel$export(module.exports, "getArticle", () => $7400961d156cb7d9$export$f8c0d0a39b0d7d4e);
$parcel$export(module.exports, "getArticleTitle", () => $7400961d156cb7d9$export$7aa4b20764201f2f);
const $7400961d156cb7d9$export$59baee6c0c5ecafe = (state, categoryId)=>{
    if (!categoryId) return undefined;
    const articleState = state.persisted.kbArticles;
    if (articleState.articles[categoryId] && articleState.articles[categoryId].error) return articleState.articles[categoryId].error;
    return articleState.articles[categoryId] ? articleState.articles[categoryId].articles : undefined;
};
const $7400961d156cb7d9$export$f8c0d0a39b0d7d4e = (state, id)=>!!id ? state.persisted.kbArticles.legacyArticles[id] : undefined;
const $7400961d156cb7d9$export$7aa4b20764201f2f = (state, id)=>{
    const article = $7400961d156cb7d9$export$f8c0d0a39b0d7d4e(state, id);
    if (!article || 'error' in article) return undefined;
    return article.title;
};

});


parcelRegister("kFBfx", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc209b669ef24b39$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aHS3M = parcelRequire("aHS3M");

var $9J2wU = parcelRequire("9J2wU");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("e2U4l");
var $8min0 = parcelRequire("8min0");
parcelRequire("0bBIT");
var $kHvdI = parcelRequire("kHvdI");
parcelRequire("blonq");
var $4m70N = parcelRequire("4m70N");

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");

var $eENmG = parcelRequire("eENmG");
parcelRequire("2Cw7K");
var $chcrg = parcelRequire("chcrg");

var $6MwKq = parcelRequire("6MwKq");
class $dc209b669ef24b39$export$b0a220e8bdf61c72 extends $fc4bM.Component {
    componentDidMount() {
        const { shouldFetchPortalOnMount: shouldFetchPortalOnMount, fetchPortal: fetchPortal, fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        if (shouldFetchPortalOnMount && portalId) fetchPortal({
            id: portalId,
            expand: [
                'reqTypes',
                'reqGroups',
                'orderMapping',
                'kbs'
            ]
        });
        if (portalId && projectId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        const shouldFetchArticles = !prevProps.projectId && projectId;
        if (shouldFetchArticles && projectId && portalId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    renderInnerContent() {
        const { category: category, articles: articles, portalId: portalId, isArticlesLoading: isArticlesLoading, portalName: portalName, portalLink: portalLink, showRequestCreateButton: showRequestCreateButton } = this.props;
        if (!category || !portalId || !portalName) return null;
        const attributes = (articles || []).reduce((attr, article)=>({
                featured: attr.featured + (article.isFeatured ? 1 : 0),
                total: attr.total + 1
            }), {
            featured: 0,
            total: 0
        });
        return /*#__PURE__*/ $fc4bM.createElement((0, $eENmG.AnalyticsContext), {
            attributes: attributes
        }, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.PaperContent), null, /*#__PURE__*/ $fc4bM.createElement((0, $kHvdI.default), {
            subHeading: category.name,
            description: category.description,
            portalId: portalId,
            categoryId: category.id
        }), /*#__PURE__*/ $fc4bM.createElement((0, $chcrg.default), {
            portalLink: portalLink,
            portalId: portalId,
            portalName: portalName,
            categoryId: category.id,
            articles: articles,
            showRequestCreateButton: showRequestCreateButton,
            isLoading: isArticlesLoading
        })));
    }
    render() {
        const { category: category, portalName: portalName, intl: intl, isLoading: isLoading } = this.props;
        const pageTitle = category && portalName ? intl.formatMessage((0, $6MwKq.default).categoryDocumentTitle, {
            portalName: portalName,
            categoryName: category.name
        }) : undefined;
        return /*#__PURE__*/ $fc4bM.createElement((0, $aHS3M.default), {
            title: pageTitle
        }, /*#__PURE__*/ $fc4bM.createElement((0, $8min0.default), {
            isLoading: isLoading
        }, this.renderInnerContent()));
    }
    constructor(...args){
        super(...args), this.getFailureAnalyticsEvent = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'articlesFetch failed',
                    analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE)
                })
            };
        };
    }
}
var $dc209b669ef24b39$export$2e2bcd8739ae039 = (0, $9J2wU.withErrorPage)((0, $fcCIH.default)((0, $613oU.default)({
    componentName: 'KbCategory'
})((0, $azARG.default)()($dc209b669ef24b39$export$b0a220e8bdf61c72))));

});
parcelRegister("e2U4l", function(module, exports) {
$parcel$export(module.exports, "LoadingContainer", () => (parcelRequire("8min0")).default);

var $8min0 = parcelRequire("8min0");

});
parcelRegister("8min0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc57b54972e3510b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aUHFa = parcelRequire("aUHFa");

var $d7r8x = parcelRequire("d7r8x");
class $bc57b54972e3510b$export$2e2bcd8739ae039 extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, interactionName: interactionName, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const loader = /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.default), {
            isLoading: true,
            loadingPosition: loadingPosition,
            interactionName: interactionName
        });
        if (!isLoading) return children;
        return enableUFOHold ? /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
            name: ufoHoldName
        }, loader) : loader;
    }
}

});


parcelRegister("0bBIT", function(module, exports) {
$parcel$export(module.exports, "PaperHeader", () => (parcelRequire("kHvdI")).default);

var $kHvdI = parcelRequire("kHvdI");

});
parcelRegister("kHvdI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e035fca13170bc6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $2KIJl = parcelRequire("2KIJl");
parcelRequire("iaK5c");
var $1y6Eq = parcelRequire("1y6Eq");
parcelRequire("f2SdC");
var $gtyP1 = parcelRequire("gtyP1");

var $3Z9Za = parcelRequire("3Z9Za");

var $1hJdJ = parcelRequire("1hJdJ");

var $6Pd4T = parcelRequire("6Pd4T");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
const $3e035fca13170bc6$var$headerDescription = (description, dangerouslyAllowHtmlInDescription)=>dangerouslyAllowHtmlInDescription ? /*#__PURE__*/ $fc4bM.createElement((0, $3Z9Za.Description), {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }) : /*#__PURE__*/ $fc4bM.createElement((0, $3Z9Za.Description), null, description);
const $3e035fca13170bc6$var$PaperHeader = ({ subHeading: subHeading, description: description, logoUrl: logoUrl, showRequestsInBreadcrumbs: showRequestsInBreadcrumbs, dangerouslyAllowHtmlInDescription: dangerouslyAllowHtmlInDescription, dataTestId: dataTestId, articleId: articleId, hideBreadcrumbs: hideBreadcrumbs = false, ...props })=>{
    const isCsmSupportSite = $fc4bM.useMemo(()=>(0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType), []);
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-testid": dataTestId
    }, !hideBreadcrumbs && (articleId && isCsmSupportSite ? /*#__PURE__*/ $fc4bM.createElement($fc4bM.Suspense, {
        fallback: /*#__PURE__*/ $fc4bM.createElement((0, $1y6Eq.default), {
            ...props,
            showRequests: showRequestsInBreadcrumbs
        })
    }, /*#__PURE__*/ $fc4bM.createElement((0, $gtyP1.CsmBreadcrumbs), {
        articleId: articleId
    })) : /*#__PURE__*/ $fc4bM.createElement((0, $1y6Eq.default), {
        ...props,
        showRequests: showRequestsInBreadcrumbs
    })), /*#__PURE__*/ $fc4bM.createElement((0, $3Z9Za.SubHeadingContainer), null, !!logoUrl && /*#__PURE__*/ $fc4bM.createElement((0, $3Z9Za.IconContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $2KIJl.default), {
        src: logoUrl,
        alt: ""
    })), /*#__PURE__*/ $fc4bM.createElement("div", null, /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
            size: "large",
            as: "h1"
        }, subHeading)
    }, /*#__PURE__*/ $fc4bM.createElement((0, $3Z9Za.SubHeading), null, subHeading)))), !!description && $3e035fca13170bc6$var$headerDescription(description, dangerouslyAllowHtmlInDescription));
};
var $3e035fca13170bc6$export$2e2bcd8739ae039 = $3e035fca13170bc6$var$PaperHeader;

});
parcelRegister("iaK5c", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbs", () => (parcelRequire("1y6Eq")).default);

var $1y6Eq = parcelRequire("1y6Eq");

});
parcelRegister("1y6Eq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1a4f4ff2f3f398f$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $eXQnZ = parcelRequire("eXQnZ");
parcelRequire("g3jMF");
var $49H5B = parcelRequire("49H5B");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("3cm1i");
var $kftqr = parcelRequire("kftqr");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $g81wt = parcelRequire("g81wt");
parcelRequire("krNxs");
var $eQvye = parcelRequire("eQvye");
const $c1a4f4ff2f3f398f$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getSharedPortalName), (state, props)=>{
    return (0, $9D9SX.getName)(state, (0, $g81wt.toNumber)(props.portalId)) ?? (0, $49H5B.getPortalNameFromBranding)(state);
}, (state, props)=>{
    const category = (0, $9D9SX.getCategory)(state, (0, $g81wt.toNumber)(props.portalId), props.categoryId);
    return !!category && 'name' in category ? category.name : undefined;
}, (state, props)=>{
    return (0, $kftqr.getArticleTitle)(state, props.articleId);
}, (sharedPortalName, portalName, categoryName, articleTitle)=>({
        sharedPortalName: sharedPortalName,
        portalName: portalName,
        categoryName: categoryName,
        articleTitle: articleTitle
    }));
const $c1a4f4ff2f3f398f$export$5646050d516e06bc = (0, $6umft.default)($c1a4f4ff2f3f398f$var$selector)((0, $eQvye.default));
var $c1a4f4ff2f3f398f$export$2e2bcd8739ae039 = (0, $eXQnZ.default)($c1a4f4ff2f3f398f$export$5646050d516e06bc);

});
parcelRegister("g3jMF", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => (parcelRequire("49H5B")).getPortalNameFromBranding);

var $49H5B = parcelRequire("49H5B");

});
parcelRegister("49H5B", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => $97c5a4c9c1feaa38$export$b81ba060d3a3afb3);
const $97c5a4c9c1feaa38$export$b81ba060d3a3afb3 = (state)=>{
    var _state$persisted$bran;
    if ((_state$persisted$bran = state.persisted.branding) !== null && _state$persisted$bran !== void 0 && _state$persisted$bran.name) return state.persisted.branding.name;
    return undefined;
};

});


parcelRegister("krNxs", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbsDumb", () => (parcelRequire("eQvye")).default);

var $eQvye = parcelRequire("eQvye");

});
parcelRegister("eQvye", function(module, exports) {
$parcel$export(module.exports, "default", () => $a38d4ccba370bf86$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7ZXzW = parcelRequire("7ZXzW");

var $fcCIH = parcelRequire("fcCIH");

var $ddnRa = parcelRequire("ddnRa");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $gioQl = parcelRequire("gioQl");

var $1erEI = parcelRequire("1erEI");
const $a38d4ccba370bf86$export$a1a3354a8b2c8731 = ({ sharedPortalName: sharedPortalName, portalName: portalName, categoryName: categoryName, articleTitle: articleTitle, portalId: portalId, categoryId: categoryId, articleId: articleId, showRequests: showRequests, intl: intl, requestKey: requestKey, requestUrl: requestUrl, additionalBreadCrumbs: additionalBreadCrumbs })=>{
    const requestCreateBreadcrumb = showRequests ? intl.formatMessage((0, $1erEI.default).raiseRequestBreadcrumb) : undefined;
    const isCSM = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    return /*#__PURE__*/ $fc4bM.createElement((0, $ddnRa.default), {
        label: intl.formatMessage((0, $1erEI.default).breadcrumbsLabel)
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        to: (0, $gioQl.getHelpCenterUrl)(),
        name: !isCSM ? sharedPortalName : intl.formatMessage((0, $1erEI.default).breadcrumbsHome),
        isFirstCrumb: true,
        actionSubjectId: "helpCenterBreadcrumb"
    }, !isCSM && portalId !== undefined && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        to: `/portal/${portalId}`,
        name: portalName,
        actionSubjectId: "portalBreadcrumb"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        to: requestUrl || '',
        name: requestKey,
        actionSubjectId: "requestBreadcrumb",
        testId: "requestKey"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        to: `/portal/${portalId}/group/-1`,
        name: requestCreateBreadcrumb,
        actionSubjectId: "requestCreateBreadcrumb"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}`,
        name: categoryName,
        actionSubjectId: "categoryBreadcrumb"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    }), additionalBreadCrumbs === null || additionalBreadCrumbs === void 0 ? void 0 : additionalBreadCrumbs.map((breadCrumb)=>breadCrumb)));
};
var $a38d4ccba370bf86$export$2e2bcd8739ae039 = (0, $fcCIH.default)($a38d4ccba370bf86$export$a1a3354a8b2c8731);

});
parcelRegister("7ZXzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ca273c0a0ee4278$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $g9mbo = parcelRequire("g9mbo");

var $io4o2 = parcelRequire("io4o2");

var $lq3BZ = parcelRequire("lq3BZ");

var $imLe4 = parcelRequire("imLe4");

var $fRgxR = parcelRequire("fRgxR");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $6Pd4T = parcelRequire("6Pd4T");
/**
 * This is a nestable bread crumb component, it will render the first component with a valid name.
 * It itself will also not render if the name is not valid.
 */ const $2ca273c0a0ee4278$var$BreadCrumbDumb = ({ name: name, to: to, children: children, isFirstCrumb: isFirstCrumb, actionSubjectId: actionSubjectId, testId: testId, tabIndex: tabIndex, onClick: onClick, disableTheme: disableTheme = false })=>{
    const isCSMTypographyMigrationEnabled = (0, $6Pd4T.useIsCSMTypographyMigrationEnabled)();
    if (!name) return null;
    let child;
    $fc4bM.Children.forEach(children, (element)=>{
        // Short circuit if there is already a match
        if (child) return;
        if (element && /*#__PURE__*/ $fc4bM.isValidElement(element)) {
            const { name: childName } = element.props;
            if (childName) child = element;
        }
    });
    let linkComponent;
    if (to.startsWith('/')) {
        let RootLinkComponent = disableTheme ? $2ca273c0a0ee4278$var$RootLinkDisabledTheme : $2ca273c0a0ee4278$var$RootLink;
        if (isCSMTypographyMigrationEnabled) RootLinkComponent = disableTheme ? $2ca273c0a0ee4278$var$RootLinkDisabledTheme : $2ca273c0a0ee4278$var$RootLinkWithToken;
        linkComponent = /*#__PURE__*/ $fc4bM.createElement(RootLinkComponent, {
            to: to,
            actionSubjectId: actionSubjectId,
            "data-test-id": testId,
            "aria-current": child ? 'false' : 'page',
            tabIndex: tabIndex,
            onClick: onClick
        }, name);
    } else {
        let ExternalLinkComponent = disableTheme ? $2ca273c0a0ee4278$var$ExternalLinkDisabledTheme : $2ca273c0a0ee4278$var$ExternalLink;
        if (isCSMTypographyMigrationEnabled) ExternalLinkComponent = disableTheme ? $2ca273c0a0ee4278$var$ExternalLinkDisabledTheme : $2ca273c0a0ee4278$var$ExternalLinkWithToken;
        const externalLinkProps = {
            tabIndex: tabIndex,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            href: to,
            'data-test-id': testId,
            'aria-current': child ? 'false' : 'page'
        };
        linkComponent = /*#__PURE__*/ $fc4bM.createElement(ExternalLinkComponent, externalLinkProps, name);
    }
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        as: 'li',
        xcss: [
            $2ca273c0a0ee4278$var$breadCrumbContainer,
            isFirstCrumb ? undefined : $2ca273c0a0ee4278$var$breadCrumbSeparator
        ]
    }, linkComponent), child);
};
var $2ca273c0a0ee4278$export$2e2bcd8739ae039 = $2ca273c0a0ee4278$var$BreadCrumbDumb;
const $2ca273c0a0ee4278$var$breadCrumbContainer = (0, $kig2V.xcss)({
    display: 'flex',
    listStyle: 'none',
    alignItems: 'center',
    margin: 'space.0'
});
const $2ca273c0a0ee4278$var$breadCrumbSeparator = (0, $kig2V.xcss)({
    '::before': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: 'space.0',
        paddingInline: 'space.075',
        textAlign: 'center',
        lineHeight: '1.5em',
        color: 'color.text'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2ca273c0a0ee4278$var$RootLink = /*#__PURE__*/ (0, $luz1X.default)((0, $fRgxR.default)).withConfig({
    componentId: "sc-1t2enhc-0"
})`${$imLe4.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2ca273c0a0ee4278$var$RootLinkWithToken = /*#__PURE__*/ (0, $luz1X.default)((0, $fRgxR.default)).withConfig({
    componentId: "sc-1t2enhc-1"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2ca273c0a0ee4278$var$ExternalLink = /*#__PURE__*/ (0, $luz1X.default)((0, $lq3BZ.default)).withConfig({
    componentId: "sc-1t2enhc-2"
})`${$imLe4.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2ca273c0a0ee4278$var$ExternalLinkWithToken = /*#__PURE__*/ (0, $luz1X.default)((0, $lq3BZ.default)).withConfig({
    componentId: "sc-1t2enhc-3"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $2ca273c0a0ee4278$var$RootLinkDisabledTheme = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-1t2enhc-4"
})`margin:0;color:unset !important;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $2ca273c0a0ee4278$var$ExternalLinkDisabledTheme = /*#__PURE__*/ (0, $luz1X.default)((0, $g9mbo.HtmlAnchor)).withConfig({
    componentId: "sc-1t2enhc-5"
})`margin:0;color:unset !important;`;

});
parcelRegister("lq3BZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2c24a96d651f240$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $g9mbo = parcelRequire("g9mbo");
const $b2c24a96d651f240$export$1d567c320f4763bc = /*#__PURE__*/ (0, $luz1X.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b2c24a96d651f240$var$ExternalThemedLink = /*#__PURE__*/ (0, $luz1X.default)((0, $g9mbo.HtmlAnchor)).withConfig({
    componentId: "sc-ckmeb1-0"
})`${$b2c24a96d651f240$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$b2c24a96d651f240$export$2e2bcd8739ae039 = $b2c24a96d651f240$var$ExternalThemedLink;

});


parcelRegister("ddnRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $70bc59498fd8bd73$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $j5N6B = parcelRequire("j5N6B");

var $4dCfH = parcelRequire("4dCfH");

var $9JZL9 = parcelRequire("9JZL9");

var $dRkX9 = parcelRequire("dRkX9");

var $hDt7O = parcelRequire("hDt7O");

var $iWf0K = parcelRequire("iWf0K");

var $bRs76 = parcelRequire("bRs76");

var $iDjp8 = parcelRequire("iDjp8");

var $6XODz = parcelRequire("6XODz");

var $5njQB = parcelRequire("5njQB");
const $70bc59498fd8bd73$var$defaultMaxItems = 8;
const $70bc59498fd8bd73$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $70bc59498fd8bd73$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $70bc59498fd8bd73$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children;
const $70bc59498fd8bd73$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: undefined,
    packageVersion: undefined
};
const $70bc59498fd8bd73$var$noop = (0, $9JZL9.default);
const $70bc59498fd8bd73$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $70bc59498fd8bd73$var$breadcrumbStylesOld = null;
const $70bc59498fd8bd73$var$breadcrumbStylesNew = null;
const $70bc59498fd8bd73$var$navStylesNew = null;
const $70bc59498fd8bd73$var$ellipsisItemWrapperStyles = null;
// items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $70bc59498fd8bd73$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $70bc59498fd8bd73$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $hDt7O.default);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $70bc59498fd8bd73$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    if ((0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $3LM7S.jsx)($70bc59498fd8bd73$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($70bc59498fd8bd73$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $70bc59498fd8bd73$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $70bc59498fd8bd73$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $70bc59498fd8bd73$var$noop, analyticsContext: analyticsContext, label: label = $70bc59498fd8bd73$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $70bc59498fd8bd73$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $fc4bM.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $fc4bM.useState)(false);
    const wrapperRef = (0, $fc4bM.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $70bc59498fd8bd73$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $fc4bM.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($70bc59498fd8bd73$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $6XODz.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) {
                var _getDocument;
                setExpansionTrigger(event.target === ((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement));
            }
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$70bc59498fd8bd73$var$analyticsAttributes
    });
    const childrenArray = $70bc59498fd8bd73$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iWf0K.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bRs76.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("nav", {
            "aria-label": label,
            ref: (0, $4dCfH.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("ol", {
                "data-testid": testId,
                className: (0, $2R2iS.default)([
                    "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
                ]),
                children: breadcrumbsItems
            })
        })
    });
});
const $70bc59498fd8bd73$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $70bc59498fd8bd73$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $70bc59498fd8bd73$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $5njQB.default)(itemCount);
    const handleOverflowExpansion = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: $70bc59498fd8bd73$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$70bc59498fd8bd73$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$70bc59498fd8bd73$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child, index)=>{
        const isCollapsed = collapsedIndices.has(index);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $3LM7S.jsx)("li", {
                    className: (0, $2R2iS.default)([
                        "_1e0c1txw _vchhusvi _4cvr1h6o _2lx2vrvc _1o9zidpf _1wpz1h6o _1pfhze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1h6o _14rn1rpy _aetr1n76 _8yoa1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iDjp8.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($70bc59498fd8bd73$var$cloneBreadcrumbChild(child, index, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child, index)=>$70bc59498fd8bd73$var$cloneBreadcrumbChild(child, index, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bRs76.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: (0, $2R2iS.default)([
                "_1reo15vq _18m915vq _1mour5cr _195gr5cr _1rjc1b66 _18zr1b66 _1ul9idpf"
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("ol", {
                "data-testid": testId,
                ref: registerContainer,
                className: (0, $2R2iS.default)([
                    "_1e0c1txw _1ul9idpf _4cvr1h6o _1n261q9c _2mzuglyw _6rthidpf _1pfhidpf _12l2idpf _ahbqidpf _85i5idpf _1q51idpf _y4tiidpf _bozgidpf"
                ]),
                children: naturalWidthsReady ? renderedItems : measureItems
            })
        })
    });
});
const $70bc59498fd8bd73$var$Breadcrumbs = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $3LM7S.jsx)($70bc59498fd8bd73$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    })));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70bc59498fd8bd73$export$2e2bcd8739ae039 = $70bc59498fd8bd73$var$Breadcrumbs;

});
parcelRegister("hDt7O", function(module, exports) {
$parcel$export(module.exports, "default", () => $b021585872b8c581$export$2e2bcd8739ae039);
/* breadcrumbs-current-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /* breadcrumbs-current-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7iKPB = parcelRequire("7iKPB");

var $fRCnG = parcelRequire("fRCnG");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $9JZL9 = parcelRequire("9JZL9");

var $inMs5 = parcelRequire("inMs5");

var $dRkX9 = parcelRequire("dRkX9");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $bcTS3 = parcelRequire("bcTS3");

var $l9rCJ = parcelRequire("l9rCJ");

var $lQfHe = parcelRequire("lQfHe");
const $b021585872b8c581$var$analyticsAttributes = {
    componentName: 'breadcrumbsCurrentItem',
    packageName: undefined,
    packageVersion: undefined
};
const $b021585872b8c581$var$COPY_RESET_DELAY_MS = 2000;
const $b021585872b8c581$var$ICON_WIDTH_ESTIMATE = 24;
const $b021585872b8c581$var$unboundedStyles = {
    container: "_zulp1b66 _2rko12b0 _1rjcv77o _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k8s _1ql7kb7n",
    itemWrapper: "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
    copyButtonWrapper: "_1e0c116y _tzy4idpf _gwqekb7n _1mygkb7n",
    iconWrapper: "_syaz1cv2",
    iconWrapperSmall: "_w8l57vkz _17527vkz"
};
const $b021585872b8c581$var$styles = {
    interactiveContainer: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8fhey _1e0c116y _4cvr1h6o _vchhusvi _syazi7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _9h8hi7uo",
    interactiveContainerMotion: "_v5641rrn _1hms8stv _4bfu1j28 _o7kshxmd _9oiki7uo _1ggl87vo _1nrmi7uo",
    interactiveContainerSmall: "_11c8wadc",
    interactiveContainerLegacy: "_4t3i1k8s",
    interactiveContainerWithTruncation: "_1ul9idpf _1o9zkb7n",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textSmall: "_11c8wadc _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $b021585872b8c581$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $fc4bM.memo)(({ text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $l9rCJ.useBreadcrumbsSize)() === 'small';
    const handleClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onClick ?? (0, $9JZL9.default),
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$b021585872b8c581$var$analyticsAttributes
    });
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $fc4bM.useState)(false);
    const [linkElement, setLinkElement] = (0, $fc4bM.useState)(null);
    const resetTimerRef = (0, $fc4bM.useRef)(null);
    const setLinkRef = (0, $fc4bM.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $lQfHe.default)(truncationWidth, linkElement, (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $b021585872b8c581$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $fc4bM.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink === null || onCopyLink === void 0 || onCopyLink();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $b021585872b8c581$var$COPY_RESET_DELAY_MS);
        }, (0, $9JZL9.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $fc4bM.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $2R2iS.default)([
            $b021585872b8c581$var$styles.iconWrapper,
            $b021585872b8c581$var$unboundedStyles.iconWrapper,
            (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $b021585872b8c581$var$styles.iconWrapperExternal,
            isSmall && $b021585872b8c581$var$styles.iconWrapperExternalSmall,
            isSmall && $b021585872b8c581$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const textElement = /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            isSmall && $b021585872b8c581$var$styles.textSmall,
            !isSmall && $b021585872b8c581$var$styles.text,
            truncationWidth && $b021585872b8c581$var$styles.textWithTruncation
        ]),
        children: text
    });
    const renderLink = (triggerProps)=>{
        const tooltipRef = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref;
        const handleTriggerClick = (event)=>{
            var _triggerProps$onClick;
            triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            handleClick(event);
        };
        return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5Ny1Q.Anchor), {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
            "aria-current": "page",
            onClick: handleTriggerClick,
            onMouseOver: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver,
            onMouseOut: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut,
            onMouseMove: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove,
            onMouseDown: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown,
            onFocus: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus,
            onBlur: triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur,
            "aria-describedby": triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby'],
            testId: testId,
            ref: tooltipRef ? (0, $4dCfH.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
            (0, $4Cnkn.cx)($b021585872b8c581$var$styles.interactiveContainer, !(0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $b021585872b8c581$var$styles.interactiveContainerLegacy, isSmall && $b021585872b8c581$var$styles.interactiveContainerSmall, truncationWidth != null && $b021585872b8c581$var$styles.interactiveContainerWithTruncation, $b021585872b8c581$var$styles.interactiveContainerMotion),
            style: {
                maxWidth: truncationWidth
            },
            children: [
                !(0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                textElement
            ]
        });
    };
    const copyButton = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom",
        hasNewContentOnTriggerClick: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $2R2iS.default)([
                    $b021585872b8c581$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($inMs5))),
                    isTooltipDisabled: true,
                    label: copied ? 'Link copied' : 'Copy link',
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $2R2iS.default)([
            $b021585872b8c581$var$unboundedStyles.itemWrapper
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("span", {
            className: (0, $2R2iS.default)([
                $b021585872b8c581$var$unboundedStyles.container
            ]),
            children: [
                (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                shouldShowTooltip ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
                    content: text,
                    position: "bottom",
                    onShow: onTooltipShown,
                    children: renderLink
                }) : renderLink(),
                copyButton
            ]
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b021585872b8c581$export$2e2bcd8739ae039 = $b021585872b8c581$var$BreadcrumbsCurrentItem;

});
parcelRegister("inMs5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2795fc1ebee30d2a3977d5783012a5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d61ff5874d1a6e0e$var$_react = $d61ff5874d1a6e0e$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d61ff5874d1a6e0e$var$_iconNew = $d61ff5874d1a6e0e$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d61ff5874d1a6e0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link
 * Usage guidance:
 * Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d61ff5874d1a6e0e$var$LinkIcon = (props)=>/*#__PURE__*/ $d61ff5874d1a6e0e$var$_react.default.createElement($d61ff5874d1a6e0e$var$_iconNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$d61ff5874d1a6e0e$var$LinkIcon.displayName = 'LinkIcon';
var $d61ff5874d1a6e0e$var$_default = module.exports.default = $d61ff5874d1a6e0e$var$LinkIcon;

});

parcelRegister("l9rCJ", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbsSize", () => $b6dd70ff8d7ad5a6$export$c60a2bbc99661fa2);

var $fc4bM = parcelRequire("fc4bM");

var $dEzue = parcelRequire("dEzue");
function $b6dd70ff8d7ad5a6$export$c60a2bbc99661fa2() {
    return (0, $fc4bM.useContext)((0, $dEzue.default));
}

});
parcelRegister("dEzue", function(module, exports) {
$parcel$export(module.exports, "default", () => $df0441fe523ad6fb$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $df0441fe523ad6fb$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $fc4bM.createContext)('medium');
var $df0441fe523ad6fb$export$2e2bcd8739ae039 = $df0441fe523ad6fb$var$BreadcrumbsSizeContext;

});


parcelRegister("lQfHe", function(module, exports) {
$parcel$export(module.exports, "default", () => $5329028907cd3de1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $5329028907cd3de1$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $fc4bM.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $fc4bM.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $fc4bM.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("iWf0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $778462598bc17a37$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ellipsis-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4Cnkn = parcelRequire("4Cnkn");

var $9JZL9 = parcelRequire("9JZL9");

var $EawnW = parcelRequire("EawnW");

var $l9rCJ = parcelRequire("l9rCJ");
const $778462598bc17a37$var$noop = (0, $9JZL9.default);
const $778462598bc17a37$var$itemWrapperStyles = null;
const $778462598bc17a37$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1wpz1h6o _1pfhze3t _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    interactiveMotion: "_v564hxmd _1hms8stv _4bfu1j28 _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo"
};
const $778462598bc17a37$var$EllipsisItem = /*#__PURE__*/ (0, $fc4bM.memo)(({ label: label, onClick: onClick = $778462598bc17a37$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $l9rCJ.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ (0, $3LM7S.jsx)("li", {
        className: (0, $2R2iS.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
            "aria-label": label,
            onClick: onClick,
            xcss: (0, $4Cnkn.cx)($778462598bc17a37$var$styles.root, isSmall && $778462598bc17a37$var$styles.rootSmall, $778462598bc17a37$var$styles.interactiveMotion),
            testId: testId,
            children: "\u2026"
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$778462598bc17a37$export$2e2bcd8739ae039 = $778462598bc17a37$var$EllipsisItem;

});

parcelRegister("bRs76", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbsSizeProvider", () => $8b6dada966e9aeff$export$2295e777093f3940);

var $dEzue = parcelRequire("dEzue");
const $8b6dada966e9aeff$export$2295e777093f3940 = (0, $dEzue.default).Provider;

});

parcelRegister("iDjp8", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf65520aac2d4c26$export$2e2bcd8739ae039);
/* ellipsis-popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fRCnG = parcelRequire("fRCnG");

var $2Vha5 = parcelRequire("2Vha5");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $gcxcG = parcelRequire("gcxcG");
const $cf65520aac2d4c26$var$groupWrapperStyles = null;
function $cf65520aac2d4c26$export$2e2bcd8739ae039({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Vha5.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                var _triggerProps$onClick;
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                onClick === null || onClick === void 0 || onClick(event);
            };
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gcxcG))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                "_p12f1y37"
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bZYjs.default), {
                children: collapsedItems.map((item, i)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7A0bt.default), {
                        href: item.href,
                        target: item.target,
                        onClick: item.onClick,
                        children: item.text
                    }, i))
            })
        })
    });
}

});
parcelRegister("2Vha5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc80b41fa605f770$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $5dzEI = parcelRequire("5dzEI");

var $d5gKU = parcelRequire("d5gKU");

var $4dCfH = parcelRequire("4dCfH");

var $9JZL9 = parcelRequire("9JZL9");

var $ibiss = parcelRequire("ibiss");

var $i6FRY = parcelRequire("i6FRY");

var $13zmE = parcelRequire("13zmE");

var $8cuhG = parcelRequire("8cuhG");

var $dRkX9 = parcelRequire("dRkX9");

var $4EPUx = parcelRequire("4EPUx");

var $2SWSA = parcelRequire("2SWSA");

var $1Qvsi = parcelRequire("1Qvsi");

var $20CXo = parcelRequire("20CXo");

var $4YYCt = parcelRequire("4YYCt");

var $6STSR = parcelRequire("6STSR");

var $f7Sbe = parcelRequire("f7Sbe");

var $ehNKJ = parcelRequire("ehNKJ");
const $bc80b41fa605f770$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $bc80b41fa605f770$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $bc80b41fa605f770$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$bc80b41fa605f770$var$opposites[crossAxis]}`,
            `${$bc80b41fa605f770$var$opposites[mainAxis]}-${crossAxis}`,
            `${$bc80b41fa605f770$var$opposites[mainAxis]}`,
            `${$bc80b41fa605f770$var$opposites[mainAxis]}-${$bc80b41fa605f770$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$bc80b41fa605f770$var$opposites[mainAxis]}`,
        `${$bc80b41fa605f770$var$opposites[mainAxis]}-start`,
        `${$bc80b41fa605f770$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $bc80b41fa605f770$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $bc80b41fa605f770$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $9JZL9.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $2SWSA.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $ibiss.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $fc4bM.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $fc4bM.useState)(false);
    const id = (0, $ehNKJ.default)();
    const itemRef = (0, $f7Sbe.default)();
    const { currentLevel: currentLevel } = (0, $8cuhG.useLayering)();
    const fallbackPlacements = (0, $fc4bM.useMemo)(()=>$bc80b41fa605f770$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $fc4bM.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $fc4bM.useCallback)((event, currentLevel)=>{
        var _event$target$closest, _event$target;
        const isTabLeftOrEscapeKey = $bc80b41fa605f770$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $d5gKU.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $bc80b41fa605f770$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $d5gKU.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, `[id^=${(0, $ehNKJ.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $ehNKJ.PREFIX)}] [aria-haspopup="true"]`)) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($bc80b41fa605f770$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $d5gKU.KEY_LEFT))) requestAnimationFrame(()=>{
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $i6FRY.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $fc4bM.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $9JZL9.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $9JZL9.default;
        return (0, $6Zi52.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $ehNKJ.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $ehNKJ.PREFIX)}] [aria-haspopup="true"]`);
                if (e.key === (0, $d5gKU.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $d5gKU.KEY_SPACE) || e.key === (0, $d5gKU.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $d5gKU.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6STSR.default), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4EPUx.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $4dCfH.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                    ...bindFocus,
                    ref: (0, $4dCfH.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            // Legacy only. Run time passes the setter for every role; the types hide it.
            // The cast goes at the flag cleanup.
            content: (contentProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $20CXo.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4YYCt.default), {
                        spacing: spacing,
                        maxHeight: $bc80b41fa605f770$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: contentProps.update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? contentProps.setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $bc80b41fa605f770$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpen, onOpenChange: onOpenChange = (0, $9JZL9.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $dRkX9.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1Qvsi.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $3LM7S.jsx)($bc80b41fa605f770$var$DropdownMenuLegacy, {
        ...props
    });
};
var $bc80b41fa605f770$export$2e2bcd8739ae039 = $bc80b41fa605f770$var$DropdownMenu;

});
parcelRegister("ibiss", function(module, exports) {
$parcel$export(module.exports, "default", () => $5977f7cb307c5c1d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $5977f7cb307c5c1d$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $fc4bM.useState)(getDefaultPropValue);
    const isControlledRef = (0, $fc4bM.useRef)(isControlled);
    (0, $fc4bM.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $fc4bM.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("i6FRY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b25f5feee32214bd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $b25f5feee32214bd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $fc4bM.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $fc4bM.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("1Qvsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c87bc244b6b4fdd$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $6Zi52 = parcelRequire("6Zi52");

var $5dzEI = parcelRequire("5dzEI");

var $d5gKU = parcelRequire("d5gKU");

var $9JZL9 = parcelRequire("9JZL9");

var $ibiss = parcelRequire("ibiss");

var $i6FRY = parcelRequire("i6FRY");

var $13zmE = parcelRequire("13zmE");

var $gSOfb = parcelRequire("gSOfb");

var $hculA = parcelRequire("hculA");

var $hjRaA = parcelRequire("hjRaA");

var $1NuuZ = parcelRequire("1NuuZ");

var $j5ggC = parcelRequire("j5ggC");

var $28XcR = parcelRequire("28XcR");

var $GyLDf = parcelRequire("GyLDf");

var $lz1tR = parcelRequire("lz1tR");

var $fxkzW = parcelRequire("fxkzW");

var $i3E5d = parcelRequire("i3E5d");

var $6STSR = parcelRequire("6STSR");
const $7c87bc244b6b4fdd$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $7c87bc244b6b4fdd$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
function $7c87bc244b6b4fdd$var$getRootMenuPopover({ menu: menu }) {
    var _menu$parentElement;
    const parentMenu = (_menu$parentElement = menu.parentElement) === null || _menu$parentElement === void 0 ? void 0 : _menu$parentElement.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $7c87bc244b6b4fdd$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $7c87bc244b6b4fdd$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        role: "menuitem",
        className: (0, $2R2iS.default)([
            $7c87bc244b6b4fdd$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $7c87bc244b6b4fdd$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $9JZL9.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $ibiss.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $fc4bM.useRef)(null);
    const popoverRef = (0, $fc4bM.useRef)(null);
    const setPopoverRef = (0, $fc4bM.useCallback)((element)=>{
        popoverRef.current = element;
        // Leave untouched menus without a busy state; retain false once it has been set.
        if (isLoading !== undefined || element !== null && element !== void 0 && element.hasAttribute('aria-busy')) element === null || element === void 0 || element.setAttribute('aria-busy', String(Boolean(isLoading)));
    }, [
        isLoading
    ]);
    const popoverId = (0, $i3E5d.usePopoverId)();
    const topLayerPlacement = (0, $fc4bM.useMemo)(()=>(0, $j5ggC.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $lz1tR.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $fc4bM.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    const handleTriggerClicked = (0, $fc4bM.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $i6FRY.default)();
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $fc4bM.useEffect)(()=>{
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]'));
        return (0, $6Zi52.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $d5gKU.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $fc4bM.useCallback)(({ trigger: trigger })=>{
        if (!trigger.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger.click();
    }, []);
    const handleTabClose = (0, $fc4bM.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $7c87bc244b6b4fdd$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $fxkzW.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $1NuuZ.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $fc4bM.useCallback)((e)=>{
        var _e$target$closest, _e$target;
        if (!(e.target instanceof Element)) return;
        const menuItem = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $hjRaA.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ const setTriggerRef = (0, $fc4bM.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...ariaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...ariaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6STSR.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $GyLDf.Popover), {
                ref: setPopoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $28XcR.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gSOfb.default), {
                        maxHeight: $7c87bc244b6b4fdd$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $3LM7S.jsx)($7c87bc244b6b4fdd$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
var $7c87bc244b6b4fdd$export$2e2bcd8739ae039 = $7c87bc244b6b4fdd$var$DropdownMenuTopLayer;

});
parcelRegister("1NuuZ", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $23bdbe0d23ec75f7$export$f1bba0ef464d60af);
const $23bdbe0d23ec75f7$var$menuSelector = '[role="menu"]';
/**
 * Walks up from `element` and returns `true` when it reaches `container` before any other
 * `role="menu"` element.
 */ function $23bdbe0d23ec75f7$var$reachesContainerWithoutNestedMenu({ element: element, container: container }) {
    if (!element) return false;
    if (element === container) return true;
    if (element.getAttribute('role') === 'menu') return false;
    return $23bdbe0d23ec75f7$var$reachesContainerWithoutNestedMenu({
        element: element.parentElement,
        container: container
    });
}
function $23bdbe0d23ec75f7$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($23bdbe0d23ec75f7$var$menuSelector);
    // Pattern 1: the element belongs to this level if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Pattern 2: the container is a wrapper without `role="menu"`. An element in no menu belongs to
    // this level.
    if (closestMenu === null) return true;
    // Start from the parent, so the walk does not stop at `closestMenu` itself.
    return $23bdbe0d23ec75f7$var$reachesContainerWithoutNestedMenu({
        element: closestMenu.parentElement,
        container: container
    });
}

});

parcelRegister("fxkzW", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $ec0bcebeb3d7bb37$export$23dfbae28e0cc453);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $d5gKU = parcelRequire("d5gKU");

var $1jBJ5 = parcelRequire("1jBJ5");

var $6nKyR = parcelRequire("6nKyR");

var $ac55F = parcelRequire("ac55F");
const $ec0bcebeb3d7bb37$var$menuSelector = '[role="menu"]';
/**
 * Whether the focused element belongs to this menu level, so the hook acts on the key. A nested
 * menu handles its own keys.
 */ function $ec0bcebeb3d7bb37$var$isFocusedElementAtThisLevel({ focusedElement: focusedElement, container: container, filter: filter }) {
    if (!(focusedElement instanceof HTMLElement)) return true;
    if (filter) return filter(focusedElement, container);
    if (container.getAttribute('role') !== 'menu') return true;
    return focusedElement.closest($ec0bcebeb3d7bb37$var$menuSelector) === container;
}
function $ec0bcebeb3d7bb37$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $fc4bM.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        const focusedElement = container.ownerDocument.activeElement;
        if (!$ec0bcebeb3d7bb37$var$isFocusedElementAtThisLevel({
            focusedElement: focusedElement,
            container: container,
            filter: filter
        })) return;
        if (event.key === (0, $d5gKU.KEY_DOWN)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $ac55F.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $d5gKU.KEY_UP)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $ac55F.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $d5gKU.KEY_HOME)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $1jBJ5.getFirstFocusable)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $d5gKU.KEY_END)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $6nKyR.getLastFocusable)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $d5gKU.KEY_TAB)) {
            onClose();
            return;
        }
        // Nested menus (WAI-ARIA menu pattern): ArrowRight on an item with `aria-haspopup` opens
        // its submenu.
        if (event.key === (0, $d5gKU.KEY_RIGHT)) {
            if (onNestedOpen && focusedElement instanceof HTMLElement && focusedElement.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focusedElement
                });
            }
            return;
        }
        // ArrowLeft closes this menu only if it is a submenu.
        if (event.key === (0, $d5gKU.KEY_LEFT)) {
            if (onNestedClose) {
                var _container$parentElem;
                // Start from the parent, so `closest()` does not match the container itself.
                const isNested = Boolean((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($ec0bcebeb3d7bb37$var$menuSelector));
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $6Zi52.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("6STSR", function(module, exports) {
$parcel$export(module.exports, "default", () => $5390c225599d9007$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7WsKS = parcelRequire("7WsKS");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $5390c225599d9007$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $fc4bM.useRef)({});
    const context = (0, $fc4bM.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7WsKS.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $5390c225599d9007$export$2e2bcd8739ae039 = $5390c225599d9007$var$SelectionStore;

});
parcelRegister("7WsKS", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $824ab881c87bb27a$export$756f795847463ebd);

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");
const $824ab881c87bb27a$export$756f795847463ebd = /*#__PURE__*/ (0, $fc4bM.createContext)({
    setItemState: (0, $9JZL9.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $9JZL9.default),
    getGroupState: ()=>({})
});

});



parcelRegister("20CXo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7a0b1138e18eb2d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $8cuhG = parcelRequire("8cuhG");

var $bkPe8 = parcelRequire("bkPe8");

var $iaUOx = parcelRequire("iaUOx");
/**
 * Focus manager logic.
 */ const $b7a0b1138e18eb2d$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $fc4bM.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $fc4bM.useState)(0);
    const registerMode = (0, $fc4bM.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $fc4bM.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $8cuhG.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $fc4bM.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $fc4bM.useEffect)(()=>(0, $6Zi52.bind)(window, {
            type: 'keydown',
            listener: (0, $bkPe8.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iaUOx.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $b7a0b1138e18eb2d$export$2e2bcd8739ae039 = $b7a0b1138e18eb2d$var$FocusManager;

});
parcelRegister("bkPe8", function(module, exports) {
$parcel$export(module.exports, "default", () => $27be08e872ffab30$export$2e2bcd8739ae039);

var $d5gKU = parcelRequire("d5gKU");

var $dRkX9 = parcelRequire("dRkX9");

var $ehNKJ = parcelRequire("ehNKJ");
const $27be08e872ffab30$var$actionMap = {
    [(0, $d5gKU.KEY_DOWN)]: 'next',
    [(0, $d5gKU.KEY_UP)]: 'prev',
    [(0, $d5gKU.KEY_HOME)]: 'first',
    [(0, $d5gKU.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $27be08e872ffab30$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $27be08e872ffab30$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $27be08e872ffab30$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>{
            var _document$activeEleme;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $dRkX9.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest(`[id^=${(0, $ehNKJ.PREFIX)}]`));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $d5gKU.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $d5gKU.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $d5gKU.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $d5gKU.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $27be08e872ffab30$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $27be08e872ffab30$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $27be08e872ffab30$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $27be08e872ffab30$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $27be08e872ffab30$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("ehNKJ", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $b97ccb82ef74ba2d$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $b97ccb82ef74ba2d$export$2e2bcd8739ae039);

var $3zBNx = parcelRequire("3zBNx");
const $b97ccb82ef74ba2d$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $b97ccb82ef74ba2d$export$2e2bcd8739ae039() {
    const id = (0, $3zBNx.useId)();
    return `${$b97ccb82ef74ba2d$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("iaUOx", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $3541e50c484d2bee$export$f18c1d4fc7326096);

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");
const $3541e50c484d2bee$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    menuItemRefs: [],
    registerRef: (0, $9JZL9.default)
});

});


parcelRegister("4YYCt", function(module, exports) {
$parcel$export(module.exports, "default", () => $445c531d170eef69$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gSOfb = parcelRequire("gSOfb");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $hculA = parcelRequire("hculA");

var $jFkap = parcelRequire("jFkap");

var $3OMnH = parcelRequire("3OMnH");

var $iaUOx = parcelRequire("iaUOx");
const $445c531d170eef69$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $445c531d170eef69$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $445c531d170eef69$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $445c531d170eef69$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $fc4bM.useContext)((0, $iaUOx.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $jFkap.default)(menuItem) || (0, $3OMnH.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $fc4bM.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $dRkX9.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gSOfb.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $3LM7S.jsx)($445c531d170eef69$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $445c531d170eef69$export$2e2bcd8739ae039 = $445c531d170eef69$var$MenuWrapper;

});
parcelRegister("jFkap", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eca9530a034884c$export$2e2bcd8739ae039);
function $7eca9530a034884c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("3OMnH", function(module, exports) {
$parcel$export(module.exports, "default", () => $093e6cabd06944bb$export$2e2bcd8739ae039);
function $093e6cabd06944bb$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("f7Sbe", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aa4d86f21a583a2$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $iaUOx = parcelRequire("iaUOx");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $3aa4d86f21a583a2$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $fc4bM.useContext)((0, $iaUOx.FocusManagerContext));
    const itemRef = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (hasPopup && (0, $dRkX9.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $3aa4d86f21a583a2$export$2e2bcd8739ae039 = $3aa4d86f21a583a2$var$useRegisterItemWithFocusManager;

});


parcelRegister("7A0bt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8057c4d6a8e39c19$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4dCfH = parcelRequire("4dCfH");

var $eaozo = parcelRequire("eaozo");

var $bKfoa = parcelRequire("bKfoa");

var $9v7Ro = parcelRequire("9v7Ro");

var $dRkX9 = parcelRequire("dRkX9");

var $f7Sbe = parcelRequire("f7Sbe");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $8057c4d6a8e39c19$var$DropdownMenuItem = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog';
    const itemRef = (0, $f7Sbe.default)(isNestedTrigger);
    const handleItemClick = (0, $fc4bM.useCallback)((event)=>{
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bKfoa.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $4dCfH.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9v7Ro.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $4dCfH.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eaozo.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $4dCfH.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $dRkX9.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $8057c4d6a8e39c19$export$2e2bcd8739ae039 = $8057c4d6a8e39c19$var$DropdownMenuItem;

});

parcelRegister("bZYjs", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc1290d44de77c6$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3zBNx = parcelRequire("3zBNx");

var $3rlj9 = parcelRequire("3rlj9");

var $3xqIO = parcelRequire("3xqIO");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $6bc1290d44de77c6$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $3zBNx.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3rlj9.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3xqIO.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $6bc1290d44de77c6$export$2e2bcd8739ae039 = $6bc1290d44de77c6$var$DropdownMenuItemGroup;

});
parcelRegister("3xqIO", function(module, exports) {
$parcel$export(module.exports, "default", () => $092f3214c6ab8a13$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $092f3214c6ab8a13$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $092f3214c6ab8a13$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $092f3214c6ab8a13$var$styles.heading,
        children: title
    });
var $092f3214c6ab8a13$export$2e2bcd8739ae039 = $092f3214c6ab8a13$var$GroupTitle;

});


parcelRegister("gcxcG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb9e6baa42be79f49a55523cb2c1b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcb785de7db9c938$var$_react = $bcb785de7db9c938$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $bcb785de7db9c938$var$_iconNew = $bcb785de7db9c938$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $bcb785de7db9c938$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bcb785de7db9c938$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $bcb785de7db9c938$var$_react.default.createElement($bcb785de7db9c938$var$_iconNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$bcb785de7db9c938$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $bcb785de7db9c938$var$_default = module.exports.default = $bcb785de7db9c938$var$ShowMoreHorizontalIcon;

});


parcelRegister("6XODz", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", () => $c4dbaf7021708226$export$e9c4922b2ecf808a);

var $fc4bM = parcelRequire("fc4bM");

var $ijhy8 = parcelRequire("ijhy8");
function $c4dbaf7021708226$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $ijhy8.default)(isExpanded);
    (0, $fc4bM.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});

parcelRegister("5njQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e18368071e14957$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $7e18368071e14957$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $7e18368071e14957$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
function $7e18368071e14957$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $7e18368071e14957$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $7e18368071e14957$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $fc4bM.useRef)([]);
    const containerRef = (0, $fc4bM.useRef)(null);
    const naturalWidths = (0, $fc4bM.useRef)([]);
    const naturalWidthsReady = (0, $fc4bM.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $fc4bM.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $fc4bM.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $7e18368071e14957$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>(el === null || el === void 0 ? void 0 : el.offsetWidth) ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $fc4bM.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $7e18368071e14957$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $7e18368071e14957$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$7e18368071e14957$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $fc4bM.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $fc4bM.useRef)(null);
    const registerContainer = (0, $fc4bM.useCallback)((el)=>{
        var _observerRef$current;
        // Disconnect any existing observer
        (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            var _observerRef$current2;
            (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 || _observerRef$current2.disconnect();
        };
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});


parcelRegister("1erEI", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaeb5b01bc2179e2$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $eaeb5b01bc2179e2$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    breadcrumbsLabel: {
        id: 'cv.portal.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'The accessible label for the breadcrumb navigation container shown at the top of the portal page.'
    },
    raiseRequestBreadcrumb: {
        defaultMessage: 'Raise a request',
        description: 'Breadcrumb item to go to select a request group of a portal',
        id: 'cv.portal.breadcrumbs.raise.request'
    },
    breadcrumbsHome: {
        defaultMessage: 'Home',
        description: 'Generic label for the first entry of the breadcrumbs for Service hub',
        id: 'cv.portal.breadcrumbs.home'
    }
});

});





parcelRegister("f2SdC", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbs", () => (parcelRequire("gtyP1")).CsmBreadcrumbs);
parcelRequire("iOrCT");
var $ctcIv = parcelRequire("ctcIv");

var $gtyP1 = parcelRequire("gtyP1");

});
parcelRegister("iOrCT", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbsInner", () => (parcelRequire("ctcIv")).CsmBreadcrumbsInner);

var $ctcIv = parcelRequire("ctcIv");

});
parcelRegister("ctcIv", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbsInner", () => $6ac96f6a02789b7d$export$139cc1264c7dcd05);

var $3MhiW = parcelRequire("3MhiW");

var $fc4bM = parcelRequire("fc4bM");

var $7ZXzW = parcelRequire("7ZXzW");

var $6LH8a = parcelRequire("6LH8a");

var $ddnRa = parcelRequire("ddnRa");

var $8p5Cv = parcelRequire("8p5Cv");
var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
const $6ac96f6a02789b7d$var$breadcrumbsLabel = (0, $8p5Cv.defineMessage)({
    defaultMessage: 'Breadcrumbs',
    id: 'help-center.csm-breadcrumbs.breadcrumbs-label',
    description: 'Aria label for the CSM breadcrumb navigation'
});
const $6ac96f6a02789b7d$var$breadcrumbsHome = (0, $8p5Cv.defineMessage)({
    defaultMessage: 'Home',
    id: 'help-center.csm-breadcrumbs.breadcrumbs-home',
    description: 'Home breadcrumb label for the CSM breadcrumb navigation'
});
const $6ac96f6a02789b7d$export$139cc1264c7dcd05 = ({ articleId: articleId, articleTitle: articleTitle, homeUrl: homeUrl = '/' })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $3MhiW.default), {
        articleId: articleId,
        cloudId: (0, $6LH8a.getCloudId)(),
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)()
    });
    const ancestors = ((_data$helpObjectStore = data.helpObjectStore_searchArticlesForSupportSite) === null || _data$helpObjectStore === void 0 || (_data$helpObjectStore = _data$helpObjectStore.nodes) === null || _data$helpObjectStore === void 0 || (_data$helpObjectStore = _data$helpObjectStore[0]) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.ancestors) ?? [];
    // Skip the first ancestor (index 0) — it is a top-level category/space root not relevant to the page trail
    const pageAncestors = ancestors.filter((_, index)=>index !== 0);
    const currentArticleCrumb = /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        to: `/article/${articleId}`,
        name: articleTitle ?? '',
        actionSubjectId: "articleAncestorCurrentArticleBreadcrumb"
    });
    const ancestorChain = pageAncestors.reduceRight((innerChild, ancestor)=>/*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
            key: ancestor.id,
            to: ancestor.type === 'PAGE' ? `/article/${ancestor.id}` : `/folder/${ancestor.id}`,
            name: ancestor.title ?? '',
            actionSubjectId: `articleAncestorBreadcrumb-${ancestor.id}`
        }, innerChild), currentArticleCrumb);
    return /*#__PURE__*/ $fc4bM.createElement((0, $ddnRa.default), {
        label: formatMessage($6ac96f6a02789b7d$var$breadcrumbsLabel)
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7ZXzW.default), {
        to: homeUrl,
        name: formatMessage($6ac96f6a02789b7d$var$breadcrumbsHome),
        isFirstCrumb: true,
        actionSubjectId: "articleAncestorHomeBreadcrumb"
    }, ancestorChain));
};
var $6ac96f6a02789b7d$export$2e2bcd8739ae039 = $6ac96f6a02789b7d$export$139cc1264c7dcd05;

});
parcelRegister("3MhiW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4aa9ac33922aec7e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae90646d5a8444c8bd4510deafb15985>>
 * @relayHash b26d74a977afd1c1cb5201fbf9d16e1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d96953a486fcf90f51cbf1e9f655d2bcde0beb3d2d3cb5f7d32043794748f110
const $4aa9ac33922aec7e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "articleId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "articleIds.0",
                            "variableName": "articleId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "articleIds"
                },
                {
                    "kind": "Literal",
                    "name": "expand",
                    "value": [
                        "ANCESTORS"
                    ]
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ ,
            {
                "concreteType": "HelpObjectStoreArticleRelative",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmBreadcrumbsInnerQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmBreadcrumbsInnerQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d96953a486fcf90f51cbf1e9f655d2bcde0beb3d2d3cb5f7d32043794748f110",
            "metadata": {},
            "name": "csmBreadcrumbsInnerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4aa9ac33922aec7e$var$node.hash = "fc0a03b251b6289b521688cdb7d387f1";
var $4aa9ac33922aec7e$export$2e2bcd8739ae039 = $4aa9ac33922aec7e$var$node;

});



parcelRegister("gtyP1", function(module, exports) {
$parcel$export(module.exports, "CsmBreadcrumbs", () => $4f1c66b3481bc59f$export$ee4634b1f7dbb2c5);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("3cm1i");
var $kftqr = parcelRequire("kftqr");
parcelRequire("iOrCT");
var $ctcIv = parcelRequire("ctcIv");
const $4f1c66b3481bc59f$var$selector = (0, $2n2bS.createSelector)((state, props)=>props.articleTitle ?? (0, $kftqr.getArticleTitle)(state, props.articleId), (articleTitle)=>({
        articleTitle: articleTitle
    }));
const $4f1c66b3481bc59f$export$ee4634b1f7dbb2c5 = (0, $6umft.default)($4f1c66b3481bc59f$var$selector)((0, $ctcIv.CsmBreadcrumbsInner));
var $4f1c66b3481bc59f$export$2e2bcd8739ae039 = $4f1c66b3481bc59f$export$ee4634b1f7dbb2c5;

});


parcelRegister("3Z9Za", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $97ad98f1acecae0f$export$8f314e512d92575f);
$parcel$export(module.exports, "SubHeadingContainer", () => $97ad98f1acecae0f$export$c8db0106bd269e8c);
$parcel$export(module.exports, "SubHeading", () => $97ad98f1acecae0f$export$210dc657affc8afd);
$parcel$export(module.exports, "Description", () => $97ad98f1acecae0f$export$393edc798c47379d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $k3ktd = parcelRequire("k3ktd");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");
const $97ad98f1acecae0f$var$ICON_SIZE_MOBILE = $fOCtI.multiple(4.5).unitless;
const $97ad98f1acecae0f$var$ICON_SIZE_DESKTOP = $fOCtI.multiple(6.25).unitless;
const $97ad98f1acecae0f$var$MARGIN_RIGHT = "var(--ds-space-200, 16px)";
const $97ad98f1acecae0f$var$SUBHEADING_MARGIN_TOP_MOBILE = "var(--ds-space-200, 16px)";
const $97ad98f1acecae0f$var$SUBHEADING_MARGIN_TOP_DESKTOP = "var(--ds-space-100, 8px)";
const $97ad98f1acecae0f$var$DESCRIPTION_MARGIN_TOP_MOBILE = "var(--ds-space-100, 8px)";
const $97ad98f1acecae0f$export$8f314e512d92575f = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-69w8vc-0"
})`${$3DjOo.flexCenter};height:${$97ad98f1acecae0f$var$ICON_SIZE_MOBILE}px;width:${$97ad98f1acecae0f$var$ICON_SIZE_MOBILE}px;margin-right:${$97ad98f1acecae0f$var$MARGIN_RIGHT};flex-shrink:0;${$k3ktd.fromXSmall.css`
        height: ${$97ad98f1acecae0f$var$ICON_SIZE_DESKTOP}px;
        width: ${$97ad98f1acecae0f$var$ICON_SIZE_DESKTOP}px;
    `};`;
const $97ad98f1acecae0f$export$c8db0106bd269e8c = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-69w8vc-1"
})`display:flex;justify-content:flex-start;align-items:center;margin-top:${$97ad98f1acecae0f$var$SUBHEADING_MARGIN_TOP_MOBILE};${$k3ktd.fromXSmall.css`
        margin-top: ${$97ad98f1acecae0f$var$SUBHEADING_MARGIN_TOP_DESKTOP};
    `};`;
const $97ad98f1acecae0f$export$210dc657affc8afd = /*#__PURE__*/ (0, $luz1X.default).h1.withConfig({
    componentId: "sc-69w8vc-2"
})`${$imLe4.h700};${$3DjOo.breakWord};margin:0;`;
const $97ad98f1acecae0f$export$393edc798c47379d = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-69w8vc-3"
})`display:block;color:${"var(--ds-text, #172B4D)"};margin-top:${$97ad98f1acecae0f$var$DESCRIPTION_MARGIN_TOP_MOBILE};width:100%;`;

});



parcelRegister("2Cw7K", function(module, exports) {
$parcel$export(module.exports, "ArticleList", () => (parcelRequire("chcrg")).default);

var $chcrg = parcelRequire("chcrg");

});
parcelRegister("chcrg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c624bc52a109c143$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fRgxR = parcelRequire("fRgxR");

var $fd880 = parcelRequire("fd880");
parcelRequire("2sJSQ");
var $ei4x6 = parcelRequire("ei4x6");
parcelRequire("e2U4l");
var $8min0 = parcelRequire("8min0");
parcelRequire("fQcId");
var $5SLMu = parcelRequire("5SLMu");

var $3TJLC = parcelRequire("3TJLC");

var $lvRbB = parcelRequire("lvRbB");
parcelRequire("aWvUw");
var $eNieK = parcelRequire("eNieK");

var $lbU7h = parcelRequire("lbU7h");
const $c624bc52a109c143$export$cf74bb99f97bf995 = (portalId, categoryId, articles, opts)=>{
    return /*#__PURE__*/ $fc4bM.createElement("section", null, opts.showHeading && /*#__PURE__*/ $fc4bM.createElement($c624bc52a109c143$export$72d7ca7a5d1d4807, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), opts.isFeatured ? (0, $lbU7h.default).featuredArticlesHeading : (0, $lbU7h.default).moreArticlesHeading)), /*#__PURE__*/ $fc4bM.createElement($c624bc52a109c143$export$9d0ad9ba52d8bb58, null, articles.map((article)=>{
        const { title: title, summaryExcerpt: summaryExcerpt, id: articleId } = article;
        return /*#__PURE__*/ $fc4bM.createElement((0, $eNieK.default), {
            portalId: portalId,
            categoryId: categoryId,
            articleId: articleId,
            key: articleId,
            title: title,
            summaryExcerpt: summaryExcerpt,
            isFeatured: opts.isFeatured
        });
    })));
};
/**
 * ArticleList comes with forced top margin because of the featured vs. non featured articles
 * groupings. Take this into consideration when using in places no under knowledge category page.
 */ const $c624bc52a109c143$var$ArticleList = ({ articles: articles, portalName: portalName, portalId: portalId, portalLink: portalLink, categoryId: categoryId, showRequestCreateButton: showRequestCreateButton, isLoading: isLoading })=>{
    const featuredArticles = articles ? articles.filter((article)=>article.isFeatured) : [];
    const regularArticles = articles ? articles.filter((article)=>!article.isFeatured) : [];
    const hasRegularArticles = regularArticles.length > 0;
    const hasFeaturedArticles = featuredArticles.length > 0;
    const hasAnyArticles = hasRegularArticles || hasFeaturedArticles;
    const containerHasExtraMargin = hasRegularArticles && hasFeaturedArticles || !hasAnyArticles;
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                numberOfArticles: articles && articles.length
            }
        }
    }, /*#__PURE__*/ $fc4bM.createElement($c624bc52a109c143$export$79927783e7566f41, {
        marginTop: containerHasExtraMargin
    }, /*#__PURE__*/ $fc4bM.createElement((0, $8min0.default), {
        isLoading: isLoading,
        loadingPosition: "fill-container"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), hasFeaturedArticles && $c624bc52a109c143$export$cf74bb99f97bf995(portalId, categoryId, featuredArticles, {
        isFeatured: true,
        showHeading: hasRegularArticles
    }), hasRegularArticles && $c624bc52a109c143$export$cf74bb99f97bf995(portalId, categoryId, regularArticles, {
        isFeatured: false,
        showHeading: hasFeaturedArticles
    }), !hasAnyArticles && /*#__PURE__*/ $fc4bM.createElement($c624bc52a109c143$export$aff2890a94825ec8, null, /*#__PURE__*/ $fc4bM.createElement($c624bc52a109c143$export$4ba49fb37bbab46d, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $lbU7h.default).articlesEmptyStateText)), /*#__PURE__*/ $fc4bM.createElement((0, $fRgxR.default), {
        to: `/portal/${portalId}`,
        actionSubjectId: "backToPortal"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $lbU7h.default).categoriesEmptyStateLink,
        values: {
            portalName: portalName
        }
    }))), showRequestCreateButton && /*#__PURE__*/ $fc4bM.createElement((0, $5SLMu.default), {
        to: portalLink
    }))));
};
var $c624bc52a109c143$export$2e2bcd8739ae039 = $c624bc52a109c143$var$ArticleList;
const $c624bc52a109c143$export$4ba49fb37bbab46d = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ejyd2g-0"
})`${$imLe4.regular};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $c624bc52a109c143$export$9d0ad9ba52d8bb58 = /*#__PURE__*/ (0, $luz1X.default).ol.withConfig({
    componentId: "sc-1ejyd2g-1"
})`margin:0 -${(0, $ei4x6.GROUP_BOX_PADDING_LEFT_RIGHT)};padding:0;`;
const $c624bc52a109c143$export$72d7ca7a5d1d4807 = /*#__PURE__*/ (0, $luz1X.default).h2.withConfig({
    componentId: "sc-1ejyd2g-2"
})`${$imLe4.h500};`;
const $c624bc52a109c143$export$79927783e7566f41 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ejyd2g-3"
})`margin-top:${(props)=>props.marginTop ? "var(--ds-space-200, 16px)" : 0};> *{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $c624bc52a109c143$export$aff2890a94825ec8 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ejyd2g-4"
})`margin-bottom:${"var(--ds-space-500, 40px)"};`;

});
parcelRegister("2sJSQ", function(module, exports) {
$parcel$export(module.exports, "GroupBox", () => (parcelRequire("23B2e")).default);
$parcel$export(module.exports, "GroupBoxLink", () => (parcelRequire("5GNfO")).default);
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => (parcelRequire("ei4x6")).GROUP_BOX_PADDING_LEFT_RIGHT);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => (parcelRequire("ei4x6")).GROUP_BOX_PADDING_TOP_BOTTOM);

var $23B2e = parcelRequire("23B2e");
parcelRequire("3bkQR");
var $5GNfO = parcelRequire("5GNfO");

var $ei4x6 = parcelRequire("ei4x6");

});
parcelRegister("23B2e", function(module, exports) {
$parcel$export(module.exports, "default", () => $46ce96c77397ebe3$export$2e2bcd8739ae039);
/* group-box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $2KIJl = parcelRequire("2KIJl");

var $1hJdJ = parcelRequire("1hJdJ");

var $ei4x6 = parcelRequire("ei4x6");
const $46ce96c77397ebe3$var$GroupBox = ({ heading: heading, description: description, icon: icon, editRequestTypeOnRequestList: editRequestTypeOnRequestList, headingAs: headingAs = 'h3', isAriaHidden: isAriaHidden = false, lineClamp: lineClamp = 0, ...props })=>{
    const showEditRequestButton = !!editRequestTypeOnRequestList;
    const ariaHidden = isAriaHidden ? undefined : true;
    const content = showEditRequestButton ? /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_kqswh2mm"
        ])
    }, heading && /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description), /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-edit-overlay": "true",
        className: (0, $2R2iS.default)([
            "_kqswstnw _1xi2ze3t _154ize3t _tzy4idpf"
        ])
    }, editRequestTypeOnRequestList)) : /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, heading && /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description));
    return /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.StyledIconCardLayout), {
        ...props,
        leftIcon: icon && /*#__PURE__*/ ($fc4bM.isValidElement(icon) ? icon : /*#__PURE__*/ $fc4bM.createElement((0, $2KIJl.default), {
            src: icon,
            alt: ""
        })),
        content: content
    });
};
const $46ce96c77397ebe3$var$GroupBoxWithAdditionalButtonLayout = null;
const $46ce96c77397ebe3$var$OverlayButtonLayout = null;
var $46ce96c77397ebe3$export$2e2bcd8739ae039 = $46ce96c77397ebe3$var$GroupBox;

});
parcelRegister("ei4x6", function(module, exports) {
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => $4ad0ee267fc983c0$export$5ff888af59e97bf4);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => $4ad0ee267fc983c0$export$2968d5852daac253);
$parcel$export(module.exports, "StyledIconCardLayout", () => $4ad0ee267fc983c0$export$66f468dd3258e073);
$parcel$export(module.exports, "HeadingContent", () => $4ad0ee267fc983c0$export$5cb6fad052f5d74e);
$parcel$export(module.exports, "Description", () => $4ad0ee267fc983c0$export$393edc798c47379d);
$parcel$export(module.exports, "StyledLink", () => $4ad0ee267fc983c0$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");

var $imLe4 = parcelRequire("imLe4");

var $3DjOo = parcelRequire("3DjOo");
parcelRequire("4VBqm");
var $6Rj0i = parcelRequire("6Rj0i");

var $k2M4v = parcelRequire("k2M4v");
const $4ad0ee267fc983c0$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $4ad0ee267fc983c0$var$isHcAdsDropCommit2Enabled = ()=>(0, $k2M4v.default).checkGate($4ad0ee267fc983c0$var$HC_ADS_DROP_COMMIT_2);
const $4ad0ee267fc983c0$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT = "var(--ds-space-200, 16px)";
const $4ad0ee267fc983c0$export$5ff888af59e97bf4 = "var(--ds-space-300, 24px)";
const $4ad0ee267fc983c0$export$2968d5852daac253 = "var(--ds-space-300, 24px)";
const $4ad0ee267fc983c0$export$66f468dd3258e073 = /*#__PURE__*/ (0, $luz1X.default)((0, $6Rj0i.default)).withConfig({
    componentId: "sc-1p6gmq3-0"
})`padding:${$4ad0ee267fc983c0$export$2968d5852daac253} ${(props)=>props.containerPadding === 'tight' ? $4ad0ee267fc983c0$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT : $4ad0ee267fc983c0$export$5ff888af59e97bf4};`;
const $4ad0ee267fc983c0$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1p6gmq3-1"
})`${$imLe4.h400};${(props)=>$3DjOo.applyIf(props.lineClamp, $3DjOo.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $4ad0ee267fc983c0$export$5cb6fad052f5d74e = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1p6gmq3-2"
})`${(props)=>$3DjOo.applyIf(props.lineClamp, $3DjOo.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $4ad0ee267fc983c0$export$393edc798c47379d = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1p6gmq3-3"
})`${(props)=>$3DjOo.applyIf(props.lineClamp > 0, /*
             We use multiline clamp so we avoid descriptions that have multi paragraphs looking like this:
             Clamped...
             Clamped...
             Clamped...
         */ $3DjOo.multiLineClamp(props.lineClamp))};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-050, 4px)"};`;
const $4ad0ee267fc983c0$export$9048d548939551ee = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-1p6gmq3-4"
})`${$3DjOo.borderRadius};${()=>$4ad0ee267fc983c0$var$isHcAdsDropCommit2Enabled() && $3DjOo.borderRadiusLarge} display:block;background-color:${(props)=>props.selected ? "var(--ds-surface-raised, #F4F5F7)" : 'inherit'};&:hover,&:focus-visible{text-decoration:none;background-color:${"var(--ds-surface-raised-hovered, #F4F5F7)"};}&:hover [data-edit-overlay]{opacity:1;}&:focus{text-decoration:none;}`;

});
parcelRegister("4VBqm", function(module, exports) {
$parcel$export(module.exports, "IconCardLayout", () => (parcelRequire("6Rj0i")).default);

var $6Rj0i = parcelRequire("6Rj0i");

});
parcelRegister("6Rj0i", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7110f2e62963536$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $aYMdQ = parcelRequire("aYMdQ");

var $k2M4v = parcelRequire("k2M4v");

var $1AiIz = parcelRequire("1AiIz");
const $e7110f2e62963536$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $e7110f2e62963536$var$DEFAULT_RESULT_PADDING = "var(--ds-space-200, 16px)";
const $e7110f2e62963536$var$DEFAULT_ICON_SIZE = "var(--ds-space-400, 32px)";
const $e7110f2e62963536$var$DEFAULT_ICON_MARGIN = "var(--ds-space-200, 16px)";
const $e7110f2e62963536$var$ICON_SIZE_TO_TILE_SIZE = {
    '20px': 'small',
    '24px': 'medium',
    '32px': 'large',
    '40px': 'xlarge',
    '48px': 'xlarge'
};
const $e7110f2e62963536$export$dbd3bc8edfb9a83d = (iconSize)=>$e7110f2e62963536$var$ICON_SIZE_TO_TILE_SIZE[iconSize] ?? 'medium';
const $e7110f2e62963536$var$getSpaceValueWithDefault = (defaultSpacing, value, customSpacing)=>{
    if (!(0, $aYMdQ.isNil)(value)) return `${value}px`;
    return customSpacing || defaultSpacing;
};
const $e7110f2e62963536$var$IconCardLayout = ({ leftIcon: leftIcon, rightIcon: rightIcon, content: content, iconSize: iconSize, iconMargin: iconMargin, padding: padding, alignItems: alignItems, className: className, centerAlignLeftIcon: centerAlignLeftIcon, centerAlignRightIcon: centerAlignRightIcon, dataTestId: dataTestId, customStyling: customStyling })=>{
    const { iconSize: customIconSize, iconMargin: customIconMargin, padding: customPadding } = customStyling || {};
    const iconSizeWithDefault = $e7110f2e62963536$var$getSpaceValueWithDefault($e7110f2e62963536$var$DEFAULT_ICON_SIZE, iconSize, customIconSize);
    const iconMarginWithDefault = $e7110f2e62963536$var$getSpaceValueWithDefault($e7110f2e62963536$var$DEFAULT_ICON_MARGIN, iconMargin, customIconMargin);
    const paddingWithDefault = $e7110f2e62963536$var$getSpaceValueWithDefault($e7110f2e62963536$var$DEFAULT_RESULT_PADDING, padding, customPadding);
    const isHcAdsDropCommit2Enabled = (0, $k2M4v.default).checkGate($e7110f2e62963536$var$HC_ADS_DROP_COMMIT_2);
    const tileSize = $e7110f2e62963536$export$dbd3bc8edfb9a83d(iconSizeWithDefault);
    const renderLeftIcon = $fc4bM.useCallback(()=>leftIcon, [
        leftIcon
    ]);
    const renderRightIcon = $fc4bM.useCallback(()=>rightIcon, [
        rightIcon
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($e7110f2e62963536$var$ResultContainer, {
        "data-test-id": dataTestId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        padding: paddingWithDefault,
        align: alignItems || 'center',
        gap: isHcAdsDropCommit2Enabled ? iconMarginWithDefault : undefined
    }, leftIcon && (isHcAdsDropCommit2Enabled ? leftIcon && /*#__PURE__*/ $fc4bM.createElement((0, $1AiIz.default), {
        size: tileSize,
        icon: renderLeftIcon,
        label: "",
        appearance: "gray"
    }) : /*#__PURE__*/ $fc4bM.createElement($e7110f2e62963536$var$IconContainer, {
        iconMargin: iconMarginWithDefault,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignLeftIcon
    }, leftIcon)), /*#__PURE__*/ $fc4bM.createElement($e7110f2e62963536$var$ResultContentContainer, null, content), rightIcon && (isHcAdsDropCommit2Enabled ? rightIcon && /*#__PURE__*/ $fc4bM.createElement((0, $1AiIz.default), {
        size: tileSize,
        icon: renderRightIcon,
        label: "",
        appearance: "gray"
    }) : /*#__PURE__*/ $fc4bM.createElement($e7110f2e62963536$var$IconContainer, {
        iconMargin: $e7110f2e62963536$var$DEFAULT_ICON_MARGIN,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignRightIcon,
        right: true
    }, rightIcon)));
};
var $e7110f2e62963536$export$2e2bcd8739ae039 = $e7110f2e62963536$var$IconCardLayout;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e7110f2e62963536$var$ResultContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-fn7rhf-0"
})`display:flex;width:100%;box-sizing:border-box;align-items:${(props)=>props.align};padding:0 ${(props)=>props.padding};${(props)=>props.gap && `gap: ${props.gap}`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e7110f2e62963536$var$IconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-fn7rhf-1"
})`display:flex;align-items:center;justify-content:center;width:${(props)=>props.iconSize};align-self:flex-start;margin-top:${"var(--ds-space-050, 4px)"};flex-shrink:0;${(props)=>props.isCenterAlignIcon && `margin: auto`};${(props)=>props.right ? `margin-left: ${props.iconMargin}` : `margin-right: ${props.iconMargin}`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e7110f2e62963536$var$ResultContentContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-fn7rhf-2"
})`width:100%;`;

});




parcelRegister("3bkQR", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("5GNfO")).default);

var $5GNfO = parcelRequire("5GNfO");

});
parcelRegister("5GNfO", function(module, exports) {
$parcel$export(module.exports, "default", () => $df4863c28d8008c8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("fQxpy");
var $1JcSo = parcelRequire("1JcSo");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $esgVk = parcelRequire("esgVk");

var $23B2e = parcelRequire("23B2e");

var $ei4x6 = parcelRequire("ei4x6");
const $df4863c28d8008c8$var$isExternalLink = (target)=>{
    return target instanceof HTMLElement && target.className.includes('external-link');
};
const $df4863c28d8008c8$var$handleExternalLink = (e)=>{
    e.preventDefault();
    (0, $esgVk.open)(e.target.toString(), '_blank');
};
const $df4863c28d8008c8$var$GroupBoxLink = ({ className: className, selected: selected, onClick: onClick, target: target, dataTestId: dataTestId, actionSubjectId: actionSubjectId, ...rest })=>{
    const [isPageInEditMode] = (0, $1JcSo.useIsPageInEditMode)();
    const tabIndex = isPageInEditMode ? -1 : undefined;
    const handleClick = $fc4bM.useCallback((e)=>{
        if (isPageInEditMode) return;
        if ($df4863c28d8008c8$var$isExternalLink(e.target)) {
            $df4863c28d8008c8$var$handleExternalLink(e);
            return;
        }
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    if ('to' in rest) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // oxlint-disable-next-line no-shadow
        const { to: to, editRequestTypeOnRequestList: editRequestTypeOnRequestList, ...forGroupBox } = rest;
        const showEditRequestTypeButton = !isPageInEditMode && !!editRequestTypeOnRequestList;
        const contentWithTo = showEditRequestTypeButton ? /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId
        }, /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), {
            ...forGroupBox,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        })) : /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId,
            tabIndex: tabIndex
        }, /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), forGroupBox));
        return isPageInEditMode ? /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
            xcss: $df4863c28d8008c8$var$disabledLink
        }, contentWithTo) : contentWithTo;
    }
    const { href: href, ...forGroupBox } = rest;
    const content = /*#__PURE__*/ $fc4bM.createElement((0, $ei4x6.StyledLink), {
        selected: !!selected,
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        onClick: handleClick,
        target: target,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        tabIndex: tabIndex
    }, /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), forGroupBox));
    return isPageInEditMode ? /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        xcss: $df4863c28d8008c8$var$disabledLink
    }, content) : content;
};
const $df4863c28d8008c8$var$disabledLink = (0, $kig2V.xcss)({
    pointerEvents: 'none'
});
var $df4863c28d8008c8$export$2e2bcd8739ae039 = $df4863c28d8008c8$var$GroupBoxLink;

});



parcelRegister("fQcId", function(module, exports) {
$parcel$export(module.exports, "RaiseRequestLink", () => (parcelRequire("5SLMu")).default);

var $5SLMu = parcelRequire("5SLMu");

});
parcelRegister("5SLMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f07ebcf39817185a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fd880 = parcelRequire("fd880");
parcelRequire("g29WC");
var $k7nnc = parcelRequire("k7nnc");
parcelRequire("2sJSQ");
var $ei4x6 = parcelRequire("ei4x6");

var $eF51U = parcelRequire("eF51U");
const $f07ebcf39817185a$var$RaiseRequestLink = ({ to: to, isEmbeddedRoute: isEmbeddedRoute, ...props })=>/*#__PURE__*/ $fc4bM.createElement((0, $k7nnc.default), {
        to: to,
        padding: 0,
        actionSubjectId: "requestCreateLink",
        target: isEmbeddedRoute ? '_blank' : undefined,
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement($f07ebcf39817185a$var$MessageContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $eF51U.default).raiseRequestText)));
var $f07ebcf39817185a$export$2e2bcd8739ae039 = $f07ebcf39817185a$var$RaiseRequestLink;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f07ebcf39817185a$var$MessageContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-r621zd-0"
})`padding:${(0, $ei4x6.GROUP_BOX_PADDING_TOP_BOTTOM)} ${(0, $ei4x6.GROUP_BOX_PADDING_LEFT_RIGHT)};`;

});
parcelRegister("g29WC", function(module, exports) {
$parcel$export(module.exports, "CardLink", () => (parcelRequire("k7nnc")).default);

var $k7nnc = parcelRequire("k7nnc");

});
parcelRegister("k7nnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a8619e87f7e90a5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("fQxpy");
var $1JcSo = parcelRequire("1JcSo");

var $1ZqY6 = parcelRequire("1ZqY6");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $8HMxq = parcelRequire("8HMxq");
const $1a8619e87f7e90a5$var$CardLink = ({ children: children, to: to, padding: padding, className: className, appearance: appearance, actionSubjectId: actionSubjectId, dataTestId: dataTestId, target: target, onClick: onClick })=>{
    const [isPageInEditMode] = (0, $1JcSo.useIsPageInEditMode)();
    const handleClick = $fc4bM.useCallback(()=>{
        if (isPageInEditMode) return;
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    const content = /*#__PURE__*/ $fc4bM.createElement((0, $8HMxq.Card), {
        to: to,
        padding: padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        appearance: appearance,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        target: target,
        onClick: handleClick,
        tabIndex: isPageInEditMode ? -1 : undefined
    }, /*#__PURE__*/ $fc4bM.createElement((0, $8HMxq.Container), null, children, /*#__PURE__*/ $fc4bM.createElement((0, $8HMxq.IconContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6))), {
        size: "small",
        spacing: "spacious",
        label: "",
        "aria-hidden": "true",
        color: "var(--ds-text, #172B4D)"
    }))));
    return isPageInEditMode ? /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        xcss: $1a8619e87f7e90a5$var$disabledCard
    }, content) : content;
};
$1a8619e87f7e90a5$var$CardLink.defaultProps = {
    appearance: 'gray'
};
const $1a8619e87f7e90a5$var$disabledCard = (0, $kig2V.xcss)({
    pointerEvents: 'none'
});
var $1a8619e87f7e90a5$export$2e2bcd8739ae039 = $1a8619e87f7e90a5$var$CardLink;

});
parcelRegister("1ZqY6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da37f0a43857e8b8e953de1c778f2dc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1730684b16006555$var$_react = $1730684b16006555$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $1730684b16006555$var$_iconNew = $1730684b16006555$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $1730684b16006555$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-right
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1730684b16006555$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $1730684b16006555$var$_react.default.createElement($1730684b16006555$var$_iconNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$1730684b16006555$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $1730684b16006555$var$_default = module.exports.default = $1730684b16006555$var$ChevronRightIcon;

});

parcelRegister("8HMxq", function(module, exports) {
$parcel$export(module.exports, "Container", () => $aa797a00f43d760b$export$42a852a2b6b56249);
$parcel$export(module.exports, "IconContainer", () => $aa797a00f43d760b$export$8f314e512d92575f);
$parcel$export(module.exports, "Card", () => $aa797a00f43d760b$export$60332b2344f7fe41);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $3DjOo = parcelRequire("3DjOo");
parcelRequire("jM0xB");
var $fq3zF = parcelRequire("fq3zF");

var $k2M4v = parcelRequire("k2M4v");
const $aa797a00f43d760b$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $aa797a00f43d760b$var$isHcAdsDropCommit2Enabled = ()=>(0, $k2M4v.default).checkGate($aa797a00f43d760b$var$HC_ADS_DROP_COMMIT_2);
const $aa797a00f43d760b$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-15f4chr-0"
})`display:flex;align-items:center;justify-content:space-between;`;
const $aa797a00f43d760b$export$8f314e512d92575f = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-15f4chr-1"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $aa797a00f43d760b$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $luz1X.default)((0, $fq3zF.LinkCard)).withConfig({
    componentId: "sc-15f4chr-2"
})`${$3DjOo.borderRadius};${()=>$aa797a00f43d760b$var$isHcAdsDropCommit2Enabled() && $3DjOo.borderRadiusLarge} background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised, #FAFBFC)" : "var(--ds-surface-raised, #FFFFFF)"};padding:${(props)=>props.padding !== undefined ? `${props.padding}px` : "var(--ds-space-200, 16px)"};span{color:${"var(--ds-text, #172B4D)"};}&:hover{background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised-hovered, #FAFBFC)" : "var(--ds-surface-raised-hovered, #FFFFFF)"};}`;

});
parcelRegister("jM0xB", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => (parcelRequire("fq3zF")).LinkCard);

var $fq3zF = parcelRequire("fq3zF");

});
parcelRegister("fq3zF", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => $a9c802c070004b86$export$2c381a86421d5abf);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");

var $io4o2 = parcelRequire("io4o2");

var $4rovU = parcelRequire("4rovU");

var $3DjOo = parcelRequire("3DjOo");

var $k2M4v = parcelRequire("k2M4v");
const $a9c802c070004b86$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $a9c802c070004b86$var$isHcAdsDropCommit2Enabled = ()=>(0, $k2M4v.default).checkGate($a9c802c070004b86$var$HC_ADS_DROP_COMMIT_2);
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a9c802c070004b86$var$linkCardBase = /*#__PURE__*/ (0, $luz1X.css)`${$3DjOo.raiseUpOnHoverOrFocus((0, $4rovU.newElevationsFromDesignSystems).e100, (0, $4rovU.newElevationsFromDesignSystems).e200)};${$3DjOo.borderRadius};${()=>$a9c802c070004b86$var$isHcAdsDropCommit2Enabled() && $3DjOo.borderRadiusLarge} ${$3DjOo.focusRing.default};display:block;background-color:${"var(--ds-surface-raised, #FFFFFF)"};:hover,:focus{text-decoration:none;}`;
const $a9c802c070004b86$export$2c381a86421d5abf = /*#__PURE__*/ (0, $luz1X.default)((0, $io4o2.Link)).withConfig({
    componentId: "sc-axlah-0"
})`${$a9c802c070004b86$var$linkCardBase};`;

});





parcelRegister("eF51U", function(module, exports) {
$parcel$export(module.exports, "default", () => $564440542906cf7f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $564440542906cf7f$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    raiseRequestText: {
        defaultMessage: 'Need to raise a request? Contact us.',
        description: 'Card button text to raise request',
        id: 'sd.customerview.portal.card.button.text'
    }
});

});



parcelRegister("aWvUw", function(module, exports) {
$parcel$export(module.exports, "ArticleListItem", () => (parcelRequire("eNieK")).default);

var $eNieK = parcelRequire("eNieK");

});
parcelRegister("eNieK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf0638360f23709e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fOCtI = parcelRequire("fOCtI");

var $3DjOo = parcelRequire("3DjOo");
parcelRequire("2sJSQ");
var $5GNfO = parcelRequire("5GNfO");

var $3TJLC = parcelRequire("3TJLC");

var $dMHtF = parcelRequire("dMHtF");
const $bf0638360f23709e$var$ArticleListItem = ({ portalId: portalId, categoryId: categoryId, articleId: articleId, title: title, summaryExcerpt: summaryExcerpt, onClick: onClick })=>{
    const articleUrl = `/portal/${portalId}/topic/${categoryId}/article/${articleId}`;
    const analyticData = {
        attributes: {
            articleId: articleId,
            portalId: portalId,
            categoryId: categoryId
        }
    };
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: analyticData
    }, /*#__PURE__*/ $fc4bM.createElement($bf0638360f23709e$var$ListItem, null, /*#__PURE__*/ $fc4bM.createElement((0, $5GNfO.default), {
        actionSubjectId: "article",
        to: articleUrl,
        onClick: onClick,
        heading: title,
        description: /*#__PURE__*/ $fc4bM.createElement($bf0638360f23709e$export$ef81c5adc5a715ed, {
            dangerouslySetInnerHTML: {
                __html: summaryExcerpt
            }
        }),
        icon: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dMHtF))), {
            label: "",
            "aria-hidden": "true",
            size: "medium",
            color: "var(--ds-icon, #42526E)",
            spacing: "spacious"
        }),
        lineClamp: 2
    })));
};
var $bf0638360f23709e$export$2e2bcd8739ae039 = $bf0638360f23709e$var$ArticleListItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bf0638360f23709e$var$ListItem = /*#__PURE__*/ (0, $luz1X.default).li.withConfig({
    componentId: "sc-1u8m6l-0"
})`margin:0;list-style:none;`;
const $bf0638360f23709e$export$ef81c5adc5a715ed = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-1u8m6l-1"
})`${$3DjOo.multiLineClamp(2, $fOCtI.multiple(2.5).unitless)};margin:0;`;

});
parcelRegister("dMHtF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e7015f59509d2b635af4bc6bdf65848>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0917bc8d2217ead$var$_react = $a0917bc8d2217ead$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a0917bc8d2217ead$var$_iconNew = $a0917bc8d2217ead$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a0917bc8d2217ead$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/book-with-bookmark
 * Usage guidance:
 * Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0917bc8d2217ead$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $a0917bc8d2217ead$var$_react.default.createElement($a0917bc8d2217ead$var$_iconNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$a0917bc8d2217ead$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $a0917bc8d2217ead$var$_default = module.exports.default = $a0917bc8d2217ead$var$BookWithBookmarkIcon;

});



parcelRegister("lbU7h", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c1de1df769233ad$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $6c1de1df769233ad$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    featuredArticlesHeading: {
        defaultMessage: 'Featured articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.featured-articles.heading'
    },
    moreArticlesHeading: {
        defaultMessage: 'More articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.more-articles.heading'
    },
    articlesEmptyStateText: {
        defaultMessage: 'There are no articles in this category yet. Try another category, or raise a request below.',
        description: 'The text is shown as the body message in the empty state of the article list on a knowledge category page, displayed when no articles exist in the selected category.',
        id: 'cv.categories.page.no.articles.message'
    },
    categoriesEmptyStateLink: {
        defaultMessage: 'Back to {portalName}',
        description: 'The text is shown as a back navigation link in the empty state of the article list on a knowledge category page. The placeholder {portalName} will be substituted with the name of the current portal.',
        id: 'cv.categories.page.no.articles.back.link'
    }
});

});



parcelRegister("6MwKq", function(module, exports) {
$parcel$export(module.exports, "default", () => $252298e404eb111d$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $252298e404eb111d$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    categoryDocumentTitle: {
        defaultMessage: '{portalName} - {categoryName}',
        description: 'Document title for portal article topics page',
        id: 'cv.categories.page.title'
    }
});

});



parcelRegister("bDo58", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bF3yO").then(()=>parcelRequire('3Fyl9'));

});


parcelRegister("icz03", function(module, exports) {
$parcel$export(module.exports, "loginRoute", () => $a3772a75587bd18b$export$798bfdbebc5ea68e);
$parcel$export(module.exports, "portalLoginRoute", () => $a3772a75587bd18b$export$e338715dbbd45865);

var $9mazR = parcelRequire("9mazR");
parcelRequire("5bYTt");
var $8XF5F = parcelRequire("8XF5F");

var $joDHD = parcelRequire("joDHD");

var $ivtaS = parcelRequire("ivtaS");
const $a3772a75587bd18b$var$portalLogin = {
    name: 'portal-login',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/login`,
    exact: true,
    component: (0, $8XF5F.default),
    resources: []
};
const $a3772a75587bd18b$var$login = {
    name: 'login',
    path: (0, $ivtaS.LOGIN_ROUTE),
    exact: true,
    component: (0, $8XF5F.default),
    resources: []
};
const $a3772a75587bd18b$var$screenName = (0, $9mazR.ScreenName).LOGIN;
const $a3772a75587bd18b$export$798bfdbebc5ea68e = (0, $joDHD.createRouteWithLayout)($a3772a75587bd18b$var$login, $a3772a75587bd18b$var$screenName, (0, $ivtaS.anonymousScreenLayout));
const $a3772a75587bd18b$export$e338715dbbd45865 = (0, $joDHD.createRouteWithLayout)($a3772a75587bd18b$var$portalLogin, $a3772a75587bd18b$var$screenName, (0, $ivtaS.anonymousScreenLayout));

});
parcelRegister("5bYTt", function(module, exports) {
$parcel$export(module.exports, "Login", () => (parcelRequire("8XF5F")).default);

var $8XF5F = parcelRequire("8XF5F");

});
parcelRegister("8XF5F", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4e1324eebca14ff$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $eXQnZ = parcelRequire("eXQnZ");

var $hO6iq = parcelRequire("hO6iq");

var $1wdH4 = parcelRequire("1wdH4");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("d6hfC");
var $7m3Xa = parcelRequire("7m3Xa");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("ac3DA");
var $RpRsX = parcelRequire("RpRsX");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("k4bWB");
var $5OBCw = parcelRequire("5OBCw");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $gbtKV = parcelRequire("gbtKV");
const $d4e1324eebca14ff$var$selector = (0, $2n2bS.createSelector)((state)=>(0, $ePyx3.getSharedPortalName)(state), (state)=>(0, $5OBCw.getLogin)(state), (state)=>(0, $5OBCw.getIsLoginLoaded)(state), (state)=>(0, $RpRsX.getResetUrl)(state), (state)=>(0, $7RWiC.isLoggedIn)(state), (state)=>(0, $5OBCw.getLoginUIState)(state), (state)=>(0, $fYLlE.getIsAnonymousEnabled)(state), (helpCenterName, loginModel, loaded, resetUrl, isUserLoggedIn, loginUIState, isAnonymousEnabled)=>({
        helpCenterName: helpCenterName,
        loginModel: loginModel,
        resetUrl: resetUrl,
        loginUIState: loginUIState,
        isAnonymousEnabled: isAnonymousEnabled,
        isLoggedIn: isUserLoggedIn,
        isLoading: !loaded
    }));
var $d4e1324eebca14ff$export$2e2bcd8739ae039 = (0, $6umft.default)($d4e1324eebca14ff$var$selector, {
    resetLogin: $6oW6S.resetLogin,
    fetchLoginModel: $1wdH4.fetchLoginModel,
    checkLoginActionSuccess: $6oW6S.checkLoginActionSuccess,
    fetchForgotPasswordModel: $hO6iq.fetchForgotPasswordModel,
    successfullyLoggedInAction: (0, $7m3Xa.successfullyLoggedIn),
    onExitTestMode: (0, $6oW6S.exitTestModeAction)
})((0, $613oU.default)({
    component: 'login'
})((0, $azARG.default)()((0, $eXQnZ.default)((0, $gbtKV.default)))));

});
parcelRegister("ac3DA", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => (parcelRequire("RpRsX")).getResetUrl);

var $RpRsX = parcelRequire("RpRsX");

});
parcelRegister("RpRsX", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => $734bf143e43825e6$export$8f4db1396a1458f2);
const $734bf143e43825e6$var$getForgotPasswordOrError = (state)=>{
    return state.persisted.forgotPassword;
};
const $734bf143e43825e6$export$8f4db1396a1458f2 = (state)=>{
    const data = $734bf143e43825e6$var$getForgotPasswordOrError(state);
    return data && 'forgotPassword' in data && data.forgotPassword ? data.forgotPassword.resetUrl : undefined;
};

});


parcelRegister("k4bWB", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => (parcelRequire("5OBCw")).getLogin);
$parcel$export(module.exports, "getIsLoginLoaded", () => (parcelRequire("5OBCw")).getIsLoginLoaded);
$parcel$export(module.exports, "getLoginUIState", () => (parcelRequire("5OBCw")).getLoginUIState);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => (parcelRequire("5OBCw")).getIsFailedLoginAttempt);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => (parcelRequire("5OBCw")).getLoginAnnouncementLocale);

var $5OBCw = parcelRequire("5OBCw");

});
parcelRegister("5OBCw", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => $a7f39b1f467786fc$export$b91571cfe9876bf7);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => $a7f39b1f467786fc$export$30a66755de1b0435);
$parcel$export(module.exports, "getIsLoginLoaded", () => $a7f39b1f467786fc$export$b8e9d5ecaaf5cf65);
$parcel$export(module.exports, "getLoginUIState", () => $a7f39b1f467786fc$export$3751fae82567dd3f);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => $a7f39b1f467786fc$export$bd53bde676b5f183);
const $a7f39b1f467786fc$var$getLoginOrError = (state)=>{
    return state.persisted.login;
};
const $a7f39b1f467786fc$export$b91571cfe9876bf7 = (state)=>{
    const data = $a7f39b1f467786fc$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? data.login : undefined;
};
const $a7f39b1f467786fc$export$30a66755de1b0435 = (state)=>{
    var _data$login;
    const data = $a7f39b1f467786fc$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? (_data$login = data.login) === null || _data$login === void 0 ? void 0 : _data$login.loginAnnouncementLocale : undefined;
};
const $a7f39b1f467786fc$export$b8e9d5ecaaf5cf65 = (state)=>{
    const login = $a7f39b1f467786fc$export$b91571cfe9876bf7(state);
    return login !== undefined;
};
const $a7f39b1f467786fc$export$3751fae82567dd3f = (state)=>{
    return state.ui.login;
};
const $a7f39b1f467786fc$export$9fd495314b248bd5 = (state)=>{
    return $a7f39b1f467786fc$export$3751fae82567dd3f(state).error;
};
const $a7f39b1f467786fc$export$bd53bde676b5f183 = (state)=>{
    const loginUIState = $a7f39b1f467786fc$export$3751fae82567dd3f(state);
    return $a7f39b1f467786fc$export$9fd495314b248bd5(state) !== undefined || loginUIState.loginAttemptResponse !== undefined && !loginUIState.loginAttemptResponse.loginSucceeded;
};

});


parcelRegister("gbtKV", function(module, exports) {
$parcel$export(module.exports, "default", () => $430f125c8a0937dd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $7VVXk = parcelRequire("7VVXk");

var $9mazR = parcelRequire("9mazR");

var $aHS3M = parcelRequire("aHS3M");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $fRgxR = parcelRequire("fRgxR");

var $fJq3t = parcelRequire("fJq3t");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("2uGW5");
var $e81ck = parcelRequire("e81ck");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");

var $dBa2X = parcelRequire("dBa2X");

var $3TJLC = parcelRequire("3TJLC");

var $1hJdJ = parcelRequire("1hJdJ");

var $4T8rw = parcelRequire("4T8rw");

var $g1Ebu = parcelRequire("g1Ebu");

var $d7r8x = parcelRequire("d7r8x");

var $eENmG = parcelRequire("eENmG");

var $cf3fd = parcelRequire("cf3fd");

var $dkrfZ = parcelRequire("dkrfZ");

var $6Pd4T = parcelRequire("6Pd4T");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $dbYz0 = parcelRequire("dbYz0");

var $lqPWj = parcelRequire("lqPWj");

var $4OdjM = parcelRequire("4OdjM");

var $gioQl = parcelRequire("gioQl");

var $ioG3n = parcelRequire("ioG3n");
parcelRequire("6htNE");
var $kviVM = parcelRequire("kviVM");
parcelRequire("76bXj");
var $gPXLn = parcelRequire("gPXLn");
parcelRequire("haDv7");
var $efCMI = parcelRequire("efCMI");
parcelRequire("9PMVG");
var $3Tlii = parcelRequire("3Tlii");
parcelRequire("6gKNW");
var $hkMok = parcelRequire("hkMok");
parcelRequire("9DUFj");
var $9JFHA = parcelRequire("9JFHA");

var $1lhZ5 = parcelRequire("1lhZ5");
/**
 * Check if loginAnnouncement is present
 */ const $430f125c8a0937dd$var$isAnnouncementPresent = (loginModel)=>{
    if (!loginModel) return false;
    const { loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage } = loginModel;
    return (0, $lqPWj.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
};
const $430f125c8a0937dd$var$getLoginAnnouncementText = (loginAnnouncementMessage)=>{
    return /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$var$LoginAnnouncementBody, {
        dangerouslySetInnerHTML: {
            __html: (0, $fJq3t.sanitize)(loginAnnouncementMessage)
        }
    });
};
const $430f125c8a0937dd$export$f20e6faa97f704fb = ({ loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage })=>/*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$var$LoginAnnouncementContainer, null, loginAnnouncementSubject ? /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
            size: "small"
        }, loginAnnouncementSubject)
    }, /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$var$LoginAnnouncementTitle, null, loginAnnouncementSubject)) : null, loginAnnouncementMessage ? $430f125c8a0937dd$var$getLoginAnnouncementText(loginAnnouncementMessage) : null);
class $430f125c8a0937dd$export$21a94553ffa41578 extends $fc4bM.Component {
    componentDidMount() {
        const { isLoading: isLoading, resetUrl: resetUrl, loginUIState: loginUIState } = this.props;
        const ssoCustomerMethod = loginUIState.authInfo.authMethods.get((0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
        if (isLoading) this.props.fetchLoginModel();
        if (!resetUrl) this.props.fetchForgotPasswordModel();
        if (loginUIState.authInfo.authMethods.size === 0) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: true,
            redirectUrlIsMissing: false
        });
        else if (ssoCustomerMethod && ssoCustomerMethod.redirectLink === undefined) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: false,
            redirectUrlIsMissing: true
        });
    }
    getNavigationTiming() {
        var _globalThis$performan, _globalThis$performan2;
        return (_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 || (_globalThis$performan2 = _globalThis$performan.getEntriesByType) === null || _globalThis$performan2 === void 0 || (_globalThis$performan2 = _globalThis$performan2.call(_globalThis$performan, 'navigation')) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2[0];
    }
    render() {
        const { isLoggedIn: isLoggedIn, portalId: portalId } = this.props;
        const navigation = this.getNavigationTiming();
        if (isLoggedIn) return /*#__PURE__*/ $fc4bM.createElement((0, $4OdjM.RedirectLoggedInUser), {
            portalId: portalId
        });
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: {
                attributes: {
                    isSsoTestMode: (0, $gioQl.getSsoTestModeParamFromUrl)(new URLSearchParams((0, $esgVk.search)()))
                }
            }
        }, /*#__PURE__*/ $fc4bM.createElement((0, $g1Ebu.default), {
            data: {
                isFromRedirect: navigation ? navigation.redirectCount > 0 : undefined,
                redirectCount: navigation ? navigation.redirectCount : undefined,
                isDefaultHelpCenter: (0, $cf3fd.isDefaultHelpCenter)()
            }
        }), /*#__PURE__*/ $fc4bM.createElement("div", {
            "data-test-id": "login-page.wrapper"
        }, this.renderLoginPage()));
    }
    constructor(...args){
        super(...args), this.fireLoginFailedOperationalEvent = (attributes)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const { noMethodsAvailable: noMethodsAvailable, redirectUrlIsMissing: redirectUrlIsMissing } = attributes;
            if (createAnalyticsEvent) createAnalyticsEvent({
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'login',
                action: 'failed',
                attributes: {
                    noMethodsAvailable: noMethodsAvailable,
                    redirectUrlIsMissing: redirectUrlIsMissing
                }
            }).fire();
        }, this.getJITContinueParam = ()=>{
            const { destination: destination, isAbsolute: isAbsolute } = (0, $gioQl.parseLoginSignupRedirectUrlParams)();
            const prefix = destination && isAbsolute ? '' : `${(0, $esgVk.origin)()}${(0, $diqlM.getBaseName)()}/aa-redirect?from=portalLoginJitSignup`;
            return `${prefix}`;
        }, this.resetHasLoginPageUpdated = ()=>{
            this.props.resetLogin(this.props.loginUIState.email);
        }, this.renderForgotPasswordConfirmation = ()=>{
            const { isLoading: isLoading, loginUIState: loginUIState, helpCenterName: helpCenterName, resetUrl: resetUrl } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
                screenName: (0, $9mazR.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $fc4bM.createElement((0, $4xX38.default), {
                screenName: (0, $9mazR.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $fc4bM.createElement((0, $e81ck.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $fc4bM.createElement((0, $gPXLn.default), {
                email: loginUIState.email,
                helpCenterName: helpCenterName,
                resetUrl: resetUrl || '',
                onBackButtonClick: this.resetHasLoginPageUpdated
            }))));
        }, this.renderSsoTestModeErrorPage = ()=>{
            const { isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
                screenName: (0, $9mazR.ScreenName).LOGIN_SSO_TEST_MODE_ERROR
            }, /*#__PURE__*/ $fc4bM.createElement((0, $e81ck.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $fc4bM.createElement((0, $kviVM.default), null)));
        }, this.renderSingleSignOn = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $dbYz0.AuthMethodType).ATLASSIAN_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
                        screenName: (0, $9mazR.ScreenName).LOGIN_SINGLE_SIGN_ON
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $hkMok.default), {
                        redirectUrl: redirectLink,
                        email: loginUIState.email
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.resetToCustomerPasswordLogin = ()=>{
            this.props.checkLoginActionSuccess((0, $dbYz0.LoginType).CUSTOMER_ACCOUNT_LOGIN, {
                accountStage: (0, $dbYz0.AccountStageType).LOGIN,
                authMethods: new Map([
                    [
                        (0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            });
        }, this.renderSingleSignOnCustomer = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const passwordLoginAvailable = loginUIState.authInfo.authMethods.has((0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
                        screenName: (0, $9mazR.ScreenName).LOGIN_SINGLE_SIGN_ON_CUSTOMER
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $9JFHA.default), {
                        email: loginUIState.email,
                        redirectLink: redirectLink,
                        passwordLoginAvailable: passwordLoginAvailable,
                        onContinueWithPassword: this.resetToCustomerPasswordLogin
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.renderLoginPasswordForm = ()=>{
            return /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
                screenName: (0, $9mazR.ScreenName).LOGIN_PASSWORD
            }, this.renderLoginForm());
        }, this.renderLoginForm = ()=>{
            const { resetUrl: resetUrl, loginUIState: loginUIState, portalId: portalId } = this.props;
            const formSupplier = (loginModel)=>/*#__PURE__*/ $fc4bM.createElement((0, $3Tlii.default), {
                    portalId: portalId,
                    contactAdminLink: loginModel.contactAdminLink,
                    resetUrl: resetUrl || '',
                    loginUIState: loginUIState,
                    canResetPassword: loginModel.canReset,
                    continueParam: (0, $gioQl.getContinueParam)(portalId)
                });
            return this.renderWithTitleAndFooter(formSupplier);
        }, this.renderFooter = ()=>{
            const { intl: intl, isAnonymousEnabled: isAnonymousEnabled, loginUIState: loginUIState, helpCenterName: helpCenterName } = this.props;
            return isAnonymousEnabled && !loginUIState.atlassianAccountCheckPerformed && /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$var$FooterContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $fRgxR.default), {
                to: (0, $gioQl.getHelpCenterUrl)(),
                actionSubjectId: "helpCenterLink",
                onClick: (e)=>{
                    // This is ugly but we want to do a full page load (not an SPA load/transition)
                    // to allow the backend to make the decision about where we should end up.
                    // If CSM DOES NOT allow anonymous access but Jira Admin settings DOES, then
                    // an SPA transition will lead to a blank homepage as the backend actually
                    // wants to redirect the user to the login page.
                    e.preventDefault();
                    (0, $esgVk.assign)((0, $7lN8e.getEnv)().baseUrl);
                }
            }, intl.formatMessage((0, $1lhZ5.default).helpCenterLink, {
                helpCenterName: helpCenterName
            })));
        }, this.renderBackButton = ()=>{
            const { intl: intl } = this.props;
            const buttonText = intl.formatMessage((0, $1lhZ5.default).backButton);
            return /*#__PURE__*/ $fc4bM.createElement((0, $ioG3n.default), {
                appearance: "link",
                actionSubjectId: "returnToLogin",
                onClick: this.resetHasLoginPageUpdated
            }, buttonText);
        }, this.getLoginAnnouncementCard = ()=>{
            const { loginModel: loginModel } = this.props;
            if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)()) // render new login announcement with relay fetch
            return /*#__PURE__*/ $fc4bM.createElement((0, $efCMI.default), null);
            if (loginModel && $430f125c8a0937dd$var$isAnnouncementPresent(loginModel)) // render old login announcement card with model
            return /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$export$f20e6faa97f704fb, {
                loginAnnouncementSubject: loginModel.loginAnnouncementSubject,
                loginAnnouncementMessage: loginModel.loginAnnouncementMessage
            });
            return null;
        }, this.getContent = (componentSupplier)=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading, loginModel: loginModel, loginUIState: loginUIState } = this.props;
            let description = intl.formatMessage((0, $1lhZ5.default).description);
            if (loginUIState.atlassianAccountCheckPerformed) {
                if (loginUIState.authInfo.authMethods.has((0, $dbYz0.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) switch(loginUIState.authInfo.accountStage){
                    case (0, $dbYz0.AccountStageType).SIGNUP:
                        description = intl.formatMessage((0, $1lhZ5.default).useAtlassianAccountSignup);
                        break;
                    case (0, $dbYz0.AccountStageType).LOGIN:
                    default:
                        description = intl.formatMessage((0, $1lhZ5.default).useAtlassianAccountLogin);
                        break;
                }
                else description = intl.formatMessage((0, $1lhZ5.default).descriptionLogin);
            }
            const loginAnnouncementCard = this.getLoginAnnouncementCard();
            if (!isLoading && loginModel) return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, loginUIState.atlassianAccountCheckPerformed && this.renderBackButton(), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$export$8faa746ec8bdfab3, null, helpCenterName)), !loginUIState.atlassianAccountCheckPerformed ? loginAnnouncementCard : null, /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                    size: "medium"
                }, description)
            }, /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$var$LoginDescription, null, description)), /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$var$LoginFormContainer, null, componentSupplier(loginModel)), this.renderFooter());
            return /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
                name: "render-login-page-loading"
            });
        }, this.renderWithTitleAndFooter = (componentSupplier)=>{
            const { isLoading: isLoading } = this.props;
            const content = this.getContent(componentSupplier);
            const urlParams = new URLSearchParams((0, $esgVk.search)());
            const ssoTest = urlParams.get((0, $dbYz0.QUERY_PARAM_SSO_TEST));
            return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, ssoTest === 'true' ? /*#__PURE__*/ $fc4bM.createElement((0, $dBa2X.SsoTestModeBanner), null) : null, /*#__PURE__*/ $fc4bM.createElement((0, $e81ck.NoteContent), {
                isLoading: isLoading
            }, content));
        }, this.isInvalidFedRampLogin = ()=>{
            const isPasswordLoginDisabledByEnv = !(0, $7VVXk.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login');
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.isInvalidIcLogin = ()=>{
            const isPasswordLoginDisabledByEnv = !(0, $7VVXk.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login');
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.noAuthMethodOrOnlyHasPasswordAuthMethod = ()=>{
            const { loginUIState: loginUIState } = this.props;
            return loginUIState.authInfo.authMethods.size === 0 || loginUIState.authInfo.authMethods.size === 1 && loginUIState.authInfo.authMethods.has((0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
        }, this.renderNoLoginMethodPage = ()=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement((0, $e81ck.NoteContent), {
                isLoading: isLoading
            }, this.renderBackButton(), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $fc4bM.createElement($430f125c8a0937dd$export$8faa746ec8bdfab3, null, helpCenterName)), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), null, intl.formatMessage((0, $1lhZ5.default).noLoginMethodWarningContent))
            }, /*#__PURE__*/ $fc4bM.createElement("p", null, intl.formatMessage((0, $1lhZ5.default).noLoginMethodWarningContent))));
        }, this.renderLoginPage = ()=>{
            const { intl: intl, loginUIState: loginUIState } = this.props;
            let loginPage;
            if (loginUIState.showPasswordConfirmation) loginPage = this.renderForgotPasswordConfirmation();
            else if (loginUIState.authInfo.authMethods.has((0, $dbYz0.AuthMethodType).CUSTOMER_ACCOUNT_SSO)) loginPage = this.renderSingleSignOnCustomer();
            else if (loginUIState.authInfo.authMethods.has((0, $dbYz0.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) loginPage = this.renderSingleSignOn();
            else if (loginUIState.showSsoTestModeErrorPage) loginPage = this.renderSsoTestModeErrorPage();
            else if (loginUIState.atlassianAccountCheckPerformed) {
                if (this.isInvalidFedRampLogin() || this.isInvalidIcLogin()) loginPage = this.renderNoLoginMethodPage();
                else loginPage = this.renderLoginPasswordForm();
            } else loginPage = this.renderLoginForm();
            return /*#__PURE__*/ $fc4bM.createElement((0, $aHS3M.default), {
                title: intl.formatMessage((0, $1lhZ5.default).documentTitle)
            }, loginPage);
        };
    }
}
var $430f125c8a0937dd$export$2e2bcd8739ae039 = (0, $fcCIH.default)($430f125c8a0937dd$export$21a94553ffa41578);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $430f125c8a0937dd$var$LoginDescription = /*#__PURE__*/ (0, $luz1X.default).h2.withConfig({
    componentId: "sc-1ifnvh3-0"
})`${(0, $imLe4.h600)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $430f125c8a0937dd$var$LoginFormContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ifnvh3-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $430f125c8a0937dd$var$FooterContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ifnvh3-2"
})`margin-top:${"var(--ds-space-400, 32px)"};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $430f125c8a0937dd$var$LoginAnnouncementContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ifnvh3-3"
})`padding-bottom:${"var(--ds-space-200, 16px)"};border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $430f125c8a0937dd$var$LoginAnnouncementTitle = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ifnvh3-4"
})`${(0, $imLe4.h500)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $430f125c8a0937dd$var$LoginAnnouncementBody = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1ifnvh3-5"
})`margin-top:${"var(--ds-space-100, 8px)"};max-width:${$fOCtI.multiple(42).px};overflow-wrap:break-word;`;
const $430f125c8a0937dd$export$8faa746ec8bdfab3 = /*#__PURE__*/ (0, $luz1X.default).h1.withConfig({
    componentId: "sc-1ifnvh3-6"
})`${(0, $imLe4.h700)};`;

});
parcelRegister("2uGW5", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => (parcelRequire("e81ck")).NoteContent);

var $e81ck = parcelRequire("e81ck");

});
parcelRegister("e81ck", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => $b71817c109267d63$export$fe2e0d4376bdc305);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $fOCtI = parcelRequire("fOCtI");
parcelRequire("e2U4l");
var $8min0 = parcelRequire("8min0");
class $b71817c109267d63$export$fe2e0d4376bdc305 extends $fc4bM.Component {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement($b71817c109267d63$var$NoteContentContainer, {
            isCentered: this.props.isCentered,
            "data-testid": "note-content-container"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $8min0.default), {
            isLoading: this.props.isLoading,
            loadingPosition: "fill-container"
        }, this.props.children));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b71817c109267d63$var$NoteContentContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-x5t5ez-0"
})`margin:${"var(--ds-space-800, 64px)"};max-width:${$fOCtI.multiple(44).px};text-align:${(props)=>props.isCentered ? 'center' : 'start'};`;

});


parcelRegister("dBa2X", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeBanner", () => $195f49bd1c40656f$export$c5b94d186c592c02);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $195f49bd1c40656f$export$c5b94d186c592c02 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("kg0qe")), {
        moduleId: "./src/view/sso-test-mode-banner/hocs.tsx"
    })
});

});
parcelRegister("kg0qe", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hraEJ").then(()=>parcelRequire('3Cwg5'));

});


parcelRegister("g1Ebu", function(module, exports) {
$parcel$export(module.exports, "default", () => $14f09e0ae228aaf7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $9UyEJ = parcelRequire("9UyEJ");
function $14f09e0ae228aaf7$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $fc4bM.useContext)((0, $9UyEJ.default));
    (0, $fc4bM.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}

});

parcelRegister("lqPWj", function(module, exports) {
$parcel$export(module.exports, "isValidAnnouncement", () => $e739772c8ece4252$export$12ee192c1d1082df);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_TITLE_LIMIT", () => $e739772c8ece4252$export$6cca6da7b99ee46e);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_MESSAGE_LIMIT", () => $e739772c8ece4252$export$24036c5b680cb85);
const $e739772c8ece4252$export$12ee192c1d1082df = (header, message)=>header !== '' || message !== '';
const $e739772c8ece4252$export$6cca6da7b99ee46e = 50;
const $e739772c8ece4252$export$24036c5b680cb85 = 480;

});

parcelRegister("4OdjM", function(module, exports) {
$parcel$export(module.exports, "RedirectLoggedInUser", () => $2425b3e9b1e885c6$export$b883ffb676ea4071);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $g9ziK = parcelRequire("g9ziK");

var $gioQl = parcelRequire("gioQl");
const $2425b3e9b1e885c6$export$b883ffb676ea4071 = ({ portalId: portalId })=>{
    const { destination: destination } = (0, $gioQl.parseLoginSignupRedirectUrlParams)();
    if ((0, $hN5YJ.isHubsEnabledInHelpCenter)() && (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) || (0, $cf3fd.getIsHelpHub)()) {
        if (destination && (0, $esgVk.isValidLocation)(destination)) {
            const relativeUrl = (0, $gioQl.convertAbsoluteUrlToRelativeUrl)(destination);
            const redirectPath = `${(0, $diqlM.getRelativeBasePath)()}${relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`}`;
            (0, $esgVk.replace)(redirectPath);
        } else if (destination && decodeURIComponent(destination).startsWith('//')) (0, $esgVk.replace)((0, $diqlM.getRelativeBasePath)());
        else {
            const redirectPath = `${(0, $diqlM.getRelativeBasePath)()}${destination ? `/${destination}` : ''}`;
            (0, $esgVk.replace)(redirectPath);
        }
        return null;
    }
    if (destination) {
        if ((0, $esgVk.isValidLocation)(destination)) {
            const relativeUrl = (0, $gioQl.convertAbsoluteUrlToRelativeUrl)(destination);
            (0, $esgVk.assign)(relativeUrl);
            return null;
        }
        if (decodeURIComponent(destination).startsWith('//')) {
            (0, $esgVk.assign)((0, $gioQl.getHelpCenterUrl)());
            return null;
        }
    }
    if ($2425b3e9b1e885c6$var$shouldExecuteFullPageReload(destination)) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (0, $esgVk.replace)(`${(0, $diqlM.getRelativeBasePath)()}/${destination}`);
        return null;
    }
    const relativeDestination = `/${destination || (0, $gioQl.getDefaultDestination)(portalId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g9ziK.Redirect), {
        to: relativeDestination
    });
};
const $2425b3e9b1e885c6$var$fullPageReloadPathsRegexs = [
    /^request\/[0-9]+\/attachment\/[0-9]+[/]?(\?.*)?$/,
    /^request\/[0-9]+\/attachment\/[0-9]+\/thumbnail[/]?(\?.*)?$/
];
/**
 * Some URLs, even though they start with /servicedesk/customer, don't have any specific component mapped to that route.
 * When customers account log in the portal will simply do an SPA redirection and it will end up in 404
 * This method will allow for these "special" URLs to execute a full page reload after a customer account logs in.
 */ const $2425b3e9b1e885c6$var$shouldExecuteFullPageReload = (destination)=>{
    if (destination) return $2425b3e9b1e885c6$var$fullPageReloadPathsRegexs.some((regex)=>regex.test(destination));
    return false;
};

});

parcelRegister("ioG3n", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9ca737cd8e7010$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $iK1uY = parcelRequire("iK1uY");

var $i2XJe = parcelRequire("i2XJe");
const $ad9ca737cd8e7010$var$ThemedBackButton = (props)=>{
    const { children: children, onClick: onClick, actionSubjectId: actionSubjectId, appearance: appearance } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ad9ca737cd8e7010$var$BackButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iK1uY.ThemedButton), {
        iconBefore: // Icon is decorative — adjacent button text already conveys the label
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i2XJe))), {
            spacing: "spacious",
            label: ""
        }),
        appearance: appearance,
        spacing: "compact",
        actionSubjectId: actionSubjectId,
        onClick: onClick
    }, children));
};
var $ad9ca737cd8e7010$export$2e2bcd8739ae039 = $ad9ca737cd8e7010$var$ThemedBackButton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ad9ca737cd8e7010$var$BackButtonWrapper = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-x420oi-0"
})`margin-left:${"var(--ds-space-negative-200, -16px)"};`;

});

parcelRegister("6htNE", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeErrorPage", () => (parcelRequire("kviVM")).default);

var $kviVM = parcelRequire("kviVM");

});
parcelRegister("kviVM", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcbacec0219437de$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $fRgxR = parcelRequire("fRgxR");

var $4Pqwt = parcelRequire("4Pqwt");

var $gpjDl = parcelRequire("gpjDl");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $lvRbB = parcelRequire("lvRbB");

var $6Pd4T = parcelRequire("6Pd4T");

var $knfle = parcelRequire("knfle");
const $dcbacec0219437de$var$LEARN_MORE_LINK = 'https://support.atlassian.com/jira-service-management-cloud/docs/test-single-sign-on-for-customer-login/';
const $dcbacec0219437de$var$CaSsoTestModeErrorPage = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ $fc4bM.createElement($dcbacec0219437de$var$Container, {
        "data-test-id": "ca-sso-test-mode-error-screen-container"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), /*#__PURE__*/ $fc4bM.createElement($dcbacec0219437de$var$IconContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $4Pqwt.default), null)), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
            paddingBlockEnd: "space.050"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
            size: "medium"
        }, formatMessage((0, $knfle.default).title)))
    }, /*#__PURE__*/ $fc4bM.createElement($dcbacec0219437de$var$Title, null, formatMessage((0, $knfle.default).title))), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), null, formatMessage((0, $knfle.default).instructionMessage))
    }, /*#__PURE__*/ $fc4bM.createElement("p", null, formatMessage((0, $knfle.default).instructionMessage))), /*#__PURE__*/ $fc4bM.createElement((0, $fRgxR.default), {
        actionSubjectId: "learnMoreSsoTestMode",
        href: $dcbacec0219437de$var$LEARN_MORE_LINK,
        target: "_blank"
    }, formatMessage((0, $knfle.default).learnMoreLinkLabel)));
};
var $dcbacec0219437de$export$2e2bcd8739ae039 = $dcbacec0219437de$var$CaSsoTestModeErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $dcbacec0219437de$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1q5wzvf-0"
})`text-align:center;> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $dcbacec0219437de$var$Title = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1q5wzvf-1"
})`${(0, $imLe4.h600)};margin-bottom:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $dcbacec0219437de$var$IconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1q5wzvf-2"
})`width:${$fOCtI.multiple(10.5).px};margin:0 auto ${"var(--ds-space-300, 24px)"} auto;`;

});
parcelRegister("knfle", function(module, exports) {
$parcel$export(module.exports, "default", () => $09b8ed0121c8b940$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $09b8ed0121c8b940$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    learnMoreLinkLabel: {
        defaultMessage: 'Learn more about testing single sign-on',
        description: 'label for learn more link for sso test mode failure',
        id: 'cv.login.ca.sso.test.mode.error.learn.more.label'
    },
    instructionMessage: {
        defaultMessage: 'Turn on the single sign-on test mode in your Authentication settings.',
        description: 'message with instruction for SSO test mode',
        id: 'cv.login.ca.sso.test.mode.error.instruction.message'
    },
    title: {
        defaultMessage: 'Single Sign-on test mode is disabled',
        description: 'title for SSO test mode error page',
        id: 'cv.login.ca.sso.test.mode.error.title'
    }
});

});



parcelRegister("76bXj", function(module, exports) {
$parcel$export(module.exports, "ForgotPasswordConfirmation", () => (parcelRequire("gPXLn")).default);

var $gPXLn = parcelRequire("gPXLn");

});
parcelRegister("gPXLn", function(module, exports) {
$parcel$export(module.exports, "default", () => $82daa346151def02$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $5kfOu = parcelRequire("5kfOu");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");

var $grezp = parcelRequire("grezp");
var $82daa346151def02$export$2e2bcd8739ae039 = (0, $6umft.default)((state)=>({
        baseUrl: (0, $fYLlE.getBaseUrl)(state)
    }), {
    resetLoginAction: (0, $6oW6S.resetLogin),
    onResendLinkError: (0, $5kfOu.handleAjaxError),
    onResendSuccess: (0, $5kfOu.showSuccessFlag)
})((0, $grezp.default));

});
parcelRegister("grezp", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fc2e594594022f0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $iK1uY = parcelRequire("iK1uY");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");

var $epDUQ = parcelRequire("epDUQ");

var $ioG3n = parcelRequire("ioG3n");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $lvRbB = parcelRequire("lvRbB");

var $6Pd4T = parcelRequire("6Pd4T");

var $gioQl = parcelRequire("gioQl");

var $1lhZ5 = parcelRequire("1lhZ5");

var $J3DxC = parcelRequire("J3DxC");
class $6fc2e594594022f0$export$3ed80e0e31a57da extends $fc4bM.Component {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement($6fc2e594594022f0$var$Container, {
            "data-test-id": "forgot-password-container"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), this.renderContent());
    }
    constructor(...args){
        super(...args), this.state = {
            isSendingForgotPasswordEmail: false
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $gioQl.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onResendButtonClick = ()=>{
            this.setState({
                isSendingForgotPasswordEmail: true
            });
            const redirectUrl = this.getRedirectUrl(this.props.baseUrl);
            (0, $epDUQ.forgotPassword)(this.props.resetUrl, this.props.email, redirectUrl).toPromise().then(()=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendSuccess((0, $J3DxC.default).resendSuccessMessage, {
                    emailAddress: this.props.email
                });
            }).catch((err)=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendLinkError(err);
            });
        }, this.renderContent = ()=>{
            const { intl: intl, email: email, helpCenterName: helpCenterName, onBackButtonClick: onBackButtonClick } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $ioG3n.default), {
                appearance: "link",
                onClick: onBackButtonClick,
                actionSubjectId: "returnToLogin"
            }, intl.formatMessage((0, $1lhZ5.default).backButton)), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                    paddingBlockEnd: "space.300"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                    size: "large"
                }, helpCenterName))
            }, /*#__PURE__*/ $fc4bM.createElement($6fc2e594594022f0$var$Title, null, helpCenterName)), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                    size: "medium"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $J3DxC.default).checkYourEmail))
            }, /*#__PURE__*/ $fc4bM.createElement($6fc2e594594022f0$var$Subtitle, null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $J3DxC.default).checkYourEmail))), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), null, intl.formatMessage((0, $J3DxC.default).emailHasBeenSentMessage, {
                    emailAddress: email
                }))
            }, /*#__PURE__*/ $fc4bM.createElement("div", null, intl.formatMessage((0, $J3DxC.default).emailHasBeenSentMessage, {
                emailAddress: email
            }))), /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
                appearance: 'primary',
                onClick: this.onResendButtonClick,
                actionSubjectId: "returnToLogin",
                shouldFitContainer: true,
                isLoading: this.state.isSendingForgotPasswordEmail
            }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $J3DxC.default).resendResetPasswordLinkLabel)));
        };
    }
}
var $6fc2e594594022f0$export$2e2bcd8739ae039 = (0, $fcCIH.default)($6fc2e594594022f0$export$3ed80e0e31a57da);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6fc2e594594022f0$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-11c9vcd-0"
})`> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6fc2e594594022f0$var$Title = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-11c9vcd-1"
})`${(0, $imLe4.h700)};margin-bottom:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6fc2e594594022f0$var$Subtitle = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-11c9vcd-2"
})`${(0, $imLe4.h600)};`;

});
parcelRegister("1lhZ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb44fe3354781218$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $cb44fe3354781218$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    documentTitle: {
        defaultMessage: 'Customer Login - Help Center',
        description: 'Browser document title shown on the customer login page of the help center',
        id: 'cv.login.document.title'
    },
    header: {
        defaultMessage: 'Log in to {helpCenterName}',
        description: 'Heading shown at the top of the login page, where {helpCenterName} is the name of the help center',
        id: 'cv.login.header'
    },
    helpCenterLink: {
        defaultMessage: 'Go to { helpCenterName } home page',
        description: 'Text for link that redirects to the portals home page',
        id: 'cv.login.helpcenter.link'
    },
    description: {
        defaultMessage: 'Enter your email to log in or sign up',
        description: 'Description shown about the initial login screen',
        id: 'cv.login.description'
    },
    descriptionLogin: {
        defaultMessage: 'Log in to continue',
        description: 'Description shown after email check is customer login',
        id: 'cv.login.description.login'
    },
    useAtlassianAccountLogin: {
        defaultMessage: 'Use Atlassian account to log in',
        description: 'Description shown when login form is in atlassian SSO state',
        id: 'cv.login.use.atlassian.account.log.in'
    },
    useAtlassianAccountSignup: {
        defaultMessage: 'Use Atlassian account to sign up',
        description: 'Description shown when login form is in atlassian JIT state',
        id: 'cv.login.use.atlassian.account.sign.up'
    },
    backButton: {
        defaultMessage: 'Back',
        description: 'Button text for navigating back in the login screen',
        id: 'cv.login.back.button'
    },
    noLoginMethodWarningContent: {
        defaultMessage: 'Access to the help center is unavailable. Try again later or contact your admin for assistance.',
        description: 'No available login method warning content',
        id: 'cv.login.no.login.method.warning.content'
    }
});

});

parcelRegister("J3DxC", function(module, exports) {
$parcel$export(module.exports, "default", () => $90065e499287bf3e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $90065e499287bf3e$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    checkYourEmail: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Help text to tell user check their mailbox for reset password email',
        id: 'cv.login.forgot.password.check.your.email'
    },
    emailHasBeenSentMessage: {
        defaultMessage: "We've sent a reset password link to {emailAddress}",
        description: 'A help text to inform the user that email has been sent',
        id: 'cv.login.forgot.password.email.has.been.sent'
    },
    resendResetPasswordLinkLabel: {
        defaultMessage: 'Resend reset password link',
        description: 'label for Resend reset password link button',
        id: 'cv.login.forgot.password.resend.button.label'
    },
    resendSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'Success notification confirming the reset password email was sent to {emailAddress}',
        id: 'cv.login.forgot.password.resend.success.flag.message'
    }
});

});




parcelRegister("haDv7", function(module, exports) {
$parcel$export(module.exports, "LoginAnnouncement", () => (parcelRequire("efCMI")).default);

var $efCMI = parcelRequire("efCMI");

});
parcelRegister("efCMI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a6379fff802f9fb$export$2e2bcd8739ae039);

var $ebLft = parcelRequire("ebLft");

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $6LH8a = parcelRequire("6LH8a");

var $fOCtI = parcelRequire("fOCtI");

var $fJq3t = parcelRequire("fJq3t");

var $3BZyK = parcelRequire("3BZyK");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $lqPWj = parcelRequire("lqPWj");
// Since LoginAnnouncement epic is made for home page which get messages as plain text, we can't use this epic for our use case, hence we are using useLazyLoadQuery to get the data using graphql query
const $5a6379fff802f9fb$var$LoginAnnouncement = ()=>{
    var _data$helpCenter, _data$helpCenter2;
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $ebLft.default), {
        helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
        cloudId: (0, $6LH8a.getCloudId)()
    });
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') // not displaying anything if the response is not of type HelpCenter
    return null;
    // As confirmed by the backend team, there will be only one login announcement for now, hence using the first element
    const announcementDetails = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.announcements) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.loginAnnouncements) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2[0];
    const loginAnnouncementSubject = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.name) ?? '';
    const loginAnnouncementMessage = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.description) ?? '';
    const loginAnnouncementDescriptionType = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.descriptionType) ?? '';
    const isAnnouncementValid = (0, $lqPWj.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
    if (!isAnnouncementValid) // not displaying anything if the announcement is not valid or the description type is not WIKI_MARKUP
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $5a6379fff802f9fb$var$loginAnnouncementContainerStyles
    }, loginAnnouncementSubject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "small"
    }, loginAnnouncementSubject) : null, loginAnnouncementMessage && loginAnnouncementDescriptionType === 'WIKI_MARKUP' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $5a6379fff802f9fb$var$loginAnnouncementBodyStyles,
        dangerouslySetInnerHTML: {
            __html: (0, $fJq3t.sanitize)(loginAnnouncementMessage)
        }
    }) : null);
};
const $5a6379fff802f9fb$var$LoginAnnouncementLoader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).LOGIN,
        id: 'login-announcements'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($5a6379fff802f9fb$var$LoginAnnouncement, null)));
};
var $5a6379fff802f9fb$export$2e2bcd8739ae039 = $5a6379fff802f9fb$var$LoginAnnouncementLoader;
const $5a6379fff802f9fb$var$loginAnnouncementContainerStyles = (0, $kig2V.xcss)({
    marginTop: 'space.300',
    paddingBottom: 'space.200',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"}`
});
const $5a6379fff802f9fb$var$loginAnnouncementBodyStyles = (0, $kig2V.xcss)({
    marginTop: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    maxWidth: $fOCtI.multiple(42).px,
    overflowWrap: 'break-word'
});

});
parcelRegister("ebLft", function(module, exports) {
$parcel$export(module.exports, "default", () => $b607720bf9bd9eb6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d45b845761ae33b6af2ca93974f3307>>
 * @relayHash 81efd7e37c8c0c5533e02b03e01e4763
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2
const $b607720bf9bd9eb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "descriptionType"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2",
            "metadata": {},
            "name": "loginAnnouncementsCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b607720bf9bd9eb6$var$node.hash = "263cd15a061b12291f170e7431e9e440";
var $b607720bf9bd9eb6$export$2e2bcd8739ae039 = $b607720bf9bd9eb6$var$node;

});



parcelRegister("9PMVG", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => (parcelRequire("3Tlii")).default);

var $3Tlii = parcelRequire("3Tlii");

});
parcelRegister("3Tlii", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f887884b1010b10$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("9ipL7");
var $6oW6S = parcelRequire("6oW6S");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("k4bWB");
var $5OBCw = parcelRequire("5OBCw");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $hxwq4 = parcelRequire("hxwq4");
var $5f887884b1010b10$export$2e2bcd8739ae039 = (0, $6umft.default)((state)=>({
        loginAnnouncementLocale: (0, $5OBCw.getLoginAnnouncementLocale)(state),
        baseUrl: (0, $fYLlE.getBaseUrl)(state)
    }), {
    changeEmailInputAction: (0, $6oW6S.changeEmailInput),
    checkLoginActionAction: (0, $6oW6S.checkLoginAction),
    forgotPasswordAction: (0, $6oW6S.forgotPassword),
    createPasswordAction: (0, $6oW6S.createPassword),
    loginAttemptAction: (0, $6oW6S.loginAttempt),
    resetLoginAction: (0, $6oW6S.resetLogin)
})((0, $613oU.default)({
    componentName: 'loginForm'
})((0, $azARG.default)()((0, $hxwq4.LoginForm))));

});
parcelRegister("hxwq4", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => $3c1f5cbd1554252b$export$1f58f750f20f344b);

var $fc4bM = parcelRequire("fc4bM");

var $5W771 = parcelRequire("5W771");

var $hN5YJ = parcelRequire("hN5YJ");

var $epDUQ = parcelRequire("epDUQ");

var $fhYB5 = parcelRequire("fhYB5");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $gioQl = parcelRequire("gioQl");

var $gioQl = parcelRequire("gioQl");
parcelRequire("YR49s");
var $5x7Bf = parcelRequire("5x7Bf");

var $e9GZ6 = parcelRequire("e9GZ6");
// eslint-disable-next-line no-useless-escape
const $3c1f5cbd1554252b$var$EMAIL_PATTERN = /.+\@.+\..+/;
class $3c1f5cbd1554252b$export$1f58f750f20f344b extends $fc4bM.Component {
    buildAuthDataRequest() {
        const isInIframe = window.self !== window.top;
        const { destination: destination, isAbsolute: isAbsolute } = (0, $gioQl.parseLoginSignupRedirectUrlParams)();
        const prefix = destination && isAbsolute ? '' : `${(0, $diqlM.getBaseName)()}/`;
        const redirectUrl = `${prefix}${destination || this.getDefaultDestination()}`;
        const params = new URLSearchParams((0, $esgVk.search)());
        return isInIframe && (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? {
            ssoTest: (0, $gioQl.getSsoTestModeParamFromUrl)(params),
            redirectTo: '/servicedesk/customer/embeds/login-success',
            absoluteRedirectUrl: false
        } : {
            ssoTest: (0, $gioQl.getSsoTestModeParamFromUrl)(params),
            redirectTo: redirectUrl,
            absoluteRedirectUrl: isAbsolute
        };
    }
    render() {
        var _loginUIState$loginAt;
        const { canResetPassword: canResetPassword, loginUIState: loginUIState, contactAdminLink: contactAdminLink, loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        const { validEmail: validEmail, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit, password: password } = this.state;
        return /*#__PURE__*/ $fc4bM.createElement((0, $5x7Bf.default), {
            isSubmitting: loginUIState.isSubmitting,
            isSendingForgotPasswordEmail: loginUIState.isSendingForgotPasswordEmail,
            isSendingCreatePasswordEmail: loginUIState.isSendingCreatePasswordEmail,
            onSubmit: this.onSubmit,
            onEmailFieldChange: this.onEmailFieldChange,
            onPasswordChange: this.onPasswordChange,
            validEmail: validEmail,
            isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit,
            email: loginUIState.email,
            password: password,
            loginError: this.getLoginError(),
            atlassianAccountCheckPerformed: loginUIState.atlassianAccountCheckPerformed,
            loginFailure: (_loginUIState$loginAt = loginUIState.loginAttemptResponse) === null || _loginUIState$loginAt === void 0 ? void 0 : _loginUIState$loginAt.error,
            showLoginConsentError: loginUIState.showLoginConsentErrorPage,
            createAnalyticsEvent: this.props.createAnalyticsEvent,
            onEmailFieldFocus: this.onEmailFieldFocus,
            onForgotPasswordLinkClick: this.onForgotPasswordLinkClick,
            onCreatePasswordLinkClick: this.onCreatePasswordLinkClick,
            contactAdminLink: contactAdminLink,
            canResetPassword: canResetPassword,
            loginAnnouncementLocale: loginAnnouncementLocale
        });
    }
    constructor(...args){
        super(...args), this.state = {
            password: '',
            validEmail: true,
            isPasswordEmptyOnSubmit: false
        }, this.onEmailFieldChange = (email)=>{
            this.props.changeEmailInputAction(email);
        }, this.onEmailFieldFocus = ()=>{
            if (!this.props.loginUIState.email) this.props.resetLoginAction(this.props.loginUIState.email);
        }, this.onPasswordChange = (password)=>{
            this.setState({
                password: password
            });
        }, this.validateEmail = ()=>{
            const validEmail = $3c1f5cbd1554252b$var$EMAIL_PATTERN.test(this.props.loginUIState.email);
            this.setState({
                validEmail: validEmail
            });
            return validEmail;
        }, this.onSubmit = ()=>{
            if (this.validateEmail()) {
                const { loginUIState: loginUIState, loginAttemptAction: loginAttemptAction, checkLoginActionAction: checkLoginActionAction, createAnalyticsEvent: createAnalyticsEvent, continueParam: continueParam } = this.props;
                const authData = this.buildAuthDataRequest();
                const { password: password } = this.state;
                if (loginUIState.atlassianAccountCheckPerformed) {
                    const isPasswordEmptyOnSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($5W771)))(password);
                    this.setState({
                        isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit
                    });
                    if (!isPasswordEmptyOnSubmit) loginAttemptAction({
                        password: password,
                        continueParam: continueParam,
                        email: loginUIState.email.trim()
                    });
                } else checkLoginActionAction(loginUIState.email.trim(), this.props.portalId, authData, createAnalyticsEvent);
            } else (0, $fhYB5.focus)('user-email');
        }, this.getDefaultDestination = ()=>{
            const { portalId: portalId } = this.props;
            if (portalId) return `portal/${portalId}`;
            return 'portals';
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $gioQl.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onForgotPasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, forgotPasswordAction: forgotPasswordAction, resetUrl: resetUrl, baseUrl: baseUrl } = this.props;
            const redirectUrl = this.getRedirectUrl(baseUrl);
            forgotPasswordAction(resetUrl, loginUIState.email.trim(), redirectUrl);
        }, this.onCreatePasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, createPasswordAction: createPasswordAction, resetUrl: resetUrl } = this.props;
            createPasswordAction(resetUrl, loginUIState.email.trim());
        }, this.getLoginError = ()=>{
            const { error: error, loginAttemptResponse: loginAttemptResponse } = this.props.loginUIState;
            if (error) return error.description;
            const loginFailure = loginAttemptResponse === null || loginAttemptResponse === void 0 ? void 0 : loginAttemptResponse.error;
            if (loginFailure) switch(loginFailure.errorType){
                case (0, $epDUQ.LoginAttemptErrorType).INVALID_CREDENTIALS:
                    return (0, $e9GZ6.default).invalidLogin;
                case (0, $epDUQ.LoginAttemptErrorType).ACCOUNT_LOCKED_ERROR:
                    return (0, $e9GZ6.default).accountLocked;
                case (0, $epDUQ.LoginAttemptErrorType).MISC_LOGIN_ERROR:
                default:
                    return (0, $e9GZ6.default).miscLoginError;
            }
            return undefined;
        };
    }
}

});
parcelRegister("YR49s", function(module, exports) {
$parcel$export(module.exports, "LoginFormStateless", () => (parcelRequire("5x7Bf")).default);

var $5x7Bf = parcelRequire("5x7Bf");

});
parcelRegister("5x7Bf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a7685754c31b25b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $iK1uY = parcelRequire("iK1uY");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");

var $epDUQ = parcelRequire("epDUQ");
parcelRequire("5B9nk");
var $gQFhc = parcelRequire("gQFhc");
parcelRequire("ch1yB");
var $evcLx = parcelRequire("evcLx");
parcelRequire("2N4Ib");
var $cuTR5 = parcelRequire("cuTR5");
parcelRequire("fkMK1");
var $dEDTq = parcelRequire("dEDTq");

var $3TJLC = parcelRequire("3TJLC");

var $4T8rw = parcelRequire("4T8rw");

var $dtvmL = parcelRequire("dtvmL");

var $eENmG = parcelRequire("eENmG");

var $lvRbB = parcelRequire("lvRbB");

var $fhYB5 = parcelRequire("fhYB5");

var $6Pd4T = parcelRequire("6Pd4T");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $aipaD = parcelRequire("aipaD");
const $8a7685754c31b25b$var$USER_EMAIL_ID = 'user-email';
const $8a7685754c31b25b$var$SUBMIT_BUTTON_ID = 'login-button';
const $8a7685754c31b25b$var$USER_PASSWORD_ID = 'user-password';
class $8a7685754c31b25b$export$464b5747f72597dd extends $fc4bM.Component {
    getForm() {
        return /*#__PURE__*/ $fc4bM.createElement($8a7685754c31b25b$var$Form, {
            id: "login-form",
            "data-testid": "login-form",
            onSubmit: this.onSubmit
        }, this.getLoginError(), this.getLoginConsentError(), this.getEmailField(), this.getPasswordField(), this.getSubmitButton());
    }
    render() {
        const { loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: loginAnnouncementLocale ? {
                attributes: {
                    loginAnnouncementLocale: loginAnnouncementLocale
                }
            } : {}
        }, this.getForm(), this.getForgotPasswordLink(), this.getSetPasswordLink(), /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null));
    }
    constructor(...args){
        super(...args), this.onSubmit = (event)=>{
            if (event) event.preventDefault();
            // We need to do this here in order to work on chrome. Calling this method on password field focus
            // had no effect.
            this.blurEmailFieldAndFocusSubmitButton();
            this.cleanErrorCodeFromParams();
            this.props.onSubmit();
        }, this.blurEmailFieldAndFocusSubmitButton = ()=>{
            /*
     * We need to blur the email field this way because when typing an email clicking the submit button after (for checking atlassian account)
     * does not blur the email field on Chrome and Edge. So after clicking the button it looks like the email and password field have the focus.
     * There is no way to reference the html element on @atlaskit/textfield that's why we use document.getElementById .
     */ (0, $fhYB5.blur)($8a7685754c31b25b$var$USER_EMAIL_ID);
            /*
     * In order to create an understandable focus state on errors (and it will be the same one when using keyboard or clicking the button)
     * we need to focus the button after calling blur on the email text field.
     */ (0, $fhYB5.focus)($8a7685754c31b25b$var$SUBMIT_BUTTON_ID);
        }, this.cleanErrorCodeFromParams = ()=>{
            const params = new URLSearchParams((0, $esgVk.search)());
            if (params.has('error_code')) {
                params.delete('error_code');
                (0, $diqlM.default).replace({
                    search: params.toString()
                });
            }
        }, this.onEmailFieldChange = (_, email)=>{
            this.props.onEmailFieldChange(email);
        }, this.onPasswordChange = (password)=>{
            this.props.onPasswordChange(password);
        }, this.getEmailErrorMessage = ()=>{
            if (this.props.validEmail) return undefined;
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $aipaD.default).invalidEmailError);
        }, this.getPasswordErrorMessage = ()=>{
            const { intl: intl } = this.props;
            if (this.props.isPasswordEmptyOnSubmit) return intl.formatMessage((0, $aipaD.default).emptyPasswordError);
            return intl.formatMessage((0, $aipaD.default).incorrectPasswordError);
        }, this.getPasswordField = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, password: password, intl: intl, loginFailure: loginFailure, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit } = this.props;
            if (atlassianAccountCheckPerformed) {
                const isInvalid = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) === (0, $epDUQ.LoginAttemptErrorType).INVALID_CREDENTIALS || isPasswordEmptyOnSubmit;
                const passwordLabelAndPlaceholder = intl.formatMessage((0, $aipaD.default).passwordLabelAndPlaceholder);
                return /*#__PURE__*/ $fc4bM.createElement((0, $evcLx.default), {
                    label: passwordLabelAndPlaceholder,
                    htmlFor: $8a7685754c31b25b$var$USER_PASSWORD_ID
                }, /*#__PURE__*/ $fc4bM.createElement((0, $dEDTq.default), {
                    id: $8a7685754c31b25b$var$USER_PASSWORD_ID,
                    testId: $8a7685754c31b25b$var$USER_PASSWORD_ID,
                    value: password,
                    onChange: this.onPasswordChange,
                    isDisabled: isSubmitting || isSendingForgotPasswordEmail,
                    errorMessage: this.getPasswordErrorMessage(),
                    isInvalid: isInvalid,
                    hideStrengthMeter: true,
                    autoFocus: true
                }));
            }
            return undefined;
        }, this.getButtonText = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, intl: intl } = this.props;
            if (!atlassianAccountCheckPerformed) return intl.formatMessage((0, $aipaD.default).nextButton);
            return intl.formatMessage((0, $aipaD.default).continueButton);
        }, this.getSetPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onCreatePasswordLinkClick: onCreatePasswordLinkClick, isSubmitting: isSubmitting, isSendingCreatePasswordEmail: isSendingCreatePasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword && onCreatePasswordLinkClick) return /*#__PURE__*/ $fc4bM.createElement($8a7685754c31b25b$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $fc4bM.createElement("div", null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $aipaD.default).dontHavePasswordText)), /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
                id: "set-password-link",
                testId: "set-password-link",
                appearance: "link",
                onClick: onCreatePasswordLinkClick,
                actionSubjectId: "createPassword",
                isDisabled: isSubmitting,
                isLoading: isSendingCreatePasswordEmail
            }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $aipaD.default).createPasswordLink)));
            return undefined;
        }, this.getForgotPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onForgotPasswordLinkClick: onForgotPasswordLinkClick, intl: intl, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword) {
                const linkText = intl.formatMessage((0, $aipaD.default).resetPasswordLink);
                return /*#__PURE__*/ $fc4bM.createElement($8a7685754c31b25b$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
                    id: "forgot-password-link",
                    testId: "forgot-password-link",
                    appearance: "link",
                    onClick: onForgotPasswordLinkClick,
                    actionSubjectId: "forgotPassword",
                    isDisabled: isSubmitting,
                    isLoading: isSendingForgotPasswordEmail
                }, linkText));
            }
            return undefined;
        }, this.getLoginError = ()=>{
            return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, this.getErrorFromParams(), this.getLoginErrorOnSubmitting());
        }, this.getLoginConsentError = ()=>{
            if (this.props.showLoginConsentError) {
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                createAnalyticsEvent && createAnalyticsEvent({
                    analyticsType: (0, $eENmG.UI_EVENT_TYPE),
                    action: 'viewed',
                    actionSubjectId: `showConsentError`
                }).fire();
                return /*#__PURE__*/ $fc4bM.createElement((0, $dtvmL.default), {
                    appearance: "warning",
                    testId: "login-consent-error"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $aipaD.default).loginConsentErrorMessage));
            }
            return undefined;
        }, this.getLoginErrorOnSubmitting = ()=>{
            const { intl: intl, loginError: loginError, loginFailure: loginFailure, contactAdminLink: contactAdminLink } = this.props;
            const notInvalidCredentials = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) !== (0, $epDUQ.LoginAttemptErrorType).INVALID_CREDENTIALS;
            if (loginError && notInvalidCredentials) return /*#__PURE__*/ $fc4bM.createElement("div", {
                "aria-live": "assertive",
                role: "alert"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $dtvmL.default), {
                appearance: "error",
                testId: "login-error-on-submit-section"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
                ...loginError,
                values: {
                    contactAdminLink: /*#__PURE__*/ $fc4bM.createElement($8a7685754c31b25b$export$8ffc1cb9f69665da, {
                        dangerouslySetInnerHTML: {
                            __html: contactAdminLink
                        }
                    }),
                    forgotPasswordLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                    /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                        migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), {
                            weight: "semibold"
                        }, intl.formatMessage((0, $aipaD.default).resetPasswordLinkInlineBold))
                    }, /*#__PURE__*/ $fc4bM.createElement("strong", null, intl.formatMessage((0, $aipaD.default).resetPasswordLinkInlineBold)))
                }
            })));
            return undefined;
        }, this.getErrorFromParams = ()=>{
            const { intl: intl } = this.props;
            const params = new URLSearchParams((0, $esgVk.search)());
            const errorCode = params.get('error_code');
            if (errorCode) {
                const errorMessage = errorCode === 'access_denied' ? intl.formatMessage((0, $aipaD.default).accessDeniedErrorCodeMessage) : intl.formatMessage((0, $aipaD.default).defaultErrorCodeMessage);
                return /*#__PURE__*/ $fc4bM.createElement((0, $dtvmL.default), {
                    appearance: "error"
                }, errorMessage);
            }
            return undefined;
        }, this.getEmailField = ()=>{
            const { intl: intl, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, email: email, onEmailFieldFocus: onEmailFieldFocus } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement((0, $gQFhc.default), {
                name: 'login-email-field'
            }, /*#__PURE__*/ $fc4bM.createElement((0, $cuTR5.default), {
                id: $8a7685754c31b25b$var$USER_EMAIL_ID,
                shouldFitContainer: true,
                label: intl.formatMessage((0, $aipaD.default).emailLabel),
                onChange: this.onEmailFieldChange,
                errorMessage: this.getEmailErrorMessage(),
                ariaDescribedby: "field-error",
                disabled: isSubmitting || isSendingForgotPasswordEmail || atlassianAccountCheckPerformed,
                defaultValue: email,
                onFocus: onEmailFieldFocus,
                autoComplete: "email",
                autoFocus: !this.props.showLoginConsentError
            }));
        }, this.getSubmitButton = ()=>{
            const { isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed } = this.props;
            const buttonText = this.getButtonText();
            const buttonActionSubjectId = atlassianAccountCheckPerformed ? 'submitLoginForm' : 'checkLoginEmail';
            return /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
                id: $8a7685754c31b25b$var$SUBMIT_BUTTON_ID,
                testId: $8a7685754c31b25b$var$SUBMIT_BUTTON_ID,
                type: "submit",
                appearance: "primary",
                shouldFitContainer: true,
                isLoading: isSubmitting,
                isDisabled: isSendingForgotPasswordEmail,
                actionSubjectId: buttonActionSubjectId
            }, buttonText);
        };
    }
}
var $8a7685754c31b25b$export$2e2bcd8739ae039 = (0, $fcCIH.default)($8a7685754c31b25b$export$464b5747f72597dd);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8a7685754c31b25b$var$Form = /*#__PURE__*/ (0, $luz1X.default).form.withConfig({
    componentId: "sc-1wf191w-0"
})`#login-button{margin-top:${"var(--ds-space-300, 24px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8a7685754c31b25b$var$ForgotPasswordLinkContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1wf191w-1"
})`margin-top:${"var(--ds-space-300, 24px)"};text-align:center;`;
const $8a7685754c31b25b$export$8ffc1cb9f69665da = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1wf191w-2"
})`display:inline;`;

});
parcelRegister("5B9nk", function(module, exports) {
$parcel$export(module.exports, "DisableViewUntilMount", () => (parcelRequire("gQFhc")).default);

var $gQFhc = parcelRequire("gQFhc");

});
parcelRegister("gQFhc", function(module, exports) {
$parcel$export(module.exports, "default", () => $f309ab40041c7582$export$2e2bcd8739ae039);
/* disable-view-until-mount.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $f309ab40041c7582$var$DisableViewUntilMount = ({ children: children, name: name })=>{
    const componentPointerCssVar = `--pointer-events-${name}`;
    $fc4bM.useEffect(()=>{
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty(componentPointerCssVar, 'none');
    }, [
        componentPointerCssVar
    ]);
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-testid": `disable-view-until-mount`,
        className: (0, $2R2iS.default)([
            "_1bsb1osq"
        ])
    }, children, /*#__PURE__*/ $fc4bM.createElement("div", {
        style: {
            // @ts-ignore // because we want to use a dynamic css variable
            pointerEvents: `var(${componentPointerCssVar}, auto)`
        },
        className: (0, $2R2iS.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _154iidpf _1ltvidpf _80omv00u"
        ])
    }));
};
var $f309ab40041c7582$export$2e2bcd8739ae039 = $f309ab40041c7582$var$DisableViewUntilMount;
const $f309ab40041c7582$var$componentWrapper = null;
const $f309ab40041c7582$var$loaderWrapper = null;

});


parcelRegister("ch1yB", function(module, exports) {
$parcel$export(module.exports, "FieldBase", () => (parcelRequire("evcLx")).default);

var $evcLx = parcelRequire("evcLx");

});
parcelRegister("evcLx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d554e6eb1e527d9$export$2e2bcd8739ae039);
/* field-base.tsx generated by @compiled/babel-plugin v3.0.2 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $c4WgE = parcelRequire("c4WgE");

var $9Zxa0 = parcelRequire("9Zxa0");

var $gDsF8 = parcelRequire("gDsF8");

var $k8Adr = parcelRequire("k8Adr");

var $6Pd4T = parcelRequire("6Pd4T");
parcelRequire("4mlxQ");
var $8gSZb = parcelRequire("8gSZb");
const $6d554e6eb1e527d9$var$FieldBase = ({ label: label, labelId: labelId, required: required, errorMessage: errorMessage, description: description, children: children, noLabel: noLabel, htmlFor: htmlFor, tooltip: tooltip })=>{
    const isCSMTypographyMigrationEnabled = (0, $6Pd4T.useIsCSMTypographyMigrationEnabled)();
    const renderField = ()=>noLabel ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($6d554e6eb1e527d9$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c4WgE.Label), {
            htmlFor: htmlFor,
            id: labelId
        }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Zxa0.RequiredAsterisk), null), isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            className: (0, $2R2iS.default)([
                "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), null, "(required)")) : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($6d554e6eb1e527d9$var$RequiredMessage, null, "(required)")), tooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, tooltip))), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-test-id": `request-field-${htmlFor}`
    }, renderField(), !!errorMessage && (isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            "_19pk1b66 _syaz1tmw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        size: "small",
        color: "color.text.danger",
        testId: "field-error-text",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($6d554e6eb1e527d9$var$ErrorText, {
        "data-test-id": "field-error",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage))), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8gSZb.default), {
        id: `${htmlFor}-field-description`
    }, description));
};
var $6d554e6eb1e527d9$export$2e2bcd8739ae039 = $6d554e6eb1e527d9$var$FieldBase;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6d554e6eb1e527d9$var$ErrorText = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-1tyod05-0"
})`${$imLe4.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6d554e6eb1e527d9$var$FieldContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_19pkpxbi _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $6d554e6eb1e527d9$var$errorIconWrapperCSS = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6d554e6eb1e527d9$var$RequiredMessage = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug",
            __cmplp.className
        ])
    });
});
const $6d554e6eb1e527d9$var$requireMessageCSS = null;
const $6d554e6eb1e527d9$var$errorMessageCSS = null;

});
parcelRegister("4mlxQ", function(module, exports) {
$parcel$export(module.exports, "FieldDescription", () => (parcelRequire("8gSZb")).default);

var $8gSZb = parcelRequire("8gSZb");

});
parcelRegister("8gSZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $808c50c1471f96d9$export$2e2bcd8739ae039);
/* field-description.tsx generated by @compiled/babel-plugin v3.0.2 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $25eLu = parcelRequire("25eLu");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $fcCIH = parcelRequire("fcCIH");

var $5tbyV = parcelRequire("5tbyV");

var $k2M4v = parcelRequire("k2M4v");

var $k8Adr = parcelRequire("k8Adr");

var $4gVCP = parcelRequire("4gVCP");

var $fhYB5 = parcelRequire("fhYB5");

var $6Pd4T = parcelRequire("6Pd4T");

var $jIk0d = parcelRequire("jIk0d");
class $808c50c1471f96d9$export$873ced4623a3149c extends $fc4bM.PureComponent {
    componentDidMount() {
        this.checkIfShouldCollapse();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) this.checkIfShouldCollapse();
    }
    render() {
        const { intl: intl } = this.props;
        const { shouldCollapse: shouldCollapse, isOpen: isOpen } = this.state;
        const removeWidthObserver = (0, $k2M4v.default).checkGate('remove_widthobserver_from_field_description');
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, removeWidthObserver ? null : /*#__PURE__*/ $fc4bM.createElement((0, $4gVCP.WidthObserver), {
            setWidth: this.checkIfShouldCollapse
        }), shouldCollapse ? /*#__PURE__*/ $fc4bM.createElement($808c50c1471f96d9$export$b7e78554be83b35d, {
            onClick: this.onToggle
        }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tbyV))), {
            expanded: isOpen,
            collapsedHeight: `${$808c50c1471f96d9$export$4ea46454a0bad5c3}px`
        }, this.renderHelpText()), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $fc4bM.createElement("div", {
                className: (0, $2R2iS.default)([
                    "_syaz131l"
                ])
            }, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
                size: "small",
                color: "color.text.subtlest",
                weight: "medium"
            }, intl.formatMessage(isOpen ? (0, $jIk0d.default).showLess : (0, $jIk0d.default).showMore)))
        }, /*#__PURE__*/ $fc4bM.createElement($808c50c1471f96d9$export$5f734e3a73651e57, null, intl.formatMessage(isOpen ? (0, $jIk0d.default).showLess : (0, $jIk0d.default).showMore)))) : this.renderHelpText());
    }
    constructor(...args){
        super(...args), this.state = {
            shouldCollapse: false,
            isOpen: false
        }, this.helpTextRef = /*#__PURE__*/ $fc4bM.createRef(), this.checkIfShouldCollapse = ()=>{
            if (this.helpTextRef.current && (0, $fhYB5.getElementHeight)(this.helpTextRef.current) > $808c50c1471f96d9$export$4ea46454a0bad5c3) this.setState({
                shouldCollapse: true
            });
            else if (this.state.shouldCollapse) this.setState({
                shouldCollapse: false
            });
        }, this.onToggle = (e)=>{
            e.preventDefault();
            this.setState((prevState)=>({
                    isOpen: !prevState.isOpen
                }));
        }, this.renderHelpText = ()=>{
            const { children: children, id: id } = this.props;
            if (typeof children === 'string') return /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement($808c50c1471f96d9$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef,
                    dangerouslySetInnerHTML: {
                        __html: children
                    }
                })
            }, /*#__PURE__*/ $fc4bM.createElement($808c50c1471f96d9$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef,
                dangerouslySetInnerHTML: {
                    __html: children
                }
            }));
            return /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement($808c50c1471f96d9$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef
                }, children)
            }, /*#__PURE__*/ $fc4bM.createElement($808c50c1471f96d9$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef
            }, children));
        };
    }
}
var $808c50c1471f96d9$export$2e2bcd8739ae039 = (0, $fcCIH.default)($808c50c1471f96d9$export$873ced4623a3149c);
const $808c50c1471f96d9$export$a67c0bc59081311a = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-mimyi-0"
})`${$imLe4.xsmall};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $808c50c1471f96d9$export$29708599cbdda103 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-mimyi-1"
})`font:${"var(--ds-font-heading-xsmall, normal 600 0.875rem/1rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $808c50c1471f96d9$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-mimyi-2"
})`${$imLe4.xsmall};color:${"var(--ds-text-subtlest, #6B778C)"};font-weight:500;`;
const $808c50c1471f96d9$var$buttonTextCSS = null;
const $808c50c1471f96d9$export$b7e78554be83b35d = /*#__PURE__*/ (0, $luz1X.default)((0, $25eLu.default)).withConfig({
    componentId: "sc-mimyi-3"
})`display:block;`;
const $808c50c1471f96d9$export$4ea46454a0bad5c3 = $fOCtI.multiple(4.5).unitless;

});
parcelRegister("5tbyV", function(module, exports) {
"use strict";

var $j3tQw = parcelRequire("j3tQw");

var $9fQWM = parcelRequire("9fQWM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3fb8a1374cd3b6b3$var$_objectWithoutProperties2 = $j3tQw((parcelRequire("XbQF0")));

var $3fb8a1374cd3b6b3$var$_classCallCheck2 = $j3tQw((parcelRequire("45UVS")));

var $3fb8a1374cd3b6b3$var$_createClass2 = $j3tQw((parcelRequire("3dy9s")));

var $3fb8a1374cd3b6b3$var$_assertThisInitialized2 = $j3tQw((parcelRequire("fGR3n")));

var $3fb8a1374cd3b6b3$var$_inherits2 = $j3tQw((parcelRequire("lbZ4p")));

var $3fb8a1374cd3b6b3$var$_possibleConstructorReturn2 = $j3tQw((parcelRequire("fqtX3")));

var $3fb8a1374cd3b6b3$var$_getPrototypeOf2 = $j3tQw((parcelRequire("dDVSt")));

var $3fb8a1374cd3b6b3$var$_defineProperty2 = $j3tQw((parcelRequire("geBXM")));

var $3fb8a1374cd3b6b3$var$React = $3fb8a1374cd3b6b3$var$_interopRequireWildcard((parcelRequire("fc4bM")));

var $3fb8a1374cd3b6b3$var$_propTypes = $j3tQw((parcelRequire("dso8W")));

var $3fb8a1374cd3b6b3$var$_getTransitionTimeMs = $j3tQw((parcelRequire("8B1nO")));

var $3LM7S = parcelRequire("3LM7S");
var $3fb8a1374cd3b6b3$var$_excluded = [
    "allowOverflowWhenOpen",
    "children",
    "collapsedHeight",
    "eagerRender",
    "expanded",
    "heightTransition",
    "onChangeEnd"
];
function $3fb8a1374cd3b6b3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3fb8a1374cd3b6b3$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3fb8a1374cd3b6b3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9fQWM(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $3fb8a1374cd3b6b3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3fb8a1374cd3b6b3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3fb8a1374cd3b6b3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3fb8a1374cd3b6b3$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3fb8a1374cd3b6b3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3fb8a1374cd3b6b3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3fb8a1374cd3b6b3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $3fb8a1374cd3b6b3$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $3fb8a1374cd3b6b3$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $3fb8a1374cd3b6b3$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $3fb8a1374cd3b6b3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3fb8a1374cd3b6b3$var$SmoothCollapse = /*#__PURE__*/ function(_React$Component) {
    (0, $3fb8a1374cd3b6b3$var$_inherits2["default"])(SmoothCollapse, _React$Component);
    var _super = $3fb8a1374cd3b6b3$var$_createSuper(SmoothCollapse);
    function SmoothCollapse(props) {
        var _this;
        (0, $3fb8a1374cd3b6b3$var$_classCallCheck2["default"])(this, SmoothCollapse);
        _this = _super.call(this, props);
        (0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])((0, $3fb8a1374cd3b6b3$var$_assertThisInitialized2["default"])(_this), "_removeTransitionEndListener", function() {});
        (0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])((0, $3fb8a1374cd3b6b3$var$_assertThisInitialized2["default"])(_this), "_main", /*#__PURE__*/ $3fb8a1374cd3b6b3$var$React.createRef());
        (0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])((0, $3fb8a1374cd3b6b3$var$_assertThisInitialized2["default"])(_this), "_inner", /*#__PURE__*/ $3fb8a1374cd3b6b3$var$React.createRef());
        (0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])((0, $3fb8a1374cd3b6b3$var$_assertThisInitialized2["default"])(_this), "_onNextTransitionEnd", function(el, callback) {
            _this._removeTransitionEndListener();
            var listener = function listener() {
                _this._removeTransitionEndListener();
                callback();
            };
            var timeout;
            _this._removeTransitionEndListener = function() {
                _this._removeTransitionEndListener = function() {};
                clearTimeout(timeout);
                el.removeEventListener('transitionend', listener);
            }; // Wait until the transitionend event, or until a timer goes off in
            // case the event doesn't fire because the browser doesn't support it
            // or the element is hidden before it happens. The timer is a little
            // longer than the transition is supposed to take to make sure we don't
            // cut the animation early while it's still going if the browser is
            // running it just a little slow.
            el.addEventListener('transitionend', listener);
            var ms = (0, $3fb8a1374cd3b6b3$var$_getTransitionTimeMs["default"])(_this.props.heightTransition) * 1.1 + 500;
            timeout = setTimeout(listener, ms);
        });
        _this.state = {
            renderInner: props.expanded || SmoothCollapse._visibleWhenClosed(props),
            closing: false,
            fullyClosed: !props.expanded,
            height: props.expanded ? 'auto' : props.collapsedHeight
        };
        return _this;
    }
    (0, $3fb8a1374cd3b6b3$var$_createClass2["default"])(SmoothCollapse, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._removeTransitionEndListener();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                if (!prevProps.expanded && this.props.expanded) {
                    this._removeTransitionEndListener();
                    var mainEl = this._main.current;
                    var innerEl = this._inner.current;
                    if (!mainEl || !innerEl) throw new Error('Should not happen'); // Set the collapser to the target height instead of auto so that it
                    // animates correctly. Then switch it to 'auto' after the animation so
                    // that it flows correctly if the page is resized.
                    var targetHeight = "".concat(innerEl.clientHeight, "px");
                    this.setState({
                        height: targetHeight
                    });
                    this._onNextTransitionEnd(mainEl, function() {
                        _this2.setState({
                            height: 'auto'
                        }, function() {
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                } else if (prevProps.expanded && !this.props.expanded) {
                    this._removeTransitionEndListener();
                    if (!this._inner.current) throw new Error('Should not happen');
                    this.setState({
                        height: "".concat(this._inner.current.clientHeight, "px")
                    }, function() {
                        var mainEl = _this2._main.current;
                        if (!mainEl) throw new Error('Should not happen');
                        mainEl.clientHeight; // force the page layout
                        _this2.setState({
                            height: _this2.props.collapsedHeight,
                            closing: true
                        });
                        _this2._onNextTransitionEnd(mainEl, function() {
                            _this2.setState({
                                closing: false,
                                fullyClosed: true
                            });
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var visibleWhenClosed = SmoothCollapse._visibleWhenClosed(this.props);
                var _this$props = this.props, allowOverflowWhenOpen = _this$props.allowOverflowWhenOpen, children = _this$props.children, collapsedHeight = _this$props.collapsedHeight, eagerRender = _this$props.eagerRender, expanded = _this$props.expanded, heightTransition = _this$props.heightTransition, onChangeEnd = _this$props.onChangeEnd, props = (0, $3fb8a1374cd3b6b3$var$_objectWithoutProperties2["default"])(_this$props, $3fb8a1374cd3b6b3$var$_excluded);
                var _this$state = this.state, height = _this$state.height, fullyClosed = _this$state.fullyClosed, renderInner = _this$state.renderInner;
                var innerEl = renderInner ? /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    ref: this._inner,
                    style: {
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden'
                    },
                    children: children
                }) : null;
                return /*#__PURE__*/ (0, $3LM7S.jsx)("div", $3fb8a1374cd3b6b3$var$_objectSpread($3fb8a1374cd3b6b3$var$_objectSpread({}, props), {}, {
                    ref: this._main,
                    style: {
                        height: height,
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden',
                        display: fullyClosed && !visibleWhenClosed ? 'none' : null,
                        transition: "height ".concat(heightTransition)
                    },
                    children: innerEl
                }));
            }
        }
    ], [
        {
            key: "_visibleWhenClosed",
            value: function _visibleWhenClosed(props) {
                return props.eagerRender || parseFloat(props.collapsedHeight) !== 0;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (props.expanded && (state.closing || state.fullyClosed)) return {
                    closing: false,
                    fullyClosed: false,
                    renderInner: true
                };
                else if (!props.expanded && (state.closing || state.fullyClosed) && state.height !== props.collapsedHeight) return {
                    height: props.collapsedHeight,
                    renderInner: state.renderInner || SmoothCollapse._visibleWhenClosed(props)
                };
                return null;
            }
        }
    ]);
    return SmoothCollapse;
}($3fb8a1374cd3b6b3$var$React.Component);
module.exports["default"] = $3fb8a1374cd3b6b3$var$SmoothCollapse;
(0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])($3fb8a1374cd3b6b3$var$SmoothCollapse, "propTypes", {
    expanded: $3fb8a1374cd3b6b3$var$_propTypes["default"].bool.isRequired,
    onChangeEnd: $3fb8a1374cd3b6b3$var$_propTypes["default"].func,
    collapsedHeight: $3fb8a1374cd3b6b3$var$_propTypes["default"].string,
    heightTransition: $3fb8a1374cd3b6b3$var$_propTypes["default"].string,
    className: $3fb8a1374cd3b6b3$var$_propTypes["default"].string,
    allowOverflowWhenOpen: $3fb8a1374cd3b6b3$var$_propTypes["default"].bool,
    eagerRender: $3fb8a1374cd3b6b3$var$_propTypes["default"].bool
});
(0, $3fb8a1374cd3b6b3$var$_defineProperty2["default"])($3fb8a1374cd3b6b3$var$SmoothCollapse, "defaultProps", {
    collapsedHeight: '0',
    heightTransition: '.25s ease',
    className: '',
    allowOverflowWhenOpen: false,
    eagerRender: false
});

});
parcelRegister("XbQF0", function(module, exports) {

var $6Mx0E = parcelRequire("6Mx0E");
function $0b1eb3a40b6c8f7a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6Mx0E(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $0b1eb3a40b6c8f7a$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("45UVS", function(module, exports) {
function $2fb3caa58169b688$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $2fb3caa58169b688$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3dy9s", function(module, exports) {

var $gvBRV = parcelRequire("gvBRV");
function $257d13c86a258538$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $gvBRV(o.key), o);
    }
}
function $257d13c86a258538$var$_createClass(e, r, t) {
    return r && $257d13c86a258538$var$_defineProperties(e.prototype, r), t && $257d13c86a258538$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $257d13c86a258538$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lbZ4p", function(module, exports) {

var $8pyts = parcelRequire("8pyts");
function $f6d9ff4bc1a11260$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $8pyts(t, e);
}
module.exports = $f6d9ff4bc1a11260$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fqtX3", function(module, exports) {

var $9fQWM = parcelRequire("9fQWM");
var $b3b0847642a9730c$var$_typeof = $9fQWM.default;

var $fGR3n = parcelRequire("fGR3n");
function $b3b0847642a9730c$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b3b0847642a9730c$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $fGR3n(t);
}
module.exports = $b3b0847642a9730c$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dDVSt", function(module, exports) {
function $9eebd02b238d6e9e$var$_getPrototypeOf(t) {
    return module.exports = $9eebd02b238d6e9e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9eebd02b238d6e9e$var$_getPrototypeOf(t);
}
module.exports = $9eebd02b238d6e9e$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8B1nO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6422da183e8dad4f$var$getTransitionTimeMs;
function $6422da183e8dad4f$var$getTransitionTimeMs(heightTransition) {
    var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
    if (!m) throw new Error('Could not parse time from transition value');
    return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}

});


parcelRegister("jIk0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bfe128b8628117a$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $6bfe128b8628117a$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    showMore: {
        defaultMessage: 'Show more...',
        description: 'Button action text to expand a form fields description',
        id: 'cv.field-base.description.show-more'
    },
    showLess: {
        defaultMessage: 'Show less...',
        description: 'Button action text to collapse a form fields description',
        id: 'cv.field-base.description.show-less'
    }
});

});





parcelRegister("2N4Ib", function(module, exports) {
$parcel$export(module.exports, "TextField", () => (parcelRequire("cuTR5")).default);
$parcel$export(module.exports, "ControlledTextField", () => (parcelRequire("cuTR5")).ControlledTextField);

var $cuTR5 = parcelRequire("cuTR5");

});
parcelRegister("cuTR5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8886aaaf7eedf7a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ControlledTextField", () => $c8886aaaf7eedf7a$export$befa4be8e9119768);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("ch1yB");
var $evcLx = parcelRequire("evcLx");

var $aEtFp = parcelRequire("aEtFp");
parcelRequire("6wHv6");
var $5leVl = parcelRequire("5leVl");
class $c8886aaaf7eedf7a$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    static #_ = this.defaultProps = {
        shouldFitContainer: true,
        type: 'text'
    };
    render() {
        const { id: id, testId: testId, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, maxLength: maxLength, disabled: disabled, render: render, placeholder: placeholder, isLabelHidden: isLabelHidden, type: type, autoFocus: autoFocus, value: value, onFocus: onFocus, onKeyDown: onKeyDown, ariaDescribedby: ariaDescribedby, autoComplete: autoComplete, ariaLabelledby: ariaLabelledby, tooltip: tooltip, isInvalid: isInvalidProp } = this.props;
        const isInvalid = isInvalidProp || !(0, $aYMdQ.isEmpty)(errorMessage);
        const inputType = type;
        /** Currently to match the legacy behavior in some cases we are passing both value and defaultValue
     * there will be a sentry alert to either use controlled or uncontrolled but not both
     * to prevent this we only pass one of value or defaultValue
     * such scenarios can be avoided once we clean the legacy code
     * when cleaning up feature flag see if this can be removed
     */ const isValueDefined = typeof value === 'string';
        const textFieldValueProps = isValueDefined ? {
            value: value
        } : {
            defaultValue: defaultValue
        };
        const ariaDescribedByText = ariaDescribedby || `${id}-field-description ${isInvalid ? 'field-error' : ''}`;
        const ariaLabelledByText = ariaLabelledby || `${id}-label`;
        const field = /*#__PURE__*/ $fc4bM.createElement((0, $aEtFp.default), {
            id: id,
            testId: testId,
            name: id,
            "aria-describedby": ariaDescribedByText,
            "aria-labelledby": ariaLabelledByText,
            "aria-invalid": isInvalid,
            "aria-required": required,
            ...textFieldValueProps,
            onChange: this.onChange,
            isInvalid: isInvalid,
            isDisabled: disabled,
            placeholder: placeholder,
            type: inputType,
            maxLength: maxLength,
            autoFocus: autoFocus,
            onFocus: onFocus,
            onBlur: this.onBlur,
            onKeyDown: onKeyDown,
            autoComplete: autoComplete
        });
        return /*#__PURE__*/ $fc4bM.createElement((0, $evcLx.default), {
            htmlFor: id,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage,
            noLabel: isLabelHidden,
            labelId: `${id}-label`,
            ...(0, $hN5YJ.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, render ? render(field) : field);
    }
    constructor(...args){
        super(...args), this.inputRef = /*#__PURE__*/ $fc4bM.createRef(), //TODO - We need to find a better way to add focus to input field when there is an error. This should be done in the form component. https://hello.jira.atlassian.cloud/browse/CHANNELSUI-258
        this.onChange = (e)=>{
            if (this.props.onChange) this.props.onChange(this.props.id, e.target.value, false, {
                rawObject: e,
                rawValue: e.target.value
            });
        }, this.onBlur = (e)=>{
            if (this.props.onFieldBlurredByUser) this.props.onFieldBlurredByUser({
                field: this.props.id,
                value: e.target.value,
                additionalFieldData: {
                    rawObject: e,
                    rawValue: e.target.value
                }
            });
            if (this.props.onBlur) this.props.onBlur();
        };
    }
}
const $c8886aaaf7eedf7a$export$befa4be8e9119768 = (0, $5leVl.withControlledFormComponentValue)((_field, value)=>value)($c8886aaaf7eedf7a$export$2e2bcd8739ae039);

});
parcelRegister("6wHv6", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => (parcelRequire("5leVl")).withControlledFormComponentValue);

var $5leVl = parcelRequire("5leVl");

});
parcelRegister("5leVl", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => $79d7867fbae8a46f$export$cd499d091f6810cd);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");

var $gYNf1 = parcelRequire("gYNf1");
function $79d7867fbae8a46f$export$cd499d091f6810cd(mapOnChangeValue, valueTransformer) {
    return (FormComponent)=>class ControlledFormComponentWrapper extends $fc4bM.PureComponent {
            static #_ = this.displayName = 'ControlledFormComponentWrapper';
            componentDidUpdate(prevProps, prevState) {
                // Handle valueOverride changes (UI Modifications)
                if (this.checkIsValueOverride() && this.props.valueOverride !== prevProps.valueOverride && this.props.valueOverride !== prevState.controlledValue) this.setState({
                    controlledValue: this.props.valueOverride
                });
                // Handle external value changes (native automation rules, form resets, etc.)
                if ((0, $hN5YJ.isMultiSelectEnabled)() && this.props.value !== prevProps.value && this.props.value !== prevState.controlledValue && !this.checkIsValueOverride()) this.setState({
                    controlledValue: this.props.value
                });
            }
            render() {
                const { defaultValue: _1, value: _2, valueOverride: _3, onChange: _4, ...remainingProps } = this.props;
                if ((0, $hN5YJ.isUiModificationsSupportEnabled)()) {
                    const transformedValue = valueTransformer ? valueTransformer(this.state.controlledValue) : this.state.controlledValue;
                    const componentProps = {
                        ...remainingProps,
                        value: transformedValue,
                        onChange: this.onChange,
                        shouldReplaceValue: this.checkIsValueOverride()
                    };
                    return /*#__PURE__*/ $fc4bM.createElement((0, $gYNf1.FieldDecoratorAsync), {
                        Component: FormComponent,
                        componentProps: componentProps
                    });
                }
                return /*#__PURE__*/ $fc4bM.createElement(FormComponent, {
                    ...remainingProps,
                    value: this.state.controlledValue,
                    onChange: this.onChange
                });
            }
            constructor(...args){
                super(...args), this.checkIsValueOverride = ()=>{
                    if (this.props.valueOverride === null || this.props.valueOverride === '' || this.props.valueOverride) return true;
                    return false;
                }, this.state = {
                    controlledValue: this.checkIsValueOverride() ? this.props.valueOverride : this.props.defaultValue
                }, this.onChange = (...args)=>{
                    var _this$props$onChange, _this$props;
                    this.setState({
                        controlledValue: mapOnChangeValue(...args)
                    });
                    (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, ...args);
                };
            }
        };
}

});
parcelRegister("gYNf1", function(module, exports) {
$parcel$export(module.exports, "FieldDecoratorAsync", () => $b4d550df3a057abf$export$7bf1fdc8d847e1ea);

var $fc4bM = parcelRequire("fc4bM");

var $5YXrV = parcelRequire("5YXrV");

var $g4H12 = parcelRequire("g4H12");

var $bfYTF = parcelRequire("bfYTF");

var $3ICRL = parcelRequire("3ICRL");
const $b4d550df3a057abf$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const isUiModificationsEnabled = (0, $g4H12.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, componentProps);
    if (!isUiModificationsEnabled) return undecoratedComponent;
    if (!(0, $5YXrV.isFieldTypeSupported)((0, $bfYTF.REQUEST_CREATE_VIEW_TYPE), componentProps.jiraFieldType ?? componentProps.id)) return undecoratedComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3ICRL.EnabledFieldDecorator), {
        componentProps: componentProps,
        Component: Component
    });
};
const $b4d550df3a057abf$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $fc4bM.memo)($b4d550df3a057abf$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("3ICRL", function(module, exports) {
$parcel$export(module.exports, "EnabledFieldDecorator", () => $20d7f228e2441110$export$a39682472306ffd4);

var $fc4bM = parcelRequire("fc4bM");

var $kzUgZ = parcelRequire("kzUgZ");

var $doFx2 = parcelRequire("doFx2");
const $20d7f228e2441110$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { id: id } = componentProps;
    const isBusy = (0, $doFx2.useFieldIsBusy)(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
        ...componentProps,
        ...isBusy ? {
            disabled: true,
            isDisabled: true,
            tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kzUgZ.FieldBusyIndicator), {
                fieldId: id
            })
        } : {}
    });
};
const $20d7f228e2441110$export$a39682472306ffd4 = /*#__PURE__*/ (0, $fc4bM.memo)($20d7f228e2441110$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("kzUgZ", function(module, exports) {
$parcel$export(module.exports, "FieldBusyIndicator", () => $c9285653eb617bc7$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $9OPbR = parcelRequire("9OPbR");

var $hculA = parcelRequire("hculA");

var $bcTS3 = parcelRequire("bcTS3");

var $53u8k = parcelRequire("53u8k");
const $c9285653eb617bc7$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $fc4bM.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const loadingMessage = formatMessage((0, $53u8k.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c9285653eb617bc7$export$4e31364808fb7483, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9OPbR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
        testId: indicatorId,
        size: "small"
    }))));
});
$c9285653eb617bc7$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $c9285653eb617bc7$export$4e31364808fb7483 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9OPbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f3b1a79c271ec26$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $97mY8 = parcelRequire("97mY8");
function $1f3b1a79c271ec26$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $97mY8.default), props);
}

});
parcelRegister("97mY8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcbc9f09d7cbbf62$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fVzQQ = parcelRequire("fVzQQ");
/**
 * Prevent a subtree from holding up an interaction
 * Use this when you have a component which loads in late, but
 * isn't considered to be a breach of SLO
 *
 * ```js
 * <App>
 *   <Main />
 *   <Sidebar>
 *     <UFOIgnoreHolds>
 *       <InsightsButton />
 *     </UFOIgnoreHolds>
 *   </Sidebar>
 * </App>
 * ```
 *
 * Has an `ignore` prop, to allow you to use it conditionally
 * Has a `reason` prop, to specify why the hold is being ignored
 */ const $fcbc9f09d7cbbf62$var$UFOIgnoreHolds = ({ children: children, ignore: ignore = true })=>{
    const parentContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    const ignoredInteractionContext = (0, $fc4bM.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fVzQQ.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
};
$fcbc9f09d7cbbf62$var$UFOIgnoreHolds.displayName = 'UFOIgnoreHolds';
var $fcbc9f09d7cbbf62$export$2e2bcd8739ae039 = $fcbc9f09d7cbbf62$var$UFOIgnoreHolds;

});


parcelRegister("53u8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $6388a04fe4f9eab5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $6388a04fe4f9eab5$var$_default_1 = (0, $8p5Cv.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});
var $6388a04fe4f9eab5$export$2e2bcd8739ae039 = $6388a04fe4f9eab5$var$_default_1;

});


parcelRegister("doFx2", function(module, exports) {
$parcel$export(module.exports, "useFieldIsBusy", () => $4430d3b5f3f86294$export$b4ae28da91c35ed4);

var $ih9LT = parcelRequire("ih9LT");

var $aN3M1 = parcelRequire("aN3M1");

var $ba4LP = parcelRequire("ba4LP");
const $4430d3b5f3f86294$export$b4ae28da91c35ed4 = (fieldId)=>{
    const [isBusyData] = (0, $ba4LP.useFieldIsProcessing)(fieldId);
    const uimConsentMap = (0, $ih9LT.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $aN3M1.UIM_CONSENT_REQUIRED));
};

});
parcelRegister("ih9LT", function(module, exports) {
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $1eb1c848e0e8b3b5$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $1eb1c848e0e8b3b5$export$2a5a8f1570c161c6);

var $g6dQg = parcelRequire("g6dQg");
var $5nVr1 = parcelRequire("5nVr1");

var $g4H12 = parcelRequire("g4H12");

var $aN3M1 = parcelRequire("aN3M1");
const $1eb1c848e0e8b3b5$var$selectOverallConsentStatus = (0, $g6dQg.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $aN3M1.UIM_CONSENT_REQUIRED)) ? (0, $aN3M1.UIM_CONSENT_REQUIRED) : (0, $aN3M1.UIM_CONSENT_CONSENTED));
const $1eb1c848e0e8b3b5$export$e2c526d2c1843a0e = (0, $5nVr1.createStateHook)((0, $g4H12.store), {
    selector: $1eb1c848e0e8b3b5$var$selectOverallConsentStatus
});
const $1eb1c848e0e8b3b5$export$7700bb22109a011e = (0, $5nVr1.createStateHook)((0, $g4H12.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $aN3M1.UIM_CONSENT_UNKNOWN)
});
const $1eb1c848e0e8b3b5$export$2a5a8f1570c161c6 = (0, $5nVr1.createStateHook)((0, $g4H12.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("aN3M1", function(module, exports) {
$parcel$export(module.exports, "UIM_CONSENT_UNKNOWN", () => $c32fa56367a99b4e$export$39d15f3568f5a72c);
$parcel$export(module.exports, "UIM_CONSENT_REQUIRED", () => $c32fa56367a99b4e$export$d67d63332ce3ce38);
$parcel$export(module.exports, "UIM_CONSENT_CONSENTED", () => $c32fa56367a99b4e$export$45ca911896c5084f);
const $c32fa56367a99b4e$export$39d15f3568f5a72c = 'unknown';
const $c32fa56367a99b4e$export$d67d63332ce3ce38 = 'required';
const $c32fa56367a99b4e$export$45ca911896c5084f = 'consented';

});


parcelRegister("ba4LP", function(module, exports) {
$parcel$export(module.exports, "useFieldIsProcessing", () => $363a97631d8da7ea$export$7fa63f8479e2806a);

var $25okM = parcelRequire("25okM");

var $5nVr1 = parcelRequire("5nVr1");
var $g6dQg = parcelRequire("g6dQg");

var $kzQWi = parcelRequire("kzQWi");
const $363a97631d8da7ea$export$9076a5ac331011bb = (0, $g6dQg.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($25okM)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $363a97631d8da7ea$export$7fa63f8479e2806a = (0, $5nVr1.createHook)((0, $kzQWi.store), {
    selector: $363a97631d8da7ea$export$9076a5ac331011bb
});

});








parcelRegister("fkMK1", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => (parcelRequire("dEDTq")).default);

var $dEDTq = parcelRequire("dEDTq");

});
parcelRegister("dEDTq", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => $0dafa8e6286eb9b9$export$65ed9482db2257fa);
$parcel$export(module.exports, "default", () => $0dafa8e6286eb9b9$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $MPQAF = parcelRequire("MPQAF");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("fZgL2");
var $46k4N = parcelRequire("46k4N");

var $k2M4v = parcelRequire("k2M4v");

var $bqWPH = parcelRequire("bqWPH");

var $3Q3UJ = parcelRequire("3Q3UJ");

var $aEtFp = parcelRequire("aEtFp");

var $bcTS3 = parcelRequire("bcTS3");
parcelRequire("gE5Ax");
var $5avKE = parcelRequire("5avKE");

var $fNU0N = parcelRequire("fNU0N");
/**
 * Feature gate: a11y_password_show_button_focus_indicator
 *
 * Adds a clearly visible keyboard focus indicator to the show/hide password
 * toggle. The toggle renders inside the @atlaskit/textfield's `elemAfterInput`
 * slot, whose container has `overflow: hidden`, which clips the button's default
 * (outer) focus ring - leaving no visible focus indicator (fails WCAG 2.4.7).
 * When enabled, an inset focus ring is drawn instead so it is not clipped.
 */ const $0dafa8e6286eb9b9$var$PASSWORD_SHOW_BUTTON_FOCUS_INDICATOR = 'a11y_password_show_button_focus_indicator';
const $0dafa8e6286eb9b9$var$isPasswordShowButtonFocusIndicatorEnabled = ()=>(0, $k2M4v.default).checkGate($0dafa8e6286eb9b9$var$PASSWORD_SHOW_BUTTON_FOCUS_INDICATOR);
class $0dafa8e6286eb9b9$export$65ed9482db2257fa extends $fc4bM.Component {
    render() {
        const { autoFocus: autoFocus, intl: intl, id: id, maxLength: maxLength, value: value, isDisabled: isDisabled, isInvalid: isInvalid, weakPasswords: weakPasswords, errorMessage: errorMessage, hideStrengthMeter: hideStrengthMeter, testId: testId, onKeyDown: onKeyDown } = this.props;
        const { showPassword: showPassword } = this.state;
        const passwordFieldType = showPassword ? 'text' : 'password';
        const shouldRenderStrengthMeter = !hideStrengthMeter;
        // Associate the requirement/strength hint with the input only when the meter is actually
        // rendered (complete-signup), which leaves the login field (which hides the meter)
        // unaffected. Derive the hint id from the input's own (unique) id so two PasswordFields on
        // the same page (e.g. "new password" + "confirm password") never share a hint id and break
        // aria-describedby. Shared between the input's `aria-describedby` and the strength hint <p>.
        const strengthHintId = shouldRenderStrengthMeter ? `${id}-strength-hint` : undefined;
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $aEtFp.default), {
            id: id,
            testId: testId,
            type: passwordFieldType,
            maxLength: maxLength,
            onChange: this.onChange,
            isDisabled: isDisabled,
            autoFocus: autoFocus,
            isInvalid: isInvalid,
            value: value,
            elemAfterInput: this.renderShowHideButton(),
            onKeyDown: onKeyDown,
            "aria-describedby": strengthHintId
        }), isInvalid && errorMessage && /*#__PURE__*/ $fc4bM.createElement((0, $5avKE.default), {
            errorMessage: errorMessage
        }), shouldRenderStrengthMeter && /*#__PURE__*/ $fc4bM.createElement((0, $46k4N.default), {
            intl: intl,
            password: value,
            scoreWords: weakPasswords,
            hintId: strengthHintId
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            showPassword: false
        }, this.onChange = (e)=>{
            this.props.onChange(e.target.value);
        }, this.onShowPasswordToggle = ()=>{
            this.setState((prevState)=>({
                    showPassword: !prevState.showPassword
                }));
        }, this.renderShowHideButton = ()=>{
            const { intl: intl, isDisabled: isDisabled } = this.props;
            const { showPassword: showPassword } = this.state;
            const buttonActionPrefix = showPassword ? 'hide' : 'show';
            const togglePasswordButtonDescription = showPassword ? intl.formatMessage((0, $fNU0N.default).hidePassword) : intl.formatMessage((0, $fNU0N.default).showPassword);
            const icon = showPassword ? /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Q3UJ))), {
                spacing: "spacious",
                testId: "watch-filled-icon",
                label: togglePasswordButtonDescription
            }) : /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bqWPH))), {
                spacing: "spacious",
                testId: "watch-icon",
                label: togglePasswordButtonDescription
            });
            // Behind the a11y gate, render a variant of the toggle that pulls its design-system focus
            // ring inside the button (see ShowHideButton) so the surrounding field's `overflow: hidden`
            // cannot clip it (WCAG 2.4.7).
            const focusIndicatorEnabled = $0dafa8e6286eb9b9$var$isPasswordShowButtonFocusIndicatorEnabled();
            const ToggleButton = focusIndicatorEnabled ? $0dafa8e6286eb9b9$var$ShowHideButton : (0, $MPQAF.Button);
            return /*#__PURE__*/ $fc4bM.createElement((0, $bcTS3.default), {
                content: togglePasswordButtonDescription
            }, /*#__PURE__*/ $fc4bM.createElement(ToggleButton, {
                actionSubjectId: `${buttonActionPrefix}-password`,
                appearance: "subtle",
                isDisabled: isDisabled,
                onClick: this.onShowPasswordToggle,
                iconBefore: /*#__PURE__*/ $fc4bM.createElement($0dafa8e6286eb9b9$var$IconContainer, null, icon),
                testId: focusIndicatorEnabled ? 'user-password-show-toggle' : undefined
            }));
        };
    }
}
var $0dafa8e6286eb9b9$export$2e2bcd8739ae039 = (0, $fcCIH.default)($0dafa8e6286eb9b9$export$65ed9482db2257fa);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0dafa8e6286eb9b9$var$IconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-19v26xn-0"
})`padding-right:${"var(--ds-space-025, 2px)"};margin-left:${"var(--ds-space-negative-025, -2px)"};`;
/*
 * The show/hide toggle renders inside the @atlaskit/textfield's elemAfterInput slot, whose
 * container has overflow: hidden. The button's design-system focus ring (@atlaskit/focus-ring) is
 * drawn just outside its border box, so the container clips it and keyboard users see no focus
 * indicator (WCAG 2.4.7). A negative outline-offset draws the same DS ring inside the button -
 * matching @atlaskit/focus-ring's own inset variant - so it cannot be clipped. Styling the button
 * directly (className is forwarded to the underlying <button>) avoids adding an extra DOM node; the
 * doubled `&&` wins specificity over the focus-ring rule without needing !important.
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0dafa8e6286eb9b9$var$ShowHideButton = /*#__PURE__*/ (0, $luz1X.default)((0, $MPQAF.Button)).withConfig({
    componentId: "sc-19v26xn-1"
})`&&:focus-visible{outline-offset:calc(-1 * ${"var(--ds-border-width-focused, 2px)"});}`;

});
parcelRegister("fZgL2", function(module, exports) {
$parcel$export(module.exports, "AsyncLoadedPasswordStrengthMeter", () => (parcelRequire("46k4N")).default);

var $46k4N = parcelRequire("46k4N");

});
parcelRegister("46k4N", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdafd185618f4a09$export$2e2bcd8739ae039);
/**
 * Heavily inspired by https://stash.atlassian.com/projects/AID/repos/aid-frontend/browse/src/components/PasswordStrengthMeter.tsx.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $aYMdQ = parcelRequire("aYMdQ");

var $lTM5g = parcelRequire("lTM5g");

var $72rBD = parcelRequire("72rBD");

var $b94Q3 = parcelRequire("b94Q3");
const $cdafd185618f4a09$var$passwordAnalyzerUrl = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';
const $cdafd185618f4a09$var$splitter = /\W+/;
const $cdafd185618f4a09$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS = 200;
class $cdafd185618f4a09$export$eebfb7c0549090 extends $fc4bM.Component {
    render() {
        const { hintId: hintId } = this.props;
        const { score: score } = this.state;
        const strengthText = this.getStrengthTextForScore(score);
        // Only attach id/aria-live when an id is provided (gate on) so the
        // gate-off render is byte-for-byte identical to before.
        const hintA11yProps = hintId ? {
            id: hintId,
            'aria-live': 'polite'
        } : {};
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($cdafd185618f4a09$export$bbc6c6369b38e3d1, {
            "data-testid": "password-strength-bar",
            score: score
        }, /*#__PURE__*/ $fc4bM.createElement($cdafd185618f4a09$var$Dividers, null)), /*#__PURE__*/ $fc4bM.createElement($cdafd185618f4a09$export$8d13340382210b65, {
            "data-testid": "password-strength-hint",
            ...hintA11yProps
        }, strengthText));
    }
    constructor(...args){
        super(...args), this.state = {
            score: null
        }, this.calculateScoreDebounced = (0, $aYMdQ.debounce)(()=>{
            const { password: password, scoreWords: scoreWords, zxcvbn: passwordAnalyzer } = this.props;
            const result = passwordAnalyzer && password ? passwordAnalyzer(password, scoreWords) : null;
            this.setState({
                score: result ? result.score : null
            });
        }, $cdafd185618f4a09$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS), this.componentDidUpdate = (prevProps)=>{
            if (this.props.password === prevProps.password) return;
            if (!this.props.password) {
                this.setState({
                    score: null
                });
                return;
            }
            this.calculateScoreDebounced();
        }, this.getStrengthTextForScore = (score)=>{
            const { intl: intl, password: password, zxcvbn: passwordAnalyzer } = this.props;
            if (!password) return '';
            if (password.length < (0, $72rBD.MIN_PASSWORD_LENGTH_IN_CHARS)) return this.props.intl.formatMessage((0, $b94Q3.default).passwordInvalid);
            if (!passwordAnalyzer) return intl.formatMessage((0, $b94Q3.default).passwordStrengthUnavailable);
            return score !== null ? this.mapScoreToStrengthText(score) : '';
        }, this.mapScoreToStrengthText = (score)=>{
            let strengthText;
            switch(score){
                case 0:
                    strengthText = (0, $b94Q3.default).passwordStrengthLevel0;
                    break;
                case 1:
                    strengthText = (0, $b94Q3.default).passwordStrengthLevel1;
                    break;
                case 2:
                    strengthText = (0, $b94Q3.default).passwordStrengthLevel2;
                    break;
                case 3:
                    strengthText = (0, $b94Q3.default).passwordStrengthLevel3;
                    break;
                case 4:
                    strengthText = (0, $b94Q3.default).passwordStrengthLevel4;
                    break;
                default:
                    strengthText = (0, $b94Q3.default).passwordStrengthUnavailable;
            }
            return this.props.intl.formatMessage(strengthText);
        };
    }
}
const $cdafd185618f4a09$export$6672436889ec70b1 = (0, $lTM5g.default)($cdafd185618f4a09$var$passwordAnalyzerUrl, {
    globalName: 'zxcvbn'
})($cdafd185618f4a09$export$eebfb7c0549090);
var $cdafd185618f4a09$export$2e2bcd8739ae039 = $cdafd185618f4a09$export$6672436889ec70b1;
const $cdafd185618f4a09$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $cdafd185618f4a09$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($cdafd185618f4a09$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($cdafd185618f4a09$var$splitter).reduce($cdafd185618f4a09$var$addUnique, arr), deduped);
}
const $cdafd185618f4a09$var$leftPercentage = '19%';
const $cdafd185618f4a09$var$rightPercentage = '19%';
const $cdafd185618f4a09$var$leftPercentageAfter = '30%';
const $cdafd185618f4a09$var$rightPercentageAfter = '30%';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $cdafd185618f4a09$var$Dividers = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-2owkvn-0"
})`border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;left:${$cdafd185618f4a09$var$leftPercentage};position:absolute;right:${$cdafd185618f4a09$var$rightPercentage};top:0;&::after{border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;content:'';left:${$cdafd185618f4a09$var$leftPercentageAfter};position:absolute;right:${$cdafd185618f4a09$var$rightPercentageAfter};top:0;}`;
const $cdafd185618f4a09$var$barWidths = [
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $cdafd185618f4a09$var$barColours = [
    "var(--ds-chart-danger-bold, #BF2600)",
    "var(--ds-chart-danger, #FF5630)",
    "var(--ds-chart-warning, #FFAB00)",
    "var(--ds-chart-success, #36B37E)",
    "var(--ds-chart-success-bold, #00875A)"
];
const $cdafd185618f4a09$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-2owkvn-1"
})`background:${"var(--ds-chart-neutral, #DFE1E6)"};height:${$fOCtI.multiple(0.25).px};margin-top:${"var(--ds-space-075, 6px)"};position:relative;&::before{background-color:${(props)=>props.score === null ? "var(--ds-chart-neutral, #DFE1E6)" : $cdafd185618f4a09$var$barColours[props.score]};bottom:0;content:'';left:0;position:absolute;top:0;transition:all 0.2s ease-out;width:${(props)=>props.score === null ? 0 : $cdafd185618f4a09$var$barWidths[props.score]};}`;
const $cdafd185618f4a09$export$8d13340382210b65 = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-2owkvn-2"
})`color:${"var(--ds-text-subtlest, #8993A4)"};${$imLe4.small} height:${$fOCtI.multiple(2).px};line-height:${$fOCtI.multiple(2).px};margin-top:${"var(--ds-space-050, 4px)"};position:relative;text-align:center;`;

});
parcelRegister("lTM5g", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff1408772ce9a80e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");

var $hFHD3 = parcelRequire("hFHD3");
function $ff1408772ce9a80e$var$_extends() {
    $ff1408772ce9a80e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff1408772ce9a80e$var$_extends.apply(this, arguments);
}
function $ff1408772ce9a80e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ff1408772ce9a80e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ff1408772ce9a80e$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $ff1408772ce9a80e$var$idCount = 0;
function $ff1408772ce9a80e$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $ff1408772ce9a80e$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $ff1408772ce9a80e$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $ff1408772ce9a80e$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $ff1408772ce9a80e$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $ff1408772ce9a80e$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $fc4bM.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $fc4bM.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $fc4bM.forwardRef)(function(props, ref) {
            return (0, $fc4bM.createElement)(AsyncScriptLoader, $ff1408772ce9a80e$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($dso8W))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($hFHD3)))(ForwardedComponent, WrappedComponent);
    };
}

});

parcelRegister("b94Q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca9330e49e0d06fb$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ca9330e49e0d06fb$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    passwordInvalid: {
        id: 'password.invalid.password.size',
        description: 'Displayed when the user has entered a password shorter than 8 characters',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel0: {
        id: 'password.strength.level.0',
        description: 'Displayed when the user has entered a weak password',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        description: 'Displayed when the user has entered a fair (not very good) password',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        description: 'Displayed when the user has entered a good password',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        description: 'Displayed when the user has entered a strong password',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        description: 'Displayed when the user has entered a very strong password',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        description: 'Displayed when the password strength cannot be determined due to an error',
        defaultMessage: 'Password strength unavailable'
    }
});

});



parcelRegister("gE5Ax", function(module, exports) {
$parcel$export(module.exports, "ErrorIndication", () => (parcelRequire("5avKE")).default);

var $5avKE = parcelRequire("5avKE");

});
parcelRegister("5avKE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3ec707ba5abcc8f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fcCIH = parcelRequire("fcCIH");

var $gDsF8 = parcelRequire("gDsF8");

var $4T8rw = parcelRequire("4T8rw");

var $6Pd4T = parcelRequire("6Pd4T");
const $a3ec707ba5abcc8f$var$ErrorIndication = ({ errorMessage: errorMessage, intl: intl })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $fc4bM.createElement($a3ec707ba5abcc8f$var$ContainerV2, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
            label: "error",
            color: "var(--ds-icon-danger, #BF2600)",
            size: "small"
        }), /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), {
            size: "small",
            color: "color.text.danger"
        }, typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)))
    }, /*#__PURE__*/ $fc4bM.createElement($a3ec707ba5abcc8f$var$Container, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        label: "error",
        color: "var(--ds-icon-danger, #BF2600)",
        size: "small"
    }), typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)));
};
var $a3ec707ba5abcc8f$export$2e2bcd8739ae039 = (0, $fcCIH.default)($a3ec707ba5abcc8f$var$ErrorIndication);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a3ec707ba5abcc8f$var$ContainerV2 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-xau1xe-0"
})`margin-top:${"var(--ds-space-050, 4px)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a3ec707ba5abcc8f$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-xau1xe-1"
})`${$imLe4.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("fNU0N", function(module, exports) {
$parcel$export(module.exports, "default", () => $d91d7c2f0017adc6$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $d91d7c2f0017adc6$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    label: {
        defaultMessage: 'Password',
        description: 'Label for the password input field in the login form.',
        id: 'password.field.label'
    },
    showPassword: {
        defaultMessage: 'Show',
        description: 'Label for the button to show the password in the password field.',
        id: 'password.show.button.label'
    },
    hidePassword: {
        defaultMessage: 'Hide',
        description: 'Label for the button to hide the password in the password field.',
        id: 'password.hide.button.label'
    }
});

});



parcelRegister("dtvmL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $54e3bc8b18d222f2$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fRCnG = parcelRequire("fRCnG");

var $1hJdJ = parcelRequire("1hJdJ");

var $gV8E5 = parcelRequire("gV8E5");

var $i3riz = parcelRequire("i3riz");

var $cJzRi = parcelRequire("cJzRi");

var $dtq1L = parcelRequire("dtq1L");
const $54e3bc8b18d222f2$var$sectionMessageStyles = {
    container: "_2rko1mok _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $54e3bc8b18d222f2$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $54e3bc8b18d222f2$var$SectionMessage = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, appearance: appearance = 'information', actions: actions, title: title, headingLevel: headingLevel = 'h2', icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref)=>{
    const [dismissed, setDismissed] = (0, $fc4bM.useState)(false);
    const handleDismiss = (0, $fc4bM.useCallback)(()=>{
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $dtq1L.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $fc4bM.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $fc4bM.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $3LM7S.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $2R2iS.default)([
            $54e3bc8b18d222f2$var$sectionMessageStyles.container,
            $54e3bc8b18d222f2$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    className: (0, $2R2iS.default)([
                        $54e3bc8b18d222f2$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $54e3bc8b18d222f2$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                            as: headingLevel,
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            className: (0, $2R2iS.default)([
                                $54e3bc8b18d222f2$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $54e3bc8b18d222f2$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    className: (0, $2R2iS.default)([
                        $54e3bc8b18d222f2$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$54e3bc8b18d222f2$var$SectionMessage.displayName = 'SectionMessage';
var $54e3bc8b18d222f2$export$2e2bcd8739ae039 = $54e3bc8b18d222f2$var$SectionMessage;

});
parcelRegister("dtq1L", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $2258bc191febc483$export$e9b82d2e21ac0c1f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fmFjF = parcelRequire("fmFjF");

var $gDsF8 = parcelRequire("gDsF8");

var $fKWgA = parcelRequire("fKWgA");

var $fBVBf = parcelRequire("fBVBf");

var $7ZdBj = parcelRequire("7ZdBj");
const $2258bc191febc483$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fmFjF))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $2258bc191febc483$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $2258bc191febc483$var$appearanceIconSchema[appearance] || $2258bc191febc483$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, $3LM7S.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("fmFjF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9aea886ae883664b6f933ff09352e51d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2f8f5a2c607319d$var$_react = $b2f8f5a2c607319d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b2f8f5a2c607319d$var$_iconNew = $b2f8f5a2c607319d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b2f8f5a2c607319d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-discovery
 * Usage guidance:
 * Reserved for discovery statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2f8f5a2c607319d$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $b2f8f5a2c607319d$var$_react.default.createElement($b2f8f5a2c607319d$var$_iconNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$b2f8f5a2c607319d$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $b2f8f5a2c607319d$var$_default = module.exports.default = $b2f8f5a2c607319d$var$StatusDiscoveryIcon;

});



parcelRegister("aipaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a2d4789b3e3cf94$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7a2d4789b3e3cf94$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    resetPasswordLink: {
        defaultMessage: 'Reset password',
        description: 'Text of the reset password link',
        id: 'cv.login.reset.password.link'
    },
    resetPasswordLinkInlineBold: {
        defaultMessage: 'Reset Password',
        description: 'Text of the reset password which is inline bold',
        id: 'cv.login.reset.password.link.bold'
    },
    createPasswordLink: {
        defaultMessage: 'Create password',
        description: "Text to create password for customers who haven't yet set a password",
        id: 'cv.login.create.a.password.link'
    },
    dontHavePasswordText: {
        defaultMessage: "Don't have a password?",
        description: "Text to prompt user if they don't already have a password due to a new account",
        id: 'cv.login.dont.have.password.text'
    },
    nextButton: {
        defaultMessage: 'Next',
        description: 'Label for the Next button on the login form',
        id: 'cv.next.button.label'
    },
    continueButton: {
        defaultMessage: 'Continue',
        description: 'Label for the Continue button on the login form',
        id: 'cv.continue.button.label'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for the email address input field on the login form',
        id: 'cv.login.page.email.label'
    },
    passwordLabelAndPlaceholder: {
        defaultMessage: 'Password',
        description: 'Placeholder and label for login password field',
        id: 'cv.signup.page.password'
    },
    invalidEmailError: {
        defaultMessage: 'Enter a valid email address and try again.',
        description: 'Error shown when the email does not have the correct format.',
        id: 'sd.login.error.invalid.email.error'
    },
    incorrectPasswordError: {
        defaultMessage: 'Incorrect password. Try again',
        description: 'Error shown when the password is incorrect.',
        id: 'sd.login.error.incorrect.password'
    },
    emptyPasswordError: {
        defaultMessage: 'You must enter your password to log in',
        description: 'Error shown when the password is empty',
        id: 'sd.login.error.empty.password'
    },
    accessDeniedErrorCodeMessage: {
        defaultMessage: "You can\u2019t continue with single sign-on. Try again.",
        description: 'Error shown when receiving access deny error code from identity.',
        id: 'sd.login.errorcode.access.denied'
    },
    defaultErrorCodeMessage: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error shown when the receiving other error code',
        id: 'sd.login.errorcode.default'
    },
    loginConsentErrorMessage: {
        defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later',
        description: 'Error shown when the FedRAMP user failed to consent and got redirected to the login page',
        id: 'sd.login.consent.fail.error'
    }
});

});



parcelRegister("e9GZ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2702d0561dfb0000$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $2702d0561dfb0000$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    invalidLogin: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Message to show that email or password are incorrect and that the user should try again.',
        id: 'sd.login.error.invalid.login.unified'
    },
    accountLocked: {
        defaultMessage: "For security reasons, we've temporarily locked this account due to multiple unsuccessful login attempts. To regain access, select {forgotPasswordLink} to reset your password.",
        description: 'Error message if the account is locked.',
        id: 'sd.login.account.locked.unified'
    },
    miscLoginError: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error message for any not classified errors.',
        id: 'sd.login.error.misc.unified'
    }
});

});




parcelRegister("6gKNW", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOn", () => (parcelRequire("hkMok")).default);

var $hkMok = parcelRequire("hkMok");

});
parcelRegister("hkMok", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c76961f2ca2124a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $hN5YJ = parcelRequire("hN5YJ");

var $imLe4 = parcelRequire("imLe4");

var $iK1uY = parcelRequire("iK1uY");

var $fRgxR = parcelRequire("fRgxR");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");
parcelRequire("2N4Ib");
var $cuTR5 = parcelRequire("cuTR5");

var $k2M4v = parcelRequire("k2M4v");

var $1hJdJ = parcelRequire("1hJdJ");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $lvRbB = parcelRequire("lvRbB");

var $6Pd4T = parcelRequire("6Pd4T");

var $lLSsX = parcelRequire("lLSsX");
class $1c76961f2ca2124a$export$b77dc1349d86cfac extends $fc4bM.Component {
    componentDidMount() {
        this.setState({
            isInIframe: window.self !== window.top
        });
    }
    render() {
        return /*#__PURE__*/ $fc4bM.createElement($1c76961f2ca2124a$var$Container, null, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), this.getSSOFormContent(), /*#__PURE__*/ $fc4bM.createElement($1c76961f2ca2124a$var$ButtonContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $iK1uY.ThemedButton), {
            id: "login-button",
            "data-test-id": "login-sso-button",
            appearance: "primary",
            shouldFitContainer: true,
            actionSubjectId: "submitLoginSSO",
            href: this.getSSOUrl(),
            target: this.state.isInIframe && (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
            rel: this.state.isInIframe && (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
            autoFocus: true
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $lLSsX.default).continueWithAtlassianAccountButton))), this.getAtlassianAccountInfoSection());
    }
    constructor(...args){
        super(...args), this.state = {
            isInIframe: false
        }, this.getSSOUrl = ()=>{
            return this.props.redirectUrl;
        }, this.getSSOFormContent = ()=>{
            const { intl: intl, email: email } = this.props;
            return /*#__PURE__*/ $fc4bM.createElement((0, $cuTR5.default), {
                id: "user-email",
                shouldFitContainer: true,
                label: intl.formatMessage((0, $lLSsX.default).emailLabel),
                disabled: true,
                defaultValue: email
            });
        }, this.getAtlassianAccountInfoSection = ()=>{
            const { intl: intl } = this.props;
            const URI = 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/';
            const supportLink = /*#__PURE__*/ $fc4bM.createElement((0, $fRgxR.default), {
                actionSubjectId: "learnMoreAtlassianAccount",
                href: URI,
                target: "_blank",
                id: "sso-login-learn-more-link",
                "aria-labelledby": "sso-login-learn-more-link sso-login-atlassian-account-heading"
            }, intl.formatMessage((0, $lLSsX.default).atlassianAccountInfoLink));
            return /*#__PURE__*/ $fc4bM.createElement($1c76961f2ca2124a$var$InfoSectionContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                    paddingBlockStart: "space.300"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
                    size: "xsmall"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $lLSsX.default).atlassianAccountInfoTitle)))
            }, /*#__PURE__*/ $fc4bM.createElement($1c76961f2ca2124a$var$InfoSectionTitle, {
                role: "heading",
                "aria-level": 3,
                id: "sso-login-atlassian-account-heading"
            }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $lLSsX.default).atlassianAccountInfoTitle))), /*#__PURE__*/ $fc4bM.createElement((0, $6Pd4T.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                    paddingBlockStart: "space.050"
                }, /*#__PURE__*/ $fc4bM.createElement((0, $4T8rw.Text), null, (0, $k2M4v.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
                    ...(0, $lLSsX.default).atlassianAccountInfoContentAppify,
                    // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                    values: {
                        supportLink: supportLink
                    }
                }) : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
                    ...(0, $lLSsX.default).atlassianAccountInfoContent,
                    // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                    values: {
                        supportLink: supportLink
                    }
                })))
            }, /*#__PURE__*/ $fc4bM.createElement($1c76961f2ca2124a$var$InfoSectionContent, null, (0, $k2M4v.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
                ...(0, $lLSsX.default).atlassianAccountInfoContentAppify,
                // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                values: {
                    supportLink: supportLink
                }
            }) : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
                ...(0, $lLSsX.default).atlassianAccountInfoContent,
                // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                values: {
                    supportLink: supportLink
                }
            }))));
        };
    }
}
var $1c76961f2ca2124a$export$2e2bcd8739ae039 = (0, $fcCIH.default)($1c76961f2ca2124a$export$b77dc1349d86cfac);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1c76961f2ca2124a$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-qruqqd-0"
})`text-align:left;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1c76961f2ca2124a$var$ButtonContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-qruqqd-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1c76961f2ca2124a$var$InfoSectionContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-qruqqd-2"
})`margin-top:${"var(--ds-space-300, 24px)"};border-top:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1c76961f2ca2124a$var$InfoSectionTitle = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-qruqqd-3"
})`${(0, $imLe4.h400)};margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1c76961f2ca2124a$var$InfoSectionContent = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-qruqqd-4"
})`margin-top:${"var(--ds-space-050, 4px)"};`;

});
parcelRegister("lLSsX", function(module, exports) {
$parcel$export(module.exports, "default", () => $db4dd685c5bc13a9$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $db4dd685c5bc13a9$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    continueWithAtlassianAccountButton: {
        defaultMessage: 'Continue with Atlassian account',
        description: 'The redirect button text for login with single sign-on',
        id: 'cv.login.sso.button.text'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for the email address input field on the SSO login form',
        id: 'cv.login.sso.email.label'
    },
    atlassianAccountInfoTitle: {
        defaultMessage: 'Your Atlassian account',
        description: 'Title of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.title'
    },
    atlassianAccountInfoContent: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian products. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content'
    },
    atlassianAccountInfoContentAppify: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian apps. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content-appify'
    },
    atlassianAccountInfoLink: {
        defaultMessage: 'Learn more',
        description: 'Learn more link of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.link'
    }
});

});



parcelRegister("9DUFj", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOnCustomer", () => (parcelRequire("9JFHA")).default);

var $9JFHA = parcelRequire("9JFHA");

});
parcelRegister("9JFHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d9a9f138a496984$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $hN5YJ = parcelRequire("hN5YJ");

var $fOCtI = parcelRequire("fOCtI");

var $iK1uY = parcelRequire("iK1uY");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("2N4Ib");
var $cuTR5 = parcelRequire("cuTR5");

var $lvRbB = parcelRequire("lvRbB");

var $hANKa = parcelRequire("hANKa");

var $8p79I = parcelRequire("8p79I");
const $1d9a9f138a496984$var$LoginSingleSignOnCustomer = (props)=>{
    const { email: email, redirectLink: redirectLink, passwordLoginAvailable: passwordLoginAvailable, onContinueWithPassword: onContinueWithPassword } = props;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [isInIframe, setIsInIframe] = (0, $fc4bM.useState)(false);
    (0, $fc4bM.useEffect)(()=>{
        setIsInIframe(window.self !== window.top);
    }, []);
    const getContinueWithPasswordLink = ()=>{
        return passwordLoginAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1d9a9f138a496984$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iK1uY.ThemedButton), {
            appearance: "link",
            actionSubjectId: "continueWithPassword",
            onClick: onContinueWithPassword
        }, formatMessage((0, $8p79I.default).continueWithPasswordButton))) : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($1d9a9f138a496984$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvRbB.FireScreenEventOnMount), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cuTR5.default), {
        id: "user-email",
        shouldFitContainer: true,
        label: formatMessage((0, $8p79I.default).emailLabel),
        disabled: true,
        defaultValue: email
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hANKa.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iK1uY.ThemedButton), {
        id: "continue-with-customer-sso-button",
        appearance: "primary",
        shouldFitContainer: true,
        actionSubjectId: "continueWithCustomerSSO",
        isDisabled: redirectLink === undefined,
        href: redirectLink,
        target: isInIframe && (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
        rel: isInIframe && (0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
        autoFocus: true
    }, formatMessage((0, $8p79I.default).continueWithSingleSignOnButton))), getContinueWithPasswordLink());
};
var $1d9a9f138a496984$export$2e2bcd8739ae039 = $1d9a9f138a496984$var$LoginSingleSignOnCustomer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1d9a9f138a496984$var$FooterContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-t9atao-0"
})`margin-top:${$fOCtI.multiple(4.25).px};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1d9a9f138a496984$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-t9atao-1"
})`text-align:left;`;

});
parcelRegister("hANKa", function(module, exports) {
$parcel$export(module.exports, "ButtonContainer", () => $bcadad11021f3491$export$eddf54ea3db8d0f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $luz1X = parcelRequire("luz1X");
const $bcadad11021f3491$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-mrwmoh-0"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("8p79I", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c88ed3b7e53ced9$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $2c88ed3b7e53ced9$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for the email address input field on the customer SSO login form',
        id: 'cv.login.sso.customer.email.label'
    },
    continueWithPasswordButton: {
        defaultMessage: 'Continue with password',
        description: 'The button text for customer account login using password',
        id: 'cv.login.sso.customer.password.link.text'
    },
    continueWithSingleSignOnButton: {
        defaultMessage: 'Continue with single sign-on',
        description: 'The redirect button text for customer account login using single sign-on',
        id: 'cv.login.sso.customer.button.text'
    }
});

});







parcelRegister("4WfeP", function(module, exports) {
$parcel$export(module.exports, "portalAccessForbiddenRoute", () => $c8b1836aa769779d$export$51c7ebad0d50c69a);

var $9mazR = parcelRequire("9mazR");
parcelRequire("hwBjj");
var $8vLfR = parcelRequire("8vLfR");

var $joDHD = parcelRequire("joDHD");
const $c8b1836aa769779d$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true,
    headerless: true
};
const $c8b1836aa769779d$export$51c7ebad0d50c69a = (0, $joDHD.createRouteWithLayout)({
    name: 'portal-access-forbidden',
    path: '/user/forbidden',
    exact: true,
    component: (0, $8vLfR.default),
    resources: []
}, (0, $9mazR.ScreenName).PORTAL_ACCESS_FORBIDDEN, $c8b1836aa769779d$var$layoutProps);

});
parcelRegister("hwBjj", function(module, exports) {
$parcel$export(module.exports, "PortalAccessForbidden", () => (parcelRequire("8vLfR")).default);

var $8vLfR = parcelRequire("8vLfR");

});
parcelRegister("8vLfR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08caa45775f9ddc$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $1tIY9 = parcelRequire("1tIY9");
const $c08caa45775f9ddc$var$selector = (0, $2n2bS.createSelector)((state)=>(0, $7RWiC.isLoggedIn)(state), (state)=>(0, $7RWiC.getUserState)(state), (isUserLoggedIn, userState)=>({
        isUserLoggedIn: isUserLoggedIn,
        userEmail: userState.email || ''
    }));
var $c08caa45775f9ddc$export$2e2bcd8739ae039 = (0, $6umft.default)($c08caa45775f9ddc$var$selector)((0, $1tIY9.default));

});
parcelRegister("1tIY9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c7e3aa3a0b3df4b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $aHS3M = parcelRequire("aHS3M");

var $imLe4 = parcelRequire("imLe4");

var $fOCtI = parcelRequire("fOCtI");

var $fRgxR = parcelRequire("fRgxR");

var $7IsHf = parcelRequire("7IsHf");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");
parcelRequire("blonq");
var $4m70N = parcelRequire("4m70N");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $g9ziK = parcelRequire("g9ziK");

var $gioQl = parcelRequire("gioQl");

var $jxN6E = parcelRequire("jxN6E");
const $7c7e3aa3a0b3df4b$var$PortalAccessForbidden = ({ isUserLoggedIn: isUserLoggedIn, userEmail: userEmail })=>{
    const callToActionUrl = 'https://start.atlassian.com/';
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const isCSMHelpCenterEnabled = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    if (!isUserLoggedIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g9ziK.Redirect), {
        to: (0, $gioQl.getHelpCenterUrl)()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aHS3M.default), {
        title: formatMessage((0, $jxN6E.default).documentTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m70N.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7c7e3aa3a0b3df4b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7c7e3aa3a0b3df4b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7IsHf.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7c7e3aa3a0b3df4b$var$Message, null, formatMessage((0, $jxN6E.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7c7e3aa3a0b3df4b$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...isCSMHelpCenterEnabled ? (0, $jxN6E.default).errorDescriptionTextV2 : (0, $jxN6E.default).errorDescriptionText,
        values: {
            userEmail: userEmail,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("br", null)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7c7e3aa3a0b3df4b$var$AnchorContainer, {
        actionSubjectId: "redirectToAtlassianStart",
        href: callToActionUrl
    }, formatMessage((0, $jxN6E.default).callToActionText)))));
};
var $7c7e3aa3a0b3df4b$export$2e2bcd8739ae039 = $7c7e3aa3a0b3df4b$var$PortalAccessForbidden;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7c7e3aa3a0b3df4b$var$Container = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-98kmq7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7c7e3aa3a0b3df4b$var$IconContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-98kmq7-1"
})`width:${$fOCtI.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7c7e3aa3a0b3df4b$var$Message = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-98kmq7-2"
})`${$imLe4.h600};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7c7e3aa3a0b3df4b$var$Description = /*#__PURE__*/ (0, $luz1X.default).p.withConfig({
    componentId: "sc-98kmq7-3"
})`${$imLe4.regular};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7c7e3aa3a0b3df4b$var$AnchorContainer = /*#__PURE__*/ (0, $luz1X.default)((0, $fRgxR.default)).withConfig({
    componentId: "sc-98kmq7-4"
})`text-align:center;`;

});
parcelRegister("jxN6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $7590f13cb106eaf4$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7590f13cb106eaf4$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    documentTitle: {
        defaultMessage: 'No access',
        description: 'Document title for user with no access to portal',
        id: 'cv.portal.forbidden.access.document.title'
    },
    errorHeading: {
        defaultMessage: 'No access',
        description: 'Error heading for user with no portal access',
        id: 'cv.portal.forbidden.access.error.heading'
    },
    errorDescriptionText: {
        defaultMessage: "It seems that your account {userEmail} doesn't have access to the help center.{br}Try contacting your admins to grant you permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text'
    },
    errorDescriptionTextV2: {
        defaultMessage: "Your account {userEmail} doesn't have access to this website, help center, or hub.{br}Contact your admin(s) to request access permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text.v2'
    },
    callToActionText: {
        defaultMessage: 'Go to Atlassian Start',
        description: 'Next action link label for user with no portal access',
        id: 'cv.portal.forbidden.access.error.action.link.label'
    }
});

});





parcelRegister("d9md5", function(module, exports) {
$parcel$export(module.exports, "getPortalHomeRoutes", () => $f6c857b0c4ffac13$export$87f7f4cc1cadb13a);
parcelRequire("cYrJu");
var $kwv2X = parcelRequire("kwv2X");

var $joDHD = parcelRequire("joDHD");

const $f6c857b0c4ffac13$var$getRoute = ()=>({
        name: 'portal-home',
        path: `/portal/:portalId/:group?/:requestGroupId?/:create?/:requestTypeId?`,
        exact: true,
        component: (0, $kwv2X.default),
        getUFONameBasedOnRouteMatch: (routerState)=>{
            const { requestTypeId: requestTypeId } = routerState.params;
            if (requestTypeId) return 'request-create';
            return 'portal-home';
        },
        resources: []
    });
const $f6c857b0c4ffac13$var$paperAppearance = 'xxwide';
const $f6c857b0c4ffac13$var$layoutProps = {
    paperAppearance: $f6c857b0c4ffac13$var$paperAppearance,
    fadeInSearchModal: true
};
const $f6c857b0c4ffac13$export$87f7f4cc1cadb13a = ()=>(0, $joDHD.createRouteWithLayout)($f6c857b0c4ffac13$var$getRoute(), undefined, $f6c857b0c4ffac13$var$layoutProps);

});
parcelRegister("cYrJu", function(module, exports) {
$parcel$export(module.exports, "PortalHome", () => (parcelRequire("kwv2X")).default);

var $kwv2X = parcelRequire("kwv2X");

});
parcelRegister("kwv2X", function(module, exports) {
$parcel$export(module.exports, "default", () => $2abee41b760fbdec$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("epa1X");
var $7egf9 = parcelRequire("7egf9");

var $9mazR = parcelRequire("9mazR");

var $fecgs = parcelRequire("fecgs");

var $eSLE4 = parcelRequire("eSLE4");
parcelRequire("5BjLS");
var $jbwFT = parcelRequire("jbwFT");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("ljSph");
var $1mt5N = parcelRequire("1mt5N");
parcelRequire("6afVg");
var $aXlr1 = parcelRequire("aXlr1");
parcelRequire("2SHxh");
var $6CHcz = parcelRequire("6CHcz");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("1xUIS");
var $jfaQa = parcelRequire("jfaQa");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $azARG = parcelRequire("azARG");

var $613oU = parcelRequire("613oU");

var $hN5YJ = parcelRequire("hN5YJ");

var $eENmG = parcelRequire("eENmG");

var $4MjGQ = parcelRequire("4MjGQ");

var $dkrfZ = parcelRequire("dkrfZ");

var $esgVk = parcelRequire("esgVk");

var $g81wt = parcelRequire("g81wt");

var $bzsGe = parcelRequire("bzsGe");

var $eMdst = parcelRequire("eMdst");
parcelRequire("6OVhp");
var $4xX38 = parcelRequire("4xX38");
parcelRequire("9D5bd");
var $fgV0H = parcelRequire("fgV0H");
const $2abee41b760fbdec$export$3fbf10a15d6b2168 = (screenLocation)=>(0, $esgVk.pathname)().endsWith(screenLocation);
class $2abee41b760fbdec$export$2521bdc6772d1464 extends $fc4bM.Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchUser: fetchUser, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, requestTypeId: requestTypeId, categories: categories } = this.props;
        const analytics = this.getViewSinglePortalAnalyticsEvents();
        if (portalId) {
            fetchPortal({
                id: portalId,
                expand: [
                    'kbs',
                    'orderMapping',
                    'reqGroups',
                    'reqTypes',
                    'analyticsContext',
                    'categories'
                ]
            }, analytics);
            if (requestTypeId) {
                if (!this.props.requestCreateModelLoaded || this.props.isPrefillPending) fetchRequestCreate({
                    portalId: portalId,
                    id: requestTypeId
                });
                fetchUiModifications({
                    portalId: portalId,
                    requestTypeId: requestTypeId
                });
            }
            // FSD-2541: required to re-fetch user model inorder to send correct analytics remove in clean-up task FSD-2881
            fetchUser();
            if (!categories) this.tryFetchCategories();
        }
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, requestTypeId: requestTypeId, portalId: portalId, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, kbEnabled: kbEnabled } = this.props;
        const projectUpdated = prevProps.projectId !== projectId;
        const kbEnabledUpdated = !prevProps.kbEnabled && kbEnabled;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId;
        const portalUpdated = prevProps.portalId !== portalId;
        if (projectUpdated || kbEnabledUpdated) this.tryFetchCategories();
        if (portalId && requestTypeId && (portalUpdated || requestTypeUpdated)) {
            fetchRequestCreate({
                portalId: portalId,
                id: requestTypeId
            });
            fetchUiModifications({
                portalId: portalId,
                requestTypeId: requestTypeId
            });
        }
    }
    getScreenName() {
        const { requestTypeId: requestTypeId, requestGroupId: requestGroupId } = this.props;
        let screenName;
        if (requestTypeId) screenName = (0, $9mazR.ScreenName).REQUEST_CREATE;
        else if (requestGroupId === -1) screenName = (0, $9mazR.ScreenName).REQUEST_GROUP_LIST;
        else if (requestGroupId) screenName = (0, $9mazR.ScreenName).REQUEST_GROUP;
        else screenName = (0, $9mazR.ScreenName).PORTAL_HOME;
        return screenName;
    }
    render() {
        const { sideBarOpen: sideBarOpen } = this.state;
        const { portalName: portalName, requestTypeName: requestTypeName, isLoading: isLoading, error: error, announcement: announcement, canEditAnnouncement: canEditAnnouncement, portalId: portalId, projectId: projectId, categories: categories, requestTypeId: requestTypeId, requestGroupId: requestGroupId, isProjectSimplified: isProjectSimplified, isAtlassianManagedAccount: isAtlassianManagedAccount, isProjectAdmin: isProjectAdmin, canCustomiseHelpCenter: canCustomiseHelpCenter, requestTypeBelongsToGroup: requestTypeBelongsToGroup, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction } = this.props;
        const screenName = this.getScreenName();
        return /*#__PURE__*/ $fc4bM.createElement((0, $dkrfZ.default), {
            screenName: screenName,
            screenId: requestTypeId || requestGroupId || portalId
        }, /*#__PURE__*/ $fc4bM.createElement((0, $4xX38.default), {
            screenName: screenName
        }, /*#__PURE__*/ $fc4bM.createElement((0, $7egf9.default), {
            name: (0, $9mazR.ExperienceName).REQUEST_CREATE
        }, /*#__PURE__*/ $fc4bM.createElement((0, $eMdst.UiModificationsContainer), null, /*#__PURE__*/ $fc4bM.createElement((0, $fgV0H.default), {
            portalName: portalName,
            portalId: portalId,
            projectId: projectId,
            requestTypeName: requestTypeName,
            requestTypeId: requestTypeId,
            requestGroupId: requestGroupId,
            loading: isLoading,
            sideBarOpen: sideBarOpen,
            toggleSidebar: this.toggleSideBar,
            announcement: announcement,
            canEditAnnouncement: canEditAnnouncement,
            categories: categories,
            isProjectSimplified: isProjectSimplified,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            isProjectAdmin: isProjectAdmin,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            requestTypeBelongsToGroup: requestTypeBelongsToGroup,
            isBrandingLoaded: isBrandingLoaded,
            isLoggedIn: isLoggedIn,
            screenName: screenName,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBarAction,
            closeChatSideBar: closeChatSideBarAction,
            ...error
        })))));
    }
    constructor(...args){
        super(...args), this.state = {
            sideBarOpen: false
        }, this.tryFetchCategories = ()=>{
            const { portalId: portalId, kbEnabled: kbEnabled, projectId: projectId, categoriesLoaded: categoriesLoaded, fetchCategories: fetchCategories } = this.props;
            if (kbEnabled && projectId && portalId && !categoriesLoaded) {
                const meta = this.getAnalyticsEvents();
                fetchCategories(projectId, portalId, meta);
            }
        }, this.getAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsSuccessEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories success',
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories error',
                    analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE)
                })
            };
        }, this.getViewSinglePortalAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return {
                analyticsSuccessEvent: createAnalyticsEvent({
                    action: (0, $4MjGQ.AnalyticsTrackActions).FETCHED,
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent({
                    action: (0, $4MjGQ.AnalyticsTrackActions).FETCHED_FAILURE,
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                })
            };
            return {};
        }, this.toggleSideBar = (value)=>{
            this.setState({
                sideBarOpen: value !== undefined ? value : !this.state.sideBarOpen
            });
            // this.props.location.pathname is used to check if the user is on the same page
            if (value === false && $2abee41b760fbdec$export$3fbf10a15d6b2168(this.props.location.pathname)) (0, $bzsGe.clearSidebarExperienceAndCustomize)();
        };
    }
}
const $2abee41b760fbdec$var$selector = (0, $2n2bS.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const portalId = (0, $g81wt.toNumber)(portalIdAsString);
    const kbEnabled = portalId && (0, $9D9SX.getIsKbEnabled)(state, portalId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestTypeId = props.match.params && (0, $g81wt.toNumber)(props.match.params.requestTypeId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestGroupId = props.match.params && (0, $g81wt.toNumber)(props.match.params.requestGroupId);
    const portalName = portalId ? (0, $9D9SX.getName)(state, portalId) : undefined;
    const requestType = portalId && requestTypeId ? (0, $9D9SX.getPortalRequestType)(state, portalId, requestTypeId) : undefined;
    const requestTypeName = requestType ? requestType.name : undefined;
    const requestTypeBelongsToGroup = portalId && requestGroupId && requestTypeId && (0, $9D9SX.getIsRequestTypeBelongsToGroup)(state, portalId, requestGroupId, requestTypeId);
    const requestCreateModelLoaded = portalId && requestTypeId && !!(0, $jfaQa.getRequestCreate)(state, portalId, requestTypeId);
    let isPrefillPending = false;
    if ((0, $hN5YJ.isJsmPortalRovoIntegrationEnabled)() && portalId && requestTypeId) isPrefillPending = (0, $jfaQa.getIsPrefillPending)(state, portalId, requestTypeId);
    return {
        portalId: portalId,
        portalName: portalName,
        kbEnabled: kbEnabled,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        requestTypeBelongsToGroup: requestTypeBelongsToGroup,
        requestCreateModelLoaded: requestCreateModelLoaded,
        isPrefillPending: isPrefillPending,
        isAtlassianManagedAccount: (0, $7RWiC.isAtlassianAccountManaged)(state),
        isLoggedIn: (0, $7RWiC.isLoggedIn)(state),
        categories: (0, $9D9SX.getCategories)(state, portalId),
        portal: (0, $9D9SX.getPortalOrError)(state, portalId),
        projectId: (0, $9D9SX.getProjectId)(state, portalId),
        announcement: (0, $9D9SX.getPortalAnnouncement)(state, portalId),
        isProjectAdmin: (0, $9D9SX.getCanAdministerProject)(state, portalId),
        canCustomiseHelpCenter: (0, $ePyx3.getCanCustomize)(state),
        isProjectSimplified: (0, $9D9SX.getIsProjectSimplified)(state, portalId),
        isBrandingLoaded: (0, $ePyx3.getHelpCenterBrandingLoader)(state),
        isChatSideBarOpen: (0, $6CHcz.isChatSideBarOpen)(state)
    };
}, ({ portalId: portalId, portal: portal, announcement: announcement, requestTypeId: requestTypeId, requestGroupId: requestGroupId, portalName: portalName, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, requestCreateModelLoaded: requestCreateModelLoaded, isPrefillPending: isPrefillPending, isAtlassianManagedAccount: isAtlassianManagedAccount, projectId: projectId, kbEnabled: kbEnabled, categories: categories, isProjectAdmin: isProjectAdmin, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isChatSideBarOpen: isChatSideBarOpen })=>{
    let isLoading = false;
    /**
   * Categories details are required only for single portal screen and not on portal groups / request create form screen (i.e when requestGroupId is present in the URL)
   */ if (requestGroupId) isLoading = Boolean(!portal);
    else isLoading = Boolean(!portal || kbEnabled && !categories);
    const categoriesOrUndefined = Array.isArray(categories) ? categories : undefined;
    return {
        portalId: portalId,
        portalName: portalName,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        projectId: projectId,
        announcement: announcement,
        isLoading: isLoading,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        isBrandingLoaded: isBrandingLoaded,
        isLoggedIn: isLoggedIn,
        isChatSideBarOpen: isChatSideBarOpen,
        requestTypeBelongsToGroup: Boolean(requestTypeBelongsToGroup),
        requestCreateModelLoaded: Boolean(requestCreateModelLoaded),
        isPrefillPending: Boolean(isPrefillPending),
        kbEnabled: Boolean(kbEnabled),
        categories: categoriesOrUndefined,
        isProjectAdmin: Boolean(isProjectAdmin),
        isProjectSimplified: Boolean(isProjectSimplified),
        categoriesLoaded: !!categories,
        error: portal && 'error' in portal ? portal : undefined,
        canEditAnnouncement: announcement ? announcement.canEditAnnouncement : undefined
    };
});
var $2abee41b760fbdec$export$2e2bcd8739ae039 = (0, $6umft.default)($2abee41b760fbdec$var$selector, {
    openChatSideBar: $jbwFT.openChatSideBar,
    closeChatSideBar: $jbwFT.closeChatSideBar,
    fetchPortal: (0, $hijaX.fetchPortalAction),
    fetchUser: (0, $fecgs.fetchUserModelAction),
    fetchCategories: (0, $eSLE4.fetchCategoriesAction),
    fetchRequestCreate: (0, $1mt5N.fetchRequestCreateAction),
    fetchUiModifications: (0, $aXlr1.fetchUiModificationsAction)
})((0, $613oU.default)({
    componentName: 'PortalHome'
})((0, $azARG.default)()($2abee41b760fbdec$export$2521bdc6772d1464)));

});
parcelRegister("epa1X", function(module, exports) {
$parcel$export(module.exports, "withExperience", () => $fac4fe366765b31a$export$7733b94414b7dcb7);
$parcel$export(module.exports, "Experience", () => (parcelRequire("7egf9")).default);

var $fc4bM = parcelRequire("fc4bM");

var $7egf9 = parcelRequire("7egf9");
const $fac4fe366765b31a$export$7733b94414b7dcb7 = (experienceName)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $fc4bM.createElement((0, $7egf9.default), {
                name: experienceName
            }, /*#__PURE__*/ $fc4bM.createElement(Component, props));
        };

});

parcelRegister("2SHxh", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => (parcelRequire("6CHcz")).isChatSideBarOpen);

var $6CHcz = parcelRequire("6CHcz");

});
parcelRegister("6CHcz", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => $4b26efc232bdf8a1$export$d16875019bc5532b);
const $4b26efc232bdf8a1$export$d16875019bc5532b = (state)=>state.ui.chatDetails.isChatSideBarOpen;

});


parcelRegister("1xUIS", function(module, exports) {
$parcel$export(module.exports, "getFormName", () => (parcelRequire("jfaQa")).getFormName);
$parcel$export(module.exports, "getFormIntro", () => (parcelRequire("jfaQa")).getFormIntro);
$parcel$export(module.exports, "getFormInstructions", () => (parcelRequire("jfaQa")).getFormInstructions);
$parcel$export(module.exports, "getIconUrl", () => (parcelRequire("jfaQa")).getIconUrl);
$parcel$export(module.exports, "getRequestCreate", () => (parcelRequire("jfaQa")).getRequestCreate);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("jfaQa")).getProjectId);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("jfaQa")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("jfaQa")).getIssueTypeId);
$parcel$export(module.exports, "getRequestCreateOrError", () => (parcelRequire("jfaQa")).getRequestCreateOrError);
$parcel$export(module.exports, "getCanCreateUsers", () => (parcelRequire("jfaQa")).getCanCreateUsers);
$parcel$export(module.exports, "getDateFormat", () => (parcelRequire("jfaQa")).getDateFormat);
$parcel$export(module.exports, "getDateTimeFormat", () => (parcelRequire("jfaQa")).getDateTimeFormat);
$parcel$export(module.exports, "getFirstDay", () => (parcelRequire("jfaQa")).getFirstDay);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => (parcelRequire("jfaQa")).getUseISO8601WeekNumbers);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => (parcelRequire("jfaQa")).getOrganisationsForCurrentUser);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => (parcelRequire("jfaQa")).getRequestTypeHasProformaForm);
$parcel$export(module.exports, "getProformaTemplateForm", () => (parcelRequire("jfaQa")).getProformaTemplateForm);
$parcel$export(module.exports, "getIsProformaFormDirty", () => (parcelRequire("jfaQa")).getIsProformaFormDirty);
$parcel$export(module.exports, "getIsPrefillPending", () => (parcelRequire("jfaQa")).getIsPrefillPending);

var $jfaQa = parcelRequire("jfaQa");

});
parcelRegister("jfaQa", function(module, exports) {
$parcel$export(module.exports, "getRequestCreate", () => $3dbe19002e066016$export$15c8c5e17b9baa02);
$parcel$export(module.exports, "getFormName", () => $3dbe19002e066016$export$fbe1ca2f3d088136);
$parcel$export(module.exports, "getFormIntro", () => $3dbe19002e066016$export$aa9648d61391326c);
$parcel$export(module.exports, "getIconUrl", () => $3dbe19002e066016$export$89d1c740383224f4);
$parcel$export(module.exports, "getFormInstructions", () => $3dbe19002e066016$export$76982f53d034f6b1);
$parcel$export(module.exports, "getRequestCreateOrError", () => $3dbe19002e066016$export$16e5e434a1b5c95e);
$parcel$export(module.exports, "getProjectId", () => $3dbe19002e066016$export$89040d072f281f85);
$parcel$export(module.exports, "getIssueType", () => $3dbe19002e066016$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $3dbe19002e066016$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getCanCreateUsers", () => $3dbe19002e066016$export$cbe7d03f30fd0cb4);
$parcel$export(module.exports, "getDateFormat", () => $3dbe19002e066016$export$fa96065c64444af6);
$parcel$export(module.exports, "getDateTimeFormat", () => $3dbe19002e066016$export$c9c87e313820bd4c);
$parcel$export(module.exports, "getFirstDay", () => $3dbe19002e066016$export$456eb4e172ef8704);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => $3dbe19002e066016$export$defea3d86e4ab71a);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => $3dbe19002e066016$export$fb4f9a76e583ce63);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => $3dbe19002e066016$export$740668767bebf9a);
$parcel$export(module.exports, "getProformaTemplateForm", () => $3dbe19002e066016$export$9cb4f66aa30e267a);
$parcel$export(module.exports, "getIsProformaFormDirty", () => $3dbe19002e066016$export$cd859d45f5982e2);
$parcel$export(module.exports, "getIsPrefillPending", () => $3dbe19002e066016$export$c1f5b3a2b47daad);
const $3dbe19002e066016$export$830c804e8d921bba = (state, portalId, requestTypeId)=>{
    if (!portalId || !requestTypeId) return undefined;
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.form;
};
const $3dbe19002e066016$export$fbe1ca2f3d088136 = (state, portalId, requestTypeId)=>{
    const form = $3dbe19002e066016$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.name;
};
const $3dbe19002e066016$export$aa9648d61391326c = (state, portalId, requestTypeId)=>{
    const form = $3dbe19002e066016$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.intro;
};
const $3dbe19002e066016$export$89d1c740383224f4 = (state, portalId, requestTypeId)=>{
    const form = $3dbe19002e066016$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.iconUrl;
};
const $3dbe19002e066016$export$76982f53d034f6b1 = (state, portalId, requestTypeId)=>{
    const form = $3dbe19002e066016$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.instructions;
};
const $3dbe19002e066016$export$d5523731e7fe4ded = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.fields;
};
const $3dbe19002e066016$export$b87c6f04552c18ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiUploadToken;
};
const $3dbe19002e066016$export$ddddbd1696231d6a = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiError;
};
const $3dbe19002e066016$export$15c8c5e17b9baa02 = (state, portalId, requestTypeId)=>{
    const data = $3dbe19002e066016$export$16e5e434a1b5c95e(state, portalId, requestTypeId);
    return data && 'error' in data ? undefined : data;
};
const $3dbe19002e066016$export$16e5e434a1b5c95e = (state, portalId, requestTypeId)=>{
    const id = `${portalId}/${requestTypeId}`;
    return state.persisted.requestCreate[id];
};
const $3dbe19002e066016$export$89040d072f281f85 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.projectId;
};
const $3dbe19002e066016$export$ed2455632bf977ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueType;
};
const $3dbe19002e066016$export$110c9a4a16c5b8c9 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueTypeId;
};
const $3dbe19002e066016$export$36651d42b0b3e63 = (state, portalId, requestTypeId)=>{
    const form = $3dbe19002e066016$export$830c804e8d921bba(state, portalId, requestTypeId);
    return !!form && form.captchaEnabled && !!form.sitekey;
};
const $3dbe19002e066016$export$490b07b05dbf5ae5 = (state, portalId, requestTypeId)=>{
    const form = $3dbe19002e066016$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.captchaEnabled ? form.sitekey : undefined;
};
const $3dbe19002e066016$export$cbe7d03f30fd0cb4 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate && !!requestCreate.canCreateUsers;
};
const $3dbe19002e066016$export$fa96065c64444af6 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateFormat;
};
const $3dbe19002e066016$export$c9c87e313820bd4c = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateTimeFormat;
};
const $3dbe19002e066016$export$456eb4e172ef8704 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.firstDay;
};
const $3dbe19002e066016$export$defea3d86e4ab71a = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.useISO8601WeekNumbers;
};
const $3dbe19002e066016$export$fb4f9a76e583ce63 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate ? requestCreate.organisationsForCurrentUser : [];
};
const $3dbe19002e066016$export$2808eba338b2ae16 = (state, portalId, requestTypeId)=>{
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && requestCreate.projectHasProformaForms);
};
const $3dbe19002e066016$export$740668767bebf9a = (state, portalId, requestTypeId)=>{
    var _requestCreate$profor;
    const requestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && (_requestCreate$profor = requestCreate.proforma) !== null && _requestCreate$profor !== void 0 && _requestCreate$profor.formExists);
};
const $3dbe19002e066016$export$9cb4f66aa30e267a = (state, portalId, requestTypeId)=>{
    var _getRequestCreate;
    const proformaTemplateForm = (_getRequestCreate = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) === null || _getRequestCreate === void 0 ? void 0 : _getRequestCreate.proformaTemplateForm;
    if (!proformaTemplateForm || Object.keys(proformaTemplateForm).length === 0) return undefined;
    return proformaTemplateForm;
};
const $3dbe19002e066016$export$cd859d45f5982e2 = (state, portalId, requestTypeId)=>{
    var _getRequestCreate2;
    return !!((_getRequestCreate2 = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate2 !== void 0 && _getRequestCreate2.proformaFormIsDirty);
};
const $3dbe19002e066016$export$c1f5b3a2b47daad = (state, portalId, requestTypeId)=>{
    var _getRequestCreate3;
    return !!((_getRequestCreate3 = $3dbe19002e066016$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate3 !== void 0 && _getRequestCreate3.prefillPending);
};

});


parcelRegister("9D5bd", function(module, exports) {
$parcel$export(module.exports, "PortalHomeDumb", () => (parcelRequire("fgV0H")).default);

var $fgV0H = parcelRequire("fgV0H");

});
parcelRegister("fgV0H", function(module, exports) {
$parcel$export(module.exports, "default", () => $55b04e6aaa15a881$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $dbhrd = parcelRequire("dbhrd");

var $04E2Q = parcelRequire("04E2Q");

var $9mazR = parcelRequire("9mazR");

var $aHS3M = parcelRequire("aHS3M");

var $iya1I = parcelRequire("iya1I");

var $9J2wU = parcelRequire("9J2wU");

var $hN5YJ = parcelRequire("hN5YJ");

var $1HEEa = parcelRequire("1HEEa");

var $6LH8a = parcelRequire("6LH8a");

var $fcCIH = parcelRequire("fcCIH");
parcelRequire("ieUrC");
var $euVUr = parcelRequire("euVUr");

var $ddiJA = parcelRequire("ddiJA");

var $cBamM = parcelRequire("cBamM");
parcelRequire("llKl2");
var $27yMc = parcelRequire("27yMc");
var $57bUW = parcelRequire("57bUW");
parcelRequire("7EPpJ");
var $fko08 = parcelRequire("fko08");
parcelRequire("e2U4l");
var $8min0 = parcelRequire("8min0");
parcelRequire("kOWPe");
var $bwpot = parcelRequire("bwpot");
parcelRequire("bK2QR");
var $7Fgg2 = parcelRequire("7Fgg2");

var $aJJ7z = parcelRequire("aJJ7z");

var $cf4bF = parcelRequire("cf4bF");

var $ixenv = parcelRequire("ixenv");
parcelRequire("blonq");
var $4m70N = parcelRequire("4m70N");

var $l0QpJ = parcelRequire("l0QpJ");
parcelRequire("cNyOd");
var $9JyQP = parcelRequire("9JyQP");

var $7d7Uj = parcelRequire("7d7Uj");

var $deOmO = parcelRequire("deOmO");
parcelRequire("ch4dJ");
var $kjLl6 = parcelRequire("kjLl6");

var $9jO1B = parcelRequire("9jO1B");

var $3TJLC = parcelRequire("3TJLC");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $1zYKE = parcelRequire("1zYKE");

var $d7r8x = parcelRequire("d7r8x");

var $5svsU = parcelRequire("5svsU");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $g9ziK = parcelRequire("g9ziK");

var $gczYx = parcelRequire("gczYx");

var $039iL = parcelRequire("039iL");

var $fzCD5 = parcelRequire("fzCD5");

var $7gm7u = parcelRequire("7gm7u");
parcelRequire("26cjK");
var $keHIJ = parcelRequire("keHIJ");
var $fqmIx = parcelRequire("fqmIx");
var $gMzVJ = parcelRequire("gMzVJ");

var $dQMHQ = parcelRequire("dQMHQ");
parcelRequire("gcRsK");
var $dJF35 = parcelRequire("dJF35");
parcelRequire("cLft7");
var $dDlpZ = parcelRequire("dDlpZ");

var $eyEcW = parcelRequire("eyEcW");
const $55b04e6aaa15a881$var$validateRequestGroupIdPresent = (requestGroupId)=>{
    if (requestGroupId === -1) return false;
    return !!requestGroupId;
};
const $55b04e6aaa15a881$var$getConnectPageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $04E2Q.REQUEST_CREATE;
    return 0, $04E2Q.PORTAL_HOME;
};
const $55b04e6aaa15a881$var$getForgePageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $1HEEa.FORGE_REQUEST_CREATE;
    return 0, $1HEEa.FORGE_PORTAL_HOME;
};
const $55b04e6aaa15a881$var$getPortalHomeTitle = ({ intl: intl, portalName: portalName, requestTypeName: requestTypeName, requestGroupId: requestGroupId })=>{
    if (requestTypeName) return intl.formatMessage((0, $eyEcW.default).requestTypePageTitle, {
        portalName: portalName,
        requestTypeName: requestTypeName
    });
    if (requestGroupId) return intl.formatMessage((0, $eyEcW.default).portalGroupPageTitle, {
        portalName: portalName
    });
    return intl.formatMessage((0, $eyEcW.default).portalPageTitle, {
        portalName: portalName
    });
};
const $55b04e6aaa15a881$var$PortalHome = ({ intl: intl, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, portalName: portalName, portalId: portalId, projectId: projectId, loading: loading, requestTypeId: requestTypeId, requestGroupId: requestGroupId, sideBarOpen: sideBarOpen, announcement: announcement, categories: categories, canEditAnnouncement: canEditAnnouncement, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectAdmin: isProjectAdmin, isAtlassianManagedAccount: isAtlassianManagedAccount, toggleSidebar: toggleSidebar, screenName: screenName, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction })=>{
    const customiseSidebarTriggerRef = (0, $bwpot.useCustomiseSidebarTriggerRef)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { [(0, $fqmIx.REFERRER_QUERY_PARAM)]: referrer } = (0, $dJF35.useQueryParams)();
    const [isSubmitting, setIsSubmitting] = (0, $fc4bM.useState)(false);
    const openSidebar = (0, $fc4bM.useCallback)(()=>toggleSidebar(true), [
        toggleSidebar
    ]);
    const closeSidebar = (0, $fc4bM.useCallback)(()=>toggleSidebar(false), [
        toggleSidebar
    ]);
    const openChatSidebarCallback = (0, $fc4bM.useCallback)(()=>openChatSideBarAction === null || openChatSideBarAction === void 0 ? void 0 : openChatSideBarAction(), [
        openChatSideBarAction
    ]);
    const closeChatSidebarCallback = (0, $fc4bM.useCallback)(()=>closeChatSideBarAction === null || closeChatSideBarAction === void 0 ? void 0 : closeChatSideBarAction(), [
        closeChatSideBarAction
    ]);
    const onSubmit = (0, $fc4bM.useCallback)(()=>setIsSubmitting(true), [
        setIsSubmitting
    ]);
    const onSubmitComplete = (0, $fc4bM.useCallback)(()=>setIsSubmitting(false), [
        setIsSubmitting
    ]);
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const renderVsaChatSidebar = ()=>{
        if (!portalId || !isChatSideBarOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $l0QpJ.LazyVirtualServiceAgentChatSidebar), {
            isOpen: true,
            onOpen: openChatSidebarCallback,
            onClose: closeChatSidebarCallback,
            portalId: portalId
        }));
    };
    const renderSidebar = ()=>{
        if (!canEditAnnouncement) return null;
        if ((0, $cf3fd.isKoshEnabledForDefaultHelpCenter)() && !isBrandingLoaded) // since check in shouldRenderAsPortalAnnouncement is dependent on "canCustomiseHelpCenter" which is coming from helpCenter model, we need to make sure branding relay call is completed
        return null;
        // Render the new 'next-gen' side bar, either as just the Announcement for agents with permission or with all customisation features available for admins
        if (shouldRenderAsPortalAnnouncement()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7d7Uj.LazyPortalSettingsAnnouncementSidebar), {
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euVUr.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $deOmO.LazyPortalSettingsSidebar), {
            isProjectSimplified: isProjectSimplified,
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
    };
    const key = String(requestTypeId);
    const title = portalName && $55b04e6aaa15a881$var$getPortalHomeTitle({
        intl: intl,
        portalName: portalName,
        requestTypeName: requestTypeName,
        requestGroupId: requestGroupId
    });
    const shouldRenderDropdown = !!requestGroupId || !categories || !categories.length;
    const shouldShowRequestsInBreadcrumbs = !!shouldRenderDropdown && categories && !!categories.length;
    const isExternalLinksVisible = projectId && !$55b04e6aaa15a881$var$validateRequestGroupIdPresent(requestGroupId) && !requestTypeId;
    const shouldShowSkeleton = projectId && requestTypeId; // show only on request create page (for now)
    const LoadingIndicator = shouldShowSkeleton ? (0, $7Fgg2.SkeletonLoadingContainer) : (0, $8min0.default);
    const cloudId = (0, $6LH8a.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isVirtualAgentLoading } = (0, $039iL.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const shouldShowLearnByDoingExperimentBanner = (0, $gMzVJ.shouldShowLearnByDoingBanner)(isProjectAdmin, referrer);
    if ((0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g9ziK.Redirect), {
        to: '/'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aHS3M.default), {
        title: title,
        ignoreBaseTitle: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(LoadingIndicator, {
        isLoading: loading,
        enableUFOHold: true,
        ufoHoldName: "portal-home-dumb-fallback"
    }, loading && !announcement && !(0, $hN5YJ.isUseHelpCenterRefresh)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "announcement-banner-loading"
    }), !!announcement && !(0, $hN5YJ.isUseHelpCenterRefresh)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dbhrd.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: $55b04e6aaa15a881$var$AnnouncementInnerContainer
    }), requestGroupId && portalId && requestTypeId && !requestTypeBelongsToGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g9ziK.Redirect), {
        to: `/portal/${portalId}/group/${requestGroupId}`,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                [(0, $fqmIx.REFERRER_QUERY_PARAM)]: referrer
            }
        }
    }, shouldShowLearnByDoingExperimentBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        testId: "learn-by-doing-container",
        xcss: $55b04e6aaa15a881$var$LearnByDoingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $keHIJ.default), {
        screenName: screenName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m70N.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7gm7u.UiModificationsEntryPoint), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dDlpZ.default), {
        showRequestsInBreadcrumbs: shouldShowRequestsInBreadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kjLl6.default), null, projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ddiJA.BlockedAppsBanner), {
        page: $55b04e6aaa15a881$var$getForgePageType(requestTypeId),
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $57bUW.default), {
        page: $55b04e6aaa15a881$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ixenv.ForgeHeaderModule), {
        page: $55b04e6aaa15a881$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    }), isVirtualAgentLoading && !(0, $hN5YJ.isHideVsaEndpointsEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "virtual-agent-banner-loading"
    }), isVirtualAgentEnabled && !(0, $hN5YJ.isHideVsaEndpointsEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $55b04e6aaa15a881$var$virtualBannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fzCD5.VirtualAgentBanner), {
        cloudId: cloudId,
        portalId: portalId
    })), !requestGroupId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($55b04e6aaa15a881$export$b1b1a7643a727bbc, {
        portalId: portalId
    }), shouldRenderDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($55b04e6aaa15a881$export$a096e20ba94bf2ce, {
        autoFocus: false,
        portalId: portalId,
        requestGroupId: requestGroupId,
        requestTypeId: requestTypeId,
        isDisabled: isSubmitting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9JyQP.default), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9jO1B.RequestCreateForm), {
        portalId: portalId,
        requestTypeId: requestTypeId,
        key: key,
        onSubmit: onSubmit,
        onSubmitComplete: onSubmitComplete
    }), isExternalLinksVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($55b04e6aaa15a881$var$ExternalLinksListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aJJ7z.ExternalLinks), {
        projectId: projectId
    })), projectId && isAtlassianManagedAccount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dQMHQ.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: (0, $5svsU.JiraProjectAri).create({
            projectId: projectId.toString(),
            siteId: cloudId
        }).toString(),
        surface: "PORTAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $27yMc.default), {
        page: $55b04e6aaa15a881$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cf4bF.ForgeFooterModule), {
        page: $55b04e6aaa15a881$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR,
        id: 'portal-home-sidebar'
    }, sideBarOpen && renderSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).HELP_CENTER_VSA_CHAT_SIDEBAR,
        id: 'portal-home-vsa-chat-sidebar'
    }, isChatSideBarOpen && renderVsaChatSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gczYx.SidebarToggle), {
        openSidebar: openSidebar,
        closeSidebar: closeSidebar
    })));
};
const $55b04e6aaa15a881$export$22ca00a6007ba086 = (0, $9J2wU.withErrorPage)($55b04e6aaa15a881$var$PortalHome, {
    isEmptyTraceIdLogExcluded: true
});
var $55b04e6aaa15a881$export$2e2bcd8739ae039 = (0, $fcCIH.default)($55b04e6aaa15a881$export$22ca00a6007ba086);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $55b04e6aaa15a881$var$AnnouncementInnerContainer = /*#__PURE__*/ (0, $luz1X.default)((0, $4m70N.PaperContent)).withConfig({
    componentId: "sc-1lc3w8v-0"
})`padding-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $55b04e6aaa15a881$var$ExternalLinksListWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1lc3w8v-1"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $55b04e6aaa15a881$export$a096e20ba94bf2ce = /*#__PURE__*/ (0, $luz1X.default)((0, $fko08.default)).withConfig({
    componentId: "sc-1lc3w8v-2"
})`margin:${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-100, 8px)"};position:relative;`;
const $55b04e6aaa15a881$export$b1b1a7643a727bbc = /*#__PURE__*/ (0, $luz1X.default)((0, $cBamM.CategoryList)).withConfig({
    componentId: "sc-1lc3w8v-3"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $55b04e6aaa15a881$var$virtualBannerStyles = (0, $kig2V.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.200'
});
const $55b04e6aaa15a881$var$LearnByDoingContainerStyles = (0, $kig2V.xcss)({
    height: '266px',
    display: 'none',
    [(0, $1zYKE.media).above.md]: {
        display: 'flex'
    }
});

});
parcelRegister("ddiJA", function(module, exports) {
$parcel$export(module.exports, "BlockedAppsBanner", () => $78baad3c8482dcbe$export$757c2c7994b73daa);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("ls5vm");
var $uekef = parcelRequire("uekef");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $8IuxF = parcelRequire("8IuxF");

var $613oU = parcelRequire("613oU");
const $78baad3c8482dcbe$var$blockedAppsBannerSelector = (0, $2n2bS.createSelector)((0, $uekef.getBlockedAppsBannerStatePortal), (0, $uekef.getBlockedAppsBannerStateRequestView), (0, $uekef.getBlockedAppsBannerStateCreateRequest), (0, $uekef.getBlockedAppsBannerStateCsmRequestCreate), (0, $7RWiC.getAccountId), (portal, viewRequest, createRequest, csmRequestCreate, accountId)=>{
    return {
        accountId: accountId,
        blockedAppsBannerState: {
            portal: portal,
            view_request: viewRequest,
            create_request: createRequest,
            csm_create_request: csmRequestCreate
        }
    };
});
const $78baad3c8482dcbe$export$757c2c7994b73daa = (0, $6umft.default)($78baad3c8482dcbe$var$blockedAppsBannerSelector)((0, $613oU.default)({
    componentName: 'blockedAppBanner'
})((0, $8IuxF.default)));

});
parcelRegister("ls5vm", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => (parcelRequire("uekef")).getBlockedAppsBannerStatePortal);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => (parcelRequire("uekef")).getBlockedAppsBannerStateCreateRequest);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => (parcelRequire("uekef")).getBlockedAppsBannerStateRequestView);
$parcel$export(module.exports, "getBlockedAppsBannerStateCsmRequestCreate", () => (parcelRequire("uekef")).getBlockedAppsBannerStateCsmRequestCreate);

var $uekef = parcelRequire("uekef");

});
parcelRegister("uekef", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => $df0e8000ea965b9d$export$5d00eff3ead4a783);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => $df0e8000ea965b9d$export$5e1a47e73ae7249);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => $df0e8000ea965b9d$export$4b185f1cda5a42b9);
$parcel$export(module.exports, "getBlockedAppsBannerStateCsmRequestCreate", () => $df0e8000ea965b9d$export$af4a28eee1c6b301);
const $df0e8000ea965b9d$export$5d00eff3ead4a783 = (state)=>{
    return state.persisted.blockedAppsBanner.portal || state.persisted.blockedAppsBanner.connect.portal;
};
const $df0e8000ea965b9d$export$5e1a47e73ae7249 = (state)=>{
    return state.persisted.blockedAppsBanner.view_request || state.persisted.blockedAppsBanner.connect.view_request;
};
const $df0e8000ea965b9d$export$4b185f1cda5a42b9 = (state)=>{
    return state.persisted.blockedAppsBanner.create_request || state.persisted.blockedAppsBanner.connect.create_request;
};
const $df0e8000ea965b9d$export$af4a28eee1c6b301 = (state)=>{
    return state.persisted.blockedAppsBanner.csm_create_request;
};

});


parcelRegister("8IuxF", function(module, exports) {
$parcel$export(module.exports, "default", () => $67be240bb64542e0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $1HEEa = parcelRequire("1HEEa");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $k2M4v = parcelRequire("k2M4v");

var $dtvmL = parcelRequire("dtvmL");

var $56eZ1 = parcelRequire("56eZ1");

var $eENmG = parcelRequire("eENmG");

var $2AdoZ = parcelRequire("2AdoZ");

var $gioQl = parcelRequire("gioQl");

var $zW6hK = parcelRequire("zW6hK");
const $67be240bb64542e0$export$6db1cbf096e6afb2 = 'sd.portal.blocked.apps.banner.learnMore';
const $67be240bb64542e0$export$f35e1704e0ced261 = 'sd.portal.blocked.apps.banner.doNotShow';
const $67be240bb64542e0$var$getStyles = (page)=>{
    if (page === (0, $1HEEa.FORGE_REQUEST_DETAILS)) return {
        marginBottom: `${"var(--ds-space-300, 24px)"}`
    };
    return {
        marginTop: `${"var(--ds-space-300, 24px)"}`
    };
};
const $67be240bb64542e0$export$1cac45d8ffd5ecc3 = (accountId, projectId)=>{
    return `showBlockedAppsBanner-${projectId}-${accountId}`;
};
const $67be240bb64542e0$var$BlockedAppsBannerComponent = ({ blockedAppsBannerState: blockedAppsBannerState, page: page, projectId: projectId, isAtlassianManagedAccount: isAtlassianManagedAccount, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const [showBannerForProject, setShowBannerForProject] = (0, $fc4bM.useState)(false);
    const doNotShowClickHandler = (0, $fc4bM.useCallback)(()=>{
        if (accountId) (0, $2AdoZ.setLocalStorageItem)($67be240bb64542e0$export$1cac45d8ffd5ecc3(accountId, projectId), 'false');
        setShowBannerForProject(false);
    }, [
        accountId,
        projectId
    ]);
    const learnMoreUrl = (0, $fc4bM.useMemo)(()=>{
        return (0, $gioQl.getLearnMoreUrl)();
    }, []);
    const isBannerCondtionsSatisfied = !!blockedAppsBannerState && // @ts-ignore
    !!blockedAppsBannerState[page] && isAtlassianManagedAccount && showBannerForProject;
    (0, $fc4bM.useEffect)(()=>{
        if (accountId) {
            const showBannerStatus = (0, $2AdoZ.getLocalStorageItem)($67be240bb64542e0$export$1cac45d8ffd5ecc3(accountId, projectId));
            if (showBannerStatus && showBannerStatus === 'false') setShowBannerForProject(false);
            else setShowBannerForProject(true);
        }
    }, [
        accountId,
        projectId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (isBannerCondtionsSatisfied) {
            const event = createAnalyticsEvent({
                analyticsType: (0, $eENmG.UI_EVENT_TYPE),
                action: 'viewed',
                actionSubject: 'blockedAppBanner',
                attributes: {
                    page: page,
                    userType: isAtlassianManagedAccount ? 'isAtlassianManagedAccount' : 'customer'
                }
            });
            event.fire();
        }
    }, [
        createAnalyticsEvent,
        isBannerCondtionsSatisfied,
        accountId,
        projectId,
        isAtlassianManagedAccount,
        page
    ]);
    if (isBannerCondtionsSatisfied) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        style: $67be240bb64542e0$var$getStyles(page)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dtvmL.default), {
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $56eZ1.default), {
                testId: $67be240bb64542e0$export$6db1cbf096e6afb2,
                href: learnMoreUrl,
                key: $67be240bb64542e0$export$6db1cbf096e6afb2
            }, formatMessage((0, $zW6hK.default).learnMore)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $56eZ1.default), {
                testId: $67be240bb64542e0$export$f35e1704e0ced261,
                onClick: doNotShowClickHandler,
                key: $67be240bb64542e0$export$f35e1704e0ced261
            }, formatMessage((0, $zW6hK.default).doNotShow))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("p", null, (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $zW6hK.default).bannerDescriptionGalaxia) : formatMessage((0, $zW6hK.default).bannerDescription)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null);
};
var $67be240bb64542e0$export$2e2bcd8739ae039 = $67be240bb64542e0$var$BlockedAppsBannerComponent;

});
parcelRegister("56eZ1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3769ddc79d42f92$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v3.0.2 */ /* section-message-action.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $kTVlm = parcelRequire("kTVlm");

var $4Cnkn = parcelRequire("4Cnkn");

var $dM0Q8 = parcelRequire("dM0Q8");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");
const $f3769ddc79d42f92$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_2rkolb4i _syaz13af _k48p1wq8 _bfhk1j28 _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $f3769ddc79d42f92$var$SectionMessageAction = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }, ref)=>{
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            className: (0, $2R2iS.default)([
                $f3769ddc79d42f92$var$styles.common,
                $f3769ddc79d42f92$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dM0Q8.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                ref: ref,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $4Cnkn.cx)($f3769ddc79d42f92$var$styles.common, $f3769ddc79d42f92$var$styles.pressable),
            ref: ref,
            children: children
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
            as: "span",
            testId: testId,
            xcss: $f3769ddc79d42f92$var$styles.common,
            ref: ref,
            children: children
        });
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kTVlm.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref,
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
        children: children
    });
}));
$f3769ddc79d42f92$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $f3769ddc79d42f92$export$2e2bcd8739ae039 = $f3769ddc79d42f92$var$SectionMessageAction;

});

parcelRegister("zW6hK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee501165a82e0776$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $ee501165a82e0776$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    bannerDescription: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this project through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description'
    },
    bannerDescriptionGalaxia: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this space through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description-galaxia'
    },
    doNotShow: {
        defaultMessage: "Don't show again",
        description: 'Do not show again link. When the user clicks on this, he will not see the blocked apps banner again',
        id: 'sd.portal.blocked.app.banner.doNotShow'
    },
    learnMore: {
        defaultMessage: 'View blocked apps',
        description: 'This is a link that the users can click to view the blocked apps',
        id: 'sd.portal.blocked.app.banner.learnMore'
    }
});

});



parcelRegister("cBamM", function(module, exports) {
$parcel$export(module.exports, "CategoryList", () => $3b4dd932681fd891$export$79717968ed9ae6cd);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $jhwDd = parcelRequire("jhwDd");
const $3b4dd932681fd891$var$selector = (0, $2n2bS.createSelector)((state, props)=>(0, $9D9SX.getCategories)(state, props.portalId), (state, props)=>(0, $9D9SX.getIsKbEnabled)(state, props.portalId), (state, props)=>(0, $9D9SX.getPortalLink)(state, props.portalId), (state, props)=>(0, $9D9SX.canCreateRequest)(state, props.portalId), (maybeCategories, enabled, portalLink, showRequestCreateButton)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        hidden: !enabled
    };
});
const $3b4dd932681fd891$export$79717968ed9ae6cd = (0, $6umft.default)($3b4dd932681fd891$var$selector)((0, $jhwDd.default));

});
parcelRegister("jhwDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6f668c9db9597b4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");

var $fd880 = parcelRequire("fd880");
parcelRequire("2sJSQ");
var $ei4x6 = parcelRequire("ei4x6");
parcelRequire("fQcId");
var $5SLMu = parcelRequire("5SLMu");

var $3TJLC = parcelRequire("3TJLC");

var $dMHtF = parcelRequire("dMHtF");

var $lvRbB = parcelRequire("lvRbB");
parcelRequire("bWVrP");
var $b0wFU = parcelRequire("b0wFU");

var $Uw9Au = parcelRequire("Uw9Au");
class $d6f668c9db9597b4$export$2e2bcd8739ae039 extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        portalId: undefined,
        categories: []
    };
    render() {
        const { portalId: portalId, categories: categories, portalLink: portalLink, hidden: hidden, cardLinkAppearance: cardLinkAppearance, className: className, showRequestCreateButton: showRequestCreateButton, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        if (hidden || !portalId || categories.length === 0) return null;
        const analyticData = {
            attributes: {
                numberOfCategories: categories.length
            }
        };
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: analyticData
        }, /*#__PURE__*/ $fc4bM.createElement($d6f668c9db9597b4$export$be92b6f5f03c0fe9, {
            className: className
        }, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), /*#__PURE__*/ $fc4bM.createElement($d6f668c9db9597b4$var$CategorySectionTitle, null, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dMHtF))), {
            spacing: "spacious",
            label: "",
            "aria-hidden": "true",
            color: "var(--ds-icon, #42526E)"
        }), /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $Uw9Au.default).kbCategorySectionTitle)), /*#__PURE__*/ $fc4bM.createElement($d6f668c9db9597b4$var$CategoryItems, null, categories.map((category)=>/*#__PURE__*/ $fc4bM.createElement($d6f668c9db9597b4$var$CategoryItemContainer, {
                key: category.id
            }, /*#__PURE__*/ $fc4bM.createElement((0, $b0wFU.default), {
                portalId: portalId,
                category: category,
                isEmbeddedRoute: isEmbeddedRoute
            })))), showRequestCreateButton && /*#__PURE__*/ $fc4bM.createElement((0, $5SLMu.default), {
            appearance: cardLinkAppearance,
            to: portalLink,
            isEmbeddedRoute: isEmbeddedRoute
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d6f668c9db9597b4$var$CategorySectionTitle = /*#__PURE__*/ (0, $luz1X.default).h2.withConfig({
    componentId: "sc-12gjrid-0"
})`${$imLe4.h500};display:flex;align-items:center;font-weight:600;margin-bottom:0;> :first-child{margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d6f668c9db9597b4$var$CategoryItems = /*#__PURE__*/ (0, $luz1X.default).ul.withConfig({
    componentId: "sc-12gjrid-1"
})`padding:0;margin:0 -${(0, $ei4x6.GROUP_BOX_PADDING_LEFT_RIGHT)} ${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d6f668c9db9597b4$var$CategoryItemContainer = /*#__PURE__*/ (0, $luz1X.default).li.withConfig({
    componentId: "sc-12gjrid-2"
})`padding:0;margin:0;list-style:none;`;
const $d6f668c9db9597b4$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-12gjrid-3"
})`flex:1 1 auto;`;

});
parcelRegister("bWVrP", function(module, exports) {
$parcel$export(module.exports, "CategoryItem", () => (parcelRequire("b0wFU")).default);

var $b0wFU = parcelRequire("b0wFU");

});
parcelRegister("b0wFU", function(module, exports) {
$parcel$export(module.exports, "default", () => $98a9c57adf6f0648$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("3bkQR");
var $5GNfO = parcelRequire("5GNfO");

var $3TJLC = parcelRequire("3TJLC");
class $98a9c57adf6f0648$export$2e2bcd8739ae039 extends $fc4bM.Component {
    render() {
        const { category: category, portalId: portalId, onClick: onClick, className: className, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        const analyticData = {
            attributes: {
                portalId: portalId,
                categoryId: category.id
            }
        };
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: analyticData
        }, /*#__PURE__*/ $fc4bM.createElement((0, $5GNfO.default), {
            actionSubjectId: "category",
            to: `/portal/${portalId}/topic/${category.id}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: onClick,
            heading: category.name,
            headingAs: "div",
            isAriaHidden: true,
            description: category.description,
            lineClamp: 2,
            target: isEmbeddedRoute ? '_blank' : undefined
        }));
    }
}

});


parcelRegister("Uw9Au", function(module, exports) {
$parcel$export(module.exports, "default", () => $63ccd60329ed6c24$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $63ccd60329ed6c24$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    kbCategorySectionTitle: {
        defaultMessage: 'Learn more about',
        description: 'Section title for a section that shows a list of knowledge base categories',
        id: 'cv.portal.home.kb.category.section.title'
    }
});

});



parcelRegister("llKl2", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("57bUW")).default);
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("27yMc")).default);
/*
  Previously a distinction was made between the single portal and request-create pages when rendering connect fragments.
  In Portal X, the portal home and request create page display the same connect fragments.
*/ parcelRequire("hvzsx");
var $57bUW = parcelRequire("57bUW");
parcelRequire("5NwRQ");
var $27yMc = parcelRequire("27yMc");

});
parcelRegister("hvzsx", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("57bUW")).default);

var $57bUW = parcelRequire("57bUW");

});
parcelRegister("57bUW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce3548f898f0b78e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8qhwO = parcelRequire("8qhwO");
var $04E2Q = parcelRequire("04E2Q");
const $ce3548f898f0b78e$var$HeaderConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $8qhwO.ConnectFragment), {
        page: page,
        location: (0, $04E2Q.HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }), /*#__PURE__*/ $fc4bM.createElement((0, $8qhwO.ConnectFragment), {
        page: page,
        location: (0, $04E2Q.SUB_HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $ce3548f898f0b78e$export$2e2bcd8739ae039 = $ce3548f898f0b78e$var$HeaderConnectFragments;

});


parcelRegister("5NwRQ", function(module, exports) {
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("27yMc")).default);

var $27yMc = parcelRequire("27yMc");

});
parcelRegister("27yMc", function(module, exports) {
$parcel$export(module.exports, "default", () => $896b0d116aad74bc$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $8qhwO = parcelRequire("8qhwO");
var $04E2Q = parcelRequire("04E2Q");
const $896b0d116aad74bc$var$FooterConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $fc4bM.createElement($896b0d116aad74bc$var$ConnectFooterContainer, null, /*#__PURE__*/ $fc4bM.createElement((0, $8qhwO.ConnectFragment), {
        page: page,
        location: (0, $04E2Q.FOOTER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $896b0d116aad74bc$export$2e2bcd8739ae039 = $896b0d116aad74bc$var$FooterConnectFragments;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $896b0d116aad74bc$var$ConnectFooterContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1lbb1kc-0"
})`padding-top:0;padding-bottom:0;`;

});



parcelRegister("7EPpJ", function(module, exports) {
$parcel$export(module.exports, "FormPicker", () => (parcelRequire("fko08")).default);

var $fko08 = parcelRequire("fko08");

});
parcelRegister("fko08", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4108310459a585b$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("7h8sD");
var $8EcmC = parcelRequire("8EcmC");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("2iiVB");
var $cInef = parcelRequire("cInef");
const $d4108310459a585b$var$getRequestTypes = (state, props)=>(0, $9D9SX.getPortalRequestTypes)(state, props.portalId);
const $d4108310459a585b$var$getRequestGroups = (state, props)=>(0, $9D9SX.getPortalRequestGroups)(state, props.portalId);
const $d4108310459a585b$var$getIsSimplifiedPortal = (state, props)=>Boolean((0, $9D9SX.getIsProjectSimplified)(state, props.portalId));
const $d4108310459a585b$var$getPortalProjectKey = (state, props)=>{
    const projectKey = (0, $9D9SX.getProjectKey)(state, props === null || props === void 0 ? void 0 : props.portalId);
    return (projectKey === null || projectKey === void 0 ? void 0 : projectKey.toString()) || '';
};
const $d4108310459a585b$var$getIsProjectAdmin = (state, props)=>{
    return Boolean((0, $9D9SX.getCanAdministerProject)(state, props.portalId));
};
const $d4108310459a585b$var$getIsJiraAdmin = (state, _)=>{
    return Boolean((0, $7RWiC.getCanAdministerJIRA)(state));
};
const $d4108310459a585b$var$getRequestTypeNameById = (id, requestTypes)=>{
    const requestType = requestTypes.find((reqType)=>reqType.id === id);
    return requestType ? {
        name: requestType.name,
        id: requestType.id
    } : undefined;
};
const $d4108310459a585b$var$getRequestTypeNames = (groupReqTypes = [], portalReqGroups)=>groupReqTypes.map((id)=>$d4108310459a585b$var$getRequestTypeNameById(id, portalReqGroups)).filter(Boolean);
const $d4108310459a585b$var$populateRequestTypeNames = (portalReqTypes)=>(requestGroup)=>({
            ...requestGroup,
            reqTypes: $d4108310459a585b$var$getRequestTypeNames(requestGroup.reqTypes, portalReqTypes)
        });
const $d4108310459a585b$var$selector = (0, $2n2bS.createSelector)($d4108310459a585b$var$getRequestGroups, $d4108310459a585b$var$getRequestTypes, (0, $8EcmC.getPortals), $d4108310459a585b$var$getIsSimplifiedPortal, $d4108310459a585b$var$getPortalProjectKey, $d4108310459a585b$var$getIsProjectAdmin, $d4108310459a585b$var$getIsJiraAdmin, (requestGroups, requestTypes, allPortals, isProjectSimplified, projectKey, isProjectAdmin, isJiraAdmin)=>({
        requestTypes: requestTypes,
        isProjectSimplified: isProjectSimplified,
        projectKey: projectKey,
        isProjectAdmin: isProjectAdmin,
        isJiraAdmin: isJiraAdmin,
        requestGroups: requestGroups.map($d4108310459a585b$var$populateRequestTypeNames(requestTypes)),
        // displayLinkWhenNoGroups will only return true if portals data is already populated. If this page is accessed by direct link, it'll return false.
        // As it's such an edge case, it was decided that's enough.
        displayLinkWhenNoGroups: Object.keys(allPortals).length > 1
    }));
var $d4108310459a585b$export$2e2bcd8739ae039 = (0, $6umft.default)($d4108310459a585b$var$selector)((0, $cInef.default));

});
parcelRegister("2iiVB", function(module, exports) {
$parcel$export(module.exports, "FormPickerDumb", () => (parcelRequire("cInef")).default);

var $cInef = parcelRequire("cInef");

});
parcelRegister("cInef", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eaecc3843b3a70e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $iya1I = parcelRequire("iya1I");

var $fRgxR = parcelRequire("fRgxR");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");
parcelRequire("dXpgS");
var $bYfqS = parcelRequire("bYfqS");
var $dAUq0 = parcelRequire("dAUq0");
var $eVksZ = parcelRequire("eVksZ");

var $lvRbB = parcelRequire("lvRbB");

var $diqlM = parcelRequire("diqlM");

var $6rayQ = parcelRequire("6rayQ");
parcelRequire("26cjK");
var $fqmIx = parcelRequire("fqmIx");
parcelRequire("96EjI");
var $kPHiO = parcelRequire("kPHiO");
parcelRequire("aGQgU");
var $cBqUC = parcelRequire("cBqUC");

var $2bShK = parcelRequire("2bShK");
class $0eaecc3843b3a70e$export$600c4eef2a10987b extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        // Required to explicitly set this to false by default as the <AutoFocus />
        // component will focus when it is `undefined`.
        autoFocus: false
    };
    render() {
        const { requestGroupId: requestGroupId, requestTypeId: requestTypeId, portalId: portalId, requestGroups: requestGroups, isDisabled: isDisabled, className: className, intl: intl, hideLabels: hideLabels, autoFocus: autoFocus, cardLinkAppearance: cardLinkAppearance, displayLinkWhenNoGroups: displayLinkWhenNoGroups, isEmbeddedRoute: isEmbeddedRoute, isCSM: isCSM, isProjectSimplified: isProjectSimplified, projectKey: projectKey, isProjectAdmin: isProjectAdmin } = this.props;
        const hasSingleRequestGroup = requestGroups.length === 1;
        const hasRequestGroup = requestGroups.length > 0;
        // If a group id is passed through that isn't actually inside the request groups array we make it undefined
        const matchingRequestGroupId = !!requestGroups.find((group)=>group.id === requestGroupId) ? requestGroupId : undefined;
        // If there is only one element in the request groups array we force it to be selected.
        const selectedRequestGroupId = hasSingleRequestGroup ? requestGroups[0].id : matchingRequestGroupId;
        const requestTypesForGroup = this.getRequestTypesForSelectedRequestGroup(selectedRequestGroupId);
        // If a type id is passed through that isn't actually inside the request types array we make it undefined
        const selectedRequestTypeId = !!requestTypesForGroup.find((requestType)=>Number(requestType.id) === Number(requestTypeId)) ? requestTypeId : undefined;
        const { customizePortalButtonsGroup: customizePortalButtonsGroup, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.getAdditionButtons(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId);
        return hasRequestGroup ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $fc4bM.createElement("div", {
            className: className
        }, hasSingleRequestGroup || /*#__PURE__*/ $fc4bM.createElement((0, $kPHiO.default), {
            autoFocus: autoFocus && !selectedRequestGroupId,
            portalId: portalId,
            requestGroups: requestGroups,
            label: !!hideLabels ? '' : intl.formatMessage((0, $2bShK.default).requestGroupSelectLabel),
            value: selectedRequestGroupId,
            onChange: this.selectRequestGroup,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            labelHeadingAs: "h2",
            ...!!customizePortalButtonsGroup && {
                customizePortalButtonsGroup: customizePortalButtonsGroup
            }
        }), !!requestTypesForGroup.length && /*#__PURE__*/ $fc4bM.createElement($0eaecc3843b3a70e$export$d9d410f2d2df162e, {
            hasTopMargin: !hasSingleRequestGroup,
            autoFocus: autoFocus && !!selectedRequestGroupId,
            portalId: portalId,
            requestGroupId: selectedRequestGroupId,
            label: this.getStyledRequestTypeSelectLabel(),
            requestTypes: requestTypesForGroup,
            value: selectedRequestTypeId,
            onChange: this.selectRequestType,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            isCSM: isCSM,
            headingAs: "div",
            labelHeadingAs: "h2",
            ...!!editRequestTypeOnRequestForm && {
                editRequestTypeOnRequestForm: editRequestTypeOnRequestForm
            },
            ...!!editRequestTypeOnRequestList && {
                editRequestTypeOnRequestList: editRequestTypeOnRequestList
            }
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $fc4bM.createElement("div", {
            className: className
        }, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2bShK.default).emptyStateMessage), ' ', displayLinkWhenNoGroups && /*#__PURE__*/ $fc4bM.createElement((0, $fRgxR.default), {
            actionSubjectId: "tryAnotherServiceDesk",
            to: "/portals"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2bShK.default).tryAnotherServiceProjectLink)));
    }
    getAdditionButtons(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId) {
        const shouldShowAdditionalPortalLinks = isProjectAdmin && !isProjectSimplified;
        const customizePortalButtonsGroup = projectKey !== null && projectKey !== void 0 && projectKey.length && shouldShowAdditionalPortalLinks ? /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
            id: "customize-portal-button-group",
            renderError: ()=>null
        }, /*#__PURE__*/ $fc4bM.createElement((0, $bYfqS.default), {
            projectKey: projectKey
        })) : null;
        const editRequestTypeOnRequestForm = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestTypeId && shouldShowAdditionalPortalLinks ? /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
            id: "edit-request-type-button",
            renderError: ()=>null
        }, /*#__PURE__*/ $fc4bM.createElement((0, $dAUq0.default), {
            projectKey: projectKey,
            requestTypeId: selectedRequestTypeId
        })) : null;
        const editRequestTypeOnRequestList = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestGroupId && shouldShowAdditionalPortalLinks ? (requestTypeId, ariaLabel)=>/*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
                id: "edit-request-type-button",
                renderError: ()=>null
            }, /*#__PURE__*/ $fc4bM.createElement((0, $eVksZ.default), {
                projectKey: projectKey,
                requestTypeId: requestTypeId,
                ariaLabel: ariaLabel
            })) : null;
        return {
            customizePortalButtonsGroup: customizePortalButtonsGroup,
            editRequestTypeOnRequestForm: editRequestTypeOnRequestForm,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        };
    }
    constructor(...args){
        super(...args), this.getRequestTypesForSelectedRequestGroup = (requestGroupId)=>{
            const { requestTypes: requestTypes, requestGroups: requestGroups } = this.props;
            if (requestGroupId) {
                const selectedRequestGroup = requestGroups.find((requestGroup)=>requestGroup.id === requestGroupId);
                if (selectedRequestGroup) return selectedRequestGroup.reqTypes.map((reqType)=>requestTypes.find((rt)=>rt.id === reqType.id)).filter(Boolean);
            }
            return [];
        }, this.selectRequestGroup = (id)=>{
            // If id is undefined we push back to the /:portalId/group/-1 route.
            // This covers the case if there are article categories on the portal.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            const referrer = $6rayQ.get((0, $fqmIx.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            (0, $diqlM.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${this.props.portalId}/group/${id || '-1'}`,
                search: shouldAddReferrer ? `?${0, $fqmIx.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.selectRequestType = (id)=>{
            const { requestGroups: requestGroups, portalId: portalId, requestGroupId: requestGroupId } = this.props;
            const hasSingleRequestGroup = requestGroups.length === 1;
            const groupId = hasSingleRequestGroup ? requestGroups[0].id : requestGroupId;
            const referrer = $6rayQ.get((0, $fqmIx.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            (0, $diqlM.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${portalId}/group/${groupId}${id ? `/create/${id}` : ''}`,
                search: shouldAddReferrer ? `?${0, $fqmIx.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.getStyledRequestTypeSelectLabel = ()=>{
            const { hideLabels: hideLabels, intl: intl, isCSM: isCSM } = this.props;
            if (!!hideLabels) return '';
            if (isCSM) return intl.formatMessage((0, $2bShK.default).CSMRequestTypeSelectLabel);
            return intl.formatMessage((0, $2bShK.default).requestTypeSelectLabel);
        };
    }
}
var $0eaecc3843b3a70e$export$2e2bcd8739ae039 = (0, $fcCIH.default)($0eaecc3843b3a70e$export$600c4eef2a10987b);
const $0eaecc3843b3a70e$export$d9d410f2d2df162e = /*#__PURE__*/ (0, $luz1X.default)((0, $cBqUC.default)).withConfig({
    componentId: "sc-1hnffkr-0"
})`margin-top:${(props)=>props.hasTopMargin ? "var(--ds-space-400, 32px)" : 0};`;

});
parcelRegister("dXpgS", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("bYfqS")).default);
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("dAUq0")).default);
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("eVksZ")).default);
parcelRequire("1d6dJ");
var $bYfqS = parcelRequire("bYfqS");
parcelRequire("9dJub");
var $dAUq0 = parcelRequire("dAUq0");
parcelRequire("8BNAY");
var $eVksZ = parcelRequire("eVksZ");

});
parcelRegister("1d6dJ", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("bYfqS")).default);

var $bYfqS = parcelRequire("bYfqS");

});
parcelRegister("bYfqS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e42f46c7ac535ee6$export$2e2bcd8739ae039);
/* customize-portal-button-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $613oU = parcelRequire("613oU");

var $jEubQ = parcelRequire("jEubQ");

var $2VysO = parcelRequire("2VysO");

var $k2M4v = parcelRequire("k2M4v");

var $6NnMd = parcelRequire("6NnMd");

var $26fPW = parcelRequire("26fPW");

var $k8Adr = parcelRequire("k8Adr");

var $eENmG = parcelRequire("eENmG");

var $gioQl = parcelRequire("gioQl");

var $hRcQs = parcelRequire("hRcQs");
const $e42f46c7ac535ee6$var$ISSUE_A11Y_37386 = 'issue-a11y-37386';
const $e42f46c7ac535ee6$var$isIssueA11y37386Enabled = ()=>(0, $k2M4v.default).checkGate($e42f46c7ac535ee6$var$ISSUE_A11Y_37386);
const $e42f46c7ac535ee6$var$ButtonStyles = null;
const $e42f46c7ac535ee6$var$CustomizePortalButtonFolderOpenIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6NnMd))), {
        ...iconProps,
        label: $e42f46c7ac535ee6$var$isIssueA11y37386Enabled() ? '' : formatMessage((0, $hRcQs.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $e42f46c7ac535ee6$var$CustomizePortalButtonGroup = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { projectKey: projectKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const onClickManagePortalGroups = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'managePortalGroupsButton',
            action: 'clicked',
            actionSubject: 'CustomizePortalButtonGroup',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $fc4bM.createElement((0, $26fPW.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2VysO.default), {
        href: (0, $gioQl.getPortalGroupSettingsUrl)(projectKey),
        appearance: "subtle",
        target: "_blank",
        testId: "manage-portal-groups-button",
        onClick: onClickManagePortalGroups,
        iconBefore: $e42f46c7ac535ee6$var$CustomizePortalButtonFolderOpenIcon
    }, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $hRcQs.default).managePortalGroupsLabel)))));
};
var $e42f46c7ac535ee6$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'CustomizePortalButtonGroup'
})($e42f46c7ac535ee6$var$CustomizePortalButtonGroup);

});
parcelRegister("2VysO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8fe6771f1856959$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ /* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $4dCfH = parcelRequire("4dCfH");

var $8PakO = parcelRequire("8PakO");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $6m8y3 = parcelRequire("6m8y3");

var $dw5IO = parcelRequire("dw5IO");
const $d8fe6771f1856959$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _10531gmx _jomr187o _f8pj1gmx _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $d8fe6771f1856959$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $d8fe6771f1856959$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $d8fe6771f1856959$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _irr31afz _1di61kru"
};
const $d8fe6771f1856959$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $d8fe6771f1856959$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $d8fe6771f1856959$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $d8fe6771f1856959$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $d8fe6771f1856959$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $d8fe6771f1856959$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $fc4bM.useRef)(null);
    (0, $8PakO.default)(localRef, autoFocus);
    const combinedRef = (0, $4dCfH.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5Ny1Q.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $4Cnkn.cx)($d8fe6771f1856959$var$styles.base, !isDisabled && $d8fe6771f1856959$var$styles.interactiveMotion, appearance === 'default' && $d8fe6771f1856959$var$defaultStyles.root, appearance === 'primary' && $d8fe6771f1856959$var$primaryStyles.root, appearance === 'rovo' && $d8fe6771f1856959$var$rovoStyles.root, appearance === 'warning' && $d8fe6771f1856959$var$warningStyles.root, appearance === 'danger' && $d8fe6771f1856959$var$dangerStyles.root, appearance === 'discovery' && $d8fe6771f1856959$var$discoveryStyles.root, appearance === 'subtle' && $d8fe6771f1856959$var$subtleStyles.root, $d8fe6771f1856959$var$styles.linkDecorationUnset, isSelected && $d8fe6771f1856959$var$selectedStyles.root, isSelected && appearance === 'danger' && $d8fe6771f1856959$var$selectedStyles.danger, isSelected && appearance === 'warning' && $d8fe6771f1856959$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $d8fe6771f1856959$var$selectedStyles.discovery, isDisabled && $d8fe6771f1856959$var$styles.disabled, spacing === 'compact' && $d8fe6771f1856959$var$styles.spacingCompact, hasIconBefore && $d8fe6771f1856959$var$styles.buttonIconBefore, hasIconAfter && $d8fe6771f1856959$var$styles.buttonIconAfter, shouldFitContainer && $d8fe6771f1856959$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6m8y3.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                    icon: iconBefore,
                    spacing: spacing
                })
            }),
            children && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6m8y3.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6m8y3.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dw5IO.default), {
                    icon: iconAfter,
                    spacing: spacing
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $d8fe6771f1856959$var$LinkButton = /*#__PURE__*/ (0, $fc4bM.forwardRef)($d8fe6771f1856959$var$LinkButtonBase);
$d8fe6771f1856959$var$LinkButton.displayName = 'LinkButton';
var $d8fe6771f1856959$export$2e2bcd8739ae039 = $d8fe6771f1856959$var$LinkButton;

});

parcelRegister("6NnMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43f19c9c1a27a90187893d14cfaa1965>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f29c33ee1b7deee$var$_react = $4f29c33ee1b7deee$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $4f29c33ee1b7deee$var$_iconNew = $4f29c33ee1b7deee$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $4f29c33ee1b7deee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-open
 * Usage guidance:
 * Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f29c33ee1b7deee$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $4f29c33ee1b7deee$var$_react.default.createElement($4f29c33ee1b7deee$var$_iconNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$4f29c33ee1b7deee$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $4f29c33ee1b7deee$var$_default = module.exports.default = $4f29c33ee1b7deee$var$FolderOpenIcon;

});

parcelRegister("hRcQs", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7268f5ecf8afb6d$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $c7268f5ecf8afb6d$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    managePortalGroupsLabel: {
        defaultMessage: 'Manage portal groups',
        description: 'Button text to Navigate user to Manage Portal Groups in JSM',
        id: 'help-center.app.common.customize-portal-buttons.manage-portal-groups-label'
    },
    editRequestTypeLabel: {
        defaultMessage: 'Edit request type',
        description: 'Button text to Navigate user to Request Type editor in JSM',
        id: 'help-center.app.common.customize-portal-buttons.edit-request-type-label'
    }
});

});



parcelRegister("9dJub", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("dAUq0")).default);

var $dAUq0 = parcelRequire("dAUq0");

});
parcelRegister("dAUq0", function(module, exports) {
$parcel$export(module.exports, "default", () => $92f09763cfddcffa$export$2e2bcd8739ae039);
/* edit-request-type-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $613oU = parcelRequire("613oU");

var $jEubQ = parcelRequire("jEubQ");

var $2VysO = parcelRequire("2VysO");

var $5BrPA = parcelRequire("5BrPA");

var $k8Adr = parcelRequire("k8Adr");

var $26fPW = parcelRequire("26fPW");

var $eENmG = parcelRequire("eENmG");

var $gioQl = parcelRequire("gioQl");

var $hRcQs = parcelRequire("hRcQs");
const $92f09763cfddcffa$var$EditRequestTypeButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const onClickButton = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $fc4bM.createElement((0, $26fPW.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2VysO.default), {
        href: (0, $gioQl.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-button",
        onClick: onClickButton,
        iconBefore: $92f09763cfddcffa$var$EditRequestTypeButtonEditIcon
    }, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $hRcQs.default).editRequestTypeLabel)))));
};
const $92f09763cfddcffa$var$EditRequestTypeButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5BrPA))), {
        ...iconProps,
        label: formatMessage((0, $hRcQs.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $92f09763cfddcffa$var$ButtonStyles = null;
var $92f09763cfddcffa$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'EditRequestTypeButton'
})($92f09763cfddcffa$var$EditRequestTypeButton);

});
parcelRegister("5BrPA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64841177977326ccd1f2b755f9ee3f4a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4145ff1b534bba92$var$_react = $4145ff1b534bba92$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $4145ff1b534bba92$var$_iconNew = $4145ff1b534bba92$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $4145ff1b534bba92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/edit
 * Usage guidance:
 * Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4145ff1b534bba92$var$EditIcon = (props)=>/*#__PURE__*/ $4145ff1b534bba92$var$_react.default.createElement($4145ff1b534bba92$var$_iconNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$4145ff1b534bba92$var$EditIcon.displayName = 'EditIcon';
var $4145ff1b534bba92$var$_default = module.exports.default = $4145ff1b534bba92$var$EditIcon;

});



parcelRegister("8BNAY", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("eVksZ")).default);

var $eVksZ = parcelRequire("eVksZ");

});
parcelRegister("eVksZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $13b67ebdcfd4d109$export$2e2bcd8739ae039);
/* edit-request-type-hover-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $613oU = parcelRequire("613oU");

var $jEubQ = parcelRequire("jEubQ");

var $2VysO = parcelRequire("2VysO");

var $5BrPA = parcelRequire("5BrPA");

var $k2M4v = parcelRequire("k2M4v");

var $k8Adr = parcelRequire("k8Adr");

var $eENmG = parcelRequire("eENmG");

var $gioQl = parcelRequire("gioQl");

var $hRcQs = parcelRequire("hRcQs");
const $13b67ebdcfd4d109$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $13b67ebdcfd4d109$var$isHcAdsDropCommit2Enabled = ()=>(0, $k2M4v.default).checkGate($13b67ebdcfd4d109$var$HC_ADS_DROP_COMMIT_2);
const $13b67ebdcfd4d109$var$EditRequestTypeHoverButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId, ariaLabel: ariaLabel } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const onClickButton = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeHoverButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
    };
    const defaultLabel = formatMessage((0, $hRcQs.default).editRequestTypeLabel);
    const label = ariaLabel ? `${defaultLabel} - ${ariaLabel}` : defaultLabel;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-testid": "edit-request-type-hover-button-wrapper",
        className: (0, $2R2iS.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _vchhusvi",
            $13b67ebdcfd4d109$var$isHcAdsDropCommit2Enabled() && "_2rko1qi0"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2VysO.default), {
        href: (0, $gioQl.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-hover-button",
        onClick: onClickButton,
        spacing: "compact",
        shouldFitContainer: true,
        iconBefore: $13b67ebdcfd4d109$var$EditRequestTypeHoverButtonEditIcon,
        "aria-label": label
    }, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, defaultLabel)));
};
const $13b67ebdcfd4d109$var$EditRequestTypeHoverButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5BrPA))), {
        ...iconProps,
        label: formatMessage((0, $hRcQs.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #505258)"
    });
};
const $13b67ebdcfd4d109$var$ButtonStyles = null;
// hc_ads_drop_commit_2: ADS drop 2 bumps the request-description tile radius.
const $13b67ebdcfd4d109$var$buttonShapeThemeStyles = null;
var $13b67ebdcfd4d109$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'EditRequestTypeHoverButton'
})($13b67ebdcfd4d109$var$EditRequestTypeHoverButton);

});



parcelRegister("26cjK", function(module, exports) {
$parcel$export(module.exports, "LearnByDoing", () => (parcelRequire("keHIJ")).default);
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => (parcelRequire("gMzVJ")).shouldShowLearnByDoingBanner);
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => (parcelRequire("fqmIx")).REFERRER_QUERY_PARAM);

var $keHIJ = parcelRequire("keHIJ");

var $gMzVJ = parcelRequire("gMzVJ");

var $fqmIx = parcelRequire("fqmIx");

});
parcelRegister("keHIJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc13e7b5cef3490c$export$2e2bcd8739ae039);

var $luz1X = parcelRequire("luz1X");

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $613oU = parcelRequire("613oU");

var $hR4ky = parcelRequire("hR4ky");

var $2VysO = parcelRequire("2VysO");

var $1hJdJ = parcelRequire("1hJdJ");

var $jaqgn = parcelRequire("jaqgn");

var $dRkX9 = parcelRequire("dRkX9");

var $1JdzP = parcelRequire("1JdzP");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");

var $1zYKE = parcelRequire("1zYKE");

var $4T8rw = parcelRequire("4T8rw");

var $eENmG = parcelRequire("eENmG");

var $4kzni = parcelRequire("4kzni");

var $eZCqA = parcelRequire("eZCqA");
var $bc13e7b5cef3490c$export$8400747e4d4d02ee = /*#__PURE__*/ function(StepNumber) {
    StepNumber[StepNumber["STEP1"] = 0] = "STEP1";
    StepNumber[StepNumber["STEP2"] = 1] = "STEP2";
    StepNumber[StepNumber["STEP3"] = 2] = "STEP3";
    return StepNumber;
}({});
const $bc13e7b5cef3490c$var$LearnByDoing = ({ projectRedirectionLink: projectRedirectionLink, screenName: screenName })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const getStepNumber = ()=>{
        let step;
        if (screenName === (0, $9mazR.ScreenName).PORTAL_HOME || screenName === (0, $9mazR.ScreenName).REQUEST_GROUP) step = 0;
        else if (screenName === (0, $9mazR.ScreenName).REQUEST_CREATE) step = 1;
        else if (screenName === (0, $9mazR.ScreenName).REQUEST_DETAILS) step = 2;
        else step = -1;
        return step;
    };
    (0, $fc4bM.useEffect)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubject: 'learnByDoing',
            attributes: {
                screenName: screenName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        screenName
    ]);
    const stepNumber = getStepNumber();
    const steps = (0, $fc4bM.useMemo)(()=>[
            {
                stepNumber: 0,
                title: formatMessage((0, $eZCqA.default).chooseRequestTypeHeading),
                description: formatMessage((0, $eZCqA.default).chooseRequestTypeDesc)
            },
            {
                stepNumber: 1,
                title: formatMessage((0, $eZCqA.default).sendExampleRequestHeading),
                description: formatMessage((0, $eZCqA.default).sendExampleRequestDesc)
            },
            {
                stepNumber: 2,
                title: formatMessage((0, $eZCqA.default).requestCreatedHeading),
                description: formatMessage((0, $dRkX9.fg)('itsm-project-renaming') ? (0, $eZCqA.default).requestCreatedDescGalaxia : (0, $eZCqA.default).requestCreatedDesc)
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hR4ky.default), null, stepNumber >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        alignInline: "center",
        alignBlock: "center",
        xcss: $bc13e7b5cef3490c$var$LearnByDoingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
        xcss: $bc13e7b5cef3490c$var$LearnByDoingStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "medium"
    }, formatMessage((0, $eZCqA.default).learnByDoingDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
        xcss: $bc13e7b5cef3490c$var$LearnByDoingFlowStyle
    }, steps.map((step, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
            xcss: [
                $bc13e7b5cef3490c$var$LearnByDoingStepDefaultStyle,
                index === stepNumber && $bc13e7b5cef3490c$var$LearnByDoingStepActiveStyle,
                index < stepNumber && $bc13e7b5cef3490c$var$LearnByDoingStepDisableStyle
            ],
            key: `step-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
            xcss: [
                $bc13e7b5cef3490c$var$StepNumberContainerDefaultStyle,
                index === stepNumber && $bc13e7b5cef3490c$var$StepNumberContainerActiveStyle,
                index < stepNumber && $bc13e7b5cef3490c$var$StepNumberContainerDisableStyle
            ]
        }, index >= stepNumber ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
            alignItems: "center",
            xcss: [
                $bc13e7b5cef3490c$var$headingContainerStepNumberDefaultStyles,
                index === stepNumber && $bc13e7b5cef3490c$var$headingContainerStepNumberActiveStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bc13e7b5cef3490c$var$_StyledBox, null, step.stepNumber + 1)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jaqgn))), {
            label: "success",
            color: "var(--ds-icon-accent-green, #189864)",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
            xcss: $bc13e7b5cef3490c$var$ContentStyle,
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
            size: "small"
        }, step.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $bc13e7b5cef3490c$var$descriptionStyles
        }, step.description), index === steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
            xcss: $bc13e7b5cef3490c$var$QueuesRedirectButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2VysO.default), {
            href: projectRedirectionLink ?? '#',
            appearance: "discovery",
            isDisabled: !projectRedirectionLink,
            testId: "project-redirect-link",
            analyticsContext: {
                actionSubjectId: 'learnByDoingRedirect'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
            weight: "medium",
            color: !projectRedirectionLink ? 'color.text.disabled' : 'color.text.inverse'
        }, formatMessage((0, $eZCqA.default).queuesRedirectLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1JdzP.Flex), {
            xcss: $bc13e7b5cef3490c$var$nextStepImageStyle
        }, index !== steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4kzni))),
            alt: ""
        })));
    })))));
};
const $bc13e7b5cef3490c$var$LearnByDoingWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: "learnByDoing",
        id: "create-request",
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bc13e7b5cef3490c$var$LearnByDoing, props));
};
var $bc13e7b5cef3490c$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'LearnByDoing'
})($bc13e7b5cef3490c$var$LearnByDoingWithErrorBoundary);
const $bc13e7b5cef3490c$var$LearnByDoingWrapper = (0, $kig2V.xcss)({
    width: 'auto',
    position: 'absolute',
    right: 'space.400',
    left: 'space.400',
    height: '266px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.large'
});
const $bc13e7b5cef3490c$var$LearnByDoingStyles = (0, $kig2V.xcss)({
    display: 'none',
    width: '100%',
    maxWidth: '1200px',
    gap: 'space.200',
    paddingBlock: 'space.300',
    paddingInline: 'space.300',
    borderRadius: 'radius.small',
    [(0, $1zYKE.media).above.md]: {
        display: 'flex'
    },
    [(0, $1zYKE.media).above.lg]: {
        // Max valid space token space.1000 = 80px, have to use px to make it correctly aligned
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingRight: '108px',
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingLeft: '88px'
    }
});
const $bc13e7b5cef3490c$var$LearnByDoingFlowStyle = (0, $kig2V.xcss)({
    width: '100%',
    gap: 'space.500',
    [(0, $1zYKE.media).above.lg]: {
        gap: 'space.600'
    }
});
const $bc13e7b5cef3490c$var$LearnByDoingStepDefaultStyle = (0, $kig2V.xcss)({
    gap: 'space.150',
    padding: 'space.200',
    backgroundColor: 'color.background.input',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    minHeight: '150px',
    position: 'relative',
    flex: '1 1 0px',
    [(0, $1zYKE.media).above.lg]: {
        gap: 'space.200'
    }
});
const $bc13e7b5cef3490c$var$LearnByDoingStepActiveStyle = (0, $kig2V.xcss)({
    backgroundColor: 'color.background.input',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    borderColor: 'color.border.discovery'
});
const $bc13e7b5cef3490c$var$LearnByDoingStepDisableStyle = (0, $kig2V.xcss)({
    backgroundColor: 'color.background.discovery',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $bc13e7b5cef3490c$var$StepNumberContainerDefaultStyle = (0, $kig2V.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    width: '40px',
    height: '40px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.full',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'center'
});
const $bc13e7b5cef3490c$var$StepNumberContainerActiveStyle = (0, $kig2V.xcss)({
    backgroundColor: 'color.background.discovery.bold'
});
const $bc13e7b5cef3490c$var$StepNumberContainerDisableStyle = (0, $kig2V.xcss)({
    backgroundColor: 'color.background.success'
});
const $bc13e7b5cef3490c$var$headingContainerStepNumberDefaultStyles = (0, $kig2V.xcss)({
    height: "var(--ds-space-250, 20px)",
    color: 'color.text.discovery'
});
const $bc13e7b5cef3490c$var$headingContainerStepNumberActiveStyles = (0, $kig2V.xcss)({
    color: 'color.text.inverse'
});
const $bc13e7b5cef3490c$var$stepNumberStyles = (0, $kig2V.xcss)({
    font: 'font.heading.small'
});
const $bc13e7b5cef3490c$var$nextStepImageStyle = (0, $kig2V.xcss)({
    zIndex: 'card',
    position: 'absolute',
    top: 'space.300',
    right: '-52px',
    [(0, $1zYKE.media).above.lg]: {
        right: '-60px'
    }
});
const $bc13e7b5cef3490c$var$ContentStyle = (0, $kig2V.xcss)({
    width: '100%',
    gap: 'space.050'
});
const $bc13e7b5cef3490c$var$descriptionStyles = (0, $kig2V.xcss)({
    color: 'color.text.subtle',
    font: 'font.body'
});
const $bc13e7b5cef3490c$var$QueuesRedirectButtonStyles = (0, $kig2V.xcss)({
    width: 'fit-content',
    marginTop: 'space.050'
});
var $bc13e7b5cef3490c$var$_StyledBox = /*#__PURE__*/ /*#__PURE__*/ (0, $luz1X.default)((0, $5a4EU.Box)).withConfig({
    componentId: "sc-1fng6fm-0"
}).withConfig({
    componentId: "sc-1fng6fm-1"
})`${$bc13e7b5cef3490c$var$stepNumberStyles}`;

});
parcelRegister("hR4ky", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6bee62cb9a6eb37$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $aehaU = parcelRequire("aehaU");

var $77pV6 = parcelRequire("77pV6");

var $4Ilay = parcelRequire("4Ilay");

var $fsV9t = parcelRequire("fsV9t");

var $gvJqv = parcelRequire("gvJqv");

var $l6UsL = parcelRequire("l6UsL");
function $b6bee62cb9a6eb37$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $l6UsL.useIsInsideAppProvider)();
    (0, $fsV9t.useScrollbarHarmonisation)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4Ilay.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $77pV6.InsideAppProviderContext).Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $aehaU.AppProviderThemingEnabledContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gvJqv.ThemeProvider), {
                defaultColorMode: defaultColorMode,
                defaultTheme: defaultTheme,
                children: routerLinkProvider
            })
        })
    });
}
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { AppProvider } from '@atlaskit/app-provider/app-provider'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$b6bee62cb9a6eb37$export$2e2bcd8739ae039 = $b6bee62cb9a6eb37$export$c7dacf3845253dcf;

});
parcelRegister("fsV9t", function(module, exports) {
$parcel$export(module.exports, "useScrollbarHarmonisation", () => $4a3e7bb76aa601d9$export$6a82770d3a3903f7);

var $fc4bM = parcelRequire("fc4bM");

var $j5N6B = parcelRequire("j5N6B");

var $dRkX9 = parcelRequire("dRkX9");

var $ep4SK = parcelRequire("ep4SK");
function $4a3e7bb76aa601d9$export$6a82770d3a3903f7(isEnabled) {
    const isGateEnabled = (0, $dRkX9.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    (0, $fc4bM.useEffect)(()=>{
        if (!shouldEnable) return;
        const targetDocument = (0, $j5N6B.getDocument)();
        if (!targetDocument) return;
        return (0, $ep4SK.installScrollbarHarmonisation)(targetDocument);
    }, [
        shouldEnable
    ]);
}

});
parcelRegister("ep4SK", function(module, exports) {
$parcel$export(module.exports, "installScrollbarHarmonisation", () => $48a97069107f3cbd$export$f289ecff4a99e09d);

var $4KJRy = parcelRequire("4KJRy");

var $1hcIK = parcelRequire("1hcIK");
const $48a97069107f3cbd$var$controllers = new WeakMap();
function $48a97069107f3cbd$export$f289ecff4a99e09d(targetDocument) {
    return (0, $1hcIK.installDocumentAttribute)(targetDocument, (0, $4KJRy.SCROLLBAR_HARMONISATION_ATTRIBUTE), $48a97069107f3cbd$var$controllers);
}

});
parcelRegister("4KJRy", function(module, exports) {
$parcel$export(module.exports, "SCROLLBAR_HARMONISATION_ATTRIBUTE", () => $de65ac25bc3823ba$export$cc97c2566f53fd12);
const $de65ac25bc3823ba$export$cc97c2566f53fd12 = 'data-scrollbar-harmonisation';

});

parcelRegister("1hcIK", function(module, exports) {
$parcel$export(module.exports, "installDocumentAttribute", () => $93e71c493205a91b$export$4d0b2e184ba12ee7);
function $93e71c493205a91b$export$4d0b2e184ba12ee7(targetDocument, attribute, controllers) {
    const existingController = controllers.get(targetDocument);
    if (existingController) {
        existingController.references += 1;
        let isReleased = false;
        return ()=>{
            if (isReleased) return;
            isReleased = true;
            existingController.references -= 1;
            if (existingController.references === 0) {
                existingController.release();
                controllers.delete(targetDocument);
            }
        };
    }
    const rootElement = targetDocument.documentElement;
    const controller = {
        references: 1,
        release: ()=>rootElement.removeAttribute(attribute)
    };
    rootElement.setAttribute(attribute, '');
    controllers.set(targetDocument, controller);
    let isReleased = false;
    return ()=>{
        if (isReleased) return;
        isReleased = true;
        controller.references -= 1;
        if (controller.references === 0) {
            controller.release();
            controllers.delete(targetDocument);
        }
    };
}

});




parcelRegister("jaqgn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97fadb77040fc214fca377f612fb6ef3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df4352c9e962e894$var$_react = $df4352c9e962e894$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $df4352c9e962e894$var$_iconNew = $df4352c9e962e894$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $df4352c9e962e894$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-mark
 * Usage guidance:
 * Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df4352c9e962e894$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $df4352c9e962e894$var$_react.default.createElement($df4352c9e962e894$var$_iconNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$df4352c9e962e894$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $df4352c9e962e894$var$_default = module.exports.default = $df4352c9e962e894$var$CheckMarkIcon;

});

parcelRegister("4kzni", function(module, exports) {
module.exports = new URL("../images/vector.dd7c71e0.svg", import.meta.url).toString();

});

parcelRegister("eZCqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbda68ed9f06497e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $cbda68ed9f06497e$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    learnByDoingDesc: {
        id: 'help-center.learn-by-doing.create-request.description',
        defaultMessage: 'Welcome to the portal! Try raising a request like your customers.',
        description: 'Description for Learn By Doing create Request component'
    },
    chooseRequestTypeHeading: {
        id: 'help-center.learn-by-doing.choose-request-type.heading',
        defaultMessage: 'Choose a request type',
        description: 'Heading for choosing a request type in Learn By Doing component'
    },
    chooseRequestTypeDesc: {
        id: 'help-center.learn-by-doing.choose-request-type.description',
        defaultMessage: 'Request types represent what your team can help customers with.',
        description: 'The text is shown as a description below the "Choose a request type" heading in the Learn By Doing onboarding component, explaining what request types are.'
    },
    sendExampleRequestHeading: {
        id: 'help-center.learn-by-doing.send-example-request.heading',
        defaultMessage: 'Send an example request',
        description: 'Heading for sending an example request in Learn By Doing component'
    },
    sendExampleRequestDesc: {
        id: 'help-center.learn-by-doing.send-example-request.description',
        defaultMessage: 'Fill out the request details, then send it off!',
        description: 'The text is shown as a description below the "Send an example request" heading in the Learn By Doing onboarding component, guiding the user to fill out and submit the example request form.'
    },
    requestCreatedHeading: {
        id: 'help-center.learn-by-doing.request-created.heading',
        defaultMessage: 'Manage request as an agent',
        description: 'Heading after request is created in Learn By Doing component'
    },
    requestCreatedDesc: {
        id: 'help-center.learn-by-doing.request-created.description',
        defaultMessage: 'Assign, add comments and resolve this request in your project.',
        description: 'The text is shown as a description in the Learn By Doing component after a request is created, telling the agent to manage the request in their project.'
    },
    requestCreatedDescGalaxia: {
        id: 'help-center.learn-by-doing.request-created.description-galaxia',
        defaultMessage: 'Assign, add comments and resolve this request in your space.',
        description: 'The text is shown as a description in the Learn By Doing component after a request is created in a Galaxia space, telling the agent to manage the request in their space.'
    },
    queuesRedirectLabel: {
        id: 'help-center.learn-by-doing.queues-redirect.label',
        defaultMessage: 'Go to agent view',
        description: 'The text is shown on a button in the Learn By Doing component after a request is created, redirecting the agent to the queues (agent view) to manage incoming requests.'
    }
});

});


parcelRegister("gMzVJ", function(module, exports) {
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => $5d6886288f996e14$export$54a369ffec06fa13);

var $fqmIx = parcelRequire("fqmIx");
const $5d6886288f996e14$export$54a369ffec06fa13 = (isProjectAdmin, referrer = '')=>isProjectAdmin && (referrer === (0, $fqmIx.GETTING_STARTED_PAGE_LEARN_BY_DOING) || referrer === (0, $fqmIx.YOUR_WORK) || referrer === (0, $fqmIx.SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE));

});
parcelRegister("fqmIx", function(module, exports) {
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => $20cf10f439515125$export$7640e1e223f51f1a);
$parcel$export(module.exports, "SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE", () => $20cf10f439515125$export$95ca3e9dccd62856);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_LEARN_BY_DOING", () => $20cf10f439515125$export$952482a78309d288);
$parcel$export(module.exports, "YOUR_WORK", () => $20cf10f439515125$export$3461424d6e65d62d);
const $20cf10f439515125$export$7640e1e223f51f1a = 'referrer';
const $20cf10f439515125$export$95ca3e9dccd62856 = 'overviewCreateRequest';
const $20cf10f439515125$export$952482a78309d288 = 'gettingStartedPageLearnByDoing';
const $20cf10f439515125$export$3461424d6e65d62d = 'yourWork';

});



parcelRegister("96EjI", function(module, exports) {
$parcel$export(module.exports, "RequestGroupSelect", () => (parcelRequire("kPHiO")).default);

var $kPHiO = parcelRequire("kPHiO");

});
parcelRegister("kPHiO", function(module, exports) {
$parcel$export(module.exports, "default", () => $dffd40691f2f5dba$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $imLe4 = parcelRequire("imLe4");
parcelRequire("jJxtk");
var $7mF3u = parcelRequire("7mF3u");

var $3TJLC = parcelRequire("3TJLC");

var $5T9DI = parcelRequire("5T9DI");

var $6rayQ = parcelRequire("6rayQ");
parcelRequire("26cjK");
var $fqmIx = parcelRequire("fqmIx");
class $dffd40691f2f5dba$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    getRedirectionUrl(requestGroupid, portalId) {
        const referrer = $6rayQ.get((0, $fqmIx.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return `/portal/${portalId}/group/${requestGroupid}${shouldAddReferrer ? `?${0, $fqmIx.REFERRER_QUERY_PARAM}=${referrer}` : ''}`;
    }
    getOptions() {
        const { requestGroups: requestGroups, portalId: portalId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestGroups.map((requestGroup)=>({
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                to: this.getRedirectionUrl(requestGroup === null || requestGroup === void 0 ? void 0 : requestGroup.id, portalId),
                value: requestGroup.id,
                label: requestGroup.name,
                description: /*#__PURE__*/ $fc4bM.createElement($dffd40691f2f5dba$var$RequestTypeList, null, this.formatReqGroupNames(requestGroup.reqTypes)),
                dataTestId: `request-group:${requestGroup.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    formatReqGroupNames(reqTypes) {
        return reqTypes.map((rt)=>rt.name).join(', ');
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, ...props } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: {
                actionSubjectId: 'requestTypeGroups',
                attributes: {
                    portalId: props.portalId,
                    numberOfRequestTypeGroups: props.requestGroups.length
                }
            }
        }, /*#__PURE__*/ $fc4bM.createElement((0, $7mF3u.default), {
            id: "request-group-select",
            actionSubjectId: "requestTypeGroupSelect",
            itemActionSubjectId: "requestTypeGroup",
            listAppearance: "card",
            selectAppearance: "simple",
            label: label,
            labelIcon: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5T9DI))), {
                spacing: "spacious",
                label: '',
                "aria-hidden": "true",
                color: "var(--ds-icon, #42526E)"
            }),
            options: this.getOptions(),
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props
        }));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $dffd40691f2f5dba$var$RequestTypeList = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-1iqgmfs-0"
})`${$imLe4.small};`;

});
parcelRegister("jJxtk", function(module, exports) {
$parcel$export(module.exports, "GroupBoxSelect", () => (parcelRequire("7mF3u")).default);

var $7mF3u = parcelRequire("7mF3u");

});
parcelRegister("7mF3u", function(module, exports) {
$parcel$export(module.exports, "default", () => $732315f46f679964$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $g43xT = parcelRequire("g43xT");

var $imLe4 = parcelRequire("imLe4");

var $3DjOo = parcelRequire("3DjOo");
parcelRequire("fwgWP");
var $1FXn1 = parcelRequire("1FXn1");
parcelRequire("g29WC");
var $k7nnc = parcelRequire("k7nnc");

var $4nCqe = parcelRequire("4nCqe");

var $1JdzP = parcelRequire("1JdzP");

var $kig2V = parcelRequire("kig2V");

var $lvRbB = parcelRequire("lvRbB");

var $6oof1 = parcelRequire("6oof1");
parcelRequire("2sJSQ");
var $23B2e = parcelRequire("23B2e");
var $5GNfO = parcelRequire("5GNfO");
class $732315f46f679964$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    static #_ = this.defaultProps = {
        listAppearance: 'default',
        selectAppearance: 'default'
    };
    getValue() {
        const { value: value, options: options } = this.props;
        if (value) return options.find((option)=>option.value === value);
        return null;
    }
    renderSmallLabel() {
        const { id: id, label: label, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm } = this.props;
        const HeaderComponent = $732315f46f679964$export$105792bf13c50cea;
        return !!editRequestTypeOnRequestForm ? /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $732315f46f679964$var$labelSmallStylesWrapper
        }, /*#__PURE__*/ $fc4bM.createElement(HeaderComponent, null, /*#__PURE__*/ $fc4bM.createElement("label", {
            htmlFor: id
        }, label)), editRequestTypeOnRequestForm) : /*#__PURE__*/ $fc4bM.createElement(HeaderComponent, null, /*#__PURE__*/ $fc4bM.createElement("label", {
            htmlFor: id
        }, label));
    }
    renderBigLabel() {
        const { id: id, label: label, labelIcon: labelIcon, customizePortalButtonsGroup: customizePortalButtonsGroup, labelHeadingAs: labelHeadingAs } = this.props;
        const HeaderComponent = $732315f46f679964$export$2e1776684c14bc89;
        // When a heading element is requested (e.g. "h2") render the visible label
        // text with semantic heading markup so screen reader users can navigate by
        // heading. The label text keeps its visual styling (inherited from the
        // surrounding header) and the wrapping <label htmlFor> is preserved so the
        // text stays associated with the select input.
        const LabelText = labelHeadingAs ? // Render the visible label text with semantic heading markup (e.g. <h2>)
        // so screen reader users can navigate to it by heading. Styling is kept
        // identical to the plain <span> via LabelHeading (inherits font, no margin).
        /*#__PURE__*/ $fc4bM.createElement((0, $4nCqe.LabelHeading), {
            headingTag: labelHeadingAs,
            text: label
        }) : // Important for this to be in a span so we can use CSS selectors to target when
        // there is/isn't a label. Span gives this a proper element.
        /*#__PURE__*/ $fc4bM.createElement("span", null, label);
        return !!customizePortalButtonsGroup ? /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $732315f46f679964$var$labelStylesWrapper
        }, /*#__PURE__*/ $fc4bM.createElement(HeaderComponent, null, /*#__PURE__*/ $fc4bM.createElement($732315f46f679964$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, LabelText)), customizePortalButtonsGroup) : /*#__PURE__*/ $fc4bM.createElement(HeaderComponent, null, /*#__PURE__*/ $fc4bM.createElement($732315f46f679964$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, LabelText));
    }
    renderAsSelect(optionValue) {
        const { id: id, disabled: disabled, options: options, autoFocus: autoFocus, actionSubjectId: actionSubjectId, allowSelectedValueToWrap: allowSelectedValueToWrap } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, this.renderSmallLabel(), /*#__PURE__*/ $fc4bM.createElement((0, $g43xT.Select), {
            actionSubjectId: actionSubjectId,
            inputId: id,
            autoFocus: autoFocus,
            options: options,
            onChange: this.onChange,
            value: optionValue,
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            menuPortalTarget: document.body,
            formatOptionLabel: this.formatOptionLabel,
            isDisabled: disabled,
            menuPlacement: "auto",
            // We want the selected option to be visible so customers can read the description if they desire.
            hideSelectedOptions: false,
            isSearchable: false,
            styles: {
                control: (supplied, { isFocused: isFocused })=>({
                        ...supplied,
                        // Don't allow flex children to wrap, since we reset styles of
                        // the value container we need this.
                        flexWrap: 'nowrap',
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        ':hover': {
                            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            ...supplied[':hover'],
                            backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)",
                            borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)"
                        },
                        backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)",
                        borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                    }),
                valueContainer: ()=>({
                        // We apply our own styles here.
                        //
                        // Overflow hidden so the children show their ellipsis if needed.
                        overflow: 'hidden'
                    }),
                singleValue: ()=>({
                        // We apply our own styles here.
                        //
                        // Since the value is a flex child set its width to 100% so it only
                        // takes up the given space.
                        width: '100%',
                        // These styles are merged over the base styles rather than replacing them, so
                        // react-select's `white-space: nowrap` is still in effect and is inherited by
                        // the value's contents. See `allowSelectedValueToWrap`.
                        ...allowSelectedValueToWrap && {
                            whiteSpace: 'normal'
                        }
                    }),
                option: (_, state)=>({
                        // We apply our own styles here.
                        backgroundColor: state.isFocused ? "var(--ds-surface-hovered, #F4F5F7)" : undefined,
                        cursor: 'pointer',
                        padding: 0,
                        margin: 0,
                        width: '100%'
                    }),
                menu: (styles)=>({
                        ...styles,
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            }
        }));
    }
    renderAsList(optionValue) {
        const { options: options, autoFocus: autoFocus, listAppearance: listAppearance, renderItem: renderItem } = this.props;
        const hasSelectedSingleValue = options.length === 1 && optionValue === options[0];
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), null), hasSelectedSingleValue ? this.renderSmallLabel() : this.renderBigLabel(), /*#__PURE__*/ $fc4bM.createElement($732315f46f679964$export$54c2e3dc7acea9f5, null, options.map((option, index)=>{
            const content = this.renderListItemContent(option, optionValue === option, hasSelectedSingleValue);
            return /*#__PURE__*/ $fc4bM.createElement((0, $1FXn1.AutoFocus), {
                key: option.value,
                isEnabled: autoFocus && index === 0
            }, /*#__PURE__*/ $fc4bM.createElement($732315f46f679964$var$ListItem, {
                withMargin: listAppearance === 'card'
            }, renderItem && !hasSelectedSingleValue ? renderItem(content, index) : content));
        })));
    }
    renderListItemContent(option, isSelected, hasSelectedSingleValue) {
        const { listAppearance: listAppearance, cardLinkAppearance: cardLinkAppearance, itemActionSubjectId: itemActionSubjectId, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.props;
        switch(listAppearance){
            case 'card':
                return /*#__PURE__*/ $fc4bM.createElement((0, $k7nnc.default), {
                    to: option.to,
                    padding: 0,
                    appearance: cardLinkAppearance,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target
                }, /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    lineClamp: isSelected ? 1 : 0
                }));
            case 'default':
            default:
                return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, isSelected ? /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    dataTestId: option.dataTestId,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0
                }) : /*#__PURE__*/ $fc4bM.createElement((0, $5GNfO.default), {
                    icon: option.iconUrl,
                    to: option.to,
                    heading: option.label,
                    description: option.description,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0,
                    selected: isSelected,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target,
                    ...!!editRequestTypeOnRequestList && {
                        editRequestTypeOnRequestList: editRequestTypeOnRequestList(option.value, option.label)
                    }
                }));
        }
    }
    render() {
        const { className: className, options: options } = this.props;
        const value = this.getValue();
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $fc4bM.createElement("div", {
            className: className
        }, options.length > 1 && value ? this.renderAsSelect(value) : this.renderAsList(value)));
    }
    constructor(...args){
        super(...args), this.formatOptionLabel = (option, context)=>{
            const { headingAs: headingAs } = this.props;
            switch(this.props.selectAppearance){
                case 'simple':
                    if (context.context === 'menu') return /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), {
                        containerPadding: "tight",
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description
                    });
                    return /*#__PURE__*/ $fc4bM.createElement($732315f46f679964$var$SimpleSelectOption, null, option.label);
                case 'default':
                default:
                    return /*#__PURE__*/ $fc4bM.createElement((0, $23B2e.default), {
                        containerPadding: "tight",
                        headingAs: headingAs,
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description,
                        lineClamp: context.context === 'value' ? 1 : 0
                    });
            }
        }, this.onChange = (optionValue)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            return (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, (_toSingleSelectValue = (0, $6oof1.toSingleSelectValue)(optionValue)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value);
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $732315f46f679964$var$ListItem = /*#__PURE__*/ (0, $luz1X.default).li.withConfig({
    componentId: "sc-h09otw-0"
})`display:block;${(props)=>$3DjOo.applyIf(!!props.withMargin, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $luz1X.css)`&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $732315f46f679964$var$LabelWithIcon = /*#__PURE__*/ (0, $luz1X.default).label.withConfig({
    componentId: "sc-h09otw-1"
})`display:flex;align-items:center;> :not(:last-child){margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $732315f46f679964$var$SimpleSelectOption = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-h09otw-2"
})`margin-left:${"var(--ds-space-100, 8px)"};`;
const $732315f46f679964$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN = "var(--ds-space-negative-200, -16px)";
const $732315f46f679964$var$GROUP_BOX_SELECT_PADDING_INLINE = "var(--ds-space-negative-300, -24px)";
const $732315f46f679964$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $luz1X.default).ul.withConfig({
    componentId: "sc-h09otw-3"
})`margin:${(props)=>props.offsetMargin ? `${$732315f46f679964$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN} ${$732315f46f679964$var$GROUP_BOX_SELECT_PADDING_INLINE} 0` : '0'};padding:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $732315f46f679964$var$selectHeaderStyles = /*#__PURE__*/ (0, $luz1X.css)`${$imLe4.h500};display:block;margin-top:0;margin-bottom:0;`;
const $732315f46f679964$export$2e1776684c14bc89 = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-h09otw-4"
})`${$732315f46f679964$var$selectHeaderStyles}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $732315f46f679964$var$smallSelectHeaderBaseStyles = /*#__PURE__*/ (0, $luz1X.css)`${$imLe4.h500};display:block;margin-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $732315f46f679964$var$smallSelectHeaderStyles = /*#__PURE__*/ (0, $luz1X.css)`${$732315f46f679964$var$smallSelectHeaderBaseStyles};${$imLe4.h200};margin-top:0;margin-bottom:0;`;
const $732315f46f679964$export$105792bf13c50cea = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-h09otw-5"
})`${$732315f46f679964$var$smallSelectHeaderStyles}`;
const $732315f46f679964$var$labelStylesWrapper = (0, $kig2V.xcss)({
    marginBottom: 'space.200'
});
const $732315f46f679964$var$labelSmallStylesWrapper = (0, $kig2V.xcss)({
    marginBottom: 'space.100'
});

});
parcelRegister("fwgWP", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => (parcelRequire("1FXn1")).AutoFocus);

var $1FXn1 = parcelRequire("1FXn1");

});
parcelRegister("1FXn1", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => $ed8f7a53f23062ef$export$9d8c528bc52bedf6);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");
class $ed8f7a53f23062ef$export$9d8c528bc52bedf6 extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        isEnabled: true
    };
    componentDidMount() {
        const { isEnabled: isEnabled } = this.props;
        // If we haven't yet triggered the focus we will focus on the ref if available
        if (isEnabled && !this.focused) {
            // eslint-disable-next-line react/no-find-dom-node
            const el = (0, $bTkYf.findDOMNode)(this);
            if (el) {
                el.focus();
                this.focused = true;
            }
        }
    }
    render() {
        const { children: children } = this.props;
        return $fc4bM.Children.only(children);
    }
}

});


parcelRegister("4nCqe", function(module, exports) {
$parcel$export(module.exports, "LabelHeading", () => $7f7579abdb835cfe$export$46cacff9402088d9);
/* styles.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @compiled/jsx-pragma
// `React` is imported and referenced (via React.FC) so this file works under the
// classic JSX runtime used by the Jest test env, while the pragma above enables
// the Compiled `css` prop for builds.

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// Visual reset for the semantic heading label: inherits the surrounding font
// and color and removes the browser's default heading margin/weight so the
// heading looks identical to the previous plain <span>.
const $7f7579abdb835cfe$var$labelHeadingStyles = null;
const $7f7579abdb835cfe$export$46cacff9402088d9 = ({ text: text, headingTag: HeadingTag })=>/*#__PURE__*/ $fc4bM.createElement(HeadingTag, {
        className: (0, $2R2iS.default)([
            "_11c81kw7 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _syaz1kw7"
        ])
    }, text);

});

parcelRegister("6oof1", function(module, exports) {
$parcel$export(module.exports, "toSingleSelectValue", () => $e8a8625465735058$export$e6e136d0998f71a);
$parcel$export(module.exports, "toMultiSelectValue", () => $e8a8625465735058$export$f3f3cd2c513af530);
const $e8a8625465735058$export$e6e136d0998f71a = (value)=>{
    if (value == null) return value;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Array.isArray(value) ? value[0] : value;
};
const $e8a8625465735058$export$f3f3cd2c513af530 = (value)=>{
    if (value == null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
};

});



parcelRegister("5T9DI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::959808d0c396950308013c029859eefb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44999108f6acf9c1$var$_react = $44999108f6acf9c1$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $44999108f6acf9c1$var$_iconNew = $44999108f6acf9c1$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $44999108f6acf9c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/send
 * Usage guidance:
 * Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44999108f6acf9c1$var$SendIcon = (props)=>/*#__PURE__*/ $44999108f6acf9c1$var$_react.default.createElement($44999108f6acf9c1$var$_iconNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$44999108f6acf9c1$var$SendIcon.displayName = 'SendIcon';
var $44999108f6acf9c1$var$_default = module.exports.default = $44999108f6acf9c1$var$SendIcon;

});



parcelRegister("aGQgU", function(module, exports) {
$parcel$export(module.exports, "RequestTypeSelect", () => (parcelRequire("cBqUC")).default);

var $cBqUC = parcelRequire("cBqUC");

});
parcelRegister("cBqUC", function(module, exports) {
$parcel$export(module.exports, "default", () => $865028829a2b21f2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");
parcelRequire("3BNzL");
var $5uGKc = parcelRequire("5uGKc");
parcelRequire("jJxtk");
var $7mF3u = parcelRequire("7mF3u");

var $3TJLC = parcelRequire("3TJLC");

var $6rayQ = parcelRequire("6rayQ");
parcelRequire("26cjK");
var $fqmIx = parcelRequire("fqmIx");
class $865028829a2b21f2$export$2e2bcd8739ae039 extends $fc4bM.PureComponent {
    getOptions() {
        const referrer = $6rayQ.get((0, $fqmIx.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        const { requestTypes: requestTypes, portalId: portalId, requestGroupId: requestGroupId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestTypes.map((requestType)=>({
                value: Number(requestType.id),
                label: requestType.name,
                description: /*#__PURE__*/ $fc4bM.createElement($865028829a2b21f2$var$RequestTypeDescription, {
                    dangerouslySetInnerHTML: {
                        __html: requestType.descriptionHtml
                    }
                }),
                iconUrl: requestType.iconUrl,
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                to: `/portal/${portalId}/group/${requestGroupId}/create/${requestType.id}${shouldAddReferrer ? `?${0, $fqmIx.REFERRER_QUERY_PARAM}=${referrer}` : ''}`,
                dataTestId: `request-type:${requestType.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    getCSMOptions() {
        const { requestTypes: requestTypes } = this.props;
        return requestTypes.map((requestType)=>({
                value: requestType.name,
                label: requestType.name
            }));
    }
    getCSMValue(value) {
        const { requestTypes: requestTypes } = this.props;
        if (!value) return {
            value: '',
            label: ''
        };
        const requestType = requestTypes.find((requestTypeOption)=>Number(requestTypeOption.id) === value);
        return {
            value: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || '',
            label: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || ''
        };
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, isCSM: isCSM, headingAs: headingAs, ...props } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: {
                actionSubjectId: 'requestTypes',
                attributes: {
                    portalId: props.portalId,
                    requestGroupId: props.requestGroupId,
                    numberOfRequestTypes: props.requestTypes.length
                }
            }
        }, /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, isCSM ? /*#__PURE__*/ $fc4bM.createElement((0, $5uGKc.default), {
            id: "request-type-select",
            label: label,
            options: this.getCSMOptions(),
            defaultValue: this.getCSMValue(value),
            disabled: !!disabled
        }) : /*#__PURE__*/ $fc4bM.createElement((0, $7mF3u.default), {
            id: "request-type-select",
            actionSubjectId: "requestTypeSelect",
            itemActionSubjectId: "requestType",
            label: label,
            options: this.getOptions(),
            headingAs: headingAs,
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props,
            allowSelectedValueToWrap: true
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $865028829a2b21f2$var$RequestTypeDescription = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-1qcxsi7-0"
})`p{display:inline;}`;

});
parcelRegister("3BNzL", function(module, exports) {
$parcel$export(module.exports, "SingleSelectField", () => (parcelRequire("5uGKc")).default);
/** This is the single select form component type  */ 
var $5uGKc = parcelRequire("5uGKc");

});
parcelRegister("5uGKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8387f47433020ecb$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6v10u = parcelRequire("6v10u");

var $6oof1 = parcelRequire("6oof1");
class $8387f47433020ecb$var$SingleFieldSelect extends $fc4bM.PureComponent {
    componentDidMount() {
        // JDW-2280 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultValue) this.onChange(this.props.defaultValue);
    }
    render() {
        const { disabled: disabled, ...otherProps } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $6v10u.FormSingleSelect), {
            ...otherProps,
            onChange: this.onChange,
            isDisabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.onChange = (option, meta)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, ((_toSingleSelectValue = (0, $6oof1.toSingleSelectValue)(option)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value) ?? '', false, {
                rawObject: meta ?? {},
                rawValue: option
            });
        };
    }
}
var $8387f47433020ecb$export$2e2bcd8739ae039 = $8387f47433020ecb$var$SingleFieldSelect;

});
parcelRegister("6v10u", function(module, exports) {
$parcel$export(module.exports, "FieldSingleSelect", () => $5bb37306730bea37$export$a63157f03e4869bc);
$parcel$export(module.exports, "FormSingleSelect", () => $5bb37306730bea37$export$6440c30e7d5bd2b2);
$parcel$export(module.exports, "FormAsyncSingleSelect", () => $5bb37306730bea37$export$1232b3d2b9045cfb);
$parcel$export(module.exports, "FormAsyncCreatableSingleSelect", () => $5bb37306730bea37$export$5e090ccc28fd7327);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("fO5DL");
var $g79jO = parcelRequire("g79jO");
parcelRequire("6wHv6");
var $5leVl = parcelRequire("5leVl");

var $k6bCh = parcelRequire("k6bCh");

var $gg6vz = parcelRequire("gg6vz");

var $iRlFU = parcelRequire("iRlFU");
const $5bb37306730bea37$export$a63157f03e4869bc = (0, $iRlFU.default)((0, $g79jO.ThemedSelect));
const $5bb37306730bea37$var$FieldAsyncSingleSelect = (0, $iRlFU.default)((0, $g79jO.ThemedAsyncSelect));
const $5bb37306730bea37$var$FieldAsyncCreatableSingleSelect = (0, $iRlFU.default)((0, $g79jO.ThemedAsyncCreatableSelect));
class $5bb37306730bea37$var$FormAsyncCreatableSingleSelectBase extends $fc4bM.PureComponent {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement($5bb37306730bea37$var$FieldAsyncCreatableSingleSelect, {
            ...this.props,
            onCreateOption: this.onCreateOption
        });
    }
    constructor(...args){
        super(...args), this.onCreateOption = (input)=>{
            const { onChange: onChange, showNewLabelForCreatedValues: showNewLabelForCreatedValues } = this.props;
            const newOption = {
                value: input,
                label: input,
                isNew: showNewLabelForCreatedValues
            };
            onChange === null || onChange === void 0 || onChange(newOption, {
                action: 'create-option',
                option: newOption
            });
        };
    }
}
const $5bb37306730bea37$var$ControlledFieldAsyncSingleSelect = (0, $5leVl.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $fc4bM.createElement($5bb37306730bea37$var$FieldAsyncSingleSelect, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $5bb37306730bea37$var$ControlledFormAsyncCreatableSingleSelectBase = (0, $5leVl.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $fc4bM.createElement($5bb37306730bea37$var$FormAsyncCreatableSingleSelectBase, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $5bb37306730bea37$export$6440c30e7d5bd2b2 = (0, $5leVl.withControlledFormComponentValue)((option)=>option)($5bb37306730bea37$export$a63157f03e4869bc);
const $5bb37306730bea37$export$1232b3d2b9045cfb = (0, $k6bCh.componentWithCondition)(()=>(0, $hN5YJ.isUserPickerSupportEnabled)(), $5bb37306730bea37$var$ControlledFieldAsyncSingleSelect, (0, $gg6vz.default)($5bb37306730bea37$var$FieldAsyncSingleSelect));
const $5bb37306730bea37$export$5e090ccc28fd7327 = (0, $k6bCh.componentWithCondition)(()=>(0, $hN5YJ.isUserPickerSupportEnabled)(), $5bb37306730bea37$var$ControlledFormAsyncCreatableSingleSelectBase, (0, $gg6vz.default)($5bb37306730bea37$var$FormAsyncCreatableSingleSelectBase));

});
parcelRegister("fO5DL", function(module, exports) {
$parcel$export(module.exports, "ThemedSelect", () => (parcelRequire("g79jO")).ThemedSelect);
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => (parcelRequire("g79jO")).ThemedAsyncCreatableSelect);
$parcel$export(module.exports, "ThemedAsyncSelect", () => (parcelRequire("g79jO")).ThemedAsyncSelect);

var $g79jO = parcelRequire("g79jO");

});
parcelRegister("g79jO", function(module, exports) {
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => $2e7b9967027e7b7b$export$6ed24baf80289e3c);
$parcel$export(module.exports, "ThemedAsyncSelect", () => $2e7b9967027e7b7b$export$ffdb66031dcf42ea);
$parcel$export(module.exports, "ThemedSelect", () => $2e7b9967027e7b7b$export$336563657ba327fe);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $jjgXC = parcelRequire("jjgXC");
var $eKdkG = parcelRequire("eKdkG");
var $77YVQ = parcelRequire("77YVQ");
var $g43xT = parcelRequire("g43xT");
function $2e7b9967027e7b7b$var$withThemeSelect(Component) {
    class ThemedSelectWrapper extends $fc4bM.PureComponent {
        render() {
            const { theme: theme, styles: externalStyles = {}, ...selectProps } = this.props;
            const customStyles = {
                // This is to ensure the multi select options stay within the container without overflowing
                valueContainer: (styles)=>({
                        ...styles,
                        width: '100%',
                        overflow: 'hidden'
                    }),
                // This is used to apply our theming
                option: (styles, { isFocused: isFocused, isSelected: isSelected })=>{
                    const themed = theme;
                    const optionFocusBackground = isFocused ? "var(--ds-background-neutral-subtle-hovered, #F4F5F7)" : null;
                    const backgroundColor = isSelected ? themed.lightColor : optionFocusBackground;
                    return {
                        ...styles,
                        backgroundColor: backgroundColor,
                        ':active': {
                            backgroundColor: themed.lightColor
                        },
                        color: "var(--ds-text, #172B4D)"
                    };
                },
                // This is to ensure long select options doesn't cause a horizontal scroll bar to appear in the select menu
                menu: (styles)=>({
                        ...styles,
                        'word-wrap': 'break-word',
                        'overflow-y': 'hidden',
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            };
            return /*#__PURE__*/ $fc4bM.createElement(Component, {
                placeholder: "",
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage, @atlassian/ssr-linting/no-dom-globals-in-react-cc-render
                menuPortalTarget: document.body,
                menuPlacement: "auto",
                ...selectProps,
                styles: {
                    ...externalStyles,
                    ...customStyles
                }
            });
        }
    }
    return (0, $luz1X.withTheme)(ThemedSelectWrapper);
}
const $2e7b9967027e7b7b$export$6ed24baf80289e3c = $2e7b9967027e7b7b$var$withThemeSelect((0, $jjgXC.AsyncCreatableSelect));
const $2e7b9967027e7b7b$export$1692d6296f3148ba = $2e7b9967027e7b7b$var$withThemeSelect((0, $77YVQ.CreatableSelect));
const $2e7b9967027e7b7b$export$ffdb66031dcf42ea = $2e7b9967027e7b7b$var$withThemeSelect((0, $eKdkG.AsyncSelect));
const $2e7b9967027e7b7b$export$336563657ba327fe = $2e7b9967027e7b7b$var$withThemeSelect((0, $g43xT.Select));

});
parcelRegister("jjgXC", function(module, exports) {
$parcel$export(module.exports, "AsyncCreatableSelect", () => $e91afdb277733a46$export$c0b2520fe082e4aa);

var $77UoJ = parcelRequire("77UoJ");

var $asUgz = parcelRequire("asUgz");
const $e91afdb277733a46$export$c0b2520fe082e4aa = (0, $asUgz.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $77UoJ.default));

});
parcelRegister("77UoJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b10eb178835e2b88$export$2e2bcd8739ae039);

var $42txB = parcelRequire("42txB");

var $5eTWm = parcelRequire("5eTWm");
const $b10eb178835e2b88$var$AsyncCreatableSelect = (0, $5eTWm.default)((0, $42txB.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b10eb178835e2b88$export$2e2bcd8739ae039 = $b10eb178835e2b88$var$AsyncCreatableSelect;

});
parcelRegister("42txB", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dccd48583b7df02$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iM7Ff = parcelRequire("iM7Ff");

var $e1eEo = parcelRequire("e1eEo");

var $fS8hy = parcelRequire("fS8hy");

var $iJY8V = parcelRequire("iJY8V");
const $0dccd48583b7df02$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $e1eEo.default)(props);
    const creatableProps = (0, $iJY8V.default)(stateManagerProps);
    const selectProps = (0, $fS8hy.default)(creatableProps);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iM7Ff.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0dccd48583b7df02$export$2e2bcd8739ae039 = $0dccd48583b7df02$var$AsyncCreatableSelect;

});
parcelRegister("fS8hy", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff2053d15e9889de$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $2Vsv2 = parcelRequire("2Vsv2");

var $71RWc = parcelRequire("71RWc");

var $8rkHO = parcelRequire("8rkHO");

var $bxhpS = parcelRequire("bxhpS");
const $ff2053d15e9889de$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $ff2053d15e9889de$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$ff2053d15e9889de$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$ff2053d15e9889de$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $ff2053d15e9889de$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $ff2053d15e9889de$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $ff2053d15e9889de$var$builtins.isValidNewOption, getNewOptionData: // @ts-expect-error -- The built-in option shape cannot satisfy every possible generic Option type.
getNewOptionData = $ff2053d15e9889de$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $71RWc.getOptionValue), getOptionLabel: getOptionLabel = (0, $2Vsv2.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $fc4bM.useMemo)(()=>isValidNewOption(inputValue, (0, $8rkHO.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $fc4bM.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $fc4bM.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $bxhpS.valueTernary)(isMulti, [
                    ...(0, $8rkHO.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});




parcelRegister("eKdkG", function(module, exports) {
$parcel$export(module.exports, "AsyncSelect", () => $09932cb2f6e81413$export$aca05dd54e009a80);

var $8UTo1 = parcelRequire("8UTo1");

var $asUgz = parcelRequire("asUgz");
const $09932cb2f6e81413$export$aca05dd54e009a80 = (0, $asUgz.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $8UTo1.default));

});
parcelRegister("8UTo1", function(module, exports) {
$parcel$export(module.exports, "default", () => $acd23c8747bbbeaf$export$2e2bcd8739ae039);

var $X9ALI = parcelRequire("X9ALI");

var $5eTWm = parcelRequire("5eTWm");
const $acd23c8747bbbeaf$var$AsyncSelect = (0, $5eTWm.default)((0, $X9ALI.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$acd23c8747bbbeaf$export$2e2bcd8739ae039 = $acd23c8747bbbeaf$var$AsyncSelect;

});


parcelRegister("77YVQ", function(module, exports) {
$parcel$export(module.exports, "CreatableSelect", () => $aaf5d2493453b0a1$export$4d213c67c76d12fa);

var $iPHMu = parcelRequire("iPHMu");

var $asUgz = parcelRequire("asUgz");
const $aaf5d2493453b0a1$export$4d213c67c76d12fa = (0, $asUgz.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $iPHMu.default));

});
parcelRegister("iPHMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca899778989f9ba$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $3SPzt = parcelRequire("3SPzt");

var $5eTWm = parcelRequire("5eTWm");
const $bca899778989f9ba$var$CreatableSelect = (0, $5eTWm.default)((0, $3SPzt.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bca899778989f9ba$export$2e2bcd8739ae039 = $bca899778989f9ba$var$CreatableSelect;

});
parcelRegister("3SPzt", function(module, exports) {
$parcel$export(module.exports, "default", () => $edb4fbe2fabf1308$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $iM7Ff = parcelRequire("iM7Ff");

var $fS8hy = parcelRequire("fS8hy");

var $iJY8V = parcelRequire("iJY8V");
const $edb4fbe2fabf1308$var$CreatableSelect = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const creatableProps = (0, $iJY8V.default)(props);
    const selectProps = (0, $fS8hy.default)(creatableProps);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iM7Ff.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$edb4fbe2fabf1308$export$2e2bcd8739ae039 = $edb4fbe2fabf1308$var$CreatableSelect;

});





parcelRegister("k6bCh", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $ca008f8570946ee7$export$6e8ea24b15199873);

var $fc4bM = parcelRequire("fc4bM");
function $ca008f8570946ee7$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("gg6vz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0653e11be146d93$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $f0653e11be146d93$var$withControlledValueSingleSelect(SelectComponent) {
    return class ControlledValueSingleSelectWrapper extends $fc4bM.PureComponent {
        static #_ = this.displayName = 'ControlledValueSingleSelectWrapper';
        render() {
            return /*#__PURE__*/ $fc4bM.createElement(SelectComponent, {
                ...this.props,
                isMulti: false,
                value: this.state.selectedOption,
                onChange: this.onChange,
                isClearable: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                selectedOption: this.props.defaultValue
            }, this.onChange = (option, context)=>{
                var _this$props$onChange, _this$props;
                this.setState({
                    selectedOption: option
                });
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, option, context);
            };
        }
    };
}
var $f0653e11be146d93$export$2e2bcd8739ae039 = $f0653e11be146d93$var$withControlledValueSingleSelect;

});

parcelRegister("iRlFU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1703f113e7727d9a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("ch1yB");
var $evcLx = parcelRequire("evcLx");
function $1703f113e7727d9a$var$withFieldBase(SelectComponent) {
    const wrappedComponent = (props)=>{
        const { label: label, required: required, errorMessage: errorMessage, description: description, id: id, tooltip: tooltip, ...otherProps } = props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $evcLx.default), {
            htmlFor: id,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description,
            ...(0, $hN5YJ.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, /*#__PURE__*/ $fc4bM.createElement(SelectComponent, {
            ...otherProps,
            inputId: id,
            "aria-describedby": `${id}-field-description`,
            validationState: !!errorMessage ? 'error' : 'default'
        }));
    };
    return wrappedComponent;
}
var $1703f113e7727d9a$export$2e2bcd8739ae039 = $1703f113e7727d9a$var$withFieldBase;

});






parcelRegister("2bShK", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1881a341451f34a$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $a1881a341451f34a$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    requestGroupSelectLabel: {
        defaultMessage: 'Contact us about',
        description: 'Label shown for selecting a request group',
        id: 'sd.portal.request.group.select'
    },
    requestTypeSelectLabel: {
        defaultMessage: 'What can we help you with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.request.type.select'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    CSMRequestTypeSelectLabel: {
        defaultMessage: 'What do you need help with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.csm.request.type.select'
    },
    emptyStateMessage: {
        defaultMessage: "There's nothing in this portal yet.",
        description: 'This message is shown, when there are no configured request groups for service project',
        id: 'sd.jsm.portal.empty.request.type'
    },
    tryAnotherServiceProjectLink: {
        defaultMessage: 'Go to the help center',
        description: 'This link is shown, when there are no configured request groups for current service project and there are other service projects available',
        id: 'sd.jsm.portal.empty.sd.link'
    }
});

});





parcelRegister("bK2QR", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => (parcelRequire("7Fgg2")).SkeletonLoadingContainer);

var $7Fgg2 = parcelRequire("7Fgg2");

});
parcelRegister("7Fgg2", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => $056150bd4d1560ec$export$ed074b591cb3b239);

var $fc4bM = parcelRequire("fc4bM");

var $aUHFa = parcelRequire("aUHFa");
parcelRequire("blonq");
var $4m70N = parcelRequire("4m70N");

var $d7r8x = parcelRequire("d7r8x");
class $056150bd4d1560ec$export$ed074b591cb3b239 extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const skeleton = /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.SkeletonLoadingWrapper), {
            isLoading: true,
            loadingPosition: loadingPosition
        });
        return isLoading ? /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.PaperContent), null, enableUFOHold ? /*#__PURE__*/ $fc4bM.createElement((0, $d7r8x.default), {
            name: ufoHoldName
        }, skeleton) : skeleton) : children;
    }
}

});


parcelRegister("aJJ7z", function(module, exports) {
$parcel$export(module.exports, "ExternalLinks", () => $4ad0a0da0d5e508b$export$7c6fdaf98295312b);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $4ad0a0da0d5e508b$export$7c6fdaf98295312b = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("fPQyG")), {
        moduleId: "./src/view/external-links/external-links.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("fPQyG", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2g5QR"),
    $9dnsd("fvgTB")
]).then(()=>parcelRequire('8uEQf'));

});


parcelRegister("cf4bF", function(module, exports) {
$parcel$export(module.exports, "ForgeFooterModule", () => $ac81d864777121de$export$c664a1597302ef11);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $ac81d864777121de$export$c664a1597302ef11 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("en1WA")), {
        moduleId: "./src/view/forge-ui/portal-footer/portal-footer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("en1WA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6520E").then(()=>parcelRequire('5wuLr'));

});


parcelRegister("ixenv", function(module, exports) {
$parcel$export(module.exports, "ForgeHeaderModule", () => $e8f7199d5a234ed0$export$8010fd64cd5cfdb9);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $e8f7199d5a234ed0$export$8010fd64cd5cfdb9 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("fnh2U")), {
        moduleId: "./src/view/forge-ui/portal-header/portal-header.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("fnh2U", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8S9Y9").then(()=>parcelRequire('jDtH8'));

});


parcelRegister("l0QpJ", function(module, exports) {
$parcel$export(module.exports, "LazyVirtualServiceAgentChatSidebar", () => $83917b3cf55d369f$export$5ab8ce8fb542ac03);
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $83917b3cf55d369f$export$5ab8ce8fb542ac03 = (0, $dohmo.lazy)(()=>(parcelRequire("ccGuS")), {
    moduleId: "./src/view/layout/virtual-service-agent-chat-sidebar/virtual-service-agent-chat-sidebar.tsx"
});

});
parcelRegister("ccGuS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gWCAL"),
    $9dnsd("5slKd"),
    $9dnsd("bQogk"),
    $9dnsd("hOVAC"),
    $9dnsd("j81ar"),
    $9dnsd("fQ86q"),
    $9dnsd("lgbKq"),
    $9dnsd("1AKkv"),
    $9dnsd("kQwdK"),
    $9dnsd("4A2hN"),
    $9dnsd("2aAs1"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("3EcVO"),
    $9dnsd("gxCRt"),
    $9dnsd("cz9eg"),
    $9dnsd("k09lt"),
    $9dnsd("7etds"),
    $9dnsd("aPbFz"),
    $9dnsd("lsa7j"),
    $9dnsd("2pTiU"),
    $9dnsd("1ne6N"),
    $9dnsd("8coHv")
]).then(()=>parcelRequire('ioiUt'));

});


parcelRegister("cNyOd", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpText", () => (parcelRequire("9JyQP")).default);

var $9JyQP = parcelRequire("9JyQP");

});
parcelRegister("9JyQP", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ecc12364ff6fd2$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("3krBW");
var $7Xr9B = parcelRequire("7Xr9B");
const $91ecc12364ff6fd2$var$selector = (0, $2n2bS.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    const requestType = (0, $9D9SX.getPortalRequestType)(state, portalId, requestTypeId);
    return requestType && requestType.helpTextHtml;
}, (helpText)=>({
        helpText: helpText
    }));
var $91ecc12364ff6fd2$export$2e2bcd8739ae039 = (0, $6umft.default)($91ecc12364ff6fd2$var$selector)((0, $7Xr9B.default));

});
parcelRegister("3krBW", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpTextDumb", () => (parcelRequire("7Xr9B")).default);

var $7Xr9B = parcelRequire("7Xr9B");

});
parcelRegister("7Xr9B", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cd2e62370937ab1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");
parcelRequire("1cU1r");
var $w9hUA = parcelRequire("w9hUA");
class $3cd2e62370937ab1$var$RequestCreateFormHelpTextDumb extends $fc4bM.Component {
    render() {
        return /*#__PURE__*/ $fc4bM.createElement((0, $w9hUA.default), {
            in: !!this.props.helpText
        }, /*#__PURE__*/ $fc4bM.createElement($3cd2e62370937ab1$var$HelpTextContainer, {
            dangerouslySetInnerHTML: {
                __html: this.props.helpText
            }
        }));
    }
}
var $3cd2e62370937ab1$export$2e2bcd8739ae039 = $3cd2e62370937ab1$var$RequestCreateFormHelpTextDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3cd2e62370937ab1$var$HelpTextContainer = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-1u76lr1-0"
})`margin-top:${"var(--ds-space-200, 16px)"};margin-bottom:${"var(--ds-space-100, 8px)"};a{text-decoration:underline;}`;

});
parcelRegister("1cU1r", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("w9hUA")).default);
parcelRequire("lhYV8");
var $w9hUA = parcelRequire("w9hUA");

});
parcelRegister("lhYV8", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("w9hUA")).default);

var $w9hUA = parcelRequire("w9hUA");

});
parcelRegister("w9hUA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8dfd9f0c3bc269e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $6F3K7 = parcelRequire("6F3K7");

var $1IFGQ = parcelRequire("1IFGQ");
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b8dfd9f0c3bc269e$var$Container = /*#__PURE__*/ (0, $luz1X.default).span.withConfig({
    componentId: "sc-10ahj68-0"
})`${$6F3K7.fadeInOut($6F3K7.speedMs.fast)};`;
/**
 * This is for ease of use fade in/out. This will add an extra <span> around the children to do the
 * animating. If you need finer grained control, or don't want the extra span markup, use <Transition />
 * and our transition mixins directly.
 */ const $b8dfd9f0c3bc269e$var$Fade = ({ children: children, appear: appear, in: show })=>/*#__PURE__*/ $fc4bM.createElement((0, $1IFGQ.default), {
        timeout: $6F3K7.speedMs.fast,
        in: show,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: appear
    }, (state)=>/*#__PURE__*/ $fc4bM.createElement($b8dfd9f0c3bc269e$var$Container, {
            state: state
        }, children));
var $b8dfd9f0c3bc269e$export$2e2bcd8739ae039 = $b8dfd9f0c3bc269e$var$Fade;

});







parcelRegister("7d7Uj", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsAnnouncementSidebar", () => $c6fa6a9b10c8bf1e$export$454a2c99809e1b66);
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $c6fa6a9b10c8bf1e$export$454a2c99809e1b66 = (0, $dohmo.lazy)(()=>(parcelRequire("4fiQP")), {
    moduleId: "./src/view/portal-settings-announcement-sidebar/portal-settings-announcement-sidebar.tsx"
});

});
parcelRegister("4fiQP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5Tatj"),
    $9dnsd("g0whP"),
    $9dnsd("047zo"),
    $9dnsd("6VzBn"),
    $9dnsd("8E76J")
]).then(()=>parcelRequire('iNAdc'));

});


parcelRegister("deOmO", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsSidebar", () => $fdbc82507bfe5d8d$export$4bdb57f5e35140ab);
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $fdbc82507bfe5d8d$export$4bdb57f5e35140ab = (0, $dohmo.lazy)(()=>(parcelRequire("iOrUf")), {
    moduleId: "./src/view/portal-settings-sidebar/portal-settings-sidebar.tsx"
});

});
parcelRegister("iOrUf", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5Tatj"),
    $9dnsd("g0whP"),
    $9dnsd("047zo"),
    $9dnsd("6VzBn"),
    $9dnsd("aejHq"),
    $9dnsd("61osU"),
    $9dnsd("84PLG"),
    $9dnsd("jBz2s"),
    $9dnsd("PRvhC")
]).then(()=>parcelRequire('5PW3S'));

});


parcelRegister("ch4dJ", function(module, exports) {
$parcel$export(module.exports, "PortalIntlBoundary", () => (parcelRequire("kjLl6")).default);

var $kjLl6 = parcelRequire("kjLl6");

});
parcelRegister("kjLl6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3a7b2530f672ea2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8MaoS = parcelRequire("8MaoS");
var $gpjDl = parcelRequire("gpjDl");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $k2M4v = parcelRequire("k2M4v");

var $9Ii6A = parcelRequire("9Ii6A");

var $8s5M7 = parcelRequire("8s5M7");

var $7ZNRj = parcelRequire("7ZNRj");

var $h6Bv6 = parcelRequire("h6Bv6");
const $a3a7b2530f672ea2$var$PORTAL_LANGUAGE_PACK_IN_MODEL = 'jsm-portal-include-language-pack-in-model';
const $a3a7b2530f672ea2$var$isPortalLanguagePackInModelEnabled = ()=>(0, $k2M4v.default).checkGate($a3a7b2530f672ea2$var$PORTAL_LANGUAGE_PACK_IN_MODEL);
const $a3a7b2530f672ea2$export$66c101287efe2f55 = ({ i18nTranslations: i18nTranslations, portalLocale: portalLocale, children: children })=>{
    const outerIntl = (0, $gpjDl.default)();
    const shouldOverride = $a3a7b2530f672ea2$var$isPortalLanguagePackInModelEnabled() && !!i18nTranslations && Object.keys(i18nTranslations).length > 0;
    const messages = (0, $fc4bM.useMemo)(()=>shouldOverride ? {
            ...(0, $9Ii6A.default)(),
            ...i18nTranslations
        } : undefined, [
        shouldOverride,
        i18nTranslations
    ]);
    // The backend sends `_`-separated locale keys, which `Intl` rejects. Platform
    // consumers need the region kept, so this cannot reuse `getLanguageFromLocale`.
    const portalLocaleTag = (0, $fc4bM.useMemo)(()=>portalLocale ? (0, $8s5M7.ensureConsistentKey)(portalLocale) : undefined, [
        portalLocale
    ]);
    if (!shouldOverride) return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, children);
    return /*#__PURE__*/ $fc4bM.createElement((0, $h6Bv6.PortalLocaleProvider), {
        value: portalLocaleTag
    }, /*#__PURE__*/ $fc4bM.createElement((0, $8MaoS.default), {
        locale: portalLocale ? (0, $7ZNRj.getLanguageFromLocale)(portalLocale) : outerIntl.locale,
        defaultLocale: outerIntl.defaultLocale,
        messages: messages,
        formats: outerIntl.formats,
        timeZone: outerIntl.timeZone,
        onError: (0, $9Ii6A.onIntlNextError)
    }, children));
};
const $a3a7b2530f672ea2$var$selector = (0, $2n2bS.createSelector)((state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    return {
        i18nTranslations: (0, $9D9SX.getPortalI18nTranslations)(state, portalId),
        portalLocale: (0, $9D9SX.getPortalLocale)(state, portalId)
    };
}, ({ i18nTranslations: i18nTranslations, portalLocale: portalLocale })=>({
        i18nTranslations: i18nTranslations,
        portalLocale: portalLocale
    }));
var $a3a7b2530f672ea2$export$2e2bcd8739ae039 = (0, $6umft.default)($a3a7b2530f672ea2$var$selector)($a3a7b2530f672ea2$export$66c101287efe2f55);

});
parcelRegister("h6Bv6", function(module, exports) {
$parcel$export(module.exports, "PortalLocaleProvider", () => $5617131c1dbc660e$export$fdd7d28b3dddbf46);
$parcel$export(module.exports, "usePortalLocale", () => $5617131c1dbc660e$export$b4a39b22d9a69563);

var $fc4bM = parcelRequire("fc4bM");
/**
 * The portal's own locale, published by `PortalIntlBoundary` over the subtree it
 * wraps, as a hyphenated BCP-47 tag with the region kept.
 *
 * `undefined` means "not inside a portal-scoped boundary". That default is what
 * keeps non-portal surfaces — CSM request details, the customisation editors,
 * embedded pages — on the user's account locale without needing a per-consumer
 * opt-out list.
 */ const $5617131c1dbc660e$var$PortalLocaleContext = /*#__PURE__*/ $fc4bM.createContext(undefined);
const $5617131c1dbc660e$export$fdd7d28b3dddbf46 = $5617131c1dbc660e$var$PortalLocaleContext.Provider;
const $5617131c1dbc660e$export$b4a39b22d9a69563 = ()=>$fc4bM.useContext($5617131c1dbc660e$var$PortalLocaleContext);

});



parcelRegister("9jO1B", function(module, exports) {
$parcel$export(module.exports, "RequestCreateForm", () => $b0af430bdbc2f7b6$export$23aadacdae45e79);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $b0af430bdbc2f7b6$var$loader = (0, $dohmo.lazyForPaint)(()=>{
    return (parcelRequire("kRqlf"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-form/hocs.tsx"
});
const $b0af430bdbc2f7b6$export$23aadacdae45e79 = (0, $bQkfB.default)({
    loader: $b0af430bdbc2f7b6$var$loader
});

});
parcelRegister("kRqlf", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bmLFd"),
    $9dnsd("lv25e"),
    $9dnsd("9Fw1L"),
    $9dnsd("4NKrY"),
    $9dnsd("kE1ct"),
    $9dnsd("je1qw"),
    $9dnsd("5sb3y"),
    $9dnsd("aejHq"),
    $9dnsd("cFGPX"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("bMKAA"),
    $9dnsd("h05a5"),
    $9dnsd("SIJqa")
]).then(()=>parcelRequire('25N8O'));

});


parcelRegister("gczYx", function(module, exports) {
$parcel$export(module.exports, "SidebarToggle", () => $e01050ef8c63f8cd$export$d1b4e884a11aa0f2);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("gcRsK");
var $dJF35 = parcelRequire("dJF35");
const $e01050ef8c63f8cd$export$d1b4e884a11aa0f2 = ({ openSidebar: openSidebar, closeSidebar: closeSidebar })=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $dJF35.useQueryParams)();
    $fc4bM.useEffect(()=>{
        if (customize === 'true' && !!experience) openSidebar === null || openSidebar === void 0 || openSidebar();
        else closeSidebar === null || closeSidebar === void 0 || closeSidebar();
    }, [
        customize,
        openSidebar,
        closeSidebar,
        experience
    ]);
    return null;
};

});

parcelRegister("7gm7u", function(module, exports) {
$parcel$export(module.exports, "UiModificationsEntryPoint", () => $806253a7553012e7$export$c89b83ae4e6840b3);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("ipwCB");
var $3VDD6 = parcelRequire("3VDD6");

var $6lbrU = parcelRequire("6lbrU");

var $4AeuO = parcelRequire("4AeuO");

var $jok5A = parcelRequire("jok5A");

var $4vw6O = parcelRequire("4vw6O");

var $bfYTF = parcelRequire("bfYTF");

var $dnN1g = parcelRequire("dnN1g");

var $atnzF = parcelRequire("atnzF");
/**
 * Entry point that reads the fetched UIM payload (per-app configuration and installed
 * extensions) from the `persisted.uiModifications` Redux slice, filled by the JSM models REST
 * epic, and hands it to the platform root. Redux only caches that payload; UIM runtime state
 * lives in the core's react-sweet-state store.
 */ const $806253a7553012e7$var$EntryPointWithReduxData = ({ portalId: portalId, requestTypeId: requestTypeId, triggerPointKey: triggerPointKey, uiModifications: uiModifications, uiModificationsError: uiModificationsError })=>{
    const executionContextKey = portalId && requestTypeId ? `${portalId}-${requestTypeId}` : null;
    const cloudId = (0, $6LH8a.getCloudId)();
    const activationId = (0, $6LH8a.getActivationId)();
    // Fire analytics when there's an error fetching UI modifications
    (0, $fc4bM.useEffect)(()=>{
        if (uiModificationsError) (0, $jok5A.fireErrorAnalytics)({
            error: new Error(uiModificationsError),
            id: 'fetchUiModificationsFailure',
            viewType: (0, $bfYTF.REQUEST_CREATE_VIEW_TYPE),
            attributes: {
                portalId: portalId,
                requestTypeId: requestTypeId
            }
        });
    }, [
        uiModificationsError,
        portalId,
        requestTypeId
    ]);
    const executionContext = (0, $fc4bM.useMemo)(()=>{
        if (!portalId || !requestTypeId) return null;
        return {
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        };
    }, [
        portalId,
        requestTypeId
    ]);
    // Wrap Redux data in { jira: ... } structure expected by platform component
    const wrappedUiModificationsData = (0, $fc4bM.useMemo)(()=>{
        if (!uiModifications) return {
            jira: {
                forge: {
                    uiModificationsExtensions: []
                },
                uiModifications: []
            }
        };
        return {
            jira: uiModifications
        };
    }, [
        uiModifications
    ]);
    const triggerPointKeyVal = triggerPointKey ?? (0, $dnN1g.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4vw6O.UiModificationsRootWithData), {
        executionContext: executionContext,
        uiModificationsData: wrappedUiModificationsData,
        cloudId: cloudId,
        activationId: activationId,
        executionContextKey: executionContextKey,
        triggerPointKey: triggerPointKeyVal,
        ForgeAppRenderer: (0, $atnzF.ForgeAppRenderer)
    });
};
const $806253a7553012e7$var$selector = (0, $2n2bS.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    let uiModifications;
    let uiModificationsError;
    if (portalId && requestTypeId) {
        uiModifications = (0, $3VDD6.getUiModificationsData)(state, portalId, requestTypeId);
        uiModificationsError = (0, $3VDD6.getUiModificationsError)(state, portalId, requestTypeId);
    }
    return {
        portalId: portalId,
        requestTypeId: requestTypeId,
        uiModifications: uiModifications,
        uiModificationsError: uiModificationsError,
        triggerPointKey: props.triggerPointKey
    };
}, (selectorData)=>selectorData);
const $806253a7553012e7$var$EntryPoint = (0, $6umft.default)($806253a7553012e7$var$selector)($806253a7553012e7$var$EntryPointWithReduxData);
const $806253a7553012e7$export$c89b83ae4e6840b3 = (props)=>{
    return (0, $hN5YJ.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        id: "uiModifications",
        packageName: "jsmUiModificationsViewRequestCreate"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4AeuO.AnalyticsListener), {
        analyticsWebClient: (0, $6lbrU.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($806253a7553012e7$var$EntryPoint, props))) : null;
};

});
parcelRegister("ipwCB", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => (parcelRequire("3VDD6")).getUiModificationsData);
$parcel$export(module.exports, "getUiModificationsError", () => (parcelRequire("3VDD6")).getUiModificationsError);

var $3VDD6 = parcelRequire("3VDD6");

});
parcelRegister("3VDD6", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => $6a77c4d09a683689$export$3f2ec852b79889c8);
$parcel$export(module.exports, "getUiModificationsError", () => $6a77c4d09a683689$export$a973ad30babc208b);
const $6a77c4d09a683689$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $6a77c4d09a683689$export$77a087943aa778c9 = (state, portalId, requestTypeId)=>{
    var _state$persisted$uiMo;
    const storeKey = $6a77c4d09a683689$var$buildStoreKey(portalId, requestTypeId);
    return (_state$persisted$uiMo = state.persisted.uiModifications) === null || _state$persisted$uiMo === void 0 ? void 0 : _state$persisted$uiMo[storeKey];
};
const $6a77c4d09a683689$export$3f2ec852b79889c8 = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn;
    return (_getUiModificationsEn = $6a77c4d09a683689$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn === void 0 ? void 0 : _getUiModificationsEn.data;
};
const $6a77c4d09a683689$export$a973ad30babc208b = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn2;
    return (_getUiModificationsEn2 = $6a77c4d09a683689$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn2 === void 0 ? void 0 : _getUiModificationsEn2.error;
};

});


parcelRegister("4AeuO", function(module, exports) {
$parcel$export(module.exports, "AnalyticsListener", () => $2a12f08a9a09708d$export$22edec767217cd60);

var $fc4bM = parcelRequire("fc4bM");

var $hH2zO = parcelRequire("hH2zO");

var $aVQWM = parcelRequire("aVQWM");

var $j5wIQ = parcelRequire("j5wIQ");

var $8xOOU = parcelRequire("8xOOU");

var $d9XyX = parcelRequire("d9XyX");
const $2a12f08a9a09708d$export$7329bcdc3edcd90e = (event, client)=>{
    switch(event.type){
        case 0, $aVQWM.OPERATIONAL_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
            break;
        case 0, $aVQWM.TRACK_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
            break;
    }
};
const $2a12f08a9a09708d$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
        const eventData = (0, $j5wIQ.extractAWCDataFromEvent)(event);
        $2a12f08a9a09708d$export$7329bcdc3edcd90e({
            type: eventData.type,
            ...eventData.payload
        }, analyticsWebClient);
    };
const $2a12f08a9a09708d$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
    const onEvent = (0, $fc4bM.useMemo)(()=>$2a12f08a9a09708d$export$eee20638634729b3(analyticsWebClient), [
        analyticsWebClient
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const initClient = async ()=>{
            const client = await analyticsWebClient;
            (0, $8xOOU.initialiseErrorAnalyticsClient)(client);
        };
        initClient();
    }, [
        analyticsWebClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hH2zO.default), {
        onEvent: onEvent,
        channel: (0, $d9XyX.UI_MODIFICATIONS_ANALYTICS_CHANNEL)
    }, children);
};

});

parcelRegister("4vw6O", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootWithData", () => $b9b801cbda1bb899$export$56d75038a9162ad6);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $g4H12 = parcelRequire("g4H12");

var $43SzX = parcelRequire("43SzX");

var $aiipA = parcelRequire("aiipA");

var $UNIiR = parcelRequire("UNIiR");

var $5YXrV = parcelRequire("5YXrV");

var $8uBXm = parcelRequire("8uBXm");

var $5C1NW = parcelRequire("5C1NW");

var $45M2c = parcelRequire("45M2c");

var $bZIaw = parcelRequire("bZIaw");
const $b9b801cbda1bb899$export$56d75038a9162ad6 = (props)=>{
    const executionContext = (0, $bZIaw.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $aiipA.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $g4H12.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $5YXrV.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $5YXrV.isExecutionContextSupported)(executionContext);
    (0, $fc4bM.useEffect)(()=>{
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b9b801cbda1bb899$var$RootWithDataCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
const $b9b801cbda1bb899$var$RootWithDataCleanup = (props)=>{
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $45M2c.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $fc4bM.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $fc4bM.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $43SzX.ExecutionContextProvider), {
        value: executionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $UNIiR.TenantContextProvider), {
        value: tenantContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b9b801cbda1bb899$var$RootWithData, props))));
};
const $b9b801cbda1bb899$var$RootWithData = ({ uiModificationsData: uiModificationsData, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    const appsToRender = (0, $5C1NW.useAppsToRender)({
        data: uiModificationsData,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uBXm.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("43SzX", function(module, exports) {
$parcel$export(module.exports, "useExecutionContext", () => $2cb4c70e0be785dc$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "ExecutionContextProvider", () => $2cb4c70e0be785dc$export$14f2a780bc6de643);

var $fc4bM = parcelRequire("fc4bM");
const $2cb4c70e0be785dc$export$7f8a924805594460 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $2cb4c70e0be785dc$export$b0467ce6d1ed861f = ()=>{
    const executionContext = (0, $fc4bM.useContext)($2cb4c70e0be785dc$export$7f8a924805594460);
    if (executionContext === null) throw new Error('executionContext value is null');
    return executionContext;
};
const $2cb4c70e0be785dc$export$14f2a780bc6de643 = ({ children: children, value: value })=>{
    if (!value) throw new Error('ExecutionContextProvider requires a value');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($2cb4c70e0be785dc$export$7f8a924805594460.Provider, {
        value: value
    }, children);
};

});

parcelRegister("aiipA", function(module, exports) {
$parcel$export(module.exports, "useViewType", () => $9a8cb8e405544ac7$export$1568c16ff8af07a3);

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $9a8cb8e405544ac7$export$1568c16ff8af07a3 = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    selector: (state)=>state.viewType
});

});

parcelRegister("UNIiR", function(module, exports) {
$parcel$export(module.exports, "useTenantContext", () => $cc3f93e8f2ee5687$export$28e7c557f4d454d9);
$parcel$export(module.exports, "TenantContextProvider", () => $cc3f93e8f2ee5687$export$e32355e80a92030c);

var $fc4bM = parcelRequire("fc4bM");
const $cc3f93e8f2ee5687$var$TenantContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $cc3f93e8f2ee5687$export$28e7c557f4d454d9 = ()=>{
    const tenantContext = (0, $fc4bM.useContext)($cc3f93e8f2ee5687$var$TenantContext);
    if (tenantContext === null) throw new Error('tenantContext value is null');
    return tenantContext;
};
const $cc3f93e8f2ee5687$export$e32355e80a92030c = ({ children: children, value: value })=>{
    if (!value) throw new Error('TenantContextProvider requires a value');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($cc3f93e8f2ee5687$var$TenantContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("8uBXm", function(module, exports) {
$parcel$export(module.exports, "AppsRenderer", () => $b2e4a60df01cc0b3$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $gbEv3 = parcelRequire("gbEv3");

var $hIHQ9 = parcelRequire("hIHQ9");

var $3M5IG = parcelRequire("3M5IG");
const $b2e4a60df01cc0b3$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $hIHQ9.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
        const { appId: appId, environmentId: envId } = (0, $gbEv3.parseExtensionId)(forgeExtension.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
            key: `${forgeExtension.id}-${triggerFieldInitializationKey}`,
            data: {
                attributes: {
                    appId: appId,
                    envId: envId
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3M5IG.SingleAppRenderer), {
            forgeExtension: forgeExtension,
            uiModificationsConfig: uiModificationsConfig,
            ForgeAppRenderer: ForgeAppRenderer
        }));
    }));
};

});
parcelRegister("gbEv3", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $3f4ff9760b01dcd4$export$bae42cbaf7fa3e1b);

var $cPhAu = parcelRequire("cPhAu");
const $3f4ff9760b01dcd4$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $cPhAu.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("cPhAu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5lpFe = parcelRequire("5lpFe");

var $3xjue = parcelRequire("3xjue");

$5lpFe.__exportStar((parcelRequire("cgimU")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $9567e3f50d75468e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $9567e3f50d75468e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $9567e3f50d75468e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $9567e3f50d75468e$var$InvalidAriError;
function $9567e3f50d75468e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $9567e3f50d75468e$var$basicCharConstraint = $3xjue.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $9567e3f50d75468e$var$resourceTypeCharConstraints = $3xjue.pattern(/^[a-z][a-z.-]*$/i);
const $9567e3f50d75468e$var$resourceOwnerConstraints = [
    $3xjue.lengthBetween(3, 255),
    $9567e3f50d75468e$var$basicCharConstraint
];
const $9567e3f50d75468e$var$resourceTypeConstraints = [
    $3xjue.lengthBetween(3, 255),
    $9567e3f50d75468e$var$resourceTypeCharConstraints
];
const $9567e3f50d75468e$var$cloudIdConstraints = [
    $3xjue.lengthBetween(3, 255)
];
const $9567e3f50d75468e$var$siteResourceType = 'site';
const $9567e3f50d75468e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $9567e3f50d75468e$var$resourceIdConstraints = [
    $3xjue.pattern(new RegExp(`^${$9567e3f50d75468e$var$resourceIdChars}+(/${$9567e3f50d75468e$var$resourceIdChars}*)*(;v=${$9567e3f50d75468e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $9567e3f50d75468e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $9567e3f50d75468e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $9567e3f50d75468e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $9567e3f50d75468e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $9567e3f50d75468e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $9567e3f50d75468e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $9567e3f50d75468e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $9567e3f50d75468e$var$InvalidAriError(ariString);
        return new $9567e3f50d75468e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $9567e3f50d75468e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $9567e3f50d75468e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $9567e3f50d75468e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $9567e3f50d75468e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $9567e3f50d75468e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $9567e3f50d75468e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $9567e3f50d75468e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $9567e3f50d75468e$var$siteResourceType && !!other.resourceType || $9567e3f50d75468e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $9567e3f50d75468e$var$siteResourceType && !!other.resourceType || $9567e3f50d75468e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $9567e3f50d75468e$var$siteResourceType && !cloudId) return new $3xjue.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $3xjue.validateField(this, 'resourceOwner', $9567e3f50d75468e$var$resourceOwnerConstraints),
            $3xjue.validateField(this, 'resourceType', $9567e3f50d75468e$var$resourceTypeConstraints),
            $3xjue.validateField(this, 'resourceId', $9567e3f50d75468e$var$resourceIdConstraints),
            $3xjue.validateField(this, 'cloudId', $9567e3f50d75468e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $9567e3f50d75468e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $9567e3f50d75468e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $9567e3f50d75468e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $9567e3f50d75468e$var$parse(ariString) {
    return $9567e3f50d75468e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $9567e3f50d75468e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $9567e3f50d75468e$var$parseEncoded(encodedAriString) {
    return $9567e3f50d75468e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $9567e3f50d75468e$var$parseEncoded;

});
parcelRegister("3xjue", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f4x58 = parcelRequire("f4x58");
class $293391cd3fd4f65b$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $293391cd3fd4f65b$var$LengthConstraint;
class $293391cd3fd4f65b$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $293391cd3fd4f65b$var$RegexConstraint;
class $293391cd3fd4f65b$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $293391cd3fd4f65b$var$GeneralValidationError;
class $293391cd3fd4f65b$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $293391cd3fd4f65b$var$ConstraintViolation;
function $293391cd3fd4f65b$var$lengthBetween(min, max) {
    return new $293391cd3fd4f65b$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $293391cd3fd4f65b$var$lengthBetween;
function $293391cd3fd4f65b$var$pattern(regex) {
    return new $293391cd3fd4f65b$var$RegexConstraint(regex);
}
module.exports.pattern = $293391cd3fd4f65b$var$pattern;
function $293391cd3fd4f65b$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($f4x58.isDefined);
    return violatedConstraints.length > 0 ? new $293391cd3fd4f65b$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $293391cd3fd4f65b$var$validateField;

});
parcelRegister("f4x58", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $af90e4130c991c70$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $af90e4130c991c70$var$isPresent;
function $af90e4130c991c70$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $af90e4130c991c70$var$isDefined;
function $af90e4130c991c70$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $af90e4130c991c70$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $af90e4130c991c70$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $af90e4130c991c70$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $af90e4130c991c70$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $af90e4130c991c70$var$hasValueAtKey;

});


parcelRegister("cgimU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cpFbn = parcelRequire("cpFbn");
var $8ed53a3ced210d20$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($8ed53a3ced210d20$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $8ed53a3ced210d20$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $8ed53a3ced210d20$var$AppFamilyAriError;
class $8ed53a3ced210d20$var$NotAppFamilyAriError extends $8ed53a3ced210d20$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $8ed53a3ced210d20$var$NotAppFamilyAriError;
class $8ed53a3ced210d20$var$NotExpectedAppFamilyAriTypeError extends $8ed53a3ced210d20$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $8ed53a3ced210d20$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $8ed53a3ced210d20$var$parseAppAri(ari) {
    return $cpFbn.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $8ed53a3ced210d20$var$parseAppAri;
function $8ed53a3ced210d20$var$createAppAri(json) {
    return new $cpFbn.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $8ed53a3ced210d20$var$createAppAri;

});
parcelRegister("cpFbn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cgimU = parcelRequire("cgimU");

var $cPhAu = parcelRequire("cPhAu");

var $3xjue = parcelRequire("3xjue");
const $9097c3cda0d72426$var$versionPrefix = ';v=';
const $9097c3cda0d72426$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $9097c3cda0d72426$var$uuidConstraints = [
    $3xjue.pattern(new RegExp(`^${$9097c3cda0d72426$var$uuidRegExpString}$`, 'i'))
];
const $9097c3cda0d72426$var$extensionGroupIdConstraints = [
    $3xjue.pattern(new RegExp(`^(${$9097c3cda0d72426$var$uuidRegExpString}|static)$`, 'i'))
];
class $9097c3cda0d72426$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $cgimU.AppFamilyAri.resourceOwner) throw new $cgimU.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$cgimU.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $cgimU.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $cgimU.NotAppFamilyAriError(ari, `resourceType must be one of ${$cgimU.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $cgimU.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($9097c3cda0d72426$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($9097c3cda0d72426$var$versionPrefix) > versionIndex) throw new $cgimU.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($9097c3cda0d72426$var$versionPrefix);
        const segments = mainResourceId.split('/').map($9097c3cda0d72426$var$stripToUndefined);
        if (segments.length > 4) throw new $cgimU.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $cgimU.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $cgimU.AppFamilyAri.extensionGroupResourceType || resourceType === $cgimU.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $cgimU.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $cgimU.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$cgimU.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $cgimU.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $cgimU.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$cgimU.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $cgimU.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $cgimU.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$cgimU.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $cgimU.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $cgimU.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$cgimU.AppFamilyAri.environmentResourceType}`);
        return new $9097c3cda0d72426$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $cgimU.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $3xjue.validateField(this, 'environmentId', $9097c3cda0d72426$var$uuidConstraints),
            $3xjue.validateField(this, 'appId', $9097c3cda0d72426$var$uuidConstraints),
            $3xjue.validateField(this, 'extensionGroupId', $9097c3cda0d72426$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $cPhAu.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $cgimU.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$9097c3cda0d72426$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $cPhAu.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $cgimU.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $cPhAu.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $cgimU.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $cPhAu.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $cgimU.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $cPhAu.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $cgimU.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $9097c3cda0d72426$var$AppFamilyAriImpl;
function $9097c3cda0d72426$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("hIHQ9", function(module, exports) {
$parcel$export(module.exports, "useTriggerFieldInitialization", () => $8766f958b0df4677$export$1c69013aaf9112f0);
// eslint-disable-next-line import/order

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $8766f958b0df4677$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $8766f958b0df4677$export$1c69013aaf9112f0 = (0, $5nVr1.createHook)((0, $kzQWi.store), {
    selector: $8766f958b0df4677$var$selectTriggerFieldInitializationKey
});

});

parcelRegister("3M5IG", function(module, exports) {
$parcel$export(module.exports, "SingleAppRenderer", () => $3814d6275b2e9c54$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $kv786 = parcelRequire("kv786");

var $gbEv3 = parcelRequire("gbEv3");

var $ih9LT = parcelRequire("ih9LT");

var $aN3M1 = parcelRequire("aN3M1");

var $43SzX = parcelRequire("43SzX");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $5YXrV = parcelRequire("5YXrV");

var $3LZgF = parcelRequire("3LZgF");

var $5Guc4 = parcelRequire("5Guc4");

var $8cH4c = parcelRequire("8cH4c");

var $98xeI = parcelRequire("98xeI");

var $bsGgK = parcelRequire("bsGgK");
const $3814d6275b2e9c54$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const viewType = (0, $aiipA.useViewType)();
    const executionContext = (0, $43SzX.useExecutionContext)();
    const extensionData = (0, $fc4bM.useMemo)(()=>(0, $bsGgK.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $gbEv3.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $5Guc4.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $3LZgF.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $8cH4c.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $ih9LT.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $fc4bM.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $5YXrV.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $aN3M1.UIM_CONSENT_REQUIRED)) {
            setLoadingComplete();
            (0, $5YXrV.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $98xeI.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kv786.default), {
        name: "single-frame-iframe",
        fallback: null,
        key: moduleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ForgeAppRenderer, {
        extension: forgeExtension,
        extensionData: extensionData,
        customBridgeMethods: customBridgeMethods,
        onIframeLoad: (0, $5YXrV.getAnalytics)(viewType).markIframeLoad,
        isIframeResizable: false,
        isIframeHidden: true,
        ...consentProps
    }));
};

});
parcelRegister("3LZgF", function(module, exports) {
$parcel$export(module.exports, "useCustomBridgeMethods", () => $f928188bd501f55f$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $6uIU4 = parcelRequire("6uIU4");

var $dKlRN = parcelRequire("dKlRN");

var $1RxQr = parcelRequire("1RxQr");

var $aPu3F = parcelRequire("aPu3F");

var $bQOSB = parcelRequire("bQOSB");

var $bPLX1 = parcelRequire("bPLX1");

var $1jMAo = parcelRequire("1jMAo");
const $f928188bd501f55f$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $bQOSB.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $1RxQr.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $1jMAo.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $bPLX1.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $dKlRN.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $aPu3F.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $fc4bM.useCallback)(()=>{
        onBridgeCommunicationReceived === null || onBridgeCommunicationReceived === void 0 || onBridgeCommunicationReceived();
        return {
            data: {
                onInitChangeId: (0, $6uIU4.ON_INIT_CHANGE_ID),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $fc4bM.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
parcelRegister("dKlRN", function(module, exports) {
$parcel$export(module.exports, "useOnBridgeError", () => $61101334c322af89$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $e3M82 = parcelRequire("e3M82");

var $jok5A = parcelRequire("jok5A");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $5YXrV = parcelRequire("5YXrV");

var $dDoxB = parcelRequire("dDoxB");
const $61101334c322af89$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($e3M82)))(payload) && (0, $dDoxB.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $61101334c322af89$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const viewType = (0, $aiipA.useViewType)();
    return (0, $fc4bM.useCallback)((payload)=>{
        if (!$61101334c322af89$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error, cause: cause } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $5YXrV.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`, {
            cause: cause
        });
        (0, $jok5A.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error,
                cause: cause
            }
        });
    }, [
        setError,
        unregisterFields,
        viewType,
        appId
    ]);
};

});
parcelRegister("dDoxB", function(module, exports) {
$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $7b0dd4fe38766df9$export$7845535459d8a620);
const $7b0dd4fe38766df9$export$6634aa68b37142fc = 'onInitError';
const $7b0dd4fe38766df9$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $7b0dd4fe38766df9$export$3018e0c759270938 = 'getApiError';
const $7b0dd4fe38766df9$export$7845535459d8a620 = [
    $7b0dd4fe38766df9$export$6634aa68b37142fc,
    $7b0dd4fe38766df9$export$7ab66e58aded6116,
    $7b0dd4fe38766df9$export$3018e0c759270938
];

});


parcelRegister("1RxQr", function(module, exports) {
$parcel$export(module.exports, "useOnChangeSubscription", () => $86a9808e108e6901$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $hWDOW = parcelRequire("hWDOW");

var $ciPjL = parcelRequire("ciPjL");

var $bTjpv = parcelRequire("bTjpv");

var $aiipA = parcelRequire("aiipA");

var $5agEy = parcelRequire("5agEy");

var $jGXRS = parcelRequire("jGXRS");
const $86a9808e108e6901$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $aiipA.useViewType)();
    const notifyAppRef = (0, $fc4bM.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $bTjpv.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $ciPjL.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    /**
   * Single ref for all data that must be up-to-date but not trigger notification.
   */ const dataRef = (0, $fc4bM.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $fc4bM.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $5agEy.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $jGXRS.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $fc4bM.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("ciPjL", function(module, exports) {
$parcel$export(module.exports, "useCurrentFormState", () => $70ad611c84967ef6$export$655680d54d70050d);

var $g6dQg = parcelRequire("g6dQg");
var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $70ad611c84967ef6$var$stableEmpty = {};
const $70ad611c84967ef6$var$stableEmptyScreenTabsArrray = [];
const $70ad611c84967ef6$var$selectCurrentFormState = (0, $g6dQg.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $70ad611c84967ef6$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $70ad611c84967ef6$var$stableEmpty,
        currentScreenTabsState: $70ad611c84967ef6$var$stableEmptyScreenTabsArrray
    };
});
const $70ad611c84967ef6$export$655680d54d70050d = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    selector: $70ad611c84967ef6$var$selectCurrentFormState
});

});

parcelRegister("bTjpv", function(module, exports) {
$parcel$export(module.exports, "useLastProcessedChange", () => $b1b301b841fed312$export$e5124fbd2a3221d);

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $b1b301b841fed312$export$e5124fbd2a3221d = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("5agEy", function(module, exports) {
$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $5de7a47a699bfd1b$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $5de7a47a699bfd1b$export$51fbc854b278b1ff);

var $5YXrV = parcelRequire("5YXrV");
const $5de7a47a699bfd1b$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    var _getSupportedFieldCon;
    const fieldRequiredScopes = (_getSupportedFieldCon = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $5de7a47a699bfd1b$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!(value !== null && value !== void 0 && value.fieldType)) return false;
        const { fieldType: fieldType } = value;
        return $5de7a47a699bfd1b$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $5de7a47a699bfd1b$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field === null || field === void 0 ? void 0 : field.fieldType;
        if (!fieldType) return false;
        return $5de7a47a699bfd1b$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("jGXRS", function(module, exports) {
$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $3829b8609b805b3c$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $3829b8609b805b3c$export$6a622a0cc96dcad7);

var $hWDOW = parcelRequire("hWDOW");

var $34xW7 = parcelRequire("34xW7");
const $3829b8609b805b3c$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $3829b8609b805b3c$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $3829b8609b805b3c$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($3829b8609b805b3c$var$includeCoarseScopes((0, $34xW7.baseRequiredReadScopes), moduleScopes) || $3829b8609b805b3c$var$includeGranularScopes((0, $34xW7.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $3829b8609b805b3c$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($3829b8609b805b3c$var$includeCoarseScopes((0, $34xW7.baseRequiredWriteScopes), moduleScopes) || $3829b8609b805b3c$var$includeGranularScopes((0, $34xW7.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("34xW7", function(module, exports) {
$parcel$export(module.exports, "baseRequiredReadScopes", () => $1da5e7066f48057a$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $1da5e7066f48057a$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $1da5e7066f48057a$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $1da5e7066f48057a$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("aPu3F", function(module, exports) {
$parcel$export(module.exports, "useOnErrorSubscription", () => $cc0fba381cb67fdd$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $25okM = parcelRequire("25okM");

var $jEubQ = parcelRequire("jEubQ");

var $hWDOW = parcelRequire("hWDOW");

var $jhmOR = parcelRequire("jhmOR");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");
const $cc0fba381cb67fdd$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $aiipA.useViewType)();
    const notifyAppRef = (0, $fc4bM.useRef)(null);
    const { appErrors: appErrors } = (0, $jhmOR.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $kzQWi.useIssueAdjustmentsActions)();
    (0, $fc4bM.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($25okM)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $fc4bM.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("jhmOR", function(module, exports) {
$parcel$export(module.exports, "useAppErrors", () => $9582b4f42fa38c0a$export$535312244836989b);

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $9582b4f42fa38c0a$export$535312244836989b = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("bQOSB", function(module, exports) {
$parcel$export(module.exports, "useOnInit", () => $8308b0d8c98e3b26$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $hWDOW = parcelRequire("hWDOW");

var $iDMNo = parcelRequire("iDMNo");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $5YXrV = parcelRequire("5YXrV");

var $5agEy = parcelRequire("5agEy");

var $jGXRS = parcelRequire("jGXRS");
const $8308b0d8c98e3b26$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $8308b0d8c98e3b26$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $fc4bM.useRef)(null);
    const viewType = (0, $aiipA.useViewType)();
    const publicUIMDataForApp = (0, $iDMNo.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $fc4bM.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $5agEy.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $jGXRS.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $8308b0d8c98e3b26$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $5YXrV.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("iDMNo", function(module, exports) {
$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $175868a9ef4d82d5$export$484a467ba25fea19);

var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");

var $kLX2P = parcelRequire("kLX2P");
const $175868a9ef4d82d5$export$484a467ba25fea19 = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    selector: (0, $kLX2P.selectReadyPublicDataForOnInit)
});

});


parcelRegister("bPLX1", function(module, exports) {
$parcel$export(module.exports, "useRegisterFields", () => $5811eb4d24f2518e$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $5YXrV = parcelRequire("5YXrV");
const $5811eb4d24f2518e$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const viewType = (0, $aiipA.useViewType)();
    return (0, $fc4bM.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $5YXrV.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("1jMAo", function(module, exports) {
$parcel$export(module.exports, "useSubmit", () => $207a68f23b0a281e$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $jEubQ = parcelRequire("jEubQ");

var $jok5A = parcelRequire("jok5A");

var $hWDOW = parcelRequire("hWDOW");

var $hkmlN = parcelRequire("hkmlN");

var $6uIU4 = parcelRequire("6uIU4");

var $gl0Ji = parcelRequire("gl0Ji");

var $43SzX = parcelRequire("43SzX");

var $29m7T = parcelRequire("29m7T");

var $3wnCh = parcelRequire("3wnCh");

var $bTjpv = parcelRequire("bTjpv");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $bTH3p = parcelRequire("bTH3p");

var $UNIiR = parcelRequire("UNIiR");

var $5YXrV = parcelRequire("5YXrV");

var $jGXRS = parcelRequire("jGXRS");

var $lU2oU = parcelRequire("lU2oU");

var $8hxV5 = parcelRequire("8hxV5");
const $207a68f23b0a281e$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const viewType = (0, $aiipA.useViewType)();
    const getAsyncLookupData = (0, $29m7T.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $8hxV5.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $UNIiR.useTenantContext)();
    const executionContext = (0, $43SzX.useExecutionContext)();
    const environment = (0, $3BZyK.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $lU2oU.useFieldsChangesValidation)();
    const { lastProcessedChange: lastProcessedChange } = (0, $bTjpv.useLastProcessedChange)();
    const lastChangedProcessRef = (0, $fc4bM.useRef)(lastProcessedChange);
    const formMetadata = (0, $3wnCh.useFormMetadata)();
    const formMetadataRef = (0, $fc4bM.useRef)(formMetadata);
    formMetadataRef.current = formMetadata;
    (0, $fc4bM.useEffect)(()=>{
        lastChangedProcessRef.current = lastProcessedChange;
    }, [
        lastProcessedChange
    ]);
    const intl = (0, $gpjDl.default)();
    const getFieldAttributesForAnalytics = (0, $fc4bM.useCallback)((fieldsChanges)=>{
        try {
            const fieldAttributes = [];
            for(const fieldId in fieldsChanges){
                var _formMetadataRef$curr;
                if ((_formMetadataRef$curr = formMetadataRef.current) !== null && _formMetadataRef$curr !== void 0 && _formMetadataRef$curr[fieldId]) {
                    const { fieldType: fieldType } = formMetadataRef.current[fieldId];
                    const attributes = Object.keys(fieldsChanges[fieldId]);
                    fieldAttributes.push({
                        fieldType: fieldType,
                        attributes: attributes
                    });
                }
            }
            return JSON.stringify(fieldAttributes);
        // oxlint-disable-next-line no-unused-vars
        } catch (_error) {
            return 'NULL';
        }
    }, []);
    return (0, $fc4bM.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        let isSameFieldValueChanged = false;
        let fieldType = null;
        // Name the event after the canonical viewType (so overlay traffic lands in the
        // same bucket) and move the real viewType into attributes so we still know
        // exactly where we are.
        const analyticsViewType = executionContext.analyticsViewType ? executionContext.analyticsViewType : viewType;
        try {
            var _lastChangedProcessRe, _formMetadataRef$curr2;
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: // TODO: We should pass validatedFieldsChanges instead of fieldsChanges, UIM-2214
                lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $jGXRS.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $5YXrV.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            isSameFieldValueChanged = (0, $gl0Ji.checkSameFieldValueChanged)(fieldsChanges, lastChangedProcessRef.current, changeId);
            if ((_lastChangedProcessRe = lastChangedProcessRef.current) !== null && _lastChangedProcessRe !== void 0 && _lastChangedProcessRe.fieldId && (_formMetadataRef$curr2 = formMetadataRef.current) !== null && _formMetadataRef$curr2 !== void 0 && _formMetadataRef$curr2[lastChangedProcessRef.current.fieldId]) {
                const fieldId = lastChangedProcessRef.current.fieldId;
                const { fieldType: fieldTypeFromFormMetadata } = formMetadataRef.current[fieldId];
                fieldType = fieldTypeFromFormMetadata;
            }
            (0, $hkmlN.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${analyticsViewType}jiraUiModificationsUseSubmit`,
                attributes: {
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $6uIU4.ON_INIT_CHANGE_ID),
                    fieldType: fieldType,
                    submittedFields: getFieldAttributesForAnalytics(fieldsChanges),
                    viewType: viewType
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $5YXrV.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $bTH3p.UiModificationsValidationError)) {
                (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $jok5A.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                analyticsViewType: analyticsViewType,
                attributes: {
                    errorCause: err === null || err === void 0 ? void 0 : err.cause,
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $6uIU4.ON_INIT_CHANGE_ID),
                    fieldType: fieldType
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields,
        getFieldAttributesForAnalytics
    ]);
};

});
parcelRegister("hkmlN", function(module, exports) {
$parcel$export(module.exports, "fireTrackEvent", () => $30c806508bf180b7$export$574d2f19a52d67ca);

var $8lxUN = parcelRequire("8lxUN");

var $aVQWM = parcelRequire("aVQWM");

var $d9XyX = parcelRequire("d9XyX");
const $30c806508bf180b7$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $8lxUN.default)((0, $d9XyX.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $aVQWM.TRACK_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});

parcelRegister("29m7T", function(module, exports) {
$parcel$export(module.exports, "useLookupFieldData", () => $9aa2bb29a138963c$export$d43e9e394c54e784);

var $fc4bM = parcelRequire("fc4bM");

var $l8G72 = parcelRequire("l8G72");

var $3BZyK = parcelRequire("3BZyK");

var $jEubQ = parcelRequire("jEubQ");

var $87Mi2 = parcelRequire("87Mi2");

var $1RhjL = parcelRequire("1RhjL");

var $819o0 = parcelRequire("819o0");

var $1nb6c = parcelRequire("1nb6c");

var $l00Jg = parcelRequire("l00Jg");

var $aqMjO = parcelRequire("aqMjO");

var $dOExu = parcelRequire("dOExu");

var $43SzX = parcelRequire("43SzX");

var $3wnCh = parcelRequire("3wnCh");

var $aiipA = parcelRequire("aiipA");

var $UNIiR = parcelRequire("UNIiR");

var $5YXrV = parcelRequire("5YXrV");
const $9aa2bb29a138963c$var$getProjectScope = (executionContext)=>{
    const { project: project } = executionContext;
    if (!project || typeof project !== 'object' || !('id' in project) || !('key' in project)) return null;
    const { id: id, key: key } = project;
    return typeof id === 'string' && typeof key === 'string' ? {
        id: id,
        key: key
    } : null;
};
const $9aa2bb29a138963c$export$d43e9e394c54e784 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $UNIiR.useTenantContext)();
    const environment = (0, $3BZyK.useRelayEnvironment)();
    const formMetadata = (0, $3wnCh.useFormMetadata)();
    const formMetadataRef = (0, $fc4bM.useRef)(formMetadata);
    const viewType = (0, $aiipA.useViewType)();
    const executionContext = (0, $43SzX.useExecutionContext)();
    const executionContextRef = (0, $fc4bM.useRef)(executionContext);
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    executionContextRef.current = executionContext;
    return (0, $fc4bM.useCallback)(async (fieldsChanges)=>{
        var _asyncFieldsValues$co, _asyncFieldsValues$ve;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration === null || supportedFieldsConfiguration === void 0 ? void 0 : supportedFieldsConfiguration.lookupSource;
            const isUserLookupField = lookupSource === (0, $87Mi2.LOOKUP_SOURCE_USERS_ASYNC_DATA);
            const isProjectLookupField = lookupSource === (0, $87Mi2.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA);
            const isComponentLookupField = lookupSource === (0, $87Mi2.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA);
            const isVersionLookupField = lookupSource === (0, $87Mi2.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA);
            if (isUserLookupField && fieldValue && (0, $1RhjL.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            if (isProjectLookupField && fieldValue) {
                const currentProjectIds = acc.projectIds ? [
                    ...acc.projectIds
                ] : [];
                const newProjectIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.projectIds = [
                    ...currentProjectIds,
                    ...newProjectIds
                ];
            }
            if (isComponentLookupField && fieldValue) {
                const currentComponentIds = acc.componentIds ? [
                    ...acc.componentIds
                ] : [];
                const newComponentIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.componentIds = [
                    ...currentComponentIds,
                    ...newComponentIds
                ];
            }
            if (isVersionLookupField && fieldValue) {
                const currentVersionIds = acc.versionIds ? [
                    ...acc.versionIds
                ] : [];
                const newVersionIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.versionIds = [
                    ...currentVersionIds,
                    ...newVersionIds
                ];
            }
            return acc;
        }, {});
        let users = [];
        let projects = [];
        let components = [];
        let versions = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))(asyncFieldsValues.accountIds);
            users = await (0, $aqMjO.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        if (asyncFieldsValues.projectIds) {
            const uniqueProjectIds = (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))(asyncFieldsValues.projectIds);
            // Convert numeric project IDs to ARIs before fetching
            // GraphQL expects ARIs like "ari:cloud:jira:{cloudId}:project/10001", not plain "10001"
            const projectAris = (0, $819o0.convertProjectIdsToAris)(uniqueProjectIds, cloudId);
            projects = await (0, $l00Jg.fetchProjects)(environment, projectAris, createAnalyticsEvent);
        }
        const projectScope = $9aa2bb29a138963c$var$getProjectScope(executionContextRef.current);
        if ((_asyncFieldsValues$co = asyncFieldsValues.componentIds) !== null && _asyncFieldsValues$co !== void 0 && _asyncFieldsValues$co.length && projectScope) {
            const uniqueComponentIds = (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))(asyncFieldsValues.componentIds);
            components = await (0, $1nb6c.fetchComponents)(environment, cloudId, projectScope.key, uniqueComponentIds, createAnalyticsEvent);
        }
        if ((_asyncFieldsValues$ve = asyncFieldsValues.versionIds) !== null && _asyncFieldsValues$ve !== void 0 && _asyncFieldsValues$ve.length && projectScope) {
            const uniqueVersionIds = (0, (/*@__PURE__*/$parcel$interopDefault($l8G72)))(asyncFieldsValues.versionIds);
            versions = await (0, $dOExu.fetchVersions)(environment, cloudId, projectScope.key, uniqueVersionIds, createAnalyticsEvent);
        }
        lookupData[0, $87Mi2.LOOKUP_SOURCE_USERS_ASYNC_DATA] = users;
        lookupData[0, $87Mi2.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA] = projects;
        lookupData[0, $87Mi2.LOOKUP_SOURCE_COMPONENTS_ASYNC_DATA] = components;
        lookupData[0, $87Mi2.LOOKUP_SOURCE_VERSIONS_ASYNC_DATA] = versions;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment,
        cloudId
    ]);
};

});
parcelRegister("819o0", function(module, exports) {
$parcel$export(module.exports, "convertProjectIdsToAris", () => $0c65bd873101a41e$export$2a73bd4f6cc71a00);
/**
 * Converts a project ID to a Jira project ARI.
 *
 * @param projectId - The project ID (numeric string like "10001" or already an ARI)
 * @param cloudId - The cloud/tenant ID
 * @returns The full project ARI in format "ari:cloud:jira:{cloudId}:project/{projectId}"
 *
 * @example
 * ```typescript
 * convertProjectIdToAri("10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001"
 *
 * convertProjectIdToAri("ari:cloud:jira:abc-123-def:project/10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001" (unchanged)
 * ```
 */ const $0c65bd873101a41e$export$fee909b034ddb326 = (projectId, cloudId)=>{
    // If already an ARI, return as-is
    if (projectId.startsWith('ari:')) return projectId;
    // Convert numeric project ID to ARI format
    return `ari:cloud:jira:${cloudId}:project/${projectId}`;
};
const $0c65bd873101a41e$export$2a73bd4f6cc71a00 = (projectIds, cloudId)=>{
    return projectIds.map((id)=>$0c65bd873101a41e$export$fee909b034ddb326(id, cloudId));
};

});

parcelRegister("1nb6c", function(module, exports) {
$parcel$export(module.exports, "fetchComponents", () => $37c637c7d02f8ce7$export$4f703ddb7c8cc5b3);

var $4La3R = parcelRequire("4La3R");

var $3BZyK = parcelRequire("3BZyK");

var $hWDOW = parcelRequire("hWDOW");

var $eH2AW = parcelRequire("eH2AW");
const $37c637c7d02f8ce7$export$4f703ddb7c8cc5b3 = async (environment, cloudId, projectIdOrKey, componentIds, createAnalyticsEvent)=>{
    try {
        var _response$jira_projec;
        const apiStartTime = performance.now();
        const response = await (0, $3BZyK.fetchQuery)(environment, (0, $4La3R.default), {
            cloudId: cloudId,
            idOrKey: projectIdOrKey,
            componentIds: componentIds,
            first: componentIds.length
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const connection = response === null || response === void 0 || (_response$jira_projec = response.jira_projectByIdOrKey) === null || _response$jira_projec === void 0 ? void 0 : _response$jira_projec.components;
        if (!connection) throw new (0, $eH2AW.ErrorWithStatusCode)('[fetch-components service] [fetchComponentsQuery]: Property jira_projectByIdOrKey.components does not exist.', {
            cause: 'FETCH_COMPONENTS_MISSING_COMPONENTS_PROPERTY'
        }, 'FETCH_COMPONENTS_MISSING_COMPONENTS_PROPERTY');
        const resolved = [];
        for (const edge of connection.edges ?? []){
            const node = edge === null || edge === void 0 ? void 0 : edge.node;
            if (node !== null && node !== void 0 && node.componentId) resolved.push({
                id: node.componentId,
                name: node.name ?? ''
            });
        }
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchComponents',
            attributes: {
                componentsAPILatency: apiLatencyMs
            }
        });
        return resolved;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_COMPONENTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("4La3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $722a760767fd8cce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72506ae8440435e02d7f3c56abf88feb>>
 * @relayHash 37d93a84b6e6288eab04437f1692cb28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b68508a27ab628b521cd513005cdad2a9785f41028da93157f24132b2909ad09
const $722a760767fd8cce$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "componentIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "idOrKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "idOrKey"
        }
    ], v5 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "componentIds"
                },
                {
                    "kind": "Literal",
                    "name": "operation",
                    "value": "ALLOW"
                }
            ],
            "kind": "ObjectValue",
            "name": "filterById"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "componentId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchComponentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraComponentConnection",
                            "kind": "LinkedField",
                            "name": "components",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraComponentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraComponent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchComponentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraComponentConnection",
                            "kind": "LinkedField",
                            "name": "components",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraComponentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraComponent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "b68508a27ab628b521cd513005cdad2a9785f41028da93157f24132b2909ad09",
            "metadata": {},
            "name": "fetchComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$722a760767fd8cce$var$node.hash = "6c026a99ef4cd36167652e2f64e1e401";
var $722a760767fd8cce$export$2e2bcd8739ae039 = $722a760767fd8cce$var$node;

});

parcelRegister("eH2AW", function(module, exports) {
$parcel$export(module.exports, "ErrorWithStatusCode", () => $70af219f87831770$export$13144d723cf04c);
class $70af219f87831770$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("l00Jg", function(module, exports) {
$parcel$export(module.exports, "fetchProjects", () => $4f51164902bef021$export$f0d2ca471cdb99b0);

var $87CsT = parcelRequire("87CsT");

var $3BZyK = parcelRequire("3BZyK");

var $hWDOW = parcelRequire("hWDOW");

var $eH2AW = parcelRequire("eH2AW");
const $4f51164902bef021$export$f0d2ca471cdb99b0 = async (environment, projectIds, createAnalyticsEvent)=>{
    try {
        var _response$jira;
        const apiStartTime = performance.now();
        const response = await (0, $3BZyK.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $87CsT.default), {
            projectIds: projectIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && (_response$jira = response.jira) !== null && _response$jira !== void 0 && _response$jira.jiraProjects)) throw new (0, $eH2AW.ErrorWithStatusCode)('[fetch-projects service] [fetchProjectsQuery]: Property jira.jiraProjects does not exist.', {
            cause: 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY'
        }, 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchProjects',
            attributes: {
                projectsAPILatency: apiLatencyMs
            }
        });
        return response.jira.jiraProjects.filter((project)=>project !== null && project !== undefined && project.projectId !== null && project.projectId !== undefined).map((project)=>{
            var _project$avatar;
            return {
                // Use projectId (numeric ID like "10001"), not id (ARI)
                id: project.projectId,
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': ((_project$avatar = project.avatar) === null || _project$avatar === void 0 ? void 0 : _project$avatar.large) || ''
                }
            };
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_PROJECTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("87CsT", function(module, exports) {
$parcel$export(module.exports, "default", () => $56254a466d1e9574$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63bd7a4e2ee2e0f9a2be5f0889617550>>
 * @relayHash 8dddd1ce7676474299e324ca788770e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e
const $56254a466d1e9574$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ids",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjects",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e",
            "metadata": {},
            "name": "fetchProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$56254a466d1e9574$var$node.hash = "bfbd83d6cfdfb7072506c62a347912b6";
var $56254a466d1e9574$export$2e2bcd8739ae039 = $56254a466d1e9574$var$node;

});


parcelRegister("aqMjO", function(module, exports) {
$parcel$export(module.exports, "fetchUsers", () => $5423c73da86aef43$export$2bb8333a9210be15);

var $5n93K = parcelRequire("5n93K");

var $3BZyK = parcelRequire("3BZyK");

var $hWDOW = parcelRequire("hWDOW");

var $eH2AW = parcelRequire("eH2AW");
const $5423c73da86aef43$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $3BZyK.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $5n93K.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && response.users)) throw new (0, $eH2AW.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("5n93K", function(module, exports) {
$parcel$export(module.exports, "default", () => $08ba62df699f1de8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e70547764e67b037edaf0816b6f4ec77>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $08ba62df699f1de8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$08ba62df699f1de8$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $08ba62df699f1de8$export$2e2bcd8739ae039 = $08ba62df699f1de8$var$node;

});


parcelRegister("dOExu", function(module, exports) {
$parcel$export(module.exports, "fetchVersions", () => $aa0b667c091b9b74$export$4559ccb0044798a5);

var $kYciJ = parcelRequire("kYciJ");

var $3BZyK = parcelRequire("3BZyK");

var $hWDOW = parcelRequire("hWDOW");

var $eH2AW = parcelRequire("eH2AW");
const $aa0b667c091b9b74$export$4559ccb0044798a5 = async (environment, cloudId, projectIdOrKey, versionIds, createAnalyticsEvent)=>{
    try {
        var _response$jira_projec;
        const apiStartTime = performance.now();
        const response = await (0, $3BZyK.fetchQuery)(environment, (0, $kYciJ.default), {
            cloudId: cloudId,
            idOrKey: projectIdOrKey,
            versionIds: versionIds,
            first: versionIds.length
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const connection = response === null || response === void 0 || (_response$jira_projec = response.jira_projectByIdOrKey) === null || _response$jira_projec === void 0 ? void 0 : _response$jira_projec.versions;
        if (!connection) throw new (0, $eH2AW.ErrorWithStatusCode)('[fetch-versions service] [fetchVersionsQuery]: Property jira_projectByIdOrKey.versions does not exist.', {
            cause: 'FETCH_VERSIONS_MISSING_VERSIONS_PROPERTY'
        }, 'FETCH_VERSIONS_MISSING_VERSIONS_PROPERTY');
        const resolved = [];
        for (const edge of connection.edges ?? []){
            const node = edge === null || edge === void 0 ? void 0 : edge.node;
            if (node !== null && node !== void 0 && node.versionId) resolved.push({
                id: node.versionId,
                name: node.name ?? ''
            });
        }
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchVersions',
            attributes: {
                versionsAPILatency: apiLatencyMs
            }
        });
        return resolved;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_VERSIONS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("kYciJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ffe3862ce468c4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c93d89a2145fdb8572a6bb0cef7da0ec>>
 * @relayHash 61e6877436db9caf5fc1888b682137a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e497389782710d6c061f7eb4f4aab84b821ebfeb8f7c94409d3c758c2f7ec0f
const $1ffe3862ce468c4c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "idOrKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionIds"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "idOrKey"
        }
    ], v5 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": [
                "RELEASED",
                "UNRELEASED",
                "ARCHIVED"
            ]
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "versionIds"
                },
                {
                    "kind": "Literal",
                    "name": "operation",
                    "value": "ALLOW"
                }
            ],
            "kind": "ObjectValue",
            "name": "filterById"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchVersionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchVersionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2e497389782710d6c061f7eb4f4aab84b821ebfeb8f7c94409d3c758c2f7ec0f",
            "metadata": {},
            "name": "fetchVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1ffe3862ce468c4c$var$node.hash = "6bcc668390a80ba013587a8380113f14";
var $1ffe3862ce468c4c$export$2e2bcd8739ae039 = $1ffe3862ce468c4c$var$node;

});


parcelRegister("3wnCh", function(module, exports) {
$parcel$export(module.exports, "useFormMetadata", () => $044c7cc20a0efedb$export$863414fa128cb7ef);

var $g6dQg = parcelRequire("g6dQg");
var $5nVr1 = parcelRequire("5nVr1");

var $kzQWi = parcelRequire("kzQWi");
const $044c7cc20a0efedb$var$selectFormMetadata = (0, $g6dQg.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $044c7cc20a0efedb$export$863414fa128cb7ef = (0, $5nVr1.createStateHook)((0, $kzQWi.store), {
    selector: $044c7cc20a0efedb$var$selectFormMetadata
});

});


parcelRegister("lU2oU", function(module, exports) {
$parcel$export(module.exports, "useFieldsChangesValidation", () => $938c5fcbb3618b76$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $ciPjL = parcelRequire("ciPjL");

var $3wnCh = parcelRequire("3wnCh");

var $aiipA = parcelRequire("aiipA");

var $hu03C = parcelRequire("hu03C");

var $fA1wf = parcelRequire("fA1wf");
const $938c5fcbb3618b76$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $938c5fcbb3618b76$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $938c5fcbb3618b76$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const formMetadata = (0, $3wnCh.useFormMetadata)();
    const formMetadataRef = (0, $fc4bM.useRef)(formMetadata);
    const viewType = (0, $aiipA.useViewType)();
    const { currentFormState: currentFormState } = (0, $ciPjL.useCurrentFormState)();
    const currentFormStateRef = (0, $fc4bM.useRef)(currentFormState);
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $fc4bM.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $fA1wf.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $938c5fcbb3618b76$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $hu03C.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $938c5fcbb3618b76$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("fA1wf", function(module, exports) {
$parcel$export(module.exports, "validateFieldChanges", () => $574733ae75c36969$export$a2b7ddd7c3d0703a);

var $5YXrV = parcelRequire("5YXrV");

var $i3k7T = parcelRequire("i3k7T");

var $dMo6s = parcelRequire("dMo6s");
const $574733ae75c36969$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $5YXrV.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $i3k7T.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $dMo6s.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $dMo6s.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $i3k7T.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $dMo6s.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $i3k7T.VALID_RESULT;
};

});
parcelRegister("i3k7T", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $02a32fc8f348ccdc$export$ee79e3ab53b8db79);
const $02a32fc8f348ccdc$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("dMo6s", function(module, exports) {
$parcel$export(module.exports, "prepareValidationResult", () => $d89f325e66f7041a$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $d89f325e66f7041a$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $d89f325e66f7041a$export$fd744b06c9068a9e);

var $h7jt0 = parcelRequire("h7jt0");

var $eKEBo = parcelRequire("eKEBo");

var $i3k7T = parcelRequire("i3k7T");
const $d89f325e66f7041a$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $h7jt0.FIELD_VALIDATION_ERROR),
            method: (0, $eKEBo.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $i3k7T.VALID_RESULT;
};
const $d89f325e66f7041a$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $h7jt0.FIELD_VALIDATION_ERROR),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $i3k7T.VALID_RESULT;
};
const $d89f325e66f7041a$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $d89f325e66f7041a$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $d89f325e66f7041a$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $d89f325e66f7041a$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $d89f325e66f7041a$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});



parcelRegister("8hxV5", function(module, exports) {
$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $8e65d21fe9bc4f04$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $ciPjL = parcelRequire("ciPjL");

var $aiipA = parcelRequire("aiipA");

var $5agEy = parcelRequire("5agEy");
const $8e65d21fe9bc4f04$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $ciPjL.useCurrentFormState)();
    const currentFormStateRef = (0, $fc4bM.useRef)(currentFormState);
    const viewType = (0, $aiipA.useViewType)();
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ currentFormStateRef.current = currentFormState;
    return (0, $fc4bM.useCallback)((fieldChanges)=>(0, $5agEy.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("5Guc4", function(module, exports) {
$parcel$export(module.exports, "useIframeTimeout", () => $d29578d6b06ddd2d$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $aUAhb = parcelRequire("aUAhb");

var $jEubQ = parcelRequire("jEubQ");

var $hWDOW = parcelRequire("hWDOW");

var $aiipA = parcelRequire("aiipA");
const $d29578d6b06ddd2d$export$45f7ef64ce535ffd = 12000;
const $d29578d6b06ddd2d$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $fc4bM.useRef)(undefined);
    const callbackRef = (0, $fc4bM.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($aUAhb))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const viewType = (0, $aiipA.useViewType)();
    const onTimeout = (0, $fc4bM.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$d29578d6b06ddd2d$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $fc4bM.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $fc4bM.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $d29578d6b06ddd2d$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("8cH4c", function(module, exports) {
$parcel$export(module.exports, "useScopeChecks", () => $6cb80e23f6a7792b$export$5b312a37a22a70a8);

var $a9OTG = parcelRequire("a9OTG");
const $6cb80e23f6a7792b$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $a9OTG.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $a9OTG.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("a9OTG", function(module, exports) {
$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $50d2506c6ec12569$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $50d2506c6ec12569$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $50d2506c6ec12569$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $50d2506c6ec12569$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("98xeI", function(module, exports) {
$parcel$export(module.exports, "useThreeLOPromptProps", () => $57c53ce4bd532d84$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $gbEv3 = parcelRequire("gbEv3");

var $hWDOW = parcelRequire("hWDOW");

var $g4H12 = parcelRequire("g4H12");

var $ih9LT = parcelRequire("ih9LT");

var $aN3M1 = parcelRequire("aN3M1");

var $aiipA = parcelRequire("aiipA");

var $5YXrV = parcelRequire("5YXrV");
const $57c53ce4bd532d84$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $fc4bM.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $g4H12.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $gbEv3.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $aiipA.useViewType)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const currentUIModificationsConsentStatus = (0, $ih9LT.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $fc4bM.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $aN3M1.UIM_CONSENT_CONSENTED)
        });
        (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $fc4bM.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $aN3M1.UIM_CONSENT_UNKNOWN)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $aN3M1.UIM_CONSENT_REQUIRED)
            });
            if (!hasBeenTracked) {
                (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $fc4bM.useMemo)(()=>{
        return formatMessage((0, $5YXrV.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $fc4bM.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("bsGgK", function(module, exports) {
$parcel$export(module.exports, "buildExtensionData", () => $0982145828c55978$export$141a9933f8885d99);

var $6uIU4 = parcelRequire("6uIU4");
const $0982145828c55978$export$141a9933f8885d99 = (executionContext)=>{
    const { analyticsViewType: _analyticsViewType, ...executionContextWithoutAnalytics } = executionContext;
    return {
        type: (0, $6uIU4.UI_MODIFICATIONS_MODULE),
        ...executionContextWithoutAnalytics
    };
};

});



parcelRegister("5C1NW", function(module, exports) {
$parcel$export(module.exports, "useAppsToRender", () => $ad3027344bfc7bd3$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $hWDOW = parcelRequire("hWDOW");

var $g4H12 = parcelRequire("g4H12");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $20pvl = parcelRequire("20pvl");

var $ecRhs = parcelRequire("ecRhs");
const $ad3027344bfc7bd3$export$bef357953bcc2428 = (payload)=>{
    var _data$jira3, _data$jira4, _data$jira6, _data$jira9, _data$jira0;
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $g4H12.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const viewType = (0, $aiipA.useViewType)();
    const configuredApps = (0, $fc4bM.useMemo)(()=>{
        var _data$jira, _data$jira2;
        return (0, $ecRhs.getConfiguredApps)((_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.uiModificationsExtensions, (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.uiModifications);
    }, [
        (_data$jira3 = data.jira) === null || _data$jira3 === void 0 || (_data$jira3 = _data$jira3.forge) === null || _data$jira3 === void 0 ? void 0 : _data$jira3.uiModificationsExtensions,
        (_data$jira4 = data.jira) === null || _data$jira4 === void 0 ? void 0 : _data$jira4.uiModifications
    ]);
    const appsToRender = (0, $fc4bM.useMemo)(()=>{
        return configuredApps.slice(0, (0, $20pvl.MAX_NUMBER_OF_UIM_APPS));
    }, [
        configuredApps
    ]);
    (0, $fc4bM.useEffect)(()=>{
        var _data$jira5;
        if (((_data$jira5 = data.jira) === null || _data$jira5 === void 0 ? void 0 : _data$jira5.uiModifications) !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        (_data$jira6 = data.jira) === null || _data$jira6 === void 0 ? void 0 : _data$jira6.uiModifications
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) {
            var _data$jira7, _data$jira8;
            (0, $hWDOW.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: 'jiraUiModifications.configuredAppsPerContext',
                attributes: {
                    forgeModulesCount: (_data$jira7 = data.jira) === null || _data$jira7 === void 0 || (_data$jira7 = _data$jira7.forge) === null || _data$jira7 === void 0 ? void 0 : _data$jira7.uiModificationsExtensions.length,
                    uimConfiguredAppCount: (_data$jira8 = data.jira) === null || _data$jira8 === void 0 ? void 0 : _data$jira8.uiModifications.length,
                    configuredAndInstalledApps: configuredAppsCount,
                    areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                    viewType: viewType
                }
            });
        }
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        (_data$jira9 = data.jira) === null || _data$jira9 === void 0 || (_data$jira9 = _data$jira9.forge) === null || _data$jira9 === void 0 ? void 0 : _data$jira9.uiModificationsExtensions.length,
        (_data$jira0 = data.jira) === null || _data$jira0 === void 0 ? void 0 : _data$jira0.uiModifications.length
    ]);
    return appsToRender;
};

});
parcelRegister("20pvl", function(module, exports) {
$parcel$export(module.exports, "MAX_NUMBER_OF_UIM_APPS", () => $3f7de4ec59e6e399$export$575c2f3c7fe81caa);
const $3f7de4ec59e6e399$export$575c2f3c7fe81caa = 5;

});

parcelRegister("ecRhs", function(module, exports) {
$parcel$export(module.exports, "getConfiguredApps", () => $40c3cc6b9a3f5ccf$export$6ead423ef319ea49);

var $kbpwm = parcelRequire("kbpwm");
const $40c3cc6b9a3f5ccf$var$STABLE_EMPTY_ARRAY = [];
const $40c3cc6b9a3f5ccf$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $40c3cc6b9a3f5ccf$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $kbpwm.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("kbpwm", function(module, exports) {
$parcel$export(module.exports, "normalizeExtensions", () => $5f4e766633fd2481$export$7e2e604b6166a087);

var $gbEv3 = parcelRequire("gbEv3");
const $5f4e766633fd2481$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $gbEv3.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("45M2c", function(module, exports) {
$parcel$export(module.exports, "useContextCleanup", () => $abcfbe65ad221aa4$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $fc4bM = parcelRequire("fc4bM");

var $g4H12 = parcelRequire("g4H12");

var $aiipA = parcelRequire("aiipA");

var $kzQWi = parcelRequire("kzQWi");

var $5YXrV = parcelRequire("5YXrV");
const $abcfbe65ad221aa4$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $kzQWi.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $g4H12.useAdjustmentsContextActions)();
    const viewType = (0, $aiipA.useViewType)();
    (0, $fc4bM.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $fc4bM.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $fc4bM.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $5YXrV.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("bZIaw", function(module, exports) {
$parcel$export(module.exports, "useEnrichedExecutionContext", () => $249ae6080b147c64$export$649da33b72723913);

var $fc4bM = parcelRequire("fc4bM");

var $aiipA = parcelRequire("aiipA");
const $249ae6080b147c64$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    const viewType = (0, $aiipA.useViewType)();
    const enrichedExecutionContext = (0, $fc4bM.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});


parcelRegister("atnzF", function(module, exports) {
$parcel$export(module.exports, "ForgeAppRenderer", () => $e08c675d4ad61de7$export$6eef17fe5fde390c);

var $fc4bM = parcelRequire("fc4bM");

var $2UXyw = parcelRequire("2UXyw");

var $1HEEa = parcelRequire("1HEEa");

var $bTECU = parcelRequire("bTECU");

var $493pH = parcelRequire("493pH");
const $e08c675d4ad61de7$export$6eef17fe5fde390c = (props)=>{
    const { extension: extension, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bTECU.ExtensionPointProvider), {
        extensionType: (0, $1HEEa.UI_MODIFICATIONS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $493pH.Renderer), {
        ...restProps,
        extension: extension,
        contextTokenType: (0, $2UXyw.ContextTokenType).JIRA
    }));
};

});
parcelRegister("2UXyw", function(module, exports) {
$parcel$export(module.exports, "ALLOWED", () => $10b0daa3d1b70c3f$export$b4c0bb1de45ab46c);
$parcel$export(module.exports, "BLOCKED", () => $10b0daa3d1b70c3f$export$c2dfa6e96815ac6b);
$parcel$export(module.exports, "ContextTokenType", () => $10b0daa3d1b70c3f$export$70a9026332abd115);
$parcel$export(module.exports, "AtlassianHelpConfigAccountType", () => $10b0daa3d1b70c3f$export$5ea1c090b459f41f);
$parcel$export(module.exports, "isForgeCustomField", () => $10b0daa3d1b70c3f$export$78cf1b56a8dede1f);
const $10b0daa3d1b70c3f$export$b4c0bb1de45ab46c = 'ALLOWED';
const $10b0daa3d1b70c3f$export$c2dfa6e96815ac6b = 'BLOCKED';
const $10b0daa3d1b70c3f$export$8a7e8af112e5972a = 'extension';
var $10b0daa3d1b70c3f$export$70a9026332abd115 = /*#__PURE__*/ function(ContextTokenType) {
    ContextTokenType["JSM"] = "JSM";
    ContextTokenType["JIRA"] = "JIRA";
    return ContextTokenType;
}({});
var $10b0daa3d1b70c3f$export$5ea1c090b459f41f = /*#__PURE__*/ function(AtlassianHelpConfigAccountType) {
    AtlassianHelpConfigAccountType["ATLASSIAN"] = "atlassian";
    AtlassianHelpConfigAccountType["CUSTOMER"] = "customer";
    AtlassianHelpConfigAccountType["ANONYMOUS"] = "anonymous";
    return AtlassianHelpConfigAccountType;
}({});
/**
 * The ARI prefix for Forge ecosystem extensions.
 * All Forge custom field customIds start with this prefix.
 */ const $10b0daa3d1b70c3f$var$FORGE_EXTENSION_ARI_PREFIX = 'ari:cloud:ecosystem::extension/';
const $10b0daa3d1b70c3f$export$78cf1b56a8dede1f = (customId)=>{
    return Boolean(customId && customId.startsWith($10b0daa3d1b70c3f$var$FORGE_EXTENSION_ARI_PREFIX));
};

});

parcelRegister("bTECU", function(module, exports) {
$parcel$export(module.exports, "ExtensionPointProvider", () => $9a05cf6b04c66249$export$80b99728bc3dad9);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $9a05cf6b04c66249$export$80b99728bc3dad9 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("7QT6q")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-point-provider/extension-point-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("7QT6q", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2pTiU"),
    $9dnsd("TSK2Y"),
    $9dnsd("3C6jY")
]).then(()=>parcelRequire('fHEy4'));

});


parcelRegister("493pH", function(module, exports) {
$parcel$export(module.exports, "Renderer", () => $11cec8431b65ff53$export$88530751e3977073);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $11cec8431b65ff53$export$88530751e3977073 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("1PDwB")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/renderer/renderer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("1PDwB", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("6142a"),
    $9dnsd("fUarJ"),
    $9dnsd("6Df0C"),
    $9dnsd("ozcFp"),
    $9dnsd("8QhuV"),
    $9dnsd("4SQTv"),
    $9dnsd("ktw4w"),
    $9dnsd("gUCeg"),
    $9dnsd("zu3lW"),
    $9dnsd("2pTiU"),
    $9dnsd("TSK2Y"),
    $9dnsd("3I6ts")
]).then(()=>parcelRequire('b3C4M'));

});




parcelRegister("cLft7", function(module, exports) {
$parcel$export(module.exports, "HeaderSinglePortalMode", () => (parcelRequire("dDlpZ")).default);

var $dDlpZ = parcelRequire("dDlpZ");

});
parcelRegister("dDlpZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6617a7b9d89c5b64$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("53Mcy");
var $dFKzv = parcelRequire("dFKzv");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("0bBIT");
var $kHvdI = parcelRequire("kHvdI");
const $6617a7b9d89c5b64$var$getPortalName = (state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    return portalId ? (0, $9D9SX.getName)(state, portalId) : undefined;
};
const $6617a7b9d89c5b64$var$getPortalDescription = (state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    return portalId ? (0, $9D9SX.getDescription)(state, portalId) : undefined;
};
const $6617a7b9d89c5b64$var$getPortalLogoUrl = (state)=>{
    const portalId = (0, $dFKzv.getPortalId)(state);
    return portalId ? (0, $9D9SX.getLogoUrl)(state, portalId) : undefined;
};
const $6617a7b9d89c5b64$var$selector = (0, $2n2bS.createSelector)($6617a7b9d89c5b64$var$getPortalName, $6617a7b9d89c5b64$var$getPortalDescription, $6617a7b9d89c5b64$var$getPortalLogoUrl, (portalName, portalDescription, portalLogoUrl)=>({
        subHeading: portalName,
        description: portalDescription,
        logoUrl: portalLogoUrl,
        dangerouslyAllowHtmlInDescription: true
    }));
var $6617a7b9d89c5b64$export$2e2bcd8739ae039 = (0, $6umft.default)($6617a7b9d89c5b64$var$selector)((0, $kHvdI.default));

});


parcelRegister("eyEcW", function(module, exports) {
$parcel$export(module.exports, "default", () => $588abdfd51c98ce5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $588abdfd51c98ce5$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    addAnnoucement: {
        defaultMessage: 'Add announcement',
        description: 'Text for add announcement button',
        id: 'cv.portal.home.add.announcement.button'
    },
    editAnnouncement: {
        defaultMessage: 'Edit announcement',
        description: 'Text for edit announcement button',
        id: 'cv.portal.home.edit.announcement.button'
    },
    requestTypePageTitle: {
        defaultMessage: '{requestTypeName} - {portalName} - Jira Service Management',
        description: 'Page title for portal page when customer selected a request type form',
        id: 'sd.jsm.customerview.request.type.selected.portal.page.title'
    },
    portalPageTitle: {
        defaultMessage: '{portalName} - Jira Service Management',
        description: 'Page title for portal landing page',
        id: 'sd.jsm.customerview.portal.page.title'
    },
    portalGroupPageTitle: {
        defaultMessage: '{portalName} - Raise a request - Jira Service Management',
        description: 'Page title for portal group page',
        id: 'sd.jsm.customerview.portal.group.page.title'
    }
});

});






parcelRegister("kM3gF", function(module, exports) {
$parcel$export(module.exports, "requestApprovalRoute", () => $50e8d750e1c0c4f5$export$bcdc6af6b60bfb08);

var $9mazR = parcelRequire("9mazR");

var $6p3wn = parcelRequire("6p3wn");

var $joDHD = parcelRequire("joDHD");

var $ivtaS = parcelRequire("ivtaS");
const $50e8d750e1c0c4f5$var$route = {
    name: 'request-approval',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/:requestKey/approval/:approvalId/:decision`,
    exact: true,
    component: (0, $6p3wn.RequestApproval)
};
const $50e8d750e1c0c4f5$var$screenName = (0, $9mazR.ScreenName).REQUEST_APPROVAL;
const $50e8d750e1c0c4f5$var$paperAppearance = 'normal';
const $50e8d750e1c0c4f5$var$layoutProps = {
    ...(0, $ivtaS.anonymousScreenLayout),
    paperAppearance: $50e8d750e1c0c4f5$var$paperAppearance
};
const $50e8d750e1c0c4f5$export$bcdc6af6b60bfb08 = (0, $joDHD.createRouteWithLayout)($50e8d750e1c0c4f5$var$route, $50e8d750e1c0c4f5$var$screenName, $50e8d750e1c0c4f5$var$layoutProps);

});
parcelRegister("6p3wn", function(module, exports) {
$parcel$export(module.exports, "RequestApproval", () => $cd2672d0cdb343cb$export$741ffb1ed280e417);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $cd2672d0cdb343cb$export$741ffb1ed280e417 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("l8xoK")), {
        moduleId: "./src/view/request-approval/hocs.tsx"
    })
});

});
parcelRegister("l8xoK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8p5DR").then(()=>parcelRequire('ckm0K'));

});



parcelRegister("gp1kG", function(module, exports) {
$parcel$export(module.exports, "requestDetailsRoute", () => $c541dbbbdf7419c7$export$c7023f3ff27ad6e1);

var $9mazR = parcelRequire("9mazR");
parcelRequire("kqfQb");
var $b7wxn = parcelRequire("b7wxn");

var $joDHD = parcelRequire("joDHD");


var $ivtaS = parcelRequire("ivtaS");
const $c541dbbbdf7419c7$var$route = {
    name: 'request-details',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/:requestKey`,
    exact: true,
    component: (0, $b7wxn.default),
    resources: []
};
const $c541dbbbdf7419c7$var$screenName = (0, $9mazR.ScreenName).REQUEST_DETAILS;
const $c541dbbbdf7419c7$var$paperAppearance = 'xxwide';
const $c541dbbbdf7419c7$var$layoutProps = {
    paperAppearance: $c541dbbbdf7419c7$var$paperAppearance,
    hideSearchButton: false,
    fadeInSearchModal: true
};
const $c541dbbbdf7419c7$export$c7023f3ff27ad6e1 = (0, $joDHD.createRouteWithLayout)($c541dbbbdf7419c7$var$route, $c541dbbbdf7419c7$var$screenName, $c541dbbbdf7419c7$var$layoutProps);

});
parcelRegister("kqfQb", function(module, exports) {
$parcel$export(module.exports, "RequestDetails", () => (parcelRequire("b7wxn")).default);

var $b7wxn = parcelRequire("b7wxn");

});
parcelRegister("b7wxn", function(module, exports) {
$parcel$export(module.exports, "default", () => $38c54bc0330142d2$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $eXQnZ = parcelRequire("eXQnZ");

var $x2dJZ = parcelRequire("x2dJZ");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("kjNSL");
var $kV2FF = parcelRequire("kV2FF");
parcelRequire("g3jMF");
var $49H5B = parcelRequire("49H5B");
parcelRequire("1Qg1o");
var $auzgq = parcelRequire("auzgq");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("a12XX");
var $mNZ1o = parcelRequire("mNZ1o");
parcelRequire("i5DBE");
var $7YNu3 = parcelRequire("7YNu3");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $bo2GC = parcelRequire("bo2GC");

var $g81wt = parcelRequire("g81wt");

var $3iOBU = parcelRequire("3iOBU");
const $38c54bc0330142d2$var$selector = (0, $2n2bS.createSelector)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $9D9SX.getPortal)(state, (0, $g81wt.toNumber)(props.match.params.portalId)), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $7YNu3.getRequestDetails)(state, props.match.params.requestKey), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $mNZ1o.getReqSlas)(state, props.match.params.requestKey), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $7YNu3.getError)(state, props.match.params.requestKey), (state, props)=>{
    return (0, $9D9SX.getName)(state, Number(props.match.params.portalId)) ?? (0, $49H5B.getPortalNameFromBranding)(state);
}, (state, props)=>(0, $bo2GC.getIssueAnalyticsContext)(state, Number(props.match.params.portalId)), (state)=>(0, $7RWiC.isAtlassianAccountManaged)(state), (state, props)=>(0, $auzgq.getRequestSpecificConnectAddonPanels)({
        state: state,
        location: 'detailsPanels',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        requestKey: props.match.params.requestKey
    }), (state, props)=>{
    return Boolean((0, $9D9SX.getCanAdministerProject)(state, Number(props.match.params.portalId)));
}, (portal, requestDetails, reqSlas, persistedError, portalName, issueAnalyticsContext, isManagedAccount, connectPanels, isProjectAdmin)=>({
        portal: portal,
        requestDetails: requestDetails,
        reqSlas: reqSlas,
        issueAnalyticsContext: issueAnalyticsContext,
        portalName: portalName,
        isProjectAdmin: isProjectAdmin,
        isAtlassianManagedAccount: isManagedAccount,
        ...persistedError,
        hasConnectPanels: connectPanels && connectPanels.length > 0,
        isLoading: requestDetails === undefined && persistedError === undefined
    }));
var $38c54bc0330142d2$export$2e2bcd8739ae039 = (0, $6umft.default)($38c54bc0330142d2$var$selector, {
    fetchPortal: (0, $hijaX.fetchPortalAction),
    fetchRequestDetails: (0, $kV2FF.fetchRequestDetailsModel),
    fetchReqSlas: (0, $x2dJZ.fetchReqSlasModelAction),
    changeSubscriptionAction: (0, $kV2FF.changeSubscription)
})((0, $eXQnZ.default)((0, $3iOBU.default)));

});
parcelRegister("a12XX", function(module, exports) {
$parcel$export(module.exports, "getReqSlas", () => (parcelRequire("mNZ1o")).getReqSlas);

var $mNZ1o = parcelRequire("mNZ1o");

});
parcelRegister("mNZ1o", function(module, exports) {
$parcel$export(module.exports, "getReqSlas", () => $7d71303bc06c09ef$export$65608680bc2b85d0);
const $7d71303bc06c09ef$export$65608680bc2b85d0 = (state, requestKey)=>{
    var _state$persisted$reqS;
    return (_state$persisted$reqS = state.persisted.reqSlas) === null || _state$persisted$reqS === void 0 ? void 0 : _state$persisted$reqS[requestKey];
};

});


parcelRegister("i5DBE", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => (parcelRequire("7YNu3")).getRequestDetails);
$parcel$export(module.exports, "getError", () => (parcelRequire("7YNu3")).getError);
$parcel$export(module.exports, "isTransitionDialogVisible", () => (parcelRequire("7YNu3")).isTransitionDialogVisible);
$parcel$export(module.exports, "isTransactionInProgress", () => (parcelRequire("7YNu3")).isTransactionInProgress);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => (parcelRequire("7YNu3")).getReadMediaApiCredentials);
$parcel$export(module.exports, "getTransitionFailure", () => (parcelRequire("7YNu3")).getTransitionFailure);
$parcel$export(module.exports, "getCommentIsSubmitting", () => (parcelRequire("7YNu3")).getCommentIsSubmitting);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => (parcelRequire("7YNu3")).getCommentBeingSubmitted);
$parcel$export(module.exports, "getReporter", () => (parcelRequire("7YNu3")).getReporter);
$parcel$export(module.exports, "getParticipants", () => (parcelRequire("7YNu3")).getParticipants);
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("7YNu3")).getOrganisations);
$parcel$export(module.exports, "getCanRemoveParticipants", () => (parcelRequire("7YNu3")).getCanRemoveParticipants);
$parcel$export(module.exports, "getCanSearchParticipants", () => (parcelRequire("7YNu3")).getCanSearchParticipants);
$parcel$export(module.exports, "getCanShareRequest", () => (parcelRequire("7YNu3")).getCanShareRequest);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => (parcelRequire("7YNu3")).getCanSubmitWithEmailAddress);
$parcel$export(module.exports, "getInProgressApprovalAction", () => (parcelRequire("7YNu3")).getInProgressApprovalAction);
$parcel$export(module.exports, "getCanAddComment", () => (parcelRequire("7YNu3")).getCanAddComment);
$parcel$export(module.exports, "getCanExport", () => (parcelRequire("7YNu3")).getCanExport);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("7YNu3")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("7YNu3")).getIssueTypeId);
$parcel$export(module.exports, "getIssueKey", () => (parcelRequire("7YNu3")).getIssueKey);
$parcel$export(module.exports, "getIssueId", () => (parcelRequire("7YNu3")).getIssueId);

var $7YNu3 = parcelRequire("7YNu3");

});
parcelRegister("7YNu3", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => $6c2bcbd83d62db58$export$76e59470e6bca129);
$parcel$export(module.exports, "getError", () => $6c2bcbd83d62db58$export$e1599abf47b5b568);
$parcel$export(module.exports, "isTransactionInProgress", () => $6c2bcbd83d62db58$export$5e8f929af64a353a);
$parcel$export(module.exports, "getTransitionFailure", () => $6c2bcbd83d62db58$export$a047f9f9384611fe);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => $6c2bcbd83d62db58$export$cef4d2d501c0dcdb);
$parcel$export(module.exports, "getCommentIsSubmitting", () => $6c2bcbd83d62db58$export$c18738b22e944190);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => $6c2bcbd83d62db58$export$706d262046c8358f);
$parcel$export(module.exports, "getReporter", () => $6c2bcbd83d62db58$export$e8105f4fd5ecc593);
$parcel$export(module.exports, "getParticipants", () => $6c2bcbd83d62db58$export$ccadfc093764e9cd);
$parcel$export(module.exports, "getOrganisations", () => $6c2bcbd83d62db58$export$17495f9c20464b8);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => $6c2bcbd83d62db58$export$c1d23959dfbf9e60);
$parcel$export(module.exports, "getCanSearchParticipants", () => $6c2bcbd83d62db58$export$1fb693409140fdf8);
$parcel$export(module.exports, "getCanShareRequest", () => $6c2bcbd83d62db58$export$bd1011b4c5e87dfc);
$parcel$export(module.exports, "getCanRemoveParticipants", () => $6c2bcbd83d62db58$export$8e53e7bfa4b4035a);
$parcel$export(module.exports, "getCanAddComment", () => $6c2bcbd83d62db58$export$71d5372270878818);
$parcel$export(module.exports, "isTransitionDialogVisible", () => $6c2bcbd83d62db58$export$5d33edbc6a385b);
$parcel$export(module.exports, "getInProgressApprovalAction", () => $6c2bcbd83d62db58$export$55685a606a2adcb4);
$parcel$export(module.exports, "getIssueType", () => $6c2bcbd83d62db58$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $6c2bcbd83d62db58$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getIssueKey", () => $6c2bcbd83d62db58$export$4a030f6192bebe03);
$parcel$export(module.exports, "getIssueId", () => $6c2bcbd83d62db58$export$b4dd560abafd1fae);
$parcel$export(module.exports, "getCanExport", () => $6c2bcbd83d62db58$export$eda75b639af011cf);
const $6c2bcbd83d62db58$var$getRequestDetailsOrError = (state, requestKey)=>{
    if (requestKey && state.persisted.requestDetails) return state.persisted.requestDetails[requestKey];
    return undefined;
};
const $6c2bcbd83d62db58$export$76e59470e6bca129 = (state, requestKey)=>{
    const data = $6c2bcbd83d62db58$var$getRequestDetailsOrError(state, requestKey);
    return $6c2bcbd83d62db58$var$isError(data) ? undefined : data;
};
const $6c2bcbd83d62db58$var$isError = (data)=>data !== undefined && 'error' in data;
const $6c2bcbd83d62db58$export$e1599abf47b5b568 = (state, requestKey)=>{
    const data = $6c2bcbd83d62db58$var$getRequestDetailsOrError(state, requestKey);
    return $6c2bcbd83d62db58$var$isError(data) ? data : undefined;
};
const $6c2bcbd83d62db58$export$5e8f929af64a353a = (state, transactionId)=>{
    const { inProgressTransitionId: inProgressTransitionId } = state.ui.requestDetails;
    return inProgressTransitionId !== undefined && inProgressTransitionId === transactionId;
};
const $6c2bcbd83d62db58$export$a047f9f9384611fe = (state)=>{
    return state.ui.requestDetails.transitionFailure;
};
const $6c2bcbd83d62db58$export$cef4d2d501c0dcdb = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.readFileMediaCredentials : undefined;
};
const $6c2bcbd83d62db58$export$c18738b22e944190 = (state)=>{
    return state.ui.requestDetails.commentSubmitting;
};
const $6c2bcbd83d62db58$export$706d262046c8358f = (state)=>{
    return state.ui.requestDetails.commentBeingSubmitted;
};
const $6c2bcbd83d62db58$export$e8105f4fd5ecc593 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.reporter : undefined;
};
const $6c2bcbd83d62db58$export$ccadfc093764e9cd = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.participants : undefined;
};
const $6c2bcbd83d62db58$export$17495f9c20464b8 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.organisations : undefined;
};
const $6c2bcbd83d62db58$export$c1d23959dfbf9e60 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSubmitWithEmailAddress : false;
};
const $6c2bcbd83d62db58$export$1fb693409140fdf8 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSearchParticipants : false;
};
const $6c2bcbd83d62db58$export$bd1011b4c5e87dfc = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canShareRequest : false;
};
const $6c2bcbd83d62db58$export$8e53e7bfa4b4035a = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canRemoveParticipants : false;
};
const $6c2bcbd83d62db58$export$71d5372270878818 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canAddComment : false;
};
const $6c2bcbd83d62db58$export$5d33edbc6a385b = (state, id)=>{
    return state.ui.requestDetails.visibleTransitionDialog === id;
};
const $6c2bcbd83d62db58$export$55685a606a2adcb4 = (state)=>{
    return state.ui.requestDetails.inProgressApprovalAction;
};
const $6c2bcbd83d62db58$export$d23b1708046e514c = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return !!(requestDetails !== null && requestDetails !== void 0 && requestDetails.hasProformaForm);
};
const $6c2bcbd83d62db58$export$ed2455632bf977ef = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueTypeName;
};
const $6c2bcbd83d62db58$export$110c9a4a16c5b8c9 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueType;
};
const $6c2bcbd83d62db58$export$4a030f6192bebe03 = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.key;
};
const $6c2bcbd83d62db58$export$b4dd560abafd1fae = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.id;
};
const $6c2bcbd83d62db58$export$eda75b639af011cf = (state, requestKey)=>{
    const requestDetails = $6c2bcbd83d62db58$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.issue.canExport : false;
};

});


parcelRegister("bo2GC", function(module, exports) {
$parcel$export(module.exports, "getIssueAnalyticsContext", () => $ed28048f5ed6aa20$export$fe0282397d97e2a6);
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
const $ed28048f5ed6aa20$export$fe0282397d97e2a6 = (state, portalId)=>({
        user: {
            getAgentForPortal: ()=>(0, $7RWiC.getAgentForPortal)(state),
            getAccountId: ()=>(0, $7RWiC.getAccountId)(state)
        },
        portal: {
            getPortalAnnouncement: ()=>({
                    getCanAdministerProject: ()=>(0, $9D9SX.getCanAdministerProject)(state, portalId)
                })
        }
    });

});

parcelRegister("3iOBU", function(module, exports) {
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_RESULT_QUERY_PARAM", () => $5579fa72390c98a7$export$491313a4e8829a1a);
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_QUERY_PARAM_SUCCESS", () => $5579fa72390c98a7$export$fddfe2b6ca9cfe5c);
$parcel$export(module.exports, "default", () => $5579fa72390c98a7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $k2M4v = parcelRequire("k2M4v");

var $9J2wU = parcelRequire("9J2wU");

var $fcCIH = parcelRequire("fcCIH");

var $4MjGQ = parcelRequire("4MjGQ");

var $6rayQ = parcelRequire("6rayQ");
parcelRequire("26cjK");
var $fqmIx = parcelRequire("fqmIx");
var $gMzVJ = parcelRequire("gMzVJ");
parcelRequire("eK8Hl");
var $1LEgf = parcelRequire("1LEgf");

var $8agoQ = parcelRequire("8agoQ");

var $b9KEh = parcelRequire("b9KEh");
const $5579fa72390c98a7$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS = 'jsm-sla-in-portal-request-details';
const $5579fa72390c98a7$export$491313a4e8829a1a = 'approval';
const $5579fa72390c98a7$export$fddfe2b6ca9cfe5c = '200';
class $5579fa72390c98a7$export$1ec22ccbfe26843b extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchRequestDetails: fetchRequestDetails, fetchReqSlas: fetchReqSlas, requestKey: key } = this.props;
        fetchRequestDetails({
            key: key,
            portalId: Number(portalId),
            ...(0, $k2M4v.default).checkGate('assets_custom_fields_limit_increase_ga') ? {
                expand: [
                    'cmdbLazyDetails'
                ]
            } : {}
        });
        fetchPortal({
            id: Number(portalId),
            expand: [
                'analyticsContext'
            ]
        });
        if ((0, $k2M4v.default).checkGate($5579fa72390c98a7$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS)) fetchReqSlas({
            key: key
        });
        this.trackIssueViewed();
        this.setState({
            isApprovalError: this.checkIfApprovalError()
        });
    }
    componentDidUpdate(prevProps) {
        const { portal: portal, requestDetails: requestDetails, reqSlas: reqSlas } = this.props;
        if (portal && portal.analyticAttributes && requestDetails && (!(0, $k2M4v.default).checkGate($5579fa72390c98a7$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS) || reqSlas) && !requestDetails.userMentionedDuringRequestCreation) {
            var _prevProps$reqSlas;
            if (!prevProps.portal || !prevProps.portal.analyticAttributes || !prevProps.requestDetails || (0, $k2M4v.default).checkGate($5579fa72390c98a7$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS) && !prevProps.reqSlas) this.trackIssueViewed();
            else if (portal.id !== prevProps.portal.id || requestDetails.issue.id !== prevProps.requestDetails.issue.id || (0, $k2M4v.default).checkGate($5579fa72390c98a7$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS) && ((_prevProps$reqSlas = prevProps.reqSlas) === null || _prevProps$reqSlas === void 0 ? void 0 : _prevProps$reqSlas.length) !== (reqSlas === null || reqSlas === void 0 ? void 0 : reqSlas.length)) this.trackIssueViewed();
        }
    }
    trackIssueViewed() {
        const { portal: portal, requestDetails: requestDetails, issueAnalyticsContext: issueAnalyticsContext, reqSlas: reqSlas } = this.props;
        const isSlaEnabled = (0, $k2M4v.default).checkGate($5579fa72390c98a7$var$JSM_SLA_IN_PORTAL_REQUEST_DETAILS);
        if (!portal || !portal.analyticAttributes || !requestDetails || isSlaEnabled && !reqSlas) return;
        const { issue: issue, issueType: issueType, workflowTransitions: workflowTransitions } = requestDetails;
        const { requestTypeId: requestTypeId, id: issueId } = issue;
        const customerTransitionIds = workflowTransitions ? workflowTransitions.map((transition)=>transition.id) : undefined;
        const renderedSlaCount = (reqSlas === null || reqSlas === void 0 ? void 0 : reqSlas.length) ?? 0;
        (0, $4MjGQ.trackIssueEvent)({
            issueId: issueId,
            projectId: String(portal.projectId),
            action: 'viewed',
            attributes: {
                customerTransitionIds: customerTransitionIds,
                numberOfCustomerTransitionIds: customerTransitionIds && customerTransitionIds.length,
                portalId: String(portal.id),
                issueTypeId: issueType,
                requestTypeId: String(requestTypeId),
                ...isSlaEnabled ? {
                    renderedSlaCount: renderedSlaCount,
                    hasRenderedSla: renderedSlaCount > 0
                } : {},
                ...portal.analyticAttributes
            }
        }, issueAnalyticsContext.user, issueAnalyticsContext.portal);
    }
    render() {
        var _this$props$portal, _requestDetails$appro2;
        const { isApprovalError: isApprovalError } = this.state;
        const { requestDetails: requestDetails, reqSlas: reqSlas, isLoading: isLoading, portalName: portalName, requestKey: requestKey, portal: portal, hasConnectPanels: hasConnectPanels, isProjectAdmin: isProjectAdmin } = this.props;
        const serviceDeskId = Number(portal === null || portal === void 0 ? void 0 : portal.serviceDeskId);
        const portalId = Number(this.props.portalId);
        const projectId = Number(portal === null || portal === void 0 ? void 0 : portal.projectId);
        const projectKey = (_this$props$portal = this.props.portal) === null || _this$props$portal === void 0 ? void 0 : _this$props$portal.projectKey;
        const isAtlassianManagedAccount = this.props.isAtlassianManagedAccount;
        const shouldShowLearnByDoingExperimentBanner = (0, $gMzVJ.shouldShowLearnByDoingBanner)(isProjectAdmin, $6rayQ.get((0, $fqmIx.REFERRER_QUERY_PARAM)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, isApprovalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1LEgf.default), {
            approvalError: this.getApprovalError(),
            hasDecision: (requestDetails === null || requestDetails === void 0 || (_requestDetails$appro2 = requestDetails.approvalStatus[0]) === null || _requestDetails$appro2 === void 0 || (_requestDetails$appro2 = _requestDetails$appro2.decision) === null || _requestDetails$appro2 === void 0 ? void 0 : _requestDetails$appro2.decision) !== undefined,
            onDismissError: this.onDismissError
        }) : [], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $b9KEh.default), {
            requestDetails: requestDetails,
            reqSlas: reqSlas,
            isLoading: isLoading,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            serviceDeskId: serviceDeskId,
            portalId: portalId,
            projectId: projectId,
            requestKey: requestKey,
            onNotificationChange: this.onNotificationChange,
            portalName: portalName,
            hasConnectPanels: hasConnectPanels,
            detailsHiddenOnInitialView: !!this.detailsHiddenOnInitialView,
            activityItemsHiddenOnInitialView: !!this.activityItemsHiddenOnInitialView,
            removeOldParticipantsAndReporterFromComment: this.removeOldParticipantsAndReporterFromComment,
            projectKey: projectKey,
            shouldShowLearnByDoingExperimentBanner: shouldShowLearnByDoingExperimentBanner
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isApprovalError: false
        }, this.onNotificationChange = (shouldSubscribe)=>{
            const { requestDetails: requestDetails, changeSubscriptionAction: changeSubscriptionAction } = this.props;
            if (requestDetails) changeSubscriptionAction(requestDetails.key, requestDetails.issue.id, shouldSubscribe);
        }, this.checkIfApprovalError = ()=>{
            return !!$6rayQ.get($5579fa72390c98a7$export$491313a4e8829a1a) && $6rayQ.get($5579fa72390c98a7$export$491313a4e8829a1a) !== $5579fa72390c98a7$export$fddfe2b6ca9cfe5c;
        }, this.getApprovalError = ()=>{
            return this.checkIfApprovalError() ? $6rayQ.get($5579fa72390c98a7$export$491313a4e8829a1a) : undefined;
        }, this.onDismissError = ()=>{
            this.setState({
                isApprovalError: false
            });
        }, this.removeOldParticipantsAndReporterFromComment = (accountIds)=>{
            const requestDetails = this.props.requestDetails;
            if (requestDetails) {
                const { participants: participants, reporter: reporter } = requestDetails;
                /* Removing user mentions which should not be added as request participants */ (reporter === null || reporter === void 0 ? void 0 : reporter.accountId) && accountIds.delete(reporter === null || reporter === void 0 ? void 0 : reporter.accountId);
                participants.forEach((participant)=>accountIds.delete(participant.accountId));
            }
            return accountIds;
        }, this.getFlagTitleAndDescription = ()=>{
            var _requestDetails$appro;
            // Error messages for approve by email
            const { intl: intl, requestDetails: requestDetails } = this.props;
            const decision = requestDetails === null || requestDetails === void 0 || (_requestDetails$appro = requestDetails.approvalStatus[0]) === null || _requestDetails$appro === void 0 || (_requestDetails$appro = _requestDetails$appro.decision) === null || _requestDetails$appro === void 0 ? void 0 : _requestDetails$appro.decision;
            switch($6rayQ.get($5579fa72390c98a7$export$491313a4e8829a1a)){
                case '400':
                    if (decision) // if decision already made
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    // if misspelling in url
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    // if approver has been removed as approver by admin
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription403)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitleDefault, {
                            value: $6rayQ.get($5579fa72390c98a7$export$491313a4e8829a1a) ?? ''
                        }),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $5579fa72390c98a7$export$2e2bcd8739ae039 = (0, $9J2wU.withErrorPage)((0, $fcCIH.default)($5579fa72390c98a7$export$1ec22ccbfe26843b));

});
parcelRegister("eK8Hl", function(module, exports) {
$parcel$export(module.exports, "ApprovalErrorFlag", () => (parcelRequire("1LEgf")).default);

var $1LEgf = parcelRequire("1LEgf");

});
parcelRegister("1LEgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f7810a5eeea1850$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $eBDNv = parcelRequire("eBDNv");

var $bAQQ9 = parcelRequire("bAQQ9");

var $48hlF = parcelRequire("48hlF");

var $8agoQ = parcelRequire("8agoQ");
class $3f7810a5eeea1850$export$15f2320c01f1c048 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { approvalError: approvalError, onDismissError: onDismissError, intl: intl } = this.props;
        const { title: title, description: description } = this.getFlagTitleAndDescription();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bAQQ9.default), {
            onDismissed: onDismissError
        }, approvalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eBDNv.default), {
            id: "approve-by-email-fail-approve-error-flag",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #BF2600)",
                label: ""
            }),
            title: title,
            description: description,
            actions: [
                {
                    content: intl.formatMessage((0, $8agoQ.default).dismiss),
                    onClick: ()=>onDismissError()
                }
            ]
        }) : []);
    }
    constructor(...args){
        super(...args), this.getFlagTitleAndDescription = ()=>{
            const { intl: intl, hasDecision: hasDecision, approvalError: approvalError } = this.props;
            switch(approvalError){
                case '400':
                    if (hasDecision) return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription403)
                    };
                case '404':
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle404),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription404)
                    };
                case '409':
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitle409),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescription409)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagTitleDefault, {}),
                        description: intl.formatMessage((0, $8agoQ.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $3f7810a5eeea1850$export$2e2bcd8739ae039 = (0, $fcCIH.default)($3f7810a5eeea1850$export$15f2320c01f1c048);

});
parcelRegister("8agoQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11c82a58af5547c$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $e11c82a58af5547c$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    dismiss: {
        defaultMessage: 'Dismiss',
        description: 'Label for the button that dismisses the approval error flag',
        id: 'cv.request.details.approve.by.email.approval.error.dismiss.flag.message'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_1: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_1: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page.',
        description: 'Description for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_2: {
        defaultMessage: 'You no longer need to approve or decline',
        description: 'Title for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_2: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_2'
    },
    approvalByEmailErrorFlagTitle403: {
        defaultMessage: 'You need permission to approve this request',
        description: 'Title for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.title401'
    },
    approvalByEmailErrorFlagDescription403: {
        defaultMessage: `Ask your admin if you\u{2019}re on the approvers list, or check that you\u{2019}re logged in with the right account.`,
        description: 'Description for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.description401'
    },
    approvalByEmailErrorFlagTitle404: {
        defaultMessage: `We couldn\u{2019}t update the request`,
        description: 'Title for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.title404'
    },
    approvalByEmailErrorFlagDescription404: {
        defaultMessage: 'This request no longer needs approval. It may have been updated or deleted.',
        description: 'Description for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.description404'
    },
    approvalByEmailErrorFlagTitle409: {
        defaultMessage: 'Approval not required',
        description: 'Title for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.title409'
    },
    approvalByEmailErrorFlagDescription409: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.description409'
    },
    approvalByEmailErrorFlagTitleDefault: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.title.default'
    },
    approvalByEmailErrorFlagDescriptionDefault: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page if available, or try again later.',
        description: 'Description for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.description.default'
    }
});

});



parcelRegister("b9KEh", function(module, exports) {
$parcel$export(module.exports, "default", () => $f54c30ff6a4bbbcf$export$2e2bcd8739ae039);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $f54c30ff6a4bbbcf$var$loader = (0, $dohmo.lazyForPaint)(()=>(parcelRequire("8parT")), {
    moduleId: "./src/view/request-details/request-details-stateless/request-details-stateless.tsx"
});
var $f54c30ff6a4bbbcf$export$2e2bcd8739ae039 = (0, $bQkfB.default)({
    loader: $f54c30ff6a4bbbcf$var$loader
});

});
parcelRegister("8parT", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("lv25e"),
    $9dnsd("hCVB4"),
    $9dnsd("l4iXV"),
    $9dnsd("bVBnH"),
    $9dnsd("9Fw1L"),
    $9dnsd("6142a"),
    $9dnsd("26NYz"),
    $9dnsd("047zo"),
    $9dnsd("5C3QI"),
    $9dnsd("aejHq"),
    $9dnsd("ozcFp"),
    $9dnsd("bMKAA"),
    $9dnsd("h05a5"),
    $9dnsd("4SQTv"),
    $9dnsd("es3w2")
]).then(()=>parcelRequire('auKM5'));

});






parcelRegister("8cc0X", function(module, exports) {
$parcel$export(module.exports, "userSignupRoute", () => $7eae31c215ee6dcf$export$6c53daec3917ca4f);
$parcel$export(module.exports, "userResetPasswordRoute", () => $7eae31c215ee6dcf$export$a1ff4b1e673ba98c);
$parcel$export(module.exports, "userCompleteSignupRoute", () => $7eae31c215ee6dcf$export$61da5e60a0c99a8a);
$parcel$export(module.exports, "userCheckMailRoute", () => $7eae31c215ee6dcf$export$934c0e27338aac46);
$parcel$export(module.exports, "portalSignupRoute", () => $7eae31c215ee6dcf$export$766487cfd72c58e6);
$parcel$export(module.exports, "portalResetPasswordRoute", () => $7eae31c215ee6dcf$export$a52bd3b0b1b1499b);
$parcel$export(module.exports, "portalCompleteSignupRoute", () => $7eae31c215ee6dcf$export$c0d26476c776bd62);
$parcel$export(module.exports, "portalInvitedSignupRoute", () => $7eae31c215ee6dcf$export$124a02da2ab0bcaf);

var $9mazR = parcelRequire("9mazR");

var $12B75 = parcelRequire("12B75");

var $lkitE = parcelRequire("lkitE");

var $8vxCR = parcelRequire("8vxCR");

var $3B2H1 = parcelRequire("3B2H1");

var $6nykw = parcelRequire("6nykw");

var $joDHD = parcelRequire("joDHD");

var $ivtaS = parcelRequire("ivtaS");
const $7eae31c215ee6dcf$var$userSignup = {
    resources: [],
    name: 'user-signup',
    path: `/user/signup`,
    exact: true,
    component: (0, $3B2H1.SignUp)
};
const $7eae31c215ee6dcf$var$userResetPassword = {
    resources: [],
    name: 'user-reset-password',
    path: `/user/resetpassword`,
    exact: true,
    component: (0, $8vxCR.ResetPassword)
};
const $7eae31c215ee6dcf$var$userCompleteSignup = {
    resources: [],
    name: 'user-complete-signup',
    path: `/user/complete-signup`,
    exact: true,
    component: (0, $12B75.CompleteSignup)
};
const $7eae31c215ee6dcf$var$userCheckMail = {
    resources: [],
    name: 'user-checkmail',
    path: `/user/check-email`,
    exact: true,
    component: (0, $6nykw.CheckEmail)
};
const $7eae31c215ee6dcf$var$portalSignup = {
    resources: [],
    name: 'portal-signup',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/signup`,
    exact: true,
    component: (0, $3B2H1.SignUp)
};
const $7eae31c215ee6dcf$var$portalResetPassword = {
    resources: [],
    name: 'portal-reset-password',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
    exact: true,
    component: (0, $8vxCR.ResetPassword)
};
const $7eae31c215ee6dcf$var$portalCompleteSignup = {
    resources: [],
    name: 'portal-complete-signup',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
    exact: true,
    component: (0, $12B75.CompleteSignup)
};
const $7eae31c215ee6dcf$var$portalInvitedSignup = {
    resources: [],
    name: 'portal-invited-signup',
    path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
    exact: true,
    component: (0, $lkitE.InvitedSignUp)
};
const $7eae31c215ee6dcf$var$signUpScreenName = (0, $9mazR.ScreenName).SIGNUP;
const $7eae31c215ee6dcf$export$6c53daec3917ca4f = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$userSignup, $7eae31c215ee6dcf$var$signUpScreenName, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$a1ff4b1e673ba98c = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$userResetPassword, (0, $9mazR.ScreenName).RESET_PASSWORD, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$61da5e60a0c99a8a = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$userCompleteSignup, (0, $9mazR.ScreenName).COMPLETE_SIGNUP, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$934c0e27338aac46 = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$userCheckMail, (0, $9mazR.ScreenName).CHECK_EMAIL, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$766487cfd72c58e6 = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$portalSignup, $7eae31c215ee6dcf$var$signUpScreenName, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$a52bd3b0b1b1499b = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$portalResetPassword, (0, $9mazR.ScreenName).RESET_PASSWORD, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$c0d26476c776bd62 = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$portalCompleteSignup, (0, $9mazR.ScreenName).COMPLETE_SIGNUP, (0, $ivtaS.anonymousScreenLayout));
const $7eae31c215ee6dcf$export$124a02da2ab0bcaf = (0, $joDHD.createRouteWithLayout)($7eae31c215ee6dcf$var$portalInvitedSignup, (0, $9mazR.ScreenName).INVITED_SIGNUP, (0, $ivtaS.anonymousScreenLayout));

});
parcelRegister("12B75", function(module, exports) {
$parcel$export(module.exports, "CompleteSignup", () => $c2cbf1d4917504f2$export$372770c8487ebcca);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $c2cbf1d4917504f2$export$372770c8487ebcca = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("dQdWT")), {
        moduleId: "./src/view/complete-signup/hocs.tsx"
    })
});

});
parcelRegister("dQdWT", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("iUf4j").then(()=>parcelRequire('2aBTN'));

});


parcelRegister("lkitE", function(module, exports) {
$parcel$export(module.exports, "InvitedSignUp", () => $8c0fba1b41a65c44$export$b6f2cb2bcdfbfdb9);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $8c0fba1b41a65c44$export$b6f2cb2bcdfbfdb9 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("fT0pe")), {
        moduleId: "./src/view/invited-sign-up/hocs.tsx"
    })
});

});
parcelRegister("fT0pe", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("9V7D9").then(()=>parcelRequire('bcivG'));

});


parcelRegister("8vxCR", function(module, exports) {
$parcel$export(module.exports, "ResetPassword", () => $46c198ba9a40fac0$export$a4c3d56613a57187);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $46c198ba9a40fac0$export$a4c3d56613a57187 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("a79fC")), {
        moduleId: "./src/view/reset-password/hocs.tsx"
    })
});

});
parcelRegister("a79fC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gpAnw").then(()=>parcelRequire('8mtv3'));

});


parcelRegister("3B2H1", function(module, exports) {
$parcel$export(module.exports, "SignUp", () => $54ac3d7084a66455$export$4ee457d816cea81a);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $54ac3d7084a66455$export$4ee457d816cea81a = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("l6vIz")), {
        moduleId: "./src/view/sign-up/hocs.tsx"
    })
});

});
parcelRegister("l6vIz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("9VOLw").then(()=>parcelRequire('hoZ60'));

});


parcelRegister("6nykw", function(module, exports) {
$parcel$export(module.exports, "CheckEmail", () => $974d38fd55ade6ba$export$fd89248056ed5439);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $974d38fd55ade6ba$export$fd89248056ed5439 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("jfjOB")), {
        moduleId: "./src/view/sign-up-check-email/hocs.tsx"
    })
});

});
parcelRegister("jfjOB", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("enOq6").then(()=>parcelRequire('jc2Qp'));

});



parcelRegister("9fFmP", function(module, exports) {
$parcel$export(module.exports, "getViewTopicRoute", () => $2ad080701e721dc5$export$8c8c8d8cda238e84);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $DNksS = parcelRequire("DNksS");

var $gsroF = parcelRequire("gsroF");

var $joDHD = parcelRequire("joDHD");
var $8zK3E = parcelRequire("8zK3E");

var $bpFZU = parcelRequire("bpFZU");
const $2ad080701e721dc5$var$PageLoader = ()=>{
    const [{ match: { params: { id: id } } }] = (0, $7lAXH.useRouter)();
    (0, $DNksS.default)(id);
    const { queryReference: queryReference } = (0, $8zK3E.useRelayResource)((0, $bpFZU.viewTopicResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gsroF.ViewTopic), {
        topicId: id,
        queryReference: queryReference
    });
};
const $2ad080701e721dc5$export$8c8c8d8cda238e84 = ()=>{
    const paperAppearance = (0, $hN5YJ.isUseHelpCenterRefresh)() ? 'xwide' : 'normal';
    const layoutProps = {
        paperAppearance: paperAppearance,
        fadeInSearchModal: true
    };
    return (0, $joDHD.createRouteWithLayout)({
        name: 'view-topic',
        path: '/topic/:id',
        exact: true,
        component: $2ad080701e721dc5$var$PageLoader,
        resources: [
            (0, $bpFZU.viewTopicResource)
        ]
    }, (0, $9mazR.ScreenName).VIEW_TOPIC, layoutProps);
};

});
parcelRegister("gsroF", function(module, exports) {
$parcel$export(module.exports, "ViewTopic", () => $640364d9a6cdf760$export$8036aeb45d373d7d);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $640364d9a6cdf760$var$loader = (0, $dohmo.lazyForPaint)(()=>(parcelRequire("gNOQQ")), {
    moduleId: "./src/view/topic/topic.tsx"
});
const $640364d9a6cdf760$export$8036aeb45d373d7d = (0, $bQkfB.default)({
    loader: $640364d9a6cdf760$var$loader
});

});
parcelRegister("gNOQQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2g5QR"),
    $9dnsd("cinWY")
]).then(()=>parcelRequire('bzs8A'));

});


parcelRegister("bpFZU", function(module, exports) {
$parcel$export(module.exports, "viewTopicResource", () => $91408b82b6a1c236$export$425f51060493cc67);

var $2v5xb = parcelRequire("2v5xb");

var $8zK3E = parcelRequire("8zK3E");
const $91408b82b6a1c236$export$425f51060493cc67 = (0, $8zK3E.createRelayResource)({
    type: 'VIEW_TOPIC',
    getQuery: ({ match: { params: { id: id } } }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $2v5xb.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                topicId: String(id)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("2v5xb", function(module, exports) {
$parcel$export(module.exports, "default", () => $581b4774318ed374$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04f0af7279f78d72dbeae49d34853aac>>
 * @relayHash ebbdf9e39eabac61b9f8917e5b0cac0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1
const $581b4774318ed374$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "topicId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "description"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v6 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "topicQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "helpCenterTopic_HelpCenterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "topicQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "helpCenterAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "topicId",
                                    "variableName": "topicId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterTopicById",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "HelpCenterTopicItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterTopicItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "ari"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isHelpCenterHelpObject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "HelpObjectStoreIcon",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "icon",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreRequestForm"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreArticle"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreChannel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ],
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        }
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "items(first:10)"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "mainHelpObjectsList_HelpCenterTopic_items",
                                            "kind": "LinkedHandle",
                                            "name": "items"
                                        }
                                    ],
                                    "type": "HelpCenterTopic"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1",
            "metadata": {},
            "name": "topicQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$581b4774318ed374$var$node.hash = "aad6fa68f7fdec1c20c0311c482bf40f";
var $581b4774318ed374$export$2e2bcd8739ae039 = $581b4774318ed374$var$node;

});



parcelRegister("bT4AH", function(module, exports) {
$parcel$export(module.exports, "userVerifyEmailRoute", () => $ac2f472dcc9e00bb$export$421ececb54aacf4e);

var $9mazR = parcelRequire("9mazR");

var $knMP4 = parcelRequire("knMP4");

var $joDHD = parcelRequire("joDHD");

var $ivtaS = parcelRequire("ivtaS");
const $ac2f472dcc9e00bb$var$userVerifyEmail = {
    resources: [],
    name: 'verify-email',
    path: `/user/verify-email`,
    exact: true,
    component: (0, $knMP4.VerifyEmail)
};
const $ac2f472dcc9e00bb$export$421ececb54aacf4e = (0, $joDHD.createRouteWithLayout)($ac2f472dcc9e00bb$var$userVerifyEmail, (0, $9mazR.ScreenName).VERIFY_EMAIL, (0, $ivtaS.anonymousScreenLayout));

});
parcelRegister("knMP4", function(module, exports) {
$parcel$export(module.exports, "VerifyEmail", () => $996874a4ff58d1c9$export$3d3197b723615cc);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $996874a4ff58d1c9$export$3d3197b723615cc = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("6148y")), {
        moduleId: "./src/view/verify-email/hocs.tsx"
    })
});

});
parcelRegister("6148y", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8AWhI").then(()=>parcelRequire('eCIj5'));

});



parcelRegister("jB96H", function(module, exports) {
$parcel$export(module.exports, "UFOWatcher", () => $20b60d6d3cbe4daa$export$261b8a18a570aef7);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $jQYQa = parcelRequire("jQYQa");

var $a3bfc = parcelRequire("a3bfc");

var $eWyyY = parcelRequire("eWyyY");

var $cIdUu = parcelRequire("cIdUu");

var $l6hzB = parcelRequire("l6hzB");
const $20b60d6d3cbe4daa$var$INTERESTING_RESOURCE_PATTERNS = [
    {
        spanLabel: 'jsapi.js',
        regEx: /\/jsapi\.js/
    },
    {
        spanLabel: 'challenge.js',
        regEx: /\/challenge\.js/
    },
    {
        spanLabel: 'vendor-react.chunk.js',
        regEx: /\/vendor-react\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-vendor.chunk.js',
        regEx: /\/servicedesk-vendor\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-atlaskit.chunk.js',
        regEx: /\/servicedesk-atlaskit\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'compiled-css.chunk.js',
        regEx: /\/compiled-css\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-customerportal.bundle.js',
        regEx: /\/servicedesk-customerportal\.bundle\..{0,64}js/
    }
];
function $20b60d6d3cbe4daa$var$addResourceTimingsToUFO() {
    var _globalThis$performan, _globalThis$performan2;
    ((_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 ? void 0 : _globalThis$performan.getEntriesByType) && Array.from((_globalThis$performan2 = globalThis.performance) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2.getEntriesByType('resource')).forEach((entry)=>{
        for (const resource of $20b60d6d3cbe4daa$var$INTERESTING_RESOURCE_PATTERNS)if (resource.regEx.test(entry.name)) (0, $jQYQa.addSpanToAll)('fetch', resource.spanLabel, [
            {
                name: 'custom-network'
            },
            {
                name: 'resources'
            }
        ], entry.startTime, entry.startTime + entry.duration);
    });
}
const $20b60d6d3cbe4daa$export$261b8a18a570aef7 = ()=>{
    const isInitial = (0, $fc4bM.useRef)(true);
    const [routerState] = (0, $7lAXH.useRouter)();
    const route = routerState.route;
    const match = routerState.match;
    let ufoName = (0, $a3bfc.default)(route).toLowerCase();
    if ('getUFONameBasedOnRouteMatch' in route && route.getUFONameBasedOnRouteMatch instanceof Function) ufoName = route.getUFONameBasedOnRouteMatch(match);
    const lastUFOName = (0, $fc4bM.useRef)(ufoName);
    if (ufoName) {
        if ((0, $hN5YJ.isUiModificationsSupportEnabled)() && ufoName === (0, $9mazR.ExperienceName).REQUEST_CREATE) (0, $l6hzB.startScreenTTIWithUIModifications)();
        if (isInitial.current) {
            $20b60d6d3cbe4daa$var$addResourceTimingsToUFO();
            (0, $eWyyY.default)(ufoName);
            isInitial.current = false;
        }
        if (lastUFOName.current !== ufoName && !isInitial.current) {
            lastUFOName.current = ufoName;
            (0, $cIdUu.default)(ufoName);
        }
    }
    return null;
};

});
parcelRegister("a3bfc", function(module, exports) {
$parcel$export(module.exports, "default", () => $5573a004351b18c0$export$2e2bcd8739ae039);
function $5573a004351b18c0$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $5573a004351b18c0$export$2e2bcd8739ae039 = $5573a004351b18c0$var$getUFORouteName;

});

parcelRegister("eWyyY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cb5ddfa05a250a6$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $eUgRu = parcelRequire("eUgRu");

var $jR7cM = parcelRequire("jR7cM");

var $5hPkM = parcelRequire("5hPkM");

var $f4Vz4 = parcelRequire("f4Vz4");

var $7bB5V = parcelRequire("7bB5V");

var $jQYQa = parcelRequire("jQYQa");

var $7jb5s = parcelRequire("7jb5s");

const $9cb5ddfa05a250a6$export$8851ca06c4e629aa = 'awaiting_pageload_name';
function $9cb5ddfa05a250a6$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $5hPkM.isUFOEnabled)()) return;
    const activeInteraction = (0, $jQYQa.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $7jb5s.default).current = routeName || null;
    const rate = ufoName ? (0, $5hPkM.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $jR7cM.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $eUgRu.default)();
        (0, $7bB5V.default).current = newId;
        (0, $jQYQa.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $f4Vz4.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $jQYQa.addHoldByID)(newId, [], $9cb5ddfa05a250a6$export$8851ca06c4e629aa, $9cb5ddfa05a250a6$export$8851ca06c4e629aa, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $jQYQa.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $jQYQa.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $jQYQa.removeHoldByID)(activeInteraction.id, $9cb5ddfa05a250a6$export$8851ca06c4e629aa);
    }
}
var $9cb5ddfa05a250a6$export$2e2bcd8739ae039 = $9cb5ddfa05a250a6$var$traceUFOPageLoad;

});

parcelRegister("cIdUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $824862c43c895fb2$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $eUgRu = parcelRequire("eUgRu");

var $jR7cM = parcelRequire("jR7cM");

var $kmQKA = parcelRequire("kmQKA");

var $5hPkM = parcelRequire("5hPkM");

var $f4Vz4 = parcelRequire("f4Vz4");

var $7bB5V = parcelRequire("7bB5V");

var $jQYQa = parcelRequire("jQYQa");

var $7jb5s = parcelRequire("7jb5s");

var $9QENh = parcelRequire("9QENh");
function $824862c43c895fb2$var$traceUFOTransition(ufoName, routeName = ufoName, preloadKey, eventOrTimestamp) {
    if (!(0, $5hPkM.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $5hPkM.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $jQYQa.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $jQYQa.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $7jb5s.default).current = ufoName;
        const rate = (0, $5hPkM.getInteractionRate)(ufoName, 'transition');
        if ((0, $jR7cM.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $eUgRu.default)();
            (0, $9QENh.setInteractionActiveTrace)(newId);
            (0, $7bB5V.default).current = newId;
            (0, $jQYQa.addNewInteraction)(newId, ufoName, 'transition', (0, $kmQKA.resolveInteractionTimestamp)(eventOrTimestamp) ?? performance.now(), rate, null, routeName, (0, $f4Vz4.getActiveTrace)(), preloadKey);
        }
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$824862c43c895fb2$export$2e2bcd8739ae039 = $824862c43c895fb2$var$traceUFOTransition;

});
parcelRegister("kmQKA", function(module, exports) {
$parcel$export(module.exports, "resolveInteractionTimestamp", () => $f01fe768fd31ac31$export$b0db6fdfee79a5);
function $f01fe768fd31ac31$export$b0db6fdfee79a5(eventOrTimestamp) {
    return typeof eventOrTimestamp === 'number' ? eventOrTimestamp : eventOrTimestamp === null || eventOrTimestamp === void 0 ? void 0 : eventOrTimestamp.timeStamp;
}

});

parcelRegister("9QENh", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $d86d5439d422c624$export$f2e521e495a88544);

var $62qKR = parcelRequire("62qKR");

var $1LZs8 = parcelRequire("1LZs8");
function $d86d5439d422c624$export$f2e521e495a88544(newId) {
    (0, $62qKR.setActiveTrace)(newId.replace(/-/g, ''), (0, $1LZs8.generateSpanId)(), 'transition');
}

});
parcelRegister("1LZs8", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $1ef4964d9a0d0170$export$295213bc4d0c54ad);
function $1ef4964d9a0d0170$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});




parcelRegister("fQ7Me", function(module, exports) {
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => (parcelRequire("5J3cB")).getAnonymousRequestSuccessRouteWithHubShell);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => (parcelRequire("5J3cB")).getCheckEmailRouteWithHubShell);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => (parcelRequire("5J3cB")).getCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmContactUsRouteWithHubShell);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmFolderRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmViewArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmViewCrossSiteArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmViewCrossSitePortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => (parcelRequire("5J3cB")).getCsmViewPortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getHubAllSearchResultsRouteWithHubShell", () => (parcelRequire("5J3cB")).getHubAllSearchResultsRouteWithHubShell);
$parcel$export(module.exports, "getHubCustompageRoute", () => (parcelRequire("5J3cB")).getHubCustompageRoute);
$parcel$export(module.exports, "getHubHomepageRoute", () => (parcelRequire("5J3cB")).getHubHomepageRoute);
$parcel$export(module.exports, "getHubPortalPageRoute", () => (parcelRequire("5J3cB")).getHubPortalPageRoute);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => (parcelRequire("5J3cB")).getHubUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getHubViewArticleRoute", () => (parcelRequire("5J3cB")).getHubViewArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => (parcelRequire("5J3cB")).getHubViewCrossSiteArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => (parcelRequire("5J3cB")).getHubViewCrossSitePortalArticleRoute);
$parcel$export(module.exports, "getHubViewKbRoute", () => (parcelRequire("5J3cB")).getHubViewKbRoute);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => (parcelRequire("5J3cB")).getHubViewPortalArticleRoute);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => (parcelRequire("5J3cB")).getJsmApprovalsRouteWithHubShell);
$parcel$export(module.exports, "getJsmManageColumnsRequestsListRouteWithHubShell", () => (parcelRequire("5J3cB")).getJsmManageColumnsRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => (parcelRequire("5J3cB")).getJsmRequestApprovalRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => (parcelRequire("5J3cB")).getJsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => (parcelRequire("5J3cB")).getLoginRouteWithHubShell);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => (parcelRequire("5J3cB")).getNotFoundRouteWithHubShell);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => (parcelRequire("5J3cB")).getPortalAccessForbiddenRouteWithHubShell);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => (parcelRequire("5J3cB")).getPortalCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => (parcelRequire("5J3cB")).getPortalInvitedSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => (parcelRequire("5J3cB")).getPortalLoginRouteWithHubShell);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => (parcelRequire("5J3cB")).getPortalResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => (parcelRequire("5J3cB")).getPortalSignupRouteWithHubShell);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => (parcelRequire("5J3cB")).getRequestCreateRouteWithHubShell);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => (parcelRequire("5J3cB")).getRequestFeedbackRouteWithHubShell);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => (parcelRequire("5J3cB")).getResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => (parcelRequire("5J3cB")).getSignupRouteWithHubShell);
$parcel$export(module.exports, "getSurveyRouteWithHubShell", () => (parcelRequire("5J3cB")).getSurveyRouteWithHubShell);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => (parcelRequire("5J3cB")).getUnsubscribeRouteWithHubShell);
parcelRequire("5J3cB");

});
parcelRegister("5J3cB", function(module, exports) {
$parcel$export(module.exports, "getHubHomepageRoute", () => $45968780182e9dcf$export$3b1658f4569bf0ca);
$parcel$export(module.exports, "getHubCustompageRoute", () => $45968780182e9dcf$export$737d1198516688ea);
$parcel$export(module.exports, "getHubPortalPageRoute", () => $45968780182e9dcf$export$561a9432cf020904);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => $45968780182e9dcf$export$2a2a6f715f782520);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => $45968780182e9dcf$export$2a6efc2e2d50dd68);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => $45968780182e9dcf$export$d59699c7220ea7d4);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => $45968780182e9dcf$export$c8e491027fcd76d5);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => $45968780182e9dcf$export$7e31411194771e76);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => $45968780182e9dcf$export$eb078274575814fa);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => $45968780182e9dcf$export$8628a4d0641114fc);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => $45968780182e9dcf$export$d23db2e306b7fa10);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => $45968780182e9dcf$export$df37fdf84c1e0c73);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => $45968780182e9dcf$export$9bd8f060725abce6);
$parcel$export(module.exports, "getHubViewArticleRoute", () => $45968780182e9dcf$export$215c0eb21c8c9bbd);
$parcel$export(module.exports, "getHubViewKbRoute", () => $45968780182e9dcf$export$fe3b3b72e1ee1e3);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => $45968780182e9dcf$export$276f7d60ee8fa12a);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => $45968780182e9dcf$export$3e0c0cee1ca6ead0);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => $45968780182e9dcf$export$a2895ad4defdb0c4);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => $45968780182e9dcf$export$3677170bee4c0cc5);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => $45968780182e9dcf$export$c80d2e838cbb1b16);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => $45968780182e9dcf$export$a60f6f9ee1a764cc);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => $45968780182e9dcf$export$d0572cd96b5c4ab4);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => $45968780182e9dcf$export$cfbf23f65634d193);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => $45968780182e9dcf$export$ab61a9d90fe1a668);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => $45968780182e9dcf$export$af956eb6d34eabf5);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => $45968780182e9dcf$export$ec03abb34db753b9);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => $45968780182e9dcf$export$176415cbffecf519);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => $45968780182e9dcf$export$f8feb17b3d1c6ff8);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => $45968780182e9dcf$export$30dd11011e9a2dff);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => $45968780182e9dcf$export$1b17db464925ac22);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => $45968780182e9dcf$export$dafd7c818cd58b07);
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => $45968780182e9dcf$export$a02fb894ac2280da);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => $45968780182e9dcf$export$1914f2b2604a5e33);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => $45968780182e9dcf$export$a5c23db41dcff27e);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => $45968780182e9dcf$export$aa08b576762efb0a);
$parcel$export(module.exports, "getJsmManageColumnsRequestsListRouteWithHubShell", () => $45968780182e9dcf$export$a3dcaa8df9ca6d14);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => $45968780182e9dcf$export$dbe932e8b71d8b83);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => $45968780182e9dcf$export$b5d541e9feeaef7e);
$parcel$export(module.exports, "getSurveyRouteWithHubShell", () => $45968780182e9dcf$export$44fc575b237ca256);
$parcel$export(module.exports, "getHubAllSearchResultsRouteWithHubShell", () => $45968780182e9dcf$export$85fd887d4a3e26c3);
/* hub-routes.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $6LH8a = parcelRequire("6LH8a");

var $bQkfB = parcelRequire("bQkfB");

var $eXQnZ = parcelRequire("eXQnZ");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("5sUPt");
var $dTc6i = parcelRequire("dTc6i");

var $jcOpK = parcelRequire("jcOpK");

var $12B75 = parcelRequire("12B75");

var $lkitE = parcelRequire("lkitE");
parcelRequire("5bYTt");
var $8XF5F = parcelRequire("8XF5F");
parcelRequire("hwBjj");
var $8vLfR = parcelRequire("8vLfR");

var $8vxCR = parcelRequire("8vxCR");

var $3B2H1 = parcelRequire("3B2H1");

var $6nykw = parcelRequire("6nykw");
parcelRequire("917It");
var $54pru = parcelRequire("54pru");

var $k2M4v = parcelRequire("k2M4v");

var $jWHud = parcelRequire("jWHud");

var $arvnk = parcelRequire("arvnk");

var $7rRF6 = parcelRequire("7rRF6");

var $eMhka = parcelRequire("eMhka");

var $k2kQM = parcelRequire("k2kQM");

var $bagyb = parcelRequire("bagyb");

var $aWXCW = parcelRequire("aWXCW");

var $dAKXg = parcelRequire("dAKXg");

var $0290X = parcelRequire("0290X");

var $3vF82 = parcelRequire("3vF82");

var $jIOxU = parcelRequire("jIOxU");

var $jHziR = parcelRequire("jHziR");

var $EXfS9 = parcelRequire("EXfS9");

var $6kWsJ = parcelRequire("6kWsJ");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $esgVk = parcelRequire("esgVk");

var $bKaMP = parcelRequire("bKaMP");

var $8EcEU = parcelRequire("8EcEU");

var $beT51 = parcelRequire("beT51");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("6AnW7");
var $6FAhw = parcelRequire("6FAhw");
parcelRequire("49Qlh");
var $6XxyH = parcelRequire("6XxyH");
parcelRequire("6jJcK");
var $ci8ys = parcelRequire("ci8ys");
parcelRequire("545kt");
var $2kcEp = parcelRequire("2kcEp");
parcelRequire("fVmVF");
var $jwtpI = parcelRequire("jwtpI");

var $2AeNo = parcelRequire("2AeNo");

var $9E84G = parcelRequire("9E84G");

var $3C1PA = parcelRequire("3C1PA");

var $4OMBM = parcelRequire("4OMBM");

var $3isMq = parcelRequire("3isMq");

var $8BDrU = parcelRequire("8BDrU");

var $kYptZ = parcelRequire("kYptZ");

var $e4v4V = parcelRequire("e4v4V");
parcelRequire("jqBmV");
var $hkB55 = parcelRequire("hkB55");
parcelRequire("fy0p0");
var $bM9x6 = parcelRequire("bM9x6");

var $6p3wn = parcelRequire("6p3wn");
parcelRequire("kqfQb");
var $b7wxn = parcelRequire("b7wxn");

var $1qVIU = parcelRequire("1qVIU");

var $chv7T = parcelRequire("chv7T");

var $jr9Qn = parcelRequire("jr9Qn");

var $9PouM = parcelRequire("9PouM");

var $5hFUB = parcelRequire("5hFUB");

var $9xVWL = parcelRequire("9xVWL");

var $hdisM = parcelRequire("hdisM");

var $bIlPC = parcelRequire("bIlPC");
parcelRequire("chKSm");
var $lJe7m = parcelRequire("lJe7m");

// Dynamic import, not a static one: `routes/kb` statically pulls in
// `view/knowledge-category`, whose graph reaches `packages/util/url` and calls
// `isCSMHelpCenter(getEnv())` at module scope. Loading it lazily keeps that out of
// this module's chunk and out of test-time module evaluation.
const $45968780182e9dcf$var$AsyncArticlesSearch = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>// Relative, not the `routes/kb` alias: the lazy-import babel transform resolves
        // this specifier itself and does not apply webpack's `resolve.modules`.
        (parcelRequire("3WipF")).then((m)=>({
                default: m.RenderArticlesSearchRoute
            })), {
        moduleId: "./src/routes/kb/index.tsx"
    })
});
const $45968780182e9dcf$var$editMigratedHelpCenterDraft = ()=>{
    const { helpCenterId: helpCenterId } = (0, $8BDrU.parseHelpCenterAri)((0, $6LH8a.getHelpCenterAri)() ?? '');
    (0, $esgVk.assign)((0, $3isMq.buildMigratedHelpCenterEditorUrl)({
        helpCenterId: helpCenterId
    }));
};
const $45968780182e9dcf$var$MIGRATED_HELP_CENTER_REVIEW = {
    onEditDraft: $45968780182e9dcf$var$editMigratedHelpCenterDraft,
    onFinishLater: (0, $3isMq.leaveMigratedHelpCenterReview)
};
const $45968780182e9dcf$var$renderAvatarMenuOptions = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $bM9x6.HubAvatarMenuOptions), null);
};
const $45968780182e9dcf$var$createHubRouteProps = (shouldRenderRightNavActions)=>{
    var _initialModelState$us, _initialModelState$us2, _initialModelState$us3, _initialModelState$us4;
    const initialModelState = (0, $bKaMP.default)();
    const helpCenterAri = (0, $6LH8a.getHelpCenterAri)();
    const renderRightNavActions = ()=>{
        return /*#__PURE__*/ $fc4bM.createElement((0, $6FAhw.default), {
            trigger: "icon"
        });
    };
    const isHelpHub = (0, $cf3fd.getIsHelpHub)();
    const isCSMHelpCenterFlag = (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType);
    const { helpCenterId: helpCenterId } = (0, $8BDrU.parseHelpCenterAri)(helpCenterAri ?? '');
    const isMigratedHelpCenterReviewPathActive = (0, $3isMq.isMigratedHelpCenterReviewPath)(globalThis.location.pathname);
    const migrationReview = (0, $3isMq.isMigratedHelpCenterReviewEnabled)() && isHelpHub && isMigratedHelpCenterReviewPathActive && helpCenterAri !== null && helpCenterAri !== void 0 && helpCenterAri.endsWith('-hubs') ? $45968780182e9dcf$var$MIGRATED_HELP_CENTER_REVIEW : undefined;
    return {
        renderRightNavActions: shouldRenderRightNavActions ? renderRightNavActions : undefined,
        ...(0, $k2M4v.default).checkGate('forge-on-hubs') ? {
            productExtensionsDependenciesProvider: (0, $bIlPC.HubExtensionsDependenciesProvider)
        } : {},
        renderAvatarMenuOptions: isHelpHub ? $45968780182e9dcf$var$renderAvatarMenuOptions : undefined,
        // Whether the site may customise its help center — the same attribute the
        // avatar menu reads for its Premium pill, and what the editor passes in
        // `HubEditLayout`. The view experience needs it too, because the Customise
        // menu renders here: without it `useShouldShowPremiumUpsell` only ever sees
        // `undefined` and no upsell could show. Tri-state, so `undefined` never gates,
        // and CSM is excluded by the hook's own `hubType` check rather than here.
        isPremiumEntitled: (0, $7lN8e.getIsHCCustomizationEnabled)(),
        ...migrationReview ? {
            migrationReview: migrationReview
        } : {},
        user: {
            email: ((_initialModelState$us = initialModelState.user) === null || _initialModelState$us === void 0 ? void 0 : _initialModelState$us.email) || '',
            displayName: ((_initialModelState$us2 = initialModelState.user) === null || _initialModelState$us2 === void 0 ? void 0 : _initialModelState$us2.displayName) || '',
            avatarSrc: ((_initialModelState$us3 = initialModelState.user) === null || _initialModelState$us3 === void 0 || (_initialModelState$us3 = _initialModelState$us3.avatars) === null || _initialModelState$us3 === void 0 ? void 0 : _initialModelState$us3.xlarge) || '',
            isJiraAdmin: ((_initialModelState$us4 = initialModelState.user) === null || _initialModelState$us4 === void 0 ? void 0 : _initialModelState$us4.canAdministerJIRA) || false,
            id: ''
        },
        env: {
            helpCenterId: helpCenterId,
            helpCenterAri: helpCenterAri,
            cloudId: (0, $6LH8a.getCloudId)(),
            jiraDisplayUrl: (0, $7lN8e.getJiraDisplayUrl)(),
            hoistedProjectKey: (0, $7lN8e.getHoistedProjectKey)() || '',
            relativeBaseUrl: (0, $diqlM.getRelativeBasePath)()
        },
        featureFlags: {
            enable_hub_breadcrumbs: isHelpHub,
            enable_rovo_in_help_hubs: isHelpHub && (0, $k2M4v.default).checkGate('enable_rovo_in_help_hubs'),
            hub_component_upgrade: isHelpHub && (0, $k2M4v.default).checkGate('hub_component_upgrade'),
            csm_callout_banner_component_release: isCSMHelpCenterFlag && (0, $k2M4v.default).checkGate('csm_callout_banner_component_release'),
            hub_editor_floating_toolbar: isHelpHub && (0, $k2M4v.default).checkGate('hub_editor_floating_toolbar'),
            'portal-pages-in-hub': isHelpHub && (0, $k2M4v.default).checkGate('portal-pages-in-hub'),
            // Product-level flag that opts a hub surface into advanced theming
            // v2. Today only JSM Help Hubs are opted in; the platform-level
            // `hub-advanced-theming` Statsig gate AND-combines with this so
            // rollout is independently controlled from both sides.
            'advanced-theming-in-hub': isHelpHub && (0, $k2M4v.default).checkGate('advanced-theming-in-jsm'),
            translation_support: isHelpHub,
            help_hubs_configurable_site_tree: isHelpHub
        },
        actions: {
            onLogoutClick: ()=>{
                const action = (0, $3C1PA.logOutAction)();
                (0, $4OMBM.store).dispatch(action);
                return action;
            }
        }
    };
};
const $45968780182e9dcf$var$createRouteWithHubShell = (...args)=>{
    const [props, component, ...restArgs] = args;
    return (0, $9E84G.createRouteWithHubShell)(props, (0, $8EcEU.withSetThemeColorInRedux)((0, $eXQnZ.withPathParamProvider)(component)), ...restArgs);
};
/**
 * Route props carrying the Customise menu. `pageType` is only for pages that can
 * be edited from it; everything else gets the shared help center section alone.
 *
 * Guarded on `getIsHelpHub()` because several of these routes are registered by the
 * CSM router as well as the hub one — home, custom page, not found and portal
 * access forbidden are all shared — so being wired here is not enough to mean the
 * caller is a help hub. Same guard `createHubRouteProps` puts on
 * `renderAvatarMenuOptions`, and read inside the callback so it resolves at render
 * rather than at route registration.
 */ const $45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu = (shouldRenderRightNavActions, pageType)=>({
        ...$45968780182e9dcf$var$createHubRouteProps(shouldRenderRightNavActions),
        renderCustomNavActions: (iconColor)=>(0, $cf3fd.getIsHelpHub)() ? /*#__PURE__*/ $fc4bM.createElement((0, $2kcEp.HubCustomizeNavActions), {
                iconColor: iconColor,
                pageType: pageType
            }) : null
    });
const $45968780182e9dcf$export$3b1658f4569bf0ca = ()=>(0, $54pru.withHubPremiumSlaExperience)((0, $9E84G.createHubHomepageRoute)({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        appearance: (0, $cf3fd.getIsHelpHub)() && (0, $hdisM.isHubMaxWidthAppearanceEnabled)() ? 'max' : undefined,
        renderCustomNavActions: (iconColor)=>(0, $cf3fd.getIsHelpHub)() ? /*#__PURE__*/ $fc4bM.createElement((0, $ci8ys.HubHomepageCustomizeNavActions), {
                iconColor: iconColor
            }) : null
    }), (0, $9mazR.ExperienceName).HELP_CENTER, (0, $9mazR.ScreenName).HELP_CENTER);
const $45968780182e9dcf$export$737d1198516688ea = ()=>(0, $9E84G.createHubCustomPageRoute)({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true, (0, $jWHud.HubPageType).CUSTOM),
        appearance: (0, $cf3fd.getIsHelpHub)() && (0, $hdisM.isHubMaxWidthAppearanceEnabled)() ? 'max' : undefined
    });
const $45968780182e9dcf$export$561a9432cf020904 = ()=>(0, $54pru.withHubPremiumSlaExperience)((0, $9E84G.createHubPortalPageRoute)({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true, (0, $jWHud.HubPageType).PORTAL),
        appearance: (0, $cf3fd.getIsHelpHub)() && (0, $hdisM.isHubMaxWidthAppearanceEnabled)() ? 'max' : undefined
    }), (0, $9mazR.ExperienceName).REQUEST_CREATE, // The older help center's portal home, which mounts the same experience.
    (0, $9mazR.ScreenName).PORTAL_HOME);
const $45968780182e9dcf$export$2a2a6f715f782520 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $9PouM.CsmUserProfileForHubs), (0, $9xVWL.HUB_ROUTES).USER_PROFILE.path, (0, $9xVWL.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $45968780182e9dcf$export$2a6efc2e2d50dd68 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $jIOxU.CsmRequestsListForHubs), (0, $9xVWL.HUB_ROUTES).CSM_REQUESTS_LIST.path, (0, $9xVWL.HUB_ROUTES).CSM_REQUESTS_LIST.name, [
        (0, $EXfS9.csmRequestsListQueryResource)
    ], 'full-width');
const $45968780182e9dcf$export$d59699c7220ea7d4 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $arvnk.CsmContactUsForHubs), (0, $9xVWL.HUB_ROUTES).CSM_CONTACT_US.path, (0, $9xVWL.HUB_ROUTES).CSM_CONTACT_US.name, [
        (0, $6kWsJ.mediaUploadCredentialsResource)
    ], 'full-width');
const $45968780182e9dcf$export$c8e491027fcd76d5 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $dTc6i.NotFoundPage), (0, $9xVWL.HUB_ROUTES).NOT_FOUND.path, (0, $9xVWL.HUB_ROUTES).NOT_FOUND.name, [], 'normal');
const $45968780182e9dcf$export$7e31411194771e76 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $7rRF6.CsmFolderForHubs), (0, $9xVWL.HUB_ROUTES).CSM_FOLDER.path, (0, $9xVWL.HUB_ROUTES).CSM_FOLDER.name, [
        (0, $k2kQM.CsmFolderResource),
        (0, $eMhka.CsmEmptyFolderResource)
    ], 'full-width');
const $45968780182e9dcf$export$eb078274575814fa = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $3vF82.AsyncCsmRequestDetails), (0, $9xVWL.HUB_ROUTES).CSM_REQUEST_DETAILS.path, (0, $9xVWL.HUB_ROUTES).CSM_REQUEST_DETAILS.name, [
        (0, $bagyb.csmRequestDetailsQueryResource),
        (0, $0290X.requestConversationResource),
        (0, $aWXCW.mediaReadCredentialsResource),
        (0, $dAKXg.mediaUploadCredentialsResource)
    ], 'xxwide');
const $45968780182e9dcf$export$8628a4d0641114fc = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $jcOpK.CsmArticle), (0, $9xVWL.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], 'wide');
const $45968780182e9dcf$export$d23db2e306b7fa10 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $e4v4V.Article), (0, $9xVWL.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], 'wide');
const $45968780182e9dcf$export$df37fdf84c1e0c73 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $8vLfR.default), (0, $9xVWL.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.path, (0, $9xVWL.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.name, [], 'normal');
const $45968780182e9dcf$export$9bd8f060725abce6 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $jcOpK.CsmArticle), (0, $9xVWL.HUB_ROUTES).VIEW_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_ARTICLE.name, [], 'full-width');
const $45968780182e9dcf$export$215c0eb21c8c9bbd = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $e4v4V.Article), (0, $9xVWL.HUB_ROUTES).VIEW_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_ARTICLE.name, [], 'normal');
const $45968780182e9dcf$export$fe3b3b72e1ee1e3 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        appearance: 'full-width'
    }, (0, $e4v4V.Article), (0, $9xVWL.HUB_ROUTES).VIEW_KB_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_KB_ARTICLE.name, [], 'normal');
const $45968780182e9dcf$export$276f7d60ee8fa12a = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $jcOpK.CsmArticle), (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $45968780182e9dcf$export$3e0c0cee1ca6ead0 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $e4v4V.Article), (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $45968780182e9dcf$export$a2895ad4defdb0c4 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $e4v4V.Article), (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $45968780182e9dcf$export$3677170bee4c0cc5 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRouteProps(true), (0, $jcOpK.CsmArticle), (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $9xVWL.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $45968780182e9dcf$export$c80d2e838cbb1b16 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $8XF5F.default), null)), (0, $9xVWL.HUB_ROUTES).LOGIN.path, (0, $9xVWL.HUB_ROUTES).LOGIN.name, [], 'note');
const $45968780182e9dcf$export$a60f6f9ee1a764cc = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $8XF5F.default), null)), (0, $9xVWL.HUB_ROUTES).PORTAL_LOGIN.path, (0, $9xVWL.HUB_ROUTES).PORTAL_LOGIN.name, [], 'note');
const $45968780182e9dcf$export$d0572cd96b5c4ab4 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $3B2H1.SignUp), routeProps)), (0, $9xVWL.HUB_ROUTES).SIGNUP.path, (0, $9xVWL.HUB_ROUTES).SIGNUP.name, [], 'note');
const $45968780182e9dcf$export$cfbf23f65634d193 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $3B2H1.SignUp), routeProps)), (0, $9xVWL.HUB_ROUTES).PORTAL_SIGNUP.path, (0, $9xVWL.HUB_ROUTES).PORTAL_SIGNUP.name, [], 'note');
const $45968780182e9dcf$export$ab61a9d90fe1a668 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $12B75.CompleteSignup), routeProps)), (0, $9xVWL.HUB_ROUTES).COMPLETE_SIGNUP.path, (0, $9xVWL.HUB_ROUTES).COMPLETE_SIGNUP.name, [], 'note');
const $45968780182e9dcf$export$af956eb6d34eabf5 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $12B75.CompleteSignup), routeProps)), (0, $9xVWL.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.path, (0, $9xVWL.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.name, [], 'note');
const $45968780182e9dcf$export$ec03abb34db753b9 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $8vxCR.ResetPassword), routeProps)), (0, $9xVWL.HUB_ROUTES).RESET_PASSWORD.path, (0, $9xVWL.HUB_ROUTES).RESET_PASSWORD.name, [], 'note');
const $45968780182e9dcf$export$176415cbffecf519 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $8vxCR.ResetPassword), routeProps)), (0, $9xVWL.HUB_ROUTES).PORTAL_RESET_PASSWORD.path, (0, $9xVWL.HUB_ROUTES).PORTAL_RESET_PASSWORD.name, [], 'note');
const $45968780182e9dcf$export$f8feb17b3d1c6ff8 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $6nykw.CheckEmail), {
            ...routeProps,
            isLoading: false
        })), (0, $9xVWL.HUB_ROUTES).CHECK_EMAIL.path, (0, $9xVWL.HUB_ROUTES).CHECK_EMAIL.name, [], 'note');
const $45968780182e9dcf$export$30dd11011e9a2dff = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ $fc4bM.createElement((0, $hkB55.HubAnonymousLayout), null, /*#__PURE__*/ $fc4bM.createElement((0, $lkitE.InvitedSignUp), null)), (0, $9xVWL.HUB_ROUTES).PORTAL_INVITED_SIGNUP.path, (0, $9xVWL.HUB_ROUTES).PORTAL_INVITED_SIGNUP.name, [], 'note');
const $45968780182e9dcf$export$1b17db464925ac22 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $jr9Qn.Unsubscribe), (0, $9xVWL.HUB_ROUTES).UNSUBSCRIBE.path, (0, $9xVWL.HUB_ROUTES).UNSUBSCRIBE.name, [], 'note');
const $45968780182e9dcf$export$dafd7c818cd58b07 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $1qVIU.RequestFeedback), (0, $9xVWL.HUB_ROUTES).REQUEST_FEEDBACK.path, (0, $9xVWL.HUB_ROUTES).REQUEST_FEEDBACK.name, [], 'note');
const $45968780182e9dcf$export$a02fb894ac2280da = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $dTc6i.RenderCreateAnonymousSuccess), (0, $9xVWL.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.path, (0, $9xVWL.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.name, [], 'xxwide');
const $45968780182e9dcf$export$1914f2b2604a5e33 = ()=>(0, $54pru.withHubPremiumSlaExperience)($45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $dTc6i.RenderRequestCreateForHubs), (0, $9xVWL.HUB_ROUTES).REQUEST_CREATE.path, (0, $9xVWL.HUB_ROUTES).REQUEST_CREATE.name, [], 'full-width'), (0, $9mazR.ExperienceName).REQUEST_CREATE, (0, $9mazR.ScreenName).REQUEST_CREATE);
const $45968780182e9dcf$export$a5c23db41dcff27e = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $lJe7m.withStaticHubBreadcrumbs)((0, $5hFUB.UserProfileForHubs), (0, $9xVWL.HUB_ROUTES).USER_PROFILE.name), (0, $9xVWL.HUB_ROUTES).USER_PROFILE.path, (0, $9xVWL.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $45968780182e9dcf$export$aa08b576762efb0a = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $b7wxn.default), (0, $9xVWL.HUB_ROUTES).JSM_REQUEST_DETAILS.path, (0, $9xVWL.HUB_ROUTES).JSM_REQUEST_DETAILS.name, [], 'xxwide');
const $45968780182e9dcf$var$JsmCustomizeNavActions = ({ iconColor: iconColor })=>{
    const state = (0, $4OMBM.store).getState();
    const canAdministerJIRA = (0, $7RWiC.getCanAdministerJIRA)(state);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleManageListViewClick = (0, $fc4bM.useCallback)(()=>{
        (0, $4OMBM.store).dispatch((0, $beT51.customizingRequestListColumn)(true));
    }, []);
    const items = (0, $fc4bM.useMemo)(()=>{
        if (!canAdministerJIRA) return [];
        return [
            {
                label: formatMessage((0, $2AeNo.default).manageListViewButtonLabel),
                testId: 'manage-list-view-button',
                actionSubjectId: 'manageListViewButton',
                onClick: handleManageListViewClick
            }
        ];
    }, [
        canAdministerJIRA,
        formatMessage,
        handleManageListViewClick
    ]);
    const helpCenterSection = (0, $jwtpI.useHelpCenterCustomizeSection)(canAdministerJIRA);
    const sections = (0, $fc4bM.useMemo)(()=>[
            {
                items: items
            },
            helpCenterSection
        ].filter((section)=>Boolean(section)), [
        items,
        helpCenterSection
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6XxyH.HubCustomizeMenu), {
        sections: sections,
        iconColor: iconColor
    });
};
const $45968780182e9dcf$var$RequestListWithStaticHubBreadcrumbs = (0, $lJe7m.withStaticHubBreadcrumbs)((0, $chv7T.RequestList), (0, $9xVWL.HUB_ROUTES).JSM_REQUESTS_LIST.name);
const $45968780182e9dcf$export$a3dcaa8df9ca6d14 = ()=>{
    const renderCustomNavActions = (iconColor)=>/*#__PURE__*/ $fc4bM.createElement($45968780182e9dcf$var$JsmCustomizeNavActions, {
            iconColor: iconColor
        });
    return $45968780182e9dcf$var$createRouteWithHubShell(/**
   * TODO: The banner text has to be internationalized
   */ {
        ...$45968780182e9dcf$var$createHubRouteProps(true),
        renderCustomNavActions: renderCustomNavActions,
        layout: {
            showBanner: true,
            bannerText: 'Requests',
            isAnonymousRoute: false
        }
    }, $45968780182e9dcf$var$RequestListWithStaticHubBreadcrumbs, (0, $9xVWL.HUB_ROUTES).JSM_REQUESTS_LIST.path, (0, $9xVWL.HUB_ROUTES).JSM_REQUESTS_LIST.name, [], 'xxwide');
};
const $45968780182e9dcf$export$dbe932e8b71d8b83 = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: 'Approvals',
            isAnonymousRoute: false
        }
    }, (0, $lJe7m.withStaticHubBreadcrumbs)((0, $kYptZ.ApprovalList), (0, $9xVWL.HUB_ROUTES).JSM_APPROVALS.name), (0, $9xVWL.HUB_ROUTES).JSM_APPROVALS.path, (0, $9xVWL.HUB_ROUTES).JSM_APPROVALS.name, [], 'xxwide');
const $45968780182e9dcf$export$b5d541e9feeaef7e = ()=>$45968780182e9dcf$var$createRouteWithHubShell({
        ...$45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $6p3wn.RequestApproval), (0, $9xVWL.HUB_ROUTES).JSM_REQUEST_APPROVAL.path, (0, $9xVWL.HUB_ROUTES).JSM_REQUEST_APPROVAL.name, [], 'xxwide');
const $45968780182e9dcf$export$44fc575b237ca256 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), (0, $jHziR.AsyncSurveyDetails), (0, $9xVWL.HUB_ROUTES).SURVEY.path, (0, $9xVWL.HUB_ROUTES).SURVEY.name, [], 'xxwide');
const $45968780182e9dcf$export$85fd887d4a3e26c3 = ()=>$45968780182e9dcf$var$createRouteWithHubShell($45968780182e9dcf$var$createHubRoutePropsWithCustomizeMenu(true), $45968780182e9dcf$var$AsyncArticlesSearch, (0, $9xVWL.HUB_ROUTES).ALL_SEARCH_RESULTS.path, (0, $9xVWL.HUB_ROUTES).ALL_SEARCH_RESULTS.name, [], 'full-width', {
        hideNavbar: true
    });

});
parcelRegister("917It", function(module, exports) {
$parcel$export(module.exports, "HubPremiumSlaElementsProvider", () => (parcelRequire("54pru")).HubPremiumSlaElementsProvider);
$parcel$export(module.exports, "withHubPremiumSlaExperience", () => (parcelRequire("54pru")).withHubPremiumSlaExperience);

var $54pru = parcelRequire("54pru");

});
parcelRegister("54pru", function(module, exports) {
$parcel$export(module.exports, "HubPremiumSlaElementsProvider", () => $a5e7500eb84cce1e$export$6534426fcefca7b3);
$parcel$export(module.exports, "withHubPremiumSlaExperience", () => $a5e7500eb84cce1e$export$a1922c62fb34200e);
/**
 * Premium SLA (UI task success / fail) metrics for the new help center, a.k.a. hubs.
 *
 * Hub routes render through the platform `@atlassian/hub` packages and emitted neither
 * `view-help-center` nor `request-create`. This mounts the same `Experience` with the same
 * payload and screen, so hub traffic is separated in reporting by the `helpCenterCategory`
 * attribute the analytics client already adds, not by a different metric:
 * - Success: hub pages have no help center notifiers, so `HubPremiumSlaElementsProvider`
 *   supplies one per rendered element.
 * - Failure: hub failures are caught by the platform's `HubErrorBoundary`, which reports
 *   to `HubErrorObserverContext`.
 */ 
var $fc4bM = parcelRequire("fc4bM");
parcelRequire("epa1X");
var $7egf9 = parcelRequire("7egf9");
var $7egf9 = parcelRequire("7egf9");
var $4zyaU = parcelRequire("4zyaU");

var $9mazR = parcelRequire("9mazR");

var $k2M4v = parcelRequire("k2M4v");

var $eENmG = parcelRequire("eENmG");

var $6KLOx = parcelRequire("6KLOx");

var $iHy52 = parcelRequire("iHy52");

var $4Y293 = parcelRequire("4Y293");

var $c0Y6o = parcelRequire("c0Y6o");
/** Gates the whole hub emission, so it can be rolled out gradually and killed if it misreports. */ const $a5e7500eb84cce1e$var$HUB_PREMIUM_SLA_METRICS = 'help_center_hub_premium_sla_metrics';
const $a5e7500eb84cce1e$export$c6fcfc3cc09fa333 = ()=>(0, $k2M4v.default).checkGate($a5e7500eb84cce1e$var$HUB_PREMIUM_SLA_METRICS);
/** The page itself failed to render, so neither journey can complete. */ const $a5e7500eb84cce1e$var$PAGE_LEVEL_ERROR_IDS = new Set([
    'hub-page',
    'route-with-hub-shell'
]);
const $a5e7500eb84cce1e$var$JSM_HELP_EXTENSION_KEY = 'jsm-help';
/**
 * Fail the home page but not create request: a customer can still reach the request
 * form when these fail.
 */ const $a5e7500eb84cce1e$var$HOME_PAGE_ONLY_ERROR_IDS = new Set([
    'spotlight',
    'carousel',
    'cards',
    'links-menu',
    'hub-section',
    'banner'
]);
const $a5e7500eb84cce1e$export$7e7b0dfb9751d5dd = (id, journey)=>{
    if ($a5e7500eb84cce1e$var$PAGE_LEVEL_ERROR_IDS.has(id) || id === $a5e7500eb84cce1e$var$JSM_HELP_EXTENSION_KEY) return true;
    return journey === (0, $9mazR.ExperienceName).HELP_CENTER && $a5e7500eb84cce1e$var$HOME_PAGE_ONLY_ERROR_IDS.has(id);
};
const $a5e7500eb84cce1e$var$PremiumSlaErrorObserver = ({ children: children, journey: journey })=>{
    const { onFailure: onFailure } = (0, $fc4bM.useContext)((0, $7egf9.ExperienceContext));
    const observeError = (0, $fc4bM.useCallback)(({ error: error, id: id })=>{
        const fetchError = error;
        // Only 5xx counts. 4xx and network errors are excluded, as in the older help center.
        if (!$a5e7500eb84cce1e$export$7e7b0dfb9751d5dd(id, journey) || (0, $c0Y6o.isFetchNetworkOrClientError)(fetchError)) return;
        onFailure({
            errorMessage: error.message,
            errorName: error.name,
            unhandledError: true,
            errorLocation: id.startsWith('hub-') ? id : `hub-${id}`,
            status: fetchError.status
        });
    }, [
        journey,
        onFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4Y293.HubErrorObserverContext).Provider, {
        value: observeError
    }, children);
};
const $a5e7500eb84cce1e$export$6534426fcefca7b3 = ({ children: children, extensionKey: extensionKey, mode: mode })=>{
    const productDependencies = (0, $iHy52.useProductDependencies)();
    // Only the published renderer is measured; editing a hub is not a customer journey.
    const isEnabled = $a5e7500eb84cce1e$export$c6fcfc3cc09fa333() && mode === (0, $6KLOx.ExtensionMode).RENDERER;
    // Keyed on the extension key alone: a changing identity would remount the element.
    const experienceStartComponent = (0, $fc4bM.useMemo)(()=>{
        const location = `hub-element-${extensionKey || 'unknown'}`;
        const HubElementRendered = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4zyaU.ExperienceSuccess), {
                location: location
            });
        HubElementRendered.displayName = 'HubElementRendered';
        return HubElementRendered;
    }, [
        extensionKey
    ]);
    const value = isEnabled ? {
        ...productDependencies,
        experienceStartComponent: experienceStartComponent
    } : productDependencies;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iHy52.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $a5e7500eb84cce1e$export$a1922c62fb34200e = (route, journey, screenName)=>{
    const Component = route.component;
    if (!$a5e7500eb84cce1e$export$c6fcfc3cc09fa333() || !Component) return route;
    const HubRouteWithPremiumSla = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eENmG.AnalyticsContext), {
            sourceName: screenName,
            sourceType: (0, $eENmG.ScreenTypes).SCREEN
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7egf9.default), {
            name: journey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a5e7500eb84cce1e$var$PremiumSlaErrorObserver, {
            journey: journey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props))));
    return {
        ...route,
        component: HubRouteWithPremiumSla
    };
};

});
parcelRegister("6KLOx", function(module, exports) {
$parcel$export(module.exports, "ButtonStyle", () => $26b6f66305c6d940$export$bdc3c19374266b98);
$parcel$export(module.exports, "CornerStyle", () => $26b6f66305c6d940$export$a6e645fda5339bf8);
$parcel$export(module.exports, "Height", () => $26b6f66305c6d940$export$8954cfac7c08d16a);
$parcel$export(module.exports, "Alignment", () => $26b6f66305c6d940$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "Orientation", () => $26b6f66305c6d940$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "CardLayout", () => $26b6f66305c6d940$export$21e76ed09a093e97);
$parcel$export(module.exports, "CommonLayout", () => $26b6f66305c6d940$export$42809f9f1496f50d);
$parcel$export(module.exports, "FeedbackType", () => $26b6f66305c6d940$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ExtensionMode", () => $26b6f66305c6d940$export$533ae1c1b7b7ac6);
$parcel$export(module.exports, "RenderVariant", () => $26b6f66305c6d940$export$1f60141b6ce5efed);
$parcel$export(module.exports, "SegmentationTargets", () => $26b6f66305c6d940$export$f6cd408cac7f930c);
$parcel$export(module.exports, "ITEM_FIELDS", () => $26b6f66305c6d940$export$bf7ebf7fed6e7189);
var $26b6f66305c6d940$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $26b6f66305c6d940$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $26b6f66305c6d940$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $26b6f66305c6d940$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $26b6f66305c6d940$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $26b6f66305c6d940$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $26b6f66305c6d940$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $26b6f66305c6d940$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $26b6f66305c6d940$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $26b6f66305c6d940$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $26b6f66305c6d940$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $26b6f66305c6d940$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $26b6f66305c6d940$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});

});

parcelRegister("iHy52", function(module, exports) {
$parcel$export(module.exports, "ProductDependenciesContext", () => $559b53097a763844$export$49e1053dfc41d188);
$parcel$export(module.exports, "useProductDependencies", () => $559b53097a763844$export$8dcbb40932065737);

var $fc4bM = parcelRequire("fc4bM");
const $559b53097a763844$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $559b53097a763844$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $fc4bM.useContext)($559b53097a763844$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($559b53097a763844$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
function $559b53097a763844$export$8dcbb40932065737() {
    const ctx = (0, $fc4bM.useContext)($559b53097a763844$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}

});

parcelRegister("4Y293", function(module, exports) {
$parcel$export(module.exports, "HubErrorObserverContext", () => $cedc6ed57290d7ac$export$f0a9f6d56660bc06);

var $fc4bM = parcelRequire("fc4bM");
const $cedc6ed57290d7ac$export$f0a9f6d56660bc06 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(undefined);

});



parcelRegister("jWHud", function(module, exports) {
$parcel$export(module.exports, "HubPageType", () => $e744945ee5ab7582$export$dbf470ddbd9b58b6);
$parcel$export(module.exports, "isPortalPage", () => $e744945ee5ab7582$export$646dda995799f7d5);
$parcel$export(module.exports, "isTopicPage", () => $e744945ee5ab7582$export$cf2e4190faa8ff7e);
$parcel$export(module.exports, "getPortalIdFromPageId", () => $e744945ee5ab7582$export$fef05bffd39d3ca1);
$parcel$export(module.exports, "buildPortalPageAri", () => $e744945ee5ab7582$export$9d2b62eb20639695);
$parcel$export(module.exports, "buildHomePageAri", () => $e744945ee5ab7582$export$f030375a17a3cd03);
$parcel$export(module.exports, "isHomePageByAri", () => $e744945ee5ab7582$export$c0ca1e0679075a3);
$parcel$export(module.exports, "resolveCurrentPage", () => $e744945ee5ab7582$export$bec70b043200c466);
// eslint-disable-next-line no-restricted-imports

var $4MoYu = parcelRequire("4MoYu");
var $gK5mb = parcelRequire("gK5mb");
const $e744945ee5ab7582$var$PORTAL_PAGE_PREFIX = 'portal_page-';
const $e744945ee5ab7582$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $4MoYu.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // Silently fail for invalid ARIs
    }
};
var $e744945ee5ab7582$export$dbf470ddbd9b58b6 = /*#__PURE__*/ function(HubPageType) {
    /** The hub's home/landing page */ HubPageType["HOME"] = "HOME";
    /** A custom page created in the hub editor */ HubPageType["CUSTOM"] = "CUSTOM";
    /** A portal page backed by a JSM portal */ HubPageType["PORTAL"] = "PORTAL";
    return HubPageType;
}({});
const $e744945ee5ab7582$export$c246174f38c9bde7 = (pageId)=>{
    if (!pageId) return "HOME";
    if (pageId.startsWith($e744945ee5ab7582$var$PORTAL_PAGE_PREFIX)) return "PORTAL";
    return "CUSTOM";
};
const $e744945ee5ab7582$export$646dda995799f7d5 = (pageId)=>$e744945ee5ab7582$export$c246174f38c9bde7(pageId) === "PORTAL";
const $e744945ee5ab7582$export$cf2e4190faa8ff7e = (pageId, topicPages)=>{
    if (!pageId || $e744945ee5ab7582$export$646dda995799f7d5(pageId)) return false;
    return topicPages.some((page)=>{
        try {
            return (0, $gK5mb.HelpPageAri).parse(page.id).pageId === pageId;
        } catch  {
            // Skip rather than throw: this runs on every render of the editor host.
            return false;
        }
    });
};
const $e744945ee5ab7582$export$fef05bffd39d3ca1 = (pageId)=>{
    if (!$e744945ee5ab7582$export$646dda995799f7d5(pageId)) return '';
    return pageId.slice($e744945ee5ab7582$var$PORTAL_PAGE_PREFIX.length);
};
const $e744945ee5ab7582$export$9d2b62eb20639695 = (helpCenterAri, portalPageId)=>{
    const meta = $e744945ee5ab7582$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return '';
    const { activationId: activationId, helpCenterId: helpCenterId } = meta;
    return `ari:cloud:help::page/${activationId}/${portalPageId}/${helpCenterId}`;
};
const $e744945ee5ab7582$export$f030375a17a3cd03 = (helpCenterAri, hubId)=>{
    const meta = $e744945ee5ab7582$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return '';
    return `ari:cloud:help::page/${meta.activationId}/${hubId}`;
};
const $e744945ee5ab7582$export$c0ca1e0679075a3 = (parsedPageId, helpCenterAri)=>{
    const meta = $e744945ee5ab7582$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return false;
    return parsedPageId === meta.helpCenterId;
};
const $e744945ee5ab7582$export$bec70b043200c466 = (pageId, filteredPages, helpCenterAri, currentPageName)=>{
    const pageType = $e744945ee5ab7582$export$c246174f38c9bde7(pageId);
    if (pageType === "PORTAL") return {
        pageType: pageType,
        isHomePage: false,
        pageAri: $e744945ee5ab7582$export$9d2b62eb20639695(helpCenterAri, pageId),
        pageName: currentPageName || ''
    };
    if (pageType === "CUSTOM") {
        const matchedPage = filteredPages.find((page)=>{
            var _page$name;
            return ((_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default) && (0, $gK5mb.HelpPageAri).parse(page.id).pageId === pageId;
        });
        if (matchedPage) {
            var _matchedPage$name;
            return {
                pageType: pageType,
                isHomePage: false,
                pageAri: matchedPage.id,
                pageName: ((_matchedPage$name = matchedPage.name) === null || _matchedPage$name === void 0 ? void 0 : _matchedPage$name.default) || ''
            };
        }
        return null;
    }
    return {
        pageType: "HOME",
        isHomePage: true,
        pageAri: '',
        pageName: ''
    };
};

});

parcelRegister("arvnk", function(module, exports) {
$parcel$export(module.exports, "CsmContactUsForHubs", () => $db15a5205113340d$export$18dcede65e3972a9);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $db15a5205113340d$export$18dcede65e3972a9 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("9hXhY")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("9hXhY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("e2nF0"),
    $9dnsd("bmLFd"),
    $9dnsd("jsVEa"),
    $9dnsd("9Fw1L"),
    $9dnsd("kE1ct"),
    $9dnsd("39YZp"),
    $9dnsd("5nj3m"),
    $9dnsd("hHYFE"),
    $9dnsd("6VzBn"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("bMKAA"),
    $9dnsd("8QEJW"),
    $9dnsd("6vflX"),
    $9dnsd("8jUSm")
]).then(()=>parcelRequire('lsZik'));

});


parcelRegister("7rRF6", function(module, exports) {
$parcel$export(module.exports, "CsmFolderForHubs", () => $219cffd305a6815a$export$46d643ae94fd657a);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $219cffd305a6815a$export$46d643ae94fd657a = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("bhz1Y")), {
        moduleId: "./packages/customer-service/csm-folder/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("bhz1Y", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("6ODTf"),
    $9dnsd("fWhEO")
]).then(()=>parcelRequire('lkhqH'));

});


parcelRegister("jIOxU", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsListForHubs", () => $73be2b585f496d1e$export$3f37ab3da4f058a);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $73be2b585f496d1e$export$3f37ab3da4f058a = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("1lRZY")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("1lRZY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("ftxV4"),
    $9dnsd("bVBnH"),
    $9dnsd("d3iv7"),
    $9dnsd("aqyjy"),
    $9dnsd("hs3rY"),
    $9dnsd("cT544"),
    $9dnsd("3y9mg")
]).then(()=>parcelRequire('50JQI'));

});


parcelRegister("jHziR", function(module, exports) {
$parcel$export(module.exports, "AsyncSurveyDetails", () => $ad0ceb113a973a22$export$b01dbc7a6c5c4fed);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $ad0ceb113a973a22$export$b01dbc7a6c5c4fed = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("fjMF7")), {
        moduleId: "./packages/surveys/src/Survey.tsx"
    })
});

});
parcelRegister("fjMF7", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("e2nF0"),
    $9dnsd("bmLFd"),
    $9dnsd("jsVEa"),
    $9dnsd("kE1ct"),
    $9dnsd("gTl3E"),
    $9dnsd("hHYFE"),
    $9dnsd("6VzBn"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("8QEJW"),
    $9dnsd("gUCeg"),
    $9dnsd("fWi8e")
]).then(()=>parcelRequire('eYlAg'));

});


parcelRegister("8EcEU", function(module, exports) {
$parcel$export(module.exports, "withSetThemeColorInRedux", () => $abe3b5e06439ddde$export$e14001b3f71f56fc);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $gwluP = parcelRequire("gwluP");
const $abe3b5e06439ddde$export$e14001b3f71f56fc = (InnerComponent)=>{
    const Component = (props)=>{
        const { bannerBackgroundColor: bannerBackgroundColor, setThemeColor: setThemeColor } = props;
        $fc4bM.useEffect(()=>{
            if (bannerBackgroundColor) setThemeColor({
                themeColor: bannerBackgroundColor
            });
        }, [
            bannerBackgroundColor,
            setThemeColor
        ]);
        return /*#__PURE__*/ $fc4bM.createElement(InnerComponent, props);
    };
    return (0, $6umft.default)(null, {
        setThemeColor: (0, $gwluP.updateHCThemeColorAction)
    })(Component);
};

});

parcelRegister("49Qlh", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeMenu", () => (parcelRequire("6XxyH")).HubCustomizeMenu);
parcelRequire("6XxyH");

});
parcelRegister("6XxyH", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeMenu", () => $de0fa36bebc71126$export$1c1a3da435dd8e63);
/* hub-customize-menu.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $g9mbo = parcelRequire("g9mbo");

var $jEubQ = parcelRequire("jEubQ");

var $k2M4v = parcelRequire("k2M4v");

var $eENmG = parcelRequire("eENmG");

var $fRCnG = parcelRequire("fRCnG");

var $fBqpc = parcelRequire("fBqpc");

var $eaozo = parcelRequire("eaozo");

var $bKfoa = parcelRequire("bKfoa");

var $T88uF = parcelRequire("T88uF");

var $gSOfb = parcelRequire("gSOfb");

var $3rlj9 = parcelRequire("3rlj9");

var $4EPUx = parcelRequire("4EPUx");
parcelRequire("kOWPe");
var $bwpot = parcelRequire("bwpot");

var $fXKVz = parcelRequire("fXKVz");

var $2AeNo = parcelRequire("2AeNo");
/**
 * Has the hub Customise menu report its trigger and every option's click, and
 * its Premium upsell items report their exposure.
 */ const $de0fa36bebc71126$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE = 'hubs_customize_menu_analytics';
const $de0fa36bebc71126$var$isHubCustomizeMenuAnalyticsEnabled = ()=>(0, $k2M4v.default).checkGate($de0fa36bebc71126$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE);
const $de0fa36bebc71126$var$menuContainerStyles = null;
const $de0fa36bebc71126$var$setRefValue = (ref, element)=>{
    if (typeof ref === 'function') ref(element);
    else if (ref && typeof ref === 'object' && 'current' in ref) ref.current = element;
};
const $de0fa36bebc71126$var$HubCustomizeMenuComponent = ({ sections: sections, iconColor: iconColor })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const isMobile = (0, $fXKVz.useMediaQuery)('(max-width: 768px)');
    const setCustomiseSidebarTrigger = (0, $bwpot.useSetCustomiseSidebarTrigger)();
    const handleToggle = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        if ($de0fa36bebc71126$var$isHubCustomizeMenuAnalyticsEnabled()) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'hubCustomizeMenuTrigger',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
        setIsOpen((prev)=>!prev);
    }, [
        createAnalyticsEvent
    ]);
    const fireItemClicked = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((item)=>{
        if (!$de0fa36bebc71126$var$isHubCustomizeMenuAnalyticsEnabled()) return;
        // `customizeMenu` is what these items reported before the menu owned it.
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'customizeMenu',
            actionSubjectId: item.actionSubjectId,
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            attributes: item.analyticsAttributes
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleItemClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((onClick)=>{
        onClick === null || onClick === void 0 || onClick();
        setIsOpen(false);
    }, []);
    const visibleSections = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>sections.filter((section)=>section.items.length > 0), [
        sections
    ]);
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            "data-testid": "hub-customize-menu-content",
            className: (0, $2R2iS.default)([
                "_2rkofajl _1bsbnpok _bfhkvuon _16qs1m5t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gSOfb.default), null, visibleSections.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
                key: section.heading ?? `section-${index}`,
                hasSeparator: index > 0
            }, section.heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $T88uF.default), {
                id: `hub-customize-menu-heading-${index}`
            }, section.heading), section.items.map((item)=>{
                if (item.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
                    key: item.testId
                }, item.customRenderer({
                    onClick: ()=>fireItemClicked(item)
                }));
                return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
                    key: item.testId,
                    component: (0, $g9mbo.HtmlAnchor),
                    href: item.href,
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    actionSubjectId: item.actionSubjectId,
                    testId: item.testId,
                    onClick: ()=>handleItemClick(item.onClick),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
                    className: "cv-exclude-from-customisation"
                }, item.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
                    key: item.testId,
                    testId: item.testId,
                    onClick: ()=>{
                        fireItemClicked(item);
                        handleItemClick(item.onClick);
                    }
                }, item.label);
            }))))), [
        visibleSections,
        handleItemClick,
        fireItemClicked
    ]);
    const renderTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(({ ref: ref, ...triggerProps })=>{
        const combinedRef = (element)=>{
            $de0fa36bebc71126$var$setRefValue(ref, element);
            setCustomiseSidebarTrigger === null || setCustomiseSidebarTrigger === void 0 || setCustomiseSidebarTrigger(element);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
            ...triggerProps,
            ref: combinedRef,
            appearance: "subtle",
            icon: (iconProps)=>iconColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
                    "data-testid": "hub-customize-menu-icon",
                    style: {
                        color: iconColor
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqpc))), iconProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqpc))), iconProps),
            label: formatMessage((0, $2AeNo.default).customizeMenuLabel),
            testId: "hub-customize-menu-trigger",
            onClick: handleToggle
        });
    }, [
        formatMessage,
        handleToggle,
        iconColor,
        setCustomiseSidebarTrigger
    ]);
    if (visibleSections.length === 0 || isMobile) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-end",
        shouldRenderToParent: true,
        content: renderContent,
        trigger: renderTrigger
    });
};
$de0fa36bebc71126$var$HubCustomizeMenuComponent.displayName = 'HubCustomizeMenu';
const $de0fa36bebc71126$export$1c1a3da435dd8e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo($de0fa36bebc71126$var$HubCustomizeMenuComponent);

});
parcelRegister("fBqpc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03d94757a5ce26f8391dae629241af48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5becb4e28c5595a$var$_react = $b5becb4e28c5595a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b5becb4e28c5595a$var$_iconNew = $b5becb4e28c5595a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b5becb4e28c5595a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/customize
 * Usage guidance:
 * Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5becb4e28c5595a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $b5becb4e28c5595a$var$_react.default.createElement($b5becb4e28c5595a$var$_iconNew.default, Object.assign({
        name: "CustomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.5 10.5V12H0v-1.5zM16 4v1.5H8.5V4zm-5.5 8.75h1v-3h-1zM13 10.5h3V12h-3v.875c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375v-3.25c0-.76.616-1.375 1.375-1.375h1.25c.76 0 1.375.616 1.375 1.375zM5.5 3.25h-1v3h1zM7 6.375c0 .76-.616 1.375-1.375 1.375h-1.25C3.615 7.75 3 7.134 3 6.375V5.5H0V4h3v-.875c0-.76.616-1.375 1.375-1.375h1.25C6.385 1.75 7 2.366 7 3.125z"/>`
    }, props));
$b5becb4e28c5595a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $b5becb4e28c5595a$var$_default = module.exports.default = $b5becb4e28c5595a$var$CustomizeIcon;

});

parcelRegister("fXKVz", function(module, exports) {
$parcel$export(module.exports, "useMediaQuery", () => $709e6478bfac1f18$export$32d5543ab307c01);

var $fc4bM = parcelRequire("fc4bM");

var $aYMdQ = parcelRequire("aYMdQ");
function $709e6478bfac1f18$export$32d5543ab307c01(query) {
    const [match, setMatch] = $fc4bM.useState(false);
    $fc4bM.useEffect(()=>{
        function screenTest(e) {
            setMatch(Boolean(e.matches));
        }
        if (window && Object.prototype.hasOwnProperty.call(window, 'matchMedia')) {
            const mql = window.matchMedia(query);
            /**
       * Trigger the screenTest even for the first call
       */ screenTest(mql);
            mql.addListener(screenTest);
            return ()=>{
                mql.removeListener(screenTest);
            };
        }
        return 0, $aYMdQ.noop;
    }, [
        query
    ]);
    return match;
}

});

parcelRegister("2AeNo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1077a4159944e55$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $f1077a4159944e55$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    csmRequestsListBannerText: {
        defaultMessage: 'My requests',
        description: 'Text for the banner in the csm requests list page',
        id: 'hub.csm.requests.list.banner.text.non-final'
    },
    customizeMenuLabel: {
        id: 'hub.routes.customize-menu.label',
        defaultMessage: 'Customize',
        description: 'Accessible label for the customize dropdown menu trigger button in the hub header.'
    },
    manageListViewButtonLabel: {
        id: 'hub.routes.jsm-requests-list.manage-list-view.button.label',
        defaultMessage: 'Manage list view',
        description: 'Label for the menu item in the customize dropdown that opens the manage columns sidebar on the JSM requests list page.'
    },
    loginAnnouncementButtonLabel: {
        id: 'hub.routes.homepage.login-announcement.button.label',
        defaultMessage: 'Add login page message',
        description: 'Label for the Hub Customize menu item that opens login announcement settings.'
    },
    helpCenterSectionHeading: {
        id: 'hub.routes.customize-menu.help-center-section.heading',
        defaultMessage: 'Help center',
        description: 'Heading for the group of the customize dropdown holding the site-wide help center entry points, which are the same on every page.'
    },
    editHelpCenterLabel: {
        id: 'hub.routes.customize-menu.edit-help-center.label',
        defaultMessage: 'Edit help center',
        description: 'Label for the customize dropdown menu item that opens the help center home page in the editor.'
    },
    editPortalPageLabel: {
        id: 'hub.routes.customize-menu.edit-portal-page.label',
        defaultMessage: 'Edit portal page',
        description: 'Label for the customize dropdown menu item that opens the current portal page in the editor.'
    },
    editPortalAnnouncementLabel: {
        id: 'hub.routes.customize-menu.edit-portal-announcement.label',
        defaultMessage: 'Edit portal announcement',
        description: 'Label for the customize dropdown menu item that opens the current portal page in the editor, shown to sites without Premium, where the announcement is the only part of a portal page they can change.'
    },
    editCustomPageLabel: {
        id: 'hub.routes.customize-menu.edit-custom-page.label',
        defaultMessage: 'Edit custom page',
        description: 'Label for the customize dropdown menu item that opens the current custom page in the editor.'
    },
    editTopicPageLabel: {
        id: 'hub.routes.customize-menu.edit-topic-page.label',
        defaultMessage: 'Edit topic page',
        description: 'Label for the customize dropdown menu item that opens the current topic page in the editor.'
    },
    viewAllHelpCentersLabel: {
        id: 'hub.routes.customize-menu.view-all-help-centers.label',
        defaultMessage: 'View all help centers',
        description: 'Label for the customize dropdown menu item that opens the help center management screen.'
    },
    createHelpCenterLabel: {
        id: 'hub.routes.customize-menu.create-help-center.label',
        defaultMessage: 'Create help center',
        description: 'Label for the customize dropdown menu item that opens the help center management screen with its create flow open.'
    },
    createCustomPageLabel: {
        id: 'hub.routes.customize-menu.create-custom-page.label',
        defaultMessage: 'Create custom page',
        description: 'Label for the customize dropdown menu item that opens the editor on the help center home page with the create page dialog open.'
    },
    premiumLozenge: {
        id: 'hub.routes.customize-menu.premium-lozenge',
        defaultMessage: 'Premium',
        description: 'Lozenge marking a customize menu item as a Premium feature, shown to sites that are not entitled to it.'
    },
    rovoAgentLabel: {
        id: 'hub.routes.customize-menu.rovo-agent.label',
        defaultMessage: 'Rovo agent',
        description: "Label for the customize dropdown menu item that opens the help center's Rovo agent settings."
    }
});

});



parcelRegister("6jJcK", function(module, exports) {
$parcel$export(module.exports, "HubHomepageCustomizeNavActions", () => (parcelRequire("ci8ys")).HubHomepageCustomizeNavActions);
parcelRequire("48zix");
var $ci8ys = parcelRequire("ci8ys");

});
parcelRegister("48zix", function(module, exports) {
$parcel$export(module.exports, "HubHomepageCustomizeNavActions", () => (parcelRequire("ci8ys")).HubHomepageCustomizeNavActions);

var $ci8ys = parcelRequire("ci8ys");

});
parcelRegister("ci8ys", function(module, exports) {
$parcel$export(module.exports, "HubHomepageCustomizeNavActions", () => $bb36bb133fe660ab$export$c0b4b03ead4d16ad);
/* hub-homepage-customize-nav-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("ieUrC");
var $euVUr = parcelRequire("euVUr");

var $jEubQ = parcelRequire("jEubQ");

var $k2M4v = parcelRequire("k2M4v");

var $eENmG = parcelRequire("eENmG");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $alVAg = parcelRequire("alVAg");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $kOWPe = parcelRequire("kOWPe");
var $bwpot = parcelRequire("bwpot");

var $1nlSb = parcelRequire("1nlSb");
parcelRequire("49Qlh");
var $6XxyH = parcelRequire("6XxyH");

var $6LH8a = parcelRequire("6LH8a");

var $8BDrU = parcelRequire("8BDrU");

var $2AeNo = parcelRequire("2AeNo");
parcelRequire("fVmVF");
var $jwtpI = parcelRequire("jwtpI");
parcelRequire("l40Sg");
var $2hO2y = parcelRequire("2hO2y");
const $bb36bb133fe660ab$var$sidebarContentStyles = null;
const $bb36bb133fe660ab$var$noop = ()=>undefined;
/**
 * With this on, the Customise menu reports the Login announcement click itself.
 */ const $bb36bb133fe660ab$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE = 'hubs_customize_menu_analytics';
const $bb36bb133fe660ab$var$isHubCustomizeMenuAnalyticsEnabled = ()=>(0, $k2M4v.default).checkGate($bb36bb133fe660ab$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE);
const $bb36bb133fe660ab$var$HubHomepageCustomizeNavActionsComponent = ({ iconColor: iconColor, canAdministerJIRA: canAdministerJIRA, setEditingHelpCenter: setEditingHelpCenter })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const triggerRef = (0, $bwpot.useCustomiseSidebarTriggerRef)();
    const { isOpen: isOpen, openFromMenu: openFromMenu, close: close } = (0, $2hO2y.useHubCustomizationSidebar)('login-announcement');
    const isSidebarOpen = canAdministerJIRA && isOpen;
    const helpCenterSection = (0, $jwtpI.useHelpCenterCustomizeSection)(canAdministerJIRA);
    $fc4bM.useEffect(()=>{
        setEditingHelpCenter(isSidebarOpen);
    }, [
        isSidebarOpen,
        setEditingHelpCenter
    ]);
    $fc4bM.useEffect(()=>()=>{
            setEditingHelpCenter(false);
        }, [
        setEditingHelpCenter
    ]);
    $fc4bM.useEffect(()=>{
        if (isOpen && !canAdministerJIRA) close();
    }, [
        canAdministerJIRA,
        close,
        isOpen
    ]);
    // With the gate on the menu reports this click itself, so only report it here
    // when the menu does not.
    const handleLoginAnnouncementClick = $fc4bM.useCallback(()=>{
        if (!$bb36bb133fe660ab$var$isHubCustomizeMenuAnalyticsEnabled()) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'customizeMenu',
            actionSubjectId: 'navbarLoginAnnouncement',
            analyticsType: (0, $eENmG.UI_EVENT_TYPE)
        }).fire();
        openFromMenu();
    }, [
        createAnalyticsEvent,
        openFromMenu
    ]);
    const items = $fc4bM.useMemo(()=>{
        if (!canAdministerJIRA) return [];
        const { helpCenterId: helpCenterId } = (0, $8BDrU.parseHelpCenterAri)((0, $6LH8a.getHelpCenterAri)());
        return [
            {
                label: formatMessage((0, $2AeNo.default).editHelpCenterLabel),
                testId: 'edit-hub-link',
                href: `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/edit-hub`,
                // Same id this item carried in the avatar menu, so its click
                // analytics survive the move.
                actionSubjectId: 'navbarCustomiseHub'
            },
            {
                label: formatMessage((0, $2AeNo.default).loginAnnouncementButtonLabel),
                testId: 'login-announcement-button',
                actionSubjectId: 'navbarLoginAnnouncement',
                onClick: handleLoginAnnouncementClick
            }
        ];
    }, [
        canAdministerJIRA,
        formatMessage,
        handleLoginAnnouncementClick
    ]);
    const sections = $fc4bM.useMemo(()=>[
            {
                items: items
            },
            helpCenterSection
        ].filter((section)=>Boolean(section)), [
        items,
        helpCenterSection
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $6XxyH.HubCustomizeMenu), {
        sections: sections,
        iconColor: iconColor
    }), isSidebarOpen ? /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).HELP_CENTER_CUSTOMIZE_LOGIN_ANNOUNCEMENT_SIDEBAR,
        id: "hub-login-announcement-sidebar",
        renderError: ()=>null
    }, /*#__PURE__*/ $fc4bM.createElement((0, $euVUr.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ $fc4bM.createElement((0, $kOWPe.LazyPushingCustomizeSidebar), {
        isOpen: isSidebarOpen,
        onOpen: $bb36bb133fe660ab$var$noop,
        onClose: close,
        triggerRef: triggerRef
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1nlSb.LazyHelpCenterBucketsRoutes), {
        isOpen: isSidebarOpen,
        onClose: close
    }))))) : null);
};
const $bb36bb133fe660ab$export$c0b4b03ead4d16ad = (0, $6umft.default)((state)=>({
        canAdministerJIRA: (0, $7RWiC.getCanAdministerJIRA)(state)
    }), {
    setEditingHelpCenter: (0, $alVAg.editingHelpCenter)
})($bb36bb133fe660ab$var$HubHomepageCustomizeNavActionsComponent);

});
parcelRegister("1nlSb", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterBucketsRoutes", () => $a9906d80cd33cc5a$export$d2d3e564d372d997);
// export HelpCenterBucketsRoutes from './bucket-routes';

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $a9906d80cd33cc5a$export$d2d3e564d372d997 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("iEKyf")), {
        moduleId: "./src/view/help-center-customize-sidebar/bucket-routes/bucket-routes.tsx"
    })
});

});
parcelRegister("iEKyf", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("d2xXR"),
    $9dnsd("4cJBF"),
    $9dnsd("VNsDq"),
    $9dnsd("5Tatj"),
    $9dnsd("047zo"),
    $9dnsd("jUsD2"),
    $9dnsd("6VzBn"),
    $9dnsd("6gN9a")
]).then(()=>parcelRequire('185W5'));

});


parcelRegister("8BDrU", function(module, exports) {
$parcel$export(module.exports, "parseHelpCenterAri", () => $855f28139ea73c7a$export$2b81f3445e8c13f4);
$parcel$export(module.exports, "getHelpCenterId", () => $855f28139ea73c7a$export$7ac65eebc1dbe637);
$parcel$export(module.exports, "createHelpCenterAri", () => $855f28139ea73c7a$export$dbcb6d0534e1f531);
// eslint-disable-next-line no-restricted-imports

var $4MoYu = parcelRequire("4MoYu");
const $855f28139ea73c7a$export$2b81f3445e8c13f4 = (helpCenterAri)=>{
    const isValidAri = (0, $4MoYu.HelpHelpCenterAri).check(helpCenterAri) && helpCenterAri !== 'null' && helpCenterAri !== '';
    return isValidAri ? (0, $4MoYu.HelpHelpCenterAri).parse(helpCenterAri) : {
        helpCenterId: ''
    };
};
const $855f28139ea73c7a$export$7ac65eebc1dbe637 = (helpCenterAri)=>{
    const { helpCenterId: helpCenterId } = $855f28139ea73c7a$export$2b81f3445e8c13f4(helpCenterAri);
    return helpCenterId;
};
const $855f28139ea73c7a$export$dbcb6d0534e1f531 = (activationId, helpCenterId)=>{
    if (!helpCenterId || !activationId || helpCenterId === 'null' || activationId === 'null') return '';
    return (0, $4MoYu.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
};

});

parcelRegister("fVmVF", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterCustomizeSection", () => (parcelRequire("jwtpI")).useHelpCenterCustomizeSection);

var $jwtpI = parcelRequire("jwtpI");

});
parcelRegister("jwtpI", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterCustomizeSection", () => $3ad2a47cc397b640$export$ed4a3420f731a7b1);

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");

var $7N9Wp = parcelRequire("7N9Wp");

var $bSHq3 = parcelRequire("bSHq3");

var $8BDrU = parcelRequire("8BDrU");

var $2AeNo = parcelRequire("2AeNo");
parcelRequire("dQHNq");
var $2RSI0 = parcelRequire("2RSI0");
const $3ad2a47cc397b640$export$ed4a3420f731a7b1 = (canAdministerJIRA)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const basePath = (0, $7N9Wp.useHubBasePath)();
    const shouldUpsellPremium = (0, $bSHq3.useShouldShowPremiumUpsell)();
    return (0, $fc4bM.useMemo)(()=>{
        if (!canAdministerJIRA) return null;
        const { helpCenterId: helpCenterId } = (0, $8BDrU.parseHelpCenterAri)((0, $6LH8a.getHelpCenterAri)());
        // Same check `hub-home` makes off this base path to pick its Rovo settings URL.
        const isInJira = basePath.startsWith('/jira');
        // Jira lists help centers at the base path itself; the help-center-hosted
        // screen lists them under /hubs.
        const managementUrl = isInJira ? basePath : `${basePath}/hubs`;
        // Both screens open their create flow from the same query param.
        const createHelpCenterUrl = `${managementUrl}?create=true`;
        const rovoAgentUrl = isInJira ? `${basePath}/${helpCenterId}/settings?tab=rovo-agent` : `${basePath}/${helpCenterId}/rovo-agent`;
        // Deliberately not built from `basePath`: there is no Jira-side editor route,
        // so this stays on the help-center-hosted path in both worlds — the same thing
        // every `edit-hub` URL in `hub-home` does. It always opens the hub home page,
        // per the design, even when triggered from another page.
        const createCustomPageUrl = `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/edit-hub?createPage=true`;
        // Premium-gated: these two upsell instead of navigating when the site is not
        // entitled, so an admin is not sent to a screen they cannot use.
        const createHelpCenter = shouldUpsellPremium ? {
            label: formatMessage((0, $2AeNo.default).createHelpCenterLabel),
            testId: 'create-help-center-upsell',
            // Same id as the entitled link, so both read as one option.
            actionSubjectId: 'navbarCreateHelpCenter',
            analyticsAttributes: {
                isPremiumUpsell: true,
                touchpointId: 'hubs-customise-menu-create-help-center'
            },
            onClick: ()=>undefined,
            customRenderer: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2RSI0.PremiumUpsellMenuItem), {
                    label: formatMessage((0, $2AeNo.default).createHelpCenterLabel),
                    testId: "create-help-center-upsell",
                    touchpointId: "hubs-customise-menu-create-help-center",
                    onClick: onClick
                })
        } : {
            label: formatMessage((0, $2AeNo.default).createHelpCenterLabel),
            testId: 'create-help-center-link',
            href: createHelpCenterUrl,
            actionSubjectId: 'navbarCreateHelpCenter'
        };
        const createCustomPage = shouldUpsellPremium ? {
            label: formatMessage((0, $2AeNo.default).createCustomPageLabel),
            testId: 'create-custom-page-upsell',
            actionSubjectId: 'navbarCreateCustomPage',
            analyticsAttributes: {
                isPremiumUpsell: true,
                touchpointId: 'hubs-customise-menu-create-custom-page'
            },
            onClick: ()=>undefined,
            customRenderer: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2RSI0.PremiumUpsellMenuItem), {
                    label: formatMessage((0, $2AeNo.default).createCustomPageLabel),
                    testId: "create-custom-page-upsell",
                    touchpointId: "hubs-customise-menu-create-custom-page",
                    onClick: onClick
                })
        } : {
            label: formatMessage((0, $2AeNo.default).createCustomPageLabel),
            testId: 'create-custom-page-link',
            href: createCustomPageUrl,
            actionSubjectId: 'navbarCreateCustomPage'
        };
        return {
            heading: formatMessage((0, $2AeNo.default).helpCenterSectionHeading),
            items: [
                {
                    label: formatMessage((0, $2AeNo.default).viewAllHelpCentersLabel),
                    testId: 'view-all-help-centers-link',
                    href: managementUrl,
                    actionSubjectId: 'navbarViewAllHelpCenters'
                },
                createHelpCenter,
                createCustomPage,
                {
                    label: formatMessage((0, $2AeNo.default).rovoAgentLabel),
                    testId: 'rovo-agent-link',
                    href: rovoAgentUrl,
                    actionSubjectId: 'navbarRovoAgent'
                }
            ]
        };
    }, [
        canAdministerJIRA,
        formatMessage,
        basePath,
        shouldUpsellPremium
    ]);
};

});
parcelRegister("7N9Wp", function(module, exports) {
$parcel$export(module.exports, "useHubBasePath", () => $08ab12924adbf5f9$export$eadd097d221d05e6);
/**
 * `useHubBasePath` — resolves the effective base path used to build
 * internal SPA URLs inside `HubHomeContent` and its sub-tree.
 *
 * Returns `/jira/helpcenter-management` when the
 * `jira_sidebar_show_helpcenter` experiment is enabled (i.e. the
 * Jira-embedded route is active), and falls back to
 * `/helpcenter-management` otherwise — the historical value used
 * before this hook existed, so pre-existing hosts see no
 * behavioural change.
 */ 
var $bcN2K = parcelRequire("bcN2K");
const $08ab12924adbf5f9$export$eadd097d221d05e6 = ()=>{
    return (0, $bcN2K.isExperimentEnabled)('jira_sidebar_show_helpcenter') ? '/jira/helpcenter-management' : '/helpcenter-management';
};

});
parcelRegister("bcN2K", function(module, exports) {
$parcel$export(module.exports, "isExperimentEnabled", () => $f2d5b6c6168b25f1$export$336b018592dc9972);

var $8EvCx = parcelRequire("8EvCx");
function $f2d5b6c6168b25f1$export$336b018592dc9972(experimentName) {
    return (0, $8EvCx.expVal)(experimentName, 'isEnabled', false) === true;
}

});


parcelRegister("bSHq3", function(module, exports) {
$parcel$export(module.exports, "useShouldShowPremiumUpsell", () => $7565f450ffeb308b$export$c54b4589f088dfd2);
/**
 * Whether this tenant should get the un-entitled treatment for Premium-gated hub
 * features — a locked editor, an upsell in place of controls, and so on.
 *
 * `=== false`, not `!isPremiumEntitled`: the flag is tri-state and `undefined`
 * means "unknown", which must never lock anything — that would take paid
 * features away from entitled customers.
 *
 * Help hubs only. `hubType` comes from the bootstrap query rather than `envJson`,
 * so it is reliable in both the view and edit experiences — Customer Service
 * (`CUSTOMER_SERVICE`) hubs are never affected regardless of how they were routed.
 *
 * Reads `HubContext` rather than `useProductDependencies`, which is only mounted
 * around hub *extensions*, not the editor or its config panels.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $aQNcS = parcelRequire("aQNcS");
const $7565f450ffeb308b$export$c54b4589f088dfd2 = ()=>{
    const ctx = (0, $fc4bM.useContext)((0, $aQNcS.HubContext));
    if (!ctx) // e.g. Confluence Company Hub — never lock.
    return false;
    if (ctx.hubType !== 'HELP_HUB') return false;
    return ctx.isPremiumEntitled === false && (0, $dRkX9.fg)('hubs_premium_upsell');
};

});
parcelRegister("aQNcS", function(module, exports) {
$parcel$export(module.exports, "getMediaProvider", () => $d0eb6240bd9a643d$export$98e696b66f6bbf2b);
$parcel$export(module.exports, "HubContext", () => $d0eb6240bd9a643d$export$6a5aa704056d141b);
$parcel$export(module.exports, "useHubContext", () => $d0eb6240bd9a643d$export$ac8576a9912be18c);

var $fc4bM = parcelRequire("fc4bM");

var $4MoYu = parcelRequire("4MoYu");
var $gK5mb = parcelRequire("gK5mb");
const $d0eb6240bd9a643d$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $d0eb6240bd9a643d$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl, isUploadMediaConfigRequired)=>{
    const authProvider = $d0eb6240bd9a643d$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl);
    return {
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: authProvider,
            useSha256ForUploads: true
        },
        ...isUploadMediaConfigRequired && {
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        }
    };
};
const $d0eb6240bd9a643d$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $d0eb6240bd9a643d$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $d0eb6240bd9a643d$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $gK5mb.HelpPageAri).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $d0eb6240bd9a643d$export$6a5aa704056d141b = (0, $fc4bM.createContext)(null);
const $d0eb6240bd9a643d$export$ac8576a9912be18c = ()=>{
    const context = (0, $fc4bM.useContext)($d0eb6240bd9a643d$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};

});


parcelRegister("dQHNq", function(module, exports) {
$parcel$export(module.exports, "PremiumUpsellMenuItem", () => (parcelRequire("2RSI0")).PremiumUpsellMenuItem);

var $2RSI0 = parcelRequire("2RSI0");

});
parcelRegister("2RSI0", function(module, exports) {
$parcel$export(module.exports, "PremiumUpsellMenuItem", () => $9052cda63c657a94$export$b4d4b513f166a4a2);

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $k2M4v = parcelRequire("k2M4v");

var $euRd1 = parcelRequire("euRd1");

var $eaozo = parcelRequire("eaozo");

var $lh6uV = parcelRequire("lh6uV");

var $cJsi5 = parcelRequire("cJsi5");

var $asC5r = parcelRequire("asC5r");

var $kJiHZ = parcelRequire("kJiHZ");

var $2AeNo = parcelRequire("2AeNo");
/**
 * Has the item report its exposure when the Customise menu opens.
 */ const $9052cda63c657a94$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE = 'hubs_customize_menu_analytics';
const $9052cda63c657a94$var$isHubCustomizeMenuAnalyticsEnabled = ()=>(0, $k2M4v.default).checkGate($9052cda63c657a94$var$HUBS_CUSTOMIZE_MENU_ANALYTICS_GATE);
const $9052cda63c657a94$export$b4d4b513f166a4a2 = ({ label: label, testId: testId, touchpointId: touchpointId, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    // `ModalTrigger` does not emit the trigger analytics the legacy trigger did, so
    // the surface reports its own view and click for parity with the other upsell
    // entry points, which is what lets the upsell funnel count this exposure.
    const fireTriggerEvent = (0, $fc4bM.useCallback)((action)=>{
        createAnalyticsEvent({
            action: action,
            eventType: 'ui',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                touchpointId: touchpointId,
                product: 'jira-service-management',
                variantId: 'help-center-customization',
                source: 'hubCustomizeMenu'
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        touchpointId
    ]);
    // The item only mounts while the menu is open, so mounting is the view.
    (0, $fc4bM.useEffect)(()=>{
        if ($9052cda63c657a94$var$isHubCustomizeMenuAnalyticsEnabled()) fireTriggerEvent('viewed');
    }, [
        fireTriggerEvent
    ]);
    const fireTriggerClicked = (0, $fc4bM.useCallback)(()=>{
        fireTriggerEvent('clicked');
        onClick === null || onClick === void 0 || onClick();
    }, [
        fireTriggerEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).HELP_CENTER,
        id: `hub-customize-menu-${touchpointId}`,
        // A broken upsell must not take the rest of the menu with it.
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $asC5r.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kJiHZ.ModalTrigger), {
        entryPoint: (0, $cJsi5.editionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: (0, $6LH8a.getCloudId)(),
            product: 'jira-service-management'
        },
        entryPointProps: {
            touchpointId: touchpointId,
            variantId: 'help-center-customization'
        },
        modalProps: (0, $lh6uV.MODAL_CONFIG)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
            ref: ref,
            testId: testId,
            onClick: fireTriggerClicked,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                appearance: "discovery"
            }, formatMessage((0, $2AeNo.default).premiumLozenge))
        }, label))));
};

});




parcelRegister("l40Sg", function(module, exports) {
$parcel$export(module.exports, "useHubCustomizationSidebar", () => (parcelRequire("2hO2y")).useHubCustomizationSidebar);

var $2hO2y = parcelRequire("2hO2y");

});
parcelRegister("2hO2y", function(module, exports) {
$parcel$export(module.exports, "useHubCustomizationSidebar", () => $e593285491923898$export$8e00b7528696d00);

var $fc4bM = parcelRequire("fc4bM");

var $6rayQ = parcelRequire("6rayQ");

var $bzsGe = parcelRequire("bzsGe");
parcelRequire("gcRsK");
var $dJF35 = parcelRequire("dJF35");
const $e593285491923898$export$8e00b7528696d00 = (experience)=>{
    const queryParams = (0, $dJF35.useQueryParams)();
    const isOpen = queryParams.customize === 'true' && queryParams.experience === experience;
    const openFromMenu = (0, $fc4bM.useCallback)(()=>{
        (0, $6rayQ.set)({
            experience: experience,
            customize: 'true'
        }, false);
    }, [
        experience
    ]);
    const close = (0, $fc4bM.useCallback)(()=>{
        (0, $bzsGe.clearSidebarExperienceAndCustomize)();
    }, []);
    return {
        isOpen: isOpen,
        openFromMenu: openFromMenu,
        close: close
    };
};

});





parcelRegister("545kt", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeNavActions", () => (parcelRequire("2kcEp")).HubCustomizeNavActions);

var $2kcEp = parcelRequire("2kcEp");

});
parcelRegister("2kcEp", function(module, exports) {
$parcel$export(module.exports, "HubCustomizeNavActions", () => $86ce330e052998a7$export$9fc791ebb5bc4121);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $k2M4v = parcelRequire("k2M4v");

var $gioQl = parcelRequire("gioQl");

var $9mazR = parcelRequire("9mazR");

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $bSHq3 = parcelRequire("bSHq3");

var $jWHud = parcelRequire("jWHud");

var $8BDrU = parcelRequire("8BDrU");

var $hRcQs = parcelRequire("hRcQs");

var $9INjF = parcelRequire("9INjF");
parcelRequire("49Qlh");
var $6XxyH = parcelRequire("6XxyH");

var $2AeNo = parcelRequire("2AeNo");
parcelRequire("fVmVF");
var $jwtpI = parcelRequire("jwtpI");
parcelRequire("47FF7");
var $eYCcg = parcelRequire("eYCcg");
const $86ce330e052998a7$var$HubCustomizeNavActionsComponent = ({ iconColor: iconColor, pageType: pageType, canAdministerJIRA: canAdministerJIRA, fetchPortal: fetchPortal, isProjectAdmin: isProjectAdmin, isProjectSimplified: isProjectSimplified, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [{ match: match }] = (0, $7lAXH.useRouter)();
    const helpCenterSection = (0, $jwtpI.useHelpCenterCustomizeSection)(canAdministerJIRA);
    const portalSettingsEnabled = (0, $k2M4v.default).checkGate('hubs-show-portal-settings');
    const shouldUpsellPremium = (0, $bSHq3.useShouldShowPremiumUpsell)();
    const { portalId: portalId, id: id } = match.params;
    // Topic pages share the custom page route, so the item is only labelled for
    // the page it actually opens once the page's type is known.
    const isTopicPage = (0, $eYCcg.useIsTopicPage)(pageType === (0, $jWHud.HubPageType).CUSTOM ? id : undefined);
    $fc4bM.useEffect(()=>{
        if (!canAdministerJIRA || pageType !== (0, $jWHud.HubPageType).PORTAL || !portalId || typeof isProjectAdmin === 'boolean' && typeof isProjectSimplified === 'boolean' && typeof projectKey === 'string') return;
        const portalIdAsNumber = Number(portalId);
        if (Number.isSafeInteger(portalIdAsNumber)) fetchPortal({
            id: portalIdAsNumber
        });
    }, [
        canAdministerJIRA,
        fetchPortal,
        isProjectSimplified,
        isProjectAdmin,
        pageType,
        portalId,
        projectKey
    ]);
    const editSection = $fc4bM.useMemo(()=>{
        if (!canAdministerJIRA) return null;
        // A page-specific route missing its own id falls back to Edit help center
        // rather than linking to whichever page the stale param belonged to.
        let label = formatMessage((0, $2AeNo.default).editHelpCenterLabel);
        let suffix = '';
        if (pageType === (0, $jWHud.HubPageType).PORTAL && portalId) {
            // Same editor either way, but Free and Standard sites can only change the
            // announcement on a portal page, so the item promises only that.
            label = formatMessage(shouldUpsellPremium ? (0, $2AeNo.default).editPortalAnnouncementLabel : (0, $2AeNo.default).editPortalPageLabel);
            suffix = `/portal/${portalId}`;
        } else if (pageType === (0, $jWHud.HubPageType).CUSTOM && id) {
            label = formatMessage(isTopicPage ? (0, $2AeNo.default).editTopicPageLabel : (0, $2AeNo.default).editCustomPageLabel);
            suffix = `/${id}`;
        }
        const { helpCenterId: helpCenterId } = (0, $8BDrU.parseHelpCenterAri)((0, $6LH8a.getHelpCenterAri)());
        const normalizedProjectKey = typeof projectKey === 'string' ? projectKey.toUpperCase() : undefined;
        const isPortalAdmin = pageType === (0, $jWHud.HubPageType).PORTAL && isProjectAdmin && normalizedProjectKey && typeof isProjectSimplified === 'boolean';
        return {
            items: [
                {
                    label: label,
                    testId: 'edit-hub-link',
                    href: `${(0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/edit-hub${suffix}`,
                    // Same id this item carried in the avatar menu, so its click
                    // analytics survive the move.
                    actionSubjectId: 'navbarCustomiseHub'
                },
                ...isPortalAdmin && portalSettingsEnabled ? [
                    {
                        label: formatMessage((0, $9INjF.default).configurePortal),
                        testId: 'configure-portal-link',
                        href: `${(0, $gioQl.getNextgenSettingsUrl)(normalizedProjectKey)}/${isProjectSimplified ? 'channels/portal-settings' : 'portal-settings'}`,
                        actionSubjectId: 'navbarConfigurePortal',
                        target: '_blank'
                    },
                    {
                        label: formatMessage((0, $9INjF.default).customizeRequestTypes),
                        testId: 'customize-request-types-link',
                        href: isProjectSimplified ? (0, $gioQl.getNextgenSettingsRequestTypesUrl)(normalizedProjectKey) : `${(0, $gioQl.getNextgenSettingsUrl)(normalizedProjectKey)}/request-types/`,
                        actionSubjectId: 'navbarCustomizeRequestTypes',
                        target: '_blank'
                    }
                ] : [],
                ...isPortalAdmin ? [
                    {
                        label: formatMessage((0, $hRcQs.default).managePortalGroupsLabel),
                        testId: 'manage-portal-groups-link',
                        href: isProjectSimplified ? (0, $gioQl.getTeamManagedPortalGroupSettingsUrl)(normalizedProjectKey) : (0, $gioQl.getPortalGroupSettingsUrl)(normalizedProjectKey),
                        actionSubjectId: 'managePortalGroupsButton'
                    }
                ] : []
            ]
        };
    }, [
        canAdministerJIRA,
        formatMessage,
        id,
        isTopicPage,
        portalSettingsEnabled,
        pageType,
        portalId,
        isProjectSimplified,
        isProjectAdmin,
        projectKey,
        shouldUpsellPremium
    ]);
    const sections = $fc4bM.useMemo(()=>[
            editSection,
            helpCenterSection
        ].filter((section)=>Boolean(section)), [
        editSection,
        helpCenterSection
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6XxyH.HubCustomizeMenu), {
        sections: sections,
        iconColor: iconColor
    });
};
const $86ce330e052998a7$var$ConnectedHubCustomizeNavActions = (0, $6umft.default)((state, { routePortalId: routePortalId })=>{
    const portalIdAsNumber = routePortalId !== undefined ? Number(routePortalId) : undefined;
    return {
        canAdministerJIRA: (0, $7RWiC.getCanAdministerJIRA)(state),
        isProjectAdmin: (0, $9D9SX.getCanAdministerProject)(state, portalIdAsNumber),
        isProjectSimplified: (0, $9D9SX.getIsProjectSimplified)(state, portalIdAsNumber),
        projectKey: (0, $9D9SX.getProjectKey)(state, portalIdAsNumber)
    };
}, {
    fetchPortal: (0, $hijaX.fetchPortalAction)
})($86ce330e052998a7$var$HubCustomizeNavActionsComponent);
const $86ce330e052998a7$export$9fc791ebb5bc4121 = (props)=>{
    const [{ match: match }] = (0, $7lAXH.useRouter)();
    const routePortalId = typeof match.params.portalId === 'string' ? match.params.portalId : undefined;
    return /*#__PURE__*/ $fc4bM.createElement($86ce330e052998a7$var$ConnectedHubCustomizeNavActions, {
        ...props,
        routePortalId: routePortalId
    });
};

});
parcelRegister("47FF7", function(module, exports) {
$parcel$export(module.exports, "useIsTopicPage", () => (parcelRequire("eYCcg")).useIsTopicPage);

var $eYCcg = parcelRequire("eYCcg");

});
parcelRegister("eYCcg", function(module, exports) {
$parcel$export(module.exports, "useIsTopicPage", () => $e3cac314ab0264a5$export$f5e07d18b80097b8);

var $9y9iE = parcelRequire("9y9iE");

var $fc4bM = parcelRequire("fc4bM");

var $3BZyK = parcelRequire("3BZyK");

var $k2M4v = parcelRequire("k2M4v");

var $gK5mb = parcelRequire("gK5mb");

var $6LH8a = parcelRequire("6LH8a");
const $e3cac314ab0264a5$var$TopicPagesQuery = (0, $9y9iE.default);
// Same gate the navbar's Topics menu and the editor's Topics panel read: with it
// off a hub has no topic pages, so there is nothing to look up.
const $e3cac314ab0264a5$var$HUBS_TOPICS_GATE = 'hubs_premium_upsell';
const $e3cac314ab0264a5$var$isTopicsEnabled = ()=>(0, $k2M4v.default).checkGate($e3cac314ab0264a5$var$HUBS_TOPICS_GATE);
const $e3cac314ab0264a5$var$EMPTY_TOPIC_PAGE_IDS = [];
const $e3cac314ab0264a5$var$getPageIdFromAri = (pageAri)=>{
    try {
        const parsed = (0, $gK5mb.HelpPageAri).parse(pageAri);
        return parsed.pageId;
    } catch  {
        return null;
    }
};
const $e3cac314ab0264a5$export$f5e07d18b80097b8 = (pageId)=>{
    const environment = (0, $3BZyK.useRelayEnvironment)();
    const [topicPageIds, setTopicPageIds] = (0, $fc4bM.useState)($e3cac314ab0264a5$var$EMPTY_TOPIC_PAGE_IDS);
    const cloudId = (0, $6LH8a.getCloudId)();
    const helpCenterAri = (0, $6LH8a.getHelpCenterAri)();
    (0, $fc4bM.useEffect)(()=>{
        if (!pageId || !cloudId || !helpCenterAri || !$e3cac314ab0264a5$var$isTopicsEnabled()) return;
        const subscription = (0, $3BZyK.fetchQuery)(environment, $e3cac314ab0264a5$var$TopicPagesQuery, // View mode always renders published content, and passing `isDraft`
        // explicitly keeps the arguments identical to `navLinksQuery`'s, which
        // is what lets this resolve from the store.
        {
            cloudId: cloudId,
            hubAri: helpCenterAri,
            isDraft: false
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                var _data$helpCenter;
                const helpCenterById = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
                if ((helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.__typename) !== 'HelpCenter') return;
                setTopicPageIds((helpCenterById.topicPages ?? []).map((page)=>page !== null && page !== void 0 && page.id ? $e3cac314ab0264a5$var$getPageIdFromAri(page.id) : null).filter((id)=>id !== null));
            },
            // Nothing to recover: the menu keeps the custom page label, which is
            // what it shows for every page of this route today.
            error: ()=>setTopicPageIds($e3cac314ab0264a5$var$EMPTY_TOPIC_PAGE_IDS)
        });
        return ()=>subscription.unsubscribe();
    }, [
        cloudId,
        environment,
        helpCenterAri,
        pageId
    ]);
    return !!pageId && topicPageIds.includes(pageId);
};

});
parcelRegister("9y9iE", function(module, exports) {
$parcel$export(module.exports, "default", () => $4205c8bf8af4c057$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d52be667a26174d3523663c1159cb1f0>>
 * @relayHash 8c98fb75af10eba733df196552019aca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3971ebc68ae273d86e6d6a0691f1354685a419f21cba1e62dd711eea6d067b2a
const $4205c8bf8af4c057$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hubAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "topicPages",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "ids": [],
                            "type": "TOPIC"
                        }
                    }
                ],
                "concreteType": "HelpCenterPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": v4 /*: any*/ ,
                "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsTopicPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsTopicPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3971ebc68ae273d86e6d6a0691f1354685a419f21cba1e62dd711eea6d067b2a",
            "metadata": {},
            "name": "useIsTopicPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4205c8bf8af4c057$var$node.hash = "5ae91eb56209fb8899ab523142eaf60d";
var $4205c8bf8af4c057$export$2e2bcd8739ae039 = $4205c8bf8af4c057$var$node;

});





parcelRegister("9E84G", function(module, exports) {
$parcel$export(module.exports, "createHubHomepageRoute", () => $f340f7a8553acd53$export$5dafaf7a5091e51);
$parcel$export(module.exports, "createHubCustomPageRoute", () => $f340f7a8553acd53$export$394540a667e798bf);
$parcel$export(module.exports, "createHubPortalPageRoute", () => $f340f7a8553acd53$export$c7ef2adac2336d4a);
$parcel$export(module.exports, "createRouteWithHubShell", () => $f340f7a8553acd53$export$bf7b7ea558d32a05);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");

var $dRkX9 = parcelRequire("dRkX9");

var $d7r8x = parcelRequire("d7r8x");

var $pMGlN = parcelRequire("pMGlN");

var $hculA = parcelRequire("hculA");

var $jqBmw = parcelRequire("jqBmw");

var $c9FA9 = parcelRequire("c9FA9");

var $4NHoX = parcelRequire("4NHoX");

var $fok6N = parcelRequire("fok6N");

var $gYdLJ = parcelRequire("gYdLJ");

var $gOXJv = parcelRequire("gOXJv");

var $56E0t = parcelRequire("56E0t");

var $2VPly = parcelRequire("2VPly");

var $2JK5q = parcelRequire("2JK5q");

var $eW4ml = parcelRequire("eW4ml");
const $f340f7a8553acd53$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc",
    root: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _1tke1osq _1bsb1osq"
};
const $f340f7a8553acd53$export$74c90840fe177d0a = {
    component: (0, $2VPly.HubApp),
    exact: true,
    name: (0, $eW4ml.HUB_ROUTE_NAME),
    resources: [
        (0, $gOXJv.hubBootstrapResource),
        (0, $gOXJv.hubPageResource)
    ],
    path: (0, $dRkX9.fg)('enable-ssr-for-hubs') ? (0, $eW4ml.HUB_ROUTE_PATH_OPTIONAL_SLASH) : (0, $eW4ml.HUB_ROUTE_PATH)
};
const $f340f7a8553acd53$export$ccad182393585435 = {
    component: (0, $2VPly.HubApp),
    exact: true,
    name: (0, $eW4ml.HUB_CUSTOM_PAGE_ROUTE_NAME),
    resources: [
        (0, $gOXJv.hubBootstrapResource),
        (0, $gOXJv.hubPageResource)
    ],
    path: (0, $eW4ml.HUB_CUSTOM_PAGE_ROUTE_PATH)
};
/**
 * Whether to preload `rovoWidgetProviderQuery` as a route resource.
 *
 * Skipped once `hubs_rovo_config_from_kosh` is on, because `hubQuery` then carries `rovoConfig`
 * (served by help-kosh from convo-ai's licence-independent resolver) and is the only source of
 * truth. The callout banner skips its own lazy load off the same gate, so with the gate on this
 * query does not run at all — including when help-kosh resolves the field to null, which is its
 * answer rather than a reason to ask again.
 */ const $f340f7a8553acd53$var$shouldPreloadRovoWidgetQuery = ()=>(0, $dRkX9.fg)('hub_preload_rovo_widget_query') && !(0, $dRkX9.fg)('hubs_rovo_config_from_kosh');
const $f340f7a8553acd53$var$shouldPreloadNavigationBarQuery = (hubAppProps)=>{
    var _hubAppProps$featureF;
    return (0, $dRkX9.fg)('hub_preload_navigation_bar_query') && ((_hubAppProps$featureF = hubAppProps.featureFlags) === null || _hubAppProps$featureF === void 0 ? void 0 : _hubAppProps$featureF.hub_component_upgrade) === true;
};
const $f340f7a8553acd53$var$getHubRouteResources = (resources, hubAppProps)=>[
        ...resources,
        ...$f340f7a8553acd53$var$shouldPreloadNavigationBarQuery(hubAppProps) ? [
            (0, $gOXJv.createNavigationBarResource)(hubAppProps)
        ] : [],
        ...$f340f7a8553acd53$var$shouldPreloadRovoWidgetQuery() ? [
            (0, $gOXJv.rovoWidgetResource)
        ] : []
    ];
const $f340f7a8553acd53$export$5dafaf7a5091e51 = (hubAppProps)=>{
    const HubAppComponent = ()=>{
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2VPly.HubApp), {
            ...hubAppProps,
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$f340f7a8553acd53$export$74c90840fe177d0a,
        component: HubAppComponent,
        resources: $f340f7a8553acd53$var$getHubRouteResources($f340f7a8553acd53$export$74c90840fe177d0a.resources, hubAppProps)
    };
};
const $f340f7a8553acd53$export$8b1ac9e5cb498cd8 = ()=>{
    const hubRoute = $f340f7a8553acd53$export$5dafaf7a5091e51((0, $jqBmw.mockHubRouteProps));
    return {
        ...hubRoute,
        path: (0, $eW4ml.HUB_PREVIEW_ROUTE_PATH),
        name: (0, $eW4ml.HUB_PREVIEW_ROUTE_NAME)
    };
};
const $f340f7a8553acd53$export$394540a667e798bf = (hubAppProps)=>{
    const HubCustomPageComponent = ({ match: match })=>{
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2VPly.HubApp), {
            ...hubAppProps,
            customPageBreadcrumbPath: match.url,
            showPageNameAsHubDocumentTitle: true,
            showCustomPageBreadcrumbs: true
        });
    };
    return {
        ...$f340f7a8553acd53$export$ccad182393585435,
        component: HubCustomPageComponent,
        resources: $f340f7a8553acd53$var$getHubRouteResources($f340f7a8553acd53$export$ccad182393585435.resources, hubAppProps)
    };
};
const $f340f7a8553acd53$export$c6260de3189c8f50 = {
    component: (0, $2VPly.HubApp),
    exact: true,
    name: (0, $eW4ml.HUB_PORTAL_PAGE_ROUTE_NAME),
    resources: [
        (0, $gOXJv.hubBootstrapResource),
        (0, $gOXJv.hubPageResource)
    ],
    path: (0, $eW4ml.HUB_PORTAL_PAGE_ROUTE_PATH)
};
const $f340f7a8553acd53$export$c7ef2adac2336d4a = (hubAppProps)=>{
    const HubPortalPageComponent = ({ match: match })=>{
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2VPly.HubApp), {
            ...hubAppProps,
            portalBreadcrumbPath: match.url,
            showPageNameAsHubDocumentTitle: true,
            showPortalBreadcrumbs: true
        });
    };
    return {
        ...$f340f7a8553acd53$export$c6260de3189c8f50,
        component: HubPortalPageComponent,
        resources: $f340f7a8553acd53$var$getHubRouteResources($f340f7a8553acd53$export$c6260de3189c8f50.resources, hubAppProps)
    };
};
const $f340f7a8553acd53$export$bf7b7ea558d32a05 = (hubAppProps, InnerComponent, path, name, resources, componentWidth, options)=>{
    const Component = ()=>{
        const { queryReference: hubBootstrapQueryReference } = (0, $56E0t.useRelayResource)((0, $gOXJv.hubBootstrapResource));
        if (!hubBootstrapQueryReference) return null;
        const InnerComponentWithRouter = (0, $7tc2B.withRouter)(InnerComponent);
        const ComponentWithBannerBackgroundColor = (0, $2JK5q.withBannerBackgroundColor)(InnerComponentWithRouter);
        const cloudId = hubBootstrapQueryReference.variables.cloudId;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $pMGlN.default), {
            name: "hub-shell",
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fok6N.HubErrorBoundary), {
                shouldForceError: true,
                id: "route-with-hub-shell",
                packageName: "@atlassian/hub",
                fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $c9FA9.GenericErrorPage), {}),
                operationNames: [
                    'hubBootstrapWrapperQuery'
                ],
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
                    fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                        name: "hub-shell-loader",
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            className: (0, $2R2iS.default)([
                                $f340f7a8553acd53$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                                size: 'large'
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4NHoX.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        ...hubAppProps,
                        cloudId: cloudId,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gYdLJ.HubAppShell), {
                            hideNavbar: options === null || options === void 0 ? void 0 : options.hideNavbar,
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                style: {
                                    maxWidth: (0, $2JK5q.getContentWidth)(componentWidth)
                                },
                                className: (0, $2R2iS.default)([
                                    $f340f7a8553acd53$var$styles.root
                                ]),
                                children: /*#__PURE__*/ (0, $3LM7S.jsx)(ComponentWithBannerBackgroundColor, {})
                            })
                        })
                    })
                })
            })
        });
    };
    return {
        component: Component,
        exact: true,
        name: name,
        path: path,
        resources: [
            (0, $gOXJv.hubBootstrapResource),
            ...resources
        ]
    };
};

});
parcelRegister("jqBmw", function(module, exports) {
$parcel$export(module.exports, "mockHubRouteProps", () => $a1e2dd9de971b390$export$427679abd9cc3708);

var $fc4bM = parcelRequire("fc4bM");
const $a1e2dd9de971b390$export$60332b2344f7fe41 = ({ url: url = '', onError: onError = (_error)=>{}, children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": `smart-card-${url}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("button", {
        onClick: ()=>onError({
                status: 'not_found'
            })
    }, "Trigger not_found error status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("button", {
        onClick: ()=>onError({
                status: 'unauthorized'
            })
    }, "Trigger unauthorized error status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("button", {
        onClick: ()=>onError({
                status: 'forbidden'
            })
    }, "Trigger forbidden error status"), children);
const $a1e2dd9de971b390$export$7b5e1b7f9a325b6 = $a1e2dd9de971b390$export$60332b2344f7fe41;
const $a1e2dd9de971b390$export$2e4ce4ce734f69e1 = ({ primary: primary = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, primary.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: name
        }, "Primary metadata: ", name)));
const $a1e2dd9de971b390$export$50a6a2d597e669c = ({ children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, "CustomBlock", children);
const $a1e2dd9de971b390$export$fff1c9c894fd3e9c = ({ overrideUrl: overrideUrl = 'NONE' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, "Preview: ", overrideUrl);
const $a1e2dd9de971b390$export$ababd1478ac17bc0 = ({ text: text = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, "Snippet: ", text);
const $a1e2dd9de971b390$export$ccf187e9bb6e68c = ({ metadata: metadata = [], text: text = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, !!text ? text : 'TitleBlock', metadata.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: name
        }, "Metadata: ", name)));
const $a1e2dd9de971b390$export$427679abd9cc3708 = {
    actions: {
        onLogoutClick: ()=>({
                type: 'epic.logout.LOG_OUT'
            })
    },
    env: {
        cloudId: '17554ffe-ef18-4562-8222-e295e81a46bb',
        helpCenterAri: 'ari:cloud:help::help-center/5b32ba66-fea2-4010-893d-278bfac050bc/5e67e6f9-7753-41fa-811b-55cb9fd71897',
        helpCenterId: '5e67e6f9-7753-41fa-811b-55cb9fd71897',
        hoistedProjectKey: 'TR',
        hubEditMode: false,
        jiraDisplayUrl: '/',
        relativeBaseUrl: '/'
    },
    layout: {
        bannerText: '',
        isAnonymousRoute: false,
        showBanner: false
    },
    user: {
        avatarSrc: '',
        displayName: 'test_name',
        email: 'test@atlassian.com',
        id: 'some_random_id',
        isJiraAdmin: false
    }
};

});

parcelRegister("c9FA9", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => $b4cee6edc9d0dc3a$export$5d76009b056f3e5d);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");

var $1hJdJ = parcelRequire("1hJdJ");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $jm6ya = parcelRequire("jm6ya");

var $2ehvl = parcelRequire("2ehvl");
const $b4cee6edc9d0dc3a$var$styles = {
    image: "_1bsbclpc",
    root: "_4t3i1osq _n3tdxncg",
    content: "_y3gn1h6o _p12f1dup"
};
const $b4cee6edc9d0dc3a$export$5d76009b056f3e5d = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $b4cee6edc9d0dc3a$var$styles.root
    }, /*#__PURE__*/ $fc4bM.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jm6ya))),
        alt: "error page",
        className: (0, $2R2iS.default)([
            $b4cee6edc9d0dc3a$var$styles.image
        ])
    }), /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $b4cee6edc9d0dc3a$var$styles.content
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        size: "xlarge"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2ehvl.default).genericErrorHeading)), /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $2ehvl.default).genericErrorDescription)))));
};

});
parcelRegister("jm6ya", function(module, exports) {
module.exports = new URL("../images/error-icon.fcea7b28.svg", import.meta.url).toString();

});

parcelRegister("2ehvl", function(module, exports) {
$parcel$export(module.exports, "default", () => $171c7617551c61ba$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $171c7617551c61ba$var$_default_1 = (0, $8p5Cv.defineMessages)({
    genericErrorHeading: {
        id: 'company-hub.generic-error-page.heading',
        defaultMessage: "We're on it",
        description: 'The text is shown as the main heading on the generic error page displayed when an unexpected error occurs in a Company Hub page, reassuring users that the issue is being addressed.'
    },
    genericErrorDescription: {
        id: 'company-hub.generic-error-page.description',
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'The text is shown as the body paragraph on the generic error page in Company Hub, explaining to users that an unexpected error occurred and the team is working to restore functionality.'
    }
});
var $171c7617551c61ba$export$2e2bcd8739ae039 = $171c7617551c61ba$var$_default_1;

});


parcelRegister("4NHoX", function(module, exports) {
$parcel$export(module.exports, "HubBootstrap", () => $a1bdae8a76fc4cab$export$caae1ac058a7a032);
$parcel$export(module.exports, "HubBootstrapWrapper", () => $a1bdae8a76fc4cab$export$5f7521758ed90a1b);

var $dhrtT = parcelRequire("dhrtT");

var $GFVNQ = parcelRequire("GFVNQ");

var $alGyR = parcelRequire("alGyR");

var $fc4bM = parcelRequire("fc4bM");

var $3BZyK = parcelRequire("3BZyK");

var $dRkX9 = parcelRequire("dRkX9");

var $leSAN = parcelRequire("leSAN");

var $iU70g = parcelRequire("iU70g");

var $c48ao = parcelRequire("c48ao");

var $iIxrR = parcelRequire("iIxrR");

var $dsn5W = parcelRequire("dsn5W");

var $aQNcS = parcelRequire("aQNcS");

var $aiSBX = parcelRequire("aiSBX");

var $jCBqQ = parcelRequire("jCBqQ");

var $jFYW1 = parcelRequire("jFYW1");
/**
 * Narrows the page-scoped media config returned by the bootstrap fragment
 * (where every field is nullable due to `@skip(if: $skipPageMediaConfig)`) to
 * the non-nullable shape expected by `HubContext.pageMediaConfig`. Returns
 * `undefined` when any required field is missing so the caller can omit the
 * key from the context value entirely.
 */ const $a1bdae8a76fc4cab$var$getPageMediaConfigFromBootstrap = (input)=>{
    if (!input) return undefined;
    const { asapIssuer: asapIssuer, mediaCollectionName: mediaCollectionName, mediaToken: mediaToken, mediaUrl: mediaUrl } = input;
    if (asapIssuer == null || mediaCollectionName == null || mediaToken == null || mediaUrl == null) return undefined;
    return {
        asapIssuer: asapIssuer,
        mediaCollectionName: mediaCollectionName,
        mediaToken: mediaToken,
        mediaUrl: mediaUrl
    };
};
const $a1bdae8a76fc4cab$export$caae1ac058a7a032 = ({ bootstrapQueryReference: bootstrapQueryReference, tenantContextsQueryReference: tenantContextsQueryReference, children: children, cloudId: cloudId, isInPreviewMode: isInPreviewMode = false, ...props })=>{
    var _tenantData$tenantCon, _data$helpCenterById, _branding$colors, _branding$colors2, _data$helpCenterById2, _data$helpCenterById3;
    // `skipPageMediaConfig` defaults to `false` so callers that don't pass it
    // fall back to the original behavior of fetching pageMediaConfig in the
    // bootstrap. The wrapper query passes a value derived from the fix flag.
    const data = (0, $3BZyK.useFragment)((0, $alGyR.default), bootstrapQueryReference);
    const tenantData = (0, $3BZyK.useFragment)((0, $GFVNQ.default), tenantContextsQueryReference);
    const cloudUrl = ((_tenantData$tenantCon = tenantData.tenantContexts) === null || _tenantData$tenantCon === void 0 || (_tenantData$tenantCon = _tenantData$tenantCon[0]) === null || _tenantData$tenantCon === void 0 ? void 0 : _tenantData$tenantCon.cloudUrl) ?? window.location.origin;
    if (!data.helpCenterById) throw new Error('Help center not found');
    const branding = (_data$helpCenterById = data.helpCenterById) === null || _data$helpCenterById === void 0 ? void 0 : _data$helpCenterById.helpCenterBranding;
    const logo = branding === null || branding === void 0 ? void 0 : branding.logo;
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? undefined;
    // BE persists the secondary brand color as `secondaryColor` on
    // HelpCenterBrandingColors. We expose it on the FE context as `accent`
    // to match the existing HubThemingContext / panel terminology (admin
    // label is "Accent color"). The bridge happens here at the data
    // boundary.
    const accentColor = (branding === null || branding === void 0 || (_branding$colors2 = branding.colors) === null || _branding$colors2 === void 0 ? void 0 : _branding$colors2.secondaryColor) ?? undefined;
    // Map the BE typography shape (`{ headingFont, bodyFont }`, FontKey strings
    // or null) to the FE `HubTypography` ({ heading, body }). Either side may be
    // null independently — fall back to Atlassian Sans for the missing one. When
    // neither is set we leave `typography` undefined so HubTypographyScope
    // no-ops and the framework default (Atlassian Sans) applies. This is the
    // single read seam that feeds BOTH the editor and all help-seeker view
    // pages — they share this bootstrap.
    //
    // `toFontKey` validates each value against FONT_REGISTRY rather than blindly
    // casting: an unrecognised backend string (a font added server-side before
    // this enum ships, a migration) would otherwise reach the registry lookups
    // in HubTypographyScope / buildGoogleFontsUrl and throw on `undefined`.
    const beTypography = branding === null || branding === void 0 ? void 0 : branding.typography;
    const headingFont = (beTypography === null || beTypography === void 0 ? void 0 : beTypography.headingFont) ?? undefined;
    const bodyFont = (beTypography === null || beTypography === void 0 ? void 0 : beTypography.bodyFont) ?? undefined;
    // Stable reference keyed on the primitive font strings so the
    // hubContextValue memo below can depend on `typography` directly without
    // recomputing on every render (and exhaustive-deps stays satisfied).
    const typography = (0, $fc4bM.useMemo)(()=>headingFont || bodyFont ? {
            heading: (0, $jCBqQ.toFontKey)(headingFont),
            body: (0, $jCBqQ.toFontKey)(bodyFont)
        } : undefined, [
        headingFont,
        bodyFont
    ]);
    // Hub-wide corner radius. The BE field is `HelpCenterBranding.cornerRadius`
    // (distinct from `navigationBar.cornerRadius`). `?? undefined` normalises
    // GraphQL null to undefined so absent vs. not-set are indistinguishable to
    // consumers — both fall back to the framework default (8 px).
    const cornerRadius = (branding === null || branding === void 0 ? void 0 : branding.cornerRadius) ?? undefined;
    // Hub-wide space density. The BE field is `HelpCenterBranding.spaceDensity`
    // (`HelpCenterSpaceDensity` enum). `toSpaceDensity` validates the value and
    // normalises null / unrecognised to undefined so absent vs. not-set are
    // indistinguishable to consumers — both fall back to the framework default
    // spacing.
    const spaceDensity = (0, $aiSBX.toSpaceDensity)(branding === null || branding === void 0 ? void 0 : branding.spaceDensity);
    const fileId = (logo === null || logo === void 0 ? void 0 : logo.fileId) || '';
    const url = (logo === null || logo === void 0 ? void 0 : logo.url) || '';
    const hubType = ((_data$helpCenterById2 = data.helpCenterById) === null || _data$helpCenterById2 === void 0 ? void 0 : _data$helpCenterById2.type) || '';
    const hubName = ((_data$helpCenterById3 = data.helpCenterById) === null || _data$helpCenterById3 === void 0 || (_data$helpCenterById3 = _data$helpCenterById3.name) === null || _data$helpCenterById3 === void 0 ? void 0 : _data$helpCenterById3.default) ?? undefined;
    // Convert the logo to a base64 data URL so the signed token embedded in the
    // original URL never expires while the user has the page open.
    const [logoUrl, setLogoUrl] = (0, $fc4bM.useState)(url);
    const prevUrlRef = (0, $fc4bM.useRef)(url);
    if (prevUrlRef.current !== url) {
        prevUrlRef.current = url;
        setLogoUrl(url);
    }
    (0, $fc4bM.useEffect)(()=>{
        if (!url) return;
        let cancelled = false;
        fetch(url).then((res)=>res.blob()).then((blob)=>new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            })).then((base64)=>{
            if (!cancelled) setLogoUrl(base64);
        }).catch(()=>{
        // Silently fall back to the original signed URL if the fetch fails.
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        url
    ]);
    const navigationBar = (branding === null || branding === void 0 ? void 0 : branding.navigationBar) ?? null;
    // When the fix flag is ON, `pageMediaConfig` is omitted from the bootstrap
    // and is instead provided by the page-scoped `Hub` (read mode) and `HubInfo`
    // (edit mode) components via a nested `HubContext.Provider`. When the flag
    // is OFF the bootstrap still fetches it (via `$pageAri`) and provides it
    // here as before.
    const bootstrapPageMediaConfig = (0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media') ? undefined : $a1bdae8a76fc4cab$var$getPageMediaConfigFromBootstrap(data.pageMediaConfig);
    // Memoize the context value so that consumers (e.g. `Hub`) receive a stable
    // reference across re-renders. Without this, every render of `HubBootstrap`
    // produces a new object literal, causing all `useHubContext()` consumers to
    // re-render even when nothing meaningful has changed. This is especially
    // important for the `useMemo` in `Hub` that merges `pageMediaConfig` into
    // the context — its deps array includes `hubContext`, so it needs a stable
    // input to avoid recomputing on every render.
    const hubContextValue = (0, $fc4bM.useMemo)(()=>({
            ...bootstrapPageMediaConfig ? {
                pageMediaConfig: bootstrapPageMediaConfig
            } : {},
            hubMediaConfig: data.hubMediaConfig,
            branding: {
                logo: {
                    fileId: fileId,
                    url: logoUrl
                },
                colors: {
                    primary: primaryColor || (0, $leSAN.DEFAULT_BRANDING_COLOR),
                    // `accent` is intentionally NOT defaulted here — the
                    // HubThemingProvider owns the FE-side default so a single
                    // constant governs both "no BE field set" (returns null)
                    // and "outside HubBootstrap entirely" (Confluence/CSM)
                    // cases. Passing `undefined` lets the provider's
                    // `branding?.colors?.accent ?? DEFAULT_ACCENT` shortcut
                    // kick in either way.
                    ...accentColor ? {
                        accent: accentColor
                    } : {}
                },
                // Only present when the BE has a stored choice; undefined falls
                // through to the Atlassian Sans framework default downstream.
                ...typography ? {
                    typography: typography
                } : {},
                // Only present when the BE has a stored value; undefined means
                // consumers fall back to the framework default (8 px).
                ...cornerRadius !== undefined ? {
                    cornerRadius: cornerRadius
                } : {},
                // Only present when the BE has a stored value; undefined means
                // consumers fall back to the framework default spacing.
                ...spaceDensity ? {
                    spaceDensity: spaceDensity
                } : {}
            },
            layout: props.layout,
            user: props.user,
            env: props.env,
            actions: props.actions,
            containerStyling: props.containerStyling,
            renderAvatarMenuOptions: props.renderAvatarMenuOptions,
            renderCustomNavActions: props.renderCustomNavActions,
            renderRightNavActions: props.renderRightNavActions,
            featureFlags: props.featureFlags,
            edition: props.edition,
            isPremiumEntitled: props.isPremiumEntitled,
            hubName: hubName,
            migrationReview: props.migrationReview,
            cloudId: cloudId,
            cloudUrl: cloudUrl,
            hubType: hubType,
            isInPreviewMode: isInPreviewMode
        }), [
        bootstrapPageMediaConfig,
        data.hubMediaConfig,
        fileId,
        logoUrl,
        primaryColor,
        accentColor,
        typography,
        cornerRadius,
        spaceDensity,
        props.layout,
        props.user,
        props.env,
        props.actions,
        props.containerStyling,
        props.renderAvatarMenuOptions,
        props.renderCustomNavActions,
        props.renderRightNavActions,
        props.featureFlags,
        props.edition,
        props.isPremiumEntitled,
        hubName,
        props.migrationReview,
        cloudId,
        cloudUrl,
        hubType,
        isInPreviewMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aQNcS.HubContext).Provider, {
        value: hubContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iU70g.HubThemingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a1bdae8a76fc4cab$var$NavigationStyleProvider, {
        navigationBar: navigationBar,
        primaryColor: primaryColor
    }, children)));
};
/**
 * Provides the `NavigationStyleContext` derived from the BE navigation-bar
 * branding.
 *
 * IMPORTANT — why this is a separate component:
 * The corner-radius gate (`useIsHubCornerRadiusEnabled` →
 * `useIsAdvancedThemingEnabled`) reads `useContext(HubContext)`. It MUST run
 * *inside* the `<HubContext.Provider>` that `HubBootstrap` renders — otherwise
 * (as when it was inlined in `HubBootstrap` above the provider) it reads the
 * absent outer context, always resolves `false`, and the mapper coerces an
 * unset `navigationBar.cornerRadius` (null) to the 8px default. That pins the
 * navbar and stops it inheriting the hub-wide radius in view mode. Evaluating
 * the gate here keeps it consistent with the page-scoped `Hub` mapper so the
 * navbar correctly inherits (null) until an explicit radius is set.
 */ const $a1bdae8a76fc4cab$var$NavigationStyleProvider = ({ navigationBar: navigationBar, primaryColor: primaryColor, children: children })=>{
    const isCornerRadiusEnabled = (0, $dsn5W.useIsHubCornerRadiusEnabled)();
    const isAdvancedThemingEnabled = (0, $iIxrR.useIsAdvancedThemingEnabled)();
    const navStyleOptions = (0, $fc4bM.useMemo)(()=>({
            options: navigationBar ? (0, $jFYW1.mapApiToNavigationOptions)(navigationBar, primaryColor, isCornerRadiusEnabled, isAdvancedThemingEnabled) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        primaryColor,
        isCornerRadiusEnabled,
        isAdvancedThemingEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c48ao.NavigationStyleContext).Provider, {
        value: navStyleOptions
    }, children);
};
const $a1bdae8a76fc4cab$export$5f7521758ed90a1b = ({ children: children, queryReference: queryReference, ...props })=>{
    const data = (0, $3BZyK.usePreloadedQuery)((0, $dhrtT.default), queryReference);
    if (!data.helpCenter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a1bdae8a76fc4cab$export$caae1ac058a7a032, {
        bootstrapQueryReference: data.helpCenter,
        tenantContextsQueryReference: data,
        ...props
    }, children);
};

});
parcelRegister("dhrtT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b878b9c58585131d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a27c8604be208843cc1a0e8052a82427>>
 * @relayHash 888781c9fe90b2f4e05676de22fb5522
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 377e7ad9a780ab506407e2fc59fcd57d811ef9197f8d5e89d0b946e31055a08a
const $b878b9c58585131d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPageMediaConfig"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "pageAri",
                                    "variableName": "pageAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "skipPageMediaConfig",
                                    "variableName": "skipPageMediaConfig"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "condition": "skipPageMediaConfig",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "pageMediaConfig",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "ari",
                                            "variableName": "pageAri"
                                        },
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "concreteType": "HelpCenterMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "hubMediaConfig",
                                    "plural": false,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterNavigationBar",
                                                    "kind": "LinkedField",
                                                    "name": "navigationBar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "backgroundColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderType"
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "padding"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "positionType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "textColor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingTypography",
                                                    "kind": "LinkedField",
                                                    "name": "typography",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "headingFont"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "bodyFont"
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "spaceDensity"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "377e7ad9a780ab506407e2fc59fcd57d811ef9197f8d5e89d0b946e31055a08a",
            "metadata": {},
            "name": "hubBootstrapWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b878b9c58585131d$var$node.hash = "86640fbb58e4cc03ace693195e50e046";
var $b878b9c58585131d$export$2e2bcd8739ae039 = $b878b9c58585131d$var$node;

});

parcelRegister("GFVNQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1f60f86956e4f00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<042bc6b2c3f711f749a6f3aaf17ffbc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1f60f86956e4f00$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "hubEditMode"
        }
    ],
    "kind": "Fragment",
    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference",
    "selections": [
        {
            "condition": "hubEditMode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cloudUrl"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$e1f60f86956e4f00$var$node.hash = "951df66590a0cca5f7516d267ed12179";
var $e1f60f86956e4f00$export$2e2bcd8739ae039 = $e1f60f86956e4f00$var$node;

});

parcelRegister("alGyR", function(module, exports) {
$parcel$export(module.exports, "default", () => $3276e256c8c2a0e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52871c826a7c9b288f54b36388441b3a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3276e256c8c2a0e2$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v1 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v2 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v3 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v5 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "hubAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDraft"
            },
            {
                "kind": "RootArgument",
                "name": "operationType"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "pageAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipPageMediaConfig"
            }
        ],
        "kind": "Fragment",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "hubAri"
                        },
                        v0 /*: any*/ ,
                        v1 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterMediaConfig",
                    "kind": "LinkedField",
                    "name": "hubMediaConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v4 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW"
                        }
                    ]
                },
                "action": "THROW"
            },
            {
                "condition": "skipPageMediaConfig",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "alias": "pageMediaConfig",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "ari",
                                "variableName": "pageAri"
                            },
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ],
                        "concreteType": "HelpCenterMediaConfig",
                        "kind": "LinkedField",
                        "name": "hubMediaConfig",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "helpCenterAri",
                        "variableName": "hubAri"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "concreteType": "HelpCenterName",
                                "kind": "LinkedField",
                                "name": "name",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "default"
                                    }
                                ]
                            },
                            {
                                "concreteType": "HelpCenterBranding",
                                "kind": "LinkedField",
                                "name": "helpCenterBranding",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLogo",
                                        "kind": "LinkedField",
                                        "name": "logo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fileId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterBrandingColors",
                                        "kind": "LinkedField",
                                        "name": "colors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "primary"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "secondaryColor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterNavigationBar",
                                        "kind": "LinkedField",
                                        "name": "navigationBar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "backgroundColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderType"
                                            },
                                            v6 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "padding"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "positionType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "textColor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterBrandingTypography",
                                        "kind": "LinkedField",
                                        "name": "typography",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "headingFont"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "bodyFont"
                                            }
                                        ]
                                    },
                                    v6 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "spaceDensity"
                                    }
                                ]
                            }
                        ],
                        "type": "HelpCenter"
                    }
                ]
            }
        ],
        "type": "HelpCenterQueryApi"
    };
}();
$3276e256c8c2a0e2$var$node.hash = "3078bc0e48a16d0464bbdd1221708a30";
var $3276e256c8c2a0e2$export$2e2bcd8739ae039 = $3276e256c8c2a0e2$var$node;

});

parcelRegister("leSAN", function(module, exports) {
$parcel$export(module.exports, "SPOTLIGHT_EXTENSION_TYPE", () => $c11ee7df34e0e00d$export$df3c2062a081a534);
$parcel$export(module.exports, "SECTION_EXTENSION_TYPE", () => $c11ee7df34e0e00d$export$4454075c4322ae47);
$parcel$export(module.exports, "RESOURCE_TILES_EXTENSION_TYPE", () => $c11ee7df34e0e00d$export$2dd5fc71941a6787);
$parcel$export(module.exports, "DEFAULT_BRANDING_COLOR", () => $c11ee7df34e0e00d$export$8e1a1e8b8109dbf3);
$parcel$export(module.exports, "HUB_PRIMARY_COLOR_CSS_VAR", () => $c11ee7df34e0e00d$export$8161b1f4e2928fa0);
$parcel$export(module.exports, "HUB_PRIMARY_TEXT_COLOR_CSS_VAR", () => $c11ee7df34e0e00d$export$94d2a2331edd895d);
$parcel$export(module.exports, "HUB_PRIMARY_LINK_COLOR_CSS_VAR", () => $c11ee7df34e0e00d$export$64de52c9db8240f6);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT", () => $c11ee7df34e0e00d$export$4c91e7265b76e3a1);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT_LEGACY", () => $c11ee7df34e0e00d$export$d713f99e5e84a256);
$parcel$export(module.exports, "SENTRY_DSN", () => $c11ee7df34e0e00d$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "UNKNOWN_TAG", () => $c11ee7df34e0e00d$export$ea77880e3935182d);
$parcel$export(module.exports, "NETWORK_ERROR_CODE", () => $c11ee7df34e0e00d$export$c7f012c6e67c4217);
const $c11ee7df34e0e00d$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $c11ee7df34e0e00d$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $c11ee7df34e0e00d$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $c11ee7df34e0e00d$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $c11ee7df34e0e00d$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $c11ee7df34e0e00d$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $c11ee7df34e0e00d$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $c11ee7df34e0e00d$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $c11ee7df34e0e00d$export$8e1a1e8b8109dbf3 = '#003172';
const $c11ee7df34e0e00d$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $c11ee7df34e0e00d$export$94d2a2331edd895d = '--hub-primary-text-color';
const $c11ee7df34e0e00d$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $c11ee7df34e0e00d$export$4c91e7265b76e3a1 = '32px';
const $c11ee7df34e0e00d$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $c11ee7df34e0e00d$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $c11ee7df34e0e00d$export$ea77880e3935182d = 'unknown';
const $c11ee7df34e0e00d$export$c7f012c6e67c4217 = 0;

});

parcelRegister("iU70g", function(module, exports) {
$parcel$export(module.exports, "HubThemingProvider", () => $ef5cc88b65550864$export$637b3c4e057a01d3);
$parcel$export(module.exports, "useHubTheming", () => $ef5cc88b65550864$export$33bfea475043649c);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $aVQWM = parcelRequire("aVQWM");

var $lo6r6 = parcelRequire("lo6r6");

var $bRst2 = parcelRequire("bRst2");

var $h46Vs = parcelRequire("h46Vs");

var $leSAN = parcelRequire("leSAN");

var $aQNcS = parcelRequire("aQNcS");

var $4Q8Rn = parcelRequire("4Q8Rn");
var $gN0s7 = parcelRequire("gN0s7");
var $2dO3w = parcelRequire("2dO3w");

var $dw5hC = parcelRequire("dw5hC");

var $cWpLK = parcelRequire("cWpLK");

var $baQcN = parcelRequire("baQcN");

var $1pbmG = parcelRequire("1pbmG");

var $1eqSX = parcelRequire("1eqSX");

var $iIxrR = parcelRequire("iIxrR");

var $bSHq3 = parcelRequire("bSHq3");
const $ef5cc88b65550864$var$HubThemingContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $ef5cc88b65550864$var$readableHubTextColor = (color)=>(0, $bRst2.readableTextColor)(color, '@atlassian/company-hub-common');
const $ef5cc88b65550864$export$637b3c4e057a01d3 = ({ children: children })=>{
    var _branding$colors, _branding$colors2;
    const { branding: branding, env: env, hubType: hubType, isInPreviewMode: isInPreviewMode } = (0, $aQNcS.useHubContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const isEnabled = (0, $iIxrR.useIsAdvancedThemingEnabled)();
    const isBrandPaletteLocked = (0, $bSHq3.useShouldShowPremiumUpsell)();
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? (0, $1pbmG.DEFAULT_PRIMARY);
    // Accent comes from the BE (`HelpCenterBrandingColors.secondaryColor`,
    // mapped to `branding.colors.accent` at the bootstrap boundary). If the
    // BE returns nothing — pre-v2 hubs, non-help-center hosts, fresh tenants
    // — we fall through to `DEFAULT_ACCENT`. The panel persists changes via
    // the same Relay mutation path that primary uses, so the picker's
    // `value` prop and the provider's `accentColor` here stay in lockstep
    // via the next bootstrap re-render. No FE-side state needed.
    const accentColor = (branding === null || branding === void 0 || (_branding$colors2 = branding.colors) === null || _branding$colors2 === void 0 ? void 0 : _branding$colors2.accent) ?? (0, $1pbmG.DEFAULT_ACCENT);
    const palette = (0, $2dO3w.useHubBrandPalette)({
        primary: primaryColor,
        accent: accentColor
    });
    const primaryTextColor = (0, $fc4bM.useMemo)(()=>$ef5cc88b65550864$var$readableHubTextColor(primaryColor), [
        primaryColor
    ]);
    const primaryLinkColor = (0, $fc4bM.useMemo)(()=>(0, $h46Vs.generateThemeBranding)(primaryColor).color900, [
        primaryColor
    ]);
    // Typography source of truth is the BE-persisted value, surfaced on
    // `branding.typography` at the bootstrap boundary. This is what makes the
    // help-seeker VIEW pages (homepage, profile, login, request list/details)
    // render the admin's chosen font — they read the same branding the editor
    // does. `setHubTypography` layers an in-session override on top for instant
    // edit-mode preview; the override is persisted on Publish via the branding
    // mutation (see action-bar), after which a bootstrap re-read makes the base
    // value match. View mode never calls the setter, so it always shows the
    // persisted value. Undefined (no BE value, no override) → HubTypographyScope
    // no-ops → Atlassian Sans default.
    const brandingTypography = branding === null || branding === void 0 ? void 0 : branding.typography;
    const [typographyOverride, setTypographyOverride] = (0, $fc4bM.useState)(undefined);
    const typography = typographyOverride ?? brandingTypography;
    const setHubTypography = (0, $fc4bM.useCallback)((next)=>{
        setTypographyOverride(next);
    }, []);
    const brandingSpaceDensity = branding === null || branding === void 0 ? void 0 : branding.spaceDensity;
    const [spaceDensityOverride, setSpaceDensityOverride] = (0, $fc4bM.useState)(undefined);
    const spaceDensity = spaceDensityOverride ?? brandingSpaceDensity;
    const setSpaceDensity = (0, $fc4bM.useCallback)((next)=>{
        setSpaceDensityOverride(next);
    }, []);
    // Corner radius source of truth is the BE-persisted value, surfaced on
    // `branding.cornerRadius` at the bootstrap boundary. `setHubCornerRadius`
    // layers an in-session override on top for instant edit-mode preview; the
    // override is persisted on Publish via the branding mutation. View mode
    // never calls the setter. Undefined / invalid → resolves to 8px default.
    const brandingCornerRadius = branding === null || branding === void 0 ? void 0 : branding.cornerRadius;
    const [cornerRadiusOverride, setCornerRadiusOverride] = (0, $fc4bM.useState)(undefined);
    const cornerRadius = (0, $cWpLK.resolveHubCornerRadius)(cornerRadiusOverride ?? brandingCornerRadius);
    const setHubCornerRadius = (0, $fc4bM.useCallback)((next)=>{
        setCornerRadiusOverride(next);
    }, []);
    // Adoption denominator: fire once per hub load (view or edit) with the
    // persisted theming state, but only when advanced theming is enabled. The
    // provider mounts on every hub load via HubBootstrap, so this captures the
    // full installed base; deduped downstream by helpCenterAri.
    const hasFiredRenderedRef = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        if (hasFiredRenderedRef.current || !isEnabled) return;
        if (!(env !== null && env !== void 0 && env.helpCenterAri)) return;
        hasFiredRenderedRef.current = true;
        // Flat analytics-bridge envelope (top-level `analyticsType`): this is the shape
        // help-center's analytics listener chain extracts and forwards to GAS v3. A nested
        // `{ type, data }` envelope resolves `analyticsType: undefined` and is silently
        // dropped on this host, so we mirror hub-home's `help_hub published` pattern.
        createAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'helpHubTheme',
            analyticsType: (0, $aVQWM.TRACK_EVENT_TYPE),
            attributes: {
                source: 'hubThemingProvider',
                helpCenterAri: env.helpCenterAri,
                helpCenterId: env.helpCenterId,
                hubType: hubType,
                isInPreviewMode: !!isInPreviewMode,
                ...(0, $baQcN.buildHubThemingStateAttributes)({
                    primaryColor: primaryColor,
                    accentColor: accentColor,
                    typography: typography,
                    cornerRadius: cornerRadius,
                    spaceDensity: spaceDensity
                })
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        env,
        hubType,
        isInPreviewMode,
        isEnabled,
        primaryColor,
        accentColor,
        typography,
        cornerRadius,
        spaceDensity
    ]);
    // `defaultParameters` and `brandBackgroundColorMap` deliberately split on
    // `isEnabled` so consumers (CommonHubExtensionsDependenciesProvider, the
    // extension config panels) can keep reading from `useHubTheming()` without
    // branching themselves. When the gate is OFF we restore the pre-v2 shape
    // exactly: legacy CSS-var refs in default params (consumed by
    // setHubBrandingStyle's writes) and a single-knownColor swatch grid built
    // from `branding.colors.primary` so the picker still shows the brand swatch.
    //
    // When ON, the wrapper div below emits `--hub-color-*` vars, and
    // `defaultParameters.backgroundColor` is a `var(--hub-color-primary-200)`
    // reference rather than a hex literal. The renderer drops the var ref into
    // inline style; the cascade resolves it against the wrapper. This means
    // brand-color edits trigger a CSS-only repaint — no React re-render in the
    // consumer is needed for the new color to apply.
    const defaultParameters = (0, $fc4bM.useMemo)(()=>isEnabled ? // Gate ON: resolver returns `var(--hub-color-primary-200)` + readable
        // text; when locked it seeds the raw `primaryColor` instead.
        {
            ...(0, $1eqSX.getHubDefaultParameters)({
                palette: palette,
                isBrandPaletteLocked: isBrandPaletteLocked,
                primaryColor: primaryColor
            }),
            textColor: primaryTextColor
        } : // Gate OFF: same resolver with no palette → legacy `var(--hub-*)`
        // chain that resolves against setHubBrandingStyle's writes on <html>.
        (0, $1eqSX.getHubDefaultParameters)(), [
        isEnabled,
        palette,
        primaryTextColor,
        isBrandPaletteLocked,
        primaryColor
    ]);
    // Brand swatch grid, shared by every bespoke element picker via context:
    //   - ON + unlocked: full palette + white/black.
    //   - ON + locked: the admin's primary brand colour + white/black (gating the
    //     source here reduces every picker at once; each adds its own current
    //     value + custom-hex). Also see `brandBorderColorMap` below.
    //   - OFF: legacy single CSS-var string (matches master's strict-equality
    //     swatch highlight for pre-v2 ADFs).
    //
    // White and black are offered to locked tenants too: they are neutrals, not
    // palette tints, so they cost nothing in entitlement terms — and without
    // them a text or heading picker with a dark brand colour has no legible
    // choice at all beyond typing a custom hex.
    const brandBackgroundColorMap = (0, $fc4bM.useMemo)(()=>{
        if (!isEnabled) return (0, $lo6r6.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        });
        if (isBrandPaletteLocked) return (0, $lo6r6.createBuiltInColorMap)({
            knownColors: [
                primaryColor,
                ...(0, $dw5hC.HUB_LOCKED_NEUTRAL_HEXES)
            ]
        });
        return (0, $lo6r6.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                ...(0, $dw5hC.HUB_LOCKED_NEUTRAL_HEXES)
            ]
        });
    }, [
        isEnabled,
        isBrandPaletteLocked,
        primaryColor,
        palette,
        defaultParameters
    ]);
    // Same as brandBackgroundColorMap but with 4 neutrals appended (white,
    // color.border, color.border.bold, black); consumer translates the neutral
    // hexes back to token refs at onChange. Locked tenants get the primary plus
    // the same 4 neutrals — a border is neutral far more often than it is brand.
    const brandBorderColorMap = (0, $fc4bM.useMemo)(()=>{
        if (!isEnabled) return (0, $lo6r6.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        });
        if (isBrandPaletteLocked) return (0, $lo6r6.createBuiltInColorMap)({
            knownColors: [
                primaryColor,
                ...(0, $dw5hC.HUB_LOCKED_BORDER_NEUTRAL_HEXES)
            ]
        });
        return (0, $lo6r6.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                ...(0, $dw5hC.HUB_LOCKED_BORDER_NEUTRAL_HEXES)
            ]
        });
    }, [
        isEnabled,
        isBrandPaletteLocked,
        primaryColor,
        palette,
        defaultParameters
    ]);
    // Bound once here so no element panel has to remember to pass the locked
    // state through to `toAdfColor` — forgetting it is what let locked tenants
    // persist palette-shade refs that stop tracking the brand colour.
    const toStoredColor = (0, $fc4bM.useCallback)((hex)=>(0, $gN0s7.toAdfColor)(hex, palette, {
            isBrandPaletteLocked: isBrandPaletteLocked,
            primaryColor: primaryColor
        }), [
        palette,
        isBrandPaletteLocked,
        primaryColor
    ]);
    const value = (0, $fc4bM.useMemo)(()=>({
            isAdvancedThemingEnabled: isEnabled,
            isBrandPaletteLocked: isBrandPaletteLocked,
            primaryColor: primaryColor,
            accentColor: accentColor,
            primaryTextColor: primaryTextColor,
            primaryLinkColor: primaryLinkColor,
            palette: palette,
            defaultParameters: defaultParameters,
            brandBackgroundColorMap: brandBackgroundColorMap,
            brandBorderColorMap: brandBorderColorMap,
            cornerRadius: cornerRadius,
            setHubCornerRadius: setHubCornerRadius,
            setHubTypography: setHubTypography,
            typography: typography,
            setSpaceDensity: setSpaceDensity,
            spaceDensity: spaceDensity,
            toStoredColor: toStoredColor
        }), [
        isEnabled,
        isBrandPaletteLocked,
        primaryColor,
        accentColor,
        primaryTextColor,
        primaryLinkColor,
        palette,
        defaultParameters,
        brandBackgroundColorMap,
        brandBorderColorMap,
        cornerRadius,
        setHubCornerRadius,
        setHubTypography,
        typography,
        setSpaceDensity,
        spaceDensity,
        toStoredColor
    ]);
    // Wrapper div emits the entire palette as inline `style` so the 20
    // `--hub-color-*` custom properties land in the SSR HTML and resolve on
    // first paint — no useEffect, no `document.documentElement.setProperty`,
    // no flash of unthemed content. Everything inside the wrapper inherits the
    // vars through the normal CSS cascade.
    //
    // `display: contents` tells the browser to render the wrapper's children
    // but skip generating a box for the wrapper itself, so it is invisible to
    // flex/grid/positioning. Without it, the wrapper would introduce a
    // `display: block` box that could break ancestor layouts (extra flex item,
    // extra grid cell, broken percentage heights, etc.). We get CSS-var
    // scoping + a DOM marker for devtools without any layout side-effect.
    // The cascade still works — `display: contents` does not stop custom
    // properties from being inherited by descendants.
    //
    // Wrapper always emits the full palette + legacy vars, regardless of the
    // gate state. This matters when an admin edits under v2 ON and then toggles
    // the FF off — their persisted ADFs reference `--hub-color-primary-*` and
    // would resolve to `unset` (white) without the wrapper providing the vars.
    // Always emitting keeps a flag flip non-destructive while the resolver and
    // picker still gate their *behavior* on `isAdvancedThemingEnabled`.
    //
    // Legacy compat vars (`--hub-primary-color` / `--hub-primary-text-color` /
    // `--hub-primary-link-color`) are also always emitted so pre-v2 ADFs that
    // reference them render with the exact same colors as before the v2 flip
    // (the input hex verbatim, WCAG-readable text, and
    // `generateThemeBranding(...).color900` link tint). Matches
    // `setHubBrandingStyle`'s semantics so admins with already-customised hubs
    // see no visual change post-flip.
    const wrapperStyle = (0, $fc4bM.useMemo)(()=>({
            display: 'contents',
            ...$ef5cc88b65550864$var$buildPaletteStyle(palette),
            [(0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR)]: primaryColor,
            [(0, $leSAN.HUB_PRIMARY_TEXT_COLOR_CSS_VAR)]: primaryTextColor,
            [(0, $leSAN.HUB_PRIMARY_LINK_COLOR_CSS_VAR)]: primaryLinkColor,
            [(0, $cWpLK.HUB_CORNER_RADIUS_CSS_VAR)]: `${cornerRadius}px`
        }), [
        palette,
        primaryColor,
        primaryTextColor,
        primaryLinkColor,
        cornerRadius
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ef5cc88b65550864$var$HubThemingContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-hub-theme-root": "",
        style: wrapperStyle
    }, children));
};
/**
 * Build the inline-style object emitted on the wrapper div from the palette.
 * Returns 20 entries of the form `{ '--hub-color-primary-200': '#B3D4FF' }`.
 *
 * Kept outside the provider so the entry-set construction is testable in
 * isolation and not entangled with React rendering.
 */ const $ef5cc88b65550864$var$buildPaletteStyle = (palette)=>{
    const out = {};
    for (const ref of Object.keys(palette))out[(0, $4Q8Rn.HUB_COLOR_CSS_VARS)[ref]] = palette[ref];
    return out;
};
const $ef5cc88b65550864$export$33bfea475043649c = ()=>{
    return (0, $fc4bM.useContext)($ef5cc88b65550864$var$HubThemingContext) ?? undefined;
};

});
parcelRegister("lo6r6", function(module, exports) {
$parcel$export(module.exports, "createBuiltInColorMap", () => $bf07568f2a1f70b1$export$a4af15b2fa34f34e);

var $aaElU = parcelRequire("aaElU");

var $52R4z = parcelRequire("52R4z");
const $bf07568f2a1f70b1$export$a4af15b2fa34f34e = ({ knownColors: knownColors, allColors: allColors, humanReadableColors: humanReadableColors, getResponsiveColor: getResponsiveColor })=>{
    knownColors = knownColors.map((color)=>color.toLowerCase());
    const knownTokens = knownColors.map((color)=>(0, $aaElU.extractToken)(color));
    if (!allColors) allColors = knownColors;
    else allColors = allColors.map((color)=>color.toLowerCase());
    const allTokens = allColors.map((color)=>(0, $aaElU.extractToken)(color));
    const humanReadableColorsMap = humanReadableColors ? new Map([
        ...(0, $52R4z.allHumanReadableColors).entries(),
        ...humanReadableColors.entries()
    ]) : (0, $52R4z.allHumanReadableColors);
    return {
        knownColors: knownColors,
        knownTokens: knownTokens,
        allColors: allColors,
        allTokens: allTokens,
        humanReadableColors: humanReadableColorsMap,
        getResponsiveColor: getResponsiveColor || ((color)=>color)
    };
};

});
parcelRegister("aaElU", function(module, exports) {
$parcel$export(module.exports, "isValidColor", () => $9a464283a9663681$export$35fa9d266cdb6f09);
$parcel$export(module.exports, "convertLegacyColor", () => $9a464283a9663681$export$b2b344a3caf230bf);
$parcel$export(module.exports, "extractToken", () => $9a464283a9663681$export$5039139b891079e8);
$parcel$export(module.exports, "getSanitizedColor", () => $9a464283a9663681$export$d16dc80c78f978b3);
$parcel$export(module.exports, "toHexColor", () => $9a464283a9663681$export$342249704b28d862);
$parcel$export(module.exports, "isReadable", () => $9a464283a9663681$export$3fe5b5ca1e6a6a28);
$parcel$export(module.exports, "getMostReadableColor", () => $9a464283a9663681$export$21e0b327e0d86beb);

var $goAAA = parcelRequire("goAAA");
/* regular expressions obtained from CssColourValidator.java
 * CssColourValidator runs in legacy Color Scheme on updateSiteLookAndFeel mutation
 * instead of validating on Save, we are now validating as user enters custom input
 */ const $9a464283a9663681$var$VAR_MATCH = new RegExp('^var\\((\\-\\-[a-zA-Z0-9\\-_]+)\\s*(,(.+))?\\)$');
const $9a464283a9663681$var$SHORT_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){3}$');
const $9a464283a9663681$var$LONG_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){6}$');
const $9a464283a9663681$var$RGB_MATCH = new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
const $9a464283a9663681$var$PERC_MATCH = new RegExp('^rgb\\((\\d+)%,\\s*(\\d+)%,\\s*(\\d+)%\\)$');
const $9a464283a9663681$var$RGBA_MATCH = new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[0-9]*)|[01])\\s*\\)$');
const $9a464283a9663681$var$HSL_MATCH = new RegExp('^hsl\\(\\s*(0|[1-9]\\d?|[12]\\d\\d|3[0-5]\\d)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*\\)$');
/* evaluates validity for any incoming colors from 1) siteConfiguration query 2) custom input field
 * until hsla and named color conversion errors are handled properly in app-navigation, we return the default Atlassian theme as in getSanitizedColor fn
 * it is an existing pattern under useNavigationTheme to return the theme as means of error handling
 * once resolved, this isValidColor can validate for HSLA_MATCH and NAMED_COLOR_MATCH
 */ function $9a464283a9663681$var$isValidVarColor(color) {
    const matches = $9a464283a9663681$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$;
        const fallback = (_matches$ = matches[3]) === null || _matches$ === void 0 ? void 0 : _matches$.trim();
        if (fallback) {
            // If fallback is another var() call, validate it recursively
            if (fallback.startsWith('var(')) return $9a464283a9663681$var$isValidVarColor(fallback);
            // Otherwise validate as a regular color
            return $9a464283a9663681$export$35fa9d266cdb6f09(fallback, false);
        }
        // If there's a comma but no fallback (like "var(--token, )"), it's invalid
        if (matches[2] && !fallback) return false;
        return true;
    }
    return false;
}
function $9a464283a9663681$export$35fa9d266cdb6f09(color, isVarColorAllowed = true) {
    return isVarColorAllowed && $9a464283a9663681$var$isValidVarColor(color) || $9a464283a9663681$var$SHORT_NUMERIC_MATCH.test(color) || $9a464283a9663681$var$LONG_NUMERIC_MATCH.test(color) || $9a464283a9663681$var$RGB_MATCH.test(color) || $9a464283a9663681$var$PERC_MATCH.test(color) || $9a464283a9663681$var$RGBA_MATCH.test(color) || $9a464283a9663681$var$HSL_MATCH.test(color);
}
function $9a464283a9663681$export$b2b344a3caf230bf(color) {
    if (!$9a464283a9663681$export$35fa9d266cdb6f09(color)) return (0, $goAAA.default)('invalid');
    const colorCode = $9a464283a9663681$var$extractColorCode(color);
    return (0, $goAAA.default)(colorCode);
}
/* simply extracts the color code from given color string.
 * If color is tokenized, either computes or extracts fallback hex value
 * Else return color as is
 */ function $9a464283a9663681$var$extractColorCode(color) {
    const matches = $9a464283a9663681$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$2;
        const fallback = (_matches$2 = matches[3]) === null || _matches$2 === void 0 ? void 0 : _matches$2.trim();
        const token = matches[1].toLowerCase();
        // SSR guard
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const compiledTokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
            // If we have a computed value, return it
            if (compiledTokenValue) return compiledTokenValue;
        }
        // If there's a fallback, process it recursively
        if (fallback) {
            // If fallback is another var() call, extract from it recursively
            if (fallback.startsWith('var(')) return $9a464283a9663681$var$extractColorCode(fallback);
            // Otherwise return the fallback as is
            return fallback;
        }
        // No computed value and no fallback
        return '';
    }
    return color;
}
function $9a464283a9663681$export$5039139b891079e8(color = '') {
    const matches = $9a464283a9663681$var$VAR_MATCH.exec(color);
    return (matches === null || matches === void 0 ? void 0 : matches[1].toLowerCase()) ?? color;
}
function $9a464283a9663681$export$d16dc80c78f978b3({ allColors: allColors, allTokens: allTokens, knownColors: knownColors }, color = '') {
    const index = allTokens.indexOf($9a464283a9663681$export$5039139b891079e8(color));
    if (index !== -1) return allColors[index];
    if (!$9a464283a9663681$export$35fa9d266cdb6f09(color)) return knownColors[0];
    return color;
}
function $9a464283a9663681$export$342249704b28d862(color) {
    const converted = $9a464283a9663681$export$b2b344a3caf230bf(color);
    if (converted.isValid()) return converted.toHexString();
    return color;
}
function $9a464283a9663681$export$3fe5b5ca1e6a6a28(backgroundColor, highlightColor) {
    const backgroundCode = $9a464283a9663681$var$extractColorCode(backgroundColor);
    const highlightCode = $9a464283a9663681$var$extractColorCode(highlightColor);
    return (0, $goAAA.default).isReadable(backgroundCode, highlightCode);
}
function $9a464283a9663681$export$21e0b327e0d86beb(color) {
    color = $9a464283a9663681$var$extractColorCode(color);
    return (0, $goAAA.default).mostReadable(color, [
        '#000000',
        '#ffffff'
    ]).toHexString();
}
function $9a464283a9663681$export$bf60f520e1f9cbf8(color1, color2) {
    return $9a464283a9663681$var$extractColorCode(color1) === $9a464283a9663681$var$extractColorCode(color2);
}

});
parcelRegister("goAAA", function(module, exports) {
$parcel$export(module.exports, "default", () => $befb450ff87fb7df$export$2e2bcd8739ae039);
// This file is autogenerated. It's used to publish ESM to npm.
function $befb450ff87fb7df$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $befb450ff87fb7df$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $befb450ff87fb7df$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $befb450ff87fb7df$var$trimLeft = /^\s+/;
var $befb450ff87fb7df$var$trimRight = /\s+$/;
function $befb450ff87fb7df$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $befb450ff87fb7df$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $befb450ff87fb7df$export$2e2bcd8739ae039)) return new $befb450ff87fb7df$export$2e2bcd8739ae039(color, opts);
    var rgb = $befb450ff87fb7df$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$befb450ff87fb7df$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $befb450ff87fb7df$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $befb450ff87fb7df$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $befb450ff87fb7df$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $befb450ff87fb7df$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $befb450ff87fb7df$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $befb450ff87fb7df$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $befb450ff87fb7df$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($befb450ff87fb7df$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($befb450ff87fb7df$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($befb450ff87fb7df$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($befb450ff87fb7df$var$bound01(this._r, 255) * 100) + "%, " + Math.round($befb450ff87fb7df$var$bound01(this._g, 255) * 100) + "%, " + Math.round($befb450ff87fb7df$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($befb450ff87fb7df$var$bound01(this._r, 255) * 100) + "%, " + Math.round($befb450ff87fb7df$var$bound01(this._g, 255) * 100) + "%, " + Math.round($befb450ff87fb7df$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $befb450ff87fb7df$var$hexNames[$befb450ff87fb7df$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $befb450ff87fb7df$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $befb450ff87fb7df$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $befb450ff87fb7df$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $befb450ff87fb7df$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($befb450ff87fb7df$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($befb450ff87fb7df$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($befb450ff87fb7df$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($befb450ff87fb7df$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($befb450ff87fb7df$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($befb450ff87fb7df$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($befb450ff87fb7df$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($befb450ff87fb7df$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($befb450ff87fb7df$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($befb450ff87fb7df$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($befb450ff87fb7df$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($befb450ff87fb7df$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($befb450ff87fb7df$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$befb450ff87fb7df$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($befb450ff87fb7df$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $befb450ff87fb7df$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $befb450ff87fb7df$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $befb450ff87fb7df$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $befb450ff87fb7df$var$stringInputToObject(color);
    if ($befb450ff87fb7df$var$_typeof(color) == "object") {
        if ($befb450ff87fb7df$var$isValidCSSUnit(color.r) && $befb450ff87fb7df$var$isValidCSSUnit(color.g) && $befb450ff87fb7df$var$isValidCSSUnit(color.b)) {
            rgb = $befb450ff87fb7df$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($befb450ff87fb7df$var$isValidCSSUnit(color.h) && $befb450ff87fb7df$var$isValidCSSUnit(color.s) && $befb450ff87fb7df$var$isValidCSSUnit(color.v)) {
            s = $befb450ff87fb7df$var$convertToPercentage(color.s);
            v = $befb450ff87fb7df$var$convertToPercentage(color.v);
            rgb = $befb450ff87fb7df$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($befb450ff87fb7df$var$isValidCSSUnit(color.h) && $befb450ff87fb7df$var$isValidCSSUnit(color.s) && $befb450ff87fb7df$var$isValidCSSUnit(color.l)) {
            s = $befb450ff87fb7df$var$convertToPercentage(color.s);
            l = $befb450ff87fb7df$var$convertToPercentage(color.l);
            rgb = $befb450ff87fb7df$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $befb450ff87fb7df$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $befb450ff87fb7df$var$rgbToRgb(r, g, b) {
    return {
        r: $befb450ff87fb7df$var$bound01(r, 255) * 255,
        g: $befb450ff87fb7df$var$bound01(g, 255) * 255,
        b: $befb450ff87fb7df$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $befb450ff87fb7df$var$rgbToHsl(r, g, b) {
    r = $befb450ff87fb7df$var$bound01(r, 255);
    g = $befb450ff87fb7df$var$bound01(g, 255);
    b = $befb450ff87fb7df$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $befb450ff87fb7df$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $befb450ff87fb7df$var$bound01(h, 360);
    s = $befb450ff87fb7df$var$bound01(s, 100);
    l = $befb450ff87fb7df$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $befb450ff87fb7df$var$rgbToHsv(r, g, b) {
    r = $befb450ff87fb7df$var$bound01(r, 255);
    g = $befb450ff87fb7df$var$bound01(g, 255);
    b = $befb450ff87fb7df$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $befb450ff87fb7df$var$hsvToRgb(h, s, v) {
    h = $befb450ff87fb7df$var$bound01(h, 360) * 6;
    s = $befb450ff87fb7df$var$bound01(s, 100);
    v = $befb450ff87fb7df$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $befb450ff87fb7df$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $befb450ff87fb7df$var$pad2(Math.round(r).toString(16)),
        $befb450ff87fb7df$var$pad2(Math.round(g).toString(16)),
        $befb450ff87fb7df$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $befb450ff87fb7df$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $befb450ff87fb7df$var$pad2(Math.round(r).toString(16)),
        $befb450ff87fb7df$var$pad2(Math.round(g).toString(16)),
        $befb450ff87fb7df$var$pad2(Math.round(b).toString(16)),
        $befb450ff87fb7df$var$pad2($befb450ff87fb7df$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $befb450ff87fb7df$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $befb450ff87fb7df$var$pad2($befb450ff87fb7df$var$convertDecimalToHex(a)),
        $befb450ff87fb7df$var$pad2(Math.round(r).toString(16)),
        $befb450ff87fb7df$var$pad2(Math.round(g).toString(16)),
        $befb450ff87fb7df$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$befb450ff87fb7df$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $befb450ff87fb7df$export$2e2bcd8739ae039(color1).toRgbString() == $befb450ff87fb7df$export$2e2bcd8739ae039(color2).toRgbString();
};
$befb450ff87fb7df$export$2e2bcd8739ae039.random = function() {
    return $befb450ff87fb7df$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $befb450ff87fb7df$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $befb450ff87fb7df$var$clamp01(hsl.s);
    return $befb450ff87fb7df$export$2e2bcd8739ae039(hsl);
}
function $befb450ff87fb7df$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $befb450ff87fb7df$var$clamp01(hsl.s);
    return $befb450ff87fb7df$export$2e2bcd8739ae039(hsl);
}
function $befb450ff87fb7df$var$_greyscale(color) {
    return $befb450ff87fb7df$export$2e2bcd8739ae039(color).desaturate(100);
}
function $befb450ff87fb7df$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $befb450ff87fb7df$var$clamp01(hsl.l);
    return $befb450ff87fb7df$export$2e2bcd8739ae039(hsl);
}
function $befb450ff87fb7df$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $befb450ff87fb7df$export$2e2bcd8739ae039(rgb);
}
function $befb450ff87fb7df$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $befb450ff87fb7df$var$clamp01(hsl.l);
    return $befb450ff87fb7df$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $befb450ff87fb7df$var$_spin(color, amount) {
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $befb450ff87fb7df$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $befb450ff87fb7df$var$_complement(color) {
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $befb450ff87fb7df$export$2e2bcd8739ae039(hsl);
}
function $befb450ff87fb7df$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $befb450ff87fb7df$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($befb450ff87fb7df$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $befb450ff87fb7df$var$_splitcomplement(color) {
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $befb450ff87fb7df$export$2e2bcd8739ae039(color),
        $befb450ff87fb7df$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $befb450ff87fb7df$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $befb450ff87fb7df$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $befb450ff87fb7df$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($befb450ff87fb7df$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $befb450ff87fb7df$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $befb450ff87fb7df$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($befb450ff87fb7df$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$befb450ff87fb7df$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $befb450ff87fb7df$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $befb450ff87fb7df$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $befb450ff87fb7df$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$befb450ff87fb7df$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $befb450ff87fb7df$export$2e2bcd8739ae039(color1);
    var c2 = $befb450ff87fb7df$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$befb450ff87fb7df$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $befb450ff87fb7df$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $befb450ff87fb7df$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$befb450ff87fb7df$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $befb450ff87fb7df$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $befb450ff87fb7df$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($befb450ff87fb7df$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $befb450ff87fb7df$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $befb450ff87fb7df$var$names = $befb450ff87fb7df$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $befb450ff87fb7df$var$hexNames = $befb450ff87fb7df$export$2e2bcd8739ae039.hexNames = $befb450ff87fb7df$var$flip($befb450ff87fb7df$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $befb450ff87fb7df$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $befb450ff87fb7df$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $befb450ff87fb7df$var$bound01(n, max) {
    if ($befb450ff87fb7df$var$isOnePointZero(n)) n = "100%";
    var processPercent = $befb450ff87fb7df$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $befb450ff87fb7df$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $befb450ff87fb7df$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $befb450ff87fb7df$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $befb450ff87fb7df$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $befb450ff87fb7df$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $befb450ff87fb7df$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $befb450ff87fb7df$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $befb450ff87fb7df$var$convertHexToDecimal(h) {
    return $befb450ff87fb7df$var$parseIntFromHex(h) / 255;
}
var $befb450ff87fb7df$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $befb450ff87fb7df$var$isValidCSSUnit(color) {
    return !!$befb450ff87fb7df$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $befb450ff87fb7df$var$stringInputToObject(color) {
    color = color.replace($befb450ff87fb7df$var$trimLeft, "").replace($befb450ff87fb7df$var$trimRight, "").toLowerCase();
    var named = false;
    if ($befb450ff87fb7df$var$names[color]) {
        color = $befb450ff87fb7df$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $befb450ff87fb7df$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $befb450ff87fb7df$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $befb450ff87fb7df$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $befb450ff87fb7df$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $befb450ff87fb7df$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $befb450ff87fb7df$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $befb450ff87fb7df$var$matchers.hex8.exec(color)) return {
        r: $befb450ff87fb7df$var$parseIntFromHex(match[1]),
        g: $befb450ff87fb7df$var$parseIntFromHex(match[2]),
        b: $befb450ff87fb7df$var$parseIntFromHex(match[3]),
        a: $befb450ff87fb7df$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $befb450ff87fb7df$var$matchers.hex6.exec(color)) return {
        r: $befb450ff87fb7df$var$parseIntFromHex(match[1]),
        g: $befb450ff87fb7df$var$parseIntFromHex(match[2]),
        b: $befb450ff87fb7df$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $befb450ff87fb7df$var$matchers.hex4.exec(color)) return {
        r: $befb450ff87fb7df$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $befb450ff87fb7df$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $befb450ff87fb7df$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $befb450ff87fb7df$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $befb450ff87fb7df$var$matchers.hex3.exec(color)) return {
        r: $befb450ff87fb7df$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $befb450ff87fb7df$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $befb450ff87fb7df$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $befb450ff87fb7df$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}

});


parcelRegister("52R4z", function(module, exports) {
$parcel$export(module.exports, "allHumanReadableColors", () => $269e4b47744deb60$export$37744bda14f72c19);

var $8MJq2 = parcelRequire("8MJq2");
const $269e4b47744deb60$export$37744bda14f72c19 = new Map([
    // background colors
    [
        "var(--ds-surface-overlay, #FFFFFF)".toLowerCase(),
        (0, $8MJq2.colorNames).defaultWhite
    ],
    [
        "var(--ds-background-accent-blue-subtlest, #E9F2FE)".toLowerCase(),
        (0, $8MJq2.colorNames).lightBlue
    ],
    [
        "var(--ds-background-accent-purple-subtlest, #F8EEFE)".toLowerCase(),
        (0, $8MJq2.colorNames).lightPurple
    ],
    [
        "var(--ds-background-accent-magenta-subtlest, #FFECF8)".toLowerCase(),
        (0, $8MJq2.colorNames).lightMagenta
    ],
    [
        "var(--ds-background-accent-red-subtlest, #FFECEB)".toLowerCase(),
        (0, $8MJq2.colorNames).lightRed
    ],
    [
        "var(--ds-background-accent-orange-subtlest, #FFF5DB)".toLowerCase(),
        (0, $8MJq2.colorNames).lightOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".toLowerCase(),
        (0, $8MJq2.colorNames).lightYellow
    ],
    [
        "var(--ds-background-accent-lime-subtlest, #EFFFD6)".toLowerCase(),
        (0, $8MJq2.colorNames).lightLime
    ],
    [
        "var(--ds-background-accent-green-subtlest, #DCFFF1)".toLowerCase(),
        (0, $8MJq2.colorNames).lightGreen
    ],
    [
        "var(--ds-background-accent-teal-subtlest, #E7F9FF)".toLowerCase(),
        (0, $8MJq2.colorNames).lightTeal
    ],
    [
        "var(--ds-background-accent-gray-subtler, #DDDEE1)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleGray
    ],
    [
        "var(--ds-background-accent-blue-subtler, #CFE1FD)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleBlue
    ],
    [
        "var(--ds-background-accent-purple-subtler, #EED7FC)".toLowerCase(),
        (0, $8MJq2.colorNames).subtlePurple
    ],
    [
        "var(--ds-background-accent-magenta-subtler, #FDD0EC)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleMagenta
    ],
    [
        "var(--ds-background-accent-red-subtler, #FFD5D2)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleRed
    ],
    [
        "var(--ds-background-accent-orange-subtler, #FCE4A6)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtler, #F5E989)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleYellow
    ],
    [
        "var(--ds-background-accent-lime-subtler, #D3F1A7)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleLime
    ],
    [
        "var(--ds-background-accent-green-subtler, #BAF3DB)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleGreen
    ],
    [
        "var(--ds-background-accent-teal-subtler, #C6EDFB)".toLowerCase(),
        (0, $8MJq2.colorNames).subtleTeal
    ],
    [
        "var(--ds-background-accent-gray-subtle, #8C8F97)".toLowerCase(),
        (0, $8MJq2.colorNames).gray
    ],
    [
        "var(--ds-background-accent-blue-subtle, #669DF1)".toLowerCase(),
        (0, $8MJq2.colorNames).blue
    ],
    [
        "var(--ds-background-accent-purple-subtle, #C97CF4)".toLowerCase(),
        (0, $8MJq2.colorNames).purple
    ],
    [
        "var(--ds-background-accent-magenta-subtle, #E774BB)".toLowerCase(),
        (0, $8MJq2.colorNames).magenta
    ],
    [
        "var(--ds-background-accent-red-subtle, #F87168)".toLowerCase(),
        (0, $8MJq2.colorNames).red
    ],
    [
        "var(--ds-background-accent-orange-subtle, #FCA700)".toLowerCase(),
        (0, $8MJq2.colorNames).orange
    ],
    [
        "var(--ds-background-accent-yellow-subtle, #EED12B)".toLowerCase(),
        (0, $8MJq2.colorNames).yellow
    ],
    [
        "var(--ds-background-accent-lime-subtle, #94C748)".toLowerCase(),
        (0, $8MJq2.colorNames).lime
    ],
    [
        "var(--ds-background-accent-green-subtle, #4BCE97)".toLowerCase(),
        (0, $8MJq2.colorNames).green
    ],
    [
        "var(--ds-background-accent-teal-subtle, #6CC3E0)".toLowerCase(),
        (0, $8MJq2.colorNames).teal
    ],
    [
        "var(--ds-text-brand, #1868DB)".toLowerCase(),
        (0, $8MJq2.colorNames).defaultBlue
    ],
    [
        "var(--ds-background-accent-gray-bolder, #6B6E76)".toLowerCase(),
        (0, $8MJq2.colorNames).boldGray
    ],
    [
        "var(--ds-background-accent-blue-bolder, #1868DB)".toLowerCase(),
        (0, $8MJq2.colorNames).boldBlue
    ],
    [
        "var(--ds-background-accent-purple-bolder, #964AC0)".toLowerCase(),
        (0, $8MJq2.colorNames).boldPurple
    ],
    [
        "var(--ds-background-accent-magenta-bolder, #AE4787)".toLowerCase(),
        (0, $8MJq2.colorNames).boldMagenta
    ],
    [
        "var(--ds-background-accent-red-bolder, #C9372C)".toLowerCase(),
        (0, $8MJq2.colorNames).boldRed
    ],
    [
        "var(--ds-background-accent-orange-bolder, #BD5B00)".toLowerCase(),
        (0, $8MJq2.colorNames).boldOrange
    ],
    [
        "var(--ds-background-accent-yellow-bolder, #946F00)".toLowerCase(),
        (0, $8MJq2.colorNames).boldYellow
    ],
    [
        "var(--ds-background-accent-lime-bolder, #5B7F24)".toLowerCase(),
        (0, $8MJq2.colorNames).boldLime
    ],
    [
        "var(--ds-background-accent-green-bolder, #1F845A)".toLowerCase(),
        (0, $8MJq2.colorNames).boldGreen
    ],
    [
        "var(--ds-background-accent-teal-bolder, #227D9B)".toLowerCase(),
        (0, $8MJq2.colorNames).boldTeal
    ],
    // text colors
    [
        "var(--ds-text, #292A2E)".toLowerCase(),
        (0, $8MJq2.colorNames).boldGray
    ],
    [
        "var(--ds-text-accent-blue-bolder, #123263)".toLowerCase(),
        (0, $8MJq2.colorNames).boldBlue
    ],
    [
        "var(--ds-text-accent-purple-bolder, #48245D)".toLowerCase(),
        (0, $8MJq2.colorNames).boldPurple
    ],
    [
        "var(--ds-text-accent-magenta-bolder, #50253F)".toLowerCase(),
        (0, $8MJq2.colorNames).boldMagenta
    ],
    [
        "var(--ds-text-accent-red-bolder, #5D1F1A)".toLowerCase(),
        (0, $8MJq2.colorNames).boldRed
    ],
    [
        "var(--ds-text-accent-orange-bolder, #693200)".toLowerCase(),
        (0, $8MJq2.colorNames).boldOrange
    ],
    [
        "var(--ds-text-accent-yellow-bolder, #533F04)".toLowerCase(),
        (0, $8MJq2.colorNames).boldYellow
    ],
    [
        "var(--ds-text-accent-lime-bolder, #37471F)".toLowerCase(),
        (0, $8MJq2.colorNames).boldLime
    ],
    [
        "var(--ds-text-accent-green-bolder, #164B35)".toLowerCase(),
        (0, $8MJq2.colorNames).boldGreen
    ],
    [
        "var(--ds-text-accent-teal-bolder, #164555)".toLowerCase(),
        (0, $8MJq2.colorNames).boldTeal
    ],
    [
        "var(--ds-text-subtle, #505258)".toLowerCase(),
        (0, $8MJq2.colorNames).gray
    ],
    [
        "var(--ds-text-accent-blue, #1558BC)".toLowerCase(),
        (0, $8MJq2.colorNames).blue
    ],
    [
        "var(--ds-text-accent-purple, #803FA5)".toLowerCase(),
        (0, $8MJq2.colorNames).purple
    ],
    [
        "var(--ds-text-accent-magenta, #943D73)".toLowerCase(),
        (0, $8MJq2.colorNames).magenta
    ],
    [
        "var(--ds-text-accent-red, #AE2E24)".toLowerCase(),
        (0, $8MJq2.colorNames).red
    ],
    [
        "var(--ds-text-accent-orange, #9E4C00)".toLowerCase(),
        (0, $8MJq2.colorNames).orange
    ],
    [
        "var(--ds-text-accent-yellow, #7F5F01)".toLowerCase(),
        (0, $8MJq2.colorNames).yellow
    ],
    [
        "var(--ds-text-accent-lime, #4C6B1F)".toLowerCase(),
        (0, $8MJq2.colorNames).lime
    ],
    [
        "var(--ds-text-accent-green, #216E4E)".toLowerCase(),
        (0, $8MJq2.colorNames).green
    ],
    [
        "var(--ds-text-accent-teal, #206A83)".toLowerCase(),
        (0, $8MJq2.colorNames).teal
    ],
    [
        "var(--ds-text-inverse, #FFFFFF)".toLowerCase(),
        (0, $8MJq2.colorNames).white
    ],
    // border colors
    [
        "var(--ds-border-accent-blue, #357DE8)".toLowerCase(),
        (0, $8MJq2.colorNames).blue
    ],
    [
        "var(--ds-border-accent-purple, #AF59E1)".toLowerCase(),
        (0, $8MJq2.colorNames).purple
    ],
    [
        "var(--ds-border-accent-magenta, #CD519D)".toLowerCase(),
        (0, $8MJq2.colorNames).magenta
    ],
    [
        "var(--ds-border-accent-red, #E2483D)".toLowerCase(),
        (0, $8MJq2.colorNames).red
    ],
    [
        "var(--ds-border-accent-orange, #E06C00)".toLowerCase(),
        (0, $8MJq2.colorNames).orange
    ],
    [
        "var(--ds-border-accent-yellow, #B38600)".toLowerCase(),
        (0, $8MJq2.colorNames).yellow
    ],
    [
        "var(--ds-border-accent-lime, #6A9A23)".toLowerCase(),
        (0, $8MJq2.colorNames).lime
    ],
    [
        "var(--ds-border-accent-green, #22A06B)".toLowerCase(),
        (0, $8MJq2.colorNames).green
    ],
    [
        "var(--ds-border-accent-teal, #2898BD)".toLowerCase(),
        (0, $8MJq2.colorNames).teal
    ],
    [
        "var(--ds-border-inverse, #FFFFFF)".toLowerCase(),
        (0, $8MJq2.colorNames).white
    ],
    [
        "var(--ds-border-accent-gray, #7D818A)".toLowerCase(),
        (0, $8MJq2.colorNames).gray
    ]
]);

});
parcelRegister("8MJq2", function(module, exports) {
$parcel$export(module.exports, "colorNames", () => $8ae449b8e221be22$export$88bbe6beac980300);

var $8p5Cv = parcelRequire("8p5Cv");
const $8ae449b8e221be22$export$88bbe6beac980300 = (0, $8p5Cv.defineMessages)({
    defaultWhite: {
        id: 'company-hub.color-picker.default-white',
        description: 'Name of default white color',
        defaultMessage: 'Default white'
    },
    white: {
        id: 'company-hub.color-picker.white',
        description: 'Name of white color',
        defaultMessage: 'White'
    },
    lightGray: {
        id: 'company-hub.color-picker.light-gray',
        description: 'Name of light gray color',
        defaultMessage: 'Light gray'
    },
    lightBlue: {
        id: 'company-hub.color-picker.light-blue',
        description: 'Name of light blue color',
        defaultMessage: 'Light blue'
    },
    lightPurple: {
        id: 'company-hub.color-picker.light-purple',
        description: 'Name of light purple color',
        defaultMessage: 'Light purple'
    },
    lightMagenta: {
        id: 'company-hub.color-picker.light-magenta',
        description: 'Name of light magenta color',
        defaultMessage: 'Light magenta'
    },
    lightRed: {
        id: 'company-hub.color-picker.light-red',
        description: 'Name of light red color',
        defaultMessage: 'Light red'
    },
    lightOrange: {
        id: 'company-hub.color-picker.light-orange',
        description: 'Name of light orange color',
        defaultMessage: 'Light orange'
    },
    lightYellow: {
        id: 'company-hub.color-picker.light-yellow',
        description: 'Name of light yellow color',
        defaultMessage: 'Light yellow'
    },
    lightLime: {
        id: 'company-hub.color-picker.light-lime',
        description: 'Name of light lime color',
        defaultMessage: 'Light lime'
    },
    lightGreen: {
        id: 'company-hub.color-picker.light-green',
        description: 'Name of light green color',
        defaultMessage: 'Light green'
    },
    lightTeal: {
        id: 'company-hub.color-picker.light-teal',
        description: 'Name of light teal color',
        defaultMessage: 'Light teal'
    },
    subtleGray: {
        id: 'company-hub.color-picker.subtle-gray',
        description: 'Name of subtle gray color',
        defaultMessage: 'Subtle gray'
    },
    subtleBlue: {
        id: 'company-hub.color-picker.subtle-blue',
        description: 'Name of subtle blue color',
        defaultMessage: 'Subtle blue'
    },
    subtlePurple: {
        id: 'company-hub.color-picker.subtle-purple',
        description: 'Name of subtle purple color',
        defaultMessage: 'Subtle purple'
    },
    subtleMagenta: {
        id: 'company-hub.color-picker.subtle-magenta',
        description: 'Name of subtle magenta color',
        defaultMessage: 'Subtle magenta'
    },
    subtleRed: {
        id: 'company-hub.color-picker.subtle-red',
        description: 'Name of subtle red color',
        defaultMessage: 'Subtle red'
    },
    subtleOrange: {
        id: 'company-hub.color-picker.subtle-orange',
        description: 'Name of subtle orange color',
        defaultMessage: 'Subtle orange'
    },
    subtleYellow: {
        id: 'company-hub.color-picker.subtle-yellow',
        description: 'Name of subtle yellow color',
        defaultMessage: 'Subtle yellow'
    },
    subtleLime: {
        id: 'company-hub.color-picker.subtle-lime',
        description: 'Name of subtle lime color',
        defaultMessage: 'Subtle lime'
    },
    subtleGreen: {
        id: 'company-hub.color-picker.subtle-green',
        description: 'Name of subtle green color',
        defaultMessage: 'Subtle green'
    },
    subtleTeal: {
        id: 'company-hub.color-picker.subtle-teal',
        description: 'Name of subtle teal color',
        defaultMessage: 'Subtle teal'
    },
    gray: {
        id: 'company-hub.color-picker.gray',
        description: 'Name of gray color',
        defaultMessage: 'Gray'
    },
    blue: {
        id: 'company-hub.color-picker.blue',
        description: 'Name of blue color',
        defaultMessage: 'Blue'
    },
    purple: {
        id: 'company-hub.color-picker.purple',
        description: 'Name of purple color',
        defaultMessage: 'Purple'
    },
    magenta: {
        id: 'company-hub.color-picker.magenta',
        description: 'Name of magenta color',
        defaultMessage: 'Magenta'
    },
    red: {
        id: 'company-hub.color-picker.red',
        description: 'Name of red color',
        defaultMessage: 'Red'
    },
    orange: {
        id: 'company-hub.color-picker.orange',
        description: 'Name of orange color',
        defaultMessage: 'Orange'
    },
    yellow: {
        id: 'company-hub.color-picker.yellow',
        description: 'Name of yellow color',
        defaultMessage: 'Yellow'
    },
    lime: {
        id: 'company-hub.color-picker.lime',
        description: 'Name of lime color',
        defaultMessage: 'Lime'
    },
    green: {
        id: 'company-hub.color-picker.green',
        description: 'Name of green color',
        defaultMessage: 'Green'
    },
    teal: {
        id: 'company-hub.color-picker.teal',
        description: 'Name of teal color',
        defaultMessage: 'Teal'
    },
    boldGray: {
        id: 'company-hub.color-picker.bold-gray',
        description: 'Name of bold gray color',
        defaultMessage: 'Bold gray'
    },
    boldBlue: {
        id: 'company-hub.color-picker.bold-blue',
        description: 'Name of bold blue color',
        defaultMessage: 'Bold blue'
    },
    boldPurple: {
        id: 'company-hub.color-picker.bold-purple',
        description: 'Name of bold purple color',
        defaultMessage: 'Bold purple'
    },
    boldMagenta: {
        id: 'company-hub.color-picker.bold-magenta',
        description: 'Name of bold magenta color',
        defaultMessage: 'Bold magenta'
    },
    boldRed: {
        id: 'company-hub.color-picker.bold-red',
        description: 'Name of bold red color',
        defaultMessage: 'Bold red'
    },
    boldOrange: {
        id: 'company-hub.color-picker.bold-orange',
        description: 'Name of bold orange color',
        defaultMessage: 'Bold orange'
    },
    boldYellow: {
        id: 'company-hub.color-picker.bold-yellow',
        description: 'Name of bold yellow color',
        defaultMessage: 'Bold yellow'
    },
    boldLime: {
        id: 'company-hub.color-picker.bold-lime',
        description: 'Name of bold lime color',
        defaultMessage: 'Bold lime'
    },
    boldGreen: {
        id: 'company-hub.color-picker.bold-green',
        description: 'Name of bold green color',
        defaultMessage: 'Bold green'
    },
    boldTeal: {
        id: 'company-hub.color-picker.bold-teal',
        description: 'Name of bold teal color',
        defaultMessage: 'Bold teal'
    },
    defaultBlue: {
        id: 'company-hub.color-picker.default-blue',
        description: 'Name of default blue color',
        defaultMessage: 'Default blue'
    }
});

});



parcelRegister("bRst2", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $2a608c23aefe105a$export$3d31854eb05903e0);

var $dOEaD = parcelRequire("dOEaD");

var $8xOOU = parcelRequire("8xOOU");

var $aaElU = parcelRequire("aaElU");
const $2a608c23aefe105a$export$3d31854eb05903e0 = (color, packageName)=>{
    try {
        // Convert to HEX as polished's getLuminance only accepts HEX colors
        const hexColor = (0, $aaElU.toHexColor)(color);
        return (0, $dOEaD.getLuminance)(hexColor) > 0.5 ? "var(--ds-text, #292A2E)" : "var(--ds-text-inverse, #FFFFFF)";
    } catch (error) {
        (0, $8xOOU.default)({
            error: error instanceof Error ? error : new Error(`Color luminance calculation failed for color: ${color}`),
            meta: {
                id: 'readableTextColor',
                packageName: packageName
            }
        });
        // Fallback to text color
        return "var(--ds-text, #292A2E)";
    }
};

});
parcelRegister("dOEaD", function(module, exports) {
$parcel$export(module.exports, "getLuminance", () => $a0ef1ae3d49c250a$export$c852d90bf7403b62);
//      
// @private
function $a0ef1ae3d49c250a$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//      
var $a0ef1ae3d49c250a$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $a0ef1ae3d49c250a$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return '' + acc + $a0ef1ae3d49c250a$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
    return property === joinedProperty ? '' + property + position : joinedProperty;
}
function $a0ef1ae3d49c250a$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$a0ef1ae3d49c250a$var$generateProperty(property, $a0ef1ae3d49c250a$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $a0ef1ae3d49c250a$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === undefined ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === undefined ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === undefined ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $a0ef1ae3d49c250a$var$generateStyles(property, valuesWithDefaults);
}
//      
function $a0ef1ae3d49c250a$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
//      
/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $a0ef1ae3d49c250a$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
//      
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $a0ef1ae3d49c250a$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$a0ef1ae3d49c250a$var$endsWith(pxval, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
            newPxval = $a0ef1ae3d49c250a$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$a0ef1ae3d49c250a$var$endsWith(base, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
            newBase = $a0ef1ae3d49c250a$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
        if (typeof newBase === 'string') throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
        return '' + newPxval / newBase + to;
    };
};
//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $a0ef1ae3d49c250a$export$c63c6f932822f543 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$pxtoFactory('em');
//      
var $a0ef1ae3d49c250a$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $a0ef1ae3d49c250a$export$c82a8a23c9e8bdb6(steps) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$a0ef1ae3d49c250a$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $a0ef1ae3d49c250a$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $a0ef1ae3d49c250a$var$ratioNames[ratio] : ratio;
    if (typeof realBase === 'string') throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
    return realBase * Math.pow(realRatio, steps) + 'em';
}
//      
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $a0ef1ae3d49c250a$export$fb1897a40d146f7f = /*#__PURE__*/ $a0ef1ae3d49c250a$var$pxtoFactory('rem');
//      
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $a0ef1ae3d49c250a$export$8c467e8859fdef13() {
    var _ref;
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
    var pseudoSelector = parent + '::after';
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
//      
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $a0ef1ae3d49c250a$export$a5b94313d6908893() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
//      
/** */ function $a0ef1ae3d49c250a$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + '.' + format + '")';
    });
    return fileFontReferences.join(', ');
}
function $a0ef1ae3d49c250a$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(', ');
}
function $a0ef1ae3d49c250a$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($a0ef1ae3d49c250a$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($a0ef1ae3d49c250a$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $a0ef1ae3d49c250a$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === undefined ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $a0ef1ae3d49c250a$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight
        }
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
//      
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $a0ef1ae3d49c250a$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
//      
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $a0ef1ae3d49c250a$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
//      
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $a0ef1ae3d49c250a$export$e79006618d7c6cc3() {
    var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
var $a0ef1ae3d49c250a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a0ef1ae3d49c250a$var$taggedTemplateLiteralLoose = function(strings, raw) {
    strings.raw = raw;
    return strings;
};
var $a0ef1ae3d49c250a$var$_opinionatedRules;
var $a0ef1ae3d49c250a$var$_abbrTitle;
var $a0ef1ae3d49c250a$var$_unopinionatedRules;
//      
var $a0ef1ae3d49c250a$var$opinionatedRules = ($a0ef1ae3d49c250a$var$_opinionatedRules = {
    html: {
        fontFamily: 'sans-serif'
    },
    body: {
        margin: '0'
    }
}, $a0ef1ae3d49c250a$var$_opinionatedRules['a:active,\n  a:hover'] = {
    outlineWidth: '0'
}, $a0ef1ae3d49c250a$var$_opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    fontFamily: 'sans-serif',
    fontSize: '100%',
    lineHeight: '1.15'
}, $a0ef1ae3d49c250a$var$_opinionatedRules);
var $a0ef1ae3d49c250a$var$unopinionatedRules = ($a0ef1ae3d49c250a$var$_unopinionatedRules = {
    html: {
        lineHeight: '1.15',
        textSizeAdjust: '100%'
    }
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
    display: 'block'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.h1 = {
    fontSize: '2em',
    margin: '0.67em 0'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['figcaption,\n  figure,\n  main'] = {
    display: 'block'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.figure = {
    margin: '1em 40px'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.hr = {
    boxSizing: 'content-box',
    height: '0',
    overflow: 'visible'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.pre = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.a = {
    'background-color': 'transparent',
    '-webkit-text-decoration-skip': 'objects'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['abbr[title]'] = ($a0ef1ae3d49c250a$var$_abbrTitle = {
    borderBottom: 'none',
    textDecoration: 'underline'
}, $a0ef1ae3d49c250a$var$_abbrTitle['textDecoration'] = 'underline dotted', $a0ef1ae3d49c250a$var$_abbrTitle), $a0ef1ae3d49c250a$var$_unopinionatedRules['b,\n  strong'] = {
    fontWeight: 'inherit'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['code,\n  kbd,\n  samp'] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.dfn = {
    fontStyle: 'italic'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.mark = {
    backgroundColor: '#ff0',
    color: '#000'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.small = {
    fontSize: '80%'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['sub,\n  sup'] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.sub = {
    bottom: '-0.25em'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.sup = {
    top: '-0.5em'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['audio,\n  video'] = {
    display: 'inline-block'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['audio:not([controls])'] = {
    display: 'none',
    height: '0'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.img = {
    borderStyle: 'none'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['svg:not(:root)'] = {
    overflow: 'hidden'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    margin: '0'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['button,\n  input'] = {
    overflow: 'visible'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['button,\n  select'] = {
    textTransform: 'none'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
    '-webkit-appearance': 'button'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
    borderStyle: 'none',
    padding: '0'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
    outline: '1px dotted ButtonText'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.fieldset = {
    border: '1px solid #c0c0c0',
    margin: '0 2px',
    padding: '0.35em 0.625em 0.75em'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.progress = {
    display: 'inline-block',
    verticalAlign: 'baseline'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.textarea = {
    overflow: 'auto'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
    boxSizing: 'border-box',
    padding: '0'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
    height: 'auto'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['[type="search"]'] = {
    '-webkit-appearance': 'textfield',
    outlineOffset: '-2px'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
    '-webkit-appearance': 'none'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['::-webkit-file-upload-button'] = {
    '-webkit-appearance': 'button',
    font: 'inherit'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['details,\n  menu'] = {
    display: 'block'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.summary = {
    display: 'list-item'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.canvas = {
    display: 'inline-block'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules.template = {
    display: 'none'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules['[hidden]'] = {
    display: 'none'
}, $a0ef1ae3d49c250a$var$_unopinionatedRules);
function $a0ef1ae3d49c250a$var$mergeRules(baseRules, additionalRules) {
    var mergedRules = $a0ef1ae3d49c250a$var$_extends({}, baseRules);
    Object.keys(additionalRules).forEach(function(key) {
        if (mergedRules[key]) mergedRules[key] = $a0ef1ae3d49c250a$var$_extends({}, mergedRules[key], additionalRules[key]);
        else mergedRules[key] = $a0ef1ae3d49c250a$var$_extends({}, additionalRules[key]);
    });
    return mergedRules;
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $a0ef1ae3d49c250a$export$a3295358bff77e(excludeOpinionated) {
    if (excludeOpinionated) return $a0ef1ae3d49c250a$var$unopinionatedRules;
    return $a0ef1ae3d49c250a$var$mergeRules($a0ef1ae3d49c250a$var$unopinionatedRules, $a0ef1ae3d49c250a$var$opinionatedRules);
}
//      
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $a0ef1ae3d49c250a$export$c7187bbd1a7a9244(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
    return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = $a0ef1ae3d49c250a$var$_extends({}, styles), _ref[parent + ':-moz-placeholder'] = $a0ef1ae3d49c250a$var$_extends({}, styles), _ref[parent + '::-moz-placeholder'] = $a0ef1ae3d49c250a$var$_extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = $a0ef1ae3d49c250a$var$_extends({}, styles), _ref;
}
var $a0ef1ae3d49c250a$var$_templateObject = /*#__PURE__*/ $a0ef1ae3d49c250a$var$taggedTemplateLiteralLoose([
    'radial-gradient(',
    '',
    '',
    '',
    ')'
], [
    'radial-gradient(',
    '',
    '',
    '',
    ')'
]);
//      
/** */ function $a0ef1ae3d49c250a$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $a0ef1ae3d49c250a$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        // Adds leading coma if properties preceed color-stops
        if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $a0ef1ae3d49c250a$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $a0ef1ae3d49c250a$var$parseFallback(colorStops),
        backgroundImage: $a0ef1ae3d49c250a$var$constructGradientValue($a0ef1ae3d49c250a$var$_templateObject, position, shape, extent, colorStops.join(', '))
    };
}
//      
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $a0ef1ae3d49c250a$export$19389033401d366a(filename, backgroundSize) {
    var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
    var _ref;
    var retinaFilename = arguments[3];
    var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
    return _ref = {
        backgroundImage: 'url(' + filename + '.' + ext + ')'
    }, _ref[$a0ef1ae3d49c250a$export$e79006618d7c6cc3()] = {
        backgroundImage: 'url(' + rFilename + ')',
        backgroundSize: backgroundSize
    }, _ref;
}
//      
/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $a0ef1ae3d49c250a$export$7c69810f7b8835c9(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return _ref = {}, _ref[parent + '::-moz-selection'] = $a0ef1ae3d49c250a$var$_extends({}, styles), _ref[parent + '::selection'] = $a0ef1ae3d49c250a$var$_extends({}, styles), _ref;
}
//      
/* eslint-disable key-spacing */ var $a0ef1ae3d49c250a$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $a0ef1ae3d49c250a$export$61210fa83792a81(timingFunction) {
    return $a0ef1ae3d49c250a$var$functionsMap[timingFunction];
}
//      
/** */ var $a0ef1ae3d49c250a$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
        case 'left':
            return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
        case 'bottom':
            return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
        case 'right':
            return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
};
// needed for border-color
var $a0ef1ae3d49c250a$var$reverseDirection = {
    left: 'Right',
    right: 'Left',
    top: 'Bottom',
    bottom: 'Top'
};
function $a0ef1ae3d49c250a$export$9eed783d03e0135c(_ref) {
    var _ref2;
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
    var unitlessHeight = parseFloat(height);
    var unitlessWidth = parseFloat(width);
    if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    return _ref2 = {
        borderColor: backgroundColor,
        width: '0',
        height: '0',
        borderWidth: $a0ef1ae3d49c250a$var$getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
        borderStyle: 'solid'
    }, _ref2['border' + $a0ef1ae3d49c250a$var$reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}
//      
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $a0ef1ae3d49c250a$export$dca3d8ad656c34d2() {
    var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
//      
function $a0ef1ae3d49c250a$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $a0ef1ae3d49c250a$var$convertToInt(red, green, blue) {
    return $a0ef1ae3d49c250a$var$colorToInt(red) + "," + $a0ef1ae3d49c250a$var$colorToInt(green) + "," + $a0ef1ae3d49c250a$var$colorToInt(blue);
}
function $a0ef1ae3d49c250a$var$hslToRgb(hue, saturation, lightness) {
    var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a0ef1ae3d49c250a$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
//      
var $a0ef1ae3d49c250a$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $a0ef1ae3d49c250a$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $a0ef1ae3d49c250a$var$namedColorMap[normalizedColorName] ? '#' + $a0ef1ae3d49c250a$var$namedColorMap[normalizedColorName] : color;
}
//      
var $a0ef1ae3d49c250a$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $a0ef1ae3d49c250a$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $a0ef1ae3d49c250a$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $a0ef1ae3d49c250a$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $a0ef1ae3d49c250a$var$hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $a0ef1ae3d49c250a$var$hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $a0ef1ae3d49c250a$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $a0ef1ae3d49c250a$var$nameToHex(color);
    if (normalizedColor.match($a0ef1ae3d49c250a$var$hexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($a0ef1ae3d49c250a$var$reducedHexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
    var rgbMatched = $a0ef1ae3d49c250a$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt('' + rgbMatched[1], 10),
        green: parseInt('' + rgbMatched[2], 10),
        blue: parseInt('' + rgbMatched[3], 10)
    };
    var rgbaMatched = $a0ef1ae3d49c250a$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt('' + rgbaMatched[1], 10),
        green: parseInt('' + rgbaMatched[2], 10),
        blue: parseInt('' + rgbaMatched[3], 10),
        alpha: parseFloat('' + rgbaMatched[4])
    };
    var hslMatched = $a0ef1ae3d49c250a$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt('' + hslMatched[1], 10);
        var saturation = parseInt('' + hslMatched[2], 10) / 100;
        var lightness = parseInt('' + hslMatched[3], 10) / 100;
        var rgbColorString = 'rgb(' + $a0ef1ae3d49c250a$var$hslToRgb(hue, saturation, lightness) + ')';
        var hslRgbMatched = $a0ef1ae3d49c250a$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
        return {
            red: parseInt('' + hslRgbMatched[1], 10),
            green: parseInt('' + hslRgbMatched[2], 10),
            blue: parseInt('' + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $a0ef1ae3d49c250a$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt('' + hslaMatched[1], 10);
        var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
        var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
        var _rgbColorString = 'rgb(' + $a0ef1ae3d49c250a$var$hslToRgb(_hue, _saturation, _lightness) + ')';
        var _hslRgbMatched = $a0ef1ae3d49c250a$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
        return {
            red: parseInt('' + _hslRgbMatched[1], 10),
            green: parseInt('' + _hslRgbMatched[2], 10),
            blue: parseInt('' + _hslRgbMatched[3], 10),
            alpha: parseFloat('' + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
//      
function $a0ef1ae3d49c250a$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue = void 0;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
//      
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $a0ef1ae3d49c250a$var$rgbToHsl($a0ef1ae3d49c250a$export$2f48baff6995707a(color));
}
//      
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $a0ef1ae3d49c250a$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
//      
function $a0ef1ae3d49c250a$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $a0ef1ae3d49c250a$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $a0ef1ae3d49c250a$var$reduceHexValue('#' + $a0ef1ae3d49c250a$var$numberToHex(value) + $a0ef1ae3d49c250a$var$numberToHex(green) + $a0ef1ae3d49c250a$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $a0ef1ae3d49c250a$var$reduceHexValue('#' + $a0ef1ae3d49c250a$var$numberToHex(value.red) + $a0ef1ae3d49c250a$var$numberToHex(value.green) + $a0ef1ae3d49c250a$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $a0ef1ae3d49c250a$export$2f48baff6995707a(firstValue);
        return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $a0ef1ae3d49c250a$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $a0ef1ae3d49c250a$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
//      
function $a0ef1ae3d49c250a$var$colorToHex(color) {
    return $a0ef1ae3d49c250a$var$numberToHex(Math.round(color * 255));
}
function $a0ef1ae3d49c250a$var$convertToHex(red, green, blue) {
    return $a0ef1ae3d49c250a$var$reduceHexValue('#' + $a0ef1ae3d49c250a$var$colorToHex(red) + $a0ef1ae3d49c250a$var$colorToHex(green) + $a0ef1ae3d49c250a$var$colorToHex(blue));
}
function $a0ef1ae3d49c250a$var$hslToHex(hue, saturation, lightness) {
    return $a0ef1ae3d49c250a$var$hslToRgb(hue, saturation, lightness, $a0ef1ae3d49c250a$var$convertToHex);
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $a0ef1ae3d49c250a$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $a0ef1ae3d49c250a$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $a0ef1ae3d49c250a$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $a0ef1ae3d49c250a$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $a0ef1ae3d49c250a$var$hslToHex(value, saturation, lightness) : 'rgba(' + $a0ef1ae3d49c250a$var$hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $a0ef1ae3d49c250a$var$hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + $a0ef1ae3d49c250a$var$hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
//      
var $a0ef1ae3d49c250a$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $a0ef1ae3d49c250a$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $a0ef1ae3d49c250a$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $a0ef1ae3d49c250a$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $a0ef1ae3d49c250a$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $a0ef1ae3d49c250a$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($a0ef1ae3d49c250a$var$errMsg);
    if ($a0ef1ae3d49c250a$var$isRgba(color)) return $a0ef1ae3d49c250a$export$4e46ac54fc82cf3b(color);
    if ($a0ef1ae3d49c250a$var$isRgb(color)) return $a0ef1ae3d49c250a$export$8972dc0e6ad9238f(color);
    if ($a0ef1ae3d49c250a$var$isHsla(color)) return $a0ef1ae3d49c250a$export$810b04175080204c(color);
    if ($a0ef1ae3d49c250a$var$isHsl(color)) return $a0ef1ae3d49c250a$export$8f4a7c0bb78e6ea8(color);
    throw new Error($a0ef1ae3d49c250a$var$errMsg);
}
//      
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $a0ef1ae3d49c250a$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $a0ef1ae3d49c250a$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $a0ef1ae3d49c250a$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $a0ef1ae3d49c250a$var$curried(f, f.length, []);
}
//      
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$adjustHue(degree, color) {
    var hslColor = $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, hslColor, {
        hue: (hslColor.hue + degree) % 360
    }));
}
var $a0ef1ae3d49c250a$export$2b372a09365374d6 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$adjustHue);
//      
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
//      
function $a0ef1ae3d49c250a$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
//      
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$darken(amount, color) {
    var hslColor = $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, hslColor, {
        lightness: $a0ef1ae3d49c250a$var$guard(0, 1, hslColor.lightness - amount)
    }));
}
var $a0ef1ae3d49c250a$export$4b073707ff63303 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$darken);
//      
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$desaturate(amount, color) {
    var hslColor = $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, hslColor, {
        saturation: $a0ef1ae3d49c250a$var$guard(0, 1, hslColor.saturation - amount)
    }));
}
var $a0ef1ae3d49c250a$export$fb75607d98509d9 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$desaturate);
//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $a0ef1ae3d49c250a$export$c852d90bf7403b62(color) {
    var rgbColor = $a0ef1ae3d49c250a$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
//      
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$export$6f416a6db2dfcd5c(color) {
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
//      
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $a0ef1ae3d49c250a$export$2f48baff6995707a(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
//      
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$lighten(amount, color) {
    var hslColor = $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, hslColor, {
        lightness: $a0ef1ae3d49c250a$var$guard(0, 1, hslColor.lightness + amount)
    }));
}
var $a0ef1ae3d49c250a$export$c0816ed86df316af = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$lighten);
//      
/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $a0ef1ae3d49c250a$var$mix() {
    var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
    var color = arguments[1];
    var otherColor = arguments[2];
    var parsedColor1 = $a0ef1ae3d49c250a$export$2f48baff6995707a(color);
    var color1 = $a0ef1ae3d49c250a$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $a0ef1ae3d49c250a$export$2f48baff6995707a(otherColor);
    var color2 = $a0ef1ae3d49c250a$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = weight * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
    };
    return $a0ef1ae3d49c250a$export$4e46ac54fc82cf3b(mixedColor);
}
var $a0ef1ae3d49c250a$export$2c9e8a9632a706b2 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$mix);
//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$opacify(amount, color) {
    var parsedColor = $a0ef1ae3d49c250a$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $a0ef1ae3d49c250a$var$_extends({}, parsedColor, {
        alpha: $a0ef1ae3d49c250a$var$guard(0, 1, (alpha * 100 + amount * 100) / 100)
    });
    return $a0ef1ae3d49c250a$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $a0ef1ae3d49c250a$export$f4f50e3877dd0530 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$opacify);
//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $a0ef1ae3d49c250a$var$readableColor(color) {
    return $a0ef1ae3d49c250a$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
var $a0ef1ae3d49c250a$export$61654c1796c44811 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$readableColor);
//      
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$saturate(amount, color) {
    var hslColor = $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color);
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, hslColor, {
        saturation: $a0ef1ae3d49c250a$var$guard(0, 1, hslColor.saturation + amount)
    }));
}
var $a0ef1ae3d49c250a$export$5fcac96f5a87e3db = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$saturate);
//      
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$setHue(hue, color) {
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color), {
        hue: hue
    }));
}
var $a0ef1ae3d49c250a$export$3bf58ce3e497a846 = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$setHue);
//      
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$setLightness(lightness, color) {
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color), {
        lightness: lightness
    }));
}
var $a0ef1ae3d49c250a$export$7ef5d725337b805d = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$setLightness);
//      
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $a0ef1ae3d49c250a$var$setSaturation(saturation, color) {
    return $a0ef1ae3d49c250a$export$42fe740cdf79b2df($a0ef1ae3d49c250a$var$_extends({}, $a0ef1ae3d49c250a$export$1286688e1b3fde9c(color), {
        saturation: saturation
    }));
}
var $a0ef1ae3d49c250a$export$b40fe421ea7a4f7e = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$setSaturation);
//      
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $a0ef1ae3d49c250a$var$shade(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $a0ef1ae3d49c250a$export$2c9e8a9632a706b2(percentage, color, 'rgb(0, 0, 0)');
}
var $a0ef1ae3d49c250a$export$3e32adda0df4ef5d = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$shade);
//      
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $a0ef1ae3d49c250a$var$tint(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $a0ef1ae3d49c250a$export$2c9e8a9632a706b2(percentage, color, 'rgb(255, 255, 255)');
}
var $a0ef1ae3d49c250a$export$fc176dd65a27d98b = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$tint);
//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $a0ef1ae3d49c250a$var$transparentize(amount, color) {
    var parsedColor = $a0ef1ae3d49c250a$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $a0ef1ae3d49c250a$var$_extends({}, parsedColor, {
        alpha: $a0ef1ae3d49c250a$var$guard(0, 1, (alpha * 100 - amount * 100) / 100)
    });
    return $a0ef1ae3d49c250a$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $a0ef1ae3d49c250a$export$d11da87e55cc498f = /*#__PURE__*/ $a0ef1ae3d49c250a$var$curry($a0ef1ae3d49c250a$var$transparentize);
//      
/** */ /**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $a0ef1ae3d49c250a$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
//      
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $a0ef1ae3d49c250a$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $a0ef1ae3d49c250a$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $a0ef1ae3d49c250a$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
        'borderColor'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $a0ef1ae3d49c250a$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $a0ef1ae3d49c250a$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $a0ef1ae3d49c250a$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
        'borderStyle'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $a0ef1ae3d49c250a$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
        'borderWidth'
    ].concat(values));
}
//      
function $a0ef1ae3d49c250a$var$generateSelectors(template, state) {
    var stateSuffix = state ? ':' + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $a0ef1ae3d49c250a$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $a0ef1ae3d49c250a$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($a0ef1ae3d49c250a$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
//      
var $a0ef1ae3d49c250a$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $a0ef1ae3d49c250a$var$template(state) {
    return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $a0ef1ae3d49c250a$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$var$statefulSelectors(states, $a0ef1ae3d49c250a$var$template, $a0ef1ae3d49c250a$var$stateMap);
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $a0ef1ae3d49c250a$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
        'margin'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $a0ef1ae3d49c250a$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
        'padding'
    ].concat(values));
}
//      
var $a0ef1ae3d49c250a$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $a0ef1ae3d49c250a$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($a0ef1ae3d49c250a$var$positionMap$1.indexOf(positionKeyword) >= 0) return $a0ef1ae3d49c250a$var$_extends({
        position: positionKeyword
    }, $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $a0ef1ae3d49c250a$export$4fc00c04dd60af95.apply(undefined, [
            '',
            firstValue
        ].concat(values));
    }
}
//      
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $a0ef1ae3d49c250a$export$346677f925de839c(height) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
    return {
        height: height,
        width: width
    };
}
//      
var $a0ef1ae3d49c250a$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $a0ef1ae3d49c250a$var$template$1(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $a0ef1ae3d49c250a$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $a0ef1ae3d49c250a$var$statefulSelectors(states, $a0ef1ae3d49c250a$var$template$1, $a0ef1ae3d49c250a$var$stateMap$1);
}
//      
/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */ function $a0ef1ae3d49c250a$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        transition: properties.join(', ')
    };
}

});


parcelRegister("4Q8Rn", function(module, exports) {
$parcel$export(module.exports, "HUB_COLOR_CSS_VARS", () => $81decb526ae8cf2c$export$6e4a1de0ca7c3086);
/**
 * Centralised registry of `--hub-*` CSS custom-property names emitted by
 * `<HubThemingProvider>`'s wrapper `<div>`. These are the **only** v2 CSS-var
 * names extension code references — never hand-write `--hub-*` strings at the
 * call site.
 *
 * Why centralised:
 *   • Single rename point — change a name here, every consumer follows.
 *   • Type-safe lookup via `PaletteRef` — typo "primary.150" fails the build.
 *   • `resolveAdfColor` derives its `var(--hub-color-...)` output from this
 *     registry, so the renderer never sees raw var-name strings.
 *
 * Naming convention:
 *   --hub-color-{family}-{shade}    → e.g. --hub-color-primary-200
 *   --hub-color-{semantic}          → e.g. --hub-color-text-on-primary
 *   --hub-radius-{slot}             → reserved for future radius work
 *   --hub-space-{slot}              → reserved for future density work
 *
 * The wrapper div emits the registry as inline `style` so the values are
 * present in the SSR HTML on first paint — no useEffect, no setProperty.
 */ const $81decb526ae8cf2c$var$SHADES = [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '1000'
];
const $81decb526ae8cf2c$var$FAMILIES = [
    'primary',
    'accent'
];
const $81decb526ae8cf2c$var$buildColorVarMap = ()=>{
    const out = {};
    for (const family of $81decb526ae8cf2c$var$FAMILIES)for (const shade of $81decb526ae8cf2c$var$SHADES){
        const ref = `${family}.${shade}`;
        out[ref] = `--hub-color-${family}-${shade}`;
    }
    return out;
};
const $81decb526ae8cf2c$export$6e4a1de0ca7c3086 = Object.freeze($81decb526ae8cf2c$var$buildColorVarMap());
const $81decb526ae8cf2c$export$83d6614a5062fafa = Object.freeze({
    color: $81decb526ae8cf2c$export$6e4a1de0ca7c3086
});

});

parcelRegister("gN0s7", function(module, exports) {
$parcel$export(module.exports, "toAdfColor", () => $416ce35c5855faa2$export$3b6ce31dec9a22fc);
/**
 * Picker → ADF storage adapter.
 *
 * If the hex emitted by the color-picker matches a shade in the active brand
 * palette, persist the CSS-var reference for that shade (e.g.
 * `"var(--hub-color-primary-300)"`) so the value tracks future brand-color
 * edits via the browser's CSS cascade — no resolver call, no JS palette
 * lookup at render time. Otherwise persist the raw hex (frozen literal).
 *
 * Pure case-insensitive lookup, no normalisation — relies on the picker
 * emitting hex in the same casing the palette uses (`csm-colour-theme-generator`
 * outputs lowercase). Pure, synchronous, no side effects → SSR-safe.
 */ 
var $leSAN = parcelRequire("leSAN");

var $4Q8Rn = parcelRequire("4Q8Rn");
const $416ce35c5855faa2$export$3b6ce31dec9a22fc = (hex, palette, opts)=>{
    if (opts !== null && opts !== void 0 && opts.isBrandPaletteLocked) {
        // Locked tenants have no palette to track — the picker offers exactly
        // one brand swatch (the admin's primary) plus custom hex. Anchor a
        // primary pick to `--hub-primary-color`, which `HubThemingProvider`
        // keeps pointed at the live brand colour, so the element keeps
        // following future brand-colour edits.
        //
        // The palette path below would *look* like it works — `generateColors`
        // substitutes the brand hex into whichever ramp slot is
        // luminance-closest, so the pick does match a shade — but that slot
        // index is a function of the brand colour. Re-brand and the persisted
        // `--hub-color-primary-<N>` resolves to an unrelated tint of the new
        // hue instead of the new brand colour. And when the primary isn't a
        // hex `generateThemeBranding` can parse, it appears nowhere in the
        // ramp and the pick is persisted as a bare literal with no var at all.
        if (opts.primaryColor && hex.toLowerCase() === opts.primaryColor.toLowerCase()) return `var(${0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR}, ${hex})`;
        // Anything else is a custom colour: freeze it, so an un-entitled
        // tenant can't persist a palette-shade ref via a stale current value.
        return hex;
    }
    const lower = hex.toLowerCase();
    for (const [ref, shadeHex] of Object.entries(palette)){
        if (shadeHex.toLowerCase() === lower) // Hex fallback after the CSS var name lets the value still resolve
        // to a usable color when the wrapper isn't in scope (e.g. shared
        // extensions rendered in Confluence Company Hub, or color helpers
        // like `extractColorCode` that look up the var on `documentElement`
        // rather than the wrapper). The browser uses the wrapper's live
        // value when the var is defined (so brand-color edits still track
        // inside the hub), and falls back to this snapshot hex otherwise.
        return `var(${(0, $4Q8Rn.HUB_COLOR_CSS_VARS)[ref]}, ${shadeHex})`;
    }
    return hex;
};

});

parcelRegister("2dO3w", function(module, exports) {
$parcel$export(module.exports, "useHubBrandPalette", () => $13bd50e2a1589b2b$export$52531ed83ceae9ec);

var $fc4bM = parcelRequire("fc4bM");

var $5zxCi = parcelRequire("5zxCi");
const $13bd50e2a1589b2b$export$52531ed83ceae9ec = (inputs)=>{
    const { primary: primary, accent: accent } = inputs;
    return (0, $fc4bM.useMemo)(()=>(0, $5zxCi.generateHubBrandPalette)({
            primary: primary,
            accent: accent
        }), [
        primary,
        accent
    ]);
};

});
parcelRegister("5zxCi", function(module, exports) {
$parcel$export(module.exports, "generateHubBrandPalette", () => $0243cb47e7c09f67$export$fb2e77ab23c1ab27);
/**
 * Build a 20-shade `HubBrandPalette` from a (primary, accent) brand colour
 * pair, per §4.1 of the Advanced Theming v2 design.
 *
 * Implementation note: this is a thin wrapper around the existing CSM colour
 * theme generator (which is also what `setHubBrandingStyle` already uses).
 * That generator runs the same Material-HCT-based 10-step ramp algorithm as
 * `@atlaskit/tokens`'s internal `generateColors`, but is exposed via a public
 * entry-point and is already a hubs dependency, so we don't have to duplicate
 * the colour science.
 *
 * Pure and synchronous — safe to call during render, including SSR.
 */ 
var $h46Vs = parcelRequire("h46Vs");
const $0243cb47e7c09f67$var$SHADES = [
    [
        '100',
        'color100'
    ],
    [
        '200',
        'color200'
    ],
    [
        '300',
        'color300'
    ],
    [
        '400',
        'color400'
    ],
    [
        '500',
        'color500'
    ],
    [
        '600',
        'color600'
    ],
    [
        '700',
        'color700'
    ],
    [
        '800',
        'color800'
    ],
    [
        '900',
        'color900'
    ],
    [
        '1000',
        'color1000'
    ]
];
const $0243cb47e7c09f67$var$buildFamily = (family, hex)=>{
    const ramp = (0, $h46Vs.generateThemeBranding)(hex);
    const out = {};
    for (const [shade, rampKey] of $0243cb47e7c09f67$var$SHADES){
        const key = `${family}.${shade}`;
        out[key] = ramp[rampKey];
    }
    return out;
};
const $0243cb47e7c09f67$export$fb2e77ab23c1ab27 = ({ primary: primary, accent: accent })=>{
    return {
        ...$0243cb47e7c09f67$var$buildFamily('primary', primary),
        ...$0243cb47e7c09f67$var$buildFamily('accent', accent)
    };
};

});


parcelRegister("dw5hC", function(module, exports) {
$parcel$export(module.exports, "HUB_LOCKED_NEUTRAL_HEXES", () => $8a6145b5fb238463$export$acb8db9451e22570);
$parcel$export(module.exports, "HUB_LOCKED_BORDER_NEUTRAL_HEXES", () => $8a6145b5fb238463$export$713a593549a724d8);
$parcel$export(module.exports, "buildLockedColorMap", () => $8a6145b5fb238463$export$8cccd6c3699eb41c);

var $lo6r6 = parcelRequire("lo6r6");
const $8a6145b5fb238463$export$a6017cadbc9d9217 = '#DCDFE4'; // matches `color.border`
const $8a6145b5fb238463$export$29b411f689221690 = '#758195'; // matches `color.border.bold`
const $8a6145b5fb238463$export$acb8db9451e22570 = [
    '#FFFFFF',
    '#000000'
];
const $8a6145b5fb238463$export$713a593549a724d8 = [
    '#FFFFFF',
    $8a6145b5fb238463$export$a6017cadbc9d9217,
    $8a6145b5fb238463$export$29b411f689221690,
    '#000000'
];
const $8a6145b5fb238463$export$8cccd6c3699eb41c = (...hexes)=>{
    const knownColors = Array.from(new Set(hexes.filter(Boolean).map((hex)=>hex.toLowerCase())));
    return (0, $lo6r6.createBuiltInColorMap)({
        knownColors: knownColors
    });
};

});

parcelRegister("cWpLK", function(module, exports) {
$parcel$export(module.exports, "HUB_CORNER_RADIUS_MIN", () => $1acf2e5865ae3745$export$ca8289818e8a00b3);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_MAX", () => $1acf2e5865ae3745$export$fd5c0c061b90ed51);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_STEP", () => $1acf2e5865ae3745$export$39e466a7b7ce22ff);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_DEFAULT", () => $1acf2e5865ae3745$export$80508b5197dbe846);
$parcel$export(module.exports, "HUB_CORNER_RADIUS_CSS_VAR", () => $1acf2e5865ae3745$export$e3711566ecaf02ae);
$parcel$export(module.exports, "resolveHubCornerRadius", () => $1acf2e5865ae3745$export$122ea29a9b10732a);
$parcel$export(module.exports, "resolveCornerRadiusOverride", () => $1acf2e5865ae3745$export$db3cd30e3eed0965);

var $6KLOx = parcelRequire("6KLOx");
const $1acf2e5865ae3745$export$ca8289818e8a00b3 = 0;
const $1acf2e5865ae3745$export$fd5c0c061b90ed51 = 32;
const $1acf2e5865ae3745$export$39e466a7b7ce22ff = 8;
const $1acf2e5865ae3745$export$80508b5197dbe846 = 8;
const $1acf2e5865ae3745$export$e3711566ecaf02ae = '--hub-corner-radius';
const $1acf2e5865ae3745$var$VALID = new Set([
    0,
    8,
    16,
    24,
    32
]);
const $1acf2e5865ae3745$export$122ea29a9b10732a = (value)=>typeof value === 'number' && $1acf2e5865ae3745$var$VALID.has(value) ? value : $1acf2e5865ae3745$export$80508b5197dbe846;
const $1acf2e5865ae3745$export$3795d91173f540a = (style)=>style === (0, $6KLOx.CornerStyle).SQUARED ? 0 : undefined;
const $1acf2e5865ae3745$export$db3cd30e3eed0965 = (cornerRadius, cornerStyle)=>cornerRadius ?? $1acf2e5865ae3745$export$3795d91173f540a(cornerStyle);

});

parcelRegister("baQcN", function(module, exports) {
$parcel$export(module.exports, "buildHubThemingStateAttributes", () => $6d1c2938e9a03fd5$export$8173e092749d2f38);

var $cWpLK = parcelRequire("cWpLK");

var $KqeQQ = parcelRequire("KqeQQ");

var $1pbmG = parcelRequire("1pbmG");
const $6d1c2938e9a03fd5$export$8173e092749d2f38 = ({ primaryColor: primaryColor, accentColor: accentColor, typography: typography, cornerRadius: cornerRadius, spaceDensity: spaceDensity })=>{
    const colorsCustomized = !!primaryColor && primaryColor.toUpperCase() !== (0, $1pbmG.DEFAULT_PRIMARY) || !!accentColor && accentColor.toUpperCase() !== (0, $1pbmG.DEFAULT_ACCENT);
    const typographyCustomized = !!typography;
    const cornerRadiusCustomized = typeof cornerRadius === 'number' && cornerRadius !== (0, $cWpLK.HUB_CORNER_RADIUS_DEFAULT);
    const spaceDensityCustomized = !!spaceDensity && spaceDensity !== (0, $KqeQQ.DEFAULT_SPACE_DENSITY);
    const customizedDimensionCount = Number(colorsCustomized) + Number(typographyCustomized) + Number(cornerRadiusCustomized) + Number(spaceDensityCustomized);
    return {
        customizedDimensionCount: customizedDimensionCount,
        colorsCustomized: colorsCustomized,
        typographyCustomized: typographyCustomized,
        cornerRadiusCustomized: cornerRadiusCustomized,
        spaceDensityCustomized: spaceDensityCustomized,
        primaryColor: primaryColor,
        accentColor: accentColor,
        bodyFont: typography === null || typography === void 0 ? void 0 : typography.body,
        headingFont: typography === null || typography === void 0 ? void 0 : typography.heading,
        cornerRadius: cornerRadius,
        spaceDensity: spaceDensity
    };
};

});
parcelRegister("KqeQQ", function(module, exports) {
$parcel$export(module.exports, "SPACE_DENSITIES", () => $8cdb8b08ba67adc1$export$7525d7f8474e6b81);
$parcel$export(module.exports, "DEFAULT_SPACE_DENSITY", () => $8cdb8b08ba67adc1$export$61fa4fc6e277c51f);
$parcel$export(module.exports, "EDITOR_BLOCK_SPACING_VAR", () => $8cdb8b08ba67adc1$export$cf3820686f87514a);
$parcel$export(module.exports, "getBlockSpacingForDensity", () => $8cdb8b08ba67adc1$export$a652a2b31fb9818);
$parcel$export(module.exports, "getCardGapForDensity", () => $8cdb8b08ba67adc1$export$4cd8ab356af25889);
/**
 * Public type for the Hub space density (spacing) customization.
 *
 * Values mirror the backend `HelpCenterSpaceDensity` GraphQL enum exactly
 * (uppercase), so there is no case-mapping at the read/write boundaries.
 *
 * The chosen density will control the vertical rhythm
 * between every element on the hub page and, eventually, the spacing inside
 * elements.
 */ const $8cdb8b08ba67adc1$export$7525d7f8474e6b81 = [
    'DEFAULT',
    'COMFORTABLE',
    'BREEZY'
];
const $8cdb8b08ba67adc1$export$61fa4fc6e277c51f = 'DEFAULT';
const $8cdb8b08ba67adc1$export$cf3820686f87514a = '--ak-editor-extension-block-spacing';
const $8cdb8b08ba67adc1$export$6ca1261611fbc46e = {
    DEFAULT: '0',
    COMFORTABLE: '16px',
    BREEZY: '24px'
};
const $8cdb8b08ba67adc1$export$a652a2b31fb9818 = (density)=>$8cdb8b08ba67adc1$export$6ca1261611fbc46e[density];
const $8cdb8b08ba67adc1$export$cc1134cace54c337 = {
    DEFAULT: 16,
    COMFORTABLE: 16,
    BREEZY: 24
};
const $8cdb8b08ba67adc1$export$4cd8ab356af25889 = (density)=>$8cdb8b08ba67adc1$export$cc1134cace54c337[density];

});

parcelRegister("1pbmG", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PRIMARY", () => $c2c476a58e7009a5$export$b9864279fc70d379);
$parcel$export(module.exports, "DEFAULT_ACCENT", () => $c2c476a58e7009a5$export$74ca527397fc1422);
/**
 * Single source of truth for the day-0 brand-colour defaults.
 *
 * A hub with no persisted primary/accent falls back to these, and the analytics
 * "customized vs default" check compares against them — so BOTH
 * `controllers/hub-theming-context` (which applies them) and
 * `utils/hub-theming-analytics` (which measures against them) import from here.
 * Do not re-declare these anywhere else, or day-0 hubs get mis-flagged as
 * customized when only one copy is updated.
 *
 * The other two dimensions' defaults already live with their own modules and
 * should be imported from there: `HUB_CORNER_RADIUS_DEFAULT` from
 * `utils/hub-corner-radius`, `DEFAULT_SPACE_DENSITY` from `utils/hub-space-density`.
 *
 * Kept dependency-free (no React/relay) so the pure analytics helper can import
 * it without pulling in the framework or creating an import cycle with
 * `hub-theming-context` (which imports the analytics helper).
 */ const $c2c476a58e7009a5$export$b9864279fc70d379 = '#003172';
const $c2c476a58e7009a5$export$74ca527397fc1422 = '#DDDEE1';

});


parcelRegister("1eqSX", function(module, exports) {
$parcel$export(module.exports, "getHubDefaultParameters", () => $4749815ff407600f$export$25a6d2da841ddb1d);

var $bRst2 = parcelRequire("bRst2");

var $leSAN = parcelRequire("leSAN");

var $fkejg = parcelRequire("fkejg");
var $4Q8Rn = parcelRequire("4Q8Rn");
/**
 * Day-0 default shade that bespoke extensions inherit through
 * `CommonHubExtensionsDependenciesProvider` when an extension hasn't pinned a
 * background of its own. Kept local to this resolver — it is intentionally
 * decoupled from `ELEMENT_DEFAULTS` because the per-element map is the
 * source-of-truth for *named* element slots (e.g. `callout.bg`), whereas this
 * is the resolver's own generic fallback shared across every extension.
 */ const $4749815ff407600f$var$DEFAULT_HUB_BACKGROUND_SHADE = 'primary.200';
/**
 * Per-element bg shade overrides. When an extension wants a different default
 * shade than the resolver's generic `primary.200`, it's mapped here. Keys
 * match the `ELEMENT_DEFAULTS` map; values are the slot suffix to look up.
 */ const $4749815ff407600f$var$ELEMENT_BG_SHADE = {
    section: (0, $fkejg.ELEMENT_DEFAULTS)['section.bg']
};
/**
 * Per-element icon-color shade overrides. Currently only JSM Help renders an
 * icon; values are looked up in `ELEMENT_DEFAULTS`.
 */ const $4749815ff407600f$var$ELEMENT_ICON_SHADE = {
    'jsm-help': (0, $fkejg.ELEMENT_DEFAULTS)['jsm-help.icon']
};
const $4749815ff407600f$export$25a6d2da841ddb1d = (options = {})=>{
    if (options.palette) {
        if (options.isBrandPaletteLocked) {
            // One brand colour across every element — no palette tints. The
            // `--hub-primary-color` var tracks brand edits; the hex is the fallback.
            const primary = options.primaryColor ?? options.palette['primary.600'];
            const iconShade = options.element && $4749815ff407600f$var$ELEMENT_ICON_SHADE[options.element];
            return {
                backgroundColor: `var(${0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR}, ${primary})`,
                textColor: (0, $bRst2.readableTextColor)(primary, '@atlassian/company-hub-common'),
                isAdvancedThemingEnabled: true,
                ...iconShade ? {
                    iconColor: `var(${0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR}, ${primary})`
                } : {}
            };
        }
        const bgShade = options.element && $4749815ff407600f$var$ELEMENT_BG_SHADE[options.element] || $4749815ff407600f$var$DEFAULT_HUB_BACKGROUND_SHADE;
        const iconShade = options.element && $4749815ff407600f$var$ELEMENT_ICON_SHADE[options.element];
        // Gate ON:
        //   - bg = CSS-var ref so the cascade tracks brand-color edits via the
        //     <HubThemingProvider> wrapper's inline `style`.
        //   - text = WCAG-readable black/white computed against the resolved
        //     bg hex. Stored as a literal so it remains correct even when
        //     admin overrides bg per-element (the auto-transition hook in
        //     the panel handles per-element flips at edit time).
        //   - icon = CSS-var ref (only when element opts in via ELEMENT_ICON_SHADE).
        return {
            backgroundColor: `var(${(0, $4Q8Rn.HUB_COLOR_CSS_VARS)[bgShade]})`,
            textColor: (0, $bRst2.readableTextColor)(options.palette[bgShade], '@atlassian/company-hub-common'),
            isAdvancedThemingEnabled: true,
            ...iconShade ? {
                iconColor: `var(${(0, $4Q8Rn.HUB_COLOR_CSS_VARS)[iconShade]}, ${options.palette[iconShade]})`
            } : {}
        };
    }
    return {
        backgroundColor: `var(${0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR}, ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"})`,
        textColor: `var(${0, $leSAN.HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${"var(--ds-text, #292A2E)"})`,
        isAdvancedThemingEnabled: false
    };
};

});
parcelRegister("fkejg", function(module, exports) {
$parcel$export(module.exports, "ELEMENT_DEFAULTS", () => $9d430b1e3cd3ea0d$export$6d3cb81378fd614a);
/**
 * Element-default contract — see §4.2 of the Advanced Theming v2 design.
 *
 * Maps an element-color-slot key to a palette token reference. Day 0 only
 * defines bespoke-extension *background* slots, all pointing at `primary.200`,
 * which gives every bespoke element a coherent themed default while the rest
 * of the override / picker UX is built out.
 */ const $9d430b1e3cd3ea0d$export$6d3cb81378fd614a = {
    // Bespoke extensions — backgrounds (day 0).
    'callout.bg': 'primary.200',
    'cards.bg': 'primary.200',
    'carousel.bg': 'primary.200',
    'spotlight.bg': 'primary.200',
    'jsm-help.bg': 'primary.200',
    // JSM Help icon — bold brand tone for visibility against the light bg.
    'jsm-help.icon': 'primary.800',
    // Sections use a lighter accent tint to differentiate from bespoke extension cards.
    'section.bg': 'accent.100'
};

});


parcelRegister("iIxrR", function(module, exports) {
$parcel$export(module.exports, "useIsAdvancedThemingEnabled", () => $579be1c248879cbb$export$13ab96420d94e773);
/**
 * Returns `true` when advanced theming v2 should be active for the current
 * hub render, `false` otherwise.
 *
 * Advanced theming is gated by **both** of:
 *
 *   1. The product-level flag, exposed via `useHubContext().featureFlags
 *      ['advanced-theming-in-hub']`. The product (e.g. help-center) sets this
 *      `true` only for surfaces it has opted in (today: JSM Help Hubs only).
 *   2. The platform-level Statsig gate `hub-advanced-theming`, owned by the
 *      hubs platform team to control rollout independently of the product.
 *
 * AND-gating both lets either side hold the rollout independently — the
 * product can still keep the feature off for itself even if the platform
 * gate flips on, and vice versa. Pure read of context + statsig — SSR-safe.
 *
 * Cross-host safety: this hook tolerates a missing `<HubContextProvider>` and
 * returns `false` in that case. Confluence Company Hub and similar surfaces
 * that don't mount `HubBootstrap` (and therefore don't mount `HubContext`)
 * cannot be in a theming-enabled tree by definition, so returning `false`
 * is both safe and correct.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $aQNcS = parcelRequire("aQNcS");
const $579be1c248879cbb$export$13ab96420d94e773 = ()=>{
    var _ctx$featureFlags;
    const ctx = (0, $fc4bM.useContext)((0, $aQNcS.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub). Theming
    // is help-center-only — return false without throwing.
    return false;
    const productFlag = ((_ctx$featureFlags = ctx.featureFlags) === null || _ctx$featureFlags === void 0 ? void 0 : _ctx$featureFlags['advanced-theming-in-hub']) === true;
    return productFlag && (0, $dRkX9.fg)('hub-advanced-theming');
};

});


parcelRegister("c48ao", function(module, exports) {
$parcel$export(module.exports, "NavigationStyleContext", () => $5f23bb9fce690446$export$2c6067e95d1be081);
$parcel$export(module.exports, "useNavigationStyle", () => $5f23bb9fce690446$export$ce205152a61c4e11);

var $fc4bM = parcelRequire("fc4bM");
const $5f23bb9fce690446$var$noop = ()=>{};
const $5f23bb9fce690446$export$2c6067e95d1be081 = (0, $fc4bM.createContext)({
    options: null,
    setOptions: $5f23bb9fce690446$var$noop
});
const $5f23bb9fce690446$export$ce205152a61c4e11 = ()=>(0, $fc4bM.useContext)($5f23bb9fce690446$export$2c6067e95d1be081);

});

parcelRegister("dsn5W", function(module, exports) {
$parcel$export(module.exports, "useIsHubCornerRadiusEnabled", () => $2d3c403e745fcd59$export$186c72664a5e904e);
/**
 * Returns `true` when Hub corner radius customization should be active.
 *
 * Corner radius is a sub-feature of advanced theming and never ships without
 * it, so this follows `useIsAdvancedThemingEnabled` (the product-level flag
 * `advanced-theming-in-hub` via HubContext, plus the platform gate).
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */ 
var $iIxrR = parcelRequire("iIxrR");
const $2d3c403e745fcd59$export$186c72664a5e904e = ()=>(0, $iIxrR.useIsAdvancedThemingEnabled)();

});

parcelRegister("aiSBX", function(module, exports) {
$parcel$export(module.exports, "toSpaceDensity", () => $b40c747caa18ae9b$export$48c62bfd809136a6);

var $KqeQQ = parcelRequire("KqeQQ");
const $b40c747caa18ae9b$export$48c62bfd809136a6 = (value)=>value != null && (0, $KqeQQ.SPACE_DENSITIES).includes(value) ? value : undefined;

});

parcelRegister("jCBqQ", function(module, exports) {
$parcel$export(module.exports, "toFontKey", () => $1205d17f8d5d1b36$export$3237e77afd58a8d5);

var $8xZUP = parcelRequire("8xZUP");
/** The framework default — already loaded by the AK shell, no Google Fonts request. */ const $1205d17f8d5d1b36$var$DEFAULT_FONT_KEY = 'atlassian-sans';
const $1205d17f8d5d1b36$export$3237e77afd58a8d5 = (value)=>value != null && Object.prototype.hasOwnProperty.call((0, $8xZUP.FONT_REGISTRY), value) ? value : $1205d17f8d5d1b36$var$DEFAULT_FONT_KEY;

});
parcelRegister("8xZUP", function(module, exports) {
$parcel$export(module.exports, "FONT_REGISTRY", () => $b1517eab7d675933$export$40b121c0fb5c472f);
const $b1517eab7d675933$export$40b121c0fb5c472f = {
    'atlassian-sans': {
        displayName: 'Atlassian Sans',
        family: '"Atlassian Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: null
    },
    'noto-sans': {
        displayName: 'Noto Sans',
        family: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: 'Noto+Sans:wght@400;500;700'
    },
    'ibm-plex-sans': {
        displayName: 'IBM Plex Sans',
        family: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: 'IBM+Plex+Sans:wght@400;500;700'
    },
    'work-sans': {
        displayName: 'Work Sans',
        family: '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        category: 'sans-serif',
        googleFontsFamily: 'Work+Sans:wght@400;500;700'
    },
    'ibm-plex-serif': {
        displayName: 'IBM Plex Serif',
        family: '"IBM Plex Serif", Georgia, "Times New Roman", serif',
        category: 'serif',
        googleFontsFamily: 'IBM+Plex+Serif:wght@400;500;700'
    },
    merriweather: {
        displayName: 'Merriweather',
        family: '"Merriweather", Georgia, "Times New Roman", serif',
        category: 'serif',
        googleFontsFamily: 'Merriweather:wght@400;500;700'
    },
    lora: {
        displayName: 'Lora',
        family: '"Lora", Georgia, "Times New Roman", serif',
        category: 'serif',
        googleFontsFamily: 'Lora:wght@400;500;700'
    }
};

});


parcelRegister("jFYW1", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_NAVIGATION_OPTIONS", () => $8239a8379694ca5a$export$cfca0f39600e333c);
$parcel$export(module.exports, "getDefaultNavigationOptions", () => $8239a8379694ca5a$export$5046aed2fe45af56);
$parcel$export(module.exports, "mapApiToNavigationOptions", () => $8239a8379694ca5a$export$b35e3817d72db278);

var $bRst2 = parcelRequire("bRst2");

var $4Q8Rn = parcelRequire("4Q8Rn");
const $8239a8379694ca5a$var$readableTextColor = (color)=>(0, $bRst2.readableTextColor)(color, '@atlassian/company-hub-common');
const $8239a8379694ca5a$export$cfca0f39600e333c = {
    padding: true,
    fixedAtTop: false,
    backgroundColor: '#FFFFFF',
    textColor: '#172B4D',
    borderColor: '#DFE1E6',
    borderType: 'NO_BORDER',
    cornerRadius: 8
};
function $8239a8379694ca5a$export$5046aed2fe45af56(brandColor, isAdvancedThemingEnabled) {
    if (isAdvancedThemingEnabled) return {
        ...$8239a8379694ca5a$export$cfca0f39600e333c,
        backgroundColor: `var(${(0, $4Q8Rn.HUB_COLOR_CSS_VARS)['primary.1000']})`,
        textColor: "var(--ds-text-inverse, #FFFFFF)"
    };
    if (!brandColor) return $8239a8379694ca5a$export$cfca0f39600e333c;
    return {
        ...$8239a8379694ca5a$export$cfca0f39600e333c,
        backgroundColor: brandColor,
        textColor: $8239a8379694ca5a$var$readableTextColor(brandColor)
    };
}
function $8239a8379694ca5a$export$b35e3817d72db278(apiData, brandColor, isCornerRadiusEnabled, isAdvancedThemingEnabled) {
    const defaults = $8239a8379694ca5a$export$5046aed2fe45af56(brandColor, isAdvancedThemingEnabled);
    if (!apiData) return defaults;
    return {
        padding: apiData.padding ?? defaults.padding,
        fixedAtTop: apiData.positionType === 'FIXED',
        backgroundColor: apiData.backgroundColor ?? defaults.backgroundColor,
        textColor: apiData.textColor ?? defaults.textColor,
        borderColor: apiData.borderColor ?? defaults.borderColor,
        borderType: apiData.borderType === 'BOTTOM_BORDER' ? 'BOTTOM_BORDER' : apiData.borderType === 'ALL_BORDER' ? 'ALL_BORDER' : 'NO_BORDER',
        // When the corner-radius feature is on, preserve a missing value as null so
        // the navbar inherits --hub-corner-radius. Otherwise keep the legacy 8 default.
        cornerRadius: isCornerRadiusEnabled ? apiData.cornerRadius ?? null : apiData.cornerRadius ?? defaults.cornerRadius
    };
}

});


parcelRegister("fok6N", function(module, exports) {
$parcel$export(module.exports, "HubErrorBoundary", () => $dca5876b870644fe$export$ba2f52e216142b3d);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $dRkX9 = parcelRequire("dRkX9");

var $9PWjZ = parcelRequire("9PWjZ");

var $8xOOU = parcelRequire("8xOOU");

var $8mmdq = parcelRequire("8mmdq");

var $4Y293 = parcelRequire("4Y293");
const $dca5876b870644fe$var$isFetchClientError = (err)=>{
    return (err === null || err === void 0 ? void 0 : err.status) < 500;
};
const $dca5876b870644fe$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError, operationNames: operationNames })=>{
    const logError = (0, $9PWjZ.useUFOReportError)();
    const observeError = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $4Y293.HubErrorObserverContext));
    const onError = (error)=>{
        if ($dca5876b870644fe$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        if ((0, $dRkX9.fg)('help_center_hub_premium_sla_metrics')) observeError === null || observeError === void 0 || observeError({
            error: error,
            id: id,
            packageName: packageName,
            shouldForceError: shouldForceError
        });
        // react-ufo does not expose a dedicated traceId/attribute field, so the trace ID is
        // appended to the error message. fireErrorAnalytics additionally receives it as an attribute.
        let traceId;
        if (operationNames && (0, $dRkX9.fg)('hub_error_analytics_trace_id')) {
            const traceIds = operationNames.flatMap((name)=>(0, $8mmdq.getTraceIds)(name));
            traceId = traceIds.find(Boolean);
        }
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: traceId ? `${error.message} (traceId: ${traceId})` : error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $8xOOU.default)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                },
                attributes: traceId ? {
                    traceId: traceId
                } : undefined
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        onError: onError,
        fallback: fallback
    }, children);
};

});

parcelRegister("gYdLJ", function(module, exports) {
$parcel$export(module.exports, "HubAppShell", () => $f4885c8e358d3832$export$647b3ff790ea59d4);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ /* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $jdt4T = parcelRequire("jdt4T");

var $3TJLC = parcelRequire("3TJLC");

var $c4StN = parcelRequire("c4StN");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $c48ao = parcelRequire("c48ao");

var $edrd0 = parcelRequire("edrd0");

var $dkkKf = parcelRequire("dkkKf");

var $bT87j = parcelRequire("bT87j");

var $hPVoC = parcelRequire("hPVoC");

var $iU70g = parcelRequire("iU70g");

var $afA7P = parcelRequire("afA7P");

var $2MYZ0 = parcelRequire("2MYZ0");

var $aQNcS = parcelRequire("aQNcS");

var $dJGUc = parcelRequire("dJGUc");

var $bLOyf = parcelRequire("bLOyf");

var $eh2Kx = parcelRequire("eh2Kx");

var $W2U74 = parcelRequire("W2U74");

var $lXmFz = parcelRequire("lXmFz");
const $f4885c8e358d3832$var$HELP_CENTER_PREVIEW_PATH_PREFIX = '/helpcenter/test/';
const $f4885c8e358d3832$var$HELP_CENTER_LIVE_PATH_PREFIX = '/helpcenter/';
const $f4885c8e358d3832$var$DEFAULT_HELP_CENTER_PORTALS_LIVE_PATH = '/servicedesk/customer/portals';
const $f4885c8e358d3832$var$MIGRATION_REVIEW_ACTION_BAR_ANALYTICS_SOURCE = 'helpCenterMigrationReviewActionBar';
// Existing global-link selectors require the unbounded Compiled API.
const $f4885c8e358d3832$var$containerStyles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    container: "_19itglyw _vchhusvi _r06hglyw _kqswh2mm _bfhkhp5a _1tke1osq _1e0c1txw _2lx21bp4 _1bzh1gj0 _5cd81gj0",
    childrenWrapper: "_n3tdoahv",
    childrenWrapperEditMode: "_16jlkb7n _1tkeidpf"
};
// Compiled supports the inherited custom background, which ADS bounded styles do not.
const $f4885c8e358d3832$var$navigationStyles = {
    scrollableContainer: "_1reo1wug _18m91wug",
    fixedNavContainer: "_kqsw1if8 _154iidpf _1pby1kze _bfhk1kw7 _ca0q1ejb _otyr1ejb"
};
const $f4885c8e358d3832$export$647b3ff790ea59d4 = ({ children: children, isEditMode: isEditMode = false, hideNavbar: hideNavbar = false })=>{
    const { cloudId: cloudId, cloudUrl: cloudUrl, env: env, layout: layout, containerStyling: containerStyling, hubName: hubName, migrationReview: migrationReview } = (0, $aQNcS.useHubContext)();
    const { options: navStyle } = (0, $c48ao.useNavigationStyle)();
    const isStickyNavFixEnabled = (0, $dRkX9.fg)('hubs_nav_fixed_top_sticky_fix');
    const isFixedAtTop = Boolean(navStyle === null || navStyle === void 0 ? void 0 : navStyle.fixedAtTop);
    const shouldRenderShellNavigation = !hideNavbar;
    // When the sticky fix is enabled, the shell stops owning the scroll so the
    // fixed navbar can stick to the viewport. When padded, a sticky wrapper keeps
    // the top gap in place and covers scrolling content behind it.
    // Scoped to view mode — edit mode injects its own
    // navbar via `editor-plugin-hub-shell` and relies on the shell keeping its
    // own scroll container for the editor height chain.
    const shouldUseViewportStickyNav = isStickyNavFixEnabled && isFixedAtTop && !isEditMode && shouldRenderShellNavigation;
    const shouldWrapPaddedFixedNav = shouldUseViewportStickyNav && Boolean(navStyle === null || navStyle === void 0 ? void 0 : navStyle.padding);
    // Whenever the shell still owns scrolling, a fixed navbar relies on the shell
    // being full height. Tied to `shouldUseViewportStickyNav` rather than the gate
    // so edit mode keeps its height chain once the gate is enabled.
    const fixedNavFullHeightStyling = !shouldUseViewportStickyNav && isFixedAtTop ? {
        height: '100%'
    } : {};
    const showBanner = layout === null || layout === void 0 ? void 0 : layout.showBanner;
    const isHelpHubMigrationEnabled = (0, $dRkX9.fg)('enable-help-hub-migration');
    const shouldApplyContainerStyling = (0, $dRkX9.fg)('enable-jsm-in-hubs');
    const [isBreadcrumbsEnabled] = (0, $2MYZ0.useIsHubFeatureEnabled)([
        (0, $2MYZ0.HUB_FEATURES).BREADCRUMBS
    ]);
    // Edit mode injects the navbar and breadcrumbs into the editor content area so they
    // resize with the ProseMirror canvas and stay below the editor toolbar.
    const shouldRenderShellBreadcrumbs = !isEditMode;
    const publishedHelpCenterPath = env.relativeBaseUrl.startsWith($f4885c8e358d3832$var$HELP_CENTER_PREVIEW_PATH_PREFIX) ? env.relativeBaseUrl.replace($f4885c8e358d3832$var$HELP_CENTER_PREVIEW_PATH_PREFIX, $f4885c8e358d3832$var$HELP_CENTER_LIVE_PATH_PREFIX) : // Matches the default Help Center with or without the `/portals` segment,
    // since the backend reports its base path without one.
    (0, $dJGUc.isDefaultHelpCenterBasePath)(env.relativeBaseUrl) ? $f4885c8e358d3832$var$DEFAULT_HELP_CENTER_PORTALS_LIVE_PATH : env.relativeBaseUrl;
    const publishedHelpCenterUrl = new URL(publishedHelpCenterPath, cloudUrl).toString();
    // Default hardcoded styles (used when feature flag is disabled for backward compatibility)
    const defaultContainerStyling = {
        borderRadius: "var(--ds-radius-large, 8px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    };
    // Apply containerStyling from props if feature flag is enabled, otherwise use hardcoded defaults
    const appliedContainerStyling = shouldApplyContainerStyling ? containerStyling : defaultContainerStyling;
    // Built outside the JSX so the `enforce-style-prop` suppression covers the whole
    // object: these values are dynamic (theming props plus gated layout) and cannot
    // move into `cssMap`.
    const containerInlineStyles = {
        ...appliedContainerStyling,
        ...fixedNavFullHeightStyling
    };
    const hubContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    (0, $dkkKf.useUnsetGlobalTheme)(isEditMode ? hubContainerRef.current : null); // for view mode we don't need to unset the global theme
    // useHubTheming returns undefined outside <HubThemingProvider>, but
    // HubAppShell is always mounted inside HubBootstrap → provider is in tree.
    const { primaryColor: primaryColor, isAdvancedThemingEnabled: isAdvancedThemingEnabled } = (0, $iU70g.useHubTheming)();
    // Legacy theming path: when the v2 gate is OFF we restore the pre-v2
    // behaviour by writing the `--hub-primary-*` CSS vars into the document so
    // existing ADFs (which encode `var(--hub-primary-color, ...)` strings) and
    // chrome that consumes the same vars continue to look correct. When the
    // gate is ON the palette + adapter outputs from `useHubTheming()` drive
    // every consumer directly, so this effect is a no-op.
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (isAdvancedThemingEnabled) return undefined;
        return (0, $edrd0.setHubBrandingStyle)({
            primaryColor: primaryColor
        });
    }, [
        isAdvancedThemingEnabled,
        primaryColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hPVoC.HubBreadcrumbsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $afA7P.HubTypographyScope), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c4StN.FlagsProvider), null, isHelpHubMigrationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eh2Kx.MigrationPublishSuccessFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: (0, $jdt4T.cx)($f4885c8e358d3832$var$containerStyles.container, !shouldUseViewportStickyNav && $f4885c8e358d3832$var$navigationStyles.scrollableContainer),
        testId: "hub-app-shell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic styles passed from outside via containerStyling prop
        style: containerInlineStyles,
        ref: hubContainerRef
    }, !isEditMode && migrationReview && isHelpHubMigrationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            source: $f4885c8e358d3832$var$MIGRATION_REVIEW_ACTION_BAR_ANALYTICS_SOURCE
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $W2U74.MigrationReviewActionBar), {
        cloudId: cloudId,
        helpCenterAri: env.helpCenterAri,
        helpCenterName: hubName,
        migrationReview: migrationReview,
        publishedHelpCenterUrl: publishedHelpCenterUrl
    })), shouldRenderShellNavigation && (shouldWrapPaddedFixedNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": "hub-sticky-navbar",
        className: (0, $2R2iS.default)([
            $f4885c8e358d3832$var$navigationStyles.fixedNavContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lXmFz.Navbar), {
        isEditMode: isEditMode,
        isViewportSticky: shouldUseViewportStickyNav
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lXmFz.Navbar), {
        isEditMode: isEditMode,
        isViewportSticky: shouldUseViewportStickyNav
    })), isBreadcrumbsEnabled && shouldRenderShellBreadcrumbs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bT87j.HubBreadcrumbs), null), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $f4885c8e358d3832$var$containerStyles.bannerContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bLOyf.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: isEditMode ? $f4885c8e358d3832$var$containerStyles.childrenWrapperEditMode : $f4885c8e358d3832$var$containerStyles.childrenWrapper,
        testId: "hub-app-shell-children-wrapper"
    }, children)))));
};

});
parcelRegister("edrd0", function(module, exports) {
$parcel$export(module.exports, "setHubBrandingStyle", () => $255fcb433cb80880$export$202bcc6267a600cb);

var $aaElU = parcelRequire("aaElU");

var $bRst2 = parcelRequire("bRst2");

var $h46Vs = parcelRequire("h46Vs");

var $8xOOU = parcelRequire("8xOOU");

var $leSAN = parcelRequire("leSAN");
const $255fcb433cb80880$var$readableTextColor = (color)=>{
    return (0, $bRst2.readableTextColor)(color, '@atlassian/company-hub-common');
};
const $255fcb433cb80880$export$202bcc6267a600cb = ({ primaryColor: primaryColor, targetElement: targetElement })=>{
    const primaryColorToUse = primaryColor || (0, $leSAN.DEFAULT_BRANDING_COLOR);
    const finalTargetElement = targetElement || document.documentElement;
    try {
        // Convert to HEX for functions that require it (getLuminance, generateThemeBranding)
        const hexPrimaryColor = (0, $aaElU.toHexColor)(primaryColorToUse);
        const primaryTextColor = $255fcb433cb80880$var$readableTextColor(hexPrimaryColor);
        // Keep original format for CSS custom property (works with any valid CSS color)
        finalTargetElement.style.setProperty((0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR), primaryColorToUse);
        finalTargetElement.style.setProperty((0, $leSAN.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), primaryTextColor);
        // generateThemeBranding expects HEX colors
        const themeColours = (0, $h46Vs.generateThemeBranding)(hexPrimaryColor);
        finalTargetElement.style.setProperty((0, $leSAN.HUB_PRIMARY_LINK_COLOR_CSS_VAR), themeColours.color900);
    } catch (error) {
        (0, $8xOOU.default)({
            error: error instanceof Error ? error : new Error(`Hub branding style processing failed for color: ${primaryColorToUse}`),
            meta: {
                id: 'setHubBrandingStyle',
                packageName: '@atlassian/company-hub-common'
            }
        });
        // Fallback to default branding if color processing fails
        finalTargetElement.style.setProperty((0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR), (0, $leSAN.DEFAULT_BRANDING_COLOR));
        finalTargetElement.style.setProperty((0, $leSAN.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), "var(--ds-text, #292A2E)");
    }
    return ()=>{
        finalTargetElement.style.removeProperty((0, $leSAN.HUB_PRIMARY_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $leSAN.HUB_PRIMARY_TEXT_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $leSAN.HUB_PRIMARY_LINK_COLOR_CSS_VAR));
    };
};

});

parcelRegister("dkkKf", function(module, exports) {
$parcel$export(module.exports, "useUnsetGlobalTheme", () => $fb933ce20af2e429$export$8726d385cd3f733);

var $fc4bM = parcelRequire("fc4bM");

var $cyWOf = parcelRequire("cyWOf");

var $anluN = parcelRequire("anluN");
const $fb933ce20af2e429$export$8726d385cd3f733 = (targetElement, idsToUnset = [
    'light',
    'dark',
    'spacing'
])=>{
    const { colorMode: colorMode, dark: dark, light: light, spacing: spacing, typography: typography, UNSAFE_themeOptions: UNSAFE_themeOptions } = (0, $anluN.useThemeObserver)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (targetElement) (0, $cyWOf.getThemeStyles)().then((themeStyles)=>{
            themeStyles.forEach((themeStyle)=>{
                if (idsToUnset.includes(themeStyle.id)) {
                    const allCssVariables = themeStyle.css.match(/--[\w-]+/g); // output => ['--ds-text', '--ds-text-accent-lime']
                    allCssVariables === null || allCssVariables === void 0 || allCssVariables.forEach((cssVariable)=>{
                        targetElement.style.setProperty(cssVariable, 'initial');
                    });
                }
            });
        });
    }, [
        targetElement,
        idsToUnset,
        colorMode,
        dark,
        light,
        spacing,
        typography,
        UNSAFE_themeOptions
    ]);
};

});
parcelRegister("cyWOf", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $8be4a40ed8608c1d$export$a3fc04b8551e006a);

var $dRkX9 = parcelRequire("dRkX9");

var $5tRJN = parcelRequire("5tRJN");

var $2Thdv = parcelRequire("2Thdv");

var $eSTRI = parcelRequire("eSTRI");

var $lHDyu = parcelRequire("lHDyu");

var $dLoRK = parcelRequire("dLoRK");

var $hcaq9 = parcelRequire("hcaq9");

const $8be4a40ed8608c1d$export$a3fc04b8551e006a = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $5tRJN.themeIdsWithOverrides);
        if (!(0, $dRkX9.fg)('platform-dst-tokens-finesse')) themePreferences = themePreferences.filter((themeId)=>!(0, $5tRJN.themeOverrideIds).includes(themeId));
        // CLEANUP: Remove
        if (!(0, $dRkX9.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast' && n !== 'light-increased-contrast-finesse' && n !== 'dark-increased-contrast-finesse');
    } else {
        const themeState = {
            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $2Thdv.themeStateDefaults)['colorMode'],
            contrastMode: (preferences === null || preferences === void 0 ? void 0 : preferences.contrastMode) || (0, $2Thdv.themeStateDefaults)['contrastMode'],
            dark: (preferences === null || preferences === void 0 ? void 0 : preferences.dark) || (0, $2Thdv.themeStateDefaults)['dark'],
            light: (preferences === null || preferences === void 0 ? void 0 : preferences.light) || (0, $2Thdv.themeStateDefaults)['light'],
            motion: (preferences === null || preferences === void 0 ? void 0 : preferences.motion) || (0, $2Thdv.themeStateDefaults)['motion'](),
            shape: (preferences === null || preferences === void 0 ? void 0 : preferences.shape) || (0, $2Thdv.themeStateDefaults)['shape'],
            spacing: (preferences === null || preferences === void 0 ? void 0 : preferences.spacing) || (0, $2Thdv.themeStateDefaults)['spacing'],
            typography: (preferences === null || preferences === void 0 ? void 0 : preferences.typography) || (0, $2Thdv.themeStateDefaults)['typography']
        };
        themePreferences = (0, $lHDyu.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $eSTRI.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $hcaq9.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async (_preferences$UNSAFE_t)=>{
            if (preferences !== 'all' && preferences !== null && preferences !== void 0 && preferences.UNSAFE_themeOptions && (0, $dLoRK.isValidBrandHex)(preferences === null || preferences === void 0 || (_preferences$UNSAFE_t = preferences.UNSAFE_themeOptions) === null || _preferences$UNSAFE_t === void 0 ? void 0 : _preferences$UNSAFE_t.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("6804I"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $2Thdv.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences === null || preferences === void 0 ? void 0 : preferences.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
            return undefined;
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $8be4a40ed8608c1d$export$2e2bcd8739ae039 = $8be4a40ed8608c1d$export$a3fc04b8551e006a;

});
parcelRegister("6804I", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4oE74").then(()=>parcelRequire('3UqqD'));

});



parcelRegister("bT87j", function(module, exports) {
$parcel$export(module.exports, "HubBreadcrumbsSkeleton", () => $8c71b8b527adcfdf$export$e610d88d5224ae75);
$parcel$export(module.exports, "HubBreadcrumbs", () => $8c71b8b527adcfdf$export$cc8c957f0e477af0);
/* hub-breadcrumbs.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $3TJLC = parcelRequire("3TJLC");

var $ddnRa = parcelRequire("ddnRa");

var $hDt7O = parcelRequire("hDt7O");

var $52Xoa = parcelRequire("52Xoa");

var $kVIgP = parcelRequire("kVIgP");

var $5zdB1 = parcelRequire("5zdB1");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $2MYZ0 = parcelRequire("2MYZ0");

var $aQNcS = parcelRequire("aQNcS");

var $4HJ98 = parcelRequire("4HJ98");

var $hPVoC = parcelRequire("hPVoC");

var $jEmWr = parcelRequire("jEmWr");
const $8c71b8b527adcfdf$var$styles = {
    container: "_vchhusvi _1ul9idpf _n3td1ejb _19bv1ejb _u5f31ejb _1bsb1osq",
    item: "_11c8fhey _1e0c1txw _vchhusvi _1ul9idpf _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _19pkidpf",
    separator: "_1rjcv77o _18zru2gc _1bsbftgi _1o9zidpf _y3gn1h6o",
    itemText: "_1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
};
const $8c71b8b527adcfdf$var$StaticHubParentBreadcrumb = ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $8c71b8b527adcfdf$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        className: (0, $2R2iS.default)([
            $8c71b8b527adcfdf$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        color: 'color.text.subtlest',
        maxLines: 1
    }, item.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "aria-hidden": true,
        className: (0, $2R2iS.default)([
            $8c71b8b527adcfdf$var$styles.separator
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        color: "color.text.subtlest"
    }, "/")));
};
const $8c71b8b527adcfdf$var$StaticHubCurrentBreadcrumb = ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $8c71b8b527adcfdf$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "aria-current": "page",
        className: (0, $2R2iS.default)([
            $8c71b8b527adcfdf$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        maxLines: 1
    }, item.text)));
};
const $8c71b8b527adcfdf$export$e610d88d5224ae75 = ({ itemCount: itemCount })=>{
    const [isBreadcrumbsEnabled] = (0, $2MYZ0.useIsHubFeatureEnabled)([
        (0, $2MYZ0.HUB_FEATURES).BREADCRUMBS
    ]);
    if (!isBreadcrumbsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $8c71b8b527adcfdf$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kVIgP.default), null, Array.from({
        length: itemCount
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5zdB1.default), {
            width: 60,
            key: index
        }))));
};
const $8c71b8b527adcfdf$export$cc8c957f0e477af0 = ()=>{
    const intl = (0, $gpjDl.default)();
    const items = (0, $hPVoC.useHubBreadcrumbItems)();
    const currentItem = items[items.length - 1];
    const { env: { relativeBaseUrl: relativeBaseUrl } } = (0, $aQNcS.useHubContext)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    if (!currentItem) return null;
    const label = intl.formatMessage((0, $jEmWr.messages).label);
    const ellipsisLabel = intl.formatMessage((0, $jEmWr.messages).showMore);
    const onBreadcrumbItemClick = (href)=>(event)=>{
            const isPrimaryClick = 'button' in event && event.button === 0;
            const isEnterKey = 'key' in event && event.key === 'Enter';
            if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                // The anchor needs the Hub base path, but browser history adds it on navigation.
                event.preventDefault();
                push(href);
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": "hub-breadcrumbs-container",
        className: (0, $2R2iS.default)([
            $8c71b8b527adcfdf$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ddnRa.default), {
        ellipsisLabel: ellipsisLabel,
        label: label,
        size: "medium",
        testId: "hub-breadcrumbs"
    }, items.slice(0, -1).map((item, index)=>item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
            data: {
                attributes: {
                    itemType: item.id,
                    position: index + 1
                }
            },
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $52Xoa.default), {
            href: (0, $4HJ98.getHubBreadcrumbHref)(relativeBaseUrl, item.href),
            onClick: onBreadcrumbItemClick(item.href),
            text: item.text
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8c71b8b527adcfdf$var$StaticHubParentBreadcrumb, {
            item: item,
            key: item.id
        })), currentItem.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                itemType: currentItem.id,
                position: items.length
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hDt7O.default), {
        href: (0, $4HJ98.getHubBreadcrumbHref)(relativeBaseUrl, currentItem.href),
        text: currentItem.text
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($8c71b8b527adcfdf$var$StaticHubCurrentBreadcrumb, {
        item: currentItem
    })));
};

});
parcelRegister("52Xoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $35ab1dac5ec2c759$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $bcTS3 = parcelRequire("bcTS3");

var $iy8tI = parcelRequire("iy8tI");

var $lBlRs = parcelRequire("lBlRs");

var $h2rHJ = parcelRequire("h2rHJ");

var $l9rCJ = parcelRequire("l9rCJ");

var $lQfHe = parcelRequire("lQfHe");
const $35ab1dac5ec2c759$var$itemWrapperStyles = null;
const $35ab1dac5ec2c759$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $35ab1dac5ec2c759$var$ICON_WIDTH_ESTIMATE = 24;
const $35ab1dac5ec2c759$var$staticItemStyles = null;
const $35ab1dac5ec2c759$var$staticItemWithTruncationStyles = null;
const $35ab1dac5ec2c759$var$staticItemWithoutTruncationStyles = null;
const $35ab1dac5ec2c759$var$motionItemStyles = null;
const $35ab1dac5ec2c759$var$BreadcrumbsItem = /*#__PURE__*/ (0, $fc4bM.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $fc4bM.useState)(null);
    const setStepRef = (0, $fc4bM.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $l9rCJ.useBreadcrumbsSize)();
    const leadingIconWidth = resolvedElemBefore ? $35ab1dac5ec2c759$var$ICON_WIDTH_ESTIMATE + (breadcrumbsSize === 'small' ? 0 : 2) : 0;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $35ab1dac5ec2c759$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $35ab1dac5ec2c759$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $lQfHe.default)(truncationWidth, stepElement, // The refresh control now includes the leading icon; exclude it from the truncation check.
    (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') ? -leadingIconWidth : iconWidthAllowance);
    if (!component && (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iy8tI.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // TODO(CAT-2913): Remove `iconAfter` from the refresh path once Jira stops depending on deprecated
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$35ab1dac5ec2c759$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lBlRs.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $h2rHJ.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $2R2iS.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v",
            "_v564hxmd _4bfu1j28 _1hms8stv _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("li", {
        ref: _overflowRef,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _4cvr1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35ab1dac5ec2c759$export$2e2bcd8739ae039 = $35ab1dac5ec2c759$var$BreadcrumbsItem;

});
parcelRegister("iy8tI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dfbc58e7d24070f$export$2e2bcd8739ae039);
/* breadcrumbs-item-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* breadcrumbs-item-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4dCfH = parcelRequire("4dCfH");

var $bcTS3 = parcelRequire("bcTS3");

var $lBlRs = parcelRequire("lBlRs");
const $5dfbc58e7d24070f$var$itemWrapperStyles = null;
const $5dfbc58e7d24070f$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lBlRs.default), {
            ref: tooltipRef ? (0, $4dCfH.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth,
            children: text
        });
    };
    const step = renderStep();
    return /*#__PURE__*/ (0, $3LM7S.jsx)("li", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required for public xcss passthrough
        className: (0, $2R2iS.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _2lx2vrvc _1wpz1h6o _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1q9y _14rn1rpy _aetr1n76 _8yoa1h6o",
            xcss
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5dfbc58e7d24070f$export$2e2bcd8739ae039 = $5dfbc58e7d24070f$var$BreadcrumbsItemBase;

});
parcelRegister("lBlRs", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb7c8f5a735f7420$export$2e2bcd8739ae039);
/* step.tsx generated by @compiled/babel-plugin v3.0.2 */ /* step.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $7iKPB = parcelRequire("7iKPB");

var $4Cnkn = parcelRequire("4Cnkn");

var $9JZL9 = parcelRequire("9JZL9");

var $dRkX9 = parcelRequire("dRkX9");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $EawnW = parcelRequire("EawnW");

var $l9rCJ = parcelRequire("l9rCJ");
const $bb7c8f5a735f7420$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: undefined,
    packageVersion: undefined
};
const $bb7c8f5a735f7420$var$noop = (0, $9JZL9.default);
const $bb7c8f5a735f7420$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rkolb4i _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    rootRefresh: "_zulpze3t _vchhusvi _4t3i1k8s",
    interactiveMotion: "_v564hxmd _1hms8stv _4bfu1j28 _o7kshxmd _9oik1rpy _1ggl87vo _1nrmi7uo",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    withTruncation: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperSpacing: "_12l2v77o",
    iconWrapperSmallSpacing: "_12l2ze3t",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textWithIconAfter: "_12l21b66",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $bb7c8f5a735f7420$var$unboundedStyles = {
    iconWrapperRefresh: "_1bsb1ejb _4t3i1ejb",
    iconWrapperSmall: "_w8l57vkz _17527vkz",
    iconWrapperSmallRefresh: "_w8l5pxbi _1752pxbi",
    iconWrapper: "_syaz1cv2"
};
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $bb7c8f5a735f7420$var$Step = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $bb7c8f5a735f7420$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $l9rCJ.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    // Preserve the text/trailing-icon width budget now that the leading icon is inside the control.
    const leadingIconWidth = resolvedElemBefore ? `${"var(--ds-space-300, 24px)"} + ${isSmall ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)"}` : '0px';
    const maxWidth = (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && truncationWidth != null ? `calc(${truncationWidth}px + ${leadingIconWidth})` : truncationWidth;
    const handleClick = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bb7c8f5a735f7420$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        var _triggerProps$onClick;
        triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
        handleClick(event);
    };
    const controlRef = (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $2R2iS.default)([
            $bb7c8f5a735f7420$var$styles.iconWrapper,
            (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$unboundedStyles.iconWrapperRefresh,
            $bb7c8f5a735f7420$var$unboundedStyles.iconWrapper,
            (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$styles.iconWrapperSpacing,
            isSmall && $bb7c8f5a735f7420$var$styles.iconWrapperSmallSpacing,
            !(0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $bb7c8f5a735f7420$var$unboundedStyles.iconWrapperSmall,
            (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $bb7c8f5a735f7420$var$unboundedStyles.iconWrapperSmallRefresh
        ]),
        children: resolvedElemBefore
    });
    const content = /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            !(0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore,
            ((0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') || isSmall) && iconElement,
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                ref: textRef,
                className: (0, $2R2iS.default)([
                    $bb7c8f5a735f7420$var$styles.text,
                    (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && Boolean(iconAfter) && $bb7c8f5a735f7420$var$styles.textWithIconAfter,
                    truncationWidth != null && (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$styles.textWithTruncation
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Ny1Q.Anchor), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        href: href,
        onClick: handleTriggerClick,
        onMouseOver: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver) ?? onMouseOver,
        onMouseOut: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut) ?? onMouseOut,
        onMouseMove: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove) ?? onMouseMove,
        onMouseDown: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown) ?? onMouseDown,
        onFocus: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus) ?? onFocus,
        onBlur: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur) ?? onBlur,
        "aria-describedby": (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby']) ?? ariaDescribedBy,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: testId,
        title: title,
        xcss: (0, $4Cnkn.cx)($bb7c8f5a735f7420$var$styles.root, isSmall && $bb7c8f5a735f7420$var$styles.rootSmall, (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$styles.rootRefresh, truncationWidth != null && (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$styles.withTruncation, truncationWidth == null && $bb7c8f5a735f7420$var$styles.withoutTruncation, $bb7c8f5a735f7420$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: handleTriggerClick,
        onMouseOver: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOver) ?? onMouseOver,
        onMouseOut: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseOut) ?? onMouseOut,
        onMouseMove: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseMove) ?? onMouseMove,
        onMouseDown: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onMouseDown) ?? onMouseDown,
        onFocus: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onFocus) ?? onFocus,
        onBlur: (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onBlur) ?? onBlur,
        "aria-describedby": (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps['aria-describedby']) ?? ariaDescribedBy,
        testId: testId,
        title: title,
        xcss: (0, $4Cnkn.cx)($bb7c8f5a735f7420$var$styles.root, isSmall && $bb7c8f5a735f7420$var$styles.rootSmall, (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$styles.rootRefresh, truncationWidth != null && (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') && $bb7c8f5a735f7420$var$styles.withTruncation, truncationWidth == null && $bb7c8f5a735f7420$var$styles.withoutTruncation, $bb7c8f5a735f7420$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
});
var $bb7c8f5a735f7420$export$2e2bcd8739ae039 = $bb7c8f5a735f7420$var$Step;

});


parcelRegister("h2rHJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $20d7f5a3e6aa1c09$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $kTVlm = parcelRequire("kTVlm");

var $9JZL9 = parcelRequire("9JZL9");

var $dRkX9 = parcelRequire("dRkX9");
const $20d7f5a3e6aa1c09$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: undefined,
    packageVersion: undefined
};
const $20d7f5a3e6aa1c09$var$noop = (0, $9JZL9.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $20d7f5a3e6aa1c09$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $20d7f5a3e6aa1c09$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$20d7f5a3e6aa1c09$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $dRkX9.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kTVlm.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $20d7f5a3e6aa1c09$export$2e2bcd8739ae039 = $20d7f5a3e6aa1c09$var$StepOld;

});


parcelRegister("kVIgP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6c10a0e064ee24e$export$2e2bcd8739ae039);
/* breadcrumbs-skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $5zdB1 = parcelRequire("5zdB1");

var $dvA9j = parcelRequire("dvA9j");
const $e6c10a0e064ee24e$var$styles = {
    nav: "_p12f1osq",
    list: "_1e0c1txw _4cvr1h6o _1n261g80 _2mzuglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
};
const $e6c10a0e064ee24e$var$defaultItems = [
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5zdB1.default), {
        width: 64
    }, "home"),
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5zdB1.default), {
        width: 96
    }, "parent"),
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5zdB1.default), {
        width: 80
    }, "current")
];
function $e6c10a0e064ee24e$export$2e2bcd8739ae039({ children: children, isShimmering: isShimmering = true, label: label = 'Loading breadcrumbs', size: size = 'medium', testId: testId }) {
    const renderedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.count(children) > 0 ? children : $e6c10a0e064ee24e$var$defaultItems;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dvA9j.BreadcrumbsSkeletonContext).Provider, {
        value: {
            isShimmering: isShimmering,
            size: size
        },
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("nav", {
            "aria-busy": "true",
            "aria-label": label,
            className: (0, $2R2iS.default)([
                $e6c10a0e064ee24e$var$styles.nav
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("ol", {
                "aria-hidden": "true",
                "data-testid": testId,
                className: (0, $2R2iS.default)([
                    $e6c10a0e064ee24e$var$styles.list
                ]),
                children: renderedChildren
            })
        })
    });
}

});
parcelRegister("5zdB1", function(module, exports) {
$parcel$export(module.exports, "default", () => $52fc34c2579efbae$export$2e2bcd8739ae039);
/* breadcrumbs-skeleton-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $9tXBF = parcelRequire("9tXBF");

var $4E5hn = parcelRequire("4E5hn");
const $52fc34c2579efbae$var$styles = {
    item: "_1e0c1txw _4cvr1h6o _vchhusvi _4t3i1k8s _p12f1osq",
    iconWrapper: "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _12l2v77o"
};
const $52fc34c2579efbae$var$unboundedStyles = {
    item: "_1758v77o _z9kiu2gc _f42wftgi _rfr7idpf _nqnu1rpy _8bo21n76 _n2r11h6o"
};
function $52fc34c2579efbae$export$2e2bcd8739ae039({ hasIcon: hasIcon, width: width }) {
    const { isShimmering: isShimmering, size: size } = (0, $4E5hn.useBreadcrumbsSkeleton)();
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("li", {
        className: (0, $2R2iS.default)([
            $52fc34c2579efbae$var$styles.item,
            $52fc34c2579efbae$var$unboundedStyles.item
        ]),
        children: [
            hasIcon ? /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                className: (0, $2R2iS.default)([
                    $52fc34c2579efbae$var$styles.iconWrapper
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9tXBF.default), {
                    height: 16,
                    isShimmering: isShimmering,
                    width: 16
                })
            }) : null,
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9tXBF.default), {
                height: size === 'small' ? 12 : 14,
                isShimmering: isShimmering,
                width: width
            })
        ]
    });
}

});
parcelRegister("9tXBF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b1ae627ff5eab71f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $fVzQQ = parcelRequire("fVzQQ");

var $dRkX9 = parcelRequire("dRkX9");
const $b1ae627ff5eab71f$var$shimmerKeyframes = null;
const $b1ae627ff5eab71f$var$skeletonStyles = null;
const $b1ae627ff5eab71f$var$activeShimmerStyles = null;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $b1ae627ff5eab71f$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $b1ae627ff5eab71f$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    $b1ae627ff5eab71f$var$useLayoutEffect(()=>{
        if (context != null && (0, $dRkX9.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $2R2iS.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
            isShimmering && "",
            isShimmering && "_j7hq19vq"
        ])
    });
};
var $b1ae627ff5eab71f$export$2e2bcd8739ae039 = $b1ae627ff5eab71f$var$Skeleton;

});

parcelRegister("4E5hn", function(module, exports) {
$parcel$export(module.exports, "useBreadcrumbsSkeleton", () => $6934bc8a38fe7bfa$export$15d0b942535a287);

var $fc4bM = parcelRequire("fc4bM");

var $dvA9j = parcelRequire("dvA9j");
function $6934bc8a38fe7bfa$export$15d0b942535a287() {
    return (0, $fc4bM.useContext)((0, $dvA9j.BreadcrumbsSkeletonContext));
}

});
parcelRegister("dvA9j", function(module, exports) {
$parcel$export(module.exports, "BreadcrumbsSkeletonContext", () => $d48fce89bfc700a4$export$ea207007e4cd246c);

var $fc4bM = parcelRequire("fc4bM");
const $d48fce89bfc700a4$export$ea207007e4cd246c = /*#__PURE__*/ (0, $fc4bM.createContext)({
    isShimmering: true,
    size: 'medium'
});

});




parcelRegister("2MYZ0", function(module, exports) {
$parcel$export(module.exports, "HUB_FEATURES", () => $9f7ce9e0abed7962$export$49ecbc2ec404bcce);
$parcel$export(module.exports, "useIsHubFeatureEnabled", () => $9f7ce9e0abed7962$export$5a7b13b33b3b4bc8);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $aQNcS = parcelRequire("aQNcS");
var $9f7ce9e0abed7962$export$49ecbc2ec404bcce = /*#__PURE__*/ function(HUB_FEATURES) {
    HUB_FEATURES["BREADCRUMBS"] = "BREADCRUMBS";
    HUB_FEATURES["CONFIGURABLE_SITE_TREE"] = "CONFIGURABLE_SITE_TREE";
    HUB_FEATURES["DRAFT_MODE"] = "DRAFT_MODE";
    return HUB_FEATURES;
}({});
const $9f7ce9e0abed7962$var$HUB_FEATURE_CONFIG = {
    ["BREADCRUMBS"]: {
        contextKey: 'enable_hub_breadcrumbs',
        isPlatformEnabled: ()=>(0, $dRkX9.fg)('enable_hub_breadcrumbs')
    },
    ["CONFIGURABLE_SITE_TREE"]: {
        contextKey: 'help_hubs_configurable_site_tree',
        isPlatformEnabled: ()=>(0, $dRkX9.fg)('help_hubs_configurable_site_tree')
    },
    ["DRAFT_MODE"]: {
        contextKey: 'help_hubs_draft_mode',
        isPlatformEnabled: ()=>(0, $dRkX9.fg)('help_hubs_draft_mode')
    }
};
function $9f7ce9e0abed7962$export$5a7b13b33b3b4bc8(features) {
    const ctx = (0, $fc4bM.useContext)((0, $aQNcS.HubContext));
    const next = features.map((feature)=>{
        var _ctx$featureFlags;
        const { contextKey: contextKey, isPlatformEnabled: isPlatformEnabled } = $9f7ce9e0abed7962$var$HUB_FEATURE_CONFIG[feature];
        const isContextEnabled = (ctx === null || ctx === void 0 || (_ctx$featureFlags = ctx.featureFlags) === null || _ctx$featureFlags === void 0 ? void 0 : _ctx$featureFlags[contextKey]) === true;
        return isContextEnabled && isPlatformEnabled();
    });
    // Reuse the previous array when values match so deps on the return value
    // do not re-fire every render.
    const cachedRef = (0, $fc4bM.useRef)(next);
    const cached = cachedRef.current;
    if (cached.length !== next.length || next.some((value, index)=>value !== cached[index])) cachedRef.current = next;
    return cachedRef.current;
}

});

parcelRegister("4HJ98", function(module, exports) {
$parcel$export(module.exports, "getHubBreadcrumbHref", () => $4734653bea0894b0$export$657a9453714bdcb9);
const $4734653bea0894b0$export$657a9453714bdcb9 = (relativeBaseUrl, routePath)=>{
    const basePath = relativeBaseUrl.replace(/\/+$/, '');
    if (/^https?:\/\//.test(routePath)) return routePath;
    if (basePath && (routePath === basePath || routePath.startsWith(`${basePath}/`))) return routePath;
    const path = routePath === '/' ? '' : `/${routePath.replace(/^\/+/, '')}`;
    return `${basePath}${path}` || '/';
};

});

parcelRegister("hPVoC", function(module, exports) {
$parcel$export(module.exports, "HubBreadcrumbsProvider", () => $3503129bb912db7e$export$cf2b9e6505681ebf);
$parcel$export(module.exports, "useRegisterHubBreadcrumbs", () => $3503129bb912db7e$export$695acbe2b31cd25f);
$parcel$export(module.exports, "useHubBreadcrumbItems", () => $3503129bb912db7e$export$e623729f7cd92c6b);

var $fc4bM = parcelRequire("fc4bM");
const $3503129bb912db7e$var$HubBreadcrumbsContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $3503129bb912db7e$var$areBreadcrumbsEqual = (currentItems, nextItems)=>currentItems.length === nextItems.length && currentItems.every((item, index)=>{
        const nextItem = nextItems[index];
        return nextItem !== undefined && item.href === nextItem.href && item.id === nextItem.id && item.text === nextItem.text;
    });
const $3503129bb912db7e$export$cf2b9e6505681ebf = ({ children: children })=>{
    const [items, setItems] = (0, $fc4bM.useState)([]);
    const setBreadcrumbs = (0, $fc4bM.useCallback)((nextItems)=>{
        setItems((currentItems)=>$3503129bb912db7e$var$areBreadcrumbsEqual(currentItems, nextItems) ? currentItems : nextItems);
    }, []);
    const clearBreadcrumbs = (0, $fc4bM.useCallback)(()=>setItems([]), []);
    const value = (0, $fc4bM.useMemo)(()=>({
            clearBreadcrumbs: clearBreadcrumbs,
            items: items,
            setBreadcrumbs: setBreadcrumbs
        }), [
        clearBreadcrumbs,
        items,
        setBreadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3503129bb912db7e$var$HubBreadcrumbsContext.Provider, {
        value: value
    }, children);
};
const $3503129bb912db7e$var$useHubBreadcrumbsContext = ()=>{
    const context = (0, $fc4bM.useContext)($3503129bb912db7e$var$HubBreadcrumbsContext);
    if (!context) throw new Error('Hub breadcrumb hooks must be used within HubBreadcrumbsProvider');
    return context;
};
const $3503129bb912db7e$export$695acbe2b31cd25f = (items)=>{
    const { clearBreadcrumbs: clearBreadcrumbs, setBreadcrumbs: setBreadcrumbs } = $3503129bb912db7e$var$useHubBreadcrumbsContext();
    (0, $fc4bM.useEffect)(()=>{
        setBreadcrumbs(items);
    }, [
        items,
        setBreadcrumbs
    ]);
    (0, $fc4bM.useEffect)(()=>()=>{
            clearBreadcrumbs();
        }, [
        clearBreadcrumbs
    ]);
};
const $3503129bb912db7e$export$e623729f7cd92c6b = ()=>$3503129bb912db7e$var$useHubBreadcrumbsContext().items;

});

parcelRegister("jEmWr", function(module, exports) {
$parcel$export(module.exports, "messages", () => $45f050397d007c42$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $45f050397d007c42$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    label: {
        id: 'company-hub-common.hub-breadcrumbs.label.non-final',
        defaultMessage: 'Breadcrumbs',
        description: 'Accessible label for the breadcrumb navigation shown on Help Hub pages.'
    },
    showMore: {
        id: 'company-hub-common.hub-breadcrumbs.showMore.non-final',
        defaultMessage: 'Show more breadcrumbs',
        description: 'Accessible label for the button that reveals breadcrumb items hidden at narrow widths.'
    }
});

});


parcelRegister("afA7P", function(module, exports) {
$parcel$export(module.exports, "HubTypographyScope", () => $72d8152157415392$export$e514657628596864);

var $fc4bM = parcelRequire("fc4bM");

var $iU70g = parcelRequire("iU70g");

var $lGUoH = parcelRequire("lGUoH");

var $7Wa2q = parcelRequire("7Wa2q");
var $8xZUP = parcelRequire("8xZUP");
var $6V7Ay = parcelRequire("6V7Ay");
/**
 * Force the picked typography onto every descendant of HubTypographyScope,
 * including admin-published content rendered inside the editor (info
 * panels, decision lists, headings, paragraphs, etc.).
 *
 * Why this rule is needed — observed in DevTools:
 *   - An emotion-styled Hub layout box (e.g. `.fEBamI`) renders ABOVE
 *     HubTypographyScope and declares `font: var(--ds-font-body)` on
 *     itself. At that ancestor our scope isn't in scope yet, so
 *     `var(--ds-font-body)` resolves to AK's default and the `font`
 *     shorthand sets `font-family: <Atlassian Sans / ui-sans-serif, ...>`
 *     directly. That declared `font-family` then cascades down through
 *     HubTypographyScope, through the editor wrapper, and into every
 *     paragraph and heading the admin inserts.
 *   - Overriding CSS variables alone doesn't break the chain because
 *     `font-family` is already declared (inherited) at HubTypographyScope's
 *     ancestor and nothing inside the editor `var()`-references our handles
 *     for font-family itself.
 *
 * Fix: declare `font-family` directly at HubTypographyScope's wrapper
 * (paragraph stack) so descendants inherit the picked family, and
 * override to the heading stack for any heading element inside the scope.
 *
 * The editor `--editor-font-ugc-token-*` redeclarations stay as a
 * defensive hook for any editor surface that does consume them via
 * `font: var(--editor-font-ugc-token-body)`. Late-bound `var()`
 * substitution lets HubTypographyResetScope reset them back to
 * Atlassian Sans for admin-only popovers without touching this rule.
 *
 * Wrapper inheritance alone is NOT enough for `.ProseMirror p` (see the
 * dedicated rule below): @atlaskit/editor-core hardcodes a literal font
 * stack directly on that selector rather than consuming the UGC token,
 * so it must be beaten with an explicit `!important` override too.
 */ const $72d8152157415392$var$TYPOGRAPHY_CSS = `
[data-hub-typography-scope] :where(h1, h2, h3, h4, h5, h6) {
	/*
	 * !important is required to beat the renderer's heading font.
	 * @atlaskit/renderer renders view-mode headings with
	 * \`font: var(--ak-renderer-editor-font-heading-*)\` \u{2014} a \`font\`
	 * shorthand at specificity (0,2,0) whose family segment is the
	 * hardcoded \`ui-sans-serif, -apple-system, ...\` stack. We can't
	 * override that token (the renderer sets it inline on its own
	 * dynamic-class container, which shadows any inherited override), so
	 * we override the family longhand with !important. It wins over the
	 * non-important shorthand's family while leaving the renderer's
	 * size / weight / line-height intact. The same rule covers editor
	 * (.ProseMirror) and AK Heading components, which is why it's applied
	 * scope-wide rather than only to the renderer.
	 */
	font-family: var(--hub-heading-font-family) !important;
}

[data-hub-typography-scope] .ProseMirror p {
	/*
	 * !important is required to beat @atlaskit/editor-core's own paragraph
	 * rule (paragraphStylesUGCRefreshed / paragraphStylesUGCModernized),
	 * which hardcodes a literal "Atlassian Sans" font stack directly on
	 * \`.ProseMirror p\` instead of consuming a themeable token (unlike the
	 * heading rule above, which does read --editor-font-ugc-token-heading-*).
	 * Every text node the editor wraps in a <p> \u{2014} plain paragraphs,
	 * bullet/ordered list items, blockquotes, table cells, panels, expands,
	 * task/decision items \u{2014} inherits that hardcoded family, so it must be
	 * overridden here the same way headings are.
	 */
	font-family: var(--hub-paragraph-font-family) !important;
}

[data-hub-typography-scope] .ProseMirror {
	--editor-font-ugc-token-heading-h1: normal 500 1.71429em / 1.16667 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h2: normal 500 1.42857em / 1.2 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h3: normal 600 1.14286em / 1.25 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h4: normal 600 1em / 1.14286 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h5: normal 600 0.857143em / 1.33333 var(--hub-heading-font-family);
	--editor-font-ugc-token-heading-h6: normal 700 0.785714em / 1.45455 var(--hub-heading-font-family);
	--editor-font-ugc-token-body: normal 400 1em / 1.714 var(--hub-paragraph-font-family);
}

[data-hub-typography-scope] .ak-renderer-document {
	/*
	 * View-mode (renderer) UGC typography \u{2014} the mirror of the .ProseMirror block
	 * above. @atlaskit/renderer renders native ADF content (paragraphs, lists,
	 * panels, expand, blockquotes, dates, layout columns, table cells, headings\u{2026})
	 * by reading its own --ak-renderer-editor-font-* "font" shorthand tokens,
	 * which bake in the default Atlassian Sans family. We redefine those tokens
	 * with the picked hub family \u{2014} the values are copied verbatim from
	 * @atlaskit/editor-common's editorUGCTokensRefreshed and ONLY the trailing
	 * family segment is swapped \u{2014} so the renderer's size / weight / line-height
	 * are preserved exactly and only the family changes. !important is needed to
	 * beat the renderer setting these tokens inline on its own container.
	 *
	 * Why remap tokens instead of forcing font-family on every element: this
	 * touches ONLY the renderer's private tokens \u{2014} never font-family directly and
	 * never the shared --ds-font-* tokens. So bespoke extensions (spotlight,
	 * cards, carousel, \u{2026}), which style their titles/body with --ds-font-* and are
	 * remapped once on the wrapper (HUB_HEADING_TOKEN_MAP / HUB_PARAGRAPH_TOKEN_MAP),
	 * are untouched and keep the correct heading vs body font in both edit and
	 * view mode. Code (@atlaskit/code, its own monospace token) and
	 * HubTypographyResetScope subtrees don't read these tokens either, so they are
	 * left alone automatically \u{2014} no per-element exclusions required.
	 *
	 * Both modes now theme font *tokens* rather than overriding elements, so a new
	 * ADF node type is covered in both modes with no per-element work.
	 */
	--ak-renderer-editor-font-heading-h1: normal 600 1.71429em / 1.16667 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h2: normal 600 1.42857em / 1.2 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h3: normal 600 1.14286em / 1.25 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h4: normal 600 1em / 1.14286 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h5: normal 600 0.857143em / 1.33333 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-heading-h6: normal 600 0.785714em / 1.45455 var(--hub-heading-font-family) !important;
	--ak-renderer-editor-font-normal-text: normal 400 1em / 1.714 var(--hub-paragraph-font-family) !important;
	--ak-renderer-editor-font-small-text: normal 400 0.875em / 1.714 var(--hub-paragraph-font-family) !important;
}
`;
const $72d8152157415392$export$e514657628596864 = ({ children: children })=>{
    const enabled = (0, $lGUoH.useIsHubTypographyEnabled)();
    const theming = (0, $iU70g.useHubTheming)();
    const typography = theming === null || theming === void 0 ? void 0 : theming.typography;
    const googleFontsUrl = (0, $fc4bM.useMemo)(()=>typography ? (0, $7Wa2q.buildGoogleFontsUrl)([
            typography.heading,
            typography.body
        ]) : '', [
        typography
    ]);
    const wrapperStyle = (0, $fc4bM.useMemo)(()=>{
        if (!typography) return {};
        // FONT_REGISTRY values are intentionally hard-coded font stacks — this
        // component's entire purpose is to override AK's typography tokens with
        // admin-picked families, so AK design-system tokens cannot be used here.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        const heading = (0, $8xZUP.FONT_REGISTRY)[typography.heading].family;
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        const body = (0, $8xZUP.FONT_REGISTRY)[typography.body].family;
        return {
            display: 'contents',
            // Points at our own --hub-paragraph-font-family handle so descendants
            // inherit the picked family. AK tokens cannot be used here — this IS
            // the override mechanism.
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontFamily: 'var(--hub-paragraph-font-family)',
            '--hub-heading-font-family': heading,
            '--hub-paragraph-font-family': body,
            ...(0, $6V7Ay.HUB_HEADING_TOKEN_MAP),
            ...(0, $6V7Ay.HUB_PARAGRAPH_TOKEN_MAP)
        };
    }, [
        typography
    ]);
    if (!enabled || !typography) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, googleFontsUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("link", {
        rel: "stylesheet",
        href: googleFontsUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("style", null, $72d8152157415392$var$TYPOGRAPHY_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-hub-typography-scope": "",
        style: wrapperStyle
    }, children));
};

});
parcelRegister("lGUoH", function(module, exports) {
$parcel$export(module.exports, "useIsHubTypographyEnabled", () => $3d6ded1f1ccb6b13$export$7667d247a9598346);
/**
 * Returns `true` when Hub typography customization should be active.
 *
 * Typography is a sub-feature of advanced theming and never ships without it,
 * so this is gated by `useIsAdvancedThemingEnabled`, which ANDs together:
 *   1. The product-level flag `advanced-theming-in-hub` (via HubContext).
 *   2. The platform-level Statsig gate `hub-advanced-theming` (the v2
 *      colour palette gate).
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */ 
var $iIxrR = parcelRequire("iIxrR");
const $3d6ded1f1ccb6b13$export$7667d247a9598346 = ()=>{
    return (0, $iIxrR.useIsAdvancedThemingEnabled)();
};

});

parcelRegister("7Wa2q", function(module, exports) {
$parcel$export(module.exports, "buildGoogleFontsUrl", () => $cc48c71bc27ba059$export$86eb54e95bc87537);

var $8xZUP = parcelRequire("8xZUP");
const $cc48c71bc27ba059$export$86eb54e95bc87537 = (fontKeys)=>{
    const families = new Set();
    for (const key of fontKeys){
        const family = (0, $8xZUP.FONT_REGISTRY)[key].googleFontsFamily;
        if (family) families.add(family);
    }
    if (families.size === 0) return '';
    const query = Array.from(families).map((f)=>`family=${f}`).join('&');
    return `https://fonts.googleapis.com/css2?${query}&display=swap`;
};

});

parcelRegister("6V7Ay", function(module, exports) {
$parcel$export(module.exports, "HUB_HEADING_TOKEN_MAP", () => $7495726be2a6d640$export$f357f3dafa7e9577);
$parcel$export(module.exports, "HUB_PARAGRAPH_TOKEN_MAP", () => $7495726be2a6d640$export$74bfab40c379f83);
/**
 * CSS-var overrides set on the `<HubTypographyScope>` wrapper. These map
 * AK design-system typography tokens onto values that reference the
 * `--hub-heading-font-family` / `--hub-paragraph-font-family` handles —
 * forcing every heading / body composite token to render with the admin's
 * picked font instead of the AK default.
 *
 * Sizes and line-heights use rem values matching the canonical AK source at
 * `platform/packages/design-system/tokens/src/artifacts/themes/atlassian-typography.tsx`.
 * The only difference from the AK source is the `font-family` segment, which
 * is replaced with the hub family CSS-var handle.
 *
 * Medium / Bold / xxsmall heading entries and weight variants for body are
 * included defensively (cost of a missing override is visible inconsistency;
 * cost of an unnecessary override is zero).
 */ const $7495726be2a6d640$export$f357f3dafa7e9577 = {
    '--ds-font-family-heading': 'var(--hub-heading-font-family)',
    '--ds-font-family-brand-heading': 'var(--hub-heading-font-family)',
    '--ds-font-heading-xxlarge': 'normal 653 2rem/2.25rem var(--hub-heading-font-family)',
    '--ds-font-heading-xlarge': 'normal 653 1.75rem/2rem var(--hub-heading-font-family)',
    '--ds-font-heading-large': 'normal 653 1.5rem/1.75rem var(--hub-heading-font-family)',
    '--ds-font-heading-medium': 'normal 653 1.25rem/1.5rem var(--hub-heading-font-family)',
    '--ds-font-heading-small': 'normal 653 1rem/1.25rem var(--hub-heading-font-family)',
    '--ds-font-heading-xsmall': 'normal 653 0.875rem/1.25rem var(--hub-heading-font-family)',
    '--ds-font-heading-xxsmall': 'normal 653 0.75rem/1rem var(--hub-heading-font-family)'
};
const $7495726be2a6d640$export$74bfab40c379f83 = {
    '--ds-font-family-body': 'var(--hub-paragraph-font-family)',
    '--ds-font-family-brand-body': 'var(--hub-paragraph-font-family)',
    '--ds-font-body-large': 'normal 400 1rem/1.5rem var(--hub-paragraph-font-family)',
    '--ds-font-body-large-medium': 'normal 500 1rem/1.5rem var(--hub-paragraph-font-family)',
    '--ds-font-body-large-bold': 'normal 700 1rem/1.5rem var(--hub-paragraph-font-family)',
    '--ds-font-body': 'normal 400 0.875rem/1.25rem var(--hub-paragraph-font-family)',
    '--ds-font-body-medium': 'normal 500 0.875rem/1.25rem var(--hub-paragraph-font-family)',
    '--ds-font-body-bold': 'normal 700 0.875rem/1.25rem var(--hub-paragraph-font-family)',
    '--ds-font-body-small': 'normal 400 0.75rem/1rem var(--hub-paragraph-font-family)',
    '--ds-font-body-small-medium': 'normal 500 0.75rem/1rem var(--hub-paragraph-font-family)',
    '--ds-font-body-small-bold': 'normal 700 0.75rem/1rem var(--hub-paragraph-font-family)',
    '--ds-font-body-UNSAFE_small': 'normal 400 0.75rem/1rem var(--hub-paragraph-font-family)'
};

});


parcelRegister("dJGUc", function(module, exports) {
$parcel$export(module.exports, "isDefaultHelpCenterBasePath", () => $075c76bab69ad3cb$export$5c865fc34320ed7b);
$parcel$export(module.exports, "getHelpCenterHomePath", () => $075c76bab69ad3cb$export$e90b39e75e81f606);
const $075c76bab69ad3cb$var$DEFAULT_HELP_CENTER_BASE_PATH = '/servicedesk/customer';
const $075c76bab69ad3cb$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH = '/servicedesk/customer/test';
const $075c76bab69ad3cb$var$PORTALS_SEGMENT = '/portals';
const $075c76bab69ad3cb$var$stripTrailingSlashes = (path)=>path.replace(/\/+$/, '');
const $075c76bab69ad3cb$export$5c865fc34320ed7b = (basePath)=>{
    const normalizedBasePath = $075c76bab69ad3cb$var$stripTrailingSlashes(basePath);
    return [
        $075c76bab69ad3cb$var$DEFAULT_HELP_CENTER_BASE_PATH,
        $075c76bab69ad3cb$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH,
        `${$075c76bab69ad3cb$var$DEFAULT_HELP_CENTER_BASE_PATH}${$075c76bab69ad3cb$var$PORTALS_SEGMENT}`,
        `${$075c76bab69ad3cb$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH}${$075c76bab69ad3cb$var$PORTALS_SEGMENT}`
    ].includes(normalizedBasePath);
};
const $075c76bab69ad3cb$export$e90b39e75e81f606 = (basePath)=>{
    const normalizedBasePath = $075c76bab69ad3cb$var$stripTrailingSlashes(basePath);
    if (!$075c76bab69ad3cb$export$5c865fc34320ed7b(normalizedBasePath)) return normalizedBasePath;
    return normalizedBasePath.endsWith($075c76bab69ad3cb$var$PORTALS_SEGMENT) ? normalizedBasePath : `${normalizedBasePath}${$075c76bab69ad3cb$var$PORTALS_SEGMENT}`;
};

});

parcelRegister("bLOyf", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $e6b33b23013b7bb9$export$3b4e64e77073e307);
$parcel$export(module.exports, "withHubBanner", () => $e6b33b23013b7bb9$export$c5c3e0c2fc948b49);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $cJzRi = parcelRequire("cJzRi");

var $leSAN = parcelRequire("leSAN");

var $fok6N = parcelRequire("fok6N");

var $iIxrR = parcelRequire("iIxrR");

var $aQNcS = parcelRequire("aQNcS");

var $5PsgU = parcelRequire("5PsgU");
const $e6b33b23013b7bb9$var$styles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    textContainer: "_4t3i8vuz _19pk1epz _otyr1epz",
    textContainerWidth: "_1bsb1vuk",
    bannerText: "_k48pwu06 _1wybckbl _vwz48vuz",
    bannerHeadingMargin: "_19pkze3t _otyrze3t",
    bannerTextTruncation: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _y3gn1h6o",
    container: "_2rko12b0"
};
const $e6b33b23013b7bb9$var$BannerContent = ({ bannerText: bannerText })=>{
    const { branding: branding, layout: layout } = (0, $aQNcS.useHubContext)();
    // Advanced theming (help hubs only) gates rendering the banner title as a
    // semantic heading. When off, keep the legacy non-semantic div.
    const isAdvancedThemingEnabled = (0, $iIxrR.useIsAdvancedThemingEnabled)();
    const bannerBackgroundColour = branding.colors.primary;
    const title = bannerText ? bannerText : layout === null || layout === void 0 ? void 0 : layout.bannerText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: bannerBackgroundColour
        },
        "data-testid": "banner",
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cJzRi.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.textContainer,
            (0, $dRkX9.fg)('enable-jsm-in-hubs') && $e6b33b23013b7bb9$var$styles.textContainerWidth
        ])
    }, isAdvancedThemingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("h1", {
        "data-testid": "banner-text",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            color: (0, $5PsgU.readableTextColor)(bannerBackgroundColour)
        },
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.bannerText,
            $e6b33b23013b7bb9$var$styles.bannerHeadingMargin,
            (0, $dRkX9.fg)('enable-jsm-in-hubs') && $e6b33b23013b7bb9$var$styles.bannerTextTruncation
        ])
    }, title || '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": "banner-text",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            color: (0, $5PsgU.readableTextColor)(bannerBackgroundColour)
        },
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.bannerText,
            (0, $dRkX9.fg)('enable-jsm-in-hubs') && $e6b33b23013b7bb9$var$styles.bannerTextTruncation
        ])
    }, title || ''))));
};
// Fallback banner shown when BannerContent fails to render
const $e6b33b23013b7bb9$var$BannerFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: (0, $leSAN.DEFAULT_BRANDING_COLOR)
        },
        "data-testid": "banner-fallback",
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cJzRi.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.textContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            color: "var(--ds-text, #292A2E)"
        },
        className: (0, $2R2iS.default)([
            $e6b33b23013b7bb9$var$styles.bannerText
        ])
    }))));
const $e6b33b23013b7bb9$export$3b4e64e77073e307 = ({ bannerText: bannerText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fok6N.HubErrorBoundary), {
        packageName: "@atlassian/hub-app-shell",
        id: "banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e6b33b23013b7bb9$var$BannerFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e6b33b23013b7bb9$var$BannerContent, {
        bannerText: bannerText
    }));
};
const $e6b33b23013b7bb9$export$c5c3e0c2fc948b49 = (InnerComponent)=>{
    const ComponentWithHubBanner = (props)=>{
        const { bannerText: bannerText, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            className: (0, $2R2iS.default)([
                $e6b33b23013b7bb9$var$styles.bannerContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e6b33b23013b7bb9$export$3b4e64e77073e307, {
            bannerText: bannerText
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(InnerComponent, rest));
    };
    return ComponentWithHubBanner;
};

});
parcelRegister("5PsgU", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $b9148857a8379348$export$3d31854eb05903e0);

var $bRst2 = parcelRequire("bRst2");
const $b9148857a8379348$export$3d31854eb05903e0 = (color)=>{
    return (0, $bRst2.readableTextColor)(color, '@atlassian/hub-app-shell');
};

});


parcelRegister("eh2Kx", function(module, exports) {
$parcel$export(module.exports, "MigrationPublishSuccessFlag", () => $7970ba08a244e779$export$7f6029f49f2c88b);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $abHGL = parcelRequire("abHGL");

var $fBVBf = parcelRequire("fBVBf");

var $aIHAn = parcelRequire("aIHAn");
var $9JZXD = parcelRequire("9JZXD");
const $7970ba08a244e779$export$7f6029f49f2c88b = ({ shouldShow: shouldShow, isSandboxHelpCenter: isSandboxHelpCenterOverride })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { showFlag: showFlag } = (0, $abHGL.useFlags)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        const currentUrl = new URL(window.location.href);
        const shouldShowPublishSuccessFlag = shouldShow ?? currentUrl.searchParams.get((0, $aIHAn.MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM)) === 'true';
        if (!shouldShowPublishSuccessFlag) return;
        if (shouldShow === undefined) {
            currentUrl.searchParams.delete((0, $aIHAn.MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM));
            window.history.replaceState(window.history.state, '', currentUrl);
        }
        const isSandboxHelpCenter = isSandboxHelpCenterOverride ?? (0, $aIHAn.isSandboxHelpCenterBasePath)(currentUrl.pathname);
        const title = formatMessage(isSandboxHelpCenter ? (0, $9JZXD.migrationPublishMessages).sandboxHelpCenterPublished : (0, $9JZXD.migrationPublishMessages).helpCenterPublished);
        showFlag({
            title: title,
            description: formatMessage(isSandboxHelpCenter ? (0, $9JZXD.migrationPublishMessages).sandboxHelpCenterPublishedDescription : (0, $9JZXD.migrationPublishMessages).helpCenterPublishedDescription),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
                label: title,
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "spacious"
            })
        });
    }, [
        formatMessage,
        isSandboxHelpCenterOverride,
        shouldShow,
        showFlag
    ]);
    return null;
};

});
parcelRegister("abHGL", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $41ad575eb60dbab2$export$2879604e6aec4ab);

var $fc4bM = parcelRequire("fc4bM");

var $HfuUp = parcelRequire("HfuUp");
function $41ad575eb60dbab2$export$2879604e6aec4ab() {
    const api = (0, $fc4bM.useContext)((0, $HfuUp.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}

});

parcelRegister("aIHAn", function(module, exports) {
$parcel$export(module.exports, "MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM", () => $ed85bda0b2277f9e$export$d1ab110f0c36cc19);
$parcel$export(module.exports, "isDefaultHelpCenterPortalsPreviewPath", () => $ed85bda0b2277f9e$export$9bfa4aaee0635b5e);
$parcel$export(module.exports, "isSandboxHelpCenterBasePath", () => $ed85bda0b2277f9e$export$4beffde23d35a4ff);
$parcel$export(module.exports, "getMigrationPublishedUrl", () => $ed85bda0b2277f9e$export$deba28094075216b);

var $9JZXD = parcelRequire("9JZXD");
const $ed85bda0b2277f9e$export$d1ab110f0c36cc19 = 'migrationPublished';
const $ed85bda0b2277f9e$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH = '/servicedesk/customer/test/portals';
const $ed85bda0b2277f9e$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH = '/servicedesk/customer/test';
const $ed85bda0b2277f9e$var$HELP_CENTER_PREVIEW_PATH_PREFIX = '/helpcenter/test/';
const $ed85bda0b2277f9e$export$9bfa4aaee0635b5e = (pathname)=>pathname === $ed85bda0b2277f9e$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH || pathname === `${$ed85bda0b2277f9e$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH}/`;
const $ed85bda0b2277f9e$export$4beffde23d35a4ff = (basePath)=>{
    const normalizedBasePath = basePath.replace(/\/+$/, '');
    return normalizedBasePath === $ed85bda0b2277f9e$var$DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH || normalizedBasePath === $ed85bda0b2277f9e$var$DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH || normalizedBasePath.startsWith($ed85bda0b2277f9e$var$HELP_CENTER_PREVIEW_PATH_PREFIX) && normalizedBasePath.length > $ed85bda0b2277f9e$var$HELP_CENTER_PREVIEW_PATH_PREFIX.length;
};
const $ed85bda0b2277f9e$export$deba28094075216b = (url)=>{
    const destination = new URL(url);
    destination.searchParams.set($ed85bda0b2277f9e$export$d1ab110f0c36cc19, 'true');
    return destination.toString();
};

});
parcelRegister("9JZXD", function(module, exports) {
$parcel$export(module.exports, "migrationPublishMessages", () => $10b597ea03752b42$export$30737412df457d29);

var $8p5Cv = parcelRequire("8p5Cv");
const $10b597ea03752b42$export$30737412df457d29 = (0, $8p5Cv.defineMessages)({
    helpCenterPublished: {
        id: 'hub-home.help-center-layout.draft-published-success',
        defaultMessage: 'Help center published',
        description: 'Success flag title shown when draft changes are published to a help center'
    },
    helpCenterPublishedDescription: {
        id: 'hub-home.help-center-layout.draft-published-description',
        defaultMessage: 'All your changes have been published and are now visible to your audience.',
        description: 'Success flag description shown when draft changes are published to a help center'
    },
    sandboxHelpCenterPublished: {
        id: 'hub-home.help-center-layout.sandbox-draft-published-success.non-final',
        defaultMessage: 'Help center published',
        description: 'Success flag title shown when changes are published to a sandbox help center.'
    },
    sandboxHelpCenterPublishedDescription: {
        id: 'hub-home.help-center-layout.sandbox-draft-published-description.non-final',
        defaultMessage: 'Your changes have been published to this help center.',
        description: 'Success flag description shown after publishing draft changes to a sandbox help center.'
    }
});

});



parcelRegister("W2U74", function(module, exports) {
$parcel$export(module.exports, "MigrationReviewActionBar", () => $d3bdbfb505ebf025$export$a3fef1c3a02c6fed);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5y1SF = parcelRequire("5y1SF");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $jEubQ = parcelRequire("jEubQ");

var $5dzEI = parcelRequire("5dzEI");

var $fRCnG = parcelRequire("fRCnG");

var $h9xhf = parcelRequire("h9xhf");

var $2Vha5 = parcelRequire("2Vha5");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $abHGL = parcelRequire("abHGL");

var $13zmE = parcelRequire("13zmE");

var $48hlF = parcelRequire("48hlF");

var $bqWPH = parcelRequire("bqWPH");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $k8Adr = parcelRequire("k8Adr");

var $16GaT = parcelRequire("16GaT");

var $jGG4c = parcelRequire("jGG4c");

var $aIHAn = parcelRequire("aIHAn");

var $f4NVl = parcelRequire("f4NVl");

var $fpVhP = parcelRequire("fpVhP");
const $d3bdbfb505ebf025$var$styles = {
    container: "_85i5utpp _1q51utpp _y4ti1ejb _bozg1ejb"
};
const $d3bdbfb505ebf025$export$a3fef1c3a02c6fed = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, helpCenterName: helpCenterName, migrationReview: migrationReview, publishedHelpCenterUrl: publishedHelpCenterUrl })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $abHGL.useFlags)();
    const [isFinishLaterModalOpen, setIsFinishLaterModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [isPublishModalOpen, setIsPublishModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const hasTrackedView = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    const publishAttemptRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef({
        attempt: null,
        retry: false
    });
    const [commitGoLiveHelpCenter, isPublishing] = (0, $3BZyK.useMutation)((0, $5y1SF.default));
    const fireAnalyticsEvent = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId })=>{
        (0, $16GaT.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), actionSubjectId);
    }, [
        createAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (hasTrackedView.current) return;
        hasTrackedView.current = true;
        fireAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'migrationReviewActionBar',
            actionSubjectId: 'migrationReviewActionBar'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const showPublishErrorFlag = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        const title = formatMessage((0, $fpVhP.default).publishError);
        showFlag({
            title: title,
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
                label: title,
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            })
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const completePublishAttempt = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((attempt, action, outcome)=>{
        const state = publishAttemptRef.current;
        if (state.attempt !== attempt || attempt.terminal) return false;
        attempt.terminal = true;
        state.retry = action === 'failed';
        (0, $16GaT.fireOperationalAnalytics)(createAnalyticsEvent({}), `helpCenterMigrationReviewAction ${action}`, 'goLiveHelpCenter', {
            duration: Date.now() - attempt.startedAt,
            retry: attempt.retry,
            ...outcome
        });
        return true;
    }, [
        createAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>()=>{
            var _attempt$disposable;
            const attempt = publishAttemptRef.current.attempt;
            if (!attempt || attempt.terminal) return;
            completePublishAttempt(attempt, 'cancelled', {
                outcome: 'unmounted'
            });
            (_attempt$disposable = attempt.disposable) === null || _attempt$disposable === void 0 || _attempt$disposable.dispose();
        }, [
        completePublishAttempt
    ]);
    const handlePublishModalOpen = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewPublishButton'
        });
        setIsPublishModalOpen(true);
    }, [
        fireAnalyticsEvent
    ]);
    const handlePublishModalCancel = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        setIsPublishModalOpen(false);
    }, []);
    const handleFinishLaterModalOpen = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: 'migrationReviewFinishLaterMenuItem'
        });
        fireAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'modal',
            actionSubjectId: 'migrationReviewFinishLaterModal'
        });
        setIsFinishLaterModalOpen(true);
    }, [
        fireAnalyticsEvent
    ]);
    const handleFinishLaterModalCancel = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewFinishLaterModalCancel'
        });
        setIsFinishLaterModalOpen(false);
    }, [
        fireAnalyticsEvent
    ]);
    const handlePublish = ()=>{
        const publishAttemptState = publishAttemptRef.current;
        if (isPublishing || publishAttemptState.attempt && !publishAttemptState.attempt.terminal) return;
        const attempt = {
            disposable: null,
            startedAt: Date.now(),
            terminal: false,
            retry: publishAttemptState.retry
        };
        publishAttemptState.attempt = attempt;
        setIsPublishModalOpen(false);
        attempt.disposable = commitGoLiveHelpCenter({
            variables: {
                cloudId: cloudId,
                input: {
                    helpCenterAri: helpCenterAri
                }
            },
            onCompleted: (response)=>{
                var _response$helpCenter;
                const goLiveHelpCenter = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.goLiveHelpCenter;
                if (goLiveHelpCenter !== null && goLiveHelpCenter !== void 0 && goLiveHelpCenter.success) {
                    if (completePublishAttempt(attempt, 'succeeded', {
                        outcome: 'published'
                    })) window.location.href = (0, $aIHAn.getMigrationPublishedUrl)(publishedHelpCenterUrl);
                    return;
                }
                if (completePublishAttempt(attempt, 'failed', {
                    errorCode: goLiveHelpCenter ? 'PUBLISH_REJECTED' : 'EMPTY_RESPONSE'
                })) showPublishErrorFlag();
            },
            onError: ()=>{
                if (completePublishAttempt(attempt, 'failed', {
                    errorCode: 'RELAY_REQUEST_FAILED'
                })) showPublishErrorFlag();
            }
        });
    };
    const handleMoreActionsClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewMoreActionsButton'
        });
    }, [
        fireAnalyticsEvent
    ]);
    const handleEditDraft = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: 'migrationReviewEditDraftMenuItem'
        });
        migrationReview.onEditDraft();
    }, [
        fireAnalyticsEvent,
        migrationReview
    ]);
    const handleFinishLaterConfirm = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'migrationReviewFinishLaterModalConfirm'
        });
        migrationReview.onFinishLater();
        setIsFinishLaterModalOpen(false);
    }, [
        fireAnalyticsEvent,
        migrationReview
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        backgroundColor: "color.background.accent.blue.subtlest",
        xcss: $d3bdbfb505ebf025$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        rowSpace: "space.150",
        shouldWrap: true,
        space: "space.200",
        spread: "space-between",
        testId: "migration-review-action-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bqWPH))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), null, formatMessage((0, $fpVhP.default).banner))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        rowSpace: "space.100",
        shouldWrap: true,
        space: "space.100",
        testId: "migration-review-action-bar-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $h9xhf.SplitButton), {
        appearance: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        isDisabled: isPublishing,
        isLoading: isPublishing,
        onClick: handlePublishModalOpen
    }, formatMessage((0, $fpVhP.default).publish)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
                ref: triggerRef,
                ...triggerProps,
                onClickCapture: handleMoreActionsClick,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($13zmE))),
                label: formatMessage((0, $fpVhP.default).morePublishActions)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
        onClick: handleEditDraft
    }, formatMessage((0, $fpVhP.default).editDraft)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
        onClick: handleFinishLaterModalOpen
    }, formatMessage((0, $fpVhP.default).finishLater)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $f4NVl.PublishMigrationModal), {
        isOpen: isPublishModalOpen,
        onCancel: handlePublishModalCancel,
        onConfirm: handlePublish
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jGG4c.FinishMigrationReviewModal), {
        helpCenterName: helpCenterName,
        isOpen: isFinishLaterModalOpen,
        onCancel: handleFinishLaterModalCancel,
        onConfirm: handleFinishLaterConfirm
    }));
};

});
parcelRegister("5y1SF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0e053cb6ce17732$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04deeef1f2658d38f33a4fd67e657cf2>>
 * @relayHash e23d2e5c7dfca11e2dc4cccb39b1eb51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f866042051dd312587032db4be12d468485a124b37cb6fa7b64164638a68737
const $e0e053cb6ce17732$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterHubGoLiveHelpCenterPayload",
                    "kind": "LinkedField",
                    "name": "goLiveHelpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3f866042051dd312587032db4be12d468485a124b37cb6fa7b64164638a68737",
            "metadata": {},
            "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e0e053cb6ce17732$var$node.hash = "dc20ceea767638a38fd0257323a7c400";
var $e0e053cb6ce17732$export$2e2bcd8739ae039 = $e0e053cb6ce17732$var$node;

});

parcelRegister("h9xhf", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $ad7d801c59d8bb70$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $kjPnV = parcelRequire("kjPnV");

var $kH5Gv = parcelRequire("kH5Gv");

var $9P9F7 = parcelRequire("9P9F7");

var $h11B3 = parcelRequire("h11B3");
const $ad7d801c59d8bb70$var$buttonStyles = {
    primaryButton: "_1g6vidpf _k9paidpf _7k5eidpf _10t6idpf",
    secondaryButton: "_jw1uidpf _1uoaidpf _zb8tidpf _3yvgidpf"
};
const $ad7d801c59d8bb70$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $h11B3.getActions)(children);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kH5Gv.SplitButtonContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $9P9F7.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    className: (0, $2R2iS.default)([
                        $ad7d801c59d8bb70$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kjPnV.Divider), {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    className: (0, $2R2iS.default)([
                        $ad7d801c59d8bb70$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("kjPnV", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $d4bf4020050e62dd$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $d4bf4020050e62dd$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkbk0g _80om13gf",
    dividerOffset: "_195g1n1a"
};
const $d4bf4020050e62dd$var$dividerAppearanceStyles = {
    default: "_bfhk1l7x",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkazsu _tzy419lr"
};
const $d4bf4020050e62dd$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
const $d4bf4020050e62dd$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $d4bf4020050e62dd$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            $d4bf4020050e62dd$var$dividerStyles.baseDivider,
            isDefaultDivider && $d4bf4020050e62dd$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $d4bf4020050e62dd$var$dividerHeightStyles[spacing],
            isDisabled && $d4bf4020050e62dd$var$dividerStyles.dividerDisabled,
            !isDisabled && $d4bf4020050e62dd$var$dividerAppearanceStyles[appearance],
            $d4bf4020050e62dd$var$dividerStyles.dividerOffset
        ])
    });
};

});

parcelRegister("kH5Gv", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContainer", () => $26b14f8fe11b936e$export$994ba1b4c598f7);
/* split-button-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $26b14f8fe11b936e$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    defaultAppearanceContainer: "_2rko1qi0 _12ji1l7x _1cwg1n1a _1qu2nqa1 _12y3t94y",
    defaultAppearanceDisabledContainer: "_12jibk0g"
};
const $26b14f8fe11b936e$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            appearance === 'default' && $26b14f8fe11b936e$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && isDisabled && $26b14f8fe11b936e$var$buttonStyles.defaultAppearanceDisabledContainer,
            $26b14f8fe11b936e$var$buttonStyles.splitButton
        ]),
        children: children
    });

});

parcelRegister("h11B3", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $1966f2999692943d$export$fe3955935f564b31);

var $fc4bM = parcelRequire("fc4bM");

var $3jCFs = parcelRequire("3jCFs");
const $1966f2999692943d$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $fc4bM.Children).toArray(children);
    typeof $3jCFs;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("jGG4c", function(module, exports) {
$parcel$export(module.exports, "FinishMigrationReviewModal", () => $94b48117d61d1d8d$export$a44a4b429312c901);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $5dzEI = parcelRequire("5dzEI");

var $dkw9k = parcelRequire("dkw9k");

var $2u7SO = parcelRequire("2u7SO");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $dVxDa = parcelRequire("dVxDa");

var $7fZmj = parcelRequire("7fZmj");
const $94b48117d61d1d8d$export$a44a4b429312c901 = ({ helpCenterName: helpCenterName, isOpen: isOpen, isPending: isPending = false, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), null, formatMessage((0, $7fZmj.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, formatMessage(helpCenterName ? (0, $7fZmj.default).body : (0, $7fZmj.default).bodyWithoutHelpCenterName, {
        helpCenterName: helpCenterName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVxDa.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        role: "status"
    }, isPending ? formatMessage((0, $7fZmj.default).saving) : ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $7fZmj.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "warning",
        isDisabled: isPending,
        isLoading: isPending,
        onClick: onConfirm
    }, formatMessage((0, $7fZmj.default).confirm))));
};

});
parcelRegister("7fZmj", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5f9e86e6cc10a0e$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $e5f9e86e6cc10a0e$var$messages = (0, $8p5Cv.defineMessages)({
    cancel: {
        id: 'company-hub-common.finish-migration-review-modal.cancel',
        defaultMessage: 'Cancel',
        description: 'Button that closes the finish migration review later confirmation modal.'
    },
    confirm: {
        id: 'company-hub-common.finish-migration-review-modal.confirm',
        defaultMessage: 'Confirm',
        description: 'Button that confirms saving the migration review update as a draft.'
    },
    saving: {
        id: 'company-hub-common.finish-migration-review-modal.saving',
        defaultMessage: 'Saving changes',
        description: 'Screen reader status announced while migration review changes are being saved before finishing later.'
    },
    body: {
        id: 'company-hub-common.finish-migration-review-modal.body',
        defaultMessage: "You\u2019re about to leave the {helpCenterName} update. We\u2019ll save your changes as a draft, but you\u2019ll need to review them later for the update to go live.",
        description: 'Explains that leaving this help center update saves it as a draft. The helpCenterName placeholder is replaced by the help center name.'
    },
    bodyWithoutHelpCenterName: {
        id: 'company-hub-common.finish-migration-review-modal.bodyWithoutHelpCenterName',
        defaultMessage: "You\u2019re about to leave the help center update. We\u2019ll save your changes as a draft, but you\u2019ll need to review them later for the update to go live.",
        description: 'Explains that leaving the unnamed default help center update saves it as a draft and requires a later review before it goes live.'
    },
    title: {
        id: 'company-hub-common.finish-migration-review-modal.title',
        defaultMessage: 'Finish review later',
        description: 'Title of the modal that confirms finishing a migration review later.'
    }
});
var $e5f9e86e6cc10a0e$export$2e2bcd8739ae039 = $e5f9e86e6cc10a0e$var$messages;

});


parcelRegister("f4NVl", function(module, exports) {
$parcel$export(module.exports, "PublishMigrationModal", () => $42aec36338e5b96e$export$da79270de2e2071d);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $5dzEI = parcelRequire("5dzEI");

var $dkw9k = parcelRequire("dkw9k");

var $2u7SO = parcelRequire("2u7SO");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $k8Adr = parcelRequire("k8Adr");

var $91nVt = parcelRequire("91nVt");
const $42aec36338e5b96e$export$da79270de2e2071d = ({ isOpen: isOpen, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const hasConfirmedRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (isOpen) hasConfirmedRef.current = false;
    }, [
        isOpen
    ]);
    const handleConfirm = ()=>{
        if (hasConfirmedRef.current) return;
        hasConfirmedRef.current = true;
        onConfirm();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), null, formatMessage((0, $91nVt.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        as: "p"
    }, formatMessage((0, $91nVt.default).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $91nVt.default).keepEditing)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: "primary",
        onClick: handleConfirm
    }, formatMessage((0, $91nVt.default).publish)))));
};

});
parcelRegister("91nVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $03ccbfd02336dc9f$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $03ccbfd02336dc9f$var$messages = (0, $8p5Cv.defineMessages)({
    title: {
        id: 'company-hub-common.publish-migration-modal.title',
        defaultMessage: 'Replace current help center?',
        description: 'Title of the confirmation dialog before publishing a migrated help center.'
    },
    body: {
        id: 'company-hub-common.publish-migration-modal.body',
        defaultMessage: 'Publishing will permanently replace your existing help center with the new version. This action is final and cannot be undone.',
        description: 'Warning that publishing a migrated help center permanently replaces the existing one.'
    },
    keepEditing: {
        id: 'company-hub-common.publish-migration-modal.keep-editing',
        defaultMessage: 'Keep editing',
        description: 'Dismiss the confirmation dialog without publishing the migrated help center.'
    },
    publish: {
        id: 'company-hub-common.publish-migration-modal.publish',
        defaultMessage: 'Publish',
        description: 'Confirm publishing the migrated help center and replacing the existing one.'
    }
});
var $03ccbfd02336dc9f$export$2e2bcd8739ae039 = $03ccbfd02336dc9f$var$messages;

});


parcelRegister("fpVhP", function(module, exports) {
$parcel$export(module.exports, "default", () => $246af34f5443ccde$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $246af34f5443ccde$var$messages = (0, $8p5Cv.defineMessages)({
    banner: {
        id: 'hub-app-shell.migration-review-action-bar.banner',
        defaultMessage: 'Previewing your help center draft',
        description: 'Banner text that explains an administrator is previewing a help center draft.'
    },
    editDraft: {
        id: 'hub-app-shell.migration-review-action-bar.editDraft',
        defaultMessage: 'Edit draft',
        description: 'Menu item that returns the administrator to editing the help center draft.'
    },
    finishLater: {
        id: 'hub-app-shell.migration-review-action-bar.finishLater',
        defaultMessage: 'Finish later',
        description: 'Menu item that asks the administrator to confirm finishing the help center review later.'
    },
    morePublishActions: {
        id: 'hub-app-shell.migration-review-action-bar.morePublishActions',
        defaultMessage: 'More publish actions',
        description: 'Accessible label for the overflow button next to the Publish action.'
    },
    publish: {
        id: 'hub-app-shell.migration-review-action-bar.publish',
        defaultMessage: 'Publish',
        description: 'Primary button that starts publishing the help center draft.'
    },
    publishError: {
        id: 'hub-app-shell.migration-review-action-bar.publishError.ai-non-final',
        defaultMessage: 'Unable to publish your help center. Try again.',
        description: 'Error flag shown when publishing the migrated help center fails and the administrator can retry.'
    }
});
var $246af34f5443ccde$export$2e2bcd8739ae039 = $246af34f5443ccde$var$messages;

});


parcelRegister("lXmFz", function(module, exports) {
$parcel$export(module.exports, "Navbar", () => $3a5f2ccd79d00c95$export$42cfbb80f7861e77);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $hi8gb = parcelRequire("hi8gb");
var $8whFx = parcelRequire("8whFx");

var $itdHE = parcelRequire("itdHE");

var $cWkQ8 = parcelRequire("cWkQ8");

var $5dzEI = parcelRequire("5dzEI");

var $fRCnG = parcelRequire("fRCnG");

var $4Cnkn = parcelRequire("4Cnkn");

var $gV8E5 = parcelRequire("gV8E5");

var $dPjnu = parcelRequire("dPjnu");

var $eM7mn = parcelRequire("eM7mn");

var $kNom1 = parcelRequire("kNom1");

var $dVK9d = parcelRequire("dVK9d");

var $iXBtU = parcelRequire("iXBtU");

var $dRkX9 = parcelRequire("dRkX9");

var $4EPUx = parcelRequire("4EPUx");

var $dBtOK = parcelRequire("dBtOK");

var $26fPW = parcelRequire("26fPW");

var $9YEIZ = parcelRequire("9YEIZ");

var $c48ao = parcelRequire("c48ao");

var $las2k = parcelRequire("las2k");

var $cWpLK = parcelRequire("cWpLK");

var $dsn5W = parcelRequire("dsn5W");

var $bSHq3 = parcelRequire("bSHq3");

var $aQNcS = parcelRequire("aQNcS");

var $1WsIe = parcelRequire("1WsIe");

var $2XoPX = parcelRequire("2XoPX");

var $eoElV = parcelRequire("eoElV");

var $gxNgz = parcelRequire("gxNgz");

const $3a5f2ccd79d00c95$var$MobileMenuOverlay = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("9nSrq")).then((m)=>({
            default: m.MobileMenuOverlay
        })));
const $3a5f2ccd79d00c95$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $3a5f2ccd79d00c95$var$styles = {
    navbarStacking: "_kqswh2mm _1pby1kze",
    navbar: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    navbarUpdated: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    navBarDisabled: "_lcxvglyw",
    logoContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    rightSection: "_zulputpp _1e0c1txw _4cvr1h6o _1o9zidpf"
};
const $3a5f2ccd79d00c95$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false, isViewportSticky: isViewportSticky = false })=>{
    var _hubContext$layout;
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $fc4bM.useState)(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, $fc4bM.useState)(false);
    const [viewportMatches, setViewportMatches] = (0, $fc4bM.useState)();
    const navbarRef = (0, $fc4bM.useRef)(null);
    const isViewportSwitchEnabled = (0, $dRkX9.fg)('switch-hub-nav-bar');
    const handleViewportChange = (0, $fc4bM.useCallback)((event)=>{
        setViewportMatches(event.matches);
        setIsMobileMenuOpen(false);
        setIsAvatarMenuOpen(false);
    }, []);
    const mediaQuery = (0, $9YEIZ.UNSAFE_useMediaQuery)('below.sm', isViewportSwitchEnabled ? handleViewportChange : undefined);
    const isBelowSm = (isViewportSwitchEnabled ? viewportMatches : undefined) ?? (mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches) ?? false;
    const hubContext = (0, $aQNcS.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $c48ao.useNavigationStyle)();
    // Keep a black/white navbar label legible against the live brand colour. The
    // navbar's day-0 background is the darkest brand shade, so a brand change can
    // invert which of black/white is readable. An explicit colour is left alone.
    // See `hub-auto-text-color`.
    const resolveNavTextColor = (0, $las2k.useHubAutoTextColor)('hub-app-shell');
    const navTextColor = resolveNavTextColor({
        backgroundColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.backgroundColor,
        textColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor,
        defaultRef: 'primary.1000'
    });
    const isNavBarUpdated = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.hub_component_upgrade) ?? false;
    const isLoginButtonContrastGateEnabled = (0, $dRkX9.fg)('hubs_nav_login_button_contrast');
    const isLoginButtonContrastEnabled = isNavBarUpdated && isLoginButtonContrastGateEnabled;
    const isCornerRadiusEnabled = (0, $dsn5W.useIsHubCornerRadiusEnabled)();
    // A navbar-specific corner radius is Premium. Suppressing it makes the navbar
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    // Only the gated path is neutralised: the legacy path below has no hub-wide
    // value to fall back to, so it keeps applying the saved radius.
    const isCornerRadiusLocked = (0, $bSHq3.useShouldShowPremiumUpsell)();
    const shouldShowMobileNavLinks = isNavBarUpdated && isBelowSm;
    const dynamicStyle = (0, $fc4bM.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`;
        // Gate ON: always drive from the hub-wide CSS var; pin it locally only when
        // this navbar has an explicit numeric radius, otherwise inherit the global.
        // Gate OFF: legacy fixed px (cornerRadius is always a number here).
        const cornerRadiusStyle = isCornerRadiusEnabled ? {
            borderRadius: navStyle.padding ? `var(${0, $cWpLK.HUB_CORNER_RADIUS_CSS_VAR})` : '0',
            ...!isCornerRadiusLocked && navStyle.padding && typeof navStyle.cornerRadius === 'number' ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                [(0, $cWpLK.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $cWpLK.resolveHubCornerRadius)(navStyle.cornerRadius)}px`
            } : {}
        } : // Gate OFF: legacy fixed px. `cornerRadius` is typed `number | null`; if an
        // unset (null) value ever reaches this branch, fall back to the legacy
        // 8px default (matching the mapper's gate-off coercion) rather than
        // rendering an invalid "nullpx".
        {
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius ?? 8}px` : '0'
        };
        // Fixed ("Fixed to top") navbar layout differs by cohort.
        const fixedNavLayoutStyle = isViewportSticky ? {
            // The shell wraps padded fixed navbars in a sticky, background-covered
            // container in view mode. That wrapper owns the top gap so it cannot
            // scroll away; don't add a second offset or margin to the navbar.
            top: '0px'
        } : {
            // The sticky offset provides the top gap when viewport stickiness is disabled.
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            marginTop: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined
        };
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navTextColor,
            ...cornerRadiusStyle,
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            ...fixedNavLayoutStyle,
            marginLeft: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginRight: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            // The padded sticky wrapper owns the bottom gap in view mode, keeping
            // that spacing outside its background-covered area while scrolling.
            marginBottom: isViewportSticky && navStyle.padding ? 0 : "var(--ds-space-300, 24px)",
            transition: 'margin 0.3s ease, border-radius 0.3s ease, top 0.3s ease'
        };
    }, [
        navStyle,
        navTextColor,
        isCornerRadiusEnabled,
        isCornerRadiusLocked,
        isViewportSticky
    ]);
    const iconColor = isNavBarUpdated ? navTextColor : undefined;
    const { push: push } = (0, $8whFx.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderCustomNavActions: renderCustomNavActions, renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = ((_hubContext$layout = hubContext.layout) === null || _hubContext$layout === void 0 ? void 0 : _hubContext$layout.isAnonymousRoute) || false;
    const homePath = isAnonymousRoute ? '/user/login' : '/';
    const isHomeLinkHrefEnabled = (0, $dRkX9.fg)('csm_support_site_home_link_href');
    const handleHomeClick = (0, $fc4bM.useCallback)((event)=>{
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || 'button' in event && event.button !== 0) return;
        // Keep router navigation relative; the href includes the hub base path.
        event.preventDefault();
        push(homePath);
    }, [
        homePath,
        push
    ]);
    const handleInboxClick = (0, $fc4bM.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $fc4bM.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $fc4bM.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    const handleHamburgerClick = (0, $fc4bM.useCallback)(()=>{
        setIsMobileMenuOpen(true);
    }, []);
    const handleMobileMenuClose = (0, $fc4bM.useCallback)(()=>{
        setIsMobileMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        ref: navbarRef,
        "data-testId": "navbar",
        ...isEditMode ? {
            inert: ''
        } : {},
        xcss: (0, $4Cnkn.cx)($3a5f2ccd79d00c95$var$styles.navbarStacking, isNavBarUpdated ? $3a5f2ccd79d00c95$var$styles.navbarUpdated : $3a5f2ccd79d00c95$var$styles.navbar, isEditMode && $3a5f2ccd79d00c95$var$styles.navBarDisabled),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic navigation styles from context
        style: isNavBarUpdated ? dynamicStyle : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $26fPW.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $3a5f2ccd79d00c95$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hi8gb.default), {
        to: homePath,
        ...isHomeLinkHrefEnabled ? {
            href: `${hubContext.env.relativeBaseUrl.replace(/\/$/, '')}${homePath}`,
            onClick: handleHomeClick
        } : {}
    }, logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
        height: (0, $1WsIe.getHubLogoHeight)(hubType),
        src: logoUrl,
        alt: formatMessage((0, $eoElV.default).hubLogo)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPjnu))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $eoElV.default).hubLogo),
        color: navTextColor
    }))), !isAnonymousRoute && email && isNavBarUpdated && !isBelowSm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxNgz.NavLinks), {
        textColor: navTextColor,
        backgroundColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.backgroundColor
    }), !isAnonymousRoute && email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $3a5f2ccd79d00c95$var$styles.rightSection
    }, !isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", null, renderRightNavActions && renderRightNavActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eM7mn))), {
                ...iconProps,
                color: iconColor
            }),
        label: "User requests",
        onClick: handleInboxClick
    })), shouldShowMobileNavLinks ? isMobileMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $eoElV.default).closeMenu),
        onClick: handleMobileMenuClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kNom1))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $eoElV.default).openMenu),
        onClick: handleHamburgerClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, renderCustomNavActions && renderCustomNavActions(iconColor), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $itdHE.Profile), {
                ...triggerProps,
                tooltip: "Profile and settings",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWkQ8.default), {
                    appearance: "circle",
                    size: "medium",
                    src: avatarSrc
                }),
                onClick: handleProfileClick
            }),
        shouldRenderToParent: true,
        placement: "bottom-end",
        isOpen: isAvatarMenuOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2XoPX.AvatarMenu), null),
        onClose: handleAvatarMenuClose
    }))), !isAnonymousRoute && !email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hi8gb.default), {
        to: `/user/login`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic navigation text color from context
        style: isLoginButtonContrastEnabled ? {
            color: navTextColor
        } : undefined
    }, formatMessage((0, $eoElV.default).login)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iXBtU.default), {
        appear: true
    }, isMobileMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVK9d.default), {
        enteringAnimationXcss: $3a5f2ccd79d00c95$var$motionStyles.slideEntering,
        exitingAnimationXcss: $3a5f2ccd79d00c95$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3a5f2ccd79d00c95$var$MobileMenuOverlay, {
        onClose: handleMobileMenuClose,
        navbarRef: navbarRef
    })))));
};

});
parcelRegister("dPjnu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebf482a6988f6298a86299ac42fdfe98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a10f11d35a593aed$var$_react = $a10f11d35a593aed$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a10f11d35a593aed$var$_iconNew = $a10f11d35a593aed$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a10f11d35a593aed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/home
 * Usage guidance:
 * Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a10f11d35a593aed$var$HomeIcon = (props)=>/*#__PURE__*/ $a10f11d35a593aed$var$_react.default.createElement($a10f11d35a593aed$var$_iconNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$a10f11d35a593aed$var$HomeIcon.displayName = 'HomeIcon';
var $a10f11d35a593aed$var$_default = module.exports.default = $a10f11d35a593aed$var$HomeIcon;

});

parcelRegister("kNom1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::113cd4523810e6c9fe05d0e52a1ca1f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f23b467f241a1db4$var$_react = $f23b467f241a1db4$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $f23b467f241a1db4$var$_iconNew = $f23b467f241a1db4$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $f23b467f241a1db4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/menu
 * Usage guidance:
 * Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f23b467f241a1db4$var$MenuIcon = (props)=>/*#__PURE__*/ $f23b467f241a1db4$var$_react.default.createElement($f23b467f241a1db4$var$_iconNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$f23b467f241a1db4$var$MenuIcon.displayName = 'MenuIcon';
var $f23b467f241a1db4$var$_default = module.exports.default = $f23b467f241a1db4$var$MenuIcon;

});

parcelRegister("las2k", function(module, exports) {
$parcel$export(module.exports, "useHubAutoTextColor", () => $d45ce56174a1724a$export$fe15218ae47525c4);

var $fc4bM = parcelRequire("fc4bM");

var $iU70g = parcelRequire("iU70g");

var $kKMOS = parcelRequire("kKMOS");

var $5X0bl = parcelRequire("5X0bl");
const $d45ce56174a1724a$export$fe15218ae47525c4 = (packageName)=>{
    const theming = (0, $iU70g.useHubTheming)();
    const isAutoTextColorEnabled = (0, $5X0bl.useIsHubAutoTextColorEnabled)();
    const isEnabled = Boolean(isAutoTextColorEnabled && (theming === null || theming === void 0 ? void 0 : theming.isAdvancedThemingEnabled) && theming.palette);
    const palette = theming === null || theming === void 0 ? void 0 : theming.palette;
    const primaryColor = theming === null || theming === void 0 ? void 0 : theming.primaryColor;
    const isBrandPaletteLocked = theming === null || theming === void 0 ? void 0 : theming.isBrandPaletteLocked;
    return (0, $fc4bM.useCallback)(({ backgroundColor: backgroundColor, textColor: textColor, defaultRef: defaultRef })=>{
        if (!isEnabled || !palette || !primaryColor) return textColor;
        return (0, $kKMOS.resolveHubAutoTextColor)({
            backgroundColor: backgroundColor,
            textColor: textColor,
            defaultRef: defaultRef,
            palette: palette,
            primaryColor: primaryColor,
            isBrandPaletteLocked: isBrandPaletteLocked,
            packageName: packageName
        });
    }, [
        isEnabled,
        palette,
        primaryColor,
        isBrandPaletteLocked,
        packageName
    ]);
};

});
parcelRegister("kKMOS", function(module, exports) {
$parcel$export(module.exports, "resolveHubAutoTextColor", () => $749ea052b08997b5$export$adb108b39d52b18e);

var $4hpbQ = parcelRequire("4hpbQ");

var $7PzaH = parcelRequire("7PzaH");
const $749ea052b08997b5$export$adb108b39d52b18e = ({ backgroundColor: backgroundColor, textColor: textColor, defaultRef: defaultRef, palette: palette, primaryColor: primaryColor, isBrandPaletteLocked: isBrandPaletteLocked = false, packageName: packageName })=>{
    // An unstored background means the element is painting its default, and the
    // default differs by tier: Free/Standard renders `var(--hub-primary-color)`
    // (the brand colour) while Premium renders the element's palette shade. Using
    // the shade for a locked tenant would measure text against a light tint while
    // the element actually paints the full brand colour — inverting the result for
    // any dark brand. Mirrors `getHubDefaultParameters`'s locked branch.
    if (!backgroundColor) return (0, $7PzaH.resolveAutoTextColor)({
        textColor: textColor,
        backgroundHex: isBrandPaletteLocked ? primaryColor : palette[defaultRef],
        packageName: packageName
    });
    const backgroundHex = (0, $4hpbQ.resolveAdfColorForPicker)(backgroundColor, palette, defaultRef, primaryColor, primaryColor);
    return (0, $7PzaH.resolveAutoTextColor)({
        textColor: textColor,
        backgroundHex: backgroundHex,
        packageName: packageName
    });
};

});
parcelRegister("4hpbQ", function(module, exports) {
$parcel$export(module.exports, "resolveAdfColor", () => $ee0290da7a47b70b$export$e3e100f3579bc61);
$parcel$export(module.exports, "resolveAdfColorForPicker", () => $ee0290da7a47b70b$export$9fcb237afadfd602);
/**
 * Pure runtime resolver for per-element ADF color attributes.
 *
 * **Renderer path (`resolveAdfColor`)** — returns a CSS string the renderer
 * can drop straight into an inline `style`:
 *
 *   • A `var(--hub-color-primary-200)` reference for palette-tracked values
 *     and the day-0 default — the browser cascade resolves these against the
 *     wrapper div emitted by `<HubThemingProvider>`, so brand-color edits
 *     repaint without any React render or JS palette lookup.
 *   • A literal hex (`#FF8B00`) for custom-hex overrides — frozen, won't
 *     track future brand-color edits.
 *
 * **Picker path (`resolveAdfColorForPicker`)** — returns a hex literal so AK
 * `<ColorPicker>` can match against its `knownColors` and highlight the right
 * swatch. The picker can't reverse-look up `var(--hub-...)` strings.
 *
 * Input grammar (both paths):
 *
 *   1. null / undefined                       → day-0 default
 *   2. { custom: hex }                        → custom literal (frozen)
 *   3. `var(--hub-color-primary-200)` string  → palette-tracked (primary form)
 *   4. `"primary.200"` string                 → legacy alias → palette-tracked
 *                                               (kept so ADFs written before
 *                                               the var-ref switch keep working)
 *   5. legacy `var(--hub-primary-color, ...)` → day-0 default (pre-v2 ADF)
 *   6. plain string (raw hex / anything else) → as-is (forward-compat)
 *
 * Pure, synchronous, no side effects → SSR-safe.
 */ 
var $4Q8Rn = parcelRequire("4Q8Rn");
const $ee0290da7a47b70b$var$PALETTE_REF_PATTERN = /^(primary|accent)\.(100|200|300|400|500|600|700|800|900|1000)$/;
// Matches the canonical `var(--hub-color-{family}-{shade})` form with an
// optional `, <fallback>` segment (a hex snapshot that lets the value resolve
// even outside the wrapper — see `toAdfColor`).
const $ee0290da7a47b70b$var$HUB_COLOR_VAR_PATTERN = /^var\(--hub-color-(primary|accent)-(100|200|300|400|500|600|700|800|900|1000)(?:,\s*[^)]+)?\)$/;
const $ee0290da7a47b70b$var$LEGACY_HUB_VAR_PATTERN = /^var\(--hub-primary-/;
// `--hub-primary-color` carries the brand colour itself, whereas
// `--hub-primary-text-color` / `--hub-primary-link-color` carry values *derived*
// from it. Premium-locked picks persist the former (see `toAdfColor`), so the
// picker has to resolve it to the live brand colour rather than to the
// readable-text fallback its callers supply for the derived vars.
const $ee0290da7a47b70b$var$HUB_PRIMARY_COLOR_VAR_PATTERN = /^var\(--hub-primary-color\s*[,)]/;
const $ee0290da7a47b70b$var$isPaletteRef = (value)=>$ee0290da7a47b70b$var$PALETTE_REF_PATTERN.test(value);
const $ee0290da7a47b70b$var$isHubColorVarRef = (value)=>$ee0290da7a47b70b$var$HUB_COLOR_VAR_PATTERN.test(value);
const $ee0290da7a47b70b$var$isLegacyHubVarRef = (value)=>$ee0290da7a47b70b$var$LEGACY_HUB_VAR_PATTERN.test(value);
const $ee0290da7a47b70b$var$isHubPrimaryColorVarRef = (value)=>$ee0290da7a47b70b$var$HUB_PRIMARY_COLOR_VAR_PATTERN.test(value);
const $ee0290da7a47b70b$var$cssVarFor = (ref)=>`var(${(0, $4Q8Rn.HUB_COLOR_CSS_VARS)[ref]})`;
/**
 * Extracts the `PaletteRef` carried by a `var(--hub-color-{family}-{shade})`
 * reference string, e.g. `var(--hub-color-primary-200)` → `'primary.200'`.
 * Returns `null` if the string is not a recognised hub-color var ref.
 *
 * Used by the picker path to reverse-look up a swatch hex from a stored var
 * reference.
 */ const $ee0290da7a47b70b$var$paletteRefFromVar = (value)=>{
    const match = value.match($ee0290da7a47b70b$var$HUB_COLOR_VAR_PATTERN);
    if (!match) return null;
    return `${match[1]}.${match[2]}`;
};
const $ee0290da7a47b70b$export$e3e100f3579bc61 = (value, defaultRef)=>{
    if (value == null) return $ee0290da7a47b70b$var$cssVarFor(defaultRef);
    if (typeof value === 'object') return value.custom;
    if ($ee0290da7a47b70b$var$isHubColorVarRef(value)) // Primary form — already a `var(--hub-color-...)` ref. Pass through.
    return value;
    if ($ee0290da7a47b70b$var$isPaletteRef(value)) // Legacy ADFs written before the var-ref switch persisted bare
    // PaletteRef strings like `"primary.200"`. Map forward.
    return $ee0290da7a47b70b$var$cssVarFor(value);
    if ($ee0290da7a47b70b$var$isLegacyHubVarRef(value)) // Pre-v2 ADF pointing at the legacy `--hub-primary-color` /
    // `--hub-primary-text-color` / `--hub-primary-link-color` chain.
    // `HubThemingProvider` keeps these vars defined on the wrapper with
    // the same values `setHubBrandingStyle` used to write to `<html>`, so
    // we forward the legacy ref verbatim — the browser cascade resolves it
    // to the admin's exact pre-v2 color. Critically we do NOT rewrite to a
    // palette shade (e.g. `primary.200`); the admin's input hex is not at
    // a fixed ramp position so any rewrite would visually drift colors for
    // already-customised hubs.
    return value;
    // Forward-compat: raw hex literals or any other string passed through.
    return value;
};
const $ee0290da7a47b70b$export$9fcb237afadfd602 = (value, palette, defaultRef, legacyFallback, brandPrimaryColor)=>{
    if (value == null) return palette[defaultRef];
    if (typeof value === 'object') return value.custom;
    if ($ee0290da7a47b70b$var$isHubColorVarRef(value)) {
        const ref = $ee0290da7a47b70b$var$paletteRefFromVar(value);
        return ref ? palette[ref] : palette[defaultRef];
    }
    if ($ee0290da7a47b70b$var$isPaletteRef(value)) return palette[value];
    if ($ee0290da7a47b70b$var$isHubPrimaryColorVarRef(value)) // `--hub-primary-color` resolves at runtime to the admin's exact brand
    // hex on the wrapper, so the picker must show that same colour to stay
    // in sync with the canvas. Text-ish callers supply a readable
    // black/white as `legacyFallback`, which is wrong here — prefer the
    // explicit brand colour, then `legacyFallback` (background pickers pass
    // the brand colour there already), then the element default.
    return brandPrimaryColor ?? legacyFallback ?? palette[defaultRef];
    if ($ee0290da7a47b70b$var$isLegacyHubVarRef(value)) // Pre-v2 ADF pointing at the derived `--hub-primary-text-color` /
    // `--hub-primary-link-color` chain. Returning the caller's
    // `legacyFallback` lets the picker match it against its swatch grid and
    // highlight the right circle, keeping the picker UI in sync with the
    // rendered colour. Falls back to the element default when not passed.
    return legacyFallback ?? palette[defaultRef];
    return value;
};

});

parcelRegister("7PzaH", function(module, exports) {
$parcel$export(module.exports, "resolveAutoTextColor", () => $d26f1fb848bc40bf$export$8c188c8e25fd5636);

var $aaElU = parcelRequire("aaElU");

var $bRst2 = parcelRequire("bRst2");

var $aZ3CZ = parcelRequire("aZ3CZ");
const $d26f1fb848bc40bf$var$HEX = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const $d26f1fb848bc40bf$export$8c188c8e25fd5636 = ({ textColor: textColor, backgroundHex: backgroundHex, packageName: packageName })=>{
    if (!(0, $aZ3CZ.isAutoManagedTextColor)(textColor)) return textColor;
    // Only derive when the background actually resolved to a colour we can
    // measure. `readableTextColor` swallows a failure and returns `color.text`,
    // so an unresolvable background would silently flip white text to dark — on
    // a dark surface that is worse than leaving the stored value alone. Happens
    // for a value the palette cannot resolve: an unrecognised token with no
    // fallback hex, or a var read during SSR where there is no computed style.
    if (!$d26f1fb848bc40bf$var$HEX.test((0, $aaElU.toHexColor)(backgroundHex).trim())) return textColor;
    return (0, $bRst2.readableTextColor)(backgroundHex, packageName);
};

});
parcelRegister("aZ3CZ", function(module, exports) {
$parcel$export(module.exports, "isAutoManagedTextColor", () => $0319c05a72c19a20$export$999aa00a54e0cddc);

var $aaElU = parcelRequire("aaElU");
/**
 * Whether a stored text colour is one this system may re-derive.
 *
 * The distinction is **seeded default vs admin choice**, and the two are told
 * apart by their *shape*:
 *
 *   • **Auto-managed** — a design-token reference. Every element manifest seeds
 *     `token('color.text')` / `token('color.text.inverse')`, i.e.
 *     `var(--ds-text, …)` / `var(--ds-text-inverse, …)`, and the legacy
 *     `--hub-primary-text-color` var is itself a readable black/white. Nothing
 *     stored counts too — the element is showing a derived default.
 *   • **Explicit** — anything else, including a bare `#FFFFFF` or `#000000`.
 *
 * That split matters because the colour picker emits a **raw hex**: its
 * `knownColors` are lowercased literals (see `createBuiltInColorMap`), so
 * choosing the white swatch stores `#ffffff` while the seeded white is
 * `var(--ds-text-inverse, …)`. Treating a bare hex as auto-managed made an
 * explicitly chosen white unusable — it was immediately re-derived back to dark
 * on a light background, so the pick appeared not to apply at all.
 *
 * Matching is done on the *string*, never through `extractColorCode`, because
 * that resolves vars against `document.documentElement` — where the hub
 * palette does not live (the provider emits it on its own wrapper div), so it
 * silently yields `''` and every comparison collapses to black.
 */ const $0319c05a72c19a20$var$AUTO_MANAGED_TOKENS = new Set([
    '--ds-text',
    '--ds-text-inverse',
    '--hub-primary-text-color'
]);
const $0319c05a72c19a20$export$999aa00a54e0cddc = (value)=>{
    const trimmed = value === null || value === void 0 ? void 0 : value.trim();
    if (!trimmed) // Nothing stored means the element is showing a derived default, which is
    // exactly the case we want to keep deriving.
    return true;
    // `extractToken` returns the custom-property name for a `var(...)` string and
    // the input untouched otherwise, so this covers both token and var forms
    // without touching the DOM.
    return $0319c05a72c19a20$var$AUTO_MANAGED_TOKENS.has((0, $aaElU.extractToken)(trimmed));
};

});



parcelRegister("5X0bl", function(module, exports) {
$parcel$export(module.exports, "useIsHubAutoTextColorEnabled", () => $37f771e0900db0fc$export$41c42fd5c71e0872);

var $fc4bM = parcelRequire("fc4bM");

var $aQNcS = parcelRequire("aQNcS");
const $37f771e0900db0fc$export$41c42fd5c71e0872 = ()=>{
    const ctx = (0, $fc4bM.useContext)((0, $aQNcS.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub).
    return false;
    if (ctx.hubType !== 'HELP_HUB') // Customer Service hubs keep their existing colours untouched.
    return false;
    return true;
};

});


parcelRegister("1WsIe", function(module, exports) {
$parcel$export(module.exports, "getHubLogoHeight", () => $f687fd6f7fb45b0a$export$8eeba3862e4455cf);

var $leSAN = parcelRequire("leSAN");
const $f687fd6f7fb45b0a$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $leSAN.HUB_LOGO_HEIGHT;
    // CSM hubs always use new height
    if (hubType === 'CUSTOMER_SERVICE') return 0, $leSAN.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for other hub types
    return 0, $leSAN.HUB_LOGO_HEIGHT_LEGACY;
};

});

parcelRegister("2XoPX", function(module, exports) {
$parcel$export(module.exports, "AvatarMenu", () => $374c59bcf41e92aa$export$f7f58290278dd286);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $eaozo = parcelRequire("eaozo");

var $bKfoa = parcelRequire("bKfoa");

var $9v7Ro = parcelRequire("9v7Ro");

var $gSOfb = parcelRequire("gSOfb");

var $3rlj9 = parcelRequire("3rlj9");

var $dRkX9 = parcelRequire("dRkX9");

var $jKtUD = parcelRequire("jKtUD");

var $aQNcS = parcelRequire("aQNcS");

var $f3Yjv = parcelRequire("f3Yjv");

var $gqiEa = parcelRequire("gqiEa");
const $374c59bcf41e92aa$var$styles = {
    menu: "_1bsbnpok"
};
const $374c59bcf41e92aa$export$f7f58290278dd286 = ()=>{
    const hubContext = (0, $aQNcS.useHubContext)();
    const [{ match: match }] = (0, $7lAXH.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const shouldUseConsumerAvatarMenu = (0, $dRkX9.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = (0, $dRkX9.fg)('csm_appification_standalone_navigation') ? `${cloudUrl}/jira/customer-service-management/experiences/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}` : `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $374c59bcf41e92aa$var$styles.menu
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $gSOfb.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $3rlj9.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $f3Yjv.AccountDetails), null)), consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ $fc4bM.createElement((0, $3rlj9.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $9v7Ro.default), {
        href: csmEditorUrl,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $gqiEa.default).editSite))), /*#__PURE__*/ $fc4bM.createElement((0, $3rlj9.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bKfoa.default), {
        component: (0, $jKtUD.default),
        to: `/user/profile`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $gqiEa.default).profile)), /*#__PURE__*/ $fc4bM.createElement((0, $eaozo.default), {
        onClick: onLogoutClick
    }, formatMessage((0, $gqiEa.default).logout)))));
};

});
parcelRegister("jKtUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f523af2da5b405e8$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $b2AyF = parcelRequire("b2AyF");
parcelRequire("a3Wd7");
var $hi8gb = parcelRequire("hi8gb");
var $dpoZ0 = parcelRequire("dpoZ0");
const $f523af2da5b405e8$export$d3010bc2e9cc1386 = (to, currentLocation)=>(0, $b2AyF.createLocation)(to, null, undefined, currentLocation);
const $f523af2da5b405e8$var$isModifiedEvent = (event)=>event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
/**
 * React Resource Router does not apply the base URL when `to` is a string. because we do not pass basePath to the router, we instead pass it to the history.
 * Keep the displayed URL base-aware while navigating with the relative router location.
 */ // The server case is intentionally not handled until platform can safely access AJS metadata.
const $f523af2da5b405e8$var$getHref = (history, location)=>history.createHref(location);
const $f523af2da5b405e8$var$BaseUrlRespectedLink = ({ to: to, onClick: onClick, history: history, location: location, target: target, replace: replace, children: children, ...rest })=>{
    const toAsLocation = $f523af2da5b405e8$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $f523af2da5b405e8$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $fc4bM.useCallback)((event)=>{
        try {
            onClick === null || onClick === void 0 || onClick(event);
        } catch (error) {
            event.preventDefault();
            throw error;
        }
        const isPrimaryClick = 'button' in event && event.button === 0;
        const isEnterKey = 'key' in event && event.key === 'Enter';
        if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && (!target || target === '_self') && !$f523af2da5b405e8$var$isModifiedEvent(event)) {
            event.preventDefault();
            const method = replace ? history.replace : history.push;
            method($f523af2da5b405e8$export$d3010bc2e9cc1386(to, location));
        }
    }, [
        history,
        location,
        onClick,
        replace,
        target,
        to
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $hi8gb.default), {
        href: href,
        ...rest,
        target: target,
        onClick: wrappedOnClick
    }, children);
};
const $f523af2da5b405e8$var$BaseUrlRespectedLinkWithRouter = (props)=>/*#__PURE__*/ $fc4bM.createElement((0, $dpoZ0.RouterSubscriber), null, (router)=>{
        const { location: location } = router;
        const { history: history } = router;
        return /*#__PURE__*/ $fc4bM.createElement($f523af2da5b405e8$var$BaseUrlRespectedLink, {
            location: location,
            history: history,
            ...props
        });
    });
var $f523af2da5b405e8$export$2e2bcd8739ae039 = $f523af2da5b405e8$var$BaseUrlRespectedLinkWithRouter;

});

parcelRegister("f3Yjv", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $463e785b140d8b2c$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $cWkQ8 = parcelRequire("cWkQ8");

var $26fPW = parcelRequire("26fPW");

var $i3riz = parcelRequire("i3riz");

var $cJzRi = parcelRequire("cJzRi");

var $aQNcS = parcelRequire("aQNcS");
const $463e785b140d8b2c$var$styles = {
    displayName: "_11c8fhey",
    root: "_ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    emailText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _1e0c1o8l _p12f1lit"
};
const $463e785b140d8b2c$export$66e04d0aacdb3b2 = ()=>{
    const { user: user } = (0, $aQNcS.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $463e785b140d8b2c$var$styles.root
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $26fPW.Flex), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $cWkQ8.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), null, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $463e785b140d8b2c$var$styles.displayName
        ])
    }, displayName), /*#__PURE__*/ $fc4bM.createElement("small", {
        className: (0, $2R2iS.default)([
            $463e785b140d8b2c$var$styles.emailText
        ])
    }, email))));
};

});

parcelRegister("gqiEa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff8657aadab61367$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $ff8657aadab61367$var$_default_1 = (0, $8p5Cv.defineMessages)({
    editSite: {
        id: 'hub-app-shell.avatar-menu.edit-site',
        defaultMessage: 'Edit site',
        description: 'The text is shown as a drop-down menu item in the avatar menu, allowing the site administrator to navigate to the site editing interface.'
    },
    profile: {
        id: 'hub-app-shell.avatar-menu.profile',
        defaultMessage: 'Profile',
        description: 'The text is shown as a drop-down menu item in the avatar menu, allowing the current user to navigate to their profile page.'
    },
    logout: {
        id: 'hub-app-shell.avatar-menu.logout',
        defaultMessage: 'Logout',
        description: 'The text is shown as a drop-down menu item in the avatar menu that, when clicked, signs the current user out of the application.'
    }
});
var $ff8657aadab61367$export$2e2bcd8739ae039 = $ff8657aadab61367$var$_default_1;

});


parcelRegister("eoElV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7dc0c402d02a8ca$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $b7dc0c402d02a8ca$var$_default_1 = (0, $8p5Cv.defineMessages)({
    hubLogo: {
        id: 'company-hub.hub-app-shell.navbar.hub.logo',
        defaultMessage: 'Support home',
        description: 'The accessible label for the Hub logo link in the navigation bar, which navigates to the support home page when clicked.'
    },
    login: {
        id: 'company-hub.hub-app-shell.navbar.hub.log-in',
        defaultMessage: 'Log in',
        description: 'The text is shown on a button in the navigation bar that allows unauthenticated users to sign in to the help center.'
    },
    openMenu: {
        id: 'company-hub.hub-app-shell.navbar.open-menu.non-final',
        defaultMessage: 'Open navigation menu',
        description: 'The accessible label for the hamburger button in the navigation bar that opens the mobile navigation menu.'
    },
    closeMenu: {
        id: 'company-hub.hub-app-shell.navbar.close-menu.non-final',
        defaultMessage: 'Close navigation menu',
        description: 'The accessible label for the close button in the mobile navigation menu overlay that dismisses it.'
    }
});
var $b7dc0c402d02a8ca$export$2e2bcd8739ae039 = $b7dc0c402d02a8ca$var$_default_1;

});

parcelRegister("gxNgz", function(module, exports) {
$parcel$export(module.exports, "NavLinks", () => $d48e6d7d1112760b$export$b615cd9717379c80);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $6O1np = parcelRequire("6O1np");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $kTVlm = parcelRequire("kTVlm");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $d7r8x = parcelRequire("d7r8x");

var $bSHq3 = parcelRequire("bSHq3");

var $aQNcS = parcelRequire("aQNcS");

var $c9klZ = parcelRequire("c9klZ");

var $gNPF6 = parcelRequire("gNPF6");

var $jSmvC = parcelRequire("jSmvC");

var $aMWJd = parcelRequire("aMWJd");

var $36xm8 = parcelRequire("36xm8");

var $fKYEw = parcelRequire("fKYEw");

var $iUkGE = parcelRequire("iUkGE");

var $9n7td = parcelRequire("9n7td");
const $d48e6d7d1112760b$var$styles = {
    countBadge: "_2rkopb1k _4t3igktf _1ul9gktf _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1aqn _syaz15cr _19bv1b66 _u5f31b66",
    siteTreeNavLinks: "_16jlkb7n _1o9zkb7n _1ul9idpf"
};
// Module-level cache so repeated mount/unmount cycles don't re-trigger the
// network request when the data has already been fetched for this hub.
// Only used when hubs_fix_rerendering_bootstrap_page_media is ON.
const $d48e6d7d1112760b$var$requestCountCache = new Map();
const $d48e6d7d1112760b$var$getCacheKey = (cloudUrl, helpCenterAri)=>`${cloudUrl}::${helpCenterAri}`;
const $d48e6d7d1112760b$export$7a00ed33b23e6d4d = ()=>{
    $d48e6d7d1112760b$var$requestCountCache.clear();
};
const $d48e6d7d1112760b$var$NavLinkItems = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    var _data$helpCenter, _helpCenterRef$helpCe;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri, hubEditMode: hubEditMode }, featureFlags: featureFlags } = (0, $aQNcS.useHubContext)();
    const navigationBarQueryVariables = (0, $fKYEw.getNavigationBarQueryVariables)({
        cloudId: cloudId,
        featureFlags: featureFlags,
        helpCenterAri: helpCenterAri,
        hubEditMode: hubEditMode
    });
    const { isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled, isTopicsEnabled: isTopicsEnabled } = navigationBarQueryVariables;
    // Folders and custom pages are Premium-only, so un-entitled tenants get no
    // entry point to them — from the site tree or the legacy More dropdown.
    const isPremiumLocked = (0, $bSHq3.useShouldShowPremiumUpsell)();
    // TODO: Use usePreloadedQuery once hub_preload_navigation_bar_query is cleaned up.
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $6O1np.default), navigationBarQueryVariables);
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterRef = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.__typename) === 'HelpCenter' ? helpCenterById : null;
    const { isPortalsMenuHidden: isPortalsMenuHidden, isTopicsMenuHidden: isTopicsMenuHidden } = (0, $gNPF6.getHiddenNavMenus)(helpCenterRef === null || helpCenterRef === void 0 || (_helpCenterRef$helpCe = helpCenterRef.helpCenterBranding) === null || _helpCenterRef$helpCe === void 0 || (_helpCenterRef$helpCe = _helpCenterRef$helpCe.navigationBar) === null || _helpCenterRef$helpCe === void 0 ? void 0 : _helpCenterRef$helpCe.hiddenMenus);
    const handleHomeClick = (0, $fc4bM.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $fc4bM.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $fc4bM.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        testId: "nav-links",
        space: "space.050",
        xcss: isConfigurableSiteTreeEnabled ? $d48e6d7d1112760b$var$styles.siteTreeNavLinks : undefined,
        alignInline: isConfigurableSiteTreeEnabled ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        appearance: "subtle",
        onClick: handleHomeClick,
        style: {
            color: textColor
        }
    }, formatMessage((0, $jSmvC.default).home)), !isPortalsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $36xm8.PortalDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), isTopicsEnabled && !isTopicsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9n7td.TopicDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        appearance: "subtle",
        onClick: handleRequestsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $jSmvC.default).requests), requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $d48e6d7d1112760b$var$styles.countBadge
    }, requestCount.request))), (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        appearance: "subtle",
        onClick: handleApprovalsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $jSmvC.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $d48e6d7d1112760b$var$styles.countBadge
    }, requestCount.pendingApprovals))), !isPremiumLocked && (isConfigurableSiteTreeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iUkGE.SiteNavigation), {
        queryRef: helpCenterRef,
        textColor: textColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aMWJd.MoreDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    })));
};
const $d48e6d7d1112760b$export$b615cd9717379c80 = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $aQNcS.useHubContext)();
    const [requestCount, setRequestCount] = (0, $fc4bM.useState)(()=>(0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media') ? $d48e6d7d1112760b$var$requestCountCache.get($d48e6d7d1112760b$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null);
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media')) {
            const cacheKey = $d48e6d7d1112760b$var$getCacheKey(cloudUrl, helpCenterAri);
            const cached = $d48e6d7d1112760b$var$requestCountCache.get(cacheKey);
            (0, $c9klZ.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                // Always refresh both the request and approvals counts from the
                // latest API response. The Approvals tab is rendered only when
                // `approvals > 0`, so updating to a fresh value of 0 will
                // correctly remove the tab when there is nothing to show.
                const next = {
                    approvals: data.userRequestsCounts.approvalsCount,
                    pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                    request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                };
                $d48e6d7d1112760b$var$requestCountCache.set(cacheKey, next);
                setRequestCount(next);
            }).catch(()=>{
                if (cached) // Keep showing the cached values on refresh failure.
                return;
                // fallback count to zero if request count API fails on first load
                const fallback = {
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                };
                $d48e6d7d1112760b$var$requestCountCache.set(cacheKey, fallback);
                setRequestCount(fallback);
            });
        } else (0, $c9klZ.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
            setRequestCount({
                approvals: data.userRequestsCounts.approvalsCount,
                pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                pendingApprovals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "nav-links-loader"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d48e6d7d1112760b$var$NavLinkItems, {
        textColor: textColor,
        backgroundColor: backgroundColor,
        requestCount: requestCount
    }));
};

});
parcelRegister("6O1np", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b367a2e68538e9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4bed07e061999ed9f22a55e1b1401214>>
 * @relayHash 9167ad897bae8a64894ef8308ea351f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bd4ffde441f81fd5ca2ec83f6bbb63d9b154db45cf924d5ae6ad4da647ebd7c
const $1b367a2e68538e9c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfigurableSiteTreeEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideNavMenusEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTopicsEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "portalsFilter",
            "variableName": "portalsFilter"
        }
    ], v11 = {
        "condition": "isHideNavMenusEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hiddenMenus"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v14 = [
        v12 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": v13 /*: any*/ 
        }
    ], v15 = {
        "kind": "InlineFragment",
        "selections": v14 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "moreDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "siteNavigation_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "topicPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "TOPIC"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "customPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "CUSTOM"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterSiteTree",
                                                    "kind": "LinkedField",
                                                    "name": "siteTree",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterFolder",
                                                            "kind": "LinkedField",
                                                            "name": "root",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contents",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpCenterFolderName",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "name",
                                                                                            "plural": false,
                                                                                            "selections": v13 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "contents",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "nodes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v15 /*: any*/ ,
                                                                                                        v16 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpCenterFolder"
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7bd4ffde441f81fd5ca2ec83f6bbb63d9b154db45cf924d5ae6ad4da647ebd7c",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1b367a2e68538e9c$var$node.hash = "b335d58b621eacf12959f6864e39f900";
var $1b367a2e68538e9c$export$2e2bcd8739ae039 = $1b367a2e68538e9c$var$node;

});

parcelRegister("c9klZ", function(module, exports) {
$parcel$export(module.exports, "getRequestCount", () => $0c4908a7da907db2$export$9aabeb09177df765);
const $0c4908a7da907db2$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $0c4908a7da907db2$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$0c4908a7da907db2$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};

});

parcelRegister("gNPF6", function(module, exports) {
$parcel$export(module.exports, "isHideNavMenusEnabled", () => $e085e436e43758a6$export$d80475e2e9574bf6);
$parcel$export(module.exports, "getHiddenNavMenus", () => $e085e436e43758a6$export$b56f2ad6d9942cbc);

var $dRkX9 = parcelRequire("dRkX9");
const $e085e436e43758a6$export$d80475e2e9574bf6 = ()=>(0, $dRkX9.fg)('help_hubs_hide_nav_menus');
const $e085e436e43758a6$export$b56f2ad6d9942cbc = (hiddenMenus)=>{
    const hidden = $e085e436e43758a6$export$d80475e2e9574bf6() ? hiddenMenus ?? [] : [];
    return {
        isPortalsMenuHidden: hidden.includes('PORTALS'),
        isTopicsMenuHidden: hidden.includes('TOPICS')
    };
};

});

parcelRegister("jSmvC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c88c5ad87e6398f5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $c88c5ad87e6398f5$var$messages = (0, $8p5Cv.defineMessages)({
    downIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.down-icon',
        defaultMessage: 'Open dropdown',
        description: 'Accessible label for the chevron-down icon button in the company hub navbar that opens a navigation dropdown.'
    },
    home: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.home',
        defaultMessage: 'Home',
        description: 'Text shown as the Home navigation link in the company hub top navbar, taking users to the hub home page.'
    },
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more',
        defaultMessage: 'More',
        description: 'Text shown as the More navigation link in the company hub top navbar, opening a dropdown with additional custom pages.'
    },
    openFolderSubmenu: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.openFolderSubmenu',
        defaultMessage: 'Open folder',
        description: 'Accessible label for the chevron-right icon on a nested folder row in the site navigation More menu.'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals page'
    },
    requests: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.requests',
        defaultMessage: 'Requests',
        description: 'Text shown as the Requests navigation link in the company hub top navbar, taking users to their submitted support requests.'
    },
    approvals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.approvals',
        defaultMessage: 'Approvals',
        description: 'Navigation link label for user approvals'
    }
});
var $c88c5ad87e6398f5$export$2e2bcd8739ae039 = $c88c5ad87e6398f5$var$messages;

});

parcelRegister("aMWJd", function(module, exports) {
$parcel$export(module.exports, "MoreDropdown", () => $6f349fba1b343280$export$6d7fd1d1521d3638);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hYdpl = parcelRequire("hYdpl");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $kTVlm = parcelRequire("kTVlm");

var $2Vha5 = parcelRequire("2Vha5");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $13zmE = parcelRequire("13zmE");

var $f69ft = parcelRequire("f69ft");

var $dS86g = parcelRequire("dS86g");

var $eaozo = parcelRequire("eaozo");

var $3rlj9 = parcelRequire("3rlj9");

var $dVK9d = parcelRequire("dVK9d");

var $iXBtU = parcelRequire("iXBtU");

var $4T8rw = parcelRequire("4T8rw");

var $gK5mb = parcelRequire("gK5mb");

var $cYu4p = parcelRequire("cYu4p");
const $6f349fba1b343280$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $6f349fba1b343280$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $6f349fba1b343280$export$6d7fd1d1521d3638 = ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $fc4bM.useState)(false);
    const data = (0, $3BZyK.useFragment)((0, $hYdpl.default), queryRef);
    const customPages = data === null || data === void 0 ? void 0 : data.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f69ft))), {
            label: formatMessage((0, $cYu4p.default).moreUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            label: formatMessage((0, $cYu4p.default).moreDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.default), {
        weight: "medium"
    }, formatMessage((0, $cYu4p.default).more))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $6f349fba1b343280$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iXBtU.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVK9d.default), {
        enteringAnimationXcss: $6f349fba1b343280$var$motionStyles.slideEntering,
        exitingAnimationXcss: $6f349fba1b343280$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": "more-dropdown-items",
        className: (0, $2R2iS.default)([
            $6f349fba1b343280$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, customPages.map((page)=>{
        var _page$name;
        const pageId = page !== null && page !== void 0 && page.id ? (0, $gK5mb.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page === null || page === void 0 || (_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default);
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                    label: formatMessage((0, $cYu4p.default).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $cYu4p.default).more)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, customPages.map((page)=>{
        var _page$name2;
        const pageId = page !== null && page !== void 0 && page.id ? (0, $gK5mb.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                label: formatMessage((0, $cYu4p.default).pageIconLabel)
            }),
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page === null || page === void 0 || (_page$name2 = page.name) === null || _page$name2 === void 0 ? void 0 : _page$name2.default);
    })));
};

});
parcelRegister("hYdpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $727bd016e4fbe647$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b420321b8f0e6761b0f1e413d38c4e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $727bd016e4fbe647$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$727bd016e4fbe647$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $727bd016e4fbe647$export$2e2bcd8739ae039 = $727bd016e4fbe647$var$node;

});

parcelRegister("cYu4p", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ee01260f144263b$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $9ee01260f144263b$var$messages = (0, $8p5Cv.defineMessages)({
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more',
        defaultMessage: 'More',
        description: 'Navigation link label for the more dropdown showing custom pages'
    },
    moreDownIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-down',
        defaultMessage: 'Open more dropdown',
        description: 'Accessible label for the chevron-down icon button in the company hub navbar that opens the More navigation dropdown listing custom pages.'
    },
    moreUpIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-up',
        defaultMessage: 'Close more dropdown',
        description: 'Accessible label for the chevron-up icon button in the mobile navigation menu that closes the More accordion listing custom pages.'
    },
    pageIconLabel: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label',
        defaultMessage: 'Page icon',
        description: 'Label for the page icon in the more dropdown'
    }
});
var $9ee01260f144263b$export$2e2bcd8739ae039 = $9ee01260f144263b$var$messages;

});


parcelRegister("36xm8", function(module, exports) {
$parcel$export(module.exports, "PortalDropdown", () => $020e6b38964530e9$export$32e0c0d1c2f88773);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5cDKU = parcelRequire("5cDKU");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $kTVlm = parcelRequire("kTVlm");

var $2Vha5 = parcelRequire("2Vha5");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $13zmE = parcelRequire("13zmE");

var $f69ft = parcelRequire("f69ft");

var $dS86g = parcelRequire("dS86g");

var $eaozo = parcelRequire("eaozo");

var $3rlj9 = parcelRequire("3rlj9");

var $dVK9d = parcelRequire("dVK9d");

var $iXBtU = parcelRequire("iXBtU");

var $4T8rw = parcelRequire("4T8rw");

var $2MYZ0 = parcelRequire("2MYZ0");

var $5pygW = parcelRequire("5pygW");

var $fKYEw = parcelRequire("fKYEw");
const $020e6b38964530e9$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $020e6b38964530e9$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $020e6b38964530e9$export$32e0c0d1c2f88773 = ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    var _data$portals;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $fc4bM.useState)(false);
    const [isConfigurableSiteTreeEnabled] = (0, $2MYZ0.useIsHubFeatureEnabled)([
        (0, $2MYZ0.HUB_FEATURES).CONFIGURABLE_SITE_TREE
    ]);
    const data = (0, $3BZyK.useFragment)((0, $5cDKU.default), queryRef);
    const portalPages = data === null || data === void 0 || (_data$portals = data.portals) === null || _data$portals === void 0 ? void 0 : _data$portals.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) {
            var _portalPages$2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
                onClick: ()=>{
                    var _portalPages$;
                    push(`/portal/${(_portalPages$ = portalPages[0]) === null || _portalPages$ === void 0 ? void 0 : _portalPages$.id}`);
                }
            }, (_portalPages$2 = portalPages[0]) === null || _portalPages$2 === void 0 ? void 0 : _portalPages$2.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
            iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f69ft))), {
                label: formatMessage((0, $5pygW.default).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                label: formatMessage((0, $5pygW.default).portalDownIcon)
            }),
            onClick: ()=>setIsExpanded((prev)=>!prev),
            "aria-expanded": isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.default), {
            weight: "medium"
        }, formatMessage((0, $5pygW.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            className: (0, $2R2iS.default)([
                $020e6b38964530e9$var$styles.overflowHidden
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iXBtU.default), {
            appear: true
        }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVK9d.default), {
            enteringAnimationXcss: $020e6b38964530e9$var$motionStyles.slideEntering,
            exitingAnimationXcss: $020e6b38964530e9$var$motionStyles.slideExiting
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            "data-testid": "portal-dropdown-items",
            className: (0, $2R2iS.default)([
                $020e6b38964530e9$var$styles.dropdownItems
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, portalPages === null || portalPages === void 0 ? void 0 : portalPages.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
                key: portal === null || portal === void 0 ? void 0 : portal.id,
                onClick: ()=>{
                    push(`/portal/${portal === null || portal === void 0 ? void 0 : portal.id}`);
                }
            }, portal === null || portal === void 0 ? void 0 : portal.name))))))));
    }
    if (hasSinglePortal) {
        var _portalPages$4;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
            appearance: "subtle",
            onClick: ()=>{
                var _portalPages$3;
                push(`/portal/${(_portalPages$3 = portalPages[0]) === null || _portalPages$3 === void 0 ? void 0 : _portalPages$3.id}`);
            },
            style: {
                color: textColor
            }
        }, (_portalPages$4 = portalPages[0]) === null || _portalPages$4 === void 0 ? void 0 : _portalPages$4.name);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                    label: formatMessage((0, $5pygW.default).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $5pygW.default).portals)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, portalPages === null || portalPages === void 0 ? void 0 : portalPages.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
            key: portal === null || portal === void 0 ? void 0 : portal.id,
            onClick: ()=>{
                push(`/portal/${portal === null || portal === void 0 ? void 0 : portal.id}`);
            },
            elemBefore: isConfigurableSiteTreeEnabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                label: formatMessage((0, $5pygW.default).pageIcon)
            })
        }, portal === null || portal === void 0 ? void 0 : portal.name))));
};

});
parcelRegister("5cDKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $56f79e2535a6bbbd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d7aa09aa29354220a79c91e7d74f6e10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56f79e2535a6bbbd$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "portalsFilter"
        }
    ],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "portalsFilter",
                    "variableName": "portalsFilter"
                }
            ],
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$56f79e2535a6bbbd$var$node.hash = "99e96001b0845815b25025bb6c70250a";
var $56f79e2535a6bbbd$export$2e2bcd8739ae039 = $56f79e2535a6bbbd$var$node;

});

parcelRegister("5pygW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dc1aeb51dc4db21$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $0dc1aeb51dc4db21$var$messages = (0, $8p5Cv.defineMessages)({
    pageIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final',
        defaultMessage: 'Page icon',
        description: 'The accessible label for the page icon displayed next to portal navigation items in the portals drop-down in the navbar.'
    },
    portalDownIcon: {
        defaultMessage: 'Open portals dropdown',
        description: 'The accessible label for the chevron-down icon on the button that opens the portals drop-down in the navbar navigation.',
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final'
    },
    portalUpIcon: {
        defaultMessage: 'Close portals dropdown',
        description: 'The accessible label for the chevron-up icon on the button that closes the portals accordion in the mobile navigation menu.',
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-up.non-final'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals dropdown'
    }
});
var $0dc1aeb51dc4db21$export$2e2bcd8739ae039 = $0dc1aeb51dc4db21$var$messages;

});

parcelRegister("fKYEw", function(module, exports) {
$parcel$export(module.exports, "getPortalsFilter", () => $ef097cdaa512a04b$export$563ca09564aae6d5);
$parcel$export(module.exports, "getNavigationBarQueryVariables", () => $ef097cdaa512a04b$export$7465fb1a07d28cb3);

var $dRkX9 = parcelRequire("dRkX9");

var $gNPF6 = parcelRequire("gNPF6");
const $ef097cdaa512a04b$export$563ca09564aae6d5 = ()=>(0, $dRkX9.fg)('hubs_nav_visible_portals_filter') ? {
        typeFilter: [
            'VISIBLE'
        ]
    } : null;
const $ef097cdaa512a04b$export$7465fb1a07d28cb3 = ({ cloudId: cloudId, featureFlags: featureFlags, helpCenterAri: helpCenterAri, hubEditMode: hubEditMode })=>{
    const isDraftModeEnabled = (0, $dRkX9.fg)('help_hubs_draft_mode') && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.help_hubs_draft_mode) === true;
    const isConfigurableSiteTreeEnabled = (0, $dRkX9.fg)('help_hubs_configurable_site_tree') && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.help_hubs_configurable_site_tree) === true;
    return {
        cloudId: cloudId,
        hubAri: helpCenterAri,
        isDraft: Boolean(hubEditMode) && isDraftModeEnabled,
        isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
        isHideNavMenusEnabled: (0, $gNPF6.isHideNavMenusEnabled)(),
        isTopicsEnabled: (0, $dRkX9.fg)('hubs_premium_upsell'),
        portalsFilter: $ef097cdaa512a04b$export$563ca09564aae6d5()
    };
};

});


parcelRegister("iUkGE", function(module, exports) {
$parcel$export(module.exports, "SiteNavigation", () => $81d88f1260a4dbcd$export$42c2afabaf9bb88e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $lduiO = parcelRequire("lduiO");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $4Cnkn = parcelRequire("4Cnkn");

var $2Vha5 = parcelRequire("2Vha5");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $13zmE = parcelRequire("13zmE");

var $1ZqY6 = parcelRequire("1ZqY6");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");

var $gK5mb = parcelRequire("gK5mb");

var $jSmvC = parcelRequire("jSmvC");

var $g4iwu = parcelRequire("g4iwu");
const $81d88f1260a4dbcd$var$EMPTY_SITE_NAVIGATION_ITEMS = [];
const $81d88f1260a4dbcd$var$styles = {
    centerSlot: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf _kqswh2mm",
    navItemLabel: "_1reo15vq _18m915vq _1e0c1ule _p12fuuw1 _1bto1l2s _o5721q9c",
    trigger: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrutpp _1e0c116y _vchhusvi _4cvr1h6o _gy1p1b66 _4t3iviql _bfhksm61 _k48p1wq8 _irr31dpa _1di6fcek",
    triggerSelected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp",
    measurementViewport: "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _1reo15vq _3um015vq _lcxvglyw",
    measurementRow: "_zulp1b66 _1e0c1txw _1bsb1ris"
};
const $81d88f1260a4dbcd$var$NavItemLabel = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $81d88f1260a4dbcd$var$styles.navItemLabel
    }, children);
const $81d88f1260a4dbcd$var$NavTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(function NavTrigger({ children: children, iconLabel: iconLabel = '', isSelected: isSelected = false, showIcon: showIcon = true, textColor: textColor, truncate: truncate = false, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $EawnW.Pressable), {
        ...props,
        ref: ref,
        style: {
            color: isSelected ? undefined : textColor
        },
        xcss: (0, $4Cnkn.cx)($81d88f1260a4dbcd$var$styles.trigger, isSelected && $81d88f1260a4dbcd$var$styles.triggerSelected)
    }, truncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavItemLabel, null, children) : children, showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
        color: "currentColor",
        label: iconLabel
    }));
});
const $81d88f1260a4dbcd$var$getFolderPages = (folder)=>folder.contents.nodes.filter((node)=>node.__typename === 'HelpCenterPage');
const $81d88f1260a4dbcd$var$getPageId = (page)=>{
    try {
        return (0, $gK5mb.HelpPageAri).parse(page.id).pageId;
    } catch  {
        return null;
    }
};
const $81d88f1260a4dbcd$var$PageItem = ({ page: page })=>{
    var _page$name;
    const { push: push } = (0, $8whFx.useRouterActions)();
    const pageId = $81d88f1260a4dbcd$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
        onClick: ()=>push(`/page/${pageId}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavItemLabel, null, ((_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default) ?? ''));
};
const $81d88f1260a4dbcd$var$FolderMenuItems = ({ pages: pages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$PageItem, {
            key: page.id,
            page: page
        })));
const $81d88f1260a4dbcd$var$PromotedFolderMenu = ({ folder: folder, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>{
            var _folder$name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $jSmvC.default).downIcon),
                ref: triggerRef,
                textColor: textColor,
                truncate: true
            }, ((_folder$name = folder.name) === null || _folder$name === void 0 ? void 0 : _folder$name.default) ?? '');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$FolderMenuItems, {
        pages: $81d88f1260a4dbcd$var$getFolderPages(folder)
    }));
};
const $81d88f1260a4dbcd$var$PromotedPage = ({ page: page, textColor: textColor })=>{
    var _page$name2;
    const { push: push } = (0, $8whFx.useRouterActions)();
    const pageId = $81d88f1260a4dbcd$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavTrigger, {
        onClick: ()=>push(`/page/${pageId}`),
        showIcon: false,
        textColor: textColor,
        truncate: true
    }, ((_page$name2 = page.name) === null || _page$name2 === void 0 ? void 0 : _page$name2.default) ?? '');
};
const $81d88f1260a4dbcd$var$OverflowFolderMenu = ({ folder: folder })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        placement: "right-start",
        shouldFlip: true,
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>{
            var _folder$name2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
                ...props,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6))), {
                    label: formatMessage((0, $jSmvC.default).openFolderSubmenu),
                    size: "small"
                }),
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavItemLabel, null, ((_folder$name2 = folder.name) === null || _folder$name2 === void 0 ? void 0 : _folder$name2.default) ?? ''));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$FolderMenuItems, {
        pages: $81d88f1260a4dbcd$var$getFolderPages(folder)
    }));
};
const $81d88f1260a4dbcd$var$OverflowItem = ({ item: item })=>item.__typename === 'HelpCenterPage' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$PageItem, {
        page: item
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$OverflowFolderMenu, {
        folder: item
    });
const $81d88f1260a4dbcd$export$c14b2ae736940562 = ({ overflowItems: overflowItems, promotedItems: promotedItems, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (promotedItems.length === 0 && overflowItems.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, promotedItems.map((item)=>item.__typename === 'HelpCenterFolder' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$PromotedFolderMenu, {
            key: item.id,
            folder: item,
            textColor: textColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$PromotedPage, {
            key: item.id,
            page: item,
            textColor: textColor
        })), overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $jSmvC.default).downIcon),
                ref: triggerRef,
                testId: "site-navigation-more",
                textColor: textColor
            }, formatMessage((0, $jSmvC.default).more))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, overflowItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$OverflowItem, {
            key: item.id,
            item: item
        })))));
};
const $81d88f1260a4dbcd$export$42c2afabaf9bb88e = ({ queryRef: queryRef, textColor: textColor })=>{
    var _data$siteTree;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const slotRef = (0, $fc4bM.useRef)(null);
    const measurementRowRef = (0, $fc4bM.useRef)(null);
    const data = (0, $3BZyK.useFragment)((0, $lduiO.default), queryRef);
    const nodes = data === null || data === void 0 || (_data$siteTree = data.siteTree) === null || _data$siteTree === void 0 || (_data$siteTree = _data$siteTree.root) === null || _data$siteTree === void 0 ? void 0 : _data$siteTree.contents.nodes;
    const items = (0, $fc4bM.useMemo)(()=>(nodes === null || nodes === void 0 ? void 0 : nodes.filter((node)=>node.__typename === 'HelpCenterPage' || node.__typename === 'HelpCenterFolder')) ?? $81d88f1260a4dbcd$var$EMPTY_SITE_NAVIGATION_ITEMS, [
        nodes
    ]);
    const { overflowItems: overflowItems, promotedItems: promotedItems } = (0, $g4iwu.useSiteNavigationOverflow)({
        items: items,
        measurementRowRef: measurementRowRef,
        slotRef: slotRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        ref: slotRef,
        testId: "nav-links-center-slot",
        xcss: $81d88f1260a4dbcd$var$styles.centerSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$export$c14b2ae736940562, {
        overflowItems: overflowItems,
        promotedItems: promotedItems,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        "aria-hidden": "true",
        testId: "site-navigation-measurement-viewport",
        xcss: $81d88f1260a4dbcd$var$styles.measurementViewport
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        "aria-hidden": "true",
        ref: measurementRowRef,
        testId: "site-navigation-measurement-row",
        xcss: $81d88f1260a4dbcd$var$styles.measurementRow
    }, items.map((item)=>{
        var _item$name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            "data-site-navigation-item-id": item.id,
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavTrigger, {
            iconLabel: "",
            tabIndex: -1,
            textColor: textColor,
            truncate: true
        }, (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.default));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        "data-site-navigation-more-item": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($81d88f1260a4dbcd$var$NavTrigger, {
        iconLabel: "",
        tabIndex: -1,
        textColor: textColor
    }, formatMessage((0, $jSmvC.default).more))))));
};

});
parcelRegister("lduiO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f55a8f6edc3288d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a74aadd35812656d4f189fff568b4c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f55a8f6edc3288d1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            v1 /*: any*/ ,
            {
                "concreteType": "HelpCenterPageName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": v2 /*: any*/ 
            }
        ],
        "type": "HelpCenterPage"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "siteNavigation_AtlassianHubAppShell",
        "selections": [
            {
                "concreteType": "HelpCenterSiteTree",
                "kind": "LinkedField",
                "name": "siteTree",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterFolder",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpCenterFolderName",
                                                        "kind": "LinkedField",
                                                        "name": "name",
                                                        "plural": false,
                                                        "selections": v2 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "contents",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v3 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "HelpCenterFolder"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
}();
$f55a8f6edc3288d1$var$node.hash = "758f2701bd08a1f04afa67c01cd4f843";
var $f55a8f6edc3288d1$export$2e2bcd8739ae039 = $f55a8f6edc3288d1$var$node;

});

parcelRegister("g4iwu", function(module, exports) {
$parcel$export(module.exports, "useSiteNavigationOverflow", () => $005c4d7717b1d588$export$afacae323adcfe97);

var $fc4bM = parcelRequire("fc4bM");

var $3ZJj6 = parcelRequire("3ZJj6");

var $gIkJn = parcelRequire("gIkJn");
const $005c4d7717b1d588$var$getLeftoverWidth = (row, slot)=>{
    const rowWidth = row.getBoundingClientRect().width;
    const gapWidth = Number.parseFloat(window.getComputedStyle(row).columnGap) || Number.parseFloat(window.getComputedStyle(row).gap) || 0;
    const children = Array.from(row.children);
    const siblingWidth = children.filter((child)=>child !== slot).reduce((total, child)=>total + child.getBoundingClientRect().width, 0);
    const gapCount = Math.max(children.length - 1, 0);
    return rowWidth - siblingWidth - gapCount * gapWidth;
};
const $005c4d7717b1d588$export$afacae323adcfe97 = ({ items: items, measurementRowRef: measurementRowRef, slotRef: slotRef })=>{
    const [split, setSplit] = (0, $fc4bM.useState)(()=>({
            promotedItems: [],
            overflowItems: [
                ...items
            ]
        }));
    (0, $fc4bM.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        const measurementRow = measurementRowRef.current;
        const row = slot === null || slot === void 0 ? void 0 : slot.parentElement;
        if (!slot || !measurementRow || !row) return;
        let animationFrame = null;
        let hasUsableMeasurement = false;
        const measure = ()=>{
            const itemWidths = Object.fromEntries(Array.from(measurementRow.querySelectorAll('[data-site-navigation-item-id]'), (element)=>[
                    element.getAttribute('data-site-navigation-item-id') ?? '',
                    element.getBoundingClientRect().width
                ]));
            const moreItem = measurementRow.querySelector('[data-site-navigation-more-item]');
            const gapWidth = Number.parseFloat(window.getComputedStyle(measurementRow).columnGap) || 0;
            // Centering hugs the slot, so leftover width is the row minus Home /
            // Portals / Requests (and their gaps), not the slot's own box.
            const availableWidth = $005c4d7717b1d588$var$getLeftoverWidth(row, slot);
            // The navbar row is `display: none` until its responsive breakpoint
            // resolves, so wait until leftover width is usable.
            if (availableWidth <= 0) return;
            hasUsableMeasurement = true;
            const next = (0, $gIkJn.splitSiteNavigation)(items, {
                availableWidth: availableWidth,
                itemWidths: itemWidths,
                gapWidth: gapWidth,
                moreWidth: (moreItem === null || moreItem === void 0 ? void 0 : moreItem.getBoundingClientRect().width) ?? 0
            });
            // Deep-compare so renames (same ids, new names) still update the nav.
            setSplit((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(previous, next) ? previous : next);
        };
        // Coalesce resize callbacks after the first usable synchronous measure.
        const scheduleMeasurement = ()=>{
            if (!hasUsableMeasurement) {
                measure();
                return;
            }
            if (animationFrame === null) animationFrame = requestAnimationFrame(()=>{
                animationFrame = null;
                measure();
            });
        };
        // Measure before the browser paints so the first frame already shows the
        // correct split, rather than briefly rendering everything under More.
        measure();
        const observer = new ResizeObserver(scheduleMeasurement);
        observer.observe(row);
        observer.observe(measurementRow);
        return ()=>{
            if (animationFrame !== null) cancelAnimationFrame(animationFrame);
            observer.disconnect();
        };
    }, [
        items,
        measurementRowRef,
        slotRef
    ]);
    return split;
};

});
parcelRegister("gIkJn", function(module, exports) {
$parcel$export(module.exports, "splitSiteNavigation", () => $1cd3d72c970420e8$export$b77a77786b18d4b);
// Allow 1px of sub-pixel rounding so the split does not flap.
const $1cd3d72c970420e8$var$COMPARISON_TOLERANCE = 1;
const $1cd3d72c970420e8$var$getRowWidth = ({ itemWidths: itemWidths, items: items, gapWidth: gapWidth, moreWidth: moreWidth, showMore: showMore })=>{
    const visibleItemCount = items.length + (showMore ? 1 : 0);
    const visibleGapCount = Math.max(visibleItemCount - 1, 0);
    // An unmeasured item is unfittable, so it stays in More.
    const promotedItemWidth = items.reduce((total, { id: id })=>total + (itemWidths[id] ?? Number.MAX_SAFE_INTEGER), 0);
    return promotedItemWidth + (showMore ? moreWidth : 0) + visibleGapCount * gapWidth;
};
const $1cd3d72c970420e8$export$b77a77786b18d4b = (items, measurements)=>{
    const conservativeSplit = {
        promotedItems: [],
        overflowItems: [
            ...items
        ]
    };
    if (measurements.availableWidth === null || items.length === 0) return conservativeSplit;
    const availableWidth = measurements.availableWidth;
    const fits = (candidateItems, showMore)=>$1cd3d72c970420e8$var$getRowWidth({
            ...measurements,
            items: candidateItems,
            showMore: showMore
        }) <= availableWidth + $1cd3d72c970420e8$var$COMPARISON_TOLERANCE;
    // "More" is optional when every item fits.
    if (fits([
        ...items
    ], false)) return {
        promotedItems: [
            ...items
        ],
        overflowItems: []
    };
    // Reserve "More" and promote root items left to right while they still fit beside it.
    const promotedItems = [];
    for (const item of items){
        const candidateItems = [
            ...promotedItems,
            item
        ];
        if (!fits(candidateItems, true)) break;
        promotedItems.push(item);
    }
    return {
        promotedItems: promotedItems,
        overflowItems: items.slice(promotedItems.length)
    };
};

});



parcelRegister("9n7td", function(module, exports) {
$parcel$export(module.exports, "TopicDropdown", () => $1ff0ea3348fde683$export$ffcc4c72ae603c4e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $gZznE = parcelRequire("gZznE");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $kTVlm = parcelRequire("kTVlm");

var $2Vha5 = parcelRequire("2Vha5");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $13zmE = parcelRequire("13zmE");

var $f69ft = parcelRequire("f69ft");

var $eaozo = parcelRequire("eaozo");

var $3rlj9 = parcelRequire("3rlj9");

var $dVK9d = parcelRequire("dVK9d");

var $iXBtU = parcelRequire("iXBtU");

var $dRkX9 = parcelRequire("dRkX9");

var $k8Adr = parcelRequire("k8Adr");

var $gK5mb = parcelRequire("gK5mb");

var $eCY7y = parcelRequire("eCY7y");
const $1ff0ea3348fde683$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $1ff0ea3348fde683$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq1139 _5sagi9qs _1pgl1lbj"
};
const $1ff0ea3348fde683$var$getPageIdFromAri = (pageAri)=>{
    try {
        return (0, $gK5mb.HelpPageAri).parse(pageAri).pageId;
    } catch  {
        return null;
    }
};
const $1ff0ea3348fde683$export$ffcc4c72ae603c4e = ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $fc4bM.useState)(false);
    const data = (0, $3BZyK.useFragment)((0, $gZznE.default), queryRef);
    const topicPages = data === null || data === void 0 ? void 0 : data.topicPages;
    // Nothing to open onto, so the menu stays out of the navbar entirely.
    if (!(0, $dRkX9.fg)('hubs_premium_upsell') || !topicPages || topicPages.length === 0) return null;
    const openTopic = (pageAri)=>{
        const pageId = pageAri ? $1ff0ea3348fde683$var$getPageIdFromAri(pageAri) : null;
        if (pageId) push(`/page/${pageId}`);
    };
    const topicTestId = (pageAri)=>`nav-topic-page-${(pageAri ? $1ff0ea3348fde683$var$getPageIdFromAri(pageAri) : null) ?? ''}`;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f69ft))), {
            label: formatMessage((0, $eCY7y.default).topicUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            label: formatMessage((0, $eCY7y.default).topicDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        weight: "medium"
    }, formatMessage((0, $eCY7y.default).topics))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $1ff0ea3348fde683$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iXBtU.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVK9d.default), {
        enteringAnimationXcss: $1ff0ea3348fde683$var$motionStyles.slideEntering,
        exitingAnimationXcss: $1ff0ea3348fde683$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": "topic-dropdown-items",
        className: (0, $2R2iS.default)([
            $1ff0ea3348fde683$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), null, topicPages.map((topic)=>{
        var _topic$name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
            key: topic === null || topic === void 0 ? void 0 : topic.id,
            testId: topicTestId(topic === null || topic === void 0 ? void 0 : topic.id),
            onClick: ()=>openTopic(topic === null || topic === void 0 ? void 0 : topic.id)
        }, (topic === null || topic === void 0 || (_topic$name = topic.name) === null || _topic$name === void 0 ? void 0 : _topic$name.default) ?? '');
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                    label: formatMessage((0, $eCY7y.default).topicDownIcon)
                }),
                ref: triggerRef,
                testId: "topic-dropdown-trigger"
            }, formatMessage((0, $eCY7y.default).topics)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, topicPages.map((topic)=>{
        var _topic$name2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
            key: topic === null || topic === void 0 ? void 0 : topic.id,
            testId: topicTestId(topic === null || topic === void 0 ? void 0 : topic.id),
            onClick: ()=>openTopic(topic === null || topic === void 0 ? void 0 : topic.id)
        }, (topic === null || topic === void 0 || (_topic$name2 = topic.name) === null || _topic$name2 === void 0 ? void 0 : _topic$name2.default) ?? '');
    })));
};

});
parcelRegister("gZznE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a549fd42271ddb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0759b364a6890ded896701bb942cb0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a7a549fd42271ddb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topicDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "topicPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "TOPIC"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
        }
    ],
    "type": "HelpCenter"
};
$a7a549fd42271ddb$var$node.hash = "9aa0d54a463ddf69b87af168a98c5079";
var $a7a549fd42271ddb$export$2e2bcd8739ae039 = $a7a549fd42271ddb$var$node;

});

parcelRegister("eCY7y", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac08166c9ad2af24$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $ac08166c9ad2af24$var$messages = (0, $8p5Cv.defineMessages)({
    topics: {
        id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topics',
        defaultMessage: 'Topics',
        description: 'The label on the button that opens the topics drop-down in the help center navigation bar.'
    },
    topicDownIcon: {
        id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topicDownIcon',
        defaultMessage: 'Open topics dropdown',
        description: 'The accessible label for the chevron-down icon on the button that opens the topics drop-down in the navbar navigation.'
    },
    topicUpIcon: {
        id: 'hub-app-shell.navbar.nav-links.topic-dropdown.topicUpIcon',
        defaultMessage: 'Close topics dropdown',
        description: 'The accessible label for the chevron-up icon on the button that closes the topics accordion in the mobile navigation menu.'
    }
});
var $ac08166c9ad2af24$export$2e2bcd8739ae039 = $ac08166c9ad2af24$var$messages;

});



parcelRegister("9nSrq", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("itIBB").then(()=>parcelRequire('bxrXa'));

});



parcelRegister("gOXJv", function(module, exports) {
$parcel$export(module.exports, "hubBootstrapResource", () => $471ddf5607773c20$export$8ce4230d96a2a267);
$parcel$export(module.exports, "hubPageResource", () => $471ddf5607773c20$export$6d8c7b8b2daae34c);
$parcel$export(module.exports, "createNavigationBarResource", () => $471ddf5607773c20$export$370816537ff1c2c5);
$parcel$export(module.exports, "rovoWidgetResource", () => $471ddf5607773c20$export$a727d87e333dcf6e);

var $dRkX9 = parcelRequire("dRkX9");

var $dhrtT = parcelRequire("dhrtT");

var $jqBmw = parcelRequire("jqBmw");

var $6O1np = parcelRequire("6O1np");

var $fKYEw = parcelRequire("fKYEw");

var $eRg5p = parcelRequire("eRg5p");

var $eW4ml = parcelRequire("eW4ml");

var $f6O9g = parcelRequire("f6O9g");

var $56E0t = parcelRequire("56E0t");
const $471ddf5607773c20$var$getPageIdFromRouteParams = (match, routeName)=>{
    if (routeName === (0, $eW4ml.HUB_PORTAL_PAGE_ROUTE_NAME) && (0, $dRkX9.fg)('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.id || '';
};
const $471ddf5607773c20$export$8ce4230d96a2a267 = (0, $56E0t.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment, shouldAddEdgeFallbackToUnidentified: shouldAddEdgeFallbackToUnidentified })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $eW4ml.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $471ddf5607773c20$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $jqBmw.mockHubRouteProps).env.cloudId && (0, $jqBmw.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $jqBmw.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $jqBmw.mockHubRouteProps).env.helpCenterAri;
        }
        const skipPageMediaConfig = (0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media');
        const edgeFallbackHeaders = shouldAddEdgeFallbackToUnidentified ? {
            'X-Edge-Fallback-To-Unidentified': 'true'
        } : undefined;
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                // Always pass `$pageAri` so the query variable is always
                // defined; when `$skipPageMediaConfig` is true the field is
                // skipped by the GraphQL `@skip` directive and the value is
                // not sent to the server.
                pageAri: (0, $56E0t.getPageAri)(helpCenterAriDerived, pageId),
                isDraft: false,
                operationType: 'READ',
                hubEditMode: false,
                skipPageMediaConfig: // When true, the bootstrap fragment skips `pageMediaConfig`
                // (via `@skip`) so the query stays page-agnostic and is not
                // refetched on every page navigation.
                skipPageMediaConfig
            },
            query: (0, $dhrtT.default),
            options: {
                fetchPolicy: 'store-or-network',
                ...edgeFallbackHeaders ? {
                    networkCacheConfig: {
                        metadata: {
                            headers: edgeFallbackHeaders
                        }
                    }
                } : {}
            },
            environment: relayEnvironment
        };
    }
});
const $471ddf5607773c20$export$6d8c7b8b2daae34c = (0, $56E0t.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, isHelpHub: isHelpHub, relayEnvironment: relayEnvironment })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $eW4ml.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $471ddf5607773c20$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $jqBmw.mockHubRouteProps).env.cloudId && (0, $jqBmw.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $jqBmw.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $jqBmw.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                isDraft: false,
                pageAri: (0, $56E0t.getPageAri)(helpCenterAriDerived, pageId),
                operationType: 'READ',
                includeCustomPageParents: Boolean(isHelpHub) && (route === null || route === void 0 ? void 0 : route.name) === (0, $eW4ml.HUB_CUSTOM_PAGE_ROUTE_NAME) && (0, $dRkX9.fg)('enable_hub_breadcrumbs'),
                // Gates the page-scoped `rovoConfig` selection. When false the field is not even
                // requested, so help-kosh never resolves it and no call reaches convo-ai — the
                // existing `rovoWidgetProviderQuery` path stays in sole use. Skipped unless the
                // callout banner could use the answer, which rules out CSM support sites.
                rovoConfigFromKosh: Boolean(isHelpHub) && (0, $dRkX9.fg)('hubs_rovo_config_from_kosh')
            },
            environment: relayEnvironment,
            query: (0, $f6O9g.default),
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $471ddf5607773c20$export$370816537ff1c2c5 = (hubAppProps)=>(0, $56E0t.createRelayResource)({
        getQuery: ({ route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment })=>{
            const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $eW4ml.HUB_PREVIEW_ROUTE_NAME);
            let cloudIdDerived = cloudId;
            let helpCenterAriDerived = helpCenterAri;
            if (isPreview && (0, $jqBmw.mockHubRouteProps).env.cloudId && (0, $jqBmw.mockHubRouteProps).env.helpCenterAri) {
                cloudIdDerived = (0, $jqBmw.mockHubRouteProps).env.cloudId;
                helpCenterAriDerived = (0, $jqBmw.mockHubRouteProps).env.helpCenterAri;
            }
            return {
                variables: (0, $fKYEw.getNavigationBarQueryVariables)({
                    cloudId: cloudIdDerived,
                    featureFlags: hubAppProps.featureFlags,
                    helpCenterAri: helpCenterAriDerived,
                    hubEditMode: hubAppProps.env.hubEditMode
                }),
                query: (0, $6O1np.default),
                options: {
                    fetchPolicy: 'store-or-network'
                },
                environment: relayEnvironment
            };
        }
    });
const $471ddf5607773c20$export$a727d87e333dcf6e = (0, $56E0t.createRelayResource)({
    getQuery: ({ route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $eW4ml.HUB_PREVIEW_ROUTE_NAME);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $jqBmw.mockHubRouteProps).env.cloudId && (0, $jqBmw.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $jqBmw.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $jqBmw.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                cloudIdString: cloudIdDerived,
                containerAri: helpCenterAriDerived
            },
            query: (0, $eRg5p.default),
            options: {
                fetchPolicy: 'store-or-network'
            },
            environment: relayEnvironment
        };
    }
});

});
parcelRegister("eRg5p", function(module, exports) {
$parcel$export(module.exports, "default", () => $83e4472aecf56ef7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820c13c646099ecb5149604afcca7bf3>>
 * @relayHash bb0ffcd3ee07a20a6e7bee99ae361456
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d3b7f55862392a8e7fc340c23e3564932a5de0b48b0561129e09f6c4620e8ce
const $83e4472aecf56ef7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIdString"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCustomAgentsAvailable"
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudIdString"
        },
        {
            "kind": "Variable",
            "name": "containerAri",
            "variableName": "containerAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "AgentStudioAssistant"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rovoWidgetProviderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_widgetByContainerAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "AgentStudioWidget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rovoWidgetProviderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_widgetByContainerAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v6 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ],
                            "type": "AgentStudioWidget"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3d3b7f55862392a8e7fc340c23e3564932a5de0b48b0561129e09f6c4620e8ce",
            "metadata": {},
            "name": "rovoWidgetProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$83e4472aecf56ef7$var$node.hash = "000b7d5b220d2d981324c500d4aeab75";
var $83e4472aecf56ef7$export$2e2bcd8739ae039 = $83e4472aecf56ef7$var$node;

});

parcelRegister("eW4ml", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTE_NAME", () => $01f0d763850505ca$export$b4255e69eefe642e);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_NAME", () => $01f0d763850505ca$export$35619d8059a56474);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_PATH", () => $01f0d763850505ca$export$a1b29fc86625d058);
$parcel$export(module.exports, "HUB_ROUTE_PATH", () => $01f0d763850505ca$export$2735e29305134506);
$parcel$export(module.exports, "HUB_ROUTE_PATH_OPTIONAL_SLASH", () => $01f0d763850505ca$export$3c60e35f1f1173cb);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_NAME", () => $01f0d763850505ca$export$da6ac9e48027aa54);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_PATH", () => $01f0d763850505ca$export$7815c1f7abc1c129);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_NAME", () => $01f0d763850505ca$export$54ede43f7406f46f);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_PATH", () => $01f0d763850505ca$export$c7f93458584dce24);
const $01f0d763850505ca$export$b4255e69eefe642e = 'hub';
const $01f0d763850505ca$export$35619d8059a56474 = 'hub-preview';
const $01f0d763850505ca$export$a1b29fc86625d058 = '/s/:cloudId/hubs/:hubId/preview';
const $01f0d763850505ca$export$2735e29305134506 = '/';
const $01f0d763850505ca$export$3c60e35f1f1173cb = '(/)?';
const $01f0d763850505ca$export$da6ac9e48027aa54 = 'hub-custom-page';
const $01f0d763850505ca$export$7815c1f7abc1c129 = '/page/:id/:title?';
const $01f0d763850505ca$export$54ede43f7406f46f = 'hub-portal-page';
const $01f0d763850505ca$export$c7f93458584dce24 = '/portal/:portalId';

});

parcelRegister("f6O9g", function(module, exports) {
$parcel$export(module.exports, "default", () => $fde9be023548c0a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a8fc8327bbc16797934fde2f0d46ca7>>
 * @relayHash 8a31aae7d3b8c9fde55af400f49e8a24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 51765b6bf2502b4d7d3de6aecb1717c47c8279e2b5b8bd7c763a11acfd774f5d
const $fde9be023548c0a5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCustomPageParents"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "rovoConfigFromKosh"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "pageAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        },
        {
            "kind": "Variable",
            "name": "operationType",
            "variableName": "operationType"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v10 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v11 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v12 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v17 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v18 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterNavigationBar",
                "kind": "LinkedField",
                "name": "navigationBar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "backgroundColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "borderColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "borderType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "cornerRadius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "padding"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "positionType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "textColor"
                    }
                ]
            }
        ]
    }, v19 = [
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "ids.0",
                            "variableName": "pageAri"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "ids"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "condition": "rovoConfigFromKosh",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "HelpCenterPageRovoConfig",
                "kind": "LinkedField",
                "name": "rovoConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isCustomAgentsAvailable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRovoEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "agentId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "widgetContainerAri"
                    }
                ]
            }
        ]
    }, v24 = {
        "concreteType": "HelpCenterPageLayout",
        "kind": "LinkedField",
        "name": "pageLayout",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterLayoutAdf",
                "kind": "LinkedField",
                "name": "layoutAdf",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterLayoutAdfContentConnection",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterLayoutAdfContentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "content"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "pageMediaConfig",
                                "args": v8 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "hubMediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v9 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v10 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v11 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v12 /*: any*/ ,
                                        "action": "THROW"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "args": v19 /*: any*/ ,
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "includeCustomPageParents",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterPageParentReference",
                                                            "kind": "LinkedField",
                                                            "name": "parents",
                                                            "plural": true,
                                                            "selections": [
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "pageMediaConfig",
                            "args": v8 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "args": v19 /*: any*/ ,
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "includeCustomPageParents",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterPageParentReference",
                                                            "kind": "LinkedField",
                                                            "name": "parents",
                                                            "plural": true,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v25 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v20 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "51765b6bf2502b4d7d3de6aecb1717c47c8279e2b5b8bd7c763a11acfd774f5d",
            "metadata": {},
            "name": "hubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fde9be023548c0a5$var$node.hash = "c16441ee88faaf83200addc773fa4c96";
var $fde9be023548c0a5$export$2e2bcd8739ae039 = $fde9be023548c0a5$var$node;

});

parcelRegister("56E0t", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $92ba5a955ea61f4c$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $92ba5a955ea61f4c$export$42ca7b248c7aaee);
$parcel$export(module.exports, "getPageAri", () => $92ba5a955ea61f4c$export$9e8d72642057ad79);

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");
var $VTASg = parcelRequire("VTASg");

var $dRkX9 = parcelRequire("dRkX9");

var $4MoYu = parcelRequire("4MoYu");
var $gK5mb = parcelRequire("gK5mb");

var $jWHud = parcelRequire("jWHud");

var $l9Gq2 = parcelRequire("l9Gq2");

var $8mmdq = parcelRequire("8mmdq");
function $92ba5a955ea61f4c$var$createCacheKey(query, variables) {
    const queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
    return `relay-${queryId}-${query.params.name}-${JSON.stringify(variables ?? {})}`;
}
const $92ba5a955ea61f4c$export$1cc887c62079ea32 = ({ getQuery: getQuery })=>(0, $fOvEc.createResource)({
        type: 'RELAY_RESOURCE_TYPE',
        getKey: (routerContext, customContext)=>{
            const { query: query, variables: variables, cacheKey: cacheKey } = getQuery(routerContext, customContext);
            return cacheKey ?? $92ba5a955ea61f4c$var$createCacheKey(query, variables);
        },
        getData: (routerContext, customContext)=>{
            const { query: query, variables: variables, options: options, environment: environment } = getQuery(routerContext, customContext);
            if ((0, $dRkX9.fg)('hub_error_analytics_trace_id')) (0, $8mmdq.startCapturingTraceIds)(query.params.name);
            const queryReference = (0, $3BZyK.loadQuery)(environment ?? (0, $l9Gq2.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__), query, variables ?? {}, options);
            return Promise.resolve(queryReference);
        }
    });
const $92ba5a955ea61f4c$export$42ca7b248c7aaee = (resource)=>{
    const { data: queryReference } = (0, $VTASg.useResource)(resource);
    return {
        queryReference: queryReference
    };
};
const $92ba5a955ea61f4c$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $4MoYu.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $92ba5a955ea61f4c$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $92ba5a955ea61f4c$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    const resolvedPageId = pageId || helpCenterId;
    if ((0, $jWHud.isPortalPage)(resolvedPageId) && helpCenterId) return (0, $jWHud.buildPortalPageAri)(helpCenterAri, resolvedPageId);
    return (0, $gK5mb.HelpPageAri).create({
        activationId: activationId,
        pageId: resolvedPageId
    }).toString() || '';
};

});


parcelRegister("2VPly", function(module, exports) {
$parcel$export(module.exports, "HubApp", () => $650877283043c6ea$export$44db4a416180c024);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $f6O9g = parcelRequire("f6O9g");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $lSYBN = parcelRequire("lSYBN");

var $4cz1R = parcelRequire("4cz1R");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $d7r8x = parcelRequire("d7r8x");

var $hculA = parcelRequire("hculA");

var $aVQWM = parcelRequire("aVQWM");

var $eef75 = parcelRequire("eef75");

var $gvvtK = parcelRequire("gvvtK");

var $h1TGx = parcelRequire("h1TGx");

var $c48ao = parcelRequire("c48ao");

var $71BJF = parcelRequire("71BJF");

var $jFYW1 = parcelRequire("jFYW1");

var $c9FA9 = parcelRequire("c9FA9");

var $4NHoX = parcelRequire("4NHoX");

var $fok6N = parcelRequire("fok6N");

var $iIxrR = parcelRequire("iIxrR");

var $dsn5W = parcelRequire("dsn5W");

var $aQNcS = parcelRequire("aQNcS");

var $dWJrt = parcelRequire("dWJrt");

var $4u8f8 = parcelRequire("4u8f8");

var $5TrOT = parcelRequire("5TrOT");

var $iAlkM = parcelRequire("iAlkM");

var $gYdLJ = parcelRequire("gYdLJ");

var $h7xso = parcelRequire("h7xso");

var $iVXn1 = parcelRequire("iVXn1");

var $lJX27 = parcelRequire("lJX27");

var $31Sza = parcelRequire("31Sza");

var $58t6F = parcelRequire("58t6F");

var $gOXJv = parcelRequire("gOXJv");

var $56E0t = parcelRequire("56E0t");

var $ajqWj = parcelRequire("ajqWj");

var $lDLEr = parcelRequire("lDLEr");

var $9RQSk = parcelRequire("9RQSk");

var $7VaO1 = parcelRequire("7VaO1");

var $e5bIT = parcelRequire("e5bIT");
const $650877283043c6ea$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc",
    cookiePreferences: "_1e0c1txw _1bah1h6o _1pfhpxbi"
};
const $650877283043c6ea$var$HubInner = ({ appearance: appearance = 'full-page', parsedAdf: parsedAdf, mediaProvider: mediaProvider, providerFactory: providerFactory, extensionHandlers: extensionHandlers, helpCenterData: helpCenterData, productExtensionsDependenciesProvider: productExtensionsDependenciesProvider })=>{
    var _helpCenterData$pages;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4cz1R.MediaClientProvider), {
        clientConfig: mediaProvider.viewMediaClientConfig,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $71BJF.HubSpacingScope), {
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iVXn1.default), {
                document: parsedAdf,
                appearance: appearance,
                dataProviders: providerFactory,
                product: (0, $dWJrt.helpCenterTypeToProduct)((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || ''),
                additionalExtensionHandlers: extensionHandlers,
                contentId: (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$pages = helpCenterData.pages) === null || _helpCenterData$pages === void 0 || (_helpCenterData$pages = _helpCenterData$pages[0]) === null || _helpCenterData$pages === void 0 ? void 0 : _helpCenterData$pages.id) || '',
                PropsProvider: productExtensionsDependenciesProvider
            })
        })
    });
};
const $650877283043c6ea$var$Hub = ({ queryReference: queryReference, appearance: appearance = 'full-page', showPageNameAsHubDocumentTitle: showPageNameAsHubDocumentTitle = false, productExtensionsDependenciesProvider: productExtensionsDependenciesProvider = (0, $h1TGx.CommonHubExtensionsDependenciesProvider), customPageBreadcrumbPath: customPageBreadcrumbPath, portalBreadcrumbPath: portalBreadcrumbPath, showCustomPageBreadcrumbs: showCustomPageBreadcrumbs = false, showPortalBreadcrumbs: showPortalBreadcrumbs = false })=>{
    var _data$helpCenter, _data$helpCenter2, _helpCenterData$pages2, _helpCenterData$pages3, _pageParents, _helpCenterData$pages4, _helpCenterData$helpC, _branding$colors;
    // When the fix flag is ON, `HubAppShell` is rendered one level up in
    // `HubApp` so it stays mounted across page navigations. When the flag is
    // OFF, `Hub` renders `HubAppShell` itself (original behaviour).
    const hubContext = (0, $aQNcS.useHubContext)();
    if (!hubContext) throw new Error('HubContext not found. HubBootstrap must be used as a parent component.');
    const { user: user, cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = hubContext;
    // When the fix flag is ON, `pageMediaConfig` is fetched here (page-scoped)
    // so the bootstrap query stays page-agnostic and is not refetched on every
    // page navigation. When the flag is OFF, `pageMediaConfig` is skipped here
    // and remains on the bootstrap query as before.
    /* eslint-disable @atlassian/relay/unused-fields */ const data = (0, $3BZyK.usePreloadedQuery)((0, $f6O9g.default), queryReference);
    /* eslint-enable @atlassian/relay/unused-fields */ // When the fix flag is ON, read `pageMediaConfig` from the page-scoped
    // hubQuery result. When OFF, it comes from the bootstrap via `hubContext`.
    const pageMediaConfigFromQuery = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.pageMediaConfig;
    const pageMediaConfigFromContext = hubContext.pageMediaConfig;
    const pageMediaConfig = (0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media') ? pageMediaConfigFromQuery : pageMediaConfigFromContext;
    if (!pageMediaConfig) throw new Error('pageMediaConfig not found');
    const { mediaCollectionName: mediaCollectionName, asapIssuer: asapIssuer, mediaToken: mediaToken, mediaUrl: mediaUrl } = pageMediaConfig;
    const helpCenterData = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById;
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'QueryError') throw new Error(`QueryError in hub query: ${helpCenterData.message}`);
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) !== 'HelpCenter') throw new Error('HelpCenter not found in hub query');
    const helpCenterType = (helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || '';
    const pageName = (_helpCenterData$pages2 = helpCenterData.pages) === null || _helpCenterData$pages2 === void 0 || (_helpCenterData$pages2 = _helpCenterData$pages2[0]) === null || _helpCenterData$pages2 === void 0 || (_helpCenterData$pages2 = _helpCenterData$pages2.name) === null || _helpCenterData$pages2 === void 0 ? void 0 : _helpCenterData$pages2.default;
    const pageParents = (_helpCenterData$pages3 = helpCenterData.pages) === null || _helpCenterData$pages3 === void 0 || (_helpCenterData$pages3 = _helpCenterData$pages3[0]) === null || _helpCenterData$pages3 === void 0 ? void 0 : _helpCenterData$pages3.parents;
    const parentFolderName = pageParents === null || pageParents === void 0 || (_pageParents = pageParents[pageParents.length - 1]) === null || _pageParents === void 0 ? void 0 : _pageParents.name;
    const title = showPageNameAsHubDocumentTitle && pageName ? pageName : '';
    const mediaProvider = (0, $aQNcS.getMediaProvider)(mediaCollectionName, asapIssuer, mediaToken, mediaUrl);
    const emojiProvider = (0, $h7xso.getEmojiProvider)({
        cloudId: queryReference.variables.cloudId,
        // NOTE: id is not yet available in the user object, but will be in the near future
        // as per https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/186871/overview#comment-659373408.
        // userId is optional for getEmojiProvider so just leaving this here for now.
        userId: user.id
    });
    const providerFactory = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        return (0, $lSYBN.default).create({
            mediaProvider: Promise.resolve(mediaProvider),
            emojiProvider: Promise.resolve(emojiProvider)
        });
    }, [
        mediaProvider,
        emojiProvider
    ]);
    const layoutAdf = ((_helpCenterData$pages4 = helpCenterData.pages) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4[0]) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.pageLayout) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.layoutAdf) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.content) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.edges) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.map((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.content;
    })) === null || _helpCenterData$pages4 === void 0 ? void 0 : _helpCenterData$pages4.join('')) || '{}';
    const parsedAdf = JSON.parse(layoutAdf);
    const environment = (0, $lJX27.useRelayEnvironmentProvider)().getEnvironment({});
    // The Rovo widget query is preloaded as a route resource (in parallel with the
    // hub bootstrap/page queries) so the help-hub callout banner's "Ask Rovo" search
    // box doesn't wait on a late, lazily-fired query. The resource is only attached to
    // the route when the `hub_preload_rovo_widget_query` gate is on (see the route
    // factories); when it isn't attached, the router never loads it and this reads
    // `null`. The reference is forwarded to the (help-hub-only) callout banner handler.
    const { queryReference: rovoWidgetProviderQueryReference } = (0, $56E0t.useRelayResource)((0, $gOXJv.rovoWidgetResource));
    // Use product extension handlers hook to get additional handlers for the product
    const extensionHandlers = (0, $58t6F.useProductExtensionHandlers)({
        contentId: queryReference.variables.hubAri,
        PropsProvider: productExtensionsDependenciesProvider,
        product: helpCenterType,
        rovoWidgetQueryReference: rovoWidgetProviderQueryReference
    });
    const aiWidgetProviderQueryReference = (0, $fc4bM.useMemo)(()=>{
        if (helpCenterType !== 'CUSTOMER_SERVICE') return null;
        return (0, $3BZyK.loadQuery)(environment, (0, $iAlkM.default), {
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        });
    }, [
        helpCenterType,
        environment,
        cloudId,
        helpCenterAri
    ]);
    const navigationBar = (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.navigationBar) ?? null;
    const { branding: branding } = (0, $aQNcS.useHubContext)();
    const brandColor = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary;
    const isCornerRadiusEnabled = (0, $dsn5W.useIsHubCornerRadiusEnabled)();
    const isAdvancedThemingEnabled = (0, $iIxrR.useIsAdvancedThemingEnabled)();
    const navStyleOptions = (0, $fc4bM.useMemo)(()=>({
            options: navigationBar ? (0, $jFYW1.mapApiToNavigationOptions)(navigationBar, brandColor, isCornerRadiusEnabled, isAdvancedThemingEnabled) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        brandColor,
        isCornerRadiusEnabled,
        isAdvancedThemingEnabled
    ]);
    // When the fix flag is ON, re-provide `HubContext` with `pageMediaConfig`
    // from the page-scoped query so descendants can read it via
    // `useHubContext()` without a separate hook. When the flag is OFF the
    // bootstrap already set `pageMediaConfig` on the context, so no
    // re-provision is needed.
    const hubContextWithPageMedia = (0, $fc4bM.useMemo)(()=>({
            ...hubContext,
            pageMediaConfig: pageMediaConfig
        }), [
        hubContext,
        pageMediaConfig
    ]);
    // Derived from the page-scoped `rovoConfig` (absent unless `hubs_rovo_config_from_kosh` is on).
    // See `deriveRovoWidgetConfig` for exactly when this is null.
    const koshRovoWidgetConfig = (0, $fc4bM.useMemo)(()=>{
        var _helpCenterData$pages5;
        return (0, $4u8f8.deriveRovoWidgetConfig)((_helpCenterData$pages5 = helpCenterData.pages) === null || _helpCenterData$pages5 === void 0 || (_helpCenterData$pages5 = _helpCenterData$pages5[0]) === null || _helpCenterData$pages5 === void 0 ? void 0 : _helpCenterData$pages5.rovoConfig);
    }, [
        helpCenterData
    ]);
    const inner = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $c48ao.NavigationStyleContext).Provider, {
        value: navStyleOptions,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9RQSk.HubsDocumentTitle), {
            title: title,
            shouldRenderDocumentTitle: showPageNameAsHubDocumentTitle,
            children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
                children: [
                    helpCenterType === 'HELP_HUB' && showCustomPageBreadcrumbs && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7VaO1.HubPageBreadcrumbs), {
                        pageName: pageName,
                        pagePath: customPageBreadcrumbPath,
                        pageType: "custom",
                        parentFolderName: parentFolderName
                    }),
                    helpCenterType === 'HELP_HUB' && showPortalBreadcrumbs && portalBreadcrumbPath && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7VaO1.HubPageBreadcrumbs), {
                        pageName: pageName,
                        pagePath: portalBreadcrumbPath,
                        pageType: "portal"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)($650877283043c6ea$var$HubInner, {
                        appearance: appearance,
                        parsedAdf: parsedAdf,
                        mediaProvider: mediaProvider,
                        providerFactory: providerFactory,
                        extensionHandlers: extensionHandlers,
                        helpCenterData: helpCenterData,
                        productExtensionsDependenciesProvider: productExtensionsDependenciesProvider
                    }),
                    (helpCenterType === 'HELP_HUB' || helpCenterType === 'CUSTOMER_SERVICE') && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                        xcss: $650877283043c6ea$var$styles.cookiePreferences,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lDLEr.CookiePreferencesButton), {})
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
                        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                            name: "ai-corner-agent-renderer-loader"
                        }),
                        children: aiWidgetProviderQueryReference && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1VpRA.ErrorBoundary), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5TrOT.AiWidgetProvider), {
                                queryReference: aiWidgetProviderQueryReference,
                                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ajqWj.AiCornerAgentRenderer), {})
                            })
                        })
                    })
                ]
            })
        })
    });
    // When the fix flag is ON, wrap with a HubContext.Provider that merges
    // in the page-scoped `pageMediaConfig`. When OFF, restore the original
    // behaviour: render `HubAppShell` here (wrapping `inner`) and use the
    // bootstrap context which already has `pageMediaConfig`.
    const content = (0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $aQNcS.HubContext).Provider, {
        value: hubContextWithPageMedia,
        children: inner
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gYdLJ.HubAppShell), {
        children: inner
    });
    // Provide the help-kosh-sourced config here so the callout banner reads it via
    // `useOptionalRovoWidgetConfig()` with no second AGG round trip. The banner skips its own
    // query-backed provider when this one is already in the tree, so this path takes precedence
    // and the query-backed one remains the fallback.
    return koshRovoWidgetConfig ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $31Sza.RovoWidgetConfigProvider), {
        rovoWidgetConfig: koshRovoWidgetConfig,
        children: content
    }) : content;
};
const $650877283043c6ea$export$44db4a416180c024 = (props)=>{
    const { appearance: appearance = 'full-page' } = props;
    const { queryReference: hubPageQueryReference } = (0, $56E0t.useRelayResource)((0, $gOXJv.hubPageResource));
    const { queryReference: hubBootstrapQueryReference } = (0, $56E0t.useRelayResource)((0, $gOXJv.hubBootstrapResource));
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (!hubPageQueryReference || !hubBootstrapQueryReference) return null;
    const cloudId = hubBootstrapQueryReference.variables.cloudId;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fok6N.HubErrorBoundary), {
        packageName: "hub",
        id: "hub-page",
        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $c9FA9.GenericErrorPage), {}),
        shouldForceError: true,
        operationNames: [
            'hubBootstrapWrapperQuery'
        ],
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $eef75.ContextWrapper), {
            sourceType: (0, $aVQWM.SCREEN),
            sourceName: "hub",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
                    fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                        name: "hub-loader",
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            className: (0, $2R2iS.default)([
                                $650877283043c6ea$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                                size: "large",
                                label: formatMessage((0, $e5bIT.default).hubLoadingSpinnerLabel)
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4NHoX.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        cloudId: cloudId,
                        ...props,
                        children: (0, $dRkX9.fg)('hubs_fix_rerendering_bootstrap_page_media') ? // Flag ON: HubAppShell lives outside Hub so the app
                        // shell is not remounted on every page navigation.
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gYdLJ.HubAppShell), {
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
                                fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                                    name: "hub-loader",
                                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                        className: (0, $2R2iS.default)([
                                            $650877283043c6ea$var$styles.spinnerContainer
                                        ]),
                                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                                            size: "large",
                                            label: formatMessage((0, $e5bIT.default).hubLoadingSpinnerLabel)
                                        })
                                    })
                                }),
                                children: /*#__PURE__*/ (0, $3LM7S.jsx)($650877283043c6ea$var$Hub, {
                                    appearance: appearance,
                                    customPageBreadcrumbPath: props.customPageBreadcrumbPath,
                                    portalBreadcrumbPath: props.portalBreadcrumbPath,
                                    queryReference: hubPageQueryReference,
                                    showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle,
                                    showCustomPageBreadcrumbs: props.showCustomPageBreadcrumbs,
                                    showPortalBreadcrumbs: props.showPortalBreadcrumbs,
                                    productExtensionsDependenciesProvider: props.productExtensionsDependenciesProvider
                                })
                            })
                        }) : // Flag OFF: original behaviour — Hub renders HubAppShell
                        // internally on every page render.
                        /*#__PURE__*/ (0, $3LM7S.jsx)($650877283043c6ea$var$Hub, {
                            appearance: appearance,
                            customPageBreadcrumbPath: props.customPageBreadcrumbPath,
                            portalBreadcrumbPath: props.portalBreadcrumbPath,
                            queryReference: hubPageQueryReference,
                            showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle,
                            showCustomPageBreadcrumbs: props.showCustomPageBreadcrumbs,
                            showPortalBreadcrumbs: props.showPortalBreadcrumbs,
                            productExtensionsDependenciesProvider: props.productExtensionsDependenciesProvider
                        })
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gvvtK.FireScreenAnalytics), {})
            ]
        })
    });
};

});
parcelRegister("lSYBN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5fdd7e4948bcb54$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b5fdd7e4948bcb54$var$isUndefined(x) {
    return x === undefined;
}
class $b5fdd7e4948bcb54$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $b5fdd7e4948bcb54$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$b5fdd7e4948bcb54$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("h1TGx", function(module, exports) {
$parcel$export(module.exports, "CommonHubExtensionsDependenciesProvider", () => $9632da6647778fab$export$93e984eb90009a17);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $1r3i4 = parcelRequire("1r3i4");

var $iHy52 = parcelRequire("iHy52");

var $fE5cB = parcelRequire("fE5cB");

var $iU70g = parcelRequire("iU70g");

var $aQNcS = parcelRequire("aQNcS");
const $9632da6647778fab$export$93e984eb90009a17 = ({ children: children })=>{
    var _branding$colors;
    const { cloudId: cloudId, cloudUrl: cloudUrl, pageMediaConfig: pageMediaConfig, hubMediaConfig: hubMediaConfig, env: env, branding: branding, user: user, hubType: hubType } = (0, $aQNcS.useHubContext)();
    const { hoistedProjectKey: hoistedProjectKey } = env;
    // Advanced theming v2: read derived theming literals from HubThemingContext.
    // The provider is mounted at the HubAppShell level so every consumer reaches
    // the same memoised palette / defaults / swatch map — and the values are
    // SSR-safe hex literals (no --hub-* CSS vars).
    // useHubTheming returns undefined outside the provider, but this provider is
    // only mounted by help-center inside HubBootstrap → provider is in tree.
    // NOTE: must run BEFORE the pageMediaConfig guard below — Rules of Hooks
    // require the same number of hook calls on every render.
    const { defaultParameters: defaultParameters, brandBackgroundColorMap: brandBackgroundColorMap } = (0, $iU70g.useHubTheming)();
    // When the fix flag is ON, `pageMediaConfig` is provided by the `Hub`
    // component (via `hubQuery`) via a nested `HubContext.Provider`. When the
    // flag is OFF it comes from the bootstrap. Either way it must be present
    // by the time this provider renders; if it is missing the consumer is
    // mounted in an unsupported position.
    if (!pageMediaConfig) throw new Error("CommonHubExtensionsDependenciesProvider requires `pageMediaConfig` on the HubContext. Ensure this provider is rendered as a descendant of the `Hub` component.");
    const authProvider = (0, $fc4bM.useCallback)(()=>Promise.resolve({
            asapIssuer: pageMediaConfig.asapIssuer,
            token: pageMediaConfig.mediaToken,
            baseUrl: pageMediaConfig.mediaUrl
        }), [
        pageMediaConfig
    ]);
    const createEditorMediaProvider = (0, $fc4bM.useCallback)(async ({ onUploadRejection: onUploadRejection })=>{
        const mediaProvider = {
            uploadParams: {
                collection: pageMediaConfig.mediaCollectionName,
                onUploadRejection: onUploadRejection
            },
            viewMediaClientConfig: {
                authProvider: authProvider
            },
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        };
        return mediaProvider;
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const useMediaConfig = (0, $fc4bM.useCallback)(({ imageSrc: imageSrc })=>{
        return {
            authProvider: authProvider,
            collection: pageMediaConfig.mediaCollectionName,
            fileId: imageSrc
        };
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const contextValue = {
        smartCardProviderComponent: undefined,
        isTargetAudience: ()=>false,
        useSegmentationTargetGroups: ()=>({}),
        isCompanyHub: true,
        // need to pass this true to enable company hub specific extensions
        // Help-Hub-only signal. Derived here from the hub context, which is
        // help-center-only (this provider is never mounted outside a HubContext).
        // The Confluence company hub uses ConfluenceDependenciesProvider and so
        // leaves this false; CSM help centers have hubType !== 'HELP_HUB'.
        isHelpHub: hubType === 'HELP_HUB',
        enableLinkInputInMediaPicker: true,
        cloudId: cloudId,
        cloudUrl: cloudUrl,
        hoistedProjectKey: hoistedProjectKey,
        helpCenterAri: env.helpCenterAri,
        isAdminHubAIEnabled: false,
        linkPickerConfig: {
            linkPickerPlugins: []
        },
        userId: (0, $dRkX9.fg)('fix_user_context_in_hubs') ? user.id : '',
        customMediaConfig: hubMediaConfig,
        createEditorMediaProvider: createEditorMediaProvider,
        useMediaConfig: useMediaConfig,
        branding: {
            ...branding,
            defaultParameters: defaultParameters,
            hideDefaultColorPalette: !!(branding !== null && branding !== void 0 && (_branding$colors = branding.colors) !== null && _branding$colors !== void 0 && _branding$colors.primary),
            brandBackgroundColorMap: brandBackgroundColorMap
        },
        hideExtensionBorders: true,
        showConfigPreambleSupportLink: false,
        enableTargeting: false,
        enableUnifiedSearchFeatures: (0, $dRkX9.fg)('enable_dynamic_cards_for_gday'),
        enableSmartCardsFields: false,
        experienceStopComponent: (0, $fE5cB.HubErrorLogger),
        submitError: (0, $1r3i4.logException)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iHy52.ProductDependenciesContext).Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("1r3i4", function(module, exports) {
$parcel$export(module.exports, "logException", () => $a1ed32d8259fb8ac$export$f86b2a1a2ce291b3);

var $leSAN = parcelRequire("leSAN");
let $a1ed32d8259fb8ac$var$Sentry;
const $a1ed32d8259fb8ac$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $a1ed32d8259fb8ac$export$668f31ea3127f48f = window.BUILD_KEY;

const $a1ed32d8259fb8ac$export$f553e8b08ef59d31 = async ()=>{
    if (!$a1ed32d8259fb8ac$var$Sentry) $a1ed32d8259fb8ac$var$Sentry = Promise.resolve((parcelRequire("3DbpT"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $leSAN.SENTRY_DSN),
            attachStacktrace: true,
            release: $a1ed32d8259fb8ac$export$668f31ea3127f48f || (0, $leSAN.UNKNOWN_TAG),
            environment: $a1ed32d8259fb8ac$export$57570b1603cf6adb()
        });
        return SentryModule;
    }).catch(()=>{});
    return $a1ed32d8259fb8ac$var$Sentry;
};
const $a1ed32d8259fb8ac$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await $a1ed32d8259fb8ac$export$f553e8b08ef59d31();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('product', 'hub');
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

});
parcelRegister("3DbpT", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $2a4ddebafc04d6f4$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2bnbp")));

var $5lpFe = parcelRequire("5lpFe");

var $mPMBq = parcelRequire("mPMBq");

var $2aLTg = parcelRequire("2aLTg");
parcelRequire("5Ve5I");
var $2mAO5 = parcelRequire("2mAO5");

var $7F02p = parcelRequire("7F02p");

var $2bnbp = parcelRequire("2bnbp");
var $2a4ddebafc04d6f4$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $2a4ddebafc04d6f4$var$_window = (0, $2mAO5.getGlobalObject)();
if ($2a4ddebafc04d6f4$var$_window.Sentry && $2a4ddebafc04d6f4$var$_window.Sentry.Integrations) $2a4ddebafc04d6f4$var$windowIntegrations = $2a4ddebafc04d6f4$var$_window.Sentry.Integrations;
var $2a4ddebafc04d6f4$export$99d02219d259eb94 = (0, $5lpFe.__assign)((0, $5lpFe.__assign)((0, $5lpFe.__assign)({}, $2a4ddebafc04d6f4$var$windowIntegrations), (0, $2aLTg)), $7F02p);
$parcel$exportWildcard(module.exports, $mPMBq);

});
parcelRegister("mPMBq", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("8lCud")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("freWv")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("2tNS7")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("2tNS7")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("2tNS7")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("2tNS7")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("2tNS7")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("REREP")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("REREP")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("REREP")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("REREP")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("freWv")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("6q5Ba")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("2tNS7")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("8ntGr")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("2tNS7")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("2tNS7")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("2tNS7")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("2tNS7")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("2tNS7")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("2tNS7")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("2tNS7")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("keI9Q")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1xbOS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("fcznZ")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("fcznZ")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("6SODg")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("6SODg")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("6SODg")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("6SODg")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("6SODg")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("6SODg")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("6SODg")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("6SODg")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("6SODg")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("bc5Op")).SDK_NAME);

var $8lCud = parcelRequire("8lCud");

var $2tNS7 = parcelRequire("2tNS7");
var $freWv = parcelRequire("freWv");
var $REREP = parcelRequire("REREP");
var $8ntGr = parcelRequire("8ntGr");
var $6q5Ba = parcelRequire("6q5Ba");

var $keI9Q = parcelRequire("keI9Q");

var $1xbOS = parcelRequire("1xbOS");

var $fcznZ = parcelRequire("fcznZ");

var $6SODg = parcelRequire("6SODg");

var $bc5Op = parcelRequire("bc5Op");

});
parcelRegister("bc5Op", function(module, exports) {
$parcel$export(module.exports, "SDK_NAME", () => $826552d7a464b0a6$export$ca61d37259221480);
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $826552d7a464b0a6$export$ca61d37259221480 = 'sentry.javascript.browser';

});


parcelRegister("7F02p", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("7ATFd")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("5FM25")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("jEFf2")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("inxLT")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("2yS8d")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("flU3k")).Dedupe);

var $7ATFd = parcelRequire("7ATFd");

var $5FM25 = parcelRequire("5FM25");

var $jEFf2 = parcelRequire("jEFf2");

var $inxLT = parcelRequire("inxLT");

var $2yS8d = parcelRequire("2yS8d");

var $flU3k = parcelRequire("flU3k");

});

parcelRegister("2bnbp", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("31QKS")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("GRO5X")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("b1vKk")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("8Qb7E")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("k2phX")).makeNewXHRTransport);

var $31QKS = parcelRequire("31QKS");

var $GRO5X = parcelRequire("GRO5X");

var $b1vKk = parcelRequire("b1vKk");

var $8Qb7E = parcelRequire("8Qb7E");

var $k2phX = parcelRequire("k2phX");

});



parcelRegister("fE5cB", function(module, exports) {
$parcel$export(module.exports, "HubErrorLogger", () => $6d45d073bf8b1d47$export$9ef862d41b8c7d0f);

var $fc4bM = parcelRequire("fc4bM");

var $9PWjZ = parcelRequire("9PWjZ");
const $6d45d073bf8b1d47$export$9ef862d41b8c7d0f = ({ error: error, shouldForceError: shouldForceError })=>{
    const logError = (0, $9PWjZ.useUFOReportError)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        logError({
            name: (error === null || error === void 0 ? void 0 : error.name) || 'unknown',
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) || '',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) || '',
            forcedError: shouldForceError
        });
    }, [
        logError,
        error,
        shouldForceError
    ]);
    return null;
};

});


parcelRegister("71BJF", function(module, exports) {
$parcel$export(module.exports, "HubSpacingScope", () => $193af29c38347527$export$1d8b960adcd035f4);

var $fc4bM = parcelRequire("fc4bM");

var $iU70g = parcelRequire("iU70g");

var $3DOY6 = parcelRequire("3DOY6");

var $KqeQQ = parcelRequire("KqeQQ");
const $193af29c38347527$export$1d8b960adcd035f4 = ({ children: children, enabled: enabled = true })=>{
    const gateEnabled = (0, $3DOY6.useIsHubSpaceDensityEnabled)();
    const theming = (0, $iU70g.useHubTheming)();
    const spaceDensity = theming === null || theming === void 0 ? void 0 : theming.spaceDensity;
    const wrapperStyle = (0, $fc4bM.useMemo)(()=>{
        const density = spaceDensity ?? (0, $KqeQQ.DEFAULT_SPACE_DENSITY);
        return {
            display: 'contents',
            [(0, $KqeQQ.EDITOR_BLOCK_SPACING_VAR)]: (0, $KqeQQ.getBlockSpacingForDensity)(density)
        };
    }, [
        spaceDensity
    ]);
    // No-op unless the feature gate is on, the host enables this surface, and a
    // density has actually been selected/persisted.
    if (!gateEnabled || !enabled || !spaceDensity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-hub-space-density-scope": "",
        style: wrapperStyle
    }, children));
};

});
parcelRegister("3DOY6", function(module, exports) {
$parcel$export(module.exports, "useIsHubSpaceDensityEnabled", () => $d9f4873f0a2186ed$export$1f7957aafeeb725b);
/**
 * Returns `true` when the Hub space density (spacing) customization should be
 * available.
 *
 * Space density is a sub-feature of advanced theming and is available whenever
 * advanced theming is enabled.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted (Confluence
 * Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled` returns false in
 * that case.
 */ 
var $iIxrR = parcelRequire("iIxrR");
const $d9f4873f0a2186ed$export$1f7957aafeeb725b = ()=>(0, $iIxrR.useIsAdvancedThemingEnabled)();

});


parcelRegister("dWJrt", function(module, exports) {
$parcel$export(module.exports, "helpCenterTypeToProduct", () => $408ae053d04bf6a0$export$cf749f9c25e568e8);
const $408ae053d04bf6a0$export$cf749f9c25e568e8 = (helpCenterType)=>{
    switch(helpCenterType){
        case 'CUSTOMER_SERVICE':
            return 'CSM';
        case 'HELP_HUB':
            return 'JSM';
        default:
            return 'CSM';
    }
};

});

parcelRegister("4u8f8", function(module, exports) {
$parcel$export(module.exports, "deriveRovoWidgetConfig", () => $d85bc51111f87ae4$export$35601df0cf654b0a);
/**
 * Shape of the `rovoConfig` field on `HelpCenterPage`, as selected by `hubQuery`.
 *
 * Typed structurally rather than off the generated Relay type so this stays a plain pure function
 * with no codegen dependency. The field is absent entirely when `hubs_rovo_config_from_kosh` is off
 * (`@include(if:)`), hence `undefined` is a valid input.
 */ const $d85bc51111f87ae4$export$35601df0cf654b0a = (rovoConfig)=>{
    if (!(rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isCustomAgentsAvailable) || !rovoConfig.isRovoEnabled || !rovoConfig.agentId) return null;
    return {
        agentId: rovoConfig.agentId,
        ...rovoConfig.widgetContainerAri ? {
            widgetContainerAri: rovoConfig.widgetContainerAri
        } : {}
    };
};

});

parcelRegister("5TrOT", function(module, exports) {
$parcel$export(module.exports, "AiWidgetProvider", () => $683e3ee7ece5bf77$export$963f3fe63ca0f1aa);

var $iAlkM = parcelRequire("iAlkM");

var $fc4bM = parcelRequire("fc4bM");

var $3BZyK = parcelRequire("3BZyK");

var $fok6N = parcelRequire("fok6N");

var $aQNcS = parcelRequire("aQNcS");

var $7S70r = parcelRequire("7S70r");

var $jQmhc = parcelRequire("jQmhc");
/**
 * Provides AI widget config via context when available.
 * On query failure or invalid data, it falls back to rendering children only.
 */ const $683e3ee7ece5bf77$var$AiWidgetProviderInner = ({ queryReference: queryReference, children: children })=>{
    var _data$helpCenter;
    const { cloudId: siteId } = (0, $aQNcS.useHubContext)();
    const data = (0, $3BZyK.usePreloadedQuery)((0, $iAlkM.default), queryReference);
    const primaryColor = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    const widgetConfig = data.csmAi_getSupportWidget;
    const supportWidgetConfig = (0, $fc4bM.useMemo)(()=>{
        if (!widgetConfig || !widgetConfig.id || !widgetConfig.theme || !primaryColor || !siteId) return null;
        return {
            siteId: siteId,
            widgetId: widgetConfig.id,
            widgetTheme: {
                primaryColor: primaryColor,
                radius: (0, $7S70r.handleWidgetRadiusType)(widgetConfig.theme.radius),
                space: (0, $7S70r.handleWidgetSpaceType)(widgetConfig.theme.space),
                chatBubbleVariant: (0, $7S70r.handleChatBubbleVariant)(widgetConfig.theme.chatColor),
                widgetButtonVariant: (0, $7S70r.handleWidgetButtonVariant)(widgetConfig.theme.colorVibeVariant),
                attribution: null
            },
            widgetPosition: (0, $7S70r.handleWidgetPosition)(widgetConfig.position),
            isEnabled: Boolean(widgetConfig.isEnabled)
        };
    }, [
        widgetConfig,
        primaryColor,
        siteId
    ]);
    if (!supportWidgetConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jQmhc.AiWidgetConfigProvider), {
        supportWidgetConfig: supportWidgetConfig
    }, children);
};
const $683e3ee7ece5bf77$export$963f3fe63ca0f1aa = ({ queryReference: queryReference, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fok6N.HubErrorBoundary), {
        packageName: "@atlassian/csm-ai-search-trigger",
        id: "AiWidgetProvider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($683e3ee7ece5bf77$var$AiWidgetProviderInner, {
        queryReference: queryReference
    }, children));
};

});
parcelRegister("iAlkM", function(module, exports) {
$parcel$export(module.exports, "default", () => $39aaaa96b40b297c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2eb8409e14d8125227a3ef3f45225d9>>
 * @relayHash d24b4ad1a97ccd24bce6bb96d6c01dac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c
const $39aaaa96b40b297c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c",
            "metadata": {},
            "name": "aiWidgetProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$39aaaa96b40b297c$var$node.hash = "cc0a8c3c2e0c2ac2a4e32f0440175bfe";
var $39aaaa96b40b297c$export$2e2bcd8739ae039 = $39aaaa96b40b297c$var$node;

});

parcelRegister("7S70r", function(module, exports) {
$parcel$export(module.exports, "handleWidgetRadiusType", () => $9d47231b238e87b2$export$21feeed55533391b);
$parcel$export(module.exports, "handleWidgetSpaceType", () => $9d47231b238e87b2$export$882cd7667f1dc36b);
$parcel$export(module.exports, "handleWidgetPosition", () => $9d47231b238e87b2$export$565c45f827c88f12);
$parcel$export(module.exports, "handleChatBubbleVariant", () => $9d47231b238e87b2$export$8d7135a196764ba5);
$parcel$export(module.exports, "handleWidgetButtonVariant", () => $9d47231b238e87b2$export$1e1d4315fa0edb5);
const $9d47231b238e87b2$export$21feeed55533391b = (radius)=>{
    switch(radius){
        case 'ROUNDED':
            return 'rounded';
        case 'SHARP':
            return 'sharp';
        case 'NORMAL':
        default:
            return 'normal';
    }
};
const $9d47231b238e87b2$export$882cd7667f1dc36b = (space)=>{
    switch(space){
        case 'COSY':
            return 'cosy';
        case 'GENEROUS':
            return 'generous';
        case 'COMFORTABLE':
        default:
            return 'comfortable';
    }
};
const $9d47231b238e87b2$export$565c45f827c88f12 = (position)=>{
    switch(position){
        case 'CENTER':
            return 'CENTER';
        case 'CORNER':
        default:
            return 'CORNER';
    }
};
const $9d47231b238e87b2$export$8d7135a196764ba5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'default';
    }
};
const $9d47231b238e87b2$export$1e1d4315fa0edb5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'dark';
    }
};

});

parcelRegister("jQmhc", function(module, exports) {
$parcel$export(module.exports, "AiWidgetConfigProvider", () => $834e847352537cd5$export$6e44feab0c163a95);
$parcel$export(module.exports, "useOptionalAiWidgetConfig", () => $834e847352537cd5$export$ab391f3a63cacd0);
$parcel$export(module.exports, "useAiWidgetConfig", () => $834e847352537cd5$export$91842e2b4fccaca6);

var $fc4bM = parcelRequire("fc4bM");
const $834e847352537cd5$var$AiWidgetConfigContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $834e847352537cd5$export$6e44feab0c163a95 = ({ supportWidgetConfig: supportWidgetConfig, children: children })=>{
    const [value] = (0, $fc4bM.useState)({
        supportWidgetConfig: supportWidgetConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($834e847352537cd5$var$AiWidgetConfigContext.Provider, {
        value: value
    }, children);
};
const $834e847352537cd5$export$ab391f3a63cacd0 = ()=>{
    return (0, $fc4bM.useContext)($834e847352537cd5$var$AiWidgetConfigContext);
};
const $834e847352537cd5$export$91842e2b4fccaca6 = ()=>{
    const contextValue = (0, $fc4bM.useContext)($834e847352537cd5$var$AiWidgetConfigContext);
    if (!contextValue) throw new Error('useSuppportWidgetConfig must be used within a AiWidgetConfigProvider');
    return contextValue;
};

});


parcelRegister("h7xso", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $3a8cacb2e54bcd80$export$8210f5f78c0bcf27);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $jPgDQ = parcelRequire("jPgDQ");

var $3NFpe = parcelRequire("3NFpe");
const $3a8cacb2e54bcd80$var$BASE_URL = '/gateway/api/emoji';
const $3a8cacb2e54bcd80$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$3a8cacb2e54bcd80$var$BASE_URL}/standard`
        },
        {
            url: `${$3a8cacb2e54bcd80$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$3a8cacb2e54bcd80$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $3a8cacb2e54bcd80$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? '';
    const disableUpload = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload) ?? false;
    const emojiSSRConfigString = extraConfig !== null && extraConfig !== void 0 && extraConfig.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $3a8cacb2e54bcd80$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($jPgDQ)))((extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? undefined;
    const disableUpload = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload;
    const emojiSSRConfig = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.emojiSSRConfig) ?? undefined;
    const emojiConfig = $3a8cacb2e54bcd80$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $3NFpe.default)(emojiConfig);
}, $3a8cacb2e54bcd80$var$resolverOfMemoize);
const $3a8cacb2e54bcd80$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($jPgDQ)))((extraConfig)=>{
    const emojiResource = $3a8cacb2e54bcd80$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $3a8cacb2e54bcd80$var$resolverOfMemoize);

});
parcelRegister("3NFpe", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e2738774783c4bc$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dRkX9 = parcelRequire("dRkX9");

var $6AWhp = parcelRequire("6AWhp");

var $3DToh = parcelRequire("3DToh");

var $fhv13 = parcelRequire("fhv13");

var $iVe7J = parcelRequire("iVe7J");

var $dMfNK = parcelRequire("dMfNK");

var $5av15 = parcelRequire("5av15");

var $j8Z78 = parcelRequire("j8Z78");

var $eriBW = parcelRequire("eriBW");

var $hsPKy = parcelRequire("hsPKy");

var $faqTp = parcelRequire("faqTp");

var $hh8nC = parcelRequire("hh8nC");

var $ko6w5 = parcelRequire("ko6w5");

var $6b28p = parcelRequire("6b28p");

var $jCwn8 = parcelRequire("jCwn8");

var $eC95f = parcelRequire("eC95f");

const $4e2738774783c4bc$var$teamoji26QueryParam = 'useTeamoji26=true';
const $4e2738774783c4bc$var$addTeamoji26QueryParam = (url)=>{
    if (!url.includes('/atlassian') || /[?&]useTeamoji26=/.test(url)) return url;
    const hashIndex = url.indexOf('#');
    const urlWithoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
    const separator = urlWithoutHash.includes('?') ? '&' : '?';
    return `${urlWithoutHash}${separator}${$4e2738774783c4bc$var$teamoji26QueryParam}${hash}`;
};
class $4e2738774783c4bc$export$b5efafc6dd611ec5 extends (0, $3DToh.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        const migrateRemainingEmojiProviders = (0, $dRkX9.fg)('migrate-remaining-emoji-provider-integrations');
        const rewriteEmojiGatewayPath = (url)=>migrateRemainingEmojiProviders ? url.replace('gateway/api/emoji', 'gateway/api/elements/emoji') : url.replace('/gateway/api/emoji', '/gateway/api/elements/emoji');
        const stargateEmojiPathEnabled = (0, $dRkX9.fg)('use-elements-stargate-emoji-path') || migrateRemainingEmojiProviders;
        const singleEmojiApi = config.singleEmojiApi;
        const optimisticImageApi = config.optimisticImageApi;
        const providers = config.providers.map((provider)=>{
            const rewrittenUrl = stargateEmojiPathEnabled ? rewriteEmojiGatewayPath(provider.url) : provider.url;
            return {
                ...provider,
                url: $4e2738774783c4bc$var$addTeamoji26QueryParam(rewrittenUrl)
            };
        });
        this.emojiProviderConfig = {
            ...config,
            providers: providers,
            singleEmojiApi: stargateEmojiPathEnabled && singleEmojiApi ? {
                ...singleEmojiApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(singleEmojiApi.getUrl(emojiId))
            } : singleEmojiApi,
            optimisticImageApi: stargateEmojiPathEnabled && optimisticImageApi ? {
                ...optimisticImageApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(optimisticImageApi.getUrl(emojiId))
            } : optimisticImageApi
        };
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $faqTp.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
   * Get the emoji provider from Emoji Resource
   * @returns Promise<EmojiProvider>
   */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $hsPKy.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $iVe7J.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $5av15.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $iVe7J.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $6b28p.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $iVe7J.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $iVe7J.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $hsPKy.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder) {
        const shortNameLookupOrder = (0, $dRkX9.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined;
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId, shortNameLookupOrder);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $6b28p.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId, shortNameLookupOrder);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId, shortNameLookupOrder);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $fhv13.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $fhv13.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $fhv13.ProviderTypes).ATLASSIAN;
        return (0, $fhv13.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $jCwn8.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $eC95f.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $eriBW.isPromise)(done)) return done.then(()=>{
                    (0, $hsPKy.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $hsPKy.default)('Failed to prime siteEmojiResource');
                });
                else (0, $hsPKy.default)('Already primed siteEmojiResource');
            } else (0, $hsPKy.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $eriBW.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const storedToneString = window.localStorage.getItem((0, $5av15.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
   *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
   */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $j8Z78.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $j8Z78.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $eriBW.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $dMfNK.ufoExperiences)['emoji-searched'].start();
        (0, $dMfNK.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: (query === null || query === void 0 ? void 0 : query.length) || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $dMfNK.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: (options === null || options === void 0 ? void 0 : options.source) || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName, emojiProviderLookupOrder) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName, emojiProviderLookupOrder);
        return this.retryIfLoading(()=>this.findByShortName(shortName, emojiProviderLookupOrder), undefined);
    }
    findByEmojiId(emojiId, emojiProviderLookupOrder) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName, emojiProviderLookupOrder);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName, emojiProviderLookupOrder);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName, emojiProviderLookupOrder);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId, emojiProviderLookupOrder), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
   * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
   * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
   * for the purposes of tracking the frequency of use.
   *
   * @param emoji The full description of the emoji to record usage for.
   */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $ko6w5.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $6AWhp.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $faqTp.default)('localStorage')) try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem((0, $5av15.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $4e2738774783c4bc$export$2e2bcd8739ae039 extends $4e2738774783c4bc$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 30000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $hh8nC.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("6AWhp", function(module, exports) {
$parcel$export(module.exports, "utils", () => $dac7c54403c468dd$export$eab97d15b1788b8d);

var $9MTHn = parcelRequire("9MTHn");

var $37a0L = parcelRequire("37a0L");
const $dac7c54403c468dd$export$eab97d15b1788b8d = $37a0L;
const $dac7c54403c468dd$export$3b4c04cf7dad0e50 = $9MTHn;

});
parcelRegister("9MTHn", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $72f6dcc4b815fe06$export$8b13532c81e8ac89);

var $eUalX = parcelRequire("eUalX");

var $akU0n = parcelRequire("akU0n");

var $gz0GE = parcelRequire("gz0GE");

var $6rr91 = parcelRequire("6rr91");

var $3QiIL = parcelRequire("3QiIL");

var $anwxR = parcelRequire("anwxR");
const $72f6dcc4b815fe06$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $3QiIL.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $6rr91.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gz0GE.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $anwxR.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $akU0n.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $eUalX.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $72f6dcc4b815fe06$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("eUalX", function(module, exports) {
$parcel$export(module.exports, "meros", () => $ad9e538e4b9f8756$export$74e0a034be2368c7);
async function $ad9e538e4b9f8756$export$74e0a034be2368c7(e, t) {
    if (!e.ok || !e.body || e.bodyUsed) return e;
    let n = e.headers.get("content-type");
    if (!n || !~n.indexOf("multipart/")) return e;
    let i = n.indexOf("boundary="), l = "-";
    if (~i) {
        let e = i + 9, t = n.indexOf(";", e);
        l = n.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(e, t, n) {
        let i, l, r, d = new TextDecoder("utf8"), o = e.getReader(), a = !n || !n.multiple, f = t.length, s = "", c = [];
        try {
            let e;
            e: for(; !(e = await o.read()).done;){
                let n = d.decode(e.value, {
                    stream: !0
                });
                i = s.length, s += n;
                let o = n.indexOf(t);
                for(~o ? i += o : i = s.indexOf(t), c = []; ~i;){
                    let e = s.slice(0, i), n = s.slice(i + f);
                    if (l) {
                        let t = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", t), l = !1, d = e.slice(t, i > -1 ? void 0 : i), o = String(e.slice(0, t)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; r = o[--s]; r = r.split(": "), f[r.shift().toLowerCase()] = r.join(": "));
                        if (r = f["content-type"], r && ~r.indexOf("application/json")) try {
                            d = JSON.parse(d), l = !0;
                        } catch (e) {}
                        if (r = {
                            headers: f,
                            body: d,
                            json: l
                        }, a ? yield r : c.push(r), "--" === n.slice(0, 2)) break e;
                    } else t = "\r\n" + t, l = f += 2;
                    s = n, i = s.indexOf(t);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(e.body, `--${l}`, t);
}

});

parcelRegister("gz0GE", function(module, exports) {
$parcel$export(module.exports, "buildHeaders", () => $5595e4bf544007e4$export$7d6ed858a91629c3);
const $5595e4bf544007e4$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $5595e4bf544007e4$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $5595e4bf544007e4$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $5595e4bf544007e4$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});

parcelRegister("6rr91", function(module, exports) {
$parcel$export(module.exports, "buildUrl", () => $a079c9bf9c6c2b82$export$b5cd97dee32de81d);
const $a079c9bf9c6c2b82$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};

});

parcelRegister("3QiIL", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $ae7c53eb0507bdb5$export$160dbda113bfad3b);
const $ae7c53eb0507bdb5$export$160dbda113bfad3b = {};

});

parcelRegister("anwxR", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $37988d3bc7f8f602$export$2ac26f1ab7eda637);
const $37988d3bc7f8f602$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});


parcelRegister("37a0L", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => (parcelRequire("02UHI")).extractTracingHeaders);
$parcel$export(module.exports, "requestService", () => (parcelRequire("fO3v4")).requestService);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { extractTracingHeaders } from '@atlaskit/util-service-support/extractTracingHeaders'` instead.
 */ 
var $02UHI = parcelRequire("02UHI");

var $fO3v4 = parcelRequire("fO3v4");

});
parcelRegister("02UHI", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => $33b001727a356a58$export$4f34edf253146101);
const $33b001727a356a58$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $33b001727a356a58$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $33b001727a356a58$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};

});

parcelRegister("fO3v4", function(module, exports) {
$parcel$export(module.exports, "requestService", () => $b88cbefda228febf$export$97bfde5a702aaeca);

var $akU0n = parcelRequire("akU0n");

var $gz0GE = parcelRequire("gz0GE");

var $6rr91 = parcelRequire("6rr91");

var $02UHI = parcelRequire("02UHI");

var $3QiIL = parcelRequire("3QiIL");

var $anwxR = parcelRequire("anwxR");
const $b88cbefda228febf$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $3QiIL.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $6rr91.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gz0GE.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $anwxR.buildCredentials)(secOptions);
    const ignoreResponsePayload = (options === null || options === void 0 ? void 0 : options.ignoreResponsePayload) || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $akU0n.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options !== null && options !== void 0 && options.reportTracingHeaders) {
            const tracingHeaders = (0, $02UHI.extractTracingHeaders)(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $b88cbefda228febf$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});



parcelRegister("3DToh", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $77b26a32a10329c8$export$4529f10aed0950d4);
class $77b26a32a10329c8$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("fhv13", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $537d8971fc2158e8$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $537d8971fc2158e8$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $537d8971fc2158e8$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $537d8971fc2158e8$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $537d8971fc2158e8$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $537d8971fc2158e8$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $537d8971fc2158e8$export$482549d945a3723);
var $537d8971fc2158e8$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $537d8971fc2158e8$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $537d8971fc2158e8$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $537d8971fc2158e8$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $537d8971fc2158e8$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $537d8971fc2158e8$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $537d8971fc2158e8$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("iVe7J", function(module, exports) {
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $8b7032c0dc54cd02$export$1466212a1606133);

var $dMfNK = parcelRequire("dMfNK");

var $c55iO = parcelRequire("c55iO");
const $8b7032c0dc54cd02$export$1466212a1606133 = (providerType)=>{
    return (0, $c55iO.withSampling)((0, $dMfNK.ufoExperiences)['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("dMfNK", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $4ded74c4f57cee6e$export$615f888019c45765);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dfnp7 = parcelRequire("dfnp7");

var $9yyGy = parcelRequire("9yyGy");

var $kjVFD = parcelRequire("kjVFD");

var $fhv13 = parcelRequire("fhv13");



const $4ded74c4f57cee6e$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $kjVFD.ExperienceTypes).Load,
        performanceType: (0, $kjVFD.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $4ded74c4f57cee6e$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $kjVFD.ExperienceTypes).Experience,
        performanceType: (0, $kjVFD.ExperiencePerformanceTypes).InlineResult
    };
};
const $4ded74c4f57cee6e$var$customEmojiTimings = [
    {
        key: (0, $fhv13.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $fhv13.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $fhv13.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $fhv13.UfoEmojiTimings).METADATA_START,
        endMark: (0, $fhv13.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $fhv13.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $fhv13.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $fhv13.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $fhv13.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $fhv13.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $fhv13.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $fhv13.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $fhv13.UfoEmojiTimings).ONLOAD_END
    }
];
const $4ded74c4f57cee6e$export$615f888019c45765 = {
    'emoji-rendered': new (0, $dfnp7.ConcurrentExperience)((0, $fhv13.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $fhv13.UfoComponentName).EMOJI
        },
        type: (0, $kjVFD.ExperienceTypes).Operation,
        performanceType: (0, $kjVFD.ExperiencePerformanceTypes).Custom,
        timings: $4ded74c4f57cee6e$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $dfnp7.ConcurrentExperience)((0, $fhv13.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $4ded74c4f57cee6e$var$createRenderExperience((0, $fhv13.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $9yyGy.UFOExperience)((0, $fhv13.UfoExperienceName).EMOJI_PICKER_OPENED, $4ded74c4f57cee6e$var$createRenderExperience((0, $fhv13.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $9yyGy.UFOExperience)((0, $fhv13.UfoExperienceName).EMOJI_SELECTION_RECORDED, $4ded74c4f57cee6e$var$createInlineExperience((0, $fhv13.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $9yyGy.UFOExperience)((0, $fhv13.UfoExperienceName).EMOJI_UPLOADED, $4ded74c4f57cee6e$var$createInlineExperience((0, $fhv13.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $9yyGy.UFOExperience)((0, $fhv13.UfoExperienceName).EMOJI_SEARCHED, $4ded74c4f57cee6e$var$createInlineExperience((0, $fhv13.UfoComponentName).EMOJI_PICKER))
};

});
parcelRegister("dfnp7", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $b50238f6be3270ea$export$ac1cddfee07ba6ac);

var $ap2Ft = parcelRequire("ap2Ft");

var $9yyGy = parcelRequire("9yyGy");
class $b50238f6be3270ea$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $9yyGy.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $ap2Ft.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("ap2Ft", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $5e6953695bf59ec8$export$b4958caff08a0960);

var $7nSsr = parcelRequire("7nSsr");
const $5e6953695bf59ec8$export$b4958caff08a0960 = (...args)=>{
    (0, $7nSsr.ufologger).log(...args);
};

});
parcelRegister("7nSsr", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $81f56ff5412b8312$export$4ab84f6f04f6566d);
class $81f56ff5412b8312$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($81f56ff5412b8312$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($81f56ff5412b8312$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $81f56ff5412b8312$export$4ab84f6f04f6566d = new $81f56ff5412b8312$var$UFOLogger();

});


parcelRegister("9yyGy", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $498c897a7fadca04$export$c00d22927c60484a);

var $9mViS = parcelRequire("9mViS");
class $498c897a7fadca04$export$c00d22927c60484a extends (0, $9mViS.UFOAbstractExperience) {
}

});
parcelRegister("9mViS", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $5a4f32db689e742a$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eUgRu = parcelRequire("eUgRu");

var $gB5o2 = parcelRequire("gB5o2");

var $9vc1U = parcelRequire("9vc1U");

var $biYp5 = parcelRequire("biYp5");

var $565SQ = parcelRequire("565SQ");

var $kMppf = parcelRequire("kMppf");

var $ap2Ft = parcelRequire("ap2Ft");

var $8MHix = parcelRequire("8MHix");

var $2nw7P = parcelRequire("2nw7P");

var $6IMxW = parcelRequire("6IMxW");

var $j5Q2r = parcelRequire("j5Q2r");

var $eGEM0 = parcelRequire("eGEM0");

var $609JM = parcelRequire("609JM");

var $kjVFD = parcelRequire("kjVFD");

var $eos0H = parcelRequire("eos0H");
const $5a4f32db689e742a$var$getPageVisibleState = ()=>{
    return !(0, $j5Q2r.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $6IMxW.PageVisibleState).VISIBLE : (0, $6IMxW.PageVisibleState).HIDDEN;
};
class $5a4f32db689e742a$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $eGEM0.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $6IMxW.PageVisibleState).MIXED;
            (0, $2nw7P.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $5a4f32db689e742a$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $kjVFD.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $kjVFD.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $ap2Ft.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $609JM.canTransition)(this.state, newState)) {
            (0, $ap2Ft.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $eGEM0.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $eos0H.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $eUgRu.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $eos0H.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $biYp5.getGlobalEventStream)().push((0, $kMppf.unsubscribeEvent)((0, $6IMxW.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $ap2Ft.ufolog)('this.parent', this.parent);
                (0, $biYp5.getGlobalEventStream)().push((0, $9vc1U.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $ap2Ft.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $8MHix.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $eGEM0.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $5a4f32db689e742a$var$getPageVisibleState();
            (0, $2nw7P.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $ap2Ft.ufolog)('subscribed', this.id);
                (0, $biYp5.getGlobalEventStream)().push((0, $565SQ.subscribeEvent)((0, $6IMxW.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $6IMxW.FMP_MARK) && name !== (0, $6IMxW.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $8MHix.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $eos0H.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $eGEM0.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $6IMxW.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $6IMxW.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $8MHix.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $2nw7P.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $eGEM0.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $eGEM0.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $eGEM0.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $ap2Ft.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $gB5o2.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("gB5o2", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $ddbc416d3e61b830$export$2295b861f318254a);
// temp solution until we can get it automated
const $ddbc416d3e61b830$export$2295b861f318254a = '0.1.5';

});

parcelRegister("9vc1U", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $81ed6b80ed1209c8$export$7c957416596ca127);

var $6IMxW = parcelRequire("6IMxW");
const $81ed6b80ed1209c8$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $6IMxW.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("6IMxW", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $a19d3de8b472ffa5$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $a19d3de8b472ffa5$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $a19d3de8b472ffa5$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $a19d3de8b472ffa5$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $a19d3de8b472ffa5$export$837e0f79a8056912);
var $a19d3de8b472ffa5$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $a19d3de8b472ffa5$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $a19d3de8b472ffa5$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $a19d3de8b472ffa5$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $a19d3de8b472ffa5$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $a19d3de8b472ffa5$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $a19d3de8b472ffa5$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $a19d3de8b472ffa5$export$9f2bf58999404c75 = 'fmp';
const $a19d3de8b472ffa5$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("biYp5", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $9695faeea9e05df6$export$6123a44dc2384540);

var $8Z6Rl = parcelRequire("8Z6Rl");
const $9695faeea9e05df6$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $8Z6Rl.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("8Z6Rl", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $780904ec6a1a6c3a$export$d8b468db8a225bc9);
const $780904ec6a1a6c3a$export$d8b468db8a225bc9 = 250;

});


parcelRegister("565SQ", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $540370e348bd8798$export$37863216db4b714d);

var $6IMxW = parcelRequire("6IMxW");
const $540370e348bd8798$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $6IMxW.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("kMppf", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $bdde2d9ba8d9de30$export$ee1a7bd1fc9ea85e);

var $6IMxW = parcelRequire("6IMxW");
const $bdde2d9ba8d9de30$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $6IMxW.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("8MHix", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $78330da217b62dae$export$d53d07b6034c4560);

var $7nSsr = parcelRequire("7nSsr");
const $78330da217b62dae$export$d53d07b6034c4560 = (...args)=>{
    (0, $7nSsr.ufologger).warn(...args);
};

});

parcelRegister("2nw7P", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $7623d47da53154f9$export$13e680397ec8f3eb);

var $j5Q2r = parcelRequire("j5Q2r");
class $7623d47da53154f9$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $j5Q2r.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $7623d47da53154f9$export$13e680397ec8f3eb = new $7623d47da53154f9$var$VisibilityChangeObserver();

});
parcelRegister("j5Q2r", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $c28758cf119ca59f$export$15e172712955e18f);
const $c28758cf119ca59f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("eGEM0", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $82c0e4c68bb2c298$export$81b70111112841a0);
const $82c0e4c68bb2c298$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("609JM", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $541d70be7b5c091a$export$178881f329fdb81f);

var $eGEM0 = parcelRequire("eGEM0");
const $541d70be7b5c091a$var$UFOStateAvailableTransitions = {
    [(0, $eGEM0.UFOExperienceState).NOT_STARTED.id]: [
        (0, $eGEM0.UFOExperienceState).STARTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).STARTED.id]: [
        (0, $eGEM0.UFOExperienceState).IN_PROGRESS.id,
        (0, $eGEM0.UFOExperienceState).BLOCKED.id,
        (0, $eGEM0.UFOExperienceState).SUCCEEDED.id,
        (0, $eGEM0.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $eGEM0.UFOExperienceState).FAILED.id,
        (0, $eGEM0.UFOExperienceState).ABORTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $eGEM0.UFOExperienceState).BLOCKED.id,
        (0, $eGEM0.UFOExperienceState).SUCCEEDED.id,
        (0, $eGEM0.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $eGEM0.UFOExperienceState).FAILED.id,
        (0, $eGEM0.UFOExperienceState).ABORTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).BLOCKED.id]: [
        (0, $eGEM0.UFOExperienceState).RECOVERED.id,
        (0, $eGEM0.UFOExperienceState).ABORTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).RECOVERED.id]: [
        (0, $eGEM0.UFOExperienceState).STARTED.id,
        (0, $eGEM0.UFOExperienceState).SUCCEEDED.id,
        (0, $eGEM0.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $eGEM0.UFOExperienceState).FAILED.id,
        (0, $eGEM0.UFOExperienceState).ABORTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).SUCCEEDED.id]: [
        (0, $eGEM0.UFOExperienceState).STARTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $eGEM0.UFOExperienceState).SUCCEEDED.id,
        (0, $eGEM0.UFOExperienceState).FAILED.id,
        (0, $eGEM0.UFOExperienceState).ABORTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).FAILED.id]: [
        (0, $eGEM0.UFOExperienceState).STARTED.id
    ],
    [(0, $eGEM0.UFOExperienceState).ABORTED.id]: [
        (0, $eGEM0.UFOExperienceState).STARTED.id
    ]
};
const $541d70be7b5c091a$export$178881f329fdb81f = (state1, state2)=>{
    return $541d70be7b5c091a$var$UFOStateAvailableTransitions[state1.id] && $541d70be7b5c091a$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("kjVFD", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $127a1c72ee78db60$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $127a1c72ee78db60$export$cc26007c03242fff);
var $127a1c72ee78db60$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $127a1c72ee78db60$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("eos0H", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $4fb67ffe2695c60e$export$c753e8669d30c8ad);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $hy1m2 = parcelRequire("hy1m2");
const $4fb67ffe2695c60e$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $hy1m2.roundPerfNow)();
};

});
parcelRegister("hy1m2", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $c5c5e636ee5babad$export$5f490af6b2b115cf);
const $c5c5e636ee5babad$export$5f490af6b2b115cf = ()=>~~performance.now();

});






parcelRegister("c55iO", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $94e4f185a796f77d$export$dc2f0946255b3f89);

var $jvsT4 = parcelRequire("jvsT4");

var $h2ag7 = parcelRequire("h2ag7");
const $94e4f185a796f77d$var$hasSampledFromStart = (experience)=>{
    if (!(0, $h2ag7.ufoExperiencesSampled)[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return (0, $h2ag7.ufoExperiencesSampled)[experience.id].sampledInstance[experience.instanceId];
    return (0, $h2ag7.ufoExperiencesSampled)[experience.id].sampled;
};
const $94e4f185a796f77d$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!(0, $h2ag7.ufoExperiencesSampled)[ufoExperience.id]) (0, $h2ag7.ufoExperiencesSampled)[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || (0, $jvsT4.isExperienceSampled);
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) (0, $h2ag7.ufoExperiencesSampled)[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            (0, $h2ag7.ufoExperiencesSampled)[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            (0, $h2ag7.ufoExperiencesSampled)[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            (0, $h2ag7.ufoExperiencesSampled)[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$94e4f185a796f77d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});
parcelRegister("jvsT4", function(module, exports) {
$parcel$export(module.exports, "isExperienceSampled", () => $37e1595936166929$export$1c967630b3ea2d58);
/**
 * A random sampling function
 * sampling algorithm is from @atlassian/jira-coinflip at https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/platform/app-framework/coinflip/src/index.tsx
 * E.g. isExperienceSampled(2) will pass 50% of the time
 * @param rate The chance that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ // default sampling function to determine which one to be sampled
const $37e1595936166929$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};

});

parcelRegister("h2ag7", function(module, exports) {
$parcel$export(module.exports, "ufoExperiencesSampled", () => $85a134f4e733a0e8$export$c7c4959fece2f3ec);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 


const $85a134f4e733a0e8$export$c7c4959fece2f3ec = {};

});



parcelRegister("5av15", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $e0c274b1453e5713$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $e0c274b1453e5713$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $e0c274b1453e5713$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $e0c274b1453e5713$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $e0c274b1453e5713$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $e0c274b1453e5713$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $e0c274b1453e5713$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $e0c274b1453e5713$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $e0c274b1453e5713$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $e0c274b1453e5713$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $e0c274b1453e5713$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $e0c274b1453e5713$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $e0c274b1453e5713$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $e0c274b1453e5713$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $e0c274b1453e5713$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $e0c274b1453e5713$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $e0c274b1453e5713$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $e0c274b1453e5713$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $e0c274b1453e5713$export$8efb414216030943);
$parcel$export(module.exports, "defaultInlineEmojiHeight", () => $e0c274b1453e5713$export$4adebc94e462aea5);
$parcel$export(module.exports, "emojiPickerWidth", () => $e0c274b1453e5713$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $e0c274b1453e5713$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $e0c274b1453e5713$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeightNew", () => $e0c274b1453e5713$export$9f36457335d8859f);
$parcel$export(module.exports, "emojiPickerPreviewHeight", () => $e0c274b1453e5713$export$e218e5cb105a0e22);
$parcel$export(module.exports, "localStoragePrefix", () => $e0c274b1453e5713$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $e0c274b1453e5713$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "selectedProductivityColorStorageKey", () => $e0c274b1453e5713$export$ec5e3f6f684720d7);
$parcel$export(module.exports, "defaultCategories", () => $e0c274b1453e5713$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $e0c274b1453e5713$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $e0c274b1453e5713$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $e0c274b1453e5713$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $e0c274b1453e5713$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $e0c274b1453e5713$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $e0c274b1453e5713$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $e0c274b1453e5713$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $e0c274b1453e5713$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $e0c274b1453e5713$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $e0c274b1453e5713$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $e0c274b1453e5713$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $e0c274b1453e5713$export$66cabad5e268b05e);
const $e0c274b1453e5713$export$5e4e3d1c3e43156a = 'CUSTOM';
const $e0c274b1453e5713$export$78ccdc4be403c468 = 'FREQUENT';
const $e0c274b1453e5713$export$2c4b04c3aacdf1b3 = 'SITE';
const $e0c274b1453e5713$export$1b0258512be88334 = 'SEARCH';
const $e0c274b1453e5713$export$42b510423367f354 = 'USER_CUSTOM';
const $e0c274b1453e5713$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $e0c274b1453e5713$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $e0c274b1453e5713$export$8ac325bfd32359b0 = 'data:';
const $e0c274b1453e5713$export$a330961542edfe6f = 'delete-emoji';
const $e0c274b1453e5713$export$1a817f1886276c6d = 100000;
const $e0c274b1453e5713$export$2e7088017339c92 = 28;
const $e0c274b1453e5713$export$4cb591b57c224c0 = 26;
const $e0c274b1453e5713$export$b31a41e904161dc1 = 24;
const $e0c274b1453e5713$export$7dd039b460c61389 = 22;
const $e0c274b1453e5713$export$96ee6614460413a0 = 24.25;
const $e0c274b1453e5713$export$103771a4cd74af90 = 22.25;
const $e0c274b1453e5713$export$5cc2afcf38309ce9 = 20.25;
const $e0c274b1453e5713$export$9a9984214a4bd724 = 18.25;
const $e0c274b1453e5713$export$3f99ac31dc0406db = 20;
const $e0c274b1453e5713$export$8efb414216030943 = 16.25;
const $e0c274b1453e5713$export$4adebc94e462aea5 = 16;
const $e0c274b1453e5713$export$d171dc12fee2b1da = 350;
const $e0c274b1453e5713$export$c10ac8125a260041 = 80;
const $e0c274b1453e5713$export$5248fb9e0cccc41f = 'medium';
const $e0c274b1453e5713$export$94f75d625e7801d3 = 260;
const $e0c274b1453e5713$export$7ed599d166d65aea = 295;
const $e0c274b1453e5713$export$9f36457335d8859f = $e0c274b1453e5713$export$7ed599d166d65aea - 102; // picker height - actions height - preview height
const $e0c274b1453e5713$export$e218e5cb105a0e22 = 54;
const $e0c274b1453e5713$export$e67f617938b111f1 = $e0c274b1453e5713$export$7ed599d166d65aea + $e0c274b1453e5713$export$e218e5cb105a0e22;
const $e0c274b1453e5713$export$e394a0c530ae5631 = 'fabric.emoji';
const $e0c274b1453e5713$export$79ee4ef84c545f8f = `${$e0c274b1453e5713$export$e394a0c530ae5631}.selectedTone`;
const $e0c274b1453e5713$export$ec5e3f6f684720d7 = `${$e0c274b1453e5713$export$e394a0c530ae5631}.selectedProductivityColor`;
const $e0c274b1453e5713$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $e0c274b1453e5713$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $e0c274b1453e5713$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $e0c274b1453e5713$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $e0c274b1453e5713$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $e0c274b1453e5713$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $e0c274b1453e5713$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $e0c274b1453e5713$export$4f0ee90b28d6efc5 = 0;
const $e0c274b1453e5713$export$9f7de4293d27f3aa = 50;
const $e0c274b1453e5713$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $e0c274b1453e5713$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $e0c274b1453e5713$export$2829f3ec323f8ec0 = 8;
const $e0c274b1453e5713$export$ce3a0e7d2d7d6ba2 = 5;
const $e0c274b1453e5713$export$858e8dc100a97278 = 150;
const $e0c274b1453e5713$export$83aab2ae64548423 = 20;
const $e0c274b1453e5713$export$66cabad5e268b05e = 100;

});

parcelRegister("j8Z78", function(module, exports) {
$parcel$export(module.exports, "isMediaEmoji", () => $b0fa3c654f2125fe$export$a7e82c67204c73a1);

var $1PflG = parcelRequire("1PflG");
const $b0fa3c654f2125fe$export$a7e82c67204c73a1 = (emoji)=>(0, $1PflG.isMediaRepresentation)(emoji.representation);

});
parcelRegister("1PflG", function(module, exports) {
$parcel$export(module.exports, "isMediaRepresentation", () => $171e35d87d28050f$export$979133dc1df141c6);
const $171e35d87d28050f$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);

});


parcelRegister("eriBW", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $7790bfde5bf753e8$export$4369c812aac99591);
const $7790bfde5bf753e8$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("hsPKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9581c53de98d9483$export$2e2bcd8739ae039);
let $9581c53de98d9483$var$debugEnabled = false;
let $9581c53de98d9483$var$stacktracesEnabled = false;
function $9581c53de98d9483$export$748ada60eaf985cc(enable) {
    $9581c53de98d9483$var$debugEnabled = enable;
}
function $9581c53de98d9483$export$4f7017086af31c25(enable) {
    $9581c53de98d9483$var$stacktracesEnabled = enable;
}
function $9581c53de98d9483$export$2a858f450a2f66d() {
    if ($9581c53de98d9483$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $9581c53de98d9483$export$2e2bcd8739ae039(msg, ...args) {
    if ($9581c53de98d9483$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("faqTp", function(module, exports) {
$parcel$export(module.exports, "default", () => $02f5a22ae04b9bc1$export$2e2bcd8739ae039);
function $02f5a22ae04b9bc1$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("hh8nC", function(module, exports) {
$parcel$export(module.exports, "promiseWithTimeout", () => $c1f45b1346993bb2$export$a9cd205a244d9f54);
function $c1f45b1346993bb2$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});

parcelRegister("ko6w5", function(module, exports) {
$parcel$export(module.exports, "toEmojiId", () => $f1208798583a1f87$export$8d7d3de6b5b305d1);
const $f1208798583a1f87$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });

});

parcelRegister("6b28p", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bbb068b29ed6db2$export$2e2bcd8739ae039);

var $kLszd = parcelRequire("kLszd");

var $im5mC = parcelRequire("im5mC");

var $lG8wl = parcelRequire("lG8wl");
/**
 * Shared cache of in-flight/resolved emoji load promises, keyed by the request URL so that
 * multiple loaders created for the same provider config reuse a single request instead of
 * refetching.
 */ const $0bbb068b29ed6db2$var$emojiPromiseCache = new Map();
class $0bbb068b29ed6db2$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
   * Returns a promise with an array of Emoji from all providers.
   */ loadEmoji() {
        // The cache is module-level and outlives individual loaders, so under test it would leak
        // responses between cases sharing a provider url. Always refetch there instead.
        if ((0, $kLszd.isTestEnvironment)()) return this.fetchEmoji();
        const cacheKey = this.config.url;
        const cachedPromise = $0bbb068b29ed6db2$var$emojiPromiseCache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const emojiPromise = this.fetchEmoji();
        // Evict on failure so a rejected promise is not cached, allowing retries to refetch.
        emojiPromise.catch(()=>{
            if ($0bbb068b29ed6db2$var$emojiPromiseCache.get(cacheKey) === emojiPromise) $0bbb068b29ed6db2$var$emojiPromiseCache.delete(cacheKey);
        });
        $0bbb068b29ed6db2$var$emojiPromiseCache.set(cacheKey, emojiPromise);
        return emojiPromise;
    }
    fetchEmoji() {
        return (0, $lG8wl.emojiRequest)(this.config).then((emojiServiceResponse)=>(0, $im5mC.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("kLszd", function(module, exports) {
$parcel$export(module.exports, "isTestEnvironment", () => $a8c0bea8ce1007b5$export$43ea16ac36fe59f1);
/**
 * Detects Jest unit tests and automated browsers (Playwright and other WebDriver-based drivers).
 *
 * Used to opt out of module-level caching that outlives individual instances. Such a cache leaks
 * state between test cases that share an input, which makes tests order-dependent and forces every
 * consumer to reset shared internals from their own suites.
 */ 
var $3jCFs = parcelRequire("3jCFs");
function $a8c0bea8ce1007b5$export$43ea16ac36fe59f1() {
    try {
        var _process, _process2;
        return Boolean(typeof $3jCFs !== 'undefined' && (// NODE_ENV can be overridden by consumers, so also check for a Jest worker
        ((_process = $3jCFs) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.NODE_ENV) === 'test' || ((_process2 = $3jCFs) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.JEST_WORKER_ID) !== undefined) || // Playwright serves examples with NODE_ENV=development, but sets navigator.webdriver
        typeof navigator !== 'undefined' && navigator.webdriver);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});

parcelRegister("im5mC", function(module, exports) {
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $1f4a0fc47a19cd31$export$afaea97e40b5ca70);

var $2fDPY = parcelRequire("2fDPY");

var $iQNPC = parcelRequire("iQNPC");

var $aTp9d = parcelRequire("aTp9d");

var $1Uf2A = parcelRequire("1Uf2A");
const $1f4a0fc47a19cd31$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = (0, $aTp9d.denormaliseServiceRepresentation)(emoji.representation, emojiData.meta);
        const altRepresentation = (0, $iQNPC.denormaliseServiceAltRepresentation)(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = (0, $1Uf2A.denormaliseSkinEmoji)(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: _representation, skinVariations: _skinVariations, altRepresentations: _altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $2fDPY.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};

});
parcelRegister("2fDPY", function(module, exports) {
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $9343c69b2b2fb3a7$export$a48c58c688a3131);
const $9343c69b2b2fb3a7$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};

});

parcelRegister("iQNPC", function(module, exports) {
$parcel$export(module.exports, "denormaliseServiceAltRepresentation", () => $c191555664585209$export$aa9faa01267cb2e7);

var $aTp9d = parcelRequire("aTp9d");

var $kRAky = parcelRequire("kRAky");
const $c191555664585209$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : (0, $aTp9d.denormaliseServiceRepresentation)((0, $kRAky.getAltRepresentation)(altReps), meta);
};

});
parcelRegister("aTp9d", function(module, exports) {
$parcel$export(module.exports, "denormaliseServiceRepresentation", () => $460ecde0096e967a$export$55077db3efc820aa);

var $eVOU3 = parcelRequire("eVOU3");

var $iK3c6 = parcelRequire("iK3c6");

var $5PbCI = parcelRequire("5PbCI");

var $hsPKy = parcelRequire("hsPKy");

var $d8SOI = parcelRequire("d8SOI");
const $460ecde0096e967a$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $5PbCI.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $iK3c6.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ((0, $d8SOI.isMediaApiUrl)(imagePath, meta)) return (0, $eVOU3.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $hsPKy.default)('failed conversion for representation', representation, meta);
    return undefined;
};

});
parcelRegister("eVOU3", function(module, exports) {
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $572eaccc74ac4aea$export$20a1bd1d33069ce7);
const $572eaccc74ac4aea$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });

});

parcelRegister("iK3c6", function(module, exports) {
$parcel$export(module.exports, "isImageRepresentation", () => $73c8203687a1ba91$export$90b099a26fbd8b41);
const $73c8203687a1ba91$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);

});

parcelRegister("5PbCI", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $6ebca52ec7f78322$export$1c52f72b88b558e8);
const $6ebca52ec7f78322$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);

});

parcelRegister("d8SOI", function(module, exports) {
$parcel$export(module.exports, "isMediaApiUrl", () => $c1c7cab131b53c56$export$db05e6ae1fd416af);
const $c1c7cab131b53c56$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);

});


parcelRegister("kRAky", function(module, exports) {
$parcel$export(module.exports, "getAltRepresentation", () => $e5d39206a0e9da29$export$4a0301d636367e1d);

var $3Nsm5 = parcelRequire("3Nsm5");

var $cZGOL = parcelRequire("cZGOL");
const $e5d39206a0e9da29$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[(0, $3Nsm5.calculateScale)((0, $cZGOL.getPixelRatio)).altScale];
};

});
parcelRegister("3Nsm5", function(module, exports) {
$parcel$export(module.exports, "calculateScale", () => $730722d2159ebd0e$export$1d78826433168f34);

var $aEmSo = parcelRequire("aEmSo");
const $730722d2159ebd0e$export$1d78826433168f34 = (getRatio)=>{
    if ((0, $aEmSo.expValEquals)('platform_editor_emoji_default_scale', 'isEnabled', true)) {
        // retina display
        if (getRatio() > 1) return {
            scale: 'XXXHDPI',
            altScale: 'XXXHDPI'
        };
        // default set used for desktop
        return {
            altScale: 'XXXHDPI'
        };
    }
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};

});
parcelRegister("aEmSo", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $2de670a82366a73f$export$45abdb3f977b5b14);

var $lsSrw = parcelRequire("lsSrw");
function $2de670a82366a73f$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $lsSrw.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("lsSrw", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $410358a73283b578$export$58e581060588c6bb);

var $k2M4v = parcelRequire("k2M4v");

var $2Eign = parcelRequire("2Eign");

var $btIgm = parcelRequire("btIgm");

var $02SZ7 = parcelRequire("02SZ7");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
const $410358a73283b578$var$allowsProductKeys = [
    'cc-maui-experiment',
    'platform_use_unicode_emojis'
];
function $410358a73283b578$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon;
    if ((0, $02SZ7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $02SZ7._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $k2M4v.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKeyName = $410358a73283b578$var$allowsProductKeys.includes(experimentName) ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ((_editorExperimentsCon = (0, $btIgm.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 || (_editorExperimentsCon = _editorExperimentsCon.productKeys) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon[0, $02SZ7._product]) ?? experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $k2M4v.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $2Eign.addFeatureFlagAccessed)(`${experimentKeyName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("btIgm", function(module, exports) {
$parcel$export(module.exports, "disallowsProductKeys", () => $7c5d2d865e51d126$export$5c897d5297c5b7fd);
$parcel$export(module.exports, "editorExperimentsConfig", () => $7c5d2d865e51d126$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8o0j3 = parcelRequire("8o0j3");

var $7sk6L = parcelRequire("7sk6L");
const $7c5d2d865e51d126$export$5c897d5297c5b7fd = [
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness'
];
const $7c5d2d865e51d126$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_remix_icon_right_side: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-08-08
    'example-boolean': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $8o0j3.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $7sk6L.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("8o0j3", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $0e534df45ff1db2b$export$456f1587c9c92021);

var $kWbZX = parcelRequire("kWbZX");
function $0e534df45ff1db2b$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $kWbZX.isBoolean),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("kWbZX", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $6034aadc48f70304$export$f9ce7b637dfbe238);
function $6034aadc48f70304$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("7sk6L", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $748ed65bf380e7ec$export$fb89e8a786694d1);

var $iqWS6 = parcelRequire("iqWS6");
function $748ed65bf380e7ec$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        // Maintains the tuple
        typeGuard: (0, $iqWS6.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("iqWS6", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $ae5bc2e787888c03$export$a9a18ae5ba42aeab);

var $3jCFs = parcelRequire("3jCFs");
var $ae5bc2e787888c03$var$_process, $ae5bc2e787888c03$var$_process2;
const $ae5bc2e787888c03$var$IS_TESTING_ENV = typeof $3jCFs !== 'undefined' && ((($ae5bc2e787888c03$var$_process = $3jCFs) === null || $ae5bc2e787888c03$var$_process === void 0 || ($ae5bc2e787888c03$var$_process = $ae5bc2e787888c03$var$_process.env) === null || $ae5bc2e787888c03$var$_process === void 0 ? void 0 : $ae5bc2e787888c03$var$_process.NODE_ENV) === 'test' || (($ae5bc2e787888c03$var$_process2 = $3jCFs) === null || $ae5bc2e787888c03$var$_process2 === void 0 || ($ae5bc2e787888c03$var$_process2 = $ae5bc2e787888c03$var$_process2.env) === null || $ae5bc2e787888c03$var$_process2 === void 0 ? void 0 : $ae5bc2e787888c03$var$_process2.JEST_WORKER_ID) !== undefined);
function $ae5bc2e787888c03$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($ae5bc2e787888c03$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("02SZ7", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $85979359316141fa$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $85979359316141fa$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $85979359316141fa$export$cf7305fc65acbf0d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $ethbk = parcelRequire("ethbk");

var $btIgm = parcelRequire("btIgm");
let $85979359316141fa$export$e5d73bf4f8e2ae96 = {};
let $85979359316141fa$export$4e849416bb5c5b52 = {};
let $85979359316141fa$export$cf7305fc65acbf0d;
function $85979359316141fa$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $btIgm.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $85979359316141fa$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $btIgm.editorExperimentsConfig)).map(([key, value])=>{
            var _groupOverrides;
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                ((_groupOverrides = groupOverrides) === null || _groupOverrides === void 0 ? void 0 : _groupOverrides[key]) ?? (0, $ethbk.testMultivariateOverrides)[key] ?? (0, $ethbk.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $85979359316141fa$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $85979359316141fa$export$cf7305fc65acbf0d = product;
    $85979359316141fa$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("ethbk", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $5dbbde40c7fcd7a1$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $5dbbde40c7fcd7a1$export$54960937bb713f97);
const $5dbbde40c7fcd7a1$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_paste_actions_menu_v2: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
const $5dbbde40c7fcd7a1$export$54960937bb713f97 = {
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false
};

});





parcelRegister("cZGOL", function(module, exports) {
$parcel$export(module.exports, "getPixelRatio", () => $476a1b2698ede901$export$d39ce20a37bba061);
const $476a1b2698ede901$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};

});



parcelRegister("1Uf2A", function(module, exports) {
$parcel$export(module.exports, "denormaliseSkinEmoji", () => $b9901ef2b4d5061f$export$e3da49c88c2e54d5);

var $iQNPC = parcelRequire("iQNPC");

var $aTp9d = parcelRequire("aTp9d");
const $b9901ef2b4d5061f$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: _representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: (0, $aTp9d.denormaliseServiceRepresentation)(skin.representation, meta),
            altRepresentation: (0, $iQNPC.denormaliseServiceAltRepresentation)(altRepresentations, meta),
            ...other
        };
    });
};

});


parcelRegister("lG8wl", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $5204daeaaefa081f$export$ea1accde4cc117f4);

var $6AWhp = parcelRequire("6AWhp");

var $3Nsm5 = parcelRequire("3Nsm5");

var $cZGOL = parcelRequire("cZGOL");
const $5204daeaaefa081f$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = (0, $cZGOL.getPixelRatio), ...serviceConfig } = provider;
    const scaleQueryParams = (0, $3Nsm5.calculateScale)(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $6AWhp.utils).requestService(serviceConfig, requestOptions);
};

});


parcelRegister("jCwn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ee673d8491f16f8$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $3C6fZ = parcelRequire("3C6fZ");

var $fhv13 = parcelRequire("fhv13");

var $5av15 = parcelRequire("5av15");

var $4pTbi = parcelRequire("4pTbi");

var $bKBhv = parcelRequire("bKBhv");

var $an53g = parcelRequire("an53g");

var $gHZUS = parcelRequire("gHZUS");

var $ghLW8 = parcelRequire("ghLW8");

var $dXCon = parcelRequire("dXCon");

var $ixSvG = parcelRequire("ixSvG");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $0ee673d8491f16f8$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $an53g.tokenizerRegex).lastIndex = 0;
        while((match = (0, $an53g.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $0ee673d8491f16f8$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $bKBhv.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$0ee673d8491f16f8$var$addAllVariants(variation, fnKey, map));
    }
};
const $0ee673d8491f16f8$var$findByKey = (map, key, emojiProviderLookupOrder)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) {
        if (emojiProviderLookupOrder !== null && emojiProviderLookupOrder !== void 0 && emojiProviderLookupOrder.length) for (const emojiType of emojiProviderLookupOrder){
            const matchingEmoji = emojis.find((emoji)=>emoji.type === emojiType);
            if (matchingEmoji) return matchingEmoji;
        }
        // Priority is always to source from the last emoji set (last overrides first)
        return emojis[emojis.length - 1];
    }
    return undefined;
};
const $0ee673d8491f16f8$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $0ee673d8491f16f8$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $0ee673d8491f16f8$export$2e2bcd8739ae039 {
    static #_ = this.defaultEmojiWeight = 1000000;
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
   * Returns all available (and searchable) emoji in some default order.
   */ all() {
        const options = {
            sort: (0, $fhv13.SearchSort).None
        };
        return this.search('', options);
    }
    /**
   * Text search of emoji shortName and name field for suitable matches.
   *
   * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
   *
   * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
   * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
   * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
   */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $0ee673d8491f16f8$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
   * Returns all emoji with matching shortName
   */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
   * Returns the first matching emoji matching the shortName, or null if none found.
   */ findByShortName(shortName, emojiProviderLookupOrder) {
        return $0ee673d8491f16f8$var$findByKey(this.shortNameMap, shortName, emojiProviderLookupOrder);
    }
    /**
   * Returns the first matching emoji matching the id, or null if none found.
   */ findById(id) {
        return $0ee673d8491f16f8$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $5av15.frequentCategory)) return this.getFrequentlyUsed();
        else if (categoryId === 'ATLASSIAN') return this.all().emojis.filter((emoji)=>emoji.category === categoryId || emoji.type === 'ATLASSIAN');
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
   * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
   * there are none.
   *
   * @param options optional settings to be applied to the set of frequently used emoji
   */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
   * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
   * in sorting, etc).
   *
   * @param emoji the emoji that was just used
   */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $5av15.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $5av15.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $0ee673d8491f16f8$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $fhv13.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $fhv13.SearchSort).Default) comparator = (0, $ghLW8.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $fhv13.SearchSort).UsageFrequency) comparator = (0, $dXCon.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return (0, $gHZUS.getEmojiVariation)(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $ixSvG.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        // When emojis are deleted - the repository is re-initialised.
        // This invalidates the full search index that's lazily loaded later
        this.fullSearchReady = false;
    }
    /**
   * Optimisation to initialise all map member variables in single loop over emojis
   */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(this.getDynamicCategoryForEmoji(emoji));
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $5av15.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $5av15.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $3C6fZ.Search)('id');
        this.fullSearch.tokenizer = new $0ee673d8491f16f8$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $3C6fZ.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addIndex('keywords');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $0ee673d8491f16f8$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $0ee673d8491f16f8$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $0ee673d8491f16f8$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $0ee673d8491f16f8$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = this.getDynamicCategoryForEmoji(emoji);
        if ((0, $5av15.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
    getDynamicCategoryForEmoji(emoji) {
        const category = (0, $4pTbi.getCategoryId)(emoji);
        if (emoji.type === 'ATLASSIAN' && category !== (0, $5av15.frequentCategory)) return 'ATLASSIAN';
        return category;
    }
}

});
parcelRegister("3C6fZ", function(module, exports) {
$parcel$export(module.exports, "UnorderedSearchIndex", () => $2a19c635b91876da$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $2a19c635b91876da$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $2a19c635b91876da$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $2a19c635b91876da$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $2a19c635b91876da$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $2a19c635b91876da$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $2a19c635b91876da$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $2a19c635b91876da$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $2a19c635b91876da$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    };
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $2a19c635b91876da$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $2a19c635b91876da$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    };
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $2a19c635b91876da$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $2a19c635b91876da$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($2a19c635b91876da$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $2a19c635b91876da$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $2a19c635b91876da$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$2a19c635b91876da$export$eeaf491a400e882a.constructor = false;
$2a19c635b91876da$export$eeaf491a400e882a.hasOwnProperty = false;
$2a19c635b91876da$export$eeaf491a400e882a.isPrototypeOf = false;
$2a19c635b91876da$export$eeaf491a400e882a.propertyIsEnumerable = false;
$2a19c635b91876da$export$eeaf491a400e882a.toLocaleString = false;
$2a19c635b91876da$export$eeaf491a400e882a.toString = false;
$2a19c635b91876da$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $2a19c635b91876da$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$2a19c635b91876da$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $2a19c635b91876da$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2a19c635b91876da$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a19c635b91876da$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a19c635b91876da$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $2a19c635b91876da$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $2a19c635b91876da$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $2a19c635b91876da$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $2a19c635b91876da$export$147e8ac43c84713a();
        this._tokenizer = new $2a19c635b91876da$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    };
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    };
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    };
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    };
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $2a19c635b91876da$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $2a19c635b91876da$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $2a19c635b91876da$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $2a19c635b91876da$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $2a19c635b91876da$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $2a19c635b91876da$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    };
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("4pTbi", function(module, exports) {
$parcel$export(module.exports, "getCategoryId", () => $916ef7d97b6ee5e6$export$4bcbf61cb6832a8e);
const $916ef7d97b6ee5e6$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});

parcelRegister("bKBhv", function(module, exports) {
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $faf8ef4075459b80$export$b0ed6d8df471f3cc);
const $faf8ef4075459b80$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);

});

parcelRegister("an53g", function(module, exports) {
$parcel$export(module.exports, "tokenizerRegex", () => $56354d93f11b56cf$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
/* eslint-disable no-misleading-character-class */ const $56354d93f11b56cf$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi'); /* eslint-enable no-misleading-character-class */ 

});

parcelRegister("gHZUS", function(module, exports) {
$parcel$export(module.exports, "getEmojiVariation", () => $855915ba886257e3$export$e55e46e1520c899d);

var $bKBhv = parcelRequire("bKBhv");
const $855915ba886257e3$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $bKBhv.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};

});

parcelRegister("ghLW8", function(module, exports) {
$parcel$export(module.exports, "createSearchEmojiComparator", () => $77da4b2a917da012$export$e6097b005751df7);

var $54PiC = parcelRequire("54PiC");

var $cJdi5 = parcelRequire("cJdi5");

var $2BEOC = parcelRequire("2BEOC");

var $h0FZ5 = parcelRequire("h0FZ5");

var $gCMQH = parcelRequire("gCMQH");

var $ggJ2R = parcelRequire("ggJ2R");

var $cO8is = parcelRequire("cO8is");
function $77da4b2a917da012$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new (0, $cJdi5.AsciiMatchComparator)(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new (0, $h0FZ5.ExactShortNameMatchComparator)(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new (0, $cO8is.UsageFrequencyComparator)(orderedIds));
    if (textQuery) comparators.push(new (0, $ggJ2R.QueryStringPositionMatchComparator)(textQuery, 'shortName'), new (0, $ggJ2R.QueryStringPositionMatchComparator)(textQuery, 'name'));
    comparators.push((0, $gCMQH.OrderComparator).Instance, (0, $54PiC.AlphabeticalShortnameComparator).Instance);
    const comparator = new (0, $2BEOC.ChainedEmojiComparator)(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}

});
parcelRegister("54PiC", function(module, exports) {
$parcel$export(module.exports, "AlphabeticalShortnameComparator", () => $7bade3a7fd22bf3b$export$30ce221e1adf48c1);
class $7bade3a7fd22bf3b$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("cJdi5", function(module, exports) {
$parcel$export(module.exports, "AsciiMatchComparator", () => $6ebba0a0f26549f1$export$ff92575cd1bbad0e);
class $6ebba0a0f26549f1$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}

});

parcelRegister("2BEOC", function(module, exports) {
$parcel$export(module.exports, "ChainedEmojiComparator", () => $36c7fb554d7e5fd7$export$a8052d0852821684);
class $36c7fb554d7e5fd7$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}

});

parcelRegister("h0FZ5", function(module, exports) {
$parcel$export(module.exports, "ExactShortNameMatchComparator", () => $0e8925b84934f2ff$export$3026b08b79541139);

var $eGtHz = parcelRequire("eGtHz");
class $0e8925b84934f2ff$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new (0, $eGtHz.EmojiTypeComparator)(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}

});
parcelRegister("eGtHz", function(module, exports) {
$parcel$export(module.exports, "EmojiTypeComparator", () => $e46a404389b120ab$export$a7f7a0b04013a8a8);
class $e46a404389b120ab$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}

});


parcelRegister("gCMQH", function(module, exports) {
$parcel$export(module.exports, "OrderComparator", () => $ba3268c3de25d992$export$165e96ceead77edd);

var $5av15 = parcelRequire("5av15");
class $ba3268c3de25d992$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $5av15.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $5av15.MAX_ORDINAL);
        return o1 - o2;
    }
}

});

parcelRegister("ggJ2R", function(module, exports) {
$parcel$export(module.exports, "QueryStringPositionMatchComparator", () => $912644ba496672a5$export$587c775915dc4869);

var $5av15 = parcelRequire("5av15");
class $912644ba496672a5$export$587c775915dc4869 {
    /**
   * @param query the query to match
   * @param propertyToCompare the property of EmojiDescription to check for query within
   */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $5av15.MAX_ORDINAL);
        return score === -1 ? (0, $5av15.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}

});

parcelRegister("cO8is", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyComparator", () => $c327bb3bda31e272$export$55e24837a4bf653);

var $5av15 = parcelRequire("5av15");

var $581br = parcelRequire("581br");
class $c327bb3bda31e272$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
   * Get the ordinal representing the position of this emoji.
   *
   * @param id the id of the emoji
   */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $581br.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $5av15.MAX_ORDINAL;
    }
}

});
parcelRegister("581br", function(module, exports) {
$parcel$export(module.exports, "isEmojiVariationDescription", () => $31dfe821c8270f2b$export$82a0350e1f6b5c0a);
const $31dfe821c8270f2b$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};

});



parcelRegister("dXCon", function(module, exports) {
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $9f1a416d3c20eef7$export$1bd055808eeccb4e);

var $2BEOC = parcelRequire("2BEOC");

var $eGtHz = parcelRequire("eGtHz");

var $gCMQH = parcelRequire("gCMQH");

var $cO8is = parcelRequire("cO8is");
function $9f1a416d3c20eef7$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new (0, $2BEOC.ChainedEmojiComparator)(new (0, $cO8is.UsageFrequencyComparator)(orderedIds), new (0, $eGtHz.EmojiTypeComparator)(), (0, $gCMQH.OrderComparator).Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}

});

parcelRegister("ixSvG", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyTracker", () => $e1d8b33a386f808a$export$3f86810331c44209);

var $5av15 = parcelRequire("5av15");

var $blI7e = parcelRequire("blI7e");

var $581br = parcelRequire("581br");

var $faqTp = parcelRequire("faqTp");

var $1c1vU = parcelRequire("1c1vU");

var $fWTVH = parcelRequire("fWTVH");
class $e1d8b33a386f808a$export$3f86810331c44209 {
    static #_ = this.queueOptions = {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        storage: (0, $faqTp.default)('localStorage') ? window.localStorage : undefined,
        storagePrefix: (0, $5av15.localStoragePrefix),
        maxDuplicates: 25,
        minUniqueItems: 5
    };
    constructor(useStorageIfPossible = true){
        const options = $e1d8b33a386f808a$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $1c1vU.default)(queueOptions);
        } else this.queue = new (0, $blI7e.default)(options);
        this.gateway = new (0, $fWTVH.Gateway)(10);
    }
    /**
   * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
   * count on getOrder() reflecting this usage immediately.
   *
   * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
   */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $581br.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
   * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
   * are no usages then an empty array will be returned.
   */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
   * Exposed for testing only. Clear any recorded usage.
   */ clear() {
        this.queue.clear();
    }
}

});
parcelRegister("blI7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $963f0308bdd7b708$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $963f0308bdd7b708$export$2e2bcd8739ae039 {
    /**
   * Construct a new DuplicateLimitedQueue.
   *
   * @param options the options for this queue.
   */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
   * @param item the item to add to the queue.
   */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items in the queue, ordered by how often they are duplicated. The items with the
   * most duplicates come first in the returned Array.
   *
   * If there are no items in the queue then an empty Array will be returned.
   */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue.
   */ clear() {
        this.createEmptyState();
    }
    /**
   * A more efficient mechanism for adding multiple items. Ordering is only performed once all
   * the items have been added.
   *
   * @param items the items to be enqueued, which happens in their presented order.
   */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items currently stored in the queue.
   */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
   * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
   * performed by this enqueuing. You must trigger that manually if required.
   *
   * @param item the item to be queued
   */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
   * Get an array of items from the queue ordered by how often they are duplicated in the queue.
   */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
   * Walk the list of items and remove the first occurrence of the matching item.
   *
   * @param item the item to be removed.
   */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
   * Remove the first item from the queue and update the itemCountMap accordingly.
   * @return the item add the front of the queue or undefined if the queue is empty
   */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
   * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
   * @param item the item to be added to the queue
   */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("1c1vU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6812b4e272acbb6a$export$2e2bcd8739ae039);

var $blI7e = parcelRequire("blI7e");

var $hsPKy = parcelRequire("hsPKy");
class $6812b4e272acbb6a$export$2e2bcd8739ae039 extends (0, $blI7e.default) {
    static #_ = this.storageKey = 'lastUsed';
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$6812b4e272acbb6a$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
   * Enqueue the supplied item and also persist the new contents of the queue to storage.
   *
   * @param item the item to be enqueued
   */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
   */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
   * Initialise the queue contents from the configured Storage. If there is no data found in
   * storage then the queue will have no items added. Likewise, a failure to read or parse stored
   * data will be swallowed and no items are added to the queue.
   */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $hsPKy.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
   * Save the current items in the queue, overwriting any previously stored queue.
   * Any failure in saving will be silently ignored with the likely outcome that any previous
   * saved items will remain unchanged in storage.
   */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $hsPKy.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});

parcelRegister("fWTVH", function(module, exports) {
$parcel$export(module.exports, "Gateway", () => $3373d7787ad1bbc3$export$a0e1fa6601cae894);
class $3373d7787ad1bbc3$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
   * Run the supplied function if the count of already submitted work allows it. Drop the work
   * if it's not allowed to run.
   *
   * Will return true if the function has been submitted or false if it was not submitted.
   */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});



parcelRegister("eC95f", function(module, exports) {
$parcel$export(module.exports, "default", () => $96725bdf113c17a4$export$2e2bcd8739ae039);

var $bLScU = parcelRequire("bLScU");

var $6AWhp = parcelRequire("6AWhp");

var $2fDPY = parcelRequire("2fDPY");

var $eVOU3 = parcelRequire("eVOU3");

var $ddtT7 = parcelRequire("ddtT7");

var $j8Z78 = parcelRequire("j8Z78");

var $1PflG = parcelRequire("1PflG");

var $hsPKy = parcelRequire("hsPKy");

var $im5mC = parcelRequire("im5mC");

var $lG8wl = parcelRequire("lG8wl");

var $kRAky = parcelRequire("kRAky");

var $iYZBZ = parcelRequire("iYZBZ");

var $76nr7 = parcelRequire("76nr7");
const $96725bdf113c17a4$export$6f3a08dea02a7b2b = 0.95;
class $96725bdf113c17a4$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $6AWhp.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $eVOU3.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $kRAky.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $eVOU3.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $2fDPY.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $76nr7.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $iYZBZ.default)(this.tokenManager);
    }
    /**
   * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
   */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $1PflG.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $1PflG.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
   * Will load media emoji, returning a new EmojiDescription if, for example,
   * the URL has changed.
   */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $j8Z78.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $1PflG.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $hsPKy.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $bLScU.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                mediaClient.file.uploadExternal(upload.dataURL, collectionName, undefined, true).then(({ uploadableFileUpfrontIds: uploadableFileUpfrontIds })=>{
                    const subscription = mediaClient.file.getFileState(uploadableFileUpfrontIds.id, {
                        collectionName: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $96725bdf113c17a4$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing' || state.status === 'processed') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, $hsPKy.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, uploadableFileUpfrontIds.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                }).catch((error)=>{
                    reject(error);
                });
            });
        });
    }
    /**
   * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
   * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
   * completes with failure then the Promise will resolve to false.
   */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $lG8wl.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $im5mC.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $hsPKy.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
   * Calls to site-scoped EmojiResource to delete emoji
   * @param emoji media emoji to delete
   * @returns Promise.resolve() if success and Promise.reject() for failure
   */ deleteEmoji(emoji) {
        if (!(0, $j8Z78.isMediaEmoji)(emoji) && !(0, $ddtT7.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $6AWhp.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("ddtT7", function(module, exports) {
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $73a1f5604a68c794$export$d25a80b2c86d7fdf);

var $5av15 = parcelRequire("5av15");

var $kqmS6 = parcelRequire("kqmS6");
const $73a1f5604a68c794$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $5av15.customCategory) && (0, $kqmS6.hasDataURLImage)(emoji.representation);

});
parcelRegister("kqmS6", function(module, exports) {
$parcel$export(module.exports, "hasDataURLImage", () => $7ead779566d478ea$export$7720a4954d6f75f8);

var $5av15 = parcelRequire("5av15");

var $iK3c6 = parcelRequire("iK3c6");
const $7ead779566d478ea$export$7720a4954d6f75f8 = (rep)=>(0, $iK3c6.isImageRepresentation)(rep) && rep.imagePath.indexOf((0, $5av15.dataURLPrefix)) === 0;

});


parcelRegister("iYZBZ", function(module, exports) {
$parcel$export(module.exports, "maxImageCached", () => $3ff0658b30621ba1$export$887a842045ce5826);
$parcel$export(module.exports, "maxImageSize", () => $3ff0658b30621ba1$export$20a2bfdf672c7448);
$parcel$export(module.exports, "default", () => $3ff0658b30621ba1$export$2e2bcd8739ae039);

var $1PflG = parcelRequire("1PflG");

var $eriBW = parcelRequire("eriBW");

var $hsPKy = parcelRequire("hsPKy");

var $jWs7U = parcelRequire("jWs7U");

var $k11Ic = parcelRequire("k11Ic");

var $hjm38 = parcelRequire("hjm38");

var $4HkZC = parcelRequire("4HkZC");
const $3ff0658b30621ba1$export$887a842045ce5826 = 1000;
const $3ff0658b30621ba1$export$20a2bfdf672c7448 = 10000;
class $3ff0658b30621ba1$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $hsPKy.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $hjm38.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $k11Ic.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $1PflG.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $eriBW.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $eriBW.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return (0, $jWs7U.BrowserCacheStrategy).supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new (0, $jWs7U.BrowserCacheStrategy)(this.mediaImageLoader);
            return new (0, $4HkZC.MemoryCacheStrategy)(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("jWs7U", function(module, exports) {
$parcel$export(module.exports, "BrowserCacheStrategy", () => $6736e5b9d8049161$export$3850f566ce8d817a);

var $1PflG = parcelRequire("1PflG");

var $hsPKy = parcelRequire("hsPKy");

var $k11Ic = parcelRequire("k11Ic");
const $6736e5b9d8049161$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $6736e5b9d8049161$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $hsPKy.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $k11Ic.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $1PflG.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($6736e5b9d8049161$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}

});
parcelRegister("k11Ic", function(module, exports) {
$parcel$export(module.exports, "getRequiredRepresentation", () => $a82ad1f8f771f59a$export$6875157046b6a22d);
const $a82ad1f8f771f59a$export$6875157046b6a22d = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;

});


parcelRegister("hjm38", function(module, exports) {
$parcel$export(module.exports, "default", () => $a61f6cdae62cdd10$export$2e2bcd8739ae039);

var $eendN = parcelRequire("eendN");
const $a61f6cdae62cdd10$var$defaultConcurrentDownloadLimit = 16;
const $a61f6cdae62cdd10$var$backoffMaxDelayInMillis = 600;
const $a61f6cdae62cdd10$var$defaultMaxRetriesOnNotFound = 2;
class $a61f6cdae62cdd10$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $a61f6cdae62cdd10$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $a61f6cdae62cdd10$var$defaultMaxRetriesOnNotFound) {
        return (0, $eendN.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($a61f6cdae62cdd10$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("eendN", function(module, exports) {
$parcel$export(module.exports, "getNaturalImageSize", () => $9befbe08771df6ee$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $9befbe08771df6ee$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $9befbe08771df6ee$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $9befbe08771df6ee$export$f8e7886bc155c2e6);
const $9befbe08771df6ee$var$maxEmojiSizeInBytes = 1048576;
const $9befbe08771df6ee$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $9befbe08771df6ee$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $9befbe08771df6ee$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $9befbe08771df6ee$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $9befbe08771df6ee$var$isWebpSupported;
const $9befbe08771df6ee$export$c5a964eb84c7fca8 = ()=>{
    if ($9befbe08771df6ee$var$isWebpSupported !== undefined) return Promise.resolve($9befbe08771df6ee$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $9befbe08771df6ee$var$isWebpSupported = img.height === 2;
            resolve($9befbe08771df6ee$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $9befbe08771df6ee$export$f8e7886bc155c2e6 = ()=>$9befbe08771df6ee$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});


parcelRegister("4HkZC", function(module, exports) {
$parcel$export(module.exports, "MemoryCacheStrategy", () => $abf4fd723e61ada3$export$b522858a3709f4c);

var $11Qwb = parcelRequire("11Qwb");

var $iezjt = parcelRequire("iezjt");

var $1PflG = parcelRequire("1PflG");

var $hsPKy = parcelRequire("hsPKy");

var $k11Ic = parcelRequire("k11Ic");

var $iYZBZ = parcelRequire("iYZBZ");
class $abf4fd723e61ada3$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $hsPKy.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $11Qwb.LRUMap)((0, $iYZBZ.maxImageCached));
    }
    loadEmoji(emoji, useAlt) {
        const representation = (0, $k11Ic.getRequiredRepresentation)(emoji, useAlt);
        if (!(0, $1PflG.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $iezjt.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $iezjt.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= (0, $iYZBZ.maxImageSize)) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $hsPKy.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}

});
parcelRegister("iezjt", function(module, exports) {
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $1fb548b7a641cbc1$export$f1a89a11f425faaa);

var $2fDPY = parcelRequire("2fDPY");

var $85U1L = parcelRequire("85U1L");

var $1PflG = parcelRequire("1PflG");
const $1fb548b7a641cbc1$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!(0, $1PflG.isMediaRepresentation)(mediaRepresentation) && !(0, $1PflG.isMediaRepresentation)(mediaAltRepresentation)) return emoji;
    const representation = (0, $1PflG.isMediaRepresentation)(mediaRepresentation) ? (0, $85U1L.convertMediaToImageRepresentation)(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = (0, $1PflG.isMediaRepresentation)(mediaAltRepresentation) ? (0, $85U1L.convertMediaToImageRepresentation)(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return (0, $2fDPY.buildEmojiDescriptionWithAltRepresentation)(baseEmoji, altRepresentation);
};

});
parcelRegister("85U1L", function(module, exports) {
$parcel$export(module.exports, "convertMediaToImageRepresentation", () => $3281eda765e6d0b0$export$3197405d49d2e298);
const $3281eda765e6d0b0$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });

});




parcelRegister("76nr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b87c505d90ecf792$export$2e2bcd8739ae039);

var $6AWhp = parcelRequire("6AWhp");
const $b87c505d90ecf792$export$866c20c059277b6 = 30;
class $b87c505d90ecf792$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $b87c505d90ecf792$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $6AWhp.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});




parcelRegister("iVXn1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a69f529741c6fd0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $c5sKT = parcelRequire("c5sKT");

var $lSYBN = parcelRequire("lSYBN");

var $jrhh7 = parcelRequire("jrhh7");

var $3UXic = parcelRequire("3UXic");

var $gtSHE = parcelRequire("gtSHE");

var $xfOMX = parcelRequire("xfOMX");

var $6KLOx = parcelRequire("6KLOx");

var $dnylb = parcelRequire("dnylb");

var $eDH6u = parcelRequire("eDH6u");

var $9ES7w = parcelRequire("9ES7w");
const $2a69f529741c6fd0$export$8f69873d7d6eec35 = (props)=>{
    const { product: product, appearance: appearance, additionalExtensionHandlers: additionalExtensionHandlers = {}, PropsProvider: PropsProvider, contentId: contentId, dataProviders: dataProviders } = props;
    const [sectionsProvider, setSectionsProvider] = (0, $fc4bM.useState)(null);
    const intl = (0, $gpjDl.default)();
    const hubExtensionHandlers = (0, $9ES7w.useHubExtensionHandlers)({
        contentId: contentId,
        PropsProvider: PropsProvider
    });
    const allExtensionHandlers = (0, $fc4bM.useMemo)(()=>{
        return {
            ...hubExtensionHandlers,
            ...additionalExtensionHandlers
        };
    }, [
        hubExtensionHandlers,
        additionalExtensionHandlers
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const loadSectionsProvider = async ()=>{
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $6KLOx.ExtensionMode).RENDERER,
                getSectionExtensionContents: $dnylb.getSectionExtensionContents
            };
            const defaultExtensionInstanceProps = {
                intl: intl,
                contentId: contentId
            };
            const sectionsProviderInstance = await (0, $eDH6u.sectionExtensionProvider)(defaultExtensionProviderProps);
            const sectionsProvider = await sectionsProviderInstance(defaultExtensionInstanceProps);
            setSectionsProvider(sectionsProvider);
        };
        loadSectionsProvider();
    }, [
        contentId,
        intl,
        PropsProvider
    ]);
    const providerFactory = (0, $fc4bM.useMemo)(()=>{
        const factory = dataProviders || (0, $lSYBN.default).create({});
        if (sectionsProvider) factory.setProvider('extensionProvider', Promise.resolve((0, $c5sKT.default)([
            sectionsProvider
        ])));
        return factory;
    }, [
        sectionsProvider,
        dataProviders
    ]);
    const smartCardClient = (0, $fc4bM.useMemo)(()=>new (0, $jrhh7.default)(), []);
    // Use the same document layout as the Help Hub editor within the max-width canvas.
    const useDocumentColumn = product === 'JSM' && appearance === 'max';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $xfOMX.HubRendererWrapperGated), {
        "data-testid": "hub-renderer",
        product: product,
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3UXic.SmartCardProvider), {
        product: product,
        client: smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gtSHE.RendererWithAnalytics), {
        ...props,
        ...useDocumentColumn && {
            appearance: 'full-page',
            allowRendererContainerStyles: true,
            UNSTABLE_allowTableResizing: true,
            UNSTABLE_allowTableAlignment: true
        },
        allowCustomPanels: true,
        media: {
            allowLinking: true
        },
        extensionHandlers: allExtensionHandlers,
        // dataProviders supplies the extension provider factory which enables section extensions to be rendered within the hub
        dataProviders: providerFactory,
        adfStage: "stage0"
    })));
};
var $2a69f529741c6fd0$export$2e2bcd8739ae039 = $2a69f529741c6fd0$export$8f69873d7d6eec35;

});
parcelRegister("c5sKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c21422ebdc4a04c2$export$2e2bcd8739ae039);

var $4L1hQ = parcelRequire("4L1hQ");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles optional explicit resolution, promise racing, and safely discarded rejections.
 */ $c21422ebdc4a04c2$export$2e2bcd8739ae039 = (extensionProviders, { resolveExtension: resolveExtension, resolvePreloadedExtension: resolvePreloadedExtension } = {})=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $4L1hQ.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>{
                var _provider$preload;
                return provider === null || provider === void 0 || (_provider$preload = provider.preload) === null || _provider$preload === void 0 ? void 0 : _provider$preload.call(provider);
            }));
        },
        getPreloadedExtension (type, key) {
            const resolvedExtension = resolvePreloadedExtension === null || resolvePreloadedExtension === void 0 ? void 0 : resolvePreloadedExtension(type, key);
            if (resolvedExtension) return resolvedExtension;
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                var _provider$getPreloade;
                const result = provider === null || provider === void 0 || (_provider$getPreloade = provider.getPreloadedExtension) === null || _provider$getPreloade === void 0 ? void 0 : _provider$getPreloade.call(provider, type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        async getExtension (type, key) {
            const resolvedExtension = await (resolveExtension === null || resolveExtension === void 0 ? void 0 : resolveExtension(type, key));
            if (resolvedExtension) return resolvedExtension;
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("4L1hQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c1a138214e90fe0$export$2e2bcd8739ae039);

var $goi3h = parcelRequire("goi3h");

var $k0pXy = parcelRequire("k0pXy");
const $1c1a138214e90fe0$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $1c1a138214e90fe0$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $goi3h.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $goi3h.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
   * Run a method from the provider which expects to return a single item
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $k0pXy.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
   * Run a method in the provider which expectes to return a list of items
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $goi3h.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $goi3h.getOnlyFulfilled)(results);
        return $1c1a138214e90fe0$var$flatten(fulfilledResults).filter((result)=>result);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeOptionalList = async (methodName, args)=>{
        const providersWithMethod = (await getFulfilledProviders()).filter((provider)=>typeof provider[methodName] === 'function');
        const results = await (0, $goi3h.waitForAllPromises)(providersWithMethod.map(createCallback(methodName, args)));
        const fulfilledResults = (0, $goi3h.getOnlyFulfilled)(results);
        return $1c1a138214e90fe0$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList,
        invokeOptionalList: invokeOptionalList
    };
};

});
parcelRegister("goi3h", function(module, exports) {
$parcel$export(module.exports, "waitForAllPromises", () => $33e7e20868fc1763$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $33e7e20868fc1763$export$b7581cbf0e22e36b);

var $fVanw = parcelRequire("fVanw");
const $33e7e20868fc1763$var$isFullfilled = (result)=>result.status === (0, $fVanw.ResultStatus).FULFILLED;
const $33e7e20868fc1763$var$markFullfilled = (value)=>({
        status: (0, $fVanw.ResultStatus).FULFILLED,
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $33e7e20868fc1763$var$markRejected = (error)=>({
        status: (0, $fVanw.ResultStatus).FAILED,
        reason: error
    });
const $33e7e20868fc1763$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($33e7e20868fc1763$var$markFullfilled).catch($33e7e20868fc1763$var$markRejected)));
};
const $33e7e20868fc1763$export$b7581cbf0e22e36b = (results)=>results.filter($33e7e20868fc1763$var$isFullfilled).map((result)=>result.value); // eslint-disable-next-line @atlaskit/editor/no-re-export
 // eslint-disable-next-line @atlaskit/editor/no-re-export

});
parcelRegister("fVanw", function(module, exports) {
$parcel$export(module.exports, "ResultStatus", () => $ec06286064885360$export$7103a54af3e45080);
var $ec06286064885360$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});

});


parcelRegister("k0pXy", function(module, exports) {
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $ad7dbe9b2b07d236$export$cb8861b0e3f3dd6f);
/**
 * Will resolve on the first fulfilled promise and disregard the remaining ones. Similar to `Promise.race` but won't
 * care about rejected promises.
 * @param promises
 */ const $ad7dbe9b2b07d236$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};

});



parcelRegister("jrhh7", function(module, exports) {
$parcel$export(module.exports, "default", () => $35793ae163244ad0$export$2e2bcd8739ae039);

var $3kCr9 = parcelRequire("3kCr9");

var $6kMSc = parcelRequire("6kMSc");

var $gOLMp = parcelRequire("gOLMp");

var $11Qwb = parcelRequire("11Qwb");

var $80C48 = parcelRequire("80C48");

var $jBHs2 = parcelRequire("jBHs2");

var $fu7F9 = parcelRequire("fu7F9");

var $jW4zs = parcelRequire("jW4zs");

var $jLOTc = parcelRequire("jLOTc");

var $eHf7g = parcelRequire("eHf7g");

var $6XuWH = parcelRequire("6XuWH");

var $dRkX9 = parcelRequire("dRkX9");

var $27j42 = parcelRequire("27j42");

var $gH83t = parcelRequire("gH83t");
const $35793ae163244ad0$var$MAX_BATCH_SIZE = 50;
const $35793ae163244ad0$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $35793ae163244ad0$var$URL_RESPONSE_CACHE_SIZE = 100;
const $35793ae163244ad0$export$d6a66073b5d79eb3 = new (0, $11Qwb.LRUMap)($35793ae163244ad0$var$URL_RESPONSE_CACHE_SIZE);
const $35793ae163244ad0$var$urlResponseInFlightCache = new Map();
class $35793ae163244ad0$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($gOLMp)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $jBHs2.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $jBHs2.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $27j42.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $jBHs2.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $jBHs2.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $27j42.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $jW4zs.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($80C48)))({
            limit: 1,
            interval: $35793ae163244ad0$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6kMSc)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $35793ae163244ad0$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $jLOTc.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $35793ae163244ad0$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $35793ae163244ad0$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $35793ae163244ad0$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gH83t.isSuccessfulResponse)(response) || (0, $6XuWH.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $35793ae163244ad0$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $35793ae163244ad0$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $35793ae163244ad0$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $35793ae163244ad0$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $35793ae163244ad0$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $35793ae163244ad0$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($35793ae163244ad0$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $35793ae163244ad0$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $gH83t.isSuccessfulResponse)(response) || (0, $6XuWH.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $35793ae163244ad0$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $gH83t.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($3kCr9)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $gH83t.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $27j42.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($3kCr9)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gH83t.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $jBHs2.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $jBHs2.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $27j42.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $jBHs2.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response !== null && response !== void 0 && response.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $eHf7g.NetworkError)) return new (0, $fu7F9.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $fu7F9.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $fu7F9.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $fu7F9.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $fu7F9.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $fu7F9.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("3kCr9", function(module, exports) {
// Packages

var $c17Bb = parcelRequire("c17Bb");
function $26d10e1b03a1dec2$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $c17Bb.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $26d10e1b03a1dec2$var$retry;

});
parcelRegister("c17Bb", function(module, exports) {

module.exports = (parcelRequire("d5ayZ"));

});
parcelRegister("d5ayZ", function(module, exports) {

var $ggd4U = parcelRequire("ggd4U");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $ggd4U(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("ggd4U", function(module, exports) {
function $bd6848ff661d1db9$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $bd6848ff661d1db9$var$RetryOperation;
$bd6848ff661d1db9$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$bd6848ff661d1db9$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$bd6848ff661d1db9$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$bd6848ff661d1db9$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$bd6848ff661d1db9$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$bd6848ff661d1db9$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$bd6848ff661d1db9$var$RetryOperation.prototype.start = $bd6848ff661d1db9$var$RetryOperation.prototype.try;
$bd6848ff661d1db9$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$bd6848ff661d1db9$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$bd6848ff661d1db9$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("gOLMp", function(module, exports) {

var $lNhdb = parcelRequire("lNhdb");

var $jqxdR = parcelRequire("jqxdR");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $c3e660f25dfb87b0$var$uniqBy(array, iteratee) {
    return array && array.length ? $jqxdR(array, $lNhdb(iteratee, 2)) : [];
}
module.exports = $c3e660f25dfb87b0$var$uniqBy;

});

parcelRegister("80C48", function(module, exports) {
'use strict';
class $5d4bd9e1edd64af2$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $5d4bd9e1edd64af2$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $5d4bd9e1edd64af2$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $5d4bd9e1edd64af2$var$pThrottle;
module.exports.AbortError = $5d4bd9e1edd64af2$var$AbortError;

});

parcelRegister("jBHs2", function(module, exports) {
$parcel$export(module.exports, "request", () => $f75a548d4901b357$export$b5fe3f66a567bec0);

var $eHf7g = parcelRequire("eHf7g");
const $f75a548d4901b357$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $f75a548d4901b357$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $f75a548d4901b357$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses !== null && statuses !== void 0 && statuses.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $eHf7g.NetworkError)(error);
        throw error;
    }
}

});
parcelRegister("eHf7g", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $b6c73cdf0ac97418$export$bae979e68e4dc802);
class $b6c73cdf0ac97418$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}

});


parcelRegister("fu7F9", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $3e5f0df62e2fe225$export$3e5b797e39668f84);
class $3e5f0df62e2fe225$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("jW4zs", function(module, exports) {
$parcel$export(module.exports, "getResolverUrl", () => $d14279da705e2e13$export$dc37652c1696f231);

var $hzN2E = parcelRequire("hzN2E");
const $d14279da705e2e13$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $hzN2E.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};

});
parcelRegister("hzN2E", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $2136142f2d7e27aa$export$f654b28f82155665);

var $9khMl = parcelRequire("9khMl");
const $2136142f2d7e27aa$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $9khMl.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $9khMl.BaseUrls) ? (0, $9khMl.BaseUrls)[envKey] : (0, $9khMl.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};

});
parcelRegister("9khMl", function(module, exports) {
$parcel$export(module.exports, "prodBaseUrl", () => $d7383f47473a6f3a$export$7469f9cd9cda802c);
$parcel$export(module.exports, "BaseUrls", () => $d7383f47473a6f3a$export$e2b040f052407032);
const $d7383f47473a6f3a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $d7383f47473a6f3a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $d7383f47473a6f3a$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $d7383f47473a6f3a$export$e2b040f052407032 = {
    dev: $d7383f47473a6f3a$var$devBaseUrl,
    development: $d7383f47473a6f3a$var$devBaseUrl,
    stg: $d7383f47473a6f3a$var$stgBaseUrl,
    staging: $d7383f47473a6f3a$var$stgBaseUrl,
    prd: $d7383f47473a6f3a$export$7469f9cd9cda802c,
    prod: $d7383f47473a6f3a$export$7469f9cd9cda802c,
    production: $d7383f47473a6f3a$export$7469f9cd9cda802c
};
var $d7383f47473a6f3a$export$2e2bcd8739ae039 = $d7383f47473a6f3a$export$e2b040f052407032;

});



parcelRegister("jLOTc", function(module, exports) {
$parcel$export(module.exports, "InvalidUrlError", () => $762d95f2c70f11ad$export$19fa02dd69bd4efd);
class $762d95f2c70f11ad$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}

});

parcelRegister("6XuWH", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $d4b37c0500fb92f4$export$b70265791d2079d4);
const $d4b37c0500fb92f4$var$getStatusForNotFoundVisibility = (meta)=>{
    var _meta$requestAccess;
    const accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $d4b37c0500fb92f4$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $d4b37c0500fb92f4$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("27j42", function(module, exports) {
$parcel$export(module.exports, "isErrorResponse", () => $4dde03606e84adc8$export$bea7bee8a87e7c52);
const $4dde03606e84adc8$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("gH83t", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", () => $293280667ed6dde1$export$1b59fe731a28a49d);
const $293280667ed6dde1$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};

});


parcelRegister("3UXic", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", () => $edbcf28e53358771$export$497ecb0280204df4);

var $fc4bM = parcelRequire("fc4bM");

var $eVfhL = parcelRequire("eVfhL");
parcelRequire("UZaDE");
var $6tkGS = parcelRequire("6tkGS");

var $kSVgB = parcelRequire("kSVgB");

var $cSf11 = parcelRequire("cSf11");

var $fu7F9 = parcelRequire("fu7F9");

var $6Ki2B = parcelRequire("6Ki2B");

var $dRkX9 = parcelRequire("dRkX9");

var $jrhh7 = parcelRequire("jrhh7");

var $dyyyQ = parcelRequire("dyyyQ");

var $jm858 = parcelRequire("jm858");

var $gAa0D = parcelRequire("gAa0D");
/**
 * Whether the error represents a URL the resolver does not support. This is an expected,
 * benign outcome (not a real failure) and must not be surfaced as an errored card.
 */ const $edbcf28e53358771$var$isUnsupportedError = (error)=>error.type === 'UnsupportedError' || error.type === 'ResolveUnsupportedError' || error.type === 'SearchUnsupportedError';
function $edbcf28e53358771$export$497ecb0280204df4({ linkNavigation: linkNavigation, storeOptions: storeOptions, bridgeProduct: bridgeProduct, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions, choreographer: choreographer, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct }) {
    const parentContext = (0, $fc4bM.useContext)((0, $gAa0D.SmartCardContext));
    const defaultInitialState = (0, $fc4bM.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $fc4bM.useMemo)(()=>{
        return (0, $6tkGS.default)((0, $dyyyQ.cardReducer), initialState);
    }, [
        initialState
    ]);
    const client = (0, $fc4bM.useMemo)(()=>{
        const c = customClient || new (0, $jrhh7.default)();
        if (product && c.setProduct) c.setProduct(product);
        return c;
    }, [
        customClient,
        product
    ]);
    // Listen for external auth completion events and re-resolve any matching unauthorized cards in this store.
    (0, $fc4bM.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const handler = (event)=>{
            var _detail$extensionKeys;
            const detail = event.detail;
            if (!(detail !== null && detail !== void 0 && (_detail$extensionKeys = detail.extensionKeys) !== null && _detail$extensionKeys !== void 0 && _detail$extensionKeys.length)) return;
            const targetKeys = new Set(detail.extensionKeys);
            const state = store.getState();
            for (const url of Object.keys(state)){
                var _cardState$details;
                const cardState = state[url];
                if (!cardState || cardState.status !== 'unauthorized') continue;
                const cardExtensionKey = (_cardState$details = cardState.details) === null || _cardState$details === void 0 || (_cardState$details = _cardState$details.meta) === null || _cardState$details === void 0 ? void 0 : _cardState$details.key;
                if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                // Fetch fresh data from ORS and dispatch new payload data
                client.fetchData(url, true).then((response)=>{
                    store.dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_RELOADING), {
                        url: url
                    }, response, undefined, undefined, true));
                }, (err)=>{
                    // "Unsupported URL" is a benign, expected resolver outcome (ORS does not
                    // support this link), surfaced as a fatal APIError. Turning it into an
                    // errored card state causes non-flexible SmartLinks to re-throw it to their
                    // error boundary and report it to Sentry. Leave the card in its prior
                    // unauthorized state instead.
                    if (err instanceof (0, $fu7F9.APIError) && $edbcf28e53358771$var$isUnsupportedError(err)) return;
                    store.dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_ERROR), {
                        url: url
                    }, undefined, err, undefined, true));
                });
            }
        };
        window.addEventListener((0, $jm858.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
        return ()=>{
            window.removeEventListener((0, $jm858.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
        };
    }, [
        store,
        client
    ]);
    const providerValue = (0, $fc4bM.useMemo)(()=>{
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, _platform)=>{
            const cardState = (0, $6Ki2B.getUrl)(store, url);
            return cardState.details ? (0, $kSVgB.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            bridgeProduct: bridgeProduct,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions,
            choreographer: choreographer,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
    }, [
        customAuthFlow,
        bridgeProduct,
        client,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        choreographer,
        store,
        xpcProduct,
        xpcSubProduct
    ]);
    const value = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eVfhL)))({}, parentContext || providerValue, {
            ...(0, $dRkX9.fg)('confluence_ep_shim_macro_links_v2') ? {
                linkNavigation: linkNavigation
            } : undefined,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        openPreviewPanel,
        linkNavigation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gAa0D.SmartCardContext).Provider, {
        value: value
    }, children);
}

});
parcelRegister("kSVgB", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $9a8cba86dd254731$export$864b719baf5d744d);

var $YqY0I = parcelRequire("YqY0I");

var $juFVr = parcelRequire("juFVr");

var $6G8gX = parcelRequire("6G8gX");
const $9a8cba86dd254731$var$extractEntityEmbedUrl = (response)=>{
    const entity = (0, $YqY0I.extractEntity)(response);
    return entity && 'liveEmbedUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl) === 'string' ? entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl : undefined;
};
const $9a8cba86dd254731$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $9a8cba86dd254731$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $juFVr.extractPreview)(response === null || response === void 0 ? void 0 : response.data, 'web', iframeUrlType);
};

});
parcelRegister("YqY0I", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $98f6c4bc57c62608$export$8beff7405d020ddf);
const $98f6c4bc57c62608$export$8beff7405d020ddf = (response)=>response === null || response === void 0 ? void 0 : response.entityData;

});

parcelRegister("juFVr", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $2b2970970cd0543d$export$4b0d98b1b7f6d115);

var $8VBY1 = parcelRequire("8VBY1");

var $8BY94 = parcelRequire("8BY94");
const $2b2970970cd0543d$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.preview;
    const isSupported = (0, $8VBY1.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $8BY94.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $8BY94.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};

});
parcelRegister("8VBY1", function(module, exports) {
$parcel$export(module.exports, "extractPlatformIsSupported", () => $35f493997f3a62bb$export$3e8ad908070b68b2);
const $35f493997f3a62bb$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("8BY94", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $efc7a969fed2b210$export$396ba4ef2e37dc65);
const $efc7a969fed2b210$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $efc7a969fed2b210$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});


parcelRegister("6G8gX", function(module, exports) {
$parcel$export(module.exports, "isEntityPresent", () => $5f9f6581fd494237$export$c7168210b81d9383);

var $YqY0I = parcelRequire("YqY0I");
const $5f9f6581fd494237$export$c7168210b81d9383 = (response)=>Boolean((0, $YqY0I.extractEntity)(response));

});


parcelRegister("cSf11", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $db5191faf902361d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $db5191faf902361d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $db5191faf902361d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $db5191faf902361d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $db5191faf902361d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $db5191faf902361d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $db5191faf902361d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $db5191faf902361d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $db5191faf902361d$export$6e470aad5ba8952e = 'pending';
const $db5191faf902361d$export$9a6a932a0a39498e = 'resolving';
const $db5191faf902361d$export$63ec8bc7a8a75482 = 'resolved';
const $db5191faf902361d$export$b8cfaa842c9ab487 = 'reloading';
const $db5191faf902361d$export$6d8ed3f9433dd372 = 'errored';
const $db5191faf902361d$export$cfbbb7126bc8a0c6 = 'fallback';
const $db5191faf902361d$export$76b5c1aca20759c6 = 'preload';
const $db5191faf902361d$export$2c5edb971b673330 = 'metadata';
const $db5191faf902361d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("6Ki2B", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $2cba1cb004251737$export$94df0e59ebebf4a7);
const $2cba1cb004251737$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("dyyyQ", function(module, exports) {
$parcel$export(module.exports, "cardReducer", () => $764c057b5423e277$export$3c7c3113a97b6492);

var $cSf11 = parcelRequire("cSf11");

var $6XuWH = parcelRequire("6XuWH");
const $764c057b5423e277$var$isCardAction = (action)=>{
    return [
        (0, $cSf11.ACTION_PENDING),
        (0, $cSf11.ACTION_RESOLVING),
        (0, $cSf11.ACTION_RESOLVED),
        (0, $cSf11.ACTION_RELOADING),
        (0, $cSf11.ACTION_ERROR),
        (0, $cSf11.ACTION_ERROR_FALLBACK),
        (0, $cSf11.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $764c057b5423e277$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $6XuWH.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $764c057b5423e277$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $cSf11.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $cSf11.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $cSf11.ACTION_RESOLVED:
            return $764c057b5423e277$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $cSf11.ACTION_RELOADING:
            return $764c057b5423e277$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $cSf11.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $cSf11.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $cSf11.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $764c057b5423e277$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$764c057b5423e277$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $764c057b5423e277$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});

parcelRegister("jm858", function(module, exports) {
$parcel$export(module.exports, "SMART_CARD_EXTERNAL_AUTH_EVENT", () => $3056481c0e492277$export$97eec7ea3e925862);
/**
 * This event is intended to be dispatched by code OUTSIDE the SmartCardProvider's React tree
 * (e.g. Post Office flags) when an external auth flow has completed and any matching unauthorized SmartLinks on the page should be refreshed.
 *
 * @example for usage from external source:
 *   window.dispatchEvent(new CustomEvent('atlaskit-smart-card:external-auth-completed', {
 *     detail: { extensionKeys: ['figma-object-provider'] },
 *   }));
 */ const $3056481c0e492277$export$97eec7ea3e925862 = 'atlaskit-smart-card:external-auth-completed';

});

parcelRegister("gAa0D", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $e0401f559f1295a6$export$156b523e63b4f63a);

var $fc4bM = parcelRequire("fc4bM");
const $e0401f559f1295a6$export$156b523e63b4f63a = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
var $e0401f559f1295a6$export$2e2bcd8739ae039 = $e0401f559f1295a6$export$156b523e63b4f63a;

});


parcelRegister("gtSHE", function(module, exports) {
$parcel$export(module.exports, "RendererWithAnalytics", () => $0f30f23a54551fa1$export$af81ffb59b6ef0dd);
$parcel$export(module.exports, "default", () => $0f30f23a54551fa1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ /* eslint-disable @atlaskit/editor/no-re-export */ 
var $avb69 = parcelRequire("avb69");

var $lqFn6 = parcelRequire("lqFn6");
const $0f30f23a54551fa1$export$88530751e3977073 = (0, $avb69.withLazyNodes)((0, $lqFn6.Renderer));
const $0f30f23a54551fa1$export$c49fe2316038f3c2 = (0, $avb69.withLazyNodes)((0, $lqFn6.RendererFunctionalComponent));
const $0f30f23a54551fa1$export$af81ffb59b6ef0dd = (0, $avb69.withLazyNodes)((0, $lqFn6.RendererWithAnalytics));
const $0f30f23a54551fa1$var$RendererWithAnnotationSelection = (0, $avb69.withLazyNodes)((0, $lqFn6.default));
var /**
 * @deprecated Use `Renderer` from `@atlaskit/renderer/default` instead.
 * This export will be removed in December 2026.
 * @see https://hello.atlassian.net/wiki/spaces/EDITOR/pages/7650942996/Moving+to+Synchronous+Rendering+in+Editor+Renderer for more.
 */ $0f30f23a54551fa1$export$2e2bcd8739ae039 = $0f30f23a54551fa1$var$RendererWithAnnotationSelection;

});
parcelRegister("avb69", function(module, exports) {
$parcel$export(module.exports, "withLazyNodes", () => $2825ca3da61194de$export$a9c9d867b49b1b5c);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dQGZg = parcelRequire("dQGZg");
function $2825ca3da61194de$export$a9c9d867b49b1b5c(BaseComponent) {
    const ComponentWithLazyNodes = (props)=>{
        const nodeComponentsWithLazyNodes = (0, $fc4bM.useMemo)(()=>({
                ...(0, $dQGZg.nodeToReact),
                ...props.nodeComponents
            }), [
            props.nodeComponents
        ]);
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $3LM7S.jsx)(BaseComponent, {
            ...props,
            nodeComponents: nodeComponentsWithLazyNodes
        });
    };
    return ComponentWithLazyNodes;
}

});
parcelRegister("dQGZg", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $8fd9d9751f2ace62$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $8fd9d9751f2ace62$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $8fd9d9751f2ace62$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $8fd9d9751f2ace62$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $8fd9d9751f2ace62$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $8fd9d9751f2ace62$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("lIQWN")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("lIQWN")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $fCOgx = parcelRequire("fCOgx");

var $8reIA = parcelRequire("8reIA");

var $kWMiU = parcelRequire("kWMiU");

var $bcN2K = parcelRequire("bcN2K");

var $fUieO = parcelRequire("fUieO");

var $4VU2L = parcelRequire("4VU2L");

var $gCbQi = parcelRequire("gCbQi");

var $3fACb = parcelRequire("3fACb");

var $lIQWN = parcelRequire("lIQWN");

var $hJw7x = parcelRequire("hJw7x");

var $YZCgQ = parcelRequire("YZCgQ");

var $1Z2sX = parcelRequire("1Z2sX");

var $jCySQ = parcelRequire("jCySQ");

var $1toFn = parcelRequire("1toFn");

var $463vm = parcelRequire("463vm");

var $5Ut7t = parcelRequire("5Ut7t");

var $3FbPQ = parcelRequire("3FbPQ");

var $68bBw = parcelRequire("68bBw");

var $1mOhI = parcelRequire("1mOhI");

var $5c5ee = parcelRequire("5c5ee");

var $aEM32 = parcelRequire("aEM32");

var $bNgSZ = parcelRequire("bNgSZ");

var $2xxrU = parcelRequire("2xxrU");

var $hhstU = parcelRequire("hhstU");

var $4fz3H = parcelRequire("4fz3H");

var $i7RMy = parcelRequire("i7RMy");

const $8fd9d9751f2ace62$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("GMLmP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("5jFDz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("kfzfz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("j2OpD")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("fnbXq")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("e9yqP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("35WyX")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("a2TPA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("ljl0j")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("8GTe8")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("kwd7i")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("ieGZY")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("1Lvhm")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("bV6Df")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("8NwJS")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("a2VAt")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("8TPVZ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("jVsxL")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("6JOKo")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("cD0R4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $8fd9d9751f2ace62$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("912OP")).then((mod)=>mod.default),
    loading: ()=>null
});
const $8fd9d9751f2ace62$export$3931063f6a5f290e = {
    blockquote: (0, $fUieO.default),
    bulletList: (0, $gCbQi.default),
    blockCard: $8fd9d9751f2ace62$export$d18ccd25c0d2c6b0,
    caption: (0, $3fACb.default),
    date: $8fd9d9751f2ace62$export$6341f9a885713487,
    decisionItem: $8fd9d9751f2ace62$export$b6f73a2b0b0de599,
    decisionList: $8fd9d9751f2ace62$export$b458dfa720128865,
    doc: (0, $lIQWN.default),
    emoji: $8fd9d9751f2ace62$export$56cc48506ff790a,
    extension: (0, $hJw7x.default),
    bodiedExtension: (0, $4VU2L.default),
    multiBodiedExtension: (0, $68bBw.default),
    extensionFrame: (0, $YZCgQ.default),
    hardBreak: (0, $1Z2sX.default),
    heading: (0, $jCySQ.default),
    inlineCard: $8fd9d9751f2ace62$export$aff6291803939b05,
    inlineExtension: (0, $1toFn.default),
    layoutSection: (0, $5Ut7t.default),
    layoutColumn: (0, $463vm.default),
    listItem: (0, $3FbPQ.default),
    media: $8fd9d9751f2ace62$export$7fc53215244aec38,
    mediaGroup: $8fd9d9751f2ace62$export$d7858be3df00d59,
    mediaInline: $8fd9d9751f2ace62$export$462ea7c2a1c4cb1f,
    mediaSingle: $8fd9d9751f2ace62$export$888d74bc001c3a5d,
    mention: $8fd9d9751f2ace62$export$e891316fea657d90,
    orderedList: (0, $1mOhI.default),
    panel: $8fd9d9751f2ace62$export$2ddb90ad54e5f587,
    panel_c1: $8fd9d9751f2ace62$export$2ddb90ad54e5f587,
    paragraph: (0, $5c5ee.default),
    placeholder: (0, $aEM32.default),
    rule: (0, $bNgSZ.default),
    status: $8fd9d9751f2ace62$export$96e9906d6d93a972,
    taskItem: $8fd9d9751f2ace62$export$27c4189b8be1bf93,
    taskList: $8fd9d9751f2ace62$export$771a55a10b0a40ae,
    table: (0, $2xxrU.default),
    tableCell: (0, $hhstU.TableCell),
    tableHeader: (0, $hhstU.TableHeader),
    tableRow: (0, $4fz3H.default),
    unknownBlock: (0, $i7RMy.default),
    unsupportedBlock: (0, $8reIA.default),
    unsupportedInline: (0, $kWMiU.default),
    expand: $8fd9d9751f2ace62$export$49bd1dfb0ad29c40,
    syncBlock: $8fd9d9751f2ace62$var$SyncBlockLoader,
    bodiedSyncBlock: $8fd9d9751f2ace62$var$BodiedSyncBlock,
    nestedExpand: $8fd9d9751f2ace62$export$49bd1dfb0ad29c40,
    embedCard: $8fd9d9751f2ace62$export$6789d7ecdc77631b,
    blockTaskItem: $8fd9d9751f2ace62$export$27c4189b8be1bf93
};
const $8fd9d9751f2ace62$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $lIQWN.DocWithSelectAllTrap;
    // Custom components provide the node implementations used by the renderer.
    const nodes = {
        ...(0, $bcN2K.isExperimentEnabled)('platform_editor_remove_default_renderer_nodes') ? {} : $8fd9d9751f2ace62$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if (node.type.name === 'codeBlock') {
        if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return nodes.windowedCodeBlock ?? $8fd9d9751f2ace62$export$a22ee8f907eecb5f;
        return nodes.codeBlock ?? $8fd9d9751f2ace62$export$6c415d1fdae3dfdb;
    }
    nodes['multiBodiedExtension'] = (0, $68bBw.default);
    return nodes[node.type.name];
};
const $8fd9d9751f2ace62$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$8fd9d9751f2ace62$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $8fd9d9751f2ace62$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $8fd9d9751f2ace62$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $8fd9d9751f2ace62$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $8fd9d9751f2ace62$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8fd9d9751f2ace62$var$whitespaceRegex = /^\s*$/;
const $8fd9d9751f2ace62$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $8fd9d9751f2ace62$var$isEmojiBlock(node.content);
};
const $8fd9d9751f2ace62$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($8fd9d9751f2ace62$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("fCOgx", function(module, exports) {
"use strict";
var $b601655f89903e0c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $b601655f89903e0c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b601655f89903e0c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b601655f89903e0c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $fc4bM = parcelRequire("fc4bM");

var $dso8W = parcelRequire("dso8W");
var $b601655f89903e0c$var$ALL_INITIALIZERS = [];
var $b601655f89903e0c$var$READY_INITIALIZERS = [];
function $b601655f89903e0c$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $b601655f89903e0c$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $b601655f89903e0c$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $b601655f89903e0c$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $b601655f89903e0c$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $b601655f89903e0c$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $b601655f89903e0c$var$render(loaded, props) {
    return $fc4bM.createElement($b601655f89903e0c$var$resolve(loaded), props);
}
function $b601655f89903e0c$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $b601655f89903e0c$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $b601655f89903e0c$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $b601655f89903e0c$var$READY_INITIALIZERS.push(function() {
        if ($b601655f89903e0c$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $b601655f89903e0c$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $b601655f89903e0c$var$_classCallCheck(this, LoadableComponent);
            var _this = $b601655f89903e0c$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        // renamed from componentWillMount See https://fb.me/react-unsafe-component-lifecycles
        LoadableComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $fc4bM.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($fc4bM.Component), _class.contextTypes = {
        loadable: $dso8W.shape({
            report: $dso8W.func.isRequired
        })
    }, _temp;
}
function $b601655f89903e0c$var$Loadable(opts) {
    return $b601655f89903e0c$var$createLoadableComponent($b601655f89903e0c$var$load, opts);
}
function $b601655f89903e0c$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $b601655f89903e0c$var$createLoadableComponent($b601655f89903e0c$var$loadMap, opts);
}
$b601655f89903e0c$var$Loadable.Map = $b601655f89903e0c$var$LoadableMap;
var $b601655f89903e0c$var$Capture = function(_React$Component2) {
    $b601655f89903e0c$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $b601655f89903e0c$var$_classCallCheck(this, Capture);
        return $b601655f89903e0c$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $fc4bM.Children.only(this.props.children);
    };
    return Capture;
}($fc4bM.Component);
$b601655f89903e0c$var$Capture.propTypes = {
    report: $dso8W.func.isRequired
};
$b601655f89903e0c$var$Capture.childContextTypes = {
    loadable: $dso8W.shape({
        report: $dso8W.func.isRequired
    }).isRequired
};
$b601655f89903e0c$var$Loadable.Capture = $b601655f89903e0c$var$Capture;
function $b601655f89903e0c$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $b601655f89903e0c$var$flushInitializers(initializers);
    });
}
$b601655f89903e0c$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $b601655f89903e0c$var$flushInitializers($b601655f89903e0c$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$b601655f89903e0c$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $b601655f89903e0c$var$flushInitializers($b601655f89903e0c$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $b601655f89903e0c$var$Loadable;

});

parcelRegister("8reIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $47d897686f46eb8f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $014x6 = parcelRequire("014x6");

var $kaFRI = parcelRequire("kaFRI");

var $bcTS3 = parcelRequire("bcTS3");

var $3LeME = parcelRequire("3LeME");

var $kLu6a = parcelRequire("kLu6a");

var $6DM8w = parcelRequire("6DM8w");

var $fbK55 = parcelRequire("fbK55");
const $47d897686f46eb8f$var$blockNodeStyle = /*#__PURE__*/ (0, $jctmk.css)({
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $014x6.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $47d897686f46eb8f$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fbK55.getUnsupportedContent)((0, $kLu6a.unsupportedContentMessages).unsupportedBlockContent, (0, $kLu6a.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $kLu6a.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $fc4bM.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $fc4bM.useCallback)(()=>dispatchAnalyticsEvent && (0, $6DM8w.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $3LeME.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $47d897686f46eb8f$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kaFRI))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $47d897686f46eb8f$var$_default_1 = (0, $fcCIH.default)($47d897686f46eb8f$var$UnsupportedBlockNode);
var $47d897686f46eb8f$export$2e2bcd8739ae039 = $47d897686f46eb8f$var$_default_1;

});
parcelRegister("014x6", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $d71fc7fc4db027c9$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $d71fc7fc4db027c9$export$24495b314f307191);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $d71fc7fc4db027c9$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $d71fc7fc4db027c9$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $d71fc7fc4db027c9$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $d71fc7fc4db027c9$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $d71fc7fc4db027c9$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $d71fc7fc4db027c9$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $d71fc7fc4db027c9$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $d71fc7fc4db027c9$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $d71fc7fc4db027c9$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $d71fc7fc4db027c9$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $d71fc7fc4db027c9$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $d71fc7fc4db027c9$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $d71fc7fc4db027c9$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $d71fc7fc4db027c9$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $d71fc7fc4db027c9$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableContainerBg", () => $d71fc7fc4db027c9$export$d0fb376c4d4be9e2);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $d71fc7fc4db027c9$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $d71fc7fc4db027c9$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $d71fc7fc4db027c9$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $d71fc7fc4db027c9$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorMaxWidthLayoutWidth", () => $d71fc7fc4db027c9$export$c0f7d71e10d277e9);
$parcel$export(module.exports, "akEditorMaxLayoutWidth", () => $d71fc7fc4db027c9$export$45eb0f5135abf6f1);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $d71fc7fc4db027c9$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $d71fc7fc4db027c9$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $d71fc7fc4db027c9$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $d71fc7fc4db027c9$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $d71fc7fc4db027c9$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $d71fc7fc4db027c9$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $d71fc7fc4db027c9$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $d71fc7fc4db027c9$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $d71fc7fc4db027c9$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $d71fc7fc4db027c9$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $d71fc7fc4db027c9$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $d71fc7fc4db027c9$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $d71fc7fc4db027c9$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $d71fc7fc4db027c9$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $d71fc7fc4db027c9$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $d71fc7fc4db027c9$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $d71fc7fc4db027c9$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $d71fc7fc4db027c9$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $d71fc7fc4db027c9$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $d71fc7fc4db027c9$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $d71fc7fc4db027c9$export$e88f6c898960b391);
$parcel$export(module.exports, "layoutBreakpointWidth", () => $d71fc7fc4db027c9$export$e5c605f2b2a12b00);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $d71fc7fc4db027c9$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $d71fc7fc4db027c9$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $d71fc7fc4db027c9$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $d71fc7fc4db027c9$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $d71fc7fc4db027c9$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $d71fc7fc4db027c9$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorFullPageToolbarHeight", () => $d71fc7fc4db027c9$export$d1343597f3b52d83);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $d71fc7fc4db027c9$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $d71fc7fc4db027c9$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $d71fc7fc4db027c9$export$59733a9f61449b25);
$parcel$export(module.exports, "relativeSizeToBaseFontSize", () => $d71fc7fc4db027c9$export$46715ac1fbd9e64e);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $d71fc7fc4db027c9$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $d71fc7fc4db027c9$export$42608c013398a830);

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");
const $d71fc7fc4db027c9$export$fe6b0b821a0e9067 = 16;
const $d71fc7fc4db027c9$export$24495b314f307191 = 13;
const $d71fc7fc4db027c9$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $d71fc7fc4db027c9$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $d71fc7fc4db027c9$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
const $d71fc7fc4db027c9$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $d71fc7fc4db027c9$export$f0e953d95429ca1 = '12px';
const $d71fc7fc4db027c9$export$a309dbdeca0adb1a = '2px 4px';
const $d71fc7fc4db027c9$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $d71fc7fc4db027c9$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $d71fc7fc4db027c9$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $d71fc7fc4db027c9$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $d71fc7fc4db027c9$export$d2715266dd4a1fd1 = 20;
const $d71fc7fc4db027c9$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
const $d71fc7fc4db027c9$export$8dac549e32469ac4 = 1;
const $d71fc7fc4db027c9$export$befaaae517e3d864 = 2;
const $d71fc7fc4db027c9$export$6e1e1996c4e8cc51 = `${$d71fc7fc4db027c9$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #1868DB)"}`;
const $d71fc7fc4db027c9$export$b6a59ac3a19b6343 = `0 0 0 ${$d71fc7fc4db027c9$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #1868DB)"}`;
const $d71fc7fc4db027c9$export$37e178ca41c198ca = `0 0 0 ${$d71fc7fc4db027c9$export$befaaae517e3d864}px ${"var(--ds-border-selected, #1868DB)"}`;
const $d71fc7fc4db027c9$export$4a007c22e25e31f6 = 0.3;
const $d71fc7fc4db027c9$export$f35cc48f3398ab79 = 1;
const $d71fc7fc4db027c9$export$b46cda584c619451 = 2;
const $d71fc7fc4db027c9$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $d71fc7fc4db027c9$export$321ddd2f049dd12 = $d71fc7fc4db027c9$export$6bed85de54b5de42 + 1;
const $d71fc7fc4db027c9$export$daeac9b8422ac3c2 = 2;
const $d71fc7fc4db027c9$export$501d46e11ed5bf73 = 500;
const $d71fc7fc4db027c9$export$6817b4b6a5ef78f1 = 400;
const $d71fc7fc4db027c9$export$93768eb72dec48ce = $d71fc7fc4db027c9$export$501d46e11ed5bf73 + 10;
const $d71fc7fc4db027c9$export$c0aec4e0896849a0 = $d71fc7fc4db027c9$export$93768eb72dec48ce - 5;
const $d71fc7fc4db027c9$export$5886f057e4f21fe4 = $d71fc7fc4db027c9$export$6817b4b6a5ef78f1 + 5;
const $d71fc7fc4db027c9$export$6e85faa46d537a3f = 11;
const $d71fc7fc4db027c9$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $d71fc7fc4db027c9$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $d71fc7fc4db027c9$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $d71fc7fc4db027c9$export$95e9a0285b97474d = '#2C333A';
const $d71fc7fc4db027c9$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
const $d71fc7fc4db027c9$export$76b5e653883e5290 = '3px';
const $d71fc7fc4db027c9$export$d0fb376c4d4be9e2 = '--table-container-bg';
const $d71fc7fc4db027c9$export$6d85fe8177a50c0c = 0.5;
const $d71fc7fc4db027c9$export$fad19f16d3f953a3 = 680;
const $d71fc7fc4db027c9$export$9db045950eedb49f = 760;
const $d71fc7fc4db027c9$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $d71fc7fc4db027c9$export$f580e3d28d0986de = 1800;
const $d71fc7fc4db027c9$export$c0f7d71e10d277e9 = 4000;
const $d71fc7fc4db027c9$export$9d5488b5afad62bf = 1792;
const $d71fc7fc4db027c9$export$45eb0f5135abf6f1 = 4000;
const $d71fc7fc4db027c9$export$37df10057d36a0e5 = 42;
const $d71fc7fc4db027c9$export$437293c5e9fc2703 = 96;
const $d71fc7fc4db027c9$export$6e0f4d52efd3d2d = 32;
const $d71fc7fc4db027c9$export$f222e0c7a2dc5324 = ()=>72;
const $d71fc7fc4db027c9$export$aae87d25ced827bb = 24;
const $d71fc7fc4db027c9$export$cccda66937c91e4c = 600;
const $d71fc7fc4db027c9$export$efe8561bbd3f74d2 = 720;
const $d71fc7fc4db027c9$export$e4d39a9e8607c1d3 = 48;
const $d71fc7fc4db027c9$export$43946f2400ab6f1f = 128;
const $d71fc7fc4db027c9$export$558438ae7fd4b8ce = 12;
const $d71fc7fc4db027c9$export$6beb98d32d4ca149 = 4;
const $d71fc7fc4db027c9$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $d71fc7fc4db027c9$export$5edb4f38c3eacb1a = 1024;
const $d71fc7fc4db027c9$export$e60820063058ed59 = 1.33;
const $d71fc7fc4db027c9$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $d71fc7fc4db027c9$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $d71fc7fc4db027c9$export$fb15fade89f67217 = $d71fc7fc4db027c9$export$f35cc48f3398ab79 * 99;
const $d71fc7fc4db027c9$export$847030921e9d5a40 = 12;
const $d71fc7fc4db027c9$export$40eb41ab799f0329 = 1.714;
const $d71fc7fc4db027c9$export$e271312fc7124aec = '1px';
const $d71fc7fc4db027c9$export$d29cb2c31fcbb7c5 = 2;
const $d71fc7fc4db027c9$export$688a6dc01e760755 = 320;
const $d71fc7fc4db027c9$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $d71fc7fc4db027c9$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $d71fc7fc4db027c9$export$e88f6c898960b391 = $d71fc7fc4db027c9$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $d71fc7fc4db027c9$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $d71fc7fc4db027c9$export$1d0d506416d457f1 = '0.75rem';
const $d71fc7fc4db027c9$export$53030af820b542f5 = '0.75em';
const $d71fc7fc4db027c9$export$e683ef42725d1713 = 680;
const $d71fc7fc4db027c9$export$226c784ba04bd04b = 480;
const $d71fc7fc4db027c9$export$214ff00e5618d86c = 20;
const $d71fc7fc4db027c9$export$c82675fa56f2eefd = '56px';
const $d71fc7fc4db027c9$var$DEFAULT_FONT_SIZE = 14;
const $d71fc7fc4db027c9$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// If value is undefined, assume this is being called outside of the editor.
    isToolbarAIFCEnabled === undefined ? (0, $dRkX9.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $d71fc7fc4db027c9$export$d1343597f3b52d83 = 40;
const $d71fc7fc4db027c9$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $d71fc7fc4db027c9$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $d71fc7fc4db027c9$var$DEFAULT_FONT_SIZE;
const $d71fc7fc4db027c9$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$d71fc7fc4db027c9$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $d71fc7fc4db027c9$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $d71fc7fc4db027c9$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$d71fc7fc4db027c9$export$fe6b0b821a0e9067})`;
};
const $d71fc7fc4db027c9$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $d71fc7fc4db027c9$export$9369fd010fa0ddd6 = 0;
const $d71fc7fc4db027c9$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$d71fc7fc4db027c9$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $d71fc7fc4db027c9$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $d71fc7fc4db027c9$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
const $d71fc7fc4db027c9$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});
parcelRegister("kaRof", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $f02357c90b0db8b1$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $k2M4v = parcelRequire("k2M4v");

var $2Eign = parcelRequire("2Eign");

var $btIgm = parcelRequire("btIgm");

var $02SZ7 = parcelRequire("02SZ7");
const $f02357c90b0db8b1$var$EDITOR_CONTROLS_EXPERIMENT = 'platform_editor_controls';
const $f02357c90b0db8b1$var$EDITOR_CONTROLS_OTHER_APPS_KILL_SWITCH = 'platform_editor_controls_other_apps_ks';
/**
 * Resolves the `platform_editor_controls` cohort while the experiment is being cleaned up.
 *
 * - Confluence and Jira always get `variant1`. Their product code has been cleaned up to always
 *   behave as `variant1` (EDITOR-9269, EDITOR-9270), so the editor must agree with it.
 * - Every other app (no product, or a product without a product key such as Bitbucket) gets
 *   `variant1` unless the kill switch `platform_editor_controls_other_apps_ks` passes for that app,
 *   in which case it gets `control`. The kill switch defaults to false, so controls are on by
 *   default. Its exposure always fires so Statsig shows which apps run this code.
 * - Before the Statsig client is initialised, other apps get the experiment's default value.
 * - The `test` product keeps the experiment's default value.
 *
 * Remove together with the experiment in EDITOR-9262.
 */ function $f02357c90b0db8b1$var$getEditorControlsCohort(defaultValue) {
    if ((0, $02SZ7._product) === 'confluence' || (0, $02SZ7._product) === 'jira') return 'variant1';
    if ((0, $02SZ7._product) === 'test') return defaultValue;
    if (!(0, $k2M4v.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    return (0, $k2M4v.default).checkGate($f02357c90b0db8b1$var$EDITOR_CONTROLS_OTHER_APPS_KILL_SWITCH, {
        fireGateExposure: true
    }) ? 'control' : 'variant1';
}
function $f02357c90b0db8b1$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    var _experimentConfig$pro;
    const experimentConfig = (0, $btIgm.editorExperimentsConfig)[experimentName];
    if ((0, $02SZ7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $02SZ7._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (experimentName === $f02357c90b0db8b1$var$EDITOR_CONTROLS_EXPERIMENT) {
        const cohort = $f02357c90b0db8b1$var$getEditorControlsCohort(experimentConfig.defaultValue);
        (0, $2Eign.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, cohort);
        return cohort === expectedExperimentValue;
    }
    if (!(0, $02SZ7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $02SZ7._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $btIgm.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $k2M4v.default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    (0, $2Eign.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}

});


parcelRegister("kaFRI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaf53765d3edf95c$var$_react = $eaf53765d3edf95c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $eaf53765d3edf95c$var$_iconNew = $eaf53765d3edf95c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $eaf53765d3edf95c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eaf53765d3edf95c$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $eaf53765d3edf95c$var$_react.default.createElement($eaf53765d3edf95c$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$eaf53765d3edf95c$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $eaf53765d3edf95c$var$_default = module.exports.default = $eaf53765d3edf95c$var$QuestionCircleIcon;

});

parcelRegister("3LeME", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $278baeea7fe1bbfb$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $278baeea7fe1bbfb$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $278baeea7fe1bbfb$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "MEDIA_INSERT_TAB", () => $278baeea7fe1bbfb$export$9395e0d0ae49956f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $278baeea7fe1bbfb$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $278baeea7fe1bbfb$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $278baeea7fe1bbfb$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $278baeea7fe1bbfb$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $278baeea7fe1bbfb$export$9f0b2adf3cfd71b7);
var $278baeea7fe1bbfb$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $278baeea7fe1bbfb$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["ADOPTED"] = "adopted";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARD_ALL"] = "discardAll";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DIVERGED"] = "diverged";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EMPTY_STATE_EXPOSED"] = "emptyStateExposed";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["GENERATED"] = "generated";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INSERT_ATTEMPTED"] = "insertAttempted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIMITED_MODE_LATCHED"] = "limitedModeLatched";
    ACTION["LANGUAGE_AUTO_DETECTED"] = "languageAutoDetected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["ACCEPTED"] = "accepted";
    ACTION["NO_DIFF_FOUND"] = "noDiffFound";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["QUICK_INSERT_INFORMATION"] = "quickInsertInformation";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REGENERATION_COMPLETED"] = "regenerationCompleted";
    ACTION["REGENERATION_STARTED"] = "regenerationStarted";
    ACTION["RIGHT_RAIL_CLOSED"] = "rightRailClosed";
    ACTION["RIGHT_RAIL_VIEWED"] = "rightRailViewed";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["SEARCHED"] = "searched";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["RENDERED"] = "rendered";
    ACTION["REASONING_VIEWED"] = "reasoningViewed";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["CONTAINER_NODE_TRANSFORMED"] = "containerNodeTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["AGENT_EDIT_SHIMMER_NOT_SHOWN"] = "agentEditShimmerNotShown";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_FOLDING"] = "toggleCodeFolding";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TOGGLE_CODE_BLOCK_LINE_NUMBERS"] = "toggleCodeBlockLineNumbers";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["LOCAL_IDS_REPAIRED"] = "localIdsRepaired";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    // fired when the on-device autocomplete LLM finishes loading/starting
    ACTION["LOCAL_MODEL_LOADED"] = "localModelLoaded";
    // fired when the on-device autocomplete LLM fails to load/start
    ACTION["LOCAL_MODEL_LOAD_FAILED"] = "localModelLoadFailed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $278baeea7fe1bbfb$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    INPUT_METHOD["REMIX"] = "remix";
    INPUT_METHOD["REMIX_FROM_MEDIA_INSERTS"] = "remixFromMediaInserts";
    return INPUT_METHOD;
}({});
var $278baeea7fe1bbfb$export$9395e0d0ae49956f = /*#__PURE__*/ function(MEDIA_INSERT_TAB) {
    MEDIA_INSERT_TAB["CREATE"] = "create";
    MEDIA_INSERT_TAB["LINK"] = "link";
    MEDIA_INSERT_TAB["UPLOAD"] = "upload";
    return MEDIA_INSERT_TAB;
}({});
var $278baeea7fe1bbfb$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $278baeea7fe1bbfb$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $278baeea7fe1bbfb$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DIVIDER"] = "divider";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["EXTENSION_AS_INLINE"] = "extensionAsInline";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HEADING"] = "heading";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["NUMBERED_HEADINGS"] = "numberedHeadings";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["INLINE_COMMENT_TOOLBAR"] = "inlineCommentToolbar";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["AI_SUGGESTIONS"] = "aiSuggestions";
    ACTION_SUBJECT["CONTEXTUAL_TYPEAHEAD"] = "contextualTypeahead";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    ACTION_SUBJECT["NATIVE_EMBED_FALLBACK"] = "nativeEmbedFallback";
    return ACTION_SUBJECT;
}({});
var $278baeea7fe1bbfb$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_REMIX_BUTTON"] = "aiRemixButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CONVERSATION_ERROR"] = "conversationError";
    ACTION_SUBJECT_ID["SUGGESTIONS_REGENERATION"] = "suggestionsRegeneration";
    ACTION_SUBJECT_ID["SUGGESTIONS_REGENERATION_ERROR"] = "suggestionsRegenerationError";
    ACTION_SUBJECT_ID["SUGGESTIONS_ERROR_RETRY"] = "suggestionsErrorRetry";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LAYOUT_COLUMN"] = "layoutColumn";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_ADD_CONTENT"] = "syncedBlockAddContent";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_INFO_ORPHANED"] = "syncedBlockSourceInfoOrphaned";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CACHE_DELETION_FORCED"] = "syncedBlockCacheDeletionForced";
    ACTION_SUBJECT_ID["UNSUPPORTED_SURFACE"] = "unsupportedSurface";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    ACTION_SUBJECT_ID["SNIPPET"] = "snippet";
    return ACTION_SUBJECT_ID;
}({});
var $278baeea7fe1bbfb$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $278baeea7fe1bbfb$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("kLu6a", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $6dc5f64847b8265e$export$32ec96484dd3ba39);

var $8p5Cv = parcelRequire("8p5Cv");
const $6dc5f64847b8265e$export$32ec96484dd3ba39 = (0, $8p5Cv.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'The text is shown as an inline label in the editor when a content node type is not supported for display. It appears alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'The text is shown as a block-level message in the editor when a content block type is not supported for display. It appears centered within a dashed border container alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'The text is shown as tooltip content when the user hovers over the question mark icon on an unsupported content node in the editor. It reassures users that unsupported content will not be lost when they edit and save the document.'
    }
});

});

parcelRegister("6DM8w", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $c88269639d338aa8$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $c88269639d338aa8$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $c88269639d338aa8$export$3a34598135e7219b);

var $3LeME = parcelRequire("3LeME");
const $c88269639d338aa8$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $c88269639d338aa8$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c88269639d338aa8$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $c88269639d338aa8$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $c88269639d338aa8$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$c88269639d338aa8$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $c88269639d338aa8$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $3LeME.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $c88269639d338aa8$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $c88269639d338aa8$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $3LeME.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $c88269639d338aa8$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $3LeME.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $3LeME.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $3LeME.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $c88269639d338aa8$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$c88269639d338aa8$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $c88269639d338aa8$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $c88269639d338aa8$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $c88269639d338aa8$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $c88269639d338aa8$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $3LeME.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $c88269639d338aa8$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $c88269639d338aa8$var$trackUnsupportedContentTooltipActionFor((0, $3LeME.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("fbK55", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $98d9cc5baae7e8bf$export$d4ded51d0f0bd2df);
function $98d9cc5baae7e8bf$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("kWMiU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9382613c490b3336$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $014x6 = parcelRequire("014x6");

var $kaFRI = parcelRequire("kaFRI");

var $bcTS3 = parcelRequire("bcTS3");

var $3LeME = parcelRequire("3LeME");

var $kLu6a = parcelRequire("kLu6a");

var $6DM8w = parcelRequire("6DM8w");

var $fbK55 = parcelRequire("fbK55");
const $9382613c490b3336$var$inlineNodeStyle = /*#__PURE__*/ (0, $jctmk.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $014x6.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $9382613c490b3336$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fbK55.getUnsupportedContent)((0, $kLu6a.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $kLu6a.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $fc4bM.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $fc4bM.useCallback)(()=>dispatchAnalyticsEvent && (0, $6DM8w.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $3LeME.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: $9382613c490b3336$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kaFRI))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $9382613c490b3336$var$_default_1 = (0, $fcCIH.default)($9382613c490b3336$var$UnsupportedInlineNode);
var $9382613c490b3336$export$2e2bcd8739ae039 = $9382613c490b3336$var$_default_1;

});

parcelRegister("fUieO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6c3324a8295b395$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $f6c3324a8295b395$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("blockquote", {
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("4VU2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b37f6420c25c52d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $3LeME = parcelRequire("3LeME");

var $8EvCx = parcelRequire("8EvCx");

var $eDhBT = parcelRequire("eDhBT");

var $seKqV = parcelRequire("seKqV");

var $4h8CP = parcelRequire("4h8CP");

var $5XiSC = parcelRequire("5XiSC");

var $gZRzj = parcelRequire("gZRzj");

var $hJw7x = parcelRequire("hJw7x");

var $5mJkS = parcelRequire("5mJkS");

var $iGevH = parcelRequire("iGevH");

var $h4qU2 = parcelRequire("h4qU2");
const $9b37f6420c25c52d$var$BodiedExtensionContent = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, fireAnalyticsEvent: fireAnalyticsEvent } = props;
    const presetOptions = props.scheduleExtensionHeightRemoval ? {
        height: props.nodePresetHeight
    } : {};
    const presetMinHeight = props.scheduleExtensionHeightRemoval ? props.nodePresetMinHeight : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $fc4bM.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5XiSC.ErrorBoundary), {
        component: (0, $eDhBT.ACTION_SUBJECT).RENDERER,
        componentId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $seKqV.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gZRzj.ValidationContextProvider), {
                value: validationContextValue,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4h8CP.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ node: node, result: result })=>{
                        if (localId && extensionType === 'com.atlassian.ecosystem' && (0, $iGevH.FORGE_BODIED_EXTENSION_HANDOFF_KEYS).has(extensionKey) && !(shouldDisplayExtensionAsInline !== null && shouldDisplayExtensionAsInline !== void 0 && shouldDisplayExtensionAsInline(node)) && (0, $8EvCx.expVal)('cc_aura_table_filter_cls', 'isEnabled', false)) return (0, $hJw7x.renderExtension)(/*#__PURE__*/ (0, $3LM7S.jsx)((0, $5mJkS.default), {
                            localId: localId,
                            fallback: children,
                            result: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(result) ? result : null
                        }, localId), layout, {
                            isTopLevel: path.length < 1,
                            rendererAppearance: props.rendererAppearance,
                            fireAnalyticsEvent: fireAnalyticsEvent
                        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $hJw7x.renderExtension)(result, layout, {
                                ...presetOptions,
                                isTopLevel: path.length < 1,
                                rendererAppearance: props.rendererAppearance,
                                fireAnalyticsEvent: fireAnalyticsEvent
                            }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, presetMinHeight, localId, shouldDisplayExtensionAsInline, node);
                        } catch  {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $hJw7x.renderExtension)(children, layout, {
                            ...presetOptions,
                            isTopLevel: path.length < 1,
                            rendererAppearance: props.rendererAppearance,
                            fireAnalyticsEvent: fireAnalyticsEvent
                        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, presetMinHeight, localId, shouldDisplayExtensionAsInline, node);
                    }
                })
            })
        })
    });
};
const $9b37f6420c25c52d$var$BodiedExtensionWithTemporarySizing = (props)=>{
    var _props$parameters;
    const { presetMinHeight: presetMinHeight, presetHeight: presetHeight, hasExpired: hasExpired } = (0, $h4qU2.useNodeHeight)({
        nodePresetMinHeight: props.nodePresetMinHeight,
        node: props.extensionNode,
        scheduleRemoval: props.scheduleExtensionHeightRemoval,
        nodePresetHeight: props.nodePresetHeight,
        hasViewportSize: (0, $hJw7x.hasExtensionViewportSize)((_props$parameters = props.parameters) === null || _props$parameters === void 0 ? void 0 : _props$parameters.extensionId, props.extensionViewportSizes)
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($9b37f6420c25c52d$var$BodiedExtensionContent, {
        ...props,
        nodePresetMinHeight: presetMinHeight,
        nodePresetHeight: presetHeight,
        extensionViewportSizes: hasExpired || presetHeight !== undefined ? undefined : props.extensionViewportSizes
    });
};
const $9b37f6420c25c52d$var$BodiedExtension = (props)=>{
    if (props.scheduleExtensionHeightRemoval) // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)($9b37f6420c25c52d$var$BodiedExtensionWithTemporarySizing, {
        ...props
    });
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)($9b37f6420c25c52d$var$BodiedExtensionContent, {
        ...props
    });
};
var $9b37f6420c25c52d$export$2e2bcd8739ae039 = $9b37f6420c25c52d$var$BodiedExtension;

});
parcelRegister("eDhBT", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $0fc8805b3b6e9b6b$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $0fc8805b3b6e9b6b$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $0fc8805b3b6e9b6b$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $0fc8805b3b6e9b6b$export$9957974f8b4d8f74);
var $0fc8805b3b6e9b6b$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $0fc8805b3b6e9b6b$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $0fc8805b3b6e9b6b$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $0fc8805b3b6e9b6b$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_DOWNLOAD"] = "codeBlockDownload";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("seKqV", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $8bd2b4466c3d6bc1$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $8bd2b4466c3d6bc1$export$cef0157dd42cbb3f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $jEubQ = parcelRequire("jEubQ");

var $lk7ff = parcelRequire("lk7ff");

var $85PxU = parcelRequire("85PxU");

var $kvlmJ = parcelRequire("kvlmJ");

var $9Xm1T = parcelRequire("9Xm1T");

var $gF12C = parcelRequire("gF12C");

var $2x3iO = parcelRequire("2x3iO");

var $kMeXA = parcelRequire("kMeXA");

var $hTXdp = parcelRequire("hTXdp");
const $8bd2b4466c3d6bc1$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $2x3iO.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $8bd2b4466c3d6bc1$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext({
    startPos: 1
});
const $8bd2b4466c3d6bc1$export$7121915072388536 = (props)=>{
    var _providers$inlineComm, _providers$inlineComm2;
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $fc4bM.useContext)((0, $lk7ff.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $gF12C.useAnnotationStateByTypeEvent)({
        type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lk7ff.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9Xm1T.AnnotationRangeProvider), {
            allowCommentsOnMedia: (providers === null || providers === void 0 || (_providers$inlineComm = providers.inlineComment) === null || _providers$inlineComm === void 0 ? void 0 : _providers$inlineComm.allowCommentsOnMedia) ?? false,
            hasBlockNodeSupport: Boolean(providers === null || providers === void 0 || (_providers$inlineComm2 = providers.inlineComment) === null || _providers$inlineComm2 === void 0 ? void 0 : _providers$inlineComm2.isBlockNodeSupported),
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $85PxU.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $hTXdp.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)($8bd2b4466c3d6bc1$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kMeXA.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $8bd2b4466c3d6bc1$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider !== null && annotationProvider !== void 0 && annotationProvider.annotationManager) {
        var _annotationProvider$i;
        // We need to ensure there is a single instance of the annotation manager for the whole document
        // and that it is the same instance for all annotations.
        // This is because the annotation manager is responsible for managing the state of ALL annotations.
        // This includes annotations inside extensions.
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lk7ff.ProvidersContext).Provider, {
            value: annotationProvider,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kvlmJ.AnnotationManagerProvider), {
                annotationManager: annotationProvider.annotationManager,
                updateSubscriber: (annotationProvider === null || annotationProvider === void 0 || (_annotationProvider$i = annotationProvider.inlineComment) === null || _annotationProvider$i === void 0 ? void 0 : _annotationProvider$i.updateSubscriber) ?? undefined,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)($8bd2b4466c3d6bc1$export$7121915072388536, {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    isNestedRender: isNestedRender,
                    onLoadComplete: onLoadComplete,
                    children: children
                })
            })
        });
    } else return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lk7ff.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($8bd2b4466c3d6bc1$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("6DAwh", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $e31d67c4f6b89289$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $e31d67c4f6b89289$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $e31d67c4f6b89289$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $e31d67c4f6b89289$export$8512c9afa7b24c3b);

var $8oMY3 = parcelRequire("8oMY3");
var $e31d67c4f6b89289$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $e31d67c4f6b89289$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e31d67c4f6b89289$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $e31d67c4f6b89289$export$8512c9afa7b24c3b = (0, $8oMY3.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$e31d67c4f6b89289$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});
parcelRegister("8oMY3", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $356fcced894fc576$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $356fcced894fc576$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $356fcced894fc576$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $356fcced894fc576$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $356fcced894fc576$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $356fcced894fc576$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $356fcced894fc576$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $356fcced894fc576$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $356fcced894fc576$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $356fcced894fc576$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $356fcced894fc576$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $356fcced894fc576$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $356fcced894fc576$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $356fcced894fc576$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $356fcced894fc576$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $356fcced894fc576$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $356fcced894fc576$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $356fcced894fc576$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $356fcced894fc576$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $356fcced894fc576$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $356fcced894fc576$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $jgGEA = parcelRequire("jgGEA");
const $356fcced894fc576$export$8e53000a4ec837 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $356fcced894fc576$export$8512c9afa7b24c3b = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $356fcced894fc576$export$8c5a050822fd698c = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $356fcced894fc576$export$1edee58a52776cd9 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $356fcced894fc576$export$89015c65f1c75e3f = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $356fcced894fc576$export$6565f9f03506010b = (0, $jgGEA.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $356fcced894fc576$export$f3b72f8fc4684ecd = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $356fcced894fc576$export$3024f02c495408d6 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $356fcced894fc576$export$c63c6f932822f543 = (0, $jgGEA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $356fcced894fc576$export$85e3c3ca0c6fb93 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $356fcced894fc576$export$f00aeb236b6f05af = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $356fcced894fc576$export$480c699bd4ec0d86 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $356fcced894fc576$export$9c30223ca0a664fb = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $356fcced894fc576$export$4899a95d70ec5056 = (0, $jgGEA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $356fcced894fc576$export$59ae2c325a998f89 = (0, $jgGEA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $356fcced894fc576$export$b3401ee80eb31041 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $356fcced894fc576$export$32f78bffcd82ff28 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $356fcced894fc576$export$20af3dabbb5538df = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $356fcced894fc576$export$425327af25286e5e = (0, $jgGEA.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $356fcced894fc576$export$30d78d5eb6719bb8 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $356fcced894fc576$export$a316dc07ff5182a2 = (0, $jgGEA.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});
parcelRegister("jgGEA", function(module, exports) {
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $2db2c7cd62af2a34$export$cf5823ed4e9f4c6f);
const $2db2c7cd62af2a34$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("lk7ff", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $2e030828d13f0b41$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $2e030828d13f0b41$export$aafe46a36ef535ba);

var $fc4bM = parcelRequire("fc4bM");
const $2e030828d13f0b41$export$6a26b015ac619737 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $2e030828d13f0b41$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $fc4bM.createContext)({});

});

parcelRegister("85PxU", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $1fb0d4db114c6bf7$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $1fb0d4db114c6bf7$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $1fb0d4db114c6bf7$export$c288883964405c82);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $1fb0d4db114c6bf7$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    isWithinRange: false
});
const $1fb0d4db114c6bf7$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $1fb0d4db114c6bf7$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $fc4bM.useState)(false);
    const timeoutHandler = (0, $fc4bM.useRef)();
    const cancelTimeout = (0, $fc4bM.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $fc4bM.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $fc4bM.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $fc4bM.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($1fb0d4db114c6bf7$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($1fb0d4db114c6bf7$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $1fb0d4db114c6bf7$export$a02bfcbbbf920306 = ()=>{
    return (0, $fc4bM.useContext)($1fb0d4db114c6bf7$var$AnnotationHoverStateContext);
};
const $1fb0d4db114c6bf7$export$c288883964405c82 = ()=>{
    return (0, $fc4bM.useContext)($1fb0d4db114c6bf7$var$AnnotationHoverDispatchContext);
};

});

parcelRegister("kvlmJ", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $19696f21fe9e8f6c$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $19696f21fe9e8f6c$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $19696f21fe9e8f6c$export$12cbbb89fb7702d0);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $aoZ67 = parcelRequire("aoZ67");

var $2bxGO = parcelRequire("2bxGO");
const $19696f21fe9e8f6c$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $19696f21fe9e8f6c$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $fc4bM.createContext)($19696f21fe9e8f6c$var$initState);
const $19696f21fe9e8f6c$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $19696f21fe9e8f6c$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$19696f21fe9e8f6c$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    var _state$annotations$id, _state$annotations$id2;
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && ((_state$annotations$id = state.annotations[id]) === null || _state$annotations$id === void 0 ? void 0 : _state$annotations$id.markState) === (0, $6DAwh.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $6DAwh.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!(loadedAnnotation !== null && loadedAnnotation !== void 0 && loadedAnnotation.markState) && ((_state$annotations$id2 = state.annotations[id]) === null || _state$annotations$id2 === void 0 ? void 0 : _state$annotations$id2.markState) !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current === null || current === void 0 ? void 0 : current.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $6DAwh.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if ((current === null || current === void 0 ? void 0 : current.markState) !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $6DAwh.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $6DAwh.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $19696f21fe9e8f6c$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $fc4bM.useReducer)($19696f21fe9e8f6c$var$reducer, $19696f21fe9e8f6c$var$initState);
    const actionContext = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    (0, $fc4bM.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('getDraft', getDraft);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $fc4bM.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            var _state$annotations;
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!((_state$annotations = state.annotations) !== null && _state$annotations !== void 0 && _state$annotations[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- resolve mark node by id in the document
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $fc4bM.useRef)(undefined);
    (0, $fc4bM.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            var _state$annotations2;
            if (!((_state$annotations2 = state.annotations) !== null && _state$annotations2 !== void 0 && _state$annotations2[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            var _state$annotations3;
            if (!((_state$annotations3 = state.annotations) !== null && _state$annotations3 !== void 0 && _state$annotations3[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $6DAwh.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $fc4bM.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $6DAwh.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $fc4bM.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($19696f21fe9e8f6c$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($19696f21fe9e8f6c$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $19696f21fe9e8f6c$export$654a1fb45487f838 = ()=>{
    return (0, $fc4bM.useContext)($19696f21fe9e8f6c$var$AnnotationManagerStateContext);
};
const $19696f21fe9e8f6c$export$12cbbb89fb7702d0 = ()=>{
    return (0, $fc4bM.useContext)($19696f21fe9e8f6c$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("aoZ67", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $a96f425891f5093d$export$c1c4b33b4e7b1c70);

var $hylEy = parcelRequire("hylEy");
var $a96f425891f5093d$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $a96f425891f5093d$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hylEy)))();
    }
}

});

parcelRegister("2bxGO", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $e75f5b0ce4e8beaa$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $e75f5b0ce4e8beaa$export$66feffbad722f9d4);
/* eslint-disable jsdoc/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $38vAg = parcelRequire("38vAg");

var $jEubQ = parcelRequire("jEubQ");

var $3LeME = parcelRequire("3LeME");

var $dRkX9 = parcelRequire("dRkX9");

var $626rq = parcelRequire("626rq");

var $e9N5Z = parcelRequire("e9N5Z");
const $e75f5b0ce4e8beaa$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(new (0, $626rq.default)());
function $e75f5b0ce4e8beaa$export$66feffbad722f9d4({ children: children, context: context, includeLegacyContentAnnotations: includeLegacyContentAnnotations }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const actions = (0, $fc4bM.useMemo)(()=>new (0, $626rq.default)(true), []);
    const inheritedIncludeLegacyContentAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $e9N5Z.IncludeLegacyContentAnnotationsContext));
    const shouldIncludeLegacyContentAnnotations = includeLegacyContentAnnotations ?? inheritedIncludeLegacyContentAnnotations;
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.count(children) > 1 && (0, $dRkX9.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $38vAg.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e9N5Z.IncludeLegacyContentAnnotationsContext).Provider, {
        value: shouldIncludeLegacyContentAnnotations,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($e75f5b0ce4e8beaa$export$1e9ea4edb6d1bfe6.Provider, {
            value: context || actions,
            children: (0, $dRkX9.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(children) : children
        })
    });
}
const $e75f5b0ce4e8beaa$export$d5fcf151601331bc = $e75f5b0ce4e8beaa$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("626rq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4156cb2711d4501c$export$2e2bcd8739ae039);

var $6DAwh = parcelRequire("6DAwh");

var $3LeME = parcelRequire("3LeME");

var $f1MDe = parcelRequire("f1MDe");

var $f7AYl = parcelRequire("f7AYl");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $cNUap = parcelRequire("cNUap");

var $17pA6 = parcelRequire("17pA6");

var $5pBjL = parcelRequire("5pBjL");

var $d3z80 = parcelRequire("d3z80");

var $9Nj04 = parcelRequire("9Nj04");
class $4156cb2711d4501c$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.includeLegacyContentAnnotations = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $f7AYl.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent, includeLegacyContentAnnotations = false) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
        this.includeLegacyContentAnnotations = includeLegacyContentAnnotations;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
        this.includeLegacyContentAnnotations = false;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $801jp.TextSelection).create(this.doc, from, to);
        if ((0, $f1MDe.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $f1MDe.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        const schema = this.schema;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && (0, $d3z80.isBlockAnnotationTarget)(node, schema)) nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $k2WVn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $k2WVn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $3LeME.ACTION).DELETED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $k2WVn.RemoveMarkStep) ? (0, $5pBjL.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cNUap.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cNUap.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (this.isInsideNestedExtensionRenderer(startContainer) || this.isInsideNestedExtensionRenderer(endContainer)) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    /**
   * A range only threatens a nested renderer's own document (e.g. a bodiedExtension's macro
   * body, which renders its own nested `<Renderer>`) when it sits inside that nested renderer's
   * `.ak-renderer-document`. Landing directly on the extension's own outer wrapper -- with no
   * nested document in between -- must stay annotatable so the whole chart/extension can be
   * targeted (MAUI-1256), rather than being rejected outright the way any range touching
   * `.ak-renderer-extension` previously was.
   *
   * Behind `cc_maui_annotations_on_extensions` -- the same gate MAUI-1255 added for extension
   * node-mark support -- to preserve the previous behaviour (reject anything touching
   * `.ak-renderer-extension`) while the feature is off.
   */ isInsideNestedExtensionRenderer(container) {
        // Preserve the legacy parent-based rejection while the gate is disabled.
        if (!(0, $dRkX9.fg)('cc_maui_annotations_on_extensions')) {
            var _container$parentElem;
            return !!((_container$parentElem = container.parentElement) !== null && _container$parentElem !== void 0 && _container$parentElem.closest('.ak-renderer-extension'));
        }
        const element = container instanceof Element ? container : container.parentElement;
        if (!element) return false;
        const extensionAncestor = element.closest('.ak-renderer-extension');
        if (!extensionAncestor) return false;
        const nestedDocument = element.closest('.ak-renderer-document');
        return !!nestedDocument && extensionAncestor.contains(nestedDocument);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cNUap.getPosFromRange)(range);
    }
    getSelectionContext() {
        return (0, $9Nj04.getSelectionContext)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        if (this.includeLegacyContentAnnotations || (0, $bcN2K.isExperimentEnabled)('platform_editor_fix_lcm_renderer_annotations')) {
            const marks = [];
            doc.descendants((node)=>{
                const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
                marks.push(...annotationsMark.map((mark)=>({
                        fromLegacyContent: false,
                        mark: mark
                    })));
                if ((0, $17pA6.isLegacyContentExtension)(node)) marks.push(...(0, $17pA6.getAnnotationMarksWithLegacyContent)(node, annotationMarkType).map((mark)=>({
                        fromLegacyContent: true,
                        mark: mark
                    })));
                return annotationsMark.length === 0;
            });
            const rootAnnotationIds = new Set(marks.filter(({ fromLegacyContent: fromLegacyContent })=>!fromLegacyContent).map(({ mark: mark })=>mark.attrs.id));
            const uniqueMarks = new Map();
            marks.forEach(({ mark: mark, fromLegacyContent: fromLegacyContent })=>{
                const id = mark.attrs.id;
                if (fromLegacyContent && (rootAnnotationIds.has(id) || uniqueMarks.has(id))) return;
                uniqueMarks.set(id, mark);
            });
            return Array.from(uniqueMarks.values());
        }
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getMediaNodeContext(identifier) {
        if (!this.doc) return {
            status: 'missing'
        };
        const candidates = [];
        this.doc.descendants((node, position)=>{
            if (node.type.name !== 'media' || node.attrs.type !== 'file' || node.attrs.id !== identifier.id) return true;
            candidates.push({
                fileId: identifier.id,
                annotationIds: node.marks.filter((mark)=>mark.type.name === 'annotation' && mark.attrs.annotationType === (0, $6DAwh.AnnotationTypes).INLINE_COMMENT).map((mark)=>mark.attrs.id).filter((id)=>typeof id === 'string'),
                position: position,
                displayText: node.attrs.alt || node.attrs.__fileName || node.attrs.fileName || node.attrs.name,
                occurrenceKey: typeof node.attrs.occurrenceKey === 'string' ? node.attrs.occurrenceKey : undefined
            });
            return false;
        });
        const exactMatches = identifier.occurrenceKey ? candidates.filter((candidate)=>candidate.occurrenceKey === identifier.occurrenceKey) : [];
        const matches = exactMatches.length > 0 ? exactMatches : candidates;
        if (matches.length === 0) return {
            status: 'missing'
        };
        if (matches.length > 1) return {
            status: 'ambiguous'
        };
        return {
            status: 'resolved',
            context: matches[0]
        };
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cNUap.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $f1MDe.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        const isBlockTarget = possibleNode ? (0, $d3z80.isBlockAnnotationTarget)(possibleNode, this.schema) : false;
        if (possibleNode && isBlockTarget) {
            targetNodeType = possibleNode.type.name;
            step = new (0, $k2WVn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cNUap.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $d3z80.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $5pBjL.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $d3z80.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $f1MDe.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("f1MDe", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $d2eee245dc32bec1$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $d2eee245dc32bec1$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $d2eee245dc32bec1$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $d2eee245dc32bec1$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $d2eee245dc32bec1$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $d2eee245dc32bec1$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $d2eee245dc32bec1$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $d2eee245dc32bec1$export$2efbc6d84ea0fbec);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $d2eee245dc32bec1$export$a35880e7ecdcf47b);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6DAwh = parcelRequire("6DAwh");

var $dRkX9 = parcelRequire("dRkX9");
const $d2eee245dc32bec1$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $d2eee245dc32bec1$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $d2eee245dc32bec1$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $d2eee245dc32bec1$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $d2eee245dc32bec1$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($d2eee245dc32bec1$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $d2eee245dc32bec1$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $d2eee245dc32bec1$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $d2eee245dc32bec1$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $d2eee245dc32bec1$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $d2eee245dc32bec1$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("f7AYl", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", () => $971cf28790b5d95a$export$98cb1d9308d0944d);

var $3ZJj6 = parcelRequire("3ZJj6");

var $b4w4S = parcelRequire("b4w4S");

var $8ckOW = parcelRequire("8ckOW");

var $6WL33 = parcelRequire("6WL33");
const $971cf28790b5d95a$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $971cf28790b5d95a$var$emptyDoc = $971cf28790b5d95a$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
class $971cf28790b5d95a$export$98cb1d9308d0944d {
    /**
   * Creates a new JSONTransformer instance.
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $b4w4S.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $8ckOW.sanitizeNode)((0, $6WL33.toJSON)(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(content, $971cf28790b5d95a$var$emptyDoc.content)) return $971cf28790b5d95a$var$createDocFromContent([]);
        return $971cf28790b5d95a$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $b4w4S.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($971cf28790b5d95a$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node, options = {}) {
        return (0, $8ckOW.sanitizeNode)((0, $6WL33.toJSON)(node, this.mentionMap), options);
    }
}

});
parcelRegister("b4w4S", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f3fb4431eed950ca$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f3fb4431eed950ca$export$1db618b7b2275ea1);

var $jiju3 = parcelRequire("jiju3");

var $dRkX9 = parcelRequire("dRkX9");

var $kF7Lb = parcelRequire("kF7Lb");

var $eC92i = parcelRequire("eC92i");
var $l5yqo = parcelRequire("l5yqo");
var $jXulL = parcelRequire("jXulL");
var $iglh1 = parcelRequire("iglh1");
var $2KlGf = parcelRequire("2KlGf");
var $63Q5S = parcelRequire("63Q5S");

var $viZe0 = parcelRequire("viZe0");

var $j9iKu = parcelRequire("j9iKu");

var $bMAIM = parcelRequire("bMAIM");

var $iglh1 = parcelRequire("iglh1");

var $djAdL = parcelRequire("djAdL");
const $f3fb4431eed950ca$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f3fb4431eed950ca$export$e4e3ac1fa64862db = $f3fb4431eed950ca$var$getDefaultSchemaConfig();
const $f3fb4431eed950ca$export$fd147e7d448dea03 = (0, $jiju3.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $f3fb4431eed950ca$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $2KlGf.layoutSectionWithSingleColumn),
        extension: (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') ? (0, $iglh1.extensionRootOnlyWithAnnotationStage0) : (0, $iglh1.extensionRootOnlyStage0),
        bodiedExtension: (0, $eC92i.bodiedExtensionRootOnlyStage0),
        multiBodiedExtension: (0, $jXulL.multiBodiedExtensionRootOnlyStage0),
        extensionFrame: (0, $jXulL.extensionFrame),
        expand: (0, $l5yqo.expandWithNestedExpand),
        table: (0, $63Q5S.tableWithNestedTable),
        tableRow: (0, $63Q5S.tableRowWithNestedTable),
        tableCell: (0, $63Q5S.tableCellWithNestedTableStage0),
        tableHeader: (0, $63Q5S.tableHeaderWithNestedTableStage0),
        panel: (0, $bMAIM.extendedPanelRootOnlyStage0)(true),
        panel_c1: (0, $j9iKu.extendedPanelC1RootOnlyStage0)(true),
        rule: (0, $djAdL.ruleWithAttrsRootOnlyStage0),
        bodiedRule: (0, $viZe0.bodiedRuleRootOnlyStage0)
    };
    return (0, $kF7Lb.createSchema)(defaultSchemaConfig);
});
const $f3fb4431eed950ca$export$1db618b7b2275ea1 = $f3fb4431eed950ca$export$fd147e7d448dea03();

});
parcelRegister("kF7Lb", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $b995bde5d907d10e$export$5f4ce795563f4211);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $7H6Cr = parcelRequire("7H6Cr");

var $hOebH = parcelRequire("hOebH");

var $5BGfZ = parcelRequire("5BGfZ");

var $1Qxra = parcelRequire("1Qxra");

var $45x64 = parcelRequire("45x64");

var $ijgm7 = parcelRequire("ijgm7");

function $b995bde5d907d10e$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat((0, $5BGfZ.markGroupDeclarationsNames));
    let nodes = (0, $hOebH.addItems)((0, $45x64.nodesInOrder), nodesConfig, customNodeSpecs);
    const marks = (0, $hOebH.addItems)((0, $1Qxra.marksInOrder), marksConfig, customMarkSpecs);
    nodes = (0, $ijgm7.sanitizeNodes)(nodes, marks);
    return new (0, $7H6Cr.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $b995bde5d907d10e$export$c77b6d30da5276a1 = true;

});
parcelRegister("7H6Cr", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $59a1aef9ae52a370$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $59a1aef9ae52a370$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $59a1aef9ae52a370$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $59a1aef9ae52a370$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $59a1aef9ae52a370$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $59a1aef9ae52a370$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $59a1aef9ae52a370$export$85c928794f8d04d4);
$parcel$export(module.exports, "ContentMatch", () => $59a1aef9ae52a370$export$364ed450558d7ec4);
$parcel$export(module.exports, "NodeType", () => $59a1aef9ae52a370$export$f06e977173f1857c);
$parcel$export(module.exports, "MarkType", () => $59a1aef9ae52a370$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $59a1aef9ae52a370$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $59a1aef9ae52a370$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $59a1aef9ae52a370$export$3476b78f8f5a8b72);

var $hi0pE = parcelRequire("hi0pE");
function $59a1aef9ae52a370$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $59a1aef9ae52a370$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $59a1aef9ae52a370$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $59a1aef9ae52a370$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $59a1aef9ae52a370$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $59a1aef9ae52a370$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $59a1aef9ae52a370$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $59a1aef9ae52a370$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $59a1aef9ae52a370$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $59a1aef9ae52a370$var$retIndex(0, pos);
        if (pos == this.size) return $59a1aef9ae52a370$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $59a1aef9ae52a370$var$retIndex(i + 1, end);
                return $59a1aef9ae52a370$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $59a1aef9ae52a370$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $59a1aef9ae52a370$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $59a1aef9ae52a370$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $59a1aef9ae52a370$export$ffb0004e005737fa.empty;
        if (nodes instanceof $59a1aef9ae52a370$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $59a1aef9ae52a370$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $59a1aef9ae52a370$export$ffb0004e005737fa.empty = new $59a1aef9ae52a370$export$ffb0004e005737fa([], 0);
const $59a1aef9ae52a370$var$found = {
    index: 0,
    offset: 0
};
function $59a1aef9ae52a370$var$retIndex(index, offset) {
    $59a1aef9ae52a370$var$found.index = index;
    $59a1aef9ae52a370$var$found.offset = offset;
    return $59a1aef9ae52a370$var$found;
}
function $59a1aef9ae52a370$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$59a1aef9ae52a370$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$59a1aef9ae52a370$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $59a1aef9ae52a370$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $59a1aef9ae52a370$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
        if (marks instanceof $59a1aef9ae52a370$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $59a1aef9ae52a370$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $59a1aef9ae52a370$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $59a1aef9ae52a370$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $59a1aef9ae52a370$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $59a1aef9ae52a370$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $59a1aef9ae52a370$export$b3f2e2de3a8baa1e($59a1aef9ae52a370$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $59a1aef9ae52a370$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $59a1aef9ae52a370$export$b3f2e2de3a8baa1e($59a1aef9ae52a370$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $59a1aef9ae52a370$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $59a1aef9ae52a370$export$b3f2e2de3a8baa1e.empty = new $59a1aef9ae52a370$export$b3f2e2de3a8baa1e($59a1aef9ae52a370$export$ffb0004e005737fa.empty, 0, 0);
function $59a1aef9ae52a370$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($59a1aef9ae52a370$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $59a1aef9ae52a370$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $59a1aef9ae52a370$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $59a1aef9ae52a370$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $59a1aef9ae52a370$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $59a1aef9ae52a370$export$6de0e778727af3f2("Inconsistent open depths");
    return $59a1aef9ae52a370$var$replaceOuter($from, $to, slice, 0);
}
function $59a1aef9ae52a370$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $59a1aef9ae52a370$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $59a1aef9ae52a370$var$close(node, $59a1aef9ae52a370$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $59a1aef9ae52a370$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $59a1aef9ae52a370$var$prepareSliceForReplace(slice, $from);
        return $59a1aef9ae52a370$var$close(node, $59a1aef9ae52a370$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $59a1aef9ae52a370$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $59a1aef9ae52a370$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $59a1aef9ae52a370$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $59a1aef9ae52a370$var$checkJoin(node, $after.node(depth));
    return node;
}
function $59a1aef9ae52a370$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $59a1aef9ae52a370$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $59a1aef9ae52a370$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$59a1aef9ae52a370$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $59a1aef9ae52a370$var$addNode($end.nodeBefore, target);
}
function $59a1aef9ae52a370$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $59a1aef9ae52a370$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $59a1aef9ae52a370$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $59a1aef9ae52a370$var$joinable($end, $to, depth + 1);
    let content = [];
    $59a1aef9ae52a370$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $59a1aef9ae52a370$var$checkJoin(openStart, openEnd);
        $59a1aef9ae52a370$var$addNode($59a1aef9ae52a370$var$close(openStart, $59a1aef9ae52a370$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $59a1aef9ae52a370$var$addNode($59a1aef9ae52a370$var$close(openStart, $59a1aef9ae52a370$var$replaceTwoWay($from, $start, depth + 1)), content);
        $59a1aef9ae52a370$var$addRange($start, $end, depth, content);
        if (openEnd) $59a1aef9ae52a370$var$addNode($59a1aef9ae52a370$var$close(openEnd, $59a1aef9ae52a370$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $59a1aef9ae52a370$var$addRange($to, null, depth, content);
    return new $59a1aef9ae52a370$export$ffb0004e005737fa(content);
}
function $59a1aef9ae52a370$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $59a1aef9ae52a370$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $59a1aef9ae52a370$var$joinable($from, $to, depth + 1);
        $59a1aef9ae52a370$var$addNode($59a1aef9ae52a370$var$close(type, $59a1aef9ae52a370$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $59a1aef9ae52a370$var$addRange($to, null, depth, content);
    return new $59a1aef9ae52a370$export$ffb0004e005737fa(content);
}
function $59a1aef9ae52a370$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($59a1aef9ae52a370$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $59a1aef9ae52a370$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $59a1aef9ae52a370$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $59a1aef9ae52a370$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $59a1aef9ae52a370$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $59a1aef9ae52a370$var$resolveCache.set(doc, cache = new $59a1aef9ae52a370$var$ResolveCache);
        let result = cache.elts[cache.i] = $59a1aef9ae52a370$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $59a1aef9ae52a370$var$resolveCacheSize;
        return result;
    }
}
class $59a1aef9ae52a370$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $59a1aef9ae52a370$var$resolveCacheSize = 12, $59a1aef9ae52a370$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $59a1aef9ae52a370$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $59a1aef9ae52a370$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $59a1aef9ae52a370$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $59a1aef9ae52a370$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $59a1aef9ae52a370$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $59a1aef9ae52a370$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $59a1aef9ae52a370$var$emptyAttrs) && $59a1aef9ae52a370$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $59a1aef9ae52a370$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $59a1aef9ae52a370$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $59a1aef9ae52a370$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $59a1aef9ae52a370$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $59a1aef9ae52a370$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $59a1aef9ae52a370$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $59a1aef9ae52a370$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $59a1aef9ae52a370$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $59a1aef9ae52a370$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $59a1aef9ae52a370$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$59a1aef9ae52a370$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $59a1aef9ae52a370$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$59a1aef9ae52a370$export$85c928794f8d04d4.prototype.text = undefined;
class $59a1aef9ae52a370$var$TextNode extends $59a1aef9ae52a370$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $59a1aef9ae52a370$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $59a1aef9ae52a370$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $59a1aef9ae52a370$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $59a1aef9ae52a370$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $59a1aef9ae52a370$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $59a1aef9ae52a370$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $59a1aef9ae52a370$export$364ed450558d7ec4.empty;
        let expr = $59a1aef9ae52a370$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $59a1aef9ae52a370$var$dfa($59a1aef9ae52a370$var$nfa(expr));
        $59a1aef9ae52a370$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $59a1aef9ae52a370$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $59a1aef9ae52a370$export$364ed450558d7ec4.empty = new $59a1aef9ae52a370$export$364ed450558d7ec4(true);
class $59a1aef9ae52a370$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $59a1aef9ae52a370$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($59a1aef9ae52a370$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $59a1aef9ae52a370$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($59a1aef9ae52a370$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $59a1aef9ae52a370$var$parseExprSubscript(stream) {
    let expr = $59a1aef9ae52a370$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $59a1aef9ae52a370$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $59a1aef9ae52a370$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $59a1aef9ae52a370$var$parseExprRange(stream, expr) {
    let min = $59a1aef9ae52a370$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $59a1aef9ae52a370$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $59a1aef9ae52a370$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $59a1aef9ae52a370$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $59a1aef9ae52a370$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $59a1aef9ae52a370$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $59a1aef9ae52a370$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $59a1aef9ae52a370$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $59a1aef9ae52a370$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($59a1aef9ae52a370$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $59a1aef9ae52a370$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($59a1aef9ae52a370$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $59a1aef9ae52a370$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $59a1aef9ae52a370$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($59a1aef9ae52a370$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $59a1aef9ae52a370$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $59a1aef9ae52a370$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $59a1aef9ae52a370$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $59a1aef9ae52a370$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $59a1aef9ae52a370$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $59a1aef9ae52a370$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $59a1aef9ae52a370$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $59a1aef9ae52a370$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $59a1aef9ae52a370$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $59a1aef9ae52a370$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $59a1aef9ae52a370$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $59a1aef9ae52a370$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $59a1aef9ae52a370$export$ffb0004e005737fa.from(content), $59a1aef9ae52a370$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $59a1aef9ae52a370$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $59a1aef9ae52a370$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $59a1aef9ae52a370$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $59a1aef9ae52a370$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($59a1aef9ae52a370$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $59a1aef9ae52a370$export$85c928794f8d04d4(this, attrs, content.append(after), $59a1aef9ae52a370$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $59a1aef9ae52a370$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $59a1aef9ae52a370$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $59a1aef9ae52a370$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $59a1aef9ae52a370$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $59a1aef9ae52a370$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $59a1aef9ae52a370$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $59a1aef9ae52a370$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $59a1aef9ae52a370$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $59a1aef9ae52a370$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $59a1aef9ae52a370$export$c9d15bcfc6d42044(this, $59a1aef9ae52a370$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $59a1aef9ae52a370$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $59a1aef9ae52a370$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $59a1aef9ae52a370$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $hi0pE.default).from(spec.nodes), instanceSpec.marks = (0, $hi0pE.default).from(spec.marks || {}), this.nodes = $59a1aef9ae52a370$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $59a1aef9ae52a370$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $59a1aef9ae52a370$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $59a1aef9ae52a370$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $59a1aef9ae52a370$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $59a1aef9ae52a370$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $59a1aef9ae52a370$var$TextNode(type, type.defaultAttrs, text, $59a1aef9ae52a370$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $59a1aef9ae52a370$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $59a1aef9ae52a370$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $59a1aef9ae52a370$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $59a1aef9ae52a370$var$isTagRule(rule) {
    return rule.tag != null;
}
function $59a1aef9ae52a370$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $59a1aef9ae52a370$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($59a1aef9ae52a370$var$isTagRule(rule)) this.tags.push(rule);
            else if ($59a1aef9ae52a370$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $59a1aef9ae52a370$var$ParseContext(this, options, false);
        context.addAll(dom, $59a1aef9ae52a370$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $59a1aef9ae52a370$var$ParseContext(this, options, true);
        context.addAll(dom, $59a1aef9ae52a370$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $59a1aef9ae52a370$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($59a1aef9ae52a370$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $59a1aef9ae52a370$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $59a1aef9ae52a370$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $59a1aef9ae52a370$export$1059c6e7d2ce5669(schema, $59a1aef9ae52a370$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $59a1aef9ae52a370$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $59a1aef9ae52a370$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $59a1aef9ae52a370$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $59a1aef9ae52a370$var$OPT_PRESERVE_WS = 1, $59a1aef9ae52a370$var$OPT_PRESERVE_WS_FULL = 2, $59a1aef9ae52a370$var$OPT_OPEN_LEFT = 4;
function $59a1aef9ae52a370$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $59a1aef9ae52a370$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $59a1aef9ae52a370$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $59a1aef9ae52a370$var$OPT_PRESERVE_WS | $59a1aef9ae52a370$var$OPT_PRESERVE_WS_FULL : base & ~$59a1aef9ae52a370$var$OPT_OPEN_LEFT;
}
class $59a1aef9ae52a370$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $59a1aef9ae52a370$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($59a1aef9ae52a370$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $59a1aef9ae52a370$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $59a1aef9ae52a370$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($59a1aef9ae52a370$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$59a1aef9ae52a370$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $59a1aef9ae52a370$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $59a1aef9ae52a370$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $59a1aef9ae52a370$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $59a1aef9ae52a370$var$NodeContext(topNode.type, topNode.attrs, $59a1aef9ae52a370$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $59a1aef9ae52a370$var$NodeContext(null, null, $59a1aef9ae52a370$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $59a1aef9ae52a370$var$NodeContext(parser.schema.topNodeType, null, $59a1aef9ae52a370$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $59a1aef9ae52a370$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $59a1aef9ae52a370$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($59a1aef9ae52a370$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $59a1aef9ae52a370$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $59a1aef9ae52a370$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($59a1aef9ae52a370$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $59a1aef9ae52a370$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $59a1aef9ae52a370$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $59a1aef9ae52a370$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $59a1aef9ae52a370$var$OPT_OPEN_LEFT;
        let applyMarks = $59a1aef9ae52a370$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $59a1aef9ae52a370$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $59a1aef9ae52a370$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $59a1aef9ae52a370$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $59a1aef9ae52a370$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $59a1aef9ae52a370$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $59a1aef9ae52a370$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $59a1aef9ae52a370$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $59a1aef9ae52a370$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $59a1aef9ae52a370$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $59a1aef9ae52a370$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $59a1aef9ae52a370$var$renderSpec($59a1aef9ae52a370$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $59a1aef9ae52a370$var$renderSpec($59a1aef9ae52a370$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $59a1aef9ae52a370$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $59a1aef9ae52a370$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $59a1aef9ae52a370$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $59a1aef9ae52a370$var$gatherToDOM(schema.marks);
    }
}
function $59a1aef9ae52a370$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $59a1aef9ae52a370$var$doc(options) {
    return options.document || window.document;
}
const $59a1aef9ae52a370$var$suspiciousAttributeCache = new WeakMap();
function $59a1aef9ae52a370$var$suspiciousAttributes(attrs) {
    let value = $59a1aef9ae52a370$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $59a1aef9ae52a370$var$suspiciousAttributeCache.set(attrs, value = $59a1aef9ae52a370$var$suspiciousAttributesInner(attrs));
    return value;
}
function $59a1aef9ae52a370$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $59a1aef9ae52a370$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $59a1aef9ae52a370$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $59a1aef9ae52a370$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("hi0pE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9647012c07ae270$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $c9647012c07ae270$var$OrderedMap(content) {
    this.content = content;
}
$c9647012c07ae270$var$OrderedMap.prototype = {
    constructor: $c9647012c07ae270$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $c9647012c07ae270$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $c9647012c07ae270$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $c9647012c07ae270$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $c9647012c07ae270$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $c9647012c07ae270$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $c9647012c07ae270$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $c9647012c07ae270$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $c9647012c07ae270$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $c9647012c07ae270$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $c9647012c07ae270$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$c9647012c07ae270$var$OrderedMap.from = function(value) {
    if (value instanceof $c9647012c07ae270$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $c9647012c07ae270$var$OrderedMap(content);
};
var $c9647012c07ae270$export$2e2bcd8739ae039 = $c9647012c07ae270$var$OrderedMap;

});


parcelRegister("hOebH", function(module, exports) {
$parcel$export(module.exports, "addItems", () => $0df336a3c0048923$export$efa5595d3b524179);
function $0df336a3c0048923$export$efa5595d3b524179(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}

});

parcelRegister("5BGfZ", function(module, exports) {
$parcel$export(module.exports, "markGroupDeclarations", () => $174665bdda4ffa7d$export$78b27f3e8d09085f);
$parcel$export(module.exports, "markGroupDeclarationsNames", () => $174665bdda4ffa7d$export$ee0d2ba599b1121f);

var $3eJ2x = parcelRequire("3eJ2x");
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
function $174665bdda4ffa7d$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $174665bdda4ffa7d$export$78b27f3e8d09085f = [
    $174665bdda4ffa7d$var$groupDeclaration((0, $3eJ2x.COLOR)),
    $174665bdda4ffa7d$var$groupDeclaration((0, $3eJ2x.FONT_STYLE)),
    $174665bdda4ffa7d$var$groupDeclaration((0, $3eJ2x.SEARCH_QUERY)),
    $174665bdda4ffa7d$var$groupDeclaration((0, $3eJ2x.LINK))
];
const $174665bdda4ffa7d$export$ee0d2ba599b1121f = $174665bdda4ffa7d$export$78b27f3e8d09085f.map((groupMark)=>groupMark.name);

});
parcelRegister("3eJ2x", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", () => $a27977e439331983$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $a27977e439331983$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $a27977e439331983$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $a27977e439331983$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $a27977e439331983$export$4498a6080fed604c = 'fontStyle';
const $a27977e439331983$export$f8e8a5f34f6ea725 = 'searchQuery';
const $a27977e439331983$export$b395009ca7f092c7 = 'link';
const $a27977e439331983$export$9b982809044276a6 = 'color';
const $a27977e439331983$export$470d0905851e47a1 = 'alignment';
const $a27977e439331983$export$bacb7f4b06a06b22 = 'indentation';

});


parcelRegister("1Qxra", function(module, exports) {
$parcel$export(module.exports, "marksInOrder", () => $c42e00b101142c5f$export$2a20daddecce6807);

var $5BGfZ = parcelRequire("5BGfZ");

var $6BHhZ = parcelRequire("6BHhZ");
var $6DAwh = parcelRequire("6DAwh");
var $3zGhJ = parcelRequire("3zGhJ");
var $fweje = parcelRequire("fweje");
var $g37he = parcelRequire("g37he");
var $44Fx3 = parcelRequire("44Fx3");
var $7QNFx = parcelRequire("7QNFx");
var $le0kK = parcelRequire("le0kK");
var $cBfNk = parcelRequire("cBfNk");
var $3yFC9 = parcelRequire("3yFC9");
var $ipVDa = parcelRequire("ipVDa");
var $ldGuo = parcelRequire("ldGuo");
var $b0oSW = parcelRequire("b0oSW");
var $i39zf = parcelRequire("i39zf");
var $7FN4W = parcelRequire("7FN4W");
var $dulEt = parcelRequire("dulEt");
var $7pWsE = parcelRequire("7pWsE");
var $2nNKH = parcelRequire("2nNKH");
var $aw5xJ = parcelRequire("aw5xJ");
var $dVToP = parcelRequire("dVToP");
var $8x0rq = parcelRequire("8x0rq");
const $c42e00b101142c5f$export$2a20daddecce6807 = [
    {
        name: 'link',
        spec: (0, $b0oSW.link)
    },
    {
        name: 'em',
        spec: (0, $cBfNk.em)
    },
    {
        name: 'strong',
        spec: (0, $7FN4W.strong)
    },
    {
        name: 'textColor',
        spec: (0, $7pWsE.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $3zGhJ.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $i39zf.strike)
    },
    {
        name: 'subsup',
        spec: (0, $dulEt.subsup)
    },
    {
        name: 'underline',
        spec: (0, $aw5xJ.underline)
    },
    {
        name: 'code',
        spec: (0, $44Fx3.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $2nNKH.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $6BHhZ.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $6DAwh.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $7QNFx.confluenceInlineComment)
    },
    ...(0, $5BGfZ.markGroupDeclarations),
    {
        name: 'fontSize',
        spec: (0, $3yFC9.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $g37he.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $le0kK.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $ipVDa.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $ldGuo.indentation)
    },
    {
        name: 'border',
        spec: (0, $fweje.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $dVToP.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $8x0rq.unsupportedNodeAttribute)
    }
];

});
parcelRegister("6BHhZ", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $5adb7bc900423622$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $5adb7bc900423622$export$8e53000a4ec837);

var $8oMY3 = parcelRequire("8oMY3");
const $5adb7bc900423622$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $5adb7bc900423622$export$8e53000a4ec837 = (0, $8oMY3.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});

parcelRegister("3zGhJ", function(module, exports) {
$parcel$export(module.exports, "backgroundColorPalette", () => $d306081c957682df$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColorPaletteNew", () => $d306081c957682df$export$5e11ef3de07e2b1);
$parcel$export(module.exports, "backgroundColor", () => $d306081c957682df$export$8c5a050822fd698c);

var $bcN2K = parcelRequire("bcN2K");

var $3NBIB = parcelRequire("3NBIB");

var $8oMY3 = parcelRequire("8oMY3");

var $3Mcc1 = parcelRequire("3Mcc1");

var $lefJT = parcelRequire("lefJT");

var $d41Jy = parcelRequire("d41Jy");

var $gmPq6 = parcelRequire("gmPq6");

var $7pWsE = parcelRequire("7pWsE");
const $d306081c957682df$var$colorArrayPalette = [
    [
        (0, $3Mcc1.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $3Mcc1.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $3Mcc1.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $3Mcc1.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $3Mcc1.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $3Mcc1.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $3Mcc1.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $d306081c957682df$var$colorArrayPaletteNew = [
    [
        (0, $3Mcc1.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $3Mcc1.B75),
        'Blue'
    ],
    // token: color.background.accent.blue.subtler
    [
        (0, $3Mcc1.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $3Mcc1.G75),
        'Green'
    ],
    // token: color.background.accent.green.subtler
    [
        (0, $3Mcc1.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $3Mcc1.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $3Mcc1.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $3Mcc1.R200),
        'Red'
    ],
    // token: color.background.accent.red.subtler
    [
        (0, $3Mcc1.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $3Mcc1.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $d306081c957682df$export$14ec3f21a268e497 = new Map();
$d306081c957682df$var$colorArrayPalette.forEach(([color, label])=>$d306081c957682df$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $d306081c957682df$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/iu;
const $d306081c957682df$export$5e11ef3de07e2b1 = new Map();
$d306081c957682df$var$colorArrayPaletteNew.forEach(([color, label])=>$d306081c957682df$export$5e11ef3de07e2b1.set(color.toLowerCase(), label));
const $d306081c957682df$var$isSupportedBackgroundColor = (hexColor)=>{
    if ($d306081c957682df$export$14ec3f21a268e497.has(hexColor)) return true;
    return (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $d306081c957682df$export$5e11ef3de07e2b1.has(hexColor);
};
const $d306081c957682df$var$getBackgroundColor = (value)=>{
    let hexColor;
    if (value.match($d306081c957682df$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $gmPq6.rgbToHex)(value);
    else if (value[0] === '#') hexColor = value.toLowerCase();
    // else handle other colour formats
    return hexColor && $d306081c957682df$var$isSupportedBackgroundColor(hexColor) ? {
        color: hexColor
    } : false;
};
const $d306081c957682df$export$8c5a050822fd698c = (0, $8oMY3.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                if ((0, $bcN2K.isExperimentEnabled)('platform_editor_fix_table_cell_background')) return false;
                return $d306081c957682df$var$getBackgroundColor(maybeValue);
            }
        },
        {
            // the table cell and background color palettes overlap on Blue and Green, so
            // we need to exclude table cells to avoid parsing table cell background as background color
            tag: '[style]:not(td):not(th)',
            consuming: false,
            priority: 60,
            getAttrs: (maybeElement)=>{
                if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_fix_table_cell_background') || !(maybeElement instanceof HTMLElement)) return false;
                return $d306081c957682df$var$getBackgroundColor(maybeElement.style.backgroundColor);
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $d306081c957682df$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $d41Jy.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $7pWsE.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $lefJT.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("3NBIB", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $2d05e2f82667b499$export$63eebf86443a0a61);

var $lsSrw = parcelRequire("lsSrw");
function $2d05e2f82667b499$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $lsSrw.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("3Mcc1", function(module, exports) {
$parcel$export(module.exports, "R50", () => $8dae395d91787aeb$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $8dae395d91787aeb$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $8dae395d91787aeb$export$be802dd0d8b57f35);
$parcel$export(module.exports, "RedBold", () => $8dae395d91787aeb$export$8ce25cbf2e1e4328);
$parcel$export(module.exports, "R200", () => $8dae395d91787aeb$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $8dae395d91787aeb$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $8dae395d91787aeb$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $8dae395d91787aeb$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $8dae395d91787aeb$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $8dae395d91787aeb$export$5aae31392d72caaa);
$parcel$export(module.exports, "YellowBold", () => $8dae395d91787aeb$export$b9aaaa578bb08b28);
$parcel$export(module.exports, "Yellow200", () => $8dae395d91787aeb$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $8dae395d91787aeb$export$59619663aa6500fb);
$parcel$export(module.exports, "Y600", () => $8dae395d91787aeb$export$8d067e56aec921ba);
$parcel$export(module.exports, "Y800", () => $8dae395d91787aeb$export$880b9499608823af);
$parcel$export(module.exports, "G50", () => $8dae395d91787aeb$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $8dae395d91787aeb$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $8dae395d91787aeb$export$747d86715d4175de);
$parcel$export(module.exports, "GreenBold", () => $8dae395d91787aeb$export$4ba6949317382ac4);
$parcel$export(module.exports, "G300", () => $8dae395d91787aeb$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $8dae395d91787aeb$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $8dae395d91787aeb$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $8dae395d91787aeb$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $8dae395d91787aeb$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "BlueBold", () => $8dae395d91787aeb$export$7489d9dce51bb172);
$parcel$export(module.exports, "B400", () => $8dae395d91787aeb$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $8dae395d91787aeb$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L50", () => $8dae395d91787aeb$export$f51762073d2bb381);
$parcel$export(module.exports, "L200", () => $8dae395d91787aeb$export$f72948ef771f6f15);
$parcel$export(module.exports, "L400", () => $8dae395d91787aeb$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L600", () => $8dae395d91787aeb$export$b118f20869cce368);
$parcel$export(module.exports, "L800", () => $8dae395d91787aeb$export$4d2dfdfde6a26b06);
$parcel$export(module.exports, "N0", () => $8dae395d91787aeb$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $8dae395d91787aeb$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $8dae395d91787aeb$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $8dae395d91787aeb$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "GrayBold", () => $8dae395d91787aeb$export$a85cd17eb3a74576);
$parcel$export(module.exports, "N80", () => $8dae395d91787aeb$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $8dae395d91787aeb$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $8dae395d91787aeb$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $8dae395d91787aeb$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $8dae395d91787aeb$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $8dae395d91787aeb$export$f78789c8b01753cd);
$parcel$export(module.exports, "M50", () => $8dae395d91787aeb$export$dce26b47982a2d83);
$parcel$export(module.exports, "M200", () => $8dae395d91787aeb$export$a19f0c33186f7767);
$parcel$export(module.exports, "M400", () => $8dae395d91787aeb$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M600", () => $8dae395d91787aeb$export$3bff0a0c68537008);
$parcel$export(module.exports, "M800", () => $8dae395d91787aeb$export$aedcf6658caf5ad6);
$parcel$export(module.exports, "O200", () => $8dae395d91787aeb$export$51716a84e62e022c);
$parcel$export(module.exports, "Orange50", () => $8dae395d91787aeb$export$8692a80ca6403e1e);
$parcel$export(module.exports, "Orange200", () => $8dae395d91787aeb$export$a0fa9fa6bfbb29d1);
$parcel$export(module.exports, "Orange400", () => $8dae395d91787aeb$export$e58d39c2a9e7b70e);
$parcel$export(module.exports, "O600", () => $8dae395d91787aeb$export$65becf92d294645b);
$parcel$export(module.exports, "O800", () => $8dae395d91787aeb$export$d50a5202329f668e);
$parcel$export(module.exports, "P50", () => $8dae395d91787aeb$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $8dae395d91787aeb$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $8dae395d91787aeb$export$6011520a64d9a187);
$parcel$export(module.exports, "PurpleBold", () => $8dae395d91787aeb$export$33050b411a4844fe);
$parcel$export(module.exports, "P200", () => $8dae395d91787aeb$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $8dae395d91787aeb$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $8dae395d91787aeb$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $8dae395d91787aeb$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $8dae395d91787aeb$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $8dae395d91787aeb$export$776c9c497ef08533);
$parcel$export(module.exports, "TealBold", () => $8dae395d91787aeb$export$f4de2950886ae4c9);
$parcel$export(module.exports, "T200", () => $8dae395d91787aeb$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $8dae395d91787aeb$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $8dae395d91787aeb$export$6036577f95c3877e);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * We're avoding importing these colors from @atlaskit/theme since we
 * do not want to have react as a dependency of this package.
 * TODO: Refactor this once tokenization by Core team is ready
 * https://product-fabric.atlassian.net/browse/CS-908
 */ 





const $8dae395d91787aeb$export$4b84fd0e2c617bd = '#FFEBE6';
const $8dae395d91787aeb$export$b34b069eff244586 = '#FFBDAD';
const $8dae395d91787aeb$export$be802dd0d8b57f35 = '#FF8F73';
const $8dae395d91787aeb$export$8ce25cbf2e1e4328 = '#FFB8B2';
const $8dae395d91787aeb$export$60847d42f9da92a6 = '#FFD5D2';
const $8dae395d91787aeb$export$4a7404f376229999 = '#FF5630';
const $8dae395d91787aeb$export$2010d0fb4295b346 = '#DE350B';
const $8dae395d91787aeb$export$2837b5a1a71d5c02 = '#BF2600';
const $8dae395d91787aeb$export$8d9596b529bbb9cf = '#FFFAE6';
const $8dae395d91787aeb$export$41060a744ab0b7ae = '#FFF0B3';
const $8dae395d91787aeb$export$5aae31392d72caaa = '#FFC400';
const $8dae395d91787aeb$export$b9aaaa578bb08b28 = '#EFDD4E';
const $8dae395d91787aeb$export$fc857b6f8771648a = '#F8E6A0';
const $8dae395d91787aeb$export$59619663aa6500fb = '#FF991F';
const $8dae395d91787aeb$export$874739ea9e379ab6 = '#FF8B00';
const $8dae395d91787aeb$export$8d067e56aec921ba = '#B38600';
const $8dae395d91787aeb$export$880b9499608823af = '#7F5F01';
const $8dae395d91787aeb$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $8dae395d91787aeb$export$69a3bf21b9686c2b = '#ABF5D1';
const $8dae395d91787aeb$export$747d86715d4175de = '#57D9A3';
const $8dae395d91787aeb$export$4ba6949317382ac4 = '#97EDC9';
const $8dae395d91787aeb$export$940e1f69e873f202 = '#36B37E';
const $8dae395d91787aeb$export$a49394138f7b8e85 = '#00875A';
const $8dae395d91787aeb$export$6fa04827ac68a4fb = '#006644';
const $8dae395d91787aeb$export$226de0355ed012f8 = '#DEEBFF';
const $8dae395d91787aeb$export$8c13c2ee36917869 = '#B3D4FF';
const $8dae395d91787aeb$export$ecfc1dff386a3e7a = '#4C9AFF';
const $8dae395d91787aeb$export$7489d9dce51bb172 = '#ADCBFB';
const $8dae395d91787aeb$export$b3de0ae08da2ce64 = '#0052CC';
const $8dae395d91787aeb$export$a6ee3d71bc067634 = '#0747A6';
const $8dae395d91787aeb$export$f51762073d2bb381 = '#EFFFD6';
const $8dae395d91787aeb$export$f72948ef771f6f15 = '#D3F1A7';
const $8dae395d91787aeb$export$4b0a7cabffffd4f5 = '#BDE97C';
const $8dae395d91787aeb$export$b118f20869cce368 = '#6A9A23';
const $8dae395d91787aeb$export$4d2dfdfde6a26b06 = '#4C6B1F';
const $8dae395d91787aeb$export$29a4f05edc054374 = '#FFFFFF';
const $8dae395d91787aeb$export$9fdfb749e33cdf97 = '#F4F5F7';
const $8dae395d91787aeb$export$3e51e8f1440314ba = '#EBECF0';
const $8dae395d91787aeb$export$1ce2d1575d444ceb = '#DFE1E6';
const $8dae395d91787aeb$export$8754fc7e6d8b3000 = '#C1C7D0';
const $8dae395d91787aeb$export$c2e91cbeada39b8b = '#B3BAC5';
const $8dae395d91787aeb$export$a85cd17eb3a74576 = '#B7B9BE';
const $8dae395d91787aeb$export$eaa8c8a70ac22806 = '#97A0AF';
const $8dae395d91787aeb$export$7c87d337fb91a97d = '#8993A4';
const $8dae395d91787aeb$export$f563ee71e9ee74cd = '#6B778C';
const $8dae395d91787aeb$export$e2ef2124cf4024b1 = '#5E6C84';
const $8dae395d91787aeb$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $8dae395d91787aeb$export$13609db0e6812ab8 = '#091E4224';
const $8dae395d91787aeb$export$c39c0fe0f26207ae = '#42526E';
const $8dae395d91787aeb$export$7090862dc3038a9f = '#758195';
const $8dae395d91787aeb$export$7d61b15e0da132af = '#172B4D';
const $8dae395d91787aeb$export$f78789c8b01753cd = '#172B4D';
const $8dae395d91787aeb$export$dce26b47982a2d83 = '#FFECF8';
const $8dae395d91787aeb$export$a19f0c33186f7767 = '#FDD0EC';
const $8dae395d91787aeb$export$a1d4686c17e1cdef = '#FCB6E1';
const $8dae395d91787aeb$export$3bff0a0c68537008 = '#CD519D';
const $8dae395d91787aeb$export$aedcf6658caf5ad6 = '#943D73';
const $8dae395d91787aeb$export$51716a84e62e022c = '#FEDEC8';
const $8dae395d91787aeb$export$8692a80ca6403e1e = '#FFF5DB';
const $8dae395d91787aeb$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
const $8dae395d91787aeb$export$e58d39c2a9e7b70e = '#FBD779';
const $8dae395d91787aeb$export$65becf92d294645b = '#E06C00';
const $8dae395d91787aeb$export$d50a5202329f668e = '#9E4C00';
const $8dae395d91787aeb$export$363e4475840015bb = '#EAE6FF';
const $8dae395d91787aeb$export$4b0a4417ed59760f = '#C0B6F2';
const $8dae395d91787aeb$export$6011520a64d9a187 = '#998DD9';
const $8dae395d91787aeb$export$33050b411a4844fe = '#E3BDFA';
const $8dae395d91787aeb$export$a7175d4e9206bc80 = '#DFD8FD';
const $8dae395d91787aeb$export$b48405b95304b5a1 = '#6554C0';
const $8dae395d91787aeb$export$c71e4279dd54a18d = '#5243AA';
const $8dae395d91787aeb$export$147899de772240ec = '#403294';
const $8dae395d91787aeb$export$2cf711fe14c66f06 = '#E6FCFF';
const $8dae395d91787aeb$export$7a8f4d33f6f9772c = '#B3F5FF';
const $8dae395d91787aeb$export$776c9c497ef08533 = '#79E2F2';
const $8dae395d91787aeb$export$f4de2950886ae4c9 = '#B1E4F7';
const $8dae395d91787aeb$export$69cb3ca10c1e330e = '#C6EDFB';
const $8dae395d91787aeb$export$9dc1ef0f3f48059b = '#00B8D9';
const $8dae395d91787aeb$export$6036577f95c3877e = '#008DA6';

});

parcelRegister("lefJT", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $5510be5676c9fdc6$export$a5065c3b8aacaf99);

var $jm0MS = parcelRequire("jm0MS");

var $bvyIi = parcelRequire("bvyIi");

var $b2DPH = parcelRequire("b2DPH");
const $5510be5676c9fdc6$var$getLightness = (color)=>{
    const rgb = (0, $bvyIi.rgbFromHex)(color);
    if (rgb === null) return 0;
    const lch = (0, $b2DPH.rgbToLch)(rgb);
    return lch.l;
};
const $5510be5676c9fdc6$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5510be5676c9fdc6$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return (0, $jm0MS.clampLightness)(currentBackgroundColor, newLightness).toUpperCase();
};

});
parcelRegister("jm0MS", function(module, exports) {
$parcel$export(module.exports, "clampLightness", () => $2983eea720335d81$export$313b8a8fcb34c3b8);

var $bvyIi = parcelRequire("bvyIi");

var $b2DPH = parcelRequire("b2DPH");
const $2983eea720335d81$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $2983eea720335d81$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $2983eea720335d81$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $2983eea720335d81$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $2983eea720335d81$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $2983eea720335d81$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $2983eea720335d81$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $2983eea720335d81$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $2983eea720335d81$var$lchToRgb = (lch)=>$2983eea720335d81$var$xyzToRgb($2983eea720335d81$var$labToXyz($2983eea720335d81$var$lchToLab(lch)));
const $2983eea720335d81$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = (0, $bvyIi.rgbFromHex)(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = (0, $b2DPH.rgbToLch)(rgb);
    lch.l = $2983eea720335d81$var$clamp(newPercent, 0, 100);
    return $2983eea720335d81$var$rgbToHex($2983eea720335d81$var$lchToRgb(lch));
};

});
parcelRegister("bvyIi", function(module, exports) {
$parcel$export(module.exports, "rgbFromHex", () => $199df253ebc12b43$export$d604f368c5212474);

var $3HSq8 = parcelRequire("3HSq8");

var $hRDn0 = parcelRequire("hRDn0");
const $199df253ebc12b43$export$d604f368c5212474 = (input)=>{
    const fullHex = (0, $3HSq8.expandShorthandHex)(input);
    const result = (0, $hRDn0.FULL_HEX_REGEX).exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};

});
parcelRegister("3HSq8", function(module, exports) {
$parcel$export(module.exports, "expandShorthandHex", () => $1d23bbb097acff2a$export$f67f480c2f5dd62d);
const $1d23bbb097acff2a$var$SHORTHAND_HEX_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/iu;
const $1d23bbb097acff2a$export$f67f480c2f5dd62d = (input)=>input.replace($1d23bbb097acff2a$var$SHORTHAND_HEX_REGEX, (_m, r, g, b)=>r + r + g + g + b + b);

});

parcelRegister("hRDn0", function(module, exports) {
$parcel$export(module.exports, "FULL_HEX_REGEX", () => $6e71a206a551bec9$export$c3a7521d0ffa04dc);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 







const $6e71a206a551bec9$export$c3a7521d0ffa04dc = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu;

});


parcelRegister("b2DPH", function(module, exports) {
$parcel$export(module.exports, "rgbToLch", () => $8cf299fb5cbfdcaf$export$60714bf90ef24e7b);

var $cuuFH = parcelRequire("cuuFH");

var $6MUEk = parcelRequire("6MUEk");

var $dbXSt = parcelRequire("dbXSt");
const $8cf299fb5cbfdcaf$export$60714bf90ef24e7b = (rgb)=>(0, $cuuFH.labToLch)((0, $dbXSt.xyzToLab)((0, $6MUEk.rgbToXyz)(rgb)));

});
parcelRegister("cuuFH", function(module, exports) {
$parcel$export(module.exports, "labToLch", () => $1b82d1d0b63a0743$export$21f398e7d277f911);
const $1b82d1d0b63a0743$export$21f398e7d277f911 = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};

});

parcelRegister("6MUEk", function(module, exports) {
$parcel$export(module.exports, "rgbToXyz", () => $df550229c6a2a0c5$export$532d5190d94ac8d7);
const $df550229c6a2a0c5$export$532d5190d94ac8d7 = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};

});

parcelRegister("dbXSt", function(module, exports) {
$parcel$export(module.exports, "xyzToLab", () => $1cfa0b85152dbced$export$a7b197d2a22fcf09);
const $1cfa0b85152dbced$export$a7b197d2a22fcf09 = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });

});




parcelRegister("d41Jy", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $6b9fba425f049a36$export$8b58ff1b36bb75e0);

var $615t3 = parcelRequire("615t3");
function $6b9fba425f049a36$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $615t3.textBackgroundColorPalette)[hexColor.toUpperCase()] : undefined;
}

});
parcelRegister("615t3", function(module, exports) {
$parcel$export(module.exports, "editorBorderPalette", () => $495b85eab488ca2d$export$aa000893c5e2b9c2);
$parcel$export(module.exports, "editorTextPalette", () => $495b85eab488ca2d$export$57fa5089caad992);
$parcel$export(module.exports, "textBackgroundColorPalette", () => $495b85eab488ca2d$export$12a518ff137dd389);
$parcel$export(module.exports, "editorBackgroundPalette", () => $495b85eab488ca2d$export$2462741d70e6a62f);

var $3NBIB = parcelRequire("3NBIB");
const $495b85eab488ca2d$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
const $495b85eab488ca2d$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)',
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? 'var(--ds-border-accent-yellow, #B38600)' : 'var(--ds-icon-accent-yellow, #B38600)';
    },
    /** yellow - strong */ '#7F5F01': 'var(--ds-text-accent-yellow, #7F5F01)'
};
const $495b85eab488ca2d$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Red - light */ '#FFD5D2': 'var(--ds-background-accent-red-subtler, #FFD5D2)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
const $495b85eab488ca2d$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    },
    /** lime - light */ '#EFFFD6': {
        getValue: ()=>'#EFFFD6',
        token: 'var(--ds-background-accent-lime-subtlest, #EFFFD6)'
    },
    /** lime - medium */ '#D3F1A7': {
        getValue: ()=>'#D3F1A7',
        token: 'var(--ds-background-accent-lime-subtler, #D3F1A7)'
    },
    /** lime - bold */ '#BDE97C': {
        getValue: ()=>'#BDE97C',
        token: 'var(--ds-background-accent-lime-subtler-hovered, #BDE97C)'
    },
    /** orange - light */ '#FFF5DB': {
        getValue: ()=>'#FFF5DB',
        token: 'var(--ds-background-accent-orange-subtlest, #FFF5DB)'
    },
    /** orange - medium */ '#FCE4A6': {
        getValue: ()=>'#FCE4A6',
        token: 'var(--ds-background-accent-orange-subtler, #FCE4A6)'
    },
    /** orange - bold */ '#FBD779': {
        getValue: ()=>'#FBD779',
        token: 'var(--ds-background-accent-orange-subtler-hovered, #FBD779)'
    },
    /** magenta - light */ '#FFECF8': {
        getValue: ()=>'#FFECF8',
        token: 'var(--ds-background-accent-magenta-subtlest, #FFECF8)'
    },
    /** magenta - medium */ '#FDD0EC': {
        getValue: ()=>'#FDD0EC',
        token: 'var(--ds-background-accent-magenta-subtler, #FDD0EC)'
    },
    /** magenta - bold */ '#FCB6E1': {
        getValue: ()=>'#FCB6E1',
        token: 'var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)'
    },
    // Bold row mappings using subtler.hovered tokens. These use new hex codes
    // so pre-existing documents keep their old subtle-token mappings above.
    /** blue - bold */ '#ADCBFB': {
        getValue: ()=>'#ADCBFB',
        token: 'var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)'
    },
    /** teal - bold */ '#B1E4F7': {
        getValue: ()=>'#B1E4F7',
        token: 'var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)'
    },
    /** green - bold */ '#97EDC9': {
        getValue: ()=>'#97EDC9',
        token: 'var(--ds-background-accent-green-subtler-hovered, #97EDC9)'
    },
    /** yellow - bold */ '#EFDD4E': {
        getValue: ()=>'#EFDD4E',
        token: 'var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)'
    },
    /** red - bold */ '#FFB8B2': {
        getValue: ()=>'#FFB8B2',
        token: 'var(--ds-background-accent-red-subtler-hovered, #FFB8B2)'
    },
    /** purple - bold */ '#E3BDFA': {
        getValue: ()=>'#E3BDFA',
        token: 'var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)'
    },
    /** gray - bold */ '#B7B9BE': {
        getValue: ()=>'#B7B9BE',
        token: 'var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)'
    }
};

});


parcelRegister("gmPq6", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $a80b5d002b039a9a$export$34d09c4a771c46ef);
// eslint-disable-line import/no-namespace
function $a80b5d002b039a9a$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}

});

parcelRegister("7pWsE", function(module, exports) {
$parcel$export(module.exports, "colorPalette", () => $9a1f827cbccf3965$export$569885e57444f84a);
$parcel$export(module.exports, "colorPaletteNew", () => $9a1f827cbccf3965$export$dee1d8a8cb3ab555);
$parcel$export(module.exports, "getGlobalTheme", () => $9a1f827cbccf3965$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $9a1f827cbccf3965$export$32f78bffcd82ff28);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $3NBIB = parcelRequire("3NBIB");

var $8oMY3 = parcelRequire("8oMY3");

var $3Mcc1 = parcelRequire("3Mcc1");

var $lefJT = parcelRequire("lefJT");

var $61Cst = parcelRequire("61Cst");

var $gmPq6 = parcelRequire("gmPq6");
// used for extended palette in text color picker
const $9a1f827cbccf3965$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $3Mcc1.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $3Mcc1.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $3Mcc1.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $3Mcc1.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $3Mcc1.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $3Mcc1.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $3Mcc1.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $3Mcc1.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $3Mcc1.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $3Mcc1.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $3Mcc1.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $3Mcc1.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $3Mcc1.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $3Mcc1.N0),
        'White'
    ],
    [
        (0, $3Mcc1.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $3Mcc1.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $3Mcc1.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $3Mcc1.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $3Mcc1.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $3Mcc1.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
const $9a1f827cbccf3965$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $3Mcc1.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $3Mcc1.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $3Mcc1.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $3Mcc1.L800),
        'Dark lime'
    ],
    [
        (0, $3Mcc1.Y800),
        'Dark yellow'
    ],
    [
        (0, $3Mcc1.O800),
        'Dark orange'
    ],
    [
        (0, $3Mcc1.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $3Mcc1.M800),
        'Dark magenta'
    ],
    [
        (0, $3Mcc1.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $3Mcc1.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $3Mcc1.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $3Mcc1.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $3Mcc1.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $3Mcc1.L600),
        'Lime'
    ],
    [
        (0, $3Mcc1.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $3Mcc1.O600),
        'Orange'
    ],
    [
        (0, $3Mcc1.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $3Mcc1.M600),
        'Magenta'
    ],
    [
        (0, $3Mcc1.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $3Mcc1.N0),
        'White'
    ],
    [
        (0, $3Mcc1.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $3Mcc1.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $3Mcc1.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $3Mcc1.L200),
        'Light lime'
    ],
    [
        (0, $3Mcc1.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $3Mcc1.Orange200),
        'Light orange'
    ],
    [
        (0, $3Mcc1.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $3Mcc1.M200),
        'Light magenta'
    ],
    [
        (0, $3Mcc1.P50),
        'Light purple'
    ] // Lavender secret
];
const $9a1f827cbccf3965$export$569885e57444f84a = new Map();
const $9a1f827cbccf3965$export$dee1d8a8cb3ab555 = new Map();
const $9a1f827cbccf3965$export$81e5ed9e84fe2e28 = $9a1f827cbccf3965$export$569885e57444f84a;
$9a1f827cbccf3965$var$colorArrayPalette.forEach(([color, label])=>$9a1f827cbccf3965$export$569885e57444f84a.set(color.toLowerCase(), label));
$9a1f827cbccf3965$var$colorArrayPaletteNew.forEach(([color, label])=>$9a1f827cbccf3965$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label));
const $9a1f827cbccf3965$var$isSupportedTextColor = (hexColor)=>{
    if ($9a1f827cbccf3965$export$569885e57444f84a.has(hexColor)) return true;
    return (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $9a1f827cbccf3965$export$dee1d8a8cb3ab555.has(hexColor);
};
// these are for test only
let $9a1f827cbccf3965$var$testGlobalTheme;
const $9a1f827cbccf3965$export$fd7e0dd2b74807f7 = (theme)=>{
    $9a1f827cbccf3965$var$testGlobalTheme = theme;
};
const $9a1f827cbccf3965$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($9a1f827cbccf3965$var$testGlobalTheme) return {
        colorMode: $9a1f827cbccf3965$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $9a1f827cbccf3965$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/iu;
const $9a1f827cbccf3965$export$32f78bffcd82ff28 = (0, $8oMY3.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($9a1f827cbccf3965$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $gmPq6.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $9a1f827cbccf3965$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $9a1f827cbccf3965$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $61Cst.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($9a1f827cbccf3965$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $lefJT.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("61Cst", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $085c909df06bbd88$export$9c2f408d391feb93);

var $615t3 = parcelRequire("615t3");
function $085c909df06bbd88$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return normalizedHexColor ? (0, $615t3.editorTextPalette)[normalizedHexColor] : undefined;
}

});



parcelRegister("fweje", function(module, exports) {
$parcel$export(module.exports, "borderColorPalette", () => $5a585c15316709b9$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $5a585c15316709b9$export$1edee58a52776cd9);

var $8oMY3 = parcelRequire("8oMY3");

var $3Mcc1 = parcelRequire("3Mcc1");

var $8HRRz = parcelRequire("8HRRz");
const $5a585c15316709b9$var$borderColorArrayPalette = [
    [
        (0, $3Mcc1.N300A),
        'Subtle gray'
    ],
    [
        (0, $3Mcc1.N600),
        'Gray'
    ],
    [
        (0, $3Mcc1.N1000),
        'Bold gray'
    ]
];
const $5a585c15316709b9$export$e4e044c989c86ca7 = new Map();
$5a585c15316709b9$var$borderColorArrayPalette.forEach(([color, label])=>$5a585c15316709b9$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $5a585c15316709b9$export$1edee58a52776cd9 = (0, $8oMY3.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $5a585c15316709b9$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $8HRRz.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});
parcelRegister("8HRRz", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $97c50675b8759265$export$bad3c41dd33cb4bc);

var $615t3 = parcelRequire("615t3");
function $97c50675b8759265$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $615t3.editorBorderPalette)[hexColor.toUpperCase()] : undefined;
}

});


parcelRegister("g37he", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $5ff5f0504c026cf7$export$89015c65f1c75e3f);

var $8oMY3 = parcelRequire("8oMY3");
const $5ff5f0504c026cf7$var$allowedTypes = [
    'wide',
    'full-width'
];
const $5ff5f0504c026cf7$export$89015c65f1c75e3f = (0, $8oMY3.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $5ff5f0504c026cf7$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("44Fx3", function(module, exports) {
$parcel$export(module.exports, "code", () => $105c8981c3e171bd$export$6565f9f03506010b);

var $8oMY3 = parcelRequire("8oMY3");
const $105c8981c3e171bd$export$6565f9f03506010b = (0, $8oMY3.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("7QNFx", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $58545ca6894359d6$export$f3b72f8fc4684ecd);

var $8oMY3 = parcelRequire("8oMY3");
const $58545ca6894359d6$export$f3b72f8fc4684ecd = (0, $8oMY3.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("le0kK", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $bfa846ae0092ad66$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $bfa846ae0092ad66$export$54fd2c36b5cc6731);

var $8oMY3 = parcelRequire("8oMY3");

var $bXuzq = parcelRequire("bXuzq");
const $bfa846ae0092ad66$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $bXuzq.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $bfa846ae0092ad66$export$3024f02c495408d6 = (0, $8oMY3.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$bfa846ae0092ad66$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $bfa846ae0092ad66$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("bXuzq", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $3d932f59c9c92c03$export$c296e2d4365c37a5);
const $3d932f59c9c92c03$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("cBfNk", function(module, exports) {
$parcel$export(module.exports, "em", () => $6049cd94edfef8cc$export$c63c6f932822f543);

var $8oMY3 = parcelRequire("8oMY3");
const $6049cd94edfef8cc$var$emDOM = [
    'em'
];
const $6049cd94edfef8cc$export$c63c6f932822f543 = (0, $8oMY3.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $6049cd94edfef8cc$var$emDOM;
    }
});

});

parcelRegister("3yFC9", function(module, exports) {
$parcel$export(module.exports, "fontSize", () => $cb9d8b6a8815bd3e$export$85e3c3ca0c6fb93);

var $8oMY3 = parcelRequire("8oMY3");
const $cb9d8b6a8815bd3e$var$allowedSizes = [
    'small'
];
const $cb9d8b6a8815bd3e$export$85e3c3ca0c6fb93 = (0, $8oMY3.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $cb9d8b6a8815bd3e$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});

});

parcelRegister("ipVDa", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $9417f22e32886da6$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $9417f22e32886da6$export$54fd2c36b5cc6731);

var $8oMY3 = parcelRequire("8oMY3");

var $bXuzq = parcelRequire("bXuzq");
const $9417f22e32886da6$var$parseFragment = (maybeValue)=>{
    if (!(0, $bXuzq.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $9417f22e32886da6$export$f00aeb236b6f05af = (0, $8oMY3.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$9417f22e32886da6$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $9417f22e32886da6$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("ldGuo", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $c0cd1a268bfb873a$export$480c699bd4ec0d86);

var $8oMY3 = parcelRequire("8oMY3");
const $c0cd1a268bfb873a$export$480c699bd4ec0d86 = (0, $8oMY3.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("b0oSW", function(module, exports) {
$parcel$export(module.exports, "link", () => $d2bc3aa38b190d74$export$9c30223ca0a664fb);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $8oMY3 = parcelRequire("8oMY3");

var $9ISAz = parcelRequire("9ISAz");

var $gYMiz = parcelRequire("gYMiz");

const $d2bc3aa38b190d74$export$9c30223ca0a664fb = (0, $8oMY3.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: (0, $gYMiz.getLinkAttrs)('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: (0, $gYMiz.getLinkAttrs)('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $9ISAz.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});

});
parcelRegister("gYMiz", function(module, exports) {
$parcel$export(module.exports, "getLinkAttrs", () => $162995dce1031e45$export$b5f67017585d1431);

var $fupYg = parcelRequire("fupYg");

var $9ISAz = parcelRequire("9ISAz");

var $lHHx7 = parcelRequire("lHHx7");
const $162995dce1031e45$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $9ISAz.isSafeUrl)(href)) return false;
        if ((0, $fupYg.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $lHHx7.normalizeUrl)(href);
        return attrs;
    };

});
parcelRegister("fupYg", function(module, exports) {
$parcel$export(module.exports, "isRootRelative", () => $f71fc84afcf2f8fc$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ /**
 * checks if root relative link
 */ function $f71fc84afcf2f8fc$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});

parcelRegister("lHHx7", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $54c9162c1be90af1$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $ioQAC = parcelRequire("ioQAC");
function $54c9162c1be90af1$export$6535eb414fa2c8b6(url) {
    const match = (0, $ioQAC.getLinkMatch)(url);
    return match && match.url || '';
}

});
parcelRegister("ioQAC", function(module, exports) {
$parcel$export(module.exports, "getLinkMatch", () => $78205cbba816d694$export$ce9ae45aed3e4ec);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $4MVTx = parcelRequire("4MVTx");

var $ifmoh = parcelRequire("ifmoh");
function $78205cbba816d694$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = (0, $4MVTx.linkifyMatch)(str);
    if (!match.length) match = (0, $ifmoh.linkify).match(str);
    return match && match[0];
}

});
parcelRegister("4MVTx", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $18a136b9f2ed12ae$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $ifmoh = parcelRequire("ifmoh");
const $18a136b9f2ed12ae$export$6f7d7761b97f967 = (text)=>{
    if (!(0, $ifmoh.LINK_REGEXP).test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match((0, $ifmoh.LINK_REGEXP)) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search((0, $ifmoh.LINK_REGEXP));
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};

});
parcelRegister("ifmoh", function(module, exports) {
$parcel$export(module.exports, "linkify", () => $39bc38091e68044b$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "LINK_REGEXP", () => $39bc38091e68044b$export$746d02eae03c72e1);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $8rgUo = parcelRequire("8rgUo");

var $dRkX9 = parcelRequire("dRkX9");





const $39bc38091e68044b$export$8ccbde94d5c7f8e7 = new (0, $8rgUo.default)();
const $39bc38091e68044b$var$URI_WITHOUT_SPACES = /[^\s]+/u;
const $39bc38091e68044b$var$URI_WITHOUT_SPACES_ANCHORED = /^[^\s]+/u;
const $39bc38091e68044b$var$urlWithoutSpacesValidator = {
    validate: (text, pos)=>{
        const tail = text.slice(pos);
        const pattern = (0, $dRkX9.fg)('platform_bugfix_invalid_urls_parsing_in_editor') ? $39bc38091e68044b$var$URI_WITHOUT_SPACES_ANCHORED : $39bc38091e68044b$var$URI_WITHOUT_SPACES;
        const match = tail.match(pattern);
        return match ? match[0].length : 0;
    }
};
const $39bc38091e68044b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $39bc38091e68044b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $39bc38091e68044b$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
$39bc38091e68044b$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$39bc38091e68044b$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
$39bc38091e68044b$export$8ccbde94d5c7f8e7.add('tel:', $39bc38091e68044b$var$urlWithoutSpacesValidator);
$39bc38091e68044b$export$8ccbde94d5c7f8e7.add('file:', $39bc38091e68044b$var$urlWithoutSpacesValidator);
$39bc38091e68044b$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
$39bc38091e68044b$var$tlds.push($39bc38091e68044b$var$tlds2Char);
$39bc38091e68044b$export$8ccbde94d5c7f8e7.tlds($39bc38091e68044b$var$tlds, false);

});
parcelRegister("8rgUo", function(module, exports) {
$parcel$export(module.exports, "default", () => $624df605bbb81c5d$export$2e2bcd8739ae039);

var $5CCmz = parcelRequire("5CCmz");
//
// Helpers
//
// Merge objects
//
function $624df605bbb81c5d$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $624df605bbb81c5d$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $624df605bbb81c5d$var$isString(obj) {
    return $624df605bbb81c5d$var$_class(obj) === '[object String]';
}
function $624df605bbb81c5d$var$isObject(obj) {
    return $624df605bbb81c5d$var$_class(obj) === '[object Object]';
}
function $624df605bbb81c5d$var$isRegExp(obj) {
    return $624df605bbb81c5d$var$_class(obj) === '[object RegExp]';
}
function $624df605bbb81c5d$var$isFunction(obj) {
    return $624df605bbb81c5d$var$_class(obj) === '[object Function]';
}
function $624df605bbb81c5d$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $624df605bbb81c5d$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $624df605bbb81c5d$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $624df605bbb81c5d$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $624df605bbb81c5d$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp(`^\\/\\/${self.re.src_auth}${self.re.src_host_port_strict}${self.re.src_path}`, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            `(?:localhost|(?:(?:${self.re.src_domain})\\.)+${self.re.src_domain_root})` + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp(`^${self.re.src_email_name}@${self.re.src_host_strict}`, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
const $624df605bbb81c5d$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $624df605bbb81c5d$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $624df605bbb81c5d$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $624df605bbb81c5d$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $624df605bbb81c5d$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $5CCmz.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($624df605bbb81c5d$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.email_fuzzy_global = RegExp(untpl(re.tpl_email_fuzzy), 'ig');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_fuzzy_global = RegExp(untpl(re.tpl_link_fuzzy), 'ig');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.link_no_ip_fuzzy_global = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'ig');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error(`(LinkifyIt) Invalid schema "${name}": ${val}`);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($624df605bbb81c5d$var$isObject(val)) {
            if ($624df605bbb81c5d$var$isRegExp(val.validate)) compiled.validate = $624df605bbb81c5d$var$createValidator(val.validate);
            else if ($624df605bbb81c5d$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($624df605bbb81c5d$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $624df605bbb81c5d$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($624df605bbb81c5d$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $624df605bbb81c5d$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($624df605bbb81c5d$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'i');
    self.re.schema_search = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'ig');
    self.re.schema_at_start = RegExp(`^${self.re.schema_search.source}`, 'i');
    self.re.pretest = RegExp(`(${self.re.schema_test.source})|(${self.re.host_fuzzy_test.source})|@`, 'i');
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $624df605bbb81c5d$var$Match(text, schema, index, lastIndex) {
    const raw = text.slice(index, lastIndex);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = schema.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = index;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = lastIndex;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = raw;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = raw;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = raw;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $624df605bbb81c5d$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $624df605bbb81c5d$var$LinkifyIt)) return new $624df605bbb81c5d$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($624df605bbb81c5d$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $624df605bbb81c5d$var$assign({}, $624df605bbb81c5d$var$defaultOptions, options);
    this.__schemas__ = $624df605bbb81c5d$var$assign({}, $624df605bbb81c5d$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $624df605bbb81c5d$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $624df605bbb81c5d$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $624df605bbb81c5d$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $624df605bbb81c5d$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.test = function test(text) {
    if (!text.length) return false;
    let m, re;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            if (this.testSchemaAt(text, m[2], re.lastIndex)) return true;
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) // guess schemaless links
    {
        if (text.search(this.re.host_fuzzy_test) >= 0) {
            if (text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) return true;
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) // guess schemaless emails
    {
        if (text.indexOf('@') >= 0) {
            // We can't skip this check, because this cases are possible:
            // 192.168.1.1@gmail.com, my.in@example.com
            if (text.match(this.re.email_fuzzy) !== null) return true;
        }
    }
    return false;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    const type_schemed = [];
    const type_fuzzy_link = [];
    const type_fuzzy_email = [];
    let m, len, re;
    function choose(a, b) {
        if (!a) return b;
        if (!b) return a;
        if (a.index !== b.index) return a.index < b.index ? a : b;
        return a.lastIndex >= b.lastIndex ? a : b;
    }
    if (!text.length) return null;
    // scan for links with schema
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) type_schemed.push({
                schema: m[2],
                index: m.index + m[1].length,
                lastIndex: m.index + m[0].length + len
            });
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        re = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_link.push({
            schema: '',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        re = this.re.email_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_email.push({
            schema: 'mailto:',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    const indexes = [
        0,
        0,
        0
    ];
    let lastIndex = 0;
    for(;;){
        const candidates = [
            type_schemed[indexes[0]],
            type_fuzzy_email[indexes[1]],
            type_fuzzy_link[indexes[2]]
        ];
        const candidate = choose(choose(candidates[0], candidates[1]), candidates[2]);
        if (!candidate) break;
        if (candidate === candidates[0]) indexes[0]++;
        else if (candidate === candidates[1]) indexes[1]++;
        else indexes[2]++;
        if (candidate.index < lastIndex) continue;
        const match = new $624df605bbb81c5d$var$Match(text, candidate.schema, candidate.index, candidate.lastIndex);
        this.__compiled__[match.schema].normalize(match, this);
        result.push(match);
        lastIndex = candidate.lastIndex;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    const match = new $624df605bbb81c5d$var$Match(text, m[2], m.index + m[1].length, m.index + m[0].length + len);
    this.__compiled__[match.schema].normalize(match, this);
    return match;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $624df605bbb81c5d$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $624df605bbb81c5d$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = `http://${match.url}`;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = `mailto:${match.url}`;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $624df605bbb81c5d$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $624df605bbb81c5d$export$2e2bcd8739ae039 = $624df605bbb81c5d$var$LinkifyIt;

});
parcelRegister("5CCmz", function(module, exports) {
$parcel$export(module.exports, "default", () => $417e427ba477e279$export$2e2bcd8739ae039);
parcelRequire("eZybF");
var $2rrNZ = parcelRequire("2rrNZ");
var $ggzEC = parcelRequire("ggzEC");
var $lcnKw = parcelRequire("lcnKw");
var $5ago6 = parcelRequire("5ago6");
function $417e427ba477e279$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $2rrNZ.default).source;
    re.src_Cc = (0, $ggzEC.default).source;
    re.src_Z = (0, $5ago6.default).source;
    re.src_P = (0, $lcnKw.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = `(?:(?!${text_separators}|${re.src_ZPCc})${re.src_Any})`;
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    // Length is capped to exclude possible rescans till the end and avoid O(n^2)
    // DoS. No standard limit, just take something reasonable.
    re.src_auth = `(?:(?:(?!${re.src_ZCc}|[@/\\[\\]()]).){1,50}@)?`;
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = `(?=$|${text_separators}|${re.src_ZPCc})` + `(?!${opts['---'] ? '-(?!--)|' : '-|'}_|:\\d|\\.-|\\.(?!$|${re.src_ZPCc}))`;
    re.src_path = "(?:[/?#](?:" + `(?!${re.src_ZCc}|${text_separators}|[()[\\]{}.,"'?!\\-;]).|` + `\\[(?:(?!${re.src_ZCc}|\\]).)*\\]|` + `\\((?:(?!${re.src_ZCc}|[)]).)*\\)|` + `\\{(?:(?!${re.src_ZCc}|[}]).)*\\}|` + `\\"(?:(?!${re.src_ZCc}|["]).)+\\"|` + `\\'(?:(?!${re.src_ZCc}|[']).)+\\'|` + // allow `I'm_king` if no pair found
    `\\'(?=${re.src_pseudo_letter}|[-])|` + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + `\\.(?!${re.src_ZCc}|[.]|$)|` + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    `,(?!${re.src_ZCc}|$)|` + // allow `;` if not followed by space-like char
    `;(?!${re.src_ZCc}|$)|` + // allow `!!!` in paths, but not at the end
    `\\!+(?!${re.src_ZCc}|[!]|$)|` + `\\?(?!${re.src_ZCc}|[?]|$)` + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    // Max name length capped to 64 chars (RFC 5321). This also prevents O(n^2)
    // rescans to the end on inputs like `mailto:mailto:...`
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]{0,63}';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + `${re.src_pseudo_letter}{1,63}` + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + `(?:${re.src_pseudo_letter})` + '|' + `(?:${re.src_pseudo_letter}(?:-|${re.src_pseudo_letter}){0,61}${re.src_pseudo_letter})` + ')';
    re.src_host = '(?:' + // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
    `(?:(?:(?:${re.src_domain})\\.)*${re.src_domain})` + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))` + ')';
    re.tpl_host_no_ip_fuzzy = `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))`;
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:${re.src_ZPCc}|>|$))`;
    re.tpl_email_fuzzy = `(^|${text_separators}|"|\\(|${re.src_ZCc})` + `(${re.src_email_name}@${re.tpl_host_fuzzy_strict})`;
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_fuzzy_strict}${re.src_path})`;
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_no_ip_fuzzy_strict}${re.src_path})`;
    return re;
}

});
parcelRegister("eZybF", function(module, exports) {
$parcel$export(module.exports, "Any", () => (parcelRequire("2rrNZ")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("ggzEC")).default);
$parcel$export(module.exports, "Cf", () => (parcelRequire("fJmXA")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("lcnKw")).default);
$parcel$export(module.exports, "S", () => (parcelRequire("bPYH0")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("5ago6")).default);

var $2rrNZ = parcelRequire("2rrNZ");

var $ggzEC = parcelRequire("ggzEC");

var $fJmXA = parcelRequire("fJmXA");

var $lcnKw = parcelRequire("lcnKw");

var $bPYH0 = parcelRequire("bPYH0");

var $5ago6 = parcelRequire("5ago6");

});
parcelRegister("2rrNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c73abf290c31613$export$2e2bcd8739ae039);
var $1c73abf290c31613$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("ggzEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd79cc28f4f6d57b$export$2e2bcd8739ae039);
var $bd79cc28f4f6d57b$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("fJmXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b73cde5a190bdfa4$export$2e2bcd8739ae039);
var $b73cde5a190bdfa4$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("lcnKw", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6ed241351bf3c2e$export$2e2bcd8739ae039);
var $f6ed241351bf3c2e$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("bPYH0", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e3896d513e66cf$export$2e2bcd8739ae039);
var $89e3896d513e66cf$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("5ago6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c2a992bbd617e83$export$2e2bcd8739ae039);
var $3c2a992bbd617e83$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});










parcelRegister("i39zf", function(module, exports) {
$parcel$export(module.exports, "strike", () => $02db7fadecf41811$export$4899a95d70ec5056);

var $8oMY3 = parcelRequire("8oMY3");
const $02db7fadecf41811$export$4899a95d70ec5056 = (0, $8oMY3.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("7FN4W", function(module, exports) {
$parcel$export(module.exports, "strong", () => $4e978eaf0f06fad8$export$59ae2c325a998f89);

var $8oMY3 = parcelRequire("8oMY3");
const $4e978eaf0f06fad8$var$strongDOM = [
    'strong'
];
const $4e978eaf0f06fad8$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9]\d{2,})$/u;
const $4e978eaf0f06fad8$export$59ae2c325a998f89 = (0, $8oMY3.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $4e978eaf0f06fad8$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $4e978eaf0f06fad8$var$strongDOM;
    }
});

});

parcelRegister("dulEt", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $e533d40050c77ea5$export$b3401ee80eb31041);

var $8oMY3 = parcelRequire("8oMY3");
function $e533d40050c77ea5$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $e533d40050c77ea5$export$b3401ee80eb31041 = (0, $8oMY3.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$e533d40050c77ea5$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$e533d40050c77ea5$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("2nNKH", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $f61028231561c0bf$export$20af3dabbb5538df);

var $8oMY3 = parcelRequire("8oMY3");

var $3Mcc1 = parcelRequire("3Mcc1");
const $f61028231561c0bf$export$20af3dabbb5538df = (0, $8oMY3.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $3Mcc1.B400)}`
            }
        ];
    }
});

});

parcelRegister("aw5xJ", function(module, exports) {
$parcel$export(module.exports, "underline", () => $5f23e615e12991b6$export$425327af25286e5e);

var $8oMY3 = parcelRequire("8oMY3");
const $5f23e615e12991b6$export$425327af25286e5e = (0, $8oMY3.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("dVToP", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $3596058763895719$export$30d78d5eb6719bb8);

var $8oMY3 = parcelRequire("8oMY3");
const $3596058763895719$export$30d78d5eb6719bb8 = (0, $8oMY3.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("8x0rq", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $abb768286a5c03b6$export$a316dc07ff5182a2);

var $8oMY3 = parcelRequire("8oMY3");
const $abb768286a5c03b6$export$a316dc07ff5182a2 = (0, $8oMY3.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});


parcelRegister("45x64", function(module, exports) {
$parcel$export(module.exports, "nodesInOrder", () => $79896bbf7a7ea3f9$export$77d2c0ec1ddbfa6c);

var $8Nxxj = parcelRequire("8Nxxj");
var $cd0UN = parcelRequire("cd0UN");
var $eC92i = parcelRequire("eC92i");
var $laaDK = parcelRequire("laaDK");
var $MCCgU = parcelRequire("MCCgU");
var $3y4dy = parcelRequire("3y4dy");
var $iq16s = parcelRequire("iq16s");
var $jZozI = parcelRequire("jZozI");
var $gj3iP = parcelRequire("gj3iP");
var $3eFUn = parcelRequire("3eFUn");
var $1dOrX = parcelRequire("1dOrX");
var $jwm0O = parcelRequire("jwm0O");
var $bOVzM = parcelRequire("bOVzM");
var $7gCXC = parcelRequire("7gCXC");
var $gapZI = parcelRequire("gapZI");
var $23LTd = parcelRequire("23LTd");
var $l5yqo = parcelRequire("l5yqo");
var $exRcf = parcelRequire("exRcf");
var $1GMi7 = parcelRequire("1GMi7");
var $2Avts = parcelRequire("2Avts");
var $iglh1 = parcelRequire("iglh1");
var $jXulL = parcelRequire("jXulL");
var $arpnd = parcelRequire("arpnd");
var $knCYS = parcelRequire("knCYS");
var $3CMyJ = parcelRequire("3CMyJ");
var $bNXHl = parcelRequire("bNXHl");
var $608PD = parcelRequire("608PD");
var $9XvY7 = parcelRequire("9XvY7");
var $2KlGf = parcelRequire("2KlGf");
var $1CJRu = parcelRequire("1CJRu");
var $6s15K = parcelRequire("6s15K");
var $e224s = parcelRequire("e224s");
var $47k1x = parcelRequire("47k1x");
var $6E6Kd = parcelRequire("6E6Kd");
var $d1R2l = parcelRequire("d1R2l");
var $flh6x = parcelRequire("flh6x");
var $4rqGA = parcelRequire("4rqGA");
var $kUt8q = parcelRequire("kUt8q");
var $gITKe = parcelRequire("gITKe");
var $djAdL = parcelRequire("djAdL");
var $1oEoc = parcelRequire("1oEoc");
var $cdpdE = parcelRequire("cdpdE");
var $63Q5S = parcelRequire("63Q5S");
var $eohEq = parcelRequire("eohEq");
var $7mXyo = parcelRequire("7mXyo");
var $gtZE7 = parcelRequire("gtZE7");
var $7eKWK = parcelRequire("7eKWK");
var $e2bmr = parcelRequire("e2bmr");

var $viZe0 = parcelRequire("viZe0");
const $79896bbf7a7ea3f9$export$77d2c0ec1ddbfa6c = [
    {
        name: 'doc',
        spec: (0, $7gCXC.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $kUt8q.paragraph)
    },
    {
        name: 'text',
        spec: (0, $7mXyo.text)
    },
    {
        name: 'bulletList',
        spec: (0, $MCCgU.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $4rqGA.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $1CJRu.listItem)
    },
    {
        name: 'heading',
        spec: (0, $knCYS.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $exRcf.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $iq16s.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $1GMi7.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $2Avts.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $djAdL.rule)
    },
    {
        name: 'bodiedRule',
        spec: (0, $viZe0.bodiedRule)
    },
    {
        name: 'image',
        spec: (0, $3CMyJ.image)
    },
    {
        name: 'mention',
        spec: (0, $d1R2l.mention)
    },
    {
        name: 'caption',
        spec: (0, $3y4dy.caption)
    },
    {
        name: 'media',
        spec: (0, $6s15K.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $e224s.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $6E6Kd.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $47k1x.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $gITKe.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $2KlGf.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $9XvY7.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $arpnd.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $23LTd.emoji)
    },
    {
        name: 'table',
        spec: (0, $63Q5S.table)
    },
    {
        name: 'tableCell',
        spec: (0, $63Q5S.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $63Q5S.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $63Q5S.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $jZozI.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $3eFUn.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $gj3iP.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $bOVzM.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $jwm0O.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $eohEq.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $cd0UN.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $cd0UN.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $1dOrX.date)
    },
    {
        name: 'status',
        spec: (0, $1oEoc.status)
    },
    {
        name: 'expand',
        spec: (0, $l5yqo.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $flh6x.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $iglh1.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $608PD.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $eC92i.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $jXulL.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $jXulL.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $bNXHl.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $8Nxxj.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $gapZI.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $cdpdE.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $laaDK.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $gtZE7.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $7eKWK.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $e2bmr.unsupportedInline)
    }
];

});
parcelRegister("8Nxxj", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $3045e4c360ed9e40$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $3045e4c360ed9e40$export$9894f24949f094e5);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $3045e4c360ed9e40$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $3045e4c360ed9e40$export$c4c2f833baaebdb8 = (0, $joxKE.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$3045e4c360ed9e40$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$3045e4c360ed9e40$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
const $3045e4c360ed9e40$export$9894f24949f094e5 = (0, $joxKE.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$3045e4c360ed9e40$var$getCommonAttributesFromDom(dom),
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$3045e4c360ed9e40$var$getCommonAttributesFromDom(dom),
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2, _node$attrs3;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});
parcelRegister("joxKE", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $b3a2deb6b74d9277$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $b3a2deb6b74d9277$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $b3a2deb6b74d9277$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $b3a2deb6b74d9277$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $b3a2deb6b74d9277$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedRuleStage0", () => $b3a2deb6b74d9277$export$fedbe6c839176437);
$parcel$export(module.exports, "bodiedSyncBlock", () => $b3a2deb6b74d9277$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $b3a2deb6b74d9277$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $b3a2deb6b74d9277$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $b3a2deb6b74d9277$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $b3a2deb6b74d9277$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $b3a2deb6b74d9277$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $b3a2deb6b74d9277$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $b3a2deb6b74d9277$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $b3a2deb6b74d9277$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $b3a2deb6b74d9277$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $b3a2deb6b74d9277$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $b3a2deb6b74d9277$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $b3a2deb6b74d9277$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $b3a2deb6b74d9277$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $b3a2deb6b74d9277$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $b3a2deb6b74d9277$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $b3a2deb6b74d9277$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $b3a2deb6b74d9277$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $b3a2deb6b74d9277$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $b3a2deb6b74d9277$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $b3a2deb6b74d9277$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $b3a2deb6b74d9277$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $b3a2deb6b74d9277$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $b3a2deb6b74d9277$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $b3a2deb6b74d9277$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $b3a2deb6b74d9277$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $b3a2deb6b74d9277$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $b3a2deb6b74d9277$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $b3a2deb6b74d9277$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $b3a2deb6b74d9277$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $b3a2deb6b74d9277$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $b3a2deb6b74d9277$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $b3a2deb6b74d9277$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $b3a2deb6b74d9277$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $b3a2deb6b74d9277$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $b3a2deb6b74d9277$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $b3a2deb6b74d9277$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $b3a2deb6b74d9277$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelC1Stage0", () => $b3a2deb6b74d9277$export$6f6742e395e02fdc);
$parcel$export(module.exports, "paragraph", () => $b3a2deb6b74d9277$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $b3a2deb6b74d9277$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $b3a2deb6b74d9277$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $b3a2deb6b74d9277$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $b3a2deb6b74d9277$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $b3a2deb6b74d9277$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $b3a2deb6b74d9277$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $b3a2deb6b74d9277$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $b3a2deb6b74d9277$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $b3a2deb6b74d9277$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $b3a2deb6b74d9277$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $b3a2deb6b74d9277$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $b3a2deb6b74d9277$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $b3a2deb6b74d9277$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $b3a2deb6b74d9277$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $b3a2deb6b74d9277$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $b3a2deb6b74d9277$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $b3a2deb6b74d9277$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $aKmaa = parcelRequire("aKmaa");
const $b3a2deb6b74d9277$export$c4c2f833baaebdb8 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $b3a2deb6b74d9277$export$67dc04e652a298ca = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $b3a2deb6b74d9277$export$199922e5af8e9a6 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $b3a2deb6b74d9277$export$16018c61064a18df = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$27903d543b563e39 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$8bbe5aa5bba36cc1 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$e7320d153c538837 = (0, $aKmaa.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$208411233915368e = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$fedbe6c839176437 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$e92c7e4302dd4371 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel_c1 | panel | rule | bodiedRule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$a140c94e5ea26bee = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$8e3c2dfdc4f0453d = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $b3a2deb6b74d9277$export$7bb0d5c671655cc4 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $b3a2deb6b74d9277$export$e4f1c66d84049f8b = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $b3a2deb6b74d9277$export$daf889beb5092f95 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$e6e4878f43c27cab = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$3e6d667072febc87 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$324d90190a8b822a = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$47988d68fe575725 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$6959e16eeff859b4 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $b3a2deb6b74d9277$export$62d45a65fb43d95e = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$2a111da947c407d2 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | rule | codeBlock | panel | panel_c1_root_only | bodiedRule | extension | bodiedExtension | multiBodiedExtension | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation breakout'
});
const $b3a2deb6b74d9277$export$be4283d9a1cb1ff6 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$a19185d1233fc4b2 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$f5574b5d45fc2112 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$9f77e0932fb78f72 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$7e3788972005cc72 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$1b45514b112dd749 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$ad06037362b3c3b3 = (0, $aKmaa.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$243bc54b0560ecc = (0, $aKmaa.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$3e3366ebd634cc62 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$a8baf338431a691 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$b555be60c7703afb = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$371da9dd35aba193 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $b3a2deb6b74d9277$export$46e4a324ac90507f = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$1b0c1557b234fa00 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$85461f751c457cc2 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$2b380a0f7e250af1 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$5c452ff88e35e47d = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $b3a2deb6b74d9277$export$cbf8224b64e0d942 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $b3a2deb6b74d9277$export$2f4e72b9459914ad = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $b3a2deb6b74d9277$export$16b353b2649bd8d9 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$b3b1e36c2105006d = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$ab76e7c03cd6f650 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $b3a2deb6b74d9277$export$b3b6a70a7fa4a5be = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $b3a2deb6b74d9277$export$cdae19acb0a520fd = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $b3a2deb6b74d9277$export$206007566ca0aca5 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $b3a2deb6b74d9277$export$76c7e83ecc9cdf05 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$987d49ffe1b0900f = (0, $aKmaa.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$2855e964765eac9 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $b3a2deb6b74d9277$export$38bab695e3f720f1 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$969fe3781ca15058 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $b3a2deb6b74d9277$export$8d067f22dc2d1254 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$7e767666f2ce108a = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$4bd9a38995f6bf50 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$db83999c14438df4 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$46f790bd65f760d0 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$6f4c18ddc3950a66 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $b3a2deb6b74d9277$export$750e45819f66d9d0 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $b3a2deb6b74d9277$export$63cadbf5f4296627 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | bodiedRule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$f03786aa6312d1e4 = (0, $aKmaa.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $b3a2deb6b74d9277$export$a5dc81035676e7a = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$21f42ab9b6679f44 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$862432e0a10d1bc1 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$6f6742e395e02fdc = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$7eb9416336a42c2b = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$9c206ddddb32a9b = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$4f98472e6dc14293 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$b0710a201beac6b2 = (0, $aKmaa.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$ea332b61641b0588 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$a1f41dc4901771f8 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$c7187bbd1a7a9244 = (0, $aKmaa.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $b3a2deb6b74d9277$export$fbeb3a3956e8a3c7 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$1d53b70195c9c417 = (0, $aKmaa.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$78cca5eef2450890 = (0, $aKmaa.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$17f7139bf40eed49 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $b3a2deb6b74d9277$export$471f7ae5c4103ae1 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$b6ce52be8d7a261 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$faab0ca9701d7048 = (0, $aKmaa.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$9852986a3ec5f6a0 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $b3a2deb6b74d9277$export$ce086a560a1d05f5 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $b3a2deb6b74d9277$export$e1e720e5f4603e6a = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $b3a2deb6b74d9277$export$abf39ca178940ff3 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $b3a2deb6b74d9277$export$48884d2a5190dc73 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $b3a2deb6b74d9277$export$2a5a518232fa1a97 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $b3a2deb6b74d9277$export$ce666bf02318c957 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $b3a2deb6b74d9277$export$7d657479499397 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $b3a2deb6b74d9277$export$6d8b0ef52e2e6390 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$375b6afcc5f4d291 = (0, $aKmaa.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $b3a2deb6b74d9277$export$6f093cfa640b7166 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline'
});
const $b3a2deb6b74d9277$export$5ea06bc686c59dc2 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline'
});
const $b3a2deb6b74d9277$export$93256a4c17b33a82 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline'
});
const $b3a2deb6b74d9277$export$a12828d0f14a2762 = (0, $aKmaa.createPMNodeSpecFactory)({});
const $b3a2deb6b74d9277$export$44b79b0979d0f0f7 = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $b3a2deb6b74d9277$export$310ebe0d80122e9b = (0, $aKmaa.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("aKmaa", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $48c66425dfee3fc4$export$bf0a80f00e2b8ff6);
const $48c66425dfee3fc4$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});


parcelRegister("1FHzN", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $803e969377017a11$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $803e969377017a11$export$31b40729666a4ae0);
const $803e969377017a11$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $803e969377017a11$var$staticValue = false;
const $803e969377017a11$export$31b40729666a4ae0 = {
    setStatic (value) {
        $803e969377017a11$var$staticValue = value;
    },
    generate () {
        return $803e969377017a11$var$staticValue || $803e969377017a11$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("cd0UN", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $c016e8101504b8fb$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $c016e8101504b8fb$export$16018c61064a18df);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $c016e8101504b8fb$export$6d8b0ef52e2e6390 = (0, $joxKE.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $1FHzN.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c016e8101504b8fb$export$16018c61064a18df = (0, $joxKE.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $1FHzN.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("eC92i", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $f919b02b1182c22c$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtensionRootOnlyStage0", () => $f919b02b1182c22c$export$8bbe5aa5bba36cc1);

var $joxKE = parcelRequire("joxKE");

var $fsHLO = parcelRequire("fsHLO");
const $f919b02b1182c22c$export$27903d543b563e39 = (0, $joxKE.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fsHLO.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $f919b02b1182c22c$export$8bbe5aa5bba36cc1 = {
    ...$f919b02b1182c22c$export$27903d543b563e39,
    marks: `breakout ${$f919b02b1182c22c$export$27903d543b563e39.marks}`
};

});
parcelRegister("fsHLO", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $bb86814bfe402ddc$export$1765e2758fc47004);

var $hyAqH = parcelRequire("hyAqH");
const $bb86814bfe402ddc$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = (0, $hyAqH.isValidLayout)(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});
parcelRegister("hyAqH", function(module, exports) {
$parcel$export(module.exports, "isValidLayout", () => $1cb71059294fa5bb$export$d5f21755dc782a4a);
const $1cb71059294fa5bb$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};

});



parcelRegister("laaDK", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $11406d8c6646bb5c$export$e92c7e4302dd4371);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $11406d8c6646bb5c$export$e92c7e4302dd4371 = (0, $joxKE.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $1FHzN.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("MCCgU", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $530744bceb6716b7$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $530744bceb6716b7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $530744bceb6716b7$export$dfd406053b2bab40);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $530744bceb6716b7$export$5f25a39efab3b58b = '.ak-ul';
const $530744bceb6716b7$export$a140c94e5ea26bee = (0, $joxKE.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $530744bceb6716b7$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $530744bceb6716b7$export$dfd406053b2bab40 = (0, $joxKE.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $530744bceb6716b7$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3y4dy", function(module, exports) {
$parcel$export(module.exports, "caption", () => $9d398ff75bea73bd$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $9d398ff75bea73bd$export$b5d01ee303c467aa);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $9d398ff75bea73bd$export$8e3c2dfdc4f0453d = (0, $joxKE.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $9d398ff75bea73bd$export$b5d01ee303c467aa = (0, $joxKE.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("iq16s", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $c56dcf0177ae41a2$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $c56dcf0177ae41a2$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $c56dcf0177ae41a2$export$3f75de798a0b5356);

var $7H6Cr = parcelRequire("7H6Cr");

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $c56dcf0177ae41a2$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $c56dcf0177ae41a2$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $c56dcf0177ae41a2$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $c56dcf0177ae41a2$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $c56dcf0177ae41a2$var$LANGUAGE_CLASS_REGEX = /(?:^|\s)language-([^\s]+)/u;
const $c56dcf0177ae41a2$var$TRAILING_NEWLINE_REGEX = /\n$/u;
const $c56dcf0177ae41a2$var$extractLanguageFromClass = (className)=>{
    const result = $c56dcf0177ae41a2$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $c56dcf0177ae41a2$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($c56dcf0177ae41a2$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $c56dcf0177ae41a2$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $c56dcf0177ae41a2$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $c56dcf0177ae41a2$export$7bb0d5c671655cc4 = (0, $joxKE.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $c56dcf0177ae41a2$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $c56dcf0177ae41a2$var$getLanguageFromEditorStyle(dom.parentElement) || $c56dcf0177ae41a2$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $c56dcf0177ae41a2$var$removeLastNewLine(dom);
                const wrapAttr = dom.getAttribute('data-wrap');
                const isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                const wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                const hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $c56dcf0177ae41a2$var$parseCodeFromHtml(domNode);
                return code ? (0, $7H6Cr.Fragment).from(schema.text(code)) : (0, $7H6Cr.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $c56dcf0177ae41a2$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $c56dcf0177ae41a2$export$3f75de798a0b5356 = (0, $joxKE.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $c56dcf0177ae41a2$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $c56dcf0177ae41a2$var$getLanguageFromEditorStyle(dom.parentElement) || $c56dcf0177ae41a2$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $c56dcf0177ae41a2$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $c56dcf0177ae41a2$var$parseCodeFromHtml(domNode);
                return code ? (0, $7H6Cr.Fragment).from(schema.text(code)) : (0, $7H6Cr.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("jZozI", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $d4e24f8916bebb16$export$daf889beb5092f95);

var $joxKE = parcelRequire("joxKE");
const $d4e24f8916bebb16$var$name = 'confluenceJiraIssue';
const $d4e24f8916bebb16$export$daf889beb5092f95 = (0, $joxKE.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$d4e24f8916bebb16$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $d4e24f8916bebb16$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("gj3iP", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $ac22ca69189227b5$export$e6e4878f43c27cab);

var $joxKE = parcelRequire("joxKE");
const $ac22ca69189227b5$var$name = 'confluenceUnsupportedBlock';
const $ac22ca69189227b5$export$e6e4878f43c27cab = (0, $joxKE.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $ac22ca69189227b5$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$ac22ca69189227b5$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("3eFUn", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $3392d4e4f87f8590$export$3e6d667072febc87);

var $joxKE = parcelRequire("joxKE");
const $3392d4e4f87f8590$var$name = 'confluenceUnsupportedInline';
const $3392d4e4f87f8590$export$3e6d667072febc87 = (0, $joxKE.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $3392d4e4f87f8590$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$3392d4e4f87f8590$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("1dOrX", function(module, exports) {
$parcel$export(module.exports, "date", () => $114b50e4e497c46b$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $114b50e4e497c46b$export$a6a035390e3921b2);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $114b50e4e497c46b$export$324d90190a8b822a = (0, $joxKE.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $114b50e4e497c46b$export$a6a035390e3921b2 = (0, $joxKE.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("jwm0O", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $5793d3b2e1f379f4$export$6959e16eeff859b4);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $5793d3b2e1f379f4$export$6959e16eeff859b4 = (0, $joxKE.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $1FHzN.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bOVzM", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $4fc1e3fc147fcdf3$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $4fc1e3fc147fcdf3$export$62d45a65fb43d95e);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $4fc1e3fc147fcdf3$var$name = 'decisionList';
const $4fc1e3fc147fcdf3$export$a5393ce68c2ff601 = `[data-node-type="${$4fc1e3fc147fcdf3$var$name}"]`;
const $4fc1e3fc147fcdf3$export$62d45a65fb43d95e = (0, $joxKE.decisionList)({
    parseDOM: [
        {
            tag: `ol${$4fc1e3fc147fcdf3$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $4fc1e3fc147fcdf3$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7gCXC", function(module, exports) {
$parcel$export(module.exports, "doc", () => $908352b3b7bb0052$export$2a111da947c407d2);

var $joxKE = parcelRequire("joxKE");
const $908352b3b7bb0052$export$2a111da947c407d2 = (0, $joxKE.doc)({});

});

parcelRegister("gapZI", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $e89ad2c762ec4db0$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $e89ad2c762ec4db0$export$36734475a7f6fd3e);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $e89ad2c762ec4db0$export$be4283d9a1cb1ff6 = (0, $joxKE.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $e89ad2c762ec4db0$export$36734475a7f6fd3e = (0, $joxKE.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("23LTd", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $b668ddeaddd40fc5$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $b668ddeaddd40fc5$export$ebb3b3c7a0ac9936);

var $joxKE = parcelRequire("joxKE");

var $bKEpR = parcelRequire("bKEpR");

var $kpESB = parcelRequire("kpESB");

var $1FHzN = parcelRequire("1FHzN");
const $b668ddeaddd40fc5$export$a19185d1233fc4b2 = (0, $joxKE.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $bKEpR.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $kpESB.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $b668ddeaddd40fc5$export$ebb3b3c7a0ac9936 = (0, $joxKE.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $bKEpR.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $kpESB.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $b668ddeaddd40fc5$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("bKEpR", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $793988345e3314a8$export$f61e93bda2a8b420);

var $i5dwV = parcelRequire("i5dwV");

var $1fNQj = parcelRequire("1fNQj");
function $793988345e3314a8$export$f61e93bda2a8b420(acName) {
    const emojiData = (0, $i5dwV.acNameToEmojiMap)[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: (0, $1fNQj.DEFAULT_EMOJI_ID),
        shortName: `:${acName}:`,
        text: ''
    };
}

});
parcelRegister("i5dwV", function(module, exports) {
$parcel$export(module.exports, "acNameToEmojiMap", () => $95a3bfaa4f8f4507$export$7962498ea8ccffac);
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $95a3bfaa4f8f4507$export$7962498ea8ccffac = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};

});

parcelRegister("1fNQj", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_EMOJI_ID", () => $855e4e678017899a$export$936e67708ade64a9);
$parcel$export(module.exports, "DEFAULT_EMOJI_ACNAME", () => $855e4e678017899a$export$209b328f48821d5f);
$parcel$export(module.exports, "HC_EMOTICON_PREFIX", () => $855e4e678017899a$export$1c102a772ecd912c);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 




const $855e4e678017899a$export$936e67708ade64a9 = '2b50';
const $855e4e678017899a$export$209b328f48821d5f = 'blue-star';
const $855e4e678017899a$export$1c102a772ecd912c = 'atlassian-';

});


parcelRegister("kpESB", function(module, exports) {
$parcel$export(module.exports, "acShortcutToEmoji", () => $ce9a3ab9204fec85$export$441f8b58f5790a68);

var $1fNQj = parcelRequire("1fNQj");
function $ce9a3ab9204fec85$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${0, $1fNQj.HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}

});


parcelRegister("l5yqo", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $a1d41dcdab1ff2b9$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $a1d41dcdab1ff2b9$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $a1d41dcdab1ff2b9$export$54fd2c36b5cc6731);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
function $a1d41dcdab1ff2b9$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $a1d41dcdab1ff2b9$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $a1d41dcdab1ff2b9$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $a1d41dcdab1ff2b9$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $a1d41dcdab1ff2b9$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $a1d41dcdab1ff2b9$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $a1d41dcdab1ff2b9$export$7b80cba28d10b2c1 = (0, $joxKE.expand)($a1d41dcdab1ff2b9$var$nodeSpecOptions);
const $a1d41dcdab1ff2b9$export$2ae5e7565ff9ffa6 = (0, $joxKE.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $a1d41dcdab1ff2b9$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $a1d41dcdab1ff2b9$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $a1d41dcdab1ff2b9$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $a1d41dcdab1ff2b9$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a1d41dcdab1ff2b9$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("exRcf", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $1ddc97e0aec940b7$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $1ddc97e0aec940b7$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $1ddc97e0aec940b7$export$950ebf43f3364a0f);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $1ddc97e0aec940b7$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $1ddc97e0aec940b7$export$67dc04e652a298ca = (0, $joxKE.blockquoteLegacy)($1ddc97e0aec940b7$var$nodeSpecOptions);
const $1ddc97e0aec940b7$export$70a64939da3e8455 = (0, $joxKE.blockquote)($1ddc97e0aec940b7$var$nodeSpecOptions);
const $1ddc97e0aec940b7$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
const $1ddc97e0aec940b7$export$950ebf43f3364a0f = (0, $joxKE.blockquote)($1ddc97e0aec940b7$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("1GMi7", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", () => $fe33821a584e562c$export$ce20b13564211141);

var $joxKE = parcelRequire("joxKE");

var $dtNv3 = parcelRequire("dtNv3");
const $fe33821a584e562c$export$ce20b13564211141 = (allowCustomPanel)=>(0, $joxKE.panel)((0, $dtNv3.createPanelNodeSpecOptions)(allowCustomPanel));

});
parcelRegister("dtNv3", function(module, exports) {
$parcel$export(module.exports, "createPanelNodeSpecOptions", () => $4bec659238d6237a$export$1f22c1e22ac5e390);

var $lvjrY = parcelRequire("lvjrY");

var $erTF0 = parcelRequire("erTF0");
const $4bec659238d6237a$export$1f22c1e22ac5e390 = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>(0, $erTF0.getParseDOMAttrs)(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = (0, $lvjrY.getDomAttrs)(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });

});
parcelRegister("lvjrY", function(module, exports) {
$parcel$export(module.exports, "getDomAttrs", () => $0f28de0ae59effb5$export$573b838ca5694549);
const $0f28de0ae59effb5$export$573b838ca5694549 = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};

});

parcelRegister("erTF0", function(module, exports) {
$parcel$export(module.exports, "getParseDOMAttrs", () => $3c9b190cd0cfa178$export$f5f376335f9d8c6b);

var $1FHzN = parcelRequire("1FHzN");

var $39FD9 = parcelRequire("39FD9");
const $3c9b190cd0cfa178$export$f5f376335f9d8c6b = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $1FHzN.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === (0, $39FD9.PanelType).CUSTOM ? (0, $39FD9.PanelType).INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};

});
parcelRegister("39FD9", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $839e38c1c6d6e74b$export$969277cf61e5a7aa);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 








var $839e38c1c6d6e74b$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});

});




parcelRegister("2Avts", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1", () => $0c1fd684a88ff02d$export$c158ac2988d2f011);

var $joxKE = parcelRequire("joxKE");

var $dtNv3 = parcelRequire("dtNv3");
const $0c1fd684a88ff02d$export$c158ac2988d2f011 = (allowCustomPanel)=>(0, $joxKE.panelC1Stage0)((0, $dtNv3.createPanelNodeSpecOptions)(allowCustomPanel));

});

parcelRegister("iglh1", function(module, exports) {
$parcel$export(module.exports, "extension", () => $df19591ba5e4237f$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionRootOnlyStage0", () => $df19591ba5e4237f$export$ad06037362b3c3b3);
$parcel$export(module.exports, "extensionWithAnnotationStage0", () => $df19591ba5e4237f$export$3e3366ebd634cc62);
$parcel$export(module.exports, "extensionRootOnlyWithAnnotationStage0", () => $df19591ba5e4237f$export$243bc54b0560ecc);

var $joxKE = parcelRequire("joxKE");

var $fsHLO = parcelRequire("fsHLO");
const $df19591ba5e4237f$export$1b45514b112dd749 = (0, $joxKE.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fsHLO.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
const $df19591ba5e4237f$export$ad06037362b3c3b3 = {
    ...$df19591ba5e4237f$export$1b45514b112dd749,
    marks: 'breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $df19591ba5e4237f$export$3e3366ebd634cc62 = {
    ...$df19591ba5e4237f$export$1b45514b112dd749,
    marks: 'annotation dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $df19591ba5e4237f$export$243bc54b0560ecc = {
    ...$df19591ba5e4237f$export$1b45514b112dd749,
    marks: 'annotation breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("jXulL", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $dd573cbcd2915a1b$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $dd573cbcd2915a1b$export$c3c04d555a8b9013);
$parcel$export(module.exports, "multiBodiedExtensionRootOnlyStage0", () => $dd573cbcd2915a1b$export$6f4c18ddc3950a66);

var $joxKE = parcelRequire("joxKE");

var $fsHLO = parcelRequire("fsHLO");
const $dd573cbcd2915a1b$export$4fdcae991fd743e7 = (0, $joxKE.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $dd573cbcd2915a1b$export$c3c04d555a8b9013 = (0, $joxKE.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $fsHLO.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $dd573cbcd2915a1b$export$6f4c18ddc3950a66 = {
    ...$dd573cbcd2915a1b$export$c3c04d555a8b9013,
    marks: `breakout ${$dd573cbcd2915a1b$export$c3c04d555a8b9013.marks}`
};

});

parcelRegister("arpnd", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $4d061ac4d9f27c66$export$371da9dd35aba193);

var $joxKE = parcelRequire("joxKE");
const $4d061ac4d9f27c66$export$371da9dd35aba193 = (0, $joxKE.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("knCYS", function(module, exports) {
$parcel$export(module.exports, "heading", () => $1f1f1b986efe88a3$export$46e4a324ac90507f);

var $joxKE = parcelRequire("joxKE");
const $1f1f1b986efe88a3$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $1f1f1b986efe88a3$export$46e4a324ac90507f = (0, $joxKE.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $1f1f1b986efe88a3$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $1f1f1b986efe88a3$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $1f1f1b986efe88a3$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $1f1f1b986efe88a3$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $1f1f1b986efe88a3$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $1f1f1b986efe88a3$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("3CMyJ", function(module, exports) {
$parcel$export(module.exports, "image", () => $7b08b53ec75955c7$export$5c452ff88e35e47d);

var $joxKE = parcelRequire("joxKE");
const $7b08b53ec75955c7$export$5c452ff88e35e47d = (0, $joxKE.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("bNXHl", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $d934153d9789201d$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $d934153d9789201d$export$7ed775fc743eadd1);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $d934153d9789201d$export$cbf8224b64e0d942 = (0, $joxKE.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $d934153d9789201d$export$7ed775fc743eadd1 = (0, $joxKE.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $1FHzN.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("608PD", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $88498527b5536806$export$16b353b2649bd8d9);

var $joxKE = parcelRequire("joxKE");

var $fsHLO = parcelRequire("fsHLO");
const $88498527b5536806$export$16b353b2649bd8d9 = (0, $joxKE.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fsHLO.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("9XvY7", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $f06fc555f569160f$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $f06fc555f569160f$export$b2e27d292505bac2);
$parcel$export(module.exports, "layoutColumnStage0", () => $f06fc555f569160f$export$f8cda4c28dab3f58);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");

var $kzxEp = parcelRequire("kzxEp");
const $f06fc555f569160f$var$setColumnAttributes = (node, { withLocalId: withLocalId = false } = {})=>{
    const attrs = {
        'data-layout-column': 'true'
    };
    const { width: width, valign: valign, localId: localId } = node.attrs;
    if (width) {
        const baseStyle = `flex-basis: ${width}%`;
        attrs['style'] = `${baseStyle}; --column-width: ${width}%`;
        attrs['data-column-width'] = `${width}`;
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
const $f06fc555f569160f$var$getColumnAttrs = ({ withLocalId: withLocalId = false } = {})=>(domNode)=>{
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = domNode;
        const base = {
            width: Number(dom.getAttribute('data-column-width')) || undefined,
            ...withLocalId && {
                localId: (0, $1FHzN.uuid).generate()
            }
        };
        const valign = (0, $kzxEp.parseValign)(dom.getAttribute('data-valign'));
        return valign ? {
            ...base,
            valign: valign
        } : base;
    };
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
const $f06fc555f569160f$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
const $f06fc555f569160f$export$ab76e7c03cd6f650 = (0, $joxKE.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $f06fc555f569160f$var$getColumnAttrs()
        }
    ],
    toDOM (node) {
        return [
            'div',
            $f06fc555f569160f$var$setColumnAttributes(node),
            [
                'div',
                $f06fc555f569160f$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $f06fc555f569160f$export$b2e27d292505bac2 = (0, $joxKE.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $f06fc555f569160f$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM (node) {
        return [
            'div',
            $f06fc555f569160f$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $f06fc555f569160f$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $f06fc555f569160f$export$f8cda4c28dab3f58 = $f06fc555f569160f$export$b2e27d292505bac2;

});
parcelRegister("kzxEp", function(module, exports) {
$parcel$export(module.exports, "parseValign", () => $b7b847496923564e$export$80408efb85c33a7a);
const $b7b847496923564e$export$80408efb85c33a7a = (raw)=>{
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};

});


parcelRegister("2KlGf", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $fad663c2fa35c2e2$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $fad663c2fa35c2e2$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $fad663c2fa35c2e2$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $fad663c2fa35c2e2$export$64facded20dfd85c);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $fad663c2fa35c2e2$export$b3b6a70a7fa4a5be = (0, $joxKE.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $fad663c2fa35c2e2$export$cdae19acb0a520fd = (0, $joxKE.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $fad663c2fa35c2e2$export$4f9d8f623ff17117 = (0, $joxKE.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $fad663c2fa35c2e2$export$d9d3c69a64270b13 = (0, $joxKE.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $1FHzN.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $fad663c2fa35c2e2$export$64facded20dfd85c = (0, $joxKE.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $1FHzN.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1CJRu", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $7b1af282923b60e7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $7b1af282923b60e7$export$483d52f09158e61c);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $7b1af282923b60e7$export$76c7e83ecc9cdf05 = (0, $joxKE.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $7b1af282923b60e7$export$483d52f09158e61c = (0, $joxKE.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("6s15K", function(module, exports) {
$parcel$export(module.exports, "media", () => $89cd97c4035f1035$export$987d49ffe1b0900f);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");

var $3gcS7 = parcelRequire("3gcS7");



const $89cd97c4035f1035$export$bb3fe706be61f640 = {
    ...(0, $joxKE.media)({}).attrs
};
const $89cd97c4035f1035$export$987d49ffe1b0900f = (0, $3gcS7.createMediaSpec)($89cd97c4035f1035$export$bb3fe706be61f640, false, false);
const $89cd97c4035f1035$export$8446e47a4c7fd000 = (0, $3gcS7.createMediaSpec)({
    ...$89cd97c4035f1035$export$bb3fe706be61f640,
    localId: {
        default: (0, $1FHzN.uuid).generate()
    }
}, false, true);

});
parcelRegister("3gcS7", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", () => $c5dac3a3dfd83b68$export$35bdbf5bc8caa677);

var $joxKE = parcelRequire("joxKE");

var $3Mcc1 = parcelRequire("3Mcc1");

var $1FHzN = parcelRequire("1FHzN");

var $adgdK = parcelRequire("adgdK");

var $90lGn = parcelRequire("90lGn");
const $c5dac3a3dfd83b68$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/u;
const $c5dac3a3dfd83b68$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = (0, $adgdK.camelCaseToKebabCase)(k).replace($c5dac3a3dfd83b68$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    const value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $1FHzN.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $3Mcc1.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        (0, $90lGn.copyPrivateAttributes)(node.attrs, attrs, attributes, (key)=>`data-${(0, $adgdK.camelCaseToKebabCase)(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $joxKE.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $joxKE.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $1FHzN.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};

});
parcelRegister("adgdK", function(module, exports) {
$parcel$export(module.exports, "camelCaseToKebabCase", () => $39dca02b5edf2c1d$export$f84fdfb973c05bd8);
const $39dca02b5edf2c1d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);

});

parcelRegister("90lGn", function(module, exports) {
$parcel$export(module.exports, "copyPrivateAttributes", () => $089cfd0a0c3f455f$export$111130fa8968d741);
const $089cfd0a0c3f455f$export$111130fa8968d741 = (from, to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};

});



parcelRegister("e224s", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $b38b3d23db86a17a$export$2855e964765eac9);

var $joxKE = parcelRequire("joxKE");
const $b38b3d23db86a17a$export$2855e964765eac9 = (0, $joxKE.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("47k1x", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $2a04f37e395b1b91$export$38bab695e3f720f1);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");

var $3gcS7 = parcelRequire("3gcS7");
const $2a04f37e395b1b91$export$38bab695e3f720f1 = (0, $3gcS7.createMediaSpec)((0, $joxKE.mediaInline)({}).attrs, true);
const $2a04f37e395b1b91$export$aea8e9c496505c61 = (0, $3gcS7.createMediaSpec)({
    ...(0, $joxKE.mediaInline)({}).attrs,
    localId: {
        default: (0, $1FHzN.uuid).generate()
    }
}, true, true);

});

parcelRegister("6E6Kd", function(module, exports) {
$parcel$export(module.exports, "mediaSingle", () => $4dc56b7c26314646$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $4dc56b7c26314646$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $4dc56b7c26314646$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $4dc56b7c26314646$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $4dc56b7c26314646$export$75376a385837c942);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $eGp9b = parcelRequire("eGp9b");

const $4dc56b7c26314646$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $4dc56b7c26314646$export$969fe3781ca15058 = (0, $eGp9b.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $4dc56b7c26314646$export$d35e6c006d4abdfb = (0, $eGp9b.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $4dc56b7c26314646$export$9c58e19811ce4cf5 = (0, $eGp9b.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $4dc56b7c26314646$export$7e767666f2ce108a = (0, $eGp9b.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $4dc56b7c26314646$export$75376a385837c942 = (0, $eGp9b.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});

});
parcelRegister("eGp9b", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $e33256cf91a95c32$export$5a1e124099b60c6b);

var $joxKE = parcelRequire("joxKE");

var $bXuzq = parcelRequire("bXuzq");

var $1FHzN = parcelRequire("1FHzN");

var $lRZeX = parcelRequire("lRZeX");
const $e33256cf91a95c32$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $bXuzq.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $1FHzN.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $lRZeX.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs;
            attrs['data-local-id'] = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $lRZeX.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $joxKE.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $joxKE.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $joxKE.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $joxKE.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};

});
parcelRegister("lRZeX", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $fa8879559e908da7$export$4d41558722ac7eed);
var $fa8879559e908da7$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});



parcelRegister("d1R2l", function(module, exports) {
$parcel$export(module.exports, "mention", () => $38f93235d7079039$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $38f93235d7079039$export$54fd2c36b5cc6731);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
var $38f93235d7079039$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $38f93235d7079039$export$db83999c14438df4 = (0, $joxKE.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $38f93235d7079039$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $38f93235d7079039$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $38f93235d7079039$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $1FHzN.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($38f93235d7079039$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $38f93235d7079039$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $38f93235d7079039$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($38f93235d7079039$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("flh6x", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $2828d99b892eaad8$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $2828d99b892eaad8$export$b854197485aa1fa0);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
function $2828d99b892eaad8$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $1FHzN.uuid).generate() : undefined
    };
}
const $2828d99b892eaad8$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$2828d99b892eaad8$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$2828d99b892eaad8$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $2828d99b892eaad8$export$63cadbf5f4296627 = (0, $joxKE.nestedExpand)($2828d99b892eaad8$var$nestedExpandFactoryOptions);
const $2828d99b892eaad8$export$b854197485aa1fa0 = (0, $joxKE.nestedExpand)({
    ...$2828d99b892eaad8$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$2828d99b892eaad8$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$2828d99b892eaad8$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$2828d99b892eaad8$var$getExpandAttrs(domNode, true)
        }
    ]
});

});

parcelRegister("4rqGA", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $eecd00b077ae3c18$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $eecd00b077ae3c18$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $eecd00b077ae3c18$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $eecd00b077ae3c18$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $eecd00b077ae3c18$export$2ea3505d41d7525d);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $eecd00b077ae3c18$export$4e7125c7ff595be5 = '.ak-ol';
const $eecd00b077ae3c18$export$a5dc81035676e7a = (0, $joxKE.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $eecd00b077ae3c18$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $eecd00b077ae3c18$export$8157adc5747ec436 = (0, $joxKE.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $eecd00b077ae3c18$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eecd00b077ae3c18$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $eecd00b077ae3c18$export$b9ab759e8298198f = (0, $joxKE.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $eecd00b077ae3c18$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const start = $eecd00b077ae3c18$var$resolveStart(node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $eecd00b077ae3c18$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $eecd00b077ae3c18$export$2ea3505d41d7525d = (0, $joxKE.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $1FHzN.uuid).generate();
                if (startDOMAttr) {
                    const start = $eecd00b077ae3c18$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs3, _node$attrs4;
        const start = $eecd00b077ae3c18$var$resolveStart(node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $eecd00b077ae3c18$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kUt8q", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $868a7545c2454cdb$export$9c206ddddb32a9b);

var $joxKE = parcelRequire("joxKE");
const $868a7545c2454cdb$export$9c206ddddb32a9b = (0, $joxKE.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $868a7545c2454cdb$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 || (_paragraph$attrs = _paragraph$attrs.localId) === null || _paragraph$attrs === void 0 ? void 0 : _paragraph$attrs.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("gITKe", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $22d9fc2ba5e179bb$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $22d9fc2ba5e179bb$export$6205248609a8f7a0);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $22d9fc2ba5e179bb$export$c7187bbd1a7a9244 = (0, $joxKE.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $22d9fc2ba5e179bb$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $22d9fc2ba5e179bb$export$6205248609a8f7a0 = (0, $joxKE.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $22d9fc2ba5e179bb$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("djAdL", function(module, exports) {
$parcel$export(module.exports, "rule", () => $420ff01273bfcd99$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $420ff01273bfcd99$export$bf3ef6fb6ad90e7);
$parcel$export(module.exports, "ruleWithAttrs", () => $420ff01273bfcd99$export$ef9ec4ed8a654d7f);
$parcel$export(module.exports, "ruleRootOnlyStage0", () => $420ff01273bfcd99$export$1d53b70195c9c417);
$parcel$export(module.exports, "ruleWithAttrsRootOnlyStage0", () => $420ff01273bfcd99$export$78cca5eef2450890);

var $joxKE = parcelRequire("joxKE");

var $61Cst = parcelRequire("61Cst");

var $1FHzN = parcelRequire("1FHzN");
const $420ff01273bfcd99$var$hrDOM = [
    'hr'
];
const $420ff01273bfcd99$export$fbeb3a3956e8a3c7 = (0, $joxKE.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $420ff01273bfcd99$var$hrDOM;
    }
});
const $420ff01273bfcd99$export$bf3ef6fb6ad90e7 = (0, $joxKE.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});
const $420ff01273bfcd99$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || undefined,
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $420ff01273bfcd99$export$ef9ec4ed8a654d7f = {
    ...$420ff01273bfcd99$export$bf3ef6fb6ad90e7,
    attrs: {
        ...$420ff01273bfcd99$export$bf3ef6fb6ad90e7.attrs,
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: $420ff01273bfcd99$var$getAttrs
        }
    ],
    toDOM (node) {
        const { color: color, localId: localId, style: style, weight: weight } = node.attrs;
        const paletteColorValue = color && ((0, $61Cst.hexToEditorTextPaletteColor)(color) ?? color);
        return [
            'hr',
            {
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined,
                style: paletteColorValue ? `--custom-palette-color: ${paletteColorValue}` : undefined
            }
        ];
    }
};
const $420ff01273bfcd99$export$1d53b70195c9c417 = {
    ...$420ff01273bfcd99$export$bf3ef6fb6ad90e7,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
const $420ff01273bfcd99$export$78cca5eef2450890 = {
    ...$420ff01273bfcd99$export$ef9ec4ed8a654d7f,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("1oEoc", function(module, exports) {
$parcel$export(module.exports, "status", () => $b5b6e0c1aaeaffda$export$471f7ae5c4103ae1);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $b5b6e0c1aaeaffda$var$NEWLINE_REGEX = /\n/u;
const $b5b6e0c1aaeaffda$export$471f7ae5c4103ae1 = (0, $joxKE.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace($b5b6e0c1aaeaffda$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $1FHzN.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("cdpdE", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $e6e94bc19d13a3b5$export$faab0ca9701d7048);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $e6e94bc19d13a3b5$export$faab0ca9701d7048 = (0, $joxKE.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $1FHzN.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("63Q5S", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $27b0686124e908e0$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $27b0686124e908e0$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $27b0686124e908e0$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $27b0686124e908e0$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $27b0686124e908e0$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $27b0686124e908e0$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $27b0686124e908e0$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $27b0686124e908e0$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorNameByHex", () => $27b0686124e908e0$export$87db0bca041942ef);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $27b0686124e908e0$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundColorPaletteNew", () => $27b0686124e908e0$export$f26b9114878cba41);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $27b0686124e908e0$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $27b0686124e908e0$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $27b0686124e908e0$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $27b0686124e908e0$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $27b0686124e908e0$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $27b0686124e908e0$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $27b0686124e908e0$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $27b0686124e908e0$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $27b0686124e908e0$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $27b0686124e908e0$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $27b0686124e908e0$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $27b0686124e908e0$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $27b0686124e908e0$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $27b0686124e908e0$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $27b0686124e908e0$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $27b0686124e908e0$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $27b0686124e908e0$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $27b0686124e908e0$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $27b0686124e908e0$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $27b0686124e908e0$export$7928c3aeb4cd2213);
$parcel$export(module.exports, "tableCellStage0", () => $27b0686124e908e0$export$7ffdb7030e2f2223);
$parcel$export(module.exports, "tableHeaderStage0", () => $27b0686124e908e0$export$53c69bb0cddd9750);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => $27b0686124e908e0$export$10671ff6b5f3bd84);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => $27b0686124e908e0$export$69bdb7ac5d810d92);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $joxKE = parcelRequire("joxKE");

var $3Mcc1 = parcelRequire("3Mcc1");

var $lefJT = parcelRequire("lefJT");

var $7RQp8 = parcelRequire("7RQp8");

var $2JEwD = parcelRequire("2JEwD");

var $k2BT5 = parcelRequire("k2BT5");

var $aZBXL = parcelRequire("aZBXL");

var $gmPq6 = parcelRequire("gmPq6");

var $1FHzN = parcelRequire("1FHzN");

var $kzxEp = parcelRequire("kzxEp");
const $27b0686124e908e0$export$9cfceb893b24742a = 'pm-table';
const $27b0686124e908e0$var$COL_WIDTH_ATTR_REGEX = /^\d+(,\d+)*$/u;
const $27b0686124e908e0$export$69cb4c3f80383763 = `${$27b0686124e908e0$export$9cfceb893b24742a}-cell-content-wrap`;
const $27b0686124e908e0$export$7b07d37d879c957f = `${$27b0686124e908e0$export$9cfceb893b24742a}-header-content-wrap`;
const $27b0686124e908e0$export$8dd42a84cd52da07 = `${$27b0686124e908e0$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $27b0686124e908e0$export$5e26a5c19f0865d8 = `${$27b0686124e908e0$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $27b0686124e908e0$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $3Mcc1.N20).toLocaleLowerCase();
const $27b0686124e908e0$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && $27b0686124e908e0$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $k2BT5.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $aZBXL.isRgb)(backgroundColor)) {
        const result = (0, $gmPq6.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    const valign = (0, $kzxEp.parseValign)(dom.getAttribute('data-valign'));
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        },
        ...valign && {
            valign: valign
        }
    };
};
// these are for test only
let $27b0686124e908e0$var$testGlobalTheme;
const $27b0686124e908e0$export$fd7e0dd2b74807f7 = (theme)=>{
    $27b0686124e908e0$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $27b0686124e908e0$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($27b0686124e908e0$var$testGlobalTheme) return {
        colorMode: $27b0686124e908e0$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $27b0686124e908e0$var$cssVariablePattern = /^var\(--.*\)$/u;
const $27b0686124e908e0$export$363c8dda799bfe9c = (node)=>{
    var _node$attrs;
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $27b0686124e908e0$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $27b0686124e908e0$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $aZBXL.isRgb)(background) && (0, $gmPq6.rgbToHex)(background) ? (0, $gmPq6.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $7RQp8.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $27b0686124e908e0$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($27b0686124e908e0$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $lefJT.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $27b0686124e908e0$export$87db0bca041942ef.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $27b0686124e908e0$export$7b07d37d879c957f;
    else attrs.class = $27b0686124e908e0$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
const $27b0686124e908e0$export$219b7f492ad209f8 = new Map();
const $27b0686124e908e0$export$f26b9114878cba41 = new Map();
const $27b0686124e908e0$export$95e9c925fbf01d1c = (0, $2JEwD.hexToRgba)((0, $3Mcc1.N800), 0.12) || (0, $3Mcc1.N0);
const $27b0686124e908e0$export$8cc2833b5b349a1e = new Map();
const $27b0686124e908e0$export$87db0bca041942ef = new Map();
// Original 7-column palette — kept as the default export so external consumers
// are not broken. When cleaning up the platform_editor_lovability_text_bg_color experiment, check if this can be removed
[
    [
        (0, $3Mcc1.N0),
        'White'
    ],
    [
        (0, $3Mcc1.B50),
        'Light blue'
    ],
    [
        (0, $3Mcc1.T50),
        'Light teal'
    ],
    [
        (0, $3Mcc1.G50),
        'Light green'
    ],
    [
        (0, $3Mcc1.Y50),
        'Light yellow'
    ],
    [
        (0, $3Mcc1.R50),
        'Light red'
    ],
    [
        (0, $3Mcc1.P50),
        'Light purple'
    ],
    [
        (0, $3Mcc1.N20),
        'Light gray'
    ],
    [
        (0, $3Mcc1.B75),
        'Blue'
    ],
    [
        (0, $3Mcc1.T75),
        'Teal'
    ],
    [
        (0, $3Mcc1.G75),
        'Green'
    ],
    [
        (0, $3Mcc1.Y75),
        'Yellow'
    ],
    [
        (0, $3Mcc1.R75),
        'Red'
    ],
    [
        (0, $3Mcc1.P75),
        'Purple'
    ],
    [
        (0, $3Mcc1.N60),
        'Gray'
    ],
    [
        (0, $3Mcc1.B100),
        'Dark blue'
    ],
    [
        (0, $3Mcc1.T100),
        'Dark teal'
    ],
    [
        (0, $3Mcc1.G200),
        'Dark green'
    ],
    [
        (0, $3Mcc1.Y200),
        'Dark yellow'
    ],
    [
        (0, $3Mcc1.R100),
        'Dark red'
    ],
    [
        (0, $3Mcc1.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $27b0686124e908e0$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $27b0686124e908e0$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $27b0686124e908e0$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
[
    [
        (0, $3Mcc1.N0),
        'White'
    ],
    [
        (0, $3Mcc1.B50),
        'Light blue'
    ],
    [
        (0, $3Mcc1.T50),
        'Light teal'
    ],
    [
        (0, $3Mcc1.G50),
        'Light green'
    ],
    [
        (0, $3Mcc1.L50),
        'Subtle lime'
    ],
    [
        (0, $3Mcc1.Y50),
        'Light yellow'
    ],
    [
        (0, $3Mcc1.Orange50),
        'Subtle orange'
    ],
    [
        (0, $3Mcc1.R50),
        'Light red'
    ],
    [
        (0, $3Mcc1.M50),
        'Subtle magenta'
    ],
    [
        (0, $3Mcc1.P50),
        'Light purple'
    ],
    [
        (0, $3Mcc1.N20),
        'Light gray'
    ],
    [
        (0, $3Mcc1.B75),
        'Blue'
    ],
    [
        (0, $3Mcc1.T75),
        'Teal'
    ],
    [
        (0, $3Mcc1.G75),
        'Green'
    ],
    [
        (0, $3Mcc1.L200),
        'Lime'
    ],
    [
        (0, $3Mcc1.Y75),
        'Yellow'
    ],
    [
        (0, $3Mcc1.Orange200),
        'Orange'
    ],
    [
        (0, $3Mcc1.R75),
        'Red'
    ],
    [
        (0, $3Mcc1.M200),
        'Magenta'
    ],
    [
        (0, $3Mcc1.P75),
        'Purple'
    ],
    [
        (0, $3Mcc1.GrayBold),
        'Bold gray'
    ],
    [
        (0, $3Mcc1.BlueBold),
        'Bold blue'
    ],
    [
        (0, $3Mcc1.TealBold),
        'Bold teal'
    ],
    [
        (0, $3Mcc1.GreenBold),
        'Bold green'
    ],
    [
        (0, $3Mcc1.L400),
        'Bold lime'
    ],
    [
        (0, $3Mcc1.YellowBold),
        'Bold yellow'
    ],
    [
        (0, $3Mcc1.Orange400),
        'Bold orange'
    ],
    [
        (0, $3Mcc1.RedBold),
        'Bold red'
    ],
    [
        (0, $3Mcc1.M400),
        'Bold magenta'
    ],
    [
        (0, $3Mcc1.PurpleBold),
        'Bold purple'
    ]
].forEach(([colorValue, colorName])=>{
    $27b0686124e908e0$export$f26b9114878cba41.set(colorValue.toLowerCase(), colorName);
    $27b0686124e908e0$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $27b0686124e908e0$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
const $27b0686124e908e0$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $1FHzN.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $27b0686124e908e0$var$createTableSpec = ()=>(0, $joxKE.table)($27b0686124e908e0$var$tableNodeSpecOptions);
const $27b0686124e908e0$export$9852986a3ec5f6a0 = $27b0686124e908e0$var$createTableSpec();
const $27b0686124e908e0$export$90e634fbace1f0c4 = $27b0686124e908e0$var$createTableSpec();
const $27b0686124e908e0$export$3862de5c8c9098cf = $27b0686124e908e0$var$createTableSpec();
const $27b0686124e908e0$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $27b0686124e908e0$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$27b0686124e908e0$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $27b0686124e908e0$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $27b0686124e908e0$export$ce666bf02318c957 = (0, $joxKE.tableRow)($27b0686124e908e0$var$tableRowNodeSpecOptions);
const $27b0686124e908e0$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
const $27b0686124e908e0$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$27b0686124e908e0$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $27b0686124e908e0$export$363c8dda799bfe9c(node),
            0
        ]
};
const $27b0686124e908e0$export$e1e720e5f4603e6a = (0, $joxKE.tableCell)($27b0686124e908e0$var$tableCellNodeSpecOptions);
const $27b0686124e908e0$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($27b0686124e908e0$var$cellAttrs[key] && $27b0686124e908e0$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $27b0686124e908e0$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $27b0686124e908e0$export$43977bde391e007(dom, {
                    background: $27b0686124e908e0$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $27b0686124e908e0$export$363c8dda799bfe9c(node),
            0
        ]
};
const $27b0686124e908e0$export$48884d2a5190dc73 = (0, $joxKE.tableHeader)($27b0686124e908e0$var$tableHeaderNodeSpecOptions);
const $27b0686124e908e0$export$2af48797a1010bb1 = $27b0686124e908e0$export$2ac34c099660f1a8;
const $27b0686124e908e0$export$ce086a560a1d05f5 = (0, $joxKE.tableWithNestedTable)($27b0686124e908e0$var$tableNodeSpecOptions);
const $27b0686124e908e0$export$7d657479499397 = (0, $joxKE.tableRowWithNestedTable)($27b0686124e908e0$var$tableRowNodeSpecOptions);
const $27b0686124e908e0$export$abf39ca178940ff3 = (0, $joxKE.tableCellWithNestedTable)($27b0686124e908e0$var$tableCellNodeSpecOptions);
const $27b0686124e908e0$export$2a5a518232fa1a97 = (0, $joxKE.tableHeaderWithNestedTable)($27b0686124e908e0$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $27b0686124e908e0$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
const $27b0686124e908e0$export$c8f0853ac97552c9 = (0, $joxKE.tableRow)($27b0686124e908e0$var$tableRowNodeSpecOptionsWithLocalId);
const $27b0686124e908e0$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $27b0686124e908e0$export$43977bde391e007(dom, {
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $27b0686124e908e0$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $27b0686124e908e0$export$db76cfd28a574029 = (0, $joxKE.tableCell)($27b0686124e908e0$var$tableCellNodeSpecOptionsWithLocalId);
const $27b0686124e908e0$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $27b0686124e908e0$export$43977bde391e007(dom, {
                    background: $27b0686124e908e0$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $27b0686124e908e0$export$363c8dda799bfe9c(node),
            0
        ]
};
const $27b0686124e908e0$export$b82d2b1d8824143d = (0, $joxKE.tableHeader)($27b0686124e908e0$var$tableHeaderNodeSpecOptionsWithLocalId);
const $27b0686124e908e0$export$27926e30c8a74147 = (0, $joxKE.tableRowWithNestedTable)($27b0686124e908e0$var$tableRowNodeSpecOptionsWithLocalId);
const $27b0686124e908e0$export$e9fd700fafee293a = (0, $joxKE.tableCellWithNestedTable)($27b0686124e908e0$var$tableCellNodeSpecOptionsWithLocalId);
const $27b0686124e908e0$export$7928c3aeb4cd2213 = (0, $joxKE.tableHeaderWithNestedTable)($27b0686124e908e0$var$tableHeaderNodeSpecOptionsWithLocalId);
const $27b0686124e908e0$export$7ffdb7030e2f2223 = $27b0686124e908e0$export$db76cfd28a574029;
const $27b0686124e908e0$export$53c69bb0cddd9750 = $27b0686124e908e0$export$b82d2b1d8824143d;
const $27b0686124e908e0$export$10671ff6b5f3bd84 = $27b0686124e908e0$export$e9fd700fafee293a;
const $27b0686124e908e0$export$69bdb7ac5d810d92 = $27b0686124e908e0$export$7928c3aeb4cd2213;

});
parcelRegister("7RQp8", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $f5da945308d469fc$export$a270511a0e7fd61a);

var $615t3 = parcelRequire("615t3");
function $f5da945308d469fc$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? (0, $615t3.editorBackgroundPalette)[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}

});

parcelRegister("2JEwD", function(module, exports) {
$parcel$export(module.exports, "hexToRgba", () => $56d22213fe9c4e5b$export$9665a07d9187b414);
// eslint-disable-line import/no-namespace

var $29J7f = parcelRequire("29J7f");
function $56d22213fe9c4e5b$export$9665a07d9187b414(rawColor, alpha) {
    const color = (0, $29J7f.normalizeHexColor)(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}

});
parcelRegister("29J7f", function(module, exports) {
$parcel$export(module.exports, "normalizeHexColor", () => $1de64d05f1dec81f$export$b61655071712e690);

var $qo0hc = parcelRequire("qo0hc");

var $k2BT5 = parcelRequire("k2BT5");

var $aZBXL = parcelRequire("aZBXL");

var $gmPq6 = parcelRequire("gmPq6");
function $1de64d05f1dec81f$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ((0, $k2BT5.isHex)(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ((0, $aZBXL.isRgb)(color)) return (0, $gmPq6.rgbToHex)(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $qo0hc.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $qo0hc.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $qo0hc.default[color];
        else if ($qo0hc && $qo0hc[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $qo0hc[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}

});
parcelRegister("qo0hc", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});

parcelRegister("k2BT5", function(module, exports) {
$parcel$export(module.exports, "isHex", () => $af406380aed1ff38$export$8a9b6341a7c96bc);
// eslint-disable-line import/no-namespace
const $af406380aed1ff38$var$IS_HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/u;
function $af406380aed1ff38$export$8a9b6341a7c96bc(color) {
    return $af406380aed1ff38$var$IS_HEX_REGEX.test(color);
}

});

parcelRegister("aZBXL", function(module, exports) {
$parcel$export(module.exports, "isRgb", () => $9725ccb4c1df8f67$export$e698776ec826343);
// eslint-disable-line import/no-namespace
const $9725ccb4c1df8f67$var$IS_RGB_REGEX = /rgba?\(/u;
function $9725ccb4c1df8f67$export$e698776ec826343(color) {
    return $9725ccb4c1df8f67$var$IS_RGB_REGEX.test(color);
}

});




parcelRegister("eohEq", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $87743d068becf5d2$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $87743d068becf5d2$export$375b6afcc5f4d291);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $87743d068becf5d2$var$name = 'actionList';
const $87743d068becf5d2$export$c0ec71adb7a18fb2 = `[data-node-type="${$87743d068becf5d2$var$name}"]`;
const $87743d068becf5d2$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$87743d068becf5d2$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $1FHzN.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $87743d068becf5d2$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $87743d068becf5d2$export$375b6afcc5f4d291 = (0, $joxKE.taskList)($87743d068becf5d2$var$taskListParseDOMAndToDOM);

});

parcelRegister("7mXyo", function(module, exports) {
$parcel$export(module.exports, "text", () => $4e0fe25f2220735e$export$6f093cfa640b7166);

var $joxKE = parcelRequire("joxKE");
const $4e0fe25f2220735e$export$6f093cfa640b7166 = (0, $joxKE.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("gtZE7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6ae193217f9378b$export$2e2bcd8739ae039);
const $b6ae193217f9378b$var$name = 'unknownBlock';
const $b6ae193217f9378b$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $b6ae193217f9378b$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type=\"${$b6ae193217f9378b$var$name}\"]`
        }
    ]
};

});

parcelRegister("7eKWK", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $ff1cddf12d329fc2$export$44b79b0979d0f0f7);

var $joxKE = parcelRequire("joxKE");
const $ff1cddf12d329fc2$export$44b79b0979d0f0f7 = (0, $joxKE.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("e2bmr", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $ce55600b24b76132$export$310ebe0d80122e9b);

var $joxKE = parcelRequire("joxKE");
const $ce55600b24b76132$export$310ebe0d80122e9b = (0, $joxKE.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("viZe0", function(module, exports) {
$parcel$export(module.exports, "bodiedRule", () => $f1ea881e10908aa9$export$2069efcbff2f0292);
$parcel$export(module.exports, "bodiedRuleRootOnlyStage0", () => $f1ea881e10908aa9$export$208411233915368e);

var $joxKE = parcelRequire("joxKE");

var $1FHzN = parcelRequire("1FHzN");
const $f1ea881e10908aa9$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        alignment: dom.getAttribute('data-alignment') || undefined,
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || (0, $1FHzN.uuid).generate(),
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $f1ea881e10908aa9$export$2069efcbff2f0292 = (0, $joxKE.bodiedRuleStage0)({
    parseDOM: [
        {
            tag: 'div[data-node-type="bodied-rule"]',
            getAttrs: $f1ea881e10908aa9$var$getAttrs
        }
    ],
    toDOM (node) {
        const { alignment: alignment, color: color, localId: localId, style: style, weight: weight } = node.attrs;
        return [
            'div',
            {
                'data-node-type': 'bodied-rule',
                'data-alignment': alignment || undefined,
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined
            },
            0
        ];
    }
});
const $f1ea881e10908aa9$export$208411233915368e = {
    ...$f1ea881e10908aa9$export$2069efcbff2f0292,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};

});


parcelRegister("ijgm7", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $9d403c937573d876$export$daf54fed04c8fb77);
function $9d403c937573d876$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $9d403c937573d876$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $9d403c937573d876$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = Array.from(new Set(contentKeys.filter((contentKey)=>!$9d403c937573d876$var$isContentSupported(nodes, contentKey)))).sort((a, b)=>b.length - a.length);
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$9d403c937573d876$var$sanitizedContent(newContent, nodeName), rawContent);
}
const $9d403c937573d876$var$WORD_CHAR_REGEX = /\w/u;
function $9d403c937573d876$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($9d403c937573d876$var$WORD_CHAR_REGEX)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $9d403c937573d876$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});


parcelRegister("j9iKu", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1RootOnlyStage0", () => $843e90e08a227a89$export$9ef8544aba133962);

var $lKqex = parcelRequire("lKqex");
const $843e90e08a227a89$export$9ef8544aba133962 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $lKqex.extendedPanelC1WithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};

});
parcelRegister("lKqex", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => $b27535dcda3828db$export$9c65e35ecb68f683);

var $joxKE = parcelRequire("joxKE");

var $dtNv3 = parcelRequire("dtNv3");
const $b27535dcda3828db$export$9c65e35ecb68f683 = (allowCustomPanel)=>(0, $joxKE.panelC1Stage0)((0, $dtNv3.createPanelNodeSpecOptions)(allowCustomPanel, true));

});


parcelRegister("bMAIM", function(module, exports) {
$parcel$export(module.exports, "extendedPanelRootOnlyStage0", () => $fb74f1d027e9f78a$export$71123ea8f73a7fb);

var $4VRBv = parcelRequire("4VRBv");
const $fb74f1d027e9f78a$export$71123ea8f73a7fb = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $4VRBv.extendedPanelWithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};

});
parcelRegister("4VRBv", function(module, exports) {
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $b6dcbae15b4dc30d$export$855c3c67c9c9ebaf);

var $joxKE = parcelRequire("joxKE");

var $dtNv3 = parcelRequire("dtNv3");
const $b6dcbae15b4dc30d$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $joxKE.panel)((0, $dtNv3.createPanelNodeSpecOptions)(allowCustomPanel, true));

});



parcelRegister("8ckOW", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $1f6bc03abecbcb1b$export$48b382180baf8e88);

var $3UcKI = parcelRequire("3UcKI");

var $9RIwK = parcelRequire("9RIwK");

var $6O6T5 = parcelRequire("6O6T5");

var $1RtZN = parcelRequire("1RtZN");
const $1f6bc03abecbcb1b$var$hasNestedTable = (tableCellNode)=>{
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some((node)=>(node === null || node === void 0 ? void 0 : node.type) === 'table');
};
function $1f6bc03abecbcb1b$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $9RIwK.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $1RtZN.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($1f6bc03abecbcb1b$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $3UcKI.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($1f6bc03abecbcb1b$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $3UcKI.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: (node)=>({
                ...node,
                type: 'panel'
            }),
        emoji: (0, $1RtZN.removeNonAnnotationMarks),
        mention: (0, $1RtZN.removeNonAnnotationMarks),
        date: (0, $1RtZN.removeNonAnnotationMarks),
        hardBreak: (0, $6O6T5.removeMarks),
        inlineCard: (0, $1RtZN.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("3UcKI", function(module, exports) {
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $24c166238df5bd40$export$8a334a7d9fe120ec);

var $8lpWI = parcelRequire("8lpWI");

var $6g3YR = parcelRequire("6g3YR");

var $9yZC8 = parcelRequire("9yZC8");
const $24c166238df5bd40$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        var _tableCellNode$conten;
        return {
            ...tableCellNode,
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map((childNode)=>{
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $8lpWI.extension)({
                    extensionType: (0, $9yZC8.NESTED_TABLE_EXTENSION_TYPE),
                    extensionKey: (0, $9yZC8.NESTED_TABLE_EXTENSION_KEY),
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $6g3YR.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("8lpWI", function(module, exports) {
$parcel$export(module.exports, "extension", () => $6af7394c7ec7e2d3$export$1b45514b112dd749);
const $6af7394c7ec7e2d3$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("6g3YR", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $e4237abc265eb126$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $e4237abc265eb126$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});

parcelRegister("9yZC8", function(module, exports) {
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_TYPE", () => $61178217edaff292$export$3b760d14ce8127a2);
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_KEY", () => $61178217edaff292$export$f45f8b42c24922c1);



var $3UcKI = parcelRequire("3UcKI");
const $61178217edaff292$export$3b760d14ce8127a2 = 'com.atlassian.confluence.migration', $61178217edaff292$export$f45f8b42c24922c1 = 'nested-table';

});


parcelRegister("6O6T5", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $281ebd70c5976d84$export$9bf001d8ef76e497);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ function $281ebd70c5976d84$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}

});

parcelRegister("1RtZN", function(module, exports) {
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $811227603c92161f$export$8cae9126fc577085);
function $811227603c92161f$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});


parcelRegister("6WL33", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $b3d44bdee4eeb3e4$export$54fd2c36b5cc6731);

var $he46D = parcelRequire("he46D");

var $iq16s = parcelRequire("iq16s");

var $le0kK = parcelRequire("le0kK");

var $l5yqo = parcelRequire("l5yqo");

var $ipVDa = parcelRequire("ipVDa");

var $d1R2l = parcelRequire("d1R2l");

var $63Q5S = parcelRequire("63Q5S");

var $iof8L = parcelRequire("iof8L");

var $E9igg = parcelRequire("E9igg");

var $c34zW = parcelRequire("c34zW");
const $b3d44bdee4eeb3e4$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $b3d44bdee4eeb3e4$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $b3d44bdee4eeb3e4$var$isCodeBlock = $b3d44bdee4eeb3e4$var$isType('codeBlock');
const $b3d44bdee4eeb3e4$var$isMediaNode = $b3d44bdee4eeb3e4$var$isType('media');
const $b3d44bdee4eeb3e4$var$isMediaInline = $b3d44bdee4eeb3e4$var$isType('mediaInline');
const $b3d44bdee4eeb3e4$var$isMediaSingleNode = $b3d44bdee4eeb3e4$var$isType('mediaSingle');
const $b3d44bdee4eeb3e4$var$isMentionNode = $b3d44bdee4eeb3e4$var$isType('mention');
const $b3d44bdee4eeb3e4$var$isParagraph = $b3d44bdee4eeb3e4$var$isType('paragraph');
const $b3d44bdee4eeb3e4$var$isHeading = $b3d44bdee4eeb3e4$var$isType('heading');
const $b3d44bdee4eeb3e4$var$isTable = $b3d44bdee4eeb3e4$var$isType('table');
const $b3d44bdee4eeb3e4$var$isTableCell = $b3d44bdee4eeb3e4$var$isType('tableCell');
const $b3d44bdee4eeb3e4$var$isTableHeader = $b3d44bdee4eeb3e4$var$isType('tableHeader');
const $b3d44bdee4eeb3e4$var$isLinkMark = $b3d44bdee4eeb3e4$var$isType('link');
const $b3d44bdee4eeb3e4$var$isUnsupportedMark = $b3d44bdee4eeb3e4$var$isType('unsupportedMark');
const $b3d44bdee4eeb3e4$var$isUnsupportedNodeAttributeMark = $b3d44bdee4eeb3e4$var$isType('unsupportedNodeAttribute');
const $b3d44bdee4eeb3e4$var$isExpand = $b3d44bdee4eeb3e4$var$isType('expand');
const $b3d44bdee4eeb3e4$var$isNestedExpand = $b3d44bdee4eeb3e4$var$isType('nestedExpand');
const $b3d44bdee4eeb3e4$var$isExtensionNode = $b3d44bdee4eeb3e4$var$isType('extension');
const $b3d44bdee4eeb3e4$var$isUnsupportedNode = (node)=>$b3d44bdee4eeb3e4$var$isType('unsupportedBlock')(node) || $b3d44bdee4eeb3e4$var$isType('unsupportedInline')(node);
const $b3d44bdee4eeb3e4$var$isDataConsumer = $b3d44bdee4eeb3e4$var$isType('dataConsumer');
const $b3d44bdee4eeb3e4$var$isFragmentMark = $b3d44bdee4eeb3e4$var$isType('fragment');
const $b3d44bdee4eeb3e4$var$isAnnotationMark = $b3d44bdee4eeb3e4$var$isType('annotation');
const $b3d44bdee4eeb3e4$var$isAllowedNodeForAnnotation = (node)=>!node.type.isBlock || $b3d44bdee4eeb3e4$var$isMediaNode(node) || $b3d44bdee4eeb3e4$var$isExtensionNode(node);
const $b3d44bdee4eeb3e4$var$isHardBreak = $b3d44bdee4eeb3e4$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b3d44bdee4eeb3e4$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $b3d44bdee4eeb3e4$var$filterNull(current);
    }
    return output;
};
const $b3d44bdee4eeb3e4$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $c34zW.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $b3d44bdee4eeb3e4$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
const $b3d44bdee4eeb3e4$export$54fd2c36b5cc6731 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($b3d44bdee4eeb3e4$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($b3d44bdee4eeb3e4$var$isMediaNode(node)) obj.attrs = (0, $E9igg.toJSON)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isMediaSingleNode(node)) obj.attrs = (0, $iof8L.toJSON)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isMediaInline(node)) obj.attrs = (0, $E9igg.toJSON)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isMentionNode(node)) obj.attrs = (0, $d1R2l.toJSON)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isCodeBlock(node)) obj.attrs = (0, $iq16s.toJSON)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isTable(node)) obj.attrs = (0, $63Q5S.tableToJSON)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isTableCell(node)) obj.attrs = (0, $63Q5S.toJSONTableCell)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isTableHeader(node)) obj.attrs = (0, $63Q5S.toJSONTableHeader)(node).attrs;
    else if ($b3d44bdee4eeb3e4$var$isExpand(node) || $b3d44bdee4eeb3e4$var$isNestedExpand(node)) obj.attrs = (0, $l5yqo.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $b3d44bdee4eeb3e4$var$filterNull(obj.attrs);
    if ($b3d44bdee4eeb3e4$var$isMentionNode(node) && mentionMap) {
        var _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = ((_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($b3d44bdee4eeb3e4$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $b3d44bdee4eeb3e4$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($b3d44bdee4eeb3e4$export$54fd2c36b5cc6731(child, mentionMap));
    });
    if ($b3d44bdee4eeb3e4$var$isParagraph(node) || $b3d44bdee4eeb3e4$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($b3d44bdee4eeb3e4$var$isAnnotationMark(mark) && !$b3d44bdee4eeb3e4$var$isAllowedNodeForAnnotation(node)) return null;
            else if ($b3d44bdee4eeb3e4$var$isUnsupportedMark(mark)) return $b3d44bdee4eeb3e4$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($b3d44bdee4eeb3e4$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($b3d44bdee4eeb3e4$var$isLinkMark(mark)) return (0, $he46D.toJSON)(mark);
            else if ($b3d44bdee4eeb3e4$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                const serialised = (0, $le0kK.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($b3d44bdee4eeb3e4$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $ipVDa.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($b3d44bdee4eeb3e4$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$b3d44bdee4eeb3e4$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};

});
parcelRegister("he46D", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $fc501e8ed9b5291f$export$54fd2c36b5cc6731);
const $fc501e8ed9b5291f$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $fc501e8ed9b5291f$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($fc501e8ed9b5291f$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});

parcelRegister("iof8L", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $80c9fa458957e47d$export$54fd2c36b5cc6731);
const $80c9fa458957e47d$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("E9igg", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $b06933265339d7d3$export$54fd2c36b5cc6731);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $b06933265339d7d3$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $b06933265339d7d3$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $b06933265339d7d3$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $b06933265339d7d3$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($b06933265339d7d3$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("c34zW", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $99c6f617f8cb247d$export$28e4e3c024cce988);
const $99c6f617f8cb247d$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $99c6f617f8cb247d$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $99c6f617f8cb247d$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $99c6f617f8cb247d$var$defaultAllowOverrideBehaviour;
        default:
            return $99c6f617f8cb247d$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});



parcelRegister("801jp", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $5d2f575e3dd958d8$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $5d2f575e3dd958d8$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $5d2f575e3dd958d8$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $5d2f575e3dd958d8$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $5d2f575e3dd958d8$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $5d2f575e3dd958d8$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $5d2f575e3dd958d8$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $5d2f575e3dd958d8$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $5d2f575e3dd958d8$export$1692d8b0e89cecc3);

var $7H6Cr = parcelRequire("7H6Cr");

var $k2WVn = parcelRequire("k2WVn");
const $5d2f575e3dd958d8$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $5d2f575e3dd958d8$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $5d2f575e3dd958d8$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7H6Cr.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7H6Cr.Slice).empty : content);
            if (i == 0) $5d2f575e3dd958d8$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $5d2f575e3dd958d8$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $5d2f575e3dd958d8$export$c2b25f346d19bcbb($pos) : $5d2f575e3dd958d8$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $5d2f575e3dd958d8$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $5d2f575e3dd958d8$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $5d2f575e3dd958d8$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $5d2f575e3dd958d8$var$findSelectionIn(doc, doc, 0, 0, 1) || new $5d2f575e3dd958d8$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $5d2f575e3dd958d8$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $5d2f575e3dd958d8$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $5d2f575e3dd958d8$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $5d2f575e3dd958d8$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $5d2f575e3dd958d8$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $5d2f575e3dd958d8$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$5d2f575e3dd958d8$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $5d2f575e3dd958d8$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $5d2f575e3dd958d8$var$warnedAboutTextSelection = false;
function $5d2f575e3dd958d8$var$checkTextSelection($pos) {
    if (!$5d2f575e3dd958d8$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $5d2f575e3dd958d8$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $5d2f575e3dd958d8$export$c2b25f346d19bcbb extends $5d2f575e3dd958d8$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $5d2f575e3dd958d8$var$checkTextSelection($anchor);
        $5d2f575e3dd958d8$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $5d2f575e3dd958d8$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $5d2f575e3dd958d8$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7H6Cr.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7H6Cr.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $5d2f575e3dd958d8$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $5d2f575e3dd958d8$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $5d2f575e3dd958d8$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $5d2f575e3dd958d8$export$52baac22726c72bf.findFrom($head, bias, true) || $5d2f575e3dd958d8$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $5d2f575e3dd958d8$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($5d2f575e3dd958d8$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $5d2f575e3dd958d8$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $5d2f575e3dd958d8$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$5d2f575e3dd958d8$export$52baac22726c72bf.jsonID("text", $5d2f575e3dd958d8$export$c2b25f346d19bcbb);
class $5d2f575e3dd958d8$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $5d2f575e3dd958d8$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $5d2f575e3dd958d8$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $5d2f575e3dd958d8$export$e2940151ac854c0b extends $5d2f575e3dd958d8$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $5d2f575e3dd958d8$export$52baac22726c72bf.near($pos);
        return new $5d2f575e3dd958d8$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $5d2f575e3dd958d8$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $5d2f575e3dd958d8$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $5d2f575e3dd958d8$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $5d2f575e3dd958d8$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$5d2f575e3dd958d8$export$e2940151ac854c0b.prototype.visible = false;
$5d2f575e3dd958d8$export$52baac22726c72bf.jsonID("node", $5d2f575e3dd958d8$export$e2940151ac854c0b);
class $5d2f575e3dd958d8$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $5d2f575e3dd958d8$var$TextBookmark(pos, pos) : new $5d2f575e3dd958d8$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $5d2f575e3dd958d8$export$e2940151ac854c0b.isSelectable(node)) return new $5d2f575e3dd958d8$export$e2940151ac854c0b($pos);
        return $5d2f575e3dd958d8$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $5d2f575e3dd958d8$export$c15d9ba76bdbcd95 extends $5d2f575e3dd958d8$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7H6Cr.Slice).empty) {
        if (content == (0, $7H6Cr.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $5d2f575e3dd958d8$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $5d2f575e3dd958d8$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $5d2f575e3dd958d8$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $5d2f575e3dd958d8$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $5d2f575e3dd958d8$var$AllBookmark;
    }
}
$5d2f575e3dd958d8$export$52baac22726c72bf.jsonID("all", $5d2f575e3dd958d8$export$c15d9ba76bdbcd95);
const $5d2f575e3dd958d8$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $5d2f575e3dd958d8$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $5d2f575e3dd958d8$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $5d2f575e3dd958d8$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $5d2f575e3dd958d8$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $5d2f575e3dd958d8$export$e2940151ac854c0b.isSelectable(child)) return $5d2f575e3dd958d8$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $5d2f575e3dd958d8$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $k2WVn.ReplaceStep) || step instanceof (0, $k2WVn.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($5d2f575e3dd958d8$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $5d2f575e3dd958d8$var$UPDATED_SEL = 1, $5d2f575e3dd958d8$var$UPDATED_MARKS = 2, $5d2f575e3dd958d8$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $5d2f575e3dd958d8$export$febc5573c75cefb0 extends (0, $k2WVn.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $5d2f575e3dd958d8$var$UPDATED_SEL) & ~$5d2f575e3dd958d8$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $5d2f575e3dd958d8$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $5d2f575e3dd958d8$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7H6Cr.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $5d2f575e3dd958d8$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$5d2f575e3dd958d8$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7H6Cr.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($5d2f575e3dd958d8$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $5d2f575e3dd958d8$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $5d2f575e3dd958d8$var$UPDATED_SCROLL) > 0;
    }
}
function $5d2f575e3dd958d8$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $5d2f575e3dd958d8$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $5d2f575e3dd958d8$var$bind(desc.init, self);
        this.apply = $5d2f575e3dd958d8$var$bind(desc.apply, self);
    }
}
const $5d2f575e3dd958d8$var$baseFields = [
    new $5d2f575e3dd958d8$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $5d2f575e3dd958d8$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $5d2f575e3dd958d8$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $5d2f575e3dd958d8$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $5d2f575e3dd958d8$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $5d2f575e3dd958d8$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $5d2f575e3dd958d8$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $5d2f575e3dd958d8$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $5d2f575e3dd958d8$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $5d2f575e3dd958d8$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $5d2f575e3dd958d8$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $5d2f575e3dd958d8$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $5d2f575e3dd958d8$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $5d2f575e3dd958d8$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $5d2f575e3dd958d8$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $5d2f575e3dd958d8$var$Configuration(config.schema, config.plugins);
        let instance = new $5d2f575e3dd958d8$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7H6Cr.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $5d2f575e3dd958d8$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $5d2f575e3dd958d8$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $5d2f575e3dd958d8$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $5d2f575e3dd958d8$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $5d2f575e3dd958d8$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $5d2f575e3dd958d8$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $5d2f575e3dd958d8$var$keys = Object.create(null);
function $5d2f575e3dd958d8$var$createKey(name) {
    if (name in $5d2f575e3dd958d8$var$keys) return name + "$" + ++$5d2f575e3dd958d8$var$keys[name];
    $5d2f575e3dd958d8$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $5d2f575e3dd958d8$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $5d2f575e3dd958d8$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("k2WVn", function(module, exports) {
$parcel$export(module.exports, "StepMap", () => $e981b3b80acc5b13$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $e981b3b80acc5b13$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $e981b3b80acc5b13$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $e981b3b80acc5b13$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $e981b3b80acc5b13$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $e981b3b80acc5b13$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $e981b3b80acc5b13$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $e981b3b80acc5b13$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $e981b3b80acc5b13$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $e981b3b80acc5b13$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $e981b3b80acc5b13$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $e981b3b80acc5b13$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $e981b3b80acc5b13$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $e981b3b80acc5b13$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $e981b3b80acc5b13$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $e981b3b80acc5b13$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $e981b3b80acc5b13$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $e981b3b80acc5b13$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $e981b3b80acc5b13$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $e981b3b80acc5b13$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $e981b3b80acc5b13$export$563a914cafbdc389);

var $7H6Cr = parcelRequire("7H6Cr");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $e981b3b80acc5b13$var$lower16 = 0xffff;
const $e981b3b80acc5b13$var$factor16 = Math.pow(2, 16);
function $e981b3b80acc5b13$var$makeRecover(index, offset) {
    return index + offset * $e981b3b80acc5b13$var$factor16;
}
function $e981b3b80acc5b13$var$recoverIndex(value) {
    return value & $e981b3b80acc5b13$var$lower16;
}
function $e981b3b80acc5b13$var$recoverOffset(value) {
    return (value - (value & $e981b3b80acc5b13$var$lower16)) / $e981b3b80acc5b13$var$factor16;
}
const $e981b3b80acc5b13$var$DEL_BEFORE = 1, $e981b3b80acc5b13$var$DEL_AFTER = 2, $e981b3b80acc5b13$var$DEL_ACROSS = 4, $e981b3b80acc5b13$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $e981b3b80acc5b13$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $e981b3b80acc5b13$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($e981b3b80acc5b13$var$DEL_BEFORE | $e981b3b80acc5b13$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($e981b3b80acc5b13$var$DEL_AFTER | $e981b3b80acc5b13$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $e981b3b80acc5b13$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $e981b3b80acc5b13$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty) return $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $e981b3b80acc5b13$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $e981b3b80acc5b13$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $e981b3b80acc5b13$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $e981b3b80acc5b13$var$DEL_AFTER : pos == end ? $e981b3b80acc5b13$var$DEL_BEFORE : $e981b3b80acc5b13$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $e981b3b80acc5b13$var$DEL_SIDE;
                return new $e981b3b80acc5b13$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $e981b3b80acc5b13$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $e981b3b80acc5b13$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $e981b3b80acc5b13$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty : new $e981b3b80acc5b13$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty = new $e981b3b80acc5b13$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $e981b3b80acc5b13$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $e981b3b80acc5b13$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $e981b3b80acc5b13$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $e981b3b80acc5b13$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $e981b3b80acc5b13$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $e981b3b80acc5b13$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $e981b3b80acc5b13$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $e981b3b80acc5b13$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $e981b3b80acc5b13$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $e981b3b80acc5b13$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $e981b3b80acc5b13$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $e981b3b80acc5b13$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $e981b3b80acc5b13$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7H6Cr.ReplaceError)) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $e981b3b80acc5b13$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($e981b3b80acc5b13$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7H6Cr.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $e981b3b80acc5b13$export$d24ba56b0e3464a9 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $e981b3b80acc5b13$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $e981b3b80acc5b13$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $e981b3b80acc5b13$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $e981b3b80acc5b13$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $e981b3b80acc5b13$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("addMark", $e981b3b80acc5b13$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $e981b3b80acc5b13$export$94150db1311f67a9 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $e981b3b80acc5b13$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $e981b3b80acc5b13$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $e981b3b80acc5b13$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $e981b3b80acc5b13$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $e981b3b80acc5b13$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("removeMark", $e981b3b80acc5b13$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $e981b3b80acc5b13$export$adefd16c402fee4e extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $e981b3b80acc5b13$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $e981b3b80acc5b13$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $e981b3b80acc5b13$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $e981b3b80acc5b13$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $e981b3b80acc5b13$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("addNodeMark", $e981b3b80acc5b13$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $e981b3b80acc5b13$export$fdf7d1dc10724da2 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $e981b3b80acc5b13$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $e981b3b80acc5b13$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $e981b3b80acc5b13$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("removeNodeMark", $e981b3b80acc5b13$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $e981b3b80acc5b13$export$5c860b2e74034756 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $e981b3b80acc5b13$var$contentBetween(doc, this.from, this.to)) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $e981b3b80acc5b13$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $e981b3b80acc5b13$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $e981b3b80acc5b13$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $e981b3b80acc5b13$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7H6Cr.Slice).empty : new (0, $7H6Cr.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $e981b3b80acc5b13$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7H6Cr.Slice).empty : new (0, $7H6Cr.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $e981b3b80acc5b13$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $e981b3b80acc5b13$export$5c860b2e74034756(json.from, json.to, (0, $7H6Cr.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("replace", $e981b3b80acc5b13$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $e981b3b80acc5b13$export$444ba800d6024a98 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($e981b3b80acc5b13$var$contentBetween(doc, this.from, this.gapFrom) || $e981b3b80acc5b13$var$contentBetween(doc, this.gapTo, this.to))) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $e981b3b80acc5b13$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $e981b3b80acc5b13$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $e981b3b80acc5b13$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $e981b3b80acc5b13$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7H6Cr.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("replaceAround", $e981b3b80acc5b13$export$444ba800d6024a98);
function $e981b3b80acc5b13$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $e981b3b80acc5b13$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $e981b3b80acc5b13$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $e981b3b80acc5b13$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $e981b3b80acc5b13$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7H6Cr.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $e981b3b80acc5b13$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $e981b3b80acc5b13$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $e981b3b80acc5b13$export$5c860b2e74034756(cur, end, (0, $7H6Cr.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $e981b3b80acc5b13$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $e981b3b80acc5b13$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7H6Cr.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7H6Cr.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $e981b3b80acc5b13$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $e981b3b80acc5b13$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$e981b3b80acc5b13$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $e981b3b80acc5b13$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7H6Cr.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7H6Cr.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7H6Cr.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7H6Cr.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $e981b3b80acc5b13$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7H6Cr.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $e981b3b80acc5b13$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $e981b3b80acc5b13$var$findWrappingOutside(range, nodeType);
    let inner = around && $e981b3b80acc5b13$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($e981b3b80acc5b13$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($e981b3b80acc5b13$var$withAttrs));
}
function $e981b3b80acc5b13$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $e981b3b80acc5b13$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $e981b3b80acc5b13$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $e981b3b80acc5b13$var$wrap(tr, range, wrappers) {
    let content = (0, $7H6Cr.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7H6Cr.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $e981b3b80acc5b13$export$444ba800d6024a98(start, end, start, end, new (0, $7H6Cr.Slice)(content, 0, 0), wrappers.length, true));
}
function $e981b3b80acc5b13$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $e981b3b80acc5b13$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $e981b3b80acc5b13$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $e981b3b80acc5b13$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $e981b3b80acc5b13$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $e981b3b80acc5b13$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $e981b3b80acc5b13$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $e981b3b80acc5b13$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $e981b3b80acc5b13$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $e981b3b80acc5b13$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $e981b3b80acc5b13$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $e981b3b80acc5b13$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $e981b3b80acc5b13$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7H6Cr.Fragment).empty, after = (0, $7H6Cr.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7H6Cr.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7H6Cr.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $e981b3b80acc5b13$export$5c860b2e74034756(pos, pos, new (0, $7H6Cr.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $e981b3b80acc5b13$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $e981b3b80acc5b13$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $e981b3b80acc5b13$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $e981b3b80acc5b13$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $e981b3b80acc5b13$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $e981b3b80acc5b13$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $e981b3b80acc5b13$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $e981b3b80acc5b13$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $e981b3b80acc5b13$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $e981b3b80acc5b13$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $e981b3b80acc5b13$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $7H6Cr.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $e981b3b80acc5b13$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $e981b3b80acc5b13$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $e981b3b80acc5b13$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $e981b3b80acc5b13$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7H6Cr.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($e981b3b80acc5b13$var$fitsTrivially($from, $to, slice)) return new $e981b3b80acc5b13$export$5c860b2e74034756(from, to, slice);
    return new $e981b3b80acc5b13$var$Fitter($from, $to, slice).fit();
}
function $e981b3b80acc5b13$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $e981b3b80acc5b13$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7H6Cr.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7H6Cr.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7H6Cr.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $e981b3b80acc5b13$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $e981b3b80acc5b13$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $e981b3b80acc5b13$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7H6Cr.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $e981b3b80acc5b13$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7H6Cr.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $e981b3b80acc5b13$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($e981b3b80acc5b13$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $e981b3b80acc5b13$var$addToFragment(this.placed, frontierDepth, (0, $7H6Cr.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7H6Cr.Slice).empty : new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$e981b3b80acc5b13$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $e981b3b80acc5b13$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $e981b3b80acc5b13$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $e981b3b80acc5b13$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $e981b3b80acc5b13$var$addToFragment(this.placed, this.depth, (0, $7H6Cr.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7H6Cr.Fragment).empty, true);
        if (add.childCount) this.placed = $e981b3b80acc5b13$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $e981b3b80acc5b13$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($e981b3b80acc5b13$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $e981b3b80acc5b13$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($e981b3b80acc5b13$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $e981b3b80acc5b13$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $e981b3b80acc5b13$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $e981b3b80acc5b13$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7H6Cr.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $e981b3b80acc5b13$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$e981b3b80acc5b13$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $e981b3b80acc5b13$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $e981b3b80acc5b13$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $e981b3b80acc5b13$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($e981b3b80acc5b13$var$fitsTrivially($from, $to, slice)) return tr.step(new $e981b3b80acc5b13$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $e981b3b80acc5b13$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $e981b3b80acc5b13$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7H6Cr.Slice)($e981b3b80acc5b13$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $e981b3b80acc5b13$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($e981b3b80acc5b13$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7H6Cr.Fragment).empty, true));
    }
    return fragment;
}
function $e981b3b80acc5b13$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $e981b3b80acc5b13$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(node), 0, 0));
}
function $e981b3b80acc5b13$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $e981b3b80acc5b13$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $e981b3b80acc5b13$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $e981b3b80acc5b13$export$626399c38172f669 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $e981b3b80acc5b13$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $e981b3b80acc5b13$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $e981b3b80acc5b13$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $e981b3b80acc5b13$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("attr", $e981b3b80acc5b13$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $e981b3b80acc5b13$export$f50707b396300ac9 extends $e981b3b80acc5b13$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $e981b3b80acc5b13$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $e981b3b80acc5b13$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $e981b3b80acc5b13$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $e981b3b80acc5b13$export$f50707b396300ac9(json.attr, json.value);
    }
}
$e981b3b80acc5b13$export$fd55ce593607084a.jsonID("docAttr", $e981b3b80acc5b13$export$f50707b396300ac9);
/**
@internal
*/ let $e981b3b80acc5b13$export$88cc3a1dfce48dd3 = class extends Error {
};
$e981b3b80acc5b13$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$e981b3b80acc5b13$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$e981b3b80acc5b13$export$88cc3a1dfce48dd3.prototype.constructor = $e981b3b80acc5b13$export$88cc3a1dfce48dd3;
$e981b3b80acc5b13$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $e981b3b80acc5b13$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $e981b3b80acc5b13$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $e981b3b80acc5b13$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7H6Cr.Slice).empty) {
        let step = $e981b3b80acc5b13$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7H6Cr.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $e981b3b80acc5b13$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $e981b3b80acc5b13$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $e981b3b80acc5b13$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $e981b3b80acc5b13$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $e981b3b80acc5b13$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $e981b3b80acc5b13$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $e981b3b80acc5b13$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $e981b3b80acc5b13$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $e981b3b80acc5b13$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $e981b3b80acc5b13$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $e981b3b80acc5b13$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7H6Cr.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $e981b3b80acc5b13$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $e981b3b80acc5b13$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $e981b3b80acc5b13$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $e981b3b80acc5b13$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $e981b3b80acc5b13$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("cNUap", function(module, exports) {
$parcel$export(module.exports, "getStartPos", () => $76d4af961846e8e0$export$aabc9b13a308cc43);
$parcel$export(module.exports, "findParent", () => $76d4af961846e8e0$export$25245567f53f158f);
$parcel$export(module.exports, "getPosFromRange", () => $76d4af961846e8e0$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $76d4af961846e8e0$export$74899f7e5acb5cd3);
/* eslint-disable jsdoc/require-jsdoc -- internal step helpers */ 
var $k2WVn = parcelRequire("k2WVn");

var $dRkX9 = parcelRequire("dRkX9");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $76d4af961846e8e0$var$MEDIA_OR_MEDIA_SINGLE_REGEX = /media|mediaSingle/;
function $76d4af961846e8e0$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $76d4af961846e8e0$var$getNodeType = (element)=>element.dataset.nodeType;
function $76d4af961846e8e0$var$isPositionPointer(element) {
    return $76d4af961846e8e0$export$aabc9b13a308cc43(element) > -1;
}
function $76d4af961846e8e0$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $76d4af961846e8e0$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($76d4af961846e8e0$var$isPositionPointer(parentElement)) return parentElement;
    return $76d4af961846e8e0$export$25245567f53f158f(parentElement);
}
function $76d4af961846e8e0$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $76d4af961846e8e0$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $76d4af961846e8e0$var$findMediaParent(parentElement);
}
function $76d4af961846e8e0$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($76d4af961846e8e0$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($76d4af961846e8e0$var$isPositionPointer(parentElement)) return element;
    return $76d4af961846e8e0$var$findParentBeforePointer(parentElement);
}
function $76d4af961846e8e0$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $76d4af961846e8e0$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $76d4af961846e8e0$var$isHighlightTextNode(node) {
    var _dataset;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $76d4af961846e8e0$var$isNodeInlineMark(node) {
    return $76d4af961846e8e0$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $76d4af961846e8e0$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $76d4af961846e8e0$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $76d4af961846e8e0$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($76d4af961846e8e0$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $76d4af961846e8e0$var$hasInlineNodeDescendant(node) {
    if ($76d4af961846e8e0$var$isElementNode(node)) {
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($76d4af961846e8e0$var$hasInlineNodeDescendant);
    }
    return false;
}
function $76d4af961846e8e0$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($76d4af961846e8e0$var$isTextNode(prev) || $76d4af961846e8e0$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($76d4af961846e8e0$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($76d4af961846e8e0$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $76d4af961846e8e0$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $76d4af961846e8e0$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
        var _node$parentElement;
        const startPosAncestor = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('[data-renderer-start-pos');
        const potentialParent = (0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor !== null && startPosAncestor !== void 0 && startPosAncestor.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10) + 1;
            else return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $76d4af961846e8e0$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $76d4af961846e8e0$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++){
                var _children$i;
                count += ((_children$i = children[i]) === null || _children$i === void 0 || (_children$i = _children$i.textContent) === null || _children$i === void 0 ? void 0 : _children$i.length) || 1;
            }
            return count;
        }
        return $76d4af961846e8e0$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $76d4af961846e8e0$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $76d4af961846e8e0$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $76d4af961846e8e0$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($76d4af961846e8e0$var$isNodeInlineTextMark(preParentPointer) || $76d4af961846e8e0$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($76d4af961846e8e0$var$isElementInlineMark(preParentPointer) || $76d4af961846e8e0$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $76d4af961846e8e0$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $76d4af961846e8e0$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $76d4af961846e8e0$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $76d4af961846e8e0$var$getSelectedCommentTargetPosition(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    if (startContainer !== endContainer || endOffset !== startOffset + 1) return false;
    const selectedNode = startContainer.childNodes[startOffset];
    if (!selectedNode || !$76d4af961846e8e0$var$isElementNode(selectedNode) || selectedNode.dataset.inlineCommentsTarget !== 'true' || !$76d4af961846e8e0$var$isPositionPointer(selectedNode)) return false;
    // Subtract 1 from the renderer start position to get the position before the extension node.
    return $76d4af961846e8e0$export$aabc9b13a308cc43(selectedNode) - 1;
}
function $76d4af961846e8e0$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const selectedCommentTargetPosition = (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && $76d4af961846e8e0$var$getSelectedCommentTargetPosition(range);
    if (selectedCommentTargetPosition !== false) return {
        from: selectedCommentTargetPosition,
        to: selectedCommentTargetPosition
    };
    const possibleMediaOrMediaSingleElement = $76d4af961846e8e0$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && $76d4af961846e8e0$var$MEDIA_OR_MEDIA_SINGLE_REGEX.test($76d4af961846e8e0$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $76d4af961846e8e0$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $76d4af961846e8e0$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $76d4af961846e8e0$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $76d4af961846e8e0$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $76d4af961846e8e0$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $76d4af961846e8e0$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $k2WVn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("17pA6", function(module, exports) {
$parcel$export(module.exports, "isLegacyContentExtension", () => $af558c6bdbddded0$export$ae607f800f514e24);
$parcel$export(module.exports, "getAnnotationMarksWithLegacyContent", () => $af558c6bdbddded0$export$749ce64ac8cc8fd7);
const $af558c6bdbddded0$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $af558c6bdbddded0$export$ae607f800f514e24 = (node)=>(node.type.name === 'extension' || node.type.name === 'inlineExtension' || node.type.name === 'bodiedExtension') && node.attrs.extensionType === 'com.atlassian.confluence.migration' && node.attrs.extensionKey === 'legacy-content';
const $af558c6bdbddded0$var$getNestedContent = (node)=>{
    const parameters = node.attrs.parameters;
    if (!$af558c6bdbddded0$var$isObject(parameters)) return undefined;
    const nestedContent = parameters.nestedContent;
    return $af558c6bdbddded0$var$isObject(nestedContent) && nestedContent.type === 'doc' && Array.isArray(nestedContent.content) ? nestedContent : undefined;
};
const $af558c6bdbddded0$export$749ce64ac8cc8fd7 = (node, annotationMarkType)=>{
    if (!$af558c6bdbddded0$export$ae607f800f514e24(node)) return [];
    const nestedContent = $af558c6bdbddded0$var$getNestedContent(node);
    if (!nestedContent) return [];
    const marks = [];
    const visited = new WeakSet();
    const pending = [
        nestedContent
    ];
    while(pending.length){
        const value = pending.pop();
        if (!$af558c6bdbddded0$var$isObject(value) || visited.has(value)) continue;
        visited.add(value);
        if (Array.isArray(value.marks)) for (const mark of value.marks){
            if (!$af558c6bdbddded0$var$isObject(mark) || mark.type !== 'annotation' || !$af558c6bdbddded0$var$isObject(mark.attrs)) continue;
            const { id: id, annotationType: annotationType } = mark.attrs;
            if (annotationType === 'inlineComment' && typeof id === 'string' && id.trim().length > 0) marks.push(annotationMarkType.create({
                id: id,
                annotationType: annotationType
            }));
        }
        if (Array.isArray(value.content)) for(let index = value.content.length - 1; index >= 0; index--)pending.push(value.content[index]);
        const attrs = value.attrs;
        if ($af558c6bdbddded0$var$isObject(attrs) && (value.type === 'extension' || value.type === 'inlineExtension' || value.type === 'bodiedExtension') && attrs.extensionType === 'com.atlassian.confluence.migration' && attrs.extensionKey === 'legacy-content') {
            const parameters = attrs.parameters;
            const childNestedContent = $af558c6bdbddded0$var$isObject(parameters) ? parameters.nestedContent : undefined;
            if ($af558c6bdbddded0$var$isObject(childNestedContent) && childNestedContent.type === 'doc' && Array.isArray(childNestedContent.content)) pending.push(childNestedContent);
        }
    }
    return marks;
};

});

parcelRegister("5pBjL", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $bd3f6ec5d17b1451$export$b0ea72d31617ccea);

var $f1MDe = parcelRequire("f1MDe");

var $dRkX9 = parcelRequire("dRkX9");
function $bd3f6ec5d17b1451$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $f1MDe.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("d3z80", function(module, exports) {
$parcel$export(module.exports, "isBlockAnnotationTarget", () => $839ab5d0061f424c$export$b642df2122d0ab8);
$parcel$export(module.exports, "getIndexMatch", () => $839ab5d0061f424c$export$fb7dab895a0d310e);

var $dRkX9 = parcelRequire("dRkX9");
function $839ab5d0061f424c$export$b642df2122d0ab8(node, schema) {
    const { extension: extension, media: media } = schema.nodes;
    return node.type === media || node.type === extension && (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && node.type.allowsMarkType(schema.marks.annotation);
}
function $839ab5d0061f424c$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const isBlockTarget = $839ab5d0061f424c$export$b642df2122d0ab8(node, schema);
        const isBlockContainer = nodeType.isBlock && !nodeType.isLeaf && !nodeType.inlineContent;
        // Containers may allow annotations for their children; skip their own text to avoid double-counting.
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation) || isBlockContainer) && !isBlockTarget) return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            if (isBlockTarget) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $839ab5d0061f424c$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $839ab5d0061f424c$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $839ab5d0061f424c$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("9Nj04", function(module, exports) {
$parcel$export(module.exports, "getSelectionContext", () => $76c9278ebca8f590$export$3726c4866ce829b5);

var $8lzQl = parcelRequire("8lzQl");
var $750wn = parcelRequire("750wn");

var $801jp = parcelRequire("801jp");

var $cNUap = parcelRequire("cNUap");
const $76c9278ebca8f590$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $cNUap.findParent)(range.startContainer);
    const endNode = (0, $cNUap.findParent)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $cNUap.getStartPos)(startNode);
    const endPos = (0, $cNUap.getStartPos)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $cNUap.getPosFromRange)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $801jp.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $8lzQl.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $750wn.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};

});
parcelRegister("8lzQl", function(module, exports) {
$parcel$export(module.exports, "getFragmentsFromSelection", () => $2327f42146669bb2$export$dae3dcae007fe30);

var $cu8Jp = parcelRequire("cu8Jp");

var $lXU4d = parcelRequire("lXU4d");
const $2327f42146669bb2$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = (0, $lXU4d.getSliceFromSelection)(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $cu8Jp.nodeToJSON)(node, {
            keepNestedTables: true
        }));
    });
    return fragment;
};

});
parcelRegister("cu8Jp", function(module, exports) {
$parcel$export(module.exports, "validateNodes", () => $f94b8fb2049786fc$export$996213f7c272fc6f);
$parcel$export(module.exports, "isType", () => $f94b8fb2049786fc$export$26b9f946b448f23e);
$parcel$export(module.exports, "isParagraph", () => $f94b8fb2049786fc$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $f94b8fb2049786fc$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $f94b8fb2049786fc$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $f94b8fb2049786fc$export$5125f50e751e84db);
$parcel$export(module.exports, "toJSON", () => $f94b8fb2049786fc$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $f94b8fb2049786fc$export$3a858d3babd60825);

var $f7AYl = parcelRequire("f7AYl");

var $2tg6H = parcelRequire("2tg6H");

var $8lhM8 = parcelRequire("8lhM8");




const $f94b8fb2049786fc$export$996213f7c272fc6f = (nodes)=>nodes.every((0, $8lhM8.validNode));
const $f94b8fb2049786fc$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $f94b8fb2049786fc$export$d7ae8c533ae18832 = (node, schema)=>$f94b8fb2049786fc$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $f94b8fb2049786fc$export$1879817ac5c922b7 = (node, schema)=>$f94b8fb2049786fc$export$26b9f946b448f23e(node, schema.nodes.text);
const $f94b8fb2049786fc$export$5dfeda3a9e6fe056 = (node, schema)=>$f94b8fb2049786fc$export$26b9f946b448f23e(node, schema.marks.link);
const $f94b8fb2049786fc$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return (0, $2tg6H.SelectedState).selectedInRange;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return (0, $2tg6H.SelectedState).selectedInside;
    return null;
};
const $f94b8fb2049786fc$var$transformer = new (0, $f7AYl.JSONTransformer)();
function $f94b8fb2049786fc$export$54fd2c36b5cc6731(node) {
    return $f94b8fb2049786fc$var$transformer.encode(node);
}
function $f94b8fb2049786fc$export$3a858d3babd60825(node, options) {
    return $f94b8fb2049786fc$var$transformer.encodeNode(node, options);
}

});
parcelRegister("2tg6H", function(module, exports) {
$parcel$export(module.exports, "SelectedState", () => $39e44ca917506c32$export$a6212ae0c82963af);
var $39e44ca917506c32$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});

});

parcelRegister("8lhM8", function(module, exports) {
$parcel$export(module.exports, "validNode", () => $2eeebafffb3666bf$export$4c39e41e39b3c449);
const $2eeebafffb3666bf$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};

});


parcelRegister("lXU4d", function(module, exports) {
$parcel$export(module.exports, "getSliceFromSelection", () => $55fd080ce2443bee$export$4fd509032ef7561b);

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");


const $55fd080ce2443bee$var$listDepth = 3;
const $55fd080ce2443bee$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $55fd080ce2443bee$var$listDepth && $to.depth >= $55fd080ce2443bee$var$listDepth && $from.depth === $to.depth) {
        var _greatGrandparentFrom, _greatGrandparentFrom2;
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        (_greatGrandparentFrom = greatGrandparentFrom.firstChild) !== null && _greatGrandparentFrom !== void 0 && _greatGrandparentFrom.eq(grandparentFrom) && (_greatGrandparentFrom2 = greatGrandparentFrom.lastChild) !== null && _greatGrandparentFrom2 !== void 0 && _greatGrandparentFrom2.eq(grandparentTo)) return true;
    }
    return false;
};
const $55fd080ce2443bee$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $7H6Cr.Fragment).empty;
    let frag = (0, $7H6Cr.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $801jp.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($55fd080ce2443bee$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $55fd080ce2443bee$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};

});


parcelRegister("750wn", function(module, exports) {
$parcel$export(module.exports, "getLocalIdsFromSelection", () => $d646cdb986163eba$export$9ce8378d786d4035);

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $dRkX9 = parcelRequire("dRkX9");

var $lXU4d = parcelRequire("lXU4d");
const $d646cdb986163eba$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $801jp.NodeSelection)) {
        if ((0, $dRkX9.fg)('platform_editor_ai_selection_local_ids')) {
            var _selection$node$attrs;
            const ids = [];
            const rootLocalId = (_selection$node$attrs = selection.node.attrs) === null || _selection$node$attrs === void 0 ? void 0 : _selection$node$attrs.localId;
            if (rootLocalId) ids.push(rootLocalId);
            selection.node.descendants((node)=>{
                var _node$attrs;
                if (node.isInline) return false;
                const localId = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId;
                if (localId) ids.push(localId);
            });
            return ids;
        }
        return [
            selection.node.attrs.localId
        ];
    } else if (selection instanceof (0, $ev7OZ.CellSelection)) {
        if ((0, $dRkX9.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const ancestorIds = new Set();
            // Collect localIds from each selected cell and its descendants
            selection.forEachCell((cellNode, cellPos)=>{
                var _cellNode$attrs;
                const cellLocalId = (_cellNode$attrs = cellNode.attrs) === null || _cellNode$attrs === void 0 ? void 0 : _cellNode$attrs.localId;
                if (cellLocalId) ids.push(cellLocalId);
                cellNode.descendants((node)=>{
                    var _node$attrs2;
                    if (node.isInline) return false;
                    const localId = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId;
                    if (localId) ids.push(localId);
                });
                // Collect ancestor localIds (row, table) separately
                const $cell = selection.$anchorCell.doc.resolve(cellPos + 1);
                for(let depth = $cell.depth - 1; depth >= 1; depth--){
                    var _ancestor$attrs;
                    const ancestor = $cell.node(depth);
                    const localId = (_ancestor$attrs = ancestor.attrs) === null || _ancestor$attrs === void 0 ? void 0 : _ancestor$attrs.localId;
                    if (localId) ancestorIds.add(localId);
                }
            });
            const uniqueIds = new Set(ids);
            const uniqueAncestors = [
                ...ancestorIds
            ].filter((id)=>!uniqueIds.has(id));
            return [
                ...uniqueIds,
                ...uniqueAncestors
            ];
        }
    } else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = (0, $lXU4d.getSliceFromSelection)(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        var _node$attrs3;
        const localId = (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};

});
parcelRegister("ev7OZ", function(module, exports) {
$parcel$export(module.exports, "CellSelection", () => $58256db2783af191$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $gY2co = parcelRequire("gY2co");

var $dpooP = parcelRequire("dpooP");

var $2AdQE = parcelRequire("2AdQE");

var $9CB3n = parcelRequire("9CB3n");

var $OBqFU = parcelRequire("OBqFU");

var $9fk2x = parcelRequire("9fk2x");
class $58256db2783af191$export$831cc7e2a83afa94 extends (0, $801jp.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $2AdQE.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $OBqFU.pointsAtCell)($anchorCell) && (0, $OBqFU.pointsAtCell)($headCell) && (0, $9CB3n.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $58256db2783af191$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $58256db2783af191$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $58256db2783af191$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $801jp.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $dpooP.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $9fk2x.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $9fk2x.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $7H6Cr.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $7H6Cr.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7H6Cr.Slice).empty : content);
        }
        const sel = (0, $801jp.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $dpooP.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $dpooP.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $58256db2783af191$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $dpooP.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $58256db2783af191$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $dpooP.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $58256db2783af191$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $58256db2783af191$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $58256db2783af191$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $58256db2783af191$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $gY2co.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $801jp.Selection).jsonID('cell', $58256db2783af191$export$831cc7e2a83afa94);

});
parcelRegister("gY2co", function(module, exports) {
$parcel$export(module.exports, "CellBookmark", () => $2f32bcc2037e50a8$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $801jp = parcelRequire("801jp");

var $9CB3n = parcelRequire("9CB3n");
class $2f32bcc2037e50a8$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $2f32bcc2037e50a8$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $9CB3n.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $801jp.Selection).fromJSON(doc, data);
        }
        return (0, $801jp.Selection).near($headCell, 1);
    }
}

});
parcelRegister("9CB3n", function(module, exports) {
$parcel$export(module.exports, "inSameTable", () => $3d49aa5a6e8928ed$export$debd62b44eb7e281);
function $3d49aa5a6e8928ed$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("dpooP", function(module, exports) {
$parcel$export(module.exports, "TableProblemTypes", () => $64ad190704011974$export$d8cd393a71edca79);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $64ad190704011974$export$c60fae4049791eae);
$parcel$export(module.exports, "TableMap", () => $64ad190704011974$export$493da463fed0a57a);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $aE7IK = parcelRequire("aE7IK");

var $er2Xz = parcelRequire("er2Xz");

var $iTbj2 = parcelRequire("iTbj2");

var $1pRtZ = parcelRequire("1pRtZ");


var $64ad190704011974$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $64ad190704011974$export$c60fae4049791eae = 140;
class $64ad190704011974$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new (0, $1pRtZ.Rect)(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new (0, $1pRtZ.Rect)(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return (0, $iTbj2.readFromCache)(table) || (0, $aE7IK.addToCache)(table, (0, $er2Xz.computeMap)(table));
    }
}

});
parcelRegister("aE7IK", function(module, exports) {
$parcel$export(module.exports, "addToCache", () => $d12e20a8468ae063$export$d6414c810925a1da);

var $23cuQ = parcelRequire("23cuQ");
function $d12e20a8468ae063$export$d6414c810925a1da(key, value) {
    return (0, $23cuQ.tableMapCache).set(key, value);
}

});
parcelRegister("23cuQ", function(module, exports) {
$parcel$export(module.exports, "tableMapCache", () => $5a1240ebe9578aac$export$8972ebb43002a388);
// Share the same cache between readers and writers. Table maps are relative to
// immutable table nodes, so changing the document produces a different key.
let $5a1240ebe9578aac$var$readFromCache;
let $5a1240ebe9578aac$var$addToCache;
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $5a1240ebe9578aac$var$readFromCache = (key)=>cache.get(key);
    $5a1240ebe9578aac$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // The original fallback stores five pairs in a ten-slot circular cache.
    const cache = [];
    const cacheSize = 5;
    let cachePos = 0;
    $5a1240ebe9578aac$var$readFromCache = (key)=>{
        for (const [node, map] of cache){
            if (node === key) return map;
        }
        return undefined;
    };
    $5a1240ebe9578aac$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = [
            key,
            value
        ];
        return value;
    };
}
const $5a1240ebe9578aac$export$8972ebb43002a388 = {
    get: $5a1240ebe9578aac$var$readFromCache,
    set: $5a1240ebe9578aac$var$addToCache
};

});


parcelRegister("er2Xz", function(module, exports) {
$parcel$export(module.exports, "computeMap", () => $57646794169b25d9$export$b00423e42c344284);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hkfhP = parcelRequire("hkfhP");

var $gbe8Q = parcelRequire("gbe8Q");

var $dpooP = parcelRequire("dpooP");
function $57646794169b25d9$export$b00423e42c344284(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = (0, $gbe8Q.findWidth)(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: (0, $dpooP.TableProblemTypes).OVERLONG_ROWSPAN,
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: (0, $dpooP.TableProblemTypes).COLLISION,
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: (0, $dpooP.TableProblemTypes).MISSING,
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new (0, $dpooP.TableMap)(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push((0, $dpooP.tableNewColumnMinWidth), 0);
        badWidths = true;
    }
    if (badWidths) (0, $hkfhP.findBadColWidths)(tableMap, colWidths, table);
    return tableMap;
}

});
parcelRegister("hkfhP", function(module, exports) {
$parcel$export(module.exports, "findBadColWidths", () => $1b62b00594e8a990$export$3c60fa892a0c95fe);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dpooP = parcelRequire("dpooP");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1b62b00594e8a990$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}
function $1b62b00594e8a990$export$3c60fa892a0c95fe(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $1b62b00594e8a990$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: (0, $dpooP.TableProblemTypes).COLWIDTH_MISMATCH,
            pos: pos,
            colwidth: updated
        });
    }
}

});

parcelRegister("gbe8Q", function(module, exports) {
$parcel$export(module.exports, "findWidth", () => $49d60781c0f125cf$export$f7bee8f27db3cd05);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
function $49d60781c0f125cf$export$f7bee8f27db3cd05(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}

});


parcelRegister("iTbj2", function(module, exports) {
$parcel$export(module.exports, "readFromCache", () => $cc0d30606548c161$export$42a80a4a4ad0dbe3);

var $23cuQ = parcelRequire("23cuQ");
function $cc0d30606548c161$export$42a80a4a4ad0dbe3(key) {
    return (0, $23cuQ.tableMapCache).get(key);
}

});

parcelRegister("1pRtZ", function(module, exports) {
$parcel$export(module.exports, "Rect", () => $769c925468763017$export$c79fc6492f3af13d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
class $769c925468763017$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}

});


parcelRegister("2AdQE", function(module, exports) {
$parcel$export(module.exports, "getCellSelectionRanges", () => $bbba4fa208c85e32$export$a60a444208fd5099);

var $801jp = parcelRequire("801jp");

var $dpooP = parcelRequire("dpooP");
function $bbba4fa208c85e32$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $dpooP.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $801jp.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});

parcelRegister("OBqFU", function(module, exports) {
$parcel$export(module.exports, "pointsAtCell", () => $65652732aa88f4b2$export$3c89e45c7dff9619);
function $65652732aa88f4b2$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}

});

parcelRegister("9fk2x", function(module, exports) {
$parcel$export(module.exports, "removeColSpan", () => $04307a14db3d9781$export$b24d9c3cc95412e0);
function $04307a14db3d9781$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}

});





parcelRegister("e9N5Z", function(module, exports) {
$parcel$export(module.exports, "IncludeLegacyContentAnnotationsContext", () => $e2167bd8b0e1828d$export$776d1bc38cce3f79);

var $fc4bM = parcelRequire("fc4bM");
const $e2167bd8b0e1828d$export$776d1bc38cce3f79 = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(false);

});



parcelRegister("9Xm1T", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $4c9a5eb0f8696a12$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $4c9a5eb0f8696a12$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $4c9a5eb0f8696a12$export$708fc397e2b6f08d);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
const $4c9a5eb0f8696a12$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $4c9a5eb0f8696a12$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $4c9a5eb0f8696a12$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $4c9a5eb0f8696a12$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $4c9a5eb0f8696a12$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, hasBlockNodeSupport: hasBlockNodeSupport })=>{
    const extensionCommentsEnabled = !!hasBlockNodeSupport && (0, $dRkX9.fg)('cc_maui_annotations_on_extensions');
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $fc4bM.useReducer)($4c9a5eb0f8696a12$var$reducer, $4c9a5eb0f8696a12$var$initialState);
    const clearSelectionRange = (0, $fc4bM.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $fc4bM.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $fc4bM.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const hoverDraftRangeRef = (0, $fc4bM.useRef)(hoverDraftRange);
    hoverDraftRangeRef.current = hoverDraftRange;
    const setHoverTarget = (0, $fc4bM.useCallback)((target)=>{
        const draftRange = hoverDraftRangeRef.current;
        const draftTarget = draftRange === null || draftRange === void 0 ? void 0 : draftRange.startContainer.childNodes[draftRange.startOffset];
        if (extensionCommentsEnabled && draftTarget instanceof HTMLElement && draftTarget.matches('.ak-renderer-extension[data-inline-comments-target="true"]')) // Keep the composer callbacks bound to the chart chosen when its draft opened.
        return;
        // The HoverComponent expects an element deeply nested inside media or the eligible
        // block node's wrapper. Each selector is only included when its comment type is
        // supported, so hover targeting never activates on an ineligible block node.
        const selectors = [
            allowCommentsOnMedia && '.media-card-inline-player, .media-file-card-view',
            extensionCommentsEnabled && '.ak-renderer-extension[data-inline-comments-target="true"]'
        ].filter((selector)=>Boolean(selector)).join(', ');
        const hoverableNode = extensionCommentsEnabled && target.matches('.ak-renderer-extension[data-inline-comments-target="true"]') ? target : selectors ? target.querySelector(selectors) : null;
        if (!hoverableNode) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- range for media/extension hover highlight
        const range = document.createRange();
        range.setStartBefore(hoverableNode);
        range.setEndAfter(hoverableNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, [
        allowCommentsOnMedia,
        extensionCommentsEnabled
    ]);
    const promoteSelectionToDraft = (0, $fc4bM.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $fc4bM.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $fc4bM.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $fc4bM.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $fc4bM.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $fc4bM.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: allowCommentsOnMedia || extensionCommentsEnabled ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        extensionCommentsEnabled,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($4c9a5eb0f8696a12$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($4c9a5eb0f8696a12$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $4c9a5eb0f8696a12$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, hasBlockNodeSupport: hasBlockNodeSupport, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)($4c9a5eb0f8696a12$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        hasBlockNodeSupport: hasBlockNodeSupport,
        children: children
    });
};
const $4c9a5eb0f8696a12$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $fc4bM.useContext)($4c9a5eb0f8696a12$export$145b9bb655c3d220);
};
const $4c9a5eb0f8696a12$export$708fc397e2b6f08d = ()=>{
    return (0, $fc4bM.useContext)($4c9a5eb0f8696a12$export$efb0d1c8cbaac647);
};

});

parcelRegister("gF12C", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $100c9a456886ae34$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $100c9a456886ae34$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $100c9a456886ae34$export$26cf539704e444c1);

var $fc4bM = parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $38vAg = parcelRequire("38vAg");

var $3LeME = parcelRequire("3LeME");

var $aoZ67 = parcelRequire("aoZ67");

var $kvlmJ = parcelRequire("kvlmJ");
const $100c9a456886ae34$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $fc4bM.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $kvlmJ.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $fc4bM.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $100c9a456886ae34$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $fc4bM.useState)(false);
    const [isHovered, setIsHovered] = (0, $fc4bM.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $kvlmJ.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $100c9a456886ae34$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $100c9a456886ae34$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $fc4bM.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $kvlmJ.useAnnotationManagerState)();
    const selectedAnnotation = (0, $fc4bM.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // This is a constant to represent the case when no annotation is selected.
        // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $100c9a456886ae34$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) {
                var _annotationsByType$;
                createAnalyticsEvent({
                    action: (0, $3LeME.ACTION).VIEWED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        // Let products identify the annotated target without changing the open behavior.
                        annotationId: (_annotationsByType$ = annotationsByType[0]) === null || _annotationsByType$ === void 0 ? void 0 : _annotationsByType$.id,
                        overlap: annotationsByType.length || 0,
                        targetNodeType: eventTargetType,
                        method: viewMethod
                    }
                }).fire((0, $38vAg.FabricChannel).editor);
            }
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});

parcelRegister("2x3iO", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $e6801bc83110fbf7$export$39f7c1a861a0d41c);

var $fc4bM = parcelRequire("fc4bM");

var $aoZ67 = parcelRequire("aoZ67");

var $2bxGO = parcelRequire("2bxGO");

var $lk7ff = parcelRequire("lk7ff");

var $kvlmJ = parcelRequire("kvlmJ");
const $e6801bc83110fbf7$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const providers = (0, $fc4bM.useContext)((0, $lk7ff.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $fc4bM.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});

parcelRegister("kMeXA", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $3813a46833c825f5$export$41cd4a02859c2806);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2bxGO = parcelRequire("2bxGO");

var $lk7ff = parcelRequire("lk7ff");

var $gF12C = parcelRequire("gF12C");
const $3813a46833c825f5$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $fc4bM.useContext)((0, $lk7ff.ProvidersContext));
    const actionContext = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $gF12C.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $fc4bM.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $fc4bM.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $3LM7S.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});

parcelRegister("hTXdp", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $1f8434c0c0c24cd7$export$787af8a111ff3c03);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lk7ff = parcelRequire("lk7ff");

var $j81gR = parcelRequire("j81gR");

var $6ladz = parcelRequire("6ladz");
const $1f8434c0c0c24cd7$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $fc4bM.useContext)((0, $lk7ff.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $j81gR.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6ladz.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("j81gR", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $11bff1889ba8a522$export$6d8376a902cb8aa7);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2bxGO = parcelRequire("2bxGO");

var $85PxU = parcelRequire("85PxU");

var $9Xm1T = parcelRequire("9Xm1T");

var $3jMyO = parcelRequire("3jMyO");
const $11bff1889ba8a522$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $9Xm1T.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $9Xm1T.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $85PxU.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3jMyO.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$11bff1889ba8a522$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("3jMyO", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $970d75b08271918e$export$2109cd350bcf6eda);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $38vAg = parcelRequire("38vAg");

var $3LeME = parcelRequire("3LeME");

var $aEmSo = parcelRequire("aEmSo");

var $2bxGO = parcelRequire("2bxGO");

var $9Xm1T = parcelRequire("9Xm1T");

var $aAJVV = parcelRequire("aAJVV");
const $970d75b08271918e$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $9Xm1T.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $9Xm1T.useAnnotationRangeState)();
    const actions = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const onCreateCallback = (0, $fc4bM.useCallback)((annotationId)=>{
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        const positionToAnnotate = (0, $aEmSo.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        }).fire((0, $38vAg.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $fc4bM.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $fc4bM.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $3LeME.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            }).fire((0, $38vAg.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one.
        // Without this, if a previous draft was not explicitly closed, hoverDraftDocumentPosition
        // retains the old position and the comment anchors to the wrong text (COMMENTS-6594).
        if ((0, $aEmSo.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearHoverDraft();
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $3LeME.ACTION).OPENED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $38vAg.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $aAJVV.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        const positionToAnnotate = (0, $aEmSo.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $3LeME.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            }).fire((0, $38vAg.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        hoverDraftDocumentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        clearHoverDraft
    ]);
    const removeDraftModeCallback = (0, $fc4bM.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $fc4bM.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $3LeME.ACTION).CLOSED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $38vAg.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("aAJVV", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $5e44ce6cfa58428d$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $5e44ce6cfa58428d$export$e14699d956e87e73);
/* eslint-disable @atlaskit/platform/no-direct-document-usage -- draft selection uses document range APIs */ const $5e44ce6cfa58428d$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $5e44ce6cfa58428d$var$buildDataAttributesQuery = (pos)=>{
    const a = $5e44ce6cfa58428d$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $5e44ce6cfa58428d$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($5e44ce6cfa58428d$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});



parcelRegister("6ladz", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $9f4bfe40cd4bc773$export$74435b85e23b84d9);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2bxGO = parcelRequire("2bxGO");

var $c84Wx = parcelRequire("c84Wx");

var $bCiO9 = parcelRequire("bCiO9");
const $9f4bfe40cd4bc773$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $c84Wx.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bCiO9.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$9f4bfe40cd4bc773$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("c84Wx", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $499902bec2a6a841$export$47201332e612f5a4);

var $fc4bM = parcelRequire("fc4bM");

var $aEmSo = parcelRequire("aEmSo");

var $kvlmJ = parcelRequire("kvlmJ");

var $9Xm1T = parcelRequire("9Xm1T");

var $6Xrbb = parcelRequire("6Xrbb");
const $499902bec2a6a841$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $fc4bM.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $9Xm1T.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $9Xm1T.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $fc4bM.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $fc4bM.useCallback)((_event)=>{
        var _document$body;
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        /*
     * The 100ms debounce batches rapid `selectionchange` events during user drag/extend
     * operations into a single React update. When the nudge button triggers a programmatic
     * `addRange`, it fires exactly ONE `selectionchange` — no batching needed. Skipping the
     * debounce ensures annotation position is computed synchronously so the first click
     * applies the yellow highlight immediately. `data-nudge-selection-active` is set
     * exclusively by the Confluence comment nudge feature and is double-gated:
     * (1) `expValEquals('confluence_comment_nudgebar_improvement', ...)` — explicit experiment
     * gate; (2) `data-nudge-selection-active` — ensures 0ms only fires during an actual nudge
     * click, not on every selectionchange for experiment-ON users. Zero behavioral change for
     * other products or experiment-OFF users.
     */ const nudgeDelay = typeof document !== 'undefined' && ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.getAttribute('data-nudge-selection-active')) === 'true' && (0, $aEmSo.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true) ? 0 : 100;
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $6Xrbb.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, nudgeDelay);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("6Xrbb", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $4cf32ad5b9dc7542$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $4cf32ad5b9dc7542$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bCiO9", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $5d4850705ddb079b$export$ca7741472ed8ba00);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $6DAwh = parcelRequire("6DAwh");

var $38vAg = parcelRequire("38vAg");

var $3LeME = parcelRequire("3LeME");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $5pBjL = parcelRequire("5pBjL");

var $2bxGO = parcelRequire("2bxGO");

var $kvlmJ = parcelRequire("kvlmJ");

var $9Xm1T = parcelRequire("9Xm1T");

var $aAJVV = parcelRequire("aAJVV");
const $5d4850705ddb079b$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $9Xm1T.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $9Xm1T.useAnnotationRangeState)();
    const actions = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $kvlmJ.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $fc4bM.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $5pBjL.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $fc4bM.useCallback)((annotationId)=>{
        // Use documentPosition directly when gate is on — selectionDraftDocumentPosition may be stale
        // (from a previous selection) causing the comment to anchor to the wrong text (COMMENTS-6594).
        const positionToAnnotate = (0, $aEmSo.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        }).fire((0, $38vAg.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        selectionDraftDocumentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $fc4bM.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $fc4bM.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $3LeME.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            }).fire((0, $38vAg.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one (COMMENTS-6594).
        if ((0, $aEmSo.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearSelectionDraft();
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $3LeME.ACTION).OPENED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $38vAg.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $aAJVV.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Use documentPosition directly when either:
        // - platform_editor_comments_api_manager is on (existing behaviour), OR
        // - COMMENTS-6594 experiment is on (fix: avoids stale closure value)
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        const positionToAnnotate = (0, $dRkX9.fg)('platform_editor_comments_api_manager') || (0, $aEmSo.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $3LeME.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            }).fire((0, $38vAg.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        clearSelectionDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $fc4bM.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $fc4bM.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $3LeME.ACTION).CLOSED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $38vAg.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, $eUgRu.default)();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $6DAwh.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $fc4bM.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});




parcelRegister("4h8CP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a375a4dbe25e1a8b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jiju3 = parcelRequire("jiju3");

var $iVHNS = parcelRequire("iVHNS");

var $75FAm = parcelRequire("75FAm");

var $8oPL3 = parcelRequire("8oPL3");
function $a375a4dbe25e1a8b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a375a4dbe25e1a8b$var$inlineExtensionStyle = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $a375a4dbe25e1a8b$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $a375a4dbe25e1a8b$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, getContent: getContent, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>(0, $jiju3.default)((0, $iVHNS.getNodeRenderer)), []);
    /**
   * null -> provider promise not yet settled (pending)
   * undefined -> provider promise rejected (settled, no provider available)
   * <provider> -> provider promise resolved
   */ const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(null);
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((_name, providerPromise)=>{
        providerPromise === null || providerPromise === void 0 || providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        }, ()=>{
            // Consumers can use this to distinguish a rejected provider from a pending one
            if (isMounted.current) setExtensionProvider(undefined);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((extensionProvider, isExtensionProviderPending)=>{
        var _marks$find, _node$parameters;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        // Extension handlers read the macro body off `node.content`, so this is the one place that
        // always has to serialize. `getContent` is what makes it a single pass instead of one per
        // ancestor node.
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: (getContent === null || getContent === void 0 ? void 0 : getContent()) || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.macroParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $8oPL3.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $jctmk.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $jctmk.jsx)($a375a4dbe25e1a8b$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $jctmk.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $jctmk.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            isExtensionProviderPending: isExtensionProviderPending,
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        getContent,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext === null || rendererContext === void 0 ? void 0 : rendererContext.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((providers)=>{
        if (extensionProvider === null && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider, Boolean(providers.extensionProvider) && extensionProvider === null);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $75FAm.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $a375a4dbe25e1a8b$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $a375a4dbe25e1a8b$var$inlineExtensionStyle,
            isPlainTextMacro && $a375a4dbe25e1a8b$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("iVHNS", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNode", () => $e24002fc3fcb3859$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $e24002fc3fcb3859$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $e24002fc3fcb3859$export$67a7d49db68d30a0);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $fCOgx = parcelRequire("fCOgx");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
var $euVUr = parcelRequire("euVUr");

var $bcN2K = parcelRequire("bcN2K");

var $1fO1j = parcelRequire("1fO1j");

var $1OjU8 = parcelRequire("1OjU8");

var $NrIGY = parcelRequire("NrIGY");

var $lLMCv = parcelRequire("lLMCv");

function $e24002fc3fcb3859$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $e24002fc3fcb3859$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $1fO1j.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $e24002fc3fcb3859$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $e24002fc3fcb3859$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    var _extensionProvider$ge;
    const [extKey, nodeKey] = (0, $1fO1j.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider === null || extensionProvider === void 0 || (_extensionProvider$ge = extensionProvider.getPreloadedExtension) === null || _extensionProvider$ge === void 0 ? void 0 : _extensionProvider$ge.call(extensionProvider, extensionType, extKey);
    if (manifest) return $e24002fc3fcb3859$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$e24002fc3fcb3859$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $e24002fc3fcb3859$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $e24002fc3fcb3859$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $e24002fc3fcb3859$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    var _extensionNode$parame;
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!((_extensionNode$parame = extensionNode.parameters) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.macroParams) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.__bodyContent) !== null && _extensionNode$parame !== void 0 && _extensionNode$parame.value);
}
// eslint-disable-next-line @repo/internal/react/no-class-components -- error boundaries require a class component
class $e24002fc3fcb3859$var$ExtensionRendererErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', error);
    }
    render() {
        return this.state.error ? $e24002fc3fcb3859$var$renderExtensionLoadingError(this.state.error, this.props.fallbackProps) : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {};
    }
}
const $e24002fc3fcb3859$var$noop = ()=>{};
function $e24002fc3fcb3859$var$renderExtensionLoadingError(error, props) {
    // Needed because the old react-loadable (older code-splitting library) error handling behaviour might be relied on by extensions.
    // https://unpkg.com/react-loadable@5.2.2/lib/index.js
    return /*#__PURE__*/ (0, $3LM7S.jsx)($e24002fc3fcb3859$var$ExtensionLoading, {
        isLoading: false,
        pastDelay: true,
        timedOut: false,
        error: error,
        retry: $e24002fc3fcb3859$var$noop,
        ...props
    });
}
function $e24002fc3fcb3859$var$ExtensionLoading(props) {
    const intl = (0, $gpjDl.default)();
    const extensionNode = props.node;
    if (!props.error && !props.timedOut && props.loadingFallback) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: props.loadingFallback
    });
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $e24002fc3fcb3859$var$isUnknownConfluenceMacroWithBody(extensionNode)) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lLMCv.UnknownMacroPlaceholder), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            children: intl.formatMessage((0, $1OjU8.messages).extensionLoadingError)
        });
    } else return null;
}
function $e24002fc3fcb3859$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    // Async is needed to wrap the getExtensionModuleNodeMaybePreloaded call in a promise so that we can use the lazy() API
    const loadNodeRenderer = async ()=>{
        var _renderSync, _ref;
        const maybePromise = $e24002fc3fcb3859$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
        if (maybePromise instanceof Promise) return (0, $1fO1j.resolveImport)((await maybePromise).render());
        const preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync = (_ref = maybePromise).renderSync) === null || _renderSync === void 0 ? void 0 : _renderSync.call(_ref);
        // Only product implemented preloading will return sync result
        // However the out-of-box won't handle this. Confluence uses a custom implementation
        return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $NrIGY.resolveImportSync)(preloaded) : (0, $1fO1j.resolveImport)((await maybePromise).render());
    };
    const LazyNodeRenderer = (0, $dohmo.lazy)(()=>loadNodeRenderer(), {});
    LazyNodeRenderer.displayName = 'lazy(NodeRenderer)';
    const loadNodeRendererNoWrappedPromise = ()=>{
        var _renderSync2, _ref2;
        const maybePromise = $e24002fc3fcb3859$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
        if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $1fO1j.resolveImport)(node.render()));
        const preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync2 = (_ref2 = maybePromise).renderSync) === null || _renderSync2 === void 0 ? void 0 : _renderSync2.call(_ref2);
        // Only product implemented preloading will return sync result
        // However the out-of-box won't handle this. Confluence uses a custom implementation
        return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $NrIGY.resolveImportSync)(preloaded) : (0, $1fO1j.resolveImport)(maybePromise.render());
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
        loader: loadNodeRendererNoWrappedPromise,
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $e24002fc3fcb3859$var$ExtensionLoading
    });
    // We have to make sure the Loadable is assigned the name "getNodeRenderer" by Babel.
    // This loadable name is used by Babel to inject _maybeSyncLoader: true.
    // confluence/next/tools/config/loadableBabelPluginOptions.config.js (see HOT-307098)
    const LoadableNodeRenderer = getNodeRenderer;
    const NodeRenderer = (props)=>{
        if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration')) // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $3LM7S.jsx)(LoadableNodeRenderer, {
            ...props
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)($e24002fc3fcb3859$var$ExtensionRendererErrorBoundary, {
            fallbackProps: props,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $euVUr.LazySuspense), {
                fallback: props.loadingFallback ?? null,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)(LazyNodeRenderer, {
                    ...props
                })
            })
        });
    };
    NodeRenderer.preload = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? LazyNodeRenderer.preload() : LoadableNodeRenderer.preload();
    return NodeRenderer;
}

});
parcelRegister("1fO1j", function(module, exports) {
$parcel$export(module.exports, "FORGE_EXTENSION_TYPE", () => $4f64c586d5dcdd59$export$a7d04c836550045a);
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_TYPE", () => $4f64c586d5dcdd59$export$862c0e8acc7585d7);
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_KEY", () => $4f64c586d5dcdd59$export$b343a94058bea058);
$parcel$export(module.exports, "AGENT_MANAGED_EXTENSION_KEY", () => $4f64c586d5dcdd59$export$e400f4d17a615c24);
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $4f64c586d5dcdd59$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $4f64c586d5dcdd59$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $4f64c586d5dcdd59$export$d69c9b451c47653b);

var $2R1Se = parcelRequire("2R1Se");

var $NrIGY = parcelRequire("NrIGY");
const $4f64c586d5dcdd59$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $4f64c586d5dcdd59$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $4f64c586d5dcdd59$export$b343a94058bea058 = 'native-embed';
const $4f64c586d5dcdd59$export$e400f4d17a615c24 = 'agent-managed-block';
const $4f64c586d5dcdd59$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $4f64c586d5dcdd59$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
function $4f64c586d5dcdd59$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $4f64c586d5dcdd59$export$33863d887d6f4bfd(action, manifest);
}
const $4f64c586d5dcdd59$export$d69c9b451c47653b = async (importPromise)=>{
    return (0, $NrIGY.resolveImportSync)(await importPromise);
};
function $4f64c586d5dcdd59$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = (0, $2R1Se.buildExtensionKeyAndNodeKey)(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});
parcelRegister("2R1Se", function(module, exports) {
$parcel$export(module.exports, "buildExtensionKeyAndNodeKey", () => $c7560808bed04c12$export$5f3eb042babacbbd);
const $c7560808bed04c12$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};

});

parcelRegister("NrIGY", function(module, exports) {
$parcel$export(module.exports, "resolveImportSync", () => $83ef51efc2b31e10$export$dca2026e63034304);
const $83ef51efc2b31e10$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};

});


parcelRegister("1OjU8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ad69a6906cd8863d$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");

const $ad69a6906cd8863d$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'The text is shown as a button label in the extension context menu. Triggers opening the properties editor for the selected extension to modify its configuration.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'Label for a checkbox in a confirm modal that allows the user to also delete connected elements when deleting an extension.'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Informational message displayed in the extension configuration panel to reassure users that their changes are being saved automatically without requiring manual save action.'
    },
    panelLoadingError: {
        id: 'fabric.editor.extensions.config-panel.loading-error.non-final',
        defaultMessage: 'We ran into a bit of trouble. Refresh to try again.',
        description: 'Error message displayed when the extension configuration panel fails to load. Instructs users to refresh the page to attempt loading the panel again.'
    },
    extensionLoadingError: {
        id: 'fabric.editor.extension.loading-error',
        defaultMessage: 'Error loading the extension!',
        description: 'Error message displayed when an extension fails to load in the editor. Indicates a problem occurred during the extension initialization or rendering process.'
    },
    unknownMacroPlaceholderAriaLabel: {
        id: 'fabric.editor.extension.unknownMacroPlaceholderAriaLabel',
        defaultMessage: 'Unknown macro placeholder',
        description: 'Accessible label for the unknown macro fallback block shown when a Confluence macro cannot be resolved.'
    },
    unknownMacroHeader: {
        id: 'fabric.editor.extension.unknownMacroHeader',
        defaultMessage: "Unknown macro: ''{macroTitle}''",
        description: 'Header text for an unresolved Confluence macro placeholder.'
    }
});

});

parcelRegister("lLMCv", function(module, exports) {
$parcel$export(module.exports, "UnknownMacroPlaceholder", () => $59119dc7553a4499$export$414b5225f50e455b);
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $bcN2K = parcelRequire("bcN2K");

var $1OjU8 = parcelRequire("1OjU8");
// Unknown macro placeholder styling aligned with Legacy Content Macro (LCM) for consistent look
const $59119dc7553a4499$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $59119dc7553a4499$var$unknownMacroContainerStyles = null;
// Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $59119dc7553a4499$var$unknownMacroHeaderStyles = null;
// Match LCM content area: white surface, text color inherits
const $59119dc7553a4499$var$unknownMacroBodyStyles = null;
const $59119dc7553a4499$var$unknownMacroPreStyles = null;
const $59119dc7553a4499$var$formatParam = (key, param)=>{
    const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
    return `${key} = ${value}`;
};
const $59119dc7553a4499$var$EMPTY_MACRO_PARAMS = {};
function $59119dc7553a4499$export$414b5225f50e455b({ extensionNode: extensionNode }) {
    var _extensionNode$parame, _extensionNode$parame2, _extensionNode$parame3, _extensionNode$parame4;
    const intl = (0, $gpjDl.default)();
    const macroTitle = ((_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 || (_extensionNode$parame = _extensionNode$parame.macroMetadata) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.title) || extensionNode.extensionKey;
    const bodyContent = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.macroParams) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.__bodyContent) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.value;
    const macroParamsOld = ((_extensionNode$parame3 = extensionNode.parameters) === null || _extensionNode$parame3 === void 0 ? void 0 : _extensionNode$parame3.macroParams) ?? {};
    const macroParams = ((_extensionNode$parame4 = extensionNode.parameters) === null || _extensionNode$parame4 === void 0 ? void 0 : _extensionNode$parame4.macroParams) ?? $59119dc7553a4499$var$EMPTY_MACRO_PARAMS;
    const formatParamInline = (key, param)=>{
        const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
        return `${key} = ${value}`;
    };
    const memoizedVisibleParams = (0, $fc4bM.useMemo)(()=>Object.entries(macroParams).filter(([key])=>!key.startsWith('_')).map(([key, param])=>$59119dc7553a4499$var$formatParam(key, param)).join(' | '), [
        macroParams
    ]);
    const visibleParams = (0, $bcN2K.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedVisibleParams : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    Object.entries(macroParamsOld).filter(([key])=>!key.startsWith('_')).map(([key, param])=>formatParamInline(key, param)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $1OjU8.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $1OjU8.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("section", {
        "aria-label": intl.formatMessage((0, $1OjU8.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $2R2iS.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ]),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)("pre", {
                    className: (0, $2R2iS.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
                    ]),
                    children: bodyContent
                })
            })
        ]
    });
}

});


parcelRegister("75FAm", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $7af2ef1a061899e6$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $fc4bM = parcelRequire("fc4bM");
class $7af2ef1a061899e6$export$d498ee8be33e096f extends (0, $fc4bM.PureComponent) {
    static #_ = this.displayName = 'WithProviders';
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("8oPL3", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $23a17d34c1a8eae9$export$9214452ef07eda7);
function $23a17d34c1a8eae9$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("5XiSC", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $7aaa038806834356$export$e926676385687eaf);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $38vAg = parcelRequire("38vAg");

var $3LeME = parcelRequire("3LeME");

var $kFIjS = parcelRequire("kFIjS");

var $a63R3 = parcelRequire("a63R3");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7aaa038806834356$var$FAILED_TO_EXECUTE_REGEX = /Failed to execute.*on 'Node'.*/;
class $7aaa038806834356$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $38vAg.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $3LeME.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $a63R3.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`,
                componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $kFIjS.logException)(error, {
            location: 'renderer'
        });
        const matchesPattern = $7aaa038806834356$var$FAILED_TO_EXECUTE_REGEX.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $3LeME.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $a63R3.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
            children: this.props.children
        }, this.state.domErrorCount);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}

});
parcelRegister("kFIjS", function(module, exports) {
$parcel$export(module.exports, "logException", () => $8fb74d8bf3b97ad7$export$f86b2a1a2ce291b3);

var $3DbpT = parcelRequire("3DbpT");

var $hhBD3 = parcelRequire("hhBD3");

var $7BfnO = parcelRequire("7BfnO");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8fb74d8bf3b97ad7$var$NETWORK_ERROR_REGEX = /^network error/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8fb74d8bf3b97ad7$var$NETWORK_FAILURE_REGEX = /^network failure/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8fb74d8bf3b97ad7$var$RESIZE_OBSERVER_LOOP_REGEX = /ResizeObserver loop completed with undelivered notifications/;
const $8fb74d8bf3b97ad7$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8fb74d8bf3b97ad7$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8fb74d8bf3b97ad7$var$packageVersion = undefined;
const $8fb74d8bf3b97ad7$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8fb74d8bf3b97ad7$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("3DbpT")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("3cHjb"));
        const breadcrumbsIntegration = new (0, $3DbpT.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $7BfnO.SERIALIZABLE_ATTRIBUTES)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        });
        const sentryOptions = {
            dsn: (0, $hhBD3.isFedRamp)() ? undefined : $8fb74d8bf3b97ad7$var$SENTRY_DSN,
            release: `${$8fb74d8bf3b97ad7$var$packageName}@${$8fb74d8bf3b97ad7$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            beforeBreadcrumb: (0, $7BfnO.normaliseSentryBreadcrumbs),
            ignoreErrors: [
                // Network issues
                $8fb74d8bf3b97ad7$var$NETWORK_ERROR_REGEX,
                $8fb74d8bf3b97ad7$var$NETWORK_FAILURE_REGEX,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                $8fb74d8bf3b97ad7$var$RESIZE_OBSERVER_LOOP_REGEX
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    breadcrumbsIntegration,
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8fb74d8bf3b97ad7$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            var _buildInfo;
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("hhBD3", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $a1dc7d6252fb9cfb$export$64d6499adf9b2e51);
const $a1dc7d6252fb9cfb$var$FEDRAMP_MODERATE = 'fedramp-moderate';
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $a1dc7d6252fb9cfb$var$FEDRAMP_HOSTNAME_REGEX = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
function $a1dc7d6252fb9cfb$export$64d6499adf9b2e51() {
    var _global$location;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $a1dc7d6252fb9cfb$var$FEDRAMP_MODERATE;
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match($a1dc7d6252fb9cfb$var$FEDRAMP_HOSTNAME_REGEX);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("7BfnO", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $b66309e98c9037ee$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $b66309e98c9037ee$export$6f14342128c6eaa4);
const $b66309e98c9037ee$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $b66309e98c9037ee$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$b66309e98c9037ee$export$b5bdb04ea16a02e3
];
const $b66309e98c9037ee$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$b66309e98c9037ee$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $b66309e98c9037ee$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($b66309e98c9037ee$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $b66309e98c9037ee$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category !== null && category !== void 0 && category.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $b66309e98c9037ee$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("3cHjb", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jFQhj").then(()=>parcelRequire('gJ3ID'));

});


parcelRegister("a63R3", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $6dcbe60968362530$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $6dcbe60968362530$export$e48589d9e4824227);
var $6dcbe60968362530$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $6dcbe60968362530$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $6dcbe60968362530$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($6dcbe60968362530$var$RESOLVE_METHOD || {});

});


parcelRegister("gZRzj", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $fb31252a42e99188$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $fb31252a42e99188$export$5b655fe45447a548);

var $fc4bM = parcelRequire("fc4bM");
const $fb31252a42e99188$export$d452675449e81987 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $fb31252a42e99188$export$5b655fe45447a548 = $fb31252a42e99188$export$d452675449e81987.Provider;

});

parcelRegister("hJw7x", function(module, exports) {
$parcel$export(module.exports, "hasExtensionViewportSize", () => $918252da88197c35$export$6a74de9f5aa04140);
$parcel$export(module.exports, "renderExtension", () => $918252da88197c35$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $918252da88197c35$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $3LeME = parcelRequire("3LeME");

var $1r7H5 = parcelRequire("1r7H5");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aGINe = parcelRequire("aGINe");

var $lk7ff = parcelRequire("lk7ff");

var $85PxU = parcelRequire("85PxU");

var $9Xm1T = parcelRequire("9Xm1T");

var $4h8CP = parcelRequire("4h8CP");

var $lHYTa = parcelRequire("lHYTa");

var $cIDeA = parcelRequire("cIDeA");

var $h4qU2 = parcelRequire("h4qU2");
function $918252da88197c35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $918252da88197c35$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
/**
 * Mirrors `FORGE_INLINE_BODIED_PARAM` in `@atlassian/xen-editor-provider`. Duplicated rather than
 * imported: the renderer must not depend on a Forge package, and this is a stored parameter name,
 * so it is part of the document contract rather than that package's API.
 */ const $918252da88197c35$var$FORGE_INLINE_BODIED_PARAM = 'atlassianForgeInlineBodied';
const $918252da88197c35$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $918252da88197c35$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $918252da88197c35$export$6a74de9f5aa04140 = (extensionId, extensionViewportSizes)=>Boolean(extensionId && (extensionViewportSizes === null || extensionViewportSizes === void 0 ? void 0 : extensionViewportSizes.some((extension)=>extension.extensionId === extensionId && Boolean(extension.viewportSize))));
const $918252da88197c35$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $918252da88197c35$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $918252da88197c35$var$macroHeights[viewportSize];
    }
};
const $918252da88197c35$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
/**
 * Fires an analytics event once on mount when a bodied extension is rendered as an inline element.
 * The node is stored in a ref to avoid re-firing if the node reference changes.
 */ const $918252da88197c35$var$FireExtensionAsInlineAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, node: node })=>{
    const nodeRef = (0, $fc4bM.useRef)(node);
    (0, $fc4bM.useEffect)(()=>{
        fireAnalyticsEvent({
            action: (0, $3LeME.ACTION).RENDERED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION_AS_INLINE,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            attributes: {
                extensionKey: nodeRef.current.extensionKey,
                extensionType: nodeRef.current.extensionType
            },
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
        });
    }, [
        fireAnalyticsEvent
    ]);
    return null;
};
const $918252da88197c35$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodePresetMinHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    var _node$parameters, _node$parameters2, _options$dataAttribut;
    const overflowContainerClass = !removeOverflow ? (0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance, fireAnalyticsEvent: fireAnalyticsEvent } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $aGINe.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $918252da88197c35$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodePresetMinHeight || viewportSize;
    // Forge manifest heights already include px; Connect node heights are numeric strings.
    const extensionMinHeight = extensionHeight !== null && extensionHeight !== void 0 && extensionHeight.endsWith('px') && (0, $dRkX9.fg)('confluence_forge_early_render_reserve_height') ? extensionHeight : extensionHeight && `${extensionHeight}px`;
    /**
   * Scoped to nodes inserted by an app declaring `layout: inline-bodied`, which is what writes
   * `atlassianForgeInlineBodied`. The output-type marker alone would also match migrated Connect
   * content — it carries the same marker, and after an upgrade plus a storage round trip in the
   * same shape — so keying on it would change how existing content renders. The renderer only
   * ever sees the stored node, never the manifest, so a parameter this code writes is the only
   * available signal.
   */ const hasForgeInlineBodiedMarker = Boolean((node === null || node === void 0 ? void 0 : node.extensionType) === $918252da88197c35$var$FORGE_EXTENSION_TYPE && (node === null || node === void 0 ? void 0 : node.content) && (node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.guestParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters[$918252da88197c35$var$FORGE_INLINE_BODIED_PARAM]) === 'true');
    const isInlineBodiedLayoutEnabled = (node === null || node === void 0 ? void 0 : node.extensionType) === $918252da88197c35$var$FORGE_EXTENSION_TYPE && (node === null || node === void 0 ? void 0 : node.type) === 'bodiedExtension' && (node === null || node === void 0 || (_node$parameters2 = node.parameters) === null || _node$parameters2 === void 0 ? void 0 : _node$parameters2.layout) === 'inline-bodied';
    /**
   * The pass that marks the sibling textblocks around an inline extension resolves their
   * positions without a depth term, so it only ever matches at the top level. Inlining a nested
   * container without joining its neighbours leaves a shrink-wrapped box alone on its own line,
   * which is worse than leaving it a block — so keep nested inline-bodied Forge macros as
   * blocks until the sibling marking works at depth.
   */ const isNestedForgeInlineBodied = !isTopLevel && (hasForgeInlineBodiedMarker || isInlineBodiedLayoutEnabled);
    const isInline = (shouldDisplayExtensionAsInline === null || shouldDisplayExtensionAsInline === void 0 ? void 0 : shouldDisplayExtensionAsInline(node)) && !isNestedForgeInlineBodied;
    const inlineClassName = isInline ? (0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE : '';
    /**
   * A native Forge macro does not have its body rendered by the product — the body ADF is
   * sent to the app over the bridge and the app renders it with its own nested renderer.
   * The inline styling above stops at the outer wrapper, so mark these nodes to let the
   * nested document's block spacing be collapsed too.
   */ const isNativeForgeInline = Boolean(isInline && hasForgeInlineBodiedMarker);
    /**
   * Migrated inline-bodied macros intentionally do not receive the native Forge marker. Mark the
   * rendered wrapper instead so the stylesheet can fix only the surrounding text flow without
   * applying the native nested-renderer, overflow or sizing rules to migrated content.
   * Custom UI also uses this outer text-flow treatment, without styling inside its iframe.
   */ const isMigratedInlineBodied = Boolean(isInline && (node === null || node === void 0 ? void 0 : node.content) && !hasForgeInlineBodiedMarker);
    const asInlineAnalytics = isInline && fireAnalyticsEvent && node ? /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$FireExtensionAsInlineAnalytics, {
        fireAnalyticsEvent: fireAnalyticsEvent,
        node: node
    }) : null;
    const extensionDiv = /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: options.handleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $aGINe.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Runtime preset height is omitted from the legacy style object.
            ...!isInline && options.height !== undefined ? {
                height: options.height
            } : {},
            width: isInline ? undefined : ((0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lHYTa.calcBreakoutWidthCss)(layout) : (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? undefined : '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            minHeight: isInline ? undefined : extensionMinHeight
        },
        "data-layout": layout,
        "data-local-id": localId,
        "data-renderer-start-pos": (_options$dataAttribut = options.dataAttributes) === null || _options$dataAttribut === void 0 ? void 0 : _options$dataAttribut['data-renderer-start-pos'],
        "data-testid": "extension--wrapper",
        "data-node-type": "extension",
        "data-inline-comments-target": options.isCommentTarget || undefined,
        "data-top-level": isTopLevel || undefined,
        "data-forge-inline": isNativeForgeInline || undefined,
        "data-migrated-inline": isMigratedInlineBodied || undefined,
        onBlur: options.onBlur,
        onFocus: options.onFocus,
        onMouseEnter: options.onMouseEnter,
        onMouseLeave: options.onMouseLeave
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        tabIndex: options.tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $aGINe.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
        css: [
            !isInsideOfInlineExtension && $918252da88197c35$var$containerStyle
        ]
    }, asInlineAnalytics, content));
    return centerAlignClass ? /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $aGINe.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $aGINe.RendererCssClassName).FLEX_CENTER_WRAPPER
    }, extensionDiv) : extensionDiv;
};
const $918252da88197c35$var$ExtensionWithAnnotations = (props)=>{
    var _providers$inlineComm, _providers$inlineComm2, _props$dataAttributes;
    const providers = (0, $fc4bM.useContext)((0, $lk7ff.ProvidersContext));
    const { setHoverTarget: setHoverTarget } = (0, $9Xm1T.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $85PxU.useAnnotationHoverDispatch)();
    const isBlockNodeSupported = providers === null || providers === void 0 || (_providers$inlineComm = providers.inlineComment) === null || _providers$inlineComm === void 0 ? void 0 : _providers$inlineComm.isBlockNodeSupported;
    const supportsComments = (0, $fc4bM.useMemo)(()=>Boolean(props.extensionNode && (isBlockNodeSupported === null || isBlockNodeSupported === void 0 ? void 0 : isBlockNodeSupported(props.extensionNode)) === true), [
        props.extensionNode,
        isBlockNodeSupported
    ]);
    const canCreateCommentOnBlockNode = providers === null || providers === void 0 || (_providers$inlineComm2 = providers.inlineComment) === null || _providers$inlineComm2 === void 0 ? void 0 : _providers$inlineComm2.canCreateCommentOnBlockNode;
    const isFullPageRenderer = props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width';
    // The creation policy may fire an experiment exposure. In the full-page renderer it is only
    // checked once the user hovers or focuses the extension, where the comment target appears.
    // Other renderers have no hover entry point, so they keep checking during render. Saved
    // threads stay viewable through `supportsComments`.
    // Only an allowed result is stored. A rejection is not cached because it can be temporary (for
    // example before Statsig initializes), so the check runs again on the next hover or focus.
    const [allowedCommentNode, setAllowedCommentNode] = (0, $fc4bM.useState)();
    const canCreateDuringRender = (0, $fc4bM.useMemo)(()=>!isFullPageRenderer && Boolean(supportsComments && props.extensionNode && (canCreateCommentOnBlockNode === null || canCreateCommentOnBlockNode === void 0 ? void 0 : canCreateCommentOnBlockNode(props.extensionNode))), [
        isFullPageRenderer,
        supportsComments,
        props.extensionNode,
        canCreateCommentOnBlockNode
    ]);
    const isCommentTarget = Boolean(supportsComments && props.extensionNode && (!canCreateCommentOnBlockNode || canCreateDuringRender || allowedCommentNode === props.extensionNode));
    const isCommentTargetRef = (0, $fc4bM.useRef)(isCommentTarget);
    isCommentTargetRef.current = isCommentTarget;
    const resolveCommentTarget = (0, $fc4bM.useCallback)((target)=>{
        if (isCommentTargetRef.current) return true;
        const node = props.extensionNode;
        if (!supportsComments || !node || !canCreateCommentOnBlockNode || !canCreateCommentOnBlockNode(node)) return false;
        // The hover target is matched against this attribute before React re-renders, so set it
        // now; the batched render below writes the same value.
        target.dataset.inlineCommentsTarget = 'true';
        isCommentTargetRef.current = true;
        setAllowedCommentNode(node);
        return true;
    }, [
        supportsComments,
        props.extensionNode,
        canCreateCommentOnBlockNode
    ]);
    const onMouseEnter = (0, $fc4bM.useCallback)((event)=>{
        if (!resolveCommentTarget(event.currentTarget)) return;
        cancelTimeout();
        if (event.buttons === 0) {
            setHoverTarget === null || setHoverTarget === void 0 || setHoverTarget(event.currentTarget);
            setIsWithinRange(true);
        }
    }, [
        cancelTimeout,
        resolveCommentTarget,
        setHoverTarget,
        setIsWithinRange
    ]);
    const onMouseLeave = (0, $fc4bM.useCallback)(()=>{
        if (isCommentTargetRef.current) initiateTimeout();
    }, [
        initiateTimeout
    ]);
    const onFocus = (0, $fc4bM.useCallback)((event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        if (!resolveCommentTarget(event.currentTarget)) return;
        cancelTimeout();
        setHoverTarget === null || setHoverTarget === void 0 || setHoverTarget(event.currentTarget);
        setIsWithinRange(true);
    }, [
        cancelTimeout,
        resolveCommentTarget,
        setHoverTarget,
        setIsWithinRange
    ]);
    const onBlur = (0, $fc4bM.useCallback)((event)=>{
        if (isCommentTargetRef.current && !event.currentTarget.contains(event.relatedTarget)) initiateTimeout();
    }, [
        initiateTimeout
    ]);
    // Listen whenever comments are supported, so the first hover or focus can check creation.
    const commentTargetOptions = supportsComments && isFullPageRenderer ? {
        isCommentTarget: isCommentTarget,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    } : {
        isCommentTarget: isCommentTarget
    };
    const commentProps = {
        enabled: supportsComments,
        allowAnnotations: props.allowAnnotations,
        allowAnnotationsDraftMode: props.allowAnnotationsDraftMode && isCommentTarget,
        startPos: (_props$dataAttributes = props.dataAttributes) === null || _props$dataAttributes === void 0 ? void 0 : _props$dataAttributes['data-renderer-start-pos'],
        marks: props.marks
    };
    return /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$ExtensionContent, {
        ...props,
        commentProps: commentProps,
        commentTargetOptions: commentTargetOptions
    });
};
const $918252da88197c35$var$ExtensionContent = ({ commentProps: commentProps = {}, commentTargetOptions: commentTargetOptions, ...props })=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    const presetOptions = props.scheduleExtensionHeightRemoval ? {
        height: props.nodePresetHeight
    } : {};
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $4h8CP.default), {
        ...props,
        type: "extension"
    }, ({ isExtensionProviderPending: isExtensionProviderPending, result: result })=>{
        var _props$hideExtensionK;
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(result)) return $918252da88197c35$export$b7482bdc8aff85e4(/*#__PURE__*/ (0, $jctmk.jsx)((0, $cIDeA.ExtensionComments), {
                enabled: commentProps.enabled,
                allowAnnotations: commentProps.allowAnnotations,
                allowAnnotationsDraftMode: commentProps.allowAnnotationsDraftMode,
                startPos: commentProps.startPos,
                marks: commentProps.marks
            }, result), layout, {
                ...presetOptions,
                dataAttributes: props.dataAttributes,
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance,
                ...commentTargetOptions
            }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        if (isExtensionProviderPending && (_props$hideExtensionK = props.hideExtensionKeysWhilePending) !== null && _props$hideExtensionK !== void 0 && _props$hideExtensionK.includes(props.extensionKey)) return /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null);
        // Always return default content if anything goes wrong
        return $918252da88197c35$export$b7482bdc8aff85e4(/*#__PURE__*/ (0, $jctmk.jsx)((0, $cIDeA.ExtensionComments), {
            enabled: commentProps.enabled,
            allowAnnotations: commentProps.allowAnnotations,
            allowAnnotationsDraftMode: commentProps.allowAnnotationsDraftMode,
            startPos: commentProps.startPos,
            marks: commentProps.marks
        }, text || 'extension'), layout, {
            ...presetOptions,
            dataAttributes: props.dataAttributes,
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance,
            ...commentTargetOptions
        }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $918252da88197c35$var$ExtensionView = (props)=>{
    // Keep annotation context subscriptions out of the gate-off render path.
    if ((0, $dRkX9.fg)('cc_maui_annotations_on_extensions')) // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$ExtensionWithAnnotations, props);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$ExtensionContent, props);
};
const $918252da88197c35$var$ExtensionWithTemporarySizing = (props)=>{
    var _props$parameters;
    const { presetMinHeight: presetMinHeight, presetHeight: presetHeight, hasExpired: hasExpired } = (0, $h4qU2.useNodeHeight)({
        nodePresetMinHeight: props.nodePresetMinHeight,
        node: props.extensionNode,
        scheduleRemoval: props.scheduleExtensionHeightRemoval,
        nodePresetHeight: props.nodePresetHeight,
        hasViewportSize: $918252da88197c35$export$6a74de9f5aa04140((_props$parameters = props.parameters) === null || _props$parameters === void 0 ? void 0 : _props$parameters.extensionId, props.extensionViewportSizes)
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$ExtensionView, {
        ...props,
        nodeHeight: presetMinHeight,
        nodePresetHeight: presetHeight,
        extensionViewportSizes: hasExpired || presetHeight !== undefined ? undefined : props.extensionViewportSizes
    });
};
const $918252da88197c35$var$Extension = (props)=>{
    if (props.scheduleExtensionHeightRemoval) // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$ExtensionWithTemporarySizing, props);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($918252da88197c35$var$ExtensionView, props);
};
const $918252da88197c35$var$_default_1 = (0, $1r7H5.default)($918252da88197c35$var$Extension, {
    overflowSelector: `.${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $918252da88197c35$export$2e2bcd8739ae039 = $918252da88197c35$var$_default_1;

});
parcelRegister("1r7H5", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $17a129323ba295b4$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $17a129323ba295b4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4gwsO = parcelRequire("4gwsO");

var $9QPfA = parcelRequire("9QPfA");
const $17a129323ba295b4$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $17a129323ba295b4$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
        get isDisabled() {
            if (this.disabled === undefined) {
                var _options$isDisabled;
                this.disabled = ((_options$isDisabled = options.isDisabled) === null || _options$isDisabled === void 0 ? void 0 : _options$isDisabled.call(options)) ?? false;
            }
            return this.disabled;
        }
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $4gwsO.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            var _this$props, _this$props2;
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = this.isDisabled ? '' : [
                !((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableTableOverflowShadow) && showRightShadow && $17a129323ba295b4$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.disableTableOverflowShadow) && showLeftShadow && $17a129323ba295b4$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $9QPfA.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (this.isDisabled || options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($17a129323ba295b4$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (this.isDisabled) return;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $17a129323ba295b4$var$isElementNode(node) {
    return node.nodeType === 1;
}

});
parcelRegister("4gwsO", function(module, exports) {
$parcel$export(module.exports, "ShadowObserver", () => $c694ab6fbc094593$export$51a5b28e4fb2dba2);

var $jYxak = parcelRequire("jYxak");

var $9QPfA = parcelRequire("9QPfA");
const $c694ab6fbc094593$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $c694ab6fbc094593$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $c694ab6fbc094593$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            [(0, $jYxak.ShadowKeys).SHOW_LEFT_SHADOW]: false,
            [(0, $jYxak.ShadowKeys).SHOW_RIGHT_SHADOW]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add((0, $9QPfA.shadowObserverClassNames).SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add((0, $9QPfA.shadowObserverClassNames).SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $c694ab6fbc094593$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains((0, $9QPfA.shadowObserverClassNames).SENTINEL_LEFT)) this.shadowStates[(0, $jYxak.ShadowKeys).SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains((0, $9QPfA.shadowObserverClassNames).SENTINEL_RIGHT)) this.shadowStates[(0, $jYxak.ShadowKeys).SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        var _this$sentinels$left, _this$sentinels$right;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $c694ab6fbc094593$var$cancelIdleCallback(this.requestCallbackId);
        }
        (_this$sentinels$left = this.sentinels.left) === null || _this$sentinels$left === void 0 || _this$sentinels$left.remove();
        (_this$sentinels$right = this.sentinels.right) === null || _this$sentinels$right === void 0 || _this$sentinels$right.remove();
        this.sentinels = {};
    }
}

});
parcelRegister("jYxak", function(module, exports) {
$parcel$export(module.exports, "ShadowKeys", () => $7fa91b821efd7e40$export$ebeea2fe2e93862e);
var $7fa91b821efd7e40$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});

});

parcelRegister("9QPfA", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $01dedb2b09b72190$export$1cbe0bb16052178d);
const $01dedb2b09b72190$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};

});



parcelRegister("aGINe", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $f61b5e5ba7130598$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $f61b5e5ba7130598$var$clPrefix = 'ak-renderer-';
const $f61b5e5ba7130598$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$f61b5e5ba7130598$var$clPrefix}document`,
    EXTENSION: `${$f61b5e5ba7130598$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$f61b5e5ba7130598$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$f61b5e5ba7130598$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$f61b5e5ba7130598$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$f61b5e5ba7130598$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$f61b5e5ba7130598$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$f61b5e5ba7130598$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$f61b5e5ba7130598$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$f61b5e5ba7130598$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});

parcelRegister("lHYTa", function(module, exports) {
$parcel$export(module.exports, "calcBreakoutWidthCss", () => $d28ee1ceb7a9f007$export$87eeb477611c8fe);
const $d28ee1ceb7a9f007$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};

});

parcelRegister("cIDeA", function(module, exports) {
$parcel$export(module.exports, "ExtensionComments", () => $8908cffd398dca06$export$933bbfa6d43bf61d);
/* extension-comments.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $7tbCp = parcelRequire("7tbCp");

var $hN6uZ = parcelRequire("hN6uZ");

var $aoZ67 = parcelRequire("aoZ67");

var $kvlmJ = parcelRequire("kvlmJ");

var $9Xm1T = parcelRequire("9Xm1T");

var $994OL = parcelRequire("994OL");

var $dCLw2 = parcelRequire("dCLw2");

var $dYypm = parcelRequire("dYypm");
const $8908cffd398dca06$var$containerStyles = null;
const $8908cffd398dca06$var$annotationParentIds = [];
const $8908cffd398dca06$var$annotationDataAttributes = {
    'data-renderer-mark': true,
    'data-block-mark': true
};
const $8908cffd398dca06$var$badgeStyles = null;
const $8908cffd398dca06$var$ExtensionCommentsEnabled = ({ marks: marks, children: children, enabled: enabled, allowAnnotations: allowAnnotations, allowAnnotationsDraftMode: allowAnnotationsDraftMode, startPos: startPos })=>{
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $9Xm1T.useAnnotationRangeState)();
    const isDraft = Boolean(enabled && allowAnnotationsDraftMode && hoverDraftDocumentPosition && hoverDraftDocumentPosition.from + 1 === startPos);
    const updateSubscriber = (0, $994OL.useInlineCommentSubscriberContext)();
    const annotationIds = (0, $fc4bM.useMemo)(()=>(marks === null || marks === void 0 ? void 0 : marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>mark.attrs.id)) ?? [], [
        marks
    ]);
    const activeIds = (0, $dCLw2.useInlineCommentsFilter)({
        annotationIds: annotationIds,
        filter: {
            state: (0, $6DAwh.AnnotationMarkStates).ACTIVE
        }
    });
    const [focusedId, setFocusedId] = (0, $fc4bM.useState)();
    const [entered, setEntered] = (0, $fc4bM.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $kvlmJ.useAnnotationManagerState)();
    const active = activeIds.some((id)=>id === focusedId || id === currentSelectedAnnotationId);
    (0, $fc4bM.useEffect)(()=>{
        if (!updateSubscriber) return;
        const onFocus = (payload)=>setFocusedId(payload === null || payload === void 0 ? void 0 : payload.annotationId);
        const onBlur = ()=>setFocusedId(undefined);
        updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onFocus);
        updateSubscriber.on((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onBlur);
        return ()=>{
            updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onFocus);
            updateSubscriber.off((0, $aoZ67.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onBlur);
        };
    }, [
        updateSubscriber
    ]);
    const onClick = (0, $fc4bM.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        // Anchor the thread to this chart, not an icon inside the badge or a nested renderer.
        const extension = event.currentTarget.closest('.ak-renderer-extension');
        if (extension && activeIds.length) updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.emit((0, $aoZ67.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeIds,
            eventTarget: extension,
            eventTargetType: 'extension',
            viewMethod: (0, $7tbCp.VIEW_METHOD).BADGE
        });
    }, [
        activeIds,
        updateSubscriber
    ]);
    const onMouseEnter = (0, $fc4bM.useCallback)(()=>setEntered(true), []);
    const onMouseLeave = (0, $fc4bM.useCallback)(()=>setEntered(false), []);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        "data-annotation-draft-mark": isDraft || undefined,
        "data-renderer-mark": isDraft || undefined,
        "data-renderer-start-pos": isDraft ? startPos : undefined,
        className: (0, $2R2iS.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            allowAnnotations && annotationIds.map((id)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dYypm.default), {
                    id: id,
                    annotationType: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT,
                    annotationParentIds: $8908cffd398dca06$var$annotationParentIds,
                    allowAnnotations: true,
                    useBlockLevel: true,
                    isExtension: true,
                    dataAttributes: $8908cffd398dca06$var$annotationDataAttributes
                }, id)),
            enabled && activeIds.length > 0 && updateSubscriber && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    "_kqswstnw _154iu2gc _1xi2u2gc"
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hN6uZ.CommentBadgeNext), {
                    status: active ? 'active' : entered ? 'entered' : 'default',
                    onClick: onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                })
            })
        ]
    });
};
const $8908cffd398dca06$export$933bbfa6d43bf61d = (props)=>{
    if (!props.enabled && !props.allowAnnotations) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($8908cffd398dca06$var$ExtensionCommentsEnabled, {
        enabled: props.enabled,
        allowAnnotations: props.allowAnnotations,
        allowAnnotationsDraftMode: props.allowAnnotationsDraftMode,
        startPos: props.startPos,
        marks: props.marks,
        children: props.children
    });
};

});
parcelRegister("7tbCp", function(module, exports) {
$parcel$export(module.exports, "RESOLVE_METHOD", () => $13bcdd437f95d4db$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $13bcdd437f95d4db$export$9cf3651d97128b9c);
var $13bcdd437f95d4db$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $13bcdd437f95d4db$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("hN6uZ", function(module, exports) {
$parcel$export(module.exports, "CommentBadgeNext", () => $270ea220acaa71d3$export$d5da84b0136a0cc4);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3UAb3 = parcelRequire("3UAb3");

var $bcN2K = parcelRequire("bcN2K");

var $l3fZT = parcelRequire("l3fZT");

var $kig2V = parcelRequire("kig2V");

var $bcTS3 = parcelRequire("bcTS3");

var $jTXrz = parcelRequire("jTXrz");
const $270ea220acaa71d3$var$baseStyles = (0, $kig2V.xcss)({
    borderRadius: 'radius.small'
});
const $270ea220acaa71d3$var$mediumBadgeStyles = (0, $kig2V.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $270ea220acaa71d3$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $gpjDl.default)();
    const title = intl.formatMessage((0, $jTXrz.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $fc4bM.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $l3fZT.Pressable), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $270ea220acaa71d3$var$baseStyles,
                $270ea220acaa71d3$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))), {
                label: title,
                spacing: "spacious",
                color: (0, $bcN2K.isExperimentEnabled)('cc_comments_media_viewer_sidebar') ? "var(--ds-icon-accent-yellow, #B38600)" : 'currentColor'
            })
        })
    });
};

});
parcelRegister("jTXrz", function(module, exports) {
$parcel$export(module.exports, "commentMessages", () => $7800c43c9898f0ff$export$4c0d145df60cfb04);

var $8p5Cv = parcelRequire("8p5Cv");
const $7800c43c9898f0ff$export$4c0d145df60cfb04 = (0, $8p5Cv.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'The text is shown on a button in the media floating toolbar that opens the comments panel, allowing the user to view existing comments and add new ones for the selected image or media item.'
    }
});

});


parcelRegister("994OL", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $071fc9b6e46dbd56$export$b46737175cffd396);

var $fc4bM = parcelRequire("fc4bM");

var $lk7ff = parcelRequire("lk7ff");
const $071fc9b6e46dbd56$export$b46737175cffd396 = ()=>{
    const providers = (0, $fc4bM.useContext)((0, $lk7ff.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});

parcelRegister("dCLw2", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $7c9372be546dc5f7$export$8e7d47f9e38ad4f1);

var $fc4bM = parcelRequire("fc4bM");

var $lk7ff = parcelRequire("lk7ff");
const $7c9372be546dc5f7$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $fc4bM.useContext)((0, $lk7ff.InlineCommentsStateContext));
    return (0, $fc4bM.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("dYypm", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $70e0cfe66db9d7d9$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $70e0cfe66db9d7d9$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $9A4S5 = parcelRequire("9A4S5");
const $70e0cfe66db9d7d9$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $70e0cfe66db9d7d9$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isExtension: isExtension, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $6DAwh.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9A4S5.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        isExtension: isExtension,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $70e0cfe66db9d7d9$export$2e2bcd8739ae039 = $70e0cfe66db9d7d9$var$AnnotationComponent;

});
parcelRegister("9A4S5", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $c248e12f5f26cd13$export$f3069f755c1eba0b);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $aoZ67 = parcelRequire("aoZ67");

var $lk7ff = parcelRequire("lk7ff");

var $kvlmJ = parcelRequire("kvlmJ");

var $gF12C = parcelRequire("gF12C");

var $994OL = parcelRequire("994OL");

var $dCLw2 = parcelRequire("dCLw2");

var $f0brR = parcelRequire("f0brR");
const $c248e12f5f26cd13$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel, isExtension: isExtension })=>{
    const updateSubscriber = (0, $994OL.useInlineCommentSubscriberContext)();
    const states = (0, $fc4bM.useContext)((0, $lk7ff.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $gF12C.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $fc4bM.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const onClick = (0, $fc4bM.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager === null || annotationManager === void 0 || annotationManager.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $aoZ67.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $dCLw2.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $6DAwh.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $f0brR.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        isExtension: isExtension,
        children: children
    });
};

});
parcelRegister("f0brR", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $d695ffc5d017ff81$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $gpjDl = parcelRequire("gpjDl");

var $6DAwh = parcelRequire("6DAwh");

var $dRkX9 = parcelRequire("dRkX9");

var $brSjT = parcelRequire("brSjT");

var $kvlmJ = parcelRequire("kvlmJ");

var $6SGXD = parcelRequire("6SGXD");
const $d695ffc5d017ff81$var$markStyles = /*#__PURE__*/ (0, $jctmk.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6DAwh.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $d695ffc5d017ff81$var$markStylesLayeringFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6DAwh.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $d695ffc5d017ff81$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6DAwh.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $d695ffc5d017ff81$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6DAwh.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $d695ffc5d017ff81$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6DAwh.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $d695ffc5d017ff81$var$MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const $d695ffc5d017ff81$var$isMobile = ()=>{
    return $d695ffc5d017ff81$var$MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};
const $d695ffc5d017ff81$var$accessibilityStylesNew = /*#__PURE__*/ (0, $jctmk.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $d695ffc5d017ff81$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel, isExtension: isExtension })=>{
    const intl = (0, $gpjDl.default)();
    const annotationIds = (0, $fc4bM.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $kvlmJ.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $fc4bM.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $fc4bM.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $6DAwh.AnnotationMarkStates).ACTIVE) return;
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        var _document$activeEleme;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- keyboard focus for mark / Enter handling
        const focusedElementTag = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $d695ffc5d017ff81$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $6DAwh.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    if (isExtension && (0, $dRkX9.fg)('cc_maui_annotations_on_extensions')) // The chart's badge owns interaction. Anchors only supply geometry and annotation state.
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $6SGXD.ExtensionAnnotation), {
        id: id,
        dataAttributes: overriddenData,
        markRef: id === currentSelectedAnnotationId ? markRef : undefined
    });
    return (0, $jctmk.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $d695ffc5d017ff81$var$markStyles,
                $d695ffc5d017ff81$var$markStylesLayeringFix,
                (0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') && $d695ffc5d017ff81$var$markStylesWithInlineComments,
                $d695ffc5d017ff81$var$markStylesWithCommentsPanel,
                !$d695ffc5d017ff81$var$isMobile() && $d695ffc5d017ff81$var$accessibilityStylesNew,
                $d695ffc5d017ff81$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $brSjT.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $brSjT.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            }
        }
    }, children);
};

});
parcelRegister("brSjT", function(module, exports) {
$parcel$export(module.exports, "collapsibleHeadingMessages", () => $3cab4bc5bfd0a6af$export$7f5b2987e1dbb312);
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $3cab4bc5bfd0a6af$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $3cab4bc5bfd0a6af$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $3cab4bc5bfd0a6af$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8p5Cv = parcelRequire("8p5Cv");
const $3cab4bc5bfd0a6af$export$7f5b2987e1dbb312 = (0, $8p5Cv.defineMessages)({
    collapseSection: {
        id: 'fabric.editor.collapsibleHeading.collapseSection.ai-non-final',
        defaultMessage: 'Collapse section',
        description: 'Accessible label and tooltip for the button beside an expanded renderer heading. Activating the button hides the content in that heading section.'
    },
    expandSection: {
        id: 'fabric.editor.collapsibleHeading.expandSection.ai-non-final',
        defaultMessage: 'Expand section',
        description: 'Accessible label and tooltip for the button beside a collapsed renderer heading. Activating the button reveals the content in that heading section.'
    }
});
const $3cab4bc5bfd0a6af$export$74bada844422036d = (0, $8p5Cv.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Tooltip and aria-label for the button that copies an anchor link to a heading in the rendered document to the clipboard.'
    },
    copyLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLinkTo',
        defaultMessage: 'Copy link to',
        description: 'Copy heading link to clipboard. Will be used as part of a 2-part a11y label ("Copy link to", "{heading text}")'
    },
    copyHeadingLinkLabelledBy: {
        id: 'fabric.editor.headingLink.copyAnchorLinkLabelledBy',
        defaultMessage: '{copyLink} {heading}',
        description: 'The order in which to read the parts of the aria-labelledby for the copy heading link button depending on the grammar of the language. {copyLink} will be replaced with the "Copy link to" text and {heading} will be replaced with the actual heading text'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly on the copy button after the heading anchor link has been successfully copied to the clipboard.'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'Aria label for the copy link button displayed next to a heading. Used by screen readers to describe the button that copies the heading anchor link to the clipboard.'
    }
});
const $3cab4bc5bfd0a6af$export$c79ebc36348824d1 = (0, $8p5Cv.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'Accessible label for a table column sort indicator when no sorting is applied to that column.'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $3cab4bc5bfd0a6af$export$9f52c375a6ef34fc = (0, $8p5Cv.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});

parcelRegister("6SGXD", function(module, exports) {
$parcel$export(module.exports, "ExtensionAnnotation", () => $d03171608066fe51$export$723dc5b6097df2eb);
/* extension.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");
const $d03171608066fe51$var$styles = {
    anchor: "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _lcxvglyw"
};
const $d03171608066fe51$export$723dc5b6097df2eb = ({ id: id, dataAttributes: dataAttributes, markRef: markRef })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        id: id,
        ref: markRef,
        "data-id": dataAttributes['data-id'],
        "data-mark-type": dataAttributes['data-mark-type'],
        "data-mark-annotation-type": dataAttributes['data-mark-annotation-type'],
        "data-mark-annotation-state": dataAttributes['data-mark-annotation-state'],
        "data-block-mark": dataAttributes['data-block-mark'],
        "data-renderer-mark": dataAttributes['data-renderer-mark'],
        "data-has-focus": dataAttributes['data-has-focus'],
        "data-is-hovered": dataAttributes['data-is-hovered'],
        className: (0, $2R2iS.default)([
            $d03171608066fe51$var$styles.anchor
        ])
    });

});





parcelRegister("h4qU2", function(module, exports) {
$parcel$export(module.exports, "useNodeHeight", () => $e1dcb908ba2f953a$export$4e9bd75b2d1c5f7c);

var $fc4bM = parcelRequire("fc4bM");
const $e1dcb908ba2f953a$var$useHeightExpiry = (value, property, node, scheduleRemoval)=>{
    const [expired, setExpired] = (0, $fc4bM.useState)(false);
    (0, $fc4bM.useEffect)(()=>{
        setExpired(false);
        if (value === undefined || !node || !scheduleRemoval) return;
        return scheduleRemoval(node, ()=>setExpired(true), property);
    }, [
        value,
        property,
        node,
        scheduleRemoval
    ]);
    return expired;
};
const $e1dcb908ba2f953a$export$4e9bd75b2d1c5f7c = ({ nodePresetMinHeight: nodePresetMinHeight, nodePresetHeight: nodePresetHeight, node: node, scheduleRemoval: scheduleRemoval, hasViewportSize: hasViewportSize = false })=>{
    const ignorePresets = hasViewportSize && !!scheduleRemoval;
    const presetMinHeight = ignorePresets ? undefined : nodePresetMinHeight;
    const presetHeight = ignorePresets ? undefined : nodePresetHeight;
    const minHeightExpired = $e1dcb908ba2f953a$var$useHeightExpiry(presetMinHeight, 'minHeight', node, scheduleRemoval);
    const heightExpired = $e1dcb908ba2f953a$var$useHeightExpiry(presetHeight, 'height', node, scheduleRemoval);
    return {
        presetMinHeight: minHeightExpired ? undefined : presetMinHeight,
        presetHeight: heightExpired ? undefined : presetHeight,
        hasExpired: minHeightExpired || heightExpired
    };
};

});


parcelRegister("5mJkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b79973c20d211e6$export$2e2bcd8739ae039);
/* ForgeBodiedExtensionHandoff.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $6Zi52 = parcelRequire("6Zi52");
const $6b79973c20d211e6$var$styles = {
    container: "_1e0c11p5",
    layer: "_nd5l1ekt _1ul9idpf",
    reservation: "_nd5l1ekt _1ul9idpf _3um015vq _lcxvglyw"
};
function $6b79973c20d211e6$export$2e2bcd8739ae039({ fallback: fallback, localId: localId, result: result }) {
    const [ready, setReady] = (0, $fc4bM.useState)(false);
    const hasResult = Boolean(result);
    (0, $fc4bM.useEffect)(()=>{
        if (!hasResult || ready) return;
        const onReady = (event)=>{
            var _event$data, _event$data2, _event$data3;
            if (event.source === window && event.origin === window.location.origin && ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.source) === 'forge-extension' && ((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.type) === 'EXTENSION_READY' && ((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.localId) === localId) setReady(true);
        };
        const unbind = (0, $6Zi52.bind)(window, {
            type: 'message',
            listener: onReady
        });
        // Do not retain an invisible body indefinitely if app initialization fails.
        const timeout = window.setTimeout(()=>setReady(true), 30000);
        return ()=>{
            unbind();
            window.clearTimeout(timeout);
        };
    }, [
        hasResult,
        localId,
        ready
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        className: (0, $2R2iS.default)([
            $6b79973c20d211e6$var$styles.container
        ]),
        children: [
            (!ready || !hasResult) && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                "aria-hidden": hasResult || undefined,
                className: (0, $2R2iS.default)([
                    $6b79973c20d211e6$var$styles.layer,
                    hasResult && $6b79973c20d211e6$var$styles.reservation
                ]),
                children: fallback
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    $6b79973c20d211e6$var$styles.layer
                ]),
                children: result
            })
        ]
    });
}

});

parcelRegister("iGevH", function(module, exports) {
$parcel$export(module.exports, "FORGE_BODIED_EXTENSION_HANDOFF_KEYS", () => $aad4adf47b71d3b3$export$b1f6f7fd6d96359a);
/** Exact extension keys whose native body is retained until Forge reports ready.
 * Keep this static so SSR and the first client render use the same allowlist.
 */ const $aad4adf47b71d3b3$export$b1f6f7fd6d96359a = new Set([
    // Aura Table Filter (production).
    '7be6519f-6039-4662-a5a4-2e38f785dc0a/f9fff7f6-4e74-44eb-9de4-f0be57852570/static/table-filter'
]);

});


parcelRegister("gCbQi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7243fd9d28fcac1$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $MCCgU = parcelRequire("MCCgU");

var $3k7qh = parcelRequire("3k7qh");
function $c7243fd9d28fcac1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $MCCgU.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $3k7qh.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("3k7qh", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $9e16e22103c33a93$export$75aa84e85754623e);
function $9e16e22103c33a93$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("3fACb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5d55593dadf2982$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $1nTtI = parcelRequire("1nTtI");
const $e5d55593dadf2982$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1nTtI.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $e5d55593dadf2982$export$2e2bcd8739ae039 = $e5d55593dadf2982$var$RenderCaption;

});
parcelRegister("1nTtI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3d168b1af6b40cd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $8dTRP = parcelRequire("8dTRP");
function $b3d168b1af6b40cd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b3d168b1af6b40cd$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $b3d168b1af6b40cd$var$placeholderStyle = (0, $kig2V.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $b3d168b1af6b40cd$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $b3d168b1af6b40cd$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
            xcss: $b3d168b1af6b40cd$var$placeholderStyle
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4T8rw.Text), null, formatMessage((0, $8dTRP.messages).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $b3d168b1af6b40cd$var$_default_1 = (0, $fcCIH.default)($b3d168b1af6b40cd$export$f7feb87190a94c76);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b3d168b1af6b40cd$export$2e2bcd8739ae039 = $b3d168b1af6b40cd$var$_default_1;

});
parcelRegister("8dTRP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b585d7edcae0f8f1$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $b585d7edcae0f8f1$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("lIQWN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce7dd5acfc811d0e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $ce7dd5acfc811d0e$export$41121a410ca2f650);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $aGINe = parcelRequire("aGINe");

var $9DjD2 = parcelRequire("9DjD2");
function $ce7dd5acfc811d0e$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $aGINe.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $ce7dd5acfc811d0e$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: (0, $9DjD2.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $aGINe.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("9DjD2", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $7b790712bcb80fb2$export$98871b245ee25215);

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $78GVL = parcelRequire("78GVL");

var $5FQDi = parcelRequire("5FQDi");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b790712bcb80fb2$var$MAC_PLATFORM_REGEX = /Mac/;
const $7b790712bcb80fb2$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $78GVL.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef();
    const mac = typeof navigator !== 'undefined' ? $7b790712bcb80fb2$var$MAC_PLATFORM_REGEX.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((e)=>{
        var _e$target, _e$target$matches;
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $5FQDi.ElementSelection).fromWindow();
        const isInput = (_e$target = e.target) === null || _e$target === void 0 || (_e$target$matches = _e$target.matches) === null || _e$target$matches === void 0 ? void 0 : _e$target$matches.call(_e$target, 'input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                action: (0, $3LeME.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                action: (0, $3LeME.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((e)=>{
        var _ref$current;
        clicked.current = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("78GVL", function(module, exports) {
$parcel$export(module.exports, "default", () => $eabf398bf8e7a826$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $eabf398bf8e7a826$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $eabf398bf8e7a826$export$2e2bcd8739ae039 = $eabf398bf8e7a826$var$AnalyticsContext;

});

parcelRegister("5FQDi", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $703eba84a62c7bdd$export$6e6724d89f27411);
class $703eba84a62c7bdd$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            var _this$range, _this$range2;
            const startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
            const endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        var _this$range3;
        return el.contains(((_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $703eba84a62c7bdd$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $703eba84a62c7bdd$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("YZCgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ff79b247419850a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $jctmk = parcelRequire("jctmk");
const $6ff79b247419850a$var$containerCSS = /*#__PURE__*/ (0, $jctmk.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $6ff79b247419850a$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            $6ff79b247419850a$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $6ff79b247419850a$export$2e2bcd8739ae039 = $6ff79b247419850a$var$ExtensionFrame;

});

parcelRegister("1Z2sX", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa3bfcfe4ff07bc5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $aa3bfcfe4ff07bc5$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("br", {}),
            /*#__PURE__*/ (0, $3LM7S.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("br", {});
};
var $aa3bfcfe4ff07bc5$export$2e2bcd8739ae039 = $aa3bfcfe4ff07bc5$var$HardBreak;

});

parcelRegister("jCySQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $575eebfbbafc0859$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $fRCnG = parcelRequire("fRCnG");

var $3LeME = parcelRequire("3LeME");

var $1ZqY6 = parcelRequire("1ZqY6");

var $jQYQa = parcelRequire("jQYQa");

var $aEmSo = parcelRequire("aEmSo");

var $dVxDa = parcelRequire("dVxDa");

var $78GVL = parcelRequire("78GVL");

var $brSjT = parcelRequire("brSjT");

var $gRn2W = parcelRequire("gRn2W");

var $imKvb = parcelRequire("imKvb");

var $1jdFu = parcelRequire("1jdFu");
const $575eebfbbafc0859$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $575eebfbbafc0859$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER = 'renderer-collapsible-heading-wrapper';
const $575eebfbbafc0859$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $575eebfbbafc0859$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
// Matches the editor's decoration-based number prefix without changing heading text or IDs.
const $575eebfbbafc0859$var$numberedHeadingStyles = null;
const $575eebfbbafc0859$var$wrapperStyles = null;
const $575eebfbbafc0859$var$collapsibleHeadingWrapperStyles = null;
const $575eebfbbafc0859$var$collapsibleHeadingButtonStyles = null;
const $575eebfbbafc0859$var$collapsibleHeadingButtonExpandedStyles = null;
const $575eebfbbafc0859$var$collapsibleHeadingButtonHiddenStyles = null;
const $575eebfbbafc0859$var$ChevronRightSmallIcon = ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6))), {
        label: "",
        size: "small"
    });
const $575eebfbbafc0859$var$hasFocusVisible = (target)=>{
    try {
        return target.matches(':focus-visible');
    } catch  {
        return true;
    }
};
const $575eebfbbafc0859$var$getHeadingAnchorLinksConfig = (allowHeadingAnchorLinks)=>typeof allowHeadingAnchorLinks === 'object' ? allowHeadingAnchorLinks : undefined;
function $575eebfbbafc0859$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, getHeadingLink: getHeadingLink, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $78GVL.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $1jdFu.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $3LeME.ACTION).CLICKED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $3LeME.EVENT_TYPE).UI
                    });
                    return (0, $imKvb.copyTextToClipboard)((getHeadingLink === null || getHeadingLink === void 0 ? void 0 : getHeadingLink(headingId)) ?? $575eebfbbafc0859$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $575eebfbbafc0859$var$CollapsibleHeadingButton({ collapsibleHeading: collapsibleHeading, headingLevel: headingLevel, isHeadingHovered: isHeadingHovered }) {
    const intl = (0, $gpjDl.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $78GVL.default));
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const { isCollapsed: isCollapsed, toggle: toggle } = collapsibleHeading;
    const isVisible = isCollapsed || isFocused || isHeadingHovered;
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        event.stopPropagation();
        fireAnalyticsEvent({
            action: (0, $3LeME.ACTION).TOGGLED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).HEADING,
            attributes: {
                expanded: isCollapsed,
                headingLevel: headingLevel
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        });
        toggle();
    }, [
        fireAnalyticsEvent,
        headingLevel,
        isCollapsed,
        toggle
    ]);
    const handleFocus = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        setIsFocused($575eebfbbafc0859$var$hasFocusVisible(event.target));
    }, []);
    const handleBlur = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>setIsFocused(false), []);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>setIsFocused(true), []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        className: (0, $2R2iS.default)([
            "_kqswstnw _152tidpf _1e02idpf _1pbykb7n _l8ku180e _wxvuglyw",
            !isCollapsed && "_12hn14w8",
            !isVisible && "_tzy4idpf _lcxvglyw _tza3kb7n _12yg1wug _xrqrkb7n _l4c51wug"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: $575eebfbbafc0859$var$ChevronRightSmallIcon,
            label: intl.formatMessage(isCollapsed ? (0, $brSjT.collapsibleHeadingMessages).expandSection : (0, $brSjT.collapsibleHeadingMessages).collapseSection),
            "aria-expanded": !isCollapsed,
            isTooltipDisabled: false,
            testId: "collapsible-heading-button",
            onClick: handleClick,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown
        })
    });
}
function $575eebfbbafc0859$var$CollapsibleHeadingContainer({ children: children, collapsibleHeading: collapsibleHeading, headingLevel: headingLevel }) {
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const mouseEnterHandler = ()=>{
        if (!mouseEntered.current) {
            (0, $jQYQa.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        "data-testid": $575eebfbbafc0859$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER,
        "data-level": headingLevel,
        onMouseEnter: ()=>{
            mouseEnterHandler();
            setIsHovered(true);
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: (event)=>setIsFocused($575eebfbbafc0859$var$hasFocusVisible(event.target)),
        onBlur: ()=>setIsFocused(false),
        className: (0, $2R2iS.default)([
            "_ahbqukr8 _bozgxy5q _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$CollapsibleHeadingButton, {
                collapsibleHeading: collapsibleHeading,
                headingLevel: headingLevel,
                isHeadingHovered: isHovered || isFocused
            }),
            children
        ]
    });
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $575eebfbbafc0859$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $575eebfbbafc0859$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $575eebfbbafc0859$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $jQYQa.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)(HX, {
                "data-heading-number": props.headingNumber,
                id: headingIdToUse,
                "data-local-id": localId,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                "data-as-inline": asInline,
                onMouseEnter: mouseEnterHandler,
                tabIndex: -1,
                className: (0, $2R2iS.default)([
                    props.headingNumber && "_1kt9j9bv _1mbqu2gc _1wqoglyw"
                ]),
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            getHeadingLink: getHeadingLink,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            getHeadingLink: getHeadingLink,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    getHeadingLink: getHeadingLink,
                    headingId: headingId
                })
            })
        ]
    });
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $575eebfbbafc0859$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline, collapsibleHeading: collapsibleHeading } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $575eebfbbafc0859$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $575eebfbbafc0859$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if ((showAnchorLink || collapsibleHeading) && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $jQYQa.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    const handleWrapperMouseEnter = ()=>{
        mouseEnterHandler();
        setIsHovered(true);
    };
    const handleWrapperMouseLeave = ()=>setIsHovered(false);
    const handleWrapperFocus = (event)=>setIsFocused($575eebfbbafc0859$var$hasFocusVisible(event.target));
    const handleWrapperBlur = ()=>setIsFocused(false);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1e0c1ule",
            collapsibleHeading && "_ahbqukr8 _bozgxy5q _kqswh2mm",
            $575eebfbbafc0859$var$RENDERER_HEADING_WRAPPER
        ]),
        "data-testid": $575eebfbbafc0859$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        onMouseEnter: collapsibleHeading ? handleWrapperMouseEnter : undefined,
        onMouseLeave: collapsibleHeading ? handleWrapperMouseLeave : undefined,
        onFocus: collapsibleHeading ? handleWrapperFocus : undefined,
        onBlur: collapsibleHeading ? handleWrapperBlur : undefined,
        children: [
            collapsibleHeading && /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$CollapsibleHeadingButton, {
                collapsibleHeading: collapsibleHeading,
                headingLevel: props.level,
                isHeadingHovered: isHovered || isFocused
            }),
            showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$WrappedHeadingAnchor, {
                level: props.level,
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                getHeadingLink: getHeadingLink,
                headingId: headingId,
                hideFromScreenReader: false
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)(HX, {
                "data-heading-number": props.headingNumber,
                id: headingIdToUse,
                "data-local-id": localId,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                "data-as-inline": asInline,
                onMouseEnter: collapsibleHeading ? undefined : mouseEnterHandler,
                tabIndex: -1,
                className: (0, $2R2iS.default)([
                    props.headingNumber && "_1kt9j9bv _1mbqu2gc _1wqoglyw"
                ]),
                children: props.children
            }),
            showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$WrappedHeadingAnchor, {
                level: props.level,
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                getHeadingLink: getHeadingLink,
                headingId: headingId,
                hideFromScreenReader: false
            })
        ]
    });
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise preserves HeadingWithDuplicateAnchor (old structure), adding only the collapse
 *   container when the top-level heading is collapsible
 */ function $575eebfbbafc0859$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, headingNumber: headingNumber, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, path: path, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    const collapsibleHeading = (0, $gRn2W.useCollapsibleHeading)(dataAttributes['data-renderer-start-pos'], (path === null || path === void 0 ? void 0 : path.length) === 0);
    if ((0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        headingNumber: headingNumber,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline,
        collapsibleHeading: collapsibleHeading,
        children: children
    });
    const headingWithDuplicateAnchor = /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        headingNumber: headingNumber,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline,
        children: children
    });
    if (collapsibleHeading) return /*#__PURE__*/ (0, $3LM7S.jsx)($575eebfbbafc0859$var$CollapsibleHeadingContainer, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: level,
        children: headingWithDuplicateAnchor
    });
    return headingWithDuplicateAnchor;
}
var $575eebfbbafc0859$export$2e2bcd8739ae039 = $575eebfbbafc0859$var$Heading;

});
parcelRegister("gRn2W", function(module, exports) {
$parcel$export(module.exports, "CollapsibleHeadingsProvider", () => $c9564386bdb393ef$export$158f0ca2ade2cf24);
$parcel$export(module.exports, "useCollapsibleHeading", () => $c9564386bdb393ef$export$3df123b939d40b52);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $3ZJj6 = parcelRequire("3ZJj6");

var $2Wk5p = parcelRequire("2Wk5p");

var $9jGKI = parcelRequire("9jGKI");
const $c9564386bdb393ef$var$CollapsibleHeadingsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(null);
const $c9564386bdb393ef$var$emptyCollapsedHeadings = new Set();
function $c9564386bdb393ef$var$isSameDocument(currentDocument, nextDocument) {
    if (currentDocument === nextDocument) return true;
    if (!currentDocument || !nextDocument) return false;
    // Node.eq compares node-type identity. The shared schema cache can be evicted by another
    // renderer, producing different node types for identical content on the next render.
    return currentDocument.type.schema === nextDocument.type.schema ? currentDocument.eq(nextDocument) : (0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(currentDocument.toJSON(), nextDocument.toJSON());
}
function $c9564386bdb393ef$var$supportsHiddenUntilFound(rendererRef) {
    var _rendererRef$current;
    const body = (_rendererRef$current = rendererRef.current) === null || _rendererRef$current === void 0 ? void 0 : _rendererRef$current.ownerDocument.body;
    return body ? 'onbeforematch' in body : false;
}
function $c9564386bdb393ef$export$158f0ca2ade2cf24({ children: children, isEnabled: isEnabled, pmDocument: pmDocument, rendererRef: rendererRef }) {
    const [isBrowserFindSupported, setIsBrowserFindSupported] = (0, $fc4bM.useState)(false);
    const [state, setState] = (0, $fc4bM.useState)({
        pmDocument: pmDocument,
        positions: new Set()
    });
    const originalHiddenAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(new WeakMap()).current;
    const sections = (0, $fc4bM.useMemo)(()=>(0, $9jGKI.buildTopLevelHeadingSections)(pmDocument), [
        pmDocument
    ]);
    const collapsibleSectionPositions = (0, $fc4bM.useMemo)(()=>new Set(sections.filter((section)=>section.contentFrom < section.to).map((section)=>section.headingPos)), [
        sections
    ]);
    const isCurrentDocument = $c9564386bdb393ef$var$isSameDocument(state.pmDocument, pmDocument);
    const collapsedHeadings = isCurrentDocument ? state.positions : $c9564386bdb393ef$var$emptyCollapsedHeadings;
    const isActive = isEnabled && isBrowserFindSupported && Boolean(pmDocument);
    (0, $fc4bM.useEffect)(()=>{
        setIsBrowserFindSupported(isEnabled && $c9564386bdb393ef$var$supportsHiddenUntilFound(rendererRef));
    }, [
        isEnabled,
        rendererRef
    ]);
    const updateCollapsedHeadings = (0, $fc4bM.useCallback)((update)=>{
        setState((currentState)=>{
            const isStillCurrentDocument = $c9564386bdb393ef$var$isSameDocument(currentState.pmDocument, pmDocument);
            const positions = new Set(isStillCurrentDocument ? currentState.positions : $c9564386bdb393ef$var$emptyCollapsedHeadings);
            if (!update(positions)) return isStillCurrentDocument ? currentState : {
                pmDocument: pmDocument,
                positions: positions
            };
            return {
                pmDocument: pmDocument,
                positions: positions
            };
        });
    }, [
        pmDocument
    ]);
    const collapse = (0, $fc4bM.useCallback)((headingPos)=>{
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings((positions)=>{
            if (positions.has(headingPos)) return false;
            positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    const expand = (0, $fc4bM.useCallback)((headingPos)=>{
        updateCollapsedHeadings((positions)=>positions.delete(headingPos));
    }, [
        updateCollapsedHeadings
    ]);
    const expandMany = (0, $fc4bM.useCallback)((headingPositions)=>{
        const positionsToExpand = new Set(headingPositions);
        updateCollapsedHeadings((positions)=>{
            let didChange = false;
            positionsToExpand.forEach((headingPos)=>{
                didChange = positions.delete(headingPos) || didChange;
            });
            return didChange;
        });
    }, [
        updateCollapsedHeadings
    ]);
    const expandContainingPosition = (0, $fc4bM.useCallback)((position)=>{
        expandMany(sections.filter((section)=>position >= section.contentFrom && position < section.to).map((section)=>section.headingPos));
    }, [
        expandMany,
        sections
    ]);
    const toggle = (0, $fc4bM.useCallback)((headingPos)=>{
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings((positions)=>{
            if (positions.has(headingPos)) positions.delete(headingPos);
            else positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    const contextValue = (0, $fc4bM.useMemo)(()=>isActive ? {
            canCollapse: (headingPos)=>collapsibleSectionPositions.has(headingPos),
            collapse: collapse,
            expand: expand,
            expandContainingPosition: expandContainingPosition,
            expandMany: expandMany,
            isCollapsed: (headingPos)=>collapsedHeadings.has(headingPos),
            toggle: toggle
        } : null, [
        collapse,
        collapsedHeadings,
        collapsibleSectionPositions,
        expand,
        expandContainingPosition,
        expandMany,
        isActive,
        toggle
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const rendererRoot = rendererRef.current;
        if (!rendererRoot) return;
        const positions = isActive ? collapsedHeadings : $c9564386bdb393ef$var$emptyCollapsedHeadings;
        const sync = ()=>(0, $2Wk5p.reconcileCollapsedHeadingContent)({
                collapsedHeadings: positions,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: sections
            });
        sync();
        if (!isActive || positions.size === 0) return;
        const rendererDocuments = (0, $2Wk5p.getOwnedRendererDocuments)(rendererRoot);
        const rendererDocumentSet = new Set(rendererDocuments);
        const handleBeforeMatch = (event)=>{
            var _rendererRoot$ownerDo;
            const target = event.target;
            const HTMLElementConstructor = (_rendererRoot$ownerDo = rendererRoot.ownerDocument.defaultView) === null || _rendererRoot$ownerDo === void 0 ? void 0 : _rendererRoot$ownerDo.HTMLElement;
            if (!HTMLElementConstructor || !(target instanceof HTMLElementConstructor)) return;
            const collapsedContent = target.closest(`[${(0, $2Wk5p.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE)}]`);
            if (!collapsedContent) return;
            const rendererDocument = collapsedContent.closest('.ak-renderer-document');
            if (!rendererDocument || !rendererDocumentSet.has(rendererDocument)) return;
            expandMany((0, $2Wk5p.getCollapsedContentOwners)(collapsedContent));
        };
        const unbindBeforeMatchListeners = rendererDocuments.map((rendererDocument)=>(0, $6Zi52.bind)(rendererDocument, {
                type: 'beforematch',
                listener: handleBeforeMatch,
                options: {
                    capture: true
                }
            }));
        const observer = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(sync);
        rendererDocuments.forEach((rendererDocument)=>{
            observer === null || observer === void 0 || observer.observe(rendererDocument, {
                childList: true
            });
        });
        return ()=>{
            observer === null || observer === void 0 || observer.disconnect();
            unbindBeforeMatchListeners.forEach((unbindBeforeMatch)=>unbindBeforeMatch());
        };
    }, [
        collapsedHeadings,
        expandMany,
        isActive,
        originalHiddenAttributes,
        rendererRef,
        sections
    ]);
    (0, $fc4bM.useEffect)(()=>()=>{
            const rendererRoot = rendererRef.current;
            if (rendererRoot) (0, $2Wk5p.reconcileCollapsedHeadingContent)({
                collapsedHeadings: $c9564386bdb393ef$var$emptyCollapsedHeadings,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: []
            });
        }, [
        originalHiddenAttributes,
        rendererRef
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($c9564386bdb393ef$var$CollapsibleHeadingsContext.Provider, {
        value: contextValue,
        children: children
    });
}
function $c9564386bdb393ef$export$3df123b939d40b52(startPos, isTopLevel) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($c9564386bdb393ef$var$CollapsibleHeadingsContext);
    const contextToggle = context === null || context === void 0 ? void 0 : context.toggle;
    const isCollapsible = Boolean(context && isTopLevel && context.canCollapse(startPos));
    const isCollapsed = Boolean(isCollapsible && (context === null || context === void 0 ? void 0 : context.isCollapsed(startPos)));
    const toggle = (0, $fc4bM.useCallback)(()=>contextToggle === null || contextToggle === void 0 ? void 0 : contextToggle(startPos), [
        contextToggle,
        startPos
    ]);
    return (0, $fc4bM.useMemo)(()=>isCollapsible ? {
            isCollapsed: isCollapsed,
            toggle: toggle
        } : null, [
        isCollapsed,
        isCollapsible,
        toggle
    ]);
}
function $c9564386bdb393ef$export$16b4e68f51f04e9e() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($c9564386bdb393ef$var$CollapsibleHeadingsContext);
}

});
parcelRegister("2Wk5p", function(module, exports) {
$parcel$export(module.exports, "COLLAPSED_CONTENT_OWNERS_ATTRIBUTE", () => $e46b41118b75f7bb$export$2116c0d2c1e9b9e4);
$parcel$export(module.exports, "getOwnedRendererDocuments", () => $e46b41118b75f7bb$export$236858493fcc483b);
$parcel$export(module.exports, "reconcileCollapsedHeadingContent", () => $e46b41118b75f7bb$export$371cf0cf237e6c69);
$parcel$export(module.exports, "getCollapsedContentOwners", () => $e46b41118b75f7bb$export$18ccec9830a10d6e);
const $e46b41118b75f7bb$var$RENDERER_DOCUMENT_SELECTOR = '.ak-renderer-document';
const $e46b41118b75f7bb$var$RENDERER_START_POS_ATTRIBUTE = 'data-renderer-start-pos';
const $e46b41118b75f7bb$var$HEADING_SELECTOR = [
    1,
    2,
    3,
    4,
    5,
    6
].map((level)=>`h${level}[${$e46b41118b75f7bb$var$RENDERER_START_POS_ATTRIBUTE}]`).join(',');
const $e46b41118b75f7bb$export$2116c0d2c1e9b9e4 = 'data-renderer-collapsed-content-owners';
function $e46b41118b75f7bb$var$getDirectRendererChild(rendererDocument, element) {
    var _currentElement;
    let currentElement = element;
    while(currentElement && currentElement.parentElement !== rendererDocument)currentElement = currentElement.parentElement;
    return ((_currentElement = currentElement) === null || _currentElement === void 0 ? void 0 : _currentElement.parentElement) === rendererDocument ? currentElement : null;
}
function $e46b41118b75f7bb$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions) {
    const headingPositionsByContainer = new Map();
    rendererDocument.querySelectorAll($e46b41118b75f7bb$var$HEADING_SELECTOR).forEach((headingElement)=>{
        if (headingElement.closest($e46b41118b75f7bb$var$RENDERER_DOCUMENT_SELECTOR) !== rendererDocument) return;
        const position = Number(headingElement.getAttribute($e46b41118b75f7bb$var$RENDERER_START_POS_ATTRIBUTE));
        if (!Number.isFinite(position) || !topLevelHeadingPositions.has(position)) return;
        const headingContainer = $e46b41118b75f7bb$var$getDirectRendererChild(rendererDocument, headingElement);
        if (headingContainer) headingPositionsByContainer.set(headingContainer, position);
    });
    return headingPositionsByContainer;
}
function $e46b41118b75f7bb$var$restoreHiddenAttribute(element, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) return;
    const originalHiddenAttribute = originalHiddenAttributes.get(element);
    if (originalHiddenAttribute === null || originalHiddenAttribute === undefined) element.removeAttribute('hidden');
    else element.setAttribute('hidden', originalHiddenAttribute);
    originalHiddenAttributes.delete(element);
}
function $e46b41118b75f7bb$var$setCollapsedOwners(element, owners, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) originalHiddenAttributes.set(element, element.getAttribute('hidden'));
    element.setAttribute($e46b41118b75f7bb$export$2116c0d2c1e9b9e4, Array.from(owners).join(','));
    element.setAttribute('hidden', 'until-found');
}
function $e46b41118b75f7bb$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections) {
    const desiredOwners = new Map();
    if (collapsedHeadings.size === 0) return desiredOwners;
    const topLevelHeadingPositions = new Set(sections.map((section)=>section.headingPos));
    const sectionsByHeadingPosition = new Map(sections.map((section)=>[
            section.headingPos,
            section
        ]));
    rendererDocuments.forEach((rendererDocument)=>{
        // Index headings once, then reconcile every top-level renderer child in DOM order.
        const headingPositionsByContainer = $e46b41118b75f7bb$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions);
        let activeCollapsedSections = [];
        const contentElements = Array.from(rendererDocument.children);
        contentElements.forEach((contentElement)=>{
            const headingPosition = headingPositionsByContainer.get(contentElement);
            if (headingPosition !== undefined) activeCollapsedSections = activeCollapsedSections.filter((section)=>section.to > headingPosition);
            if (activeCollapsedSections.length > 0) desiredOwners.set(contentElement, new Set(activeCollapsedSections.map((section)=>section.headingPos)));
            if (headingPosition !== undefined && collapsedHeadings.has(headingPosition)) {
                const section = sectionsByHeadingPosition.get(headingPosition);
                if (section) activeCollapsedSections.push(section);
            }
        });
    });
    return desiredOwners;
}
function $e46b41118b75f7bb$export$236858493fcc483b(rendererRoot) {
    return Array.from(rendererRoot.querySelectorAll($e46b41118b75f7bb$var$RENDERER_DOCUMENT_SELECTOR)).filter((rendererDocument)=>{
        var _rendererDocument$par;
        const parentRendererDocument = (_rendererDocument$par = rendererDocument.parentElement) === null || _rendererDocument$par === void 0 ? void 0 : _rendererDocument$par.closest($e46b41118b75f7bb$var$RENDERER_DOCUMENT_SELECTOR);
        return !parentRendererDocument || !rendererRoot.contains(parentRendererDocument);
    });
}
function $e46b41118b75f7bb$export$371cf0cf237e6c69({ collapsedHeadings: collapsedHeadings, originalHiddenAttributes: originalHiddenAttributes, rendererRoot: rendererRoot, sections: sections }) {
    const rendererDocuments = $e46b41118b75f7bb$export$236858493fcc483b(rendererRoot);
    const desiredOwners = $e46b41118b75f7bb$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections);
    rendererDocuments.forEach((rendererDocument)=>{
        rendererDocument.querySelectorAll(`[${$e46b41118b75f7bb$export$2116c0d2c1e9b9e4}]`).forEach((element)=>{
            if (element.closest($e46b41118b75f7bb$var$RENDERER_DOCUMENT_SELECTOR) === rendererDocument && !desiredOwners.has(element)) {
                element.removeAttribute($e46b41118b75f7bb$export$2116c0d2c1e9b9e4);
                $e46b41118b75f7bb$var$restoreHiddenAttribute(element, originalHiddenAttributes);
            }
        });
    });
    desiredOwners.forEach((owners, element)=>{
        const desiredOwnersAttribute = Array.from(owners).join(',');
        if (element.getAttribute($e46b41118b75f7bb$export$2116c0d2c1e9b9e4) !== desiredOwnersAttribute || element.getAttribute('hidden') !== 'until-found') $e46b41118b75f7bb$var$setCollapsedOwners(element, owners, originalHiddenAttributes);
    });
}
function $e46b41118b75f7bb$export$18ccec9830a10d6e(element) {
    return (element.getAttribute($e46b41118b75f7bb$export$2116c0d2c1e9b9e4) ?? '').split(',').filter((owner)=>owner !== '').map(Number).filter(Number.isFinite);
}

});

parcelRegister("9jGKI", function(module, exports) {
$parcel$export(module.exports, "buildTopLevelHeadingSections", () => $3aa9bbdf4edc9685$export$640970ddc72cf5cf);
const $3aa9bbdf4edc9685$var$RENDERER_DOCUMENT_POSITION_OFFSET = 1;
function $3aa9bbdf4edc9685$export$640970ddc72cf5cf(pmDocument) {
    if (!pmDocument) return [];
    const sections = [];
    const openSections = [];
    const documentEnd = pmDocument.content.size + $3aa9bbdf4edc9685$var$RENDERER_DOCUMENT_POSITION_OFFSET;
    pmDocument.forEach((node, offset)=>{
        if (node.type.name !== 'heading') return;
        const headingPos = offset + $3aa9bbdf4edc9685$var$RENDERER_DOCUMENT_POSITION_OFFSET;
        const level = Number(node.attrs.level);
        while(openSections.length > 0 && openSections[openSections.length - 1].level >= level){
            const section = openSections.pop();
            if (section) section.to = headingPos;
        }
        const section = {
            contentFrom: headingPos + node.nodeSize,
            headingPos: headingPos,
            level: level,
            to: documentEnd
        };
        sections.push(section);
        openSections.push(section);
    });
    return sections;
}

});


parcelRegister("imKvb", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $0d76f6459ec7eb94$export$f980440e1ab4537d);
const $0d76f6459ec7eb94$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("1jdFu", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $343100e19e8a1e9b$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $343100e19e8a1e9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $inMs5 = parcelRequire("inMs5");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $bcTS3 = parcelRequire("bcTS3");

var $brSjT = parcelRequire("brSjT");

var $ipj6V = parcelRequire("ipj6V");
function $343100e19e8a1e9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $343100e19e8a1e9b$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $343100e19e8a1e9b$var$headingAnchorWrapperTargetSizeStyles = {
    name: "v48shi",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;width:24px;height:24px;vertical-align:middle"
};
const $343100e19e8a1e9b$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $343100e19e8a1e9b$export$3c9cedc52604835d,
        css: (0, $bcN2K.isExperimentEnabled)('platform_editor_heading_link_target_size') ? $343100e19e8a1e9b$var$headingAnchorWrapperTargetSizeStyles : undefined,
        ref: ref
    }, children);
});
const $343100e19e8a1e9b$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
const $343100e19e8a1e9b$var$scaledLinkIconStyles = {
    name: "1m0xiot",
    styles: "display:inline-flex;transform:scale(1.5);transform-origin:center"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $343100e19e8a1e9b$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    constructor(props){
        super(props), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, // Stable reference for Tooltip content prop to avoid recreating on each render
        this.renderTooltipContent = ({ update: update })=>{
            this._tooltipUpdate = update;
            return this.state.tooltipMessage;
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            }, ()=>{
                var _this$_tooltipUpdate;
                // Reposition tooltip after content change (replaces the key-based remount)
                (_this$_tooltipUpdate = this._tooltipUpdate) === null || _this$_tooltipUpdate === void 0 || _this$_tooltipUpdate.call(this);
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $brSjT.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $brSjT.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            const tooltip = (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $brSjT.headingAnchorLinkMessages).copyLinkToClipboard : (0, $brSjT.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $brSjT.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_heading_link_target_size')) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $ipj6V.default), {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
                css: $343100e19e8a1e9b$var$scaledLinkIconStyles,
                "data-testid": "scaled-link-icon"
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
                label: this.getCopyAriaLabel(),
                size: "medium",
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            })));
            return /*#__PURE__*/ (0, $jctmk.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $343100e19e8a1e9b$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // Fix for A11Y-30972: Use content as a function with update callback so
        // the Tooltip repositions without unmounting (which caused focus loss).
        // @see https://hello.jira.atlassian.cloud/browse/A11Y-30972
        return /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
            tag: $343100e19e8a1e9b$var$CopyAnchorWrapperWithRef,
            content: this.renderTooltipContent,
            position: "top",
            delay: 0,
            isScreenReaderAnnouncementDisabled: (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false,
            hasNewContentOnTriggerClick: true
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $343100e19e8a1e9b$var$_default_1 = (0, $fcCIH.default)($343100e19e8a1e9b$var$HeadingAnchor);
var $343100e19e8a1e9b$export$2e2bcd8739ae039 = $343100e19e8a1e9b$var$_default_1;

});
parcelRegister("ipj6V", function(module, exports) {
$parcel$export(module.exports, "default", () => $18b79fe3e23f646e$export$2e2bcd8739ae039);
/* heading-anchor-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $18b79fe3e23f646e$var$buttonStyles = null;
function $18b79fe3e23f646e$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading -- Forward the existing heading anchor's accessibility and event props.
    return /*#__PURE__*/ (0, $3LM7S.jsx)("button", {
        ...props,
        type: "button",
        className: (0, $2R2iS.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1dqoglyw _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n4nkob _bfhk1j28 _80omtlke"
        ])
    });
}

});



parcelRegister("1toFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b867c3c49acfee30$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $4h8CP = parcelRequire("4h8CP");
const $b867c3c49acfee30$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4h8CP.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(result)) return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $b867c3c49acfee30$export$2e2bcd8739ae039 = $b867c3c49acfee30$var$InlineExtension;

});

parcelRegister("463vm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f79da79561b83d38$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $bcN2K = parcelRequire("bcN2K");

var $fzRvL = parcelRequire("fzRvL");

var $6g6jF = parcelRequire("6g6jF");

var $jf0Mi = parcelRequire("jf0Mi");
const $f79da79561b83d38$var$LayoutSectionMigration = (0, $fzRvL.componentWithCondition)(()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_renderer_static_css'), (0, $6g6jF.LayoutSectionCompiled), (0, $jf0Mi.LayoutSectionEmotion));
function $f79da79561b83d38$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)($f79da79561b83d38$var$LayoutSectionMigration, {
        ...props
    });
}

});
parcelRegister("6g6jF", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionCompiled", () => $a9887fbb7b0b0187$export$417b5700bb65fae1);
/* layoutColumn-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Compiled branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $iYGtj = parcelRequire("iYGtj");
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $a9887fbb7b0b0187$var$clearNextSiblingMarginTopStyle = null;
const $a9887fbb7b0b0187$var$verticalAlignMiddleStyles = null;
const $a9887fbb7b0b0187$var$verticalAlignBottomStyles = null;
const $a9887fbb7b0b0187$var$multipleWrappedImagesStyle = null;
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $a9887fbb7b0b0187$var$clearNextSiblingBlockMarkMarginTopStyle = null;
const $a9887fbb7b0b0187$export$417b5700bb65fae1 = (props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        className: (0, $2R2iS.default)([
            props.valign === 'middle' && "_1e0c1txw _2lx21bp4 _1bah1h6o",
            props.valign === 'bottom' && "_1e0c1txw _2lx21bp4 _1bahesu3",
            "_1tihidpf _12kpidpf"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $iYGtj.WidthProvider), {
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    "data-layout-column-start": "true",
                    className: (0, $2R2iS.default)([
                        "_1skbgrf3",
                        "_19segrf3 _1ki1grf3 _bmdegrf3 _166hgrf3 _7g1ogrf3 _sk2jgrf3 _hgeogrf3"
                    ])
                }),
                props.children
            ]
        })
    });
};

});
parcelRegister("iYGtj", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $638349b03d4b9158$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $638349b03d4b9158$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $638349b03d4b9158$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $638349b03d4b9158$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $638349b03d4b9158$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jiju3 = parcelRequire("jiju3");

var $PIUl3 = parcelRequire("PIUl3");

var $4gVCP = parcelRequire("4gVCP");

var $eVKpX = parcelRequire("eVKpX");
function $638349b03d4b9158$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $638349b03d4b9158$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $638349b03d4b9158$var$SCROLLBAR_WIDTH = 30;
function $638349b03d4b9158$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $638349b03d4b9158$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $638349b03d4b9158$export$1eb095b00b926404(width)
    };
}
const $638349b03d4b9158$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext($638349b03d4b9158$export$31a4966bffb9ac98());
const $638349b03d4b9158$var$Provider = $638349b03d4b9158$export$27e39f636459b9f.Provider;
const $638349b03d4b9158$export$5d8538aa831b6ebb = $638349b03d4b9158$export$27e39f636459b9f.Consumer;
const $638349b03d4b9158$export$df154c49e93b2ac2 = (0, $jiju3.default)(()=>{
    var _document$body;
    return (0, $eVKpX.isSSR)() ? 0 : ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth) ?? 0;
});
const $638349b03d4b9158$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $fc4bM.useContext)($638349b03d4b9158$export$27e39f636459b9f);
    const [width, setWidth] = (0, $fc4bM.useState)($638349b03d4b9158$export$df154c49e93b2ac2);
    const widthRef = (0, $fc4bM.useRef)(width);
    const isMountedRef = (0, $fc4bM.useRef)(true);
    const providerValue = (0, $fc4bM.useMemo)(()=>$638349b03d4b9158$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $fc4bM.useMemo)(()=>{
        return (0, $PIUl3.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $638349b03d4b9158$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $638349b03d4b9158$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4gVCP.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $jctmk.jsx)($638349b03d4b9158$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("eVKpX", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $4d6a2ae0e50bfa65$export$48d7c418edadb60c);

var $3jCFs = parcelRequire("3jCFs");
function $4d6a2ae0e50bfa65$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $3jCFs !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("jf0Mi", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionEmotion", () => $1b070371c42f3636$export$2cc1a43fb56df180);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $iYGtj = parcelRequire("iYGtj");
function $1b070371c42f3636$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $1b070371c42f3636$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $1b070371c42f3636$var$verticalAlignMiddleStyles = {
    name: "16mmcnu",
    styles: "display:flex;flex-direction:column;justify-content:center"
};
const $1b070371c42f3636$var$verticalAlignBottomStyles = {
    name: "igeqly",
    styles: "display:flex;flex-direction:column;justify-content:flex-end"
};
const $1b070371c42f3636$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $1b070371c42f3636$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
const $1b070371c42f3636$export$2cc1a43fb56df180 = (props)=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        css: [
            // Keep separate: Compiled crashes on ternary/object lookup here.
            props.valign === 'middle' && $1b070371c42f3636$var$verticalAlignMiddleStyles,
            props.valign === 'bottom' && $1b070371c42f3636$var$verticalAlignBottomStyles,
            $1b070371c42f3636$var$multipleWrappedImagesStyle
        ]
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $iYGtj.WidthProvider), null, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-layout-column-start": "true",
        css: [
            $1b070371c42f3636$var$clearNextSiblingMarginTopStyle,
            $1b070371c42f3636$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
};

});


parcelRegister("5Ut7t", function(module, exports) {
$parcel$export(module.exports, "default", () => $17b60a0364db841c$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $kaRof = parcelRequire("kaRof");
function $17b60a0364db841c$export$2e2bcd8739ae039(props) {
    var _props$getContent;
    const columnCount = (_props$getContent = props.getContent) === null || _props$getContent === void 0 || (_props$getContent = _props$getContent.call(props)) === null || _props$getContent === void 0 ? void 0 : _props$getContent.length;
    return (0, $kaRof.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: "layout-section-container",
        "data-local-id": props.localId,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": columnCount,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-layout-section": true,
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("3FbPQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $20b1b94c532e1b10$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $20b1b94c532e1b10$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("68bBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $67c43df0a4c19e1c$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $bcN2K = parcelRequire("bcN2K");

var $78GVL = parcelRequire("78GVL");

var $aGINe = parcelRequire("aGINe");

var $lHYTa = parcelRequire("lHYTa");

var $jKJON = parcelRequire("jKJON");

var $ehFFs = parcelRequire("ehFFs");
function $67c43df0a4c19e1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $67c43df0a4c19e1c$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $67c43df0a4c19e1c$var$getFramesActiveFrameStyles = (activeChildIndex)=>{
    // Apply the active-frame rule on the frames article itself so nested MBEs
    // only target their own direct frames.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return /*#__PURE__*/ (0, $jctmk.css)("&>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
};
const $67c43df0a4c19e1c$var$MultiBodiedExtensionChildrenContainer = ({ activeChildIndex: activeChildIndex, children: children })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("article", {
        css: $67c43df0a4c19e1c$var$getFramesActiveFrameStyles(activeChildIndex),
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $67c43df0a4c19e1c$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $67c43df0a4c19e1c$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $aGINe.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $aGINe.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lHYTa.calcBreakoutWidthCss)(layout) : (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $67c43df0a4c19e1c$var$MultiBodiedExtension = (props)=>{
    var _extensionContext$pri;
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, extensionHandlers: extensionHandlers, getContent: getContent, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $fc4bM.useState)(0);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $fc4bM.useContext)((0, $78GVL.default));
    const { loading: loading, extensionContext: extensionContext } = (0, $ehFFs.useMultiBodiedExtensionContext)({
        extensionHandlers: extensionHandlers,
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $jKJON.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $jctmk.jsx)($67c43df0a4c19e1c$var$MultiBodiedExtensionChildrenContainer, {
            activeChildIndex: activeChildIndex
        }, children),
        allowBodiedOverride: extensionContext === null || extensionContext === void 0 || (_extensionContext$pri = extensionContext.privateProps) === null || _extensionContext$pri === void 0 ? void 0 : _extensionContext$pri.__allowBodiedOverride,
        extensionKey: extensionKey,
        extensionType: extensionType,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        var _marks$find;
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: getContent === null || getContent === void 0 ? void 0 : getContent(),
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $jctmk.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, $jctmk.jsx)($67c43df0a4c19e1c$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $jctmk.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $jctmk.jsx)($67c43df0a4c19e1c$var$MultiBodiedExtensionChildrenContainer, {
            activeChildIndex: activeChildIndex
        }, children));
    }, [
        activeChildIndex,
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        getContent,
        localId,
        actions,
        children
    ]);
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout);
    const wrapper = /*#__PURE__*/ (0, $jctmk.jsx)($67c43df0a4c19e1c$var$MultiBodiedExtensionWrapperNext, {
        layout: layout,
        path: path,
        rendererAppearance: rendererAppearance
    }, renderContent());
    return /*#__PURE__*/ (0, $jctmk.jsx)("section", {
        css: $67c43df0a4c19e1c$var$containerStyles,
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId,
        "data-node-type": "multiBodiedExtension"
    }, useCenterWrapper ? /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $aGINe.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $aGINe.RendererCssClassName).FLEX_CENTER_WRAPPER
    }, wrapper) : wrapper);
};
var $67c43df0a4c19e1c$export$2e2bcd8739ae039 = $67c43df0a4c19e1c$var$MultiBodiedExtension;

});
parcelRegister("jKJON", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $7cd03983df43e457$export$3c7139d93ecb4f1f);

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $aEmSo = parcelRequire("aEmSo");
const $7cd03983df43e457$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer, extensionKey: extensionKey = '', extensionType: extensionType = '', fireAnalyticsEvent: fireAnalyticsEvent })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                if ((0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
                    action: (0, $3LeME.ACTION).CHANGE_ACTIVE,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
                    attributes: {
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                });
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reorderChildren (_fromIndex, _toIndex) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer,
        extensionKey,
        extensionType,
        fireAnalyticsEvent
    ]);
};

});

parcelRegister("ehFFs", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $1c85581f079eff11$export$e55394818db35473);

var $fc4bM = parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");

var $iVHNS = parcelRequire("iVHNS");

var $kMctD = parcelRequire("kMctD");

var $8oPL3 = parcelRequire("8oPL3");

var $aEmSo = parcelRequire("aEmSo");
const $1c85581f079eff11$var$getExtensionHandlerNode = (extensionHandler)=>{
    return ({ node: node, doc: doc, actions: actions })=>{
        return extensionHandler(node, doc, actions);
    };
};
const $1c85581f079eff11$export$e55394818db35473 = ({ extensionHandlers: extensionHandlers, extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>(0, $jiju3.default)((0, $iVHNS.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState();
    const providerPromise = (0, $kMctD.useProvider)('extensionProvider');
    const ExtensionHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        const extensionHandler = extensionHandlers && extensionHandlers[extensionType] && (0, $8oPL3.getExtensionRenderer)(extensionHandlers[extensionType]);
        if (extensionHandler) return $1c85581f079eff11$var$getExtensionHandlerNode(extensionHandler);
        return null;
    }, [
        extensionHandlers,
        extensionType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $iVHNS.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const ExtensionProviderNode = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (ExtensionHandlerNode && (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return {
            extensionContext: {
                NodeRenderer: ExtensionHandlerNode,
                privateProps: {
                    __allowBodiedOverride: true
                }
            },
            loading: false
        };
        if (!provider || !ExtensionProviderNode || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: ExtensionProviderNode,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        ExtensionHandlerNode,
        provider,
        ExtensionProviderNode,
        privateProps
    ]);
};

});
parcelRegister("kMctD", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $9711d48149c6c3db$export$617c134b25cc4265);
$parcel$export(module.exports, "useProviderFactory", () => $9711d48149c6c3db$export$a3af4b6980aa23b5);
$parcel$export(module.exports, "useProvider", () => $9711d48149c6c3db$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $9711d48149c6c3db$export$6fde1d0d81db98e1);

var $fc4bM = parcelRequire("fc4bM");

var $lSYBN = parcelRequire("lSYBN");
const $9711d48149c6c3db$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(new (0, $lSYBN.default)());
const $9711d48149c6c3db$export$617c134b25cc4265 = $9711d48149c6c3db$var$ProviderFactoryContext.Provider;
const $9711d48149c6c3db$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($9711d48149c6c3db$var$ProviderFactoryContext);
const $9711d48149c6c3db$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState();
    const providerFactory = $9711d48149c6c3db$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $9711d48149c6c3db$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState();
    const providerFactory = $9711d48149c6c3db$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});



parcelRegister("1mOhI", function(module, exports) {
$parcel$export(module.exports, "default", () => $19ce337455c22b3b$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $4rqGA = parcelRequire("4rqGA");

var $1Gdi2 = parcelRequire("1Gdi2");

var $b3aXG = parcelRequire("b3aXG");

var $6wGgg = parcelRequire("6wGgg");

var $3k7qh = parcelRequire("3k7qh");
function $19ce337455c22b3b$export$2e2bcd8739ae039(props) {
    var _props$getContent;
    const extraProps = {};
    // Item count drives the marker column width, so losing it narrows the gutter by a digit.
    const itemsCount = (_props$getContent = props.getContent) === null || _props$getContent === void 0 || (_props$getContent = _props$getContent.call(props)) === null || _props$getContent === void 0 ? void 0 : _props$getContent.length;
    const itemCounterDigitsSize = (0, $6wGgg.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: itemsCount
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $1Gdi2.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $b3aXG.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4rqGA.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $3k7qh.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("1Gdi2", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $01b91662856d0d98$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $01b91662856d0d98$export$6d31fdb1d74cee3e);
const $01b91662856d0d98$export$bafd6beec0797f87 = 24;
var $01b91662856d0d98$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($01b91662856d0d98$var$CSS_VAR_NAMES || {});
const $01b91662856d0d98$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $01b91662856d0d98$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $01b91662856d0d98$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $01b91662856d0d98$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $01b91662856d0d98$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("b3aXG", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $81c5c8c25263a4ac$export$d445360e2a3c026b);
// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
const $81c5c8c25263a4ac$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};

});

parcelRegister("6wGgg", function(module, exports) {
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $dc8dcd550a04e26f$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $dc8dcd550a04e26f$export$320582fc14ba1e0f);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.

var $b3aXG = parcelRequire("b3aXG");




const $dc8dcd550a04e26f$export$8ef94ae42a3729bd = 1;
const $dc8dcd550a04e26f$export$cbefb5b89ef0719f = (orderedListNode)=>{
    var _orderedListNode$attr;
    const order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (0, $b3aXG.resolveOrder)(order) ?? $dc8dcd550a04e26f$export$8ef94ae42a3729bd;
};
const $dc8dcd550a04e26f$export$320582fc14ba1e0f = (options)=>{
    var _String;
    const order = (0, $b3aXG.resolveOrder)(options.order) ?? $dc8dcd550a04e26f$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split('.')) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};

});


parcelRegister("5c5ee", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f94435e2d873db5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $a6B77 = parcelRequire("a6B77");
function $2f94435e2d873db5$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline, plainTextFastPath: plainTextFastPath }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $3LM7S.jsx)("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $a6B77.default), {
            plainTextFastPath: plainTextFastPath,
            children: children
        })
    }));
}

});
parcelRegister("a6B77", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d74eeefb962c035$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
function $1d74eeefb962c035$export$b8eec8c96e98e4e7(children) {
    if (children == null || typeof children === 'boolean') return false;
    if (Array.isArray(children)) {
        for (const child of children){
            if ($1d74eeefb962c035$export$b8eec8c96e98e4e7(child)) return true;
        }
        return false;
    }
    return true;
}
function $1d74eeefb962c035$export$2e2bcd8739ae039(props) {
    const { children: children, plainTextFastPath: plainTextFastPath } = props;
    const isEmpty = plainTextFastPath ? !$1d74eeefb962c035$export$b8eec8c96e98e4e7(children) : (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children).length === 0;
    if (isEmpty) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("aEM32", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae8f40440f5f8da4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $ae8f40440f5f8da4$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {});
}

});

parcelRegister("bNgSZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d25febdac105f90$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gGiKk = parcelRequire("gGiKk");

var $bcN2K = parcelRequire("bcN2K");
function $5d25febdac105f90$export$2e2bcd8739ae039({ color: color, localId: localId, style: style, weight: weight } = {}) {
    if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_dividers_attributes')) return /*#__PURE__*/ (0, $3LM7S.jsx)("hr", {
        role: "presentation"
    });
    const paletteColor = color && ((0, $gGiKk.hexToEditorTextPaletteColor)(color) ?? color);
    const paletteStyle = paletteColor ? {
        '--custom-palette-color': paletteColor
    } : undefined;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("hr", {
        role: "presentation",
        "data-color": color || undefined,
        "data-local-id": localId || undefined,
        "data-style": style || undefined,
        "data-weight": weight ?? undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: paletteStyle
    });
}

});
parcelRegister("gGiKk", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $bd0ad79559f8177b$export$9c2f408d391feb93);
// This import will be stripped on build

var $3NBIB = parcelRequire("3NBIB");
function $bd0ad79559f8177b$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return normalizedHexColor ? $bd0ad79559f8177b$export$57fa5089caad992[normalizedHexColor] : undefined;
}
const $bd0ad79559f8177b$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)",
    // source for hex code was legacy token N800
    // lime
    /** lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** lime - medium */ ['#6A9A23']: "var(--ds-icon-accent-lime, #6A9A23)",
    /** lime - strong */ ['#4C6B1F']: "var(--ds-text-accent-lime, #4C6B1F)",
    // orange
    /** orange - light */ ['#FCE4A6']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** orange - medium */ ['#E06C00']: "var(--ds-icon-accent-orange, #E06C00)",
    /** orange - strong */ ['#9E4C00']: "var(--ds-text-accent-orange, #9E4C00)",
    // magenta
    /** magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** magenta - medium */ ['#CD519D']: "var(--ds-icon-accent-magenta, #CD519D)",
    /** magenta - strong */ ['#943D73']: "var(--ds-text-accent-magenta, #943D73)",
    // yellow
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? "var(--ds-border-accent-yellow, #B38600)" : "var(--ds-icon-accent-yellow, #B38600)";
    },
    /** yellow - strong */ ['#7F5F01']: "var(--ds-text-accent-yellow, #7F5F01)"
};

});


parcelRegister("2xxrU", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => $e4657fa43a37a610$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $e4657fa43a37a610$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $e4657fa43a37a610$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $k5JVX = parcelRequire("k5JVX");

var $1r7H5 = parcelRequire("1r7H5");

var $8aFCM = parcelRequire("8aFCM");

var $jd8X7 = parcelRequire("jd8X7");

var $bzCw0 = parcelRequire("bzCw0");

var $20eP6 = parcelRequire("20eP6");

var $vmDrV = parcelRequire("vmDrV");
var $58JKn = parcelRequire("58JKn");

var $jtrdr = parcelRequire("jtrdr");

var $kbJyy = parcelRequire("kbJyy");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $aGINe = parcelRequire("aGINe");

var $1G4dd = parcelRequire("1G4dd");

var $aCsLi = parcelRequire("aCsLi");

var $4A4UU = parcelRequire("4A4UU");

var $6FD1C = parcelRequire("6FD1C");

var $97Yng = parcelRequire("97Yng");

var $deviX = parcelRequire("deviX");

var $6bNTL = parcelRequire("6bNTL");

var $3P2Ol = parcelRequire("3P2Ol");

var $hhstU = parcelRequire("hhstU");

var $65PWi = parcelRequire("65PWi");
const $e4657fa43a37a610$var$stickyContainerStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%',
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $e4657fa43a37a610$export$eec82c0a93aa66d9 = (appearance)=>(0, $6FD1C.isFullWidthOrFullPageAppearance)(appearance) || (0, $6FD1C.isCommentAppearance)(appearance);
const $e4657fa43a37a610$export$bdb2dadcb04aad50 = (appearance)=>(0, $6FD1C.isFullWidthOrFullPageAppearance)(appearance) && (0, $kaRof.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $e4657fa43a37a610$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $20eP6.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $jtrdr.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $vmDrV.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $e4657fa43a37a610$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $e4657fa43a37a610$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $e4657fa43a37a610$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $e4657fa43a37a610$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $e4657fa43a37a610$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $e4657fa43a37a610$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $hhstU.TableHeader);
    return children.every((node)=>node.type === (0, $hhstU.TableHeader));
};
const $e4657fa43a37a610$export$940095e914312886 = (node, children)=>{
    return $e4657fa43a37a610$export$28daf78feed5098c(children) && node && node.firstChild && !$e4657fa43a37a610$export$42f5658c8e0092da(node.firstChild);
};
/**
 * Fake left/right borders rendered as direct children of TABLE_CONTAINER
 * (the non-scrolling parent of the horizontally scrolling TABLE_NODE_WRAPPER).
 *
 * The visible styling for these divs lives in `tableFakeBorderStyles`
 * (`renderer/src/ui/Renderer/RendererStyleContainer.tsx`), which is applied
 * when `isInsideSyncBlock` is true.
 */ const $e4657fa43a37a610$var$TableFakeBorders = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>/*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER,
                "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
                "data-testid": "table-left-border"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER,
                "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
                "data-testid": "table-right-border"
            })
        ]
    });
const $e4657fa43a37a610$export$c8a6e9aeff774364 = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const { nestedRendererType: nestedRendererType } = (0, $1G4dd.useRendererContext)();
    const isInsideOfRefSyncBlock = nestedRendererType === 'syncedBlock';
    if (!isInsideOfRefSyncBlock) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)($e4657fa43a37a610$var$TableFakeBorders, {
        isNumberColumnEnabled: isNumberColumnEnabled
    });
};
class $e4657fa43a37a610$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    /**
   * Checks if this table is inside a nested renderer (e.g. Include Page macro)
   * by looking for multiple .ak-renderer-document ancestors in the DOM.
   * The result is cached since a table's position in the DOM tree is stable after mount.
   */ isInsideNestedRenderer() {
        if (this._isInsideNestedRenderer !== null) return this._isInsideNestedRenderer;
        if (!this.containerRef) return false;
        let docAncestorCount = 0;
        let el = this.containerRef.parentElement;
        while(el){
            if (el.classList.contains((0, $aGINe.RendererCssClassName).DOCUMENT)) {
                docAncestorCount++;
                if (docAncestorCount >= 2) {
                    this._isInsideNestedRenderer = true;
                    return true;
                }
            }
            el = el.parentElement;
        }
        this._isInsideNestedRenderer = false;
        return false;
    }
    /**
   * Checks if this table is inside a table cell in the DOM. The result is cached
   * since a table's position in the DOM tree is stable after mount.
   */ isInsideTableCell() {
        if (this._isInsideTableCell !== null) return this._isInsideTableCell;
        if (!this.containerRef) return false;
        this._isInsideTableCell = Boolean(this.containerRef.closest('td, th'));
        return this._isInsideTableCell;
    }
    isInsideTableContext() {
        return Boolean(this.props.isInsideOfTable || this.isInsideTableCell());
    }
    /**
   * For tables inside nested renderers (e.g. Include Page macro), the parent
   * renderer's CSS override forces width:100%!important and left:0!important
   * which overrides the inline styles set by this component. Using
   * style.setProperty with 'important' priority on inline styles beats
   * stylesheet !important rules per the CSS cascade.
   *
   * Tables that are nested inside another table need to remain constrained by
   * their table-cell context. Do not promote their width to inline !important,
   * otherwise nested tables rendered through macros such as Excerpt Include can
   * overflow and overlap adjacent cells.
   *
   * Top-level tables in nested renderers still preserve their saved width, but
   * are capped to their containing block so wide tables do not escape constrained
   * macro bodies such as Excerpt Include panels.
   *
   * Uses lastComputedStyle (populated during render) rather than reading from
   * element.style, because React may remove properties from the DOM when their
   * values transition to undefined between renders.
   *
   * `platform_nested_table_style_override_2` fixes a follow-up regression where a
   * NON-resized table inside an Excerpt macro (not Excerpt Include) on a
   * wide/full-width page shrinks to only show its first columns in the renderer.
   * Inside a nested renderer (a macro body) a non-resized table's computed width
   * is a default layout cap (760px/1800px, or a `cqw` length for full-page
   * appearances) taken from the outer renderer's width context. That value does
   * not match the macro's own box, so promoting it to inline `!important` makes
   * the table collapse. Such tables have no author-chosen size to preserve, so
   * under this gate we re-assert the parent stylesheet's intent (fill the box:
   * `width: 100%; left: 0`) with inline `!important`.
   *
   * Explicitly resized tables (`tableNode.attrs.width` set) are excluded and keep
   * the original PGXT-10226 behavior: their author-chosen width/left is promoted
   * verbatim so the Include Page macro does not stretch or indent them. The
   * table-cell short-circuit (PGXT-10294) above also still applies.
   */ applyNestedRendererTableFix() {
        var _this$props$tableNode;
        if (!this.containerRef) return;
        if (!this.isInsideNestedRenderer() || this.isInsideTableContext()) return;
        const { width: width, left: left, marginLeft: marginLeft } = this.lastComputedStyle;
        const style = this.containerRef.style;
        // A table is "explicitly resized" when the author set a width on the node.
        // Non-resized tables instead take a default layout cap (e.g. 760px/1800px)
        // derived from the outer renderer's appearance.
        const isExplicitlyResized = Boolean((_this$props$tableNode = this.props.tableNode) === null || _this$props$tableNode === void 0 ? void 0 : _this$props$tableNode.attrs.width);
        if (!isExplicitlyResized && (0, $dRkX9.fg)('platform_nested_table_style_override_2')) {
            // PGXT-10421: For a NON-resized table inside a nested renderer (e.g. an
            // Excerpt macro body), the computed width is a default layout cap
            // (760px/1800px, or a `cqw` length for full-page appearances) taken from
            // the *outer* renderer's width context. That value does not match the
            // macro's own box, so promoting it to inline `!important` makes the table
            // ignore the available space and collapse to its first columns.
            //
            // These tables have no author-chosen size to preserve, so re-assert the
            // parent stylesheet's intent — fill the available box (`width: 100%`) —
            // with inline `!important` priority so it survives React re-renders and
            // wins over the stylesheet rule that leaks into nested renderers.
            style.setProperty('width', '100%', 'important');
            style.setProperty('max-width', '100%', 'important');
            style.setProperty('left', '0', 'important');
            style.setProperty('margin-left', '0', 'important');
            return;
        }
        // PGXT-10226: An explicitly resized table inside a nested renderer (e.g.
        // Include Page macro) must keep its author-chosen width and position. The
        // parent stylesheet forces `width: 100% !important; left: 0 !important`,
        // which would stretch and indent it, so we promote the component's own
        // computed width/left with inline `!important` to win the cascade.
        style.setProperty('width', width || 'auto', 'important');
        style.setProperty('max-width', '100%', 'important');
        style.setProperty('left', left || 'auto', 'important');
        style.setProperty('margin-left', marginLeft || '0', 'important');
    }
    /**
   * Starts observing table dimensions and wires sticky header/scrollbar behavior after mount.
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            var _this$props$stickyHea;
            this.overflowParent = (0, $6bNTL.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $e4657fa43a37a610$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $65PWi.TableStickyScrollbar)(this.wrapperRef.current);
        this.applyNestedRendererTableFix();
    }
    /**
   * Updates sticky header wiring and scroll synchronization after prop or state changes.
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) {
            var _this$props$stickyHea2;
            this.overflowParent = (0, $6bNTL.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
        } else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        // React re-applies the style prop on every render, which overwrites the
        // !important priorities set at mount time. Re-apply after each update.
        this.applyNestedRendererTableFix();
    }
    /**
   * Calculates the top offset used when the sticky header is pinned to the table bottom.
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $jd8X7.tableMarginTop) - (0, $6bNTL.tableStickyPadding);
    }
    /**
   * Determines whether sticky header positioning should include the default scroll root offset.
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   * Resolves the top position for the sticky header based on the current sticky mode.
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   * Renders the table container, sticky header, table content, sticky scrollbar, and synced block borders.
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $014x6.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $aCsLi.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return `min(${0, $014x6.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return `min(${0, $014x6.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $k5JVX.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $014x6.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $014x6.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $6FD1C.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $6FD1C.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $6FD1C.isMaxWidthAppearance)(rendererAppearance) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $k5JVX.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $6FD1C.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $6FD1C.isFullWidthAppearance)(rendererAppearance) || (0, $6FD1C.isMaxWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $6FD1C.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $014x6.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const isContentModeTable = (0, $bzCw0.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $deviX.isContentModeSupported)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
        });
        const style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        // Store computed style values for applyNestedRendererTableFix() to use.
        // Reading from props rather than the DOM ensures correctness when React
        // removes properties (transitions from set to undefined) between renders.
        this.lastComputedStyle = {
            width: typeof style.width === 'number' ? `${style.width}px` : style.width,
            left: style.left,
            marginLeft: style.marginLeft
        };
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
            children: /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.setContainerRef,
                style: style,
                children: [
                    $e4657fa43a37a610$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && !isContentModeTable && $e4657fa43a37a610$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6bNTL.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout,
                        "data-autosize": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.__autoSize,
                        "data-table-local-id": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId,
                        "data-table-width": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3P2Ol.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $e4657fa43a37a610$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}-view-page`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: $e4657fa43a37a610$var$stickyContainerStyles,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            style: {
                                width: '100%',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $e4657fa43a37a610$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)($e4657fa43a37a610$export$c8a6e9aeff774364, {
                        isNumberColumnEnabled: isNumberColumnEnabled
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.overflowParent = null, this.containerRef = null, this._isInsideNestedRenderer = null, this._isInsideTableCell = null, // Stores the last computed style values from render() for use by applyNestedRendererTableFix().
        // This avoids reading from the DOM which can be stale when React removes properties between renders.
        this.lastComputedStyle = {}, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, /**
   * Callback ref that captures the container DOM element and also forwards
   * to the handleRef prop from the overflow shadow HOC.
   */ this.setContainerRef = (el)=>{
            if (this.containerRef !== el) {
                this._isInsideNestedRenderer = null;
                this._isInsideTableCell = null;
            }
            this.containerRef = el;
            const { handleRef: handleRef } = this.props;
            if (typeof handleRef === 'function') handleRef(el);
            else if (handleRef && typeof handleRef === 'object') // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleRef.current = el;
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $6bNTL.tableStickyPadding);
            const tableTop = $e4657fa43a37a610$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $e4657fa43a37a610$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $e4657fa43a37a610$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
const $e4657fa43a37a610$var$getCellEdgePropsByCellOffset = (tableNode, isNumberColumnEnabled)=>{
    // The serializer uses the node attribute. Other callers can supply a different render prop.
    const useCachedEdges = (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_perf_patch') && Boolean(isNumberColumnEnabled) === Boolean(tableNode.attrs.isNumberColumnEnabled);
    const cached = useCachedEdges ? (0, $97Yng.getCachedTableEdges)(tableNode) : undefined;
    if (cached) return cached;
    const cellEdgePropsByCellOffset = new Map();
    const cellRightByCellOffset = new Map();
    const occupiedGrid = [];
    let tableWidth = 0;
    let cellOffset = 0;
    tableNode.forEach((rowNode, _rowOffset, rowIndex)=>{
        occupiedGrid[rowIndex] = occupiedGrid[rowIndex] ?? [];
        let columnIndex = 0;
        cellOffset += 1;
        rowNode.forEach((cellNode)=>{
            while(occupiedGrid[rowIndex][columnIndex])columnIndex += 1;
            const colspan = cellNode.attrs.colspan || 1;
            const rowspan = cellNode.attrs.rowspan || 1;
            const cellLeft = columnIndex;
            const cellRight = cellLeft + colspan;
            const cellTop = rowIndex;
            const cellBottom = cellTop + rowspan;
            for(let row = cellTop; row < cellBottom; row += 1){
                occupiedGrid[row] = occupiedGrid[row] ?? [];
                for(let column = cellLeft; column < cellRight; column += 1)occupiedGrid[row][column] = true;
            }
            tableWidth = Math.max(tableWidth, cellRight);
            cellRightByCellOffset.set(cellOffset, cellRight);
            cellEdgePropsByCellOffset.set(cellOffset, {
                reachesBottom: cellBottom >= tableNode.childCount,
                // With number column enabled, PM column 0 is not visually leftmost and must not get `data-reaches-left`.
                reachesLeft: cellLeft === 0 && !isNumberColumnEnabled,
                reachesRight: false,
                reachesTop: cellTop === 0
            });
            columnIndex = cellRight;
            cellOffset += cellNode.nodeSize;
        });
        cellOffset += 1;
    });
    cellRightByCellOffset.forEach((cellRight, currentCellOffset)=>{
        const edgeProps = cellEdgePropsByCellOffset.get(currentCellOffset);
        if (edgeProps) edgeProps.reachesRight = cellRight >= tableWidth;
    });
    if (useCachedEdges) (0, $97Yng.cacheTableEdges)(tableNode, cellEdgePropsByCellOffset);
    return cellEdgePropsByCellOffset;
};
const $e4657fa43a37a610$var$isRenderedTableCell = (element)=>{
    const { nodeType: nodeType } = element.props;
    return nodeType === 'tableCell' || nodeType === 'tableHeader' || element.type === (0, $hhstU.TableCell) || element.type === (0, $hhstU.TableHeader);
};
const $e4657fa43a37a610$var$addTableCellEdgePropsThroughWrappers = (rows, tableNode, isNumberColumnEnabled)=>{
    const useCachedEdges = (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_perf_patch');
    try {
        if (!tableNode) return rows;
        const cellEdgePropsByCellOffset = $e4657fa43a37a610$var$getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        let cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(rows, (row, rowIndex)=>{
            const rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            let cellIndex = 0;
            const addEdgePropsToRenderedCells = (element)=>{
                if ($e4657fa43a37a610$var$isRenderedTableCell(element)) {
                    const cellNode = rowNode.child(cellIndex);
                    const edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                    cellIndex += 1;
                    cellOffset += cellNode.nodeSize;
                    if (useCachedEdges) return (0, $97Yng.withTableCellEdgeProps)(element, edgeProps);
                    return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(element, edgeProps) : element;
                }
                const { children: children } = element.props;
                if (children === undefined) return element;
                const childrenWithEdgeProps = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child) ? addEdgePropsToRenderedCells(child) : child);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(element, undefined, childrenWithEdgeProps);
            };
            const rowWithEdgeProps = addEdgePropsToRenderedCells(row);
            if (cellIndex !== rowNode.childCount) throw new Error('Rendered table row does not match its document node');
            cellOffset += 1;
            return rowWithEdgeProps;
        });
    } catch  {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
class $e4657fa43a37a610$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    /**
   * Renders processed table children inside the table container.
   *
   * @example
   */ render() {
        const { allowColumnSorting: allowColumnSorting, allowFixedColumnWidthOption: allowFixedColumnWidthOption, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, children: children, columnWidths: columnWidths, disableTableOverflowShadow: disableTableOverflowShadow, handleRef: handleRef, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isNumberColumnEnabled: isNumberColumnEnabled, isPresentational: isPresentational, layout: layout, rendererAppearance: rendererAppearance, renderWidth: renderWidth, shadowClassNames: shadowClassNames, smartCardStorage: smartCardStorage, stickyHeaders: stickyHeaders, tabIndex: tabIndex, tableNode: tableNode } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children);
        const childrenWithTableEdgeProps = (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $e4657fa43a37a610$var$addTableCellEdgePropsThroughWrappers(childrenArray, tableNode, isNumberColumnEnabled) : childrenArray;
        const orderedChildren = (0, $kbJyy.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenWithTableEdgeProps);
        return /*#__PURE__*/ (0, $3LM7S.jsx)($e4657fa43a37a610$export$f2c3aea42b2a048f, {
            allowColumnSorting: allowColumnSorting,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
            allowTableAlignment: allowTableAlignment,
            allowTableResizing: allowTableResizing,
            columnWidths: columnWidths,
            disableTableOverflowShadow: disableTableOverflowShadow,
            handleRef: handleRef,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
            isInsideOfTable: isInsideOfTable,
            isNumberColumnEnabled: isNumberColumnEnabled,
            isPresentational: isPresentational,
            layout: layout,
            rendererAppearance: rendererAppearance,
            renderWidth: renderWidth,
            shadowClassNames: shadowClassNames,
            smartCardStorage: smartCardStorage,
            stickyHeaders: stickyHeaders,
            tabIndex: tabIndex,
            tableNode: tableNode,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $e4657fa43a37a610$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $58JKn.hasMergedCell)(tableNode)) return $e4657fa43a37a610$export$100baa0f10804e6e($e4657fa43a37a610$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $e4657fa43a37a610$export$28daf78feed5098c(rows);
            const lastRowIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.count(rows) - 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1,
                    isFirstRow: index === 0,
                    isLastRow: index === lastRowIndex
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e4657fa43a37a610$var$TableWithShadowsAndContainerStyles = (0, $1r7H5.default)($e4657fa43a37a610$export$827f89182557f335, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $e4657fa43a37a610$var$TableWithWidth = (props)=>{
    var _props$columnWidths;
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $1G4dd.useRendererContext)();
    const isInsideOfNestedRenderer = isTopLevelRenderer === false;
    const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce((total, val)=>total + val, 0)) || 0;
    if (colWidthsSum || props.allowTableResizing) return /*#__PURE__*/ (0, $3LM7S.jsx)($e4657fa43a37a610$var$TableWithShadowsAndContainerStyles, {
        ...props,
        isInsideOfNestedRenderer: isInsideOfNestedRenderer
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($e4657fa43a37a610$export$827f89182557f335, {
        ...props,
        isInsideOfNestedRenderer: isInsideOfNestedRenderer
    });
};
const $e4657fa43a37a610$var$_default_1 = (0, $4A4UU.withSmartCardStorage)($e4657fa43a37a610$var$TableWithWidth);
var $e4657fa43a37a610$export$2e2bcd8739ae039 = $e4657fa43a37a610$var$_default_1;

});
parcelRegister("k5JVX", function(module, exports) {
$parcel$export(module.exports, "layoutToWidth", () => $7b31758275b2af5f$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $7b31758275b2af5f$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $7b31758275b2af5f$export$3930799be057b305);

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $2DjPx = parcelRequire("2DjPx");

var $35HTp = parcelRequire("35HTp");

var $jd8X7 = parcelRequire("jd8X7");

var $9JwwP = parcelRequire("9JwwP");
const $7b31758275b2af5f$var$GRID_SIZE = 8;
const $7b31758275b2af5f$var$NESTED_DND_GUTTER_OFFSET = 8;
const $7b31758275b2af5f$var$NESTED_DND_MARGIN_OFFSET = 12;
const $7b31758275b2af5f$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $014x6.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $014x6.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $014x6.akEditorFullWidthLayoutWidth)
};
const $7b31758275b2af5f$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    var _contextPanelPluginKe, _contextPanelPluginKe2;
    if (!pos) return;
    const node = $7b31758275b2af5f$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $7b31758275b2af5f$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $014x6.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
                // margin between sections
                parentWidth -= ((0, $35HTp.LAYOUT_SECTION_MARGIN) + $7b31758275b2af5f$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= ((0, $35HTp.LAYOUT_COLUMN_PADDING) + $7b31758275b2af5f$var$NESTED_DND_GUTTER_OFFSET) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $2DjPx.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $2DjPx.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $7b31758275b2af5f$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $7b31758275b2af5f$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $7b31758275b2af5f$var$GRID_SIZE;
            // padding left
            parentWidth -= $7b31758275b2af5f$var$GRID_SIZE * 4 - $7b31758275b2af5f$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $jd8X7.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $7b31758275b2af5f$export$84f6ca4f6812e69a = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        state.schema.nodes.bodiedSyncBlock
    ]);
    return parent ? parent.node : null;
};
const $7b31758275b2af5f$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $014x6.akEditorGutterPaddingDynamic)() * 2 + (0, $014x6.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $014x6.akEditorFullWidthLayoutWidth)) : (0, $9JwwP.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $7b31758275b2af5f$export$3930799be057b305 = (node)=>{
    if (node !== null && node !== void 0 && node.attrs.width) return node.attrs.width;
    return $7b31758275b2af5f$export$9b77d38feba5446[node === null || node === void 0 ? void 0 : node.attrs.layout] || (0, $014x6.akEditorDefaultLayoutWidth);
};
const $7b31758275b2af5f$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $7b31758275b2af5f$export$3930799be057b305(node) - offset;
    return $7b31758275b2af5f$export$3930799be057b305(node);
};

});
parcelRegister("a4TQr", function(module, exports) {
$parcel$export(module.exports, "removeParentNodeOfType", () => $756598ba5bab59f7$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $756598ba5bab59f7$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $756598ba5bab59f7$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $756598ba5bab59f7$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $756598ba5bab59f7$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $756598ba5bab59f7$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $756598ba5bab59f7$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $756598ba5bab59f7$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $756598ba5bab59f7$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $756598ba5bab59f7$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $756598ba5bab59f7$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $756598ba5bab59f7$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $756598ba5bab59f7$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $756598ba5bab59f7$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $756598ba5bab59f7$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $756598ba5bab59f7$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $756598ba5bab59f7$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $756598ba5bab59f7$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $756598ba5bab59f7$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $756598ba5bab59f7$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $756598ba5bab59f7$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByAttr", () => $756598ba5bab59f7$export$a836476a7f9de5b4);
$parcel$export(module.exports, "findChildrenByType", () => $756598ba5bab59f7$export$96bb9476c7c69f39);
$parcel$export(module.exports, "findChildrenByMark", () => $756598ba5bab59f7$export$c01a9e7ec615e821);
$parcel$export(module.exports, "contains", () => $756598ba5bab59f7$export$2344b14b097df817);
// src/selection.ts

var $801jp = parcelRequire("801jp");

var $7H6Cr = parcelRequire("7H6Cr");
var $756598ba5bab59f7$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $756598ba5bab59f7$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $756598ba5bab59f7$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $756598ba5bab59f7$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $756598ba5bab59f7$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $756598ba5bab59f7$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $756598ba5bab59f7$export$7d6e4e6663186878 = (tr)=>{
    if ($756598ba5bab59f7$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $756598ba5bab59f7$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $756598ba5bab59f7$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($756598ba5bab59f7$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $7H6Cr.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $7H6Cr.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $756598ba5bab59f7$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $801jp.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $756598ba5bab59f7$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $801jp.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $756598ba5bab59f7$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $7H6Cr.Node) && node.type && node.type.spec.selectable);
var $756598ba5bab59f7$var$shouldSelectNode = (node)=>$756598ba5bab59f7$var$isSelectableNode(node) && node.type.isLeaf;
var $756598ba5bab59f7$var$setSelection = (node, pos, tr)=>{
    if ($756598ba5bab59f7$var$shouldSelectNode(node)) return tr.setSelection(new (0, $801jp.NodeSelection)(tr.doc.resolve(pos)));
    return $756598ba5bab59f7$export$1df6d14df6b0b758(pos)(tr);
};
var $756598ba5bab59f7$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $756598ba5bab59f7$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($756598ba5bab59f7$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $756598ba5bab59f7$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($756598ba5bab59f7$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $756598ba5bab59f7$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $756598ba5bab59f7$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $756598ba5bab59f7$var$setSelection(content, pos, tr);
            }
        }
        if ($756598ba5bab59f7$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $756598ba5bab59f7$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $756598ba5bab59f7$var$cloneTr($756598ba5bab59f7$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($756598ba5bab59f7$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $756598ba5bab59f7$var$cloneTr($756598ba5bab59f7$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $756598ba5bab59f7$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $756598ba5bab59f7$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $756598ba5bab59f7$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $756598ba5bab59f7$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$756598ba5bab59f7$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $756598ba5bab59f7$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $756598ba5bab59f7$var$cloneTr(tr.setSelection((0, $801jp.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $756598ba5bab59f7$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $756598ba5bab59f7$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $756598ba5bab59f7$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $756598ba5bab59f7$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $801jp.NodeSelection);
};
var $756598ba5bab59f7$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $756598ba5bab59f7$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $756598ba5bab59f7$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($756598ba5bab59f7$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $756598ba5bab59f7$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $756598ba5bab59f7$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $756598ba5bab59f7$var$cloneTr(tr);
        }
        return tr;
    };
var $756598ba5bab59f7$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $7H6Cr.Fragment) ? content : (0, $7H6Cr.Fragment).from(content));
};
var $756598ba5bab59f7$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $756598ba5bab59f7$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $756598ba5bab59f7$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $7H6Cr.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $7H6Cr.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $756598ba5bab59f7$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $756598ba5bab59f7$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $756598ba5bab59f7$export$fe09644e3bc6166b($from, predicate);
    };
var $756598ba5bab59f7$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $756598ba5bab59f7$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $756598ba5bab59f7$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $756598ba5bab59f7$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $756598ba5bab59f7$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$756598ba5bab59f7$export$dc159056ffdb4c76(predicate)(selection);
    };
var $756598ba5bab59f7$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $756598ba5bab59f7$export$dc159056ffdb4c76((node)=>$756598ba5bab59f7$var$equalNodeType(nodeType, node))(selection);
    };
var $756598ba5bab59f7$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $756598ba5bab59f7$export$fe09644e3bc6166b($pos, (node)=>$756598ba5bab59f7$var$equalNodeType(nodeType, node));
};
var $756598ba5bab59f7$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $756598ba5bab59f7$export$178ecaf80f45fdb6((node)=>$756598ba5bab59f7$var$equalNodeType(nodeType, node))(selection);
    };
var $756598ba5bab59f7$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $756598ba5bab59f7$export$8556d79fa8189214((node)=>$756598ba5bab59f7$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $756598ba5bab59f7$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($756598ba5bab59f7$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($756598ba5bab59f7$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $756598ba5bab59f7$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $801jp.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $756598ba5bab59f7$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $756598ba5bab59f7$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $756598ba5bab59f7$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $756598ba5bab59f7$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $756598ba5bab59f7$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $756598ba5bab59f7$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $756598ba5bab59f7$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $756598ba5bab59f7$export$ddc1620722e25671 = (node, descend = true)=>{
    return $756598ba5bab59f7$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $756598ba5bab59f7$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $756598ba5bab59f7$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $756598ba5bab59f7$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $756598ba5bab59f7$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $756598ba5bab59f7$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $756598ba5bab59f7$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $756598ba5bab59f7$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $756598ba5bab59f7$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $756598ba5bab59f7$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$756598ba5bab59f7$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("2DjPx", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $2c3568527f6232b0$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $2c3568527f6232b0$export$91624ec52c59c24c);
const $2c3568527f6232b0$export$f5ecdce4c60ff98b = 8;
const $2c3568527f6232b0$export$5ac5087fe1217160 = $2c3568527f6232b0$export$f5ecdce4c60ff98b * 2;
const $2c3568527f6232b0$export$91624ec52c59c24c = 12;

});

parcelRegister("35HTp", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $6a24e6addc3ea647$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $6a24e6addc3ea647$export$a1bb91aa2d5fcce8);
const $6a24e6addc3ea647$export$cd04f19842abff0 = 8;
const $6a24e6addc3ea647$export$a1bb91aa2d5fcce8 = $6a24e6addc3ea647$export$cd04f19842abff0 * 1.5;
const $6a24e6addc3ea647$export$e5ee675b2c7e739b = 50;

});

parcelRegister("jd8X7", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $5193f166b990540a$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableCellMinWidth", () => $5193f166b990540a$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $5193f166b990540a$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $5193f166b990540a$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $5193f166b990540a$export$e56b8ca552b280f6);
$parcel$export(module.exports, "tableControlsSpacing", () => $5193f166b990540a$export$880976487022eb5);
$parcel$export(module.exports, "tableSharedStyle", () => $5193f166b990540a$export$c2bf8eea75aa9302);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");

var $gsX8d = parcelRequire("gsX8d");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $dqFZv = parcelRequire("dqFZv");

var $t10OO = parcelRequire("t10OO");

var $7rkNI = parcelRequire("7rkNI");

var $8aFCM = parcelRequire("8aFCM");

function $5193f166b990540a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5193f166b990540a$export$808015ab1dd6897a = 24;
const $5193f166b990540a$export$afe1899c3eea9823 = 16;
const $5193f166b990540a$export$910bf0d22c3d10f2 = 14;
const $5193f166b990540a$export$a43e30915fab3ccf = 8;
const $5193f166b990540a$export$531f77930bf508de = 48;
const $5193f166b990540a$export$c60fae4049791eae = 140;
const $5193f166b990540a$export$72aad729077aa0fb = 1;
const $5193f166b990540a$export$e56b8ca552b280f6 = 8;
const $5193f166b990540a$export$bba39e724bc39451 = 6;
const $5193f166b990540a$export$e5ff276883773ffd = 8;
const $5193f166b990540a$export$880976487022eb5 = $5193f166b990540a$export$808015ab1dd6897a + $5193f166b990540a$export$e5ff276883773ffd - $5193f166b990540a$export$72aad729077aa0fb;
/* first block node has 0 top margin */ var $5193f166b990540a$var$_ref = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $5193f166b990540a$var$firstNodeWithNotMarginTop = ()=>$5193f166b990540a$var$_ref;
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * The style is mirrored in:
 * - packages/editor/renderer/src/ui/Renderer/RendererStyleContainer.tsx ( seems outdated )
 * - packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
 *
 * If you are updating this, please also update the above files.
 *
 * @deprecated This Emotion-based style function is being phased out in favor of Compiled CSS.
 * Any changes here MUST also be reflected in `EditorContentContainer-compiled.tsx`
 * (look for `tableSharedStyle`, `tableSharedStyle_with_*`, `tableSharedStyle_without_*` entries
 * in the `editorContentStyles` cssMap) to keep the shared styles consistent.
 */ const $5193f166b990540a$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $dqFZv.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $jctmk.css)((0, $7rkNI.tableCellBackgroundStyleOverride)(), " .", (0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Fake side borders are not needed when the rounded overlay owns the outer border. */
				.${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER},
				.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER} {
					display: none;
				}
					` : `.${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER},
			.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				left: 0;
			}
			.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true'] {
				left: ${(0, $014x6.akEditorTableNumberColumnWidth) - 1}px;
			}`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", (0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $014x6.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", (0, $8aFCM.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", (0, $8aFCM.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", (0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", (0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $dRkX9.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", (0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table,.", (0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Keep a transparent border so the collapsed border model reserves the same 1px slot
			   on the table edge; the ::after overlay draws the visible rounded border instead. */
			border: ${$5193f166b990540a$export$72aad729077aa0fb}px solid transparent;` : `border: ${$5193f166b990540a$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
			border-left-color: transparent;
			border-right-color: transparent;`, " table-layout:fixed;font-size:1em;width:100%;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `position: relative;

			/* Table-width outer-border owner for overflow-safe rounded corners. */
			&::after {
				content: '';
				position: absolute;
				inset: -0.5px;
				border: ${$5193f166b990540a$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				border-radius: ${"var(--ds-radius-xlarge, 12px)"};
				pointer-events: none;
				z-index: 1;
			}

			/* When content-visibility is applied to the table (see editor-plugin-table nodeview), the
			   implied \`contain: paint\` clips descendant painting to the table's border-box. The
			   overlay above sits at \`inset: -0.5px\` (half a pixel outside), so it would be shaved \u{2014}
			   most visibly along the bottom. Pull it flush to the edge so it paints inside the clip. */
			&[data-content-visibility]::after {
				inset: 0;
			}` : '', " &[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $5193f166b990540a$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;", (0, $3NBIB.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) ? `&[data-valign='middle'] {
								vertical-align: middle;
							}
							&[data-valign='bottom'] {
								vertical-align: bottom;
							}` : '', " border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $5193f166b990540a$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Let the wrapper overlay own the outer table perimeter.
				   data-reaches-* attributes are set by the TableCell node view. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top] {
					border-top-color: transparent;
				}

				> tbody > tr > th[data-reaches-left],
				> tbody > tr > td[data-reaches-left] {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-left]::after {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-bottom]::after,
				> tbody > tr > th[data-reaches-bottom]::after {
					border-bottom-color: transparent;
				}

				/* The rounded-table overlay owns transparent perimeter borders.
				   Paint edge cell backgrounds into that reserved border area so coloured
				   first/last rows do not show the page background through 1px seams. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top],
				> tbody > tr > th[data-reaches-bottom],
				> tbody > tr > td[data-reaches-bottom] {
					background-clip: border-box;
				}` : '', " th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $014x6.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $gsX8d.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $gsX8d.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* When the number column is enabled, the left visual edge belongs to the number column.
		   Remove the left border-radius and left border from the table's ::after overlay
		   so it doesn't double-up or round where the number column already provides that edge. */
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
			> .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table::after,
			> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table::after {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-left-color: transparent;
			}
		}` : '', ";");
};

});
parcelRegister("gsX8d", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $c0654d57e6b70543$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
const $c0654d57e6b70543$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $jctmk.css)();
};

});

parcelRegister("dqFZv", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $f1805366087f41d2$export$6c724a6ffa2dc3e1);

var $jiju3 = parcelRequire("jiju3");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$IE_EDGE_REGEX = /\sedg\//i;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$IE_EDGE2_REGEX = /edg([ea]|ios)/i;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$INTERNET_EXPLORER_REGEX = /msie|trident/i;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$MAC_REGEX = /Mac/;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$WINDOWS_REGEX = /Windows|Win\d+/i;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$IE_EDGE_VERSION_REGEX = /\sedg\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$IE_EDGE2_VERSION_REGEX = /edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$IE_VERSION_REGEX = /(?:msie |rv:)(\d+(\.?_?\d+)+)/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$GECKO_REGEX = /gecko\/\d/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$CHROME_REGEX = /Chrome\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$ANDROID_REGEX = /Android \d/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$APPLE_WEBKIT_REGEX = /AppleWebKit/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$MOBILE_REGEX = /Mobile\/\w+/;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$SAFARI_REGEX = /safari|applewebkit/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$SAFARI_VERSION_REGEX = /Version\/([0-9\._]+).*Safari/;
// eslint-disable-next-line require-unicode-regexp
const $f1805366087f41d2$var$WEBKIT_REGEX = /(apple)?webkit/i;
const $f1805366087f41d2$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $f1805366087f41d2$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $f1805366087f41d2$var$getSafeUserAgent = ()=>{
    var _window$navigator;
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
};
const $f1805366087f41d2$var$getSafePlatform = ()=>{
    var _window$navigator2;
    if (typeof window === 'undefined') return undefined;
    return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform;
};
const $f1805366087f41d2$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $f1805366087f41d2$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $f1805366087f41d2$export$6c724a6ffa2dc3e1 = (0, $jiju3.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $f1805366087f41d2$var$getSafeUserAgent();
    const platform = $f1805366087f41d2$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        const ieEdge = $f1805366087f41d2$var$IE_EDGE_REGEX.test(userAgent);
        const ieEdge2 = $f1805366087f41d2$var$IE_EDGE2_REGEX.test(userAgent);
        const internetExplorer = $f1805366087f41d2$var$INTERNET_EXPLORER_REGEX.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        result.mac = platform && $f1805366087f41d2$var$MAC_REGEX.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = $f1805366087f41d2$var$WINDOWS_REGEX.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($f1805366087f41d2$var$getFirstMatch($f1805366087f41d2$var$IE_EDGE_VERSION_REGEX, userAgent), 10) : ieEdge2 ? parseInt($f1805366087f41d2$var$getSecondMatch($f1805366087f41d2$var$IE_EDGE2_VERSION_REGEX, userAgent), 10) : parseInt($f1805366087f41d2$var$getFirstMatch($f1805366087f41d2$var$IE_VERSION_REGEX, userAgent), 10);
        result.gecko = !ie && $f1805366087f41d2$var$GECKO_REGEX.test(userAgent);
        result.gecko_version = parseInt((userAgent.match($f1805366087f41d2$var$FIREFOX_VERSION_REGEX) || [])[1], 10);
        result.chrome = !ie && $f1805366087f41d2$var$CHROME_REGEX.test(userAgent);
        result.chrome_version = parseInt((userAgent.match($f1805366087f41d2$var$CHROME_VERSION_REGEX) || [])[1], 10);
        result.android = $f1805366087f41d2$var$ANDROID_REGEX.test(userAgent);
        result.ios = !ie && $f1805366087f41d2$var$APPLE_WEBKIT_REGEX.test(userAgent) && $f1805366087f41d2$var$MOBILE_REGEX.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && $f1805366087f41d2$var$SAFARI_REGEX.test(userAgent);
        result.safari_version = parseInt((userAgent.match($f1805366087f41d2$var$SAFARI_VERSION_REGEX) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        result.webkit = $f1805366087f41d2$var$WEBKIT_REGEX.test(userAgent);
        result.supportsIntersectionObserver = $f1805366087f41d2$var$hasIntersectionObserver();
        result.supportsResizeObserver = $f1805366087f41d2$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("t10OO", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $41d0b8d4a03d126f$export$42659c26f026f6ea);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $41d0b8d4a03d126f$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("7rkNI", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $f3e346cc878780a4$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $8zFBi = parcelRequire("8zFBi");
const $f3e346cc878780a4$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $jctmk.css)((0, $8zFBi.mapBackgroundColors)());

});
parcelRegister("8zFBi", function(module, exports) {
$parcel$export(module.exports, "mapBackgroundColors", () => $56a6cf7500be4504$export$35c9e86e192acb85);

var $63Q5S = parcelRequire("63Q5S");

var $5j2ZG = parcelRequire("5j2ZG");
const $56a6cf7500be4504$export$35c9e86e192acb85 = ()=>{
    let cssString = '';
    (0, $63Q5S.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $5j2ZG.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};

});
parcelRegister("5j2ZG", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $6bfc74c6759f1ec1$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $6bfc74c6759f1ec1$export$a270511a0e7fd61a);
// This import will be stripped on build

var $bOuQQ = parcelRequire("bOuQQ");
function $6bfc74c6759f1ec1$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $6bfc74c6759f1ec1$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $6bfc74c6759f1ec1$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $6bfc74c6759f1ec1$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $6bfc74c6759f1ec1$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    /** blue - bold */ ['#ADCBFB']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.blue.subtler.hovered', fallback),
        token: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"
    },
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    /** teal - bold */ ['#B1E4F7']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.teal.subtler.hovered', fallback),
        token: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    /** green - bold */ ['#97EDC9']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.green.subtler.hovered', fallback),
        token: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)"
    },
    // lime
    /** lime - light */ ['#EFFFD6']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.lime.subtlest', fallback),
        token: "var(--ds-background-accent-lime-subtlest, #EFFFD6)"
    },
    /** lime - medium */ ['#D3F1A7']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.lime.subtler', fallback),
        token: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    /** lime - bold */ ['#BDE97C']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.lime.subtler.hovered', fallback),
        token: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    /** yellow - bold */ ['#EFDD4E']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.yellow.subtler.hovered', fallback),
        token: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"
    },
    // orange
    /** orange - light */ ['#FFF5DB']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.orange.subtlest', fallback),
        token: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    /** orange - medium */ ['#FCE4A6']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.orange.subtler', fallback),
        token: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    /** orange - bold */ ['#FBD779']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.orange.subtler.hovered', fallback),
        token: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)"
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    /** red - bold */ ['#FFB8B2']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.red.subtler.hovered', fallback),
        token: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"
    },
    // magenta
    /** magenta - light */ ['#FFECF8']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.magenta.subtlest', fallback),
        token: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    /** magenta - medium */ ['#FDD0EC']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.magenta.subtler', fallback),
        token: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    /** magenta - bold */ ['#FCB6E1']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.magenta.subtler.hovered', fallback),
        token: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    /** purple - bold */ ['#E3BDFA']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.purple.subtler.hovered', fallback),
        token: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    },
    /** gray - bold */ ['#B7B9BE']: {
        getValue: (fallback)=>(0, $bOuQQ.getTokenValue)('color.background.accent.gray.subtler.hovered', fallback),
        token: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"
    }
};

});
parcelRegister("bOuQQ", function(module, exports) {
$parcel$export(module.exports, "getTokenValue", () => $33c63069a205a040$export$37e2c47c7e49c28a);


var $eAbub = parcelRequire("eAbub");

var $3jCFs = parcelRequire("3jCFs");
function $33c63069a205a040$export$37e2c47c7e49c28a(tokenId, fallback = '') {
    let token = (0, $eAbub.default)[tokenId];
    let tokenValue = fallback;
    typeof $3jCFs;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $33c63069a205a040$export$2e2bcd8739ae039 = $33c63069a205a040$export$37e2c47c7e49c28a;

});
parcelRegister("eAbub", function(module, exports) {
$parcel$export(module.exports, "default", () => $19c7a800e5705039$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3554c5febd836a4b5be9a51b32c1bf4>>
 * @codegenCommand yarn build tokens
 */ const $19c7a800e5705039$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.form.message.enter': '--ds-form-message-enter',
    'motion.form.message.exit': '--ds-form-message-exit',
    'motion.iconography.enter.cycle.up': '--ds-iconography-enter-cycle-up',
    'motion.iconography.enter.fade': '--ds-iconography-enter-fade',
    'motion.iconography.exit.cycle.up': '--ds-iconography-exit-cycle-up',
    'motion.iconography.exit.fade': '--ds-iconography-exit-fade',
    'motion.input': '--ds-input',
    'motion.input.selection': '--ds-input-selection',
    'motion.input.toggle': '--ds-input-toggle',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'motion.tab': '--ds-tab',
    'motion.tab.indicator.enter.left': '--ds-tab-indicator-enter-left',
    'motion.tab.indicator.enter.right': '--ds-tab-indicator-enter-right',
    'motion.tab.indicator.exit.left': '--ds-tab-indicator-exit-left',
    'motion.tab.indicator.exit.right': '--ds-tab-indicator-exit-right',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.gap.large': '--ds-space-gap-large',
    'space.gap.medium': '--ds-space-gap-medium',
    'space.gap.small': '--ds-space-gap-small',
    'space.gap.xlarge': '--ds-space-gap-xlarge',
    'space.gap.xsmall': '--ds-space-gap-xsmall',
    'space.gap.xxlarge': '--ds-space-gap-xxlarge',
    'space.gap.xxsmall': '--ds-space-gap-xxsmall',
    'space.inset.3xlarge': '--ds-space-inset-3xlarge',
    'space.inset.large': '--ds-space-inset-large',
    'space.inset.medium': '--ds-space-inset-medium',
    'space.inset.small': '--ds-space-inset-small',
    'space.inset.xlarge': '--ds-space-inset-xlarge',
    'space.inset.xsmall': '--ds-space-inset-xsmall',
    'space.inset.xxlarge': '--ds-space-inset-xxlarge',
    'space.inset.xxsmall': '--ds-space-inset-xxsmall',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $19c7a800e5705039$export$2e2bcd8739ae039 = $19c7a800e5705039$var$tokens;

});





parcelRegister("8aFCM", function(module, exports) {
$parcel$export(module.exports, "TableSharedCssClassName", () => $636aa6d2f892a5d7$export$c096bca5477eb7ad);

var $63Q5S = parcelRequire("63Q5S");
const $636aa6d2f892a5d7$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $63Q5S.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $63Q5S.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $63Q5S.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $63Q5S.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $63Q5S.tablePrefixSelector)}-left-border`,
    TABLE_NATIVE_STICKY: `${(0, $63Q5S.tablePrefixSelector)}-row-native-sticky`,
    TABLE_STICKY_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $63Q5S.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $63Q5S.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $63Q5S.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $63Q5S.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $63Q5S.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_STICKY: `${(0, $63Q5S.tablePrefixSelector)}-sticky`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $63Q5S.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $63Q5S.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $63Q5S.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $63Q5S.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $63Q5S.tablePrefixSelector)}-resizer-container`,
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};

});


parcelRegister("9JwwP", function(module, exports) {
$parcel$export(module.exports, "breakoutConsts", () => $cd8208c3585b6461$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $cd8208c3585b6461$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $cd8208c3585b6461$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $cd8208c3585b6461$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $cd8208c3585b6461$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $cd8208c3585b6461$export$c377853ecdd53e5b);
$parcel$export(module.exports, "calcBreakoutWidthPx", () => $cd8208c3585b6461$export$586300c53bd298dd);

var $014x6 = parcelRequire("014x6");

var $hqVRH = parcelRequire("hqVRH");

var $iYGtj = parcelRequire("iYGtj");

var $g2vOy = parcelRequire("g2vOy");




const $cd8208c3585b6461$export$ead1fecec2ecf57c = {
    padding: (0, $014x6.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $014x6.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $014x6.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $014x6.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $014x6.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $hqVRH.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $iYGtj.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $cd8208c3585b6461$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $cd8208c3585b6461$export$ead1fecec2ecf57c.calcBreakoutWidth($cd8208c3585b6461$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $014x6.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $014x6.akEditorWideLayoutWidth;
        default:
            return $cd8208c3585b6461$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($cd8208c3585b6461$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $cd8208c3585b6461$export$86325001fe8f3adc = $cd8208c3585b6461$export$ead1fecec2ecf57c.calcWideWidth($cd8208c3585b6461$export$ead1fecec2ecf57c);
const $cd8208c3585b6461$export$5f4502874a28dfce = $cd8208c3585b6461$export$ead1fecec2ecf57c.calcBreakoutWidth($cd8208c3585b6461$export$ead1fecec2ecf57c);
const $cd8208c3585b6461$export$ccc0a02edddeed39 = $cd8208c3585b6461$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($cd8208c3585b6461$export$ead1fecec2ecf57c);
function $cd8208c3585b6461$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $cd8208c3585b6461$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $g2vOy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $014x6.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $014x6.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $cd8208c3585b6461$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $g2vOy.parsePx)($cd8208c3585b6461$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}

});
parcelRegister("hqVRH", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $9b19f8a99647d649$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $9b19f8a99647d649$export$a1a213d350ca51ca);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $g7pKS = parcelRequire("g7pKS");

var $014x6 = parcelRequire("014x6");

var $iYGtj = parcelRequire("iYGtj");
function $9b19f8a99647d649$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $9b19f8a99647d649$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $fc4bM.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $014x6.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $g7pKS.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $9b19f8a99647d649$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iYGtj.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $3LM7S.jsx)($9b19f8a99647d649$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
                    children: children
                })
            })
    });
}

});

parcelRegister("g2vOy", function(module, exports) {
$parcel$export(module.exports, "parsePx", () => $042ae445a67c25d1$export$b0eef8cd00b29d5c);
/**
 * Util for converting a css pixel size value to a number (of pixels).
 *
 * ie.
 * ```ts
 * const pixels = parsePx('10px')
 * //    ^$ const pixels: number
 * ```
 * * ```ts
 * const pixels = parsePx('10')
 * //    ^$ const pixels: number | undefined
 * ```
 */ // At time of writting prettier would strip the extend here.
// prettier-ignore
function $042ae445a67c25d1$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}

});



parcelRegister("bzCw0", function(module, exports) {
$parcel$export(module.exports, "isTableInContentMode", () => $37327da4e150b96b$export$90b9840b2d94b80a);

var $fx6My = parcelRequire("fx6My");
const $37327da4e150b96b$export$8c07f44cea64e3c7 = (tableNode)=>tableNode.attrs.width !== null || (0, $fx6My.hasTableColumnBeenResized)(tableNode);
const $37327da4e150b96b$export$90b9840b2d94b80a = ({ tableNode: tableNode, isSupported: isSupported, isTableNested: isTableNested })=>{
    if (!tableNode || isTableNested) return false;
    return isSupported && !$37327da4e150b96b$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};

});
parcelRegister("fx6My", function(module, exports) {
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $ab818ae551b0df7e$export$b44a013e4f554514);
const $ab818ae551b0df7e$export$b44a013e4f554514 = (tableNode)=>{
    const firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(let i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};

});


parcelRegister("20eP6", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $b1f84c58d50bcb3f$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 

var $l8sw8 = parcelRequire("l8sw8");

var $5U88h = parcelRequire("5U88h");

var $hZLY3 = parcelRequire("hZLY3");

var $b1f84c58d50bcb3f$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("l8sw8", function(module, exports) {
$parcel$export(module.exports, "ToolbarSize", () => $16406e6f0cebeb6b$export$ed55211407a9423);
var $16406e6f0cebeb6b$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});

});

parcelRegister("5U88h", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $ab797bd2ad19e2ed$export$501a79d885598191);
var $ab797bd2ad19e2ed$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});

parcelRegister("hZLY3", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsNext", () => $2f18ee4ef4986623$export$3f050002d3df641b);
var $2f18ee4ef4986623$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});

});


parcelRegister("vmDrV", function(module, exports) {
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a73cedff0edc55ca$export$69fbfaf01f2fd534);
function $a73cedff0edc55ca$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}

});

parcelRegister("58JKn", function(module, exports) {
$parcel$export(module.exports, "hasMergedCell", () => $fcebacf73a1b5122$export$f9d610bfbb78949b);
function $fcebacf73a1b5122$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}

});

parcelRegister("jtrdr", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $ddfbf7c242f27932$export$49215374a8bec29c);

var $20eP6 = parcelRequire("20eP6");

var $8bcik = parcelRequire("8bcik");
function $ddfbf7c242f27932$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $ddfbf7c242f27932$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $ddfbf7c242f27932$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            const maybeANumber = $ddfbf7c242f27932$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $ddfbf7c242f27932$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $ddfbf7c242f27932$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: (0, $8bcik.ContentType).LINK,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: (0, $8bcik.ContentType).NUMBER,
        value: normalizedText
    };
    return {
        type: (0, $8bcik.ContentType).TEXT,
        value: normalizedText ?? text
    };
}
function $ddfbf7c242f27932$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $ddfbf7c242f27932$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: (0, $8bcik.ContentType).LINK,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: (0, $8bcik.ContentType).LINK,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $ddfbf7c242f27932$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: (0, $8bcik.ContentType).STATUS,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: (0, $8bcik.ContentType).DATE,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: (0, $8bcik.ContentType).MENTION,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $ddfbf7c242f27932$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $ddfbf7c242f27932$export$49215374a8bec29c = (options, order = (0, $20eP6.SortOrder).ASC)=>{
    const normalizeTextParser = $ddfbf7c242f27932$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $ddfbf7c242f27932$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $ddfbf7c242f27932$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $ddfbf7c242f27932$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $20eP6.SortOrder).DESC ? -1 : 1) * $ddfbf7c242f27932$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $ddfbf7c242f27932$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type === (0, $8bcik.ContentType).TEXT && metaNodeB.type === (0, $8bcik.ContentType).NUMBER || metaNodeA.type === (0, $8bcik.ContentType).NUMBER && metaNodeB.type === (0, $8bcik.ContentType).TEXT) return $ddfbf7c242f27932$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $ddfbf7c242f27932$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("8bcik", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $de1b3ca7829cbef1$export$e2e108cbe2e4f865);
var $de1b3ca7829cbef1$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});

});


parcelRegister("kbJyy", function(module, exports) {
$parcel$export(module.exports, "compose", () => $a7a475075365d4bc$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $a7a475075365d4bc$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("1G4dd", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $91d2d6ff7bcf0cba$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $91d2d6ff7bcf0cba$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $fc4bM = parcelRequire("fc4bM");
const $91d2d6ff7bcf0cba$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext({});
const $91d2d6ff7bcf0cba$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($91d2d6ff7bcf0cba$var$RendererContext);
const $91d2d6ff7bcf0cba$export$ca5df47902194781 = $91d2d6ff7bcf0cba$var$RendererContext.Provider;

});

parcelRegister("aCsLi", function(module, exports) {
$parcel$export(module.exports, "FullPagePadding", () => $bd5c934a2ce1361d$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $bd5c934a2ce1361d$export$74b525449cc7cbd1);
const $bd5c934a2ce1361d$export$12fd658e5eef0d79 = 32;
const $bd5c934a2ce1361d$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

});

parcelRegister("4A4UU", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $eae0f944a0d1a968$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $eae0f944a0d1a968$export$65e2d5a272a382b0);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $eae0f944a0d1a968$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(new Map());
const $eae0f944a0d1a968$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)($eae0f944a0d1a968$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $eae0f944a0d1a968$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
        render() {
            return /*#__PURE__*/ (0, $3LM7S.jsx)($eae0f944a0d1a968$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $3LM7S.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("6FD1C", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $d1a9ead32be4b76e$export$c0112b8340d4924b);
$parcel$export(module.exports, "isMaxWidthAppearance", () => $d1a9ead32be4b76e$export$ab050440a1241762);
$parcel$export(module.exports, "isFullPageAppearance", () => $d1a9ead32be4b76e$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $d1a9ead32be4b76e$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $d1a9ead32be4b76e$export$33331a99fac775a1);
const $d1a9ead32be4b76e$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $d1a9ead32be4b76e$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $d1a9ead32be4b76e$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $d1a9ead32be4b76e$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $d1a9ead32be4b76e$export$33331a99fac775a1 = (appearance)=>$d1a9ead32be4b76e$export$a64737a81cde10b4(appearance) || $d1a9ead32be4b76e$export$c0112b8340d4924b(appearance) || $d1a9ead32be4b76e$export$ab050440a1241762(appearance);

});

parcelRegister("97Yng", function(module, exports) {
$parcel$export(module.exports, "getCachedTableEdges", () => $211972c78c87cb83$export$31d630246d855205);
$parcel$export(module.exports, "cacheTableEdges", () => $211972c78c87cb83$export$478493861e163fac);
$parcel$export(module.exports, "withTableCellEdgeProps", () => $211972c78c87cb83$export$bd1a340286df77f2);

var $fc4bM = parcelRequire("fc4bM");
// The table node includes the number-column setting. Cache only its edge data.
const $211972c78c87cb83$var$edgeCache = new WeakMap();
const $211972c78c87cb83$var$noEdges = {
    reachesTop: false,
    reachesBottom: false,
    reachesLeft: false,
    reachesRight: false
};
const $211972c78c87cb83$export$31d630246d855205 = (node)=>$211972c78c87cb83$var$edgeCache.get(node);
const $211972c78c87cb83$export$478493861e163fac = (node, edges)=>{
    // The existing geometry builder provides every cell; retain only the perimeter.
    for (const [offset, props] of edges)if (!props.reachesTop && !props.reachesBottom && !props.reachesLeft && !props.reachesRight) edges.delete(offset);
    $211972c78c87cb83$var$edgeCache.set(node, edges);
};
const $211972c78c87cb83$export$bd1a340286df77f2 = (element, edges = $211972c78c87cb83$var$noEdges)=>{
    const current = element.props;
    if (Boolean(current.reachesTop) === edges.reachesTop && Boolean(current.reachesBottom) === edges.reachesBottom && Boolean(current.reachesLeft) === edges.reachesLeft && Boolean(current.reachesRight) === edges.reachesRight) return element;
    // Also clears stale edges when a previously decorated element becomes an interior cell.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(element, edges);
};

});

parcelRegister("deviX", function(module, exports) {
$parcel$export(module.exports, "isContentModeSupported", () => $d8a671a0828fcffe$export$e217d2a535d6ae45);
const $d8a671a0828fcffe$export$e217d2a535d6ae45 = ({ allowTableResizing: allowTableResizing, rendererAppearance: rendererAppearance })=>{
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};

});

parcelRegister("6bNTL", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $37d0addf55480fbc$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $37d0addf55480fbc$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $37d0addf55480fbc$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $8aFCM = parcelRequire("8aFCM");

var $014x6 = parcelRequire("014x6");

var $aEmSo = parcelRequire("aEmSo");

var $4dB4Z = parcelRequire("4dB4Z");

var $3P2Ol = parcelRequire("3P2Ol");
function $37d0addf55480fbc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $37d0addf55480fbc$export$3de6413b528017ca = 8;
const $37d0addf55480fbc$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
const $37d0addf55480fbc$var$suppressExternalStickStyles = {
    name: "1hdnnda",
    styles: "&.fixed-table-div-custom-table-resizing[mode='stick']{background:var(--ds-surface, #FFFFFF);}"
};
const $37d0addf55480fbc$var$panelAwareStickyTableStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Override external renderer wrapper styles targeting div[mode='stick']
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        background: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface, #FFFFFF)"})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface, #FFFFFF)"})`
        }
    },
    borderTopColor: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface, #FFFFFF)"})`,
    background: `var(--ak-renderer-panel-bg-color, ${"var(--ds-surface-overlay, #FFFFFF)"})`
});
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $37d0addf55480fbc$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $jctmk.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$37d0addf55480fbc$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $37d0addf55480fbc$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $014x6.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $37d0addf55480fbc$var$fixedTableDivStaticStyles,
            $37d0addf55480fbc$var$modeSpecficStyles === null || $37d0addf55480fbc$var$modeSpecficStyles === void 0 ? void 0 : $37d0addf55480fbc$var$modeSpecficStyles[mode],
            (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $37d0addf55480fbc$var$suppressExternalStickStyles,
            (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && $37d0addf55480fbc$var$panelAwareStickyTableStyles
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $37d0addf55480fbc$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $jctmk.jsx)($37d0addf55480fbc$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $3P2Ol.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: true,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $4dB4Z.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $37d0addf55480fbc$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $37d0addf55480fbc$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $37d0addf55480fbc$export$e97bc6692974bd0b($37d0addf55480fbc$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("4dB4Z", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $8b2c9ade63eaacbd$export$40e12ce8e0a76b0c);

var $fc4bM = parcelRequire("fc4bM");
function $8b2c9ade63eaacbd$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, {
            children: $8b2c9ade63eaacbd$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, propsToInject);
    });
}

});

parcelRegister("3P2Ol", function(module, exports) {
$parcel$export(module.exports, "Table", () => $0d507155b2115c17$export$54ec01a60f47d33d);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $k5JVX = parcelRequire("k5JVX");

var $bzCw0 = parcelRequire("bzCw0");

var $014x6 = parcelRequire("014x6");

var $dRkX9 = parcelRequire("dRkX9");

var $dM6uz = parcelRequire("dM6uz");

var $deviX = parcelRequire("deviX");
const $0d507155b2115c17$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    var _tableNode$attrs;
    let tableWidth = tableNode ? (0, $k5JVX.getTableContainerWidth)(tableNode) : (0, $014x6.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) tableWidth = 'inherit';
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') tableColumnWidths = columnWidths && (0, $dM6uz.colWidthSum)(columnWidths) ? columnWidths : undefined;
    const tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
    const tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
    const isContentMode = (0, $bzCw0.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $deviX.isContentModeSupported)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("table", {
        ...(0, $dRkX9.fg)('platform_renderer_ispresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dM6uz.Colgroup), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("dM6uz", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $9c7976a6d48ece38$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $9c7976a6d48ece38$export$89efc2d0ceeaa030);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $k5JVX = parcelRequire("k5JVX");

var $jd8X7 = parcelRequire("jd8X7");

var $iYGtj = parcelRequire("iYGtj");

var $014x6 = parcelRequire("014x6");

var $1G4dd = parcelRequire("1G4dd");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $9c7976a6d48ece38$var$MAX_SCALING_PERCENT = 0.3;
const $9c7976a6d48ece38$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $9c7976a6d48ece38$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $9c7976a6d48ece38$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent, skipMinWidth: skipMinWidth })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        const scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $jd8X7.tableCellMinWidth));
    }
    const adjusted = columnWidth - (0, $jd8X7.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $014x6.akEditorTableLegacyCellMinWidth) : (0, $jd8X7.tableCellMinWidth));
};
const $9c7976a6d48ece38$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $014x6.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $014x6.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $9c7976a6d48ece38$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ const $9c7976a6d48ece38$var$getDataColumnWidth = (totalWidth, isNumberColumnEnabled)=>isNumberColumnEnabled ? totalWidth - (0, $014x6.akEditorTableNumberColumnWidth) : totalWidth;
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ const $9c7976a6d48ece38$var$scaleColumnsToWidth = (columnWidths, availableWidth)=>{
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    const scaleFactor = availableWidth / rawTotalWidth;
    const scaledWidths = columnWidths.map((colWidth)=>Math.max(Math.floor(colWidth * scaleFactor), (0, $jd8X7.tableCellMinWidth)));
    const totalScaled = scaledWidths.reduce((sum, w)=>sum + w, 0);
    const diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $jd8X7.tableCellMinWidth)) {
        for(let i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $jd8X7.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map((width)=>({
            width: `${width}px`
        }));
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true), we use getTableContainerWidth(tableNode) as the
 * reference — the width the editor saved, which already accounts for the parent cell's available
 * space (colwidth minus tableCellPadding * 2). This matches bodiedSyncBlock where isRendererNested=false,
 * so renderScaleDownColgroup uses getTableContainerWidth(tableNode). For syncBlock the nested
 * renderer has isRendererNested=true, which incorrectly overrides tableContainerWidth with renderWidth
 * (the full container), causing overflow by 2 * tableCellPadding (16px).
 */ const $9c7976a6d48ece38$var$renderSyncBlockColgroup = ({ isInsideOfSyncBlock: isInsideOfSyncBlock, isInsideOfTable: isInsideOfTable, tableNode: tableNode, columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidthProp, contextWidth: contextWidth })=>{
    if (!isInsideOfSyncBlock) return null;
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    if (isInsideOfTable) return null;
    // SSR / first client render before WidthObserver measures. Output % of original ADF
    // proportions so columns are stable — the CSS container query (100cqw) handles actual
    // scaling width. We key off renderWidthProp alone because WidthProvider initialises with
    // document.body.offsetWidth (non-zero on the client), so contextWidth > 0 even before
    // WidthObserver has measured the real container, which would skip this branch and produce
    // column widths scaled to the full viewport.
    if (renderWidthProp <= 0) {
        const fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $014x6.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map((colWidth)=>({
                width: `${colWidth / fullTableWidth * 100}%`
            }));
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    const effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    const availableWidth = $9c7976a6d48ece38$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    // Only scale down if the table is actually wider than the available space.
    // If the table fits, return original widths with the same tableCellBorderWidth (2px) adjustment
    // that renderScaleDownColgroup applies via fixColumnWidth's no-scale path.
    if (availableWidth >= rawTotalWidth) return columnWidths.map((colWidth)=>({
            width: `${Math.max(colWidth - (0, $jd8X7.tableCellBorderWidth), (0, $jd8X7.tableCellMinWidth))}px`
        }));
    // Cap scaling at MAX_SCALING_PERCENT (30%), matching renderScaleDownColgroup's calcScalePercent.
    //
    // Both `availableWidth` and `rawTotalWidth` are already in data-column space (number column
    // excluded via getDataColumnWidth), so `diffPercent = 1 - availableWidth / rawTotalWidth` is
    // equivalent to calcScalePercent's `numColumnScalePercent` path when isNumberColumnEnabled,
    // and to the `noNumColumnScalePercent` path otherwise. We express the cap as a target width
    // (clampedAvailableWidth) rather than a scale-down percentage, but the result is the same:
    // columns are scaled by at most MAX_SCALING_PERCENT (30%).
    const diffPercent = 1 - availableWidth / rawTotalWidth;
    const clampedAvailableWidth = diffPercent <= $9c7976a6d48ece38$var$MAX_SCALING_PERCENT ? availableWidth : Math.floor(rawTotalWidth * (1 - $9c7976a6d48ece38$var$MAX_SCALING_PERCENT));
    return $9c7976a6d48ece38$var$scaleColumnsToWidth(columnWidths, clampedAvailableWidth);
};
const $9c7976a6d48ece38$var$renderScaleDownColgroup = (props)=>{
    var _props$tableNode;
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, isInsideOfSyncBlock: isInsideOfSyncBlock } = props;
    const skipMinWidth = !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every((width)=>width === 0)) return [];
    const tableColumnResized = $9c7976a6d48ece38$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) || isRendererNested && !isNumberColumnEnabled ? renderWidth : (0, $k5JVX.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $014x6.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $9c7976a6d48ece38$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $014x6.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $014x6.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $jd8X7.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $jd8X7.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $014x6.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $014x6.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && ((_props$tableNode = props.tableNode) === null || _props$tableNode === void 0 ? void 0 : _props$tableNode.attrs.displayMode) === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $9c7976a6d48ece38$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $9c7976a6d48ece38$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $014x6.akEditorTableLegacyCellMinWidth) ? (0, $014x6.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) scaleDownPercent = $9c7976a6d48ece38$var$calcScalePercent({
        renderWidth: renderWidth,
        tableWidth: tableWidth,
        maxScale: maxScalingPercent,
        isNumberColumnEnabled: isNumberColumnEnabled
    });
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$9c7976a6d48ece38$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth);
        const sumFixedColumnWidths = $9c7976a6d48ece38$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $014x6.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $9c7976a6d48ece38$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $9c7976a6d48ece38$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer, nestedRendererType: nestedRendererType } = (0, $1G4dd.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const { width: contextWidth } = (0, $fc4bM.useContext)((0, $iYGtj.WidthContext));
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = props.allowFixedColumnWidthOption ?? false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    const isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    const colStyles = $9c7976a6d48ece38$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    }) ?? $9c7976a6d48ece38$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $3LM7S.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $014x6.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3LM7S.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});



parcelRegister("hhstU", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $9504a737fecdbf9f$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $9504a737fecdbf9f$export$1e4baea7053fc0e3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $lefJT = parcelRequire("lefJT");

var $63Q5S = parcelRequire("63Q5S");

var $3LeME = parcelRequire("3LeME");

var $jBiFR = parcelRequire("jBiFR");

var $20eP6 = parcelRequire("20eP6");

var $5j2ZG = parcelRequire("5j2ZG");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $anluN = parcelRequire("anluN");

var $a63R3 = parcelRequire("a63R3");

var $aGINe = parcelRequire("aGINe");

var $brSjT = parcelRequire("brSjT");
const $9504a737fecdbf9f$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $9504a737fecdbf9f$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $20eP6.SortOrder).NO_ORDER:
            return (0, $20eP6.SortOrder).ASC;
        case (0, $20eP6.SortOrder).ASC:
            return (0, $20eP6.SortOrder).DESC;
        case (0, $20eP6.SortOrder).DESC:
            return (0, $20eP6.SortOrder).NO_ORDER;
    }
    return (0, $20eP6.SortOrder).NO_ORDER;
};
const $9504a737fecdbf9f$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $brSjT.tableCellMessages);
    switch(currentSortOrder){
        case (0, $20eP6.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $20eP6.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $20eP6.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $9504a737fecdbf9f$var$getDataAttributes = (colwidth, background, cellEdgeProps, valign)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesTop) attrs['data-reaches-top'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesBottom) attrs['data-reaches-bottom'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesLeft) attrs['data-reaches-left'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesRight) attrs['data-reaches-right'] = true;
    }
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    if (valign && (0, $3NBIB.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) attrs['data-valign'] = valign;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9504a737fecdbf9f$var$cssVariablePattern = /^var\(--.*\)$/;
const $9504a737fecdbf9f$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode, valign: valign })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $5j2ZG.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $9504a737fecdbf9f$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $lefJT.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    if (valign && (0, $3NBIB.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) style.verticalAlign = valign;
    return style;
};
const $9504a737fecdbf9f$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort, reachesTop: reachesTop, reachesBottom: reachesBottom, reachesLeft: reachesLeft, reachesRight: reachesRight, valign: valign } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const backgroundHex = background === null || background === void 0 ? void 0 : background.toLowerCase();
        const colorName = backgroundHex ? (0, $63Q5S.tableBackgroundColorNameByHex).get(backgroundHex) : '';
        return /*#__PURE__*/ (0, $3LM7S.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $9504a737fecdbf9f$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode,
                valign: valign
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$9504a737fecdbf9f$var$getDataAttributes(colwidth, background, {
                reachesTop: reachesTop,
                reachesBottom: reachesBottom,
                reachesLeft: reachesLeft,
                reachesRight: reachesRight
            }, valign),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $9504a737fecdbf9f$var$TH = $9504a737fecdbf9f$var$getWithCellProps('th');
const $9504a737fecdbf9f$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $gpjDl.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $20eP6.SortOrder).NO_ORDER ? (0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $3LM7S.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $9504a737fecdbf9f$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                className: (0, $aGINe.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $3LM7S.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jBiFR.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$9504a737fecdbf9f$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $9504a737fecdbf9f$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $3LeME.ACTION).SORT_COLUMN,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $a63R3.PLATFORM).WEB,
                        mode: (0, $a63R3.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $3LeME.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $a63R3.PLATFORM).WEB,
                    mode: (0, $a63R3.MODE).RENDERER
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            });
        }
    };
};
const $9504a737fecdbf9f$export$f850895b287ef28e = $9504a737fecdbf9f$export$cfca40ca5c56a38e($9504a737fecdbf9f$var$TH);
const $9504a737fecdbf9f$var$TD = $9504a737fecdbf9f$var$getWithCellProps('td');
const $9504a737fecdbf9f$export$1e4baea7053fc0e3 = $9504a737fecdbf9f$var$TD;

});
parcelRegister("jBiFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7cf697e54e5307c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $aEmSo = parcelRequire("aEmSo");

var $bcTS3 = parcelRequire("bcTS3");

var $20eP6 = parcelRequire("20eP6");

var $81vYS = parcelRequire("81vYS");

var $3CcBL = parcelRequire("3CcBL");

var $8ZKj6 = parcelRequire("8ZKj6");

var $19j2V = parcelRequire("19j2V");

var $dKPNE = parcelRequire("dKPNE");
function $b7cf697e54e5307c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $b7cf697e54e5307c$var$buttonStyles = /*#__PURE__*/ (0, $jctmk.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;z-index:1;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $b7cf697e54e5307c$var$iconWrapperStyles = /*#__PURE__*/ (0, $jctmk.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", (0, $dKPNE.StatusClassNames).DESC, "{transform:rotate(-180deg);}&.", (0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $b7cf697e54e5307c$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $b7cf697e54e5307c$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $20eP6.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${(0, $dKPNE.StatusClassNames).SORTING_NOT_ALLOWED} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $20eP6.SortOrder).ASC:
            return `${(0, $dKPNE.StatusClassNames).ASC} ${activeStatusClass}`;
        case (0, $20eP6.SortOrder).DESC:
            return `${(0, $dKPNE.StatusClassNames).DESC} ${activeStatusClass}`;
        default:
            return `${(0, $dKPNE.StatusClassNames).NO_ORDER} ${activeStatusClass}`;
    }
};
const $b7cf697e54e5307c$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $19j2V.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $20eP6.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $20eP6.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $20eP6.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $b7cf697e54e5307c$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $8ZKj6.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $20eP6.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $20eP6.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $20eP6.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $b7cf697e54e5307c$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $20eP6.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $b7cf697e54e5307c$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $b7cf697e54e5307c$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
        delay: 0,
        content: content,
        position: "top",
        hasNewContentOnTriggerClick: true
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $b7cf697e54e5307c$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $3CcBL.NewSortingIcon), {
        sortOrdered: sortOrdered
    }) : /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $b7cf697e54e5307c$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b7cf697e54e5307c$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            $b7cf697e54e5307c$var$iconStyles
        ]
    }))));
};
const $b7cf697e54e5307c$var$_default_1 = (0, $fcCIH.default)($b7cf697e54e5307c$var$SortingIcon);
var $b7cf697e54e5307c$export$2e2bcd8739ae039 = $b7cf697e54e5307c$var$_default_1;

});
parcelRegister("81vYS", function(module, exports) {
$parcel$export(module.exports, "SORTABLE_COLUMN_ICON_CLASSNAME", () => $1af74e6e272c01ad$export$bd4f24d8b1e86b23);
const $1af74e6e272c01ad$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

});

parcelRegister("3CcBL", function(module, exports) {
$parcel$export(module.exports, "NewSortingIcon", () => $0b6e0d253c009e99$export$4be21af7f864512e);
/* NewSortingIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4jmqR = parcelRequire("4jmqR");

var $hSoIi = parcelRequire("hSoIi");

var $20eP6 = parcelRequire("20eP6");
const $0b6e0d253c009e99$var$newIconWrapperStyles = {
    base: "_v5642l60 _1bsb7vkz _4t3i7vkz _1e0c1txw _1bah1h6o _4cvr1h6o _8hrz1qre",
    inactive: "_tzy415iw"
};
const $0b6e0d253c009e99$export$4be21af7f864512e = ({ sortOrdered: sortOrdered })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            $0b6e0d253c009e99$var$newIconWrapperStyles.base,
            sortOrdered === (0, $20eP6.SortOrder).NO_ORDER && $0b6e0d253c009e99$var$newIconWrapperStyles.inactive
        ]),
        children: sortOrdered === (0, $20eP6.SortOrder).DESC ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jmqR))), {
            spacing: "none",
            label: ""
        }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hSoIi))), {
            spacing: "none",
            label: ""
        })
    });
};

});
parcelRegister("4jmqR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::982535952b0b997873182b9102c6defc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $323a565f08fa4ef1$var$_react = $323a565f08fa4ef1$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $323a565f08fa4ef1$var$_iconNew = $323a565f08fa4ef1$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $323a565f08fa4ef1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-ascending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $323a565f08fa4ef1$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $323a565f08fa4ef1$var$_react.default.createElement($323a565f08fa4ef1$var$_iconNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$323a565f08fa4ef1$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $323a565f08fa4ef1$var$_default = module.exports.default = $323a565f08fa4ef1$var$SortAscendingIcon;

});

parcelRegister("hSoIi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07f197be0bf4c2b3f61c32ad2572b521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d03aa663fab165dd$var$_react = $d03aa663fab165dd$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d03aa663fab165dd$var$_iconNew = $d03aa663fab165dd$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d03aa663fab165dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-descending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d03aa663fab165dd$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $d03aa663fab165dd$var$_react.default.createElement($d03aa663fab165dd$var$_iconNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$d03aa663fab165dd$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $d03aa663fab165dd$var$_default = module.exports.default = $d03aa663fab165dd$var$SortDescendingIcon;

});


parcelRegister("8ZKj6", function(module, exports) {
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $3c7f2834b4d6912e$export$f142573f51a67577);

var $8p5Cv = parcelRequire("8p5Cv");
const $3c7f2834b4d6912e$export$f142573f51a67577 = (0, $8p5Cv.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});

parcelRegister("19j2V", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $e2edeba5a88313de$export$458c50917513cd1a);

var $8p5Cv = parcelRequire("8p5Cv");
const $e2edeba5a88313de$export$458c50917513cd1a = (0, $8p5Cv.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from A to Z (ascending order).'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from Z to A (descending order).'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'Label shown on a table column header sort button to remove any active sorting and restore the default column order.'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'Warning message shown in a table column header when sorting cannot be applied because the table contains merged cells.'
    }
});

});

parcelRegister("dKPNE", function(module, exports) {
$parcel$export(module.exports, "StatusClassNames", () => $f4d6c42e31945e73$export$c3618f310f725028);
var $f4d6c42e31945e73$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});

});



parcelRegister("65PWi", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $89c9dfc91f86c18a$export$8c072780619cfc83);

var $8aFCM = parcelRequire("8aFCM");

var $dRkX9 = parcelRequire("dRkX9");
class $89c9dfc91f86c18a$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        var _this$wrapper$parentE, _this$wrapper$parentE2;
        if (!this.wrapper) return;
        const scrollbarContainers = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelectorAll(`.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $dRkX9.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers === null || scrollbarContainers === void 0 ? void 0 : scrollbarContainers.item(scrollbarContainers.length - 1) : (_this$wrapper$parentE2 = this.wrapper.parentElement) === null || _this$wrapper$parentE2 === void 0 ? void 0 : _this$wrapper$parentE2.querySelector(`.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        var _this$wrapper, _this$wrapper2, _this$wrapper3;
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $dRkX9.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = (_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.parentElement) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.getElementsByClassName((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        var _entry$rootBounds;
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        var _entry$rootBounds2;
        const sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});


parcelRegister("4fz3H", function(module, exports) {
$parcel$export(module.exports, "default", () => $275184579aaba9aa$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $20eP6 = parcelRequire("20eP6");

var $aGINe = parcelRequire("aGINe");
function $275184579aaba9aa$export$2e2bcd8739ae039({ allowColumnSorting: allowColumnSorting, children: children, index: index, innerRef: innerRef, isFirstRow: isFirstRow, isLastRow: isLastRow, isNumberColumnEnabled: isNumberColumnEnabled, onSorting: onSorting, tableOrderStatus: tableOrderStatus }) {
    const isHeaderRow = !index;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children);
    const cells = allowColumnSorting && isHeaderRow ? childrenArray.map((child, columnIndex)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, {
            columnIndex: columnIndex,
            onSorting: onSorting,
            sortOrdered: (tableOrderStatus === null || tableOrderStatus === void 0 ? void 0 : tableOrderStatus.columnIndex) === columnIndex ? tableOrderStatus.order : (0, $20eP6.SortOrder).NO_ORDER,
            isHeaderRow: isHeaderRow
        });
    }) : childrenArray;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("tr", {
        ref: innerRef,
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $3LM7S.jsx)("td", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $aGINe.RendererCssClassName).NUMBER_COLUMN,
                "data-reaches-left": true,
                "data-reaches-top": isFirstRow || undefined,
                "data-reaches-bottom": isLastRow || undefined,
                children: index
            }),
            cells
        ]
    });
}

});

parcelRegister("i7RMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaab68d4521b71ab$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $eaab68d4521b71ab$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("GMLmP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("iN4HG").then(()=>parcelRequire('evrAX'));

});

parcelRegister("5jFDz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1vJx4"),
    $9dnsd("e4Bdg")
]).then(()=>parcelRequire('cHsNl'));

});

parcelRegister("kfzfz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7AUd0").then(()=>parcelRequire('fiLCA'));

});

parcelRegister("j2OpD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1LIKk").then(()=>parcelRequire('gLCU5'));

});

parcelRegister("fnbXq", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bqTAA").then(()=>parcelRequire('8MJin'));

});

parcelRegister("e9yqP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("fHprD").then(()=>parcelRequire('77BGO'));

});

parcelRegister("35WyX", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("yc74z").then(()=>parcelRequire('6L0cO'));

});

parcelRegister("a2TPA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("h7Vlc").then(()=>parcelRequire('3zaZy'));

});

parcelRegister("ljl0j", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5nsCa"),
    $9dnsd("1HtFV")
]).then(()=>parcelRequire('dqNFx'));

});

parcelRegister("8GTe8", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5nsCa"),
    $9dnsd("jcaxl")
]).then(()=>parcelRequire('ijXhG'));

});

parcelRegister("kwd7i", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("lsa7j"),
    $9dnsd("67Pud"),
    $9dnsd("9xUCJ"),
    $9dnsd("4fx7d"),
    $9dnsd("hlB3R"),
    $9dnsd("k8cxe")
]).then(()=>parcelRequire('f2omO'));

});

parcelRegister("ieGZY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("lsa7j"),
    $9dnsd("67Pud"),
    $9dnsd("9xUCJ"),
    $9dnsd("4fx7d")
]).then(()=>parcelRequire('91Vfg'));

});

parcelRegister("1Lvhm", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("lsa7j"),
    $9dnsd("67Pud"),
    $9dnsd("9xUCJ"),
    $9dnsd("4fx7d"),
    $9dnsd("hlB3R")
]).then(()=>parcelRequire('gf8p8'));

});

parcelRegister("bV6Df", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("EiaEi"),
    $9dnsd("b1NYz"),
    $9dnsd("flroK"),
    $9dnsd("331MG")
]).then(()=>parcelRequire('d28FL'));

});

parcelRegister("8NwJS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("eGFvg").then(()=>parcelRequire('lPgAG'));

});

parcelRegister("a2VAt", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("5m7vv"),
    $9dnsd("EiaEi"),
    $9dnsd("b1NYz"),
    $9dnsd("flroK"),
    $9dnsd("iL4uN")
]).then(()=>parcelRequire('kwRMS'));

});

parcelRegister("8TPVZ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("jC90T").then(()=>parcelRequire('i8uwT'));

});

parcelRegister("jVsxL", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2aAs1"),
    $9dnsd("5Uz8z")
]).then(()=>parcelRequire('79GnG'));

});

parcelRegister("6JOKo", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bLb8A").then(()=>parcelRequire('hdikn'));

});

parcelRegister("cD0R4", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cmmyj").then(()=>parcelRequire('kPFub'));

});

parcelRegister("912OP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("510Ox").then(()=>parcelRequire('cyWd3'));

});



parcelRegister("lqFn6", function(module, exports) {
$parcel$export(module.exports, "RendererFunctionalComponent", () => $806137c2fbf1e968$export$c49fe2316038f3c2);
$parcel$export(module.exports, "Renderer", () => $806137c2fbf1e968$export$88530751e3977073);
$parcel$export(module.exports, "RendererWithAnalytics", () => $806137c2fbf1e968$export$af81ffb59b6ef0dd);
$parcel$export(module.exports, "default", () => $806137c2fbf1e968$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $eUgRu = parcelRequire("eUgRu");

var $b4w4S = parcelRequire("b4w4S");

var $38vAg = parcelRequire("38vAg");

var $hykpf = parcelRequire("hykpf");

var $3LeME = parcelRequire("3LeME");

var $hqVRH = parcelRequire("hqVRH");

var $dqFZv = parcelRequire("dqFZv");

var $bqKLc = parcelRequire("bqKLc");

var $7A6aW = parcelRequire("7A6aW");

var $6pkbD = parcelRequire("6pkbD");

var $8KhpP = parcelRequire("8KhpP");

var $2K76H = parcelRequire("2K76H");

var $lLgnB = parcelRequire("lLgnB");

var $kMctD = parcelRequire("kMctD");

var $lSYBN = parcelRequire("lSYBN");

var $8reIA = parcelRequire("8reIA");

var $eL7f2 = parcelRequire("eL7f2");

var $ik3vI = parcelRequire("ik3vI");

var $290lK = parcelRequire("290lK");

var $iYGtj = parcelRequire("iYGtj");

var $3HBqL = parcelRequire("3HBqL");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $78GVL = parcelRequire("78GVL");

var $a63R3 = parcelRequire("a63R3");

var $gV3Ti = parcelRequire("gV3Ti");

var $6Hdvp = parcelRequire("6Hdvp");

var $eFo2X = parcelRequire("eFo2X");

var $kVBv0 = parcelRequire("kVBv0");

var $1G4dd = parcelRequire("1G4dd");

var $9K4MK = parcelRequire("9K4MK");

var $5lVP5 = parcelRequire("5lVP5");

var $seKqV = parcelRequire("seKqV");

var $gRn2W = parcelRequire("gRn2W");

var $scK4d = parcelRequire("scK4d");

var $2bxGO = parcelRequire("2bxGO");

var $e9N5Z = parcelRequire("e9N5Z");

var $4A4UU = parcelRequire("4A4UU");

var $loW2K = parcelRequire("loW2K");

var $bcvZJ = parcelRequire("bcvZJ");

var $6lOA7 = parcelRequire("6lOA7");

var $czk7W = parcelRequire("czk7W");

var $5XiSC = parcelRequire("5XiSC");

var $kSttA = parcelRequire("kSttA");

var $79H3N = parcelRequire("79H3N");

var $iHiHa = parcelRequire("iHiHa");

var $4Hr4F = parcelRequire("4Hr4F");

var $aCsLi = parcelRequire("aCsLi");

var $cUUJH = parcelRequire("cUUJH");

var $1kas5 = parcelRequire("1kas5");

var $gZRzj = parcelRequire("gZRzj");
function $806137c2fbf1e968$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $806137c2fbf1e968$export$47b2879ca9bbf67a = 2000;
const $806137c2fbf1e968$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $806137c2fbf1e968$var$TABLE_INFO_TIMEOUT = 10000;
const $806137c2fbf1e968$var$RENDER_EVENT_SAMPLE_RATE = 0.1;
const $806137c2fbf1e968$var$packageName = undefined;
const $806137c2fbf1e968$var$packageVersion = undefined;
const $806137c2fbf1e968$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $806137c2fbf1e968$var$handleMouseTripleClickInTables = (event)=>{
    var _parentElement, _parentElement2;
    const browser = (0, $dqFZv.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $806137c2fbf1e968$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    var _props$eventHandlers;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $806137c2fbf1e968$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!((_props$eventHandlers = props.eventHandlers) !== null && _props$eventHandlers !== void 0 && _props$eventHandlers.onUnhandledClick)) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $9K4MK.findInTree)(targetElement, rendererWrapper, (0, $6lOA7.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $806137c2fbf1e968$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $fc4bM.useRef)(undefined);
    const providerFactory = (0, $fc4bM.useMemo)(()=>props.dataProviders || new (0, $lSYBN.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $1G4dd.useRendererContext)();
    const createRendererContext = (0, $fc4bM.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $6pkbD.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                nestedRendererType: // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType
            };
        }, [
        nestedRendererType
    ]);
    const fireAnalyticsEventOld = (0, $fc4bM.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $38vAg.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $fc4bM.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $38vAg.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $kaRof.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $fc4bM.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            isPerformanceModeActive: props.isPerformanceModeActive ?? false,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            hideExtensionKeysWhilePending: props.hideExtensionKeysWhilePending,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $iHiHa.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            headingIdPrefix: props.headingIdPrefix,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            showHeadingNumbers: props.showHeadingNumbers,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            mentionNodeDataProvider: props.mentionNodeDataProvider,
            emojiProviderLookupOrder: props.emojiProviderLookupOrder,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionPresetHeight: props.getExtensionPresetHeight,
            getExtensionHeight: props.getExtensionHeight,
            scheduleExtensionHeightRemoval: props.scheduleExtensionHeightRemoval,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $1kas5.useMemoFromPropsDerivative)((serializerProps)=>{
        var _props$createSerializ;
        return ((_props$createSerializ = props.createSerializer) === null || _props$createSerializ === void 0 ? void 0 : _props$createSerializ.call(props, serializerProps)) ?? new (0, $gV3Ti.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $fc4bM.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $fc4bM.useMemo)(()=>(0, $eUgRu.default)(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $fc4bM.useMemo)(()=>(0, $2K76H.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $fc4bM.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $8KhpP.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $fc4bM.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- anchor navigation uses document.getElementById for hash targets
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $3LeME.ACTION).VIEWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $a63R3.PLATFORM).WEB,
                    mode: (0, $a63R3.MODE).RENDERER
                },
                eventType: (0, $3LeME.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $fc4bM.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $b4w4S.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $fc4bM.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            if (Math.random() < $806137c2fbf1e968$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                action: (0, $3LeME.ACTION).STARTED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $a63R3.PLATFORM).WEB,
                    sampleRate: $806137c2fbf1e968$var$RENDER_EVENT_SAMPLE_RATE
                },
                eventType: (0, $3LeME.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $8KhpP.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $290lK.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $ik3vI.getAnalyticsEventSeverity)(duration, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) ?? $806137c2fbf1e968$export$47b2879ca9bbf67a, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) ?? $806137c2fbf1e968$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.enabled) === false;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const distortedDuration = renderedMeasurementDistortedDurationMonitor.distortedDuration;
                    const ttfb = (0, $lLgnB.getResponseEndTime)();
                    const nodes = (0, $czk7W.countNodes)(props.document);
                    // Always signal that the renderer has finished rendering, regardless of analytics
                    // sampling or TTR tracking config. This is a reliable, unsampled lifecycle hook
                    // (e.g. used to release a UFO load hold) and must not be coupled to the sampled
                    // `rendered` analytics event below, which only fires for a fraction of renders.
                    if (props.onRendered) props.onRendered({
                        duration: duration,
                        distortedDuration: distortedDuration,
                        nodes: nodes,
                        ttfb: ttfb
                    });
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $3LeME.ACTION).RENDERED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $a63R3.PLATFORM).WEB,
                                duration: duration,
                                distortedDuration: distortedDuration,
                                ttfb: ttfb,
                                nodes: nodes,
                                nestedRendererType: nestedRendererType,
                                severity: severity,
                                sampleRate: $806137c2fbf1e968$var$RENDER_EVENT_SAMPLE_RATE
                            },
                            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
                        };
                        if (Math.random() < $806137c2fbf1e968$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent(event);
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    var _props$innerRef;
                    const renderer = (_props$innerRef = props.innerRef) === null || _props$innerRef === void 0 || (_props$innerRef = _props$innerRef.current) === null || _props$innerRef === void 0 ? void 0 : _props$innerRef.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $loW2K.getWidthInfoPayload)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        const payloadHeight = (0, $loW2K.getHeightInfoPayload)(renderer);
                        if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $806137c2fbf1e968$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $fc4bM.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            isPerformanceModeActive: props.isPerformanceModeActive ?? false,
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone,
        props.isPerformanceModeActive
    ]);
    const isCollapsibleHeadingsEnabled = props.allowCollapsibleHeadings === true && [
        'full-page',
        'full-width',
        'max'
    ].includes(props.appearance || '') && rendererContext.isTopLevelRenderer && (0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings');
    (0, $scK4d.useScrollToBlock)(editorRef, props.document, props.scrollToBlock);
    const { allowNestedTables: allowNestedTables } = props;
    // Memoised so `renderDocument`'s validation memo can match by reference across re-renders.
    const validationOverrides = (0, $fc4bM.useMemo)(()=>{
        const schema = getSchema(props.schema, props.adfStage);
        return (0, $7A6aW.isPanelNestingTableSupported)(schema) ? {
            allowNestedTables: allowNestedTables,
            allowTableInPanel: true
        } : {
            allowNestedTables: allowNestedTables
        };
    }, [
        allowNestedTables,
        getSchema,
        props.schema,
        props.adfStage
    ]);
    // Invoking `onComplete` during render lets consumers set state on other components mid-render,
    // so the stat is parked here and delivered once the rendered document has been committed.
    // No dependency array: `renderDocument` produces a new stat on every render, so the callback
    // must run after every commit to keep its historical once-per-render cadence.
    const pendingOnCompleteStatRef = (0, $fc4bM.useRef)(null);
    const { onComplete: onComplete } = props;
    (0, $fc4bM.useEffect)(()=>{
        const stat = pendingOnCompleteStatRef.current;
        if (stat === null || !onComplete) return;
        pendingOnCompleteStatRef.current = null;
        onComplete(stat);
    });
    try {
        var _props$media;
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $kVBv0.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $iHiHa.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, validationOverrides);
        if (props.onComplete) pendingOnCompleteStatRef.current = stat;
        const rendererOutput = /*#__PURE__*/ (0, $jctmk.jsx)((0, $1G4dd.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $5lVP5.ActiveHeaderIdProvider), {
            value: (0, $eFo2X.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $78GVL.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4A4UU.Provider), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $kMctD.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $eFo2X.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$806137c2fbf1e968$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: (_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcvZJ.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $gRn2W.CollapsibleHeadingsProvider), {
            pmDocument: pmDoc,
            rendererRef: editorRef,
            isEnabled: isCollapsibleHeadingsEnabled
        }, result))))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $cUUJH.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $eFo2X.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$806137c2fbf1e968$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $8reIA.default), null));
    }
};
const $806137c2fbf1e968$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo($806137c2fbf1e968$export$c49fe2316038f3c2);
const $806137c2fbf1e968$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($806137c2fbf1e968$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $79H3N.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($806137c2fbf1e968$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $806137c2fbf1e968$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $seKqV.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $1G4dd.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $fc4bM.useContext)((0, $gZRzj.ValidationContext)) || {};
    return /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        allowNestedTables: allowNestedTables
    });
}
const $806137c2fbf1e968$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $hykpf.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $eL7f2.getAnalyticsAppearance)(props.appearance),
            packageName: $806137c2fbf1e968$var$packageName,
            packageVersion: $806137c2fbf1e968$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, $eUgRu.default)()
        }
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $3HBqL.WithCreateAnalyticsEvent), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5XiSC.ErrorBoundary), {
                component: (0, $3LeME.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $bqKLc.IntlErrorBoundary), null, /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $806137c2fbf1e968$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- telepointer span for collaborative presence
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $aCsLi.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(true);
    const { nestedRendererType: nestedRendererType } = (0, $1G4dd.useRendererContext)();
    (0, $fc4bM.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    var _mutation$addedNodes$, _mutation$removedNode;
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $aCsLi.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $aCsLi.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && ((_mutation$addedNodes$ = mutation.addedNodes[0]) === null || _mutation$addedNodes$ === void 0 ? void 0 : _mutation$addedNodes$.id) === (0, $aCsLi.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && ((_mutation$removedNode = mutation.removedNodes[0]) === null || _mutation$removedNode === void 0 ? void 0 : _mutation$removedNode.id) === (0, $aCsLi.TELEPOINTER_ID))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $aCsLi.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastElement === null || lastElement === void 0 || lastElement.appendChild(createTelepointer());
                            } else {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastChild === null || lastChild === void 0 || lastChild.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $jctmk.jsx)((0, $iYGtj.WidthProvider), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop -- legacy renderer wrapper appearance classes
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $hqVRH.BaseTheme), {
        baseFontSize: (0, $kSttA.getBaseFontSize)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $6Hdvp.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4Hr4F.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer) return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $806137c2fbf1e968$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles ? /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $806137c2fbf1e968$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $806137c2fbf1e968$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(null);
function $806137c2fbf1e968$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($806137c2fbf1e968$var$RootRendererContext);
    const actions = (0, $fc4bM.useContext)((0, $2bxGO.RendererContext));
    const includeLegacyContentAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $e9N5Z.IncludeLegacyContentAnnotationsContext));
    const rendererRef = (0, $fc4bM.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer.
    // Otherwise we are in the root renderer and set the doc to the current doc.
    const _doc = rootRendererContextValue ? rootRendererContextValue.doc : doc;
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent, includeLegacyContentAnnotations);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent,
        includeLegacyContentAnnotations
    ]);
    // Memoised so nested renderers don't re-render on every root renderer render
    // when the doc itself is unchanged.
    const rootRendererValue = (0, $fc4bM.useMemo)(()=>({
            doc: _doc
        }), [
        _doc
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$var$RootRendererContext.Provider, {
        value: rootRendererValue
    }, children);
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $806137c2fbf1e968$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $2bxGO.RendererActionsContext), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $seKqV.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $jctmk.jsx)($806137c2fbf1e968$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $806137c2fbf1e968$export$2e2bcd8739ae039 = $806137c2fbf1e968$var$RendererWithAnnotationSelection;

});
parcelRegister("bqKLc", function(module, exports) {
$parcel$export(module.exports, "IntlErrorBoundary", () => $6854ffca8c9e8427$export$7df0749115d18d19);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $8MaoS = parcelRequire("8MaoS");
const $6854ffca8c9e8427$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $6854ffca8c9e8427$var$isMissingIntlProviderInAncestryError = (err)=>{
    var _err$toString;
    return err === null || err === void 0 || (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
class $6854ffca8c9e8427$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($6854ffca8c9e8427$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8MaoS.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("7A6aW", function(module, exports) {
$parcel$export(module.exports, "isPanelNestingTableSupported", () => $a0ca5c58a76dce23$export$da873e3c90937d2a);

var $aEmSo = parcelRequire("aEmSo");
const $a0ca5c58a76dce23$export$da873e3c90937d2a = (schema)=>{
    var _panel_c1$contentMatc;
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    const panelC1CanContainTable = ((_panel_c1$contentMatc = panel_c1.contentMatch.matchType(table)) === null || _panel_c1$contentMatc === void 0 ? void 0 : _panel_c1$contentMatc.validEnd) === true;
    return panelC1CanContainTable && (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};

});

parcelRegister("6pkbD", function(module, exports) {
$parcel$export(module.exports, "normalizeFeatureFlags", () => $c763390b3007b3b3$export$f1485fc4974593c0);

var $h1ySl = parcelRequire("h1ySl");

var $gWPic = parcelRequire("gWPic");

var $9cqgq = parcelRequire("9cqgq");
const $c763390b3007b3b3$var$EMPTY = {};
function $c763390b3007b3b3$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $c763390b3007b3b3$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $c763390b3007b3b3$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $c763390b3007b3b3$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($c763390b3007b3b3$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($h1ySl)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $c763390b3007b3b3$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($gWPic)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($h1ySl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($c763390b3007b3b3$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}

});
parcelRegister("h1ySl", function(module, exports) {

var $8lzVk = parcelRequire("8lzVk");

var $hgVKP = parcelRequire("hgVKP");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $c64d953a4c15e804$var$camelCase = $hgVKP(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $8lzVk(word) : word);
});
module.exports = $c64d953a4c15e804$var$camelCase;

});
parcelRegister("8lzVk", function(module, exports) {

var $2YOY3 = parcelRequire("2YOY3");

var $bO6Iq = parcelRequire("bO6Iq");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $613c269a64a5f814$var$capitalize(string) {
    return $bO6Iq($2YOY3(string).toLowerCase());
}
module.exports = $613c269a64a5f814$var$capitalize;

});
parcelRegister("bO6Iq", function(module, exports) {

var $esFWb = parcelRequire("esFWb");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $898992cc24a6dce3$var$upperFirst = $esFWb('toUpperCase');
module.exports = $898992cc24a6dce3$var$upperFirst;

});
parcelRegister("esFWb", function(module, exports) {

var $9PDU6 = parcelRequire("9PDU6");

var $lBM2b = parcelRequire("lBM2b");

var $f31iI = parcelRequire("f31iI");

var $2YOY3 = parcelRequire("2YOY3");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $a87436175863f41c$var$createCaseFirst(methodName) {
    return function(string) {
        string = $2YOY3(string);
        var strSymbols = $lBM2b(string) ? $f31iI(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $9PDU6(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $a87436175863f41c$var$createCaseFirst;

});
parcelRegister("9PDU6", function(module, exports) {

var $6pPhS = parcelRequire("6pPhS");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $7287d48b11da9a58$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $6pPhS(array, start, end);
}
module.exports = $7287d48b11da9a58$var$castSlice;

});

parcelRegister("lBM2b", function(module, exports) {
/** Used to compose unicode character classes. */ var $fbb2503f1373985e$var$rsAstralRange = '\\ud800-\\udfff', $fbb2503f1373985e$var$rsComboMarksRange = '\\u0300-\\u036f', $fbb2503f1373985e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $fbb2503f1373985e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $fbb2503f1373985e$var$rsComboRange = $fbb2503f1373985e$var$rsComboMarksRange + $fbb2503f1373985e$var$reComboHalfMarksRange + $fbb2503f1373985e$var$rsComboSymbolsRange, $fbb2503f1373985e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $fbb2503f1373985e$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $fbb2503f1373985e$var$reHasUnicode = RegExp('[' + $fbb2503f1373985e$var$rsZWJ + $fbb2503f1373985e$var$rsAstralRange + $fbb2503f1373985e$var$rsComboRange + $fbb2503f1373985e$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $fbb2503f1373985e$var$hasUnicode(string) {
    return $fbb2503f1373985e$var$reHasUnicode.test(string);
}
module.exports = $fbb2503f1373985e$var$hasUnicode;

});

parcelRegister("f31iI", function(module, exports) {

var $5huH8 = parcelRequire("5huH8");

var $lBM2b = parcelRequire("lBM2b");

var $fBdBq = parcelRequire("fBdBq");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $af482523b6b62e5d$var$stringToArray(string) {
    return $lBM2b(string) ? $fBdBq(string) : $5huH8(string);
}
module.exports = $af482523b6b62e5d$var$stringToArray;

});
parcelRegister("5huH8", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3d8659a1ec348855$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $3d8659a1ec348855$var$asciiToArray;

});

parcelRegister("fBdBq", function(module, exports) {
/** Used to compose unicode character classes. */ var $b5b4dce64341d451$var$rsAstralRange = '\\ud800-\\udfff', $b5b4dce64341d451$var$rsComboMarksRange = '\\u0300-\\u036f', $b5b4dce64341d451$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $b5b4dce64341d451$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $b5b4dce64341d451$var$rsComboRange = $b5b4dce64341d451$var$rsComboMarksRange + $b5b4dce64341d451$var$reComboHalfMarksRange + $b5b4dce64341d451$var$rsComboSymbolsRange, $b5b4dce64341d451$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $b5b4dce64341d451$var$rsAstral = '[' + $b5b4dce64341d451$var$rsAstralRange + ']', $b5b4dce64341d451$var$rsCombo = '[' + $b5b4dce64341d451$var$rsComboRange + ']', $b5b4dce64341d451$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $b5b4dce64341d451$var$rsModifier = '(?:' + $b5b4dce64341d451$var$rsCombo + '|' + $b5b4dce64341d451$var$rsFitz + ')', $b5b4dce64341d451$var$rsNonAstral = '[^' + $b5b4dce64341d451$var$rsAstralRange + ']', $b5b4dce64341d451$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $b5b4dce64341d451$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $b5b4dce64341d451$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $b5b4dce64341d451$var$reOptMod = $b5b4dce64341d451$var$rsModifier + '?', $b5b4dce64341d451$var$rsOptVar = '[' + $b5b4dce64341d451$var$rsVarRange + ']?', $b5b4dce64341d451$var$rsOptJoin = '(?:' + $b5b4dce64341d451$var$rsZWJ + '(?:' + [
    $b5b4dce64341d451$var$rsNonAstral,
    $b5b4dce64341d451$var$rsRegional,
    $b5b4dce64341d451$var$rsSurrPair
].join('|') + ')' + $b5b4dce64341d451$var$rsOptVar + $b5b4dce64341d451$var$reOptMod + ')*', $b5b4dce64341d451$var$rsSeq = $b5b4dce64341d451$var$rsOptVar + $b5b4dce64341d451$var$reOptMod + $b5b4dce64341d451$var$rsOptJoin, $b5b4dce64341d451$var$rsSymbol = '(?:' + [
    $b5b4dce64341d451$var$rsNonAstral + $b5b4dce64341d451$var$rsCombo + '?',
    $b5b4dce64341d451$var$rsCombo,
    $b5b4dce64341d451$var$rsRegional,
    $b5b4dce64341d451$var$rsSurrPair,
    $b5b4dce64341d451$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $b5b4dce64341d451$var$reUnicode = RegExp($b5b4dce64341d451$var$rsFitz + '(?=' + $b5b4dce64341d451$var$rsFitz + ')|' + $b5b4dce64341d451$var$rsSymbol + $b5b4dce64341d451$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b5b4dce64341d451$var$unicodeToArray(string) {
    return string.match($b5b4dce64341d451$var$reUnicode) || [];
}
module.exports = $b5b4dce64341d451$var$unicodeToArray;

});





parcelRegister("hgVKP", function(module, exports) {

var $5F0ID = parcelRequire("5F0ID");

var $7QrF2 = parcelRequire("7QrF2");

var $7ilJX = parcelRequire("7ilJX");
/** Used to compose unicode capture groups. */ var $c930bb17ac819db4$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $c930bb17ac819db4$var$reApos = RegExp($c930bb17ac819db4$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $c930bb17ac819db4$var$createCompounder(callback) {
    return function(string) {
        return $5F0ID($7ilJX($7QrF2(string).replace($c930bb17ac819db4$var$reApos, '')), callback, '');
    };
}
module.exports = $c930bb17ac819db4$var$createCompounder;

});
parcelRegister("5F0ID", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $41f156db9c65ca34$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $41f156db9c65ca34$var$arrayReduce;

});

parcelRegister("7QrF2", function(module, exports) {

var $63akv = parcelRequire("63akv");

var $2YOY3 = parcelRequire("2YOY3");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $01795613123a5060$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $01795613123a5060$var$rsComboMarksRange = '\\u0300-\\u036f', $01795613123a5060$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $01795613123a5060$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $01795613123a5060$var$rsComboRange = $01795613123a5060$var$rsComboMarksRange + $01795613123a5060$var$reComboHalfMarksRange + $01795613123a5060$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $01795613123a5060$var$rsCombo = '[' + $01795613123a5060$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $01795613123a5060$var$reComboMark = RegExp($01795613123a5060$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $01795613123a5060$var$deburr(string) {
    string = $2YOY3(string);
    return string && string.replace($01795613123a5060$var$reLatin, $63akv).replace($01795613123a5060$var$reComboMark, '');
}
module.exports = $01795613123a5060$var$deburr;

});
parcelRegister("63akv", function(module, exports) {

var $huS5w = parcelRequire("huS5w");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $01230446ee8a56fa$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $01230446ee8a56fa$var$deburrLetter = $huS5w($01230446ee8a56fa$var$deburredLetters);
module.exports = $01230446ee8a56fa$var$deburrLetter;

});
parcelRegister("huS5w", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $cbcf31c89cc76201$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $cbcf31c89cc76201$var$basePropertyOf;

});



parcelRegister("7ilJX", function(module, exports) {

var $4uYk0 = parcelRequire("4uYk0");

var $hRnvQ = parcelRequire("hRnvQ");

var $2YOY3 = parcelRequire("2YOY3");

var $ht96h = parcelRequire("ht96h");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $54fb140720c33369$var$words(string, pattern, guard) {
    string = $2YOY3(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $hRnvQ(string) ? $ht96h(string) : $4uYk0(string);
    return string.match(pattern) || [];
}
module.exports = $54fb140720c33369$var$words;

});
parcelRegister("4uYk0", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $3468c160e823eb8b$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3468c160e823eb8b$var$asciiWords(string) {
    return string.match($3468c160e823eb8b$var$reAsciiWord) || [];
}
module.exports = $3468c160e823eb8b$var$asciiWords;

});

parcelRegister("hRnvQ", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $d009a0020e6035d4$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $d009a0020e6035d4$var$hasUnicodeWord(string) {
    return $d009a0020e6035d4$var$reHasUnicodeWord.test(string);
}
module.exports = $d009a0020e6035d4$var$hasUnicodeWord;

});

parcelRegister("ht96h", function(module, exports) {
/** Used to compose unicode character classes. */ var $cb7c344031d77046$var$rsAstralRange = '\\ud800-\\udfff', $cb7c344031d77046$var$rsComboMarksRange = '\\u0300-\\u036f', $cb7c344031d77046$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $cb7c344031d77046$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $cb7c344031d77046$var$rsComboRange = $cb7c344031d77046$var$rsComboMarksRange + $cb7c344031d77046$var$reComboHalfMarksRange + $cb7c344031d77046$var$rsComboSymbolsRange, $cb7c344031d77046$var$rsDingbatRange = '\\u2700-\\u27bf', $cb7c344031d77046$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $cb7c344031d77046$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $cb7c344031d77046$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $cb7c344031d77046$var$rsPunctuationRange = '\\u2000-\\u206f', $cb7c344031d77046$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $cb7c344031d77046$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $cb7c344031d77046$var$rsVarRange = '\\ufe0e\\ufe0f', $cb7c344031d77046$var$rsBreakRange = $cb7c344031d77046$var$rsMathOpRange + $cb7c344031d77046$var$rsNonCharRange + $cb7c344031d77046$var$rsPunctuationRange + $cb7c344031d77046$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $cb7c344031d77046$var$rsApos = "['\u2019]", $cb7c344031d77046$var$rsBreak = '[' + $cb7c344031d77046$var$rsBreakRange + ']', $cb7c344031d77046$var$rsCombo = '[' + $cb7c344031d77046$var$rsComboRange + ']', $cb7c344031d77046$var$rsDigits = '\\d+', $cb7c344031d77046$var$rsDingbat = '[' + $cb7c344031d77046$var$rsDingbatRange + ']', $cb7c344031d77046$var$rsLower = '[' + $cb7c344031d77046$var$rsLowerRange + ']', $cb7c344031d77046$var$rsMisc = '[^' + $cb7c344031d77046$var$rsAstralRange + $cb7c344031d77046$var$rsBreakRange + $cb7c344031d77046$var$rsDigits + $cb7c344031d77046$var$rsDingbatRange + $cb7c344031d77046$var$rsLowerRange + $cb7c344031d77046$var$rsUpperRange + ']', $cb7c344031d77046$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $cb7c344031d77046$var$rsModifier = '(?:' + $cb7c344031d77046$var$rsCombo + '|' + $cb7c344031d77046$var$rsFitz + ')', $cb7c344031d77046$var$rsNonAstral = '[^' + $cb7c344031d77046$var$rsAstralRange + ']', $cb7c344031d77046$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $cb7c344031d77046$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $cb7c344031d77046$var$rsUpper = '[' + $cb7c344031d77046$var$rsUpperRange + ']', $cb7c344031d77046$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $cb7c344031d77046$var$rsMiscLower = '(?:' + $cb7c344031d77046$var$rsLower + '|' + $cb7c344031d77046$var$rsMisc + ')', $cb7c344031d77046$var$rsMiscUpper = '(?:' + $cb7c344031d77046$var$rsUpper + '|' + $cb7c344031d77046$var$rsMisc + ')', $cb7c344031d77046$var$rsOptContrLower = '(?:' + $cb7c344031d77046$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $cb7c344031d77046$var$rsOptContrUpper = '(?:' + $cb7c344031d77046$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $cb7c344031d77046$var$reOptMod = $cb7c344031d77046$var$rsModifier + '?', $cb7c344031d77046$var$rsOptVar = '[' + $cb7c344031d77046$var$rsVarRange + ']?', $cb7c344031d77046$var$rsOptJoin = '(?:' + $cb7c344031d77046$var$rsZWJ + '(?:' + [
    $cb7c344031d77046$var$rsNonAstral,
    $cb7c344031d77046$var$rsRegional,
    $cb7c344031d77046$var$rsSurrPair
].join('|') + ')' + $cb7c344031d77046$var$rsOptVar + $cb7c344031d77046$var$reOptMod + ')*', $cb7c344031d77046$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $cb7c344031d77046$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $cb7c344031d77046$var$rsSeq = $cb7c344031d77046$var$rsOptVar + $cb7c344031d77046$var$reOptMod + $cb7c344031d77046$var$rsOptJoin, $cb7c344031d77046$var$rsEmoji = '(?:' + [
    $cb7c344031d77046$var$rsDingbat,
    $cb7c344031d77046$var$rsRegional,
    $cb7c344031d77046$var$rsSurrPair
].join('|') + ')' + $cb7c344031d77046$var$rsSeq;
/** Used to match complex or compound words. */ var $cb7c344031d77046$var$reUnicodeWord = RegExp([
    $cb7c344031d77046$var$rsUpper + '?' + $cb7c344031d77046$var$rsLower + '+' + $cb7c344031d77046$var$rsOptContrLower + '(?=' + [
        $cb7c344031d77046$var$rsBreak,
        $cb7c344031d77046$var$rsUpper,
        '$'
    ].join('|') + ')',
    $cb7c344031d77046$var$rsMiscUpper + '+' + $cb7c344031d77046$var$rsOptContrUpper + '(?=' + [
        $cb7c344031d77046$var$rsBreak,
        $cb7c344031d77046$var$rsUpper + $cb7c344031d77046$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $cb7c344031d77046$var$rsUpper + '?' + $cb7c344031d77046$var$rsMiscLower + '+' + $cb7c344031d77046$var$rsOptContrLower,
    $cb7c344031d77046$var$rsUpper + '+' + $cb7c344031d77046$var$rsOptContrUpper,
    $cb7c344031d77046$var$rsOrdUpper,
    $cb7c344031d77046$var$rsOrdLower,
    $cb7c344031d77046$var$rsDigits,
    $cb7c344031d77046$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $cb7c344031d77046$var$unicodeWords(string) {
    return string.match($cb7c344031d77046$var$reUnicodeWord) || [];
}
module.exports = $cb7c344031d77046$var$unicodeWords;

});




parcelRegister("gWPic", function(module, exports) {

var $hgVKP = parcelRequire("hgVKP");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $c569d9c661901a06$var$kebabCase = $hgVKP(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $c569d9c661901a06$var$kebabCase;

});

parcelRegister("9cqgq", function(module, exports) {
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $8931e8ec57f5411d$export$6d018dd0f6cbebcb);
function $8931e8ec57f5411d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});


parcelRegister("8KhpP", function(module, exports) {
$parcel$export(module.exports, "startMeasure", () => $dd93b8080cce9b87$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $dd93b8080cce9b87$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $dd93b8080cce9b87$export$6f766653554dac02);

var $kluFa = parcelRequire("kluFa");
const $dd93b8080cce9b87$var$measureMap = new Map();
function $dd93b8080cce9b87$export$b62aa2130c86b59b(measureName) {
    if (!(0, $kluFa.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $dd93b8080cce9b87$var$measureMap.set(measureName, performance.now());
}
function $dd93b8080cce9b87$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $kluFa.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $dd93b8080cce9b87$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $dd93b8080cce9b87$export$6f766653554dac02(measureName);
    }
}
function $dd93b8080cce9b87$export$6f766653554dac02(measureName) {
    if (!(0, $kluFa.isPerformanceAPIAvailable)()) return;
    $dd93b8080cce9b87$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $dd93b8080cce9b87$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $kluFa.isPerformanceAPIAvailable)()) return false;
    return $dd93b8080cce9b87$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("kluFa", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $7bd27dcdfbe92dd5$export$b5717a625dd4a3eb);

var $5GMqo = parcelRequire("5GMqo");
let $7bd27dcdfbe92dd5$var$hasRequiredPerformanceAPIs;
function $7bd27dcdfbe92dd5$export$b5717a625dd4a3eb() {
    if ($7bd27dcdfbe92dd5$var$hasRequiredPerformanceAPIs === undefined) $7bd27dcdfbe92dd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $7bd27dcdfbe92dd5$var$hasRequiredPerformanceAPIs;
}
function $7bd27dcdfbe92dd5$export$4370ec0f52022f66() {
    return (0, $5GMqo.isPerformanceObserverAvailable)() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});
parcelRegister("5GMqo", function(module, exports) {
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $5a9ffd0ee1e88bdc$export$48995af1e77d8643);
function $5a9ffd0ee1e88bdc$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}

});



parcelRegister("2K76H", function(module, exports) {
$parcel$export(module.exports, "getDistortedDurationMonitor", () => $ee02b5b16b631eb0$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $ee02b5b16b631eb0$export$267ed650a5d21ae6);

var $kluFa = parcelRequire("kluFa");
const $ee02b5b16b631eb0$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $ee02b5b16b631eb0$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $kluFa.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $ee02b5b16b631eb0$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("lLgnB", function(module, exports) {
$parcel$export(module.exports, "getResponseEndTime", () => $503428de7e4ec909$export$92d097a1155bbe27);

var $kluFa = parcelRequire("kluFa");
function $503428de7e4ec909$export$92d097a1155bbe27() {
    if (!(0, $kluFa.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("eL7f2", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => $8d5ebabae29aacb3$export$be87849653b93e6b);

var $hykpf = parcelRequire("hykpf");
const $8d5ebabae29aacb3$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $hykpf.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $hykpf.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $hykpf.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $hykpf.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $hykpf.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $hykpf.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};

});

parcelRegister("ik3vI", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $ab7aaca0e33c40dd$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $ab7aaca0e33c40dd$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "analyticsEventKey", () => $ab7aaca0e33c40dd$export$288273ee3e3b6132);
$parcel$export(module.exports, "getBreakpointKey", () => $ab7aaca0e33c40dd$export$afdcbbd112676ca8);
$parcel$export(module.exports, "getAnalyticsAppearance", () => (parcelRequire("eL7f2")).getAnalyticsAppearance);

var $eL7f2 = parcelRequire("eL7f2");

var $gtI22 = parcelRequire("gtI22");

var $dxKaj = parcelRequire("dxKaj");
const $ab7aaca0e33c40dd$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${(0, $eL7f2.getAnalyticsAppearance)(editorAppearance)}` : '_unknown';
const $ab7aaca0e33c40dd$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return (0, $gtI22.SEVERITY).DEGRADED;
    if (duration > degradedThreshold) return (0, $gtI22.SEVERITY).BLOCKING;
    return (0, $gtI22.SEVERITY).NORMAL;
};
const $ab7aaca0e33c40dd$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $ab7aaca0e33c40dd$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $ab7aaca0e33c40dd$var$TABLE_BREAKPOINT_KEYS = Object.keys($ab7aaca0e33c40dd$var$EDITOR_BREAKPOINT_WIDTH);
const $ab7aaca0e33c40dd$export$afdcbbd112676ca8 = (width)=>{
    return $ab7aaca0e33c40dd$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $ab7aaca0e33c40dd$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};

});
parcelRegister("gtI22", function(module, exports) {
$parcel$export(module.exports, "SEVERITY", () => $08848b19831d7308$export$6a6bef12562cd865);
var $08848b19831d7308$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});

});

parcelRegister("dxKaj", function(module, exports) {
$parcel$export(module.exports, "findInsertLocation", () => $2131e668f5669744$export$d770b562ead089d8);

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $ev7OZ = parcelRequire("ev7OZ");
function $2131e668f5669744$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $801jp.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $ev7OZ.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $a4TQr.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}

});


parcelRegister("290lK", function(module, exports) {
$parcel$export(module.exports, "shouldForceTracking", () => $a721b260371aab2d$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $a721b260371aab2d$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("3HBqL", function(module, exports) {
$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $42ccd078b5b77d67$export$9ac3d19711324187);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");
const $42ccd078b5b77d67$export$9ac3d19711324187 = (0, $azARG.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gV3Ti", function(module, exports) {
$parcel$export(module.exports, "default", () => $c82b73bc79e8db7a$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2sezh = parcelRequire("2sezh");

var $ePYW1 = parcelRequire("ePYW1");

var $1jvzH = parcelRequire("1jvzH");

var $frezR = parcelRequire("frezR");

var $7H6Cr = parcelRequire("7H6Cr");

var $a4TQr = parcelRequire("a4TQr");

var $8EvCx = parcelRequire("8EvCx");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $lHdKv = parcelRequire("lHdKv");

var $9K4MK = parcelRequire("9K4MK");

var $dYypm = parcelRequire("dYypm");
var $7gUV5 = parcelRequire("7gUV5");

var $UmdFO = parcelRequire("UmdFO");
parcelRequire("dQGZg");
var $lIQWN = parcelRequire("lIQWN");
var $dQGZg = parcelRequire("dQGZg");

var $6dwyE = parcelRequire("6dwyE");

var $hZlCI = parcelRequire("hZlCI");

var $eSNUD = parcelRequire("eSNUD");

var $1Sher = parcelRequire("1Sher");

var $eFo2X = parcelRequire("eFo2X");

var $imO2b = parcelRequire("imO2b");

var $iGedO = parcelRequire("iGedO");
function $c82b73bc79e8db7a$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $7H6Cr.MarkType) && prev && prev.type instanceof (0, $7H6Cr.MarkType) && Array.isArray(prev.content) && (0, $frezR.isSameMark)(prev, markOrNode)) prev.content = $c82b73bc79e8db7a$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $c82b73bc79e8db7a$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        this.headingNumbers = [];
        this.headingNumberIndex = 0;
        /**
   * The reason we have this extra array here is because we need to generate the same unique
   * heading id for 2 different nodes: headers and expands (check the implementation of
   * `getUniqueHeadingId` for more info).
   *
   * We will eventually need to refactor the current approach to generate unique ids
   * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
   */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowDownloadCodeBlock = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.textFastPath = false;
        this.paragraphPropsFastPath = false;
        this.allowAnnotations = false;
        this.standaloneBackgroundColorMarks = [];
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem') && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.parentIsIncompleteTask) === true;
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $dQGZg.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>{
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            const serialized = marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                // Extension annotations are sibling anchors inside the stable extension shell.
                // Wrapping the extension here would remount its iframe whenever marks change.
                if (node.type.name === 'extension' && mark.type.name === 'annotation' && this.allowAnnotations && (0, $dRkX9.fg)('cc_maui_annotations_on_extensions')) return content;
                return this.renderMark((0, $7gUV5.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
            return (0, $lHdKv.withExpandBodyBlock)(node, currentPath, index, serialized);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $dYypm.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $dYypm.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $UmdFO.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        this.initStartPos = init.startPos || 1;
        this.startPos = init.startPos || 1;
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.headingIdPrefix = init.headingIdPrefix;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.showHeadingNumbers = init.showHeadingNumbers === true && (0, $bcN2K.isExperimentEnabled)('platform_editor_numbered_headings');
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowDownloadCodeBlock = init.allowDownloadCodeBlock;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.textFastPath = (0, $8EvCx.expVal)('platform_renderer_text_paragraph_fast_path', 'isEnabled', false);
        this.paragraphPropsFastPath = (0, $8EvCx.expVal)('platform_renderer_paragraph_props_fast_path', 'isEnabled', false);
        this.media = init.media;
        this.mentionNodeDataProvider = init.mentionNodeDataProvider;
        this.emojiProviderLookupOrder = init.emojiProviderLookupOrder;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.hideExtensionKeysWhilePending = init.hideExtensionKeysWhilePending;
        this.getExtensionPresetHeight = init.getExtensionPresetHeight;
        this.getExtensionHeight = init.getExtensionHeight;
        this.scheduleExtensionHeightRemoval = init.scheduleExtensionHeightRemoval;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
    resetState() {
        this.headingIds = [];
        this.headingNumbers = [];
        this.headingNumberIndex = 0;
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'paragraph':
                // Explicit paragraph overrides retain the full generic props contract.
                if (this.paragraphPropsFastPath && (!this.nodeComponents || !Object.prototype.hasOwnProperty.call(this.nodeComponents, 'paragraph'))) return this.getParagraphProps(node, path);
                return this.getProps(node, path);
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'mention':
                return this.getMentionProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
            case 'nestedExpand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            case 'panel_c1':
                if ((0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return this.getPanelProps(node);
                return this.getProps(node, path);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $lIQWN.DocWithSelectAllTrap) : (0, $lIQWN.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') {
            this.resetState();
            if (this.showHeadingNumbers) {
                const levels = [];
                fragment.descendants((node)=>{
                    if (node.type.name === 'heading') {
                        levels.push(Number(node.attrs.level));
                        return false;
                    }
                    return !node.isTextblock && !node.isLeaf;
                });
                this.headingNumbers = (0, $2sezh.getHeadingNumbers)(levels);
            }
        }
        return this.renderNode(target, props, key, (0, $lHdKv.mergeExpandBodyText)(this.getChildNodes(fragment, !(parentInfo !== null && parentInfo !== void 0 && parentInfo.path.length)).map((node, index)=>{
            if ((0, $dQGZg.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        })));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $1Sher.getStandaloneBackgroundColorMarks)(content));
        return $c82b73bc79e8db7a$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $dQGZg.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $7gUV5.toReact)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6dwyE.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                plainTextFastPath: this.textFastPath,
                children: mark.text
            }, textKey);
        }
        return (0, $iGedO.renderText)(mark.text, this.textHighlighter, mark.marks, startPos, this.textFastPath);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $3LM7S.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $3LM7S.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $hZlCI.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $hZlCI.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $hZlCI.insideTable)(path, node.type.schema);
        const stickyHeaders = !isInsideOfTable ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $ePYW1.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $dRkX9.fg)('platform_renderer_ispresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $hZlCI.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        var _this$media, _this$media2, _this$media3, _this$media4, _this$media5;
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>{
            var _n$type2;
            return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
        });
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $hZlCI.getNestedUnderNodes)(path, [
            'bodiedSyncBlock'
        ]);
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableSyncMediaCard,
            mediaViewerExtensions: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.mediaViewerExtensions,
            fallbackMediaNameFetcher: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.fallbackMediaNameFetcher,
            onMediaRenderEvent: (_this$media5 = this.media) === null || _this$media5 === void 0 ? void 0 : _this$media5.onMediaRenderEvent,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        var _this$getExtensionHei, _this$getExtensionPre;
        const extensionProps = {
            ...this.getProps(node, path),
            allowAnnotations: this.allowAnnotations,
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            extensionNode: node,
            extensionViewportSizes: this.extensionViewportSizes,
            hideExtensionKeysWhilePending: this.hideExtensionKeysWhilePending,
            nodeHeight: (_this$getExtensionHei = this.getExtensionHeight) === null || _this$getExtensionHei === void 0 ? void 0 : _this$getExtensionHei.call(this, node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
        if (!this.scheduleExtensionHeightRemoval) return extensionProps;
        return {
            ...extensionProps,
            nodePresetMinHeight: extensionProps.nodeHeight,
            nodePresetHeight: (_this$getExtensionPre = this.getExtensionPresetHeight) === null || _this$getExtensionPre === void 0 ? void 0 : _this$getExtensionPre.call(this, node),
            scheduleExtensionHeightRemoval: this.scheduleExtensionHeightRemoval
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            emojiProviderLookupOrder: (0, $dRkX9.fg)('platform_bitbucket_fix_shortname_and_ordering') ? this.emojiProviderLookupOrder : undefined,
            resourceConfig: this.emojiResourceConfig
        };
    }
    getMentionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            mentionNodeDataProvider: this.mentionNodeDataProvider
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $hZlCI.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        var _this$media6, _this$media7;
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: (_this$media6 = this.media) === null || _this$media6 === void 0 ? void 0 : _this$media6.enableDownloadButton,
            ssr: (_this$media7 = this.media) === null || _this$media7 === void 0 ? void 0 : _this$media7.ssr
        };
    }
    getMediaInlineProps(node) {
        var _this$media8, _this$media9;
        return {
            ...this.getProps(node),
            ssr: (_this$media8 = this.media) === null || _this$media8 === void 0 ? void 0 : _this$media8.ssr,
            fallbackMediaNameFetcher: (_this$media9 = this.media) === null || _this$media9 === void 0 ? void 0 : _this$media9.fallbackMediaNameFetcher
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getParagraphProps(node, path = []) {
        const startPos = this.startPos + path.length;
        // Keep traversal metadata for serializer subclasses without allocating unused content getters.
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            plainTextFastPath: this.textFastPath,
            nodeType: node.type.name,
            marks: node.marks,
            dataAttributes: {
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            plainTextFastPath: this.textFastPath,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            getContent: (0, $eSNUD.createContentGetter)(node.content),
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowDownloadCodeBlock: this.allowDownloadCodeBlock,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $eFo2X.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            headingId: this.getHeadingId(node, this.headingIds),
            headingNumber: this.showHeadingNumbers ? this.headingNumbers[this.headingNumberIndex++] : undefined,
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        // Expand is given the node so it can tell whether it opted into lazy body loading at all. The
        // text each block shows is attached to the block itself, by `withExpandBodyBlock`.
        if (!(0, $eFo2X.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            node: node
        };
        const nestedHeaderIds = (0, $a4TQr.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            node: node
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $9K4MK.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        const uniqueId = this.getUniqueHeadingId(nodeContent, headingIds);
        return this.headingIdPrefix ? `${this.headingIdPrefix}-${uniqueId}` : uniqueId;
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment, isTopLevel = true) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $dQGZg.mergeTextNodes)(children);
        if (this.shouldDisplayExtensionAsInline) (0, $imO2b.markBlockAsInline)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            isTopLevel: isTopLevel,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $1jvzH.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $c82b73bc79e8db7a$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
}

});
parcelRegister("2sezh", function(module, exports) {
$parcel$export(module.exports, "getHeadingNumbers", () => $fc3fbc2bbc7092b5$export$752de4a5fff9f402);
const $fc3fbc2bbc7092b5$var$MAX_HEADING_LEVEL = 6;
const $fc3fbc2bbc7092b5$export$dce4ebcd2cd38df4 = 'data-heading-number';
const $fc3fbc2bbc7092b5$export$752de4a5fff9f402 = (levels)=>{
    const counters = new Array($fc3fbc2bbc7092b5$var$MAX_HEADING_LEVEL).fill(0);
    return levels.map((rawLevel)=>{
        const level = Math.min(Math.max(Math.trunc(rawLevel) || 1, 1), $fc3fbc2bbc7092b5$var$MAX_HEADING_LEVEL);
        for(let index = 0; index < level - 1; index++)if (counters[index] === 0) counters[index] = 1;
        counters[level - 1] += 1;
        for(let index = level; index < $fc3fbc2bbc7092b5$var$MAX_HEADING_LEVEL; index++)counters[index] = 0;
        return counters.slice(0, level).join('.');
    });
};

});

parcelRegister("ePYW1", function(module, exports) {
$parcel$export(module.exports, "getColumnWidths", () => $7d121357be8d9937$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $7d121357be8d9937$export$98951d3cdcfd364b);



function $7d121357be8d9937$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $7d121357be8d9937$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}

});

parcelRegister("1jvzH", function(module, exports) {
$parcel$export(module.exports, "getMarksByOrder", () => $992ab6cc1a62644b$export$99a33ed044c278ae);
$parcel$export(module.exports, "getValidNode", () => $992ab6cc1a62644b$export$81b20b6c83a56bd);

var $dWftz = parcelRequire("dWftz");

var $9ISAz = parcelRequire("9ISAz");

var $39FD9 = parcelRequire("39FD9");

var $b4w4S = parcelRequire("b4w4S");

var $1FHzN = parcelRequire("1FHzN");

var $dRkX9 = parcelRequire("dRkX9");

var $k1dx5 = parcelRequire("k1dx5");

var $lDDJ6 = parcelRequire("lDDJ6");


const $992ab6cc1a62644b$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>(0, $lDDJ6.markOrder).indexOf(a.type.name) - (0, $lDDJ6.markOrder).indexOf(b.type.name));
};
const $992ab6cc1a62644b$export$fb80336a7e408cb3 = (doc, schema = (0, $b4w4S.defaultSchema), adfStage = 'final')=>{
    const node = $992ab6cc1a62644b$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $992ab6cc1a62644b$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $992ab6cc1a62644b$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $dWftz.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $992ab6cc1a62644b$export$fafd4f799ee68da0 = (content, schema = (0, $b4w4S.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$992ab6cc1a62644b$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $992ab6cc1a62644b$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $992ab6cc1a62644b$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $992ab6cc1a62644b$var$ANCHOR_LINK = /^#/;
const $992ab6cc1a62644b$var$flattenUnknownBlockTree = (node, schema = (0, $b4w4S.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($992ab6cc1a62644b$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$992ab6cc1a62644b$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $992ab6cc1a62644b$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $9ISAz.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $992ab6cc1a62644b$var$flattenUnknownBlockTree(node)
    };
};
const $992ab6cc1a62644b$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $992ab6cc1a62644b$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $992ab6cc1a62644b$export$81b20b6c83a56bd = (originalNode, schema = (0, $b4w4S.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $992ab6cc1a62644b$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $992ab6cc1a62644b$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $9ISAz.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $9ISAz.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $9ISAz.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $9ISAz.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $9ISAz.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $9ISAz.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $992ab6cc1a62644b$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $992ab6cc1a62644b$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $992ab6cc1a62644b$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                let localId;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                    localId = attrs.localId;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: '',
                            ...localId ? {
                                localId: localId
                            } : {}
                        },
                        ...(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $992ab6cc1a62644b$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $992ab6cc1a62644b$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $39FD9.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $1FHzN.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $1FHzN.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $1FHzN.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $1FHzN.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $1FHzN.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $1FHzN.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $992ab6cc1a62644b$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $1FHzN.generateUuid)()
                },
                marks: marks
            };
            return $992ab6cc1a62644b$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $1FHzN.generateUuid)()
                },
                marks: marks,
                content: content
            };
            return $992ab6cc1a62644b$export$b9908ef75cad1e0e(node);
    }
    return $992ab6cc1a62644b$export$b9908ef75cad1e0e(node);
};
const $992ab6cc1a62644b$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$992ab6cc1a62644b$var$RELATIVE_LINK.test(linkHref) && !$992ab6cc1a62644b$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $9ISAz.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ((0, $k1dx5.isSubSupType)(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $992ab6cc1a62644b$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $992ab6cc1a62644b$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("dWftz", function(module, exports) {
$parcel$export(module.exports, "inlineNodes", () => $227b8427ab0364b1$export$b1f729c6af6f2a6e);
// eslint-disable-next-line import/no-namespace

var $bKyJg = parcelRequire("bKyJg");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $227b8427ab0364b1$var$typedNodes = $bKyJg;
const $227b8427ab0364b1$export$b1f729c6af6f2a6e = new Set(Object.keys($227b8427ab0364b1$var$typedNodes).filter((key)=>$227b8427ab0364b1$var$typedNodes[key] && $227b8427ab0364b1$var$typedNodes[key].group === 'inline'));

});
parcelRegister("bKyJg", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("l5yqo")).expandWithNestedExpand);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => (parcelRequire("l5yqo")).expandWithNestedExpandLocalId);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("l5yqo")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("jZozI")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("gj3iP")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("3eFUn")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("7gCXC")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("exRcf")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("exRcf")).extendedBlockquote);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("exRcf")).extendedBlockquoteWithLocalId);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("MCCgU")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("MCCgU")).bulletListSelector);
$parcel$export(module.exports, "bulletListWithLocalId", () => (parcelRequire("MCCgU")).bulletListWithLocalId);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("iq16s")).codeBlock);
$parcel$export(module.exports, "codeBlockWithLocalId", () => (parcelRequire("iq16s")).codeBlockWithLocalId);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("iq16s")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("arpnd")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("knCYS")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("djAdL")).rule);
$parcel$export(module.exports, "ruleWithLocalId", () => (parcelRequire("djAdL")).ruleWithLocalId);
$parcel$export(module.exports, "ruleRootOnlyStage0", () => (parcelRequire("djAdL")).ruleRootOnlyStage0);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("4rqGA")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("4rqGA")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithLocalId", () => (parcelRequire("4rqGA")).orderedListWithLocalId);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("4rqGA")).orderedListWithOrder);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("4rqGA")).orderedListWithOrderAndLocalId);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("kUt8q")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("23LTd")).emoji);
$parcel$export(module.exports, "emojiWithLocalId", () => (parcelRequire("23LTd")).emojiWithLocalId);
$parcel$export(module.exports, "image", () => (parcelRequire("3CMyJ")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("d1R2l")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("d1R2l")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("1CJRu")).listItem);
$parcel$export(module.exports, "listItemWithLocalId", () => (parcelRequire("1CJRu")).listItemWithLocalId);
$parcel$export(module.exports, "extendedPanelC1RootOnlyStage0", () => (parcelRequire("j9iKu")).extendedPanelC1RootOnlyStage0);
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => (parcelRequire("lKqex")).extendedPanelC1WithLocalId);
$parcel$export(module.exports, "extendedPanelC1", () => (parcelRequire("2Avts")).extendedPanelC1);
$parcel$export(module.exports, "extendedPanelRootOnlyStage0", () => (parcelRequire("bMAIM")).extendedPanelRootOnlyStage0);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => (parcelRequire("4VRBv")).extendedPanelWithLocalId);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("1GMi7")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("39FD9")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("7mXyo")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("gtZE7")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("3y4dy")).caption);
$parcel$export(module.exports, "captionWithLocalId", () => (parcelRequire("3y4dy")).captionWithLocalId);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("90lGn")).copyPrivateAttributes);
$parcel$export(module.exports, "media", () => (parcelRequire("6s15K")).media);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("E9igg")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("e224s")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("47k1x")).mediaInline);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("eGp9b")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("6E6Kd")).mediaSingle);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("6E6Kd")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => (parcelRequire("6E6Kd")).mediaSingleFullWithLocalId);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("6E6Kd")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("6E6Kd")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("iof8L")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("63Q5S")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("63Q5S")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("63Q5S")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("63Q5S")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("63Q5S")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableCellStage0", () => (parcelRequire("63Q5S")).tableCellStage0);
$parcel$export(module.exports, "tableHeaderStage0", () => (parcelRequire("63Q5S")).tableHeaderStage0);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => (parcelRequire("63Q5S")).tableCellWithNestedTableStage0);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => (parcelRequire("63Q5S")).tableHeaderWithNestedTableStage0);
$parcel$export(module.exports, "tableRowWithLocalId", () => (parcelRequire("63Q5S")).tableRowWithLocalId);
$parcel$export(module.exports, "tableCellWithLocalId", () => (parcelRequire("63Q5S")).tableCellWithLocalId);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => (parcelRequire("63Q5S")).tableHeaderWithLocalId);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("63Q5S")).tableRowWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("63Q5S")).tableCellWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("63Q5S")).tableHeaderWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("63Q5S")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("63Q5S")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("63Q5S")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("63Q5S")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("63Q5S")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("63Q5S")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("63Q5S")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("63Q5S")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("63Q5S")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundColorPaletteNew", () => (parcelRequire("63Q5S")).tableBackgroundColorPaletteNew);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("63Q5S")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("63Q5S")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("63Q5S")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("63Q5S")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("63Q5S")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("63Q5S")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("63Q5S")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("63Q5S")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("63Q5S")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("bOVzM")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("bOVzM")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("jwm0O")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("eohEq")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("eohEq")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("cd0UN")).taskItem);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("cd0UN")).blockTaskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("1dOrX")).date);
$parcel$export(module.exports, "dateWithLocalId", () => (parcelRequire("1dOrX")).dateWithLocalId);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("gITKe")).placeholder);
$parcel$export(module.exports, "placeholderWithLocalId", () => (parcelRequire("gITKe")).placeholderWithLocalId);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("2KlGf")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => (parcelRequire("2KlGf")).layoutSectionWithLocalId);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("2KlGf")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("2KlGf")).layoutSectionWithSingleColumnLocalId);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("9XvY7")).layoutColumn);
$parcel$export(module.exports, "layoutColumnStage0", () => (parcelRequire("9XvY7")).layoutColumnStage0);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => (parcelRequire("9XvY7")).layoutColumnWithLocalId);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("bNXHl")).inlineCard);
$parcel$export(module.exports, "inlineCardWithLocalId", () => (parcelRequire("bNXHl")).inlineCardWithLocalId);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("8Nxxj")).blockCard);
$parcel$export(module.exports, "blockCardWithLocalId", () => (parcelRequire("8Nxxj")).blockCardWithLocalId);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("7eKWK")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("e2bmr")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("1oEoc")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("flh6x")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => (parcelRequire("flh6x")).nestedExpandWithLocalId);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("gapZI")).embedCard);
$parcel$export(module.exports, "embedCardWithLocalId", () => (parcelRequire("gapZI")).embedCardWithLocalId);
$parcel$export(module.exports, "extension", () => (parcelRequire("iglh1")).extension);
$parcel$export(module.exports, "extensionRootOnlyStage0", () => (parcelRequire("iglh1")).extensionRootOnlyStage0);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("608PD")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("eC92i")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtensionRootOnlyStage0", () => (parcelRequire("eC92i")).bodiedExtensionRootOnlyStage0);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("jXulL")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("jXulL")).multiBodiedExtension);
$parcel$export(module.exports, "multiBodiedExtensionRootOnlyStage0", () => (parcelRequire("jXulL")).multiBodiedExtensionRootOnlyStage0);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("cdpdE")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("laaDK")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.

var $l5yqo = parcelRequire("l5yqo");

var $jZozI = parcelRequire("jZozI");

var $gj3iP = parcelRequire("gj3iP");

var $3eFUn = parcelRequire("3eFUn");

var $7gCXC = parcelRequire("7gCXC");

var $exRcf = parcelRequire("exRcf");

var $MCCgU = parcelRequire("MCCgU");

var $iq16s = parcelRequire("iq16s");

var $arpnd = parcelRequire("arpnd");

var $knCYS = parcelRequire("knCYS");

var $djAdL = parcelRequire("djAdL");

var $4rqGA = parcelRequire("4rqGA");

var $kUt8q = parcelRequire("kUt8q");

var $23LTd = parcelRequire("23LTd");

var $3CMyJ = parcelRequire("3CMyJ");

var $d1R2l = parcelRequire("d1R2l");

var $1CJRu = parcelRequire("1CJRu");

var $j9iKu = parcelRequire("j9iKu");

var $lKqex = parcelRequire("lKqex");

var $2Avts = parcelRequire("2Avts");

var $bMAIM = parcelRequire("bMAIM");

var $4VRBv = parcelRequire("4VRBv");

var $1GMi7 = parcelRequire("1GMi7");

var $39FD9 = parcelRequire("39FD9");

var $7mXyo = parcelRequire("7mXyo");

var $gtZE7 = parcelRequire("gtZE7");

var $3y4dy = parcelRequire("3y4dy");

var $90lGn = parcelRequire("90lGn");

var $6s15K = parcelRequire("6s15K");

var $E9igg = parcelRequire("E9igg");

var $e224s = parcelRequire("e224s");

var $47k1x = parcelRequire("47k1x");

var $eGp9b = parcelRequire("eGp9b");

var $6E6Kd = parcelRequire("6E6Kd");

var $iof8L = parcelRequire("iof8L");

var $63Q5S = parcelRequire("63Q5S");

var $bOVzM = parcelRequire("bOVzM");

var $jwm0O = parcelRequire("jwm0O");

var $eohEq = parcelRequire("eohEq");

var $cd0UN = parcelRequire("cd0UN");

var $1dOrX = parcelRequire("1dOrX");

var $gITKe = parcelRequire("gITKe");

var $2KlGf = parcelRequire("2KlGf");

var $9XvY7 = parcelRequire("9XvY7");

var $bNXHl = parcelRequire("bNXHl");

var $8Nxxj = parcelRequire("8Nxxj");

var $7eKWK = parcelRequire("7eKWK");

var $e2bmr = parcelRequire("e2bmr");

var $1oEoc = parcelRequire("1oEoc");

var $flh6x = parcelRequire("flh6x");

var $gapZI = parcelRequire("gapZI");

var $iglh1 = parcelRequire("iglh1");

var $608PD = parcelRequire("608PD");

var $eC92i = parcelRequire("eC92i");

var $jXulL = parcelRequire("jXulL");

var $cdpdE = parcelRequire("cdpdE");

var $laaDK = parcelRequire("laaDK");

});


parcelRegister("k1dx5", function(module, exports) {
$parcel$export(module.exports, "isSubSupType", () => $806a38690b5fe89b$export$30f8aa4cc1f8c1cb);
const $806a38690b5fe89b$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};

});

parcelRegister("lDDJ6", function(module, exports) {
$parcel$export(module.exports, "markOrder", () => $32283169fcca18cd$export$62d5811a2955c1d8);
/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/ETEMP/pages/11174043/Atlassian+Document+Format+-+Internal+documentation#Rank
 */ const $32283169fcca18cd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];

});


parcelRegister("frezR", function(module, exports) {
$parcel$export(module.exports, "isSameMark", () => $5c14a9cc90f6f4b6$export$b1304404bdc42b7a);
const $5c14a9cc90f6f4b6$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};

});

parcelRegister("lHdKv", function(module, exports) {
$parcel$export(module.exports, "ExpandBodyProvider", () => $1231e8ce8803d920$export$57ea044a2befcf45);
$parcel$export(module.exports, "useExpandBody", () => $1231e8ce8803d920$export$40dd974b96ebf5ba);
$parcel$export(module.exports, "withExpandBodyBlock", () => $1231e8ce8803d920$export$b4e33946e63ad887);
$parcel$export(module.exports, "mergeExpandBodyText", () => $1231e8ce8803d920$export$3099c7a6e9a4b682);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $bUICL = parcelRequire("bUICL");
const $1231e8ce8803d920$var$ExpandBodyContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $1231e8ce8803d920$export$57ea044a2befcf45 = $1231e8ce8803d920$var$ExpandBodyContext.Provider;
const $1231e8ce8803d920$export$40dd974b96ebf5ba = ()=>(0, $fc4bM.useContext)($1231e8ce8803d920$var$ExpandBodyContext);
const $1231e8ce8803d920$export$8b49603a5a5ab281 = ({ children: children, searchText: searchText })=>{
    const body = $1231e8ce8803d920$export$40dd974b96ebf5ba();
    if (searchText === undefined || body === null || body.revealed) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: children
    });
    return searchText;
};
const $1231e8ce8803d920$export$b4e33946e63ad887 = (node, ancestors, index, serialized)=>{
    const parent = ancestors[ancestors.length - 1];
    if (!parent || !(0, $bUICL.isExpandNode)(parent)) return serialized;
    // `serialized` is only null for a node the renderer has no component for, which a table is not.
    // Such a table falls through to the paths below, which do not reach into it.
    if (node.type.name === 'table' && serialized !== null) {
        const parts = (0, $bUICL.getTableStandInParts)(node);
        // With no row to keep, one string can stand in for the whole table — the table then renders
        // nothing at all, and its text joins with the blocks either side of it.
        return parts.every((part)=>typeof part === 'string') ? /*#__PURE__*/ (0, $3LM7S.jsx)($1231e8ce8803d920$export$8b49603a5a5ab281, {
            searchText: parts.join(''),
            children: serialized
        }, `expand-body-block-${index}`) : /*#__PURE__*/ (0, $3LM7S.jsx)($1231e8ce8803d920$export$f62b093160ec006b, {
            node: node,
            children: serialized
        }, `expand-body-table-${index}`);
    }
    if ((0, $bUICL.holdsRevealableContent)(node)) return serialized;
    const searchText = (0, $bUICL.getBlockSearchText)(node);
    if (searchText === undefined) return serialized;
    return /*#__PURE__*/ (0, $3LM7S.jsx)($1231e8ce8803d920$export$8b49603a5a5ab281, {
        searchText: searchText,
        children: serialized
    }, `expand-body-block-${index}`);
};
const $1231e8ce8803d920$var$isRow = (child)=>/*#__PURE__*/ (0, $fc4bM.isValidElement)(child) && child.props.nodeType === 'tableRow';
/**
 * The rows inside the serialized table, wherever they sit.
 *
 * What the serializer hands over is not reliably the element whose children are the rows. Marks are
 * folded around the node afterwards, and a product's own serializer may wrap the rows themselves —
 * Confluence's progressive renderer wraps every row but the first. Assuming either a depth or a set
 * of direct children means any wrapper added later silently costs the saving, so the rows are found
 * instead by the `nodeType` the serializer puts on every node.
 *
 * Descent stops at each row: a nested table's rows sit inside a row of this one, and would
 * otherwise be counted among them.
 *
 * The count is only a consistency check. `getTableStandInParts` indexes the rows by position, so a
 * partial match cannot be lined up and the table has to render instead.
 */ const $1231e8ce8803d920$var$rowsOf = (serialized, rowCount)=>{
    const rows = [];
    const collect = (node)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(node).forEach((child)=>{
            if (!/*#__PURE__*/ (0, $fc4bM.isValidElement)(child)) return;
            if ($1231e8ce8803d920$var$isRow(child)) {
                rows.push(child);
                return;
            }
            collect(child.props.children);
        });
    };
    collect(serialized);
    return rows.length === rowCount ? rows : undefined;
};
const $1231e8ce8803d920$export$f62b093160ec006b = ({ children: children, node: node })=>{
    const body = $1231e8ce8803d920$export$40dd974b96ebf5ba();
    if (body === null || body.revealed) return children;
    const rows = $1231e8ce8803d920$var$rowsOf(children, node.childCount);
    if (!rows) {
        // eslint-disable-next-line no-console
        console.info('@atlaskit/renderer: the rows of a table in a collapsed expand were not found, so the table renders in full rather than showing their text');
        return children;
    }
    return (0, $bUICL.getTableStandInParts)(node).map((part)=>typeof part === 'string' ? part : // A row cannot stand in the page on its own — `<tr>` is only valid inside a table — so it
        // keeps the least table around it that makes the markup valid. None of this is laid out: the
        // body is hidden until the reader or find opens the expand, and opening it renders the real
        // table in place of all this.
        /*#__PURE__*/ (0, $3LM7S.jsx)("table", {
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("tbody", {
                children: rows[part]
            })
        }, `expand-body-row-${part}`));
};
const $1231e8ce8803d920$var$searchTextOf = (child)=>/*#__PURE__*/ (0, $fc4bM.isValidElement)(child) && child.type === $1231e8ce8803d920$export$8b49603a5a5ab281 ? child.props.searchText : undefined;
const $1231e8ce8803d920$export$3099c7a6e9a4b682 = (children)=>{
    // Called for every fragment in the document, and only an expand's body has anything to merge, so
    // leave the array alone unless two neighbours are actually showing text.
    const hasRun = children.some((child, index)=>index > 0 && $1231e8ce8803d920$var$searchTextOf(child) !== undefined && $1231e8ce8803d920$var$searchTextOf(children[index - 1]) !== undefined);
    if (!hasRun) return children;
    const merged = [];
    let run = [];
    const endRun = ()=>{
        if (run.length === 0) return;
        if (run.length === 1) merged.push(run[0]);
        else {
            const text = run.map($1231e8ce8803d920$var$searchTextOf).filter(Boolean).join((0, $bUICL.BLOCK_SEPARATOR));
            // The blocks themselves, not the wrappers around them: nesting the wrappers would show
            // each block's text again inside the joined run.
            const blocks = run.map((child)=>child.props.children);
            merged.push(/*#__PURE__*/ (0, $3LM7S.jsx)($1231e8ce8803d920$export$8b49603a5a5ab281, {
                searchText: text,
                children: blocks
            }, run[0].key ?? undefined));
        }
        run = [];
    };
    children.forEach((child)=>{
        if ($1231e8ce8803d920$var$searchTextOf(child) === undefined) {
            endRun();
            merged.push(child);
            return;
        }
        run.push(child);
    });
    endRun();
    return merged;
};

});
parcelRegister("bUICL", function(module, exports) {
$parcel$export(module.exports, "BLOCK_SEPARATOR", () => $73ed92834e83361c$export$107fd3c009356079);
$parcel$export(module.exports, "isExpandNode", () => $73ed92834e83361c$export$8e4b11a2e791d70a);
$parcel$export(module.exports, "holdsRevealableContent", () => $73ed92834e83361c$export$190cd2ff72900fe7);
$parcel$export(module.exports, "getBlockSearchText", () => $73ed92834e83361c$export$2228423caf47f74);
$parcel$export(module.exports, "getTableStandInParts", () => $73ed92834e83361c$export$e860c2c8391d30bf);

var $a4TQr = parcelRequire("a4TQr");
const $73ed92834e83361c$export$107fd3c009356079 = ' ';
const $73ed92834e83361c$var$asText = (value)=>typeof value === 'string' ? value : '';
const $73ed92834e83361c$var$nestedContentOf = (attrs)=>{
    var _attrs$parameters;
    return attrs === null || attrs === void 0 || (_attrs$parameters = attrs.parameters) === null || _attrs$parameters === void 0 ? void 0 : _attrs$parameters.nestedContent;
};
const $73ed92834e83361c$export$8e4b11a2e791d70a = (node)=>node.type.name === 'expand' || node.type.name === 'nestedExpand';
/**
 * Reads the text out of raw ADF JSON.
 *
 * Some extensions keep a whole ADF subtree in `attrs.parameters.nestedContent` rather than in their
 * node content. Confluence does this when the authored nesting is deeper than the schema allows —
 * an expand more than two collapsible layers deep, for example. To ProseMirror the extension is a
 * leaf, so walking the node tree never sees that subtree, even though a nested renderer puts it on
 * the page. Recurses, because stashed content often stashes more content of its own.
 */ const $73ed92834e83361c$var$adfEntityText = (entity)=>{
    var _entity$content;
    if (!entity) return '';
    const parts = [];
    if (entity.type === 'text') parts.push($73ed92834e83361c$var$asText(entity.text));
    const nestedContent = $73ed92834e83361c$var$nestedContentOf(entity.attrs);
    if (nestedContent) // Prefer the real subtree over `attrs.text`, which is only a placeholder label for it.
    parts.push($73ed92834e83361c$var$adfEntityText(nestedContent));
    else {
        var _entity$attrs;
        parts.push($73ed92834e83361c$var$asText((_entity$attrs = entity.attrs) === null || _entity$attrs === void 0 ? void 0 : _entity$attrs.text));
    }
    (_entity$content = entity.content) === null || _entity$content === void 0 || _entity$content.forEach((child)=>parts.push($73ed92834e83361c$var$adfEntityText(child)));
    return parts.filter(Boolean).join($73ed92834e83361c$export$107fd3c009356079);
};
/**
 * `textBetween` skips every leaf node unless its spec declares `leafText`, and no ADF node
 * does — so mentions, emoji, dates and statuses would all be lost. They keep their visible
 * text in attrs, so read it from there.
 */ const $73ed92834e83361c$var$leafText = (leaf)=>{
    var _leaf$attrs;
    const nestedContent = $73ed92834e83361c$var$nestedContentOf(leaf.attrs);
    if (nestedContent) return $73ed92834e83361c$var$adfEntityText(nestedContent);
    return $73ed92834e83361c$var$asText((_leaf$attrs = leaf.attrs) === null || _leaf$attrs === void 0 ? void 0 : _leaf$attrs.text);
};
const $73ed92834e83361c$var$isRevealable = (node)=>$73ed92834e83361c$export$8e4b11a2e791d70a(node) || Boolean($73ed92834e83361c$var$nestedContentOf(node.attrs));
const $73ed92834e83361c$var$revealableCache = new WeakMap();
const $73ed92834e83361c$export$190cd2ff72900fe7 = (node)=>{
    const cached = $73ed92834e83361c$var$revealableCache.get(node);
    if (cached !== undefined) return cached;
    let found = $73ed92834e83361c$var$isRevealable(node);
    if (!found) node.descendants((descendant)=>{
        if (found) return false;
        found = $73ed92834e83361c$var$isRevealable(descendant);
        return !found;
    });
    $73ed92834e83361c$var$revealableCache.set(node, found);
    return found;
};
const $73ed92834e83361c$var$hasInlineComment = (node)=>(0, $a4TQr.findChildrenByMark)(node, node.type.schema.marks.annotation, true).some((annotation)=>annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment'));
/** `null` is a cached "no search text for this node", as distinct from `undefined` for a miss. */ const $73ed92834e83361c$var$searchTextCache = new WeakMap();
const $73ed92834e83361c$export$2228423caf47f74 = (node)=>{
    let cached = $73ed92834e83361c$var$searchTextCache.get(node);
    if (cached === undefined) {
        cached = $73ed92834e83361c$var$hasInlineComment(node) ? // No text, which makes the block render instead. Comment navigation looks through the DOM
        // for the commented text and scrolls to it, so that text has to be a real element —
        // plain text carries no comment marks and cannot stand in for it. Without this, the
        // arrow keys silently skip every comment inside a collapsed expand. We give up the
        // saving for this block on purpose.
        null : // A leaf block is not inside its own range, so `textBetween` would return nothing and its
        // text would be lost — a macro sitting straight in an expand body, for instance.
        node.isLeaf ? $73ed92834e83361c$var$leafText(node) : node.textBetween(0, node.content.size, $73ed92834e83361c$export$107fd3c009356079, $73ed92834e83361c$var$leafText);
        $73ed92834e83361c$var$searchTextCache.set(node, cached);
    }
    return cached ?? undefined;
};
const $73ed92834e83361c$var$tableStandInCache = new WeakMap();
const $73ed92834e83361c$export$e860c2c8391d30bf = (table)=>{
    const cached = $73ed92834e83361c$var$tableStandInCache.get(table);
    if (cached !== undefined) return cached;
    const parts = [];
    table.forEach((row, _offset, index)=>{
        const text = $73ed92834e83361c$export$190cd2ff72900fe7(row) ? undefined : $73ed92834e83361c$export$2228423caf47f74(row);
        if (text === undefined) {
            parts.push(index);
            return;
        }
        const last = parts[parts.length - 1];
        if (typeof last === 'string') {
            parts[parts.length - 1] = `${last}${$73ed92834e83361c$export$107fd3c009356079}${text}`;
            return;
        }
        parts.push(text);
    });
    $73ed92834e83361c$var$tableStandInCache.set(table, parts);
    return parts;
};

});


parcelRegister("9K4MK", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", () => $979365d45faf089e$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $979365d45faf089e$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $979365d45faf089e$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $979365d45faf089e$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $b4w4S = parcelRequire("b4w4S");

var $f7AYl = parcelRequire("f7AYl");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $979365d45faf089e$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $979365d45faf089e$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $b4w4S.defaultSchema));
        this.encode = $979365d45faf089e$var$createEncoder(transformer, new (0, $f7AYl.JSONTransformer)());
    }
}
const $979365d45faf089e$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $979365d45faf089e$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $979365d45faf089e$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $979365d45faf089e$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("7gUV5", function(module, exports) {
$parcel$export(module.exports, "toReact", () => $1257edadfc4dfa3c$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $2JnBd = parcelRequire("2JnBd");

var $dYypm = parcelRequire("dYypm");

var $3UHCx = parcelRequire("3UHCx");

var $8324S = parcelRequire("8324S");

var $ixSKT = parcelRequire("ixSKT");

var $UmdFO = parcelRequire("UmdFO");

var $1BehG = parcelRequire("1BehG");

var $br7UP = parcelRequire("br7UP");

var $76AfX = parcelRequire("76AfX");

var $fRQTs = parcelRequire("fRQTs");

var $fpqxE = parcelRequire("fpqxE");

var $e5I4a = parcelRequire("e5I4a");

var $bSViW = parcelRequire("bSViW");

var $mvsbF = parcelRequire("mvsbF");

var $kSzKU = parcelRequire("kSzKU");

var $drrx9 = parcelRequire("drrx9");

var $JUmmM = parcelRequire("JUmmM");

var $3ilp9 = parcelRequire("3ilp9");

var $YZkqa = parcelRequire("YZkqa");

var $2peAf = parcelRequire("2peAf");
const $1257edadfc4dfa3c$export$c00d967a0f56fdb7 = {
    code: (0, $UmdFO.default),
    em: (0, $76AfX.default),
    link: (0, $bSViW.default),
    strike: (0, $mvsbF.default),
    strong: (0, $kSzKU.default),
    subsup: (0, $drrx9.default),
    textColor: (0, $JUmmM.default),
    backgroundColor: (0, $3UHCx.default),
    underline: (0, $3ilp9.default),
    annotation: (0, $dYypm.default),
    border: (0, $8324S.default),
    fontSize: (0, $fRQTs.default),
    // Stage0
    confluenceInlineComment: (0, $1BehG.default),
    breakout: (0, $ixSKT.default),
    alignment: (0, $2JnBd.default),
    indentation: (0, $e5I4a.default),
    unsupportedMark: (0, $YZkqa.default),
    unsupportedNodeAttribute: (0, $2peAf.default),
    dataConsumer: (0, $br7UP.default),
    fragment: (0, $fpqxE.default)
};
const $1257edadfc4dfa3c$export$d4334b129116aad7 = (mark)=>{
    return $1257edadfc4dfa3c$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("2JnBd", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a321f9a65bfede9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $6BHhZ = parcelRequire("6BHhZ");
const $6a321f9a65bfede9$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $6BHhZ.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $6a321f9a65bfede9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $jctmk.jsx)($6a321f9a65bfede9$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("3UHCx", function(module, exports) {
$parcel$export(module.exports, "default", () => $572170ed86d0d37f$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lefJT = parcelRequire("lefJT");

var $bWHm4 = parcelRequire("bWHm4");

var $anluN = parcelRequire("anluN");
function $572170ed86d0d37f$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $bWHm4.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $lefJT.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $fc4bM.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "background-color-padding-left background-color-padding-right",
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("bWHm4", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $1356706c96d28e4c$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $1356706c96d28e4c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Red - light */ ['#FFD5D2']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    /** Blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    /** Green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)"
};
function $1356706c96d28e4c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $1356706c96d28e4c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("8324S", function(module, exports) {
$parcel$export(module.exports, "default", () => $f232cc893a85d185$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $jctmk = parcelRequire("jctmk");
function $f232cc893a85d185$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("ixSKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b78e36ddf2b7c21c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");

var $aGINe = parcelRequire("aGINe");
function $b78e36ddf2b7c21c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b78e36ddf2b7c21c$var$flexWrapperStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $014x6.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $b78e36ddf2b7c21c$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $b78e36ddf2b7c21c$var$getWidth = (width, mode)=>{
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if (mode === 'max' || typeof width === 'number' && width >= (0, $014x6.akEditorFullWidthLayoutWidth)) return `min(${0, $014x6.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'full-width') return `min(${0, $014x6.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $b78e36ddf2b7c21c$export$2e2bcd8739ae039(props) {
    const breakoutWidth = props.width ?? null;
    const width = $b78e36ddf2b7c21c$var$getWidth(breakoutWidth, props.mode);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $aGINe.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $b78e36ddf2b7c21c$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $b78e36ddf2b7c21c$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $kaRof.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
}

});

parcelRegister("UmdFO", function(module, exports) {
$parcel$export(module.exports, "isCodeMark", () => $b4b1f88ca64ccfd5$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $b4b1f88ca64ccfd5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $8rK38 = parcelRequire("8rK38");

var $jXapy = parcelRequire("jXapy");
const $b4b1f88ca64ccfd5$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $b4b1f88ca64ccfd5$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $jXapy.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8rK38.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $b4b1f88ca64ccfd5$var$_default_1 = (0, $fcCIH.default)($b4b1f88ca64ccfd5$export$7cea6ffa7022e85f);
var $b4b1f88ca64ccfd5$export$2e2bcd8739ae039 = $b4b1f88ca64ccfd5$var$_default_1;

});
parcelRegister("8rK38", function(module, exports) {
$parcel$export(module.exports, "default", () => $739f8313eaa09e1d$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $flr7A = parcelRequire("flr7A");

var $7p4cu = parcelRequire("7p4cu");
const $739f8313eaa09e1d$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $739f8313eaa09e1d$var$Code = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $3LM7S.jsx)($739f8313eaa09e1d$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $2R2iS.default)([
            $739f8313eaa09e1d$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $739f8313eaa09e1d$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $flr7A.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7p4cu.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($739f8313eaa09e1d$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)($739f8313eaa09e1d$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: replacedChildren
    });
}
function $739f8313eaa09e1d$var$isReactElement(child) {
    return !!child.type;
}
$739f8313eaa09e1d$var$Code.displayName = 'Code';
var $739f8313eaa09e1d$export$2e2bcd8739ae039 = $739f8313eaa09e1d$var$Code;

});
parcelRegister("flr7A", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f1ad9da777f71c4$export$2e2bcd8739ae039);

var $iM61q = parcelRequire("iM61q");
function $1f1ad9da777f71c4$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $iM61q.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});
parcelRegister("iM61q", function(module, exports) {
$parcel$export(module.exports, "bidiCharacterRegex", () => $776db744c8c0cb9d$export$ecb256e6a1f5ee7e);
const $776db744c8c0cb9d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;

});


parcelRegister("7p4cu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3e9f31a6347c880$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $bcTS3 = parcelRequire("bcTS3");

var $9TR3X = parcelRequire("9TR3X");
function $a3e9f31a6347c880$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: label,
        tag: $a3e9f31a6347c880$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9TR3X.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9TR3X.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $a3e9f31a6347c880$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("9TR3X", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $cdd10fb1bb12d781$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dVxDa = parcelRequire("dVxDa");
const $cdd10fb1bb12d781$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $cdd10fb1bb12d781$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $cdd10fb1bb12d781$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $2R2iS.default)([
                    $cdd10fb1bb12d781$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $cdd10fb1bb12d781$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    const bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return `U+${bidiCharacterCode}`;
}

});



parcelRegister("jXapy", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningMessages", () => $e8c5a110cf0878f0$export$42bb270d1224182);

var $8p5Cv = parcelRequire("8p5Cv");
const $e8c5a110cf0878f0$export$42bb270d1224182 = (0, $8p5Cv.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});


parcelRegister("1BehG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e2efd7c8e0f92d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
class $d7e2efd7c8e0f92d$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});

parcelRegister("br7UP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4084ae9a4d32b8a1$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $4084ae9a4d32b8a1$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $3LM7S.jsx)(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("76AfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $0314cd258aaca00d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $0314cd258aaca00d$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $3LM7S.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("fRQTs", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d65be8f7087af83$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $9d65be8f7087af83$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize,
        children: props.children
    });
}

});

parcelRegister("fpqxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $34cc9d1b8aa2e24d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $34cc9d1b8aa2e24d$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $3LM7S.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("e5I4a", function(module, exports) {
$parcel$export(module.exports, "default", () => $49918e4c92118992$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $49918e4c92118992$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("bSViW", function(module, exports) {
$parcel$export(module.exports, "default", () => $72769a88eda16d86$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $3LeME = parcelRequire("3LeME");

var $bcN2K = parcelRequire("bcN2K");

var $fzRvL = parcelRequire("fzRvL");

var $a63R3 = parcelRequire("a63R3");

var $9K4MK = parcelRequire("9K4MK");

var $d8sRM = parcelRequire("d8sRM");

var $1kFSe = parcelRequire("1kFSe");
const $72769a88eda16d86$var$LinkUrlMigration = (0, $fzRvL.componentWithCondition)(()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_renderer_static_css'), (0, $d8sRM.LinkUrlCompiled), (0, $1kFSe.LinkUrlEmotion));
function $72769a88eda16d86$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $9K4MK.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
        children: props.children
    });
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3TJLC.default), {
        data: analyticsData,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($72769a88eda16d86$var$LinkUrlMigration, {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>{
                if (fireAnalyticsEvent) fireAnalyticsEvent({
                    action: (0, $3LeME.ACTION).VISITED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).LINK,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        platform: (0, $a63R3.PLATFORM).WEB,
                        mode: (0, $a63R3.MODE).RENDERER
                    }
                });
                if (handler) handler(e, href);
            },
            ...anchorProps,
            ...dataAttributes,
            isLinkComponent: true,
            enableResolve: true,
            children: props.children
        })
    });
}

});
parcelRegister("d8sRM", function(module, exports) {
$parcel$export(module.exports, "LinkUrlCompiled", () => $e9391876398e84c7$export$10ae7cf734c9da69);
/* link-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Compiled branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4je51 = parcelRequire("4je51");
const $e9391876398e84c7$var$anchorStyles = null;
const $e9391876398e84c7$export$10ae7cf734c9da69 = (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $4je51.LinkUrl), {
        ...props,
        className: (0, $2R2iS.default)([
            "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
        ])
    });

});
parcelRegister("4je51", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a93143040a4327a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LinkUrl", () => $2a93143040a4327a$export$56ff87f78018e459);

var $fc4bM = parcelRequire("fc4bM");

var $613oU = parcelRequire("613oU");

var $cstmi = parcelRequire("cstmi");

var $ChNgn = parcelRequire("ChNgn");

var $5WltR = parcelRequire("5WltR");

var $fZlXU = parcelRequire("fZlXU");

var $1Pbap = parcelRequire("1Pbap");
const $2a93143040a4327a$var$PACKAGE_DATA = {
    packageName: undefined,
    packageVersion: undefined,
    componentName: 'linkUrl'
};
const $2a93143040a4327a$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $1Pbap.useLinkWarningModal)();
    const Link = enableResolve ? (0, $5WltR.HyperlinkWithSmartLinkResolver) : (0, $ChNgn.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cstmi.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Link, {
        href: href,
        testId: testId,
        isLinkComponent: isLinkComponent,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fZlXU.default), linkWarningModalProps));
};
const $2a93143040a4327a$export$56ff87f78018e459 = (0, $613oU.default)($2a93143040a4327a$var$PACKAGE_DATA)($2a93143040a4327a$var$LinkUrl);
var $2a93143040a4327a$export$2e2bcd8739ae039 = $2a93143040a4327a$export$56ff87f78018e459;

});
parcelRegister("cstmi", function(module, exports) {
$parcel$export(module.exports, "LinkAnalyticsContext", () => $c6552d8796747ab7$export$9458cdec663b9ff1);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");
const $c6552d8796747ab7$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("ChNgn", function(module, exports) {
$parcel$export(module.exports, "default", () => $89a232e5f9bbda4a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dM0Q8 = parcelRequire("dM0Q8");

var $3M9BL = parcelRequire("3M9BL");
const $89a232e5f9bbda4a$var$Anchor = (0, $3M9BL.withLinkClickedEvent)('a');
const $89a232e5f9bbda4a$export$8c0773eab230d49e = (0, $3M9BL.withLinkClickedEvent)((0, $dM0Q8.default));
const $89a232e5f9bbda4a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $89a232e5f9bbda4a$export$8c0773eab230d49e : $89a232e5f9bbda4a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $89a232e5f9bbda4a$export$2e2bcd8739ae039 = $89a232e5f9bbda4a$var$Hyperlink;

});
parcelRegister("3M9BL", function(module, exports) {
$parcel$export(module.exports, "withLinkClickedEvent", () => $ccfd006f0c2c57ca$export$263352d59c0c5966);

var $fc4bM = parcelRequire("fc4bM");

var $7GSrC = parcelRequire("7GSrC");

var $f1474 = parcelRequire("f1474");
const $ccfd006f0c2c57ca$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $ccfd006f0c2c57ca$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $7GSrC.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $f1474.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$ccfd006f0c2c57ca$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("7GSrC", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $0e059bebd2eee5cc$export$5993d3ca6c85f774);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $9VWuO = parcelRequire("9VWuO");
var $0e059bebd2eee5cc$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0e059bebd2eee5cc$export$5993d3ca6c85f774 = (handler, predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    return (0, $fc4bM.useCallback)((...args)=>{
        const [event] = args;
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $9VWuO.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("9VWuO", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $479612491c06f09e$export$7987de3055fbdcb0);
parcelRequire("fc4bM");

var $9JzR9 = parcelRequire("9JzR9");

var $klpwM = parcelRequire("klpwM");
const $479612491c06f09e$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = (0, $klpwM.createLinkClickedPayload)(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.nonPrivacySafeAttributes
            }
        }).fire((0, $9JzR9.ANALYTICS_CHANNEL));
    };

});
parcelRegister("9JzR9", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $25733dc012b6d7d2$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $25733dc012b6d7d2$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $25733dc012b6d7d2$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $25733dc012b6d7d2$export$c89e475f7f7174c2);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

const $25733dc012b6d7d2$export$85183a312807388d = 'media';
const $25733dc012b6d7d2$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: '',
    packageVersion: ''
};
var $25733dc012b6d7d2$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $25733dc012b6d7d2$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});

});

parcelRegister("klpwM", function(module, exports) {
$parcel$export(module.exports, "createLinkClickedPayload", () => $30f70b25e890560e$export$7fedc699766c16de);
parcelRequire("fc4bM");

var $jcqjR = parcelRequire("jcqjR");

var $fJbgu = parcelRequire("fJbgu");

var $lb9Km = parcelRequire("lb9Km");
const $30f70b25e890560e$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $30f70b25e890560e$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : (0, $jcqjR.buttonMap).get(event.button);
    if (!clickType) return;
    const clickOutcome = (0, $lb9Km.getLinkClickOutcome)(event, clickType);
    const keysHeld = (0, $fJbgu.getKeys)(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $30f70b25e890560e$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};

});
parcelRegister("jcqjR", function(module, exports) {
$parcel$export(module.exports, "buttonMap", () => $f9b6f7628c02c384$export$cfb45d54e1604f6c);
const $f9b6f7628c02c384$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);

});

parcelRegister("fJbgu", function(module, exports) {
$parcel$export(module.exports, "getKeys", () => $70be0de5fa232f74$export$74743eda5dda3ccf);
parcelRequire("fc4bM");
const $70be0de5fa232f74$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};

});

parcelRegister("lb9Km", function(module, exports) {
$parcel$export(module.exports, "getLinkClickOutcome", () => $58d4d42f5c8640b2$export$d2a83e3b34be812b);
parcelRequire("fc4bM");

var $fJ9SP = parcelRequire("fJ9SP");
const $58d4d42f5c8640b2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $58d4d42f5c8640b2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $fJ9SP.browser)();
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($58d4d42f5c8640b2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}

});
parcelRegister("fJ9SP", function(module, exports) {
$parcel$export(module.exports, "browser", () => $ddcb86ca7ae18ac3$export$3f2684e5d7cb1006);
const $ddcb86ca7ae18ac3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $ddcb86ca7ae18ac3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $ddcb86ca7ae18ac3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $ddcb86ca7ae18ac3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $ddcb86ca7ae18ac3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $ddcb86ca7ae18ac3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $ddcb86ca7ae18ac3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $ddcb86ca7ae18ac3$var$result.android = /Android \d/.test(navigator.userAgent);
    $ddcb86ca7ae18ac3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $ddcb86ca7ae18ac3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $ddcb86ca7ae18ac3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $ddcb86ca7ae18ac3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $ddcb86ca7ae18ac3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $ddcb86ca7ae18ac3$export$3f2684e5d7cb1006() {
    return $ddcb86ca7ae18ac3$var$result;
}

});





parcelRegister("f1474", function(module, exports) {
$parcel$export(module.exports, "useMouseDownEvent", () => $cff9e6ab3d94642b$export$df67f318ded0283c);

var $7GSrC = parcelRequire("7GSrC");
const $cff9e6ab3d94642b$var$isNotLeftClick = (event)=>event.button !== 0;
const $cff9e6ab3d94642b$export$df67f318ded0283c = (onMouseDown)=>{
    return (0, $7GSrC.useLinkClicked)(onMouseDown, $cff9e6ab3d94642b$var$isNotLeftClick);
};

});



parcelRegister("5WltR", function(module, exports) {
$parcel$export(module.exports, "HyperlinkWithSmartLinkResolver", () => $3e565064820217d9$export$1fdb4f77fe528a52);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $fcCIH = parcelRequire("fcCIH");

var $4TeS8 = parcelRequire("4TeS8");

var $iIrBK = parcelRequire("iIrBK");

var $4qbnX = parcelRequire("4qbnX");

var $ec9Mk = parcelRequire("ec9Mk");

var $baiO5 = parcelRequire("baiO5");

var $6sD3Q = parcelRequire("6sD3Q");

var $8f4S4 = parcelRequire("8f4S4");

var $eaXI0 = parcelRequire("eaXI0");

var $ChNgn = parcelRequire("ChNgn");
const $3e565064820217d9$var$HyperlinkFallbackComponent = ()=>null;
const $3e565064820217d9$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $ec9Mk.default)(props === null || props === void 0 ? void 0 : props.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $baiO5.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DefaultComponent, props);
    };
const $3e565064820217d9$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { state: state } = (0, $4qbnX.default)({
        href: props.href || ''
    });
    const thirdPartyARI = (0, $iIrBK.getThirdPartyARI)(state === null || state === void 0 ? void 0 : state.details);
    const firstPartyIdentifier = (0, $4TeS8.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $eaXI0.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI);
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = (state === null || state === void 0 ? void 0 : state.status) === 'resolved' && fire3PClickEvent;
    const onClick = (0, $fc4bM.useCallback)((e)=>{
        // button === 0 is left-click, see
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (shouldFire3PClickEvent && (e === null || e === void 0 ? void 0 : e.button) === 0) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent();
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onAuxClick = (0, $fc4bM.useCallback)((e)=>{
        // isAuxClick guards against Windows right-clicks firing onAuxClick with button === 2.
        if ((0, $6sD3Q.isAuxClick)(e) && shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onContextMenu = (0, $fc4bM.useCallback)((_e)=>{
        if (shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ChNgn.default), {
        ...props,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    });
};
const $3e565064820217d9$export$1fdb4f77fe528a52 = (0, $1VpRA.withErrorBoundary)($3e565064820217d9$var$withValidator((0, $fcCIH.default)((0, $8f4S4.default)($3e565064820217d9$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $ChNgn.default)), {
    FallbackComponent: $3e565064820217d9$var$HyperlinkFallbackComponent
});

});
parcelRegister("4TeS8", function(module, exports) {
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $149180c2b506bd47$export$48b4e58cdb8031ba);
// Helper function to extract page ID from standard Confluence page URLs
const $149180c2b506bd47$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $149180c2b506bd47$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $149180c2b506bd47$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $149180c2b506bd47$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
const $149180c2b506bd47$export$48b4e58cdb8031ba = ()=>{
    if (typeof window === 'undefined') return undefined;
    const product = $149180c2b506bd47$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $149180c2b506bd47$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $149180c2b506bd47$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $149180c2b506bd47$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};

});

parcelRegister("iIrBK", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyARI", () => $cefef833f871b279$export$e029950864672b4);
const $cefef833f871b279$export$e029950864672b4 = (details)=>{
    if (details !== null && details !== void 0 && details.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
    if (details !== null && details !== void 0 && details.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
        const ari = details.data['atlassian:ari'];
        if (ari.includes('ari:third-party')) return ari;
    }
    return undefined;
};

});

parcelRegister("4qbnX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f61801f044c3534$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $fVrlX = parcelRequire("fVrlX");

var $7Wdq8 = parcelRequire("7Wdq8");

var $8yp28 = parcelRequire("8yp28");

var $6PbEY = parcelRequire("6PbEY");

var $lBTn5 = parcelRequire("lBTn5");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $jKScA = parcelRequire("jKScA");

var $fzYCU = parcelRequire("fzYCU");

var $1mQD1 = parcelRequire("1mQD1");
const $2f61801f044c3534$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $fc4bM.useState)(()=>(0, $eUgRu.default)());
    const state = (0, $fzYCU.useSmartCardState)(href);
    const definitionId = (0, $6ZxOX.getDefinitionId)(state.details);
    const extensionKey = (0, $96gGh.getExtensionKey)(state.details);
    const resourceType = (0, $jKScA.getResourceType)(state.details);
    const actions = (0, $lBTn5.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $1mQD1.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $fc4bM.useEffect)(()=>{
        (0, $6PbEY.mark)(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            (0, $7Wdq8.create)(id, state.status);
            if (state.status === 'resolved') {
                var _getMeasure;
                fireEvent('operational.hyperlink.resolved', {
                    definitionId: definitionId ?? null,
                    extensionKey: extensionKey ?? null,
                    resourceType: resourceType ?? null,
                    duration: ((_getMeasure = (0, $8yp28.getMeasure)(id, state.status)) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) ?? null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $2f61801f044c3534$export$2e2bcd8739ae039 = $2f61801f044c3534$var$useResolveHyperlink;

});
parcelRegister("fVrlX", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $5b2fff33ac612bbd$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::7d3d9083d0211b0990b4c41be73c44fd>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen smart-card
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $6hfZf = parcelRequire("6hfZf");

var $bE7Mx = parcelRequire("bE7Mx");
const $5b2fff33ac612bbd$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const fireEvent = (0, $fc4bM.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $bE7Mx.default)(...params));
        event.fire((0, $6hfZf.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("6hfZf", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $352ad73b2ff5c393$export$3f072f06b90c3985);
const $352ad73b2ff5c393$export$3f072f06b90c3985 = 'media';

});

parcelRegister("bE7Mx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9860e2429dc743eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::fe05c93b9e82ab4b7ef821abc44c49bb>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen smart-card
 */ const $9860e2429dc743eb$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $9860e2429dc743eb$export$2e2bcd8739ae039 = $9860e2429dc743eb$var$createEventPayload;

});


parcelRegister("7Wdq8", function(module, exports) {
$parcel$export(module.exports, "create", () => $09ffdc82edba51b3$export$185802fd694ee1f5);

var $3E6mq = parcelRequire("3E6mq");

var $8yp28 = parcelRequire("8yp28");

var $8exdt = parcelRequire("8exdt");

var $bvUI5 = parcelRequire("bvUI5");
const $09ffdc82edba51b3$var$getMark = (id, status)=>{
    if (0, $bvUI5.hasPerformanceAPIAvailable) {
        const name = (0, $3E6mq.getMarkName)(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $09ffdc82edba51b3$export$185802fd694ee1f5 = (id, status)=>{
    if (0, $bvUI5.hasPerformanceAPIAvailable) {
        const name = (0, $8exdt.getMeasureName)(id, status);
        const measure = (0, $8yp28.getMeasure)(id, status);
        if (!measure) {
            const startMark = $09ffdc82edba51b3$var$getMark(id, 'pending');
            const endMark = $09ffdc82edba51b3$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});
parcelRegister("3E6mq", function(module, exports) {
$parcel$export(module.exports, "getMarkName", () => $9c317e91304950d6$export$fcff3185c7ce7f2b);
const $9c317e91304950d6$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;

});

parcelRegister("8yp28", function(module, exports) {
$parcel$export(module.exports, "getMeasure", () => $90cdd5fdfedeb6dc$export$d6e97a903ae9a3aa);

var $8exdt = parcelRequire("8exdt");

var $bvUI5 = parcelRequire("bvUI5");
const $90cdd5fdfedeb6dc$export$d6e97a903ae9a3aa = (id, status)=>{
    if (0, $bvUI5.hasPerformanceAPIAvailable) {
        const name = (0, $8exdt.getMeasureName)(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};

});
parcelRegister("8exdt", function(module, exports) {
$parcel$export(module.exports, "getMeasureName", () => $711a8640169135de$export$984df7f61dd7928f);
const $711a8640169135de$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;

});

parcelRegister("bvUI5", function(module, exports) {
$parcel$export(module.exports, "hasPerformanceAPIAvailable", () => $6293c3724f82cdfc$export$8dfeb9778591bc94);

var $KnpSa = parcelRequire("KnpSa");
const $6293c3724f82cdfc$export$8dfeb9778591bc94 = (0, $KnpSa.isPerformanceAPIAvailable)();

});
parcelRegister("KnpSa", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $9598d7f3244a8def$export$b5717a625dd4a3eb);
const $9598d7f3244a8def$export$b5717a625dd4a3eb = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};

});




parcelRegister("6PbEY", function(module, exports) {
$parcel$export(module.exports, "mark", () => $bfc32f2ac84180b8$export$bf7f2fce5c1cf636);

var $3E6mq = parcelRequire("3E6mq");

var $bvUI5 = parcelRequire("bvUI5");
const $bfc32f2ac84180b8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if (0, $bvUI5.hasPerformanceAPIAvailable) {
        const name = (0, $3E6mq.getMarkName)(id, status);
        performance.mark(name);
    }
};

});

parcelRegister("lBTn5", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $4135a77948d4fcd5$export$f7c340395f31e832);

var $fc4bM = parcelRequire("fc4bM");

var $kzNPc = parcelRequire("kzNPc");

var $9b5Ea = parcelRequire("9b5Ea");

var $fnEFU = parcelRequire("fnEFU");

var $cSf11 = parcelRequire("cSf11");

var $bi3GB = parcelRequire("bi3GB");

var $dRkX9 = parcelRequire("dRkX9");

var $8e3eG = parcelRequire("8e3eG");

var $aEmSo = parcelRequire("aEmSo");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $f4Od9 = parcelRequire("f4Od9");

var $k7o0P = parcelRequire("k7o0P");

var $7UUfD = parcelRequire("7UUfD");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $9pwnX = parcelRequire("9pwnX");

var $i8iZD = parcelRequire("i8iZD");

var $cA6hx = parcelRequire("cA6hx");

var $fypiH = parcelRequire("fypiH");
const $4135a77948d4fcd5$var$POST_AUTH_CHAT_EXTENSION_KEY = 'google-object-provider';
// Smart Card resolver key differs from the consumer-facing Rovo payload key.
const $4135a77948d4fcd5$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY = 'google-drive';
const $4135a77948d4fcd5$var$SMART_LINK_3P_POST_AUTH_SOURCE = 'smart-link-3p-post-auth';
const $4135a77948d4fcd5$var$getPostAuthChatPayloadId = ()=>{
    if (typeof crypto !== 'undefined') {
        if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        if (typeof crypto.getRandomValues === 'function') {
            const values = new Uint32Array(4);
            crypto.getRandomValues(values);
            return `smart-link-post-auth-chat-${Array.from(values, (value)=>value.toString(16)).join('-')}`;
        }
    }
    return `smart-link-post-auth-chat-${Date.now()}`;
};
const $4135a77948d4fcd5$var$sendPostAuthChatOpenMessage = (url, documentTitle)=>{
    var _window$parent;
    if (typeof window === 'undefined' || typeof ((_window$parent = window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage) !== 'function') return;
    const payload = {
        type: 'chat-smartlink-3p-post-auth-launch',
        source: $4135a77948d4fcd5$var$SMART_LINK_3P_POST_AUTH_SOURCE,
        openChat: true,
        openChatMode: 'mini-modal',
        data: {
            extensionKey: $4135a77948d4fcd5$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY,
            provider: 'Google Drive',
            projectContext: {
                projectId: url,
                projectName: documentTitle ?? 'Google Drive',
                projectUrl: url
            }
        }
    };
    window.parent.postMessage({
        eventType: (0, $8e3eG.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: $4135a77948d4fcd5$var$getPostAuthChatPayloadId()
    }, '*');
};
const $4135a77948d4fcd5$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $fypiH.default)();
    const invokeClientAction = (0, $cA6hx.default)({});
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const flags = (0, $i8iZD.default)();
    const { store: store, rovoOptions: rovoOptions } = (0, $fnEFU.useSmartLinkContext)();
    const rovoOptionsRef = (0, $fc4bM.useRef)(rovoOptions);
    rovoOptionsRef.current = rovoOptions;
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $fc4bM.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $j9rqA.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $fc4bM.useCallback)((metadataStatus)=>{
        dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    // Original resolve function — signature kept intact for maximum safety when FG is off.
    const resolve = (0, $fc4bM.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id
        }), [
        id,
        resolveUrl,
        url
    ]);
    // New resolve function accepting ResolveUrlParams (minus 'id' which is closed over).
    // Used when FG is enabled to pass appearance to ORS.
    const resolveNew = (0, $fc4bM.useCallback)(async (params = {})=>{
        const { url: resourceUrl = url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, appearance: appearance } = params;
        return resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id,
            appearance: appearance
        });
    }, [
        id,
        resolveUrl,
        url
    ]);
    /**
   * Register a smart link for resolution.
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ const register = (0, $fc4bM.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_RESOLVING), {
                url: url
            }));
            // Always set metadataStatus to 'pending' during registration to prevent
            // loadMetadata from firing a duplicate concurrent fetch if a hover card
            // mounts while registration is in-flight. This matches pre-PR behaviour.
            setMetadataStatus('pending');
        }
        if ((0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) return resolveNew({
            url: url,
            appearance: appearance
        });
        return resolve(url);
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $fc4bM.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $6ZxOX.getDefinitionId)(details);
        if ((0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) {
            if (definitionId) (0, $7UUfD.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolveNew({
                    url: reloadUrl,
                    isReloading: true,
                    appearance: appearance
                }));
            else resolveNew({
                url: url,
                isReloading: true,
                appearance: appearance
            });
        } else if (definitionId) (0, $7UUfD.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolve(reloadUrl, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve,
        resolveNew
    ]);
    /**
   * Load metadata for hover card preview.
   * This always requests 'block' appearance to get full data including summary.
   *
   * Inline optimized and SSR-resolved links keep metadataStatus pending until hover
   * requests the full block response.
   */ const loadMetadata = (0, $fc4bM.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        const needsBlockData = metadataStatus === undefined || metadataStatus === 'pending' && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization');
        if (needsBlockData) {
            setMetadataStatus('pending');
            if ((0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) // Always request 'block' appearance for hover card metadata to get full data
            return resolveNew({
                url: url,
                isMetadataRequest: true,
                appearance: 'block'
            });
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $fc4bM.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $6ZxOX.getDefinitionId)(details);
        const extensionKey = (0, $96gGh.getExtensionKey)(details);
        const isSupportedPostAuthChatExtensionKey = extensionKey === $4135a77948d4fcd5$var$POST_AUTH_CHAT_EXTENSION_KEY;
        const services = (0, $9pwnX.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $bi3GB.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $k7o0P.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                // Post-auth Chat onboarding: auto-open Rovo Chat mini-modal with the
                // authed 3P link as context, for supported providers (e.g. Google Drive).
                // Provider eligibility is derived from the pre-auth SmartLink state.
                const isEligibleForPostAuthChat = status === 'unauthorized' && isSupportedPostAuthChatExtensionKey && (0, $dRkX9.fg)('platform_sl_3p_post_auth_chat_open_fg') && (0, $f4Od9.getIsRovoChatEnabled)(rovoOptionsRef.current);
                // Experiment check: fires exposure for both control and treatment.
                // Only reached after eligibility preconditions + kill switch pass, so
                // exposure is counted for the triggered eligible pool.
                const isPostAuthChatTreatment = isEligibleForPostAuthChat && (0, $aEmSo.expValEquals)('platform_sl_3p_post_auth_chat_open_exp', 'isEnabled', true);
                if (status === 'unauthorized' && !isPostAuthChatTreatment) {
                    const provider = (0, $kzNPc.extractSmartLinkProvider)(details);
                    flags.showConnectFlag({
                        id: `smart-link-connect-success-${extensionKey}`,
                        provider: provider
                    });
                }
                reload();
                if (isPostAuthChatTreatment) $4135a77948d4fcd5$var$sendPostAuthChatOpenMessage(url, (0, $9b5Ea.extractSmartLinkTitle)(details));
            }, (err)=>{
                (0, $k7o0P.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent,
        flags,
        url
    ]);
    const invoke = (0, $fc4bM.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("kzNPc", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkProvider", () => $20e7a1ffed08b0f6$export$ff753ed519e96e9e);

var $5NVZG = parcelRequire("5NVZG");

var $7fCRQ = parcelRequire("7fCRQ");

var $6G8gX = parcelRequire("6G8gX");
const $20e7a1ffed08b0f6$export$ff753ed519e96e9e = (response)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) return (0, $5NVZG.extractEntityProvider)(response);
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $7fCRQ.extractProvider)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("5NVZG", function(module, exports) {
$parcel$export(module.exports, "extractEntityProvider", () => $c0b5de4eb5882ba7$export$ad879f2c9d5100a0);

var $fc4bM = parcelRequire("fc4bM");

var $eLXbZ = parcelRequire("eLXbZ");

var $6lBxt = parcelRequire("6lBxt");

var $dRkX9 = parcelRequire("dRkX9");

var $bA4RK = parcelRequire("bA4RK");

var $2IY91 = parcelRequire("2IY91");

var $2okdt = parcelRequire("2okdt");
const $c0b5de4eb5882ba7$export$ad879f2c9d5100a0 = (response)=>{
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) return undefined;
    if (!(0, $dRkX9.fg)('platform_lp_use_generator_icon_for_provider')) {
        const entityIcon = (0, $2okdt.extractEntityIcon)(response);
        if (entityIcon) return (0, $bA4RK.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        });
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $2IY91.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eLXbZ.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $2IY91.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6lBxt.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $bA4RK.rebrandProvider)({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        iconLabel: name
    });
};

});
parcelRegister("eLXbZ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $f1b010436cebc060$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932d47dd87f3f2976aabd1b4699b27b4>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $b3n1a = parcelRequire("b3n1a");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f1b010436cebc060$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $f1b010436cebc060$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $f1b010436cebc060$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b3n1a.IconWrapper), {
        svg: $f1b010436cebc060$var$svg,
        customThemeSvg: $f1b010436cebc060$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("b3n1a", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $6a0c384a74745539$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $anluN = parcelRequire("anluN");
const $6a0c384a74745539$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a0c384a74745539$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a0c384a74745539$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a0c384a74745539$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a0c384a74745539$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $6a0c384a74745539$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $6a0c384a74745539$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a0c384a74745539$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $6a0c384a74745539$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $2R2iS.default)([
            $6a0c384a74745539$var$styles.root,
            $6a0c384a74745539$var$sizeMap[size],
            colorMode === 'dark' ? $6a0c384a74745539$var$dataCenterDarkAppearanceMap[appearance] : $6a0c384a74745539$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $6a0c384a74745539$var$rovoDarkAppearanceMap[appearance] : $6a0c384a74745539$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $6a0c384a74745539$var$cloudDarkAppearanceMap[appearance] : $6a0c384a74745539$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $dRkX9.fg)('assets-platform-branding') || (0, $dRkX9.fg)('assets-platform-branding-v2')) && $6a0c384a74745539$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("6lBxt", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $b2a2fc45c24f1a1e$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0e4bfbb3ca87324a6e97db845b2ae2c>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $b3n1a = parcelRequire("b3n1a");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b2a2fc45c24f1a1e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $b2a2fc45c24f1a1e$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $b2a2fc45c24f1a1e$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b3n1a.IconWrapper), {
        svg: $b2a2fc45c24f1a1e$var$svg,
        customThemeSvg: $b2a2fc45c24f1a1e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bA4RK", function(module, exports) {
$parcel$export(module.exports, "rebrandProvider", () => $8a4d8533b06ebe62$export$df1b15aebbcf717e);
const $8a4d8533b06ebe62$var$GOOGLE_DRIVE = 'Google Drive';
const $8a4d8533b06ebe62$export$df1b15aebbcf717e = (provider)=>{
    switch(provider === null || provider === void 0 ? void 0 : provider.text){
        case 'Google':
            return {
                ...provider,
                iconLabel: $8a4d8533b06ebe62$var$GOOGLE_DRIVE,
                text: $8a4d8533b06ebe62$var$GOOGLE_DRIVE
            };
        default:
            return provider;
    }
};

});

parcelRegister("2IY91", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $07205668d03ddeaa$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $07205668d03ddeaa$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $07205668d03ddeaa$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $07205668d03ddeaa$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $07205668d03ddeaa$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $07205668d03ddeaa$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $07205668d03ddeaa$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $07205668d03ddeaa$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $07205668d03ddeaa$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $07205668d03ddeaa$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $07205668d03ddeaa$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $07205668d03ddeaa$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "SmartLinkSize", () => $07205668d03ddeaa$export$51f13ced115cbdae);
$parcel$export(module.exports, "IconType", () => $07205668d03ddeaa$export$13ff1290a9e22e77);
const $07205668d03ddeaa$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $07205668d03ddeaa$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $07205668d03ddeaa$export$84a73a0383f58180 = 'JiraTask';
const $07205668d03ddeaa$export$c6c83963a9378a67 = 'JiraSubTask';
const $07205668d03ddeaa$export$58af3c426c111a6d = 'JiraStory';
const $07205668d03ddeaa$export$ac9898a63417219e = 'JiraBug';
const $07205668d03ddeaa$export$54db5e3fb12e39cd = 'JiraEpic';
const $07205668d03ddeaa$export$2f54a5a217202c85 = 'JiraIncident';
const $07205668d03ddeaa$export$d097371052bfc411 = 'JiraServiceRequest';
const $07205668d03ddeaa$export$efd9452ad16c6676 = 'JiraChange';
const $07205668d03ddeaa$export$2e7e70abb5d81f67 = 'JiraProblem';
const $07205668d03ddeaa$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $07205668d03ddeaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $07205668d03ddeaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});

});

parcelRegister("2okdt", function(module, exports) {
$parcel$export(module.exports, "extractEntityIcon", () => $2a3e6f1d7398e893$export$19346520e937a99f);

var $6s2Op = parcelRequire("6s2Op");

var $6VVze = parcelRequire("6VVze");

var $drnK3 = parcelRequire("drnK3");

var $YqY0I = parcelRequire("YqY0I");
const $2a3e6f1d7398e893$export$19346520e937a99f = (response)=>{
    const entity = (0, $YqY0I.extractEntity)(response);
    if (!entity) return undefined;
    if (!(0, $6s2Op.isBaseEntity)(entity)) return undefined;
    if ((0, $6VVze.isDesignEntity)(entity) && entity.iconUrl) return {
        url: entity.iconUrl,
        label: entity.type
    };
    if ((0, $drnK3.isDocumentEntity)(entity) && entity.type.iconUrl) return {
        url: entity.type.iconUrl,
        label: entity.type.category
    };
    // When JSON-LD is deprecated, we can change this to returning entity provider icon.
    // For now code upstream will return better result when this method returns undefined.
    return undefined;
};

});
parcelRegister("6s2Op", function(module, exports) {
$parcel$export(module.exports, "isBaseEntity", () => $985be1220a4e1251$export$12af7c5462954d1e);

var $6Yza6 = parcelRequire("6Yza6");
const $985be1220a4e1251$export$12af7c5462954d1e = (value)=>(0, $6Yza6.isObject)(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';

});
parcelRegister("6Yza6", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $decf9f14c7545dc1$export$a6cdc56e425d0d0a);
const $decf9f14c7545dc1$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;

});


parcelRegister("6VVze", function(module, exports) {
$parcel$export(module.exports, "isDesignEntity", () => $f9d37f3799721d41$export$8dc9be81b5b6266b);

var $53Kf2 = parcelRequire("53Kf2");

var $b9XRy = parcelRequire("b9XRy");

var $6s2Op = parcelRequire("6s2Op");

var $5QT41 = parcelRequire("5QT41");
const $f9d37f3799721d41$export$8dc9be81b5b6266b = (value)=>(0, $6s2Op.isBaseEntity)(value) && (0, $5QT41.isOneOf)((0, $b9XRy.DESIGN_STATUSES), (0, $53Kf2.asRecord)(value).status) && (0, $5QT41.isOneOf)((0, $b9XRy.DESIGN_TYPES), (0, $53Kf2.asRecord)(value).type);

});
parcelRegister("53Kf2", function(module, exports) {
$parcel$export(module.exports, "asRecord", () => $5949bc997cb98829$export$badcc9423dc3e1c1);
const $5949bc997cb98829$export$badcc9423dc3e1c1 = (value)=>value;

});

parcelRegister("b9XRy", function(module, exports) {
$parcel$export(module.exports, "DESIGN_TYPES", () => $4a4b736841128be5$export$7d4721a36ceb2894);
$parcel$export(module.exports, "DESIGN_STATUSES", () => $4a4b736841128be5$export$fcc968815a3eb9c5);
$parcel$export(module.exports, "DOCUMENT_CATEGORIES", () => $4a4b736841128be5$export$892192ec11178e3c);
const $4a4b736841128be5$export$7d4721a36ceb2894 = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $4a4b736841128be5$export$fcc968815a3eb9c5 = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $4a4b736841128be5$export$a544329e8f55f05 = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $4a4b736841128be5$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $4a4b736841128be5$export$cfae73bab05203cf = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $4a4b736841128be5$export$892192ec11178e3c = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];

});

parcelRegister("5QT41", function(module, exports) {
$parcel$export(module.exports, "isOneOf", () => $5b5f14226f757ec7$export$532a90c0e5e8e48c);
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $5b5f14226f757ec7$export$532a90c0e5e8e48c = (values, value)=>typeof value === 'string' && values.includes(value);

});


parcelRegister("drnK3", function(module, exports) {
$parcel$export(module.exports, "isDocumentEntity", () => $65ffae09231eef32$export$32c06ee7e0e9b79e);

var $53Kf2 = parcelRequire("53Kf2");

var $b9XRy = parcelRequire("b9XRy");

var $6s2Op = parcelRequire("6s2Op");

var $6Yza6 = parcelRequire("6Yza6");

var $5QT41 = parcelRequire("5QT41");
const $65ffae09231eef32$export$32c06ee7e0e9b79e = (value)=>{
    if (!(0, $6s2Op.isBaseEntity)(value)) return false;
    const entityType = (0, $53Kf2.asRecord)(value).type;
    return (0, $6Yza6.isObject)(entityType) && (entityType.category === undefined || (0, $5QT41.isOneOf)((0, $b9XRy.DOCUMENT_CATEGORIES), entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ((0, $5QT41.isOneOf)((0, $b9XRy.DOCUMENT_CATEGORIES), entityType.category) || typeof entityType.iconUrl === 'string');
};

});



parcelRegister("7fCRQ", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $aab794d7649046a1$export$a832871718466647);

var $bA4RK = parcelRequire("bA4RK");

var $6Eo84 = parcelRequire("6Eo84");

var $8BY94 = parcelRequire("8BY94");
const $aab794d7649046a1$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $8BY94.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $8BY94.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $aab794d7649046a1$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $bA4RK.rebrandProvider)({
                text: generator.name
            });
        } else if (generator.name) {
            const id = generator['@id'];
            return (0, $bA4RK.rebrandProvider)({
                text: generator.name,
                icon: (0, $6Eo84.extractProviderIcon)(generator.icon, id),
                iconLabel: generator.name,
                id: id,
                image: $aab794d7649046a1$var$extractProviderImage(generator.image)
            });
        }
    }
    return undefined;
};

});
parcelRegister("6Eo84", function(module, exports) {
$parcel$export(module.exports, "extractProviderIcon", () => $8ba9b9d55eea2cd6$export$6fb636a2ac885215);

var $fc4bM = parcelRequire("fc4bM");

var $eLXbZ = parcelRequire("eLXbZ");

var $6lBxt = parcelRequire("6lBxt");

var $2IY91 = parcelRequire("2IY91");

var $6Hxqo = parcelRequire("6Hxqo");
const $8ba9b9d55eea2cd6$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $2IY91.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eLXbZ.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $2IY91.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6lBxt.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $6Hxqo.extractUrlFromIconJsonLd)(icon);
    return undefined;
};

});
parcelRegister("6Hxqo", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $142ba11b655506d0$export$67f3d92c824fd850);

var $8BY94 = parcelRequire("8BY94");
const $142ba11b655506d0$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $8BY94.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $8BY94.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});




parcelRegister("9b5Ea", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $36bea96a85d7fb44$export$3eda18658b66108);

var $YqY0I = parcelRequire("YqY0I");

var $4Dem6 = parcelRequire("4Dem6");

var $6G8gX = parcelRequire("6G8gX");
const $36bea96a85d7fb44$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    return (0, $4Dem6.extractTitle)(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};

});
parcelRegister("4Dem6", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $06485b1c1a91a3d3$export$b05803156e5015b6);

var $35LkA = parcelRequire("35LkA");

var $lOxou = parcelRequire("lOxou");
const $06485b1c1a91a3d3$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    var _jsonLd$name;
    if (!jsonLd) return undefined;
    const name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $35LkA.extractContext)(jsonLd);
    const type = (0, $lOxou.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("35LkA", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $e52f8fcc3c05b9cb$export$efdbd45f3e77a161);

var $lOxou = parcelRequire("lOxou");

var $6Hxqo = parcelRequire("6Hxqo");
const $e52f8fcc3c05b9cb$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $lOxou.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("lOxou", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $22c7124915fc2e32$export$2e9ae379995d99e3);
const $22c7124915fc2e32$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});




parcelRegister("fnEFU", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkContext", () => $0f0e08118467a02a$export$e1d190b530cf0ee9);

var $fc4bM = parcelRequire("fc4bM");

var $gAa0D = parcelRequire("gAa0D");
function $0f0e08118467a02a$export$e1d190b530cf0ee9() {
    const context = (0, $fc4bM.useContext)((0, $gAa0D.SmartCardContext));
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}

});

parcelRegister("bi3GB", function(module, exports) {
$parcel$export(module.exports, "auth", () => $dc092c0b28b0c684$export$73693bad9f5880b0);

var $aJwDw = parcelRequire("aJwDw");

var $kJDwO = parcelRequire("kJDwO");
function $dc092c0b28b0c684$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $kJDwO.isOfTypeAuthError)(errorType)) reject(new (0, $aJwDw.AuthError)(data.message, errorType));
                    else reject(new (0, $aJwDw.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $aJwDw.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("aJwDw", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $d580f27aaaca1071$export$145273558d58e0ac);
class $d580f27aaaca1071$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("kJDwO", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $f218cf93b16fa020$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $f218cf93b16fa020$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("8e3eG", function(module, exports) {
$parcel$export(module.exports, "ROVO_POST_MESSAGE_EVENT_TYPE", () => $074df042b0a4555c$export$cabfb6cc8c48b099);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $074df042b0a4555c$export$5340cc94dd0ecbea);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $4jZpi = parcelRequire("4jZpi");
const $074df042b0a4555c$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $074df042b0a4555c$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $074df042b0a4555c$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $074df042b0a4555c$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $074df042b0a4555c$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($074df042b0a4555c$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $074df042b0a4555c$var$allowedOrigins.includes(hostname));
};
const $074df042b0a4555c$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $4jZpi.usePublish)('ai-mate');
    (0, $fc4bM.useEffect)(()=>{
        const handlerUnbind = (0, $6Zi52.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$074df042b0a4555c$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $074df042b0a4555c$export$cabfb6cc8c48b099) {
                    var _event$source;
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $074df042b0a4555c$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    (_event$source = event.source) === null || _event$source === void 0 || _event$source.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $074df042b0a4555c$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $074df042b0a4555c$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $fc4bM.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $fc4bM.useState)(false);
    (0, $fc4bM.useEffect)(()=>{
        const handlerUnbind = (0, $6Zi52.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$074df042b0a4555c$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $074df042b0a4555c$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $fc4bM.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $074df042b0a4555c$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $074df042b0a4555c$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("4jZpi", function(module, exports) {
$parcel$export(module.exports, "usePublish", () => $30b12ef52fdd02cb$export$d55c81786220731c);
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- command callers cannot use hooks */ 
var $fc4bM = parcelRequire("fc4bM");
const $30b12ef52fdd02cb$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $30b12ef52fdd02cb$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    'agent-editor-open-tools',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'conversation-read',
    'smartlinks-context-payload',
    'set-message-context',
    'jira-create-context-payload',
    'submit-rovo-remix',
    'rovo-remix-handoff-failed',
    'sync-prompt-input-draft'
]);
const $30b12ef52fdd02cb$var$isIgnoredForTriggerLatest = (type)=>$30b12ef52fdd02cb$var$ignoredTriggerLatestEvents.has(type);
const $30b12ef52fdd02cb$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $30b12ef52fdd02cb$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$30b12ef52fdd02cb$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    const clearLatest = (topic)=>{
        delete publishQueue[topic];
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue,
        clearLatest: clearLatest
    };
};
const $30b12ef52fdd02cb$var$pubSub = $30b12ef52fdd02cb$var$createPubSub();
const $30b12ef52fdd02cb$export$89b472e03be495df = (topic, payload)=>{
    $30b12ef52fdd02cb$var$pubSub.publish(topic, payload);
};
const $30b12ef52fdd02cb$var$usePubSub = ()=>{
    return $30b12ef52fdd02cb$var$pubSub;
};
const $30b12ef52fdd02cb$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, clearLatestOnUnmount: clearLatestOnUnmount, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe, clearLatest: clearLatest } = $30b12ef52fdd02cb$var$usePubSub();
    const callbackRef = (0, $fc4bM.useRef)(callback);
    callbackRef.current = callback;
    (0, $fc4bM.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return ()=>{
            unsubscribe();
            if (clearLatestOnUnmount) clearLatest(topic);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        clearLatestOnUnmount,
        consumeOnceKey
    ]);
};
const $30b12ef52fdd02cb$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $30b12ef52fdd02cb$var$usePubSub();
    const callbackRef = (0, $fc4bM.useRef)(callback);
    callbackRef.current = callback;
    (0, $fc4bM.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $30b12ef52fdd02cb$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $30b12ef52fdd02cb$var$usePubSub();
    (0, $fc4bM.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $30b12ef52fdd02cb$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $30b12ef52fdd02cb$var$usePubSub();
    const publishFn = (0, $fc4bM.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $30b12ef52fdd02cb$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $30b12ef52fdd02cb$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $30b12ef52fdd02cb$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("j9rqA", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $a6c79dbb871a2dec$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $a6c79dbb871a2dec$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_ROVO", () => $a6c79dbb871a2dec$export$c36142a78ab570c5);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $a6c79dbb871a2dec$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $a6c79dbb871a2dec$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $a6c79dbb871a2dec$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $a6c79dbb871a2dec$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $a6c79dbb871a2dec$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $a6c79dbb871a2dec$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $a6c79dbb871a2dec$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $a6c79dbb871a2dec$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $a6c79dbb871a2dec$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $a6c79dbb871a2dec$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $a6c79dbb871a2dec$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $a6c79dbb871a2dec$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $a6c79dbb871a2dec$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $a6c79dbb871a2dec$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $a6c79dbb871a2dec$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $a6c79dbb871a2dec$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardAction", () => $a6c79dbb871a2dec$export$f40b7e0b762b928b);
$parcel$export(module.exports, "CardDisplay", () => $a6c79dbb871a2dec$export$6ca4ef8b3dc2c804);
const $a6c79dbb871a2dec$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $a6c79dbb871a2dec$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $a6c79dbb871a2dec$export$c36142a78ab570c5 = 'https://www.atlassian.com/trust/ai';
const $a6c79dbb871a2dec$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $a6c79dbb871a2dec$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $a6c79dbb871a2dec$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $a6c79dbb871a2dec$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $a6c79dbb871a2dec$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $a6c79dbb871a2dec$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $a6c79dbb871a2dec$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $a6c79dbb871a2dec$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $a6c79dbb871a2dec$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $a6c79dbb871a2dec$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $a6c79dbb871a2dec$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $a6c79dbb871a2dec$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    ActionName["RovoChatAction"] = "RovoChatAction";
    return ActionName;
}({});
var $a6c79dbb871a2dec$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $a6c79dbb871a2dec$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $a6c79dbb871a2dec$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $a6c79dbb871a2dec$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $a6c79dbb871a2dec$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
var $a6c79dbb871a2dec$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("f4Od9", function(module, exports) {
$parcel$export(module.exports, "getIsRovoChatEnabled", () => $af77d7cdb811db2a$export$e9a534e68169723d);
const $af77d7cdb811db2a$export$e9a534e68169723d = (rovoConfig)=>rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoEnabled && rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoLLMEnabled ? true : false;

});

parcelRegister("k7o0P", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $f63ea42c6c7c2ca6$export$5e9287b6a10f8075);

var $4Y0sD = parcelRequire("4Y0sD");
const $f63ea42c6c7c2ca6$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = (0, $4Y0sD.ufoExperiences)[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};

});
parcelRegister("4Y0sD", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $da1bb06f6cea143b$export$615f888019c45765);

var $dfnp7 = parcelRequire("dfnp7");

var $kjVFD = parcelRequire("kjVFD");
const $da1bb06f6cea143b$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $kjVFD.ExperienceTypes).Experience,
    performanceType: (0, $kjVFD.ExperiencePerformanceTypes).InlineResult
};
const $da1bb06f6cea143b$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $kjVFD.ExperienceTypes).Load,
    performanceType: (0, $kjVFD.ExperiencePerformanceTypes).PageSegmentLoad
};
const $da1bb06f6cea143b$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $kjVFD.ExperienceTypes).Experience,
    performanceType: (0, $kjVFD.ExperiencePerformanceTypes).InlineResult
};
const $da1bb06f6cea143b$export$615f888019c45765 = {
    'smart-link-rendered': new (0, $dfnp7.ConcurrentExperience)('smart-link-rendered', $da1bb06f6cea143b$var$renderExperience),
    'smart-link-authenticated': new (0, $dfnp7.ConcurrentExperience)('smart-link-authenticated', $da1bb06f6cea143b$var$inlineExperience),
    'smart-link-action-invocation': new (0, $dfnp7.ConcurrentExperience)('smart-link-action-invocation', $da1bb06f6cea143b$var$inlineExperience),
    'smart-link-ai-summary': new (0, $dfnp7.ConcurrentExperience)('smart-link-ai-summary', $da1bb06f6cea143b$var$aiExperience)
};

});


parcelRegister("7UUfD", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $039596e68a2366db$export$f75b0b690ab4dfb9);
const $039596e68a2366db$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};

});

parcelRegister("6ZxOX", function(module, exports) {
$parcel$export(module.exports, "getDefinitionId", () => $784c874e597930bc$export$46fa3e7718c82e41);
const $784c874e597930bc$export$46fa3e7718c82e41 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};

});

parcelRegister("96gGh", function(module, exports) {
$parcel$export(module.exports, "getExtensionKey", () => $cf4e50ea6b82e987$export$218d96312e385949);
const $cf4e50ea6b82e987$export$218d96312e385949 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key;
};

});

parcelRegister("9pwnX", function(module, exports) {
$parcel$export(module.exports, "getServices", () => $12c1a4cac5045c78$export$a009e3a1163d46fb);
const $12c1a4cac5045c78$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];

});

parcelRegister("i8iZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $394551a67617dc48$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $ewFKq = parcelRequire("ewFKq");

var $4mDZ7 = parcelRequire("4mDZ7");

var $lNNaL = parcelRequire("lNNaL");
const $394551a67617dc48$var$FLAG_ICON_SIZE = '16px';
const $394551a67617dc48$var$renderIcon = (iconUrlOrElement)=>{
    if (!iconUrlOrElement) return;
    const icon = iconUrlOrElement && typeof iconUrlOrElement === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4mDZ7.default), {
        height: $394551a67617dc48$var$FLAG_ICON_SIZE,
        testId: "sl-flag",
        url: iconUrlOrElement,
        width: $394551a67617dc48$var$FLAG_ICON_SIZE
    }) : iconUrlOrElement;
    return icon;
};
// Safe wrapper — returns null if IntlProvider is not in the tree
const $394551a67617dc48$var$useIntlSafe = ()=>{
    try {
        return (0, $gpjDl.default)();
    } catch  {
        return null;
    }
};
const $394551a67617dc48$var$useActionFlags = ()=>{
    const intl = $394551a67617dc48$var$useIntlSafe();
    const showConnectFlag = (0, $fc4bM.useCallback)(({ provider: provider, ...flagArgs } = {})=>{
        if (!intl) return;
        const context = (provider === null || provider === void 0 ? void 0 : provider.text) ?? intl.formatMessage((0, $ewFKq.messages).connect_link_account_success_flag_title_default);
        (0, $lNNaL.showFlag)({
            icon: $394551a67617dc48$var$renderIcon(provider === null || provider === void 0 ? void 0 : provider.icon),
            title: intl.formatMessage((0, $ewFKq.messages).connect_link_account_success_flag_title, {
                context: context
            }),
            description: intl.formatMessage((0, $ewFKq.messages).connect_link_account_success_flag_description),
            ...flagArgs
        });
    }, [
        intl
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            showConnectFlag: showConnectFlag
        }), [
        showConnectFlag
    ]);
};
var $394551a67617dc48$export$2e2bcd8739ae039 = $394551a67617dc48$var$useActionFlags;

});
parcelRegister("ewFKq", function(module, exports) {
$parcel$export(module.exports, "messages", () => $13079879f4412633$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $13079879f4412633$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: 'Title for a section or menu containing available actions for a resource.'
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Button label that allows the user to add and connect a new external account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summary_error_generic_rebrand: {
        id: 'fabric.linking.ai_summary_error_generic_rebrand',
        defaultMessage: "Rovo isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    change_status: {
        id: 'fabric.linking.change_status',
        defaultMessage: 'Change status: {status}',
        description: 'Aria label for the button to change the status of a linked resource.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel the current action or close the modal.'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Text shown in a lozenge badge on a smart link or card to indicate the feature is currently in beta.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: 'Label for a button or icon that closes the currently open modal dialog or overlay screen.'
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Heading shown at the top of the link safety warning modal, prompting the user to verify a potentially unsafe link before proceeding.'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}',
        description: 'Indicates the number of components the resource is applied to.'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_link_account_success_flag_description: {
        id: 'fabric.linking.connect_link_account_success_flag_description',
        defaultMessage: 'Shared links now display rich previews.',
        description: 'Shown in a flag after user successfully connect 3P account and Smart Link reload with metadata'
    },
    connect_link_account_success_flag_title: {
        id: 'fabric.linking.connect_link_account_success_flag_title',
        defaultMessage: '{context} is connected',
        description: 'Shown in a flag after user successfully connect 3P account. {context} is the name of link provider, e.g. Google, Figma, etc.'
    },
    connect_link_account_success_flag_title_default: {
        id: 'fabric.linking.connect_link_account_success_flag_title_default',
        defaultMessage: 'Smart Link',
        description: 'Default context for connect_link_account_success_flag_title when link provider name (Google, Figma, etc.) is not provided'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_3p_account: {
        id: 'fabric.linking.connect_3p_account.non-final',
        defaultMessage: 'Connect {context}',
        description: 'Shown on a button to connect user external 3P account to their Atlassian account, e.g. Connect Figma'
    },
    connect_inline_provider_to_update: {
        id: 'fabric.linking.connect_inline_provider_to_update.ai-non-final',
        defaultMessage: 'Connect {context} to update',
        description: 'Text shown on the connect button of an unauthorised inline Smart Link. {context} is replaced with the provider name, and update means updating the Smart Link preview after the account is connected.'
    },
    connect_inline_social_proof: {
        id: 'fabric.linking.connect_inline_social_proof',
        defaultMessage: 'Connect',
        description: 'Shown on a button for unauthorised inline smart links when the social proof inline CTA experiment is active. Replaces the longer "Connect your {context} account" label.'
    },
    connect_inline_to_update: {
        id: 'fabric.linking.connect_inline_to_update.ai-non-final',
        defaultMessage: 'Connect to update',
        description: 'Text shown on the connect button of an unauthorised inline Smart Link. It prompts the user to connect an account, and update means updating the Smart Link preview.'
    },
    social_proof_inline_cta_tag_high_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_with_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees {context} previews',
        description: 'Social-proof tag pill beside the shortcut "Connect" on an unauthorised inline smart link when adoption is not in the exploratory range. {connectedPct} is the approximate share seeing previews for the integration; {context} is the provider display name.'
    },
    social_proof_inline_cta_tag_high_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_no_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees richer previews',
        description: 'Social-proof tag pill when adoption is above the exploratory threshold and no provider display name is available; {connectedPct} is the approximate share seeing richer previews.'
    },
    social_proof_inline_cta_tag_low_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_with_context',
        defaultMessage: 'Your team sees richer {context} previews',
        description: 'Social-proof tag pill when share is below the percentage headline threshold; shown only when a provider display name is available. Omit the pill entirely when personalization is unavailable or the provider name is unknown.'
    },
    social_proof_inline_cta_tag_low_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_no_context',
        defaultMessage: 'Your team sees richer previews',
        description: 'Social-proof tag pill for the case when neither percentage nor provider display name are available.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'Label for a button that advances the user to the next step, e.g. in the link safety warning modal flow.'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: 'Action to copy the URL of the link to the clipboard.'
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly after the user copies a URL to the clipboard using the copy link action.'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Label for the delete action in a smart link or card action menu, allowing the user to remove the linked item.'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: 'Label for the download action in a smart link or card action menu, initiating a file download.'
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: "Tooltip or description text for the download action, explaining it saves the file to the user's local storage."
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Label for the download file action in a smart link or card action menu, allowing the user to save the linked file locally.'
    },
    ai_summary_action_rebrand: {
        id: 'fabric.linking.ai_summary_action_rebrand',
        defaultMessage: 'Summarize with Rovo',
        description: 'Label for the AI summarize action in a smart link or hover card action menu, allowing the user to generate an AI summary of the linked content.'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    ai_summary_action_description_rebrand: {
        id: 'fabric.linking.ai_summary_action_description_rebrand',
        defaultMessage: 'Summarize the content of this link using Rovo.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Label for the edit action in a smart link or card action menu, allowing the user to modify the linked item.'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Label for the follow button on a smart link card, allowing the user to subscribe to updates for the linked project or resource.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Tooltip or description text for the follow project button, explaining that clicking it enables notifications for the project.'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Label for the follow project button on a smart link card, allowing the user to subscribe to updates for the linked Atlassian project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Tooltip or description text for the follow goal button, explaining that clicking it enables notifications for updates to the goal.'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Label for the follow goal button on a smart link card, allowing the user to subscribe to updates for the linked Atlas goal.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'Label for a navigation button that returns the user to the previous step or screen in a modal flow.'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira issue in Jira.'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Label for the action button on a smart link card that opens the linked resource in a new browser tab.'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Tooltip or description text for the preview action on a smart link card, explaining it opens a full-screen embed preview of the linked content.'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_with_title: {
        id: 'smart-card.preview_with_title.ai-non-final',
        defaultMessage: 'Open preview for {title}',
        description: 'Accessible label for the smart link preview action. Opens a preview of the linked content. The {title} placeholder is the title of the linked resource, or its URL when no title is available.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_modal_with_title: {
        id: 'smart-card.preview_modal_with_title.ai-non-final',
        defaultMessage: 'Open preview modal for {title}',
        description: 'Accessible label for the smart link action that opens a preview modal. The {title} placeholder is the title of the linked resource, or its URL when no title is available.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_panel_with_title: {
        id: 'smart-card.preview_panel_with_title.ai-non-final',
        defaultMessage: 'Open preview panel for {title}',
        description: 'Accessible label for the smart link action that opens a preview side panel. The {title} placeholder is the title of the linked resource, or its URL when no title is available.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Label for the button that closes the embed preview modal dialog on a smart link card.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Blocker priority.'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Critical priority.'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has High priority.'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Highest priority.'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Low priority.'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Lowest priority.'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Major priority.'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Medium priority.'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Minor priority.'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Trivial priority.'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Label for a priority badge on a Jira issue smart link card when the priority level is not defined or unknown.'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Text shown on a smart link card displaying the estimated reading time. The placeholder {context} is substituted with the number of minutes.'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Label for a retry button shown on a smart link card after an error, allowing the user to attempt the failed action again.'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: "Label for a save button on a smart link card or action, confirming and persisting the user's changes."
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Label for a button shown on a smart link error state, prompting the user to retry the failed load or action.'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Warning message shown in the link safety modal. The placeholder {unsafeLinkText} is substituted with the suspicious link text, and <a> wraps the actual destination URL.'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    rovo_actions_explore: {
        id: 'fabric.linking.rovo_actions_explore-non-final',
        defaultMessage: 'Explore',
        description: 'Label for the Rovo Actions button that allows users to explore AI actions for a link'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Label for the unfollow button on a smart link card, allowing the user to stop receiving updates for the linked project or resource.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Tooltip or description for the unfollow project button, explaining that clicking it stops project update notifications.'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Label for the unfollow project button on a smart link card, allowing the user to stop following the linked Atlassian project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Tooltip or description for the unfollow goal button, explaining that clicking it stops notifications for the linked Atlas goal.'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Label for the unfollow goal button on a smart link card, allowing the user to stop following the linked Atlas goal.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewInProvider: {
        id: 'fabric.linking.viewinprovider',
        defaultMessage: 'View in {providerName}',
        description: 'We have a link in our preview modals to the original document. This text tells the user where it will open'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'Generic error message shown on a smart link card when an unspecified error occurs and no more specific message is available.'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Heading shown in the related links modal when related links fail to load due to a network or server error.'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Heading shown in the related links modal when no related links are available for the current resource.'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira work item in Jira (issue term refresh variant).'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Text shown on a smart link card displaying the number of members in a team. The placeholder {context} is substituted with the member count.'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Tooltip or description for the follow space button (Galaxia variant), explaining that clicking it enables notifications for the Confluence space.'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Tooltip or description for the unfollow space button (Galaxia variant), explaining that clicking it stops notifications for the Confluence space.'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: 'fabric.linking.learn_more_about_connecting_account_experiment_short',
        defaultMessage: 'Turn your URLs into rich, interactive previews.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    rovo_summary_loading: {
        id: 'fabric.linking.rovo_summary.loading.non-final',
        defaultMessage: 'Rovo is thinking',
        description: 'Shown when a Rovo summary is loading, indicating that the AI is generating a summary for the user.'
    },
    ai_disclaimer: {
        id: 'fabric.linking.rovo_summary.ai_disclaimer.non-final',
        defaultMessage: 'Uses AI. Verify Results.',
        description: 'Shown on a Rovo summary to indicate that the summary was generated by AI and should be verified by the user for accuracy.'
    },
    rovo_unauthorised_title: {
        id: 'fabric.linking.rovo_unauthorised.title',
        defaultMessage: 'Get smarter workflows by connecting your {context} account',
        description: 'Banner headline in Rovo unauthorised hover card header. {context} is the third-party provider name (e.g. Google).'
    },
    rovo_unauthorised_title_no_provider: {
        id: 'fabric.linking.rovo_unauthorised.title_no_provider',
        defaultMessage: 'Get smarter workflows by connecting your account',
        description: 'Banner headline in Rovo unauthorised hover card header when the provider name is unknown.'
    },
    rovo_unauthorised_feature_clear_link_names: {
        id: 'fabric.linking.rovo_unauthorised.feature.clear_link_names',
        defaultMessage: 'Turn long URLs into clear link names',
        description: 'First feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_understand_linked_docs: {
        id: 'fabric.linking.rovo_unauthorised.feature.understand_linked_docs',
        defaultMessage: 'Understand linked docs in seconds',
        description: 'Second feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_go_deeper_smart_suggestions: {
        id: 'fabric.linking.rovo_unauthorised.feature.go_deeper_smart_suggestions',
        defaultMessage: 'Go deeper with smart suggestions',
        description: 'Third feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_connect_account: {
        id: 'fabric.linking.rovo_unauthorised.connect_account',
        defaultMessage: 'Connect',
        description: 'Primary action button in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_not_now: {
        id: 'fabric.linking.rovo_unauthorised.not_now',
        defaultMessage: 'Maybe later',
        description: 'Secondary action in Rovo unauthorised hover card.'
    },
    rovo_prompt_context_generic: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'page',
        description: 'The location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_generic_plural: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'pages',
        description: 'The site-wide location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'Confluence page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item.non-final',
        defaultMessage: 'Jira work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_message_summarize: {
        id: 'fabric.linking.rovo_prompt_message_summarize.non-final',
        defaultMessage: '<p>Summarize the main ideas and key points of <a>{url}</a> in 3-5 clear, complete bullet points (markdown list).</p><p>Preserve important details such as names, dates, and key decisions.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_button_ask_rovo.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'The name of the action to open Rovo Chat and ask a question in relation to current Smart Link'
    },
    rovo_prompt_message_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_message_ask_rovo_anything.non-final',
        defaultMessage: '`I have a question about this linked item` {url}',
        description: "The placeholder prompt message pre-filled in Rovo Chat input. {url} refers to the Smart Link URL. This is not auto-submitted \u2014 the user types their question."
    },
    rovo_prompt_button_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_button_highlight_relevant_content',
        defaultMessage: `Highlight what's relevant`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_message_highlight_relevant_content',
        defaultMessage: "<p>Based on this linked item (<a>{url}</a>) and the {context} I'm currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_trends',
        defaultMessage: `Identify key trends`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_trends',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key trends, anomalies, and headline numbers. Call out anything increasing/decreasing significantly, noteworthy comparisons, and any risks or opportunities the data suggests.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_points',
        defaultMessage: `Identify key points`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_points',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key points, proposals, and decisions. Focus on what someone skimming the deck should know in order to understand the main message.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_button_find_open_questions',
        defaultMessage: `Find open questions`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_message_find_open_questions',
        defaultMessage: "<p>Look at this <a>{url}</a> and list any open questions, unresolved decisions, or asks that still need follow\u2011up. Group them by owner if possible and keep it concise.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_key_highlights: {
        id: 'fabric.linking.rovo_prompt_button_key_highlights',
        defaultMessage: `Key highlights`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_key_highlights: {
        id: 'fabric.linking.rovo_prompt_message_key_highlights',
        defaultMessage: "<p>Based on this <a>{url}</a> and the page or ticket I\u2019m currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_chat_action_section_header: {
        id: 'fabric.linking.rovo_chat_action_section_header.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'Heading shown above the Rovo prompt action buttons in the smart link hover card, alongside the Rovo logo, to introduce the AI prompt suggestions.'
    },
    rovo_prompt_button_summarize_this: {
        id: 'fabric.linking.rovo_prompt_button_summarize_this.non-final',
        defaultMessage: 'Summarize this for me',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_ask_a_specific_question: {
        id: 'fabric.linking.rovo_prompt_button_ask_a_specific_question.non-final',
        defaultMessage: 'Ask a specific question',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_show_me_whats_relevant: {
        id: 'fabric.linking.rovo_prompt_button_show_me_whats_relevant.non-final',
        defaultMessage: `Show me what's relevant`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_summarize_document: {
        id: 'fabric.linking.rovo_prompt_message_summarize_document',
        defaultMessage: `<p>Summarize this doc <a>{url}</a> into a concise, easy-to-scan overview. Adapt to whatever the content is and focus on the main ideas, important decisions, key updates, and next steps, only include these if they exist; don't mention their absence. Avoid unnecessary detail, repetition, or formatting commentary. Write in plain language and optimize for a quick 5\u{2013}10 second read</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_message_summarize_presentation: {
        id: 'fabric.linking.rovo_prompt_message_summarize_presentation',
        defaultMessage: `<p>Summarize this Google Slides deck <a>{url}</a> into a concise executive overview. Focus on the tldr, key findings, decisions, metrics, risks, and next steps, if there are any. Use a short executive summary followed by 2-3 bullet points. Avoid slide-by-slide narration, design details, repetition, and filler.</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_explain_code: {
        id: 'fabric.linking.rovo_prompt_button_explain_code',
        defaultMessage: `Explain`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_explain_code: {
        id: 'fabric.linking.rovo_prompt_message_explain_code',
        defaultMessage: `<p>Explain this code, pull request, or commit <a>{url}</a> in clear, plain language for a non-technical audience.</p><p>Cover:</p><ol><li><strong>Purpose</strong> \u{2014} What problem does it solve or what goal does it achieve?</li><li><strong>How it works</strong> \u{2014} High-level mechanics (no implementation detail unless critical to understanding).</li><li><strong>Why</strong> \u{2014} Motivation for the change or design choice.</li><li><strong>Impact</strong> \u{2014} Key behavior changes, risks, or downstream effects worth noting.</li></ol><p>Constraints:</p><ul><li>3\u{2013}5 sentences or 100\u{2013}150 words max.</li><li>Omit sections with nothing meaningful to say.</li><li>Prefer concrete language over abstract descriptions (e.g., "speeds up page load by caching results" over "improves performance").</li></ul>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_catch_up: {
        id: 'fabric.linking.rovo_prompt_button_catch_up',
        defaultMessage: `Catch up`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_catch_up: {
        id: 'fabric.linking.rovo_prompt_message_catch_up',
        defaultMessage: `<p>Catch me up on the latest {provider} conversations or channel activity in <a>{url}</a> from the last two weeks. If there's no activity in the past two weeks, expand the window to the most recent 30 days (or until meaningful activity is found). Summarize the most important updates, decisions, and discussions so the user can quickly understand what they missed. Focus on key changes, unresolved questions, and any action items or follow-ups. Prioritize recent messages with the most activity. Keep the response concise \u{2014} ideally 80\u{2013}150 words or a short set of 3\u{2013}5 key bullets.</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. {provider} is the 3P app name (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_button_salesforce_prep',
        defaultMessage: `Prep`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_message_salesforce_prep',
        defaultMessage: `<p>Prep me for this Salesforce record <a>{url}</a>. What's the current state, what's the recent activity, what risks or opportunities should I be aware of, and what would be useful to know before a conversation about it?</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    // TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    pre_auth_block_social_proof_not_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_not_low',
        defaultMessage: '<b>{percentage}%</b> of your team sees <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when 30% or more of the tenant has connected the provider. {percentage} is a number, {provider} is the 3P app name (e.g. OneDrive).'
    },
    pre_auth_block_social_proof_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_low',
        defaultMessage: 'Your team sees richer <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when less than 30% of the tenant has connected the provider. {provider} is the 3P app name (e.g. OneDrive).'
    }
});

});

parcelRegister("4mDZ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $089beb9b2a646dc6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $lig3b = parcelRequire("lig3b");

var $nLHJY = parcelRequire("nLHJY");
const $089beb9b2a646dc6$var$styles = {
    roundImg: "_2rko1rr0"
};
const $089beb9b2a646dc6$var$ImageIcon = ({ label: label, defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fc4bM.useState)(false);
    // If url changes, reset state
    (0, $fc4bM.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ $fc4bM.createElement("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: (label === null || label === void 0 ? void 0 : label.trim()) ?? '',
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $2R2iS.default)([
            appearance === 'round' && $089beb9b2a646dc6$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lig3b))), {
        src: url,
        loading: /*#__PURE__*/ $fc4bM.createElement((0, $nLHJY.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ $fc4bM.createElement("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: (label === null || label === void 0 ? void 0 : label.trim()) ?? '',
            style: {
                width: width,
                height: height
            },
            className: (0, $2R2iS.default)([
                appearance === 'round' && $089beb9b2a646dc6$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $089beb9b2a646dc6$export$2e2bcd8739ae039 = $089beb9b2a646dc6$var$ImageIcon;

});
parcelRegister("lig3b", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f807baafe3c28e8a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fc4bM = parcelRequire("fc4bM");
var $f807baafe3c28e8a$var$React = $f807baafe3c28e8a$var$_interopRequireWildcard($fc4bM);
function $f807baafe3c28e8a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $f807baafe3c28e8a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f807baafe3c28e8a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f807baafe3c28e8a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $f807baafe3c28e8a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $f807baafe3c28e8a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $f807baafe3c28e8a$var$errored() {
    return {
        isErrored: true
    };
}
function $f807baafe3c28e8a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $f807baafe3c28e8a$var$ImageRenderer = function(_React$Component) {
    $f807baafe3c28e8a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $f807baafe3c28e8a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $f807baafe3c28e8a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($f807baafe3c28e8a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($f807baafe3c28e8a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $f807baafe3c28e8a$var$_possibleConstructorReturn(_this, _ret);
    }
    $f807baafe3c28e8a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($f807baafe3c28e8a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($f807baafe3c28e8a$var$hasPropsChanged(this.props, nextProps)) this.setState($f807baafe3c28e8a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($f807baafe3c28e8a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($f807baafe3c28e8a$var$React.Component);
module.exports.default = $f807baafe3c28e8a$var$ImageRenderer;

});

parcelRegister("nLHJY", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $33fb8e561388d8e6$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $33fb8e561388d8e6$var$animationNameStyles = null;
const $33fb8e561388d8e6$var$loadingSkeletonStyle = null;
const $33fb8e561388d8e6$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $2R2iS.default)([
            "_2rkolb4i _uiztglyw _bfhkvkf5 _1itkfj9x _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("lNNaL", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $93dcee740782c5f6$export$e12b2cc6b75b006b);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [flagGroupState, pendingFirstRender, root]; splitting would fork the singleton and is forbidden by TS2632 */ /**
 * Smart Link flag module — imperative singleton pattern.
 *
 * ## Why not a React context provider?
 *
 * The natural approach would be to render a `<FlagProvider>` inside the Card
 * component tree, managing flag state via React context. This was the original
 * implementation. However, it caused a critical bug:
 *
 * When a parent component of smart card changed, either swap or unmount,
 * it unmounts the entire card subtree including `FlagsProvider`.
 * Any flag that was visible at that moment is instantly destroyed and lost.
 *
 * ## Why an injected React root?
 *
 * This module manages a persistent `FlagGroup` at `document.body` via its own
 * `createRoot` — completely independent of any card component tree. The root is created
 * lazily on the first `showFlag` call and kept alive indefinitely, re-rendering with
 * the current flags array on every change.
 *
 * Benefits:
 * - Flags survive any card unmount/remount cycle
 * - No provider needed anywhere in the component tree
 * - Works identically for all card paths (Card, CardSSR)
 * - Same pattern as `EmbedModal/utils.tsx` but for a persistent group
 *
 * Usage: import `showFlag` and call it directly — no provider needed.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $dQotp = parcelRequire("dQotp");

var $8MaoS = parcelRequire("8MaoS");

var $jS4uw = parcelRequire("jS4uw");

var $bAQQ9 = parcelRequire("bAQQ9");

var $fkpcn = parcelRequire("fkpcn");
const $93dcee740782c5f6$var$FLAG_GROUP_MOUNT_POINT_ID = 'smart-link-flags-mount';
// ---------------------------------------------------------------------------
// Module-level singleton state
// Lives for the entire page session — independent of any React component tree.
//
// The sequence:
// 1. ensureRoot()
//    └── flushSync(() => root.render(<empty FlagGroup>))
//        └── ExitingPersistence mounts with appear=false
//        └── pendingFirstRender = true
//
// 2. showFlag() detects pendingFirstRender=true
//    └── pendingFirstRender = false
//    └── setTimeout(0, () => renderToRoot())
//        ← deferred: runs AFTER useEffect fires
//
// 3. [async] ExitingPersistence's useEffect fires
//    └── appear flips false → true
//
// 4. [async] setTimeout(0) fires → renderToRoot()
//    └── FlagGroup receives flag as new child
//    └── ExitingPersistence sees new child with appear=true → ANIMATES
// ---------------------------------------------------------------------------
let $93dcee740782c5f6$var$flagGroupState = [];
let $93dcee740782c5f6$var$root = null;
// True after ensureRoot() creates a new root but before ExitingPersistence's useEffect
// has flipped `appear` to true. While pending, the first renderToRoot is deferred via
// setTimeout so that the enter animation fires correctly.
let $93dcee740782c5f6$var$pendingFirstRender = false;
const $93dcee740782c5f6$var$removeFlag = (id)=>{
    $93dcee740782c5f6$var$flagGroupState = $93dcee740782c5f6$var$flagGroupState.filter((f)=>f.id !== id);
    $93dcee740782c5f6$var$renderToRoot();
};
const $93dcee740782c5f6$var$renderToRoot = ()=>{
    if (!$93dcee740782c5f6$var$root) return;
    $93dcee740782c5f6$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bAQQ9.default), {
        onDismissed: $93dcee740782c5f6$var$removeFlag
    }, $93dcee740782c5f6$var$flagGroupState.map((flagProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fkpcn.default), {
            borderRadius: 'large',
            isVisible: true,
            key: flagProps.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jS4uw.default), {
            ...flagProps,
            key: flagProps.id
        }));
    }))));
};
const $93dcee740782c5f6$var$ensureRoot = ()=>{
    if ($93dcee740782c5f6$var$root !== null || typeof document === 'undefined') return;
    let container = document.getElementById($93dcee740782c5f6$var$FLAG_GROUP_MOUNT_POINT_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = $93dcee740782c5f6$var$FLAG_GROUP_MOUNT_POINT_ID;
        document.body.appendChild(container);
    }
    $93dcee740782c5f6$var$root = (0, $dQotp.createRoot)(container);
    const locale = typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en';
    // Render an empty FlagGroup immediately so React has a "before" state to diff against.
    // Without this, the first flag has no previous render to compare to — React mounts it
    // directly and the FlagGroup animation library sees it as "already present" rather than
    // "just entered", skipping the slide-in animation.
    // Subsequent flags always have the previous (possibly empty) render to diff against,
    // which is why they animate correctly.
    const renderEmptyFlagGroup = ()=>$93dcee740782c5f6$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bAQQ9.default), {
            onDismissed: $93dcee740782c5f6$var$removeFlag
        })));
    // Use flushSync to synchronously commit an empty FlagGroup before any flag is added.
    // This mounts ExitingPersistence (inside FlagGroup) in an empty state so that when the
    // first flag arrives (deferred via setTimeout below), ExitingPersistence recognises it
    // as a genuinely new child and runs the slide-in animation.
    try {
        (0, $bTkYf.flushSync)(renderEmptyFlagGroup);
    } catch  {
        // flushSync cannot be called during React rendering or from a lifecycle (e.g. useEffect).
        // We try it and fall back to a regular async render if React throws — in that case the
        // first flag may appear without a slide-in animation, but all subsequent flags will
        // animate correctly (ExitingPersistence will have mounted and flipped appear=true by then).
        renderEmptyFlagGroup();
    }
    // After flushSync commits the empty FlagGroup, ExitingPersistence's useEffect runs
    // asynchronously to flip `appear` from false → true (enabling enter animations).
    // We store a pending flag to signal that the first renderToRoot should be deferred.
    $93dcee740782c5f6$var$pendingFirstRender = true;
};
const $93dcee740782c5f6$export$e12b2cc6b75b006b = (options)=>{
    const flagProps = {
        ...options,
        id: options.id || crypto.randomUUID()
    };
    const index = $93dcee740782c5f6$var$flagGroupState.findIndex((f)=>f.id === flagProps.id);
    if (index === -1) $93dcee740782c5f6$var$flagGroupState = [
        flagProps,
        ...$93dcee740782c5f6$var$flagGroupState
    ];
    else $93dcee740782c5f6$var$flagGroupState = $93dcee740782c5f6$var$flagGroupState.map((f, i)=>i === index ? flagProps : f);
    $93dcee740782c5f6$var$ensureRoot();
    if ($93dcee740782c5f6$var$pendingFirstRender) {
        // ensureRoot() just created a new root and committed an empty FlagGroup via flushSync.
        // ExitingPersistence's useEffect (which flips `appear` false→true) runs asynchronously
        // after the commit. We defer renderToRoot via setTimeout(0) to ensure that useEffect
        // has already fired before the flag is added — only then will ExitingPersistence
        // treat it as a new entering child and run the slide-in animation.
        $93dcee740782c5f6$var$pendingFirstRender = false;
        setTimeout(()=>{
            $93dcee740782c5f6$var$renderToRoot();
        }, 0);
    } else $93dcee740782c5f6$var$renderToRoot();
};
const $93dcee740782c5f6$export$3dd8302481493c99 = ()=>{
    $93dcee740782c5f6$var$flagGroupState = [];
    $93dcee740782c5f6$var$pendingFirstRender = false;
    if ($93dcee740782c5f6$var$root) {
        $93dcee740782c5f6$var$root.unmount();
        $93dcee740782c5f6$var$root = null;
    }
    if (typeof document !== 'undefined') {
        var _document$getElementB;
        (_document$getElementB = document.getElementById($93dcee740782c5f6$var$FLAG_GROUP_MOUNT_POINT_ID)) === null || _document$getElementB === void 0 || _document$getElementB.remove();
    }
};

});
parcelRegister("dQotp", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $a1431d9b59e972df$export$882461b6382ed46c, (v) => $a1431d9b59e972df$export$882461b6382ed46c = v);
var $a1431d9b59e972df$export$882461b6382ed46c;
var $a1431d9b59e972df$export$757ceba2d55c277e;
'use strict';

var $bTkYf = parcelRequire("bTkYf");
var $a1431d9b59e972df$var$i;
$a1431d9b59e972df$export$882461b6382ed46c = $bTkYf.createRoot;
$a1431d9b59e972df$export$757ceba2d55c277e = $bTkYf.hydrateRoot;

});

parcelRegister("fkpcn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0263f199225768f5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $anluN = parcelRequire("anluN");

var $jcrWt = parcelRequire("jcrWt");

var $k39ME = parcelRequire("k39ME");
const $0263f199225768f5$var$contentStyles = null;
const $0263f199225768f5$var$contentStylesPrismVisible = null;
const $0263f199225768f5$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $0263f199225768f5$var$borderRadiusStyles = {
    large: "_2rko1mok",
    small: "_2rko12b0"
};
const $0263f199225768f5$var$popupContainerStyles = null;
const $0263f199225768f5$var$AIPrism = ({ borderRadius: borderRadius, children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $anluN.useThemeObserver)();
    return /*#__PURE__*/ $fc4bM.createElement((0, $jcrWt.default), {
        palette: (0, $k39ME.AI_BORDER_PALETTE)[colorMode] ?? (0, $k39ME.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $2R2iS.default)([
            $0263f199225768f5$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false'],
            borderRadius && $0263f199225768f5$var$borderRadiusStyles[borderRadius]
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $0263f199225768f5$export$2e2bcd8739ae039 = $0263f199225768f5$var$AIPrism;

});
parcelRegister("jcrWt", function(module, exports) {
$parcel$export(module.exports, "default", () => $e94eb2c26d4f8db3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $4IioS = parcelRequire("4IioS");
const $e94eb2c26d4f8db3$var$borderContainerStyles = null;
const $e94eb2c26d4f8db3$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $e94eb2c26d4f8db3$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ $fc4bM.createElement("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4IioS.default), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $fc4bM.createElement((0, $4IioS.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
var $e94eb2c26d4f8db3$export$2e2bcd8739ae039 = $e94eb2c26d4f8db3$var$AIGlowingBorder;

});
parcelRegister("4IioS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c74cb127232695bd$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
let $c74cb127232695bd$var$namespaceUUID = 0;
const $c74cb127232695bd$var$svgStyles = null;
const $c74cb127232695bd$var$blurredStyles = null;
const $c74cb127232695bd$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $c74cb127232695bd$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $fc4bM.useRef)(null);
    const namespaceId = (0, $fc4bM.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $c74cb127232695bd$var$namespaceUUID;
        $c74cb127232695bd$var$namespaceUUID += 1;
    }
    (0, $fc4bM.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $fc4bM.createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $fc4bM.createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $fc4bM.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $fc4bM.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $fc4bM.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $c74cb127232695bd$export$2e2bcd8739ae039 = $c74cb127232695bd$var$AnimatedSvgContainer;

});


parcelRegister("k39ME", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $02d871a37e62e58e$export$23b7b83c7063ccfe);
const $02d871a37e62e58e$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $02d871a37e62e58e$export$23b7b83c7063ccfe = {
    dark: {
        blue: $02d871a37e62e58e$export$3088ed82e2905d1e.blue800,
        teal: $02d871a37e62e58e$export$3088ed82e2905d1e.teal500,
        yellow: $02d871a37e62e58e$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $02d871a37e62e58e$export$3088ed82e2905d1e.blue600,
        teal: $02d871a37e62e58e$export$3088ed82e2905d1e.teal300,
        yellow: $02d871a37e62e58e$export$3088ed82e2905d1e.yellow200
    }
};

});




parcelRegister("cA6hx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee71a08e563d8a1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $dRkX9 = parcelRequire("dRkX9");

var $fVrlX = parcelRequire("fVrlX");

var $8yp28 = parcelRequire("8yp28");

var $6PbEY = parcelRequire("6PbEY");

var $gvrpl = parcelRequire("gvrpl");

var $k7o0P = parcelRequire("k7o0P");

var $eCeLl = parcelRequire("eCeLl");
const $6ee71a08e563d8a1$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $6ee71a08e563d8a1$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $fc4bM.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, prompt: prompt, interactionSource: interactionSource, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, $eUgRu.default)();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        (0, $6PbEY.mark)(markName, 'pending');
        try {
            var _getMeasure;
            // Begin UFO experience
            (0, $k7o0P.startUfoExperience)($6ee71a08e563d8a1$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType,
                prompt: prompt,
                ...(0, $dRkX9.fg)('platform_sl_one_click_chat_spotlight_v2_fg') && actionSubjectId === 'rovoChatPrompt' && interactionSource ? {
                    interactionSource: interactionSource
                } : {}
            });
            // Invoke action
            const result = await actionFn();
            (0, $6PbEY.mark)(markName, 'resolved');
            (0, $eCeLl.succeedUfoExperience)($6ee71a08e563d8a1$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_getMeasure = (0, $8yp28.getMeasure)(markName, 'resolved')) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            var _getMeasure2;
            (0, $6PbEY.mark)(markName, 'errored');
            (0, $gvrpl.failUfoExperience)($6ee71a08e563d8a1$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err === null || err === void 0 ? void 0 : err.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_getMeasure2 = (0, $8yp28.getMeasure)(markName, 'errored')) === null || _getMeasure2 === void 0 ? void 0 : _getMeasure2.duration) ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $6ee71a08e563d8a1$export$2e2bcd8739ae039 = $6ee71a08e563d8a1$var$useInvokeClientAction;

});
parcelRegister("gvrpl", function(module, exports) {
$parcel$export(module.exports, "failUfoExperience", () => $76b4af9b69d08be5$export$8dda83bafca11b77);

var $4Y0sD = parcelRequire("4Y0sD");
const $76b4af9b69d08be5$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = (0, $4Y0sD.ufoExperiences)[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};

});

parcelRegister("eCeLl", function(module, exports) {
$parcel$export(module.exports, "succeedUfoExperience", () => $e98a700b22df0145$export$c5a5cf072c836c0e);

var $4Y0sD = parcelRequire("4Y0sD");
const $e98a700b22df0145$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = (0, $4Y0sD.ufoExperiences)[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};

});


parcelRegister("fypiH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0378d45e70e478ff$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6G8gX = parcelRequire("6G8gX");

var $fnEFU = parcelRequire("fnEFU");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $huP1R = parcelRequire("huP1R");

var $5kQNN = parcelRequire("5kQNN");
const $0378d45e70e478ff$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $fnEFU.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $5kQNN.default)();
    return (0, $fc4bM.useCallback)(async (params)=>{
        const { url: url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, id: id = '', appearance: appearance } = params;
        const isInlineResolveOptimizationEnabled = (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization');
        const isOptimizedBlockRequest = appearance === 'block' && isInlineResolveOptimizationEnabled;
        const { details: details, metadataStatus: currentMetadataStatus } = getState()[url] || {
            status: (0, $j9rqA.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $6G8gX.isEntityPresent)(details));
        const needsOptimizedBlockData = isOptimizedBlockRequest && currentMetadataStatus !== 'resolved';
        if (isReloading || !hasData || isMetadataRequest || needsOptimizedBlockData) {
            // ORS caches each appearance separately, so optimized block requests can reuse the
            // block cache. Preserve the existing replacement decision so a cached full response
            // still replaces any reduced inline data already in the store.
            const shouldReplaceExistingData = isReloading || needsOptimizedBlockData;
            const shouldForceFetch = isInlineResolveOptimizationEnabled ? isReloading : shouldReplaceExistingData;
            const metadataStatus = appearance === 'inline' && !isMetadataRequest && isInlineResolveOptimizationEnabled ? 'pending' : undefined;
            return connections.client.fetchData(url, shouldForceFetch, appearance).then((response)=>handleResolvedLinkResponse(url, response, shouldReplaceExistingData, isMetadataRequest, metadataStatus)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        } else (0, $huP1R.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $0378d45e70e478ff$export$2e2bcd8739ae039 = $0378d45e70e478ff$var$useResolve;

});
parcelRegister("huP1R", function(module, exports) {
$parcel$export(module.exports, "addMetadataToExperience", () => $df738016dca2c2f1$export$4084c0df4a03a6af);

var $4Y0sD = parcelRequire("4Y0sD");
const $df738016dca2c2f1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    (0, $4Y0sD.ufoExperiences)[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("5kQNN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4b34428377bd88a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $fnEFU = parcelRequire("fnEFU");

var $cSf11 = parcelRequire("cSf11");

var $fu7F9 = parcelRequire("fu7F9");

var $6XuWH = parcelRequire("6XuWH");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $1hXii = parcelRequire("1hXii");

var $jCe46 = parcelRequire("jCe46");
const $e4b34428377bd88a$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $fnEFU.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $fc4bM.useCallback)((url, metadataStatus)=>{
        dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $fc4bM.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $j9rqA.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_RESOLVED), {
            url: url
        }, (0, $1hXii.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $fc4bM.useCallback)((resourceUrl, response, isReloading, isMetadataRequest, metadataStatus = 'resolved')=>{
        var _getState$resourceUrl;
        /**
     * Metadata status scenarios:
     * - Gate off, or a non-resolved response: use `resolved`, preserving legacy behavior and
     *   avoiding a gate exposure when the result would not affect the status.
     * - Gate on with full metadata: use the provided/default `resolved` status.
     * - Gate on with reduced inline metadata: use the provided `pending` status so block or
     *   hover rendering knows to request the full metadata later.
     * - Reduced inline metadata arriving after full metadata: keep the existing `resolved`
     *   status so an out-of-order response cannot trigger another full request.
     * - Explicit reload: allow `pending` even after full metadata, because the caller is
     *   intentionally replacing the existing data.
     */ const shouldUseProvidedMetadataStatus = (0, $6XuWH.getStatus)(response) === 'resolved' && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization');
        const shouldPreserveResolvedMetadata = shouldUseProvidedMetadataStatus && metadataStatus === 'pending' && !isReloading && ((_getState$resourceUrl = getState()[resourceUrl]) === null || _getState$resourceUrl === void 0 ? void 0 : _getState$resourceUrl.metadataStatus) === 'resolved';
        const nextMetadataStatus = shouldUseProvidedMetadataStatus && !shouldPreserveResolvedMetadata ? metadataStatus : 'resolved';
        setMetadataStatus(resourceUrl, nextMetadataStatus);
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $cSf11.cardAction)((0, $cSf11.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $fc4bM.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest, metadataStatus)=>{
        if (!resourceUrl) return;
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $6XuWH.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $fu7F9.APIError)('fallback', hostname, (0, $jCe46.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $fu7F9.APIError)('fatal', hostname, (0, $jCe46.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $fu7F9.APIError)('error', hostname, (0, $jCe46.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $bTkYf.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest, metadataStatus);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $e4b34428377bd88a$export$2e2bcd8739ae039 = $e4b34428377bd88a$var$useResponse;

});
parcelRegister("1hXii", function(module, exports) {
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $8a4f2a505990507c$export$b9482e0f6d365cc7);

var $8aoX8 = parcelRequire("8aoX8");
const $8a4f2a505990507c$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...(0, $8aoX8.emptyData)
        }
    });

});
parcelRegister("8aoX8", function(module, exports) {
$parcel$export(module.exports, "emptyData", () => $b51f5449fc05d515$export$49de42a13d6e867c);
const $b51f5449fc05d515$export$49de42a13d6e867c = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};

});


parcelRegister("jCe46", function(module, exports) {
$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $cbba4488abb0fcb6$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $cbba4488abb0fcb6$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $cbba4488abb0fcb6$export$338f7d9ccca1975d);
const $cbba4488abb0fcb6$export$297c39c8b9bfca0 = 'resolving';
const $cbba4488abb0fcb6$export$b64a888338c24e0e = 'errored';
const $cbba4488abb0fcb6$export$677b6edfa0002c70 = 'fallback';
const $cbba4488abb0fcb6$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cbba4488abb0fcb6$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cbba4488abb0fcb6$export$338f7d9ccca1975d = 'Error resolving metadata.';

});




parcelRegister("jKScA", function(module, exports) {
$parcel$export(module.exports, "getResourceType", () => $91b4681e42f2fb5a$export$16c0ebb0de9b767b);
const $91b4681e42f2fb5a$export$16c0ebb0de9b767b = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.resourceType;
};

});

parcelRegister("fzYCU", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $0c8405158c4e588e$export$b0444d00ba7313c6);

var $iXlbb = parcelRequire("iXlbb");

var $fnEFU = parcelRequire("fnEFU");
const $0c8405158c4e588e$var$PENDING_STATE = {
    status: 'pending'
};
function $0c8405158c4e588e$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $fnEFU.useSmartLinkContext)();
    const cardState = (0, $iXlbb.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $0c8405158c4e588e$var$PENDING_STATE;
}

});

parcelRegister("1mQD1", function(module, exports) {
$parcel$export(module.exports, "useScheduledRegister", () => $b787da1e3c38cf7b$export$db80d61271e4d5af);
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $fc4bM = parcelRequire("fc4bM");
const $b787da1e3c38cf7b$var$batchQueue = new Map();
const $b787da1e3c38cf7b$var$batchTimeouts = new Map();
const $b787da1e3c38cf7b$var$BATCH_DELAY = 250;
const $b787da1e3c38cf7b$var$executeBatch = (hostname)=>{
    const items = $b787da1e3c38cf7b$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $b787da1e3c38cf7b$var$batchQueue.delete(hostname);
    $b787da1e3c38cf7b$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $b787da1e3c38cf7b$var$addToBatch = (hostname, item)=>{
    if (!$b787da1e3c38cf7b$var$batchQueue.has(hostname)) $b787da1e3c38cf7b$var$batchQueue.set(hostname, []);
    $b787da1e3c38cf7b$var$batchQueue.get(hostname).push(item);
    if ($b787da1e3c38cf7b$var$batchTimeouts.has(hostname)) clearTimeout($b787da1e3c38cf7b$var$batchTimeouts.get(hostname));
    $b787da1e3c38cf7b$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $b787da1e3c38cf7b$var$executeBatch(hostname);
    }, $b787da1e3c38cf7b$var$BATCH_DELAY));
};
const $b787da1e3c38cf7b$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $fc4bM.useRef)(false);
    const scheduledRegister = (0, $fc4bM.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $b787da1e3c38cf7b$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};

});


parcelRegister("ec9Mk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ca9c6d274c45cd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gAa0D = parcelRequire("gAa0D");

var $bRqc6 = parcelRequire("bRqc6");
const $d4ca9c6d274c45cd$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $fc4bM.useContext)((0, $gAa0D.SmartCardContext));
    return hasSmartCardProvider && (0, $bRqc6.shouldResolveUrl)(href);
};
var $d4ca9c6d274c45cd$export$2e2bcd8739ae039 = $d4ca9c6d274c45cd$var$useResolveHyperlinkValidator;

});
parcelRegister("bRqc6", function(module, exports) {
$parcel$export(module.exports, "shouldResolveUrl", () => $d529984716a996a6$export$aa45d36a96427452);
const $d529984716a996a6$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $d529984716a996a6$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $d529984716a996a6$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};

});


parcelRegister("baiO5", function(module, exports) {
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $9ff0df0ea82fd941$export$eaff10f7ec59c455);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $dRkX9 = parcelRequire("dRkX9");

var $fzYCU = parcelRequire("fzYCU");

var $16FEv = parcelRequire("16FEv");
const $9ff0df0ea82fd941$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $fzYCU.useSmartCardState)(url);
    const data = (0, $16FEv.getSmartLinkAnalyticsContext)({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dRkX9.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: data
    }, children);
};

});
parcelRegister("16FEv", function(module, exports) {
$parcel$export(module.exports, "getSmartLinkAnalyticsContext", () => $dd8a9fac1ed7897c$export$5732565218b28467);

var $fYtij = parcelRequire("fYtij");

var $9JzR9 = parcelRequire("9JzR9");
const $dd8a9fac1ed7897c$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2;
    return {
        definitionId: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId) ?? null,
        resourceType: (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.resourceType) ?? null,
        ...(0, $fYtij.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    };
};
const $dd8a9fac1ed7897c$export$5732565218b28467 = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $dd8a9fac1ed7897c$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $9JzR9.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};

});
parcelRegister("fYtij", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $b655cf8e3c9689e3$export$7243431f5325a7b);

var $6XuWH = parcelRequire("6XuWH");

var $dRkX9 = parcelRequire("dRkX9");

var $7RHOw = parcelRequire("7RHOw");
const $b655cf8e3c9689e3$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2, _details$meta3, _details$meta4, _details$meta5, _details$meta6, _details$meta7, _details$meta8, _details$meta9, _details$meta0, _details$meta1;
    const status = linkStatus ?? (details && (0, $6XuWH.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $7RHOw.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.requestAccess) === null || _details$meta === void 0 ? void 0 : _details$meta.accessType) ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $dRkX9.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key) ?? (error === null || error === void 0 ? void 0 : error.extensionKey) ?? null : (details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.key) ?? null,
        destinationTenantId: (details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.tenantId) ?? null,
        destinationActivationId: (details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.activationId) ?? null,
        destinationContainerId: (details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.containerId) ?? null,
        destinationCategory: (details === null || details === void 0 || (_details$meta7 = details.meta) === null || _details$meta7 === void 0 ? void 0 : _details$meta7.category) ?? null,
        destinationProduct: (details === null || details === void 0 || (_details$meta8 = details.meta) === null || _details$meta8 === void 0 ? void 0 : _details$meta8.product) ?? null,
        destinationSubproduct: (details === null || details === void 0 || (_details$meta9 = details.meta) === null || _details$meta9 === void 0 ? void 0 : _details$meta9.subproduct) ?? null,
        destinationObjectId: (details === null || details === void 0 || (_details$meta0 = details.meta) === null || _details$meta0 === void 0 ? void 0 : _details$meta0.objectId) ?? null,
        destinationObjectType: (details === null || details === void 0 || (_details$meta1 = details.meta) === null || _details$meta1 === void 0 ? void 0 : _details$meta1.resourceType) ?? null,
        canBeDatasource: ((details === null || details === void 0 ? void 0 : details.datasources) || []).length > 0
    };
};

});
parcelRegister("7RHOw", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $0151ae40171da097$export$28ddbae335bd80b5);
const $0151ae40171da097$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});




parcelRegister("6sD3Q", function(module, exports) {
$parcel$export(module.exports, "isAuxClick", () => $5a3b0c0c430d4f42$export$15213acd7ac7d39a);
/**
 * Returns true for genuine middle-clicks (button === 1).
 * Filters out Windows right-clicks, which fire onAuxClick with button === 2
 * in addition to onContextMenu, to prevent double-counting.
 */ const $5a3b0c0c430d4f42$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};

});

parcelRegister("8f4S4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba9512c17ece0601$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8MaoS = parcelRequire("8MaoS");
/**
 * HOC to wrap component with IntlProvider if not available
 */ const $ba9512c17ece0601$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props);
        return props !== null && props !== void 0 && props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
            locale: "en"
        }, content);
    };
var $ba9512c17ece0601$export$2e2bcd8739ae039 = $ba9512c17ece0601$var$withIntlProvider;

});

parcelRegister("eaXI0", function(module, exports) {
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $4e7668976fcaf587$export$e682245dc886cff2);

var $jEubQ = parcelRequire("jEubQ");
function $4e7668976fcaf587$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    return ({ isAuxClick: isAuxClick = false, isContextMenu: isContextMenu = false } = {})=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier,
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});


parcelRegister("fZlXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4581a74abf5e6d09$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");
var $fcCIH = parcelRequire("fcCIH");
var $8MaoS = parcelRequire("8MaoS");

var $kTVlm = parcelRequire("kTVlm");

var $dM0Q8 = parcelRequire("dM0Q8");

var $dkw9k = parcelRequire("dkw9k");

var $2u7SO = parcelRequire("2u7SO");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $ewFKq = parcelRequire("ewFKq");
const $4581a74abf5e6d09$var$breakWordsCss = null;
const $4581a74abf5e6d09$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $fc4bM.createElement((0, $ggkex.default), null, isOpen && /*#__PURE__*/ $fc4bM.createElement((0, $2u7SO.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2NqAY.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5t2KI.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).check_this_link))), /*#__PURE__*/ $fc4bM.createElement((0, $dkw9k.default), null, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $fc4bM.createElement((0, $dM0Q8.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $8qwF5.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $kTVlm.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).go_back)), /*#__PURE__*/ $fc4bM.createElement((0, $kTVlm.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $fc4bM.createElement((0, $8MaoS.default), {
        locale: "en"
    }, content);
};
const $4581a74abf5e6d09$var$_default_1 = (0, $fcCIH.default)($4581a74abf5e6d09$var$WarningModal, {
    enforceContext: false
});
var $4581a74abf5e6d09$export$2e2bcd8739ae039 = $4581a74abf5e6d09$var$_default_1;

});

parcelRegister("1Pbap", function(module, exports) {
$parcel$export(module.exports, "useLinkWarningModal", () => $52f7c39c5df7f88b$export$32b76c003683c2ec);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $geXLV = parcelRequire("geXLV");

var $9JzR9 = parcelRequire("9JzR9");
const $52f7c39c5df7f88b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $52f7c39c5df7f88b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $fc4bM.useState)(null);
    const [url, setUrl] = (0, $fc4bM.useState)(null);
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $9JzR9.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $9JzR9.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $geXLV.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $52f7c39c5df7f88b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $52f7c39c5df7f88b$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = (hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin) === currentAtlassianProductOrigin && (linkTextUrl === null || linkTextUrl === void 0 ? void 0 : linkTextUrl.origin) === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("geXLV", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $e4a89d85d4b9567e$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $8rgUo = parcelRequire("8rgUo");

var $guSlZ = parcelRequire("guSlZ");

var $irhVf = parcelRequire("irhVf");
const $e4a89d85d4b9567e$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $e4a89d85d4b9567e$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $e4a89d85d4b9567e$var$linkify = new (0, $8rgUo.default)();
$e4a89d85d4b9567e$var$linkify.add('sourcetree:', 'http:');
$e4a89d85d4b9567e$var$linkify.add('jamfselfservice:', 'http:');
$e4a89d85d4b9567e$var$linkify.add('notes:', 'http:');
$e4a89d85d4b9567e$var$tlds.push($e4a89d85d4b9567e$var$tlds2Char);
$e4a89d85d4b9567e$var$linkify.tlds($e4a89d85d4b9567e$var$tlds, false);
const $e4a89d85d4b9567e$var$normaliseLinkHref = (url)=>{
    const match = $e4a89d85d4b9567e$var$getLinkMatch(url);
    return match && match.url || null;
};
const $e4a89d85d4b9567e$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = (0, $irhVf.linkifyMatch)(str);
    if (!match || !match.length) match = $e4a89d85d4b9567e$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
function $e4a89d85d4b9567e$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ((0, $guSlZ.isSafeUrl)(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $e4a89d85d4b9567e$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("guSlZ", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $3f363157aaf7eb65$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $3f363157aaf7eb65$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $3f363157aaf7eb65$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $3f363157aaf7eb65$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};

});

parcelRegister("irhVf", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $dca41ee650889f5f$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $dca41ee650889f5f$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dca41ee650889f5f$export$6f7d7761b97f967 = (text)=>{
    const matches = [];
    if (!$dca41ee650889f5f$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dca41ee650889f5f$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dca41ee650889f5f$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};

});





parcelRegister("1kFSe", function(module, exports) {
$parcel$export(module.exports, "LinkUrlEmotion", () => $5a8557627733a5d3$export$bcc8540ceca8fa1c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $jctmk = parcelRequire("jctmk");

var $4je51 = parcelRequire("4je51");
function $5a8557627733a5d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5a8557627733a5d3$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
const $5a8557627733a5d3$export$bcc8540ceca8fa1c = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $jctmk.jsx)((0, $4je51.LinkUrl), {
        css: $5a8557627733a5d3$var$anchorStyles,
        ...props
    });

});


parcelRegister("mvsbF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab1b086b5214f5f0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $ab1b086b5214f5f0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("kSzKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $27f96e8ae852f201$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $27f96e8ae852f201$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $3LM7S.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("drrx9", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca545198872041dd$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $ca545198872041dd$var$isSub = (type)=>{
    return type === 'sub';
};
function $ca545198872041dd$export$2e2bcd8739ae039(props) {
    if ($ca545198872041dd$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("JUmmM", function(module, exports) {
$parcel$export(module.exports, "default", () => $55d98e8106d1aa8e$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lefJT = parcelRequire("lefJT");

var $gGiKk = parcelRequire("gGiKk");

var $anluN = parcelRequire("anluN");
function $55d98e8106d1aa8e$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $gGiKk.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $gGiKk.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $lefJT.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $fc4bM.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});

parcelRegister("3ilp9", function(module, exports) {
$parcel$export(module.exports, "default", () => $223e297354487bef$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $223e297354487bef$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("YZkqa", function(module, exports) {
$parcel$export(module.exports, "default", () => $56bf0c3b77d7a948$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $56bf0c3b77d7a948$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("2peAf", function(module, exports) {
$parcel$export(module.exports, "default", () => $80d4cfc0e825049f$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $80d4cfc0e825049f$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});


parcelRegister("6dwyE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b06b27da1b174a3$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9ejhj = parcelRequire("9ejhj");
const $8b06b27da1b174a3$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9ejhj.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        plainTextFastPath: props.plainTextFastPath,
        children: children
    });
};
var $8b06b27da1b174a3$export$2e2bcd8739ae039 = $8b06b27da1b174a3$var$TextWrapper;

});
parcelRegister("9ejhj", function(module, exports) {
$parcel$export(module.exports, "TextWithAnnotationDraft", () => $a6c3fab6400a562f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $iGedO = parcelRequire("iGedO");

var $kvlmJ = parcelRequire("kvlmJ");

var $9Xm1T = parcelRequire("9Xm1T");

var $3dFu0 = parcelRequire("3dFu0");

var $aAJVV = parcelRequire("aAJVV");

var $iwVx4 = parcelRequire("iwVx4");

var $ajw0q = parcelRequire("ajw0q");
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $a6c3fab6400a562f$var$markStyles = /*#__PURE__*/ (0, $jctmk.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $a6c3fab6400a562f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $kvlmJ.useAnnotationManagerDispatch)();
    const markRef = (0, $fc4bM.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $aAJVV.dataAttributes)(draftPosition),
        css: $a6c3fab6400a562f$var$markStyles,
        ref: markRef
    }, children);
};
const $a6c3fab6400a562f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $3dFu0.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $3dFu0.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $3dFu0.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $a6c3fab6400a562f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks, plainTextFastPath: plainTextFastPath = false })=>{
    const annotateIndex = $a6c3fab6400a562f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const rendered = (0, $iGedO.renderText)(value, textHighlighter, marks || [], draftPosition.from, plainTextFastPath);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $jctmk.jsx)($a6c3fab6400a562f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, rendered));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
            key: index
        }, rendered));
    });
};
const $a6c3fab6400a562f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks, plainTextFastPath: plainTextFastPath = false })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $9Xm1T.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $iwVx4.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $ajw0q.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, (0, $iGedO.renderText)(textString, textHighlighter, marks || [], startPos, plainTextFastPath));
    if (shouldApplyAnnotationAt === (0, $3dFu0.InsertDraftPosition).AROUND_TEXT) return /*#__PURE__*/ (0, $jctmk.jsx)($a6c3fab6400a562f$export$8062d68eccdfa39c, {
        key: 0,
        draftPosition: nextDraftPosition
    }, (0, $iGedO.renderText)(textString, textHighlighter, marks || [], startPos, plainTextFastPath));
    const offsets = (0, $ajw0q.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $ajw0q.splitText)(textString, offsets);
    if (!texts) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, (0, $iGedO.renderText)(textString, textHighlighter, marks || [], startPos, plainTextFastPath));
    const components = $a6c3fab6400a562f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks,
        plainTextFastPath: plainTextFastPath
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, components);
};

});
parcelRegister("iGedO", function(module, exports) {
$parcel$export(module.exports, "renderText", () => $1ef9cd624b2d6fee$export$482c90f94eb9717c);

var $23Cvj = parcelRequire("23Cvj");

var $akAop = parcelRequire("akAop");
function $1ef9cd624b2d6fee$export$482c90f94eb9717c(text, textHighlighter, marks, startPos, fastPath) {
    if (fastPath && (!textHighlighter || !text)) return text ?? '';
    const segments = (0, $akAop.segmentText)(text, textHighlighter);
    return (0, $23Cvj.renderTextSegments)(segments, textHighlighter, marks, startPos, fastPath);
}

});
parcelRegister("23Cvj", function(module, exports) {
$parcel$export(module.exports, "renderTextSegments", () => $557a21d984d2652a$export$8a20fd0614851c5f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
/** Collects the mark type names a highlighter component receives for a text node. */ const $557a21d984d2652a$var$toMarkNames = (marksList)=>new Set(marksList.map((m)=>m.type.name));
function $557a21d984d2652a$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos, lazyMarks = false) {
    const Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    // With `lazyMarks`, the Set is only built once a highlighted segment is actually rendered, so
    // a highlighter with no matches on this text allocates nothing extra.
    let marks = lazyMarks ? undefined : $557a21d984d2652a$var$toMarkNames(marksList);
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        if (!marks) marks = $557a21d984d2652a$var$toMarkNames(marksList);
        return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            })
        }, `${segment.text}_${startPos}_${idx}`);
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});

parcelRegister("akAop", function(module, exports) {
$parcel$export(module.exports, "segmentText", () => $d4f2dbcdc69434a0$export$93301b6f1ff0b0c3);
function $d4f2dbcdc69434a0$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});


parcelRegister("3dFu0", function(module, exports) {
$parcel$export(module.exports, "InsertDraftPosition", () => $1cc4075d225cef32$export$c1bd4813440b4505);
var $1cc4075d225cef32$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("iwVx4", function(module, exports) {
$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $379e2b8ec7bfd43b$export$b1baddbd5f289877);

var $3dFu0 = parcelRequire("3dFu0");
const $379e2b8ec7bfd43b$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $3dFu0.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $3dFu0.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $3dFu0.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $3dFu0.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("ajw0q", function(module, exports) {
$parcel$export(module.exports, "findTextString", () => $4c5a7e3310228cb1$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $4c5a7e3310228cb1$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $4c5a7e3310228cb1$export$1059bfc467f4f55d);

var $fc4bM = parcelRequire("fc4bM");
const $4c5a7e3310228cb1$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($4c5a7e3310228cb1$var$isReactElement(childNode) && childNode.props.children) result = $4c5a7e3310228cb1$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $4c5a7e3310228cb1$var$isReactElement(child) {
    return !!child.type;
}
const $4c5a7e3310228cb1$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $4c5a7e3310228cb1$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});



parcelRegister("hZlCI", function(module, exports) {
$parcel$export(module.exports, "insideBlockNode", () => $bf2ec242bd0456c9$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $bf2ec242bd0456c9$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $bf2ec242bd0456c9$export$244bf4b32387ef62);
$parcel$export(module.exports, "getNestedUnderNodes", () => $bf2ec242bd0456c9$export$a8df1f99c673fa27);
const $bf2ec242bd0456c9$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $bf2ec242bd0456c9$var$isExpandNode = (node)=>node.type.name === 'expand';
const $bf2ec242bd0456c9$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $bf2ec242bd0456c9$export$d7bc71cca336a3b = (path)=>path.some((item)=>$bf2ec242bd0456c9$var$isLayoutNode(item) && $bf2ec242bd0456c9$var$hasBreakOutMark(item));
const $bf2ec242bd0456c9$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$bf2ec242bd0456c9$var$isExpandNode(item) && $bf2ec242bd0456c9$var$hasBreakOutMark(item));
const $bf2ec242bd0456c9$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $bf2ec242bd0456c9$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $bf2ec242bd0456c9$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $bf2ec242bd0456c9$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};

});

parcelRegister("eSNUD", function(module, exports) {
$parcel$export(module.exports, "createContentGetter", () => $1a53d261bd8f4dda$export$18a05b40f8bf404f);
const $1a53d261bd8f4dda$export$18a05b40f8bf404f = (fragment)=>{
    let serialized;
    let materialized = false;
    return ()=>{
        if (!materialized) {
            serialized = fragment ? fragment.toJSON() : undefined;
            // Set last: if `toJSON()` throws, the error propagates and a retry re-attempts instead of
            // caching a partial result.
            materialized = true;
        }
        return serialized;
    };
};

});

parcelRegister("1Sher", function(module, exports) {
$parcel$export(module.exports, "getStandaloneBackgroundColorMarks", () => $20e3bf79a41e9d79$export$eeb66772b38d7581);

var $gV3Ti = parcelRequire("gV3Ti");
const $20e3bf79a41e9d79$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true // initial value to handle leading BackgroundColor
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $gV3Ti.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $gV3Ti.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $gV3Ti.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};

});

parcelRegister("eFo2X", function(module, exports) {
$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $7b8b80182dcc34bc$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $7b8b80182dcc34bc$export$acb253d79d72af92);
function $7b8b80182dcc34bc$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $7b8b80182dcc34bc$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$7b8b80182dcc34bc$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("imO2b", function(module, exports) {
$parcel$export(module.exports, "markBlockAsInline", () => $1816e7b3ea391a8b$export$3a88c97d9b0d8d1c);
function $1816e7b3ea391a8b$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, isTopLevel: isTopLevel = true }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        var _node$attrs, _node$attrs2, _node$attrs3, _node$attrs4, _node$attrs5, _node$attrs6;
        if (!isTopLevel && (node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === 'com.atlassian.ecosystem' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.parameters) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.layout) === 'inline-bodied') return false;
        return Boolean((node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.extensionKey,
            extensionType: (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.extensionType,
            parameters: (_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.parameters,
            content: node.content,
            localId: (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode !== null && prevNode !== void 0 && prevNode.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}

});


parcelRegister("6Hdvp", function(module, exports) {
$parcel$export(module.exports, "EditorMediaClientProvider", () => $cf9afc1bb4aeacfe$export$77218b6ff680865f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $kMctD = parcelRequire("kMctD");

var $bLScU = parcelRequire("bLScU");

var $4cz1R = parcelRequire("4cz1R");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");
const $cf9afc1bb4aeacfe$var$getMediaClientConfigForRenderer = (provider)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return provider.viewAndUploadMediaClientConfig && (0, $dRkX9.fg)('platform_media_video_captions') ? provider.viewAndUploadMediaClientConfig : provider.viewMediaClientConfig;
};
const $cf9afc1bb4aeacfe$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $fc4bM.useState)(()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_media_reliability_enhancements') ? ssr === null || ssr === void 0 ? void 0 : ssr.config : undefined);
    const providerFactory = (0, $kMctD.useProviderFactory)();
    const mediaProvider = (0, $kMctD.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ const shouldSkipContext = (0, $bcN2K.isExperimentEnabled)('platform_editor_media_reliability_enhancements') ? Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    const contextMediaClient = (0, $fc4bM.useContext)((0, $4cz1R.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $fc4bM.useMemo)(()=>mediaClientConfig ? (0, $bLScU.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    // When the experiment is enabled, use useEffect instead of useLayoutEffect because:
    // - For the ssr.config branch: useState is already initialised with ssr.config, so this
    //   effect is a no-op on first render — the "before paint" guarantee is irrelevant.
    // - For the mediaProvider branch: the actual work happens inside a Promise callback which
    //   resolves asynchronously, so it can never run before paint regardless of which hook
    //   schedules it — useLayoutEffect's guarantee is equally irrelevant here.
    // The legacy path keeps useLayoutEffect to preserve existing behaviour when the experiment is off.
    //
    // The two hooks below are mutually exclusive — only one runs per render — so there is no
    // actual chaining of state updates at runtime. The lint rule cannot statically prove this.
    (0, $fc4bM.useEffect)(()=>{
        if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_media_reliability_enhancements')) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMediaClientConfig(ssr.config);
        else if (mediaProvider) {
            let cancelled = false;
            // Cancellation flag prevents setMediaClientConfig from being called after
            // unmount or when mediaProvider changes mid-flight (stale promise fix).
            // No .catch() is needed — the media provider is not expected to reject,
            // and a catch handler would be a no-op anyway.
            mediaProvider.then((provider)=>{
                if (!cancelled) setMediaClientConfig($cf9afc1bb4aeacfe$var$getMediaClientConfigForRenderer(provider));
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    // Legacy path (experiment off): keep useLayoutEffect to preserve existing behaviour.
    // remove this when clean up platform_editor_media_reliability_enhancements
    (0, $fc4bM.useLayoutEffect)(()=>{
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_media_reliability_enhancements')) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig($cf9afc1bb4aeacfe$var$getMediaClientConfigForRenderer(provider));
        });
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4cz1R.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});

parcelRegister("kVBv0", function(module, exports) {
$parcel$export(module.exports, "renderDocument", () => $3cb810a27ff2382b$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jiju3 = parcelRequire("jiju3");

var $b4w4S = parcelRequire("b4w4S");

var $7c95O = parcelRequire("7c95O");

var $4na70 = parcelRequire("4na70");

var $5nnU0 = parcelRequire("5nnU0");

var $iyvuh = parcelRequire("iyvuh");

var $3LeME = parcelRequire("3LeME");

var $6DM8w = parcelRequire("6DM8w");

var $pSP9h = parcelRequire("pSP9h");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $a63R3 = parcelRequire("a63R3");

var $9De3B = parcelRequire("9De3B");

var $czk7W = parcelRequire("czk7W");
const $3cb810a27ff2382b$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $3cb810a27ff2382b$var$withStopwatch = (cb)=>{
    const startTime = $3cb810a27ff2382b$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $3cb810a27ff2382b$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $3cb810a27ff2382b$var$_validation = (doc, schema, adfStage, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    // link mark on mediaSingle is deprecated, need to move link mark to child media node
    // https://product-fabric.atlassian.net/browse/ED-14043
    const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4na70.transformMediaLinkMarks)(doc);
    if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
        action: (0, $3LeME.ACTION).MEDIA_LINK_TRANSFORMED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
    });
    // Forward `adfStage` only when a caller names one. Omitting it keeps stage-0 specs acceptable,
    // which is what a renderer wants: stored documents can contain them, and wrapping such content
    // as unsupported is worse than rendering it. A caller that declares `final` asks for full-ADF
    // strictness and gets it.
    let result = skipValidation ? transformedAdf || doc : (0, $pSP9h.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides, adfStage);
    // The spec validator can return the original root object when malformed JSON has no node type.
    // Reject it here, matching the legacy validator, before ProseMirror attempts to deserialize it.
    if (!result || typeof result.type !== 'string' || result.type.length === 0) return null;
    // ProseMirror always require a child under doc
    if (result.type === 'doc') {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $iyvuh.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $3LeME.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $a63R3.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    // Upgrade panel → panel_c1 where the schema allows it
    if (result && (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $7c95O.transformContainerNodes)(result, schema);
        if (isTransformed && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $3LeME.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $a63R3.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel to panel_c1' : undefined}`
            }
        });
    }
    if (result && !(0, $aEmSo.expValEquals)('cc-maui-experiment', 'isEnabled', true) && !((0, $dRkX9.fg)('platform_native_embeds_rollout_non_maui_experience') || (0, $dRkX9.fg)('platform_native_embeds_rollout_all_products')) && (0, $dRkX9.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $5nnU0.nativeEmbedsFallbackTransform)(result, schema);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $3LeME.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $3cb810a27ff2382b$var$memoValidation = (0, $jiju3.default)($3cb810a27ff2382b$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    // `areDocsEqual` may stringify the whole document, so it goes last and only runs once everything
    // cheaper has matched.
    return newSchema === oldSchema && newADFStage === oldADFStage && newSkipValidation === oldSkipValidation && $3cb810a27ff2382b$var$areValidationOverridesEqual(newValidationOverrides, oldValidationOverrides) && $3cb810a27ff2382b$var$areDocsEqual(newDoc, oldDoc);
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3cb810a27ff2382b$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) {
        // `Node.eq` compares markup and content directly; stringifying both `toJSON` trees gives the
        // same answer ~14x slower on a 5k-node document.
        if (typeof docA.eq === 'function' && typeof docB.eq === 'function') return docA.eq(docB);
        return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    }
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
/**
 * `Renderer` rebuilds this object in its render body, so a reference check never matches and the memo
 * re-validates (and re-transforms) an unchanged document every render. A flat bag of optional
 * booleans, so a shallow key/value comparison is exact and free next to what it protects.
 */ const $3cb810a27ff2382b$var$areValidationOverridesEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const aEntries = Object.entries(a);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bRecord = b;
    return aEntries.length === Object.keys(b).length && aEntries.every(([key, value])=>bRecord[key] === value);
};
const $3cb810a27ff2382b$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $3cb810a27ff2382b$var$memoSerializeFragment = (0, $jiju3.default)($3cb810a27ff2382b$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $3cb810a27ff2382b$var$areDocsEqual(newDoc, oldDoc);
});
const $3cb810a27ff2382b$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $a63R3.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $3cb810a27ff2382b$var$memoCreateNodeAndCheck = (0, $jiju3.default)($3cb810a27ff2382b$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $3cb810a27ff2382b$var$areDocsEqual(newDoc, oldDoc);
});
const $3cb810a27ff2382b$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $b4w4S.defaultSchema), adfStage, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $3cb810a27ff2382b$var$withStopwatch(()=>{
        return $3cb810a27ff2382b$var$memoValidation(doc, schema, adfStage, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $3cb810a27ff2382b$var$withStopwatch(()=>{
        return $3cb810a27ff2382b$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $3cb810a27ff2382b$var$withStopwatch(()=>{
        return $3cb810a27ff2382b$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent) {
        (0, $6DM8w.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $9De3B.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $czk7W.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("7c95O", function(module, exports) {
$parcel$export(module.exports, "transformContainerNodes", () => $54911b31277e3a1d$export$62836639b6ded12a);

var $bcN2K = parcelRequire("bcN2K");

var $9RIwK = parcelRequire("9RIwK");

var $kGuAC = parcelRequire("kGuAC");

var $7BPFO = parcelRequire("7BPFO");
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows a `panel_c1` child. Returns an empty set if the
 * schema does not declare a `panel_c1` node.
 */ const $54911b31277e3a1d$var$getPanelC1AllowedParentTypes = (schema)=>{
    const panelC1Type = schema.nodes['panel_c1'];
    if (!panelC1Type) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes)){
        var _nodeType$contentMatc;
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(panelC1Type)) allowed.add(nodeType.name);
    }
    return allowed;
};
/**
 * Resolves which ancestor will actually become the parent of the top-level nodes of `adf`
 * once the fragment is placed back into its destination document.
 *
 * Walks `parentNodes` innermost-first and returns the first type whose content expression
 * accepts a `panel`. Ancestors closer in than that (a textblock the selection happens to sit
 * in, for instance) cannot hold a panel, so they cannot be the effective parent. Returns
 * `undefined` when no destination context was supplied or none of the ancestors can hold a
 * panel, in which case callers fall back to the parent seen during traversal.
 */ const $54911b31277e3a1d$var$resolveEffectiveRootParentType = (schema, parentNodes)=>{
    const panelType = schema.nodes['panel'];
    if (!panelType || !(parentNodes !== null && parentNodes !== void 0 && parentNodes.length)) return undefined;
    for(let index = parentNodes.length - 1; index >= 0; index--){
        var _schema$nodes$parentT;
        const parentType = parentNodes[index];
        if ((_schema$nodes$parentT = schema.nodes[parentType]) !== null && _schema$nodes$parentT !== void 0 && (_schema$nodes$parentT = _schema$nodes$parentT.contentMatch) !== null && _schema$nodes$parentT !== void 0 && _schema$nodes$parentT.matchType(panelType)) return parentType;
    }
    return undefined;
};
const $54911b31277e3a1d$export$fe0c97d482910ea = (adf, schema, options)=>{
    const panelC1AllowedParents = $54911b31277e3a1d$var$getPanelC1AllowedParentTypes(schema);
    if (panelC1AllowedParents.size === 0) return {
        isTransformed: false,
        transformedAdf: adf
    };
    const topNodeType = schema.topNodeType.name;
    const effectiveRootParentType = $54911b31277e3a1d$var$resolveEffectiveRootParentType(schema, options === null || options === void 0 ? void 0 : options.parentNodes);
    let isTransformed = false;
    const transformedAdf = (0, $9RIwK.traverse)(adf, {
        panel: (node, parent, _index, depth)=>{
            var _parent$node, _parent$node2;
            // A panel sitting directly under the top node is destined for whatever the
            // fragment gets inserted into, not for the top node itself.
            const isTopLevelNode = depth === 1 && ((_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) === topNodeType;
            const parentType = isTopLevelNode && effectiveRootParentType ? effectiveRootParentType : (_parent$node2 = parent.node) === null || _parent$node2 === void 0 ? void 0 : _parent$node2.type;
            if (parentType && panelC1AllowedParents.has(parentType)) {
                isTransformed = true;
                return {
                    ...node,
                    type: 'panel_c1'
                };
            }
            return;
        }
    });
    return {
        isTransformed: isTransformed,
        transformedAdf: transformedAdf
    };
};
const $54911b31277e3a1d$export$62836639b6ded12a = (adf, schema, options)=>{
    let isTransformed = false;
    const transformedNodeTypes = new Set();
    let transformedAdf = adf;
    // Gate the generalised (table + expand + panel + blockquote + bodiedExtension) transform
    // behind the consolidated container-in-panel experiment; the in-production table-in-panel
    // path continues to use the deprecated table-only transform.
    const panelC1FallbackResult = (0, $bcN2K.isExperimentEnabled)('platform_editor_nest_container_in_panel') ? (0, $7BPFO.panelC1FallbackTransformV2)(schema, transformedAdf) : (0, $kGuAC.panelC1FallbackTransform)(schema, transformedAdf);
    if (panelC1FallbackResult.isTransformed && panelC1FallbackResult.transformedAdf) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
        transformedAdf = panelC1FallbackResult.transformedAdf;
    }
    const promotionResult = $54911b31277e3a1d$export$fe0c97d482910ea(transformedAdf, schema, options);
    if (promotionResult.isTransformed) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
    }
    return {
        transformedAdf: promotionResult.transformedAdf,
        isTransformed: isTransformed,
        transformedNodeTypes: Array.from(transformedNodeTypes)
    };
};

});
parcelRegister("kGuAC", function(module, exports) {
$parcel$export(module.exports, "panelC1FallbackTransform", () => $aaf362174d448cad$export$9a4ff29f7abd9bcd);

var $9RIwK = parcelRequire("9RIwK");
// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping a table in an LCM keeps
// it visible/editable inside a plain `panel` (which permits `extension` children) —
// unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
const $aaf362174d448cad$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $aaf362174d448cad$var$LCM_EXTENSION_KEY = 'legacy-content';
const $aaf362174d448cad$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped table may be restored into. A plain `panel` doesn't yet allow a
// `table`, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the table here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping tables wrapped elsewhere.
const $aaf362174d448cad$var$TABLE_RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
const $aaf362174d448cad$var$safeParseAdf = (adf)=>{
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch  {
        return undefined;
    }
};
const $aaf362174d448cad$var$wrapAsLcm = (node)=>{
    const nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $aaf362174d448cad$var$LCM_EXTENSION_TYPE,
            extensionKey: $aaf362174d448cad$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: {
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent),
                [$aaf362174d448cad$var$PANEL_C1_FALLBACK_MARKER]: true
            }
        }
    };
};
const $aaf362174d448cad$var$isLcm = (node)=>{
    var _node$attrs, _node$attrs2, _node$attrs3;
    return node.type === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === $aaf362174d448cad$var$LCM_EXTENSION_TYPE && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === $aaf362174d448cad$var$LCM_EXTENSION_KEY && ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 || (_node$attrs3 = _node$attrs3.parameters) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3[$aaf362174d448cad$var$PANEL_C1_FALLBACK_MARKER]) === true;
};
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ const $aaf362174d448cad$var$getLcmWrappedNode = (node)=>{
    var _node$attrs4, _nested$content;
    const params = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.parameters;
    const nested = (params === null || params === void 0 ? void 0 : params.nestedContent) ?? $aaf362174d448cad$var$safeParseAdf(params === null || params === void 0 ? void 0 : params.adf);
    return (nested === null || nested === void 0 || (_nested$content = nested.content) === null || _nested$content === void 0 ? void 0 : _nested$content.length) === 1 ? nested.content[0] : undefined;
};
const $aaf362174d448cad$var$wrappedNodeIsTable = (node)=>{
    var _getLcmWrappedNode, _node$attrs5;
    return $aaf362174d448cad$var$isLcm(node) && ((_getLcmWrappedNode = $aaf362174d448cad$var$getLcmWrappedNode(node)) === null || _getLcmWrappedNode === void 0 ? void 0 : _getLcmWrappedNode.type) === 'table' || node.type === 'unsupportedBlock' && ((_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 || (_node$attrs5 = _node$attrs5.originalValue) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.type) === 'table';
};
const $aaf362174d448cad$var$isTableInPanelSupported = (schema)=>{
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    return true;
};
const $aaf362174d448cad$export$9a4ff29f7abd9bcd = (schema, adf)=>{
    let isTransformed = false;
    const { extension: extension, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const tableInPanelSupported = $aaf362174d448cad$var$isTableInPanelSupported(schema);
    const shouldDowngrade = !tableInPanelSupported;
    const shouldRestore = tableInPanelSupported;
    const hasRelevantNode = (node)=>shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $aaf362174d448cad$var$wrappedNodeIsTable(node) || Array.isArray(node.content) && node.content.some((c)=>!!c && hasRelevantNode(c));
    if (!hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    const wrapTable = (tableNode)=>extension ? $aaf362174d448cad$var$wrapAsLcm(tableNode) : unsupportedBlock.createChecked({
            originalValue: tableNode
        }).toJSON();
    const downgradePanel = (node)=>{
        if (!Array.isArray(node.content)) return node;
        const hasTableChild = node.content.some((child)=>(child === null || child === void 0 ? void 0 : child.type) === 'table');
        if (hasTableChild && !extension && !unsupportedBlock) return node;
        const content = node.content.map((child)=>{
            if ((child === null || child === void 0 ? void 0 : child.type) === 'table') {
                isTransformed = true;
                return wrapTable(child);
            }
            return child;
        });
        isTransformed = true;
        return {
            ...node,
            type: 'panel',
            content: content
        };
    };
    const restoreWrappedTable = (node, parent)=>{
        var _parent$node, _node$attrs6;
        if (!$aaf362174d448cad$var$TABLE_RESTORE_PARENT_TYPES.has((parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) ?? '')) return node;
        const restored = $aaf362174d448cad$var$isLcm(node) ? $aaf362174d448cad$var$getLcmWrappedNode(node) : (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.originalValue;
        if ((restored === null || restored === void 0 ? void 0 : restored.type) === 'table') {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    const transformedAdf = (0, $9RIwK.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping table children.
        panel_c1: (node)=>shouldDowngrade ? downgradePanel(node) : node,
        // Supported schema: restore tables wrapped as an LCM / unsupportedBlock.
        extension: (node, parent)=>shouldRestore ? restoreWrappedTable(node, parent) : node,
        unsupportedBlock: (node, parent)=>shouldRestore ? restoreWrappedTable(node, parent) : node
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("7BPFO", function(module, exports) {
$parcel$export(module.exports, "panelC1FallbackTransformV2", () => $5a36da24b857e561$export$b8c073a615247b65);

var $9RIwK = parcelRequire("9RIwK");
// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping an extended child (table,
// expand) in an LCM keeps it visible/editable inside a plain `panel` (which permits
// `extension` children) — unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
const $5a36da24b857e561$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $5a36da24b857e561$var$LCM_EXTENSION_KEY = 'legacy-content';
const $5a36da24b857e561$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped child may be restored into. A plain `panel` doesn't yet allow the
// extended children, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the child here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping children wrapped elsewhere.
const $5a36da24b857e561$var$RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
// The extended block children unlocked on `panel_c1` over successive nesting scenarios.
// Each is a plain-`panel`-incompatible child that must be LCM-wrapped when the schema
// doesn't support `panel_c1`, and restored when it does.
// - table  (platform_editor_nest_table_in_panel)
// - expand (platform_editor_nest_expand_in_panel)
const $5a36da24b857e561$var$PANEL_C1_EXTENDED_CHILD_TYPES = new Set([
    'table',
    'expand'
]);
const $5a36da24b857e561$var$safeParseAdf = (adf)=>{
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch  {
        return undefined;
    }
};
const $5a36da24b857e561$var$wrapAsLcm = (node)=>{
    const nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $5a36da24b857e561$var$LCM_EXTENSION_TYPE,
            extensionKey: $5a36da24b857e561$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: {
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent),
                [$5a36da24b857e561$var$PANEL_C1_FALLBACK_MARKER]: true
            }
        }
    };
};
const $5a36da24b857e561$var$isLcm = (node)=>{
    var _node$attrs, _node$attrs2, _node$attrs3;
    return node.type === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === $5a36da24b857e561$var$LCM_EXTENSION_TYPE && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === $5a36da24b857e561$var$LCM_EXTENSION_KEY && ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 || (_node$attrs3 = _node$attrs3.parameters) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3[$5a36da24b857e561$var$PANEL_C1_FALLBACK_MARKER]) === true;
};
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ const $5a36da24b857e561$var$getLcmWrappedNode = (node)=>{
    var _node$attrs4, _nested$content;
    const params = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.parameters;
    const nested = (params === null || params === void 0 ? void 0 : params.nestedContent) ?? $5a36da24b857e561$var$safeParseAdf(params === null || params === void 0 ? void 0 : params.adf);
    return (nested === null || nested === void 0 || (_nested$content = nested.content) === null || _nested$content === void 0 ? void 0 : _nested$content.length) === 1 ? nested.content[0] : undefined;
};
// Type guard: true when the node is a defined extended child of panel_c1 (table, expand, ...).
// Narrows `node` to `ADFEntity` so callers can safely operate on it.
const $5a36da24b857e561$var$isExtendedChild = (node)=>!!(node !== null && node !== void 0 && node.type) && $5a36da24b857e561$var$PANEL_C1_EXTENDED_CHILD_TYPES.has(node.type);
const $5a36da24b857e561$var$wrappedNodeIsExtendedChild = (node)=>{
    var _node$attrs5;
    return $5a36da24b857e561$var$isLcm(node) && $5a36da24b857e561$var$isExtendedChild($5a36da24b857e561$var$getLcmWrappedNode(node)) || node.type === 'unsupportedBlock' && $5a36da24b857e561$var$isExtendedChild((_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.originalValue);
};
const $5a36da24b857e561$var$isPanelC1Supported = (schema)=>{
    if (!schema.nodes.panel_c1) return false;
    // The schema must also declare at least one of the extended child node types, otherwise
    // there's nothing to wrap/restore.
    return Array.from($5a36da24b857e561$var$PANEL_C1_EXTENDED_CHILD_TYPES).some((type)=>!!schema.nodes[type]);
};
const $5a36da24b857e561$export$b8c073a615247b65 = (schema, adf)=>{
    let isTransformed = false;
    const { extension: extension, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const panelC1Supported = $5a36da24b857e561$var$isPanelC1Supported(schema);
    const shouldDowngrade = !panelC1Supported;
    const shouldRestore = panelC1Supported;
    const hasRelevantNode = (node)=>shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $5a36da24b857e561$var$wrappedNodeIsExtendedChild(node) || Array.isArray(node.content) && node.content.some((c)=>!!c && hasRelevantNode(c));
    if (!hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    const wrapChild = (childNode)=>extension ? $5a36da24b857e561$var$wrapAsLcm(childNode) : unsupportedBlock.createChecked({
            originalValue: childNode
        }).toJSON();
    const downgradePanel = (node)=>{
        if (!Array.isArray(node.content)) return node;
        const hasExtendedChild = node.content.some((child)=>$5a36da24b857e561$var$isExtendedChild(child));
        if (hasExtendedChild && !extension && !unsupportedBlock) return node;
        const content = node.content.map((child)=>{
            if ($5a36da24b857e561$var$isExtendedChild(child)) {
                isTransformed = true;
                return wrapChild(child);
            }
            return child;
        });
        isTransformed = true;
        return {
            ...node,
            type: 'panel',
            content: content
        };
    };
    const restoreWrappedChild = (node, parent)=>{
        var _parent$node, _node$attrs6;
        if (!$5a36da24b857e561$var$RESTORE_PARENT_TYPES.has((parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) ?? '')) return node;
        const restored = $5a36da24b857e561$var$isLcm(node) ? $5a36da24b857e561$var$getLcmWrappedNode(node) : (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.originalValue;
        if ($5a36da24b857e561$var$isExtendedChild(restored)) {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    const transformedAdf = (0, $9RIwK.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping extended children.
        panel_c1: (node)=>shouldDowngrade ? downgradePanel(node) : node,
        // Supported schema: restore children wrapped as an LCM / unsupportedBlock.
        extension: (node, parent)=>shouldRestore ? restoreWrappedChild(node, parent) : node,
        unsupportedBlock: (node, parent)=>shouldRestore ? restoreWrappedChild(node, parent) : node
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});


parcelRegister("4na70", function(module, exports) {
$parcel$export(module.exports, "transformMediaLinkMarks", () => $f0fb8dfbcddc9fce$export$6528700f3fa2fe2a);

var $9RIwK = parcelRequire("9RIwK");
const $f0fb8dfbcddc9fce$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $9RIwK.traverse)(adf, {
        mediaSingle: (node)=>{
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("5nnU0", function(module, exports) {
$parcel$export(module.exports, "nativeEmbedsFallbackTransform", () => $520d84040dba8826$export$fdee1e5f1664414c);

var $9RIwK = parcelRequire("9RIwK");

var $77DyS = parcelRequire("77DyS");
const $520d84040dba8826$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows an `embedCard` child. Returns an empty set if the
 * schema does not declare an `embedCard` node.
 */ const $520d84040dba8826$var$getEmbedCardAllowedParentTypes = (schema)=>{
    const embedCardType = schema.nodes.embedCard;
    if (!embedCardType) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes)){
        var _nodeType$contentMatc;
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(embedCardType)) allowed.add(nodeType.name);
    }
    return allowed;
};
const $520d84040dba8826$export$fdee1e5f1664414c = (adf, schema)=>{
    const embedCardAllowedParentTypes = $520d84040dba8826$var$getEmbedCardAllowedParentTypes(schema);
    const isEmbedCardAllowedInParent = (parent)=>{
        var _parent$node;
        const parentType = parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type;
        return parentType ? embedCardAllowedParentTypes.has(parentType) : false;
    };
    let didTransform = false;
    const transformedAdf = (0, $9RIwK.traverse)(adf, {
        extension: (node, parent)=>{
            var _node$attrs, _node$attrs2;
            if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs['extensionKey'].split(':')[0]) !== $520d84040dba8826$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2['parameters']) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.macroParams) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.url) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            if (isEmbedCardAllowedInParent(parent)) return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'center'
                }
            };
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $77DyS.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};

});

parcelRegister("iyvuh", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $9b374a4b52359418$export$18544d0b5f43e4a1);

var $9RIwK = parcelRequire("9RIwK");

var $6g3YR = parcelRequire("6g3YR");

var $aQdmQ = parcelRequire("aQdmQ");
const $9b374a4b52359418$var$transformNestedTableExtension = (nestedTableExtension)=>{
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        const adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $6g3YR.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
const $9b374a4b52359418$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $9RIwK.traverse)(adf, {
        extension: (node)=>{
            if ((0, $aQdmQ.isNestedTableExtension)(node)) {
                isTransformed = true;
                return $9b374a4b52359418$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("aQdmQ", function(module, exports) {
$parcel$export(module.exports, "isNestedTableExtension", () => $33c68c6bb971d343$export$f45e7335ec874bfe);

var $9yZC8 = parcelRequire("9yZC8");
const $33c68c6bb971d343$export$f45e7335ec874bfe = (extensionNode)=>{
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === (0, $9yZC8.NESTED_TABLE_EXTENSION_TYPE) && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === (0, $9yZC8.NESTED_TABLE_EXTENSION_KEY);
};

});


parcelRegister("pSP9h", function(module, exports) {
$parcel$export(module.exports, "validationErrorHandler", () => $30a084fd2cd59a18$export$468b008419c9a974);
$parcel$export(module.exports, "validateADFEntity", () => $30a084fd2cd59a18$export$884cfad20dece33e);

var $77DyS = parcelRequire("77DyS");

var $3LeME = parcelRequire("3LeME");

var $hcz63 = parcelRequire("hcz63");

var $6DM8w = parcelRequire("6DM8w");

var $3R1gR = parcelRequire("3R1gR");
const $30a084fd2cd59a18$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $30a084fd2cd59a18$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $30a084fd2cd59a18$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowNestedTables,
            allowTableInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowTableInPanel,
            allowContainerInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowContainerInPanel
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $30a084fd2cd59a18$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $30a084fd2cd59a18$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return (0, $3R1gR.wrapWithUnsupported)(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $30a084fd2cd59a18$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $30a084fd2cd59a18$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $30a084fd2cd59a18$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta !== null && meta !== void 0 && meta.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta === null || meta === void 0 ? void 0 : meta.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, expand-in-panel documents are stored as
    // plain ADF `panel` nodes containing an `expand`. The base validator-spec does not permit
    // `expand` inside `panel` (it's gated behind the consolidated container-in-panel experiment,
    // see `isPanelNestingContainerSupported`), so we suppress the INVALID_CONTENT error when
    // `allowContainerInPanel` is set.
    if (options.allowContainerInPanel) {
        const meta = error.meta;
        if ((meta === null || meta === void 0 ? void 0 : meta.parentType) === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'expand') return entity;
    }
    if (options.allowUnsupportedBlock) return (0, $3R1gR.wrapWithUnsupported)(entity);
    if (options.allowUnsupportedInline) return (0, $3R1gR.wrapWithUnsupported)(entity, 'inline');
    if (dispatchAnalyticsEvent) $30a084fd2cd59a18$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $30a084fd2cd59a18$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? (0, $3R1gR.wrapWithUnsupported)(child) : validate(child, $30a084fd2cd59a18$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return (0, $3R1gR.wrapWithUnsupported)(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? (0, $3R1gR.wrapWithUnsupported)(child) : child;
        });
    }
    return entity;
}
function $30a084fd2cd59a18$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $6DM8w.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $3LeME.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $30a084fd2cd59a18$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides, adfStage)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    // Full-ADF strictness is opt-in: only a caller that names `final` gets it, and omitting `adfStage`
    // keeps stage-0 specs acceptable. Strictness has to be asked for rather than defaulted into,
    // because a document holding a stage-0-only construct, such as a `layoutSection` with one column,
    // otherwise has that content wrapped as unsupported. Editors carry such constructs by design,
    // since the editor's own schema enables them, and renderers meet them in stored documents.
    const validate = (0, $77DyS.validator)(nodes, marks, {
        allowPrivateAttributes: true,
        stage0: adfStage !== (0, $hcz63.ADFStages).FINAL
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $30a084fd2cd59a18$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};

});
parcelRegister("hcz63", function(module, exports) {
$parcel$export(module.exports, "ADFStages", () => $1f5bc91fead8956a$export$3b94ef2190b2d585);
const $1f5bc91fead8956a$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};

});

parcelRegister("3R1gR", function(module, exports) {
$parcel$export(module.exports, "wrapWithUnsupported", () => $f2e6fc533045e88e$export$87b732fa69cdf16e);
function $f2e6fc533045e88e$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});


parcelRegister("9De3B", function(module, exports) {
$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $5f9dbbb655d21cd0$export$a43de96edd8d0a0);

var $3LeME = parcelRequire("3LeME");

var $eL7f2 = parcelRequire("eL7f2");

var $aKzMA = parcelRequire("aKzMA");

var $a63R3 = parcelRequire("a63R3");
const $5f9dbbb655d21cd0$var$rendersMap = {};
const $5f9dbbb655d21cd0$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $aKzMA.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $eL7f2.getAnalyticsAppearance)(item.appearance),
                platform: (0, $a63R3.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $a63R3.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $5f9dbbb655d21cd0$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $5f9dbbb655d21cd0$var$DEFAULT_SAMPLING_RATE = 100;
const $5f9dbbb655d21cd0$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$5f9dbbb655d21cd0$var$rendersMap[appearance]) $5f9dbbb655d21cd0$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $5f9dbbb655d21cd0$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $5f9dbbb655d21cd0$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $5f9dbbb655d21cd0$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($5f9dbbb655d21cd0$var$rendersMap[appearance].size === 1) $5f9dbbb655d21cd0$var$schedule(()=>$5f9dbbb655d21cd0$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($5f9dbbb655d21cd0$var$rendersMap[appearance].size % sampleRate === 0) $5f9dbbb655d21cd0$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("aKzMA", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $1fbe75b41da88c08$export$484b83e0462998d);

var $9RIwK = parcelRequire("9RIwK");

var $5JXZ6 = parcelRequire("5JXZ6");

var $g8K1z = parcelRequire("g8K1z");
const $1fbe75b41da88c08$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || (0, $g8K1z.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || (0, $g8K1z.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).BLOCKING
    };
};
const $1fbe75b41da88c08$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $9RIwK.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                const originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $9RIwK.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        var _parent$parent;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = ((_parent$parent = parent.parent) === null || _parent$parent === void 0 || (_parent$parent = _parent$parent.node) === null || _parent$parent === void 0 ? void 0 : _parent$parent.type) ?? 'unknown';
                        const type = `${parentType}/${(unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = ((unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $1fbe75b41da88c08$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return (0, $5JXZ6.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return (0, $5JXZ6.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).BLOCKING;
    return (0, $5JXZ6.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).NORMAL;
};
const $1fbe75b41da88c08$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $1fbe75b41da88c08$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $1fbe75b41da88c08$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $1fbe75b41da88c08$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});
parcelRegister("5JXZ6", function(module, exports) {
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_LEVEL_SEVERITY", () => $954b71108e830948$export$6632e71a22d31bf1);
var $954b71108e830948$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});

});

parcelRegister("g8K1z", function(module, exports) {
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS", () => $be5cfbaa9e47c3ce$export$f9f8a29778652c3e);
const $be5cfbaa9e47c3ce$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};

});



parcelRegister("czk7W", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $3f501134d4844813$export$1daf15cbaf649dad);
/* eslint-disable jsdoc/require-jsdoc */ 
var $45kB9 = parcelRequire("45kB9");
function $3f501134d4844813$export$1daf15cbaf649dad(adfDocument) {
    return (0, $45kB9.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("45kB9", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $3e69c2101b2dc9e3$export$533b26079ad0b4b);

var $9RIwK = parcelRequire("9RIwK");
function $3e69c2101b2dc9e3$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $9RIwK.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("5lVP5", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $e8603d7bbd90ddac$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $e8603d7bbd90ddac$export$cddc3c6ebe2d2cec);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $e8603d7bbd90ddac$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(undefined);
const $e8603d7bbd90ddac$export$20439b49fdd0d26c = $e8603d7bbd90ddac$var$dest.Provider;
const $e8603d7bbd90ddac$var$Consumer = $e8603d7bbd90ddac$var$dest.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $e8603d7bbd90ddac$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $fc4bM.useState)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)($e8603d7bbd90ddac$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("scK4d", function(module, exports) {
$parcel$export(module.exports, "useScrollToBlock", () => $2f282e022efc5c37$export$81bdbc2b3f1c95ef);

var $fc4bM = parcelRequire("fc4bM");

var $j5N6B = parcelRequire("j5N6B");

var $66P2W = parcelRequire("66P2W");
var $hQPwW = parcelRequire("hQPwW");
var $9A8aY = parcelRequire("9A8aY");

var $7pa9Y = parcelRequire("7pa9Y");

var $1J7sh = parcelRequire("1J7sh");

var $9k41B = parcelRequire("9k41B");
const $2f282e022efc5c37$export$81bdbc2b3f1c95ef = (containerRef, adfDoc, scrollToBlock)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $9k41B.useStableScroll)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $fc4bM.useEffect)(()=>{
        var _getDocument;
        // Only run in browser environment.
        if (typeof window === 'undefined' || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $7pa9Y.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $1J7sh.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $9A8aY.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $66P2W.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $hQPwW.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            cancelExpandAndScroll = (0, $1J7sh.expandAllParentsThenScroll)(element, 0, (el)=>{
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $1J7sh.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $9A8aY.isExpandCollapsed)(expandContainer)) {
                    (0, $66P2W.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $hQPwW.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if (((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.readyState) === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            var _getDocument2;
            if (((_getDocument2 = (0, $j5N6B.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.readyState) === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};

});
parcelRegister("66P2W", function(module, exports) {
$parcel$export(module.exports, "expandElement", () => $082dc4f61735d7b7$export$280ec17414a50cdd);
/**
 * Expand a collapsed expand node by clicking its toggle button.
 *
 * This function finds the toggle button with aria-expanded="false" and programmatically
 * clicks it to expand the node. It does not wait for the expansion to complete.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the toggle button was found and clicked, false otherwise.
 */ const $082dc4f61735d7b7$export$280ec17414a50cdd = (expandContainer)=>{
    // Find and click the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};

});

parcelRegister("hQPwW", function(module, exports) {
$parcel$export(module.exports, "getLocalIdSelector", () => $e457cfc2ec87d0ff$export$94a68fcf7c5634d2);
const $e457cfc2ec87d0ff$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) // return table wrapper instead of table div, so the height calculation is correct
    return element.parentElement;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};

});

parcelRegister("9A8aY", function(module, exports) {
$parcel$export(module.exports, "isExpandCollapsed", () => $7e85b0958e86a0f7$export$785b8bfd794fa7b6);
/**
 * Check if an expand node is currently collapsed.
 *
 * Uses two methods to determine collapse state:
 * 1. First checks aria-expanded attribute on the toggle button (most reliable).
 * 2. Falls back to checking content div visibility via computed styles.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the expand is collapsed, false if expanded or state cannot be determined.
 */ const $7e85b0958e86a0f7$export$785b8bfd794fa7b6 = (expandContainer)=>{
    // Check for aria-expanded attribute on the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    const contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        const computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || Boolean(contentDiv.hidden);
    }
    return false;
};

});

parcelRegister("7pa9Y", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_BLOCK_LINK_HASH_PREFIX", () => $420502f404c305ce$export$18a71eb9fe4307bc);
$parcel$export(module.exports, "createBlockLinkHashValue", () => $420502f404c305ce$export$7d28ccc9eddf2197);
const $420502f404c305ce$export$18a71eb9fe4307bc = 'block-';
const $420502f404c305ce$export$d7e471f6502a69e2 = (hash, prefix = $420502f404c305ce$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    // Ignored via go/ees019
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    // Ignored via go/ees019
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $420502f404c305ce$export$c95c8d5e0fd74b32 = (hash, prefix = $420502f404c305ce$export$18a71eb9fe4307bc)=>{
    if (!$420502f404c305ce$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $420502f404c305ce$export$7d28ccc9eddf2197 = (blockId, prefix = $420502f404c305ce$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};

});

parcelRegister("1J7sh", function(module, exports) {
$parcel$export(module.exports, "findNodeWithExpandParents", () => $b1f1b74907cde5cc$export$e070f925e0e65bbc);
$parcel$export(module.exports, "expandAllParentsThenScroll", () => $b1f1b74907cde5cc$export$9d8f3695c9ce7da0);
/**
 * Shared utilities for scrolling to block elements with expand node support.
 * Used by both Confluence's useScrollOnUrlChange and platform renderer's useScrollToBlock.
 */ 
var $66P2W = parcelRequire("66P2W");

var $9A8aY = parcelRequire("9A8aY");

var $jpISK = parcelRequire("jpISK");

function $b1f1b74907cde5cc$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    let result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ const traverse = (node, expandAncestors)=>{
        var _node$attrs, _node$attrs2;
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) === targetLocalId) {
            result = {
                expandParentLocalIds: [
                    ...expandAncestors
                ] // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        const isExpand = (node === null || node === void 0 ? void 0 : node.type) === 'expand' || (node === null || node === void 0 ? void 0 : node.type) === 'nestedExpand';
        const newExpandAncestors = isExpand && node !== null && node !== void 0 && (_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.localId ? [
            ...expandAncestors,
            node.attrs.localId
        ] : expandAncestors;
        // Traverse children if they exist
        if (node !== null && node !== void 0 && node.content && Array.isArray(node.content)) for (const child of node.content){
            if (result || !child) break;
            traverse(child, newExpandAncestors);
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    traverse(adfDoc, []);
    return result;
}
const $b1f1b74907cde5cc$export$4fc3b03d60a46096 = (element, maxDepth = (0, $jpISK.SCROLL_TO_BLOCK_TIMING).MAX_EXPAND_DEPTH)=>{
    const expands = [];
    let currentElement = element;
    let depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        const expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
const $b1f1b74907cde5cc$export$9d8f3695c9ce7da0 = (element, attempt = 0, scrollFn)=>{
    const { MAX_EXPAND_DEPTH: MAX_EXPAND_DEPTH, MAX_ATTEMPTS: MAX_ATTEMPTS, DOM_UPDATE_DELAY: DOM_UPDATE_DELAY, RETRY_DELAY: RETRY_DELAY } = (0, $jpISK.SCROLL_TO_BLOCK_TIMING);
    const doScroll = scrollFn ?? ((el)=>el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        }));
    // Store timeout ID and nested cleanup function so they can be cancelled.
    let timeoutId = null;
    let nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    const cleanup = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) doScroll(element);
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        const parentExpands = $b1f1b74907cde5cc$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        const collapsedExpands = parentExpands.filter((expandContainer)=>expandContainer.isConnected && (0, $9A8aY.isExpandCollapsed)(expandContainer));
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            doScroll(element);
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        const outermostCollapsed = collapsedExpands[0];
        try {
            const expanded = (0, $66P2W.expandElement)(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(()=>{
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $b1f1b74907cde5cc$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
                } catch  {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) doScroll(element);
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $b1f1b74907cde5cc$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        } catch  {
            // Retry on error.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $b1f1b74907cde5cc$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        }
    } catch  {
        // Fallback to simple scroll on error.
        if (element.isConnected) doScroll(element);
    }
    return cleanup;
};

});
parcelRegister("jpISK", function(module, exports) {
$parcel$export(module.exports, "SCROLL_TO_BLOCK_TIMING", () => $ff1efcea58079d39$export$7f8747c9df4cadcb);
/**
 * Timing constants for expand animation and DOM update delays.
 * These values are tuned for the expand component's behavior and React's update cycle.
 */ const $ff1efcea58079d39$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};

});


parcelRegister("9k41B", function(module, exports) {
$parcel$export(module.exports, "useStableScroll", () => $b15f6fc481dd3df9$export$3325eba9424d3c32);

var $fc4bM = parcelRequire("fc4bM");
const $b15f6fc481dd3df9$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $fc4bM.useRef)(null);
    const resizeObserverRef = (0, $fc4bM.useRef)(null);
    const lastStableTimeRef = (0, $fc4bM.useRef)(0);
    const onStableCallbackRef = (0, $fc4bM.useRef)(null);
    const cleanup = (0, $fc4bM.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $fc4bM.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $fc4bM.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};

});


parcelRegister("loW2K", function(module, exports) {
$parcel$export(module.exports, "getWidthInfoPayload", () => $5d6200cbedc78ab4$export$208d2421b73f3f86);
$parcel$export(module.exports, "getHeightInfoPayload", () => $5d6200cbedc78ab4$export$34e5b28c67455a81);

var $3LeME = parcelRequire("3LeME");

var $1H8qk = parcelRequire("1H8qk");

var $8d4kB = parcelRequire("8d4kB");

var $ik3vI = parcelRequire("ik3vI");
const $5d6200cbedc78ab4$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $8d4kB.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $ik3vI.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $ik3vI.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $1H8qk.MODE).RENDERER
        },
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
    };
};
const $5d6200cbedc78ab4$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $8d4kB.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
    };
};

});
parcelRegister("1H8qk", function(module, exports) {
$parcel$export(module.exports, "PLATFORMS", () => $31630c61168faf03$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $31630c61168faf03$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $31630c61168faf03$export$57453495b81e2dde);
var $31630c61168faf03$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $31630c61168faf03$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $31630c61168faf03$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $31630c61168faf03$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("8d4kB", function(module, exports) {
$parcel$export(module.exports, "TABLE_ACTION", () => $776aadc7b6ff4eab$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $776aadc7b6ff4eab$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $776aadc7b6ff4eab$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $776aadc7b6ff4eab$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $776aadc7b6ff4eab$export$ba2dfc055a59d951);
var $776aadc7b6ff4eab$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    TABLE_ACTION["CHANGED_CELL_VERTICAL_ALIGNMENT"] = "changedVerticalAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $776aadc7b6ff4eab$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $776aadc7b6ff4eab$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $776aadc7b6ff4eab$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $776aadc7b6ff4eab$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $776aadc7b6ff4eab$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});


parcelRegister("bcvZJ", function(module, exports) {
$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $77daebd3d88b485a$export$cfc1361be0de4203);
/* eslint-disable jsdoc/require-jsdoc -- SSR inline script helpers */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9JwwP = parcelRequire("9JwwP");

var $aCsLi = parcelRequire("aCsLi");
function $77daebd3d88b485a$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: true
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $77daebd3d88b485a$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $77daebd3d88b485a$export$92859d13f30c883e(id, shouldSkipScript) {
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$77daebd3d88b485a$export$47813c4121c8b4b3};
(${$77daebd3d88b485a$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)});
})(window);
`;
}
const $77daebd3d88b485a$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $9JwwP.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $9JwwP.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $9JwwP.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $9JwwP.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $9JwwP.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $9JwwP.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $aCsLi.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $77daebd3d88b485a$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- inline script runs in browser document context
    document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>{
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth || isExtension) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $77daebd3d88b485a$export$2a0b3eeee3f2ea40 = (0, $9JwwP.breakoutConsts).calcLineLength((0, $9JwwP.breakoutConsts));

});

parcelRegister("6lOA7", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $eff9a3206304b410$export$3dee5e4542c672d9);

var $iNPVn = parcelRequire("iNPVn");

var $hqsUn = parcelRequire("hqsUn");
function $eff9a3206304b410$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $hqsUn.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $iNPVn.fileCardImageViewSelector))) return true;
    return false;
}

});
parcelRegister("iNPVn", function(module, exports) {
$parcel$export(module.exports, "fileCardImageViewSelector", () => $4025f8c0b9e3830d$export$7a6526d4be3b7eb3);
const $4025f8c0b9e3830d$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $4025f8c0b9e3830d$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

});

parcelRegister("hqsUn", function(module, exports) {
$parcel$export(module.exports, "mediaViewerPopupClass", () => $921787a1ac8b1a40$export$42c8d07e41ed1e74);
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $921787a1ac8b1a40$export$42c8d07e41ed1e74 = 'media-viewer-popup';

});


parcelRegister("kSttA", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $3468d589282819ed$export$8e2864079bc476bd);

var $014x6 = parcelRequire("014x6");
const $3468d589282819ed$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if (contentMode === 'compact') return 0, $014x6.akEditorFullPageDenseFontSize;
    return appearance && appearance !== 'comment' ? (0, $014x6.akEditorFullPageDefaultFontSize) : 14;
};

});

parcelRegister("79H3N", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $001f8a46f001be1b$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $001f8a46f001be1b$export$b1072f43c67b540c);
/* eslint-disable jsdoc/require-jsdoc -- thin portal context helpers */ 
var $fc4bM = parcelRequire("fc4bM");
const $001f8a46f001be1b$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(undefined);
function $001f8a46f001be1b$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $fc4bM.useContext)($001f8a46f001be1b$export$60d741e20e0aa309);
    return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}

});

parcelRegister("iHiHa", function(module, exports) {
$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $0c4c43d88eafa7cc$export$c94cfc0c675062a1);
const $0c4c43d88eafa7cc$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !((child === null || child === void 0 ? void 0 : child.type) === 'hardBreak' || (child === null || child === void 0 ? void 0 : child.type) === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("4Hr4F", function(module, exports) {
$parcel$export(module.exports, "RendererStyleContainer", () => $b4bf0c05737ca105$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $MCCgU = parcelRequire("MCCgU");

var $4rqGA = parcelRequire("4rqGA");

var $dqFZv = parcelRequire("dqFZv");

var $6nJfj = parcelRequire("6nJfj");

var $9KnDV = parcelRequire("9KnDV");

var $1r7H5 = parcelRequire("1r7H5");

var $8aFCM = parcelRequire("8aFCM");

var $t10OO = parcelRequire("t10OO");

var $khldo = parcelRequire("khldo");

var $8fPFa = parcelRequire("8fPFa");

var $1Gdi2 = parcelRequire("1Gdi2");

var $03LQP = parcelRequire("03LQP");

var $9RBkq = parcelRequire("9RBkq");

var $gOOOo = parcelRequire("gOOOo");

var $jd8X7 = parcelRequire("jd8X7");

var $iSJ2T = parcelRequire("iSJ2T");

var $81vYS = parcelRequire("81vYS");

var $9QPfA = parcelRequire("9QPfA");

var $014x6 = parcelRequire("014x6");

var $5av15 = parcelRequire("5av15");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $aGINe = parcelRequire("aGINe");

var $cT8sX = parcelRequire("cT8sX");

var $1jdFu = parcelRequire("1jdFu");

var $2xxrU = parcelRequire("2xxrU");

var $2Wk5p = parcelRequire("2Wk5p");

var $kSttA = parcelRequire("kSttA");

var $aCsLi = parcelRequire("aCsLi");
function $b4bf0c05737ca105$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b4bf0c05737ca105$var$wrappedMediaBreakoutPoint = 410;
const $b4bf0c05737ca105$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $b4bf0c05737ca105$var$tableShadowWidth = 32;
const $b4bf0c05737ca105$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $b4bf0c05737ca105$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME = 'remix-block-highlight';
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $b4bf0c05737ca105$var$tableRowHeight = 44;
const $b4bf0c05737ca105$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $dqFZv.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $b4bf0c05737ca105$var$baseFontStyle = /*#__PURE__*/ (0, $jctmk.css)({
    font: (0, $6nJfj.editorUGCTokensRefreshed)['editor.font.body']
});
const $b4bf0c05737ca105$var$fontSizeStyles = {
    name: "jdulnm",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--ak-renderer-editor-font-small-text);}"
};
const $b4bf0c05737ca105$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $b4bf0c05737ca105$var$baseStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $014x6.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT}`]: {
        [`> [${0, $2Wk5p.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE}][hidden='until-found']`]: {
            display: 'block',
            // `hidden='until-found'` maps to `content-visibility: hidden`, which skips the element's
            // contents but keeps its own box, sized by its own specified sizes. Everything below
            // needs `!important` because extension nodes are sized and spaced by declarations that
            // would otherwise win: an inline `height`/`min-height` reserving macro height (see
            // `react/nodes/extension.tsx`), and `!important` alignment margins from
            // `@atlaskit/native-embeds-common`. Without it the collapsed section keeps a visible gap.
            blockSize: '0 !important',
            minBlockSize: '0 !important',
            marginBlock: '0 !important',
            paddingBlock: '0 !important',
            borderBlockWidth: '0 !important'
        },
        // p, h3, and action items
        [`.${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9KnDV.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $b4bf0c05737ca105$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $jctmk.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transitionProperty: 'opacity, transform',
                    transitionDuration: `${"var(--ds-duration-medium, 0.2s)"}, ${"var(--ds-duration-medium, 0.2s)"}`,
                    transitionTimingFunction: `${"var(--ds-easing-out-practical, ease)"}, ${"var(--ds-easing-out-practical, ease)"}`,
                    transitionDelay: '0s, 0s'
                }
            },
            '&:hover': {
                [`.${0, $1jdFu.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $b4bf0c05737ca105$var$headingAnchorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $1jdFu.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $b4bf0c05737ca105$var$headingAnchorButtonFocusVisibleStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
        'button:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            borderRadius: "var(--ds-radius-small, 3px)"
        }
    }
});
const $b4bf0c05737ca105$var$akEditorBreakpointForSmallDevice = '1266px';
const $b4bf0c05737ca105$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $jctmk.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $014x6.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$b4bf0c05737ca105$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $b4bf0c05737ca105$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $jctmk.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$b4bf0c05737ca105$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $b4bf0c05737ca105$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $jctmk.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$b4bf0c05737ca105$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $014x6.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $b4bf0c05737ca105$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $jctmk.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $b4bf0c05737ca105$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $b4bf0c05737ca105$var$rendererFullPageStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $014x6.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $aCsLi.FullPagePadding)}px`
});
const $b4bf0c05737ca105$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $jctmk.css)({
    '--ak-renderer--full-page-gutter': `${(0, $aCsLi.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $014x6.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $014x6.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $014x6.akEditorGutterPaddingReduced)}px`
    }
});
const $b4bf0c05737ca105$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $014x6.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $b4bf0c05737ca105$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $014x6.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $b4bf0c05737ca105$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $014x6.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $b4bf0c05737ca105$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $014x6.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $b4bf0c05737ca105$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $b4bf0c05737ca105$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`#${$b4bf0c05737ca105$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $b4bf0c05737ca105$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $b4bf0c05737ca105$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $014x6.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $b4bf0c05737ca105$var$headingsSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $b4bf0c05737ca105$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $b4bf0c05737ca105$var$headingAnchorWrapperTargetSizeStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        verticalAlign: 'middle'
    },
    [`& .renderer-heading-wrapper > .${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle'
    }
});
const $b4bf0c05737ca105$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $b4bf0c05737ca105$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $b4bf0c05737ca105$var$ruleSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $014x6.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
const $b4bf0c05737ca105$var$ruleBreakoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER}:has(> .${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > hr)`]: {
        marginTop: 0,
        marginBottom: 0
    },
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER} > .${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > hr`]: {
        // preserve unwrapped divider spacing, including first and last dividers.
        marginTop: `${(0, $014x6.akEditorLineHeight)}em`,
        marginBottom: `${(0, $014x6.akEditorLineHeight)}em`
    }
});
// these masks need to be aligned with editor-core/styles/ruleWithAttrs.ts
const $b4bf0c05737ca105$var$dashedStrokeMask = 'linear-gradient(to right, black 0, black 4px, transparent 4px, transparent 10px)';
const $b4bf0c05737ca105$var$fadeStrokeMask = 'linear-gradient(to right, transparent 0%, black 27.4%, black 74%, transparent 100%)';
// dotted strokes
const $b4bf0c05737ca105$var$dottedStrokeMaskSmall = 'radial-gradient(circle at center, black 0.5px, transparent 0.6px)';
const $b4bf0c05737ca105$var$dottedStrokeMaskMedium = 'radial-gradient(circle at center, black 1px, transparent 1.1px)';
const $b4bf0c05737ca105$var$dottedStrokeMaskLarge = 'radial-gradient(circle at center, black 1.5px, transparent 1.6px)';
// sketch strokes
const $b4bf0c05737ca105$var$sketchStrokePath = 'M0.00161171 1.0107C6.6387 1 9.94061 5.16958 16.6371 5.16958C23.3336 5.16958 26.5761 1.00913 33.2726 1.0107C39.3797 1.01213 42.4198 4.22998 48.5219 4.47643C55.9487 4.77638 59.8075 0.780687 67.2368 1.0107C73.6051 1.20786 76.8081 4.42122 83.1792 4.47643C89.815 4.53393 93.1788 1.06378 99.8147 1.0107C106.716 0.95549 110.244 4.6564 117.143 4.47643C123.248 4.31717 126.289 1.21517 132.393 1.0107C139.555 0.770735 143.25 4.64894 150.414 4.47643C156.784 4.32307 159.986 1.06591 166.357 1.0107C172.993 0.953195 176.356 4.47655 182.992 4.47643C189.628 4.47632 192.992 1.01007 199.628 1.01007C206.264 1.01007 209.627 4.47632 216.263 4.47643C222.899 4.47655 226.263 1.0107 232.899 1.0107';
const $b4bf0c05737ca105$var$sketchStrokeMaskSmall = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 233 7'%3E%3Cpath fill='none' stroke='%23000' stroke-width='1' d='${$b4bf0c05737ca105$var$sketchStrokePath}'/%3E%3C/svg%3E")`;
const $b4bf0c05737ca105$var$sketchStrokeMaskMedium = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 233 7'%3E%3Cpath fill='none' stroke='%23000' stroke-width='2' d='${$b4bf0c05737ca105$var$sketchStrokePath}'/%3E%3C/svg%3E")`;
const $b4bf0c05737ca105$var$sketchStrokeMaskLarge = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 233 8'%3E%3Cpath fill='none' stroke='%23000' stroke-width='3' d='${$b4bf0c05737ca105$var$sketchStrokePath}'/%3E%3C/svg%3E")`;
const $b4bf0c05737ca105$var$ruleWithAttrsStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& hr[data-color]': {
        backgroundColor: 'var(--custom-palette-color)'
    },
    '& hr[data-style="dashed"]': {
        maskImage: $b4bf0c05737ca105$var$dashedStrokeMask,
        maskRepeat: 'repeat-x',
        maskSize: '10px 100%'
    },
    '& hr[data-style="dotted"]': {
        maskImage: $b4bf0c05737ca105$var$dottedStrokeMaskMedium,
        maskPosition: 'center',
        maskRepeat: 'repeat-x',
        maskSize: '6px 2px'
    },
    '& hr[data-style="sketch"]': {
        height: `calc(2px + ${"var(--ds-space-050, 4px)"} + ${"var(--ds-space-050, 4px)"})`,
        maskImage: $b4bf0c05737ca105$var$sketchStrokeMaskMedium,
        maskPosition: 'center',
        maskRepeat: 'repeat-x',
        maskSize: '233px 7px'
    },
    '& hr[data-style="fade"]': {
        maskImage: $b4bf0c05737ca105$var$fadeStrokeMask,
        maskRepeat: 'no-repeat',
        maskSize: '100% 100%'
    },
    '& hr[data-weight="1"]': {
        height: '1px'
    },
    '& hr[data-weight="3"]': {
        height: '3px'
    },
    '& hr[data-style="dotted"][data-weight="1"]': {
        maskImage: $b4bf0c05737ca105$var$dottedStrokeMaskSmall,
        maskSize: '6px 1px'
    },
    '& hr[data-style="dotted"][data-weight="3"]': {
        maskImage: $b4bf0c05737ca105$var$dottedStrokeMaskLarge,
        maskSize: '6px 3px'
    },
    // Sketch needs a mask per weight because CSS cannot change the SVG stroke width.
    '& hr[data-style="sketch"][data-weight="1"]': {
        height: `calc(1px + ${"var(--ds-space-050, 4px)"} + ${"var(--ds-space-050, 4px)"})`,
        maskImage: $b4bf0c05737ca105$var$sketchStrokeMaskSmall
    },
    '& hr[data-style="sketch"][data-weight="3"]': {
        height: `calc(3px + ${"var(--ds-space-050, 4px)"} + ${"var(--ds-space-050, 4px)"})`,
        maskImage: $b4bf0c05737ca105$var$sketchStrokeMaskLarge,
        maskSize: '233px 8px'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $b4bf0c05737ca105$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $jctmk.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $014x6.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $b4bf0c05737ca105$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $jctmk.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $014x6.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $b4bf0c05737ca105$var$listsSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    /* =============== INDENTATION SPACING ========= */ // Skips top-layer surfaces. See top-layer/notes/decisions/top-layer-unsafe-selectors.md
    '& ul:not(:where([popover], dialog, & :is([popover], dialog) *)), & ol:not(:where([popover], dialog, & :is([popover], dialog) *))': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $1Gdi2.listItemCounterPadding)}px)`
    },
    [`${0, $4rqGA.orderedListSelector}, ${0, $MCCgU.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $b4bf0c05737ca105$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 */ const $b4bf0c05737ca105$var$listItemHiddenMarkerStyles = {
    name: "j8szsq",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-list-local-id] > div[data-task-list-local-id]{margin-top:0;}div[data-task-local-id] + div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);}"
};
const $b4bf0c05737ca105$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $b4bf0c05737ca105$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $014x6.blockNodesVerticalMargin)
        }
    }
});
const $b4bf0c05737ca105$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $jctmk.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $b4bf0c05737ca105$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $b4bf0c05737ca105$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $b4bf0c05737ca105$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $b4bf0c05737ca105$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $aGINe.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $b4bf0c05737ca105$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $aGINe.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $b4bf0c05737ca105$var$migratedInlineBodiedFlowStyle = /*#__PURE__*/ (0, $jctmk.css)({
    [[
        `.${(0, $aGINe.RendererCssClassName).DOCUMENT} [data-migrated-inline] + [data-as-inline="on"]`,
        `.${(0, $aGINe.RendererCssClassName).DOCUMENT} [data-as-inline="on"]:has(+ [data-migrated-inline])`
    ].join(', ')]: {
        display: 'inline'
    }
});
const $b4bf0c05737ca105$var$forgeInlineBodiedSpacingStyle = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline]`]: {
        marginBottom: 0,
        verticalAlign: 'baseline',
        maxWidth: '100%'
    },
    [[
        `.${(0, $aGINe.RendererCssClassName).DOCUMENT} [data-forge-inline] + [data-as-inline="on"]`,
        `.${(0, $aGINe.RendererCssClassName).DOCUMENT} [data-as-inline="on"]:has(+ [data-forge-inline])`
    ].join(', ')]: {
        display: 'inline'
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline] *`]: {
        maxWidth: '100%'
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline] .${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        overflowX: 'auto'
    },
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION_AS_INLINE}[data-forge-inline] .${(0, $aGINe.RendererCssClassName).DOCUMENT} > p`]: {
        display: 'inline',
        margin: 0
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $b4bf0c05737ca105$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $b4bf0c05737ca105$var$shadowSharedStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $1r7H5.shadowClassNames).LEFT_SHADOW}::before, .${(0, $1r7H5.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $014x6.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}, .${(0, $1r7H5.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1r7H5.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9QPfA.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9QPfA.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $b4bf0c05737ca105$var$dateSharedStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $khldo.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $b4bf0c05737ca105$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $b4bf0c05737ca105$var$backgroundColorStyles = {
    name: "1rjaz80",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
// Don't show text highlight styling when there is a hyperlink.
// Conditionally applied when the highlight-on-links experiment is off.
const $b4bf0c05737ca105$var$highlightLinksUnsetStyles = {
    name: "1d6748d",
    styles: "a .fabric-background-color-mark{background-color:unset;}"
};
const $b4bf0c05737ca105$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $b4bf0c05737ca105$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $iSJ2T.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $014x6.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $iSJ2T.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $iSJ2T.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $014x6.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $iSJ2T.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $014x6.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $014x6.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $014x6.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $b4bf0c05737ca105$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $b4bf0c05737ca105$var$smartCardStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $9RBkq.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $014x6.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $b4bf0c05737ca105$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $9RBkq.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $9RBkq.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $b4bf0c05737ca105$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $9RBkq.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $9RBkq.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $b4bf0c05737ca105$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $9RBkq.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $9RBkq.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $b4bf0c05737ca105$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform.
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $b4bf0c05737ca105$var$centerWrapperStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
// Reset only Expands with no preceding content sibling. Streaming SSR style/script siblings
// are ignored so moving them to the head on the client does not change the top margin.
const $b4bf0c05737ca105$var$expandSsrMarginStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > [data-node-type='expand']:not(:not(style, script) ~ *)`]: {
        marginTop: 0
    }
});
const $b4bf0c05737ca105$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $jctmk.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $03LQP.richMediaClassName}.rich-media-wrapped + .${0, $03LQP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $03LQP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $03LQP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $03LQP.richMediaClassName}.image-align-start,
		.${0, $03LQP.richMediaClassName}.image-center,
		.${0, $03LQP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $aGINe.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $aGINe.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $014x6.blockNodesVerticalMargin)}`
        },
        [`.${(0, $aGINe.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $aGINe.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* Embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $aGINe.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $9QPfA.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $b4bf0c05737ca105$var$hideExtensionStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).EXTENSION}:has([data-extension-key='hide'])`]: {
        marginTop: 0
    }
});
const $b4bf0c05737ca105$var$baseOtherStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $03LQP.richMediaClassName}.rich-media-wrapped + .${0, $03LQP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $03LQP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $03LQP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $03LQP.richMediaClassName}.image-align-start,
		.${0, $03LQP.richMediaClassName}.image-center,
		.${0, $03LQP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $aGINe.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $aGINe.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $aGINe.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $014x6.blockNodesVerticalMargin)}`
        },
        [`.${(0, $aGINe.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $aGINe.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* Embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $aGINe.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $aGINe.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $9QPfA.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $b4bf0c05737ca105$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $jctmk.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $1jdFu.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $b4bf0c05737ca105$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $1jdFu.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $b4bf0c05737ca105$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $03LQP.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $03LQP.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $b4bf0c05737ca105$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $03LQP.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $03LQP.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $03LQP.richMediaClassName}.image-wrap-right + .${0, $03LQP.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $03LQP.richMediaClassName}.image-wrap-left + .${0, $03LQP.richMediaClassName}.image-wrap-right, .${0, $03LQP.richMediaClassName}.image-wrap-right + .${0, $03LQP.richMediaClassName}.image-wrap-left, .${0, $03LQP.richMediaClassName}.image-wrap-left + .${0, $03LQP.richMediaClassName}.image-wrap-left, .${0, $03LQP.richMediaClassName}.image-wrap-right + .${0, $03LQP.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$b4bf0c05737ca105$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $b4bf0c05737ca105$var$tableSharedStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    'td[colorname="subtle lime" i], th[colorname="subtle lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtlest, #EFFFD6)"} !important`
    },
    'td[colorname="subtle orange" i], th[colorname="subtle orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtlest, #FFF5DB)"} !important`
    },
    'td[colorname="subtle magenta" i], th[colorname="subtle magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest, #FFECF8)"} !important`
    },
    'td[colorname="lime" i], th[colorname="lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtler, #D3F1A7)"} !important`
    },
    'td[colorname="orange" i], th[colorname="orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtler, #FCE4A6)"} !important`
    },
    'td[colorname="magenta" i], th[colorname="magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`
    },
    'td[colorname="bold gray" i], th[colorname="bold gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"} !important`
    },
    'td[colorname="bold blue" i], th[colorname="bold blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"} !important`
    },
    'td[colorname="bold teal" i], th[colorname="bold teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"} !important`
    },
    'td[colorname="bold green" i], th[colorname="bold green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler-hovered, #97EDC9)"} !important`
    },
    'td[colorname="bold lime" i], th[colorname="bold lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"} !important`
    },
    'td[colorname="bold yellow" i], th[colorname="bold yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"} !important`
    },
    'td[colorname="bold orange" i], th[colorname="bold orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtler-hovered, #FBD779)"} !important`
    },
    'td[colorname="bold red" i], th[colorname="bold red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"} !important`
    },
    'td[colorname="bold magenta" i], th[colorname="bold magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"} !important`
    },
    'td[colorname="bold purple" i], th[colorname="bold purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"} !important`
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $014x6.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $jd8X7.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '&[data-initial-width-mode="content"]': {
            tableLayout: 'auto',
            width: 'auto'
        },
        // Skips top-layer surfaces. See top-layer/notes/decisions/top-layer-unsafe-selectors.md
        '& *:not(:where([popover], dialog, & :is([popover], dialog) *))': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $014x6.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $b4bf0c05737ca105$var$roundedTableRemixBlockHighlightStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.${$b4bf0c05737ca105$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.${$b4bf0c05737ca105$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.${$b4bf0c05737ca105$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderColor: "var(--ds-border-selected, #1868DB)"
        }
    }
});
const $b4bf0c05737ca105$var$roundedTableOuterBorderOverlayStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderColor: 'transparent',
        position: 'relative',
        '&::after': {
            content: "''",
            position: 'absolute',
            inset: '-0.5px',
            border: `${(0, $jd8X7.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRadius: "var(--ds-radius-xlarge, 12px)",
            pointerEvents: 'none',
            zIndex: 1
        },
        '> tbody > tr > th[data-reaches-top], > tbody > tr > td[data-reaches-top]': {
            borderTopColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-bottom], > tbody > tr > td[data-reaches-bottom]': {
            borderBottomColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderLeftColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderRightColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
            borderBottomLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
            borderBottomRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        }
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`]: {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    // Keep the cloned sticky header rounded at the top while preserving a square bottom edge.
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        '> tbody > tr': {
            // The sticky table clone sets a row background locally; force it off so
            // the rounded header cells, not a square row box, own the visible fill.
            background: 'transparent !important'
        },
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left][data-reaches-bottom], > tbody > tr > td[data-reaches-left][data-reaches-bottom]': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right][data-reaches-bottom], > tbody > tr > td[data-reaches-right][data-reaches-bottom]': {
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left]::after, > tbody > tr > td[data-reaches-left]::after': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right]::after, > tbody > tr > td[data-reaches-right]::after': {
            borderBottomRightRadius: 0
        }
    }
});
const $b4bf0c05737ca105$var$roundedTableOuterBorderOverlayOverflowFixStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            inset: 0
        }
    }
});
const $b4bf0c05737ca105$var$tableContentModeScopedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}:has(> table[data-initial-width-mode="content"]),
	.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}:has(> .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table[data-initial-width-mode="content"]),
	.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}:has(> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table[data-initial-width-mode="content"])`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'max-content !important',
        maxWidth: 'var(--renderer-table-max-width)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > colgroup > col`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'unset !important'
    }
});
const $b4bf0c05737ca105$var$tableContentModeExtensionContainmentStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Content-mode tables need extension content to participate in intrinsic width calculation.
    // Keep containment for extensions in all other table modes so nested renderers stay constrained.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] .${(0, $aGINe.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        containerType: 'normal'
    }
});
const $b4bf0c05737ca105$var$tableContentModeNestedTableStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Nested tables may sit inside expands, extensions, or other blocks within the parent cell.
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $aGINe.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $aGINe.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        width: 'max-content !important',
        maxWidth: '100%'
    }
});
const $b4bf0c05737ca105$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $jd8X7.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
/**
 * Matches an element with no rendered block before it. Injected `<style>`, `<link>` and
 * `<template>` siblings (SSR) are ignored, as is the heading anchor `span`.
 */ const $b4bf0c05737ca105$var$NO_PRECEDING_BLOCK = ':not(:not(style, link, template, span) ~ *)';
const $b4bf0c05737ca105$var$HEADING_WRAPPER_SELECTOR = `:is(.fabric-editor-block-mark, .renderer-heading-wrapper, .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN})`;
/** A heading that starts a cell, directly or inside up to two wrappers (alignment mark, heading wrapper, sortable header). */ const $b4bf0c05737ca105$var$headingStartingCellSelector = (heading)=>[
        `> ${heading}${$b4bf0c05737ca105$var$NO_PRECEDING_BLOCK}`,
        `> ${$b4bf0c05737ca105$var$HEADING_WRAPPER_SELECTOR}${$b4bf0c05737ca105$var$NO_PRECEDING_BLOCK} > ${heading}`,
        `> ${$b4bf0c05737ca105$var$HEADING_WRAPPER_SELECTOR}${$b4bf0c05737ca105$var$NO_PRECEDING_BLOCK} > ${$b4bf0c05737ca105$var$HEADING_WRAPPER_SELECTOR}${$b4bf0c05737ca105$var$NO_PRECEDING_BLOCK} > ${heading}`
    ].join(', ');
/**
 * H3-H6 line boxes are shorter than a body text line (1.714em), so in a top-aligned cell
 * their text sits higher than paragraph text in the same row. Padding a heading that starts
 * a cell by half the difference gives its first line a body-sized line box.
 */ const $b4bf0c05737ca105$var$tableHeadingCellAlignmentStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            [$b4bf0c05737ca105$var$headingStartingCellSelector('h3')]: {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingBlock: '0.125em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            [$b4bf0c05737ca105$var$headingStartingCellSelector('h4')]: {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingBlock: '0.28571em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            [$b4bf0c05737ca105$var$headingStartingCellSelector('h5')]: {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingBlock: '0.33333em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            [$b4bf0c05737ca105$var$headingStartingCellSelector('h6')]: {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingBlock: '0.36364em'
            }
        }
    }
});
const $b4bf0c05737ca105$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $b4bf0c05737ca105$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $b4bf0c05737ca105$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $b4bf0c05737ca105$var$rendererTableStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $1r7H5.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $jd8X7.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $jd8X7.tableMarginTop)}px)`,
            zIndex: `${(0, $014x6.akEditorStickyHeaderZIndex)}`,
            width: `${$b4bf0c05737ca105$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $9QPfA.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $9QPfA.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $jd8X7.tableMarginTop)}px)`
        }
    }
});
const $b4bf0c05737ca105$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$b4bf0c05737ca105$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $b4bf0c05737ca105$var$stickyScrollbarOverflowShadowFixStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`&.${(0, $1r7H5.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $1r7H5.shadowClassNames).LEFT_SHADOW}::before`]: {
            // The sticky scrollbar retains this space in the table container's layout even while hidden.
            bottom: "var(--ds-space-250, 20px)",
            height: 'auto'
        }
    }
});
const $b4bf0c05737ca105$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $b4bf0c05737ca105$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $jd8X7.tableCellPadding)}px`,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// Sortable header cells render content inside an extra div, so mirror the th alignment there.
const $b4bf0c05737ca105$var$rendererTableSortableColumnValignStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`th[data-valign='middle'].${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            [`th[data-valign='bottom'].${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end'
            }
        }
    }
});
const $b4bf0c05737ca105$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $aGINe.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $014x6.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $aGINe.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $b4bf0c05737ca105$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $b4bf0c05737ca105$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $aGINe.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $1jdFu.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $b4bf0c05737ca105$var$stickyHeaderStyles = /*#__PURE__*/ (0, $jctmk.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $014x6.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $014x6.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $b4bf0c05737ca105$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $014x6.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT}
		> .${(0, $cT8sX.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $014x6.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $014x6.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $014x6.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $014x6.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $014x6.blockNodesVerticalMargin)
        }
    }
});
// Match the first content sibling throughout streaming SSR and hydration. Emotion moves
// style elements to the head, which must not change code block or media group spacing.
// Keep these selectors less specific than the top-level lightweight code block override.
const $b4bf0c05737ca105$var$blockSsrMarginStyles = {
    name: "1yr3pal",
    styles: "& .MediaGroup:not(:not(style, script) ~ *), & .code-block:not(:not(style, script) ~ *){margin-top:0;}& [data-layout-section] .MediaGroup:not(:not(style, script) ~ *), & [data-layout-section] .code-block:not(:not(style, script) ~ *), & li > .code-block:not(:not(style, script) ~ *){margin-top:0;}"
};
// Layout columns start with an empty margin-reset element. Ignore only streamed siblings
// between that element and the first code block/media group, preserving later block spacing.
const $b4bf0c05737ca105$var$layoutBlockSsrMarginStyles = {
    name: "iiym4g",
    styles: "& [data-layout-column-start] ~ .code-block:not([data-layout-column-start] ~ :not(style, script) ~ *), & [data-layout-column-start] ~ .MediaGroup:not([data-layout-column-start] ~ :not(style, script) ~ *){margin-top:0;}"
};
const $b4bf0c05737ca105$var$codeBlockInListSsrMarginSafariFixStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $9RBkq.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '> .code-block:not(:not(style, script) ~ *)': {
            marginTop: `-${(0, $014x6.akEditorLineHeight)}em !important`
        }
    }
});
const $b4bf0c05737ca105$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $b4bf0c05737ca105$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $b4bf0c05737ca105$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $9RBkq.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $014x6.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $014x6.akEditorLineHeight)}em !important`
        }
    }
});
const $b4bf0c05737ca105$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $014x6.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $b4bf0c05737ca105$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $b4bf0c05737ca105$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$b4bf0c05737ca105$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $b4bf0c05737ca105$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $jctmk.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $b4bf0c05737ca105$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $b4bf0c05737ca105$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $014x6.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $b4bf0c05737ca105$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $014x6.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $b4bf0c05737ca105$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $5av15.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $5av15.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $5av15.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $5av15.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $5av15.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.denseEmojiHeightH1)}px`,
        width: `${(0, $5av15.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.denseEmojiHeightH2)}px`,
        width: `${(0, $5av15.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.denseEmojiHeightH3)}px`,
        width: `${(0, $5av15.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.denseEmojiHeightH4)}px`,
        width: `${(0, $5av15.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.defaultDenseEmojiHeight)}px`,
        width: `${(0, $5av15.defaultDenseEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $5av15.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $5av15.defaultInlineEmojiHeight)}px`,
        height: `${(0, $5av15.defaultInlineEmojiHeight)}px`,
        width: `${(0, $5av15.defaultInlineEmojiHeight)}px`
    }
});
const $b4bf0c05737ca105$var$scaledEmojiStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $5av15.defaultEmojiHeight)}px`,
        minHeight: `${(0, $5av15.defaultEmojiHeight)}px`,
        minWidth: `${(0, $5av15.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $5av15.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $5av15.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.scaledEmojiHeightH1)}px`,
        width: `${(0, $5av15.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.scaledEmojiHeightH2)}px`,
        width: `${(0, $5av15.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.scaledEmojiHeightH3)}px`,
        width: `${(0, $5av15.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.scaledEmojiHeightH4)}px`,
        width: `${(0, $5av15.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $5av15.defaultEmojiHeight)}px`,
        width: `${(0, $5av15.defaultEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $5av15.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $5av15.defaultInlineEmojiHeight)}px`,
        height: `${(0, $5av15.defaultInlineEmojiHeight)}px`,
        width: `${(0, $5av15.defaultInlineEmojiHeight)}px`
    }
});
const $b4bf0c05737ca105$var$denseStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $8fPFa.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $5av15.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $014x6.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $5av15.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $014x6.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $5av15.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $014x6.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $aGINe.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $b4bf0c05737ca105$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $b4bf0c05737ca105$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $b4bf0c05737ca105$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $b4bf0c05737ca105$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $b4bf0c05737ca105$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $b4bf0c05737ca105$var$syncBlockRendererStyles = {
    name: "g5u32w",
    styles: "margin:0;max-width:none;padding:0"
};
/**
 * Fake left/right table borders.
 *
 * Adapted from the editor-plugin-table behavior (see editor-common's
 * `tableSharedStyle()` in `editor-common/src/styles/shared/table.ts`). The
 * visible vertical edges of the table are painted by these absolutely-positioned
 * 1px divs that live inside the (non-scrolling) TABLE_CONTAINER, while the real
 * <table> left/right borders are made `transparent`. Because the divs are not
 * inside the horizontally scrolling TABLE_NODE_WRAPPER, they remain visible
 * regardless of scroll position — fixing the missing right border when an
 * overflowing table inside a reference synced block is scrolled all the way to
 * the left.
 *
 * The `height` formula adjusted for table in renderer
 */ const $b4bf0c05737ca105$var$tableFakeBorderStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        // Mirror the editor's tableSharedStyle() rule from
        // `editor-common/src/styles/shared/table.ts` (lines 142-150). The fake
        // borders are absolutely positioned inside pm-table-container;
        // their height is adjusted for renderer to `100% - space.300 - space.250` so the border runs from
        // the top of the table to the bottom of the container
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'block',
            width: '1px',
            height: `calc(100% - ${"var(--ds-space-300, 24px)"} - ${"var(--ds-space-250, 20px)"})`,
            background: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
            position: 'absolute',
            top: "var(--ds-space-300, 24px)"
        },
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER}`]: {
            right: 0
        },
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER},
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true']`]: {
            left: 0
        }
    },
    // Make the real left/right table borders transparent so the fake border
    // divs above are the only painted vertical edges. Top/bottom borders on the
    // <table> element remain visible.
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $8aFCM.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent'
    }
});
const $b4bf0c05737ca105$var$roundedTableFakeBorderOverlayStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'none'
        }
    }
});
const $b4bf0c05737ca105$var$syncBlockStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $gOOOo.SyncBlockSharedCssClassName).renderer}, .${(0, $gOOOo.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $gOOOo.SyncBlockSharedCssClassName).error}, .${(0, $gOOOo.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $gOOOo.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $gOOOo.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $gOOOo.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    },
    [`.${(0, $gOOOo.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $b4bf0c05737ca105$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId, isInsideSyncBlock: isInsideSyncBlock } = props;
    const isAdvancedLayoutsOn = (0, $kaRof.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const isStickyScrollbarOn = (0, $2xxrU.isStickyScrollbarEnabled)(appearance);
    const baseFontSize = (0, $kSttA.getBaseFontSize)(appearance, contentMode);
    const browser = (0, $dqFZv.getBrowserInfo)();
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.heading.h1']}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.heading.h2']}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.heading.h3']}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.heading.h4']}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.heading.h5']}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.heading.h6']}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $6nJfj.editorUGCTokensRefreshed)['editor.font.body']}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            '--ak-renderer-editor-font-small-text': (0, $6nJfj.editorUGCTokensRefreshed)['editor.font.body.small']
        },
        css: [
            (0, $aEmSo.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $b4bf0c05737ca105$var$baseFontStyle : $b4bf0c05737ca105$var$originalBaseFontLineHeight,
            $b4bf0c05737ca105$var$baseStyles,
            $b4bf0c05737ca105$var$fontSizeStyles,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$headingAnchorStyles : $b4bf0c05737ca105$var$headingAnchorStylesDuplicateAnchor,
            $b4bf0c05737ca105$var$headingAnchorButtonFocusVisibleStyles,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$hideHeadingCopyLinkWrapperStyles : $b4bf0c05737ca105$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $b4bf0c05737ca105$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $b4bf0c05737ca105$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? $b4bf0c05737ca105$var$rendererFullWidthStyles : $b4bf0c05737ca105$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max') && !(0, $2xxrU.isTableResizingEnabled)(appearance) && $b4bf0c05737ca105$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? $b4bf0c05737ca105$var$rendererMaxWidthStyles : $b4bf0c05737ca105$var$oldRendererMaxWidthStyles),
            $b4bf0c05737ca105$var$rovoTelepointerStyles,
            $b4bf0c05737ca105$var$whitespaceSharedStyles,
            $b4bf0c05737ca105$var$blockquoteSharedStyles,
            $b4bf0c05737ca105$var$headingsSharedStyles,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $b4bf0c05737ca105$var$headingWrapperInlineFlowStyles,
            (0, $bcN2K.isExperimentEnabled)('platform_editor_heading_link_target_size') && $b4bf0c05737ca105$var$headingAnchorWrapperTargetSizeStyles,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$headingWithAlignmentStyles : $b4bf0c05737ca105$var$headingWithAlignmentStylesDuplicateAnchor,
            $b4bf0c05737ca105$var$ruleSharedStyles,
            (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_dividers_attributes') && $b4bf0c05737ca105$var$ruleWithAttrsStyles,
            contentMode === 'compact' && $b4bf0c05737ca105$var$extensionStyle,
            contentMode === 'compact' ? $b4bf0c05737ca105$var$paragraphStylesUGCScaledMargin : $b4bf0c05737ca105$var$paragraphSharedStylesWithEditorUGC,
            $b4bf0c05737ca105$var$listsSharedStyles,
            browser.gecko && $b4bf0c05737ca105$var$listsSharedStylesForGekko,
            $b4bf0c05737ca105$var$listItemHiddenMarkerStyles,
            $b4bf0c05737ca105$var$indentationSharedStyles,
            $b4bf0c05737ca105$var$indentationSharedStylesWithMarginFix,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$blockMarksSharedStyles : $b4bf0c05737ca105$var$blockMarksSharedStylesDuplicateAnchor,
            $b4bf0c05737ca105$var$codeMarkSharedStyles,
            $b4bf0c05737ca105$var$shadowSharedStyle,
            $b4bf0c05737ca105$var$dateSharedStyle,
            $b4bf0c05737ca105$var$textColorStyles,
            $b4bf0c05737ca105$var$backgroundColorStyles,
            !(0, $aEmSo.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $b4bf0c05737ca105$var$highlightLinksUnsetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $b4bf0c05737ca105$export$a365082c2a191514,
            $b4bf0c05737ca105$var$tasksAndDecisionsStyles,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $b4bf0c05737ca105$var$headingPanelStyles,
            $b4bf0c05737ca105$var$smartCardStyles,
            $b4bf0c05737ca105$var$smartCardStylesAvatarFix,
            $b4bf0c05737ca105$var$headerSmartCardStyles,
            $b4bf0c05737ca105$var$smartCardStylesAvatarMarginFix,
            $b4bf0c05737ca105$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') && $b4bf0c05737ca105$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') && $b4bf0c05737ca105$var$rendererAnnotationStylesCommentHeightFix,
            (0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$baseOtherStyles : $b4bf0c05737ca105$var$baseOtherStylesDuplicateAnchor,
            $b4bf0c05737ca105$var$expandSsrMarginStyles,
            // this should be placed after baseOtherStyles
            (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_important_in_render_ext') ? $b4bf0c05737ca105$var$extensionAsInlineStyle : $b4bf0c05737ca105$var$oldExtensionAsInlineStyle,
            [
                $b4bf0c05737ca105$var$migratedInlineBodiedFlowStyle,
                $b4bf0c05737ca105$var$forgeInlineBodiedSpacingStyle
            ],
            $b4bf0c05737ca105$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$alignedHeadingAnchorStyle : $b4bf0c05737ca105$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $b4bf0c05737ca105$var$mediaSingleSharedStyle,
            $b4bf0c05737ca105$var$firstWrappedMediaStyles,
            $b4bf0c05737ca105$var$tableSharedStyle,
            (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $b4bf0c05737ca105$var$roundedTableOuterBorderOverlayStyles,
            (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_border_overflow_fix') && $b4bf0c05737ca105$var$roundedTableOuterBorderOverlayOverflowFixStyles,
            (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $b4bf0c05737ca105$var$roundedTableRemixBlockHighlightStyles,
            $b4bf0c05737ca105$var$tableContentModeScopedStyles,
            $b4bf0c05737ca105$var$tableContentModeExtensionContainmentStyles,
            $b4bf0c05737ca105$var$tableContentModeNestedTableStyles,
            $b4bf0c05737ca105$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $dRkX9.fg)('platform_editor_table_heading_cell_alignment') && $b4bf0c05737ca105$var$tableHeadingCellAlignmentStyles,
            (0, $dRkX9.fg)('platform_editor_bordered_panel_nested_in_table') && $b4bf0c05737ca105$var$tableRendererNestedPanelStyles,
            $b4bf0c05737ca105$var$isBackgroundClipBrowserFixNeeded() && $b4bf0c05737ca105$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            $b4bf0c05737ca105$var$firstNodeWithNotMarginTopWithNestedDnD,
            $b4bf0c05737ca105$var$rendererTableStyles,
            isStickyScrollbarOn && $b4bf0c05737ca105$var$stickyScrollbarStyles,
            isStickyScrollbarOn && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') && $b4bf0c05737ca105$var$stickyScrollbarOverflowShadowFixStyles,
            $b4bf0c05737ca105$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $b4bf0c05737ca105$var$rendererTableSortableColumnStyles,
            allowColumnSorting && (0, $3NBIB.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) && $b4bf0c05737ca105$var$rendererTableSortableColumnValignStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $aEmSo.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $b4bf0c05737ca105$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $b4bf0c05737ca105$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $b4bf0c05737ca105$var$rendererTableColumnStyles,
            $b4bf0c05737ca105$var$stickyHeaderStyles,
            $b4bf0c05737ca105$var$codeBlockAndLayoutStyles,
            $b4bf0c05737ca105$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $b4bf0c05737ca105$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $b4bf0c05737ca105$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $b4bf0c05737ca105$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $b4bf0c05737ca105$var$gridRenderForCodeBlockStyles,
            browser.safari && $b4bf0c05737ca105$var$codeBlockInListSafariFixStyles,
            $b4bf0c05737ca105$var$blockSsrMarginStyles,
            $b4bf0c05737ca105$var$layoutBlockSsrMarginStyles,
            browser.safari && $b4bf0c05737ca105$var$codeBlockInListSsrMarginSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $b4bf0c05737ca105$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $b4bf0c05737ca105$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max') && $b4bf0c05737ca105$var$responsiveBreakoutWidthFullWidth,
            (0, $aEmSo.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? contentMode === 'compact' ? $b4bf0c05737ca105$var$scaledDenseEmojiStyles : $b4bf0c05737ca105$var$scaledEmojiStyles : contentMode === 'compact' ? $b4bf0c05737ca105$var$denseStyles : undefined,
            $b4bf0c05737ca105$var$syncBlockStyles,
            $b4bf0c05737ca105$var$centerWrapperStyles,
            (0, $dRkX9.fg)('platform_editor_breakout_spacing_in_renderer') && $b4bf0c05737ca105$var$ruleBreakoutStyles,
            isInsideSyncBlock ? $b4bf0c05737ca105$var$syncBlockRendererStyles : null,
            isInsideSyncBlock && $b4bf0c05737ca105$var$tableFakeBorderStyles,
            isInsideSyncBlock && (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $b4bf0c05737ca105$var$roundedTableFakeBorderOverlayStyles : null,
            $b4bf0c05737ca105$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};

});
parcelRegister("6nJfj", function(module, exports) {
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $2de1470eb2b2d136$export$63adc0ebe3278d31);
const $2de1470eb2b2d136$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});

parcelRegister("9KnDV", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $ff4c4d37c794c900$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $ff4c4d37c794c900$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $ff4c4d37c794c900$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $ff4c4d37c794c900$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $ff4c4d37c794c900$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $ff4c4d37c794c900$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $ff4c4d37c794c900$export$4d0a7f76ad443516);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $ayBhk = parcelRequire("ayBhk");
const $ff4c4d37c794c900$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $ff4c4d37c794c900$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $ff4c4d37c794c900$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $ff4c4d37c794c900$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $ff4c4d37c794c900$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $jctmk.css)(">.mediaInlineView-content-wrap>.", $ff4c4d37c794c900$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $ff4c4d37c794c900$export$dd2e16f83ae6aa78, ",>.", $ff4c4d37c794c900$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $ff4c4d37c794c900$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $ff4c4d37c794c900$export$dee15762144889b7 = /*#__PURE__*/ (0, $jctmk.css)(".", $ff4c4d37c794c900$export$dd2e16f83ae6aa78, "{height:", (0, $ayBhk.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $ff4c4d37c794c900$var$inlineImageHeight((0, $ayBhk.referenceHeights)['h1'], -3), ";}h2{", $ff4c4d37c794c900$var$inlineImageHeight((0, $ayBhk.referenceHeights)['h2'], -3), ";}h3{", $ff4c4d37c794c900$var$inlineImageHeight((0, $ayBhk.referenceHeights)['h3'], -2), ";}h4{", $ff4c4d37c794c900$var$inlineImageHeight((0, $ayBhk.referenceHeights)['h4'], -2), ";}h5{", $ff4c4d37c794c900$var$inlineImageHeight((0, $ayBhk.referenceHeights)['h5'], -2), ";}h6{", $ff4c4d37c794c900$var$inlineImageHeight((0, $ayBhk.referenceHeights)['h6'], -2), ";}");
const $ff4c4d37c794c900$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$ff4c4d37c794c900$export$7ab34e219ce6eef}, ${(0, $ayBhk.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $ff4c4d37c794c900$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $jctmk.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $ff4c4d37c794c900$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $jctmk.css)({
    borderColor: `var(${$ff4c4d37c794c900$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$ff4c4d37c794c900$export$263a8a844c370a89}, ${(0, $ayBhk.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$ff4c4d37c794c900$export$263a8a844c370a89}, ${(0, $ayBhk.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("ayBhk", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $e6d68ed20ea8b9a0$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $e6d68ed20ea8b9a0$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $e6d68ed20ea8b9a0$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $e6d68ed20ea8b9a0$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $e6d68ed20ea8b9a0$export$c1317a9224e4d798);
const $e6d68ed20ea8b9a0$export$d722b7527b1834a8 = 250;
const $e6d68ed20ea8b9a0$export$da894f7669b4e67c = 200;
const $e6d68ed20ea8b9a0$export$286cf28b87ad4b4f = $e6d68ed20ea8b9a0$export$d722b7527b1834a8 / $e6d68ed20ea8b9a0$export$da894f7669b4e67c;
const $e6d68ed20ea8b9a0$export$64fe09732fb8680 = 0;
const $e6d68ed20ea8b9a0$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("khldo", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $4d179f9a4761dc87$export$99cdf122d0bb9f95);
const $4d179f9a4761dc87$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("8fPFa", function(module, exports) {
$parcel$export(module.exports, "EmojiSharedCssClassName", () => $d355bcea988b0a9d$export$ee47248f9a998789);

var $coQxr = parcelRequire("coQxr");
const $d355bcea988b0a9d$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $coQxr.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $coQxr.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $coQxr.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $coQxr.placeholder)
};

});
parcelRegister("coQxr", function(module, exports) {
$parcel$export(module.exports, "commonSelectedStyles", () => $5179bdfdc60abc50$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $5179bdfdc60abc50$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $5179bdfdc60abc50$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $5179bdfdc60abc50$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $5179bdfdc60abc50$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $5179bdfdc60abc50$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $5179bdfdc60abc50$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $5179bdfdc60abc50$export$22b19c311e9caa4);
$parcel$export(module.exports, "placeholder", () => $5179bdfdc60abc50$export$c7187bbd1a7a9244);
const $5179bdfdc60abc50$export$8633a0edef8e95dd = 'emoji-common-selected';
const $5179bdfdc60abc50$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $5179bdfdc60abc50$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $5179bdfdc60abc50$export$b06c4aab1d012063 = 'emoji-common-node';
const $5179bdfdc60abc50$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $5179bdfdc60abc50$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $5179bdfdc60abc50$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $5179bdfdc60abc50$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $5179bdfdc60abc50$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $5179bdfdc60abc50$export$b0fe756d87022806 = 'emoji-picker-add-emoji';

});


parcelRegister("03LQP", function(module, exports) {
$parcel$export(module.exports, "richMediaClassName", () => $d77d8d5cd6a4b37b$export$cfe6da7d522d87bb);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");
const $d77d8d5cd6a4b37b$export$cfe6da7d522d87bb = 'rich-media-item';
const $d77d8d5cd6a4b37b$var$wrappedMediaBreakoutPoint = 410;
const $d77d8d5cd6a4b37b$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right, .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left, .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left, .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$d77d8d5cd6a4b37b$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $d77d8d5cd6a4b37b$export$b51dea84d928a378 = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $014x6.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right, .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left, .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-left, .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right + .${$d77d8d5cd6a4b37b$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$d77d8d5cd6a4b37b$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("9RBkq", function(module, exports) {
$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $f9e3c939c659a5b8$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $f9e3c939c659a5b8$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $f9e3c939c659a5b8$export$863ae87a9d233606);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $f9e3c939c659a5b8$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $f9e3c939c659a5b8$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $f9e3c939c659a5b8$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';

});

parcelRegister("gOOOo", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSharedCssClassName", () => $24f165f112b24ca1$export$84840734cffb342f);
$parcel$export(module.exports, "SyncBlockRendererDataAttributeName", () => $24f165f112b24ca1$export$8c57d8325d08218b);
$parcel$export(module.exports, "BodiedSyncBlockSharedCssClassName", () => $24f165f112b24ca1$export$628f41eb22ec9a2);
$parcel$export(module.exports, "SyncBlockLabelSharedCssClassName", () => $24f165f112b24ca1$export$f75b6075afbd73af);
$parcel$export(module.exports, "SyncBlockStateCssClassName", () => $24f165f112b24ca1$export$9b10dd4c500e3ce8);
const $24f165f112b24ca1$var$prefix = 'ak-editor-sync-block';
const $24f165f112b24ca1$export$84840734cffb342f = {
    prefix: $24f165f112b24ca1$var$prefix,
    renderer: `${$24f165f112b24ca1$var$prefix}__renderer`,
    error: `${$24f165f112b24ca1$var$prefix}__error_state`,
    loading: `${$24f165f112b24ca1$var$prefix}__loading_state`
};
const $24f165f112b24ca1$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $24f165f112b24ca1$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $24f165f112b24ca1$export$628f41eb22ec9a2 = {
    prefix: $24f165f112b24ca1$var$bodiedPrefix,
    renderer: `${$24f165f112b24ca1$var$bodiedPrefix}__renderer`,
    content: `${$24f165f112b24ca1$var$bodiedPrefix}__content`,
    selectionInside: `${$24f165f112b24ca1$var$bodiedPrefix}__selection_inside`,
    // Applied by the node view when the block holds nothing but a single empty paragraph.
    // Emptiness is derived from the ProseMirror document rather than the rendered DOM, because
    // decorations (for example the selection marker's cursor widget) and ProseMirror's own
    // separator/trailing-break hack nodes are injected as children of that paragraph and make
    // DOM-shape heuristics unreliable. See EDITOR-8327.
    empty: `${$24f165f112b24ca1$var$bodiedPrefix}__empty`
};
// Constant labelClassName value here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $24f165f112b24ca1$var$labelClassName = 'ak-editor-sync-block__label';
const $24f165f112b24ca1$export$f75b6075afbd73af = {
    labelClassName: $24f165f112b24ca1$var$labelClassName
};
const $24f165f112b24ca1$export$7e44804769d54f36 = 'disabled';
const $24f165f112b24ca1$export$da351099a95c41a2 = 'view-mode';
const $24f165f112b24ca1$export$ddb90512ea536019 = 'creation-loading';
const $24f165f112b24ca1$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $24f165f112b24ca1$export$9b10dd4c500e3ce8 = {
    disabledClassName: $24f165f112b24ca1$export$7e44804769d54f36,
    viewModeClassName: $24f165f112b24ca1$export$da351099a95c41a2,
    creationLoadingClassName: $24f165f112b24ca1$export$ddb90512ea536019,
    draggingClassName: $24f165f112b24ca1$export$52ab9fe57e8e4c2e
};

});

parcelRegister("iSJ2T", function(module, exports) {
$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $6932c7fca14abfa4$export$a7172b75d403a0e4);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $6932c7fca14abfa4$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};

});

parcelRegister("cT8sX", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $f682b85a09ca4de1$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $f682b85a09ca4de1$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $t10OO = parcelRequire("t10OO");

var $014x6 = parcelRequire("014x6");

var $gsX8d = parcelRequire("gsX8d");

var $aGINe = parcelRequire("aGINe");
const $f682b85a09ca4de1$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $014x6.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $014x6.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $f682b85a09ca4de1$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $jctmk.css)({
    [`.${(0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $f682b85a09ca4de1$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $f682b85a09ca4de1$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $jctmk.css)(".", (0, $aGINe.RendererCssClassName).DOCUMENT, ">.", $f682b85a09ca4de1$export$afbde0e7339bed51.CONTAINER, " .", (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $014x6.blockNodesVerticalMargin), ";}");
};
const $f682b85a09ca4de1$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ text: text, hideLineNumbers: hideLineNumbers = false, className: className }, ref)=>{
    const textRows = (0, $fc4bM.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const classNames = [
        $f682b85a09ca4de1$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $gsX8d.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $f682b85a09ca4de1$var$codeBlockSharedStyles,
            $f682b85a09ca4de1$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        className: (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, !hideLineNumbers && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $jctmk.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        className: (0, $t10OO.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $jctmk.jsx)("code", null, text)))));
});
var $f682b85a09ca4de1$export$2e2bcd8739ae039 = $f682b85a09ca4de1$var$LightWeightCodeBlock;

});


parcelRegister("cUUJH", function(module, exports) {
$parcel$export(module.exports, "TruncatedWrapper", () => $2bbde4998f23f8a9$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");
const $2bbde4998f23f8a9$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $jctmk.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $2bbde4998f23f8a9$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $2bbde4998f23f8a9$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: styles
    }, children);
};
class $2bbde4998f23f8a9$export$79ad592494094f07 extends (0, $fc4bM.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $jctmk.jsx)($2bbde4998f23f8a9$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("1kas5", function(module, exports) {
$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $1422734cb6377d95$export$80ffe7e3c6bf25c3);
/* eslint-disable jsdoc/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");
function $1422734cb6377d95$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $fc4bM.useRef)(props);
    const prevFactory = (0, $fc4bM.useRef)(null);
    return (0, $fc4bM.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});



parcelRegister("xfOMX", function(module, exports) {
$parcel$export(module.exports, "HubRendererWrapperGated", () => $61b37a127e480c0d$export$1f620b69b87fadbd);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
// When the space-density experience is active, HubSpacingScope / hub-home-content
// set `--ak-editor-extension-block-spacing` on an ancestor. The wrapper reads
// that variable (falling back to `0`) as top/bottom PADDING on each bespoke hub
// extension, so the vertical rhythm between extensions follows the selected
// density. Padding (not margin) is used deliberately so adjacent extensions do
// not margin-collapse — the gap between two extensions is the sum of the lower
// extension's top padding and the upper extension's bottom padding. When the
// variable is unset the padding is `0`, so this is a no-op for hubs without a
// density selected.
const $61b37a127e480c0d$var$extensionBlockPadding = 'var(--ak-editor-extension-block-spacing, 0)';
const $61b37a127e480c0d$export$1a063b7cda785385 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_1e6s8tqg _1e111zeq _10xj1mtz _utchidpf _ovodidpf _17qaidpf _rtpd1uiu _1c211uiu _1frp1uiu _qndeidpf _1k6kidpf _icwmidpf _tjcw1uiu _mctt1uiu _6b941uiu _1p9ml5sy _1awjl5sy _1eejl5sy _tnsdl5sy _127ml5sy _1x7bl5sy _128soahv _s8ydoahv _jxcqoahv _1o1joahv _1bweoahv _1clwoahv _1cw7ovzw _yqhmovzw _uo9kovzw _1a031ssb _1fd01ssb _r3nk1ssb _x0t7zr6s _ato1zr6s _l6q3zr6s _14cjbxvg _13rbbxvg _1drwbxvg _1gyg274h _78a5274h _owha274h _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});
const $61b37a127e480c0d$var$HubRendererWrapperWithPadding = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_bozg1ejb _y4ti1ejb _xx6j4sbg _cyqw4sbg _1fv712ar _pw4g12ar _19d8e27k _zhdke27k _1e6s8tqg _1e111zeq _10xj1mtz _utchidpf _ovodidpf _17qaidpf _rtpd1uiu _1c211uiu _1frp1uiu _qndeidpf _1k6kidpf _icwmidpf _tjcw1uiu _mctt1uiu _6b941uiu _1p9ml5sy _1awjl5sy _1eejl5sy _tnsdl5sy _127ml5sy _1x7bl5sy _128soahv _s8ydoahv _jxcqoahv _1o1joahv _1bweoahv _1clwoahv _1cw7ovzw _yqhmovzw _uo9kovzw _1a031ssb _1fd01ssb _r3nk1ssb _x0t7zr6s _ato1zr6s _l6q3zr6s _14cjbxvg _13rbbxvg _1drwbxvg _1gyg274h _78a5274h _owha274h _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});
const $61b37a127e480c0d$export$1f620b69b87fadbd = ({ appearance: appearance, children: children, product: product, ...props })=>{
    const maxWidth = appearance === 'max' ? true : undefined;
    // Help-seeker (JSM) hub content always keeps its horizontal page inset,
    // independently of appearance and navbar padding.
    const shouldApplyPadding = product === 'JSM';
    if (shouldApplyPadding) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($61b37a127e480c0d$var$HubRendererWrapperWithPadding, {
        ...props,
        "data-hub-max-width": maxWidth
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($61b37a127e480c0d$export$1a063b7cda785385, {
        ...props,
        "data-hub-max-width": maxWidth
    }, children);
};

});

parcelRegister("dnylb", function(module, exports) {
$parcel$export(module.exports, "getSectionExtensionContents", () => $081deb206c0f5073$export$993dca3597b448e8);

var $fBMmh = parcelRequire("fBMmh");
const $081deb206c0f5073$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $fBMmh.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
                        extensionType: (0, $fBMmh.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];

});
parcelRegister("fBMmh", function(module, exports) {
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE", () => $75bf45e83c610f94$export$c14e692c91462ed4);
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY", () => $75bf45e83c610f94$export$ca3a94184e0fbd97);
const $75bf45e83c610f94$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $75bf45e83c610f94$export$ca3a94184e0fbd97 = 'hub-element-placeholder';

});


parcelRegister("eDH6u", function(module, exports) {
$parcel$export(module.exports, "sectionExtensionProvider", () => $0236d14ab911d5b5$export$6775abcfdb3b0453);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $5dbWS = parcelRequire("5dbWS");

var $d7r8x = parcelRequire("d7r8x");

var $leSAN = parcelRequire("leSAN");

var $gse21 = parcelRequire("gse21");

var $4Yydc = parcelRequire("4Yydc");

var $cYGVZ = parcelRequire("cYGVZ");

const $0236d14ab911d5b5$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: async ()=>(await (parcelRequire("ba98A"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "section-extension-loader"
        })
});
const $0236d14ab911d5b5$var$sectionParameters = (intl, defaultBackgroundColor)=>({
        extensionTitle: intl.formatMessage((0, $cYGVZ.messages).lozengeTitle),
        backgroundColor: defaultBackgroundColor,
        contentWidth: (0, $4Yydc.DEFAULT_CONTENT_WIDTH)
    });

const $0236d14ab911d5b5$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider, defaultParameters: defaultParameters })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $cYGVZ.messages).lozengeTitle);
        const description = intl.formatMessage((0, $cYGVZ.messages).description);
        // Only honour the v2 seed when advanced theming is on. Falls back to the
        // legacy `DEFAULT_BACKGROUND_COLOR` for Confluence/CSM/gate-OFF help-center.
        const defaultBackgroundColor = defaultParameters !== null && defaultParameters !== void 0 && defaultParameters.isAdvancedThemingEnabled && defaultParameters.backgroundColor ? defaultParameters.backgroundColor : (0, $4Yydc.DEFAULT_BACKGROUND_COLOR);
        const parameters = $0236d14ab911d5b5$var$sectionParameters(intl, defaultBackgroundColor);
        const type = (0, $leSAN.SECTION_EXTENSION_TYPE);
        const key = (0, $4Yydc.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $cYGVZ.messages).contentHeader),
            subHeader: intl.formatMessage((0, $cYGVZ.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $cYGVZ.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>(parcelRequire("lzfLx")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            var _editorActions$getSel, _selectedNode$attrs;
            const selectedNode = editorActions === null || editorActions === void 0 || (_editorActions$getSel = editorActions.getSelectedNode()) === null || _editorActions$getSel === void 0 ? void 0 : _editorActions$getSel.toJSON();
            const selectedLocalId = selectedNode === null || selectedNode === void 0 || (_selectedNode$attrs = selectedNode.attrs) === null || _selectedNode$attrs === void 0 ? void 0 : _selectedNode$attrs.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($0236d14ab911d5b5$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $5dbWS.default)([
            (0, $gse21.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };

});
parcelRegister("5dbWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $06e7f85886de0982$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");

var $PMvXl = parcelRequire("PMvXl");
class $06e7f85886de0982$export$2e2bcd8739ae039 {
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsCache = [];
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            var _manifest$modules;
            const nodes = manifest === null || manifest === void 0 || (_manifest$modules = manifest.modules) === null || _manifest$modules === void 0 ? void 0 : _manifest$modules.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                var _preloadRender, _ref;
                preloadCalls.push(node === null || node === void 0 || (_preloadRender = (_ref = node).preloadRender) === null || _preloadRender === void 0 ? void 0 : _preloadRender.call(_ref));
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    /**
   * Synchronously returns an extension from the manifests loaded by `preload`. Returns undefined when
   * the extension is not preloaded, so callers can fall back to the asynchronous `getExtension`.
   */ getPreloadedExtension(type, key) {
        if ((0, $dRkX9.fg)('platform_editor_preloaded_extension_not_found')) return this.findExtensionInManifests(this.manifestsCache, type, key);
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    findExtensionInManifests(manifests, type, key) {
        return manifests.find((manifest)=>manifest.type === type && manifest.key === key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = this.findExtensionInManifests(manifests, type, key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $PMvXl.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
}

});
parcelRegister("PMvXl", function(module, exports) {
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $66f02ec2e1bd8682$export$60407594ea5edd1c);
async function $66f02ec2e1bd8682$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}

});


parcelRegister("gse21", function(module, exports) {
$parcel$export(module.exports, "getExtensionManifest", () => $ed6631e7bea9cf94$export$573ee875a39e7e73);
const $ed6631e7bea9cf94$export$573ee875a39e7e73 = ({ key: key, icons: icons, parameters: parameters, update: update, render: render, title: title, type: type, description: description, source: source, nodeType: nodeType = 'extension', quickInsertAction: quickInsertAction, preview: preview, setUpsellModalSource: setUpsellModalSource, additionalModuleNodeProps: additionalModuleNodeProps })=>{
    return {
        title: title,
        type: type,
        key: key,
        description: description,
        icons: icons,
        ...preview && {
            preview: preview
        },
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'quick-insert',
                    action: async ()=>setUpsellModalSource(source)
                }
            ] : [
                {
                    key: 'quick-insert',
                    action: quickInsertAction || {
                        type: 'node',
                        key: 'default',
                        parameters: parameters
                    }
                }
            ],
            nodes: {
                default: {
                    type: nodeType,
                    render: render,
                    update: update,
                    ...additionalModuleNodeProps
                }
            }
        }
    };
};

});

parcelRegister("4Yydc", function(module, exports) {
$parcel$export(module.exports, "SECTION_EXTENSION_KEY", () => $dcd297371187f70e$export$bc69bf23ec1f99d5);
$parcel$export(module.exports, "SECTION_EXTENSION_ANALYTICS_SOURCE", () => $dcd297371187f70e$export$7a75cc6a69e05549);
$parcel$export(module.exports, "CONTENT_WIDTH", () => $dcd297371187f70e$export$3130b484681bf8bc);
$parcel$export(module.exports, "DEFAULT_CONTENT_WIDTH", () => $dcd297371187f70e$export$6cccba5fae1d609d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $dcd297371187f70e$export$617cdcc6afaae4f7);
const $dcd297371187f70e$export$bc69bf23ec1f99d5 = 'hub-section';
const $dcd297371187f70e$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $dcd297371187f70e$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $dcd297371187f70e$export$6cccba5fae1d609d = "wide";
const $dcd297371187f70e$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";

});

parcelRegister("cYGVZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a3009ef72a4a39b5$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $a3009ef72a4a39b5$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    lozengeTitle: {
        id: 'company-hub.section-extension.manifest.extension-lozenge-title',
        defaultMessage: 'Section',
        description: 'Title of section extension to be displayed in lozenge/quick insert menu.'
    },
    description: {
        id: 'company-hub.section-extension.manifest.macro-description',
        defaultMessage: 'Group elements together with a background',
        description: 'Description of section extension to be displayed in toolbar/shortcut macros dropdown'
    },
    contentHeader: {
        id: 'company-hub.section-extension.manifest.content.header',
        defaultMessage: 'Give your section a title',
        description: "Header of section extension's initial content"
    },
    contentSubHeader: {
        id: 'company-hub.section-extension.manifest.content.sub-header',
        defaultMessage: 'Organize elements into sections with customizable backgrounds.',
        description: "Sub-header of section extension's initial content"
    },
    placeHolderTitle: {
        id: 'company-hub.section-extension.manifest.content.placeholder-title',
        defaultMessage: 'Placeholder',
        description: 'Title of hub element placeholder extension to be displayed the macro is presented in the editor.'
    }
});

});

parcelRegister("ba98A", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ho7hy").then(()=>parcelRequire('2NpyN'));

});

parcelRegister("lzfLx", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6lgiG").then(()=>parcelRequire('k9Qkk'));

});


parcelRegister("9ES7w", function(module, exports) {
$parcel$export(module.exports, "useHubExtensionHandlers", () => $17c5249fbbc7d159$export$617d11c0fd386821);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $d7r8x = parcelRequire("d7r8x");

var $7k275 = parcelRequire("7k275");

var $ch8O0 = parcelRequire("ch8O0");

var $leSAN = parcelRequire("leSAN");

var $6KLOx = parcelRequire("6KLOx");

var $dwFzI = parcelRequire("dwFzI");

const $17c5249fbbc7d159$var$SpotlightExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: async ()=>(await (parcelRequire("hi7GK"))).SpotlightExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "spotlight-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null))
});

const $17c5249fbbc7d159$var$LinksMenuLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: async ()=>(await (parcelRequire("9LVYR"))).LinksMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "links-menu-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null))
});

const $17c5249fbbc7d159$export$b55cedbe49066c7 = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: async ()=>(await (parcelRequire("hwbmg"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "cards-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null))
});

const $17c5249fbbc7d159$var$CarouselLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: async ()=>(await (parcelRequire("iuAQf"))).Carousel,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "carousel-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null))
});

const $17c5249fbbc7d159$var$SectionExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: async ()=>(await (parcelRequire("ba98A"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
            name: "section-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null))
});
const $17c5249fbbc7d159$export$617d11c0fd386821 = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider } = props;
    const extensionHandlers = {
        [(0, $leSAN.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null),
        [(0, $dwFzI.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null),
        [(0, $7k275.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null),
        [(0, $ch8O0.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null),
        [(0, $leSAN.SECTION_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null)
    };
    const defaultExtensionHandlerProps = (0, $fc4bM.useMemo)(()=>({
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $6KLOx.ExtensionMode).RENDERER
        }), [
        contentId,
        PropsProvider
    ]);
    const spotlightExtension = (0, $fc4bM.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($17c5249fbbc7d159$var$SpotlightExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const linksMenuExtension = (0, $fc4bM.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($17c5249fbbc7d159$var$LinksMenuLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const cardsExtension = (0, $fc4bM.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($17c5249fbbc7d159$export$b55cedbe49066c7, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const carouselExtension = (0, $fc4bM.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($17c5249fbbc7d159$var$CarouselLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const sectionExtension = (0, $fc4bM.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($17c5249fbbc7d159$var$SectionExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    if (contentId) {
        extensionHandlers[0, $leSAN.SPOTLIGHT_EXTENSION_TYPE] = spotlightExtension;
        extensionHandlers[0, $dwFzI.LINKS_MENU_EXTENSION_TYPE] = linksMenuExtension;
        extensionHandlers[0, $7k275.CARDS_EXTENSION_TYPE] = cardsExtension;
        extensionHandlers[0, $ch8O0.carouselExtensionType] = carouselExtension;
        extensionHandlers[0, $leSAN.SECTION_EXTENSION_TYPE] = sectionExtension;
    }
    return extensionHandlers;
};

});
parcelRegister("7k275", function(module, exports) {
$parcel$export(module.exports, "CARDS_EXTENSION_TYPE", () => $894a6ada1129d619$export$81e5b59a1e176638);
$parcel$export(module.exports, "CARDS_EXTENSION_KEY", () => $894a6ada1129d619$export$8a4891a61ff91b00);
$parcel$export(module.exports, "CARDS_EXTENSION_ANALYTIC_SOURCE", () => $894a6ada1129d619$export$67bfcae6d68bb0bf);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $894a6ada1129d619$export$7f17fab0aecb44ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE", () => $894a6ada1129d619$export$6a35a50674becbae);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE", () => $894a6ada1129d619$export$9bf56665bf6ea6ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE", () => $894a6ada1129d619$export$cf23b6d2fd159502);
$parcel$export(module.exports, "DYNAMIC_CARDS_SEARCH_EXPERIENCE", () => $894a6ada1129d619$export$97dc3a9d9f5d9aa3);
$parcel$export(module.exports, "CARDS_EXTENSION_VERSION_5", () => $894a6ada1129d619$export$b84f9a7c097c895c);
$parcel$export(module.exports, "CARDS_IMAGES_V5", () => $894a6ada1129d619$export$5e905747d7497a1f);
const $894a6ada1129d619$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $894a6ada1129d619$export$8a4891a61ff91b00 = 'cards';
const $894a6ada1129d619$export$67bfcae6d68bb0bf = 'cardsExtension';
const $894a6ada1129d619$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $894a6ada1129d619$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $894a6ada1129d619$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $894a6ada1129d619$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $894a6ada1129d619$export$97dc3a9d9f5d9aa3 = 'dynamic-cards';
const $894a6ada1129d619$export$131b76b4d30d2b44 = '2';
const $894a6ada1129d619$export$a08b7507bedba276 = '3';
const $894a6ada1129d619$export$c87753a8bb0c4e75 = '4';
const $894a6ada1129d619$export$b84f9a7c097c895c = '5';
const $894a6ada1129d619$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];

});

parcelRegister("ch8O0", function(module, exports) {
$parcel$export(module.exports, "carouselExtensionType", () => $8d046f8a8659eb04$export$a06ac4f1777262dc);
$parcel$export(module.exports, "carouselExtensionKey", () => $8d046f8a8659eb04$export$6c8179fa243b4399);
$parcel$export(module.exports, "carouselContentAnalyticSource", () => $8d046f8a8659eb04$export$ca14f22a239c4ae9);
$parcel$export(module.exports, "carouselConfigAnalyticSource", () => $8d046f8a8659eb04$export$4cb671946a80c52e);
$parcel$export(module.exports, "AUTOPLAY_SECONDS", () => $8d046f8a8659eb04$export$93995a2609cff38d);
$parcel$export(module.exports, "ARIA_CONTROLS_PREFIX", () => $8d046f8a8659eb04$export$3a86d0fc7eb402f4);
$parcel$export(module.exports, "CAROUSEL_VERSION_2", () => $8d046f8a8659eb04$export$b429752dfe934bea);
$parcel$export(module.exports, "FRAMES_LIMIT_V2", () => $8d046f8a8659eb04$export$c5c6e75ceae0cc22);
const $8d046f8a8659eb04$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $8d046f8a8659eb04$export$6c8179fa243b4399 = 'carousel';
const $8d046f8a8659eb04$export$ca14f22a239c4ae9 = 'carouselExtension';
const $8d046f8a8659eb04$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $8d046f8a8659eb04$export$93995a2609cff38d = 8;
const $8d046f8a8659eb04$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $8d046f8a8659eb04$export$9575b4f5d97a1c29 = '1';
const $8d046f8a8659eb04$export$b429752dfe934bea = '2';
const $8d046f8a8659eb04$export$c5c6e75ceae0cc22 = 10;

});

parcelRegister("dwFzI", function(module, exports) {
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_TYPE", () => $94840337e17b396d$export$9fdf64a495514b4);
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_ANALYTIC_SOURCE", () => $94840337e17b396d$export$ed5854f17099adbf);
const $94840337e17b396d$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $94840337e17b396d$export$ed5854f17099adbf = 'linksMenuExtension';

});

parcelRegister("hi7GK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("jut7n"),
    $9dnsd("8JwX0"),
    $9dnsd("lWJ03")
]).then(()=>parcelRequire('3Ttjx'));

});

parcelRegister("9LVYR", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("j5AWa"),
    $9dnsd("2lCWM")
]).then(()=>parcelRequire('e8oTA'));

});

parcelRegister("hwbmg", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1xWnR"),
    $9dnsd("4SNZI"),
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("3EcVO"),
    $9dnsd("gxCRt"),
    $9dnsd("cz9eg"),
    $9dnsd("k09lt"),
    $9dnsd("hzmzP"),
    $9dnsd("gGeD6"),
    $9dnsd("1zkIL"),
    $9dnsd("77JWw"),
    $9dnsd("hlj0q"),
    $9dnsd("hrLwj"),
    $9dnsd("9RLh6"),
    $9dnsd("cvO2I"),
    $9dnsd("lAoL0"),
    $9dnsd("iH74T"),
    $9dnsd("6jy1b"),
    $9dnsd("ekETX"),
    $9dnsd("iDMqi"),
    $9dnsd("lsa7j"),
    $9dnsd("67Pud"),
    $9dnsd("gUCeg"),
    $9dnsd("flsuY")
]).then(()=>parcelRequire('6Uj0X'));

});

parcelRegister("iuAQf", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("kKSCA"),
    $9dnsd("jut7n"),
    $9dnsd("1ggPn"),
    $9dnsd("gjCvi"),
    $9dnsd("j8G7L")
]).then(()=>parcelRequire('l6tVb'));

});



parcelRegister("31Sza", function(module, exports) {
$parcel$export(module.exports, "RovoWidgetConfigProvider", () => $60718efca7614510$export$f5c8aa8bbd79048b);
$parcel$export(module.exports, "useOptionalRovoWidgetConfig", () => $60718efca7614510$export$7214a7b21115b7c6);

var $fc4bM = parcelRequire("fc4bM");
const $60718efca7614510$var$RovoWidgetConfigContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $60718efca7614510$export$f5c8aa8bbd79048b = ({ rovoWidgetConfig: rovoWidgetConfig, children: children })=>{
    const [value] = (0, $fc4bM.useState)({
        rovoWidgetConfig: rovoWidgetConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($60718efca7614510$var$RovoWidgetConfigContext.Provider, {
        value: value
    }, children);
};
const $60718efca7614510$export$7214a7b21115b7c6 = ()=>{
    return (0, $fc4bM.useContext)($60718efca7614510$var$RovoWidgetConfigContext);
};
const $60718efca7614510$export$1092b6d5a83d6e = ()=>{
    const contextValue = (0, $fc4bM.useContext)($60718efca7614510$var$RovoWidgetConfigContext);
    if (!contextValue) throw new Error('useRovoWidgetConfig must be used within a RovoWidgetConfigProvider');
    return contextValue;
};

});

parcelRegister("58t6F", function(module, exports) {
$parcel$export(module.exports, "useProductExtensionHandlers", () => $8f337b5377818f42$export$f8392d0e24abe6db);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $d7r8x = parcelRequire("d7r8x");

var $eR9Lm = parcelRequire("eR9Lm");

var $exNRh = parcelRequire("exNRh");

var $leSAN = parcelRequire("leSAN");

var $6KLOx = parcelRequire("6KLOx");

var $fVRf7 = parcelRequire("fVRf7");

var $lD6st = parcelRequire("lD6st");

var $7pQcS = parcelRequire("7pQcS");

var $h7C3u = parcelRequire("h7C3u");

const $8f337b5377818f42$var$CalloutBannerExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>(parcelRequire("7ZCDS")).then((mod)=>({
            default: mod.CalloutBannerExtension
        })));

const $8f337b5377818f42$var$ResourceTilesExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>(parcelRequire("cG1Zz")).then((mod)=>({
            default: mod.ResourceTilesExtension
        })));

const $8f337b5377818f42$var$JSMHelpExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>(parcelRequire("iwYvY")).then((mod)=>({
            default: mod.JSMHelpExtension
        })));

const $8f337b5377818f42$var$HubForgeExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>(parcelRequire("7SbZl")).then((mod)=>({
            default: mod.HubForgeExtension
        })));

const $8f337b5377818f42$var$HubConnectExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>(parcelRequire("3nWjO")).then((mod)=>({
            default: mod.HubConnectExtension
        })));
// Host-gated: `forge-on-hubs` for Help Hub / JSM, `forge-on-csm-hubs` for CSM.
const $8f337b5377818f42$var$getHubForgeAndConnectExtensionHandlers = (contentId, PropsProvider, gateName = 'forge-on-hubs')=>{
    if (!(0, $dRkX9.fg)(gateName)) return {};
    const handlers = {};
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $6KLOx.ExtensionMode).RENDERER
    };
    handlers[0, $lD6st.HUB_FORGE_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                name: "hub-forge-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($8f337b5377818f42$var$HubForgeExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    handlers[0, $fVRf7.HUB_CONNECT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                name: "hub-connect-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($8f337b5377818f42$var$HubConnectExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    return handlers;
};
const $8f337b5377818f42$var$getCSMExtensionHandlers = (contentId, PropsProvider)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $6KLOx.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $eR9Lm.ArticleSearchComponent)
    };
    // Callout banner Extension Handler
    handlers[0, $h7C3u.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($8f337b5377818f42$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    // Resource Tiles Extension Handler
    handlers[0, $leSAN.RESOURCE_TILES_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                name: "resource-tiles-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($8f337b5377818f42$var$ResourceTilesExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension,
                isInEditor: false
            })
        });
    Object.assign(handlers, $8f337b5377818f42$var$getHubForgeAndConnectExtensionHandlers(contentId, PropsProvider, 'forge-on-csm-hubs'));
    return handlers;
};
const $8f337b5377818f42$var$getJSMExtensionHandlers = (contentId, PropsProvider, rovoWidgetQueryReference)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $6KLOx.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $exNRh.HelpObjectSearchComponent)
    };
    handlers[0, $h7C3u.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($8f337b5377818f42$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension,
                rovoWidgetQueryReference: rovoWidgetQueryReference
            })
        });
    // JSM Help Extension Handler
    handlers[0, $7pQcS.JSM_HELP_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d7r8x.default), {
                name: "jsm-help-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($8f337b5377818f42$var$JSMHelpExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    Object.assign(handlers, $8f337b5377818f42$var$getHubForgeAndConnectExtensionHandlers(contentId, PropsProvider));
    return handlers;
};
const $8f337b5377818f42$export$f8392d0e24abe6db = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider, product: product, rovoWidgetQueryReference: rovoWidgetQueryReference } = props;
    const extensionHandlers = (0, $fc4bM.useMemo)(()=>{
        if (product === 'CUSTOMER_SERVICE') return $8f337b5377818f42$var$getCSMExtensionHandlers(contentId, PropsProvider);
        // Rovo in the callout banner is only available in help hubs, so the
        // preloaded Rovo widget query is only forwarded here.
        if (product === 'HELP_HUB' && (0, $dRkX9.fg)('enable-jsm-in-hubs')) return $8f337b5377818f42$var$getJSMExtensionHandlers(contentId, PropsProvider, rovoWidgetQueryReference);
        return {};
    }, [
        product,
        contentId,
        PropsProvider,
        rovoWidgetQueryReference
    ]);
    return extensionHandlers;
};

});
parcelRegister("eR9Lm", function(module, exports) {
$parcel$export(module.exports, "ArticleSearchComponent", () => $0b6357f3a547ee37$export$8a672206592a1254);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $4EPUx = parcelRequire("4EPUx");

var $dBtOK = parcelRequire("dBtOK");

var $iHy52 = parcelRequire("iHy52");

var $gpdro = parcelRequire("gpdro");

var $lgMnQ = parcelRequire("lgMnQ");

var $5JxdW = parcelRequire("5JxdW");
const $0b6357f3a547ee37$export$8a672206592a1254 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $fc4bM.useState)('');
    const [showDropdown, setShowDropdown] = (0, $fc4bM.useState)(false);
    const inputBoxRef = (0, $fc4bM.useRef)(null);
    const inputRef = (0, $fc4bM.useRef)(null);
    const [_, setInputWidth] = (0, $fc4bM.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, helpCenterAri: helpCenterAri } = (0, $iHy52.useProductDependencies)();
    (0, $fc4bM.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $fc4bM.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            ref: inputBoxRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JxdW.SearchTextField), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onInput: handleInput,
            isReadOnly: isEditor,
            placeholderText: placeholderText,
            showDropdown: showDropdown,
            queryWord: queryWord
        }));
    }, [
        isEditor,
        placeholderText,
        showDropdown,
        queryWord
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gpdro.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMnQ.SearchDropdown), {
                ...contentProps,
                cloudId: cloudId,
                helpCenterAri: helpCenterAri || '',
                inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                queryWord: queryWord
            }));
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("gpdro", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $2c018bd5fba14b2e$export$4da28cf324280418);
$parcel$export(module.exports, "KeyboardHighlightProvider", () => $2c018bd5fba14b2e$export$c8551b32665b42b);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $2c018bd5fba14b2e$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    selectComponentByTrackingId: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $2c018bd5fba14b2e$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const navigationTrackingId = (options === null || options === void 0 ? void 0 : options.navigationTrackingId) ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $fc4bM.useContext)($2c018bd5fba14b2e$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const onKeydownCallback = options === null || options === void 0 ? void 0 : options.onKeydownCallback;
    const onHighlightedCallback = options === null || options === void 0 ? void 0 : options.onHighlightedCallback;
    const unregister = (0, $fc4bM.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $fc4bM.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $fc4bM.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $fc4bM.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
const $2c018bd5fba14b2e$export$c8551b32665b42b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ children: children, listenerNode: listenerNode, onSelectedElementChange: onSelectedElementChange }, ref)=>{
    const currentlySelectedRef = (0, $fc4bM.useRef)(undefined);
    const currentSelectedTrackingIdRef = (0, $fc4bM.useRef)(null);
    const keyboardNavComponentsRef = (0, $fc4bM.useRef)([]);
    const getSelectedIndex = (0, $fc4bM.useCallback)(()=>{
        const currentlySelected = currentlySelectedRef.current;
        if (!currentlySelected) return undefined;
        return keyboardNavComponentsRef.current.findIndex(({ id: id })=>id === currentlySelected);
    }, []);
    const getSearchIdIndex = (0, $fc4bM.useCallback)((searchId)=>searchId === null ? undefined : keyboardNavComponentsRef.current.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), []);
    const unhighlightComponentAt = (0, $fc4bM.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) components[index].onHighlightChanged(false);
    }, []);
    const highlightComponentAt = (0, $fc4bM.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (index >= 0 && index < components.length) {
            const { id: id, navigationTrackingId: navigationTrackingId } = components[index];
            currentlySelectedRef.current = id;
            currentSelectedTrackingIdRef.current = navigationTrackingId;
            components[index].onHighlightChanged(true);
            onSelectedElementChange === null || onSelectedElementChange === void 0 || onSelectedElementChange(navigationTrackingId || undefined);
        }
    }, [
        onSelectedElementChange
    ]);
    const unhighlightAll = (0, $fc4bM.useCallback)(()=>{
        currentSelectedTrackingIdRef.current = null;
        currentlySelectedRef.current = undefined;
        onSelectedElementChange === null || onSelectedElementChange === void 0 || onSelectedElementChange(undefined);
        keyboardNavComponentsRef.current.forEach((component)=>component.onHighlightChanged(false));
    }, [
        onSelectedElementChange
    ]);
    const onHighlightedCallback = (0, $fc4bM.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const callback = components[index].onHighlightedCallback;
            callback && callback(index);
        }
    }, []);
    const selectComponentByTrackingId = (0, $fc4bM.useCallback)((trackingId)=>{
        const index = getSearchIdIndex(trackingId);
        if (index === undefined || index < 0) return undefined;
        unhighlightAll();
        highlightComponentAt(index);
        onHighlightedCallback(index);
        return index;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        onHighlightedCallback,
        unhighlightAll
    ]);
    const onKeyDownCallbackAt = (0, $fc4bM.useCallback)((index, e)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const onKeyDown = components[index].onKeyDownWhenHighlighted;
            onKeyDown && onKeyDown(e, components[index].domRef);
        }
    }, []);
    const registerKeyboardEnabled = (0, $fc4bM.useCallback)((currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCb)=>{
        const components = keyboardNavComponentsRef.current;
        const indexAt = components.findIndex(({ id: id })=>id === currentId);
        // If the currentId is null or we can't find any records of the id we will create a new entry
        const isNew = currentId === null || currentId === undefined || indexAt === -1;
        const id = isNew ? Math.max(...components.map((component)=>component.id), 0) + 1 : components[indexAt].id;
        if (isNew) components.push({
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        });
        else // Otherwise we will update the current entry
        components[indexAt] = {
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        };
        keyboardNavComponentsRef.current = components.sort((c1, c2)=>{
            const result = c1.domRef.compareDocumentPosition(c2.domRef);
            if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
        const indexToHighlight = getSearchIdIndex(currentSelectedTrackingIdRef.current);
        if (indexToHighlight !== undefined && indexToHighlight >= 0) {
            unhighlightAll();
            highlightComponentAt(indexToHighlight);
        }
        return id;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
    const unregisterKeyboardEnabled = (0, $fc4bM.useCallback)((unregisterRef)=>{
        if (currentlySelectedRef.current === unregisterRef) {
            currentlySelectedRef.current = undefined;
            onSelectedElementChange === null || onSelectedElementChange === void 0 || onSelectedElementChange(undefined);
        }
        keyboardNavComponentsRef.current = keyboardNavComponentsRef.current.filter(({ id: ref })=>ref !== unregisterRef);
        // Reset currentSelectedTrackingId when all components are unregistered
        if (keyboardNavComponentsRef.current.length === 0) currentSelectedTrackingIdRef.current = null;
    }, [
        onSelectedElementChange
    ]);
    const onKeyDown = (0, $fc4bM.useCallback)((e)=>{
        const components = keyboardNavComponentsRef.current;
        if (components.length === 0) return;
        if (e.isComposing || e.keyCode === 229) return;
        let currentIndex = getSelectedIndex();
        const prevIndex = currentIndex;
        if (e.code === 'ArrowDown' || e.keyCode === 40) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = 0;
                else currentIndex = (currentIndex + 1) % components.length;
                e.preventDefault();
            }
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = components.length - 1;
                else {
                    currentIndex -= 1;
                    if (currentIndex < 0) currentIndex = components.length - Math.abs(currentIndex);
                }
                e.preventDefault();
            }
        } else {
            if (typeof currentIndex !== 'undefined') onKeyDownCallbackAt(currentIndex, e);
            return;
        }
        if (prevIndex !== currentIndex && currentIndex !== undefined) {
            unhighlightComponentAt(prevIndex);
            highlightComponentAt(currentIndex);
            onHighlightedCallback(currentIndex);
        }
    }, [
        getSelectedIndex,
        onKeyDownCallbackAt,
        unhighlightComponentAt,
        highlightComponentAt,
        onHighlightedCallback
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!listenerNode) return;
        listenerNode.addEventListener('keydown', onKeyDown);
        return ()=>{
            listenerNode.removeEventListener('keydown', onKeyDown);
        };
    }, [
        listenerNode,
        onKeyDown
    ]);
    (0, $fc4bM.useEffect)(()=>()=>onSelectedElementChange === null || onSelectedElementChange === void 0 ? void 0 : onSelectedElementChange(undefined), [
        onSelectedElementChange
    ]);
    const contextValue = (0, $fc4bM.useMemo)(()=>({
            registerKeyboardEnabled: registerKeyboardEnabled,
            unregisterKeyboardEnabled: unregisterKeyboardEnabled,
            getSelectedIndex: getSelectedIndex,
            selectComponentByTrackingId: selectComponentByTrackingId,
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            get keyboardNavComponents () {
                // Always read the latest registry from the ref so consumers that
                // destructure `keyboardNavComponents` from the context still see
                // up-to-date data without forcing a re-render of the provider.
                return keyboardNavComponentsRef.current;
            }
        }), [
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        getSelectedIndex,
        selectComponentByTrackingId,
        highlightComponentAt,
        unhighlightComponentAt,
        unhighlightAll
    ]);
    (0, $fc4bM.useImperativeHandle)(ref, ()=>({
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            getSelectedIndex: getSelectedIndex
        }));
    return /*#__PURE__*/ (0, $3LM7S.jsx)($2c018bd5fba14b2e$export$ef7af5d8bc5d5ac1.Provider, {
        value: contextValue,
        children: children
    });
});
const $2c018bd5fba14b2e$export$cbeda0f7f7a8026c = ()=>{
    return (0, $fc4bM.useContext)($2c018bd5fba14b2e$export$ef7af5d8bc5d5ac1);
};

});

parcelRegister("lgMnQ", function(module, exports) {
$parcel$export(module.exports, "SearchDropdown", () => $7827d66532df278c$export$e33d60b8f4099ae);

var $fc4bM = parcelRequire("fc4bM");

var $5cRZl = parcelRequire("5cRZl");

var $1QpNn = parcelRequire("1QpNn");

var $45QqP = parcelRequire("45QqP");
const $7827d66532df278c$export$e33d60b8f4099ae = ({ inputWidth: inputWidth, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5cRZl.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $45QqP.SearchSkeletons), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1QpNn.ResolvedAndErrorContent), props)));
};

});
parcelRegister("5cRZl", function(module, exports) {
$parcel$export(module.exports, "SearchDialog", () => $0d75dca744d68392$export$2aadebb53f6015f6);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $kWpCp = parcelRequire("kWpCp");
const $0d75dca744d68392$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $kWpCp.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });

});
parcelRegister("kWpCp", function(module, exports) {
$parcel$export(module.exports, "SearchDialogWrapper", () => $0764ef59d1895874$export$dcefba65c42da69c);
parcelRequire("fc4bM");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $0764ef59d1895874$export$dcefba65c42da69c = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e101cjwc0"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $2np0Z.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $2np0Z.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $2np0Z.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $2np0Z.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");

});
parcelRegister("2np0Z", function(module, exports) {
$parcel$export(module.exports, "grid", () => $c717eef3f1c882e2$export$85fc379452d91af0);
$parcel$export(module.exports, "dialogWidth", () => $c717eef3f1c882e2$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $c717eef3f1c882e2$export$ce4512df260a325a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $c717eef3f1c882e2$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$c717eef3f1c882e2$var$AkGrid(multiplier * num),
        half: ()=>$c717eef3f1c882e2$var$AkGrid(0.5 * num),
        twice: ()=>$c717eef3f1c882e2$var$AkGrid(2 * num)
    });
const $c717eef3f1c882e2$export$85fc379452d91af0 = $c717eef3f1c882e2$var$AkGrid(1);
const $c717eef3f1c882e2$export$b9930dabfa4a3a3 = '56px';
const $c717eef3f1c882e2$export$f6af7620e8789c39 = '200px';
const $c717eef3f1c882e2$export$64d8573e83b64ff8 = '150px';
const $c717eef3f1c882e2$export$a3da89b899389ed8 = '780px';
const $c717eef3f1c882e2$export$ce4512df260a325a = 780;
const $c717eef3f1c882e2$export$a406031ed42c8e02 = '1130px';
const $c717eef3f1c882e2$export$e00021bea368c518 = $c717eef3f1c882e2$export$85fc379452d91af0.multiple(4);
const $c717eef3f1c882e2$export$30310ee354b45eb0 = $c717eef3f1c882e2$export$85fc379452d91af0.multiple(6);

});

parcelRegister("3E7Rl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a7b3436a67cc506$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");
parcelRequire("jctmk");
var $g7pKS = parcelRequire("g7pKS");

var $dWJZQ = parcelRequire("dWJZQ");

var $dUbjW = parcelRequire("dUbjW");

var $cW82w = parcelRequire("cW82w");

var $fc4bM = parcelRequire("fc4bM");

var $8lWu6 = parcelRequire("8lWu6");
var $2a7b3436a67cc506$var$isDevelopment = false;
var $2a7b3436a67cc506$var$testOmitPropsOnStringTag = (0, $8lWu6.default);
var $2a7b3436a67cc506$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $2a7b3436a67cc506$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2a7b3436a67cc506$var$testOmitPropsOnStringTag : $2a7b3436a67cc506$var$testOmitPropsOnComponent;
};
var $2a7b3436a67cc506$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2a7b3436a67cc506$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cW82w.registerStyles)(cache, serialized, isStringTag);
    (0, $dUbjW.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cW82w.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2a7b3436a67cc506$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2a7b3436a67cc506$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2a7b3436a67cc506$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $g7pKS.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $fc4bM.useContext((0, $g7pKS.T));
            }
            if (typeof props.className === 'string') className = (0, $cW82w.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $dWJZQ.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2a7b3436a67cc506$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($2a7b3436a67cc506$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $fc4bM.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $2a7b3436a67cc506$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $hHCeM.default)({}, options, nextOptions, {
                shouldForwardProp: $2a7b3436a67cc506$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8lWu6", function(module, exports) {
$parcel$export(module.exports, "default", () => $614da6b11a8dbd8e$export$2e2bcd8739ae039);

var $kMbkQ = parcelRequire("kMbkQ");
// eslint-disable-next-line no-undef
var $614da6b11a8dbd8e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $614da6b11a8dbd8e$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $kMbkQ.default)(function(prop) {
    return $614da6b11a8dbd8e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});




parcelRegister("1QpNn", function(module, exports) {
$parcel$export(module.exports, "ResolvedAndErrorContent", () => $ce3d26e726dfc202$export$5d6737b8e2fd8b38);

var $frLqh = parcelRequire("frLqh");

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $2yV5V = parcelRequire("2yV5V");

var $dS86g = parcelRequire("dS86g");

var $d68Yo = parcelRequire("d68Yo");

var $5pB2s = parcelRequire("5pB2s");
var $bFHiR = parcelRequire("bFHiR");

var $2f8np = parcelRequire("2f8np");

var $esfUw = parcelRequire("esfUw");

var $jTfHh = parcelRequire("jTfHh");

var $6ZeA9 = parcelRequire("6ZeA9");

var $4KHuY = parcelRequire("4KHuY");
const $ce3d26e726dfc202$export$5d6737b8e2fd8b38 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $3BZyK.useLazyLoadQuery)((0, $frLqh.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        input: {
            query: queryWord,
            contentTypes: [
                'FOLDER',
                'PAGE'
            ]
        },
        first: 10
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const { articlesAndFolders: articlesAndFolders, hasQueryError: hasQueryError } = (0, $esfUw.useArticleSearch)(searchResponse, queryWord);
    const showEmptyState = articlesAndFolders && articlesAndFolders.length === 0;
    const showResolvedState = articlesAndFolders && articlesAndFolders.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null, (showEmptyState || hasQueryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d68Yo.EmptyState), {
        title: hasQueryError ? formatMessage((0, $4KHuY.messages).errorTitle) : formatMessage((0, $4KHuY.messages).emptyStateTitle),
        Image: (0, $6ZeA9.SearchErrorImage),
        content: hasQueryError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $4KHuY.messages).errorDescription) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $4KHuY.messages).emptyStateDescription)
    }), showResolvedState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bFHiR.SearchDialogContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5pB2s.ResultContainer), null, articlesAndFolders.map((result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2f8np.SearchResult), {
            key: result.id,
            href: result.url,
            title: result.title,
            isCollapsed: true,
            icon: result.type === (0, $jTfHh.ContentType).PAGE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2yV5V))), {
                label: ""
            })
        }))))));
};

});
parcelRegister("frLqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d6341e0cc6d26dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdd62f48e8fdad92549ed462bc7fb25f>>
 * @relayHash d3adfd96cf5547776151651b69eb76b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a
const $1d6341e0cc6d26dc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "contentType"
            },
            {
                "concreteType": "HelpObjectStoreArticleURLInfo",
                "kind": "LinkedField",
                "name": "urlInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "shareUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "alias": "helpObjectStore_searchArticlesForSupportSite",
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ],
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "__ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "args": v12 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "helpCenterAri",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "helpObjectStore_searchArticlesForSupportSite"
                        ]
                    }
                ]
            },
            "name": "resolvedAndErrorContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1d6341e0cc6d26dc$var$node.hash = "8f52dcfd8c2f8d8ee3e0ac349b7693a1";
var $1d6341e0cc6d26dc$export$2e2bcd8739ae039 = $1d6341e0cc6d26dc$var$node;

});

parcelRegister("2yV5V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83aab1eaf1c12eec7924b955b15ac03b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ddb0b89b9e738b0$var$_react = $1ddb0b89b9e738b0$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $1ddb0b89b9e738b0$var$_iconNew = $1ddb0b89b9e738b0$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $1ddb0b89b9e738b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-closed
 * Usage guidance:
 * Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ddb0b89b9e738b0$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $1ddb0b89b9e738b0$var$_react.default.createElement($1ddb0b89b9e738b0$var$_iconNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1ddb0b89b9e738b0$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $1ddb0b89b9e738b0$var$_default = module.exports.default = $1ddb0b89b9e738b0$var$FolderClosedIcon;

});

parcelRegister("d68Yo", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $f4e249d0f0576e45$export$fddf379e22a74b00);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $aJKBl = parcelRequire("aJKBl");

var $59lte = parcelRequire("59lte");

var $3R69k = parcelRequire("3R69k");
const $f4e249d0f0576e45$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3R69k.Wrapper), {
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)(Image, {}),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $59lte.Title), {
                    children: title
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $aJKBl.Content), {
                    children: content
                })
            ]
        })
    });

});
parcelRegister("aJKBl", function(module, exports) {
$parcel$export(module.exports, "Content", () => $fb0cea561176cd7b$export$7c6e2c02157bb7d2);
parcelRequire("fc4bM");

var $5XxJg = parcelRequire("5XxJg");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $fb0cea561176cd7b$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1nenibz0"
})({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $2np0Z.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5XxJg.primaryTextColour)
});

});
parcelRegister("5XxJg", function(module, exports) {
$parcel$export(module.exports, "primaryTextColour", () => $a48db32d6760a5b6$export$eeb0307e2964e28d);
const $a48db32d6760a5b6$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

});


parcelRegister("59lte", function(module, exports) {
$parcel$export(module.exports, "Title", () => $09b28e558d96102c$export$f99233281efd08a0);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");


// // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $09b28e558d96102c$var$TitleContainerStyles = (0, $kig2V.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $09b28e558d96102c$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        xcss: $09b28e558d96102c$var$TitleContainerStyles,
        children: children
    });
};

});

parcelRegister("3R69k", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $ac14e55a3cc13d31$export$e6dfd72ab29f8598);
parcelRequire("fc4bM");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $ac14e55a3cc13d31$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1pv7r8x0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $2np0Z.grid).twice().px
});

});


parcelRegister("5pB2s", function(module, exports) {
$parcel$export(module.exports, "ResultContainer", () => $8ac096e8db12afd7$export$ab35601bed9ca017);
parcelRequire("fc4bM");

var $3E7Rl = parcelRequire("3E7Rl");
function $8ac096e8db12afd7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ac096e8db12afd7$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "eqbbglm0"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});

});

parcelRegister("bFHiR", function(module, exports) {
$parcel$export(module.exports, "SearchDialogContent", () => $1316edf883999686$export$c9e0e8491f083dd5);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2np0Z = parcelRequire("2np0Z");

var $hxM92 = parcelRequire("hxM92");

var $wFLxS = parcelRequire("wFLxS");

var $3E7Rl = parcelRequire("3E7Rl");



var $5pB2s = parcelRequire("5pB2s");


const $1316edf883999686$var$SIDEBAR_PANE_WIDTH = 272;
const $1316edf883999686$var$resultContainerVerticalPadding = 8;
const $1316edf883999686$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "ee3sr7s1"
})("flex:0 1 auto;width:", $1316edf883999686$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $2np0Z.dialogPageTakeoverWidth), "px){display:none;}");
const $1316edf883999686$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hxM92.SidebarContainerBorder), {}),
            /*#__PURE__*/ (0, $3LM7S.jsx)($1316edf883999686$export$6b8430dd9f61a5c7, {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $wFLxS.SidebarScrollContainer), {
                    children: children
                })
            })
        ]
    });
const $1316edf883999686$var$totalDialogHeightPx = 776 + $1316edf883999686$var$resultContainerVerticalPadding * 2;
const $1316edf883999686$var$footerHeight = 48;
const $1316edf883999686$var$belowDialogSpace = 224;
const $1316edf883999686$var$aiFullDialogPromptHeight = 64;
const $1316edf883999686$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "ee3sr7s0"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$1316edf883999686$var$belowDialogSpace - $1316edf883999686$var$footerHeight + (props.showAtlassianHomeSearchLink ? $1316edf883999686$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $1316edf883999686$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $1316edf883999686$var$totalDialogHeightPx + $1316edf883999686$var$belowDialogSpace, "px){max-height:", (props)=>`${$1316edf883999686$var$totalDialogHeightPx - $1316edf883999686$var$footerHeight - (props.aiSearchFullDialogEnabled ? $1316edf883999686$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $2np0Z.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");

});
parcelRegister("hxM92", function(module, exports) {
$parcel$export(module.exports, "SidebarContainerBorder", () => $cfe41511a5230150$export$33eeaf745b96a17f);
parcelRequire("fc4bM");

var $3E7Rl = parcelRequire("3E7Rl");
const $cfe41511a5230150$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1vcw7g0"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});

});

parcelRegister("wFLxS", function(module, exports) {
$parcel$export(module.exports, "SidebarScrollContainer", () => $d51398b96fc7c9ec$export$34a31057caff1acb);
parcelRequire("fc4bM");

var $3E7Rl = parcelRequire("3E7Rl");
const $d51398b96fc7c9ec$export$34a31057caff1acb = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e18m3bbr0"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});

});


parcelRegister("2f8np", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $f0365355f8c1b5f5$export$a2def421b23768aa);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3JrP3 = parcelRequire("3JrP3");

var $bL2lB = parcelRequire("bL2lB");

var $koWCE = parcelRequire("koWCE");
const $f0365355f8c1b5f5$export$a2def421b23768aa = (props)=>{
    const ResultContentComponent = props.isQuickFind ? (0, $bL2lB.EnlargedSearchResultContent) : (0, $3JrP3.SearchResultContent);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $koWCE.SearchResultLink), {
        ...props,
        children: (isKeyboardHighlighted)=>/*#__PURE__*/ (0, $3LM7S.jsx)(ResultContentComponent, {
                ...props,
                isKeyboardHighlighted: isKeyboardHighlighted
            })
    });
};

});
parcelRegister("3JrP3", function(module, exports) {
$parcel$export(module.exports, "SearchResultContent", () => $93769e0886ef64c7$export$b5fd7d6305bfbd3e);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9THTp = parcelRequire("9THTp");

var $c6gb7 = parcelRequire("c6gb7");

var $6xxfq = parcelRequire("6xxfq");

var $4S9fL = parcelRequire("4S9fL");

var $7t6oC = parcelRequire("7t6oC");

var $ipx2x = parcelRequire("ipx2x");

var $9gUT1 = parcelRequire("9gUT1");

var $c4BZt = parcelRequire("c4BZt");

var $8yXjO = parcelRequire("8yXjO");

var $9w4uU = parcelRequire("9w4uU");
const $93769e0886ef64c7$export$595b9d59c3d65270 = '@@@hl@@@';
const $93769e0886ef64c7$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $93769e0886ef64c7$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $c4BZt.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $93769e0886ef64c7$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $93769e0886ef64c7$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $c6gb7.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $8yXjO.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $93769e0886ef64c7$var$getResultLabel(label),
                            $93769e0886ef64c7$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $4S9fL.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6xxfq.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7t6oC.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6xxfq.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $8yXjO.ResultTitleContainer), {
                        children: [
                            $93769e0886ef64c7$var$getResultLabel(label),
                            $93769e0886ef64c7$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9gUT1.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9gUT1.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    (0, $fc4bM.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $9w4uU.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ipx2x.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9w4uU.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9THTp.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};

});
parcelRegister("9THTp", function(module, exports) {
$parcel$export(module.exports, "ReturnIcon", () => $eadaa6ea25540a88$export$d6c38c54dfb7c9d5);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $eadaa6ea25540a88$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? "var(--ds-background-neutral-bold, #292A2E)" : "var(--ds-background-neutral, #0515240F)",
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                    fill: inverted ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)",
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });

});

parcelRegister("c6gb7", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $4233be8d9849d5db$export$ee32d1086c278cfc);

var $3E7Rl = parcelRequire("3E7Rl");
function $4233be8d9849d5db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4233be8d9849d5db$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1oz9dht0"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});

});

parcelRegister("6xxfq", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultDetail", () => $96fcbe3b4cd3c936$export$addf7aa0f753bbe8);

var $azcry = parcelRequire("azcry");

var $bltmu = parcelRequire("bltmu");

var $3E7Rl = parcelRequire("3E7Rl");
const $96fcbe3b4cd3c936$export$addf7aa0f753bbe8 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1kgzlm60"
})((0, $bltmu.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $azcry.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});

});
parcelRegister("azcry", function(module, exports) {
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $e8724c26f2bedf82$export$7168c0a11fb9ab29);
const $e8724c26f2bedf82$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

});

parcelRegister("bltmu", function(module, exports) {
$parcel$export(module.exports, "nowrapEllipsis", () => $ba1a938a6c939454$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $ba1a938a6c939454$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ba1a938a6c939454$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});


parcelRegister("4S9fL", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $6bcdb2827da8073e$export$43a2b5c94cb85d9c);

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $6bcdb2827da8073e$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "ehiioj40"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2np0Z.grid).multiple(54).px
});

});

parcelRegister("7t6oC", function(module, exports) {
$parcel$export(module.exports, "DetailsSeparator", () => $0436f0676299dfb0$export$35507434feaa4496);

var $azcry = parcelRequire("azcry");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $0436f0676299dfb0$export$35507434feaa4496 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e18eh42m0"
})({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $azcry.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2np0Z.grid).px}`
});

});

parcelRegister("ipx2x", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $7da55170c0c2c58b$export$8f314e512d92575f);

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $7da55170c0c2c58b$export$8f314e512d92575f = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "eymydq50"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2np0Z.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2np0Z.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $2np0Z.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2np0Z.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("9gUT1", function(module, exports) {
$parcel$export(module.exports, "ResultDetail", () => $ab388cecb45cea6a$export$b695f824f00c1cb0);

var $azcry = parcelRequire("azcry");

var $bltmu = parcelRequire("bltmu");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $ab388cecb45cea6a$export$b695f824f00c1cb0 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "euh103z0"
})((0, $bltmu.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $azcry.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2np0Z.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2np0Z.grid).multiple(19).px
});

});

parcelRegister("c4BZt", function(module, exports) {
$parcel$export(module.exports, "ResultLabel", () => $d8eb2ba853e739db$export$a999164f6ebc756c);

var $bltmu = parcelRequire("bltmu");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $d8eb2ba853e739db$export$a999164f6ebc756c = /*#__PURE__*/ (0, $3E7Rl.default)("span", {
    target: "e1rd3aa10"
})((0, $bltmu.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #505258)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2np0Z.grid).px
});

});

parcelRegister("8yXjO", function(module, exports) {
$parcel$export(module.exports, "ResultTitleContainer", () => $3da4c90ddd86b88e$export$9c613d6c52df949a);

var $bltmu = parcelRequire("bltmu");

var $5XxJg = parcelRequire("5XxJg");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $3da4c90ddd86b88e$export$9c613d6c52df949a = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "eiapvw30"
})((0, $bltmu.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $2np0Z.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $5XxJg.primaryTextColour), ";@media screen and (max-width: ", (0, $2np0Z.dialogPageTakeoverWidth), "px){width:100%;}");

});

parcelRegister("9w4uU", function(module, exports) {
$parcel$export(module.exports, "ResultContentWrapper", () => $74472f5a210c9a06$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $74472f5a210c9a06$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $74472f5a210c9a06$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $74472f5a210c9a06$export$cc248e72bc9d7b85);

var $gR2Dm = parcelRequire("gR2Dm");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");


















function $74472f5a210c9a06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $74472f5a210c9a06$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e8crcwv4"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2np0Z.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $2np0Z.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $gR2Dm.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $gR2Dm.itemHighlightColor)
        }
    }));
const $74472f5a210c9a06$export$e10965f6350456f8 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e8crcwv3"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-radius-medium, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $gR2Dm.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $gR2Dm.itemHighlightColor)
        }
    }));
const $74472f5a210c9a06$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e8crcwv2"
})((props)=>({
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $2np0Z.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $2np0Z.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2np0Z.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $2np0Z.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $2np0Z.grid).px : (0, $2np0Z.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $74472f5a210c9a06$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e8crcwv1"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $74472f5a210c9a06$export$d84276b3ae03593f = /*#__PURE__*/ (0, $3E7Rl.default)($74472f5a210c9a06$export$b7244afbfdf4cb9a, {
    target: "e8crcwv0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2np0Z.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $2np0Z.grid).multiple(2.5).px,
    opacity: 1
});

});
parcelRegister("gR2Dm", function(module, exports) {
$parcel$export(module.exports, "itemHighlightColor", () => $f73fe3f641c4c436$export$4ac85ff259fe4fce);
const $f73fe3f641c4c436$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

});



parcelRegister("bL2lB", function(module, exports) {
$parcel$export(module.exports, "EnlargedSearchResultContent", () => $bd4f5aa327724d64$export$171a2a7e5a778acc);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $fRCnG = parcelRequire("fRCnG");

var $f7q11 = parcelRequire("f7q11");

var $8900c = parcelRequire("8900c");

var $27o55 = parcelRequire("27o55");

var $k7XYs = parcelRequire("k7XYs");

var $c6gb7 = parcelRequire("c6gb7");

var $lQ9C5 = parcelRequire("lQ9C5");

var $3arOI = parcelRequire("3arOI");

var $du1WL = parcelRequire("du1WL");

var $apHEX = parcelRequire("apHEX");

var $eis9l = parcelRequire("eis9l");

var $c4BZt = parcelRequire("c4BZt");

var $9w4uU = parcelRequire("9w4uU");
const $bd4f5aa327724d64$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $fc4bM.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $fc4bM.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $fc4bM.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $fc4bM.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $9w4uU.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $du1WL.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $c6gb7.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $eis9l.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
                                children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $f7q11.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $c4BZt.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3arOI.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lQ9C5.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $apHEX.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9w4uU.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $27o55.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9w4uU.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                    icon: (0, $8900c.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fd880.default), {
                        ...(0, $k7XYs.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};

});
parcelRegister("f7q11", function(module, exports) {
$parcel$export(module.exports, "enrichResultTitle", () => $f5e1b82eb8bc5d6b$export$c43ff622b37ceaa9);

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $f5e1b82eb8bc5d6b$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $f5e1b82eb8bc5d6b$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $f5e1b82eb8bc5d6b$var$highlightMarkerRE = new RegExp(`${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_START_TAG}|${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_END_TAG}`, 'g');
const $f5e1b82eb8bc5d6b$export$8ebd5c051fe06ad1 = (text)=>text.replace($f5e1b82eb8bc5d6b$var$highlightMarkerRE, '');
const $f5e1b82eb8bc5d6b$var$highlightRE = new RegExp(`${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_START_TAG}(.*?)${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_END_TAG}.*`);
const $f5e1b82eb8bc5d6b$var$openingTagRE = new RegExp(`(.*?)${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_START_TAG}`);
const $f5e1b82eb8bc5d6b$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($f5e1b82eb8bc5d6b$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($f5e1b82eb8bc5d6b$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($f5e1b82eb8bc5d6b$var$highlightRE) || [];
        title = title.replace(`${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_START_TAG}${highlightText}${$f5e1b82eb8bc5d6b$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};

});

parcelRegister("8900c", function(module, exports) {
$parcel$export(module.exports, "RemoveIcon", () => $6f2f4a6fc02017bc$export$6382847193091a26);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $6f2f4a6fc02017bc$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #292A2E)"
        })
    });

});

parcelRegister("27o55", function(module, exports) {
$parcel$export(module.exports, "SquareReturnIcon", () => $2e71ed7501409cae$export$4501fc029b186da8);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $2e71ed7501409cae$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $3LM7S.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: "var(--ds-background-neutral, #0515240F)"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: "var(--ds-icon-subtle, #505258)"
            })
        ]
    });

});

parcelRegister("k7XYs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $68bb1fb187e13e71$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $68bb1fb187e13e71$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    remove_button_label: {
        id: 'search_dialog.results.remove_button_label',
        defaultMessage: 'Remove this.',
        description: 'Label of the button that has remove function and appearance.'
    }
});

});

parcelRegister("lQ9C5", function(module, exports) {
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $16cc980be9dbd9fe$export$a44951d703db9a17);

var $azcry = parcelRequire("azcry");

var $bltmu = parcelRequire("bltmu");

var $3E7Rl = parcelRequire("3E7Rl");
const $16cc980be9dbd9fe$export$a44951d703db9a17 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1a0jgbt0"
})((0, $bltmu.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $azcry.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});

});

parcelRegister("3arOI", function(module, exports) {
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $aee55f7eb50c070b$export$2dfb537c5a7f8cc3);

var $3E7Rl = parcelRequire("3E7Rl");
function $aee55f7eb50c070b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aee55f7eb50c070b$export$2dfb537c5a7f8cc3 = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "e1ilyjzy0"
})({
    name: "uy5e1i",
    styles: "display:flex;width:90%"
});

});

parcelRegister("du1WL", function(module, exports) {
$parcel$export(module.exports, "EnlargedIconContainer", () => $06eb1a7f25768655$export$ca5c00fa71c2e27e);

var $3E7Rl = parcelRequire("3E7Rl");
const $06eb1a7f25768655$export$ca5c00fa71c2e27e = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "ej3qn9h0"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("apHEX", function(module, exports) {
$parcel$export(module.exports, "EnlargedResultDetail", () => $6aaa8aa00ec603f9$export$c8ec38cc79b76eaa);

var $azcry = parcelRequire("azcry");

var $bltmu = parcelRequire("bltmu");

var $3E7Rl = parcelRequire("3E7Rl");
const $6aaa8aa00ec603f9$export$c8ec38cc79b76eaa = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "ei2t34t0"
})((0, $bltmu.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $azcry.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});

});

parcelRegister("eis9l", function(module, exports) {
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $f290cbb1bef7967f$export$e97ece467686c93c);

var $bltmu = parcelRequire("bltmu");

var $5XxJg = parcelRequire("5XxJg");

var $2np0Z = parcelRequire("2np0Z");

var $3E7Rl = parcelRequire("3E7Rl");
const $f290cbb1bef7967f$export$e97ece467686c93c = /*#__PURE__*/ (0, $3E7Rl.default)("div", {
    target: "efsee9j0"
})((0, $bltmu.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $5XxJg.primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, $2np0Z.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");

});


parcelRegister("koWCE", function(module, exports) {
$parcel$export(module.exports, "SearchResultLink", () => $2a3c69427b3522ab$export$76cc11d043a1381);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2GyjI = parcelRequire("2GyjI");

var $3iCDn = parcelRequire("3iCDn");
const $2a3c69427b3522ab$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $3iCDn.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2GyjI.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};

});
parcelRegister("2GyjI", function(module, exports) {
$parcel$export(module.exports, "ResultLink", () => $1deb47cc52327353$export$d0a8235d2583609);

var $5XxJg = parcelRequire("5XxJg");

var $jdIMO = parcelRequire("jdIMO");

var $46nJQ = parcelRequire("46nJQ");

var $3E7Rl = parcelRequire("3E7Rl");
const $1deb47cc52327353$export$d0a8235d2583609 = /*#__PURE__*/ (0, $3E7Rl.default)((0, $jdIMO.Link), {
    target: "e1xrnjlr0"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5XxJg.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $5XxJg.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $5XxJg.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $46nJQ.visitedLinkColor)
        }
    }
});

});
parcelRegister("jdIMO", function(module, exports) {
$parcel$export(module.exports, "Link", () => $67574dc67a8ed8ba$export$a6c7ac8248d6e38a);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $67574dc67a8ed8ba$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        ...props
    });
};

});

parcelRegister("46nJQ", function(module, exports) {
$parcel$export(module.exports, "visitedLinkColor", () => $4858fe32d8b2a3d9$export$271fb8b1437b1d62);
const $4858fe32d8b2a3d9$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

});


parcelRegister("3iCDn", function(module, exports) {
$parcel$export(module.exports, "useKeyboardHighlighting", () => $5a4b9a55dc84e6bc$export$9803d460130e453);

var $fc4bM = parcelRequire("fc4bM");

var $gpdro = parcelRequire("gpdro");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $5a4b9a55dc84e6bc$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && (_clickTarget$firstEle = clickTarget.firstElementChild) !== null && _clickTarget$firstEle !== void 0 && _clickTarget$firstEle.click){
            var _clickTarget$firstEle;
            clickTarget = clickTarget.firstElementChild;
        }
        clickTarget.click();
    }
};
const $5a4b9a55dc84e6bc$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $gpdro.useKeyboardNavigation)({
        onKeydownCallback: $5a4b9a55dc84e6bc$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $fc4bM.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $fc4bM.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted === null || onHighlighted === void 0 || onHighlighted();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});



parcelRegister("esfUw", function(module, exports) {
$parcel$export(module.exports, "useArticleSearch", () => $d07b9638e652ae09$export$f4258d6b7c4900b8);

var $fc4bM = parcelRequire("fc4bM");
const $d07b9638e652ae09$var$MIN_INPUT_CHAR_LENGTH = 1;
const $d07b9638e652ae09$export$f4258d6b7c4900b8 = (searchResponse, queryWord)=>{
    var _searchResponse$helpO3;
    const entities = (0, $fc4bM.useMemo)(()=>{
        var _searchResponse$helpO;
        return (searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.edges) || [];
    }, [
        searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.helpObjectStore_searchArticlesForSupportSite
    ]);
    const hasQueryError = Boolean(entities.find((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.message;
    }));
    const articlesAndFolders = (0, $fc4bM.useMemo)(()=>{
        var _searchResponse$helpO2;
        const edges = (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.edges;
        if (edges) {
            const resultItems = edges.map(({ node: node })=>{
                const { id: id, title: title, contentType: contentType, urlInfo: urlInfo } = node;
                if (id && title && contentType && urlInfo !== null && urlInfo !== void 0 && urlInfo.shareUrl) return {
                    id: id,
                    title: title,
                    type: contentType.toString(),
                    url: urlInfo.shareUrl
                };
                return null;
            }).filter((item)=>item !== null);
            return resultItems;
        }
        return undefined;
    }, [
        (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.edges
    ]);
    if (queryWord.length < $d07b9638e652ae09$var$MIN_INPUT_CHAR_LENGTH) return {
        articlesAndFolders: undefined,
        hasQueryError: false
    };
    return {
        articlesAndFolders: articlesAndFolders,
        hasQueryError: hasQueryError
    };
};

});

parcelRegister("jTfHh", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $deddf35b100e09be$export$e2e108cbe2e4f865);
var $deddf35b100e09be$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "PAGE";
    ContentType["FOLDER"] = "FOLDER";
    return ContentType;
}({});

});

parcelRegister("6ZeA9", function(module, exports) {
$parcel$export(module.exports, "SearchErrorImage", () => $f31b74459a09d2fd$export$d689645a972509c2);

var $fc4bM = parcelRequire("fc4bM");
const $f31b74459a09d2fd$export$d689645a972509c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("svg", {
        width: "61",
        height: "82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: ".01",
        d: "M0 0h61v82H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M42.676 60.465 39.8 57.71l-3.867 3.956 2.874 2.755a5.347 5.347 0 0 1 1.492 2.58 5.348 5.348 0 0 0 1.492 2.582l11.66 11.176a4.484 4.484 0 0 0 6.294-.102 4.377 4.377 0 0 0-.102-6.232l-11.66-11.176a5.412 5.412 0 0 0-2.654-1.394 5.377 5.377 0 0 1-2.654-1.39z",
        fill: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M45.213 61.83a5.409 5.409 0 0 1-2.537-1.365l-.876-.839a2.804 2.804 0 0 0-3.934.062 2.737 2.737 0 0 0 .062 3.895l.876.838a5.334 5.334 0 0 1 1.46 2.461 23.389 23.389 0 0 0 4.95-5.053z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M23.633 69.38c-6.214.097-12.095-2.204-16.56-6.483-9.218-8.832-9.456-23.441-.536-32.567 4.323-4.42 10.126-6.91 16.34-7.009 6.215-.098 12.096 2.203 16.561 6.483 4.466 4.28 6.981 10.025 7.08 16.174.1 6.149-2.225 11.975-6.548 16.396-4.322 4.417-10.126 6.907-16.337 7.005zm-.667-40.563c-4.73.076-9.148 1.97-12.44 5.336-6.794 6.947-6.61 18.072.407 24.798 3.399 3.26 7.879 5.01 12.608 4.937 4.73-.077 9.148-1.971 12.44-5.336s5.06-7.8 4.983-12.483c-.077-4.682-1.991-9.056-5.39-12.316-3.398-3.26-7.875-5.012-12.608-4.936z",
        fill: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m31.78 40.93-2.384-2.317a1.04 1.04 0 0 0-1.466.015l-4.55 4.588-4.634-4.505a1.04 1.04 0 0 0-1.467.015l-2.339 2.36a1.016 1.016 0 0 0 .015 1.451l4.634 4.505-4.55 4.588a1.016 1.016 0 0 0 .015 1.452l2.383 2.316c.41.399 1.067.391 1.466-.015l4.55-4.588 4.635 4.505c.41.399 1.066.392 1.466-.015l2.34-2.36a1.016 1.016 0 0 0-.015-1.451l-4.638-4.505 4.55-4.588c.403-.403.4-1.053-.012-1.452zM26.075 10.073 22.555.156c-.08-.232-.421-.192-.45.05L20.967 9.82l-2.244-.262a.23.23 0 0 0-.246.305l3.52 9.917c.08.232.421.192.45-.051l1.137-9.612 2.244.261c.169.022.3-.145.246-.304zM14.999 16.374l-4.374-2.958c-.092-.062-.202.04-.147.134l2.405 4.185-.982.555a.1.1 0 0 0-.008.171l4.374 2.958c.092.062.202-.04.147-.134L14.01 17.1l.982-.556a.1.1 0 0 0 .008-.17z",
        fill: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M30.804 21.245a.363.363 0 0 1-.36-.443c-.09-.196-.754-.599-1.158-.842-.909-.552-1.693-1.027-1.48-1.655.212-.632 1.128-.54 2.188-.44.429.044 1.122.11 1.379.04-.165-.21-.756-.566-1.126-.79-.91-.552-1.694-1.024-1.481-1.656.213-.631 1.13-.54 2.189-.439.429.043 1.118.109 1.378.04-.165-.21-.755-.566-1.125-.791-.91-.552-1.694-1.024-1.482-1.656.213-.627 1.13-.54 2.19-.439.469.044 1.242.12 1.436.018a.367.367 0 0 1 .451-.192c.191.065.297.269.231.461-.212.628-1.129.54-2.188.436-.43-.044-1.122-.11-1.379-.04.165.21.755.566 1.126.79.909.553 1.693 1.024 1.48 1.656-.212.628-1.128.54-2.188.44-.429-.044-1.122-.11-1.379-.04.165.21.756.566 1.126.79.91.552 1.694 1.024 1.481 1.656-.212.631-1.13.54-2.189.439-.429-.044-1.122-.109-1.378-.04.165.21.755.57 1.125.791.91.552 1.694 1.028 1.482 1.656a.368.368 0 0 1-.349.25zM35.996 23.104a.361.361 0 0 1-.32-.186c-.403-.704-.857-1.502-.373-1.953.488-.45 1.265.059 2.09.6.348.228.909.595 1.158.645-.033-.246-.366-.827-.572-1.186-.487-.85-.95-1.652-.462-2.106.488-.45 1.265.058 2.09.6.374.246.994.649 1.206.649h.004a.37.37 0 0 1 .491.04.356.356 0 0 1-.018.512c-.488.453-1.265-.058-2.09-.6-.348-.228-.91-.595-1.158-.645.033.247.366.827.572 1.187.487.849.95 1.651.462 2.105-.488.45-1.265-.058-2.09-.599-.349-.229-.91-.595-1.155-.646.033.247.366.831.484 1.034a.36.36 0 0 1-.14.494.299.299 0 0 1-.18.055zM8.971 24.537c-.029 0-.055 0-.084-.003-.663-.08-.766-.999-.876-1.968-.048-.41-.121-1.074-.242-1.292-.172.185-.407.81-.55 1.198-.345.918-.675 1.782-1.33 1.702-.665-.08-.767-.998-.88-1.967-.052-.443-.136-1.18-.272-1.336a.365.365 0 0 1-.286-.4.366.366 0 0 1 .407-.315c.663.08.766.998.88 1.971.047.41.12 1.074.245 1.292.173-.185.407-.81.55-1.198.345-.914.671-1.774 1.331-1.702.664.08.766.998.88 1.971.048.41.121 1.07.242 1.292.169-.185.407-.813.491-1.034a.369.369 0 0 1 .473-.214c.191.069.286.28.217.468-.286.719-.594 1.535-1.196 1.535z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "a",
        x1: "45.58",
        y1: "73.338",
        x2: "51.997",
        y2: "66.855",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-icon-subtle, #505258)",
        stopOpacity: ".5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "b",
        x1: "6.803",
        y1: "62.638",
        x2: "39.376",
        y2: "29.737",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: ".557",
        stopColor: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: ".966",
        stopColor: "var(--ds-icon-subtle, #505258)",
        stopOpacity: ".5"
    }))));

});

parcelRegister("4KHuY", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7f63fad03642bb28$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $7f63fad03642bb28$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.article-search-component.empty-title',
        defaultMessage: "We couldn\u2019t find a match for your search",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    emptyStateDescription: {
        id: 'company-hub.article-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    },
    errorTitle: {
        id: 'company-hub.article-search-component.error-title',
        defaultMessage: "We\u2019re having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    errorDescription: {
        id: 'company-hub.article-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    }
});

});


parcelRegister("45QqP", function(module, exports) {
$parcel$export(module.exports, "SearchSkeletons", () => $1fef3dffb24115a6$export$d660f580aff4b70c);

var $fc4bM = parcelRequire("fc4bM");

var $3vLS5 = parcelRequire("3vLS5");
const $1fef3dffb24115a6$export$d660f580aff4b70c = ({ count: count = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3vLS5.RowSkeleton), {
            key: index
        })));
};

});
parcelRegister("3vLS5", function(module, exports) {
$parcel$export(module.exports, "RowSkeleton", () => $f957f36a6c345994$export$94071f5afde0c224);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $f957f36a6c345994$var$styles = {
    rowWithDescription: "_2rko1mok _1bsb1ns9 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1e0c11p5 _gy1pu2gc _yv0e5bpd _1lmc1hhf _4cvr1h6o _4t3i12am",
    icon: "_nd5l2ec4 _2rkolb4i _bfhki8nm _1bsb1tcg _4t3i1tcg",
    title: "_nd5l1cy2 _2rkolb4i _bfhki8nm _1bsbgx0z _4t3idlk8",
    description: "_nd5ltgt2 _2rkolb4i _bfhki8nm _1bsb1w81 _4t3i19bv"
};
const $f957f36a6c345994$export$94071f5afde0c224 = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $f957f36a6c345994$var$styles.rowWithDescription
    }, /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $f957f36a6c345994$var$styles.icon
    }), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $f957f36a6c345994$var$styles.title
    }), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $f957f36a6c345994$var$styles.description
    }));
};

});



parcelRegister("5JxdW", function(module, exports) {
$parcel$export(module.exports, "SearchTextField", () => $4483ef316e9be3f3$export$fb8d8fbc0c4c1705);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("7UQvt");
var $ld4e0 = parcelRequire("ld4e0");
var $hT5G8 = parcelRequire("hT5G8");

var $fRCnG = parcelRequire("fRCnG");

var $4Cnkn = parcelRequire("4Cnkn");

var $gV8E5 = parcelRequire("gV8E5");

var $8K7DG = parcelRequire("8K7DG");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $k8Adr = parcelRequire("k8Adr");

var $aEtFp = parcelRequire("aEtFp");

var $dVxDa = parcelRequire("dVxDa");

var $27o55 = parcelRequire("27o55");

var $3snj8 = parcelRequire("3snj8");
const $4483ef316e9be3f3$var$cssOverrideWrapperStyles = null;
const $4483ef316e9be3f3$var$styles = {
    wrapper: "_1bsb1kdj",
    responsiveWrapper: "_p12f1osq",
    searchIcon: "_1ul91ns9 _1tke1ns9 _18u0u2gc _1e0c1txw _1bah1h6o _4cvr1h6o",
    clearIcon: "_2hwxu2gc",
    searchEnterHint: "_2hwxutpp _1o9zidpf _o5721q9c _1e0c1txw _4cvr1h6o",
    searchEnterHintIcon: "_1e0c1txw _4cvr1h6o _1bah1h6o _t9ecdfmd"
};
const $4483ef316e9be3f3$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    var _routerState$location;
    const { isReadOnly: isReadOnly, onInput: onInput, placeholderText: placeholderText, queryWord: queryWord, searchBasePath: searchBasePath, showSearchEnterHint: showSearchEnterHint = false } = props;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push } = (0, $hT5G8.useRouterActions)();
    const [routerState] = (0, $ld4e0.useRouter)();
    const searchEnterHintDescriptionId = (0, $fc4bM.useId)();
    const handleChange = (e)=>{
        const value = e.currentTarget.value;
        onInput(value);
    };
    const handleKeyDown = (0, $fc4bM.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            if (showSearchEnterHint && queryWord.trim().length === 0) return;
            const currentPath = searchBasePath || routerState.location.pathname;
            const updatedPathIfHasMissingTrailingSlash = currentPath.endsWith('/') ? currentPath : `${currentPath}/`;
            push(`${updatedPathIfHasMissingTrailingSlash}articles/search?q=${encodeURIComponent(queryWord)}`);
        }
    }, [
        searchBasePath,
        routerState === null || routerState === void 0 || (_routerState$location = routerState.location) === null || _routerState$location === void 0 ? void 0 : _routerState$location.pathname,
        queryWord,
        push,
        showSearchEnterHint
    ]);
    const handleClear = (0, $fc4bM.useCallback)(()=>{
        onInput('');
    }, [
        onInput
    ]);
    const isHintVisible = showSearchEnterHint && queryWord.trim().length > 0;
    const trailingElement = (0, $fc4bM.useMemo)(()=>{
        if (isHintVisible) return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: $4483ef316e9be3f3$var$styles.searchEnterHint,
            testId: "search-enter-hint"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $dVxDa.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
            id: searchEnterHintDescriptionId
        }, formatMessage((0, $3snj8.messages).searchHintDescription))), /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
            color: "color.text.subtle",
            size: "small"
        }, formatMessage((0, $3snj8.messages).searchHint)), /*#__PURE__*/ $fc4bM.createElement("span", {
            "aria-hidden": "true",
            className: (0, $2R2iS.default)([
                $4483ef316e9be3f3$var$styles.searchEnterHintIcon
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, $27o55.SquareReturnIcon), null))));
        if (queryWord) return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: $4483ef316e9be3f3$var$styles.clearIcon
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fRCnG.default), {
            icon: (iconProps)=>/*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                    ...iconProps,
                    color: "currentColor",
                    label: ""
                }),
            spacing: "compact",
            onClick: handleClear,
            label: "",
            appearance: "subtle"
        }));
        return null;
    }, [
        formatMessage,
        handleClear,
        isHintVisible,
        queryWord,
        searchEnterHintDescriptionId
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        ref: ref,
        xcss: (0, $4Cnkn.cx)($4483ef316e9be3f3$var$styles.wrapper, (0, $dRkX9.fg)('hubs_jsm_max_width_appearance') && $4483ef316e9be3f3$var$styles.responsiveWrapper)
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_dhd01mok _1227e4h9"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $aEtFp.default), {
        ref: props.keyboardRef,
        id: "article-search-query-input",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        isReadOnly: isReadOnly,
        placeholder: placeholderText ?? formatMessage((0, $3snj8.messages).defaultPlaceholder),
        value: queryWord,
        "aria-describedby": isHintVisible ? searchEnterHintDescriptionId : undefined,
        elemBeforeInput: /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: $4483ef316e9be3f3$var$styles.searchIcon
        }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })),
        elemAfterInput: trailingElement
    })));
});

});
parcelRegister("7UQvt", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("ld4e0")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("hT5G8")).useRouterActions);

parcelRequire("iBTaM");
var $ld4e0 = parcelRequire("ld4e0");
var $hT5G8 = parcelRequire("hT5G8");
parcelRequire("aU3Ym");
var $dZYFH = parcelRequire("dZYFH");
var $6J07H = parcelRequire("6J07H");
parcelRequire("9tZC2");
var $daIJV = parcelRequire("daIJV");
var $g85rb = parcelRequire("g85rb");
var $luSOU = parcelRequire("luSOU");
var $9tZC2 = parcelRequire("9tZC2");

var $kKYyS = parcelRequire("kKYyS");

var $fS0Ph = parcelRequire("fS0Ph");

var $6JbSK = parcelRequire("6JbSK");
parcelRequire("1L7Xm");
var $2GMXb = parcelRequire("2GMXb");
var $cTw4V = parcelRequire("cTw4V");
var $h2u6I = parcelRequire("h2u6I");

});
parcelRegister("iBTaM", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("ld4e0")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("hT5G8")).useRouterActions);

var $dUblT = parcelRequire("dUblT");

var $fkXsT = parcelRequire("fkXsT");

var $cZZg5 = parcelRequire("cZZg5");

var $2Qm2m = parcelRequire("2Qm2m");

var $fS0Ph = parcelRequire("fS0Ph");

var $9TPhT = parcelRequire("9TPhT");

var $cPpUt = parcelRequire("cPpUt");

var $ld4e0 = parcelRequire("ld4e0");

var $hT5G8 = parcelRequire("hT5G8");

var $39DAe = parcelRequire("39DAe");

});
parcelRegister("dUblT", function(module, exports) {

var $hHCeM = parcelRequire("hHCeM");

var $bD5s2 = parcelRequire("bD5s2");

var $b2AyF = parcelRequire("b2AyF");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9tZC2");
var $iXbNF = parcelRequire("iXbNF");

var $ld4e0 = parcelRequire("ld4e0");
class $a1f94fa44744d076$var$Redirector extends (0, $fc4bM.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $b2AyF.createPath)((0, $iXbNF.generateLocationFromPath)(to.path, routeAttributes)) : (0, $b2AyF.createPath)(to) : to;
        const currentPath = (0, $b2AyF.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $bD5s2.default)($a1f94fa44744d076$var$Redirector, "defaultProps", {
    push: false
});
const $a1f94fa44744d076$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $ld4e0.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a1f94fa44744d076$var$Redirector, (0, $hHCeM.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("9tZC2", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("iXbNF")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("luSOU")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("2MwOv")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("aAK7V")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("g85rb")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("g85rb")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("kffBH")).isSameRouteMatch);

var $daIJV = parcelRequire("daIJV");

var $iXbNF = parcelRequire("iXbNF");

var $luSOU = parcelRequire("luSOU");

var $2MwOv = parcelRequire("2MwOv");

var $aAK7V = parcelRequire("aAK7V");

var $g85rb = parcelRequire("g85rb");

var $kffBH = parcelRequire("kffBH");

});
parcelRegister("daIJV", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $996ee9e80aeff5cb$export$883c3f3b6c000133);

var $hHCeM = parcelRequire("hHCeM");

var $b2AyF = parcelRequire("b2AyF");

var $pkMey = parcelRequire("pkMey");

var $ip10O = parcelRequire("ip10O");
const $996ee9e80aeff5cb$var$hasWindow = ()=>typeof window !== 'undefined';
const $996ee9e80aeff5cb$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ip10O)))
};
const $996ee9e80aeff5cb$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $996ee9e80aeff5cb$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $996ee9e80aeff5cb$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($pkMey)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $996ee9e80aeff5cb$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $996ee9e80aeff5cb$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $996ee9e80aeff5cb$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $hHCeM.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $996ee9e80aeff5cb$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $996ee9e80aeff5cb$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $b2AyF.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $b2AyF.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $996ee9e80aeff5cb$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
        createHref: (location)=>(0, $b2AyF.createPath)(location)
    } : $996ee9e80aeff5cb$var$methodsPlaceholders);
};

});

parcelRegister("iXbNF", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $dcc6e3eaf21d1805$export$37e0729cc751960b);

var $aagDn = parcelRequire("aagDn");

var $5AACw = parcelRequire("5AACw");
function $dcc6e3eaf21d1805$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5AACw.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $aagDn.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("aagDn", function(module, exports) {
$parcel$export(module.exports, "compile", () => $7667bdb9e6df3707$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $7667bdb9e6df3707$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $7667bdb9e6df3707$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $7667bdb9e6df3707$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $7667bdb9e6df3707$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($7667bdb9e6df3707$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($7667bdb9e6df3707$var$escapeString(prevText), ")[^").concat($7667bdb9e6df3707$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $7667bdb9e6df3707$export$ef7acd7185315e22(str, options) {
    return $7667bdb9e6df3707$export$5b9bad9e403cf3d9($7667bdb9e6df3707$export$98e6a39c04603d36(str, options), options);
}
function $7667bdb9e6df3707$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $7667bdb9e6df3707$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $7667bdb9e6df3707$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $7667bdb9e6df3707$export$71304158c7e35877(str, keys, options);
    return $7667bdb9e6df3707$export$968e97c88708237a(re, keys, options);
}
function $7667bdb9e6df3707$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $7667bdb9e6df3707$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $7667bdb9e6df3707$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $7667bdb9e6df3707$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $7667bdb9e6df3707$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $7667bdb9e6df3707$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $7667bdb9e6df3707$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $7667bdb9e6df3707$var$stringToRegexp(path, keys, options) {
    return $7667bdb9e6df3707$export$9a9303716def6456($7667bdb9e6df3707$export$98e6a39c04603d36(path, options), keys, options);
}
function $7667bdb9e6df3707$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($7667bdb9e6df3707$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($7667bdb9e6df3707$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $7667bdb9e6df3707$var$escapeString(encode(token));
        else {
            var prefix = $7667bdb9e6df3707$var$escapeString(encode(token.prefix));
            var suffix = $7667bdb9e6df3707$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $7667bdb9e6df3707$var$flags(options));
}
function $7667bdb9e6df3707$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $7667bdb9e6df3707$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $7667bdb9e6df3707$var$arrayToRegexp(path, keys, options);
    return $7667bdb9e6df3707$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("luSOU", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $fa66ec6f6bec51cf$export$82476f982757e71e);

var $aagDn = parcelRequire("aagDn");
const $fa66ec6f6bec51cf$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $aagDn.compile)(pattern)(params);

});

parcelRegister("2MwOv", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $20698490c7e02be2$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3jCFs = parcelRequire("3jCFs");
const $20698490c7e02be2$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $20698490c7e02be2$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3jCFs !== 'undefined' && $3jCFs.versions != null && $3jCFs.versions.node != null) return true;
    if ($20698490c7e02be2$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("aAK7V", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $7b610bfadc622757$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $7b610bfadc622757$export$2e2bcd8739ae039);

var $5AACw = parcelRequire("5AACw");

var $5Qv4l = parcelRequire("5Qv4l");

var $aMTpK = parcelRequire("aMTpK");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $7b610bfadc622757$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $5AACw.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $aMTpK.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $5Qv4l.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $aMTpK.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $7b610bfadc622757$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$7b610bfadc622757$var$matchRoute(routes, pathname, queryParams, basePath);
const $7b610bfadc622757$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $7b610bfadc622757$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $7b610bfadc622757$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$7b610bfadc622757$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("5Qv4l", function(module, exports) {
$parcel$export(module.exports, "default", () => $4419e8c22515a97e$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");

var $eoJT4 = parcelRequire("eoJT4");

var $ejl2I = parcelRequire("ejl2I");
/* This should match what react-router does to compute a root match. */ const $4419e8c22515a97e$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $4419e8c22515a97e$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $eoJT4.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $4419e8c22515a97e$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $ejl2I.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $hHCeM.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $4419e8c22515a97e$export$2e2bcd8739ae039 = $4419e8c22515a97e$var$execRouteMatching;

});
parcelRegister("eoJT4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7b6e6d887dbb7fd$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $aagDn = parcelRequire("aagDn");
const $a7b6e6d887dbb7fd$var$cache = {};
const $a7b6e6d887dbb7fd$var$cacheLimit = 10000;
let $a7b6e6d887dbb7fd$var$cacheCount = 0;
function $a7b6e6d887dbb7fd$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $a7b6e6d887dbb7fd$var$cache[cacheKey] || ($a7b6e6d887dbb7fd$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $aagDn.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($a7b6e6d887dbb7fd$var$cacheCount < $a7b6e6d887dbb7fd$var$cacheLimit) {
        pathCache[path] = result;
        $a7b6e6d887dbb7fd$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $a7b6e6d887dbb7fd$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $a7b6e6d887dbb7fd$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $a7b6e6d887dbb7fd$export$2e2bcd8739ae039 = $a7b6e6d887dbb7fd$var$matchPath;

});

parcelRegister("ejl2I", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6b329b47bdecd11$export$2e2bcd8739ae039);

var $hHCeM = parcelRequire("hHCeM");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $a6b329b47bdecd11$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $hHCeM.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $a6b329b47bdecd11$export$2e2bcd8739ae039 = $a6b329b47bdecd11$var$matchQuery;

});


parcelRegister("aMTpK", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $7da95f2ec45fb9d4$export$f594abf16a5ad948);
const $7da95f2ec45fb9d4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $7da95f2ec45fb9d4$var$MAX_CACHE_SIZE = 1000;
function $7da95f2ec45fb9d4$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$7da95f2ec45fb9d4$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $7da95f2ec45fb9d4$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($7da95f2ec45fb9d4$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $7da95f2ec45fb9d4$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $7da95f2ec45fb9d4$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("g85rb", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $bbe19c7353f59c50$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $bbe19c7353f59c50$export$a0bd0313cbeabd49);

var $5AACw = parcelRequire("5AACw");

var $6JbSK = parcelRequire("6JbSK");

var $luSOU = parcelRequire("luSOU");

var $aAK7V = parcelRequire("aAK7V");
const $bbe19c7353f59c50$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $luSOU.generatePath)(route.path, params);
    const matchedRoute = (0, $aAK7V.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $6JbSK.DEFAULT_MATCH),
        query: query
    };
};
const $bbe19c7353f59c50$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $5AACw.qs).parse(search);
    const matchedRoute = (0, $aAK7V.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $6JbSK.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $6JbSK.DEFAULT_MATCH)
    };
};

});
parcelRegister("6JbSK", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $4e60298de2ae4838$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $4e60298de2ae4838$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $4e60298de2ae4838$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $4e60298de2ae4838$export$fa440ddf675c8a93);

var $ip10O = parcelRequire("ip10O");

var $daIJV = parcelRequire("daIJV");
const $4e60298de2ae4838$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $4e60298de2ae4838$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $4e60298de2ae4838$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $4e60298de2ae4838$export$39607c9878cf5148 = (0, $daIJV.createLegacyHistory)();
const $4e60298de2ae4838$export$1515254c8c90bebb = {
    location: $4e60298de2ae4838$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($ip10O)))
};
const $4e60298de2ae4838$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("kffBH", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $ebd1509f3d8c2d5f$export$5997e70fc4543270);
const $ebd1509f3d8c2d5f$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $ebd1509f3d8c2d5f$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $ebd1509f3d8c2d5f$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $ebd1509f3d8c2d5f$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("ld4e0", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $f70e16ddd1d3dd9a$export$9a302a45f65d0572);

var $fS0Ph = parcelRequire("fS0Ph");
const $f70e16ddd1d3dd9a$export$9a302a45f65d0572 = (0, $fS0Ph.useRouterStore);

});
parcelRegister("fS0Ph", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $b8dc8a2f1d127fb8$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $b8dc8a2f1d127fb8$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $b8dc8a2f1d127fb8$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $b8dc8a2f1d127fb8$export$ada49399abf7a3a1);

var $hHCeM = parcelRequire("hHCeM");

var $b2AyF = parcelRequire("b2AyF");

var $iOIqA = parcelRequire("iOIqA");
var $5nVr1 = parcelRequire("5nVr1");
var $ik3UL = parcelRequire("ik3UL");
var $ipn74 = parcelRequire("ipn74");
var $kMxBB = parcelRequire("kMxBB");

var $6JbSK = parcelRequire("6JbSK");
parcelRequire("9tZC2");
var $g85rb = parcelRequire("g85rb");
var $iXbNF = parcelRequire("iXbNF");
var $luSOU = parcelRequire("luSOU");
var $2MwOv = parcelRequire("2MwOv");
var $aAK7V = parcelRequire("aAK7V");

var $3F7eG = parcelRequire("3F7eG");
const $b8dc8a2f1d127fb8$export$36d128238e6b60f5 = {
    action: (0, $6JbSK.DEFAULT_ACTION),
    basePath: '',
    location: (0, $6JbSK.DEFAULT_HISTORY).location,
    history: (0, $6JbSK.DEFAULT_HISTORY),
    match: (0, $6JbSK.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $6JbSK.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $b8dc8a2f1d127fb8$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $g85rb.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $hHCeM.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $2MwOv.isServerEnvironment)()) dispatch($b8dc8a2f1d127fb8$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $g85rb.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $3F7eG.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iOIqA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $hHCeM.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $3F7eG.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $3F7eG.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $iXbNF.generateLocationFromPath)(route.path, (0, $hHCeM.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $aAK7V.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $3F7eG.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $3F7eG.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $iXbNF.generateLocationFromPath)(route.path, (0, $hHCeM.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $aAK7V.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $hHCeM.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $3F7eG.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $3F7eG.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $hHCeM.default)({}, existingPathParams, params);
            const updatedPath = (0, $luSOU.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $hHCeM.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $3F7eG.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $3F7eG.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $b8dc8a2f1d127fb8$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $3F7eG.isExternalAbsolutePath)(path)) {
                const location = (0, $b2AyF.parsePath)((0, $3F7eG.getRelativePath)(path, basePath));
                nextContext = (0, $g85rb.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iOIqA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $b8dc8a2f1d127fb8$export$1cf0ecab63b1963c = (0, $ipn74.createStore)({
    initialState: $b8dc8a2f1d127fb8$export$36d128238e6b60f5,
    actions: $b8dc8a2f1d127fb8$var$actions,
    name: 'router'
});
const $b8dc8a2f1d127fb8$export$d6b817abe7a77ea5 = (0, $ik3UL.createContainer)($b8dc8a2f1d127fb8$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($b8dc8a2f1d127fb8$var$actions.bootstrapStore(props));
            !(0, $2MwOv.isServerEnvironment)() && dispatch($b8dc8a2f1d127fb8$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $2MwOv.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $b8dc8a2f1d127fb8$export$9569010eab09ae9e = (0, $5nVr1.createHook)($b8dc8a2f1d127fb8$export$1cf0ecab63b1963c);
const $b8dc8a2f1d127fb8$export$ada49399abf7a3a1 = (0, $5nVr1.createActionsHook)($b8dc8a2f1d127fb8$export$1cf0ecab63b1963c);
function $b8dc8a2f1d127fb8$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $5nVr1.createHook)($b8dc8a2f1d127fb8$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $b8dc8a2f1d127fb8$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $kMxBB.defaultRegistry).getStore($b8dc8a2f1d127fb8$export$1cf0ecab63b1963c);
const $b8dc8a2f1d127fb8$export$ebf37f7e180b13a9 = ()=>$b8dc8a2f1d127fb8$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("3F7eG", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $2aaad04f24ea342d$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $2aaad04f24ea342d$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $2aaad04f24ea342d$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $2aaad04f24ea342d$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $2aaad04f24ea342d$export$c9237620ff7fdf7c);

var $5AACw = parcelRequire("5AACw");
parcelRequire("9tZC2");
var $kffBH = parcelRequire("kffBH");
const $2aaad04f24ea342d$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $2aaad04f24ea342d$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $2aaad04f24ea342d$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $2aaad04f24ea342d$var$stripTrailingSlash(prefix);
        prefix = $2aaad04f24ea342d$var$addLeadingSlash(prefix);
        path = $2aaad04f24ea342d$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $2aaad04f24ea342d$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $2aaad04f24ea342d$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$2aaad04f24ea342d$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5AACw)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5AACw)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $2aaad04f24ea342d$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$2aaad04f24ea342d$export$e83e3719fc818ee5(path)) {
        path = $2aaad04f24ea342d$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($5AACw)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $2aaad04f24ea342d$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5AACw.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $2aaad04f24ea342d$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $2aaad04f24ea342d$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $kffBH.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("fkXsT", function(module, exports) {

var $hHCeM = parcelRequire("hHCeM");

var $b2AyF = parcelRequire("b2AyF");

var $fc4bM = parcelRequire("fc4bM");

var $fS0Ph = parcelRequire("fS0Ph");
const $b2a6d9c812171890$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fS0Ph.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $b2a6d9c812171890$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $fc4bM.useMemo)(()=>(0, $b2AyF.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b2a6d9c812171890$export$55185c17a0fcbe46, (0, $hHCeM.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("cZZg5", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $hT5G8 = parcelRequire("hT5G8");
const $976ab33528fab18e$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $hT5G8.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(actions));
};
$976ab33528fab18e$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("hT5G8", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $d05bfa61a41724d0$export$402e82ff1b20594b);

var $fS0Ph = parcelRequire("fS0Ph");
const $d05bfa61a41724d0$export$402e82ff1b20594b = (0, $fS0Ph.useRouterStoreActions);

});


parcelRegister("2Qm2m", function(module, exports) {

var $1ZwRz = parcelRequire("1ZwRz");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9tZC2");
var $2MwOv = parcelRequire("2MwOv");

var $fS0Ph = parcelRequire("fS0Ph");
const $21218838041c1162$var$_excluded = [
    "listen"
];
const $21218838041c1162$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $fS0Ph.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1ZwRz.default)(_ref, $21218838041c1162$var$_excluded);
    if (!state.unlisten && !(0, $2MwOv.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(state, actions));
};

});

parcelRegister("9TPhT", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $5nVr1 = parcelRequire("5nVr1");

var $fS0Ph = parcelRequire("fS0Ph");
const $01dc254d8a6fd48f$var$createPathParamHook = (0, $5nVr1.createHook)((0, $fS0Ph.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $01dc254d8a6fd48f$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $01dc254d8a6fd48f$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $fc4bM.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("cPpUt", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $5nVr1 = parcelRequire("5nVr1");

var $fS0Ph = parcelRequire("fS0Ph");
const $956e58a19321b80e$var$createQueryParamHook = (0, $5nVr1.createHook)((0, $fS0Ph.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $956e58a19321b80e$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $956e58a19321b80e$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $fc4bM.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("39DAe", function(module, exports) {

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");

var $fS0Ph = parcelRequire("fS0Ph");
const $24c0eacd746074fd$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $24c0eacd746074fd$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $24c0eacd746074fd$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $fS0Ph.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, (0, $hHCeM.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("aU3Ym", function(module, exports) {

var $6J07H = parcelRequire("6J07H");

var $dZYFH = parcelRequire("dZYFH");

});
parcelRegister("6J07H", function(module, exports) {

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");

var $b2AyF = parcelRequire("b2AyF");

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9tZC2");
var $g85rb = parcelRequire("g85rb");
var $iXbNF = parcelRequire("iXbNF");

var $fS0Ph = parcelRequire("fS0Ph");

var $ijH3D = parcelRequire("ijH3D");
parcelRequire("ccVDh");
var $g7Z5J = parcelRequire("g7Z5J");
var $jwkmE = parcelRequire("jwkmE");
const $4e570a7cd36f24cd$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $4e570a7cd36f24cd$var$PREFETCH_DELAY = 225;
const $4e570a7cd36f24cd$var$Link = /*#__PURE__*/ (0, $fc4bM.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1ZwRz.default)(_ref, $4e570a7cd36f24cd$var$_excluded);
    const routerActions = (0, $fS0Ph.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $ijH3D.useTimeout)($4e570a7cd36f24cd$var$PREFETCH_DELAY);
    const validLinkType = (0, $g7Z5J.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $fc4bM.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $b2AyF.createPath)((0, $iXbNF.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $fc4bM.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $g85rb.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $jwkmE.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $fc4bM.createElement)(validLinkType, (0, $hHCeM.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$4e570a7cd36f24cd$var$Link.displayName = 'Link';
var $4e570a7cd36f24cd$export$2e2bcd8739ae039 = $4e570a7cd36f24cd$var$Link;

});
parcelRegister("ijH3D", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $d55b66aa714b874c$export$d8e6abf214c9ec0f);

var $fc4bM = parcelRequire("fc4bM");
const $d55b66aa714b874c$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $fc4bM.useRef)();
    const schedule = (0, $fc4bM.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $fc4bM.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("ccVDh", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("g7Z5J")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("jwkmE")).handleNavigation);

var $g7Z5J = parcelRequire("g7Z5J");

var $jwkmE = parcelRequire("jwkmE");

});
parcelRegister("g7Z5J", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $bbdcb043fe5e64dc$export$855ece989b15eb57);
const $bbdcb043fe5e64dc$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $bbdcb043fe5e64dc$export$855ece989b15eb57 = (type)=>$bbdcb043fe5e64dc$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("jwkmE", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $e360cd6fd0e145ff$export$706ad1af8096e280);

var $bpfJa = parcelRequire("bpfJa");
const $e360cd6fd0e145ff$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $bpfJa.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $bpfJa.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $bpfJa.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("bpfJa", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $84de3aaf19824c87$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $84de3aaf19824c87$export$130b789831072f4c);
const $84de3aaf19824c87$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $84de3aaf19824c87$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("dZYFH", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("iBTaM");
var $ld4e0 = parcelRequire("ld4e0");
const $a31008f40b769013$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $ld4e0.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("kKYyS", function(module, exports) {
parcelRequire("9tZC2");
var $g85rb = parcelRequire("g85rb");
const $f1c714cbe828df16$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $g85rb.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("1L7Xm", function(module, exports) {

var $3vXOH = parcelRequire("3vXOH");

var $cTw4V = parcelRequire("cTw4V");

var $h2u6I = parcelRequire("h2u6I");

var $6ZUzT = parcelRequire("6ZUzT");

var $2GMXb = parcelRequire("2GMXb");

var $3vXOH = parcelRequire("3vXOH");

var $iwH5o = parcelRequire("iwH5o");

});
parcelRegister("3vXOH", function(module, exports) {

var $2GMXb = parcelRequire("2GMXb");
parcelRequire("eZJBs");
var $jAaQQ = parcelRequire("jAaQQ");
const $28f2aab5cb734856$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $28f2aab5cb734856$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $2GMXb.getResourceStore)().actions;
    const nextResources = (0, $jAaQQ.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $28f2aab5cb734856$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $2GMXb.getResourceStore)().actions;
    const nextResources = (0, $jAaQQ.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $28f2aab5cb734856$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $2GMXb.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $28f2aab5cb734856$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $28f2aab5cb734856$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $28f2aab5cb734856$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $2GMXb.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $2GMXb.getResourceStore)().actions;
            const nextResources = (0, $jAaQQ.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $2GMXb.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("2GMXb", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $1f557a2f37b62c97$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $1f557a2f37b62c97$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $1f557a2f37b62c97$export$98e41a62c9bef75e);

var $hHCeM = parcelRequire("hHCeM");

var $1ZwRz = parcelRequire("1ZwRz");

var $5nVr1 = parcelRequire("5nVr1");
var $ik3UL = parcelRequire("ik3UL");
var $ipn74 = parcelRequire("ipn74");
var $c7ORi = parcelRequire("c7ORi");
var $kMxBB = parcelRequire("kMxBB");
parcelRequire("9tZC2");
var $2MwOv = parcelRequire("2MwOv");

var $iiRbt = parcelRequire("iiRbt");
parcelRequire("eZJBs");
var $ezPdq = parcelRequire("ezPdq");
var $jh6oa = parcelRequire("jh6oa");
var $eqUIF = parcelRequire("eqUIF");
var $kxegT = parcelRequire("kxegT");
var $lEvxf = parcelRequire("lEvxf");
var $gLiWi = parcelRequire("gLiWi");
var $j7QTA = parcelRequire("j7QTA");
var $jIIPl = parcelRequire("jIIPl");
var $zkPqV = parcelRequire("zkPqV");
var $03MKD = parcelRequire("03MKD");
var $bJL7o = parcelRequire("bJL7o");
var $fKCt5 = parcelRequire("fKCt5");
const $1f557a2f37b62c97$var$_excluded = [
    "context"
], $1f557a2f37b62c97$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $1f557a2f37b62c97$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $eqUIF.deleteResourceState)(type, key));
                dispatch((0, $ezPdq.executeForDependents)(resource, (dependentResource)=>$1f557a2f37b62c97$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $eqUIF.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1ZwRz.default)(_getState, $1f557a2f37b62c97$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $iiRbt.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $hHCeM.default)({}, prevSlice, changes, {
                expiresAt: (0, $j7QTA.getExpiresAt)(maxAge),
                accessedAt: (0, $lEvxf.getAccessedAt)()
            });
            dispatch((0, $eqUIF.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $ezPdq.executeForDependents)(resource, (dependentResource)=>$1f557a2f37b62c97$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $eqUIF.getResourceState)(type, key));
            if (cached && (0, $jIIPl.shouldUseCache)(cached)) {
                if ((0, $jIIPl.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $zkPqV.setSsrDataPromise)(cached);
                    cached = (0, $j7QTA.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $lEvxf.getAccessedAt)();
                dispatch((0, $eqUIF.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($1f557a2f37b62c97$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $eqUIF.getResourceState)(type, key)) || (0, $gLiWi.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $fKCt5.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $eqUIF.getPrefetchSlice)(type, key)) || (0, $jh6oa.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $ezPdq.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $eqUIF.setResourceState)(type, key, (0, $hHCeM.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $lEvxf.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $ezPdq.executeForDependents)(resource, (dependentResource)=>$1f557a2f37b62c97$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $03MKD.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $eqUIF.getResourceState)(type, key));
            const finalSlice = (0, $hHCeM.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $lEvxf.getAccessedAt)(),
                expiresAt: (0, $j7QTA.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $eqUIF.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $eqUIF.getPrefetchSlice)(type, key)) || (0, $jh6oa.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $ezPdq.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $eqUIF.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $ezPdq.executeForDependents)(resource, (dependentResource)=>$1f557a2f37b62c97$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $1f557a2f37b62c97$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $ezPdq.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $1f557a2f37b62c97$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $ezPdq.actionWithDependencies)(routerStoreContext.route.resources, resource, $1f557a2f37b62c97$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $ezPdq.actionWithDependencies)(routerStoreContext.route.resources, resource, $1f557a2f37b62c97$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $ezPdq.actionWithDependencies)(routerStoreContext.route.resources, resource, $1f557a2f37b62c97$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($1f557a2f37b62c97$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $eqUIF.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $eqUIF.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $2MwOv.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $ezPdq.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$1f557a2f37b62c97$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $ezPdq.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$1f557a2f37b62c97$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $hHCeM.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $bJL7o.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1ZwRz.default)(_ref, $1f557a2f37b62c97$var$_excluded2);
                const deserializedError = !error ? null : (0, $kxegT.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $hHCeM.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $bJL7o.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $kxegT.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $03MKD.TimeoutError) ? loading : false
                }))
};
const $1f557a2f37b62c97$export$94f50dade551bd01 = (0, $ipn74.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $1f557a2f37b62c97$export$e324594224ef24da,
    name: 'router-resources'
});
const $1f557a2f37b62c97$export$cc90fb9c37c5589d = (0, $ik3UL.createContainer)($1f557a2f37b62c97$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $1f557a2f37b62c97$export$fee1a6213543bd78 = (0, $c7ORi.createSubscriber)($1f557a2f37b62c97$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $iiRbt.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $1f557a2f37b62c97$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $kMxBB.defaultRegistry).getStore($1f557a2f37b62c97$export$94f50dade551bd01);
const $1f557a2f37b62c97$export$ac3608e0bb357c7 = (0, $5nVr1.createHook)($1f557a2f37b62c97$export$94f50dade551bd01, {
    selector: (0, $iiRbt.getSliceForResource)
});
const $1f557a2f37b62c97$export$98e41a62c9bef75e = (0, $5nVr1.createActionsHook)($1f557a2f37b62c97$export$94f50dade551bd01);
const $1f557a2f37b62c97$export$e59f52df235ac7b3 = (0, $5nVr1.createHook)($1f557a2f37b62c97$export$94f50dade551bd01, {
    selector: (0, $iiRbt.getResourceStoreContext)
});

});
parcelRegister("iiRbt", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $d53329a8da35fdf1$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $d53329a8da35fdf1$export$6a0b1779210de0ee);

var $hHCeM = parcelRequire("hHCeM");
parcelRequire("eZJBs");
var $gLiWi = parcelRequire("gLiWi");
const $d53329a8da35fdf1$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $hHCeM.default)({}, slice) : (0, $gLiWi.getDefaultStateSlice)();
};
const $d53329a8da35fdf1$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("eZJBs", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("lEvxf")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("jh6oa")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("ezPdq")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("ezPdq")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("ezPdq")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("ezPdq")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("j7QTA")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("j7QTA")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("gLiWi")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("jAaQQ")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("fKCt5")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("eqUIF")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("eqUIF")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("eqUIF")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("eqUIF")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("eqUIF")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("kxegT")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("kxegT")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("jIIPl")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("jIIPl")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("zkPqV")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("03MKD")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("bJL7o")).transformData);

var $lEvxf = parcelRequire("lEvxf");

var $jh6oa = parcelRequire("jh6oa");

var $jYGTh = parcelRequire("jYGTh");

var $ezPdq = parcelRequire("ezPdq");

var $j7QTA = parcelRequire("j7QTA");

var $bqX8G = parcelRequire("bqX8G");

var $gLiWi = parcelRequire("gLiWi");

var $jIjBf = parcelRequire("jIjBf");

var $jAaQQ = parcelRequire("jAaQQ");

var $fKCt5 = parcelRequire("fKCt5");

var $eqUIF = parcelRequire("eqUIF");

var $gpHdk = parcelRequire("gpHdk");

var $kxegT = parcelRequire("kxegT");

var $jIIPl = parcelRequire("jIIPl");

var $zkPqV = parcelRequire("zkPqV");

var $03MKD = parcelRequire("03MKD");

var $bJL7o = parcelRequire("bJL7o");

});
parcelRegister("lEvxf", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $fc35cba601261295$export$9ccb639b7a119f61);
const $fc35cba601261295$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("jh6oa", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $e0848f8733ba9d1e$export$dc62515c8f0b52dd);

var $hHCeM = parcelRequire("hHCeM");

var $3edsb = parcelRequire("3edsb");

var $j7QTA = parcelRequire("j7QTA");

var $bqX8G = parcelRequire("bqX8G");

var $03MKD = parcelRequire("03MKD");

var $d8buA = parcelRequire("d8buA");
function $e0848f8733ba9d1e$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $hHCeM.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $bqX8G.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $03MKD.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $j7QTA.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $3edsb.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $j7QTA.getExpiresAt)((0, $d8buA.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("3edsb", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $259d1d84479566e4$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $259d1d84479566e4$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $259d1d84479566e4$export$12c1dc38ea1692da);
const $259d1d84479566e4$export$881d135f98d8d7d0 = 100;
const $259d1d84479566e4$export$9ab5bdcb8a1d6c34 = false;
const $259d1d84479566e4$export$12c1dc38ea1692da = 0;

});

parcelRegister("j7QTA", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $dec7b3b6b6bd9eab$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $dec7b3b6b6bd9eab$export$18d1d420fd588368);

var $hHCeM = parcelRequire("hHCeM");
const $dec7b3b6b6bd9eab$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $dec7b3b6b6bd9eab$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $hHCeM.default)({}, slice, {
        expiresAt: $dec7b3b6b6bd9eab$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("bqX8G", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $852fff3688f1c44b$export$58634b3a58ae66b7);
const $852fff3688f1c44b$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("03MKD", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $00b618eb46649d8f$export$66d311bf29d5c89c);
class $00b618eb46649d8f$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("d8buA", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $98f4efe0326fa81d$export$37d3126be6549b13);
const $98f4efe0326fa81d$export$37d3126be6549b13 = 10000;

});


parcelRegister("jYGTh", function(module, exports) {

var $3edsb = parcelRequire("3edsb");
/**
 * Utility method to created async versions of getData functions
 */ const $e8b4e41ce01e0806$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $e8b4e41ce01e0806$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $e8b4e41ce01e0806$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $3edsb.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $3edsb.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $3edsb.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("ezPdq", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $a9cc0fede2829a67$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $a9cc0fede2829a67$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $a9cc0fede2829a67$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $a9cc0fede2829a67$export$75915f81f2a6540a);

var $hHCeM = parcelRequire("hHCeM");

var $gLiWi = parcelRequire("gLiWi");

var $eqUIF = parcelRequire("eqUIF");
var $a9cc0fede2829a67$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $a9cc0fede2829a67$var$fromEntries = ($a9cc0fede2829a67$var$_Object$fromEntries = Object.fromEntries) != null ? $a9cc0fede2829a67$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $a9cc0fede2829a67$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $a9cc0fede2829a67$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $a9cc0fede2829a67$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($a9cc0fede2829a67$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($a9cc0fede2829a67$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($a9cc0fede2829a67$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $a9cc0fede2829a67$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($a9cc0fede2829a67$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $a9cc0fede2829a67$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$a9cc0fede2829a67$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $a9cc0fede2829a67$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($a9cc0fede2829a67$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $a9cc0fede2829a67$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($a9cc0fede2829a67$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $a9cc0fede2829a67$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($a9cc0fede2829a67$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $a9cc0fede2829a67$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $a9cc0fede2829a67$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $a9cc0fede2829a67$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $eqUIF.getResourceState)(dependencyType, key)) || (0, $gLiWi.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $eqUIF.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $hHCeM.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("gLiWi", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $c33fba1338a6754d$export$fa8e33c3301e2e94);

var $hHCeM = parcelRequire("hHCeM");

var $lEvxf = parcelRequire("lEvxf");

var $3edsb = parcelRequire("3edsb");

var $j7QTA = parcelRequire("j7QTA");

var $drjtG = parcelRequire("drjtG");
const $c33fba1338a6754d$export$fa8e33c3301e2e94 = ()=>(0, $hHCeM.default)({}, (0, $drjtG.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $j7QTA.getExpiresAt)((0, $3edsb.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $lEvxf.getAccessedAt)()
    });

});
parcelRegister("drjtG", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $9c8ce7d6443ddaf2$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $9c8ce7d6443ddaf2$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("eqUIF", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $a81f7dae8f009937$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $a81f7dae8f009937$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $a81f7dae8f009937$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $a81f7dae8f009937$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $a81f7dae8f009937$export$d40f35dc5952864b);

var $1ZwRz = parcelRequire("1ZwRz");

var $hHCeM = parcelRequire("hHCeM");
function $a81f7dae8f009937$var$_toPropertyKey(t) {
    var i = $a81f7dae8f009937$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $a81f7dae8f009937$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $a81f7dae8f009937$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $a81f7dae8f009937$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $hHCeM.default)({}, prefetching, {
                [type]: (0, $hHCeM.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $a81f7dae8f009937$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($a81f7dae8f009937$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $hHCeM.default)({}, data, {
                [type]: (0, $hHCeM.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $a81f7dae8f009937$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $a81f7dae8f009937$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1ZwRz.default)(data, [
            type
        ].map($a81f7dae8f009937$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1ZwRz.default)(resourceForType, [
                key
            ].map($a81f7dae8f009937$var$_toPropertyKey));
            setState({
                data: (0, $hHCeM.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("jIjBf", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $e5a1547eb486fd01$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $e5a1547eb486fd01$export$cd7fbe7e979df558);
const $e5a1547eb486fd01$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $e5a1547eb486fd01$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$e5a1547eb486fd01$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("jAaQQ", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $e419cbf8e75df404$export$7cbbc763e2f3d65d);

var $jIjBf = parcelRequire("jIjBf");

var $gpHdk = parcelRequire("gpHdk");
const $e419cbf8e75df404$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $gpHdk.routeHasResources)(nextRoute)) return [];
    if ((0, $gpHdk.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $jIjBf.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $jIjBf.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("gpHdk", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $bf30808ee02acbab$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $bf30808ee02acbab$export$221027ff1aa38f82);
const $bf30808ee02acbab$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $bf30808ee02acbab$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("fKCt5", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $b778fde043cb1cb5$export$89440b7623c2c75c);

var $eqUIF = parcelRequire("eqUIF");
const $b778fde043cb1cb5$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $b778fde043cb1cb5$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $b778fde043cb1cb5$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $b778fde043cb1cb5$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $b778fde043cb1cb5$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $eqUIF.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("kxegT", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $ef31f5bfa13b2d5f$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $ef31f5bfa13b2d5f$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $ef31f5bfa13b2d5f$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $ef31f5bfa13b2d5f$var$NonError);
    }
}
const $ef31f5bfa13b2d5f$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $ef31f5bfa13b2d5f$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $ef31f5bfa13b2d5f$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $ef31f5bfa13b2d5f$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $ef31f5bfa13b2d5f$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $ef31f5bfa13b2d5f$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $ef31f5bfa13b2d5f$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $ef31f5bfa13b2d5f$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $ef31f5bfa13b2d5f$var$NonError(value);
};

});

parcelRegister("jIIPl", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $e5b4e6238e8bd3cf$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $e5b4e6238e8bd3cf$export$399de8c43d0ece3c);
const $e5b4e6238e8bd3cf$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $e5b4e6238e8bd3cf$var$isFresh = (resource)=>{
    if ($e5b4e6238e8bd3cf$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $e5b4e6238e8bd3cf$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($e5b4e6238e8bd3cf$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("zkPqV", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $06a36d1e81b8e9d0$export$2e4da1b414980956);

var $hHCeM = parcelRequire("hHCeM");
const $06a36d1e81b8e9d0$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $hHCeM.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("bJL7o", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $88b87265c450d51e$export$3ceb62baab058c6b);
const $88b87265c450d51e$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("cTw4V", function(module, exports) {

var $fc4bM = parcelRequire("fc4bM");

var $h2u6I = parcelRequire("h2u6I");
const $963381356d7972fc$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $h2u6I.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(result));
};

});
parcelRegister("h2u6I", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $c679fa3cc96addaa$export$9f6abfd74295843b);

var $hHCeM = parcelRequire("hHCeM");

var $fc4bM = parcelRequire("fc4bM");

var $5nVr1 = parcelRequire("5nVr1");

var $fS0Ph = parcelRequire("fS0Ph");

var $2GMXb = parcelRequire("2GMXb");
const $c679fa3cc96addaa$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $2GMXb.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $fS0Ph.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $fc4bM.useMemo)(()=>(0, $5nVr1.createHook)((0, $fS0Ph.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $2GMXb.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $fc4bM.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $fc4bM.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $fc4bM.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $fc4bM.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $fc4bM.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $hHCeM.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("6ZUzT", function(module, exports) {

var $2GMXb = parcelRequire("2GMXb");
const $518453c3b30937a4$export$dee7bf9fc0ff48c3 = (fn)=>(0, $2GMXb.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("iwH5o", function(module, exports) {
const $d7cca31baa7a6df5$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("3snj8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e82faa6e70787a06$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $e82faa6e70787a06$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    defaultPlaceholder: {
        id: 'company-hub.article-search-component.placeholder',
        defaultMessage: 'Search for help',
        description: 'Default placeholder text for the article search input.'
    },
    searchHint: {
        id: 'company-hub.article-search-component.search-hint',
        defaultMessage: 'Search',
        description: 'Label shown next to an Enter key icon at the end of the search field, hinting that pressing Enter runs the search.'
    },
    searchHintDescription: {
        id: 'company-hub.article-search-component.search-hint-description',
        defaultMessage: 'Press Enter to search',
        description: 'Description of the search field, announced to screen reader users only, explaining that pressing the Enter key runs the search.'
    }
});

});



parcelRegister("exNRh", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchComponent", () => $81a52fa99b512b0d$export$8fa6497fb1b229b0);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $4Cnkn = parcelRequire("4Cnkn");

var $dRkX9 = parcelRequire("dRkX9");

var $4EPUx = parcelRequire("4EPUx");

var $dBtOK = parcelRequire("dBtOK");

var $afA7P = parcelRequire("afA7P");

var $aQNcS = parcelRequire("aQNcS");

var $gpdro = parcelRequire("gpdro");

var $5JxdW = parcelRequire("5JxdW");

var $8Z7BV = parcelRequire("8Z7BV");
const $81a52fa99b512b0d$var$styles = {
    responsiveTrigger: "_1bsb1kdj _p12f1osq"
};
const $81a52fa99b512b0d$export$8fa6497fb1b229b0 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $fc4bM.useState)('');
    const [showDropdown, setShowDropdown] = (0, $fc4bM.useState)(false);
    const inputBoxRef = (0, $fc4bM.useRef)(null);
    const inputRef = (0, $fc4bM.useRef)(null);
    const [_, setInputWidth] = (0, $fc4bM.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, hubType: hubType, env: { helpCenterAri: helpCenterAri, relativeBaseUrl: relativeBaseUrl } } = (0, $aQNcS.useHubContext)();
    if (!helpCenterAri || !cloudId) throw new Error('Help center Ari and cloud ID are required');
    (0, $fc4bM.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $fc4bM.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            ref: inputBoxRef,
            xcss: (0, $4Cnkn.cx)((0, $dRkX9.fg)('hubs_jsm_max_width_appearance') && $81a52fa99b512b0d$var$styles.responsiveTrigger)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JxdW.SearchTextField), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onInput: handleInput,
            isReadOnly: isEditor,
            placeholderText: placeholderText,
            showDropdown: showDropdown,
            queryWord: queryWord,
            searchBasePath: relativeBaseUrl || undefined,
            showSearchEnterHint: hubType === 'HELP_HUB'
        }));
    }, [
        hubType,
        isEditor,
        placeholderText,
        queryWord,
        relativeBaseUrl,
        showDropdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return(// Not redundant with the scope HubAppShell mounts: `Popup` portals to
            // `body`, so the dropdown escapes that subtree and loses the hub fonts.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $afA7P.HubTypographyScope), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gpdro.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8Z7BV.HelpObjectSearchDropdown), {
                ...contentProps,
                cloudId: cloudId,
                helpCenterAri: helpCenterAri || '',
                inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                queryWord: queryWord
            }))));
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("8Z7BV", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchDropdown", () => $91c861e7ceccba3c$export$99781ab3c09b5cc0);

var $fc4bM = parcelRequire("fc4bM");

var $fok6N = parcelRequire("fok6N");

var $5cRZl = parcelRequire("5cRZl");

var $45QqP = parcelRequire("45QqP");

var $cgw3w = parcelRequire("cgw3w");
const $91c861e7ceccba3c$export$99781ab3c09b5cc0 = ({ inputWidth: inputWidth, queryWord: queryWord, ...props })=>{
    const results = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $45QqP.SearchSkeletons), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cgw3w.HelpObjectSearchResults), {
        ...props,
        queryWord: queryWord
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5cRZl.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fok6N.HubErrorBoundary), {
        key: queryWord,
        id: "help-object-search-results",
        packageName: "article-search",
        operationNames: [
            'articleResultsQuery',
            'portalResultsQuery',
            'requestTypeResultsQuery'
        ],
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cgw3w.HelpObjectSearchError), null)
    }, results));
};

});
parcelRegister("cgw3w", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchError", () => $eccaef68a067cdea$export$9152df2cffc49a08);
$parcel$export(module.exports, "HelpObjectSearchResults", () => $eccaef68a067cdea$export$4d1c12e2349aa7cc);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $d68Yo = parcelRequire("d68Yo");

var $6ZeA9 = parcelRequire("6ZeA9");

var $7YJP3 = parcelRequire("7YJP3");

var $aBMr7 = parcelRequire("aBMr7");
const $eccaef68a067cdea$export$9152df2cffc49a08 = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ $fc4bM.createElement((0, $d68Yo.EmptyState), {
        title: formatMessage((0, $7YJP3.messages).errorTitle),
        Image: (0, $6ZeA9.SearchErrorImage),
        content: /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $7YJP3.messages).errorDescription)
    });
};
const $eccaef68a067cdea$export$4d1c12e2349aa7cc = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $aBMr7.SplitHelpObjectSearchResults), {
        key: `${cloudId}:${helpCenterAri}:${queryWord}`,
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryWord: queryWord
    });
};

});
parcelRegister("7YJP3", function(module, exports) {
$parcel$export(module.exports, "messages", () => $33b2f5a8689446d0$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $33b2f5a8689446d0$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.help-object-search-component.empty-title',
        defaultMessage: "We couldn't find a match for your search",
        description: 'Text displayed in the dialog when no results are found during the search.'
    },
    emptyStateDescription: {
        id: 'company-hub.help-object-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the search dialog to guide users when there are no results.'
    },
    errorTitle: {
        id: 'company-hub.help-object-search-component.error-title',
        defaultMessage: "We're having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the search.'
    },
    errorDescription: {
        id: 'company-hub.help-object-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the search dialog to guide users when there is an error.'
    },
    resourcesHeading: {
        id: 'company-hub.help-object-search-component.resources-heading',
        defaultMessage: 'Resources',
        description: 'Heading for the resources section in search results.'
    },
    teamPortalsHeading: {
        id: 'company-hub.help-object-search-component.team-portals-heading',
        defaultMessage: 'Team Portals',
        description: 'Heading for the team portals section in search results.'
    },
    requestFormsHeading: {
        id: 'company-hub.help-object-search-component.request-forms-heading',
        defaultMessage: 'Request forms',
        description: 'Heading for the request forms section in search results.'
    }
});

});

parcelRegister("aBMr7", function(module, exports) {
$parcel$export(module.exports, "SplitHelpObjectSearchResults", () => $53bf550db52fbca0$export$afff10febc2e68cd);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $53bjB = parcelRequire("53bjB");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $cJzRi = parcelRequire("cJzRi");

var $d68Yo = parcelRequire("d68Yo");

var $bFHiR = parcelRequire("bFHiR");

var $6ZeA9 = parcelRequire("6ZeA9");

var $45QqP = parcelRequire("45QqP");

var $7YJP3 = parcelRequire("7YJP3");

var $gyNxK = parcelRequire("gyNxK");

var $dTaJa = parcelRequire("dTaJa");

var $2CrH4 = parcelRequire("2CrH4");

var $19KAV = parcelRequire("19KAV");

var $7dgyE = parcelRequire("7dgyE");

var $dpnhf = parcelRequire("dpnhf");
const $53bf550db52fbca0$var$initialResultStatuses = {
    [(0, $dpnhf.SearchResultType).Articles]: (0, $dpnhf.SearchResultStatus).Pending,
    [(0, $dpnhf.SearchResultType).Portals]: (0, $dpnhf.SearchResultStatus).Pending,
    [(0, $dpnhf.SearchResultType).RequestTypes]: (0, $dpnhf.SearchResultStatus).Pending
};
// Fixed order: Resources, then Team Portals, then Request forms.
const $53bf550db52fbca0$var$DEBOUNCE_DELAY_MS = 500;
const $53bf550db52fbca0$var$sections = [
    {
        type: (0, $dpnhf.SearchResultType).Articles,
        Component: (0, $gyNxK.ArticleResults)
    },
    {
        type: (0, $dpnhf.SearchResultType).Portals,
        Component: (0, $dTaJa.PortalResults)
    },
    {
        type: (0, $dpnhf.SearchResultType).RequestTypes,
        Component: (0, $2CrH4.RequestTypeResults)
    }
];
const $53bf550db52fbca0$export$afff10febc2e68cd = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [debouncedQueryWord, setDebouncedQueryWordState] = (0, $fc4bM.useState)();
    const [statuses, setStatuses] = (0, $fc4bM.useState)($53bf550db52fbca0$var$initialResultStatuses);
    const setDebouncedQueryWord = (0, $fc4bM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(setDebouncedQueryWordState, $53bf550db52fbca0$var$DEBOUNCE_DELAY_MS), []);
    const updateStatus = (0, $fc4bM.useCallback)((resultType, status)=>{
        setStatuses((currentStatuses)=>{
            if (currentStatuses[resultType] === status) return currentStatuses;
            return {
                ...currentStatuses,
                [resultType]: status
            };
        });
    }, []);
    // Stable per-type handlers so each section's status effect only re-runs when its own status
    // changes, rather than on every parent render.
    const onStatusByType = (0, $fc4bM.useMemo)(()=>({
            [(0, $dpnhf.SearchResultType).Articles]: (status)=>updateStatus((0, $dpnhf.SearchResultType).Articles, status),
            [(0, $dpnhf.SearchResultType).Portals]: (status)=>updateStatus((0, $dpnhf.SearchResultType).Portals, status),
            [(0, $dpnhf.SearchResultType).RequestTypes]: (status)=>updateStatus((0, $dpnhf.SearchResultType).RequestTypes, status)
        }), [
        updateStatus
    ]);
    (0, $fc4bM.useEffect)(()=>{
        setDebouncedQueryWord(queryWord);
        return ()=>{
            setDebouncedQueryWord.cancel();
        };
    }, [
        queryWord,
        setDebouncedQueryWord
    ]);
    if (debouncedQueryWord === undefined) return /*#__PURE__*/ $fc4bM.createElement((0, $bFHiR.SearchDialogContent), null, /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), {
        xcss: $53bf550db52fbca0$var$styles.stackContainer
    }, /*#__PURE__*/ $fc4bM.createElement((0, $45QqP.SearchSkeletons), null)));
    const hasPendingResults = Object.values(statuses).includes((0, $dpnhf.SearchResultStatus).Pending);
    const hasResults = Object.values(statuses).includes((0, $dpnhf.SearchResultStatus).Results);
    const hasOnlyErrors = Object.values(statuses).every((status)=>status === (0, $dpnhf.SearchResultStatus).Error);
    const showEmptyState = !hasPendingResults && !hasResults && !hasOnlyErrors;
    const showErrorState = !hasPendingResults && hasOnlyErrors;
    return /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Fragment), null, hasPendingResults && !hasResults && /*#__PURE__*/ $fc4bM.createElement((0, $45QqP.SearchSkeletons), null), showEmptyState && /*#__PURE__*/ $fc4bM.createElement((0, $d68Yo.EmptyState), {
        title: formatMessage((0, $7YJP3.messages).emptyStateTitle),
        Image: (0, $6ZeA9.SearchErrorImage),
        content: /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $7YJP3.messages).emptyStateDescription)
    }), showErrorState && /*#__PURE__*/ $fc4bM.createElement((0, $d68Yo.EmptyState), {
        title: formatMessage((0, $7YJP3.messages).errorTitle),
        Image: (0, $6ZeA9.SearchErrorImage),
        content: /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $7YJP3.messages).errorDescription)
    }), (hasResults || hasPendingResults) && /*#__PURE__*/ $fc4bM.createElement((0, $bFHiR.SearchDialogContent), null, /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), {
        xcss: $53bf550db52fbca0$var$styles.stackContainer
    }, $53bf550db52fbca0$var$sections.map(({ type: type, Component: Component })=>/*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultBoundary), {
            key: type,
            onError: ()=>updateStatus(type, (0, $dpnhf.SearchResultStatus).Error)
        }, /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Suspense), {
            fallback: hasResults ? /*#__PURE__*/ $fc4bM.createElement((0, $45QqP.SearchSkeletons), {
                count: 1
            }) : null
        }, /*#__PURE__*/ $fc4bM.createElement(Component, {
            cloudId: cloudId,
            helpCenterAri: helpCenterAri,
            onStatus: onStatusByType[type],
            queryWord: debouncedQueryWord
        })))), hasResults && /*#__PURE__*/ $fc4bM.createElement((0, $7dgyE.ShowMoreLink), {
        queryWord: queryWord
    }))));
};
const $53bf550db52fbca0$var$styles = {
    stackContainer: "_1bsb1osq _n3tdpxbi"
};

});
parcelRegister("53bjB", function(module, exports) {

var $e3M82 = parcelRequire("e3M82");

var $7PCeE = parcelRequire("7PCeE");

var $gBct1 = parcelRequire("gBct1");
/** Error message constants. */ var $3ad60289d36340d7$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3ad60289d36340d7$var$nativeMax = Math.max, $3ad60289d36340d7$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $3ad60289d36340d7$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($3ad60289d36340d7$var$FUNC_ERROR_TEXT);
    wait = $gBct1(wait) || 0;
    if ($e3M82(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $3ad60289d36340d7$var$nativeMax($gBct1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $3ad60289d36340d7$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7PCeE();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7PCeE());
    }
    function debounced() {
        var time = $7PCeE(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $3ad60289d36340d7$var$debounce;

});
parcelRegister("7PCeE", function(module, exports) {

var $4XvF4 = parcelRequire("4XvF4");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $5b3af48a2d2932dc$var$now = function() {
    return $4XvF4.Date.now();
};
module.exports = $5b3af48a2d2932dc$var$now;

});


parcelRegister("gyNxK", function(module, exports) {
$parcel$export(module.exports, "ArticleResults", () => $7333ef4a461ca448$export$c10eb8bb08a63f90);
/* article-results.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $lnUi2 = parcelRequire("lnUi2");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $dS86g = parcelRequire("dS86g");

var $2f8np = parcelRequire("2f8np");

var $7YJP3 = parcelRequire("7YJP3");

var $19KAV = parcelRequire("19KAV");

var $dpnhf = parcelRequire("dpnhf");

var $il8Bw = parcelRequire("il8Bw");

var $oxQxU = parcelRequire("oxQxU");
const $7333ef4a461ca448$var$DEFAULT_RESULTS_LIMIT = 3;
const $7333ef4a461ca448$export$c10eb8bb08a63f90 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, onStatus: onStatus, queryWord: queryWord })=>{
    var _data$helpObjectStore, _data$helpObjectStore3;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $lnUi2.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $7333ef4a461ca448$var$DEFAULT_RESULTS_LIMIT
    });
    const errorMessage = (_data$helpObjectStore = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.message;
    const articles = (0, $fc4bM.useMemo)(()=>{
        var _data$helpObjectStore2;
        return ((_data$helpObjectStore2 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.results) ?? [];
    }, [
        (_data$helpObjectStore3 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.results
    ]);
    const resultStatus = (0, $oxQxU.getResultStatus)(errorMessage, articles.length);
    (0, $il8Bw.useSearchResultAnalytics)({
        resultCount: articles.length,
        resultStatus: resultStatus,
        resultType: (0, $dpnhf.SearchResultType).Articles
    });
    (0, $fc4bM.useEffect)(()=>{
        onStatus(resultStatus);
    }, [
        onStatus,
        resultStatus
    ]);
    if (articles.length === 0 || errorMessage) return /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Fragment), null);
    return /*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultSection), {
        heading: formatMessage((0, $7YJP3.messages).resourcesHeading)
    }, articles.map((article)=>{
        var _article$metadata;
        return /*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultContainer), {
            key: article.ari
        }, /*#__PURE__*/ $fc4bM.createElement((0, $2f8np.SearchResult), {
            href: article.displayLink,
            linkComponent: (_article$metadata = article.metadata) !== null && _article$metadata !== void 0 && _article$metadata.isExternal ? (0, $19KAV.ExternalLinkComponent) : (0, $19KAV.InternalLinkComponent),
            title: article.title,
            isCollapsed: true,
            icon: /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }));
    }));
};

});
parcelRegister("lnUi2", function(module, exports) {
$parcel$export(module.exports, "default", () => $18ef6f50a438610c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0863eb78f0b56d79a6620d1486f690e7>>
 * @relayHash 9ef0f140ce2c2630c1a318d633310d2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc023caf92a359bdb6e8e8fb3c9fbe927f1bad8f7b0bc2a86ed34f07963aae5c
const $18ef6f50a438610c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Literal",
            "name": "highlight",
            "value": false
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreArticleSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "displayLink"
                    },
                    {
                        "concreteType": "HelpObjectStoreArticleMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isExternal"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreArticleSearchResults"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "articleResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "articleResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "fc023caf92a359bdb6e8e8fb3c9fbe927f1bad8f7b0bc2a86ed34f07963aae5c",
            "metadata": {},
            "name": "articleResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$18ef6f50a438610c$var$node.hash = "1cc7700a3e9a557a0cd862ac9aecccbf";
var $18ef6f50a438610c$export$2e2bcd8739ae039 = $18ef6f50a438610c$var$node;

});

parcelRegister("19KAV", function(module, exports) {
$parcel$export(module.exports, "SearchResultBoundary", () => $6f566709c145d2fa$export$ff333f2a35899865);
$parcel$export(module.exports, "ExternalLinkComponent", () => $6f566709c145d2fa$export$17cfda15b3eef31e);
$parcel$export(module.exports, "InternalLinkComponent", () => $6f566709c145d2fa$export$2fef3fb2f4dec78);
$parcel$export(module.exports, "SearchResultSection", () => $6f566709c145d2fa$export$51a5a703da15f0f7);
$parcel$export(module.exports, "SearchResultContainer", () => $6f566709c145d2fa$export$a849c4440d2afe66);
/* search-result-section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $hi8gb = parcelRequire("hi8gb");

var $1hJdJ = parcelRequire("1hJdJ");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $dBtOK = parcelRequire("dBtOK");
class $6f566709c145d2fa$export$ff333f2a35899865 extends (0, $fc4bM.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch() {
        this.props.onError();
    }
    render() {
        return this.state.hasError ? null : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
const $6f566709c145d2fa$export$17cfda15b3eef31e = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ href: href = '#', ...props }, ref)=>/*#__PURE__*/ $fc4bM.createElement((0, $5Ny1Q.Anchor), {
        ref: ref,
        href: href,
        ...props,
        target: "_blank",
        xcss: $6f566709c145d2fa$var$styles.externalLink,
        rel: "noopener noreferrer"
    }));
const $6f566709c145d2fa$export$2fef3fb2f4dec78 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ href: href = '#', children: children, ...props }, ref)=>/*#__PURE__*/ $fc4bM.createElement((0, $hi8gb.default), {
        ref: ref,
        to: href,
        ...props
    }, children));
const $6f566709c145d2fa$export$51a5a703da15f0f7 = ({ children: children, heading: heading })=>/*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $6f566709c145d2fa$var$styles.sectionHeading
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1hJdJ.default), {
        as: "h3",
        size: "xsmall"
    }, heading)), children);
const $6f566709c145d2fa$export$a849c4440d2afe66 = ({ children: children })=>/*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $6f566709c145d2fa$var$styles.searchResultContainer
    }, children);
const $6f566709c145d2fa$var$styles = {
    externalLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    searchResultContainer: "_19bv1b66 _u5f31b66",
    sectionHeading: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvv47k"
};

});

parcelRegister("dpnhf", function(module, exports) {
$parcel$export(module.exports, "SearchResultStatus", () => $18c9ac8c5f5a45da$export$3c74771c44f42198);
$parcel$export(module.exports, "SearchResultType", () => $18c9ac8c5f5a45da$export$95cacd63dfd98bee);
var $18c9ac8c5f5a45da$export$3c74771c44f42198 = /*#__PURE__*/ function(SearchResultStatus) {
    SearchResultStatus["Pending"] = "pending";
    SearchResultStatus["Results"] = "results";
    SearchResultStatus["Empty"] = "empty";
    SearchResultStatus["Error"] = "error";
    return SearchResultStatus;
}({});
var $18c9ac8c5f5a45da$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["Articles"] = "articles";
    SearchResultType["Portals"] = "portals";
    SearchResultType["RequestTypes"] = "requestTypes";
    return SearchResultType;
}({});

});

parcelRegister("il8Bw", function(module, exports) {
$parcel$export(module.exports, "useSearchResultAnalytics", () => $7e0daab6ca8eac8f$export$cf3afb4db2c5bb64);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $16GaT = parcelRequire("16GaT");

var $dpnhf = parcelRequire("dpnhf");
const $7e0daab6ca8eac8f$var$HELP_OBJECT_SEARCH_ANALYTIC_SOURCE = 'helpObjectSearch';
const $7e0daab6ca8eac8f$export$cf3afb4db2c5bb64 = ({ resultCount: resultCount, resultStatus: resultStatus, resultType: resultType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const lastReportedStatus = (0, $fc4bM.useRef)((0, $dpnhf.SearchResultStatus).Pending);
    (0, $fc4bM.useEffect)(()=>{
        if (resultStatus === (0, $dpnhf.SearchResultStatus).Pending || lastReportedStatus.current === resultStatus) return;
        lastReportedStatus.current = resultStatus;
        (0, $16GaT.fireOperationalAnalytics)(createAnalyticsEvent({
            source: $7e0daab6ca8eac8f$var$HELP_OBJECT_SEARCH_ANALYTIC_SOURCE
        }), `searchResults ${resultStatus === (0, $dpnhf.SearchResultStatus).Error ? 'failed' : 'resolved'}`, {
            resultCount: resultCount,
            resultType: resultType
        });
    }, [
        createAnalyticsEvent,
        resultCount,
        resultStatus,
        resultType
    ]);
};

});

parcelRegister("oxQxU", function(module, exports) {
$parcel$export(module.exports, "getResultStatus", () => $5587a5c96e6476a8$export$166050e137a4dbb4);

var $dpnhf = parcelRequire("dpnhf");
const $5587a5c96e6476a8$export$166050e137a4dbb4 = (errorMessage, resultCount)=>{
    if (errorMessage) return (0, $dpnhf.SearchResultStatus).Error;
    if (resultCount > 0) return (0, $dpnhf.SearchResultStatus).Results;
    return (0, $dpnhf.SearchResultStatus).Empty;
};

});


parcelRegister("dTaJa", function(module, exports) {
$parcel$export(module.exports, "PortalResults", () => $85106a2a36b4320e$export$d36a8db16b6d44cc);
/* portal-results.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $7mNYa = parcelRequire("7mNYa");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $78Y6r = parcelRequire("78Y6r");

var $2f8np = parcelRequire("2f8np");

var $7YJP3 = parcelRequire("7YJP3");

var $19KAV = parcelRequire("19KAV");

var $dpnhf = parcelRequire("dpnhf");

var $il8Bw = parcelRequire("il8Bw");

var $oxQxU = parcelRequire("oxQxU");
const $85106a2a36b4320e$var$DEFAULT_RESULTS_LIMIT = 3;
const $85106a2a36b4320e$export$d36a8db16b6d44cc = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, onStatus: onStatus, queryWord: queryWord })=>{
    var _data$helpObjectStore, _data$helpObjectStore3;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $7mNYa.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $85106a2a36b4320e$var$DEFAULT_RESULTS_LIMIT
    });
    const errorMessage = (_data$helpObjectStore = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.message;
    const portals = (0, $fc4bM.useMemo)(()=>{
        var _data$helpObjectStore2;
        return ((_data$helpObjectStore2 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore2 === void 0 || (_data$helpObjectStore2 = _data$helpObjectStore2.results) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.filter((portal)=>portal.__typename === 'HelpObjectStorePortalSearchResult')) ?? [];
    }, [
        (_data$helpObjectStore3 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.results
    ]);
    const resultStatus = (0, $oxQxU.getResultStatus)(errorMessage, portals.length);
    (0, $il8Bw.useSearchResultAnalytics)({
        resultCount: portals.length,
        resultStatus: resultStatus,
        resultType: (0, $dpnhf.SearchResultType).Portals
    });
    (0, $fc4bM.useEffect)(()=>{
        onStatus(resultStatus);
    }, [
        onStatus,
        resultStatus
    ]);
    if (portals.length === 0 || errorMessage) return /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Fragment), null);
    return /*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultSection), {
        heading: formatMessage((0, $7YJP3.messages).teamPortalsHeading)
    }, portals.map((portal)=>/*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultContainer), {
            key: portal.id
        }, /*#__PURE__*/ $fc4bM.createElement((0, $2f8np.SearchResult), {
            href: portal.displayLink,
            linkComponent: (0, $19KAV.InternalLinkComponent),
            title: portal.title,
            isCollapsed: true,
            icon: portal.iconUrl ? /*#__PURE__*/ $fc4bM.createElement("img", {
                src: portal.iconUrl,
                alt: "",
                className: (0, $2R2iS.default)([
                    $85106a2a36b4320e$var$styles.icon
                ])
            }) : /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($78Y6r))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }))));
};
const $85106a2a36b4320e$var$styles = {
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51"
};

});
parcelRegister("7mNYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3882c8178529b065$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d1c6a38756486eb8fb687621048ce80>>
 * @relayHash 885bd39d3055be0e62f6aa397ff732e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdc5f273151879ea39dabff7aaa0325934c9b554b76b6dfca148cc4464809677
const $3882c8178529b065$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStorePortalSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "displayLink"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStorePortalSearchResults"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "portalResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "portalResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "fdc5f273151879ea39dabff7aaa0325934c9b554b76b6dfca148cc4464809677",
            "metadata": {},
            "name": "portalResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3882c8178529b065$var$node.hash = "38a8a09da34512d24061349cb66a0e46";
var $3882c8178529b065$export$2e2bcd8739ae039 = $3882c8178529b065$var$node;

});


parcelRegister("2CrH4", function(module, exports) {
$parcel$export(module.exports, "RequestTypeResults", () => $628ae5fc892221df$export$16a59c31a51185c5);
/* request-type-results.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5pkzh = parcelRequire("5pkzh");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $dgs90 = parcelRequire("dgs90");

var $2f8np = parcelRequire("2f8np");

var $7YJP3 = parcelRequire("7YJP3");

var $19KAV = parcelRequire("19KAV");

var $dpnhf = parcelRequire("dpnhf");

var $il8Bw = parcelRequire("il8Bw");

var $oxQxU = parcelRequire("oxQxU");
const $628ae5fc892221df$var$DEFAULT_RESULTS_LIMIT = 3;
const $628ae5fc892221df$export$16a59c31a51185c5 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, onStatus: onStatus, queryWord: queryWord })=>{
    var _data$helpObjectStore, _data$helpObjectStore3;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $5pkzh.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $628ae5fc892221df$var$DEFAULT_RESULTS_LIMIT
    });
    const errorMessage = (_data$helpObjectStore = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.message;
    const requestTypes = (0, $fc4bM.useMemo)(()=>{
        var _data$helpObjectStore2;
        return ((_data$helpObjectStore2 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.results) ?? [];
    }, [
        (_data$helpObjectStore3 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.results
    ]);
    const resultStatus = (0, $oxQxU.getResultStatus)(errorMessage, requestTypes.length);
    (0, $il8Bw.useSearchResultAnalytics)({
        resultCount: requestTypes.length,
        resultStatus: resultStatus,
        resultType: (0, $dpnhf.SearchResultType).RequestTypes
    });
    (0, $fc4bM.useEffect)(()=>{
        onStatus(resultStatus);
    }, [
        onStatus,
        resultStatus
    ]);
    if (requestTypes.length === 0 || errorMessage) return /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Fragment), null);
    return /*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultSection), {
        heading: formatMessage((0, $7YJP3.messages).requestFormsHeading)
    }, requestTypes.map((requestType)=>/*#__PURE__*/ $fc4bM.createElement((0, $19KAV.SearchResultContainer), {
            key: requestType.id
        }, /*#__PURE__*/ $fc4bM.createElement((0, $2f8np.SearchResult), {
            linkComponent: (0, $19KAV.InternalLinkComponent),
            href: requestType.displayLink,
            title: requestType.title,
            isCollapsed: true,
            icon: requestType.iconUrl ? /*#__PURE__*/ $fc4bM.createElement("img", {
                src: requestType.iconUrl,
                alt: "",
                className: (0, $2R2iS.default)([
                    $628ae5fc892221df$var$styles.icon
                ])
            }) : /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dgs90))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }))));
};
const $628ae5fc892221df$var$styles = {
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51"
};

});
parcelRegister("5pkzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $accca0c4efda5af6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5469e60ce3706e81811fe92b1ee8410d>>
 * @relayHash 1d572b0b09b6273877d713d1bc3dd292
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a906b3609a37df47206b6df90f9f24180b744d3564fcfe4c3a7fdb77054abb3f
const $accca0c4efda5af6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "displayLink"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreRequestTypeSearchResults"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "requestTypeResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "requestTypeResultsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a906b3609a37df47206b6df90f9f24180b744d3564fcfe4c3a7fdb77054abb3f",
            "metadata": {},
            "name": "requestTypeResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$accca0c4efda5af6$var$node.hash = "0f366047b72f38714c532a0e12cf562b";
var $accca0c4efda5af6$export$2e2bcd8739ae039 = $accca0c4efda5af6$var$node;

});


parcelRegister("7dgyE", function(module, exports) {
$parcel$export(module.exports, "ShowMoreLink", () => $a3a536943f550180$export$758fc69c3e12a959);
/* show-more-link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $dBtOK = parcelRequire("dBtOK");

var $iU70g = parcelRequire("iU70g");

var $aQNcS = parcelRequire("aQNcS");

var $dW7mT = parcelRequire("dW7mT");
const $a3a536943f550180$var$styles = {
    container: "_ca0qu2gc _u5f3pxbi _19bvv47k",
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $a3a536943f550180$export$758fc69c3e12a959 = ({ queryWord: queryWord })=>{
    var _useHubTheming;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { push: push } = (0, $8whFx.useRouterActions)();
    const { env: { relativeBaseUrl: relativeBaseUrl } } = (0, $aQNcS.useHubContext)();
    const primaryLinkColor = (_useHubTheming = (0, $iU70g.useHubTheming)()) === null || _useHubTheming === void 0 ? void 0 : _useHubTheming.primaryLinkColor;
    const brandedLinkStyle = primaryLinkColor ? {
        color: primaryLinkColor
    } : undefined;
    const searchPath = `/articles/search?q=${encodeURIComponent(queryWord)}`;
    const href = `${relativeBaseUrl.replace(/\/+$/, '')}${searchPath}`;
    const onClick = (event)=>{
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        push(searchPath);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $a3a536943f550180$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5Ny1Q.Anchor), {
        href: href,
        onClick: onClick,
        style: brandedLinkStyle,
        xcss: $a3a536943f550180$var$styles.link
    }, formatMessage((0, $dW7mT.messages).showMore)));
};

});
parcelRegister("dW7mT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0d29e0b6e9620c44$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $0d29e0b6e9620c44$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    showMore: {
        id: 'company-hub.help-object-search-component.show-more',
        defaultMessage: 'Show more',
        description: 'Navigates to the full search results page.'
    }
});

});






parcelRegister("fVRf7", function(module, exports) {
$parcel$export(module.exports, "HUB_CONNECT_EXTENSION_TYPE", () => $a2ede33055177066$export$9739bc39ff578ef);
$parcel$export(module.exports, "HUB_CONNECT_EXTENSION_KEY", () => $a2ede33055177066$export$3a3256797a873c9d);
$parcel$export(module.exports, "isFooterExtensionKey", () => $a2ede33055177066$export$5672169d8cc92b0b);
$parcel$export(module.exports, "HUB_CONNECT_EXTENSION_VERSION_1", () => $a2ede33055177066$export$cbd6fa0855da1fbd);
$parcel$export(module.exports, "ConnectElementType", () => $a2ede33055177066$export$a7467005470ef946);
$parcel$export(module.exports, "ConnectPageContext", () => $a2ede33055177066$export$dc1f825c64ccdff6);
$parcel$export(module.exports, "HUB_CONNECT_LEARN_MORE_URL", () => $a2ede33055177066$export$88cc63a4344dc0e3);
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub
 * Connect extension. Must remain stable across product releases — changing
 * it is a breaking change to persisted hub content.
 *
 * Mirrors the Help Center Connect module shape so installed Connect apps
 * (Portal header / Portal footer modules) can be shared between Help
 * Center and Hub editors with zero schema translation.
 */ const $a2ede33055177066$export$9739bc39ff578ef = 'com.atlassian.hub-connect';
const $a2ede33055177066$export$3a3256797a873c9d = 'hub-connect';
const $a2ede33055177066$export$a391370883dc60a0 = `${$a2ede33055177066$export$3a3256797a873c9d}-header`;
const $a2ede33055177066$export$6214169031454add = `${$a2ede33055177066$export$3a3256797a873c9d}-footer`;
const $a2ede33055177066$export$2772ad16b9dc4cf1 = (extensionKey)=>extensionKey === $a2ede33055177066$export$a391370883dc60a0;
const $a2ede33055177066$export$5672169d8cc92b0b = (extensionKey)=>extensionKey === $a2ede33055177066$export$6214169031454add;
const $a2ede33055177066$export$cbd6fa0855da1fbd = '1.0.0';
const $a2ede33055177066$export$a7467005470ef946 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $a2ede33055177066$export$dc1f825c64ccdff6 = {
    HELP_HUB: 'HELP_HUB'
};
const $a2ede33055177066$export$939aa9ef868c885e = 'hubConnectExtension';
const $a2ede33055177066$export$7bb2524ff74eaaaa = 'hubConnectExtensionConfig';
const $a2ede33055177066$export$88cc63a4344dc0e3 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';

});

parcelRegister("lD6st", function(module, exports) {
$parcel$export(module.exports, "HUB_FORGE_EXTENSION_TYPE", () => $e9334d6783d74271$export$28815926b67771e7);
$parcel$export(module.exports, "HUB_FORGE_EXTENSION_KEY", () => $e9334d6783d74271$export$e1401e10db30b53d);
$parcel$export(module.exports, "HUB_FORGE_HEADER_EXTENSION_KEY", () => $e9334d6783d74271$export$bbd2284a8b6f23d6);
$parcel$export(module.exports, "HUB_FORGE_FOOTER_EXTENSION_KEY", () => $e9334d6783d74271$export$9204604618f84769);
$parcel$export(module.exports, "HUB_FORGE_EXTENSION_VERSION_1", () => $e9334d6783d74271$export$4fd744a56941aef9);
$parcel$export(module.exports, "ForgeElementType", () => $e9334d6783d74271$export$f351bc2072386324);
$parcel$export(module.exports, "ForgePageContext", () => $e9334d6783d74271$export$ed5f67b6b84eb2bf);
$parcel$export(module.exports, "HUB_FORGE_LEARN_MORE_URL", () => $e9334d6783d74271$export$7e8317652605f123);
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub Forge
 * extension. Must remain stable across product releases — changing it is a
 * breaking change to persisted hub content.
 *
 * Mirrors the Help Center Forge module shape so that Forge UI Kit / Custom UI
 * extensions can be shared between Help Center and Hub editors.
 */ const $e9334d6783d74271$export$28815926b67771e7 = 'com.atlassian.hub-forge';
const $e9334d6783d74271$export$e1401e10db30b53d = 'hub-forge';
const $e9334d6783d74271$export$bbd2284a8b6f23d6 = `${$e9334d6783d74271$export$e1401e10db30b53d}-header`;
const $e9334d6783d74271$export$9204604618f84769 = `${$e9334d6783d74271$export$e1401e10db30b53d}-footer`;
const $e9334d6783d74271$export$4fd744a56941aef9 = '1.0.0';
const $e9334d6783d74271$export$f351bc2072386324 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $e9334d6783d74271$export$ed5f67b6b84eb2bf = {
    HELP_HUB: 'HELP_HUB',
    CSM_HELP_CENTER: 'CSM_HELP_CENTER'
};
const $e9334d6783d74271$export$a4c5610f6315d2b8 = 'hubForgeExtension';
const $e9334d6783d74271$export$10977f18dbecea4f = 'hubForgeExtensionConfig';
const $e9334d6783d74271$export$7e8317652605f123 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';

});

parcelRegister("7pQcS", function(module, exports) {
$parcel$export(module.exports, "JSM_HELP_EXTENSION_TYPE", () => $f60d65ecd55db568$export$62b7ac1cc8a8f8d7);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_KEY", () => $f60d65ecd55db568$export$b5a30704f903627a);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $f60d65ecd55db568$export$5eecea5c34e4d0ec);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_VERSION_1", () => $f60d65ecd55db568$export$42fa33c628980eca);
$parcel$export(module.exports, "PAGE_SIZE", () => $f60d65ecd55db568$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "SourceType", () => $f60d65ecd55db568$export$d95e7684b6658cc2);
const $f60d65ecd55db568$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $f60d65ecd55db568$export$b5a30704f903627a = 'jsm-help';
const $f60d65ecd55db568$export$727d928d273126f1 = 'jsmHelpExtension';
const $f60d65ecd55db568$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $f60d65ecd55db568$export$42fa33c628980eca = '1.0.0';
const $f60d65ecd55db568$export$8ec3d08588d2eeda = 9;
const $f60d65ecd55db568$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $f60d65ecd55db568$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};

});

parcelRegister("h7C3u", function(module, exports) {
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_KEY", () => $9e08bb05cc6cc81b$export$5eb13835d9fc35c6);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_TYPE", () => $9e08bb05cc6cc81b$export$1e0076557b3776e7);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE", () => $9e08bb05cc6cc81b$export$bbe74ef6b7213123);
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $9e08bb05cc6cc81b$export$5eb13835d9fc35c6 = 'page-topper';
const $9e08bb05cc6cc81b$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $9e08bb05cc6cc81b$export$bbe74ef6b7213123 = 'calloutBannerExtension';

});

parcelRegister("7ZCDS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2Bcam"),
    $9dnsd("e0rfG")
]).then(()=>parcelRequire('2Tcer'));

});

parcelRegister("cG1Zz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1xWnR"),
    $9dnsd("jXyON"),
    $9dnsd("bMKAA"),
    $9dnsd("f0Leu")
]).then(()=>parcelRequire('1UUcv'));

});

parcelRegister("iwYvY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1xWnR"),
    $9dnsd("gA65H"),
    $9dnsd("8lqgs"),
    $9dnsd("5nj3m"),
    $9dnsd("aejHq"),
    $9dnsd("bMKAA"),
    $9dnsd("8QEJW"),
    $9dnsd("amvsE")
]).then(()=>parcelRequire('lfxH4'));

});

parcelRegister("7SbZl", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gUCeg"),
    $9dnsd("jtcuY"),
    $9dnsd("JUStE")
]).then(()=>parcelRequire('2ob0e'));

});

parcelRegister("3nWjO", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gUCeg"),
    $9dnsd("JroVe"),
    $9dnsd("k9Jmn")
]).then(()=>parcelRequire('kjTLo'));

});


parcelRegister("ajqWj", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgentRenderer", () => $f2a3e3e0cd556547$export$93c28c6c94b1d8af);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $jQmhc = parcelRequire("jQmhc");

var $7S70r = parcelRequire("7S70r");

var $3xM7T = parcelRequire("3xM7T");
const $f2a3e3e0cd556547$export$93c28c6c94b1d8af = ()=>{
    const aiWidgetConfig = (0, $jQmhc.useOptionalAiWidgetConfig)();
    const supportWidgetConfig = aiWidgetConfig === null || aiWidgetConfig === void 0 ? void 0 : aiWidgetConfig.supportWidgetConfig;
    const isSSR = typeof window !== 'undefined' && !!window.__SSR_RENDERED__;
    const showCornerAgent = Boolean(!isSSR && supportWidgetConfig && supportWidgetConfig.isEnabled && (0, $7S70r.handleWidgetPosition)(supportWidgetConfig.widgetPosition) === 'CORNER');
    return showCornerAgent ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3xM7T.AiCornerAgentWithContext), {}) : null;
};

});
parcelRegister("3xM7T", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerWithContext", () => $9a8be011a725b92f$export$ee4cebdd26cd9fad);
$parcel$export(module.exports, "AiSearchTriggerFloatingWithContext", () => $9a8be011a725b92f$export$48844b0016715530);
$parcel$export(module.exports, "AiCornerAgentWithContext", () => $9a8be011a725b92f$export$53048ab92eeb2224);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $jQmhc = parcelRequire("jQmhc");

var $6JlK4 = parcelRequire("6JlK4");

var $1dpWV = parcelRequire("1dpWV");
const $9a8be011a725b92f$var$useWidgetLocale = ()=>{
    const { locale: locale } = (0, $gpjDl.default)();
    // The widget runs in an iframe and cannot inherit React Intl context from the host application.
    // Forward the resolved application locale so its UI matches the surrounding experience.
    return locale;
};
const $9a8be011a725b92f$export$ee4cebdd26cd9fad = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $jQmhc.useAiWidgetConfig)();
    const locale = $9a8be011a725b92f$var$useWidgetLocale();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1dpWV.AiSearchTrigger), {
        locale: locale,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $9a8be011a725b92f$export$48844b0016715530 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $jQmhc.useAiWidgetConfig)();
    const locale = $9a8be011a725b92f$var$useWidgetLocale();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1dpWV.AiSearchTriggerFloating), {
        locale: locale,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $9a8be011a725b92f$export$53048ab92eeb2224 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $jQmhc.useAiWidgetConfig)();
    const locale = $9a8be011a725b92f$var$useWidgetLocale();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6JlK4.AiCornerAgent), {
        locale: locale,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId
    });
};

});
parcelRegister("6JlK4", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgent", () => $e8b77b532fe9b38b$export$df8fdfe108711d3f);

var $fc4bM = parcelRequire("fc4bM");

var $1jQXg = parcelRequire("1jQXg");

var $4qJL8 = parcelRequire("4qJL8");
const $e8b77b532fe9b38b$export$df8fdfe108711d3f = ({ locale: locale, site: site, siteId: siteId, widgetId: widgetId, isSuppressed: isSuppressed = false })=>{
    (0, $fc4bM.useEffect)(()=>{
        if (!isSuppressed) (0, $4qJL8.initCSM)({
            locale: locale,
            site: site,
            siteId: siteId,
            widgetId: widgetId
        });
    }, [
        locale,
        site,
        siteId,
        widgetId,
        isSuppressed
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isSuppressed || !('CSM' in window) || !window.CSM) return;
        // The SDK owns the launcher outside React and queues commands while loading.
        (0, $1jQXg.hide)();
        return ()=>{
            (0, $1jQXg.show)();
        };
    }, [
        isSuppressed
    ]);
    return null;
};

});
parcelRegister("1jQXg", function(module, exports) {
$parcel$export(module.exports, "open", () => $2fddb0a8ba644b53$export$3ce6949f20cea765);
$parcel$export(module.exports, "hide", () => $2fddb0a8ba644b53$export$fe8985bb6374093c);
$parcel$export(module.exports, "show", () => $2fddb0a8ba644b53$export$57bf213be019eeb0);
$parcel$export(module.exports, "update", () => $2fddb0a8ba644b53$export$722fbec263ad908a);
$parcel$export(module.exports, "createNewConversation", () => $2fddb0a8ba644b53$export$319172c070d96d91);
$parcel$export(module.exports, "onOpen", () => $2fddb0a8ba644b53$export$16688e2160da47bd);
$parcel$export(module.exports, "onClose", () => $2fddb0a8ba644b53$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "getCurrentConversation", () => $2fddb0a8ba644b53$export$8862049f62228856);
const $2fddb0a8ba644b53$var$createCommand = (command)=>{
    const fn = (...args)=>{
        if (typeof window === 'undefined' || !window.CSM) {
            // eslint-disable-next-line no-console
            console.warn('CSM SDK has not been loaded!');
            return;
        }
        // @ts-expect-error - window.CSM is dynamically typed; TypeScript cannot infer the overloaded command signature at call site
        window.CSM(command, ...args);
    };
    return fn;
};
const $2fddb0a8ba644b53$export$3ce6949f20cea765 = $2fddb0a8ba644b53$var$createCommand('open');
const $2fddb0a8ba644b53$export$8360e631d277ea4d = $2fddb0a8ba644b53$var$createCommand('close');
const $2fddb0a8ba644b53$export$fe8985bb6374093c = $2fddb0a8ba644b53$var$createCommand('hide');
const $2fddb0a8ba644b53$export$57bf213be019eeb0 = $2fddb0a8ba644b53$var$createCommand('show');
const $2fddb0a8ba644b53$export$722fbec263ad908a = $2fddb0a8ba644b53$var$createCommand('update');
const $2fddb0a8ba644b53$export$319172c070d96d91 = $2fddb0a8ba644b53$var$createCommand('createNewConversation');
const $2fddb0a8ba644b53$export$16688e2160da47bd = $2fddb0a8ba644b53$var$createCommand('onOpen');
const $2fddb0a8ba644b53$export$f312d3bc7ef841a8 = $2fddb0a8ba644b53$var$createCommand('onClose');
const $2fddb0a8ba644b53$export$8862049f62228856 = $2fddb0a8ba644b53$var$createCommand('getCurrentConversation');

});

parcelRegister("4qJL8", function(module, exports) {
$parcel$export(module.exports, "initCSM", () => $3fa6565b95517cc7$export$a161b0281c42400f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $2SWSA = parcelRequire("2SWSA");

var $1jQXg = parcelRequire("1jQXg");

var $9esQR = parcelRequire("9esQR");
const $3fa6565b95517cc7$var$belowDialog = (0, $2SWSA.layers).dialog() - 1;
const $3fa6565b95517cc7$export$a161b0281c42400f = ({ locale: locale, site: siteProp, siteId: siteId, widgetId: widgetId })=>{
    let site = siteProp ?? (typeof window !== 'undefined' && window.location.hostname);
    if (!site) return;
    if (site === 'localhost') // if in development and window.location.hostname === 'localhost'
    // we set it to the testing instance's site url. Change if using different one than the one below
    site = 'support-ccp.jira-dev.com';
    (0, $9esQR.CSM)({
        locale: locale,
        site: site,
        siteId: siteId,
        widgetId: widgetId
    });
    // Ensures the widget does not render on top of dialogs (e.g., search).
    (0, $1jQXg.update)({
        zIndex: $3fa6565b95517cc7$var$belowDialog
    });
};

});
parcelRegister("9esQR", function(module, exports) {
$parcel$export(module.exports, "CSM", () => $6a0063dbc87f9133$export$e20267fb524e653f);

var $6TS2i = parcelRequire("6TS2i");

var $ecQaW = parcelRequire("ecQaW");
const $6a0063dbc87f9133$export$e20267fb524e653f = async ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, locale: locale })=>{
    if (typeof window === 'undefined') return;
    if (typeof window.CSM === 'undefined') window.CSM = (0, $6TS2i.createSDKQueue)();
    return await (0, $ecQaW.loadCSMSDK)({
        site: site,
        siteId: siteId,
        cloudId: cloudId,
        widgetId: widgetId,
        locale: locale
    });
};

});
parcelRegister("6TS2i", function(module, exports) {
$parcel$export(module.exports, "createSDKQueue", () => $98112202d8936321$export$7bcdf693772d0a65);
const $98112202d8936321$export$7bcdf693772d0a65 = ()=>{
    const q = function CMSQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};

});

parcelRegister("ecQaW", function(module, exports) {
$parcel$export(module.exports, "loadCSMSDK", () => $a90a1482a9ddbc73$export$6aed1f3cc6c8351e);

var $gime3 = parcelRequire("gime3");

var $elFaG = parcelRequire("elFaG");
let $a90a1482a9ddbc73$var$promise = null;
const $a90a1482a9ddbc73$var$NOOP = ()=>{};
const $a90a1482a9ddbc73$export$6aed1f3cc6c8351e = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, locale: locale, debug: debug = $a90a1482a9ddbc73$var$NOOP })=>{
    if (!$a90a1482a9ddbc73$var$promise) $a90a1482a9ddbc73$var$promise = new Promise((resolve, reject)=>{
        if (typeof window === 'undefined') {
            debug({
                message: '[SDKLoader]: window is undefined'
            });
            reject(new Error('Failed to load CSM SDK: window is undefined'));
        }
        if (window.CSM && !('__q__' in window.CSM)) {
            debug({
                message: '[SDKLoader]: window.CSM already exists'
            });
            resolve(window.CSM);
        }
        const script = document.createElement('script');
        script.src = (0, $gime3.getSDKSrc)({
            site: site,
            siteId: siteId,
            cloudId: cloudId,
            widgetId: widgetId,
            locale: locale
        });
        script.setAttribute('async', '');
        script.type = 'text/javascript';
        script.onerror = ()=>{
            reject(new Error('Failed to load CSM SDK script: onerror'));
        };
        script.onload = ()=>{
            debug({
                message: '[SDKLoader]: script onload called'
            });
            if (window.CSM && !('__q__' in window.CSM)) {
                debug({
                    message: '[SDKLoader]: CSM SDK found after script onload'
                });
                resolve(window.CSM);
            } else {
                debug({
                    message: '[SDKLoader]: CSM SDK not found after script onload'
                });
                reject(new Error('Failed to load CSM SDK: window.CSM is undefined'));
            }
        };
        debug({
            message: '[SDKLoader]: CSM SDK appended to body'
        });
        document.body.appendChild(script);
        /**
       * Preconnect to initialise the connection ahead of loading any iframe
       * which will load static assets from the JCS widget domain.
       */ const link = document.createElement('link');
        const linkHref = (0, $elFaG.getPreconnectHref)(site);
        link.rel = 'preconnect';
        link.href = linkHref;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
        debug({
            message: `[SDKLoader]: CSM SDK preconnecting to ${linkHref}`
        });
    });
    return $a90a1482a9ddbc73$var$promise;
};

});
parcelRegister("gime3", function(module, exports) {
$parcel$export(module.exports, "getSDKSrc", () => $41ff9587d14a2987$export$80f32c89482836ae);
const $41ff9587d14a2987$export$80f32c89482836ae = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, locale: locale })=>{
    const url = new URL(`/csm/widget/script.js`, `https://${site}`);
    if (siteId) {
        url.searchParams.set('siteId', siteId);
        url.searchParams.set('site', site);
    }
    if (cloudId) {
        url.searchParams.set('cloudId', cloudId);
        url.searchParams.set('site', site);
    }
    if (widgetId) url.searchParams.set('widgetId', widgetId);
    if (locale) url.searchParams.set('locale', locale);
    return url.toString();
};

});

parcelRegister("elFaG", function(module, exports) {
$parcel$export(module.exports, "getPreconnectHref", () => $eeaece5bd4b49fe8$export$270686f4186620fa);
const $eeaece5bd4b49fe8$var$JCS_WIDGET_DOMAIN_PROD = 'https://jcs-chat-widget.atlassian.com';
const $eeaece5bd4b49fe8$var$JCS_WIDGET_DOMAIN_STG = 'https://jcs-chat-widget.stg.atlassian.com';
const $eeaece5bd4b49fe8$export$270686f4186620fa = (site)=>{
    return /jira-dev\.com/.test(site) ? $eeaece5bd4b49fe8$var$JCS_WIDGET_DOMAIN_STG : $eeaece5bd4b49fe8$var$JCS_WIDGET_DOMAIN_PROD;
};

});





parcelRegister("1dpWV", function(module, exports) {
$parcel$export(module.exports, "AiSearchTrigger", () => $800afe327a2964b4$export$999e3594add7a0eb);
$parcel$export(module.exports, "AiSearchTriggerFloating", () => $800afe327a2964b4$export$950284a1ac54bad5);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $cufVT = parcelRequire("cufVT");

var $fizaR = parcelRequire("fizaR");

var $1jQXg = parcelRequire("1jQXg");

var $kG8hM = parcelRequire("kG8hM");

var $lJ3Zp = parcelRequire("lJ3Zp");
const $800afe327a2964b4$var$floatingBoxPositionStyles = null;
const $800afe327a2964b4$var$AiSearchTriggerBase = ()=>{
    const { ref: ref } = (0, $kG8hM.useTriggerIntersectionObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($800afe327a2964b4$var$ConnectedAiSearchInput, {
        ref: ref
    });
};
const $800afe327a2964b4$var$hiddenToBottomStyles = null;
const $800afe327a2964b4$var$hiddenToRightStyles = null;
/**
 * Connected "smart" UI component
 *
 * This component is connected to the AI search context and will update the value and onChange
 * functions when the user types in the input.
 *
 * It also handles the submission of the form and the creation of a new conversation.
 *
 * @private
 */ const $800afe327a2964b4$var$ConnectedAiSearchInput = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ className: className, hidden: hiddenByProp }, ref)=>{
    const { isTriggerVisible: isTriggerVisible } = (0, $kG8hM.useSearchTriggerVisibility)();
    const { value: value, onChange: onChange } = (0, $kG8hM.useAiSearch)();
    const hideTrigger = hiddenByProp || !isTriggerVisible;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lJ3Zp.AiSearchInput), {
        ref: ref,
        hidden: hideTrigger,
        // eslint-disable-next-line
        className: (0, $2R2iS.default)([
            hiddenByProp && "_t9ecdgi6",
            !isTriggerVisible && "_t9ec14jq",
            className
        ]),
        value: value,
        onChange: onChange,
        onSubmit: ({ message: message })=>{
            (0, $1jQXg.show)();
            (0, $1jQXg.open)();
            (0, $1jQXg.createNewConversation)(typeof message === 'string' && message.length > 0 ? {
                message: message
            } : {});
            onChange('');
        }
    });
});
const $800afe327a2964b4$var$ConditionalThemeProvider = ({ children: children, themeConfig: themeConfig })=>{
    if (themeConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fizaR.ThemeProvider), {
        themeConfig: themeConfig
    }, children);
    return children;
};
const $800afe327a2964b4$export$999e3594add7a0eb = ({ locale: locale, site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($800afe327a2964b4$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kG8hM.AiSearchTriggerContainer), {
        locale: locale,
        site: site,
        siteId: siteId,
        widgetId: widgetId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($800afe327a2964b4$var$AiSearchTriggerBase, null)));
/**
 * The connected search trigger but connected to the store to hide
 * if there is a visible `AiSearchTrigger` in the viewport
 *
 * @private
 */ const $800afe327a2964b4$var$AiSearchTriggerFloatingBase = ()=>{
    const [mounted, setMounted] = (0, $fc4bM.useState)(false);
    const hasIntersectingTrigger = (0, $kG8hM.useHasIntersectingTrigger)();
    const isHidden = !mounted || hasIntersectingTrigger;
    (0, $fc4bM.useLayoutEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($800afe327a2964b4$var$ConnectedAiSearchInput, {
        hidden: isHidden,
        className: (0, $2R2iS.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _kqsw1n9t _1ltvidpf _1xi2idpf _94n5xy5q _1pby16oo"
        ])
    });
};
const $800afe327a2964b4$export$950284a1ac54bad5 = ({ locale: locale, site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme, isSuppressed: isSuppressed = false })=>{
    (0, $fc4bM.useEffect)(()=>{
        if (isSuppressed && 'CSM' in window && window.CSM) {
            (0, $1jQXg.hide)();
            (0, $kG8hM.resetSearchTriggerVisibility)();
        }
    // The floating trigger reopens the widget; show() would add a corner launcher.
    }, [
        isSuppressed
    ]);
    if (isSuppressed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cufVT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($800afe327a2964b4$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kG8hM.AiSearchTriggerContainer), {
        locale: locale,
        site: site,
        siteId: siteId,
        widgetId: widgetId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($800afe327a2964b4$var$AiSearchTriggerFloatingBase, null))));
};

});
parcelRegister("fizaR", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $e1caf858bdaffa2a$export$d8964aec282183a3);

var $fc4bM = parcelRequire("fc4bM");

var $bbleC = parcelRequire("bbleC");

var $54fFy = parcelRequire("54fFy");

var $8Zunl = parcelRequire("8Zunl");

var $dX0hq = parcelRequire("dX0hq");
const $e1caf858bdaffa2a$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $e1caf858bdaffa2a$export$93d4e7f90805808f = ()=>{
    const context = (0, $fc4bM.useContext)($e1caf858bdaffa2a$export$2c657da244d00bd6);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};
const $e1caf858bdaffa2a$export$d8964aec282183a3 = ({ children: children, themeConfig: themeConfig, styles: styles = {} })=>{
    if (!themeConfig) throw new Error('themeConfig is required for the CSM Branding to works');
    const themeStyles = (0, $dX0hq.useGenerateThemeBranding)(themeConfig);
    const tokenStyles = (0, $fc4bM.useMemo)(()=>{
        const { borderRadius: borderRadius, space: space, colorRamps: colorRamps } = themeStyles;
        const iconColor = (0, $8Zunl.getContrastYIQ)(themeConfig.primaryColor) === 'dark' ? '#FFFFFF' : '#000000';
        const brandColor = (0, $54fFy.deriveBrandColors)(colorRamps, themeConfig.primaryColor);
        const properties = {
            [(0, $bbleC.csmAiTokens)['color.100']]: colorRamps.color100,
            [(0, $bbleC.csmAiTokens)['color.200']]: colorRamps.color200,
            [(0, $bbleC.csmAiTokens)['color.300']]: colorRamps.color300,
            [(0, $bbleC.csmAiTokens)['color.400']]: colorRamps.color400,
            [(0, $bbleC.csmAiTokens)['color.500']]: colorRamps.color500,
            [(0, $bbleC.csmAiTokens)['color.600']]: colorRamps.color600,
            [(0, $bbleC.csmAiTokens)['color.700']]: colorRamps.color700,
            [(0, $bbleC.csmAiTokens)['color.800']]: colorRamps.color800,
            [(0, $bbleC.csmAiTokens)['color.900']]: colorRamps.color900,
            [(0, $bbleC.csmAiTokens)['color.1000']]: colorRamps.color1000,
            [(0, $bbleC.csmAiTokens)['color.icon']]: iconColor,
            [(0, $bbleC.csmAiTokens)['color.brand']]: brandColor.brand,
            [(0, $bbleC.csmAiTokens)['color.brand.hover']]: brandColor.hover,
            [(0, $bbleC.csmAiTokens)['color.brand.active']]: brandColor.active,
            [(0, $bbleC.csmAiTokens)['color.brand.text']]: brandColor.brandText,
            [(0, $bbleC.csmAiTokens)['color.brand.hover.text']]: brandColor.hoverText,
            [(0, $bbleC.csmAiTokens)['color.brand.active.text']]: brandColor.activeText,
            [(0, $bbleC.csmAiTokens)['radius.lg']]: borderRadius.lg,
            [(0, $bbleC.csmAiTokens)['radius.md']]: borderRadius.md,
            [(0, $bbleC.csmAiTokens)['radius.sm']]: borderRadius.sm,
            [(0, $bbleC.csmAiTokens)['radius.container']]: borderRadius.container,
            [(0, $bbleC.csmAiTokens)['radius.widget']]: borderRadius.widget,
            [(0, $bbleC.csmAiTokens)['space.lg']]: space.lg,
            [(0, $bbleC.csmAiTokens)['space.md']]: space.md,
            [(0, $bbleC.csmAiTokens)['space.sm']]: space.sm
        };
        return properties;
    }, [
        themeConfig.primaryColor,
        themeStyles
    ]);
    const combineStyles = {
        ...tokenStyles,
        ...styles,
        // The wrapper only supplies CSS variables and does not participate in layout.
        display: 'contents'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e1caf858bdaffa2a$export$2c657da244d00bd6.Provider, {
        value: themeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        style: combineStyles
    }, children));
};

});
parcelRegister("bbleC", function(module, exports) {
$parcel$export(module.exports, "csmAiTokens", () => $19a2316da94c8d93$export$e26bc1991ee46534);
const $19a2316da94c8d93$export$e26bc1991ee46534 = {
    'color.100': '--csm-color-100',
    'color.200': '--csm-color-200',
    'color.300': '--csm-color-300',
    'color.400': '--csm-color-400',
    'color.500': '--csm-color-500',
    'color.600': '--csm-color-600',
    'color.700': '--csm-color-700',
    'color.800': '--csm-color-800',
    'color.900': '--csm-color-900',
    'color.1000': '--csm-color-1000',
    'color.icon': '--csm-color-icon',
    'color.brand': '--csm-color-brand',
    'color.brand.hover': '--csm-color-brand-hover',
    'color.brand.active': '--csm-color-brand-active',
    'color.brand.text': '--csm-color-brand-text',
    'color.brand.hover.text': '--csm-color-brand-hover-text',
    'color.brand.active.text': '--csm-color-brand-active-text',
    'radius.lg': '--csm-border-radius-lg',
    'radius.md': '--csm-border-radius-md',
    'radius.sm': '--csm-border-radius-sm',
    'radius.container': '--csm-border-radius-container',
    'radius.widget': '--csm-border-radius-widget',
    'space.lg': '--csm-space-lg',
    'space.md': '--csm-space-md',
    'space.sm': '--csm-space-sm'
};

});

parcelRegister("54fFy", function(module, exports) {
$parcel$export(module.exports, "deriveBrandColors", () => $e07a7edefe863fde$export$56e08ca4c9e5e798);

var $luTTC = parcelRequire("luTTC");
const $e07a7edefe863fde$var$clampRamp = (n)=>{
    const v = Math.max(100, Math.min(1000, n));
    return v;
};
const $e07a7edefe863fde$var$buildRampMap = (r)=>new Map([
        [
            100,
            r.color100
        ],
        [
            200,
            r.color200
        ],
        [
            300,
            r.color300
        ],
        [
            400,
            r.color400
        ],
        [
            500,
            r.color500
        ],
        [
            600,
            r.color600
        ],
        [
            700,
            r.color700
        ],
        [
            800,
            r.color800
        ],
        [
            900,
            r.color900
        ],
        [
            1000,
            r.color1000
        ]
    ]);
const $e07a7edefe863fde$var$textOn = (hex)=>{
    return (0, $luTTC.getContrastRatio)('#FFFFFF', hex) >= (0, $luTTC.getContrastRatio)('#000000', hex) ? '#FFFFFF' : '#000000';
};
const $e07a7edefe863fde$export$56e08ca4c9e5e798 = (ramps, primaryColor)=>{
    const rampMap = $e07a7edefe863fde$var$buildRampMap(ramps);
    const target = primaryColor.toLowerCase();
    let baseRamp = 400;
    for (const [n, hex] of rampMap)if (hex.toLowerCase() === target) {
        baseRamp = n;
        break;
    }
    const goLighter = baseRamp >= 800;
    const hoverRamp = $e07a7edefe863fde$var$clampRamp(baseRamp + (goLighter ? -200 : 200));
    const activeRamp = $e07a7edefe863fde$var$clampRamp(baseRamp + (goLighter ? -300 : 300));
    const brand = rampMap.get(baseRamp);
    const hover = rampMap.get(hoverRamp);
    const active = rampMap.get(activeRamp);
    return {
        brand: brand,
        hover: hover,
        active: active,
        brandText: $e07a7edefe863fde$var$textOn(brand),
        hoverText: $e07a7edefe863fde$var$textOn(hover),
        activeText: $e07a7edefe863fde$var$textOn(active)
    };
};

});
parcelRegister("luTTC", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $5034bab28c9129af$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $5034bab28c9129af$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $5034bab28c9129af$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $5034bab28c9129af$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $5034bab28c9129af$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $5034bab28c9129af$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $5034bab28c9129af$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $5034bab28c9129af$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $5034bab28c9129af$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $5034bab28c9129af$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $5034bab28c9129af$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $5034bab28c9129af$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $5034bab28c9129af$export$b36dbdb4f463f05c(hex) {
    if (!$5034bab28c9129af$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $5034bab28c9129af$export$1212645cf40ebf71(hex)
    ];
}
function $5034bab28c9129af$export$5a544e13ad4e1fa5(hex) {
    if (!$5034bab28c9129af$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $5034bab28c9129af$export$47ea145a83f50dc0(hex) {
    if (!$5034bab28c9129af$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $5034bab28c9129af$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $5034bab28c9129af$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $5034bab28c9129af$export$d061e26956a60b0a(foreground, background) {
    if (!$5034bab28c9129af$var$isValidHex(foreground) || !$5034bab28c9129af$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $5034bab28c9129af$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $5034bab28c9129af$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $5034bab28c9129af$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $5034bab28c9129af$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $5034bab28c9129af$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $5034bab28c9129af$var$rgbToLab(rgbA);
    let labB = $5034bab28c9129af$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $5034bab28c9129af$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});


parcelRegister("8Zunl", function(module, exports) {
$parcel$export(module.exports, "getContrastYIQ", () => $e602f142eff7c7e4$export$5f6ad4d710455f9b);
const $e602f142eff7c7e4$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `rgb(${$e602f142eff7c7e4$var$hexToInt(result, 1)}, ${$e602f142eff7c7e4$var$hexToInt(result, 2)},${$e602f142eff7c7e4$var$hexToInt(result, 3)})` : null;
};
const $e602f142eff7c7e4$var$hexToInt = (arr, index)=>parseInt(arr[index], 16);
const $e602f142eff7c7e4$export$5f6ad4d710455f9b = (hex)=>{
    const rgb = $e602f142eff7c7e4$var$hexToRgb(hex);
    const modifyRgb = rgb ? rgb.substring(4, rgb.length - 1).replace(/ /g, '').split(',') : [];
    const yiq = modifyRgb !== null && modifyRgb !== void 0 && modifyRgb.length ? (Number(modifyRgb[0]) * 299 + Number(modifyRgb[1]) * 587 + Number(modifyRgb[2]) * 114) / 1000 : 0;
    return yiq >= 128 ? 'light' : 'dark';
};

});

parcelRegister("dX0hq", function(module, exports) {
$parcel$export(module.exports, "useGenerateThemeBranding", () => $ea63c492341de616$export$4be1c3ef709f1b04);

var $fc4bM = parcelRequire("fc4bM");

var $if0sH = parcelRequire("if0sH");
const $ea63c492341de616$export$4be1c3ef709f1b04 = (themeConfig)=>{
    return (0, $fc4bM.useMemo)(()=>{
        const theme = (0, $if0sH.generateThemeBranding)(themeConfig);
        return theme;
    }, [
        themeConfig
    ]);
};

});
parcelRegister("if0sH", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $cad6be91b251b8d9$export$c1410db1c88d6e0f);

var $8tekC = parcelRequire("8tekC");
// Values are taken from figma [design](https://www.figma.com/design/sxl0BlQxD2g2eU27Rl2VhG/CSM-X-Loom-Support---In-Product?node-id=2351-34333&t=d8zOoCnHa3EJORFr-4), some are guesstimated
const $cad6be91b251b8d9$var$BORDER_RADIUS = {
    sharp: {
        lg: '8px',
        md: '4px',
        sm: '2px',
        container: '12px',
        widget: '12px'
    },
    normal: {
        lg: '10px',
        md: '6px',
        sm: '4px',
        container: '18px',
        widget: '18px'
    },
    rounded: {
        lg: '12px',
        md: '10px',
        sm: '6px',
        container: '22px',
        widget: '100%'
    }
};
const $cad6be91b251b8d9$var$SPACE = {
    cosy: {
        lg: '12px',
        md: '8px',
        sm: '8px'
    },
    comfortable: {
        lg: '16px',
        md: '12px',
        sm: '8px'
    },
    generous: {
        lg: '24px',
        md: '16px',
        sm: '8px'
    }
};
const $cad6be91b251b8d9$export$c1410db1c88d6e0f = (themeConfig)=>{
    const { radius: radius, space: space, primaryColor: primaryColor } = themeConfig;
    const colorRamps = (0, $8tekC.generateColorRamps)(primaryColor);
    const borderRadius = $cad6be91b251b8d9$var$BORDER_RADIUS[radius] || $cad6be91b251b8d9$var$BORDER_RADIUS.normal;
    const themeSpace = $cad6be91b251b8d9$var$SPACE[space] || $cad6be91b251b8d9$var$SPACE.comfortable;
    return {
        colorRamps: colorRamps,
        borderRadius: borderRadius,
        space: themeSpace
    };
};

});
parcelRegister("8tekC", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $940cdfe00c0c4bf7$export$3a180ce5632a9d57);

var $luTTC = parcelRequire("luTTC");

var $intRM = parcelRequire("intRM");

var $cz2H7 = parcelRequire("cz2H7");

var $1YZwQ = parcelRequire("1YZwQ");
const $940cdfe00c0c4bf7$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $940cdfe00c0c4bf7$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $940cdfe00c0c4bf7$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $luTTC.deltaE)((0, $luTTC.hexToRgb)(value), (0, $luTTC.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $940cdfe00c0c4bf7$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $luTTC.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $luTTC.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $luTTC.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $940cdfe00c0c4bf7$var$lowLuminanceContrastRatios : $940cdfe00c0c4bf7$var$highLuminanceContrastRatios;
    const brandRgba = (0, $luTTC.hexToRgbA)(brandColor);
    const hctColor = (0, $1YZwQ.Hct).fromInt((0, $intRM.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $intRM.rgbaFromArgb)((0, $1YZwQ.Hct).from(hctColor.hue, hctColor.chroma, (0, $cz2H7.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $luTTC.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $940cdfe00c0c4bf7$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $940cdfe00c0c4bf7$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $940cdfe00c0c4bf7$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("intRM", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $532ee340bc8b43c2$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $532ee340bc8b43c2$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $532ee340bc8b43c2$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $532ee340bc8b43c2$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $532ee340bc8b43c2$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $532ee340bc8b43c2$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $532ee340bc8b43c2$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $532ee340bc8b43c2$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $532ee340bc8b43c2$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $532ee340bc8b43c2$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $1nquw = parcelRequire("1nquw");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $532ee340bc8b43c2$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $532ee340bc8b43c2$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $532ee340bc8b43c2$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $532ee340bc8b43c2$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $532ee340bc8b43c2$export$7928ddf440518d19(linrgb) {
    const r = $532ee340bc8b43c2$export$777e26aa2ec02b1(linrgb[0]);
    const g = $532ee340bc8b43c2$export$777e26aa2ec02b1(linrgb[1]);
    const b = $532ee340bc8b43c2$export$777e26aa2ec02b1(linrgb[2]);
    return $532ee340bc8b43c2$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $532ee340bc8b43c2$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $532ee340bc8b43c2$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $532ee340bc8b43c2$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $532ee340bc8b43c2$var$blueFromArgb(argb) {
    return argb & 255;
}
function $532ee340bc8b43c2$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $532ee340bc8b43c2$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $532ee340bc8b43c2$export$777e26aa2ec02b1(linearR);
    const g = $532ee340bc8b43c2$export$777e26aa2ec02b1(linearG);
    const b = $532ee340bc8b43c2$export$777e26aa2ec02b1(linearB);
    return $532ee340bc8b43c2$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $532ee340bc8b43c2$var$xyzFromArgb(argb) {
    const r = $532ee340bc8b43c2$export$dec6bcda7bf47f2c($532ee340bc8b43c2$var$redFromArgb(argb));
    const g = $532ee340bc8b43c2$export$dec6bcda7bf47f2c($532ee340bc8b43c2$var$greenFromArgb(argb));
    const b = $532ee340bc8b43c2$export$dec6bcda7bf47f2c($532ee340bc8b43c2$var$blueFromArgb(argb));
    return $1nquw.matrixMultiply([
        r,
        g,
        b
    ], $532ee340bc8b43c2$var$SRGB_TO_XYZ);
}
function $532ee340bc8b43c2$export$ae8c227f6d0cbddb(lstar) {
    const y = $532ee340bc8b43c2$export$7f3071c4a5db05a0(lstar);
    const component = $532ee340bc8b43c2$export$777e26aa2ec02b1(y);
    return $532ee340bc8b43c2$export$58a74b9f8e513b7b(component, component, component);
}
function $532ee340bc8b43c2$export$8b8f7ef2e0a71c61(argb) {
    const y = $532ee340bc8b43c2$var$xyzFromArgb(argb)[1];
    return 116.0 * $532ee340bc8b43c2$var$labF(y / 100.0) - 16.0;
}
function $532ee340bc8b43c2$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $532ee340bc8b43c2$var$labInvf((lstar + 16.0) / 116.0);
}
function $532ee340bc8b43c2$export$bfc0d1dd9c64ada2(y) {
    return $532ee340bc8b43c2$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $532ee340bc8b43c2$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $532ee340bc8b43c2$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $1nquw.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $532ee340bc8b43c2$export$d4534a444c6526c3() {
    return $532ee340bc8b43c2$var$WHITE_POINT_D65;
}
function $532ee340bc8b43c2$export$fb1fd26c787a8662(argb) {
    const r = $532ee340bc8b43c2$var$redFromArgb(argb);
    const g = $532ee340bc8b43c2$var$greenFromArgb(argb);
    const b = $532ee340bc8b43c2$var$blueFromArgb(argb);
    const a = $532ee340bc8b43c2$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $532ee340bc8b43c2$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $532ee340bc8b43c2$var$clampComponent(r);
    const gValue = $532ee340bc8b43c2$var$clampComponent(g);
    const bValue = $532ee340bc8b43c2$var$clampComponent(b);
    const aValue = $532ee340bc8b43c2$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $532ee340bc8b43c2$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $532ee340bc8b43c2$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $532ee340bc8b43c2$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("1nquw", function(module, exports) {
$parcel$export(module.exports, "signum", () => $4e23635123476946$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $4e23635123476946$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $4e23635123476946$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $4e23635123476946$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $4e23635123476946$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $4e23635123476946$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $4e23635123476946$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $4e23635123476946$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $4e23635123476946$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $4e23635123476946$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $4e23635123476946$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $4e23635123476946$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("cz2H7", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $5015626dcab17331$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $intRM = parcelRequire("intRM");

var $1nquw = parcelRequire("1nquw");
class $5015626dcab17331$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $1nquw.clampDouble(0.0, 100.0, toneA);
        toneB = $1nquw.clampDouble(0.0, 100.0, toneB);
        return $5015626dcab17331$export$656ae42051d0ca86.ratioOfYs($intRM.yFromLstar(toneA), $intRM.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $intRM.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $5015626dcab17331$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $intRM.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $intRM.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $5015626dcab17331$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $intRM.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $5015626dcab17331$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $5015626dcab17331$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("1YZwQ", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $ec7fe862a0af69f6$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $intRM = parcelRequire("intRM");

var $1nquw = parcelRequire("1nquw");
class $ec7fe862a0af69f6$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $ec7fe862a0af69f6$export$91d2e033b3924566($ec7fe862a0af69f6$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $ec7fe862a0af69f6$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($ec7fe862a0af69f6$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($ec7fe862a0af69f6$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($ec7fe862a0af69f6$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $ec7fe862a0af69f6$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $intRM.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $ec7fe862a0af69f6$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $intRM.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $ec7fe862a0af69f6$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $ec7fe862a0af69f6$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $ec7fe862a0af69f6$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $ec7fe862a0af69f6$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $intRM.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $ec7fe862a0af69f6$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $ec7fe862a0af69f6$var$Cam16.fromIntInViewingConditions(argb, $ec7fe862a0af69f6$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $intRM.linearized(red);
        const greenL = $intRM.linearized(green);
        const blueL = $intRM.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $1nquw.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $1nquw.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $1nquw.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $ec7fe862a0af69f6$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $ec7fe862a0af69f6$var$Cam16.fromJchInViewingConditions(j, c, h, $ec7fe862a0af69f6$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $ec7fe862a0af69f6$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $ec7fe862a0af69f6$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $ec7fe862a0af69f6$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $ec7fe862a0af69f6$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($ec7fe862a0af69f6$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $1nquw.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $1nquw.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $1nquw.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $intRM.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $1nquw.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $1nquw.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $1nquw.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $ec7fe862a0af69f6$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $1nquw.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $1nquw.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $1nquw.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $ec7fe862a0af69f6$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $1nquw.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $1nquw.matrixMultiply(linrgb, $ec7fe862a0af69f6$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $ec7fe862a0af69f6$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $ec7fe862a0af69f6$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $ec7fe862a0af69f6$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $ec7fe862a0af69f6$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $ec7fe862a0af69f6$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $ec7fe862a0af69f6$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $ec7fe862a0af69f6$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $ec7fe862a0af69f6$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $ec7fe862a0af69f6$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $ec7fe862a0af69f6$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($ec7fe862a0af69f6$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($ec7fe862a0af69f6$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($ec7fe862a0af69f6$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $ec7fe862a0af69f6$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $ec7fe862a0af69f6$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $ec7fe862a0af69f6$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($ec7fe862a0af69f6$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $ec7fe862a0af69f6$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $ec7fe862a0af69f6$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $ec7fe862a0af69f6$var$HctSolver.criticalPlaneBelow($ec7fe862a0af69f6$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $ec7fe862a0af69f6$var$HctSolver.criticalPlaneAbove($ec7fe862a0af69f6$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $ec7fe862a0af69f6$var$HctSolver.criticalPlaneAbove($ec7fe862a0af69f6$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $ec7fe862a0af69f6$var$HctSolver.criticalPlaneBelow($ec7fe862a0af69f6$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $ec7fe862a0af69f6$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $ec7fe862a0af69f6$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $ec7fe862a0af69f6$var$HctSolver.hueOf(mid);
                    if ($ec7fe862a0af69f6$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $ec7fe862a0af69f6$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $1nquw.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $ec7fe862a0af69f6$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $ec7fe862a0af69f6$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $ec7fe862a0af69f6$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $ec7fe862a0af69f6$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $1nquw.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $ec7fe862a0af69f6$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $ec7fe862a0af69f6$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $ec7fe862a0af69f6$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $ec7fe862a0af69f6$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $intRM.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $intRM.argbFromLstar(lstar);
        hueDegrees = $1nquw.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $intRM.yFromLstar(lstar);
        const exactAnswer = $ec7fe862a0af69f6$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $ec7fe862a0af69f6$var$HctSolver.bisectToLimit(y, hueRadians);
        return $intRM.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $ec7fe862a0af69f6$var$Cam16.fromInt($ec7fe862a0af69f6$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $ec7fe862a0af69f6$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $ec7fe862a0af69f6$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $intRM.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $intRM.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $1nquw.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $1nquw.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $intRM.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $ec7fe862a0af69f6$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});





parcelRegister("kG8hM", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerContainer", () => $a82adcdac9e78c3e$export$c23f578d84bfd719);
$parcel$export(module.exports, "resetSearchTriggerVisibility", () => $a82adcdac9e78c3e$export$f6e21f618e9dbf8a);
$parcel$export(module.exports, "useAiSearch", () => $a82adcdac9e78c3e$export$77f51d599ca38b3);
$parcel$export(module.exports, "useTriggerIntersectionObserver", () => $a82adcdac9e78c3e$export$d341e445290d4887);
$parcel$export(module.exports, "useHasIntersectingTrigger", () => $a82adcdac9e78c3e$export$e134485de3777bd2);
$parcel$export(module.exports, "useSearchTriggerVisibility", () => $a82adcdac9e78c3e$export$7f622cc0692430e8);

var $fc4bM = parcelRequire("fc4bM");

var $ik3UL = parcelRequire("ik3UL");
var $5nVr1 = parcelRequire("5nVr1");
var $ipn74 = parcelRequire("ipn74");
var $kMxBB = parcelRequire("kMxBB");

var $1jQXg = parcelRequire("1jQXg");

var $4qJL8 = parcelRequire("4qJL8");
const $a82adcdac9e78c3e$var$actions = {
    resetWidgetVisibility: ()=>({ setState: setState })=>{
            setState({
                widgetVisibility: 'hidden'
            });
        },
    setInputValue: (inputValue)=>({ setState: setState })=>{
            setState({
                inputValue: inputValue
            });
        },
    observe: (id, element)=>({ setState: setState, getState: getState })=>{
            const { triggers: triggers, observer: currentObserver } = getState();
            const observer = currentObserver ?? new IntersectionObserver(([entry])=>{
                setState({
                    triggers: {
                        ...triggers,
                        [id]: {
                            element: element,
                            isIntersecting: entry.isIntersecting
                        }
                    }
                });
            }, {
                threshold: 0
            });
            setState({
                observer: observer
            });
            observer.observe(element);
        },
    disconnect: (id)=>({ setState: setState, getState: getState })=>{
            const { triggers: prevTriggers, observer: observer } = getState();
            if (observer && prevTriggers[id]) observer.unobserve(prevTriggers[id].element);
            const triggers = {
                ...prevTriggers
            };
            delete triggers[id];
            setState({
                triggers: triggers
            });
        }
};
const $a82adcdac9e78c3e$var$StoreContainer = (0, $ik3UL.createContainer)();
const $a82adcdac9e78c3e$export$c23f578d84bfd719 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a82adcdac9e78c3e$var$StoreContainer, {
        ...props,
        isGlobal: true
    }, children);
};
const $a82adcdac9e78c3e$var$store = (0, $ipn74.createStore)({
    name: 'csm-ai-search-trigger-store',
    initialState: {
        inputValue: '',
        widgetVisibility: null,
        triggers: {},
        observer: null
    },
    actions: $a82adcdac9e78c3e$var$actions,
    containedBy: $a82adcdac9e78c3e$var$StoreContainer,
    handlers: {
        onInit: ()=>({ setState: setState }, { locale: locale, site: site, siteId: siteId, widgetId: widgetId })=>{
                (0, $4qJL8.initCSM)({
                    locale: locale,
                    site: site,
                    siteId: siteId,
                    widgetId: widgetId
                });
                (0, $1jQXg.hide)();
                setState({
                    widgetVisibility: 'hidden'
                });
                (0, $1jQXg.onOpen)(()=>{
                    setState({
                        widgetVisibility: 'visible'
                    });
                });
                (0, $1jQXg.onClose)(()=>{
                    (0, $1jQXg.getCurrentConversation)((conversation)=>{
                        if (!conversation) {
                            (0, $1jQXg.hide)();
                            setState({
                                widgetVisibility: 'hidden'
                            });
                        }
                    });
                });
            }
    }
});
const $a82adcdac9e78c3e$export$f6e21f618e9dbf8a = ()=>{
    if ((0, $kMxBB.defaultRegistry).hasStore($a82adcdac9e78c3e$var$store)) (0, $kMxBB.defaultRegistry).getStore($a82adcdac9e78c3e$var$store).actions.resetWidgetVisibility();
};
const $a82adcdac9e78c3e$var$searchFieldValueSelector = (state)=>state.inputValue;
const $a82adcdac9e78c3e$var$useSearchFieldValueHook = (0, $5nVr1.createHook)($a82adcdac9e78c3e$var$store, {
    selector: $a82adcdac9e78c3e$var$searchFieldValueSelector
});
const $a82adcdac9e78c3e$export$77f51d599ca38b3 = ()=>{
    const [inputValue, { setInputValue: setInputValue }] = $a82adcdac9e78c3e$var$useSearchFieldValueHook();
    return {
        value: inputValue,
        onChange: (value)=>setInputValue(value)
    };
};
const $a82adcdac9e78c3e$var$useAiSearchStore = (0, $5nVr1.createHook)($a82adcdac9e78c3e$var$store);
const $a82adcdac9e78c3e$export$d341e445290d4887 = ()=>{
    const id = (0, $fc4bM.useId)();
    const [_, { observe: observe, disconnect: disconnect }] = $a82adcdac9e78c3e$var$useAiSearchStore();
    const ref = (0, $fc4bM.useCallback)((element)=>{
        if (element) observe(id, element);
        else disconnect(id);
    }, [
        observe,
        disconnect,
        id
    ]);
    return {
        ref: ref
    };
};
const $a82adcdac9e78c3e$var$hasIntersectingTriggerSelector = (state)=>{
    return Object.values(state.triggers).some((trigger)=>trigger.isIntersecting);
};
const $a82adcdac9e78c3e$var$useHasIntersectingTriggerHook = (0, $5nVr1.createHook)($a82adcdac9e78c3e$var$store, {
    selector: $a82adcdac9e78c3e$var$hasIntersectingTriggerSelector
});
const $a82adcdac9e78c3e$export$e134485de3777bd2 = ()=>{
    const [hasIntersectingTrigger] = $a82adcdac9e78c3e$var$useHasIntersectingTriggerHook();
    return hasIntersectingTrigger;
};
const $a82adcdac9e78c3e$export$7f622cc0692430e8 = ()=>{
    const [{ widgetVisibility: widgetVisibility }] = $a82adcdac9e78c3e$var$useAiSearchStore();
    return {
        isTriggerVisible: widgetVisibility !== 'visible'
    };
};

});

parcelRegister("lJ3Zp", function(module, exports) {
$parcel$export(module.exports, "AiSearchInput", () => $622c09cc9a3f4401$export$39dac845faefc1b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $k8Adr = parcelRequire("k8Adr");

var $dVxDa = parcelRequire("dVxDa");

var $6yuI9 = parcelRequire("6yuI9");

var $11s6V = parcelRequire("11s6V");

var $5RUmk = parcelRequire("5RUmk");

var $l6ypc = parcelRequire("l6ypc");
const $622c09cc9a3f4401$var$formStyles = null;
const $622c09cc9a3f4401$var$hiddenStyles = null;
const $622c09cc9a3f4401$export$39dac845faefc1b = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ className: className, hidden: hidden, onChange: onChange, onSubmit: onSubmit, value: value }, ref)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const id = (0, $fc4bM.useId)();
    const formLabelledById = `form-${id}-description`;
    const handleSubmit = (e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const message = formData.get('message');
        if (typeof message !== 'string') throw new Error('Message is not a string');
        onSubmit({
            message: message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("form", {
        ref: ref,
        "aria-hidden": hidden,
        // eslint-disable-next-line
        className: (0, $2R2iS.default)([
            "_v56410bs _1e0c1txw _4cvr1h6o _1bsb1ns9 _m6k4gioh _w6ng15vq _t9ecmk3q",
            hidden && "_lcxvglyw _tzy4idpf _3um015vq",
            className
        ]),
        "aria-labelledby": formLabelledById,
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVxDa.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        id: formLabelledById
    }, formatMessage((0, $l6ypc.messages).searchFieldDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6yuI9.SearchTrigger), {
        value: value,
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("label", {
            htmlFor: id
        }, formatMessage((0, $l6ypc.messages).searchPlaceholder)),
        submitButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUmk.SearchTriggerSubmitButton), {
            as: "button",
            type: "submit"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $11s6V.SearchTriggerInputElement), {
        id: id,
        inputLabel: formatMessage((0, $l6ypc.messages).searchInputLabel)
    })));
});

});
parcelRegister("6yuI9", function(module, exports) {
$parcel$export(module.exports, "SearchTrigger", () => $b47f75268089232c$export$d846b13db73b361e);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $lSZGi = parcelRequire("lSZGi");

var $dVxDa = parcelRequire("dVxDa");

var $bq9CU = parcelRequire("bq9CU");
const $b47f75268089232c$var$EXPANDED_WIDTH = '320px';
const $b47f75268089232c$var$rootStyles = null;
const $b47f75268089232c$var$hoverFocusStyles = null;
const $b47f75268089232c$var$expandedStyles = null;
const $b47f75268089232c$var$boxStyles = null;
const $b47f75268089232c$var$subtlePlaceholderStyles = null;
const $b47f75268089232c$var$layoutStyles = null;
const $b47f75268089232c$var$inputContainerStyles = null;
const $b47f75268089232c$var$labelOverlayStyles = null;
const $b47f75268089232c$var$buttonContainerStyles = null;
const $b47f75268089232c$export$d846b13db73b361e = ({ children: children, value: value = '', onChange: onChange, placeholder: placeholder, submitButton: submitButton, interactive: interactive = true })=>{
    const [isHovered, setIsHovered] = (0, $fc4bM.useState)(false);
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(false);
    const isAtRest = value.length === 0 && !isFocused;
    const isExpanded = !isAtRest || isHovered;
    const VisuallyHiddenPlaceholder = isFocused || value.length > 0 ? (0, $dVxDa.default) : (0, $fc4bM.Fragment);
    const contextValue = (0, $fc4bM.useMemo)(()=>{
        return {
            isExpanded: isExpanded,
            isHovered: isHovered,
            isFocused: isFocused,
            setIsHovered: setIsHovered,
            setIsFocused: setIsFocused,
            value: value,
            onChange: onChange,
            isAtRest: isAtRest,
            interactive: interactive
        };
    }, [
        isExpanded,
        isHovered,
        isFocused,
        value,
        onChange,
        isAtRest,
        interactive
    ]);
    const mouseEnterLeaverProps = interactive ? {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    } : {};
    return /*#__PURE__*/ $fc4bM.createElement((0, $bq9CU.SearchTriggerInputContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_v564130x _1bsbp3fh _m6k41jlu",
            interactive && "_195pnklw _1chpnklw",
            interactive && isExpanded && "_1bsbnklw"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        ...mouseEnterLeaverProps,
        className: (0, $2R2iS.default)([
            "_2rko1rr0 _zulp12x7 _v5641yk7 _11c81d4k _1h6dysee _1dqonqa1 _1bsb1osq _vchhusvi _1e0c1txw _4cvr1fhb _bfhkvuon _16qst7xp _tzy4kb7n _3um0ewfl _w6ng15vq _t9ecmk3q _y4tiu2gc _syazi7uo _4t3i8vuz"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1e0c1txw _1bsb1osq"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_kqswh2mm _1bsb1osq"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp12x7 _1wpz1h6o _1e0c1txw _kqswstnw _1ltvpxbi _154iidpf _94n5idpf _lcxvglyw _80om1kdv",
            isAtRest && "_syaz1rpy"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ $fc4bM.createElement(VisuallyHiddenPlaceholder, null, placeholder)), children), /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1wpz1h6o"
        ])
    }, submitButton)))));
};

});
parcelRegister("lSZGi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cb129d05fcf195c63eb8b31a673cd76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $feee7cb85f140a9b$var$_react = $feee7cb85f140a9b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $feee7cb85f140a9b$var$_iconNew = $feee7cb85f140a9b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $feee7cb85f140a9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-chat
 * Usage guidance:
 * Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $feee7cb85f140a9b$var$AiChatIcon = (props)=>/*#__PURE__*/ $feee7cb85f140a9b$var$_react.default.createElement($feee7cb85f140a9b$var$_iconNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$feee7cb85f140a9b$var$AiChatIcon.displayName = 'AiChatIcon';
var $feee7cb85f140a9b$var$_default = module.exports.default = $feee7cb85f140a9b$var$AiChatIcon;

});

parcelRegister("bq9CU", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputContext", () => $614927742702f82a$export$9cec4f4bc0c5ec28);
$parcel$export(module.exports, "useSearchTriggerInput", () => $614927742702f82a$export$ffbcaaf65823abae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");
const $614927742702f82a$export$9cec4f4bc0c5ec28 = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $614927742702f82a$export$ffbcaaf65823abae = ()=>{
    const context = (0, $fc4bM.useContext)($614927742702f82a$export$9cec4f4bc0c5ec28);
    if (!context) throw new Error('useSearchTriggerInput must be used within a SearchTriggerInputProvider');
    return context;
};

});


parcelRegister("11s6V", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputElement", () => $d8efc5838e394b51$export$42ccbc2c6177b53f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bq9CU = parcelRequire("bq9CU");
const $d8efc5838e394b51$var$inputStyles = null;
const $d8efc5838e394b51$export$42ccbc2c6177b53f = ({ id: id, inputLabel: inputLabel })=>{
    const { value: value, onChange: onChange, setIsFocused: setIsFocused } = (0, $bq9CU.useSearchTriggerInput)();
    // store the local value in state to avoid the input being "locked in" as a Latin character
    const [localValue, setLocalValue] = (0, $fc4bM.useState)(value);
    const isComposingRef = (0, $fc4bM.useRef)(false);
    // Sync local value with controlled value when not composing
    (0, $fc4bM.useEffect)(()=>{
        if (!isComposingRef.current) setLocalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ $fc4bM.createElement("input", {
        "data-testid": "csm-ai-search-input",
        id: id,
        value: localValue,
        name: "message",
        onChange: (e)=>{
            const newValue = e.currentTarget.value;
            setLocalValue(newValue);
            // Only propagate to parent when not composing (IME input)
            // This fixes Japanese/Chinese/Korean input where the first character
            // would otherwise be "locked in" as a Latin character
            if (!isComposingRef.current) onChange === null || onChange === void 0 || onChange(newValue);
        },
        onCompositionStart: ()=>{
            isComposingRef.current = true;
        },
        onCompositionEnd: (e)=>{
            isComposingRef.current = false;
            // Commit the final composed value after IME conversion completes
            onChange === null || onChange === void 0 || onChange(e.currentTarget.value);
        },
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false),
        autoComplete: "off",
        spellCheck: "false",
        "aria-label": inputLabel,
        className: (0, $2R2iS.default)([
            "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _11c81d4k _r06hglyw _bfhk1j28 _4t3i1osq _1bsb1osq _syazi7uo _vchhusvi _1q51idpf _85i5idpf _bozgoahv _y4tiu2gc"
        ])
    });
};

});

parcelRegister("5RUmk", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerSubmitButton", () => $7cf1444c42fc12ae$export$c4e4405f3e81e277);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $9R2Ny = parcelRequire("9R2Ny");

var $bq9CU = parcelRequire("bq9CU");

var $k11QZ = parcelRequire("k11QZ");
// TODO: connect with ADS to figure out the best approach to use dynamic value with cssMap, to avoid manually use the csm token
const $7cf1444c42fc12ae$var$styles = {
    pressable: "_2rko1qll _19itglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1h1tkb7n _4t3i14no _1tkezwfg _bfhki8nm _13ix1yyw _mizu1g87",
    usedState: "_v564k6bl _bfhk1y25 _30l3czge _irr31hsi _1ggl5xtf _9h8h15cr _1di6jowl",
    cursorPointer: "_80omtlke"
};
const $7cf1444c42fc12ae$var$buttonMotionStyles = null;
const $7cf1444c42fc12ae$export$c4e4405f3e81e277 = ({ ...props })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isExpanded: isExpanded, interactive: interactive } = (0, $bq9CU.useSearchTriggerInput)();
    const isDimmed = !isExpanded;
    if (props.as === 'button') {
        const { as: _, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("button", {
            "aria-disabled": isDimmed,
            ...rest,
            className: (0, $2R2iS.default)([
                $7cf1444c42fc12ae$var$styles.pressable,
                $7cf1444c42fc12ae$var$styles.cursorPointer,
                interactive && !isDimmed && $7cf1444c42fc12ae$var$styles.usedState,
                interactive && !isDimmed && "_v564k6bl _1ggl5xtf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9R2Ny))), {
            label: formatMessage((0, $k11QZ.messages).searchButtonLabel)
        }));
    }
    const { as: _, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        ...rest,
        className: (0, $2R2iS.default)([
            $7cf1444c42fc12ae$var$styles.pressable,
            interactive && !isDimmed && $7cf1444c42fc12ae$var$styles.usedState
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9R2Ny))), {
        label: formatMessage((0, $k11QZ.messages).searchButtonLabel)
    }));
};

});
parcelRegister("9R2Ny", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5531747c7120d806a0ad0879344fad9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72cb3bf646d44508$var$_react = $72cb3bf646d44508$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $72cb3bf646d44508$var$_iconNew = $72cb3bf646d44508$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $72cb3bf646d44508$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-right
 * Usage guidance:
 * Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72cb3bf646d44508$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $72cb3bf646d44508$var$_react.default.createElement($72cb3bf646d44508$var$_iconNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$72cb3bf646d44508$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $72cb3bf646d44508$var$_default = module.exports.default = $72cb3bf646d44508$var$ArrowRightIcon;

});

parcelRegister("k11QZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2751ced56b3e5d06$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $2751ced56b3e5d06$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    searchButtonLabel: {
        id: 'csm.chat.widget.search.trigger.search.button.label.non-fin',
        defaultMessage: 'Search with AI',
        description: 'label for the CSM chat widget search trigger button'
    }
});

});


parcelRegister("l6ypc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $07e32c32e07fe52c$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $07e32c32e07fe52c$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    searchPlaceholder: {
        id: 'csm.chat.widget.search.trigger.search.placeholder',
        defaultMessage: 'Ask anything',
        description: 'placeholder for the CSM chat widget search trigger input'
    },
    searchFieldDescription: {
        id: 'csm.chat.widget.search.trigger.search.field.description',
        defaultMessage: 'Submit your question to get chat with and get answers from our AI assistant',
        description: 'Describes that the input field upon submission will trigger the chat widget'
    },
    searchInputLabel: {
        id: 'csm.chat.widget.search.trigger.search.input.label',
        defaultMessage: 'Chat search trigger input',
        description: 'Accessibility label for chat search input'
    }
});

});





parcelRegister("9RQSk", function(module, exports) {
$parcel$export(module.exports, "HubsDocumentTitle", () => $321c75e7db1c310e$export$9b71b60159f818b1);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $j9hi1 = parcelRequire("j9hi1");
const $321c75e7db1c310e$export$9b71b60159f818b1 = ({ title: title, shouldRenderDocumentTitle: shouldRenderDocumentTitle, children: children })=>{
    if (!title || !shouldRenderDocumentTitle) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j9hi1))), {
        title: title,
        children: children
    });
};

});

parcelRegister("7VaO1", function(module, exports) {
$parcel$export(module.exports, "HubPageBreadcrumbs", () => $e0be74252ac9a53d$export$f3c1ece3750b1716);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $hPVoC = parcelRequire("hPVoC");

var $2MYZ0 = parcelRequire("2MYZ0");

var $e5bIT = parcelRequire("e5bIT");
const $e0be74252ac9a53d$export$f3c1ece3750b1716 = (props)=>{
    const { pageName: pageName, pageType: pageType } = props;
    const pagePath = props.pagePath;
    const parentFolderName = pageType === 'custom' ? props.parentFolderName : undefined;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [isBreadcrumbsEnabled] = (0, $2MYZ0.useIsHubFeatureEnabled)([
        (0, $2MYZ0.HUB_FEATURES).BREADCRUMBS
    ]);
    const items = (0, $fc4bM.useMemo)(()=>{
        const normalizedPageName = pageName === null || pageName === void 0 ? void 0 : pageName.trim();
        if (!isBreadcrumbsEnabled || !normalizedPageName) return [];
        const homeItem = {
            href: '/',
            id: 'home',
            text: formatMessage((0, $e5bIT.default).homeBreadcrumb)
        };
        if (pageType === 'portal') {
            if (!pagePath) return [];
            return [
                homeItem,
                {
                    href: pagePath,
                    id: 'portal',
                    text: normalizedPageName
                }
            ];
        }
        const normalizedParentFolderName = parentFolderName === null || parentFolderName === void 0 ? void 0 : parentFolderName.trim();
        return [
            homeItem,
            ...normalizedParentFolderName ? [
                {
                    id: 'parent-folder',
                    text: normalizedParentFolderName
                }
            ] : [],
            {
                href: pagePath,
                id: 'custom-page',
                text: normalizedPageName
            }
        ];
    }, [
        formatMessage,
        isBreadcrumbsEnabled,
        pageName,
        pagePath,
        pageType,
        parentFolderName
    ]);
    (0, $hPVoC.useRegisterHubBreadcrumbs)(items);
    return null;
};

});
parcelRegister("e5bIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $11110b621fa704ee$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $11110b621fa704ee$var$_default_1 = (0, $8p5Cv.defineMessages)({
    homeBreadcrumb: {
        id: 'hub.hub.homeBreadcrumb',
        defaultMessage: 'Home',
        description: 'Breadcrumb label linking back to the Help Hub home page.'
    },
    hubLoadingSpinnerLabel: {
        id: 'company-hub.hub.loading-spinner-label',
        defaultMessage: 'Loading hub',
        description: 'Accessible label for the loading spinner shown while the company hub page is being loaded.'
    }
});
var $11110b621fa704ee$export$2e2bcd8739ae039 = $11110b621fa704ee$var$_default_1;

});



parcelRegister("2JK5q", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $78118db3f19834b4$export$f61abf052f87399f);
$parcel$export(module.exports, "withBannerBackgroundColor", () => $78118db3f19834b4$export$f6b6d100e7beb8c8);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $aQNcS = parcelRequire("aQNcS");
// 800px is normal width
const $78118db3f19834b4$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $78118db3f19834b4$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $78118db3f19834b4$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $78118db3f19834b4$var$GRID_XXWIDE_WIDTH = '1200px';
const $78118db3f19834b4$var$GRID_NOTE_WIDTH = '480px';
const $78118db3f19834b4$var$GRID_FULL_WIDTH = '100%';
const $78118db3f19834b4$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $78118db3f19834b4$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $78118db3f19834b4$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $78118db3f19834b4$var$GRID_WIDE_WIDTH;
        case 'note':
            return $78118db3f19834b4$var$GRID_NOTE_WIDTH;
        case 'full-width':
            return $78118db3f19834b4$var$GRID_FULL_WIDTH;
        default:
            return $78118db3f19834b4$var$GRID_NORMAL_WIDTH;
    }
};
const $78118db3f19834b4$export$f6b6d100e7beb8c8 = (InnerComponent)=>{
    return (props)=>{
        const hubContext = (0, $aQNcS.useHubContext)();
        const bannerBackgroundColor = hubContext.branding.colors.primary;
        return /*#__PURE__*/ (0, $3LM7S.jsx)(InnerComponent, {
            ...props,
            bannerBackgroundColor: bannerBackgroundColor
        });
    };
};

});


parcelRegister("3isMq", function(module, exports) {
$parcel$export(module.exports, "isMigratedHelpCenterReviewEnabled", () => $1730c22b6200cd5a$export$3062d1bfac14e492);
$parcel$export(module.exports, "isMigratedHelpCenterReviewPath", () => $1730c22b6200cd5a$export$8ec66b40f5f77868);
$parcel$export(module.exports, "buildMigratedHelpCenterEditorUrl", () => $1730c22b6200cd5a$export$a4eb20b7850747d9);
$parcel$export(module.exports, "leaveMigratedHelpCenterReview", () => $1730c22b6200cd5a$export$f295d6724fc207e2);

var $9mazR = parcelRequire("9mazR");

var $k2M4v = parcelRequire("k2M4v");

var $aIHAn = parcelRequire("aIHAn");

var $esgVk = parcelRequire("esgVk");
const $1730c22b6200cd5a$var$MIGRATED_HELP_CENTER_SANDBOX_PATH = /^\/helpcenter\/test\/[^/]+(?:\/|$)/;
const $1730c22b6200cd5a$var$MIGRATED_HELP_CENTER_REVIEW_FLAG = 'enable-help-hub-migration';
const $1730c22b6200cd5a$export$3062d1bfac14e492 = ()=>(0, $k2M4v.default).checkGate($1730c22b6200cd5a$var$MIGRATED_HELP_CENTER_REVIEW_FLAG);
const $1730c22b6200cd5a$export$8ec66b40f5f77868 = (pathname)=>$1730c22b6200cd5a$var$MIGRATED_HELP_CENTER_SANDBOX_PATH.test(pathname) || (0, $aIHAn.isDefaultHelpCenterPortalsPreviewPath)(pathname);
const $1730c22b6200cd5a$export$a4eb20b7850747d9 = (input)=>`/helpcenter-management/${encodeURIComponent(input.helpCenterId)}/edit-hub`;
const $1730c22b6200cd5a$export$f295d6724fc207e2 = ()=>{
    (0, $esgVk.replace)((0, $9mazR.HELP_CENTERS_MANAGEMENT_BASE_PATH));
};

});

parcelRegister("jqBmV", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => (parcelRequire("hkB55")).HubAnonymousLayout);
parcelRequire("hkB55");

});
parcelRegister("hkB55", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => $3408fd7489314298$export$ae9644df85d50589);
/* hub-anonymous-layout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $fOCtI = parcelRequire("fOCtI");

var $4m70N = parcelRequire("4m70N");
const $3408fd7489314298$var$anonymousStyles = null;
const $3408fd7489314298$export$ae9644df85d50589 = ({ children: children })=>/*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1e0c1txw _2lx21bp4 _19pk1ai2 _18u01wug _2hwx1wug _1bsb1osq _p12f1osq _1tke1586 _1wpz1y6m _1c421osq _138yidpf"
        ]),
        style: {
            "--_19v4s1f-": (0, $8xbhL.default)($fOCtI.multiple(15).unitless, "px", "-"),
            "--_jnopm3": (0, $8xbhL.default)($fOCtI.multiple(52).unitless, "px")
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4m70N.NoteBackground), null, children));

});


parcelRegister("fy0p0", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => (parcelRequire("bM9x6")).HubAvatarMenuOptions);

var $bM9x6 = parcelRequire("bM9x6");

});
parcelRegister("bM9x6", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => $fea42ba3c0a3aecc$export$4f0698e82fb00313);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $io4o2 = parcelRequire("io4o2");

var $fecgs = parcelRequire("fecgs");

var $1HEEa = parcelRequire("1HEEa");

var $3C7EO = parcelRequire("3C7EO");

var $gpjDl = parcelRequire("gpjDl");

var $lpWRK = parcelRequire("lpWRK");

var $k2M4v = parcelRequire("k2M4v");

var $bKfoa = parcelRequire("bKfoa");

var $3rlj9 = parcelRequire("3rlj9");

var $1eY13 = parcelRequire("1eY13");

var $haEws = parcelRequire("haEws");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");
parcelRequire("aGypY");
var $hzlql = parcelRequire("hzlql");

var $6AE1S = parcelRequire("6AE1S");

var $fqx4Q = parcelRequire("fqx4Q");

var $bEtKM = parcelRequire("bEtKM");
const $fea42ba3c0a3aecc$var$HubAvatarMenuOptionsComponent = ({ fetchUser: fetchUser, fetchUserRequestsCounts: fetchUserRequestsCounts, fetchOrganisations: fetchOrganisations, customMenuLinks: customMenuLinks, myRequestCount: myRequestCount = 0, pendingApprovalCount: pendingApprovalCount = 0, approvalCount: approvalCount = 0 })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    // Fetch user data and request counts on component mount
    (0, $fc4bM.useEffect)(()=>{
        fetchUser();
        fetchOrganisations();
        fetchUserRequestsCounts();
    }, [
        fetchUser,
        fetchOrganisations,
        fetchUserRequestsCounts
    ]);
    // Calculate total pending items for badges
    const totalRequestsCount = myRequestCount || 0;
    const totalApprovalsCount = pendingApprovalCount || 0;
    const showApprovals = approvalCount > 0 || pendingApprovalCount > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3C7EO.ForgeModalContextProvider), {
        type: (0, $1HEEa.USER_MENU_ACTION_SECTION_MODULE)
    }, !(0, $k2M4v.default).checkGate('hub_component_upgrade') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        component: (0, $io4o2.Link),
        actionSubjectId: "navbarUserRequests",
        to: "/user/requests?reporter=all&statuses=open",
        iconAfter: totalRequestsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lpWRK.default), null, totalRequestsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $bEtKM.default).requests)), showApprovals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
        component: (0, $io4o2.Link),
        actionSubjectId: "navbarUserApprovals",
        to: "/user/approvals",
        iconAfter: totalApprovalsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lpWRK.default), null, totalApprovalsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $bEtKM.default).approvals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6AE1S.HubConnectMenuSection), {
        customMenuLinks: customMenuLinks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fqx4Q.HubForgeMenuSection), null));
};
const $fea42ba3c0a3aecc$var$mapStateToProps = (state)=>{
    const userRequestsCounts = (0, $hzlql.getUserRequestsCounts)(state);
    return {
        myRequestCount: userRequestsCounts.myRequestCount,
        pendingApprovalCount: userRequestsCounts.pendingApprovalCount,
        approvalCount: userRequestsCounts.approvalCount,
        customMenuLinks: (0, $7RWiC.getCustomMenuLinks)(state)
    };
};
const $fea42ba3c0a3aecc$export$4f0698e82fb00313 = (0, $6umft.default)($fea42ba3c0a3aecc$var$mapStateToProps, {
    fetchUser: (0, $fecgs.fetchUserModelAction),
    fetchUserRequestsCounts: (0, $haEws.fetchUserRequestsCountsAction),
    fetchOrganisations: (0, $1eY13.fetchOrganisationsModelAction)
})($fea42ba3c0a3aecc$var$HubAvatarMenuOptionsComponent);

});
parcelRegister("6AE1S", function(module, exports) {
$parcel$export(module.exports, "HubConnectMenuSection", () => $b310ad9d54fa4099$export$97faed7dd622e8ae);

var $fc4bM = parcelRequire("fc4bM");

var $g9mbo = parcelRequire("g9mbo");

var $8qhwO = parcelRequire("8qhwO");

var $bKfoa = parcelRequire("bKfoa");

var $3rlj9 = parcelRequire("3rlj9");

var $g8fua = parcelRequire("g8fua");
const $b310ad9d54fa4099$var$ConnectMenuLinks = ({ customMenuLinks: customMenuLinks, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-test-id": "custom-menu-link"
    }, customMenuLinks.map((menuLink)=>{
        const menuLinkKey = menuLink.id || menuLink.key || menuLink.href;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Connect apps provide AP classes for dialog behaviour.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            key: `hub-custom-menu-link_${menuLinkKey}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bKfoa.default), {
            actionSubjectId: "custom-menu-link",
            component: (0, $g9mbo.HtmlAnchor),
            href: menuLink.href,
            onClick: onClose,
            "data-test-id": "custom-menu-link",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: "cv-exclude-from-customisation"
        }, menuLink.label)));
    }));
const $b310ad9d54fa4099$var$DeferredConnectMenuLinks = (0, $g8fua.withDeferredWrmLoaded)($b310ad9d54fa4099$var$ConnectMenuLinks, (0, $8qhwO.initializeConnect));
const $b310ad9d54fa4099$export$97faed7dd622e8ae = ({ customMenuLinks: customMenuLinks })=>{
    if (customMenuLinks.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b310ad9d54fa4099$var$DeferredConnectMenuLinks, {
        customMenuLinks: customMenuLinks,
        onClose: ()=>undefined
    }));
};

});

parcelRegister("fqx4Q", function(module, exports) {
$parcel$export(module.exports, "HubForgeMenuSection", () => $4d8ac43c834429d0$export$da20fe93c1284982);

var $fc4bM = parcelRequire("fc4bM");

var $g97N1 = parcelRequire("g97N1");

var $1HEEa = parcelRequire("1HEEa");

var $js98a = parcelRequire("js98a");

var $eaozo = parcelRequire("eaozo");

var $3rlj9 = parcelRequire("3rlj9");
const $4d8ac43c834429d0$var$ForgeMenuSectionItems = ()=>{
    const { data: { extensionTitles: extensionTitles }, methods: { setExtensionToDisplay: setExtensionToDisplay } } = (0, $fc4bM.useContext)((0, $js98a.ForgeModalContext));
    if (extensionTitles.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3rlj9.default), {
        hasSeparator: true
    }, extensionTitles.map(({ id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eaozo.default), {
            id: id,
            key: `hub-forge-title_${id}`,
            onClick: ()=>setExtensionToDisplay(id)
        }, title)));
};
const $4d8ac43c834429d0$export$da20fe93c1284982 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($4d8ac43c834429d0$var$ForgeMenuSectionItems, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $g97N1.ForgeActionModule), {
        type: (0, $1HEEa.USER_MENU_ACTION_SECTION_MODULE),
        componentName: (0, $1HEEa.USER_MENU_ACTION_COMPONENT)
    }));
};

});

parcelRegister("bEtKM", function(module, exports) {
$parcel$export(module.exports, "default", () => $50b0bd73cb8703fa$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $50b0bd73cb8703fa$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests item in hub avatar menu',
        id: 'hub.avatar.menu.requests'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'Approvals item in hub avatar menu',
        id: 'hub.avatar.menu.approvals'
    }
});

});



parcelRegister("chv7T", function(module, exports) {
$parcel$export(module.exports, "RequestList", () => $4d1692d8062927d0$export$c58d16d73d0428fb);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $4d1692d8062927d0$export$c58d16d73d0428fb = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("kWIOr")).then((module)=>{
            const { registerRequestsListEpicsndReducers: registerRequestsListEpicsndReducers } = module;
            registerRequestsListEpicsndReducers();
            return module.default;
        }), {
        moduleId: "./src/view/request-list/hocs.tsx"
    })
});

});
parcelRegister("kWIOr", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("lWdqq"),
    $9dnsd("eyTAx")
]).then(()=>parcelRequire('bNE1W'));

});


parcelRegister("9PouM", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfileForHubs", () => $6daafee425e48748$export$eca04c8a7924030c);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $6daafee425e48748$export$eca04c8a7924030c = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("5tJsP")), {
        moduleId: "./src/view/user-profile/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("5tJsP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3ky1E"),
    $9dnsd("7pVSl")
]).then(()=>parcelRequire('dTXQy'));

});


parcelRegister("5hFUB", function(module, exports) {
$parcel$export(module.exports, "UserProfileForHubs", () => $05c88ed4445b1502$export$4c16441af2ce2701);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

const $05c88ed4445b1502$var$loader = (0, $dohmo.lazyForPaint)(()=>{
    return (parcelRequire("54vsg"));
}, {
    ssr: true,
    moduleId: "./src/view/user-profile/hub-variant/hub-variant.tsx"
});
const $05c88ed4445b1502$export$4c16441af2ce2701 = (0, $bQkfB.default)({
    loader: $05c88ed4445b1502$var$loader
});

});
parcelRegister("54vsg", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("3ky1E"),
    $9dnsd("8agEZ")
]).then(()=>parcelRequire('KcEKT'));

});


parcelRegister("9xVWL", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTES", () => $78591eb26aedf4b9$export$89e88c91b6499ccb);

var $ivtaS = parcelRequire("ivtaS");
const $78591eb26aedf4b9$export$89e88c91b6499ccb = {
    USER_PROFILE: {
        path: '/user/profile',
        name: 'hubs-user-profile'
    },
    REQUESTS_LIST: {
        path: '/user/requests',
        name: 'requests-list'
    },
    CSM_REQUESTS_LIST: {
        path: '/user/requests',
        name: 'csm-requests-list'
    },
    CSM_CONTACT_US: {
        path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
        name: 'contact-us'
    },
    NOT_FOUND: {
        path: '(.*)',
        name: 'hubs-not-found-error-page'
    },
    CSM_FOLDER: {
        path: '/folder/:folderId',
        name: 'csm-folder'
    },
    CSM_REQUEST_DETAILS: {
        path: '/user/requests/:requestKey',
        name: 'csm-request-details'
    },
    VIEW_PORTAL_ARTICLE: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
        name: 'hubs-view-portal-kb-article'
    },
    PORTAL_ACCESS_FORBIDDEN: {
        path: '/user/forbidden',
        name: 'hubs-portal-access-forbidden'
    },
    VIEW_ARTICLE: {
        path: '/article/:articleId',
        name: 'hubs-view-kb-article'
    },
    VIEW_KB_ARTICLE: {
        path: '/kb/view/:pageId',
        name: 'hubs-view-kb-article'
    },
    VIEW_CROSS_SITE_PORTAL_ARTICLE: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
        name: 'hubs-view-portal-cross-site-kb-article'
    },
    VIEW_CROSS_SITE_ARTICLE: {
        path: '/cloudId/:cloudId/article/:articleId',
        name: 'hubs-view-kb-cross-site-article'
    },
    LOGIN: {
        path: '/user/login',
        name: 'hubs-login'
    },
    PORTAL_LOGIN: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/login`,
        name: 'hubs-portal-login'
    },
    SIGNUP: {
        path: '/user/signup',
        name: 'hubs-user-signup'
    },
    PORTAL_SIGNUP: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/signup`,
        name: 'hubs-portal-signup'
    },
    COMPLETE_SIGNUP: {
        path: '/user/complete-signup',
        name: 'hubs-user-complete-signup'
    },
    PORTAL_COMPLETE_SIGNUP: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
        name: 'hubs-portal-complete-signup'
    },
    RESET_PASSWORD: {
        path: '/user/resetpassword',
        name: 'hubs-user-reset-password'
    },
    PORTAL_RESET_PASSWORD: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
        name: 'hubs-portal-reset-password'
    },
    CHECK_EMAIL: {
        path: '/user/check-email',
        name: 'hubs-user-checkmail'
    },
    PORTAL_INVITED_SIGNUP: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
        name: 'hubs-portal-invited-signup'
    },
    UNSUBSCRIBE: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/:requestKey/unsubscribe`,
        name: 'hubs-unsubscribe'
    },
    REQUEST_FEEDBACK: {
        path: `${(0, $ivtaS.PORTAL_ROUTE_PREFIX)}/:requestKey/feedback`,
        name: 'jsm-hubs-request-feedback'
    },
    REQUEST_CREATE: {
        path: `/portal/:portalId/create/:requestTypeId`,
        name: 'jsm-hubs-request-create'
    },
    ANONYMOUS_REQUEST_SUCCESS: {
        path: `/portal/:portalId/create/:requestTypeId/confirm`,
        name: 'jsm-hubs-anonymous-request-success'
    },
    JSM_REQUEST_DETAILS: {
        path: `/portal/:portalId/:requestKey`,
        name: 'jsm-hubs-request-details'
    },
    JSM_REQUESTS_LIST: {
        path: `/user/requests`,
        name: 'jsm-hubs-requests-list'
    },
    JSM_APPROVALS: {
        path: `/user/approvals`,
        name: 'jsm-hubs-approvals'
    },
    JSM_REQUEST_APPROVAL: {
        path: `/portal/:portalId/:requestKey/approval/:approvalId/:decision`,
        name: 'jsm-hubs-request-approval'
    },
    HUB_ARTICLES: {
        name: 'view-kb-article',
        path: `/article/:articleId`
    },
    HUB_KB_PAGE: {
        name: 'view-kb-page',
        path: `/kb/view/:pageId`
    },
    HUB_CROSS_SITE_ARTICLE: {
        name: 'view-kb-cross-site-article',
        path: `/cloudId/:cloudId/article/:articleId`
    },
    SURVEY: {
        name: 'survey',
        path: `/portal/:portalId/survey/:surveyId`
    },
    // Name matches the non-hub `viewAllSearchResultsRoute` so analytics / UFO
    // segments are unaffected when one registration swaps for the other.
    ALL_SEARCH_RESULTS: {
        name: 'view-all-search-results',
        path: `/articles/search`
    }
};

});

parcelRegister("hdisM", function(module, exports) {
$parcel$export(module.exports, "isHubMaxWidthAppearanceEnabled", () => $16d9a19537a81591$export$fadefac9afec766f);

var $dRkX9 = parcelRequire("dRkX9");
const $16d9a19537a81591$export$fadefac9afec766f = ()=>(0, $dRkX9.fg)('hubs_jsm_max_width_appearance');

});

parcelRegister("bIlPC", function(module, exports) {
$parcel$export(module.exports, "HubExtensionsDependenciesProvider", () => $d3f0fd019b5cb070$export$8084bb73ea6f042e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Help-center side of the Hub Forge/Connect renderer integration.
 *
 * The platform-level packages (`@atlassian/hub-forge-extension`,
 * `@atlassian/hub-connect-extension`) ship the ADF schema, manifests and
 * empty-state UI for the four new editor elements (Forge header / footer,
 * Connect header / footer). They intentionally do NOT depend on any Forge
 * or Connect SDK — the host product is expected to inject a concrete
 * renderer via the `HubForge|ConnectRendererProvider` context.
 *
 * This module is that injection point for the Help Hub / Customer Service
 * Hub. It mirrors how the legacy help-center Forge/Connect customisation
 * elements render today (see
 * `help-center/packages/help-center/customisation/elements/forge`
 * and `…/elements/connect`):
 *  - same `<ElementRoot>` wrapper (margin/padding tokens, flexibility flag)
 *  - same pointer-events shield while editing (gated by `mode === EDITOR`)
 *  - same `<ConnectFragment>` fan-out for `headerAndSubheaderPanels`
 *  - same `trackError` analytics on invalid `elementType`s
 *
 * "Is Connect installed on the tenant?" / "Is Forge installed?" are
 * decided server-side: the BE only emits a `HubForgeExtension` /
 * `HubConnectExtension` ADF node when the corresponding app is available
 * for the slot. At render time the legacy `<ForgeHeaderModule>` /
 * `<ConnectFragment>` primitives perform a second, finer-grained check
 * (their internal Relay queries return empty when there are no matching
 * Forge/Connect modules, in which case they render nothing — matching the
 * legacy element behaviour).
 *
 * Mounted through `HubAppProps.productExtensionsDependenciesProvider` so
 * platform extension renderers can resolve Help Center's concrete Forge / Connect
 * primitives from both published renderer and editor extension roots.
 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $k2M4v = parcelRequire("k2M4v");

var $8MaoS = parcelRequire("8MaoS");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $jhhWw = parcelRequire("jhhWw");

var $fVRf7 = parcelRequire("fVRf7");

var $dOuSz = parcelRequire("dOuSz");

var $iGOXo = parcelRequire("iGOXo");

var $lD6st = parcelRequire("lD6st");

var $cuzWU = parcelRequire("cuzWU");

var $h1TGx = parcelRequire("h1TGx");

var $8qhwO = parcelRequire("8qhwO");
var $04E2Q = parcelRequire("04E2Q");

var $hN5YJ = parcelRequire("hN5YJ");

var $7ZNRj = parcelRequire("7ZNRj");

var $9Ii6A = parcelRequire("9Ii6A");

var $4OMBM = parcelRequire("4OMBM");
parcelRequire("2tW0k");
var $3eUyM = parcelRequire("3eUyM");
var $SRPqf = parcelRequire("SRPqf");

var $cf4bF = parcelRequire("cf4bF");

var $ixenv = parcelRequire("ixenv");
parcelRequire("iLM5T");
var $fH4Ny = parcelRequire("fH4Ny");

var $6KLOx = parcelRequire("6KLOx");
parcelRequire("917It");
var $54pru = parcelRequire("54pru");

var $1HEEa = parcelRequire("1HEEa");

var $dRkX9 = parcelRequire("dRkX9");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
parcelRequire("1Qg1o");
var $auzgq = parcelRequire("auzgq");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $aIVqJ = parcelRequire("aIVqJ");
// ---------------------------------------------------------------------------
// Forge bridge
// ---------------------------------------------------------------------------
// Surface-aware Forge page name; the CSM surface is guarded by forge-on-csm-hubs (else JSM Hub page).
const $d3f0fd019b5cb070$var$getForgePage = ()=>(0, $dRkX9.fg)('forge-on-csm-hubs') && (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) ? (0, $1HEEa.FORGE_CSM_HELP_CENTER) : (0, $1HEEa.FORGE_HELP_CENTER);
const $d3f0fd019b5cb070$var$USE_USER_LOCALE_FOR_FORGE = 'use_user_locale_for_forge';
const $d3f0fd019b5cb070$var$isUseUserLocaleForForgeEnabled = ()=>(0, $k2M4v.default).checkGate($d3f0fd019b5cb070$var$USE_USER_LOCALE_FOR_FORGE);
const $d3f0fd019b5cb070$var$FIX_HUB_EXTENSION_TRANSLATIONS = 'fix_hub_extension_translations';
const $d3f0fd019b5cb070$var$isFixHubExtensionTranslationsEnabled = ()=>(0, $k2M4v.default).checkGate($d3f0fd019b5cb070$var$FIX_HUB_EXTENSION_TRANSLATIONS);
const $d3f0fd019b5cb070$var$forgeModuleProps = {
    noWrapper: true,
    allowCustomPadding: true,
    skipHelpCenterWrapper: true
};
const $d3f0fd019b5cb070$export$96d94af5e9221f94 = (pathname)=>{
    const match = /\/portal\/(\d+)(?:\/|$)/.exec(pathname);
    if (!match) return undefined;
    const portalId = Number(match[1]);
    return Number.isSafeInteger(portalId) && portalId > 0 ? portalId : undefined;
};
/**
 * Resolves the portal's project id from the portal model in Redux, keyed on the
 * portal id parsed from the URL. `react-redux` here is v6 (no hooks), so this is
 * resolved through `connect`. Returns primitives so the mapped values are
 * referentially stable across re-renders.
 */ const $d3f0fd019b5cb070$var$mapResourceFromState = (state)=>{
    var _globalThis$location;
    // CSM help centers have no "portal" concept, so the getPortalIdFromUrl path below does not apply;
    // use the hub's hoisted project id as the Forge resource context instead (gated by forge-on-csm-hubs).
    if ((0, $dRkX9.fg)('forge-on-csm-hubs') && (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType)) return {
        portalId: undefined,
        projectId: (0, $7lN8e.getEnv)().hoistedProjectId,
        isPortalModelLoaded: false
    };
    const portalId = $d3f0fd019b5cb070$export$96d94af5e9221f94(((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.pathname) ?? '');
    if (!portalId) return {
        portalId: undefined,
        projectId: undefined,
        isPortalModelLoaded: false
    };
    return {
        portalId: portalId,
        projectId: (0, $9D9SX.getProjectId)(state, portalId),
        // The portal record (success or error) is present once a fetch settled.
        isPortalModelLoaded: Boolean((0, $9D9SX.getPortalOrError)(state, portalId))
    };
};
const $d3f0fd019b5cb070$var$mapDispatch = {
    fetchPortal: (0, $hijaX.fetchPortalAction)
};
/**
 * Ensures the current portal model is fetched into Redux so `getProjectId` can
 * resolve the portal's project in both edit and view mode. Only fetches when a
 * portal page is detected and the model is not already loaded. Rendering never
 * waits on this fetch — the resource context is simply applied once the project
 * resolves.
 */ const $d3f0fd019b5cb070$var$useEnsurePortalFetched = (portalId, isPortalModelLoaded, fetchPortal)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (portalId && !isPortalModelLoaded) fetchPortal({
            id: portalId
        });
    }, [
        portalId,
        isPortalModelLoaded,
        fetchPortal
    ]);
};
/**
 * Builds a referentially-stable resource context from the primitive project id,
 * so the fetch effect that depends on it does not re-run on every render.
 */ const $d3f0fd019b5cb070$var$useProjectResourceContext = (projectId)=>(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>projectId ? {
            resourceId: projectId.toString(),
            resourceType: (0, $1HEEa.RESOURCE_TYPE_PROJECT)
        } : undefined, [
        projectId
    ]);
/**
 * Whether the portal resource context has settled, i.e. it will not change from
 * "absent" to "present" on a later render:
 * - not a portal page (no `portalId`) -> nothing to resolve, and
 * - a portal page whose portal model is already in Redux.
 *
 * The empty-state probes wait for this so they issue a single, correctly-scoped
 * request instead of one without the resource context followed by one with it.
 */ const $d3f0fd019b5cb070$var$isResourceContextSettled = (portalId, isPortalModelLoaded)=>!portalId || isPortalModelLoaded;
/**
 * Editor-only probe for the header + subheader modules: reports whether any
 * apps are installed so the editor can show a placeholder for an empty slot.
 *
 * This is deliberately not rendered in the published view, where the result is
 * unused and the requests would be wasted — the modules fetch what they need to
 * render themselves.
 */ const $d3f0fd019b5cb070$var$ForgeHeaderEmptyStateProbe = ({ projectId: projectId })=>{
    const forgePage = $d3f0fd019b5cb070$var$getForgePage();
    const resourceContext = $d3f0fd019b5cb070$var$useProjectResourceContext(projectId);
    const { extensions: headerExtensions, resolved: headerResolved } = (0, $fH4Ny.useTFExtensionList)({
        resourceContext: resourceContext,
        type: (0, $1HEEa.PORTAL_HEADER_MODULE),
        page: forgePage
    });
    const { extensions: subheaderExtensions, resolved: subheaderResolved } = (0, $fH4Ny.useTFExtensionList)({
        resourceContext: resourceContext,
        type: (0, $1HEEa.PORTAL_SUBHEADER_MODULE),
        page: forgePage
    });
    // Wait for this probe to settle before mounting the modules. The modules
    // request the same extension types, and the cache only holds settled results,
    // so mounting them straight away would race this request and duplicate it.
    // Once this resolves their lookup hits the warm cache instead. Bounded:
    // `resolved` settles on both success and failure.
    if (!headerResolved || !subheaderResolved) return null;
    const isEmpty = ((headerExtensions === null || headerExtensions === void 0 ? void 0 : headerExtensions.length) ?? 0) === 0 && ((subheaderExtensions === null || subheaderExtensions === void 0 ? void 0 : subheaderExtensions.length) ?? 0) === 0;
    if (isEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cuzWU.HubForgeEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ixenv.ForgeHeaderModule), {
        ...$d3f0fd019b5cb070$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
/**
 * Header slot: renders the Forge header + subheader modules. In the editor,
 * once the trusted-fetch resolves with no installed apps for either module,
 * it shows the empty-state placeholder instead so authors know the slot is
 * empty. In the published view the modules self-render nothing when empty.
 *
 * On a portal page nothing is mounted until the resource context has settled:
 * mounting the modules with an unresolved project would make them fetch without
 * the resource context and then fetch again once it resolved. The wait is
 * bounded — `isPortalModelLoaded` settles whether the portal request succeeds or
 * fails — and does not apply off portal pages.
 */ const $d3f0fd019b5cb070$var$ForgeHeaderSlotInner = ({ isPageInEditMode: isPageInEditMode, portalId: portalId, projectId: projectId, isPortalModelLoaded: isPortalModelLoaded, fetchPortal: fetchPortal })=>{
    const forgePage = $d3f0fd019b5cb070$var$getForgePage();
    $d3f0fd019b5cb070$var$useEnsurePortalFetched(portalId, isPortalModelLoaded, fetchPortal);
    if (!$d3f0fd019b5cb070$var$isResourceContextSettled(portalId, isPortalModelLoaded)) return null;
    if (isPageInEditMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ForgeHeaderEmptyStateProbe, {
        projectId: projectId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ixenv.ForgeHeaderModule), {
        ...$d3f0fd019b5cb070$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
const $d3f0fd019b5cb070$var$ForgeHeaderSlot = (0, $6umft.default)($d3f0fd019b5cb070$var$mapResourceFromState, $d3f0fd019b5cb070$var$mapDispatch)($d3f0fd019b5cb070$var$ForgeHeaderSlotInner);
/**
 * Editor-only probe for the footer module. See
 * {@link ForgeHeaderEmptyStateProbe}.
 */ const $d3f0fd019b5cb070$var$ForgeFooterEmptyStateProbe = ({ projectId: projectId })=>{
    const forgePage = $d3f0fd019b5cb070$var$getForgePage();
    const resourceContext = $d3f0fd019b5cb070$var$useProjectResourceContext(projectId);
    const { extensions: extensions, resolved: resolved } = (0, $fH4Ny.useTFExtensionList)({
        resourceContext: resourceContext,
        type: (0, $1HEEa.PORTAL_FOOTER_MODULE),
        page: forgePage
    });
    // See ForgeHeaderEmptyStateProbe: wait for this request to settle so the
    // module's lookup for the same type hits the warm cache instead of racing it.
    if (!resolved) return null;
    if (((extensions === null || extensions === void 0 ? void 0 : extensions.length) ?? 0) === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cuzWU.HubForgeEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cf4bF.ForgeFooterModule), {
        ...$d3f0fd019b5cb070$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
/**
 * Footer slot: same behaviour as {@link ForgeHeaderSlot} for the single
 * footer module type.
 */ const $d3f0fd019b5cb070$var$ForgeFooterSlotInner = ({ isPageInEditMode: isPageInEditMode, portalId: portalId, projectId: projectId, isPortalModelLoaded: isPortalModelLoaded, fetchPortal: fetchPortal })=>{
    const forgePage = $d3f0fd019b5cb070$var$getForgePage();
    $d3f0fd019b5cb070$var$useEnsurePortalFetched(portalId, isPortalModelLoaded, fetchPortal);
    if (!$d3f0fd019b5cb070$var$isResourceContextSettled(portalId, isPortalModelLoaded)) return null;
    if (isPageInEditMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ForgeFooterEmptyStateProbe, {
        projectId: projectId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cf4bF.ForgeFooterModule), {
        ...$d3f0fd019b5cb070$var$forgeModuleProps,
        page: forgePage,
        projectId: projectId
    });
};
const $d3f0fd019b5cb070$var$ForgeFooterSlot = (0, $6umft.default)($d3f0fd019b5cb070$var$mapResourceFromState, $d3f0fd019b5cb070$var$mapDispatch)($d3f0fd019b5cb070$var$ForgeFooterSlotInner);
/**
 * Adapter from the platform-level Forge renderer signature to the legacy
 * help-center Forge header / footer modules.
 *
 * `'help_center'` is the canonical Forge page name (see
 * `JsmForgePageName`) used by the legacy `<ForgeElement />` for the same
 * header/footer slots. `noWrapper` + `allowCustomPadding` match the legacy
 * invocation so visual treatment is identical across legacy help-center
 * and the new hub editor.
 *
 * Returning `null` for unknown `elementType`s (rather than throwing) keeps
 * the editor render loop deterministic — the empty state owned by
 * `<HubForgeExtension />` is the user-visible fallback.
 */ const $d3f0fd019b5cb070$var$ForgeBridge = ({ extensionNode: extensionNode, mode: mode })=>{
    var _extensionNode$parame;
    const elementType = (_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.elementType;
    const isPageInEditMode = mode === (0, $6KLOx.ExtensionMode).EDITOR;
    const isFullWidthLayout = extensionNode.layout === 'full-width';
    const elementWidth = $d3f0fd019b5cb070$var$getElementWidth(extensionNode.layout);
    const isValid = elementType === (0, $lD6st.ForgeElementType).HEADER_AND_SUB_HEADER_PANELS || elementType === (0, $lD6st.ForgeElementType).FOOTER_PANELS;
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (!isValid) (0, $aIVqJ.trackError)('hub.forge.element.type.invalid', {
            elementType: elementType
        }, 'Invalid Hub Forge Element Type received');
    }, [
        isValid,
        elementType
    ]);
    if (!isValid) return null;
    const inner = elementType === (0, $lD6st.ForgeElementType).HEADER_AND_SUB_HEADER_PANELS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ForgeHeaderSlot, {
        isPageInEditMode: isPageInEditMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ForgeFooterSlot, {
        isPageInEditMode: isPageInEditMode
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            isFullWidthLayout && "_1wpz1fhb _1bsb1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3eUyM.default), {
        removePadding: true,
        removeMargin: (0, $hN5YJ.isIncreasedFlexibilityEnabled)(),
        elementWidth: elementWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-hub-extension-bridge-content": "forge",
        className: (0, $2R2iS.default)([
            "_1bsb1osq",
            isPageInEditMode && "_lcxvglyw"
        ])
    }, inner)));
};
const $d3f0fd019b5cb070$var$renderHubForge = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ForgeBridge, props);
const $d3f0fd019b5cb070$export$33429e4c460e2543 = (pathname)=>{
    const portalId = $d3f0fd019b5cb070$export$96d94af5e9221f94(pathname);
    return portalId ? {
        portalId: portalId,
        page: (0, $04E2Q.PORTAL_HOME)
    } : {
        page: (0, $04E2Q.HELP_CENTER)
    };
};
/**
 * Connect panels are Redux-backed: `<ConnectFragment>` fetches them on mount
 * and the result lands in the store keyed by page + portal + location. The
 * selector returns `undefined` until the fetch settles, then an array
 * (possibly empty) or an error. We treat "all requested locations resolved to
 * an empty array" as "no Connect app for this slot" and render nothing. The
 * `<ConnectFragment>`s are still rendered so they keep ownership of fetching
 * and of rendering the real app when present.
 */ const $d3f0fd019b5cb070$var$connectLocationsHaveApp = (state, locations, { page: page, portalId: portalId })=>{
    // Gate on the fetch lifecycle, not on the panel values. A successful fetch
    // that returns no apps stores `undefined`/`[]` for individual locations,
    // which is indistinguishable from "not fetched yet" if we only look at the
    // panel values — that bug kept the empty state hidden forever. Using the
    // page-level resolution signal lets the empty state appear once the fetch
    // settles, even when there are no Connect apps.
    if (!(0, $auzgq.isConnectFragmentsResolved)({
        state: state,
        portalId: portalId,
        pageName: page
    })) return undefined;
    // Resolved: report whether any requested location actually has a panel.
    return locations.some((location)=>{
        const panel = (0, $auzgq.getConnectAddonPanels)({
            state: state,
            location: location,
            portalId: portalId,
            pageName: page
        });
        return Array.isArray(panel) && panel.length > 0;
    });
};
/**
 * Adapter from the platform-level Connect renderer signature to the
 * legacy help-center `ConnectFragment` for the help-center page.
 *
 * For the header slot we render both `headerPanels` and `subheaderPanels`
 * to match the legacy `<ConnectElement />` behaviour — Connect apps that
 * registered against either location continue to render in the new hub
 * editor with zero migration work.
 */ const $d3f0fd019b5cb070$var$ConnectBridge = ({ extensionNode: extensionNode, mode: mode })=>{
    var _extensionNode$parame2;
    const elementType = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.elementType;
    const isPageInEditMode = mode === (0, $6KLOx.ExtensionMode).EDITOR;
    const isFullWidthLayout = extensionNode.layout === 'full-width';
    const elementWidth = $d3f0fd019b5cb070$var$getElementWidth(extensionNode.layout);
    const isValid = elementType === (0, $fVRf7.ConnectElementType).HEADER_AND_SUB_HEADER_PANELS || elementType === (0, $fVRf7.ConnectElementType).FOOTER_PANELS;
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (!isValid) (0, $aIVqJ.trackError)('hub.connect.element.type.invalid', {
            elementType: elementType
        }, 'Invalid Hub Connect Element Type received');
    }, [
        isValid,
        elementType
    ]);
    if (!isValid) return null;
    const locations = elementType === (0, $fVRf7.ConnectElementType).HEADER_AND_SUB_HEADER_PANELS ? [
        'headerPanels',
        'subheaderPanels'
    ] : [
        'footerPanels'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ConnectSlot, {
        isPageInEditMode: isPageInEditMode,
        locations: [
            ...locations
        ],
        elementWidth: elementWidth,
        isFullWidthLayout: isFullWidthLayout
    });
};
const $d3f0fd019b5cb070$var$ConnectPublishedSlotInner = ({ locations: locations, hasApp: hasApp, page: page, portalId: portalId, elementWidth: elementWidth, isFullWidthLayout: isFullWidthLayout })=>{
    if (hasApp === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            isFullWidthLayout && "_1wpz1fhb _1bsb1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3eUyM.default), {
        removePadding: true,
        removeMargin: (0, $hN5YJ.isIncreasedFlexibilityEnabled)(),
        elementWidth: elementWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-hub-extension-bridge-content": "connect",
        className: (0, $2R2iS.default)([
            "_1bsb1osq"
        ])
    }, locations.map((location)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qhwO.ConnectFragment), {
            key: location,
            page: page,
            portalId: portalId,
            location: location
        })))));
};
const $d3f0fd019b5cb070$var$ConnectPublishedSlot = (0, $6umft.default)((state, ownProps)=>{
    var _globalThis$location2;
    const pageContext = $d3f0fd019b5cb070$export$33429e4c460e2543(((_globalThis$location2 = globalThis.location) === null || _globalThis$location2 === void 0 ? void 0 : _globalThis$location2.pathname) ?? '');
    return {
        // Primitives only, so `connect` keeps the mapped props stable.
        page: pageContext.page,
        portalId: pageContext.portalId,
        hasApp: $d3f0fd019b5cb070$var$connectLocationsHaveApp(state, ownProps.locations, pageContext)
    };
})($d3f0fd019b5cb070$var$ConnectPublishedSlotInner);
const $d3f0fd019b5cb070$var$ConnectEditorSlot = ({ elementWidth: elementWidth, isFullWidthLayout: isFullWidthLayout })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            isFullWidthLayout && "_1wpz1fhb _1bsb1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3eUyM.default), {
        removePadding: true,
        removeMargin: (0, $hN5YJ.isIncreasedFlexibilityEnabled)(),
        elementWidth: elementWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-hub-extension-bridge-content": "connect",
        className: (0, $2R2iS.default)([
            "_1bsb1osq",
            "_lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dOuSz.HubConnectEmptyState), null))));
const $d3f0fd019b5cb070$var$ConnectSlot = ({ isPageInEditMode: isPageInEditMode, locations: locations, elementWidth: elementWidth, isFullWidthLayout: isFullWidthLayout })=>isPageInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ConnectEditorSlot, {
        elementWidth: elementWidth,
        isFullWidthLayout: isFullWidthLayout
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ConnectPublishedSlot, {
        isPageInEditMode: false,
        locations: locations,
        elementWidth: elementWidth,
        isFullWidthLayout: isFullWidthLayout
    });
const $d3f0fd019b5cb070$var$renderHubConnect = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$ConnectBridge, props);
/**
 * Single mount point that injects both Hub Forge and Hub Connect renderers.
 * Order of providers is irrelevant — they are independent contexts.
 */ const $d3f0fd019b5cb070$var$HubExtensionsBridge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iGOXo.HubForgeRendererProvider), {
        renderer: $d3f0fd019b5cb070$var$renderHubForge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jhhWw.HubConnectRendererProvider), {
        renderer: $d3f0fd019b5cb070$var$renderHubConnect
    }, children));
const $d3f0fd019b5cb070$export$8084bb73ea6f042e = ({ children: children, extensionNode: extensionNode, mode: mode })=>{
    const useUserLocale = $d3f0fd019b5cb070$var$isUseUserLocaleForForgeEnabled();
    // A nested IntlProvider replaces the app's messages rather than merging with them,
    // so without these every extension string falls back to its English default.
    const passAppMessages = useUserLocale && $d3f0fd019b5cb070$var$isFixHubExtensionTranslationsEnabled();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
        locale: useUserLocale ? (0, $7ZNRj.getLanguageFromLocale)((0, $7RWiC.getLocale)((0, $4OMBM.store).getState())) : 'en',
        messages: passAppMessages ? (0, $9Ii6A.default)() : undefined,
        onError: passAppMessages ? (0, $9Ii6A.onIntlNextError) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $h1TGx.CommonHubExtensionsDependenciesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $54pru.HubPremiumSlaElementsProvider), {
        extensionKey: extensionNode === null || extensionNode === void 0 ? void 0 : extensionNode.extensionKey,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d3f0fd019b5cb070$var$HubExtensionsBridge, null, children))));
};
// ---------------------------------------------------------------------------
// Styles (declared at the bottom of the file per styled-component-order)
// ---------------------------------------------------------------------------
const $d3f0fd019b5cb070$var$getElementWidth = (layout)=>layout === 'full-width' ? (0, $SRPqf.ElementWidth).FULL_WIDTH : undefined;
const $d3f0fd019b5cb070$var$fullWidthRootCss = null;
const $d3f0fd019b5cb070$var$fullWidthCss = null;
const $d3f0fd019b5cb070$var$editModeCss = null;

});
parcelRegister("jhhWw", function(module, exports) {
$parcel$export(module.exports, "HubConnectRendererProvider", () => $21f1d18e5b6e0541$export$ca4738bfb172ba62);
$parcel$export(module.exports, "useHubConnectRenderer", () => $21f1d18e5b6e0541$export$7b1d86b9d48f9fd9);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $21f1d18e5b6e0541$var$HubConnectRendererContext = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $21f1d18e5b6e0541$export$ca4738bfb172ba62 = ({ children: children, renderer: renderer })=>/*#__PURE__*/ (0, $3LM7S.jsx)($21f1d18e5b6e0541$var$HubConnectRendererContext.Provider, {
        value: renderer,
        children: children
    });
const $21f1d18e5b6e0541$export$7b1d86b9d48f9fd9 = ()=>(0, $fc4bM.useContext)($21f1d18e5b6e0541$var$HubConnectRendererContext);

});

parcelRegister("dOuSz", function(module, exports) {
$parcel$export(module.exports, "HubConnectEmptyState", () => $63995b22fe2cfeff$export$a04622704b47a193);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $jChqI = parcelRequire("jChqI");

var $dBtOK = parcelRequire("dBtOK");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $3G8tu = parcelRequire("3G8tu");
const $63995b22fe2cfeff$var$styles = {
    iconBadge: "_2rko1rr0 _4cvr1h6o _bfhki8nm _1e0c1txw _4t3izwfg _1bah1h6o _1bsbzwfg"
};
const $63995b22fe2cfeff$export$a04622704b47a193 = ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        paddingBlock: "space.500",
        paddingInline: "space.300",
        testId: "hub-connect-extension.empty-state",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
            space: "space.150",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    xcss: $63995b22fe2cfeff$var$styles.iconBadge,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jChqI))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                    as: "strong",
                    weight: "bold",
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fd880.default), {
                        ...(0, $3G8tu.messages).emptyStateTitle
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                    color: "color.text.subtle",
                    align: "center",
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fd880.default), {
                        ...(0, $3G8tu.messages).emptyStateDescription
                    })
                })
            ]
        })
    });

});
parcelRegister("jChqI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d92d6da68cdb4ac3639231927c6c671>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e47f1625c647b5de$var$_react = $e47f1625c647b5de$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e47f1625c647b5de$var$_iconNew = $e47f1625c647b5de$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e47f1625c647b5de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app
 * Usage guidance:
 * Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e47f1625c647b5de$var$AppIcon = (props)=>/*#__PURE__*/ $e47f1625c647b5de$var$_react.default.createElement($e47f1625c647b5de$var$_iconNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$e47f1625c647b5de$var$AppIcon.displayName = 'AppIcon';
var $e47f1625c647b5de$var$_default = module.exports.default = $e47f1625c647b5de$var$AppIcon;

});

parcelRegister("3G8tu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $97b560f7dec461d7$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $97b560f7dec461d7$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    emptyStateTitle: {
        id: 'hub-connect-extension.hub-connect-empty-state.emptyStateTitle',
        defaultMessage: 'No connect app available',
        description: 'Empty state title shown inside the Hub Connect extension node when no installed Connect app module is available for the slot.'
    },
    emptyStateDescription: {
        id: 'hub-connect-extension.hub-connect-empty-state.emptyStateDescription',
        defaultMessage: 'You haven\u2019t installed a custom app in this section yet.',
        description: 'Empty state description shown inside the Hub Connect extension node when no installed Connect app module is available for the slot.'
    }
});

});


parcelRegister("iGOXo", function(module, exports) {
$parcel$export(module.exports, "HubForgeRendererProvider", () => $6bf0eed22ae279e9$export$253e913813c9fa14);
$parcel$export(module.exports, "useHubForgeRenderer", () => $6bf0eed22ae279e9$export$e9aaa46bc7719f1e);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $6bf0eed22ae279e9$var$HubForgeRendererContext = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $6bf0eed22ae279e9$export$253e913813c9fa14 = ({ children: children, renderer: renderer })=>/*#__PURE__*/ (0, $3LM7S.jsx)($6bf0eed22ae279e9$var$HubForgeRendererContext.Provider, {
        value: renderer,
        children: children
    });
const $6bf0eed22ae279e9$export$e9aaa46bc7719f1e = ()=>(0, $fc4bM.useContext)($6bf0eed22ae279e9$var$HubForgeRendererContext);

});

parcelRegister("cuzWU", function(module, exports) {
$parcel$export(module.exports, "HubForgeEmptyState", () => $36dd5543b00f068d$export$2f9e41329f23dd0b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $jChqI = parcelRequire("jChqI");

var $dBtOK = parcelRequire("dBtOK");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $eaBVj = parcelRequire("eaBVj");
const $36dd5543b00f068d$var$styles = {
    iconBadge: "_2rkol0p1 _4cvr1h6o _bfhki8nm _1e0c1txw _4t3izwfg _1bah1h6o _1bsbzwfg"
};
const $36dd5543b00f068d$export$2f9e41329f23dd0b = ({ description: description = (0, $eaBVj.messages).emptyStateDescription, title: title = (0, $eaBVj.messages).emptyStateTitle })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        paddingBlock: "space.500",
        paddingInline: "space.300",
        testId: "hub-forge-extension.empty-state",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
            space: "space.150",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    xcss: $36dd5543b00f068d$var$styles.iconBadge,
                    testId: "hub-forge-extension.empty-state.icon-tile",
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jChqI))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                    as: "strong",
                    weight: "bold",
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fd880.default), {
                        ...title
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                    color: "color.text.subtle",
                    align: "center",
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fd880.default), {
                        ...description
                    })
                })
            ]
        })
    });

});
parcelRegister("eaBVj", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d655c0cfa74fc5b8$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $d655c0cfa74fc5b8$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    emptyStateTitle: {
        id: 'hub-forge-extension.hub-forge-empty-state.emptyStateTitle',
        defaultMessage: 'No app available',
        description: 'Empty state title shown inside the Hub Forge extension node when no installed Forge app is available for the slot.'
    },
    emptyStateDescription: {
        id: 'hub-forge-extension.hub-forge-empty-state.emptyStateDescription',
        defaultMessage: 'You haven\u2019t installed a custom app yet.',
        description: 'Empty state description shown inside the Hub Forge extension node when no installed Forge app is available for the slot.'
    },
    invalidParametersTitle: {
        id: 'hub-forge-extension.hub-forge-empty-state.invalidParametersTitle',
        defaultMessage: "Forge app couldn\u2019t load",
        description: 'Empty state title shown inside the Hub Forge extension node in edit mode when the saved extension parameters cannot be read.'
    },
    invalidParametersDescription: {
        id: 'hub-forge-extension.hub-forge-empty-state.invalidParametersDescription',
        defaultMessage: 'Remove this app and add it again.',
        description: 'Empty state description shown inside the Hub Forge extension node in edit mode when the saved extension parameters cannot be read.'
    }
});

});


parcelRegister("2tW0k", function(module, exports) {
$parcel$export(module.exports, "ElementRoot", () => (parcelRequire("3eUyM")).default);
$parcel$export(module.exports, "ElementWidth", () => (parcelRequire("SRPqf")).ElementWidth);

var $3eUyM = parcelRequire("3eUyM");

var $SRPqf = parcelRequire("SRPqf");

});
parcelRegister("3eUyM", function(module, exports) {
$parcel$export(module.exports, "default", () => $795e99dcf0fbf853$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");
parcelRequire("86gJQ");
var $aiLVt = parcelRequire("aiLVt");

var $SRPqf = parcelRequire("SRPqf");
const $795e99dcf0fbf853$var$selector = (0, $2n2bS.createSelector)((0, $aiLVt.isCustomizing), (0, $ePyx3.getHelpCenterTopBarSplitFlag), (customizing, hasTopBarBeenSplit)=>({
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        isCustomizing: customizing
    }));
var $795e99dcf0fbf853$export$2e2bcd8739ae039 = (0, $6umft.default)($795e99dcf0fbf853$var$selector, {})((0, $SRPqf.ElementRoot));

});
parcelRegister("SRPqf", function(module, exports) {
$parcel$export(module.exports, "ElementWidth", () => $72d7281f29eb7c7b$export$8cb772970d402972);
$parcel$export(module.exports, "ElementMargins", () => $72d7281f29eb7c7b$export$59f0813ca361e932);
$parcel$export(module.exports, "ElementRoot", () => $72d7281f29eb7c7b$export$a627c7223f17f950);

var $fc4bM = parcelRequire("fc4bM");

var $hN5YJ = parcelRequire("hN5YJ");
parcelRequire("fQxpy");
var $1JcSo = parcelRequire("1JcSo");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $1zYKE = parcelRequire("1zYKE");
var $72d7281f29eb7c7b$export$8cb772970d402972 = /*#__PURE__*/ function(ElementWidth) {
    ElementWidth["FULL_WIDTH"] = "full-width";
    ElementWidth["COMPACT"] = "compact";
    return ElementWidth;
}({});
var $72d7281f29eb7c7b$export$59f0813ca361e932 = /*#__PURE__*/ function(ElementMargins) {
    ElementMargins["STANDARD"] = "standard";
    ElementMargins["COMPACT"] = "compact";
    return ElementMargins;
}({});
const $72d7281f29eb7c7b$export$a627c7223f17f950 = ({ elementRef: elementRef, children: children, isCustomizing: isCustomizing, elementWidth: elementWidth, elementMargins: elementMargins, removePadding: removePadding, removeMargin: // deprecated after enabling flag isIncreasedFlexibilityEnabled
removeMargin, customStyles: // for use-case of forge where we give margin internally
customStyles, hasTopBarBeenSplit: hasTopBarBeenSplit })=>{
    const [isPageInEditMode] = (0, $1JcSo.useIsPageInEditMode)();
    const [isPageInPreviewMode] = (0, $1JcSo.useIsPageInPreviewMode)();
    const isIncreasedFlexibilityEnabledWithTopBarSplit = (0, $hN5YJ.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit;
    const rootXCSS = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        const xcssStyle = [
            isIncreasedFlexibilityEnabledWithTopBarSplit ? $72d7281f29eb7c7b$var$rootStyleIncreasedFlexibility : $72d7281f29eb7c7b$var$rootStyle
        ];
        if (elementWidth === "compact") {
            if (isCustomizing) xcssStyle.push($72d7281f29eb7c7b$var$rootStyleWithSidebarOpened);
            else xcssStyle.push($72d7281f29eb7c7b$var$rootStyleWithSidebarClosed);
        } else if (isIncreasedFlexibilityEnabledWithTopBarSplit && elementWidth === "full-width") xcssStyle.push($72d7281f29eb7c7b$var$rootStyleFullWith);
        if (!removePadding && !isIncreasedFlexibilityEnabledWithTopBarSplit) xcssStyle.push($72d7281f29eb7c7b$var$rootPaddingStyle);
        if (isIncreasedFlexibilityEnabledWithTopBarSplit && !removeMargin) {
            if (!isPageInEditMode || isPageInPreviewMode) {
                // only don't apply while page edit
                if (elementMargins === "compact") xcssStyle.push($72d7281f29eb7c7b$export$6f424e557a8c03e);
                else xcssStyle.push($72d7281f29eb7c7b$export$31724e6a9731e3b6);
            }
        }
        if (customStyles) return [
            ...xcssStyle,
            ...customStyles
        ];
        return xcssStyle;
    }, [
        isIncreasedFlexibilityEnabledWithTopBarSplit,
        elementWidth,
        removePadding,
        removeMargin,
        customStyles,
        isCustomizing,
        isPageInEditMode,
        isPageInPreviewMode,
        elementMargins
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        ref: elementRef,
        testId: 'element-root',
        xcss: rootXCSS
    }, children);
};
const $72d7281f29eb7c7b$var$rootStyle = (0, $kig2V.xcss)({
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center'
});
const $72d7281f29eb7c7b$var$rootStyleIncreasedFlexibility = (0, $kig2V.xcss)({
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center',
    // do not add margin and padding is there is no children
    ':empty': {
        display: 'none'
    }
});
const $72d7281f29eb7c7b$var$rootStyleFullWith = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    width: 'auto'
});
const $72d7281f29eb7c7b$var$rootPaddingStyle = (0, $kig2V.xcss)({
    paddingTop: 'space.300',
    paddingBottom: 'space.300'
});
const $72d7281f29eb7c7b$export$6f424e557a8c03e = (0, $kig2V.xcss)({
    marginLeft: 'space.200',
    marginRight: 'space.200',
    marginTop: 'space.200',
    marginBottom: 'space.200',
    [(0, $1zYKE.media).above.xs]: {
        marginLeft: 'space.400',
        marginRight: 'space.400'
    }
});
const $72d7281f29eb7c7b$export$31724e6a9731e3b6 = (0, $kig2V.xcss)({
    marginLeft: 'space.400',
    marginRight: 'space.400',
    marginTop: 'space.400',
    marginBottom: 'space.400'
});
const $72d7281f29eb7c7b$var$rootStyleWithSidebarOpened = (0, $kig2V.xcss)({
    maxWidth: '336px',
    // 42 * 8
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 80rem)': {
        // ((110 + SIDEBAR_WIDTH_LARGE_MULTIPLIER) * 8) / 16;
        maxWidth: '720px' // 90 * 8
    },
    '@media (min-width: 102rem)': {
        // ((155 + SIDEBAR_WIDTH_LARGE_MULTIPLIER) * 8) / 16;
        maxWidth: '1160px' // 145 * 8
    }
});
const $72d7281f29eb7c7b$var$rootStyleWithSidebarClosed = (0, $kig2V.xcss)({
    maxWidth: '336px',
    // 42 * 8
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 60rem)': {
        maxWidth: '720px' // 90 * 8
    },
    '@media (min-width: 80rem)': {
        maxWidth: '1160px' // 145 * 8
    }
});

});



parcelRegister("iLM5T", function(module, exports) {
$parcel$export(module.exports, "useTFExtensionList", () => (parcelRequire("fH4Ny")).useTFExtensionList);

var $fH4Ny = parcelRequire("fH4Ny");

});
parcelRegister("fH4Ny", function(module, exports) {
$parcel$export(module.exports, "useTFExtensionList", () => $9e4e46b79be6d330$export$a10e5b463a47e957);

var $fc4bM = parcelRequire("fc4bM");

var $2UXyw = parcelRequire("2UXyw");

var $1HEEa = parcelRequire("1HEEa");

var $6LH8a = parcelRequire("6LH8a");

var $jEubQ = parcelRequire("jEubQ");

var $eENmG = parcelRequire("eENmG");

var $aIVqJ = parcelRequire("aIVqJ");
parcelRequire("6tdA4");
var $7QLam = parcelRequire("7QLam");
const $9e4e46b79be6d330$export$a10e5b463a47e957 = ({ type: type, resourceContext: resourceContext, page: page })=>{
    const [extensions, setExtensions] = $fc4bM.useState([]);
    // Tracks whether the availability fetch has settled (success or failure).
    // Consumers use this to distinguish "no apps installed" from "still
    // loading" — e.g. to decide when to show an editor empty state — without
    // relying on fragile reference-identity heuristics.
    const [resolved, setResolved] = $fc4bM.useState(false);
    const accountType = (0, $6LH8a.getMetaFromHTML)('ajs-account-type') || (0, $2UXyw.AtlassianHelpConfigAccountType).ANONYMOUS;
    const { getExtensionsByType: getExtensionsByType, getExtensionsByTypeV2: getExtensionsByTypeV2 } = $fc4bM.useContext((0, $7QLam.TFECacheContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    $fc4bM.useEffect(()=>{
        if (accountType === (0, $2UXyw.AtlassianHelpConfigAccountType).ATLASSIAN || accountType === (0, $2UXyw.AtlassianHelpConfigAccountType).ANONYMOUS || accountType === (0, $2UXyw.AtlassianHelpConfigAccountType).CUSTOMER) {
            const { resourceType: resourceType } = resourceContext || {};
            if (resourceType === (0, $1HEEa.RESOURCE_TYPE_ISSUE) || resourceType === (0, $1HEEa.RESOURCE_TYPE_PROJECT)) getExtensionsByTypeV2(type, resourceContext, page).then((fetchedExtensions)=>{
                setExtensions(fetchedExtensions[type] || []);
            }).catch((e)=>{
                (0, $aIVqJ.trackError)('forge-tfe.setState.failed', {}, e);
            }).finally(()=>{
                setResolved(true);
            });
            else getExtensionsByType(type, page).then((fetchedExtensions)=>{
                setExtensions(fetchedExtensions[type] || []);
            }).catch((e)=>{
                (0, $aIVqJ.trackError)('forge-tfe.setState.failed', {}, e);
            }).finally(()=>{
                setResolved(true);
            });
        } else // Account type that never fetches: treat as immediately resolved so
        // consumers do not wait forever for a request that will not happen.
        setResolved(true);
    }, [
        accountType,
        getExtensionsByType,
        getExtensionsByTypeV2,
        type,
        resourceContext,
        page,
        createAnalyticsEvent
    ]);
    $fc4bM.useEffect(()=>{
        extensions.forEach((extension)=>{
            const { id: id, dataClassificationPolicyDecision: dataClassificationPolicyDecision } = extension;
            const event = createAnalyticsEvent({
                actionSubject: 'forgeTFE',
                action: 'fetched',
                analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
                attributes: {
                    page: page,
                    moduleType: type,
                    status: dataClassificationPolicyDecision === null || dataClassificationPolicyDecision === void 0 ? void 0 : dataClassificationPolicyDecision.status,
                    extensionId: id
                }
            });
            event.context.push({
                componentName: 'forgeTFE'
            });
            event.fire();
        });
    }, [
        extensions,
        page,
        createAnalyticsEvent,
        type
    ]);
    return {
        extensions: extensions,
        resolved: resolved
    };
};

});



parcelRegister("chKSm", function(module, exports) {
$parcel$export(module.exports, "withStaticHubBreadcrumbs", () => (parcelRequire("lJe7m")).withStaticHubBreadcrumbs);

var $lJe7m = parcelRequire("lJe7m");

});
parcelRegister("lJe7m", function(module, exports) {
$parcel$export(module.exports, "withStaticHubBreadcrumbs", () => $e9d51c97b9c79b17$export$99bacf9a450014fe);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $9xVWL = parcelRequire("9xVWL");
parcelRequire("erve6");
var $agR85 = parcelRequire("agR85");

var $cBvEA = parcelRequire("cBvEA");
const $e9d51c97b9c79b17$export$ac4ac0508ba0d049 = {
    [(0, $9xVWL.HUB_ROUTES).JSM_REQUESTS_LIST.name]: {
        id: 'requests',
        message: (0, $cBvEA.staticHubBreadcrumbMessages).requests,
        path: (0, $9xVWL.HUB_ROUTES).JSM_REQUESTS_LIST.path
    },
    [(0, $9xVWL.HUB_ROUTES).JSM_APPROVALS.name]: {
        id: 'approvals',
        message: (0, $cBvEA.staticHubBreadcrumbMessages).approvals,
        path: (0, $9xVWL.HUB_ROUTES).JSM_APPROVALS.path
    },
    [(0, $9xVWL.HUB_ROUTES).USER_PROFILE.name]: {
        id: 'profile',
        message: (0, $cBvEA.staticHubBreadcrumbMessages).profile,
        path: (0, $9xVWL.HUB_ROUTES).USER_PROFILE.path
    }
};
const $e9d51c97b9c79b17$export$c2c425f5600ea5f7 = (routeName)=>$e9d51c97b9c79b17$export$ac4ac0508ba0d049[routeName];
const $e9d51c97b9c79b17$export$799d9c081c82ef5b = ({ children: children, routeName: routeName })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const route = $e9d51c97b9c79b17$export$c2c425f5600ea5f7(routeName);
    (0, $agR85.useHubBreadcrumbs)({
        currentItem: route ? {
            href: route.path,
            id: route.id,
            text: formatMessage(route.message)
        } : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children);
};
const $e9d51c97b9c79b17$export$99bacf9a450014fe = (Component, routeName)=>{
    const ComponentWithStaticHubBreadcrumbs = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e9d51c97b9c79b17$export$799d9c081c82ef5b, {
            routeName: routeName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props));
    ComponentWithStaticHubBreadcrumbs.displayName = `withStaticHubBreadcrumbs(${Component.displayName ?? Component.name ?? 'Component'})`;
    return ComponentWithStaticHubBreadcrumbs;
};

});
parcelRegister("erve6", function(module, exports) {
$parcel$export(module.exports, "useAreHubBreadcrumbsEnabled", () => (parcelRequire("agR85")).useAreHubBreadcrumbsEnabled);
$parcel$export(module.exports, "useHubBreadcrumbs", () => (parcelRequire("agR85")).useHubBreadcrumbs);

var $agR85 = parcelRequire("agR85");

});
parcelRegister("agR85", function(module, exports) {
$parcel$export(module.exports, "useAreHubBreadcrumbsEnabled", () => $c006a417e69a708c$export$7fee7fea09c78a48);
$parcel$export(module.exports, "useHubBreadcrumbs", () => $c006a417e69a708c$export$bfef814becf816f1);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $hPVoC = parcelRequire("hPVoC");

var $2MYZ0 = parcelRequire("2MYZ0");

var $cBvEA = parcelRequire("cBvEA");
const $c006a417e69a708c$export$a9cfa7bd6905691a = ({ currentItem: currentItem, homeText: homeText, ancestorItems: ancestorItems = [] })=>{
    if (!currentItem) return [];
    const normalizedHierarchy = [
        ...ancestorItems,
        currentItem
    ].map((item)=>{
        var _item$text;
        return {
            ...item,
            text: (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.trim()
        };
    });
    if (normalizedHierarchy.some((item)=>!item.text)) return [];
    return [
        {
            href: '/',
            id: 'home',
            text: homeText
        },
        ...normalizedHierarchy.map((item)=>({
                href: item.href,
                id: item.id,
                text: item.text ?? ''
            }))
    ];
};
const $c006a417e69a708c$export$7fee7fea09c78a48 = ()=>{
    const [isBreadcrumbsEnabled] = (0, $2MYZ0.useIsHubFeatureEnabled)([
        (0, $2MYZ0.HUB_FEATURES).BREADCRUMBS
    ]);
    return isBreadcrumbsEnabled;
};
const $c006a417e69a708c$export$bfef814becf816f1 = ({ ancestorItems: ancestorItems, currentItem: currentItem })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const isBreadcrumbsEnabled = $c006a417e69a708c$export$7fee7fea09c78a48();
    const items = (0, $fc4bM.useMemo)(()=>{
        if (!isBreadcrumbsEnabled) return [];
        return $c006a417e69a708c$export$a9cfa7bd6905691a({
            ancestorItems: ancestorItems,
            currentItem: currentItem,
            homeText: formatMessage((0, $cBvEA.staticHubBreadcrumbMessages).home)
        });
    }, [
        ancestorItems,
        currentItem,
        formatMessage,
        isBreadcrumbsEnabled
    ]);
    (0, $hPVoC.useRegisterHubBreadcrumbs)(items);
};

});
parcelRegister("cBvEA", function(module, exports) {
$parcel$export(module.exports, "staticHubBreadcrumbMessages", () => $b9e15c6a850bdc63$export$cc98b88bd82a9896);

var $iFjDK = parcelRequire("iFjDK");

var $1erEI = parcelRequire("1erEI");

var $iXURv = parcelRequire("iXURv");

var $cLYAN = parcelRequire("cLYAN");
const $b9e15c6a850bdc63$export$cc98b88bd82a9896 = {
    home: (0, $1erEI.default).breadcrumbsHome,
    requests: (0, $iXURv.default).title,
    approvals: (0, $iFjDK.default).title,
    profile: (0, $cLYAN.default).title
};

});
parcelRegister("iFjDK", function(module, exports) {
$parcel$export(module.exports, "default", () => $00f1df9b2a211a30$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $00f1df9b2a211a30$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    documentTitle: {
        defaultMessage: 'Approvals',
        description: 'title of the approval list page',
        id: 'cv.approval.list.document.title'
    },
    title: {
        defaultMessage: 'Approvals',
        description: 'headline of the approval list page',
        id: 'cv.approval.list.title'
    }
});

});

parcelRegister("iXURv", function(module, exports) {
$parcel$export(module.exports, "default", () => $415ddd5cff8ee02b$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $415ddd5cff8ee02b$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    documentTitle: {
        defaultMessage: 'Requests',
        description: 'title of the request list page',
        id: 'cv.request.list.document.title'
    },
    title: {
        defaultMessage: 'Requests',
        description: 'headline of the request list page',
        id: 'cv.request.list.title'
    }
});

});

parcelRegister("cLYAN", function(module, exports) {
$parcel$export(module.exports, "default", () => $a08391bfa02806a1$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $a08391bfa02806a1$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    title: {
        defaultMessage: 'Profile',
        description: 'headline of the customer portal profile page',
        id: 'cv.user.profile.title'
    }
});

});






parcelRegister("3WipF", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5uGya").then(()=>parcelRequire('5OrVn'));

});



parcelRegister("iDxNX", function(module, exports) {
$parcel$export(module.exports, "routeWithAiWidgetConfigResource", () => $bcc84723ff8690af$export$66e676d5e26b883e);

var $4Mkfe = parcelRequire("4Mkfe");
const $bcc84723ff8690af$export$66e676d5e26b883e = (route)=>{
    return {
        ...route,
        resources: [
            ...route.resources ?? [],
            (0, $4Mkfe.csmSupportWidgetConfigQueryResource)
        ]
    };
};

});
parcelRegister("4Mkfe", function(module, exports) {
$parcel$export(module.exports, "csmSupportWidgetConfigQueryResource", () => $1006e6d63be631fd$export$157d87119e3de36e);

var $k2M4v = parcelRequire("k2M4v");

var $6LH8a = parcelRequire("6LH8a");

var $8zK3E = parcelRequire("8zK3E");

var $3zCBT = parcelRequire("3zCBT");
const $1006e6d63be631fd$export$157d87119e3de36e = (0, $8zK3E.createRelayResource)({
    type: 'CSM_SUPPORT_WIDGET_CONFIG_QUERY',
    getQuery: ()=>({
            parameters: (0, $3zCBT.default),
            variables: {
                helpCenterAri: (0, $6LH8a.getMeta)('help-center-ari') ?? '',
                cloudId: (0, $6LH8a.getMeta)('tenant-id') ?? '',
                csm_ai_widget_in_contact_page: (0, $k2M4v.default).checkGate('csm_ai_widget_in_contact_page')
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("3zCBT", function(module, exports) {
$parcel$export(module.exports, "default", () => $882345a841666a47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b74cf2face947e7f9e6846984f58bf22>>
 * @relayHash 2d7b96c2ca29a77e4c115f4b68b89278
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 516996bf29728e2f3370af3f6f1e0ba41f72b24571c9531c8a1ac7bbada3b5e9
const $882345a841666a47$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "csm_ai_widget_in_contact_page"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v9 = {
        "kind": "ScalarField",
        "name": "position"
    }, v10 = {
        "concreteType": "CsmAiWidgetBrandingTheme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorVibeVariant"
            },
            {
                "kind": "ScalarField",
                "name": "radius"
            },
            {
                "kind": "ScalarField",
                "name": "space"
            },
            {
                "kind": "ScalarField",
                "name": "chatColor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "csm_ai_widget_in_contact_page",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "supportWidgetConfigProviderContactPage"
                                                    }
                                                ],
                                                "type": "CsmAiWidgetConfig"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contactPageConfig"
                                        }
                                    ]
                                },
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ],
                            "type": "CsmAiWidgetConfig"
                        },
                        {
                            "condition": "csm_ai_widget_in_contact_page",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "supportWidgetConfigProviderQueryError"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "queryError"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "condition": "csm_ai_widget_in_contact_page",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "contactPageExperience"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiWidgetConfig"
                        },
                        {
                            "condition": "csm_ai_widget_in_contact_page",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "516996bf29728e2f3370af3f6f1e0ba41f72b24571c9531c8a1ac7bbada3b5e9",
            "metadata": {},
            "name": "supportWidgetConfigProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$882345a841666a47$var$node.hash = "6dd9582237b5e50bf8e1a101130e2508";
var $882345a841666a47$export$2e2bcd8739ae039 = $882345a841666a47$var$node;

});



parcelRegister("3etYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c294ee9909567f99$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $luz1X = parcelRequire("luz1X");

var $hN5YJ = parcelRequire("hN5YJ");

var $2p58l = parcelRequire("2p58l");

var $gxSIz = parcelRequire("gxSIz");

parcelRequire("a3Wd7");
var $3iZvk = parcelRequire("3iZvk");
var $2drpp = parcelRequire("2drpp");

var $4MFtS = parcelRequire("4MFtS");

var $iidRB = parcelRequire("iidRB");

var $fQ6nv = parcelRequire("fQ6nv");

var $8Nv7y = parcelRequire("8Nv7y");

var $3dpJU = parcelRequire("3dpJU");

var $fU9IO = parcelRequire("fU9IO");

var $ciXwj = parcelRequire("ciXwj");

var $fHOft = parcelRequire("fHOft");

var $1NjiO = parcelRequire("1NjiO");

var $eKYgj = parcelRequire("eKYgj");

var $icz03 = parcelRequire("icz03");

var $4WfeP = parcelRequire("4WfeP");

var $d9md5 = parcelRequire("d9md5");

var $kM3gF = parcelRequire("kM3gF");

var $gp1kG = parcelRequire("gp1kG");

var $2eNaP = parcelRequire("2eNaP");

var $8cc0X = parcelRequire("8cc0X");

var $4l2XL = parcelRequire("4l2XL");

var $9fFmP = parcelRequire("9fFmP");

var $bT4AH = parcelRequire("bT4AH");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $jB96H = parcelRequire("jB96H");

var $k2M4v = parcelRequire("k2M4v");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $diqlM = parcelRequire("diqlM");

var $aWLgo = parcelRequire("aWLgo");
parcelRequire("5sUPt");
var $dTc6i = parcelRequire("dTc6i");
var $173qD = parcelRequire("173qD");
const $c294ee9909567f99$export$2f7745f2f5ab3897 = ()=>{
    return [
        ...(0, $cf3fd.isAdvancedHelpCenter)() || (0, $cf3fd.isFlexiHCEnabledInDefaultHC)() ? [
            (0, $4MFtS.getViewHomePageRoute)(),
            (0, $4MFtS.getEditHomePageRoute)()
        ] : [],
        ...(0, $hN5YJ.isEmailVerifiedSignalEnabled)() ? [
            (0, $bT4AH.userVerifyEmailRoute)
        ] : [],
        (0, $3dpJU.viewPortalConversationPageRoute),
        (0, $iidRB.aiAnswerRoute),
        (0, $8Nv7y.consentFormRoute),
        (0, $icz03.loginRoute),
        (0, $8cc0X.userResetPasswordRoute),
        (0, $8cc0X.userSignupRoute),
        (0, $8cc0X.userCompleteSignupRoute),
        (0, $8cc0X.userCheckMailRoute),
        (0, $4WfeP.portalAccessForbiddenRoute),
        (0, $icz03.portalLoginRoute),
        (0, $8cc0X.portalSignupRoute),
        (0, $8cc0X.portalResetPasswordRoute),
        (0, $8cc0X.portalCompleteSignupRoute),
        (0, $8cc0X.portalInvitedSignupRoute),
        (0, $dTc6i.requestFeedbackRoute),
        (0, $dTc6i.unsubscribeRoute),
        (0, $1NjiO.getHelpCenterRoute)(),
        (0, $4MFtS.getEditHomePageRoute)('edit-homepage', '/edit'),
        (0, $gp1kG.requestDetailsRoute),
        (0, $eKYgj.viewKbPageRoute),
        (0, $eKYgj.viewAllSearchResultsRoute),
        (0, $eKYgj.viewPortalAllSearchResultsRoute),
        (0, $eKYgj.viewPortalCategoryArticleRoute),
        (0, $eKYgj.viewPortalArticleRoute),
        (0, $eKYgj.viewCrossSitePortalArticleRoute),
        (0, $eKYgj.viewArticleRoute),
        (0, $eKYgj.viewCrossSiteArticleRoute),
        (0, $2eNaP.requestsListRoute),
        (0, $fQ6nv.approvalsRoute),
        (0, $kM3gF.requestApprovalRoute),
        (0, $dTc6i.userProfileRoute),
        (0, $eKYgj.viewPortalKnowledgeCategoryRoute),
        (0, $dTc6i.anonymousRequestSuccessRoute),
        (0, $dTc6i.getRequestCreateRoute)(),
        (0, $4l2XL.getSurveyRoute)(),
        (0, $d9md5.getPortalHomeRoutes)(),
        (0, $fHOft.getEmbedCreateRequestRoute)(),
        (0, $fHOft.embedSinglePortalRoute),
        (0, $fHOft.embedKBArticleRoute),
        ...(0, $k2M4v.default).checkGate('embed_hc_featured_portals') ? [
            (0, $fHOft.embedFeaturedPortalsRoute)
        ] : [],
        ...(0, $k2M4v.default).checkGate('jsm_portal_rovo_integration') ? [
            (0, $fHOft.embedLoginSuccessRoute)
        ] : [],
        (0, $173qD.portalReorderRoute)(true),
        (0, $ciXwj.editTopicRoute),
        (0, $ciXwj.addTopicRoute),
        (0, $9fFmP.getViewTopicRoute)(),
        ...(0, $3dpJU.getHelpCenterConversationPageRoute)(),
        ...(0, $7lN8e.getIsHCCustomizationEnabled)() ? [
            (0, $fU9IO.getEditCustomPageRoute)(),
            (0, $fU9IO.getViewCustomPageRoute)()
        ] : [],
        (0, $dTc6i.notFoundErrorRoute)
    ];
};
const $c294ee9909567f99$export$360df1dbfef16ccf = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $2p58l.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $2p58l.lightenColor)(themeColor);
    const routes = (0, $fc4bM.useMemo)(()=>$c294ee9909567f99$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $luz1X.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2drpp.Router), {
        routes: routes,
        history: (0, $diqlM.default),
        isGlobal: false,
        plugins: [
            (0, $aWLgo.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxSIz.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jB96H.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3iZvk.RouteComponent), null)));
};
const $c294ee9909567f99$var$selector = (0, $2n2bS.createSelector)((0, $fYLlE.getHeadless), (0, $ePyx3.getThemeColor), (0, $ePyx3.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $c294ee9909567f99$export$2e2bcd8739ae039 = (0, $6umft.default)($c294ee9909567f99$var$selector)($c294ee9909567f99$export$360df1dbfef16ccf);

});
parcelRegister("3dpJU", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterConversationPageRoute", () => $9a4c0bfb9694c74e$export$c0656a6d05f5099e);
$parcel$export(module.exports, "viewPortalConversationPageRoute", () => $9a4c0bfb9694c74e$export$226a8310910111d5);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $9mazR = parcelRequire("9mazR");

var $hN5YJ = parcelRequire("hN5YJ");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");
var $6FZlb = parcelRequire("6FZlb");

var $eSBzR = parcelRequire("eSBzR");
parcelRequire("jlh7w");
var $4Unyr = parcelRequire("4Unyr");

var $gu5dn = parcelRequire("gu5dn");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");
parcelRequire("cpU2y");
var $carvf = parcelRequire("carvf");
parcelRequire("22veO");
var $1btQp = parcelRequire("1btQp");
var $7t9uz = parcelRequire("7t9uz");
var $14eYg = parcelRequire("14eYg");

var $k2M4v = parcelRequire("k2M4v");

var $gioQl = parcelRequire("gioQl");
const $9a4c0bfb9694c74e$var$Error = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7t9uz.Error), null);
const $9a4c0bfb9694c74e$var$WrappedConversationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $14eYg.default), {
        renderError: $9a4c0bfb9694c74e$var$Error,
        component: (0, $1btQp.HelpCenterConversationPage),
        screenName: (0, $9mazR.ScreenName).CONVERSATION_PAGE,
        headerless: true,
        footerless: true
    });
const $9a4c0bfb9694c74e$export$80dcf24036ea46a1 = ()=>{
    const WrappedComponent = (0, $hN5YJ.isUnifiedHelpAddFilterForCustomerAccounts)() ? (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a4c0bfb9694c74e$var$WrappedConversationPage, null)) : (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }), (0, $gu5dn.default)())(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a4c0bfb9694c74e$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
const $9a4c0bfb9694c74e$export$ee1ce6de59399f4b = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const forbiddenPageOptions = {
        message: formatMessage((0, $1btQp.authPageMessage)),
        callToActionText: formatMessage((0, $1btQp.callToActionUrlText)),
        callToActionUrl: (0, $gioQl.getHelpCenterUrl)()
    };
    const enhancer = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }), (0, $4Unyr.default)(forbiddenPageOptions));
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a4c0bfb9694c74e$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
const $9a4c0bfb9694c74e$export$c0656a6d05f5099e = ()=>{
    const viewConversationPageRoute = {
        name: (0, $9mazR.ScreenName).CONVERSATION_PAGE,
        path: (0, $9mazR.VA_ON_HC_CONVERSATION_PATH),
        exact: true,
        resources: [
            (0, $eSBzR.HelpCenterVirtualAgentResource)
        ],
        component: $9a4c0bfb9694c74e$export$80dcf24036ea46a1
    };
    return [
        {
            ...viewConversationPageRoute,
            component: $9a4c0bfb9694c74e$export$ee1ce6de59399f4b
        }
    ];
};
const $9a4c0bfb9694c74e$export$6cb15740fc92fb28 = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [isTestConversationParam] = (0, $6FZlb.useQueryParam)('isTestConversation');
    const [isVSAAdoptionConversation] = (0, $6FZlb.useQueryParam)('vsaAdoption');
    const [portalIdAsString] = (0, $lJu6R.usePathParam)('portalId');
    const forbiddenPageOptions = {
        message: formatMessage((0, $1btQp.authPageMessage)),
        callToActionText: formatMessage((0, $1btQp.callToActionUrlText)),
        callToActionUrl: portalIdAsString ? `/portal/${portalIdAsString}` : (0, $gioQl.getHelpCenterUrl)(),
        hideBanner: (0, $k2M4v.default).checkGate('jsm_vsa_adoption_flickering_issue_fix') && isVSAAdoptionConversation === 'true'
    };
    const enhancer = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }), ...isTestConversationParam === 'true' ? [
        (0, $carvf.default)(forbiddenPageOptions)
    ] : []);
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $14eYg.default), {
            renderError: $9a4c0bfb9694c74e$var$Error,
            component: (0, $1btQp.PortalConversationPage),
            screenName: (0, $9mazR.ScreenName).CONVERSATION_PAGE,
            headerless: true,
            footerless: true
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props));
};
const $9a4c0bfb9694c74e$export$226a8310910111d5 = {
    name: (0, $9mazR.ScreenName).CONVERSATION_PAGE,
    path: (0, $9mazR.VA_ON_PORTAL_CONVERSATION_PATH),
    exact: true,
    component: $9a4c0bfb9694c74e$export$6cb15740fc92fb28
};

});
parcelRegister("eSBzR", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $48a80994d60ad924$export$7ab6648586bf1bbf);

var $8zK3E = parcelRequire("8zK3E");

var $5s5Sm = parcelRequire("5s5Sm");
const $48a80994d60ad924$export$7ab6648586bf1bbf = (0, $8zK3E.createRelayResource)({
    type: 'HELP_CENTER_CONVERSATION_PAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $5s5Sm.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("5s5Sm", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5d1418c60942c7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b10b2a606470ed53bdcc706bf0f6b686>>
 * @relayHash e78f9a445a8971ac73233b1bac7a2a92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6e5b97c3cdf9012b3e29fca6b6e5bbdb9affcff242479b192eed90727a18df5b
const $d5d1418c60942c7d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v6 = {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "containerId",
                        "variableName": "helpCenterAri"
                    }
                ],
                "kind": "ScalarField",
                "name": "virtualAgentAvailability"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "6e5b97c3cdf9012b3e29fca6b6e5bbdb9affcff242479b192eed90727a18df5b",
            "metadata": {},
            "name": "ConversationPageVirtualAgentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d5d1418c60942c7d$var$node.hash = "01910dc3315ecc30438398b0c72237c5";
var $d5d1418c60942c7d$export$2e2bcd8739ae039 = $d5d1418c60942c7d$var$node;

});


parcelRegister("jlh7w", function(module, exports) {
$parcel$export(module.exports, "withJsmAiConfigEnabled", () => (parcelRequire("4Unyr")).default);

var $4Unyr = parcelRequire("4Unyr");

});
parcelRegister("4Unyr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e972c0993cd0f595$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $9mazR = parcelRequire("9mazR");

var $9J2wU = parcelRequire("9J2wU");
parcelRequire("68iI4");
var $fYLlE = parcelRequire("fYLlE");
parcelRequire("imh0G");
var $d041D = parcelRequire("d041D");
const $e972c0993cd0f595$var$selector = (0, $2n2bS.createSelector)((0, $fYLlE.getJsmAIConfigEnabled), (jsmAIConfigEnabled)=>({
        jsmAIConfigEnabled: jsmAIConfigEnabled
    }));
const $e972c0993cd0f595$var$connector = (0, $6umft.default)($e972c0993cd0f595$var$selector, null);
const $e972c0993cd0f595$var$withJsmAiConfigEnabled = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { jsmAIConfigEnabled: jsmAIConfigEnabled } = props;
            if (jsmAIConfigEnabled) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $fc4bM.createElement((0, $d041D.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $fc4bM.createElement((0, $9J2wU.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $9mazR.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $e972c0993cd0f595$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithJsmAiConfigEnabled';
        return ConnectedComponent;
    };
var $e972c0993cd0f595$export$2e2bcd8739ae039 = $e972c0993cd0f595$var$withJsmAiConfigEnabled;

});


parcelRegister("gu5dn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce6408fe22518242$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $g9ziK = parcelRequire("g9ziK");
const $ce6408fe22518242$var$selector = (0, $2n2bS.createSelector)((0, $7RWiC.isAtlassianAccountManaged), (isAtlassianAccount)=>({
        isAtlassianAccount: isAtlassianAccount
    }));
const $ce6408fe22518242$var$connector = (0, $6umft.default)($ce6408fe22518242$var$selector, null);
const $ce6408fe22518242$var$withOnlyAtlassianAccount = ()=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isAtlassianAccount: isAtlassianAccount } = props;
            if (isAtlassianAccount) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props);
            return /*#__PURE__*/ $fc4bM.createElement((0, $g9ziK.Redirect), {
                to: "/user/forbidden"
            });
        };
        const ConnectedComponent = $ce6408fe22518242$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyAtlassianAccount';
        return ConnectedComponent;
    };
var $ce6408fe22518242$export$2e2bcd8739ae039 = $ce6408fe22518242$var$withOnlyAtlassianAccount;

});

parcelRegister("cpU2y", function(module, exports) {
$parcel$export(module.exports, "withOnlyProjectAdmin", () => (parcelRequire("carvf")).default);

var $carvf = parcelRequire("carvf");

});
parcelRegister("carvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4893da76f473420d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $9mazR = parcelRequire("9mazR");

var $9J2wU = parcelRequire("9J2wU");

var $aUHFa = parcelRequire("aUHFa");

var $aYMdQ = parcelRequire("aYMdQ");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");
parcelRequire("cizQ1");
var $hijaX = parcelRequire("hijaX");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");
parcelRequire("imh0G");
var $d041D = parcelRequire("d041D");
const $4893da76f473420d$var$selector = (0, $2n2bS.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    if (portalIdAsString) return (0, $9D9SX.getCanAdministerProject)(state, (0, $aYMdQ.toNumber)(portalIdAsString));
    return false;
}, (isProjectAdmin)=>({
        isProjectAdmin: isProjectAdmin
    }));
const $4893da76f473420d$var$connector = (0, $6umft.default)($4893da76f473420d$var$selector, {
    fetchPortals: (0, $hijaX.fetchPortalAction)
});
const $4893da76f473420d$var$withOnlyProjectAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isProjectAdmin: isProjectAdmin, fetchPortals: fetchPortals } = props;
            const [portalId] = (0, $lJu6R.usePathParam)('portalId');
            $fc4bM.useEffect(()=>{
                if (isProjectAdmin === undefined && options.hideBanner) fetchPortals({
                    id: (0, $aYMdQ.toSafeInteger)(portalId),
                    expand: [
                        'kbs',
                        'reqTypes',
                        'reqGroups',
                        'orderMapping'
                    ]
                });
            }, [
                isProjectAdmin,
                fetchPortals,
                portalId
            ]);
            if (isProjectAdmin === undefined) return options.hideBanner ? /*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.default), null) : /*#__PURE__*/ $fc4bM.createElement((0, $d041D.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $fc4bM.createElement((0, $aUHFa.default), null),
                layoutProps: {
                    headerless: false,
                    fadeInSearchModal: true
                }
            });
            if (isProjectAdmin) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $fc4bM.createElement((0, $d041D.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $fc4bM.createElement((0, $9J2wU.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $9mazR.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        // @ts-ignore
        const ConnectedComponent = $4893da76f473420d$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'withOnlyProjectAdmin';
        return ConnectedComponent;
    };
var $4893da76f473420d$export$2e2bcd8739ae039 = $4893da76f473420d$var$withOnlyProjectAdmin;

});


parcelRegister("22veO", function(module, exports) {
$parcel$export(module.exports, "Layout", () => (parcelRequire("14eYg")).default);
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("7t9uz")).Error);
$parcel$export(module.exports, "HelpCenterConversationPage", () => (parcelRequire("1btQp")).HelpCenterConversationPage);
$parcel$export(module.exports, "PortalConversationPage", () => (parcelRequire("1btQp")).PortalConversationPage);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("1btQp")).authPageMessage);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("1btQp")).callToActionUrlText);

var $14eYg = parcelRequire("14eYg");
parcelRequire("eAVe7");
var $7t9uz = parcelRequire("7t9uz");

var $1btQp = parcelRequire("1btQp");

});
parcelRegister("14eYg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3163a5ac4b881599$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("aQGvL");
var $jAOGD = parcelRequire("jAOGD");

const $3163a5ac4b881599$var$LoadAppLazily = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("eoZ5w")).then(({ App: App })=>(0, $jAOGD.default)(App)), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/app/App.tsx"
    })
});
const $3163a5ac4b881599$var$Layout = ({ component: component, screenName: screenName, renderError: renderError, headerless: headerless = false, footerless: footerless = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3163a5ac4b881599$var$LoadAppLazily, {
        component: component,
        screenName: screenName,
        renderError: renderError,
        layoutProps: {
            headerless: headerless,
            footerless: footerless
        }
    });
};
var $3163a5ac4b881599$export$2e2bcd8739ae039 = $3163a5ac4b881599$var$Layout;

});
parcelRegister("eoZ5w", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1ne6N"),
    $9dnsd("4M4fo")
]).then(()=>parcelRequire('hEk8l'));

});


parcelRegister("eAVe7", function(module, exports) {
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("7t9uz")).Error);

var $7t9uz = parcelRequire("7t9uz");

});
parcelRegister("7t9uz", function(module, exports) {
$parcel$export(module.exports, "Error", () => $e166dbb7513a6bb9$export$edf27be85e5f6da0);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");
parcelRequire("9KCPm");
var $43htV = parcelRequire("43htV");

var $729x1 = parcelRequire("729x1");
const $e166dbb7513a6bb9$export$edf27be85e5f6da0 = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $43htV.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $729x1.default).errorTitle),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, formatMessage((0, $729x1.default).errorDescriptionText, {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("a", {
                    href: "/servicedesk"
                }, chunks)
        })),
        hideFooter: true
    });
};

});
parcelRegister("729x1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ff1a48d709c714d$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $9ff1a48d709c714d$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorTitle: {
        defaultMessage: "We couldn\u2019t load this page",
        description: 'Text on show more results button',
        id: 'unified-help.error.page.title'
    },
    errorDescriptionText: {
        defaultMessage: 'Try refreshing the page or head to your <a>help center</a>.',
        description: 'Text for label on show more results icon',
        id: 'unified-help.error.page.description.text'
    }
});

});



parcelRegister("1btQp", function(module, exports) {
$parcel$export(module.exports, "HelpCenterConversationPage", () => $a971dc3505572689$export$1ebb9e18779d3716);
$parcel$export(module.exports, "PortalConversationPage", () => $a971dc3505572689$export$68489d6e6f9646e7);
$parcel$export(module.exports, "callToActionUrlText", () => $a971dc3505572689$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $a971dc3505572689$export$5342e2a00fe6d647);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

var $lhDcI = parcelRequire("lhDcI");

const $a971dc3505572689$export$1ebb9e18779d3716 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("4TPYA")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/conversation-page/ConversationPage.tsx"
    })
});

const $a971dc3505572689$export$68489d6e6f9646e7 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("kn7dI")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/portal-conversation-page/PortalConversationPage.tsx"
    })
});
const $a971dc3505572689$export$d96795d242b62963 = (0, $lhDcI.default).callToActionUrlText;
const $a971dc3505572689$export$5342e2a00fe6d647 = (0, $lhDcI.default).authPageMessage;

});
parcelRegister("lhDcI", function(module, exports) {
$parcel$export(module.exports, "default", () => $688d32facbcc36c2$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $688d32facbcc36c2$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.message.nonFinal'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to portal',
        description: 'Call to action text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.text.nonFinal'
    }
});

});

parcelRegister("4TPYA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gWCAL"),
    $9dnsd("5slKd"),
    $9dnsd("bQogk"),
    $9dnsd("hOVAC"),
    $9dnsd("j81ar"),
    $9dnsd("fQ86q"),
    $9dnsd("lgbKq"),
    $9dnsd("1AKkv"),
    $9dnsd("kQwdK"),
    $9dnsd("4A2hN"),
    $9dnsd("2aAs1"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("3EcVO"),
    $9dnsd("gxCRt"),
    $9dnsd("cz9eg"),
    $9dnsd("k09lt"),
    $9dnsd("7etds"),
    $9dnsd("aPbFz"),
    $9dnsd("lsa7j"),
    $9dnsd("2pTiU"),
    $9dnsd("1ne6N"),
    $9dnsd("7ZMu6")
]).then(()=>parcelRequire('jZLS6'));

});

parcelRegister("kn7dI", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gWCAL"),
    $9dnsd("5slKd"),
    $9dnsd("bQogk"),
    $9dnsd("hOVAC"),
    $9dnsd("j81ar"),
    $9dnsd("fQ86q"),
    $9dnsd("lgbKq"),
    $9dnsd("1AKkv"),
    $9dnsd("kQwdK"),
    $9dnsd("4A2hN"),
    $9dnsd("2aAs1"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("3EcVO"),
    $9dnsd("gxCRt"),
    $9dnsd("cz9eg"),
    $9dnsd("k09lt"),
    $9dnsd("7etds"),
    $9dnsd("aPbFz"),
    $9dnsd("lsa7j"),
    $9dnsd("2pTiU"),
    $9dnsd("1ne6N"),
    $9dnsd("b4uGY")
]).then(()=>parcelRequire('h7uHC'));

});




parcelRegister("2eNaP", function(module, exports) {
$parcel$export(module.exports, "requestsListRoute", () => $03ab1cb0e1d1ae55$export$28cf91f271fafef3);

var $9mazR = parcelRequire("9mazR");

var $chv7T = parcelRequire("chv7T");

var $joDHD = parcelRequire("joDHD");
const $03ab1cb0e1d1ae55$var$route = {
    name: 'requests-list',
    path: '/user/requests',
    exact: true,
    component: (0, $chv7T.RequestList)
};
const $03ab1cb0e1d1ae55$var$screeName = (0, $9mazR.ScreenName).REQUEST_LIST;
const $03ab1cb0e1d1ae55$var$paperAppearance = 'xxwide';
const $03ab1cb0e1d1ae55$var$layoutProps = {
    paperAppearance: $03ab1cb0e1d1ae55$var$paperAppearance,
    fadeInSearchModal: true
};
const $03ab1cb0e1d1ae55$export$28cf91f271fafef3 = (0, $joDHD.createRouteWithLayout)($03ab1cb0e1d1ae55$var$route, $03ab1cb0e1d1ae55$var$screeName, $03ab1cb0e1d1ae55$var$layoutProps);

});

parcelRegister("4l2XL", function(module, exports) {
$parcel$export(module.exports, "getSurveyRoute", () => $43737a8f682247ea$export$7cb84a2d5bf6d9c9);

var $9mazR = parcelRequire("9mazR");

var $joDHD = parcelRequire("joDHD");

var $jHziR = parcelRequire("jHziR");
const $43737a8f682247ea$export$7cb84a2d5bf6d9c9 = ()=>(0, $joDHD.createRouteWithLayout)({
        name: 'survey',
        path: '/portal/:portalId/survey/:surveyId',
        exact: true,
        component: (0, $jHziR.AsyncSurveyDetails),
        resources: []
    }, (0, $9mazR.ScreenName).SURVEY, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });

});

parcelRegister("aWLgo", function(module, exports) {
$parcel$export(module.exports, "resourcesPlugin", () => $822b8d9625dc9673$export$f4f160418a82e3b7);

var $6LH8a = parcelRequire("6LH8a");

var $1xOZp = parcelRequire("1xOZp");
parcelRequire("lmYMP");
var $fVzH4 = parcelRequire("fVzH4");

var $ivtaS = parcelRequire("ivtaS");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");
const $822b8d9625dc9673$var$shouldAddEdgeFallbackForHelpCenterType = (helpCenterType)=>(0, $cf3fd.isCSMHelpCenter)(helpCenterType) || helpCenterType === 'HELP_HUB';
const $822b8d9625dc9673$var$customContext = {
    cloudId: (0, $6LH8a.getCloudId)(),
    productName: (0, $ivtaS.PROJECT_NAME),
    helpCenterAri: (0, $6LH8a.getHelpCenterAri)(),
    workspaceAri: (0, $6LH8a.getWorkspaceAri)(),
    layoutAri: (0, $6LH8a.getLayoutAri)(),
    isUserLoggedIn: Boolean((0, $6LH8a.getMeta)('ajs-atlassian-account-id')),
    accountType: (0, $6LH8a.getMeta)('ajs-account-type') || '',
    relayEnvironment: (0, $1xOZp.getRelayEnvironment)(),
    // Read by the shared hub page resource, which gates a query variable on it and so needs it
    // before the query runs. Just the surface type, not ANDed with `enable_rovo_in_help_hubs`:
    // evaluating a feature gate at module scope resolves to false under SSR
    // (@atlaskit/platform/no-module-level-eval). The resource ANDs its own gate at call time.
    isHelpHub: (0, $cf3fd.getIsHelpHub)(),
    // Signal the shared hub bootstrap resource to add the edge-fallback request
    // header (`X-Edge-Fallback-To-Unidentified`) for CSM Support Site and JSM Help
    // Hub consumers.
    shouldAddEdgeFallbackToUnidentified: $822b8d9625dc9673$var$shouldAddEdgeFallbackForHelpCenterType((0, $7lN8e.getEnv)().helpCenterType)
};
const $822b8d9625dc9673$export$f4f160418a82e3b7 = (0, $fVzH4.createResourcesPlugin)({
    context: $822b8d9625dc9673$var$customContext
});

});



parcelRegister("hBWs0", function(module, exports) {
$parcel$export(module.exports, "helpCenterViewHomePageExperience", () => $44c16eef5e7158dc$export$deb53e4c26a043b6);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $44c16eef5e7158dc$export$deb53e4c26a043b6 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.helpCenterViewHomePageExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("iMyUt", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTE_FAMILY", () => $540f6197f7e5001c$export$5e0bd5dd4e173380);
$parcel$export(module.exports, "getHelpCenterRouteFamily", () => $540f6197f7e5001c$export$ea5555298bcabe28);

var $dRkX9 = parcelRequire("dRkX9");
const $540f6197f7e5001c$var$HELP_HUB_TYPE = 'HELP_HUB';
const $540f6197f7e5001c$export$5e0bd5dd4e173380 = 'hub';
const $540f6197f7e5001c$export$35bb63ad9165c1ed = 'legacy';
const $540f6197f7e5001c$export$ea5555298bcabe28 = (helpCenterType, hubsEnabled = (0, $dRkX9.fg)('enable-jsm-in-hubs'))=>{
    // Missing and unrecognised types retain the existing legacy routing behaviour.
    return hubsEnabled && helpCenterType === $540f6197f7e5001c$var$HELP_HUB_TYPE ? $540f6197f7e5001c$export$5e0bd5dd4e173380 : $540f6197f7e5001c$export$35bb63ad9165c1ed;
};

});

parcelRegister("3D8fH", function(module, exports) {
$parcel$export(module.exports, "default", () => $321fe41ba0b5d7c4$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $luz1X = parcelRequire("luz1X");

var $7VVXk = parcelRequire("7VVXk");

var $2p58l = parcelRequire("2p58l");

var $gxSIz = parcelRequire("gxSIz");
parcelRequire("a3Wd7");
var $3iZvk = parcelRequire("3iZvk");
var $2drpp = parcelRequire("2drpp");

var $eRolR = parcelRequire("eRolR");

var $dQIQC = parcelRequire("dQIQC");

var $3fkMn = parcelRequire("3fkMn");

var $fEbxN = parcelRequire("fEbxN");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $jB96H = parcelRequire("jB96H");

var $k2M4v = parcelRequire("k2M4v");

var $cf3fd = parcelRequire("cf3fd");

var $diqlM = parcelRequire("diqlM");

var $aWLgo = parcelRequire("aWLgo");
parcelRequire("5sUPt");
var $dTc6i = parcelRequire("dTc6i");
const $321fe41ba0b5d7c4$export$4c59d19d881588b9 = (props)=>{
    //Order matters here
    const routes = (0, $fc4bM.useMemo)(()=>{
        const includeRovoAgentRoute = (0, $cf3fd.getIsHelpHub)() && (0, $k2M4v.default).checkGate('enable_rovo_in_help_hubs') || (0, $7VVXk.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent');
        const includeVirtualAgentRoute = (0, $7VVXk.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        return [
            (0, $dQIQC.helpcenterEditRoute),
            (0, $dQIQC.helpcenterManageProjectsRoute),
            (0, $dQIQC.helpcenterManageCustomPagesRoute),
            ...(0, $k2M4v.default).checkGate('enable-jsm-in-hubs') ? [
                ...(0, $k2M4v.default).checkGate('portal-pages-in-hub') ? [
                    (0, $dQIQC.hubEditPortalLayoutRoute)
                ] : [],
                (0, $dQIQC.hubEditLayoutRoute)
            ] : [],
            // Feature gate: jsm_help_center_one-click_rovo_agent (Help Center) / enable_rovo_in_help_hubs (Help Hub)
            ...includeRovoAgentRoute ? [
                (0, $eRolR.helpcenterRovoServiceAgentRoute)
            ] : [],
            ...includeVirtualAgentRoute ? [
                (0, $3fkMn.helpcenterVirtualAgentRoute)
            ] : [],
            (0, $fEbxN.viewHelpCentersManagementPageRoute),
            ...(0, $k2M4v.default).checkGate('enable-jsm-in-hubs') ? [
                (0, $fEbxN.viewHelpHubsManagementPageRoute)
            ] : [],
            (0, $dTc6i.notFoundErrorRoute)
        ];
    }, []);
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $2p58l.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $2p58l.lightenColor)(themeColor);
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $luz1X.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2drpp.Router), {
        routes: routes,
        history: (0, $diqlM.default),
        isGlobal: false,
        plugins: [
            (0, $aWLgo.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxSIz.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jB96H.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3iZvk.RouteComponent), null)));
};
const $321fe41ba0b5d7c4$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getThemeColor), (0, $ePyx3.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $321fe41ba0b5d7c4$export$2e2bcd8739ae039 = (0, $6umft.default)($321fe41ba0b5d7c4$var$selector)($321fe41ba0b5d7c4$export$4c59d19d881588b9);

});
parcelRegister("eRolR", function(module, exports) {
$parcel$export(module.exports, "helpcenterRovoServiceAgentRoute", () => $d9d4064810374116$export$b887b8f40276e27c);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $bQkfB = parcelRequire("bQkfB");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");

var $80yPZ = parcelRequire("80yPZ");
parcelRequire("62zSr");
var $2oyaj = parcelRequire("2oyaj");

var $abuEW = parcelRequire("abuEW");

const $d9d4064810374116$var$AsyncRovoServiceAgentPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("kdCQx")).then((module)=>({
                default: module.RovoServiceAgentSettingsPageLoader
            })), {
        moduleId: "./packages/rovo-service-agent/rovo-service-agent-settings/src/index.tsx"
    })
});
const $d9d4064810374116$var$RovoServiceAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }), (0, $aylSc.default)({
        message: formatMessage((0, $80yPZ.authPageMessage)),
        callToActionText: formatMessage((0, $80yPZ.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2oyaj.default), {
            featureName: "Rovo Service Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d9d4064810374116$var$AsyncRovoServiceAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
const $d9d4064810374116$export$b887b8f40276e27c = {
    name: 'rovoServiceAgentSettings',
    path: '/:helpcenterId/rovo-agent',
    exact: true,
    resources: [
        (0, $abuEW.HelpCenterRovoServiceAgentResource)
    ],
    component: (0, $7tc2B.withRouter)($d9d4064810374116$var$RovoServiceAgentPage)
};

});
parcelRegister("62zSr", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("2oyaj")).default);
$parcel$export(module.exports, "useHelpCenterAri", () => (parcelRequire("5kxdi")).useHelpCenterAri);
$parcel$export(module.exports, "useConditionalMessage", () => (parcelRequire("4OGFc")).useConditionalMessage);
parcelRequire("6BaOS");
var $2oyaj = parcelRequire("2oyaj");

var $5kxdi = parcelRequire("5kxdi");

var $4OGFc = parcelRequire("4OGFc");

});
parcelRegister("6BaOS", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("2oyaj")).default);
parcelRequire("evfUT");
var $2oyaj = parcelRequire("2oyaj");
parcelRequire("cu3fi");
var $AsQS9 = parcelRequire("AsQS9");

var $7JIA1 = parcelRequire("7JIA1");

});
parcelRegister("evfUT", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("2oyaj")).default);
$parcel$export(module.exports, "AdminManagementLayoutLoader", () => (parcelRequire("2oyaj")).AdminManagementLayoutLoader);

var $2oyaj = parcelRequire("2oyaj");

});
parcelRegister("2oyaj", function(module, exports) {
$parcel$export(module.exports, "default", () => $363e3b8c005916a7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AdminManagementLayoutLoader", () => $363e3b8c005916a7$export$5684c902453038e9);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $iya1I = parcelRequire("iya1I");

var $hN5YJ = parcelRequire("hN5YJ");

var $gxSIz = parcelRequire("gxSIz");

var $lXJd8 = parcelRequire("lXJd8");

var $hnTdV = parcelRequire("hnTdV");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");
var $7lAXH = parcelRequire("7lAXH");
parcelRequire("b46ZL");
var $7RWiC = parcelRequire("7RWiC");

var $fXKVz = parcelRequire("fXKVz");

var $DpObF = parcelRequire("DpObF");

var $k2M4v = parcelRequire("k2M4v");

var $lSZGi = parcelRequire("lSZGi");

var $inMs5 = parcelRequire("inMs5");

var $jK5Nz = parcelRequire("jK5Nz");

var $dFt22 = parcelRequire("dFt22");

var $8MEIm = parcelRequire("8MEIm");

var $7sw4G = parcelRequire("7sw4G");

var $5PQxp = parcelRequire("5PQxp");

var $ftqVM = parcelRequire("ftqVM");

var $6BtWW = parcelRequire("6BtWW");

var $6920b = parcelRequire("6920b");

var $jp7SM = parcelRequire("jp7SM");

var $5a4EU = parcelRequire("5a4EU");

var $1zYKE = parcelRequire("1zYKE");

var $kig2V = parcelRequire("kig2V");

var $7yidP = parcelRequire("7yidP");

var $9tXBF = parcelRequire("9tXBF");

var $7lN8e = parcelRequire("7lN8e");

var $cBXWW = parcelRequire("cBXWW");

var $l5kZr = parcelRequire("l5kZr");
parcelRequire("ahbzr");
var $8Q1to = parcelRequire("8Q1to");
parcelRequire("7ijSZ");
var $gcPtm = parcelRequire("gcPtm");

var $hTV59 = parcelRequire("hTV59");
const $363e3b8c005916a7$var$AdminManagementLayoutContentBase = ({ children: children, featureName: featureName, hasSiteAdministerAccess: hasSiteAdministerAccess, hideSidebar: hideSidebar })=>{
    const [{ route: route }, { push: push }] = (0, $7lAXH.useRouter)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [helpCenterId = ''] = (0, $lJu6R.usePathParam)('helpcenterId');
    const { name: routeName } = route;
    const { isHelpHub: isHelpHub } = (0, $cBXWW.useHelpCenterType)();
    const rovoServiceAgentRouteName = 'rovoServiceAgentSettings';
    const rovoServiceAgentUrl = `/${helpCenterId}/rovo-agent`;
    const virtualAgentRouteName = 'virtualAgentSettings';
    const virtualAgentUrl = `/${helpCenterId}/virtual-agent`;
    const mapProjectsScreenUrl = `/${helpCenterId}/projects`;
    const mapPagesScreenUrl = `/${helpCenterId}/pages`;
    const editProjectDetailsScreenUrl = `/${helpCenterId}/details`;
    const navigationContentItems = [
        {
            onClick: ()=>push(editProjectDetailsScreenUrl),
            text: formatMessage((0, $hTV59.default).helpcenterDetailsItem),
            isVisible: true,
            isSelected: routeName === 'edit-details',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MEIm))), {
                label: formatMessage((0, $hTV59.default).helpcenterDetailsItem)
            })
        },
        {
            onClick: ()=>push(mapProjectsScreenUrl),
            text: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $hTV59.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $hTV59.default).helpcenterManageProjectsItem),
            isSelected: routeName === 'manage-projects',
            isVisible: true,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
                label: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $hTV59.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $hTV59.default).helpcenterManageProjectsItem)
            })
        }
    ];
    // The manage-pages page is only an upsell for non-premium users.
    // So we only show it for premium users or users with billing permission.
    if ((0, $7lN8e.getIsHCCustomizationEnabled)() || hasSiteAdministerAccess) navigationContentItems.push({
        onClick: ()=>push(mapPagesScreenUrl),
        text: formatMessage((0, $hTV59.default).helpcenterManagePagesItem),
        isSelected: routeName === 'manage-pages',
        isVisible: !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jK5Nz))), {
            label: formatMessage((0, $hTV59.default).helpcenterManagePagesItem)
        })
    });
    // Rovo Agent
    // For Help Hubs: gated behind enable_rovo_in_help_hubs
    // For Help Centers: gated behind jsm_help_center_one-click_rovo_agent
    navigationContentItems.push({
        onClick: ()=>push(rovoServiceAgentUrl),
        text: formatMessage((0, $hTV59.default).helpcenterRovoServiceAgentItem),
        isSelected: routeName === rovoServiceAgentRouteName,
        isVisible: isHelpHub ? (0, $k2M4v.default).checkGate('enable_rovo_in_help_hubs') : (0, $k2M4v.default).checkGate('jsm_help_center_one-click_rovo_agent'),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFt22))), {
            label: formatMessage((0, $hTV59.default).helpcenterRovoServiceAgentItem)
        })
    });
    // Virtual Service Agent
    if (!(0, $hN5YJ.isHideVsaEndpointsEnabled)() && (!hasSiteAdministerAccess || (0, $7lN8e.getIsHCCustomizationEnabled)())) navigationContentItems.push({
        onClick: ()=>push(virtualAgentUrl),
        text: formatMessage((0, $hTV59.default).helpcenterVsaReportingItem),
        isSelected: routeName === virtualAgentRouteName,
        isVisible: (0, $7lN8e.getJsmAIConfigEnabled)() && !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
            label: formatMessage((0, $hTV59.default).helpcenterVsaReportingItem)
        })
    });
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $DpObF.default), {
            header: formatMessage((0, $hTV59.default).errorTitle),
            description: formatMessage((0, $hTV59.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hnTdV)))
        });
    };
    const packageName = ()=>{
        switch(routeName){
            case 'edit-details':
                return 'editDetails';
            case 'manage-projects':
                return 'manageProjects';
            case 'manage-pages':
                return 'managePages';
            case 'rovoServiceAgentSettings':
                return 'rovoServiceAgentSettings';
            case 'virtualAgentSettings':
                return 'virtualAgentSettings';
            case 'reporting':
                return 'reporting';
            default:
                return 'unknown';
        }
    };
    const mainContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ftqVM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: packageName(),
        id: 'admin-layout-management-page',
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: hideSidebar ? $363e3b8c005916a7$var$container : [
            $363e3b8c005916a7$var$container,
            $363e3b8c005916a7$var$containerWithMaxWidth
        ]
    }, children)));
    const isTablet = !(0, $fXKVz.useMediaQuery)(`(max-width: ${(0, $lXJd8.sizes).xsmall}px)`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5PQxp.default), {
        blanketIsTinted: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: [
            $363e3b8c005916a7$var$pageLayoutWrapper,
            hideSidebar && $363e3b8c005916a7$var$pageLayoutWrapperHideOverflow
        ],
        testId: "admin-layout-management-page-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6920b.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jp7SM.default), {
        isFixed: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8Q1to.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6BtWW.default), null, isTablet && !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gcPtm.default), {
        width: (0, $l5kZr.SIDEBAR_WIDTH),
        navigationContentItems: navigationContentItems,
        featureName: featureName
    }), hideSidebar ? mainContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $363e3b8c005916a7$var$bodyContainer,
        testId: "admin-layout-body-container"
    }, mainContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxSIz.NewGlobalBGColor), null)))));
};
const $363e3b8c005916a7$var$selector = (0, $2n2bS.createSelector)((state)=>{
    return {
        hasSiteAdministerAccess: (0, $7RWiC.getHasSiteAdministerAccess)(state)
    };
}, ({ hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
const $363e3b8c005916a7$var$AdminManagementLayoutContent = (0, $6umft.default)($363e3b8c005916a7$var$selector)($363e3b8c005916a7$var$AdminManagementLayoutContentBase);
const $363e3b8c005916a7$export$b52b33be5684c42c = ({ children: children, featureName: featureName, loadingFallback: loadingFallback, hideSidebar: hideSidebar = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: loadingFallback ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cBXWW.HelpCenterTypeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($363e3b8c005916a7$var$AdminManagementLayoutContent, {
        featureName: featureName,
        hideSidebar: hideSidebar
    }, children)));
};
var $363e3b8c005916a7$export$2e2bcd8739ae039 = $363e3b8c005916a7$export$b52b33be5684c42c;
const $363e3b8c005916a7$var$loaderStyles = {
    container: (0, $kig2V.xcss)({
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    }),
    content: (0, $kig2V.xcss)({
        display: 'flex',
        flexGrow: 1,
        minHeight: '0px'
    }),
    sidebar: (0, $kig2V.xcss)({
        width: '240px',
        paddingTop: 'space.200',
        paddingRight: 'space.200',
        paddingBottom: 'space.200',
        paddingLeft: 'space.200'
    }),
    pageContent: (0, $kig2V.xcss)({
        flexGrow: 1,
        minHeight: '0px',
        paddingTop: 'space.400',
        paddingRight: 'space.300',
        paddingBottom: 'space.300',
        paddingLeft: 'space.300'
    })
};
const $363e3b8c005916a7$export$5684c902453038e9 = ({ hideSidebar: hideSidebar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $363e3b8c005916a7$var$loaderStyles.container,
        testId: "admin-management-layout-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tXBF.default), {
        width: "100%",
        height: 58
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $363e3b8c005916a7$var$loaderStyles.content
    }, !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $363e3b8c005916a7$var$loaderStyles.sidebar,
        testId: "admin-management-layout-loader-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tXBF.default), {
        width: "70%",
        height: 24,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tXBF.default), {
        width: "100%",
        height: 16,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tXBF.default), {
        width: "85%",
        height: 16,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tXBF.default), {
        width: "100%",
        height: 16,
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $363e3b8c005916a7$var$loaderStyles.pageContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tXBF.default), {
        width: "100%",
        height: "100%",
        isShimmering: true
    }))));
const $363e3b8c005916a7$var$container = (0, $kig2V.xcss)({
    margin: '0 auto',
    paddingBottom: 'space.050',
    paddingInline: 'space.600',
    [(0, $1zYKE.media).above.lg]: {
        paddingInline: 'space.0'
    }
});
const $363e3b8c005916a7$var$containerWithMaxWidth = (0, $kig2V.xcss)({
    maxWidth: '1160px'
});
const $363e3b8c005916a7$var$pageLayoutWrapper = (0, $kig2V.xcss)({
    overflowAnchor: 'none',
    height: '100%'
});
// In hub edit mode the editor uses its own fixed-height scroll container, so the
// page wrapper must not scroll — otherwise a second scrollbar appears on large screens.
const $363e3b8c005916a7$var$pageLayoutWrapperHideOverflow = (0, $kig2V.xcss)({
    overflow: 'hidden'
});
const $363e3b8c005916a7$var$bodyContainer = (0, $kig2V.xcss)({
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: `calc(100vh - (${(0, $7sw4G.TOP_NAVIGATION_HEIGHT)} + ${(0, $7sw4G.BANNER_HEIGHT)}))`,
    width: '100%'
});

});
parcelRegister("hnTdV", function(module, exports) {
module.exports = new URL("../images/project-mapping-error.ef7a4be3.svg", import.meta.url).toString();

});

parcelRegister("DpObF", function(module, exports) {
$parcel$export(module.exports, "default", () => $bef01e00105b62a4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $lHYHS = parcelRequire("lHYHS");

var $1hJdJ = parcelRequire("1hJdJ");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $hculA = parcelRequire("hculA");

var $v9h8K = parcelRequire("v9h8K");

var $6Gx8w = parcelRequire("6Gx8w");

var $lGafC = parcelRequire("lGafC");

var $dsm7V = parcelRequire("dsm7V");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $bef01e00105b62a4$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $v9h8K.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $lHYHS.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dsm7V.default), {
                children: isLoading && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $6Gx8w.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lGafC.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $bef01e00105b62a4$export$2e2bcd8739ae039 = $bef01e00105b62a4$var$EmptyState;

});
parcelRegister("v9h8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $a13ab08d9752b658$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $a13ab08d9752b658$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $a13ab08d9752b658$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $a13ab08d9752b658$export$2e2bcd8739ae039 = $a13ab08d9752b658$var$ActionsContainer;

});

parcelRegister("6Gx8w", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce7e405f70ee0243$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $ce7e405f70ee0243$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $ce7e405f70ee0243$var$wideContainerStyles = null;
const $ce7e405f70ee0243$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $ce7e405f70ee0243$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $ce7e405f70ee0243$export$2e2bcd8739ae039 = $ce7e405f70ee0243$var$Container;

});

parcelRegister("lGafC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a2e3cb5c639dd78$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $3a2e3cb5c639dd78$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $3a2e3cb5c639dd78$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $3a2e3cb5c639dd78$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $3a2e3cb5c639dd78$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $3LM7S.jsx)("img", {
        style: {
            [$3a2e3cb5c639dd78$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$3a2e3cb5c639dd78$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $2R2iS.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $3a2e3cb5c639dd78$export$2e2bcd8739ae039 = $3a2e3cb5c639dd78$var$Image;

});

parcelRegister("dsm7V", function(module, exports) {
$parcel$export(module.exports, "default", () => $45445d9c3694fbd1$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $45445d9c3694fbd1$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $45445d9c3694fbd1$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $45445d9c3694fbd1$export$2e2bcd8739ae039 = $45445d9c3694fbd1$var$SpinnerContainer;

});


parcelRegister("jK5Nz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de050e7ad7082dc8bd3a7ec6dcb292e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5f6cfa89700d69b$var$_react = $e5f6cfa89700d69b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e5f6cfa89700d69b$var$_iconNew = $e5f6cfa89700d69b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e5f6cfa89700d69b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pages
 * Usage guidance:
 * Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5f6cfa89700d69b$var$PagesIcon = (props)=>/*#__PURE__*/ $e5f6cfa89700d69b$var$_react.default.createElement($e5f6cfa89700d69b$var$_iconNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$e5f6cfa89700d69b$var$PagesIcon.displayName = 'PagesIcon';
var $e5f6cfa89700d69b$var$_default = module.exports.default = $e5f6cfa89700d69b$var$PagesIcon;

});

parcelRegister("dFt22", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c789d79db2d4e9441e0875f3295345a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f359fd087d7f365$var$_react = $9f359fd087d7f365$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9f359fd087d7f365$var$_iconNew = $9f359fd087d7f365$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9f359fd087d7f365$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/rovo
 * Usage guidance:
 * Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f359fd087d7f365$var$RovoIcon = (props)=>/*#__PURE__*/ $9f359fd087d7f365$var$_react.default.createElement($9f359fd087d7f365$var$_iconNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$9f359fd087d7f365$var$RovoIcon.displayName = 'RovoIcon';
var $9f359fd087d7f365$var$_default = module.exports.default = $9f359fd087d7f365$var$RovoIcon;

});

parcelRegister("8MEIm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c33c49386fab22e088fef79f72c28139>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01a67d79c74fe517$var$_react = $01a67d79c74fe517$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $01a67d79c74fe517$var$_iconNew = $01a67d79c74fe517$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $01a67d79c74fe517$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/wrench
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $01a67d79c74fe517$var$WrenchIcon = (props)=>/*#__PURE__*/ $01a67d79c74fe517$var$_react.default.createElement($01a67d79c74fe517$var$_iconNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$01a67d79c74fe517$var$WrenchIcon.displayName = 'WrenchIcon';
var $01a67d79c74fe517$var$_default = module.exports.default = $01a67d79c74fe517$var$WrenchIcon;

});

parcelRegister("7sw4G", function(module, exports) {
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $06f4f566b5000b0a$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $06f4f566b5000b0a$export$ed7cc0d417ee89e);
/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $06f4f566b5000b0a$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $06f4f566b5000b0a$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $06f4f566b5000b0a$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $06f4f566b5000b0a$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $06f4f566b5000b0a$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $06f4f566b5000b0a$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

});

parcelRegister("jp7SM", function(module, exports) {
$parcel$export(module.exports, "default", () => $622af3b6c0fec37b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $ieqE6 = parcelRequire("ieqE6");

var $gMNCr = parcelRequire("gMNCr");

var $11jpN = parcelRequire("11jpN");

var $6586e = parcelRequire("6586e");
var $kGKYz = parcelRequire("kGKYz");

var $5OEc0 = parcelRequire("5OEc0");

var $c6HWM = parcelRequire("c6HWM");
const $622af3b6c0fec37b$var$topNavigationStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ieqE6.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ieqE6.TOP_NAVIGATION)
});
const $622af3b6c0fec37b$var$fixedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $ieqE6.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ieqE6.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ieqE6.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $622af3b6c0fec37b$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $ieqE6.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $11jpN.resolveDimension)((0, $ieqE6.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $fc4bM.useEffect)(()=>{
        (0, $6586e.default)({
            [(0, $ieqE6.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $6586e.default)({
                [(0, $ieqE6.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $kGKYz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5OEc0.default), null, ({ className: className })=>/*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: [
                $622af3b6c0fec37b$var$topNavigationStyles,
                isFixed && $622af3b6c0fec37b$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $gMNCr.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $c6HWM.default), {
            variableName: (0, $ieqE6.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $622af3b6c0fec37b$export$2e2bcd8739ae039 = $622af3b6c0fec37b$var$TopNavigation;

});
parcelRegister("11jpN", function(module, exports) {
$parcel$export(module.exports, "resolveDimension", () => $c9a2505a353908a2$export$74732e47915c7839);

var $axI6K = parcelRequire("axI6K");
const $c9a2505a353908a2$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = (0, $axI6K.getGridStateFromStorage)('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};

});
parcelRegister("axI6K", function(module, exports) {
$parcel$export(module.exports, "getGridStateFromStorage", () => $aa06d2565d2473be$export$d95e99d8116d17dc);

var $ieqE6 = parcelRequire("ieqE6");

var $fBMW2 = parcelRequire("fBMW2");
const $aa06d2565d2473be$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $fBMW2.default)().getItem((0, $ieqE6.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};

});
parcelRegister("fBMW2", function(module, exports) {
$parcel$export(module.exports, "default", () => $15f2faa2bd359920$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $15f2faa2bd359920$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(testKey, testKey);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.removeItem(testKey);
        return true;
    } catch  {
        return false;
    }
};
const $15f2faa2bd359920$var$safeLocalStorage = ()=>{
    if ($15f2faa2bd359920$var$isLocalStorageSupported()) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $15f2faa2bd359920$export$2e2bcd8739ae039 = $15f2faa2bd359920$var$safeLocalStorage;

});



parcelRegister("6586e", function(module, exports) {
$parcel$export(module.exports, "default", () => $a62aaace432c2c0e$export$2e2bcd8739ae039);

var $lqfQV = parcelRequire("lqfQV");

var $kZR7U = parcelRequire("kZR7U");
const $a62aaace432c2c0e$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $kZR7U.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $lqfQV.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $a62aaace432c2c0e$export$2e2bcd8739ae039 = $a62aaace432c2c0e$var$publishGridState;

});
parcelRegister("lqfQV", function(module, exports) {
$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $c55244fe9f00abed$export$f8355a2df0f4a946);

var $ieqE6 = parcelRequire("ieqE6");

var $fBMW2 = parcelRequire("fBMW2");
const $c55244fe9f00abed$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $fBMW2.default)().getItem((0, $ieqE6.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $fBMW2.default)().setItem((0, $ieqE6.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};

});

parcelRegister("kZR7U", function(module, exports) {
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $850fad4609ac1b1d$export$17e3760e0b35f1cd);

var $ieqE6 = parcelRequire("ieqE6");

var $fBMW2 = parcelRequire("fBMW2");
const $850fad4609ac1b1d$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $fBMW2.default)().getItem((0, $ieqE6.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $fBMW2.default)().setItem((0, $ieqE6.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};

});


parcelRegister("c6HWM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b5402cea028969b$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gEQiC = parcelRequire("gEQiC");
/**
 * Hoists slot dimension styles to the root element.
 */ const $4b5402cea028969b$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $gEQiC.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3LM7S.jsx)("style", {
        children: style
    }));
};
var $4b5402cea028969b$export$2e2bcd8739ae039 = $4b5402cea028969b$var$SlotDimensions;

});


parcelRegister("cBXWW", function(module, exports) {
$parcel$export(module.exports, "HelpCenterTypeProvider", () => $9b5247b02b8fc96b$export$d53895d6fb159859);
$parcel$export(module.exports, "useHelpCenterType", () => $9b5247b02b8fc96b$export$f4dfe81df1da8e40);
$parcel$export(module.exports, "useOptionalHelpCenterType", () => $9b5247b02b8fc96b$export$9f436e6b1d27b8b1);

var $gvt9g = parcelRequire("gvt9g");

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $3BZyK = parcelRequire("3BZyK");

var $5kxdi = parcelRequire("5kxdi");
const $9b5247b02b8fc96b$var$HelpCenterTypeContext = /*#__PURE__*/ (0, $fc4bM.createContext)(undefined);
const $9b5247b02b8fc96b$export$d53895d6fb159859 = ({ children: children })=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $5kxdi.useHelpCenterAri)();
    const cloudId = (0, $6LH8a.getCloudId)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $gvt9g.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterType = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.type) ?? null;
    const isHelpHub = helpCenterType === 'HELP_HUB';
    const value = {
        helpCenterType: helpCenterType,
        isHelpHub: isHelpHub
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9b5247b02b8fc96b$var$HelpCenterTypeContext.Provider, {
        value: value
    }, children);
};
const $9b5247b02b8fc96b$export$f4dfe81df1da8e40 = ()=>{
    const context = (0, $fc4bM.useContext)($9b5247b02b8fc96b$var$HelpCenterTypeContext);
    if (context === undefined) throw new Error('useHelpCenterType must be used within a HelpCenterTypeProvider');
    return context;
};
const $9b5247b02b8fc96b$export$9f436e6b1d27b8b1 = ()=>{
    const context = (0, $fc4bM.useContext)($9b5247b02b8fc96b$var$HelpCenterTypeContext);
    // Default to BASIC/Help Center when context is not available (e.g., creating new help centers)
    return context ?? {
        helpCenterType: null,
        isHelpHub: false
    };
};

});
parcelRegister("gvt9g", function(module, exports) {
$parcel$export(module.exports, "default", () => $43fbf4d848859532$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85612eb43834db2f494f160069fa5560>>
 * @relayHash beb53aa7a0d0e9601d0a8ed6e41c37bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65
const $43fbf4d848859532$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65",
            "metadata": {},
            "name": "helpCenterTypeContextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$43fbf4d848859532$var$node.hash = "84d5aba1364a6a49146d359035c72854";
var $43fbf4d848859532$export$2e2bcd8739ae039 = $43fbf4d848859532$var$node;

});

parcelRegister("5kxdi", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterAri", () => $96d2a24ec2491be5$export$f14e6e523bbc25e7);
/**
 This hook will only work if the helpcenterId exists in the path param and the activation-id exists in the meta tag.
 @returns {string} The Help Center ARI.
 */ 
var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $lJu6R = parcelRequire("lJu6R");

var $4MoYu = parcelRequire("4MoYu");
const $96d2a24ec2491be5$export$f14e6e523bbc25e7 = ()=>{
    const [helpCenterId = ''] = (0, $lJu6R.usePathParam)('helpcenterId');
    const activationId = (0, $6LH8a.getMeta)('activation-id') || '';
    const helpCenterAri = (0, $4MoYu.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
    return helpCenterAri;
};

});


parcelRegister("l5kZr", function(module, exports) {
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $e72f4cae711c5e5e$export$780035d9fe48eb32);
$parcel$export(module.exports, "CANT_UNLINK_ALL_DIALOG", () => $e72f4cae711c5e5e$export$34c86dd326ed7328);
$parcel$export(module.exports, "UNLINK_CONFIRMATION_DIALOG", () => $e72f4cae711c5e5e$export$e1e71e4a40967783);
$parcel$export(module.exports, "MANAGE_PROJECT_HEAD_WIDTH", () => $e72f4cae711c5e5e$export$39266233350d2cc1);
$parcel$export(module.exports, "MANAGE_PAGE_HEAD_WIDTH", () => $e72f4cae711c5e5e$export$d93583f12bb7f663);
$parcel$export(module.exports, "ALREADY_EXISTED_CUSTOM_PAGE_MESSAGE", () => $e72f4cae711c5e5e$export$24707863b4005c32);
$parcel$export(module.exports, "CUSTOM_PAGE_NAME_CHARACTER_LIMIT", () => $e72f4cae711c5e5e$export$7b26638f36689ddd);
$parcel$export(module.exports, "CUSTOM_PAGE_DESC_CHARACTER_LIMIT", () => $e72f4cae711c5e5e$export$8dc5686b04c6900a);
$parcel$export(module.exports, "NUMBER_OF_PAGES_INITIAL_FETCH", () => $e72f4cae711c5e5e$export$4b69f23d48ad7a80);
$parcel$export(module.exports, "HARD_LIMIT_CUSTOM_PAGES_MESSAGE", () => $e72f4cae711c5e5e$export$7e882a52c33de54f);
$parcel$export(module.exports, "NUMBER_OF_PAGES_PER_PAGE", () => $e72f4cae711c5e5e$export$806937cd4427be30);
const $e72f4cae711c5e5e$export$780035d9fe48eb32 = 240;
const $e72f4cae711c5e5e$export$34c86dd326ed7328 = 'cant-unlink-all-dialog';
const $e72f4cae711c5e5e$export$e1e71e4a40967783 = 'unlink-confirmation-dialog';
const $e72f4cae711c5e5e$export$39266233350d2cc1 = {
    'select-all': 5,
    'project-name': 35,
    'lead-name': 35,
    status: 15,
    'action-button': 15
};
const $e72f4cae711c5e5e$export$d93583f12bb7f663 = {
    'page-name': 20,
    'last-updated': 20,
    'page-description': 40,
    'action-button': 10
};
const $e72f4cae711c5e5e$export$24707863b4005c32 = `A custom page with this name already exists on your site. Try again with a different name.`;
const $e72f4cae711c5e5e$export$7b26638f36689ddd = 100;
const $e72f4cae711c5e5e$export$8dc5686b04c6900a = 256;
const $e72f4cae711c5e5e$export$4b69f23d48ad7a80 = 100;
const $e72f4cae711c5e5e$export$7e882a52c33de54f = `Pages limit of ${$e72f4cae711c5e5e$export$4b69f23d48ad7a80} is exceeded`;
const $e72f4cae711c5e5e$export$806937cd4427be30 = 20;

});

parcelRegister("ahbzr", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("8Q1to")).default);

var $8Q1to = parcelRequire("8Q1to");

});
parcelRegister("8Q1to", function(module, exports) {
$parcel$export(module.exports, "default", () => $553e8def8f88355c$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $fecgs = parcelRequire("fecgs");

var $cdmCs = parcelRequire("cdmCs");
var $553e8def8f88355c$export$2e2bcd8739ae039 = (0, $6umft.default)(null, {
    fetchUser: (0, $fecgs.fetchUserModelAction)
})((0, $cdmCs.default));

});
parcelRegister("cdmCs", function(module, exports) {
$parcel$export(module.exports, "default", () => $644eef3dd5d72b0a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $613oU = parcelRequire("613oU");

var $iXbJT = parcelRequire("iXbJT");

var $kI3TG = parcelRequire("kI3TG");

var $hM29F = parcelRequire("hM29F");
var $jSL0k = parcelRequire("jSL0k");
parcelRequire("iyjHn");
var $cScvY = parcelRequire("cScvY");

var $5a7Ta = parcelRequire("5a7Ta");
const $644eef3dd5d72b0a$var$HomeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hM29F.JiraServiceManagementIcon), {
        size: "xsmall",
        appearance: "brand"
    });
const $644eef3dd5d72b0a$var$HomeLogo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jSL0k.JiraServiceManagementLogoCS), {
        size: "xsmall",
        appearance: "brand"
    });
const $644eef3dd5d72b0a$var$Home = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kI3TG.default), {
        icon: $644eef3dd5d72b0a$var$HomeIcon,
        logo: $644eef3dd5d72b0a$var$HomeLogo,
        href: `${window.location.origin}/jira/your-work`
    });
const $644eef3dd5d72b0a$var$AppSwitcher = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a7Ta.default), null);
const $644eef3dd5d72b0a$var$Header = ({ fetchUser: fetchUser })=>{
    (0, $fc4bM.useEffect)(()=>{
        fetchUser();
    }, [
        fetchUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iXbJT.AtlassianNavigation), {
        label: "site",
        renderProductHome: $644eef3dd5d72b0a$var$Home,
        renderProfile: (0, $cScvY.default),
        renderAppSwitcher: $644eef3dd5d72b0a$var$AppSwitcher,
        primaryItems: []
    });
};
var $644eef3dd5d72b0a$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'Header'
})($644eef3dd5d72b0a$var$Header);

});
parcelRegister("iXbJT", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigation", () => $109213026845bba0$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $aGcDH = parcelRequire("aGcDH");


var $18HuX = parcelRequire("18HuX");

var $cafSq = parcelRequire("cafSq");
var $2vUvi = parcelRequire("2vUvi");

var $lI5oh = parcelRequire("lI5oh");

var $3jCFs = parcelRequire("3jCFs");
function $109213026845bba0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $109213026845bba0$var$containerStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $18HuX.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $109213026845bba0$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $109213026845bba0$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $109213026845bba0$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $109213026845bba0$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $109213026845bba0$export$f66ccb39f60980e5 = (props)=>{
    typeof $3jCFs;
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $cafSq.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $2vUvi.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $aGcDH.NavigationAnalyticsContext), {
        data: $109213026845bba0$var$analyticsData
    }, /*#__PURE__*/ (0, $jctmk.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $109213026845bba0$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $jctmk.jsx)("nav", {
        css: $109213026845bba0$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $jctmk.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $jctmk.jsx)(ProductHome, null), /*#__PURE__*/ (0, $jctmk.jsx)((0, $lI5oh.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $109213026845bba0$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $jctmk.jsx)(Search, null), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        role: "list",
        css: [
            $109213026845bba0$var$rightStyles,
            $109213026845bba0$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $jctmk.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $jctmk.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $jctmk.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $jctmk.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $jctmk.jsx)(Profile, null))))));
};

});
parcelRegister("18HuX", function(module, exports) {
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $445316dc76ab8844$export$30fa7cc5f2690a43);
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", () => $445316dc76ab8844$export$4033a111ca79977d);
/**
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $445316dc76ab8844$export$30fa7cc5f2690a43 = 56;
const $445316dc76ab8844$export$4033a111ca79977d = 1280;
const $445316dc76ab8844$export$24ec62cee78b7042 = 1130;
const $445316dc76ab8844$export$d8bde68ac946124f = '--ds--ans--fbc';
const $445316dc76ab8844$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $445316dc76ab8844$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $445316dc76ab8844$export$d81606c1fc5119bc = '--ds--ans--c';
const $445316dc76ab8844$export$65f656ad520ea71 = '--ds--ans--bc';

});

parcelRegister("2vUvi", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $dcb7f1388b3d5751$export$d8964aec282183a3);

var $bWIV7 = parcelRequire("bWIV7");
const $dcb7f1388b3d5751$export$d8964aec282183a3 = (0, $bWIV7.ThemeContext).Provider;

});

parcelRegister("lI5oh", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainer", () => $1d8d848a7d9e92ae$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $4EPUx = parcelRequire("4EPUx");

var $4gVCP = parcelRequire("4gVCP");

var $a3xMO = parcelRequire("a3xMO");

var $cmTaK = parcelRequire("cmTaK");

var $3AHTD = parcelRequire("3AHTD");
function $1d8d848a7d9e92ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1d8d848a7d9e92ae$var$containerStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // Guard excludes top-layer popover siblings (eg the overflow menu / tooltip); :where() keeps specificity.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > *:not(:where([popover], dialog))': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $1d8d848a7d9e92ae$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $1d8d848a7d9e92ae$var$overflowItemsStyles = {
    name: "4ekwwx",
    styles: "color:var(--ds-text, #292A2E)"
};
const $1d8d848a7d9e92ae$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $fc4bM.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cmTaK.useOverflowController)(items);
    const onMoreClick = (0, $fc4bM.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $fc4bM.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $fc4bM.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $fc4bM.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $3AHTD.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $fc4bM.useCallback)(()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $a3xMO.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: $1d8d848a7d9e92ae$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $1d8d848a7d9e92ae$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $a3xMO.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $jctmk.jsx)((0, $4EPUx.Popup), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $jctmk.jsx)(Create, null), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $1d8d848a7d9e92ae$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4gVCP.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("a3xMO", function(module, exports) {
$parcel$export(module.exports, "OverflowProvider", () => $dedf103042e87e41$export$a3a2def3937905a0);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $68iEy = parcelRequire("68iEy");
const $dedf103042e87e41$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const value = (0, $fc4bM.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $68iEy.OverflowContext).Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("68iEy", function(module, exports) {
$parcel$export(module.exports, "OverflowContext", () => $55a1bc017f5968b5$export$79f16dd643143c25);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");
const $55a1bc017f5968b5$export$79f16dd643143c25 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $9JZL9.default),
    closeOverflowMenu: (0, $9JZL9.default)
});

});


parcelRegister("cmTaK", function(module, exports) {
$parcel$export(module.exports, "useOverflowController", () => $8556a0ba6736cb84$export$705aa66a39c35bf7);

var $fc4bM = parcelRequire("fc4bM");

var $030TE = parcelRequire("030TE");
const $8556a0ba6736cb84$var$THROTTLE_INTERVAL = 64;
const $8556a0ba6736cb84$var$ITEM_APPROX_MINWIDTH = 70;
const $8556a0ba6736cb84$var$calculateHash = (w, n)=>w + '#' + n;
const $8556a0ba6736cb84$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $8556a0ba6736cb84$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(nodes);
    const [width, setWidth] = (0, $fc4bM.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $fc4bM.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $fc4bM.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $fc4bM.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $fc4bM.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $fc4bM.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($030TE)))(setWidth, $8556a0ba6736cb84$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $8556a0ba6736cb84$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $8556a0ba6736cb84$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $8556a0ba6736cb84$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $8556a0ba6736cb84$var$ITEM_APPROX_MINWIDTH * 2), $8556a0ba6736cb84$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $8556a0ba6736cb84$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $8556a0ba6736cb84$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $8556a0ba6736cb84$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $8556a0ba6736cb84$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $8556a0ba6736cb84$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $8556a0ba6736cb84$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        return;
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};

});
parcelRegister("030TE", function(module, exports) {

var $53bjB = parcelRequire("53bjB");

var $e3M82 = parcelRequire("e3M82");
/** Error message constants. */ var $0090f9f9f4ef97b5$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $0090f9f9f4ef97b5$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($0090f9f9f4ef97b5$var$FUNC_ERROR_TEXT);
    if ($e3M82(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $53bjB(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $0090f9f9f4ef97b5$var$throttle;

});


parcelRegister("3AHTD", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", () => $fcadf414bf22d3f7$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $13zmE = parcelRequire("13zmE");

var $iNvz5 = parcelRequire("iNvz5");
function $fcadf414bf22d3f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fcadf414bf22d3f7$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $fcadf414bf22d3f7$export$bb3af89fb196520d = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $iNvz5.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        css: [
            $fcadf414bf22d3f7$var$buttonNoOpStyle
        ],
        ...rest
    });
});

});
parcelRegister("iNvz5", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $d82a31eebd75ee11$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $k7lry = parcelRequire("k7lry");

var $bcTS3 = parcelRequire("bcTS3");

var $2vZS1 = parcelRequire("2vZS1");

var $9e7Ta = parcelRequire("9e7Ta");
function $d82a31eebd75ee11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d82a31eebd75ee11$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $d82a31eebd75ee11$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $d82a31eebd75ee11$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $d82a31eebd75ee11$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $d82a31eebd75ee11$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$d82a31eebd75ee11$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$d82a31eebd75ee11$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $d82a31eebd75ee11$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $2vZS1.useTheme)();
    const button = /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        style: {
            [$d82a31eebd75ee11$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$d82a31eebd75ee11$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $d82a31eebd75ee11$var$buttonBaseStyles,
            isHighlighted && $d82a31eebd75ee11$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $k7lry.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $9e7Ta.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $d82a31eebd75ee11$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("9e7Ta", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $65b6c85514fca4d3$export$14dd6915caf431fe);
const $65b6c85514fca4d3$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("kI3TG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eb1d7d66f99155e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $18HuX = parcelRequire("18HuX");

var $2vZS1 = parcelRequire("2vZS1");

var $aKJCT = parcelRequire("aKJCT");

var $lXAnV = parcelRequire("lXAnV");

function $1eb1d7d66f99155e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1eb1d7d66f99155e$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $1eb1d7d66f99155e$var$productHomeButtonStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $18HuX.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $18HuX.PRODUCT_HOME_BREAKPOINT}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $1eb1d7d66f99155e$var$productLogoStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$1eb1d7d66f99155e$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$1eb1d7d66f99155e$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $18HuX.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $1eb1d7d66f99155e$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $1eb1d7d66f99155e$var$productIconStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $18HuX.PRODUCT_HOME_BREAKPOINT}px)`]: {
        display: 'none'
    }
});
const $1eb1d7d66f99155e$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 *
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $1eb1d7d66f99155e$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $2vZS1.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    let { iconColor: iconColor, textColor: textColor } = theme.mode.productHome;
    // If the theme returns the default Atlassian theme, rely on the Logo default behaviour instead
    if (iconColor === '#357DE8' && textColor === "var(--ds-text, #292A2E)") {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $lXAnV.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $aKJCT.stripEmptyProperties)({
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$1eb1d7d66f99155e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$1eb1d7d66f99155e$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $1eb1d7d66f99155e$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            $1eb1d7d66f99155e$var$customMaxHeightStyles,
            $1eb1d7d66f99155e$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $jctmk.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-expect-error -- The new logo component does not declare the legacy appearance prop.
        appearance: iconColor || textColor ? undefined : 'brand'
    })), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            $1eb1d7d66f99155e$var$customMaxHeightStyles,
            $1eb1d7d66f99155e$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $jctmk.jsx)(Icon, {
        iconColor: iconColor,
        size: 'small',
        // @ts-expect-error -- The new icon component does not declare the legacy appearance prop.
        appearance: iconColor || textColor ? undefined : 'brand'
    }))), siteTitle && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $1eb1d7d66f99155e$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $1eb1d7d66f99155e$export$2e2bcd8739ae039 = $1eb1d7d66f99155e$var$ProductHome;

});
parcelRegister("aKJCT", function(module, exports) {
$parcel$export(module.exports, "stripEmptyProperties", () => $22b07025dac98abb$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $22b07025dac98abb$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});

parcelRegister("lXAnV", function(module, exports) {
$parcel$export(module.exports, "getTag", () => $a700becf3302d3f0$export$dad497fe1f6e27c0);
const $a700becf3302d3f0$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("hM29F", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $5c2446c9e315cf5e$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::018e1283e27acb8e799a70f211bb080a>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $b3n1a = parcelRequire("b3n1a");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $5c2446c9e315cf5e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $5c2446c9e315cf5e$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $5c2446c9e315cf5e$export$3c6158790f5e01c4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b3n1a.IconWrapper), {
        svg: $5c2446c9e315cf5e$var$svg,
        customThemeSvg: $5c2446c9e315cf5e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jSL0k", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $a83b8e321da9d075$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::510112a7c331386966b3b832ba6806dc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5U7eF = parcelRequire("5U7eF");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a83b8e321da9d075$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $a83b8e321da9d075$export$de148263c75d2bc1({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5U7eF.LogoWrapper), {
        svg: $a83b8e321da9d075$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("5U7eF", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $2c9c883766c1c1cc$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $anluN = parcelRequire("anluN");
const $2c9c883766c1c1cc$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $2c9c883766c1c1cc$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $2c9c883766c1c1cc$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $2c9c883766c1c1cc$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $2c9c883766c1c1cc$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $2c9c883766c1c1cc$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $2c9c883766c1c1cc$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $2c9c883766c1c1cc$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $2c9c883766c1c1cc$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $2c9c883766c1c1cc$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $2c9c883766c1c1cc$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $2c9c883766c1c1cc$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $2R2iS.default)([
            $2c9c883766c1c1cc$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $2c9c883766c1c1cc$var$logoTextColorMap[colorMode ?? 'light'],
            $2c9c883766c1c1cc$var$sizeMap[size],
            colorMode === 'dark' ? $2c9c883766c1c1cc$var$textDarkAppearanceMap[appearance] : $2c9c883766c1c1cc$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $2c9c883766c1c1cc$var$dataCenterDarkAppearanceMap[appearance] : $2c9c883766c1c1cc$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $2c9c883766c1c1cc$var$rovoDarkAppearanceMap[appearance] : $2c9c883766c1c1cc$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $2c9c883766c1c1cc$var$cloudDarkAppearanceMap[appearance] : $2c9c883766c1c1cc$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $dRkX9.fg)('assets-platform-branding') || (0, $dRkX9.fg)('assets-platform-branding-v2')) && $2c9c883766c1c1cc$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("5a7Ta", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e1fca40dccfd401$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $iEAag = parcelRequire("iEAag");

var $4EPUx = parcelRequire("4EPUx");

var $q6fmJ = parcelRequire("q6fmJ");

var $hhh9w = parcelRequire("hhh9w");
const $7e1fca40dccfd401$var$APP_SWITCHER_PRODUCT = 'jiraServiceManagement';
const $7e1fca40dccfd401$var$AppSwitcherComponent = ()=>{
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    const cloudId = (0, $6LH8a.getCloudId)();
    const onClick = ()=>{
        setIsOpen(!isOpen);
    };
    const onClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $q6fmJ.AtlassianSwitcherLoader), {
                product: $7e1fca40dccfd401$var$APP_SWITCHER_PRODUCT,
                cloudId: cloudId
            }),
        isOpen: isOpen,
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hhh9w.default), {
                cloudId: cloudId,
                product: $7e1fca40dccfd401$var$APP_SWITCHER_PRODUCT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iEAag.AppSwitcher), {
                onClick: onClick,
                tooltip: "Switch to...",
                ...triggerProps
            }))
    });
};
var $7e1fca40dccfd401$export$2e2bcd8739ae039 = $7e1fca40dccfd401$var$AppSwitcherComponent;

});
parcelRegister("iEAag", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $0be1402086ee14d1$export$9923361bd43fa030);
/* app-switcher.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $1bEFS = parcelRequire("1bEFS");

var $26fPW = parcelRequire("26fPW");

var $lWnWg = parcelRequire("lWnWg");
const $0be1402086ee14d1$var$iconSpacingStyles = {
    space050: "_1rjc1b66 _18zr1b66"
};
const $0be1402086ee14d1$export$9923361bd43fa030 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lWnWg.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
            xcss: $0be1402086ee14d1$var$iconSpacingStyles.space050,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bEFS))), {
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
            })
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});

});
parcelRegister("1bEFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::891f8b0b0e6811694a02696ff381b7b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0dd65e9dcb0d6119$var$_react = $0dd65e9dcb0d6119$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $0dd65e9dcb0d6119$var$_iconNew = $0dd65e9dcb0d6119$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $0dd65e9dcb0d6119$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app-switcher
 * Usage guidance:
 * Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dd65e9dcb0d6119$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $0dd65e9dcb0d6119$var$_react.default.createElement($0dd65e9dcb0d6119$var$_iconNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$0dd65e9dcb0d6119$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $0dd65e9dcb0d6119$var$_default = module.exports.default = $0dd65e9dcb0d6119$var$AppSwitcherIcon;

});


parcelRegister("q6fmJ", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $9a40b131764d0678$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadGenericSwitcher", () => $9a40b131764d0678$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $9a40b131764d0678$export$25f16f9fee84a840);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $9a40b131764d0678$export$8c21d1a0c59fc17e);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $dRkX9 = parcelRequire("dRkX9");

var $8uo4C = parcelRequire("8uo4C");

const $9a40b131764d0678$export$6c6894dd831bfacb = ()=>(parcelRequire("9ydnK")).then((module)=>module.default);

const $9a40b131764d0678$export$64191a36345a6b2b = ()=>(parcelRequire("1huzP")).then((module)=>module.default);

const $9a40b131764d0678$var$AtlassianSwitcherLoaderLazyComponent = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("9ydnK")));
Object.assign($9a40b131764d0678$var$AtlassianSwitcherLoaderLazyComponent, {
    displayName: 'lazy(AtlassianSwitcherLoader)'
});
const $9a40b131764d0678$var$AtlassianSwitcherLoaderLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: $9a40b131764d0678$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uo4C.default), null)
});
function $9a40b131764d0678$var$AtlassianSwitcherLoaderWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uo4C.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a40b131764d0678$var$AtlassianSwitcherLoaderLazyComponent, props));
}
const $9a40b131764d0678$export$25f16f9fee84a840 = (props)=>(0, $dRkX9.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a40b131764d0678$var$AtlassianSwitcherLoaderWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a40b131764d0678$var$AtlassianSwitcherLoaderLoadableComponent, props);

const $9a40b131764d0678$var$GenericSwitcherLoaderLazyComponent = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("1huzP")));
Object.assign($9a40b131764d0678$var$GenericSwitcherLoaderLazyComponent, {
    displayName: 'lazy(GenericSwitcherLoader)'
});
const $9a40b131764d0678$var$GenericSwitcherLoaderLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: $9a40b131764d0678$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uo4C.default), null)
});
function $9a40b131764d0678$var$GenericSwitcherLoaderWithSuspense(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uo4C.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a40b131764d0678$var$GenericSwitcherLoaderLazyComponent, props));
}
const $9a40b131764d0678$export$8c21d1a0c59fc17e = (props)=>(0, $dRkX9.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a40b131764d0678$var$GenericSwitcherLoaderWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($9a40b131764d0678$var$GenericSwitcherLoaderLoadableComponent, props);

});
parcelRegister("8uo4C", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6f14819af4f82c2$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $dBtOK = parcelRequire("dBtOK");

var $iXwVt = parcelRequire("iXwVt");
var $1o5lm = parcelRequire("1o5lm");

var $4JRvS = parcelRequire("4JRvS");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $c6f14819af4f82c2$var$iconSkeleton = /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $c6f14819af4f82c2$var$lineSkeleton = /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $c6f14819af4f82c2$export$2e2bcd8739ae039 = ()=>{
    (0, $1o5lm.useExperienceRenderAndMountMark)((0, $iXwVt.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const items = /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        }
    }, $c6f14819af4f82c2$var$iconSkeleton, $c6f14819af4f82c2$var$lineSkeleton);
    return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        as: "section",
        // No fixed height: the switcher grows to fit its content, so the skeleton
        // fits its own rows and the panel grows into the loaded content, rather
        // than reserving 80vh that the panel would then visibly shrink from.
        style: {
            width: '343px'
        },
        role: "alert",
        "aria-label": formatMessage((0, $4JRvS.default).skeletonLoaderAriaLabel),
        testId: "skeleton"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        "aria-hidden": "true",
        style: {
            paddingInline: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-300, 24px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }
    }, $c6f14819af4f82c2$var$lineSkeleton), items, items, items);
};

});
parcelRegister("iXwVt", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $2c94d117d3993436$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $2c94d117d3993436$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $2c94d117d3993436$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $2c94d117d3993436$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $2c94d117d3993436$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $2c94d117d3993436$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $2c94d117d3993436$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $2c94d117d3993436$export$86919b84f9a64054);

var $atXmE = parcelRequire("atXmE");

var $dXrHg = parcelRequire("dXrHg");
var $2c94d117d3993436$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $2c94d117d3993436$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $atXmE.ExperienceTypes).Load,
        performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $atXmE.ExperienceTypes).Load,
        performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $atXmE.ExperienceTypes).Load,
        performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $atXmE.ExperienceTypes).Load,
        performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $2c94d117d3993436$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $2c94d117d3993436$var$allNonTestExperienceMarks = Object.values($2c94d117d3993436$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $2c94d117d3993436$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $2c94d117d3993436$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $2c94d117d3993436$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $2c94d117d3993436$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $2c94d117d3993436$var$allNonTestExperienceMarks
};
const $2c94d117d3993436$export$805ed806e0769ee4 = (0, $dXrHg.invertRecordOfArrays)($2c94d117d3993436$export$755e75afbd377bc4);
var $2c94d117d3993436$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $2c94d117d3993436$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $2c94d117d3993436$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("dXrHg", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $0c92e5e57fc2adf1$export$c371a74fe5222b3);
function $0c92e5e57fc2adf1$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("1o5lm", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $e96aaea49df01ca6$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $e96aaea49df01ca6$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $fc4bM = parcelRequire("fc4bM");

var $jFOcR = parcelRequire("jFOcR");

var $4vac1 = parcelRequire("4vac1");
function $e96aaea49df01ca6$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $4vac1.useExperienceTracker)();
    (0, $jFOcR.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $e96aaea49df01ca6$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $4vac1.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fc4bM.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $e96aaea49df01ca6$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $4vac1.useExperienceTracker)();
    (0, $jFOcR.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fc4bM.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("jFOcR", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $12b6eb892c108fab$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $12b6eb892c108fab$export$ad4f8d0eee7a0e24);

var $fc4bM = parcelRequire("fc4bM");
function $12b6eb892c108fab$export$abf4268d2dd55708(builder) {
    const ref = (0, $fc4bM.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $12b6eb892c108fab$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $fc4bM.useRef)(false);
    const result = (0, $fc4bM.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});

parcelRegister("4vac1", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $bfd50f1b2b197b1a$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $bfd50f1b2b197b1a$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $bfd50f1b2b197b1a$export$f88dde183f4d31cb);

var $fc4bM = parcelRequire("fc4bM");
const $bfd50f1b2b197b1a$var$noop = ()=>{};
const $bfd50f1b2b197b1a$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $fc4bM.createContext)({
    start: $bfd50f1b2b197b1a$var$noop,
    success: $bfd50f1b2b197b1a$var$noop,
    failure: $bfd50f1b2b197b1a$var$noop,
    failureAll: $bfd50f1b2b197b1a$var$noop,
    abort: $bfd50f1b2b197b1a$var$noop,
    abortAll: $bfd50f1b2b197b1a$var$noop,
    markStart: $bfd50f1b2b197b1a$var$noop,
    markEnd: $bfd50f1b2b197b1a$var$noop
});
const $bfd50f1b2b197b1a$export$cdefb2a8b53f879f = ()=>(0, $fc4bM.useContext)($bfd50f1b2b197b1a$export$3f3eebb4b8116461);
const $bfd50f1b2b197b1a$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $bfd50f1b2b197b1a$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("4JRvS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d5018c8940b7255$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $5d5018c8940b7255$var$messages = (0, $8p5Cv.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    },
    showMoreSites: {
        id: 'fabric.atlassianSwitcher.showMoreSites',
        defaultMessage: 'Show more',
        description: 'The text of a button that reveals the remaining sites in an expanded switcher item site list'
    },
    showLessSites: {
        id: 'fabric.atlassianSwitcher.showLessSites',
        defaultMessage: 'Show less',
        description: 'The text of a button that collapses the expanded list of sites back to the first few in a switcher item'
    },
    unitDescriptionInfoButton: {
        id: 'fabric.atlassianSwitcher.unitDescriptionInfoButton',
        defaultMessage: 'About {unitName}',
        description: 'The accessible label of an info icon button that reveals a short administrator-written description of the named organisation unit'
    },
    pinOrgOrUnit: {
        id: 'fabric.atlassianSwitcher.pinOrgOrUnit',
        defaultMessage: 'Pin {name}',
        description: 'Accessible label and tooltip for the button that pins an organisation or unit to the top of the app switcher org list. {name} is the organisation or unit name.'
    },
    unpinOrgOrUnit: {
        id: 'fabric.atlassianSwitcher.unpinOrgOrUnit',
        defaultMessage: 'Unpin {name}',
        description: 'Accessible label and tooltip for the button that removes an organisation or unit from the pinned list in the app switcher. {name} is the organisation or unit name.'
    }
});
var $5d5018c8940b7255$export$2e2bcd8739ae039 = $5d5018c8940b7255$var$messages;

});


parcelRegister("9ydnK", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("7K4EA"),
    $9dnsd("gNUTT")
]).then(()=>parcelRequire('6sTMa'));

});

parcelRegister("1huzP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("7K4EA"),
    $9dnsd("3KK3D"),
    $9dnsd("hCVB4"),
    $9dnsd("dBsNp"),
    $9dnsd("chKIr"),
    $9dnsd("7QAkm"),
    $9dnsd("5sb3y"),
    $9dnsd("kaxju"),
    $9dnsd("6Df0C"),
    $9dnsd("8QhuV"),
    $9dnsd("c9nTK")
]).then(()=>parcelRequire('lw1Me'));

});


parcelRegister("hhh9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d87606e5b317790$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $030TE = parcelRequire("030TE");

var $foX5u = parcelRequire("foX5u");
var $aGcDH = parcelRequire("aGcDH");
var $aDo1D = parcelRequire("aDo1D");
var $azARG = parcelRequire("azARG");

var $gym2k = parcelRequire("gym2k");

var $gSmWK = parcelRequire("gSmWK");

var $73I4o = parcelRequire("73I4o");
const $0d87606e5b317790$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $0d87606e5b317790$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $0d87606e5b317790$var$TRIGGER_CONTEXT = {
    componentName: (0, $foX5u.TRIGGER_COMPONENT),
    ...(0, $gym2k.default)
};
class $0d87606e5b317790$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $aDo1D.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $foX5u.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $foX5u.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($030TE)))(()=>{
            (0, $73I4o.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $0d87606e5b317790$var$THROTTLE_EXPIRES, $0d87606e5b317790$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $gSmWK.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $gSmWK.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $0d87606e5b317790$var$PrefetchTriggerWithEvents = (0, $azARG.default)()($0d87606e5b317790$var$PrefetchTrigger);
var $0d87606e5b317790$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aGcDH.NavigationAnalyticsContext), {
        data: $0d87606e5b317790$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($0d87606e5b317790$var$PrefetchTriggerWithEvents, props));

});
parcelRegister("foX5u", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $bc9f6528ed3b1330$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $bc9f6528ed3b1330$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $bc9f6528ed3b1330$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $bc9f6528ed3b1330$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $bc9f6528ed3b1330$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $bc9f6528ed3b1330$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $bc9f6528ed3b1330$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $bc9f6528ed3b1330$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $bc9f6528ed3b1330$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $bc9f6528ed3b1330$export$22f5f827d9934254);
$parcel$export(module.exports, "analyticsAttributes", () => $bc9f6528ed3b1330$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $bc9f6528ed3b1330$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $bc9f6528ed3b1330$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $bc9f6528ed3b1330$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $bc9f6528ed3b1330$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $bc9f6528ed3b1330$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $bc9f6528ed3b1330$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("azARG")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("aGcDH")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("aDo1D")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("aDo1D")).UI_EVENT_TYPE);

var $fc4bM = parcelRequire("fc4bM");

var $aDo1D = parcelRequire("aDo1D");

var $aGcDH = parcelRequire("aGcDH");

var $8lxUN = parcelRequire("8lxUN");

var $azARG = parcelRequire("azARG");

var $dNcG1 = parcelRequire("dNcG1");

var $ckN3S = parcelRequire("ckN3S");

var $fdp6J = parcelRequire("fdp6J");
const $bc9f6528ed3b1330$export$515664faa1398f37 = 'navigation';
const $bc9f6528ed3b1330$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $bc9f6528ed3b1330$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $bc9f6528ed3b1330$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $bc9f6528ed3b1330$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $bc9f6528ed3b1330$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $bc9f6528ed3b1330$export$2b570fc112cbca = 'atlassianSwitcher';
const $bc9f6528ed3b1330$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $bc9f6528ed3b1330$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $bc9f6528ed3b1330$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $bc9f6528ed3b1330$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $bc9f6528ed3b1330$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $bc9f6528ed3b1330$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $bc9f6528ed3b1330$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $bc9f6528ed3b1330$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $bc9f6528ed3b1330$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $bc9f6528ed3b1330$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $bc9f6528ed3b1330$var$RENDERED_ACTION = 'rendered';
const $bc9f6528ed3b1330$var$NOT_RENDERED_ACTION = 'not_rendered';
const $bc9f6528ed3b1330$var$VIEWED_ACTION = 'viewed';
const $bc9f6528ed3b1330$export$884b1a4c7ac9dd14 = (0, $8lxUN.default)($bc9f6528ed3b1330$export$515664faa1398f37);
const $bc9f6528ed3b1330$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $bc9f6528ed3b1330$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aGcDH.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, props));
    };
};
const $bc9f6528ed3b1330$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $bc9f6528ed3b1330$export$e09ad93c2b74b853 = (0, $azARG.default)({
    onRender: (createAnalyticsEvent, props)=>{
        var _props$data;
        const duration = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.duration;
        return createAnalyticsEvent({
            eventType: (0, $aDo1D.OPERATIONAL_EVENT_TYPE),
            action: $bc9f6528ed3b1330$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$bc9f6528ed3b1330$var$isValidDuration(duration) && {
                    bucket: (0, $fdp6J.getMetricBucket)(duration, (0, $fdp6J.RenderTrackerBuckets))
                }
            }
        }).fire($bc9f6528ed3b1330$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $bc9f6528ed3b1330$export$95b1f1a72cad0dcb = (0, $azARG.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $aDo1D.OPERATIONAL_EVENT_TYPE),
            action: $bc9f6528ed3b1330$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($bc9f6528ed3b1330$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $bc9f6528ed3b1330$export$b3fd6624b6a6d057 = (0, $azARG.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $aDo1D.UI_EVENT_TYPE),
            action: $bc9f6528ed3b1330$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($bc9f6528ed3b1330$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $bc9f6528ed3b1330$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bc9f6528ed3b1330$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bc9f6528ed3b1330$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $bc9f6528ed3b1330$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bc9f6528ed3b1330$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($bc9f6528ed3b1330$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $bc9f6528ed3b1330$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $dNcG1.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $bc9f6528ed3b1330$var$renderTracker({
        subject: $bc9f6528ed3b1330$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $bc9f6528ed3b1330$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if ((customLinksProviderResult === null || customLinksProviderResult === void 0 ? void 0 : customLinksProviderResult.status) === (0, $dNcG1.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $ckN3S.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $bc9f6528ed3b1330$var$renderTrackerWithReason({
        subject: $bc9f6528ed3b1330$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $bc9f6528ed3b1330$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$bc9f6528ed3b1330$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("dNcG1", function(module, exports) {
$parcel$export(module.exports, "Status", () => $14dc0b06c0b6f335$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $14dc0b06c0b6f335$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $14dc0b06c0b6f335$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $14dc0b06c0b6f335$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $14dc0b06c0b6f335$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $14dc0b06c0b6f335$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $azARG = parcelRequire("azARG");

var $foX5u = parcelRequire("foX5u");
var $aDo1D = parcelRequire("aDo1D");

var $7sxes = parcelRequire("7sxes");

var $4vac1 = parcelRequire("4vac1");

var $jBSqJ = parcelRequire("jBSqJ");
const $14dc0b06c0b6f335$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $14dc0b06c0b6f335$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $14dc0b06c0b6f335$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $14dc0b06c0b6f335$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $14dc0b06c0b6f335$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $14dc0b06c0b6f335$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $14dc0b06c0b6f335$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $14dc0b06c0b6f335$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
        static #_ = this.displayName = `DataProvider(${name})`;
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $jBSqJ.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
                shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $7sxes.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$14dc0b06c0b6f335$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $7sxes.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $aDo1D.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $14dc0b06c0b6f335$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $foX5u.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $azARG.default)()((0, $4vac1.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}

});
parcelRegister("7sxes", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $e6e0279fe70b48b6$export$a3e288208721751b);
function $e6e0279fe70b48b6$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("jBSqJ", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $0ee0d6b343bf3ca6$export$1d94629c94e7a17f);
const $0ee0d6b343bf3ca6$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $0ee0d6b343bf3ca6$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $0ee0d6b343bf3ca6$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});


parcelRegister("ckN3S", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $094061127cf2165a$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $094061127cf2165a$export$c460344055e97b1);
var $094061127cf2165a$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $094061127cf2165a$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("fdp6J", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $9501afdd21dfaeac$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $9501afdd21dfaeac$export$b59492d26971ae92);
const $9501afdd21dfaeac$var$INFINITY = '+Inf';
const $9501afdd21dfaeac$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $9501afdd21dfaeac$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $9501afdd21dfaeac$var$INFINITY) : null;
};

});


parcelRegister("gym2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2b88de4c068502b$export$2e2bcd8739ae039);
const $d2b88de4c068502b$var$packageName = undefined;
const $d2b88de4c068502b$var$packageVersion = undefined;
const $d2b88de4c068502b$var$_default_1 = {
    packageName: $d2b88de4c068502b$var$packageName,
    packageVersion: $d2b88de4c068502b$var$packageVersion
};
var $d2b88de4c068502b$export$2e2bcd8739ae039 = $d2b88de4c068502b$var$_default_1;

});

parcelRegister("gSmWK", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $2378de5b59485128$export$fb4230f160368c88);
const $2378de5b59485128$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});

parcelRegister("73I4o", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $c932bd02e1ba3a42$export$aba5d6cf034db22e);

var $6gpuZ = parcelRequire("6gpuZ");

var $gazuc = parcelRequire("gazuc");

var $huICS = parcelRequire("huICS");

var $hy2Aq = parcelRequire("hy2Aq");

var $ePih1 = parcelRequire("ePih1");
const $c932bd02e1ba3a42$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $hy2Aq.default)();
    (0, $6gpuZ.prefetchFlightDeck)({});
    (0, $gazuc.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $huICS.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $ePih1.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("6gpuZ", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $4610abe87ad35762$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $4610abe87ad35762$export$7d2a567d3e50224);

var $fc4bM = parcelRequire("fc4bM");

var $6gUvB = parcelRequire("6gUvB");

var $7rEw1 = parcelRequire("7rEw1");

var $7lyWC = parcelRequire("7lyWC");

var $iXwVt = parcelRequire("iXwVt");

var $2ru0b = parcelRequire("2ru0b");

var $kylyn = parcelRequire("kylyn");

var $8TANM = parcelRequire("8TANM");
const $4610abe87ad35762$var$client = new (0, $6gUvB.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $4610abe87ad35762$var$fetchFlightDeck, ProviderComponent: $4610abe87ad35762$var$DefaultFlightDeckProviderComponent } = (0, $kylyn.createProviderWithCustomFetchData)('flightDeck', (0, $iXwVt.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $4610abe87ad35762$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $7rEw1.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $4610abe87ad35762$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $4610abe87ad35762$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $8TANM.formatLabel)(displayName),
            description: (0, $8TANM.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $7lyWC.ASSETS_APP_KEY))) artifactMap.set((0, $7lyWC.ASSETS_APP_KEY), {
            key: (0, $7lyWC.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            // make sure assets is below jsm
            label: (0, $8TANM.formatLabel)((0, $2ru0b.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $8TANM.formatLabel)(link.displayName),
                    description: (0, $8TANM.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $4610abe87ad35762$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($4610abe87ad35762$var$DefaultFlightDeckProviderComponent, null, children);
const $4610abe87ad35762$export$7d2a567d3e50224 = $4610abe87ad35762$var$fetchFlightDeck;

});
parcelRegister("6gUvB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4910122884d6abe0$export$2e2bcd8739ae039);

var $bD5s2 = parcelRequire("bD5s2");

var $j8yLU = parcelRequire("j8yLU");
parcelRequire("bhV4A");
var $6EzEO = parcelRequire("6EzEO");

var $hMY0t = parcelRequire("hMY0t");
var $e6fVj = parcelRequire("e6fVj");

var $hgW7l = parcelRequire("hgW7l");

var $04rqQ = parcelRequire("04rqQ");

var $7jxJF = parcelRequire("7jxJF");
function $4910122884d6abe0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4910122884d6abe0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4910122884d6abe0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bD5s2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4910122884d6abe0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4910122884d6abe0$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $4910122884d6abe0$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $4910122884d6abe0$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $bD5s2.default)(this, "fallbackArtifactMap", new Map());
        (0, $bD5s2.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $6EzEO.StorageClient)($4910122884d6abe0$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $04rqQ.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $j8yLU.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $hMY0t.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $hgW7l.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$4910122884d6abe0$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $7jxJF.flightDeckClientExperience)() : new (0, $e6fVj.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $4910122884d6abe0$var$_objectSpread($4910122884d6abe0$var$_objectSpread({}, artifact), {}, {
                key: (0, $04rqQ.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $7jxJF.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("j8yLU", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $59318670d860c15a$export$1d94629c94e7a17f);

var $eTcnm = parcelRequire("eTcnm");

var $c81zz = parcelRequire("c81zz");

var $7G3lL = parcelRequire("7G3lL");

var $1CuPQ = parcelRequire("1CuPQ");
const $59318670d860c15a$var$NO_CALLS_ERROR = 'No calls made';
const $59318670d860c15a$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $c81zz.NO_RETRIES), retryOn: retryOn = [
    (0, $7G3lL.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($59318670d860c15a$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await (0, $1CuPQ.wait)(nextMSInterval);
        if (onRetry && error.message !== $59318670d860c15a$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $eTcnm.convertToError)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("eTcnm", function(module, exports) {
$parcel$export(module.exports, "convertToError", () => $eb0a55e20b5db3a3$export$70fb45ead8febbe5);
const $eb0a55e20b5db3a3$export$70fb45ead8febbe5 = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};

});

parcelRegister("c81zz", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $842355bc7ba1392f$export$a0a1c8f90becc136);
const $842355bc7ba1392f$export$a0a1c8f90becc136 = [];
const $842355bc7ba1392f$export$972171517b12aa4 = [
    0,
    0
];
const $842355bc7ba1392f$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $842355bc7ba1392f$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("7G3lL", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => $42bfa2810129eaba$export$558a29265b4c0def);
$parcel$export(module.exports, "default", () => $42bfa2810129eaba$export$2e2bcd8739ae039);
class $42bfa2810129eaba$export$558a29265b4c0def extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
var $42bfa2810129eaba$export$2e2bcd8739ae039 = $42bfa2810129eaba$export$558a29265b4c0def;

});

parcelRegister("1CuPQ", function(module, exports) {
$parcel$export(module.exports, "wait", () => $de6db09cd5e6cbdf$export$5c069c93d2b7493f);
const $de6db09cd5e6cbdf$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });

});


parcelRegister("hMY0t", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $cf3577727e9ea857$export$6026918e023c9101);

var $eFzfb = parcelRequire("eFzfb");

var $jVnVV = parcelRequire("jVnVV");

var $ea8MY = parcelRequire("ea8MY");

var $lkyxC = parcelRequire("lkyxC");

var $jWi79 = parcelRequire("jWi79");

var $e6fVj = parcelRequire("e6fVj");

var $aW0Oi = parcelRequire("aW0Oi");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $cf3577727e9ea857$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $cf3577727e9ea857$var$defaultPerimeter = "commercial";
async function $cf3577727e9ea857$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $cf3577727e9ea857$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $cf3577727e9ea857$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $cf3577727e9ea857$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $eFzfb.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $cf3577727e9ea857$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $cf3577727e9ea857$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $cf3577727e9ea857$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $cf3577727e9ea857$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $cf3577727e9ea857$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $cf3577727e9ea857$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $e6fVj.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $e6fVj.getVersionMetadataFetchExperience)();
    return new (0, $jWi79.ConfigClient)(new (0, $ea8MY.BifrostDataSource)(new (0, $lkyxC.BifrostHttpClientImpl)(env, perimeter), (0, $jVnVV.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $cf3577727e9ea857$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("eFzfb", function(module, exports) {
$parcel$export(module.exports, "default", () => $31dea9d214c9d4ab$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $31dea9d214c9d4ab$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $31dea9d214c9d4ab$export$2e2bcd8739ae039 = $31dea9d214c9d4ab$export$852ff24d0930c62f;

});

parcelRegister("jVnVV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $2NS8m = parcelRequire("2NS8m");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $2NS8m.Either;
    }
});

var $1XcLp = parcelRequire("1XcLp");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $1XcLp.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $1XcLp.tryGetArtifactData;
    }
});

var $k2bnZ = parcelRequire("k2bnZ");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $k2bnZ.parseArtifactManifest;
    }
});

var $bLCqH = parcelRequire("bLCqH");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $bLCqH.parseVersionMetadata;
    }
});

var $e844U = parcelRequire("e844U");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $e844U.checkManifest;
    }
});

var $lLcIr = parcelRequire("lLcIr");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $lLcIr.ConfigRegistryDataSource;
    }
});

var $3rrx2 = parcelRequire("3rrx2");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3rrx2.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3rrx2.Versions;
    }
});

});
parcelRegister("2NS8m", function(module, exports) {
"use strict";
var $20aa263d05f7d91b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $20aa263d05f7d91b$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $20aa263d05f7d91b$var$Right(value);
    };
    Either.left = function(error) {
        return new $20aa263d05f7d91b$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $20aa263d05f7d91b$var$Either;
var $20aa263d05f7d91b$var$Right = /** @class */ function(_super) {
    $20aa263d05f7d91b$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $20aa263d05f7d91b$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $20aa263d05f7d91b$var$Either.right(this.right);
    };
    return Right;
}($20aa263d05f7d91b$var$Either);
var $20aa263d05f7d91b$var$Left = /** @class */ function(_super) {
    $20aa263d05f7d91b$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $20aa263d05f7d91b$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $20aa263d05f7d91b$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $20aa263d05f7d91b$var$Either.left(f(this.left));
    };
    return Left;
}($20aa263d05f7d91b$var$Either);

});

parcelRegister("1XcLp", function(module, exports) {
"use strict";
var $16c533b9cc52c6f3$var$__assign = module.exports && module.exports.__assign || function() {
    $16c533b9cc52c6f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16c533b9cc52c6f3$var$__assign.apply(this, arguments);
};
var $16c533b9cc52c6f3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $16c533b9cc52c6f3$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $16c533b9cc52c6f3$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $16c533b9cc52c6f3$var$tryGetArtifactData;

var $atZta = parcelRequire("atZta");

var $jVnVV = parcelRequire("jVnVV");

var $fYHJK = parcelRequire("fYHJK");

var $2z2wB = parcelRequire("2z2wB");

var $iTs1L = parcelRequire("iTs1L");
function $16c533b9cc52c6f3$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $16c533b9cc52c6f3$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $16c533b9cc52c6f3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $16c533b9cc52c6f3$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $16c533b9cc52c6f3$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $jVnVV.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $fYHJK.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $16c533b9cc52c6f3$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $2z2wB.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $16c533b9cc52c6f3$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $16c533b9cc52c6f3$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $16c533b9cc52c6f3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $atZta.interpolateTagScheme)(manifest.tagScheme, $16c533b9cc52c6f3$var$__assign($16c533b9cc52c6f3$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $16c533b9cc52c6f3$var$__awaiter(_this, void 0, void 0, function() {
                                return $16c533b9cc52c6f3$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $16c533b9cc52c6f3$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $iTs1L.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $iTs1L.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $2z2wB.assertUnreachable)(artifact);
    }
}

});
parcelRegister("atZta", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $7a1c4b5d22e61d9e$var$interpolateTagScheme;
module.exports.generateTagScheme = $7a1c4b5d22e61d9e$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $7a1c4b5d22e61d9e$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $7a1c4b5d22e61d9e$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $7a1c4b5d22e61d9e$var$getVersionMetadataTag;
const $7a1c4b5d22e61d9e$var$TAG_SCHEME_VERSION = 2;
function $7a1c4b5d22e61d9e$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($7a1c4b5d22e61d9e$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $7a1c4b5d22e61d9e$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $7a1c4b5d22e61d9e$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $7a1c4b5d22e61d9e$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $7a1c4b5d22e61d9e$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $7a1c4b5d22e61d9e$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $7a1c4b5d22e61d9e$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $7a1c4b5d22e61d9e$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("fYHJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $03007d772b2b06b0$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $03007d772b2b06b0$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("2z2wB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $1de0cf05c93f9dd2$var$assertUnreachable;
function $1de0cf05c93f9dd2$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("iTs1L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $dc131ab1a8a1fb25$var$toJson;
module.exports.toPrettyJson = $dc131ab1a8a1fb25$var$toPrettyJson;
function $dc131ab1a8a1fb25$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $dc131ab1a8a1fb25$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("k2bnZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $e95cd389e8a4fd32$var$parseArtifactManifest;

var $de62h = parcelRequire("de62h");
function $e95cd389e8a4fd32$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $de62h.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $de62h.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $e95cd389e8a4fd32$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $de62h.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $e95cd389e8a4fd32$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $e95cd389e8a4fd32$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $de62h.parseUnknownObject)(dimensions);
    var supported = (0, $de62h.parseArray)(unparsedDimensions.supported).map($de62h.parseString);
    var fallback = (0, $de62h.parseUndefinedOr)($de62h.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $e95cd389e8a4fd32$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $de62h.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $e95cd389e8a4fd32$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $e95cd389e8a4fd32$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $de62h.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $de62h.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $de62h.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $de62h.parseUndefinedOr)($de62h.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $e95cd389e8a4fd32$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $e95cd389e8a4fd32$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("de62h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $9a1143be49a36748$var$parseString;
module.exports.parseArray = $9a1143be49a36748$var$parseArray;
module.exports.parseBoolean = $9a1143be49a36748$var$parseBoolean;
module.exports.parseUnknownObject = $9a1143be49a36748$var$parseUnknownObject;
module.exports.parseUndefinedOr = $9a1143be49a36748$var$parseUndefinedOr;
function $9a1143be49a36748$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $9a1143be49a36748$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $9a1143be49a36748$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $9a1143be49a36748$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $9a1143be49a36748$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("bLCqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $8911e4cfbad21181$var$parseVersionMetadata;

var $de62h = parcelRequire("de62h");
function $8911e4cfbad21181$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $de62h.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $de62h.parseString)(unknownObject.version);
    var publishTime = new Date((0, $de62h.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $de62h.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("e844U", function(module, exports) {
"use strict";
var $a494f9e4d97a2a27$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $a494f9e4d97a2a27$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $a494f9e4d97a2a27$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $a494f9e4d97a2a27$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("lLcIr", function(module, exports) {
"use strict";
var $fd77d9d94b7b4e66$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fd77d9d94b7b4e66$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $atZta = parcelRequire("atZta");

var $2NS8m = parcelRequire("2NS8m");

var $k2bnZ = parcelRequire("k2bnZ");

var $bLCqH = parcelRequire("bLCqH");
var $fd77d9d94b7b4e66$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $fd77d9d94b7b4e66$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $fd77d9d94b7b4e66$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $atZta.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($k2bnZ.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2NS8m.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $fd77d9d94b7b4e66$var$__awaiter(this, void 0, void 0, function() {
            return $fd77d9d94b7b4e66$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $fd77d9d94b7b4e66$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $fd77d9d94b7b4e66$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $atZta.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $bLCqH.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $fd77d9d94b7b4e66$var$ConfigRegistryDataSource;

});

parcelRegister("3rrx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $28193ff6e99c516d$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $28193ff6e99c516d$var$BaseUrls;
var $28193ff6e99c516d$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $28193ff6e99c516d$var$Versions;

});


parcelRegister("ea8MY", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $a4f8d12743ec7938$export$2cb8d79200775058);

var $jVnVV = parcelRequire("jVnVV");

var $atZta = parcelRequire("atZta");
class $a4f8d12743ec7938$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $atZta.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $jVnVV.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $jVnVV.parseVersionMetadata)(response);
                return (0, $jVnVV.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $jVnVV.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $atZta.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $jVnVV.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $jVnVV.parseArtifactManifest)(response);
                return (0, $jVnVV.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $jVnVV.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("lkyxC", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $f876426a85e7c7b9$export$45c6d12ca9c14f83);

var $jVnVV = parcelRequire("jVnVV");
function $f876426a85e7c7b9$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $f876426a85e7c7b9$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $f876426a85e7c7b9$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $jVnVV.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $jVnVV.Either).right(json)));
            }).catch((error)=>resolve((0, $jVnVV.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("jWi79", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $e8417c3991a4883b$export$8489e2f039bfcc4c);

var $bD5s2 = parcelRequire("bD5s2");

var $jVnVV = parcelRequire("jVnVV");

var $iVe8L = parcelRequire("iVe8L");
function $e8417c3991a4883b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8417c3991a4883b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8417c3991a4883b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bD5s2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8417c3991a4883b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $e8417c3991a4883b$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $iVe8L.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $e8417c3991a4883b$var$_objectSpread($e8417c3991a4883b$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $jVnVV.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $jVnVV.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("iVe8L", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $dc6884d75e2c5cbe$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $dc6884d75e2c5cbe$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("e6fVj", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $a43dfa43f02acd77$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $a43dfa43f02acd77$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $a43dfa43f02acd77$export$c3ac7702bfd47c1b);
const $a43dfa43f02acd77$var$SAMPLING_RATE = 10;
class $a43dfa43f02acd77$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $a43dfa43f02acd77$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $a43dfa43f02acd77$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $a43dfa43f02acd77$var$SAMPLING_RATE) return new $a43dfa43f02acd77$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("j3tvi"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $a43dfa43f02acd77$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $a43dfa43f02acd77$export$5e7536cf7bc56fee();
    }
}
const $a43dfa43f02acd77$export$a3006f8f221c0a3b = ()=>$a43dfa43f02acd77$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $a43dfa43f02acd77$export$c3ac7702bfd47c1b = ()=>$a43dfa43f02acd77$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("j3tvi", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8ahsU").then(()=>parcelRequire('dUVo3'));

});


parcelRegister("aW0Oi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $bg4zv = parcelRequire("bg4zv");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $bg4zv.parseConfigWithTargeting;
    }
});

var $PNHw3 = parcelRequire("PNHw3");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $PNHw3.TargetedConfig;
    }
});

});
parcelRegister("bg4zv", function(module, exports) {
"use strict";
var $8324bc2819736d6c$var$__assign = module.exports && module.exports.__assign || function() {
    $8324bc2819736d6c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8324bc2819736d6c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $8324bc2819736d6c$var$parseConfigWithTargeting;

var $PNHw3 = parcelRequire("PNHw3");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $8324bc2819736d6c$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $8324bc2819736d6c$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $PNHw3.TargetedConfig({
                defaultConfig: $8324bc2819736d6c$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $8324bc2819736d6c$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $PNHw3.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $8324bc2819736d6c$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $8324bc2819736d6c$var$__assign($8324bc2819736d6c$var$__assign({}, accObject), (_a = {}, _a[key] = $8324bc2819736d6c$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $8324bc2819736d6c$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $8324bc2819736d6c$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $8324bc2819736d6c$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $8324bc2819736d6c$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $8324bc2819736d6c$var$parseIdentifierList(target.orgIds),
            siteIds: $8324bc2819736d6c$var$parseIdentifierList(target.siteIds),
            userIds: $8324bc2819736d6c$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $8324bc2819736d6c$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("PNHw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $09bb5117a87ab791$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $09bb5117a87ab791$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $09bb5117a87ab791$var$TargetedConfig;
function $09bb5117a87ab791$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("hgW7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $c93103380d3df95e$export$2e2bcd8739ae039);
class $c93103380d3df95e$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $c93103380d3df95e$export$1d76d155060824c9 = (e)=>e instanceof $c93103380d3df95e$export$2e2bcd8739ae039;

});

parcelRegister("04rqQ", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $00d5a7432df64c2b$export$e3553dc63541d477);
const $00d5a7432df64c2b$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("7jxJF", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $553479eff1484507$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $553479eff1484507$export$f33622abb5224195);

var $bD5s2 = parcelRequire("bD5s2");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
function $553479eff1484507$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $553479eff1484507$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $553479eff1484507$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bD5s2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $553479eff1484507$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $553479eff1484507$export$1e3a41a51f6457c5 = ()=>new (0, $9LFKj.UFOExperience)("retrieve-artifact", {
        type: (0, $atXmE.ExperienceTypes).Operation,
        performanceType: (0, $atXmE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $553479eff1484507$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $553479eff1484507$var$_objectSpread($553479eff1484507$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("7lyWC", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $e24d432236567d4a$export$45e63649edff1e2a);
$parcel$export(module.exports, "TENANTLESS_ORG_ID", () => $e24d432236567d4a$export$eb7589a4ee50c678);
const $e24d432236567d4a$export$45e63649edff1e2a = 'ASSETS';
const $e24d432236567d4a$export$eb7589a4ee50c678 = 'tenantless';

});

parcelRegister("2ru0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $98c348668a51bb22$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $98c348668a51bb22$var$messages = (0, $8p5Cv.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    rovo: {
        id: 'fabric.atlassianSwitcher.rovo-home',
        defaultMessage: 'Rovo Home',
        description: 'The text of a link redirecting the user to the rovo home site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    artifacts: {
        id: 'fabric.atlassianSwitcher.artifacts',
        defaultMessage: 'Artifacts',
        description: 'The text of a link redirecting the user to Artifacts'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    insights: {
        id: 'fabric.atlassianSwitcher.insights',
        defaultMessage: 'Insights',
        description: 'The text of a link redirecting the user to Insights'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    rovoSearch: {
        id: 'fabric.atlassianSwitcher.rovo-search',
        defaultMessage: 'Rovo Search',
        description: 'The text of a link redirecting the user to Rovo Search app'
    },
    rovoChat: {
        id: 'fabric.atlassianSwitcher.rovo-chat',
        defaultMessage: 'Rovo Chat',
        description: 'The text of a link redirecting the user to the Rovo Chat app'
    },
    rovoStudio: {
        id: 'fabric.atlassianSwitcher.rovo-studio',
        defaultMessage: 'Rovo Studio',
        description: 'The text of a link redirecting the user to Rovo Studio app'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} more',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    customLinksSectionTitle: {
        id: 'fabric.atlassianSwitcher.customLinksSectionTitle',
        defaultMessage: 'Custom links',
        description: 'Title of the collapsible custom links section in the App Switcher, shown on the section header.'
    },
    thirdPartySectionTitle: {
        id: 'fabric.atlassianSwitcher.thirdPartySectionTitle',
        defaultMessage: 'Integrations',
        description: 'Title of the collapsible third-party apps section in the App Switcher, shown on the section header.'
    },
    sitesSectionLabel: {
        id: 'fabric.atlassianSwitcher.sitesSectionLabel',
        defaultMessage: 'Sites',
        description: 'Label shown above the list of connected sites for a product in the App Switcher, when the product is available on more than one site.'
    }
});
var $98c348668a51bb22$export$2e2bcd8739ae039 = $98c348668a51bb22$var$messages;

});

parcelRegister("kylyn", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $d36c06663c3e2baa$export$310e48be95687c2f);

var $fbUig = parcelRequire("fbUig");

var $knOWk = parcelRequire("knOWk");

var $dNcG1 = parcelRequire("dNcG1");
const $d36c06663c3e2baa$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $knOWk.withCached)((param)=>(0, $fbUig.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $dNcG1.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $d36c06663c3e2baa$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig, shouldUpdate)=>{
    const fetchMethod = (0, $knOWk.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $dNcG1.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig, shouldUpdate)
    };
};

});
parcelRegister("fbUig", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $f20512b631ef41af$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $f20512b631ef41af$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $f20512b631ef41af$export$c776284ef4b1209a);

var $gym2k = parcelRequire("gym2k");

var $9YfZp = parcelRequire("9YfZp");

var $jBSqJ = parcelRequire("jBSqJ");
const $f20512b631ef41af$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $9YfZp.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $f20512b631ef41af$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $gym2k.default).packageVersion,
            ...init === null || init === void 0 ? void 0 : init.headers
        }
    }).then(!emptyResponse ? $f20512b631ef41af$var$extraJsonFromResponse : ()=>{});
const $f20512b631ef41af$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $jBSqJ.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $gym2k.default).packageVersion,
                ...init === null || init === void 0 ? void 0 : init.headers
            }
        }), retryConfig).then($f20512b631ef41af$var$extraJsonFromResponse);
};
const $f20512b631ef41af$export$c776284ef4b1209a = (url, data, emptyResponse)=>$f20512b631ef41af$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("9YfZp", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $39f4b13b80edd1c5$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $39f4b13b80edd1c5$export$26e841bcf1aeb894);
const $39f4b13b80edd1c5$export$83179404a61b001a = 'FetchError';
class $39f4b13b80edd1c5$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $39f4b13b80edd1c5$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $39f4b13b80edd1c5$export$26e841bcf1aeb894;
    }
}

});


parcelRegister("knOWk", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $dca60445c5b4c81d$export$7f51828d6b6af163);
const $dca60445c5b4c81d$export$d4d4b402ab64e2f4 = 5000;
const $dca60445c5b4c81d$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $dca60445c5b4c81d$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($dca60445c5b4c81d$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $dca60445c5b4c81d$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("8TANM", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $36222da6858868f0$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $36222da6858868f0$export$f731e929548061dc);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
const $36222da6858868f0$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), label);
};
const $36222da6858868f0$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), description) : null;
};

});


parcelRegister("gazuc", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $99509b198dceb23a$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $99509b198dceb23a$export$1c5684a3ba697d80);

var $fc4bM = parcelRequire("fc4bM");

var $c0zXV = parcelRequire("c0zXV");
const { fetchMethod: $99509b198dceb23a$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $99509b198dceb23a$var$DefaultBffDataProviderComponent } = (0, $c0zXV.createAppSwitcherBffAvailableProductsProvider)();
const $99509b198dceb23a$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($99509b198dceb23a$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
const $99509b198dceb23a$export$1c5684a3ba697d80 = $99509b198dceb23a$var$fetchAppSwitcherBffAvailableProducts;
const $99509b198dceb23a$export$cd9fc41c59711bdd = ()=>$99509b198dceb23a$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("c0zXV", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $a93e8846dd894f85$export$7fd9c7ae7afb494c);

var $iXwVt = parcelRequire("iXwVt");

var $fbUig = parcelRequire("fbUig");

var $kylyn = parcelRequire("kylyn");
const $a93e8846dd894f85$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $a93e8846dd894f85$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $fbUig.fetchJsonWithNetworkRetries)(`${$a93e8846dd894f85$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $a93e8846dd894f85$export$7fd9c7ae7afb494c = ()=>{
    return (0, $kylyn.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $iXwVt.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $a93e8846dd894f85$export$1096efb00c5f8afc);
};

});


parcelRegister("huICS", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $3a99fd84c6365fd5$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $3a99fd84c6365fd5$export$ba83558707df5bbe);

var $fc4bM = parcelRequire("fc4bM");

var $8VfHz = parcelRequire("8VfHz");
const { fetchMethod: $3a99fd84c6365fd5$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $3a99fd84c6365fd5$var$DefaultBffThirdPartyProductsDataProvider } = (0, $8VfHz.createAppSwitcherBffThirdPartyProductsProvider)();
const $3a99fd84c6365fd5$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3a99fd84c6365fd5$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product
    }, children);
const $3a99fd84c6365fd5$export$ba83558707df5bbe = $3a99fd84c6365fd5$var$fetchAppSwitcherBffThirdPartyProducts;
const $3a99fd84c6365fd5$export$fdb5fe543e39bc7a = ()=>$3a99fd84c6365fd5$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("8VfHz", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $e83fa7f1dea202f3$export$1a41882ddb3a9c38);

var $iXwVt = parcelRequire("iXwVt");

var $fbUig = parcelRequire("fbUig");

var $kylyn = parcelRequire("kylyn");
const $e83fa7f1dea202f3$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $e83fa7f1dea202f3$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $fbUig.fetchJsonWithNetworkRetries)(`${$e83fa7f1dea202f3$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $e83fa7f1dea202f3$export$1a41882ddb3a9c38 = ()=>{
    return (0, $kylyn.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $iXwVt.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $e83fa7f1dea202f3$export$c39ca0fbc2221bcc);
};

});


parcelRegister("hy2Aq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5402d391fb3a6c5$export$2e2bcd8739ae039);

var $q6fmJ = parcelRequire("q6fmJ");
var $d5402d391fb3a6c5$export$2e2bcd8739ae039 = ()=>{
    (0, $q6fmJ.loadAtlassianSwitcher)();
    return (0, $q6fmJ.loadGenericSwitcher)();
};

});

parcelRegister("ePih1", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $0ef3a8fe61948fe2$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $0ef3a8fe61948fe2$export$2aed3ef1595b4d9);

var $fc4bM = parcelRequire("fc4bM");

var $65xBc = parcelRequire("65xBc");
const { fetchMethod: $0ef3a8fe61948fe2$var$fetchJoinableSites, ProviderComponent: $0ef3a8fe61948fe2$var$DefaultDataProviderComponent } = (0, $65xBc.createJoinableSitesProvider)();
const $0ef3a8fe61948fe2$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $0ef3a8fe61948fe2$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
const $0ef3a8fe61948fe2$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $0ef3a8fe61948fe2$var$fetchJoinableSites({});
};
const $0ef3a8fe61948fe2$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $0ef3a8fe61948fe2$var$fetchJoinableSites.reset();
};

});
parcelRegister("65xBc", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $fb3aff77f60452be$export$c3b6af53f1ca17d8);

var $kylyn = parcelRequire("kylyn");

var $iXwVt = parcelRequire("iXwVt");
const $fb3aff77f60452be$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $fb3aff77f60452be$export$c3b6af53f1ca17d8 = (fetchData = $fb3aff77f60452be$export$62986affcccd56a5, retryConfig)=>{
    return (0, $kylyn.createProviderWithCustomFetchData)('joinableSites', (0, $iXwVt.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});








parcelRegister("7ijSZ", function(module, exports) {
$parcel$export(module.exports, "Sidebar", () => (parcelRequire("gcPtm")).default);

var $gcPtm = parcelRequire("gcPtm");

});
parcelRegister("gcPtm", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b29eb3e6b670c0a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $3syVB = parcelRequire("3syVB");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $jEubQ = parcelRequire("jEubQ");

var $613oU = parcelRequire("613oU");

var $vgKRi = parcelRequire("vgKRi");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $7DDak = parcelRequire("7DDak");

var $3yZwQ = parcelRequire("3yZwQ");

var $dEtFb = parcelRequire("dEtFb");

var $8YmGC = parcelRequire("8YmGC");

var $llek7 = parcelRequire("llek7");

var $jX8z3 = parcelRequire("jX8z3");

var $i5QNC = parcelRequire("i5QNC");

var $eENmG = parcelRequire("eENmG");

var $4OGFc = parcelRequire("4OGFc");

var $dNn4D = parcelRequire("dNn4D");
parcelRequire("adCFZ");
var $hGdox = parcelRequire("hGdox");
parcelRequire("khh75");
var $a0yOb = parcelRequire("a0yOb");
const $4b29eb3e6b670c0a$var$Sidebar = ({ width: width, navigationContentItems: navigationContentItems, featureName: featureName })=>{
    const { push: push } = (0, $8whFx.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const helpCenterMessages = (0, $4OGFc.useHelpCenterMessageDictionary)();
    const onBackButtonClick = (0, $fc4bM.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $eENmG.UI_EVENT_TYPE),
            action: 'click',
            actionSubjectId: `SidebarBackButton`
        }).fire();
        push(helpCenterMessages.backButtonHref);
    }, [
        createAnalyticsEvent,
        push,
        helpCenterMessages.backButtonHref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $vgKRi.default), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $4b29eb3e6b670c0a$var$sidebarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $llek7.SideNavigation), {
        label: formatMessage((0, $dNn4D.default).sidebarNavigationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $a0yOb.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jX8z3.NavigationHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hGdox.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7DDak.GoBackItem), {
        onClick: onBackButtonClick
    }, formatMessage(helpCenterMessages.backButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i5QNC.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dEtFb.HeadingItem), null, formatMessage(helpCenterMessages.settingsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8YmGC.Section), {
        isList: true
    }, navigationContentItems.map(({ onClick: onClick, iconBefore: iconBefore, text: text, isSelected: isSelected, isVisible: isVisible })=>{
        const renderButtonItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3yZwQ.ButtonItem), {
                onClick: onClick,
                iconBefore: iconBefore,
                key: text,
                isSelected: isSelected
            }, text);
        return isVisible && renderButtonItem();
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $4b29eb3e6b670c0a$var$navFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i5QNC.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8YmGC.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3syVB.default), {
        showIcon: true,
        showTypeField: true,
        featureName: featureName,
        buttonLabel: (0, $dNn4D.default).feedbackWidget,
        analyticsSubjectId: "SidebarFeedbackButton",
        useSideNavButton: true
    }))))))));
};
const $4b29eb3e6b670c0a$var$navFooter = (0, $kig2V.xcss)({
    position: 'relative'
});
const $4b29eb3e6b670c0a$var$sidebarContainerStyles = (0, $kig2V.xcss)({
    width: '100%',
    height: '100%',
    borderRightWidth: 'border.width',
    borderRightStyle: 'solid',
    borderColor: 'color.border',
    boxSizing: 'inherit'
});
var $4b29eb3e6b670c0a$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'SideBar'
})($4b29eb3e6b670c0a$var$Sidebar);

});
parcelRegister("vgKRi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b12f60ee843d4c75$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $ieqE6 = parcelRequire("ieqE6");

var $11jpN = parcelRequire("11jpN");

var $6586e = parcelRequire("6586e");
var $kGKYz = parcelRequire("kGKYz");

var $c3Wbd = parcelRequire("c3Wbd");

var $fW4Qs = parcelRequire("fW4Qs");

var $c6HWM = parcelRequire("c6HWM");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $b12f60ee843d4c75$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $11jpN.resolveDimension)((0, $ieqE6.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $fc4bM.useEffect)(()=>{
        (0, $6586e.default)({
            [(0, $ieqE6.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $6586e.default)({
                [(0, $ieqE6.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $kGKYz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fW4Qs.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $c6HWM.default), {
        variableName: (0, $ieqE6.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $jctmk.jsx)((0, $c3Wbd.default), {
        isFixed: isFixed
    }, children));
};
var $b12f60ee843d4c75$export$2e2bcd8739ae039 = $b12f60ee843d4c75$var$LeftSidebarWithoutResize;

});
parcelRegister("c3Wbd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d254044250f9fbe3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");

var $1Ry06 = parcelRequire("1Ry06");

var $b5xMz = parcelRequire("b5xMz");

var $gEQiC = parcelRequire("gEQiC");

var $ieqE6 = parcelRequire("ieqE6");

var $JakqB = parcelRequire("JakqB");
function $d254044250f9fbe3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d254044250f9fbe3$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $jctmk.css)((0, $b5xMz.prefersReducedMotion)());
const $d254044250f9fbe3$var$mobileStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $gEQiC.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ieqE6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $ieqE6.BANNER_HEIGHT)} + ${(0, $ieqE6.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $ieqE6.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s`
    }
});
const $d254044250f9fbe3$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $gEQiC.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $ieqE6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $ieqE6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s, box-shadow ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $d254044250f9fbe3$var$fixedInnerStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $ieqE6.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ieqE6.BANNER_HEIGHT)} + ${(0, $ieqE6.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $ieqE6.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s`
});
const $d254044250f9fbe3$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ieqE6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $d254044250f9fbe3$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $d254044250f9fbe3$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $d254044250f9fbe3$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $JakqB.default)();
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            // mobile viewport styles
            $d254044250f9fbe3$var$mobileStyles,
            isFlyoutOpen && $d254044250f9fbe3$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $d254044250f9fbe3$var$staticInnerStyles,
            isFixed && $d254044250f9fbe3$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $d254044250f9fbe3$var$fixedInnerFlyoutStyles,
            isDragging && $d254044250f9fbe3$var$draggingStyles,
            $d254044250f9fbe3$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d254044250f9fbe3$export$2e2bcd8739ae039 = $d254044250f9fbe3$var$LeftSidebarInner;

});

parcelRegister("fW4Qs", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b69d4ecbb240ec8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $1Ry06 = parcelRequire("1Ry06");

var $b5xMz = parcelRequire("b5xMz");

var $gEQiC = parcelRequire("gEQiC");

var $ieqE6 = parcelRequire("ieqE6");

var $gMNCr = parcelRequire("gMNCr");

var $JakqB = parcelRequire("JakqB");

var $aj0hJ = parcelRequire("aj0hJ");

var $5OEc0 = parcelRequire("5OEc0");
function $5b69d4ecbb240ec8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5b69d4ecbb240ec8$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $jctmk.css)((0, $b5xMz.prefersReducedMotion)());
const $5b69d4ecbb240ec8$var$mobileStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $gEQiC.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ieqE6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $ieqE6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $5b69d4ecbb240ec8$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $gEQiC.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $5b69d4ecbb240ec8$var$outerStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ieqE6.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ieqE6.TRANSITION_DURATION)}ms ${(0, $1Ry06.easeOut)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $5b69d4ecbb240ec8$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $5b69d4ecbb240ec8$var$fixedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ieqE6.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $5b69d4ecbb240ec8$var$flyoutStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ieqE6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $5b69d4ecbb240ec8$var$flyoutFixedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ieqE6.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $5b69d4ecbb240ec8$var$selector = (0, $gMNCr.getPageLayoutSlotSelector)('left-sidebar');
const $5b69d4ecbb240ec8$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $JakqB.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $fc4bM.useContext)((0, $aj0hJ.SidebarResizeContext));
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5OEc0.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: [
                // mobile viewport styles
                $5b69d4ecbb240ec8$var$mobileStyles,
                isFlyoutOpen && $5b69d4ecbb240ec8$var$mobileFlyoutStyles,
                // generic styles
                $5b69d4ecbb240ec8$var$outerStyles,
                isFixed && $5b69d4ecbb240ec8$var$fixedStyles,
                isFlyoutOpen && $5b69d4ecbb240ec8$var$flyoutStyles,
                isFlyoutOpen && isFixed && $5b69d4ecbb240ec8$var$flyoutFixedStyles,
                isDragging && $5b69d4ecbb240ec8$var$draggingStyles,
                $5b69d4ecbb240ec8$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$5b69d4ecbb240ec8$var$selector
        }, children));
};
const $5b69d4ecbb240ec8$var$LeftSidebarOuter = /*#__PURE__*/ (0, $fc4bM.forwardRef)($5b69d4ecbb240ec8$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5b69d4ecbb240ec8$export$2e2bcd8739ae039 = $5b69d4ecbb240ec8$var$LeftSidebarOuter;

});


parcelRegister("7DDak", function(module, exports) {
$parcel$export(module.exports, "GoBackItem", () => $19990e9e81803ac0$export$5a7b8181e2fdb767);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $i2XJe = parcelRequire("i2XJe");

var $3yZwQ = parcelRequire("3yZwQ");
const $19990e9e81803ac0$export$5a7b8181e2fdb767 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i2XJe))), {
    color: "currentColor",
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $fc4bM.useState)(false);
    const onClickHandler = (0, $fc4bM.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3yZwQ.ButtonItem), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});

});

parcelRegister("dEtFb", function(module, exports) {
$parcel$export(module.exports, "HeadingItem", () => $af86edfc63b98be5$export$33647cff569304d0);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $T88uF = parcelRequire("T88uF");

var $bRQHU = parcelRequire("bRQHU");
const $af86edfc63b98be5$var$styles = {
    headingItem: "_18zru2gc"
};
const $af86edfc63b98be5$export$33647cff569304d0 = (props)=>{
    const { shouldRender: shouldRender } = (0, $bRQHU.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $T88uF.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $2R2iS.default)([
            $af86edfc63b98be5$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};

});

parcelRegister("8YmGC", function(module, exports) {
$parcel$export(module.exports, "Section", () => $330018f9eab3d4a6$export$6e2c8f0811a474ce);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3rlj9 = parcelRequire("3rlj9");

var $bRQHU = parcelRequire("bRQHU");
const $330018f9eab3d4a6$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $bRQHU.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3rlj9.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});

});

parcelRegister("llek7", function(module, exports) {
$parcel$export(module.exports, "SideNavigation", () => $862b441044c8a74e$export$cc4f63927c41742f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");


var $8ZObF = parcelRequire("8ZObF");

var $3jCFs = parcelRequire("3jCFs");
const $862b441044c8a74e$var$sidebarMinWidth = '240px';
const $862b441044c8a74e$var$sideNavStyles = null;
const $862b441044c8a74e$export$cc4f63927c41742f = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    typeof $3jCFs;
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkvuon _syazazsu"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8ZObF.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});

});

parcelRegister("jX8z3", function(module, exports) {
$parcel$export(module.exports, "NavigationHeader", () => $d8d260c528af7c46$export$791138eae2988149);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $d8d260c528af7c46$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
const $d8d260c528af7c46$export$791138eae2988149 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $d8d260c528af7c46$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};

});

parcelRegister("i5QNC", function(module, exports) {
$parcel$export(module.exports, "NavigationContent", () => $8c9e87b494253e00$export$af215290f9b7dac5);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $jkgEb = parcelRequire("jkgEb");

var $bRQHU = parcelRequire("bRQHU");
const $8c9e87b494253e00$var$outerContainerCSS = null;
const $8c9e87b494253e00$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjlb4i _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $8c9e87b494253e00$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
const $8c9e87b494253e00$export$af215290f9b7dac5 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $bRQHU.useShouldNestedElementRender)();
    const scrollbar = (0, $jkgEb.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rusvpsx _1kt9b3bt _1enwftgi _z5wtu2gc _14mjlb4i _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfkvpsx _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $2R2iS.default)([
                $8c9e87b494253e00$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $8c9e87b494253e00$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: (0, $2R2iS.default)([
                    $8c9e87b494253e00$var$containerCSS.basic,
                    showTopScrollIndicator && $8c9e87b494253e00$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});

});
parcelRegister("jkgEb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2996a1ceed2f137$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $d2996a1ceed2f137$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $fc4bM.useState)(0);
    const elementRef = (0, $fc4bM.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fc4bM.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("4OGFc", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterMessageDictionary", () => $33a58ee9bd2c181e$export$5698e375f19e7351);
$parcel$export(module.exports, "useConditionalMessage", () => $33a58ee9bd2c181e$export$17f06fb6e83cbd1d);

var $cBXWW = parcelRequire("cBXWW");

var $1Edl5 = parcelRequire("1Edl5");

var $dNn4D = parcelRequire("dNn4D");

var $hka0d = parcelRequire("hka0d");
const $33a58ee9bd2c181e$export$5698e375f19e7351 = ()=>{
    const { isHelpHub: isHelpHub } = (0, $cBXWW.useOptionalHelpCenterType)();
    return {
        // Sidebar messages
        backButton: isHelpHub ? (0, $dNn4D.default).backButtonHelpHub : (0, $dNn4D.default).backButton,
        backButtonHref: isHelpHub ? '/hubs' : '/',
        settingsLabel: isHelpHub ? (0, $dNn4D.default).settingsLabelHelpHub : (0, $dNn4D.default).settingsLabel,
        // Breadcrumb messages
        breadcrumbRoot: isHelpHub ? (0, $1Edl5.default).settingsPageBreadcrumbItemHelpHub : (0, $1Edl5.default).settingsPageBreadcrumbItem,
        // Sidebar header
        headerLabel: isHelpHub ? (0, $hka0d.default).helpHubLabel : (0, $hka0d.default).helpCenterLabel
    };
};
const $33a58ee9bd2c181e$export$17f06fb6e83cbd1d = (helpHubMessage, helpCenterMessage)=>{
    const { isHelpHub: isHelpHub } = (0, $cBXWW.useOptionalHelpCenterType)();
    return isHelpHub ? helpHubMessage : helpCenterMessage;
};

});
parcelRegister("1Edl5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f7bc92b93c6b48d$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7f7bc92b93c6b48d$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    settingsPageBreadcrumbItem: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.center.settings.breadcrumb.item'
    },
    settingsPageBreadcrumbItemHelpHub: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.hub.settings.breadcrumb.item'
    },
    breadcrumbsLabel: {
        id: 'help.center.settings.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'The text is shown as the accessible label for the breadcrumb navigation wrapper in the Help Center settings area, used by screen readers to identify the breadcrumb trail.'
    }
});

});

parcelRegister("dNn4D", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ad428bc930a0e65$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $5ad428bc930a0e65$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    feedbackWidget: {
        defaultMessage: 'Give feedback',
        description: 'The text for give feedback button for help centers management screen',
        id: 'sidebar.feedback.widget'
    },
    backButton: {
        defaultMessage: 'Back to all help centers',
        description: 'The text for the back button in the sidebar',
        id: 'sidebar.back.hc.management.button'
    },
    backButtonHelpHub: {
        defaultMessage: 'Back to help centers',
        description: 'The text for the back button in the sidebar when viewing a help center',
        id: 'sidebar.back.helphub.management.button'
    },
    settingsLabel: {
        defaultMessage: 'Help center settings',
        description: 'Navigation label for the help center settings link in the sidebar',
        id: 'sidebar.settings.label'
    },
    settingsLabelHelpHub: {
        defaultMessage: 'Help center settings',
        description: 'Label for settings when viewing a help center',
        id: 'sidebar.settings.label.helphub'
    },
    sidebarNavigationLabel: {
        defaultMessage: 'Sidebar navigation',
        description: 'Accessible label for the sidebar navigation landmark element',
        id: 'sidebar.navigation.label'
    }
});

});

parcelRegister("hka0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $155056bac87740b2$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $155056bac87740b2$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    helpCenterLabel: {
        defaultMessage: 'Help Center',
        description: 'Heading label for the help center displayed in the sidebar header',
        id: 'sidebar.help-center.header.helpcenter.label'
    },
    helpHubLabel: {
        defaultMessage: 'Help center',
        description: 'Heading label for the help hub displayed in the sidebar header',
        id: 'sidebar.help-center.header.helphub.label'
    },
    helpCenterImageAltLabel: {
        defaultMessage: 'help center icon',
        description: 'Label for help center icon in sidebar',
        id: 'sidebar.help-center.header.helpcenter.image.alt.label'
    }
});

});


parcelRegister("adCFZ", function(module, exports) {
$parcel$export(module.exports, "SidebarHelpCenterHeader", () => (parcelRequire("hGdox")).default);

var $hGdox = parcelRequire("hGdox");

});
parcelRegister("hGdox", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752b2b2c7866dde$export$2e2bcd8739ae039);
/* sidebar-help-center-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $i2c4n = parcelRequire("i2c4n");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $6LH8a = parcelRequire("6LH8a");

var $2N6q5 = parcelRequire("2N6q5");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $45CXQ = parcelRequire("45CXQ");

var $5kxdi = parcelRequire("5kxdi");

var $4OGFc = parcelRequire("4OGFc");
const $b752b2b2c7866dde$var$SidebarHelpCenterHeader = ()=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $5kxdi.useHelpCenterAri)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $i2c4n.default), {
        helpCenterAri: helpCenterAri,
        cloudId: (0, $6LH8a.getCloudId)()
    });
    const helpCenterData = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    let { currentHcName: currentHcName, currentHcBannerUrl: currentHcBannerUrl, currentHcThemeColor: currentHcThemeColor, useDefaultBanner: useDefaultBanner } = {
        currentHcName: undefined,
        currentHcBannerUrl: null,
        currentHcThemeColor: null,
        useDefaultBanner: false
    };
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'HelpCenter') {
        var _helpCenterData$name, _helpCenterData$helpC, _helpCenterData$helpC2, _helpCenterData$helpC3;
        currentHcName = helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$name = helpCenterData.name) === null || _helpCenterData$name === void 0 ? void 0 : _helpCenterData$name.default;
        currentHcBannerUrl = (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 || (_helpCenterData$helpC = _helpCenterData$helpC.banner) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.url;
        currentHcThemeColor = (_helpCenterData$helpC2 = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC2 === void 0 || (_helpCenterData$helpC2 = _helpCenterData$helpC2.colors) === null || _helpCenterData$helpC2 === void 0 ? void 0 : _helpCenterData$helpC2.primary;
        useDefaultBanner = !!((_helpCenterData$helpC3 = helpCenterData.helpCenterBranding) !== null && _helpCenterData$helpC3 !== void 0 && _helpCenterData$helpC3.useDefaultBanner);
    }
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const helpCenterMessages = (0, $4OGFc.useHelpCenterMessageDictionary)();
    const defaultImage = useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($2N6q5))) : undefined;
    const backgroundImage = currentHcBannerUrl ? currentHcBannerUrl : defaultImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $45CXQ.Header), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b752b2b2c7866dde$var$HelpCenterImage, {
            backgroundColor: currentHcThemeColor,
            src: backgroundImage || (0, (/*@__PURE__*/$parcel$interopDefault($2N6q5))),
            height: 24,
            width: 24,
            alt: formatMessage(helpCenterMessages.headerLabel)
        }),
        description: formatMessage(helpCenterMessages.headerLabel)
    }, currentHcName);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b752b2b2c7866dde$var$HelpCenterImage = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_128mzge": (0, $8xbhL.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_2rko1l7b _5ral1dfr",
            !__cmplp.backgroundColor ? "_bfhk4re7" : "_bfhkmpv7",
            __cmplp.className
        ])
    });
});
var $b752b2b2c7866dde$export$2e2bcd8739ae039 = $b752b2b2c7866dde$var$SidebarHelpCenterHeader;

});
parcelRegister("i2c4n", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef2abacb80e7e58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2179412537acb48a3db96339d64a5116>>
 * @relayHash 6337212810c49a971e575c2b12da2d45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956
const $1ef2abacb80e7e58$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            }
        ]
    }, v5 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956",
            "metadata": {},
            "name": "sidebarHelpCenterHeaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1ef2abacb80e7e58$var$node.hash = "b1b17113e136ecbdd8bfb74c4910cc78";
var $1ef2abacb80e7e58$export$2e2bcd8739ae039 = $1ef2abacb80e7e58$var$node;

});

parcelRegister("45CXQ", function(module, exports) {
$parcel$export(module.exports, "Header", () => $5c5a6c389e4044a6$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $kgXtI = parcelRequire("kgXtI");

var $8dsGR = parcelRequire("8dsGR");
const $5c5a6c389e4044a6$var$styles = {
    header: "_uizt1wug _vrjt1qyo _1cmdi7uo _11kjsm61 _jl2n73ad _1et6sm61 _1v6ji7uo"
};
const $5c5a6c389e4044a6$export$8b251419efc915eb = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kgXtI.CustomItem), {
        ...props,
        ref: ref,
        component: props.component || (0, $8dsGR.default),
        isTitleHeading: true,
        className: (0, $2R2iS.default)([
            $5c5a6c389e4044a6$var$styles.header
        ])
    });
});

});
parcelRegister("kgXtI", function(module, exports) {
$parcel$export(module.exports, "CustomItem", () => $78412354c67eb230$export$e2a67f48c34be853);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bKfoa = parcelRequire("bKfoa");

var $bRQHU = parcelRequire("bRQHU");
const $78412354c67eb230$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    rootMotion: "_v564hxmd _o7kshxmd _1ggl87vo",
    selectedMotion: "_v5641rrn _o7kshxmd _1ggl87vo"
};
const $78412354c67eb230$export$e2a67f48c34be853 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $bRQHU.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bKfoa.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            $78412354c67eb230$var$styles.root,
            $78412354c67eb230$var$styles.rootMotion,
            props.isSelected && $78412354c67eb230$var$styles.selectedStyles,
            props.isSelected && $78412354c67eb230$var$styles.selectedMotion,
            className
        ]),
        ...props
    });
});

});

parcelRegister("8dsGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c727a195ea794c5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
/**
 * __Container__
 *
 * A container for Header and Footer that safely handles props to the child component
 */ const $9c727a195ea794c5$var$HeaderContainer = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
var $9c727a195ea794c5$export$2e2bcd8739ae039 = $9c727a195ea794c5$var$HeaderContainer;

});




parcelRegister("khh75", function(module, exports) {
$parcel$export(module.exports, "SidebarSkeleton", () => (parcelRequire("a0yOb")).default);

var $a0yOb = parcelRequire("a0yOb");

});
parcelRegister("a0yOb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c97b1635510d66e3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bsIOe = parcelRequire("bsIOe");

var $5a4EU = parcelRequire("5a4EU");

var $1JdzP = parcelRequire("1JdzP");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $45CXQ = parcelRequire("45CXQ");

var $i5QNC = parcelRequire("i5QNC");

var $jX8z3 = parcelRequire("jX8z3");

var $8YmGC = parcelRequire("8YmGC");

var $7lN8e = parcelRequire("7lN8e");
const $c97b1635510d66e3$var$SideBarContentSkeleton = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "16px",
        width: "35%"
    }));
};
const $c97b1635510d66e3$var$SidebarHeaderSkeleton = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $jX8z3.NavigationHeader), null, /*#__PURE__*/ $fc4bM.createElement((0, $45CXQ.Header), {
        iconBefore: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
            height: "24px",
            width: "80%",
            "data-testid": "icon-skeleton"
        }),
        description: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
            height: "16px",
            width: "55%",
            "data-testid": "description-skeleton"
        })
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockEnd: "space.025"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "16px",
        width: "85%",
        "data-testid": "title-skeleton"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.300",
        paddingBlockEnd: "space.150",
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "18px",
        width: "18px",
        isCircle: true
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "16px",
        width: "60%"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $i5QNC.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "16px",
        width: "30%"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $fc4bM.createElement($c97b1635510d66e3$var$SideBarContentSkeleton, null), /*#__PURE__*/ $fc4bM.createElement($c97b1635510d66e3$var$SideBarContentSkeleton, null), (0, $7lN8e.getIsHCCustomizationEnabled)() && /*#__PURE__*/ $fc4bM.createElement($c97b1635510d66e3$var$SideBarContentSkeleton, null), /*#__PURE__*/ $fc4bM.createElement($c97b1635510d66e3$var$SideBarContentSkeleton, null)))), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        xcss: $c97b1635510d66e3$var$navFooter
    }, /*#__PURE__*/ $fc4bM.createElement((0, $i5QNC.NavigationContent), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $8YmGC.Section), null, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        height: "16px",
        width: "70%"
    })))))));
};
const $c97b1635510d66e3$var$navFooter = (0, $kig2V.xcss)({
    position: 'absolute',
    bottom: 'space.0',
    width: '94%'
});
var $c97b1635510d66e3$export$2e2bcd8739ae039 = $c97b1635510d66e3$var$SidebarHeaderSkeleton;

});




parcelRegister("hTV59", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b0c321ab3a01ddc$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $1b0c321ab3a01ddc$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    helpcenterDetailsItem: {
        defaultMessage: 'Details',
        description: 'Label for the help center details item in the help center management screen sidebar',
        id: 'admin.management.sidebar.edit.details'
    },
    helpcenterManageProjectsItem: {
        defaultMessage: 'Projects',
        description: 'Label for the help center projects item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects'
    },
    helpcenterManageProjectsItemGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Label for the help center spaces item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects-galaxia'
    },
    helpcenterManagePagesItem: {
        defaultMessage: 'Landing pages',
        description: 'Label for the help center landing pages item in the help center management screen sidebar',
        id: 'admin.management.sidebar.landing.pages'
    },
    helpcenterRovoServiceAgentItem: {
        defaultMessage: 'Rovo agent',
        description: 'Label for the help center Rovo service agent item in the help center management screen sidebar',
        id: 'admin.management.sidebar.rovo.service.agent'
    },
    helpcenterVsaReportingItem: {
        defaultMessage: 'Virtual service agent',
        description: 'Label for the help center reporting item in the help center management screen sidebar',
        id: 'admin.management.sidebar.reporting'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title shown in the help center management screen sidebar when data fails to load',
        id: 'admin.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description shown in the help center management screen sidebar when data fails to load',
        id: 'admin.management.sidebar.error.description'
    },
    landingPagesSidebarChangeBoardingHeading: {
        defaultMessage: 'Create unique pages in the help center',
        description: 'Heading text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.heading'
    },
    landingPagesSidebarChangeBoardingContent: {
        defaultMessage: "Customize layouts and curate help content to create visually-appealing landing pages that meet your audience's needs.",
        description: 'Spotlight content text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.content'
    },
    landingPagesSidebarChangeBoardingDismissButton: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.dismiss'
    },
    landingPagesSidebarChangeBoardingTryButton: {
        defaultMessage: 'Try now',
        description: 'Try now button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.try'
    }
});

});



parcelRegister("cu3fi", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => (parcelRequire("AsQS9")).HelpCenterManageProjects);

var $AsQS9 = parcelRequire("AsQS9");

});
parcelRegister("AsQS9", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => $ce88958d036d58b7$export$44752868a2f1a12);

var $F0XxH = parcelRequire("F0XxH");

var $fc4bM = parcelRequire("fc4bM");

var $io4o2 = parcelRequire("io4o2");

var $2MAnh = parcelRequire("2MAnh");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $6LH8a = parcelRequire("6LH8a");

var $hnTdV = parcelRequire("hnTdV");

var $aYMdQ = parcelRequire("aYMdQ");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $3TJLC = parcelRequire("3TJLC");

var $jEubQ = parcelRequire("jEubQ");

var $2Vha5 = parcelRequire("2Vha5");

var $bZYjs = parcelRequire("bZYjs");

var $DpObF = parcelRequire("DpObF");

var $k2M4v = parcelRequire("k2M4v");

var $1hJdJ = parcelRequire("1hJdJ");

var $8K7DG = parcelRequire("8K7DG");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $aEtFp = parcelRequire("aEtFp");

var $eef75 = parcelRequire("eef75");

var $aVQWM = parcelRequire("aVQWM");

var $eENmG = parcelRequire("eENmG");

var $lvRbB = parcelRequire("lvRbB");

var $7lN8e = parcelRequire("7lN8e");

var $c0Y6o = parcelRequire("c0Y6o");

var $uYmrU = parcelRequire("uYmrU");

var $6Nd92 = parcelRequire("6Nd92");

var $cBXWW = parcelRequire("cBXWW");

var $5kxdi = parcelRequire("5kxdi");
parcelRequire("evfUT");
var $2oyaj = parcelRequire("2oyaj");
parcelRequire("kY5US");
var $3NpCI = parcelRequire("3NpCI");

var $aHDPq = parcelRequire("aHDPq");
parcelRequire("iSdW4");
var $1lVXq = parcelRequire("1lVXq");

var $kFMLB = parcelRequire("kFMLB");
parcelRequire("5JMfB");
var $awKh7 = parcelRequire("awKh7");
parcelRequire("kpBFl");
var $f84WP = parcelRequire("f84WP");

var $28WJA = parcelRequire("28WJA");
const $ce88958d036d58b7$var$PROJECT_MAPPING_SUPPORT_DOC_URL = 'https://support.atlassian.com/jira-service-management-cloud/docs/link-service-projects-to-a-help-center/';
const $ce88958d036d58b7$var$StaticContent = ({ isReadOnlyView: isReadOnlyView })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isHelpHub: isHelpHub } = (0, $cBXWW.useHelpCenterType)();
    const isGalaxia = (0, $k2M4v.default).checkGate('itsm-project-renaming');
    const helpCenterManageProjectsLink = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $io4o2.Link), {
            href: $ce88958d036d58b7$var$PROJECT_MAPPING_SUPPORT_DOC_URL,
            actionSubjectId: "manageProjectsLink",
            target: "_blank",
            rel: "noreferrer"
        }, chunks);
    const pageTitle = isGalaxia ? (0, $kFMLB.default).manageProjectsPageTitleGalaxia : (0, $kFMLB.default).manageProjectsPageTitle;
    let pageDescription;
    if (isReadOnlyView) pageDescription = isGalaxia ? (0, $kFMLB.default).manageProjectsPageDescriptionForDefaultHCGalaxia : (0, $kFMLB.default).manageProjectsPageDescriptionForDefaultHC;
    else if (isHelpHub) pageDescription = (0, $kFMLB.default).manageProjectsPageDescriptionHelpHub;
    else if (isGalaxia) pageDescription = (0, $kFMLB.default).manageProjectsPageDescriptionGalaxia;
    else pageDescription = (0, $kFMLB.default).manageProjectsPageDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "large"
    }, formatMessage(pageTitle)), isReadOnlyView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, isHelpHub ? formatMessage(pageDescription) : formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    })));
};
const $ce88958d036d58b7$var$HelpCenterManageProjectsComponent = ()=>{
    var _data$jira, _data$helpCenter, _data$helpCenter2, _data$helpCenter3, _data$helpCenter4, _data$jira2;
    const [helpCenterMappingStatus, setHelpCenterMappingStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState((0, $28WJA.ProjectsMappingStatus).LINKED);
    const helpCenterAri = (0, $5kxdi.useHelpCenterAri)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $F0XxH.default), {
        helpCenterMappingStatus: helpCenterMappingStatus,
        helpCenterId: '',
        helpCenterARI: helpCenterAri,
        cloudId: (0, $6LH8a.getCloudId)()
    });
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [searchQuery, setSearchQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState('');
    const onInputChange = (value)=>{
        setSearchQuery(value);
    };
    const debouncedOnChange = (0, $aYMdQ.debounce)(onInputChange, (0, $9mazR.USER_TYPING_DEBOUNCE_TIME));
    const onTextFieldChange = (0, $fc4bM.useCallback)((event)=>{
        const value = event.target.value;
        debouncedOnChange(value);
    }, [
        debouncedOnChange
    ]);
    const statusTextMap = {
        [(0, $28WJA.ProjectsMappingStatus).LINKED]: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kFMLB.default).linkedFilterLabelGalaxia) : formatMessage((0, $kFMLB.default).linkedFilterLabel),
        [(0, $28WJA.ProjectsMappingStatus).UNLINKED]: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kFMLB.default).unlinkedFilterLabelGalaxia) : formatMessage((0, $kFMLB.default).unlinkedFilterLabel)
    };
    if (!(data !== null && data !== void 0 && (_data$jira = data.jira) !== null && _data$jira !== void 0 && _data$jira.jiraProjectsMappedToHelpCenter)) return null;
    if (!(data !== null && data !== void 0 && (_data$helpCenter = data.helpCenter) !== null && _data$helpCenter !== void 0 && _data$helpCenter.helpCenterById)) return null;
    const slug = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.slug;
    const isDefaultHC = !slug;
    const isReadOnlyView = !(0, $7lN8e.getIsMultiHCEnabled)() || isDefaultHC;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eef75.ContextWrapper), {
        sourceName: (0, $9mazR.ScreenName).MANAGE_PROJECTS,
        sourceType: (0, $aVQWM.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3NpCI.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce88958d036d58b7$var$StaticContent, {
        isReadOnlyView: isReadOnlyView
    }), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kFMLB.default).manageProjectPageToggleForDefaultLinkingGalaxia) : formatMessage((0, $kFMLB.default).manageProjectPageToggleForDefaultLinking)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $f84WP.default), {
        syncProjectsToggleFragmentKey: (_data$helpCenter4 = data.helpCenter) === null || _data$helpCenter4 === void 0 ? void 0 : _data$helpCenter4.helpCenterById
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $ce88958d036d58b7$var$searchInputStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
        name: "search",
        autoComplete: "off",
        isCompact: true,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
            size: "small",
            label: "search icon",
            spacing: "spacious"
        })),
        defaultValue: searchQuery,
        onChange: onTextFieldChange,
        placeholder: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $kFMLB.default).searchProjectsPlaceholderGalaxia) : formatMessage((0, $kFMLB.default).searchProjectsPlaceholder)
    })), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: 'projectMappingMenu'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $ce88958d036d58b7$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        trigger: statusTextMap[helpCenterMappingStatus],
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bZYjs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: 'projectMappingLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2MAnh.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $28WJA.ProjectsMappingStatus).LINKED);
        }
    }, statusTextMap[(0, $28WJA.ProjectsMappingStatus).LINKED])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            actionSubjectId: 'projectMappingUnLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2MAnh.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $28WJA.ProjectsMappingStatus).UNLINKED);
        }
    }, statusTextMap[(0, $28WJA.ProjectsMappingStatus).UNLINKED])))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $awKh7.default), {
        isReadOnlyView: isReadOnlyView,
        projectsListFragmentKey: data === null || data === void 0 || (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.jiraProjectsMappedToHelpCenter,
        selection: helpCenterMappingStatus,
        searchQuery: searchQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $aHDPq.manageProjectsExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvRbB.FireScreenEventOnMount), null)));
};
const $ce88958d036d58b7$export$44752868a2f1a12 = ()=>{
    (0, $6Nd92.useUFOComponentExperience)((0, $aHDPq.manageProjectsExperience));
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) {
            (0, $aHDPq.manageProjectsExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $aYMdQ.noop)).catch((0, $aYMdQ.noop));
            //TODO: Add helpCenterMappingStatus
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'project',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $DpObF.default), {
            header: formatMessage((0, $kFMLB.default).errorTitle),
            description: formatMessage((0, $kFMLB.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hnTdV)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2oyaj.default), {
        featureName: "Helpcenter manage projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).MANAGE_PROJECTS,
        id: 'help-center-manage-projects',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1lVXq.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ce88958d036d58b7$var$HelpCenterManageProjectsComponent, null))));
};
const $ce88958d036d58b7$var$searchInputStyles = (0, $kig2V.xcss)({
    width: '288px',
    marginRight: 'space.200'
});
const $ce88958d036d58b7$var$dropdownContainerStyles = (0, $kig2V.xcss)({
    zIndex: 'modal'
});

});
parcelRegister("F0XxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $83bf9b85f6a8c07b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d53c6c03de4053326d733cad1281e15b>>
 * @relayHash bc210f0fbe988c79fde091a561d08224
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392
const $83bf9b85f6a8c07b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterMappingStatus"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterARI"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterId",
                    "variableName": "helpCenterId"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterMappingStatus",
                    "variableName": "helpCenterMappingStatus"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        }
    ], v6 = [
        v4 /*: any*/ 
    ], v7 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterARI"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectsListFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "syncProjectsToggleFragment"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterProjectMappingData",
                                            "kind": "LinkedField",
                                            "name": "projectMappingData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "syncNewProjects"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392",
            "metadata": {},
            "name": "manageProjects_GetProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$83bf9b85f6a8c07b$var$node.hash = "5e6e808fa11d7afbb4a426f5b2c7f1a1";
var $83bf9b85f6a8c07b$export$2e2bcd8739ae039 = $83bf9b85f6a8c07b$var$node;

});

parcelRegister("2MAnh", function(module, exports) {
$parcel$export(module.exports, "DropdownItem", () => $56c622ab5f334203$export$6648d5fa18559e7f);

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $8lxUN = parcelRequire("8lxUN");

var $7A0bt = parcelRequire("7A0bt");
const $56c622ab5f334203$export$6648d5fa18559e7f = (0, $613oU.default)({
    componentName: 'dropdownItem'
})((0, $azARG.default)({
    onClick: (0, $8lxUN.default)('atlaskit')({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    })
})((0, $7A0bt.default)));

});

parcelRegister("kY5US", function(module, exports) {
$parcel$export(module.exports, "SettingsBreadcrumbs", () => (parcelRequire("3NpCI")).default);

var $3NpCI = parcelRequire("3NpCI");

});
parcelRegister("3NpCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2b684875a3ec135$export$2e2bcd8739ae039);

var $87wPh = parcelRequire("87wPh");

var $fc4bM = parcelRequire("fc4bM");

var $7ZXzW = parcelRequire("7ZXzW");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $ddnRa = parcelRequire("ddnRa");

var $5a4EU = parcelRequire("5a4EU");

var $4OGFc = parcelRequire("4OGFc");

var $1Edl5 = parcelRequire("1Edl5");
const $f2b684875a3ec135$var$SettingsBreadcrumbs = ({ helpCenterData: helpCenterData })=>{
    var _data$name;
    const data = (0, $3BZyK.useFragment)((0, $87wPh.default), helpCenterData);
    const helpCenterName = (data === null || data === void 0 || (_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name.default) || '';
    const slug = data === null || data === void 0 ? void 0 : data.slug;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const helpCenterMessages = (0, $4OGFc.useHelpCenterMessageDictionary)();
    const rootBreadcrumbUrl = '/';
    const getHelpcenterBreadcrumbUrl = ()=>{
        return !slug ? `${window.location.origin}/servicedesk/customer` : `${window.location.origin}/helpcenter/${slug}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ddnRa.default), {
        label: formatMessage((0, $1Edl5.default).breadcrumbsLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7ZXzW.default), {
        isFirstCrumb: true,
        to: rootBreadcrumbUrl,
        name: formatMessage(helpCenterMessages.breadcrumbRoot),
        actionSubjectId: "helpCenterBreadcrumb",
        disableTheme: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7ZXzW.default), {
        to: getHelpcenterBreadcrumbUrl(),
        name: helpCenterName,
        actionSubjectId: "helpDeskBreadcrumb",
        disableTheme: true
    }))));
};
var $f2b684875a3ec135$export$2e2bcd8739ae039 = $f2b684875a3ec135$var$SettingsBreadcrumbs;

});
parcelRegister("87wPh", function(module, exports) {
$parcel$export(module.exports, "default", () => $785d4959f2b61365$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25699f1eb65c2f623944fcb43e23c755>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $785d4959f2b61365$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "settingsBreadcrumbsFragment",
    "selections": [
        {
            "concreteType": "HelpCenterName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "default"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "slug"
        }
    ],
    "type": "HelpCenter"
};
$785d4959f2b61365$var$node.hash = "0716469cbe624819ae2ea879ee690b4e";
var $785d4959f2b61365$export$2e2bcd8739ae039 = $785d4959f2b61365$var$node;

});



parcelRegister("aHDPq", function(module, exports) {
$parcel$export(module.exports, "manageProjectsExperience", () => $15b6e0700bdfb45b$export$500b6e6c6f0e66cd);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $15b6e0700bdfb45b$export$500b6e6c6f0e66cd = new (0, $9LFKj.UFOExperience)((0, $fCHdA.manageProjectsExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("iSdW4", function(module, exports) {
$parcel$export(module.exports, "ManageProjectsLayoutSkeleton", () => (parcelRequire("1lVXq")).default);

var $1lVXq = parcelRequire("1lVXq");

});
parcelRegister("1lVXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $11a7653d1915c728$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bsIOe = parcelRequire("bsIOe");

var $aRwom = parcelRequire("aRwom");

var $1JdzP = parcelRequire("1JdzP");

var $5a4EU = parcelRequire("5a4EU");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $l5kZr = parcelRequire("l5kZr");
const $11a7653d1915c728$var$ManageProjectsLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "12px",
                    height: "12px"
                }),
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
            },
            {
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            {
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH).status
            },
            {
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 10
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "12px",
                        height: "12px"
                    })
                },
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "24px",
                        height: "24px"
                    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "24px",
                        height: "24px",
                        isCircle: true
                    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    key: 'select-all-skeleton',
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "28%",
                        height: "16px"
                    })
                },
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "30%",
                        height: "20px"
                    })
                }
            ]
        }));
    return /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-project-title-skeleton"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "50%",
        height: "20px"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "270px",
        height: "16px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "32px",
        height: "16px",
        "data-testid": "toggle-new-projects-layout-skeleton"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "25%",
        height: "32px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "20%",
        height: "32px"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        xcss: $11a7653d1915c728$var$tableSkeletonStyles
    }, /*#__PURE__*/ $fc4bM.createElement((0, $aRwom.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true,
        highlightedRowIndex: 11
    })));
};
const $11a7653d1915c728$var$tableSkeletonStyles = (0, $kig2V.xcss)({
    pointerEvents: 'none'
});
var $11a7653d1915c728$export$2e2bcd8739ae039 = $11a7653d1915c728$var$ManageProjectsLayoutSkeleton;

});
parcelRegister("aRwom", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9fe18e8c646a87$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $er5DS = parcelRequire("er5DS");

var $uOLD5 = parcelRequire("uOLD5");
class $9f9fe18e8c646a87$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static #_ = this.defaultProps = {
        defaultPage: 1,
        isLoading: false,
        isFixedSize: false,
        isRankable: false,
        onSetPage: (0, $9JZL9.default),
        onSort: (0, $9JZL9.default),
        rowsPerPage: Infinity
    };
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $uOLD5.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $er5DS.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("er5DS", function(module, exports) {
$parcel$export(module.exports, "reorderRows", () => $0a3872d4b3ad0aea$export$c476bbe5da59992d);

var $c7lWk = parcelRequire("c7lWk");
const $0a3872d4b3ad0aea$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = (0, $c7lWk.computeIndex)(sourceIndex, page, rowsPerPage);
    const toIndex = (0, $c7lWk.computeIndex)(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});
parcelRegister("c7lWk", function(module, exports) {
$parcel$export(module.exports, "computeIndex", () => $6b5ccb2d1c70cbdd$export$92bcb1ed38b134a1);
const $6b5ccb2d1c70cbdd$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};

});


parcelRegister("uOLD5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d9400c66a446ff5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $hlzw7 = parcelRequire("hlzw7");

var $cXi81 = parcelRequire("cXi81");

var $1v715 = parcelRequire("1v715");

var $62P4j = parcelRequire("62P4j");

var $jdSuF = parcelRequire("jdSuF");

var $9P2WR = parcelRequire("9P2WR");

var $6ukP6 = parcelRequire("6ukP6");

var $dUcEW = parcelRequire("dUcEW");

var $15NzZ = parcelRequire("15NzZ");

var $gWQ3q = parcelRequire("gWQ3q");

var $15HDz = parcelRequire("15HDz");

var $d2EAv = parcelRequire("d2EAv");

var $cwPHY = parcelRequire("cwPHY");

var $eM2Gk = parcelRequire("eM2Gk");
function $0d9400c66a446ff5$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 'DESC':
            return 'ASC';
        case 'ASC':
            return 'DESC';
        default:
            return currentSortOrder;
    }
}
const $0d9400c66a446ff5$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $9JZL9.default), onSort: providedOnSort = (0, $9JZL9.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $9JZL9.default), onRankEnd: providedOnRankEnd = (0, $9JZL9.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $fc4bM.useState)(false);
    const tableBodyRef = (0, $fc4bM.useRef)(null);
    const onSort = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    const onRankEnd = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    (0, $fc4bM.useEffect)(()=>{
        (0, $1v715.validateSortKey)(sortKey, head);
        (0, $hlzw7.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === 'DESC') {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? 'ASC' : $0d9400c66a446ff5$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $cXi81.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? 'large' : 'small';
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9P2WR.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jdSuF.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d2EAv.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $dUcEW.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $62P4j.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eM2Gk.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            isFixedSize: isFixedSize,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $3LM7S.jsx)($0d9400c66a446ff5$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6ukP6.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cwPHY.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $15HDz.default), {
                isLoading: isLoading,
                spinnerSize: "large",
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $0d9400c66a446ff5$var$RankableTableBody = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("cD1Ij")));
const $0d9400c66a446ff5$var$TableBody = /*#__PURE__*/ (0, $fc4bM.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $fc4bM.useState)(false);
    (0, $fc4bM.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $15NzZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gWQ3q.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)($0d9400c66a446ff5$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0d9400c66a446ff5$export$2e2bcd8739ae039 = $0d9400c66a446ff5$var$DynamicTable;

});
parcelRegister("hlzw7", function(module, exports) {
$parcel$export(module.exports, "assertIsSortable", () => $c1ea74cf3d883720$export$5eb35a4771ec4090);
const $c1ea74cf3d883720$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};

});

parcelRegister("cXi81", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $74ab62e326d8752a$export$3987dc24b734dcab);
const $74ab62e326d8752a$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};

});

parcelRegister("1v715", function(module, exports) {
$parcel$export(module.exports, "validateSortKey", () => $af50f0fda7ddd232$export$9133f5a8bfe8a200);
const $af50f0fda7ddd232$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

});

parcelRegister("62P4j", function(module, exports) {
$parcel$export(module.exports, "Caption", () => $fbec02eda0ad98d4$export$32fbfacc5d962e0c);
/* caption.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $fbec02eda0ad98d4$var$captionStyles = null;
const $fbec02eda0ad98d4$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("caption", {
        className: (0, $2R2iS.default)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });

});

parcelRegister("jdSuF", function(module, exports) {
$parcel$export(module.exports, "EmptyViewContainer", () => $29c2c2697b182d61$export$381ea436de119582);
/* empty-view-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $29c2c2697b182d61$var$emptyViewContainerStyles = null;
const $29c2c2697b182d61$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $2R2iS.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("9P2WR", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $13c1083849f08cbe$export$8f45b9407d4090d7);
/* empty-view-with-fixed-height.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $13c1083849f08cbe$var$fixedHeightStyles = null;
const $13c1083849f08cbe$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $2R2iS.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });

});

parcelRegister("6ukP6", function(module, exports) {
$parcel$export(module.exports, "PaginationWrapper", () => $4a1b897b800d36e3$export$3e5e12dc01f20a43);
/* pagination-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $4a1b897b800d36e3$var$paginationWrapperStyles = null;
const $4a1b897b800d36e3$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("dUcEW", function(module, exports) {
$parcel$export(module.exports, "Table", () => $0d2a5ae7e806dc80$export$54ec01a60f47d33d);
/* table.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
// React 18 doesn't know `inert` and only forwards it as a string attribute (`inert=""`).
// React 19 treats `inert` as a boolean, so `''` is falsy and the attribute is dropped.
const $0d2a5ae7e806dc80$var$isReact19OrLater = parseInt((0, $fc4bM.version), 10) >= 19;
const $0d2a5ae7e806dc80$var$inertValue = $0d2a5ae7e806dc80$var$isReact19OrLater ? true : '';
const $0d2a5ae7e806dc80$var$fixedSizeTableStyles = null;
const $0d2a5ae7e806dc80$var$tableStyles = null;
const $0d2a5ae7e806dc80$var$bodyBorder = null;
const $0d2a5ae7e806dc80$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("table", {
        inert: isLoading ? $0d2a5ae7e806dc80$var$inertValue : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $2R2iS.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});

});

parcelRegister("15NzZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $37c08a7c2e68ed5b$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lfPQI = parcelRequire("lfPQI");

var $3H67K = parcelRequire("3H67K");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $37c08a7c2e68ed5b$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $3LM7S.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $3H67K.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $37c08a7c2e68ed5b$var$Body = (0, $lfPQI.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)($37c08a7c2e68ed5b$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$37c08a7c2e68ed5b$export$2e2bcd8739ae039 = $37c08a7c2e68ed5b$var$Body;

});
parcelRegister("lfPQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f59575dfa7a263c3$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $cXi81 = parcelRequire("cXi81");

var $1v715 = parcelRequire("1v715");
const $f59575dfa7a263c3$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
const $f59575dfa7a263c3$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === 'ASC' ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $f59575dfa7a263c3$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $f59575dfa7a263c3$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $f59575dfa7a263c3$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $1v715.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $f59575dfa7a263c3$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $cXi81.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $3LM7S.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $3LM7S.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("3H67K", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab7179dbfaeed54$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lfMMH = parcelRequire("lfMMH");

var $cXCsn = parcelRequire("cXCsn");
const $cab7179dbfaeed54$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    // `key` is pulled out so it isn't spread into JSX (React 19 warns about that). The parent
    // already applies it to this row, and each cell gets an explicit `key` below.
    const { cells: cells, key: rowKey, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cXCsn.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${rowKey}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, key: _cellKey, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $fc4bM.createElement)((0, $lfMMH.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cab7179dbfaeed54$export$2e2bcd8739ae039 = $cab7179dbfaeed54$var$Row;

});
parcelRegister("lfMMH", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $4feb130478fc59c3$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $kcvPK = parcelRequire("kcvPK");
const $4feb130478fc59c3$var$fixedSizeTruncateStyles = null;
const $4feb130478fc59c3$var$overflowTruncateStyles = null;
const $4feb130478fc59c3$var$truncationWidthStyles = null;
const $4feb130478fc59c3$var$cellStyles = null;
const $4feb130478fc59c3$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $3LM7S.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $kcvPK.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("kcvPK", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $55e0f1caaa6580c5$export$5e6497a652ae30b5);
const $55e0f1caaa6580c5$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $55e0f1caaa6580c5$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$55e0f1caaa6580c5$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("cXCsn", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $863e8da75b0b3d89$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $863e8da75b0b3d89$var$rowStyles = null;
const $863e8da75b0b3d89$var$rowBackgroundStyles = null;
const $863e8da75b0b3d89$var$rowHighlightedBackgroundStyles = null;
const $863e8da75b0b3d89$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("tr", {
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("gWQ3q", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $aa04c6c407d0cb9a$export$e926676385687eaf);

var $fc4bM = parcelRequire("fc4bM");
class $aa04c6c407d0cb9a$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("15HDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e16d1cd153aa2c0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $hculA = parcelRequire("hculA");

var $2VaBG = parcelRequire("2VaBG");

var $5auls = parcelRequire("5auls");

var $hms1I = parcelRequire("hms1I");
class $4e16d1cd153aa2c0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: 'large',
        contentsOpacity: 0.22,
        loadingLabel: 'Loading table'
    };
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $2VaBG.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5auls.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hms1I.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("2VaBG", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dba8bd044165e1bc$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $dba8bd044165e1bc$var$containerStyles = null;
const $dba8bd044165e1bc$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $2R2iS.default)([
            "_kqswh2mm"
        ]),
        children: children
    });

});

parcelRegister("5auls", function(module, exports) {
$parcel$export(module.exports, "ContentsContainer", () => $5f1ef89de1def3a4$export$67c29eae8ae2137a);
/* contents-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $5f1ef89de1def3a4$var$CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const $5f1ef89de1def3a4$var$contentsContainerStyles = null;
const $5f1ef89de1def3a4$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            [$5f1ef89de1def3a4$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $2R2iS.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });

});

parcelRegister("hms1I", function(module, exports) {
$parcel$export(module.exports, "SpinnerContainer", () => $568e14862b3226a9$export$a5e06607a5ac6158);
/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $568e14862b3226a9$var$spinnerContainerStyles = null;
const $568e14862b3226a9$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $2R2iS.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("d2EAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $47a0fb328e2e1a34$export$2e2bcd8739ae039);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $hculA = parcelRequire("hculA");
const $47a0fb328e2e1a34$var$containerStyles = null;
const $47a0fb328e2e1a34$var$Container = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $2R2iS.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $47a0fb328e2e1a34$var$spinnerBackdropStyles = null;
const $47a0fb328e2e1a34$var$SpinnerBackdrop = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $2R2iS.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $47a0fb328e2e1a34$var$spinnerContainerStyles = null;
const $47a0fb328e2e1a34$var$SpinnerContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: ref,
        className: (0, $2R2iS.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));
class $47a0fb328e2e1a34$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: 'large',
        contentsOpacity: "var(--ds-opacity-loading, 0.2)",
        loadingLabel: 'Loading table'
    };
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this$spinnerRef, _this$containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $3LM7S.jsxs)($47a0fb328e2e1a34$var$Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $3LM7S.jsx)($47a0fb328e2e1a34$var$SpinnerBackdrop, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)($47a0fb328e2e1a34$var$SpinnerContainer, {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});

parcelRegister("cwPHY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6088bc790c7a8e3d$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $kAjco = parcelRequire("kAjco");
class $6088bc790c7a8e3d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kAjco.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("kAjco", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a48fb9fb03ba2a1$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $ibiss = parcelRequire("ibiss");

var $c4Xn6 = parcelRequire("c4Xn6");

var $1ZqY6 = parcelRequire("1ZqY6");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $6MTCM = parcelRequire("6MTCM");

var $f7h5X = parcelRequire("f7h5X");

var $QLbvn = parcelRequire("QLbvn");

var $epO2G = parcelRequire("epO2G");

var $lXUgN = parcelRequire("lXUgN");
const $4a48fb9fb03ba2a1$var$styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const $4a48fb9fb03ba2a1$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: undefined,
    packageVersion: undefined
};
function $4a48fb9fb03ba2a1$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($c4Xn6))) : (0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6)));
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        as: "span",
        xcss: $4a48fb9fb03ba2a1$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
}
function $4a48fb9fb03ba2a1$var$InnerPagination({ components: components = (0, $epO2G.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $epO2G.emptyObject), max: max = 7, onChange: onChange = (0, $9JZL9.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $QLbvn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $ibiss.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$4a48fb9fb03ba2a1$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
            as: "li",
            xcss: $4a48fb9fb03ba2a1$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $f7h5X.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6MTCM.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)($4a48fb9fb03ba2a1$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i3riz.Inline), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $4a48fb9fb03ba2a1$var$styles.paginationMenu,
                    children: (0, $lXUgN.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6MTCM.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)($4a48fb9fb03ba2a1$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $4a48fb9fb03ba2a1$var$Pagination = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)($4a48fb9fb03ba2a1$var$InnerPagination));
var $4a48fb9fb03ba2a1$export$2e2bcd8739ae039 = $4a48fb9fb03ba2a1$var$Pagination;

});
parcelRegister("c4Xn6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea16940a5b16b575a448de9712a73f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cb3e9bf8b0ebf96$var$_react = $8cb3e9bf8b0ebf96$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $8cb3e9bf8b0ebf96$var$_iconNew = $8cb3e9bf8b0ebf96$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $8cb3e9bf8b0ebf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-left
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cb3e9bf8b0ebf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $8cb3e9bf8b0ebf96$var$_react.default.createElement($8cb3e9bf8b0ebf96$var$_iconNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$8cb3e9bf8b0ebf96$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $8cb3e9bf8b0ebf96$var$_default = module.exports.default = $8cb3e9bf8b0ebf96$var$ChevronLeftIcon;

});

parcelRegister("6MTCM", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeb6eb728ddc87d5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $kTVlm = parcelRequire("kTVlm");
function $eeb6eb728ddc87d5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kTVlm.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("f7h5X", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4cc4202d41ef522$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $kTVlm = parcelRequire("kTVlm");
function $e4cc4202d41ef522$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kTVlm.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("QLbvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $587ccd30b34d4c72$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $dVxDa = parcelRequire("dVxDa");
const $587ccd30b34d4c72$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $587ccd30b34d4c72$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        as: "li",
        testId: testId,
        xcss: $587ccd30b34d4c72$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $k8Adr.Text), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $dVxDa.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("epO2G", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $a26fa8cf35e4c1d2$export$3f860eba1218f8d3);
const $a26fa8cf35e4c1d2$export$3f860eba1218f8d3 = {};

});

parcelRegister("lXUgN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6faa042dac87e7ac$export$2e2bcd8739ae039);

var $jiju3 = parcelRequire("jiju3");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $6faa042dac87e7ac$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $jiju3.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $6faa042dac87e7ac$export$2e2bcd8739ae039 = $6faa042dac87e7ac$var$collapseRange;

});



parcelRegister("eM2Gk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b8ebc27722367fa$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $1v715 = parcelRequire("1v715");

var $fWnEo = parcelRequire("fWnEo");

var $gocY1 = parcelRequire("gocY1");

var $b3LAE = parcelRequire("b3LAE");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $3b8ebc27722367fa$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $1v715.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $1v715.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $gocY1.default) : (0, $b3LAE.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fWnEo.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $3LM7S.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b8ebc27722367fa$export$2e2bcd8739ae039 = $3b8ebc27722367fa$var$TableHead;

});
parcelRegister("fWnEo", function(module, exports) {
$parcel$export(module.exports, "Head", () => $fab3d88611811150$export$e93312b7773dfcac);
/* head.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $fab3d88611811150$var$rankingStyles = null;
const $fab3d88611811150$var$headStyles = null;
const $fab3d88611811150$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $2R2iS.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};

});

parcelRegister("gocY1", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b8fae3f5fd2a3b5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $diM5U = parcelRequire("diM5U");

var $kKAKn = parcelRequire("kKAKn");

var $b3LAE = parcelRequire("b3LAE");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7b8fae3f5fd2a3b5$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $kKAKn.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b3LAE.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $7b8fae3f5fd2a3b5$var$RankableTableHeadCell = (0, $diM5U.default)($7b8fae3f5fd2a3b5$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7b8fae3f5fd2a3b5$export$2e2bcd8739ae039 = $7b8fae3f5fd2a3b5$var$RankableTableHeadCell;

});
parcelRegister("diM5U", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8e93402eae81668$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
function $d8e93402eae81668$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $3LM7S.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("kKAKn", function(module, exports) {
$parcel$export(module.exports, "inlineStylesIfRanking", () => $e6fb49bd686bd01a$export$a601f1775e10043f);
const $e6fb49bd686bd01a$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};

});

parcelRegister("b3LAE", function(module, exports) {
$parcel$export(module.exports, "default", () => $37cb173d8b5dee42$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $cPYvY = parcelRequire("cPYvY");

var $5ctSl = parcelRequire("5ctSl");

var $dBtOK = parcelRequire("dBtOK");

var $26fPW = parcelRequire("26fPW");

var $EawnW = parcelRequire("EawnW");

var $bcTS3 = parcelRequire("bcTS3");

var $8uT3P = parcelRequire("8uT3P");
const $37cb173d8b5dee42$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    truncateButtonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1ul9idpf _p12f1osq _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66",
    truncateHeaderWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _tzy4kb7n _u5f31b66 _1ul9idpf",
    truncateHiddenIconHeaderWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _tzy4idpf _18u010v4 _1ul9idpf",
    truncateTooltipWrapper: "_1ul9idpf _p12f1osq"
};
const $37cb173d8b5dee42$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06",
    truncateText: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1ule _1ul9idpf _1bto1l2s _o5721q9c"
};
const $37cb173d8b5dee42$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $fc4bM.useState)(false);
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $fc4bM.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $fc4bM.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $fc4bM.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $fc4bM.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $37cb173d8b5dee42$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: sortOrder === 'ASC' ? ascendingSortTooltip : descendingSortTooltip,
            hasNewContentOnTriggerClick: true,
            children: (tooltipProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    role: "presentation",
                    xcss: isFixedSize && shouldTruncate ? $37cb173d8b5dee42$var$styles.truncateTooltipWrapper : undefined,
                    children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $EawnW.Pressable), {
                        ...tooltipProps,
                        onClick: onClick,
                        xcss: isFixedSize && shouldTruncate ? $37cb173d8b5dee42$var$styles.truncateButtonWrapper : $37cb173d8b5dee42$var$styles.buttonWrapper,
                        "aria-roledescription": buttonAriaRoleDescription,
                        children: [
                            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
                                xcss: isFixedSize && shouldTruncate ? isVisibleIconOnlyHeader ? $37cb173d8b5dee42$var$styles.truncateHiddenIconHeaderWrapper : $37cb173d8b5dee42$var$styles.truncateHeaderWrapper : isVisibleIconOnlyHeader ? $37cb173d8b5dee42$var$styles.hideIconHeaderWrapper : $37cb173d8b5dee42$var$styles.visibleHeaderWrapper,
                                children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                                    className: (0, $2R2iS.default)([
                                        $37cb173d8b5dee42$var$headCellStyles.text,
                                        isFixedSize && shouldTruncate && $37cb173d8b5dee42$var$headCellStyles.truncateText
                                    ]),
                                    children: content
                                })
                            }),
                            shouldRenderSortIcon && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $26fPW.Flex), {
                                xcss: isSortIconVisible ? $37cb173d8b5dee42$var$styles.sortIconVisibleWrapper : $37cb173d8b5dee42$var$styles.sortIconHiddenWrapper,
                                children: sortOrder === 'ASC' ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ctSl))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--up--icon`
                                }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cPYvY))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--down--icon`
                                })
                            })
                        ]
                    })
                })
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8uT3P.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isFixedSize: isFixedSize,
        isSortable: isSortable,
        sortOrder: sortOrder,
        shouldTruncate: shouldTruncate,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$37cb173d8b5dee42$export$2e2bcd8739ae039 = $37cb173d8b5dee42$var$TableHeadCell;

});
parcelRegister("cPYvY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a417dd35c32223c531e68a3b3a9c2a91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9589306f847a0a1f$var$_react = $9589306f847a0a1f$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9589306f847a0a1f$var$_iconNew = $9589306f847a0a1f$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9589306f847a0a1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-down
 * Usage guidance:
 * Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9589306f847a0a1f$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $9589306f847a0a1f$var$_react.default.createElement($9589306f847a0a1f$var$_iconNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$9589306f847a0a1f$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $9589306f847a0a1f$var$_default = module.exports.default = $9589306f847a0a1f$var$ArrowDownIcon;

});

parcelRegister("5ctSl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::674db590f296a2f756724d798fd052ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c953f64c96f5c41$var$_react = $3c953f64c96f5c41$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $3c953f64c96f5c41$var$_iconNew = $3c953f64c96f5c41$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $3c953f64c96f5c41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c953f64c96f5c41$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $3c953f64c96f5c41$var$_react.default.createElement($3c953f64c96f5c41$var$_iconNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$3c953f64c96f5c41$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $3c953f64c96f5c41$var$_default = module.exports.default = $3c953f64c96f5c41$var$ArrowUpIcon;

});

parcelRegister("8uT3P", function(module, exports) {
$parcel$export(module.exports, "HeadCell", () => $0381b674c600d84f$export$4e8024263ace498b);
/* head-cell.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $kcvPK = parcelRequire("kcvPK");
const $0381b674c600d84f$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $0381b674c600d84f$var$overflowTruncateStyles = null;
const $0381b674c600d84f$var$truncationWidthStyles = null;
const $0381b674c600d84f$var$fixedSizeTruncateStyles = null;
const $0381b674c600d84f$var$cellStyles = null;
const $0381b674c600d84f$var$headCellBaseStyles = null;
const $0381b674c600d84f$export$4e8024263ace498b = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $kcvPK.getTruncationStyleVars)({
            width: width
        }),
        [$0381b674c600d84f$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === 'ASC';
    const isDESC = sortOrder === 'DESC';
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $2R2iS.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});




parcelRegister("cD1Ij", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("84PLG"),
    $9dnsd("jBz2s"),
    $9dnsd("a9A5B")
]).then(()=>parcelRequire('7W91l'));

});





parcelRegister("kFMLB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1006f4e3eca46e5$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $f1006f4e3eca46e5$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    manageProjectsPageTitle: {
        defaultMessage: 'Projects',
        description: 'Help center manage projects page title',
        id: 'manage.projects.page.title'
    },
    manageProjectsPageTitleGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Help center manage spaces page title',
        id: 'manage.projects.page.title-galaxia'
    },
    manageProjectsPageDescription: {
        defaultMessage: 'Manage your help content effectively by linking projects to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking projects to a help center</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.description'
    },
    manageProjectsPageDescriptionHelpHub: {
        defaultMessage: 'Manage spaces linked to your help center to organize help content and show customers only relevant resources.',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description.helphub'
    },
    manageProjectsPageDescriptionGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description-galaxia'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHC: {
        defaultMessage: 'All the projects in your site are always linked to your default help center, the resources will always be available in help center portal sections, virtual service agent, search and recently used request forms. <link>Learn more about projects in help centers</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.default.hc.description'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHCGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.default.hc.description-galaxia'
    },
    manageProjectPageToggleForDefaultLinking: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking'
    },
    manageProjectPageToggleForDefaultLinkingHelpHub: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking for help center',
        id: 'manage.projects.page.toggle.default.linking.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking for help center with Galaxia renaming',
        id: 'manage.projects.page.toggle.default.linking.galaxia.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking-galaxia'
    },
    linkedFilterLabel: {
        defaultMessage: 'Linked projects',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label'
    },
    linkedFilterLabelGalaxia: {
        defaultMessage: 'Linked spaces',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label-galaxia'
    },
    unlinkedFilterLabel: {
        defaultMessage: 'Unlinked projects',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label'
    },
    unlinkedFilterLabelGalaxia: {
        defaultMessage: 'Unlinked spaces',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label-galaxia'
    },
    searchProjectsPlaceholder: {
        defaultMessage: 'Search for projects',
        description: 'Placeholder for search projects input',
        id: 'manage.projects.page.search.placeholder'
    },
    searchProjectsPlaceholderGalaxia: {
        defaultMessage: 'Search for spaces',
        description: 'Placeholder for search spaces input',
        id: 'manage.projects.page.search.placeholder-galaxia'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title shown on the manage projects page when an unexpected error occurs',
        id: 'manage.projects.page.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error message body on the manage projects page prompting the user to retry',
        id: 'manage.projects.page.error.description'
    }
});

});

parcelRegister("5JMfB", function(module, exports) {
$parcel$export(module.exports, "ProjectsList", () => (parcelRequire("awKh7")).default);

var $awKh7 = parcelRequire("awKh7");

});
parcelRegister("awKh7", function(module, exports) {
$parcel$export(module.exports, "default", () => $78684a0c969bc35a$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $5kfOu = parcelRequire("5kfOu");

var $8GiFq = parcelRequire("8GiFq");
var $78684a0c969bc35a$export$2e2bcd8739ae039 = (0, $6umft.default)(null, {
    showErrorFlag: $5kfOu.showErrorFlag,
    showSuccessFlag: $5kfOu.showSuccessFlag
})((0, $8GiFq.default));

});
parcelRegister("8GiFq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f69da2d8b7580be1$export$2e2bcd8739ae039);

var $dxRQD = parcelRequire("dxRQD");

var $fc4bM = parcelRequire("fc4bM");

var $5mrpn = parcelRequire("5mrpn");

var $75fbt = parcelRequire("75fbt");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $hi8gb = parcelRequire("hi8gb");

var $jEubQ = parcelRequire("jEubQ");

var $cWkQ8 = parcelRequire("cWkQ8");

var $kDn5h = parcelRequire("kDn5h");

var $aRwom = parcelRequire("aRwom");

var $DpObF = parcelRequire("DpObF");

var $k2M4v = parcelRequire("k2M4v");

var $euRd1 = parcelRequire("euRd1");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $eENmG = parcelRequire("eENmG");

var $c0Y6o = parcelRequire("c0Y6o");
parcelRequire("3Feac");
var $jqF5S = parcelRequire("jqF5S");

var $l5kZr = parcelRequire("l5kZr");
parcelRequire("8UbUN");
var $cSnLt = parcelRequire("cSnLt");

var $2x3xj = parcelRequire("2x3xj");

var $28WJA = parcelRequire("28WJA");

var $d0PP3 = parcelRequire("d0PP3");

var $195ui = parcelRequire("195ui");

var $43o50 = parcelRequire("43o50");

var $cwWA0 = parcelRequire("cwWA0");
const $f69da2d8b7580be1$export$680c2e5e5eec1385 = 20;
const $f69da2d8b7580be1$var$messagesMap = {
    [(0, $28WJA.ProjectsMappingOperations).LINK]: {
        [(0, $28WJA.ProjectsMappingMode).BULK]: {
            successTitle: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).bulkLinkSuccessTitleGalaxia : (0, $2x3xj.default).bulkLinkSuccessTitle,
            errorTitle: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).bulkLinkErrorTitleGalaxia : (0, $2x3xj.default).bulkLinkErrorTitle
        },
        [(0, $28WJA.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $2x3xj.default).linkSuccessTitle,
            errorTitle: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).linkErrorTitleGalaxia : (0, $2x3xj.default).linkErrorTitle
        }
    },
    [(0, $28WJA.ProjectsMappingOperations).UNLINK]: {
        [(0, $28WJA.ProjectsMappingMode).BULK]: {
            successTitle: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).bulkUnlinkSuccessTitleGalaxia : (0, $2x3xj.default).bulkUnlinkSuccessTitle,
            errorTitle: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).bulkUnlinkErrorTitleGalaxia : (0, $2x3xj.default).bulkUnlinkErrorTitle
        },
        [(0, $28WJA.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $2x3xj.default).unlinkSuccessTitle,
            errorTitle: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).unlinkErrorTitleGalaxia : (0, $2x3xj.default).unlinkErrorTitle
        }
    }
};
const $f69da2d8b7580be1$var$ProjectsList = ({ projectsListFragmentKey: projectsListFragmentKey, searchQuery: searchQuery, selection: selection, isReadOnlyView: isReadOnlyView, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [isBulkActionLoading, setIsBulkActionLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [selectedProjectsMap, setSelectedProjectsMap] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState({});
    const [modalVisibility, setModalVisibility] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState({
        [(0, $l5kZr.CANT_UNLINK_ALL_DIALOG)]: false,
        [(0, $l5kZr.UNLINK_CONFIRMATION_DIALOG)]: false
    });
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const data = (0, $3BZyK.useFragment)((0, $dxRQD.default), projectsListFragmentKey);
    const { onLinkUnlinkProjects: onLinkUnlinkProjects } = (0, $jqF5S.useProjectMapping)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const selectedProjectsCount = Object.values(selectedProjectsMap).filter(Boolean).length;
    const disableSingleProjectActions = selectedProjectsCount > 0;
    const projects = data.edges || [];
    const handleProjectMapping = (selectedProjectIds, operationType, mappingStatus)=>{
        const getProjectName = ()=>{
            var _projects$find;
            return (_projects$find = projects.find((project)=>{
                var _project$node;
                return (project === null || project === void 0 || (_project$node = project.node) === null || _project$node === void 0 ? void 0 : _project$node.projectId) === selectedProjectIds[0];
            })) === null || _projects$find === void 0 || (_projects$find = _projects$find.node) === null || _projects$find === void 0 ? void 0 : _projects$find.name;
        };
        const mode = selectedProjectIds.length > 1 ? (0, $28WJA.ProjectsMappingMode).BULK : (0, $28WJA.ProjectsMappingMode).SINGLE;
        setIsBulkActionLoading(true);
        onLinkUnlinkProjects(selectedProjectIds, operationType, mappingStatus).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length
            }).fire();
            resetBulkSelection();
            showSuccessFlagAction($f69da2d8b7580be1$var$messagesMap[operationType][mode].successTitle, mode === (0, $28WJA.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : {
                number: selectedProjectIds.length
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            showErrorFlagAction($f69da2d8b7580be1$var$messagesMap[operationType][mode].errorTitle, (0, $2x3xj.default).genericErrorDescription, [], mode === (0, $28WJA.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : undefined);
            if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length,
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsBulkActionLoading(false);
            setModalVisibility({
                ...modalVisibility,
                [(0, $l5kZr.UNLINK_CONFIRMATION_DIALOG)]: false
            });
        });
    };
    const onBulkActionClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        const operation = selection === (0, $28WJA.ProjectsMappingStatus).LINKED ? (0, $28WJA.ProjectsMappingOperations).UNLINK : (0, $28WJA.ProjectsMappingOperations).LINK;
        if (selectedProjectIds.length === 0) return;
        if (operation === (0, $28WJA.ProjectsMappingOperations).UNLINK && selectedProjectIds.length === projects.length) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $l5kZr.CANT_UNLINK_ALL_DIALOG)]: true
            });
            return;
        }
        if (operation === (0, $28WJA.ProjectsMappingOperations).UNLINK) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $l5kZr.UNLINK_CONFIRMATION_DIALOG)]: true
            });
            return;
        }
        handleProjectMapping(selectedProjectIds, (0, $28WJA.ProjectsMappingOperations).LINK, selection);
    };
    const onUnlinkDialogButtonClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        setIsBulkActionLoading(true);
        handleProjectMapping(selectedProjectIds, (0, $28WJA.ProjectsMappingOperations).UNLINK, selection);
    };
    const isIndeterminate = !!(selectedProjectsCount > 0 && selectedProjectsCount < projects.length);
    const filteredProjects = projects.filter((project)=>{
        var _project$node2;
        return project === null || project === void 0 || (_project$node2 = project.node) === null || _project$node2 === void 0 || (_project$node2 = _project$node2.name) === null || _project$node2 === void 0 ? void 0 : _project$node2.toLowerCase().includes(searchQuery.toLowerCase());
    });
    const resetBulkSelection = ()=>{
        setIsChecked(false);
        setSelectedProjectsMap({});
    };
    // whenever the selection changes, reset the selected projects
    (0, $fc4bM.useEffect)(()=>{
        resetBulkSelection();
    }, [
        selection
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // If all projects are selected one by one, check the select all checkbox
        if (selectedProjectsCount === filteredProjects.length) setIsChecked(true);
        // If all projects are unselected one by one, uncheck the select all checkbox
        if (selectedProjectsCount === 0) setIsChecked(false);
    }, [
        selectedProjectsCount,
        filteredProjects.length
    ]);
    const onChangeHandler = ()=>{
        const selectionMap = {};
        setSelectedProjectsMap(isChecked ? selectionMap : filteredProjects.reduce((acc, project)=>{
            var _project$node3, _project$node4;
            if (!(project !== null && project !== void 0 && (_project$node3 = project.node) !== null && _project$node3 !== void 0 && _project$node3.projectId)) return acc;
            acc[project === null || project === void 0 || (_project$node4 = project.node) === null || _project$node4 === void 0 ? void 0 : _project$node4.projectId] = true;
            return acc;
        }, selectionMap));
        setIsChecked(!isChecked);
    };
    const head = {
        cells: [
            ...isReadOnlyView ? [] : [
                {
                    key: 'select-all',
                    content: // eslint-disable-next-line @atlassian/a11y/role-supports-aria-props -- Disabling existing violation, should be fixed when revisited.
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kDn5h.Checkbox), {
                        "aria-checked": isChecked,
                        isChecked: isChecked,
                        isIndeterminate: isIndeterminate,
                        onChange: onChangeHandler,
                        "aria-label": (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).selectAllProjectsCheckboxLabelGalaxia) : formatMessage((0, $195ui.default).selectAllProjectsCheckboxLabel),
                        name: "select-all-checkbox"
                    }),
                    width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
                }
            ],
            {
                key: 'project-name',
                content: 'Project',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                key: 'lead-name',
                content: 'Lead',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            ...isReadOnlyView ? [] : [
                {
                    key: 'status',
                    content: 'Status',
                    width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH).status
                },
                {
                    key: 'action-button',
                    content: 'Actions',
                    width: (0, $l5kZr.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
                }
            ]
        ]
    };
    const toggleProjectSelect = (projectId)=>{
        setSelectedProjectsMap((prevState)=>({
                ...prevState,
                [projectId]: !prevState[projectId]
            }));
    };
    const rows = filteredProjects.map((project)=>{
        var _project$node5, _project$node6, _project$node7, _project$node8, _project$node0, _project$node1, _project$node10, _project$node11, _project$node12, _project$node13, _project$node14, _project$node15, _project$node16, _project$node17, _project$node18, _project$node19;
        return {
            key: (project === null || project === void 0 || (_project$node5 = project.node) === null || _project$node5 === void 0 ? void 0 : _project$node5.projectId) || (project === null || project === void 0 || (_project$node6 = project.node) === null || _project$node6 === void 0 ? void 0 : _project$node6.name),
            isHighlighted: selectedProjectsMap[(project === null || project === void 0 || (_project$node7 = project.node) === null || _project$node7 === void 0 ? void 0 : _project$node7.projectId) || ''],
            cells: [
                ...isReadOnlyView ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kDn5h.Checkbox), {
                            isChecked: !!selectedProjectsMap[(project === null || project === void 0 || (_project$node8 = project.node) === null || _project$node8 === void 0 ? void 0 : _project$node8.projectId) || ''],
                            onChange: ()=>{
                                var _project$node9;
                                return toggleProjectSelect((project === null || project === void 0 || (_project$node9 = project.node) === null || _project$node9 === void 0 ? void 0 : _project$node9.projectId) || '');
                            },
                            name: "select-checkbox",
                            "aria-label": (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).selectProjectCheckboxLabelGalaxia) : formatMessage((0, $195ui.default).selectProjectCheckboxLabel)
                        })
                    }
                ],
                {
                    key: project === null || project === void 0 || (_project$node0 = project.node) === null || _project$node0 === void 0 ? void 0 : _project$node0.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hi8gb.default), {
                        target: "_blank",
                        href: (project === null || project === void 0 || (_project$node1 = project.node) === null || _project$node1 === void 0 ? void 0 : _project$node1.webUrl) || '#'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050",
                        paddingInlineEnd: "space.100"
                    }, (project === null || project === void 0 || (_project$node10 = project.node) === null || _project$node10 === void 0 || (_project$node10 = _project$node10.avatar) === null || _project$node10 === void 0 ? void 0 : _project$node10.small) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWkQ8.default), {
                        size: "small",
                        appearance: "square",
                        src: project === null || project === void 0 || (_project$node11 = project.node) === null || _project$node11 === void 0 || (_project$node11 = _project$node11.avatar) === null || _project$node11 === void 0 ? void 0 : _project$node11.small,
                        name: project === null || project === void 0 || (_project$node12 = project.node) === null || _project$node12 === void 0 || (_project$node12 = _project$node12.avatar) === null || _project$node12 === void 0 ? void 0 : _project$node12.small
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, project === null || project === void 0 || (_project$node13 = project.node) === null || _project$node13 === void 0 ? void 0 : _project$node13.name)))
                },
                {
                    key: project === null || project === void 0 || (_project$node14 = project.node) === null || _project$node14 === void 0 || (_project$node14 = _project$node14.lead) === null || _project$node14 === void 0 ? void 0 : _project$node14.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
                        paddingInlineEnd: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWkQ8.default), {
                        size: "small",
                        appearance: "circle",
                        src: project === null || project === void 0 || (_project$node15 = project.node) === null || _project$node15 === void 0 || (_project$node15 = _project$node15.lead) === null || _project$node15 === void 0 ? void 0 : _project$node15.picture,
                        name: project === null || project === void 0 || (_project$node16 = project.node) === null || _project$node16 === void 0 || (_project$node16 = _project$node16.lead) === null || _project$node16 === void 0 ? void 0 : _project$node16.picture
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, project === null || project === void 0 || (_project$node17 = project.node) === null || _project$node17 === void 0 || (_project$node17 = _project$node17.lead) === null || _project$node17 === void 0 ? void 0 : _project$node17.name))
                },
                ...isReadOnlyView ? [] : [
                    {
                        content: selection === (0, $28WJA.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), {
                            appearance: "success"
                        }, formatMessage((0, $195ui.default).projectsListLinkedLozengeLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $euRd1.default), null, formatMessage((0, $195ui.default).projectsListUnlinkedLozengeLabel))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cSnLt.default), {
                            isDisabled: disableSingleProjectActions,
                            projectId: (project === null || project === void 0 || (_project$node18 = project.node) === null || _project$node18 === void 0 ? void 0 : _project$node18.projectId) || '',
                            projectName: (project === null || project === void 0 || (_project$node19 = project.node) === null || _project$node19 === void 0 ? void 0 : _project$node19.name) || '',
                            selection: selection,
                            isLastProject: projects.length === 1,
                            onLinkUnlinkProjects: onLinkUnlinkProjects
                        })
                    }
                ]
            ]
        };
    });
    // If user searches for a project that doesn't exist
    if (rows.length === 0 && searchQuery.trim() !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $DpObF.default), {
        header: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).projectsListEmptySearchTitleGalaxia) : formatMessage((0, $195ui.default).projectsListEmptySearchTitle),
        description: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).projectsListEmptySearchDescriptionGalaxia) : formatMessage((0, $195ui.default).projectsListEmptySearchDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75fbt)))
    });
    // If no projects are linked to the help center and the user is in the linked tab
    if (rows.length === 0 && selection === (0, $28WJA.ProjectsMappingStatus).LINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $DpObF.default), {
        header: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).noLinkedProjectsTitleGalaxia) : formatMessage((0, $195ui.default).noLinkedProjectsTitle),
        description: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).noLinkedProjectsDescriptionGalaxia) : formatMessage((0, $195ui.default).noLinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5mrpn)))
    });
    // If no projects are linked to the help center and the user is in the unlinked tab
    if (rows.length === 0 && selection === (0, $28WJA.ProjectsMappingStatus).UNLINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $DpObF.default), {
        header: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).noUnlinkedProjectsTitleGalaxia) : formatMessage((0, $195ui.default).noUnlinkedProjectsTitle),
        description: (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $195ui.default).noUnlinkedProjectsDescriptionGalaxia) : formatMessage((0, $195ui.default).noUnlinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5mrpn)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $f69da2d8b7580be1$var$tableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d0PP3.BulkActionToolbar), {
        selectedProjectsCount: selectedProjectsCount,
        selection: selection,
        onBulkActionClick: onBulkActionClick,
        isLoading: isBulkActionLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aRwom.default), {
        head: head,
        rows: rows,
        rowsPerPage: $f69da2d8b7580be1$export$680c2e5e5eec1385,
        defaultPage: 1,
        isFixedSize: true,
        defaultSortKey: "project-name",
        defaultSortOrder: "ASC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cwWA0.UnlinkConfirmationModal), {
        isOpen: modalVisibility[0, $l5kZr.UNLINK_CONFIRMATION_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $l5kZr.UNLINK_CONFIRMATION_DIALOG)]: false
            }),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: modalVisibility[0, $l5kZr.UNLINK_CONFIRMATION_DIALOG] && isBulkActionLoading,
        numberOfProjects: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $43o50.UnlinkAllProjectsWarningModal), {
        isOpen: modalVisibility[0, $l5kZr.CANT_UNLINK_ALL_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $l5kZr.CANT_UNLINK_ALL_DIALOG)]: false
            })
    }));
};
const $f69da2d8b7580be1$var$tableStyles = (0, $kig2V.xcss)({
    position: 'relative',
    // @ts-expect-error @atlaskit/ui-styling-standard/no-nested-selectors
    th: {
        height: '100%',
        verticalAlign: 'middle'
    },
    marginBottom: 'space.100'
});
var $f69da2d8b7580be1$export$2e2bcd8739ae039 = $f69da2d8b7580be1$var$ProjectsList;

});
parcelRegister("dxRQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $430e1cf574aebe59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a4a61aea1d2ec868b83ec14a0afe25a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $430e1cf574aebe59$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectsListFragment",
        "selections": [
            {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "small"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProjectConnection"
    };
}();
$430e1cf574aebe59$var$node.hash = "3eeb7301918e0096af7f6ae5ad2df33f";
var $430e1cf574aebe59$export$2e2bcd8739ae039 = $430e1cf574aebe59$var$node;

});

parcelRegister("5mrpn", function(module, exports) {
module.exports = new URL("../images/project-mapping-empty.93914303.svg", import.meta.url).toString();

});

parcelRegister("75fbt", function(module, exports) {
module.exports = new URL("../images/project-mapping-search-no-match.507a41ed.svg", import.meta.url).toString();

});

parcelRegister("3Feac", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => (parcelRequire("jqF5S")).useProjectMapping);

var $jqF5S = parcelRequire("jqF5S");

});
parcelRegister("jqF5S", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => $68ce97fa22392309$export$79a4e4154c8382d5);

var $31EKt = parcelRequire("31EKt");

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $6LH8a = parcelRequire("6LH8a");

var $3BZyK = parcelRequire("3BZyK");

var $5kxdi = parcelRequire("5kxdi");
const $68ce97fa22392309$export$79a4e4154c8382d5 = ()=>{
    const cloudId = (0, $6LH8a.getCloudId)();
    const helpCenterAri = (0, $5kxdi.useHelpCenterAri)();
    const [linkUnlinkProject] = (0, $3BZyK.useMutation)((0, $31EKt.default));
    const removeSelectedProjects = (0, $fc4bM.useCallback)((store, selection, projectIds)=>{
        var _root$getLinkedRecord;
        const root = store.getRoot();
        const connection = root === null || root === void 0 || (_root$getLinkedRecord = root.getLinkedRecord('jira')) === null || _root$getLinkedRecord === void 0 ? void 0 : _root$getLinkedRecord.getLinkedRecord('jiraProjectsMappedToHelpCenter', {
            cloudId: (0, $6LH8a.getCloudId)(),
            filter: {
                helpCenterId: '',
                helpCenterARI: helpCenterAri,
                helpCenterMappingStatus: selection
            }
        });
        if (connection) {
            const connectionEdges = connection === null || connection === void 0 ? void 0 : connection.getLinkedRecords('edges');
            if (connectionEdges) {
                const newEdges = connectionEdges.filter((edge)=>{
                    var _edge$getLinkedRecord;
                    return !projectIds.includes(edge === null || edge === void 0 || (_edge$getLinkedRecord = edge.getLinkedRecord('node')) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getValue('projectId'));
                });
                connection === null || connection === void 0 || connection.setLinkedRecords(newEdges, 'edges');
            }
        }
        root.invalidateRecord();
    }, [
        helpCenterAri
    ]);
    const onLinkUnlinkProjects = (projectIds, operationType, selection)=>{
        return new Promise((resolve, reject)=>linkUnlinkProject({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        projectIds: projectIds,
                        operationType: operationType
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) removeSelectedProjects(store, selection, projectIds);
                },
                onCompleted: (response)=>{
                    var _response$helpCenter2, _response$helpCenter3, _error$extensions;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateProjectMapping) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $9mazR.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    };
    return {
        onLinkUnlinkProjects: onLinkUnlinkProjects
    };
};

});
parcelRegister("31EKt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe3853d582884ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<230b086af7211b5fc150b7f52ae6b010>>
 * @relayHash db52eedba06b2bb692fa79d38cecc6eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f
const $6fe3853d582884ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f",
            "metadata": {},
            "name": "useProjectMappingLinkUnlinkMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6fe3853d582884ff$var$node.hash = "90453dabffd73b96361b3ab3d4d31c32";
var $6fe3853d582884ff$export$2e2bcd8739ae039 = $6fe3853d582884ff$var$node;

});



parcelRegister("8UbUN", function(module, exports) {
$parcel$export(module.exports, "LinkUnlinkProject", () => (parcelRequire("cSnLt")).default);

var $cSnLt = parcelRequire("cSnLt");

});
parcelRegister("cSnLt", function(module, exports) {
$parcel$export(module.exports, "default", () => $22861aa7d5107647$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $5kfOu = parcelRequire("5kfOu");

var $f4j2O = parcelRequire("f4j2O");
var $22861aa7d5107647$export$2e2bcd8739ae039 = (0, $6umft.default)(null, {
    showErrorFlag: $5kfOu.showErrorFlag,
    showSuccessFlag: $5kfOu.showSuccessFlag
})((0, $f4j2O.default));

});
parcelRegister("f4j2O", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ea7f85d9cc07147$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $k2M4v = parcelRequire("k2M4v");

var $4EPUx = parcelRequire("4EPUx");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $2SWSA = parcelRequire("2SWSA");

var $eef75 = parcelRequire("eef75");

var $aVQWM = parcelRequire("aVQWM");

var $eENmG = parcelRequire("eENmG");

var $lvRbB = parcelRequire("lvRbB");

var $c0Y6o = parcelRequire("c0Y6o");

var $cwWA0 = parcelRequire("cwWA0");

var $28WJA = parcelRequire("28WJA");

var $2x3xj = parcelRequire("2x3xj");
const $3ea7f85d9cc07147$var$LinkUnlinkProject = ({ projectId: projectId, projectName: projectName, selection: selection, isLastProject: isLastProject, isDisabled: isDisabled, onLinkUnlinkProjects: onLinkUnlinkProjects, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [openUnlinkDialog, setOpenUnlinkDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [isUnlinking, setIsUnlinking] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const [isLinking, setIsLinking] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const [isLastUnlink, setIsLastUnlink] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const onLinkProject = (0, $fc4bM.useCallback)(()=>{
        setIsLinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $28WJA.ProjectsMappingOperations).LINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                operation: 'single',
                bulkOperation: false,
                mapStatus: (0, $28WJA.ProjectsMappingOperations).LINK,
                projectCount: 1
            }).fire();
            showSuccessFlagAction((0, $2x3xj.default).linkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $28WJA.ProjectsMappingOperations).LINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            showErrorFlagAction((0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).linkErrorTitleGalaxia : (0, $2x3xj.default).linkErrorTitle, (0, $2x3xj.default).genericErrorDescription, [], {
                projectName: projectName
            });
        }).finally(()=>{
            setIsLinking(false);
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        selection,
        showSuccessFlagAction,
        projectName,
        showErrorFlagAction,
        createAnalyticsEvent
    ]);
    const onUnLinkProject = (0, $fc4bM.useCallback)(()=>{
        if (isLastProject) setIsLastUnlink(true);
        else setOpenUnlinkDialog(true);
    }, [
        isLastProject
    ]);
    const onUnlinkDialogButtonClick = (0, $fc4bM.useCallback)(()=>{
        setIsUnlinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $28WJA.ProjectsMappingOperations).UNLINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $28WJA.ProjectsMappingOperations).UNLINK,
                projectCount: 1
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showSuccessFlagAction((0, $2x3xj.default).unlinkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $28WJA.ProjectsMappingOperations).UNLINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showErrorFlagAction((0, $k2M4v.default).checkGate('itsm-project-renaming') ? (0, $2x3xj.default).unlinkErrorTitleGalaxia : (0, $2x3xj.default).unlinkErrorTitle, (0, $2x3xj.default).genericErrorDescription, [], {
                projectName: projectName
            });
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        projectName,
        selection,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent
    ]);
    const contentCallback = (0, $fc4bM.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eef75.ContextWrapper), {
            sourceType: (0, $aVQWM.INLINE_DIALOG),
            sourceName: "lastProjectUnlink"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $3ea7f85d9cc07147$var$unlinkDialogPopupStyles
        }, (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $2x3xj.default).lastProjectUnlinkGalaxia) : formatMessage((0, $2x3xj.default).lastProjectUnlink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvRbB.FireScreenEventOnMount), null));
    }, [
        formatMessage
    ]);
    const triggerCallback = (0, $fc4bM.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.LoadingButton), {
            ...triggerProps,
            appearance: "link",
            actionSubjectId: "projectUnLink",
            onClick: onUnLinkProject,
            isLoading: isLinking,
            isDisabled: isDisabled
        }, formatMessage((0, $2x3xj.default).projectsListUnlinkButtonText));
    }, [
        formatMessage,
        isLinking,
        onUnLinkProject,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, selection === (0, $28WJA.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        isOpen: isLastUnlink,
        onClose: ()=>setIsLastUnlink(false),
        placement: "bottom-end",
        zIndex: (0, $2SWSA.layers).modal(),
        content: contentCallback,
        trigger: triggerCallback
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.LoadingButton), {
        actionSubjectId: "projectLink",
        appearance: "link",
        onClick: onLinkProject,
        isLoading: isLinking,
        isDisabled: isDisabled
    }, formatMessage((0, $2x3xj.default).projectsListLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cwWA0.UnlinkConfirmationModal), {
        isOpen: openUnlinkDialog,
        onClose: ()=>setOpenUnlinkDialog(false),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: isUnlinking,
        numberOfProjects: 1
    }));
};
const $3ea7f85d9cc07147$var$unlinkDialogPopupStyles = (0, $kig2V.xcss)({
    maxWidth: '230px',
    padding: 'space.200'
});
var $3ea7f85d9cc07147$export$2e2bcd8739ae039 = $3ea7f85d9cc07147$var$LinkUnlinkProject;

});
parcelRegister("cwWA0", function(module, exports) {
$parcel$export(module.exports, "UnlinkConfirmationModal", () => $47b6947a22ced990$export$42f5f02e8155f94);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $gpjDl = parcelRequire("gpjDl");

var $k2M4v = parcelRequire("k2M4v");

var $2u7SO = parcelRequire("2u7SO");

var $dkw9k = parcelRequire("dkw9k");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $aqhKL = parcelRequire("aqhKL");
const $47b6947a22ced990$export$42f5f02e8155f94 = ({ isOpen: isOpen, onClose: onClose, onUnlink: onUnlink, isLoading: isLoading, projectName: projectName, numberOfProjects: numberOfProjects })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    let modalTitle;
    let modalDescription;
    if (numberOfProjects > 1) {
        modalTitle = (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $aqhKL.default).bulkUnlinkModalTitleGalaxia, {
            number: numberOfProjects
        }) : formatMessage((0, $aqhKL.default).bulkUnlinkModalTitle, {
            number: numberOfProjects
        });
        modalDescription = (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $aqhKL.default).bulkUnlinkModalDescGalaxia) : formatMessage((0, $aqhKL.default).bulkUnlinkModalDesc);
    } else {
        modalTitle = (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $aqhKL.default).unlinkModalTitleGalaxia) : formatMessage((0, $aqhKL.default).unlinkModalTitle);
        modalDescription = (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $aqhKL.default).unlinkModalDescGalaxia, {
            projectName: projectName
        }) : formatMessage((0, $aqhKL.default).unlinkModalDesc, {
            projectName: projectName
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), {
        appearance: "warning",
        testId: "help-center-unlink-modal-title"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, modalDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.LoadingButton), {
        onClick: onUnlink,
        isLoading: isLoading,
        appearance: "warning",
        actionSubjectId: "unlinkModalConfirmButton",
        testId: "unlink-modal-confirm-button"
    }, formatMessage((0, $aqhKL.default).unlinkModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.Button), {
        onClick: onClose,
        appearance: "subtle",
        actionSubjectId: "unlinkModalCancelButton"
    }, formatMessage((0, $aqhKL.default).unlinkModalCancelButton)))));
};

});
parcelRegister("aqhKL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3773994c4c5f3441$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $3773994c4c5f3441$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    unlinkModalTitle: {
        defaultMessage: 'Unlink this project?',
        description: 'Unlink project confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title'
    },
    unlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink this space?',
        description: 'Unlink space confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title-galaxia'
    },
    unlinkModalDesc: {
        defaultMessage: `All help resources from the project {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description'
    },
    unlinkModalDescGalaxia: {
        defaultMessage: `All help resources from the space {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description-galaxia'
    },
    bulkUnlinkModalTitle: {
        defaultMessage: 'Unlink {number} projects?',
        description: 'Unlink project confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title'
    },
    bulkUnlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink {number} spaces?',
        description: 'Unlink space confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title-galaxia'
    },
    bulkUnlinkModalDesc: {
        defaultMessage: `All help resources from these projects will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description'
    },
    bulkUnlinkModalDescGalaxia: {
        defaultMessage: `All help resources from these spaces will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description-galaxia'
    },
    unlinkModalConfirmButton: {
        defaultMessage: 'Unlink',
        description: 'Unlink project confirmation modal confirm button',
        id: 'projects.list.unlink.confirmation.modal.confirm.button'
    },
    unlinkModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Unlink project confirmation modal cancel button',
        id: 'projects.list.unlink.confirmation.modal.cancel.button'
    }
});

});


parcelRegister("28WJA", function(module, exports) {
$parcel$export(module.exports, "ProjectsMappingStatus", () => $f730088301b1c362$export$eaf9dd2a52d05588);
$parcel$export(module.exports, "ProjectsMappingMode", () => $f730088301b1c362$export$6998efd89043b35d);
$parcel$export(module.exports, "ProjectsMappingOperations", () => $f730088301b1c362$export$d0c0bb49dfced741);
var $f730088301b1c362$export$eaf9dd2a52d05588 = /*#__PURE__*/ function(ProjectsMappingStatus) {
    ProjectsMappingStatus["UNLINKED"] = "UNLINKED";
    ProjectsMappingStatus["LINKED"] = "LINKED";
    ProjectsMappingStatus["ALL"] = "ALL";
    return ProjectsMappingStatus;
}({});
var $f730088301b1c362$export$6998efd89043b35d = /*#__PURE__*/ function(ProjectsMappingMode) {
    ProjectsMappingMode["BULK"] = "bulk";
    ProjectsMappingMode["SINGLE"] = "single";
    return ProjectsMappingMode;
}({});
var $f730088301b1c362$export$d0c0bb49dfced741 = /*#__PURE__*/ function(ProjectsMappingOperations) {
    ProjectsMappingOperations["UNLINK"] = "UNMAP_PROJECTS";
    ProjectsMappingOperations["LINK"] = "MAP_PROJECTS";
    return ProjectsMappingOperations;
}({});

});

parcelRegister("2x3xj", function(module, exports) {
$parcel$export(module.exports, "default", () => $040cb2df2dad97dc$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $040cb2df2dad97dc$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.link.unlink.button.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.link.unlink.button.unlink.button.text'
    },
    unlinkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is no longer linked to this help center",
        description: 'Unlink space flag success title',
        id: 'projects.link.unlink.button.unlink.flag.success.title'
    },
    linkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is now linked to this help center",
        description: 'Success flag title shown after a space is linked to the help center',
        id: 'projects.link.unlink.button.link.flag.success.title'
    },
    bulkLinkSuccessTitle: {
        defaultMessage: '{number} projects are now linked to this help center',
        description: 'Bulk link project flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title'
    },
    bulkLinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces are now linked to this help center',
        description: 'Bulk link space flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title-galaxia'
    },
    bulkLinkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the selected projects",
        description: 'Bulk link project flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title'
    },
    bulkLinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the selected spaces",
        description: 'Bulk link space flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title-galaxia'
    },
    bulkUnlinkSuccessTitle: {
        defaultMessage: '{number} projects have been unlinked from this help center',
        description: 'Bulk unlink projects flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title'
    },
    bulkUnlinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces have been unlinked from this help center',
        description: 'Bulk unlink spaces flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title-galaxia'
    },
    bulkUnlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the selected projects",
        description: 'Bulk unlink projects flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title'
    },
    bulkUnlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the selected spaces",
        description: 'Bulk unlink spaces flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title-galaxia'
    },
    unlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the projects \u2018{projectName}\u2019",
        description: 'Unlink project flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title'
    },
    unlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the spaces \u2018{projectName}\u2019",
        description: 'Error flag title shown when a space could not be unlinked from the help center',
        id: 'projects.link.unlink.button.unlink.flag.error.title-galaxia'
    },
    linkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the project \u2019{projectName}\u2019",
        description: 'Error flag title shown when a project could not be linked to the help center',
        id: 'projects.link.unlink.button.link.flag.error.title'
    },
    linkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the space \u2018{projectName}\u2019",
        description: 'Error flag title shown when a space could not be linked to the help center',
        id: 'projects.link.unlink.button.link.flag.error.title-galaxia'
    },
    genericErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Unlink project flag error description',
        id: 'projects.link.unlink.button.flag.generic.error.description'
    },
    lastProjectUnlink: {
        defaultMessage: 'Your help center needs at least one linked project to ensure that your customers can access relevant information and resources.',
        description: 'Last project unlink project dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content'
    },
    lastProjectUnlinkGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space to ensure that your customers can access relevant information and resources.',
        description: 'Last space unlink space dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content-galaxia'
    }
});

});




parcelRegister("d0PP3", function(module, exports) {
$parcel$export(module.exports, "BulkActionToolbar", () => $2c25615201c5dfee$export$522b8308f1751ff5);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $gpjDl = parcelRequire("gpjDl");

var $4CS25 = parcelRequire("4CS25");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $28WJA = parcelRequire("28WJA");

var $195ui = parcelRequire("195ui");

var $HcXXD = parcelRequire("HcXXD");
const $2c25615201c5dfee$export$522b8308f1751ff5 = ({ selectedProjectsCount: selectedProjectsCount, selection: selection, onBulkActionClick: onBulkActionClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const isVisible = selectedProjectsCount > 0;
    const toolbarAccessibilityLabelMessage = isVisible ? formatMessage((0, $HcXXD.default).toolbarAccessibilityLabel) : '';
    const buttonText = selection === (0, $28WJA.ProjectsMappingStatus).LINKED ? formatMessage((0, $195ui.default).projectsListUnlinkButtonText) : formatMessage((0, $195ui.default).projectsListLinkButtonText);
    const actionSubjectId = selection === (0, $28WJA.ProjectsMappingStatus).LINKED ? 'bulkActionUnLinkButton' : 'bulkActionLinkButton';
    return isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $2c25615201c5dfee$var$bulkActionToolbarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        as: "span",
        xcss: $2c25615201c5dfee$var$projectsCountTextStyles,
        role: "status"
    }, formatMessage((0, $HcXXD.default).selectedProjectsText, {
        count: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $2c25615201c5dfee$var$invisibleA11yTitleStyles,
        tabIndex: -1
    }, toolbarAccessibilityLabelMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.LoadingButton), {
        testId: "bulk-action-button",
        actionSubjectId: actionSubjectId,
        onClick: onBulkActionClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CS25))), {
            label: buttonText,
            size: "small",
            spacing: "spacious"
        }),
        isLoading: isLoading,
        spacing: "compact"
    }, buttonText));
};
const $2c25615201c5dfee$var$bulkActionToolbarContainerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    width: '96%',
    top: 'space.0',
    left: '4%',
    backgroundColor: 'elevation.surface',
    zIndex: 'layer',
    color: 'color.text.subtle',
    paddingBlock: 'space.050',
    paddingInline: 'space.0',
    margin: 'space.0'
});
const $2c25615201c5dfee$var$projectsCountTextStyles = (0, $kig2V.xcss)({
    paddingRight: 'space.200'
});
const $2c25615201c5dfee$var$invisibleA11yTitleStyles = (0, $kig2V.xcss)({
    opacity: 0,
    position: 'absolute'
});

});
parcelRegister("4CS25", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8acf1a27a91c9466d89ec39a50a9bc59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35e49fcd25b4dd29$var$_react = $35e49fcd25b4dd29$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $35e49fcd25b4dd29$var$_iconNew = $35e49fcd25b4dd29$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $35e49fcd25b4dd29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-broken
 * Usage guidance:
 * Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35e49fcd25b4dd29$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $35e49fcd25b4dd29$var$_react.default.createElement($35e49fcd25b4dd29$var$_iconNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$35e49fcd25b4dd29$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $35e49fcd25b4dd29$var$_default = module.exports.default = $35e49fcd25b4dd29$var$LinkBrokenIcon;

});

parcelRegister("195ui", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4c229d2454e7db7$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $e4c229d2454e7db7$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    projectsListLinkedLozengeLabel: {
        defaultMessage: 'Linked',
        description: 'Projects list linked lozenge label',
        id: 'projects.list.linked.lozenge.label'
    },
    projectsListUnlinkedLozengeLabel: {
        defaultMessage: 'Unlinked',
        description: 'Projects list unlinked lozenge label',
        id: 'projects.list.unlinked.lozenge.label'
    },
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.list.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.list.unlink.button.text'
    },
    noUnlinkedProjectsDescription: {
        defaultMessage: "When you unlink projects, they\u2019ll appear here.",
        description: 'Projects list empty state description',
        id: 'projects.list.empty.description'
    },
    noUnlinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you unlink spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description',
        id: 'projects.list.empty.description-galaxia'
    },
    noUnlinkedProjectsTitle: {
        defaultMessage: 'All your projects are linked to this help center',
        description: 'Projects list empty state title',
        id: 'projects.list.empty.title'
    },
    noUnlinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces are linked to this help center',
        description: 'Empty state title shown in the spaces list when all spaces are linked to the help center',
        id: 'projects.list.empty.title-galaxia'
    },
    noLinkedProjectsDescription: {
        defaultMessage: "When you link projects, they\u2019ll appear here.",
        description: 'Projects list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab'
    },
    noLinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you link spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab-galaxia'
    },
    noLinkedProjectsTitle: {
        defaultMessage: 'All your projects have been unlinked from this help center',
        description: 'Projects list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab'
    },
    noLinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces have been unlinked from this help center',
        description: 'Spaces list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab-galaxia'
    },
    projectsListEmptySearchTitle: {
        defaultMessage: 'No projects found matching your search',
        description: 'Projects list empty search title',
        id: 'projects.list.empty.search.title'
    },
    projectsListEmptySearchTitleGalaxia: {
        defaultMessage: 'No spaces found matching your search',
        description: 'Spaces list empty search title',
        id: 'projects.list.empty.search.title-galaxia'
    },
    projectsListEmptySearchDescription: {
        defaultMessage: 'Try using specific project names or terms',
        description: 'Projects list empty search description',
        id: 'projects.list.empty.search.description'
    },
    projectsListEmptySearchDescriptionGalaxia: {
        defaultMessage: 'Try using specific space names or terms',
        description: 'Spaces list empty search description',
        id: 'projects.list.empty.search.description-galaxia'
    },
    selectAllProjectsCheckboxLabel: {
        defaultMessage: 'Select all projects',
        description: 'Checkbox label for selecting all projects',
        id: 'projects.list.select-all.projects.checkbox.label'
    },
    selectAllProjectsCheckboxLabelGalaxia: {
        defaultMessage: 'Select all spaces',
        description: 'Checkbox label for selecting all spaces',
        id: 'projects.list.select-all.projects.checkbox.label-galaxia'
    },
    selectProjectCheckboxLabel: {
        defaultMessage: 'Select project',
        description: 'Checkbox label for selecting a single project',
        id: 'projects.list.select.project.checkbox.label'
    },
    selectProjectCheckboxLabelGalaxia: {
        defaultMessage: 'Select space',
        description: 'Checkbox label for selecting a single space',
        id: 'projects.list.select.project.checkbox.label-galaxia'
    },
    columnHeaderSpace: {
        defaultMessage: 'Space',
        description: 'Spaces list column header space',
        id: 'spaces.list.column.header.space-galaxia'
    },
    columnHeaderLead: {
        defaultMessage: 'Lead',
        description: 'Spaces list column header lead',
        id: 'spaces.list.column.header.lead'
    },
    columnHeaderStatus: {
        defaultMessage: 'Status',
        description: 'Spaces list column header status',
        id: 'spaces.list.column.header.status'
    },
    columnHeaderActions: {
        defaultMessage: 'Actions',
        description: 'Spaces list column header actions',
        id: 'spaces.list.column.header.actions'
    }
});

});

parcelRegister("HcXXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $26399c2538f580ae$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $26399c2538f580ae$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    selectedProjectsText: {
        defaultMessage: '{count, plural, one {1 selected} other { # selected}}',
        description: 'Text for displaying selected projects count',
        id: 'projects-list.bulk-action-toolbar.selected-spaces-text'
    },
    toolbarAccessibilityLabel: {
        defaultMessage: 'Actions for selected items are available before the table.',
        description: 'Accessibility label for the toolbar',
        id: 'projects-list.bulk-action-toolbar.toolbar-accessibility-label'
    }
});

});


parcelRegister("43o50", function(module, exports) {
$parcel$export(module.exports, "UnlinkAllProjectsWarningModal", () => $aa5069eec31fb88e$export$b442637e98a0429b);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $gpjDl = parcelRequire("gpjDl");

var $k2M4v = parcelRequire("k2M4v");

var $2u7SO = parcelRequire("2u7SO");

var $dkw9k = parcelRequire("dkw9k");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $eef75 = parcelRequire("eef75");

var $aVQWM = parcelRequire("aVQWM");

var $lvRbB = parcelRequire("lvRbB");

var $6xO3g = parcelRequire("6xO3g");
const $aa5069eec31fb88e$export$b442637e98a0429b = ({ isOpen: isOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eef75.ContextWrapper), {
        sourceType: (0, $aVQWM.MODAL),
        sourceName: "helpCenterUnlinkAllWarning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), {
        testId: "help-center-unlink-all-projects-warning-modal-title"
    }, (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6xO3g.default).unlinkAllWarningModalTitleGalaxia) : formatMessage((0, $6xO3g.default).unlinkAllWarningModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, (0, $k2M4v.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6xO3g.default).unlinkAllWarningModalDescriptionGalaxia) : formatMessage((0, $6xO3g.default).unlinkAllWarningModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.Button), {
        onClick: onClose,
        appearance: "primary",
        actionSubjectId: "unlinkAllWarningModalOkButton"
    }, formatMessage((0, $6xO3g.default).unlinkAllWarningModalOkButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvRbB.FireScreenEventOnMount), null));
};

});
parcelRegister("6xO3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ddbfde70fca1048$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $2ddbfde70fca1048$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    unlinkAllWarningModalTitle: {
        defaultMessage: 'Your help center needs at least one linked project',
        description: 'Title of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.title'
    },
    unlinkAllWarningModalTitleGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space',
        description: 'Title of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.title-galaxia'
    },
    unlinkAllWarningModalDescription: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one project needs to be linked to your help center. Uncheck a project and try again.',
        description: 'Description of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.description'
    },
    unlinkAllWarningModalDescriptionGalaxia: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one space needs to be linked to your help center. Uncheck a space and try again.',
        description: 'Description of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.description-galaxia'
    },
    unlinkAllWarningModalOkButton: {
        defaultMessage: 'OK',
        description: 'Unlink all projects warning modal ok button',
        id: 'projects.list.unlink.all.warning.modal.ok.button'
    }
});

});





parcelRegister("kpBFl", function(module, exports) {
$parcel$export(module.exports, "SyncProjectsToggle", () => (parcelRequire("f84WP")).default);

var $f84WP = parcelRequire("f84WP");

});
parcelRegister("f84WP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d528b569fbb2b791$export$2e2bcd8739ae039);
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $5kfOu = parcelRequire("5kfOu");

var $fndzi = parcelRequire("fndzi");
var $d528b569fbb2b791$export$2e2bcd8739ae039 = (0, $6umft.default)(null, {
    showErrorFlag: $5kfOu.showErrorFlag,
    showSuccessFlag: $5kfOu.showSuccessFlag
})((0, $fndzi.default));

});
parcelRegister("fndzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7b6478228fac727$export$2e2bcd8739ae039);

var $geQrc = parcelRequire("geQrc");

var $68D0z = parcelRequire("68D0z");

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $jEubQ = parcelRequire("jEubQ");

var $kTVlm = parcelRequire("kTVlm");

var $jtb5V = parcelRequire("jtb5V");

var $k2M4v = parcelRequire("k2M4v");

var $2u7SO = parcelRequire("2u7SO");

var $dkw9k = parcelRequire("dkw9k");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $ew1lT = parcelRequire("ew1lT");

var $eENmG = parcelRequire("eENmG");

var $c0Y6o = parcelRequire("c0Y6o");

var $cBXWW = parcelRequire("cBXWW");

var $5kxdi = parcelRequire("5kxdi");

var $7OoqG = parcelRequire("7OoqG");
const $b7b6478228fac727$var$SyncProjectsToggle = ({ syncProjectsToggleFragmentKey: syncProjectsToggleFragmentKey, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    var _helpCenterData$proje;
    const helpCenterData = (0, $3BZyK.useFragment)((0, $68D0z.default), syncProjectsToggleFragmentKey);
    const [isChecked, setIsChecked] = (0, $fc4bM.useState)(!!(helpCenterData !== null && helpCenterData !== void 0 && (_helpCenterData$proje = helpCenterData.projectMappingData) !== null && _helpCenterData$proje !== void 0 && _helpCenterData$proje.syncNewProjects));
    const [isRemoveMappingDialogOpen, setRemoveMappingDialogOpen] = (0, $fc4bM.useState)(false);
    const [isUnSyncing, setIsUnSyncing] = (0, $fc4bM.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const helpCenterAri = (0, $5kxdi.useHelpCenterAri)();
    const { isHelpHub: isHelpHub } = (0, $cBXWW.useHelpCenterType)();
    const isProjectRenamingEnabled = (0, $k2M4v.default).checkGate('itsm-project-renaming');
    let toggleLabel;
    if (isHelpHub && isProjectRenamingEnabled) toggleLabel = (0, $7OoqG.default).defaultMappingToggleLabelGalaxiaHelpHub;
    else if (isHelpHub) toggleLabel = (0, $7OoqG.default).defaultMappingToggleLabelHelpHub;
    else if (isProjectRenamingEnabled) toggleLabel = (0, $7OoqG.default).defaultMappingToggleLabelGalaxia;
    else toggleLabel = (0, $7OoqG.default).defaultMappingToggleLabel;
    const [toggleDefaultSync] = (0, $3BZyK.useMutation)((0, $geQrc.default));
    const onToggleDefault = (0, $fc4bM.useCallback)((syncNewProjects)=>{
        return new Promise((resolve, reject)=>toggleDefaultSync({
                variables: {
                    cloudId: (0, $6LH8a.getCloudId)(),
                    input: {
                        syncNewProjects: syncNewProjects,
                        helpCenterAri: helpCenterAri
                    }
                },
                onCompleted: (response)=>{
                    var _response$helpCenter, _response$helpCenter2;
                    if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) resolve(response);
                    const errors = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.errors;
                    const error = errors && errors.length > 0 ? errors[0] : new Error('Unknown error');
                    return reject(error);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    }, [
        toggleDefaultSync,
        helpCenterAri
    ]);
    const onToggleChange = (0, $fc4bM.useCallback)(()=>{
        if (isChecked) setRemoveMappingDialogOpen(true);
        else {
            setIsChecked(true);
            onToggleDefault(true).then(()=>{
                createAnalyticsEvent({
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    action: 'map',
                    actionSubject: 'newProjects',
                    toggleState: true
                }).fire();
            }).catch((error)=>{
                const { message: message, status: status } = error;
                setIsChecked(false);
                const errorTitle = isProjectRenamingEnabled ? (0, $7OoqG.default).syncErrorTitleGalaxia : (0, $7OoqG.default).syncErrorTitle;
                showErrorFlagAction(errorTitle, (0, $7OoqG.default).syncErrorDescription);
                if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    action: 'map_failed',
                    actionSubject: 'newProjects',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
            });
        }
    }, [
        isChecked,
        onToggleDefault,
        showErrorFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const onUnMapNewProjects = (0, $fc4bM.useCallback)(()=>{
        setIsUnSyncing(true);
        onToggleDefault(false).then(()=>{
            setIsChecked(false);
            const successTitle = isProjectRenamingEnabled ? (0, $7OoqG.default).unSyncSuccessTitleGalaxia : (0, $7OoqG.default).unSyncSuccessTitle;
            showSuccessFlagAction(successTitle);
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'newProjects',
                toggleState: false
            }).fire();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            const errorTitle = isProjectRenamingEnabled ? (0, $7OoqG.default).syncErrorTitleGalaxia : (0, $7OoqG.default).syncErrorTitle;
            showErrorFlagAction(errorTitle, (0, $7OoqG.default).syncErrorDescription);
            if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'newProjects',
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsUnSyncing(false);
            setRemoveMappingDialogOpen(false);
        });
    }, [
        onToggleDefault,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const modalTitle = isProjectRenamingEnabled ? (0, $7OoqG.default).removeMappingModalTitleGalaxia : (0, $7OoqG.default).removeMappingModalTitle;
    const modalDesc = isProjectRenamingEnabled ? (0, $7OoqG.default).removeMappingModalDescGalaxia : (0, $7OoqG.default).removeMappingModalDesc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ew1lT.default), {
        label: formatMessage(toggleLabel),
        isChecked: isChecked,
        onChange: onToggleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, isRemoveMappingDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        width: "small",
        onClose: ()=>setRemoveMappingDialogOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), {
        testId: "help-center-UnSync-modal-title"
    }, formatMessage(modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, formatMessage(modalDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jtb5V.default), {
        onClick: onUnMapNewProjects,
        isLoading: isUnSyncing,
        appearance: "primary",
        testId: "help-center-modal-unSync-button"
    }, formatMessage((0, $7OoqG.default).removeMappingModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTVlm.default), {
        onClick: ()=>setRemoveMappingDialogOpen(false),
        appearance: "subtle"
    }, formatMessage((0, $7OoqG.default).removeMappingModalCancelButton))))));
};
var $b7b6478228fac727$export$2e2bcd8739ae039 = $b7b6478228fac727$var$SyncProjectsToggle;

});
parcelRegister("geQrc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b64d8bc8dfd5dd36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3ec556de9df1e0dfa8527df888279ca>>
 * @relayHash f6ad0a674b4deb767396c24696d6bb4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d
const $b64d8bc8dfd5dd36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterProjectMappingUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateProjectMapping",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d",
            "metadata": {},
            "name": "syncProjectsToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b64d8bc8dfd5dd36$var$node.hash = "f63e31632e8452ce88ba847207c9b4ff";
var $b64d8bc8dfd5dd36$export$2e2bcd8739ae039 = $b64d8bc8dfd5dd36$var$node;

});

parcelRegister("68D0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $928eddb43fc307e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40debfdc71cc42750e08210b725892e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $928eddb43fc307e3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "syncProjectsToggleFragment",
    "selections": [
        {
            "concreteType": "HelpCenterProjectMappingData",
            "kind": "LinkedField",
            "name": "projectMappingData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "syncNewProjects"
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$928eddb43fc307e3$var$node.hash = "b09d61797a2afad5be65329bfb50cc92";
var $928eddb43fc307e3$export$2e2bcd8739ae039 = $928eddb43fc307e3$var$node;

});

parcelRegister("ew1lT", function(module, exports) {
$parcel$export(module.exports, "default", () => $7600ae1407e56791$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $7iKPB = parcelRequire("7iKPB");

var $9JZL9 = parcelRequire("9JZL9");

var $3zBNx = parcelRequire("3zBNx");

var $jaqgn = parcelRequire("jaqgn");

var $gV8E5 = parcelRequire("gV8E5");

var $dRkX9 = parcelRequire("dRkX9");

var $hculA = parcelRequire("hculA");

var $dVxDa = parcelRequire("dVxDa");

var $d8Mc7 = parcelRequire("d8Mc7");
const $7600ae1407e56791$var$LOADING_LABEL = ', Loading';
const $7600ae1407e56791$var$baseStyles = null;
const $7600ae1407e56791$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
};
/**
 * Slider knob translate transforms per size, applied when checked.
 */ const $7600ae1407e56791$var$checkedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
};
/**
 * Applied when the toggle is checked
 */ const $7600ae1407e56791$var$checkedStyles = null;
/**
 * Applied when the toggle is checked and not disabled.
 */ const $7600ae1407e56791$var$checkedHoveredStyles = null;
/**
 * Applied when the toggle is unchecked and not disabled.
 */ const $7600ae1407e56791$var$uncheckedHoveredStyles = null;
/**
 * Applied when the toggle is disabled.
 */ const $7600ae1407e56791$var$disabledStyles = null;
// Keep the focus border instant; only the track and its handle participate in motion.
const $7600ae1407e56791$var$motionStyles = null;
const $7600ae1407e56791$var$disabledMotionStyles = null;
const $7600ae1407e56791$var$checkedPressedStyles = null;
const $7600ae1407e56791$var$uncheckedPressedStyles = null;
const $7600ae1407e56791$var$inputStyles = null;
const $7600ae1407e56791$var$noop = (0, $9JZL9.default);
const $7600ae1407e56791$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $7600ae1407e56791$var$Toggle = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $7600ae1407e56791$var$noop, onChange: providedChange = $7600ae1407e56791$var$noop, onFocus: providedFocus = $7600ae1407e56791$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $fc4bM.useState)(defaultChecked);
    const loadingLabelId = (0, $3zBNx.useId)();
    const handleBlur = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$7600ae1407e56791$var$analyticsAttributes
    });
    const handleFocus = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$7600ae1407e56791$var$analyticsAttributes
    });
    const handleChange = (0, $7iKPB.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$7600ae1407e56791$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const hasMotion = (0, $dRkX9.fg)('platform_design_system_toggle_motion');
    const labelId = (0, $3zBNx.useId)();
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("label", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_v564c7pe _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _rfx31qll _pdykc7pe _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            $7600ae1407e56791$var$sizeStyles[size],
            shouldChecked && "_bfhkkcmj",
            shouldChecked && $7600ae1407e56791$var$checkedSliderStyles[size],
            !isDisabled && shouldChecked && "_irr3y7x8",
            !isDisabled && !shouldChecked && "_irr31ibz",
            hasMotion && "_1reo15vq _18m915vq _v56419ec _pdyk19ec _1e8eglyw _146iglyw _1h74glyw",
            hasMotion && !isDisabled && shouldChecked && "_1di6wcbh",
            hasMotion && !isDisabled && !shouldChecked && "_1di6of27",
            hasMotion && isDisabled && "_v564glyw _pdykglyw",
            isDisabled && "_bfhk187o _syaz2sac _80om13gf"
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$7600ae1407e56791$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $3LM7S.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId,
                className: (0, $2R2iS.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
                ])
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d8Mc7.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                hasMotion: hasMotion,
                isDisabled: isDisabled,
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jaqgn))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $d8Mc7.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                hasMotion: hasMotion,
                isDisabled: isDisabled,
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hculA.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dVxDa.default), {
                id: loadingLabelId,
                children: $7600ae1407e56791$var$LOADING_LABEL
            })
        ]
    });
}));
$7600ae1407e56791$var$Toggle.displayName = 'Toggle';
var $7600ae1407e56791$export$2e2bcd8739ae039 = $7600ae1407e56791$var$Toggle;

});
parcelRegister("d8Mc7", function(module, exports) {
$parcel$export(module.exports, "default", () => $31474f08cb744a33$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* icon-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $dBtOK = parcelRequire("dBtOK");
const $31474f08cb744a33$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    motion: "_v56419ec _1kxtbrmi _6pgpglyw",
    noMotion: "_v564glyw",
    outsideRight: "_t9ecxwn4",
    outsideLeft: "_t9ecjq3t",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $31474f08cb744a33$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position, hasMotion: hasMotion, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        as: "span",
        xcss: (0, $4Cnkn.cx)($31474f08cb744a33$var$styles.iconContainer, hasMotion && $31474f08cb744a33$var$styles.motion, hasMotion && isDisabled && $31474f08cb744a33$var$styles.noMotion, // Icons enter and exit at their nearest track edge, travelling with the handle.
        hasMotion && isHidden && position === 'left' && $31474f08cb744a33$var$styles.outsideLeft, hasMotion && isHidden && position === 'right' && $31474f08cb744a33$var$styles.outsideRight, isHidden && $31474f08cb744a33$var$styles.hidden, size === 'regular' && $31474f08cb744a33$var$styles.iconContainerRegular, size === 'large' && $31474f08cb744a33$var$styles.iconContainerLarge, position === 'left' && $31474f08cb744a33$var$styles.left, position === 'right' && $31474f08cb744a33$var$styles.right),
        children: children
    });
};
var $31474f08cb744a33$export$2e2bcd8739ae039 = $31474f08cb744a33$var$IconContainer;

});


parcelRegister("7OoqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ead44b82ec9bae$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $14ead44b82ec9bae$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    defaultMappingToggleLabel: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label'
    },
    defaultMappingToggleLabelHelpHub: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping for help center',
        id: 'sync.project.toggle.label.helphub'
    },
    defaultMappingToggleLabelGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping for help center with Galaxia renaming',
        id: 'sync.project.toggle.label.galaxia.helphub'
    },
    defaultMappingToggleLabelGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label-galaxia'
    },
    removeMappingModalTitle: {
        defaultMessage: 'Stop linking new projects to this help center?',
        description: 'Confirmation modal title asking whether to stop auto-linking new projects to the help center',
        id: 'sync.project.toggle.removeMapping.modal.title'
    },
    removeMappingModalTitleGalaxia: {
        defaultMessage: 'Stop linking new spaces to this help center?',
        description: 'Confirmation modal title asking whether to stop auto-linking new spaces to the help center',
        id: 'sync.project.toggle.removeMapping.modal.title-galaxia'
    },
    removeMappingModalDesc: {
        defaultMessage: 'Help resources from new projects will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description'
    },
    removeMappingModalDescGalaxia: {
        defaultMessage: 'Help resources from new spaces will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description-galaxia'
    },
    removeMappingModalConfirmButton: {
        defaultMessage: 'Continue',
        description: 'removeMapping modal confirm button',
        id: 'sync.project.toggle.removeMapping.modal.confirm'
    },
    removeMappingModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'removeMapping modal cancel button',
        id: 'sync.project.toggle.removeMapping.modal.cancel'
    },
    syncErrorTitle: {
        defaultMessage: "We couldn't turn off automatic linking of new projects",
        description: 'Sync new projects flag error title',
        id: 'sync.project.toggle.sync.flag.error.title'
    },
    syncErrorTitleGalaxia: {
        defaultMessage: "We couldn't turn off automatic linking of new spaces",
        description: 'Sync new spaces flag error title',
        id: 'sync.project.toggle.sync.flag.error.title-galaxia'
    },
    syncErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Sync new projects flag error description',
        id: 'sync.project.toggle.sync.flag.error.description'
    },
    unSyncSuccessTitle: {
        defaultMessage: 'Automatic linking of new projects turned off',
        description: 'Sync new projects flag success title',
        id: 'sync.project.toggle.sync.flag.success.title'
    },
    unSyncSuccessTitleGalaxia: {
        defaultMessage: 'Automatic linking of new spaces turned off',
        description: 'Sync new spaces flag success title',
        id: 'sync.project.toggle.sync.flag.success.title-galaxia'
    }
});

});






parcelRegister("7JIA1", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManagePages", () => $a0365e7bb01d04eb$export$ede7df3d2ca0e51e);

var $fc4bM = parcelRequire("fc4bM");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

var $6Nd92 = parcelRequire("6Nd92");
parcelRequire("evfUT");
var $2oyaj = parcelRequire("2oyaj");

var $k8QSI = parcelRequire("k8QSI");
parcelRequire("iaDYO");
var $58pmw = parcelRequire("58pmw");

const $a0365e7bb01d04eb$var$AsyncHelpCenterManagePagesComponent = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("gQPdA")), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/manage-pages.tsx"
    }),
    LoadingSkeleton: (0, $58pmw.default)
});
const $a0365e7bb01d04eb$export$ede7df3d2ca0e51e = ()=>{
    (0, $6Nd92.useUFOComponentExperience)((0, $k8QSI.managePagesExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2oyaj.default), {
        featureName: "Helpcenter manage pages"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a0365e7bb01d04eb$var$AsyncHelpCenterManagePagesComponent, null));
};

});
parcelRegister("k8QSI", function(module, exports) {
$parcel$export(module.exports, "managePagesExperience", () => $c062ed98c9abf5c9$export$5b30dfd9ef11a3c5);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $c062ed98c9abf5c9$export$5b30dfd9ef11a3c5 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.managePagesExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("iaDYO", function(module, exports) {
$parcel$export(module.exports, "ManagePagesLayoutSkeleton", () => (parcelRequire("58pmw")).default);

var $58pmw = parcelRequire("58pmw");

});
parcelRegister("58pmw", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e62eefb6552f04a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bsIOe = parcelRequire("bsIOe");

var $aRwom = parcelRequire("aRwom");

var $1JdzP = parcelRequire("1JdzP");

var $5a4EU = parcelRequire("5a4EU");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $l5kZr = parcelRequire("l5kZr");
const $8e62eefb6552f04a$var$ManagePagesLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                key: 'page-name',
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PAGE_HEAD_WIDTH)['page-name']
            },
            {
                key: 'last-updated',
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PAGE_HEAD_WIDTH)['last-updated']
            },
            {
                key: 'page-description',
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PAGE_HEAD_WIDTH)['page-description']
            },
            {
                key: 'action-button',
                content: /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $l5kZr.MANAGE_PAGE_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 20
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
                        width: "20%",
                        height: "20px"
                    }))
                }
            ]
        }));
    return /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-title-skeleton"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-create-button-skeleton"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "75%",
        height: "20px"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        xcss: $8e62eefb6552f04a$var$tableSkeletonStyles
    }, /*#__PURE__*/ $fc4bM.createElement((0, $aRwom.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true
    })));
};
const $8e62eefb6552f04a$var$tableSkeletonStyles = (0, $kig2V.xcss)({
    pointerEvents: 'none'
});
var $8e62eefb6552f04a$export$2e2bcd8739ae039 = $8e62eefb6552f04a$var$ManagePagesLayoutSkeleton;

});


parcelRegister("gQPdA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("lkCe3"),
    $9dnsd("3KK3D"),
    $9dnsd("6Df0C"),
    $9dnsd("fBb8F")
]).then(()=>parcelRequire('hG13N'));

});




parcelRegister("abuEW", function(module, exports) {
$parcel$export(module.exports, "HelpCenterRovoServiceAgentResource", () => $3c818c4cd1ea2c0d$export$edd09dd027b459f5);

var $6LH8a = parcelRequire("6LH8a");

var $8zK3E = parcelRequire("8zK3E");

var $8BDrU = parcelRequire("8BDrU");

var $gNSS4 = parcelRequire("gNSS4");
const $3c818c4cd1ea2c0d$export$edd09dd027b459f5 = (0, $8zK3E.createRelayResource)({
    type: 'HELP_ROVO_SERVICE_AGENT_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const activationId = (0, $6LH8a.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const computedHelpCenterAri = (0, $8BDrU.createHelpCenterAri)(activationId, helpCenterId);
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $gNSS4.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("gNSS4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f2677bf3dadde66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2026eb7695890747f87168577d7f7d36>>
 * @relayHash e8ae7ab32189fb155478d43e63c3f190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b
const $4f2677bf3dadde66$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCustomAgentsAvailable"
            },
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b",
            "metadata": {},
            "name": "srcRovoServiceAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4f2677bf3dadde66$var$node.hash = "31b851fb2037198c36030d97e7f1d665";
var $4f2677bf3dadde66$export$2e2bcd8739ae039 = $4f2677bf3dadde66$var$node;

});


parcelRegister("kdCQx", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bUE4p"),
    $9dnsd("f9Aw7"),
    $9dnsd("bgU0d")
]).then(()=>parcelRequire('2Hwjg'));

});


parcelRegister("dQIQC", function(module, exports) {
$parcel$export(module.exports, "helpcenterEditRoute", () => $ccdeb5b77cba66cf$export$8c1389d3983434c);
$parcel$export(module.exports, "helpcenterManageProjectsRoute", () => $ccdeb5b77cba66cf$export$5fae61522b3dcb33);
$parcel$export(module.exports, "helpcenterManageCustomPagesRoute", () => $ccdeb5b77cba66cf$export$d1e5a4952efbcb);
$parcel$export(module.exports, "hubEditLayoutRoute", () => $ccdeb5b77cba66cf$export$8f54556241df66cd);
$parcel$export(module.exports, "hubEditPortalLayoutRoute", () => $ccdeb5b77cba66cf$export$b97f195684a7c2a4);

var $fc4bM = parcelRequire("fc4bM");

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");

var $kQeCR = parcelRequire("kQeCR");
parcelRequire("evfUT");
var $2oyaj = parcelRequire("2oyaj");

var $8Yydp = parcelRequire("8Yydp");

const $ccdeb5b77cba66cf$var$AsyncHelpCenterEditDetailsPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>Promise.resolve((parcelRequire("cI6pQ"))).then(({ HelpCenterEditDetails: HelpCenterEditDetails })=>HelpCenterEditDetails), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/edit-helpcenter/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $ccdeb5b77cba66cf$var$AsyncHelpCenterManageProjectsPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>Promise.resolve((parcelRequire("cu3fi"))).then(({ HelpCenterManageProjects: HelpCenterManageProjects })=>HelpCenterManageProjects), {
        moduleId: "./packages/admin-layout/src/ui/manage-projects/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $ccdeb5b77cba66cf$var$AsyncHelpCenterManageCustomPagesPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>Promise.resolve((parcelRequire("7JIA1"))).then(({ HelpCenterManagePages: HelpCenterManagePages })=>HelpCenterManagePages), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $ccdeb5b77cba66cf$var$AsyncHubEditLayoutComponent = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("QO5tP")).then(({ HubEditLayout: HubEditLayout })=>HubEditLayout), {
        ssr: false,
        moduleId: "./packages/admin-layout/src/ui/hub-edit-layout/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2oyaj.AdminManagementLayoutLoader), {
            hideSidebar: true
        })
});
const $ccdeb5b77cba66cf$export$8c1389d3983434c = {
    name: 'edit-details',
    path: '/:helpcenterId/details',
    exact: true,
    component: (0, $7tc2B.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kQeCR.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ccdeb5b77cba66cf$var$AsyncHelpCenterEditDetailsPage, null)))
};
const $ccdeb5b77cba66cf$export$5fae61522b3dcb33 = {
    name: 'manage-projects',
    path: '/:helpcenterId/projects',
    exact: true,
    component: (0, $7tc2B.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kQeCR.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ccdeb5b77cba66cf$var$AsyncHelpCenterManageProjectsPage, null)))
};
const $ccdeb5b77cba66cf$export$d1e5a4952efbcb = {
    name: 'manage-pages',
    path: '/:helpcenterId/pages',
    exact: true,
    component: (0, $7tc2B.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kQeCR.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ccdeb5b77cba66cf$var$AsyncHelpCenterManageCustomPagesPage, null)))
};
const $ccdeb5b77cba66cf$export$8f54556241df66cd = {
    name: 'edit-hub',
    path: '/:helpcenterId/edit-hub/:pageId?',
    exact: true,
    resources: [
        (0, $8Yydp.EditLayoutResource)
    ],
    component: (0, $7tc2B.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kQeCR.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ccdeb5b77cba66cf$var$AsyncHubEditLayoutComponent, null)))
};
const $ccdeb5b77cba66cf$export$b97f195684a7c2a4 = {
    name: 'edit-hub-portal',
    path: '/:helpcenterId/edit-hub/portal/:portalId',
    exact: true,
    resources: [
        (0, $8Yydp.EditLayoutResource)
    ],
    component: (0, $7tc2B.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kQeCR.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ccdeb5b77cba66cf$var$AsyncHubEditLayoutComponent, null)))
};

});
parcelRegister("kQeCR", function(module, exports) {
$parcel$export(module.exports, "JiraAdminPermissionWrapper", () => $2bf7cdc9461035c8$export$6061a3ec828d7435);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");

var $80yPZ = parcelRequire("80yPZ");
const $2bf7cdc9461035c8$export$6061a3ec828d7435 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }), (0, $aylSc.default)({
        message: formatMessage((0, $80yPZ.authPageMessage)),
        callToActionText: formatMessage((0, $80yPZ.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};

});

parcelRegister("8Yydp", function(module, exports) {
$parcel$export(module.exports, "EditLayoutResource", () => $5c06603d40d3b899$export$e44f9c093dbfbb53);

var $6LH8a = parcelRequire("6LH8a");

var $4MoYu = parcelRequire("4MoYu");
var $gK5mb = parcelRequire("gK5mb");

var $k2M4v = parcelRequire("k2M4v");

var $jWHud = parcelRequire("jWHud");

var $8zK3E = parcelRequire("8zK3E");

var $2RiEH = parcelRequire("2RiEH");
const $5c06603d40d3b899$var$HUB_EXTENSION_MANAGE_TRANSLATIONS = 'hub_extension_manage_translations';
const $5c06603d40d3b899$var$HUB_TRANSLATIONS_SAVE_DEFAULT_LANG = 'hub_translations_save_default_lang';
const $5c06603d40d3b899$var$HUBS_TRANSLATION_PORTAL_LANG = 'hubs_translation_portal_lang';
const $5c06603d40d3b899$var$HELP_HUBS_CONFIGURABLE_SITE_TREE = 'help_hubs_configurable_site_tree';
const $5c06603d40d3b899$var$HUBS_PREMIUM_UPSELL = 'hubs_premium_upsell';
const $5c06603d40d3b899$export$f170ab873a147b4a = (match)=>{
    if ((0, $k2M4v.default).checkGate('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.pageId || '';
};
const $5c06603d40d3b899$export$e44f9c093dbfbb53 = (0, $8zK3E.createRelayResource)({
    type: 'EDIT_HUB_LAYOUT',
    getQuery: ({ match: match }, { cloudId: cloudId })=>{
        const activationId = (0, $6LH8a.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const pageId = $5c06603d40d3b899$export$f170ab873a147b4a(match);
        const computedHelpCenterAri = (0, $4MoYu.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        const resolvedPageId = pageId || helpCenterId;
        const computedPageAri = (0, $jWHud.isPortalPage)(resolvedPageId) && helpCenterId ? (0, $jWHud.buildPortalPageAri)(computedHelpCenterAri, resolvedPageId) : (0, $gK5mb.HelpPageAri).create({
            activationId: activationId,
            pageId: resolvedPageId
        }).toString();
        const isDraft = (0, $k2M4v.default).checkGate('help_hubs_draft_mode');
        const isConfigurableSiteTreeEnabled = (0, $k2M4v.default).checkGate($5c06603d40d3b899$var$HELP_HUBS_CONFIGURABLE_SITE_TREE);
        // Gates the hub's topic pages query; see hub-home's Topics section.
        const isTopicsEnabled = (0, $k2M4v.default).checkGate($5c06603d40d3b899$var$HUBS_PREMIUM_UPSELL);
        const includeLayoutTranslations = (0, $k2M4v.default).checkGate($5c06603d40d3b899$var$HUB_EXTENSION_MANAGE_TRANSLATIONS);
        const includeTranslatableBlocksSchema = (0, $k2M4v.default).checkGate($5c06603d40d3b899$var$HUB_TRANSLATIONS_SAVE_DEFAULT_LANG);
        return {
            parameters: (0, $2RiEH.default),
            variables: {
                cloudId: cloudId,
                isDraft: isDraft,
                isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
                isTopicsEnabled: isTopicsEnabled,
                includeLayoutTranslations: includeLayoutTranslations,
                includeTranslatableBlocksSchema: includeTranslatableBlocksSchema,
                isPortalPage: (0, $k2M4v.default).checkGate($5c06603d40d3b899$var$HUBS_TRANSLATION_PORTAL_LANG) && (0, $jWHud.isPortalPage)(resolvedPageId),
                hubAri: computedHelpCenterAri,
                hubEditMode: true,
                pageAri: computedPageAri,
                // When false the field is not requested, so help-kosh never resolves it and no call
                // reaches convo-ai. The editor gates consumption separately on the help center's own
                // `type`, since this route's `:helpcenterId` is what decides which one is being edited.
                rovoConfigFromKosh: (0, $k2M4v.default).checkGate('hubs_rovo_config_from_kosh')
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("2RiEH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5669cac21226147$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<646a0e9370caa7fec09c8f29b9b3ec14>>
 * @relayHash 2fd94b428a02a25c83980fb4d16ba68c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f4f759aa0ceb29478398e947fc13ff4afbbe2764f17eba2d9e9a0480df9ff12

var $35cD2 = parcelRequire("35cD2");

var $5KQKg = parcelRequire("5KQKg");
const $a5669cac21226147$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeLayoutTranslations"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeTranslatableBlocksSchema"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isConfigurableSiteTreeEnabled"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPortalPage"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isTopicsEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "rovoConfigFromKosh"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v13 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "hubAri"
    }, v14 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v15 = [
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "basePath"
    }, v17 = {
        "kind": "Variable",
        "name": "pageAri",
        "variableName": "pageAri"
    }, v18 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "isPublished"
    }, v22 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v23 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ ,
            v21 /*: any*/ ,
            v23 /*: any*/ 
        ],
        "type": "HelpCenterPage"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v26 = {
        "kind": "ScalarField",
        "name": "type"
    }, v27 = {
        "kind": "ScalarField",
        "name": "cornerRadius"
    }, v28 = {
        "concreteType": "HelpCenterNavigationBar",
        "kind": "LinkedField",
        "name": "navigationBar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "backgroundColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderType"
            },
            v27 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "padding"
            },
            {
                "kind": "ScalarField",
                "name": "positionType"
            },
            {
                "kind": "ScalarField",
                "name": "textColor"
            }
        ]
    }, v29 = [
        v20 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": v22 /*: any*/ 
        },
        {
            "condition": "isDraft",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v30 = {
        "kind": "ScalarField",
        "name": "extensionType"
    }, v31 = {
        "kind": "ScalarField",
        "name": "locale"
    }, v32 = [
        v31 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        }
    ], v33 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v34 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v16 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "hubAri",
                                    "variableName": "hubAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeLayoutTranslations",
                                    "variableName": "includeLayoutTranslations"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeTranslatableBlocksSchema",
                                    "variableName": "includeTranslatableBlocksSchema"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isConfigurableSiteTreeEnabled",
                                    "variableName": "isConfigurableSiteTreeEnabled"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "isPortalPage",
                                    "variableName": "isPortalPage"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isTopicsEnabled",
                                    "variableName": "isTopicsEnabled"
                                },
                                v17 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v17 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v11 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__ishidenavmenusenabledrelayproviderts"
                }
            ],
            "kind": "Operation",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterSiteTree",
                                                    "kind": "LinkedField",
                                                    "name": "siteTree",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterFolder",
                                                            "kind": "LinkedField",
                                                            "name": "root",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contents",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpCenterFolderName",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "name",
                                                                                            "plural": false,
                                                                                            "selections": v22 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "contents",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "nodes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpCenterFolder"
                                                                                },
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__ishidenavmenusenabledrelayproviderts",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBranding",
                                                    "kind": "LinkedField",
                                                    "name": "helpCenterBranding",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterNavigationBar",
                                                            "kind": "LinkedField",
                                                            "name": "navigationBar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hiddenMenus"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasUnpublishedChanges"
                                        },
                                        v26 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hoistedProjectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": v22 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "allPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": []
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v29 /*: any*/ ,
                                            "storageKey": "pages(filter:{\"ids\":[]})"
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "customPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "CUSTOM"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v29 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "topicPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "TOPIC"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v29 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeTranslatableBlocksSchema",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "homePage",
                                                    "args": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "items": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "ids.0",
                                                                            "variableName": "hubAri"
                                                                        }
                                                                    ],
                                                                    "kind": "ListValue",
                                                                    "name": "ids"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "CUSTOM_HOME"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "filter"
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "pageType"
                                                        },
                                                        {
                                                            "concreteType": "HelpCenterPageLayout",
                                                            "kind": "LinkedField",
                                                            "name": "pageLayout",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdf",
                                                                    "kind": "LinkedField",
                                                                    "name": "layoutAdf",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterTranslatableBlock",
                                                                            "kind": "LinkedField",
                                                                            "name": "translatableBlocksSchema",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "blockType"
                                                                                },
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "HelpCenterTranslatableField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "path"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "kind"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "arrayKey"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "idField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeLayoutTranslations",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "siteDefaultLanguageTag"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isPortalPage",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "includeLayoutTranslations",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterAnnouncements",
                                                            "kind": "LinkedField",
                                                            "name": "announcements",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterAnnouncement",
                                                                    "kind": "LinkedField",
                                                                    "name": "homePageAnnouncements",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterTranslation",
                                                                            "kind": "LinkedField",
                                                                            "name": "nameTranslationsRaw",
                                                                            "plural": true,
                                                                            "selections": v32 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "HelpCenterTranslation",
                                                                            "kind": "LinkedField",
                                                                            "name": "descriptionTranslationsRaw",
                                                                            "plural": true,
                                                                            "selections": v32 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        {
                                            "alias": "currentPage",
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "items": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "ids.0",
                                                                    "variableName": "pageAri"
                                                                }
                                                            ],
                                                            "kind": "ListValue",
                                                            "name": "ids"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isEditMode",
                                                            "variableName": "hubEditMode"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "filter"
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "condition": "rovoConfigFromKosh",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterPageRovoConfig",
                                                            "kind": "LinkedField",
                                                            "name": "rovoConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCustomAgentsAvailable"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isRovoEnabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "agentId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "widgetContainerAri"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterPageLayout",
                                                    "kind": "LinkedField",
                                                    "name": "pageLayout",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterLayoutAdf",
                                                            "kind": "LinkedField",
                                                            "name": "layoutAdf",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdfContentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpCenterLayoutAdfContent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "content"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterBrandingTypography",
                                                    "kind": "LinkedField",
                                                    "name": "typography",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "headingFont"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "bodyFont"
                                                        }
                                                    ]
                                                },
                                                v27 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "spaceDensity"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v25 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpCenterQueryResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "alias": "pageMediaConfig",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "pageAri"
                                },
                                v14 /*: any*/ ,
                                v33 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v34 /*: any*/ 
                        },
                        {
                            "condition": "includeLayoutTranslations",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "parentAri",
                                            "variableName": "pageAri"
                                        }
                                    ],
                                    "concreteType": "HelpCenterHubLayoutTranslations",
                                    "kind": "LinkedField",
                                    "name": "layoutTranslations",
                                    "plural": true,
                                    "selections": [
                                        v31 /*: any*/ ,
                                        {
                                            "concreteType": "HelpCenterHubTranslationBlock",
                                            "kind": "LinkedField",
                                            "name": "blocks",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "localId"
                                                },
                                                v30 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterHubTranslationField",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldPath"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v14 /*: any*/ ,
                                v33 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v34 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                v18 /*: any*/ ,
                                v20 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4f4f759aa0ceb29478398e947fc13ff4afbbe2764f17eba2d9e9a0480df9ff12",
            "metadata": {},
            "name": "hubHomeContentWrapperQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__ishidenavmenusenabledrelayproviderts": (0, $35cD2.default)
            }
        }
    };
}();
$a5669cac21226147$var$node.hash = "0fc92620708f15e3c894ea86558d9ac4";
(0, $5KQKg.PreloadableQueryRegistry).set($a5669cac21226147$var$node.params.id, $a5669cac21226147$var$node);
var $a5669cac21226147$export$2e2bcd8739ae039 = $a5669cac21226147$var$node;

});
parcelRegister("35cD2", function(module, exports) {
$parcel$export(module.exports, "default", () => $514464429cc70eb1$export$2e2bcd8739ae039);

var $dRkX9 = parcelRequire("dRkX9");
var $514464429cc70eb1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dRkX9.fg)('help_hubs_hide_nav_menus');
    }
};

});



parcelRegister("cI6pQ", function(module, exports) {
$parcel$export(module.exports, "HelpCenterEditDetails", () => (parcelRequire("3Kvpd")).default);

var $3Kvpd = parcelRequire("3Kvpd");

});
parcelRegister("3Kvpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $f401c621fea45ff2$export$2e2bcd8739ae039);

var $kvJBy = parcelRequire("kvJBy");

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $iya1I = parcelRequire("iya1I");

var $6LH8a = parcelRequire("6LH8a");

var $hnTdV = parcelRequire("hnTdV");

var $aYMdQ = parcelRequire("aYMdQ");

var $gpjDl = parcelRequire("gpjDl");

var $3BZyK = parcelRequire("3BZyK");

var $3TJLC = parcelRequire("3TJLC");

var $613oU = parcelRequire("613oU");

var $jEubQ = parcelRequire("jEubQ");

var $DpObF = parcelRequire("DpObF");

var $5a4EU = parcelRequire("5a4EU");

var $jVMDF = parcelRequire("jVMDF");

var $7yidP = parcelRequire("7yidP");
parcelRequire("62zSr");
var $2oyaj = parcelRequire("2oyaj");
var $5kxdi = parcelRequire("5kxdi");
parcelRequire("kY5US");
var $3NpCI = parcelRequire("3NpCI");

var $eef75 = parcelRequire("eef75");

var $aVQWM = parcelRequire("aVQWM");

var $eENmG = parcelRequire("eENmG");

var $lvRbB = parcelRequire("lvRbB");

var $c0Y6o = parcelRequire("c0Y6o");

var $uYmrU = parcelRequire("uYmrU");

var $6Nd92 = parcelRequire("6Nd92");
parcelRequire("2gN40");
var $2XPHc = parcelRequire("2XPHc");
parcelRequire("c8xDG");
var $c8dSp = parcelRequire("c8dSp");

var $NCC7B = parcelRequire("NCC7B");

var $afSin = parcelRequire("afSin");
const $f401c621fea45ff2$var$HelpCenterEditDetailsComponent = ()=>{
    var _data$helpCenter, _data$helpCenter2, _data$helpCenter3;
    const cloudId = (0, $6LH8a.getCloudId)();
    const helpCenterAri = (0, $5kxdi.useHelpCenterAri)();
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $kvJBy.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const helpCenter = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const { name: name, slug: slug, id: id } = helpCenter ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eef75.ContextWrapper), {
        sourceName: (0, $9mazR.ScreenName).EDIT_HELP_CENTER,
        sourceType: (0, $aVQWM.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), null, (data === null || data === void 0 || (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3NpCI.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2XPHc.default), {
        helpCenterToEdit: {
            translations: name && name.translations ? name.translations.map((translation)=>({
                    value: (translation === null || translation === void 0 ? void 0 : translation.value) ?? '',
                    locale: (translation === null || translation === void 0 ? void 0 : translation.locale) ?? ''
                })) : [],
            slug: slug ?? '',
            name: (name === null || name === void 0 ? void 0 : name.default) ?? '',
            ari: id ?? ''
        },
        isStandaloneForm: true,
        isOpen: true,
        onClose: (0, $aYMdQ.noop)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $uYmrU.ExperienceSuccess), {
        experience: (0, $NCC7B.editHelpCenterExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvRbB.FireScreenEventOnMount), null));
};
const $f401c621fea45ff2$export$613b634f86450035 = ()=>{
    (0, $6Nd92.useUFOComponentExperience)((0, $NCC7B.editHelpCenterExperience));
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) {
            (0, $NCC7B.editHelpCenterExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $aYMdQ.noop)).catch((0, $aYMdQ.noop));
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'helpCenterDetails',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $DpObF.default), {
            header: formatMessage((0, $afSin.default).errorTitle),
            description: formatMessage((0, $afSin.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hnTdV)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2oyaj.default), {
        featureName: "Helpcenter settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: (0, $9mazR.ScreenName).EDIT_HELP_CENTER,
        id: 'help-center-edit-details',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                workspaceAri: (0, $6LH8a.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jVMDF.Grid), {
        templateColumns: "1fr 2fr 1fr",
        rowGap: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c8dSp.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f401c621fea45ff2$var$HelpCenterEditDetailsComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null)))));
};
var $f401c621fea45ff2$export$2e2bcd8739ae039 = (0, $613oU.default)({
    component: 'helpCenterEditDetails'
})($f401c621fea45ff2$export$613b634f86450035);

});
parcelRegister("kvJBy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f08e7a6fc67b377$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9ac0204ca94c5ca5bd93a55bfdd44c6f>>
 * @relayHash efdc5420deee34a8cc05fb680adbe347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0
const $4f08e7a6fc67b377$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            },
            {
                "concreteType": "HelpCenterTranslation",
                "kind": "LinkedField",
                "name": "translations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "locale"
                    }
                ]
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "slug"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0",
            "metadata": {},
            "name": "editHelpCenter_getHelpcenterById_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4f08e7a6fc67b377$var$node.hash = "b3bd596bd547f6d09044149b39e767e6";
var $4f08e7a6fc67b377$export$2e2bcd8739ae039 = $4f08e7a6fc67b377$var$node;

});

parcelRegister("2gN40", function(module, exports) {
$parcel$export(module.exports, "HelpCenterForm", () => (parcelRequire("2XPHc")).default);

var $2XPHc = parcelRequire("2XPHc");

});
parcelRegister("2XPHc", function(module, exports) {
$parcel$export(module.exports, "default", () => $10cc62ba9331eb6f$export$2e2bcd8739ae039);
/* help-center-form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $MPQAF = parcelRequire("MPQAF");

var $5kfOu = parcelRequire("5kfOu");

var $6LH8a = parcelRequire("6LH8a");

var $9VJCP = parcelRequire("9VJCP");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");

var $3TJLC = parcelRequire("3TJLC");

var $jEubQ = parcelRequire("jEubQ");

var $613oU = parcelRequire("613oU");

var $e8E8t = parcelRequire("e8E8t");

var $9Zxa0 = parcelRequire("9Zxa0");

var $1hJdJ = parcelRequire("1hJdJ");

var $gV8E5 = parcelRequire("gV8E5");

var $2u7SO = parcelRequire("2u7SO");

var $dkw9k = parcelRequire("dkw9k");

var $8qwF5 = parcelRequire("8qwF5");

var $2NqAY = parcelRequire("2NqAY");

var $5t2KI = parcelRequire("5t2KI");

var $ggkex = parcelRequire("ggkex");

var $5a4EU = parcelRequire("5a4EU");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");
parcelRequire("62zSr");
var $4OGFc = parcelRequire("4OGFc");

var $eENmG = parcelRequire("eENmG");

var $4MoYu = parcelRequire("4MoYu");

var $aIVqJ = parcelRequire("aIVqJ");

var $7lN8e = parcelRequire("7lN8e");

var $c0Y6o = parcelRequire("c0Y6o");

var $kNP6K = parcelRequire("kNP6K");
parcelRequire("c9AFw");
var $9TsDB = parcelRequire("9TsDB");

var $9zPPf = parcelRequire("9zPPf");
parcelRequire("5CEo4");
var $5PdqK = parcelRequire("5PdqK");
parcelRequire("2Pz3t");
var $77v0t = parcelRequire("77v0t");

var $13Jvf = parcelRequire("13Jvf");
const $10cc62ba9331eb6f$var$MODAL_WIDTH = '506px';
const $10cc62ba9331eb6f$var$HelpCenterForm = ({ onClose: onClose, isOpen: isOpen, helpCenterToEdit: helpCenterToEdit, isStandaloneForm: isStandaloneForm = false, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { createHelpCenter: createHelpCenter, updateHelpCenter: updateHelpCenter } = (0, $9TsDB.useHelpCenter)();
    const displayUrl = (0, $7lN8e.getEnv)().baseUrl.replace(/^https?:\/\//i, '');
    const { slug: slug, name: name } = helpCenterToEdit || {};
    const detailsDescription = (0, $4OGFc.useConditionalMessage)((0, $13Jvf.default).helpHubDetailsPageDescription, (0, $13Jvf.default).helpCenterDetailsPageDescription);
    const { push: push } = (0, $8whFx.useRouterActions)();
    const successFlagAction = (0, $fc4bM.useCallback)((helpCenterSlug)=>[
            {
                contentNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("a", {
                    href: `${(0, $7lN8e.getEnv)().baseUrl}/helpcenter/${helpCenterSlug}`
                }, formatMessage((0, $13Jvf.default).helpCenterAddSuccessDesc))
            }
        ], [
        formatMessage
    ]);
    const onCreate = (0, $fc4bM.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9zPPf.addHelpCenterExperience).start();
        return createHelpCenter({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        }).then((response)=>{
            var _response$helpCenter;
            createAnalyticsEvent({
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'created',
                actionSubject: 'helpCenter',
                helpCenterAri: (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 || (_response$helpCenter = _response$helpCenter.createHelpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterAri
            }).fire();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $9zPPf.addHelpCenterExperience).success();
            onClose();
            setTimeout(()=>{
                var _response$helpCenter2;
                showSuccessFlagAction((0, $13Jvf.default).helpCenterAddSuccessTitleText, {
                    value: helpCenterName
                }, undefined, successFlagAction(helpCenterSlug));
                const helpCenterAri = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.createHelpCenter) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.helpCenterAri;
                const { helpCenterId: helpCenterId } = (0, $4MoYu.HelpHelpCenterAri).parse(helpCenterAri || '');
                push(`/${helpCenterId}/projects`);
            }, 1000);
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $kNP6K.HARD_LIMIT_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $13Jvf.default).helpCenterHardLimitErrorTitle, (0, $13Jvf.default).helpCenterHardLimitErrorDescription, undefined, undefined, {
                value: message
            });
            else if (message === (0, $kNP6K.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $13Jvf.default).helpCenterAddErrorTitle, (0, $13Jvf.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $kNP6K.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $13Jvf.default).helpCenterAddErrorTitle, (0, $13Jvf.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $13Jvf.default).helpCenterAddErrorTitle, (0, $13Jvf.default).helpCenterGenericErrorDesc);
            if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    action: 'create_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $9zPPf.addHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $aIVqJ.getErrorData)(message)
                    }
                });
            }
            return (0, $9zPPf.addHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        createHelpCenter,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        successFlagAction
    ]);
    const onEdit = (0, $fc4bM.useCallback)(({ helpCenterName: helpCenterName, helpCenterTranslations: helpCenterTranslations, helpCenterSlug: helpCenterSlug, helpCenterAri: helpCenterAri })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9zPPf.updateHelpCenterExperience).start();
        return updateHelpCenter({
            helpCenterAri: helpCenterAri,
            helpCenterName: helpCenterName,
            helpCenterTranslations: helpCenterTranslations,
            helpCenterSlug: helpCenterSlug
        }).then(()=>{
            createAnalyticsEvent({
                helpCenterAri: helpCenterAri,
                analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'helpCenter'
            }).fire();
            showSuccessFlagAction((0, $13Jvf.default).helpCenterUpdateSuccessTitleText, {
                value: helpCenterName ? helpCenterName : name
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $9zPPf.updateHelpCenterExperience).success();
            if (isStandaloneForm) push('/');
            else onClose();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $kNP6K.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $13Jvf.default).helpCenterUpdateErrorTitle, (0, $13Jvf.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $kNP6K.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $13Jvf.default).helpCenterUpdateErrorTitle, (0, $13Jvf.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $13Jvf.default).helpCenterUpdateErrorTitle, (0, $13Jvf.default).helpCenterGenericErrorDesc);
            if (!(0, $c0Y6o.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    helpCenterAri: helpCenterAri,
                    analyticsType: (0, $eENmG.TRACK_EVENT_TYPE),
                    action: 'update_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $9zPPf.updateHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $aIVqJ.getErrorData)(message)
                    }
                });
            }
            return (0, $9zPPf.updateHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        name,
        isStandaloneForm,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        updateHelpCenter
    ]);
    const onSubmit = (0, $fc4bM.useCallback)((data)=>{
        const { name: helpCenterName, slug: helpCenterSlug } = data;
        if (!helpCenterToEdit) return onCreate({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        });
        const { ari: ari, translations: translations } = helpCenterToEdit;
        return onEdit({
            helpCenterName: helpCenterName !== name ? helpCenterName : undefined,
            helpCenterSlug: helpCenterSlug !== slug ? helpCenterSlug : undefined,
            helpCenterAri: ari,
            helpCenterTranslations: translations
        });
    }, [
        helpCenterToEdit,
        name,
        onCreate,
        onEdit,
        slug
    ]);
    // used in settings page without a modal
    if (isStandaloneForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e8E8t.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, dirty: dirty, submitting: submitting, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
            size: "large"
        }, formatMessage((0, $13Jvf.default).helpCenterDetailsPageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, slug ? formatMessage(detailsDescription) : formatMessage((0, $13Jvf.default).defaultHelpCenterDetailsPageDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            paddingBlock: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), null, formatMessage((0, $13Jvf.default).helpCenterRequiredFieldsWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Zxa0.RequiredAsterisk), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5PdqK.HelpCenterFormFields), {
            mode: "EDIT",
            name: name,
            slug: slug,
            urlWithoutSlug: `${window.location.hostname}/helpcenter`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $77v0t.HelpCenterFormFooter), {
            mode: "EDIT",
            isStandaloneForm: true,
            isCancelDisabled: !dirty,
            submitting: submitting,
            onCancel: ()=>reset({
                    name: name ?? '',
                    slug: slug ?? ''
                })
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ggkex.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: {
            attributes: {
                workspaceAri: (0, $6LH8a.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2u7SO.default), {
        onClose: onClose,
        width: $10cc62ba9331eb6f$var$MODAL_WIDTH,
        testId: "help-centers-management-form-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e8E8t.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($10cc62ba9331eb6f$var$HelpForm, formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2NqAY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5t2KI.default), {
            testId: "help-centers-management-modal-title"
        }, formatMessage(!helpCenterToEdit ? (0, $13Jvf.default).helpCenterCreateFormTitle : (0, $13Jvf.default).helpCenterEditFormTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.Button), {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
            "aria-label": "Cancel create dialog",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
                spacing: "spacious",
                label: "cancel create dialog"
            }),
            onClick: onClose,
            actionSubjectId: "helpCenterCreateDialogCancelButton"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dkw9k.default), null, !helpCenterToEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($10cc62ba9331eb6f$var$DescriptionWrapper, null, formatMessage((0, $13Jvf.default).helpCenterCreateFormDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5PdqK.HelpCenterFormFields), {
            mode: !helpCenterToEdit ? 'CREATE' : 'EDIT',
            name: name,
            slug: slug,
            urlWithoutSlug: `${displayUrl}/helpcenter`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8qwF5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $77v0t.HelpCenterFormFooter), {
            submitting: submitting,
            onCancel: onClose,
            mode: helpCenterToEdit ? 'EDIT' : 'CREATE'
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9VJCP.default), {
        preventNavigation: isOpen
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $10cc62ba9331eb6f$var$DescriptionWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_otyrv47k",
            __cmplp.className
        ])
    });
});
const $10cc62ba9331eb6f$var$HelpForm = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});
var $10cc62ba9331eb6f$export$2e2bcd8739ae039 = (0, $6umft.default)(null, {
    showErrorFlag: $5kfOu.showErrorFlag,
    showSuccessFlag: $5kfOu.showSuccessFlag
})((0, $613oU.default)({
    component: 'helpCenterForm'
})($10cc62ba9331eb6f$var$HelpCenterForm));

});
parcelRegister("9VJCP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9d9b2fae3edc561$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $esgVk = parcelRequire("esgVk");

var $jZexQ = parcelRequire("jZexQ");

var $lEn0Q = parcelRequire("lEn0Q");
class $b9d9b2fae3edc561$export$5e156bf0bd6195af extends $fc4bM.PureComponent {
    componentDidMount() {
        if (this.props.preventNavigation) this.blockNavigation();
    }
    componentWillUnmount() {
        if (this.props.preventNavigation) this.allowNavigation();
    }
    componentDidUpdate(prevProps) {
        const { preventNavigation: preventNavigation } = this.props;
        if (preventNavigation && !prevProps.preventNavigation) this.blockNavigation();
        else if (!preventNavigation && prevProps.preventNavigation) this.allowNavigation();
    }
    render() {
        const { preventNavigation: preventNavigation, onBeforeNavigate: onBeforeNavigate } = this.props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $lEn0Q.default), {
            when: preventNavigation,
            message: this.checkCanNavigate,
            onBeforeNavigate: onBeforeNavigate
        });
    }
    constructor(...args){
        super(...args), this.checkCanNavigate = (routerLocation)=>{
            // This will cause the prompt to not prevent navigation if a "q" was, or is, going to be in the location search property.
            // Because we do that it will fail to prevent accidental navigation if interacting with the back button,
            // or pressing backspace/delete. We have another issue to pick up to make this better.
            // See: https://jdog.jira-dev.com/browse/FSD-3235
            const containsSearchQueryParam = (str)=>str.includes('q=');
            if (containsSearchQueryParam(routerLocation.search) || containsSearchQueryParam((0, $esgVk.location)().search)) return true;
            /**
     * Do not show prevent navigation prompt for allowed paths
     */ const { allowedPaths: allowedPaths } = this.props;
            const { pathname: pathname } = routerLocation;
            if (allowedPaths) for (const pathRegExp of allowedPaths){
                if (pathname.match(pathRegExp)) return true;
            }
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $jZexQ.default).navigationWarning);
        }, this.onBeforeUnload = (event)=>{
            // Prompts the user before closing the page, see:
            // https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
            event.preventDefault();
            event.returnValue = '';
        }, this.blockNavigation = ()=>{
            window.addEventListener('beforeunload', this.onBeforeUnload);
        }, this.allowNavigation = ()=>{
            window.removeEventListener('beforeunload', this.onBeforeUnload);
        };
    }
}
var $b9d9b2fae3edc561$export$2e2bcd8739ae039 = (0, $fcCIH.default)($b9d9b2fae3edc561$export$5e156bf0bd6195af);

});
parcelRegister("jZexQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fa91aab013314a7$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $1fa91aab013314a7$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    navigationWarning: {
        defaultMessage: 'You have unsubmitted changes. Are you sure you want to leave?',
        description: 'Messsage shown to users when they navigate away from a form that has been filled out.',
        id: 'cv.navigation.prompt.warning'
    }
});

});

parcelRegister("lEn0Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f092474a59405fc$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("a3Wd7");
var $8whFx = parcelRequire("8whFx");
const $7f092474a59405fc$var$NavBlocker = ({ when: when, message: message, onBeforeNavigate: onBeforeNavigate })=>{
    const { registerBlock: registerBlock } = (0, $8whFx.useRouterActions)();
    (0, $fc4bM.useEffect)(()=>{
        const unRegisterBlock = registerBlock((location)=>{
            if (!when) return true;
            const result = message(location);
            if (typeof result === 'boolean') return result;
            //RRR doesn't support async block, so we cannot use our custom dialog here.
            //We need to fallback to using browser's confirm like react-router's prompt.
            // oxlint-disable-next-line no-alert
            const confirmation = window.confirm(result);
            if (confirmation && onBeforeNavigate) onBeforeNavigate(location);
            return confirmation;
        });
        return unRegisterBlock;
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registerBlock,
        when
    ]);
    return null;
};
var $7f092474a59405fc$export$2e2bcd8739ae039 = $7f092474a59405fc$var$NavBlocker;

});


parcelRegister("kNP6K", function(module, exports) {
$parcel$export(module.exports, "BANNER_PREVIEW_WIDTH", () => $83349d2ddda41383$export$69656aaf76d15223);
$parcel$export(module.exports, "CARD_HEIGHT", () => $83349d2ddda41383$export$17f5f15729f028ea);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $83349d2ddda41383$export$780035d9fe48eb32);
$parcel$export(module.exports, "HELPCENTER_NAME_CHARACTER_LIMIT", () => $83349d2ddda41383$export$60a11b99c333dc54);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH", () => $83349d2ddda41383$export$434ed9a0808b5e5e);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_PER_FETCH", () => $83349d2ddda41383$export$81026eacb893b971);
$parcel$export(module.exports, "SORT_ORDER", () => $83349d2ddda41383$export$d33cb9b119034d29);
$parcel$export(module.exports, "HARD_LIMIT_HELP_CENTERS_MESSAGE", () => $83349d2ddda41383$export$2426c5658dae9870);
$parcel$export(module.exports, "RESERVED_TERM_HELP_CENTERS_MESSAGE", () => $83349d2ddda41383$export$b7e744b1154b89ed);
$parcel$export(module.exports, "ALREADY_EXISTED_HELP_CENTERS_MESSAGE", () => $83349d2ddda41383$export$20efc88db71ca642);
$parcel$export(module.exports, "HARD_LIMIT_HELP_HUBS_MESSAGE", () => $83349d2ddda41383$export$78070db85cc402de);
const $83349d2ddda41383$export$69656aaf76d15223 = '170px';
const $83349d2ddda41383$export$17f5f15729f028ea = '176px';
const $83349d2ddda41383$export$780035d9fe48eb32 = 240;
const $83349d2ddda41383$export$60a11b99c333dc54 = 30;
const $83349d2ddda41383$export$434ed9a0808b5e5e = 20;
const $83349d2ddda41383$export$81026eacb893b971 = 10;
const $83349d2ddda41383$export$d33cb9b119034d29 = 'CREATED_DATE_DESCENDING';
const $83349d2ddda41383$export$2426c5658dae9870 = 'This operation is not supported : Help Center limit exceeded';
const $83349d2ddda41383$export$b7e744b1154b89ed = `The slug you've entered contains a reserved term. Try again with a different slug.`;
const $83349d2ddda41383$export$20efc88db71ca642 = `A help center with this slug already exists on your site. Try again with a different slug.`;
const $83349d2ddda41383$export$78070db85cc402de = 'This operation is not supported : Help Hub limit exceeded';

});

parcelRegister("c9AFw", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => (parcelRequire("9TsDB")).useHelpCenter);

var $9TsDB = parcelRequire("9TsDB");

});
parcelRegister("9TsDB", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => $21dc920b4b042ec3$export$4545b8e2508a7415);

var $9zpsm = parcelRequire("9zpsm");

var $3G0Ae = parcelRequire("3G0Ae");

var $4Mo3v = parcelRequire("4Mo3v");

var $fc4bM = parcelRequire("fc4bM");

var $9mazR = parcelRequire("9mazR");

var $6LH8a = parcelRequire("6LH8a");

var $3BZyK = parcelRequire("3BZyK");

var $5KQKg = parcelRequire("5KQKg");

var $7lN8e = parcelRequire("7lN8e");
const $21dc920b4b042ec3$export$4545b8e2508a7415 = ()=>{
    const cloudId = (0, $6LH8a.getCloudId)();
    const workspaceAri = (0, $6LH8a.getWorkspaceAri)();
    const [helpCenterCreateMutation] = (0, $3BZyK.useMutation)((0, $4Mo3v.default));
    const [helpCenterUpdateMutation] = (0, $3BZyK.useMutation)((0, $3G0Ae.default));
    const [helpCenterDeleteMutation] = (0, $3BZyK.useMutation)((0, $9zpsm.default));
    const getHelpCenter = (0, $fc4bM.useCallback)((store)=>{
        const root = store.getRoot();
        const helpCenter = root.getLinkedRecord('helpCenter', {
            cloudId: cloudId
        });
        return helpCenter;
    }, [
        cloudId
    ]);
    const getHelpCenterList = (0, $fc4bM.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (0, $5KQKg.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const getHelpCenters = (0, $fc4bM.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            var _ConnectionHandler$ge;
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (_ConnectionHandler$ge = (0, $5KQKg.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters')) === null || _ConnectionHandler$ge === void 0 ? void 0 : _ConnectionHandler$ge.getLinkedRecords('edges');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const deleteHelpCenter = (0, $fc4bM.useCallback)(({ helpCenterAri: helpCenterAri })=>{
        return new Promise((resolve, reject)=>helpCenterDeleteMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.deleteHelpCenter) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) {
                        const helpCenters = getHelpCenters(store);
                        const helpCentersList = getHelpCenterList(store);
                        if (helpCenters && helpCentersList) {
                            const updatedHelpCenters = [
                                ...helpCenters.filter((helpCenterRecord)=>{
                                    const node = helpCenterRecord.getLinkedRecord('node');
                                    return (node === null || node === void 0 ? void 0 : node.getValue('id')) !== helpCenterAri;
                                })
                            ];
                            helpCentersList === null || helpCentersList === void 0 || helpCentersList.setLinkedRecords(updatedHelpCenters, 'edges');
                        }
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter2, _response$helpCenter3;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.deleteHelpCenter) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) return resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.deleteHelpCenter) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {};
                    return reject(error);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterDeleteMutation
    ]);
    const createHelpCenter = (0, $fc4bM.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug, helpCenterType: helpCenterType, projectMapping: projectMapping, rovoConfig: rovoConfig })=>{
        return new Promise((resolve, reject)=>helpCenterCreateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterType: helpCenterType,
                        projectMapping: projectMapping,
                        rovoConfig: rovoConfig,
                        workspaceARI: workspaceAri,
                        name: {
                            default: helpCenterName,
                            translations: [
                                {
                                    locale: (0, $7lN8e.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        },
                        slug: helpCenterSlug
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter4, _response$helpCenter5;
                    if (response !== null && response !== void 0 && (_response$helpCenter4 = response.helpCenter) !== null && _response$helpCenter4 !== void 0 && (_response$helpCenter4 = _response$helpCenter4.createHelpCenter) !== null && _response$helpCenter4 !== void 0 && _response$helpCenter4.success && response !== null && response !== void 0 && (_response$helpCenter5 = response.helpCenter) !== null && _response$helpCenter5 !== void 0 && (_response$helpCenter5 = _response$helpCenter5.createHelpCenter) !== null && _response$helpCenter5 !== void 0 && _response$helpCenter5.helpCenterAri) {
                        var _response$helpCenter6;
                        const helpCenters = getHelpCenters(store);
                        const helpCenterList = getHelpCenterList(store);
                        const node = store.create((0, $5KQKg.generateUniqueClientID)(), 'node');
                        const helpCenterRecord = store.create((0, $5KQKg.generateUniqueClientID)(), 'HelpCenter');
                        const name = store.create((0, $5KQKg.generateUniqueClientID)(), 'HelpCenterName');
                        const branding = store.create((0, $5KQKg.generateUniqueClientID)(), 'HelpCenterBranding');
                        name.setValue(helpCenterName, 'default');
                        branding.setValue(true, 'useDefaultBanner');
                        helpCenterRecord.setLinkedRecord(name, 'name');
                        helpCenterRecord.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        helpCenterRecord === null || helpCenterRecord === void 0 || helpCenterRecord.setValue(date, 'lastUpdated');
                        helpCenterRecord.setValue((_response$helpCenter6 = response.helpCenter) === null || _response$helpCenter6 === void 0 || (_response$helpCenter6 = _response$helpCenter6.createHelpCenter) === null || _response$helpCenter6 === void 0 ? void 0 : _response$helpCenter6.helpCenterAri, 'id');
                        helpCenterRecord.setLinkedRecord(branding, 'helpCenterBranding');
                        node.setLinkedRecord(helpCenterRecord, 'node');
                        const updatedHelpCenters = [
                            node,
                            ...helpCenters ?? []
                        ];
                        if (helpCenters && helpCenterList) helpCenterList.setLinkedRecords(updatedHelpCenters, 'edges');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter7, _response$helpCenter8, _error$extensions;
                    if ((_response$helpCenter7 = response.helpCenter) !== null && _response$helpCenter7 !== void 0 && (_response$helpCenter7 = _response$helpCenter7.createHelpCenter) !== null && _response$helpCenter7 !== void 0 && _response$helpCenter7.success) return resolve(response);
                    const errors = (_response$helpCenter8 = response.helpCenter) === null || _response$helpCenter8 === void 0 || (_response$helpCenter8 = _response$helpCenter8.createHelpCenter) === null || _response$helpCenter8 === void 0 ? void 0 : _response$helpCenter8.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $9mazR.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterCreateMutation,
        workspaceAri
    ]);
    const updateHelpCenter = (0, $fc4bM.useCallback)(({ helpCenterAri: helpCenterAri, helpCenterTranslations: helpCenterTranslations, helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        return new Promise((resolve, reject)=>helpCenterUpdateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        name: helpCenterName ? {
                            default: helpCenterName,
                            translations: helpCenterTranslations && helpCenterTranslations.length > 0 ? helpCenterTranslations.map((translations)=>{
                                if (translations.locale === (0, $7lN8e.getEnv)().siteDefaultLanguageTag) translations.value = helpCenterName;
                                return translations;
                            }) : [
                                {
                                    locale: (0, $7lN8e.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        } : undefined,
                        slug: helpCenterSlug ? helpCenterSlug : undefined
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter9;
                    if (response !== null && response !== void 0 && (_response$helpCenter9 = response.helpCenter) !== null && _response$helpCenter9 !== void 0 && (_response$helpCenter9 = _response$helpCenter9.updateHelpCenter) !== null && _response$helpCenter9 !== void 0 && _response$helpCenter9.success) {
                        const helpCenters = getHelpCenters(store);
                        const currentHelpCenter = helpCenters === null || helpCenters === void 0 ? void 0 : helpCenters.find((helpCenter)=>{
                            const node = helpCenter.getLinkedRecord('node');
                            return (node === null || node === void 0 ? void 0 : node.getValue('id')) === helpCenterAri;
                        });
                        const currentHelpCenterNode = currentHelpCenter === null || currentHelpCenter === void 0 ? void 0 : currentHelpCenter.getLinkedRecord('node');
                        if (helpCenterName) {
                            const name = currentHelpCenterNode === null || currentHelpCenterNode === void 0 ? void 0 : currentHelpCenterNode.getLinkedRecord('name');
                            name === null || name === void 0 || name.setValue(helpCenterName, 'default');
                        }
                        if (helpCenterSlug) currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(date, 'lastUpdated');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter0, _response$helpCenter1, _error$extensions2;
                    if ((_response$helpCenter0 = response.helpCenter) !== null && _response$helpCenter0 !== void 0 && (_response$helpCenter0 = _response$helpCenter0.updateHelpCenter) !== null && _response$helpCenter0 !== void 0 && _response$helpCenter0.success) return resolve(response);
                    const errors = (_response$helpCenter1 = response.helpCenter) === null || _response$helpCenter1 === void 0 || (_response$helpCenter1 = _response$helpCenter1.updateHelpCenter) === null || _response$helpCenter1 === void 0 ? void 0 : _response$helpCenter1.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $9mazR.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenters,
        helpCenterUpdateMutation
    ]);
    return {
        createHelpCenter: createHelpCenter,
        updateHelpCenter: updateHelpCenter,
        deleteHelpCenter: deleteHelpCenter
    };
};

});
parcelRegister("9zpsm", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9c4205c182c10d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7d9fbf0f9f046553e76513425ceaca8>>
 * @relayHash fecf54055e7ebdf24f46943683e10daa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8
const $b9c4205c182c10d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterDeletePayload",
                    "kind": "LinkedField",
                    "name": "deleteHelpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8",
            "metadata": {},
            "name": "useHelpCenterDeleteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b9c4205c182c10d2$var$node.hash = "7f1dd80d488ff1c4273819ebc7261544";
var $b9c4205c182c10d2$export$2e2bcd8739ae039 = $b9c4205c182c10d2$var$node;

});

parcelRegister("3G0Ae", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb61b586b96ab98c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c53f21dc49638e092a8cc269252804fc>>
 * @relayHash 760113b4d7a9d899532af7823cd6a3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68
const $cb61b586b96ab98c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68",
            "metadata": {},
            "name": "useHelpCenterUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cb61b586b96ab98c$var$node.hash = "162638a77ba5d44dfe258f5e31598716";
var $cb61b586b96ab98c$export$2e2bcd8739ae039 = $cb61b586b96ab98c$var$node;

});

parcelRegister("4Mo3v", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a93753149a7a65b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<574069c86901a0c3062851191b4f1cb5>>
 * @relayHash 6f452febb43ea4f48f12803ae2f36059
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976
const $1a93753149a7a65b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "helpCenterAri"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976",
            "metadata": {},
            "name": "useHelpCenterCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1a93753149a7a65b$var$node.hash = "50311be3a83d4bcff60feddeba10c3e5";
var $1a93753149a7a65b$export$2e2bcd8739ae039 = $1a93753149a7a65b$var$node;

});



parcelRegister("9zPPf", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterExperience", () => $57dd137448c89c1d$export$9ee847b39a089524);
$parcel$export(module.exports, "addHelpCenterExperience", () => $57dd137448c89c1d$export$b2a851a784010834);

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $57dd137448c89c1d$export$88b7d3eb7bfc06a1 = 'service-management.help-center.add';
const $57dd137448c89c1d$export$588afedc10fc2da4 = 'service-management.help-center.update';
const $57dd137448c89c1d$export$9ee847b39a089524 = new (0, $9LFKj.UFOExperience)($57dd137448c89c1d$export$588afedc10fc2da4, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});
const $57dd137448c89c1d$export$b2a851a784010834 = new (0, $9LFKj.UFOExperience)($57dd137448c89c1d$export$88b7d3eb7bfc06a1, {
    type: (0, $atXmE.ExperienceTypes).Experience,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("5CEo4", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => (parcelRequire("5PdqK")).HelpCenterFormFields);

var $5PdqK = parcelRequire("5PdqK");

});
parcelRegister("5PdqK", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => $a27a4e08916f82fd$export$14ec26006a1f0ef3);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $2xHR5 = parcelRequire("2xHR5");

var $gPQv9 = parcelRequire("gPQv9");

var $fKWgA = parcelRequire("fKWgA");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $7yidP = parcelRequire("7yidP");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $aEtFp = parcelRequire("aEtFp");

var $bcTS3 = parcelRequire("bcTS3");
parcelRequire("62zSr");
var $4OGFc = parcelRequire("4OGFc");

var $kNP6K = parcelRequire("kNP6K");

var $13Jvf = parcelRequire("13Jvf");

var $3rz6O = parcelRequire("3rz6O");
const $a27a4e08916f82fd$var$SLUG_VALIDATION_REGEX = /^[a-zA-Z0-9_-]{1,30}$/;
const $a27a4e08916f82fd$var$SlugInfo = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $a27a4e08916f82fd$var$slugWarningStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: formatMessage((0, $3rz6O.default).helpCenterSlugInfoTooltip),
        position: "top-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))), {
        label: formatMessage((0, $3rz6O.default).helpCenterSlugInfoLabel)
    })));
};
const $a27a4e08916f82fd$export$14ec26006a1f0ef3 = ({ name: name, slug: slug, urlWithoutSlug: urlWithoutSlug, mode: mode })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const nameLabel = (0, $4OGFc.useConditionalMessage)((0, $3rz6O.default).helpHubNameTextLabel, (0, $3rz6O.default).helpCenterNameTextLabel);
    const urlLabel = (0, $4OGFc.useConditionalMessage)((0, $3rz6O.default).helpHubSlugTextLabel, (0, $3rz6O.default).helpCenterSlugTextLabel);
    const validateHelpCenterName = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $13Jvf.default).helpCenterNameRequiredError);
        if (value && value.length > (0, $kNP6K.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $13Jvf.default).helpCenterNameCharacterLimitError);
        return undefined;
    };
    const validateHelpCenterSlug = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $13Jvf.default).helpCenterSlugRequiredError);
        if (value && value.length > (0, $kNP6K.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $13Jvf.default).helpCenterSlugCharacterLimitError);
        if (!$a27a4e08916f82fd$var$SLUG_VALIDATION_REGEX.test(value)) return formatMessage((0, $13Jvf.default).helpCenterSlugSpecialCharacterError);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7yidP.Stack), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gPQv9.default), {
        name: "name",
        key: "name",
        label: formatMessage(nameLabel),
        defaultValue: name ?? '',
        validate: validateHelpCenterName,
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            paddingBlockStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
            ...fieldProps,
            autoComplete: "off",
            autoFocus: true,
            placeholder: formatMessage((0, $3rz6O.default).helpCenterNameTextFieldPlaceholder),
            testId: "help-centers-management-name-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2xHR5.ErrorMessage), null, error))), mode === 'CREATE' || slug ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gPQv9.default), {
        name: "slug",
        key: "slug",
        label: formatMessage(urlLabel),
        defaultValue: slug ?? '',
        validate: validateHelpCenterSlug,
        elementAfterLabel: mode !== 'CREATE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($a27a4e08916f82fd$var$SlugInfo, null),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
            grow: "fill",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            paddingBlockStart: "space.100",
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4T8rw.Text), {
            color: "color.text"
        }, urlWithoutSlug, '/')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
            xcss: $a27a4e08916f82fd$var$slugTextFieldStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aEtFp.default), {
            autoComplete: "off",
            ...fieldProps,
            placeholder: formatMessage((0, $3rz6O.default).helpCenterSlugTextFieldPlaceholder),
            testId: "help-centers-management-slug-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2xHR5.ErrorMessage), null, error)))) : null);
};
const $a27a4e08916f82fd$var$slugTextFieldStyles = (0, $kig2V.xcss)({
    width: '10%',
    flexGrow: 1
});
const $a27a4e08916f82fd$var$slugWarningStyles = (0, $kig2V.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.050',
    verticalAlign: 'middle'
});

});
parcelRegister("13Jvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8e4ced717190e95$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $f8e4ced717190e95$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    helpCenterDetailsPageTitle: {
        defaultMessage: 'Details',
        description: 'Help center edit details page title',
        id: 'help.center.edit.details.page.title'
    },
    helpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.center.edit.details.page.description'
    },
    helpHubDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.hub.edit.details.page.description'
    },
    defaultHelpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name of your default help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Default help center edit details page description',
        id: 'help.center.default.help.center.description'
    },
    helpCenterCreateFormTitle: {
        defaultMessage: 'Create help center',
        description: 'Heading of the dialog or panel for creating a new help center',
        id: 'help.center.create.form.title'
    },
    helpCenterCreateFormDescription: {
        defaultMessage: 'Every new help center displays all open portals on your site by default. You can edit the home page layout to show or hide portals based on the audience.',
        description: 'Help center create form description',
        id: 'help.center.create.form.description'
    },
    helpCenterEditFormTitle: {
        defaultMessage: 'Edit help center details',
        description: 'Heading of the panel for editing existing help center details',
        id: 'help.center.edit.form.title'
    },
    helpCenterAddErrorTitle: {
        defaultMessage: `We couldn\u{2019}t create your help center`,
        description: 'Title message for add help center error',
        id: 'help.center.add.error.title'
    },
    helpCenterAddSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 created",
        description: 'Title message for add help center success',
        id: 'help.center.add.success.title.text'
    },
    helpCenterAddSuccessDesc: {
        defaultMessage: 'Go to help center',
        description: 'Description message for add help center success',
        id: 'help.center.add.success.description'
    },
    helpCenterUpdateErrorTitle: {
        defaultMessage: "We couldn\u2019t update your help center",
        description: 'Title message for update help center error',
        id: 'help.center.update.error.title'
    },
    helpCenterUpdateSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 updated",
        description: 'Title message for add help center success',
        id: 'help.center.update.success.title.text'
    },
    helpCenterGenericErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Generic description message for help center error',
        id: 'help.center.update.error.description.generic'
    },
    helpCenterErrorDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{value}',
        description: 'Description message for help center error',
        id: 'help.center.update.error.description'
    },
    helpCenterHardLimitErrorTitle: {
        defaultMessage: "You\u2019ve already created 300 help centers",
        description: 'Message title for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.title'
    },
    helpCenterHardLimitErrorDescription: {
        defaultMessage: 'Delete a help center to create another one.',
        description: 'Message description for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.description'
    },
    helpCenterNameRequiredError: {
        defaultMessage: 'Enter a name for your help center.',
        description: 'Validation error message when help center name is empty',
        id: 'help.center.name.required.validation.error'
    },
    helpCenterNameCharacterLimitError: {
        defaultMessage: 'Enter a help center name with 30 characters or less.',
        description: 'Validation error message when help center name is greater than required limit',
        id: 'help.center.name.character.limit.validation.error'
    },
    helpCenterSlugRequiredError: {
        defaultMessage: 'Add a slug.',
        description: 'Validation error message when help center slug is empty',
        id: 'help.center.slug.required.validation.error'
    },
    helpCenterSlugCharacterLimitError: {
        defaultMessage: 'Enter a slug with 30 characters or less.',
        description: 'Validation error message when help center slug is greater than required limit',
        id: 'help.center.slug.character.limit.validation.error'
    },
    helpCenterSlugSpecialCharacterError: {
        defaultMessage: `Add a slug that doesn\u{2019}t contain special characters other than hyphen (-) and underscore (_).`,
        description: 'Validation error message when help center slug contains special characters',
        id: 'help.center.slug.special.character.validation.error'
    },
    helpCenterAlreadyExistedSlugErrorDescription: {
        defaultMessage: 'A help center with this slug already exists on your site. Try again with a different slug.',
        description: 'Error message when help center slug already exists',
        id: 'help.center.already.existed.slug.error.description'
    },
    helpCenterReservedSlugErrorDescription: {
        defaultMessage: "The slug you\u2019ve entered contains a reserved term. Try again with a different slug.",
        description: 'Error message when entered slug contains reserved term',
        id: 'help.center.reserved.slug.error.description'
    },
    helpCenterRequiredFieldsWarning: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Required warning message for update help center fields',
        id: 'help.center.update.form.required.warning'
    }
});

});

parcelRegister("3rz6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d43a291afefc513$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $0d43a291afefc513$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    helpCenterNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.center.name.text.field.label.title'
    },
    helpHubNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.hub.name.text.field.label.title'
    },
    helpCenterNameTextFieldPlaceholder: {
        defaultMessage: 'Enter a help center name',
        description: 'Help center name text field placeholder',
        id: 'help.center.name.text.field.placeholder.title'
    },
    helpCenterSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.center.slug.text.field.label.title'
    },
    helpHubSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.hub.slug.text.field.label.title'
    },
    helpCenterSlugInfoTooltip: {
        defaultMessage: 'Share your new help center URL with your team members and customers',
        description: 'Help center slug text change warning tooltip',
        id: 'help.center.slug.text.field.info.tooltip'
    },
    helpCenterSlugInfoLabel: {
        defaultMessage: 'Slug change info',
        description: 'Accessible label for the slug change information icon in the help center form',
        id: 'help.center.slug.text.field.change.info.label'
    },
    helpCenterSlugTextFieldPlaceholder: {
        defaultMessage: 'Enter a slug',
        description: 'Help center slug text field placeholder',
        id: 'help.center.name.slug.field.placeholder.title'
    }
});

});



parcelRegister("2Pz3t", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => (parcelRequire("77v0t")).HelpCenterFormFooter);

var $77v0t = parcelRequire("77v0t");

});
parcelRegister("77v0t", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => $65842ae97e3b8e62$export$9f1ed90db1948ebe);

var $fc4bM = parcelRequire("fc4bM");

var $MPQAF = parcelRequire("MPQAF");

var $gpjDl = parcelRequire("gpjDl");

var $lHYHS = parcelRequire("lHYHS");

var $e2QOk = parcelRequire("e2QOk");

var $6hqQv = parcelRequire("6hqQv");
const $65842ae97e3b8e62$export$9f1ed90db1948ebe = ({ submitting: submitting, mode: mode, onCancel: onCancel, isStandaloneForm: isStandaloneForm = false, isCancelDisabled: isCancelDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const renderCancelButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.Button), {
            isDisabled: isCancelDisabled,
            onClick: onCancel,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCancelCreateButton' : 'helpCenterCancelEditButton',
            key: "cancel"
        }, formatMessage((0, $6hqQv.default).helpCenterCancelButtonText));
    const renderSaveButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $MPQAF.LoadingButton), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCreateButton' : 'helpCenterSaveButton',
            testId: "help-centers-management-primary-button",
            key: "save"
        }, formatMessage(mode === 'CREATE' ? (0, $6hqQv.default).helpCenterCreateButtonText : (0, $6hqQv.default).helpCenterSaveButtonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e2QOk.FormFooter), {
        align: isStandaloneForm ? 'start' : 'end'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lHYHS.default), null, isStandaloneForm ? [
        renderSaveButton(),
        renderCancelButton()
    ] : [
        renderCancelButton(),
        renderSaveButton()
    ]));
};

});
parcelRegister("6hqQv", function(module, exports) {
$parcel$export(module.exports, "default", () => $31b31d0d1f46e5f4$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $31b31d0d1f46e5f4$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    helpCenterSaveButtonText: {
        defaultMessage: 'Save',
        description: 'Button label to save changes to the help center details form',
        id: 'help.center.save.button.text'
    },
    helpCenterCancelButtonText: {
        defaultMessage: 'Cancel',
        description: 'Help center cancel button text',
        id: 'help.center.cancel.button.text'
    },
    helpCenterCreateButtonText: {
        defaultMessage: 'Create',
        description: 'Help center create button text',
        id: 'help.center.create.button.text'
    }
});

});





parcelRegister("c8xDG", function(module, exports) {
$parcel$export(module.exports, "EditHelpCenterLayoutSkeleton", () => (parcelRequire("c8dSp")).default);

var $c8dSp = parcelRequire("c8dSp");

});
parcelRegister("c8dSp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab942e408aadb169$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bsIOe = parcelRequire("bsIOe");

var $1JdzP = parcelRequire("1JdzP");

var $5a4EU = parcelRequire("5a4EU");

var $7yidP = parcelRequire("7yidP");
const $ab942e408aadb169$var$EditHelpCenterLayoutSkeleton = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "84px",
        height: "24px"
    })), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "20%",
        height: "28px",
        "data-testid": "edit-helpcenter-header-skeleton"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "60%",
        height: "20px"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "100%",
        height: "36px"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $5a4EU.Box), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7yidP.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "50%",
        height: "36px"
    }))))), /*#__PURE__*/ $fc4bM.createElement((0, $1JdzP.Flex), {
        direction: "row",
        gap: "space.050"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "10%",
        height: "32px",
        "data-testid": "edit-helpcenter-button-skeleton"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $bsIOe.SkeletonItem), {
        width: "10%",
        height: "32px"
    })));
};
var $ab942e408aadb169$export$2e2bcd8739ae039 = $ab942e408aadb169$var$EditHelpCenterLayoutSkeleton;

});


parcelRegister("NCC7B", function(module, exports) {
$parcel$export(module.exports, "editHelpCenterExperience", () => $6137d6097cd427fa$export$f9e64dbdb3d531);

var $fCHdA = parcelRequire("fCHdA");

var $atXmE = parcelRequire("atXmE");
var $9LFKj = parcelRequire("9LFKj");
const $6137d6097cd427fa$export$f9e64dbdb3d531 = new (0, $9LFKj.UFOExperience)((0, $fCHdA.editHelpCenterExperienceId), {
    type: (0, $atXmE.ExperienceTypes).Load,
    performanceType: (0, $atXmE.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("afSin", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c4cacb06bcb80f8$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $7c4cacb06bcb80f8$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Title shown in the sidebar when an error occurs loading the help center',
        id: 'help.center.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Message shown in the sidebar prompting the user to refresh and retry',
        id: 'help.center.management.sidebar.error.description'
    }
});

});



parcelRegister("QO5tP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("lkCe3"),
    $9dnsd("1xWnR"),
    $9dnsd("4cJBF"),
    $9dnsd("3KK3D"),
    $9dnsd("bmLFd"),
    $9dnsd("jsVEa"),
    $9dnsd("j81ar"),
    $9dnsd("fQ86q"),
    $9dnsd("8Qjad"),
    $9dnsd("jCVS7"),
    $9dnsd("hCVB4"),
    $9dnsd("hHYFE"),
    $9dnsd("b1NYz"),
    $9dnsd("6Df0C"),
    $9dnsd("fAWGE"),
    $9dnsd("ozcFp"),
    $9dnsd("2a74T"),
    $9dnsd("8QhuV"),
    $9dnsd("lsa7j"),
    $9dnsd("67Pud"),
    $9dnsd("9xUCJ"),
    $9dnsd("5nsCa"),
    $9dnsd("1ne6N"),
    $9dnsd("5TqqM"),
    $9dnsd("8y0Bh")
]).then(()=>parcelRequire('aR3eq'));

});


parcelRegister("3fkMn", function(module, exports) {
$parcel$export(module.exports, "helpcenterVirtualAgentRoute", () => $b47dd91c0cb7e26c$export$60952d52d9999cc1);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $bQkfB = parcelRequire("bQkfB");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");
parcelRequire("a3Wd7");
var $7tc2B = parcelRequire("7tc2B");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");

var $80yPZ = parcelRequire("80yPZ");
parcelRequire("62zSr");
var $2oyaj = parcelRequire("2oyaj");

var $hE1uz = parcelRequire("hE1uz");

const $b47dd91c0cb7e26c$var$AsyncVirtualAgentPage = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("ghjK5")).then((VirtualAgentSettingsPage)=>VirtualAgentSettingsPage), {
        moduleId: "./packages/virtual-agent/virtual-agent-settings/src/index.tsx"
    })
});
const $b47dd91c0cb7e26c$var$VirtualAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, $9DdYZ.default)((0, $aEq46.default)({
        redirectUrl: '/'
    }), (0, $aylSc.default)({
        message: formatMessage((0, $80yPZ.authPageMessage)),
        callToActionText: formatMessage((0, $80yPZ.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2oyaj.default), {
            featureName: "Virtual Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b47dd91c0cb7e26c$var$AsyncVirtualAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
const $b47dd91c0cb7e26c$export$60952d52d9999cc1 = {
    name: 'virtualAgentSettings',
    path: '/:helpcenterId/virtual-agent',
    exact: true,
    resources: [
        (0, $hE1uz.HelpCenterVirtualAgentResource)
    ],
    component: (0, $7tc2B.withRouter)($b47dd91c0cb7e26c$var$VirtualAgentPage)
};

});
parcelRegister("hE1uz", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $3b8e0b364ed64232$export$7ab6648586bf1bbf);

var $hN5YJ = parcelRequire("hN5YJ");

var $6LH8a = parcelRequire("6LH8a");

var $4MoYu = parcelRequire("4MoYu");

var $7lN8e = parcelRequire("7lN8e");

var $8zK3E = parcelRequire("8zK3E");

var $g6ovR = parcelRequire("g6ovR");
const $3b8e0b364ed64232$export$7ab6648586bf1bbf = (0, $8zK3E.createRelayResource)({
    type: 'HELP_REPORTING_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        let computedHelpCenterAri = helpCenterAri;
        const activationId = (0, $6LH8a.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        computedHelpCenterAri = (0, $4MoYu.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $g6ovR.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri,
                isJsmAIConfigEnabled: (0, $7lN8e.getJsmAIConfigEnabled)(),
                isHideKbColumnEnabled: (0, $hN5YJ.isHideKbColumnEnabled)(),
                isTotalArticleCountEnabled: (0, $hN5YJ.isTotalArticleCountEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("g6ovR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e08aac5252bc609b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f00b9f34f084af0c44ccdaffeaab4d03>>
 * @relayHash 28e8cbdbeb4f550a7172ffd1c0454bc7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 449d1a019e85e848bdc90eac809042aa3d0d56c5805c730187e929a3304c7bba
const $e08aac5252bc609b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideKbColumnEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJsmAIConfigEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTotalArticleCountEnabled"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v12 = [
        v5 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v13 = [
        v5 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterAri"
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterId",
                    "value": ""
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterMappingStatus",
                    "value": "LINKED"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "settingsVirtualAgentSettingsTabFragment"
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsVirtualAgentLinkedArticlesFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        v5 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isHideKbColumnEnabled",
                            "variableName": "isHideKbColumnEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "settingsVirtualAgentSettingsTabMappedProjectsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isHideKbColumnEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": v6 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "knowledgeBaseArticlesCount",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "count"
                                                                        }
                                                                    ],
                                                                    "type": "KnowledgeBaseArticleCountSource"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "virtualAgentConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isAiResponsesEnabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "liveIntentsCount"
                                                                }
                                                            ],
                                                            "type": "VirtualAgentConfiguration"
                                                        },
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "VirtualAgentQueryError"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "projectBreakdownTableMappedProjectsFragment_jiraProjectsMappedToHelpCenter",
                            "kind": "LinkedHandle",
                            "name": "jiraProjectsMappedToHelpCenter"
                        }
                    ]
                },
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "slug"
                                                }
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v11 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpObjectStoreArticleSearchResponse"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ],
                                    "type": "HelpObjectStoreArticleSearchResults"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "449d1a019e85e848bdc90eac809042aa3d0d56c5805c730187e929a3304c7bba",
            "metadata": {},
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e08aac5252bc609b$var$node.hash = "336c89be85723469b9110ef6c88dd241";
var $e08aac5252bc609b$export$2e2bcd8739ae039 = $e08aac5252bc609b$var$node;

});


parcelRegister("ghjK5", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("jeCvC"),
    $9dnsd("fDivf")
]).then(()=>parcelRequire('1y1nd'));

});


parcelRegister("fEbxN", function(module, exports) {
$parcel$export(module.exports, "viewHelpCentersManagementPageRoute", () => $de30e1a7573d1aaf$export$e49071c21a45635e);
$parcel$export(module.exports, "viewHelpHubsManagementPageRoute", () => $de30e1a7573d1aaf$export$589f7c1da1d95244);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("UZaDE");
var $9DdYZ = parcelRequire("9DdYZ");

var $9mazR = parcelRequire("9mazR");

var $gpjDl = parcelRequire("gpjDl");
parcelRequire("4WWde");
var $aylSc = parcelRequire("aylSc");
parcelRequire("hS5Dr");
var $aEq46 = parcelRequire("aEq46");

var $k2M4v = parcelRequire("k2M4v");

var $7lN8e = parcelRequire("7lN8e");

var $esgVk = parcelRequire("esgVk");
parcelRequire("kTmUE");
var $45P2X = parcelRequire("45P2X");
var $gWVRb = parcelRequire("gWVRb");
const $de30e1a7573d1aaf$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT = 'jira_sidebar_show_helpcenter';
const $de30e1a7573d1aaf$var$isJiraSidebarShowHelpcenterExperimentEnabled = ()=>(0, $k2M4v.default).getExperimentValue($de30e1a7573d1aaf$var$JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT, 'isEnabled', false);
const $de30e1a7573d1aaf$var$JiraHelpCenterManagementRedirect = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        (0, $esgVk.replace)(`${(0, $7lN8e.getJiraDisplayUrl)()}/jira/helpcenter-management${window.location.search}`);
    }, []);
    return null;
};
const $de30e1a7573d1aaf$var$HelpCentersManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>(0, $9DdYZ.default)((0, $aEq46.default)({
            redirectUrl: '/'
        }), (0, $aylSc.default)({
            message: formatMessage((0, $45P2X.authPageMessage)),
            callToActionText: formatMessage((0, $45P2X.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $45P2X.HelpCentersManagementPage)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
const $de30e1a7573d1aaf$var$HelpHubsManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>(0, $9DdYZ.default)((0, $aEq46.default)({
            redirectUrl: '/'
        }), (0, $aylSc.default)({
            message: formatMessage((0, $45P2X.authPageMessage)),
            callToActionText: formatMessage((0, $45P2X.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $45P2X.HelpCentersManagementPage)), [
        formatMessage
    ]);
    if ($de30e1a7573d1aaf$var$isJiraSidebarShowHelpcenterExperimentEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($de30e1a7573d1aaf$var$JiraHelpCenterManagementRedirect, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(WrappedComponent, null);
};
const $de30e1a7573d1aaf$export$e49071c21a45635e = {
    name: (0, $9mazR.ScreenName).HELP_CENTERS_MANAGEMENT,
    path: '/',
    exact: true,
    component: $de30e1a7573d1aaf$var$HelpCentersManagement,
    resources: [
        (0, $gWVRb.HelpCentersManagementResource),
        (0, $gWVRb.MigrationCandidatesResource)
    ]
};
const $de30e1a7573d1aaf$export$589f7c1da1d95244 = {
    name: (0, $9mazR.ScreenName).HELP_HUBS_MANAGEMENT,
    path: '/hubs',
    exact: true,
    component: $de30e1a7573d1aaf$var$HelpHubsManagement,
    resources: [
        (0, $gWVRb.HelpCentersManagementResource)
    ]
};

});
parcelRegister("kTmUE", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => (parcelRequire("45P2X")).HelpCentersManagementPage);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("gWVRb")).HelpCentersManagementResource);
$parcel$export(module.exports, "MigrationCandidatesResource", () => (parcelRequire("gWVRb")).MigrationCandidatesResource);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("45P2X")).callToActionUrlText);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("45P2X")).authPageMessage);

var $45P2X = parcelRequire("45P2X");
var $gWVRb = parcelRequire("gWVRb");
parcelRequire("cI6pQ");
var $3Kvpd = parcelRequire("3Kvpd");

});
parcelRegister("45P2X", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => $f94719e01a25aa1f$export$233bfa78dd235938);
$parcel$export(module.exports, "callToActionUrlText", () => $f94719e01a25aa1f$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $f94719e01a25aa1f$export$5342e2a00fe6d647);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("gWVRb")).HelpCentersManagementResource);
$parcel$export(module.exports, "MigrationCandidatesResource", () => (parcelRequire("gWVRb")).MigrationCandidatesResource);

var $bQkfB = parcelRequire("bQkfB");
parcelRequire("ieUrC");
var $dohmo = parcelRequire("dohmo");

var $8d9xb = parcelRequire("8d9xb");

var $gWVRb = parcelRequire("gWVRb");

const $f94719e01a25aa1f$export$233bfa78dd235938 = (0, $bQkfB.default)({
    loader: (0, $dohmo.lazyForPaint)(()=>(parcelRequire("37ylo")), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/help-centers-management-page/help-centers-management-page.tsx"
    })
});
const $f94719e01a25aa1f$export$d96795d242b62963 = (0, $8d9xb.default).callToActionUrlText;
const $f94719e01a25aa1f$export$5342e2a00fe6d647 = (0, $8d9xb.default).authPageMessage;

});
parcelRegister("8d9xb", function(module, exports) {
$parcel$export(module.exports, "default", () => $09de4d9b0a6c4220$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $09de4d9b0a6c4220$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    migrationAnnouncementBase: {
        defaultMessage: 'Your help centers are getting an update.',
        description: 'Base announcement shown above Help Center management when migration is available.',
        id: 'help.center.management.page.migration.announcement.base'
    },
    migrationAnnouncementDueDate: {
        defaultMessage: 'Update now or test it out before {dueDate, date, medium}.',
        description: "Migration announcement deadline, formatted in the viewer\u2019s locale.",
        id: 'help.center.management.page.migration.announcement.due-date'
    },
    migrationAnnouncementLearnMore: {
        defaultMessage: 'Learn more.',
        description: 'Link label leading to more information about the Help Center migration.',
        id: 'help.center.management.page.migration.announcement.learn-more'
    },
    migrationHeaderText: {
        defaultMessage: 'Update help centers',
        description: 'Help Center management screen header text when help center migration is available.',
        id: 'help.center.management.page.migration.header.text'
    },
    migrationHeaderDescription: {
        defaultMessage: 'Manage your help centers and update them here.',
        description: 'Help Center management screen header description when help center migration is available.',
        id: 'help.center.management.page.migration.header.description'
    },
    migrationUpdateButton: {
        defaultMessage: 'Update help center',
        description: 'Button that starts the Help Center update flow from the management page header.',
        id: 'help.center.management.page.migration.update.help.center.button'
    },
    migrationHeaderLearnMore: {
        defaultMessage: 'Learn more about updating help centers',
        description: 'Link label leading to more information about updating Help Centers from the management page header.',
        id: 'help.center.management.page.migration.header.learn-more'
    },
    headerTextHelpCenter: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text',
        id: 'help.center.management.page.header.text'
    },
    headerTextHelpHub: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text hubs',
        id: 'help.center.management.page.header.text.hubs'
    },
    headerDescriptionHelpCenter: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description'
    },
    headerDescriptionReadMoreLinkHelpCenter: {
        defaultMessage: 'Read more about help centers',
        description: 'Help centers management screen header description read more link',
        id: 'help.center.management.page.header.description.read.more.link'
    },
    headerDescriptionHelpHub: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description.hubs'
    },
    addButtonTextHelpCenter: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen add help center button text',
        id: 'help.center.management.add.help.center.button.text'
    },
    addButtonTextHelpHub: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen create button text',
        id: 'help.center.management.create.button.text.hubs'
    },
    createOptionHelpCenterTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option help center title',
        id: 'help.center.management.create.option.help.center.title'
    },
    createOptionHelpCenterDescription: {
        defaultMessage: 'The default help experience with portals, topics, and more',
        description: 'Help centers management screen create option help center description',
        id: 'help.center.management.create.option.help.center.description'
    },
    createOptionHubTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option hub title',
        id: 'help.center.management.create.option.hub.title'
    },
    createOptionHubDescription: {
        defaultMessage: 'Create a modern help experience with components and customization',
        description: 'Help centers management screen create option hub description',
        id: 'help.center.management.create.option.hub.description'
    },
    genericErrorHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.message'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.text'
    },
    upgradeTitleCreateClick: {
        defaultMessage: 'Upgrade to create new help centers',
        description: 'Popup title to upgrade to create help center',
        id: 'help.center.management.upgrade.title.create.click'
    },
    upgradeDescriptionCreateClick: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create multiple help centers on your site.',
        description: 'Popup description to upgrade to create help center',
        id: 'help.center.management.upgrade.description.create.click'
    },
    helpHubEmptyStateHeader: {
        defaultMessage: 'Create modern help centers to serve your customers',
        description: 'Help center empty state header',
        id: 'help.center.management.page.help.hub.empty.state.header'
    },
    helpHubEmptyStateDescription: {
        defaultMessage: 'Empower customers to find answers with knowledge base articles or get support by raising requests in Jira Service Management.',
        description: 'Help center empty state description',
        id: 'help.center.management.page.help.hub.empty.state.description'
    },
    jiraHelpCenterManagementMessage: {
        defaultMessage: 'Your help centers can be created and managed from within the Jira Service Management app navigation.',
        description: 'Information message that directs customers to the Jira Service Management app navigation where help centers can be created and managed.',
        id: 'help.center.management.page.jira.helpcenter.management.message'
    },
    jiraHelpCenterManagementAction: {
        defaultMessage: 'Manage help centers',
        description: 'External link in the Help Center management information message that opens Jira Service Management help center management.',
        id: 'help.center.management.page.jira.helpcenter.management.action'
    }
});

});

parcelRegister("gWVRb", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementResource", () => $605e2b4a8b82b7ab$export$7e2ebb4b559ed1ce);
$parcel$export(module.exports, "MigrationCandidatesResource", () => $605e2b4a8b82b7ab$export$4cbea945316f010d);

var $9mazR = parcelRequire("9mazR");

var $k2M4v = parcelRequire("k2M4v");

var $1xOZp = parcelRequire("1xOZp");

var $8zK3E = parcelRequire("8zK3E");

var $3BZyK = parcelRequire("3BZyK");
parcelRequire("a3Wd7");
var $fOvEc = parcelRequire("fOvEc");

var $kNP6K = parcelRequire("kNP6K");

var $lrPvF = parcelRequire("lrPvF");

var $iPx5W = parcelRequire("iPx5W");
const $605e2b4a8b82b7ab$var$HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
const $605e2b4a8b82b7ab$export$7e2ebb4b559ed1ce = (0, $8zK3E.createRelayResource)({
    type: 'HELP_CENTERS_MANAGEMENT',
    getQuery: ({ route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>{
        const isHelpHubRoute = route.name === (0, $9mazR.ScreenName).HELP_HUBS_MANAGEMENT;
        const filterType = isHelpHubRoute ? 'HELP_HUB' : 'BASIC';
        return {
            parameters: (0, $iPx5W.default),
            variables: {
                cloudId: cloudId,
                workspaceAri: workspaceAri,
                SORT_ORDER: $kNP6K.SORT_ORDER,
                NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $kNP6K.NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
                filterType: (0, $k2M4v.default).checkGate('enable-jsm-in-hubs') ? filterType : null
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $605e2b4a8b82b7ab$export$4cbea945316f010d = (0, $fOvEc.createResource)({
    type: 'RELAY_RESOURCE_TYPE_MIGRATION_CANDIDATES',
    getKey: ({ query: query, route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>`MIGRATION_CANDIDATES:${route.name}:${query.migrationStep ?? ''}:${cloudId}:${workspaceAri}`,
    getData: ({ query: query, route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>{
        if (route.name !== (0, $9mazR.ScreenName).HELP_CENTERS_MANAGEMENT || query.migrationStep !== 'select' || !(0, $k2M4v.default).checkGate($605e2b4a8b82b7ab$var$HELP_HUB_MIGRATION_GATE)) return null;
        return (0, $3BZyK.loadQuery)((0, $1xOZp.getRelayEnvironment)(), (0, $lrPvF.default), {
            cloudId: cloudId,
            workspaceAri: workspaceAri
        }, {
            fetchPolicy: 'store-or-network'
        });
    },
    maxAge: 0
});

});
parcelRegister("lrPvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $daa942ba78b7882b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd10c3f51643ab5365820fa677b8d05e>>
 * @relayHash 918baf2e918b4daa1f9512f460ba66f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b4c8db1810411fd3c1658a8aa00eb0ddb96fcafb2a2af12d3163b2df76311f70
const $daa942ba78b7882b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "type": "BASIC"
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 300
        },
        {
            "kind": "Literal",
            "name": "sortOrder",
            "value": "CREATED_DATE_DESCENDING"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "slug"
            },
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterMigrationInfo",
                "kind": "LinkedField",
                "name": "migration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "migrationDataCandidatesQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "migrationDataCandidatesQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b4c8db1810411fd3c1658a8aa00eb0ddb96fcafb2a2af12d3163b2df76311f70",
            "metadata": {},
            "name": "migrationDataCandidatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$daa942ba78b7882b$var$node.hash = "8ed51374d75c3cba42f22030068ce624";
var $daa942ba78b7882b$export$2e2bcd8739ae039 = $daa942ba78b7882b$var$node;

});

parcelRegister("iPx5W", function(module, exports) {
$parcel$export(module.exports, "default", () => $31074a9d977cf9a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caad237387f5fd4010799a6441a57b8a>>
 * @relayHash 6c8153f7ad0165d2a080749f574219c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36dec7ff3f1d98fdfdf67c8e99e74325d258e5db21530cd918d3a58e3df8d9d2
const $31074a9d977cf9a9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v7 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "filterType"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
        },
        {
            "kind": "Variable",
            "name": "sortOrder",
            "variableName": "SORT_ORDER"
        },
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH",
                            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
                        },
                        {
                            "kind": "Variable",
                            "name": "SORT_ORDER",
                            "variableName": "SORT_ORDER"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "filterType",
                            "variableName": "filterType"
                        },
                        v6 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "helpCentersManagementPageFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterMigrationInfo",
                                                            "kind": "LinkedField",
                                                            "name": "migration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "migratedHubAri"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterBranding",
                                                            "kind": "LinkedField",
                                                            "name": "helpCenterBranding",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isBannerAvailable"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "useDefaultBanner"
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBrandingColors",
                                                                    "kind": "LinkedField",
                                                                    "name": "colors",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "primary"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBanner",
                                                                    "kind": "LinkedField",
                                                                    "name": "banner",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mappedProjectsCount"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "helpCentersManagementPageFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "36dec7ff3f1d98fdfdf67c8e99e74325d258e5db21530cd918d3a58e3df8d9d2",
            "metadata": {},
            "name": "helpCentersManagementPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$31074a9d977cf9a9$var$node.hash = "767d192c1eee830ece678d269a62c024";
var $31074a9d977cf9a9$export$2e2bcd8739ae039 = $31074a9d977cf9a9$var$node;

});


parcelRegister("37ylo", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bUE4p"),
    $9dnsd("lkCe3"),
    $9dnsd("3KK3D"),
    $9dnsd("dLsDK"),
    $9dnsd("lgbKq"),
    $9dnsd("cT544"),
    $9dnsd("f9Aw7"),
    $9dnsd("1ggPn"),
    $9dnsd("6Df0C"),
    $9dnsd("aYb4i"),
    $9dnsd("bMKAA"),
    $9dnsd("8QhuV"),
    $9dnsd("2840j"),
    $9dnsd("3EcVO"),
    $9dnsd("gxCRt"),
    $9dnsd("cz9eg"),
    $9dnsd("k09lt"),
    $9dnsd("6z401"),
    $9dnsd("l0zbS"),
    $9dnsd("cMYEM"),
    $9dnsd("7etds"),
    $9dnsd("aPbFz"),
    $9dnsd("lsa7j"),
    $9dnsd("1BUd7"),
    $9dnsd("79oqI")
]).then(()=>parcelRequire('5Ln9T'));

});





parcelRegister("5LZ4m", function(module, exports) {
$parcel$export(module.exports, "default", () => $318ae48a5d45c59a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");

var $luz1X = parcelRequire("luz1X");

var $hN5YJ = parcelRequire("hN5YJ");

var $2p58l = parcelRequire("2p58l");

var $gxSIz = parcelRequire("gxSIz");

parcelRequire("a3Wd7");
var $3iZvk = parcelRequire("3iZvk");
var $2drpp = parcelRequire("2drpp");

var $8Nv7y = parcelRequire("8Nv7y");

var $fHOft = parcelRequire("fHOft");

var $dQIQC = parcelRequire("dQIQC");

var $bT4AH = parcelRequire("bT4AH");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $jB96H = parcelRequire("jB96H");
parcelRequire("kOWPe");
var $1fQE4 = parcelRequire("1fQE4");
parcelRequire("fQ7Me");
var $5J3cB = parcelRequire("5J3cB");

var $k2M4v = parcelRequire("k2M4v");

var $diqlM = parcelRequire("diqlM");

var $kAQaQ = parcelRequire("kAQaQ");

var $aWLgo = parcelRequire("aWLgo");
const $318ae48a5d45c59a$var$HELP_HUB_MIGRATION = 'enable-help-hub-migration';
const $318ae48a5d45c59a$var$isHelpHubMigrationEnabled = ()=>(0, $k2M4v.default).checkGate($318ae48a5d45c59a$var$HELP_HUB_MIGRATION);
const $318ae48a5d45c59a$export$2f7745f2f5ab3897 = ()=>{
    const hubHomepageRoute = (0, $5J3cB.getHubHomepageRoute)();
    return [
        hubHomepageRoute,
        ...$318ae48a5d45c59a$var$isHelpHubMigrationEnabled() ? [
            {
                ...hubHomepageRoute,
                name: 'hub-homepage-portals',
                path: '/portals'
            }
        ] : [],
        (0, $5J3cB.getHubCustompageRoute)(),
        ...(0, $k2M4v.default).checkGate('portal-pages-in-hub') ? [
            (0, $5J3cB.getHubPortalPageRoute)()
        ] : [],
        /**
   * Account Management Pages
   */ (0, $5J3cB.getLoginRouteWithHubShell)(),
        (0, $5J3cB.getPortalLoginRouteWithHubShell)(),
        (0, $5J3cB.getResetPasswordRouteWithHubShell)(),
        (0, $5J3cB.getPortalResetPasswordRouteWithHubShell)(),
        (0, $5J3cB.getSignupRouteWithHubShell)(),
        (0, $5J3cB.getPortalSignupRouteWithHubShell)(),
        (0, $5J3cB.getCompleteSignupRouteWithHubShell)(),
        (0, $5J3cB.getPortalCompleteSignupRouteWithHubShell)(),
        (0, $5J3cB.getPortalInvitedSignupRouteWithHubShell)(),
        (0, $5J3cB.getCheckEmailRouteWithHubShell)(),
        (0, $5J3cB.getUnsubscribeRouteWithHubShell)(),
        (0, $5J3cB.getHubUserProfileRouteWithHubShell)(),
        (0, $5J3cB.getPortalAccessForbiddenRouteWithHubShell)(),
        (0, $8Nv7y.consentFormRoute /* TODO: The consent form route needs the Hub Shell */ ),
        ...(0, $hN5YJ.isEmailVerifiedSignalEnabled)() ? [
            (0, $bT4AH.userVerifyEmailRoute)
        ] : [],
        /**
   * Request Management Pages
   */ (0, $5J3cB.getRequestCreateRouteWithHubShell)(),
        (0, $5J3cB.getAnonymousRequestSuccessRouteWithHubShell)(),
        (0, $5J3cB.getRequestFeedbackRouteWithHubShell)(),
        (0, $5J3cB.getJsmRequestDetailsRouteWithHubShell)(),
        (0, $5J3cB.getJsmManageColumnsRequestsListRouteWithHubShell)(),
        (0, $5J3cB.getJsmApprovalsRouteWithHubShell)(),
        (0, $5J3cB.getJsmRequestApprovalRouteWithHubShell)(),
        (0, $5J3cB.getSurveyRouteWithHubShell)(),
        /** TODO: Article Pages */ (0, $5J3cB.getHubViewKbRoute)(),
        (0, $5J3cB.getHubViewArticleRoute)(),
        (0, $5J3cB.getHubViewCrossSiteArticleRoute)(),
        (0, $5J3cB.getHubViewPortalArticleRoute)(),
        (0, $5J3cB.getHubViewCrossSitePortalArticleRoute)(),
        /**
   * Search related pages
   */ (0, $5J3cB.getHubAllSearchResultsRouteWithHubShell)(),
        /**
   * Hub Management pages
   */ (0, $dQIQC.helpcenterEditRoute),
        (0, $dQIQC.helpcenterManageProjectsRoute),
        (0, $dQIQC.helpcenterManageCustomPagesRoute),
        /**
   * EmbeddablePages
   */ (0, $fHOft.getEmbedCreateRequestRoute)(),
        (0, $fHOft.embedKBArticleRoute),
        /**
   * Not found route
   */ (0, $5J3cB.getNotFoundRouteWithHubShell)()
    ];
};
const $318ae48a5d45c59a$export$bd848585fb624145 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $2p58l.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $2p58l.lightenColor)(themeColor);
    const routes = (0, $fc4bM.useMemo)(()=>$318ae48a5d45c59a$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    const routeContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1fQE4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3iZvk.RouteComponent), null));
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $luz1X.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2drpp.Router), {
        routes: routes,
        history: (0, $diqlM.default),
        isGlobal: false,
        plugins: [
            (0, $aWLgo.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gxSIz.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jB96H.UFOWatcher), null), routeContent, (0, $k2M4v.default).checkGate('enable_rovo_in_help_hubs') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kAQaQ.RovoWidgetRenderer), null)));
};
const $318ae48a5d45c59a$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getThemeColor), (0, $ePyx3.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $318ae48a5d45c59a$export$2e2bcd8739ae039 = (0, $6umft.default)($318ae48a5d45c59a$var$selector)($318ae48a5d45c59a$export$bd848585fb624145);

});
parcelRegister("kAQaQ", function(module, exports) {
$parcel$export(module.exports, "RovoWidgetRenderer", () => $31d5ecce97a4275b$export$5d23099fbd84d512);

var $fc4bM = parcelRequire("fc4bM");

var $6LH8a = parcelRequire("6LH8a");
parcelRequire("a3Wd7");
var $7lAXH = parcelRequire("7lAXH");

var $k2M4v = parcelRequire("k2M4v");

var $dQMHQ = parcelRequire("dQMHQ");

var $jC6rE = parcelRequire("jC6rE");

var $3RD5l = parcelRequire("3RD5l");
// Route names to exclude from showing the Rovo widget. These are the customisable hub pages, where
// the callout banner is already the Rovo entry point, so this corner widget would be a second one.
const $31d5ecce97a4275b$var$EXCLUDED_ROVO_WIDGET_ROUTES = [
    'hub',
    'hub-custom-page',
    'hub-portal-page'
];
const $31d5ecce97a4275b$export$5d23099fbd84d512 = ()=>{
    var _routerState$route, _routerState$match;
    const [routerState] = (0, $7lAXH.useRouter)();
    const currentRouteName = (_routerState$route = routerState.route) === null || _routerState$route === void 0 ? void 0 : _routerState$route.name;
    if (!currentRouteName || $31d5ecce97a4275b$var$EXCLUDED_ROVO_WIDGET_ROUTES.includes(currentRouteName)) return null;
    const cloudId = (0, $6LH8a.getCloudId)();
    const helpCenterAri = (0, $6LH8a.getHelpCenterAri)();
    if (!cloudId || !helpCenterAri) return null;
    // Keyed off the route carrying a portalId rather than a list of route names, so new
    // portal-scoped routes are covered without anyone having to remember to add them here.
    const portalId = (_routerState$match = routerState.match) === null || _routerState$match === void 0 || (_routerState$match = _routerState$match.params) === null || _routerState$match === void 0 ? void 0 : _routerState$match.portalId;
    const shouldUsePortalWidget = Boolean(portalId) && (0, $k2M4v.default).checkGate('hubs_rovo_config_from_kosh');
    // Spread rather than `brandPrimaryColor={undefined}` so unbranded props stay exactly as before.
    const renderWidget = (brandPrimaryColor)=>{
        const brandProps = brandPrimaryColor ? {
            brandPrimaryColor: brandPrimaryColor
        } : {};
        return shouldUsePortalWidget && portalId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3RD5l.PortalRovoWidget), {
            portalId: portalId,
            cloudId: cloudId,
            ...brandProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dQMHQ.RovoServiceAgentWidgetInjector), {
            siteId: cloudId,
            widgetId: helpCenterAri,
            surface: "HUB",
            ...brandProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jC6rE.WithHubBrandPrimaryColor), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, renderWidget);
};

});
parcelRegister("jC6rE", function(module, exports) {
$parcel$export(module.exports, "WithHubBrandPrimaryColor", () => $c2b32fe52c53d60d$export$c7dd6c4f33796462);

var $h3xRX = parcelRequire("h3xRX");

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $3BZyK = parcelRequire("3BZyK");

var $k2M4v = parcelRequire("k2M4v");
const $c2b32fe52c53d60d$var$HubBrandPrimaryColorQueryRenderer = ({ children: children, cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
    var _data$helpCenter;
    // Same field and arguments as the hub bootstrap query (`isDraft: false` included), so Relay
    // normally answers this from the store. Its own query because the bootstrap's copy is masked
    // inside company-hub-common's fragment.
    const data = (0, $3BZyK.useLazyLoadQuery)((0, $h3xRX.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const primary = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(primary || undefined));
};
const $c2b32fe52c53d60d$export$c7dd6c4f33796462 = ({ children: children, cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
    if (!(0, $k2M4v.default).checkGate('hub_rovo_brand_theming')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(undefined));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iya1I.default), {
        packageName: "help-center",
        id: "rovo-widget-brand-primary-color",
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, children(undefined))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c2b32fe52c53d60d$var$HubBrandPrimaryColorQueryRenderer, {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, children)));
};

});
parcelRegister("h3xRX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2c2dc57b9cce59a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbaeb8f8bf4429e3203b9c9c3a9901ec>>
 * @relayHash f228feb835a19a0dfb5caa604c2aa5cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1c5bad114e75126d04562782a1a51eaf52bb0b6949001372eedd5ab4abf3490
const $f2c2dc57b9cce59a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Literal",
            "name": "isDraft",
            "value": false
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hubBrandPrimaryColorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hubBrandPrimaryColorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f1c5bad114e75126d04562782a1a51eaf52bb0b6949001372eedd5ab4abf3490",
            "metadata": {},
            "name": "hubBrandPrimaryColorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f2c2dc57b9cce59a$var$node.hash = "2522af675a8061e00c4c76881c160677";
var $f2c2dc57b9cce59a$export$2e2bcd8739ae039 = $f2c2dc57b9cce59a$var$node;

});


parcelRegister("3RD5l", function(module, exports) {
$parcel$export(module.exports, "PortalRovoWidget", () => $6bcb91b60f9c0bf1$export$73805f5dce71ead8);

var $fc4bM = parcelRequire("fc4bM");

var $ikzOZ = parcelRequire("ikzOZ");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");
parcelRequire("57GTn");
var $9D9SX = parcelRequire("9D9SX");

var $5svsU = parcelRequire("5svsU");

var $dQMHQ = parcelRequire("dQMHQ");
const $6bcb91b60f9c0bf1$export$9490f57ca961f41 = ({ cloudId: cloudId, projectId: projectId, brandPrimaryColor: brandPrimaryColor })=>{
    if (!projectId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dQMHQ.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: (0, $5svsU.JiraProjectAri).create({
            projectId: projectId.toString(),
            siteId: cloudId
        }).toString(),
        surface: "HUB",
        ...brandPrimaryColor ? {
            brandPrimaryColor: brandPrimaryColor
        } : {}
    });
};
const $6bcb91b60f9c0bf1$export$73805f5dce71ead8 = (0, $6umft.default)((state, { portalId: portalId })=>({
        // `toSafeInteger` directly rather than `getPortalIdAsNumber` from `view/search/common`: that
        // barrel pulls in analytics-components -> history -> getMeta, which blows up at import time.
        projectId: (0, $9D9SX.getProjectId)(state, (0, (/*@__PURE__*/$parcel$interopDefault($ikzOZ)))(portalId))
    }))($6bcb91b60f9c0bf1$export$9490f57ca961f41);

});



parcelRegister("4kdFG", function(module, exports) {
$parcel$export(module.exports, "JSMCookieConsentBanner", () => (parcelRequire("ehNa5")).SSRSafeJSMCookieConsentBanner);

var $ehNa5 = parcelRequire("ehNa5");

});
parcelRegister("ehNa5", function(module, exports) {
$parcel$export(module.exports, "SSRSafeJSMCookieConsentBanner", () => $e611d17329061a58$export$757e76e75a25cb0c);

var $fc4bM = parcelRequire("fc4bM");

var $eKKM5 = parcelRequire("eKKM5");

var $k2M4v = parcelRequire("k2M4v");

var $368I3 = parcelRequire("368I3");

var $vIpzx = parcelRequire("vIpzx");

var $k8XFy = parcelRequire("k8XFy");

var $2jQ6M = parcelRequire("2jQ6M");


var $7rEw1 = parcelRequire("7rEw1");
/**
 * Feature gate: csm-cm04-use-atlassian-browser-storage-controls
 *
 * Enables Atlassian-managed browser storage controls (webStorageEnabled) for the
 * CSM/JSM Help Center cookie consent banner.
 *
 * Note: registered as kebab-case in Statsig/Switcheroo; do not convert to snake_case.
 *
 * Rollout: BEARS-1324
 * Owner: @team-bears
 * Cleanup: FFCLEANUP-122701
 */ const $e611d17329061a58$var$CSM_CM04_USE_ATLASSIAN_BROWSER_STORAGE_CONTROLS = 'csm-cm04-use-atlassian-browser-storage-controls';
const $e611d17329061a58$var$isCsmCm04UseAtlassianBrowserStorageControlsEnabled = ()=>(0, $k2M4v.default).checkGate($e611d17329061a58$var$CSM_CM04_USE_ATLASSIAN_BROWSER_STORAGE_CONTROLS);
const $e611d17329061a58$export$757e76e75a25cb0c = ()=>{
    const ssrInput = (0, $eKKM5.getSSRInput)();
    const consentToken = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesConsentToken);
    const fallbackConsentToken = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesFallbackToken);
    const cookieData = consentToken ? {
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    } : {
        fallbackConsentToken: fallbackConsentToken
    };
    (0, $fc4bM.useEffect)(()=>{
        const perimeter = (0, $7rEw1.isFedRamp)() ? 'fedramp-moderate' : 'commercial';
        if (!$e611d17329061a58$var$isCsmCm04UseAtlassianBrowserStorageControlsEnabled()) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $vIpzx.initializeControls)({
                product: 'jira'
            });
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $vIpzx.initializeControls)({
            perimeter: perimeter,
            product: 'jira',
            // Storage is enabled with webStorage + indexedDB consent enforcement always on.
            webStorageEnabled: true,
            indexedDbEnabled: true,
            disableWebStorageConsentChecks: false,
            disableIndexedDbConsentChecks: false,
            // Uncategorized web-storage/indexedDB keys are always blocked.
            allowUncategorizedItemsInWebStorageOverrides: false,
            allowUncategorizedItemsInIndexedDBOverrides: false
        });
    }, []);
    // The case of only the fallbackConsentToken being present is handled differently on the
    // server and on the client. So in order to SSR the same way, we have handle this case
    // specially. Only fallback token being present on the client results in banner not being shown.
    // However, if we pass that cookie data into the initialPreferences on the client, there is a short
    // flicker of the consent banner. So we also have to special case this on the client.
    const onlyFallbackTokenPresent = Boolean(fallbackConsentToken && !consentToken);
    return(// Wrapper needed for stable DOM to rehydrate. Otherwise, rehydration failures may break the entire page when
    // this returns a banner in SSR and no banner/null in CSR (or the other way around).
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": 'jsm-cookie-consent-banner-wrapper'
    }, onlyFallbackTokenPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $368I3.ConsentBanner), {
        product: "jira"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $368I3.ConsentBanner), {
        product: "jira",
        initialPreferences: cookieData
    })));
};

});
parcelRegister("eKKM5", function(module, exports) {
$parcel$export(module.exports, "getSSRInput", () => $8585659c03c6a9fd$export$57d34b7c393d6ac0);

const $8585659c03c6a9fd$export$57d34b7c393d6ac0 = ()=>{
    var error;
    return undefined;
};

});

parcelRegister("368I3", function(module, exports) {
$parcel$export(module.exports, "ConsentBanner", () => $c1f0ca499a57f7af$export$903b95b8397e77e9);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $c4StN = parcelRequire("c4StN");

var $dRkX9 = parcelRequire("dRkX9");

var $3k55j = parcelRequire("3k55j");

var $2meLc = parcelRequire("2meLc");
const $c1f0ca499a57f7af$export$903b95b8397e77e9 = (props)=>{
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $dRkX9.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $fc4bM.useEffect)(()=>{
            onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c4StN.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2meLc.ConsentBannerImpl), props)));
};

});
parcelRegister("2meLc", function(module, exports) {
$parcel$export(module.exports, "ConsentBannerImpl", () => $7a1cea5dd1111f1a$export$24af610f9b900e82);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");
var $gpjDl = parcelRequire("gpjDl");

var $c4StN = parcelRequire("c4StN");

var $abHGL = parcelRequire("abHGL");

var $gDsF8 = parcelRequire("gDsF8");

var $fBVBf = parcelRequire("fBVBf");

var $2KlgS = parcelRequire("2KlgS");

var $92ZnW = parcelRequire("92ZnW");
var $g5Y6L = parcelRequire("g5Y6L");

var $8dlZC = parcelRequire("8dlZC");

var $3k55j = parcelRequire("3k55j");

var $2jQ6M = parcelRequire("2jQ6M");

var $g0kQx = parcelRequire("g0kQx");
var $k8XFy = parcelRequire("k8XFy");

var $eGlBA = parcelRequire("eGlBA");

var $eo2f2 = parcelRequire("eo2f2");

var $3c0fv = parcelRequire("3c0fv");

var $jFHxM = parcelRequire("jFHxM");

var $aSYuC = parcelRequire("aSYuC");

var $h5poQ = parcelRequire("h5poQ");
const $7a1cea5dd1111f1a$var$SuccessWithIntl = (0, $fcCIH.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: "spacious"
    }));
const $7a1cea5dd1111f1a$var$ErrorWithIntl = (0, $fcCIH.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: "spacious"
    }));
const $7a1cea5dd1111f1a$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7a1cea5dd1111f1a$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $7a1cea5dd1111f1a$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($7a1cea5dd1111f1a$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $7a1cea5dd1111f1a$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter })=>{
    const firstRender = (0, $fc4bM.useRef)(true);
    (0, $fc4bM.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $g5Y6L.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $g0kQx.deleteCookie)((0, $2jQ6M.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        (0, $92ZnW.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $fc4bM.useState)(false);
    const intl = (0, $gpjDl.default)();
    const { showFlag: showFlag } = (0, $abHGL.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $jFHxM.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $h5poQ.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $fc4bM.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $fc4bM.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $fc4bM.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $g5Y6L.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $fc4bM.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$7a1cea5dd1111f1a$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $eo2f2.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $eo2f2.i18n).successFlagTitle)
        });
        else showFlag({
            ...$7a1cea5dd1111f1a$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $eo2f2.i18n).successFlagDescription),
            title: intl.formatMessage((0, $eo2f2.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $fc4bM.useCallback)(()=>{
        showFlag({
            ...$7a1cea5dd1111f1a$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $eo2f2.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $eo2f2.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $fc4bM.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $g5Y6L.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $eGlBA.updatePreferences)((0, $2jQ6M.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $g5Y6L.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $2jQ6M.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $fc4bM.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $g5Y6L.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $eGlBA.updatePreferences)((0, $2jQ6M.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $g5Y6L.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $2jQ6M.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $fc4bM.useCallback)(()=>{
        (0, $g5Y6L.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $fc4bM.useEffect)(()=>{
        if (showBanner) (0, $2KlgS.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow === null || onShow === void 0 || onShow();
        else if (!showBanner) onHide === null || onHide === void 0 || onHide();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c4StN.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8dlZC.BSCIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aSYuC.PresentationalConsentBanner), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth,
        newMinHeight: newMinHeight
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3c0fv.PreferenceModal), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag,
        shouldAddWrappers: false
    })));
};

});
parcelRegister("2KlgS", function(module, exports) {
$parcel$export(module.exports, "addUFOCustomData", () => $0ca0a53798b2b636$export$d12f56a472cdbe6c);

var $ifobP = parcelRequire("ifobP");

var $jQYQa = parcelRequire("jQYQa");
function $0ca0a53798b2b636$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $ifobP.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') (0, $jQYQa.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $jQYQa.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("92ZnW", function(module, exports) {
$parcel$export(module.exports, "initializeGlobalState", () => $eb7ce42c3c63798c$export$882c4530c58781d8);

var $7VVXk = parcelRequire("7VVXk");

var $dRkX9 = parcelRequire("dRkX9");

var $cjHoj = parcelRequire("cjHoj");

var $8tbFP = parcelRequire("8tbFP");

var $3k55j = parcelRequire("3k55j");

var $bqFvR = parcelRequire("bqFvR");

var $eqqb5 = parcelRequire("eqqb5");
const $eb7ce42c3c63798c$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, packageLogLevel: packageLogLevel, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter, analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $3k55j.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $eqqb5.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $eqqb5.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $eqqb5.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $dRkX9.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $eqqb5.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $dRkX9.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $eqqb5.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $eqqb5.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $eqqb5.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, $eqqb5.__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $eqqb5.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $eqqb5.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    if ((0, $eqqb5.__internalGetHasInitialized)() && !overrideOnceParams) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $7VVXk.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $8tbFP.CacheLoader)((0, $cjHoj.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $8tbFP.CacheLoader)((0, $cjHoj.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $8tbFP.CacheLoader)((0, $cjHoj.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $8tbFP.CacheLoader)((0, $cjHoj.CategoryStorageType).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $eqqb5.__internalApplyInitialState)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, $bqFvR.resetLogLevelCache)();
};

});
parcelRegister("8tbFP", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $4af6badb59a3d333$export$e479342c697b82a9);

var $41a4X = parcelRequire("41a4X");

var $dRkX9 = parcelRequire("dRkX9");

var $9LFKj = parcelRequire("9LFKj");

var $atXmE = parcelRequire("atXmE");

var $eqqb5 = parcelRequire("eqqb5");

var $8OoGb = parcelRequire("8OoGb");

var $3k55j = parcelRequire("3k55j");

var $8U3CO = parcelRequire("8U3CO");
class $4af6badb59a3d333$export$e479342c697b82a9 {
    constructor(storageType, perimeter){
        // Asked for, not passed in: whoever constructs a loader gets the layout this process already
        // decided to fetch, so no caller can hand it a format that disagrees with everyone else's.
        this.fetchedPatternFormat = (0, $8OoGb.getFetchPatternFormat)();
        // Auto-detect perimeter from the Atl-Ctx-Perimeter cookie when not explicitly provided.
        // isFedrampModerate() reads the cookie set by the platform; if absent, the perimeter is commercial.
        // Gated by platform_bsc_auto_detect_perimeter for safe rollout.
        // Wrapped in try/catch to ensure a cookie-read failure never breaks BSC initialisation.
        const detectPerimeter = ()=>{
            try {
                return (0, $41a4X.isFedrampModerate)() ? 'fedramp-moderate' : 'commercial';
            } catch (e) {
                (0, $3k55j.Logger).errorWithOperationalEvent({
                    action: 'detectPerimeterError',
                    message: (e === null || e === void 0 ? void 0 : e.message) || 'Failed to detect perimeter via isFedrampModerate'
                });
                return 'commercial';
            }
        };
        const resolvedPerimeter = perimeter ?? ((0, $dRkX9.fg)('platform_bsc_auto_detect_perimeter') ? detectPerimeter() : 'commercial');
        const useFlatFormat = this.fetchedPatternFormat === 'flat';
        const cacheUrlLookup = (0, $8U3CO.getCategoryCacheUrlPerimeterLookup)(useFlatFormat)[resolvedPerimeter] || (0, $8U3CO.getCommercialCategoryCacheUrlLookup)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    /**
   * The format of the file this loader fetches.
  	* TEMPORARY: Will be removed when `platform_bsc_ssr_flat_pattern_file_format` is cleaned up.
   */ getFetchedPatternFormat() {
        return this.fetchedPatternFormat;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $9LFKj.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $atXmE.ExperienceTypes).Load,
                performanceType: (0, $atXmE.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $3k55j.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            // Record what we actually fetched, so pattern matching never has to re-evaluate the
            // rollout gate to work out how to read it. clearStorageControlsDataCache() drops the
            // payload, so a re-fetch re-records from that loader's own format. A malformed response
            // can parse to a primitive, which cannot carry the field — those fall back to the legacy
            // trie reading, and match nothing either way.
            if (typeof this.localResponseCache === 'object' && this.localResponseCache !== null) this.localResponseCache.patternFormat = this.fetchedPatternFormat;
            (0, $eqqb5.__internalSetCacheLoadedDate)(new Date().toISOString().slice(0, 10));
            // Extract and store CDN file version (write-once: first loader to resolve wins)
            if (typeof this.localResponseCache === 'object' && this.localResponseCache !== null && this.localResponseCache.version) (0, $eqqb5.__internalSetCdnFileVersion)(this.localResponseCache.version);
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("8OoGb", function(module, exports) {
$parcel$export(module.exports, "UNSAFE__setFetchPatternFormatFromResolvedFlag", () => $73ed4ebdd5aacdee$export$711aafe8a89fd09c);
$parcel$export(module.exports, "getFetchPatternFormat", () => $73ed4ebdd5aacdee$export$38a9c01091046388);

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");

var $iPmiQ = parcelRequire("iPmiQ");
const $73ed4ebdd5aacdee$export$43a35c1452d55dd7 = ()=>{
    if (!(0, $iPmiQ.isSSR)()) return true;
    return (0, $eqqb5.__internalGetResolvedFlatPatternFileFormat)() ?? (0, $dRkX9.fg)('platform_bsc_ssr_flat_pattern_file_format');
};
const $73ed4ebdd5aacdee$export$711aafe8a89fd09c = (value)=>{
    (0, $eqqb5.__internalSetResolvedFlatPatternFileFormat)(value);
};
const $73ed4ebdd5aacdee$export$38a9c01091046388 = ()=>{
    const decided = (0, $eqqb5.__internalGetPatternFormat)();
    if (decided) return decided;
    const patternFormat = $73ed4ebdd5aacdee$export$43a35c1452d55dd7() ? 'flat' : 'trie';
    (0, $eqqb5.__internalSetPatternFormat)(patternFormat);
    return patternFormat;
};

});

parcelRegister("8U3CO", function(module, exports) {
$parcel$export(module.exports, "getCommercialCategoryCacheUrlLookup", () => $79a089d0fc729ae6$export$5989415260e0cf82);
$parcel$export(module.exports, "getCategoryCacheUrlPerimeterLookup", () => $79a089d0fc729ae6$export$9797a362f9385b1a);

var $cjHoj = parcelRequire("cjHoj");

var $8OoGb = parcelRequire("8OoGb");
var $79a089d0fc729ae6$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $79a089d0fc729ae6$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $79a089d0fc729ae6$var$baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
const $79a089d0fc729ae6$var$baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
const $79a089d0fc729ae6$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${$79a089d0fc729ae6$var$baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${$79a089d0fc729ae6$var$baseBifrostCommercialPath}${fileName}`;
        default:
            return `${$79a089d0fc729ae6$var$baseBifrostCommercialPath}${fileName}`;
    }
};
const $79a089d0fc729ae6$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $cjHoj.CategoryStorageType).Cookies]: $79a089d0fc729ae6$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $cjHoj.CategoryStorageType).LocalStorage]: $79a089d0fc729ae6$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $cjHoj.CategoryStorageType).SessionStorage]: $79a089d0fc729ae6$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $cjHoj.CategoryStorageType).IndexedDB]: $79a089d0fc729ae6$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $79a089d0fc729ae6$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $79a089d0fc729ae6$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $cjHoj.CategoryStorageType).Cookies]: $79a089d0fc729ae6$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $cjHoj.CategoryStorageType).LocalStorage]: $79a089d0fc729ae6$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $cjHoj.CategoryStorageType).SessionStorage]: $79a089d0fc729ae6$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $cjHoj.CategoryStorageType).IndexedDB]: $79a089d0fc729ae6$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $79a089d0fc729ae6$export$1f60178895e28eb8 = (source, perimeter, storageType, UNSAFE__resolvedFlatPatternFileFormat)=>{
    if (UNSAFE__resolvedFlatPatternFileFormat !== undefined) (0, $8OoGb.UNSAFE__setFetchPatternFormatFromResolvedFlag)(UNSAFE__resolvedFlatPatternFileFormat);
    return $79a089d0fc729ae6$var$generateResourcePath(perimeter, storageType, (0, $8OoGb.getFetchPatternFormat)() === 'flat');
};

});



parcelRegister("g0kQx", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $e2c1809e4fe70264$export$b43e45590305ffaa);

var $aEAmK = parcelRequire("aEAmK");

var $dRkX9 = parcelRequire("dRkX9");

var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");
const $e2c1809e4fe70264$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, $aEAmK.default).remove(key, attributes);
    else try {
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $aEAmK.default).remove(key, attributes);
    } catch (e) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});

parcelRegister("eo2f2", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $86026b9d6bc064a6$export$a7357cdd1f0b0168);

var $8p5Cv = parcelRequire("8p5Cv");
const $86026b9d6bc064a6$export$a7357cdd1f0b0168 = (0, $8p5Cv.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("aSYuC", function(module, exports) {
$parcel$export(module.exports, "PresentationalConsentBanner", () => $cb600a4769caa757$export$dd3e60478510f81d);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $5dzEI = parcelRequire("5dzEI");

var $jaqgn = parcelRequire("jaqgn");

var $bQrkt = parcelRequire("bQrkt");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $1zYKE = parcelRequire("1zYKE");

var $kig2V = parcelRequire("kig2V");

var $bcTS3 = parcelRequire("bcTS3");

var $bdFEn = parcelRequire("bdFEn");

var $eo2f2 = parcelRequire("eo2f2");
const $cb600a4769caa757$var$boxStylesPurpleWithMinHeight = (0, $kig2V.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $cb600a4769caa757$var$noticeContainerStyles = (0, $kig2V.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $cb600a4769caa757$var$inlineWrapperStylesStaticHeight = (0, $kig2V.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $1zYKE.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $cb600a4769caa757$var$buttonContainerStylesStaticHeight = (0, $kig2V.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $1zYKE.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $cb600a4769caa757$var$truncatedTextStyles = (0, $kig2V.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $cb600a4769caa757$var$linkNoTruncateStyles = (0, $kig2V.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $cb600a4769caa757$var$smallMediumScreenContainerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $1zYKE.media).above.md]: {
        display: 'none'
    }
});
const $cb600a4769caa757$var$largeScreenContainerStyles = (0, $kig2V.xcss)({
    display: 'none',
    [(0, $1zYKE.media).above.md]: {
        display: 'block'
    }
});
const $cb600a4769caa757$var$noop = ()=>{};
const $cb600a4769caa757$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $bdFEn.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $eo2f2.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $eo2f2.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $cb600a4769caa757$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $eo2f2.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $eo2f2.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $cb600a4769caa757$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $cb600a4769caa757$var$noop, onClickAcceptAll: onClickAcceptAll = $cb600a4769caa757$var$noop, onClickPreferences: onClickPreferences = $cb600a4769caa757$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $cb600a4769caa757$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const intl = (0, $gpjDl.default)();
    const displayedTextMap = (0, $fc4bM.useMemo)(()=>{
        return $cb600a4769caa757$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $fc4bM.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $cb600a4769caa757$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $fc4bM.useCallback)(()=>{
        const displayedTextAcceptAllMap = $cb600a4769caa757$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $cb600a4769caa757$var$boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: $cb600a4769caa757$var$inlineWrapperStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: $cb600a4769caa757$var$noticeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: $cb600a4769caa757$var$smallMediumScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $eo2f2.i18n).useCookiesDescriptionNoLink),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        xcss: $cb600a4769caa757$var$truncatedTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $eo2f2.i18n).useCookiesDescriptionNoLink,
        tagName: "span"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bQrkt.Anchor), {
        id: "cookiesTrackingNoticeLink",
        href: "https://www.atlassian.com/legal/cookies",
        target: "_blank",
        onClick: onClickTrackingNoticeLink,
        xcss: $cb600a4769caa757$var$linkNoTruncateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $eo2f2.i18n).cookiesTrackingNotice))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5a4EU.Box), {
        xcss: $cb600a4769caa757$var$largeScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $eo2f2.i18n).useCookiesDescription,
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bQrkt.Anchor), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $eo2f2.i18n).cookiesTrackingNotice))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lgMZ2.Inline), {
        space: "space.100",
        xcss: $cb600a4769caa757$var$buttonContainerStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        testId: "preferences-button",
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $eo2f2.i18n).preferencesBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        testId: "only-necessary-button",
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $eo2f2.i18n).onlyNecessaryBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
        testId: "accept-all-button",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jaqgn))),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $eo2f2.i18n).acceptAllBtn)))));
};

});

parcelRegister("h5poQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce40943cdcb6f194$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $eqqb5 = parcelRequire("eqqb5");
var $g5Y6L = parcelRequire("g5Y6L");

var $iPmiQ = parcelRequire("iPmiQ");

var $2jQ6M = parcelRequire("2jQ6M");

var $e0TXu = parcelRequire("e0TXu");

var $fIv8k = parcelRequire("fIv8k");

var $k8XFy = parcelRequire("k8XFy");

var $cjHoj = parcelRequire("cjHoj");
const $ce40943cdcb6f194$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions !== null && ssrOptions !== void 0 && ssrOptions.getCookie ? ssrOptions.getCookie((0, $2jQ6M.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $k8XFy.getCookie)((0, $2jQ6M.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if (((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $iPmiQ.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $cjHoj.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $e0TXu.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $ce40943cdcb6f194$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $fc4bM.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $fc4bM.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $fIv8k.setStrictlyNecessaryCookie)((0, $2jQ6M.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $fc4bM.useMemo)(()=>{
        return $ce40943cdcb6f194$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $g5Y6L.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $ce40943cdcb6f194$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $eqqb5.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if ((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $iPmiQ.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $ce40943cdcb6f194$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $ce40943cdcb6f194$export$2e2bcd8739ae039 = $ce40943cdcb6f194$var$useBannerVisibility;

});
parcelRegister("e0TXu", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $03f9049ccdcf754a$export$6406464aa126433e);

var $dRkX9 = parcelRequire("dRkX9");

var $cXyAq = parcelRequire("cXyAq");

var $lmMgc = parcelRequire("lmMgc");

var $dzMIZ = parcelRequire("dzMIZ");

var $kcA52 = parcelRequire("kcA52");
const $03f9049ccdcf754a$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $dzMIZ.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $kcA52.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $lmMgc.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $cXyAq.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $kcA52.getBannerVisibility)(consentPrefsData, ssrOptions);
};

});




parcelRegister("vIpzx", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $07d160304a83b8e7$export$919040c32a62c7db);

var $dRkX9 = parcelRequire("dRkX9");

var $g5Y6L = parcelRequire("g5Y6L");
var $iPmiQ = parcelRequire("iPmiQ");
var $3k55j = parcelRequire("3k55j");

var $eqqb5 = parcelRequire("eqqb5");
var $92ZnW = parcelRequire("92ZnW");
parcelRequire("hPIXE");
var $jvA59 = parcelRequire("jvA59");

var $76fiM = parcelRequire("76fiM");

var $9tTwx = parcelRequire("9tTwx");

var $1hoSb = parcelRequire("1hoSb");

var $cEVW9 = parcelRequire("cEVW9");
/**
 * Shared by both `platform_bsc_sync_initialize_controls` branches so the consent-check decision can
 * never diverge between the sync and the legacy path.
 */ const $07d160304a83b8e7$var$getIndexedDbPassthroughConfig = ()=>{
    const disableIndexedDbConsentChecks = (0, $eqqb5.getBscGlobalState)().disableIndexedDbConsentChecks ?? false;
    return {
        performConsentChecks: !disableIndexedDbConsentChecks
    };
};
const $07d160304a83b8e7$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $dRkX9.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, $3k55j.Logger).debug('initializeControls invoked');
        (0, $92ZnW.initializeGlobalState)({
            ...args,
            overrideOnceParams: true
        });
        if ((0, $iPmiQ.isSSR)()) return undefined;
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                allowUncategorizedItemsInIndexedDBOverrides: args.allowUncategorizedItemsInIndexedDBOverrides,
                perimeter: args.perimeter
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $g5Y6L.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        if ((0, $dRkX9.fg)('platform_bsc_sync_initialize_controls')) {
            // Install every override on the calling tick. Because nothing below awaits, this whole
            // `async` function body runs to completion synchronously — so a product that calls
            // `initializeControls` without awaiting it still has all overrides in place the moment the
            // call returns. There is no longer a window in which `document.cookie` / `setItem` /
            // `indexedDB.open` bypass consent enforcement.
            //
            // Synchronous throws still reach the `catch` below, so the `initializeControlsError`
            // operational event and the abort-on-first-failure behaviour are unchanged. That would NOT
            // hold if we merely dropped the `await`s from the legacy `create*Passthrough` functions: a
            // sync throw inside an `async` function surfaces as a rejected promise, not a thrown error.
            (0, $9tTwx.createDocumentCookiePassthroughSync)();
            if ((0, $eqqb5.getBscGlobalState)().webStorageEnabled) {
                (0, $cEVW9.createWebStoragePassthroughSync)((0, $jvA59.WebStorageType).LocalStorage);
                (0, $cEVW9.createWebStoragePassthroughSync)((0, $jvA59.WebStorageType).SessionStorage);
            }
            if ((0, $eqqb5.getBscGlobalState)().indexedDbEnabled) (0, $1hoSb.createIndexedDBPassthroughSync)($07d160304a83b8e7$var$getIndexedDbPassthroughConfig());
        } else {
            await (0, $9tTwx.createDocumentCookiePassthrough)();
            const isWebStorageControlsEnabled = (0, $eqqb5.getBscGlobalState)().webStorageEnabled;
            if (isWebStorageControlsEnabled) {
                // Serial, not `Promise.all`: `BSCIndexedDB.boot()` short-circuits on its promise cache for
                // concurrent callers, so parallelising would install the SessionStorage override before
                // the DB is open.
                await (0, $cEVW9.createWebStoragePassthrough)((0, $jvA59.WebStorageType).LocalStorage);
                await (0, $cEVW9.createWebStoragePassthrough)((0, $jvA59.WebStorageType).SessionStorage);
            }
            const isIndexedDbEnabled = (0, $eqqb5.getBscGlobalState)().indexedDbEnabled;
            if (isIndexedDbEnabled) await (0, $1hoSb.createIndexedDBPassthrough)($07d160304a83b8e7$var$getIndexedDbPassthroughConfig());
        }
        (0, $3k55j.Logger).debug('initializeControls finished');
        const storageCleanupPromise = (0, $76fiM.cleanupStorage)();
        initResult = Object.assign(initResult ?? {}, {
            storageCleanupPromise: storageCleanupPromise
        });
    } catch (e) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};

});
parcelRegister("76fiM", function(module, exports) {
$parcel$export(module.exports, "cleanupStorage", () => $fd5d8119c80a98eb$export$e6332b39565fb2b3);

var $aEAmK = parcelRequire("aEAmK");

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");
var $3k55j = parcelRequire("3k55j");
var $g5Y6L = parcelRequire("g5Y6L");

var $ckf9y = parcelRequire("ckf9y");

var $hPIXE = parcelRequire("hPIXE");
var $jvA59 = parcelRequire("jvA59");

var $cjHoj = parcelRequire("cjHoj");

var $fWQ0G = parcelRequire("fWQ0G");
function $fd5d8119c80a98eb$var$isCategoryRevoked({ category: category, preferences: preferences }) {
    if (category === (0, $cjHoj.PreferenceCategory).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function $fd5d8119c80a98eb$var$yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const $fd5d8119c80a98eb$var$ITEMS_PER_YIELD = 50;
// Per-run enumeration cap. Yielding to the main thread every ITEMS_PER_YIELD items is independent
// of the limit, so the loop stays cooperative however high this is set.
const $fd5d8119c80a98eb$var$ENUMERATION_LIMIT = 10000;
const $fd5d8119c80a98eb$export$54394d3cfbbf53d0 = 1000;
// `deleteDatabase` completes only once every other connection to that database closes, which the
// browser asks for by firing `versionchange` on each of them. Nothing obliges a holder to listen, so
// the wait needs a bound. Confirmations run concurrently, making this the cost to a run rather than
// the cost per database.
const $fd5d8119c80a98eb$var$IDB_DELETE_CONFIRM_TIMEOUT_MS = 500;
function $fd5d8119c80a98eb$var$isRunningInFrame() {
    try {
        return window.top !== window.self;
    } catch  {
        // A cross-origin read of `window.top` throws, which itself proves we are framed.
        return true;
    }
}
/**
 * Resolves for every outcome rather than rejecting, so one database cannot fail a whole run.
 *
 * `blocked` is deliberately not handled: it is not an outcome. Another open connection leaves the
 * request pending, and `success` still arrives if those connections close, so treating `blocked` as
 * a failure would report a delete that then went through as undeleted. The deadline decides instead
 * — unblocked in time counts as deleted, still blocked when it expires does not.
 */ function $fd5d8119c80a98eb$var$deleteDatabaseAndConfirm(idb, name) {
    return new Promise((resolve)=>{
        let settled = false;
        let timeoutId;
        const settle = (deleted)=>{
            if (settled) return;
            settled = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            resolve(deleted);
        };
        const request = idb.deleteDatabase(name);
        request.onsuccess = ()=>settle(true);
        request.onerror = ()=>{
            var _request$error;
            (0, $3k55j.Logger).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${((_request$error = request.error) === null || _request$error === void 0 ? void 0 : _request$error.message) ?? ''}`);
            settle(false);
        };
        timeoutId = setTimeout(()=>settle(false), $fd5d8119c80a98eb$var$IDB_DELETE_CONFIRM_TIMEOUT_MS);
    });
}
/**
 * A cookie is identified by name + domain + path, and `document.cookie` exposes only the name. An
 * expiry therefore has to guess the other two, and a guess that misses is silently accepted by the
 * browser, so reading the cookie back is the only way to know it went away.
 *
 * Two scopes are tried: host-only, then the served host as an explicit `domain`, because scoping to
 * `Domain=<current host>` is a common library default that a host-only expiry cannot match.
 *
 * Known limitations, all reported as `false` rather than papered over:
 *
 * - **No domain above the served host is tried.** A cookie on a parent or registrable domain — where
 *   the vendor tags we embed (`_ga`, `_fbp`, `_gcl_au`) and our own cross-property cookies live — is
 *   out of reach.
 * - **Non-root paths are never tried.** js-cookie defaults to `path=/`.
 * - **`HttpOnly` cookies are invisible here**, so they are never even enumerated.
 */ function $fd5d8119c80a98eb$var$deleteCookieAndConfirm(key) {
    // `__Secure-`/`__Host-` names are rejected unless the expiring `Set-Cookie` also carries
    // `Secure`. It is not part of a cookie's identity so it is harmless on ordinary cookies, but a
    // non-secure origin ignores the whole header, so only send it where it can take effect.
    const secure = window.location.protocol === 'https:' ? {
        secure: true
    } : {};
    // `atl-set-cookie` marks both expiries below as the package's own writes, which is what the
    // `document.cookie` setter override checks before passing one through. Without it the override
    // consent-checks the expiry against the very category the cookie is being deleted for, takes its
    // blocked branch, and never calls the original setter.
    (0, $aEAmK.default).remove(key, {
        ...secure,
        'atl-set-cookie': true
    });
    if ((0, $aEAmK.default).get(key) === undefined) return true;
    // Still there, so the cookie carries an explicit `Domain`. Two names make even the served-host
    // attempt pointless: a `__Host-` cookie must be host-only, and on a single-label host
    // (`localhost`, an intranet name) `.localhost` matches nothing.
    const { hostname: hostname } = window.location;
    if (key.startsWith('__Host-') || hostname.split('.').length < 2) return false;
    (0, $aEAmK.default).remove(key, {
        ...secure,
        domain: `.${hostname}`,
        'atl-set-cookie': true
    });
    return (0, $aEAmK.default).get(key) === undefined;
}
async function $fd5d8119c80a98eb$export$e6332b39565fb2b3() {
    // One read per run, outside the try so the catch path agrees. `fg()` reads gate config that can
    // change mid-run and this function's p99 is seconds, so re-reading risks a run that deletes
    // while reporting `dry-run`.
    const deletionMode = (0, $dRkX9.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run';
    const isLiveDelete = deletionMode === 'live';
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, $eqqb5.getBscGlobalState)();
        const preferences = await (0, $fWQ0G.getPreferences)();
        const localStorage = (0, $hPIXE.findStorageTarget)((0, $jvA59.WebStorageType).LocalStorage);
        const sessionStorage = (0, $hPIXE.findStorageTarget)((0, $jvA59.WebStorageType).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, $cjHoj.CategoryStorageType).LocalStorage),
            globalState.loadCache((0, $cjHoj.CategoryStorageType).SessionStorage),
            globalState.loadCache((0, $cjHoj.CategoryStorageType).Cookies),
            globalState.loadCache((0, $cjHoj.CategoryStorageType).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        const skippedTypes = [];
        const undeletedItems = [];
        const inFrame = $fd5d8119c80a98eb$var$isRunningInFrame();
        const pendingIdbConfirmations = [];
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (!localStorageCache) skippedTypes.push({
            storageType: 'localStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // Cleanup is an internal operation, so it works on the store the wrapper wraps rather than
            // through the wrapper: the read-back below is untrapped, where the wrapper's `getItem`
            // emits `usedAtlBrowserStorageGetItem` on every call. Keys are taken up front so a removal
            // cannot shift the items still to be visited. `Object.keys` would be shorter but omits any
            // item whose name collides with a `Storage` own property — WebKit hides a stored `length`
            // from it, where `key(i)` still reports it.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const localStore = localStorage.storage;
            const localKeys = Array.from({
                length: localStore.length
            }, (_, i)=>localStore.key(i)).filter((key)=>key !== null);
            for (const key of localKeys){
                if (itemsProcessed >= $fd5d8119c80a98eb$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $fd5d8119c80a98eb$var$ITEMS_PER_YIELD === 0) await $fd5d8119c80a98eb$var$yieldToMain();
                const category = (0, $ckf9y.getItemCategoryFromPassedCache)(key, localStorageCache, productName);
                if (category === null || category === (0, $cjHoj.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'localStorage'
                });
                else if ($fd5d8119c80a98eb$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'localStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        localStore.removeItem(key);
                        const removed = localStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // sessionStorage
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'enumerationLimit'
        });
        else if (!sessionStorageCache) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const sessionStore = sessionStorage.storage;
            const sessionKeys = Array.from({
                length: sessionStore.length
            }, (_, i)=>sessionStore.key(i)).filter((key)=>key !== null);
            for (const key of sessionKeys){
                if (itemsProcessed >= $fd5d8119c80a98eb$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $fd5d8119c80a98eb$var$ITEMS_PER_YIELD === 0) await $fd5d8119c80a98eb$var$yieldToMain();
                const category = (0, $ckf9y.getItemCategoryFromPassedCache)(key, sessionStorageCache, productName);
                if (category === null || category === (0, $cjHoj.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'sessionStorage'
                });
                else if ($fd5d8119c80a98eb$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'sessionStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        sessionStore.removeItem(key);
                        const removed = sessionStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // cookies
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'cookie',
            reason: 'enumerationLimit'
        });
        else if (!cookieCache) skippedTypes.push({
            storageType: 'cookie',
            reason: 'cacheUnavailable'
        });
        else for (const key of Object.keys((0, $aEAmK.default).get())){
            if (itemsProcessed >= $fd5d8119c80a98eb$var$ENUMERATION_LIMIT) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $fd5d8119c80a98eb$var$ITEMS_PER_YIELD === 0) await $fd5d8119c80a98eb$var$yieldToMain();
            const category = (0, $ckf9y.getItemCategoryFromPassedCache)(key, cookieCache, productName);
            if (category === null || category === (0, $cjHoj.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'cookie'
            });
            else if ($fd5d8119c80a98eb$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                const item = {
                    key: key,
                    storageType: 'cookie',
                    category: category
                };
                revokedItems.push(item);
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if (isLiveDelete) {
                    item.deleted = $fd5d8119c80a98eb$var$deleteCookieAndConfirm(key);
                    if (!item.deleted) undeletedItems.push(item);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'enumerationLimit'
        });
        else if (!indexedDBCache) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'cacheUnavailable'
        });
        else if (typeof (idb === null || idb === void 0 ? void 0 : idb.databases) !== 'function') // Safari and Firefox do not implement `indexedDB.databases()`.
        skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'unsupported'
        });
        else try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= $fd5d8119c80a98eb$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $fd5d8119c80a98eb$var$ITEMS_PER_YIELD === 0) await $fd5d8119c80a98eb$var$yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, $ckf9y.getItemCategoryFromPassedCache)(name, indexedDBCache, productName);
                if (category === null || category === (0, $cjHoj.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if ($fd5d8119c80a98eb$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: name,
                        storageType: 'indexedDB',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteIdb && isLiveDelete) {
                        // Collected, not awaited inline: serial waits would make the worst case the sum of
                        // the per-database timeouts instead of the longest one.
                        pendingIdbConfirmations.push($fd5d8119c80a98eb$var$deleteDatabaseAndConfirm(idb, name).then((deleted)=>{
                            item.deleted = deleted;
                            if (!deleted) undeletedItems.push(item);
                        }));
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch  {
            // idb.databases() unavailable or threw — skip IDB entirely
            skippedTypes.push({
                storageType: 'indexedDB',
                reason: 'error'
            });
        }
        if (pendingIdbConfirmations.length > 0) await Promise.all(pendingIdbConfirmations);
        if (deletionCount > 0) (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount - undeletedItems.length,
                undeletedCount: undeletedItems.length
            }
        });
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: deletionMode,
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType: storageType, key: key, category: category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`),
                hitEnumerationLimit: hitEnumerationLimit,
                hitRevokedCountCeiling: revokedItems.length > $fd5d8119c80a98eb$export$54394d3cfbbf53d0,
                ...isLiveDelete ? {
                    undeletedCount: undeletedItems.length,
                    undeletedItems: undeletedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`)
                } : {},
                // Sent even when empty, so full coverage reads as an explicit empty value rather than a
                // missing attribute.
                skippedTypes: skippedTypes.map(({ storageType: storageType, reason: reason })=>`${storageType}:${reason}`).join(','),
                inFrame: inFrame
            }
        });
        return {
            deletionMode: deletionMode,
            revokedItems: revokedItems,
            uncategorizedItems: uncategorizedItems,
            hitEnumerationLimit: hitEnumerationLimit,
            skippedTypes: skippedTypes,
            inFrame: inFrame
        };
    } catch (error) {
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${(error === null || error === void 0 ? void 0 : error.message) ?? 'no message'}`
        });
        return {
            deletionMode: deletionMode,
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}

});

parcelRegister("9tTwx", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthroughSync", () => $e679bc32b442f46e$export$50a17589ab8bbee4);
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $e679bc32b442f46e$export$45a5573b04db016c);

var $3k55j = parcelRequire("3k55j");

var $dxzSI = parcelRequire("dxzSI");
const $e679bc32b442f46e$export$50a17589ab8bbee4 = ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
    const originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
    if (!originalSetter || !originalGetter) {
        (0, $3k55j.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $dxzSI.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};
const $e679bc32b442f46e$export$45a5573b04db016c = async ()=>$e679bc32b442f46e$export$50a17589ab8bbee4();

});
parcelRegister("dxzSI", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $c5e281d5893119b6$export$b7364c41ddbfdb0a);

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");
var $g5Y6L = parcelRequire("g5Y6L");

var $g5Y6L = parcelRequire("g5Y6L");

var $2zjw9 = parcelRequire("2zjw9");

var $ckf9y = parcelRequire("ckf9y");

var $3k55j = parcelRequire("3k55j");

var $dWPwT = parcelRequire("dWPwT");

var $cjHoj = parcelRequire("cjHoj");
const $c5e281d5893119b6$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        const extensionSignals = (0, $dRkX9.fg)('platform_bsc_browser_extension_detection') ? (0, $2zjw9.captureCallerSignals)() : undefined;
        // Set cookie function reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setCookieFailure;
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $g5Y6L.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $eqqb5.getBscGlobalState)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                // Attempt to set a known cookie that was set from outside the package
                const processingCheck = (0, $ckf9y.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        if (!itemHasCategory && (0, $dWPwT.shouldReportUncategorizedItemSet)((0, $cjHoj.CategoryStorageType).Cookies, sanitizedCookieKey)) (0, $g5Y6L.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $cjHoj.CategoryStorageType).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null,
                                cacheLoadedDate: (0, $eqqb5.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $dWPwT.uncategorizedItemSetOnSent)((0, $cjHoj.CategoryStorageType).Cookies, sanitizedCookieKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $eqqb5.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $3k55j.Logger).warn(`document.cookie setter for '${sanitizedCookieKey}' was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${sanitizedCookieKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: (0, $cjHoj.CategoryStorageType).Cookies,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $ckf9y.isPromise)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $3k55j.Logger).errorWithOperationalEvent({
                        action: 'usedDocumentCookieError',
                        message: `Failed to set cookie. ${(e === null || e === void 0 ? void 0 : e.message) || ''}`,
                        attributes: {
                            cookieKey: sanitizedCookieKey
                        }
                    });
                });
            } catch (e) {
                (0, $3k55j.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
                setCookieFailure = e;
            }
        } catch (e) {
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
        if (setCookieFailure) throw setCookieFailure;
    };

});
parcelRegister("dWPwT", function(module, exports) {
$parcel$export(module.exports, "shouldReportUncategorizedItemSet", () => $485d567ddca3d7de$export$eda682c722f364aa);
$parcel$export(module.exports, "uncategorizedItemSetOnSent", () => $485d567ddca3d7de$export$c81f34d18a3c37c3);
/**
 * Tracks which uncategorized storage-item keys have already emitted an
 * `uncategorizedWebStorageItemSet` track event this session, so repeated writes
 * of the same unknown key don't emit duplicate events.
 *
 * State is module-level (per page load), which gives us the "per session"
 * semantic for free — it resets naturally on reload. Same pattern as
 * `ItemKeyCache` (item-key-cache-service) and the logger error-event throttle.
 *
 * Keys are scoped by storage type so the same key name in different storage
 * types (e.g. a cookie and a localStorage item both named `foo`) remain
 * distinct reportable signals.
 */ class $485d567ddca3d7de$var$UncategorizedItemReportCacheService {
    compositeKey(storageType, itemKey) {
        return `${storageType}::${itemKey}`;
    }
    markReported(storageType, itemKey) {
        this.reportedKeys.add(this.compositeKey(storageType, itemKey));
    }
    wasReported(storageType, itemKey) {
        return this.reportedKeys.has(this.compositeKey(storageType, itemKey));
    }
    // Test-only helper to reset the per-process cache between tests.
    __reset() {
        this.reportedKeys.clear();
    }
    constructor(){
        this.reportedKeys = new Set();
    }
}
let $485d567ddca3d7de$var$cacheInstance;
/**
 * Lazily creates the cache on first use.
 */ function $485d567ddca3d7de$var$getCache() {
    if (!$485d567ddca3d7de$var$cacheInstance) $485d567ddca3d7de$var$cacheInstance = new $485d567ddca3d7de$var$UncategorizedItemReportCacheService();
    return $485d567ddca3d7de$var$cacheInstance;
}
function $485d567ddca3d7de$export$270367a42ceba9fe() {
    $485d567ddca3d7de$var$cacheInstance = undefined;
}
function $485d567ddca3d7de$export$eda682c722f364aa(storageType, itemKey) {
    return !$485d567ddca3d7de$var$getCache().wasReported(storageType, itemKey);
}
function $485d567ddca3d7de$export$c81f34d18a3c37c3(storageType, itemKey) {
    return ()=>$485d567ddca3d7de$var$getCache().markReported(storageType, itemKey);
}

});



parcelRegister("1hoSb", function(module, exports) {
$parcel$export(module.exports, "createIndexedDBPassthroughSync", () => $3f5c4be74c84f923$export$bbe9492afe46739);
$parcel$export(module.exports, "createIndexedDBPassthrough", () => $3f5c4be74c84f923$export$a03098708eb0de1);

var $3k55j = parcelRequire("3k55j");

var $Y70UW = parcelRequire("Y70UW");
const $3f5c4be74c84f923$export$bbe9492afe46739 = (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $3k55j.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $3k55j.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $3k55j.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $Y70UW.getIndexedDBOpenOverride)(originalOpen) : (0, $Y70UW.getIndexedDBOpenOverrideEventOnly)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $3k55j.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $3k55j.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};
const $3f5c4be74c84f923$export$a03098708eb0de1 = async (config)=>$3f5c4be74c84f923$export$bbe9492afe46739(config);

});
parcelRegister("Y70UW", function(module, exports) {
$parcel$export(module.exports, "getIndexedDBOpenOverrideEventOnly", () => $c58aa9d0f90f83a4$export$5a412306febb78c);
$parcel$export(module.exports, "getIndexedDBOpenOverride", () => $c58aa9d0f90f83a4$export$5721aa15a04b1881);

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");
var $g5Y6L = parcelRequire("g5Y6L");

var $2zjw9 = parcelRequire("2zjw9");

var $ckf9y = parcelRequire("ckf9y");

var $3k55j = parcelRequire("3k55j");

var $jhXu9 = parcelRequire("jhXu9");

var $4vyVm = parcelRequire("4vyVm");

var $dODCb = parcelRequire("dODCb");

var $cjHoj = parcelRequire("cjHoj");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $c58aa9d0f90f83a4$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $c58aa9d0f90f83a4$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $c58aa9d0f90f83a4$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $c58aa9d0f90f83a4$var$checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, $dODCb.ItemKeyCache).wasSetByPackage((0, $cjHoj.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, $eqqb5.getBscGlobalState)().product;
    const itemCategory = await (0, $ckf9y.getItemCategory)(eventDetails.databaseName, (0, $cjHoj.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $cjHoj.PreferenceCategory).StrictlyNecessary;
    // Strictly-necessary and package-set databases never block, so omit their telemetry.
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true,
            itemCategory: itemCategory ?? (0, $cjHoj.PreferenceCategory).Unknown
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $g5Y6L.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
// Keep forwarding `extensionSignals` to `isProcessingAllowedByPreferencesWithCategory` — extension
// writes rely on it to bypass the consent check.
const $c58aa9d0f90f83a4$var$checkIfAllowedWithCategory = async (dbName, extensionSignals)=>{
    if (!(0, $4vyVm.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $3k55j.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $eqqb5.getBscGlobalState)().product;
    const { isAllowed: isAllowed, itemCategory: itemCategory } = await (0, $ckf9y.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $cjHoj.CategoryStorageType).IndexedDB,
        productName: productName,
        extensionSignals: extensionSignals
    });
    return {
        isAllowed: isAllowed,
        itemCategory: itemCategory
    };
};
const $c58aa9d0f90f83a4$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $c58aa9d0f90f83a4$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $3k55j.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $c58aa9d0f90f83a4$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $dODCb.ItemKeyCache).wasSetByPackage((0, $cjHoj.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        const extensionSignals = (0, $dRkX9.fg)('platform_bsc_browser_extension_detection') ? (0, $2zjw9.captureCallerSignals)() : undefined;
        (0, $3k55j.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $jhXu9.createIDBOpenDBRequestWrapper)();
        // Always resolve category information for telemetry and so the uncategorized passthrough
        // can distinguish an unknown database from one the user denied.
        const allowUncategorizedOverride = !!(0, $eqqb5.getBscGlobalState)().allowUncategorizedItemsInIndexedDBOverrides;
        const allowedPromise = $c58aa9d0f90f83a4$var$checkIfAllowedWithCategory(databaseName, extensionSignals).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>({
                isAllowed: isAllowed,
                itemCategory: itemCategory ?? (0, $cjHoj.PreferenceCategory).Unknown,
                categoryAttribute: {
                    itemCategory: itemCategory ?? (0, $cjHoj.PreferenceCategory).Unknown
                }
            }));
        allowedPromise.then(({ isAllowed: isAllowed, itemCategory: itemCategory, categoryAttribute: categoryAttribute })=>{
            // When `allowUncategorizedItemsInIndexedDBOverrides` is enabled, databases that have
            // no known category (null/Unknown) are allowed through instead of being blocked. This
            // is a rollout-safety valve — only uncategorized DBs are affected; DBs that are
            // categorized but user-denied are still blocked regardless of this flag.
            const isUncategorized = itemCategory == null || itemCategory === (0, $cjHoj.PreferenceCategory).Unknown;
            const resolvedIsAllowed = isAllowed || allowUncategorizedOverride && isUncategorized;
            (0, $g5Y6L.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !resolvedIsAllowed,
                    outsidePackage: true,
                    ...categoryAttribute
                }
            });
            if (resolvedIsAllowed) {
                (0, $3k55j.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $3k55j.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $c58aa9d0f90f83a4$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $3k55j.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $3k55j.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };

});
parcelRegister("jhXu9", function(module, exports) {
$parcel$export(module.exports, "createIDBOpenDBRequestWrapper", () => $7ad799f6d63f2a3e$export$4037ef1f5b40c4b6);

var $6Zi52 = parcelRequire("6Zi52");

var $iPmiQ = parcelRequire("iPmiQ");

var $47lL4 = parcelRequire("47lL4");
// Store the browser implementation class here - defined conditionally below
let $7ad799f6d63f2a3e$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$7ad799f6d63f2a3e$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        var _this$_wrappedRequest;
        return ((_this$_wrappedRequest = this._wrappedRequest) === null || _this$_wrappedRequest === void 0 ? void 0 : _this$_wrappedRequest.error) ?? this._error;
    }
    get result() {
        var _this$_wrappedRequest2;
        return ((_this$_wrappedRequest2 = this._wrappedRequest) === null || _this$_wrappedRequest2 === void 0 ? void 0 : _this$_wrappedRequest2.result) ?? this._result;
    }
    get readyState() {
        var _this$_wrappedRequest3;
        return ((_this$_wrappedRequest3 = this._wrappedRequest) === null || _this$_wrappedRequest3 === void 0 ? void 0 : _this$_wrappedRequest3.readyState) ?? this._readyState;
    }
    get source() {
        var _this$_wrappedRequest4;
        return ((_this$_wrappedRequest4 = this._wrappedRequest) === null || _this$_wrappedRequest4 === void 0 ? void 0 : _this$_wrappedRequest4.source) ?? this._source;
    }
    get transaction() {
        var _this$_wrappedRequest5;
        return ((_this$_wrappedRequest5 = this._wrappedRequest) === null || _this$_wrappedRequest5 === void 0 ? void 0 : _this$_wrappedRequest5.transaction) ?? this._transaction;
    }
    /**
     * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
     * Once wrapped, all property getters will delegate to the wrapped request,
     * and all events from the wrapped request will be re-dispatched on this wrapper.
     *
     * @param request - The real IDBOpenDBRequest to wrap
     */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $6Zi52.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
     * Check if this mock is wrapping a real request
     */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
     * Get the wrapped request (if any)
     */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
     * Unbind all event listeners attached to the wrapped request.
     * Should be called when the wrapper is no longer needed.
     */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
     * Set the error property (normally readonly)
     * Only works when not wrapping another request
     */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
     * Set the result property (normally readonly)
     * Only works when not wrapping another request
     */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
     * Set the readyState property (normally readonly)
     * Only works when not wrapping another request
     */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
     * Set the source property (normally readonly)
     * Only works when not wrapping another request
     */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
     * Set the transaction property (normally readonly)
     * Only works when not wrapping another request
     */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
     * Override dispatchEvent to also call the corresponding event handler if set
     */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function $7ad799f6d63f2a3e$export$4037ef1f5b40c4b6() {
    if ((0, $iPmiQ.isSSR)() || typeof EventTarget === 'undefined' || !$7ad799f6d63f2a3e$var$BrowserImpl) return new (0, $47lL4.IDBOpenDBRequestNoOp)();
    return new $7ad799f6d63f2a3e$var$BrowserImpl();
}
const $7ad799f6d63f2a3e$export$c69b1cb39abae960 = $7ad799f6d63f2a3e$var$BrowserImpl;

});
parcelRegister("47lL4", function(module, exports) {
$parcel$export(module.exports, "IDBOpenDBRequestNoOp", () => $3db1e46cc14636fa$export$55ffeaf417e03b66);
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $3db1e46cc14636fa$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

});


parcelRegister("4vyVm", function(module, exports) {
$parcel$export(module.exports, "isValidDBName", () => $e3b986a545bc609e$export$a5be9a74f3347ccf);

var $eqqb5 = parcelRequire("eqqb5");
var $iPmiQ = parcelRequire("iPmiQ");
function $e3b986a545bc609e$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $iPmiQ.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $eqqb5.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $e3b986a545bc609e$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $e3b986a545bc609e$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

});



parcelRegister("cEVW9", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthroughSync", () => $04aad2f2b09217f3$export$68ddaf53a4783803);
$parcel$export(module.exports, "createWebStoragePassthrough", () => $04aad2f2b09217f3$export$619fe705922e5d61);

var $3k55j = parcelRequire("3k55j");

var $6APPZ = parcelRequire("6APPZ");

var $hPIXE = parcelRequire("hPIXE");
var $jvA59 = parcelRequire("jvA59");

var $7A1ZR = parcelRequire("7A1ZR");
// Members the Proxy replaces rather than forwarding.
const $04aad2f2b09217f3$var$INTERCEPTED_MEMBERS = [
    'setItem',
    'getItem',
    'removeItem',
    'clear',
    'key',
    'length'
];
/**
 * Marks a storage object as already overridden by this package. Duplicate copies of the package in
 * one page (chunk skew) each capture `globalThis.localStorage` at module evaluation, so without this
 * the second copy would proxy the first copy's Proxy and run the consent pipeline — and its
 * analytics — twice per write.
 */ const $04aad2f2b09217f3$var$BSC_STORAGE_OVERRIDE_INSTALLED = Symbol.for('atlassian.bsc.webStorageOverrideInstalled');
const $04aad2f2b09217f3$var$isAlreadyOverridden = (value)=>value !== null && typeof value === 'object' && value[$04aad2f2b09217f3$var$BSC_STORAGE_OVERRIDE_INSTALLED] === true;
/**
 * A Proxy may not report a different value for a property the target exposes as a non-writable,
 * non-configurable own data property — the runtime throws `TypeError` on every such access. A real
 * `Storage` keeps its members on `Storage.prototype` and its items as writable, configurable own
 * properties, so this only happens when something has already replaced `window.localStorage` with a
 * locked-down stand-in (some third-party storage shims and test doubles do exactly that). Detect it
 * up front and keep the legacy override for those environments instead of installing a Proxy that
 * throws on ordinary reads.
 */ const $04aad2f2b09217f3$var$canInterceptWithProxy = (storage)=>$04aad2f2b09217f3$var$INTERCEPTED_MEMBERS.every((member)=>{
        const descriptor = Object.getOwnPropertyDescriptor(storage, member);
        return !descriptor || descriptor.configurable === true || descriptor.writable === true;
    });
const $04aad2f2b09217f3$var$isLockedDownOnTarget = (target, property)=>{
    const descriptor = Reflect.getOwnPropertyDescriptor(target, property);
    return descriptor !== undefined && !descriptor.configurable && descriptor.writable === false;
};
/**
 * Wraps the real `Storage` object so consent checks still apply to writes while the rest of the
 * `Storage` interface keeps working.
 *
 * The legacy override (below) replaces `window.localStorage` with a plain object carrying the six
 * `Storage` operations. That silently drops every other guarantee of the interface: `length` becomes
 * a function instead of a number, stored keys stop being enumerable own properties, and
 * property-style access no longer reaches the store. Consumers that measure or enumerate storage —
 * `localStorage.length`, `Object.keys(localStorage)` — then see an empty or nonsensical view, which
 * disabled the age-based storage cleanups our products depend on and let storage fill to the browser
 * quota (COOK-628).
 *
 * Keeping the native `Storage` as the Proxy target inherits reads, removals, enumeration and brand
 * checks for free. Only writes are intercepted, and they are intercepted without relying on the
 * host's named-property-setter semantics: browsers ignore or shadow a write to `length` or to a
 * `Storage` method, whereas jsdom persists it as an item. Deciding those cases here rather than
 * forwarding them keeps behaviour identical across hosts and guarantees nothing reaches storage
 * without passing through the consent check.
 */ const $04aad2f2b09217f3$var$createProxiedStorage = (bscStorage, storageType)=>{
    const nativeStorage = bscStorage.storage;
    const storagePrototype = Object.getPrototypeOf(nativeStorage);
    const interceptedSetItem = (0, $7A1ZR.setItemOverride)(bscStorage, nativeStorage.setItem, storageType);
    // The `Storage` operations keep pointing at `AtlBrowserStorage` so their existing availability
    // guards and analytics are unaffected by this Proxy. `length` is handled in the `get` trap
    // because it is an accessor on `Storage` but a method on `AtlBrowserStorage`.
    const operations = new Map([
        [
            'setItem',
            interceptedSetItem
        ],
        [
            'getItem',
            bscStorage.getItem.bind(bscStorage)
        ],
        [
            'removeItem',
            bscStorage.removeItem.bind(bscStorage)
        ],
        [
            'clear',
            bscStorage.clear.bind(bscStorage)
        ],
        [
            'key',
            bscStorage.key.bind(bscStorage)
        ]
    ]);
    // Properties assigned to the storage object that are NOT storage items — symbol keys, and the
    // interface's own member names. Browsers keep these as ordinary own properties on the object and
    // never write them to the store, so we hold them here instead of touching storage. Enumeration
    // deliberately does not report them: `Object.keys(localStorage)` stays exactly the stored keys.
    // They also take precedence over `operations` on read, because products legitimately wrap the
    // storage methods (Confluence's `patchLocalStorage` replaces `setItem` and delegates to whatever
    // it captured) and that has always worked against the legacy override.
    const shadowedProperties = new Map();
    // A property names a storage item unless it resolves on the prototype chain (`length`, the
    // `Storage` methods, `Object.prototype` members) or is a symbol. Used by every trap that can
    // reach the store: `set`, `defineProperty` and `deleteProperty`.
    const isStorageItemKey = (property)=>typeof property === 'string' && !(property in storagePrototype);
    // The consent pipeline emits analytics, and anything on that path that persists a value with
    // property syntax would re-enter this trap and recurse forever. Bound to one level instead.
    let isHandlingStorageWrite = false;
    const gateStorageWrite = (property, value)=>{
        if (isHandlingStorageWrite) {
            (0, $3k55j.Logger).warn(`Dropped re-entrant ${storageType} write for '${property}' triggered from inside the consent path`);
            return;
        }
        isHandlingStorageWrite = true;
        try {
            interceptedSetItem(property, String(value));
        } finally{
            isHandlingStorageWrite = false;
        }
    };
    const proxiedStorage = new Proxy(nativeStorage, {
        get: (target, property)=>{
            if (property === $04aad2f2b09217f3$var$BSC_STORAGE_OVERRIDE_INSTALLED) return true;
            if (property === 'length') return bscStorage.length();
            if (shadowedProperties.has(property)) return shadowedProperties.get(property);
            if (operations.has(property)) return operations.get(property);
            // Deliberately NOT bound to the target: binding would hand out the raw `Storage` through
            // `localStorage.valueOf()`, which is an unchecked write path. Everything that needs a real
            // `Storage` receiver is routed above, and the remainder (`Object.prototype` members, named
            // keys, `Symbol.toStringTag`) works with the Proxy as the receiver. Returning the prototype's
            // own function object also keeps `localStorage.toString === localStorage.toString`.
            return Reflect.get(target, property, target);
        },
        // `localStorage.foo = 'bar'`, `Object.assign(localStorage, …)` and `Reflect.set` all reach the
        // store natively, so they are consent-checked exactly like `setItem`.
        set: (target, property, value, receiver)=>{
            // A receiver that is neither this Proxy nor the storage itself means the assignment targets
            // something further down a prototype chain (`Object.create(localStorage).foo = 'x'`), which
            // the browser also refuses to route into the store.
            if (receiver !== proxiedStorage && receiver !== target) return Reflect.set(target, property, value, receiver);
            if (property === 'length') // Read-only accessor: browsers ignore the write in sloppy mode. Reporting success keeps
            // strict-mode assignment from throwing where the legacy override did not.
            return true;
            // Reporting success for a locked-down own property on the target violates a Proxy
            // invariant. Fail the assignment exactly as the target itself would.
            if ($04aad2f2b09217f3$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, value);
                return true;
            }
            gateStorageWrite(property, value);
            // Report success even when consent blocked the write, so assignment does not throw in
            // strict mode. This matches how the `setItem` override treats a blocked write.
            return true;
        },
        defineProperty: (target, property, descriptor)=>{
            // Accessor descriptors on a storage key are rejected by the browser itself — forward and let
            // it throw rather than inventing a behaviour.
            if (!('value' in descriptor) || property === 'length') return Reflect.defineProperty(target, property, descriptor);
            // A non-configurable property must actually exist on the target for a `true` result to be
            // legal, and consent may block the write, so refuse instead of risking a `TypeError`.
            if (descriptor.configurable === false || $04aad2f2b09217f3$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, descriptor.value);
                return true;
            }
            gateStorageWrite(property, descriptor.value);
            return true;
        },
        // `delete localStorage.foo` removes the item natively, so it has to reach the store — but it goes
        // through `AtlBrowserStorage.removeItem` rather than the target directly, so removals behave
        // identically however they are spelled. Removals are not consent-checked, matching `removeItem`.
        deleteProperty: (target, property)=>{
            if (shadowedProperties.has(property)) {
                shadowedProperties.delete(property);
                return true;
            }
            if (isStorageItemKey(property)) {
                bscStorage.removeItem(property);
                return true;
            }
            return Reflect.deleteProperty(target, property);
        }
    });
    return proxiedStorage;
};
const $04aad2f2b09217f3$var$applyWebStorageOverride = (bscStorage, storageType)=>{
    const caseSensitiveStorageType = storageType === (0, $jvA59.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    if ($04aad2f2b09217f3$var$isAlreadyOverridden(window[caseSensitiveStorageType]) || $04aad2f2b09217f3$var$isAlreadyOverridden(bscStorage.storage)) {
        (0, $3k55j.Logger).debug(`${storageType} override is already installed, skipping`);
        return;
    }
    if ($04aad2f2b09217f3$var$canInterceptWithProxy(bscStorage.storage)) {
        Object.defineProperty(window, caseSensitiveStorageType, {
            value: $04aad2f2b09217f3$var$createProxiedStorage(bscStorage, storageType),
            writable: true,
            configurable: true
        });
        return;
    }
    (0, $3k55j.Logger).warn(`${storageType} cannot be proxied because its members are not configurable \u{2014} falling back to the legacy override`);
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $7A1ZR.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};
const $04aad2f2b09217f3$export$68ddaf53a4783803 = (storageType)=>{
    const bscStorage = (0, $hPIXE.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $3k55j.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    $04aad2f2b09217f3$var$applyWebStorageOverride(bscStorage, storageType);
};
const $04aad2f2b09217f3$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $hPIXE.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $3k55j.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $6APPZ.BSCIndexedDB).isAvailable) {
        (0, $3k55j.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $6APPZ.BSCIndexedDB).isBooted) try {
        await (0, $6APPZ.BSCIndexedDB).boot();
    } catch  {
        (0, $3k55j.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
    }
    $04aad2f2b09217f3$var$applyWebStorageOverride(bscStorage, storageType);
};

});
parcelRegister("6APPZ", function(module, exports) {
$parcel$export(module.exports, "BSCIndexedDB", () => $7572c521ec6ddd68$export$36328b3bcbe4623a);

var $iPmiQ = parcelRequire("iPmiQ");
var $g5Y6L = parcelRequire("g5Y6L");

var $3k55j = parcelRequire("3k55j");
class $7572c521ec6ddd68$export$fde2a4e0e57f47e {
    static #_ = this.OPEN_DB_TIMEOUT_MS = 3000;
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $3k55j.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $3k55j.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $3k55j.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $3k55j.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $3k55j.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $iPmiQ.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        const timeoutPromise = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new Error(`IndexedDB open timed out after ${$7572c521ec6ddd68$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
            }, $7572c521ec6ddd68$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
        });
        return Promise.race([
            openPromise,
            timeoutPromise
        ]);
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $g5Y6L.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $3k55j.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $g5Y6L.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $3k55j.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $7572c521ec6ddd68$export$36328b3bcbe4623a = new $7572c521ec6ddd68$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("7A1ZR", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $3b6beb31d5ca7e69$export$b4469df6294ea6aa);

var $dRkX9 = parcelRequire("dRkX9");

var $eqqb5 = parcelRequire("eqqb5");
var $g5Y6L = parcelRequire("g5Y6L");

var $g5Y6L = parcelRequire("g5Y6L");

var $2zjw9 = parcelRequire("2zjw9");

var $ckf9y = parcelRequire("ckf9y");

var $3k55j = parcelRequire("3k55j");

var $dODCb = parcelRequire("dODCb");

var $dWPwT = parcelRequire("dWPwT");
parcelRequire("hPIXE");
var $jvA59 = parcelRequire("jvA59");

var $7QI3R = parcelRequire("7QI3R");

var $cjHoj = parcelRequire("cjHoj");
const $3b6beb31d5ca7e69$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, $jvA59.WebStorageType).LocalStorage ? (0, $cjHoj.CategoryStorageType).LocalStorage : (0, $cjHoj.CategoryStorageType).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        itemSetByPackage = (0, $dODCb.ItemKeyCache).wasSetByPackage(categoryStorageType, originalItemKey);
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        const disableWebStorageConsentChecks = (0, $eqqb5.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
        if (disableWebStorageConsentChecks) {
            try {
                (0, $dODCb.ItemKeyCache).markSetByPackage(categoryStorageType, originalItemKey);
                originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, $7QI3R.reportSetItemError)({
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType,
                        consentChecksDisabled: true
                    },
                    error: e
                });
            }
            let wasCheckAsync = true;
            try {
                const productName = (0, $eqqb5.getBscGlobalState)().product;
                const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $eqqb5.getBscGlobalState)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, $ckf9y.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $g5Y6L.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $g5Y6L.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                        if (!itemHasCategory && (0, $dWPwT.shouldReportUncategorizedItemSet)(categoryStorageType, originalItemKey)) (0, $g5Y6L.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $eqqb5.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $dWPwT.uncategorizedItemSetOnSent)(categoryStorageType, originalItemKey)
                        });
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $7QI3R.reportSetItemError)({
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $7QI3R.reportSetItemError)({
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                },
                error: e
            });
        }
        const extensionSignals = (0, $dRkX9.fg)('platform_bsc_browser_extension_detection') ? (0, $2zjw9.captureCallerSignals)() : undefined;
        // `Storage.setItem` reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setItemFailure;
        try {
            let wasCheckAsync = true;
            try {
                const productName = (0, $eqqb5.getBscGlobalState)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                // Attempt to set a known item key that was set from outside the package
                const processingCheck = (0, $ckf9y.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $g5Y6L.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $g5Y6L.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        if (!itemHasCategory && (0, $dWPwT.shouldReportUncategorizedItemSet)(categoryStorageType, originalItemKey)) (0, $g5Y6L.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $eqqb5.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $dWPwT.uncategorizedItemSetOnSent)(categoryStorageType, originalItemKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $eqqb5.getBscGlobalState)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $3k55j.Logger).warn(`${storageType}.setItem('${originalItemKey}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${originalItemKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: categoryStorageType,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $ckf9y.isPromise)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $7QI3R.reportSetItemError)({
                        message: `Failed to set item. ${(e === null || e === void 0 ? void 0 : e.message) || ''}`,
                        attributes: {
                            itemKey: originalItemKey,
                            storageType: storageType,
                            wasAsync: true
                        },
                        error: e
                    });
                });
            } catch (e) {
                (0, $7QI3R.reportSetItemError)({
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
                setItemFailure = e;
            }
        } catch (e) {
            (0, $7QI3R.reportSetItemError)({
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`,
                error: e
            });
        }
        if (setItemFailure) throw setItemFailure;
    };

});





parcelRegister("ebrC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11b62b44ef95729$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $e11b62b44ef95729$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    unsupportedBrowser: {
        defaultMessage: "We don't support your browser version anymore and this may cause problems when you raise requests. Upgrade to a newer version to ensure a smooth request creation experience.",
        description: 'Message on top screen banner to inform user that they are using unsupported browser version',
        id: 'cv.app.banner.unsupported.browser.version'
    }
});

});



parcelRegister("gEtje", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => (parcelRequire("cIcbU")).ThemingContainer);

var $cIcbU = parcelRequire("cIcbU");

});
parcelRegister("cIcbU", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => $eb18455db2497213$export$a29c32a54963ec02);

var $fc4bM = parcelRequire("fc4bM");
parcelRequire("9XZeF");
var $6umft = parcelRequire("6umft");

var $2n2bS = parcelRequire("2n2bS");
parcelRequire("grTfP");
var $ePyx3 = parcelRequire("ePyx3");

var $jEubQ = parcelRequire("jEubQ");

var $k2M4v = parcelRequire("k2M4v");

var $1DvZb = parcelRequire("1DvZb");

var $eENmG = parcelRequire("eENmG");

var $cf3fd = parcelRequire("cf3fd");

var $7lN8e = parcelRequire("7lN8e");

var $iSFD9 = parcelRequire("iSFD9");

var $lIiOx = parcelRequire("lIiOx");
const $eb18455db2497213$export$9156684d9d875025 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { children: children, themeColor: themeColor } = props;
    const isTypographyTokenMigrationEnabled = (0, $k2M4v.default).checkGate('enable_typography_token_migration_for_csm');
    const sendAnalyticsEvent = $fc4bM.useCallback((action)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            analyticsType: (0, $eENmG.OPERATIONAL_EVENT_TYPE),
            actionSubject: 'portalThemingBootstrap'
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $iSFD9.useIsoMorphicLayoutEffect)(()=>{
        const setGlobalThemePromise = (0, $1DvZb.setGlobalTheme)({
            // @ts-expect-error
            light: '',
            spacing: 'spacing',
            colorMode: 'light',
            // @ts-expect-error
            typography: null,
            ...isTypographyTokenMigrationEnabled && (0, $cf3fd.isCSMHelpCenter)((0, $7lN8e.getEnv)().helpCenterType) && {
                typography: 'typography'
            }
        });
        setGlobalThemePromise.then(()=>sendAnalyticsEvent((0, $lIiOx.OUTCOME).SUCCESS)).catch(()=>sendAnalyticsEvent((0, $lIiOx.OUTCOME).FAILURE));
    }, [
        sendAnalyticsEvent,
        themeColor
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, children);
};
const $eb18455db2497213$var$selector = (0, $2n2bS.createSelector)((0, $ePyx3.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
const $eb18455db2497213$export$a29c32a54963ec02 = (0, $6umft.default)($eb18455db2497213$var$selector)($eb18455db2497213$export$9156684d9d875025);

});
parcelRegister("lIiOx", function(module, exports) {
$parcel$export(module.exports, "OUTCOME", () => $c2a95f20ef235178$export$a12152da2bb8d161);
var $c2a95f20ef235178$export$a12152da2bb8d161 = /*#__PURE__*/ function(OUTCOME) {
    OUTCOME["SUCCESS"] = "SUCCESS";
    OUTCOME["FAILURE"] = "FAILURE";
    return OUTCOME;
}({});

});






var $jQYQa = parcelRequire("jQYQa");

var $6LH8a = parcelRequire("6LH8a");

var $k2M4v = parcelRequire("k2M4v");
parcelRequire("6BNHY");
var $hMg06 = parcelRequire("hMg06");

var $dRkX9 = parcelRequire("dRkX9");

var $fkCWE = parcelRequire("fkCWE");

var $fkCWE = parcelRequire("fkCWE");

var $cUiDw = parcelRequire("cUiDw");
let $46027b791ca0c0b0$var$pe = null;
function $46027b791ca0c0b0$export$619cdeadfd90f3e4() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($46027b791ca0c0b0$var$pe !== null) return $46027b791ca0c0b0$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $fkCWE.PerformanceObserverEntryTypes).LayoutShift) (0, $cUiDw.EntriesBuffer)[(0, $fkCWE.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $fkCWE.PerformanceObserverEntryTypes).LongTask) (0, $cUiDw.EntriesBuffer)[(0, $fkCWE.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $46027b791ca0c0b0$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $46027b791ca0c0b0$var$pe;
}


function $81163992af6d61a8$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = (0, $46027b791ca0c0b0$export$619cdeadfd90f3e4)()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $fkCWE.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}



var $fkCWE = parcelRequire("fkCWE");

function $129621a6d11bfb5b$export$54fb8b6aaf70ec9c() {
    var _getObserver;
    (_getObserver = (0, $46027b791ca0c0b0$export$619cdeadfd90f3e4)()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $fkCWE.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}


function $240cfa61c8c2d0bd$export$5ecf2aafafee3e0() {
    (0, $81163992af6d61a8$export$768ccc3ab7bac3ea)();
    (0, $129621a6d11bfb5b$export$54fb8b6aaf70ec9c)();
}



var $5hPkM = parcelRequire("5hPkM");

var $9To4z = parcelRequire("9To4z");
function $dbd0bec082753a2e$export$e6a07a94f3e112d4(sinkFn) {
    for (const { interactionId: interactionId, data: data } of (0, $9To4z.interactionBufferState).interactionBuffer)sinkFn(interactionId, data);
    (0, $9To4z.interactionBufferState).interactionBuffer.length = 0;
    (0, $9To4z.interactionBufferState).bufferInteractionData = sinkFn;
}



var $LzvBG = parcelRequire("LzvBG");

var $1N51K = parcelRequire("1N51K");

var $jQYQa = parcelRequire("jQYQa");

var $5hPkM = parcelRequire("5hPkM");

var $jQYQa = parcelRequire("jQYQa");
const $1506ae950bc65ade$var$nameCache = new WeakMap();
function $1506ae950bc65ade$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $1506ae950bc65ade$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $1506ae950bc65ade$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $1506ae950bc65ade$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $1506ae950bc65ade$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $1506ae950bc65ade$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $1506ae950bc65ade$var$getAttributeSelector(currentElement, 'data-testid') || $1506ae950bc65ade$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $1506ae950bc65ade$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($1506ae950bc65ade$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $1506ae950bc65ade$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$1506ae950bc65ade$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $1506ae950bc65ade$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $1506ae950bc65ade$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $1506ae950bc65ade$var$getUniqueSelector(selectorConfig, element);
    $1506ae950bc65ade$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $1506ae950bc65ade$export$2e2bcd8739ae039 = $1506ae950bc65ade$var$getElementName;


const $9c97af3d63081bd4$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $9c97af3d63081bd4$var$resolveSelectorConfig() {
    return (0, $5hPkM.getSelectorConfig)() ?? $9c97af3d63081bd4$var$DEFAULT_SELECTOR_CONFIG;
}
function $9c97af3d63081bd4$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $9c97af3d63081bd4$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $9c97af3d63081bd4$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($9c97af3d63081bd4$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $9c97af3d63081bd4$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $9c97af3d63081bd4$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $jQYQa.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) interaction.unknownElementHierarchy = $9c97af3d63081bd4$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementName = (0, $1506ae950bc65ade$export$2e2bcd8739ae039)($9c97af3d63081bd4$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};


let $60d9ffd0b1af423c$var$performanceEventObserver;
const $60d9ffd0b1af423c$export$17afbba0f16b4b19 = ()=>{
    $60d9ffd0b1af423c$var$performanceEventObserver = $60d9ffd0b1af423c$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (const entry of list)if (entry.name === 'click') (0, $9c97af3d63081bd4$export$e6be05b411ce21a6)(entry);
    });
    return $60d9ffd0b1af423c$var$performanceEventObserver;
};



var $66jVy = parcelRequire("66jVy");

var $fc4bM = parcelRequire("fc4bM");

var $f4Vz4 = parcelRequire("f4Vz4");

var $51dxT = parcelRequire("51dxT");

var $jQYQa = parcelRequire("jQYQa");

var $7jb5s = parcelRequire("7jb5s");
const $3dafcc7e95510083$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $3dafcc7e95510083$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $3dafcc7e95510083$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $3dafcc7e95510083$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $3dafcc7e95510083$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $3dafcc7e95510083$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $3dafcc7e95510083$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $3dafcc7e95510083$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $3dafcc7e95510083$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $3dafcc7e95510083$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($3dafcc7e95510083$var$ABORT_ERROR_NAMES.has(name) || $3dafcc7e95510083$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $3dafcc7e95510083$var$AUTH_ERROR_NAMES.has(name) && $3dafcc7e95510083$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($3dafcc7e95510083$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($3dafcc7e95510083$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $3dafcc7e95510083$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($3dafcc7e95510083$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $3dafcc7e95510083$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($3dafcc7e95510083$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $3dafcc7e95510083$export$17e837b2daecf805(error) {
    const directMatch = $3dafcc7e95510083$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $3dafcc7e95510083$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $9dcabddf4488a0eb$var$sinkHandlerFn = ()=>{};
function $9dcabddf4488a0eb$export$e5fa3ac6dc44efff(fn) {
    $9dcabddf4488a0eb$var$sinkHandlerFn = fn;
}
const $9dcabddf4488a0eb$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $9dcabddf4488a0eb$export$1a949ef92fd30eca = (error)=>error.name === $9dcabddf4488a0eb$var$RELAY_NETWORK_ERRORS_NAME;
const $9dcabddf4488a0eb$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $9dcabddf4488a0eb$var$getErrorStatusCode = (error)=>{
    if (!$9dcabddf4488a0eb$var$isErrorObject(error)) return undefined;
    if ($9dcabddf4488a0eb$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $9dcabddf4488a0eb$var$getErrorTraceId = (error)=>$9dcabddf4488a0eb$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $9dcabddf4488a0eb$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _getActiveTrace;
    const activeInteraction = (0, $jQYQa.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $3dafcc7e95510083$export$17e837b2daecf805)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: (additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) ?? $9dcabddf4488a0eb$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: ((_getActiveTrace = (0, $f4Vz4.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) ?? $9dcabddf4488a0eb$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $jQYQa.PreviousInteractionLog).timestamp != null ? currentTime - (0, $jQYQa.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) ?? null,
        activeInteractionId: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) ?? null,
        activeInteractionType: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) ?? null,
        previousInteractionId: (0, $jQYQa.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $jQYQa.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $jQYQa.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $7jb5s.default).current ?? null
    };
    $9dcabddf4488a0eb$var$sinkHandlerFn(errorData, context);
}
function $9dcabddf4488a0eb$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $51dxT.useInteractionContext)();
    const hasReportedRef = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $9dcabddf4488a0eb$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}



var $giVVN = parcelRequire("giVVN");

var $h0ns1 = parcelRequire("h0ns1");

var $dRkX9 = parcelRequire("dRkX9");
const $ccc306a03e5a8518$var$getNativeScheduler = ()=>{
    const nativeScheduler = globalThis.scheduler;
    return typeof (nativeScheduler === null || nativeScheduler === void 0 ? void 0 : nativeScheduler.postTask) === 'function' ? nativeScheduler : undefined;
};
/**
 * Schedules `work` at idle priority using native browser APIs, in order of preference:
 * `requestIdleCallback`, then `scheduler.postTask` with `background` priority, then
 * `setTimeout(work, 0)` (e.g. Safari or SSR, where neither API is available).
 */ function $ccc306a03e5a8518$var$scheduleNativeIdleTask(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(work);
        return;
    }
    const nativeScheduler = $ccc306a03e5a8518$var$getNativeScheduler();
    if (nativeScheduler) {
        nativeScheduler.postTask(work, {
            priority: 'background'
        });
        return;
    }
    setTimeout(work, 0);
}
/**
 * Schedules `work` to run at idle priority.
 *
 * When `platform_ufo_native_task_scheduling` is enabled, uses native browser scheduling instead of
 * the `scheduler` npm package, which is being removed for React 19 compatibility.
 */ function $ccc306a03e5a8518$var$scheduleIdleCallback(work) {
    if ((0, $dRkX9.fg)('platform_ufo_native_task_scheduling')) {
        $ccc306a03e5a8518$var$scheduleNativeIdleTask(work);
        return;
    }
    (0, $h0ns1.unstable_scheduleCallback)((0, $h0ns1.unstable_IdlePriority), work);
}
var $ccc306a03e5a8518$export$2e2bcd8739ae039 = $ccc306a03e5a8518$var$scheduleIdleCallback;


let $0f4442c793bf2f92$var$initialized = false;
function $0f4442c793bf2f92$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $ccc306a03e5a8518$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $jQYQa.sinkInteractionHandler)(sinkFn);
}
function $0f4442c793bf2f92$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $jQYQa.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $ccc306a03e5a8518$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $0f4442c793bf2f92$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $9dcabddf4488a0eb$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $ccc306a03e5a8518$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $0f4442c793bf2f92$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $ccc306a03e5a8518$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $dbd0bec082753a2e$export$e6a07a94f3e112d4)(sinkFn);
}




function $0f4442c793bf2f92$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($0f4442c793bf2f92$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $5hPkM.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $5hPkM.isUFOEnabled)()) {
        $0f4442c793bf2f92$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $66jVy.initialisePressureObserver)();
    (0, $66jVy.initialiseMemoryObserver)();
    if ((0, $dRkX9.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $LzvBG.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $LzvBG.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $hMg06.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $5hPkM.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $jQYQa.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $1N51K.setupHiddenTimingCapture)();
    (0, $240cfa61c8c2d0bd$export$5ecf2aafafee3e0)();
    if ((0, $dRkX9.fg)('platform_ufo_soft_nav_paint_metrics')) (0, $giVVN.ensureSoftNavigationObserved)();
    (0, $1N51K.setupThrottleDetection)();
    $0f4442c793bf2f92$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $60d9ffd0b1af423c$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("9WfyI")),
        (parcelRequire("7JN5Q")),
        (parcelRequire("ezdA4")),
        (parcelRequire("d8Y4I"))
    ]).then(([awc, payloadPackage, extraPayloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            var _config$terminalError, _config$postInteracti, _config$extraSearchPa;
            const instance = client.getInstance();
            $0f4442c793bf2f92$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled) $0f4442c793bf2f92$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $0f4442c793bf2f92$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $0f4442c793bf2f92$var$sinkExtraSearchPageInteraction(instance, extraPayloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$postInteracti2, _config$extraSearchPa2;
            $0f4442c793bf2f92$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled) $0f4442c793bf2f92$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $0f4442c793bf2f92$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $0f4442c793bf2f92$var$sinkExtraSearchPageInteraction(awc, extraPayloadPackage);
        }
    });
}



var $7eeIG = parcelRequire("7eeIG");
var $6B6vE = parcelRequire("6B6vE");
function $5810560ff3832765$export$a311cb1baa7d2d62() {
    (0, $6B6vE.resourceTimingBuffer).start();
}



var $iRdXI = parcelRequire("iRdXI");

var $eWyyY = parcelRequire("eWyyY");

var $7lN8e = parcelRequire("7lN8e");

var $55vtE = parcelRequire("55vtE");

var $6LH8a = parcelRequire("6LH8a");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $895d000dee7fb47d$var$cacheableTypes = [
    'script',
    'link'
];
const $895d000dee7fb47d$var$CACHE_NETWORK = 'network';
const $895d000dee7fb47d$var$CACHE_MEMORY = 'memory';
const $895d000dee7fb47d$var$CACHE_DISK = 'disk';
function $895d000dee7fb47d$var$calculateTransferType(type, duration, size) {
    if (!$895d000dee7fb47d$var$cacheableTypes.includes(type)) return $895d000dee7fb47d$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $895d000dee7fb47d$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $895d000dee7fb47d$var$CACHE_DISK;
    if (size === undefined) return null;
    return $895d000dee7fb47d$var$CACHE_NETWORK;
}
function $895d000dee7fb47d$export$e8a9322c3d9da8a6({ start: start }) {
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        for (const entry of performance.getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $895d000dee7fb47d$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
}


var $53Jed = parcelRequire("53Jed");

var $7lN8e = parcelRequire("7lN8e");
var $e0dcda22c6170927$var$n = "undefined" != typeof window ? window.performance : null;
function $e0dcda22c6170927$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $e0dcda22c6170927$export$abfb0136cf8e916b(),
        effectiveConnectionType: $e0dcda22c6170927$export$265dfeca3f5017b9(),
        timeToFirstByte: $e0dcda22c6170927$export$9a2904da0506c3ba(),
        firstPaint: $e0dcda22c6170927$export$819e7a0b13f5961(),
        firstContentfulPaint: $e0dcda22c6170927$export$3086fa1a9fb7f683(),
        domContentLoaded: $e0dcda22c6170927$export$d6856d1fab905de0(),
        onLoad: $e0dcda22c6170927$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $e0dcda22c6170927$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $e0dcda22c6170927$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $e0dcda22c6170927$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $e0dcda22c6170927$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $e0dcda22c6170927$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $e0dcda22c6170927$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $e0dcda22c6170927$export$a2a699fa5b2b1ed4(n);
    });
}
function $e0dcda22c6170927$export$bf7f2fce5c1cf636(e) {
    $e0dcda22c6170927$var$n && $e0dcda22c6170927$var$n.mark && $e0dcda22c6170927$var$n.mark(e);
}
function $e0dcda22c6170927$export$83602b44513dc228(e, t) {
    if ($e0dcda22c6170927$var$n && $e0dcda22c6170927$var$n.measure) try {
        $e0dcda22c6170927$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $e0dcda22c6170927$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $e0dcda22c6170927$export$819e7a0b13f5961() {
    if (!$e0dcda22c6170927$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $e0dcda22c6170927$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $e0dcda22c6170927$export$3086fa1a9fb7f683() {
    if (!$e0dcda22c6170927$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $e0dcda22c6170927$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $e0dcda22c6170927$export$9a2904da0506c3ba() {
    if (!$e0dcda22c6170927$var$n) return null;
    var e = $e0dcda22c6170927$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $e0dcda22c6170927$export$d6856d1fab905de0() {
    if (!$e0dcda22c6170927$var$n) return null;
    var e = $e0dcda22c6170927$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $e0dcda22c6170927$export$7259a7b98f0280a3() {
    if (!$e0dcda22c6170927$var$n) return null;
    var e = $e0dcda22c6170927$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $e0dcda22c6170927$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $e0dcda22c6170927$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $e0dcda22c6170927$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $e0dcda22c6170927$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $e0dcda22c6170927$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $e0dcda22c6170927$export$4660d4a735328f2a() {
    if (!$e0dcda22c6170927$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $e0dcda22c6170927$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $e0dcda22c6170927$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $e0dcda22c6170927$export$a0d4d2a74c7df9f() {
    return $e0dcda22c6170927$var$n && "undefined" != typeof PerformanceResourceTiming ? $e0dcda22c6170927$var$n.getEntriesByType("navigation").concat($e0dcda22c6170927$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $e0dcda22c6170927$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}


const $6cedb9472c3c3593$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
const $6cedb9472c3c3593$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
const $6cedb9472c3c3593$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $e0dcda22c6170927$export$4660d4a735328f2a)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith($6cedb9472c3c3593$var$JS_EVAL_START) && !item.name.endsWith($6cedb9472c3c3593$var$JS_EVAL_STOP) && item.startTime >= data.start).forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};


const $2550d049ab41de93$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $2550d049ab41de93$export$b37a70af06e58097 = ()=>{
    if (!performance) return {};
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        decodedBodySize: navigation.decodedBodySize,
        encodedBodySize: navigation.encodedBodySize,
        transferSize: navigation.transferSize
    };
};
const $2550d049ab41de93$var$assetsTypes = [
    'script',
    'link'
];
const $2550d049ab41de93$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $2550d049ab41de93$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    for (const entry of performance.getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($2550d049ab41de93$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};


function $1644af203925f26c$export$a63eb8eebf6a41d3(interaction) {
    var _find, _apdex$;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const region = (0, $6LH8a.getMeta)('ajs-region');
    if (region !== null && region !== '') customData.region = region;
    customData.httpProtocol = ((_find = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)) === null || _find === void 0 ? void 0 : _find.nextHopProtocol) ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = (apdex === null || apdex === void 0 || (_apdex$ = apdex[0]) === null || _apdex$ === void 0 ? void 0 : _apdex$.stopTime) ?? end;
    const lightHouseMetrics = (0, $53Jed.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $6cedb9472c3c3593$export$9d952633c9c2237b)({
            start: start
        }),
        ...(0, $2550d049ab41de93$export$84e3d676f1564c75)(),
        ...(0, $2550d049ab41de93$export$b37a70af06e58097)(),
        ...(0, $2550d049ab41de93$export$b72e035af6568be7)({
            start: start,
            stop: stop
        }),
        ...(0, $895d000dee7fb47d$export$e8a9322c3d9da8a6)({
            start: start
        }),
        'app:version:web': window.BUILD_KEY,
        buildKey: window.BUILD_KEY,
        bundlerType: typeof window.BUILD_KEY === 'string' && window.BUILD_KEY.includes('ATLASPACK') ? 'atlaspack' : 'webpack',
        'app:framework:name': 'react',
        helpCenterType: (0, $7lN8e.getEnv)().helpCenterType
    };
    return customData;
}


const $5417ca78c3065722$var$allAtlassian = ({ entry: entry })=>{
    const assetNames = [
        'atl-paas.net',
        'atlastunnel',
        'batch.js'
    ];
    const isAtlassian = assetNames.some((name)=>entry.name.includes(name));
    return isAtlassian;
};
const $5417ca78c3065722$var$preloaded = ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
    return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};
const $5417ca78c3065722$export$3c97e0dabadb52a9 = {
    // allowedTypes: ['js', 'css', 'image', 'font'], // By default only JS
    classification: {
        allAtlassian: $5417ca78c3065722$var$allAtlassian,
        preloaded: $5417ca78c3065722$var$preloaded,
        all: true
    }
};



var $6lbrU = parcelRequire("6lbrU");

var $62qKR = parcelRequire("62qKR");

var $6LH8a = parcelRequire("6LH8a");
let $5c53d4152d9143fc$var$alreadySet = false;
const $5c53d4152d9143fc$export$1a71d2bbe236de99 = ()=>{
    if ($5c53d4152d9143fc$var$alreadySet) return;
    const traceId = (0, $6LH8a.getMeta)('X-B3-TraceId') || '';
    const spanId = (traceId === null || traceId === void 0 ? void 0 : traceId.substring(traceId.length - 16)) || ''; // set root span ID by convention
    $5c53d4152d9143fc$var$alreadySet = true;
    (0, $62qKR.setActiveTrace)(traceId, spanId, 'page_load');
};


const $9c98d1d15910bd58$var$DEFAULT_UFO_NAME_PREFIX = 'help-center-ufo-';
const $9c98d1d15910bd58$var$HELP_HUB_UFO_NAME_PREFIX = 'jsm-help-center-ufo-';
const $9c98d1d15910bd58$var$getUFONamePrefix = (helpCenterType)=>helpCenterType === 'HELP_HUB' ? $9c98d1d15910bd58$var$HELP_HUB_UFO_NAME_PREFIX : $9c98d1d15910bd58$var$DEFAULT_UFO_NAME_PREFIX;
function $9c98d1d15910bd58$var$runConfigureSsrTiming() {
    (0, $iRdXI.configure)({
        getDoneMark: ()=>{
            var _getMark;
            return ((_getMark = (0, $55vtE.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) ?? null;
        },
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $9c98d1d15910bd58$var$getAdditionalHelpCenterFields(interaction) {
    try {
        return {
            jira: (0, $1644af203925f26c$export$a63eb8eebf6a41d3)(interaction)
        };
    } catch (error) {
        return {};
    }
}
const $9c98d1d15910bd58$export$af995ee1d7017fea = ()=>{
    $9c98d1d15910bd58$var$runConfigureSsrTiming();
    (0, $5810560ff3832765$export$a311cb1baa7d2d62)();
    (0, $5c53d4152d9143fc$export$1a71d2bbe236de99)();
    const env = (0, $7lN8e.getEnv)();
    const isStagingEnv = env.environment === (0, $7lN8e.EnvType).STAGING;
    (0, $7eeIG.configure)({
        sanitiseEndpoints (url) {
            return url;
        },
        mapResources (url) {
            const parts = url.split('/');
            const chunkName = parts[parts.length - 1];
            if (chunkName.includes('vendor-react')) return chunkName;
            return url;
        }
    });
    (0, $0f4442c793bf2f92$export$2cd8252107eb640b)(Promise.resolve({
        getAnalyticsWebClientPromise: $6lbrU.getAnalyticsWebClientPromise
    }), {
        product: 'jira',
        region: (0, $6LH8a.getMeta)('ajs-region') || 'unknown',
        //TODO:SSR and FF data
        namePrefix: $9c98d1d15910bd58$var$getUFONamePrefix(env.helpCenterType),
        ssr: {
            getSSRDoneTime: ()=>{
                var _getMark2;
                return (_getMark2 = (0, $55vtE.getMark)('ssr.spa.rendered')) === null || _getMark2 === void 0 ? void 0 : _getMark2.startTime;
            }
        },
        assetsConfig: $5417ca78c3065722$export$3c97e0dabadb52a9,
        additionalPayloadData: $9c98d1d15910bd58$var$getAdditionalHelpCenterFields,
        capability: {
            /*
       * Enabling feature flag data to be captured in UFO.
       */ feature_flag_access: 1,
            /*
       * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
       * react_profiler is added since it is required by the type,
       * will be cleaned up in the future
       */ react_profiler: 0
        },
        vc: {
            /*
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
       */ stopVCAtInteractionFinish: true,
            enabled: true,
            selectorConfig: {
                className: true,
                role: isStagingEnv,
                id: isStagingEnv,
                testId: isStagingEnv
            },
            includeSSRInV3: (0, $k2M4v.default).checkGate('help_center_add_ssr_to_ttvc_v3'),
            includeSSRRatio: (0, $k2M4v.default).checkGate('help_center_add_ssr_ratio_to_ttvc'),
            ssr: (0, $7lN8e.getIsPageServerSideRendered)(),
            devToolsEnabled: isStagingEnv,
            enabledVCRevisions: {
                all: (0, $k2M4v.default).checkGate('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            }
        },
        kind: {
            /*
       * Sampling works in 1 in the rate specified.
       * If rate is 1, it captures all events - 1/1
       */ page_load: 1,
            transition: 1,
            press: 1,
            typing: 1,
            legacy: 0,
            //For some Jira events that will be cleaned up in UFO
            hover: 1
        },
        postInteractionLog: {
            enabled: true,
            rates: {
                'request-details': 1,
                'request-create': 1,
                login: 1
            }
        }
    });
    /*
   * Start instrumenting the page load event.
   * We invoke `traceUFOPageLoad` once more
   * when we have the route context.
   * It attaches the route name to the event.
   * */ (0, $eWyyY.default)();
};



var $k2M4v = parcelRequire("k2M4v");

var $2Eign = parcelRequire("2Eign");
/*
These are the feature flags data that we want to embed into UFO.
This FF data will be recorded in perf portal as well.
*/ const $9557fe3aa683420e$var$UFO_FEATURE_FLAGS = [];
const $9557fe3aa683420e$export$7b278fada0929739 = ()=>{
    $9557fe3aa683420e$var$UFO_FEATURE_FLAGS.forEach((featureFlag)=>{
        const ffValue = (0, $k2M4v.default).checkGate(featureFlag);
        (0, $2Eign.addFeatureFlagAccessed)(featureFlag, ffValue);
    });
};



var $k2M4v = parcelRequire("k2M4v");

var $27NB5 = parcelRequire("27NB5");

var $7rEw1 = parcelRequire("7rEw1");

var $him7m = parcelRequire("him7m");
const $dd0b35afe5ac2a6f$export$21f987f4268bfbca = ()=>$dd0b35afe5ac2a6f$var$parseJsonContentFromMetaTag('ajs-fe-statsig-values');
const $dd0b35afe5ac2a6f$var$parseJsonContentFromMetaTag = (metaTagName)=>{
    const metaContent = $dd0b35afe5ac2a6f$export$8fd697566e460c96(metaTagName);
    if (metaContent != null && metaContent !== '') try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(metaContent);
    } catch (e) {
        throw new Error(`Can't parse '${metaTagName}' value`);
    }
    return {};
};
function $dd0b35afe5ac2a6f$export$8fd697566e460c96(name) {
    const objectModelRef = typeof window === 'undefined' ? (0, $him7m.default) : document;
    const metaElement = objectModelRef.querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}


function $e28da222657ffd51$export$4d3d588e55d2ee0f(vars) {
    if ((0, $k2M4v.default).initializeCalled()) return Promise.resolve();
    try {
        const cloudId = (0, $dd0b35afe5ac2a6f$export$8fd697566e460c96)('tenant-id') ?? undefined;
        const atlassianAccountId = (0, $dd0b35afe5ac2a6f$export$8fd697566e460c96)('ajs-atlassian-account-id');
        const region = (0, $dd0b35afe5ac2a6f$export$8fd697566e460c96)('ajs-region');
        const environment = region !== undefined && region !== null && region !== void 0 && region.startsWith('prod') ? (0, $27NB5.FeatureGateEnvironment).Production : (0, $27NB5.FeatureGateEnvironment).Staging;
        return (0, $k2M4v.default).initializeFromValues({
            environment: environment,
            perimeter: (0, $7rEw1.isFedRamp)() ? (0, $27NB5.PerimeterType).FEDRAMP_MODERATE : (0, $27NB5.PerimeterType).COMMERCIAL,
            targetApp: 'jsm-portal_web',
            sdkKey: environment === (0, $27NB5.FeatureGateEnvironment).Production ? 'client-NKfwskfcfrondp65Ar9Mfv9GNLywVcUdkBvK1mLpNK6' : 'client-rRwj0kwrHSPVA9p8Gy6pMfyBouOlfD2DX6pMXJtx9y1'
        }, {
            atlassianAccountId: atlassianAccountId !== null ? atlassianAccountId : undefined,
            tenantId: cloudId
        }, {}, vars.statsigValues || (0, $dd0b35afe5ac2a6f$export$21f987f4268bfbca)());
    } catch (error) {
        return Promise.reject(error);
    }
}




var $4B1hn = parcelRequire("4B1hn");
const $d77b62d1341789c7$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
const $d77b62d1341789c7$var$PERFORMANCE_MARKS = {
    // These happen to currently exist in the Jira monolith. Will replace them with more meaningful marks on the backend and then update here
    BEFORE_FRAGMENT: 'jsd.performance.profile.customer.portal.wrm.resources.loaded',
    AFTER_FRAGMENT: 'jsd.performance.profile.customer.portal.first.chunk.loaded'
};

// Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope,@atlaskit/platform/no-direct-document-usage
document.addEventListener('DOMContentLoaded', ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const element = document.getElementById('page');
    element && element.parentElement && element.parentElement.removeChild(element);
    (0, $e28da222657ffd51$export$4d3d588e55d2ee0f)($d77b62d1341789c7$var$globalVar).catch((err)=>(0, $4B1hn.sentryQueue).pushError(err)).finally(()=>{
        try {
            (0, $9c98d1d15910bd58$export$af995ee1d7017fea)();
        } catch (err) {
            (0, $4B1hn.sentryQueue).pushError(err);
        }
        (0, $9557fe3aa683420e$export$7b278fada0929739)();
        const requiredBootstrapMarkBefore = performance.now();
        // Suppressing existing violation. Please fix this.
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */ /* oxlint-disable-next-line global-require */ const { bootstrap: bootstrap } = (parcelRequire("ggpx4"));
        const requiredBootstrapMarkAfter = performance.now();
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        bootstrap();
        const executedBootstrapMarkAfter = performance.now();
        {
            var _performance$getEntri, _performance$getEntri2;
            const beforeFragment = performance.getEntriesByName && ((_performance$getEntri = performance.getEntriesByName($d77b62d1341789c7$var$PERFORMANCE_MARKS.BEFORE_FRAGMENT)[0]) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.startTime);
            const afterFragment = beforeFragment && ((_performance$getEntri2 = performance.getEntriesByName($d77b62d1341789c7$var$PERFORMANCE_MARKS.AFTER_FRAGMENT)[0]) === null || _performance$getEntri2 === void 0 ? void 0 : _performance$getEntri2.startTime);
            beforeFragment && afterFragment && (0, $jQYQa.addSpanToAll)('custom', 'fragment executed', [
                {
                    name: 'bootstrap'
                }
            ], beforeFragment, afterFragment);
            (0, $jQYQa.addSpanToAll)('custom', 'bootstrap required', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkBefore, requiredBootstrapMarkAfter);
            (0, $jQYQa.addSpanToAll)('custom', 'bootstrap executed', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkAfter, executedBootstrapMarkAfter);
        }
    });
});


//# sourceMappingURL=entry.2dd7f52e.js.map
